'use strict';
var $fileLevelThis = this;
export { $fileLevelThis as $fileLevelThis };
var $getOwnPropertyDescriptors = (Object.getOwnPropertyDescriptors || (() => {
  var ownKeysFun;
  if ((((typeof Reflect) !== "undefined") && Reflect.ownKeys)) {
    ownKeysFun = Reflect.ownKeys;
  } else {
    var getOwnPropertySymbols = (Object.getOwnPropertySymbols || ((o) => []));
    ownKeysFun = ((o) => Object.getOwnPropertyNames(o).concat(getOwnPropertySymbols(o)));
  }
  return ((o) => {
    var ownKeys = ownKeysFun(o);
    var descriptors = ({});
    var len = (ownKeys.length | 0);
    var i = 0;
    while ((i !== len)) {
      var key = ownKeys[i];
      Object.defineProperty(descriptors, key, ({
        "configurable": true,
        "enumerable": true,
        "writable": true,
        "value": Object.getOwnPropertyDescriptor(o, key)
      }));
      i = ((i + 1) | 0);
    }
    return descriptors;
  });
})());
export { $getOwnPropertyDescriptors as $getOwnPropertyDescriptors };
var $L0;
export { $L0 as $L0 };
function $Char(c) {
  this.c = c;
}
export { $Char as $Char };
$Char.prototype.toString = (function() {
  return String.fromCharCode(this.c);
});
function $noIsInstance(arg0) {
  throw new TypeError("Cannot call isInstance() on a Class representing a JS trait/object");
}
export { $noIsInstance as $noIsInstance };
function $objectClone(arg0) {
  return Object.create(Object.getPrototypeOf(arg0), $getOwnPropertyDescriptors(arg0));
}
export { $objectClone as $objectClone };
function $objectOrArrayClone(arg0) {
  return (arg0.$classData.isArrayClass ? arg0.clone__O() : $objectClone(arg0));
}
export { $objectOrArrayClone as $objectOrArrayClone };
function $objectGetClass(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return $d_T.getClassOf();
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return $d_jl_Byte.getClassOf();
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return $d_jl_Short.getClassOf();
        } else {
          return $d_jl_Integer.getClassOf();
        }
      } else if ($isFloat(arg0)) {
        return $d_jl_Float.getClassOf();
      } else {
        return $d_jl_Double.getClassOf();
      }
    }
    case "boolean": {
      return $d_jl_Boolean.getClassOf();
    }
    case "undefined": {
      return $d_jl_Void.getClassOf();
    }
    default: {
      if ((arg0 instanceof $c_RTLong)) {
        return $d_jl_Long.getClassOf();
      } else if ((arg0 instanceof $Char)) {
        return $d_jl_Character.getClassOf();
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.getClassOf();
      } else {
        return null;
      }
    }
  }
}
export { $objectGetClass as $objectGetClass };
function $objectClassName(arg0) {
  switch ((typeof arg0)) {
    case "string": {
      return "java.lang.String";
    }
    case "number": {
      if ($isInt(arg0)) {
        if ((((arg0 << 24) >> 24) === arg0)) {
          return "java.lang.Byte";
        } else if ((((arg0 << 16) >> 16) === arg0)) {
          return "java.lang.Short";
        } else {
          return "java.lang.Integer";
        }
      } else if ($isFloat(arg0)) {
        return "java.lang.Float";
      } else {
        return "java.lang.Double";
      }
    }
    case "boolean": {
      return "java.lang.Boolean";
    }
    case "undefined": {
      return "java.lang.Void";
    }
    default: {
      if ((arg0 instanceof $c_RTLong)) {
        return "java.lang.Long";
      } else if ((arg0 instanceof $Char)) {
        return "java.lang.Character";
      } else if ((!(!(arg0 && arg0.$classData)))) {
        return arg0.$classData.name;
      } else {
        return null.getName__T();
      }
    }
  }
}
export { $objectClassName as $objectClassName };
function $dp_charAt__I__C(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__charAt__I__C(instance, x0);
  } else {
    return instance.charAt__I__C(x0);
  }
}
export { $dp_charAt__I__C as $dp_charAt__I__C };
function $dp_codePointAt__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__codePointAt__I__I(instance, x0);
  } else {
    return instance.codePointAt__I__I(x0);
  }
}
export { $dp_codePointAt__I__I as $dp_codePointAt__I__I };
function $dp_codePointBefore__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__codePointBefore__I__I(instance, x0);
  } else {
    return instance.codePointBefore__I__I(x0);
  }
}
export { $dp_codePointBefore__I__I as $dp_codePointBefore__I__I };
function $dp_compareTo__O__I(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__compareTo__O__I(instance, x0);
    }
    case "number": {
      return $f_jl_Double__compareTo__O__I(instance, x0);
    }
    case "boolean": {
      return $f_jl_Boolean__compareTo__O__I(instance, x0);
    }
    default: {
      if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__compareTo__O__I(instance, x0);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__compareTo__O__I($uC(instance), x0);
      } else {
        return instance.compareTo__O__I(x0);
      }
    }
  }
}
export { $dp_compareTo__O__I as $dp_compareTo__O__I };
function $dp_compareTo__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareTo__T__I(instance, x0);
  } else {
    return instance.compareTo__T__I(x0);
  }
}
export { $dp_compareTo__T__I as $dp_compareTo__T__I };
function $dp_compareToIgnoreCase__T__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__compareToIgnoreCase__T__I(instance, x0);
  } else {
    return instance.compareToIgnoreCase__T__I(x0);
  }
}
export { $dp_compareToIgnoreCase__T__I as $dp_compareToIgnoreCase__T__I };
function $dp_equals__O__Z(instance, x0) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__equals__O__Z(instance, x0);
    }
    case "number": {
      return $f_jl_Double__equals__O__Z(instance, x0);
    }
    case "boolean": {
      return $f_jl_Boolean__equals__O__Z(instance, x0);
    }
    case "undefined": {
      return $f_jl_Void__equals__O__Z(instance, x0);
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.equals__O__Z(x0);
      } else if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__equals__O__Z(instance, x0);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__equals__O__Z($uC(instance), x0);
      } else {
        return $c_O.prototype.equals__O__Z.call(instance, x0);
      }
    }
  }
}
export { $dp_equals__O__Z as $dp_equals__O__Z };
function $dp_getBytes__T__AB(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__getBytes__T__AB(instance, x0);
  } else {
    return instance.getBytes__T__AB(x0);
  }
}
export { $dp_getBytes__T__AB as $dp_getBytes__T__AB };
function $dp_getBytes__Ljava_nio_charset_Charset__AB(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__getBytes__Ljava_nio_charset_Charset__AB(instance, x0);
  } else {
    return instance.getBytes__Ljava_nio_charset_Charset__AB(x0);
  }
}
export { $dp_getBytes__Ljava_nio_charset_Charset__AB as $dp_getBytes__Ljava_nio_charset_Charset__AB };
function $dp_getChars__I__I__AC__I__V(instance, x0, x1, x2, x3) {
  if (((typeof instance) === "string")) {
    return $f_T__getChars__I__I__AC__I__V(instance, x0, x1, x2, x3);
  } else {
    return instance.getChars__I__I__AC__I__V(x0, x1, x2, x3);
  }
}
export { $dp_getChars__I__I__AC__I__V as $dp_getChars__I__I__AC__I__V };
function $dp_hashCode__I(instance) {
  switch ((typeof instance)) {
    case "string": {
      return $f_T__hashCode__I(instance);
    }
    case "number": {
      return $f_jl_Double__hashCode__I(instance);
    }
    case "boolean": {
      return $f_jl_Boolean__hashCode__I(instance);
    }
    case "undefined": {
      return $f_jl_Void__hashCode__I(instance);
    }
    default: {
      if (((!(!(instance && instance.$classData))) || (instance === null))) {
        return instance.hashCode__I();
      } else if ((instance instanceof $c_RTLong)) {
        return $f_jl_Long__hashCode__I(instance);
      } else if ((instance instanceof $Char)) {
        return $f_jl_Character__hashCode__I($uC(instance));
      } else {
        return $c_O.prototype.hashCode__I.call(instance);
      }
    }
  }
}
export { $dp_hashCode__I as $dp_hashCode__I };
function $dp_indent__I__T(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__indent__I__T(instance, x0);
  } else {
    return instance.indent__I__T(x0);
  }
}
export { $dp_indent__I__T as $dp_indent__I__T };
function $dp_indexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I(instance, x0);
  } else {
    return instance.indexOf__I__I(x0);
  }
}
export { $dp_indexOf__I__I as $dp_indexOf__I__I };
function $dp_indexOf__I__I__I(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__indexOf__I__I__I(instance, x0, x1);
  } else {
    return instance.indexOf__I__I__I(x0, x1);
  }
}
export { $dp_indexOf__I__I__I as $dp_indexOf__I__I__I };
function $dp_isBlank__Z(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__isBlank__Z(instance);
  } else {
    return instance.isBlank__Z();
  }
}
export { $dp_isBlank__Z as $dp_isBlank__Z };
function $dp_lastIndexOf__I__I(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__lastIndexOf__I__I(instance, x0);
  } else {
    return instance.lastIndexOf__I__I(x0);
  }
}
export { $dp_lastIndexOf__I__I as $dp_lastIndexOf__I__I };
function $dp_length__I(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__length__I(instance);
  } else {
    return instance.length__I();
  }
}
export { $dp_length__I as $dp_length__I };
function $dp_repeat__I__T(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__repeat__I__T(instance, x0);
  } else {
    return instance.repeat__I__T(x0);
  }
}
export { $dp_repeat__I__T as $dp_repeat__I__T };
function $dp_replaceAll__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceAll__T__T__T(instance, x0, x1);
  } else {
    return instance.replaceAll__T__T__T(x0, x1);
  }
}
export { $dp_replaceAll__T__T__T as $dp_replaceAll__T__T__T };
function $dp_replaceFirst__T__T__T(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__replaceFirst__T__T__T(instance, x0, x1);
  } else {
    return instance.replaceFirst__T__T__T(x0, x1);
  }
}
export { $dp_replaceFirst__T__T__T as $dp_replaceFirst__T__T__T };
function $dp_split__T__I__AT(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__split__T__I__AT(instance, x0, x1);
  } else {
    return instance.split__T__I__AT(x0, x1);
  }
}
export { $dp_split__T__I__AT as $dp_split__T__I__AT };
function $dp_subSequence__I__I__jl_CharSequence(instance, x0, x1) {
  if (((typeof instance) === "string")) {
    return $f_T__subSequence__I__I__jl_CharSequence(instance, x0, x1);
  } else {
    return instance.subSequence__I__I__jl_CharSequence(x0, x1);
  }
}
export { $dp_subSequence__I__I__jl_CharSequence as $dp_subSequence__I__I__jl_CharSequence };
function $dp_toCharArray__AC(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__toCharArray__AC(instance);
  } else {
    return instance.toCharArray__AC();
  }
}
export { $dp_toCharArray__AC as $dp_toCharArray__AC };
function $dp_toLowerCase__ju_Locale__T(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__toLowerCase__ju_Locale__T(instance, x0);
  } else {
    return instance.toLowerCase__ju_Locale__T(x0);
  }
}
export { $dp_toLowerCase__ju_Locale__T as $dp_toLowerCase__ju_Locale__T };
function $dp_toString__T(instance) {
  return ((instance === (void 0)) ? "undefined" : instance.toString());
}
export { $dp_toString__T as $dp_toString__T };
function $dp_toUpperCase__ju_Locale__T(instance, x0) {
  if (((typeof instance) === "string")) {
    return $f_T__toUpperCase__ju_Locale__T(instance, x0);
  } else {
    return instance.toUpperCase__ju_Locale__T(x0);
  }
}
export { $dp_toUpperCase__ju_Locale__T as $dp_toUpperCase__ju_Locale__T };
function $dp_trim__T(instance) {
  if (((typeof instance) === "string")) {
    return $f_T__trim__T(instance);
  } else {
    return instance.trim__T();
  }
}
export { $dp_trim__T as $dp_trim__T };
function $checkIntDivisor(arg0) {
  if ((arg0 === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  } else {
    return arg0;
  }
}
export { $checkIntDivisor as $checkIntDivisor };
function $doubleToInt(arg0) {
  return ((arg0 > 2147483647) ? 2147483647 : ((arg0 < (-2147483648)) ? (-2147483648) : (arg0 | 0)));
}
export { $doubleToInt as $doubleToInt };
function $cToS(arg0) {
  return String.fromCharCode(arg0);
}
export { $cToS as $cToS };
var $fpBitsDataView = new DataView(new ArrayBuffer(8));
export { $fpBitsDataView as $fpBitsDataView };
function $floatToBits(arg0) {
  var dataView = $fpBitsDataView;
  dataView.setFloat32(0, arg0, true);
  return dataView.getInt32(0, true);
}
export { $floatToBits as $floatToBits };
function $floatFromBits(arg0) {
  var dataView = $fpBitsDataView;
  dataView.setInt32(0, arg0, true);
  return dataView.getFloat32(0, true);
}
export { $floatFromBits as $floatFromBits };
function $doubleToBits(arg0) {
  var dataView = $fpBitsDataView;
  return $s_RTLong__fromDoubleBits__D__O__RTLong(arg0, dataView);
}
export { $doubleToBits as $doubleToBits };
function $doubleFromBits(arg0) {
  var dataView = $fpBitsDataView;
  return $s_RTLong__bitsToDouble__RTLong__O__D(arg0, dataView);
}
export { $doubleFromBits as $doubleFromBits };
function $resolveSuperRef(arg0, arg1) {
  var getPrototypeOf = Object.getPrototyeOf;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var superProto = arg0.prototype;
  while ((superProto !== null)) {
    var desc = getOwnPropertyDescriptor(superProto, arg1);
    if ((desc !== (void 0))) {
      return desc;
    }
    superProto = getPrototypeOf(superProto);
  }
}
export { $resolveSuperRef as $resolveSuperRef };
function $superGet(arg0, arg1, arg2) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var getter = desc.get;
    return ((getter !== (void 0)) ? getter.call(arg1) : getter.value);
  }
}
export { $superGet as $superGet };
function $superSet(arg0, arg1, arg2, arg3) {
  var desc = $resolveSuperRef(arg0, arg2);
  if ((desc !== (void 0))) {
    var setter = desc.set;
    if ((setter !== (void 0))) {
      setter.call(arg1, arg3);
      return (void 0);
    }
  }
  throw new TypeError((("super has no setter '" + arg2) + "'."));
}
export { $superSet as $superSet };
function $arraycopyGeneric(arg0, arg1, arg2, arg3, arg4) {
  if ((((arg0 !== arg2) || (arg3 < arg1)) || (((arg1 + arg4) | 0) < arg3))) {
    for (var i = 0; (i < arg4); i = ((i + 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)];
    }
  } else {
    for (var i = ((arg4 - 1) | 0); (i >= 0); i = ((i - 1) | 0)) {
      arg2[((arg3 + i) | 0)] = arg0[((arg1 + i) | 0)];
    }
  }
}
export { $arraycopyGeneric as $arraycopyGeneric };
var $lastIDHash = 0;
var $idHashCodeMap = new WeakMap();
function $systemIdentityHashCode(obj) {
  switch ((typeof obj)) {
    case "string": {
      return $f_T__hashCode__I(obj);
    }
    case "number": {
      return $f_jl_Double__hashCode__I(obj);
    }
    case "bigint": {
      var biHash = 0;
      if ((obj < BigInt(0))) {
        obj = (~obj);
      }
      while ((obj !== BigInt(0))) {
        biHash = (biHash ^ Number(BigInt.asIntN(32, obj)));
        obj = (obj >> BigInt(32));
      }
      return biHash;
    }
    case "boolean": {
      return (obj ? 1231 : 1237);
    }
    case "undefined": {
      return 0;
    }
    case "symbol": {
      var description = obj.description;
      return ((description === (void 0)) ? 0 : $f_T__hashCode__I(description));
    }
    default: {
      if ((obj === null)) {
        return 0;
      } else {
        var hash = $idHashCodeMap.get(obj);
        if ((hash === (void 0))) {
          hash = (($lastIDHash + 1) | 0);
          $lastIDHash = hash;
          $idHashCodeMap.set(obj, hash);
        }
        return hash;
      }
    }
  }
}
export { $systemIdentityHashCode as $systemIdentityHashCode };
function $isByte(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 24) >> 24) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
export { $isByte as $isByte };
function $isShort(arg0) {
  return ((((typeof arg0) === "number") && (((arg0 << 16) >> 16) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
export { $isShort as $isShort };
function $isInt(arg0) {
  return ((((typeof arg0) === "number") && ((arg0 | 0) === arg0)) && ((1 / arg0) !== (1 / (-0))));
}
export { $isInt as $isInt };
function $isFloat(arg0) {
  return (((typeof arg0) === "number") && ((arg0 !== arg0) || (Math.fround(arg0) === arg0)));
}
export { $isFloat as $isFloat };
function $bC(arg0) {
  return new $Char(arg0);
}
export { $bC as $bC };
var $bC0 = $bC(0);
export { $bC0 as $bC0 };
function $uC(arg0) {
  return ((arg0 === null) ? 0 : arg0.c);
}
export { $uC as $uC };
function $uJ(arg0) {
  return ((arg0 === null) ? $L0 : arg0);
}
export { $uJ as $uJ };
function $ct_O__($thiz) {
  return $thiz;
}
export { $ct_O__ as $ct_O__ };
/** @constructor */
function $c_O() {
}
export { $c_O as $c_O };
$c_O.prototype.constructor = $c_O;
/** @constructor */
function $h_O() {
}
export { $h_O as $h_O };
$h_O.prototype = $c_O.prototype;
$c_O.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_O.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_O.prototype.toString__T = (function() {
  var i = this.hashCode__I();
  return (($objectClassName(this) + "@") + (i >>> 0.0).toString(16));
});
$c_O.prototype.toString = (function() {
  return this.toString__T();
});
function $ac_O(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = null;
    }
  } else {
    this.u = arg;
  }
}
export { $ac_O as $ac_O };
$ac_O.prototype = new $h_O();
$ac_O.prototype.constructor = $ac_O;
$ac_O.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length);
});
$ac_O.prototype.clone__O = (function() {
  return new $ac_O(this.u.slice());
});
function $ah_O() {
}
export { $ah_O as $ah_O };
$ah_O.prototype = $ac_O.prototype;
function $ac_Z(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = false;
    }
  } else {
    this.u = arg;
  }
}
export { $ac_Z as $ac_Z };
$ac_Z.prototype = new $h_O();
$ac_Z.prototype.constructor = $ac_Z;
$ac_Z.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length);
});
$ac_Z.prototype.clone__O = (function() {
  return new $ac_Z(this.u.slice());
});
function $ac_C(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Uint16Array(arg);
  } else {
    this.u = arg;
  }
}
export { $ac_C as $ac_C };
$ac_C.prototype = new $h_O();
$ac_C.prototype.constructor = $ac_C;
$ac_C.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_C.prototype.clone__O = (function() {
  return new $ac_C(this.u.slice());
});
function $ac_B(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Int8Array(arg);
  } else {
    this.u = arg;
  }
}
export { $ac_B as $ac_B };
$ac_B.prototype = new $h_O();
$ac_B.prototype.constructor = $ac_B;
$ac_B.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_B.prototype.clone__O = (function() {
  return new $ac_B(this.u.slice());
});
function $ac_S(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Int16Array(arg);
  } else {
    this.u = arg;
  }
}
export { $ac_S as $ac_S };
$ac_S.prototype = new $h_O();
$ac_S.prototype.constructor = $ac_S;
$ac_S.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_S.prototype.clone__O = (function() {
  return new $ac_S(this.u.slice());
});
function $ac_I(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Int32Array(arg);
  } else {
    this.u = arg;
  }
}
export { $ac_I as $ac_I };
$ac_I.prototype = new $h_O();
$ac_I.prototype.constructor = $ac_I;
$ac_I.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_I.prototype.clone__O = (function() {
  return new $ac_I(this.u.slice());
});
function $ac_J(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Array(arg);
    for (var i = 0; (i < arg); (i++)) {
      this.u[i] = $L0;
    }
  } else {
    this.u = arg;
  }
}
export { $ac_J as $ac_J };
$ac_J.prototype = new $h_O();
$ac_J.prototype.constructor = $ac_J;
$ac_J.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length);
});
$ac_J.prototype.clone__O = (function() {
  return new $ac_J(this.u.slice());
});
function $ac_F(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Float32Array(arg);
  } else {
    this.u = arg;
  }
}
export { $ac_F as $ac_F };
$ac_F.prototype = new $h_O();
$ac_F.prototype.constructor = $ac_F;
$ac_F.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_F.prototype.clone__O = (function() {
  return new $ac_F(this.u.slice());
});
function $ac_D(arg) {
  if (((typeof arg) === "number")) {
    this.u = new Float64Array(arg);
  } else {
    this.u = arg;
  }
}
export { $ac_D as $ac_D };
$ac_D.prototype = new $h_O();
$ac_D.prototype.constructor = $ac_D;
$ac_D.prototype.copyTo = (function(srcPos, dest, destPos, length) {
  dest.u.set(this.u.subarray(srcPos, ((srcPos + length) | 0)), destPos);
});
$ac_D.prototype.clone__O = (function() {
  return new $ac_D(this.u.slice());
});
function $TypeData() {
  this.constr = (void 0);
  this.ancestors = null;
  this.componentData = null;
  this.arrayBase = null;
  this.arrayDepth = 0;
  this.zero = null;
  this.arrayEncodedName = "";
  this._classOf = (void 0);
  this._arrayOf = (void 0);
  this.isAssignableFromFun = (void 0);
  this.wrapArray = (void 0);
  this.isJSType = false;
  this.name = "";
  this.isPrimitive = false;
  this.isInterface = false;
  this.isArrayClass = false;
  this.isInstance = (void 0);
}
export { $TypeData as $TypeData };
$TypeData.prototype.initPrim = (function(zero, arrayEncodedName, displayName, arrayClass, typedArrayClass) {
  this.ancestors = ({});
  this.zero = zero;
  this.arrayEncodedName = arrayEncodedName;
  var self = this;
  this.isAssignableFromFun = ((that) => (that === self));
  this.name = displayName;
  this.isPrimitive = true;
  this.isInstance = ((obj) => false);
  if ((arrayClass !== (void 0))) {
    this._arrayOf = new $TypeData().initSpecializedArray(this, arrayClass, typedArrayClass);
  }
  return this;
});
$TypeData.prototype.initClass = (function(kindOrCtor, fullName, ancestors, isInstance) {
  var internalName = Object.getOwnPropertyNames(ancestors)[0];
  this.ancestors = ancestors;
  this.arrayEncodedName = (("L" + fullName) + ";");
  this.isAssignableFromFun = ((that) => (!(!that.ancestors[internalName])));
  this.isJSType = (kindOrCtor === 2);
  this.name = fullName;
  this.isInterface = (kindOrCtor === 1);
  this.isInstance = (isInstance || ((obj) => (!(!((obj && obj.$classData) && obj.$classData.ancestors[internalName])))));
  if (((typeof kindOrCtor) !== "number")) {
    kindOrCtor.prototype.$classData = this;
  }
  return this;
});
$TypeData.prototype.initSpecializedArray = (function(componentData, arrayClass, typedArrayClass, isAssignableFromFun) {
  arrayClass.prototype.$classData = this;
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = arrayClass;
  this.ancestors = ({
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  });
  this.componentData = componentData;
  this.arrayBase = componentData;
  this.arrayDepth = 1;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var self = this;
  this.isAssignableFromFun = (isAssignableFromFun || ((that) => (self === that)));
  this.wrapArray = (typedArrayClass ? ((array) => new arrayClass(new typedArrayClass(array))) : ((array) => new arrayClass(array)));
  this.isInstance = ((obj) => (obj instanceof arrayClass));
  return this;
});
$TypeData.prototype.initArray = (function(componentData) {
  function ArrayClass(arg) {
    if (((typeof arg) === "number")) {
      this.u = new Array(arg);
      for (var i = 0; (i < arg); (i++)) {
        this.u[i] = null;
      }
    } else {
      this.u = arg;
    }
  }
  ArrayClass.prototype = new $ah_O();
  ArrayClass.prototype.constructor = ArrayClass;
  ArrayClass.prototype.copyTo = (function(srcPos, dest, destPos, length) {
    $arraycopyGeneric(this.u, srcPos, dest.u, destPos, length);
  });
  ArrayClass.prototype.clone__O = (function() {
    return new ArrayClass(this.u.slice());
  });
  ArrayClass.prototype.$classData = this;
  var arrayBase = (componentData.arrayBase || componentData);
  var arrayDepth = (componentData.arrayDepth + 1);
  var name = ("[" + componentData.arrayEncodedName);
  this.constr = ArrayClass;
  this.ancestors = ({
    jl_Cloneable: 1,
    Ljava_io_Serializable: 1
  });
  this.componentData = componentData;
  this.arrayBase = arrayBase;
  this.arrayDepth = arrayDepth;
  this.arrayEncodedName = name;
  this.name = name;
  this.isArrayClass = true;
  var isAssignableFromFun = ((that) => {
    var thatDepth = that.arrayDepth;
    return ((thatDepth === arrayDepth) ? arrayBase.isAssignableFromFun(that.arrayBase) : ((thatDepth > arrayDepth) && (arrayBase === $d_O)));
  });
  this.isAssignableFromFun = isAssignableFromFun;
  this.wrapArray = ((array) => new ArrayClass(array));
  var self = this;
  this.isInstance = ((obj) => {
    var data = (obj && obj.$classData);
    return ((!(!data)) && ((data === self) || isAssignableFromFun(data)));
  });
  return this;
});
$TypeData.prototype.getArrayOf = (function() {
  if ((!this._arrayOf)) {
    this._arrayOf = new $TypeData().initArray(this);
  }
  return this._arrayOf;
});
$TypeData.prototype.getClassOf = (function() {
  if ((!this._classOf)) {
    this._classOf = new $c_jl_Class(this);
  }
  return this._classOf;
});
$TypeData.prototype.isAssignableFrom = (function(that) {
  return ((this === that) || this.isAssignableFromFun(that));
});
$TypeData.prototype.getSuperclass = (function() {
  return (this.parentData ? this.parentData.getClassOf() : null);
});
$TypeData.prototype.getComponentType = (function() {
  return (this.componentData ? this.componentData.getClassOf() : null);
});
$TypeData.prototype.newArray = (function(length) {
  if ((this === $d_V)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  return new (this.getArrayOf().constr)(length);
});
function $isArrayOf_O(obj, depth) {
  var data = (obj && obj.$classData);
  if ((!data)) {
    return false;
  } else {
    var arrayDepth = data.arrayDepth;
    return ((arrayDepth === depth) ? (!data.arrayBase.isPrimitive) : (arrayDepth > depth));
  }
}
export { $isArrayOf_O as $isArrayOf_O };
function $isArrayOf_Z(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_Z))));
}
export { $isArrayOf_Z as $isArrayOf_Z };
function $isArrayOf_C(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_C))));
}
export { $isArrayOf_C as $isArrayOf_C };
function $isArrayOf_B(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_B))));
}
export { $isArrayOf_B as $isArrayOf_B };
function $isArrayOf_S(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_S))));
}
export { $isArrayOf_S as $isArrayOf_S };
function $isArrayOf_I(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_I))));
}
export { $isArrayOf_I as $isArrayOf_I };
function $isArrayOf_J(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_J))));
}
export { $isArrayOf_J as $isArrayOf_J };
function $isArrayOf_F(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_F))));
}
export { $isArrayOf_F as $isArrayOf_F };
function $isArrayOf_D(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && (obj.$classData.arrayBase === $d_D))));
}
export { $isArrayOf_D as $isArrayOf_D };
var $d_O = new $TypeData();
export { $d_O as $d_O };
$d_O.ancestors = ({});
$d_O.arrayEncodedName = "Ljava.lang.Object;";
$d_O.isAssignableFromFun = ((that) => (!that.isPrimitive));
$d_O.name = "java.lang.Object";
$d_O.isInstance = ((obj) => (obj !== null));
$d_O._arrayOf = new $TypeData().initSpecializedArray($d_O, $ac_O, (void 0), ((that) => {
  var thatDepth = that.arrayDepth;
  return ((thatDepth === 1) ? (!that.arrayBase.isPrimitive) : (thatDepth > 1));
}));
$c_O.prototype.$classData = $d_O;
var $d_V = new $TypeData().initPrim((void 0), "V", "void", (void 0), (void 0));
export { $d_V as $d_V };
var $d_Z = new $TypeData().initPrim(false, "Z", "boolean", $ac_Z, (void 0));
export { $d_Z as $d_Z };
var $d_C = new $TypeData().initPrim(0, "C", "char", $ac_C, Uint16Array);
export { $d_C as $d_C };
var $d_B = new $TypeData().initPrim(0, "B", "byte", $ac_B, Int8Array);
export { $d_B as $d_B };
var $d_S = new $TypeData().initPrim(0, "S", "short", $ac_S, Int16Array);
export { $d_S as $d_S };
var $d_I = new $TypeData().initPrim(0, "I", "int", $ac_I, Int32Array);
export { $d_I as $d_I };
var $d_J = new $TypeData().initPrim(null, "J", "long", $ac_J, (void 0));
export { $d_J as $d_J };
var $d_F = new $TypeData().initPrim(0.0, "F", "float", $ac_F, Float32Array);
export { $d_F as $d_F };
var $d_D = new $TypeData().initPrim(0.0, "D", "double", $ac_D, Float64Array);
export { $d_D as $d_D };
/** @constructor */
function $c_Lcats_Eval$FnStack() {
}
export { $c_Lcats_Eval$FnStack as $c_Lcats_Eval$FnStack };
$c_Lcats_Eval$FnStack.prototype = new $h_O();
$c_Lcats_Eval$FnStack.prototype.constructor = $c_Lcats_Eval$FnStack;
/** @constructor */
function $h_Lcats_Eval$FnStack() {
}
export { $h_Lcats_Eval$FnStack as $h_Lcats_Eval$FnStack };
$h_Lcats_Eval$FnStack.prototype = $c_Lcats_Eval$FnStack.prototype;
/** @constructor */
function $c_Lcats_EvalInstances1() {
}
export { $c_Lcats_EvalInstances1 as $c_Lcats_EvalInstances1 };
$c_Lcats_EvalInstances1.prototype = new $h_O();
$c_Lcats_EvalInstances1.prototype.constructor = $c_Lcats_EvalInstances1;
/** @constructor */
function $h_Lcats_EvalInstances1() {
}
export { $h_Lcats_EvalInstances1 as $h_Lcats_EvalInstances1 };
$h_Lcats_EvalInstances1.prototype = $c_Lcats_EvalInstances1.prototype;
function $p_Lcats_Foldable$__loop$3__F2__Lcats_Eval__sc_Iterator__Lcats_Eval($thiz, f$19, lb$2, it) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (it.hasNext__Z() ? f$19.apply__O__O__O(it.next__O(), $p_Lcats_Foldable$__loop$3__F2__Lcats_Eval__sc_Iterator__Lcats_Eval($thiz, f$19, lb$2, it)) : lb$2)));
  return new $c_Lcats_Eval$$anon$5(a);
}
export { $p_Lcats_Foldable$__loop$3__F2__Lcats_Eval__sc_Iterator__Lcats_Eval as $p_Lcats_Foldable$__loop$3__F2__Lcats_Eval__sc_Iterator__Lcats_Eval };
/** @constructor */
function $c_Lcats_Foldable$() {
}
export { $c_Lcats_Foldable$ as $c_Lcats_Foldable$ };
$c_Lcats_Foldable$.prototype = new $h_O();
$c_Lcats_Foldable$.prototype.constructor = $c_Lcats_Foldable$;
/** @constructor */
function $h_Lcats_Foldable$() {
}
export { $h_Lcats_Foldable$ as $h_Lcats_Foldable$ };
$h_Lcats_Foldable$.prototype = $c_Lcats_Foldable$.prototype;
$c_Lcats_Foldable$.prototype.iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval = (function(iterable, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => iterable.iterator__sc_Iterator()));
  return new $c_Lcats_Always(a).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((it) => $p_Lcats_Foldable$__loop$3__F2__Lcats_Eval__sc_Iterator__Lcats_Eval(this, f, lb, it))));
});
var $d_Lcats_Foldable$ = new $TypeData().initClass($c_Lcats_Foldable$, "cats.Foldable$", ({
  Lcats_Foldable$: 1
}));
export { $d_Lcats_Foldable$ as $d_Lcats_Foldable$ };
var $n_Lcats_Foldable$;
function $m_Lcats_Foldable$() {
  if ((!$n_Lcats_Foldable$)) {
    $n_Lcats_Foldable$ = new $c_Lcats_Foldable$();
  }
  return $n_Lcats_Foldable$;
}
export { $m_Lcats_Foldable$ as $m_Lcats_Foldable$ };
/** @constructor */
function $c_Lcats_Foldable$Source() {
}
export { $c_Lcats_Foldable$Source as $c_Lcats_Foldable$Source };
$c_Lcats_Foldable$Source.prototype = new $h_O();
$c_Lcats_Foldable$Source.prototype.constructor = $c_Lcats_Foldable$Source;
/** @constructor */
function $h_Lcats_Foldable$Source() {
}
export { $h_Lcats_Foldable$Source as $h_Lcats_Foldable$Source };
$h_Lcats_Foldable$Source.prototype = $c_Lcats_Foldable$Source.prototype;
/** @constructor */
function $c_Lcats_Foldable$Source$() {
  this.Lcats_Foldable$Source$__f_Empty = null;
  $n_Lcats_Foldable$Source$ = this;
  this.Lcats_Foldable$Source$__f_Empty = new $c_Lcats_Foldable$Source$$anon$3();
}
export { $c_Lcats_Foldable$Source$ as $c_Lcats_Foldable$Source$ };
$c_Lcats_Foldable$Source$.prototype = new $h_O();
$c_Lcats_Foldable$Source$.prototype.constructor = $c_Lcats_Foldable$Source$;
/** @constructor */
function $h_Lcats_Foldable$Source$() {
}
export { $h_Lcats_Foldable$Source$ as $h_Lcats_Foldable$Source$ };
$h_Lcats_Foldable$Source$.prototype = $c_Lcats_Foldable$Source$.prototype;
$c_Lcats_Foldable$Source$.prototype.fromFoldable__O__Lcats_Foldable__Lcats_Foldable$Source = (function(fa, F) {
  var value = this.Lcats_Foldable$Source$__f_Empty;
  return F.foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Now(value), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a, evalSrc) => {
    var a$1 = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((evalSrc$2) => (() => new $c_Lcats_Foldable$Source$$anon$4(a, evalSrc$2)))(evalSrc));
    return new $c_Lcats_Later(a$1);
  }))).value__O();
});
var $d_Lcats_Foldable$Source$ = new $TypeData().initClass($c_Lcats_Foldable$Source$, "cats.Foldable$Source$", ({
  Lcats_Foldable$Source$: 1
}));
export { $d_Lcats_Foldable$Source$ as $d_Lcats_Foldable$Source$ };
var $n_Lcats_Foldable$Source$;
function $m_Lcats_Foldable$Source$() {
  if ((!$n_Lcats_Foldable$Source$)) {
    $n_Lcats_Foldable$Source$ = new $c_Lcats_Foldable$Source$();
  }
  return $n_Lcats_Foldable$Source$;
}
export { $m_Lcats_Foldable$Source$ as $m_Lcats_Foldable$Source$ };
/** @constructor */
function $c_Lcats_Show$ShowInterpolator$() {
}
export { $c_Lcats_Show$ShowInterpolator$ as $c_Lcats_Show$ShowInterpolator$ };
$c_Lcats_Show$ShowInterpolator$.prototype = new $h_O();
$c_Lcats_Show$ShowInterpolator$.prototype.constructor = $c_Lcats_Show$ShowInterpolator$;
/** @constructor */
function $h_Lcats_Show$ShowInterpolator$() {
}
export { $h_Lcats_Show$ShowInterpolator$ as $h_Lcats_Show$ShowInterpolator$ };
$h_Lcats_Show$ShowInterpolator$.prototype = $c_Lcats_Show$ShowInterpolator$.prototype;
$c_Lcats_Show$ShowInterpolator$.prototype.toString__T = (function() {
  return "ShowInterpolator";
});
$c_Lcats_Show$ShowInterpolator$.prototype.show$extension__s_StringContext__sci_Seq__T = (function(this$, args) {
  var f = ((str) => $m_s_StringContext$().processEscapes__T__T(str));
  var parts = this$.s_StringContext__f_parts;
  $m_s_StringContext$().checkLengths__sc_Seq__sci_Seq__V(args, parts);
  var pi = parts.iterator__sc_Iterator();
  var ai = args.iterator__sc_Iterator();
  var x0 = pi.next__O();
  var bldr = $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), f(x0));
  while (ai.hasNext__Z()) {
    var obj = ai.next__O();
    bldr.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + bldr.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var x0$1 = pi.next__O();
    var str$1 = f(x0$1);
    bldr.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + bldr.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
  }
  return bldr.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
var $d_Lcats_Show$ShowInterpolator$ = new $TypeData().initClass($c_Lcats_Show$ShowInterpolator$, "cats.Show$ShowInterpolator$", ({
  Lcats_Show$ShowInterpolator$: 1
}));
export { $d_Lcats_Show$ShowInterpolator$ as $d_Lcats_Show$ShowInterpolator$ };
var $n_Lcats_Show$ShowInterpolator$;
function $m_Lcats_Show$ShowInterpolator$() {
  if ((!$n_Lcats_Show$ShowInterpolator$)) {
    $n_Lcats_Show$ShowInterpolator$ = new $c_Lcats_Show$ShowInterpolator$();
  }
  return $n_Lcats_Show$ShowInterpolator$;
}
export { $m_Lcats_Show$ShowInterpolator$ as $m_Lcats_Show$ShowInterpolator$ };
/** @constructor */
function $c_Lcats_Show$Shown$() {
}
export { $c_Lcats_Show$Shown$ as $c_Lcats_Show$Shown$ };
$c_Lcats_Show$Shown$.prototype = new $h_O();
$c_Lcats_Show$Shown$.prototype.constructor = $c_Lcats_Show$Shown$;
/** @constructor */
function $h_Lcats_Show$Shown$() {
}
export { $h_Lcats_Show$Shown$ as $h_Lcats_Show$Shown$ };
$h_Lcats_Show$Shown$.prototype = $c_Lcats_Show$Shown$.prototype;
$c_Lcats_Show$Shown$.prototype.mat__O__Lcats_Show$ContravariantShow__T = (function(x, z) {
  var toString = z.show__O__T(x);
  return toString;
});
$c_Lcats_Show$Shown$.prototype.equals$extension__T__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lcats_Show$Shown)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.Lcats_Show$Shown__f_toString);
    return (this$ === x$0$2);
  } else {
    return false;
  }
});
$c_Lcats_Show$Shown$.prototype.productElement$extension__T__I__O = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_Show$Shown$.prototype.productElementName$extension__T__I__T = (function(this$, n) {
  if ((n === 0)) {
    return "toString";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lcats_Show$Shown$ = new $TypeData().initClass($c_Lcats_Show$Shown$, "cats.Show$Shown$", ({
  Lcats_Show$Shown$: 1
}));
export { $d_Lcats_Show$Shown$ as $d_Lcats_Show$Shown$ };
var $n_Lcats_Show$Shown$;
function $m_Lcats_Show$Shown$() {
  if ((!$n_Lcats_Show$Shown$)) {
    $n_Lcats_Show$Shown$ = new $c_Lcats_Show$Shown$();
  }
  return $n_Lcats_Show$Shown$;
}
export { $m_Lcats_Show$Shown$ as $m_Lcats_Show$Shown$ };
/** @constructor */
function $c_Lcats_Traverse$() {
}
export { $c_Lcats_Traverse$ as $c_Lcats_Traverse$ };
$c_Lcats_Traverse$.prototype = new $h_O();
$c_Lcats_Traverse$.prototype.constructor = $c_Lcats_Traverse$;
/** @constructor */
function $h_Lcats_Traverse$() {
}
export { $h_Lcats_Traverse$ as $h_Lcats_Traverse$ };
$h_Lcats_Traverse$.prototype = $c_Lcats_Traverse$.prototype;
$c_Lcats_Traverse$.prototype.traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O = (function(fa, f, G) {
  var this$4 = fa.iterator__sc_Iterator();
  var this$1 = $m_Lcats_data_Chain$();
  var z = G.pure__O__O(this$1.Lcats_data_Chain$__f_nil);
  var f$1 = ((x$1, x$2) => $f_Lcats_FlatMap__map2__O__O__F2__O(G, x$1, f.apply__O__O(x$2), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1$2, x$2$2) => x$1$2.append__O__Lcats_data_Chain(x$2$2)))));
  if ($is_sc_IndexedSeq(this$4)) {
    var at = 0;
    var end = this$4.length__I();
    var acc = z;
    while (true) {
      if ((at === end)) {
        return acc;
      } else {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$4.apply__I__O(at);
        var temp$acc = f$1(x0, x1);
        at = temp$at;
        acc = temp$acc;
      }
    }
  } else {
    var result = z;
    while (this$4.hasNext__Z()) {
      var x0$1 = result;
      var x1$1 = this$4.next__O();
      result = f$1(x0$1, x1$1);
    }
    return result;
  }
});
$c_Lcats_Traverse$.prototype.traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O = (function(fa, f, G) {
  var iter = fa.iterator__sc_Iterator();
  if (iter.hasNext__Z()) {
    var first = iter.next__O();
    var z = f.apply__O__O(first);
    var f$1 = ((x$1, x$2) => G.productR__O__O__O(x$1, f.apply__O__O(x$2)));
    if ($is_sc_IndexedSeq(iter)) {
      var at = 0;
      var end = iter.length__I();
      var acc = z;
      var $x_1;
      while (true) {
        if ((at !== end)) {
          var temp$at = ((1 + at) | 0);
          var x0 = acc;
          var x1 = iter.apply__I__O(at);
          var temp$acc = f$1(x0, x1);
          at = temp$at;
          acc = temp$acc;
          continue;
        }
        var $x_1 = acc;
        break;
      }
    } else {
      var result = z;
      while (iter.hasNext__Z()) {
        var x0$1 = result;
        var x1$1 = iter.next__O();
        result = f$1(x0$1, x1$1);
      }
      var $x_1 = result;
    }
    return G.void__O__O($x_1);
  } else {
    return G.unit__O();
  }
});
var $d_Lcats_Traverse$ = new $TypeData().initClass($c_Lcats_Traverse$, "cats.Traverse$", ({
  Lcats_Traverse$: 1
}));
export { $d_Lcats_Traverse$ as $d_Lcats_Traverse$ };
var $n_Lcats_Traverse$;
function $m_Lcats_Traverse$() {
  if ((!$n_Lcats_Traverse$)) {
    $n_Lcats_Traverse$ = new $c_Lcats_Traverse$();
  }
  return $n_Lcats_Traverse$;
}
export { $m_Lcats_Traverse$ as $m_Lcats_Traverse$ };
/** @constructor */
function $c_Lcats_compat_FoldableCompat$() {
}
export { $c_Lcats_compat_FoldableCompat$ as $c_Lcats_compat_FoldableCompat$ };
$c_Lcats_compat_FoldableCompat$.prototype = new $h_O();
$c_Lcats_compat_FoldableCompat$.prototype.constructor = $c_Lcats_compat_FoldableCompat$;
/** @constructor */
function $h_Lcats_compat_FoldableCompat$() {
}
export { $h_Lcats_compat_FoldableCompat$ as $h_Lcats_compat_FoldableCompat$ };
$h_Lcats_compat_FoldableCompat$.prototype = $c_Lcats_compat_FoldableCompat$.prototype;
$c_Lcats_compat_FoldableCompat$.prototype.toIterable__O__Lcats_Foldable__sc_Iterable = (function(fa, F) {
  $m_Lcats_Eval$();
  var this$1 = $m_sci_LazyList$();
  var a = this$1.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  return F.foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Now(a), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a$1, eb) => eb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    $m_sci_LazyList$();
    return $m_sci_LazyList$cons$().apply__F0__F0__sci_LazyList(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => a$1)), new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((_$2$2) => (() => _$2$2))(_$2)));
  })))))).value__O();
});
var $d_Lcats_compat_FoldableCompat$ = new $TypeData().initClass($c_Lcats_compat_FoldableCompat$, "cats.compat.FoldableCompat$", ({
  Lcats_compat_FoldableCompat$: 1
}));
export { $d_Lcats_compat_FoldableCompat$ as $d_Lcats_compat_FoldableCompat$ };
var $n_Lcats_compat_FoldableCompat$;
function $m_Lcats_compat_FoldableCompat$() {
  if ((!$n_Lcats_compat_FoldableCompat$)) {
    $n_Lcats_compat_FoldableCompat$ = new $c_Lcats_compat_FoldableCompat$();
  }
  return $n_Lcats_compat_FoldableCompat$;
}
export { $m_Lcats_compat_FoldableCompat$ as $m_Lcats_compat_FoldableCompat$ };
function $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain($thiz, s) {
  var lc = s.lengthCompare__I__I(1);
  if ((lc < 0)) {
    return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  } else if ((lc > 0)) {
    return new $c_Lcats_data_Chain$Wrap(s);
  } else {
    $m_Lcats_data_Chain$();
    var a = s.head__O();
    return new $c_Lcats_data_Chain$Singleton(a);
  }
}
export { $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain as $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain };
/** @constructor */
function $c_Lcats_data_ChainInstances3() {
}
export { $c_Lcats_data_ChainInstances3 as $c_Lcats_data_ChainInstances3 };
$c_Lcats_data_ChainInstances3.prototype = new $h_O();
$c_Lcats_data_ChainInstances3.prototype.constructor = $c_Lcats_data_ChainInstances3;
/** @constructor */
function $h_Lcats_data_ChainInstances3() {
}
export { $h_Lcats_data_ChainInstances3 as $h_Lcats_data_ChainInstances3 };
$h_Lcats_data_ChainInstances3.prototype = $c_Lcats_data_ChainInstances3.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances1() {
}
export { $c_Lcats_data_NonEmptyListInstances1 as $c_Lcats_data_NonEmptyListInstances1 };
$c_Lcats_data_NonEmptyListInstances1.prototype = new $h_O();
$c_Lcats_data_NonEmptyListInstances1.prototype.constructor = $c_Lcats_data_NonEmptyListInstances1;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances1() {
}
export { $h_Lcats_data_NonEmptyListInstances1 as $h_Lcats_data_NonEmptyListInstances1 };
$h_Lcats_data_NonEmptyListInstances1.prototype = $c_Lcats_data_NonEmptyListInstances1.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyVectorInstances2() {
}
export { $c_Lcats_data_NonEmptyVectorInstances2 as $c_Lcats_data_NonEmptyVectorInstances2 };
$c_Lcats_data_NonEmptyVectorInstances2.prototype = new $h_O();
$c_Lcats_data_NonEmptyVectorInstances2.prototype.constructor = $c_Lcats_data_NonEmptyVectorInstances2;
/** @constructor */
function $h_Lcats_data_NonEmptyVectorInstances2() {
}
export { $h_Lcats_data_NonEmptyVectorInstances2 as $h_Lcats_data_NonEmptyVectorInstances2 };
$h_Lcats_data_NonEmptyVectorInstances2.prototype = $c_Lcats_data_NonEmptyVectorInstances2.prototype;
function $f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated($thiz, e) {
  $m_Lcats_data_NonEmptyList$();
  var tail = $m_sci_Nil$();
  var e$1 = new $c_Lcats_data_NonEmptyList(e, tail);
  return new $c_Lcats_data_Validated$Invalid(e$1);
}
export { $f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated as $f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated };
function $f_Lcats_data_ValidatedFunctions__fromEither__s_util_Either__Lcats_data_Validated($thiz, e) {
  if ((e instanceof $c_s_util_Right)) {
    var b = e.s_util_Right__f_value;
    var $x_1 = new $c_Lcats_data_Validated$Valid(b);
  } else {
    if ((!(e instanceof $c_s_util_Left))) {
      throw new $c_s_MatchError(e);
    }
    var a = e.s_util_Left__f_value;
    var $x_1 = new $c_Lcats_data_Validated$Invalid(a);
  }
  return $x_1;
}
export { $f_Lcats_data_ValidatedFunctions__fromEither__s_util_Either__Lcats_data_Validated as $f_Lcats_data_ValidatedFunctions__fromEither__s_util_Either__Lcats_data_Validated };
/** @constructor */
function $c_Lcats_data_ValidatedInstances2() {
}
export { $c_Lcats_data_ValidatedInstances2 as $c_Lcats_data_ValidatedInstances2 };
$c_Lcats_data_ValidatedInstances2.prototype = new $h_O();
$c_Lcats_data_ValidatedInstances2.prototype.constructor = $c_Lcats_data_ValidatedInstances2;
/** @constructor */
function $h_Lcats_data_ValidatedInstances2() {
}
export { $h_Lcats_data_ValidatedInstances2 as $h_Lcats_data_ValidatedInstances2 };
$h_Lcats_data_ValidatedInstances2.prototype = $c_Lcats_data_ValidatedInstances2.prototype;
function $f_Lcats_effect_kernel_MonadCancel$Uncancelable__onCancel__O__O__O($thiz, fa, fin) {
  return fa;
}
export { $f_Lcats_effect_kernel_MonadCancel$Uncancelable__onCancel__O__O__O as $f_Lcats_effect_kernel_MonadCancel$Uncancelable__onCancel__O__O__O };
/** @constructor */
function $c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$() {
}
export { $c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ as $c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ };
$c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$.prototype = new $h_O();
$c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$.prototype.constructor = $c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$;
/** @constructor */
function $h_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$() {
}
export { $h_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ as $h_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ };
$h_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$.prototype = $c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$.prototype;
$c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$.prototype.uncancelable$extension__O__Lcats_effect_kernel_MonadCancel__O = (function(this$, F) {
  return F.uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => this$)));
});
var $d_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ = new $TypeData().initClass($c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$, "cats.effect.kernel.syntax.MonadCancelOps_$", ({
  Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$: 1
}));
export { $d_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ as $d_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ };
var $n_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$;
function $m_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$() {
  if ((!$n_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$)) {
    $n_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ = new $c_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$();
  }
  return $n_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$;
}
export { $m_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ as $m_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$ };
/** @constructor */
function $c_Lcats_effect_unsafe_UnsafeNonFatal$() {
}
export { $c_Lcats_effect_unsafe_UnsafeNonFatal$ as $c_Lcats_effect_unsafe_UnsafeNonFatal$ };
$c_Lcats_effect_unsafe_UnsafeNonFatal$.prototype = new $h_O();
$c_Lcats_effect_unsafe_UnsafeNonFatal$.prototype.constructor = $c_Lcats_effect_unsafe_UnsafeNonFatal$;
/** @constructor */
function $h_Lcats_effect_unsafe_UnsafeNonFatal$() {
}
export { $h_Lcats_effect_unsafe_UnsafeNonFatal$ as $h_Lcats_effect_unsafe_UnsafeNonFatal$ };
$h_Lcats_effect_unsafe_UnsafeNonFatal$.prototype = $c_Lcats_effect_unsafe_UnsafeNonFatal$.prototype;
$c_Lcats_effect_unsafe_UnsafeNonFatal$.prototype.apply__jl_Throwable__Z = (function(t) {
  matchAlts1: {
    matchAlts2: {
      if ((t instanceof $c_jl_VirtualMachineError)) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      if (false) {
        break matchAlts2;
      }
      if ((t instanceof $c_s_util_control_ControlThrowable)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return false;
  }
  return true;
});
var $d_Lcats_effect_unsafe_UnsafeNonFatal$ = new $TypeData().initClass($c_Lcats_effect_unsafe_UnsafeNonFatal$, "cats.effect.unsafe.UnsafeNonFatal$", ({
  Lcats_effect_unsafe_UnsafeNonFatal$: 1
}));
export { $d_Lcats_effect_unsafe_UnsafeNonFatal$ as $d_Lcats_effect_unsafe_UnsafeNonFatal$ };
var $n_Lcats_effect_unsafe_UnsafeNonFatal$;
function $m_Lcats_effect_unsafe_UnsafeNonFatal$() {
  if ((!$n_Lcats_effect_unsafe_UnsafeNonFatal$)) {
    $n_Lcats_effect_unsafe_UnsafeNonFatal$ = new $c_Lcats_effect_unsafe_UnsafeNonFatal$();
  }
  return $n_Lcats_effect_unsafe_UnsafeNonFatal$;
}
export { $m_Lcats_effect_unsafe_UnsafeNonFatal$ as $m_Lcats_effect_unsafe_UnsafeNonFatal$ };
/** @constructor */
function $c_Lcats_kernel_EqFunctions() {
}
export { $c_Lcats_kernel_EqFunctions as $c_Lcats_kernel_EqFunctions };
$c_Lcats_kernel_EqFunctions.prototype = new $h_O();
$c_Lcats_kernel_EqFunctions.prototype.constructor = $c_Lcats_kernel_EqFunctions;
/** @constructor */
function $h_Lcats_kernel_EqFunctions() {
}
export { $h_Lcats_kernel_EqFunctions as $h_Lcats_kernel_EqFunctions };
$h_Lcats_kernel_EqFunctions.prototype = $c_Lcats_kernel_EqFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_SemigroupFunctions() {
}
export { $c_Lcats_kernel_SemigroupFunctions as $c_Lcats_kernel_SemigroupFunctions };
$c_Lcats_kernel_SemigroupFunctions.prototype = new $h_O();
$c_Lcats_kernel_SemigroupFunctions.prototype.constructor = $c_Lcats_kernel_SemigroupFunctions;
/** @constructor */
function $h_Lcats_kernel_SemigroupFunctions() {
}
export { $h_Lcats_kernel_SemigroupFunctions as $h_Lcats_kernel_SemigroupFunctions };
$h_Lcats_kernel_SemigroupFunctions.prototype = $c_Lcats_kernel_SemigroupFunctions.prototype;
$c_Lcats_kernel_SemigroupFunctions.prototype.maybeCombine__s_Option__O__Lcats_kernel_Semigroup__O = (function(ox, y, ev) {
  if ((ox instanceof $c_s_Some)) {
    var x = ox.s_Some__f_value;
    return ev.combine__O__O__O(x, y);
  }
  var x$2 = $m_s_None$();
  if ((x$2 === ox)) {
    return y;
  }
  throw new $c_s_MatchError(ox);
});
$c_Lcats_kernel_SemigroupFunctions.prototype.maybeCombine__O__s_Option__Lcats_kernel_Semigroup__O = (function(x, oy, ev) {
  if ((oy instanceof $c_s_Some)) {
    var y = oy.s_Some__f_value;
    return ev.combine__O__O__O(x, y);
  }
  var x$2 = $m_s_None$();
  if ((x$2 === oy)) {
    return x;
  }
  throw new $c_s_MatchError(oy);
});
/** @constructor */
function $c_Lcats_kernel_compat_HashCompat() {
}
export { $c_Lcats_kernel_compat_HashCompat as $c_Lcats_kernel_compat_HashCompat };
$c_Lcats_kernel_compat_HashCompat.prototype = new $h_O();
$c_Lcats_kernel_compat_HashCompat.prototype.constructor = $c_Lcats_kernel_compat_HashCompat;
/** @constructor */
function $h_Lcats_kernel_compat_HashCompat() {
}
export { $h_Lcats_kernel_compat_HashCompat as $h_Lcats_kernel_compat_HashCompat };
$h_Lcats_kernel_compat_HashCompat.prototype = $c_Lcats_kernel_compat_HashCompat.prototype;
$c_Lcats_kernel_compat_HashCompat.prototype.orderedHash__sc_IterableOnce__Lcats_kernel_Hash__I = (function(xs, A) {
  var it = xs.iterator__sc_Iterator();
  var h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_seqSeed;
  if ((!it.hasNext__Z())) {
    return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 0);
  }
  var x0 = it.next__O();
  if ((!it.hasNext__Z())) {
    return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, A.hash__O__I(x0)), 1);
  }
  var x1 = it.next__O();
  var initial = A.hash__O__I(x0);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, initial);
  var h0 = h;
  var prev = A.hash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while (it.hasNext__Z()) {
    h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, prev);
    var hash = A.hash__O__I(it.next__O());
    if ((rangeDiff !== ((hash - prev) | 0))) {
      h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while (it.hasNext__Z()) {
        h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, A.hash__O__I(it.next__O()));
        i = ((1 + i) | 0);
      }
      return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, i);
    }
    prev = hash;
    i = ((1 + i) | 0);
  }
  return this.avalanche__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I($m_s_util_hashing_MurmurHash3$().mix__I__I__I(h0, rangeDiff), prev));
});
$c_Lcats_kernel_compat_HashCompat.prototype.avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
function $f_Lcats_kernel_instances_IntInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_IntOrder());
  $thiz.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_IntGroup());
}
export { $f_Lcats_kernel_instances_IntInstances__$init$__V as $f_Lcats_kernel_instances_IntInstances__$init$__V };
/** @constructor */
function $c_Lcats_kernel_instances_ListMonoid$() {
  this.Lcats_kernel_instances_ListMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_ListMonoid$ = this;
  this.Lcats_kernel_instances_ListMonoid$__f_singleton = new $c_Lcats_kernel_instances_ListMonoid();
}
export { $c_Lcats_kernel_instances_ListMonoid$ as $c_Lcats_kernel_instances_ListMonoid$ };
$c_Lcats_kernel_instances_ListMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_ListMonoid$.prototype.constructor = $c_Lcats_kernel_instances_ListMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_ListMonoid$() {
}
export { $h_Lcats_kernel_instances_ListMonoid$ as $h_Lcats_kernel_instances_ListMonoid$ };
$h_Lcats_kernel_instances_ListMonoid$.prototype = $c_Lcats_kernel_instances_ListMonoid$.prototype;
var $d_Lcats_kernel_instances_ListMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_ListMonoid$, "cats.kernel.instances.ListMonoid$", ({
  Lcats_kernel_instances_ListMonoid$: 1
}));
export { $d_Lcats_kernel_instances_ListMonoid$ as $d_Lcats_kernel_instances_ListMonoid$ };
var $n_Lcats_kernel_instances_ListMonoid$;
function $m_Lcats_kernel_instances_ListMonoid$() {
  if ((!$n_Lcats_kernel_instances_ListMonoid$)) {
    $n_Lcats_kernel_instances_ListMonoid$ = new $c_Lcats_kernel_instances_ListMonoid$();
  }
  return $n_Lcats_kernel_instances_ListMonoid$;
}
export { $m_Lcats_kernel_instances_ListMonoid$ as $m_Lcats_kernel_instances_ListMonoid$ };
function $f_Lcats_kernel_instances_LongInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V(new $c_Lcats_kernel_instances_LongOrder());
  $thiz.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V(new $c_Lcats_kernel_instances_LongGroup());
}
export { $f_Lcats_kernel_instances_LongInstances__$init$__V as $f_Lcats_kernel_instances_LongInstances__$init$__V };
/** @constructor */
function $c_Lcats_kernel_instances_SeqMonoid$() {
  this.Lcats_kernel_instances_SeqMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_SeqMonoid$ = this;
  this.Lcats_kernel_instances_SeqMonoid$__f_singleton = new $c_Lcats_kernel_instances_SeqMonoid();
}
export { $c_Lcats_kernel_instances_SeqMonoid$ as $c_Lcats_kernel_instances_SeqMonoid$ };
$c_Lcats_kernel_instances_SeqMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_SeqMonoid$.prototype.constructor = $c_Lcats_kernel_instances_SeqMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_SeqMonoid$() {
}
export { $h_Lcats_kernel_instances_SeqMonoid$ as $h_Lcats_kernel_instances_SeqMonoid$ };
$h_Lcats_kernel_instances_SeqMonoid$.prototype = $c_Lcats_kernel_instances_SeqMonoid$.prototype;
var $d_Lcats_kernel_instances_SeqMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_SeqMonoid$, "cats.kernel.instances.SeqMonoid$", ({
  Lcats_kernel_instances_SeqMonoid$: 1
}));
export { $d_Lcats_kernel_instances_SeqMonoid$ as $d_Lcats_kernel_instances_SeqMonoid$ };
var $n_Lcats_kernel_instances_SeqMonoid$;
function $m_Lcats_kernel_instances_SeqMonoid$() {
  if ((!$n_Lcats_kernel_instances_SeqMonoid$)) {
    $n_Lcats_kernel_instances_SeqMonoid$ = new $c_Lcats_kernel_instances_SeqMonoid$();
  }
  return $n_Lcats_kernel_instances_SeqMonoid$;
}
export { $m_Lcats_kernel_instances_SeqMonoid$ as $m_Lcats_kernel_instances_SeqMonoid$ };
function $f_Lcats_kernel_instances_StringInstances__$init$__V($thiz) {
  $thiz.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V(new $c_Lcats_kernel_instances_StringOrder());
  $thiz.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V(new $c_Lcats_kernel_instances_StringMonoid());
}
export { $f_Lcats_kernel_instances_StringInstances__$init$__V as $f_Lcats_kernel_instances_StringInstances__$init$__V };
/** @constructor */
function $c_Lcats_kernel_instances_VectorMonoid$() {
  this.Lcats_kernel_instances_VectorMonoid$__f_singleton = null;
  $n_Lcats_kernel_instances_VectorMonoid$ = this;
  this.Lcats_kernel_instances_VectorMonoid$__f_singleton = new $c_Lcats_kernel_instances_VectorMonoid();
}
export { $c_Lcats_kernel_instances_VectorMonoid$ as $c_Lcats_kernel_instances_VectorMonoid$ };
$c_Lcats_kernel_instances_VectorMonoid$.prototype = new $h_O();
$c_Lcats_kernel_instances_VectorMonoid$.prototype.constructor = $c_Lcats_kernel_instances_VectorMonoid$;
/** @constructor */
function $h_Lcats_kernel_instances_VectorMonoid$() {
}
export { $h_Lcats_kernel_instances_VectorMonoid$ as $h_Lcats_kernel_instances_VectorMonoid$ };
$h_Lcats_kernel_instances_VectorMonoid$.prototype = $c_Lcats_kernel_instances_VectorMonoid$.prototype;
var $d_Lcats_kernel_instances_VectorMonoid$ = new $TypeData().initClass($c_Lcats_kernel_instances_VectorMonoid$, "cats.kernel.instances.VectorMonoid$", ({
  Lcats_kernel_instances_VectorMonoid$: 1
}));
export { $d_Lcats_kernel_instances_VectorMonoid$ as $d_Lcats_kernel_instances_VectorMonoid$ };
var $n_Lcats_kernel_instances_VectorMonoid$;
function $m_Lcats_kernel_instances_VectorMonoid$() {
  if ((!$n_Lcats_kernel_instances_VectorMonoid$)) {
    $n_Lcats_kernel_instances_VectorMonoid$ = new $c_Lcats_kernel_instances_VectorMonoid$();
  }
  return $n_Lcats_kernel_instances_VectorMonoid$;
}
export { $m_Lcats_kernel_instances_VectorMonoid$ as $m_Lcats_kernel_instances_VectorMonoid$ };
/** @constructor */
function $c_Lcats_package$() {
  this.Lcats_package$__f_catsInstancesForId = null;
  this.Lcats_package$__f_Eq = null;
  this.Lcats_package$__f_PartialOrder = null;
  this.Lcats_package$__f_Order = null;
  this.Lcats_package$__f_Hash = null;
  this.Lcats_package$__f_Semigroup = null;
  this.Lcats_package$__f_Monoid = null;
  $n_Lcats_package$ = this;
  this.Lcats_package$__f_catsInstancesForId = new $c_Lcats_package$$anon$1();
  new $c_Lcats_package$$anon$2();
  new $c_Lcats_package$$anon$3();
  var evidence$1 = $m_Lcats_package$().Lcats_package$__f_catsInstancesForId;
  new $c_Lcats_Parallel$$anon$2(evidence$1);
  this.Lcats_package$__f_Eq = $m_Lcats_kernel_Eq$();
  this.Lcats_package$__f_PartialOrder = $m_Lcats_kernel_PartialOrder$();
  this.Lcats_package$__f_Order = $m_Lcats_kernel_Order$();
  $m_Lcats_kernel_Comparison$();
  this.Lcats_package$__f_Hash = $m_Lcats_kernel_Hash$();
  this.Lcats_package$__f_Semigroup = $m_Lcats_kernel_Semigroup$();
  this.Lcats_package$__f_Monoid = $m_Lcats_kernel_Monoid$();
}
export { $c_Lcats_package$ as $c_Lcats_package$ };
$c_Lcats_package$.prototype = new $h_O();
$c_Lcats_package$.prototype.constructor = $c_Lcats_package$;
/** @constructor */
function $h_Lcats_package$() {
}
export { $h_Lcats_package$ as $h_Lcats_package$ };
$h_Lcats_package$.prototype = $c_Lcats_package$.prototype;
var $d_Lcats_package$ = new $TypeData().initClass($c_Lcats_package$, "cats.package$", ({
  Lcats_package$: 1
}));
export { $d_Lcats_package$ as $d_Lcats_package$ };
var $n_Lcats_package$;
function $m_Lcats_package$() {
  if ((!$n_Lcats_package$)) {
    $n_Lcats_package$ = new $c_Lcats_package$();
  }
  return $n_Lcats_package$;
}
export { $m_Lcats_package$ as $m_Lcats_package$ };
/** @constructor */
function $c_Lcats_syntax_EitherUtil$() {
  this.Lcats_syntax_EitherUtil$__f_unit = null;
  $n_Lcats_syntax_EitherUtil$ = this;
  this.Lcats_syntax_EitherUtil$__f_unit = new $c_s_util_Right((void 0));
}
export { $c_Lcats_syntax_EitherUtil$ as $c_Lcats_syntax_EitherUtil$ };
$c_Lcats_syntax_EitherUtil$.prototype = new $h_O();
$c_Lcats_syntax_EitherUtil$.prototype.constructor = $c_Lcats_syntax_EitherUtil$;
/** @constructor */
function $h_Lcats_syntax_EitherUtil$() {
}
export { $h_Lcats_syntax_EitherUtil$ as $h_Lcats_syntax_EitherUtil$ };
$h_Lcats_syntax_EitherUtil$.prototype = $c_Lcats_syntax_EitherUtil$.prototype;
var $d_Lcats_syntax_EitherUtil$ = new $TypeData().initClass($c_Lcats_syntax_EitherUtil$, "cats.syntax.EitherUtil$", ({
  Lcats_syntax_EitherUtil$: 1
}));
export { $d_Lcats_syntax_EitherUtil$ as $d_Lcats_syntax_EitherUtil$ };
var $n_Lcats_syntax_EitherUtil$;
function $m_Lcats_syntax_EitherUtil$() {
  if ((!$n_Lcats_syntax_EitherUtil$)) {
    $n_Lcats_syntax_EitherUtil$ = new $c_Lcats_syntax_EitherUtil$();
  }
  return $n_Lcats_syntax_EitherUtil$;
}
export { $m_Lcats_syntax_EitherUtil$ as $m_Lcats_syntax_EitherUtil$ };
/** @constructor */
function $c_Lcats_syntax_EqOps(lhs, evidence$1) {
  this.Lcats_syntax_EqOps__f_lhs = null;
  this.Lcats_syntax_EqOps__f_evidence$1 = null;
  this.Lcats_syntax_EqOps__f_lhs = lhs;
  this.Lcats_syntax_EqOps__f_evidence$1 = evidence$1;
}
export { $c_Lcats_syntax_EqOps as $c_Lcats_syntax_EqOps };
$c_Lcats_syntax_EqOps.prototype = new $h_O();
$c_Lcats_syntax_EqOps.prototype.constructor = $c_Lcats_syntax_EqOps;
/** @constructor */
function $h_Lcats_syntax_EqOps() {
}
export { $h_Lcats_syntax_EqOps as $h_Lcats_syntax_EqOps };
$h_Lcats_syntax_EqOps.prototype = $c_Lcats_syntax_EqOps.prototype;
$c_Lcats_syntax_EqOps.prototype.$eq$eq$eq__O__Z = (function(rhs) {
  $m_Lcats_package$();
  var ev = this.Lcats_syntax_EqOps__f_evidence$1;
  return ev.eqv__O__O__Z(this.Lcats_syntax_EqOps__f_lhs, rhs);
});
$c_Lcats_syntax_EqOps.prototype.$eq$bang$eq__O__Z = (function(rhs) {
  $m_Lcats_package$();
  var ev = this.Lcats_syntax_EqOps__f_evidence$1;
  return ev.neqv__O__O__Z(this.Lcats_syntax_EqOps__f_lhs, rhs);
});
var $d_Lcats_syntax_EqOps = new $TypeData().initClass($c_Lcats_syntax_EqOps, "cats.syntax.EqOps", ({
  Lcats_syntax_EqOps: 1
}));
export { $d_Lcats_syntax_EqOps as $d_Lcats_syntax_EqOps };
/** @constructor */
function $c_Lcats_syntax_FlatMapOps$() {
}
export { $c_Lcats_syntax_FlatMapOps$ as $c_Lcats_syntax_FlatMapOps$ };
$c_Lcats_syntax_FlatMapOps$.prototype = new $h_O();
$c_Lcats_syntax_FlatMapOps$.prototype.constructor = $c_Lcats_syntax_FlatMapOps$;
/** @constructor */
function $h_Lcats_syntax_FlatMapOps$() {
}
export { $h_Lcats_syntax_FlatMapOps$ as $h_Lcats_syntax_FlatMapOps$ };
$h_Lcats_syntax_FlatMapOps$.prototype = $c_Lcats_syntax_FlatMapOps$.prototype;
$c_Lcats_syntax_FlatMapOps$.prototype.$greater$greater$extension__O__F0__Lcats_FlatMap__O = (function(this$, fb, F) {
  return F.flatMap__O__F1__O(this$, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => fb.apply__O())));
});
var $d_Lcats_syntax_FlatMapOps$ = new $TypeData().initClass($c_Lcats_syntax_FlatMapOps$, "cats.syntax.FlatMapOps$", ({
  Lcats_syntax_FlatMapOps$: 1
}));
export { $d_Lcats_syntax_FlatMapOps$ as $d_Lcats_syntax_FlatMapOps$ };
var $n_Lcats_syntax_FlatMapOps$;
function $m_Lcats_syntax_FlatMapOps$() {
  if ((!$n_Lcats_syntax_FlatMapOps$)) {
    $n_Lcats_syntax_FlatMapOps$ = new $c_Lcats_syntax_FlatMapOps$();
  }
  return $n_Lcats_syntax_FlatMapOps$;
}
export { $m_Lcats_syntax_FlatMapOps$ as $m_Lcats_syntax_FlatMapOps$ };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$() {
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$pool = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$readerConfig = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$writeConfig = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_intC3C = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_longC3C = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_doubleC3C = null;
  $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$ = this;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$pool = new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1();
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$readerConfig = new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig(32768, 4096, 33554432, 4194304, true, false, false, 2).withPreferredBufSize__I__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig(512).withMaxBufSize__I__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig(512).withPreferredCharBufSize__I__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig(512).withMaxCharBufSize__I__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig(512);
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$writeConfig = $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$().withPreferredBufSize__I__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig(512);
  $m_Lio_circe_JsoniterScalaCodec$();
  $m_Lio_circe_JsoniterScalaCodec$();
  $m_Lio_circe_JsoniterScalaCodec$();
  var codec$5 = new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4();
  var fromString$2 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$3) => (this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$pool.get__O().T3__f__1.read__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonValueCodec__T__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__O(codec$5, s$3, this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$readerConfig) | 0)));
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_intC3C = new $c_Lio_circe_JsoniterScalaCodec$$anon$3(fromString$2);
  $m_Lio_circe_JsoniterScalaCodec$();
  var codec$7 = new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5();
  var fromString$3 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$4) => $uJ(this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$pool.get__O().T3__f__1.read__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonValueCodec__T__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__O(codec$7, s$4, this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$readerConfig))));
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_longC3C = new $c_Lio_circe_JsoniterScalaCodec$$anon$4(fromString$3);
  $m_Lio_circe_JsoniterScalaCodec$();
  $m_Lio_circe_JsoniterScalaCodec$();
  var codec$11 = new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7();
  var fromString$5 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$6) => (+this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$pool.get__O().T3__f__1.read__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonValueCodec__T__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__O(codec$11, s$6, this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_com$github$plokhotnyuk$jsoniter_scala$circe$CirceCodecs$$$readerConfig))));
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_doubleC3C = new $c_Lio_circe_JsoniterScalaCodec$$anon$6(fromString$5);
  $m_Lio_circe_JsoniterScalaCodec$();
  $m_Lio_circe_JsoniterScalaCodec$();
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$ as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$ };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$.prototype = new $h_O();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$ as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$ };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$.prototype;
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$ = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$, "com.github.plokhotnyuk.jsoniter_scala.circe.CirceCodecs$", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$ as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$ };
var $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$;
function $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$() {
  if ((!$n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$)) {
    $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$ = new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$();
  }
  return $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$;
}
export { $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$ as $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$ };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E($thiz, msg, pos, cause) {
  $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__I__I__jl_Throwable__E($thiz, $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendString__T__I__I($thiz, msg, 0), pos, cause);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__I__I__jl_Throwable__E($thiz, from, pos, cause) {
  var i = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendString__T__I__I($thiz, ", offset: 0x", from);
  if ((($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_bbuf === null) && ($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_in === null))) {
    var t = $L0;
  } else {
    var a = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_totalRead;
    var value = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail;
    var hi = (value >> 31);
    var alo = a.RTLong__f_lo;
    var lo = ((alo - value) | 0);
    var hi$1 = ((((a.RTLong__f_hi - hi) | 0) + ((((~alo) & value) | ((~(alo ^ value)) & lo)) >> 31)) | 0);
    var x__lo = lo;
    var x__hi = hi$1;
    var t = new $c_RTLong(x__lo, x__hi);
  }
  var lo$1 = t.RTLong__f_lo;
  var hi$2 = t.RTLong__f_hi;
  var hi$3 = (pos >> 31);
  var lo$2 = ((lo$1 + pos) | 0);
  var hi$4 = ((((hi$2 + hi$3) | 0) + ((((lo$1 & pos) | ((lo$1 | pos) & (~lo$2))) >>> 31) | 0)) | 0);
  i = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendHexOffset__J__I__I($thiz, new $c_RTLong(lo$2, hi$4), i);
  if ($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_config.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_appendHexDumpToParseException) {
    i = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendString__T__I__I($thiz, ", buf:", i);
    i = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendHexDump__I__I__I__I($thiz, pos, lo$1, i);
  }
  var value$1 = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf;
  var count = i;
  throw new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReaderException($m_jl_String$().new__AC__I__I__T(value$1, 0, count), cause, $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_config.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_throwReaderExceptionWithStackTrace);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__I__I__jl_Throwable__E as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__I__I__jl_Throwable__E };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__nextToken__I__B($thiz, pos) {
  var pos$tailLocal3 = pos;
  while (true) {
    if ((pos$tailLocal3 < $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
      var b = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u[pos$tailLocal3];
      if ((((b === 32) || (b === 10)) || ((4 | b) === 13))) {
        pos$tailLocal3 = ((1 + pos$tailLocal3) | 0);
      } else {
        $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = ((1 + pos$tailLocal3) | 0);
        return b;
      }
    } else {
      pos$tailLocal3 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I($thiz, pos$tailLocal3);
    }
  }
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__nextToken__I__B as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__nextToken__I__B };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendChars__AC__I__I($thiz, cs, i) {
  var len = cs.u.length;
  var required = ((i + len) | 0);
  if (($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf.u.length < required)) {
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__growCharBuf__I__I($thiz, required);
  }
  var dest = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf;
  cs.copyTo(0, dest, i, len);
  return required;
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendChars__AC__I__I as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendChars__AC__I__I };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendString__T__I__I($thiz, s, i) {
  var len = s.length;
  var required = ((i + len) | 0);
  if (($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf.u.length < required)) {
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__growCharBuf__I__I($thiz, required);
  }
  $f_T__getChars__I__I__AC__I__V(s, 0, len, $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf, i);
  return required;
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendString__T__I__I as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendString__T__I__I };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__ensureNotLeadingZero__V($thiz) {
  var pos = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
  if ((pos < $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
    var $x_2 = true;
  } else {
    pos = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I($thiz, pos);
    var $x_2 = (pos < $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail);
  }
  if ($x_2) {
    var b = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u[pos];
    var $x_1 = ((b >= 48) && (b <= 57));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var pos$1 = (((-1) + pos) | 0);
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E($thiz, "illegal number with leading zero", pos$1, null);
  }
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__ensureNotLeadingZero__V as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__ensureNotLeadingZero__V };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__toDouble__I__I__I__D($thiz, from, newMark, pos) {
  var offset = from;
  if (($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark === 0)) {
    offset = ((offset - newMark) | 0);
  }
  var bytes = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
  var offset$1 = offset;
  var length = ((pos - offset) | 0);
  var this$1 = $m_jl_String$();
  var s = this$1.new__AB__I__I__Ljava_nio_charset_Charset__T(bytes, offset$1, length, $m_Ljava_nio_charset_UTF\uff3f8$());
  return $m_jl_Double$().parseDouble__T__D(s);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__toDouble__I__I__I__D as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__toDouble__I__I__I__D };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__numberError$default$1__I($thiz) {
  return (((-1) + $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head) | 0);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__numberError$default$1__I as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__numberError$default$1__I };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendHexDump__I__I__I__I($thiz, pos, offset, from) {
  var hexDumpSizeInBytes = ($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_config.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_hexDumpSize << 4);
  var a = ((-16) & ((pos - hexDumpSizeInBytes) | 0));
  var start = ((a > 0) ? a : 0);
  var a$1 = ((-16) & ((16 + ((pos + hexDumpSizeInBytes) | 0)) | 0));
  var b = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail;
  var end = ((a$1 < b) ? a$1 : b);
  var alignedAbsFrom = ((-16) & ((start + offset) | 0));
  var alignedAbsTo = ((-16) & ((15 + ((end + offset) | 0)) | 0));
  var len = ((alignedAbsTo - alignedAbsFrom) | 0);
  var bufOffset = ((alignedAbsFrom - offset) | 0);
  var i = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendChars__AC__I__I($thiz, $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$dumpBorder, from);
  i = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendChars__AC__I__I($thiz, $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$dumpHeader, i);
  i = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendChars__AC__I__I($thiz, $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$dumpBorder, i);
  var buf = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
  var ds = $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$hexDigits;
  var charBuf = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf;
  var lim = charBuf.u.length;
  var j = 0;
  while ((j < len)) {
    var linePos = (15 & j);
    if ((linePos === 0)) {
      if ((((81 + i) | 0) >= lim)) {
        lim = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__growCharBuf__I__I($thiz, ((81 + i) | 0));
        charBuf = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf;
      }
      charBuf.u[i] = 10;
      charBuf.u[((1 + i) | 0)] = 124;
      charBuf.u[((2 + i) | 0)] = 32;
      var d = ((alignedAbsFrom + j) | 0);
      var i$1 = ((3 + i) | 0);
      var charBuf$1 = charBuf;
      charBuf$1.u[i$1] = ds.u[((d >>> 28) | 0)];
      charBuf$1.u[((1 + i$1) | 0)] = ds.u[(15 & (d >> 24))];
      charBuf$1.u[((2 + i$1) | 0)] = ds.u[(15 & (d >> 20))];
      charBuf$1.u[((3 + i$1) | 0)] = ds.u[(15 & (d >> 16))];
      charBuf$1.u[((4 + i$1) | 0)] = ds.u[(15 & (d >> 12))];
      charBuf$1.u[((5 + i$1) | 0)] = ds.u[(15 & (d >> 8))];
      charBuf$1.u[((6 + i$1) | 0)] = ds.u[(15 & (d >> 4))];
      charBuf$1.u[((7 + i$1) | 0)] = ds.u[(15 & d)];
      charBuf.u[((11 + i) | 0)] = 32;
      charBuf.u[((12 + i) | 0)] = 124;
      charBuf.u[((13 + i) | 0)] = 32;
      i = ((14 + i) | 0);
    }
    var pos$2 = ((bufOffset + j) | 0);
    var $x_3 = charBuf;
    var $x_2 = i;
    if (((pos$2 >= start) && (pos$2 < end))) {
      var b$1 = buf.u[pos$2];
      charBuf.u[i] = ds.u[(15 & (b$1 >> 4))];
      charBuf.u[((1 + i) | 0)] = ds.u[(15 & b$1)];
      charBuf.u[((2 + i) | 0)] = 32;
      var $x_1 = (((b$1 <= 31) || (b$1 >= 127)) ? 46 : (65535 & b$1));
    } else {
      charBuf.u[i] = 32;
      charBuf.u[((1 + i) | 0)] = 32;
      charBuf.u[((2 + i) | 0)] = 32;
      var $x_1 = 32;
    }
    $x_3.u[((((50 + $x_2) | 0) - (linePos << 1)) | 0)] = $x_1;
    i = ((3 + i) | 0);
    if ((linePos === 15)) {
      charBuf.u[i] = 124;
      charBuf.u[((1 + i) | 0)] = 32;
      charBuf.u[((18 + i) | 0)] = 32;
      charBuf.u[((19 + i) | 0)] = 124;
      i = ((20 + i) | 0);
    }
    j = ((1 + j) | 0);
  }
  return $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendChars__AC__I__I($thiz, $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$dumpBorder, i);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendHexDump__I__I__I__I as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendHexDump__I__I__I__I };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendHexOffset__J__I__I($thiz, d, i) {
  var required = ((16 + i) | 0);
  if (($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf.u.length < required)) {
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__growCharBuf__I__I($thiz, required);
  }
  var ds = $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$hexDigits;
  var j = i;
  var dl = d.RTLong__f_lo;
  var hi = (dl >> 31);
  if ((!((dl === d.RTLong__f_lo) && (hi === d.RTLong__f_hi)))) {
    var hi$1 = d.RTLong__f_hi;
    var shift = (28 & ((32 - Math.clz32(hi$1)) | 0));
    while ((shift >= 0)) {
      $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf.u[j] = ds.u[(15 & (hi$1 >> shift))];
      shift = (((-4) + shift) | 0);
      j = ((1 + j) | 0);
    }
  }
  var i$1 = j;
  var charBuf = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf;
  charBuf.u[i$1] = ds.u[((dl >>> 28) | 0)];
  charBuf.u[((1 + i$1) | 0)] = ds.u[(15 & (dl >> 24))];
  charBuf.u[((2 + i$1) | 0)] = ds.u[(15 & (dl >> 20))];
  charBuf.u[((3 + i$1) | 0)] = ds.u[(15 & (dl >> 16))];
  charBuf.u[((4 + i$1) | 0)] = ds.u[(15 & (dl >> 12))];
  charBuf.u[((5 + i$1) | 0)] = ds.u[(15 & (dl >> 8))];
  charBuf.u[((6 + i$1) | 0)] = ds.u[(15 & (dl >> 4))];
  charBuf.u[((7 + i$1) | 0)] = ds.u[(15 & dl)];
  return ((8 + j) | 0);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendHexOffset__J__I__I as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__appendHexOffset__J__I__I };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__growCharBuf__I__I($thiz, required) {
  var charBufLen = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf.u.length;
  var maxCharBufSize = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_config.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxCharBufSize;
  if ((charBufLen === maxCharBufSize)) {
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__tooLongStringError__E($thiz);
  }
  var i = (charBufLen | required);
  charBufLen = ((1 + (((-1) >>> Math.clz32(i)) | 0)) | 0);
  var x = charBufLen;
  if ((((x === maxCharBufSize) ? 0 : (((x >>> 0) < (maxCharBufSize >>> 0)) ? (-1) : 1)) > 0)) {
    charBufLen = maxCharBufSize;
  }
  var original = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf;
  var newLength = charBufLen;
  $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf = $m_ju_Arrays$().copyOf__AC__I__AC(original, newLength);
  return charBufLen;
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__growCharBuf__I__I as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__growCharBuf__I__I };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I($thiz, pos) {
  if ((($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_bbuf === null) && ($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_in === null))) {
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__endOfInputError__E($thiz);
  }
  return $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__Z__I($thiz, pos, true);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I($thiz, pos) {
  return ((($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_bbuf === null) && ($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_in === null)) ? pos : $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__Z__I($thiz, pos, false));
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__Z__I($thiz, pos, throwOnEndOfInput) {
  var newPos = pos;
  var offset = (($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark < 0) ? pos : $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark);
  if ((offset > 0)) {
    newPos = ((newPos - offset) | 0);
    var buf = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
    var remaining = (($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail - offset) | 0);
    var i = 0;
    while ((i < remaining)) {
      buf.u[i] = buf.u[((i + offset) | 0)];
      i = ((1 + i) | 0);
    }
    if (($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark > 0)) {
      $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark = 0;
    }
    $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail = remaining;
    $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = newPos;
  } else if (($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u.length === $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__growBuf__V($thiz);
  }
  var len = (($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u.length - $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail) | 0);
  if (($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_bbuf !== null)) {
    var this$1 = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_bbuf;
    var a = ((this$1.Ljava_nio_Buffer__f__limit - this$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
    var b = len;
    len = ((a < b) ? a : b);
    $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_bbuf.get__AB__I__I__Ljava_nio_ByteBuffer($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf, $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail, len);
  } else {
    var a$1 = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_in.read__AB__I__I__I($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf, $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail, len);
    len = ((a$1 > 0) ? a$1 : 0);
  }
  if ((throwOnEndOfInput && (len === 0))) {
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__endOfInputError__E($thiz);
  }
  $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail = (($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail + len) | 0);
  var a$2 = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_totalRead;
  var value = len;
  var hi = (value >> 31);
  var alo = a$2.RTLong__f_lo;
  var lo = ((alo + value) | 0);
  var hi$1 = ((((a$2.RTLong__f_hi + hi) | 0) + ((((alo & value) | ((alo | value) & (~lo))) >>> 31) | 0)) | 0);
  $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_totalRead = new $c_RTLong(lo, hi$1);
  return newPos;
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__Z__I as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__Z__I };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__growBuf__V($thiz) {
  var bufLen = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u.length;
  var maxBufSize = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_config.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxBufSize;
  if ((bufLen === maxBufSize)) {
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__tooLongInputError__E($thiz);
  }
  bufLen = (bufLen << 1);
  var x = bufLen;
  if ((((x === maxBufSize) ? 0 : (((x >>> 0) < (maxBufSize >>> 0)) ? (-1) : 1)) > 0)) {
    bufLen = maxBufSize;
  }
  var original = $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
  var newLength = bufLen;
  $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf = $m_ju_Arrays$().copyOf__AB__I__AB(original, newLength);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__growBuf__V as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__growBuf__V };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__tooLongInputError__E($thiz) {
  $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E($thiz, "too long part of input exceeded 'maxBufSize'", $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail, null);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__tooLongInputError__E as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__tooLongInputError__E };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__tooLongStringError__E($thiz) {
  $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E($thiz, "too long string exceeded 'maxCharBufSize'", $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail, null);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__tooLongStringError__E as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__tooLongStringError__E };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__endOfInputError__E($thiz) {
  $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E($thiz, "unexpected end of input", $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail, null);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__endOfInputError__E as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__endOfInputError__E };
function $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__reallocateCharBufToPreferredSize__V($thiz) {
  $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf = new $ac_C($thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_config.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredCharBufSize);
}
export { $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__reallocateCharBufToPreferredSize__V as $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__reallocateCharBufToPreferredSize__V };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader(buf, head, tail, mark, charBuf, bbuf, in$1, totalRead, config) {
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_bbuf = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_in = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_totalRead = $L0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_config = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf = buf;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = head;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail = tail;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark = mark;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf = charBuf;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_bbuf = bbuf;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_in = in$1;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_totalRead = totalRead;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_config = config;
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype = new $h_O();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype;
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype.hasRemaining__Z = (function() {
  return ((this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail) || ($p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I(this, this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head) < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail));
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype.decodeError__T__E = (function(msg) {
  $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, msg, (((-1) + this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head) | 0), null);
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype.read__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonValueCodec__T__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__O = (function(codec, s, config) {
  var currBuf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
  try {
    this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf = $f_T__getBytes__Ljava_nio_charset_Charset__AB(s, $m_Ljava_nio_charset_UTF\uff3f8$());
    this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_config = config;
    this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = 0;
    var to = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u.length;
    this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail = to;
    this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_totalRead = $L0;
    this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark = (-1);
    var x = codec.decodeValue__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__O__O(this, codec.nullValue__O());
    if (((this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head !== to) && config.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_checkForEndOfInput)) {
      this.endOfInputOrError__V();
    }
    return x;
  } finally {
    this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf = currBuf;
    if ((this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_charBuf.u.length > config.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredCharBufSize)) {
      $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__reallocateCharBufToPreferredSize__V(this);
    }
  }
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype.endOfInputOrError__V = (function() {
  if (this.skipWhitespaces__Z()) {
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "expected end of input", this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head, null);
  }
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype.skipWhitespaces__Z = (function() {
  var pos = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
  var buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
  while (true) {
    if ((pos < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
      var $x_2 = true;
    } else {
      pos = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I(this, pos);
      buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
      var $x_2 = (pos < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail);
    }
    if ($x_2) {
      var b = buf.u[pos];
      var $x_1 = (((b === 32) || (b === 10)) || ((4 | b) === 13));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      pos = ((1 + pos) | 0);
    } else {
      break;
    }
  }
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = pos;
  return (pos !== this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail);
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype.readInt__Z__I = (function(isToken) {
  if (isToken) {
    var b = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__nextToken__I__B(this, this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head);
  } else {
    var pos = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
    var b;
    var pos$tailLocal1 = pos;
    while (true) {
      if ((pos$tailLocal1 >= this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        pos$tailLocal1 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I(this, pos$tailLocal1);
        continue;
      }
      this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = ((1 + pos$tailLocal1) | 0);
      var b = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u[pos$tailLocal1];
      break;
    }
  }
  var s = (-1);
  if ((b === 45)) {
    var pos$1 = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
    var pos$tailLocal1$1 = pos$1;
    while (true) {
      if ((pos$tailLocal1$1 >= this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        pos$tailLocal1$1 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I(this, pos$tailLocal1$1);
        continue;
      }
      this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = ((1 + pos$tailLocal1$1) | 0);
      b = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u[pos$tailLocal1$1];
      break;
    }
    s = 0;
  }
  if (((b < 48) || (b > 57))) {
    var pos$2 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__numberError$default$1__I(this);
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "illegal number", pos$2, null);
  }
  var x = ((48 - b) | 0);
  if ((isToken && (x === 0))) {
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__ensureNotLeadingZero__V(this);
  } else {
    var pos$3 = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
    var buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
    while (true) {
      if ((pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        var $x_3 = true;
      } else {
        pos$3 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I(this, pos$3);
        buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
        var $x_3 = (pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail);
      }
      if ($x_3) {
        b = buf.u[pos$3];
        var $x_2 = ((b >= 48) && (b <= 57));
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        if ((x < (-214748364))) {
          var $x_1 = true;
        } else {
          x = ((Math.imul(10, x) + ((48 - b) | 0)) | 0);
          var $x_1 = (x > 0);
        }
        if ($x_1) {
          var pos$4 = pos$3;
          $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "value is too large for int", pos$4, null);
        }
        pos$3 = ((1 + pos$3) | 0);
      } else {
        break;
      }
    }
    this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = pos$3;
    x = (((x ^ s) - s) | 0);
    if (((s & x) === (-2147483648))) {
      var pos$5 = (((-1) + pos$3) | 0);
      $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "value is too large for int", pos$5, null);
    }
    if ((((32 | b) === 101) || (b === 46))) {
      var pos$6 = pos$3;
      $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "illegal number", pos$6, null);
    }
  }
  return x;
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype.readLong__Z__J = (function(isToken) {
  if (isToken) {
    var b = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__nextToken__I__B(this, this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head);
  } else {
    var pos = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
    var b;
    var pos$tailLocal1 = pos;
    while (true) {
      if ((pos$tailLocal1 >= this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        pos$tailLocal1 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I(this, pos$tailLocal1);
        continue;
      }
      this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = ((1 + pos$tailLocal1) | 0);
      var b = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u[pos$tailLocal1];
      break;
    }
  }
  var isPos = true;
  if ((b === 45)) {
    var pos$1 = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
    var pos$tailLocal1$1 = pos$1;
    while (true) {
      if ((pos$tailLocal1$1 >= this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        pos$tailLocal1$1 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I(this, pos$tailLocal1$1);
        continue;
      }
      this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = ((1 + pos$tailLocal1$1) | 0);
      b = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u[pos$tailLocal1$1];
      break;
    }
    isPos = false;
  }
  if (((b < 48) || (b > 57))) {
    var pos$2 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__numberError$default$1__I(this);
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "illegal number", pos$2, null);
  }
  var x1 = ((48 - b) | 0);
  if ((isToken && (x1 === 0))) {
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__ensureNotLeadingZero__V(this);
    return $L0;
  } else {
    var pos$3 = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
    var buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
    while (true) {
      if ((x1 > (-214748364))) {
        if ((pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
          var $x_2 = true;
        } else {
          pos$3 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I(this, pos$3);
          buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
          var $x_2 = (pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail);
        }
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        b = buf.u[pos$3];
        var $x_1 = ((b >= 48) && (b <= 57));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        x1 = ((Math.imul(10, x1) + ((48 - b) | 0)) | 0);
        pos$3 = ((1 + pos$3) | 0);
      } else {
        break;
      }
    }
    var value = x1;
    var hi = (value >> 31);
    var x__lo = value;
    var x__hi = hi;
    while (true) {
      if ((pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        var $x_6 = true;
      } else {
        pos$3 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I(this, pos$3);
        buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
        var $x_6 = (pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail);
      }
      if ($x_6) {
        b = buf.u[pos$3];
        var $x_5 = ((b >= 48) && (b <= 57));
      } else {
        var $x_5 = false;
      }
      if ($x_5) {
        var a__lo = x__lo;
        var a__hi = x__hi;
        var ahi = a__hi;
        if (((ahi === (-214748365)) ? ((a__lo >>> 0) < 858993460) : (ahi < (-214748365)))) {
          var $x_3 = true;
        } else {
          var a$1__lo = x__lo;
          var a$1__hi = x__hi;
          var lo = a$1__lo;
          var lo$1 = (lo << 3);
          var hi$1 = (((lo >>> 29) | 0) | (a$1__hi << 3));
          var a$2__lo = x__lo;
          var a$2__hi = x__hi;
          var lo$2 = a$2__lo;
          var lo$3 = (lo$2 << 1);
          var hi$2 = (((lo$2 >>> 31) | 0) | (a$2__hi << 1));
          var lo$4 = ((lo$1 + lo$3) | 0);
          var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo$1 & lo$3) | ((lo$1 | lo$3) & (~lo$4))) >>> 31) | 0)) | 0);
          var value$1 = ((48 - b) | 0);
          var hi$4 = (value$1 >> 31);
          var lo$5 = ((lo$4 + value$1) | 0);
          var hi$5 = ((((hi$3 + hi$4) | 0) + ((((lo$4 & value$1) | ((lo$4 | value$1) & (~lo$5))) >>> 31) | 0)) | 0);
          var $x_4__lo = lo$5;
          var $x_4__hi = hi$5;
          x__lo = $x_4__lo;
          x__hi = $x_4__hi;
          var a$3__lo = x__lo;
          var a$3__hi = x__hi;
          var ahi$1 = a$3__hi;
          var $x_3 = ((ahi$1 === 0) ? (a$3__lo !== 0) : (ahi$1 > 0));
        }
        if ($x_3) {
          var pos$4 = pos$3;
          $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "value is too large for long", pos$4, null);
        }
        pos$3 = ((1 + pos$3) | 0);
      } else {
        break;
      }
    }
    this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = pos$3;
    if (isPos) {
      var a$4__lo = x__lo;
      var a$4__hi = x__hi;
      if (((a$4__lo === 0) && (a$4__hi === (-2147483648)))) {
        var pos$5 = (((-1) + pos$3) | 0);
        $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "value is too large for long", pos$5, null);
      }
      var b$1__lo = x__lo;
      var b$1__hi = x__hi;
      var blo = b$1__lo;
      var lo$6 = ((-blo) | 0);
      var hi$6 = ((((-b$1__hi) | 0) + ((blo | lo$6) >> 31)) | 0);
      var $x_7__lo = lo$6;
      var $x_7__hi = hi$6;
      x__lo = $x_7__lo;
      x__hi = $x_7__hi;
    }
    if ((((32 | b) === 101) || (b === 46))) {
      var pos$6 = pos$3;
      $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "illegal number", pos$6, null);
    }
    return new $c_RTLong(x__lo, x__hi);
  }
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader.prototype.readDouble__Z__D = (function(isToken) {
  if (isToken) {
    var b = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__nextToken__I__B(this, this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head);
  } else {
    var pos = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
    var b;
    var pos$tailLocal1 = pos;
    while (true) {
      if ((pos$tailLocal1 >= this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        pos$tailLocal1 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I(this, pos$tailLocal1);
        continue;
      }
      this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = ((1 + pos$tailLocal1) | 0);
      var b = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u[pos$tailLocal1];
      break;
    }
  }
  var isNeg = false;
  if ((b === 45)) {
    var pos$1 = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
    var pos$tailLocal1$1 = pos$1;
    while (true) {
      if ((pos$tailLocal1$1 >= this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        pos$tailLocal1$1 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I(this, pos$tailLocal1$1);
        continue;
      }
      this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = ((1 + pos$tailLocal1$1) | 0);
      b = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u[pos$tailLocal1$1];
      break;
    }
    isNeg = true;
  }
  if (((b < 48) || (b > 57))) {
    var pos$2 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__numberError$default$1__I(this);
    $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "illegal number", pos$2, null);
  }
  var pos$3 = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
  var buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
  var from = (((-1) + pos$3) | 0);
  var oldMark = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark;
  var newMark = ((oldMark < 0) ? from : oldMark);
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark = newMark;
  var value = (((-48) + b) | 0);
  var hi = (value >> 31);
  var m10__lo = value;
  var m10__hi = hi;
  var e10 = 0;
  var digits = 1;
  if ((isToken && (b === 48))) {
    if ((pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
      var $x_2 = true;
    } else {
      pos$3 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I(this, pos$3);
      buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
      var $x_2 = (pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail);
    }
    if ($x_2) {
      b = buf.u[pos$3];
      var $x_1 = ((b >= 48) && (b <= 57));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var pos$4 = (((-1) + pos$3) | 0);
      $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "illegal number with leading zero", pos$4, null);
    }
  } else {
    while (true) {
      if ((pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        var $x_5 = true;
      } else {
        pos$3 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I(this, pos$3);
        buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
        var $x_5 = (pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail);
      }
      if ($x_5) {
        b = buf.u[pos$3];
        var $x_4 = ((b >= 48) && (b <= 57));
      } else {
        var $x_4 = false;
      }
      if ($x_4) {
        var a__lo = m10__lo;
        var a__hi = m10__hi;
        var ahi = a__hi;
        if (((ahi === 214748364) ? ((a__lo >>> 0) < 3435973836) : (ahi < 214748364))) {
          var a$1__lo = m10__lo;
          var a$1__hi = m10__hi;
          var lo = a$1__lo;
          var lo$1 = (lo << 3);
          var hi$1 = (((lo >>> 29) | 0) | (a$1__hi << 3));
          var a$2__lo = m10__lo;
          var a$2__hi = m10__hi;
          var lo$2 = a$2__lo;
          var lo$3 = (lo$2 << 1);
          var hi$2 = (((lo$2 >>> 31) | 0) | (a$2__hi << 1));
          var lo$4 = ((lo$1 + lo$3) | 0);
          var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo$1 & lo$3) | ((lo$1 | lo$3) & (~lo$4))) >>> 31) | 0)) | 0);
          var value$1 = (((-48) + b) | 0);
          var hi$4 = (value$1 >> 31);
          var lo$5 = ((lo$4 + value$1) | 0);
          var hi$5 = ((((hi$3 + hi$4) | 0) + ((((lo$4 & value$1) | ((lo$4 | value$1) & (~lo$5))) >>> 31) | 0)) | 0);
          var $x_3__lo = lo$5;
          var $x_3__hi = hi$5;
          m10__lo = $x_3__lo;
          m10__hi = $x_3__hi;
          digits = ((1 + digits) | 0);
        } else {
          e10 = ((1 + e10) | 0);
        }
        pos$3 = ((1 + pos$3) | 0);
      } else {
        break;
      }
    }
  }
  if ((b === 46)) {
    pos$3 = ((1 + pos$3) | 0);
    e10 = ((e10 + digits) | 0);
    var noFracDigits = true;
    while (true) {
      if ((pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        var $x_8 = true;
      } else {
        pos$3 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I(this, pos$3);
        buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
        var $x_8 = (pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail);
      }
      if ($x_8) {
        b = buf.u[pos$3];
        var $x_7 = ((b >= 48) && (b <= 57));
      } else {
        var $x_7 = false;
      }
      if ($x_7) {
        var a$3__lo = m10__lo;
        var a$3__hi = m10__hi;
        var ahi$1 = a$3__hi;
        if (((ahi$1 === 214748364) ? ((a$3__lo >>> 0) < 3435973836) : (ahi$1 < 214748364))) {
          var a$4__lo = m10__lo;
          var a$4__hi = m10__hi;
          var lo$6 = a$4__lo;
          var lo$7 = (lo$6 << 3);
          var hi$6 = (((lo$6 >>> 29) | 0) | (a$4__hi << 3));
          var a$5__lo = m10__lo;
          var a$5__hi = m10__hi;
          var lo$8 = a$5__lo;
          var lo$9 = (lo$8 << 1);
          var hi$7 = (((lo$8 >>> 31) | 0) | (a$5__hi << 1));
          var lo$10 = ((lo$7 + lo$9) | 0);
          var hi$8 = ((((hi$6 + hi$7) | 0) + ((((lo$7 & lo$9) | ((lo$7 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
          var value$2 = (((-48) + b) | 0);
          var hi$9 = (value$2 >> 31);
          var lo$11 = ((lo$10 + value$2) | 0);
          var hi$10 = ((((hi$8 + hi$9) | 0) + ((((lo$10 & value$2) | ((lo$10 | value$2) & (~lo$11))) >>> 31) | 0)) | 0);
          var $x_6__lo = lo$11;
          var $x_6__hi = hi$10;
          m10__lo = $x_6__lo;
          m10__hi = $x_6__hi;
          digits = ((1 + digits) | 0);
        }
        noFracDigits = false;
        pos$3 = ((1 + pos$3) | 0);
      } else {
        break;
      }
    }
    e10 = ((e10 - digits) | 0);
    if (noFracDigits) {
      var pos$5 = pos$3;
      $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "illegal number", pos$5, null);
    }
  }
  if (((32 | b) === 101)) {
    var pos$6 = ((1 + pos$3) | 0);
    var pos$tailLocal1$2 = pos$6;
    while (true) {
      if ((pos$tailLocal1$2 >= this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        pos$tailLocal1$2 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I(this, pos$tailLocal1$2);
        continue;
      }
      this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = ((1 + pos$tailLocal1$2) | 0);
      b = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u[pos$tailLocal1$2];
      break;
    }
    var sb = b;
    if (((b === 45) || (b === 43))) {
      var pos$7 = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
      var pos$tailLocal1$3 = pos$7;
      while (true) {
        if ((pos$tailLocal1$3 >= this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
          pos$tailLocal1$3 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMoreOrError__I__I(this, pos$tailLocal1$3);
          continue;
        }
        this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = ((1 + pos$tailLocal1$3) | 0);
        b = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf.u[pos$tailLocal1$3];
        break;
      }
    }
    if (((b < 48) || (b > 57))) {
      var pos$8 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__numberError$default$1__I(this);
      $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__decodeError__T__I__jl_Throwable__E(this, "illegal number", pos$8, null);
    }
    var exp = (((-48) + b) | 0);
    pos$3 = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head;
    buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
    while (true) {
      if ((pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail)) {
        var $x_10 = true;
      } else {
        pos$3 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__loadMore__I__I(this, pos$3);
        buf = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_buf;
        var $x_10 = (pos$3 < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_tail);
      }
      if ($x_10) {
        b = buf.u[pos$3];
        var $x_9 = ((b >= 48) && (b <= 57));
      } else {
        var $x_9 = false;
      }
      if ($x_9) {
        if ((exp < 214748364)) {
          exp = ((Math.imul(10, exp) + (((-48) + b) | 0)) | 0);
        }
        pos$3 = ((1 + pos$3) | 0);
      } else {
        break;
      }
    }
    if ((sb === 45)) {
      exp = ((-exp) | 0);
    }
    e10 = ((e10 + exp) | 0);
  }
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_head = pos$3;
  if ((e10 === 0)) {
    var a$6__lo = m10__lo;
    var a$6__hi = m10__hi;
    var ahi$2 = a$6__hi;
    var $x_11 = ((ahi$2 === 214748364) ? ((a$6__lo >>> 0) < 3435973836) : (ahi$2 < 214748364));
  } else {
    var $x_11 = false;
  }
  if ($x_11) {
    var a$7__lo = m10__lo;
    var a$7__hi = m10__hi;
    var lo$12 = a$7__lo;
    var hi$11 = a$7__hi;
    var x$1 = ((4.294967296E9 * hi$11) + (lo$12 >>> 0.0));
  } else {
    var a$8__lo = m10__lo;
    var a$8__hi = m10__hi;
    var ahi$3 = a$8__hi;
    if ((((ahi$3 < 1048576) && (e10 >= (-22))) && (e10 <= ((38 - digits) | 0)))) {
      var pow10 = $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$pow10Doubles;
      if ((e10 < 0)) {
        var a$9__lo = m10__lo;
        var a$9__hi = m10__hi;
        var lo$13 = a$9__lo;
        var hi$12 = a$9__hi;
        var x$1 = (((4.294967296E9 * hi$12) + (lo$13 >>> 0.0)) / pow10.u[((-e10) | 0)]);
      } else if ((e10 <= 22)) {
        var a$10__lo = m10__lo;
        var a$10__hi = m10__hi;
        var lo$14 = a$10__lo;
        var hi$13 = a$10__hi;
        var x$1 = (((4.294967296E9 * hi$13) + (lo$14 >>> 0.0)) * pow10.u[e10]);
      } else {
        var slop = ((16 - digits) | 0);
        var a$11__lo = m10__lo;
        var a$11__hi = m10__hi;
        var lo$15 = a$11__lo;
        var hi$14 = a$11__hi;
        var x$1 = ((((4.294967296E9 * hi$14) + (lo$15 >>> 0.0)) * pow10.u[slop]) * pow10.u[((e10 - slop) | 0)]);
      }
    } else {
      var m10$1__lo = m10__lo;
      var m10$1__hi = m10__hi;
      var e10$1 = e10;
      var pos$9 = pos$3;
      if ((((m10$1__lo === 0) && (m10$1__hi === 0)) || (e10$1 < (-343)))) {
        var x$1 = 0.0;
      } else if ((e10$1 >= 310)) {
        var x$1 = Infinity;
      } else {
        var hi$15 = m10$1__hi;
        if ((hi$15 !== 0)) {
          var shift = Math.clz32(hi$15);
        } else {
          var i = m10$1__lo;
          var shift = ((32 + Math.clz32(i)) | 0);
        }
        var t = $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$pow10Mantissas.u[((343 + e10$1) | 0)];
        var lo$18 = t.RTLong__f_lo;
        var hi$17 = t.RTLong__f_hi;
        var n = shift;
        var lo$16 = m10$1__lo;
        var lo$17 = (((32 & n) === 0) ? (lo$16 << n) : 0);
        var hi$16 = (((32 & n) === 0) ? (((((lo$16 >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (m10$1__hi << n)) : (lo$16 << n));
        var a0 = (65535 & hi$17);
        var a1 = ((hi$17 >>> 16) | 0);
        var b0 = (65535 & lo$17);
        var b1 = ((lo$17 >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo$19 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$18 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var a0$1 = (65535 & lo$18);
        var a1$1 = ((lo$18 >>> 16) | 0);
        var b0$1 = (65535 & lo$17);
        var b1$1 = ((lo$17 >>> 16) | 0);
        var a0b0$1 = Math.imul(a0$1, b0$1);
        var a1b0$1 = Math.imul(a1$1, b0$1);
        var a0b1$1 = Math.imul(a0$1, b1$1);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$19 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$21 = ((lo$19 + hi$19) | 0);
        var hi$20 = ((hi$18 + ((((lo$19 & hi$19) | ((lo$19 | hi$19) & (~lo$21))) >>> 31) | 0)) | 0);
        var a0$2 = (65535 & hi$17);
        var a1$2 = ((hi$17 >>> 16) | 0);
        var b0$2 = (65535 & hi$16);
        var b1$2 = ((hi$16 >>> 16) | 0);
        var a0b0$2 = Math.imul(a0$2, b0$2);
        var a1b0$2 = Math.imul(a1$2, b0$2);
        var a0b1$2 = Math.imul(a0$2, b1$2);
        var lo$22 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
        var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
        var hi$21 = ((((Math.imul(a1$2, b1$2) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
        var lo$23 = ((lo$22 + hi$20) | 0);
        var hi$22 = ((hi$21 + ((((lo$22 & hi$20) | ((lo$22 | hi$20) & (~lo$23))) >>> 31) | 0)) | 0);
        var a0$3 = (65535 & lo$18);
        var a1$3 = ((lo$18 >>> 16) | 0);
        var b0$3 = (65535 & hi$16);
        var b1$3 = ((hi$16 >>> 16) | 0);
        var a0b0$3 = Math.imul(a0$3, b0$3);
        var a1b0$3 = Math.imul(a1$3, b0$3);
        var a0b1$3 = Math.imul(a0$3, b1$3);
        var lo$24 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
        var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
        var hi$23 = ((((Math.imul(a1$3, b1$3) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
        var lo$25 = ((lo$24 + lo$21) | 0);
        var hi$24 = ((hi$23 + ((((lo$24 & lo$21) | ((lo$24 | lo$21) & (~lo$25))) >>> 31) | 0)) | 0);
        var lo$26 = ((lo$23 + hi$24) | 0);
        var hi$25 = ((hi$22 + ((((lo$23 & hi$24) | ((lo$23 | hi$24) & (~lo$26))) >>> 31) | 0)) | 0);
        var m2__lo = lo$26;
        var m2__hi = hi$25;
        var e2 = ((1 + (((Math.imul(108853, e10$1) >> 15) - shift) | 0)) | 0);
        var l__lo = m2__lo;
        var l__hi = m2__hi;
        var hi$26 = l__hi;
        if ((hi$26 !== 0)) {
          shift = Math.clz32(hi$26);
        } else {
          var i$1 = l__lo;
          shift = ((32 + Math.clz32(i$1)) | 0);
        }
        var a$12__lo = m2__lo;
        var a$12__hi = m2__hi;
        var n$1 = shift;
        var lo$27 = a$12__lo;
        var lo$28 = (((32 & n$1) === 0) ? (lo$27 << n$1) : 0);
        var hi$27 = (((32 & n$1) === 0) ? (((((lo$27 >>> 1) | 0) >>> ((31 - n$1) | 0)) | 0) | (a$12__hi << n$1)) : (lo$27 << n$1));
        var $x_12__lo = lo$28;
        var $x_12__hi = hi$27;
        m2__lo = $x_12__lo;
        m2__hi = $x_12__hi;
        e2 = ((e2 - shift) | 0);
        var ahi$4 = m10$1__hi;
        var roundingError = ((((ahi$4 === 214748364) ? ((m10$1__lo >>> 0) < 3435973836) : (ahi$4 < 214748364)) ? 1 : 19) << shift);
        var a$13 = (((-1074) - e2) | 0);
        var truncatedBitNum = ((a$13 > 11) ? a$13 : 11);
        var savedBitNum = ((64 - truncatedBitNum) | 0);
        var n$2 = ((savedBitNum > 0) ? savedBitNum : 0);
        var lo$29 = (((32 & n$2) === 0) ? ((((-1) >>> n$2) | 0) | ((-2) << ((31 - n$2) | 0))) : (((-1) >>> n$2) | 0));
        var hi$28 = (((32 & n$2) === 0) ? (((-1) >>> n$2) | 0) : 0);
        var a$14__lo = m2__lo;
        var a$14__hi = m2__hi;
        var lo$30 = (a$14__lo & lo$29);
        var hi$29 = (a$14__hi & hi$28);
        var lo$31 = (((lo$29 >>> 1) | 0) | (hi$28 << 31));
        var hi$30 = ((hi$28 >>> 1) | 0);
        var lo$32 = ((lo$30 - lo$31) | 0);
        var hi$31 = ((((hi$29 - hi$30) | 0) + ((((~lo$30) & lo$31) | ((~(lo$30 ^ lo$31)) & lo$32)) >> 31)) | 0);
        var sign = (hi$31 >> 31);
        var xlo = (lo$32 ^ sign);
        var rlo = ((xlo - sign) | 0);
        var rhi = (((hi$31 ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
        var hi$32 = (roundingError >> 31);
        if ((((rhi === hi$32) ? ((rlo >>> 0) > (roundingError >>> 0)) : (rhi > hi$32)) || (savedBitNum <= 0))) {
          if ((savedBitNum <= 0)) {
            var $x_13__lo = 0;
            var $x_13__hi = 0;
            m2__lo = $x_13__lo;
            m2__hi = $x_13__hi;
          }
          var a$15__lo = m2__lo;
          var a$15__hi = m2__hi;
          var hi$33 = a$15__hi;
          var lo$33 = (((32 & truncatedBitNum) === 0) ? (((a$15__lo >>> truncatedBitNum) | 0) | ((hi$33 << 1) << ((31 - truncatedBitNum) | 0))) : ((hi$33 >>> truncatedBitNum) | 0));
          var hi$34 = (((32 & truncatedBitNum) === 0) ? ((hi$33 >>> truncatedBitNum) | 0) : 0);
          var $x_14__lo = lo$33;
          var $x_14__hi = hi$34;
          m2__lo = $x_14__lo;
          m2__hi = $x_14__hi;
          e2 = ((e2 + truncatedBitNum) | 0);
          if (((savedBitNum >= 0) && ((hi$31 === 0) ? (lo$32 !== 0) : (hi$31 > 0)))) {
            var a$16__lo = m2__lo;
            var a$16__hi = m2__hi;
            if (((a$16__lo === (-1)) && (a$16__hi === 2097151))) {
              var $x_15__lo = 0;
              var $x_15__hi = 1048576;
              m2__lo = $x_15__lo;
              m2__hi = $x_15__hi;
              e2 = ((1 + e2) | 0);
            } else {
              var b$1__lo = m2__lo;
              var b$1__hi = m2__hi;
              var blo = b$1__lo;
              var lo$34 = ((1 + blo) | 0);
              var hi$35 = ((b$1__hi + (((blo & (~lo$34)) >>> 31) | 0)) | 0);
              var $x_16__lo = lo$34;
              var $x_16__hi = hi$35;
              m2__lo = $x_16__lo;
              m2__hi = $x_16__hi;
            }
          }
          if ((e2 === (-1074))) {
            var t$1 = new $c_RTLong(m2__lo, m2__hi);
          } else if ((e2 >= 972)) {
            var t$1 = new $c_RTLong(0, 2146435072);
          } else {
            var value$3 = ((1075 + e2) | 0);
            var hi$37 = (value$3 << 20);
            var b$2__lo = m2__lo;
            var b$2__hi = m2__hi;
            var lo$35 = b$2__lo;
            var hi$38 = (1048575 & b$2__hi);
            var hi$39 = (hi$37 | hi$38);
            var x__lo = lo$35;
            var x__hi = hi$39;
            var t$1 = new $c_RTLong(x__lo, x__hi);
          }
          var lo$36 = t$1.RTLong__f_lo;
          var hi$40 = t$1.RTLong__f_hi;
          var fpBitsDataView = $fpBitsDataView;
          fpBitsDataView.setInt32(0, lo$36, true);
          fpBitsDataView.setInt32(4, hi$40, true);
          var x$1 = (+fpBitsDataView.getFloat64(0, true));
        } else {
          var x$1 = $p_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__toDouble__I__I__I__D(this, from, newMark, pos$9);
        }
      }
    }
  }
  if (isNeg) {
    x$1 = (-x$1);
  }
  if ((this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark > oldMark)) {
    this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__f_mark = oldMark;
  }
  return x$1;
});
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader, "com.github.plokhotnyuk.jsoniter_scala.core.JsonReader", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$() {
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$pow10Doubles = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$pow10Mantissas = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$zoneOffsets = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$zoneIds = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$hexDigits = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$dumpBorder = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$dumpHeader = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_bigDecimalMathContext = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_bigDecimalDigitsLimit = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_bigDecimalScaleLimit = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_bigIntDigitsLimit = 0;
  $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$ = this;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$pow10Doubles = new $ac_D(new Float64Array([1.0, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, 1.0E7, 1.0E8, 1.0E9, 1.0E10, 1.0E11, 1.0E12, 1.0E13, 1.0E14, 1.0E15, 1.0E16, 1.0E17, 1.0E18, 1.0E19, 1.0E20, 1.0E21, 1.0E22]));
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$pow10Mantissas = new $ac_J([new $c_RTLong((-1473257810), (-1087775573)), new $c_RTLong((-1841572262), (-285977642)), new $c_RTLong(459630072, (-1789348762)), new $c_RTLong((-1572946058), (-1162944129)), new $c_RTLong((-1966182573), (-379938337)), new $c_RTLong((-1228864108), (-1848074197)), new $c_RTLong((-1536080135), (-1236350922)), new $c_RTLong(1301125303, (-471696828)), new $c_RTLong((-1334280334), (-1905423254)), new $c_RTLong(1553375055, (-1308037243)), new $c_RTLong((-1279506653), (-561304730)), new $c_RTLong(810921078, (-1961428192)), new $c_RTLong(1013651347, (-1378043416)), new $c_RTLong(1267064184, (-648812446)), new $c_RTLong(1865656939, (-2016120515)), new $c_RTLong((-889154298), (-1446408820)), new $c_RTLong((-37701048), (-734269201)), new $c_RTLong((-23563155), (-2069530987)), new $c_RTLong(2118029704, (-1513171909)), new $c_RTLong(1573795306, (-817723062)), new $c_RTLong(2057363890, (-2121689650)), new $c_RTLong(424221215, (-1578370238)), new $c_RTLong((-1617207130), (-899220974)), new $c_RTLong(1199716560, (-50284393)), new $c_RTLong((-1934531710), (-1642040482)), new $c_RTLong(803060834, (-978808778)), new $c_RTLong((-1143657605), (-149769149)), new $c_RTLong(1432697645, (-1704218454)), new $c_RTLong((-356611592), (-1056531244)), new $c_RTLong(627977334, (-246922230)), new $c_RTLong(1466227658, (-1764939130)), new $c_RTLong((-314699076), (-1132432089)), new $c_RTLong((-393373845), (-341798287)), new $c_RTLong(827883171, (-1824236665)), new $c_RTLong((-38887860), (-1206554008)), new $c_RTLong(1025131999, (-434450685)), new $c_RTLong(103836587, (-1882144414)), new $c_RTLong((-2017687914), (-1278938694)), new $c_RTLong(699115580, (-524931543)), new $c_RTLong((-1173665499), (-1938694951)), new $c_RTLong(680401775, (-1349626864)), new $c_RTLong(850502218, (-613291756)), new $c_RTLong((-1615919762), (-1993920084)), new $c_RTLong((-946157878), (-1418658281)), new $c_RTLong((-1182697347), (-699581027)), new $c_RTLong((-1812927666), (-2047850878)), new $c_RTLong(955065889, (-1486071773)), new $c_RTLong(120090538, (-783847892)), new $c_RTLong((-2072427062), (-2100517669)), new $c_RTLong(1704433468, (-1551905262)), new $c_RTLong((-16941812), (-866139754)), new $c_RTLong((-1094919089), (-8932868)), new $c_RTLong((-147453519), (-1616195779)), new $c_RTLong(1963166749, (-946502899)), new $c_RTLong((-767267035), (-109386800)), new $c_RTLong((-2090154633), (-1678979486)), new $c_RTLong(608532181, (-1024982533)), new $c_RTLong((-313076598), (-207486343)), new $c_RTLong(878068950, (-1740291700)), new $c_RTLong(1097586188, (-1101622801)), new $c_RTLong(298240911, (-303286677)), new $c_RTLong((-350470343), (-1800166910)), new $c_RTLong((-1511829753), (-1176466813)), new $c_RTLong((-1889787191), (-396841692)), new $c_RTLong((-644246082), (-1858638794)), new $c_RTLong((-1879049427), (-1249556668)), new $c_RTLong((-1275069959), (-488204011)), new $c_RTLong((-1870660549), (-1915740243)), new $c_RTLong((-190842038), (-1320933480)), new $c_RTLong(835189277, (-577425025)), new $c_RTLong(2132606034, (-1971503377)), new $c_RTLong(1592015718, (-1390637397)), new $c_RTLong(916277824, (-664554922)), new $c_RTLong((-501068184), (-2025959563)), new $c_RTLong(1521148418, (-1458707629)), new $c_RTLong(827693699, (-749642712)), new $c_RTLong(517308561, (-2079139431)), new $c_RTLong(1720377526, (-1525182465)), new $c_RTLong(1076730083, (-832736257)), new $c_RTLong((-2011398258), (-2131072897)), new $c_RTLong(1780719474, (-1590099297)), new $c_RTLong(1152157518, (-913882297)), new $c_RTLong(366455074, (-68611047)), new $c_RTLong((-1381578315), (-1653494641)), new $c_RTLong((-1726972894), (-993126477)), new $c_RTLong(2136251179, (-167666272)), new $c_RTLong(1335156987, (-1715404156)), new $c_RTLong(1668946233, (-1070513371)), new $c_RTLong((-1135042680), (-264399890)), new $c_RTLong(901211061, (-1775862667)), new $c_RTLong((-2094711646), (-1146086510)), new $c_RTLong(602835915, (-358866313)), new $c_RTLong(1987385183, (-1834904182)), new $c_RTLong(336747830, (-1219888403)), new $c_RTLong(1494676612, (-451118680)), new $c_RTLong(934172882, (-1892561911)), new $c_RTLong((-2053509369), (-1291960565)), new $c_RTLong(1728080585, (-541208882)), new $c_RTLong(6308541, (-1948868287)), new $c_RTLong(1081627501, (-1362343535)), new $c_RTLong((-1869191096), (-629187595)), new $c_RTLong(2052981037, (-2003854983)), new $c_RTLong((-654999176), (-1431076905)), new $c_RTLong((-818748970), (-715104307)), new $c_RTLong((-1585459930), (-2057552928)), new $c_RTLong((-908083089), (-1498199336)), new $c_RTLong((-61362037), (-799007346)), new $c_RTLong(1572261463, (-2109992327)), new $c_RTLong((-1255898643), (-1563748585)), new $c_RTLong((-1569873304), (-880943907)), new $c_RTLong(185142018, (-27438059)), new $c_RTLong(652584673, (-1627761523)), new $c_RTLong(1889472666, (-960960080)), new $c_RTLong((-1933126464), (-127458276)), new $c_RTLong((-671333128), (-1690274159)), new $c_RTLong(1308317238, (-1039100874)), new $c_RTLong((-512087100), (-225134269)), new $c_RTLong(1827429210, (-1751321654)), new $c_RTLong(136802865, (-1115410243)), new $c_RTLong(1244745405, (-320520980)), new $c_RTLong((-1369517770), (-1810938349)), new $c_RTLong((-1711897212), (-1189931112)), new $c_RTLong((-1066129691), (-413672066)), new $c_RTLong(944281679, (-1869157777)), new $c_RTLong(106610275, (-1262705397)), new $c_RTLong((-940478981), (-504639923)), new $c_RTLong((-1661541187), (-1926012688)), new $c_RTLong((-1003184660), (-1333774036)), new $c_RTLong((-180239001), (-593475721)), new $c_RTLong((-112649376), (-1981535062)), new $c_RTLong((-1214553543), (-1403177003)), new $c_RTLong(629291719, (-680229429)), new $c_RTLong((-143563588), (-2035756130)), new $c_RTLong((-1253196309), (-1470953338)), new $c_RTLong(1654730086, (-764949848)), new $c_RTLong(1034206304, (-2088706391)), new $c_RTLong((-1928467592), (-1537141165)), new $c_RTLong(1884382806, (-847684632)), new $c_RTLong(1177739254, (-2140415631)), new $c_RTLong((-1749051405), (-1601777715)), new $c_RTLong((-38830608), (-928480320)), new $c_RTLong(1025203564, (-86858575)), new $c_RTLong((-969860509), (-1664899346)), new $c_RTLong(2008899836, (-1007382358)), new $c_RTLong(363641147, (-185486123)), new $c_RTLong(764146629, (-1726541563)), new $c_RTLong(2028925110, (-1084435130)), new $c_RTLong(388672740, (-281802088)), new $c_RTLong(242920462, (-1786739041)), new $c_RTLong((-770091246), (-1159681978)), new $c_RTLong((-2036355881), (-375860648)), new $c_RTLong(1411632134, (-1845525641)), new $c_RTLong(690798344, (-1233165227)), new $c_RTLong(1937239754, (-467714710)), new $c_RTLong((-2010450626), (-1902934430)), new $c_RTLong(708162189, (-1304926213)), new $c_RTLong((-188539087), (-557415943)), new $c_RTLong(955904894, (-1958997700)), new $c_RTLong(1194881118, (-1375005301)), new $c_RTLong(419859574, (-645014802)), new $c_RTLong((-811329591), (-2013746988)), new $c_RTLong(59579836, (-1443441910)), new $c_RTLong((-2073008853), (-730560564)), new $c_RTLong((-758759621), (-2067213089)), new $c_RTLong((-948449527), (-1510274537)), new $c_RTLong((-1185561908), (-814101347)), new $c_RTLong((-1814718017), (-2119426078)), new $c_RTLong(952827951, (-1575540773)), new $c_RTLong(117293115, (-895684142)), new $c_RTLong((-2000867254), (-45863354)), new $c_RTLong(360070702, (-1639277332)), new $c_RTLong(450088378, (-975354841)), new $c_RTLong((-511131352), (-145451728)), new $c_RTLong((-1930069831), (-1701520066)), new $c_RTLong(808638183, (-1053158258)), new $c_RTLong((-1136685919), (-242705999)), new $c_RTLong(363313125, (-1762303985)), new $c_RTLong((-619600418), (-1129138158)), new $c_RTLong((-1848242346), (-337680873)), new $c_RTLong((-1155151467), (-1821663282)), new $c_RTLong(1777286139, (-1203337278)), new $c_RTLong(74124026, (-430429773)), new $c_RTLong((-490543396), (-1879631345)), new $c_RTLong((-613179245), (-1275797357)), new $c_RTLong((-766474056), (-521004872)), new $c_RTLong((-2089659021), (-1936240781)), new $c_RTLong(1682893519, (-1346559152)), new $c_RTLong(2103616899, (-609457116)), new $c_RTLong((-832723086), (-1991523434)), new $c_RTLong((-2114645681), (-1415662468)), new $c_RTLong((-1569565278), (-695836261)), new $c_RTLong(1166505349, (-2045510399)), new $c_RTLong((-1763093785), (-1483146175)), new $c_RTLong((-56383584), (-780190895)), new $c_RTLong(1038502084, (-2098232045)), new $c_RTLong(224385781, (-1549048232)), new $c_RTLong(280482227, (-862568466)), new $c_RTLong((-1796880865), (-4468759)), new $c_RTLong((-49308717), (-1613405711)), new $c_RTLong(2085847752, (-943015314)), new $c_RTLong(459826043, (-105027318)), new $c_RTLong(1361133101, (-1676254810)), new $c_RTLong((-446067272), (-1021576689)), new $c_RTLong((-557584090), (-203229037)), new $c_RTLong(1798993591, (-1737630884)), new $c_RTLong((-2046225307), (-1098296781)), new $c_RTLong(1737185663, (-299129152)), new $c_RTLong(1085741039, (-1797568456)), new $c_RTLong(1357176299, (-1173218746)), new $c_RTLong((-451013274), (-392781609)), new $c_RTLong((-281883296), (-1856101242)), new $c_RTLong((-1426095944), (-1246384728)), new $c_RTLong((-708878106), (-484239086)), new $c_RTLong((-979919729), (-1913262165)), new $c_RTLong((-1224899661), (-1317835882)), new $c_RTLong(1690100896, (-573553028)), new $c_RTLong((-1091170588), (-1969083379)), new $c_RTLong(783520413, (-1387612399)), new $c_RTLong(2053142340, (-660773675)), new $c_RTLong(1820084875, (-2023596283)), new $c_RTLong((-946119379), (-1455753530)), new $c_RTLong(2038576249, (-745950088)), new $c_RTLong(1274110155, (-2076831541)), new $c_RTLong(518895870, (-1522297602)), new $c_RTLong((-1498863810), (-829130179)), new $c_RTLong((-2010531705), (-2128819098)), new $c_RTLong(708060840, (-1587282048)), new $c_RTLong(885076050, (-910360736)), new $c_RTLong(1106345063, (-64209096)), new $c_RTLong(691465664, (-1650743421)), new $c_RTLong((-209409743), (-989687453)), new $c_RTLong((-261762179), (-163367492)), new $c_RTLong(373269550, (-1712717418)), new $c_RTLong((-1680896711), (-1067154949)), new $c_RTLong((-2101120888), (-260201862)), new $c_RTLong((-1850071467), (-1773238900)), new $c_RTLong((-1238847510), (-1142806801)), new $c_RTLong((-1548559387), (-354766677)), new $c_RTLong(1179634031, (-1832341909)), new $c_RTLong(400800715, (-1216685562)), new $c_RTLong((-1646482755), (-447115129)), new $c_RTLong((-1029051722), (-1890059692)), new $c_RTLong((-212572828), (-1288832791)), new $c_RTLong(1881767613, (-537299164)), new $c_RTLong((-971378890), (-1946424714)), new $c_RTLong(2007001859, (-1359289068)), new $c_RTLong((-1786214972), (-625369511)), new $c_RTLong((-42642533), (-2001468681)), new $c_RTLong((-53303167), (-1428094027)), new $c_RTLong(2080854690, (-711375709)), new $c_RTLong(763663269, (-2055222554)), new $c_RTLong((-1192904562), (-1495286369)), new $c_RTLong((-1491130702), (-795366137)), new $c_RTLong((-931956689), (-2107716572)), new $c_RTLong((-91204037), (-1560903891)), new $c_RTLong(2033478602, (-877388039)), new $c_RTLong((-679377220), (-22993225)), new $c_RTLong((-424610762), (-1624983502)), new $c_RTLong((-1604505277), (-957487553)), new $c_RTLong((-2005631596), (-123117617)), new $c_RTLong((-1253519748), (-1687561247)), new $c_RTLong(580583963, (-1035709734)), new $c_RTLong((-1421753694), (-220895344)), new $c_RTLong(1795758501, (-1748672326)), new $c_RTLong(97214479, (-1112098583)), new $c_RTLong(1195259923, (-316381405)), new $c_RTLong(210166539, (-1808351114)), new $c_RTLong((-1884775474), (-1186697069)), new $c_RTLong(1938997954, (-409629512)), new $c_RTLong(1211873721, (-1866631181)), new $c_RTLong(441100328, (-1259547152)), new $c_RTLong(551375410, (-500692116)), new $c_RTLong((-1802874017), (-1923545309)), new $c_RTLong(2041374775, (-1330689812)), new $c_RTLong((-1743248828), (-589620441)), new $c_RTLong((-1089530517), (-1979125512)), new $c_RTLong((-288171323), (-1400165066)), new $c_RTLong((-1433955977), (-676464508)), new $c_RTLong((-359351574), (-2033403054)), new $c_RTLong((-1522931291), (-1468011993)), new $c_RTLong((-1903664114), (-761273167)), new $c_RTLong((-116048247), (-2086408466)), new $c_RTLong((-1218802133), (-1534268758)), new $c_RTLong(1697722806, (-844094123)), new $c_RTLong(1597947665, (-2138171563)), new $c_RTLong((-1223790890), (-1598972630)), new $c_RTLong(1691486859, (-924973963)), new $c_RTLong((-1106866898), (-82475630)), new $c_RTLong((-1228662723), (-1662160005)), new $c_RTLong((-1535828404), (-1003958182)), new $c_RTLong(1301439967, (-181205903)), new $c_RTLong((-797212757), (-1723866426)), new $c_RTLong((-2070257770), (-1081091208)), new $c_RTLong((-1514080388), (-277622186)), new $c_RTLong(664312493, (-1784126602)), new $c_RTLong((-1317093031), (-1156416429)), new $c_RTLong((-1646366289), (-371778712)), new $c_RTLong(1655375629, (-1842974431)), new $c_RTLong((-1152005935), (-1229976215)), new $c_RTLong(707476229, (-463728444)), new $c_RTLong((-1705311005), (-1900443014)), new $c_RTLong(1089586716, (-1301811943)), new $c_RTLong((-1859242077), (-553523105)), new $c_RTLong((-1162026298), (-1956564677)), new $c_RTLong((-1452532873), (-1371964022)), new $c_RTLong(1405559381, (-641213203)), new $c_RTLong(1415345525, (-2011370988)), new $c_RTLong(1769181906, (-1440471911)), new $c_RTLong((-1009748089), (-726848065)), new $c_RTLong((-631092556), (-2064892777)), new $c_RTLong((-788865695), (-1507374147)), new $c_RTLong(1161401530, (-810475859)), new $c_RTLong(1262746868, (-2117160148)), new $c_RTLong(1578433585, (-1572708361)), new $c_RTLong(899300158, (-892143627)), new $c_RTLong((-2097100275), (-41437710)), new $c_RTLong((-1847558584), (-1636511305)), new $c_RTLong(1985519066, (-971897307)), new $c_RTLong((-739326639), (-141129810)), new $c_RTLong(1148533586, (-1698818867)), new $c_RTLong((-1785558489), (-1049781760)), new $c_RTLong((-1158206287), (-238485376)), new $c_RTLong(1960475630, (-1759666096)), new $c_RTLong((-1844372758), (-1125840796)), new $c_RTLong((-1231724123), (-333559171)), new $c_RTLong((-1843569401), (-1819087218)), new $c_RTLong(916763721, (-1200117198)), new $c_RTLong((-1001528997), (-426404674)), new $c_RTLong(984657113, (-1877115657)), new $c_RTLong(157079567, (-1272652747)), new $c_RTLong(1270091283, (-517074110)), new $c_RTLong(1867548875, (-1933784055)), new $c_RTLong((-886789378), (-1343488245)), new $c_RTLong((-1108486722), (-605618482)), new $c_RTLong(917808535, (-1989124287)), new $c_RTLong((-2073964804), (-1412663535)), new $c_RTLong((-444972356), (-692087595)), new $c_RTLong((-1351849547), (-2043167483)), new $c_RTLong(457671715, (-1480217529)), new $c_RTLong((-501652181), (-776530088)), new $c_RTLong((-1924145349), (-2095944041)), new $c_RTLong(1889785610, (-1546188227)), new $c_RTLong((-858993460), (-858993460)), new $c_RTLong(0, (-2147483648)), new $c_RTLong(0, (-1610612736)), new $c_RTLong(0, (-939524096)), new $c_RTLong(0, (-100663296)), new $c_RTLong(0, (-1673527296)), new $c_RTLong(0, (-1018167296)), new $c_RTLong(0, (-198967296)), new $c_RTLong(0, (-1734967296)), new $c_RTLong(0, (-1094967296)), new $c_RTLong(0, (-294967296)), new $c_RTLong(0, (-1794967296)), new $c_RTLong(0, (-1169967296)), new $c_RTLong(0, (-388717296)), new $c_RTLong(0, (-1853561046)), new $c_RTLong((-2147483648), (-1243209484)), new $c_RTLong((-1610612736), (-480270031)), new $c_RTLong(67108864, (-1910781505)), new $c_RTLong((-989855744), (-1314735058)), new $c_RTLong(1983905792, (-569676998)), new $c_RTLong((-1981284352), (-1966660860)), new $c_RTLong((-1402863616), (-1384584251)), new $c_RTLong(393904128, (-656988489)), new $c_RTLong(1856802816, (-2021230542)), new $c_RTLong(173519872, (-1452796353)), new $c_RTLong((-856841984), (-742253618)), new $c_RTLong(1075086496, (-2074521247)), new $c_RTLong((-1877367352), (-1519409735)), new $c_RTLong((-199225542), (-825520345)), new $c_RTLong((-124515964), (-2126562952)), new $c_RTLong(918096869, (-1584461865)), new $c_RTLong(73879262, (-906835507)), new $c_RTLong(1166090902, (-59802560)), new $c_RTLong(728806813, (-1647989336)), new $c_RTLong(911008517, (-986244846)), new $c_RTLong((-1008723002), (-159064234)), new $c_RTLong(980160860, (-1710027882)), new $c_RTLong((-922282573), (-1063793029)), new $c_RTLong((-1152853216), (-255999462)), new $c_RTLong((-1257404172), (-1770612400)), new $c_RTLong((-498013391), (-1139523676)), new $c_RTLong(451225085, (-350662770)), new $c_RTLong((-791726146), (-1829776968)), new $c_RTLong(84084141, (-1213479385)), new $c_RTLong((-968636647), (-443107408)), new $c_RTLong(2078956655, (-1887554866)), new $c_RTLong(451212171, (-1285701758)), new $c_RTLong((-1583468434), (-533385374)), new $c_RTLong((-1526538683), (-1943978595)), new $c_RTLong(239310294, (-1356231419)), new $c_RTLong(1372879692, (-621547450)), new $c_RTLong((-215692017), (-1999079893)), new $c_RTLong((-269615021), (-1425108042)), new $c_RTLong((-1410760600), (-707643228)), new $c_RTLong((-344854463), (-2052889754)), new $c_RTLong((-1504809903), (-1492370368)), new $c_RTLong((-807270555), (-791721136)), new $c_RTLong((-2115156833), (-2105438446)), new $c_RTLong(577279431, (-1558056233)), new $c_RTLong((-352142535), (-873828468)), new $c_RTLong(633563656, (-18543760)), new $c_RTLong(395977285, (-1622202586)), new $c_RTLong((-1652512042), (-954011409)), new $c_RTLong((-2065640053), (-118772437)), new $c_RTLong(856458615, (-1684845509)), new $c_RTLong((-3168555), (-1032315063)), new $c_RTLong(2143522954, (-216652004)), new $c_RTLong((-807781802), (-1746020239)), new $c_RTLong(1137756396, (-1108783474)), new $c_RTLong((-725288153), (-312237519)), new $c_RTLong(620436728, (-1805761185)), new $c_RTLong((-298195914), (-1183459658)), new $c_RTLong((-1446486716), (-405582748)), new $c_RTLong((-367183286), (-1864101954)), new $c_RTLong((-1532720931), (-1256385618)), new $c_RTLong(1305324308, (-496740198)), new $c_RTLong(1889569516, (-1921075360)), new $c_RTLong((-1933005400), (-1327602376)), new $c_RTLong((-1342514926), (-585761146)), new $c_RTLong(771540907, (-1976713452)), new $c_RTLong(964426134, (-1397149991)), new $c_RTLong((-2015692805), (-672695665)), new $c_RTLong((-1259808003), (-2031047527)), new $c_RTLong(572723644, (-1465067584)), new $c_RTLong(715904555, (-757592656)), new $c_RTLong(447440347, (-2084108146)), new $c_RTLong((-1588183214), (-1531393359)), new $c_RTLong(162254630, (-840499874)), new $c_RTLong((-972332680), (-2135925158)), new $c_RTLong(2005809622, (-1596164623)), new $c_RTLong((-713963444), (-921463955)), new $c_RTLong(1255029343, (-78088119)), new $c_RTLong((-826219397), (-1659417811)), new $c_RTLong(1114709402, (-1000530439)), new $c_RTLong((-1827838720), (-176921225)), new $c_RTLong((-1142399200), (-1721188502)), new $c_RTLong(1793226472, (-1077743803)), new $c_RTLong((-979692382), (-273437930)), new $c_RTLong(998304997, (-1781511442)), new $c_RTLong((-899602401), (-1153147479)), new $c_RTLong(1022980646, (-367692524)), new $c_RTLong((-1508120744), (-1840420564)), new $c_RTLong((-811409106), (-1226783881)), new $c_RTLong((-1014261382), (-459738027)), new $c_RTLong((-1707655188), (-1897949003)), new $c_RTLong(12914663, (-1298694429)), new $c_RTLong((-1057598495), (-549626213)), new $c_RTLong(1486484588, (-1954129119)), new $c_RTLong((-1363119737), (-1368919575)), new $c_RTLong(443583977, (-637407644)), new $c_RTLong((-1870243662), (-2008992514)), new $c_RTLong(883420894, (-1437498818)), new $c_RTLong((-1043207530), (-723131699)), new $c_RTLong((-1725746530), (-2062570048)), new $c_RTLong((-1083441339), (-1504470736)), new $c_RTLong((-280559850), (-806846596)), new $c_RTLong(361521006, (-2114891858)), new $c_RTLong((-1695582391), (-1569872999)), new $c_RTLong(28005660, (-888599424)), new $c_RTLong(35007075, (-37007456)), new $c_RTLong(21879422, (-1633742396)), new $c_RTLong(27349277, (-968436171)), new $c_RTLong(1107928421, (-136803390)), new $c_RTLong(1766197087, (-1696114855)), new $c_RTLong((-1013479113), (-1046401745)), new $c_RTLong((-1266848892), (-234260357)), new $c_RTLong(1355703090, (-1757025459)), new $c_RTLong((-1526596609), (-1122540000)), new $c_RTLong((-834503937), (-329433176)), new $c_RTLong((-2132177697), (-1816508471)), new $c_RTLong((-517738473), (-1196893765)), new $c_RTLong((-647173091), (-422375382)), new $c_RTLong((-941354094), (-1874597350)), new $c_RTLong(2044532855, (-1269504863)), new $c_RTLong((-665559404), (-513139255)), new $c_RTLong(657767197, (-1931324770)), new $c_RTLong((-1325274652), (-1340414139)), new $c_RTLong(490890333, (-601775849)), new $c_RTLong(1917419194, (-1986722642)), new $c_RTLong(249290345, (-1409661478)), new $c_RTLong((-1835870717), (-688335024)), new $c_RTLong(1536935362, (-2040822126)), new $c_RTLong((-226314446), (-1477285834)), new $c_RTLong((-1356634881), (-772865468)), new $c_RTLong((-311025889), (-2093653654)), new $c_RTLong((-1462524185), (-1543325243)), new $c_RTLong(319328417, (-855414729)), new $c_RTLong(1810192996, (-2145246942)), new $c_RTLong(115257597, (-1607816853)), new $c_RTLong((-929669827), (-936029243)), new $c_RTLong(985396364, (-96294729)), new $c_RTLong((-2068481833), (-1670796942)), new $c_RTLong(635623181, (-1014754353)), new $c_RTLong((-279212847), (-194701118)), new $c_RTLong((-711378942), (-1732300935)), new $c_RTLong(1258259971, (-1091634344)), new $c_RTLong(1572824964, (-290801106)), new $c_RTLong((-90726222), (-1792363428)), new $c_RTLong(960334047, (-1166712460)), new $c_RTLong(1200417559, (-384648751)), new $c_RTLong((-860351762), (-1851018206)), new $c_RTLong(2145785770, (-1240030933)), new $c_RTLong(1608490388, (-476296842)), new $c_RTLong((-68435331), (-1908298263)), new $c_RTLong(2061939484, (-1311631004)), new $c_RTLong((-1717542941), (-565796931)), new $c_RTLong((-2147206162), (-1964235818)), new $c_RTLong(537217769, (-1381552948)), new $c_RTLong(671522212, (-653199361)), new $c_RTLong(2030314118, (-2018862337)), new $c_RTLong(1464150824, (-1449836097)), new $c_RTLong(756446706, (-738553297)), new $c_RTLong(2083391927, (-2072208547)), new $c_RTLong((-616985563), (-1516518860)), new $c_RTLong(302509870, (-821906750)), new $c_RTLong(1262810493, (-2124304455)), new $c_RTLong((-1642712356), (-1581638745)), new $c_RTLong((-2053390445), (-903306607)), new $c_RTLong((-419254408), (-55391435)), new $c_RTLong((-1335775829), (-1645232383)), new $c_RTLong(477763862, (-982798654)), new $c_RTLong((-1550278821), (-154756494)), new $c_RTLong((-1505795175), (-1707335545)), new $c_RTLong((-1882243969), (-1060427607)), new $c_RTLong((-205321313), (-251792685)), new $c_RTLong(2019157827, (-1767983164)), new $c_RTLong((-1771020012), (-1136237131)), new $c_RTLong((-66291367), (-346554590)), new $c_RTLong((-578303016), (-1827209355)), new $c_RTLong(1424604878, (-1210269869)), new $c_RTLong(707014273, (-439095512)), new $c_RTLong(441883920, (-1885047431)), new $c_RTLong(1626096725, (-1282567465)), new $c_RTLong(958879082, (-529467507)), new $c_RTLong(1136170338, (-1941529928)), new $c_RTLong(1420212923, (-1353170586)), new $c_RTLong((-372217494), (-617721409)), new $c_RTLong((-232635934), (-1996688617)), new $c_RTLong((-290794918), (-1422118947)), new $c_RTLong(1783990001, (-703906859)), new $c_RTLong(1651864662, (-2050554523)), new $c_RTLong((-1156394644), (-1489451330)), new $c_RTLong(1775732167, (-788072338)), new $c_RTLong(36090780, (-2103157947)), new $c_RTLong(1118855300, (-1555205610)), new $c_RTLong((-748914523), (-870265189)), new $c_RTLong((-936143154), (-14089662)), new $c_RTLong((-1121960383), (-1619418775)), new $c_RTLong(745033169, (-950531644)), new $c_RTLong(931291461, (-114422731)), new $c_RTLong(1118928075, (-1682126943)), new $c_RTLong((-1822565378), (-1028916855)), new $c_RTLong((-130723074), (-212404245)), new $c_RTLong(2065781726, (-1743365389)), new $c_RTLong(1508485334, (-1105464912)), new $c_RTLong(1885606668, (-308089316)), new $c_RTLong((-968979481), (-1803168559)), new $c_RTLong(936259297, (-1180218874)), new $c_RTLong((-977159527), (-401531769)), new $c_RTLong((-610724704), (-1861570092)), new $c_RTLong(310335944, (-1253220790)), new $c_RTLong((-1759563718), (-492784164)), new $c_RTLong((-562856412), (-1918602839)), new $c_RTLong(1443913133, (-1324511724)), new $c_RTLong(1804891416, (-581897831)), new $c_RTLong((-482555601), (-1974298881)), new $c_RTLong((-603194501), (-1394131777)), new $c_RTLong((-753993126), (-668922897)), new $c_RTLong((-471245704), (-2028689547)), new $c_RTLong(1558426518, (-1462120109)), new $c_RTLong(874291324, (-753908312)), new $c_RTLong(546432077, (-2081805431)), new $c_RTLong(1756781920, (-1528514965)), new $c_RTLong(1122235577, (-836901882)), new $c_RTLong((-372344589), (-2133676413)), new $c_RTLong((-465430736), (-1593353692)), new $c_RTLong(491953404, (-917950290)), new $c_RTLong((-1532541892), (-73696039)), new $c_RTLong(115903141, (-1656672760)), new $c_RTLong(144878926, (-997099126)), new $c_RTLong((-1966384990), (-172632084)), new $c_RTLong((-692119707), (-1718507789)), new $c_RTLong((-865149633), (-1074392912)), new $c_RTLong((-7695218), (-269249316)), new $c_RTLong(532061401, (-1778893558)), new $c_RTLong((-1482406897), (-1149875124)), new $c_RTLong((-779266797), (-363602081)), new $c_RTLong((-487041748), (-1837864037)), new $c_RTLong((-608802185), (-1223588222)), new $c_RTLong((-1834744555), (-455743453)), new $c_RTLong(1000768301, (-1895452394)), new $c_RTLong((-896523272), (-1295573669)), new $c_RTLong((-1120654090), (-545725262)), new $c_RTLong((-1237279718), (-1951691025)), new $c_RTLong((-1546599648), (-1365871957)), new $c_RTLong((-1933249560), (-633598122)), new $c_RTLong(402331761, (-2006611562)), new $c_RTLong((-1644568947), (-1434522629)), new $c_RTLong((-2055711183), (-719411462)), new $c_RTLong((-1821690402), (-2060244900)), new $c_RTLong((-1203371178), (-1501564301)), new $c_RTLong((-1504213972), (-803213552)), new $c_RTLong(1744220827, (-2112621206)), new $c_RTLong(32792386, (-1567034683)), new $c_RTLong(1114732307, (-885051530)), new $c_RTLong((-754068265), (-32572589)), new $c_RTLong(1676190982, (-1630970604)), new $c_RTLong(2095238728, (-964971431)), new $c_RTLong((-602177062), (-132472465)), new $c_RTLong((-376360664), (-1693408027)), new $c_RTLong(1677032818, (-1043018209)), new $c_RTLong(1022549199, (-230030937)), new $c_RTLong((-2045261311), (-1754382072)), new $c_RTLong((-1482834814), (-1119235766)), new $c_RTLong(1367681954, (-325302883)), new $c_RTLong(1391672133, (-1813927038)), new $c_RTLong((-407893481), (-1193666974)), new $c_RTLong((-1583608675), (-418341893)), new $c_RTLong(1157728226, (-1872076419)), new $c_RTLong((-1774065190), (-1266353700)), new $c_RTLong((-1143839663), (-509200301)), new $c_RTLong(1432583858, (-1928862924)), new $c_RTLong(1790729823, (-1337336831)), new $c_RTLong((-982813193), (-597929215)), new $c_RTLong(459483578, (-1984318495)), new $c_RTLong(1648096297, (-1406656295)), new $c_RTLong((-1161105101), (-684578545)), new $c_RTLong((-725690688), (-2038474327)), new $c_RTLong(1240370288, (-1474351084)), new $c_RTLong(1550462860, (-769197031)), new $c_RTLong((-641573449), (-2091360881)), new $c_RTLong((-801966811), (-1540459277)), new $c_RTLong((-1002458513), (-851832272)), new $c_RTLong(2057817989, (-2143007906)), new $c_RTLong(424788838, (-1605018058)), new $c_RTLong((-1616497600), (-932530749)), new $c_RTLong((-2020622000), (-91921612)), new $c_RTLong((-726017838), (-1668063744)), new $c_RTLong(166219527, (-1011337855)), new $c_RTLong(1281516232, (-190430495)), new $c_RTLong((-809665091), (-1729631796)), new $c_RTLong(61660460, (-1088297920)), new $c_RTLong(77075576, (-286630576)), new $c_RTLong(48172235, (-1789756846)), new $c_RTLong((-2087268355), (-1163454234)), new $c_RTLong(612140029, (-380575968)), new $c_RTLong(382587518, (-1848472716)), new $c_RTLong(478234397, (-1236849071)), new $c_RTLong(1671534821, (-472319515)), new $c_RTLong(1581580175, (-1905812433)), new $c_RTLong(903233395, (-1308523717))]);
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$zoneOffsets = new ($d_Ljava_time_ZoneOffset.getArrayOf().constr)(145);
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$zoneIds = $ct_ju_concurrent_ConcurrentHashMap__I__(new $c_ju_concurrent_ConcurrentHashMap(), 256);
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$hexDigits = new $ac_C(new Uint16Array([48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 97, 98, 99, 100, 101, 102]));
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$dumpBorder = new $ac_C(new Uint16Array([10, 43, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 43, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 43, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 45, 43]));
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonReader$$$dumpHeader = new $ac_C(new Uint16Array([10, 124, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 124, 32, 32, 48, 32, 32, 49, 32, 32, 50, 32, 32, 51, 32, 32, 52, 32, 32, 53, 32, 32, 54, 32, 32, 55, 32, 32, 56, 32, 32, 57, 32, 32, 97, 32, 32, 98, 32, 32, 99, 32, 32, 100, 32, 32, 101, 32, 32, 102, 32, 124, 32, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 97, 98, 99, 100, 101, 102, 32, 124]));
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_bigDecimalMathContext = $m_Ljava_math_MathContext$().Ljava_math_MathContext$__f_DECIMAL128;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_bigDecimalDigitsLimit = 308;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_bigDecimalScaleLimit = 6178;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$__f_bigIntDigitsLimit = 308;
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$ as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$ };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$.prototype = new $h_O();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$ as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$ };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$.prototype;
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$ = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$, "com.github.plokhotnyuk.jsoniter_scala.core.JsonReader$", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$ as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$ };
var $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$;
function $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$() {
  if ((!$n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$)) {
    $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$ = new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$();
  }
  return $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$;
}
export { $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$ as $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$ };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter(buf, count, limit, indention, comma, disableBufGrowing, bbuf, out, config) {
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_buf = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_count = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_limit = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_indention = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_comma = false;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_disableBufGrowing = false;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_bbuf = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_out = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_config = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_buf = buf;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_count = count;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_limit = limit;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_indention = indention;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_comma = comma;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_disableBufGrowing = disableBufGrowing;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_bbuf = bbuf;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_out = out;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter__f_config = config;
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter.prototype = new $h_O();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter.prototype;
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter, "com.github.plokhotnyuk.jsoniter_scala.core.JsonWriter", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$() {
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonWriter$$$digits = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonWriter$$$gs = null;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$__f_tenPow18Squares = null;
  $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$ = this;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonWriter$$$digits = new $ac_S(new Int16Array([12336, 12592, 12848, 13104, 13360, 13616, 13872, 14128, 14384, 14640, 12337, 12593, 12849, 13105, 13361, 13617, 13873, 14129, 14385, 14641, 12338, 12594, 12850, 13106, 13362, 13618, 13874, 14130, 14386, 14642, 12339, 12595, 12851, 13107, 13363, 13619, 13875, 14131, 14387, 14643, 12340, 12596, 12852, 13108, 13364, 13620, 13876, 14132, 14388, 14644, 12341, 12597, 12853, 13109, 13365, 13621, 13877, 14133, 14389, 14645, 12342, 12598, 12854, 13110, 13366, 13622, 13878, 14134, 14390, 14646, 12343, 12599, 12855, 13111, 13367, 13623, 13879, 14135, 14391, 14647, 12344, 12600, 12856, 13112, 13368, 13624, 13880, 14136, 14392, 14648, 12345, 12601, 12857, 13113, 13369, 13625, 13881, 14137, 14393, 14649]));
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$__f_com$github$plokhotnyuk$jsoniter_scala$core$JsonWriter$$$gs = new $ac_J([new $c_RTLong(1517391316, 1326247369), new $c_RTLong((-1700736587), 1526851760), new $c_RTLong((-149154271), 2121995790), new $c_RTLong((-144198162), 295479168), new $c_RTLong((-978316876), 1697596632), new $c_RTLong(743634930, 236383335), new $c_RTLong(935333417, 1358077306), new $c_RTLong((-264085515), 1477596856), new $c_RTLong((-110726726), 1086461844), new $c_RTLong((-1070261871), 2041070944), new $c_RTLong((-177162761), 1738338951), new $c_RTLong((-853425535), 1977223322), new $c_RTLong((-1859717127), 1390671161), new $c_RTLong((-1541733887), 1152281928), new $c_RTLong(1089206676, 1112536929), new $c_RTLong((-374393651), 921825542), new $c_RTLong((-834249696), 1780059086), new $c_RTLong((-1458023301), 1474920868), new $c_RTLong(1909580621, 1424047269), new $c_RTLong(1410561737, 750439965), new $c_RTLong((-1908309340), 1139237815), new $c_RTLong(1128449390, 600351972), new $c_RTLong((-476314566), 1822780504), new $c_RTLong(1805519024, 101569696), new $c_RTLong((-381051653), 1458224403), new $c_RTLong((-1132565159), 510752486), new $c_RTLong(554152136, 1166579523), new $c_RTLong((-906052127), 2126588907), new $c_RTLong(27649959, 1866527237), new $c_RTLong((-1449683403), 2114052063), new $c_RTLong((-1695866951), 1493221789), new $c_RTLong(1417233655, 1261744921), new $c_RTLong((-1356693561), 1194577431), new $c_RTLong((-1443193453), 1438892666), new $c_RTLong((-1311716238), 1911323890), new $c_RTLong(1985857770, 1443234807), new $c_RTLong((-1908366450), 1529059112), new $c_RTLong(729692757, 2013581305), new $c_RTLong(191293759, 1223247290), new $c_RTLong(1442747665, 322374855), new $c_RTLong(306070014, 1957195664), new $c_RTLong((-1127577573), 1374793227), new $c_RTLong(1103849470, 1565756531), new $c_RTLong(1674918319, 1958828041), new $c_RTLong(24086117, 1252605225), new $c_RTLong((-2096039181), 1137565703), new $c_RTLong(38537788, 2004168360), new $c_RTLong(941304606, 102118207), new $c_RTLong(30830230, 1603334688), new $c_RTLong((-105949775), 940688024), new $c_RTLong(1742651102, 1282667750), new $c_RTLong(774233640, 1611543879), new $c_RTLong((-1506725532), 2052268400), new $c_RTLong(1238773823, 860483288), new $c_RTLong((-2064373885), 1641814720), new $c_RTLong(991019059, 1117883360), new $c_RTLong(1784474729, 1313451776), new $c_RTLong((-1784165131), 464809958), new $c_RTLong(1137172648, 2101522842), new $c_RTLong((-1136677291), 743695933), new $c_RTLong((-808248800), 1681218273), new $c_RTLong((-50348374), 594956746), new $c_RTLong(212394419, 1344974619), new $c_RTLong(818714760, 905462127), new $c_RTLong(1028908994, 1075979695), new $c_RTLong((-204021651), 1583363160), new $c_RTLong(1646254391, 1721567512), new $c_RTLong((-1185428101), 1244890868), new $c_RTLong((-400983406), 1377254009), new $c_RTLong(769644438, 1854906154), new $c_RTLong((-320786725), 1101803207), new $c_RTLong((-243277909), 1913421652), new $c_RTLong((-1372252218), 1762885132), new $c_RTLong(469748805, 484494267), new $c_RTLong(620185144, 1410308106), new $c_RTLong((-1342187874), 387595413), new $c_RTLong((-362845344), 1128246484), new $c_RTLong((-214756840), 310076330), new $c_RTLong((-580552551), 1805194375), new $c_RTLong(1374375974, 1784612318), new $c_RTLong((-1323435500), 1444155500), new $c_RTLong((-1477479598), 1427689854), new $c_RTLong((-1917741859), 1155324400), new $c_RTLong(536003240, 712655154), new $c_RTLong((-491406597), 1848519040), new $c_RTLong(857605183, 1569744976), new $c_RTLong((-1252118737), 1478815232), new $c_RTLong((-1890896231), 1685292710), new $c_RTLong(716291929, 1183052186), new $c_RTLong((-653723525), 918737438), new $c_RTLong((-571919832), 1892883497), new $c_RTLong(672029277, 1469979902), new $c_RTLong(1260451053, 1514306798), new $c_RTLong(537623422, 746487192), new $c_RTLong((-1568619535), 1211445438), new $c_RTLong(430098738, 167693024), new $c_RTLong((-791804338), 1938312701), new $c_RTLong((-1029828938), 1127302297), new $c_RTLong(1943536907, 1550650161), new $c_RTLong((-823863151), 1331338567), new $c_RTLong(695836066, 1240520129), new $c_RTLong(1917889857, 1924064313), new $c_RTLong((-1463642671), 1984832206), new $c_RTLong((-2085336984), 931019253), new $c_RTLong(1406066241, 1587865765), new $c_RTLong(908710791, 315318673), new $c_RTLong(1124852992, 1270292612), new $c_RTLong((-132024827), 1970241856), new $c_RTLong((-1636209049), 2032468179), new $c_RTLong(1506747196, 1863896782), new $c_RTLong((-1308967239), 1625974543), new $c_RTLong(1205397757, 1061620696), new $c_RTLong((-188180332), 1300779634), new $c_RTLong(105324746, 849296557), new $c_RTLong((-301088531), 2081247415), new $c_RTLong((-1549467325), 929377761), new $c_RTLong((-1099864284), 1664997932), new $c_RTLong(1337406518, 743502209), new $c_RTLong(838095491, 1331998346), new $c_RTLong(210931755, 1024298497), new $c_RTLong((-377034133), 2131197353), new $c_RTLong((-521502651), 2068374324), new $c_RTLong(557366153, 1704957883), new $c_RTLong(1300784797, 1225202730), new $c_RTLong((-2131087455), 1363966306), new $c_RTLong((-1536352540), 550665454), new $c_RTLong(872110413, 1091173045), new $c_RTLong((-2088075491), 1729022552), new $c_RTLong(1395376662, 1745876872), new $c_RTLong(1813039970, 189455706), new $c_RTLong((-601685589), 1396701497), new $c_RTLong((-1126548402), 581061294), new $c_RTLong(1236638447, 1117361198), new $c_RTLong(1675741656, 894345765), new $c_RTLong(1119628056, 1787777917), new $c_RTLong((-1613780646), 1430953224), new $c_RTLong((-822284474), 1430222333), new $c_RTLong((-432031058), 2003756038), new $c_RTLong(201165880, 1144177867), new $c_RTLong(513368613, 1603004831), new $c_RTLong(1180858868, 1830684587), new $c_RTLong(1680383240, 846820811), new $c_RTLong((-773299824), 1464547669), new $c_RTLong(485313133, 677456649), new $c_RTLong((-618639859), 1171638135), new $c_RTLong((-1329736412), 112468589), new $c_RTLong(1587156603, 1874621017), new $c_RTLong(449402118, 609446473), new $c_RTLong((-448261636), 1499696813), new $c_RTLong(2077508613, 487557178), new $c_RTLong(500384150, 1199757451), new $c_RTLong((-55980028), 1249039201), new $c_RTLong((-917372278), 1919611921), new $c_RTLong((-89568045), 1139469263), new $c_RTLong(1843082555, 1535689537), new $c_RTLong((-930647895), 1341072140), new $c_RTLong((-243520874), 1228551629), new $c_RTLong(1832462062, 213864253), new $c_RTLong((-389633399), 1965682607), new $c_RTLong(1213952380, 1630672994), new $c_RTLong(1406280199, 1572546086), new $c_RTLong(112168445, 1734035125), new $c_RTLong(266030700, 1258036869), new $c_RTLong(89734756, 1387228100), new $c_RTLong(2143636039, 2012858990), new $c_RTLong(1002569069, 931074771), new $c_RTLong(1714908831, 1610287192), new $c_RTLong((-1774925123), 1174356546), new $c_RTLong((-346059854), 1288229753), new $c_RTLong(2016033739, 1798478696), new $c_RTLong(1164291153, 2061167606), new $c_RTLong(1507667063, 730082266), new $c_RTLong(72439463, 1648934085), new $c_RTLong((-1370846727), 1013562542), new $c_RTLong(57951570, 1319147268), new $c_RTLong(1480302996, 1669843493), new $c_RTLong((-766270946), 2110635628), new $c_RTLong((-1067489043), 94769211), new $c_RTLong(245976702, 1688508503), new $c_RTLong((-1712984694), 934808828), new $c_RTLong(1914768280, 1350806802), new $c_RTLong((-511394296), 747847062), new $c_RTLong((-186172295), 1080645441), new $c_RTLong(449878023, 1886767839), new $c_RTLong(561117788, 1729032707), new $c_RTLong(719804836, 1300841624), new $c_RTLong((-1269092688), 1383226165), new $c_RTLong(1434837328, 1040673299), new $c_RTLong((-1874267610), 1106580932), new $c_RTLong((-1429110515), 1691532098), new $c_RTLong(437145662, 1770529492), new $c_RTLong(1149397013, 129470980), new $c_RTLong((-1368270389), 1416423593), new $c_RTLong((-798469308), 533073513), new $c_RTLong((-235622852), 1133138874), new $c_RTLong(220218013, 426458811), new $c_RTLong((-376996563), 1813022199), new $c_RTLong(352348820, 252837368), new $c_RTLong((-301597251), 1450417759), new $c_RTLong(1140872515, 1490760083), new $c_RTLong((-241277801), 1160334207), new $c_RTLong(912698012, 1622104796), new $c_RTLong((-1245037940), 1856534732), new $c_RTLong((-1975657017), 877380755), new $c_RTLong(721956566, 1485227786), new $c_RTLong((-1580525614), 1560898063), new $c_RTLong((-281428206), 1188182228), new $c_RTLong((-1264420491), 389724991), new $c_RTLong(1267701789, 1901091566), new $c_RTLong(553907592, 194063257), new $c_RTLong(155167972, 1520873253), new $c_RTLong((-1274860845), 155250605), new $c_RTLong(1842121296, 1216698602), new $c_RTLong((-1878882135), 124200484), new $c_RTLong((-488579764), 1946717763), new $c_RTLong((-1288224498), 1916707693), new $c_RTLong(468129648, 1557374211), new $c_RTLong((-171586139), 1533366154), new $c_RTLong((-484489741), 1245899368), new $c_RTLong((-1855255829), 1656189653), new $c_RTLong(942803334, 1993438990), new $c_RTLong(467564509, 72923068), new $c_RTLong(754242667, 1594751192), new $c_RTLong(374051608, 487835184), new $c_RTLong((-1114592785), 1275800953), new $c_RTLong((-559752173), 819764876), new $c_RTLong((-65361537), 2041281525), new $c_RTLong(822383441, 23133614), new $c_RTLong((-911282689), 1633025220), new $c_RTLong((-201086706), 448003620), new $c_RTLong((-1588019611), 1306420176), new $c_RTLong((-1878856283), 1646893085), new $c_RTLong((-1681837918), 2090272282), new $c_RTLong((-1288183135), 1776035477), new $c_RTLong(372516584, 1672217826), new $c_RTLong(687440411, 1420828382), new $c_RTLong((-560980192), 1337774260), new $c_RTLong((-1168034590), 1136662705), new $c_RTLong(1679412071, 2140438817), new $c_RTLong(1567118493, 530170140), new $c_RTLong((-374457262), 1712351053), new $c_RTLong(2112688254, 1283129571), new $c_RTLong(559427650, 1369880843), new $c_RTLong((-27836315), 167510197), new $c_RTLong((-2129438258), 1095904674), new $c_RTLong((-1740255971), 993001617), new $c_RTLong(887866083, 1753447479), new $c_RTLong((-1066422635), 2018299317), new $c_RTLong(1569286326, 1402757983), new $c_RTLong(5855351, 755645995), new $c_RTLong((-1321551317), 1122206386), new $c_RTLong((-1713302637), 1034013525), new $c_RTLong((-1255488648), 1795530218), new $c_RTLong((-164303842), 1654421640), new $c_RTLong((-145397459), 1436424174), new $c_RTLong(727550385, 894040583), new $c_RTLong((-116317967), 1149139339), new $c_RTLong((-276953151), 285735736), new $c_RTLong((-186108747), 1838622943), new $c_RTLong(2133855336, 27680449), new $c_RTLong(710106461, 1470898355), new $c_RTLong(1707084269, 1310634548), new $c_RTLong(568085169, 1176718684), new $c_RTLong(506673956, 619010909), new $c_RTLong((-1668044107), 1882749894), new $c_RTLong((-48315130), 560920724), new $c_RTLong((-1334435286), 1506199915), new $c_RTLong(820341356, 1307730039), new $c_RTLong((-1926541688), 1204959932), new $c_RTLong(1515266544, 1046184031), new $c_RTLong(353507136, 1927935892), new $c_RTLong(706439551, 1673894450), new $c_RTLong((-1435181209), 1542348713), new $c_RTLong(1424145100, 50625371), new $c_RTLong((-289151508), 1233878970), new $c_RTLong(280322621, 40500297), new $c_RTLong(2114337964, 1974206353), new $c_RTLong((-1269470725), 1782787393), new $c_RTLong((-885510006), 1579365082), new $c_RTLong((-1015576580), 567236455), new $c_RTLong(1009578913, 1263492066), new $c_RTLong(1764519114, 1742279353), new $c_RTLong((-102660657), 2021587305), new $c_RTLong((-1471736714), 1499156776), new $c_RTLong((-941121985), 1617269844), new $c_RTLong((-318395912), 1628822150), new $c_RTLong((-752897588), 1293815875), new $c_RTLong((-1113710189), 1303057720), new $c_RTLong(1372344237, 2070105401), new $c_RTLong((-1781936302), 1655395623), new $c_RTLong(238881931, 1656084321), new $c_RTLong(292437877, 35826310), new $c_RTLong((-667887915), 1324867456), new $c_RTLong((-625043158), 1317151236), new $c_RTLong((-209627204), 2119787930), new $c_RTLong((-1859062512), 389455060), new $c_RTLong((-1026695223), 1695830344), new $c_RTLong(1089730368, 1600054237), new $c_RTLong((-821356178), 1356664275), new $c_RTLong((-1705196083), 421049930), new $c_RTLong((-1516078402), 1085331420), new $c_RTLong((-1364156866), 1195833403), new $c_RTLong(151254935, 1736530273), new $c_RTLong(394329391, 624843257), new $c_RTLong(1838990866, 1389224218), new $c_RTLong((-543529946), 1358868064), new $c_RTLong((-1105787685), 1111379374), new $c_RTLong(2142156421, 1516591181), new $c_RTLong((-1769260295), 1778206999), new $c_RTLong(1709463355, 279062242), new $c_RTLong((-1415408236), 1422565599), new $c_RTLong((-350416235), 223249793), new $c_RTLong((-1132326589), 1138052479), new $c_RTLong((-1139326447), 608096564), new $c_RTLong((-1811722542), 1820883967), new $c_RTLong(1613051522, 113961044), new $c_RTLong(268608884, 1456707174), new $c_RTLong((-427545701), 1809155753), new $c_RTLong(1073880567, 1165365739), new $c_RTLong(1375950358, 158834414), new $c_RTLong((-858771471), 1864585182), new $c_RTLong((-1234453265), 1542625251), new $c_RTLong(1030969742, 1491668146), new $c_RTLong(730424307, 375106742), new $c_RTLong((-34217666), 1193334516), new $c_RTLong((-274654014), 1159078852), new $c_RTLong(804245194, 1909335227), new $c_RTLong(2137533955, 995532705), new $c_RTLong((-1074590763), 1527468181), new $c_RTLong((-866953213), 366929434), new $c_RTLong(1717307767, 1221974545), new $c_RTLong(1883417807, 723040277), new $c_RTLong((-1547274869), 1955159272), new $c_RTLong((-2140492264), 1586361173), new $c_RTLong(480167023, 1564127418), new $c_RTLong(1723580026, 1698585668), new $c_RTLong(2102120537, 1251301934), new $c_RTLong(519870561, 929371805), new $c_RTLong(786412482, 2002083095), new $c_RTLong((-27200561), 628001428), new $c_RTLong(629129985, 1601666476), new $c_RTLong((-21760449), 1790891331), new $c_RTLong((-355689471), 1281333180), new $c_RTLong((-17408359), 1003216335), new $c_RTLong(2007877224, 2050133089), new $c_RTLong((-1745840293), 1605146137), new $c_RTLong((-1829672058), 1640106471), new $c_RTLong(1180308143, 2143110369), new $c_RTLong(1113242731, 1312085177), new $c_RTLong(85253055, 2143985025), new $c_RTLong((-1654785466), 2099336283), new $c_RTLong(1854391807, 853395662), new $c_RTLong((-464834914), 1679469026), new $c_RTLong(624519986, 1541709989), new $c_RTLong((-2089854850), 1343575221), new $c_RTLong((-2077364388), 2092361450), new $c_RTLong(905096498, 1074860177), new $c_RTLong(915088867, 814895701), new $c_RTLong((-1987819440), 1719776283), new $c_RTLong((-253844732), 1303833121), new $c_RTLong((-731262093), 1375821026), new $c_RTLong(655917674, 1472563227), new $c_RTLong(1991970703, 1100656821), new $c_RTLong(1383727599, 1607547311), new $c_RTLong(1469166207, 1761050914), new $c_RTLong(1354970698, 1283585509), new $c_RTLong(2034326425, 1408840731), new $c_RTLong((-634010360), 597371677), new $c_RTLong(768467681, 1127072585), new $c_RTLong((-1366201747), 48400612), new $c_RTLong(1229548289, 1803316136), new $c_RTLong(391057582, 1365931169), new $c_RTLong(124645172, 1442652909), new $c_RTLong(1171839525, 1092744935), new $c_RTLong(958709597, 1154122327), new $c_RTLong((-1639508757), 444699218), new $c_RTLong((-1902038482), 1846595723), new $c_RTLong((-46233635), 1570512208), new $c_RTLong((-662637326), 1477276578), new $c_RTLong((-36986908), 397416307), new $c_RTLong(328883598, 1181821263), new $c_RTLong((-1747576444), 1176926505), new $c_RTLong((-332779702), 1890914020), new $c_RTLong((-1078135393), 1024088949), new $c_RTLong((-1125217221), 1512731216), new $c_RTLong(1714472063, 1248767889), new $c_RTLong(1676806601, 1210184973), new $c_RTLong((-346409268), 569517581), new $c_RTLong(1823897102, 1936295957), new $c_RTLong(1163732090, 1770221590), new $c_RTLong((-258869237), 1549036765), new $c_RTLong((-787001246), 1845674001), new $c_RTLong((-1066088849), 1239229412), new $c_RTLong(229392462, 1906035931), new $c_RTLong(1730231679, 1982767060), new $c_RTLong((-491965520), 1761167300), new $c_RTLong(1384185343, 1586213648), new $c_RTLong(1324414503, 1838430570), new $c_RTLong((-1469632103), 1268970918), new $c_RTLong((-1517448775), 1041247726), new $c_RTLong((-633424446), 2030353469), new $c_RTLong(1867049255, 807002903), new $c_RTLong((-506739557), 1624282775), new $c_RTLong(1493639404, 1075099052), new $c_RTLong((-1264385105), 1299426220), new $c_RTLong(2053904983, 1289575971), new $c_RTLong(553964210, 2079081953), new $c_RTLong(709267594, 1204328095), new $c_RTLong((-2133809010), 1663265562), new $c_RTLong(1426407535, 1822455935), new $c_RTLong(10939711, 1330612450), new $c_RTLong(2000119487, 169474559), new $c_RTLong(17503537, 2128979920), new $c_RTLong((-235782658), 1559649483), new $c_RTLong(14002830, 1703183936), new $c_RTLong((-188626126), 388726127), new $c_RTLong((-847791196), 1362547148), new $c_RTLong((-1009894360), 2028967820), new $c_RTLong(180760503, 1090037719), new $c_RTLong((-807915488), 334684067), new $c_RTLong(2007203723, 1744060350), new $c_RTLong(425322137, 964991238), new $c_RTLong(1605762978, 1395248280), new $c_RTLong((-1377729208), 1630986449), new $c_RTLong(1284610383, 1116198624), new $c_RTLong((-243189907), 16298970), new $c_RTLong((-521603765), 1785917798), new $c_RTLong(469889607, 455575083), new $c_RTLong(441710447, 1428734239), new $c_RTLong(375911686, 793956796), new $c_RTLong(1212361817, 1142987391), new $c_RTLong(1159722808, 205668707), new $c_RTLong(221791988, 1828779826), new $c_RTLong(137569574, 2047056850), new $c_RTLong((-681559869), 1463023860), new $c_RTLong((-1607931259), 2067142209), new $c_RTLong((-1404241354), 1170419088), new $c_RTLong((-2145338466), 794720308), new $c_RTLong((-528799248), 1872670541), new $c_RTLong((-1714554628), 1271552493), new $c_RTLong((-2141026317), 1498136433), new $c_RTLong(2064330134, 1446738724), new $c_RTLong((-853827594), 1198509146), new $c_RTLong(1651464108, 298397520), new $c_RTLong((-507130691), 1917614634), new $c_RTLong(65362194, 47939303), new $c_RTLong((-405704553), 1534091707), new $c_RTLong(52289756, 467848172), new $c_RTLong(1393423276, 1227273366), new $c_RTLong((-1676155114), 374278537), new $c_RTLong(511490323, 1963637386), new $c_RTLong((-963861264), 1028342389), new $c_RTLong((-449801201), 1570909908), new $c_RTLong(1805891366, 1252170641), new $c_RTLong(499152498, 1256727927), new $c_RTLong(1444713093, 1860729972), new $c_RTLong(1657637457, 2010764683), new $c_RTLong((-1124432888), 829684307), new $c_RTLong((-1250870412), 1608611746), new $c_RTLong(818440608, 663747446), new $c_RTLong(1576284048, 1286889397), new $c_RTLong((-204240973), 530997956), new $c_RTLong((-913919360), 2059023035), new $c_RTLong(532207903, 849596731), new $c_RTLong((-1590128947), 1647218428), new $c_RTLong(1284759782, 250180655), new $c_RTLong((-413109699), 1317774742), new $c_RTLong(168814366, 1488634713), new $c_RTLong((-1519968977), 2108439588), new $c_RTLong(270102985, 1093325352), new $c_RTLong((-356981722), 1686751670), new $c_RTLong(1934069307, 15666822), new $c_RTLong((-1144578837), 1349401336), new $c_RTLong((-1888718391), 442030187), new $c_RTLong(1661317308, 1079521069), new $c_RTLong(207012206, 353624150), new $c_RTLong(81127315, 1727233711), new $c_RTLong((-1386767390), 995295369), new $c_RTLong((-794091607), 1381786968), new $c_RTLong(608573007, 366739566), new $c_RTLong(223720173, 1105429575), new $c_RTLong((-1231128513), 1581881841), new $c_RTLong(357952277, 1768687320), new $c_RTLong(607174757, 2101514217), new $c_RTLong(286361822, 1414949856), new $c_RTLong((-2091240572), 822217914), new $c_RTLong((-629904002), 1131959884), new $c_RTLong((-813998999), 1516767790), new $c_RTLong((-1007846403), 1811135815), new $c_RTLong((-1302398398), 1997331735), new $c_RTLong((-1665270581), 1448908652), new $c_RTLong((-1041918718), 309375199), new $c_RTLong(385770453, 1159126922), new $c_RTLong((-1692528434), 1535990348), new $c_RTLong(1476226185, 1854603075), new $c_RTLong((-990058576), 310100909), new $c_RTLong(1180980948, 1483682460), new $c_RTLong((-792046861), 248080727), new $c_RTLong(944784758, 1186945968), new $c_RTLong(1943342889, 1057458041), new $c_RTLong(652662154, 1899113549), new $c_RTLong(532368245, 832939407), new $c_RTLong(1381123182, 1519290839), new $c_RTLong((-433098863), 1525344984), new $c_RTLong(1963892005, 1215432671), new $c_RTLong(1371507828, 790779258), new $c_RTLong(1424240290, 1944692274), new $c_RTLong(476425606, 406253354), new $c_RTLong(1998385691, 1555753819), new $c_RTLong((-477852974), 754499412), new $c_RTLong((-1837265284), 1244603055), new $c_RTLong(1335704539, 603599530), new $c_RTLong((-362644077), 1991364888), new $c_RTLong(419140344, 1395255978), new $c_RTLong(568878198, 1593091911), new $c_RTLong(1194305734, 257211323), new $c_RTLong((-403890901), 1274473528), new $c_RTLong(955444588, 635265788), new $c_RTLong(1071761477, 2039157646), new $c_RTLong((-1907262497), 586928531), new $c_RTLong((-1584278), 1631326116), new $c_RTLong(1910163839, 1328536284), new $c_RTLong((-1719254341), 1305060893), new $c_RTLong(669137612, 1492325757), new $c_RTLong((-1032820027), 2088097429), new $c_RTLong((-647366739), 1958224481), new $c_RTLong((-826256021), 1670477943), new $c_RTLong((-1376886850), 278089396), new $c_RTLong(197988642, 1336382355), new $c_RTLong((-1960502939), 1081464976), new $c_RTLong(316781828, 2138211768), new $c_RTLong(299169134, 12357044), new $c_RTLong(1971412380, 1710569414), new $c_RTLong((-1478651611), 1727872553), new $c_RTLong((-1858843933), 1368455531), new $c_RTLong((-2041914748), 1811794772), new $c_RTLong(1089905231, 1094764425), new $c_RTLong((-1633531798), 1878932547), new $c_RTLong(1743848370, 1751623080), new $c_RTLong((-36670500), 2147298616), new $c_RTLong(1395078696, 1401298464), new $c_RTLong((-1747323318), 1717838893), new $c_RTLong(1975056416, 1121038771), new $c_RTLong((-538865195), 1374271114), new $c_RTLong(1442103348, 1793662034), new $c_RTLong(1714796065, 480846865), new $c_RTLong(2012676137, 1434929627), new $c_RTLong(512843393, 1673167681), new $c_RTLong((-107846009), 1147943701), new $c_RTLong(2128261633, 1768030874), new $c_RTLong(686439846, 1836709923), new $c_RTLong((-1748742143), 251869021), new $c_RTLong((-2027828501), 1469367938), new $c_RTLong((-540000255), 630991946), new $c_RTLong((-763269342), 1175494350), new $c_RTLong((-1290993663), 1363787016), new $c_RTLong(1355749431, 1880790961), new $c_RTLong((-347602943), 893569037), new $c_RTLong(225606085, 1504632769), new $c_RTLong(580911105, 2003345419), new $c_RTLong(1039478327, 1203706215), new $c_RTLong((-394264575), 2032173064), new $c_RTLong(1663165324, 1925929944), new $c_RTLong(1946157057, 1533489985), new $c_RTLong((-2105441578), 1540743955), new $c_RTLong((-1879048191), 2085785447), new $c_RTLong(1751620575, 1232595164), new $c_RTLong(1073741825, 380138169), new $c_RTLong(225612542, 1972152263), new $c_RTLong(1, 1467214530), new $c_RTLong(1898476952, 1577721810), new $c_RTLong(1, 1173771624), new $c_RTLong(1518781562, 1262177448), new $c_RTLong(1, 80023840), new $c_RTLong(1571057040, 2019483917), new $c_RTLong(1, 128038144), new $c_RTLong((-461141287), 1615587133), new $c_RTLong(1, 1390920704), new $c_RTLong(490080430, 1292469707), new $c_RTLong(1, 253743104), new $c_RTLong(1643122147, 2067951531), new $c_RTLong(1, 835485696), new $c_RTLong(455504258, 1654361225), new $c_RTLong(1, 1527382016), new $c_RTLong(364403406, 1323488980), new $c_RTLong(1, 2080899072), new $c_RTLong(583045451, 2117582368), new $c_RTLong(1, 322961408), new $c_RTLong((-2110544017), 1694065894), new $c_RTLong(1, 687865856), new $c_RTLong((-1688435214), 1355252715), new $c_RTLong(1, 1409286144), new $c_RTLong(2085225666, 1084202172), new $c_RTLong(1, 268435456), new $c_RTLong((-99612771), 1734723475), new $c_RTLong(1, 0), new $c_RTLong((-938683676), 1387778780), new $c_RTLong(1, 0), new $c_RTLong((-1609940400), 1110223024), new $c_RTLong(1, 0), new $c_RTLong(1719062656, 1776356839), new $c_RTLong(1, 0), new $c_RTLong((-2060723712), 1421085471), new $c_RTLong(1, 0), new $c_RTLong(928401408, 1136868377), new $c_RTLong(1, 0), new $c_RTLong((-1950531584), 1818989403), new $c_RTLong(1, 0), new $c_RTLong((-701431808), 1455191522), new $c_RTLong(1, 0), new $c_RTLong(1156841472, 1164153218), new $c_RTLong(1, 0), new $c_RTLong(991952896, 1862645149), new $c_RTLong(1, 0), new $c_RTLong(1652555776, 1490116119), new $c_RTLong(1, 0), new $c_RTLong((-2113929216), 1192092895), new $c_RTLong(1, 0), new $c_RTLong((-805306368), 1907348632), new $c_RTLong(1, 0), new $c_RTLong(1073741824, 1525878906), new $c_RTLong(1, 0), new $c_RTLong(0, 1220703125), new $c_RTLong(1, 0), new $c_RTLong(0, 1953125000), new $c_RTLong(1, 0), new $c_RTLong(0, 1562500000), new $c_RTLong(1, 0), new $c_RTLong(0, 1250000000), new $c_RTLong(1, 0), new $c_RTLong(0, 2000000000), new $c_RTLong(1, 0), new $c_RTLong(0, 1600000000), new $c_RTLong(1, 0), new $c_RTLong(0, 1280000000), new $c_RTLong(1, 0), new $c_RTLong(0, 2048000000), new $c_RTLong(1, 0), new $c_RTLong(0, 1638400000), new $c_RTLong(1, 0), new $c_RTLong(0, 1310720000), new $c_RTLong(1, 0), new $c_RTLong(0, 2097152000), new $c_RTLong(1, 0), new $c_RTLong(0, 1677721600), new $c_RTLong(1, 0), new $c_RTLong(0, 1342177280), new $c_RTLong(1, 0), new $c_RTLong(0, 1073741824), new $c_RTLong(1, 0), new $c_RTLong(1717986918, 1717986918), new $c_RTLong(858993460, 858993459), new $c_RTLong((-1202590843), 1374389534), new $c_RTLong((-1030792151), 257698037), new $c_RTLong((-962072675), 1099511627), new $c_RTLong(34359739, 1494648619), new $c_RTLong(1896657557, 1759218604), new $c_RTLong((-804017877), 1961941060), new $c_RTLong((-1918647791), 1407374883), new $c_RTLong(215779157, 1140056119), new $c_RTLong((-675924774), 1125899906), new $c_RTLong(1890610244, 1771038354), new $c_RTLong((-222486178), 1801439850), new $c_RTLong((-2128984364), 256680989), new $c_RTLong((-1036982402), 1441151880), new $c_RTLong((-844194032), 1064338250), new $c_RTLong((-1688579381), 1152921504), new $c_RTLong(1042631693, 1280967330), new $c_RTLong(1593240287, 1844674407), new $c_RTLong((-1767763129), 761057539), new $c_RTLong((-443394689), 1475739525), new $c_RTLong(1162769875, 1038342761), new $c_RTLong((-1213709211), 1180591620), new $c_RTLong((-787771019), 2119164397), new $c_RTLong(635045641, 1888946593), new $c_RTLong((-2119427089), 1243179388), new $c_RTLong((-2068943865), 1511157274), new $c_RTLong(1740432166, 1424040240), new $c_RTLong((-1655155092), 1208925819), new $c_RTLong(1392345733, 1139232192), new $c_RTLong(1646719149, 1934281311), new $c_RTLong(509766253, 1393274778), new $c_RTLong(458381860, 1547425049), new $c_RTLong(2125799921, 1114619822), new $c_RTLong(1225698947, 1237940039), new $c_RTLong((-1735333900), 1321192587), new $c_RTLong((-615862062), 1980704062), new $c_RTLong((-199553862), 1254914680), new $c_RTLong(1225297269, 1584563250), new $c_RTLong(699350370, 574435015), new $c_RTLong(980237815, 1267650600), new $c_RTLong((-1158506623), 889044741), new $c_RTLong(1568380504, 2028240960), new $c_RTLong((-994617137), 1422471586), new $c_RTLong(1254704403, 1622592768), new $c_RTLong(63299749, 1567473999), new $c_RTLong((-1573216855), 1298074214), new $c_RTLong((-1667347119), 824482469), new $c_RTLong(1777820328, 2076918743), new $c_RTLong(1627211906, 1319171951), new $c_RTLong((-1154724115), 1661534994), new $c_RTLong((-2134204312), 625840831), new $c_RTLong((-923779292), 1329227995), new $c_RTLong(869616928, 500672665), new $c_RTLong(1098933510, 2126764793), new $c_RTLong((-2044586752), 1660069723), new $c_RTLong((-1697833569), 1701411834), new $c_RTLong(82317517, 39565590), new $c_RTLong((-1358266856), 1361129467), new $c_RTLong(1783840932, 1749639390), new $c_RTLong(631373434, 1088903574), new $c_RTLong(568079286, 540718053), new $c_RTLong((-1566782883), 1742245718), new $c_RTLong(1767920317, 435652155), new $c_RTLong((-394432848), 1393796574), new $c_RTLong((-1162644124), 2066508642), new $c_RTLong((-315546278), 1115037259), new $c_RTLong((-71121840), 794213454), new $c_RTLong((-504874045), 1784059615), new $c_RTLong((-1831781862), 1700238257), new $c_RTLong((-1262892695), 1427247692), new $c_RTLong(1970548347, 930693876), new $c_RTLong(707672762, 1141798154), new $c_RTLong(1576438678, 1603548560), new $c_RTLong((-1444703958), 1826877046), new $c_RTLong(1663308425, 1706684237), new $c_RTLong(1421217211, 1461501637), new $c_RTLong((-2105327097), 1794844119), new $c_RTLong((-581013149), 1169201309), new $c_RTLong((-825268218), 147385106), new $c_RTLong((-929621039), 1870722095), new $c_RTLong((-1320429149), 1524306359), new $c_RTLong((-1602690290), 1496577676), new $c_RTLong((-1915336779), 360451628), new $c_RTLong(1294828145, 1197262141), new $c_RTLong((-1532269423), 1576851491), new $c_RTLong(353738114, 1915619426), new $c_RTLong(1843336219, 1663968927), new $c_RTLong((-576002968), 1532495540), new $c_RTLong((-243317943), 1331175141), new $c_RTLong((-1319795834), 1225996432), new $c_RTLong((-1053647813), 1923933572), new $c_RTLong(1324300503, 1961594292), new $c_RTLong((-1685836502), 1789803527), new $c_RTLong((-658546516), 1569275433), new $c_RTLong(369317717, 1431842822), new $c_RTLong(332156246, 1255420347), new $c_RTLong((-563539285), 2004467716), new $c_RTLong(1390443454, 2008672555), new $c_RTLong(1675317521, 630167969), new $c_RTLong(1112354763, 1606938044), new $c_RTLong(481260557, 933631105), new $c_RTLong(1748877269, 1285550435), new $c_RTLong((-473985013), 2035395072), new $c_RTLong((-1496763665), 2056880696), new $c_RTLong((-758376021), 1968141927), new $c_RTLong(1379569446, 1645504557), new $c_RTLong(252292642, 715520083), new $c_RTLong((-614331362), 1316403645), new $c_RTLong((-1516152805), 1431409525), new $c_RTLong(1594050199, 2106245833), new $c_RTLong(1010129349, 1001765052), new $c_RTLong((-1301740219), 1684996666), new $c_RTLong((-1768876898), 2089902230), new $c_RTLong(1535588203, 1347997333), new $c_RTLong((-1415101518), 383431595), new $c_RTLong((-1348509816), 1078397866), new $c_RTLong((-273087755), 2024732194), new $c_RTLong((-1298622245), 1725436586), new $c_RTLong((-1295933868), 233094404), new $c_RTLong(1538082581, 1380349269), new $c_RTLong((-1895740554), 1474965712), new $c_RTLong(2089459524, 1104279415), new $c_RTLong(201394476, 1179972570), new $c_RTLong((-951832057), 1766847064), new $c_RTLong(1181224620, 599465923), new $c_RTLong((-761465646), 1413477651), new $c_RTLong((-773007222), 1338566197), new $c_RTLong(1967807861, 1130782121), new $c_RTLong((-1477399237), 641356228), new $c_RTLong(1430505659, 1809251394), new $c_RTLong(1931128516, 1455666695), new $c_RTLong(2003397986, 1447401115), new $c_RTLong((-1891071024), 2023526815), new $c_RTLong(1602718389, 1157920892), new $c_RTLong((-653863360), 1189324722), new $c_RTLong((-871624414), 1852673427), new $c_RTLong(1530799002, 1043926097), new $c_RTLong(1020687387, 1482138742), new $c_RTLong(2083632661, 1264637607), new $c_RTLong((-901437009), 1185710993), new $c_RTLong((-1769067708), 1441206815), new $c_RTLong(275687705, 1897137590), new $c_RTLong((-253527955), 158447256), new $c_RTLong(220550164, 1517710072), new $c_RTLong((-1920809283), 126757805), new $c_RTLong((-1541546788), 1214168057), new $c_RTLong((-677653967), 1819393162), new $c_RTLong(969498977, 1942668892), new $c_RTLong((-1943239806), 763545412), new $c_RTLong((-942387737), 1554135113), new $c_RTLong((-1554591845), 1040333059), new $c_RTLong(105083269, 1243308091), new $c_RTLong((-2102666935), 2120756636), new $c_RTLong((-1549853687), 1989292945), new $c_RTLong(1789693659, 1245726970), new $c_RTLong((-2098876409), 1591434356), new $c_RTLong((-286231991), 1426078305), new $c_RTLong(897879250, 1273147485), new $c_RTLong((-228985593), 1999856103), new $c_RTLong(1436606801, 2037035976), new $c_RTLong(1351609969, 1052286118), new $c_RTLong(290291981, 1629628781), new $c_RTLong(1940281435, 2130319083), new $c_RTLong((-626759874), 1303703024), new $c_RTLong((-1883748689), 845261807), new $c_RTLong((-1002815798), 2085924839), new $c_RTLong((-437017525), 493425432), new $c_RTLong((-802252639), 1668739871), new $c_RTLong(509379439, 1683230535), new $c_RTLong(1935178267, 1334991897), new $c_RTLong(1266497011, 58094239), new $c_RTLong((-339688610), 2135987035), new $c_RTLong(308408299, 951944242), new $c_RTLong((-1130744347), 1708789628), new $c_RTLong(246726639, 332058664), new $c_RTLong((-45602019), 1367031702), new $c_RTLong(197381311, 1554137120), new $c_RTLong(1681505303, 1093625362), new $c_RTLong((-1560081869), 1672806425), new $c_RTLong((-745565351), 1749800579), new $c_RTLong(80849386, 529006633), new $c_RTLong((-596452281), 1399840463), new $c_RTLong(64679509, 852702036), new $c_RTLong(381831634, 1119872371), new $c_RTLong(51743607, 1541155088), new $c_RTLong((-1107056303), 1791795793), new $c_RTLong((-776203688), 318364492), new $c_RTLong((-26651584), 1433436634), new $c_RTLong((-1479956409), 1972678512), new $c_RTLong((-21321267), 1146749307), new $c_RTLong((-2042958586), 1148646080), new $c_RTLong((-893107486), 1834798892), new $c_RTLong((-1550746820), 978840269), new $c_RTLong(1003500929, 1467839114), new $c_RTLong((-2099590915), 2071562404), new $c_RTLong(1661794203, 1174271291), new $c_RTLong((-820679273), 368759734), new $c_RTLong(940883806, 1878834066), new $c_RTLong((-454093378), 1449009034), new $c_RTLong((-106286414), 1503067252), new $c_RTLong((-1222268161), 300213768), new $c_RTLong(1632957787, 1202453802), new $c_RTLong((-1836807988), 669667744), new $c_RTLong((-823241378), 1923926083), new $c_RTLong((-2079899322), 1930461850), new $c_RTLong(200400357, 1539140867), new $c_RTLong((-804925998), 1114872750), new $c_RTLong((-1557666633), 1231312693), new $c_RTLong(1074046120, 1321394930), new $c_RTLong((-774279694), 1970100309), new $c_RTLong(859480332, 1255238429), new $c_RTLong((-619423755), 1576080247), new $c_RTLong((-1030402653), 574694013), new $c_RTLong(1222447914, 1260864198), new $c_RTLong(893664796, 1318748670), new $c_RTLong(1096923204, 2017382717), new $c_RTLong((-288123244), 392010953), new $c_RTLong((-840448356), 1613906173), new $c_RTLong((-1948485514), 2031595681), new $c_RTLong(186634775, 1291124939), new $c_RTLong(1877185426, 336786356), new $c_RTLong(2016602558, 2065799902), new $c_RTLong(2144503222, 1397851629), new $c_RTLong((-104704872), 1652639921), new $c_RTLong((-1720371259), 1118281303), new $c_RTLong((-1801750816), 1322111937), new $c_RTLong((-517303548), 894625042), new $c_RTLong(553172531, 2115379100), new $c_RTLong(890301241, 1860896798), new $c_RTLong(442538025, 1692303280), new $c_RTLong((-146752466), 1059220708), new $c_RTLong(354030420, 1353842624), new $c_RTLong(741591486, 847376567), new $c_RTLong(1142217795, 1083074099), new $c_RTLong(1452266648, 1107397983), new $c_RTLong((-749431905), 1732918558), new $c_RTLong((-1971340659), 483346584), new $c_RTLong(259447935, 1386334847), new $c_RTLong(999907851, 816173997), new $c_RTLong((-1510428571), 1109067877), new $c_RTLong((-1777054097), 1941429386), new $c_RTLong(1019288124, 1774508604), new $c_RTLong(592687281, 1388300100), new $c_RTLong(1674423958, 1419606883), new $c_RTLong(1333143284, 1969633539), new $c_RTLong((-1237441211), 1135685506), new $c_RTLong((-651472291), 1146210101), new $c_RTLong((-1120912478), 1817096810), new $c_RTLong((-1042355666), 974942703), new $c_RTLong((-1755723442), 1453677448), new $c_RTLong(884102386, 1638947622), new $c_RTLong((-545585294), 1162941958), new $c_RTLong((-1869698469), 452164638), new $c_RTLong(845050448, 1860707134), new $c_RTLong((-1273530632), 723463421), new $c_RTLong(1535033817, 1488565707), new $c_RTLong(699162413, 1867260926), new $c_RTLong((-489959865), 1190852565), new $c_RTLong((-2017650447), 1923305470), new $c_RTLong(1793044595, 1905364105), new $c_RTLong((-1510253797), 70811645), new $c_RTLong(1434435676, 1524291284), new $c_RTLong((-2067196497), 56649316), new $c_RTLong(2006542000, 1219433027), new $c_RTLong(923223180, 45319453), new $c_RTLong((-225506637), 1951092843), new $c_RTLong((-1099823290), 502007854), new $c_RTLong(678588149, 1560874275), new $c_RTLong((-1738852091), 1690096472), new $c_RTLong(542870519, 1248699420), new $c_RTLong((-1391081672), 1781573907), new $c_RTLong(868592831, 1997919072), new $c_RTLong(2069236620, 1562028063), new $c_RTLong((-1023112654), 1598335257), new $c_RTLong((-62597623), 2108615909), new $c_RTLong(899496795, 1278668206), new $c_RTLong((-1768065016), 2116389457), new $c_RTLong((-278792045), 2045869129), new $c_RTLong((-251923649), 379746024), new $c_RTLong((-223033636), 1636695303), new $c_RTLong((-201538919), 303796819), new $c_RTLong(680566550, 1309356243), new $c_RTLong(697762324, 1102030915), new $c_RTLong(229913021, 2094969989), new $c_RTLong((-1460560659), 1333752734), new $c_RTLong(1042923876, 1675975991), new $c_RTLong((-1168448527), 1067002187), new $c_RTLong((-24654359), 1340780792), new $c_RTLong((-75765363), 2142091938), new $c_RTLong((-898440433), 2145249268), new $c_RTLong((-1839211499), 2138856913), new $c_RTLong(140241113, 1716199415), new $c_RTLong(1105611179, 1281588801), new $c_RTLong(112192890, 1372959532), new $c_RTLong(884488943, 1884264500), new $c_RTLong((-1628232606), 1098367625), new $c_RTLong((-151402305), 648418140), new $c_RTLong((-28191792), 1757388200), new $c_RTLong((-1960230606), 1037469025), new $c_RTLong((-881546893), 1405910560), new $c_RTLong(149802434, 1259471950), new $c_RTLong((-1564230974), 1124728448), new $c_RTLong(978835406, 1866571019), new $c_RTLong((-784782639), 1799565517), new $c_RTLong((-1010843728), 839029982), new $c_RTLong(1090160807, 1439652414), new $c_RTLong((-808674982), 1100720715), new $c_RTLong(1731122105, 1151721931), new $c_RTLong(212053473, 451079843), new $c_RTLong(1051808449, 1842755090), new $c_RTLong((-1378701361), 2010217937), new $c_RTLong(841446759, 1474204072), new $c_RTLong((-1102961089), 2037671079), new $c_RTLong((-1044829511), 1179363257), new $c_RTLong(835618047, 1200640134), new $c_RTLong(1764246620, 1886981212), new $c_RTLong(1336988876, 203037296), new $c_RTLong((-306589623), 1509584969), new $c_RTLong((-648395818), 1450920025), new $c_RTLong((-245271698), 1207667975), new $c_RTLong(2058263723, 301742561), new $c_RTLong((-2110421635), 1932268761), new $c_RTLong((-1001745339), 53291368), new $c_RTLong(888643069, 1545815009), new $c_RTLong((-801396271), 1331123283), new $c_RTLong(1569907914, 1236652007), new $c_RTLong(1076869902, 1923892086), new $c_RTLong((-924121173), 1978643211), new $c_RTLong((-853988535), 71750230), new $c_RTLong(1837683439, 1582914569), new $c_RTLong(1034796090, 486896914), new $c_RTLong((-1965827086), 1266331655), new $c_RTLong((-1749143505), 1248510990), new $c_RTLong((-568342960), 2026130648), new $c_RTLong((-221649231), 1997617584), new $c_RTLong(404319091, 1620904519), new $c_RTLong((-1895306303), 2027590797), new $c_RTLong(1182448732, 1296723615), new $c_RTLong(201741876, 1622072638), new $c_RTLong(1891917972, 2074757784), new $c_RTLong(2040773920, 877329302), new $c_RTLong((-1922439459), 1659806227), new $c_RTLong(1632619136, 272366712), new $c_RTLong(180035351, 1327844982), new $c_RTLong((-2129878528), 647390099), new $c_RTLong(1147050021, 2124551971), new $c_RTLong((-1689818727), 606327429), new $c_RTLong(58646557, 1699641577), new $c_RTLong(2084118856, 1773552132), new $c_RTLong((-1671069673), 1359713261), new $c_RTLong((-1768678752), 1848338435), new $c_RTLong(1240124639, 1087770609), new $c_RTLong(303043917, 1908167478), new $c_RTLong((-592780954), 1740432974), new $c_RTLong(1343863726, 476087587), new $c_RTLong((-474224764), 1392346379), new $c_RTLong(1075090981, 2098856988), new $c_RTLong((-379379811), 1113877103), new $c_RTLong(1079325, 1249588861), new $c_RTLong(1110979221, 1782203366), new $c_RTLong(1726920, 1569845448), new $c_RTLong(29789918, 1425762693), new $c_RTLong(860374996, 396882899), new $c_RTLong(1741818852, 1140610154), new $c_RTLong((-1029686922), 2035493237), new $c_RTLong(209929787, 1824976247), new $c_RTLong(929481302, 250312073), new $c_RTLong((-1550043089), 1459980997), new $c_RTLong(743585042, 629746388), new $c_RTLong(477952447, 1167984798), new $c_RTLong(594868034, 933293840), new $c_RTLong((-94269544), 1868775676), new $c_RTLong(951788854, 1493270144), new $c_RTLong((-1793402554), 1495020541), new $c_RTLong((-1815549295), 2053609574), new $c_RTLong(1142258335, 1196016433), new $c_RTLong((-593445976), 354397470), new $c_RTLong(968619877, 1913626293), new $c_RTLong((-949513563), 137539223), new $c_RTLong((-1802084476), 1530901034), new $c_RTLong(99382609, 110031379), new $c_RTLong((-1441667581), 1224720827), new $c_RTLong((-779487372), 517521832), new $c_RTLong(1129305707, 1959553324), new $c_RTLong(470807123, 1257531662), new $c_RTLong(1762438025, 1567642659), new $c_RTLong(376645699, 576528600), new $c_RTLong((-2026023417), 1254114127), new $c_RTLong((-1416670359), 890719609), new $c_RTLong(194336370, 2006582604), new $c_RTLong(1169301262, 566157916), new $c_RTLong(1014462555, 1605266083), new $c_RTLong((-1641539368), 882423062), new $c_RTLong((-1765410334), 1284212866), new $c_RTLong(1263748883, 1564931909), new $c_RTLong((-1965663075), 2054740586), new $c_RTLong(1163004754, 2074394325), new $c_RTLong(1004449918, 1643792469), new $c_RTLong(71410344, 800522001), new $c_RTLong(1662553393, 1315033975), new $c_RTLong((-1660858643), 1928907789), new $c_RTLong((-1634881866), 2104054360), new $c_RTLong((-939386911), 509272085), new $c_RTLong(2128068344, 1683243488), new $c_RTLong((-1610502988), 407417668), new $c_RTLong((-874525703), 1346594790), new $c_RTLong((-1288402390), 1614424323), new $c_RTLong((-1558614021), 1077275832), new $c_RTLong(687265006, 3049270), new $c_RTLong(942191403, 1723641332), new $c_RTLong((-618362909), 434375561), new $c_RTLong((-964233796), 1378913065), new $c_RTLong(2082290051, 347500449), new $c_RTLong((-1630380496), 1103130452), new $c_RTLong((-1770141796), 278000359), new $c_RTLong(827365043, 1765008724), new $c_RTLong((-255246497), 874297304), new $c_RTLong(1520885493, 1412006979), new $c_RTLong((-1063190656), 1987928032), new $c_RTLong(2075701854, 1129605583), new $c_RTLong(8440934, 731348967), new $c_RTLong((-1832837789), 1807368933), new $c_RTLong((-845487965), 1599655076), new $c_RTLong((-607276772), 1445895146), new $c_RTLong(1900590006, 1279724061), new $c_RTLong(2091158960, 1156716117), new $c_RTLong(661478546, 1023779249), new $c_RTLong((-90119501), 1850745787), new $c_RTLong(1058365673, 2067543528), new $c_RTLong(1645891318, 1480596630), new $c_RTLong(1705685997, 795041363), new $c_RTLong(1316713054, 1184477304), new $c_RTLong((-353438120), 1495026549), new $c_RTLong((-470239491), 1895163686), new $c_RTLong(1152485926, 1962545750), new $c_RTLong((-2094178511), 1516130949), new $c_RTLong((-1654991637), 1140539870), new $c_RTLong((-1675342809), 1212904759), new $c_RTLong(393993609, 1341928626), new $c_RTLong(1614418802, 1940647615), new $c_RTLong((-1946590604), 1288092342), new $c_RTLong(1291535042, 1552518092), new $c_RTLong((-698279024), 171480414), new $c_RTLong((-684758885), 1242014473), new $c_RTLong(2018357159, 566681061), new $c_RTLong(622372702, 1987223158), new $c_RTLong((-1924589301), 1765683157), new $c_RTLong((-2079082216), 1589778526), new $c_RTLong(178315477, 1412546526), new $c_RTLong(913714605, 1271822821), new $c_RTLong(1001645841, 700540491), new $c_RTLong((-256043550), 2034916513), new $c_RTLong((-974347032), 261871326), new $c_RTLong(654158619, 1627933211), new $c_RTLong(79515834, 638993791), new $c_RTLong((-335666564), 1302346568), new $c_RTLong((-795380792), 511195032), new $c_RTLong(1180920416, 2083754510), new $c_RTLong((-2131602727), 817912052), new $c_RTLong(944736333, 1667003608), new $c_RTLong(1730691655, 224832912), new $c_RTLong((-1821191312), 1333602886), new $c_RTLong(1384553324, 1897853248), new $c_RTLong((-2054912639), 2133764618), new $c_RTLong(1356291860, 889081549), new $c_RTLong((-784936652), 1707011694), new $c_RTLong(1944026947, 711265239), new $c_RTLong((-627949322), 1365609355), new $c_RTLong((-1021758820), 1428005650), new $c_RTLong((-1361352917), 1092487484), new $c_RTLong(900579863, 1571901250), new $c_RTLong(2116802629, 1747979975), new $c_RTLong((-1136052598), 2085545270), new $c_RTLong(1693442103, 1398383980), new $c_RTLong(809144840, 2097932946), new $c_RTLong(1354753683, 1118707184), new $c_RTLong(647315872, 389856168), new $c_RTLong((-409374485), 1789931494), new $c_RTLong((-1541274982), 1053266598), new $c_RTLong((-327499588), 1431945195), new $c_RTLong((-374026527), 842613278), new $c_RTLong((-1120993130), 1145556156), new $c_RTLong(1418765697, 1533084082), new $c_RTLong((-934595548), 1832889850), new $c_RTLong(1411031656, 734947613), new $c_RTLong((-1606669898), 1466311880), new $c_RTLong((-589161593), 1446951549), new $c_RTLong((-2144329378), 1173049504), new $c_RTLong(387664185, 2016554699), new $c_RTLong(864040292, 1876879207), new $c_RTLong(620262695, 1508500600), new $c_RTLong((-1026754685), 1501503365), new $c_RTLong((-1221776762), 1636297209), new $c_RTLong((-1680397207), 1201202692), new $c_RTLong(740565509, 879541038), new $c_RTLong(747338306, 1921924308), new $c_RTLong((-533082105), 548272201), new $c_RTLong((-1979109733), 1537539446), new $c_RTLong(432527775, 868114491), new $c_RTLong(993692591, 1230031557), new $c_RTLong(2064009139, 1123988322), new $c_RTLong((-1846065691), 1968050491), new $c_RTLong(1584427704, 1368884586), new $c_RTLong(1100127825, 1574440393), new $c_RTLong(2126535622, 665610939), new $c_RTLong((-1696878118), 1259552314), new $c_RTLong((-875751880), 1391482210), new $c_RTLong(1579962308, 2015283703), new $c_RTLong((-542209549), 508384618), new $c_RTLong((-1313010532), 1612226962), new $c_RTLong(2143212739, 2124694613), new $c_RTLong(667578493, 1289781570), new $c_RTLong(855576732, 1270258961), new $c_RTLong(1068125589, 2063650512), new $c_RTLong(1368922771, 1602917608), new $c_RTLong((-863486447), 1650920409), new $c_RTLong(236144757, 852837357), new $c_RTLong((-690789158), 1320736327), new $c_RTLong((-670077653), 1541263344), new $c_RTLong((-1964256111), 2113178124), new $c_RTLong((-1072124245), 318537703), new $c_RTLong((-1571404889), 1690542499), new $c_RTLong((-1716692855), 684326892), new $c_RTLong((-1257123911), 1352433999), new $c_RTLong(2062619553, 117964784), new $c_RTLong((-1005699129), 1081947199), new $c_RTLong(791102183, 523868557), new $c_RTLong((-1609118607), 1731115519), new $c_RTLong(1265763492, 2126679880), new $c_RTLong((-1287294885), 1384892415), new $c_RTLong(1871604253, 412853715), new $c_RTLong((-1888829368), 1107913932), new $c_RTLong((-1079696975), 2048269890), new $c_RTLong(413846849, 1772662292), new $c_RTLong(849465217, 1129748177), new $c_RTLong((-1386909439), 1418129833), new $c_RTLong(679572174, 474301812), new $c_RTLong((-250534092), 1134503866), new $c_RTLong((-1174329179), 379441449), new $c_RTLong(458138912, 1815206187), new $c_RTLong((-1878926687), 607106319), new $c_RTLong((-1351475789), 1452164949), new $c_RTLong(1073839028, 915181785), new $c_RTLong((-1081180631), 1161731959), new $c_RTLong((-1717909155), 302648698), new $c_RTLong((-1729889010), 1858771135), new $c_RTLong((-171674271), 1343231376), new $c_RTLong(2052062629, 1487016908), new $c_RTLong((-137339416), 645088371), new $c_RTLong((-935330275), 1189613526), new $c_RTLong(1608115385, 1804560886), new $c_RTLong((-637534980), 1903381642), new $c_RTLong((-862989220), 1169310499), new $c_RTLong(1207958934, 1522705314), new $c_RTLong(168602083, 1794441859), new $c_RTLong(1825360607, 1218164251), new $c_RTLong(1852868585, 147063298), new $c_RTLong(1202590052, 1949062802), new $c_RTLong((-471384101), 1953288195), new $c_RTLong((-755914877), 1559250241), new $c_RTLong(1340879637, 1992127286), new $c_RTLong(1972248476, 1247400193), new $c_RTLong(213710251, 1593701829), new $c_RTLong((-1998363193), 1995840309), new $c_RTLong((-1376050517), 1261432737), new $c_RTLong((-1598690554), 1596672247), new $c_RTLong((-241846955), 150152730), new $c_RTLong(439034475, 1277337798), new $c_RTLong(1524509355, 549618914), new $c_RTLong((-156538299), 2043740476), new $c_RTLong(1580221508, 449893533), new $c_RTLong((-1843217558), 1634992381), new $c_RTLong((-453809712), 1218908285), new $c_RTLong(1102406331, 1307993905), new $c_RTLong(1354939149, 1404623358), new $c_RTLong(1763850130, 2092790248), new $c_RTLong(449915720, 1388403914), new $c_RTLong((-1165900274), 1674232198), new $c_RTLong(2077919494, 1969716590), new $c_RTLong((-73726760), 1339385758), new $c_RTLong(1662335596, 1575773272), new $c_RTLong(1600024103, 2143017214), new $c_RTLong(82756575, 1232747047)]);
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$__f_tenPow18Squares = new ($d_Ljava_math_BigInteger.getArrayOf().constr)([$m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong((-1486618624), 232830643))]);
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$ as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$ };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$.prototype = new $h_O();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$ as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$ };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$.prototype;
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$ = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$, "com.github.plokhotnyuk.jsoniter_scala.core.JsonWriter$", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$ as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$ };
var $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$;
function $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$() {
  if ((!$n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$)) {
    $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$ = new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$();
  }
  return $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$;
}
export { $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$ as $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$ };
/** @constructor */
function $c_Lcom_raquo_airstream_common_InternalParentObserver$() {
}
export { $c_Lcom_raquo_airstream_common_InternalParentObserver$ as $c_Lcom_raquo_airstream_common_InternalParentObserver$ };
$c_Lcom_raquo_airstream_common_InternalParentObserver$.prototype = new $h_O();
$c_Lcom_raquo_airstream_common_InternalParentObserver$.prototype.constructor = $c_Lcom_raquo_airstream_common_InternalParentObserver$;
/** @constructor */
function $h_Lcom_raquo_airstream_common_InternalParentObserver$() {
}
export { $h_Lcom_raquo_airstream_common_InternalParentObserver$ as $h_Lcom_raquo_airstream_common_InternalParentObserver$ };
$h_Lcom_raquo_airstream_common_InternalParentObserver$.prototype = $c_Lcom_raquo_airstream_common_InternalParentObserver$.prototype;
$c_Lcom_raquo_airstream_common_InternalParentObserver$.prototype.fromTry__Lcom_raquo_airstream_core_Observable__F2__Lcom_raquo_airstream_common_InternalParentObserver = (function(parent, onTry) {
  return new $c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2(parent, onTry);
});
var $d_Lcom_raquo_airstream_common_InternalParentObserver$ = new $TypeData().initClass($c_Lcom_raquo_airstream_common_InternalParentObserver$, "com.raquo.airstream.common.InternalParentObserver$", ({
  Lcom_raquo_airstream_common_InternalParentObserver$: 1
}));
export { $d_Lcom_raquo_airstream_common_InternalParentObserver$ as $d_Lcom_raquo_airstream_common_InternalParentObserver$ };
var $n_Lcom_raquo_airstream_common_InternalParentObserver$;
function $m_Lcom_raquo_airstream_common_InternalParentObserver$() {
  if ((!$n_Lcom_raquo_airstream_common_InternalParentObserver$)) {
    $n_Lcom_raquo_airstream_common_InternalParentObserver$ = new $c_Lcom_raquo_airstream_common_InternalParentObserver$();
  }
  return $n_Lcom_raquo_airstream_common_InternalParentObserver$;
}
export { $m_Lcom_raquo_airstream_common_InternalParentObserver$ as $m_Lcom_raquo_airstream_common_InternalParentObserver$ };
/** @constructor */
function $c_Lcom_raquo_airstream_common_Observation(observable, value) {
  this.Lcom_raquo_airstream_common_Observation__f_observable = null;
  this.Lcom_raquo_airstream_common_Observation__f_value = null;
  this.Lcom_raquo_airstream_common_Observation__f_observable = observable;
  this.Lcom_raquo_airstream_common_Observation__f_value = value;
}
export { $c_Lcom_raquo_airstream_common_Observation as $c_Lcom_raquo_airstream_common_Observation };
$c_Lcom_raquo_airstream_common_Observation.prototype = new $h_O();
$c_Lcom_raquo_airstream_common_Observation.prototype.constructor = $c_Lcom_raquo_airstream_common_Observation;
/** @constructor */
function $h_Lcom_raquo_airstream_common_Observation() {
}
export { $h_Lcom_raquo_airstream_common_Observation as $h_Lcom_raquo_airstream_common_Observation };
$h_Lcom_raquo_airstream_common_Observation.prototype = $c_Lcom_raquo_airstream_common_Observation.prototype;
var $d_Lcom_raquo_airstream_common_Observation = new $TypeData().initClass($c_Lcom_raquo_airstream_common_Observation, "com.raquo.airstream.common.Observation", ({
  Lcom_raquo_airstream_common_Observation: 1
}));
export { $d_Lcom_raquo_airstream_common_Observation as $d_Lcom_raquo_airstream_common_Observation };
var $d_Lcom_raquo_airstream_core_InternalObserver = new $TypeData().initClass(1, "com.raquo.airstream.core.InternalObserver", ({
  Lcom_raquo_airstream_core_InternalObserver: 1
}));
export { $d_Lcom_raquo_airstream_core_InternalObserver as $d_Lcom_raquo_airstream_core_InternalObserver };
function $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T($thiz) {
  return (($objectGetClass($thiz).getSimpleName__T() + "@") + $thiz.hashCode__I());
}
export { $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T as $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T };
function $f_Lcom_raquo_airstream_core_Named__displayName__T($thiz) {
  var x = $thiz.maybeDisplayName__O();
  return ((x === (void 0)) ? $thiz.defaultDisplayName__T() : x);
}
export { $f_Lcom_raquo_airstream_core_Named__displayName__T as $f_Lcom_raquo_airstream_core_Named__displayName__T };
function $f_Lcom_raquo_airstream_core_Named__setDisplayName__T__Lcom_raquo_airstream_core_Named($thiz, name) {
  $thiz.maybeDisplayName_$eq__O__V(name);
  return $thiz;
}
export { $f_Lcom_raquo_airstream_core_Named__setDisplayName__T__Lcom_raquo_airstream_core_Named as $f_Lcom_raquo_airstream_core_Named__setDisplayName__T__Lcom_raquo_airstream_core_Named };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$() {
  this.Lcom_raquo_airstream_core_Observer$__f__empty = null;
  $n_Lcom_raquo_airstream_core_Observer$ = this;
  var this$2 = $m_Lcom_raquo_airstream_core_Observer$();
  var onNext = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => (void 0)));
  this.Lcom_raquo_airstream_core_Observer$__f__empty = this$2.withRecover__F1__s_PartialFunction__Z__Lcom_raquo_airstream_core_Observer(onNext, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf, true);
}
export { $c_Lcom_raquo_airstream_core_Observer$ as $c_Lcom_raquo_airstream_core_Observer$ };
$c_Lcom_raquo_airstream_core_Observer$.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_Observer$.prototype.constructor = $c_Lcom_raquo_airstream_core_Observer$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$() {
}
export { $h_Lcom_raquo_airstream_core_Observer$ as $h_Lcom_raquo_airstream_core_Observer$ };
$h_Lcom_raquo_airstream_core_Observer$.prototype = $c_Lcom_raquo_airstream_core_Observer$.prototype;
$c_Lcom_raquo_airstream_core_Observer$.prototype.withRecover__F1__s_PartialFunction__Z__Lcom_raquo_airstream_core_Observer = (function(onNext, onError, handleObserverErrors) {
  return new $c_Lcom_raquo_airstream_core_Observer$$anon$8(onNext, handleObserverErrors, onError);
});
$c_Lcom_raquo_airstream_core_Observer$.prototype.fromTry__s_PartialFunction__Z__Lcom_raquo_airstream_core_Observer = (function(onTry, handleObserverErrors) {
  return new $c_Lcom_raquo_airstream_core_Observer$$anon$9(onTry, handleObserverErrors);
});
var $d_Lcom_raquo_airstream_core_Observer$ = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Observer$, "com.raquo.airstream.core.Observer$", ({
  Lcom_raquo_airstream_core_Observer$: 1
}));
export { $d_Lcom_raquo_airstream_core_Observer$ as $d_Lcom_raquo_airstream_core_Observer$ };
var $n_Lcom_raquo_airstream_core_Observer$;
function $m_Lcom_raquo_airstream_core_Observer$() {
  if ((!$n_Lcom_raquo_airstream_core_Observer$)) {
    $n_Lcom_raquo_airstream_core_Observer$ = new $c_Lcom_raquo_airstream_core_Observer$();
  }
  return $n_Lcom_raquo_airstream_core_Observer$;
}
export { $m_Lcom_raquo_airstream_core_Observer$ as $m_Lcom_raquo_airstream_core_Observer$ };
/** @constructor */
function $c_Lcom_raquo_airstream_core_ObserverList$() {
}
export { $c_Lcom_raquo_airstream_core_ObserverList$ as $c_Lcom_raquo_airstream_core_ObserverList$ };
$c_Lcom_raquo_airstream_core_ObserverList$.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_ObserverList$.prototype.constructor = $c_Lcom_raquo_airstream_core_ObserverList$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_ObserverList$() {
}
export { $h_Lcom_raquo_airstream_core_ObserverList$ as $h_Lcom_raquo_airstream_core_ObserverList$ };
$h_Lcom_raquo_airstream_core_ObserverList$.prototype = $c_Lcom_raquo_airstream_core_ObserverList$.prototype;
$c_Lcom_raquo_airstream_core_ObserverList$.prototype.removeObserverNow$extension__Lcom_raquo_ew_JsArray__O__Z = (function(this$, observer) {
  var index = (this$.indexOf(observer) | 0);
  var shouldRemove = (index !== (-1));
  if (shouldRemove) {
    this$.splice(index, 1);
  }
  return shouldRemove;
});
var $d_Lcom_raquo_airstream_core_ObserverList$ = new $TypeData().initClass($c_Lcom_raquo_airstream_core_ObserverList$, "com.raquo.airstream.core.ObserverList$", ({
  Lcom_raquo_airstream_core_ObserverList$: 1
}));
export { $d_Lcom_raquo_airstream_core_ObserverList$ as $d_Lcom_raquo_airstream_core_ObserverList$ };
var $n_Lcom_raquo_airstream_core_ObserverList$;
function $m_Lcom_raquo_airstream_core_ObserverList$() {
  if ((!$n_Lcom_raquo_airstream_core_ObserverList$)) {
    $n_Lcom_raquo_airstream_core_ObserverList$ = new $c_Lcom_raquo_airstream_core_ObserverList$();
  }
  return $n_Lcom_raquo_airstream_core_ObserverList$;
}
export { $m_Lcom_raquo_airstream_core_ObserverList$ as $m_Lcom_raquo_airstream_core_ObserverList$ };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Protected() {
}
export { $c_Lcom_raquo_airstream_core_Protected as $c_Lcom_raquo_airstream_core_Protected };
$c_Lcom_raquo_airstream_core_Protected.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_Protected.prototype.constructor = $c_Lcom_raquo_airstream_core_Protected;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Protected() {
}
export { $h_Lcom_raquo_airstream_core_Protected as $h_Lcom_raquo_airstream_core_Protected };
$h_Lcom_raquo_airstream_core_Protected.prototype = $c_Lcom_raquo_airstream_core_Protected.prototype;
var $d_Lcom_raquo_airstream_core_Protected = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Protected, "com.raquo.airstream.core.Protected", ({
  Lcom_raquo_airstream_core_Protected: 1
}));
export { $d_Lcom_raquo_airstream_core_Protected as $d_Lcom_raquo_airstream_core_Protected };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Protected$() {
  this.Lcom_raquo_airstream_core_Protected$__f_protectedAccessEvidence = null;
  $n_Lcom_raquo_airstream_core_Protected$ = this;
  this.Lcom_raquo_airstream_core_Protected$__f_protectedAccessEvidence = new $c_Lcom_raquo_airstream_core_Protected();
}
export { $c_Lcom_raquo_airstream_core_Protected$ as $c_Lcom_raquo_airstream_core_Protected$ };
$c_Lcom_raquo_airstream_core_Protected$.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_Protected$.prototype.constructor = $c_Lcom_raquo_airstream_core_Protected$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Protected$() {
}
export { $h_Lcom_raquo_airstream_core_Protected$ as $h_Lcom_raquo_airstream_core_Protected$ };
$h_Lcom_raquo_airstream_core_Protected$.prototype = $c_Lcom_raquo_airstream_core_Protected$.prototype;
$c_Lcom_raquo_airstream_core_Protected$.prototype.maxTopoRank__Lcom_raquo_airstream_core_Observable__Lcom_raquo_ew_JsArray__I = (function(observable, observables) {
  return this.maxTopoRank__I__Lcom_raquo_ew_JsArray__I(observable.topoRank__I(), observables);
});
$c_Lcom_raquo_airstream_core_Protected$.prototype.maxTopoRank__I__Lcom_raquo_ew_JsArray__I = (function(minRank, observables) {
  var elem = 0;
  elem = minRank;
  var i = 0;
  var len = (observables.length | 0);
  while ((i < len)) {
    var observable = observables[i];
    var rank = observable.topoRank__I();
    if ((rank > elem)) {
      elem = rank;
    }
    i = ((1 + i) | 0);
  }
  return elem;
});
var $d_Lcom_raquo_airstream_core_Protected$ = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Protected$, "com.raquo.airstream.core.Protected$", ({
  Lcom_raquo_airstream_core_Protected$: 1
}));
export { $d_Lcom_raquo_airstream_core_Protected$ as $d_Lcom_raquo_airstream_core_Protected$ };
var $n_Lcom_raquo_airstream_core_Protected$;
function $m_Lcom_raquo_airstream_core_Protected$() {
  if ((!$n_Lcom_raquo_airstream_core_Protected$)) {
    $n_Lcom_raquo_airstream_core_Protected$ = new $c_Lcom_raquo_airstream_core_Protected$();
  }
  return $n_Lcom_raquo_airstream_core_Protected$;
}
export { $m_Lcom_raquo_airstream_core_Protected$ as $m_Lcom_raquo_airstream_core_Protected$ };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction(code) {
  this.Lcom_raquo_airstream_core_Transaction__f_code = null;
  this.Lcom_raquo_airstream_core_Transaction__f_maybePendingObservables = null;
  this.Lcom_raquo_airstream_core_Transaction__f_depth = 0;
  this.Lcom_raquo_airstream_core_Transaction__f_code = code;
  this.Lcom_raquo_airstream_core_Transaction__f_maybePendingObservables = (void 0);
  var x = $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().peekStack__O();
  this.Lcom_raquo_airstream_core_Transaction__f_depth = ((x === (void 0)) ? 1 : ((1 + x.Lcom_raquo_airstream_core_Transaction__f_depth) | 0));
  if ((($m_Lcom_raquo_airstream_core_Transaction$().Lcom_raquo_airstream_core_Transaction$__f_maxDepth === (-1)) || (this.Lcom_raquo_airstream_core_Transaction__f_depth > $m_Lcom_raquo_airstream_core_Transaction$().Lcom_raquo_airstream_core_Transaction$__f_maxDepth))) {
    var $x_1 = $m_Lcom_raquo_airstream_core_AirstreamError$();
    var depth = $m_Lcom_raquo_airstream_core_Transaction$().Lcom_raquo_airstream_core_Transaction$__f_maxDepth;
    $x_1.sendUnhandledError__jl_Throwable__V(new $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded(this, depth));
  } else if ($m_Lcom_raquo_airstream_core_Transaction$onStart$().Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart) {
    ($m_Lcom_raquo_airstream_core_Transaction$onStart$().Lcom_raquo_airstream_core_Transaction$onStart$__f_postStartTransactions.push(this) | 0);
  } else {
    $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().add__Lcom_raquo_airstream_core_Transaction__V(this);
  }
}
export { $c_Lcom_raquo_airstream_core_Transaction as $c_Lcom_raquo_airstream_core_Transaction };
$c_Lcom_raquo_airstream_core_Transaction.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_Transaction.prototype.constructor = $c_Lcom_raquo_airstream_core_Transaction;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction() {
}
export { $h_Lcom_raquo_airstream_core_Transaction as $h_Lcom_raquo_airstream_core_Transaction };
$h_Lcom_raquo_airstream_core_Transaction.prototype = $c_Lcom_raquo_airstream_core_Transaction.prototype;
$c_Lcom_raquo_airstream_core_Transaction.prototype.containsPendingObservable__Lcom_raquo_airstream_core_SyncObservable__Z = (function(observable) {
  var x = this.Lcom_raquo_airstream_core_Transaction__f_maybePendingObservables;
  if ((x === (void 0))) {
    var x$1 = (void 0);
  } else {
    var a = x.contains__O__Z(observable);
    var x$1 = a;
  }
  return ((x$1 === (void 0)) ? false : x$1);
});
$c_Lcom_raquo_airstream_core_Transaction.prototype.enqueuePendingObservable__Lcom_raquo_airstream_core_SyncObservable__V = (function(observable) {
  var x = this.Lcom_raquo_airstream_core_Transaction__f_maybePendingObservables;
  if ((x === (void 0))) {
    var newQueue = new $c_Lcom_raquo_airstream_util_JsPriorityQueue(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((observable$1) => observable$1.topoRank__I())));
    this.Lcom_raquo_airstream_core_Transaction__f_maybePendingObservables = newQueue;
    var $x_1 = newQueue;
  } else {
    var $x_1 = x;
  }
  var queue = $x_1;
  queue.enqueue__O__V(observable);
});
var $d_Lcom_raquo_airstream_core_Transaction = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Transaction, "com.raquo.airstream.core.Transaction", ({
  Lcom_raquo_airstream_core_Transaction: 1
}));
export { $d_Lcom_raquo_airstream_core_Transaction as $d_Lcom_raquo_airstream_core_Transaction };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction$() {
  this.Lcom_raquo_airstream_core_Transaction$__f_maxDepth = 0;
  this.Lcom_raquo_airstream_core_Transaction$__f_com$raquo$airstream$core$Transaction$$$throwDeadTrxError = null;
  $n_Lcom_raquo_airstream_core_Transaction$ = this;
  this.Lcom_raquo_airstream_core_Transaction$__f_maxDepth = 1000;
  this.Lcom_raquo_airstream_core_Transaction$__f_com$raquo$airstream$core$Transaction$$$throwDeadTrxError = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((trx) => {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), (("Attempted to run Transaction " + trx) + " after it was already executed."));
  }));
}
export { $c_Lcom_raquo_airstream_core_Transaction$ as $c_Lcom_raquo_airstream_core_Transaction$ };
$c_Lcom_raquo_airstream_core_Transaction$.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_Transaction$.prototype.constructor = $c_Lcom_raquo_airstream_core_Transaction$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction$() {
}
export { $h_Lcom_raquo_airstream_core_Transaction$ as $h_Lcom_raquo_airstream_core_Transaction$ };
$h_Lcom_raquo_airstream_core_Transaction$.prototype = $c_Lcom_raquo_airstream_core_Transaction$.prototype;
$c_Lcom_raquo_airstream_core_Transaction$.prototype.com$raquo$airstream$core$Transaction$$$run__Lcom_raquo_airstream_core_Transaction__V = (function(transaction) {
  try {
    transaction.Lcom_raquo_airstream_core_Transaction__f_code.apply__O__O(transaction);
    var x = transaction.Lcom_raquo_airstream_core_Transaction__f_maybePendingObservables;
    if ((x !== (void 0))) {
      while (((x.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue.length | 0) !== 0)) {
        if (((x.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue.length | 0) === 0)) {
          throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Unable to dequeue an empty JsPriorityQueue");
        }
        x.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue.shift().syncFire__Lcom_raquo_airstream_core_Transaction__V(transaction);
      }
    }
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    $m_Lcom_raquo_airstream_core_AirstreamError$().sendUnhandledError__jl_Throwable__V(e$2);
  }
});
var $d_Lcom_raquo_airstream_core_Transaction$ = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Transaction$, "com.raquo.airstream.core.Transaction$", ({
  Lcom_raquo_airstream_core_Transaction$: 1
}));
export { $d_Lcom_raquo_airstream_core_Transaction$ as $d_Lcom_raquo_airstream_core_Transaction$ };
var $n_Lcom_raquo_airstream_core_Transaction$;
function $m_Lcom_raquo_airstream_core_Transaction$() {
  if ((!$n_Lcom_raquo_airstream_core_Transaction$)) {
    $n_Lcom_raquo_airstream_core_Transaction$ = new $c_Lcom_raquo_airstream_core_Transaction$();
  }
  return $n_Lcom_raquo_airstream_core_Transaction$;
}
export { $m_Lcom_raquo_airstream_core_Transaction$ as $m_Lcom_raquo_airstream_core_Transaction$ };
function $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V($thiz) {
  if ((($thiz.Lcom_raquo_airstream_core_Transaction$onStart$__f_com$raquo$airstream$core$Transaction$onStart$$$pendingCallbacks.length | 0) === 0)) {
    if ((($thiz.Lcom_raquo_airstream_core_Transaction$onStart$__f_postStartTransactions.length | 0) > 0)) {
      var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => {
        while ((($m_Lcom_raquo_airstream_core_Transaction$onStart$().Lcom_raquo_airstream_core_Transaction$onStart$__f_postStartTransactions.length | 0) > 0)) {
          $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().add__Lcom_raquo_airstream_core_Transaction__V($m_Lcom_raquo_airstream_core_Transaction$onStart$().Lcom_raquo_airstream_core_Transaction$onStart$__f_postStartTransactions.shift());
        }
      }));
      new $c_Lcom_raquo_airstream_core_Transaction(code);
    }
  } else {
    var code$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((trx) => {
      while ((($m_Lcom_raquo_airstream_core_Transaction$onStart$().Lcom_raquo_airstream_core_Transaction$onStart$__f_com$raquo$airstream$core$Transaction$onStart$$$pendingCallbacks.length | 0) > 0)) {
        var callback = $m_Lcom_raquo_airstream_core_Transaction$onStart$().Lcom_raquo_airstream_core_Transaction$onStart$__f_com$raquo$airstream$core$Transaction$onStart$$$pendingCallbacks.shift();
        try {
          callback.apply__O__O(trx);
        } catch (e) {
          var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
          $m_Lcom_raquo_airstream_core_AirstreamError$().sendUnhandledError__jl_Throwable__V(e$2);
        }
      }
      while ((($m_Lcom_raquo_airstream_core_Transaction$onStart$().Lcom_raquo_airstream_core_Transaction$onStart$__f_postStartTransactions.length | 0) > 0)) {
        var _trx = $m_Lcom_raquo_airstream_core_Transaction$onStart$().Lcom_raquo_airstream_core_Transaction$onStart$__f_postStartTransactions.shift();
        $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().add__Lcom_raquo_airstream_core_Transaction__V(_trx);
      }
    }));
    new $c_Lcom_raquo_airstream_core_Transaction(code$1);
  }
}
export { $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V as $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction$onStart$() {
  this.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = false;
  this.Lcom_raquo_airstream_core_Transaction$onStart$__f_com$raquo$airstream$core$Transaction$onStart$$$pendingCallbacks = null;
  this.Lcom_raquo_airstream_core_Transaction$onStart$__f_postStartTransactions = null;
  $n_Lcom_raquo_airstream_core_Transaction$onStart$ = this;
  this.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = false;
  this.Lcom_raquo_airstream_core_Transaction$onStart$__f_com$raquo$airstream$core$Transaction$onStart$$$pendingCallbacks = $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_F1.getArrayOf().constr)([])));
  this.Lcom_raquo_airstream_core_Transaction$onStart$__f_postStartTransactions = $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_core_Transaction.getArrayOf().constr)([])));
}
export { $c_Lcom_raquo_airstream_core_Transaction$onStart$ as $c_Lcom_raquo_airstream_core_Transaction$onStart$ };
$c_Lcom_raquo_airstream_core_Transaction$onStart$.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_Transaction$onStart$.prototype.constructor = $c_Lcom_raquo_airstream_core_Transaction$onStart$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction$onStart$() {
}
export { $h_Lcom_raquo_airstream_core_Transaction$onStart$ as $h_Lcom_raquo_airstream_core_Transaction$onStart$ };
$h_Lcom_raquo_airstream_core_Transaction$onStart$.prototype = $c_Lcom_raquo_airstream_core_Transaction$onStart$.prototype;
$c_Lcom_raquo_airstream_core_Transaction$onStart$.prototype.add__F1__V = (function(callback) {
  this.Lcom_raquo_airstream_core_Transaction$onStart$__f_com$raquo$airstream$core$Transaction$onStart$$$pendingCallbacks.push(callback);
});
var $d_Lcom_raquo_airstream_core_Transaction$onStart$ = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Transaction$onStart$, "com.raquo.airstream.core.Transaction$onStart$", ({
  Lcom_raquo_airstream_core_Transaction$onStart$: 1
}));
export { $d_Lcom_raquo_airstream_core_Transaction$onStart$ as $d_Lcom_raquo_airstream_core_Transaction$onStart$ };
var $n_Lcom_raquo_airstream_core_Transaction$onStart$;
function $m_Lcom_raquo_airstream_core_Transaction$onStart$() {
  if ((!$n_Lcom_raquo_airstream_core_Transaction$onStart$)) {
    $n_Lcom_raquo_airstream_core_Transaction$onStart$ = new $c_Lcom_raquo_airstream_core_Transaction$onStart$();
  }
  return $n_Lcom_raquo_airstream_core_Transaction$onStart$;
}
export { $m_Lcom_raquo_airstream_core_Transaction$onStart$ as $m_Lcom_raquo_airstream_core_Transaction$onStart$ };
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O($thiz, transaction) {
  return $thiz.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_com$raquo$airstream$core$Transaction$pendingTransactions$$$children.get(transaction);
}
export { $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O as $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O };
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__popStack__O($thiz) {
  return $thiz.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_stack.shift();
}
export { $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__popStack__O as $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__popStack__O };
function $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__dequeueChild__Lcom_raquo_airstream_core_Transaction__O($thiz, parent) {
  var maybeParentChildren = $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O($thiz, parent);
  var x = (((maybeParentChildren === (void 0)) || ((maybeParentChildren.length | 0) > 0)) ? maybeParentChildren : (void 0));
  if ((x === (void 0))) {
    return (void 0);
  } else {
    var nextChild = x.shift();
    if (((x.length | 0) === 0)) {
      (!(!$m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_com$raquo$airstream$core$Transaction$pendingTransactions$$$children.delete(parent)));
    }
    return nextChild;
  }
}
export { $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__dequeueChild__Lcom_raquo_airstream_core_Transaction__O as $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__dequeueChild__Lcom_raquo_airstream_core_Transaction__O };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$() {
  this.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_stack = null;
  this.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_com$raquo$airstream$core$Transaction$pendingTransactions$$$children = null;
  $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ = this;
  this.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_stack = $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_core_Transaction.getArrayOf().constr)([])));
  this.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_com$raquo$airstream$core$Transaction$pendingTransactions$$$children = new Map();
}
export { $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ as $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ };
$c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype.constructor = $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Transaction$pendingTransactions$() {
}
export { $h_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ as $h_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ };
$h_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype = $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype;
$c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype.add__Lcom_raquo_airstream_core_Transaction__V = (function(newTransaction) {
  var x = this.peekStack__O();
  if ((x === (void 0))) {
    $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().com$raquo$airstream$core$Transaction$pendingTransactions$$$pushToStack__Lcom_raquo_airstream_core_Transaction__V(newTransaction);
    $m_Lcom_raquo_airstream_core_Transaction$().com$raquo$airstream$core$Transaction$$$run__Lcom_raquo_airstream_core_Transaction__V(newTransaction);
    $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().done__Lcom_raquo_airstream_core_Transaction__V(newTransaction);
  } else {
    $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().com$raquo$airstream$core$Transaction$pendingTransactions$$$enqueueChild__Lcom_raquo_airstream_core_Transaction__Lcom_raquo_airstream_core_Transaction__V(x, newTransaction);
  }
});
$c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype.done__Lcom_raquo_airstream_core_Transaction__V = (function(transaction) {
  var transaction$tailLocal1 = transaction;
  while (true) {
    var x = this.peekStack__O();
    var elem = transaction$tailLocal1;
    if ((!((x !== (void 0)) && $m_sr_BoxesRunTime$().equals__O__O__Z(elem, x)))) {
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Transaction queue error: Completed transaction is not the first in stack. This is a bug in Airstream.");
    }
    this.putNextTransactionOnStack__Lcom_raquo_airstream_core_Transaction__V(transaction$tailLocal1);
    transaction$tailLocal1.Lcom_raquo_airstream_core_Transaction__f_code = $m_Lcom_raquo_airstream_core_Transaction$().Lcom_raquo_airstream_core_Transaction$__f_com$raquo$airstream$core$Transaction$$$throwDeadTrxError;
    var maybeNextTransaction = this.peekStack__O();
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(maybeNextTransaction, (void 0))) {
      if (((this.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_com$raquo$airstream$core$Transaction$pendingTransactions$$$children.size | 0) > 0)) {
        var numChildren = new $c_sr_IntRef(0);
        this.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_com$raquo$airstream$core$Transaction$pendingTransactions$$$children.forEach(((numChildren) => ((transactions, _$4) => {
          numChildren.sr_IntRef__f_elem = ((numChildren.sr_IntRef__f_elem + (transactions.length | 0)) | 0);
        }))(numChildren));
        throw $ct_jl_Exception__T__(new $c_jl_Exception(), (((("Transaction queue error: Stack cleared, but a total of " + numChildren.sr_IntRef__f_elem) + " children for ") + (this.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_com$raquo$airstream$core$Transaction$pendingTransactions$$$children.size | 0)) + " transactions remain. This is a bug in Airstream."));
      } else {
        return (void 0);
      }
    } else {
      $m_Lcom_raquo_airstream_core_Transaction$().com$raquo$airstream$core$Transaction$$$run__Lcom_raquo_airstream_core_Transaction__V(maybeNextTransaction);
      transaction$tailLocal1 = maybeNextTransaction;
    }
  }
});
$c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype.putNextTransactionOnStack__Lcom_raquo_airstream_core_Transaction__V = (function(doneTransaction) {
  var doneTransaction$tailLocal1 = doneTransaction;
  while (true) {
    var maybeNextChildTrx = $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__dequeueChild__Lcom_raquo_airstream_core_Transaction__O(this, doneTransaction$tailLocal1);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(maybeNextChildTrx, (void 0))) {
      $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__popStack__O(this);
      var maybeParentTransaction = this.peekStack__O();
      if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(maybeParentTransaction, (void 0)))) {
        doneTransaction$tailLocal1 = maybeParentTransaction;
      } else {
        return (void 0);
      }
    } else {
      this.com$raquo$airstream$core$Transaction$pendingTransactions$$$pushToStack__Lcom_raquo_airstream_core_Transaction__V(maybeNextChildTrx);
      return (void 0);
    }
  }
});
$c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype.peekStack__O = (function() {
  return this.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_stack[0];
});
$c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype.com$raquo$airstream$core$Transaction$pendingTransactions$$$pushToStack__Lcom_raquo_airstream_core_Transaction__V = (function(transaction) {
  this.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_stack.unshift(transaction);
});
$c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$.prototype.com$raquo$airstream$core$Transaction$pendingTransactions$$$enqueueChild__Lcom_raquo_airstream_core_Transaction__Lcom_raquo_airstream_core_Transaction__V = (function(parent, newChild) {
  var maybeChildren = $p_Lcom_raquo_airstream_core_Transaction$pendingTransactions$__maybeChildrenFor__Lcom_raquo_airstream_core_Transaction__O(this, parent);
  var noChildrenFound = (maybeChildren === (void 0));
  var newChildren = ((maybeChildren === (void 0)) ? $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_core_Transaction.getArrayOf().constr)([]))) : maybeChildren);
  newChildren.push(newChild);
  if (noChildrenFound) {
    this.Lcom_raquo_airstream_core_Transaction$pendingTransactions$__f_com$raquo$airstream$core$Transaction$pendingTransactions$$$children.set(parent, newChildren);
  }
});
var $d_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$, "com.raquo.airstream.core.Transaction$pendingTransactions$", ({
  Lcom_raquo_airstream_core_Transaction$pendingTransactions$: 1
}));
export { $d_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ as $d_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ };
var $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$;
function $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$() {
  if ((!$n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$)) {
    $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ = new $c_Lcom_raquo_airstream_core_Transaction$pendingTransactions$();
  }
  return $n_Lcom_raquo_airstream_core_Transaction$pendingTransactions$;
}
export { $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ as $m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$ };
/** @constructor */
function $c_Lcom_raquo_airstream_custom_CustomSource$Config(onWillStart, onStart, onStop) {
  this.Lcom_raquo_airstream_custom_CustomSource$Config__f_onWillStart = null;
  this.Lcom_raquo_airstream_custom_CustomSource$Config__f_onStart = null;
  this.Lcom_raquo_airstream_custom_CustomSource$Config__f_onStop = null;
  this.Lcom_raquo_airstream_custom_CustomSource$Config__f_onWillStart = onWillStart;
  this.Lcom_raquo_airstream_custom_CustomSource$Config__f_onStart = onStart;
  this.Lcom_raquo_airstream_custom_CustomSource$Config__f_onStop = onStop;
}
export { $c_Lcom_raquo_airstream_custom_CustomSource$Config as $c_Lcom_raquo_airstream_custom_CustomSource$Config };
$c_Lcom_raquo_airstream_custom_CustomSource$Config.prototype = new $h_O();
$c_Lcom_raquo_airstream_custom_CustomSource$Config.prototype.constructor = $c_Lcom_raquo_airstream_custom_CustomSource$Config;
/** @constructor */
function $h_Lcom_raquo_airstream_custom_CustomSource$Config() {
}
export { $h_Lcom_raquo_airstream_custom_CustomSource$Config as $h_Lcom_raquo_airstream_custom_CustomSource$Config };
$h_Lcom_raquo_airstream_custom_CustomSource$Config.prototype = $c_Lcom_raquo_airstream_custom_CustomSource$Config.prototype;
$c_Lcom_raquo_airstream_custom_CustomSource$Config.prototype.when__F0__Lcom_raquo_airstream_custom_CustomSource$Config = (function(passes) {
  var passed = new $c_sr_BooleanRef(false);
  return new $c_Lcom_raquo_airstream_custom_CustomSource$Config(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    passed.sr_BooleanRef__f_elem = (!(!passes.apply__O()));
    if (passed.sr_BooleanRef__f_elem) {
      this.Lcom_raquo_airstream_custom_CustomSource$Config__f_onWillStart.apply__O();
    }
  })), new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    if (passed.sr_BooleanRef__f_elem) {
      this.Lcom_raquo_airstream_custom_CustomSource$Config__f_onStart.apply__O();
    }
  })), new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    if (passed.sr_BooleanRef__f_elem) {
      this.Lcom_raquo_airstream_custom_CustomSource$Config__f_onStop.apply__O();
    }
    passed.sr_BooleanRef__f_elem = false;
  })));
});
var $d_Lcom_raquo_airstream_custom_CustomSource$Config = new $TypeData().initClass($c_Lcom_raquo_airstream_custom_CustomSource$Config, "com.raquo.airstream.custom.CustomSource$Config", ({
  Lcom_raquo_airstream_custom_CustomSource$Config: 1
}));
export { $d_Lcom_raquo_airstream_custom_CustomSource$Config as $d_Lcom_raquo_airstream_custom_CustomSource$Config };
/** @constructor */
function $c_Lcom_raquo_airstream_custom_CustomSource$Config$() {
}
export { $c_Lcom_raquo_airstream_custom_CustomSource$Config$ as $c_Lcom_raquo_airstream_custom_CustomSource$Config$ };
$c_Lcom_raquo_airstream_custom_CustomSource$Config$.prototype = new $h_O();
$c_Lcom_raquo_airstream_custom_CustomSource$Config$.prototype.constructor = $c_Lcom_raquo_airstream_custom_CustomSource$Config$;
/** @constructor */
function $h_Lcom_raquo_airstream_custom_CustomSource$Config$() {
}
export { $h_Lcom_raquo_airstream_custom_CustomSource$Config$ as $h_Lcom_raquo_airstream_custom_CustomSource$Config$ };
$h_Lcom_raquo_airstream_custom_CustomSource$Config$.prototype = $c_Lcom_raquo_airstream_custom_CustomSource$Config$.prototype;
$c_Lcom_raquo_airstream_custom_CustomSource$Config$.prototype.apply__F0__F0__Lcom_raquo_airstream_custom_CustomSource$Config = (function(onStart, onStop) {
  return new $c_Lcom_raquo_airstream_custom_CustomSource$Config(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (void 0))), onStart, onStop);
});
var $d_Lcom_raquo_airstream_custom_CustomSource$Config$ = new $TypeData().initClass($c_Lcom_raquo_airstream_custom_CustomSource$Config$, "com.raquo.airstream.custom.CustomSource$Config$", ({
  Lcom_raquo_airstream_custom_CustomSource$Config$: 1
}));
export { $d_Lcom_raquo_airstream_custom_CustomSource$Config$ as $d_Lcom_raquo_airstream_custom_CustomSource$Config$ };
var $n_Lcom_raquo_airstream_custom_CustomSource$Config$;
function $m_Lcom_raquo_airstream_custom_CustomSource$Config$() {
  if ((!$n_Lcom_raquo_airstream_custom_CustomSource$Config$)) {
    $n_Lcom_raquo_airstream_custom_CustomSource$Config$ = new $c_Lcom_raquo_airstream_custom_CustomSource$Config$();
  }
  return $n_Lcom_raquo_airstream_custom_CustomSource$Config$;
}
export { $m_Lcom_raquo_airstream_custom_CustomSource$Config$ as $m_Lcom_raquo_airstream_custom_CustomSource$Config$ };
/** @constructor */
function $c_Lcom_raquo_airstream_eventbus_EventBus$() {
}
export { $c_Lcom_raquo_airstream_eventbus_EventBus$ as $c_Lcom_raquo_airstream_eventbus_EventBus$ };
$c_Lcom_raquo_airstream_eventbus_EventBus$.prototype = new $h_O();
$c_Lcom_raquo_airstream_eventbus_EventBus$.prototype.constructor = $c_Lcom_raquo_airstream_eventbus_EventBus$;
/** @constructor */
function $h_Lcom_raquo_airstream_eventbus_EventBus$() {
}
export { $h_Lcom_raquo_airstream_eventbus_EventBus$ as $h_Lcom_raquo_airstream_eventbus_EventBus$ };
$h_Lcom_raquo_airstream_eventbus_EventBus$.prototype = $c_Lcom_raquo_airstream_eventbus_EventBus$.prototype;
var $d_Lcom_raquo_airstream_eventbus_EventBus$ = new $TypeData().initClass($c_Lcom_raquo_airstream_eventbus_EventBus$, "com.raquo.airstream.eventbus.EventBus$", ({
  Lcom_raquo_airstream_eventbus_EventBus$: 1
}));
export { $d_Lcom_raquo_airstream_eventbus_EventBus$ as $d_Lcom_raquo_airstream_eventbus_EventBus$ };
var $n_Lcom_raquo_airstream_eventbus_EventBus$;
function $m_Lcom_raquo_airstream_eventbus_EventBus$() {
  if ((!$n_Lcom_raquo_airstream_eventbus_EventBus$)) {
    $n_Lcom_raquo_airstream_eventbus_EventBus$ = new $c_Lcom_raquo_airstream_eventbus_EventBus$();
  }
  return $n_Lcom_raquo_airstream_eventbus_EventBus$;
}
export { $m_Lcom_raquo_airstream_eventbus_EventBus$ as $m_Lcom_raquo_airstream_eventbus_EventBus$ };
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_DynamicOwner$() {
  this.Lcom_raquo_airstream_ownership_DynamicOwner$__f_TEMP_UNSAFE_USE_PRE_V18_DELAYED_DYNSUB_REMOVAL = false;
  this.Lcom_raquo_airstream_ownership_DynamicOwner$__f_TEMP_UNSAFE_USE_PRE_V18_DELAYED_DYNSUB_REMOVAL = false;
}
export { $c_Lcom_raquo_airstream_ownership_DynamicOwner$ as $c_Lcom_raquo_airstream_ownership_DynamicOwner$ };
$c_Lcom_raquo_airstream_ownership_DynamicOwner$.prototype = new $h_O();
$c_Lcom_raquo_airstream_ownership_DynamicOwner$.prototype.constructor = $c_Lcom_raquo_airstream_ownership_DynamicOwner$;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_DynamicOwner$() {
}
export { $h_Lcom_raquo_airstream_ownership_DynamicOwner$ as $h_Lcom_raquo_airstream_ownership_DynamicOwner$ };
$h_Lcom_raquo_airstream_ownership_DynamicOwner$.prototype = $c_Lcom_raquo_airstream_ownership_DynamicOwner$.prototype;
var $d_Lcom_raquo_airstream_ownership_DynamicOwner$ = new $TypeData().initClass($c_Lcom_raquo_airstream_ownership_DynamicOwner$, "com.raquo.airstream.ownership.DynamicOwner$", ({
  Lcom_raquo_airstream_ownership_DynamicOwner$: 1
}));
export { $d_Lcom_raquo_airstream_ownership_DynamicOwner$ as $d_Lcom_raquo_airstream_ownership_DynamicOwner$ };
var $n_Lcom_raquo_airstream_ownership_DynamicOwner$;
function $m_Lcom_raquo_airstream_ownership_DynamicOwner$() {
  if ((!$n_Lcom_raquo_airstream_ownership_DynamicOwner$)) {
    $n_Lcom_raquo_airstream_ownership_DynamicOwner$ = new $c_Lcom_raquo_airstream_ownership_DynamicOwner$();
  }
  return $n_Lcom_raquo_airstream_ownership_DynamicOwner$;
}
export { $m_Lcom_raquo_airstream_ownership_DynamicOwner$ as $m_Lcom_raquo_airstream_ownership_DynamicOwner$ };
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_DynamicSubscription$() {
}
export { $c_Lcom_raquo_airstream_ownership_DynamicSubscription$ as $c_Lcom_raquo_airstream_ownership_DynamicSubscription$ };
$c_Lcom_raquo_airstream_ownership_DynamicSubscription$.prototype = new $h_O();
$c_Lcom_raquo_airstream_ownership_DynamicSubscription$.prototype.constructor = $c_Lcom_raquo_airstream_ownership_DynamicSubscription$;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_DynamicSubscription$() {
}
export { $h_Lcom_raquo_airstream_ownership_DynamicSubscription$ as $h_Lcom_raquo_airstream_ownership_DynamicSubscription$ };
$h_Lcom_raquo_airstream_ownership_DynamicSubscription$.prototype = $c_Lcom_raquo_airstream_ownership_DynamicSubscription$.prototype;
$c_Lcom_raquo_airstream_ownership_DynamicSubscription$.prototype.unsafe__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(dynamicOwner, activate, prepend) {
  return new $c_Lcom_raquo_airstream_ownership_DynamicSubscription(dynamicOwner, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((owner) => {
    var value = activate.apply__O__O(owner);
    return new $c_s_Some(value);
  })), prepend);
});
$c_Lcom_raquo_airstream_ownership_DynamicSubscription$.prototype.subscribeCallback__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(dynamicOwner, activate, prepend) {
  return new $c_Lcom_raquo_airstream_ownership_DynamicSubscription(dynamicOwner, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((owner) => {
    activate.apply__O__O(owner);
    return $m_s_None$();
  })), prepend);
});
$c_Lcom_raquo_airstream_ownership_DynamicSubscription$.prototype.subscribeSink__Lcom_raquo_airstream_ownership_DynamicOwner__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_core_Sink__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(dynamicOwner, observable, sink) {
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().unsafe__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(dynamicOwner, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((owner) => $f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(observable, sink.toObserver__Lcom_raquo_airstream_core_Observer(), owner))), false);
});
$c_Lcom_raquo_airstream_ownership_DynamicSubscription$.prototype.subscribeFn__Lcom_raquo_airstream_ownership_DynamicOwner__Lcom_raquo_airstream_core_Observable__F1__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(dynamicOwner, observable, onNext) {
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().unsafe__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(dynamicOwner, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((owner) => $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(observable, onNext, owner))), false);
});
var $d_Lcom_raquo_airstream_ownership_DynamicSubscription$ = new $TypeData().initClass($c_Lcom_raquo_airstream_ownership_DynamicSubscription$, "com.raquo.airstream.ownership.DynamicSubscription$", ({
  Lcom_raquo_airstream_ownership_DynamicSubscription$: 1
}));
export { $d_Lcom_raquo_airstream_ownership_DynamicSubscription$ as $d_Lcom_raquo_airstream_ownership_DynamicSubscription$ };
var $n_Lcom_raquo_airstream_ownership_DynamicSubscription$;
function $m_Lcom_raquo_airstream_ownership_DynamicSubscription$() {
  if ((!$n_Lcom_raquo_airstream_ownership_DynamicSubscription$)) {
    $n_Lcom_raquo_airstream_ownership_DynamicSubscription$ = new $c_Lcom_raquo_airstream_ownership_DynamicSubscription$();
  }
  return $n_Lcom_raquo_airstream_ownership_DynamicSubscription$;
}
export { $m_Lcom_raquo_airstream_ownership_DynamicSubscription$ as $m_Lcom_raquo_airstream_ownership_DynamicSubscription$ };
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_TransferableSubscription(activate, deactivate) {
  this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_activate = null;
  this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_deactivate = null;
  this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_maybeSubscription = null;
  this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_isLiveTransferInProgress = false;
  this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_activate = activate;
  this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_deactivate = deactivate;
  this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_maybeSubscription = $m_s_None$();
  this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_isLiveTransferInProgress = false;
}
export { $c_Lcom_raquo_airstream_ownership_TransferableSubscription as $c_Lcom_raquo_airstream_ownership_TransferableSubscription };
$c_Lcom_raquo_airstream_ownership_TransferableSubscription.prototype = new $h_O();
$c_Lcom_raquo_airstream_ownership_TransferableSubscription.prototype.constructor = $c_Lcom_raquo_airstream_ownership_TransferableSubscription;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_TransferableSubscription() {
}
export { $h_Lcom_raquo_airstream_ownership_TransferableSubscription as $h_Lcom_raquo_airstream_ownership_TransferableSubscription };
$h_Lcom_raquo_airstream_ownership_TransferableSubscription.prototype = $c_Lcom_raquo_airstream_ownership_TransferableSubscription.prototype;
$c_Lcom_raquo_airstream_ownership_TransferableSubscription.prototype.isCurrentOwnerActive__Z = (function() {
  var this$1 = this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_maybeSubscription;
  if ((!this$1.isEmpty__Z())) {
    var x0 = this$1.get__O();
    var this$2 = x0.Lcom_raquo_airstream_ownership_DynamicSubscription__f_dynamicOwner;
    var this$3 = this$2.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
    return (!this$3.isEmpty__Z());
  } else {
    return false;
  }
});
$c_Lcom_raquo_airstream_ownership_TransferableSubscription.prototype.setOwner__Lcom_raquo_airstream_ownership_DynamicOwner__V = (function(nextOwner) {
  if (this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_isLiveTransferInProgress) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Unable to set owner on DynamicTransferableSubscription while a transfer on this subscription is already in progress.");
  }
  var this$1 = this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_maybeSubscription;
  if ((!this$1.isEmpty__Z())) {
    var x0 = this$1.get__O();
    var x$2 = x0.Lcom_raquo_airstream_ownership_DynamicSubscription__f_dynamicOwner;
    var $x_1 = (nextOwner === x$2);
  } else {
    var $x_1 = false;
  }
  if ((!$x_1)) {
    if (this.isCurrentOwnerActive__Z()) {
      var this$2 = nextOwner.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
      var $x_2 = (!this$2.isEmpty__Z());
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_isLiveTransferInProgress = true;
    }
    var this$3 = this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_maybeSubscription;
    if ((!this$3.isEmpty__Z())) {
      var x0$1 = this$3.get__O();
      x0$1.kill__V();
      this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_maybeSubscription = $m_s_None$();
    }
    var newPilotSubscription = $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().unsafe__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(nextOwner, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((parentOwner) => {
      if ((!this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_isLiveTransferInProgress)) {
        this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_activate.apply__O();
      }
      return new $c_Lcom_raquo_airstream_ownership_Subscription(parentOwner, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        if ((!this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_isLiveTransferInProgress)) {
          this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_deactivate.apply__O();
        }
      })));
    })), false);
    this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_maybeSubscription = new $c_s_Some(newPilotSubscription);
    this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_isLiveTransferInProgress = false;
  }
});
$c_Lcom_raquo_airstream_ownership_TransferableSubscription.prototype.clearOwner__V = (function() {
  if (this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_isLiveTransferInProgress) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Unable to clear owner on DynamicTransferableSubscription while a transfer on this subscription is already in progress.");
  }
  var this$1 = this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_maybeSubscription;
  if ((!this$1.isEmpty__Z())) {
    var x0 = this$1.get__O();
    x0.kill__V();
  }
  this.Lcom_raquo_airstream_ownership_TransferableSubscription__f_maybeSubscription = $m_s_None$();
});
var $d_Lcom_raquo_airstream_ownership_TransferableSubscription = new $TypeData().initClass($c_Lcom_raquo_airstream_ownership_TransferableSubscription, "com.raquo.airstream.ownership.TransferableSubscription", ({
  Lcom_raquo_airstream_ownership_TransferableSubscription: 1
}));
export { $d_Lcom_raquo_airstream_ownership_TransferableSubscription as $d_Lcom_raquo_airstream_ownership_TransferableSubscription };
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$() {
}
export { $c_Lcom_raquo_airstream_state_Var$ as $c_Lcom_raquo_airstream_state_Var$ };
$c_Lcom_raquo_airstream_state_Var$.prototype = new $h_O();
$c_Lcom_raquo_airstream_state_Var$.prototype.constructor = $c_Lcom_raquo_airstream_state_Var$;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$() {
}
export { $h_Lcom_raquo_airstream_state_Var$ as $h_Lcom_raquo_airstream_state_Var$ };
$h_Lcom_raquo_airstream_state_Var$.prototype = $c_Lcom_raquo_airstream_state_Var$.prototype;
$c_Lcom_raquo_airstream_state_Var$.prototype.apply__O__Lcom_raquo_airstream_state_Var = (function(initial) {
  var initial$1 = new $c_s_util_Success(initial);
  return new $c_Lcom_raquo_airstream_state_SourceVar(initial$1);
});
var $d_Lcom_raquo_airstream_state_Var$ = new $TypeData().initClass($c_Lcom_raquo_airstream_state_Var$, "com.raquo.airstream.state.Var$", ({
  Lcom_raquo_airstream_state_Var$: 1
}));
export { $d_Lcom_raquo_airstream_state_Var$ as $d_Lcom_raquo_airstream_state_Var$ };
var $n_Lcom_raquo_airstream_state_Var$;
function $m_Lcom_raquo_airstream_state_Var$() {
  if ((!$n_Lcom_raquo_airstream_state_Var$)) {
    $n_Lcom_raquo_airstream_state_Var$ = new $c_Lcom_raquo_airstream_state_Var$();
  }
  return $n_Lcom_raquo_airstream_state_Var$;
}
export { $m_Lcom_raquo_airstream_state_Var$ as $m_Lcom_raquo_airstream_state_Var$ };
/** @constructor */
function $c_Lcom_raquo_airstream_util_JsPriorityQueue(getRank) {
  this.Lcom_raquo_airstream_util_JsPriorityQueue__f_getRank = null;
  this.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue = null;
  this.Lcom_raquo_airstream_util_JsPriorityQueue__f_getRank = getRank;
  this.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue = $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([])));
}
export { $c_Lcom_raquo_airstream_util_JsPriorityQueue as $c_Lcom_raquo_airstream_util_JsPriorityQueue };
$c_Lcom_raquo_airstream_util_JsPriorityQueue.prototype = new $h_O();
$c_Lcom_raquo_airstream_util_JsPriorityQueue.prototype.constructor = $c_Lcom_raquo_airstream_util_JsPriorityQueue;
/** @constructor */
function $h_Lcom_raquo_airstream_util_JsPriorityQueue() {
}
export { $h_Lcom_raquo_airstream_util_JsPriorityQueue as $h_Lcom_raquo_airstream_util_JsPriorityQueue };
$h_Lcom_raquo_airstream_util_JsPriorityQueue.prototype = $c_Lcom_raquo_airstream_util_JsPriorityQueue.prototype;
$c_Lcom_raquo_airstream_util_JsPriorityQueue.prototype.enqueue__O__V = (function(item) {
  var itemRank = (this.Lcom_raquo_airstream_util_JsPriorityQueue__f_getRank.apply__O__O(item) | 0);
  var insertAtIndex = 0;
  var foundHigherRank = false;
  while (((insertAtIndex < (this.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue.length | 0)) && (!foundHigherRank))) {
    if (((this.Lcom_raquo_airstream_util_JsPriorityQueue__f_getRank.apply__O__O(this.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue[insertAtIndex]) | 0) > itemRank)) {
      foundHigherRank = true;
    } else {
      insertAtIndex = ((1 + insertAtIndex) | 0);
    }
  }
  this.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue.splice(insertAtIndex, 0, item);
});
$c_Lcom_raquo_airstream_util_JsPriorityQueue.prototype.contains__O__Z = (function(item) {
  return ((this.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue.indexOf(item) | 0) !== (-1));
});
var $d_Lcom_raquo_airstream_util_JsPriorityQueue = new $TypeData().initClass($c_Lcom_raquo_airstream_util_JsPriorityQueue, "com.raquo.airstream.util.JsPriorityQueue", ({
  Lcom_raquo_airstream_util_JsPriorityQueue: 1
}));
export { $d_Lcom_raquo_airstream_util_JsPriorityQueue as $d_Lcom_raquo_airstream_util_JsPriorityQueue };
/** @constructor */
function $c_Lcom_raquo_ew_JsArray$() {
}
export { $c_Lcom_raquo_ew_JsArray$ as $c_Lcom_raquo_ew_JsArray$ };
$c_Lcom_raquo_ew_JsArray$.prototype = new $h_O();
$c_Lcom_raquo_ew_JsArray$.prototype.constructor = $c_Lcom_raquo_ew_JsArray$;
/** @constructor */
function $h_Lcom_raquo_ew_JsArray$() {
}
export { $h_Lcom_raquo_ew_JsArray$ as $h_Lcom_raquo_ew_JsArray$ };
$h_Lcom_raquo_ew_JsArray$.prototype = $c_Lcom_raquo_ew_JsArray$.prototype;
$c_Lcom_raquo_ew_JsArray$.prototype.apply__sci_Seq__Lcom_raquo_ew_JsArray = (function(items) {
  return [...$m_sjsr_Compat$().toJSVarArgsImpl__sci_Seq__sjs_js_Array(items)];
});
var $d_Lcom_raquo_ew_JsArray$ = new $TypeData().initClass($c_Lcom_raquo_ew_JsArray$, "com.raquo.ew.JsArray$", ({
  Lcom_raquo_ew_JsArray$: 1
}));
export { $d_Lcom_raquo_ew_JsArray$ as $d_Lcom_raquo_ew_JsArray$ };
var $n_Lcom_raquo_ew_JsArray$;
function $m_Lcom_raquo_ew_JsArray$() {
  if ((!$n_Lcom_raquo_ew_JsArray$)) {
    $n_Lcom_raquo_ew_JsArray$ = new $c_Lcom_raquo_ew_JsArray$();
  }
  return $n_Lcom_raquo_ew_JsArray$;
}
export { $m_Lcom_raquo_ew_JsArray$ as $m_Lcom_raquo_ew_JsArray$ };
/** @constructor */
function $c_Lcom_raquo_ew_JsArray$RichJsArray$() {
}
export { $c_Lcom_raquo_ew_JsArray$RichJsArray$ as $c_Lcom_raquo_ew_JsArray$RichJsArray$ };
$c_Lcom_raquo_ew_JsArray$RichJsArray$.prototype = new $h_O();
$c_Lcom_raquo_ew_JsArray$RichJsArray$.prototype.constructor = $c_Lcom_raquo_ew_JsArray$RichJsArray$;
/** @constructor */
function $h_Lcom_raquo_ew_JsArray$RichJsArray$() {
}
export { $h_Lcom_raquo_ew_JsArray$RichJsArray$ as $h_Lcom_raquo_ew_JsArray$RichJsArray$ };
$h_Lcom_raquo_ew_JsArray$RichJsArray$.prototype = $c_Lcom_raquo_ew_JsArray$RichJsArray$.prototype;
$c_Lcom_raquo_ew_JsArray$RichJsArray$.prototype.includes$extension__Lcom_raquo_ew_JsArray__O__I__Z = (function(this$, item, fromIndex) {
  return ((this$.indexOf(item, fromIndex) | 0) !== (-1));
});
$c_Lcom_raquo_ew_JsArray$RichJsArray$.prototype.forEach$extension__Lcom_raquo_ew_JsArray__sjs_js_Function1__V = (function(this$, cb) {
  var i = 0;
  var len = (this$.length | 0);
  while ((i < len)) {
    cb(this$[i]);
    i = ((1 + i) | 0);
  }
});
var $d_Lcom_raquo_ew_JsArray$RichJsArray$ = new $TypeData().initClass($c_Lcom_raquo_ew_JsArray$RichJsArray$, "com.raquo.ew.JsArray$RichJsArray$", ({
  Lcom_raquo_ew_JsArray$RichJsArray$: 1
}));
export { $d_Lcom_raquo_ew_JsArray$RichJsArray$ as $d_Lcom_raquo_ew_JsArray$RichJsArray$ };
var $n_Lcom_raquo_ew_JsArray$RichJsArray$;
function $m_Lcom_raquo_ew_JsArray$RichJsArray$() {
  if ((!$n_Lcom_raquo_ew_JsArray$RichJsArray$)) {
    $n_Lcom_raquo_ew_JsArray$RichJsArray$ = new $c_Lcom_raquo_ew_JsArray$RichJsArray$();
  }
  return $n_Lcom_raquo_ew_JsArray$RichJsArray$;
}
export { $m_Lcom_raquo_ew_JsArray$RichJsArray$ as $m_Lcom_raquo_ew_JsArray$RichJsArray$ };
function $f_Lcom_raquo_laminar_api_AirstreamAliases__$init$__V($thiz) {
  $m_Lcom_raquo_airstream_core_Observer$();
  $thiz.Lcom_raquo_laminar_api_package$$anon$1__f_AirstreamError = $m_Lcom_raquo_airstream_core_AirstreamError$();
  $thiz.Lcom_raquo_laminar_api_package$$anon$1__f_EventBus = $m_Lcom_raquo_airstream_eventbus_EventBus$();
  $thiz.Lcom_raquo_laminar_api_package$$anon$1__f_Var = $m_Lcom_raquo_airstream_state_Var$();
}
export { $f_Lcom_raquo_laminar_api_AirstreamAliases__$init$__V as $f_Lcom_raquo_laminar_api_AirstreamAliases__$init$__V };
function $f_Lcom_raquo_laminar_api_LaminarAliases__$init$__V($thiz) {
  $thiz.Lcom_raquo_laminar_api_package$$anon$1__f_Modifier = $m_Lcom_raquo_laminar_modifiers_Modifier$();
  $thiz.Lcom_raquo_laminar_api_package$$anon$1__f_Binder = $m_Lcom_raquo_laminar_modifiers_Binder$();
}
export { $f_Lcom_raquo_laminar_api_LaminarAliases__$init$__V as $f_Lcom_raquo_laminar_api_LaminarAliases__$init$__V };
function $f_Lcom_raquo_laminar_api_MountHooks__$init$__V($thiz) {
  var fn = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    _$1.Lcom_raquo_laminar_lifecycle_MountContext__f_thisNode.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref.focus();
  }));
  $f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Z__Lcom_raquo_laminar_modifiers_Modifier($thiz, fn, false);
}
export { $f_Lcom_raquo_laminar_api_MountHooks__$init$__V as $f_Lcom_raquo_laminar_api_MountHooks__$init$__V };
function $f_Lcom_raquo_laminar_api_MountHooks__onMountBind__F1__Z__Lcom_raquo_laminar_modifiers_Modifier($thiz, fn, ignoreAlreadyMounted) {
  var elem = $m_s_None$();
  var maybeSubscription = new $c_sr_ObjectRef(elem);
  var mount = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c) => {
    var binder = fn.apply__O__O(c);
    var value = binder.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_airstream_ownership_DynamicSubscription(c.Lcom_raquo_laminar_lifecycle_MountContext__f_thisNode);
    maybeSubscription.sr_ObjectRef__f_elem = new $c_s_Some(value);
  }));
  var unmount = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    var this$3 = maybeSubscription.sr_ObjectRef__f_elem;
    if ((!this$3.isEmpty__Z())) {
      var x0 = this$3.get__O();
      x0.kill__V();
    }
    maybeSubscription.sr_ObjectRef__f_elem = $m_s_None$();
  }));
  return $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallback__F1__F1__Z__Lcom_raquo_laminar_modifiers_Modifier($thiz, mount, unmount, ignoreAlreadyMounted);
}
export { $f_Lcom_raquo_laminar_api_MountHooks__onMountBind__F1__Z__Lcom_raquo_laminar_modifiers_Modifier as $f_Lcom_raquo_laminar_api_MountHooks__onMountBind__F1__Z__Lcom_raquo_laminar_modifiers_Modifier };
function $f_Lcom_raquo_laminar_api_MountHooks__onMountInsert__F1__Z__Lcom_raquo_laminar_modifiers_Modifier($thiz, fn, ignoreAlreadyMounted) {
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element) => {
    if (ignoreAlreadyMounted) {
      var this$2 = element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner();
      var this$3 = this$2.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
      var elem = (!this$3.isEmpty__Z());
    } else {
      var elem = false;
    }
    var ignoreNextActivation = new $c_sr_BooleanRef(elem);
    var lockedInsertContext = $m_Lcom_raquo_laminar_inserters_InsertContext$().reserveSpotContext__Lcom_raquo_laminar_nodes_ReactiveElement__O__Lcom_raquo_laminar_inserters_InsertContext(element, (void 0));
    var subscribe = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((mountContext) => {
      if (ignoreNextActivation.sr_BooleanRef__f_elem) {
        ignoreNextActivation.sr_BooleanRef__f_elem = false;
        var inserterSubOpt = $m_s_None$();
      } else {
        matchResult1: {
          var inserterSubOpt;
          var x1 = fn.apply__O__O(mountContext);
          if ((x1 instanceof $c_Lcom_raquo_laminar_inserters_DynamicInserter)) {
            var value = x1.withContext__Lcom_raquo_laminar_inserters_InsertContext__Lcom_raquo_laminar_inserters_DynamicInserter(lockedInsertContext).subscribe__Lcom_raquo_laminar_inserters_InsertContext__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(lockedInsertContext, mountContext.Lcom_raquo_laminar_lifecycle_MountContext__f_owner);
            var inserterSubOpt = new $c_s_Some(value);
            break matchResult1;
          }
          if ($is_Lcom_raquo_laminar_inserters_StaticInserter(x1)) {
            x1.renderInContext__Lcom_raquo_laminar_inserters_InsertContext__V(lockedInsertContext);
            var inserterSubOpt = $m_s_None$();
            break matchResult1;
          }
          throw new $c_s_MatchError(x1);
        }
      }
      return new $c_Lcom_raquo_airstream_ownership_Subscription(mountContext.Lcom_raquo_laminar_lifecycle_MountContext__f_owner, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        if ((!inserterSubOpt.isEmpty__Z())) {
          var x0 = inserterSubOpt.get__O();
          x0.kill__V();
        }
      })));
    }));
    $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().unsafe__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element$2) => ((owner) => subscribe.apply__O__O(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element$2, owner))))(element)), false);
  }));
  return new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(f);
}
export { $f_Lcom_raquo_laminar_api_MountHooks__onMountInsert__F1__Z__Lcom_raquo_laminar_modifiers_Modifier as $f_Lcom_raquo_laminar_api_MountHooks__onMountInsert__F1__Z__Lcom_raquo_laminar_modifiers_Modifier };
function $f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Z__Lcom_raquo_laminar_modifiers_Modifier($thiz, fn, ignoreAlreadyMounted) {
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element) => {
    if (ignoreAlreadyMounted) {
      var this$2 = element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner();
      var this$3 = this$2.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
      var elem = (!this$3.isEmpty__Z());
    } else {
      var elem = false;
    }
    var ignoreNextActivation = new $c_sr_BooleanRef(elem);
    var activate = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c) => {
      if (ignoreNextActivation.sr_BooleanRef__f_elem) {
        ignoreNextActivation.sr_BooleanRef__f_elem = false;
      } else {
        fn.apply__O__O(c);
      }
    }));
    $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().subscribeCallback__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element$2) => ((owner) => {
      activate.apply__O__O(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element$2, owner));
    }))(element)), false);
  }));
  return new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(f);
}
export { $f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Z__Lcom_raquo_laminar_modifiers_Modifier as $f_Lcom_raquo_laminar_api_MountHooks__onMountCallback__F1__Z__Lcom_raquo_laminar_modifiers_Modifier };
function $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallback__F1__F1__Z__Lcom_raquo_laminar_modifiers_Modifier($thiz, mount, unmount, ignoreAlreadyMounted) {
  var unmount$1 = new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((el, _$5) => {
    unmount.apply__O__O(el);
  }));
  return $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallbackWithState__F1__F2__Z__Lcom_raquo_laminar_modifiers_Modifier($thiz, mount, unmount$1, ignoreAlreadyMounted);
}
export { $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallback__F1__F1__Z__Lcom_raquo_laminar_modifiers_Modifier as $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallback__F1__F1__Z__Lcom_raquo_laminar_modifiers_Modifier };
function $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallbackWithState__F1__F2__Z__Lcom_raquo_laminar_modifiers_Modifier($thiz, mount, unmount, ignoreAlreadyMounted) {
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element) => {
    if (ignoreAlreadyMounted) {
      var this$2 = element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner();
      var this$3 = this$2.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
      var elem = (!this$3.isEmpty__Z());
    } else {
      var elem = false;
    }
    var ignoreNextActivation = new $c_sr_BooleanRef(elem);
    var elem$1 = $m_s_None$();
    var state = new $c_sr_ObjectRef(elem$1);
    var subscribe = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element$2) => ((c) => {
      if (ignoreNextActivation.sr_BooleanRef__f_elem) {
        ignoreNextActivation.sr_BooleanRef__f_elem = false;
      } else {
        var value = mount.apply__O__O(c);
        state.sr_ObjectRef__f_elem = new $c_s_Some(value);
      }
      return new $c_Lcom_raquo_airstream_ownership_Subscription(c.Lcom_raquo_laminar_lifecycle_MountContext__f_owner, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        unmount.apply__O__O__O(element$2, state.sr_ObjectRef__f_elem);
        state.sr_ObjectRef__f_elem = $m_s_None$();
      })));
    }))(element));
    $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().unsafe__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element$2$1) => ((owner) => subscribe.apply__O__O(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element$2$1, owner))))(element)), false);
  }));
  return new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(f);
}
export { $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallbackWithState__F1__F2__Z__Lcom_raquo_laminar_modifiers_Modifier as $f_Lcom_raquo_laminar_api_MountHooks__onMountUnmountCallbackWithState__F1__F2__Z__Lcom_raquo_laminar_modifiers_Modifier };
/** @constructor */
function $c_Lcom_raquo_laminar_codecs_Codec$() {
  this.Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs = null;
  this.Lcom_raquo_laminar_codecs_Codec$__f_intAsString$lzy1 = null;
  this.Lcom_raquo_laminar_codecs_Codec$__f_intAsStringbitmap$1 = false;
  this.Lcom_raquo_laminar_codecs_Codec$__f_booleanAsIs = null;
  $n_Lcom_raquo_laminar_codecs_Codec$ = this;
  this.Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs = new $c_Lcom_raquo_laminar_codecs_Codec$$anon$3();
  this.Lcom_raquo_laminar_codecs_Codec$__f_booleanAsIs = new $c_Lcom_raquo_laminar_codecs_Codec$$anon$3();
}
export { $c_Lcom_raquo_laminar_codecs_Codec$ as $c_Lcom_raquo_laminar_codecs_Codec$ };
$c_Lcom_raquo_laminar_codecs_Codec$.prototype = new $h_O();
$c_Lcom_raquo_laminar_codecs_Codec$.prototype.constructor = $c_Lcom_raquo_laminar_codecs_Codec$;
/** @constructor */
function $h_Lcom_raquo_laminar_codecs_Codec$() {
}
export { $h_Lcom_raquo_laminar_codecs_Codec$ as $h_Lcom_raquo_laminar_codecs_Codec$ };
$h_Lcom_raquo_laminar_codecs_Codec$.prototype = $c_Lcom_raquo_laminar_codecs_Codec$.prototype;
$c_Lcom_raquo_laminar_codecs_Codec$.prototype.intAsString__Lcom_raquo_laminar_codecs_Codec = (function() {
  if ((!this.Lcom_raquo_laminar_codecs_Codec$__f_intAsStringbitmap$1)) {
    this.Lcom_raquo_laminar_codecs_Codec$__f_intAsString$lzy1 = new $c_Lcom_raquo_laminar_codecs_Codec$$anon$4();
    this.Lcom_raquo_laminar_codecs_Codec$__f_intAsStringbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_codecs_Codec$__f_intAsString$lzy1;
});
var $d_Lcom_raquo_laminar_codecs_Codec$ = new $TypeData().initClass($c_Lcom_raquo_laminar_codecs_Codec$, "com.raquo.laminar.codecs.Codec$", ({
  Lcom_raquo_laminar_codecs_Codec$: 1
}));
export { $d_Lcom_raquo_laminar_codecs_Codec$ as $d_Lcom_raquo_laminar_codecs_Codec$ };
var $n_Lcom_raquo_laminar_codecs_Codec$;
function $m_Lcom_raquo_laminar_codecs_Codec$() {
  if ((!$n_Lcom_raquo_laminar_codecs_Codec$)) {
    $n_Lcom_raquo_laminar_codecs_Codec$ = new $c_Lcom_raquo_laminar_codecs_Codec$();
  }
  return $n_Lcom_raquo_laminar_codecs_Codec$;
}
export { $m_Lcom_raquo_laminar_codecs_Codec$ as $m_Lcom_raquo_laminar_codecs_Codec$ };
/** @constructor */
function $c_Lcom_raquo_laminar_codecs_CompositeCodec$() {
}
export { $c_Lcom_raquo_laminar_codecs_CompositeCodec$ as $c_Lcom_raquo_laminar_codecs_CompositeCodec$ };
$c_Lcom_raquo_laminar_codecs_CompositeCodec$.prototype = new $h_O();
$c_Lcom_raquo_laminar_codecs_CompositeCodec$.prototype.constructor = $c_Lcom_raquo_laminar_codecs_CompositeCodec$;
/** @constructor */
function $h_Lcom_raquo_laminar_codecs_CompositeCodec$() {
}
export { $h_Lcom_raquo_laminar_codecs_CompositeCodec$ as $h_Lcom_raquo_laminar_codecs_CompositeCodec$ };
$h_Lcom_raquo_laminar_codecs_CompositeCodec$.prototype = $c_Lcom_raquo_laminar_codecs_CompositeCodec$.prototype;
$c_Lcom_raquo_laminar_codecs_CompositeCodec$.prototype.normalize__T__T__sci_List = (function(items, separator) {
  if ((items === "")) {
    return $m_sci_Nil$();
  } else {
    var arr = items.split(separator);
    var arr$1 = arr.filter(((_$1) => (_$1 !== "")));
    var this$9 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), arr$1);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$9);
  }
});
var $d_Lcom_raquo_laminar_codecs_CompositeCodec$ = new $TypeData().initClass($c_Lcom_raquo_laminar_codecs_CompositeCodec$, "com.raquo.laminar.codecs.CompositeCodec$", ({
  Lcom_raquo_laminar_codecs_CompositeCodec$: 1
}));
export { $d_Lcom_raquo_laminar_codecs_CompositeCodec$ as $d_Lcom_raquo_laminar_codecs_CompositeCodec$ };
var $n_Lcom_raquo_laminar_codecs_CompositeCodec$;
function $m_Lcom_raquo_laminar_codecs_CompositeCodec$() {
  if ((!$n_Lcom_raquo_laminar_codecs_CompositeCodec$)) {
    $n_Lcom_raquo_laminar_codecs_CompositeCodec$ = new $c_Lcom_raquo_laminar_codecs_CompositeCodec$();
  }
  return $n_Lcom_raquo_laminar_codecs_CompositeCodec$;
}
export { $m_Lcom_raquo_laminar_codecs_CompositeCodec$ as $m_Lcom_raquo_laminar_codecs_CompositeCodec$ };
function $f_Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys__$init$__V($thiz) {
  $thiz.com$raquo$laminar$defs$complex$ComplexGlobalKeys$_setter_$className_$eq__Lcom_raquo_laminar_keys_CompositeAttr__V(new $c_Lcom_raquo_laminar_keys_CompositeAttr("class", " "));
  $thiz.com$raquo$laminar$defs$complex$ComplexGlobalKeys$_setter_$cls_$eq__Lcom_raquo_laminar_keys_CompositeAttr__V($thiz.className__Lcom_raquo_laminar_keys_CompositeAttr());
}
export { $f_Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys__$init$__V as $f_Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys__$init$__V };
function $f_Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys__dataAttr__T__Lcom_raquo_laminar_keys_HtmlAttr($thiz, suffix) {
  return new $c_Lcom_raquo_laminar_keys_HtmlAttr(("data-" + suffix), $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs);
}
export { $f_Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys__dataAttr__T__Lcom_raquo_laminar_keys_HtmlAttr as $f_Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys__dataAttr__T__Lcom_raquo_laminar_keys_HtmlAttr };
function $f_Lcom_raquo_laminar_domapi_DomDebug__$init$__V($thiz) {
  $thiz.Lcom_raquo_laminar_domapi_DomApi$__f_com$raquo$laminar$domapi$DomDebug$$classNamesSeparatorRegex = new RegExp(" ", "g");
}
export { $f_Lcom_raquo_laminar_domapi_DomDebug__$init$__V as $f_Lcom_raquo_laminar_domapi_DomDebug__$init$__V };
function $f_Lcom_raquo_laminar_domapi_DomDebug__debugPath__Lorg_scalajs_dom_Node__sci_List__sci_List($thiz, element, initial) {
  var initial$tailLocal1 = initial;
  var element$tailLocal1 = element;
  while (true) {
    var x1 = element$tailLocal1;
    if ((x1 === null)) {
      return initial$tailLocal1;
    }
    var element$tailLocal1$tmp1 = element$tailLocal1.parentNode;
    var node = element$tailLocal1;
    var elem$1 = $f_Lcom_raquo_laminar_domapi_DomDebug__debugNodeDescription__Lorg_scalajs_dom_Node__T($thiz, node);
    var this$1 = initial$tailLocal1;
    var initial$tailLocal1$tmp1 = new $c_sci_$colon$colon(elem$1, this$1);
    element$tailLocal1 = element$tailLocal1$tmp1;
    initial$tailLocal1 = initial$tailLocal1$tmp1;
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomDebug__debugPath__Lorg_scalajs_dom_Node__sci_List__sci_List as $f_Lcom_raquo_laminar_domapi_DomDebug__debugPath__Lorg_scalajs_dom_Node__sci_List__sci_List };
function $f_Lcom_raquo_laminar_domapi_DomDebug__debugNodeDescription__Lorg_scalajs_dom_Node__T($thiz, node) {
  if ((!(!(node instanceof HTMLElement)))) {
    var id = node.id;
    if ((id !== "")) {
      var suffixStr = ("#" + id);
    } else {
      var classes = node.className;
      if ((classes !== "")) {
        var self = classes.replace($thiz.Lcom_raquo_laminar_domapi_DomApi$__f_com$raquo$laminar$domapi$DomDebug$$classNamesSeparatorRegex, ".");
        var suffixStr = ("." + self);
      } else {
        var suffixStr = "";
      }
    }
    var str = node.tagName;
    var self$1 = str.toLowerCase();
    return (self$1 + suffixStr);
  } else {
    return node.nodeName;
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomDebug__debugNodeDescription__Lorg_scalajs_dom_Node__T as $f_Lcom_raquo_laminar_domapi_DomDebug__debugNodeDescription__Lorg_scalajs_dom_Node__T };
function $f_Lcom_raquo_laminar_domapi_DomDebug__debugNodeOuterHtml__Lorg_scalajs_dom_Node__T($thiz, node) {
  return ((!(!(node instanceof Element))) ? node.outerHTML : ((!(!(node instanceof Text))) ? (("Text(" + node.textContent) + ")") : ((!(!(node instanceof Comment))) ? (("Comment(" + node.textContent) + ")") : ((node === null) ? "<null>" : (("OtherNode(" + $dp_toString__T(node)) + ")")))));
}
export { $f_Lcom_raquo_laminar_domapi_DomDebug__debugNodeOuterHtml__Lorg_scalajs_dom_Node__T as $f_Lcom_raquo_laminar_domapi_DomDebug__debugNodeOuterHtml__Lorg_scalajs_dom_Node__T };
function $f_Lcom_raquo_laminar_domapi_DomEvents__addEventListener__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_modifiers_EventListener__V($thiz, element, listener) {
  var prop = listener.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor;
  element.addEventListener(prop.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp.Lcom_raquo_laminar_keys_EventProp__f_name, listener.Lcom_raquo_laminar_modifiers_EventListener__f_domCallback, listener.Lcom_raquo_laminar_modifiers_EventListener__f_options);
}
export { $f_Lcom_raquo_laminar_domapi_DomEvents__addEventListener__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_modifiers_EventListener__V as $f_Lcom_raquo_laminar_domapi_DomEvents__addEventListener__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_modifiers_EventListener__V };
function $f_Lcom_raquo_laminar_domapi_DomEvents__removeEventListener__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_modifiers_EventListener__V($thiz, element, listener) {
  var prop = listener.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor;
  element.removeEventListener(prop.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp.Lcom_raquo_laminar_keys_EventProp__f_name, listener.Lcom_raquo_laminar_modifiers_EventListener__f_domCallback, listener.Lcom_raquo_laminar_modifiers_EventListener__f_options);
}
export { $f_Lcom_raquo_laminar_domapi_DomEvents__removeEventListener__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_modifiers_EventListener__V as $f_Lcom_raquo_laminar_domapi_DomEvents__removeEventListener__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_modifiers_EventListener__V };
function $f_Lcom_raquo_laminar_domapi_DomInputs__getChecked__Lorg_scalajs_dom_Element__O($thiz, element) {
  if ((!(!(element instanceof HTMLInputElement)))) {
    if (((element.type === "checkbox") || (element.type === "radio"))) {
      return (!(!element.checked));
    }
  }
  if ($f_Lcom_raquo_laminar_domapi_DomTags__isCustomElement__Lorg_scalajs_dom_Element__Z($thiz, element)) {
    var x = element.checked;
    if ((x === (void 0))) {
      return (void 0);
    } else if (((typeof x) === "boolean")) {
      var b = (!(!x));
      return b;
    } else {
      return (void 0);
    }
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomInputs__getChecked__Lorg_scalajs_dom_Element__O as $f_Lcom_raquo_laminar_domapi_DomInputs__getChecked__Lorg_scalajs_dom_Element__O };
function $f_Lcom_raquo_laminar_domapi_DomInputs__setChecked__Lorg_scalajs_dom_Element__Z__Z($thiz, element, checked) {
  if ((!(!(element instanceof HTMLInputElement)))) {
    if (((element.type === "checkbox") || (element.type === "radio"))) {
      element.checked = checked;
      return true;
    }
  }
  if ($f_Lcom_raquo_laminar_domapi_DomTags__isCustomElement__Lorg_scalajs_dom_Element__Z($thiz, element)) {
    element.checked = checked;
    return true;
  }
  return false;
}
export { $f_Lcom_raquo_laminar_domapi_DomInputs__setChecked__Lorg_scalajs_dom_Element__Z__Z as $f_Lcom_raquo_laminar_domapi_DomInputs__setChecked__Lorg_scalajs_dom_Element__Z__Z };
function $f_Lcom_raquo_laminar_domapi_DomInputs__getValue__Lorg_scalajs_dom_Element__O($thiz, element) {
  if ((!(!(element instanceof HTMLInputElement)))) {
    return element.value;
  } else if ((!(!(element instanceof HTMLTextAreaElement)))) {
    return element.value;
  } else if ((!(!(element instanceof HTMLSelectElement)))) {
    return element.value;
  } else if ((!(!(element instanceof HTMLButtonElement)))) {
    return element.value;
  } else if ((!(!(element instanceof HTMLOptionElement)))) {
    return element.value;
  } else if ($f_Lcom_raquo_laminar_domapi_DomTags__isCustomElement__Lorg_scalajs_dom_Element__Z($thiz, element)) {
    var x = element.value;
    return ((x === (void 0)) ? (void 0) : (((typeof x) === "string") ? x : (void 0)));
  } else {
    return (void 0);
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomInputs__getValue__Lorg_scalajs_dom_Element__O as $f_Lcom_raquo_laminar_domapi_DomInputs__getValue__Lorg_scalajs_dom_Element__O };
function $f_Lcom_raquo_laminar_domapi_DomInputs__setValue__Lorg_scalajs_dom_Element__T__Z($thiz, element, value) {
  if ((!(!(element instanceof HTMLInputElement)))) {
    element.value = value;
    return true;
  } else if ((!(!(element instanceof HTMLTextAreaElement)))) {
    element.value = value;
    return true;
  } else if ((!(!(element instanceof HTMLSelectElement)))) {
    element.value = value;
    return true;
  } else if ((!(!(element instanceof HTMLButtonElement)))) {
    element.value = value;
    return true;
  } else if ((!(!(element instanceof HTMLOptionElement)))) {
    element.value = value;
    return true;
  } else if ($f_Lcom_raquo_laminar_domapi_DomTags__isCustomElement__Lorg_scalajs_dom_Element__Z($thiz, element)) {
    element.value = value;
    return true;
  } else {
    return false;
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomInputs__setValue__Lorg_scalajs_dom_Element__T__Z as $f_Lcom_raquo_laminar_domapi_DomInputs__setValue__Lorg_scalajs_dom_Element__T__Z };
function $f_Lcom_raquo_laminar_domapi_DomKeys__getAttribute__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_keys_SimpleAttr__O($thiz, element, attr) {
  var this$3 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
  var element$1 = element.ref__Lorg_scalajs_dom_Node();
  var localName = attr.name__T();
  var this$2 = attr.namespaceUri__s_Option();
  var namespaceUri = (this$2.isEmpty__Z() ? null : this$2.get__O());
  var domValue = $f_Lcom_raquo_laminar_domapi_DomKeysRaw__getAttribute__Lorg_scalajs_dom_Element__T__T__O(this$3, element$1, localName, namespaceUri);
  if ((domValue === (void 0))) {
    return (void 0);
  } else {
    var a = attr.codec__Lcom_raquo_laminar_codecs_Codec().decode__O__O(domValue);
    return a;
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomKeys__getAttribute__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_keys_SimpleAttr__O as $f_Lcom_raquo_laminar_domapi_DomKeys__getAttribute__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_keys_SimpleAttr__O };
function $f_Lcom_raquo_laminar_domapi_DomKeys__setAttribute__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_keys_SimpleAttr__O__V($thiz, element, attr, value) {
  var domValue = ((value === null) ? null : attr.codec__Lcom_raquo_laminar_codecs_Codec().encode__O__O(value));
  var this$3 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
  var element$1 = element.ref__Lorg_scalajs_dom_Node();
  var localName = attr.name__T();
  var qualifiedName = attr.name__T();
  var this$2 = attr.namespaceUri__s_Option();
  var namespaceUri = (this$2.isEmpty__Z() ? null : this$2.get__O());
  $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setAttribute__Lorg_scalajs_dom_Element__T__T__T__T__V(this$3, element$1, localName, qualifiedName, namespaceUri, domValue);
}
export { $f_Lcom_raquo_laminar_domapi_DomKeys__setAttribute__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_keys_SimpleAttr__O__V as $f_Lcom_raquo_laminar_domapi_DomKeys__setAttribute__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_keys_SimpleAttr__O__V };
function $f_Lcom_raquo_laminar_domapi_DomKeys__getHtmlProperty__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__Lcom_raquo_laminar_keys_HtmlProp__O($thiz, element, prop) {
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
  var element$1 = element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
  var name = prop.Lcom_raquo_laminar_keys_HtmlProp__f_name;
  var x = $f_Lcom_raquo_laminar_domapi_DomKeysRaw__getHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__O(this$1, element$1, name);
  if ((x === (void 0))) {
    return (void 0);
  } else {
    var a = prop.Lcom_raquo_laminar_keys_HtmlProp$$anon$1__f_codec.decode__O__O(x);
    return a;
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomKeys__getHtmlProperty__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__Lcom_raquo_laminar_keys_HtmlProp__O as $f_Lcom_raquo_laminar_domapi_DomKeys__getHtmlProperty__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__Lcom_raquo_laminar_keys_HtmlProp__O };
function $f_Lcom_raquo_laminar_domapi_DomKeys__setHtmlProperty__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__Lcom_raquo_laminar_keys_HtmlProp__O__V($thiz, element, prop, value) {
  var domValue = ((value === null) ? null : prop.Lcom_raquo_laminar_keys_HtmlProp$$anon$1__f_codec.encode__O__O(value));
  if ((domValue === null)) {
    var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
    var element$1 = element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
    var propName = prop.Lcom_raquo_laminar_keys_HtmlProp__f_name;
    var reflectedAttrName = prop.Lcom_raquo_laminar_keys_HtmlProp__f_reflectedAttrName;
    $f_Lcom_raquo_laminar_domapi_DomKeysRaw__removeHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__s_Option__V(this$1, element$1, propName, reflectedAttrName);
  } else {
    var this$2 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
    var element$2 = element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
    var name = prop.Lcom_raquo_laminar_keys_HtmlProp__f_name;
    $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__O__V(this$2, element$2, name, domValue);
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomKeys__setHtmlProperty__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__Lcom_raquo_laminar_keys_HtmlProp__O__V as $f_Lcom_raquo_laminar_domapi_DomKeys__setHtmlProperty__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__Lcom_raquo_laminar_keys_HtmlProp__O__V };
function $f_Lcom_raquo_laminar_domapi_DomKeys__cssValue__O__T($thiz, value) {
  return ((value === null) ? null : $dp_toString__T(value));
}
export { $f_Lcom_raquo_laminar_domapi_DomKeys__cssValue__O__T as $f_Lcom_raquo_laminar_domapi_DomKeys__cssValue__O__T };
function $f_Lcom_raquo_laminar_domapi_DomKeysRaw__getAttribute__Lorg_scalajs_dom_Element__T__T__O($thiz, element, localName, namespaceUri) {
  var domValue = ((namespaceUri === null) ? element.getAttribute(localName) : element.getAttributeNS(namespaceUri, localName));
  return ((domValue !== null) ? domValue : (void 0));
}
export { $f_Lcom_raquo_laminar_domapi_DomKeysRaw__getAttribute__Lorg_scalajs_dom_Element__T__T__O as $f_Lcom_raquo_laminar_domapi_DomKeysRaw__getAttribute__Lorg_scalajs_dom_Element__T__T__O };
function $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setAttribute__Lorg_scalajs_dom_Element__T__T__T__T__V($thiz, element, localName, qualifiedName, namespaceUri, domValue) {
  if ((domValue === null)) {
    if ((namespaceUri === null)) {
      element.removeAttribute(localName);
    } else {
      element.removeAttributeNS(namespaceUri, localName);
    }
  } else if ((namespaceUri === null)) {
    element.setAttribute(qualifiedName, domValue);
  } else {
    element.setAttributeNS(namespaceUri, qualifiedName, domValue);
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setAttribute__Lorg_scalajs_dom_Element__T__T__T__T__V as $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setAttribute__Lorg_scalajs_dom_Element__T__T__T__T__V };
function $f_Lcom_raquo_laminar_domapi_DomKeysRaw__getHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__O($thiz, element, name) {
  return element[name];
}
export { $f_Lcom_raquo_laminar_domapi_DomKeysRaw__getHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__O as $f_Lcom_raquo_laminar_domapi_DomKeysRaw__getHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__O };
function $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__O__V($thiz, element, name, value) {
  element[name] = value;
}
export { $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__O__V as $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__O__V };
function $f_Lcom_raquo_laminar_domapi_DomKeysRaw__removeHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__s_Option__V($thiz, element, propName, reflectedAttrName) {
  if (reflectedAttrName.isEmpty__Z()) {
    element[propName] = null;
  } else {
    var x0 = reflectedAttrName.get__O();
    element.removeAttribute(x0);
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomKeysRaw__removeHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__s_Option__V as $f_Lcom_raquo_laminar_domapi_DomKeysRaw__removeHtmlProperty__Lorg_scalajs_dom_HTMLElement__T__s_Option__V };
function $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setStyle__Lorg_scalajs_dom_Element__T__sci_Seq__T__V($thiz, element, styleCssName, prefixes, styleValue) {
  if ((styleValue === null)) {
    prefixes.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((prefix) => element.style.removeProperty((("" + prefix) + styleCssName)))));
    element.style.removeProperty(styleCssName);
  } else {
    prefixes.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((prefix$2) => {
      var \u03b41$ = element.style;
      \u03b41$.setProperty((("" + prefix$2) + styleCssName), styleValue);
    })));
    var \u03b42$ = element.style;
    \u03b42$.setProperty(styleCssName, styleValue);
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setStyle__Lorg_scalajs_dom_Element__T__sci_Seq__T__V as $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setStyle__Lorg_scalajs_dom_Element__T__sci_Seq__T__V };
function $f_Lcom_raquo_laminar_domapi_DomParser__$init$__V($thiz) {
  document.createElement("template");
  var tag = $m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.svg__Lcom_raquo_laminar_api_Laminar$svg$().svg__Lcom_raquo_laminar_tags_SvgTag();
  $thiz.Lcom_raquo_laminar_domapi_DomApi$__f_com$raquo$laminar$domapi$DomParser$$svgParserContainer = $f_Lcom_raquo_laminar_domapi_DomTags__createSvgElement__Lcom_raquo_laminar_tags_SvgTag__Lorg_scalajs_dom_SVGElement($thiz, tag);
}
export { $f_Lcom_raquo_laminar_domapi_DomParser__$init$__V as $f_Lcom_raquo_laminar_domapi_DomParser__$init$__V };
function $f_Lcom_raquo_laminar_domapi_DomParser__unsafeParseSvgString__T__Lorg_scalajs_dom_SVGElement($thiz, dangerousSvgString) {
  var dangerousSvgString$1 = $f_T__trim__T(dangerousSvgString);
  var nodes = $f_Lcom_raquo_laminar_domapi_DomParser__unsafeParseSvgStringIntoNodeArray__T__sjs_js_Array($thiz, dangerousSvgString$1);
  var node = $f_Lcom_raquo_laminar_domapi_DomTags__assertSingleNode__sjs_js_Array__T__Lorg_scalajs_dom_Node($thiz, nodes, "Error parsing SVG string");
  return $f_Lcom_raquo_laminar_domapi_DomTags__assertSvgElement__Lorg_scalajs_dom_Node__T__Lorg_scalajs_dom_SVGElement($thiz, node, "Error parsing SVG string");
}
export { $f_Lcom_raquo_laminar_domapi_DomParser__unsafeParseSvgString__T__Lorg_scalajs_dom_SVGElement as $f_Lcom_raquo_laminar_domapi_DomParser__unsafeParseSvgString__T__Lorg_scalajs_dom_SVGElement };
function $f_Lcom_raquo_laminar_domapi_DomParser__unsafeParseSvgStringIntoNodeArray__T__sjs_js_Array($thiz, dangerousSvgString) {
  $thiz.Lcom_raquo_laminar_domapi_DomApi$__f_com$raquo$laminar$domapi$DomParser$$svgParserContainer.innerHTML = dangerousSvgString;
  var iterable = $thiz.Lcom_raquo_laminar_domapi_DomApi$__f_com$raquo$laminar$domapi$DomParser$$svgParserContainer.childNodes;
  var arr = Array.from(iterable);
  $thiz.Lcom_raquo_laminar_domapi_DomApi$__f_com$raquo$laminar$domapi$DomParser$$svgParserContainer.innerHTML = "";
  return arr;
}
export { $f_Lcom_raquo_laminar_domapi_DomParser__unsafeParseSvgStringIntoNodeArray__T__sjs_js_Array as $f_Lcom_raquo_laminar_domapi_DomParser__unsafeParseSvgStringIntoNodeArray__T__sjs_js_Array };
function $f_Lcom_raquo_laminar_domapi_DomTags__$init$__V($thiz) {
  $thiz.Lcom_raquo_laminar_domapi_DomApi$__f_svgNamespaceUri = "http://www.w3.org/2000/svg";
}
export { $f_Lcom_raquo_laminar_domapi_DomTags__$init$__V as $f_Lcom_raquo_laminar_domapi_DomTags__$init$__V };
function $f_Lcom_raquo_laminar_domapi_DomTags__createHtmlElement__Lcom_raquo_laminar_tags_HtmlTag__Lorg_scalajs_dom_HTMLElement($thiz, tag) {
  return document.createElement(tag.Lcom_raquo_laminar_tags_HtmlTag__f_name);
}
export { $f_Lcom_raquo_laminar_domapi_DomTags__createHtmlElement__Lcom_raquo_laminar_tags_HtmlTag__Lorg_scalajs_dom_HTMLElement as $f_Lcom_raquo_laminar_domapi_DomTags__createHtmlElement__Lcom_raquo_laminar_tags_HtmlTag__Lorg_scalajs_dom_HTMLElement };
function $f_Lcom_raquo_laminar_domapi_DomTags__createSvgElement__Lcom_raquo_laminar_tags_SvgTag__Lorg_scalajs_dom_SVGElement($thiz, tag) {
  return document.createElementNS($thiz.Lcom_raquo_laminar_domapi_DomApi$__f_svgNamespaceUri, tag.Lcom_raquo_laminar_tags_SvgTag__f_name);
}
export { $f_Lcom_raquo_laminar_domapi_DomTags__createSvgElement__Lcom_raquo_laminar_tags_SvgTag__Lorg_scalajs_dom_SVGElement as $f_Lcom_raquo_laminar_domapi_DomTags__createSvgElement__Lcom_raquo_laminar_tags_SvgTag__Lorg_scalajs_dom_SVGElement };
function $f_Lcom_raquo_laminar_domapi_DomTags__createCommentNode__T__Lorg_scalajs_dom_Comment($thiz, text) {
  return document.createComment(text);
}
export { $f_Lcom_raquo_laminar_domapi_DomTags__createCommentNode__T__Lorg_scalajs_dom_Comment as $f_Lcom_raquo_laminar_domapi_DomTags__createCommentNode__T__Lorg_scalajs_dom_Comment };
function $f_Lcom_raquo_laminar_domapi_DomTags__createTextNode__T__Lorg_scalajs_dom_Text($thiz, text) {
  return document.createTextNode(text);
}
export { $f_Lcom_raquo_laminar_domapi_DomTags__createTextNode__T__Lorg_scalajs_dom_Text as $f_Lcom_raquo_laminar_domapi_DomTags__createTextNode__T__Lorg_scalajs_dom_Text };
function $f_Lcom_raquo_laminar_domapi_DomTags__isCustomElement__Lorg_scalajs_dom_Element__Z($thiz, element) {
  var $x_1 = $m_sc_StringOps$();
  var x = element.tagName;
  return $x_1.contains$extension__T__C__Z(x, 45);
}
export { $f_Lcom_raquo_laminar_domapi_DomTags__isCustomElement__Lorg_scalajs_dom_Element__Z as $f_Lcom_raquo_laminar_domapi_DomTags__isCustomElement__Lorg_scalajs_dom_Element__Z };
function $f_Lcom_raquo_laminar_domapi_DomTags__assertSingleNode__sjs_js_Array__T__Lorg_scalajs_dom_Node($thiz, nodes, clue) {
  if (((nodes.length | 0) !== 1)) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), ((clue + ": expected exactly 1 element, got ") + (nodes.length | 0)));
  }
  return nodes[0];
}
export { $f_Lcom_raquo_laminar_domapi_DomTags__assertSingleNode__sjs_js_Array__T__Lorg_scalajs_dom_Node as $f_Lcom_raquo_laminar_domapi_DomTags__assertSingleNode__sjs_js_Array__T__Lorg_scalajs_dom_Node };
function $f_Lcom_raquo_laminar_domapi_DomTags__assertSvgElement__Lorg_scalajs_dom_Node__T__Lorg_scalajs_dom_SVGElement($thiz, node, clue) {
  if ((!(!(node instanceof SVGElement)))) {
    return node;
  }
  throw $ct_jl_Exception__T__(new $c_jl_Exception(), ((clue + ": expected SVG element, got non-element node: ") + node.nodeName));
}
export { $f_Lcom_raquo_laminar_domapi_DomTags__assertSvgElement__Lorg_scalajs_dom_Node__T__Lorg_scalajs_dom_SVGElement as $f_Lcom_raquo_laminar_domapi_DomTags__assertSvgElement__Lorg_scalajs_dom_Node__T__Lorg_scalajs_dom_SVGElement };
function $f_Lcom_raquo_laminar_domapi_DomTags__assertTagMatches__Lcom_raquo_laminar_tags_Tag__Lorg_scalajs_dom_Node__T__Lorg_scalajs_dom_Element($thiz, tag, node, clue) {
  var expectedElementTypeDesc$lzy1 = new $c_sr_LazyRef();
  var actualNodeTypeDesc$lzy1 = new $c_sr_LazyRef();
  var elementTypeMatches = (((!(!(node instanceof HTMLElement))) && (tag instanceof $c_Lcom_raquo_laminar_tags_HtmlTag)) || ((!(!(node instanceof SVGElement))) && (tag instanceof $c_Lcom_raquo_laminar_tags_SvgTag)));
  if ((!(!(node instanceof Element)))) {
    if (elementTypeMatches) {
      var str = tag.name__T();
      var x = str.toLowerCase();
      var str$1 = node.tagName;
      var y = str$1.toLowerCase();
      var tagNameMatches = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y));
      if (tagNameMatches) {
        throw $ct_jl_Exception__T__(new $c_jl_Exception(), (((((clue + ": expected ") + $ps_Lcom_raquo_laminar_domapi_DomTags__expectedElementTypeDesc$1__sr_LazyRef__Lcom_raquo_laminar_tags_Tag__T(expectedElementTypeDesc$lzy1, tag)) + ", got different tag name: `") + $ps_Lcom_raquo_laminar_domapi_DomTags__actualNodeTypeDesc$1__sr_LazyRef__Lorg_scalajs_dom_Node__T(actualNodeTypeDesc$lzy1, node)) + "`"));
      } else {
        return node;
      }
    }
  }
  throw $ct_jl_Exception__T__(new $c_jl_Exception(), (((((clue + ": expected ") + $ps_Lcom_raquo_laminar_domapi_DomTags__expectedElementTypeDesc$1__sr_LazyRef__Lcom_raquo_laminar_tags_Tag__T(expectedElementTypeDesc$lzy1, tag)) + ", got different node type: `") + $ps_Lcom_raquo_laminar_domapi_DomTags__actualNodeTypeDesc$1__sr_LazyRef__Lorg_scalajs_dom_Node__T(actualNodeTypeDesc$lzy1, node)) + "`"));
}
export { $f_Lcom_raquo_laminar_domapi_DomTags__assertTagMatches__Lcom_raquo_laminar_tags_Tag__Lorg_scalajs_dom_Node__T__Lorg_scalajs_dom_Element as $f_Lcom_raquo_laminar_domapi_DomTags__assertTagMatches__Lcom_raquo_laminar_tags_Tag__Lorg_scalajs_dom_Node__T__Lorg_scalajs_dom_Element };
function $ps_Lcom_raquo_laminar_domapi_DomTags__expectedElementTypeDesc$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_tags_Tag__T(expectedElementTypeDesc$lzy1$1, tag$1) {
  if ((expectedElementTypeDesc$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return (expectedElementTypeDesc$lzy1$1.sr_LazyRef__f__initialized ? expectedElementTypeDesc$lzy1$1.sr_LazyRef__f__value : expectedElementTypeDesc$lzy1$1.initialize__O__O(((tag$1 instanceof $c_Lcom_raquo_laminar_tags_HtmlTag) ? (("HTML <" + tag$1.Lcom_raquo_laminar_tags_HtmlTag__f_name) + ">") : ((tag$1 instanceof $c_Lcom_raquo_laminar_tags_SvgTag) ? (("SVG <" + tag$1.Lcom_raquo_laminar_tags_SvgTag__f_name) + ">") : (("Unknown element <" + tag$1.name__T()) + ">")))));
}
export { $ps_Lcom_raquo_laminar_domapi_DomTags__expectedElementTypeDesc$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_tags_Tag__T as $ps_Lcom_raquo_laminar_domapi_DomTags__expectedElementTypeDesc$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_tags_Tag__T };
function $ps_Lcom_raquo_laminar_domapi_DomTags__expectedElementTypeDesc$1__sr_LazyRef__Lcom_raquo_laminar_tags_Tag__T(expectedElementTypeDesc$lzy1$2, tag$2) {
  return (expectedElementTypeDesc$lzy1$2.sr_LazyRef__f__initialized ? expectedElementTypeDesc$lzy1$2.sr_LazyRef__f__value : $ps_Lcom_raquo_laminar_domapi_DomTags__expectedElementTypeDesc$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_tags_Tag__T(expectedElementTypeDesc$lzy1$2, tag$2));
}
export { $ps_Lcom_raquo_laminar_domapi_DomTags__expectedElementTypeDesc$1__sr_LazyRef__Lcom_raquo_laminar_tags_Tag__T as $ps_Lcom_raquo_laminar_domapi_DomTags__expectedElementTypeDesc$1__sr_LazyRef__Lcom_raquo_laminar_tags_Tag__T };
function $ps_Lcom_raquo_laminar_domapi_DomTags__actualNodeTypeDesc$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_Node__T(actualNodeTypeDesc$lzy1$1, node$1) {
  if ((actualNodeTypeDesc$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if (actualNodeTypeDesc$lzy1$1.sr_LazyRef__f__initialized) {
    var $x_1 = actualNodeTypeDesc$lzy1$1.sr_LazyRef__f__value;
  } else {
    if ((!(!(node$1 instanceof HTMLElement)))) {
      var $x_2 = (("HTML <" + node$1.tagName) + ">");
    } else if ((!(!(node$1 instanceof SVGElement)))) {
      var $x_2 = (("SVG <" + node$1.tagName) + ">");
    } else if ((!(!(node$1 instanceof Element)))) {
      var $x_2 = (("Unknown <" + node$1.tagName) + ">");
    } else if ((!(!(node$1 instanceof Comment)))) {
      var $x_2 = (("CommentNode <" + node$1.text) + ">");
    } else if ((!(!(node$1 instanceof Text)))) {
      var $x_2 = (("TextNode <" + node$1.textContent) + ">");
    } else {
      var $x_3 = $m_sc_StringOps$();
      var x = $dp_toString__T(node$1);
      var $x_2 = (("Unknown node `" + $x_3.take$extension__T__I__T(x, 20)) + "`");
    }
    var $x_1 = actualNodeTypeDesc$lzy1$1.initialize__O__O($x_2);
  }
  return $x_1;
}
export { $ps_Lcom_raquo_laminar_domapi_DomTags__actualNodeTypeDesc$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_Node__T as $ps_Lcom_raquo_laminar_domapi_DomTags__actualNodeTypeDesc$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_Node__T };
function $ps_Lcom_raquo_laminar_domapi_DomTags__actualNodeTypeDesc$1__sr_LazyRef__Lorg_scalajs_dom_Node__T(actualNodeTypeDesc$lzy1$2, node$2) {
  return (actualNodeTypeDesc$lzy1$2.sr_LazyRef__f__initialized ? actualNodeTypeDesc$lzy1$2.sr_LazyRef__f__value : $ps_Lcom_raquo_laminar_domapi_DomTags__actualNodeTypeDesc$lzyINIT1$1__sr_LazyRef__Lorg_scalajs_dom_Node__T(actualNodeTypeDesc$lzy1$2, node$2));
}
export { $ps_Lcom_raquo_laminar_domapi_DomTags__actualNodeTypeDesc$1__sr_LazyRef__Lorg_scalajs_dom_Node__T as $ps_Lcom_raquo_laminar_domapi_DomTags__actualNodeTypeDesc$1__sr_LazyRef__Lorg_scalajs_dom_Node__T };
function $f_Lcom_raquo_laminar_domapi_DomTree__appendChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z($thiz, parent, child, hooks) {
  var nextParent = new $c_s_Some(parent);
  child.willSetParent__s_Option__V(nextParent);
  if ((hooks !== (void 0))) {
    hooks.onWillInsertNode__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__V(parent, child);
  }
  var this$7 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
  var parent$1 = parent.ref__Lorg_scalajs_dom_Node();
  var child$1 = child.ref__Lorg_scalajs_dom_Node();
  var appended = $f_Lcom_raquo_laminar_domapi_DomTreeRaw__appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z(this$7, parent$1, child$1);
  if (appended) {
    child.setParent__s_Option__V(nextParent);
  }
  return appended;
}
export { $f_Lcom_raquo_laminar_domapi_DomTree__appendChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z as $f_Lcom_raquo_laminar_domapi_DomTree__appendChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z };
function $f_Lcom_raquo_laminar_domapi_DomTree__removeChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Z($thiz, parent, child) {
  var removed = false;
  var x = child.ref__Lorg_scalajs_dom_Node().parentNode;
  var y = parent.ref__Lorg_scalajs_dom_Node();
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
    child.willSetParent__s_Option__V($m_s_None$());
    var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
    var parent$1 = parent.ref__Lorg_scalajs_dom_Node();
    var child$1 = child.ref__Lorg_scalajs_dom_Node();
    removed = $f_Lcom_raquo_laminar_domapi_DomTreeRaw__removeChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z(this$1, parent$1, child$1);
    child.setParent__s_Option__V($m_s_None$());
  }
  return removed;
}
export { $f_Lcom_raquo_laminar_domapi_DomTree__removeChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Z as $f_Lcom_raquo_laminar_domapi_DomTree__removeChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Z };
function $f_Lcom_raquo_laminar_domapi_DomTree__insertChildAfter__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z($thiz, parent, newChild, referenceChild, hooks) {
  var nextParent = new $c_s_Some(parent);
  newChild.willSetParent__s_Option__V(nextParent);
  if ((hooks !== (void 0))) {
    hooks.onWillInsertNode__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__V(parent, newChild);
  }
  var this$7 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
  var parent$1 = parent.ref__Lorg_scalajs_dom_Node();
  var newChild$1 = newChild.ref__Lorg_scalajs_dom_Node();
  var referenceChild$1 = referenceChild.ref__Lorg_scalajs_dom_Node();
  var inserted = $f_Lcom_raquo_laminar_domapi_DomTreeRaw__insertAfter__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z(this$7, parent$1, newChild$1, referenceChild$1);
  newChild.setParent__s_Option__V(nextParent);
  return inserted;
}
export { $f_Lcom_raquo_laminar_domapi_DomTree__insertChildAfter__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z as $f_Lcom_raquo_laminar_domapi_DomTree__insertChildAfter__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z };
function $f_Lcom_raquo_laminar_domapi_DomTree__replaceChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z($thiz, parent, oldChild, newChild, hooks) {
  var replaced = false;
  if ((oldChild !== newChild)) {
    if (oldChild.com$raquo$laminar$nodes$ChildNode$$_maybeParent__s_Option().contains__O__Z(parent)) {
      var newChildNextParent = new $c_s_Some(parent);
      oldChild.willSetParent__s_Option__V($m_s_None$());
      newChild.willSetParent__s_Option__V(newChildNextParent);
      if ((hooks !== (void 0))) {
        hooks.onWillInsertNode__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__V(parent, newChild);
      }
      var this$7 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
      var parent$1 = parent.ref__Lorg_scalajs_dom_Node();
      var newChild$1 = newChild.ref__Lorg_scalajs_dom_Node();
      var oldChild$1 = oldChild.ref__Lorg_scalajs_dom_Node();
      replaced = $f_Lcom_raquo_laminar_domapi_DomTreeRaw__replaceChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z(this$7, parent$1, newChild$1, oldChild$1);
      if (replaced) {
        oldChild.setParent__s_Option__V($m_s_None$());
        newChild.setParent__s_Option__V(newChildNextParent);
      }
    }
  }
  return replaced;
}
export { $f_Lcom_raquo_laminar_domapi_DomTree__replaceChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z as $f_Lcom_raquo_laminar_domapi_DomTree__replaceChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z };
function $f_Lcom_raquo_laminar_domapi_DomTreeRaw__appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z($thiz, parent, child) {
  try {
    parent.appendChild(child);
    return true;
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (((e$2 instanceof $c_sjs_js_JavaScriptException) && (!(!(e$2.sjs_js_JavaScriptException__f_exception instanceof DOMException))))) {
      return false;
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomTreeRaw__appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z as $f_Lcom_raquo_laminar_domapi_DomTreeRaw__appendChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z };
function $f_Lcom_raquo_laminar_domapi_DomTreeRaw__removeChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z($thiz, parent, child) {
  try {
    parent.removeChild(child);
    return true;
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (((e$2 instanceof $c_sjs_js_JavaScriptException) && (!(!(e$2.sjs_js_JavaScriptException__f_exception instanceof DOMException))))) {
      return false;
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomTreeRaw__removeChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z as $f_Lcom_raquo_laminar_domapi_DomTreeRaw__removeChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z };
function $f_Lcom_raquo_laminar_domapi_DomTreeRaw__insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z($thiz, parent, newChild, referenceChild) {
  try {
    parent.insertBefore(newChild, referenceChild);
    return true;
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (((e$2 instanceof $c_sjs_js_JavaScriptException) && (!(!(e$2.sjs_js_JavaScriptException__f_exception instanceof DOMException))))) {
      return false;
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomTreeRaw__insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z as $f_Lcom_raquo_laminar_domapi_DomTreeRaw__insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z };
function $f_Lcom_raquo_laminar_domapi_DomTreeRaw__insertAfter__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z($thiz, parent, newChild, referenceChild) {
  try {
    parent.insertBefore(newChild, referenceChild.nextSibling);
    return true;
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (((e$2 instanceof $c_sjs_js_JavaScriptException) && (!(!(e$2.sjs_js_JavaScriptException__f_exception instanceof DOMException))))) {
      return false;
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomTreeRaw__insertAfter__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z as $f_Lcom_raquo_laminar_domapi_DomTreeRaw__insertAfter__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z };
function $f_Lcom_raquo_laminar_domapi_DomTreeRaw__replaceChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z($thiz, parent, newChild, oldChild) {
  try {
    parent.replaceChild(newChild, oldChild);
    return true;
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (((e$2 instanceof $c_sjs_js_JavaScriptException) && (!(!(e$2.sjs_js_JavaScriptException__f_exception instanceof DOMException))))) {
      return false;
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomTreeRaw__replaceChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z as $f_Lcom_raquo_laminar_domapi_DomTreeRaw__replaceChild__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z };
function $f_Lcom_raquo_laminar_domapi_DomTreeRaw__isDescendantOf__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z($thiz, node, ancestor) {
  var node$tailLocal1 = node;
  while (true) {
    if ((node$tailLocal1.parentNode !== null)) {
      var effectiveParentNode = node$tailLocal1.parentNode;
    } else {
      var maybeShadowHost = node$tailLocal1.host;
      var effectiveParentNode = ((maybeShadowHost === (void 0)) ? null : maybeShadowHost);
    }
    if ((effectiveParentNode === null)) {
      return false;
    }
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(ancestor, effectiveParentNode)) {
      return true;
    }
    node$tailLocal1 = effectiveParentNode;
  }
}
export { $f_Lcom_raquo_laminar_domapi_DomTreeRaw__isDescendantOf__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z as $f_Lcom_raquo_laminar_domapi_DomTreeRaw__isDescendantOf__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z };
function $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V($thiz, nextValue, force) {
  if (force) {
    var $x_1 = true;
  } else {
    var y = $thiz.Lcom_raquo_laminar_inputs_InputController__f_config.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_getDomValue.apply__O__O($thiz.Lcom_raquo_laminar_inputs_InputController__f_element);
    var $x_1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(nextValue, y));
  }
  if ($x_1) {
    $thiz.Lcom_raquo_laminar_inputs_InputController__f_config.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_setDomValue.apply__O__O__O($thiz.Lcom_raquo_laminar_inputs_InputController__f_element, nextValue);
  }
  $thiz.Lcom_raquo_laminar_inputs_InputController__f_prevValue = nextValue;
}
export { $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V as $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V };
function $p_Lcom_raquo_laminar_inputs_InputController__combinedObserver__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_core_Observer($thiz, owner) {
  var elem = $m_s_None$();
  var latestSourceValue = new $c_sr_ObjectRef(elem);
  $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz.Lcom_raquo_laminar_inputs_InputController__f_updater.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_values, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((sourceValue) => {
    latestSourceValue.sr_ObjectRef__f_elem = new $c_s_Some(sourceValue);
    $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V($thiz, sourceValue, false);
  })), owner);
  var this$5 = $m_Lcom_raquo_airstream_core_Observer$();
  var onNext = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    var this$4 = latestSourceValue.sr_ObjectRef__f_elem;
    $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V($thiz, (this$4.isEmpty__Z() ? $thiz.Lcom_raquo_laminar_inputs_InputController__f_prevValue : this$4.get__O()), false);
  }));
  var resetObserver = this$5.withRecover__F1__s_PartialFunction__Z__Lcom_raquo_airstream_core_Observer(onNext, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf, true);
  $m_Lcom_raquo_airstream_core_Observer$();
  var $x_1 = $m_sr_ScalaRunTime$();
  var this$6 = $m_Lcom_raquo_airstream_core_Observer$();
  var onNext$1 = $thiz.Lcom_raquo_laminar_inputs_InputController__f_listener.Lcom_raquo_laminar_modifiers_EventListener__f_callback;
  var observers = $x_1.wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_core_Observer.getArrayOf().constr)([this$6.withRecover__F1__s_PartialFunction__Z__Lcom_raquo_airstream_core_Observer(onNext$1, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf, true), resetObserver]));
  return new $c_Lcom_raquo_airstream_core_Observer$$anon$10(observers);
}
export { $p_Lcom_raquo_laminar_inputs_InputController__combinedObserver__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_core_Observer as $p_Lcom_raquo_laminar_inputs_InputController__combinedObserver__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_core_Observer };
function $p_Lcom_raquo_laminar_inputs_InputController__checkControllerCompatibility__V($thiz) {
  if ($thiz.Lcom_raquo_laminar_inputs_InputController__f_element.hasOtherControllerForSameProp__Lcom_raquo_laminar_inputs_InputController__Z($thiz)) {
    var propDomName$1 = $thiz.propDomName__T();
    var eventPropName$1 = $thiz.eventPropName__T();
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().com$raquo$laminar$inputs$InputController$$$errorMessage__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T__T__T(propDomName$1, eventPropName$1, $thiz.Lcom_raquo_laminar_inputs_InputController__f_element, (("Element already has a `" + $thiz.propDomName__T()) + "` controller."), ($m_Lcom_raquo_laminar_inputs_InputController$(), "")));
  }
  if ($thiz.Lcom_raquo_laminar_inputs_InputController__f_element.hasBinderForControllableProp__T__Z($thiz.propDomName__T())) {
    var propDomName$2 = $thiz.propDomName__T();
    var eventPropName$2 = $thiz.eventPropName__T();
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().com$raquo$laminar$inputs$InputController$$$errorMessage__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T__T__T(propDomName$2, eventPropName$2, $thiz.Lcom_raquo_laminar_inputs_InputController__f_element, (("Element already has an uncontrolled `" + $thiz.propDomName__T()) + " <-- ???` binder."), ($m_Lcom_raquo_laminar_inputs_InputController$(), "")));
  }
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  var element = $thiz.Lcom_raquo_laminar_inputs_InputController__f_element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
  if ($f_Lcom_raquo_laminar_domapi_DomTags__isCustomElement__Lorg_scalajs_dom_Element__Z(this$1, element)) {
    matchResult1: {
      var x1 = $thiz.Lcom_raquo_laminar_inputs_InputController__f_element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_tag;
      if (false) {
        var maybeAllowedConfigs = x1.allowedControllerConfigs__Lorg_scalajs_dom_HTMLElement__O($thiz.Lcom_raquo_laminar_inputs_InputController__f_element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref);
        if ((maybeAllowedConfigs === (void 0))) {
          var $x_1 = true;
        } else {
          if ((maybeAllowedConfigs === (void 0))) {
            throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
          }
          var $x_2 = maybeAllowedConfigs.length;
          var $x_1 = (($x_2 | 0) === 0);
        }
        if ($x_1) {
          var propDomName$3 = $thiz.propDomName__T();
          var eventPropName$3 = $thiz.eventPropName__T();
          throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().com$raquo$laminar$inputs$InputController$$$errorMessage__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T__T__T(propDomName$3, eventPropName$3, $thiz.Lcom_raquo_laminar_inputs_InputController__f_element, "This element does not support any controlled props.", ($m_Lcom_raquo_laminar_inputs_InputController$(), "")));
        } else {
          if ((maybeAllowedConfigs === (void 0))) {
            var maybeMatchingPropConfig = (void 0);
          } else {
            _return: {
              var len = (maybeAllowedConfigs.length | 0);
              var i = 0;
              while ((i < len)) {
                var x0 = maybeAllowedConfigs[i];
                var x = x0.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_prop;
                var x$2 = $thiz.Lcom_raquo_laminar_inputs_InputController__f_updater.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_key;
                if ((x === x$2)) {
                  var idx = i;
                  break _return;
                }
                i = ((1 + i) | 0);
              }
              var idx = (-1);
            }
            var opt = ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(maybeAllowedConfigs[idx]));
            if (opt.isEmpty__Z()) {
              var maybeMatchingPropConfig = (void 0);
            } else {
              var x0$1 = opt.get__O();
              var maybeMatchingPropConfig = x0$1;
            }
          }
          if ((maybeMatchingPropConfig === (void 0))) {
            if ((maybeAllowedConfigs === (void 0))) {
              var $x_5;
              throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
            } else {
              var $x_5 = maybeAllowedConfigs;
            }
            var $x_4 = $x_5.map(((_$5) => _$5.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_prop.Lcom_raquo_laminar_keys_HtmlProp__f_name));
            var $x_3 = $x_4.join("` or `");
            var expectedPropNames = (("`" + $x_3) + "`");
            throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().com$raquo$laminar$inputs$InputController$$$errorMessage__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T__T__T($thiz.propDomName__T(), $thiz.eventPropName__T(), $thiz.Lcom_raquo_laminar_inputs_InputController__f_element, (("This element does not support `" + $thiz.propDomName__T()) + "` controlled property"), (("Use " + expectedPropNames) + " controlled property instead")));
          } else {
            $p_Lcom_raquo_laminar_inputs_InputController__checkEventPropCompatibility__Lcom_raquo_ew_JsArray__V($thiz, maybeMatchingPropConfig.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_allowedEventProps);
            break matchResult1;
          }
        }
      }
    }
  } else {
    var expectedPropName = $thiz.Lcom_raquo_laminar_inputs_InputController__f_config.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_prop.Lcom_raquo_laminar_keys_HtmlProp__f_name;
    if (($thiz.propDomName__T() !== expectedPropName)) {
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().com$raquo$laminar$inputs$InputController$$$errorMessage__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T__T__T($thiz.propDomName__T(), $thiz.eventPropName__T(), $thiz.Lcom_raquo_laminar_inputs_InputController__f_element, (("This element does not support `" + $thiz.propDomName__T()) + "` controlled property"), (("Use `" + expectedPropName) + "` controlled property instead")));
    } else {
      $p_Lcom_raquo_laminar_inputs_InputController__checkEventPropCompatibility__Lcom_raquo_ew_JsArray__V($thiz, $thiz.Lcom_raquo_laminar_inputs_InputController__f_config.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_allowedEventProps);
    }
  }
}
export { $p_Lcom_raquo_laminar_inputs_InputController__checkControllerCompatibility__V as $p_Lcom_raquo_laminar_inputs_InputController__checkControllerCompatibility__V };
function $p_Lcom_raquo_laminar_inputs_InputController__checkEventPropCompatibility__Lcom_raquo_ew_JsArray__V($thiz, expectedEventProps) {
  var expectedEventProps$2 = $thiz.Lcom_raquo_laminar_inputs_InputController__f_config.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_allowedEventProps;
  _return: {
    var len = (expectedEventProps$2.length | 0);
    var i = 0;
    while ((i < len)) {
      var x0 = expectedEventProps$2[i];
      if ((x0.Lcom_raquo_laminar_keys_EventProp__f_name === $thiz.eventPropName__T())) {
        var $x_1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var $x_1 = (-1);
  }
  if (($x_1 < 0)) {
    var expectedEventPropNames = (("`" + expectedEventProps$2.map(((_$7) => _$7.Lcom_raquo_laminar_keys_EventProp__f_name)).join("` or `")) + "`");
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().com$raquo$laminar$inputs$InputController$$$errorMessage__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T__T__T($thiz.propDomName__T(), $thiz.eventPropName__T(), $thiz.Lcom_raquo_laminar_inputs_InputController__f_element, (("This element does not support `" + $thiz.eventPropName__T()) + "` event for controlled inputs"), (("Use " + expectedEventPropNames) + " event instead")));
  }
}
export { $p_Lcom_raquo_laminar_inputs_InputController__checkEventPropCompatibility__Lcom_raquo_ew_JsArray__V as $p_Lcom_raquo_laminar_inputs_InputController__checkEventPropCompatibility__Lcom_raquo_ew_JsArray__V };
/** @constructor */
function $c_Lcom_raquo_laminar_inputs_InputController(config, element, updater, listener) {
  this.Lcom_raquo_laminar_inputs_InputController__f_config = null;
  this.Lcom_raquo_laminar_inputs_InputController__f_element = null;
  this.Lcom_raquo_laminar_inputs_InputController__f_updater = null;
  this.Lcom_raquo_laminar_inputs_InputController__f_listener = null;
  this.Lcom_raquo_laminar_inputs_InputController__f_prevValue = null;
  this.Lcom_raquo_laminar_inputs_InputController__f_resetProcessor = null;
  this.Lcom_raquo_laminar_inputs_InputController__f_config = config;
  this.Lcom_raquo_laminar_inputs_InputController__f_element = element;
  this.Lcom_raquo_laminar_inputs_InputController__f_updater = updater;
  this.Lcom_raquo_laminar_inputs_InputController__f_listener = listener;
  this.Lcom_raquo_laminar_inputs_InputController__f_prevValue = config.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_initialValue;
  this.Lcom_raquo_laminar_inputs_InputController__f_resetProcessor = listener.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor.orElseEval__F1__Lcom_raquo_laminar_keys_EventProcessor(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V(this, this.Lcom_raquo_laminar_inputs_InputController__f_prevValue, false);
  })));
  $p_Lcom_raquo_laminar_inputs_InputController__setValue__O__Z__V(this, config.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_initialValue, true);
}
export { $c_Lcom_raquo_laminar_inputs_InputController as $c_Lcom_raquo_laminar_inputs_InputController };
$c_Lcom_raquo_laminar_inputs_InputController.prototype = new $h_O();
$c_Lcom_raquo_laminar_inputs_InputController.prototype.constructor = $c_Lcom_raquo_laminar_inputs_InputController;
/** @constructor */
function $h_Lcom_raquo_laminar_inputs_InputController() {
}
export { $h_Lcom_raquo_laminar_inputs_InputController as $h_Lcom_raquo_laminar_inputs_InputController };
$h_Lcom_raquo_laminar_inputs_InputController.prototype = $c_Lcom_raquo_laminar_inputs_InputController.prototype;
$c_Lcom_raquo_laminar_inputs_InputController.prototype.propDomName__T = (function() {
  return this.Lcom_raquo_laminar_inputs_InputController__f_updater.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_key.Lcom_raquo_laminar_keys_HtmlProp__f_name;
});
$c_Lcom_raquo_laminar_inputs_InputController.prototype.eventPropName__T = (function() {
  var prop = this.Lcom_raquo_laminar_inputs_InputController__f_listener.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor;
  return prop.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp.Lcom_raquo_laminar_keys_EventProp__f_name;
});
$c_Lcom_raquo_laminar_inputs_InputController.prototype.bind__Lcom_raquo_airstream_ownership_DynamicSubscription = (function() {
  var element$2 = this.Lcom_raquo_laminar_inputs_InputController__f_element;
  var subscribe = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ctx) => {
    $p_Lcom_raquo_laminar_inputs_InputController__checkControllerCompatibility__V(this);
    var this$2 = this.Lcom_raquo_laminar_inputs_InputController__f_element;
    var x = this$2.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners;
    if ((x !== (void 0))) {
      var i = 0;
      var len = (x.length | 0);
      while ((i < len)) {
        var arg1$2 = x[i];
        var this$11 = $m_Lcom_raquo_laminar_domapi_DomApi$();
        var element = this.Lcom_raquo_laminar_inputs_InputController__f_element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
        $f_Lcom_raquo_laminar_domapi_DomEvents__removeEventListener__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_modifiers_EventListener__V(this$11, element, arg1$2);
        i = ((1 + i) | 0);
      }
    }
    var this$12 = this.Lcom_raquo_laminar_inputs_InputController__f_resetProcessor;
    var sink = $p_Lcom_raquo_laminar_inputs_InputController__combinedObserver__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_core_Observer(this, ctx.Lcom_raquo_laminar_lifecycle_MountContext__f_owner);
    var onNext = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
      sink.onNext__O__V(_$1);
    }));
    var dynSub = new $c_Lcom_raquo_laminar_modifiers_EventListener(this$12, onNext).bind__Lcom_raquo_laminar_nodes_ReactiveElement__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(this.Lcom_raquo_laminar_inputs_InputController__f_element, true);
    var this$13 = this.Lcom_raquo_laminar_inputs_InputController__f_element;
    var x$1 = this$13.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners;
    if ((x$1 !== (void 0))) {
      var i$1 = 0;
      var len$1 = (x$1.length | 0);
      while ((i$1 < len$1)) {
        var arg1$2$1 = x$1[i$1];
        var this$22 = $m_Lcom_raquo_laminar_domapi_DomApi$();
        var element$1 = this.Lcom_raquo_laminar_inputs_InputController__f_element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
        $f_Lcom_raquo_laminar_domapi_DomEvents__addEventListener__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_modifiers_EventListener__V(this$22, element$1, arg1$2$1);
        i$1 = ((1 + i$1) | 0);
      }
    }
    return new $c_Lcom_raquo_airstream_ownership_Subscription(ctx.Lcom_raquo_laminar_lifecycle_MountContext__f_owner, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      dynSub.kill__V();
    })));
  }));
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().unsafe__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(element$2.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_dynamicOwner, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((owner) => subscribe.apply__O__O(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element$2, owner)))), false);
});
var $d_Lcom_raquo_laminar_inputs_InputController = new $TypeData().initClass($c_Lcom_raquo_laminar_inputs_InputController, "com.raquo.laminar.inputs.InputController", ({
  Lcom_raquo_laminar_inputs_InputController: 1
}));
export { $d_Lcom_raquo_laminar_inputs_InputController as $d_Lcom_raquo_laminar_inputs_InputController };
function $p_Lcom_raquo_laminar_inputs_InputController$__nodeDescription__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T($thiz, element) {
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  var attr = $m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.typ__Lcom_raquo_laminar_keys_HtmlAttr();
  var maybeTyp = $f_Lcom_raquo_laminar_domapi_DomKeys__getAttribute__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_laminar_keys_SimpleAttr__O(this$1, element, attr);
  if ((maybeTyp === (void 0))) {
    var x = (void 0);
  } else {
    var a = ((" [type=" + maybeTyp) + "]");
    var x = a;
  }
  var typSuffix = ((x === (void 0)) ? "" : x);
  var this$15 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  var node = element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
  return (("" + $f_Lcom_raquo_laminar_domapi_DomDebug__debugNodeDescription__Lorg_scalajs_dom_Node__T(this$15, node)) + typSuffix);
}
export { $p_Lcom_raquo_laminar_inputs_InputController$__nodeDescription__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T as $p_Lcom_raquo_laminar_inputs_InputController$__nodeDescription__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T };
/** @constructor */
function $c_Lcom_raquo_laminar_inputs_InputController$() {
  this.Lcom_raquo_laminar_inputs_InputController$__f_textValueConfig = null;
  this.Lcom_raquo_laminar_inputs_InputController$__f_selectValueConfig = null;
  this.Lcom_raquo_laminar_inputs_InputController$__f_checkedConfig = null;
  this.Lcom_raquo_laminar_inputs_InputController$__f_htmlControllableProps = null;
  $n_Lcom_raquo_laminar_inputs_InputController$ = this;
  this.Lcom_raquo_laminar_inputs_InputController$__f_textValueConfig = new $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig("", $m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.value__Lcom_raquo_laminar_keys_HtmlProp(), $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_keys_EventProp.getArrayOf().constr)([$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.onInput__Lcom_raquo_laminar_keys_EventProp()]))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((el) => {
    var this$2 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    var element = el.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
    var x = $f_Lcom_raquo_laminar_domapi_DomInputs__getValue__Lorg_scalajs_dom_Element__O(this$2, element);
    return ((x === (void 0)) ? "" : x);
  })), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((el$2, v) => {
    var this$8 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    var element$1 = el$2.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
    $f_Lcom_raquo_laminar_domapi_DomInputs__setValue__Lorg_scalajs_dom_Element__T__Z(this$8, element$1, v);
  })));
  this.Lcom_raquo_laminar_inputs_InputController$__f_selectValueConfig = new $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig("", $m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.value__Lcom_raquo_laminar_keys_HtmlProp(), $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_keys_EventProp.getArrayOf().constr)([$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.onInput__Lcom_raquo_laminar_keys_EventProp(), $m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.onChange__Lcom_raquo_laminar_keys_EventProp()]))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((el$3) => {
    var this$9 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    var element$2 = el$3.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
    var x$1 = $f_Lcom_raquo_laminar_domapi_DomInputs__getValue__Lorg_scalajs_dom_Element__O(this$9, element$2);
    return ((x$1 === (void 0)) ? "" : x$1);
  })), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((el$4, v$2) => {
    var this$15 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    var element$3 = el$4.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
    $f_Lcom_raquo_laminar_domapi_DomInputs__setValue__Lorg_scalajs_dom_Element__T__Z(this$15, element$3, v$2);
  })));
  this.Lcom_raquo_laminar_inputs_InputController$__f_checkedConfig = new $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig(false, $m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.checked__Lcom_raquo_laminar_keys_HtmlProp(), $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_keys_EventProp.getArrayOf().constr)([$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.onInput__Lcom_raquo_laminar_keys_EventProp(), $m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L.onClick__Lcom_raquo_laminar_keys_EventProp()]))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((el$5) => {
    var this$16 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    var element$4 = el$5.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
    var x$2 = $f_Lcom_raquo_laminar_domapi_DomInputs__getChecked__Lorg_scalajs_dom_Element__O(this$16, element$4);
    return (!(!((x$2 === (void 0)) ? false : x$2)));
  })), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((v1, v2) => {
    var v$1 = (!(!v2));
    var this$22 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    var element$5 = v1.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
    $f_Lcom_raquo_laminar_domapi_DomInputs__setChecked__Lorg_scalajs_dom_Element__Z__Z(this$22, element$5, v$1);
  })));
  this.Lcom_raquo_laminar_inputs_InputController$__f_htmlControllableProps = $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["value", "checked"])));
}
export { $c_Lcom_raquo_laminar_inputs_InputController$ as $c_Lcom_raquo_laminar_inputs_InputController$ };
$c_Lcom_raquo_laminar_inputs_InputController$.prototype = new $h_O();
$c_Lcom_raquo_laminar_inputs_InputController$.prototype.constructor = $c_Lcom_raquo_laminar_inputs_InputController$;
/** @constructor */
function $h_Lcom_raquo_laminar_inputs_InputController$() {
}
export { $h_Lcom_raquo_laminar_inputs_InputController$ as $h_Lcom_raquo_laminar_inputs_InputController$ };
$h_Lcom_raquo_laminar_inputs_InputController$.prototype = $c_Lcom_raquo_laminar_inputs_InputController$.prototype;
$c_Lcom_raquo_laminar_inputs_InputController$.prototype.controlled__Lcom_raquo_laminar_modifiers_EventListener__Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__Lcom_raquo_laminar_modifiers_Binder = (function(listener, updater) {
  var fn = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((element) => {
    var propDomName = updater.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_key.Lcom_raquo_laminar_keys_HtmlProp__f_name;
    var maybeControllableProps = element.controllableProps__O();
    var isControllableProp = ((maybeControllableProps !== (void 0)) && $m_Lcom_raquo_ew_JsArray$RichJsArray$().includes$extension__Lcom_raquo_ew_JsArray__O__I__Z(maybeControllableProps, propDomName, 0));
    if (isControllableProp) {
      var this$8 = $m_Lcom_raquo_laminar_domapi_DomApi$();
      var element$1 = element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
      if ($f_Lcom_raquo_laminar_domapi_DomTags__isCustomElement__Lorg_scalajs_dom_Element__Z(this$8, element$1)) {
        matchResult2: {
          var controller;
          var x3 = element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_tag;
          if (false) {
            var x = x3.allowableControllerConfigForProp__Lcom_raquo_laminar_keys_HtmlProp__O(updater.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_key);
            if ((x === (void 0))) {
              var prop = listener.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor;
              var eventPropName = prop.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp.Lcom_raquo_laminar_keys_EventProp__f_name;
              throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().com$raquo$laminar$inputs$InputController$$$errorMessage__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T__T__T(updater.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_key.Lcom_raquo_laminar_keys_HtmlProp__f_name, eventPropName, element, (("This element does not support `" + propDomName) + "` controlled property in its current configuration"), "Make sure you passed the right props / attributes, such as `type` for HTML inputs."));
            }
            var controller = new $c_Lcom_raquo_laminar_inputs_InputController(x, element, updater, listener);
            break matchResult2;
          }
          throw $ct_jl_Exception__T__(new $c_jl_Exception(), (("Custom element `" + $p_Lcom_raquo_laminar_inputs_InputController$__nodeDescription__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T(this, element)) + "` must use CustomHtmlTag in order to support `controlled` inputs."));
        }
      } else {
        var x$1 = this.allowedHtmlControllerConfig__Lorg_scalajs_dom_HTMLElement__O(element.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref);
        if ((x$1 === (void 0))) {
          var prop$1 = listener.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor;
          var eventPropName$1 = prop$1.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp.Lcom_raquo_laminar_keys_EventProp__f_name;
          throw $ct_jl_Exception__T__(new $c_jl_Exception(), this.com$raquo$laminar$inputs$InputController$$$errorMessage__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T__T__T(propDomName, eventPropName$1, element, "This element does not support any controlled input props.", ""));
        }
        var controller = new $c_Lcom_raquo_laminar_inputs_InputController(x$1, element, updater, listener);
      }
      return element.bindController__Lcom_raquo_laminar_inputs_InputController__Lcom_raquo_airstream_ownership_DynamicSubscription(controller);
    } else {
      var prop$2 = listener.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor;
      var eventPropName$2 = prop$2.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp.Lcom_raquo_laminar_keys_EventProp__f_name;
      if ((maybeControllableProps === (void 0))) {
        throw $ct_jl_Exception__T__(new $c_jl_Exception(), this.com$raquo$laminar$inputs$InputController$$$errorMessage__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T__T__T(propDomName, eventPropName$2, element, "This element does not support any controlled input props.", ""));
      }
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), $m_Lcom_raquo_laminar_inputs_InputController$().com$raquo$laminar$inputs$InputController$$$errorMessage__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T__T__T(propDomName, eventPropName$2, element, (("This element does not support `" + propDomName) + "` controlled property"), (("Use `" + maybeControllableProps.join("` or `")) + "` controlled property instead")));
    }
  }));
  return new $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(fn);
});
$c_Lcom_raquo_laminar_inputs_InputController$.prototype.allowedHtmlControllerConfig__Lorg_scalajs_dom_HTMLElement__O = (function(element) {
  if ((!(!(element instanceof HTMLInputElement)))) {
    var x5 = element.type;
    switch (x5) {
      case "text": {
        return this.Lcom_raquo_laminar_inputs_InputController$__f_textValueConfig;
        break;
      }
      case "checkbox":
      case "radio": {
        return this.Lcom_raquo_laminar_inputs_InputController$__f_checkedConfig;
        break;
      }
      case "file": {
        return (void 0);
        break;
      }
      default: {
        return this.Lcom_raquo_laminar_inputs_InputController$__f_textValueConfig;
      }
    }
  } else {
    return ((!(!(element instanceof HTMLTextAreaElement))) ? this.Lcom_raquo_laminar_inputs_InputController$__f_textValueConfig : ((!(!(element instanceof HTMLSelectElement))) ? this.Lcom_raquo_laminar_inputs_InputController$__f_selectValueConfig : (void 0)));
  }
});
$c_Lcom_raquo_laminar_inputs_InputController$.prototype.com$raquo$laminar$inputs$InputController$$$errorMessage__T__T__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T__T__T = (function(propDomName, eventPropName, element, reason, suggestion) {
  return $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([(((((("Can not add input controller (prop: `" + propDomName) + "` + event: `") + eventPropName) + "`) to element `") + $p_Lcom_raquo_laminar_inputs_InputController$__nodeDescription__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__T($m_Lcom_raquo_laminar_inputs_InputController$(), element)) + "`"), ((reason !== "") ? ("- Cause: " + reason) : ""), ((suggestion !== "") ? ("- Suggestion: " + suggestion) : "")]))).filter(((_$9) => (_$9 !== ""))).join("\n");
});
var $d_Lcom_raquo_laminar_inputs_InputController$ = new $TypeData().initClass($c_Lcom_raquo_laminar_inputs_InputController$, "com.raquo.laminar.inputs.InputController$", ({
  Lcom_raquo_laminar_inputs_InputController$: 1
}));
export { $d_Lcom_raquo_laminar_inputs_InputController$ as $d_Lcom_raquo_laminar_inputs_InputController$ };
var $n_Lcom_raquo_laminar_inputs_InputController$;
function $m_Lcom_raquo_laminar_inputs_InputController$() {
  if ((!$n_Lcom_raquo_laminar_inputs_InputController$)) {
    $n_Lcom_raquo_laminar_inputs_InputController$ = new $c_Lcom_raquo_laminar_inputs_InputController$();
  }
  return $n_Lcom_raquo_laminar_inputs_InputController$;
}
export { $m_Lcom_raquo_laminar_inputs_InputController$ as $m_Lcom_raquo_laminar_inputs_InputController$ };
/** @constructor */
function $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig(initialValue, prop, allowedEventProps, getDomValue, setDomValue) {
  this.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_initialValue = null;
  this.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_prop = null;
  this.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_allowedEventProps = null;
  this.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_getDomValue = null;
  this.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_setDomValue = null;
  this.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_initialValue = initialValue;
  this.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_prop = prop;
  this.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_allowedEventProps = allowedEventProps;
  this.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_getDomValue = getDomValue;
  this.Lcom_raquo_laminar_inputs_InputController$InputControllerConfig__f_setDomValue = setDomValue;
}
export { $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig as $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig };
$c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig.prototype = new $h_O();
$c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig.prototype.constructor = $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig;
/** @constructor */
function $h_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig() {
}
export { $h_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig as $h_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig };
$h_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig.prototype = $c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig.prototype;
var $d_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig = new $TypeData().initClass($c_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig, "com.raquo.laminar.inputs.InputController$InputControllerConfig", ({
  Lcom_raquo_laminar_inputs_InputController$InputControllerConfig: 1
}));
export { $d_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig as $d_Lcom_raquo_laminar_inputs_InputController$InputControllerConfig };
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_ChildInserter$() {
}
export { $c_Lcom_raquo_laminar_inserters_ChildInserter$ as $c_Lcom_raquo_laminar_inserters_ChildInserter$ };
$c_Lcom_raquo_laminar_inserters_ChildInserter$.prototype = new $h_O();
$c_Lcom_raquo_laminar_inserters_ChildInserter$.prototype.constructor = $c_Lcom_raquo_laminar_inserters_ChildInserter$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_ChildInserter$() {
}
export { $h_Lcom_raquo_laminar_inserters_ChildInserter$ as $h_Lcom_raquo_laminar_inserters_ChildInserter$ };
$h_Lcom_raquo_laminar_inserters_ChildInserter$.prototype = $c_Lcom_raquo_laminar_inserters_ChildInserter$.prototype;
$c_Lcom_raquo_laminar_inserters_ChildInserter$.prototype.apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableNode__O__Lcom_raquo_laminar_inserters_DynamicInserter = (function(childSource, renderable, initialHooks) {
  return new $c_Lcom_raquo_laminar_inserters_DynamicInserter($m_s_None$(), new $c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((ctx, owner, hooks) => {
    ctx.ensureStrictMode__V();
    var maybeLastSeenChild = new $c_sr_ObjectRef((void 0));
    return $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(childSource, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ctx$2) => ((newComponent) => {
      var newChildNode = renderable.asNode__O__Lcom_raquo_laminar_nodes_ChildNode(newComponent);
      $m_Lcom_raquo_laminar_inserters_ChildInserter$().switchToChild__O__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_inserters_InsertContext__O__V(maybeLastSeenChild.sr_ObjectRef__f_elem, newChildNode, ctx$2, hooks);
      maybeLastSeenChild.sr_ObjectRef__f_elem = newChildNode;
    }))(ctx)), owner);
  })), initialHooks);
});
$c_Lcom_raquo_laminar_inserters_ChildInserter$.prototype.switchToChild__O__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_inserters_InsertContext__O__V = (function(maybeLastSeenChild, newChildNode, ctx, hooks) {
  ctx.ensureStrictMode__V();
  var elem = ctx.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodeCount;
  var elem$1 = 0;
  elem$1 = elem;
  if ((maybeLastSeenChild === (void 0))) {
    var $x_1 = true;
  } else {
    var x = maybeLastSeenChild.ref__Lorg_scalajs_dom_Node();
    var y = ctx.Lcom_raquo_laminar_inserters_InsertContext__f_sentinelNode.ref__Lorg_scalajs_dom_Node().nextSibling;
    var $x_1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  }
  if ($x_1) {
    var x$1 = maybeLastSeenChild;
  } else {
    var x$1 = (void 0);
  }
  if ((x$1 === (void 0))) {
    var this$11 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    var parent = ctx.Lcom_raquo_laminar_inserters_InsertContext__f_parentNode;
    var referenceChild = ctx.Lcom_raquo_laminar_inserters_InsertContext__f_sentinelNode;
    $f_Lcom_raquo_laminar_domapi_DomTree__insertChildAfter__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$11, parent, newChildNode, referenceChild, hooks);
  } else {
    var this$13 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    var parent$1 = ctx.Lcom_raquo_laminar_inserters_InsertContext__f_parentNode;
    var replaced = $f_Lcom_raquo_laminar_domapi_DomTree__replaceChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$13, parent$1, x$1, newChildNode, hooks);
    if ((replaced || (x$1 === newChildNode))) {
      elem$1 = (((-1) + elem$1) | 0);
    }
  }
  ctx.removeOldChildNodesFromDOM__Lcom_raquo_laminar_nodes_ChildNode__V(newChildNode);
  ctx.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodesMap.clear();
  ctx.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodesMap.set(newChildNode.ref__Lorg_scalajs_dom_Node(), newChildNode);
  ctx.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodeCount = 1;
});
var $d_Lcom_raquo_laminar_inserters_ChildInserter$ = new $TypeData().initClass($c_Lcom_raquo_laminar_inserters_ChildInserter$, "com.raquo.laminar.inserters.ChildInserter$", ({
  Lcom_raquo_laminar_inserters_ChildInserter$: 1
}));
export { $d_Lcom_raquo_laminar_inserters_ChildInserter$ as $d_Lcom_raquo_laminar_inserters_ChildInserter$ };
var $n_Lcom_raquo_laminar_inserters_ChildInserter$;
function $m_Lcom_raquo_laminar_inserters_ChildInserter$() {
  if ((!$n_Lcom_raquo_laminar_inserters_ChildInserter$)) {
    $n_Lcom_raquo_laminar_inserters_ChildInserter$ = new $c_Lcom_raquo_laminar_inserters_ChildInserter$();
  }
  return $n_Lcom_raquo_laminar_inserters_ChildInserter$;
}
export { $m_Lcom_raquo_laminar_inserters_ChildInserter$ as $m_Lcom_raquo_laminar_inserters_ChildInserter$ };
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_ChildTextInserter$() {
}
export { $c_Lcom_raquo_laminar_inserters_ChildTextInserter$ as $c_Lcom_raquo_laminar_inserters_ChildTextInserter$ };
$c_Lcom_raquo_laminar_inserters_ChildTextInserter$.prototype = new $h_O();
$c_Lcom_raquo_laminar_inserters_ChildTextInserter$.prototype.constructor = $c_Lcom_raquo_laminar_inserters_ChildTextInserter$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_ChildTextInserter$() {
}
export { $h_Lcom_raquo_laminar_inserters_ChildTextInserter$ as $h_Lcom_raquo_laminar_inserters_ChildTextInserter$ };
$h_Lcom_raquo_laminar_inserters_ChildTextInserter$.prototype = $c_Lcom_raquo_laminar_inserters_ChildTextInserter$.prototype;
$c_Lcom_raquo_laminar_inserters_ChildTextInserter$.prototype.apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_inserters_DynamicInserter = (function(textSource, renderable) {
  return new $c_Lcom_raquo_laminar_inserters_DynamicInserter($m_s_None$(), new $c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((ctx, owner, _$1) => {
    var maybeTextNode = new $c_sr_ObjectRef((void 0));
    return $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription(textSource, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ctx$2) => ((newValue) => {
      var newText = renderable.asString__O__T(newValue);
      var x = maybeTextNode.sr_ObjectRef__f_elem;
      if ((x === (void 0))) {
        var newTextNode = new $c_Lcom_raquo_laminar_nodes_TextNode(newText);
        $m_Lcom_raquo_laminar_inserters_ChildTextInserter$().switchToChild__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_inserters_InsertContext__V(newTextNode, ctx$2);
        maybeTextNode.sr_ObjectRef__f_elem = newTextNode;
      } else {
        x.Lcom_raquo_laminar_nodes_TextNode__f_ref.textContent = newText;
      }
    }))(ctx)), owner);
  })), (void 0));
});
$c_Lcom_raquo_laminar_inserters_ChildTextInserter$.prototype.switchToChild__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_inserters_InsertContext__V = (function(newTextOrCommentNode, ctx) {
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  var parent = ctx.Lcom_raquo_laminar_inserters_InsertContext__f_parentNode;
  var oldChild = ctx.Lcom_raquo_laminar_inserters_InsertContext__f_sentinelNode;
  $f_Lcom_raquo_laminar_domapi_DomTree__replaceChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$1, parent, oldChild, newTextOrCommentNode, (void 0));
  ctx.Lcom_raquo_laminar_inserters_InsertContext__f_sentinelNode = newTextOrCommentNode;
  if (ctx.Lcom_raquo_laminar_inserters_InsertContext__f_strictMode) {
    ctx.Lcom_raquo_laminar_inserters_InsertContext__f_strictMode = false;
    ctx.removeOldChildNodesFromDOM__Lcom_raquo_laminar_nodes_ChildNode__V(newTextOrCommentNode);
    ctx.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodesMap.clear();
    ctx.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodeCount = 0;
  }
});
var $d_Lcom_raquo_laminar_inserters_ChildTextInserter$ = new $TypeData().initClass($c_Lcom_raquo_laminar_inserters_ChildTextInserter$, "com.raquo.laminar.inserters.ChildTextInserter$", ({
  Lcom_raquo_laminar_inserters_ChildTextInserter$: 1
}));
export { $d_Lcom_raquo_laminar_inserters_ChildTextInserter$ as $d_Lcom_raquo_laminar_inserters_ChildTextInserter$ };
var $n_Lcom_raquo_laminar_inserters_ChildTextInserter$;
function $m_Lcom_raquo_laminar_inserters_ChildTextInserter$() {
  if ((!$n_Lcom_raquo_laminar_inserters_ChildTextInserter$)) {
    $n_Lcom_raquo_laminar_inserters_ChildTextInserter$ = new $c_Lcom_raquo_laminar_inserters_ChildTextInserter$();
  }
  return $n_Lcom_raquo_laminar_inserters_ChildTextInserter$;
}
export { $m_Lcom_raquo_laminar_inserters_ChildTextInserter$ as $m_Lcom_raquo_laminar_inserters_ChildTextInserter$ };
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_InsertContext(parentNode, sentinelNode, strictMode, extraNodeCount, extraNodesMap) {
  this.Lcom_raquo_laminar_inserters_InsertContext__f_parentNode = null;
  this.Lcom_raquo_laminar_inserters_InsertContext__f_sentinelNode = null;
  this.Lcom_raquo_laminar_inserters_InsertContext__f_strictMode = false;
  this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodeCount = 0;
  this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodesMap = null;
  this.Lcom_raquo_laminar_inserters_InsertContext__f_parentNode = parentNode;
  this.Lcom_raquo_laminar_inserters_InsertContext__f_sentinelNode = sentinelNode;
  this.Lcom_raquo_laminar_inserters_InsertContext__f_strictMode = strictMode;
  this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodeCount = extraNodeCount;
  this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodesMap = extraNodesMap;
}
export { $c_Lcom_raquo_laminar_inserters_InsertContext as $c_Lcom_raquo_laminar_inserters_InsertContext };
$c_Lcom_raquo_laminar_inserters_InsertContext.prototype = new $h_O();
$c_Lcom_raquo_laminar_inserters_InsertContext.prototype.constructor = $c_Lcom_raquo_laminar_inserters_InsertContext;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_InsertContext() {
}
export { $h_Lcom_raquo_laminar_inserters_InsertContext as $h_Lcom_raquo_laminar_inserters_InsertContext };
$h_Lcom_raquo_laminar_inserters_InsertContext.prototype = $c_Lcom_raquo_laminar_inserters_InsertContext.prototype;
$c_Lcom_raquo_laminar_inserters_InsertContext.prototype.ensureStrictMode__V = (function() {
  if ((!this.Lcom_raquo_laminar_inserters_InsertContext__f_strictMode)) {
    if ((this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodeCount !== 0)) {
      var $x_1 = this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodeCount;
      var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
      var node = this.Lcom_raquo_laminar_inserters_InsertContext__f_parentNode.ref__Lorg_scalajs_dom_Node();
      throw $ct_jl_Exception__T__(new $c_jl_Exception(), ((("forceSetStrictMode invoked when extraNodeCount = " + $x_1) + " on parent node ") + $f_Lcom_raquo_laminar_domapi_DomDebug__debugNodeOuterHtml__Lorg_scalajs_dom_Node__T(this$1, node)));
    }
    if ((this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodesMap === null)) {
      this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodesMap = new Map();
    }
    if ((!(!(!(this.Lcom_raquo_laminar_inserters_InsertContext__f_sentinelNode.ref__Lorg_scalajs_dom_Node() instanceof Comment))))) {
      var contentNode = this.Lcom_raquo_laminar_inserters_InsertContext__f_sentinelNode;
      var newSentinelNode = new $c_Lcom_raquo_laminar_nodes_CommentNode("");
      var this$2 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
      var parent = this.Lcom_raquo_laminar_inserters_InsertContext__f_parentNode.ref__Lorg_scalajs_dom_Node();
      var newChild = newSentinelNode.Lcom_raquo_laminar_nodes_CommentNode__f_ref;
      var referenceChild = contentNode.ref__Lorg_scalajs_dom_Node();
      $f_Lcom_raquo_laminar_domapi_DomTreeRaw__insertBefore__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Lorg_scalajs_dom_Node__Z(this$2, parent, newChild, referenceChild);
      this.Lcom_raquo_laminar_inserters_InsertContext__f_sentinelNode = newSentinelNode;
      this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodeCount = 1;
      this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodesMap.set(contentNode.ref__Lorg_scalajs_dom_Node(), contentNode);
    }
    this.Lcom_raquo_laminar_inserters_InsertContext__f_strictMode = true;
  }
});
$c_Lcom_raquo_laminar_inserters_InsertContext.prototype.removeOldChildNodesFromDOM__Lcom_raquo_laminar_nodes_ChildNode__V = (function(after) {
  var elem = this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodeCount;
  var elem$1 = 0;
  elem$1 = elem;
  while ((elem$1 > 0)) {
    var prevChildRef = after.ref__Lorg_scalajs_dom_Node().nextSibling;
    if ((prevChildRef === null)) {
      elem$1 = 0;
    } else {
      var maybePrevChild = this.Lcom_raquo_laminar_inserters_InsertContext__f_extraNodesMap.get(prevChildRef);
      if ((maybePrevChild === (void 0))) {
        elem$1 = 0;
      } else if ((maybePrevChild !== (void 0))) {
        var this$10 = $m_Lcom_raquo_laminar_domapi_DomApi$();
        var parent = this.Lcom_raquo_laminar_inserters_InsertContext__f_parentNode;
        $f_Lcom_raquo_laminar_domapi_DomTree__removeChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__Z(this$10, parent, maybePrevChild);
        elem$1 = (((-1) + elem$1) | 0);
      }
    }
  }
});
var $d_Lcom_raquo_laminar_inserters_InsertContext = new $TypeData().initClass($c_Lcom_raquo_laminar_inserters_InsertContext, "com.raquo.laminar.inserters.InsertContext", ({
  Lcom_raquo_laminar_inserters_InsertContext: 1
}));
export { $d_Lcom_raquo_laminar_inserters_InsertContext as $d_Lcom_raquo_laminar_inserters_InsertContext };
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_InsertContext$() {
}
export { $c_Lcom_raquo_laminar_inserters_InsertContext$ as $c_Lcom_raquo_laminar_inserters_InsertContext$ };
$c_Lcom_raquo_laminar_inserters_InsertContext$.prototype = new $h_O();
$c_Lcom_raquo_laminar_inserters_InsertContext$.prototype.constructor = $c_Lcom_raquo_laminar_inserters_InsertContext$;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_InsertContext$() {
}
export { $h_Lcom_raquo_laminar_inserters_InsertContext$ as $h_Lcom_raquo_laminar_inserters_InsertContext$ };
$h_Lcom_raquo_laminar_inserters_InsertContext$.prototype = $c_Lcom_raquo_laminar_inserters_InsertContext$.prototype;
$c_Lcom_raquo_laminar_inserters_InsertContext$.prototype.reserveSpotContext__Lcom_raquo_laminar_nodes_ReactiveElement__O__Lcom_raquo_laminar_inserters_InsertContext = (function(parentNode, hooks) {
  var sentinelNode = new $c_Lcom_raquo_laminar_nodes_CommentNode("");
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  $f_Lcom_raquo_laminar_domapi_DomTree__appendChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$1, parentNode, sentinelNode, hooks);
  return new $c_Lcom_raquo_laminar_inserters_InsertContext(parentNode, sentinelNode, false, 0, null);
});
$c_Lcom_raquo_laminar_inserters_InsertContext$.prototype.nodesToMap__Lcom_raquo_laminar_Seq__Lcom_raquo_ew_JsMap = (function(nodes) {
  var acc = new Map();
  nodes.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((node) => {
    acc.set(node.ref__Lorg_scalajs_dom_Node(), node);
  })));
  return acc;
});
var $d_Lcom_raquo_laminar_inserters_InsertContext$ = new $TypeData().initClass($c_Lcom_raquo_laminar_inserters_InsertContext$, "com.raquo.laminar.inserters.InsertContext$", ({
  Lcom_raquo_laminar_inserters_InsertContext$: 1
}));
export { $d_Lcom_raquo_laminar_inserters_InsertContext$ as $d_Lcom_raquo_laminar_inserters_InsertContext$ };
var $n_Lcom_raquo_laminar_inserters_InsertContext$;
function $m_Lcom_raquo_laminar_inserters_InsertContext$() {
  if ((!$n_Lcom_raquo_laminar_inserters_InsertContext$)) {
    $n_Lcom_raquo_laminar_inserters_InsertContext$ = new $c_Lcom_raquo_laminar_inserters_InsertContext$();
  }
  return $n_Lcom_raquo_laminar_inserters_InsertContext$;
}
export { $m_Lcom_raquo_laminar_inserters_InsertContext$ as $m_Lcom_raquo_laminar_inserters_InsertContext$ };
function $ct_Lcom_raquo_laminar_keys_CompositeKey__($thiz) {
  $thiz.Lcom_raquo_laminar_keys_CompositeKey__f_codec = new $c_Lcom_raquo_laminar_codecs_CompositeCodec($thiz.Lcom_raquo_laminar_keys_CompositeAttr__f_separator);
  return $thiz;
}
export { $ct_Lcom_raquo_laminar_keys_CompositeKey__ as $ct_Lcom_raquo_laminar_keys_CompositeKey__ };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeKey() {
  this.Lcom_raquo_laminar_keys_CompositeKey__f_codec = null;
}
export { $c_Lcom_raquo_laminar_keys_CompositeKey as $c_Lcom_raquo_laminar_keys_CompositeKey };
$c_Lcom_raquo_laminar_keys_CompositeKey.prototype = new $h_O();
$c_Lcom_raquo_laminar_keys_CompositeKey.prototype.constructor = $c_Lcom_raquo_laminar_keys_CompositeKey;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeKey() {
}
export { $h_Lcom_raquo_laminar_keys_CompositeKey as $h_Lcom_raquo_laminar_keys_CompositeKey };
$h_Lcom_raquo_laminar_keys_CompositeKey.prototype = $c_Lcom_raquo_laminar_keys_CompositeKey.prototype;
$c_Lcom_raquo_laminar_keys_CompositeKey.prototype.$colon$eq__T__Lcom_raquo_laminar_modifiers_CompositeKeySetter = (function(items) {
  $m_Lcom_raquo_laminar_api_package$().StringValueMapper__Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$();
  var separator = this.Lcom_raquo_laminar_keys_CompositeAttr__f_separator;
  var normalizedItems = $m_Lcom_raquo_laminar_codecs_CompositeCodec$().normalize__T__T__sci_List(items, separator);
  return new $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter(this, normalizedItems);
});
$c_Lcom_raquo_laminar_keys_CompositeKey.prototype.$colon$eq__sci_Seq__Lcom_raquo_laminar_keys_CompositeValueMapper__Lcom_raquo_laminar_modifiers_CompositeKeySetter = (function(value, mapper) {
  var normalizedItems = mapper.toNormalizedList__O__T__sci_List(value, this.Lcom_raquo_laminar_keys_CompositeAttr__f_separator);
  return new $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter(this, normalizedItems);
});
/** @constructor */
function $c_Lcom_raquo_laminar_keys_EventProp(name) {
  this.Lcom_raquo_laminar_keys_EventProp__f_name = null;
  this.Lcom_raquo_laminar_keys_EventProp__f_name = name;
}
export { $c_Lcom_raquo_laminar_keys_EventProp as $c_Lcom_raquo_laminar_keys_EventProp };
$c_Lcom_raquo_laminar_keys_EventProp.prototype = new $h_O();
$c_Lcom_raquo_laminar_keys_EventProp.prototype.constructor = $c_Lcom_raquo_laminar_keys_EventProp;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_EventProp() {
}
export { $h_Lcom_raquo_laminar_keys_EventProp as $h_Lcom_raquo_laminar_keys_EventProp };
$h_Lcom_raquo_laminar_keys_EventProp.prototype = $c_Lcom_raquo_laminar_keys_EventProp.prototype;
var $d_Lcom_raquo_laminar_keys_EventProp = new $TypeData().initClass($c_Lcom_raquo_laminar_keys_EventProp, "com.raquo.laminar.keys.EventProp", ({
  Lcom_raquo_laminar_keys_EventProp: 1
}));
export { $d_Lcom_raquo_laminar_keys_EventProp as $d_Lcom_raquo_laminar_keys_EventProp };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_HtmlProp$() {
}
export { $c_Lcom_raquo_laminar_keys_HtmlProp$ as $c_Lcom_raquo_laminar_keys_HtmlProp$ };
$c_Lcom_raquo_laminar_keys_HtmlProp$.prototype = new $h_O();
$c_Lcom_raquo_laminar_keys_HtmlProp$.prototype.constructor = $c_Lcom_raquo_laminar_keys_HtmlProp$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_HtmlProp$() {
}
export { $h_Lcom_raquo_laminar_keys_HtmlProp$ as $h_Lcom_raquo_laminar_keys_HtmlProp$ };
$h_Lcom_raquo_laminar_keys_HtmlProp$.prototype = $c_Lcom_raquo_laminar_keys_HtmlProp$.prototype;
$c_Lcom_raquo_laminar_keys_HtmlProp$.prototype.apply__T__s_Option__Lcom_raquo_laminar_codecs_Codec__Lcom_raquo_laminar_keys_HtmlProp = (function(name, reflectedAttrName, codec) {
  return new $c_Lcom_raquo_laminar_keys_HtmlProp$$anon$1(name, reflectedAttrName, codec);
});
var $d_Lcom_raquo_laminar_keys_HtmlProp$ = new $TypeData().initClass($c_Lcom_raquo_laminar_keys_HtmlProp$, "com.raquo.laminar.keys.HtmlProp$", ({
  Lcom_raquo_laminar_keys_HtmlProp$: 1
}));
export { $d_Lcom_raquo_laminar_keys_HtmlProp$ as $d_Lcom_raquo_laminar_keys_HtmlProp$ };
var $n_Lcom_raquo_laminar_keys_HtmlProp$;
function $m_Lcom_raquo_laminar_keys_HtmlProp$() {
  if ((!$n_Lcom_raquo_laminar_keys_HtmlProp$)) {
    $n_Lcom_raquo_laminar_keys_HtmlProp$ = new $c_Lcom_raquo_laminar_keys_HtmlProp$();
  }
  return $n_Lcom_raquo_laminar_keys_HtmlProp$;
}
export { $m_Lcom_raquo_laminar_keys_HtmlProp$ as $m_Lcom_raquo_laminar_keys_HtmlProp$ };
/** @constructor */
function $c_Lcom_raquo_laminar_lifecycle_MountContext(thisNode, owner) {
  this.Lcom_raquo_laminar_lifecycle_MountContext__f_thisNode = null;
  this.Lcom_raquo_laminar_lifecycle_MountContext__f_owner = null;
  this.Lcom_raquo_laminar_lifecycle_MountContext__f_thisNode = thisNode;
  this.Lcom_raquo_laminar_lifecycle_MountContext__f_owner = owner;
}
export { $c_Lcom_raquo_laminar_lifecycle_MountContext as $c_Lcom_raquo_laminar_lifecycle_MountContext };
$c_Lcom_raquo_laminar_lifecycle_MountContext.prototype = new $h_O();
$c_Lcom_raquo_laminar_lifecycle_MountContext.prototype.constructor = $c_Lcom_raquo_laminar_lifecycle_MountContext;
/** @constructor */
function $h_Lcom_raquo_laminar_lifecycle_MountContext() {
}
export { $h_Lcom_raquo_laminar_lifecycle_MountContext as $h_Lcom_raquo_laminar_lifecycle_MountContext };
$h_Lcom_raquo_laminar_lifecycle_MountContext.prototype = $c_Lcom_raquo_laminar_lifecycle_MountContext.prototype;
var $d_Lcom_raquo_laminar_lifecycle_MountContext = new $TypeData().initClass($c_Lcom_raquo_laminar_lifecycle_MountContext, "com.raquo.laminar.lifecycle.MountContext", ({
  Lcom_raquo_laminar_lifecycle_MountContext: 1
}));
export { $d_Lcom_raquo_laminar_lifecycle_MountContext as $d_Lcom_raquo_laminar_lifecycle_MountContext };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Binder$() {
}
export { $c_Lcom_raquo_laminar_modifiers_Binder$ as $c_Lcom_raquo_laminar_modifiers_Binder$ };
$c_Lcom_raquo_laminar_modifiers_Binder$.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_Binder$.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_Binder$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Binder$() {
}
export { $h_Lcom_raquo_laminar_modifiers_Binder$ as $h_Lcom_raquo_laminar_modifiers_Binder$ };
$h_Lcom_raquo_laminar_modifiers_Binder$.prototype = $c_Lcom_raquo_laminar_modifiers_Binder$.prototype;
var $d_Lcom_raquo_laminar_modifiers_Binder$ = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_Binder$, "com.raquo.laminar.modifiers.Binder$", ({
  Lcom_raquo_laminar_modifiers_Binder$: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Binder$ as $d_Lcom_raquo_laminar_modifiers_Binder$ };
var $n_Lcom_raquo_laminar_modifiers_Binder$;
function $m_Lcom_raquo_laminar_modifiers_Binder$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_Binder$)) {
    $n_Lcom_raquo_laminar_modifiers_Binder$ = new $c_Lcom_raquo_laminar_modifiers_Binder$();
  }
  return $n_Lcom_raquo_laminar_modifiers_Binder$;
}
export { $m_Lcom_raquo_laminar_modifiers_Binder$ as $m_Lcom_raquo_laminar_modifiers_Binder$ };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Modifier$() {
  this.Lcom_raquo_laminar_modifiers_Modifier$__f_empty = null;
  $n_Lcom_raquo_laminar_modifiers_Modifier$ = this;
  this.Lcom_raquo_laminar_modifiers_Modifier$__f_empty = new $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1();
}
export { $c_Lcom_raquo_laminar_modifiers_Modifier$ as $c_Lcom_raquo_laminar_modifiers_Modifier$ };
$c_Lcom_raquo_laminar_modifiers_Modifier$.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_Modifier$.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_Modifier$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Modifier$() {
}
export { $h_Lcom_raquo_laminar_modifiers_Modifier$ as $h_Lcom_raquo_laminar_modifiers_Modifier$ };
$h_Lcom_raquo_laminar_modifiers_Modifier$.prototype = $c_Lcom_raquo_laminar_modifiers_Modifier$.prototype;
var $d_Lcom_raquo_laminar_modifiers_Modifier$ = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_Modifier$, "com.raquo.laminar.modifiers.Modifier$", ({
  Lcom_raquo_laminar_modifiers_Modifier$: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Modifier$ as $d_Lcom_raquo_laminar_modifiers_Modifier$ };
var $n_Lcom_raquo_laminar_modifiers_Modifier$;
function $m_Lcom_raquo_laminar_modifiers_Modifier$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_Modifier$)) {
    $n_Lcom_raquo_laminar_modifiers_Modifier$ = new $c_Lcom_raquo_laminar_modifiers_Modifier$();
  }
  return $n_Lcom_raquo_laminar_modifiers_Modifier$;
}
export { $m_Lcom_raquo_laminar_modifiers_Modifier$ as $m_Lcom_raquo_laminar_modifiers_Modifier$ };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableNode$() {
  this.Lcom_raquo_laminar_modifiers_RenderableNode$__f_nodeRenderable = null;
  $n_Lcom_raquo_laminar_modifiers_RenderableNode$ = this;
  this.Lcom_raquo_laminar_modifiers_RenderableNode$__f_nodeRenderable = new $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1();
}
export { $c_Lcom_raquo_laminar_modifiers_RenderableNode$ as $c_Lcom_raquo_laminar_modifiers_RenderableNode$ };
$c_Lcom_raquo_laminar_modifiers_RenderableNode$.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_RenderableNode$.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableNode$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableNode$() {
}
export { $h_Lcom_raquo_laminar_modifiers_RenderableNode$ as $h_Lcom_raquo_laminar_modifiers_RenderableNode$ };
$h_Lcom_raquo_laminar_modifiers_RenderableNode$.prototype = $c_Lcom_raquo_laminar_modifiers_RenderableNode$.prototype;
var $d_Lcom_raquo_laminar_modifiers_RenderableNode$ = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_RenderableNode$, "com.raquo.laminar.modifiers.RenderableNode$", ({
  Lcom_raquo_laminar_modifiers_RenderableNode$: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_RenderableNode$ as $d_Lcom_raquo_laminar_modifiers_RenderableNode$ };
var $n_Lcom_raquo_laminar_modifiers_RenderableNode$;
function $m_Lcom_raquo_laminar_modifiers_RenderableNode$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_RenderableNode$)) {
    $n_Lcom_raquo_laminar_modifiers_RenderableNode$ = new $c_Lcom_raquo_laminar_modifiers_RenderableNode$();
  }
  return $n_Lcom_raquo_laminar_modifiers_RenderableNode$;
}
export { $m_Lcom_raquo_laminar_modifiers_RenderableNode$ as $m_Lcom_raquo_laminar_modifiers_RenderableNode$ };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableText$() {
  this.Lcom_raquo_laminar_modifiers_RenderableText$__f_stringRenderable = null;
  this.Lcom_raquo_laminar_modifiers_RenderableText$__f_textNodeRenderable = null;
  $n_Lcom_raquo_laminar_modifiers_RenderableText$ = this;
  $m_Lcom_raquo_laminar_modifiers_RenderableText$();
  var render = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x));
  this.Lcom_raquo_laminar_modifiers_RenderableText$__f_stringRenderable = new $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(render);
  $m_Lcom_raquo_laminar_modifiers_RenderableText$();
  $m_Lcom_raquo_laminar_modifiers_RenderableText$();
  $m_Lcom_raquo_laminar_modifiers_RenderableText$();
  $m_Lcom_raquo_laminar_modifiers_RenderableText$();
  var render$4 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => _$4.text__T()));
  this.Lcom_raquo_laminar_modifiers_RenderableText$__f_textNodeRenderable = new $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(render$4);
}
export { $c_Lcom_raquo_laminar_modifiers_RenderableText$ as $c_Lcom_raquo_laminar_modifiers_RenderableText$ };
$c_Lcom_raquo_laminar_modifiers_RenderableText$.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_RenderableText$.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableText$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableText$() {
}
export { $h_Lcom_raquo_laminar_modifiers_RenderableText$ as $h_Lcom_raquo_laminar_modifiers_RenderableText$ };
$h_Lcom_raquo_laminar_modifiers_RenderableText$.prototype = $c_Lcom_raquo_laminar_modifiers_RenderableText$.prototype;
var $d_Lcom_raquo_laminar_modifiers_RenderableText$ = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_RenderableText$, "com.raquo.laminar.modifiers.RenderableText$", ({
  Lcom_raquo_laminar_modifiers_RenderableText$: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_RenderableText$ as $d_Lcom_raquo_laminar_modifiers_RenderableText$ };
var $n_Lcom_raquo_laminar_modifiers_RenderableText$;
function $m_Lcom_raquo_laminar_modifiers_RenderableText$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_RenderableText$)) {
    $n_Lcom_raquo_laminar_modifiers_RenderableText$ = new $c_Lcom_raquo_laminar_modifiers_RenderableText$();
  }
  return $n_Lcom_raquo_laminar_modifiers_RenderableText$;
}
export { $m_Lcom_raquo_laminar_modifiers_RenderableText$ as $m_Lcom_raquo_laminar_modifiers_RenderableText$ };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$() {
}
export { $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$ as $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$ };
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$() {
}
export { $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$ as $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$ };
$h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$.prototype = $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$.prototype;
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$.prototype.com$raquo$laminar$modifiers$SimpleKeySetter$$$StyleSetter$superArg$1__Lcom_raquo_laminar_keys_StyleProp__O__F1 = (function(key, value) {
  return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((el) => {
    $m_Lcom_raquo_laminar_domapi_DomApi$();
    var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    var value$1 = $f_Lcom_raquo_laminar_domapi_DomKeys__cssValue__O__T(this$1, value);
    var this$3 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
    var element = el.ref__Lorg_scalajs_dom_Node();
    var styleCssName = key.Lcom_raquo_laminar_keys_StyleProp__f_name;
    var prefixes = key.Lcom_raquo_laminar_keys_StyleProp__f_prefixes;
    $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setStyle__Lorg_scalajs_dom_Element__T__sci_Seq__T__V(this$3, element, styleCssName, prefixes, value$1);
  }));
});
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$.prototype.com$raquo$laminar$modifiers$SimpleKeySetter$$$StyleSetter$superArg$2__Lcom_raquo_laminar_keys_StyleProp__O__F1 = (function(key, value) {
  return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((el) => {
    $m_Lcom_raquo_laminar_domapi_DomApi$();
    var this$2 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
    var element = el.ref__Lorg_scalajs_dom_Node();
    var styleCssName = key.Lcom_raquo_laminar_keys_StyleProp__f_name;
    var prefixes = key.Lcom_raquo_laminar_keys_StyleProp__f_prefixes;
    $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setStyle__Lorg_scalajs_dom_Element__T__sci_Seq__T__V(this$2, element, styleCssName, prefixes, null);
  }));
});
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$.prototype.com$raquo$laminar$modifiers$SimpleKeySetter$$$_$$anon$superArg$1$1__F3__Lcom_raquo_laminar_keys_SimpleKey__O__F1 = (function(setOrRemoveF$2, key$2, value$2) {
  return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((el) => {
    setOrRemoveF$2.apply__O__O__O__O(el, key$2, value$2);
  }));
});
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$.prototype.com$raquo$laminar$modifiers$SimpleKeySetter$$$_$$anon$superArg$2$1__F3__Lcom_raquo_laminar_keys_SimpleKey__F1 = (function(setOrRemoveF$4, key$4) {
  return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((el) => {
    setOrRemoveF$4.apply__O__O__O__O(el, key$4, null);
  }));
});
var $d_Lcom_raquo_laminar_modifiers_SimpleKeySetter$ = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$, "com.raquo.laminar.modifiers.SimpleKeySetter$", ({
  Lcom_raquo_laminar_modifiers_SimpleKeySetter$: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_SimpleKeySetter$ as $d_Lcom_raquo_laminar_modifiers_SimpleKeySetter$ };
var $n_Lcom_raquo_laminar_modifiers_SimpleKeySetter$;
function $m_Lcom_raquo_laminar_modifiers_SimpleKeySetter$() {
  if ((!$n_Lcom_raquo_laminar_modifiers_SimpleKeySetter$)) {
    $n_Lcom_raquo_laminar_modifiers_SimpleKeySetter$ = new $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$();
  }
  return $n_Lcom_raquo_laminar_modifiers_SimpleKeySetter$;
}
export { $m_Lcom_raquo_laminar_modifiers_SimpleKeySetter$ as $m_Lcom_raquo_laminar_modifiers_SimpleKeySetter$ };
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_ReactiveElement$() {
}
export { $c_Lcom_raquo_laminar_nodes_ReactiveElement$ as $c_Lcom_raquo_laminar_nodes_ReactiveElement$ };
$c_Lcom_raquo_laminar_nodes_ReactiveElement$.prototype = new $h_O();
$c_Lcom_raquo_laminar_nodes_ReactiveElement$.prototype.constructor = $c_Lcom_raquo_laminar_nodes_ReactiveElement$;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_ReactiveElement$() {
}
export { $h_Lcom_raquo_laminar_nodes_ReactiveElement$ as $h_Lcom_raquo_laminar_nodes_ReactiveElement$ };
$h_Lcom_raquo_laminar_nodes_ReactiveElement$.prototype = $c_Lcom_raquo_laminar_nodes_ReactiveElement$.prototype;
$c_Lcom_raquo_laminar_nodes_ReactiveElement$.prototype.unsafeBindPrependSubscription__Lcom_raquo_laminar_nodes_ReactiveElement__F1__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(element, subscribe) {
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().unsafe__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((owner) => subscribe.apply__O__O(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element, owner)))), true);
});
$c_Lcom_raquo_laminar_nodes_ReactiveElement$.prototype.normalizeTagName__Lorg_scalajs_dom_Element__T = (function(element) {
  var rawTagName = element.tagName;
  var isCustomElement = ((rawTagName.indexOf("-") | 0) !== (-1));
  return (isCustomElement ? rawTagName : rawTagName.toLowerCase());
});
var $d_Lcom_raquo_laminar_nodes_ReactiveElement$ = new $TypeData().initClass($c_Lcom_raquo_laminar_nodes_ReactiveElement$, "com.raquo.laminar.nodes.ReactiveElement$", ({
  Lcom_raquo_laminar_nodes_ReactiveElement$: 1
}));
export { $d_Lcom_raquo_laminar_nodes_ReactiveElement$ as $d_Lcom_raquo_laminar_nodes_ReactiveElement$ };
var $n_Lcom_raquo_laminar_nodes_ReactiveElement$;
function $m_Lcom_raquo_laminar_nodes_ReactiveElement$() {
  if ((!$n_Lcom_raquo_laminar_nodes_ReactiveElement$)) {
    $n_Lcom_raquo_laminar_nodes_ReactiveElement$ = new $c_Lcom_raquo_laminar_nodes_ReactiveElement$();
  }
  return $n_Lcom_raquo_laminar_nodes_ReactiveElement$;
}
export { $m_Lcom_raquo_laminar_nodes_ReactiveElement$ as $m_Lcom_raquo_laminar_nodes_ReactiveElement$ };
function $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode($thiz, emptyNode$lzy1$1) {
  if ((emptyNode$lzy1$1 === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return (emptyNode$lzy1$1.sr_LazyRef__f__initialized ? emptyNode$lzy1$1.sr_LazyRef__f__value : emptyNode$lzy1$1.initialize__O__O(new $c_Lcom_raquo_laminar_nodes_CommentNode("")));
}
export { $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode as $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode };
function $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode($thiz, emptyNode$lzy1$2) {
  return (emptyNode$lzy1$2.sr_LazyRef__f__initialized ? emptyNode$lzy1$2.sr_LazyRef__f__value : $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$lzyINIT1$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode($thiz, emptyNode$lzy1$2));
}
export { $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode as $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode };
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$() {
}
export { $c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ as $c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ };
$c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$.prototype = new $h_O();
$c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$.prototype.constructor = $c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_ChildOptionReceiver$() {
}
export { $h_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ as $h_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ };
$h_Lcom_raquo_laminar_receivers_ChildOptionReceiver$.prototype = $c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$.prototype;
$c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$.prototype.$less$minus$minus__Lcom_raquo_airstream_core_Source__Lcom_raquo_laminar_inserters_DynamicInserter = (function(maybeChildSource) {
  var emptyNode$lzy1 = new $c_sr_LazyRef();
  var $x_1 = maybeChildSource.toObservable__Lcom_raquo_airstream_core_Observable();
  var emptyNode$lzy1$2$1 = emptyNode$lzy1;
  var childSource = $x_1.map__F1__Lcom_raquo_airstream_core_Observable(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((emptyNode$lzy1$2) => ((_$1) => (_$1.isEmpty__Z() ? $p_Lcom_raquo_laminar_receivers_ChildOptionReceiver$__emptyNode$1__sr_LazyRef__Lcom_raquo_laminar_nodes_CommentNode(this, emptyNode$lzy1$2) : _$1.get__O())))(emptyNode$lzy1$2$1)));
  return $m_Lcom_raquo_laminar_inserters_ChildInserter$().apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableNode__O__Lcom_raquo_laminar_inserters_DynamicInserter(childSource.toObservable__Lcom_raquo_airstream_core_Observable(), $m_Lcom_raquo_laminar_modifiers_RenderableNode$().Lcom_raquo_laminar_modifiers_RenderableNode$__f_nodeRenderable, (void 0));
});
var $d_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ = new $TypeData().initClass($c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$, "com.raquo.laminar.receivers.ChildOptionReceiver$", ({
  Lcom_raquo_laminar_receivers_ChildOptionReceiver$: 1
}));
export { $d_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ as $d_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ };
var $n_Lcom_raquo_laminar_receivers_ChildOptionReceiver$;
function $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$() {
  if ((!$n_Lcom_raquo_laminar_receivers_ChildOptionReceiver$)) {
    $n_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ = new $c_Lcom_raquo_laminar_receivers_ChildOptionReceiver$();
  }
  return $n_Lcom_raquo_laminar_receivers_ChildOptionReceiver$;
}
export { $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ as $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$ };
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_ChildReceiver$() {
  this.Lcom_raquo_laminar_receivers_ChildReceiver$__f_maybe = null;
  this.Lcom_raquo_laminar_receivers_ChildReceiver$__f_text = null;
  $n_Lcom_raquo_laminar_receivers_ChildReceiver$ = this;
  this.Lcom_raquo_laminar_receivers_ChildReceiver$__f_maybe = $m_Lcom_raquo_laminar_receivers_ChildOptionReceiver$();
  this.Lcom_raquo_laminar_receivers_ChildReceiver$__f_text = $m_Lcom_raquo_laminar_receivers_ChildTextReceiver$();
}
export { $c_Lcom_raquo_laminar_receivers_ChildReceiver$ as $c_Lcom_raquo_laminar_receivers_ChildReceiver$ };
$c_Lcom_raquo_laminar_receivers_ChildReceiver$.prototype = new $h_O();
$c_Lcom_raquo_laminar_receivers_ChildReceiver$.prototype.constructor = $c_Lcom_raquo_laminar_receivers_ChildReceiver$;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_ChildReceiver$() {
}
export { $h_Lcom_raquo_laminar_receivers_ChildReceiver$ as $h_Lcom_raquo_laminar_receivers_ChildReceiver$ };
$h_Lcom_raquo_laminar_receivers_ChildReceiver$.prototype = $c_Lcom_raquo_laminar_receivers_ChildReceiver$.prototype;
var $d_Lcom_raquo_laminar_receivers_ChildReceiver$ = new $TypeData().initClass($c_Lcom_raquo_laminar_receivers_ChildReceiver$, "com.raquo.laminar.receivers.ChildReceiver$", ({
  Lcom_raquo_laminar_receivers_ChildReceiver$: 1
}));
export { $d_Lcom_raquo_laminar_receivers_ChildReceiver$ as $d_Lcom_raquo_laminar_receivers_ChildReceiver$ };
var $n_Lcom_raquo_laminar_receivers_ChildReceiver$;
function $m_Lcom_raquo_laminar_receivers_ChildReceiver$() {
  if ((!$n_Lcom_raquo_laminar_receivers_ChildReceiver$)) {
    $n_Lcom_raquo_laminar_receivers_ChildReceiver$ = new $c_Lcom_raquo_laminar_receivers_ChildReceiver$();
  }
  return $n_Lcom_raquo_laminar_receivers_ChildReceiver$;
}
export { $m_Lcom_raquo_laminar_receivers_ChildReceiver$ as $m_Lcom_raquo_laminar_receivers_ChildReceiver$ };
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_ChildTextReceiver$() {
}
export { $c_Lcom_raquo_laminar_receivers_ChildTextReceiver$ as $c_Lcom_raquo_laminar_receivers_ChildTextReceiver$ };
$c_Lcom_raquo_laminar_receivers_ChildTextReceiver$.prototype = new $h_O();
$c_Lcom_raquo_laminar_receivers_ChildTextReceiver$.prototype.constructor = $c_Lcom_raquo_laminar_receivers_ChildTextReceiver$;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_ChildTextReceiver$() {
}
export { $h_Lcom_raquo_laminar_receivers_ChildTextReceiver$ as $h_Lcom_raquo_laminar_receivers_ChildTextReceiver$ };
$h_Lcom_raquo_laminar_receivers_ChildTextReceiver$.prototype = $c_Lcom_raquo_laminar_receivers_ChildTextReceiver$.prototype;
$c_Lcom_raquo_laminar_receivers_ChildTextReceiver$.prototype.$less$minus$minus__Lcom_raquo_airstream_core_Source__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_inserters_DynamicInserter = (function(textSource, renderable) {
  var x$2 = $m_Lcom_raquo_laminar_modifiers_RenderableText$().Lcom_raquo_laminar_modifiers_RenderableText$__f_textNodeRenderable;
  if ((renderable === x$2)) {
    var nodes = textSource.toObservable__Lcom_raquo_airstream_core_Observable();
    return $m_Lcom_raquo_laminar_inserters_ChildInserter$().apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableNode__O__Lcom_raquo_laminar_inserters_DynamicInserter(nodes, $m_Lcom_raquo_laminar_modifiers_RenderableNode$().Lcom_raquo_laminar_modifiers_RenderableNode$__f_nodeRenderable, (void 0));
  } else {
    return $m_Lcom_raquo_laminar_inserters_ChildTextInserter$().apply__Lcom_raquo_airstream_core_Observable__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_inserters_DynamicInserter(textSource.toObservable__Lcom_raquo_airstream_core_Observable(), renderable);
  }
});
var $d_Lcom_raquo_laminar_receivers_ChildTextReceiver$ = new $TypeData().initClass($c_Lcom_raquo_laminar_receivers_ChildTextReceiver$, "com.raquo.laminar.receivers.ChildTextReceiver$", ({
  Lcom_raquo_laminar_receivers_ChildTextReceiver$: 1
}));
export { $d_Lcom_raquo_laminar_receivers_ChildTextReceiver$ as $d_Lcom_raquo_laminar_receivers_ChildTextReceiver$ };
var $n_Lcom_raquo_laminar_receivers_ChildTextReceiver$;
function $m_Lcom_raquo_laminar_receivers_ChildTextReceiver$() {
  if ((!$n_Lcom_raquo_laminar_receivers_ChildTextReceiver$)) {
    $n_Lcom_raquo_laminar_receivers_ChildTextReceiver$ = new $c_Lcom_raquo_laminar_receivers_ChildTextReceiver$();
  }
  return $n_Lcom_raquo_laminar_receivers_ChildTextReceiver$;
}
export { $m_Lcom_raquo_laminar_receivers_ChildTextReceiver$ as $m_Lcom_raquo_laminar_receivers_ChildTextReceiver$ };
/** @constructor */
function $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$() {
}
export { $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$ as $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$ };
$c_Lcom_raquo_laminar_receivers_ChildrenReceiver$.prototype = new $h_O();
$c_Lcom_raquo_laminar_receivers_ChildrenReceiver$.prototype.constructor = $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$;
/** @constructor */
function $h_Lcom_raquo_laminar_receivers_ChildrenReceiver$() {
}
export { $h_Lcom_raquo_laminar_receivers_ChildrenReceiver$ as $h_Lcom_raquo_laminar_receivers_ChildrenReceiver$ };
$h_Lcom_raquo_laminar_receivers_ChildrenReceiver$.prototype = $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$.prototype;
var $d_Lcom_raquo_laminar_receivers_ChildrenReceiver$ = new $TypeData().initClass($c_Lcom_raquo_laminar_receivers_ChildrenReceiver$, "com.raquo.laminar.receivers.ChildrenReceiver$", ({
  Lcom_raquo_laminar_receivers_ChildrenReceiver$: 1
}));
export { $d_Lcom_raquo_laminar_receivers_ChildrenReceiver$ as $d_Lcom_raquo_laminar_receivers_ChildrenReceiver$ };
var $n_Lcom_raquo_laminar_receivers_ChildrenReceiver$;
function $m_Lcom_raquo_laminar_receivers_ChildrenReceiver$() {
  if ((!$n_Lcom_raquo_laminar_receivers_ChildrenReceiver$)) {
    $n_Lcom_raquo_laminar_receivers_ChildrenReceiver$ = new $c_Lcom_raquo_laminar_receivers_ChildrenReceiver$();
  }
  return $n_Lcom_raquo_laminar_receivers_ChildrenReceiver$;
}
export { $m_Lcom_raquo_laminar_receivers_ChildrenReceiver$ as $m_Lcom_raquo_laminar_receivers_ChildrenReceiver$ };
/** @constructor */
function $c_Lframework_data_FrameworkDateTime$() {
  this.Lframework_data_FrameworkDateTime$__f_utc = null;
  this.Lframework_data_FrameworkDateTime$__f_HumanReadableFormatter = null;
  this.Lframework_data_FrameworkDateTime$__f_FromToStringFormatter = null;
  this.Lframework_data_FrameworkDateTime$__f_nowIO = null;
  this.Lframework_data_FrameworkDateTime$__f_given_Ordering_FrameworkDateTime$lzy1 = null;
  this.Lframework_data_FrameworkDateTime$__f_given_Ordering_FrameworkDateTimebitmap$1 = false;
  this.Lframework_data_FrameworkDateTime$__f_circeCodec$lzy1 = null;
  this.Lframework_data_FrameworkDateTime$__f_circeCodecbitmap$1 = false;
  this.Lframework_data_FrameworkDateTime$__f_scodecCodec$lzy1 = null;
  this.Lframework_data_FrameworkDateTime$__f_scodecCodecbitmap$1 = false;
  this.Lframework_data_FrameworkDateTime$__f_schema$lzy1 = null;
  this.Lframework_data_FrameworkDateTime$__f_schemabitmap$1 = false;
  this.Lframework_data_FrameworkDateTime$__f_show$lzy1 = null;
  this.Lframework_data_FrameworkDateTime$__f_showbitmap$1 = false;
  $n_Lframework_data_FrameworkDateTime$ = this;
  this.Lframework_data_FrameworkDateTime$__f_utc = $m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId("UTC");
  this.Lframework_data_FrameworkDateTime$__f_HumanReadableFormatter = $m_Ljava_time_format_DateTimeFormatter$().ofPattern__T__Ljava_time_format_DateTimeFormatter("yyyy-MM-dd HH:mm:ss 'UTC'");
  this.Lframework_data_FrameworkDateTime$__f_FromToStringFormatter = $m_Ljava_time_format_DateTimeFormatter$().ofPattern__T__Ljava_time_format_DateTimeFormatter("yyyy-MM-dd'T'HH:mm:ss'Z'");
  this.Lframework_data_FrameworkDateTime$__f_nowIO = $m_Lcats_effect_SyncIO$().apply__F0__Lcats_effect_SyncIO(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $c_Lframework_data_FrameworkDateTime(this.now__Ljava_time_LocalDateTime()))));
}
export { $c_Lframework_data_FrameworkDateTime$ as $c_Lframework_data_FrameworkDateTime$ };
$c_Lframework_data_FrameworkDateTime$.prototype = new $h_O();
$c_Lframework_data_FrameworkDateTime$.prototype.constructor = $c_Lframework_data_FrameworkDateTime$;
/** @constructor */
function $h_Lframework_data_FrameworkDateTime$() {
}
export { $h_Lframework_data_FrameworkDateTime$ as $h_Lframework_data_FrameworkDateTime$ };
$h_Lframework_data_FrameworkDateTime$.prototype = $c_Lframework_data_FrameworkDateTime$.prototype;
$c_Lframework_data_FrameworkDateTime$.prototype.fromInstant__Ljava_time_Instant__Ljava_time_LocalDateTime = (function(instant) {
  var zone = this.Lframework_data_FrameworkDateTime$__f_utc;
  var ldt = $m_Ljava_time_LocalDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_LocalDateTime(instant, zone);
  return ldt.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime($s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit());
});
$c_Lframework_data_FrameworkDateTime$.prototype.fromUnixMillis__J__Ljava_time_LocalDateTime = (function(millis) {
  return this.fromInstant__Ljava_time_Instant__Ljava_time_LocalDateTime($m_Ljava_time_Instant$().ofEpochMilli__J__Ljava_time_Instant(millis));
});
$c_Lframework_data_FrameworkDateTime$.prototype.now__Ljava_time_LocalDateTime = (function() {
  var zone = this.Lframework_data_FrameworkDateTime$__f_utc;
  var ldt = $m_Ljava_time_LocalDateTime$().now__Ljava_time_ZoneId__Ljava_time_LocalDateTime(zone);
  return ldt.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime($s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit());
});
$c_Lframework_data_FrameworkDateTime$.prototype.given_Ordering_FrameworkDateTime__s_math_Ordering = (function() {
  if ((!this.Lframework_data_FrameworkDateTime$__f_given_Ordering_FrameworkDateTimebitmap$1)) {
    var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => {
      var _$1$1 = ((_$1 === null) ? null : _$1.Lframework_data_FrameworkDateTime__f_ldt);
      return _$1$1;
    }));
    var this$3 = $m_s_math_Ordering$();
    var this$2 = $m_s_$less$colon$less$();
    var asComparable = this$2.s_$less$colon$less$__f_singleton;
    var ord = new $c_s_math_LowPriorityOrderingImplicits$$anon$2(this$3, asComparable);
    this.Lframework_data_FrameworkDateTime$__f_given_Ordering_FrameworkDateTime$lzy1 = new $c_s_math_Ordering$$anon$5(ord, f);
    this.Lframework_data_FrameworkDateTime$__f_given_Ordering_FrameworkDateTimebitmap$1 = true;
  }
  return this.Lframework_data_FrameworkDateTime$__f_given_Ordering_FrameworkDateTime$lzy1;
});
$c_Lframework_data_FrameworkDateTime$.prototype.circeCodec__Lio_circe_Codec = (function() {
  if ((!this.Lframework_data_FrameworkDateTime$__f_circeCodecbitmap$1)) {
    var dec = $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_longC3C;
    var enc = $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_longC3C;
    var target = new $c_Lio_circe_Codec$$anon$4(dec, enc);
    var tc = $m_Lio_circe_Codec$().Lio_circe_Codec$__f_codecInvariant;
    var this$10 = new $c_Lcats_Invariant$ToInvariantOps$$anon$19(target, tc);
    var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v1) => {
      var t = $uJ(v1);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      $m_Lframework_data_FrameworkDateTime$();
      var instant = $m_Ljava_time_Instant$().ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
      var zone = $m_Lframework_data_FrameworkDateTime$().Lframework_data_FrameworkDateTime$__f_utc;
      var ldt = $m_Ljava_time_LocalDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_LocalDateTime(instant, zone);
      return new $c_Lframework_data_FrameworkDateTime(ldt.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime($s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit()));
    }));
    var g = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => {
      var _$2$1 = ((_$2 === null) ? null : _$2.Lframework_data_FrameworkDateTime__f_ldt);
      return $m_Lframework_data_FrameworkDateTime$().toInstant$extension__Ljava_time_LocalDateTime__Ljava_time_Instant(_$2$1).toEpochMilli__J();
    }));
    this.Lframework_data_FrameworkDateTime$__f_circeCodec$lzy1 = this$10.Lcats_Invariant$ToInvariantOps$$anon$19__f_typeClassInstance.imap__O__F1__F1__O(this$10.Lcats_Invariant$ToInvariantOps$$anon$19__f_self, f, g);
    this.Lframework_data_FrameworkDateTime$__f_circeCodecbitmap$1 = true;
  }
  return this.Lframework_data_FrameworkDateTime$__f_circeCodec$lzy1;
});
$c_Lframework_data_FrameworkDateTime$.prototype.scodecCodec__Lscodec_Codec = (function() {
  if ((!this.Lframework_data_FrameworkDateTime$__f_scodecCodecbitmap$1)) {
    var this$2 = $m_Lscodec_Codec$().given_Codec_Long__Lscodec_Codec();
    var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v1) => {
      var t = $uJ(v1);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      $m_Lframework_data_FrameworkDateTime$();
      var instant = $m_Ljava_time_Instant$().ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
      var zone = $m_Lframework_data_FrameworkDateTime$().Lframework_data_FrameworkDateTime$__f_utc;
      var ldt = $m_Ljava_time_LocalDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_LocalDateTime(instant, zone);
      return new $c_Lframework_data_FrameworkDateTime(ldt.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime($s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit()));
    }));
    var g = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => {
      var _$3$1 = ((_$3 === null) ? null : _$3.Lframework_data_FrameworkDateTime__f_ldt);
      return $m_Lframework_data_FrameworkDateTime$().toInstant$extension__Ljava_time_LocalDateTime__Ljava_time_Instant(_$3$1).toEpochMilli__J();
    }));
    this.Lframework_data_FrameworkDateTime$__f_scodecCodec$lzy1 = new $c_Lscodec_Codec$$anon$2(g, f, this$2);
    this.Lframework_data_FrameworkDateTime$__f_scodecCodecbitmap$1 = true;
  }
  return this.Lframework_data_FrameworkDateTime$__f_scodecCodec$lzy1;
});
$c_Lframework_data_FrameworkDateTime$.prototype.fromString__T__Ljava_time_format_DateTimeFormatter__s_util_Either = (function(str, formatter) {
  try {
    $m_Lframework_data_FrameworkDateTime$();
    var ldt = $m_Ljava_time_LocalDateTime$().parse__jl_CharSequence__Ljava_time_format_DateTimeFormatter__Ljava_time_LocalDateTime(str, formatter);
    var r1 = new $c_Lframework_data_FrameworkDateTime(ldt.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime($s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit()));
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  var eab = $x_1.toEither__s_util_Either();
  if ((eab instanceof $c_s_util_Left)) {
    var a = eab.s_util_Left__f_value;
    var value = a.toString__T();
    return new $c_s_util_Left(value);
  }
  if ((eab instanceof $c_s_util_Right)) {
    $m_Lcats_syntax_EitherUtil$();
    return eab;
  }
  throw new $c_s_MatchError(eab);
});
$c_Lframework_data_FrameworkDateTime$.prototype.schema__Lsttp_tapir_Schema = (function() {
  if ((!this.Lframework_data_FrameworkDateTime$__f_schemabitmap$1)) {
    $m_Lsttp_tapir_Schema$();
    var schemaType = new $c_Lsttp_tapir_SchemaType$SInteger();
    $m_Lsttp_tapir_Schema$();
    var name = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $m_Lsttp_tapir_Schema$();
    var description = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var default$1 = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var format = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var encodedExample = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $m_Lsttp_tapir_Schema$();
    var hidden = false;
    $m_Lsttp_tapir_Schema$();
    var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $m_Lsttp_tapir_Schema$();
    var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    this.Lframework_data_FrameworkDateTime$__f_schema$lzy1 = new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes).description__T__Lsttp_tapir_Schema("Milliseconds passed since the start of Unix epoch").encodedExample__O__Lsttp_tapir_Schema("1719314788000");
    this.Lframework_data_FrameworkDateTime$__f_schemabitmap$1 = true;
  }
  return this.Lframework_data_FrameworkDateTime$__f_schema$lzy1;
});
$c_Lframework_data_FrameworkDateTime$.prototype.show__Lcats_Show = (function() {
  if ((!this.Lframework_data_FrameworkDateTime$__f_showbitmap$1)) {
    this.Lframework_data_FrameworkDateTime$__f_show$lzy1 = new $c_Lframework_data_FrameworkDateTime$$anon$1();
    this.Lframework_data_FrameworkDateTime$__f_showbitmap$1 = true;
  }
  return this.Lframework_data_FrameworkDateTime$__f_show$lzy1;
});
$c_Lframework_data_FrameworkDateTime$.prototype.equals$extension__Ljava_time_LocalDateTime__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lframework_data_FrameworkDateTime)) {
    var x2 = ((x$0 === null) ? null : x$0.Lframework_data_FrameworkDateTime__f_ldt);
    return ((this$ === null) ? (x2 === null) : this$.equals__O__Z(x2));
  } else {
    return false;
  }
});
$c_Lframework_data_FrameworkDateTime$.prototype.toString$extension__Ljava_time_LocalDateTime__T = (function(this$) {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Lframework_data_FrameworkDateTime(this$));
});
$c_Lframework_data_FrameworkDateTime$.prototype.productElement$extension__Ljava_time_LocalDateTime__I__O = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_FrameworkDateTime$.prototype.productElementName$extension__Ljava_time_LocalDateTime__I__T = (function(this$, n) {
  if ((n === 0)) {
    return "ldt";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_FrameworkDateTime$.prototype.isSameDay$extension__Ljava_time_LocalDateTime__Ljava_time_LocalDateTime__Z = (function(this$, at) {
  var x = this$.Ljava_time_LocalDateTime__f_date;
  var x$2 = at.Ljava_time_LocalDateTime__f_date;
  return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
});
$c_Lframework_data_FrameworkDateTime$.prototype.toZonedDateTime$extension__Ljava_time_LocalDateTime__Ljava_time_ZonedDateTime = (function(this$) {
  var zone = $m_Lframework_data_FrameworkDateTime$().Lframework_data_FrameworkDateTime$__f_utc;
  var this$1 = $m_Ljava_time_ZonedDateTime$();
  return this$1.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this$, zone, null);
});
$c_Lframework_data_FrameworkDateTime$.prototype.toInstant$extension__Ljava_time_LocalDateTime__Ljava_time_Instant = (function(this$) {
  var this$1 = this.toZonedDateTime$extension__Ljava_time_LocalDateTime__Ljava_time_ZonedDateTime(this$);
  return $f_Ljava_time_chrono_ChronoZonedDateTime__toInstant__Ljava_time_Instant(this$1);
});
$c_Lframework_data_FrameworkDateTime$.prototype.toUnixMillis$extension__Ljava_time_LocalDateTime__J = (function(this$) {
  return this.toInstant$extension__Ljava_time_LocalDateTime__Ljava_time_Instant(this$).toEpochMilli__J();
});
$c_Lframework_data_FrameworkDateTime$.prototype.$plus$extension__Ljava_time_LocalDateTime__s_concurrent_duration_FiniteDuration__Ljava_time_LocalDateTime = (function(this$, duration) {
  $m_Lframework_data_FrameworkDateTime$();
  var t = duration.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(duration.s_concurrent_duration_FiniteDuration__f_length);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var ldt = $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$, this$.Ljava_time_LocalDateTime__f_date, $L0, $L0, $L0, new $c_RTLong(lo, hi), 1);
  return ldt.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime($s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit());
});
$c_Lframework_data_FrameworkDateTime$.prototype.$minus$extension__Ljava_time_LocalDateTime__s_concurrent_duration_FiniteDuration__Ljava_time_LocalDateTime = (function(this$, duration) {
  $m_Lframework_data_FrameworkDateTime$();
  var t = duration.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(duration.s_concurrent_duration_FiniteDuration__f_length);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var ldt = $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$, this$.Ljava_time_LocalDateTime__f_date, $L0, $L0, $L0, new $c_RTLong(lo, hi), (-1));
  return ldt.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime($s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit());
});
$c_Lframework_data_FrameworkDateTime$.prototype.$minus$extension__Ljava_time_LocalDateTime__Ljava_time_LocalDateTime__s_concurrent_duration_FiniteDuration = (function(this$, other) {
  var this$1 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
  var temporal1 = this.toZonedDateTime$extension__Ljava_time_LocalDateTime__Ljava_time_ZonedDateTime(other);
  var temporal2 = this.toZonedDateTime$extension__Ljava_time_LocalDateTime__Ljava_time_ZonedDateTime(this$);
  var t = temporal1.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(temporal2, this$1);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$3 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo, hi));
  var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var t$1 = this$3.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  $m_s_concurrent_duration_Duration$();
  return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$1, hi$1), unit);
});
var $d_Lframework_data_FrameworkDateTime$ = new $TypeData().initClass($c_Lframework_data_FrameworkDateTime$, "framework.data.FrameworkDateTime$", ({
  Lframework_data_FrameworkDateTime$: 1
}));
export { $d_Lframework_data_FrameworkDateTime$ as $d_Lframework_data_FrameworkDateTime$ };
var $n_Lframework_data_FrameworkDateTime$;
function $m_Lframework_data_FrameworkDateTime$() {
  if ((!$n_Lframework_data_FrameworkDateTime$)) {
    $n_Lframework_data_FrameworkDateTime$ = new $c_Lframework_data_FrameworkDateTime$();
  }
  return $n_Lframework_data_FrameworkDateTime$;
}
export { $m_Lframework_data_FrameworkDateTime$ as $m_Lframework_data_FrameworkDateTime$ };
/** @constructor */
function $c_Lframework_data_PageCursor$Builder$() {
}
export { $c_Lframework_data_PageCursor$Builder$ as $c_Lframework_data_PageCursor$Builder$ };
$c_Lframework_data_PageCursor$Builder$.prototype = new $h_O();
$c_Lframework_data_PageCursor$Builder$.prototype.constructor = $c_Lframework_data_PageCursor$Builder$;
/** @constructor */
function $h_Lframework_data_PageCursor$Builder$() {
}
export { $h_Lframework_data_PageCursor$Builder$ as $h_Lframework_data_PageCursor$Builder$ };
$h_Lframework_data_PageCursor$Builder$.prototype = $c_Lframework_data_PageCursor$Builder$.prototype;
$c_Lframework_data_PageCursor$Builder$.prototype.toString__T = (function() {
  return "Builder";
});
$c_Lframework_data_PageCursor$Builder$.prototype.next$extension__O__O__O__I__Lframework_data_PageCursor = (function(this$, primary, secondary, index) {
  var direction = $s_Lframework_data_PageCursorDirection$__Forward__Lframework_data_PageCursorDirection();
  var index$1 = ((1 + index) | 0);
  var value = new $c_Lframework_data_PageCursor$Cursor(direction, primary, secondary, index$1);
  var cursor = new $c_s_Some(value);
  return new $c_Lframework_data_PageCursor(cursor, this$);
});
$c_Lframework_data_PageCursor$Builder$.prototype.previous$extension__O__O__O__I__Lframework_data_PageCursor = (function(this$, primary, secondary, index) {
  var direction = $s_Lframework_data_PageCursorDirection$__Backward__Lframework_data_PageCursorDirection();
  var index$1 = (((-1) + index) | 0);
  var value = new $c_Lframework_data_PageCursor$Cursor(direction, primary, secondary, index$1);
  var cursor = new $c_s_Some(value);
  return new $c_Lframework_data_PageCursor(cursor, this$);
});
var $d_Lframework_data_PageCursor$Builder$ = new $TypeData().initClass($c_Lframework_data_PageCursor$Builder$, "framework.data.PageCursor$Builder$", ({
  Lframework_data_PageCursor$Builder$: 1
}));
export { $d_Lframework_data_PageCursor$Builder$ as $d_Lframework_data_PageCursor$Builder$ };
var $n_Lframework_data_PageCursor$Builder$;
function $m_Lframework_data_PageCursor$Builder$() {
  if ((!$n_Lframework_data_PageCursor$Builder$)) {
    $n_Lframework_data_PageCursor$Builder$ = new $c_Lframework_data_PageCursor$Builder$();
  }
  return $n_Lframework_data_PageCursor$Builder$;
}
export { $m_Lframework_data_PageCursor$Builder$ as $m_Lframework_data_PageCursor$Builder$ };
/** @constructor */
function $c_Lframework_exts_CirceCodecExts$package$() {
}
export { $c_Lframework_exts_CirceCodecExts$package$ as $c_Lframework_exts_CirceCodecExts$package$ };
$c_Lframework_exts_CirceCodecExts$package$.prototype = new $h_O();
$c_Lframework_exts_CirceCodecExts$package$.prototype.constructor = $c_Lframework_exts_CirceCodecExts$package$;
/** @constructor */
function $h_Lframework_exts_CirceCodecExts$package$() {
}
export { $h_Lframework_exts_CirceCodecExts$package$ as $h_Lframework_exts_CirceCodecExts$package$ };
$h_Lframework_exts_CirceCodecExts$package$.prototype = $c_Lframework_exts_CirceCodecExts$package$.prototype;
$c_Lframework_exts_CirceCodecExts$package$.prototype.fromKeyCodecs__Lio_circe_Codec$__Lio_circe_KeyDecoder__Lio_circe_KeyEncoder__Lio_circe_Codec = (function(obj, dec, enc) {
  var this$2 = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((str) => {
    var this$1 = dec.apply__T__s_Option(str);
    return (this$1.isEmpty__Z() ? new $c_s_util_Left("Failed to parse string") : new $c_s_util_Right(this$1.get__O()));
  }));
  var jsonDec = new $c_Lio_circe_Decoder$$anon$13(f, this$2);
  var this$3 = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
  var f$1 = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((key) => enc.apply__O__T(key)));
  var jsonEnc = new $c_Lio_circe_Encoder$$anon$1(f$1, this$3);
  return new $c_Lio_circe_Codec$$anon$4(jsonDec, jsonEnc);
});
$c_Lframework_exts_CirceCodecExts$package$.prototype.fromTapirCodec__Lio_circe_Codec$__Lsttp_tapir_Codec__Lio_circe_Decoder__Lio_circe_Encoder__Lio_circe_Codec = (function(obj, codec, circeDecoder, circeEncoder) {
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => {
    var this$2 = $m_Lframework_exts_TapirCodecExts$package$().toEither__Lsttp_tapir_DecodeResult__s_util_Either($f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(codec, _$1));
    var this$3 = new $c_s_util_Either$LeftProjection(this$2);
    var x1 = this$3.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $c_s_util_Left)) {
      var a = x1.s_util_Left__f_value;
      return new $c_s_util_Left(a.toString__T());
    } else {
      return this$3.s_util_Either$LeftProjection__f_e;
    }
  }));
  var decodeA = new $c_Lio_circe_Decoder$$anon$13(f, circeDecoder);
  var f$1 = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((h) => codec.encode__O__O(h)));
  var encodeA = new $c_Lio_circe_Encoder$$anon$1(f$1, circeEncoder);
  return new $c_Lio_circe_Codec$$anon$4(decodeA, encodeA);
});
var $d_Lframework_exts_CirceCodecExts$package$ = new $TypeData().initClass($c_Lframework_exts_CirceCodecExts$package$, "framework.exts.CirceCodecExts$package$", ({
  Lframework_exts_CirceCodecExts$package$: 1
}));
export { $d_Lframework_exts_CirceCodecExts$package$ as $d_Lframework_exts_CirceCodecExts$package$ };
var $n_Lframework_exts_CirceCodecExts$package$;
function $m_Lframework_exts_CirceCodecExts$package$() {
  if ((!$n_Lframework_exts_CirceCodecExts$package$)) {
    $n_Lframework_exts_CirceCodecExts$package$ = new $c_Lframework_exts_CirceCodecExts$package$();
  }
  return $n_Lframework_exts_CirceCodecExts$package$;
}
export { $m_Lframework_exts_CirceCodecExts$package$ as $m_Lframework_exts_CirceCodecExts$package$ };
/** @constructor */
function $c_Lframework_exts_TapirCodecExts$package$() {
}
export { $c_Lframework_exts_TapirCodecExts$package$ as $c_Lframework_exts_TapirCodecExts$package$ };
$c_Lframework_exts_TapirCodecExts$package$.prototype = new $h_O();
$c_Lframework_exts_TapirCodecExts$package$.prototype.constructor = $c_Lframework_exts_TapirCodecExts$package$;
/** @constructor */
function $h_Lframework_exts_TapirCodecExts$package$() {
}
export { $h_Lframework_exts_TapirCodecExts$package$ as $h_Lframework_exts_TapirCodecExts$package$ };
$h_Lframework_exts_TapirCodecExts$package$.prototype = $c_Lframework_exts_TapirCodecExts$package$.prototype;
$c_Lframework_exts_TapirCodecExts$package$.prototype.toEither__Lsttp_tapir_DecodeResult__s_util_Either = (function(dr) {
  if ((dr instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
    var x12 = dr.Lsttp_tapir_DecodeResult$Value__f_v;
    return new $c_s_util_Right(x12);
  }
  if ($is_Lsttp_tapir_DecodeResult$Failure(dr)) {
    return new $c_s_util_Left(dr);
  }
  throw new $c_s_MatchError(dr);
});
var $d_Lframework_exts_TapirCodecExts$package$ = new $TypeData().initClass($c_Lframework_exts_TapirCodecExts$package$, "framework.exts.TapirCodecExts$package$", ({
  Lframework_exts_TapirCodecExts$package$: 1
}));
export { $d_Lframework_exts_TapirCodecExts$package$ as $d_Lframework_exts_TapirCodecExts$package$ };
var $n_Lframework_exts_TapirCodecExts$package$;
function $m_Lframework_exts_TapirCodecExts$package$() {
  if ((!$n_Lframework_exts_TapirCodecExts$package$)) {
    $n_Lframework_exts_TapirCodecExts$package$ = new $c_Lframework_exts_TapirCodecExts$package$();
  }
  return $n_Lframework_exts_TapirCodecExts$package$;
}
export { $m_Lframework_exts_TapirCodecExts$package$ as $m_Lframework_exts_TapirCodecExts$package$ };
/** @constructor */
function $c_Lframework_localization_LocalizationSupport$LocalizedText$(outer) {
  this.Lframework_localization_LocalizationSupport$LocalizedText$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_localization_LocalizationSupport$LocalizedText$__f_$outer = outer;
}
export { $c_Lframework_localization_LocalizationSupport$LocalizedText$ as $c_Lframework_localization_LocalizationSupport$LocalizedText$ };
$c_Lframework_localization_LocalizationSupport$LocalizedText$.prototype = new $h_O();
$c_Lframework_localization_LocalizationSupport$LocalizedText$.prototype.constructor = $c_Lframework_localization_LocalizationSupport$LocalizedText$;
/** @constructor */
function $h_Lframework_localization_LocalizationSupport$LocalizedText$() {
}
export { $h_Lframework_localization_LocalizationSupport$LocalizedText$ as $h_Lframework_localization_LocalizationSupport$LocalizedText$ };
$h_Lframework_localization_LocalizationSupport$LocalizedText$.prototype = $c_Lframework_localization_LocalizationSupport$LocalizedText$.prototype;
$c_Lframework_localization_LocalizationSupport$LocalizedText$.prototype.always__T__Lframework_localization_LocalizationSupport$LocalizedText = (function(str) {
  var localize = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => str));
  return new $c_Lframework_localization_LocalizationSupport$$anon$2(localize, this);
});
var $d_Lframework_localization_LocalizationSupport$LocalizedText$ = new $TypeData().initClass($c_Lframework_localization_LocalizationSupport$LocalizedText$, "framework.localization.LocalizationSupport$LocalizedText$", ({
  Lframework_localization_LocalizationSupport$LocalizedText$: 1
}));
export { $d_Lframework_localization_LocalizationSupport$LocalizedText$ as $d_Lframework_localization_LocalizationSupport$LocalizedText$ };
/** @constructor */
function $c_Lframework_localization_LocalizationSupport$LocalizedTextOf$(outer) {
  this.Lframework_localization_LocalizationSupport$LocalizedTextOf$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_localization_LocalizationSupport$LocalizedTextOf$__f_$outer = outer;
}
export { $c_Lframework_localization_LocalizationSupport$LocalizedTextOf$ as $c_Lframework_localization_LocalizationSupport$LocalizedTextOf$ };
$c_Lframework_localization_LocalizationSupport$LocalizedTextOf$.prototype = new $h_O();
$c_Lframework_localization_LocalizationSupport$LocalizedTextOf$.prototype.constructor = $c_Lframework_localization_LocalizationSupport$LocalizedTextOf$;
/** @constructor */
function $h_Lframework_localization_LocalizationSupport$LocalizedTextOf$() {
}
export { $h_Lframework_localization_LocalizationSupport$LocalizedTextOf$ as $h_Lframework_localization_LocalizationSupport$LocalizedTextOf$ };
$h_Lframework_localization_LocalizationSupport$LocalizedTextOf$.prototype = $c_Lframework_localization_LocalizationSupport$LocalizedTextOf$.prototype;
var $d_Lframework_localization_LocalizationSupport$LocalizedTextOf$ = new $TypeData().initClass($c_Lframework_localization_LocalizationSupport$LocalizedTextOf$, "framework.localization.LocalizationSupport$LocalizedTextOf$", ({
  Lframework_localization_LocalizationSupport$LocalizedTextOf$: 1
}));
export { $d_Lframework_localization_LocalizationSupport$LocalizedTextOf$ as $d_Lframework_localization_LocalizationSupport$LocalizedTextOf$ };
/** @constructor */
function $c_Lframework_prelude_newtype$package$() {
  this.Lframework_prelude_newtype$package$__f_given_AsString_Any$lzy1 = null;
  this.Lframework_prelude_newtype$package$__f_given_AsString_Anybitmap$1 = false;
}
export { $c_Lframework_prelude_newtype$package$ as $c_Lframework_prelude_newtype$package$ };
$c_Lframework_prelude_newtype$package$.prototype = new $h_O();
$c_Lframework_prelude_newtype$package$.prototype.constructor = $c_Lframework_prelude_newtype$package$;
/** @constructor */
function $h_Lframework_prelude_newtype$package$() {
}
export { $h_Lframework_prelude_newtype$package$ as $h_Lframework_prelude_newtype$package$ };
$h_Lframework_prelude_newtype$package$.prototype = $c_Lframework_prelude_newtype$package$.prototype;
$c_Lframework_prelude_newtype$package$.prototype.given_AsString_Any__Lyantl_AsString = (function() {
  if ((!this.Lframework_prelude_newtype$package$__f_given_AsString_Anybitmap$1)) {
    this.Lframework_prelude_newtype$package$__f_given_AsString_Any$lzy1 = new $c_Lyantl_AsString$$anon$1();
    this.Lframework_prelude_newtype$package$__f_given_AsString_Anybitmap$1 = true;
  }
  return this.Lframework_prelude_newtype$package$__f_given_AsString_Any$lzy1;
});
var $d_Lframework_prelude_newtype$package$ = new $TypeData().initClass($c_Lframework_prelude_newtype$package$, "framework.prelude.newtype$package$", ({
  Lframework_prelude_newtype$package$: 1
}));
export { $d_Lframework_prelude_newtype$package$ as $d_Lframework_prelude_newtype$package$ };
var $n_Lframework_prelude_newtype$package$;
function $m_Lframework_prelude_newtype$package$() {
  if ((!$n_Lframework_prelude_newtype$package$)) {
    $n_Lframework_prelude_newtype$package$ = new $c_Lframework_prelude_newtype$package$();
  }
  return $n_Lframework_prelude_newtype$package$;
}
export { $m_Lframework_prelude_newtype$package$ as $m_Lframework_prelude_newtype$package$ };
/** @constructor */
function $c_Lframework_prelude_newtype\uff3fscodec$package$() {
}
export { $c_Lframework_prelude_newtype\uff3fscodec$package$ as $c_Lframework_prelude_newtype\uff3fscodec$package$ };
$c_Lframework_prelude_newtype\uff3fscodec$package$.prototype = new $h_O();
$c_Lframework_prelude_newtype\uff3fscodec$package$.prototype.constructor = $c_Lframework_prelude_newtype\uff3fscodec$package$;
/** @constructor */
function $h_Lframework_prelude_newtype\uff3fscodec$package$() {
}
export { $h_Lframework_prelude_newtype\uff3fscodec$package$ as $h_Lframework_prelude_newtype\uff3fscodec$package$ };
$h_Lframework_prelude_newtype\uff3fscodec$package$.prototype = $c_Lframework_prelude_newtype\uff3fscodec$package$.prototype;
$c_Lframework_prelude_newtype\uff3fscodec$package$.prototype.newTypeSCodecCodec__Lyantl_INewtype__Lscodec_Codec__Lscodec_Codec = (function(newType, codec) {
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((underlying) => {
    var $x_2 = $m_Lscodec_Attempt$();
    var this$1 = newType.make__Lyantl_INewtype$make$();
    var x$2 = $m_Lframework_prelude_newtype$package$().given_AsString_Any__Lyantl_AsString();
    var this$2 = $f_Lyantl_Make__asString__O__Lyantl_AsString__s_util_Either(this$1, underlying, x$2);
    var this$3 = new $c_s_util_Either$LeftProjection(this$2);
    var x1 = this$3.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $c_s_util_Left)) {
      var a = x1.s_util_Left__f_value;
      var $x_1 = new $c_s_util_Left($ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), a));
    } else {
      var $x_1 = this$3.s_util_Either$LeftProjection__f_e;
    }
    return $x_2.fromEither__s_util_Either__Lscodec_Attempt($x_1);
  }));
  var g = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((underlying$2) => {
    var a$1 = newType.protected_unwrap__O__O(underlying$2);
    return new $c_Lscodec_Attempt$Successful(a$1);
  }));
  return new $c_Lscodec_Codec$$anon$1(g, f, codec);
});
var $d_Lframework_prelude_newtype\uff3fscodec$package$ = new $TypeData().initClass($c_Lframework_prelude_newtype\uff3fscodec$package$, "framework.prelude.newtype_scodec$package$", ({
  Lframework_prelude_newtype\uff3fscodec$package$: 1
}));
export { $d_Lframework_prelude_newtype\uff3fscodec$package$ as $d_Lframework_prelude_newtype\uff3fscodec$package$ };
var $n_Lframework_prelude_newtype\uff3fscodec$package$;
function $m_Lframework_prelude_newtype\uff3fscodec$package$() {
  if ((!$n_Lframework_prelude_newtype\uff3fscodec$package$)) {
    $n_Lframework_prelude_newtype\uff3fscodec$package$ = new $c_Lframework_prelude_newtype\uff3fscodec$package$();
  }
  return $n_Lframework_prelude_newtype\uff3fscodec$package$;
}
export { $m_Lframework_prelude_newtype\uff3fscodec$package$ as $m_Lframework_prelude_newtype\uff3fscodec$package$ };
/** @constructor */
function $c_Lframework_prelude_newtype\uff3ftapir$package$() {
}
export { $c_Lframework_prelude_newtype\uff3ftapir$package$ as $c_Lframework_prelude_newtype\uff3ftapir$package$ };
$c_Lframework_prelude_newtype\uff3ftapir$package$.prototype = new $h_O();
$c_Lframework_prelude_newtype\uff3ftapir$package$.prototype.constructor = $c_Lframework_prelude_newtype\uff3ftapir$package$;
/** @constructor */
function $h_Lframework_prelude_newtype\uff3ftapir$package$() {
}
export { $h_Lframework_prelude_newtype\uff3ftapir$package$ as $h_Lframework_prelude_newtype\uff3ftapir$package$ };
$h_Lframework_prelude_newtype\uff3ftapir$package$.prototype = $c_Lframework_prelude_newtype\uff3ftapir$package$.prototype;
$c_Lframework_prelude_newtype\uff3ftapir$package$.prototype.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema = (function(newType, schema) {
  var g = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v) => newType.protected_unwrap__O__O(v)));
  var schemaType$1 = schema.Lsttp_tapir_Schema__f_schemaType.contramap__F1__Lsttp_tapir_SchemaType(g);
  var this$1 = schema.Lsttp_tapir_Schema__f_default;
  if (this$1.isEmpty__Z()) {
    var default$1 = $m_s_None$();
  } else {
    var x0 = this$1.get__O();
    matchResult4: {
      var default$1;
      if ((x0 !== null)) {
        var t = x0._1__O();
        var raw = x0._2__O();
        var this$2 = newType.make__Lyantl_INewtype$make$().apply__O__s_util_Either(t).toOption__s_Option();
        if (this$2.isEmpty__Z()) {
          var default$1 = $m_s_None$();
          break matchResult4;
        } else {
          var x0$1 = this$2.get__O();
          var default$1 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), x0$1, raw));
          break matchResult4;
        }
      }
      throw new $c_s_MatchError(x0);
    }
  }
  var validator$1 = schema.Lsttp_tapir_Schema__f_validator.contramap__F1__Lsttp_tapir_Validator(g);
  var name$1 = schema.Lsttp_tapir_Schema__f_name;
  var isOptional$1 = schema.Lsttp_tapir_Schema__f_isOptional;
  var description$1 = schema.Lsttp_tapir_Schema__f_description;
  var format$1 = schema.Lsttp_tapir_Schema__f_format;
  var encodedExample$1 = schema.Lsttp_tapir_Schema__f_encodedExample;
  var deprecated$1 = schema.Lsttp_tapir_Schema__f_deprecated;
  var hidden$1 = schema.Lsttp_tapir_Schema__f_hidden;
  var attributes$1 = schema.Lsttp_tapir_Schema__f_attributes;
  return new $c_Lsttp_tapir_Schema(schemaType$1, name$1, isOptional$1, description$1, default$1, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
});
var $d_Lframework_prelude_newtype\uff3ftapir$package$ = new $TypeData().initClass($c_Lframework_prelude_newtype\uff3ftapir$package$, "framework.prelude.newtype_tapir$package$", ({
  Lframework_prelude_newtype\uff3ftapir$package$: 1
}));
export { $d_Lframework_prelude_newtype\uff3ftapir$package$ as $d_Lframework_prelude_newtype\uff3ftapir$package$ };
var $n_Lframework_prelude_newtype\uff3ftapir$package$;
function $m_Lframework_prelude_newtype\uff3ftapir$package$() {
  if ((!$n_Lframework_prelude_newtype\uff3ftapir$package$)) {
    $n_Lframework_prelude_newtype\uff3ftapir$package$ = new $c_Lframework_prelude_newtype\uff3ftapir$package$();
  }
  return $n_Lframework_prelude_newtype\uff3ftapir$package$;
}
export { $m_Lframework_prelude_newtype\uff3ftapir$package$ as $m_Lframework_prelude_newtype\uff3ftapir$package$ };
/** @constructor */
function $c_Lframework_prelude_scodec$package$() {
  this.Lframework_prelude_scodec$package$__f_scodecULID$lzy1 = null;
  this.Lframework_prelude_scodec$package$__f_scodecULIDbitmap$1 = false;
}
export { $c_Lframework_prelude_scodec$package$ as $c_Lframework_prelude_scodec$package$ };
$c_Lframework_prelude_scodec$package$.prototype = new $h_O();
$c_Lframework_prelude_scodec$package$.prototype.constructor = $c_Lframework_prelude_scodec$package$;
/** @constructor */
function $h_Lframework_prelude_scodec$package$() {
}
export { $h_Lframework_prelude_scodec$package$ as $h_Lframework_prelude_scodec$package$ };
$h_Lframework_prelude_scodec$package$.prototype = $c_Lframework_prelude_scodec$package$.prototype;
$c_Lframework_prelude_scodec$package$.prototype.scodecULID__Lscodec_Codec = (function() {
  if ((!this.Lframework_prelude_scodec$package$__f_scodecULIDbitmap$1)) {
    var this$2 = $m_Lscodec_Codec$().given_Codec_UUID__Lscodec_Codec();
    var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((uuid) => $m_Ljkugiya_ulid_UUIDCodec$().decode__ju_UUID__Ljkugiya_ulid_ULID(uuid)));
    var g = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => $m_Ljkugiya_ulid_UUIDCodec$().encode__Ljkugiya_ulid_ULID__ju_UUID(_$1)));
    this.Lframework_prelude_scodec$package$__f_scodecULID$lzy1 = new $c_Lscodec_Codec$$anon$2(g, f, this$2);
    this.Lframework_prelude_scodec$package$__f_scodecULIDbitmap$1 = true;
  }
  return this.Lframework_prelude_scodec$package$__f_scodecULID$lzy1;
});
var $d_Lframework_prelude_scodec$package$ = new $TypeData().initClass($c_Lframework_prelude_scodec$package$, "framework.prelude.scodec$package$", ({
  Lframework_prelude_scodec$package$: 1
}));
export { $d_Lframework_prelude_scodec$package$ as $d_Lframework_prelude_scodec$package$ };
var $n_Lframework_prelude_scodec$package$;
function $m_Lframework_prelude_scodec$package$() {
  if ((!$n_Lframework_prelude_scodec$package$)) {
    $n_Lframework_prelude_scodec$package$ = new $c_Lframework_prelude_scodec$package$();
  }
  return $n_Lframework_prelude_scodec$package$;
}
export { $m_Lframework_prelude_scodec$package$ as $m_Lframework_prelude_scodec$package$ };
function $f_Lframework_utils_NamedEnum__$init$__V($thiz) {
  $m_Lcats_data_NonEmptyVector$();
  var this$ = $thiz.values__sci_Vector();
  var this$5 = this$.iterator__sc_Iterator();
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v) => {
    var self = $thiz.toName__O__T(v);
    return $ct_T2__O__O__(new $c_T2(), self, v);
  }));
  var this$7 = new $c_sc_Iterator$$anon$9(this$5, f);
  $thiz.framework$utils$NamedEnum$_setter_$byName_$eq__sci_Map__V($m_sci_Map$().from__sc_IterableOnce__sci_Map(this$7));
}
export { $f_Lframework_utils_NamedEnum__$init$__V as $f_Lframework_utils_NamedEnum__$init$__V };
function $f_Lframework_utils_NamedEnum__circeKeyCodec__Lframework_utils_CirceKeyCodec($thiz) {
  var decode = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((name) => $thiz.byName__sci_Map().get__O__s_Option(name)));
  var encode = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a) => $thiz.toName__O__T(a)));
  return new $c_Lframework_utils_CirceKeyCodec$$anon$2(decode, encode);
}
export { $f_Lframework_utils_NamedEnum__circeKeyCodec__Lframework_utils_CirceKeyCodec as $f_Lframework_utils_NamedEnum__circeKeyCodec__Lframework_utils_CirceKeyCodec };
function $f_Lframework_utils_NamedEnum__circeCodec__Lio_circe_Codec($thiz) {
  var keyCodec = $f_Lframework_utils_NamedEnum__circeKeyCodec__Lframework_utils_CirceKeyCodec($thiz);
  return $m_Lframework_exts_CirceCodecExts$package$().fromKeyCodecs__Lio_circe_Codec$__Lio_circe_KeyDecoder__Lio_circe_KeyEncoder__Lio_circe_Codec($m_Lio_circe_Codec$(), keyCodec, keyCodec);
}
export { $f_Lframework_utils_NamedEnum__circeCodec__Lio_circe_Codec as $f_Lframework_utils_NamedEnum__circeCodec__Lio_circe_Codec };
function $f_Lframework_utils_NamedEnum__schema__Lsttp_tapir_Schema($thiz) {
  $m_Lsttp_tapir_Schema$();
  $m_Lsttp_tapir_Schema$();
  var schemaType = new $c_Lsttp_tapir_SchemaType$SString();
  $m_Lsttp_tapir_Schema$();
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var $x_8 = new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  var $x_7 = $m_Lcats_Show$ShowInterpolator$();
  var parts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["\"", "\""]));
  var sc = new $c_s_StringContext(parts);
  var $x_6 = $m_sr_ScalaRunTime$();
  var $x_5 = $m_Lcats_Show$Shown$();
  $m_Lcats_data_NonEmptyVector$();
  var this$ = $thiz.values__sci_Vector();
  var $x_4 = $x_8.encodedExample__O__Lsttp_tapir_Schema($x_7.show$extension__s_StringContext__sci_Seq__T(sc, $x_6.genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($x_5.mat__O__Lcats_Show$ContravariantShow__T($thiz.toName__O__T(this$.head__O()), $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))));
  var $x_3 = $m_Lcats_Show$ShowInterpolator$();
  var parts$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["enum (", ")"]));
  var sc$1 = new $c_s_StringContext(parts$1);
  var $x_2 = $m_sr_ScalaRunTime$();
  var $x_1 = $m_Lcats_Show$Shown$();
  $m_Lcats_data_NonEmptyVector$();
  var this$$1 = $thiz.values__sci_Vector();
  var this$23 = this$$1.iterator__sc_Iterator();
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a) => $thiz.toName__O__T(a)));
  var this$24 = new $c_sc_Iterator$$anon$9(this$23, f);
  return $x_4.format__T__Lsttp_tapir_Schema($x_3.show$extension__s_StringContext__sci_Seq__T(sc$1, $x_2.genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($x_1.mat__O__Lcats_Show$ContravariantShow__T($f_sc_IterableOnceOps__mkString__T__T__T__T(this$24, "", " | ", ""), $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))));
}
export { $f_Lframework_utils_NamedEnum__schema__Lsttp_tapir_Schema as $f_Lframework_utils_NamedEnum__schema__Lsttp_tapir_Schema };
function $f_Lframework_utils_NamedEnum__schemaForMap__Lsttp_tapir_Schema__Lsttp_tapir_Schema($thiz, evidence$1) {
  $m_Lsttp_tapir_Schema$();
  var keyToString$proxy1 = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a) => $thiz.toName__O__T(a)));
  $m_Lsttp_tapir_Schema$();
  var fields = $m_sci_Nil$();
  var mapFieldValues = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => _$3.map__F1__sc_IterableOps(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ((x$1 !== null)) {
      var k = x$1._1__O();
      var v = x$1._2__O();
      var _1 = keyToString$proxy1.apply__O__O(k);
      return $ct_T2__O__O__(new $c_T2(), _1, v);
    }
    throw new $c_s_MatchError(x$1);
  })))));
  var schemaType = new $c_Lsttp_tapir_SchemaType$SOpenProduct(fields, evidence$1, mapFieldValues);
  $m_Lsttp_tapir_Schema$SName$();
  var typeParameterShortNames = new $c_sci_$colon$colon("framework.utils.NamedEnum.A", new $c_sci_$colon$colon("framework.utils.NamedEnum.schemaForMap.V", $m_sci_Nil$()));
  var value = new $c_Lsttp_tapir_Schema$SName("Map", typeParameterShortNames);
  var name = new $c_s_Some(value);
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  return new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
}
export { $f_Lframework_utils_NamedEnum__schemaForMap__Lsttp_tapir_Schema__Lsttp_tapir_Schema as $f_Lframework_utils_NamedEnum__schemaForMap__Lsttp_tapir_Schema__Lsttp_tapir_Schema };
function $f_Lframework_utils_NamedEnum__tapirCodec__Lsttp_tapir_Codec($thiz) {
  return $f_Lsttp_tapir_Codec__mapEither__F1__F1__Lsttp_tapir_Codec($m_Lsttp_tapir_Codec$().Lsttp_tapir_Codec$__f_string, new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((str) => {
    var this$3 = $thiz.byName__sci_Map().get__O__s_Option(str);
    if (this$3.isEmpty__Z()) {
      var $x_1 = $m_Lcats_Show$ShowInterpolator$();
      var parts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Unknown value: ", ""]));
      var sc = new $c_s_StringContext(parts);
      return new $c_s_util_Left($x_1.show$extension__s_StringContext__sci_Seq__T(sc, $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_Lcats_Show$Shown.getArrayOf().constr)([new $c_Lcats_Show$Shown($m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(str, $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString))]))));
    } else {
      return new $c_s_util_Right(this$3.get__O());
    }
  })), new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a) => $thiz.toName__O__T(a))));
}
export { $f_Lframework_utils_NamedEnum__tapirCodec__Lsttp_tapir_Codec as $f_Lframework_utils_NamedEnum__tapirCodec__Lsttp_tapir_Codec };
/** @constructor */
function $c_Lio_circe_DecodingFailure$() {
  this.Lio_circe_DecodingFailure$__f_eqDecodingFailure = null;
  this.Lio_circe_DecodingFailure$__f_showDecodingFailure = null;
  $n_Lio_circe_DecodingFailure$ = this;
  $m_Lcats_package$();
  var f = new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a, b) => {
    var x = a.Lio_circe_DecodingFailure__f_lazyReason.value__O();
    var x$2 = b.Lio_circe_DecodingFailure__f_lazyReason.value__O();
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      return $m_Lio_circe_CursorOp$().Lio_circe_CursorOp$__f_eqCursorOpList.eqv__O__O__Z(a.history__sci_List(), b.history__sci_List());
    } else {
      return false;
    }
  }));
  this.Lio_circe_DecodingFailure$__f_eqDecodingFailure = new $c_Lcats_kernel_Eq$$anon$5(f);
  this.Lio_circe_DecodingFailure$__f_showDecodingFailure = new $c_Lcats_Show$$anon$5();
}
export { $c_Lio_circe_DecodingFailure$ as $c_Lio_circe_DecodingFailure$ };
$c_Lio_circe_DecodingFailure$.prototype = new $h_O();
$c_Lio_circe_DecodingFailure$.prototype.constructor = $c_Lio_circe_DecodingFailure$;
/** @constructor */
function $h_Lio_circe_DecodingFailure$() {
}
export { $h_Lio_circe_DecodingFailure$ as $h_Lio_circe_DecodingFailure$ };
$h_Lio_circe_DecodingFailure$.prototype = $c_Lio_circe_DecodingFailure$.prototype;
$c_Lio_circe_DecodingFailure$.prototype.apply__T__F0__Lio_circe_DecodingFailure = (function(message, ops) {
  return $m_Lio_circe_DecodingFailure$DecodingFailureImpl$().apply__Lio_circe_DecodingFailure$Reason__s_Option__Lcats_Eval__Lio_circe_DecodingFailure(new $c_Lio_circe_DecodingFailure$Reason$CustomReason(message), $m_s_None$(), ($m_Lcats_Eval$(), new $c_Lcats_Later(ops)));
});
$c_Lio_circe_DecodingFailure$.prototype.apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure = (function(reason, ops) {
  return $m_Lio_circe_DecodingFailure$DecodingFailureImpl$().apply__Lio_circe_DecodingFailure$Reason__s_Option__Lcats_Eval__Lio_circe_DecodingFailure(reason, $m_s_None$(), ($m_Lcats_Eval$(), new $c_Lcats_Later(ops)));
});
var $d_Lio_circe_DecodingFailure$ = new $TypeData().initClass($c_Lio_circe_DecodingFailure$, "io.circe.DecodingFailure$", ({
  Lio_circe_DecodingFailure$: 1
}));
export { $d_Lio_circe_DecodingFailure$ as $d_Lio_circe_DecodingFailure$ };
var $n_Lio_circe_DecodingFailure$;
function $m_Lio_circe_DecodingFailure$() {
  if ((!$n_Lio_circe_DecodingFailure$)) {
    $n_Lio_circe_DecodingFailure$ = new $c_Lio_circe_DecodingFailure$();
  }
  return $n_Lio_circe_DecodingFailure$;
}
export { $m_Lio_circe_DecodingFailure$ as $m_Lio_circe_DecodingFailure$ };
/** @constructor */
function $c_Lio_circe_DecodingFailure$DecodingFailureImpl$() {
}
export { $c_Lio_circe_DecodingFailure$DecodingFailureImpl$ as $c_Lio_circe_DecodingFailure$DecodingFailureImpl$ };
$c_Lio_circe_DecodingFailure$DecodingFailureImpl$.prototype = new $h_O();
$c_Lio_circe_DecodingFailure$DecodingFailureImpl$.prototype.constructor = $c_Lio_circe_DecodingFailure$DecodingFailureImpl$;
/** @constructor */
function $h_Lio_circe_DecodingFailure$DecodingFailureImpl$() {
}
export { $h_Lio_circe_DecodingFailure$DecodingFailureImpl$ as $h_Lio_circe_DecodingFailure$DecodingFailureImpl$ };
$h_Lio_circe_DecodingFailure$DecodingFailureImpl$.prototype = $c_Lio_circe_DecodingFailure$DecodingFailureImpl$.prototype;
$c_Lio_circe_DecodingFailure$DecodingFailureImpl$.prototype.apply__Lio_circe_DecodingFailure$Reason__s_Option__Lcats_Eval__Lio_circe_DecodingFailure = (function(reason, pathToRoot, ops) {
  $m_Lcats_Eval$();
  var reason$1 = new $c_Lcats_Now(reason);
  return new $c_Lio_circe_DecodingFailure$DecodingFailureImpl(reason$1, pathToRoot, ops);
});
var $d_Lio_circe_DecodingFailure$DecodingFailureImpl$ = new $TypeData().initClass($c_Lio_circe_DecodingFailure$DecodingFailureImpl$, "io.circe.DecodingFailure$DecodingFailureImpl$", ({
  Lio_circe_DecodingFailure$DecodingFailureImpl$: 1
}));
export { $d_Lio_circe_DecodingFailure$DecodingFailureImpl$ as $d_Lio_circe_DecodingFailure$DecodingFailureImpl$ };
var $n_Lio_circe_DecodingFailure$DecodingFailureImpl$;
function $m_Lio_circe_DecodingFailure$DecodingFailureImpl$() {
  if ((!$n_Lio_circe_DecodingFailure$DecodingFailureImpl$)) {
    $n_Lio_circe_DecodingFailure$DecodingFailureImpl$ = new $c_Lio_circe_DecodingFailure$DecodingFailureImpl$();
  }
  return $n_Lio_circe_DecodingFailure$DecodingFailureImpl$;
}
export { $m_Lio_circe_DecodingFailure$DecodingFailureImpl$ as $m_Lio_circe_DecodingFailure$DecodingFailureImpl$ };
/** @constructor */
function $c_Lio_circe_DecodingFailure$Reason() {
}
export { $c_Lio_circe_DecodingFailure$Reason as $c_Lio_circe_DecodingFailure$Reason };
$c_Lio_circe_DecodingFailure$Reason.prototype = new $h_O();
$c_Lio_circe_DecodingFailure$Reason.prototype.constructor = $c_Lio_circe_DecodingFailure$Reason;
/** @constructor */
function $h_Lio_circe_DecodingFailure$Reason() {
}
export { $h_Lio_circe_DecodingFailure$Reason as $h_Lio_circe_DecodingFailure$Reason };
$h_Lio_circe_DecodingFailure$Reason.prototype = $c_Lio_circe_DecodingFailure$Reason.prototype;
/** @constructor */
function $c_Lio_circe_JsonObject$() {
  this.Lio_circe_JsonObject$__f_empty = null;
  this.Lio_circe_JsonObject$__f_eqJsonObject = null;
  $n_Lio_circe_JsonObject$ = this;
  this.Lio_circe_JsonObject$__f_empty = new $c_Lio_circe_JsonObject$MapAndVectorJsonObject($m_sci_Map$EmptyMap$(), ($m_sci_Vector$(), $m_sci_Vector0$()));
  this.Lio_circe_JsonObject$__f_eqJsonObject = ($m_Lcats_package$(), new $c_Lcats_kernel_Eq$$anon$6());
}
export { $c_Lio_circe_JsonObject$ as $c_Lio_circe_JsonObject$ };
$c_Lio_circe_JsonObject$.prototype = new $h_O();
$c_Lio_circe_JsonObject$.prototype.constructor = $c_Lio_circe_JsonObject$;
/** @constructor */
function $h_Lio_circe_JsonObject$() {
}
export { $h_Lio_circe_JsonObject$ as $h_Lio_circe_JsonObject$ };
$h_Lio_circe_JsonObject$.prototype = $c_Lio_circe_JsonObject$.prototype;
$c_Lio_circe_JsonObject$.prototype.fromIterable__sc_Iterable__Lio_circe_JsonObject = (function(fields) {
  if (fields.isEmpty__Z()) {
    return this.Lio_circe_JsonObject$__f_empty;
  } else {
    var map = $ct_ju_LinkedHashMap__(new $c_ju_LinkedHashMap());
    var iterator = fields.iterator__sc_Iterator();
    while (iterator.hasNext__Z()) {
      matchResult5: {
        var \u03b41$___1;
        var \u03b41$___2;
        var x16 = iterator.next__O();
        if ((x16 !== null)) {
          var key = x16._1__O();
          var value = x16._2__O();
          var \u03b41$___1 = key;
          var \u03b41$___2 = value;
          break matchResult5;
        }
        throw new $c_s_MatchError(x16);
      }
      var key$2 = \u03b41$___1;
      var value$2 = \u03b41$___2;
      if ((key$2 === null)) {
        var $x_1 = 0;
      } else {
        var originalHash = $f_T__hashCode__I(key$2);
        var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
      }
      map.java$util$HashMap$$put0__O__O__I__Z__O(key$2, value$2, $x_1, false);
    }
    return new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject(map);
  }
});
$c_Lio_circe_JsonObject$.prototype.singleton__T__Lio_circe_Json__Lio_circe_JsonObject = (function(key, value) {
  var this$2 = $m_sci_Map$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), key, value)]));
  var $x_1 = this$2.from__sc_IterableOnce__sci_Map(elems);
  var this$3 = $m_sci_Vector$();
  var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([key]));
  return new $c_Lio_circe_JsonObject$MapAndVectorJsonObject($x_1, this$3.from__sc_IterableOnce__sci_Vector(elems$1));
});
var $d_Lio_circe_JsonObject$ = new $TypeData().initClass($c_Lio_circe_JsonObject$, "io.circe.JsonObject$", ({
  Lio_circe_JsonObject$: 1
}));
export { $d_Lio_circe_JsonObject$ as $d_Lio_circe_JsonObject$ };
var $n_Lio_circe_JsonObject$;
function $m_Lio_circe_JsonObject$() {
  if ((!$n_Lio_circe_JsonObject$)) {
    $n_Lio_circe_JsonObject$ = new $c_Lio_circe_JsonObject$();
  }
  return $n_Lio_circe_JsonObject$;
}
export { $m_Lio_circe_JsonObject$ as $m_Lio_circe_JsonObject$ };
/** @constructor */
function $c_Lio_circe_JsoniterScalaCodec$() {
  this.Lio_circe_JsoniterScalaCodec$__f_intMin = null;
  this.Lio_circe_JsoniterScalaCodec$__f_intMax = null;
  this.Lio_circe_JsoniterScalaCodec$__f_longMin = null;
  this.Lio_circe_JsoniterScalaCodec$__f_longMax = null;
  $n_Lio_circe_JsoniterScalaCodec$ = this;
  this.Lio_circe_JsoniterScalaCodec$__f_intMin = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong((-2147483648), (-1)));
  this.Lio_circe_JsoniterScalaCodec$__f_intMax = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(2147483647, 0));
  this.Lio_circe_JsoniterScalaCodec$__f_longMin = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(0, (-2147483648)));
  this.Lio_circe_JsoniterScalaCodec$__f_longMax = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong((-1), 2147483647));
}
export { $c_Lio_circe_JsoniterScalaCodec$ as $c_Lio_circe_JsoniterScalaCodec$ };
$c_Lio_circe_JsoniterScalaCodec$.prototype = new $h_O();
$c_Lio_circe_JsoniterScalaCodec$.prototype.constructor = $c_Lio_circe_JsoniterScalaCodec$;
/** @constructor */
function $h_Lio_circe_JsoniterScalaCodec$() {
}
export { $h_Lio_circe_JsoniterScalaCodec$ as $h_Lio_circe_JsoniterScalaCodec$ };
$h_Lio_circe_JsoniterScalaCodec$.prototype = $c_Lio_circe_JsoniterScalaCodec$.prototype;
$c_Lio_circe_JsoniterScalaCodec$.prototype.io$circe$JsoniterScalaCodec$$$intValueExact__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(bd) {
  if ((bd.signum__I() !== 0)) {
    var p = bd.precision__I();
    var s = bd.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    if (((p <= s) || ((((-10) + p) | 0) > s))) {
      return null;
    }
    var bd0 = bd.setScale__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(0, $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UNNECESSARY);
    p = bd0.precision__I();
    if (((p > 10) || ((p === 10) && ((bd0.compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsoniterScalaCodec$__f_intMin) < 0) || (bd0.compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsoniterScalaCodec$__f_intMax) > 0))))) {
      return null;
    }
    return bd0;
  } else {
    return $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO;
  }
});
$c_Lio_circe_JsoniterScalaCodec$.prototype.io$circe$JsoniterScalaCodec$$$longValueExact__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(bd) {
  if ((bd.signum__I() !== 0)) {
    var p = bd.precision__I();
    var s = bd.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    if (((p <= s) || ((((-19) + p) | 0) > s))) {
      return null;
    }
    var bd0 = bd.setScale__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(0, $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UNNECESSARY);
    p = bd0.precision__I();
    if (((p > 19) || ((p === 19) && ((bd0.compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsoniterScalaCodec$__f_longMin) < 0) || (bd0.compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsoniterScalaCodec$__f_longMax) > 0))))) {
      return null;
    }
    return bd0;
  } else {
    return $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO;
  }
});
var $d_Lio_circe_JsoniterScalaCodec$ = new $TypeData().initClass($c_Lio_circe_JsoniterScalaCodec$, "io.circe.JsoniterScalaCodec$", ({
  Lio_circe_JsoniterScalaCodec$: 1
}));
export { $d_Lio_circe_JsoniterScalaCodec$ as $d_Lio_circe_JsoniterScalaCodec$ };
var $n_Lio_circe_JsoniterScalaCodec$;
function $m_Lio_circe_JsoniterScalaCodec$() {
  if ((!$n_Lio_circe_JsoniterScalaCodec$)) {
    $n_Lio_circe_JsoniterScalaCodec$ = new $c_Lio_circe_JsoniterScalaCodec$();
  }
  return $n_Lio_circe_JsoniterScalaCodec$;
}
export { $m_Lio_circe_JsoniterScalaCodec$ as $m_Lio_circe_JsoniterScalaCodec$ };
/** @constructor */
function $c_Lio_circe_PathToRoot$() {
  this.Lio_circe_PathToRoot$__f_empty = null;
  $n_Lio_circe_PathToRoot$ = this;
  $m_Lio_circe_PathToRoot$();
  $m_sci_Vector$();
  var value = $m_sci_Vector0$();
  this.Lio_circe_PathToRoot$__f_empty = value;
}
export { $c_Lio_circe_PathToRoot$ as $c_Lio_circe_PathToRoot$ };
$c_Lio_circe_PathToRoot$.prototype = new $h_O();
$c_Lio_circe_PathToRoot$.prototype.constructor = $c_Lio_circe_PathToRoot$;
/** @constructor */
function $h_Lio_circe_PathToRoot$() {
}
export { $h_Lio_circe_PathToRoot$ as $h_Lio_circe_PathToRoot$ };
$h_Lio_circe_PathToRoot$.prototype = $c_Lio_circe_PathToRoot$.prototype;
$c_Lio_circe_PathToRoot$.prototype.toPathString__sci_Vector__T = (function(path) {
  if ($f_sc_SeqOps__isEmpty__Z(path)) {
    return "";
  } else {
    var z = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), Math.imul(5, path.length__I()));
    var at = 0;
    var end = path.length__I();
    var acc = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = path.apply__I__O(at);
        matchResult11: {
          var temp$acc;
          var x16 = $ct_T2__O__O__(new $c_T2(), x0, x1);
          var x22 = x16.T2__f__1;
          var x23 = x16.T2__f__2;
          if ((x23 instanceof $c_Lio_circe_PathToRoot$PathElem$ObjectKey)) {
            var x26 = x23.Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName;
            var temp$acc = x22.append__T__scm_StringBuilder(".").append__T__scm_StringBuilder(x26);
            break matchResult11;
          }
          if ((x23 instanceof $c_Lio_circe_PathToRoot$PathElem$ArrayIndex)) {
            var t = x23.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index;
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            var $x_2 = x22.append__T__scm_StringBuilder("[");
            var this$4 = $m_RTLong$();
            var temp$acc = $x_2.append__T__scm_StringBuilder(this$4.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi)).append__T__scm_StringBuilder("]");
            break matchResult11;
          }
          throw new $c_s_MatchError(x16);
        }
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
    var this$5 = $x_1;
    return this$5.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
});
$c_Lio_circe_PathToRoot$.prototype.fromHistory__sci_List__s_util_Either = (function(ops) {
  var target = ops.reverse__sci_List();
  $m_Lcats_UnorderedFoldable$();
  var tc = $m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList;
  var this$41 = new $c_Lcats_Foldable$ToFoldableOps$$anon$6(target, tc);
  $m_sci_Vector$();
  var z = $m_sci_Vector0$();
  var f = new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => {
    if ((x$1 !== null)) {
      var x104 = $m_sc_package$$colon$plus$().unapply__sc_SeqOps__s_Option(x$1);
      if ((!x104.isEmpty__Z())) {
        var x105 = x104.get__O();
        var x106 = x105._1__O();
        var x107 = x105._2__O();
        if ((x107 instanceof $c_Lio_circe_PathToRoot$PathElem$ArrayIndex)) {
          var t = x107.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index;
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          var x = $m_Lio_circe_CursorOp$MoveLeft$();
          if (((x === x$2) && ((hi === 0) ? (lo === 0) : (hi < 0)))) {
            return new $c_s_util_Left("Attempt to move beyond beginning of array in cursor history.");
          }
          var x$4 = $m_Lio_circe_CursorOp$MoveLeft$();
          if ((x$4 === x$2)) {
            var lo$1 = (((-1) + lo) | 0);
            var hi$1 = (((((-1) + hi) | 0) + (((lo | (~lo$1)) >>> 31) | 0)) | 0);
            var elem = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(new $c_RTLong(lo$1, hi$1));
            var value = x106.appended__O__O(elem);
            return new $c_s_util_Right(value);
          }
          var x$6 = $m_Lio_circe_CursorOp$MoveRight$();
          if ((x$6 === x$2)) {
            var evidence$1 = $m_Lcats_kernel_instances_long_package$().Lcats_kernel_instances_long_package$__f_catsKernelStdOrderForLong;
            if (new $c_Lcats_syntax_EqOps(new $c_RTLong(lo, hi), evidence$1).$eq$eq$eq__O__Z(new $c_RTLong(2147483647, 0))) {
              return new $c_s_util_Left("Attempt to move to index > Int.MaxValue in array in cursor history.");
            }
            var lo$2 = ((1 + lo) | 0);
            var hi$2 = ((hi + (((lo & (~lo$2)) >>> 31) | 0)) | 0);
            var elem$1 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(new $c_RTLong(lo$2, hi$2));
            var value$1 = x106.appended__O__O(elem$1);
            return new $c_s_util_Right(value$1);
          }
        }
        var x$8 = $m_Lio_circe_CursorOp$MoveUp$();
        if ((x$8 === x$2)) {
          return new $c_s_util_Right(x106);
        }
      }
    }
    var x$10 = $m_Lio_circe_CursorOp$MoveUp$();
    if ((x$10 === x$2)) {
      return new $c_s_util_Left("Attempt to move up above the root of the JSON.");
    }
    if ((x$1 !== null)) {
      var x60 = $m_sc_package$$colon$plus$().unapply__sc_SeqOps__s_Option(x$1);
      if ((!x60.isEmpty__Z())) {
        var x61 = x60.get__O();
        var acc$7 = x61._1__O();
        if ((x61._2__O() instanceof $c_Lio_circe_PathToRoot$PathElem$ObjectKey)) {
          var x$1$1 = x61._2__O();
          if (false) {
            var x59 = x$2.Lio_circe_CursorOp$Field__f_k;
            var elem$2 = new $c_Lio_circe_PathToRoot$PathElem$ObjectKey(x59);
            var value$2 = acc$7.appended__O__O(elem$2);
            return new $c_s_util_Right(value$2);
          }
        }
      }
    }
    if (false) {
      return new $c_s_util_Left("Attempt to move to sibling field, but cursor history didn't indicate we were in an object.");
    }
    if ((x$2 instanceof $c_Lio_circe_CursorOp$DownField)) {
      var x49 = x$2.Lio_circe_CursorOp$DownField__f_k;
      var elem$3 = new $c_Lio_circe_PathToRoot$PathElem$ObjectKey(x49);
      var value$3 = x$1.appended__O__O(elem$3);
      return new $c_s_util_Right(value$3);
    }
    var x$12 = $m_Lio_circe_CursorOp$DownArray$();
    if ((x$12 === x$2)) {
      var elem$4 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex($L0);
      var value$4 = x$1.appended__O__O(elem$4);
      return new $c_s_util_Right(value$4);
    }
    if ((x$2 instanceof $c_Lio_circe_CursorOp$DownN)) {
      var x42 = x$2.Lio_circe_CursorOp$DownN__f_n;
      var hi$3 = (x42 >> 31);
      var elem$5 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(new $c_RTLong(x42, hi$3));
      var value$5 = x$1.appended__O__O(elem$5);
      return new $c_s_util_Right(value$5);
    }
    if ((x$1 !== null)) {
      var x34 = $m_sc_package$$colon$plus$().unapply__sc_SeqOps__s_Option(x$1);
      if ((!x34.isEmpty__Z())) {
        var x35 = x34.get__O();
        var acc$11 = x35._1__O();
        var x$14 = $m_Lio_circe_CursorOp$DeleteGoParent$();
        if ((x$14 === x$2)) {
          return new $c_s_util_Right(acc$11);
        }
      }
    }
    var x$16 = $m_Lio_circe_CursorOp$DeleteGoParent$();
    if ((x$16 === x$2)) {
      return new $c_s_util_Left("Attempt to move up above the root of the JSON.");
    }
    var value$6 = ("Invalid cursor history state: " + x$2);
    return new $c_s_util_Left(value$6);
  }));
  $m_Lcats_instances_package$either$();
  var G = new $c_Lcats_instances_EitherInstances$$anon$2();
  var this$42 = this$41.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance.foldM__O__O__F2__Lcats_Monad__O(this$41.Lcats_Foldable$ToFoldableOps$$anon$6__f_self, z, f, G);
  if ((this$42 instanceof $c_s_util_Right)) {
    var b = this$42.s_util_Right__f_value;
    return new $c_s_util_Right(new $c_Lio_circe_PathToRoot(($m_Lio_circe_PathToRoot$(), b)));
  } else {
    return this$42;
  }
});
$c_Lio_circe_PathToRoot$.prototype.equals$extension__sci_Vector__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lio_circe_PathToRoot)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.Lio_circe_PathToRoot__f_value);
    return ((this$ === null) ? (x$0$2 === null) : this$.equals__O__Z(x$0$2));
  } else {
    return false;
  }
});
$c_Lio_circe_PathToRoot$.prototype.toString$extension__sci_Vector__T = (function(this$) {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(new $c_Lio_circe_PathToRoot(this$));
});
$c_Lio_circe_PathToRoot$.prototype.productElement$extension__sci_Vector__I__O = (function(this$, n) {
  if ((n === 0)) {
    return this$;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_PathToRoot$.prototype.productElementName$extension__sci_Vector__I__T = (function(this$, n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_PathToRoot$.prototype.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector = (function(this$, elem) {
  $m_Lio_circe_PathToRoot$();
  var value = this$.prepended__O__sci_Vector(elem);
  return value;
});
var $d_Lio_circe_PathToRoot$ = new $TypeData().initClass($c_Lio_circe_PathToRoot$, "io.circe.PathToRoot$", ({
  Lio_circe_PathToRoot$: 1
}));
export { $d_Lio_circe_PathToRoot$ as $d_Lio_circe_PathToRoot$ };
var $n_Lio_circe_PathToRoot$;
function $m_Lio_circe_PathToRoot$() {
  if ((!$n_Lio_circe_PathToRoot$)) {
    $n_Lio_circe_PathToRoot$ = new $c_Lio_circe_PathToRoot$();
  }
  return $n_Lio_circe_PathToRoot$;
}
export { $m_Lio_circe_PathToRoot$ as $m_Lio_circe_PathToRoot$ };
function $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal($thiz, unscaled, scale) {
  var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(unscaled, yn)) {
    return $thiz.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero;
  } else {
    var current = unscaled;
    var lo = scale.RTLong__f_lo;
    var hi = scale.RTLong__f_hi;
    var depth__lo = lo;
    var depth__hi = hi;
    var divAndRem = current.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
    while (true) {
      var xn = divAndRem.u[1];
      var yn$1 = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn$1)) {
        current = divAndRem.u[0];
        var b__lo = depth__lo;
        var b__hi = depth__hi;
        var blo = b__lo;
        var lo$1 = (((-1) + blo) | 0);
        var hi$1 = (((((-1) + b__hi) | 0) + (((blo | (~lo$1)) >>> 31) | 0)) | 0);
        var $x_1__lo = lo$1;
        var $x_1__hi = hi$1;
        depth__lo = $x_1__lo;
        depth__hi = $x_1__hi;
        divAndRem = current.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
      } else {
        break;
      }
    }
    var $x_2 = current;
    var lVal__lo = depth__lo;
    var lVal__hi = depth__hi;
    return new $c_Lio_circe_numbers_SigAndExp($x_2, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lVal__lo, lVal__hi)));
  }
}
export { $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal as $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal };
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$() {
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxInt = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_MinInt = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero = null;
  this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero = null;
  $n_Lio_circe_numbers_BiggerDecimal$ = this;
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxBigIntegerDigits = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(262144, 0));
  this.Lio_circe_numbers_BiggerDecimal$__f_MaxInt = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(2147483647, 0));
  this.Lio_circe_numbers_BiggerDecimal$__f_MinInt = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong((-2147483648), (-1)));
  $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong((-1), 2147483647));
  $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong(0, (-2147483648)));
  this.Lio_circe_numbers_BiggerDecimal$__f_UnsignedZero = new $c_Lio_circe_numbers_BiggerDecimal$$anon$1();
  this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero = new $c_Lio_circe_numbers_BiggerDecimal$$anon$2();
}
export { $c_Lio_circe_numbers_BiggerDecimal$ as $c_Lio_circe_numbers_BiggerDecimal$ };
$c_Lio_circe_numbers_BiggerDecimal$.prototype = new $h_O();
$c_Lio_circe_numbers_BiggerDecimal$.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$() {
}
export { $h_Lio_circe_numbers_BiggerDecimal$ as $h_Lio_circe_numbers_BiggerDecimal$ };
$h_Lio_circe_numbers_BiggerDecimal$.prototype = $c_Lio_circe_numbers_BiggerDecimal$.prototype;
$c_Lio_circe_numbers_BiggerDecimal$.prototype.fromLong__J__Lio_circe_numbers_BiggerDecimal = (function(d) {
  return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this, $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(d), $L0);
});
$c_Lio_circe_numbers_BiggerDecimal$.prototype.fromDoubleUnsafe__D__Lio_circe_numbers_BiggerDecimal = (function(d) {
  if (($m_jl_Double$().compare__D__D__I(d, (-0)) === 0)) {
    return this.Lio_circe_numbers_BiggerDecimal$__f_NegativeZero;
  } else {
    var d$1 = $m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d);
    var $x_1 = d$1.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var value = d$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    return $p_Lio_circe_numbers_BiggerDecimal$__fromUnscaledAndScale__Ljava_math_BigInteger__J__Lio_circe_numbers_BiggerDecimal(this, $x_1, new $c_RTLong(value, hi));
  }
});
var $d_Lio_circe_numbers_BiggerDecimal$ = new $TypeData().initClass($c_Lio_circe_numbers_BiggerDecimal$, "io.circe.numbers.BiggerDecimal$", ({
  Lio_circe_numbers_BiggerDecimal$: 1
}));
export { $d_Lio_circe_numbers_BiggerDecimal$ as $d_Lio_circe_numbers_BiggerDecimal$ };
var $n_Lio_circe_numbers_BiggerDecimal$;
function $m_Lio_circe_numbers_BiggerDecimal$() {
  if ((!$n_Lio_circe_numbers_BiggerDecimal$)) {
    $n_Lio_circe_numbers_BiggerDecimal$ = new $c_Lio_circe_numbers_BiggerDecimal$();
  }
  return $n_Lio_circe_numbers_BiggerDecimal$;
}
export { $m_Lio_circe_numbers_BiggerDecimal$ as $m_Lio_circe_numbers_BiggerDecimal$ };
/** @constructor */
function $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, radixPowLengthInverse, paddingZeros, overflowBarrier) {
  this.jl_Long$StringRadixInfo__f_chunkLength = 0;
  this.jl_Long$StringRadixInfo__f_radixPowLength = 0;
  this.jl_Long$StringRadixInfo__f_radixPowLengthInverse = 0.0;
  this.jl_Long$StringRadixInfo__f_paddingZeros = null;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = $L0;
  this.jl_Long$StringRadixInfo__f_chunkLength = chunkLength;
  this.jl_Long$StringRadixInfo__f_radixPowLength = radixPowLength;
  this.jl_Long$StringRadixInfo__f_radixPowLengthInverse = radixPowLengthInverse;
  this.jl_Long$StringRadixInfo__f_paddingZeros = paddingZeros;
  this.jl_Long$StringRadixInfo__f_overflowBarrier = overflowBarrier;
}
export { $c_jl_Long$StringRadixInfo as $c_jl_Long$StringRadixInfo };
$c_jl_Long$StringRadixInfo.prototype = new $h_O();
$c_jl_Long$StringRadixInfo.prototype.constructor = $c_jl_Long$StringRadixInfo;
/** @constructor */
function $h_jl_Long$StringRadixInfo() {
}
export { $h_jl_Long$StringRadixInfo as $h_jl_Long$StringRadixInfo };
$h_jl_Long$StringRadixInfo.prototype = $c_jl_Long$StringRadixInfo.prototype;
var $d_jl_Long$StringRadixInfo = new $TypeData().initClass($c_jl_Long$StringRadixInfo, "java.lang.Long$StringRadixInfo", ({
  jl_Long$StringRadixInfo: 1
}));
export { $d_jl_Long$StringRadixInfo as $d_jl_Long$StringRadixInfo };
/** @constructor */
function $c_jl_Math$() {
}
export { $c_jl_Math$ as $c_jl_Math$ };
$c_jl_Math$.prototype = new $h_O();
$c_jl_Math$.prototype.constructor = $c_jl_Math$;
/** @constructor */
function $h_jl_Math$() {
}
export { $h_jl_Math$ as $h_jl_Math$ };
$h_jl_Math$.prototype = $c_jl_Math$.prototype;
$c_jl_Math$.prototype.nextUp__F__F = (function(a) {
  var bits = $floatToBits(a);
  var x = (bits >> 31);
  var y = (1 | x);
  var newBits = ((bits + y) | 0);
  var x$1 = (bits ^ newBits);
  var y$1 = (x$1 >> 8);
  var bits$1 = (newBits | y$1);
  var x$2 = (2139095040 & bits$1);
  if ((x$2 !== 2139095040)) {
    return $floatFromBits(newBits);
  } else {
    var x$3 = Math.fround((a + a));
    return Math.fround((x$3 + 1.401298464324817E-45));
  }
});
$c_jl_Math$.prototype.nextDown__F__F = (function(a) {
  var bits = $floatToBits(a);
  var x = (bits >> 31);
  var y = (1 | x);
  var newBits = ((bits - y) | 0);
  var x$1 = (bits ^ newBits);
  var y$1 = (x$1 >> 8);
  var bits$1 = (newBits | y$1);
  var x$2 = (2139095040 & bits$1);
  if ((x$2 !== 2139095040)) {
    return $floatFromBits(newBits);
  } else {
    var x$3 = Math.fround((a + a));
    return Math.fround((x$3 - 1.401298464324817E-45));
  }
});
$c_jl_Math$.prototype.scalb__D__I__D = (function(d, scaleFactor) {
  var fpBitsDataView = $fpBitsDataView;
  fpBitsDataView.setFloat64(0, d, true);
  var lo = (fpBitsDataView.getInt32(0, true) | 0);
  var hi = (fpBitsDataView.getInt32(4, true) | 0);
  var lo$1 = ((hi >>> 20) | 0);
  var e = (2047 & lo$1);
  var newE = ((e + scaleFactor) | 0);
  var hi$1 = ((-2146435073) & hi);
  var java$lang$IntFloatBits$Int64Box$$value__lo = 0;
  var java$lang$IntFloatBits$Int64Box$$value__hi = 0;
  var $x_1__lo = lo;
  var $x_1__hi = hi$1;
  java$lang$IntFloatBits$Int64Box$$value__lo = $x_1__lo;
  java$lang$IntFloatBits$Int64Box$$value__hi = $x_1__hi;
  var x = (((-1) + e) | 0);
  if ((!((x >>> 0) <= 2045))) {
    var hi$2 = (2147483647 & hi);
    if ((((lo === 0) && (hi$2 === 0)) || (hi$2 >= 2146435072))) {
      return d;
    }
    var hi$3 = (1048575 & hi);
    var clz = ((hi$3 !== 0) ? Math.clz32(hi$3) : ((32 + Math.clz32(lo)) | 0));
    newE = ((newE - (((-12) + clz) | 0)) | 0);
    var hi$4 = ((-2147483648) & hi);
    var y = (((-11) + clz) | 0);
    var lo$2 = (((32 & y) === 0) ? (lo << y) : 0);
    var hi$5 = (((32 & y) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - y) | 0)) | 0) | (hi << y)) : (lo << y));
    var hi$6 = (1048575 & hi$5);
    var hi$7 = (hi$4 | hi$6);
    var $x_2__lo = lo$2;
    var $x_2__hi = hi$7;
    java$lang$IntFloatBits$Int64Box$$value__lo = $x_2__lo;
    java$lang$IntFloatBits$Int64Box$$value__hi = $x_2__hi;
  }
  var e$1 = newE;
  var x$1 = (((-1) + e$1) | 0);
  if (((x$1 >>> 0) <= 2045)) {
    var finalNewE = newE;
    var finalSignAndMantissa__lo = java$lang$IntFloatBits$Int64Box$$value__lo;
    var finalSignAndMantissa__hi = java$lang$IntFloatBits$Int64Box$$value__hi;
    var hi$8 = (finalNewE << 20);
    var lo$3 = finalSignAndMantissa__lo;
    var hi$9 = (hi$8 | finalSignAndMantissa__hi);
    var fpBitsDataView$1 = $fpBitsDataView;
    fpBitsDataView$1.setInt32(0, lo$3, true);
    fpBitsDataView$1.setInt32(4, hi$9, true);
    return (+fpBitsDataView$1.getFloat64(0, true));
  } else {
    var x$2 = newE;
    var x$3 = ((53 + x$2) | 0);
    if (((x$3 >>> 0) <= 53)) {
      var finalNewE$1 = ((54 + newE) | 0);
      var finalSignAndMantissa$1__lo = java$lang$IntFloatBits$Int64Box$$value__lo;
      var finalSignAndMantissa$1__hi = java$lang$IntFloatBits$Int64Box$$value__hi;
      var hi$10 = (finalNewE$1 << 20);
      var lo$4 = finalSignAndMantissa$1__lo;
      var hi$11 = (hi$10 | finalSignAndMantissa$1__hi);
      var fpBitsDataView$2 = $fpBitsDataView;
      fpBitsDataView$2.setInt32(0, lo$4, true);
      fpBitsDataView$2.setInt32(4, hi$11, true);
      var x$4 = (+fpBitsDataView$2.getFloat64(0, true));
      return (5.551115123125783E-17 * x$4);
    } else {
      var finalNewE$2 = (2047 & (~(scaleFactor >> 31)));
      var hi$12 = ((-2147483648) & hi);
      var hi$13 = (finalNewE$2 << 20);
      var hi$14 = (hi$13 | hi$12);
      var fpBitsDataView$3 = $fpBitsDataView;
      fpBitsDataView$3.setInt32(0, 0, true);
      fpBitsDataView$3.setInt32(4, hi$14, true);
      return (+fpBitsDataView$3.getFloat64(0, true));
    }
  }
});
$c_jl_Math$.prototype.java$lang$Math$$intOverflow__E = (function() {
  throw new $c_jl_ArithmeticException("Integer overflow");
});
$c_jl_Math$.prototype.java$lang$Math$$longOverflow__E = (function() {
  throw new $c_jl_ArithmeticException("Long overflow");
});
var $d_jl_Math$ = new $TypeData().initClass($c_jl_Math$, "java.lang.Math$", ({
  jl_Math$: 1
}));
export { $d_jl_Math$ as $d_jl_Math$ };
var $n_jl_Math$;
function $m_jl_Math$() {
  if ((!$n_jl_Math$)) {
    $n_jl_Math$ = new $c_jl_Math$();
  }
  return $n_jl_Math$;
}
export { $m_jl_Math$ as $m_jl_Math$ };
function $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement($thiz, lines) {
  var NormalizedFrameLine = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^([^@]*)@(.*?):([0-9]+)(?::([0-9]+))?$");
  var trace = [];
  var i = 0;
  while ((i < (lines.length | 0))) {
    var line = lines[i];
    if ((line !== "")) {
      var mtch = NormalizedFrameLine.exec(line);
      if ((mtch !== null)) {
        var x = mtch[1];
        var classAndMethodName = $p_jl_StackTrace$__extractClassMethod__T__O($thiz, x);
        var $x_4 = classAndMethodName[0];
        var $x_3 = classAndMethodName[1];
        var x$1 = mtch[2];
        var x$2 = mtch[3];
        var $x_2 = parseInt(x$2);
        var x$3 = mtch[4];
        var $x_1 = trace.push($ct_jl_StackTraceElement__T__T__T__I__I__(new $c_jl_StackTraceElement(), $x_4, $x_3, x$1, ($x_2 | 0), ((x$3 !== (void 0)) ? (parseInt(x$3) | 0) : (-1))));
      } else {
        (trace.push($ct_jl_StackTraceElement__T__T__T__I__I__(new $c_jl_StackTraceElement(), "<jscode>", line, null, (-1), (-1))) | 0);
      }
    }
    i = ((1 + i) | 0);
  }
  var len = (trace.length | 0);
  var result = new ($d_jl_StackTraceElement.getArrayOf().constr)(len);
  i = 0;
  while ((i < len)) {
    result.u[i] = trace[i];
    i = ((1 + i) | 0);
  }
  return result;
}
export { $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement as $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement };
function $p_jl_StackTrace$__extractClassMethod__T__O($thiz, functionName) {
  var PatBC = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$[bc]_([^\\.]+)(?:\\.prototype)?\\.([^\\.]+)$");
  var PatS = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$(?:ps?|s|f)_((?:_[^_]|[^_])+)__([^\\.]+)$");
  var PatCT = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$ct_((?:_[^_]|[^_])+)__([^\\.]*)$");
  var PatN = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^new (?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$c_([^\\.]+)$");
  var PatM = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(?:Object\\.|\\[object Object\\]\\.|Module\\.)?\\$m_([^\\.]+)$");
  var matchBC = PatBC.exec(functionName);
  var matchBCOrS = ((matchBC !== null) ? matchBC : PatS.exec(functionName));
  if ((matchBCOrS !== null)) {
    var x = matchBCOrS[1];
    var $x_1 = $p_jl_StackTrace$__decodeClassName__T__T($thiz, x);
    var x$1 = matchBCOrS[2];
    return [$x_1, $p_jl_StackTrace$__decodeMethodName__T__T($thiz, x$1)];
  } else {
    var matchCT = PatCT.exec(functionName);
    var matchCTOrN = ((matchCT !== null) ? matchCT : PatN.exec(functionName));
    if ((matchCTOrN !== null)) {
      var x$2 = matchCTOrN[1];
      return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, x$2), "<init>"];
    } else {
      var matchM = PatM.exec(functionName);
      if ((matchM !== null)) {
        var x$3 = matchM[1];
        return [$p_jl_StackTrace$__decodeClassName__T__T($thiz, x$3), "<clinit>"];
      } else {
        return ["<jscode>", functionName];
      }
    }
  }
}
export { $p_jl_StackTrace$__extractClassMethod__T__O as $p_jl_StackTrace$__extractClassMethod__T__O };
function $p_jl_StackTrace$__decodeClassName__T__T($thiz, encodedName) {
  var dict = $p_jl_StackTrace$__decompressedClasses__O($thiz);
  if ((!(!$m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, encodedName)))) {
    var dict$1 = $p_jl_StackTrace$__decompressedClasses__O($thiz);
    var base = dict$1[encodedName];
  } else {
    var base = $p_jl_StackTrace$__loop$1__I__T__T($thiz, 0, encodedName);
  }
  var this$3 = base.split("_").join(".");
  return this$3.split("\uff3f").join("_");
}
export { $p_jl_StackTrace$__decodeClassName__T__T as $p_jl_StackTrace$__decodeClassName__T__T };
function $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = ({});
    dict.O = "java_lang_Object";
    dict.T = "java_lang_String";
    var index = 0;
    while ((index <= 22)) {
      if ((index >= 2)) {
        var key = ("T" + index);
        var value = ("scala_Tuple" + index);
        dict[key] = value;
      }
      var key$1 = ("F" + index);
      var value$1 = ("scala_Function" + index);
      dict[key$1] = value$1;
      index = ((1 + index) | 0);
    }
    $thiz.jl_StackTrace$__f_decompressedClasses = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((1 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_StackTrace$__f_decompressedClasses;
}
export { $p_jl_StackTrace$__decompressedClasses$lzycompute__O as $p_jl_StackTrace$__decompressedClasses$lzycompute__O };
function $p_jl_StackTrace$__decompressedClasses__O($thiz) {
  return (((((1 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedClasses$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedClasses);
}
export { $p_jl_StackTrace$__decompressedClasses__O as $p_jl_StackTrace$__decompressedClasses__O };
function $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    var dict = ({});
    dict.sjsr_ = "scala_scalajs_runtime_";
    dict.sjs_ = "scala_scalajs_";
    dict.sci_ = "scala_collection_immutable_";
    dict.scm_ = "scala_collection_mutable_";
    dict.scg_ = "scala_collection_generic_";
    dict.sc_ = "scala_collection_";
    dict.sr_ = "scala_runtime_";
    dict.s_ = "scala_";
    dict.jl_ = "java_lang_";
    dict.ju_ = "java_util_";
    $thiz.jl_StackTrace$__f_decompressedPrefixes = dict;
    $thiz.jl_StackTrace$__f_bitmap$0 = (((2 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_StackTrace$__f_decompressedPrefixes;
}
export { $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O as $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O };
function $p_jl_StackTrace$__decompressedPrefixes__O($thiz) {
  return (((((2 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__decompressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_decompressedPrefixes);
}
export { $p_jl_StackTrace$__decompressedPrefixes__O as $p_jl_StackTrace$__decompressedPrefixes__O };
function $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) {
  if (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_StackTrace$__f_compressedPrefixes = Object.keys($p_jl_StackTrace$__decompressedPrefixes__O($thiz));
    $thiz.jl_StackTrace$__f_bitmap$0 = (((4 | $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_StackTrace$__f_compressedPrefixes;
}
export { $p_jl_StackTrace$__compressedPrefixes$lzycompute__O as $p_jl_StackTrace$__compressedPrefixes$lzycompute__O };
function $p_jl_StackTrace$__compressedPrefixes__O($thiz) {
  return (((((4 & $thiz.jl_StackTrace$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_StackTrace$__compressedPrefixes$lzycompute__O($thiz) : $thiz.jl_StackTrace$__f_compressedPrefixes);
}
export { $p_jl_StackTrace$__compressedPrefixes__O as $p_jl_StackTrace$__compressedPrefixes__O };
function $p_jl_StackTrace$__decodeMethodName__T__T($thiz, encodedName) {
  if ((!(!encodedName.startsWith("init___")))) {
    return "<init>";
  } else {
    var methodNameLen = (encodedName.indexOf("__") | 0);
    return ((methodNameLen < 0) ? encodedName : encodedName.substring(0, methodNameLen));
  }
}
export { $p_jl_StackTrace$__decodeMethodName__T__T as $p_jl_StackTrace$__decodeMethodName__T__T };
function $p_jl_StackTrace$__normalizeStackTraceLines__O__O($thiz, e) {
  return ((!(!(!(!(!e))))) ? [] : ((!(!(!(!(e.arguments && e.stack))))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : ((!(!(!(!(e.stack && e.sourceURL))))) ? $p_jl_StackTrace$__extractSafari__O__O($thiz, e) : ((!(!(!(!(e.stack && e.number))))) ? $p_jl_StackTrace$__extractIE__O__O($thiz, e) : ((!(!(!(!(e.stack && e.fileName))))) ? $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) : ((!(!(!(!(e.message && e["opera#sourceloc"]))))) ? ((!(!(!(!(!e.stacktrace))))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : ((!(!(!(!((e.message.indexOf("\n") > (-1.0)) && (e.message.split("\n").length > e.stacktrace.split("\n").length)))))) ? $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e))) : ((!(!(!(!((e.message && e.stack) && e.stacktrace))))) ? ((!(!(!(!(e.stacktrace.indexOf("called from line") < 0.0))))) ? $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) : $p_jl_StackTrace$__extractOpera11__O__O($thiz, e)) : ((!(!(!(!(e.stack && (!e.fileName)))))) ? $p_jl_StackTrace$__extractChrome__O__O($thiz, e) : $p_jl_StackTrace$__extractOther__O__O($thiz, e)))))))));
}
export { $p_jl_StackTrace$__normalizeStackTraceLines__O__O as $p_jl_StackTrace$__normalizeStackTraceLines__O__O };
function $p_jl_StackTrace$__extractChrome__O__O($thiz, e) {
  return (e.stack + "\n").replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("^[\\s\\S]+?\\s+at\\s+"), " at ").replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^\\s+(at eval )?at\\s+", "gm"), "").replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+?)([\\n])", "gm"), "{anonymous}() ($1)$2").replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^Object.<anonymous>\\s*\\(([^\\)]+)\\)", "gm"), "{anonymous}() ($1)").replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\)) \\((.+)\\)$", "gm"), "$1@$2").split("\n").slice(0, (-1));
}
export { $p_jl_StackTrace$__extractChrome__O__O as $p_jl_StackTrace$__extractChrome__O__O };
function $p_jl_StackTrace$__extractFirefox__O__O($thiz, e) {
  return e.stack.replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("(?:\\n@:0)?\\s+$", "m"), "").replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^(?:\\((\\S*)\\))?@", "gm"), "{anonymous}($1)@").split("\n");
}
export { $p_jl_StackTrace$__extractFirefox__O__O as $p_jl_StackTrace$__extractFirefox__O__O };
function $p_jl_StackTrace$__extractIE__O__O($thiz, e) {
  var qual$1 = e.stack.replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^\\s*at\\s+(.*)$", "gm"), "$1").replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^Anonymous function\\s+", "gm"), "{anonymous}() ").replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^([^\\(]+|\\{anonymous\\}\\(\\))\\s+\\((.+)\\)$", "gm"), "$1@$2").split("\n");
  return qual$1.slice(1);
}
export { $p_jl_StackTrace$__extractIE__O__O as $p_jl_StackTrace$__extractIE__O__O };
function $p_jl_StackTrace$__extractSafari__O__O($thiz, e) {
  return e.stack.replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("\\[native code\\]\\n", "m"), "").replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^(?=\\w+Error\\:).*$\\n", "m"), "").replace($m_jl_StackTrace$StringRE$().re$extension1__T__T__O("^@", "gm"), "{anonymous}()@").split("\n");
}
export { $p_jl_StackTrace$__extractSafari__O__O as $p_jl_StackTrace$__extractSafari__O__O };
function $p_jl_StackTrace$__extractOpera9__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension1__T__T__O("Line (\\d+).*script (?:in )?(\\S+)", "i");
  var lines = e.message.split("\n");
  var result = [];
  var i = 2;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      var x = mtch[2];
      var x$1 = mtch[1];
      var $x_1 = result.push(((("{anonymous}()@" + x) + ":") + x$1));
    }
    i = ((2 + i) | 0);
  }
  return result;
}
export { $p_jl_StackTrace$__extractOpera9__O__O as $p_jl_StackTrace$__extractOpera9__O__O };
function $p_jl_StackTrace$__extractOpera10a__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension1__T__T__O("Line (\\d+).*script (?:in )?(\\S+)(?:: In function (\\S+))?$", "i");
  var lines = e.stacktrace.split("\n");
  var result = [];
  var i = 0;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      var x = mtch[3];
      var fnName = ((x !== (void 0)) ? x : "{anonymous}");
      var x$1 = mtch[2];
      var x$2 = mtch[1];
      var $x_1 = result.push(((((fnName + "()@") + x$1) + ":") + x$2));
    }
    i = ((2 + i) | 0);
  }
  return result;
}
export { $p_jl_StackTrace$__extractOpera10a__O__O as $p_jl_StackTrace$__extractOpera10a__O__O };
function $p_jl_StackTrace$__extractOpera10b__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^(.*)@(.+):(\\d+)$");
  var lines = e.stacktrace.split("\n");
  var result = [];
  var i = 0;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      var x = mtch[1];
      var fnName = ((x !== (void 0)) ? (x + "()") : "global code");
      var x$1 = mtch[2];
      var x$2 = mtch[3];
      var $x_1 = result.push(((((fnName + "@") + x$1) + ":") + x$2));
    }
    i = ((1 + i) | 0);
  }
  return result;
}
export { $p_jl_StackTrace$__extractOpera10b__O__O as $p_jl_StackTrace$__extractOpera10b__O__O };
function $p_jl_StackTrace$__extractOpera11__O__O($thiz, e) {
  var lineRE = $m_jl_StackTrace$StringRE$().re$extension0__T__O("^.*line (\\d+), column (\\d+)(?: in (.+))? in (\\S+):$");
  var lines = e.stacktrace.split("\n");
  var result = [];
  var i = 0;
  var len = (lines.length | 0);
  while ((i < len)) {
    var mtch = lineRE.exec(lines[i]);
    if ((mtch !== null)) {
      var x = mtch[4];
      var x$1 = mtch[1];
      var x$2 = mtch[2];
      var location = ((((x + ":") + x$1) + ":") + x$2);
      var x$3 = mtch[2];
      var fnName0 = ((x$3 !== (void 0)) ? x$3 : "global code");
      var fnName = fnName0.replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("<anonymous function: (\\S+)>"), "$1").replace($m_jl_StackTrace$StringRE$().re$extension0__T__O("<anonymous function>"), "{anonymous}");
      (result.push(((fnName + "@") + location)) | 0);
    }
    i = ((2 + i) | 0);
  }
  return result;
}
export { $p_jl_StackTrace$__extractOpera11__O__O as $p_jl_StackTrace$__extractOpera11__O__O };
function $p_jl_StackTrace$__extractOther__O__O($thiz, e) {
  return [];
}
export { $p_jl_StackTrace$__extractOther__O__O as $p_jl_StackTrace$__extractOther__O__O };
function $p_jl_StackTrace$__loop$1__I__T__T($thiz, i, encodedName$1) {
  while (true) {
    if ((i < ($p_jl_StackTrace$__compressedPrefixes__O($thiz).length | 0))) {
      var prefix = $p_jl_StackTrace$__compressedPrefixes__O($thiz)[i];
      if ((!(!encodedName$1.startsWith(prefix)))) {
        var dict = $p_jl_StackTrace$__decompressedPrefixes__O($thiz);
        return (("" + dict[prefix]) + encodedName$1.substring(prefix.length));
      } else {
        i = ((1 + i) | 0);
      }
    } else {
      return ((!(!encodedName$1.startsWith("L"))) ? encodedName$1.substring(1) : encodedName$1);
    }
  }
}
export { $p_jl_StackTrace$__loop$1__I__T__T as $p_jl_StackTrace$__loop$1__I__T__T };
/** @constructor */
function $c_jl_StackTrace$() {
  this.jl_StackTrace$__f_decompressedClasses = null;
  this.jl_StackTrace$__f_decompressedPrefixes = null;
  this.jl_StackTrace$__f_compressedPrefixes = null;
  this.jl_StackTrace$__f_bitmap$0 = 0;
}
export { $c_jl_StackTrace$ as $c_jl_StackTrace$ };
$c_jl_StackTrace$.prototype = new $h_O();
$c_jl_StackTrace$.prototype.constructor = $c_jl_StackTrace$;
/** @constructor */
function $h_jl_StackTrace$() {
}
export { $h_jl_StackTrace$ as $h_jl_StackTrace$ };
$h_jl_StackTrace$.prototype = $c_jl_StackTrace$.prototype;
$c_jl_StackTrace$.prototype.extract__O__Ajl_StackTraceElement = (function(jsError) {
  var lines = $p_jl_StackTrace$__normalizeStackTraceLines__O__O(this, jsError);
  return $p_jl_StackTrace$__normalizedLinesToStackTrace__O__Ajl_StackTraceElement(this, lines);
});
var $d_jl_StackTrace$ = new $TypeData().initClass($c_jl_StackTrace$, "java.lang.StackTrace$", ({
  jl_StackTrace$: 1
}));
export { $d_jl_StackTrace$ as $d_jl_StackTrace$ };
var $n_jl_StackTrace$;
function $m_jl_StackTrace$() {
  if ((!$n_jl_StackTrace$)) {
    $n_jl_StackTrace$ = new $c_jl_StackTrace$();
  }
  return $n_jl_StackTrace$;
}
export { $m_jl_StackTrace$ as $m_jl_StackTrace$ };
/** @constructor */
function $c_jl_StackTrace$StringRE$() {
}
export { $c_jl_StackTrace$StringRE$ as $c_jl_StackTrace$StringRE$ };
$c_jl_StackTrace$StringRE$.prototype = new $h_O();
$c_jl_StackTrace$StringRE$.prototype.constructor = $c_jl_StackTrace$StringRE$;
/** @constructor */
function $h_jl_StackTrace$StringRE$() {
}
export { $h_jl_StackTrace$StringRE$ as $h_jl_StackTrace$StringRE$ };
$h_jl_StackTrace$StringRE$.prototype = $c_jl_StackTrace$StringRE$.prototype;
$c_jl_StackTrace$StringRE$.prototype.re$extension0__T__O = (function(this$) {
  return new RegExp(this$);
});
$c_jl_StackTrace$StringRE$.prototype.re$extension1__T__T__O = (function(this$, mods) {
  return new RegExp(this$, mods);
});
var $d_jl_StackTrace$StringRE$ = new $TypeData().initClass($c_jl_StackTrace$StringRE$, "java.lang.StackTrace$StringRE$", ({
  jl_StackTrace$StringRE$: 1
}));
export { $d_jl_StackTrace$StringRE$ as $d_jl_StackTrace$StringRE$ };
var $n_jl_StackTrace$StringRE$;
function $m_jl_StackTrace$StringRE$() {
  if ((!$n_jl_StackTrace$StringRE$)) {
    $n_jl_StackTrace$StringRE$ = new $c_jl_StackTrace$StringRE$();
  }
  return $n_jl_StackTrace$StringRE$;
}
export { $m_jl_StackTrace$StringRE$ as $m_jl_StackTrace$StringRE$ };
/** @constructor */
function $c_jl_System$NanoTime$() {
  this.jl_System$NanoTime$__f_highPrecisionTimer = null;
  $n_jl_System$NanoTime$ = this;
  if (((typeof performance) !== "undefined")) {
    var x = performance.now;
    var $x_1 = (!(x === (void 0)));
  } else {
    var $x_1 = false;
  }
  this.jl_System$NanoTime$__f_highPrecisionTimer = ($x_1 ? performance : Date);
}
export { $c_jl_System$NanoTime$ as $c_jl_System$NanoTime$ };
$c_jl_System$NanoTime$.prototype = new $h_O();
$c_jl_System$NanoTime$.prototype.constructor = $c_jl_System$NanoTime$;
/** @constructor */
function $h_jl_System$NanoTime$() {
}
export { $h_jl_System$NanoTime$ as $h_jl_System$NanoTime$ };
$h_jl_System$NanoTime$.prototype = $c_jl_System$NanoTime$.prototype;
var $d_jl_System$NanoTime$ = new $TypeData().initClass($c_jl_System$NanoTime$, "java.lang.System$NanoTime$", ({
  jl_System$NanoTime$: 1
}));
export { $d_jl_System$NanoTime$ as $d_jl_System$NanoTime$ };
var $n_jl_System$NanoTime$;
function $m_jl_System$NanoTime$() {
  if ((!$n_jl_System$NanoTime$)) {
    $n_jl_System$NanoTime$ = new $c_jl_System$NanoTime$();
  }
  return $n_jl_System$NanoTime$;
}
export { $m_jl_System$NanoTime$ as $m_jl_System$NanoTime$ };
function $p_jl_System$SystemProperties$__loadSystemProperties__O($thiz) {
  var result = ({});
  result["java.version"] = "1.8";
  result["java.vm.specification.version"] = "1.8";
  result["java.vm.specification.vendor"] = "Oracle Corporation";
  result["java.vm.specification.name"] = "Java Virtual Machine Specification";
  result["java.vm.name"] = "Scala.js";
  result["java.vm.version"] = "1.20.1";
  result["java.specification.version"] = "1.8";
  result["java.specification.vendor"] = "Oracle Corporation";
  result["java.specification.name"] = "Java Platform API Specification";
  result["file.separator"] = "/";
  result["path.separator"] = ":";
  result["line.separator"] = "\n";
  return result;
}
export { $p_jl_System$SystemProperties$__loadSystemProperties__O as $p_jl_System$SystemProperties$__loadSystemProperties__O };
/** @constructor */
function $c_jl_System$SystemProperties$() {
  this.jl_System$SystemProperties$__f_dict = null;
  this.jl_System$SystemProperties$__f_properties = null;
  $n_jl_System$SystemProperties$ = this;
  this.jl_System$SystemProperties$__f_dict = $p_jl_System$SystemProperties$__loadSystemProperties__O(this);
  this.jl_System$SystemProperties$__f_properties = null;
}
export { $c_jl_System$SystemProperties$ as $c_jl_System$SystemProperties$ };
$c_jl_System$SystemProperties$.prototype = new $h_O();
$c_jl_System$SystemProperties$.prototype.constructor = $c_jl_System$SystemProperties$;
/** @constructor */
function $h_jl_System$SystemProperties$() {
}
export { $h_jl_System$SystemProperties$ as $h_jl_System$SystemProperties$ };
$h_jl_System$SystemProperties$.prototype = $c_jl_System$SystemProperties$.prototype;
$c_jl_System$SystemProperties$.prototype.getProperty__T__T__T = (function(key, default$1) {
  if ((this.jl_System$SystemProperties$__f_dict !== null)) {
    var dict = this.jl_System$SystemProperties$__f_dict;
    return ((!(!$m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, key))) ? dict[key] : default$1);
  } else {
    return this.jl_System$SystemProperties$__f_properties.getProperty__T__T__T(key, default$1);
  }
});
var $d_jl_System$SystemProperties$ = new $TypeData().initClass($c_jl_System$SystemProperties$, "java.lang.System$SystemProperties$", ({
  jl_System$SystemProperties$: 1
}));
export { $d_jl_System$SystemProperties$ as $d_jl_System$SystemProperties$ };
var $n_jl_System$SystemProperties$;
function $m_jl_System$SystemProperties$() {
  if ((!$n_jl_System$SystemProperties$)) {
    $n_jl_System$SystemProperties$ = new $c_jl_System$SystemProperties$();
  }
  return $n_jl_System$SystemProperties$;
}
export { $m_jl_System$SystemProperties$ as $m_jl_System$SystemProperties$ };
function $ct_jl_ThreadLocal__($thiz) {
  $thiz.jl_ThreadLocal__f_hasValue = false;
  return $thiz;
}
export { $ct_jl_ThreadLocal__ as $ct_jl_ThreadLocal__ };
/** @constructor */
function $c_jl_ThreadLocal() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
}
export { $c_jl_ThreadLocal as $c_jl_ThreadLocal };
$c_jl_ThreadLocal.prototype = new $h_O();
$c_jl_ThreadLocal.prototype.constructor = $c_jl_ThreadLocal;
/** @constructor */
function $h_jl_ThreadLocal() {
}
export { $h_jl_ThreadLocal as $h_jl_ThreadLocal };
$h_jl_ThreadLocal.prototype = $c_jl_ThreadLocal.prototype;
$c_jl_ThreadLocal.prototype.initialValue__O = (function() {
  return null;
});
$c_jl_ThreadLocal.prototype.get__O = (function() {
  if ((!this.jl_ThreadLocal__f_hasValue)) {
    this.set__O__V(this.initialValue__O());
  }
  return this.jl_ThreadLocal__f_v;
});
$c_jl_ThreadLocal.prototype.set__O__V = (function(o) {
  this.jl_ThreadLocal__f_v = o;
  this.jl_ThreadLocal__f_hasValue = true;
});
$c_jl_ThreadLocal.prototype.remove__V = (function() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
});
var $d_jl_ThreadLocal = new $TypeData().initClass($c_jl_ThreadLocal, "java.lang.ThreadLocal", ({
  jl_ThreadLocal: 1
}));
export { $d_jl_ThreadLocal as $d_jl_ThreadLocal };
/** @constructor */
function $c_jl_Utils$Cache$() {
  this.jl_Utils$Cache$__f_safeHasOwnProperty = null;
  $n_jl_Utils$Cache$ = this;
  this.jl_Utils$Cache$__f_safeHasOwnProperty = Object.prototype.hasOwnProperty;
}
export { $c_jl_Utils$Cache$ as $c_jl_Utils$Cache$ };
$c_jl_Utils$Cache$.prototype = new $h_O();
$c_jl_Utils$Cache$.prototype.constructor = $c_jl_Utils$Cache$;
/** @constructor */
function $h_jl_Utils$Cache$() {
}
export { $h_jl_Utils$Cache$ as $h_jl_Utils$Cache$ };
$h_jl_Utils$Cache$.prototype = $c_jl_Utils$Cache$.prototype;
var $d_jl_Utils$Cache$ = new $TypeData().initClass($c_jl_Utils$Cache$, "java.lang.Utils$Cache$", ({
  jl_Utils$Cache$: 1
}));
export { $d_jl_Utils$Cache$ as $d_jl_Utils$Cache$ };
var $n_jl_Utils$Cache$;
function $m_jl_Utils$Cache$() {
  if ((!$n_jl_Utils$Cache$)) {
    $n_jl_Utils$Cache$ = new $c_jl_Utils$Cache$();
  }
  return $n_jl_Utils$Cache$;
}
export { $m_jl_Utils$Cache$ as $m_jl_Utils$Cache$ };
function $f_jl_Void__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
export { $f_jl_Void__equals__O__Z as $f_jl_Void__equals__O__Z };
function $f_jl_Void__hashCode__I($thiz) {
  return 0;
}
export { $f_jl_Void__hashCode__I as $f_jl_Void__hashCode__I };
function $f_jl_Void__toString__T($thiz) {
  return "undefined";
}
export { $f_jl_Void__toString__T as $f_jl_Void__toString__T };
function $isArrayOf_jl_Void(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Void)));
}
export { $isArrayOf_jl_Void as $isArrayOf_jl_Void };
var $d_jl_Void = new $TypeData().initClass(0, "java.lang.Void", ({
  jl_Void: 1
}), ((x) => (x === (void 0))));
export { $d_jl_Void as $d_jl_Void };
function $p_jl_reflect_Array$__mismatch__O__E($thiz, array) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "argument type mismatch");
}
export { $p_jl_reflect_Array$__mismatch__O__E as $p_jl_reflect_Array$__mismatch__O__E };
function $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O($thiz, componentType, offset, dimensions$1) {
  var length = dimensions$1.u[offset];
  var result = componentType.data.newArray(length);
  var innerOffset = ((1 + offset) | 0);
  if ((innerOffset < dimensions$1.u.length)) {
    var innerComponentType = componentType.data.getComponentType();
    var i = 0;
    while ((i !== length)) {
      result.u[i] = $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O($thiz, innerComponentType, innerOffset, dimensions$1);
      i = ((1 + i) | 0);
    }
  }
  return result;
}
export { $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O as $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O };
/** @constructor */
function $c_jl_reflect_Array$() {
}
export { $c_jl_reflect_Array$ as $c_jl_reflect_Array$ };
$c_jl_reflect_Array$.prototype = new $h_O();
$c_jl_reflect_Array$.prototype.constructor = $c_jl_reflect_Array$;
/** @constructor */
function $h_jl_reflect_Array$() {
}
export { $h_jl_reflect_Array$ as $h_jl_reflect_Array$ };
$h_jl_reflect_Array$.prototype = $c_jl_reflect_Array$.prototype;
$c_jl_reflect_Array$.prototype.newInstance__jl_Class__AI__O = (function(componentType, dimensions) {
  var len = dimensions.u.length;
  if ((len === 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  var outermostComponentType = componentType;
  var i = 1;
  while ((i !== len)) {
    var componentType$1 = outermostComponentType;
    var this$1 = componentType$1.data.newArray(0);
    outermostComponentType = $objectGetClass(this$1);
    i = ((1 + i) | 0);
  }
  return $p_jl_reflect_Array$__rec$1__jl_Class__I__AI__O(this, outermostComponentType, 0, dimensions);
});
$c_jl_reflect_Array$.prototype.getLength__O__I = (function(array) {
  return ((array instanceof $ac_O) ? array.u.length : ((array instanceof $ac_Z) ? array.u.length : ((array instanceof $ac_C) ? array.u.length : ((array instanceof $ac_B) ? array.u.length : ((array instanceof $ac_S) ? array.u.length : ((array instanceof $ac_I) ? array.u.length : ((array instanceof $ac_J) ? array.u.length : ((array instanceof $ac_F) ? array.u.length : ((array instanceof $ac_D) ? array.u.length : $p_jl_reflect_Array$__mismatch__O__E(this, array))))))))));
});
var $d_jl_reflect_Array$ = new $TypeData().initClass($c_jl_reflect_Array$, "java.lang.reflect.Array$", ({
  jl_reflect_Array$: 1
}));
export { $d_jl_reflect_Array$ as $d_jl_reflect_Array$ };
var $n_jl_reflect_Array$;
function $m_jl_reflect_Array$() {
  if ((!$n_jl_reflect_Array$)) {
    $n_jl_reflect_Array$ = new $c_jl_reflect_Array$();
  }
  return $n_jl_reflect_Array$;
}
export { $m_jl_reflect_Array$ as $m_jl_reflect_Array$ };
/** @constructor */
function $c_Ljava_math_BigInteger$QuotAndRem(quot, rem) {
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = null;
  this.Ljava_math_BigInteger$QuotAndRem__f_quot = quot;
  this.Ljava_math_BigInteger$QuotAndRem__f_rem = rem;
}
export { $c_Ljava_math_BigInteger$QuotAndRem as $c_Ljava_math_BigInteger$QuotAndRem };
$c_Ljava_math_BigInteger$QuotAndRem.prototype = new $h_O();
$c_Ljava_math_BigInteger$QuotAndRem.prototype.constructor = $c_Ljava_math_BigInteger$QuotAndRem;
/** @constructor */
function $h_Ljava_math_BigInteger$QuotAndRem() {
}
export { $h_Ljava_math_BigInteger$QuotAndRem as $h_Ljava_math_BigInteger$QuotAndRem };
$h_Ljava_math_BigInteger$QuotAndRem.prototype = $c_Ljava_math_BigInteger$QuotAndRem.prototype;
$c_Ljava_math_BigInteger$QuotAndRem.prototype.toArray__ALjava_math_BigInteger = (function() {
  return new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$QuotAndRem__f_quot, this.Ljava_math_BigInteger$QuotAndRem__f_rem]);
});
var $d_Ljava_math_BigInteger$QuotAndRem = new $TypeData().initClass($c_Ljava_math_BigInteger$QuotAndRem, "java.math.BigInteger$QuotAndRem", ({
  Ljava_math_BigInteger$QuotAndRem: 1
}));
export { $d_Ljava_math_BigInteger$QuotAndRem as $d_Ljava_math_BigInteger$QuotAndRem };
/** @constructor */
function $c_Ljava_math_BitLevel$() {
}
export { $c_Ljava_math_BitLevel$ as $c_Ljava_math_BitLevel$ };
$c_Ljava_math_BitLevel$.prototype = new $h_O();
$c_Ljava_math_BitLevel$.prototype.constructor = $c_Ljava_math_BitLevel$;
/** @constructor */
function $h_Ljava_math_BitLevel$() {
}
export { $h_Ljava_math_BitLevel$ as $h_Ljava_math_BitLevel$ };
$h_Ljava_math_BitLevel$.prototype = $c_Ljava_math_BitLevel$.prototype;
$c_Ljava_math_BitLevel$.prototype.bitLength__Ljava_math_BigInteger__I = (function(bi) {
  if ((bi.Ljava_math_BigInteger__f_sign === 0)) {
    return 0;
  } else {
    var bLength = (bi.Ljava_math_BigInteger__f_numberLength << 5);
    var highDigit = bi.Ljava_math_BigInteger__f_digits.u[(((-1) + bi.Ljava_math_BigInteger__f_numberLength) | 0)];
    if ((bi.Ljava_math_BigInteger__f_sign < 0)) {
      var i = bi.getFirstNonzeroDigit__I();
      if ((i === (((-1) + bi.Ljava_math_BigInteger__f_numberLength) | 0))) {
        highDigit = (((-1) + highDigit) | 0);
      }
    }
    var $x_1 = bLength;
    var i$1 = highDigit;
    bLength = (($x_1 - Math.clz32(i$1)) | 0);
    return bLength;
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  var offset = ((andCount === 0) ? 0 : 1);
  var resLength = ((((source.Ljava_math_BigInteger__f_numberLength + intCount) | 0) + offset) | 0);
  $m_Ljava_math_BigInteger$().checkRangeBasedOnIntArrayLength__I__V(resLength);
  var resDigits = new $ac_I(resLength);
  this.shiftLeft__AI__AI__I__I__V(resDigits, source.Ljava_math_BigInteger__f_digits, intCount, andCount);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLength, resDigits);
  result.cutOffLeadingZeroes__V();
  return result;
});
$c_Ljava_math_BitLevel$.prototype.shiftLeft__AI__AI__I__I__V = (function(result, source, intCount, count) {
  if ((count === 0)) {
    var x4 = ((result.u.length - intCount) | 0);
    source.copyTo(0, result, intCount, x4);
  } else {
    var rightShiftCount = ((32 - count) | 0);
    result.u[(((-1) + result.u.length) | 0)] = 0;
    var i = (((-1) + result.u.length) | 0);
    while ((i > intCount)) {
      var ev$1 = i;
      result.u[ev$1] = (result.u[ev$1] | ((source.u[(((-1) + ((i - intCount) | 0)) | 0)] >>> rightShiftCount) | 0));
      result.u[(((-1) + i) | 0)] = (source.u[(((-1) + ((i - intCount) | 0)) | 0)] << count);
      i = (((-1) + i) | 0);
    }
  }
  var i$1 = 0;
  while ((i$1 < intCount)) {
    var value = i$1;
    result.u[value] = 0;
    i$1 = ((1 + i$1) | 0);
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(source) {
  var srcLen = source.Ljava_math_BigInteger__f_numberLength;
  var resLen = ((1 + srcLen) | 0);
  var resDigits = new $ac_I(resLen);
  this.shiftLeftOneBit__AI__AI__I__V(resDigits, source.Ljava_math_BigInteger__f_digits, srcLen);
  var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLen, resDigits);
  result.cutOffLeadingZeroes__V();
  return result;
});
$c_Ljava_math_BitLevel$.prototype.shiftLeftOneBit__AI__AI__I__V = (function(result, source, srcLen) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < srcLen)) {
    var value = i;
    var iVal = source.u[value];
    result.u[value] = ((iVal << 1) | elem);
    elem = ((iVal >>> 31) | 0);
    i = ((1 + i) | 0);
  }
  if ((elem !== 0)) {
    result.u[srcLen] = elem;
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(source, count) {
  var intCount = ((count >>> 5) | 0);
  var andCount = (31 & count);
  if ((intCount >= source.Ljava_math_BigInteger__f_numberLength)) {
    return ((source.Ljava_math_BigInteger__f_sign < 0) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO);
  } else {
    var resLength = ((source.Ljava_math_BigInteger__f_numberLength - intCount) | 0);
    var resDigits = new $ac_I(((1 + resLength) | 0));
    this.shiftRight__AI__I__AI__I__I__Z(resDigits, resLength, source.Ljava_math_BigInteger__f_digits, intCount, andCount);
    if ((source.Ljava_math_BigInteger__f_sign < 0)) {
      var i = 0;
      while (((i < intCount) && (source.Ljava_math_BigInteger__f_digits.u[i] === 0))) {
        i = ((1 + i) | 0);
      }
      var cmp = ((source.Ljava_math_BigInteger__f_digits.u[i] << ((32 - andCount) | 0)) !== 0);
      if (((i < intCount) || ((andCount > 0) && cmp))) {
        i = 0;
        while (((i < resLength) && (resDigits.u[i] === (-1)))) {
          resDigits.u[i] = 0;
          i = ((1 + i) | 0);
        }
        if ((i === resLength)) {
          resLength = ((1 + resLength) | 0);
        }
        var ev$1 = i;
        resDigits.u[ev$1] = ((1 + resDigits.u[ev$1]) | 0);
      }
    }
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), source.Ljava_math_BigInteger__f_sign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result;
  }
});
$c_Ljava_math_BitLevel$.prototype.shiftRight__AI__I__AI__I__I__Z = (function(result, resultLen, source, intCount, count) {
  var i = 0;
  var allZero = true;
  while ((i < intCount)) {
    allZero = (!(!(allZero & (source.u[i] === 0))));
    i = ((1 + i) | 0);
  }
  if ((count === 0)) {
    source.copyTo(intCount, result, 0, resultLen);
  } else {
    var leftShiftCount = ((32 - count) | 0);
    allZero = (!(!(allZero & ((source.u[i] << leftShiftCount) === 0))));
    i = 0;
    while ((i < (((-1) + resultLen) | 0))) {
      result.u[i] = (((source.u[((i + intCount) | 0)] >>> count) | 0) | (source.u[((1 + ((i + intCount) | 0)) | 0)] << leftShiftCount));
      i = ((1 + i) | 0);
    }
    result.u[i] = ((source.u[((i + intCount) | 0)] >>> count) | 0);
    i = ((1 + i) | 0);
  }
  return allZero;
});
var $d_Ljava_math_BitLevel$ = new $TypeData().initClass($c_Ljava_math_BitLevel$, "java.math.BitLevel$", ({
  Ljava_math_BitLevel$: 1
}));
export { $d_Ljava_math_BitLevel$ as $d_Ljava_math_BitLevel$ };
var $n_Ljava_math_BitLevel$;
function $m_Ljava_math_BitLevel$() {
  if ((!$n_Ljava_math_BitLevel$)) {
    $n_Ljava_math_BitLevel$ = new $c_Ljava_math_BitLevel$();
  }
  return $n_Ljava_math_BitLevel$;
}
export { $m_Ljava_math_BitLevel$ as $m_Ljava_math_BitLevel$ };
function $p_Ljava_math_Conversion$__dropLeadingZeros__T__T($thiz, s) {
  var zeroPrefixLength = 0;
  var len = s.length;
  while (true) {
    if ((zeroPrefixLength < len)) {
      var index = zeroPrefixLength;
      var $x_1 = (s.charCodeAt(index) === 48);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      zeroPrefixLength = ((1 + zeroPrefixLength) | 0);
    } else {
      break;
    }
  }
  var beginIndex = zeroPrefixLength;
  return s.substring(beginIndex);
}
export { $p_Ljava_math_Conversion$__dropLeadingZeros__T__T as $p_Ljava_math_Conversion$__dropLeadingZeros__T__T };
/** @constructor */
function $c_Ljava_math_Conversion$() {
  this.Ljava_math_Conversion$__f_DigitFitInInt = null;
  this.Ljava_math_Conversion$__f_BigRadices = null;
  $n_Ljava_math_Conversion$ = this;
  this.Ljava_math_Conversion$__f_DigitFitInInt = new $ac_I(new Int32Array([(-1), (-1), 31, 19, 15, 13, 11, 11, 10, 9, 9, 8, 8, 8, 8, 7, 7, 7, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 5]));
  this.Ljava_math_Conversion$__f_BigRadices = new $ac_I(new Int32Array([(-2147483648), 1162261467, 1073741824, 1220703125, 362797056, 1977326743, 1073741824, 387420489, 1000000000, 214358881, 429981696, 815730721, 1475789056, 170859375, 268435456, 410338673, 612220032, 893871739, 1280000000, 1801088541, 113379904, 148035889, 191102976, 244140625, 308915776, 387420489, 481890304, 594823321, 729000000, 887503681, 1073741824, 1291467969, 1544804416, 1838265625, 60466176]));
}
export { $c_Ljava_math_Conversion$ as $c_Ljava_math_Conversion$ };
$c_Ljava_math_Conversion$.prototype = new $h_O();
$c_Ljava_math_Conversion$.prototype.constructor = $c_Ljava_math_Conversion$;
/** @constructor */
function $h_Ljava_math_Conversion$() {
}
export { $h_Ljava_math_Conversion$ as $h_Ljava_math_Conversion$ };
$h_Ljava_math_Conversion$.prototype = $c_Ljava_math_Conversion$.prototype;
$c_Ljava_math_Conversion$.prototype.bigInteger2String__Ljava_math_BigInteger__I__T = (function(bi, radix) {
  var sign = bi.Ljava_math_BigInteger__f_sign;
  var numberLength = bi.Ljava_math_BigInteger__f_numberLength;
  var digits = bi.Ljava_math_BigInteger__f_digits;
  if ((sign === 0)) {
    return "0";
  } else if ((numberLength === 1)) {
    var highDigit = digits.u[(((-1) + numberLength) | 0)];
    var v__lo = highDigit;
    var v__hi = 0;
    if ((sign < 0)) {
      var b__lo = v__lo;
      var b__hi = v__hi;
      var blo = b__lo;
      var lo = ((-blo) | 0);
      var hi$1 = ((((-b__hi) | 0) + ((blo | lo) >> 31)) | 0);
      var $x_1__lo = lo;
      var $x_1__hi = hi$1;
      v__lo = $x_1__lo;
      v__hi = $x_1__hi;
    }
    var this$4 = $m_jl_Long$();
    var i__lo = v__lo;
    var i__hi = v__hi;
    if (((radix === 10) || ((radix < 2) || (radix > 36)))) {
      var this$6 = $m_RTLong$();
      return this$6.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(i__lo, i__hi);
    } else {
      return this$4.java$lang$Long$$toStringImpl__J__I__T(new $c_RTLong(i__lo, i__hi), radix);
    }
  } else if (((radix === 10) || ((radix < 2) || (radix > 36)))) {
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(bi);
  } else {
    var bitsForRadixDigit = 0.0;
    var a = radix;
    bitsForRadixDigit = ((+Math.log(a)) / (+Math.log(2.0)));
    var addForSign = ((sign < 0) ? 1 : 0);
    var this$10 = bi.abs__Ljava_math_BigInteger();
    var biAbsLen = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$10);
    var resLenInChars = ((1 + $doubleToInt(((biAbsLen / bitsForRadixDigit) + addForSign))) | 0);
    var elem = null;
    elem = "";
    var elem$1 = 0;
    elem$1 = resLenInChars;
    var elem$2 = 0;
    elem$2 = 0;
    if ((radix !== 16)) {
      var temp = new $ac_I(numberLength);
      digits.copyTo(0, temp, 0, numberLength);
      var elem$3 = 0;
      elem$3 = numberLength;
      var charsPerInt = this.Ljava_math_Conversion$__f_DigitFitInInt.u[radix];
      var bigRadix = this.Ljava_math_Conversion$__f_BigRadices.u[(((-2) + radix) | 0)];
      while (true) {
        elem$2 = $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(temp, temp, elem$3, bigRadix);
        var previous = elem$1;
        while (true) {
          elem$1 = (((-1) + elem$1) | 0);
          var this$15 = $m_jl_Character$().forDigit__I__I__C(((elem$2 % $checkIntDivisor(radix)) | 0), radix);
          elem = (("" + $cToS(this$15)) + elem);
          elem$2 = ((elem$2 / $checkIntDivisor(radix)) | 0);
          if (((elem$2 !== 0) && (elem$1 !== 0))) {
            continue;
          }
          break;
        }
        var delta = ((((charsPerInt - previous) | 0) + elem$1) | 0);
        var i$1 = 0;
        while (((i$1 < delta) && (elem$1 > 0))) {
          elem$1 = (((-1) + elem$1) | 0);
          elem = ("0" + elem);
          i$1 = ((1 + i$1) | 0);
        }
        i$1 = (((-1) + elem$3) | 0);
        while (((i$1 > 0) && (temp.u[i$1] === 0))) {
          i$1 = (((-1) + i$1) | 0);
        }
        elem$3 = ((1 + i$1) | 0);
        if ((!((elem$3 === 1) && (temp.u[0] === 0)))) {
          continue;
        }
        break;
      }
    } else {
      var i$2 = 0;
      while ((i$2 < numberLength)) {
        var value = i$2;
        var j = 0;
        while (((j < 8) && (elem$1 > 0))) {
          elem$2 = (15 & (digits.u[value] >> (j << 2)));
          elem$1 = (((-1) + elem$1) | 0);
          var i$3 = elem$2;
          elem = (("" + (i$3 >>> 0.0).toString(16)) + elem);
          j = ((1 + j) | 0);
        }
        i$2 = ((1 + i$2) | 0);
      }
    }
    var dropLen = 0;
    while (true) {
      var this$22 = elem;
      var index = dropLen;
      if ((this$22.charCodeAt(index) === 48)) {
        dropLen = ((1 + dropLen) | 0);
      } else {
        break;
      }
    }
    if ((dropLen !== 0)) {
      var this$23 = elem;
      var beginIndex = dropLen;
      elem = this$23.substring(beginIndex);
    }
    return ((sign === (-1)) ? ("-" + elem) : elem);
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__Ljava_math_BigInteger__T = (function(bi) {
  var sign = bi.Ljava_math_BigInteger__f_sign;
  var numberLength = bi.Ljava_math_BigInteger__f_numberLength;
  var digits = bi.Ljava_math_BigInteger__f_digits;
  if ((sign === 0)) {
    return "0";
  } else if ((numberLength === 1)) {
    var i = digits.u[0];
    var absStr = (i >>> 0.0).toString(10);
    return ((sign < 0) ? ("-" + absStr) : absStr);
  } else {
    var result = "";
    var temp = new $ac_I(numberLength);
    var tempLen = numberLength;
    var x4 = tempLen;
    digits.copyTo(0, temp, 0, x4);
    while (true) {
      var rem = 0;
      var i$1 = (((-1) + tempLen) | 0);
      while ((i$1 >= 0)) {
        var value = rem;
        var value$1 = temp.u[i$1];
        var hi$2 = ((value + (((value$1 & (~value$1)) >>> 31) | 0)) | 0);
        var this$10 = $m_RTLong$();
        var lo = this$10.divideUnsignedImpl__I__I__I__I__I(value$1, hi$2, 1000000000, 0);
        temp.u[i$1] = lo;
        var b0 = (65535 & lo);
        var b1 = ((lo >>> 16) | 0);
        var a0b0 = Math.imul(51712, b0);
        var a1b0 = Math.imul(15258, b0);
        var a0b1 = Math.imul(51712, b1);
        var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var lo$2 = ((value$1 - lo$1) | 0);
        rem = lo$2;
        i$1 = (((-1) + i$1) | 0);
      }
      var this$16 = rem;
      var remStr = ("" + this$16);
      var beginIndex = remStr.length;
      var padding = "000000000".substring(beginIndex);
      result = ((padding + remStr) + result);
      while (((tempLen !== 0) && (temp.u[(((-1) + tempLen) | 0)] === 0))) {
        tempLen = (((-1) + tempLen) | 0);
      }
      if ((tempLen !== 0)) {
      } else {
        break;
      }
    }
    result = $p_Ljava_math_Conversion$__dropLeadingZeros__T__T(this, result);
    return ((sign < 0) ? ("-" + result) : result);
  }
});
$c_Ljava_math_Conversion$.prototype.toDecimalScaledString__J__I__T = (function(value, scale) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === 0))) {
    switch (scale) {
      case 0: {
        return "0";
        break;
      }
      case 1: {
        return "0.0";
        break;
      }
      case 2: {
        return "0.00";
        break;
      }
      case 3: {
        return "0.000";
        break;
      }
      case 4: {
        return "0.0000";
        break;
      }
      case 5: {
        return "0.00000";
        break;
      }
      case 6: {
        return "0.000000";
        break;
      }
      default: {
        if ((scale === (-2147483648))) {
          var scaleVal = "2147483648";
        } else {
          var i = ((-scale) | 0);
          var scaleVal = ("" + i);
        }
        var result = ((scale < 0) ? "0E+" : "0E");
        return (result + scaleVal);
      }
    }
  } else {
    var ahi = value.RTLong__f_hi;
    var negNumber = (ahi < 0);
    var elem = null;
    elem = "";
    var currentChar = 18;
    if (negNumber) {
      var blo = value.RTLong__f_lo;
      var lo = ((-blo) | 0);
      var hi = ((((-value.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
      var x__lo = lo;
      var x__hi = hi;
      var t = new $c_RTLong(x__lo, x__hi);
    } else {
      var t = value;
    }
    var lo$1 = t.RTLong__f_lo;
    var hi$1 = t.RTLong__f_hi;
    var v__lo = lo$1;
    var v__hi = hi$1;
    while (true) {
      var prev__lo = v__lo;
      var prev__hi = v__hi;
      var a__lo = v__lo;
      var a__hi = v__hi;
      var this$6 = $m_RTLong$();
      var lo$2 = this$6.divideImpl__I__I__I__I__I(a__lo, a__hi, 10, 0);
      var hi$2 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $x_1__lo = lo$2;
      var $x_1__hi = hi$2;
      v__lo = $x_1__lo;
      v__hi = $x_1__hi;
      currentChar = (((-1) + currentChar) | 0);
      var b__lo = v__lo;
      var b__hi = v__hi;
      var blo$1 = b__lo;
      var b0 = (65535 & blo$1);
      var b1 = ((blo$1 >>> 16) | 0);
      var a0b0 = Math.imul(10, b0);
      var a0b1 = Math.imul(10, b1);
      var lo$3 = ((a0b0 + (a0b1 << 16)) | 0);
      var alo = prev__lo;
      var lo$4 = ((alo - lo$3) | 0);
      elem = (("" + lo$4) + elem);
      var a$1__lo = v__lo;
      var a$1__hi = v__hi;
      if ((!((a$1__lo === 0) && (a$1__hi === 0)))) {
      } else {
        break;
      }
    }
    var value$1 = ((18 - currentChar) | 0);
    var hi$5 = (value$1 >> 31);
    var hi$6 = (scale >> 31);
    var lo$5 = ((value$1 - scale) | 0);
    var hi$7 = ((((hi$5 - hi$6) | 0) + ((((~value$1) & scale) | ((~(value$1 ^ scale)) & lo$5)) >> 31)) | 0);
    var lo$6 = (((-1) + lo$5) | 0);
    var hi$8 = (((((-1) + hi$7) | 0) + (((lo$5 | (~lo$6)) >>> 31) | 0)) | 0);
    if (((scale > 0) && ((hi$8 === (-1)) ? ((lo$6 >>> 0) >= 4294967290) : (hi$8 > (-1))))) {
      var index = ((1 + lo$6) | 0);
      if ((index > 0)) {
        var this$18 = elem;
        var $x_2 = this$18.substring(0, index);
        var this$19 = elem;
        elem = (($x_2 + ".") + this$19.substring(index));
      } else {
        var end = ((-index) | 0);
        var i$1 = 0;
        while ((i$1 < end)) {
          elem = ("0" + elem);
          i$1 = ((1 + i$1) | 0);
        }
        elem = ("0." + elem);
      }
    } else if ((scale !== 0)) {
      var exponentStr = (((hi$8 === 0) ? (lo$6 !== 0) : (hi$8 > 0)) ? ("E+" + new $c_RTLong(lo$6, hi$8)) : ("E" + new $c_RTLong(lo$6, hi$8)));
      if ((((18 - currentChar) | 0) > 1)) {
        var this$23 = elem;
        var $x_3 = this$23.substring(0, 1);
        var this$24 = elem;
        elem = ((($x_3 + ".") + this$24.substring(1)) + exponentStr);
      } else {
        elem = (elem + exponentStr);
      }
    }
    return (negNumber ? ("-" + elem) : elem);
  }
});
var $d_Ljava_math_Conversion$ = new $TypeData().initClass($c_Ljava_math_Conversion$, "java.math.Conversion$", ({
  Ljava_math_Conversion$: 1
}));
export { $d_Ljava_math_Conversion$ as $d_Ljava_math_Conversion$ };
var $n_Ljava_math_Conversion$;
function $m_Ljava_math_Conversion$() {
  if ((!$n_Ljava_math_Conversion$)) {
    $n_Ljava_math_Conversion$ = new $c_Ljava_math_Conversion$();
  }
  return $n_Ljava_math_Conversion$;
}
export { $m_Ljava_math_Conversion$ as $m_Ljava_math_Conversion$ };
/** @constructor */
function $c_Ljava_math_Division$() {
}
export { $c_Ljava_math_Division$ as $c_Ljava_math_Division$ };
$c_Ljava_math_Division$.prototype = new $h_O();
$c_Ljava_math_Division$.prototype.constructor = $c_Ljava_math_Division$;
/** @constructor */
function $h_Ljava_math_Division$() {
}
export { $h_Ljava_math_Division$ as $h_Ljava_math_Division$ };
$h_Ljava_math_Division$.prototype = $c_Ljava_math_Division$.prototype;
$c_Ljava_math_Division$.prototype.divide__AI__I__AI__I__AI__I__AI = (function(quot, quotLength, a, aLength, b, bLength) {
  var normA = new $ac_I(((1 + aLength) | 0));
  var normB = new $ac_I(((1 + bLength) | 0));
  var i = b.u[(((-1) + bLength) | 0)];
  var divisorShift = Math.clz32(i);
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normB, b, 0, divisorShift);
    $m_Ljava_math_BitLevel$().shiftLeft__AI__AI__I__I__V(normA, a, 0, divisorShift);
  } else {
    a.copyTo(0, normA, 0, aLength);
    b.copyTo(0, normB, 0, bLength);
  }
  var firstDivisorDigit = normB.u[(((-1) + bLength) | 0)];
  var i$1 = (((-1) + quotLength) | 0);
  var elem = 0;
  elem = aLength;
  while ((i$1 >= 0)) {
    var elem$1 = 0;
    elem$1 = 0;
    if ((normA.u[elem] === firstDivisorDigit)) {
      elem$1 = (-1);
    } else {
      var value = normA.u[elem];
      var value$1 = normA.u[(((-1) + elem) | 0)];
      var hi$2 = ((value + (((value$1 & (~value$1)) >>> 31) | 0)) | 0);
      var this$13 = $m_RTLong$();
      var lo = this$13.divideUnsignedImpl__I__I__I__I__I(value$1, hi$2, firstDivisorDigit, 0);
      elem$1 = lo;
      var a0 = (65535 & lo);
      var a1 = ((lo >>> 16) | 0);
      var b0 = (65535 & firstDivisorDigit);
      var b1 = ((firstDivisorDigit >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var lo$2 = ((value$1 - lo$1) | 0);
      var elem$2 = 0;
      elem$2 = lo$2;
      if ((elem$1 !== 0)) {
        elem$1 = ((1 + elem$1) | 0);
        while (true) {
          elem$1 = (((-1) + elem$1) | 0);
          var value$2 = elem$1;
          var value$3 = normB.u[(((-2) + bLength) | 0)];
          var a0$1 = (65535 & value$2);
          var a1$1 = ((value$2 >>> 16) | 0);
          var b0$1 = (65535 & value$3);
          var b1$1 = ((value$3 >>> 16) | 0);
          var a0b0$1 = Math.imul(a0$1, b0$1);
          var a1b0$1 = Math.imul(a1$1, b0$1);
          var a0b1$1 = Math.imul(a0$1, b1$1);
          var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$9 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
          var value$4 = elem$2;
          var value$5 = normA.u[(((-2) + elem) | 0)];
          var hi$12 = ((value$4 + (((value$5 & (~value$5)) >>> 31) | 0)) | 0);
          var value$6 = elem$2;
          var lo$4 = ((value$6 + firstDivisorDigit) | 0);
          var hi$15 = ((((value$6 & firstDivisorDigit) | ((value$6 | firstDivisorDigit) & (~lo$4))) >>> 31) | 0);
          if ((hi$15 === 0)) {
            elem$2 = lo$4;
            if (((hi$9 === hi$12) ? ((lo$3 >>> 0) > (value$5 >>> 0)) : ((hi$9 >>> 0) > (hi$12 >>> 0)))) {
              continue;
            }
          }
          break;
        }
      }
    }
    if ((elem$1 !== 0)) {
      var borrow = $m_Ljava_math_Division$().multiplyAndSubtract__AI__I__AI__I__I__I(normA, ((elem - bLength) | 0), normB, bLength, elem$1);
      if ((borrow !== 0)) {
        elem$1 = (((-1) + elem$1) | 0);
        var elem$3__lo = 0;
        var elem$3__hi = 0;
        var $x_1__lo = 0;
        var $x_1__hi = 0;
        elem$3__lo = $x_1__lo;
        elem$3__hi = $x_1__hi;
        var i$2 = 0;
        while ((i$2 < bLength)) {
          var value$7 = i$2;
          var a$1__lo = elem$3__lo;
          var a$1__hi = elem$3__hi;
          var value$8 = normA.u[((((elem - bLength) | 0) + value$7) | 0)];
          var value$9 = normB.u[value$7];
          var lo$5 = ((value$8 + value$9) | 0);
          var hi$18 = ((((value$8 & value$9) | ((value$8 | value$9) & (~lo$5))) >>> 31) | 0);
          var alo = a$1__lo;
          var lo$6 = ((alo + lo$5) | 0);
          var hi$19 = ((((a$1__hi + hi$18) | 0) + ((((alo & lo$5) | ((alo | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
          var $x_2__lo = lo$6;
          var $x_2__hi = hi$19;
          elem$3__lo = $x_2__lo;
          elem$3__hi = $x_2__hi;
          var $x_3 = elem;
          var a$2__lo = elem$3__lo;
          var a$2__hi = elem$3__hi;
          normA.u[(((($x_3 - bLength) | 0) + value$7) | 0)] = a$2__lo;
          var a$3__lo = elem$3__lo;
          var a$3__hi = elem$3__hi;
          var hi$20 = a$3__hi;
          var $x_4__lo = hi$20;
          var $x_4__hi = 0;
          elem$3__lo = $x_4__lo;
          elem$3__hi = $x_4__hi;
          i$2 = ((1 + i$2) | 0);
        }
      }
    }
    if ((quot !== null)) {
      quot.u[i$1] = elem$1;
    }
    elem = (((-1) + elem) | 0);
    i$1 = (((-1) + i$1) | 0);
  }
  if ((divisorShift !== 0)) {
    $m_Ljava_math_BitLevel$().shiftRight__AI__I__AI__I__I__Z(normB, bLength, normA, 0, divisorShift);
    return normB;
  } else {
    normA.copyTo(0, normB, 0, bLength);
    return normA;
  }
});
$c_Ljava_math_Division$.prototype.divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem = (function(bi, divisor, divisorSign) {
  var valDigits = bi.Ljava_math_BigInteger__f_digits;
  var valLen = bi.Ljava_math_BigInteger__f_numberLength;
  var valSign = bi.Ljava_math_BigInteger__f_sign;
  if ((valLen === 1)) {
    var valDigit = valDigits.u[0];
    var value = (((valDigit >>> 0) / ($checkIntDivisor(divisor) >>> 0)) | 0);
    var quo__lo = value;
    var quo__hi = 0;
    var value$1 = (((valDigit >>> 0) % ($checkIntDivisor(divisor) >>> 0)) | 0);
    var rem__lo = value$1;
    var rem__hi = 0;
    if ((valSign !== divisorSign)) {
      var b__lo = quo__lo;
      var b__hi = quo__hi;
      var blo = b__lo;
      var lo = ((-blo) | 0);
      var hi$2 = ((((-b__hi) | 0) + ((blo | lo) >> 31)) | 0);
      var $x_1__lo = lo;
      var $x_1__hi = hi$2;
      quo__lo = $x_1__lo;
      quo__hi = $x_1__hi;
    }
    if ((valSign < 0)) {
      var b$1__lo = rem__lo;
      var b$1__hi = rem__hi;
      var blo$1 = b$1__lo;
      var lo$1 = ((-blo$1) | 0);
      var hi$3 = ((((-b$1__hi) | 0) + ((blo$1 | lo$1) >> 31)) | 0);
      var $x_2__lo = lo$1;
      var $x_2__hi = hi$3;
      rem__lo = $x_2__lo;
      rem__hi = $x_2__hi;
    }
    return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(quo__lo, quo__hi)), $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(rem__lo, rem__hi)));
  } else {
    var quotientSign = ((valSign === divisorSign) ? 1 : (-1));
    var quotientDigits = new $ac_I(valLen);
    var div = this.divideArrayByInt__AI__AI__I__I__I(quotientDigits, valDigits, valLen, divisor);
    var remainderDigits = new $ac_I(new Int32Array([div]));
    var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, valLen, quotientDigits);
    var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), valSign, 1, remainderDigits);
    result0.cutOffLeadingZeroes__V();
    result1.cutOffLeadingZeroes__V();
    return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
  }
});
$c_Ljava_math_Division$.prototype.divideArrayByInt__AI__AI__I__I__I = (function(dest, src, srcLength, divisor) {
  var rem = 0;
  var i = (((-1) + srcLength) | 0);
  while ((i >= 0)) {
    var value = rem;
    var value$1 = src.u[i];
    var this$9 = $m_RTLong$();
    var lo = this$9.divideUnsignedImpl__I__I__I__I__I(value$1, value, divisor, 0);
    var a0 = (65535 & lo);
    var a1 = ((lo >>> 16) | 0);
    var b0 = (65535 & divisor);
    var b1 = ((divisor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var lo$2 = ((value$1 - lo$1) | 0);
    rem = lo$2;
    dest.u[i] = lo;
    i = (((-1) + i) | 0);
  }
  return rem;
});
$c_Ljava_math_Division$.prototype.multiplyAndSubtract__AI__I__AI__I__I__I = (function(a, start, b, bLen, c) {
  var elem = 0;
  elem = 0;
  var elem$1 = 0;
  elem$1 = 0;
  var i = 0;
  while ((i < bLen)) {
    var value = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = b.u[value];
    var c$1 = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & c);
    var b1 = ((c >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c$1) | 0);
    var hi$4 = ((hi$2 + ((((lo & c$1) | ((lo | c$1) & (~lo$1))) >>> 31) | 0)) | 0);
    var value$1 = a.u[((start + value) | 0)];
    var lo$2 = ((value$1 - lo$1) | 0);
    var hi$6 = ((((~value$1) & lo$1) | ((~(value$1 ^ lo$1)) & lo$2)) >> 31);
    var value$2 = elem$1;
    var hi$7 = (value$2 >> 31);
    var lo$3 = ((lo$2 + value$2) | 0);
    var hi$8 = ((((hi$6 + hi$7) | 0) + ((((lo$2 & value$2) | ((lo$2 | value$2) & (~lo$3))) >>> 31) | 0)) | 0);
    a.u[((start + value) | 0)] = lo$3;
    elem$1 = hi$8;
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  var value$3 = a.u[((start + bLen) | 0)];
  var value$4 = elem;
  var lo$4 = ((value$3 - value$4) | 0);
  var hi$13 = ((((~value$3) & value$4) | ((~(value$3 ^ value$4)) & lo$4)) >> 31);
  var value$5 = elem$1;
  var hi$14 = (value$5 >> 31);
  var lo$5 = ((lo$4 + value$5) | 0);
  var hi$15 = ((((hi$13 + hi$14) | 0) + ((((lo$4 & value$5) | ((lo$4 | value$5) & (~lo$5))) >>> 31) | 0)) | 0);
  a.u[((start + bLen) | 0)] = lo$5;
  return hi$15;
});
var $d_Ljava_math_Division$ = new $TypeData().initClass($c_Ljava_math_Division$, "java.math.Division$", ({
  Ljava_math_Division$: 1
}));
export { $d_Ljava_math_Division$ as $d_Ljava_math_Division$ };
var $n_Ljava_math_Division$;
function $m_Ljava_math_Division$() {
  if ((!$n_Ljava_math_Division$)) {
    $n_Ljava_math_Division$ = new $c_Ljava_math_Division$();
  }
  return $n_Ljava_math_Division$;
}
export { $m_Ljava_math_Division$ as $m_Ljava_math_Division$ };
function $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(((1 + aSize) | 0));
  $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
export { $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI as $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI };
function $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 1;
  var value = a.u[0];
  var value$1 = b.u[0];
  var lo = ((value + value$1) | 0);
  var hi$2 = ((((value & value$1) | ((value | value$1) & (~lo))) >>> 31) | 0);
  res.u[0] = lo;
  var carry = hi$2;
  if ((aSize >= bSize)) {
    while ((i < bSize)) {
      var value$2 = a.u[i];
      var value$3 = b.u[i];
      var lo$1 = ((value$2 + value$3) | 0);
      var hi$6 = ((((value$2 & value$3) | ((value$2 | value$3) & (~lo$1))) >>> 31) | 0);
      var value$4 = carry;
      var lo$2 = ((lo$1 + value$4) | 0);
      var hi$8 = ((hi$6 + ((((lo$1 & value$4) | ((lo$1 | value$4) & (~lo$2))) >>> 31) | 0)) | 0);
      res.u[i] = lo$2;
      carry = hi$8;
      i = ((1 + i) | 0);
    }
    while ((i < aSize)) {
      var value$5 = a.u[i];
      var value$6 = carry;
      var lo$3 = ((value$5 + value$6) | 0);
      var hi$12 = ((((value$5 & value$6) | ((value$5 | value$6) & (~lo$3))) >>> 31) | 0);
      res.u[i] = lo$3;
      carry = hi$12;
      i = ((1 + i) | 0);
    }
  } else {
    while ((i < aSize)) {
      var value$7 = a.u[i];
      var value$8 = b.u[i];
      var lo$4 = ((value$7 + value$8) | 0);
      var hi$16 = ((((value$7 & value$8) | ((value$7 | value$8) & (~lo$4))) >>> 31) | 0);
      var value$9 = carry;
      var lo$5 = ((lo$4 + value$9) | 0);
      var hi$18 = ((hi$16 + ((((lo$4 & value$9) | ((lo$4 | value$9) & (~lo$5))) >>> 31) | 0)) | 0);
      res.u[i] = lo$5;
      carry = hi$18;
      i = ((1 + i) | 0);
    }
    while ((i < bSize)) {
      var value$10 = b.u[i];
      var value$11 = carry;
      var lo$6 = ((value$10 + value$11) | 0);
      var hi$22 = ((((value$10 & value$11) | ((value$10 | value$11) & (~lo$6))) >>> 31) | 0);
      res.u[i] = lo$6;
      carry = hi$22;
      i = ((1 + i) | 0);
    }
  }
  if ((carry !== 0)) {
    res.u[i] = carry;
  }
}
export { $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V as $p_Ljava_math_Elementary$__add__AI__AI__I__AI__I__V };
function $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI($thiz, a, aSize, b, bSize) {
  var res = new $ac_I(aSize);
  $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize);
  return res;
}
export { $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI as $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI };
function $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V($thiz, res, a, aSize, b, bSize) {
  var i = 0;
  var borrow = 0;
  while ((i < bSize)) {
    var value = a.u[i];
    var value$1 = b.u[i];
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((~value) & value$1) | ((~(value ^ value$1)) & lo)) >> 31);
    var value$2 = borrow;
    var hi$3 = (value$2 >> 31);
    var lo$1 = ((lo + value$2) | 0);
    var hi$4 = ((((hi$2 + hi$3) | 0) + ((((lo & value$2) | ((lo | value$2) & (~lo$1))) >>> 31) | 0)) | 0);
    res.u[i] = lo$1;
    borrow = hi$4;
    i = ((1 + i) | 0);
  }
  while ((i < aSize)) {
    var value$3 = a.u[i];
    var value$4 = borrow;
    var hi$7 = (value$4 >> 31);
    var lo$2 = ((value$3 + value$4) | 0);
    var hi$8 = ((hi$7 + ((((value$3 & value$4) | ((value$3 | value$4) & (~lo$2))) >>> 31) | 0)) | 0);
    res.u[i] = lo$2;
    borrow = hi$8;
    i = ((1 + i) | 0);
  }
}
export { $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V as $p_Ljava_math_Elementary$__subtract__AI__AI__I__AI__I__V };
/** @constructor */
function $c_Ljava_math_Elementary$() {
}
export { $c_Ljava_math_Elementary$ as $c_Ljava_math_Elementary$ };
$c_Ljava_math_Elementary$.prototype = new $h_O();
$c_Ljava_math_Elementary$.prototype.constructor = $c_Ljava_math_Elementary$;
/** @constructor */
function $h_Ljava_math_Elementary$() {
}
export { $h_Ljava_math_Elementary$ as $h_Ljava_math_Elementary$ };
$h_Ljava_math_Elementary$.prototype = $c_Ljava_math_Elementary$.prototype;
$c_Ljava_math_Elementary$.prototype.add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = op1.Ljava_math_BigInteger__f_sign;
  var op2Sign = op2.Ljava_math_BigInteger__f_sign;
  var op1Len = op1.Ljava_math_BigInteger__f_numberLength;
  var op2Len = op2.Ljava_math_BigInteger__f_numberLength;
  if ((op1Sign === 0)) {
    return op2;
  } else if ((op2Sign === 0)) {
    return op1;
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.Ljava_math_BigInteger__f_digits.u[0];
    var value$1 = op2.Ljava_math_BigInteger__f_digits.u[0];
    if ((op1Sign === op2Sign)) {
      var lo = ((value + value$1) | 0);
      var hi$2 = ((((value & value$1) | ((value | value$1) & (~lo))) >>> 31) | 0);
      return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), op1Sign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), op1Sign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
    } else {
      var $x_1 = $m_Ljava_math_BigInteger$();
      if ((op1Sign < 0)) {
        var lo$1 = ((value$1 - value) | 0);
        var hi$3 = ((((~value$1) & value) | ((~(value$1 ^ value)) & lo$1)) >> 31);
        var x__lo = lo$1;
        var x__hi = hi$3;
      } else {
        var lo$2 = ((value - value$1) | 0);
        var hi$4 = ((((~value) & value$1) | ((~(value ^ value$1)) & lo$2)) >> 31);
        var x__lo = lo$2;
        var x__hi = hi$4;
      }
      return $x_1.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(x__lo, x__hi));
    }
  } else {
    if ((op1Sign === op2Sign)) {
      var res$2 = ((op1Len >= op2Len) ? $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len));
      var x1___1 = op1Sign;
      var x1___2 = res$2;
    } else {
      var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : this.compareArrays__AI__AI__I__I(op1.Ljava_math_BigInteger__f_digits, op2.Ljava_math_BigInteger__f_digits, op1Len));
      if ((cmp === 0)) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      }
      if ((cmp === 1)) {
        var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
        var x1___1 = op1Sign;
        var x1___2 = _2;
      } else {
        var _2$1 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len);
        var x1___1 = op2Sign;
        var x1___2 = _2$1;
      }
    }
    var resSign = (x1___1 | 0);
    var resDigits = x1___2;
    var res$3 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.u.length, resDigits);
    res$3.cutOffLeadingZeroes__V();
    return res$3;
  }
});
$c_Ljava_math_Elementary$.prototype.compareArrays__AI__AI__I__I = (function(a, b, size) {
  var i = (((-1) + size) | 0);
  while (((i >= 0) && (a.u[i] === b.u[i]))) {
    i = (((-1) + i) | 0);
  }
  if ((i < 0)) {
    return 0;
  } else {
    var value = a.u[i];
    var value$1 = b.u[i];
    if (((value >>> 0) < (value$1 >>> 0))) {
      return (-1);
    } else {
      return 1;
    }
  }
});
$c_Ljava_math_Elementary$.prototype.inplaceAdd__AI__I__I__I = (function(a, aSize, addend) {
  var carry = addend;
  var i = 0;
  while (((carry !== 0) && (i < aSize))) {
    var value = carry;
    var value$1 = a.u[i];
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((value & value$1) | ((value | value$1) & (~lo))) >>> 31) | 0);
    a.u[i] = lo;
    carry = hi$2;
    i = ((1 + i) | 0);
  }
  return carry;
});
$c_Ljava_math_Elementary$.prototype.subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(op1, op2) {
  var op1Sign = op1.Ljava_math_BigInteger__f_sign;
  var op2Sign = op2.Ljava_math_BigInteger__f_sign;
  var op1Len = op1.Ljava_math_BigInteger__f_numberLength;
  var op2Len = op2.Ljava_math_BigInteger__f_numberLength;
  if ((op2Sign === 0)) {
    return op1;
  } else if ((op1Sign === 0)) {
    return op2.negate__Ljava_math_BigInteger();
  } else if ((((op1Len + op2Len) | 0) === 2)) {
    var value = op1.Ljava_math_BigInteger__f_digits.u[0];
    var a__lo = value;
    var a__hi = 0;
    var value$1 = op2.Ljava_math_BigInteger__f_digits.u[0];
    var b__lo = value$1;
    var b__hi = 0;
    if ((op1Sign < 0)) {
      var b$1__lo = a__lo;
      var b$1__hi = a__hi;
      var blo = b$1__lo;
      var lo = ((-blo) | 0);
      var hi$2 = ((((-b$1__hi) | 0) + ((blo | lo) >> 31)) | 0);
      var $x_1__lo = lo;
      var $x_1__hi = hi$2;
      a__lo = $x_1__lo;
      a__hi = $x_1__hi;
    }
    if ((op2Sign < 0)) {
      var b$2__lo = b__lo;
      var b$2__hi = b__hi;
      var blo$1 = b$2__lo;
      var lo$1 = ((-blo$1) | 0);
      var hi$3 = ((((-b$2__hi) | 0) + ((blo$1 | lo$1) >> 31)) | 0);
      var $x_2__lo = lo$1;
      var $x_2__hi = hi$3;
      b__lo = $x_2__lo;
      b__hi = $x_2__hi;
    }
    var $x_3 = $m_Ljava_math_BigInteger$();
    var a$1__lo = a__lo;
    var a$1__hi = a__hi;
    var b$3__lo = b__lo;
    var b$3__hi = b__hi;
    var alo = a$1__lo;
    var blo$2 = b$3__lo;
    var lo$2 = ((alo - blo$2) | 0);
    var hi$4 = ((((a$1__hi - b$3__hi) | 0) + ((((~alo) & blo$2) | ((~(alo ^ blo$2)) & lo$2)) >> 31)) | 0);
    return $x_3.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$2, hi$4));
  } else {
    var cmp = ((op1Len !== op2Len) ? ((op1Len > op2Len) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(op1.Ljava_math_BigInteger__f_digits, op2.Ljava_math_BigInteger__f_digits, op1Len));
    if (((op1Sign === op2Sign) && (cmp === 0))) {
      return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
    }
    if ((cmp === (-1))) {
      var res = ((op1Sign === op2Sign) ? $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len) : $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op2.Ljava_math_BigInteger__f_digits, op2Len, op1.Ljava_math_BigInteger__f_digits, op1Len));
      var _1 = ((-op2Sign) | 0);
      var x1___1 = _1;
      var x1___2 = res;
    } else if ((op1Sign === op2Sign)) {
      var _2 = $p_Ljava_math_Elementary$__subtract__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2;
    } else {
      var _2$1 = $p_Ljava_math_Elementary$__add__AI__I__AI__I__AI(this, op1.Ljava_math_BigInteger__f_digits, op1Len, op2.Ljava_math_BigInteger__f_digits, op2Len);
      var x1___1 = op1Sign;
      var x1___2 = _2$1;
    }
    var resSign = (x1___1 | 0);
    var resDigits = x1___2;
    var res$2 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resDigits.u.length, resDigits);
    res$2.cutOffLeadingZeroes__V();
    return res$2;
  }
});
var $d_Ljava_math_Elementary$ = new $TypeData().initClass($c_Ljava_math_Elementary$, "java.math.Elementary$", ({
  Ljava_math_Elementary$: 1
}));
export { $d_Ljava_math_Elementary$ as $d_Ljava_math_Elementary$ };
var $n_Ljava_math_Elementary$;
function $m_Ljava_math_Elementary$() {
  if ((!$n_Ljava_math_Elementary$)) {
    $n_Ljava_math_Elementary$ = new $c_Ljava_math_Elementary$();
  }
  return $n_Ljava_math_Elementary$;
}
export { $m_Ljava_math_Elementary$ as $m_Ljava_math_Elementary$ };
/** @constructor */
function $c_Ljava_math_MathContext(setPrecision, setRoundingMode) {
  this.Ljava_math_MathContext__f_precision = 0;
  this.Ljava_math_MathContext__f_roundingMode = null;
  this.Ljava_math_MathContext__f_precision = setPrecision;
  this.Ljava_math_MathContext__f_roundingMode = setRoundingMode;
}
export { $c_Ljava_math_MathContext as $c_Ljava_math_MathContext };
$c_Ljava_math_MathContext.prototype = new $h_O();
$c_Ljava_math_MathContext.prototype.constructor = $c_Ljava_math_MathContext;
/** @constructor */
function $h_Ljava_math_MathContext() {
}
export { $h_Ljava_math_MathContext as $h_Ljava_math_MathContext };
$h_Ljava_math_MathContext.prototype = $c_Ljava_math_MathContext.prototype;
$c_Ljava_math_MathContext.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_MathContext)) {
    if ((this.Ljava_math_MathContext__f_precision === x.Ljava_math_MathContext__f_precision)) {
      var x$2 = this.Ljava_math_MathContext__f_roundingMode;
      var x$3 = x.Ljava_math_MathContext__f_roundingMode;
      return (x$2 === x$3);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ljava_math_MathContext.prototype.hashCode__I = (function() {
  return ((this.Ljava_math_MathContext__f_precision << 3) | this.Ljava_math_MathContext__f_roundingMode.jl_Enum__f__ordinal);
});
$c_Ljava_math_MathContext.prototype.toString__T = (function() {
  return ((("precision=" + this.Ljava_math_MathContext__f_precision) + " roundingMode=") + this.Ljava_math_MathContext__f_roundingMode);
});
function $isArrayOf_Ljava_math_MathContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_MathContext)));
}
export { $isArrayOf_Ljava_math_MathContext as $isArrayOf_Ljava_math_MathContext };
var $d_Ljava_math_MathContext = new $TypeData().initClass($c_Ljava_math_MathContext, "java.math.MathContext", ({
  Ljava_math_MathContext: 1
}));
export { $d_Ljava_math_MathContext as $d_Ljava_math_MathContext };
/** @constructor */
function $c_Ljava_math_MathContext$() {
  this.Ljava_math_MathContext$__f_DECIMAL128 = null;
  $n_Ljava_math_MathContext$ = this;
  var roundingMode = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
  this.Ljava_math_MathContext$__f_DECIMAL128 = new $c_Ljava_math_MathContext(34, roundingMode);
  $m_Ljava_math_RoundingMode$();
  $m_Ljava_math_RoundingMode$();
  $m_Ljava_math_RoundingMode$();
}
export { $c_Ljava_math_MathContext$ as $c_Ljava_math_MathContext$ };
$c_Ljava_math_MathContext$.prototype = new $h_O();
$c_Ljava_math_MathContext$.prototype.constructor = $c_Ljava_math_MathContext$;
/** @constructor */
function $h_Ljava_math_MathContext$() {
}
export { $h_Ljava_math_MathContext$ as $h_Ljava_math_MathContext$ };
$h_Ljava_math_MathContext$.prototype = $c_Ljava_math_MathContext$.prototype;
var $d_Ljava_math_MathContext$ = new $TypeData().initClass($c_Ljava_math_MathContext$, "java.math.MathContext$", ({
  Ljava_math_MathContext$: 1
}));
export { $d_Ljava_math_MathContext$ as $d_Ljava_math_MathContext$ };
var $n_Ljava_math_MathContext$;
function $m_Ljava_math_MathContext$() {
  if ((!$n_Ljava_math_MathContext$)) {
    $n_Ljava_math_MathContext$ = new $c_Ljava_math_MathContext$();
  }
  return $n_Ljava_math_MathContext$;
}
export { $m_Ljava_math_MathContext$ as $m_Ljava_math_MathContext$ };
function $p_Ljava_math_Multiplication$__initialiseArrays__V($thiz) {
  var elem__lo = 0;
  var elem__hi = 0;
  var $x_1__lo = 1;
  var $x_1__hi = 0;
  elem__lo = $x_1__lo;
  elem__hi = $x_1__hi;
  var i = 0;
  while ((i < 32)) {
    var value = i;
    if ((value <= 18)) {
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.u[value] = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(elem__lo, elem__hi));
      var $x_3 = $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows;
      var $x_2 = $m_Ljava_math_BigInteger$();
      var a__lo = elem__lo;
      var a__hi = elem__hi;
      var lo = a__lo;
      var lo$1 = (((32 & value) === 0) ? (lo << value) : 0);
      var hi = (((32 & value) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - value) | 0)) | 0) | (a__hi << value)) : (lo << value));
      $x_3.u[value] = $x_2.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo$1, hi));
      var b__lo = elem__lo;
      var b__hi = elem__hi;
      var blo = b__lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(5, b0);
      var a0b1 = Math.imul(5, b1);
      var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((Math.imul(5, b__hi) + ((c1part >>> 16) | 0)) | 0);
      var $x_4__lo = lo$2;
      var $x_4__hi = hi$1;
      elem__lo = $x_4__lo;
      elem__hi = $x_4__hi;
    } else {
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.u[value] = $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.u[(((-1) + value) | 0)].multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigFivePows.u[1]);
      $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.u[value] = $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.u[(((-1) + value) | 0)].multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
    }
    i = ((1 + i) | 0);
  }
}
export { $p_Ljava_math_Multiplication$__initialiseArrays__V as $p_Ljava_math_Multiplication$__initialiseArrays__V };
function $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I($thiz, res, a, aSize, factor) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aSize)) {
    var value = i;
    $m_Ljava_math_Multiplication$();
    var a$1 = a.u[value];
    var c = elem;
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$1 = ((lo + c) | 0);
    var hi$4 = ((hi$2 + ((((lo & c) | ((lo | c) & (~lo$1))) >>> 31) | 0)) | 0);
    res.u[value] = lo$1;
    elem = hi$4;
    i = ((1 + i) | 0);
  }
  return elem;
}
export { $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I as $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I };
function $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V($thiz, a, b, t, aLen, bLen) {
  if (((a === b) && (aLen === bLen))) {
    $thiz.square__AI__I__AI__AI(a, aLen, t);
  } else {
    var i = 0;
    while ((i < aLen)) {
      var value = i;
      var elem = 0;
      elem = 0;
      var aI = a.u[value];
      var i$1 = 0;
      while ((i$1 < bLen)) {
        var value$1 = i$1;
        $m_Ljava_math_Multiplication$();
        var b$1 = b.u[value$1];
        var c = t.u[((value + value$1) | 0)];
        var d = elem;
        var a0 = (65535 & aI);
        var a1 = ((aI >>> 16) | 0);
        var b0 = (65535 & b$1);
        var b1 = ((b$1 >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$1 = ((lo + c) | 0);
        var hi$4 = ((hi$2 + ((((lo & c) | ((lo | c) & (~lo$1))) >>> 31) | 0)) | 0);
        var lo$2 = ((lo$1 + d) | 0);
        var hi$6 = ((hi$4 + ((((lo$1 & d) | ((lo$1 | d) & (~lo$2))) >>> 31) | 0)) | 0);
        t.u[((value + value$1) | 0)] = lo$2;
        elem = hi$6;
        i$1 = ((1 + i$1) | 0);
      }
      t.u[((value + bLen) | 0)] = elem;
      i = ((1 + i) | 0);
    }
  }
}
export { $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V as $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V };
function $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI($thiz, len, pow) {
  var result = new $ac_I(len);
  result.u[0] = 1;
  var i = 1;
  while ((i < len)) {
    var value = i;
    result.u[value] = Math.imul(result.u[(((-1) + value) | 0)], pow);
    i = ((1 + i) | 0);
  }
  return result;
}
export { $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI as $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI };
/** @constructor */
function $c_Ljava_math_Multiplication$() {
  this.Ljava_math_Multiplication$__f_TenPows = null;
  this.Ljava_math_Multiplication$__f_BigTenPows = null;
  this.Ljava_math_Multiplication$__f_BigFivePows = null;
  $n_Ljava_math_Multiplication$ = this;
  this.Ljava_math_Multiplication$__f_TenPows = $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 10, 10);
  $p_Ljava_math_Multiplication$__newArrayOfPows__I__I__AI(this, 14, 5);
  this.Ljava_math_Multiplication$__f_BigTenPows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  this.Ljava_math_Multiplication$__f_BigFivePows = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  $p_Ljava_math_Multiplication$__initialiseArrays__V(this);
}
export { $c_Ljava_math_Multiplication$ as $c_Ljava_math_Multiplication$ };
$c_Ljava_math_Multiplication$.prototype = new $h_O();
$c_Ljava_math_Multiplication$.prototype.constructor = $c_Ljava_math_Multiplication$;
/** @constructor */
function $h_Ljava_math_Multiplication$() {
}
export { $h_Ljava_math_Multiplication$ as $h_Ljava_math_Multiplication$ };
$h_Ljava_math_Multiplication$.prototype = $c_Ljava_math_Multiplication$.prototype;
$c_Ljava_math_Multiplication$.prototype.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(bi, factor) {
  var resSign = bi.Ljava_math_BigInteger__f_sign;
  var aNumberLength = bi.Ljava_math_BigInteger__f_numberLength;
  var aDigits = bi.Ljava_math_BigInteger__f_digits;
  if ((resSign === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  } else if ((aNumberLength === 1)) {
    var a = aDigits.u[0];
    var a0 = (65535 & a);
    var a1 = ((a >>> 16) | 0);
    var b0 = (65535 & factor);
    var b1 = ((factor >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
  } else {
    var resLength = ((1 + aNumberLength) | 0);
    var resDigits = new $ac_I(resLength);
    resDigits.u[aNumberLength] = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aNumberLength, factor);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result;
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger = (function(bi, exp) {
  var value = this.Ljava_math_Multiplication$__f_TenPows.u.length;
  var hi = (value >> 31);
  var ahi = exp.RTLong__f_hi;
  if (((ahi === hi) ? ((exp.RTLong__f_lo >>> 0) < (value >>> 0)) : (ahi < hi))) {
    return this.multiplyByPosInt__Ljava_math_BigInteger__I__Ljava_math_BigInteger(bi, this.Ljava_math_Multiplication$__f_TenPows.u[exp.RTLong__f_lo]);
  } else {
    return bi.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.powerOf10__J__Ljava_math_BigInteger(exp));
  }
});
$c_Ljava_math_Multiplication$.prototype.square__AI__I__AI__AI = (function(a, aLen, res) {
  var elem = 0;
  elem = 0;
  var i = 0;
  while ((i < aLen)) {
    var value = i;
    elem = 0;
    var _\uff3fself = ((1 + value) | 0);
    var i$1 = _\uff3fself;
    while ((i$1 < aLen)) {
      var value$1 = i$1;
      $m_Ljava_math_Multiplication$();
      var a$1 = a.u[value];
      var b = a.u[value$1];
      var c = res.u[((value + value$1) | 0)];
      var d = elem;
      var a0 = (65535 & a$1);
      var a1 = ((a$1 >>> 16) | 0);
      var b0 = (65535 & b);
      var b1 = ((b >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$1 = ((lo + c) | 0);
      var hi$4 = ((hi$2 + ((((lo & c) | ((lo | c) & (~lo$1))) >>> 31) | 0)) | 0);
      var lo$2 = ((lo$1 + d) | 0);
      var hi$6 = ((hi$4 + ((((lo$1 & d) | ((lo$1 | d) & (~lo$2))) >>> 31) | 0)) | 0);
      res.u[((value + value$1) | 0)] = lo$2;
      elem = hi$6;
      i$1 = ((1 + i$1) | 0);
    }
    res.u[((value + aLen) | 0)] = elem;
    i = ((1 + i) | 0);
  }
  $m_Ljava_math_BitLevel$().shiftLeftOneBit__AI__AI__I__V(res, res, (aLen << 1));
  elem = 0;
  var i$2 = 0;
  var index = 0;
  while ((i$2 < aLen)) {
    var a$2 = a.u[i$2];
    var b$1 = a.u[i$2];
    var c$1 = res.u[index];
    var d$1 = elem;
    var a0$1 = (65535 & a$2);
    var a1$1 = ((a$2 >>> 16) | 0);
    var b0$1 = (65535 & b$1);
    var b1$1 = ((b$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((Math.imul(a1$1, b1$1) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var lo$4 = ((lo$3 + c$1) | 0);
    var hi$11 = ((hi$9 + ((((lo$3 & c$1) | ((lo$3 | c$1) & (~lo$4))) >>> 31) | 0)) | 0);
    var lo$5 = ((lo$4 + d$1) | 0);
    var hi$13 = ((hi$11 + ((((lo$4 & d$1) | ((lo$4 | d$1) & (~lo$5))) >>> 31) | 0)) | 0);
    res.u[index] = lo$5;
    index = ((1 + index) | 0);
    var value$2 = res.u[index];
    var lo$6 = ((hi$13 + value$2) | 0);
    var hi$15 = ((((hi$13 & value$2) | ((hi$13 | value$2) & (~lo$6))) >>> 31) | 0);
    res.u[index] = lo$6;
    elem = hi$15;
    i$2 = ((1 + i$2) | 0);
    index = ((1 + index) | 0);
  }
  return res;
});
$c_Ljava_math_Multiplication$.prototype.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(val1, val2) {
  if ((val2.Ljava_math_BigInteger__f_numberLength > val1.Ljava_math_BigInteger__f_numberLength)) {
    var x1___1 = val2;
    var x1___2 = val1;
  } else {
    var x1___1 = val1;
    var x1___2 = val2;
  }
  var op1 = x1___1;
  var op2 = x1___2;
  if ((op2.Ljava_math_BigInteger__f_numberLength < 63)) {
    return this.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op1, op2);
  } else {
    var ndiv2 = (((-2) & op1.Ljava_math_BigInteger__f_numberLength) << 4);
    var upperOp1 = op1.shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var upperOp2 = op2.shiftRight__I__Ljava_math_BigInteger(ndiv2);
    var bi = upperOp1.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp1 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op1, bi);
    var bi$1 = upperOp2.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    var lowerOp2 = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(op2, bi$1);
    var upper = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(upperOp1, upperOp2);
    var lower = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(lowerOp1, lowerOp2);
    var middle = this.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(upperOp1, lowerOp1), $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(lowerOp2, upperOp2));
    var this$1 = middle;
    var bi$2 = upper;
    var this$2 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$1, bi$2);
    middle = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$2, lower);
    middle = middle.shiftLeft__I__Ljava_math_BigInteger(ndiv2);
    upper = upper.shiftLeft__I__Ljava_math_BigInteger((ndiv2 << 1));
    var this$3 = upper;
    var bi$3 = middle;
    var this$4 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$3, bi$3);
    return $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, lower);
  }
});
$c_Ljava_math_Multiplication$.prototype.multArraysPAP__AI__I__AI__I__AI__V = (function(aDigits, aLen, bDigits, bLen, resDigits) {
  if ((!((aLen === 0) || (bLen === 0)))) {
    if ((aLen === 1)) {
      resDigits.u[bLen] = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, bDigits, bLen, aDigits.u[0]);
    } else if ((bLen === 1)) {
      resDigits.u[aLen] = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this, resDigits, aDigits, aLen, bDigits.u[0]);
    } else {
      $p_Ljava_math_Multiplication$__multPAP__AI__AI__AI__I__I__V(this, aDigits, bDigits, resDigits, aLen, bLen);
    }
  }
});
$c_Ljava_math_Multiplication$.prototype.multiplyPAP__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(a, b) {
  var aLen = a.Ljava_math_BigInteger__f_numberLength;
  var bLen = b.Ljava_math_BigInteger__f_numberLength;
  var resLength = ((aLen + bLen) | 0);
  var resSign = ((a.Ljava_math_BigInteger__f_sign !== b.Ljava_math_BigInteger__f_sign) ? (-1) : 1);
  if ((resLength === 2)) {
    var a$1 = a.Ljava_math_BigInteger__f_digits.u[0];
    var b$1 = b.Ljava_math_BigInteger__f_digits.u[0];
    var a0 = (65535 & a$1);
    var a1 = ((a$1 >>> 16) | 0);
    var b0 = (65535 & b$1);
    var b1 = ((b$1 >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    return ((hi$2 === 0) ? $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), resSign, lo) : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, 2, new $ac_I(new Int32Array([lo, hi$2]))));
  } else {
    var aDigits = a.Ljava_math_BigInteger__f_digits;
    var bDigits = b.Ljava_math_BigInteger__f_digits;
    var resDigits = new $ac_I(resLength);
    this.multArraysPAP__AI__I__AI__I__AI__V(aDigits, aLen, bDigits, bLen, resDigits);
    var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
    result.cutOffLeadingZeroes__V();
    return result;
  }
});
$c_Ljava_math_Multiplication$.prototype.pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger = (function(base, exponent) {
  var exp = exponent;
  var res = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE;
  var acc = base;
  while ((exp > 1)) {
    var res2 = (((1 & exp) !== 0) ? res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc) : res);
    if ((acc.Ljava_math_BigInteger__f_numberLength === 1)) {
      var acc2 = acc.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc);
    } else {
      var a = new $ac_I((acc.Ljava_math_BigInteger__f_numberLength << 1));
      var sq = this.square__AI__I__AI__AI(acc.Ljava_math_BigInteger__f_digits, acc.Ljava_math_BigInteger__f_numberLength, a);
      var acc2 = $ct_Ljava_math_BigInteger__I__AI__(new $c_Ljava_math_BigInteger(), 1, sq);
    }
    var temp$exp = (exp >> 1);
    exp = temp$exp;
    res = res2;
    acc = acc2;
  }
  return res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(acc);
});
$c_Ljava_math_Multiplication$.prototype.powerOf10__J__Ljava_math_BigInteger = (function(exp) {
  var value = this.Ljava_math_Multiplication$__f_BigTenPows.u.length;
  var hi = (value >> 31);
  var ahi = exp.RTLong__f_hi;
  if (((ahi === hi) ? ((exp.RTLong__f_lo >>> 0) < (value >>> 0)) : (ahi < hi))) {
    return this.Ljava_math_Multiplication$__f_BigTenPows.u[exp.RTLong__f_lo];
  } else {
    var ahi$1 = exp.RTLong__f_hi;
    if (((ahi$1 === 0) ? ((exp.RTLong__f_lo >>> 0) <= 50) : (ahi$1 < 0))) {
      return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo);
    } else {
      var ahi$2 = exp.RTLong__f_hi;
      if (((ahi$2 === 0) ? ((exp.RTLong__f_lo >>> 0) <= 2147483647) : (ahi$2 < 0))) {
        return this.Ljava_math_Multiplication$__f_BigFivePows.u[1].pow__I__Ljava_math_BigInteger(exp.RTLong__f_lo).shiftLeft__I__Ljava_math_BigInteger(exp.RTLong__f_lo);
      } else {
        var powerOfFive = this.Ljava_math_Multiplication$__f_BigFivePows.u[1].pow__I__Ljava_math_BigInteger(2147483647);
        var res = powerOfFive;
        var blo = exp.RTLong__f_lo;
        var lo = (((-2147483647) + blo) | 0);
        var hi$1 = (((((-1) + exp.RTLong__f_hi) | 0) + (((blo | (~lo)) >>> 31) | 0)) | 0);
        var longExp__lo = lo;
        var longExp__hi = hi$1;
        var this$10 = $m_RTLong$();
        var lo$1 = this$10.remainderImpl__I__I__I__I__I(exp.RTLong__f_lo, exp.RTLong__f_hi, 2147483647, 0);
        while (true) {
          var a__lo = longExp__lo;
          var a__hi = longExp__hi;
          var ahi$3 = a__hi;
          if (((ahi$3 === 0) ? ((a__lo >>> 0) > 2147483647) : (ahi$3 > 0))) {
            res = res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(powerOfFive);
            var b__lo = longExp__lo;
            var b__hi = longExp__hi;
            var blo$1 = b__lo;
            var lo$2 = (((-2147483647) + blo$1) | 0);
            var hi$3 = (((((-1) + b__hi) | 0) + (((blo$1 | (~lo$2)) >>> 31) | 0)) | 0);
            var $x_1__lo = lo$2;
            var $x_1__hi = hi$3;
            longExp__lo = $x_1__lo;
            longExp__hi = $x_1__hi;
          } else {
            break;
          }
        }
        res = res.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.Ljava_math_Multiplication$__f_BigFivePows.u[1].pow__I__Ljava_math_BigInteger(lo$1));
        res = res.shiftLeft__I__Ljava_math_BigInteger(2147483647);
        var blo$2 = exp.RTLong__f_lo;
        var lo$3 = (((-2147483647) + blo$2) | 0);
        var hi$4 = (((((-1) + exp.RTLong__f_hi) | 0) + (((blo$2 | (~lo$3)) >>> 31) | 0)) | 0);
        var $x_2__lo = lo$3;
        var $x_2__hi = hi$4;
        longExp__lo = $x_2__lo;
        longExp__hi = $x_2__hi;
        while (true) {
          var a$1__lo = longExp__lo;
          var a$1__hi = longExp__hi;
          var ahi$4 = a$1__hi;
          if (((ahi$4 === 0) ? ((a$1__lo >>> 0) > 2147483647) : (ahi$4 > 0))) {
            res = res.shiftLeft__I__Ljava_math_BigInteger(2147483647);
            var b$1__lo = longExp__lo;
            var b$1__hi = longExp__hi;
            var blo$3 = b$1__lo;
            var lo$4 = (((-2147483647) + blo$3) | 0);
            var hi$5 = (((((-1) + b$1__hi) | 0) + (((blo$3 | (~lo$4)) >>> 31) | 0)) | 0);
            var $x_3__lo = lo$4;
            var $x_3__hi = hi$5;
            longExp__lo = $x_3__lo;
            longExp__hi = $x_3__hi;
          } else {
            break;
          }
        }
        return res.shiftLeft__I__Ljava_math_BigInteger(lo$1);
      }
    }
  }
});
var $d_Ljava_math_Multiplication$ = new $TypeData().initClass($c_Ljava_math_Multiplication$, "java.math.Multiplication$", ({
  Ljava_math_Multiplication$: 1
}));
export { $d_Ljava_math_Multiplication$ as $d_Ljava_math_Multiplication$ };
var $n_Ljava_math_Multiplication$;
function $m_Ljava_math_Multiplication$() {
  if ((!$n_Ljava_math_Multiplication$)) {
    $n_Ljava_math_Multiplication$ = new $c_Ljava_math_Multiplication$();
  }
  return $n_Ljava_math_Multiplication$;
}
export { $m_Ljava_math_Multiplication$ as $m_Ljava_math_Multiplication$ };
function $ct_Ljava_nio_Buffer__I__($thiz, _capacity) {
  $thiz.Ljava_nio_Buffer__f__capacity = _capacity;
  $thiz.Ljava_nio_Buffer__f__limit = $thiz.Ljava_nio_Buffer__f__capacity;
  $thiz.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  $thiz.Ljava_nio_Buffer__f__mark = (-1);
  return $thiz;
}
export { $ct_Ljava_nio_Buffer__I__ as $ct_Ljava_nio_Buffer__I__ };
/** @constructor */
function $c_Ljava_nio_Buffer() {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
}
export { $c_Ljava_nio_Buffer as $c_Ljava_nio_Buffer };
$c_Ljava_nio_Buffer.prototype = new $h_O();
$c_Ljava_nio_Buffer.prototype.constructor = $c_Ljava_nio_Buffer;
/** @constructor */
function $h_Ljava_nio_Buffer() {
}
export { $h_Ljava_nio_Buffer as $h_Ljava_nio_Buffer };
$h_Ljava_nio_Buffer.prototype = $c_Ljava_nio_Buffer.prototype;
$c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer = (function(newPosition) {
  if (((newPosition < 0) || (newPosition > this.Ljava_nio_Buffer__f__limit))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPosition;
  if ((this.Ljava_nio_Buffer__f__mark > newPosition)) {
    this.Ljava_nio_Buffer__f__mark = (-1);
  }
  return this;
});
$c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer = (function(newLimit) {
  if (((newLimit < 0) || (newLimit > this.Ljava_nio_Buffer__f__capacity))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  this.Ljava_nio_Buffer__f__limit = newLimit;
  if ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position > newLimit)) {
    this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newLimit;
    if ((this.Ljava_nio_Buffer__f__mark > newLimit)) {
      this.Ljava_nio_Buffer__f__mark = (-1);
    }
  }
  return this;
});
$c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer = (function() {
  this.Ljava_nio_Buffer__f__mark = (-1);
  this.Ljava_nio_Buffer__f__limit = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  return this;
});
$c_Ljava_nio_Buffer.prototype.toString__T = (function() {
  return ((((((($objectClassName(this) + "[pos=") + this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) + " lim=") + this.Ljava_nio_Buffer__f__limit) + " cap=") + this.Ljava_nio_Buffer__f__capacity) + "]");
});
/** @constructor */
function $c_Ljava_nio_ByteBuffer$() {
}
export { $c_Ljava_nio_ByteBuffer$ as $c_Ljava_nio_ByteBuffer$ };
$c_Ljava_nio_ByteBuffer$.prototype = new $h_O();
$c_Ljava_nio_ByteBuffer$.prototype.constructor = $c_Ljava_nio_ByteBuffer$;
/** @constructor */
function $h_Ljava_nio_ByteBuffer$() {
}
export { $h_Ljava_nio_ByteBuffer$ as $h_Ljava_nio_ByteBuffer$ };
$h_Ljava_nio_ByteBuffer$.prototype = $c_Ljava_nio_ByteBuffer$.prototype;
$c_Ljava_nio_ByteBuffer$.prototype.allocate__I__Ljava_nio_ByteBuffer = (function(capacity) {
  if ((capacity < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  var array = new $ac_B(capacity);
  var length = array.u.length;
  return $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(array, 0, array.u.length, 0, length, false);
});
var $d_Ljava_nio_ByteBuffer$ = new $TypeData().initClass($c_Ljava_nio_ByteBuffer$, "java.nio.ByteBuffer$", ({
  Ljava_nio_ByteBuffer$: 1
}));
export { $d_Ljava_nio_ByteBuffer$ as $d_Ljava_nio_ByteBuffer$ };
var $n_Ljava_nio_ByteBuffer$;
function $m_Ljava_nio_ByteBuffer$() {
  if ((!$n_Ljava_nio_ByteBuffer$)) {
    $n_Ljava_nio_ByteBuffer$ = new $c_Ljava_nio_ByteBuffer$();
  }
  return $n_Ljava_nio_ByteBuffer$;
}
export { $m_Ljava_nio_ByteBuffer$ as $m_Ljava_nio_ByteBuffer$ };
/** @constructor */
function $c_Ljava_nio_ByteOrder(name) {
  this.Ljava_nio_ByteOrder__f_name = null;
  this.Ljava_nio_ByteOrder__f_name = name;
}
export { $c_Ljava_nio_ByteOrder as $c_Ljava_nio_ByteOrder };
$c_Ljava_nio_ByteOrder.prototype = new $h_O();
$c_Ljava_nio_ByteOrder.prototype.constructor = $c_Ljava_nio_ByteOrder;
/** @constructor */
function $h_Ljava_nio_ByteOrder() {
}
export { $h_Ljava_nio_ByteOrder as $h_Ljava_nio_ByteOrder };
$h_Ljava_nio_ByteOrder.prototype = $c_Ljava_nio_ByteOrder.prototype;
$c_Ljava_nio_ByteOrder.prototype.toString__T = (function() {
  return this.Ljava_nio_ByteOrder__f_name;
});
var $d_Ljava_nio_ByteOrder = new $TypeData().initClass($c_Ljava_nio_ByteOrder, "java.nio.ByteOrder", ({
  Ljava_nio_ByteOrder: 1
}));
export { $d_Ljava_nio_ByteOrder as $d_Ljava_nio_ByteOrder };
/** @constructor */
function $c_Ljava_nio_ByteOrder$() {
  this.Ljava_nio_ByteOrder$__f_BIG_ENDIAN = null;
  this.Ljava_nio_ByteOrder$__f_LITTLE_ENDIAN = null;
  $n_Ljava_nio_ByteOrder$ = this;
  this.Ljava_nio_ByteOrder$__f_BIG_ENDIAN = new $c_Ljava_nio_ByteOrder("BIG_ENDIAN");
  this.Ljava_nio_ByteOrder$__f_LITTLE_ENDIAN = new $c_Ljava_nio_ByteOrder("LITTLE_ENDIAN");
  if (((typeof Int32Array) !== "undefined")) {
    var arrayBuffer = new ArrayBuffer(4);
    new Int32Array(arrayBuffer)[0] = 16909060;
    (new Int8Array(arrayBuffer)[0] | 0);
  }
}
export { $c_Ljava_nio_ByteOrder$ as $c_Ljava_nio_ByteOrder$ };
$c_Ljava_nio_ByteOrder$.prototype = new $h_O();
$c_Ljava_nio_ByteOrder$.prototype.constructor = $c_Ljava_nio_ByteOrder$;
/** @constructor */
function $h_Ljava_nio_ByteOrder$() {
}
export { $h_Ljava_nio_ByteOrder$ as $h_Ljava_nio_ByteOrder$ };
$h_Ljava_nio_ByteOrder$.prototype = $c_Ljava_nio_ByteOrder$.prototype;
var $d_Ljava_nio_ByteOrder$ = new $TypeData().initClass($c_Ljava_nio_ByteOrder$, "java.nio.ByteOrder$", ({
  Ljava_nio_ByteOrder$: 1
}));
export { $d_Ljava_nio_ByteOrder$ as $d_Ljava_nio_ByteOrder$ };
var $n_Ljava_nio_ByteOrder$;
function $m_Ljava_nio_ByteOrder$() {
  if ((!$n_Ljava_nio_ByteOrder$)) {
    $n_Ljava_nio_ByteOrder$ = new $c_Ljava_nio_ByteOrder$();
  }
  return $n_Ljava_nio_ByteOrder$;
}
export { $m_Ljava_nio_ByteOrder$ as $m_Ljava_nio_ByteOrder$ };
/** @constructor */
function $c_Ljava_nio_CharBuffer$() {
}
export { $c_Ljava_nio_CharBuffer$ as $c_Ljava_nio_CharBuffer$ };
$c_Ljava_nio_CharBuffer$.prototype = new $h_O();
$c_Ljava_nio_CharBuffer$.prototype.constructor = $c_Ljava_nio_CharBuffer$;
/** @constructor */
function $h_Ljava_nio_CharBuffer$() {
}
export { $h_Ljava_nio_CharBuffer$ as $h_Ljava_nio_CharBuffer$ };
$h_Ljava_nio_CharBuffer$.prototype = $c_Ljava_nio_CharBuffer$.prototype;
$c_Ljava_nio_CharBuffer$.prototype.allocate__I__Ljava_nio_CharBuffer = (function(capacity) {
  if ((capacity < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  var array = new $ac_C(capacity);
  var length = array.u.length;
  var capacity$1 = array.u.length;
  if (((capacity$1 < 0) || (capacity$1 > array.u.length))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  if (((length < 0) || (length > capacity$1))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return new $c_Ljava_nio_HeapCharBuffer(capacity$1, array, 0, 0, length, false);
});
$c_Ljava_nio_CharBuffer$.prototype.wrap__jl_CharSequence__I__I__Ljava_nio_CharBuffer = (function(csq, start, end) {
  return $m_Ljava_nio_StringCharBuffer$().wrap__jl_CharSequence__I__I__I__I__Ljava_nio_CharBuffer(csq, 0, $dp_length__I(csq), start, ((end - start) | 0));
});
var $d_Ljava_nio_CharBuffer$ = new $TypeData().initClass($c_Ljava_nio_CharBuffer$, "java.nio.CharBuffer$", ({
  Ljava_nio_CharBuffer$: 1
}));
export { $d_Ljava_nio_CharBuffer$ as $d_Ljava_nio_CharBuffer$ };
var $n_Ljava_nio_CharBuffer$;
function $m_Ljava_nio_CharBuffer$() {
  if ((!$n_Ljava_nio_CharBuffer$)) {
    $n_Ljava_nio_CharBuffer$ = new $c_Ljava_nio_CharBuffer$();
  }
  return $n_Ljava_nio_CharBuffer$;
}
export { $m_Ljava_nio_CharBuffer$ as $m_Ljava_nio_CharBuffer$ };
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer$() {
}
export { $c_Ljava_nio_HeapByteBuffer$ as $c_Ljava_nio_HeapByteBuffer$ };
$c_Ljava_nio_HeapByteBuffer$.prototype = new $h_O();
$c_Ljava_nio_HeapByteBuffer$.prototype.constructor = $c_Ljava_nio_HeapByteBuffer$;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer$() {
}
export { $h_Ljava_nio_HeapByteBuffer$ as $h_Ljava_nio_HeapByteBuffer$ };
$h_Ljava_nio_HeapByteBuffer$.prototype = $c_Ljava_nio_HeapByteBuffer$.prototype;
$c_Ljava_nio_HeapByteBuffer$.prototype.wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer = (function(array, arrayOffset, capacity, initialPosition, initialLength, isReadOnly) {
  if ((((arrayOffset < 0) || (capacity < 0)) || (((arrayOffset + capacity) | 0) > array.u.length))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var initialLimit = ((initialPosition + initialLength) | 0);
  if ((((initialPosition < 0) || (initialLength < 0)) || (initialLimit > capacity))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return new $c_Ljava_nio_HeapByteBuffer(capacity, array, arrayOffset, initialPosition, initialLimit, isReadOnly);
});
var $d_Ljava_nio_HeapByteBuffer$ = new $TypeData().initClass($c_Ljava_nio_HeapByteBuffer$, "java.nio.HeapByteBuffer$", ({
  Ljava_nio_HeapByteBuffer$: 1
}));
export { $d_Ljava_nio_HeapByteBuffer$ as $d_Ljava_nio_HeapByteBuffer$ };
var $n_Ljava_nio_HeapByteBuffer$;
function $m_Ljava_nio_HeapByteBuffer$() {
  if ((!$n_Ljava_nio_HeapByteBuffer$)) {
    $n_Ljava_nio_HeapByteBuffer$ = new $c_Ljava_nio_HeapByteBuffer$();
  }
  return $n_Ljava_nio_HeapByteBuffer$;
}
export { $m_Ljava_nio_HeapByteBuffer$ as $m_Ljava_nio_HeapByteBuffer$ };
/** @constructor */
function $c_Ljava_nio_StringCharBuffer$() {
}
export { $c_Ljava_nio_StringCharBuffer$ as $c_Ljava_nio_StringCharBuffer$ };
$c_Ljava_nio_StringCharBuffer$.prototype = new $h_O();
$c_Ljava_nio_StringCharBuffer$.prototype.constructor = $c_Ljava_nio_StringCharBuffer$;
/** @constructor */
function $h_Ljava_nio_StringCharBuffer$() {
}
export { $h_Ljava_nio_StringCharBuffer$ as $h_Ljava_nio_StringCharBuffer$ };
$h_Ljava_nio_StringCharBuffer$.prototype = $c_Ljava_nio_StringCharBuffer$.prototype;
$c_Ljava_nio_StringCharBuffer$.prototype.wrap__jl_CharSequence__I__I__I__I__Ljava_nio_CharBuffer = (function(csq, csqOffset, capacity, initialPosition, initialLength) {
  if ((((csqOffset < 0) || (capacity < 0)) || (((csqOffset + capacity) | 0) > $dp_length__I(csq)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var initialLimit = ((initialPosition + initialLength) | 0);
  if ((((initialPosition < 0) || (initialLength < 0)) || (initialLimit > capacity))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return new $c_Ljava_nio_StringCharBuffer(capacity, csq, csqOffset, initialPosition, initialLimit);
});
var $d_Ljava_nio_StringCharBuffer$ = new $TypeData().initClass($c_Ljava_nio_StringCharBuffer$, "java.nio.StringCharBuffer$", ({
  Ljava_nio_StringCharBuffer$: 1
}));
export { $d_Ljava_nio_StringCharBuffer$ as $d_Ljava_nio_StringCharBuffer$ };
var $n_Ljava_nio_StringCharBuffer$;
function $m_Ljava_nio_StringCharBuffer$() {
  if ((!$n_Ljava_nio_StringCharBuffer$)) {
    $n_Ljava_nio_StringCharBuffer$ = new $c_Ljava_nio_StringCharBuffer$();
  }
  return $n_Ljava_nio_StringCharBuffer$;
}
export { $m_Ljava_nio_StringCharBuffer$ as $m_Ljava_nio_StringCharBuffer$ };
function $p_Ljava_nio_charset_Charset$__CharsetMap$lzycompute__O($thiz) {
  if (((((2 & $thiz.Ljava_nio_charset_Charset$__f_bitmap$0) << 24) >> 24) === 0)) {
    var m = ({});
    var array = $p_Ljava_nio_charset_Charset$__allSJSCharsets__O($thiz);
    var len = (array.length | 0);
    var i = 0;
    while ((i !== len)) {
      var t = array[i];
      var this$3 = t.Ljava_nio_charset_Charset__f_canonicalName;
      var key = this$3.toLowerCase();
      m[key] = t;
      var aliases = t.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases;
      var end = aliases.u.length;
      var i$1 = 0;
      while ((i$1 < end)) {
        var value = i$1;
        var this$7 = aliases.u[value];
        var key$1 = this$7.toLowerCase();
        m[key$1] = t;
        i$1 = ((1 + i$1) | 0);
      }
      i = ((1 + i) | 0);
    }
    $thiz.Ljava_nio_charset_Charset$__f_CharsetMap = m;
    $thiz.Ljava_nio_charset_Charset$__f_bitmap$0 = (((2 | $thiz.Ljava_nio_charset_Charset$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.Ljava_nio_charset_Charset$__f_CharsetMap;
}
export { $p_Ljava_nio_charset_Charset$__CharsetMap$lzycompute__O as $p_Ljava_nio_charset_Charset$__CharsetMap$lzycompute__O };
function $p_Ljava_nio_charset_Charset$__CharsetMap__O($thiz) {
  return (((((2 & $thiz.Ljava_nio_charset_Charset$__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_nio_charset_Charset$__CharsetMap$lzycompute__O($thiz) : $thiz.Ljava_nio_charset_Charset$__f_CharsetMap);
}
export { $p_Ljava_nio_charset_Charset$__CharsetMap__O as $p_Ljava_nio_charset_Charset$__CharsetMap__O };
function $p_Ljava_nio_charset_Charset$__allSJSCharsets__O($thiz) {
  return [$m_Ljava_nio_charset_US\uff3fASCII$(), $m_Ljava_nio_charset_ISO\uff3f8859\uff3f1$(), $m_Ljava_nio_charset_UTF\uff3f8$(), $m_Ljava_nio_charset_UTF\uff3f16BE$(), $m_Ljava_nio_charset_UTF\uff3f16LE$(), $m_Ljava_nio_charset_UTF\uff3f16$()];
}
export { $p_Ljava_nio_charset_Charset$__allSJSCharsets__O as $p_Ljava_nio_charset_Charset$__allSJSCharsets__O };
/** @constructor */
function $c_Ljava_nio_charset_Charset$() {
  this.Ljava_nio_charset_Charset$__f_CharsetMap = null;
  this.Ljava_nio_charset_Charset$__f_bitmap$0 = 0;
}
export { $c_Ljava_nio_charset_Charset$ as $c_Ljava_nio_charset_Charset$ };
$c_Ljava_nio_charset_Charset$.prototype = new $h_O();
$c_Ljava_nio_charset_Charset$.prototype.constructor = $c_Ljava_nio_charset_Charset$;
/** @constructor */
function $h_Ljava_nio_charset_Charset$() {
}
export { $h_Ljava_nio_charset_Charset$ as $h_Ljava_nio_charset_Charset$ };
$h_Ljava_nio_charset_Charset$.prototype = $c_Ljava_nio_charset_Charset$.prototype;
$c_Ljava_nio_charset_Charset$.prototype.forName__T__Ljava_nio_charset_Charset = (function(charsetName) {
  var dict = $p_Ljava_nio_charset_Charset$__CharsetMap__O(this);
  var key = charsetName.toLowerCase();
  if ((!(!(!$m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, key))))) {
    throw new $c_Ljava_nio_charset_UnsupportedCharsetException(charsetName);
  }
  return dict[key];
});
var $d_Ljava_nio_charset_Charset$ = new $TypeData().initClass($c_Ljava_nio_charset_Charset$, "java.nio.charset.Charset$", ({
  Ljava_nio_charset_Charset$: 1
}));
export { $d_Ljava_nio_charset_Charset$ as $d_Ljava_nio_charset_Charset$ };
var $n_Ljava_nio_charset_Charset$;
function $m_Ljava_nio_charset_Charset$() {
  if ((!$n_Ljava_nio_charset_Charset$)) {
    $n_Ljava_nio_charset_Charset$ = new $c_Ljava_nio_charset_Charset$();
  }
  return $n_Ljava_nio_charset_Charset$;
}
export { $m_Ljava_nio_charset_Charset$ as $m_Ljava_nio_charset_Charset$ };
function $ps_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(out) {
  if ((out.Ljava_nio_Buffer__f__capacity === 0)) {
    return $m_Ljava_nio_CharBuffer$().allocate__I__Ljava_nio_CharBuffer(1);
  } else {
    var result = $m_Ljava_nio_CharBuffer$().allocate__I__Ljava_nio_CharBuffer((out.Ljava_nio_Buffer__f__capacity << 1));
    $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(out);
    result.put__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(out);
    return result;
  }
}
export { $ps_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer as $ps_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer };
function $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__($thiz, cs, _averageCharsPerByte, _maxCharsPerByte) {
  $thiz.Ljava_nio_charset_CharsetDecoder__f__averageCharsPerByte = _averageCharsPerByte;
  $thiz.Ljava_nio_charset_CharsetDecoder__f__replacement = "\ufffd";
  $thiz.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
  $thiz.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
  $thiz.Ljava_nio_charset_CharsetDecoder__f_status = 1;
  return $thiz;
}
export { $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__ as $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__ };
/** @constructor */
function $c_Ljava_nio_charset_CharsetDecoder() {
  this.Ljava_nio_charset_CharsetDecoder__f__averageCharsPerByte = 0.0;
  this.Ljava_nio_charset_CharsetDecoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f_status = 0;
}
export { $c_Ljava_nio_charset_CharsetDecoder as $c_Ljava_nio_charset_CharsetDecoder };
$c_Ljava_nio_charset_CharsetDecoder.prototype = new $h_O();
$c_Ljava_nio_charset_CharsetDecoder.prototype.constructor = $c_Ljava_nio_charset_CharsetDecoder;
/** @constructor */
function $h_Ljava_nio_charset_CharsetDecoder() {
}
export { $h_Ljava_nio_charset_CharsetDecoder as $h_Ljava_nio_charset_CharsetDecoder };
$h_Ljava_nio_charset_CharsetDecoder.prototype = $c_Ljava_nio_charset_CharsetDecoder.prototype;
$c_Ljava_nio_charset_CharsetDecoder.prototype.onMalformedInput__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetDecoder = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction = newAction;
  return this;
});
$c_Ljava_nio_charset_CharsetDecoder.prototype.onUnmappableCharacter__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetDecoder = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction = newAction;
  return this;
});
$c_Ljava_nio_charset_CharsetDecoder.prototype.decode__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Z__Ljava_nio_charset_CoderResult = (function(in$1, out, endOfInput) {
  if (((this.Ljava_nio_charset_CharsetDecoder__f_status === 4) || ((!endOfInput) && (this.Ljava_nio_charset_CharsetDecoder__f_status === 3)))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
  }
  this.Ljava_nio_charset_CharsetDecoder__f_status = (endOfInput ? 3 : 2);
  while (true) {
    try {
      var result1 = this.decodeLoop__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult(in$1, out);
    } catch (e) {
      var result1;
      if ((e instanceof $c_Ljava_nio_BufferOverflowException)) {
        var ex$2 = e;
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(ex$2);
      } else if ((e instanceof $c_Ljava_nio_BufferUnderflowException)) {
        var ex = e;
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(ex);
      } else {
        throw e;
      }
    }
    if ((result1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0)) {
      var remaining = ((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
      if ((endOfInput && (remaining > 0))) {
        var this$1 = $m_Ljava_nio_charset_CoderResult$();
        switch (remaining) {
          case 1: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
            break;
          }
          case 2: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2;
            break;
          }
          case 3: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
            break;
          }
          case 4: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4;
            break;
          }
          default: {
            var result2 = this$1.java$nio$charset$CoderResult$$malformedForLengthImpl__I__Ljava_nio_charset_CoderResult(remaining);
          }
        }
      } else {
        var result2 = result1;
      }
    } else {
      var result2 = result1;
    }
    if (((result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0) || (result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1))) {
      return result2;
    } else {
      var action = ((result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 3) ? this.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction : this.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction);
      var x = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE;
      if ((x === action)) {
        var $x_2 = out.Ljava_nio_Buffer__f__limit;
        var $x_1 = out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
        var this$2 = this.Ljava_nio_charset_CharsetDecoder__f__replacement;
        if (((($x_2 - $x_1) | 0) < this$2.length)) {
          return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
        } else {
          var src = this.Ljava_nio_charset_CharsetDecoder__f__replacement;
          out.put__T__I__I__Ljava_nio_CharBuffer(src, 0, src.length);
          var $x_3 = in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
          var l = result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length;
          if ((l < 0)) {
            throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
          }
          var newPosition = (($x_3 + l) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition);
        }
      } else {
        var x$3 = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
        if ((x$3 === action)) {
          return result2;
        } else {
          var x$5 = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_IGNORE;
          if ((x$5 === action)) {
            var $x_4 = in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
            var l$1 = result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length;
            if ((l$1 < 0)) {
              throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
            }
            var newPosition$1 = (($x_4 + l$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$1);
          } else {
            throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), action);
          }
        }
      }
    }
  }
});
$c_Ljava_nio_charset_CharsetDecoder.prototype.flush__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult = (function(out) {
  var x1 = this.Ljava_nio_charset_CharsetDecoder__f_status;
  switch (x1) {
    case 3: {
      var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      if ((result.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0)) {
        this.Ljava_nio_charset_CharsetDecoder__f_status = 4;
      }
      return result;
      break;
    }
    case 4: {
      return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      break;
    }
    default: {
      throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
    }
  }
});
$c_Ljava_nio_charset_CharsetDecoder.prototype.reset__Ljava_nio_charset_CharsetDecoder = (function() {
  this.Ljava_nio_charset_CharsetDecoder__f_status = 1;
  this.implReset__V();
  return this;
});
$c_Ljava_nio_charset_CharsetDecoder.prototype.implReset__V = (function() {
});
$c_Ljava_nio_charset_CharsetDecoder.prototype.decode__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer = (function(in$1) {
  this.reset__Ljava_nio_charset_CharsetDecoder();
  var initLength = $doubleToInt((((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) * this.Ljava_nio_charset_CharsetDecoder__f__averageCharsPerByte));
  var out = $m_Ljava_nio_CharBuffer$().allocate__I__Ljava_nio_CharBuffer(initLength);
  var out$1;
  while (true) {
    var result = this.decode__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Z__Ljava_nio_charset_CoderResult(in$1, out, true);
    if ((result.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind !== 0)) {
      if ((result.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1)) {
        out = $ps_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(out);
        continue;
      }
      result.throwException__V();
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
    }
    if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== in$1.Ljava_nio_Buffer__f__limit)) {
      throw $ct_jl_AssertionError__(new $c_jl_AssertionError());
    }
    var out$1 = out;
    break;
  }
  var out$2;
  while (true) {
    var result$1 = this.flush__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult(out$1);
    if ((result$1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind !== 0)) {
      if ((result$1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1)) {
        out$1 = $ps_Ljava_nio_charset_CharsetDecoder__grow$1__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer(out$1);
        continue;
      }
      result$1.throwException__V();
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
    }
    var out$2 = out$1;
    break;
  }
  $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(out$2);
  return out$2;
});
function $ps_Ljava_nio_charset_CharsetEncoder__grow$1__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer(out) {
  if ((out.Ljava_nio_Buffer__f__capacity === 0)) {
    return $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(1);
  } else {
    var result = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer((out.Ljava_nio_Buffer__f__capacity << 1));
    $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(out);
    result.put__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer(out);
    return result;
  }
}
export { $ps_Ljava_nio_charset_CharsetEncoder__grow$1__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer as $ps_Ljava_nio_charset_CharsetEncoder__grow$1__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer };
function $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__AB__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar, _replacement) {
  $thiz.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar = _averageBytesPerChar;
  $thiz.Ljava_nio_charset_CharsetEncoder__f__replacement = _replacement;
  $thiz.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
  $thiz.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
  $thiz.Ljava_nio_charset_CharsetEncoder__f_status = 0;
  return $thiz;
}
export { $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__AB__ as $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__AB__ };
function $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar) {
  $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__AB__($thiz, cs, _averageBytesPerChar, _maxBytesPerChar, new $ac_B(new Int8Array([63])));
  return $thiz;
}
export { $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__ as $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__ };
/** @constructor */
function $c_Ljava_nio_charset_CharsetEncoder() {
  this.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar = 0.0;
  this.Ljava_nio_charset_CharsetEncoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f_status = 0;
}
export { $c_Ljava_nio_charset_CharsetEncoder as $c_Ljava_nio_charset_CharsetEncoder };
$c_Ljava_nio_charset_CharsetEncoder.prototype = new $h_O();
$c_Ljava_nio_charset_CharsetEncoder.prototype.constructor = $c_Ljava_nio_charset_CharsetEncoder;
/** @constructor */
function $h_Ljava_nio_charset_CharsetEncoder() {
}
export { $h_Ljava_nio_charset_CharsetEncoder as $h_Ljava_nio_charset_CharsetEncoder };
$h_Ljava_nio_charset_CharsetEncoder.prototype = $c_Ljava_nio_charset_CharsetEncoder.prototype;
$c_Ljava_nio_charset_CharsetEncoder.prototype.onMalformedInput__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = newAction;
  return this;
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.onUnmappableCharacter__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder = (function(newAction) {
  if ((newAction === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null CodingErrorAction");
  }
  this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = newAction;
  return this;
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.encode__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Z__Ljava_nio_charset_CoderResult = (function(in$1, out, endOfInput) {
  if (((this.Ljava_nio_charset_CharsetEncoder__f_status === 3) || ((!endOfInput) && (this.Ljava_nio_charset_CharsetEncoder__f_status === 2)))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
  }
  this.Ljava_nio_charset_CharsetEncoder__f_status = (endOfInput ? 2 : 1);
  while (true) {
    try {
      var result1 = this.encodeLoop__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult(in$1, out);
    } catch (e) {
      var result1;
      if ((e instanceof $c_Ljava_nio_BufferOverflowException)) {
        var ex$2 = e;
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(ex$2);
      } else if ((e instanceof $c_Ljava_nio_BufferUnderflowException)) {
        var ex = e;
        throw new $c_Ljava_nio_charset_CoderMalfunctionError(ex);
      } else {
        throw e;
      }
    }
    if ((result1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0)) {
      var remaining = ((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
      if ((endOfInput && (remaining > 0))) {
        var this$1 = $m_Ljava_nio_charset_CoderResult$();
        switch (remaining) {
          case 1: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
            break;
          }
          case 2: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2;
            break;
          }
          case 3: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
            break;
          }
          case 4: {
            var result2 = this$1.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4;
            break;
          }
          default: {
            var result2 = this$1.java$nio$charset$CoderResult$$malformedForLengthImpl__I__Ljava_nio_charset_CoderResult(remaining);
          }
        }
      } else {
        var result2 = result1;
      }
    } else {
      var result2 = result1;
    }
    if (((result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0) || (result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1))) {
      return result2;
    } else {
      var action = ((result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 3) ? this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction : this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction);
      var x = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE;
      if ((x === action)) {
        if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < this.Ljava_nio_charset_CharsetEncoder__f__replacement.u.length)) {
          return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
        } else {
          var src = this.Ljava_nio_charset_CharsetEncoder__f__replacement;
          out.put__AB__I__I__Ljava_nio_ByteBuffer(src, 0, src.u.length);
          var $x_1 = in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
          var l = result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length;
          if ((l < 0)) {
            throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
          }
          var newPosition = (($x_1 + l) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition);
        }
      } else {
        var x$3 = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPORT;
        if ((x$3 === action)) {
          return result2;
        } else {
          var x$5 = $m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_IGNORE;
          if ((x$5 === action)) {
            var $x_2 = in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
            var l$1 = result2.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length;
            if ((l$1 < 0)) {
              throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
            }
            var newPosition$1 = (($x_2 + l$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$1);
          } else {
            throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), action);
          }
        }
      }
    }
  }
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.flush__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult = (function(out) {
  var x1 = this.Ljava_nio_charset_CharsetEncoder__f_status;
  switch (x1) {
    case 2: {
      var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      if ((result.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 0)) {
        this.Ljava_nio_charset_CharsetEncoder__f_status = 3;
      }
      return result;
      break;
    }
    case 3: {
      return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      break;
    }
    default: {
      throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
    }
  }
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.reset__Ljava_nio_charset_CharsetEncoder = (function() {
  this.Ljava_nio_charset_CharsetEncoder__f_status = 0;
  this.implReset__V();
  return this;
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.implReset__V = (function() {
});
$c_Ljava_nio_charset_CharsetEncoder.prototype.encode__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer = (function(in$1) {
  if ((((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) === 0)) {
    return $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(0);
  } else {
    this.reset__Ljava_nio_charset_CharsetEncoder();
    var initLength = $doubleToInt(Math.fround((Math.fround(((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0)) * this.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar)));
    var out = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(initLength);
    var out$1;
    while (true) {
      var result = this.encode__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Z__Ljava_nio_charset_CoderResult(in$1, out, true);
      if ((result.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind !== 0)) {
        if ((result.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1)) {
          out = $ps_Ljava_nio_charset_CharsetEncoder__grow$1__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer(out);
          continue;
        }
        result.throwException__V();
        throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
      }
      if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== in$1.Ljava_nio_Buffer__f__limit)) {
        throw $ct_jl_AssertionError__(new $c_jl_AssertionError());
      }
      var out$1 = out;
      break;
    }
    var out$2;
    while (true) {
      var result$1 = this.flush__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult(out$1);
      if ((result$1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind !== 0)) {
        if ((result$1.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind === 1)) {
          out$1 = $ps_Ljava_nio_charset_CharsetEncoder__grow$1__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer(out$1);
          continue;
        }
        result$1.throwException__V();
        throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "should not get here");
      }
      var out$2 = out$1;
      break;
    }
    $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(out$2);
    return out$2;
  }
});
/** @constructor */
function $c_Ljava_nio_charset_CoderResult(kind, _length) {
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind = 0;
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length = 0;
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind = kind;
  this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length = _length;
}
export { $c_Ljava_nio_charset_CoderResult as $c_Ljava_nio_charset_CoderResult };
$c_Ljava_nio_charset_CoderResult.prototype = new $h_O();
$c_Ljava_nio_charset_CoderResult.prototype.constructor = $c_Ljava_nio_charset_CoderResult;
/** @constructor */
function $h_Ljava_nio_charset_CoderResult() {
}
export { $h_Ljava_nio_charset_CoderResult as $h_Ljava_nio_charset_CoderResult };
$h_Ljava_nio_charset_CoderResult.prototype = $c_Ljava_nio_charset_CoderResult.prototype;
$c_Ljava_nio_charset_CoderResult.prototype.throwException__V = (function() {
  var x1 = this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$kind;
  switch (x1) {
    case 1: {
      throw new $c_Ljava_nio_BufferOverflowException();
      break;
    }
    case 0: {
      throw new $c_Ljava_nio_BufferUnderflowException();
      break;
    }
    case 2: {
      throw new $c_Ljava_nio_charset_MalformedInputException(this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length);
      break;
    }
    case 3: {
      throw new $c_Ljava_nio_charset_UnmappableCharacterException(this.Ljava_nio_charset_CoderResult__f_java$nio$charset$CoderResult$$_length);
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1);
    }
  }
});
var $d_Ljava_nio_charset_CoderResult = new $TypeData().initClass($c_Ljava_nio_charset_CoderResult, "java.nio.charset.CoderResult", ({
  Ljava_nio_charset_CoderResult: 1
}));
export { $d_Ljava_nio_charset_CoderResult as $d_Ljava_nio_charset_CoderResult };
/** @constructor */
function $c_Ljava_nio_charset_CoderResult$() {
  this.Ljava_nio_charset_CoderResult$__f_OVERFLOW = null;
  this.Ljava_nio_charset_CoderResult$__f_UNDERFLOW = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4 = null;
  this.Ljava_nio_charset_CoderResult$__f_uniqueMalformed = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable1 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable2 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable3 = null;
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable4 = null;
  this.Ljava_nio_charset_CoderResult$__f_uniqueUnmappable = null;
  $n_Ljava_nio_charset_CoderResult$ = this;
  this.Ljava_nio_charset_CoderResult$__f_OVERFLOW = new $c_Ljava_nio_charset_CoderResult(1, (-1));
  this.Ljava_nio_charset_CoderResult$__f_UNDERFLOW = new $c_Ljava_nio_charset_CoderResult(0, (-1));
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1 = new $c_Ljava_nio_charset_CoderResult(2, 1);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2 = new $c_Ljava_nio_charset_CoderResult(2, 2);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3 = new $c_Ljava_nio_charset_CoderResult(2, 3);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4 = new $c_Ljava_nio_charset_CoderResult(2, 4);
  this.Ljava_nio_charset_CoderResult$__f_uniqueMalformed = [];
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable1 = new $c_Ljava_nio_charset_CoderResult(3, 1);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable2 = new $c_Ljava_nio_charset_CoderResult(3, 2);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable3 = new $c_Ljava_nio_charset_CoderResult(3, 3);
  this.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable4 = new $c_Ljava_nio_charset_CoderResult(3, 4);
  this.Ljava_nio_charset_CoderResult$__f_uniqueUnmappable = [];
}
export { $c_Ljava_nio_charset_CoderResult$ as $c_Ljava_nio_charset_CoderResult$ };
$c_Ljava_nio_charset_CoderResult$.prototype = new $h_O();
$c_Ljava_nio_charset_CoderResult$.prototype.constructor = $c_Ljava_nio_charset_CoderResult$;
/** @constructor */
function $h_Ljava_nio_charset_CoderResult$() {
}
export { $h_Ljava_nio_charset_CoderResult$ as $h_Ljava_nio_charset_CoderResult$ };
$h_Ljava_nio_charset_CoderResult$.prototype = $c_Ljava_nio_charset_CoderResult$.prototype;
$c_Ljava_nio_charset_CoderResult$.prototype.java$nio$charset$CoderResult$$malformedForLengthImpl__I__Ljava_nio_charset_CoderResult = (function(length) {
  var x = this.Ljava_nio_charset_CoderResult$__f_uniqueMalformed[length];
  if ((x !== (void 0))) {
    return x;
  } else {
    var result = new $c_Ljava_nio_charset_CoderResult(2, length);
    $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_uniqueMalformed[length] = result;
    return result;
  }
});
var $d_Ljava_nio_charset_CoderResult$ = new $TypeData().initClass($c_Ljava_nio_charset_CoderResult$, "java.nio.charset.CoderResult$", ({
  Ljava_nio_charset_CoderResult$: 1
}));
export { $d_Ljava_nio_charset_CoderResult$ as $d_Ljava_nio_charset_CoderResult$ };
var $n_Ljava_nio_charset_CoderResult$;
function $m_Ljava_nio_charset_CoderResult$() {
  if ((!$n_Ljava_nio_charset_CoderResult$)) {
    $n_Ljava_nio_charset_CoderResult$ = new $c_Ljava_nio_charset_CoderResult$();
  }
  return $n_Ljava_nio_charset_CoderResult$;
}
export { $m_Ljava_nio_charset_CoderResult$ as $m_Ljava_nio_charset_CoderResult$ };
/** @constructor */
function $c_Ljava_nio_charset_CodingErrorAction(name) {
  this.Ljava_nio_charset_CodingErrorAction__f_name = null;
  this.Ljava_nio_charset_CodingErrorAction__f_name = name;
}
export { $c_Ljava_nio_charset_CodingErrorAction as $c_Ljava_nio_charset_CodingErrorAction };
$c_Ljava_nio_charset_CodingErrorAction.prototype = new $h_O();
$c_Ljava_nio_charset_CodingErrorAction.prototype.constructor = $c_Ljava_nio_charset_CodingErrorAction;
/** @constructor */
function $h_Ljava_nio_charset_CodingErrorAction() {
}
export { $h_Ljava_nio_charset_CodingErrorAction as $h_Ljava_nio_charset_CodingErrorAction };
$h_Ljava_nio_charset_CodingErrorAction.prototype = $c_Ljava_nio_charset_CodingErrorAction.prototype;
$c_Ljava_nio_charset_CodingErrorAction.prototype.toString__T = (function() {
  return this.Ljava_nio_charset_CodingErrorAction__f_name;
});
var $d_Ljava_nio_charset_CodingErrorAction = new $TypeData().initClass($c_Ljava_nio_charset_CodingErrorAction, "java.nio.charset.CodingErrorAction", ({
  Ljava_nio_charset_CodingErrorAction: 1
}));
export { $d_Ljava_nio_charset_CodingErrorAction as $d_Ljava_nio_charset_CodingErrorAction };
/** @constructor */
function $c_Ljava_nio_charset_CodingErrorAction$() {
  this.Ljava_nio_charset_CodingErrorAction$__f_IGNORE = null;
  this.Ljava_nio_charset_CodingErrorAction$__f_REPLACE = null;
  this.Ljava_nio_charset_CodingErrorAction$__f_REPORT = null;
  $n_Ljava_nio_charset_CodingErrorAction$ = this;
  this.Ljava_nio_charset_CodingErrorAction$__f_IGNORE = new $c_Ljava_nio_charset_CodingErrorAction("IGNORE");
  this.Ljava_nio_charset_CodingErrorAction$__f_REPLACE = new $c_Ljava_nio_charset_CodingErrorAction("REPLACE");
  this.Ljava_nio_charset_CodingErrorAction$__f_REPORT = new $c_Ljava_nio_charset_CodingErrorAction("REPORT");
}
export { $c_Ljava_nio_charset_CodingErrorAction$ as $c_Ljava_nio_charset_CodingErrorAction$ };
$c_Ljava_nio_charset_CodingErrorAction$.prototype = new $h_O();
$c_Ljava_nio_charset_CodingErrorAction$.prototype.constructor = $c_Ljava_nio_charset_CodingErrorAction$;
/** @constructor */
function $h_Ljava_nio_charset_CodingErrorAction$() {
}
export { $h_Ljava_nio_charset_CodingErrorAction$ as $h_Ljava_nio_charset_CodingErrorAction$ };
$h_Ljava_nio_charset_CodingErrorAction$.prototype = $c_Ljava_nio_charset_CodingErrorAction$.prototype;
var $d_Ljava_nio_charset_CodingErrorAction$ = new $TypeData().initClass($c_Ljava_nio_charset_CodingErrorAction$, "java.nio.charset.CodingErrorAction$", ({
  Ljava_nio_charset_CodingErrorAction$: 1
}));
export { $d_Ljava_nio_charset_CodingErrorAction$ as $d_Ljava_nio_charset_CodingErrorAction$ };
var $n_Ljava_nio_charset_CodingErrorAction$;
function $m_Ljava_nio_charset_CodingErrorAction$() {
  if ((!$n_Ljava_nio_charset_CodingErrorAction$)) {
    $n_Ljava_nio_charset_CodingErrorAction$ = new $c_Ljava_nio_charset_CodingErrorAction$();
  }
  return $n_Ljava_nio_charset_CodingErrorAction$;
}
export { $m_Ljava_nio_charset_CodingErrorAction$ as $m_Ljava_nio_charset_CodingErrorAction$ };
function $p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT($thiz, m, size, v) {
  if ((m.knownSize__I() >= 0)) {
    var len = m.knownSize__I();
    var destination = new ($d_T.getArrayOf().constr)(len);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(m, destination, 0, 2147483647);
    var original = destination;
  } else {
    var capacity = 0;
    var size$1 = 0;
    var jsElems = null;
    capacity = 0;
    size$1 = 0;
    jsElems = [];
    var it = m.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var original = new ($d_T.getArrayOf().constr)(jsElems);
  }
  var p = $m_ju_Arrays$().copyOf__AO__I__AO(original, size);
  var x = m.length__I();
  var isEmpty = (x >= size);
  var scala$collection$immutable$Range$$lastElement = (((-1) + size) | 0);
  if ((!isEmpty)) {
    var i = x;
    while (true) {
      var x0 = i;
      p.u[x0] = v;
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  return p;
}
export { $p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT as $p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT };
function $p_Ljava_text_DateFormatSymbols$__padAndCopyDays__sci_List__I__T__AT($thiz, m, size, v) {
  var dimensions = new $ac_I(new Int32Array([size]));
  var v$2 = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_T.getClassOf(), dimensions);
  var isEmpty = (size <= 0);
  var scala$collection$immutable$Range$$lastElement = (((-1) + size) | 0);
  if ((!isEmpty)) {
    var i = 0;
    while (true) {
      var x0 = i;
      if (((x0 === 0) || (x0 > m.length__I()))) {
        v$2.u[x0] = "";
      } else {
        var n = (((-1) + x0) | 0);
        v$2.u[x0] = $f_sc_LinearSeqOps__apply__I__O(m, n);
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  return v$2;
}
export { $p_Ljava_text_DateFormatSymbols$__padAndCopyDays__sci_List__I__T__AT as $p_Ljava_text_DateFormatSymbols$__padAndCopyDays__sci_List__I__T__AT };
function $p_Ljava_text_DateFormatSymbols$__toDFS__ju_Locale__Ljava_text_DateFormatSymbols__Llocales_cldr_LDML__Ljava_text_DateFormatSymbols($thiz, locale, dfs, ldml) {
  var read = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => _$3.Llocales_cldr_CalendarSymbols__f_months));
  var this$3 = $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c) => $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__F1__Llocales_cldr_CalendarSymbols__s_Option($thiz, read, c))));
  if (this$3.isEmpty__Z()) {
    var value = $m_sci_Nil$();
    var this$5 = new $c_s_Some(value);
  } else {
    var this$5 = this$3;
  }
  if ((!this$5.isEmpty__Z())) {
    var x0 = this$5.get__O();
    dfs.setMonths__AT__V($p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT($thiz, x0, 13, ""));
  }
  var read$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => _$4.Llocales_cldr_CalendarSymbols__f_shortMonths));
  var this$7 = $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c$1) => $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__F1__Llocales_cldr_CalendarSymbols__s_Option($thiz, read$1, c$1))));
  if (this$7.isEmpty__Z()) {
    var value$1 = $m_sci_Nil$();
    var this$9 = new $c_s_Some(value$1);
  } else {
    var this$9 = this$7;
  }
  if ((!this$9.isEmpty__Z())) {
    var x0$1 = this$9.get__O();
    dfs.setShortMonths__AT__V($p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT($thiz, x0$1, 13, ""));
  }
  var read$2 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => _$5.Llocales_cldr_CalendarSymbols__f_weekdays));
  var this$11 = $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c$2) => $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__F1__Llocales_cldr_CalendarSymbols__s_Option($thiz, read$2, c$2))));
  if (this$11.isEmpty__Z()) {
    var value$2 = $m_sci_Nil$();
    var this$13 = new $c_s_Some(value$2);
  } else {
    var this$13 = this$11;
  }
  if ((!this$13.isEmpty__Z())) {
    var x0$2 = this$13.get__O();
    dfs.setWeekdays__AT__V($p_Ljava_text_DateFormatSymbols$__padAndCopyDays__sci_List__I__T__AT($thiz, x0$2, 8, ""));
  }
  var read$3 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => _$6.Llocales_cldr_CalendarSymbols__f_shortWeekdays));
  var this$15 = $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c$3) => $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__F1__Llocales_cldr_CalendarSymbols__s_Option($thiz, read$3, c$3))));
  if (this$15.isEmpty__Z()) {
    var value$3 = $m_sci_Nil$();
    var this$17 = new $c_s_Some(value$3);
  } else {
    var this$17 = this$15;
  }
  if ((!this$17.isEmpty__Z())) {
    var x0$3 = this$17.get__O();
    dfs.setShortWeekdays__AT__V($p_Ljava_text_DateFormatSymbols$__padAndCopyDays__sci_List__I__T__AT($thiz, x0$3, 8, ""));
  }
  var read$4 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$7) => _$7.Llocales_cldr_CalendarSymbols__f_amPm));
  var this$19 = $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c$4) => $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__F1__Llocales_cldr_CalendarSymbols__s_Option($thiz, read$4, c$4))));
  if (this$19.isEmpty__Z()) {
    var value$4 = $m_sci_Nil$();
    var this$21 = new $c_s_Some(value$4);
  } else {
    var this$21 = this$19;
  }
  if ((!this$21.isEmpty__Z())) {
    var x0$4 = this$21.get__O();
    dfs.setAmPmStrings__AT__V($p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT($thiz, x0$4, 2, ""));
  }
  var read$5 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => _$8.Llocales_cldr_CalendarSymbols__f_eras));
  var this$23 = $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c$5) => $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__F1__Llocales_cldr_CalendarSymbols__s_Option($thiz, read$5, c$5))));
  if (this$23.isEmpty__Z()) {
    var value$5 = $m_sci_Nil$();
    var this$25 = new $c_s_Some(value$5);
  } else {
    var this$25 = this$23;
  }
  if ((!this$25.isEmpty__Z())) {
    var x0$5 = this$25.get__O();
    dfs.setEras__AT__V($p_Ljava_text_DateFormatSymbols$__copyAndPad__sci_List__I__T__AT($thiz, x0$5, 2, ""));
  }
  return dfs;
}
export { $p_Ljava_text_DateFormatSymbols$__toDFS__ju_Locale__Ljava_text_DateFormatSymbols__Llocales_cldr_LDML__Ljava_text_DateFormatSymbols as $p_Ljava_text_DateFormatSymbols$__toDFS__ju_Locale__Ljava_text_DateFormatSymbols__Llocales_cldr_LDML__Ljava_text_DateFormatSymbols };
function $p_Ljava_text_DateFormatSymbols$__parentSymbols$1__Llocales_cldr_LDML__s_Option($thiz, ldml) {
  var this$1 = ldml.Llocales_cldr_LDML__f_calendarSymbols;
  if (this$1.isEmpty__Z()) {
    var this$2 = ldml.Llocales_cldr_LDML__f_parent;
    if (this$2.isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var x0 = this$2.get__O();
      return $p_Ljava_text_DateFormatSymbols$__parentSymbols$1__Llocales_cldr_LDML__s_Option($thiz, x0);
    }
  } else {
    return this$1;
  }
}
export { $p_Ljava_text_DateFormatSymbols$__parentSymbols$1__Llocales_cldr_LDML__s_Option as $p_Ljava_text_DateFormatSymbols$__parentSymbols$1__Llocales_cldr_LDML__s_Option };
function $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, ldml, read) {
  var this$1 = $p_Ljava_text_DateFormatSymbols$__parentSymbols$1__Llocales_cldr_LDML__s_Option($thiz, ldml);
  if (this$1.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var this$2 = read.apply__O__O(x0);
    if (this$2.isEmpty__Z()) {
      var this$3 = ldml.Llocales_cldr_LDML__f_parent;
      if (this$3.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var x0$1 = this$3.get__O();
        return $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option($thiz, x0$1, read);
      }
    } else {
      return this$2;
    }
  }
}
export { $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option as $p_Ljava_text_DateFormatSymbols$__elementsArray$1__Llocales_cldr_LDML__F1__s_Option };
function $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__F1__Llocales_cldr_CalendarSymbols__s_Option($thiz, read$4, c) {
  var x3 = read$4.apply__O__O(c);
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(x3)) {
    return $m_s_None$();
  }
  return new $c_s_Some(x3);
}
export { $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__F1__Llocales_cldr_CalendarSymbols__s_Option as $p_Ljava_text_DateFormatSymbols$__readNonEmpty$1__F1__Llocales_cldr_CalendarSymbols__s_Option };
/** @constructor */
function $c_Ljava_text_DateFormatSymbols$() {
}
export { $c_Ljava_text_DateFormatSymbols$ as $c_Ljava_text_DateFormatSymbols$ };
$c_Ljava_text_DateFormatSymbols$.prototype = new $h_O();
$c_Ljava_text_DateFormatSymbols$.prototype.constructor = $c_Ljava_text_DateFormatSymbols$;
/** @constructor */
function $h_Ljava_text_DateFormatSymbols$() {
}
export { $h_Ljava_text_DateFormatSymbols$ as $h_Ljava_text_DateFormatSymbols$ };
$h_Ljava_text_DateFormatSymbols$.prototype = $c_Ljava_text_DateFormatSymbols$.prototype;
$c_Ljava_text_DateFormatSymbols$.prototype.getInstance__ju_Locale__Ljava_text_DateFormatSymbols = (function(locale) {
  return this.java$text$DateFormatSymbols$$$initialize__ju_Locale__Ljava_text_DateFormatSymbols__Ljava_text_DateFormatSymbols(locale, new $c_Ljava_text_DateFormatSymbols(locale));
});
$c_Ljava_text_DateFormatSymbols$.prototype.java$text$DateFormatSymbols$$$initialize__ju_Locale__Ljava_text_DateFormatSymbols__Ljava_text_DateFormatSymbols = (function(locale, dfs) {
  var this$1 = $m_Llocales_LocalesDb$().ldml__ju_Locale__s_Option(locale);
  if (this$1.isEmpty__Z()) {
    var this$2 = $m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var this$2 = new $c_s_Some($p_Ljava_text_DateFormatSymbols$__toDFS__ju_Locale__Ljava_text_DateFormatSymbols__Llocales_cldr_LDML__Ljava_text_DateFormatSymbols(this, locale, dfs, x0));
  }
  return (this$2.isEmpty__Z() ? dfs : this$2.get__O());
});
var $d_Ljava_text_DateFormatSymbols$ = new $TypeData().initClass($c_Ljava_text_DateFormatSymbols$, "java.text.DateFormatSymbols$", ({
  Ljava_text_DateFormatSymbols$: 1
}));
export { $d_Ljava_text_DateFormatSymbols$ as $d_Ljava_text_DateFormatSymbols$ };
var $n_Ljava_text_DateFormatSymbols$;
function $m_Ljava_text_DateFormatSymbols$() {
  if ((!$n_Ljava_text_DateFormatSymbols$)) {
    $n_Ljava_text_DateFormatSymbols$ = new $c_Ljava_text_DateFormatSymbols$();
  }
  return $n_Ljava_text_DateFormatSymbols$;
}
export { $m_Ljava_text_DateFormatSymbols$ as $m_Ljava_text_DateFormatSymbols$ };
/** @constructor */
function $c_Ljava_text_ParsePosition(index) {
  this.Ljava_text_ParsePosition__f_index = 0;
  this.Ljava_text_ParsePosition__f_errorIndex = 0;
  this.Ljava_text_ParsePosition__f_index = index;
  this.Ljava_text_ParsePosition__f_errorIndex = (-1);
}
export { $c_Ljava_text_ParsePosition as $c_Ljava_text_ParsePosition };
$c_Ljava_text_ParsePosition.prototype = new $h_O();
$c_Ljava_text_ParsePosition.prototype.constructor = $c_Ljava_text_ParsePosition;
/** @constructor */
function $h_Ljava_text_ParsePosition() {
}
export { $h_Ljava_text_ParsePosition as $h_Ljava_text_ParsePosition };
$h_Ljava_text_ParsePosition.prototype = $c_Ljava_text_ParsePosition.prototype;
$c_Ljava_text_ParsePosition.prototype.equals__O__Z = (function(other) {
  return ((other instanceof $c_Ljava_text_ParsePosition) && ((this.Ljava_text_ParsePosition__f_errorIndex === other.Ljava_text_ParsePosition__f_errorIndex) && (this.Ljava_text_ParsePosition__f_index === other.Ljava_text_ParsePosition__f_index)));
});
$c_Ljava_text_ParsePosition.prototype.hashCode__I = (function() {
  var state = $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapIntArray__AI__sci_ArraySeq(new $ac_I(new Int32Array([this.Ljava_text_ParsePosition__f_errorIndex, this.Ljava_text_ParsePosition__f_index]))));
  return (state.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    var _$1$1 = (_$1 | 0);
    return _$1$1;
  }))).foldLeft__O__F2__O(0, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a, b) => {
    var a$1 = (a | 0);
    var b$1 = (b | 0);
    return ((Math.imul(31, a$1) + b$1) | 0);
  }))) | 0);
});
$c_Ljava_text_ParsePosition.prototype.toString__T = (function() {
  return (((("java.text.ParsePosition[index=" + this.Ljava_text_ParsePosition__f_index) + ",errorIndex=") + this.Ljava_text_ParsePosition__f_errorIndex) + "]");
});
function $isArrayOf_Ljava_text_ParsePosition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_text_ParsePosition)));
}
export { $isArrayOf_Ljava_text_ParsePosition as $isArrayOf_Ljava_text_ParsePosition };
var $d_Ljava_text_ParsePosition = new $TypeData().initClass($c_Ljava_text_ParsePosition, "java.text.ParsePosition", ({
  Ljava_text_ParsePosition: 1
}));
export { $d_Ljava_text_ParsePosition as $d_Ljava_text_ParsePosition };
/** @constructor */
function $c_Ljava_time_Clock() {
}
export { $c_Ljava_time_Clock as $c_Ljava_time_Clock };
$c_Ljava_time_Clock.prototype = new $h_O();
$c_Ljava_time_Clock.prototype.constructor = $c_Ljava_time_Clock;
/** @constructor */
function $h_Ljava_time_Clock() {
}
export { $h_Ljava_time_Clock as $h_Ljava_time_Clock };
$h_Ljava_time_Clock.prototype = $c_Ljava_time_Clock.prototype;
/** @constructor */
function $c_Ljava_time_Clock$() {
}
export { $c_Ljava_time_Clock$ as $c_Ljava_time_Clock$ };
$c_Ljava_time_Clock$.prototype = new $h_O();
$c_Ljava_time_Clock$.prototype.constructor = $c_Ljava_time_Clock$;
/** @constructor */
function $h_Ljava_time_Clock$() {
}
export { $h_Ljava_time_Clock$ as $h_Ljava_time_Clock$ };
$h_Ljava_time_Clock$.prototype = $c_Ljava_time_Clock$.prototype;
$c_Ljava_time_Clock$.prototype.system__Ljava_time_ZoneId__Ljava_time_Clock = (function(zone) {
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone");
  }
  return new $c_Ljava_time_Clock$SystemClock(zone);
});
var $d_Ljava_time_Clock$ = new $TypeData().initClass($c_Ljava_time_Clock$, "java.time.Clock$", ({
  Ljava_time_Clock$: 1
}));
export { $d_Ljava_time_Clock$ as $d_Ljava_time_Clock$ };
var $n_Ljava_time_Clock$;
function $m_Ljava_time_Clock$() {
  if ((!$n_Ljava_time_Clock$)) {
    $n_Ljava_time_Clock$ = new $c_Ljava_time_Clock$();
  }
  return $n_Ljava_time_Clock$;
}
export { $m_Ljava_time_Clock$ as $m_Ljava_time_Clock$ };
/** @constructor */
function $c_Ljava_time_Duration$() {
  this.Ljava_time_Duration$__f_ZERO$lzy1 = null;
  this.Ljava_time_Duration$__f_ZERObitmap$1 = false;
}
export { $c_Ljava_time_Duration$ as $c_Ljava_time_Duration$ };
$c_Ljava_time_Duration$.prototype = new $h_O();
$c_Ljava_time_Duration$.prototype.constructor = $c_Ljava_time_Duration$;
/** @constructor */
function $h_Ljava_time_Duration$() {
}
export { $h_Ljava_time_Duration$ as $h_Ljava_time_Duration$ };
$h_Ljava_time_Duration$.prototype = $c_Ljava_time_Duration$.prototype;
$c_Ljava_time_Duration$.prototype.ZERO__Ljava_time_Duration = (function() {
  if ((!this.Ljava_time_Duration$__f_ZERObitmap$1)) {
    this.Ljava_time_Duration$__f_ZERO$lzy1 = new $c_Ljava_time_Duration($L0, 0);
    this.Ljava_time_Duration$__f_ZERObitmap$1 = true;
  }
  return this.Ljava_time_Duration$__f_ZERO$lzy1;
});
$c_Ljava_time_Duration$.prototype.ofSeconds__J__J__Ljava_time_Duration = (function(seconds, nanoAdjustment) {
  var this$2 = $m_RTLong$();
  var lo = this$2.divideImpl__I__I__I__I__I(nanoAdjustment.RTLong__f_lo, nanoAdjustment.RTLong__f_hi, 1000000000, 0);
  var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var hi$1 = nanoAdjustment.RTLong__f_hi;
  if ((hi$1 >= 0)) {
    var $x_1 = true;
  } else {
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(51712, b0);
    var a1b0 = Math.imul(15258, b0);
    var a0b1 = Math.imul(51712, b1);
    var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((((Math.imul(1000000000, hi) + Math.imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var $x_1 = ((lo$2 === nanoAdjustment.RTLong__f_lo) && (hi$2 === nanoAdjustment.RTLong__f_hi));
  }
  if ($x_1) {
    var b__lo = lo;
    var b__hi = hi;
  } else {
    var lo$3 = (((-1) + lo) | 0);
    var hi$3 = (((((-1) + hi) | 0) + (((lo | (~lo$3)) >>> 31) | 0)) | 0);
    var b__lo = lo$3;
    var b__hi = hi$3;
  }
  var this$8 = $m_jl_Math$();
  var alo = seconds.RTLong__f_lo;
  var blo = b__lo;
  var lo$4 = ((alo + blo) | 0);
  var hi$4 = ((((seconds.RTLong__f_hi + b__hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo$4))) >>> 31) | 0)) | 0);
  var hi$5 = (hi$4 ^ seconds.RTLong__f_hi);
  var hi$6 = (hi$4 ^ b__hi);
  var hi$7 = (hi$5 & hi$6);
  if ((hi$7 < 0)) {
    this$8.java$lang$Math$$longOverflow__E();
  }
  var this$15 = $m_RTLong$();
  var lo$8 = this$15.remainderImpl__I__I__I__I__I(nanoAdjustment.RTLong__f_lo, nanoAdjustment.RTLong__f_hi, 1000000000, 0);
  var hi$8 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var hi$9 = nanoAdjustment.RTLong__f_hi;
  if (((hi$9 >= 0) || ((lo$8 === 0) && (hi$8 === 0)))) {
    var a__lo = lo$8;
    var a__hi = hi$8;
  } else {
    var lo$10 = ((1000000000 + lo$8) | 0);
    var hi$10 = ((hi$8 + (((lo$8 & (~lo$10)) >>> 31) | 0)) | 0);
    var a__lo = lo$10;
    var a__hi = hi$10;
  }
  var nos = a__lo;
  return this.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(lo$4, hi$4), nos);
});
$c_Ljava_time_Duration$.prototype.ofNanos__J__Ljava_time_Duration = (function(nanos) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var secs__lo = lo;
  var secs__hi = hi;
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
  var nos = lo$1;
  if ((nos < 0)) {
    nos = ((1000000000 + nos) | 0);
    var b__lo = secs__lo;
    var b__hi = secs__hi;
    var blo = b__lo;
    var lo$2 = (((-1) + blo) | 0);
    var hi$2 = (((((-1) + b__hi) | 0) + (((blo | (~lo$2)) >>> 31) | 0)) | 0);
    var $x_1__lo = lo$2;
    var $x_1__hi = hi$2;
    secs__lo = $x_1__lo;
    secs__hi = $x_1__hi;
  }
  return this.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(secs__lo, secs__hi), nos);
});
$c_Ljava_time_Duration$.prototype.java$time$Duration$$$create__J__I__Ljava_time_Duration = (function(seconds, nanoAdjustment) {
  var hi = (nanoAdjustment >> 31);
  var lo = (seconds.RTLong__f_lo | nanoAdjustment);
  var hi$1 = (seconds.RTLong__f_hi | hi);
  if (((lo === 0) && (hi$1 === 0))) {
    return this.ZERO__Ljava_time_Duration();
  } else {
    return new $c_Ljava_time_Duration(seconds, nanoAdjustment);
  }
});
var $d_Ljava_time_Duration$ = new $TypeData().initClass($c_Ljava_time_Duration$, "java.time.Duration$", ({
  Ljava_time_Duration$: 1
}));
export { $d_Ljava_time_Duration$ as $d_Ljava_time_Duration$ };
var $n_Ljava_time_Duration$;
function $m_Ljava_time_Duration$() {
  if ((!$n_Ljava_time_Duration$)) {
    $n_Ljava_time_Duration$ = new $c_Ljava_time_Duration$();
  }
  return $n_Ljava_time_Duration$;
}
export { $m_Ljava_time_Duration$ as $m_Ljava_time_Duration$ };
/** @constructor */
function $c_Ljava_time_Instant$() {
  this.Ljava_time_Instant$__f_EPOCH$lzy1 = null;
  this.Ljava_time_Instant$__f_EPOCHbitmap$1 = false;
}
export { $c_Ljava_time_Instant$ as $c_Ljava_time_Instant$ };
$c_Ljava_time_Instant$.prototype = new $h_O();
$c_Ljava_time_Instant$.prototype.constructor = $c_Ljava_time_Instant$;
/** @constructor */
function $h_Ljava_time_Instant$() {
}
export { $h_Ljava_time_Instant$ as $h_Ljava_time_Instant$ };
$h_Ljava_time_Instant$.prototype = $c_Ljava_time_Instant$.prototype;
$c_Ljava_time_Instant$.prototype.EPOCH__Ljava_time_Instant = (function() {
  if ((!this.Ljava_time_Instant$__f_EPOCHbitmap$1)) {
    this.Ljava_time_Instant$__f_EPOCH$lzy1 = new $c_Ljava_time_Instant($L0, 0);
    this.Ljava_time_Instant$__f_EPOCHbitmap$1 = true;
  }
  return this.Ljava_time_Instant$__f_EPOCH$lzy1;
});
$c_Ljava_time_Instant$.prototype.ofEpochSecond__J__J__Ljava_time_Instant = (function(epochSecond, nanoAdjustment) {
  var this$2 = $m_RTLong$();
  var lo = this$2.divideImpl__I__I__I__I__I(nanoAdjustment.RTLong__f_lo, nanoAdjustment.RTLong__f_hi, 1000000000, 0);
  var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var hi$1 = nanoAdjustment.RTLong__f_hi;
  if ((hi$1 >= 0)) {
    var $x_1 = true;
  } else {
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(51712, b0);
    var a1b0 = Math.imul(15258, b0);
    var a0b1 = Math.imul(51712, b1);
    var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((((Math.imul(1000000000, hi) + Math.imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var $x_1 = ((lo$2 === nanoAdjustment.RTLong__f_lo) && (hi$2 === nanoAdjustment.RTLong__f_hi));
  }
  if ($x_1) {
    var b__lo = lo;
    var b__hi = hi;
  } else {
    var lo$3 = (((-1) + lo) | 0);
    var hi$3 = (((((-1) + hi) | 0) + (((lo | (~lo$3)) >>> 31) | 0)) | 0);
    var b__lo = lo$3;
    var b__hi = hi$3;
  }
  var this$8 = $m_jl_Math$();
  var alo = epochSecond.RTLong__f_lo;
  var blo = b__lo;
  var lo$4 = ((alo + blo) | 0);
  var hi$4 = ((((epochSecond.RTLong__f_hi + b__hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo$4))) >>> 31) | 0)) | 0);
  var hi$5 = (hi$4 ^ epochSecond.RTLong__f_hi);
  var hi$6 = (hi$4 ^ b__hi);
  var hi$7 = (hi$5 & hi$6);
  if ((hi$7 < 0)) {
    this$8.java$lang$Math$$longOverflow__E();
  }
  var this$15 = $m_RTLong$();
  var lo$8 = this$15.remainderImpl__I__I__I__I__I(nanoAdjustment.RTLong__f_lo, nanoAdjustment.RTLong__f_hi, 1000000000, 0);
  var hi$8 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var hi$9 = nanoAdjustment.RTLong__f_hi;
  if (((hi$9 >= 0) || ((lo$8 === 0) && (hi$8 === 0)))) {
    var a__lo = lo$8;
    var a__hi = hi$8;
  } else {
    var lo$10 = ((1000000000 + lo$8) | 0);
    var hi$10 = ((hi$8 + (((lo$8 & (~lo$10)) >>> 31) | 0)) | 0);
    var a__lo = lo$10;
    var a__hi = hi$10;
  }
  var nos = a__lo;
  return this.java$time$Instant$$$create__J__I__Ljava_time_Instant(new $c_RTLong(lo$4, hi$4), nos);
});
$c_Ljava_time_Instant$.prototype.ofEpochMilli__J__Ljava_time_Instant = (function(epochMilli) {
  var this$2 = $m_RTLong$();
  var lo = this$2.divideImpl__I__I__I__I__I(epochMilli.RTLong__f_lo, epochMilli.RTLong__f_hi, 1000, 0);
  var hi = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var hi$1 = epochMilli.RTLong__f_hi;
  if ((hi$1 >= 0)) {
    var $x_1 = true;
  } else {
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(1000, b0);
    var a0b1 = Math.imul(1000, b1);
    var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((Math.imul(1000, hi) + ((c1part >>> 16) | 0)) | 0);
    var $x_1 = ((lo$2 === epochMilli.RTLong__f_lo) && (hi$2 === epochMilli.RTLong__f_hi));
  }
  if ($x_1) {
    var secs__lo = lo;
    var secs__hi = hi;
  } else {
    var lo$3 = (((-1) + lo) | 0);
    var hi$3 = (((((-1) + hi) | 0) + (((lo | (~lo$3)) >>> 31) | 0)) | 0);
    var secs__lo = lo$3;
    var secs__hi = hi$3;
  }
  var this$9 = $m_RTLong$();
  var lo$4 = this$9.remainderImpl__I__I__I__I__I(epochMilli.RTLong__f_lo, epochMilli.RTLong__f_hi, 1000, 0);
  var hi$4 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var hi$5 = epochMilli.RTLong__f_hi;
  if (((hi$5 >= 0) || ((lo$4 === 0) && (hi$4 === 0)))) {
    var a__lo = lo$4;
    var a__hi = hi$4;
  } else {
    var lo$6 = ((1000 + lo$4) | 0);
    var hi$6 = ((hi$4 + (((lo$4 & (~lo$6)) >>> 31) | 0)) | 0);
    var a__lo = lo$6;
    var a__hi = hi$6;
  }
  var mos = a__lo;
  return this.java$time$Instant$$$create__J__I__Ljava_time_Instant(new $c_RTLong(secs__lo, secs__hi), Math.imul(1000000, mos));
});
$c_Ljava_time_Instant$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant = (function(temporal) {
  try {
    var t = temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var nanoOfSecond = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var $x_2 = $m_Ljava_time_Instant$();
    var $x_1 = new $c_RTLong(lo, hi);
    var hi$1 = (nanoOfSecond >> 31);
    return $x_2.ofEpochSecond__J__J__Ljava_time_Instant($x_1, new $c_RTLong(nanoOfSecond, hi$1));
  } catch (e) {
    if ((e instanceof $c_Ljava_time_DateTimeException)) {
      var ex = e;
      throw $ct_Ljava_time_DateTimeException__T__jl_Throwable__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain Instant from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)), ex);
    } else {
      throw e;
    }
  }
});
$c_Ljava_time_Instant$.prototype.java$time$Instant$$$create__J__I__Ljava_time_Instant = (function(seconds, nanoOfSecond) {
  var hi = (nanoOfSecond >> 31);
  var lo = (seconds.RTLong__f_lo | nanoOfSecond);
  var hi$1 = (seconds.RTLong__f_hi | hi);
  if (((lo === 0) && (hi$1 === 0))) {
    return this.EPOCH__Ljava_time_Instant();
  } else {
    var ahi = seconds.RTLong__f_hi;
    if (((ahi === (-7347440)) ? ((seconds.RTLong__f_lo >>> 0) < 342103040) : (ahi < (-7347440)))) {
      var $x_1 = true;
    } else {
      var ahi$1 = seconds.RTLong__f_hi;
      var $x_1 = ((ahi$1 === 7347410) ? ((seconds.RTLong__f_lo >>> 0) > 4204099839) : (ahi$1 > 7347410));
    }
    if ($x_1) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Instant exceeds minimum or maximum instant");
    } else {
      return new $c_Ljava_time_Instant(seconds, nanoOfSecond);
    }
  }
});
var $d_Ljava_time_Instant$ = new $TypeData().initClass($c_Ljava_time_Instant$, "java.time.Instant$", ({
  Ljava_time_Instant$: 1
}));
export { $d_Ljava_time_Instant$ as $d_Ljava_time_Instant$ };
var $n_Ljava_time_Instant$;
function $m_Ljava_time_Instant$() {
  if ((!$n_Ljava_time_Instant$)) {
    $n_Ljava_time_Instant$ = new $c_Ljava_time_Instant$();
  }
  return $n_Ljava_time_Instant$;
}
export { $m_Ljava_time_Instant$ as $m_Ljava_time_Instant$ };
function $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate($thiz, year, month, dayOfMonth) {
  if ((dayOfMonth > 28)) {
    var $x_2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var hi = (year >> 31);
    var $x_1 = (dayOfMonth > month.length__Z__I($x_2.isLeapYear__J__Z(new $c_RTLong(year, hi))));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    if ((dayOfMonth === 29)) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("Invalid date 'February 29' as '" + year) + "' is not a leap year"));
    } else {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (((("Invalid date '" + month.jl_Enum__f__name) + " ") + dayOfMonth) + "'"));
    }
  } else {
    return new $c_Ljava_time_LocalDate(year, month.getValue__I(), dayOfMonth);
  }
}
export { $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate as $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate };
/** @constructor */
function $c_Ljava_time_LocalDate$() {
  this.Ljava_time_LocalDate$__f_MIN$lzy1 = null;
  this.Ljava_time_LocalDate$__f_MINbitmap$1 = false;
  this.Ljava_time_LocalDate$__f_MAX$lzy1 = null;
  this.Ljava_time_LocalDate$__f_MAXbitmap$1 = false;
  this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE = 0;
  this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970 = $L0;
  $n_Ljava_time_LocalDate$ = this;
  this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE = 146097;
  var value = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(5, b0);
  var a0b1 = Math.imul(5, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(5, hi) + ((c1part >>> 16) | 0)) | 0);
  var lo$1 = (((-10957) + lo) | 0);
  var hi$2 = (((((-1) + hi$1) | 0) + (((lo | (~lo$1)) >>> 31) | 0)) | 0);
  this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970 = new $c_RTLong(lo$1, hi$2);
}
export { $c_Ljava_time_LocalDate$ as $c_Ljava_time_LocalDate$ };
$c_Ljava_time_LocalDate$.prototype = new $h_O();
$c_Ljava_time_LocalDate$.prototype.constructor = $c_Ljava_time_LocalDate$;
/** @constructor */
function $h_Ljava_time_LocalDate$() {
}
export { $h_Ljava_time_LocalDate$ as $h_Ljava_time_LocalDate$ };
$h_Ljava_time_LocalDate$.prototype = $c_Ljava_time_LocalDate$.prototype;
$c_Ljava_time_LocalDate$.prototype.MIN__Ljava_time_LocalDate = (function() {
  if ((!this.Ljava_time_LocalDate$__f_MINbitmap$1)) {
    this.Ljava_time_LocalDate$__f_MIN$lzy1 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate($m_Ljava_time_Year$().MIN_VALUE__I(), 1, 1);
    this.Ljava_time_LocalDate$__f_MINbitmap$1 = true;
  }
  return this.Ljava_time_LocalDate$__f_MIN$lzy1;
});
$c_Ljava_time_LocalDate$.prototype.MAX__Ljava_time_LocalDate = (function() {
  if ((!this.Ljava_time_LocalDate$__f_MAXbitmap$1)) {
    this.Ljava_time_LocalDate$__f_MAX$lzy1 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate($m_Ljava_time_Year$().MAX_VALUE__I(), 12, 31);
    this.Ljava_time_LocalDate$__f_MAXbitmap$1 = true;
  }
  return this.Ljava_time_LocalDate$__f_MAX$lzy1;
});
$c_Ljava_time_LocalDate$.prototype.now__Ljava_time_ZoneId__Ljava_time_LocalDate = (function(zone) {
  return this.now__Ljava_time_Clock__Ljava_time_LocalDate($m_Ljava_time_Clock$().system__Ljava_time_ZoneId__Ljava_time_Clock(zone));
});
$c_Ljava_time_LocalDate$.prototype.now__Ljava_time_Clock__Ljava_time_LocalDate = (function(clock) {
  if ((clock === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "clock");
  }
  var $x_1 = $m_Ljava_time_Instant$();
  var value = (+Date.now());
  var this$3 = $m_RTLong$();
  var lo = this$3.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var now = $x_1.ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
  var offset = clock.Ljava_time_Clock$SystemClock__f_zone.getRules__Ljava_time_zone_ZoneRules().getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(now);
  var a = now.Ljava_time_Instant__f_seconds;
  var value$1 = offset.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi$1 = (value$1 >> 31);
  var alo = a.RTLong__f_lo;
  var lo$1 = ((alo + value$1) | 0);
  var hi$2 = ((((a.RTLong__f_hi + hi$1) | 0) + ((((alo & value$1) | ((alo | value$1) & (~lo$1))) >>> 31) | 0)) | 0);
  var this$7 = $m_RTLong$();
  var lo$2 = this$7.divideImpl__I__I__I__I__I(lo$1, hi$2, 86400, 0);
  var hi$3 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((hi$2 >= 0)) {
    var $x_2 = true;
  } else {
    var b0 = (65535 & lo$2);
    var b1 = ((lo$2 >>> 16) | 0);
    var a0b0 = Math.imul(20864, b0);
    var a0b1 = Math.imul(20864, b1);
    var lo$4 = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$4 = ((((((Math.imul(86400, hi$3) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
    var $x_2 = ((lo$4 === lo$1) && (hi$4 === hi$2));
  }
  if ($x_2) {
    var epochDay__lo = lo$2;
    var epochDay__hi = hi$3;
  } else {
    var lo$5 = (((-1) + lo$2) | 0);
    var hi$5 = (((((-1) + hi$3) | 0) + (((lo$2 | (~lo$5)) >>> 31) | 0)) | 0);
    var epochDay__lo = lo$5;
    var epochDay__hi = hi$5;
  }
  return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(epochDay__lo, epochDay__hi));
});
$c_Ljava_time_LocalDate$.prototype.of__I__Ljava_time_Month__I__Ljava_time_LocalDate = (function(year, month, dayOfMonth) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var hi = (year >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
  if ((month === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "month");
  }
  var this$5 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
  var hi$1 = (dayOfMonth >> 31);
  this$5.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(dayOfMonth, hi$1), this$5);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, month, dayOfMonth);
});
$c_Ljava_time_LocalDate$.prototype.of__I__I__I__Ljava_time_LocalDate = (function(year, month, dayOfMonth) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var hi = (year >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
  var this$4 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
  var hi$1 = (month >> 31);
  this$4.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(month, hi$1), this$4);
  var this$6 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
  var hi$2 = (dayOfMonth >> 31);
  this$6.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(dayOfMonth, hi$2), this$6);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, $m_Ljava_time_Month$().of__I__Ljava_time_Month(month), dayOfMonth);
});
$c_Ljava_time_LocalDate$.prototype.ofYearDay__I__I__Ljava_time_LocalDate = (function(year, dayOfYear) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var hi = (year >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
  var this$4 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
  var hi$1 = (dayOfYear >> 31);
  this$4.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(dayOfYear, hi$1), this$4);
  var $x_1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  var hi$2 = (year >> 31);
  var leap = $x_1.isLeapYear__J__Z(new $c_RTLong(year, hi$2));
  if (((dayOfYear === 366) && (!leap))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("Invalid date 'DayOfYear 366' as '" + year) + "' is not a leap year"));
  }
  var moy = $m_Ljava_time_Month$().of__I__Ljava_time_Month(((1 + (((((-1) + dayOfYear) | 0) / 31) | 0)) | 0));
  var monthEnd = (((-1) + ((moy.firstDayOfYear__Z__I(leap) + moy.length__Z__I(leap)) | 0)) | 0);
  if ((dayOfYear > monthEnd)) {
    moy = moy.plus__J__Ljava_time_Month(new $c_RTLong(1, 0));
  }
  var dom = ((1 + ((dayOfYear - moy.firstDayOfYear__Z__I(leap)) | 0)) | 0);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, moy, dom);
});
$c_Ljava_time_LocalDate$.prototype.ofEpochDay__J__Ljava_time_LocalDate = (function(epochDay) {
  var this$1 = $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  this$1.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(epochDay, this$1);
  var b = this.Ljava_time_LocalDate$__f_DAYS_0000_TO_1970;
  var alo = epochDay.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var lo = ((alo + blo) | 0);
  var hi = ((((epochDay.RTLong__f_hi + b.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
  var zeroDay__lo = lo;
  var zeroDay__hi = hi;
  var b$1__lo = zeroDay__lo;
  var b$1__hi = zeroDay__hi;
  var blo$1 = b$1__lo;
  var lo$1 = (((-60) + blo$1) | 0);
  var hi$1 = (((((-1) + b$1__hi) | 0) + (((blo$1 | (~lo$1)) >>> 31) | 0)) | 0);
  var $x_1__lo = lo$1;
  var $x_1__hi = hi$1;
  zeroDay__lo = $x_1__lo;
  zeroDay__hi = $x_1__hi;
  var adjust__lo = 0;
  var adjust__hi = 0;
  var a__lo = zeroDay__lo;
  var a__hi = zeroDay__hi;
  var ahi = a__hi;
  if ((ahi < 0)) {
    var b$2__lo = zeroDay__lo;
    var b$2__hi = zeroDay__hi;
    var blo$2 = b$2__lo;
    var lo$2 = ((1 + blo$2) | 0);
    var hi$2 = ((b$2__hi + (((blo$2 & (~lo$2)) >>> 31) | 0)) | 0);
    var value = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
    var hi$3 = (value >> 31);
    var this$7 = $m_RTLong$();
    var lo$3 = this$7.divideImpl__I__I__I__I__I(lo$2, hi$2, value, hi$3);
    var hi$4 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$4 = (((-1) + lo$3) | 0);
    var hi$5 = (((((-1) + hi$4) | 0) + (((lo$3 | (~lo$4)) >>> 31) | 0)) | 0);
    var b0 = (65535 & lo$4);
    var b1 = ((lo$4 >>> 16) | 0);
    var a0b0 = Math.imul(400, b0);
    var a0b1 = Math.imul(400, b1);
    var lo$5 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$6 = ((Math.imul(400, hi$5) + ((c1part >>> 16) | 0)) | 0);
    var $x_2__lo = lo$5;
    var $x_2__hi = hi$6;
    adjust__lo = $x_2__lo;
    adjust__hi = $x_2__hi;
    var a$1__lo = zeroDay__lo;
    var a$1__hi = zeroDay__hi;
    var lo$6 = ((-lo$4) | 0);
    var hi$7 = ((((-hi$5) | 0) + ((lo$4 | lo$6) >> 31)) | 0);
    var value$1 = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
    var hi$8 = (value$1 >> 31);
    var a0 = (65535 & lo$6);
    var a1 = ((lo$6 >>> 16) | 0);
    var b0$1 = (65535 & value$1);
    var b1$1 = ((value$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0, b0$1);
    var a1b0 = Math.imul(a1, b0$1);
    var a0b1$1 = Math.imul(a0, b1$1);
    var lo$7 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$9 = ((((((((Math.imul(lo$6, hi$8) + Math.imul(hi$7, value$1)) | 0) + Math.imul(a1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
    var alo$1 = a$1__lo;
    var lo$8 = ((alo$1 + lo$7) | 0);
    var hi$10 = ((((a$1__hi + hi$9) | 0) + ((((alo$1 & lo$7) | ((alo$1 | lo$7) & (~lo$8))) >>> 31) | 0)) | 0);
    var $x_3__lo = lo$8;
    var $x_3__hi = hi$10;
    zeroDay__lo = $x_3__lo;
    zeroDay__hi = $x_3__hi;
  }
  var b$3__lo = zeroDay__lo;
  var b$3__hi = zeroDay__hi;
  var blo$3 = b$3__lo;
  var b0$2 = (65535 & blo$3);
  var b1$2 = ((blo$3 >>> 16) | 0);
  var a0b0$2 = Math.imul(400, b0$2);
  var a0b1$2 = Math.imul(400, b1$2);
  var lo$9 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$11 = ((Math.imul(400, b$3__hi) + ((c1part$2 >>> 16) | 0)) | 0);
  var lo$10 = ((591 + lo$9) | 0);
  var hi$12 = ((hi$11 + (((lo$9 & (~lo$10)) >>> 31) | 0)) | 0);
  var value$2 = this.Ljava_time_LocalDate$__f_DAYS_PER_CYCLE;
  var hi$13 = (value$2 >> 31);
  var this$17 = $m_RTLong$();
  var lo$11 = this$17.divideImpl__I__I__I__I__I(lo$10, hi$12, value$2, hi$13);
  var hi$14 = this$17.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var yearEst__lo = lo$11;
  var yearEst__hi = hi$14;
  var a$5__lo = zeroDay__lo;
  var a$5__hi = zeroDay__hi;
  var b$4__lo = yearEst__lo;
  var b$4__hi = yearEst__hi;
  var blo$4 = b$4__lo;
  var b0$3 = (65535 & blo$4);
  var b1$3 = ((blo$4 >>> 16) | 0);
  var a0b0$3 = Math.imul(365, b0$3);
  var a0b1$3 = Math.imul(365, b1$3);
  var lo$12 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$15 = ((Math.imul(365, b$4__hi) + ((c1part$3 >>> 16) | 0)) | 0);
  var a$2__lo = yearEst__lo;
  var a$2__hi = yearEst__hi;
  var this$19 = $m_RTLong$();
  var lo$13 = this$19.divideImpl__I__I__I__I__I(a$2__lo, a$2__hi, 4, 0);
  var hi$16 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$14 = ((lo$12 + lo$13) | 0);
  var hi$17 = ((((hi$15 + hi$16) | 0) + ((((lo$12 & lo$13) | ((lo$12 | lo$13) & (~lo$14))) >>> 31) | 0)) | 0);
  var a$3__lo = yearEst__lo;
  var a$3__hi = yearEst__hi;
  var this$21 = $m_RTLong$();
  var lo$15 = this$21.divideImpl__I__I__I__I__I(a$3__lo, a$3__hi, 100, 0);
  var hi$18 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$16 = ((lo$14 - lo$15) | 0);
  var hi$19 = ((((hi$17 - hi$18) | 0) + ((((~lo$14) & lo$15) | ((~(lo$14 ^ lo$15)) & lo$16)) >> 31)) | 0);
  var a$4__lo = yearEst__lo;
  var a$4__hi = yearEst__hi;
  var this$23 = $m_RTLong$();
  var lo$17 = this$23.divideImpl__I__I__I__I__I(a$4__lo, a$4__hi, 400, 0);
  var hi$20 = this$23.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$18 = ((lo$16 + lo$17) | 0);
  var hi$21 = ((((hi$19 + hi$20) | 0) + ((((lo$16 & lo$17) | ((lo$16 | lo$17) & (~lo$18))) >>> 31) | 0)) | 0);
  var alo$2 = a$5__lo;
  var lo$19 = ((alo$2 - lo$18) | 0);
  var hi$22 = ((((a$5__hi - hi$21) | 0) + ((((~alo$2) & lo$18) | ((~(alo$2 ^ lo$18)) & lo$19)) >> 31)) | 0);
  var doyEst__lo = lo$19;
  var doyEst__hi = hi$22;
  var a$6__lo = doyEst__lo;
  var a$6__hi = doyEst__hi;
  var ahi$1 = a$6__hi;
  if ((ahi$1 < 0)) {
    var b$5__lo = yearEst__lo;
    var b$5__hi = yearEst__hi;
    var blo$5 = b$5__lo;
    var lo$20 = (((-1) + blo$5) | 0);
    var hi$23 = (((((-1) + b$5__hi) | 0) + (((blo$5 | (~lo$20)) >>> 31) | 0)) | 0);
    var $x_4__lo = lo$20;
    var $x_4__hi = hi$23;
    yearEst__lo = $x_4__lo;
    yearEst__hi = $x_4__hi;
    var a$10__lo = zeroDay__lo;
    var a$10__hi = zeroDay__hi;
    var b$6__lo = yearEst__lo;
    var b$6__hi = yearEst__hi;
    var blo$6 = b$6__lo;
    var b0$4 = (65535 & blo$6);
    var b1$4 = ((blo$6 >>> 16) | 0);
    var a0b0$4 = Math.imul(365, b0$4);
    var a0b1$4 = Math.imul(365, b1$4);
    var lo$21 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$24 = ((Math.imul(365, b$6__hi) + ((c1part$4 >>> 16) | 0)) | 0);
    var a$7__lo = yearEst__lo;
    var a$7__hi = yearEst__hi;
    var this$29 = $m_RTLong$();
    var lo$22 = this$29.divideImpl__I__I__I__I__I(a$7__lo, a$7__hi, 4, 0);
    var hi$25 = this$29.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$23 = ((lo$21 + lo$22) | 0);
    var hi$26 = ((((hi$24 + hi$25) | 0) + ((((lo$21 & lo$22) | ((lo$21 | lo$22) & (~lo$23))) >>> 31) | 0)) | 0);
    var a$8__lo = yearEst__lo;
    var a$8__hi = yearEst__hi;
    var this$31 = $m_RTLong$();
    var lo$24 = this$31.divideImpl__I__I__I__I__I(a$8__lo, a$8__hi, 100, 0);
    var hi$27 = this$31.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$25 = ((lo$23 - lo$24) | 0);
    var hi$28 = ((((hi$26 - hi$27) | 0) + ((((~lo$23) & lo$24) | ((~(lo$23 ^ lo$24)) & lo$25)) >> 31)) | 0);
    var a$9__lo = yearEst__lo;
    var a$9__hi = yearEst__hi;
    var this$33 = $m_RTLong$();
    var lo$26 = this$33.divideImpl__I__I__I__I__I(a$9__lo, a$9__hi, 400, 0);
    var hi$29 = this$33.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$27 = ((lo$25 + lo$26) | 0);
    var hi$30 = ((((hi$28 + hi$29) | 0) + ((((lo$25 & lo$26) | ((lo$25 | lo$26) & (~lo$27))) >>> 31) | 0)) | 0);
    var alo$3 = a$10__lo;
    var lo$28 = ((alo$3 - lo$27) | 0);
    var hi$31 = ((((a$10__hi - hi$30) | 0) + ((((~alo$3) & lo$27) | ((~(alo$3 ^ lo$27)) & lo$28)) >> 31)) | 0);
    var $x_5__lo = lo$28;
    var $x_5__hi = hi$31;
    doyEst__lo = $x_5__lo;
    doyEst__hi = $x_5__hi;
  }
  var a$11__lo = yearEst__lo;
  var a$11__hi = yearEst__hi;
  var b$7__lo = adjust__lo;
  var b$7__hi = adjust__hi;
  var alo$4 = a$11__lo;
  var blo$7 = b$7__lo;
  var lo$29 = ((alo$4 + blo$7) | 0);
  var hi$32 = ((((a$11__hi + b$7__hi) | 0) + ((((alo$4 & blo$7) | ((alo$4 | blo$7) & (~lo$29))) >>> 31) | 0)) | 0);
  var $x_6__lo = lo$29;
  var $x_6__hi = hi$32;
  yearEst__lo = $x_6__lo;
  yearEst__hi = $x_6__hi;
  var a$12__lo = doyEst__lo;
  var a$12__hi = doyEst__hi;
  var marchDoy0 = a$12__lo;
  var marchMonth0 = ((((2 + Math.imul(5, marchDoy0)) | 0) / 153) | 0);
  var month = ((1 + ((((2 + marchMonth0) | 0) % 12) | 0)) | 0);
  var dom = ((1 + ((marchDoy0 - ((((5 + Math.imul(306, marchMonth0)) | 0) / 10) | 0)) | 0)) | 0);
  var a$13__lo = yearEst__lo;
  var a$13__hi = yearEst__hi;
  var value$3 = ((marchMonth0 / 10) | 0);
  var hi$33 = (value$3 >> 31);
  var alo$5 = a$13__lo;
  var lo$30 = ((alo$5 + value$3) | 0);
  var hi$34 = ((((a$13__hi + hi$33) | 0) + ((((alo$5 & value$3) | ((alo$5 | value$3) & (~lo$30))) >>> 31) | 0)) | 0);
  var $x_7__lo = lo$30;
  var $x_7__hi = hi$34;
  yearEst__lo = $x_7__lo;
  yearEst__hi = $x_7__hi;
  var this$40 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var value$4__lo = yearEst__lo;
  var value$4__hi = yearEst__hi;
  var year = this$40.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(value$4__lo, value$4__hi), this$40);
  return new $c_Ljava_time_LocalDate(year, month, dom);
});
$c_Ljava_time_LocalDate$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate = (function(temporal) {
  var date = temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery());
  if ((date === null)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalDate from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)));
  }
  return date;
});
$c_Ljava_time_LocalDate$.prototype.java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate = (function(year, month, day) {
  var _day;
  switch (month) {
    case 2: {
      var $x_1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      var hi = (year >> 31);
      if ($x_1.isLeapYear__J__Z(new $c_RTLong(year, hi))) {
        var b = 29;
      } else {
        var b = 28;
      }
      var _day = ((day < b) ? day : b);
      break;
    }
    case 4:
    case 6:
    case 9:
    case 11: {
      var _day = ((day < 30) ? day : 30);
      break;
    }
    default: {
      var _day = day;
    }
  }
  return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, month, _day);
});
var $d_Ljava_time_LocalDate$ = new $TypeData().initClass($c_Ljava_time_LocalDate$, "java.time.LocalDate$", ({
  Ljava_time_LocalDate$: 1
}));
export { $d_Ljava_time_LocalDate$ as $d_Ljava_time_LocalDate$ };
var $n_Ljava_time_LocalDate$;
function $m_Ljava_time_LocalDate$() {
  if ((!$n_Ljava_time_LocalDate$)) {
    $n_Ljava_time_LocalDate$ = new $c_Ljava_time_LocalDate$();
  }
  return $n_Ljava_time_LocalDate$;
}
export { $m_Ljava_time_LocalDate$ as $m_Ljava_time_LocalDate$ };
/** @constructor */
function $c_Ljava_time_LocalDateTime$() {
}
export { $c_Ljava_time_LocalDateTime$ as $c_Ljava_time_LocalDateTime$ };
$c_Ljava_time_LocalDateTime$.prototype = new $h_O();
$c_Ljava_time_LocalDateTime$.prototype.constructor = $c_Ljava_time_LocalDateTime$;
/** @constructor */
function $h_Ljava_time_LocalDateTime$() {
}
export { $h_Ljava_time_LocalDateTime$ as $h_Ljava_time_LocalDateTime$ };
$h_Ljava_time_LocalDateTime$.prototype = $c_Ljava_time_LocalDateTime$.prototype;
$c_Ljava_time_LocalDateTime$.prototype.now__Ljava_time_ZoneId__Ljava_time_LocalDateTime = (function(zone) {
  return this.now__Ljava_time_Clock__Ljava_time_LocalDateTime($m_Ljava_time_Clock$().system__Ljava_time_ZoneId__Ljava_time_Clock(zone));
});
$c_Ljava_time_LocalDateTime$.prototype.now__Ljava_time_Clock__Ljava_time_LocalDateTime = (function(clock) {
  if ((clock === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "clock");
  }
  var $x_1 = $m_Ljava_time_Instant$();
  var value = (+Date.now());
  var this$3 = $m_RTLong$();
  var lo = this$3.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var now = $x_1.ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi));
  var offset = clock.Ljava_time_Clock$SystemClock__f_zone.getRules__Ljava_time_zone_ZoneRules().getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(now);
  return this.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(now.Ljava_time_Instant__f_seconds, now.Ljava_time_Instant__f_nanos, offset);
});
$c_Ljava_time_LocalDateTime$.prototype.of__I__I__I__I__I__I__I__Ljava_time_LocalDateTime = (function(year, month, dayOfMonth, hour, minute, second, nanoOfSecond) {
  var date = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, month, dayOfMonth);
  var time = $m_Ljava_time_LocalTime$().of__I__I__I__I__Ljava_time_LocalTime(hour, minute, second, nanoOfSecond);
  return new $c_Ljava_time_LocalDateTime(date, time);
});
$c_Ljava_time_LocalDateTime$.prototype.of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime = (function(date, time) {
  if ((date === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "date");
  }
  if ((time === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "time");
  }
  return new $c_Ljava_time_LocalDateTime(date, time);
});
$c_Ljava_time_LocalDateTime$.prototype.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_LocalDateTime = (function(instant, zone) {
  if ((instant === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "instant");
  }
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone");
  }
  var rules = zone.getRules__Ljava_time_zone_ZoneRules();
  var offset = rules.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(instant);
  return this.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(instant.Ljava_time_Instant__f_seconds, instant.Ljava_time_Instant__f_nanos, offset);
});
$c_Ljava_time_LocalDateTime$.prototype.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime = (function(epochSecond, nanoOfSecond, offset) {
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset");
  }
  var value = offset.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  var alo = epochSecond.RTLong__f_lo;
  var lo = ((alo + value) | 0);
  var hi$1 = ((((epochSecond.RTLong__f_hi + hi) | 0) + ((((alo & value) | ((alo | value) & (~lo))) >>> 31) | 0)) | 0);
  var this$5 = $m_RTLong$();
  var lo$1 = this$5.divideImpl__I__I__I__I__I(lo, hi$1, 86400, 0);
  var hi$2 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((hi$1 >= 0)) {
    var $x_1 = true;
  } else {
    var b0 = (65535 & lo$1);
    var b1 = ((lo$1 >>> 16) | 0);
    var a0b0 = Math.imul(20864, b0);
    var a0b1 = Math.imul(20864, b1);
    var lo$3 = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$3 = ((((((Math.imul(86400, hi$2) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
    var $x_1 = ((lo$3 === lo) && (hi$3 === hi$1));
  }
  if ($x_1) {
    var localEpochDay__lo = lo$1;
    var localEpochDay__hi = hi$2;
  } else {
    var lo$4 = (((-1) + lo$1) | 0);
    var hi$4 = (((((-1) + hi$2) | 0) + (((lo$1 | (~lo$4)) >>> 31) | 0)) | 0);
    var localEpochDay__lo = lo$4;
    var localEpochDay__hi = hi$4;
  }
  var this$12 = $m_RTLong$();
  var lo$5 = this$12.remainderImpl__I__I__I__I__I(lo, hi$1, 86400, 0);
  var hi$5 = this$12.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((hi$1 >= 0) || ((lo$5 === 0) && (hi$5 === 0)))) {
    var a__lo = lo$5;
    var a__hi = hi$5;
  } else {
    var lo$7 = ((86400 + lo$5) | 0);
    var hi$6 = ((hi$5 + (((lo$5 & (~lo$7)) >>> 31) | 0)) | 0);
    var a__lo = lo$7;
    var a__hi = hi$6;
  }
  var secsOfDay = a__lo;
  var date = $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(localEpochDay__lo, localEpochDay__hi));
  var $x_2 = $m_Ljava_time_LocalTime$();
  var hi$7 = (secsOfDay >> 31);
  var time = $x_2.ofSecondOfDay__J__I__Ljava_time_LocalTime(new $c_RTLong(secsOfDay, hi$7), nanoOfSecond);
  return new $c_Ljava_time_LocalDateTime(date, time);
});
$c_Ljava_time_LocalDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_LocalDateTime)) {
    return temporal;
  } else if ((temporal instanceof $c_Ljava_time_ZonedDateTime)) {
    return temporal.Ljava_time_ZonedDateTime__f_dateTime;
  } else {
    try {
      var date = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal);
      var time = $m_Ljava_time_LocalTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(temporal);
      return new $c_Ljava_time_LocalDateTime(date, time);
    } catch (e) {
      if ((e instanceof $c_Ljava_time_DateTimeException)) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalDateTime from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)));
      } else {
        throw e;
      }
    }
  }
});
$c_Ljava_time_LocalDateTime$.prototype.parse__jl_CharSequence__Ljava_time_format_DateTimeFormatter__Ljava_time_LocalDateTime = (function(text, formatter) {
  if ((formatter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "formatter");
  }
  return formatter.parse__jl_CharSequence__Ljava_time_temporal_TemporalQuery__O(text, new $c_Ljava_time_LocalDateTime$$anon$1(this));
});
var $d_Ljava_time_LocalDateTime$ = new $TypeData().initClass($c_Ljava_time_LocalDateTime$, "java.time.LocalDateTime$", ({
  Ljava_time_LocalDateTime$: 1
}));
export { $d_Ljava_time_LocalDateTime$ as $d_Ljava_time_LocalDateTime$ };
var $n_Ljava_time_LocalDateTime$;
function $m_Ljava_time_LocalDateTime$() {
  if ((!$n_Ljava_time_LocalDateTime$)) {
    $n_Ljava_time_LocalDateTime$ = new $c_Ljava_time_LocalDateTime$();
  }
  return $n_Ljava_time_LocalDateTime$;
}
export { $m_Ljava_time_LocalDateTime$ as $m_Ljava_time_LocalDateTime$ };
function $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime($thiz) {
  if ((!$thiz.Ljava_time_LocalTime$__f_HOURSbitmap$1)) {
    var dimensions = new $ac_I(new Int32Array([24]));
    var hours = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_LocalTime.getClassOf(), dimensions);
    var i = 0;
    while ((i < hours.u.length)) {
      hours.u[i] = new $c_Ljava_time_LocalTime(i, 0, 0, 0);
      i = ((1 + i) | 0);
    }
    $thiz.Ljava_time_LocalTime$__f_HOURS$lzy1 = hours;
    $thiz.Ljava_time_LocalTime$__f_HOURSbitmap$1 = true;
  }
  return $thiz.Ljava_time_LocalTime$__f_HOURS$lzy1;
}
export { $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime as $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime };
/** @constructor */
function $c_Ljava_time_LocalTime$() {
  this.Ljava_time_LocalTime$__f_HOURS$lzy1 = null;
  this.Ljava_time_LocalTime$__f_HOURSbitmap$1 = false;
}
export { $c_Ljava_time_LocalTime$ as $c_Ljava_time_LocalTime$ };
$c_Ljava_time_LocalTime$.prototype = new $h_O();
$c_Ljava_time_LocalTime$.prototype.constructor = $c_Ljava_time_LocalTime$;
/** @constructor */
function $h_Ljava_time_LocalTime$() {
}
export { $h_Ljava_time_LocalTime$ as $h_Ljava_time_LocalTime$ };
$h_Ljava_time_LocalTime$.prototype = $c_Ljava_time_LocalTime$.prototype;
$c_Ljava_time_LocalTime$.prototype.of__I__I__Ljava_time_LocalTime = (function(hour, minute) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  var hi = (hour >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
  if ((minute === 0)) {
    return $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this).u[hour];
  } else {
    var this$4 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var hi$1 = (minute >> 31);
    this$4.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi$1), this$4);
    return new $c_Ljava_time_LocalTime(hour, minute, 0, 0);
  }
});
$c_Ljava_time_LocalTime$.prototype.of__I__I__I__Ljava_time_LocalTime = (function(hour, minute, second) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  var hi = (hour >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
  if (((minute | second) === 0)) {
    return $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this).u[hour];
  }
  var this$4 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
  var hi$1 = (minute >> 31);
  this$4.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi$1), this$4);
  var this$6 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
  var hi$2 = (second >> 31);
  this$6.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(second, hi$2), this$6);
  return new $c_Ljava_time_LocalTime(hour, minute, second, 0);
});
$c_Ljava_time_LocalTime$.prototype.of__I__I__I__I__Ljava_time_LocalTime = (function(hour, minute, second, nanoOfSecond) {
  var this$2 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  var hi = (hour >> 31);
  this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
  var this$4 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
  var hi$1 = (minute >> 31);
  this$4.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi$1), this$4);
  var this$6 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
  var hi$2 = (second >> 31);
  this$6.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(second, hi$2), this$6);
  var this$8 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var hi$3 = (nanoOfSecond >> 31);
  this$8.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(nanoOfSecond, hi$3), this$8);
  return this.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(hour, minute, second, nanoOfSecond);
});
$c_Ljava_time_LocalTime$.prototype.ofSecondOfDay__J__Ljava_time_LocalTime = (function(secondOfDay) {
  var lo = secondOfDay.RTLong__f_lo;
  var hi = secondOfDay.RTLong__f_hi;
  var _secondOfDay__lo = lo;
  var _secondOfDay__hi = hi;
  var this$1 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  var value__lo = _secondOfDay__lo;
  var value__hi = _secondOfDay__hi;
  this$1.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value__lo, value__hi), this$1);
  var a__lo = _secondOfDay__lo;
  var a__hi = _secondOfDay__hi;
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.divideImpl__I__I__I__I__I(a__lo, a__hi, 3600, 0);
  var a$1__lo = _secondOfDay__lo;
  var a$1__hi = _secondOfDay__hi;
  var value$1 = Math.imul(3600, lo$1);
  var hi$2 = (value$1 >> 31);
  var alo = a$1__lo;
  var lo$2 = ((alo - value$1) | 0);
  var hi$3 = ((((a$1__hi - hi$2) | 0) + ((((~alo) & value$1) | ((~(alo ^ value$1)) & lo$2)) >> 31)) | 0);
  var $x_1__lo = lo$2;
  var $x_1__hi = hi$3;
  _secondOfDay__lo = $x_1__lo;
  _secondOfDay__hi = $x_1__hi;
  var a$2__lo = _secondOfDay__lo;
  var a$2__hi = _secondOfDay__hi;
  var this$6 = $m_RTLong$();
  var lo$3 = this$6.divideImpl__I__I__I__I__I(a$2__lo, a$2__hi, 60, 0);
  var a$3__lo = _secondOfDay__lo;
  var a$3__hi = _secondOfDay__hi;
  var value$2 = Math.imul(60, lo$3);
  var hi$5 = (value$2 >> 31);
  var alo$1 = a$3__lo;
  var lo$4 = ((alo$1 - value$2) | 0);
  var hi$6 = ((((a$3__hi - hi$5) | 0) + ((((~alo$1) & value$2) | ((~(alo$1 ^ value$2)) & lo$4)) >> 31)) | 0);
  var $x_2__lo = lo$4;
  var $x_2__hi = hi$6;
  _secondOfDay__lo = $x_2__lo;
  _secondOfDay__hi = $x_2__hi;
  var a$4__lo = _secondOfDay__lo;
  var a$4__hi = _secondOfDay__hi;
  return this.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(lo$1, lo$3, a$4__lo, 0);
});
$c_Ljava_time_LocalTime$.prototype.ofSecondOfDay__J__I__Ljava_time_LocalTime = (function(secondOfDay, nanoOfSecond) {
  var lo = secondOfDay.RTLong__f_lo;
  var hi = secondOfDay.RTLong__f_hi;
  var _secondOfDay__lo = lo;
  var _secondOfDay__hi = hi;
  var this$1 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  var value__lo = _secondOfDay__lo;
  var value__hi = _secondOfDay__hi;
  this$1.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value__lo, value__hi), this$1);
  var this$3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var hi$1 = (nanoOfSecond >> 31);
  this$3.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(nanoOfSecond, hi$1), this$3);
  var a__lo = _secondOfDay__lo;
  var a__hi = _secondOfDay__hi;
  var this$4 = $m_RTLong$();
  var lo$1 = this$4.divideImpl__I__I__I__I__I(a__lo, a__hi, 3600, 0);
  var a$1__lo = _secondOfDay__lo;
  var a$1__hi = _secondOfDay__hi;
  var value$1 = Math.imul(3600, lo$1);
  var hi$3 = (value$1 >> 31);
  var alo = a$1__lo;
  var lo$2 = ((alo - value$1) | 0);
  var hi$4 = ((((a$1__hi - hi$3) | 0) + ((((~alo) & value$1) | ((~(alo ^ value$1)) & lo$2)) >> 31)) | 0);
  var $x_1__lo = lo$2;
  var $x_1__hi = hi$4;
  _secondOfDay__lo = $x_1__lo;
  _secondOfDay__hi = $x_1__hi;
  var a$2__lo = _secondOfDay__lo;
  var a$2__hi = _secondOfDay__hi;
  var this$8 = $m_RTLong$();
  var lo$3 = this$8.divideImpl__I__I__I__I__I(a$2__lo, a$2__hi, 60, 0);
  var a$3__lo = _secondOfDay__lo;
  var a$3__hi = _secondOfDay__hi;
  var value$2 = Math.imul(60, lo$3);
  var hi$6 = (value$2 >> 31);
  var alo$1 = a$3__lo;
  var lo$4 = ((alo$1 - value$2) | 0);
  var hi$7 = ((((a$3__hi - hi$6) | 0) + ((((~alo$1) & value$2) | ((~(alo$1 ^ value$2)) & lo$4)) >> 31)) | 0);
  var $x_2__lo = lo$4;
  var $x_2__hi = hi$7;
  _secondOfDay__lo = $x_2__lo;
  _secondOfDay__hi = $x_2__hi;
  var a$4__lo = _secondOfDay__lo;
  var a$4__hi = _secondOfDay__hi;
  return this.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(lo$1, lo$3, a$4__lo, nanoOfSecond);
});
$c_Ljava_time_LocalTime$.prototype.ofNanoOfDay__J__Ljava_time_LocalTime = (function(nanoOfDay) {
  var lo = nanoOfDay.RTLong__f_lo;
  var hi = nanoOfDay.RTLong__f_hi;
  var _nanoOfDay__lo = lo;
  var _nanoOfDay__hi = hi;
  var this$1 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  var value__lo = _nanoOfDay__lo;
  var value__hi = _nanoOfDay__hi;
  this$1.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value__lo, value__hi), this$1);
  var a__lo = _nanoOfDay__lo;
  var a__hi = _nanoOfDay__hi;
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.divideImpl__I__I__I__I__I(a__lo, a__hi, 817405952, 838);
  var a$1__lo = _nanoOfDay__lo;
  var a$1__hi = _nanoOfDay__hi;
  var hi$2 = (lo$1 >> 31);
  var b0 = (65535 & lo$1);
  var b1 = ((lo$1 >>> 16) | 0);
  var a0b0 = Math.imul(40960, b0);
  var a1b0 = Math.imul(12472, b0);
  var a0b1 = Math.imul(40960, b1);
  var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$3 = ((((((((Math.imul(817405952, hi$2) + Math.imul(838, lo$1)) | 0) + Math.imul(12472, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var alo = a$1__lo;
  var lo$3 = ((alo - lo$2) | 0);
  var hi$4 = ((((a$1__hi - hi$3) | 0) + ((((~alo) & lo$2) | ((~(alo ^ lo$2)) & lo$3)) >> 31)) | 0);
  var $x_1__lo = lo$3;
  var $x_1__hi = hi$4;
  _nanoOfDay__lo = $x_1__lo;
  _nanoOfDay__hi = $x_1__hi;
  var a$2__lo = _nanoOfDay__lo;
  var a$2__hi = _nanoOfDay__hi;
  var this$7 = $m_RTLong$();
  var lo$4 = this$7.divideImpl__I__I__I__I__I(a$2__lo, a$2__hi, (-129542144), 13);
  var a$3__lo = _nanoOfDay__lo;
  var a$3__hi = _nanoOfDay__hi;
  var hi$6 = (lo$4 >> 31);
  var b0$1 = (65535 & lo$4);
  var b1$1 = ((lo$4 >>> 16) | 0);
  var a0b0$1 = Math.imul(22528, b0$1);
  var a1b0$1 = Math.imul(63559, b0$1);
  var a0b1$1 = Math.imul(22528, b1$1);
  var lo$5 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$7 = ((((((((Math.imul((-129542144), hi$6) + Math.imul(13, lo$4)) | 0) + Math.imul(63559, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var alo$1 = a$3__lo;
  var lo$6 = ((alo$1 - lo$5) | 0);
  var hi$8 = ((((a$3__hi - hi$7) | 0) + ((((~alo$1) & lo$5) | ((~(alo$1 ^ lo$5)) & lo$6)) >> 31)) | 0);
  var $x_2__lo = lo$6;
  var $x_2__hi = hi$8;
  _nanoOfDay__lo = $x_2__lo;
  _nanoOfDay__hi = $x_2__hi;
  var a$4__lo = _nanoOfDay__lo;
  var a$4__hi = _nanoOfDay__hi;
  var this$12 = $m_RTLong$();
  var lo$7 = this$12.divideImpl__I__I__I__I__I(a$4__lo, a$4__hi, 1000000000, 0);
  var a$5__lo = _nanoOfDay__lo;
  var a$5__hi = _nanoOfDay__hi;
  var hi$10 = (lo$7 >> 31);
  var b0$2 = (65535 & lo$7);
  var b1$2 = ((lo$7 >>> 16) | 0);
  var a0b0$2 = Math.imul(51712, b0$2);
  var a1b0$2 = Math.imul(15258, b0$2);
  var a0b1$2 = Math.imul(51712, b1$2);
  var lo$8 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$11 = ((((((Math.imul(1000000000, hi$10) + Math.imul(15258, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var alo$2 = a$5__lo;
  var lo$9 = ((alo$2 - lo$8) | 0);
  var hi$12 = ((((a$5__hi - hi$11) | 0) + ((((~alo$2) & lo$8) | ((~(alo$2 ^ lo$8)) & lo$9)) >> 31)) | 0);
  var $x_3__lo = lo$9;
  var $x_3__hi = hi$12;
  _nanoOfDay__lo = $x_3__lo;
  _nanoOfDay__hi = $x_3__hi;
  var a$6__lo = _nanoOfDay__lo;
  var a$6__hi = _nanoOfDay__hi;
  return this.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(lo$1, lo$4, lo$7, a$6__lo);
});
$c_Ljava_time_LocalTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime = (function(temporal) {
  var time = temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery());
  if ((time === null)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalTime from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)));
  } else {
    return time;
  }
});
$c_Ljava_time_LocalTime$.prototype.java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime = (function(hour, minute, second, nanoOfSecond) {
  return ((((minute | second) | nanoOfSecond) === 0) ? $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this).u[hour] : new $c_Ljava_time_LocalTime(hour, minute, second, nanoOfSecond));
});
var $d_Ljava_time_LocalTime$ = new $TypeData().initClass($c_Ljava_time_LocalTime$, "java.time.LocalTime$", ({
  Ljava_time_LocalTime$: 1
}));
export { $d_Ljava_time_LocalTime$ as $d_Ljava_time_LocalTime$ };
var $n_Ljava_time_LocalTime$;
function $m_Ljava_time_LocalTime$() {
  if ((!$n_Ljava_time_LocalTime$)) {
    $n_Ljava_time_LocalTime$ = new $c_Ljava_time_LocalTime$();
  }
  return $n_Ljava_time_LocalTime$;
}
export { $m_Ljava_time_LocalTime$ as $m_Ljava_time_LocalTime$ };
/** @constructor */
function $c_Ljava_time_OffsetDateTime$() {
}
export { $c_Ljava_time_OffsetDateTime$ as $c_Ljava_time_OffsetDateTime$ };
$c_Ljava_time_OffsetDateTime$.prototype = new $h_O();
$c_Ljava_time_OffsetDateTime$.prototype.constructor = $c_Ljava_time_OffsetDateTime$;
/** @constructor */
function $h_Ljava_time_OffsetDateTime$() {
}
export { $h_Ljava_time_OffsetDateTime$ as $h_Ljava_time_OffsetDateTime$ };
$h_Ljava_time_OffsetDateTime$.prototype = $c_Ljava_time_OffsetDateTime$.prototype;
$c_Ljava_time_OffsetDateTime$.prototype.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime = (function(instant, zone) {
  if ((instant === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "instant");
  }
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone");
  }
  var rules = zone.getRules__Ljava_time_zone_ZoneRules();
  var offset = rules.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(instant);
  var ldt = $m_Ljava_time_LocalDateTime$().ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(instant.Ljava_time_Instant__f_seconds, instant.Ljava_time_Instant__f_nanos, offset);
  return new $c_Ljava_time_OffsetDateTime(ldt, offset);
});
$c_Ljava_time_OffsetDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_OffsetDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_OffsetDateTime)) {
    return temporal;
  } else {
    try {
      var offset = $m_Ljava_time_ZoneOffset$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset(temporal);
      try {
        var ldt = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(temporal);
        return new $c_Ljava_time_OffsetDateTime(ldt, offset);
      } catch (e) {
        if ((e instanceof $c_Ljava_time_DateTimeException)) {
          var instant = $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(temporal);
          return $m_Ljava_time_OffsetDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime(instant, offset);
        } else {
          throw e;
        }
      }
    } catch (e$2) {
      if ((e$2 instanceof $c_Ljava_time_DateTimeException)) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain OffsetDateTime from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)));
      } else {
        throw e$2;
      }
    }
  }
});
var $d_Ljava_time_OffsetDateTime$ = new $TypeData().initClass($c_Ljava_time_OffsetDateTime$, "java.time.OffsetDateTime$", ({
  Ljava_time_OffsetDateTime$: 1
}));
export { $d_Ljava_time_OffsetDateTime$ as $d_Ljava_time_OffsetDateTime$ };
var $n_Ljava_time_OffsetDateTime$;
function $m_Ljava_time_OffsetDateTime$() {
  if ((!$n_Ljava_time_OffsetDateTime$)) {
    $n_Ljava_time_OffsetDateTime$ = new $c_Ljava_time_OffsetDateTime$();
  }
  return $n_Ljava_time_OffsetDateTime$;
}
export { $m_Ljava_time_OffsetDateTime$ as $m_Ljava_time_OffsetDateTime$ };
/** @constructor */
function $c_Ljava_time_Period$() {
  this.Ljava_time_Period$__f_ZERO$lzy1 = null;
  this.Ljava_time_Period$__f_ZERObitmap$1 = false;
}
export { $c_Ljava_time_Period$ as $c_Ljava_time_Period$ };
$c_Ljava_time_Period$.prototype = new $h_O();
$c_Ljava_time_Period$.prototype.constructor = $c_Ljava_time_Period$;
/** @constructor */
function $h_Ljava_time_Period$() {
}
export { $h_Ljava_time_Period$ as $h_Ljava_time_Period$ };
$h_Ljava_time_Period$.prototype = $c_Ljava_time_Period$.prototype;
$c_Ljava_time_Period$.prototype.ZERO__Ljava_time_Period = (function() {
  if ((!this.Ljava_time_Period$__f_ZERObitmap$1)) {
    this.Ljava_time_Period$__f_ZERO$lzy1 = new $c_Ljava_time_Period(0, 0, 0);
    this.Ljava_time_Period$__f_ZERObitmap$1 = true;
  }
  return this.Ljava_time_Period$__f_ZERO$lzy1;
});
$c_Ljava_time_Period$.prototype.java$time$Period$$$create__I__I__I__Ljava_time_Period = (function(years, months, days) {
  return ((((years | months) | days) === 0) ? this.ZERO__Ljava_time_Period() : new $c_Ljava_time_Period(years, months, days));
});
var $d_Ljava_time_Period$ = new $TypeData().initClass($c_Ljava_time_Period$, "java.time.Period$", ({
  Ljava_time_Period$: 1
}));
export { $d_Ljava_time_Period$ as $d_Ljava_time_Period$ };
var $n_Ljava_time_Period$;
function $m_Ljava_time_Period$() {
  if ((!$n_Ljava_time_Period$)) {
    $n_Ljava_time_Period$ = new $c_Ljava_time_Period$();
  }
  return $n_Ljava_time_Period$;
}
export { $m_Ljava_time_Period$ as $m_Ljava_time_Period$ };
/** @constructor */
function $c_Ljava_time_Year$() {
  this.Ljava_time_Year$__f_MIN_VALUE$lzy1 = 0;
  this.Ljava_time_Year$__f_MIN_VALUEbitmap$1 = false;
  this.Ljava_time_Year$__f_MAX_VALUE$lzy1 = 0;
  this.Ljava_time_Year$__f_MAX_VALUEbitmap$1 = false;
}
export { $c_Ljava_time_Year$ as $c_Ljava_time_Year$ };
$c_Ljava_time_Year$.prototype = new $h_O();
$c_Ljava_time_Year$.prototype.constructor = $c_Ljava_time_Year$;
/** @constructor */
function $h_Ljava_time_Year$() {
}
export { $h_Ljava_time_Year$ as $h_Ljava_time_Year$ };
$h_Ljava_time_Year$.prototype = $c_Ljava_time_Year$.prototype;
$c_Ljava_time_Year$.prototype.MIN_VALUE__I = (function() {
  if ((!this.Ljava_time_Year$__f_MIN_VALUEbitmap$1)) {
    this.Ljava_time_Year$__f_MIN_VALUE$lzy1 = (-999999999);
    this.Ljava_time_Year$__f_MIN_VALUEbitmap$1 = true;
  }
  return this.Ljava_time_Year$__f_MIN_VALUE$lzy1;
});
$c_Ljava_time_Year$.prototype.MAX_VALUE__I = (function() {
  if ((!this.Ljava_time_Year$__f_MAX_VALUEbitmap$1)) {
    this.Ljava_time_Year$__f_MAX_VALUE$lzy1 = 999999999;
    this.Ljava_time_Year$__f_MAX_VALUEbitmap$1 = true;
  }
  return this.Ljava_time_Year$__f_MAX_VALUE$lzy1;
});
$c_Ljava_time_Year$.prototype.isLeap__J__Z = (function(year) {
  var lo = (3 & year.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_RTLong$();
    var lo$1 = this$3.remainderImpl__I__I__I__I__I(year.RTLong__f_lo, year.RTLong__f_hi, 100, 0);
    var hi = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if ((!((lo$1 === 0) && (hi === 0)))) {
      return true;
    } else {
      var this$5 = $m_RTLong$();
      var lo$2 = this$5.remainderImpl__I__I__I__I__I(year.RTLong__f_lo, year.RTLong__f_hi, 400, 0);
      var hi$1 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return ((lo$2 === 0) && (hi$1 === 0));
    }
  } else {
    return false;
  }
});
var $d_Ljava_time_Year$ = new $TypeData().initClass($c_Ljava_time_Year$, "java.time.Year$", ({
  Ljava_time_Year$: 1
}));
export { $d_Ljava_time_Year$ as $d_Ljava_time_Year$ };
var $n_Ljava_time_Year$;
function $m_Ljava_time_Year$() {
  if ((!$n_Ljava_time_Year$)) {
    $n_Ljava_time_Year$ = new $c_Ljava_time_Year$();
  }
  return $n_Ljava_time_Year$;
}
export { $m_Ljava_time_Year$ as $m_Ljava_time_Year$ };
/** @constructor */
function $c_Ljava_time_ZoneId$() {
}
export { $c_Ljava_time_ZoneId$ as $c_Ljava_time_ZoneId$ };
$c_Ljava_time_ZoneId$.prototype = new $h_O();
$c_Ljava_time_ZoneId$.prototype.constructor = $c_Ljava_time_ZoneId$;
/** @constructor */
function $h_Ljava_time_ZoneId$() {
}
export { $h_Ljava_time_ZoneId$ as $h_Ljava_time_ZoneId$ };
$h_Ljava_time_ZoneId$.prototype = $c_Ljava_time_ZoneId$.prototype;
$c_Ljava_time_ZoneId$.prototype.of__T__Ljava_time_ZoneId = (function(zoneId) {
  if ((zoneId === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId");
  }
  if ((zoneId === "Z")) {
    return $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
  } else if ((zoneId.length === 1)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, invalid format: " + zoneId));
  } else if (((!(!zoneId.startsWith("+"))) || (!(!zoneId.startsWith("-"))))) {
    return $m_Ljava_time_ZoneOffset$().of__T__Ljava_time_ZoneOffset(zoneId);
  } else if ((((zoneId === "UTC") || (zoneId === "GMT")) || (zoneId === "UT"))) {
    var this$2 = $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
    return new $c_Ljava_time_ZoneRegion(zoneId, $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$2));
  } else if (((((!(!zoneId.startsWith("UTC+"))) || (!(!zoneId.startsWith("GMT+")))) || (!(!zoneId.startsWith("UTC-")))) || (!(!zoneId.startsWith("GMT-"))))) {
    var offset = $m_Ljava_time_ZoneOffset$().of__T__Ljava_time_ZoneOffset(zoneId.substring(3));
    return ((offset.Ljava_time_ZoneOffset__f_totalSeconds === 0) ? new $c_Ljava_time_ZoneRegion(zoneId.substring(0, 3), $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset)) : new $c_Ljava_time_ZoneRegion((("" + zoneId.substring(0, 3)) + offset.Ljava_time_ZoneOffset__f_id), $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset)));
  } else if (((!(!zoneId.startsWith("UT+"))) || (!(!zoneId.startsWith("UT-"))))) {
    var offset$2 = $m_Ljava_time_ZoneOffset$().of__T__Ljava_time_ZoneOffset(zoneId.substring(2));
    return ((offset$2.Ljava_time_ZoneOffset__f_totalSeconds === 0) ? new $c_Ljava_time_ZoneRegion("UT", $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset$2)) : new $c_Ljava_time_ZoneRegion(("UT" + offset$2.Ljava_time_ZoneOffset__f_id), $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset$2)));
  } else {
    return $m_Ljava_time_ZoneRegion$().ofId__T__Z__Ljava_time_ZoneRegion(zoneId, true);
  }
});
$c_Ljava_time_ZoneId$.prototype.ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId = (function(prefix, offset) {
  if ((prefix === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "prefix");
  }
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset");
  }
  if ((prefix.length === 0)) {
    return offset;
  }
  if ((((prefix === "GMT") || (prefix === "UTC")) || (prefix === "UT"))) {
    if ((offset.Ljava_time_ZoneOffset__f_totalSeconds === 0)) {
      return new $c_Ljava_time_ZoneRegion(prefix, $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset));
    }
    return new $c_Ljava_time_ZoneRegion((("" + prefix) + offset.Ljava_time_ZoneOffset__f_id), $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(offset));
  }
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid prefix, must be GMT, UTC or UT: " + prefix));
});
$c_Ljava_time_ZoneId$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId = (function(temporal) {
  var obj = temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery());
  if ((obj === null)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZoneId from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)));
  } else {
    return obj;
  }
});
var $d_Ljava_time_ZoneId$ = new $TypeData().initClass($c_Ljava_time_ZoneId$, "java.time.ZoneId$", ({
  Ljava_time_ZoneId$: 1
}));
export { $d_Ljava_time_ZoneId$ as $d_Ljava_time_ZoneId$ };
var $n_Ljava_time_ZoneId$;
function $m_Ljava_time_ZoneId$() {
  if ((!$n_Ljava_time_ZoneId$)) {
    $n_Ljava_time_ZoneId$ = new $c_Ljava_time_ZoneId$();
  }
  return $n_Ljava_time_ZoneId$;
}
export { $m_Ljava_time_ZoneId$ as $m_Ljava_time_ZoneId$ };
function $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map($thiz) {
  if ((!$thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHEbitmap$1)) {
    $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHE$lzy1 = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHEbitmap$1 = true;
  }
  return $thiz.Ljava_time_ZoneOffset$__f_SECONDS_CACHE$lzy1;
}
export { $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map as $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map };
function $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map($thiz) {
  if ((!$thiz.Ljava_time_ZoneOffset$__f_ID_CACHEbitmap$1)) {
    $thiz.Ljava_time_ZoneOffset$__f_ID_CACHE$lzy1 = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_ZoneOffset$__f_ID_CACHEbitmap$1 = true;
  }
  return $thiz.Ljava_time_ZoneOffset$__f_ID_CACHE$lzy1;
}
export { $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map as $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map };
function $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I($thiz, offsetId, pos, precededByColon) {
  if ((precededByColon && ($dp_charAt__I__C(offsetId, (((-1) + pos) | 0)) !== 58))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, colon not found when expected: " + offsetId));
  }
  var ch1 = $dp_charAt__I__C(offsetId, pos);
  var ch2 = $dp_charAt__I__C(offsetId, ((1 + pos) | 0));
  if (((((ch1 < 48) || (ch1 > 57)) || (ch2 < 48)) || (ch2 > 57))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, non numeric characters found: " + offsetId));
  }
  return ((Math.imul(10, (((-48) + ch1) | 0)) + (((-48) + ch2) | 0)) | 0);
}
export { $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I as $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I };
function $p_Ljava_time_ZoneOffset$__validate__I__I__I__V($thiz, hours, minutes, seconds) {
  if (((hours < (-18)) || (hours > 18))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (("Zone offset hours not in valid range: value " + hours) + " is not in the range -18 to 18"));
  }
  if ((hours > 0)) {
    if (((minutes < 0) || (seconds < 0))) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg2$1__T__T($thiz, "positive"));
    }
  } else if ((hours < 0)) {
    if (((minutes > 0) || (seconds > 0))) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg2$1__T__T($thiz, "negative"));
    }
  } else if ((((minutes > 0) && (seconds < 0)) || ((minutes < 0) && (seconds > 0)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Zone offset minutes and seconds must have the same sign");
  }
  var sign = (minutes >> 31);
  if (((((minutes ^ sign) - sign) | 0) > 59)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg$1__I__T__T($thiz, minutes, "minutes"));
  }
  var sign$1 = (seconds >> 31);
  if (((((seconds ^ sign$1) - sign$1) | 0) > 59)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), $p_Ljava_time_ZoneOffset$__msg$1__I__T__T($thiz, minutes, "seconds"));
  }
  var sign$2 = (hours >> 31);
  if (((((hours ^ sign$2) - sign$2) | 0) === 18)) {
    var sign$3 = (minutes >> 31);
    if (((((minutes ^ sign$3) - sign$3) | 0) > 0)) {
      var $x_1 = true;
    } else {
      var sign$4 = (seconds >> 31);
      var $x_1 = ((((seconds ^ sign$4) - sign$4) | 0) > 0);
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Zone offset not in valid range: -18:00 to +18:00");
  }
}
export { $p_Ljava_time_ZoneOffset$__validate__I__I__I__V as $p_Ljava_time_ZoneOffset$__validate__I__I__I__V };
function $p_Ljava_time_ZoneOffset$__totalSeconds__I__I__I__I($thiz, hours, minutes, seconds) {
  return ((((Math.imul(hours, $thiz.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR) + Math.imul(minutes, $thiz.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE)) | 0) + seconds) | 0);
}
export { $p_Ljava_time_ZoneOffset$__totalSeconds__I__I__I__I as $p_Ljava_time_ZoneOffset$__totalSeconds__I__I__I__I };
function $p_Ljava_time_ZoneOffset$__msg$1__I__T__T($thiz, minutes$1, v) {
  var sign = (minutes$1 >> 31);
  return (((("Zone offset " + v) + " not in valid range: abs(value) ") + (((minutes$1 ^ sign) - sign) | 0)) + " is not in the range 0 to 59");
}
export { $p_Ljava_time_ZoneOffset$__msg$1__I__T__T as $p_Ljava_time_ZoneOffset$__msg$1__I__T__T };
function $p_Ljava_time_ZoneOffset$__msg2$1__T__T($thiz, v) {
  return ((("Zone offset minutes and seconds must be " + v) + " because hours is ") + v);
}
export { $p_Ljava_time_ZoneOffset$__msg2$1__T__T as $p_Ljava_time_ZoneOffset$__msg2$1__T__T };
/** @constructor */
function $c_Ljava_time_ZoneOffset$() {
  this.Ljava_time_ZoneOffset$__f_SECONDS_CACHE$lzy1 = null;
  this.Ljava_time_ZoneOffset$__f_SECONDS_CACHEbitmap$1 = false;
  this.Ljava_time_ZoneOffset$__f_ID_CACHE$lzy1 = null;
  this.Ljava_time_ZoneOffset$__f_ID_CACHEbitmap$1 = false;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR = 0;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE = 0;
  this.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR = 0;
  this.Ljava_time_ZoneOffset$__f_MAX_SECONDS = 0;
  this.Ljava_time_ZoneOffset$__f_UTC$lzy1 = null;
  this.Ljava_time_ZoneOffset$__f_UTCbitmap$1 = false;
  $n_Ljava_time_ZoneOffset$ = this;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR = 3600;
  this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE = 60;
  this.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR = 60;
  this.Ljava_time_ZoneOffset$__f_MAX_SECONDS = Math.imul(18, this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR);
}
export { $c_Ljava_time_ZoneOffset$ as $c_Ljava_time_ZoneOffset$ };
$c_Ljava_time_ZoneOffset$.prototype = new $h_O();
$c_Ljava_time_ZoneOffset$.prototype.constructor = $c_Ljava_time_ZoneOffset$;
/** @constructor */
function $h_Ljava_time_ZoneOffset$() {
}
export { $h_Ljava_time_ZoneOffset$ as $h_Ljava_time_ZoneOffset$ };
$h_Ljava_time_ZoneOffset$.prototype = $c_Ljava_time_ZoneOffset$.prototype;
$c_Ljava_time_ZoneOffset$.prototype.UTC__Ljava_time_ZoneOffset = (function() {
  if ((!this.Ljava_time_ZoneOffset$__f_UTCbitmap$1)) {
    this.Ljava_time_ZoneOffset$__f_UTC$lzy1 = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(0);
    this.Ljava_time_ZoneOffset$__f_UTCbitmap$1 = true;
  }
  return this.Ljava_time_ZoneOffset$__f_UTC$lzy1;
});
$c_Ljava_time_ZoneOffset$.prototype.of__T__Ljava_time_ZoneOffset = (function(offsetId) {
  var _offsetId = offsetId;
  var obj = _offsetId;
  if ((obj === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offsetId");
  }
  var offset = $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map(this).get__O__O(_offsetId);
  if ((offset !== null)) {
    return offset;
  }
  var hours = 0;
  var minutes = 0;
  var seconds = 0;
  var this$2 = _offsetId;
  if ((this$2.length === 2)) {
    var this$3 = _offsetId;
    var this$4 = _offsetId;
    _offsetId = (($cToS(this$3.charCodeAt(0)) + "0") + $cToS(this$4.charCodeAt(1)));
  }
  var this$5 = _offsetId;
  var x3 = this$5.length;
  switch (x3) {
    case 3: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = 0;
      seconds = 0;
      break;
    }
    case 5: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 3, false);
      seconds = 0;
      break;
    }
    case 6: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 4, true);
      seconds = 0;
      break;
    }
    case 7: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 3, false);
      seconds = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 5, false);
      break;
    }
    case 9: {
      hours = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 1, false);
      minutes = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 4, true);
      seconds = $p_Ljava_time_ZoneOffset$__parseNumber__jl_CharSequence__I__Z__I(this, _offsetId, 7, true);
      break;
    }
    default: {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, invalid format: " + _offsetId));
    }
  }
  var this$6 = _offsetId;
  var first = this$6.charCodeAt(0);
  if (((first !== 43) && (first !== 45))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for ZoneOffset, plus/minus not found when expected: " + _offsetId));
  }
  return ((first === 45) ? this.ofHoursMinutesSeconds__I__I__I__Ljava_time_ZoneOffset(((-hours) | 0), ((-minutes) | 0), ((-seconds) | 0)) : this.ofHoursMinutesSeconds__I__I__I__Ljava_time_ZoneOffset(hours, minutes, seconds));
});
$c_Ljava_time_ZoneOffset$.prototype.ofHoursMinutesSeconds__I__I__I__Ljava_time_ZoneOffset = (function(hours, minutes, seconds) {
  $p_Ljava_time_ZoneOffset$__validate__I__I__I__V(this, hours, minutes, seconds);
  var totalSecs = $p_Ljava_time_ZoneOffset$__totalSeconds__I__I__I__I(this, hours, minutes, seconds);
  return this.ofTotalSeconds__I__Ljava_time_ZoneOffset(totalSecs);
});
$c_Ljava_time_ZoneOffset$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset = (function(temporal) {
  var offset = temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery());
  if ((offset === null)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZoneOffset from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)));
  }
  return offset;
});
$c_Ljava_time_ZoneOffset$.prototype.ofTotalSeconds__I__Ljava_time_ZoneOffset = (function(totalSeconds) {
  var sign = (totalSeconds >> 31);
  if (((((totalSeconds ^ sign) - sign) | 0) > this.Ljava_time_ZoneOffset$__f_MAX_SECONDS)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Zone offset not in valid range: -18:00 to +18:00");
  } else if ((((totalSeconds % $checkIntDivisor(Math.imul(15, this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE))) | 0) === 0)) {
    var result = $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this).get__O__O(totalSeconds);
    if ((result === null)) {
      result = new $c_Ljava_time_ZoneOffset(totalSeconds);
      $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this).put__O__O__O(totalSeconds, result);
      result = $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this).get__O__O(totalSeconds);
      $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map(this).put__O__O__O(result.Ljava_time_ZoneOffset__f_id, result);
    }
    return result;
  } else {
    return new $c_Ljava_time_ZoneOffset(totalSeconds);
  }
});
$c_Ljava_time_ZoneOffset$.prototype.java$time$ZoneOffset$$$buildId__I__T = (function(totalSeconds) {
  if ((totalSeconds === 0)) {
    return "Z";
  } else {
    var sign = (totalSeconds >> 31);
    var absTotalSeconds = (((totalSeconds ^ sign) - sign) | 0);
    var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
    var absHours = ((absTotalSeconds / $checkIntDivisor(this.Ljava_time_ZoneOffset$__f_SECONDS_PER_HOUR)) | 0);
    var absMinutes = ((((absTotalSeconds / $checkIntDivisor(this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE)) | 0) % $checkIntDivisor(this.Ljava_time_ZoneOffset$__f_MINUTES_PER_HOUR)) | 0);
    buf.append__T__scm_StringBuilder(((totalSeconds < 0) ? "-" : "+")).append__T__scm_StringBuilder(((absHours < 10) ? "0" : "")).append__I__scm_StringBuilder(absHours).append__T__scm_StringBuilder(((absMinutes < 10) ? ":0" : ":")).append__I__scm_StringBuilder(absMinutes);
    var absSeconds = ((absTotalSeconds % $checkIntDivisor(this.Ljava_time_ZoneOffset$__f_SECONDS_PER_MINUTE)) | 0);
    if ((absSeconds !== 0)) {
      buf.append__T__scm_StringBuilder(((absSeconds < 10) ? ":0" : ":")).append__I__scm_StringBuilder(absSeconds);
    }
    return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
});
var $d_Ljava_time_ZoneOffset$ = new $TypeData().initClass($c_Ljava_time_ZoneOffset$, "java.time.ZoneOffset$", ({
  Ljava_time_ZoneOffset$: 1
}));
export { $d_Ljava_time_ZoneOffset$ as $d_Ljava_time_ZoneOffset$ };
var $n_Ljava_time_ZoneOffset$;
function $m_Ljava_time_ZoneOffset$() {
  if ((!$n_Ljava_time_ZoneOffset$)) {
    $n_Ljava_time_ZoneOffset$ = new $c_Ljava_time_ZoneOffset$();
  }
  return $n_Ljava_time_ZoneOffset$;
}
export { $m_Ljava_time_ZoneOffset$ as $m_Ljava_time_ZoneOffset$ };
function $p_Ljava_time_ZoneRegion$__PATTERN__ju_regex_Pattern($thiz) {
  if ((!$thiz.Ljava_time_ZoneRegion$__f_PATTERNbitmap$1)) {
    $thiz.Ljava_time_ZoneRegion$__f_PATTERN$lzy1 = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("[A-Za-z][A-Za-z0-9~/._+-]+", 0);
    $thiz.Ljava_time_ZoneRegion$__f_PATTERNbitmap$1 = true;
  }
  return $thiz.Ljava_time_ZoneRegion$__f_PATTERN$lzy1;
}
export { $p_Ljava_time_ZoneRegion$__PATTERN__ju_regex_Pattern as $p_Ljava_time_ZoneRegion$__PATTERN__ju_regex_Pattern };
/** @constructor */
function $c_Ljava_time_ZoneRegion$() {
  this.Ljava_time_ZoneRegion$__f_PATTERN$lzy1 = null;
  this.Ljava_time_ZoneRegion$__f_PATTERNbitmap$1 = false;
}
export { $c_Ljava_time_ZoneRegion$ as $c_Ljava_time_ZoneRegion$ };
$c_Ljava_time_ZoneRegion$.prototype = new $h_O();
$c_Ljava_time_ZoneRegion$.prototype.constructor = $c_Ljava_time_ZoneRegion$;
/** @constructor */
function $h_Ljava_time_ZoneRegion$() {
}
export { $h_Ljava_time_ZoneRegion$ as $h_Ljava_time_ZoneRegion$ };
$h_Ljava_time_ZoneRegion$.prototype = $c_Ljava_time_ZoneRegion$.prototype;
$c_Ljava_time_ZoneRegion$.prototype.ofId__T__Z__Ljava_time_ZoneRegion = (function(zoneId, checkAvailable) {
  if ((zoneId === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId");
  }
  if ((zoneId.length < 2)) {
    var $x_1 = true;
  } else {
    var this$2 = $p_Ljava_time_ZoneRegion$__PATTERN__ju_regex_Pattern(this);
    var $x_1 = (!new $c_ju_regex_Matcher(this$2, zoneId).matches__Z());
  }
  if ($x_1) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid ID for region-based ZoneId, invalid format: " + zoneId));
  }
  var rules = null;
  try {
    rules = $m_Ljava_time_zone_ZoneRulesProvider$().getRules__T__Z__Ljava_time_zone_ZoneRules(zoneId, true);
  } catch (e) {
    if ((e instanceof $c_Ljava_time_zone_ZoneRulesException)) {
      var ex = e;
      if ((zoneId === "GMT0")) {
        var this$3 = $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset();
        rules = $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this$3);
      } else if (checkAvailable) {
        throw ex;
      }
    } else {
      throw e;
    }
  }
  return new $c_Ljava_time_ZoneRegion(zoneId, rules);
});
var $d_Ljava_time_ZoneRegion$ = new $TypeData().initClass($c_Ljava_time_ZoneRegion$, "java.time.ZoneRegion$", ({
  Ljava_time_ZoneRegion$: 1
}));
export { $d_Ljava_time_ZoneRegion$ as $d_Ljava_time_ZoneRegion$ };
var $n_Ljava_time_ZoneRegion$;
function $m_Ljava_time_ZoneRegion$() {
  if ((!$n_Ljava_time_ZoneRegion$)) {
    $n_Ljava_time_ZoneRegion$ = new $c_Ljava_time_ZoneRegion$();
  }
  return $n_Ljava_time_ZoneRegion$;
}
export { $m_Ljava_time_ZoneRegion$ as $m_Ljava_time_ZoneRegion$ };
/** @constructor */
function $c_Ljava_time_ZonedDateTime$() {
}
export { $c_Ljava_time_ZonedDateTime$ as $c_Ljava_time_ZonedDateTime$ };
$c_Ljava_time_ZonedDateTime$.prototype = new $h_O();
$c_Ljava_time_ZonedDateTime$.prototype.constructor = $c_Ljava_time_ZonedDateTime$;
/** @constructor */
function $h_Ljava_time_ZonedDateTime$() {
}
export { $h_Ljava_time_ZonedDateTime$ as $h_Ljava_time_ZonedDateTime$ };
$h_Ljava_time_ZonedDateTime$.prototype = $c_Ljava_time_ZonedDateTime$.prototype;
$c_Ljava_time_ZonedDateTime$.prototype.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime = (function(localDateTime, zone, preferredOffset) {
  if ((localDateTime === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "localDateTime");
  }
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone");
  }
  var _localDateTime = localDateTime;
  if ((zone instanceof $c_Ljava_time_ZoneOffset)) {
    return new $c_Ljava_time_ZonedDateTime(_localDateTime, zone, zone);
  } else {
    var rules = zone.getRules__Ljava_time_zone_ZoneRules();
    var validOffsets = rules.getValidOffsets__Ljava_time_LocalDateTime__ju_List(_localDateTime);
    var offset$2 = null;
    if ((validOffsets.size__I() === 1)) {
      offset$2 = validOffsets.get__I__O(0);
    } else if ((validOffsets.size__I() === 0)) {
      var trans = rules.getTransition__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition(_localDateTime);
      var this$6 = _localDateTime;
      var this$4 = $m_Ljava_time_Duration$();
      var value = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(trans);
      var hi = (value >> 31);
      var this$5 = this$4.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(value, hi), 0);
      var t = this$5.Ljava_time_Duration__f_seconds;
      var lo = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      _localDateTime = $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$6, this$6.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(lo, hi$1), $L0, 1);
      offset$2 = trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
    } else if (((preferredOffset !== null) && validOffsets.contains__O__Z(preferredOffset))) {
      offset$2 = preferredOffset;
    } else {
      var obj = validOffsets.get__I__O(0);
      if ((obj === null)) {
        throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset");
      }
      offset$2 = obj;
    }
    return new $c_Ljava_time_ZonedDateTime(_localDateTime, offset$2, zone);
  }
});
$c_Ljava_time_ZonedDateTime$.prototype.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(instant, zone) {
  if ((instant === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "instant");
  }
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone");
  }
  return this.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(instant.Ljava_time_Instant__f_seconds, instant.Ljava_time_Instant__f_nanos, zone);
});
$c_Ljava_time_ZonedDateTime$.prototype.ofInstant__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(localDateTime, offset, zone) {
  if ((localDateTime === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "localDateTime");
  }
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset");
  }
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone");
  }
  var $x_1 = localDateTime.toEpochSecond__Ljava_time_ZoneOffset__J(offset);
  var this$4 = localDateTime.Ljava_time_LocalDateTime__f_time;
  return this.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime($x_1, this$4.Ljava_time_LocalTime__f_nano, zone);
});
$c_Ljava_time_ZonedDateTime$.prototype.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(epochSecond, nanoOfSecond, zone) {
  var rules = zone.getRules__Ljava_time_zone_ZoneRules();
  var $x_1 = $m_Ljava_time_Instant$();
  var hi = (nanoOfSecond >> 31);
  var instant = $x_1.ofEpochSecond__J__J__Ljava_time_Instant(epochSecond, new $c_RTLong(nanoOfSecond, hi));
  var offset = rules.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(instant);
  return new $c_Ljava_time_ZonedDateTime($m_Ljava_time_LocalDateTime$().ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(epochSecond, nanoOfSecond, offset), offset, zone);
});
$c_Ljava_time_ZonedDateTime$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZonedDateTime = (function(temporal) {
  if ((temporal instanceof $c_Ljava_time_ZonedDateTime)) {
    return temporal;
  } else {
    try {
      var zone = $m_Ljava_time_ZoneId$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId(temporal);
      if (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
        try {
          var t = temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          var nanoOfSecond = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
          return this.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(new $c_RTLong(lo, hi), nanoOfSecond, zone);
        } catch (e) {
          if ((!(e instanceof $c_Ljava_time_DateTimeException))) {
            throw e;
          }
        }
      }
      var ldt = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(temporal);
      return this.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(ldt, zone, null);
    } catch (e$2) {
      if ((e$2 instanceof $c_Ljava_time_DateTimeException)) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Unable to obtain ZonedDateTime from TemporalAccessor: " + temporal) + ", type ") + $objectClassName(temporal)));
      } else {
        throw e$2;
      }
    }
  }
});
var $d_Ljava_time_ZonedDateTime$ = new $TypeData().initClass($c_Ljava_time_ZonedDateTime$, "java.time.ZonedDateTime$", ({
  Ljava_time_ZonedDateTime$: 1
}));
export { $d_Ljava_time_ZonedDateTime$ as $d_Ljava_time_ZonedDateTime$ };
var $n_Ljava_time_ZonedDateTime$;
function $m_Ljava_time_ZonedDateTime$() {
  if ((!$n_Ljava_time_ZonedDateTime$)) {
    $n_Ljava_time_ZonedDateTime$ = new $c_Ljava_time_ZonedDateTime$();
  }
  return $n_Ljava_time_ZonedDateTime$;
}
export { $m_Ljava_time_ZonedDateTime$ as $m_Ljava_time_ZonedDateTime$ };
/** @constructor */
function $c_Ljava_time_chrono_Chronology$() {
}
export { $c_Ljava_time_chrono_Chronology$ as $c_Ljava_time_chrono_Chronology$ };
$c_Ljava_time_chrono_Chronology$.prototype = new $h_O();
$c_Ljava_time_chrono_Chronology$.prototype.constructor = $c_Ljava_time_chrono_Chronology$;
/** @constructor */
function $h_Ljava_time_chrono_Chronology$() {
}
export { $h_Ljava_time_chrono_Chronology$ as $h_Ljava_time_chrono_Chronology$ };
$h_Ljava_time_chrono_Chronology$.prototype = $c_Ljava_time_chrono_Chronology$.prototype;
$c_Ljava_time_chrono_Chronology$.prototype.from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology = (function(temporal) {
  if ((temporal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "temporal");
  }
  var obj = temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery());
  return ((obj !== null) ? obj : $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
});
var $d_Ljava_time_chrono_Chronology$ = new $TypeData().initClass($c_Ljava_time_chrono_Chronology$, "java.time.chrono.Chronology$", ({
  Ljava_time_chrono_Chronology$: 1
}));
export { $d_Ljava_time_chrono_Chronology$ as $d_Ljava_time_chrono_Chronology$ };
var $n_Ljava_time_chrono_Chronology$;
function $m_Ljava_time_chrono_Chronology$() {
  if ((!$n_Ljava_time_chrono_Chronology$)) {
    $n_Ljava_time_chrono_Chronology$ = new $c_Ljava_time_chrono_Chronology$();
  }
  return $n_Ljava_time_chrono_Chronology$;
}
export { $m_Ljava_time_chrono_Chronology$ as $m_Ljava_time_chrono_Chronology$ };
/** @constructor */
function $c_Ljava_time_chrono_IsoChronology$() {
  this.Ljava_time_chrono_IsoChronology$__f_INSTANCE$lzy1 = null;
  this.Ljava_time_chrono_IsoChronology$__f_INSTANCEbitmap$1 = false;
}
export { $c_Ljava_time_chrono_IsoChronology$ as $c_Ljava_time_chrono_IsoChronology$ };
$c_Ljava_time_chrono_IsoChronology$.prototype = new $h_O();
$c_Ljava_time_chrono_IsoChronology$.prototype.constructor = $c_Ljava_time_chrono_IsoChronology$;
/** @constructor */
function $h_Ljava_time_chrono_IsoChronology$() {
}
export { $h_Ljava_time_chrono_IsoChronology$ as $h_Ljava_time_chrono_IsoChronology$ };
$h_Ljava_time_chrono_IsoChronology$.prototype = $c_Ljava_time_chrono_IsoChronology$.prototype;
$c_Ljava_time_chrono_IsoChronology$.prototype.INSTANCE__Ljava_time_chrono_IsoChronology = (function() {
  if ((!this.Ljava_time_chrono_IsoChronology$__f_INSTANCEbitmap$1)) {
    this.Ljava_time_chrono_IsoChronology$__f_INSTANCE$lzy1 = new $c_Ljava_time_chrono_IsoChronology();
    this.Ljava_time_chrono_IsoChronology$__f_INSTANCEbitmap$1 = true;
  }
  return this.Ljava_time_chrono_IsoChronology$__f_INSTANCE$lzy1;
});
var $d_Ljava_time_chrono_IsoChronology$ = new $TypeData().initClass($c_Ljava_time_chrono_IsoChronology$, "java.time.chrono.IsoChronology$", ({
  Ljava_time_chrono_IsoChronology$: 1
}));
export { $d_Ljava_time_chrono_IsoChronology$ as $d_Ljava_time_chrono_IsoChronology$ };
var $n_Ljava_time_chrono_IsoChronology$;
function $m_Ljava_time_chrono_IsoChronology$() {
  if ((!$n_Ljava_time_chrono_IsoChronology$)) {
    $n_Ljava_time_chrono_IsoChronology$ = new $c_Ljava_time_chrono_IsoChronology$();
  }
  return $n_Ljava_time_chrono_IsoChronology$;
}
export { $m_Ljava_time_chrono_IsoChronology$ as $m_Ljava_time_chrono_IsoChronology$ };
function $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException($thiz, text, ex) {
  var abbr = (($dp_length__I(text) > 64) ? ($dp_toString__T($dp_subSequence__I__I__jl_CharSequence(text, 0, 64)) + "...") : $dp_toString__T(text));
  return $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__jl_Throwable__(new $c_Ljava_time_format_DateTimeParseException(), ((("Text '" + abbr) + "' could not be parsed: ") + ex.getMessage__T()), text, 0, ex);
}
export { $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException as $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException };
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatter(printerParser, locale, decimalStyle, resolverStyle, resolverFields, chrono, zone) {
  this.Ljava_time_format_DateTimeFormatter__f_printerParser = null;
  this.Ljava_time_format_DateTimeFormatter__f_locale = null;
  this.Ljava_time_format_DateTimeFormatter__f_decimalStyle = null;
  this.Ljava_time_format_DateTimeFormatter__f_resolverStyle = null;
  this.Ljava_time_format_DateTimeFormatter__f_resolverFields = null;
  this.Ljava_time_format_DateTimeFormatter__f_chrono = null;
  this.Ljava_time_format_DateTimeFormatter__f_zone = null;
  this.Ljava_time_format_DateTimeFormatter__f_printerParser = printerParser;
  this.Ljava_time_format_DateTimeFormatter__f_locale = locale;
  this.Ljava_time_format_DateTimeFormatter__f_decimalStyle = decimalStyle;
  this.Ljava_time_format_DateTimeFormatter__f_resolverStyle = resolverStyle;
  this.Ljava_time_format_DateTimeFormatter__f_resolverFields = resolverFields;
  this.Ljava_time_format_DateTimeFormatter__f_chrono = chrono;
  this.Ljava_time_format_DateTimeFormatter__f_zone = zone;
  if ((printerParser === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "printerParser");
  }
  if ((locale === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "locale");
  }
  if ((decimalStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "decimalStyle");
  }
  if ((resolverStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "resolverStyle");
  }
}
export { $c_Ljava_time_format_DateTimeFormatter as $c_Ljava_time_format_DateTimeFormatter };
$c_Ljava_time_format_DateTimeFormatter.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatter.prototype.constructor = $c_Ljava_time_format_DateTimeFormatter;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatter() {
}
export { $h_Ljava_time_format_DateTimeFormatter as $h_Ljava_time_format_DateTimeFormatter };
$h_Ljava_time_format_DateTimeFormatter.prototype = $c_Ljava_time_format_DateTimeFormatter.prototype;
$c_Ljava_time_format_DateTimeFormatter.prototype.withChronology__Ljava_time_chrono_Chronology__Ljava_time_format_DateTimeFormatter = (function(chrono) {
  var a = this.Ljava_time_format_DateTimeFormatter__f_chrono;
  if (((a === null) ? (chrono === null) : $f_Ljava_time_chrono_Chronology__equals__O__Z(a, chrono))) {
    return this;
  } else {
    return new $c_Ljava_time_format_DateTimeFormatter(this.Ljava_time_format_DateTimeFormatter__f_printerParser, this.Ljava_time_format_DateTimeFormatter__f_locale, this.Ljava_time_format_DateTimeFormatter__f_decimalStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields, chrono, this.Ljava_time_format_DateTimeFormatter__f_zone);
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter = (function(resolverStyle) {
  if ((resolverStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "resolverStyle");
  }
  var a = this.Ljava_time_format_DateTimeFormatter__f_resolverStyle;
  if ((a === resolverStyle)) {
    return this;
  } else {
    return new $c_Ljava_time_format_DateTimeFormatter(this.Ljava_time_format_DateTimeFormatter__f_printerParser, this.Ljava_time_format_DateTimeFormatter__f_locale, this.Ljava_time_format_DateTimeFormatter__f_decimalStyle, resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields, this.Ljava_time_format_DateTimeFormatter__f_chrono, this.Ljava_time_format_DateTimeFormatter__f_zone);
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.format__Ljava_time_temporal_TemporalAccessor__T = (function(temporal) {
  var buf = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 32);
  this.formatTo__Ljava_time_temporal_TemporalAccessor__jl_Appendable__V(temporal, buf);
  return buf.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Ljava_time_format_DateTimeFormatter.prototype.formatTo__Ljava_time_temporal_TemporalAccessor__jl_Appendable__V = (function(temporal, appendable) {
  if ((temporal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "temporal");
  }
  if ((appendable === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "appendable");
  }
  try {
    var context = $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__(new $c_Ljava_time_format_internal_TTBPDateTimePrintContext(), temporal, this);
    if ((appendable instanceof $c_jl_StringBuilder)) {
      this.Ljava_time_format_DateTimeFormatter__f_printerParser.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, appendable);
    } else {
      var buf = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 32);
      this.Ljava_time_format_DateTimeFormatter__f_printerParser.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf);
      appendable.append__jl_CharSequence__jl_Appendable(buf);
    }
  } catch (e) {
    if ((e instanceof $c_Ljava_io_IOException)) {
      var ex = e;
      throw $ct_Ljava_time_DateTimeException__T__jl_Throwable__(new $c_Ljava_time_DateTimeException(), ex.getMessage__T(), ex);
    } else {
      throw e;
    }
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.parse__jl_CharSequence__Ljava_time_temporal_TemporalQuery__O = (function(text, type) {
  if ((text === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "text");
  }
  if ((type === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "type");
  }
  try {
    var builder = this.java$time$format$DateTimeFormatter$$parseToBuilder__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_DateTimeBuilder(text, null).resolve__Ljava_time_format_ResolverStyle__ju_Set__Ljava_time_format_DateTimeBuilder(this.Ljava_time_format_DateTimeFormatter__f_resolverStyle, this.Ljava_time_format_DateTimeFormatter__f_resolverFields);
    return type.queryFrom__Ljava_time_temporal_TemporalAccessor__O(builder);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ((e$2 instanceof $c_Ljava_time_format_DateTimeParseException)) {
      throw e$2;
    } else if ((e$2 instanceof $c_jl_RuntimeException)) {
      throw $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException(this, text, e$2);
    } else {
      throw e;
    }
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.java$time$format$DateTimeFormatter$$parseToBuilder__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_DateTimeBuilder = (function(text, position) {
  var pos = ((position !== null) ? position : new $c_Ljava_text_ParsePosition(0));
  var result = this.java$time$format$DateTimeFormatter$$parseUnresolved0__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(text, pos);
  if ((((result === null) || (pos.Ljava_text_ParsePosition__f_errorIndex >= 0)) || ((position === null) && (pos.Ljava_text_ParsePosition__f_index < $dp_length__I(text))))) {
    var abbr = (($dp_length__I(text) > 64) ? ($dp_toString__T($dp_subSequence__I__I__jl_CharSequence(text, 0, 64)) + "...") : $dp_toString__T(text));
    if ((pos.Ljava_text_ParsePosition__f_errorIndex >= 0)) {
      throw $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__(new $c_Ljava_time_format_DateTimeParseException(), ((("Text '" + abbr) + "' could not be parsed at index ") + pos.Ljava_text_ParsePosition__f_errorIndex), text, pos.Ljava_text_ParsePosition__f_errorIndex);
    } else {
      throw $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__(new $c_Ljava_time_format_DateTimeParseException(), ((("Text '" + abbr) + "' could not be parsed, unparsed text found at index ") + pos.Ljava_text_ParsePosition__f_index), text, pos.Ljava_text_ParsePosition__f_index);
    }
  }
  return result.toBuilder__Ljava_time_format_DateTimeBuilder();
});
$c_Ljava_time_format_DateTimeFormatter.prototype.java$time$format$DateTimeFormatter$$parseUnresolved0__jl_CharSequence__Ljava_text_ParsePosition__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed = (function(text, position) {
  if ((text === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "text");
  }
  if ((position === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "position");
  }
  var context = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), this);
  var pos = this.Ljava_time_format_DateTimeFormatter__f_printerParser.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, text, position.Ljava_text_ParsePosition__f_index);
  if ((pos < 0)) {
    position.Ljava_text_ParsePosition__f_errorIndex = (~pos);
    return null;
  } else {
    position.Ljava_text_ParsePosition__f_index = pos;
    return $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(context);
  }
});
$c_Ljava_time_format_DateTimeFormatter.prototype.toString__T = (function() {
  var pattern = this.Ljava_time_format_DateTimeFormatter__f_printerParser.toString__T();
  if ((!(!pattern.startsWith("[")))) {
    return pattern;
  } else {
    var endIndex = (((-1) + pattern.length) | 0);
    return pattern.substring(1, endIndex);
  }
});
var $d_Ljava_time_format_DateTimeFormatter = new $TypeData().initClass($c_Ljava_time_format_DateTimeFormatter, "java.time.format.DateTimeFormatter", ({
  Ljava_time_format_DateTimeFormatter: 1
}));
export { $d_Ljava_time_format_DateTimeFormatter as $d_Ljava_time_format_DateTimeFormatter };
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatter$() {
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATEbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANTbitmap$1 = false;
}
export { $c_Ljava_time_format_DateTimeFormatter$ as $c_Ljava_time_format_DateTimeFormatter$ };
$c_Ljava_time_format_DateTimeFormatter$.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatter$.prototype.constructor = $c_Ljava_time_format_DateTimeFormatter$;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatter$() {
}
export { $h_Ljava_time_format_DateTimeFormatter$ as $h_Ljava_time_format_DateTimeFormatter$ };
$h_Ljava_time_format_DateTimeFormatter$.prototype = $c_Ljava_time_format_DateTimeFormatter$.prototype;
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_LOCAL_DATE__Ljava_time_format_DateTimeFormatter = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATEbitmap$1)) {
    var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).appendValue__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField(), 4, 10, $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle()).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(45).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField(), 2).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(45).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField(), 2);
    var style = $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE$lzy1 = this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style).withChronology__Ljava_time_chrono_Chronology__Ljava_time_format_DateTimeFormatter($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology());
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATEbitmap$1 = true;
  }
  return this.Ljava_time_format_DateTimeFormatter$__f_ISO_LOCAL_DATE$lzy1;
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ISO_INSTANT__Ljava_time_format_DateTimeFormatter = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANTbitmap$1)) {
    var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).parseCaseInsensitive__Ljava_time_format_DateTimeFormatterBuilder().appendInstant__Ljava_time_format_DateTimeFormatterBuilder();
    var style = $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
    var this$2 = $m_ju_Locale$();
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT$lzy1 = this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale).withResolverStyle__Ljava_time_format_ResolverStyle__Ljava_time_format_DateTimeFormatter(style);
    this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANTbitmap$1 = true;
  }
  return this.Ljava_time_format_DateTimeFormatter$__f_ISO_INSTANT$lzy1;
});
$c_Ljava_time_format_DateTimeFormatter$.prototype.ofPattern__T__Ljava_time_format_DateTimeFormatter = (function(pattern) {
  var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).appendPattern__T__Ljava_time_format_DateTimeFormatterBuilder(pattern);
  var this$2 = $m_ju_Locale$();
  return this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale);
});
var $d_Ljava_time_format_DateTimeFormatter$ = new $TypeData().initClass($c_Ljava_time_format_DateTimeFormatter$, "java.time.format.DateTimeFormatter$", ({
  Ljava_time_format_DateTimeFormatter$: 1
}));
export { $d_Ljava_time_format_DateTimeFormatter$ as $d_Ljava_time_format_DateTimeFormatter$ };
var $n_Ljava_time_format_DateTimeFormatter$;
function $m_Ljava_time_format_DateTimeFormatter$() {
  if ((!$n_Ljava_time_format_DateTimeFormatter$)) {
    $n_Ljava_time_format_DateTimeFormatter$ = new $c_Ljava_time_format_DateTimeFormatter$();
  }
  return $n_Ljava_time_format_DateTimeFormatter$;
}
export { $m_Ljava_time_format_DateTimeFormatter$ as $m_Ljava_time_format_DateTimeFormatter$ };
function $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__($thiz, parent, optional) {
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_parent = parent;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_optional = optional;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active = $thiz;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = 0;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = 0;
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = (-1);
  return $thiz;
}
export { $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__ as $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__ };
function $ct_Ljava_time_format_DateTimeFormatterBuilder__($thiz) {
  $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__($thiz, null, false);
  return $thiz;
}
export { $ct_Ljava_time_format_DateTimeFormatterBuilder__ as $ct_Ljava_time_format_DateTimeFormatterBuilder__ };
function $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder($thiz, pp) {
  if ((($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex >= 0) && ($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.get__I__O($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex) instanceof $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser))) {
    var activeValueParser = $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex;
    var basePP = $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.get__I__O(activeValueParser);
    if (((pp.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === pp.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth) && (pp.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))) {
      basePP = basePP.withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(pp.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth);
      $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp.withFixedWidth__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser());
      $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = activeValueParser;
    } else {
      basePP = basePP.withFixedWidth__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser();
      $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp);
    }
    $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.set__I__O__O(activeValueParser, basePP);
  } else {
    $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp);
  }
  return $thiz;
}
export { $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder as $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder };
function $p_Ljava_time_format_DateTimeFormatterBuilder__parsePattern__T__V($thiz, pattern) {
  var pos = 0;
  while ((pos < pattern.length)) {
    var index = pos;
    var cur = pattern.charCodeAt(index);
    if ((((cur >= 65) && (cur <= 90)) || ((cur >= 97) && (cur <= 122)))) {
      var start = pos;
      pos = ((1 + pos) | 0);
      while (true) {
        if ((pos < pattern.length)) {
          var index$1 = pos;
          var $x_1 = (pattern.charCodeAt(index$1) === cur);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          pos = ((1 + pos) | 0);
        } else {
          break;
        }
      }
      var count = ((pos - start) | 0);
      if ((cur === 112)) {
        var pad = 0;
        if ((pos < pattern.length)) {
          var index$2 = pos;
          cur = pattern.charCodeAt(index$2);
          if ((((cur >= 65) && (cur <= 90)) || ((cur >= 97) && (cur <= 122)))) {
            pad = count;
            start = pos;
            pos = ((1 + pos) | 0);
            while (true) {
              if ((pos < pattern.length)) {
                var index$3 = pos;
                var $x_2 = (pattern.charCodeAt(index$3) === cur);
              } else {
                var $x_2 = false;
              }
              if ($x_2) {
                pos = ((1 + pos) | 0);
              } else {
                break;
              }
            }
            count = ((pos - start) | 0);
          }
        }
        if ((pad === 0)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Pad letter 'p' must be followed by valid pad pattern: " + pattern));
        }
        var padWidth = pad;
        $thiz.padNext__I__C__Ljava_time_format_DateTimeFormatterBuilder(padWidth, 32);
      }
      var field = $m_Ljava_time_format_DateTimeFormatterBuilder$().java$time$format$DateTimeFormatterBuilder$$$FIELD_MAP__ju_Map().get__O__O($bC(cur));
      if ((field !== null)) {
        $p_Ljava_time_format_DateTimeFormatterBuilder__parseField__C__I__Ljava_time_temporal_TemporalField__V($thiz, cur, count, field);
      } else if ((cur === 122)) {
        if ((count > 4)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $cToS(cur)));
        } else if ((count === 4)) {
          $thiz.appendZoneText__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle());
        } else {
          $thiz.appendZoneText__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle());
        }
      } else if ((cur === 86)) {
        if ((count !== 2)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Pattern letter count must be 2: " + $cToS(cur)));
        }
        $thiz.appendZoneId__Ljava_time_format_DateTimeFormatterBuilder();
      } else if ((cur === 90)) {
        if ((count < 4)) {
          $thiz.appendOffset__T__T__Ljava_time_format_DateTimeFormatterBuilder("+HHMM", "+0000");
        } else if ((count === 4)) {
          $thiz.appendLocalizedOffset__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle());
        } else if ((count === 5)) {
          $thiz.appendOffset__T__T__Ljava_time_format_DateTimeFormatterBuilder("+HH:MM:ss", "Z");
        } else {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $cToS(cur)));
        }
      } else if ((cur === 79)) {
        if ((count === 1)) {
          $thiz.appendLocalizedOffset__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle());
        } else if ((count === 4)) {
          $thiz.appendLocalizedOffset__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle());
        } else {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Pattern letter count must be 1 or 4: " + $cToS(cur)));
        }
      } else if ((cur === 88)) {
        if ((count > 5)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $cToS(cur)));
        }
        $thiz.appendOffset__T__T__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS.u[((count + ((count === 1) ? 0 : 1)) | 0)], "Z");
      } else if ((cur === 120)) {
        if ((count > 5)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $cToS(cur)));
        }
        var zero = ((count === 1) ? "+00" : ((((count % 2) | 0) === 0) ? "+0000" : "+00:00"));
        $thiz.appendOffset__T__T__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS.u[((count + ((count === 1) ? 0 : 1)) | 0)], zero);
      } else if ((cur === 87)) {
        if ((count > 1)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $cToS(cur)));
        }
        $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(87, count));
      } else if ((cur === 119)) {
        if ((count > 2)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $cToS(cur)));
        }
        $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(119, count));
      } else if ((cur === 89)) {
        $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(89, count));
      } else {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Unknown pattern letter: " + $cToS(cur)));
      }
      pos = (((-1) + pos) | 0);
    } else if ((cur === 39)) {
      var start$2 = pos;
      pos = ((1 + pos) | 0);
      var break$1 = false;
      while (((!break$1) && (pos < pattern.length))) {
        var index$4 = pos;
        if ((pattern.charCodeAt(index$4) === 39)) {
          if ((((1 + pos) | 0) < pattern.length)) {
            var index$5 = ((1 + pos) | 0);
            var $x_3 = (pattern.charCodeAt(index$5) === 39);
          } else {
            var $x_3 = false;
          }
          if ($x_3) {
            pos = ((1 + pos) | 0);
          } else {
            break$1 = true;
          }
        }
        if ((!break$1)) {
          pos = ((1 + pos) | 0);
        }
      }
      if ((pos >= pattern.length)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Pattern ends with an incomplete string literal: " + pattern));
      }
      var beginIndex = ((1 + start$2) | 0);
      var endIndex = pos;
      var str = pattern.substring(beginIndex, endIndex);
      if ((str.length === 0)) {
        $thiz.appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(39);
      } else {
        $thiz.appendLiteral__T__Ljava_time_format_DateTimeFormatterBuilder(str.split("''").join("'"));
      }
    } else if ((cur === 91)) {
      $thiz.optionalStart__Ljava_time_format_DateTimeFormatterBuilder();
    } else if ((cur === 93)) {
      if (($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_parent === null)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Pattern invalid as it contains ] without previous [");
      }
      $thiz.optionalEnd__Ljava_time_format_DateTimeFormatterBuilder();
    } else if ((((cur === 123) || (cur === 125)) || (cur === 35))) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("Pattern includes reserved character: '" + $cToS(cur)) + "'"));
    } else {
      $thiz.appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(cur);
    }
    pos = ((1 + pos) | 0);
  }
}
export { $p_Ljava_time_format_DateTimeFormatterBuilder__parsePattern__T__V as $p_Ljava_time_format_DateTimeFormatterBuilder__parsePattern__T__V };
function $p_Ljava_time_format_DateTimeFormatterBuilder__parseField__C__I__Ljava_time_temporal_TemporalField__V($thiz, cur, count, field) {
  var exc = $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Too many pattern letters: " + $cToS(cur)));
  switch (cur) {
    case 117:
    case 121: {
      if ((count === 2)) {
        $thiz.appendValueReduced__Ljava_time_temporal_TemporalField__I__I__Ljava_time_chrono_ChronoLocalDate__Ljava_time_format_DateTimeFormatterBuilder(field, 2, 2, $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$__f_BASE_DATE);
      } else if ((count < 4)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__Ljava_time_format_DateTimeFormatterBuilder(field, count, 19, $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle());
      } else {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__Ljava_time_format_DateTimeFormatterBuilder(field, count, 19, $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle());
      }
      break;
    }
    case 77:
    case 81: {
      switch (count) {
        case 1: {
          $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field);
          break;
        }
        case 2: {
          $thiz.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, 2);
          break;
        }
        case 3: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle());
          break;
        }
        case 4: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle());
          break;
        }
        case 5: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle());
          break;
        }
        default: {
          throw exc;
        }
      }
      break;
    }
    case 76:
    case 113: {
      switch (count) {
        case 1: {
          $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field);
          break;
        }
        case 2: {
          $thiz.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, 2);
          break;
        }
        case 3: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__SHORT_STANDALONE__Ljava_time_format_TextStyle());
          break;
        }
        case 4: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__FULL_STANDALONE__Ljava_time_format_TextStyle());
          break;
        }
        case 5: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__NARROW_STANDALONE__Ljava_time_format_TextStyle());
          break;
        }
        default: {
          throw exc;
        }
      }
      break;
    }
    case 101: {
      switch (count) {
        case 1:
        case 2: {
          $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(101, count));
          break;
        }
        case 3: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle());
          break;
        }
        case 4: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle());
          break;
        }
        case 5: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle());
          break;
        }
        default: {
          throw exc;
        }
      }
      break;
    }
    case 99: {
      switch (count) {
        case 1: {
          $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(99, count));
          break;
        }
        case 2: {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid number of pattern letters: " + $cToS(cur)));
          break;
        }
        case 3: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__SHORT_STANDALONE__Ljava_time_format_TextStyle());
          break;
        }
        case 4: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__FULL_STANDALONE__Ljava_time_format_TextStyle());
          break;
        }
        case 5: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__NARROW_STANDALONE__Ljava_time_format_TextStyle());
          break;
        }
        default: {
          throw exc;
        }
      }
      break;
    }
    case 97: {
      if ((count === 1)) {
        $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle());
      } else {
        throw exc;
      }
      break;
    }
    case 69:
    case 71: {
      switch (count) {
        case 1:
        case 2:
        case 3: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle());
          break;
        }
        case 4: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle());
          break;
        }
        case 5: {
          $thiz.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder(field, $s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle());
          break;
        }
        default: {
          throw exc;
        }
      }
      break;
    }
    case 83: {
      $thiz.appendFraction__Ljava_time_temporal_TemporalField__I__I__Z__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), count, count, false);
      break;
    }
    case 70: {
      if ((count === 1)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field);
      } else {
        throw exc;
      }
      break;
    }
    case 100:
    case 104:
    case 72:
    case 107:
    case 75:
    case 109:
    case 115: {
      if ((count === 1)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field);
      } else if ((count === 2)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, count);
      } else {
        throw exc;
      }
      break;
    }
    case 68: {
      if ((count === 1)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field);
      } else if ((count <= 3)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, count);
      } else {
        throw exc;
      }
      break;
    }
    default: {
      if ((count === 1)) {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder(field);
      } else {
        $thiz.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, count);
      }
    }
  }
}
export { $p_Ljava_time_format_DateTimeFormatterBuilder__parseField__C__I__Ljava_time_temporal_TemporalField__V as $p_Ljava_time_format_DateTimeFormatterBuilder__parseField__C__I__Ljava_time_temporal_TemporalField__V };
function $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp) {
  var _pp = pp;
  var obj = _pp;
  if ((obj === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "pp");
  }
  if (($thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth > 0)) {
    if ((_pp !== null)) {
      _pp = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator(_pp, $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth, $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar);
    }
    $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = 0;
    $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = 0;
  }
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.add__O__Z(_pp);
  $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = (-1);
  return (((-1) + $thiz.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.size__I()) | 0);
}
export { $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I as $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I };
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder() {
  this.Ljava_time_format_DateTimeFormatterBuilder__f_parent = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_optional = false;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_active = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers = null;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = 0;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = 0;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = 0;
}
export { $c_Ljava_time_format_DateTimeFormatterBuilder as $c_Ljava_time_format_DateTimeFormatterBuilder };
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder() {
}
export { $h_Ljava_time_format_DateTimeFormatterBuilder as $h_Ljava_time_format_DateTimeFormatterBuilder };
$h_Ljava_time_format_DateTimeFormatterBuilder.prototype = $c_Ljava_time_format_DateTimeFormatterBuilder.prototype;
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.parseCaseInsensitive__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser());
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendValue__Ljava_time_temporal_TemporalField__Ljava_time_format_DateTimeFormatterBuilder = (function(field) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field");
  }
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), field, 1, 19, $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle()));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder = (function(field, width) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field");
  }
  if (((width < 1) || (width > 19))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The width must be from 1 to 19 inclusive but was " + width));
  }
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), field, width, width, $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendValue__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__Ljava_time_format_DateTimeFormatterBuilder = (function(field, minWidth, maxWidth, signStyle) {
  if (((minWidth === maxWidth) && (signStyle === $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))) {
    return this.appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder(field, maxWidth);
  }
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field");
  }
  if ((signStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "signStyle");
  }
  if (((minWidth < 1) || (minWidth > 19))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The minimum width must be from 1 to 19 inclusive but was " + minWidth));
  }
  if (((maxWidth < 1) || (maxWidth > 19))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The maximum width must be from 1 to 19 inclusive but was " + maxWidth));
  }
  if ((maxWidth < minWidth)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("The maximum width must exceed or equal the minimum width but " + maxWidth) + " < ") + minWidth));
  }
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), field, minWidth, maxWidth, signStyle));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendValueReduced__Ljava_time_temporal_TemporalField__I__I__Ljava_time_chrono_ChronoLocalDate__Ljava_time_format_DateTimeFormatterBuilder = (function(field, width, maxWidth, baseDate) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field");
  }
  if ((baseDate === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "baseDate");
  }
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser(), field, width, maxWidth, 0, baseDate));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendFraction__Ljava_time_temporal_TemporalField__I__I__Z__Ljava_time_format_DateTimeFormatterBuilder = (function(field, minWidth, maxWidth, decimalPoint) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser(field, minWidth, maxWidth, decimalPoint));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendText__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder = (function(field, textStyle) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field");
  }
  if ((textStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "textStyle");
  }
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser(field, textStyle, $m_Ljava_time_format_internal_TTBPDateTimeTextProvider$().Provider__Ljava_time_format_internal_TTBPDateTimeTextProvider()));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendInstant__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser((-2)));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendOffset__T__T__Ljava_time_format_DateTimeFormatterBuilder = (function(pattern, noOffsetText) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser(noOffsetText, pattern));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendLocalizedOffset__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder = (function(style) {
  if ((style === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "style");
  }
  if (((style !== $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle()) && (style !== $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle()))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Style must be either full or short");
  }
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser(style));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendZoneId__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery(), "ZoneId()"));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendZoneText__Ljava_time_format_TextStyle__Ljava_time_format_DateTimeFormatterBuilder = (function(textStyle) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser(textStyle));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder = (function(literal) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser(literal));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendLiteral__T__Ljava_time_format_DateTimeFormatterBuilder = (function(literal) {
  if ((literal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "literal");
  }
  if ((literal.length > 0)) {
    if ((literal.length === 1)) {
      $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser(literal.charCodeAt(0)));
    } else {
      $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser(literal));
    }
  }
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder = (function(formatter) {
  if ((formatter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "formatter");
  }
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, formatter.Ljava_time_format_DateTimeFormatter__f_printerParser.withOptional__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(false));
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.appendPattern__T__Ljava_time_format_DateTimeFormatterBuilder = (function(pattern) {
  if ((pattern === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "pattern");
  }
  $p_Ljava_time_format_DateTimeFormatterBuilder__parsePattern__T__V(this, pattern);
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.padNext__I__C__Ljava_time_format_DateTimeFormatterBuilder = (function(padWidth, padChar) {
  if ((padWidth < 1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The pad width must be at least one but was " + padWidth));
  }
  this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextWidth = padWidth;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_padNextChar = padChar;
  this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = (-1);
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.optionalStart__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_valueParserIndex = (-1);
  this.Ljava_time_format_DateTimeFormatterBuilder__f_active = $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__(new $c_Ljava_time_format_DateTimeFormatterBuilder(), this.Ljava_time_format_DateTimeFormatterBuilder__f_active, true);
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.optionalEnd__Ljava_time_format_DateTimeFormatterBuilder = (function() {
  if ((this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_parent === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Cannot call optionalEnd() as there was no previous call to optionalStart()");
  }
  if ((this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers.size__I() > 0)) {
    var cpp = $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers, this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_optional);
    this.Ljava_time_format_DateTimeFormatterBuilder__f_active = this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_parent;
    $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, cpp);
  } else {
    this.Ljava_time_format_DateTimeFormatterBuilder__f_active = this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_parent;
  }
  return this;
});
$c_Ljava_time_format_DateTimeFormatterBuilder.prototype.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter = (function(locale) {
  if ((locale === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "locale");
  }
  while ((this.Ljava_time_format_DateTimeFormatterBuilder__f_active.Ljava_time_format_DateTimeFormatterBuilder__f_parent !== null)) {
    this.optionalEnd__Ljava_time_format_DateTimeFormatterBuilder();
  }
  var pp = $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), this.Ljava_time_format_DateTimeFormatterBuilder__f_printerParsers, false);
  return new $c_Ljava_time_format_DateTimeFormatter(pp, locale, $m_Ljava_time_format_DecimalStyle$().STANDARD__Ljava_time_format_DecimalStyle(), $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle(), null, null, null);
});
var $d_Ljava_time_format_DateTimeFormatterBuilder = new $TypeData().initClass($c_Ljava_time_format_DateTimeFormatterBuilder, "java.time.format.DateTimeFormatterBuilder", ({
  Ljava_time_format_DateTimeFormatterBuilder: 1
}));
export { $d_Ljava_time_format_DateTimeFormatterBuilder as $d_Ljava_time_format_DateTimeFormatterBuilder };
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder$() {
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_FIELD_MAP$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_FIELD_MAPbitmap$1 = false;
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORT$lzy1 = null;
  this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORTbitmap$1 = false;
}
export { $c_Ljava_time_format_DateTimeFormatterBuilder$ as $c_Ljava_time_format_DateTimeFormatterBuilder$ };
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder$;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder$() {
}
export { $h_Ljava_time_format_DateTimeFormatterBuilder$ as $h_Ljava_time_format_DateTimeFormatterBuilder$ };
$h_Ljava_time_format_DateTimeFormatterBuilder$.prototype = $c_Ljava_time_format_DateTimeFormatterBuilder$.prototype;
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype.java$time$format$DateTimeFormatterBuilder$$$FIELD_MAP__ju_Map = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatterBuilder$__f_FIELD_MAPbitmap$1)) {
    var map = $ct_ju_HashMap__(new $c_ju_HashMap());
    var value = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(71), value, 71, false);
    var value$1 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(121), value$1, 121, false);
    var value$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(117), value$2, 117, false);
    var value$3 = $m_Ljava_time_temporal_IsoFields$().QUARTER_OF_YEAR__Ljava_time_temporal_TemporalField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(81), value$3, 81, false);
    var value$4 = $m_Ljava_time_temporal_IsoFields$().QUARTER_OF_YEAR__Ljava_time_temporal_TemporalField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(113), value$4, 113, false);
    var value$5 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(77), value$5, 77, false);
    var value$6 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(76), value$6, 76, false);
    var value$7 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(68), value$7, 68, false);
    var value$8 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(100), value$8, 100, false);
    var value$9 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(70), value$9, 70, false);
    var value$10 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(69), value$10, 69, false);
    var value$11 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(99), value$11, 99, false);
    var value$12 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(101), value$12, 101, false);
    var value$13 = $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(97), value$13, 97, false);
    var value$14 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(72), value$14, 72, false);
    var value$15 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(107), value$15, 107, false);
    var value$16 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(75), value$16, 75, false);
    var value$17 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(104), value$17, 104, false);
    var value$18 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(109), value$18, 109, false);
    var value$19 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(115), value$19, 115, false);
    var value$20 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(83), value$20, 83, false);
    var value$21 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(65), value$21, 65, false);
    var value$22 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(110), value$22, 110, false);
    var value$23 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
    map.java$util$HashMap$$put0__O__O__I__Z__O($bC(78), value$23, 78, false);
    this.Ljava_time_format_DateTimeFormatterBuilder$__f_FIELD_MAP$lzy1 = map;
    this.Ljava_time_format_DateTimeFormatterBuilder$__f_FIELD_MAPbitmap$1 = true;
  }
  return this.Ljava_time_format_DateTimeFormatterBuilder$__f_FIELD_MAP$lzy1;
});
$c_Ljava_time_format_DateTimeFormatterBuilder$.prototype.LENGTH_SORT__ju_Comparator = (function() {
  if ((!this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORTbitmap$1)) {
    this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORT$lzy1 = new $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3(this);
    this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORTbitmap$1 = true;
  }
  return this.Ljava_time_format_DateTimeFormatterBuilder$__f_LENGTH_SORT$lzy1;
});
var $d_Ljava_time_format_DateTimeFormatterBuilder$ = new $TypeData().initClass($c_Ljava_time_format_DateTimeFormatterBuilder$, "java.time.format.DateTimeFormatterBuilder$", ({
  Ljava_time_format_DateTimeFormatterBuilder$: 1
}));
export { $d_Ljava_time_format_DateTimeFormatterBuilder$ as $d_Ljava_time_format_DateTimeFormatterBuilder$ };
var $n_Ljava_time_format_DateTimeFormatterBuilder$;
function $m_Ljava_time_format_DateTimeFormatterBuilder$() {
  if ((!$n_Ljava_time_format_DateTimeFormatterBuilder$)) {
    $n_Ljava_time_format_DateTimeFormatterBuilder$ = new $c_Ljava_time_format_DateTimeFormatterBuilder$();
  }
  return $n_Ljava_time_format_DateTimeFormatterBuilder$;
}
export { $m_Ljava_time_format_DateTimeFormatterBuilder$ as $m_Ljava_time_format_DateTimeFormatterBuilder$ };
/** @constructor */
function $c_Ljava_time_format_DecimalStyle(zeroDigit, positiveSign, negativeSign, decimalSeparator) {
  this.Ljava_time_format_DecimalStyle__f_zeroDigit = 0;
  this.Ljava_time_format_DecimalStyle__f_positiveSign = 0;
  this.Ljava_time_format_DecimalStyle__f_negativeSign = 0;
  this.Ljava_time_format_DecimalStyle__f_decimalSeparator = 0;
  this.Ljava_time_format_DecimalStyle__f_zeroDigit = zeroDigit;
  this.Ljava_time_format_DecimalStyle__f_positiveSign = positiveSign;
  this.Ljava_time_format_DecimalStyle__f_negativeSign = negativeSign;
  this.Ljava_time_format_DecimalStyle__f_decimalSeparator = decimalSeparator;
}
export { $c_Ljava_time_format_DecimalStyle as $c_Ljava_time_format_DecimalStyle };
$c_Ljava_time_format_DecimalStyle.prototype = new $h_O();
$c_Ljava_time_format_DecimalStyle.prototype.constructor = $c_Ljava_time_format_DecimalStyle;
/** @constructor */
function $h_Ljava_time_format_DecimalStyle() {
}
export { $h_Ljava_time_format_DecimalStyle as $h_Ljava_time_format_DecimalStyle };
$h_Ljava_time_format_DecimalStyle.prototype = $c_Ljava_time_format_DecimalStyle.prototype;
$c_Ljava_time_format_DecimalStyle.prototype.convertToDigit__C__I = (function(ch) {
  var value = ((ch - this.Ljava_time_format_DecimalStyle__f_zeroDigit) | 0);
  return (((value >= 0) && (value <= 9)) ? value : (-1));
});
$c_Ljava_time_format_DecimalStyle.prototype.convertNumberToI18N__T__T = (function(numericText) {
  if ((this.Ljava_time_format_DecimalStyle__f_zeroDigit === 48)) {
    return numericText;
  }
  var diff = (((-48) + this.Ljava_time_format_DecimalStyle__f_zeroDigit) | 0);
  var array = $f_T__toCharArray__AC(numericText);
  var i = 0;
  while ((i < array.u.length)) {
    array.u[i] = (65535 & ((array.u[i] + diff) | 0));
    i = ((1 + i) | 0);
  }
  var this$1 = $m_jl_String$();
  return this$1.new__AC__I__I__T(array, 0, array.u.length);
});
$c_Ljava_time_format_DecimalStyle.prototype.equals__O__Z = (function(obj) {
  return ((obj instanceof $c_Ljava_time_format_DecimalStyle) && ((this === obj) || ((((this.Ljava_time_format_DecimalStyle__f_zeroDigit === obj.Ljava_time_format_DecimalStyle__f_zeroDigit) && (this.Ljava_time_format_DecimalStyle__f_positiveSign === obj.Ljava_time_format_DecimalStyle__f_positiveSign)) && (this.Ljava_time_format_DecimalStyle__f_negativeSign === obj.Ljava_time_format_DecimalStyle__f_negativeSign)) && (this.Ljava_time_format_DecimalStyle__f_decimalSeparator === obj.Ljava_time_format_DecimalStyle__f_decimalSeparator))));
});
$c_Ljava_time_format_DecimalStyle.prototype.hashCode__I = (function() {
  return ((((((this.Ljava_time_format_DecimalStyle__f_zeroDigit + this.Ljava_time_format_DecimalStyle__f_positiveSign) | 0) + this.Ljava_time_format_DecimalStyle__f_negativeSign) | 0) + this.Ljava_time_format_DecimalStyle__f_decimalSeparator) | 0);
});
$c_Ljava_time_format_DecimalStyle.prototype.toString__T = (function() {
  return ((((("DecimalStyle[" + $cToS(this.Ljava_time_format_DecimalStyle__f_zeroDigit)) + $cToS(this.Ljava_time_format_DecimalStyle__f_positiveSign)) + $cToS(this.Ljava_time_format_DecimalStyle__f_negativeSign)) + $cToS(this.Ljava_time_format_DecimalStyle__f_decimalSeparator)) + "]");
});
function $isArrayOf_Ljava_time_format_DecimalStyle(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_DecimalStyle)));
}
export { $isArrayOf_Ljava_time_format_DecimalStyle as $isArrayOf_Ljava_time_format_DecimalStyle };
var $d_Ljava_time_format_DecimalStyle = new $TypeData().initClass($c_Ljava_time_format_DecimalStyle, "java.time.format.DecimalStyle", ({
  Ljava_time_format_DecimalStyle: 1
}));
export { $d_Ljava_time_format_DecimalStyle as $d_Ljava_time_format_DecimalStyle };
/** @constructor */
function $c_Ljava_time_format_DecimalStyle$() {
  this.Ljava_time_format_DecimalStyle$__f_STANDARD$lzy1 = null;
  this.Ljava_time_format_DecimalStyle$__f_STANDARDbitmap$1 = false;
}
export { $c_Ljava_time_format_DecimalStyle$ as $c_Ljava_time_format_DecimalStyle$ };
$c_Ljava_time_format_DecimalStyle$.prototype = new $h_O();
$c_Ljava_time_format_DecimalStyle$.prototype.constructor = $c_Ljava_time_format_DecimalStyle$;
/** @constructor */
function $h_Ljava_time_format_DecimalStyle$() {
}
export { $h_Ljava_time_format_DecimalStyle$ as $h_Ljava_time_format_DecimalStyle$ };
$h_Ljava_time_format_DecimalStyle$.prototype = $c_Ljava_time_format_DecimalStyle$.prototype;
$c_Ljava_time_format_DecimalStyle$.prototype.STANDARD__Ljava_time_format_DecimalStyle = (function() {
  if ((!this.Ljava_time_format_DecimalStyle$__f_STANDARDbitmap$1)) {
    this.Ljava_time_format_DecimalStyle$__f_STANDARD$lzy1 = new $c_Ljava_time_format_DecimalStyle(48, 43, 45, 46);
    this.Ljava_time_format_DecimalStyle$__f_STANDARDbitmap$1 = true;
  }
  return this.Ljava_time_format_DecimalStyle$__f_STANDARD$lzy1;
});
var $d_Ljava_time_format_DecimalStyle$ = new $TypeData().initClass($c_Ljava_time_format_DecimalStyle$, "java.time.format.DecimalStyle$", ({
  Ljava_time_format_DecimalStyle$: 1
}));
export { $d_Ljava_time_format_DecimalStyle$ as $d_Ljava_time_format_DecimalStyle$ };
var $n_Ljava_time_format_DecimalStyle$;
function $m_Ljava_time_format_DecimalStyle$() {
  if ((!$n_Ljava_time_format_DecimalStyle$)) {
    $n_Ljava_time_format_DecimalStyle$ = new $c_Ljava_time_format_DecimalStyle$();
  }
  return $n_Ljava_time_format_DecimalStyle$;
}
export { $m_Ljava_time_format_DecimalStyle$ as $m_Ljava_time_format_DecimalStyle$ };
var $d_Ljava_time_format_internal_DateTimePrinterParser = new $TypeData().initClass(1, "java.time.format.internal.DateTimePrinterParser", ({
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_DateTimePrinterParser as $d_Ljava_time_format_internal_DateTimePrinterParser };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970 = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS = new $c_RTLong(2036907392, 73);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970 = new $c_RTLong(2037677056, 14);
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$.prototype;
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$, "java.time.format.internal.TTBPDateTimeFormatterBuilder$InstantPrinterParser$", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ };
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ as $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS = null;
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = this;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS = new $ac_I(new Int32Array([0, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000]));
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype;
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$, "java.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser$", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ };
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ as $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID = null;
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ = this;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS = new ($d_T.getArrayOf().constr)(["+HH", "+HHmm", "+HH:mm", "+HHMM", "+HH:MM", "+HHMMss", "+HH:MM:ss", "+HHMMSS", "+HH:MM:SS"]);
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser("Z", "+HH:MM:ss");
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$.prototype;
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$, "java.time.format.internal.TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ };
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ as $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$__f_BASE_DATE = null;
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ = this;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$__f_BASE_DATE = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(2000, 1, 1);
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$.prototype;
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ReducedPrinterParser$", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ };
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ as $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$cachedSubstringTree = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$cachedSubstringTree = null;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$.prototype.java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$prepareParser__ju_Set__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree = (function(availableIDs) {
  var ids = $ct_ju_ArrayList__ju_Collection__(new $c_ju_ArrayList(), availableIDs);
  var c = $m_Ljava_time_format_DateTimeFormatterBuilder$().LENGTH_SORT__ju_Comparator();
  $f_ju_List__sort__ju_Comparator__V(ids, c);
  var this$2 = ids.get__I__O(0);
  var tree = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(this$2.length);
  var idsIterator = ids.listIterator__I__ju_ListIterator(0);
  while (idsIterator.hasNext__Z()) {
    var id = idsIterator.next__O();
    tree.add__T__V(id);
  }
  return tree;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ };
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ as $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(length) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length = length;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI = $ct_ju_HashMap__(new $c_ju_HashMap());
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype.get__jl_CharSequence__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree = (function(substring2, caseSensitive) {
  if (caseSensitive) {
    return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap.get__O__O(substring2);
  } else {
    var $x_1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI;
    var string = $dp_toString__T(substring2);
    return $x_1.get__O__O(string.toLowerCase());
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree.prototype.add__T__V = (function(newSubstring) {
  var \u03b4this$tailLocal1 = this;
  while (true) {
    var idLen = newSubstring.length;
    if ((idLen === \u03b4this$tailLocal1.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length)) {
      \u03b4this$tailLocal1.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap.put__O__O__O(newSubstring, null);
      \u03b4this$tailLocal1.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI.put__O__O__O(newSubstring.toLowerCase(), null);
      return (void 0);
    } else if ((idLen > \u03b4this$tailLocal1.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length)) {
      var endIndex = \u03b4this$tailLocal1.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length;
      var substring = newSubstring.substring(0, endIndex);
      var parserTree = \u03b4this$tailLocal1.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap.get__O__O(substring);
      if ((parserTree === null)) {
        parserTree = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(idLen);
        \u03b4this$tailLocal1.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMap.put__O__O__O(substring, parserTree);
        \u03b4this$tailLocal1.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_substringMapCI.put__O__O__O(substring.toLowerCase(), parserTree);
      }
      \u03b4this$tailLocal1 = parserTree;
    } else {
      return (void 0);
    }
  }
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_LENGTH_COMPARATOR$lzy1 = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_LENGTH_COMPARATORbitmap$1 = false;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$.prototype.java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$$LENGTH_COMPARATOR__s_math_Ordering = (function() {
  if ((!this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_LENGTH_COMPARATORbitmap$1)) {
    this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_LENGTH_COMPARATOR$lzy1 = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5(this);
    this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_LENGTH_COMPARATORbitmap$1 = true;
  }
  return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$__f_LENGTH_COMPARATOR$lzy1;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ };
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ as $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$ };
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, locale, symbols, overrideChronology, overrideZone, caseSensitive, strict) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale = locale;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols = symbols;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology = overrideChronology;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideZone = overrideZone;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = caseSensitive;
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = strict;
  var list = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  list.add__O__Z(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed($thiz));
  $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed = list;
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__ as $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__ };
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__($thiz, formatter) {
  $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, formatter.Ljava_time_format_DateTimeFormatter__f_locale, formatter.Ljava_time_format_DateTimeFormatter__f_decimalStyle, formatter.Ljava_time_format_DateTimeFormatter__f_chrono, formatter.Ljava_time_format_DateTimeFormatter__f_zone, true, true);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__ as $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__ };
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__($thiz, other) {
  $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideZone, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive, other.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__ as $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__ };
function $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed($thiz) {
  return $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.get__I__O((((-1) + $thiz.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.size__I()) | 0));
}
export { $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed as $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext() {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideZone = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed = null;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeParseContext as $c_Ljava_time_format_internal_TTBPDateTimeParseContext };
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeParseContext as $h_Ljava_time_format_internal_TTBPDateTimeParseContext };
$h_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype = $c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.getEffectiveChronology__Ljava_time_chrono_Chronology = (function() {
  var chrono = $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono;
  if ((chrono === null)) {
    chrono = this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideChronology;
    if ((chrono === null)) {
      chrono = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    }
  }
  return chrono;
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z = (function(cs1, offset1, cs2, offset2, length) {
  if (((((offset1 + length) | 0) > $dp_length__I(cs1)) || (((offset2 + length) | 0) > $dp_length__I(cs2)))) {
    return false;
  }
  if (this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive) {
    var i = 0;
    while ((i < length)) {
      var ch1 = $dp_charAt__I__C(cs1, ((offset1 + i) | 0));
      var ch2 = $dp_charAt__I__C(cs2, ((offset2 + i) | 0));
      if ((ch1 !== ch2)) {
        return false;
      }
      i = ((1 + i) | 0);
    }
  } else {
    var i$2 = 0;
    while ((i$2 < length)) {
      var ch1$2 = $dp_charAt__I__C(cs1, ((offset1 + i$2) | 0));
      var ch2$2 = $dp_charAt__I__C(cs2, ((offset2 + i$2) | 0));
      if ((((ch1$2 !== ch2$2) && ($m_jl_Character$().toUpperCase__C__C(ch1$2) !== $m_jl_Character$().toUpperCase__C__C(ch2$2))) && ($m_jl_Character$().toLowerCase__C__C(ch1$2) !== $m_jl_Character$().toLowerCase__C__C(ch2$2)))) {
        return false;
      }
      i$2 = ((1 + i$2) | 0);
    }
  }
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.charEquals__C__C__Z = (function(ch1, ch2) {
  return (this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive ? (ch1 === ch2) : $m_Ljava_time_format_internal_TTBPDateTimeParseContext$().charEqualsIgnoreCase__C__C__Z(ch1, ch2));
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.startOptional__V = (function() {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.add__O__Z($p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).copy__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed());
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.endOptional__Z__V = (function(successful) {
  if (successful) {
    this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.remove__I__O((((-2) + this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.size__I()) | 0));
  } else {
    this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.remove__I__O((((-1) + this.Ljava_time_format_internal_TTBPDateTimeParseContext__f_parsed.size__I()) | 0));
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.getParsed__Ljava_time_temporal_TemporalField__jl_Long = (function(field) {
  return $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.get__O__O(field);
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I = (function(field, value, errorPos, successPos) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field");
  }
  var old = $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.put__O__O__O(field, value);
  return (((old !== null) && (!((old.RTLong__f_lo === value.RTLong__f_lo) && (old.RTLong__f_hi === value.RTLong__f_hi)))) ? (~errorPos) : successPos);
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.addChronologyChangedParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__J__I__I__V = (function(reducedPrinterParser, value, errorPos, successPos) {
  var _currentParsed = $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this);
  if ((_currentParsed.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_callbacks === null)) {
    _currentParsed.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_callbacks = $ct_ju_ArrayList__I__(new $c_ju_ArrayList(), 2);
  }
  _currentParsed.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_callbacks.add__O__Z(new $ac_O([reducedPrinterParser, value, errorPos, successPos]));
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.setParsed__Ljava_time_ZoneId__V = (function(zone) {
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone");
  }
  $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone = zone;
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype.toString__T = (function() {
  return $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).toString__T();
});
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeParseContext, "java.time.format.internal.TTBPDateTimeParseContext", ({
  Ljava_time_format_internal_TTBPDateTimeParseContext: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeParseContext as $d_Ljava_time_format_internal_TTBPDateTimeParseContext };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
}
export { $c_Ljava_time_format_internal_TTBPDateTimeParseContext$ as $c_Ljava_time_format_internal_TTBPDateTimeParseContext$ };
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeParseContext$ as $h_Ljava_time_format_internal_TTBPDateTimeParseContext$ };
$h_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$.prototype.charEqualsIgnoreCase__C__C__Z = (function(c1, c2) {
  return (((c1 === c2) || ($m_jl_Character$().toUpperCase__C__C(c1) === $m_jl_Character$().toUpperCase__C__C(c2))) || ($m_jl_Character$().toLowerCase__C__C(c1) === $m_jl_Character$().toLowerCase__C__C(c2)));
});
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeParseContext$, "java.time.format.internal.TTBPDateTimeParseContext$", ({
  Ljava_time_format_internal_TTBPDateTimeParseContext$: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeParseContext$ as $d_Ljava_time_format_internal_TTBPDateTimeParseContext$ };
var $n_Ljava_time_format_internal_TTBPDateTimeParseContext$;
function $m_Ljava_time_format_internal_TTBPDateTimeParseContext$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeParseContext$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeParseContext$ = new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeParseContext$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeParseContext$ as $m_Ljava_time_format_internal_TTBPDateTimeParseContext$ };
function $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__($thiz, temporal, locale, symbols) {
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal = temporal;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale = locale;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols = symbols;
  $thiz.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = 0;
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__ as $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__ };
function $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__($thiz, temporal, formatter) {
  $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__($thiz, $m_Ljava_time_format_internal_TTBPDateTimePrintContext$().adjust__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__Ljava_time_temporal_TemporalAccessor(temporal, formatter), formatter.Ljava_time_format_DateTimeFormatter__f_locale, formatter.Ljava_time_format_DateTimeFormatter__f_decimalStyle);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__ as $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext() {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = 0;
}
export { $c_Ljava_time_format_internal_TTBPDateTimePrintContext as $c_Ljava_time_format_internal_TTBPDateTimePrintContext };
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimePrintContext as $h_Ljava_time_format_internal_TTBPDateTimePrintContext };
$h_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.startOptional__V = (function() {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = ((1 + this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional) | 0);
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.endOptional__V = (function() {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional = (((-1) + this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional) | 0);
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.getValue__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var result = this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal.query__Ljava_time_temporal_TemporalQuery__O(query);
  if (((result === null) && (this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional === 0))) {
    var this$1 = this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal;
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Unable to extract value: " + $objectGetClass(this$1)));
  } else {
    return result;
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.getValue__Ljava_time_temporal_TemporalField__jl_Long = (function(field) {
  try {
    var t = this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal.getLong__Ljava_time_temporal_TemporalField__J(field);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_RTLong(lo, hi);
  } catch (e) {
    if ((e instanceof $c_Ljava_time_DateTimeException)) {
      var ex = e;
      if ((this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_optional > 0)) {
        return null;
      } else {
        throw ex;
      }
    } else {
      throw e;
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype.toString__T = (function() {
  return this.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal.toString__T();
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimePrintContext, "java.time.format.internal.TTBPDateTimePrintContext", ({
  Ljava_time_format_internal_TTBPDateTimePrintContext: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimePrintContext as $d_Ljava_time_format_internal_TTBPDateTimePrintContext };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
}
export { $c_Ljava_time_format_internal_TTBPDateTimePrintContext$ as $c_Ljava_time_format_internal_TTBPDateTimePrintContext$ };
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimePrintContext$ as $h_Ljava_time_format_internal_TTBPDateTimePrintContext$ };
$h_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype.adjust__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__Ljava_time_temporal_TemporalAccessor = (function(temporal, formatter) {
  var elem = formatter.Ljava_time_format_DateTimeFormatter__f_chrono;
  var overrideChrono = new $c_sr_ObjectRef(elem);
  var overrideZone = formatter.Ljava_time_format_DateTimeFormatter__f_zone;
  if (((overrideChrono.sr_ObjectRef__f_elem === null) && (overrideZone === null))) {
    return temporal;
  } else {
    var temporalChrono = temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery());
    var temporalZone = temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery());
    var b = overrideChrono.sr_ObjectRef__f_elem;
    if (((temporalChrono === null) ? (b === null) : $f_Ljava_time_chrono_Chronology__equals__O__Z(temporalChrono, b))) {
      var ev$2 = null;
      overrideChrono.sr_ObjectRef__f_elem = ev$2;
    }
    var b$1 = overrideZone;
    if (((temporalZone === null) ? (b$1 === null) : temporalZone.equals__O__Z(b$1))) {
      overrideZone = null;
    }
    if (((overrideChrono.sr_ObjectRef__f_elem === null) && (overrideZone === null))) {
      return temporal;
    }
    var effectiveChrono = ((overrideChrono.sr_ObjectRef__f_elem !== null) ? overrideChrono.sr_ObjectRef__f_elem : temporalChrono);
    var effectiveZone = ((overrideZone !== null) ? overrideZone : temporalZone);
    if ((overrideZone !== null)) {
      if (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
        if ((effectiveChrono !== null)) {
        } else {
          $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
        }
        var instant = $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(temporal);
        var zone = overrideZone;
        return $m_Ljava_time_ZonedDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(instant, zone);
      }
      var normalizedOffset = overrideZone.normalized__Ljava_time_ZoneId();
      var temporalOffset = temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery());
      if ((((normalizedOffset instanceof $c_Ljava_time_ZoneOffset) && (temporalOffset !== null)) && (!((normalizedOffset === null) ? (temporalOffset === null) : normalizedOffset.equals__O__Z(temporalOffset))))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid override zone for temporal: " + overrideZone) + " ") + temporal));
      }
    }
    if ((overrideChrono.sr_ObjectRef__f_elem !== null)) {
      if (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
        var effectiveDate = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal);
      } else {
        if ((!((overrideChrono.sr_ObjectRef__f_elem === $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology()) && (temporalChrono === null)))) {
          var xs = $m_Ljava_time_temporal_ChronoField$().values__ALjava_time_temporal_ChronoField();
          var f$1 = ((f) => {
            if ((f.isDateBased__Z() && temporal.isSupported__Ljava_time_temporal_TemporalField__Z(f))) {
              throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid override chronology for temporal: " + overrideChrono.sr_ObjectRef__f_elem) + " ") + temporal));
            }
          });
          var len = xs.u.length;
          var i = 0;
          if ((xs !== null)) {
            while ((i < len)) {
              var x0 = xs.u[i];
              f$1(x0);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_I)) {
            while ((i < len)) {
              var x0$1 = xs.u[i];
              f$1(x0$1);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_D)) {
            while ((i < len)) {
              var x0$2 = xs.u[i];
              f$1(x0$2);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_J)) {
            while ((i < len)) {
              var t = xs.u[i];
              var lo = t.RTLong__f_lo;
              var hi = t.RTLong__f_hi;
              f$1(new $c_RTLong(lo, hi));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_F)) {
            while ((i < len)) {
              var x0$3 = xs.u[i];
              f$1(x0$3);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_C)) {
            while ((i < len)) {
              var x0$4 = xs.u[i];
              f$1($bC(x0$4));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_B)) {
            while ((i < len)) {
              var x0$5 = xs.u[i];
              f$1(x0$5);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_S)) {
            while ((i < len)) {
              var x0$6 = xs.u[i];
              f$1(x0$6);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $ac_Z)) {
            while ((i < len)) {
              var x0$7 = xs.u[i];
              f$1(x0$7);
              i = ((1 + i) | 0);
            }
          } else {
            throw new $c_s_MatchError(xs);
          }
        }
        var effectiveDate = null;
      }
    } else {
      var effectiveDate = null;
    }
    return new $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1(effectiveDate, temporal, effectiveChrono, effectiveZone, this);
  }
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimePrintContext$, "java.time.format.internal.TTBPDateTimePrintContext$", ({
  Ljava_time_format_internal_TTBPDateTimePrintContext$: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimePrintContext$ as $d_Ljava_time_format_internal_TTBPDateTimePrintContext$ };
var $n_Ljava_time_format_internal_TTBPDateTimePrintContext$;
function $m_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimePrintContext$)) {
    $n_Ljava_time_format_internal_TTBPDateTimePrintContext$ = new $c_Ljava_time_format_internal_TTBPDateTimePrintContext$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimePrintContext$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimePrintContext$ as $m_Ljava_time_format_internal_TTBPDateTimePrintContext$ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeTextProvider() {
}
export { $c_Ljava_time_format_internal_TTBPDateTimeTextProvider as $c_Ljava_time_format_internal_TTBPDateTimeTextProvider };
$c_Ljava_time_format_internal_TTBPDateTimeTextProvider.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeTextProvider.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeTextProvider;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeTextProvider() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeTextProvider as $h_Ljava_time_format_internal_TTBPDateTimeTextProvider };
$h_Ljava_time_format_internal_TTBPDateTimeTextProvider.prototype = $c_Ljava_time_format_internal_TTBPDateTimeTextProvider.prototype;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeTextProvider$() {
  this.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_Provider$lzy1 = null;
  this.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_Providerbitmap$1 = false;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeTextProvider$ as $c_Ljava_time_format_internal_TTBPDateTimeTextProvider$ };
$c_Ljava_time_format_internal_TTBPDateTimeTextProvider$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeTextProvider$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeTextProvider$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeTextProvider$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeTextProvider$ as $h_Ljava_time_format_internal_TTBPDateTimeTextProvider$ };
$h_Ljava_time_format_internal_TTBPDateTimeTextProvider$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeTextProvider$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeTextProvider$.prototype.Provider__Ljava_time_format_internal_TTBPDateTimeTextProvider = (function() {
  if ((!this.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_Providerbitmap$1)) {
    this.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_Provider$lzy1 = new $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider();
    this.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_Providerbitmap$1 = true;
  }
  return this.Ljava_time_format_internal_TTBPDateTimeTextProvider$__f_Provider$lzy1;
});
var $d_Ljava_time_format_internal_TTBPDateTimeTextProvider$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeTextProvider$, "java.time.format.internal.TTBPDateTimeTextProvider$", ({
  Ljava_time_format_internal_TTBPDateTimeTextProvider$: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeTextProvider$ as $d_Ljava_time_format_internal_TTBPDateTimeTextProvider$ };
var $n_Ljava_time_format_internal_TTBPDateTimeTextProvider$;
function $m_Ljava_time_format_internal_TTBPDateTimeTextProvider$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeTextProvider$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeTextProvider$ = new $c_Ljava_time_format_internal_TTBPDateTimeTextProvider$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeTextProvider$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeTextProvider$ as $m_Ljava_time_format_internal_TTBPDateTimeTextProvider$ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$() {
}
export { $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ as $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ };
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$.prototype.constructor = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$() {
}
export { $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ as $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ };
$h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$.prototype = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$.prototype;
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$.prototype.java$time$format$internal$TTBPSimpleDateTimeTextProvider$$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore = (function(valueTextMap) {
  var self = $s_Ljava_time_format_TextStyle$__FULL_STANDALONE__Ljava_time_format_TextStyle();
  var this$3 = valueTextMap.get__O__s_Option($s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle());
  var y = (this$3.isEmpty__Z() ? null : this$3.get__O());
  var $x_1 = valueTextMap.$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self, y));
  var self$1 = $s_Ljava_time_format_TextStyle$__SHORT_STANDALONE__Ljava_time_format_TextStyle();
  var this$7 = valueTextMap.get__O__s_Option($s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle());
  var y$1 = (this$7.isEmpty__Z() ? null : this$7.get__O());
  var tmp1 = $x_1.$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self$1, y$1));
  if ((valueTextMap.contains__O__Z($s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle()) && (!valueTextMap.contains__O__Z($s_Ljava_time_format_TextStyle$__NARROW_STANDALONE__Ljava_time_format_TextStyle())))) {
    var self$2 = $s_Ljava_time_format_TextStyle$__NARROW_STANDALONE__Ljava_time_format_TextStyle();
    var this$11 = valueTextMap.get__O__s_Option($s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle());
    var y$2 = (this$11.isEmpty__Z() ? null : this$11.get__O());
    var tmp2 = tmp1.$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self$2, y$2));
  } else {
    var tmp2 = tmp1;
  }
  return new $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(tmp2);
});
var $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$, "java.time.format.internal.TTBPSimpleDateTimeTextProvider$", ({
  Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$: 1
}));
export { $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ as $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ };
var $n_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$;
function $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$() {
  if ((!$n_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$)) {
    $n_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ = new $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$();
  }
  return $n_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$;
}
export { $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ as $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$ };
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$() {
  this.Ljava_time_temporal_IsoFields$__f_QUARTER_OF_YEAR$lzy1 = null;
  this.Ljava_time_temporal_IsoFields$__f_QUARTER_OF_YEARbitmap$1 = false;
  this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEAR$lzy1 = null;
  this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARbitmap$1 = false;
  this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARS$lzy1 = null;
  this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARSbitmap$1 = false;
}
export { $c_Ljava_time_temporal_IsoFields$ as $c_Ljava_time_temporal_IsoFields$ };
$c_Ljava_time_temporal_IsoFields$.prototype = new $h_O();
$c_Ljava_time_temporal_IsoFields$.prototype.constructor = $c_Ljava_time_temporal_IsoFields$;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$() {
}
export { $h_Ljava_time_temporal_IsoFields$ as $h_Ljava_time_temporal_IsoFields$ };
$h_Ljava_time_temporal_IsoFields$.prototype = $c_Ljava_time_temporal_IsoFields$.prototype;
$c_Ljava_time_temporal_IsoFields$.prototype.QUARTER_OF_YEAR__Ljava_time_temporal_TemporalField = (function() {
  if ((!this.Ljava_time_temporal_IsoFields$__f_QUARTER_OF_YEARbitmap$1)) {
    this.Ljava_time_temporal_IsoFields$__f_QUARTER_OF_YEAR$lzy1 = $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field();
    this.Ljava_time_temporal_IsoFields$__f_QUARTER_OF_YEARbitmap$1 = true;
  }
  return this.Ljava_time_temporal_IsoFields$__f_QUARTER_OF_YEAR$lzy1;
});
$c_Ljava_time_temporal_IsoFields$.prototype.WEEK_BASED_YEAR__Ljava_time_temporal_TemporalField = (function() {
  if ((!this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARbitmap$1)) {
    this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEAR$lzy1 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
    this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARbitmap$1 = true;
  }
  return this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEAR$lzy1;
});
$c_Ljava_time_temporal_IsoFields$.prototype.WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit = (function() {
  if ((!this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARSbitmap$1)) {
    this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARS$lzy1 = $s_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS__Ljava_time_temporal_IsoFields$Unit();
    this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARSbitmap$1 = true;
  }
  return this.Ljava_time_temporal_IsoFields$__f_WEEK_BASED_YEARS$lzy1;
});
var $d_Ljava_time_temporal_IsoFields$ = new $TypeData().initClass($c_Ljava_time_temporal_IsoFields$, "java.time.temporal.IsoFields$", ({
  Ljava_time_temporal_IsoFields$: 1
}));
export { $d_Ljava_time_temporal_IsoFields$ as $d_Ljava_time_temporal_IsoFields$ };
var $n_Ljava_time_temporal_IsoFields$;
function $m_Ljava_time_temporal_IsoFields$() {
  if ((!$n_Ljava_time_temporal_IsoFields$)) {
    $n_Ljava_time_temporal_IsoFields$ = new $c_Ljava_time_temporal_IsoFields$();
  }
  return $n_Ljava_time_temporal_IsoFields$;
}
export { $m_Ljava_time_temporal_IsoFields$ as $m_Ljava_time_temporal_IsoFields$ };
function $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange($thiz, field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ($thiz.isSupported__Ljava_time_temporal_TemporalField__Z(field)) {
      return field.range__Ljava_time_temporal_ValueRange();
    } else {
      throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
    }
  } else {
    return field.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange($thiz);
  }
}
export { $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange as $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange };
function $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I($thiz, field) {
  return $thiz.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($thiz.getLong__Ljava_time_temporal_TemporalField__J(field), field);
}
export { $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I as $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I };
function $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  matchAlts1: {
    matchAlts2: {
      var x = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x === query)) {
        break matchAlts2;
      }
      var x$3 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
      if ((x$3 === query)) {
        break matchAlts2;
      }
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === query)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return query.queryFrom__Ljava_time_temporal_TemporalAccessor__O($thiz);
}
export { $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O as $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$() {
  this.Ljava_time_temporal_TemporalQueries$__f_zoneId$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_zoneIdbitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_chronology$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_chronologybitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_precision$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_precisionbitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_offset$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_offsetbitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_zone$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_zonebitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_localDate$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_localDatebitmap$1 = false;
  this.Ljava_time_temporal_TemporalQueries$__f_localTime$lzy1 = null;
  this.Ljava_time_temporal_TemporalQueries$__f_localTimebitmap$1 = false;
}
export { $c_Ljava_time_temporal_TemporalQueries$ as $c_Ljava_time_temporal_TemporalQueries$ };
$c_Ljava_time_temporal_TemporalQueries$.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$() {
}
export { $h_Ljava_time_temporal_TemporalQueries$ as $h_Ljava_time_temporal_TemporalQueries$ };
$h_Ljava_time_temporal_TemporalQueries$.prototype = $c_Ljava_time_temporal_TemporalQueries$.prototype;
$c_Ljava_time_temporal_TemporalQueries$.prototype.zoneId__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_zoneIdbitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_zoneId$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$1(this);
    this.Ljava_time_temporal_TemporalQueries$__f_zoneIdbitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_zoneId$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.chronology__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_chronologybitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_chronology$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$2(this);
    this.Ljava_time_temporal_TemporalQueries$__f_chronologybitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_chronology$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.precision__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_precisionbitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_precision$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$3(this);
    this.Ljava_time_temporal_TemporalQueries$__f_precisionbitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_precision$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.offset__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_offsetbitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_offset$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$4(this);
    this.Ljava_time_temporal_TemporalQueries$__f_offsetbitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_offset$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.zone__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_zonebitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_zone$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$5(this);
    this.Ljava_time_temporal_TemporalQueries$__f_zonebitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_zone$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.localDate__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_localDatebitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_localDate$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$6(this);
    this.Ljava_time_temporal_TemporalQueries$__f_localDatebitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_localDate$lzy1;
});
$c_Ljava_time_temporal_TemporalQueries$.prototype.localTime__Ljava_time_temporal_TemporalQuery = (function() {
  if ((!this.Ljava_time_temporal_TemporalQueries$__f_localTimebitmap$1)) {
    this.Ljava_time_temporal_TemporalQueries$__f_localTime$lzy1 = new $c_Ljava_time_temporal_TemporalQueries$$anon$7(this);
    this.Ljava_time_temporal_TemporalQueries$__f_localTimebitmap$1 = true;
  }
  return this.Ljava_time_temporal_TemporalQueries$__f_localTime$lzy1;
});
var $d_Ljava_time_temporal_TemporalQueries$ = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$, "java.time.temporal.TemporalQueries$", ({
  Ljava_time_temporal_TemporalQueries$: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$ as $d_Ljava_time_temporal_TemporalQueries$ };
var $n_Ljava_time_temporal_TemporalQueries$;
function $m_Ljava_time_temporal_TemporalQueries$() {
  if ((!$n_Ljava_time_temporal_TemporalQueries$)) {
    $n_Ljava_time_temporal_TemporalQueries$ = new $c_Ljava_time_temporal_TemporalQueries$();
  }
  return $n_Ljava_time_temporal_TemporalQueries$;
}
export { $m_Ljava_time_temporal_TemporalQueries$ as $m_Ljava_time_temporal_TemporalQueries$ };
/** @constructor */
function $c_Ljava_time_temporal_ValueRange$() {
}
export { $c_Ljava_time_temporal_ValueRange$ as $c_Ljava_time_temporal_ValueRange$ };
$c_Ljava_time_temporal_ValueRange$.prototype = new $h_O();
$c_Ljava_time_temporal_ValueRange$.prototype.constructor = $c_Ljava_time_temporal_ValueRange$;
/** @constructor */
function $h_Ljava_time_temporal_ValueRange$() {
}
export { $h_Ljava_time_temporal_ValueRange$ as $h_Ljava_time_temporal_ValueRange$ };
$h_Ljava_time_temporal_ValueRange$.prototype = $c_Ljava_time_temporal_ValueRange$.prototype;
$c_Ljava_time_temporal_ValueRange$.prototype.of__J__J__Ljava_time_temporal_ValueRange = (function(min, max) {
  var ahi = min.RTLong__f_hi;
  var bhi = max.RTLong__f_hi;
  if (((ahi === bhi) ? ((min.RTLong__f_lo >>> 0) > (max.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Minimum value must be less than maximum value");
  } else {
    return new $c_Ljava_time_temporal_ValueRange(min, min, max, max);
  }
});
$c_Ljava_time_temporal_ValueRange$.prototype.of__J__J__J__J__Ljava_time_temporal_ValueRange = (function(minSmallest, minLargest, maxSmallest, maxLargest) {
  var ahi = minSmallest.RTLong__f_hi;
  var bhi = minLargest.RTLong__f_hi;
  if (((ahi === bhi) ? ((minSmallest.RTLong__f_lo >>> 0) > (minLargest.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Smallest minimum value must be less than largest minimum value");
  }
  var ahi$1 = maxSmallest.RTLong__f_hi;
  var bhi$1 = maxLargest.RTLong__f_hi;
  if (((ahi$1 === bhi$1) ? ((maxSmallest.RTLong__f_lo >>> 0) > (maxLargest.RTLong__f_lo >>> 0)) : (ahi$1 > bhi$1))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Smallest maximum value must be less than largest maximum value");
  }
  var ahi$2 = minLargest.RTLong__f_hi;
  var bhi$2 = maxLargest.RTLong__f_hi;
  if (((ahi$2 === bhi$2) ? ((minLargest.RTLong__f_lo >>> 0) > (maxLargest.RTLong__f_lo >>> 0)) : (ahi$2 > bhi$2))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Minimum value must be less than maximum value");
  }
  return new $c_Ljava_time_temporal_ValueRange(minSmallest, minLargest, maxSmallest, maxLargest);
});
var $d_Ljava_time_temporal_ValueRange$ = new $TypeData().initClass($c_Ljava_time_temporal_ValueRange$, "java.time.temporal.ValueRange$", ({
  Ljava_time_temporal_ValueRange$: 1
}));
export { $d_Ljava_time_temporal_ValueRange$ as $d_Ljava_time_temporal_ValueRange$ };
var $n_Ljava_time_temporal_ValueRange$;
function $m_Ljava_time_temporal_ValueRange$() {
  if ((!$n_Ljava_time_temporal_ValueRange$)) {
    $n_Ljava_time_temporal_ValueRange$ = new $c_Ljava_time_temporal_ValueRange$();
  }
  return $n_Ljava_time_temporal_ValueRange$;
}
export { $m_Ljava_time_temporal_ValueRange$ as $m_Ljava_time_temporal_ValueRange$ };
function $p_Ljava_time_temporal_WeekFields$__CACHE__ju_Map($thiz) {
  if ((!$thiz.Ljava_time_temporal_WeekFields$__f_CACHEbitmap$1)) {
    $thiz.Ljava_time_temporal_WeekFields$__f_CACHE$lzy1 = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_temporal_WeekFields$__f_CACHEbitmap$1 = true;
  }
  return $thiz.Ljava_time_temporal_WeekFields$__f_CACHE$lzy1;
}
export { $p_Ljava_time_temporal_WeekFields$__CACHE__ju_Map as $p_Ljava_time_temporal_WeekFields$__CACHE__ju_Map };
/** @constructor */
function $c_Ljava_time_temporal_WeekFields$() {
  this.Ljava_time_temporal_WeekFields$__f_CACHE$lzy1 = null;
  this.Ljava_time_temporal_WeekFields$__f_CACHEbitmap$1 = false;
}
export { $c_Ljava_time_temporal_WeekFields$ as $c_Ljava_time_temporal_WeekFields$ };
$c_Ljava_time_temporal_WeekFields$.prototype = new $h_O();
$c_Ljava_time_temporal_WeekFields$.prototype.constructor = $c_Ljava_time_temporal_WeekFields$;
/** @constructor */
function $h_Ljava_time_temporal_WeekFields$() {
}
export { $h_Ljava_time_temporal_WeekFields$ as $h_Ljava_time_temporal_WeekFields$ };
$h_Ljava_time_temporal_WeekFields$.prototype = $c_Ljava_time_temporal_WeekFields$.prototype;
$c_Ljava_time_temporal_WeekFields$.prototype.of__ju_Locale__Ljava_time_temporal_WeekFields = (function(locale) {
  if ((locale === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "locale");
  }
  var dow = $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek();
  return $m_Ljava_time_temporal_WeekFields$().of__Ljava_time_DayOfWeek__I__Ljava_time_temporal_WeekFields(dow, 1);
});
$c_Ljava_time_temporal_WeekFields$.prototype.of__Ljava_time_DayOfWeek__I__Ljava_time_temporal_WeekFields = (function(firstDayOfWeek, minimalDaysInFirstWeek) {
  var key = (("" + firstDayOfWeek.jl_Enum__f__name) + minimalDaysInFirstWeek);
  var rules = $p_Ljava_time_temporal_WeekFields$__CACHE__ju_Map(this).get__O__O(key);
  if ((rules === null)) {
    rules = new $c_Ljava_time_temporal_WeekFields(firstDayOfWeek, minimalDaysInFirstWeek);
    $p_Ljava_time_temporal_WeekFields$__CACHE__ju_Map(this).put__O__O__O(key, rules);
    rules = $p_Ljava_time_temporal_WeekFields$__CACHE__ju_Map(this).get__O__O(key);
  }
  return rules;
});
var $d_Ljava_time_temporal_WeekFields$ = new $TypeData().initClass($c_Ljava_time_temporal_WeekFields$, "java.time.temporal.WeekFields$", ({
  Ljava_time_temporal_WeekFields$: 1
}));
export { $d_Ljava_time_temporal_WeekFields$ as $d_Ljava_time_temporal_WeekFields$ };
var $n_Ljava_time_temporal_WeekFields$;
function $m_Ljava_time_temporal_WeekFields$() {
  if ((!$n_Ljava_time_temporal_WeekFields$)) {
    $n_Ljava_time_temporal_WeekFields$ = new $c_Ljava_time_temporal_WeekFields$();
  }
  return $n_Ljava_time_temporal_WeekFields$;
}
export { $m_Ljava_time_temporal_WeekFields$ as $m_Ljava_time_temporal_WeekFields$ };
/** @constructor */
function $c_Ljava_time_zone_StandardZoneRules$() {
}
export { $c_Ljava_time_zone_StandardZoneRules$ as $c_Ljava_time_zone_StandardZoneRules$ };
$c_Ljava_time_zone_StandardZoneRules$.prototype = new $h_O();
$c_Ljava_time_zone_StandardZoneRules$.prototype.constructor = $c_Ljava_time_zone_StandardZoneRules$;
/** @constructor */
function $h_Ljava_time_zone_StandardZoneRules$() {
}
export { $h_Ljava_time_zone_StandardZoneRules$ as $h_Ljava_time_zone_StandardZoneRules$ };
$h_Ljava_time_zone_StandardZoneRules$.prototype = $c_Ljava_time_zone_StandardZoneRules$.prototype;
$c_Ljava_time_zone_StandardZoneRules$.prototype.apply__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_StandardZoneRules = (function(baseStandardOffset, baseWallOffset, standardOffsetTransitionList, transitionList, lastRules) {
  var dimensions = new $ac_I(new Int32Array([standardOffsetTransitionList.size__I()]));
  var standardTransitions = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_J.getClassOf(), dimensions);
  var dimensions$1 = new $ac_I(new Int32Array([((1 + standardOffsetTransitionList.size__I()) | 0)]));
  var standardOffsets = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_ZoneOffset.getClassOf(), dimensions$1);
  standardOffsets.u[0] = baseStandardOffset;
  var i = 0;
  while ((i < standardOffsetTransitionList.size__I())) {
    var $x_1 = i;
    var this$3 = standardOffsetTransitionList.get__I__O(i);
    standardTransitions.u[$x_1] = this$3.Ljava_time_zone_ZoneOffsetTransition__f_transition.toEpochSecond__Ljava_time_ZoneOffset__J(this$3.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
    var $x_2 = i;
    var this$4 = standardOffsetTransitionList.get__I__O(i);
    standardOffsets.u[((1 + $x_2) | 0)] = this$4.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
    i = ((1 + i) | 0);
  }
  var localTransitionList = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  var localTransitionOffsetList = $ct_ju_ArrayList__(new $c_ju_ArrayList());
  localTransitionOffsetList.add__O__Z(baseWallOffset);
  var transitions = transitionList.iterator__ju_Iterator();
  while (transitions.hasNext__Z()) {
    var trans = transitions.next__O();
    if (trans.isGap__Z()) {
      localTransitionList.add__O__Z(trans.Ljava_time_zone_ZoneOffsetTransition__f_transition);
      var this$6 = trans.Ljava_time_zone_ZoneOffsetTransition__f_transition;
      var value = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(trans);
      var hi = (value >> 31);
      localTransitionList.add__O__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$6, this$6.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value, hi), $L0, 1));
    } else {
      var this$8 = trans.Ljava_time_zone_ZoneOffsetTransition__f_transition;
      var value$1 = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(trans);
      var hi$1 = (value$1 >> 31);
      localTransitionList.add__O__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$8, this$8.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value$1, hi$1), $L0, 1));
      localTransitionList.add__O__Z(trans.Ljava_time_zone_ZoneOffsetTransition__f_transition);
    }
    localTransitionOffsetList.add__O__Z(trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter);
  }
  var dimensions$2 = new $ac_I(new Int32Array([localTransitionList.size__I()]));
  var savingsLocalTransitions = localTransitionList.toArray__AO__AO($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_LocalDateTime.getClassOf(), dimensions$2));
  var dimensions$3 = new $ac_I(new Int32Array([localTransitionOffsetList.size__I()]));
  var wallOffsets = localTransitionOffsetList.toArray__AO__AO($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_ZoneOffset.getClassOf(), dimensions$3));
  var dimensions$4 = new $ac_I(new Int32Array([transitionList.size__I()]));
  var savingsInstantTransitions = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_J.getClassOf(), dimensions$4);
  var i$2 = 0;
  while ((i$2 < transitionList.size__I())) {
    var $x_3 = i$2;
    var this$12 = transitionList.get__I__O(i$2);
    var this$13 = this$12.Ljava_time_zone_ZoneOffsetTransition__f_transition.toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant(this$12.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
    savingsInstantTransitions.u[$x_3] = this$13.Ljava_time_Instant__f_seconds;
    i$2 = ((1 + i$2) | 0);
  }
  if ((lastRules.size__I() > 15)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Too many transition rules");
  }
  var dimensions$5 = new $ac_I(new Int32Array([lastRules.size__I()]));
  var resultLastRules = lastRules.toArray__AO__AO($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_zone_ZoneOffsetTransitionRule.getClassOf(), dimensions$5));
  return new $c_Ljava_time_zone_StandardZoneRules(standardTransitions, standardOffsets, savingsInstantTransitions, wallOffsets, resultLastRules, savingsLocalTransitions);
});
var $d_Ljava_time_zone_StandardZoneRules$ = new $TypeData().initClass($c_Ljava_time_zone_StandardZoneRules$, "java.time.zone.StandardZoneRules$", ({
  Ljava_time_zone_StandardZoneRules$: 1
}));
export { $d_Ljava_time_zone_StandardZoneRules$ as $d_Ljava_time_zone_StandardZoneRules$ };
var $n_Ljava_time_zone_StandardZoneRules$;
function $m_Ljava_time_zone_StandardZoneRules$() {
  if ((!$n_Ljava_time_zone_StandardZoneRules$)) {
    $n_Ljava_time_zone_StandardZoneRules$ = new $c_Ljava_time_zone_StandardZoneRules$();
  }
  return $n_Ljava_time_zone_StandardZoneRules$;
}
export { $m_Ljava_time_zone_StandardZoneRules$ as $m_Ljava_time_zone_StandardZoneRules$ };
/** @constructor */
function $c_Ljava_time_zone_ZoneRules() {
}
export { $c_Ljava_time_zone_ZoneRules as $c_Ljava_time_zone_ZoneRules };
$c_Ljava_time_zone_ZoneRules.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRules.prototype.constructor = $c_Ljava_time_zone_ZoneRules;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules() {
}
export { $h_Ljava_time_zone_ZoneRules as $h_Ljava_time_zone_ZoneRules };
$h_Ljava_time_zone_ZoneRules.prototype = $c_Ljava_time_zone_ZoneRules.prototype;
/** @constructor */
function $c_Ljava_time_zone_ZoneRules$() {
}
export { $c_Ljava_time_zone_ZoneRules$ as $c_Ljava_time_zone_ZoneRules$ };
$c_Ljava_time_zone_ZoneRules$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRules$.prototype.constructor = $c_Ljava_time_zone_ZoneRules$;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules$() {
}
export { $h_Ljava_time_zone_ZoneRules$ as $h_Ljava_time_zone_ZoneRules$ };
$h_Ljava_time_zone_ZoneRules$.prototype = $c_Ljava_time_zone_ZoneRules$.prototype;
$c_Ljava_time_zone_ZoneRules$.prototype.of__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_ZoneRules = (function(baseStandardOffset, baseWallOffset, standardOffsetTransitionList, transitionList, lastRules) {
  if ((baseStandardOffset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "baseStandardOffset");
  }
  if ((baseWallOffset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "baseWallOffset");
  }
  if ((standardOffsetTransitionList === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "standardOffsetTransitionList");
  }
  if ((transitionList === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "transitionList");
  }
  if ((lastRules === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "lastRules");
  }
  return $m_Ljava_time_zone_StandardZoneRules$().apply__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_StandardZoneRules(baseStandardOffset, baseWallOffset, standardOffsetTransitionList, transitionList, lastRules);
});
$c_Ljava_time_zone_ZoneRules$.prototype.of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules = (function(offset) {
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset");
  }
  return new $c_Ljava_time_zone_ZoneRules$Fixed(offset);
});
var $d_Ljava_time_zone_ZoneRules$ = new $TypeData().initClass($c_Ljava_time_zone_ZoneRules$, "java.time.zone.ZoneRules$", ({
  Ljava_time_zone_ZoneRules$: 1
}));
export { $d_Ljava_time_zone_ZoneRules$ as $d_Ljava_time_zone_ZoneRules$ };
var $n_Ljava_time_zone_ZoneRules$;
function $m_Ljava_time_zone_ZoneRules$() {
  if ((!$n_Ljava_time_zone_ZoneRules$)) {
    $n_Ljava_time_zone_ZoneRules$ = new $c_Ljava_time_zone_ZoneRules$();
  }
  return $n_Ljava_time_zone_ZoneRules$;
}
export { $m_Ljava_time_zone_ZoneRules$ as $m_Ljava_time_zone_ZoneRules$ };
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesInitializer() {
}
export { $c_Ljava_time_zone_ZoneRulesInitializer as $c_Ljava_time_zone_ZoneRulesInitializer };
$c_Ljava_time_zone_ZoneRulesInitializer.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesInitializer.prototype.constructor = $c_Ljava_time_zone_ZoneRulesInitializer;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesInitializer() {
}
export { $h_Ljava_time_zone_ZoneRulesInitializer as $h_Ljava_time_zone_ZoneRulesInitializer };
$h_Ljava_time_zone_ZoneRulesInitializer.prototype = $c_Ljava_time_zone_ZoneRulesInitializer.prototype;
function $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZED__ju_concurrent_atomic_AtomicBoolean($thiz) {
  if ((!$thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZEDbitmap$1)) {
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZED$lzy1 = $ct_ju_concurrent_atomic_AtomicBoolean__Z__(new $c_ju_concurrent_atomic_AtomicBoolean(), false);
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZEDbitmap$1 = true;
  }
  return $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZED$lzy1;
}
export { $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZED__ju_concurrent_atomic_AtomicBoolean as $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZED__ju_concurrent_atomic_AtomicBoolean };
function $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER__ju_concurrent_atomic_AtomicReference($thiz) {
  if ((!$thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZERbitmap$1)) {
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZER$lzy1 = $ct_ju_concurrent_atomic_AtomicReference__(new $c_ju_concurrent_atomic_AtomicReference());
    $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZERbitmap$1 = true;
  }
  return $thiz.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZER$lzy1;
}
export { $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER__ju_concurrent_atomic_AtomicReference as $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER__ju_concurrent_atomic_AtomicReference };
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesInitializer$() {
  this.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZED$lzy1 = null;
  this.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZEDbitmap$1 = false;
  this.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZER$lzy1 = null;
  this.Ljava_time_zone_ZoneRulesInitializer$__f_INITIALIZERbitmap$1 = false;
}
export { $c_Ljava_time_zone_ZoneRulesInitializer$ as $c_Ljava_time_zone_ZoneRulesInitializer$ };
$c_Ljava_time_zone_ZoneRulesInitializer$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesInitializer$.prototype.constructor = $c_Ljava_time_zone_ZoneRulesInitializer$;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesInitializer$() {
}
export { $h_Ljava_time_zone_ZoneRulesInitializer$ as $h_Ljava_time_zone_ZoneRulesInitializer$ };
$h_Ljava_time_zone_ZoneRulesInitializer$.prototype = $c_Ljava_time_zone_ZoneRulesInitializer$.prototype;
$c_Ljava_time_zone_ZoneRulesInitializer$.prototype.initialize__V = (function() {
  if ($p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZED__ju_concurrent_atomic_AtomicBoolean(this).getAndSet__Z__Z(true)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Already initialized");
  }
  $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER__ju_concurrent_atomic_AtomicReference(this).compareAndSet__O__O__Z(null, new $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer());
  $p_Ljava_time_zone_ZoneRulesInitializer$__INITIALIZER__ju_concurrent_atomic_AtomicReference(this).ju_concurrent_atomic_AtomicReference__f_value.initializeProviders__V();
});
var $d_Ljava_time_zone_ZoneRulesInitializer$ = new $TypeData().initClass($c_Ljava_time_zone_ZoneRulesInitializer$, "java.time.zone.ZoneRulesInitializer$", ({
  Ljava_time_zone_ZoneRulesInitializer$: 1
}));
export { $d_Ljava_time_zone_ZoneRulesInitializer$ as $d_Ljava_time_zone_ZoneRulesInitializer$ };
var $n_Ljava_time_zone_ZoneRulesInitializer$;
function $m_Ljava_time_zone_ZoneRulesInitializer$() {
  if ((!$n_Ljava_time_zone_ZoneRulesInitializer$)) {
    $n_Ljava_time_zone_ZoneRulesInitializer$ = new $c_Ljava_time_zone_ZoneRulesInitializer$();
  }
  return $n_Ljava_time_zone_ZoneRulesInitializer$;
}
export { $m_Ljava_time_zone_ZoneRulesInitializer$ as $m_Ljava_time_zone_ZoneRulesInitializer$ };
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesProvider() {
}
export { $c_Ljava_time_zone_ZoneRulesProvider as $c_Ljava_time_zone_ZoneRulesProvider };
$c_Ljava_time_zone_ZoneRulesProvider.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesProvider.prototype.constructor = $c_Ljava_time_zone_ZoneRulesProvider;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesProvider() {
}
export { $h_Ljava_time_zone_ZoneRulesProvider as $h_Ljava_time_zone_ZoneRulesProvider };
$h_Ljava_time_zone_ZoneRulesProvider.prototype = $c_Ljava_time_zone_ZoneRulesProvider.prototype;
var $d_Ljava_time_zone_ZoneRulesProvider = new $TypeData().initClass(0, "java.time.zone.ZoneRulesProvider", ({
  Ljava_time_zone_ZoneRulesProvider: 1
}));
export { $d_Ljava_time_zone_ZoneRulesProvider as $d_Ljava_time_zone_ZoneRulesProvider };
function $p_Ljava_time_zone_ZoneRulesProvider$__PROVIDERS__ju_ArrayList($thiz) {
  if ((!$thiz.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERSbitmap$1)) {
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERS$lzy1 = $ct_ju_ArrayList__(new $c_ju_ArrayList());
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERSbitmap$1 = true;
  }
  return $thiz.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERS$lzy1;
}
export { $p_Ljava_time_zone_ZoneRulesProvider$__PROVIDERS__ju_ArrayList as $p_Ljava_time_zone_ZoneRulesProvider$__PROVIDERS__ju_ArrayList };
function $p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz) {
  if ((!$thiz.Ljava_time_zone_ZoneRulesProvider$__f_ZONESbitmap$1)) {
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_ZONES$lzy1 = $ct_ju_HashMap__(new $c_ju_HashMap());
    $thiz.Ljava_time_zone_ZoneRulesProvider$__f_ZONESbitmap$1 = true;
  }
  return $thiz.Ljava_time_zone_ZoneRulesProvider$__f_ZONES$lzy1;
}
export { $p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map as $p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map };
function $p_Ljava_time_zone_ZoneRulesProvider$__getProvider__T__Ljava_time_zone_ZoneRulesProvider($thiz, zoneId) {
  var provider = $p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz).get__O__O(zoneId);
  if ((provider === null)) {
    if ($p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz).isEmpty__Z()) {
      throw new $c_Ljava_time_zone_ZoneRulesException("No time-zone data files registered");
    } else {
      throw new $c_Ljava_time_zone_ZoneRulesException(("Unknown time-zone ID: " + zoneId));
    }
  } else {
    return provider;
  }
}
export { $p_Ljava_time_zone_ZoneRulesProvider$__getProvider__T__Ljava_time_zone_ZoneRulesProvider as $p_Ljava_time_zone_ZoneRulesProvider$__getProvider__T__Ljava_time_zone_ZoneRulesProvider };
function $p_Ljava_time_zone_ZoneRulesProvider$__registerProvider0__Ljava_time_zone_ZoneRulesProvider__V($thiz, provider) {
  var zoneIds = provider.provideZoneIds__ju_Set().iterator__ju_Iterator();
  while (zoneIds.hasNext__Z()) {
    var zoneId = zoneIds.next__O();
    if ((zoneId === null)) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId");
    }
    var old = $p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map($thiz).put__O__O__O(zoneId, provider);
    if ((old !== null)) {
      throw new $c_Ljava_time_zone_ZoneRulesException(((("Unable to register zone as one already registered with that ID: " + zoneId) + ", currently loading from provider: ") + provider));
    }
  }
}
export { $p_Ljava_time_zone_ZoneRulesProvider$__registerProvider0__Ljava_time_zone_ZoneRulesProvider__V as $p_Ljava_time_zone_ZoneRulesProvider$__registerProvider0__Ljava_time_zone_ZoneRulesProvider__V };
/** @constructor */
function $c_Ljava_time_zone_ZoneRulesProvider$() {
  this.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERS$lzy1 = null;
  this.Ljava_time_zone_ZoneRulesProvider$__f_PROVIDERSbitmap$1 = false;
  this.Ljava_time_zone_ZoneRulesProvider$__f_ZONES$lzy1 = null;
  this.Ljava_time_zone_ZoneRulesProvider$__f_ZONESbitmap$1 = false;
  $n_Ljava_time_zone_ZoneRulesProvider$ = this;
  $m_Ljava_time_zone_ZoneRulesInitializer$().initialize__V();
}
export { $c_Ljava_time_zone_ZoneRulesProvider$ as $c_Ljava_time_zone_ZoneRulesProvider$ };
$c_Ljava_time_zone_ZoneRulesProvider$.prototype = new $h_O();
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.constructor = $c_Ljava_time_zone_ZoneRulesProvider$;
/** @constructor */
function $h_Ljava_time_zone_ZoneRulesProvider$() {
}
export { $h_Ljava_time_zone_ZoneRulesProvider$ as $h_Ljava_time_zone_ZoneRulesProvider$ };
$h_Ljava_time_zone_ZoneRulesProvider$.prototype = $c_Ljava_time_zone_ZoneRulesProvider$.prototype;
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.getAvailableZoneIds__ju_Set = (function() {
  var a = $p_Ljava_time_zone_ZoneRulesProvider$__ZONES__ju_Map(this).keySet__ju_Set();
  return new $c_ju_Collections$UnmodifiableSet(a);
});
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.getRules__T__Z__Ljava_time_zone_ZoneRules = (function(zoneId, forCaching) {
  if ((zoneId === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zoneId");
  }
  $p_Ljava_time_zone_ZoneRulesProvider$__getProvider__T__Ljava_time_zone_ZoneRulesProvider(this, zoneId);
  return $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_ZoneOffset__ju_List__ju_List__ju_List__Ljava_time_zone_ZoneRules($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset(), $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset(), $ct_ju_ArrayList__(new $c_ju_ArrayList()), $ct_ju_ArrayList__(new $c_ju_ArrayList()), $ct_ju_ArrayList__(new $c_ju_ArrayList()));
});
$c_Ljava_time_zone_ZoneRulesProvider$.prototype.registerProvider__Ljava_time_zone_ZoneRulesProvider__V = (function(provider) {
  if ((provider === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "provider");
  }
  $p_Ljava_time_zone_ZoneRulesProvider$__registerProvider0__Ljava_time_zone_ZoneRulesProvider__V(this, provider);
  $p_Ljava_time_zone_ZoneRulesProvider$__PROVIDERS__ju_ArrayList(this).add__O__Z(provider);
});
var $d_Ljava_time_zone_ZoneRulesProvider$ = new $TypeData().initClass($c_Ljava_time_zone_ZoneRulesProvider$, "java.time.zone.ZoneRulesProvider$", ({
  Ljava_time_zone_ZoneRulesProvider$: 1
}));
export { $d_Ljava_time_zone_ZoneRulesProvider$ as $d_Ljava_time_zone_ZoneRulesProvider$ };
var $n_Ljava_time_zone_ZoneRulesProvider$;
function $m_Ljava_time_zone_ZoneRulesProvider$() {
  if ((!$n_Ljava_time_zone_ZoneRulesProvider$)) {
    $n_Ljava_time_zone_ZoneRulesProvider$ = new $c_Ljava_time_zone_ZoneRulesProvider$();
  }
  return $n_Ljava_time_zone_ZoneRulesProvider$;
}
export { $m_Ljava_time_zone_ZoneRulesProvider$ as $m_Ljava_time_zone_ZoneRulesProvider$ };
/** @constructor */
function $c_ju_AbstractMap$() {
}
export { $c_ju_AbstractMap$ as $c_ju_AbstractMap$ };
$c_ju_AbstractMap$.prototype = new $h_O();
$c_ju_AbstractMap$.prototype.constructor = $c_ju_AbstractMap$;
/** @constructor */
function $h_ju_AbstractMap$() {
}
export { $h_ju_AbstractMap$ as $h_ju_AbstractMap$ };
$h_ju_AbstractMap$.prototype = $c_ju_AbstractMap$.prototype;
$c_ju_AbstractMap$.prototype.java$util$AbstractMap$$entryEquals__ju_Map$Entry__O__Z = (function(entry, other) {
  if ($is_ju_Map$Entry(other)) {
    var a = entry.getKey__O();
    var b = other.getKey__O();
    if (((a === null) ? (b === null) : $dp_equals__O__Z(a, b))) {
      var a$1 = entry.getValue__O();
      var b$1 = other.getValue__O();
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z(a$1, b$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_AbstractMap$.prototype.java$util$AbstractMap$$entryHashCode__ju_Map$Entry__I = (function(entry) {
  var o = entry.getKey__O();
  var $x_1 = ((o === null) ? 0 : $dp_hashCode__I(o));
  var o$1 = entry.getValue__O();
  return ($x_1 ^ ((o$1 === null) ? 0 : $dp_hashCode__I(o$1)));
});
var $d_ju_AbstractMap$ = new $TypeData().initClass($c_ju_AbstractMap$, "java.util.AbstractMap$", ({
  ju_AbstractMap$: 1
}));
export { $d_ju_AbstractMap$ as $d_ju_AbstractMap$ };
var $n_ju_AbstractMap$;
function $m_ju_AbstractMap$() {
  if ((!$n_ju_AbstractMap$)) {
    $n_ju_AbstractMap$ = new $c_ju_AbstractMap$();
  }
  return $n_ju_AbstractMap$;
}
export { $m_ju_AbstractMap$ as $m_ju_AbstractMap$ };
/** @constructor */
function $c_ju_Arrays$() {
}
export { $c_ju_Arrays$ as $c_ju_Arrays$ };
$c_ju_Arrays$.prototype = new $h_O();
$c_ju_Arrays$.prototype.constructor = $c_ju_Arrays$;
/** @constructor */
function $h_ju_Arrays$() {
}
export { $h_ju_Arrays$ as $h_ju_Arrays$ };
$h_ju_Arrays$.prototype = $c_ju_Arrays$.prototype;
$c_ju_Arrays$.prototype.sort__AI__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var end = a.u.length;
  if ((end > 16)) {
    var length = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_I(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AI__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$IntArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_I(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AJ__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var end = a.u.length;
  if ((end > 16)) {
    var length = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_J(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AJ__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$LongArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_J(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AS__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var end = a.u.length;
  if ((end > 16)) {
    var length = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_S(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AS__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ShortArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_S(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AC__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var end = a.u.length;
  if ((end > 16)) {
    var length = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_C(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AC__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$CharArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_C(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AB__V = (function(a) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var end = a.u.length;
  if ((end > 16)) {
    var length = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_B(length), 0, end, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, 0, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AB__I__I__V = (function(a, fromIndex, toIndex) {
  var comparator = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  var ops = $m_ju_internal_GenericArrayOps$ByteArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = a.u.length;
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, new $ac_B(length), fromIndex, toIndex, comparator, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, fromIndex, toIndex, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AO__ju_Comparator__V = (function(array, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  var end = array.u.length;
  if ((end > 16)) {
    var length = array.u.length;
    var clazz = $objectGetClass(array);
    var componentType = clazz.data.getComponentType();
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, componentType.data.newArray(length), 0, end, comparator$1, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, 0, end, comparator$1, ops);
  }
});
$c_ju_Arrays$.prototype.sort__AO__I__I__ju_Comparator__V = (function(array, fromIndex, toIndex, comparator) {
  var comparator$1 = ((comparator === null) ? $m_ju_Arrays$NaturalComparator$() : comparator);
  var ops = $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  if ((((toIndex - fromIndex) | 0) > 16)) {
    var length = array.u.length;
    var clazz = $objectGetClass(array);
    var componentType = clazz.data.getComponentType();
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, componentType.data.newArray(length), fromIndex, toIndex, comparator$1, ops);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(array, fromIndex, toIndex, comparator$1, ops);
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V = (function(a, temp, start, end, comparator, ops) {
  var length = ((end - start) | 0);
  if ((length > 16)) {
    var middle = ((start + ((length / 2) | 0)) | 0);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, temp, start, middle, comparator, ops);
    this.java$util$Arrays$$stableSplitMerge__O__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, temp, middle, end, comparator, ops);
    var outIndex = start;
    var leftInIndex = start;
    var rightInIndex = middle;
    while ((outIndex < end)) {
      if (((leftInIndex < middle) && ((rightInIndex >= end) || (comparator.compare__O__O__I(ops.get__O__I__O(a, leftInIndex), ops.get__O__I__O(a, rightInIndex)) <= 0)))) {
        ops.set__O__I__O__V(temp, outIndex, ops.get__O__I__O(a, leftInIndex));
        leftInIndex = ((1 + leftInIndex) | 0);
      } else {
        ops.set__O__I__O__V(temp, outIndex, ops.get__O__I__O(a, rightInIndex));
        rightInIndex = ((1 + rightInIndex) | 0);
      }
      outIndex = ((1 + outIndex) | 0);
    }
    temp.copyTo(start, a, start, length);
  } else {
    this.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V(a, start, end, comparator, ops);
  }
});
$c_ju_Arrays$.prototype.java$util$Arrays$$insertionSort__O__I__I__ju_Comparator__ju_internal_GenericArrayOps$ArrayOps__V = (function(a, start, end, comparator, ops) {
  var n = ((end - start) | 0);
  if ((n >= 2)) {
    var aStart = ops.get__O__I__O(a, start);
    var aStartPlusOne = ops.get__O__I__O(a, ((1 + start) | 0));
    if ((comparator.compare__O__O__I(aStart, aStartPlusOne) > 0)) {
      ops.set__O__I__O__V(a, start, aStartPlusOne);
      ops.set__O__I__O__V(a, ((1 + start) | 0), aStart);
    }
    var m = 2;
    while ((m < n)) {
      var next = ops.get__O__I__O(a, ((start + m) | 0));
      if ((comparator.compare__O__O__I(next, ops.get__O__I__O(a, (((-1) + ((start + m) | 0)) | 0))) < 0)) {
        var iA = start;
        var iB = (((-1) + ((start + m) | 0)) | 0);
        while ((((iB - iA) | 0) > 1)) {
          var ix = ((((iA + iB) | 0) >>> 1) | 0);
          if ((comparator.compare__O__O__I(next, ops.get__O__I__O(a, ix)) < 0)) {
            iB = ix;
          } else {
            iA = ix;
          }
        }
        var ix$2 = ((iA + ((comparator.compare__O__O__I(next, ops.get__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
        var i = ((start + m) | 0);
        while ((i > ix$2)) {
          ops.set__O__I__O__V(a, i, ops.get__O__I__O(a, (((-1) + i) | 0)));
          i = (((-1) + i) | 0);
        }
        ops.set__O__I__O__V(a, ix$2, next);
      }
      m = ((1 + m) | 0);
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AJ__J__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0);
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var t = a.u[mid];
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(key.RTLong__f_lo, key.RTLong__f_hi, lo, hi);
      if ((cmp < 0)) {
        endIndex = mid;
      } else if ((cmp === 0)) {
        return mid;
      } else {
        startIndex = ((1 + mid) | 0);
      }
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AI__I__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0);
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var elem = a.u[mid];
      var cmp = ((key === elem) ? 0 : ((key < elem) ? (-1) : 1));
      if ((cmp < 0)) {
        endIndex = mid;
      } else if ((cmp === 0)) {
        return mid;
      } else {
        startIndex = ((1 + mid) | 0);
      }
    }
  }
});
$c_ju_Arrays$.prototype.binarySearch__AO__O__I = (function(a, key) {
  var startIndex = 0;
  var endIndex = a.u.length;
  while (true) {
    if ((startIndex === endIndex)) {
      return (((-1) - startIndex) | 0);
    } else {
      var mid = ((((startIndex + endIndex) | 0) >>> 1) | 0);
      var elem = a.u[mid];
      var cmp = $dp_compareTo__O__I(key, elem);
      if ((cmp < 0)) {
        endIndex = mid;
      } else if ((cmp === 0)) {
        return mid;
      } else {
        startIndex = ((1 + mid) | 0);
      }
    }
  }
});
$c_ju_Arrays$.prototype.equals__AJ__AJ__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var t = a.u[i$1];
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var i$2 = i;
    var t$1 = b.u[i$2];
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((!((lo === lo$1) && (hi === hi$1)))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AI__AI__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = a.u[i$1];
    var i$2 = i;
    var b$1 = b.u[i$2];
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AS__AS__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = a.u[i$1];
    var i$2 = i;
    var b$1 = b.u[i$2];
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AC__AC__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = a.u[i$1];
    var i$2 = i;
    var b$1 = b.u[i$2];
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AB__AB__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = a.u[i$1];
    var i$2 = i;
    var b$1 = b.u[i$2];
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AZ__AZ__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = a.u[i$1];
    var i$2 = i;
    var b$1 = b.u[i$2];
    if ((!(a$1 === b$1))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.equals__AO__AO__Z = (function(a, b) {
  if ((a === b)) {
    return true;
  }
  if (((a === null) || (b === null))) {
    return false;
  }
  var len = a.u.length;
  if ((b.u.length !== len)) {
    return false;
  }
  var i = 0;
  while ((i !== len)) {
    var i$1 = i;
    var a$1 = a.u[i$1];
    var i$2 = i;
    var b$1 = b.u[i$2];
    if ((!((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z(a$1, b$1)))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_ju_Arrays$.prototype.fill__AJ__I__I__J__V = (function(a, fromIndex, toIndex, value) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  var i$1 = fromIndex;
  while ((i$1 !== toIndex)) {
    var i$2 = i$1;
    a.u[i$2] = value;
    i$1 = ((1 + i$1) | 0);
  }
});
$c_ju_Arrays$.prototype.fill__AO__O__V = (function(a, value) {
  var toIndex = a.u.length;
  var i = 0;
  while ((i !== toIndex)) {
    var i$1 = i;
    a.u[i$1] = value;
    i = ((1 + i) | 0);
  }
});
$c_ju_Arrays$.prototype.fill__AO__I__I__O__V = (function(a, fromIndex, toIndex, value) {
  if ((fromIndex > toIndex)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("fromIndex(" + fromIndex) + ") > toIndex(") + toIndex) + ")"));
  }
  var i$1 = fromIndex;
  while ((i$1 !== toIndex)) {
    var i$2 = i$1;
    a.u[i$2] = value;
    i$1 = ((1 + i$1) | 0);
  }
});
$c_ju_Arrays$.prototype.copyOf__AO__I__AO = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var clazz = $objectGetClass(original);
  var componentType = clazz.data.getComponentType();
  var ret = componentType.data.newArray(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AO__I__jl_Class__AO = (function(original, newLength, newType) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var componentType = newType.data.getComponentType();
  var ret = componentType.data.newArray(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AB__I__AB = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_B(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AS__I__AS = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_S(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AI__I__AI = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_I(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AJ__I__AJ = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_J(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AC__I__AC = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_C(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AF__I__AF = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_F(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AD__I__AD = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_D(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOf__AZ__I__AZ = (function(original, newLength) {
  if ((newLength < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  var b = original.u.length;
  var copyLength = ((newLength < b) ? newLength : b);
  var ret = new $ac_Z(newLength);
  original.copyTo(0, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AO__I__I__AO = (function(original, from, to) {
  if ((from > to)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((from + " > ") + to));
  }
  var len = original.u.length;
  var retLength = ((to - from) | 0);
  var b = ((len - from) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var clazz = $objectGetClass(original);
  var componentType = clazz.data.getComponentType();
  var ret = componentType.data.newArray(retLength);
  original.copyTo(from, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AB__I__I__AB = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_B(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AS__I__I__AS = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_S(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AI__I__I__AI = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_I(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AJ__I__I__AJ = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_J(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AC__I__I__AC = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_C(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AF__I__I__AF = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_F(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AD__I__I__AD = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_D(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.copyOfRange__AZ__I__I__AZ = (function(original, start, end) {
  if ((start > end)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((start + " > ") + end));
  }
  var len = original.u.length;
  var retLength = ((end - start) | 0);
  var b = ((len - start) | 0);
  var copyLength = ((retLength < b) ? retLength : b);
  var ret = new $ac_Z(retLength);
  original.copyTo(start, ret, 0, copyLength);
  return ret;
});
$c_ju_Arrays$.prototype.asList__AO__ju_List = (function(a) {
  return new $c_ju_Arrays$$anon$1(a);
});
$c_ju_Arrays$.prototype.hashCode__AJ__I = (function(a) {
  if ((a === null)) {
    return 0;
  } else {
    var acc = 1;
    var len = a.u.length;
    var i = 0;
    while ((i !== len)) {
      var $x_1 = acc;
      var i$1 = i;
      var t = a.u[i$1];
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      acc = ((Math.imul(31, $x_1) + (lo ^ hi)) | 0);
      i = ((1 + i) | 0);
    }
    return acc;
  }
});
$c_ju_Arrays$.prototype.hashCode__AC__I = (function(a) {
  if ((a === null)) {
    return 0;
  } else {
    var acc = 1;
    var len = a.u.length;
    var i = 0;
    while ((i !== len)) {
      var $x_1 = acc;
      var i$1 = i;
      var o = a.u[i$1];
      acc = ((Math.imul(31, $x_1) + o) | 0);
      i = ((1 + i) | 0);
    }
    return acc;
  }
});
$c_ju_Arrays$.prototype.hashCode__AO__I = (function(a) {
  if ((a === null)) {
    return 0;
  } else {
    var acc = 1;
    var len = a.u.length;
    var i = 0;
    while ((i !== len)) {
      var $x_1 = acc;
      var i$1 = i;
      var o = a.u[i$1];
      acc = ((Math.imul(31, $x_1) + ((o === null) ? 0 : $dp_hashCode__I(o))) | 0);
      i = ((1 + i) | 0);
    }
    return acc;
  }
});
var $d_ju_Arrays$ = new $TypeData().initClass($c_ju_Arrays$, "java.util.Arrays$", ({
  ju_Arrays$: 1
}));
export { $d_ju_Arrays$ as $d_ju_Arrays$ };
var $n_ju_Arrays$;
function $m_ju_Arrays$() {
  if ((!$n_ju_Arrays$)) {
    $n_ju_Arrays$ = new $c_ju_Arrays$();
  }
  return $n_ju_Arrays$;
}
export { $m_ju_Arrays$ as $m_ju_Arrays$ };
function $p_ju_Base64$__decodeTable__AB__AI($thiz, encode) {
  var decode = new $ac_I(256);
  var i = 0;
  while ((i !== 256)) {
    decode.u[i] = (-1);
    i = ((1 + i) | 0);
  }
  var len = encode.u.length;
  var j = 0;
  while ((j !== len)) {
    decode.u[encode.u[j]] = j;
    j = ((1 + j) | 0);
  }
  decode.u[61] = (-2);
  return decode;
}
export { $p_ju_Base64$__decodeTable__AB__AI as $p_ju_Base64$__decodeTable__AB__AI };
/** @constructor */
function $c_ju_Base64$() {
  this.ju_Base64$__f_basicEncodeTable = null;
  this.ju_Base64$__f_urlSafeEncodeTable = null;
  this.ju_Base64$__f_basicDecodeTable = null;
  this.ju_Base64$__f_urlSafeDecodeTable = null;
  this.ju_Base64$__f_mimeLineSeparators = null;
  this.ju_Base64$__f_urlSafeEncoder = null;
  this.ju_Base64$__f_urlSafeDecoder = null;
  $n_ju_Base64$ = this;
  var table = new $ac_B(64);
  var i = 0;
  while ((i !== 64)) {
    var $x_1 = i;
    var index = i;
    table.u[$x_1] = (("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charCodeAt(index) << 24) >> 24);
    i = ((1 + i) | 0);
  }
  this.ju_Base64$__f_basicEncodeTable = table;
  var this$1 = this.ju_Base64$__f_basicEncodeTable;
  var table$2 = this$1.clone__O();
  table$2.u[62] = 45;
  table$2.u[63] = 95;
  this.ju_Base64$__f_urlSafeEncodeTable = table$2;
  this.ju_Base64$__f_basicDecodeTable = $p_ju_Base64$__decodeTable__AB__AI(this, this.ju_Base64$__f_basicEncodeTable);
  this.ju_Base64$__f_urlSafeDecodeTable = $p_ju_Base64$__decodeTable__AB__AI(this, this.ju_Base64$__f_urlSafeEncodeTable);
  this.ju_Base64$__f_mimeLineSeparators = new $ac_B(new Int8Array([13, 10]));
  $m_ju_Base64$Encoder$().$lessinit$greater$default$3__AB();
  this.ju_Base64$__f_urlSafeEncoder = new $c_ju_Base64$Encoder(this.ju_Base64$__f_urlSafeEncodeTable, 0, $m_ju_Base64$Encoder$().$lessinit$greater$default$3__AB(), true);
  this.ju_Base64$__f_urlSafeDecoder = new $c_ju_Base64$Decoder(this.ju_Base64$__f_urlSafeDecodeTable, false);
}
export { $c_ju_Base64$ as $c_ju_Base64$ };
$c_ju_Base64$.prototype = new $h_O();
$c_ju_Base64$.prototype.constructor = $c_ju_Base64$;
/** @constructor */
function $h_ju_Base64$() {
}
export { $h_ju_Base64$ as $h_ju_Base64$ };
$h_ju_Base64$.prototype = $c_ju_Base64$.prototype;
var $d_ju_Base64$ = new $TypeData().initClass($c_ju_Base64$, "java.util.Base64$", ({
  ju_Base64$: 1
}));
export { $d_ju_Base64$ as $d_ju_Base64$ };
var $n_ju_Base64$;
function $m_ju_Base64$() {
  if ((!$n_ju_Base64$)) {
    $n_ju_Base64$ = new $c_ju_Base64$();
  }
  return $n_ju_Base64$;
}
export { $m_ju_Base64$ as $m_ju_Base64$ };
function $p_ju_Base64$Decoder__doDecode__ju_Base64$Wrapper__ju_Base64$Wrapper__I($thiz, src, dst) {
  var srcBuffer = $ct_ju_Base64$Wrapper__AB__(new $c_ju_Base64$Wrapper(), new $ac_B(4));
  $p_ju_Base64$Decoder__iterate$1__ju_Base64$Wrapper__ju_Base64$Wrapper__ju_Base64$Wrapper__V($thiz, src, srcBuffer, dst);
  srcBuffer.flip__V();
  srcBuffer.ju_Base64$Wrapper__f_position = 0;
  var shift = 18;
  var i = 0;
  while (srcBuffer.hasRemaining__Z()) {
    i = (i | ((255 & srcBuffer.get__B()) << shift));
    shift = (((-6) + shift) | 0);
  }
  if ((shift === 12)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Last unit does not have enough valid bits");
  }
  if ((shift <= 6)) {
    dst.put__B__V((((i >> 16) << 24) >> 24));
  }
  if ((shift <= 0)) {
    dst.put__B__V((((i >> 8) << 24) >> 24));
  }
  if ((shift <= (-6))) {
    dst.put__B__V(((i << 24) >> 24));
  }
  srcBuffer.clear__V();
  while (src.hasRemaining__Z()) {
    var int = (255 & src.get__B());
    var value = $thiz.ju_Base64$Decoder__f_table.u[int];
    if (((value !== (-2)) && ((!$thiz.ju_Base64$Decoder__f_ignoreInvalid) || (value > 0)))) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Input byte array has incorrect ending byte at " + int));
    }
  }
  return dst.ju_Base64$Wrapper__f_position;
}
export { $p_ju_Base64$Decoder__doDecode__ju_Base64$Wrapper__ju_Base64$Wrapper__I as $p_ju_Base64$Decoder__doDecode__ju_Base64$Wrapper__ju_Base64$Wrapper__I };
function $p_ju_Base64$Decoder__dstRequiredLength__AB__I($thiz, src) {
  var elem = 0;
  elem = 0;
  if ($thiz.ju_Base64$Decoder__f_ignoreInvalid) {
    var end = src.u.length;
    var i = 0;
    while ((i < end)) {
      var value = i;
      if (($thiz.ju_Base64$Decoder__f_table.u[(255 & src.u[value])] >= 0)) {
        elem = ((1 + elem) | 0);
      }
      i = ((1 + i) | 0);
    }
  } else {
    elem = src.u.length;
    if (((src.u.length >= 1) && (src.u[(((-1) + src.u.length) | 0)] === 61))) {
      elem = (((-1) + elem) | 0);
      if (((src.u.length >= 2) && (src.u[(((-2) + src.u.length) | 0)] === 61))) {
        elem = (((-1) + elem) | 0);
      }
    }
    if (((src.u.length >= 1) && (elem === 0))) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Input byte array has wrong 4-byte ending unit");
    }
  }
  return $p_ju_Base64$Decoder__dstMaxLength__I__I($thiz, elem);
}
export { $p_ju_Base64$Decoder__dstRequiredLength__AB__I as $p_ju_Base64$Decoder__dstRequiredLength__AB__I };
function $p_ju_Base64$Decoder__dstMaxLength__I__I($thiz, srcLength) {
  return ((Math.imul(3, ((((3 + srcLength) | 0) / 4) | 0)) - ((((srcLength % 4) | 0) === 0) ? 0 : ((4 - ((srcLength % 4) | 0)) | 0))) | 0);
}
export { $p_ju_Base64$Decoder__dstMaxLength__I__I as $p_ju_Base64$Decoder__dstMaxLength__I__I };
function $p_ju_Base64$Decoder__iterate$1__ju_Base64$Wrapper__ju_Base64$Wrapper__ju_Base64$Wrapper__V($thiz, src$1, srcBuffer$1, dst$1) {
  while (true) {
    if (src$1.hasRemaining__Z()) {
      if (srcBuffer$1.hasRemaining__Z()) {
        var int = (255 & src$1.get__B());
        var x1 = $thiz.ju_Base64$Decoder__f_table.u[int];
        switch (x1) {
          case (-2): {
            break;
          }
          case (-1): {
            if ((!$thiz.ju_Base64$Decoder__f_ignoreInvalid)) {
              throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Illegal base64 character " + (int >>> 0.0).toString(16)));
            }
            continue;
            break;
          }
          default: {
            srcBuffer$1.put__B__V(((x1 << 24) >> 24));
            continue;
          }
        }
      } else {
        srcBuffer$1.ju_Base64$Wrapper__f_position = 0;
        var shift = 18;
        var i = 0;
        while (srcBuffer$1.hasRemaining__Z()) {
          i = (i | ((255 & srcBuffer$1.get__B()) << shift));
          shift = (((-6) + shift) | 0);
        }
        if ((shift === 12)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Last unit does not have enough valid bits");
        }
        if ((shift <= 6)) {
          dst$1.put__B__V((((i >> 16) << 24) >> 24));
        }
        if ((shift <= 0)) {
          dst$1.put__B__V((((i >> 8) << 24) >> 24));
        }
        if ((shift <= (-6))) {
          dst$1.put__B__V(((i << 24) >> 24));
        }
        srcBuffer$1.clear__V();
        continue;
      }
    }
    return (void 0);
  }
}
export { $p_ju_Base64$Decoder__iterate$1__ju_Base64$Wrapper__ju_Base64$Wrapper__ju_Base64$Wrapper__V as $p_ju_Base64$Decoder__iterate$1__ju_Base64$Wrapper__ju_Base64$Wrapper__ju_Base64$Wrapper__V };
/** @constructor */
function $c_ju_Base64$Decoder(table, ignoreInvalid) {
  this.ju_Base64$Decoder__f_table = null;
  this.ju_Base64$Decoder__f_ignoreInvalid = false;
  this.ju_Base64$Decoder__f_table = table;
  this.ju_Base64$Decoder__f_ignoreInvalid = ignoreInvalid;
}
export { $c_ju_Base64$Decoder as $c_ju_Base64$Decoder };
$c_ju_Base64$Decoder.prototype = new $h_O();
$c_ju_Base64$Decoder.prototype.constructor = $c_ju_Base64$Decoder;
/** @constructor */
function $h_ju_Base64$Decoder() {
}
export { $h_ju_Base64$Decoder as $h_ju_Base64$Decoder };
$h_ju_Base64$Decoder.prototype = $c_ju_Base64$Decoder.prototype;
$c_ju_Base64$Decoder.prototype.decode__AB__AB = (function(src) {
  var dst = new $ac_B($p_ju_Base64$Decoder__dstRequiredLength__AB__I(this, src));
  $p_ju_Base64$Decoder__doDecode__ju_Base64$Wrapper__ju_Base64$Wrapper__I(this, $ct_ju_Base64$Wrapper__AB__(new $c_ju_Base64$Wrapper(), src), $ct_ju_Base64$Wrapper__AB__(new $c_ju_Base64$Wrapper(), dst));
  return dst;
});
$c_ju_Base64$Decoder.prototype.decode__T__AB = (function(src) {
  return this.decode__AB__AB($f_T__getBytes__Ljava_nio_charset_Charset__AB(src, $m_Ljava_nio_charset_ISO\uff3f8859\uff3f1$()));
});
var $d_ju_Base64$Decoder = new $TypeData().initClass($c_ju_Base64$Decoder, "java.util.Base64$Decoder", ({
  ju_Base64$Decoder: 1
}));
export { $d_ju_Base64$Decoder as $d_ju_Base64$Decoder };
function $p_ju_Base64$Encoder__doEncode__AB__AB__I__I($thiz, src, dst, dstLength) {
  return $p_ju_Base64$Encoder__doEncode__ju_Base64$Wrapper__ju_Base64$Wrapper__I($thiz, $ct_ju_Base64$Wrapper__AB__(new $c_ju_Base64$Wrapper(), src), $ct_ju_Base64$Wrapper__AB__I__I__(new $c_ju_Base64$Wrapper(), dst, 0, dstLength));
}
export { $p_ju_Base64$Encoder__doEncode__AB__AB__I__I as $p_ju_Base64$Encoder__doEncode__AB__AB__I__I };
function $p_ju_Base64$Encoder__doEncode__ju_Base64$Wrapper__ju_Base64$Wrapper__I($thiz, src, dst) {
  var length = src.remaining__I();
  var elem = 0;
  elem = 0;
  while ((src.remaining__I() >= 3)) {
    var a = src.get__B();
    var b = src.get__B();
    var c = src.get__B();
    var bits = ((((255 & a) << 16) | ((255 & b) << 8)) | (255 & c));
    dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & ((bits >>> 18) | 0))]);
    dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & ((bits >>> 12) | 0))]);
    if (dst.hasRemaining__Z()) {
      dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & ((bits >>> 6) | 0))]);
    }
    if (dst.hasRemaining__Z()) {
      dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & bits)]);
    }
    elem = ((4 + elem) | 0);
    if ((((($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator.u.length > 0) && ($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineLength > 0)) && (elem === $thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineLength)) && dst.hasRemaining__Z())) {
      var end = $thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator.u.length;
      var i = 0;
      while ((i < end)) {
        var value = i;
        dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator.u[value]);
        i = ((1 + i) | 0);
      }
      elem = 0;
    }
  }
  var x1 = ((length % 3) | 0);
  switch (x1) {
    case 0: {
      break;
    }
    case 1: {
      var a$1 = src.get__B();
      var bits$1 = ((255 & a$1) << 16);
      dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & ((bits$1 >>> 18) | 0))]);
      dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & ((bits$1 >>> 12) | 0))]);
      if (dst.hasRemaining__Z()) {
        dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & ((bits$1 >>> 6) | 0))]);
      }
      if (dst.hasRemaining__Z()) {
        dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & bits$1)]);
      }
      elem = ((4 + elem) | 0);
      if ((((($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator.u.length > 0) && ($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineLength > 0)) && (elem === $thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineLength)) && dst.hasRemaining__Z())) {
        var end$1 = $thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator.u.length;
        var i$1 = 0;
        while ((i$1 < end$1)) {
          var value$1 = i$1;
          dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator.u[value$1]);
          i$1 = ((1 + i$1) | 0);
        }
        elem = 0;
      }
      if ($thiz.ju_Base64$Encoder__f_withPadding) {
        dst.ju_Base64$Wrapper__f_position = (((-2) + dst.ju_Base64$Wrapper__f_position) | 0);
        dst.put__B__V(61);
        dst.put__B__V(61);
      }
      break;
    }
    case 2: {
      var a$2 = src.get__B();
      var b$1 = src.get__B();
      var bits$2 = (((255 & a$2) << 16) | ((255 & b$1) << 8));
      dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & ((bits$2 >>> 18) | 0))]);
      dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & ((bits$2 >>> 12) | 0))]);
      if (dst.hasRemaining__Z()) {
        dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & ((bits$2 >>> 6) | 0))]);
      }
      if (dst.hasRemaining__Z()) {
        dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table.u[(63 & bits$2)]);
      }
      elem = ((4 + elem) | 0);
      if ((((($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator.u.length > 0) && ($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineLength > 0)) && (elem === $thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineLength)) && dst.hasRemaining__Z())) {
        var end$2 = $thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator.u.length;
        var i$2 = 0;
        while ((i$2 < end$2)) {
          var value$2 = i$2;
          dst.put__B__V($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator.u[value$2]);
          i$2 = ((1 + i$2) | 0);
        }
        elem = 0;
      }
      if ($thiz.ju_Base64$Encoder__f_withPadding) {
        dst.ju_Base64$Wrapper__f_position = (((-1) + dst.ju_Base64$Wrapper__f_position) | 0);
        dst.put__B__V(61);
      }
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1);
    }
  }
  return dst.ju_Base64$Wrapper__f_position;
}
export { $p_ju_Base64$Encoder__doEncode__ju_Base64$Wrapper__ju_Base64$Wrapper__I as $p_ju_Base64$Encoder__doEncode__ju_Base64$Wrapper__ju_Base64$Wrapper__I };
function $p_ju_Base64$Encoder__dstLength__I__I($thiz, srcLength) {
  var withPad = (((((2 + srcLength) | 0) / 3) | 0) << 2);
  var toRemove = ($thiz.ju_Base64$Encoder__f_withPadding ? 0 : ((((3 - ((srcLength % 3) | 0)) | 0) % 3) | 0));
  var withoutEndLines = ((withPad - toRemove) | 0);
  var endLines = (($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineLength <= 0) ? 0 : Math.imul((((((-1) + withoutEndLines) | 0) / $checkIntDivisor($thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineLength)) | 0), $thiz.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator.u.length));
  return ((withoutEndLines + endLines) | 0);
}
export { $p_ju_Base64$Encoder__dstLength__I__I as $p_ju_Base64$Encoder__dstLength__I__I };
/** @constructor */
function $c_ju_Base64$Encoder(table, lineLength, lineSeparator, withPadding) {
  this.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table = null;
  this.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineLength = 0;
  this.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator = null;
  this.ju_Base64$Encoder__f_withPadding = false;
  this.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table = table;
  this.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineLength = lineLength;
  this.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator = lineSeparator;
  this.ju_Base64$Encoder__f_withPadding = withPadding;
}
export { $c_ju_Base64$Encoder as $c_ju_Base64$Encoder };
$c_ju_Base64$Encoder.prototype = new $h_O();
$c_ju_Base64$Encoder.prototype.constructor = $c_ju_Base64$Encoder;
/** @constructor */
function $h_ju_Base64$Encoder() {
}
export { $h_ju_Base64$Encoder as $h_ju_Base64$Encoder };
$h_ju_Base64$Encoder.prototype = $c_ju_Base64$Encoder.prototype;
$c_ju_Base64$Encoder.prototype.encode__AB__AB = (function(src) {
  var dst = new $ac_B($p_ju_Base64$Encoder__dstLength__I__I(this, src.u.length));
  $p_ju_Base64$Encoder__doEncode__AB__AB__I__I(this, src, dst, dst.u.length);
  return dst;
});
$c_ju_Base64$Encoder.prototype.encodeToString__AB__T = (function(src) {
  var bytes = this.encode__AB__AB(src);
  var charset = $m_Ljava_nio_charset_ISO\uff3f8859\uff3f1$();
  return $m_jl_String$().new__AB__Ljava_nio_charset_Charset__T(bytes, charset);
});
$c_ju_Base64$Encoder.prototype.withoutPadding__ju_Base64$Encoder = (function() {
  return (this.ju_Base64$Encoder__f_withPadding ? new $c_ju_Base64$Encoder(this.ju_Base64$Encoder__f_java$util$Base64$Encoder$$table, this.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineLength, this.ju_Base64$Encoder__f_java$util$Base64$Encoder$$lineSeparator, false) : this);
});
var $d_ju_Base64$Encoder = new $TypeData().initClass($c_ju_Base64$Encoder, "java.util.Base64$Encoder", ({
  ju_Base64$Encoder: 1
}));
export { $d_ju_Base64$Encoder as $d_ju_Base64$Encoder };
/** @constructor */
function $c_ju_Base64$Encoder$() {
}
export { $c_ju_Base64$Encoder$ as $c_ju_Base64$Encoder$ };
$c_ju_Base64$Encoder$.prototype = new $h_O();
$c_ju_Base64$Encoder$.prototype.constructor = $c_ju_Base64$Encoder$;
/** @constructor */
function $h_ju_Base64$Encoder$() {
}
export { $h_ju_Base64$Encoder$ as $h_ju_Base64$Encoder$ };
$h_ju_Base64$Encoder$.prototype = $c_ju_Base64$Encoder$.prototype;
$c_ju_Base64$Encoder$.prototype.$lessinit$greater$default$3__AB = (function() {
  return new $ac_B(0);
});
var $d_ju_Base64$Encoder$ = new $TypeData().initClass($c_ju_Base64$Encoder$, "java.util.Base64$Encoder$", ({
  ju_Base64$Encoder$: 1
}));
export { $d_ju_Base64$Encoder$ as $d_ju_Base64$Encoder$ };
var $n_ju_Base64$Encoder$;
function $m_ju_Base64$Encoder$() {
  if ((!$n_ju_Base64$Encoder$)) {
    $n_ju_Base64$Encoder$ = new $c_ju_Base64$Encoder$();
  }
  return $n_ju_Base64$Encoder$;
}
export { $m_ju_Base64$Encoder$ as $m_ju_Base64$Encoder$ };
function $ct_ju_Base64$Wrapper__AB__I__I__($thiz, array, position, limit) {
  $thiz.ju_Base64$Wrapper__f_array = array;
  $thiz.ju_Base64$Wrapper__f_position = position;
  $thiz.ju_Base64$Wrapper__f_limit = limit;
  return $thiz;
}
export { $ct_ju_Base64$Wrapper__AB__I__I__ as $ct_ju_Base64$Wrapper__AB__I__I__ };
function $ct_ju_Base64$Wrapper__AB__($thiz, array) {
  $ct_ju_Base64$Wrapper__AB__I__I__($thiz, array, 0, array.u.length);
  return $thiz;
}
export { $ct_ju_Base64$Wrapper__AB__ as $ct_ju_Base64$Wrapper__AB__ };
/** @constructor */
function $c_ju_Base64$Wrapper() {
  this.ju_Base64$Wrapper__f_array = null;
  this.ju_Base64$Wrapper__f_position = 0;
  this.ju_Base64$Wrapper__f_limit = 0;
}
export { $c_ju_Base64$Wrapper as $c_ju_Base64$Wrapper };
$c_ju_Base64$Wrapper.prototype = new $h_O();
$c_ju_Base64$Wrapper.prototype.constructor = $c_ju_Base64$Wrapper;
/** @constructor */
function $h_ju_Base64$Wrapper() {
}
export { $h_ju_Base64$Wrapper as $h_ju_Base64$Wrapper };
$h_ju_Base64$Wrapper.prototype = $c_ju_Base64$Wrapper.prototype;
$c_ju_Base64$Wrapper.prototype.hasRemaining__Z = (function() {
  return (this.ju_Base64$Wrapper__f_position < this.ju_Base64$Wrapper__f_limit);
});
$c_ju_Base64$Wrapper.prototype.remaining__I = (function() {
  return ((this.ju_Base64$Wrapper__f_limit - this.ju_Base64$Wrapper__f_position) | 0);
});
$c_ju_Base64$Wrapper.prototype.put__B__V = (function(b) {
  this.ju_Base64$Wrapper__f_array.u[this.ju_Base64$Wrapper__f_position] = b;
  this.ju_Base64$Wrapper__f_position = ((1 + this.ju_Base64$Wrapper__f_position) | 0);
});
$c_ju_Base64$Wrapper.prototype.get__B = (function() {
  this.ju_Base64$Wrapper__f_position = ((1 + this.ju_Base64$Wrapper__f_position) | 0);
  return this.ju_Base64$Wrapper__f_array.u[(((-1) + this.ju_Base64$Wrapper__f_position) | 0)];
});
$c_ju_Base64$Wrapper.prototype.clear__V = (function() {
  this.ju_Base64$Wrapper__f_position = 0;
  this.ju_Base64$Wrapper__f_limit = this.ju_Base64$Wrapper__f_array.u.length;
});
$c_ju_Base64$Wrapper.prototype.flip__V = (function() {
  this.ju_Base64$Wrapper__f_limit = this.ju_Base64$Wrapper__f_position;
  this.ju_Base64$Wrapper__f_position = 0;
});
var $d_ju_Base64$Wrapper = new $TypeData().initClass($c_ju_Base64$Wrapper, "java.util.Base64$Wrapper", ({
  ju_Base64$Wrapper: 1
}));
export { $d_ju_Base64$Wrapper as $d_ju_Base64$Wrapper };
function $p_ju_Collections$__EMPTY_LIST$lzycompute__ju_List($thiz) {
  if (((((2 & $thiz.ju_Collections$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.ju_Collections$__f_EMPTY_LIST = new $c_ju_Collections$ImmutableList(new $c_ju_Collections$$anon$2());
    $thiz.ju_Collections$__f_bitmap$0 = (((2 | $thiz.ju_Collections$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.ju_Collections$__f_EMPTY_LIST;
}
export { $p_ju_Collections$__EMPTY_LIST$lzycompute__ju_List as $p_ju_Collections$__EMPTY_LIST$lzycompute__ju_List };
/** @constructor */
function $c_ju_Collections$() {
  this.ju_Collections$__f_EMPTY_LIST = null;
  this.ju_Collections$__f_bitmap$0 = 0;
}
export { $c_ju_Collections$ as $c_ju_Collections$ };
$c_ju_Collections$.prototype = new $h_O();
$c_ju_Collections$.prototype.constructor = $c_ju_Collections$;
/** @constructor */
function $h_ju_Collections$() {
}
export { $h_ju_Collections$ as $h_ju_Collections$ };
$h_ju_Collections$.prototype = $c_ju_Collections$.prototype;
$c_ju_Collections$.prototype.EMPTY_LIST__ju_List = (function() {
  return (((((2 & this.ju_Collections$__f_bitmap$0) << 24) >> 24) === 0) ? $p_ju_Collections$__EMPTY_LIST$lzycompute__ju_List(this) : this.ju_Collections$__f_EMPTY_LIST);
});
$c_ju_Collections$.prototype.singletonList__O__ju_List = (function(o) {
  return new $c_ju_Collections$ImmutableList(new $c_ju_Collections$$anon$15(o));
});
var $d_ju_Collections$ = new $TypeData().initClass($c_ju_Collections$, "java.util.Collections$", ({
  ju_Collections$: 1
}));
export { $d_ju_Collections$ as $d_ju_Collections$ };
var $n_ju_Collections$;
function $m_ju_Collections$() {
  if ((!$n_ju_Collections$)) {
    $n_ju_Collections$ = new $c_ju_Collections$();
  }
  return $n_ju_Collections$;
}
export { $m_ju_Collections$ as $m_ju_Collections$ };
function $is_ju_Formattable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Formattable)));
}
export { $is_ju_Formattable as $is_ju_Formattable };
function $isArrayOf_ju_Formattable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Formattable)));
}
export { $isArrayOf_ju_Formattable as $isArrayOf_ju_Formattable };
/** @constructor */
function $c_ju_Formatter$() {
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = null;
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = null;
  $n_ju_Formatter$ = this;
  this.ju_Formatter$__f_java$util$Formatter$$FormatSpecifier = new RegExp("(?:(\\d+)\\$)?([-#+ 0,\\(<]*)(\\d+)?(?:\\.(\\d+))?[%A-Za-z]", "g");
  this.ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags = new $ac_I(new Int32Array([96, 126, 638, 770, 32, 256, 2, 126, (-1), (-1), (-1), (-1), (-1), (-1), 800, (-1), (-1), (-1), 124, (-1), (-1), (-1), (-1), 544, (-1), (-1)]));
}
export { $c_ju_Formatter$ as $c_ju_Formatter$ };
$c_ju_Formatter$.prototype = new $h_O();
$c_ju_Formatter$.prototype.constructor = $c_ju_Formatter$;
/** @constructor */
function $h_ju_Formatter$() {
}
export { $h_ju_Formatter$ as $h_ju_Formatter$ };
$h_ju_Formatter$.prototype = $c_ju_Formatter$.prototype;
$c_ju_Formatter$.prototype.java$util$Formatter$$strOfZeros__I__T = (function(count) {
  if ((count <= 20)) {
    return "00000000000000000000".substring(0, count);
  } else {
    var result = "";
    var remaining = count;
    while ((remaining > 20)) {
      result = (result + "00000000000000000000");
      remaining = (((-20) + remaining) | 0);
    }
    var $x_1 = result;
    var endIndex = remaining;
    return (("" + $x_1) + "00000000000000000000".substring(0, endIndex));
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal = (function(x) {
  if ((x === 0.0)) {
    var negative = ((1.0 / x) < 0.0);
    return new $c_ju_Formatter$Decimal(negative, "0", 0);
  } else {
    var negative$2 = (x < 0.0);
    var d = (negative$2 ? (-x) : x);
    var s = ("" + d);
    var ePos = $f_T__indexOf__I__I(s, 101);
    if ((ePos < 0)) {
      var e = 0;
    } else {
      var $x_2 = parseInt;
      var beginIndex = ((1 + ePos) | 0);
      var $x_1 = $x_2(s.substring(beginIndex));
      var e = ($x_1 | 0);
    }
    var significandEnd = ((ePos < 0) ? s.length : ePos);
    var dotPos = $f_T__indexOf__I__I(s, 46);
    if ((dotPos < 0)) {
      var unscaledValue = s.substring(0, significandEnd);
      var scale = ((-e) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue, scale);
    } else {
      var $x_3 = s.substring(0, dotPos);
      var beginIndex$1 = ((1 + dotPos) | 0);
      var digits = (("" + $x_3) + s.substring(beginIndex$1, significandEnd));
      var digitsLen = digits.length;
      var i = 0;
      while (true) {
        if ((i < digitsLen)) {
          var index = i;
          var $x_4 = (digits.charCodeAt(index) === 48);
        } else {
          var $x_4 = false;
        }
        if ($x_4) {
          i = ((1 + i) | 0);
        } else {
          break;
        }
      }
      var beginIndex$2 = i;
      var unscaledValue$2 = digits.substring(beginIndex$2);
      var scale$2 = ((((-e) | 0) + ((significandEnd - ((1 + dotPos) | 0)) | 0)) | 0);
      return new $c_ju_Formatter$Decimal(negative$2, unscaledValue$2, scale$2);
    }
  }
});
$c_ju_Formatter$.prototype.java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal = (function(x) {
  var this$1 = x.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var unscaledValueWithSign = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  if ((unscaledValueWithSign === "0")) {
    return new $c_ju_Formatter$Decimal(false, "0", 0);
  } else {
    var negative = (unscaledValueWithSign.charCodeAt(0) === 45);
    var unscaledValue = (negative ? unscaledValueWithSign.substring(1) : unscaledValueWithSign);
    var scale = x.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    return new $c_ju_Formatter$Decimal(negative, unscaledValue, scale);
  }
});
var $d_ju_Formatter$ = new $TypeData().initClass($c_ju_Formatter$, "java.util.Formatter$", ({
  ju_Formatter$: 1
}));
export { $d_ju_Formatter$ as $d_ju_Formatter$ };
var $n_ju_Formatter$;
function $m_ju_Formatter$() {
  if ((!$n_ju_Formatter$)) {
    $n_ju_Formatter$ = new $c_ju_Formatter$();
  }
  return $n_ju_Formatter$;
}
export { $m_ju_Formatter$ as $m_ju_Formatter$ };
function $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal($thiz, roundingPos) {
  var digits = $thiz.ju_Formatter$Decimal__f_unscaledValue;
  var digitsLen = digits.length;
  if ((roundingPos < 0)) {
    var negative = $thiz.ju_Formatter$Decimal__f_negative;
    return new $c_ju_Formatter$Decimal(negative, "0", 0);
  } else if ((roundingPos >= digitsLen)) {
    return $thiz;
  } else if ((digits.charCodeAt(roundingPos) < 53)) {
    if ((roundingPos === 0)) {
      var negative$1 = $thiz.ju_Formatter$Decimal__f_negative;
      return new $c_ju_Formatter$Decimal(negative$1, "0", 0);
    } else {
      return new $c_ju_Formatter$Decimal($thiz.ju_Formatter$Decimal__f_negative, digits.substring(0, roundingPos), (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - roundingPos) | 0)) | 0));
    }
  } else {
    var lastNonNinePos = (((-1) + roundingPos) | 0);
    while (true) {
      if ((lastNonNinePos >= 0)) {
        var index = lastNonNinePos;
        var $x_1 = (digits.charCodeAt(index) === 57);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        lastNonNinePos = (((-1) + lastNonNinePos) | 0);
      } else {
        break;
      }
    }
    if ((lastNonNinePos < 0)) {
      var newUnscaledValue = "1";
    } else {
      var endIndex = lastNonNinePos;
      var $x_2 = digits.substring(0, endIndex);
      var index$1 = lastNonNinePos;
      var newUnscaledValue = ($x_2 + $cToS((65535 & ((1 + digits.charCodeAt(index$1)) | 0))));
    }
    var pos = ((1 + lastNonNinePos) | 0);
    var newScale = (($thiz.ju_Formatter$Decimal__f_scale - ((digitsLen - pos) | 0)) | 0);
    return new $c_ju_Formatter$Decimal($thiz.ju_Formatter$Decimal__f_negative, newUnscaledValue, newScale);
  }
}
export { $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal as $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal };
/** @constructor */
function $c_ju_Formatter$Decimal(negative, unscaledValue, scale) {
  this.ju_Formatter$Decimal__f_negative = false;
  this.ju_Formatter$Decimal__f_unscaledValue = null;
  this.ju_Formatter$Decimal__f_scale = 0;
  this.ju_Formatter$Decimal__f_negative = negative;
  this.ju_Formatter$Decimal__f_unscaledValue = unscaledValue;
  this.ju_Formatter$Decimal__f_scale = scale;
}
export { $c_ju_Formatter$Decimal as $c_ju_Formatter$Decimal };
$c_ju_Formatter$Decimal.prototype = new $h_O();
$c_ju_Formatter$Decimal.prototype.constructor = $c_ju_Formatter$Decimal;
/** @constructor */
function $h_ju_Formatter$Decimal() {
}
export { $h_ju_Formatter$Decimal as $h_ju_Formatter$Decimal };
$h_ju_Formatter$Decimal.prototype = $c_ju_Formatter$Decimal.prototype;
$c_ju_Formatter$Decimal.prototype.isZero__Z = (function() {
  return (this.ju_Formatter$Decimal__f_unscaledValue === "0");
});
$c_ju_Formatter$Decimal.prototype.round__I__ju_Formatter$Decimal = (function(precision) {
  $m_ju_Formatter$();
  var condition = (precision > 0);
  if ((!condition)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "Decimal.round() called with non-positive precision");
  }
  return $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, precision);
});
$c_ju_Formatter$Decimal.prototype.setScale__I__ju_Formatter$Decimal = (function(newScale) {
  var this$1 = this.ju_Formatter$Decimal__f_unscaledValue;
  var roundingPos = ((((this$1.length + newScale) | 0) - this.ju_Formatter$Decimal__f_scale) | 0);
  var rounded = $p_ju_Formatter$Decimal__roundAtPos__I__ju_Formatter$Decimal(this, roundingPos);
  $m_ju_Formatter$();
  var condition = (rounded.isZero__Z() || (rounded.ju_Formatter$Decimal__f_scale <= newScale));
  if ((!condition)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "roundAtPos returned a non-zero value with a scale too large");
  }
  return ((rounded.isZero__Z() || (rounded.ju_Formatter$Decimal__f_scale === newScale)) ? rounded : new $c_ju_Formatter$Decimal(this.ju_Formatter$Decimal__f_negative, (("" + rounded.ju_Formatter$Decimal__f_unscaledValue) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((newScale - rounded.ju_Formatter$Decimal__f_scale) | 0))), newScale));
});
$c_ju_Formatter$Decimal.prototype.toString__T = (function() {
  return (((((("Decimal(" + this.ju_Formatter$Decimal__f_negative) + ", ") + this.ju_Formatter$Decimal__f_unscaledValue) + ", ") + this.ju_Formatter$Decimal__f_scale) + ")");
});
var $d_ju_Formatter$Decimal = new $TypeData().initClass($c_ju_Formatter$Decimal, "java.util.Formatter$Decimal", ({
  ju_Formatter$Decimal: 1
}));
export { $d_ju_Formatter$Decimal as $d_ju_Formatter$Decimal };
/** @constructor */
function $c_ju_Formatter$LocaleInfo() {
}
export { $c_ju_Formatter$LocaleInfo as $c_ju_Formatter$LocaleInfo };
$c_ju_Formatter$LocaleInfo.prototype = new $h_O();
$c_ju_Formatter$LocaleInfo.prototype.constructor = $c_ju_Formatter$LocaleInfo;
/** @constructor */
function $h_ju_Formatter$LocaleInfo() {
}
export { $h_ju_Formatter$LocaleInfo as $h_ju_Formatter$LocaleInfo };
$h_ju_Formatter$LocaleInfo.prototype = $c_ju_Formatter$LocaleInfo.prototype;
function $p_ju_Locale__updateSpecialLanguages__T__T($thiz, l) {
  switch (l) {
    case "iw": {
      return "he";
      break;
    }
    case "ji": {
      return "yi";
      break;
    }
    case "in": {
      return "id";
      break;
    }
    default: {
      return l;
    }
  }
}
export { $p_ju_Locale__updateSpecialLanguages__T__T as $p_ju_Locale__updateSpecialLanguages__T__T };
function $p_ju_Locale__translateSpecialLanguages__T__T($thiz, l) {
  return l;
}
export { $p_ju_Locale__translateSpecialLanguages__T__T as $p_ju_Locale__translateSpecialLanguages__T__T };
function $p_ju_Locale__isEqual__ju_Locale__Z($thiz, l) {
  if (((($thiz.ju_Locale__f_language === l.getLanguage__T()) && ($thiz.ju_Locale__f_country === l.getCountry__T())) && ($thiz.ju_Locale__f_variant === l.ju_Locale__f_variant))) {
    var this$1 = $thiz.ju_Locale__f_script;
    if (this$1.isEmpty__Z()) {
      var $x_1 = true;
    } else {
      var x0 = this$1.get__O();
      var $x_1 = (x0 === l.getScript__T());
    }
  } else {
    var $x_1 = false;
  }
  if ((($x_1 && $thiz.ju_Locale__f_extensions.forall__F1__Z(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var k = $uC(x$1._1__O());
      var v = x$1._2__O();
      return (l.getExtension__C__T(k) === v);
    }
    throw new $c_s_MatchError(x$1);
  })))) && $thiz.ju_Locale__f_unicodeExtensions.forall__F1__Z(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
    if ((x$1$2 !== null)) {
      var k$1 = x$1$2._1__O();
      var v$1 = x$1$2._2__O();
      return (l.getUnicodeLocaleType__T__T(k$1) === v$1);
    }
    throw new $c_s_MatchError(x$1$2);
  }))))) {
    var x = $thiz.ju_Locale__f_unicodeAttributes;
    var this$2 = $m_s_jdk_CollectionConverters$();
    var s = l.getUnicodeLocaleAttributes__ju_Set();
    var x$2 = new $c_sc_convert_AsScalaExtensions$SetHasAsScala(this$2, s).asScala__scm_Set();
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
}
export { $p_ju_Locale__isEqual__ju_Locale__Z as $p_ju_Locale__isEqual__ju_Locale__Z };
/** @constructor */
function $c_ju_Locale(language, country, variant, script, _extensions, unicodeExtensions, unicodeAttributes, supportSpecialCases) {
  this.ju_Locale__f_language = null;
  this.ju_Locale__f_country = null;
  this.ju_Locale__f_variant = null;
  this.ju_Locale__f_script = null;
  this.ju_Locale__f_unicodeExtensions = null;
  this.ju_Locale__f_unicodeAttributes = null;
  this.ju_Locale__f_cachedLanguageTag = null;
  this.ju_Locale__f_cachedHashCode = 0;
  this.ju_Locale__f_extensions = null;
  this.ju_Locale__f_language = language;
  this.ju_Locale__f_country = country;
  this.ju_Locale__f_variant = variant;
  this.ju_Locale__f_script = script;
  this.ju_Locale__f_unicodeExtensions = unicodeExtensions;
  this.ju_Locale__f_unicodeAttributes = unicodeAttributes;
  this.ju_Locale__f_cachedLanguageTag = null;
  this.ju_Locale__f_cachedHashCode = 0;
  if ((((language === null) || (country === null)) || (variant === null))) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Null argument to constructor not allowed");
  }
  var x = new $c_T3(language, country, variant);
  var x$2 = new $c_T3("ja", "JP", "JP");
  if ((x.equals__O__Z(x$2) && supportSpecialCases)) {
    var $x_3 = $m_sc_Map$();
    var $x_2 = $m_sr_ScalaRunTime$();
    var self = $m_ju_Locale$().ju_Locale$__f_UNICODE_LOCALE_EXTENSION;
    var $x_1 = _extensions.$plus$plus__sc_IterableOnce__sc_IterableOps($x_3.apply__sci_Seq__O($x_2.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), $bC(self), "ca-japanese")]))));
  } else {
    var x$3 = new $c_T3(language, country, variant);
    var x$4 = new $c_T3("th", "TH", "TH");
    if ((x$3.equals__O__Z(x$4) && supportSpecialCases)) {
      var $x_5 = $m_sc_Map$();
      var $x_4 = $m_sr_ScalaRunTime$();
      var self$1 = $m_ju_Locale$().ju_Locale$__f_UNICODE_LOCALE_EXTENSION;
      var $x_1 = _extensions.$plus$plus__sc_IterableOnce__sc_IterableOps($x_5.apply__sci_Seq__O($x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), $bC(self$1), "nu-thai")]))));
    } else {
      var $x_1 = _extensions;
    }
  }
  this.ju_Locale__f_extensions = $x_1;
}
export { $c_ju_Locale as $c_ju_Locale };
$c_ju_Locale.prototype = new $h_O();
$c_ju_Locale.prototype.constructor = $c_ju_Locale;
/** @constructor */
function $h_ju_Locale() {
}
export { $h_ju_Locale as $h_ju_Locale };
$h_ju_Locale.prototype = $c_ju_Locale.prototype;
$c_ju_Locale.prototype.getLanguage__T = (function() {
  var this$1 = this.ju_Locale__f_language;
  return $p_ju_Locale__translateSpecialLanguages__T__T(this, this$1.toLowerCase());
});
$c_ju_Locale.prototype.getScript__T = (function() {
  var this$1 = this.ju_Locale__f_script;
  return (this$1.isEmpty__Z() ? "" : this$1.get__O());
});
$c_ju_Locale.prototype.getCountry__T = (function() {
  var this$1 = this.ju_Locale__f_country;
  return this$1.toUpperCase();
});
$c_ju_Locale.prototype.hasExtensions__Z = (function() {
  var this$1 = this.ju_Locale__f_extensions;
  if ((!this$1.isEmpty__Z())) {
    return true;
  } else {
    var this$2 = this.ju_Locale__f_unicodeExtensions;
    return (!this$2.isEmpty__Z());
  }
});
$c_ju_Locale.prototype.getExtension__C__T = (function(key) {
  if ((key === $m_ju_Locale$().ju_Locale$__f_UNICODE_LOCALE_EXTENSION)) {
    var this$1 = this.ju_Locale__f_unicodeExtensions;
    var $x_1 = (!this$1.isEmpty__Z());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var this$2 = this.ju_Locale__f_unicodeExtensions.collect__s_PartialFunction__O(new $c_ju_Locale$$anon$1());
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "-", "");
  } else {
    var this$4 = this.ju_Locale__f_extensions.get__O__s_Option($bC(key));
    return (this$4.isEmpty__Z() ? null : this$4.get__O());
  }
});
$c_ju_Locale.prototype.getUnicodeLocaleAttributes__ju_Set = (function() {
  var this$1 = $m_s_jdk_CollectionConverters$();
  var s = this.ju_Locale__f_unicodeAttributes;
  return new $c_sc_convert_AsJavaExtensions$SetHasAsJava(this$1, s).asJava__ju_Set();
});
$c_ju_Locale.prototype.getUnicodeLocaleType__T__T = (function(key) {
  var this$2 = this.ju_Locale__f_unicodeExtensions.get__O__s_Option(key);
  return (this$2.isEmpty__Z() ? null : this$2.get__O());
});
$c_ju_Locale.prototype.toString__T = (function() {
  var x = this.ju_Locale__f_variant;
  var hasVariant = (x !== "");
  var x$1 = this.getCountry__T();
  var hasCountry = (x$1 !== "");
  var x$2 = this.getLanguage__T();
  var hasLanguage = (x$2 !== "");
  var x$3 = this.getScript__T();
  var hasScript = (x$3 !== "");
  var countryPart = (hasCountry ? ("_" + this.getCountry__T()) : ((hasVariant || hasScript) ? "_" : ""));
  var variantPart = (hasVariant ? ("_" + this.ju_Locale__f_variant) : (hasScript ? "_" : ""));
  var scriptPart = ((hasScript && this.hasExtensions__Z()) ? (("#" + this.getScript__T()) + "_") : (hasScript ? ("#" + this.getScript__T()) : (this.hasExtensions__Z() ? "_#" : "")));
  var this$9 = this.ju_Locale__f_extensions.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$1) => {
    if ((x$1$1 !== null)) {
      var x$4 = $uC(x$1$1._1__O());
      var v = x$1$1._2__O();
      return (($cToS(x$4) + "-") + v);
    }
    throw new $c_s_MatchError(x$1$1);
  })));
  var extensionsPart = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$9, "", "", "");
  return ((hasLanguage || hasCountry) ? ((((this.getLanguage__T() + countryPart) + variantPart) + scriptPart) + extensionsPart) : "");
});
$c_ju_Locale.prototype.toLanguageTag__T = (function() {
  if ((this.ju_Locale__f_cachedLanguageTag === null)) {
    var x = this.getLanguage__T();
    if (((x !== "") && $m_ju_Locale$().checkLanguage__T__Z(this.getLanguage__T()))) {
      var language = $p_ju_Locale__updateSpecialLanguages__T__T(this, this.getLanguage__T());
    } else {
      var language = "und";
    }
    var country = ($m_ju_Locale$().checkRegion__T__Z(this.getCountry__T()) ? ("-" + this.getCountry__T()) : "");
    var this$3 = this.ju_Locale__f_variant;
    var variantSegments = $f_T__split__T__I__AT(this$3, "-|_", 0);
    _return: {
      var i = 0;
      while ((i < variantSegments.u.length)) {
        var x1 = i;
        var x0 = variantSegments.u[x1];
        if ((!$m_ju_Locale$().checkVariantSegment__T__Z(x0))) {
          var allSegmentsWellFormed = false;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var allSegmentsWellFormed = true;
    }
    _return$1: {
      var i$1 = 0;
      while ((i$1 < variantSegments.u.length)) {
        var x1$1 = i$1;
        var x0$1 = variantSegments.u[x1$1];
        if ((!$m_ju_Locale$().checkAcceptableVariantSegment__T__Z(x0$1))) {
          var allAcceptableSegments = false;
          break _return$1;
        }
        i$1 = ((1 + i$1) | 0);
      }
      var allAcceptableSegments = true;
    }
    if (allSegmentsWellFormed) {
      var this$8 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(variantSegments);
      var variant = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$8, "-", "-", "");
    } else if (allAcceptableSegments) {
      var $x_1 = $m_s_reflect_ClassTag$();
      var this$12 = $objectGetClass(variantSegments);
      var evidence$1 = $x_1.apply__jl_Class__s_reflect_ClassTag(this$12.data.getComponentType());
      var res1 = new $c_scm_ArrayBuilder$generic(evidence$1.runtimeClass__jl_Class());
      var $x_2 = $m_s_reflect_ClassTag$();
      var this$16 = $objectGetClass(variantSegments);
      var evidence$1$1 = $x_2.apply__jl_Class__s_reflect_ClassTag(this$16.data.getComponentType());
      var res2 = new $c_scm_ArrayBuilder$generic(evidence$1$1.runtimeClass__jl_Class());
      var i$2 = 0;
      while ((i$2 < variantSegments.u.length)) {
        var x1$2 = i$2;
        var x$1 = variantSegments.u[x1$2];
        var this$19 = ($m_ju_Locale$().checkVariantSegment__T__Z(x$1) ? res1 : res2);
        this$19.addOne__O__scm_ArrayBuilder$generic(x$1);
        i$2 = ((1 + i$2) | 0);
      }
      var _1 = res1.result__O();
      var _2 = res2.result__O();
      var \u03b41$___1 = _1;
      var \u03b41$___2 = _2;
      var wellFormed$2 = \u03b41$___1;
      var acceptable$2 = \u03b41$___2;
      if ((wellFormed$2.u.length !== 0)) {
        var this$25 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($m_sc_ArrayOps$().slice$extension__O__I__I__O(wellFormed$2, 0, 1));
        var pre = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$25, "-", "-", "-");
      } else {
        var pre = "-";
      }
      var $x_3 = $m_s_Predef$();
      var xs = $m_sc_ArrayOps$().drop$extension__O__I__O(wellFormed$2, 1);
      var newLength = ((acceptable$2.u.length + $m_jl_reflect_Array$().getLength__O__I(xs)) | 0);
      var this$33 = $objectGetClass(acceptable$2);
      var that = this$33.data.getComponentType();
      if ($d_T.isAssignableFrom(that.data)) {
        var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(acceptable$2, newLength, $d_T.getArrayOf().getClassOf());
      } else {
        var dest = new ($d_T.getArrayOf().constr)(newLength);
        $m_s_Array$().copy__O__I__O__I__I__V(acceptable$2, 0, dest, 0, acceptable$2.u.length);
        var dest$1 = dest;
      }
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest$1, acceptable$2.u.length, $m_jl_reflect_Array$().getLength__O__I(xs));
      var this$38 = $x_3.wrapRefArray__AO__scm_ArraySeq$ofRef(dest$1);
      var variant = ((pre + "x-lvariant") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$38, "-", "-", ""));
    } else {
      var variant = "";
    }
    var this$39 = this.ju_Locale__f_extensions;
    if ((!this$39.isEmpty__Z())) {
      var ext = $f_sc_IterableOnceOps__mkString__T__T__T__T(this.ju_Locale__f_extensions.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$1) => {
        if ((x$1$1 !== null)) {
          var x$2 = $uC(x$1$1._1__O());
          var v = x$1$1._2__O();
          return (($cToS(x$2) + "-") + v);
        }
        throw new $c_s_MatchError(x$1$1);
      }))), "-", "-", "");
    } else {
      var ext = "";
    }
    var this$40 = this.ju_Locale__f_script;
    var this$41 = (this$40.isEmpty__Z() ? $m_s_None$() : new $c_s_Some((this$40.get__O(), ("-" + this.getScript__T()))));
    var script = (this$41.isEmpty__Z() ? "" : this$41.get__O());
    this.ju_Locale__f_cachedLanguageTag = ((((this.getLanguage__T() === "no") && (this.getCountry__T() === "NO")) && (this.ju_Locale__f_variant === "NY")) ? "nn-NO" : ((((("" + language) + script) + country) + ext) + variant));
  }
  return this.ju_Locale__f_cachedLanguageTag;
});
$c_ju_Locale.prototype.equals__O__Z = (function(x) {
  return ((x instanceof $c_ju_Locale) && $p_ju_Locale__isEqual__ju_Locale__Z(this, x));
});
$c_ju_Locale.prototype.hashCode__I = (function() {
  if ((this.ju_Locale__f_cachedHashCode === 0)) {
    this.ju_Locale__f_cachedHashCode = $f_T__hashCode__I(this.toLanguageTag__T());
  }
  return this.ju_Locale__f_cachedHashCode;
});
function $isArrayOf_ju_Locale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Locale)));
}
export { $isArrayOf_ju_Locale as $isArrayOf_ju_Locale };
var $d_ju_Locale = new $TypeData().initClass($c_ju_Locale, "java.util.Locale", ({
  ju_Locale: 1
}));
export { $d_ju_Locale as $d_ju_Locale };
/** @constructor */
function $c_ju_Locale$() {
  this.ju_Locale$__f_ENGLISH$lzy1 = null;
  this.ju_Locale$__f_ENGLISHbitmap$1 = false;
  this.ju_Locale$__f_ROOT$lzy1 = null;
  this.ju_Locale$__f_ROOTbitmap$1 = false;
  this.ju_Locale$__f_UNICODE_LOCALE_EXTENSION = 0;
  this.ju_Locale$__f_defaultLocale = null;
  $n_ju_Locale$ = this;
  this.ju_Locale$__f_UNICODE_LOCALE_EXTENSION = 117;
  this.ju_Locale$__f_defaultLocale = $m_Llocales_DefaultLocale$().platformLocale__ju_Locale();
  var $x_10 = $m_s_Predef$();
  var xs = $m_ju_Locale$Category$().values__Aju_Locale$Category();
  var f = ((_$5) => {
    var value = this.ju_Locale$__f_defaultLocale;
    var y = new $c_s_Some(value);
    return $ct_T2__O__O__(new $c_T2(), _$5, y);
  });
  var len = xs.u.length;
  var ys = new ($d_T2.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = xs.u[i];
        ys.u[$x_1] = f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = xs.u[i];
        ys.u[$x_2] = f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = xs.u[i];
        ys.u[$x_3] = f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_J)) {
      while ((i < len)) {
        var $x_4 = i;
        var t = xs.u[i];
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.u[$x_4] = f(new $c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_F)) {
      while ((i < len)) {
        var $x_5 = i;
        var x0$3 = xs.u[i];
        ys.u[$x_5] = f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_C)) {
      while ((i < len)) {
        var $x_6 = i;
        var x0$4 = xs.u[i];
        ys.u[$x_6] = f($bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_B)) {
      while ((i < len)) {
        var $x_7 = i;
        var x0$5 = xs.u[i];
        ys.u[$x_7] = f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_S)) {
      while ((i < len)) {
        var $x_8 = i;
        var x0$6 = xs.u[i];
        ys.u[$x_8] = f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_Z)) {
      while ((i < len)) {
        var $x_9 = i;
        var x0$7 = xs.u[i];
        ys.u[$x_9] = f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $c_s_MatchError(xs);
    }
  }
  var this$10 = $x_10.wrapRefArray__AO__scm_ArraySeq$ofRef(ys);
  $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$10);
}
export { $c_ju_Locale$ as $c_ju_Locale$ };
$c_ju_Locale$.prototype = new $h_O();
$c_ju_Locale$.prototype.constructor = $c_ju_Locale$;
/** @constructor */
function $h_ju_Locale$() {
}
export { $h_ju_Locale$ as $h_ju_Locale$ };
$h_ju_Locale$.prototype = $c_ju_Locale$.prototype;
$c_ju_Locale$.prototype.ENGLISH__ju_Locale = (function() {
  if ((!this.ju_Locale$__f_ENGLISHbitmap$1)) {
    var this$1 = $m_Llocales_LocalesDb$().localeForLanguageTag__T__s_Option("en");
    this.ju_Locale$__f_ENGLISH$lzy1 = (this$1.isEmpty__Z() ? this.ROOT__ju_Locale() : this$1.get__O());
    this.ju_Locale$__f_ENGLISHbitmap$1 = true;
  }
  return this.ju_Locale$__f_ENGLISH$lzy1;
});
$c_ju_Locale$.prototype.ROOT__ju_Locale = (function() {
  if ((!this.ju_Locale$__f_ROOTbitmap$1)) {
    this.ju_Locale$__f_ROOT$lzy1 = $m_Llocales_LocalesDb$().Llocales_LocalesDb$__f_root.toLocale__ju_Locale();
    this.ju_Locale$__f_ROOTbitmap$1 = true;
  }
  return this.ju_Locale$__f_ROOT$lzy1;
});
$c_ju_Locale$.prototype.checkRegex__s_util_matching_Regex__T__Z = (function(regex, s) {
  if ((s !== null)) {
    var x32 = regex.unapplySeq__jl_CharSequence__s_Option(s);
    if ((!x32.isEmpty__Z())) {
      var x33 = x32.get__O();
      if ((x33.lengthCompare__I__I(0) === 0)) {
        return true;
      }
    }
  }
  return false;
});
$c_ju_Locale$.prototype.checkLanguage__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{2,8}", $m_sci_Nil$()), l);
});
$c_ju_Locale$.prototype.checkScript__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{4}", $m_sci_Nil$()), l);
});
$c_ju_Locale$.prototype.checkRegion__T__Z = (function(l) {
  return (this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z]{2}", $m_sci_Nil$()), l) || this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9]{3}", $m_sci_Nil$()), l));
});
$c_ju_Locale$.prototype.checkAcceptableVariantSegment__T__Z = (function(l) {
  return this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9a-zA-Z]{1,8}", $m_sci_Nil$()), l);
});
$c_ju_Locale$.prototype.checkVariantSegment__T__Z = (function(l) {
  return (this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9][0-9a-zA-Z]{3}", $m_sci_Nil$()), l) || this.checkRegex__s_util_matching_Regex__T__Z($ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9a-zA-Z]{5,8}", $m_sci_Nil$()), l));
});
$c_ju_Locale$.prototype.checkVariant__T__Z = (function(l) {
  var parts = $f_T__split__T__I__AT(l, "-|_", 0);
  var i = 0;
  while ((i < parts.u.length)) {
    var x1 = i;
    var x0 = parts.u[x1];
    if ((!this.checkVariantSegment__T__Z(x0))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
var $d_ju_Locale$ = new $TypeData().initClass($c_ju_Locale$, "java.util.Locale$", ({
  ju_Locale$: 1
}));
export { $d_ju_Locale$ as $d_ju_Locale$ };
var $n_ju_Locale$;
function $m_ju_Locale$() {
  if ((!$n_ju_Locale$)) {
    $n_ju_Locale$ = new $c_ju_Locale$();
  }
  return $n_ju_Locale$;
}
export { $m_ju_Locale$ as $m_ju_Locale$ };
/** @constructor */
function $c_ju_Locale$Builder() {
  this.ju_Locale$Builder__f_builder = null;
  var language = $m_s_None$();
  var region = $m_s_None$();
  var variant = $m_s_None$();
  var script = $m_s_None$();
  var extensions = $m_sc_Map$().empty__O();
  var unicodeExtensions = $m_sc_Map$().empty__O();
  var unicodeAttributes = $m_sc_Set$().empty__O();
  this.ju_Locale$Builder__f_builder = new $c_ju_Locale$LocaleBuilder(true, language, region, variant, script, extensions, unicodeExtensions, unicodeAttributes);
}
export { $c_ju_Locale$Builder as $c_ju_Locale$Builder };
$c_ju_Locale$Builder.prototype = new $h_O();
$c_ju_Locale$Builder.prototype.constructor = $c_ju_Locale$Builder;
/** @constructor */
function $h_ju_Locale$Builder() {
}
export { $h_ju_Locale$Builder as $h_ju_Locale$Builder };
$h_ju_Locale$Builder.prototype = $c_ju_Locale$Builder.prototype;
$c_ju_Locale$Builder.prototype.setLanguage__T__ju_Locale$Builder = (function(language) {
  var this$1 = this.ju_Locale$Builder__f_builder.language__T__s_Option(language);
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid language " + language));
  }
  var x0 = this$1.get__O();
  this.ju_Locale$Builder__f_builder = x0;
  return this;
});
$c_ju_Locale$Builder.prototype.setScript__T__ju_Locale$Builder = (function(script) {
  var this$1 = this.ju_Locale$Builder__f_builder.script__T__s_Option(script);
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid script " + script));
  }
  var x0 = this$1.get__O();
  this.ju_Locale$Builder__f_builder = x0;
  return this;
});
$c_ju_Locale$Builder.prototype.setRegion__T__ju_Locale$Builder = (function(region) {
  var this$1 = this.ju_Locale$Builder__f_builder.region__T__s_Option(region);
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid region " + region));
  }
  var x0 = this$1.get__O();
  this.ju_Locale$Builder__f_builder = x0;
  return this;
});
$c_ju_Locale$Builder.prototype.setVariant__T__ju_Locale$Builder = (function(variant) {
  var this$1 = this.ju_Locale$Builder__f_builder.variant__T__s_Option(variant);
  if (this$1.isEmpty__Z()) {
    throw $ct_ju_IllformedLocaleException__T__(new $c_ju_IllformedLocaleException(), ("Invalid variant " + variant));
  }
  var x0 = this$1.get__O();
  this.ju_Locale$Builder__f_builder = x0;
  return this;
});
$c_ju_Locale$Builder.prototype.build__ju_Locale = (function() {
  return this.ju_Locale$Builder__f_builder.build__ju_Locale();
});
var $d_ju_Locale$Builder = new $TypeData().initClass($c_ju_Locale$Builder, "java.util.Locale$Builder", ({
  ju_Locale$Builder: 1
}));
export { $d_ju_Locale$Builder as $d_ju_Locale$Builder };
function $is_ju_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map)));
}
export { $is_ju_Map as $is_ju_Map };
function $isArrayOf_ju_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map)));
}
export { $isArrayOf_ju_Map as $isArrayOf_ju_Map };
function $is_ju_Map$Entry(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Map$Entry)));
}
export { $is_ju_Map$Entry as $is_ju_Map$Entry };
function $isArrayOf_ju_Map$Entry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Map$Entry)));
}
export { $isArrayOf_ju_Map$Entry as $isArrayOf_ju_Map$Entry };
function $is_ju_RandomAccess(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_RandomAccess)));
}
export { $is_ju_RandomAccess as $is_ju_RandomAccess };
function $isArrayOf_ju_RandomAccess(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_RandomAccess)));
}
export { $isArrayOf_ju_RandomAccess as $isArrayOf_ju_RandomAccess };
function $p_ju_TimeZone$__offsetInMillis$1__I($thiz) {
  var browserDate = new Date();
  return Math.imul(1000, Math.imul(60, $doubleToInt((+browserDate.getTimezoneOffset()))));
}
export { $p_ju_TimeZone$__offsetInMillis$1__I as $p_ju_TimeZone$__offsetInMillis$1__I };
function $p_ju_TimeZone$__browserTZ$1__s_util_Try($thiz) {
  try {
    var browserDate = new Date();
    var $x_1 = $m_sc_StringOps$();
    var x = browserDate.toTimeString();
    var x$1 = $x_1.split$extension__T__C__AT(x, 32).u[1];
    _return: {
      var len = x$1.length;
      var i = 0;
      while ((i < len)) {
        var index = i;
        var x0 = x$1.charCodeAt(index);
        if ((x0 === 32)) {
          var x1 = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var x1 = (-1);
    }
    var r1 = ((x1 === (-1)) ? x$1 : x$1.substring(0, x1));
    return new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
}
export { $p_ju_TimeZone$__browserTZ$1__s_util_Try as $p_ju_TimeZone$__browserTZ$1__s_util_Try };
function $p_ju_TimeZone$__timeZone$1__T($thiz) {
  try {
    var x = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    var r1 = ((x === (void 0)) ? $p_ju_TimeZone$__browserTZ$1__s_util_Try($thiz).getOrElse__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => "UTC"))) : x);
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  return $x_1.orElse__F0__s_util_Try(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $p_ju_TimeZone$__browserTZ$1__s_util_Try($thiz)))).getOrElse__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => "UTC")));
}
export { $p_ju_TimeZone$__timeZone$1__T as $p_ju_TimeZone$__timeZone$1__T };
/** @constructor */
function $c_ju_TimeZone$() {
  $n_ju_TimeZone$ = this;
  $p_ju_TimeZone$__offsetInMillis$1__I(this);
  $p_ju_TimeZone$__timeZone$1__T(this);
}
export { $c_ju_TimeZone$ as $c_ju_TimeZone$ };
$c_ju_TimeZone$.prototype = new $h_O();
$c_ju_TimeZone$.prototype.constructor = $c_ju_TimeZone$;
/** @constructor */
function $h_ju_TimeZone$() {
}
export { $h_ju_TimeZone$ as $h_ju_TimeZone$ };
$h_ju_TimeZone$.prototype = $c_ju_TimeZone$.prototype;
$c_ju_TimeZone$.prototype.getTimeZone__T__ju_TimeZone = (function(timeZone) {
  return this.getTimeZone__Ljava_time_ZoneId__ju_TimeZone($m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId(timeZone));
});
$c_ju_TimeZone$.prototype.getTimeZone__Ljava_time_ZoneId__ju_TimeZone = (function(zoneId) {
  var rules = zoneId.getRules__Ljava_time_zone_ZoneRules();
  new $c_Ljava_time_Clock$SystemClock($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
  var $x_1 = $m_Ljava_time_Instant$();
  var value = (+Date.now());
  var this$5 = $m_RTLong$();
  var lo = this$5.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  var hi = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$6 = rules.getStandardOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($x_1.ofEpochMilli__J__Ljava_time_Instant(new $c_RTLong(lo, hi)));
  var offsetInMillis = Math.imul(1000, this$6.Ljava_time_ZoneOffset__f_totalSeconds);
  return new $c_ju_SimpleTimeZone(offsetInMillis, zoneId.getId__T());
});
var $d_ju_TimeZone$ = new $TypeData().initClass($c_ju_TimeZone$, "java.util.TimeZone$", ({
  ju_TimeZone$: 1
}));
export { $d_ju_TimeZone$ as $d_ju_TimeZone$ };
var $n_ju_TimeZone$;
function $m_ju_TimeZone$() {
  if ((!$n_ju_TimeZone$)) {
    $n_ju_TimeZone$ = new $c_ju_TimeZone$();
  }
  return $n_ju_TimeZone$;
}
export { $m_ju_TimeZone$ as $m_ju_TimeZone$ };
/** @constructor */
function $c_ju_internal_MurmurHash3$() {
}
export { $c_ju_internal_MurmurHash3$ as $c_ju_internal_MurmurHash3$ };
$c_ju_internal_MurmurHash3$.prototype = new $h_O();
$c_ju_internal_MurmurHash3$.prototype.constructor = $c_ju_internal_MurmurHash3$;
/** @constructor */
function $h_ju_internal_MurmurHash3$() {
}
export { $h_ju_internal_MurmurHash3$ as $h_ju_internal_MurmurHash3$ };
$h_ju_internal_MurmurHash3$.prototype = $c_ju_internal_MurmurHash3$.prototype;
$c_ju_internal_MurmurHash3$.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0);
});
$c_ju_internal_MurmurHash3$.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$c_ju_internal_MurmurHash3$.prototype.finalizeHash__I__I__I = (function(hash, length) {
  var hash$1 = (hash ^ length);
  var h = hash$1;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
var $d_ju_internal_MurmurHash3$ = new $TypeData().initClass($c_ju_internal_MurmurHash3$, "java.util.internal.MurmurHash3$", ({
  ju_internal_MurmurHash3$: 1
}));
export { $d_ju_internal_MurmurHash3$ as $d_ju_internal_MurmurHash3$ };
var $n_ju_internal_MurmurHash3$;
function $m_ju_internal_MurmurHash3$() {
  if ((!$n_ju_internal_MurmurHash3$)) {
    $n_ju_internal_MurmurHash3$ = new $c_ju_internal_MurmurHash3$();
  }
  return $n_ju_internal_MurmurHash3$;
}
export { $m_ju_internal_MurmurHash3$ as $m_ju_internal_MurmurHash3$ };
function $p_ju_regex_PatternCompiler__parseError__T__E($thiz, desc) {
  throw new $c_ju_regex_PatternSyntaxException(desc, $thiz.ju_regex_PatternCompiler__f_pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
}
export { $p_ju_regex_PatternCompiler__parseError__T__E as $p_ju_regex_PatternCompiler__parseError__T__E };
function $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V($thiz) {
  var m = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp.exec($thiz.ju_regex_PatternCompiler__f_pattern);
  if ((m !== null)) {
    var x = m[1];
    if ((x !== (void 0))) {
      var end = x.length;
      var i = 0;
      while ((i < end)) {
        var value = i;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags | $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$charToFlag__C__I(x.charCodeAt(value)));
        i = ((1 + i) | 0);
      }
    }
    if (((256 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags);
    }
    var x$1 = m[2];
    if ((x$1 !== (void 0))) {
      var end$1 = x$1.length;
      var i$1 = 0;
      while ((i$1 < end$1)) {
        var value$1 = i$1;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags & (~$m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$charToFlag__C__I(x$1.charCodeAt(value$1))));
        i$1 = ((1 + i$1) | 0);
      }
    }
    var $x_1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var x$2 = m[0];
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($x_1 + x$2.length) | 0);
  }
}
export { $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V as $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V };
function $p_ju_regex_PatternCompiler__literal__T__T($thiz, s) {
  var result = "";
  var len = s.length;
  var i = 0;
  while ((i !== len)) {
    var cp = $f_T__codePointAt__I__I(s, i);
    result = (("" + result) + $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp));
    i = ((i + ((cp >= 65536) ? 2 : 1)) | 0);
  }
  return result;
}
export { $p_ju_regex_PatternCompiler__literal__T__T as $p_ju_regex_PatternCompiler__literal__T__T };
function $p_ju_regex_PatternCompiler__literal__I__T($thiz, cp) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(cp);
  if ((cp < 128)) {
    switch (cp) {
      case 94:
      case 36:
      case 92:
      case 46:
      case 42:
      case 43:
      case 63:
      case 40:
      case 41:
      case 91:
      case 93:
      case 123:
      case 125:
      case 124: {
        return ("\\" + s);
        break;
      }
      default: {
        return (((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 2) ? s : (((cp >= 65) && (cp <= 90)) ? ((("[" + s) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + cp) | 0))) + "]") : (((cp >= 97) && (cp <= 122)) ? ((("[" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T((((-32) + cp) | 0))) + s) + "]") : s)));
      }
    }
  } else {
    return ((((-1024) & cp) === 56320) ? (("(?:" + s) + ")") : s);
  }
}
export { $p_ju_regex_PatternCompiler__literal__I__T as $p_ju_regex_PatternCompiler__literal__I__T };
function $p_ju_regex_PatternCompiler__skipComments__V($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1 = pattern.charCodeAt(index);
      switch (x1) {
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          continue;
          break;
        }
        case 35: {
          $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V();
          continue;
          break;
        }
      }
    }
    break;
  }
}
export { $p_ju_regex_PatternCompiler__skipComments__V as $p_ju_regex_PatternCompiler__skipComments__V };
function $p_ju_regex_PatternCompiler__compileRepeater__I__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  var repeaterDispatchChar = ((startOfRepeater === len) ? 46 : pattern.charCodeAt(startOfRepeater));
  if (((((repeaterDispatchChar === 63) || (repeaterDispatchChar === 42)) || (repeaterDispatchChar === 43)) || (repeaterDispatchChar === 123))) {
    var x1 = compiledToken.charCodeAt(0);
    switch (x1) {
      case 94:
      case 36: {
        var isTokenAnAssertion = true;
        break;
      }
      case 40: {
        var isTokenAnAssertion = ((compiledToken.charCodeAt(1) === 63) && (compiledToken.charCodeAt(2) !== 58));
        break;
      }
      case 92: {
        var c = compiledToken.charCodeAt(1);
        var isTokenAnAssertion = ((c === 98) || (c === 66));
        break;
      }
      default: {
        var isTokenAnAssertion = false;
      }
    }
    var wrappedToken = (isTokenAnAssertion ? (("(?:" + compiledToken) + ")") : compiledToken);
    var baseRepeater = $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar);
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var x1$2 = pattern.charCodeAt(index);
      switch (x1$2) {
        case 43: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, wrappedToken, baseRepeater);
          break;
        }
        case 63: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return ((("" + wrappedToken) + baseRepeater) + "?");
          break;
        }
        default: {
          return (("" + wrappedToken) + baseRepeater);
        }
      }
    } else {
      return (("" + wrappedToken) + baseRepeater);
    }
  } else {
    return compiledToken;
  }
}
export { $p_ju_regex_PatternCompiler__compileRepeater__I__T__T as $p_ju_regex_PatternCompiler__compileRepeater__I__T__T };
function $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T($thiz, repeaterDispatchChar) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var startOfRepeater = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if ((repeaterDispatchChar === 123)) {
    var len = pattern.length;
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $x_1 = true;
    } else {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = pattern.charCodeAt(index);
      var $x_1 = (!((c >= 48) && (c <= 57)));
    }
    if ($x_1) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    while (true) {
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
        var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var c$1 = pattern.charCodeAt(index$1);
        var $x_2 = ((c$1 >= 48) && (c$1 <= 57));
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      } else {
        break;
      }
    }
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    if ((pattern.charCodeAt(index$2) === 44)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      while (true) {
        if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
          var index$3 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c$2 = pattern.charCodeAt(index$3);
          var $x_3 = ((c$2 >= 48) && (c$2 <= 57));
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        } else {
          break;
        }
      }
    }
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
      var $x_4 = true;
    } else {
      var index$4 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var $x_4 = (pattern.charCodeAt(index$4) !== 125);
    }
    if ($x_4) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal repetition");
    }
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  }
  return pattern.substring(startOfRepeater, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
}
export { $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T as $p_ju_regex_PatternCompiler__parseBaseRepeater__C__T };
function $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T($thiz, compiledGroupCountBeforeThisToken, compiledToken, baseRepeater) {
  var end = ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length | 0);
  var i = 0;
  while ((i < end)) {
    var value = i;
    var mapped = ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[value] | 0);
    if ((mapped > compiledGroupCountBeforeThisToken)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[value] = ((1 + mapped) | 0);
    }
    i = ((1 + i) | 0);
  }
  var amendedToken = compiledToken.replace($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp, ((arg1$2, arg2$2, arg3$2) => {
    if ((((arg2$2.length % 2) | 0) === 0)) {
      return arg1$2;
    } else {
      var groupNumber = (parseInt(arg3$2, 10) | 0);
      return ((groupNumber > compiledGroupCountBeforeThisToken) ? (("" + arg2$2) + ((1 + groupNumber) | 0)) : arg1$2);
    }
  }));
  $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
  var myGroupNumber = ((1 + compiledGroupCountBeforeThisToken) | 0);
  return ((((("(?:(?=(" + amendedToken) + baseRepeater) + "))\\") + myGroupNumber) + ")");
}
export { $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T as $p_ju_regex_PatternCompiler__buildPossessiveQuantifier__I__T__T__T };
function $p_ju_regex_PatternCompiler__compileEscape__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  if ((((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0) === len)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\ at end of pattern");
  }
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  var dispatchChar = pattern.charCodeAt(index);
  switch (dispatchChar) {
    case 100:
    case 68:
    case 104:
    case 72:
    case 115:
    case 83:
    case 118:
    case 86:
    case 119:
    case 87:
    case 112:
    case 80: {
      var cls = $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar);
      var x1$2 = cls.ju_regex_PatternCompiler$CompiledCharClass__f_kind;
      switch (x1$2) {
        case 0: {
          return (("\\p{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break;
        }
        case 1: {
          return (("\\P{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data) + "}");
          break;
        }
        case 2: {
          return (("[" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data) + "]");
          break;
        }
        case 3: {
          return $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(cls.ju_regex_PatternCompiler$CompiledCharClass__f_data);
          break;
        }
        default: {
          throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1$2);
        }
      }
      break;
    }
    case 98: {
      if ((pattern.substring($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)) === "b{g}")) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\b{g} is not supported");
      } else if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\b with UNICODE_CASE", "2018");
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\b";
      }
      break;
    }
    case 66: {
      if (((320 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("\\B with UNICODE_CASE", "2018");
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return "\\B";
      }
      break;
    }
    case 65: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "^";
      break;
    }
    case 71: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\G in the middle of a pattern is not supported");
      break;
    }
    case 90: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var lineTerminator = (((1 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "(?:\r\n?|[\n\u0085\u2028\u2029])");
      return (("(?=" + lineTerminator) + "?$)");
      break;
    }
    case 122: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "$";
      break;
    }
    case 82: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return "(?:\r\n|[\n-\r\u0085\u2028\u2029])";
      break;
    }
    case 88: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\X is not supported");
      break;
    }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57: {
      var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var end = ((1 + start) | 0);
      while (true) {
        if ((end !== len)) {
          var index$1 = end;
          var c = pattern.charCodeAt(index$1);
          var $x_2 = ((c >= 48) && (c <= 57));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          var s = pattern.substring(start, ((1 + end) | 0));
          var $x_1 = ((parseInt(s, 10) | 0) <= (((-1) + ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length | 0)) | 0));
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          end = ((1 + end) | 0);
        } else {
          break;
        }
      }
      var groupString = pattern.substring(start, end);
      var groupNumber = (parseInt(groupString, 10) | 0);
      if ((groupNumber > (((-1) + ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length | 0)) | 0))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("numbered capturing group <" + groupNumber) + "> does not exist"));
      }
      var compiledGroupNumber = ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber] | 0);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
      return (("(?:\\" + compiledGroupNumber) + ")");
      break;
    }
    case 107: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
        var $x_3 = true;
      } else {
        var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
        var $x_3 = (pattern.charCodeAt(index$2) !== 60);
      }
      if ($x_3) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\k is not followed by '<' for named capturing group");
      }
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var groupName = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
      var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
      if ((!(!(!$m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, groupName))))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + groupName) + "> does not exit"));
      }
      var groupNumber$2 = (dict[groupName] | 0);
      var compiledGroupNumber$2 = ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap[groupNumber$2] | 0);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (("(?:\\" + compiledGroupNumber$2) + ")");
      break;
    }
    case 81: {
      var start$2 = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      var end$2 = (pattern.indexOf("\\E", start$2) | 0);
      if ((end$2 < 0)) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = pattern.length;
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, pattern.substring(start$2));
      } else {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end$2) | 0);
        return $p_ju_regex_PatternCompiler__literal__T__T($thiz, pattern.substring(start$2, end$2));
      }
      break;
    }
    default: {
      return $p_ju_regex_PatternCompiler__literal__I__T($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz));
    }
  }
}
export { $p_ju_regex_PatternCompiler__compileEscape__T as $p_ju_regex_PatternCompiler__compileEscape__T };
function $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var x1 = $f_T__codePointAt__I__I(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
  switch (x1) {
    case 48: {
      return $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz);
      break;
    }
    case 120: {
      return $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz);
      break;
    }
    case 117: {
      return $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz);
      break;
    }
    case 78: {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "\\N is not supported");
      break;
    }
    case 97: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 7;
      break;
    }
    case 116: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 9;
      break;
    }
    case 110: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 10;
      break;
    }
    case 102: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 12;
      break;
    }
    case 114: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 13;
      break;
    }
    case 101: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return 27;
      break;
    }
    case 99: {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === pattern.length)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal control escape sequence");
      }
      var cp = $f_T__codePointAt__I__I(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cp >= 65536) ? 2 : 1)) | 0);
      return (64 ^ cp);
      break;
    }
    default: {
      if ((((x1 >= 65) && (x1 <= 90)) || ((x1 >= 97) && (x1 <= 122)))) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal/unsupported escape sequence");
      }
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      return x1;
    }
  }
}
export { $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I as $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I };
function $p_ju_regex_PatternCompiler__parseOctalEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) < len)) {
    var index = ((1 + start) | 0);
    var d1 = (((-48) + pattern.charCodeAt(index)) | 0);
  } else {
    var d1 = (-1);
  }
  if (((d1 < 0) || (d1 > 7))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal octal escape sequence");
  }
  if ((((2 + start) | 0) < len)) {
    var index$1 = ((2 + start) | 0);
    var d2 = (((-48) + pattern.charCodeAt(index$1)) | 0);
  } else {
    var d2 = (-1);
  }
  if (((d2 < 0) || (d2 > 7))) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return d1;
  } else if ((d1 > 3)) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    return (((d1 << 3) + d2) | 0);
  } else {
    if ((((3 + start) | 0) < len)) {
      var index$2 = ((3 + start) | 0);
      var d3 = (((-48) + pattern.charCodeAt(index$2)) | 0);
    } else {
      var d3 = (-1);
    }
    if (((d3 < 0) || (d3 > 7))) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((d1 << 3) + d2) | 0);
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((4 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
      return (((((d1 << 6) + (d2 << 3)) | 0) + d3) | 0);
    }
  }
}
export { $p_ju_regex_PatternCompiler__parseOctalEscape__I as $p_ju_regex_PatternCompiler__parseOctalEscape__I };
function $p_ju_regex_PatternCompiler__parseHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if (((start !== len) && (pattern.charCodeAt(start) === 123))) {
    var innerStart = ((1 + start) | 0);
    var innerEnd = (pattern.indexOf("}", innerStart) | 0);
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed hexadecimal escape sequence");
    }
    var cp = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, innerStart, innerEnd, "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + innerEnd) | 0);
    return cp;
  } else {
    var cp$2 = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, ((2 + start) | 0), "hexadecimal");
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + start) | 0);
    return cp$2;
  }
}
export { $p_ju_regex_PatternCompiler__parseHexEscape__I as $p_ju_regex_PatternCompiler__parseHexEscape__I };
function $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var start = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  var end = ((4 + start) | 0);
  var codeUnit = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, "Unicode");
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = end;
  var lowStart = ((2 + end) | 0);
  var lowEnd = ((4 + lowStart) | 0);
  if (((((-1024) & codeUnit) === 55296) && (pattern.substring(end, lowStart) === "\\u"))) {
    var low = $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, lowStart, lowEnd, "Unicode");
    if ((((-1024) & low) === 56320)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = lowEnd;
      return ((((64 + (1023 & codeUnit)) | 0) << 10) | (1023 & low));
    } else {
      return codeUnit;
    }
  } else {
    return codeUnit;
  }
}
export { $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I as $p_ju_regex_PatternCompiler__parseUnicodeHexEscape__I };
function $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I($thiz, start, end, nameForError) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  if (((start === end) || (end > len))) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"));
  }
  var i = start;
  while ((i < end)) {
    var value = i;
    var c = pattern.charCodeAt(value);
    if ((!((((c >= 48) && (c <= 57)) || ((c >= 65) && (c <= 70))) || ((c >= 97) && (c <= 102))))) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("Illegal " + nameForError) + " escape sequence"));
    }
    i = ((1 + i) | 0);
  }
  if ((((end - start) | 0) > 6)) {
    var cp = 1114112;
  } else {
    var s = pattern.substring(start, end);
    var cp = (parseInt(s, 16) | 0);
  }
  if ((cp > 1114111)) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Hexadecimal codepoint is too big");
  }
  return cp;
}
export { $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I as $p_ju_regex_PatternCompiler__parseHexCodePoint__I__I__T__I };
function $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, dispatchChar) {
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  switch (dispatchChar) {
    case 100:
    case 68: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit;
      break;
    }
    case 104:
    case 72: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace;
      break;
    }
    case 115:
    case 83: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace;
      break;
    }
    case 118:
    case 86: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace;
      break;
    }
    case 119:
    case 87: {
      var positive = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar;
      break;
    }
    case 112:
    case 80: {
      var positive = $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz);
      break;
    }
    default: {
      var positive;
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), $bC(dispatchChar));
    }
  }
  return ((dispatchChar >= 97) ? positive : positive.negated__ju_regex_PatternCompiler$CompiledCharClass());
}
export { $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass as $p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass };
function $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((start === len)) {
    var property = "?";
  } else if ((pattern.charCodeAt(start) === 123)) {
    var innerStart = ((1 + start) | 0);
    var innerEnd = (pattern.indexOf("}", innerStart) | 0);
    if ((innerEnd < 0)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character family");
    }
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = innerEnd;
    var property = pattern.substring(innerStart, innerEnd);
  } else {
    var property = pattern.substring(start, ((1 + start) | 0));
  }
  var dict = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  if ((!(!(!$m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, property))))) {
    $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Unicode character family", "2018");
  }
  var property2 = ((((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2) && ((property === "Lower") || (property === "Upper"))) ? "Alpha" : property);
  var dict$1 = $m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses;
  var result = dict$1[property2];
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  return result;
}
export { $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass as $p_ju_regex_PatternCompiler__parsePCharacterClass__ju_regex_PatternCompiler$CompiledCharClass };
function $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var isNegated = (pattern.charCodeAt(index) === 94);
  } else {
    var isNegated = false;
  }
  if (isNegated) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
  }
  var builder = new $c_ju_regex_PatternCompiler$CharacterClassBuilder(((66 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 2), isNegated);
  while (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var x1 = $f_T__codePointAt__I__I(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (x1) {
        case 93: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return builder.finish__T();
          break;
        }
        case 38: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
            var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
            var $x_1 = (pattern.charCodeAt(index$1) === 38);
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
            builder.startNewConjunct__V();
            break matchResult;
          } else {
            $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, 38, len, pattern, builder);
            break matchResult;
          }
          break;
        }
        case 91: {
          var cls = $p_ju_regex_PatternCompiler__compileCharacterClass__T($thiz);
          $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(builder, cls);
          break matchResult;
          break;
        }
        case 92: {
          $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
            $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal escape sequence");
          }
          var index$2 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
          var c2 = pattern.charCodeAt(index$2);
          switch (c2) {
            case 100:
            case 68:
            case 104:
            case 72:
            case 115:
            case 83:
            case 118:
            case 86:
            case 119:
            case 87:
            case 112:
            case 80: {
              builder.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V($p_ju_regex_PatternCompiler__parsePredefinedCharacterClass__C__ju_regex_PatternCompiler$CompiledCharClass($thiz, c2));
              break matchResult;
              break;
            }
            case 81: {
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
              var fromIndex = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
              var end = (pattern.indexOf("\\E", fromIndex) | 0);
              if ((end < 0)) {
                $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
              }
              builder.addCodePointsInString__T__I__I__V(pattern, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, end);
              $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + end) | 0);
              break matchResult;
              break;
            }
            default: {
              $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz), len, pattern, builder);
              break matchResult;
            }
          }
          break;
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
            break matchResult;
          }
          break;
        }
        case 35: {
          if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            $thiz.java$util$regex$PatternCompiler$$skipSharpComment__V();
            break matchResult;
          }
          break;
        }
      }
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((x1 >= 65536) ? 2 : 1)) | 0);
      $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, x1, len, pattern, builder);
    }
  }
  $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
}
export { $p_ju_regex_PatternCompiler__compileCharacterClass__T as $p_ju_regex_PatternCompiler__compileCharacterClass__T };
function $p_ju_regex_PatternCompiler__compileGroup__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  if ((((1 + start) | 0) === len)) {
    var $x_1 = true;
  } else {
    var index = ((1 + start) | 0);
    var $x_1 = (pattern.charCodeAt(index) !== 63);
  }
  if ($x_1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + start) | 0);
    $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
    return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")");
  } else {
    if ((((2 + start) | 0) === len)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group");
    }
    var index$1 = ((2 + start) | 0);
    var c1 = pattern.charCodeAt(index$1);
    if ((((c1 === 58) || (c1 === 61)) || (c1 === 33))) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      return ((("" + pattern.substring(start, ((3 + start) | 0))) + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")");
    } else if ((c1 === 60)) {
      if ((((3 + start) | 0) === len)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed group");
      }
      var index$2 = ((3 + start) | 0);
      var c2 = pattern.charCodeAt(index$2);
      if ((((c2 >= 65) && (c2 <= 90)) || ((c2 >= 97) && (c2 <= 122)))) {
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
        var name = $p_ju_regex_PatternCompiler__parseGroupName__T($thiz);
        var dict = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        if ((!(!$m_jl_Utils$Cache$().jl_Utils$Cache$__f_safeHasOwnProperty.call(dict, name)))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, (("named capturing group <" + name) + "> is already defined"));
        }
        $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.push($thiz.ju_regex_PatternCompiler__f_compiledGroupCount);
        var dict$1 = $thiz.ju_regex_PatternCompiler__f_namedGroups;
        var value = (((-1) + ($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length | 0)) | 0);
        dict$1[name] = value;
        $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
        return (("(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + ")");
      } else {
        if (((c2 !== 61) && (c2 !== 33))) {
          $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unknown look-behind group");
        }
        $thiz.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("Look-behind group", "2018");
      }
    } else if ((c1 === 62)) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((3 + start) | 0);
      $thiz.ju_regex_PatternCompiler__f_compiledGroupCount = ((1 + $thiz.ju_regex_PatternCompiler__f_compiledGroupCount) | 0);
      var groupNumber = $thiz.ju_regex_PatternCompiler__f_compiledGroupCount;
      return (((("(?:(?=(" + $thiz.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(true)) + "))\\") + groupNumber) + ")");
    } else {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Embedded flag expression in the middle of a pattern is not supported");
    }
  }
}
export { $p_ju_regex_PatternCompiler__compileGroup__T as $p_ju_regex_PatternCompiler__compileGroup__T };
function $p_ju_regex_PatternCompiler__parseGroupName__T($thiz) {
  var pattern = $thiz.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  var start = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
  while (true) {
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = pattern.charCodeAt(index);
      var $x_1 = ((((c >= 65) && (c <= 90)) || ((c >= 97) && (c <= 122))) || ((c >= 48) && (c <= 57)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    } else {
      break;
    }
  }
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len)) {
    var $x_2 = true;
  } else {
    var index$1 = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $x_2 = (pattern.charCodeAt(index$1) !== 62);
  }
  if ($x_2) {
    $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "named capturing group is missing trailing '>'");
  }
  return pattern.substring(start, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
}
export { $p_ju_regex_PatternCompiler__parseGroupName__T as $p_ju_regex_PatternCompiler__parseGroupName__T };
function $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V($thiz, startCodePoint, len$2, pattern$3, builder$1) {
  if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__skipComments__V($thiz);
  }
  if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len$2)) {
    var index = $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
    var $x_1 = (pattern$3.charCodeAt(index) === 45);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    if (((4 & $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
      $p_ju_regex_PatternCompiler__skipComments__V($thiz);
    }
    if (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex === len$2)) {
      $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Unclosed character class");
    }
    var cpEnd = $f_T__codePointAt__I__I(pattern$3, $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    if (((cpEnd === 91) || (cpEnd === 93))) {
      builder$1.addSingleCodePoint__I__V(startCodePoint);
      builder$1.addSingleCodePoint__I__V(45);
    } else {
      $thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = (($thiz.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((cpEnd >= 65536) ? 2 : 1)) | 0);
      var endCodePoint = ((cpEnd === 92) ? $p_ju_regex_PatternCompiler__parseSingleCodePointEscape__I($thiz) : cpEnd);
      if ((endCodePoint < startCodePoint)) {
        $p_ju_regex_PatternCompiler__parseError__T__E($thiz, "Illegal character range");
      }
      builder$1.addCodePointRange__I__I__V(startCodePoint, endCodePoint);
    }
  } else {
    builder$1.addSingleCodePoint__I__V(startCodePoint);
  }
}
export { $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V as $p_ju_regex_PatternCompiler__processRangeOrSingleCodePoint$1__I__I__T__ju_regex_PatternCompiler$CharacterClassBuilder__V };
/** @constructor */
function $c_ju_regex_PatternCompiler(pattern, flags) {
  this.ju_regex_PatternCompiler__f_pattern = null;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = 0;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = null;
  this.ju_regex_PatternCompiler__f_namedGroups = null;
  this.ju_regex_PatternCompiler__f_pattern = pattern;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = flags;
  this.ju_regex_PatternCompiler__f_sticky = false;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = 0;
  this.ju_regex_PatternCompiler__f_compiledGroupCount = 0;
  this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap = [0];
  this.ju_regex_PatternCompiler__f_namedGroups = ({});
}
export { $c_ju_regex_PatternCompiler as $c_ju_regex_PatternCompiler };
$c_ju_regex_PatternCompiler.prototype = new $h_O();
$c_ju_regex_PatternCompiler.prototype.constructor = $c_ju_regex_PatternCompiler;
/** @constructor */
function $h_ju_regex_PatternCompiler() {
}
export { $h_ju_regex_PatternCompiler as $h_ju_regex_PatternCompiler };
$h_ju_regex_PatternCompiler.prototype = $c_ju_regex_PatternCompiler.prototype;
$c_ju_regex_PatternCompiler.prototype.compile__ju_regex_Pattern = (function() {
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags = (64 | this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags);
  }
  var isLiteral = ((16 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0);
  if ((!isLiteral)) {
    $p_ju_regex_PatternCompiler__processLeadingEmbeddedFlags__V(this);
  }
  if (((128 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "CANON_EQ is not supported");
  }
  if (((8 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("MULTILINE", "2018");
  }
  if (((256 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
    this.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E("UNICODE_CHARACTER_CLASS", "2018");
  }
  if (isLiteral) {
    var jsPattern = $p_ju_regex_PatternCompiler__literal__T__T(this, this.ju_regex_PatternCompiler__f_pattern);
  } else {
    if ((this.ju_regex_PatternCompiler__f_pattern.substring(this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex, ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0)) === "\\G")) {
      this.ju_regex_PatternCompiler__f_sticky = true;
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((2 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    }
    var jsPattern = this.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T(false);
  }
  var baseJSFlags = ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "us" : "u");
  var jsFlags = (((66 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) === 66) ? (baseJSFlags + "i") : baseJSFlags);
  return new $c_ju_regex_Pattern(this.ju_regex_PatternCompiler__f_pattern, this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags, jsPattern, jsFlags, this.ju_regex_PatternCompiler__f_sticky, (((-1) + (this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap.length | 0)) | 0), this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$groupNumberMap, this.ju_regex_PatternCompiler__f_namedGroups);
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$parseErrorRequireESVersion__T__T__E = (function(purpose, es) {
  $p_ju_regex_PatternCompiler__parseError__T__E(this, (((((((purpose + " is not supported because it requires RegExp features of ECMAScript ") + es) + ".\n") + ((("If you only target environments with ES" + es) + "+, you can enable ES") + es)) + " features with\n") + ("  scalaJSLinkerConfig ~= { _.withESFeatures(_.withESVersion(ESVersion.ES" + es)) + ")) }\nor an equivalent configuration depending on your build tool."));
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$compileTopLevelOrInsideGroup__Z__T = (function(insideGroup) {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  var result = "";
  while ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
    var dispatchCP = $f_T__codePointAt__I__I(pattern, this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex);
    matchResult: {
      switch (dispatchCP) {
        case 41: {
          if ((!insideGroup)) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unmatched closing ')'");
          }
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          return result;
          break;
        }
        case 124: {
          if ((this.ju_regex_PatternCompiler__f_sticky && (!insideGroup))) {
            $p_ju_regex_PatternCompiler__parseError__T__E(this, "\\G is not supported when there is an alternative at the top level");
          }
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          result = (result + "|");
          break matchResult;
          break;
        }
        case 32:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
            break matchResult;
          }
          break;
        }
        case 35: {
          if (((4 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0)) {
            this.java$util$regex$PatternCompiler$$skipSharpComment__V();
            break matchResult;
          }
          break;
        }
        case 63:
        case 42:
        case 43:
        case 123: {
          $p_ju_regex_PatternCompiler__parseError__T__E(this, (("Dangling meta character '" + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(dispatchCP)) + "'"));
          break;
        }
      }
      var compiledGroupCountBeforeThisToken = this.ju_regex_PatternCompiler__f_compiledGroupCount;
      switch (dispatchCP) {
        case 92: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileEscape__T(this);
          break;
        }
        case 91: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileCharacterClass__T(this);
          break;
        }
        case 40: {
          var compiledToken = $p_ju_regex_PatternCompiler__compileGroup__T(this);
          break;
        }
        case 94: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "^";
          break;
        }
        case 36: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var compiledToken = "$";
          break;
        }
        case 46: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
          var rejected = (((32 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "" : (((1 & this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$flags) !== 0) ? "\n" : "\n\r\u0085\u2028\u2029"));
          var compiledToken = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(rejected);
          break;
        }
        default: {
          this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex + ((dispatchCP >= 65536) ? 2 : 1)) | 0);
          var compiledToken = $p_ju_regex_PatternCompiler__literal__I__T(this, dispatchCP);
        }
      }
      result = (("" + result) + $p_ju_regex_PatternCompiler__compileRepeater__I__T__T(this, compiledGroupCountBeforeThisToken, compiledToken));
    }
  }
  if (insideGroup) {
    $p_ju_regex_PatternCompiler__parseError__T__E(this, "Unclosed group");
  }
  return result;
});
$c_ju_regex_PatternCompiler.prototype.java$util$regex$PatternCompiler$$skipSharpComment__V = (function() {
  var pattern = this.ju_regex_PatternCompiler__f_pattern;
  var len = pattern.length;
  while (true) {
    if ((this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex !== len)) {
      var index = this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex;
      var c = pattern.charCodeAt(index);
      var $x_1 = (!(((((c === 10) || (c === 13)) || (c === 133)) || (c === 8232)) || (c === 8233)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex = ((1 + this.ju_regex_PatternCompiler__f_java$util$regex$PatternCompiler$$pIndex) | 0);
    } else {
      break;
    }
  }
});
var $d_ju_regex_PatternCompiler = new $TypeData().initClass($c_ju_regex_PatternCompiler, "java.util.regex.PatternCompiler", ({
  ju_regex_PatternCompiler: 1
}));
export { $d_ju_regex_PatternCompiler as $d_ju_regex_PatternCompiler };
function $p_ju_regex_PatternCompiler$__featureTest__T__Z($thiz, flags) {
  try {
    new RegExp("", flags);
    return true;
  } catch (e) {
    return false;
  }
}
export { $p_ju_regex_PatternCompiler$__featureTest__T__Z as $p_ju_regex_PatternCompiler$__featureTest__T__Z };
/** @constructor */
function $c_ju_regex_PatternCompiler$() {
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = false;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = null;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = null;
  $n_ju_regex_PatternCompiler$ = this;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$leadingEmbeddedFlagSpecifierRegExp = new RegExp("^\\(\\?([idmsuxU]*)(?:-([idmsuxU]*))?\\)");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$renumberingRegExp = new RegExp("(\\\\+)(\\d+)", "g");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsUnicode = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsSticky = true;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll = $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "us");
  $p_ju_regex_PatternCompiler$__featureTest__T__Z(this, "d");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeDigit = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "Nd");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalHorizontalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t \u00a0\u1680\u180e\u2000-\u200a\u202f\u205f\u3000");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWhitespace = new $c_ju_regex_PatternCompiler$CompiledCharClass(0, "White_Space");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UniversalVerticalWhiteSpace = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\n-\r\u0085\u2028\u2029");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$ASCIIWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-zA-Z_0-9");
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$UnicodeWordChar = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\\p{Alphabetic}\\p{Mn}\\p{Me}\\p{Mc}\\p{Nd}\\p{Pc}\\p{Join_Control}");
  var r = ({});
  var value = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "a-z");
  r.Lower = value;
  var value$1 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Z");
  r.Upper = value$1;
  var value$2 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u007f");
  r.ASCII = value$2;
  var value$3 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "A-Za-z");
  r.Alpha = value$3;
  var value$4 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9");
  r.Digit = value$4;
  var value$5 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Za-z");
  r.Alnum = value$5;
  var value$6 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-/:-@[-`{-~");
  r.Punct = value$6;
  var value$7 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "!-~");
  r.Graph = value$7;
  var value$8 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, " -~");
  r.Print = value$8;
  var value$9 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t ");
  r.Blank = value$9;
  var value$10 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\u0000-\u001f\u007f");
  r.Cntrl = value$10;
  var value$11 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "0-9A-Fa-f");
  r.XDigit = value$11;
  var value$12 = new $c_ju_regex_PatternCompiler$CompiledCharClass(2, "\t-\r ");
  r.Space = value$12;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$asciiPOSIXCharacterClasses = r;
  this.ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$scriptCanonicalizeRegExp = new RegExp("(?:^|_)[a-z]", "g");
}
export { $c_ju_regex_PatternCompiler$ as $c_ju_regex_PatternCompiler$ };
$c_ju_regex_PatternCompiler$.prototype = new $h_O();
$c_ju_regex_PatternCompiler$.prototype.constructor = $c_ju_regex_PatternCompiler$;
/** @constructor */
function $h_ju_regex_PatternCompiler$() {
}
export { $h_ju_regex_PatternCompiler$ as $h_ju_regex_PatternCompiler$ };
$h_ju_regex_PatternCompiler$.prototype = $c_ju_regex_PatternCompiler$.prototype;
$c_ju_regex_PatternCompiler$.prototype.compile__T__I__ju_regex_Pattern = (function(regex, flags) {
  return new $c_ju_regex_PatternCompiler(regex, flags).compile__ju_regex_Pattern();
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$charToFlag__C__I = (function(c) {
  switch (c) {
    case 105: {
      return 2;
      break;
    }
    case 100: {
      return 1;
      break;
    }
    case 109: {
      return 8;
      break;
    }
    case 115: {
      return 32;
      break;
    }
    case 117: {
      return 64;
      break;
    }
    case 120: {
      return 4;
      break;
    }
    case 85: {
      return 256;
      break;
    }
    default: {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "bad in-pattern flag");
    }
  }
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointNotAmong__T__T = (function(characters) {
  return ((characters !== "") ? (("[^" + characters) + "]") : ($m_ju_regex_PatternCompiler$().ju_regex_PatternCompiler$__f_java$util$regex$PatternCompiler$$_supportsDotAll ? "." : "[\\d\\D]"));
});
$c_ju_regex_PatternCompiler$.prototype.java$util$regex$PatternCompiler$$codePointToString__I__T = (function(codePoint) {
  return String.fromCodePoint(codePoint);
});
var $d_ju_regex_PatternCompiler$ = new $TypeData().initClass($c_ju_regex_PatternCompiler$, "java.util.regex.PatternCompiler$", ({
  ju_regex_PatternCompiler$: 1
}));
export { $d_ju_regex_PatternCompiler$ as $d_ju_regex_PatternCompiler$ };
var $n_ju_regex_PatternCompiler$;
function $m_ju_regex_PatternCompiler$() {
  if ((!$n_ju_regex_PatternCompiler$)) {
    $n_ju_regex_PatternCompiler$ = new $c_ju_regex_PatternCompiler$();
  }
  return $n_ju_regex_PatternCompiler$;
}
export { $m_ju_regex_PatternCompiler$ as $m_ju_regex_PatternCompiler$ };
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V($thiz, alt) {
  if (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "")) {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = alt;
  } else {
    $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct + "|") + alt);
  }
}
export { $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V as $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V };
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T($thiz) {
  if ($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated) {
    var negThisSegment = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? negThisSegment : (((("(?:(?!" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")") + negThisSegment) + ")"));
  } else {
    return (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment === "") ? (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? "[^\\d\\D]" : (("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + ")")) : (($thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct === "") ? (("[" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "]") : (((("(?:" + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct) + "|[") + $thiz.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + "])")));
  }
}
export { $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T as $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T };
function $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T($thiz, codePoint) {
  var s = $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(codePoint);
  return (((((codePoint === 93) || (codePoint === 92)) || (codePoint === 45)) || (codePoint === 94)) ? ("\\" + s) : s);
}
export { $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T as $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T };
/** @constructor */
function $c_ju_regex_PatternCompiler$CharacterClassBuilder(asciiCaseInsensitive, isNegated) {
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = false;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = null;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive = asciiCaseInsensitive;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated = isNegated;
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = "";
}
export { $c_ju_regex_PatternCompiler$CharacterClassBuilder as $c_ju_regex_PatternCompiler$CharacterClassBuilder };
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.constructor = $c_ju_regex_PatternCompiler$CharacterClassBuilder;
/** @constructor */
function $h_ju_regex_PatternCompiler$CharacterClassBuilder() {
}
export { $h_ju_regex_PatternCompiler$CharacterClassBuilder as $h_ju_regex_PatternCompiler$CharacterClassBuilder };
$h_ju_regex_PatternCompiler$CharacterClassBuilder.prototype = $c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype;
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.finish__T = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  return ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction === "") ? conjunct : ((("(?:" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction) + conjunct) + ")"));
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.startNewConjunct__V = (function() {
  var conjunct = $p_ju_regex_PatternCompiler$CharacterClassBuilder__conjunctResult__T(this);
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_conjunction + (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_isNegated ? (conjunct + "|") : (("(?=" + conjunct) + ")")));
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisConjunct = "";
  this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = "";
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCharacterClass__ju_regex_PatternCompiler$CompiledCharClass__V = (function(cls) {
  var x1 = cls.ju_regex_PatternCompiler$CompiledCharClass__f_kind;
  switch (x1) {
    case 0: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\p{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break;
    }
    case 1: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ((this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + ("\\P{" + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data)) + "}");
      break;
    }
    case 2: {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + cls.ju_regex_PatternCompiler$CompiledCharClass__f_data);
      break;
    }
    case 3: {
      $p_ju_regex_PatternCompiler$CharacterClassBuilder__addAlternative__T__V(this, $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointNotAmong__T__T(cls.ju_regex_PatternCompiler$CompiledCharClass__f_data));
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), x1);
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointsInString__T__I__I__V = (function(str, start, end) {
  var i = start;
  while ((i !== end)) {
    var codePoint = $f_T__codePointAt__I__I(str, i);
    this.addSingleCodePoint__I__V(codePoint);
    i = ((i + ((codePoint >= 65536) ? 2 : 1)) | 0);
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addSingleCodePoint__I__V = (function(codePoint) {
  var s = $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, codePoint);
  if ((((-1024) & codePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + s) + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + s);
  }
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    if (((codePoint >= 65) && (codePoint <= 90))) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T(((32 + codePoint) | 0)));
    } else if (((codePoint >= 97) && (codePoint <= 122))) {
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (("" + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment) + $m_ju_regex_PatternCompiler$().java$util$regex$PatternCompiler$$codePointToString__I__T((((-32) + codePoint) | 0)));
    }
  }
});
$c_ju_regex_PatternCompiler$CharacterClassBuilder.prototype.addCodePointRange__I__I__V = (function(startCodePoint, endCodePoint) {
  var s = (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, startCodePoint) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, endCodePoint));
  if ((((-1024) & startCodePoint) === 56320)) {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (s + this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment);
  } else {
    this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment + s);
  }
  if (this.ju_regex_PatternCompiler$CharacterClassBuilder__f_asciiCaseInsensitive) {
    var start = ((startCodePoint > 65) ? startCodePoint : 65);
    var end = ((endCodePoint < 90) ? endCodePoint : 90);
    if ((start <= end)) {
      var $x_1 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$1 = ((32 + start) | 0);
      var end$1 = ((32 + end) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($x_1 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$1) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$1)));
    }
    var start$2 = ((startCodePoint > 97) ? startCodePoint : 97);
    var end$2 = ((endCodePoint < 122) ? endCodePoint : 122);
    if ((start$2 <= end$2)) {
      var $x_2 = this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment;
      var start$3 = (((-32) + start$2) | 0);
      var end$3 = (((-32) + end$2) | 0);
      this.ju_regex_PatternCompiler$CharacterClassBuilder__f_thisSegment = ($x_2 + (($p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, start$3) + "-") + $p_ju_regex_PatternCompiler$CharacterClassBuilder__literalCodePoint__I__T(this, end$3)));
    }
  }
});
var $d_ju_regex_PatternCompiler$CharacterClassBuilder = new $TypeData().initClass($c_ju_regex_PatternCompiler$CharacterClassBuilder, "java.util.regex.PatternCompiler$CharacterClassBuilder", ({
  ju_regex_PatternCompiler$CharacterClassBuilder: 1
}));
export { $d_ju_regex_PatternCompiler$CharacterClassBuilder as $d_ju_regex_PatternCompiler$CharacterClassBuilder };
function $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass($thiz) {
  if ((!$thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0)) {
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated = new $c_ju_regex_PatternCompiler$CompiledCharClass((1 ^ $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_kind), $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_data);
    $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = true;
  }
  return $thiz.ju_regex_PatternCompiler$CompiledCharClass__f_negated;
}
export { $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass as $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass };
/** @constructor */
function $c_ju_regex_PatternCompiler$CompiledCharClass(kind, data) {
  this.ju_regex_PatternCompiler$CompiledCharClass__f_negated = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = 0;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = null;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0 = false;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_kind = kind;
  this.ju_regex_PatternCompiler$CompiledCharClass__f_data = data;
}
export { $c_ju_regex_PatternCompiler$CompiledCharClass as $c_ju_regex_PatternCompiler$CompiledCharClass };
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype = new $h_O();
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.constructor = $c_ju_regex_PatternCompiler$CompiledCharClass;
/** @constructor */
function $h_ju_regex_PatternCompiler$CompiledCharClass() {
}
export { $h_ju_regex_PatternCompiler$CompiledCharClass as $h_ju_regex_PatternCompiler$CompiledCharClass };
$h_ju_regex_PatternCompiler$CompiledCharClass.prototype = $c_ju_regex_PatternCompiler$CompiledCharClass.prototype;
$c_ju_regex_PatternCompiler$CompiledCharClass.prototype.negated__ju_regex_PatternCompiler$CompiledCharClass = (function() {
  return ((!this.ju_regex_PatternCompiler$CompiledCharClass__f_bitmap$0) ? $p_ju_regex_PatternCompiler$CompiledCharClass__negated$lzycompute__ju_regex_PatternCompiler$CompiledCharClass(this) : this.ju_regex_PatternCompiler$CompiledCharClass__f_negated);
});
var $d_ju_regex_PatternCompiler$CompiledCharClass = new $TypeData().initClass($c_ju_regex_PatternCompiler$CompiledCharClass, "java.util.regex.PatternCompiler$CompiledCharClass", ({
  ju_regex_PatternCompiler$CompiledCharClass: 1
}));
export { $d_ju_regex_PatternCompiler$CompiledCharClass as $d_ju_regex_PatternCompiler$CompiledCharClass };
/** @constructor */
function $c_Ljkugiya_ulid_Base32Codec$() {
  this.Ljkugiya_ulid_Base32Codec$__f_toBase32 = null;
  $n_Ljkugiya_ulid_Base32Codec$ = this;
  this.Ljkugiya_ulid_Base32Codec$__f_toBase32 = new $ac_C(new Uint16Array([48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 65, 66, 67, 68, 69, 70, 71, 72, 74, 75, 77, 78, 80, 81, 82, 83, 84, 86, 87, 88, 89, 90]));
}
export { $c_Ljkugiya_ulid_Base32Codec$ as $c_Ljkugiya_ulid_Base32Codec$ };
$c_Ljkugiya_ulid_Base32Codec$.prototype = new $h_O();
$c_Ljkugiya_ulid_Base32Codec$.prototype.constructor = $c_Ljkugiya_ulid_Base32Codec$;
/** @constructor */
function $h_Ljkugiya_ulid_Base32Codec$() {
}
export { $h_Ljkugiya_ulid_Base32Codec$ as $h_Ljkugiya_ulid_Base32Codec$ };
$h_Ljkugiya_ulid_Base32Codec$.prototype = $c_Ljkugiya_ulid_Base32Codec$.prototype;
$c_Ljkugiya_ulid_Base32Codec$.prototype.encode__Ljkugiya_ulid_ULID__T = (function(ulid) {
  var dimensions = new $ac_I(new Int32Array([26]));
  var chars = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_C.getClassOf(), dimensions);
  var t = ulid.Ljkugiya_ulid_ULID__f_time;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var $x_1 = this.Ljkugiya_ulid_Base32Codec$__f_toBase32;
  var lo$1 = (31 & lo);
  chars.u[9] = $x_1.u[lo$1];
  var $x_2 = this.Ljkugiya_ulid_Base32Codec$__f_toBase32;
  var lo$2 = (((lo >>> 5) | 0) | (hi << 27));
  var lo$3 = (31 & lo$2);
  chars.u[8] = $x_2.u[lo$3];
  var $x_3 = this.Ljkugiya_ulid_Base32Codec$__f_toBase32;
  var lo$4 = (((lo >>> 10) | 0) | (hi << 22));
  var lo$5 = (31 & lo$4);
  chars.u[7] = $x_3.u[lo$5];
  var $x_4 = this.Ljkugiya_ulid_Base32Codec$__f_toBase32;
  var lo$6 = (((lo >>> 15) | 0) | (hi << 17));
  var lo$7 = (31 & lo$6);
  chars.u[6] = $x_4.u[lo$7];
  var $x_5 = this.Ljkugiya_ulid_Base32Codec$__f_toBase32;
  var lo$8 = (((lo >>> 20) | 0) | (hi << 12));
  var lo$9 = (31 & lo$8);
  chars.u[5] = $x_5.u[lo$9];
  var $x_6 = this.Ljkugiya_ulid_Base32Codec$__f_toBase32;
  var lo$10 = (((lo >>> 25) | 0) | (hi << 7));
  var lo$11 = (31 & lo$10);
  chars.u[4] = $x_6.u[lo$11];
  var $x_7 = this.Ljkugiya_ulid_Base32Codec$__f_toBase32;
  var lo$12 = (((lo >>> 30) | 0) | (hi << 2));
  var lo$13 = (31 & lo$12);
  chars.u[3] = $x_7.u[lo$13];
  var $x_8 = this.Ljkugiya_ulid_Base32Codec$__f_toBase32;
  var lo$14 = ((hi >>> 3) | 0);
  var lo$15 = (31 & lo$14);
  chars.u[2] = $x_8.u[lo$15];
  var $x_9 = this.Ljkugiya_ulid_Base32Codec$__f_toBase32;
  var lo$16 = ((hi >>> 8) | 0);
  var lo$17 = (31 & lo$16);
  chars.u[1] = $x_9.u[lo$17];
  var $x_10 = this.Ljkugiya_ulid_Base32Codec$__f_toBase32;
  var lo$18 = ((hi >>> 13) | 0);
  var lo$19 = (31 & lo$18);
  chars.u[0] = $x_10.u[lo$19];
  var randomness = ulid.Ljkugiya_ulid_ULID__f_originalRandomness;
  chars.u[10] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[0] >>> 3) | 0))];
  chars.u[11] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[0] << 2) | (3 & ((randomness.u[1] >>> 6) | 0))))];
  chars.u[12] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[1] >>> 1) | 0))];
  chars.u[13] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[1] << 4) | (15 & ((randomness.u[2] >>> 4) | 0))))];
  chars.u[14] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[2] << 1) | (1 & ((randomness.u[3] >>> 7) | 0))))];
  chars.u[15] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[3] >>> 2) | 0))];
  chars.u[16] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[3] << 3) | (7 & ((randomness.u[4] >>> 5) | 0))))];
  chars.u[17] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & randomness.u[4])];
  chars.u[18] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[5] >>> 3) | 0))];
  chars.u[19] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[5] << 2) | (3 & ((randomness.u[6] >>> 6) | 0))))];
  chars.u[20] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[6] >>> 1) | 0))];
  chars.u[21] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[6] << 4) | (15 & ((randomness.u[7] >>> 4) | 0))))];
  chars.u[22] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[7] << 1) | (1 & ((randomness.u[8] >>> 7) | 0))))];
  chars.u[23] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[8] >>> 2) | 0))];
  chars.u[24] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & ((randomness.u[8] << 3) | (7 & ((randomness.u[9] >>> 5) | 0))))];
  chars.u[25] = this.Ljkugiya_ulid_Base32Codec$__f_toBase32.u[(31 & randomness.u[9])];
  var this$31 = $m_jl_String$();
  return this$31.new__AC__I__I__T(chars, 0, chars.u.length);
});
var $d_Ljkugiya_ulid_Base32Codec$ = new $TypeData().initClass($c_Ljkugiya_ulid_Base32Codec$, "jkugiya.ulid.Base32Codec$", ({
  Ljkugiya_ulid_Base32Codec$: 1
}));
export { $d_Ljkugiya_ulid_Base32Codec$ as $d_Ljkugiya_ulid_Base32Codec$ };
var $n_Ljkugiya_ulid_Base32Codec$;
function $m_Ljkugiya_ulid_Base32Codec$() {
  if ((!$n_Ljkugiya_ulid_Base32Codec$)) {
    $n_Ljkugiya_ulid_Base32Codec$ = new $c_Ljkugiya_ulid_Base32Codec$();
  }
  return $n_Ljkugiya_ulid_Base32Codec$;
}
export { $m_Ljkugiya_ulid_Base32Codec$ as $m_Ljkugiya_ulid_Base32Codec$ };
/** @constructor */
function $c_Ljkugiya_ulid_BinaryCodec$() {
}
export { $c_Ljkugiya_ulid_BinaryCodec$ as $c_Ljkugiya_ulid_BinaryCodec$ };
$c_Ljkugiya_ulid_BinaryCodec$.prototype = new $h_O();
$c_Ljkugiya_ulid_BinaryCodec$.prototype.constructor = $c_Ljkugiya_ulid_BinaryCodec$;
/** @constructor */
function $h_Ljkugiya_ulid_BinaryCodec$() {
}
export { $h_Ljkugiya_ulid_BinaryCodec$ as $h_Ljkugiya_ulid_BinaryCodec$ };
$h_Ljkugiya_ulid_BinaryCodec$.prototype = $c_Ljkugiya_ulid_BinaryCodec$.prototype;
$c_Ljkugiya_ulid_BinaryCodec$.prototype.encode__Ljkugiya_ulid_ULID__AB = (function(ulid) {
  var buffer = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(16);
  var a = ulid.Ljkugiya_ulid_ULID__f_time;
  var lo = a.RTLong__f_lo;
  var lo$1 = (lo << 16);
  var hi = (((lo >>> 16) | 0) | (a.RTLong__f_hi << 16));
  buffer.putLong__J__Ljava_nio_ByteBuffer(new $c_RTLong(lo$1, hi));
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(buffer, 6);
  var src = ulid.Ljkugiya_ulid_ULID__f_originalRandomness;
  buffer.put__AB__I__I__Ljava_nio_ByteBuffer(src, 0, src.u.length);
  var a$1 = buffer.Ljava_nio_ByteBuffer__f__array;
  if ((a$1 === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (buffer.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  return a$1;
});
$c_Ljkugiya_ulid_BinaryCodec$.prototype.decode__AB__Ljkugiya_ulid_ULID = (function(binary) {
  if ((binary.u.length !== 16)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Binary length should be 16.");
  }
  var length = binary.u.length;
  var binaryBuffer = $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(binary, 0, binary.u.length, 0, length, false);
  var t = binaryBuffer.getLong__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = binaryBuffer.getLong__J();
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var lo$2 = (((lo >>> 16) | 0) | (hi << 16));
  var hi$2 = ((hi >>> 16) | 0);
  var hi$3 = (lo << 16);
  var lo$3 = (((lo$1 >>> 16) | 0) | (hi$1 << 16));
  var hi$4 = ((hi$1 >>> 16) | 0);
  var hi$5 = (hi$3 | hi$4);
  var lo$4 = (65535 & lo$1);
  var last16 = ((lo$4 << 16) >> 16);
  var buffer = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(10);
  buffer.putLong__J__Ljava_nio_ByteBuffer(new $c_RTLong(lo$3, hi$5)).putShort__S__Ljava_nio_ByteBuffer(last16);
  var $x_1 = new $c_RTLong(lo$2, hi$2);
  var a = buffer.Ljava_nio_ByteBuffer__f__array;
  if ((a === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (buffer.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  return new $c_Ljkugiya_ulid_ULID($x_1, a);
});
var $d_Ljkugiya_ulid_BinaryCodec$ = new $TypeData().initClass($c_Ljkugiya_ulid_BinaryCodec$, "jkugiya.ulid.BinaryCodec$", ({
  Ljkugiya_ulid_BinaryCodec$: 1
}));
export { $d_Ljkugiya_ulid_BinaryCodec$ as $d_Ljkugiya_ulid_BinaryCodec$ };
var $n_Ljkugiya_ulid_BinaryCodec$;
function $m_Ljkugiya_ulid_BinaryCodec$() {
  if ((!$n_Ljkugiya_ulid_BinaryCodec$)) {
    $n_Ljkugiya_ulid_BinaryCodec$ = new $c_Ljkugiya_ulid_BinaryCodec$();
  }
  return $n_Ljkugiya_ulid_BinaryCodec$;
}
export { $m_Ljkugiya_ulid_BinaryCodec$ as $m_Ljkugiya_ulid_BinaryCodec$ };
/** @constructor */
function $c_Ljkugiya_ulid_ULID(time, originalRandomness) {
  this.Ljkugiya_ulid_ULID__f_time = $L0;
  this.Ljkugiya_ulid_ULID__f_originalRandomness = null;
  this.Ljkugiya_ulid_ULID__f_time = time;
  this.Ljkugiya_ulid_ULID__f_originalRandomness = originalRandomness;
  var ahi = time.RTLong__f_hi;
  if ((ahi > 65535)) {
    var $x_1 = true;
  } else {
    var ahi$1 = time.RTLong__f_hi;
    var $x_1 = (ahi$1 < 0);
  }
  if ($x_1) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("Invalid timestamp is given.(" + time) + ", should be between 0 to 281474976710655."));
  }
  if ((originalRandomness.u.length !== 10)) {
    var byteLength = originalRandomness.u.length;
    var bitLength = (byteLength << 3);
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("randomness should be 80bits(10 byte), but " + bitLength) + " bits(") + byteLength) + " byte) randomness is given."));
  }
}
export { $c_Ljkugiya_ulid_ULID as $c_Ljkugiya_ulid_ULID };
$c_Ljkugiya_ulid_ULID.prototype = new $h_O();
$c_Ljkugiya_ulid_ULID.prototype.constructor = $c_Ljkugiya_ulid_ULID;
/** @constructor */
function $h_Ljkugiya_ulid_ULID() {
}
export { $h_Ljkugiya_ulid_ULID as $h_Ljkugiya_ulid_ULID };
$h_Ljkugiya_ulid_ULID.prototype = $c_Ljkugiya_ulid_ULID.prototype;
$c_Ljkugiya_ulid_ULID.prototype.toString__T = (function() {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  sb.append__T__scm_StringBuilder("ULID(b32=");
  sb.append__T__scm_StringBuilder($m_Ljkugiya_ulid_Base32Codec$().encode__Ljkugiya_ulid_ULID__T(this));
  sb.append__T__scm_StringBuilder(", uuid=");
  sb.append__O__scm_StringBuilder($m_Ljkugiya_ulid_UUIDCodec$().encode__Ljkugiya_ulid_ULID__ju_UUID(this));
  sb.append__T__scm_StringBuilder(")");
  return sb.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Ljkugiya_ulid_ULID.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljkugiya_ulid_ULID)) {
    if ((this === obj)) {
      return true;
    } else {
      var a = this.Ljkugiya_ulid_ULID__f_time;
      var b = obj.Ljkugiya_ulid_ULID__f_time;
      if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
        var a$1 = this.Ljkugiya_ulid_ULID__f_originalRandomness;
        var b$1 = obj.Ljkugiya_ulid_ULID__f_originalRandomness;
        return $m_ju_Arrays$().equals__AB__AB__Z(a$1, b$1);
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljkugiya_ulid_ULID.prototype.hashCode__I = (function() {
  var result = 1;
  var $x_1 = result;
  var this$1 = this.Ljkugiya_ulid_ULID__f_time;
  result = ((Math.imul(31, $x_1) + (this$1.RTLong__f_lo ^ this$1.RTLong__f_hi)) | 0);
  var idx = 0;
  while ((idx < this.Ljkugiya_ulid_ULID__f_originalRandomness.u.length)) {
    result = ((Math.imul(31, result) + this.Ljkugiya_ulid_ULID__f_originalRandomness.u[idx]) | 0);
    idx = ((1 + idx) | 0);
  }
  return result;
});
function $isArrayOf_Ljkugiya_ulid_ULID(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljkugiya_ulid_ULID)));
}
export { $isArrayOf_Ljkugiya_ulid_ULID as $isArrayOf_Ljkugiya_ulid_ULID };
var $d_Ljkugiya_ulid_ULID = new $TypeData().initClass($c_Ljkugiya_ulid_ULID, "jkugiya.ulid.ULID", ({
  Ljkugiya_ulid_ULID: 1
}));
export { $d_Ljkugiya_ulid_ULID as $d_Ljkugiya_ulid_ULID };
/** @constructor */
function $c_Ljkugiya_ulid_UUIDCodec$() {
}
export { $c_Ljkugiya_ulid_UUIDCodec$ as $c_Ljkugiya_ulid_UUIDCodec$ };
$c_Ljkugiya_ulid_UUIDCodec$.prototype = new $h_O();
$c_Ljkugiya_ulid_UUIDCodec$.prototype.constructor = $c_Ljkugiya_ulid_UUIDCodec$;
/** @constructor */
function $h_Ljkugiya_ulid_UUIDCodec$() {
}
export { $h_Ljkugiya_ulid_UUIDCodec$ as $h_Ljkugiya_ulid_UUIDCodec$ };
$h_Ljkugiya_ulid_UUIDCodec$.prototype = $c_Ljkugiya_ulid_UUIDCodec$.prototype;
$c_Ljkugiya_ulid_UUIDCodec$.prototype.encode__Ljkugiya_ulid_ULID__ju_UUID = (function(ulid) {
  var binary = $m_Ljkugiya_ulid_BinaryCodec$().encode__Ljkugiya_ulid_ULID__AB(ulid);
  var length = binary.u.length;
  var buffer = $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(binary, 0, binary.u.length, 0, length, false);
  return new $c_ju_UUID(buffer.getLong__J(), buffer.getLong__J());
});
$c_Ljkugiya_ulid_UUIDCodec$.prototype.decode__ju_UUID__Ljkugiya_ulid_ULID = (function(uuid) {
  var t = uuid.ju_UUID__f_java$util$UUID$$mostSigBits;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = uuid.ju_UUID__f_java$util$UUID$$leastSigBits;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var lo$2 = (((lo >>> 16) | 0) | (hi << 16));
  var hi$2 = ((hi >>> 16) | 0);
  var hi$3 = (lo << 16);
  var lo$3 = (((lo$1 >>> 16) | 0) | (hi$1 << 16));
  var hi$4 = ((hi$1 >>> 16) | 0);
  var hi$5 = (hi$3 | hi$4);
  var lo$4 = (65535 & lo$1);
  var last16 = ((lo$4 << 16) >> 16);
  var buffer = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(10);
  buffer.putLong__J__Ljava_nio_ByteBuffer(new $c_RTLong(lo$3, hi$5)).putShort__S__Ljava_nio_ByteBuffer(last16);
  var $x_1 = new $c_RTLong(lo$2, hi$2);
  var a = buffer.Ljava_nio_ByteBuffer__f__array;
  if ((a === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (buffer.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  return new $c_Ljkugiya_ulid_ULID($x_1, a);
});
var $d_Ljkugiya_ulid_UUIDCodec$ = new $TypeData().initClass($c_Ljkugiya_ulid_UUIDCodec$, "jkugiya.ulid.UUIDCodec$", ({
  Ljkugiya_ulid_UUIDCodec$: 1
}));
export { $d_Ljkugiya_ulid_UUIDCodec$ as $d_Ljkugiya_ulid_UUIDCodec$ };
var $n_Ljkugiya_ulid_UUIDCodec$;
function $m_Ljkugiya_ulid_UUIDCodec$() {
  if ((!$n_Ljkugiya_ulid_UUIDCodec$)) {
    $n_Ljkugiya_ulid_UUIDCodec$ = new $c_Ljkugiya_ulid_UUIDCodec$();
  }
  return $n_Ljkugiya_ulid_UUIDCodec$;
}
export { $m_Ljkugiya_ulid_UUIDCodec$ as $m_Ljkugiya_ulid_UUIDCodec$ };
/** @constructor */
function $c_Llocales_DefaultLocale$() {
  this.Llocales_DefaultLocale$__f_window$lzy1 = null;
  this.Llocales_DefaultLocale$__f_windowbitmap$1 = false;
}
export { $c_Llocales_DefaultLocale$ as $c_Llocales_DefaultLocale$ };
$c_Llocales_DefaultLocale$.prototype = new $h_O();
$c_Llocales_DefaultLocale$.prototype.constructor = $c_Llocales_DefaultLocale$;
/** @constructor */
function $h_Llocales_DefaultLocale$() {
}
export { $h_Llocales_DefaultLocale$ as $h_Llocales_DefaultLocale$ };
$h_Llocales_DefaultLocale$.prototype = $c_Llocales_DefaultLocale$.prototype;
$c_Llocales_DefaultLocale$.prototype.window__Llocales_Window = (function() {
  if ((!this.Llocales_DefaultLocale$__f_windowbitmap$1)) {
    this.Llocales_DefaultLocale$__f_window$lzy1 = window;
    this.Llocales_DefaultLocale$__f_windowbitmap$1 = true;
  }
  return this.Llocales_DefaultLocale$__f_window$lzy1;
});
$c_Llocales_DefaultLocale$.prototype.platformLocale__ju_Locale = (function() {
  try {
    var value = this.window__Llocales_Window().navigator.language;
    var lang = new $c_s_Some(value);
  } catch (e) {
    var lang = $m_s_None$();
  }
  if (lang.isEmpty__Z()) {
    var $x_1 = true;
  } else {
    var x0 = lang.get__O();
    var $x_1 = $m_Llocales_LocalesDb$().Llocales_LocalesDb$__f_ldmls.contains__O__Z(x0);
  }
  if ($x_1) {
    var this$2 = lang;
  } else {
    var this$2 = $m_s_None$();
  }
  var l = (this$2.isEmpty__Z() ? "en" : this$2.get__O());
  var this$3 = $m_Llocales_LocalesDb$().localeForLanguageTag__T__s_Option(l);
  return (this$3.isEmpty__Z() ? $m_Llocales_LocalesDb$().Llocales_LocalesDb$__f_root.toLocale__ju_Locale() : this$3.get__O());
});
var $d_Llocales_DefaultLocale$ = new $TypeData().initClass($c_Llocales_DefaultLocale$, "locales.DefaultLocale$", ({
  Llocales_DefaultLocale$: 1
}));
export { $d_Llocales_DefaultLocale$ as $d_Llocales_DefaultLocale$ };
var $n_Llocales_DefaultLocale$;
function $m_Llocales_DefaultLocale$() {
  if ((!$n_Llocales_DefaultLocale$)) {
    $n_Llocales_DefaultLocale$ = new $c_Llocales_DefaultLocale$();
  }
  return $n_Llocales_DefaultLocale$;
}
export { $m_Llocales_DefaultLocale$ as $m_Llocales_DefaultLocale$ };
/** @constructor */
function $c_Llocales_LocalesDb$() {
  this.Llocales_LocalesDb$__f_provider = null;
  this.Llocales_LocalesDb$__f_root = null;
  this.Llocales_LocalesDb$__f_ldmls = null;
  $n_Llocales_LocalesDb$ = this;
  var this$2 = $m_sjs_reflect_Reflect$();
  var this$3 = this$2.sjs_reflect_Reflect$__f_loadableModuleClasses.get__O__s_Option("locales.cldr.data.LocalesProvider$");
  if (this$3.isEmpty__Z()) {
    var this$4 = $m_s_None$();
  } else {
    var x0 = this$3.get__O();
    var this$4 = new $c_s_Some(x0.loadModule__O());
  }
  this.Llocales_LocalesDb$__f_provider = (this$4.isEmpty__Z() ? $m_Llocales_cldr_fallback_LocalesProvider$() : this$4.get__O());
  this.Llocales_LocalesDb$__f_root = $m_Llocales_cldr_fallback_data_\uff3froot$();
  $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  this.Llocales_LocalesDb$__f_ldmls = this.Llocales_LocalesDb$__f_provider.ldmls__sci_Map();
  this.Llocales_LocalesDb$__f_provider.metadata__Llocales_cldr_CLDRMetadata();
  this.Llocales_LocalesDb$__f_provider.currencyData__Llocales_cldr_CurrencyData();
}
export { $c_Llocales_LocalesDb$ as $c_Llocales_LocalesDb$ };
$c_Llocales_LocalesDb$.prototype = new $h_O();
$c_Llocales_LocalesDb$.prototype.constructor = $c_Llocales_LocalesDb$;
/** @constructor */
function $h_Llocales_LocalesDb$() {
}
export { $h_Llocales_LocalesDb$ as $h_Llocales_LocalesDb$ };
$h_Llocales_LocalesDb$.prototype = $c_Llocales_LocalesDb$.prototype;
$c_Llocales_LocalesDb$.prototype.localeForLanguageTag__T__s_Option = (function(languageTag) {
  if ((languageTag === "und")) {
    var value = $m_ju_Locale$().ROOT__ju_Locale();
    return new $c_s_Some(value);
  } else {
    var this$2 = this.Llocales_LocalesDb$__f_provider.ldmls__sci_Map().get__O__s_Option(languageTag);
    if (this$2.isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var x0 = this$2.get__O();
      return new $c_s_Some(x0.toLocale__ju_Locale());
    }
  }
});
$c_Llocales_LocalesDb$.prototype.ldml__ju_Locale__s_Option = (function(locale) {
  var tag = ((locale.toLanguageTag__T() === "zh-CN") ? "zh-Hans-CN" : ((locale.toLanguageTag__T() === "zh-TW") ? "zh-Hant-TW" : locale.toLanguageTag__T()));
  return this.Llocales_LocalesDb$__f_provider.ldmls__sci_Map().get__O__s_Option(tag);
});
var $d_Llocales_LocalesDb$ = new $TypeData().initClass($c_Llocales_LocalesDb$, "locales.LocalesDb$", ({
  Llocales_LocalesDb$: 1
}));
export { $d_Llocales_LocalesDb$ as $d_Llocales_LocalesDb$ };
var $n_Llocales_LocalesDb$;
function $m_Llocales_LocalesDb$() {
  if ((!$n_Llocales_LocalesDb$)) {
    $n_Llocales_LocalesDb$ = new $c_Llocales_LocalesDb$();
  }
  return $n_Llocales_LocalesDb$;
}
export { $m_Llocales_LocalesDb$ as $m_Llocales_LocalesDb$ };
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all$lzy1 = null;
  this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_allbitmap$1 = false;
}
export { $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$ as $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$ };
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype = new $h_O();
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
}
export { $h_Llocales_cldr_fallback_data_\uff3fall\uff3f$ as $h_Llocales_cldr_fallback_data_\uff3fall\uff3f$ };
$h_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype = $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype;
$c_Llocales_cldr_fallback_data_\uff3fall\uff3f$.prototype.all__ALlocales_cldr_LDML = (function() {
  if ((!this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_allbitmap$1)) {
    this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all$lzy1 = new ($d_Llocales_cldr_LDML.getArrayOf().constr)([$m_Llocales_cldr_fallback_data_\uff3fen$(), $m_Llocales_cldr_fallback_data_\uff3froot$()]);
    this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_allbitmap$1 = true;
  }
  return this.Llocales_cldr_fallback_data_\uff3fall\uff3f$__f_all$lzy1;
});
var $d_Llocales_cldr_fallback_data_\uff3fall\uff3f$ = new $TypeData().initClass($c_Llocales_cldr_fallback_data_\uff3fall\uff3f$, "locales.cldr.fallback.data._all_$", ({
  Llocales_cldr_fallback_data_\uff3fall\uff3f$: 1
}));
export { $d_Llocales_cldr_fallback_data_\uff3fall\uff3f$ as $d_Llocales_cldr_fallback_data_\uff3fall\uff3f$ };
var $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
function $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3fall\uff3f$)) {
    $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$ = new $c_Llocales_cldr_fallback_data_\uff3fall\uff3f$();
  }
  return $n_Llocales_cldr_fallback_data_\uff3fall\uff3f$;
}
export { $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$ as $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$ };
/** @constructor */
function $c_Llocales_cldr_fallback_data_numericsystems$() {
  this.Llocales_cldr_fallback_data_numericsystems$__f_latn$lzy1 = null;
  this.Llocales_cldr_fallback_data_numericsystems$__f_latnbitmap$1 = false;
}
export { $c_Llocales_cldr_fallback_data_numericsystems$ as $c_Llocales_cldr_fallback_data_numericsystems$ };
$c_Llocales_cldr_fallback_data_numericsystems$.prototype = new $h_O();
$c_Llocales_cldr_fallback_data_numericsystems$.prototype.constructor = $c_Llocales_cldr_fallback_data_numericsystems$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_numericsystems$() {
}
export { $h_Llocales_cldr_fallback_data_numericsystems$ as $h_Llocales_cldr_fallback_data_numericsystems$ };
$h_Llocales_cldr_fallback_data_numericsystems$.prototype = $c_Llocales_cldr_fallback_data_numericsystems$.prototype;
$c_Llocales_cldr_fallback_data_numericsystems$.prototype.latn__Llocales_cldr_NumberingSystem = (function() {
  if ((!this.Llocales_cldr_fallback_data_numericsystems$__f_latnbitmap$1)) {
    var elems = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([48, 49, 50, 51, 52, 53, 54, 55, 56, 57])));
    var digits = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    this.Llocales_cldr_fallback_data_numericsystems$__f_latn$lzy1 = new $c_Llocales_cldr_NumberingSystem("latn", digits);
    this.Llocales_cldr_fallback_data_numericsystems$__f_latnbitmap$1 = true;
  }
  return this.Llocales_cldr_fallback_data_numericsystems$__f_latn$lzy1;
});
var $d_Llocales_cldr_fallback_data_numericsystems$ = new $TypeData().initClass($c_Llocales_cldr_fallback_data_numericsystems$, "locales.cldr.fallback.data.numericsystems$", ({
  Llocales_cldr_fallback_data_numericsystems$: 1
}));
export { $d_Llocales_cldr_fallback_data_numericsystems$ as $d_Llocales_cldr_fallback_data_numericsystems$ };
var $n_Llocales_cldr_fallback_data_numericsystems$;
function $m_Llocales_cldr_fallback_data_numericsystems$() {
  if ((!$n_Llocales_cldr_fallback_data_numericsystems$)) {
    $n_Llocales_cldr_fallback_data_numericsystems$ = new $c_Llocales_cldr_fallback_data_numericsystems$();
  }
  return $n_Llocales_cldr_fallback_data_numericsystems$;
}
export { $m_Llocales_cldr_fallback_data_numericsystems$ as $m_Llocales_cldr_fallback_data_numericsystems$ };
/** @constructor */
function $c_Lmagnolia1_CallByNeed$() {
}
export { $c_Lmagnolia1_CallByNeed$ as $c_Lmagnolia1_CallByNeed$ };
$c_Lmagnolia1_CallByNeed$.prototype = new $h_O();
$c_Lmagnolia1_CallByNeed$.prototype.constructor = $c_Lmagnolia1_CallByNeed$;
/** @constructor */
function $h_Lmagnolia1_CallByNeed$() {
}
export { $h_Lmagnolia1_CallByNeed$ as $h_Lmagnolia1_CallByNeed$ };
$h_Lmagnolia1_CallByNeed$.prototype = $c_Lmagnolia1_CallByNeed$.prototype;
$c_Lmagnolia1_CallByNeed$.prototype.createLazy__F0__Lmagnolia1_CallByNeed = (function(a) {
  return new $c_Lmagnolia1_CallByNeed(a, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => false)));
});
$c_Lmagnolia1_CallByNeed$.prototype.createValueEvaluator__F0__Lmagnolia1_CallByNeed = (function(a) {
  return new $c_Lmagnolia1_CallByNeed(a, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => true)));
});
var $d_Lmagnolia1_CallByNeed$ = new $TypeData().initClass($c_Lmagnolia1_CallByNeed$, "magnolia1.CallByNeed$", ({
  Lmagnolia1_CallByNeed$: 1
}));
export { $d_Lmagnolia1_CallByNeed$ as $d_Lmagnolia1_CallByNeed$ };
var $n_Lmagnolia1_CallByNeed$;
function $m_Lmagnolia1_CallByNeed$() {
  if ((!$n_Lmagnolia1_CallByNeed$)) {
    $n_Lmagnolia1_CallByNeed$ = new $c_Lmagnolia1_CallByNeed$();
  }
  return $n_Lmagnolia1_CallByNeed$;
}
export { $m_Lmagnolia1_CallByNeed$ as $m_Lmagnolia1_CallByNeed$ };
function $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param($thiz, label, tc, d, repeated, annotations, inheritedAnnotations, typeAnnotations, idx) {
  var repeated$1 = (!(!repeated.getOrElse__O__F0__O(label, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => false)))));
  var it = annotations.getOrElse__O__F0__O(label, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $m_sci_Nil$())));
  var n = it.knownSize__I();
  if ((n > (-1))) {
    var elements = new $ac_O(n);
    var iterator = it.iterator__sc_Iterator();
    var i = 0;
    while ((i < n)) {
      elements.u[i] = iterator.next__O();
      i = ((1 + i) | 0);
    }
    var s = elements;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var iterator$2 = it.iterator__sc_Iterator();
    while (iterator$2.hasNext__Z()) {
      var elem = iterator$2.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var s = new $ac_O(jsElems);
  }
  var it$1 = inheritedAnnotations.getOrElse__O__F0__O(label, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $m_sci_Nil$())));
  var n$1 = it$1.knownSize__I();
  if ((n$1 > (-1))) {
    var elements$1 = new $ac_O(n$1);
    var iterator$1 = it$1.iterator__sc_Iterator();
    var i$1 = 0;
    while ((i$1 < n$1)) {
      elements$1.u[i$1] = iterator$1.next__O();
      i$1 = ((1 + i$1) | 0);
    }
    var s$1 = elements$1;
  } else {
    var capacity$1 = 0;
    var size$1 = 0;
    var jsElems$1 = null;
    capacity$1 = 0;
    size$1 = 0;
    jsElems$1 = [];
    var iterator$2$1 = it$1.iterator__sc_Iterator();
    while (iterator$2$1.hasNext__Z()) {
      var elem$1 = iterator$2$1.next__O();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems$1.push(unboxedElem$1);
    }
    var s$1 = new $ac_O(jsElems$1);
  }
  var it$2 = typeAnnotations.getOrElse__O__F0__O(label, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $m_sci_Nil$())));
  var n$2 = it$2.knownSize__I();
  if ((n$2 > (-1))) {
    var elements$2 = new $ac_O(n$2);
    var iterator$3 = it$2.iterator__sc_Iterator();
    var i$2 = 0;
    while ((i$2 < n$2)) {
      elements$2.u[i$2] = iterator$3.next__O();
      i$2 = ((1 + i$2) | 0);
    }
    var s$2 = elements$2;
  } else {
    var capacity$2 = 0;
    var size$2 = 0;
    var jsElems$2 = null;
    capacity$2 = 0;
    size$2 = 0;
    jsElems$2 = [];
    var iterator$2$2 = it$2.iterator__sc_Iterator();
    while (iterator$2$2.hasNext__Z()) {
      var elem$2 = iterator$2$2.next__O();
      var unboxedElem$2 = ((elem$2 === null) ? null : elem$2);
      jsElems$2.push(unboxedElem$2);
    }
    var s$2 = new $ac_O(jsElems$2);
  }
  return new $c_Lmagnolia1_CaseClass$Param$$anon$2(label, idx, repeated$1, s, s$2, d, tc, s$1);
}
export { $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param as $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param };
/** @constructor */
function $c_Lmagnolia1_CaseClassDerivation$() {
  this.Lmagnolia1_CaseClassDerivation$__f_returningNone = null;
  $n_Lmagnolia1_CaseClassDerivation$ = this;
  this.Lmagnolia1_CaseClassDerivation$__f_returningNone = new $c_Lmagnolia1_CaseClassDerivation$$anon$1();
}
export { $c_Lmagnolia1_CaseClassDerivation$ as $c_Lmagnolia1_CaseClassDerivation$ };
$c_Lmagnolia1_CaseClassDerivation$.prototype = new $h_O();
$c_Lmagnolia1_CaseClassDerivation$.prototype.constructor = $c_Lmagnolia1_CaseClassDerivation$;
/** @constructor */
function $h_Lmagnolia1_CaseClassDerivation$() {
}
export { $h_Lmagnolia1_CaseClassDerivation$ as $h_Lmagnolia1_CaseClassDerivation$ };
$h_Lmagnolia1_CaseClassDerivation$.prototype = $c_Lmagnolia1_CaseClassDerivation$.prototype;
var $d_Lmagnolia1_CaseClassDerivation$ = new $TypeData().initClass($c_Lmagnolia1_CaseClassDerivation$, "magnolia1.CaseClassDerivation$", ({
  Lmagnolia1_CaseClassDerivation$: 1
}));
export { $d_Lmagnolia1_CaseClassDerivation$ as $d_Lmagnolia1_CaseClassDerivation$ };
var $n_Lmagnolia1_CaseClassDerivation$;
function $m_Lmagnolia1_CaseClassDerivation$() {
  if ((!$n_Lmagnolia1_CaseClassDerivation$)) {
    $n_Lmagnolia1_CaseClassDerivation$ = new $c_Lmagnolia1_CaseClassDerivation$();
  }
  return $n_Lmagnolia1_CaseClassDerivation$;
}
export { $m_Lmagnolia1_CaseClassDerivation$ as $m_Lmagnolia1_CaseClassDerivation$ };
function $s_RTLong__remainderUnsigned__RTLong__RTLong__RTLong(a, b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderUnsignedImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn);
}
export { $s_RTLong__remainderUnsigned__RTLong__RTLong__RTLong as $s_RTLong__remainderUnsigned__RTLong__RTLong__RTLong };
function $s_RTLong__remainder__RTLong__RTLong__RTLong(a, b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn);
}
export { $s_RTLong__remainder__RTLong__RTLong__RTLong as $s_RTLong__remainder__RTLong__RTLong__RTLong };
function $s_RTLong__divideUnsigned__RTLong__RTLong__RTLong(a, b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideUnsignedImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn);
}
export { $s_RTLong__divideUnsigned__RTLong__RTLong__RTLong as $s_RTLong__divideUnsigned__RTLong__RTLong__RTLong };
function $s_RTLong__divide__RTLong__RTLong__RTLong(a, b) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, b.RTLong__f_lo, b.RTLong__f_hi);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn);
}
export { $s_RTLong__divide__RTLong__RTLong__RTLong as $s_RTLong__divide__RTLong__RTLong__RTLong };
function $s_RTLong__fromDoubleBits__D__O__RTLong(value, fpBitsDataView) {
  fpBitsDataView.setFloat64(0, value, true);
  return new $c_RTLong((fpBitsDataView.getInt32(0, true) | 0), (fpBitsDataView.getInt32(4, true) | 0));
}
export { $s_RTLong__fromDoubleBits__D__O__RTLong as $s_RTLong__fromDoubleBits__D__O__RTLong };
function $s_RTLong__fromDouble__D__RTLong(value) {
  var this$1 = $m_RTLong$();
  var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
  return new $c_RTLong(lo, this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn);
}
export { $s_RTLong__fromDouble__D__RTLong as $s_RTLong__fromDouble__D__RTLong };
function $s_RTLong__fromUnsignedInt__I__RTLong(value) {
  return new $c_RTLong(value, 0);
}
export { $s_RTLong__fromUnsignedInt__I__RTLong as $s_RTLong__fromUnsignedInt__I__RTLong };
function $s_RTLong__fromInt__I__RTLong(value) {
  return new $c_RTLong(value, (value >> 31));
}
export { $s_RTLong__fromInt__I__RTLong as $s_RTLong__fromInt__I__RTLong };
function $s_RTLong__clz__RTLong__I(a) {
  var hi = a.RTLong__f_hi;
  if ((hi !== 0)) {
    return Math.clz32(hi);
  } else {
    var i = a.RTLong__f_lo;
    return ((32 + Math.clz32(i)) | 0);
  }
}
export { $s_RTLong__clz__RTLong__I as $s_RTLong__clz__RTLong__I };
function $s_RTLong__toFloat__RTLong__F(a) {
  var lo = a.RTLong__f_lo;
  var hi = a.RTLong__f_hi;
  var compressedLo = (((((-2097152) & (hi ^ (hi >> 10))) === 0) || ((65535 & lo) === 0)) ? lo : (32768 | ((-32768) & lo)));
  return Math.fround(((4.294967296E9 * hi) + (compressedLo >>> 0.0)));
}
export { $s_RTLong__toFloat__RTLong__F as $s_RTLong__toFloat__RTLong__F };
function $s_RTLong__toDouble__RTLong__D(a) {
  var lo = a.RTLong__f_lo;
  var hi = a.RTLong__f_hi;
  return ((4.294967296E9 * hi) + (lo >>> 0.0));
}
export { $s_RTLong__toDouble__RTLong__D as $s_RTLong__toDouble__RTLong__D };
function $s_RTLong__toInt__RTLong__I(a) {
  return a.RTLong__f_lo;
}
export { $s_RTLong__toInt__RTLong__I as $s_RTLong__toInt__RTLong__I };
function $s_RTLong__bitsToDouble__RTLong__O__D(a, fpBitsDataView) {
  fpBitsDataView.setInt32(0, a.RTLong__f_lo, true);
  fpBitsDataView.setInt32(4, a.RTLong__f_hi, true);
  return (+fpBitsDataView.getFloat64(0, true));
}
export { $s_RTLong__bitsToDouble__RTLong__O__D as $s_RTLong__bitsToDouble__RTLong__O__D };
function $s_RTLong__mul__RTLong__RTLong__RTLong(a, b) {
  var alo = a.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi);
}
export { $s_RTLong__mul__RTLong__RTLong__RTLong as $s_RTLong__mul__RTLong__RTLong__RTLong };
function $s_RTLong__sub__RTLong__RTLong__RTLong(a, b) {
  var alo = a.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var lo = ((alo - blo) | 0);
  return new $c_RTLong(lo, ((((a.RTLong__f_hi - b.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0));
}
export { $s_RTLong__sub__RTLong__RTLong__RTLong as $s_RTLong__sub__RTLong__RTLong__RTLong };
function $s_RTLong__add__RTLong__RTLong__RTLong(a, b) {
  var alo = a.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var lo = ((alo + blo) | 0);
  return new $c_RTLong(lo, ((((a.RTLong__f_hi + b.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0));
}
export { $s_RTLong__add__RTLong__RTLong__RTLong as $s_RTLong__add__RTLong__RTLong__RTLong };
function $s_RTLong__sar__RTLong__I__RTLong(a, n) {
  var hi = a.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((a.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : (hi >> n)), (((32 & n) === 0) ? (hi >> n) : (hi >> 31)));
}
export { $s_RTLong__sar__RTLong__I__RTLong as $s_RTLong__sar__RTLong__I__RTLong };
function $s_RTLong__shr__RTLong__I__RTLong(a, n) {
  var hi = a.RTLong__f_hi;
  return new $c_RTLong((((32 & n) === 0) ? (((a.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : ((hi >>> n) | 0)), (((32 & n) === 0) ? ((hi >>> n) | 0) : 0));
}
export { $s_RTLong__shr__RTLong__I__RTLong as $s_RTLong__shr__RTLong__I__RTLong };
function $s_RTLong__shl__RTLong__I__RTLong(a, n) {
  var lo = a.RTLong__f_lo;
  return new $c_RTLong((((32 & n) === 0) ? (lo << n) : 0), (((32 & n) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (a.RTLong__f_hi << n)) : (lo << n)));
}
export { $s_RTLong__shl__RTLong__I__RTLong as $s_RTLong__shl__RTLong__I__RTLong };
function $s_RTLong__xor__RTLong__RTLong__RTLong(a, b) {
  return new $c_RTLong((a.RTLong__f_lo ^ b.RTLong__f_lo), (a.RTLong__f_hi ^ b.RTLong__f_hi));
}
export { $s_RTLong__xor__RTLong__RTLong__RTLong as $s_RTLong__xor__RTLong__RTLong__RTLong };
function $s_RTLong__and__RTLong__RTLong__RTLong(a, b) {
  return new $c_RTLong((a.RTLong__f_lo & b.RTLong__f_lo), (a.RTLong__f_hi & b.RTLong__f_hi));
}
export { $s_RTLong__and__RTLong__RTLong__RTLong as $s_RTLong__and__RTLong__RTLong__RTLong };
function $s_RTLong__or__RTLong__RTLong__RTLong(a, b) {
  return new $c_RTLong((a.RTLong__f_lo | b.RTLong__f_lo), (a.RTLong__f_hi | b.RTLong__f_hi));
}
export { $s_RTLong__or__RTLong__RTLong__RTLong as $s_RTLong__or__RTLong__RTLong__RTLong };
function $s_RTLong__geu__RTLong__RTLong__Z(a, b) {
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : ((ahi >>> 0) >= (bhi >>> 0)));
}
export { $s_RTLong__geu__RTLong__RTLong__Z as $s_RTLong__geu__RTLong__RTLong__Z };
function $s_RTLong__gtu__RTLong__RTLong__Z(a, b) {
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) > (b.RTLong__f_lo >>> 0)) : ((ahi >>> 0) > (bhi >>> 0)));
}
export { $s_RTLong__gtu__RTLong__RTLong__Z as $s_RTLong__gtu__RTLong__RTLong__Z };
function $s_RTLong__leu__RTLong__RTLong__Z(a, b) {
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) <= (b.RTLong__f_lo >>> 0)) : ((ahi >>> 0) <= (bhi >>> 0)));
}
export { $s_RTLong__leu__RTLong__RTLong__Z as $s_RTLong__leu__RTLong__RTLong__Z };
function $s_RTLong__ltu__RTLong__RTLong__Z(a, b) {
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) < (b.RTLong__f_lo >>> 0)) : ((ahi >>> 0) < (bhi >>> 0)));
}
export { $s_RTLong__ltu__RTLong__RTLong__Z as $s_RTLong__ltu__RTLong__RTLong__Z };
function $s_RTLong__ge__RTLong__RTLong__Z(a, b) {
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (ahi > bhi));
}
export { $s_RTLong__ge__RTLong__RTLong__Z as $s_RTLong__ge__RTLong__RTLong__Z };
function $s_RTLong__gt__RTLong__RTLong__Z(a, b) {
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) > (b.RTLong__f_lo >>> 0)) : (ahi > bhi));
}
export { $s_RTLong__gt__RTLong__RTLong__Z as $s_RTLong__gt__RTLong__RTLong__Z };
function $s_RTLong__le__RTLong__RTLong__Z(a, b) {
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) <= (b.RTLong__f_lo >>> 0)) : (ahi < bhi));
}
export { $s_RTLong__le__RTLong__RTLong__Z as $s_RTLong__le__RTLong__RTLong__Z };
function $s_RTLong__lt__RTLong__RTLong__Z(a, b) {
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) < (b.RTLong__f_lo >>> 0)) : (ahi < bhi));
}
export { $s_RTLong__lt__RTLong__RTLong__Z as $s_RTLong__lt__RTLong__RTLong__Z };
function $s_RTLong__notEquals__RTLong__RTLong__Z(a, b) {
  return (!((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi)));
}
export { $s_RTLong__notEquals__RTLong__RTLong__Z as $s_RTLong__notEquals__RTLong__RTLong__Z };
function $s_RTLong__equals__RTLong__RTLong__Z(a, b) {
  return ((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi));
}
export { $s_RTLong__equals__RTLong__RTLong__Z as $s_RTLong__equals__RTLong__RTLong__Z };
/** @constructor */
function $c_RTLong(lo, hi) {
  this.RTLong__f_lo = 0;
  this.RTLong__f_hi = 0;
  this.RTLong__f_lo = lo;
  this.RTLong__f_hi = hi;
}
export { $c_RTLong as $c_RTLong };
$c_RTLong.prototype = new $h_O();
$c_RTLong.prototype.constructor = $c_RTLong;
/** @constructor */
function $h_RTLong() {
}
export { $h_RTLong as $h_RTLong };
$h_RTLong.prototype = $c_RTLong.prototype;
$c_RTLong.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_RTLong) && ((this.RTLong__f_lo === that.RTLong__f_lo) && (this.RTLong__f_hi === that.RTLong__f_hi)));
});
$c_RTLong.prototype.hashCode__I = (function() {
  return (this.RTLong__f_lo ^ this.RTLong__f_hi);
});
$c_RTLong.prototype.toString__T = (function() {
  var this$1 = $m_RTLong$();
  return this$1.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this.RTLong__f_lo, this.RTLong__f_hi);
});
$c_RTLong.prototype.byteValue__B = (function() {
  return ((this.RTLong__f_lo << 24) >> 24);
});
$c_RTLong.prototype.shortValue__S = (function() {
  return ((this.RTLong__f_lo << 16) >> 16);
});
$c_RTLong.prototype.intValue__I = (function() {
  return this.RTLong__f_lo;
});
$c_RTLong.prototype.longValue__J = (function() {
  return this;
});
$c_RTLong.prototype.floatValue__F = (function() {
  var lo = this.RTLong__f_lo;
  var hi = this.RTLong__f_hi;
  var compressedLo = (((((-2097152) & (hi ^ (hi >> 10))) === 0) || ((65535 & lo) === 0)) ? lo : (32768 | ((-32768) & lo)));
  return Math.fround(((4.294967296E9 * hi) + (compressedLo >>> 0.0)));
});
$c_RTLong.prototype.doubleValue__D = (function() {
  var lo = this.RTLong__f_lo;
  var hi = this.RTLong__f_hi;
  return ((4.294967296E9 * hi) + (lo >>> 0.0));
});
$c_RTLong.prototype.compareTo__O__I = (function(that) {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, that.RTLong__f_lo, that.RTLong__f_hi);
});
$c_RTLong.prototype.compareTo__jl_Long__I = (function(that) {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(this.RTLong__f_lo, this.RTLong__f_hi, that.RTLong__f_lo, that.RTLong__f_hi);
});
function $isArrayOf_RTLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.RTLong)));
}
export { $isArrayOf_RTLong as $isArrayOf_RTLong };
var $d_RTLong = new $TypeData().initClass($c_RTLong, "org.scalajs.linker.runtime.RuntimeLong", ({
  RTLong: 1
}));
export { $d_RTLong as $d_RTLong };
function $p_RTLong$__unsigned_$div__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + (alo >>> 0.0));
      var bDouble = ((4.294967296E9 * bhi) + (blo >>> 0.0));
      var rDouble = (aDouble / bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (x | 0.0);
      return (rDouble | 0.0);
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0;
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    var pow = ((31 - Math.clz32(blo)) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ((ahi >>> pow) | 0);
    return (((alo >>> pow) | 0) | ((ahi << 1) << ((31 - pow) | 0)));
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    var pow$2 = ((31 - Math.clz32(bhi)) | 0);
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return ((ahi >>> pow$2) | 0);
  } else {
    return $p_RTLong$__unsignedDivModHelper__I__I__I__I__Z__I($thiz, alo, ahi, blo, bhi, true);
  }
}
export { $p_RTLong$__unsigned_$div__I__I__I__I__I as $p_RTLong$__unsigned_$div__I__I__I__I__I };
function $p_RTLong$__unsigned_$percent__I__I__I__I__I($thiz, alo, ahi, blo, bhi) {
  if ((((-2097152) & ahi) === 0)) {
    if ((((-2097152) & bhi) === 0)) {
      var aDouble = ((4.294967296E9 * ahi) + (alo >>> 0.0));
      var bDouble = ((4.294967296E9 * bhi) + (blo >>> 0.0));
      var rDouble = (aDouble % bDouble);
      var x = (rDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (x | 0.0);
      return (rDouble | 0.0);
    } else {
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo;
    }
  } else if (((bhi === 0) && ((blo & (((-1) + blo) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
    return (alo & (((-1) + blo) | 0));
  } else if (((blo === 0) && ((bhi & (((-1) + bhi) | 0)) === 0))) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (ahi & (((-1) + bhi) | 0));
    return alo;
  } else {
    return $p_RTLong$__unsignedDivModHelper__I__I__I__I__Z__I($thiz, alo, ahi, blo, bhi, false);
  }
}
export { $p_RTLong$__unsigned_$percent__I__I__I__I__I as $p_RTLong$__unsigned_$percent__I__I__I__I__I };
function $p_RTLong$__unsignedDivModHelper__I__I__I__I__Z__I($thiz, alo, ahi, blo, bhi, askQuotient) {
  var shift = ((((bhi !== 0) ? Math.clz32(bhi) : ((32 + Math.clz32(blo)) | 0)) - ((ahi !== 0) ? Math.clz32(ahi) : ((32 + Math.clz32(alo)) | 0))) | 0);
  var b = shift;
  var lo = (((32 & b) === 0) ? (blo << b) : 0);
  var hi = (((32 & b) === 0) ? (((((blo >>> 1) | 0) >>> ((31 - b) | 0)) | 0) | (bhi << b)) : (blo << b));
  var bShiftLo = lo;
  var bShiftHi = hi;
  var remLo = alo;
  var remHi = ahi;
  var quotLo = 0;
  var quotHi = 0;
  while (((shift >= 0) && (((-2097152) & remHi) !== 0))) {
    var alo$1 = remLo;
    var ahi$1 = remHi;
    var blo$1 = bShiftLo;
    var bhi$1 = bShiftHi;
    if (((ahi$1 === bhi$1) ? ((alo$1 >>> 0) >= (blo$1 >>> 0)) : ((ahi$1 >>> 0) >= (bhi$1 >>> 0)))) {
      var lo$1 = remLo;
      var hi$1 = remHi;
      var lo$2 = bShiftLo;
      var hi$2 = bShiftHi;
      var lo$3 = ((lo$1 - lo$2) | 0);
      var hi$3 = ((((hi$1 - hi$2) | 0) + ((((~lo$1) & lo$2) | ((~(lo$1 ^ lo$2)) & lo$3)) >> 31)) | 0);
      remLo = lo$3;
      remHi = hi$3;
      if ((shift < 32)) {
        quotLo = (quotLo | (1 << shift));
      } else {
        quotHi = (quotHi | (1 << shift));
      }
    }
    shift = (((-1) + shift) | 0);
    var lo$4 = bShiftLo;
    var hi$4 = bShiftHi;
    var lo$5 = (((lo$4 >>> 1) | 0) | (hi$4 << 31));
    var hi$5 = ((hi$4 >>> 1) | 0);
    bShiftLo = lo$5;
    bShiftHi = hi$5;
  }
  var alo$2 = remLo;
  var ahi$2 = remHi;
  if (((ahi$2 === bhi) ? ((alo$2 >>> 0) >= (blo >>> 0)) : ((ahi$2 >>> 0) >= (bhi >>> 0)))) {
    var lo$6 = remLo;
    var hi$6 = remHi;
    var remDouble = ((4.294967296E9 * hi$6) + (lo$6 >>> 0.0));
    var bDouble = ((4.294967296E9 * bhi) + (blo >>> 0.0));
    if (askQuotient) {
      var x = (remDouble / bDouble);
      var lo$7 = (x | 0.0);
      var x$1 = (x / 4.294967296E9);
      var hi$7 = (x$1 | 0.0);
      var lo$8 = quotLo;
      var hi$8 = quotHi;
      var lo$9 = ((lo$8 + lo$7) | 0);
      var hi$9 = ((((hi$8 + hi$7) | 0) + ((((lo$8 & lo$7) | ((lo$8 | lo$7) & (~lo$9))) >>> 31) | 0)) | 0);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = hi$9;
      return lo$9;
    } else {
      var rem_mod_bDouble = (remDouble % bDouble);
      var x$2 = (rem_mod_bDouble / 4.294967296E9);
      $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (x$2 | 0.0);
      return (rem_mod_bDouble | 0.0);
    }
  } else if (askQuotient) {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = quotHi;
    return quotLo;
  } else {
    $thiz.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = remHi;
    return remLo;
  }
}
export { $p_RTLong$__unsignedDivModHelper__I__I__I__I__Z__I as $p_RTLong$__unsignedDivModHelper__I__I__I__I__Z__I };
/** @constructor */
function $c_RTLong$() {
  this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
}
export { $c_RTLong$ as $c_RTLong$ };
$c_RTLong$.prototype = new $h_O();
$c_RTLong$.prototype.constructor = $c_RTLong$;
/** @constructor */
function $h_RTLong$() {
}
export { $h_RTLong$ as $h_RTLong$ };
$h_RTLong$.prototype = $c_RTLong$.prototype;
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T = (function(lo, hi) {
  if ((hi === (lo >> 31))) {
    return ("" + lo);
  } else if ((((-2097152) & (hi ^ (hi >> 10))) === 0)) {
    var this$2 = ((4.294967296E9 * hi) + (lo >>> 0.0));
    return ("" + this$2);
  } else {
    var sign = (hi >> 31);
    var xlo = (lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var approxNum = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var approxQuot = (+Math.floor((1.0E-9 * approxNum)));
    var x = approxQuot;
    var approxRem = ((rlo - Math.imul(1000000000, (x | 0.0))) | 0);
    if ((approxRem < 0)) {
      approxQuot = (approxQuot - 1.0);
      approxRem = ((1000000000 + approxRem) | 0);
    } else if ((approxRem >= 1000000000)) {
      approxQuot = (approxQuot + 1.0);
      approxRem = (((-1000000000) + approxRem) | 0);
    }
    var this$4 = approxRem;
    var remStr = ("" + this$4);
    var this$6 = approxQuot;
    var start = remStr.length;
    var s = ((("" + this$6) + "000000000".substring(start)) + remStr);
    return ((hi < 0) ? ("-" + s) : s);
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I = (function(value) {
  if ((value < (-9.223372036854776E18))) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-2147483648);
    return 0;
  } else if ((value >= 9.223372036854776E18)) {
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 2147483647;
    return (-1);
  } else {
    var rawLo = (value | 0.0);
    var x = (value / 4.294967296E9);
    var rawHi = (x | 0.0);
    this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (((value < 0.0) && (rawLo !== 0)) ? (((-1) + rawHi) | 0) : rawHi);
    return rawLo;
  }
});
$c_RTLong$.prototype.org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  return ((ahi === bhi) ? ((alo === blo) ? 0 : (((alo >>> 0) < (blo >>> 0)) ? (-1) : 1)) : ((ahi < bhi) ? (-1) : 1));
});
$c_RTLong$.prototype.divideImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  }
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      if (((alo === (-2147483648)) && (blo === (-1)))) {
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
        return (-2147483648);
      } else {
        var lo = ((alo / $checkIntDivisor(blo)) | 0);
        this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
        return lo;
      }
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (-1);
      return (-1);
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0;
    }
  } else {
    var sign = (ahi >> 31);
    var xlo = (alo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((ahi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var sign$1 = (bhi >> 31);
    var xlo$1 = (blo ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((bhi ^ sign$1) + (((xlo$1 & (~rlo$1)) >>> 31) | 0)) | 0);
    var absRLo = $p_RTLong$__unsigned_$div__I__I__I__I__I(this, rlo, rhi, rlo$1, rhi$1);
    if (((ahi ^ bhi) >= 0)) {
      return absRLo;
    } else {
      var hi = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var lo$1 = ((-absRLo) | 0);
      var hi$1 = ((((-hi) | 0) + ((absRLo | lo$1) >> 31)) | 0);
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = hi$1;
      return lo$1;
    }
  }
});
$c_RTLong$.prototype.divideUnsignedImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  }
  if ((ahi === 0)) {
    if ((bhi === 0)) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return (((alo >>> 0) / ($checkIntDivisor(blo) >>> 0)) | 0);
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0;
    }
  } else {
    return $p_RTLong$__unsigned_$div__I__I__I__I__I(this, alo, ahi, blo, bhi);
  }
});
$c_RTLong$.prototype.remainderImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  }
  if ((ahi === (alo >> 31))) {
    if ((bhi === (blo >> 31))) {
      var lo = ((alo % $checkIntDivisor(blo)) | 0);
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = (lo >> 31);
      return lo;
    } else if (((alo === (-2147483648)) && ((blo === (-2147483648)) && (bhi === 0)))) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return 0;
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo;
    }
  } else {
    var sign = (ahi >> 31);
    var xlo = (alo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((ahi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var sign$1 = (bhi >> 31);
    var xlo$1 = (blo ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((bhi ^ sign$1) + (((xlo$1 & (~rlo$1)) >>> 31) | 0)) | 0);
    var absRLo = $p_RTLong$__unsigned_$percent__I__I__I__I__I(this, rlo, rhi, rlo$1, rhi$1);
    if ((ahi < 0)) {
      var hi = this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var lo$1 = ((-absRLo) | 0);
      var hi$1 = ((((-hi) | 0) + ((absRLo | lo$1) >> 31)) | 0);
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = hi$1;
      return lo$1;
    } else {
      return absRLo;
    }
  }
});
$c_RTLong$.prototype.remainderUnsignedImpl__I__I__I__I__I = (function(alo, ahi, blo, bhi) {
  if (((blo | bhi) === 0)) {
    throw new $c_jl_ArithmeticException("/ by zero");
  }
  if ((ahi === 0)) {
    if ((bhi === 0)) {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = 0;
      return (((alo >>> 0) % ($checkIntDivisor(blo) >>> 0)) | 0);
    } else {
      this.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn = ahi;
      return alo;
    }
  } else {
    return $p_RTLong$__unsigned_$percent__I__I__I__I__I(this, alo, ahi, blo, bhi);
  }
});
var $d_RTLong$ = new $TypeData().initClass($c_RTLong$, "org.scalajs.linker.runtime.RuntimeLong$", ({
  RTLong$: 1
}));
export { $d_RTLong$ as $d_RTLong$ };
var $n_RTLong$;
function $m_RTLong$() {
  if ((!$n_RTLong$)) {
    $n_RTLong$ = new $c_RTLong$();
  }
  return $n_RTLong$;
}
export { $m_RTLong$ as $m_RTLong$ };
/** @constructor */
function $c_s_Array$EmptyArrays$() {
  this.s_Array$EmptyArrays$__f_emptyByteArray = null;
  this.s_Array$EmptyArrays$__f_emptyIntArray = null;
  this.s_Array$EmptyArrays$__f_emptyObjectArray = null;
  $n_s_Array$EmptyArrays$ = this;
  this.s_Array$EmptyArrays$__f_emptyByteArray = new $ac_B(0);
  this.s_Array$EmptyArrays$__f_emptyIntArray = new $ac_I(0);
  this.s_Array$EmptyArrays$__f_emptyObjectArray = new $ac_O(0);
}
export { $c_s_Array$EmptyArrays$ as $c_s_Array$EmptyArrays$ };
$c_s_Array$EmptyArrays$.prototype = new $h_O();
$c_s_Array$EmptyArrays$.prototype.constructor = $c_s_Array$EmptyArrays$;
/** @constructor */
function $h_s_Array$EmptyArrays$() {
}
export { $h_s_Array$EmptyArrays$ as $h_s_Array$EmptyArrays$ };
$h_s_Array$EmptyArrays$.prototype = $c_s_Array$EmptyArrays$.prototype;
var $d_s_Array$EmptyArrays$ = new $TypeData().initClass($c_s_Array$EmptyArrays$, "scala.Array$EmptyArrays$", ({
  s_Array$EmptyArrays$: 1
}));
export { $d_s_Array$EmptyArrays$ as $d_s_Array$EmptyArrays$ };
var $n_s_Array$EmptyArrays$;
function $m_s_Array$EmptyArrays$() {
  if ((!$n_s_Array$EmptyArrays$)) {
    $n_s_Array$EmptyArrays$ = new $c_s_Array$EmptyArrays$();
  }
  return $n_s_Array$EmptyArrays$;
}
export { $m_s_Array$EmptyArrays$ as $m_s_Array$EmptyArrays$ };
/** @constructor */
function $c_s_Array$UnapplySeqWrapper$() {
}
export { $c_s_Array$UnapplySeqWrapper$ as $c_s_Array$UnapplySeqWrapper$ };
$c_s_Array$UnapplySeqWrapper$.prototype = new $h_O();
$c_s_Array$UnapplySeqWrapper$.prototype.constructor = $c_s_Array$UnapplySeqWrapper$;
/** @constructor */
function $h_s_Array$UnapplySeqWrapper$() {
}
export { $h_s_Array$UnapplySeqWrapper$ as $h_s_Array$UnapplySeqWrapper$ };
$h_s_Array$UnapplySeqWrapper$.prototype = $c_s_Array$UnapplySeqWrapper$.prototype;
$c_s_Array$UnapplySeqWrapper$.prototype.lengthCompare$extension__O__I__I = (function(this$, len) {
  return $m_sc_ArrayOps$().lengthCompare$extension__O__I__I(this$, len);
});
var $d_s_Array$UnapplySeqWrapper$ = new $TypeData().initClass($c_s_Array$UnapplySeqWrapper$, "scala.Array$UnapplySeqWrapper$", ({
  s_Array$UnapplySeqWrapper$: 1
}));
export { $d_s_Array$UnapplySeqWrapper$ as $d_s_Array$UnapplySeqWrapper$ };
var $n_s_Array$UnapplySeqWrapper$;
function $m_s_Array$UnapplySeqWrapper$() {
  if ((!$n_s_Array$UnapplySeqWrapper$)) {
    $n_s_Array$UnapplySeqWrapper$ = new $c_s_Array$UnapplySeqWrapper$();
  }
  return $n_s_Array$UnapplySeqWrapper$;
}
export { $m_s_Array$UnapplySeqWrapper$ as $m_s_Array$UnapplySeqWrapper$ };
var $d_F0 = new $TypeData().initClass(1, "scala.Function0", ({
  F0: 1
}));
export { $d_F0 as $d_F0 };
function $f_F1__compose__F1__F1($thiz, g) {
  return new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => $thiz.apply__O__O(g.apply__O__O(x$2$2))));
}
export { $f_F1__compose__F1__F1 as $f_F1__compose__F1__F1 };
function $f_F1__andThen__F1__F1($thiz, g) {
  return new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => g.apply__O__O($thiz.apply__O__O(x$2$2))));
}
export { $f_F1__andThen__F1__F1 as $f_F1__andThen__F1__F1 };
function $is_F1(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.F1)));
}
export { $is_F1 as $is_F1 };
function $isArrayOf_F1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.F1)));
}
export { $isArrayOf_F1 as $isArrayOf_F1 };
var $d_F1 = new $TypeData().initClass(1, "scala.Function1", ({
  F1: 1
}));
export { $d_F1 as $d_F1 };
function $f_F2__tupled__F1($thiz) {
  return new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x0$1$2$2) => {
    if ((x0$1$2$2 !== null)) {
      var x1$2 = x0$1$2$2._1__O();
      var x2 = x0$1$2$2._2__O();
      return $thiz.apply__O__O__O(x1$2, x2);
    } else {
      throw new $c_s_MatchError(x0$1$2$2);
    }
  }));
}
export { $f_F2__tupled__F1 as $f_F2__tupled__F1 };
/** @constructor */
function $c_s_IArray$package$IArray$() {
}
export { $c_s_IArray$package$IArray$ as $c_s_IArray$package$IArray$ };
$c_s_IArray$package$IArray$.prototype = new $h_O();
$c_s_IArray$package$IArray$.prototype.constructor = $c_s_IArray$package$IArray$;
/** @constructor */
function $h_s_IArray$package$IArray$() {
}
export { $h_s_IArray$package$IArray$ as $h_s_IArray$package$IArray$ };
$h_s_IArray$package$IArray$.prototype = $c_s_IArray$package$IArray$.prototype;
$c_s_IArray$package$IArray$.prototype.head__O__O = (function(arr) {
  return $m_sc_ArrayOps$().head$extension__O__O(arr);
});
$c_s_IArray$package$IArray$.prototype.iterator__O__sc_Iterator = (function(arr) {
  return $m_sc_ArrayOps$().iterator$extension__O__sc_Iterator(arr);
});
$c_s_IArray$package$IArray$.prototype.nonEmpty__O__Z = (function(arr) {
  return ($m_jl_reflect_Array$().getLength__O__I(arr) !== 0);
});
$c_s_IArray$package$IArray$.prototype.genericWrapArray__O__sci_ArraySeq = (function(arr) {
  return ((arr === null) ? null : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(arr));
});
$c_s_IArray$package$IArray$.prototype.wrapRefArray__AO__sci_ArraySeq$ofRef = (function(arr) {
  if ((arr === null)) {
    return null;
  } else if ((arr.u.length === 0)) {
    var this$2 = $m_sci_ArraySeq$();
    return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this$2);
  } else {
    return new $c_sci_ArraySeq$ofRef(arr);
  }
});
$c_s_IArray$package$IArray$.prototype.wrapByteIArray__AB__sci_ArraySeq$ofByte = (function(arr) {
  return ((arr === null) ? null : new $c_sci_ArraySeq$ofByte(arr));
});
var $d_s_IArray$package$IArray$ = new $TypeData().initClass($c_s_IArray$package$IArray$, "scala.IArray$package$IArray$", ({
  s_IArray$package$IArray$: 1
}));
export { $d_s_IArray$package$IArray$ as $d_s_IArray$package$IArray$ };
var $n_s_IArray$package$IArray$;
function $m_s_IArray$package$IArray$() {
  if ((!$n_s_IArray$package$IArray$)) {
    $n_s_IArray$package$IArray$ = new $c_s_IArray$package$IArray$();
  }
  return $n_s_IArray$package$IArray$;
}
export { $m_s_IArray$package$IArray$ as $m_s_IArray$package$IArray$ };
/** @constructor */
function $c_s_LowPriorityImplicits2() {
}
export { $c_s_LowPriorityImplicits2 as $c_s_LowPriorityImplicits2 };
$c_s_LowPriorityImplicits2.prototype = new $h_O();
$c_s_LowPriorityImplicits2.prototype.constructor = $c_s_LowPriorityImplicits2;
/** @constructor */
function $h_s_LowPriorityImplicits2() {
}
export { $h_s_LowPriorityImplicits2 as $h_s_LowPriorityImplicits2 };
$h_s_LowPriorityImplicits2.prototype = $c_s_LowPriorityImplicits2.prototype;
/** @constructor */
function $c_s_Option$WithFilter(outer, p) {
  this.s_Option$WithFilter__f_p = null;
  this.s_Option$WithFilter__f_$outer = null;
  this.s_Option$WithFilter__f_p = p;
  this.s_Option$WithFilter__f_$outer = outer;
}
export { $c_s_Option$WithFilter as $c_s_Option$WithFilter };
$c_s_Option$WithFilter.prototype = new $h_O();
$c_s_Option$WithFilter.prototype.constructor = $c_s_Option$WithFilter;
/** @constructor */
function $h_s_Option$WithFilter() {
}
export { $h_s_Option$WithFilter as $h_s_Option$WithFilter };
$h_s_Option$WithFilter.prototype = $c_s_Option$WithFilter.prototype;
var $d_s_Option$WithFilter = new $TypeData().initClass($c_s_Option$WithFilter, "scala.Option$WithFilter", ({
  s_Option$WithFilter: 1
}));
export { $d_s_Option$WithFilter as $d_s_Option$WithFilter };
/** @constructor */
function $c_s_PartialFunction$() {
  this.s_PartialFunction$__f_fallback_fn = null;
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = null;
  this.s_PartialFunction$__f_empty_pf = null;
  $n_s_PartialFunction$ = this;
  this.s_PartialFunction$__f_fallback_fn = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2$2) => $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn));
  this.s_PartialFunction$__f_scala$PartialFunction$$constFalse = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$3$2$2) => false));
  this.s_PartialFunction$__f_empty_pf = new $c_s_PartialFunction$$anon$1();
}
export { $c_s_PartialFunction$ as $c_s_PartialFunction$ };
$c_s_PartialFunction$.prototype = new $h_O();
$c_s_PartialFunction$.prototype.constructor = $c_s_PartialFunction$;
/** @constructor */
function $h_s_PartialFunction$() {
}
export { $h_s_PartialFunction$ as $h_s_PartialFunction$ };
$h_s_PartialFunction$.prototype = $c_s_PartialFunction$.prototype;
$c_s_PartialFunction$.prototype.scala$PartialFunction$$fallbackOccurred__O__Z = (function(x) {
  return (this.s_PartialFunction$__f_fallback_fn === x);
});
var $d_s_PartialFunction$ = new $TypeData().initClass($c_s_PartialFunction$, "scala.PartialFunction$", ({
  s_PartialFunction$: 1
}));
export { $d_s_PartialFunction$ as $d_s_PartialFunction$ };
var $n_s_PartialFunction$;
function $m_s_PartialFunction$() {
  if ((!$n_s_PartialFunction$)) {
    $n_s_PartialFunction$ = new $c_s_PartialFunction$();
  }
  return $n_s_PartialFunction$;
}
export { $m_s_PartialFunction$ as $m_s_PartialFunction$ };
function $f_s_Proxy__toString__T($thiz) {
  return ("" + $thiz.self__O());
}
export { $f_s_Proxy__toString__T as $f_s_Proxy__toString__T };
/** @constructor */
function $c_T$() {
  this.T$__f_canEqualEmptyTuple$lzy1 = null;
  this.T$__f_canEqualEmptyTuplebitmap$1 = false;
}
export { $c_T$ as $c_T$ };
$c_T$.prototype = new $h_O();
$c_T$.prototype.constructor = $c_T$;
/** @constructor */
function $h_T$() {
}
export { $h_T$ as $h_T$ };
$h_T$.prototype = $c_T$.prototype;
$c_T$.prototype.fromArray__O__s_Product = (function(xs) {
  if ((xs instanceof $ac_O)) {
    var xs2 = xs;
  } else {
    var f = ((_$9) => _$9);
    var len = $m_jl_reflect_Array$().getLength__O__I(xs);
    var ys = new $ac_O(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs instanceof $ac_O)) {
        while ((i < len)) {
          var $x_1 = i;
          var x0 = xs.u[i];
          ys.u[$x_1] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0$1 = xs.u[i];
          ys.u[$x_2] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$2 = xs.u[i];
          ys.u[$x_3] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var $x_4 = i;
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.u[$x_4] = f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var $x_5 = i;
          var x0$3 = xs.u[i];
          ys.u[$x_5] = f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var $x_6 = i;
          var x0$4 = xs.u[i];
          ys.u[$x_6] = f($bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$5 = xs.u[i];
          ys.u[$x_7] = f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$6 = xs.u[i];
          ys.u[$x_8] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$7 = xs.u[i];
          ys.u[$x_9] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    }
    var xs2 = ys;
  }
  return $m_sr_Tuples$().fromArray__AO__s_Product(xs2);
});
$c_T$.prototype.fromIArray__O__s_Product = (function(xs) {
  if ((xs instanceof $ac_O)) {
    var xs2 = xs;
  } else {
    var f = ((_$10) => _$10);
    var len = $m_jl_reflect_Array$().getLength__O__I(xs);
    var ys = new $ac_O(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs instanceof $ac_O)) {
        while ((i < len)) {
          var $x_1 = i;
          var x0 = xs.u[i];
          ys.u[$x_1] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0$1 = xs.u[i];
          ys.u[$x_2] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$2 = xs.u[i];
          ys.u[$x_3] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var $x_4 = i;
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.u[$x_4] = f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var $x_5 = i;
          var x0$3 = xs.u[i];
          ys.u[$x_5] = f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var $x_6 = i;
          var x0$4 = xs.u[i];
          ys.u[$x_6] = f($bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$5 = xs.u[i];
          ys.u[$x_7] = f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$6 = xs.u[i];
          ys.u[$x_8] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$7 = xs.u[i];
          ys.u[$x_9] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    }
    var xs2 = ys;
  }
  return $m_sr_Tuples$().fromIArray__AO__s_Product(xs2);
});
$c_T$.prototype.canEqualEmptyTuple__s_CanEqual = (function() {
  if ((!this.T$__f_canEqualEmptyTuplebitmap$1)) {
    this.T$__f_canEqualEmptyTuple$lzy1 = $m_s_CanEqual$derived$();
    this.T$__f_canEqualEmptyTuplebitmap$1 = true;
  }
  return this.T$__f_canEqualEmptyTuple$lzy1;
});
var $d_T$ = new $TypeData().initClass($c_T$, "scala.Tuple$", ({
  T$: 1
}));
export { $d_T$ as $d_T$ };
var $n_T$;
function $m_T$() {
  if ((!$n_T$)) {
    $n_T$ = new $c_T$();
  }
  return $n_T$;
}
export { $m_T$ as $m_T$ };
function $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len$1, \u03b4this$2, ord$1) {
  if ((len$1 < 300)) {
    var a = $m_sr_ScalaRunTime$().array_clone__O__O(\u03b4this$2);
    var this$1 = $m_s_util_Sorting$();
    this$1.stableSort__O__I__I__s_math_Ordering__V(a, 0, $m_jl_reflect_Array$().getLength__O__I(a), ord$1);
    return a;
  } else {
    var this$4 = $objectGetClass(\u03b4this$2);
    var that = this$4.data.getComponentType();
    if ($d_O.isAssignableFrom(that.data)) {
      var a$2 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(\u03b4this$2, len$1, $d_O.getArrayOf().getClassOf());
    } else {
      var dest = new $ac_O(len$1);
      $m_s_Array$().copy__O__I__O__I__I__V(\u03b4this$2, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(\u03b4this$2));
      var a$2 = dest;
    }
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a$2, ord$1);
    var $x_2 = $m_s_Array$();
    var $x_1 = $m_s_reflect_ClassTag$();
    var this$9 = $objectGetClass(\u03b4this$2);
    return $x_2.copyAs__O__I__s_reflect_ClassTag__O(a$2, len$1, $x_1.apply__jl_Class__s_reflect_ClassTag(this$9.data.getComponentType()));
  }
}
export { $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O as $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O };
/** @constructor */
function $c_sc_ArrayOps$() {
  this.sc_ArrayOps$__f_fallback = null;
  $n_sc_ArrayOps$ = this;
  this.sc_ArrayOps$__f_fallback = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2$2) => $m_sc_ArrayOps$().sc_ArrayOps$__f_fallback));
}
export { $c_sc_ArrayOps$ as $c_sc_ArrayOps$ };
$c_sc_ArrayOps$.prototype = new $h_O();
$c_sc_ArrayOps$.prototype.constructor = $c_sc_ArrayOps$;
/** @constructor */
function $h_sc_ArrayOps$() {
}
export { $h_sc_ArrayOps$ as $h_sc_ArrayOps$ };
$h_sc_ArrayOps$.prototype = $c_sc_ArrayOps$.prototype;
$c_sc_ArrayOps$.prototype.head$extension__O__O = (function(this$) {
  if (($m_jl_reflect_Array$().getLength__O__I(this$) !== 0)) {
    return $m_sr_ScalaRunTime$().array_apply__O__I__O(this$, 0);
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty array");
  }
});
$c_sc_ArrayOps$.prototype.last$extension__O__O = (function(this$) {
  if (($m_jl_reflect_Array$().getLength__O__I(this$) !== 0)) {
    return $m_sr_ScalaRunTime$().array_apply__O__I__O(this$, (((-1) + $m_jl_reflect_Array$().getLength__O__I(this$)) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty array");
  }
});
$c_sc_ArrayOps$.prototype.lengthCompare$extension__O__I__I = (function(this$, len) {
  var x = $m_jl_reflect_Array$().getLength__O__I(this$);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_ArrayOps$.prototype.slice$extension__O__I__I__O = (function(this$, from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = $m_jl_reflect_Array$().getLength__O__I(this$);
  var hi = ((until < b) ? until : b);
  if ((hi > lo)) {
    if ((this$ instanceof $ac_O)) {
      return $m_ju_Arrays$().copyOfRange__AO__I__I__AO(this$, lo, hi);
    } else if ((this$ instanceof $ac_I)) {
      return $m_ju_Arrays$().copyOfRange__AI__I__I__AI(this$, lo, hi);
    } else if ((this$ instanceof $ac_D)) {
      return $m_ju_Arrays$().copyOfRange__AD__I__I__AD(this$, lo, hi);
    } else if ((this$ instanceof $ac_J)) {
      return $m_ju_Arrays$().copyOfRange__AJ__I__I__AJ(this$, lo, hi);
    } else if ((this$ instanceof $ac_F)) {
      return $m_ju_Arrays$().copyOfRange__AF__I__I__AF(this$, lo, hi);
    } else if ((this$ instanceof $ac_C)) {
      return $m_ju_Arrays$().copyOfRange__AC__I__I__AC(this$, lo, hi);
    } else if ((this$ instanceof $ac_B)) {
      return $m_ju_Arrays$().copyOfRange__AB__I__I__AB(this$, lo, hi);
    } else if ((this$ instanceof $ac_S)) {
      return $m_ju_Arrays$().copyOfRange__AS__I__I__AS(this$, lo, hi);
    } else if ((this$ instanceof $ac_Z)) {
      return $m_ju_Arrays$().copyOfRange__AZ__I__I__AZ(this$, lo, hi);
    } else {
      throw new $c_s_MatchError(this$);
    }
  } else {
    var $x_1 = $m_s_reflect_ClassTag$();
    var this$5 = $objectGetClass(this$);
    return $x_1.apply__jl_Class__s_reflect_ClassTag(this$5.data.getComponentType()).newArray__I__O(0);
  }
});
$c_sc_ArrayOps$.prototype.tail$extension__O__O = (function(this$) {
  if (($m_jl_reflect_Array$().getLength__O__I(this$) === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty array");
  } else {
    return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 1, $m_jl_reflect_Array$().getLength__O__I(this$));
  }
});
$c_sc_ArrayOps$.prototype.init$extension__O__O = (function(this$) {
  if (($m_jl_reflect_Array$().getLength__O__I(this$) === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "init of empty array");
  } else {
    return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, (((-1) + $m_jl_reflect_Array$().getLength__O__I(this$)) | 0));
  }
});
$c_sc_ArrayOps$.prototype.drop$extension__O__I__O = (function(this$, n) {
  return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, n, $m_jl_reflect_Array$().getLength__O__I(this$));
});
$c_sc_ArrayOps$.prototype.dropRight$extension__O__I__O = (function(this$, n) {
  var n$1 = (($m_jl_reflect_Array$().getLength__O__I(this$) - ((n > 0) ? n : 0)) | 0);
  return $m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, n$1);
});
$c_sc_ArrayOps$.prototype.iterator$extension__O__sc_Iterator = (function(this$) {
  if ((this$ instanceof $ac_O)) {
    return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this$);
  } else if ((this$ instanceof $ac_I)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this$);
  } else if ((this$ instanceof $ac_D)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this$);
  } else if ((this$ instanceof $ac_J)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this$);
  } else if ((this$ instanceof $ac_F)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this$);
  } else if ((this$ instanceof $ac_C)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this$);
  } else if ((this$ instanceof $ac_B)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this$);
  } else if ((this$ instanceof $ac_S)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this$);
  } else if ((this$ instanceof $ac_Z)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this$);
  } else if ($isArrayOf_jl_Void(this$, 1)) {
    return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this$);
  } else if ((this$ === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(this$);
  }
});
$c_sc_ArrayOps$.prototype.sorted$extension__O__s_math_Ordering__O = (function(this$, ord) {
  var len = $m_jl_reflect_Array$().getLength__O__I(this$);
  if ((len <= 1)) {
    return $m_sr_ScalaRunTime$().array_clone__O__O(this$);
  } else if ((this$ instanceof $ac_O)) {
    var a = $m_ju_Arrays$().copyOf__AO__I__AO(this$, len);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return a;
  } else if ((this$ instanceof $ac_I)) {
    if ((ord === $m_s_math_Ordering$Int$())) {
      var a$2 = $m_ju_Arrays$().copyOf__AI__I__AI(this$, len);
      $m_ju_Arrays$().sort__AI__V(a$2);
      return a$2;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_J)) {
    if ((ord === $m_s_math_Ordering$Long$())) {
      var a$3 = $m_ju_Arrays$().copyOf__AJ__I__AJ(this$, len);
      $m_ju_Arrays$().sort__AJ__V(a$3);
      return a$3;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_C)) {
    if ((ord === $m_s_math_Ordering$Char$())) {
      var a$4 = $m_ju_Arrays$().copyOf__AC__I__AC(this$, len);
      $m_ju_Arrays$().sort__AC__V(a$4);
      return a$4;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_B)) {
    if ((ord === $m_s_math_Ordering$Byte$())) {
      var a$5 = $m_ju_Arrays$().copyOf__AB__I__AB(this$, len);
      $m_ju_Arrays$().sort__AB__V(a$5);
      return a$5;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_S)) {
    if ((ord === $m_s_math_Ordering$Short$())) {
      var a$6 = $m_ju_Arrays$().copyOf__AS__I__AS(this$, len);
      $m_ju_Arrays$().sort__AS__V(a$6);
      return a$6;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else if ((this$ instanceof $ac_Z)) {
    if ((ord === $m_s_math_Ordering$Boolean$())) {
      var a$7 = $m_ju_Arrays$().copyOf__AZ__I__AZ(this$, len);
      var this$2 = $m_s_util_Sorting$();
      var evidence$3 = $m_s_math_Ordering$Boolean$();
      this$2.stableSort__O__I__I__s_math_Ordering__V(a$7, 0, a$7.u.length, evidence$3);
      return a$7;
    } else {
      return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
    }
  } else {
    return $ps_sc_ArrayOps$__boxed$1__I__O__s_math_Ordering__O(len, this$, ord);
  }
});
$c_sc_ArrayOps$.prototype.collectFirst$extension__O__s_PartialFunction__s_Option = (function(this$, pf) {
  var fallback = $m_sc_ArrayOps$().sc_ArrayOps$__f_fallback;
  var i = 0;
  while ((i < $m_jl_reflect_Array$().getLength__O__I(this$))) {
    var v = pf.applyOrElse__O__F1__O($m_sr_ScalaRunTime$().array_apply__O__I__O(this$, i), fallback);
    if ((v !== fallback)) {
      return new $c_s_Some(v);
    }
    i = ((1 + i) | 0);
  }
  return $m_s_None$();
});
$c_sc_ArrayOps$.prototype.zip$extension__O__sc_IterableOnce__AT2 = (function(this$, that) {
  var b = new $c_scm_ArrayBuilder$ofRef(new $c_s_reflect_ClassTag$GenericClassTag($d_T2.getClassOf()));
  var k = that.knownSize__I();
  if ((k >= 0)) {
    var b$1 = $m_jl_reflect_Array$().getLength__O__I(this$);
    var $x_1 = ((k < b$1) ? k : b$1);
  } else {
    var $x_1 = $m_jl_reflect_Array$().getLength__O__I(this$);
  }
  b.sizeHint__I__V($x_1);
  var i = 0;
  var it = that.iterator__sc_Iterator();
  while (((i < $m_jl_reflect_Array$().getLength__O__I(this$)) && it.hasNext__Z())) {
    var elem = $ct_T2__O__O__(new $c_T2(), $m_sr_ScalaRunTime$().array_apply__O__I__O(this$, i), it.next__O());
    b.addOne__O__scm_ArrayBuilder$ofRef(elem);
    i = ((1 + i) | 0);
  }
  return b.result__AO();
});
$c_sc_ArrayOps$.prototype.foreach$extension__O__F1__V = (function(this$, f) {
  var len = $m_jl_reflect_Array$().getLength__O__I(this$);
  var i = 0;
  if ((this$ instanceof $ac_O)) {
    while ((i < len)) {
      f.apply__O__O(this$.u[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_I)) {
    while ((i < len)) {
      f.apply__O__O(this$.u[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_D)) {
    while ((i < len)) {
      f.apply__O__O(this$.u[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_J)) {
    while ((i < len)) {
      f.apply__O__O(this$.u[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_F)) {
    while ((i < len)) {
      f.apply__O__O(this$.u[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_C)) {
    while ((i < len)) {
      f.apply__O__O($bC(this$.u[i]));
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_B)) {
    while ((i < len)) {
      f.apply__O__O(this$.u[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_S)) {
    while ((i < len)) {
      f.apply__O__O(this$.u[i]);
      i = ((1 + i) | 0);
    }
  } else if ((this$ instanceof $ac_Z)) {
    while ((i < len)) {
      f.apply__O__O(this$.u[i]);
      i = ((1 + i) | 0);
    }
  } else {
    throw new $c_s_MatchError(this$);
  }
});
$c_sc_ArrayOps$.prototype.copyToArray$extension__O__O__I__I__I = (function(this$, xs, start, len) {
  var srcLen = $m_jl_reflect_Array$().getLength__O__I(this$);
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this$, 0, xs, start, copied);
  }
  return copied;
});
var $d_sc_ArrayOps$ = new $TypeData().initClass($c_sc_ArrayOps$, "scala.collection.ArrayOps$", ({
  sc_ArrayOps$: 1
}));
export { $d_sc_ArrayOps$ as $d_sc_ArrayOps$ };
var $n_sc_ArrayOps$;
function $m_sc_ArrayOps$() {
  if ((!$n_sc_ArrayOps$)) {
    $n_sc_ArrayOps$ = new $c_sc_ArrayOps$();
  }
  return $n_sc_ArrayOps$;
}
export { $m_sc_ArrayOps$ as $m_sc_ArrayOps$ };
/** @constructor */
function $c_sc_Hashing$() {
}
export { $c_sc_Hashing$ as $c_sc_Hashing$ };
$c_sc_Hashing$.prototype = new $h_O();
$c_sc_Hashing$.prototype.constructor = $c_sc_Hashing$;
/** @constructor */
function $h_sc_Hashing$() {
}
export { $h_sc_Hashing$ as $h_sc_Hashing$ };
$h_sc_Hashing$.prototype = $c_sc_Hashing$.prototype;
$c_sc_Hashing$.prototype.improve__I__I = (function(hcode) {
  var h = ((hcode + (~(hcode << 9))) | 0);
  h = (h ^ ((h >>> 14) | 0));
  h = ((h + (h << 4)) | 0);
  return (h ^ ((h >>> 10) | 0));
});
var $d_sc_Hashing$ = new $TypeData().initClass($c_sc_Hashing$, "scala.collection.Hashing$", ({
  sc_Hashing$: 1
}));
export { $d_sc_Hashing$ as $d_sc_Hashing$ };
var $n_sc_Hashing$;
function $m_sc_Hashing$() {
  if ((!$n_sc_Hashing$)) {
    $n_sc_Hashing$ = new $c_sc_Hashing$();
  }
  return $n_sc_Hashing$;
}
export { $m_sc_Hashing$ as $m_sc_Hashing$ };
function $f_sc_IterableOnceOps__foreach__F1__V($thiz, f) {
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    f.apply__O__O(it.next__O());
  }
}
export { $f_sc_IterableOnceOps__foreach__F1__V as $f_sc_IterableOnceOps__foreach__F1__V };
function $f_sc_IterableOnceOps__forall__F1__Z($thiz, p) {
  var res = true;
  var it = $thiz.iterator__sc_Iterator();
  while ((res && it.hasNext__Z())) {
    res = (!(!p.apply__O__O(it.next__O())));
  }
  return res;
}
export { $f_sc_IterableOnceOps__forall__F1__Z as $f_sc_IterableOnceOps__forall__F1__Z };
function $f_sc_IterableOnceOps__exists__F1__Z($thiz, p) {
  var res = false;
  var it = $thiz.iterator__sc_Iterator();
  while (((!res) && it.hasNext__Z())) {
    res = (!(!p.apply__O__O(it.next__O())));
  }
  return res;
}
export { $f_sc_IterableOnceOps__exists__F1__Z as $f_sc_IterableOnceOps__exists__F1__Z };
function $f_sc_IterableOnceOps__find__F1__s_Option($thiz, p) {
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var a = it.next__O();
    if ((!(!p.apply__O__O(a)))) {
      return new $c_s_Some(a);
    }
  }
  return $m_s_None$();
}
export { $f_sc_IterableOnceOps__find__F1__s_Option as $f_sc_IterableOnceOps__find__F1__s_Option };
function $f_sc_IterableOnceOps__foldLeft__O__F2__O($thiz, z, op) {
  if ($is_sc_IndexedSeq($thiz)) {
    return $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, 0, $thiz.length__I(), z, op, $thiz);
  } else {
    var result = z;
    var it = $thiz.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      result = op.apply__O__O__O(result, it.next__O());
    }
    return result;
  }
}
export { $f_sc_IterableOnceOps__foldLeft__O__F2__O as $f_sc_IterableOnceOps__foldLeft__O__F2__O };
function $f_sc_IterableOnceOps__foldRight__O__F2__O($thiz, z, op) {
  return $thiz.reversed__sc_Iterable().foldLeft__O__F2__O(z, new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((b$2$2, a$2$2) => op.apply__O__O__O(a$2$2, b$2$2))));
}
export { $f_sc_IterableOnceOps__foldRight__O__F2__O as $f_sc_IterableOnceOps__foldRight__O__F2__O };
function $f_sc_IterableOnceOps__reduceLeft__F2__O($thiz, op) {
  if ($is_sc_IndexedSeq($thiz)) {
    if (($thiz.length__I() > 0)) {
      var z = $thiz.apply__I__O(0);
      return $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, 1, $thiz.length__I(), z, op, $thiz);
    }
  }
  if (($thiz.knownSize__I() === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  }
  var it = $thiz.iterator__sc_Iterator();
  if (it.hasNext__Z()) {
    var acc = it.next__O();
    while (it.hasNext__Z()) {
      acc = op.apply__O__O__O(acc, it.next__O());
    }
    return acc;
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  }
}
export { $f_sc_IterableOnceOps__reduceLeft__F2__O as $f_sc_IterableOnceOps__reduceLeft__F2__O };
function $f_sc_IterableOnceOps__isEmpty__Z($thiz) {
  var x1 = $thiz.knownSize__I();
  switch (x1) {
    case (-1): {
      return (!$thiz.iterator__sc_Iterator().hasNext__Z());
      break;
    }
    case 0: {
      return true;
      break;
    }
    default: {
      return false;
    }
  }
}
export { $f_sc_IterableOnceOps__isEmpty__Z as $f_sc_IterableOnceOps__isEmpty__Z };
function $f_sc_IterableOnceOps__size__I($thiz) {
  if (($thiz.knownSize__I() >= 0)) {
    return $thiz.knownSize__I();
  } else {
    var it = $thiz.iterator__sc_Iterator();
    var len = 0;
    while (it.hasNext__Z()) {
      len = ((1 + len) | 0);
      it.next__O();
    }
    return len;
  }
}
export { $f_sc_IterableOnceOps__size__I as $f_sc_IterableOnceOps__size__I };
function $f_sc_IterableOnceOps__copyToArray__O__I__I__I($thiz, dest, start, n) {
  var it = $thiz.iterator__sc_Iterator();
  var i = start;
  var x1 = $thiz.knownSize__I();
  var srclen = ((x1 === (-1)) ? $m_jl_reflect_Array$().getLength__O__I(dest) : x1);
  var destLen = $m_jl_reflect_Array$().getLength__O__I(dest);
  var limit = ((n < srclen) ? n : srclen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var end = ((start + ((total < 0) ? 0 : total)) | 0);
  while (((i < end) && it.hasNext__Z())) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest, i, it.next__O());
    i = ((1 + i) | 0);
  }
  return ((i - start) | 0);
}
export { $f_sc_IterableOnceOps__copyToArray__O__I__I__I as $f_sc_IterableOnceOps__copyToArray__O__I__I__I };
function $f_sc_IterableOnceOps__sum__s_math_Numeric__O($thiz, num) {
  var x1 = $thiz.knownSize__I();
  switch (x1) {
    case (-1): {
      return $thiz.foldLeft__O__F2__O(num.fromInt__I__O(0), new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$2$2, y$2$2) => num.plus__O__O__O(x$2$2, y$2$2))));
      break;
    }
    case 0: {
      return num.fromInt__I__O(0);
      break;
    }
    default: {
      var op = new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$2$2$1, y$2$2$1) => num.plus__O__O__O(x$2$2$1, y$2$2$1)));
      return $thiz.reduceLeft__F2__O(op);
    }
  }
}
export { $f_sc_IterableOnceOps__sum__s_math_Numeric__O as $f_sc_IterableOnceOps__sum__s_math_Numeric__O };
function $f_sc_IterableOnceOps__min__s_math_Ordering__O($thiz, ord) {
  var x1 = $thiz.knownSize__I();
  switch (x1) {
    case (-1): {
      var it = $thiz.iterator__sc_Iterator();
      if (it.hasNext__Z()) {
        var acc = it.next__O();
        while (it.hasNext__Z()) {
          var x0 = acc;
          var x1$1 = it.next__O();
          acc = ord.min__O__O__O(x0, x1$1);
        }
        return acc;
      } else {
        throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.min");
      }
      break;
    }
    case 0: {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.min");
      break;
    }
    default: {
      return $thiz.reduceLeft__F2__O(new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$2$2, y$2$2) => ord.min__O__O__O(x$2$2, y$2$2))));
    }
  }
}
export { $f_sc_IterableOnceOps__min__s_math_Ordering__O as $f_sc_IterableOnceOps__min__s_math_Ordering__O };
function $f_sc_IterableOnceOps__max__s_math_Ordering__O($thiz, ord) {
  var x1 = $thiz.knownSize__I();
  switch (x1) {
    case (-1): {
      var it = $thiz.iterator__sc_Iterator();
      if (it.hasNext__Z()) {
        var acc = it.next__O();
        while (it.hasNext__Z()) {
          var x0 = acc;
          var x1$1 = it.next__O();
          acc = ord.max__O__O__O(x0, x1$1);
        }
        return acc;
      } else {
        throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max");
      }
      break;
    }
    case 0: {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.max");
      break;
    }
    default: {
      return $thiz.reduceLeft__F2__O(new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$2$2, y$2$2) => ord.max__O__O__O(x$2$2, y$2$2))));
    }
  }
}
export { $f_sc_IterableOnceOps__max__s_math_Ordering__O as $f_sc_IterableOnceOps__max__s_math_Ordering__O };
function $f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O($thiz, f, ord) {
  var x1 = $thiz.knownSize__I();
  if ((x1 === 0)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.maxBy");
  } else {
    return $thiz.foldLeft__O__F2__O(new $c_sc_IterableOnceOps$Maximized($thiz, "maxBy", f, new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$2$2, y$2$2) => ord.gt__O__O__Z(x$2$2, y$2$2)))), new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((m$2$2, a$2$2) => m$2$2.apply__sc_IterableOnceOps$Maximized__O__sc_IterableOnceOps$Maximized(m$2$2, a$2$2)))).result__O();
  }
}
export { $f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O as $f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O };
function $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option($thiz, pf) {
  var sentinel = new $c_sc_IterableOnceOps$$anon$1($thiz);
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var x = pf.applyOrElse__O__F1__O(it.next__O(), sentinel);
    if ((x !== sentinel)) {
      return new $c_s_Some(x);
    }
  }
  return $m_s_None$();
}
export { $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option as $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option };
function $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, start, sep, end) {
  if (($thiz.knownSize__I() === 0)) {
    return (("" + start) + end);
  } else {
    var this$1 = $thiz.addString__scm_StringBuilder__T__T__T__scm_StringBuilder($ct_scm_StringBuilder__(new $c_scm_StringBuilder()), start, sep, end);
    return this$1.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
}
export { $f_sc_IterableOnceOps__mkString__T__T__T__T as $f_sc_IterableOnceOps__mkString__T__T__T__T };
function $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, b, start, sep, end) {
  var jsb = b.scm_StringBuilder__f_underlying;
  if ((start.length !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  }
  var it = $thiz.iterator__sc_Iterator();
  if (it.hasNext__Z()) {
    var obj = it.next__O();
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    while (it.hasNext__Z()) {
      if ((sep.length !== 0)) {
        jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      }
      var obj$1 = it.next__O();
      jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
    }
  }
  if ((end.length !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  }
  return b;
}
export { $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder as $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder };
function $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O($thiz, evidence$2) {
  if (($thiz.knownSize__I() >= 0)) {
    var destination = evidence$2.newArray__I__O($thiz.knownSize__I());
    $thiz.copyToArray__O__I__I__I(destination, 0, 2147483647);
    return destination;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$2.runtimeClass__jl_Class();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var it = $thiz.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.data.zero : elem));
      jsElems.push(unboxedElem);
    }
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return elemRuntimeClass.data.getArrayOf().wrapArray(jsElems);
  }
}
export { $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O as $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O };
function $f_sc_IterableOnceOps__reversed__sc_Iterable($thiz) {
  var xs = $m_sci_Nil$();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var rassoc$1 = it.next__O();
    var this$1 = xs;
    xs = new $c_sci_$colon$colon(rassoc$1, this$1);
  }
  return xs;
}
export { $f_sc_IterableOnceOps__reversed__sc_Iterable as $f_sc_IterableOnceOps__reversed__sc_Iterable };
function $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O($thiz, at, end, acc, op$1, seq$1) {
  while (true) {
    if ((at === end)) {
      return acc;
    } else {
      var temp$at = ((1 + at) | 0);
      var temp$acc = op$1.apply__O__O__O(acc, seq$1.apply__I__O(at));
      at = temp$at;
      acc = temp$acc;
    }
  }
}
export { $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O as $p_sc_IterableOnceOps__loop$1__I__I__O__F2__sc_IndexedSeq__O };
/** @constructor */
function $c_sc_Iterator$ConcatIteratorCell(head, tail) {
  this.sc_Iterator$ConcatIteratorCell__f_head = null;
  this.sc_Iterator$ConcatIteratorCell__f_tail = null;
  this.sc_Iterator$ConcatIteratorCell__f_head = head;
  this.sc_Iterator$ConcatIteratorCell__f_tail = tail;
}
export { $c_sc_Iterator$ConcatIteratorCell as $c_sc_Iterator$ConcatIteratorCell };
$c_sc_Iterator$ConcatIteratorCell.prototype = new $h_O();
$c_sc_Iterator$ConcatIteratorCell.prototype.constructor = $c_sc_Iterator$ConcatIteratorCell;
/** @constructor */
function $h_sc_Iterator$ConcatIteratorCell() {
}
export { $h_sc_Iterator$ConcatIteratorCell as $h_sc_Iterator$ConcatIteratorCell };
$h_sc_Iterator$ConcatIteratorCell.prototype = $c_sc_Iterator$ConcatIteratorCell.prototype;
$c_sc_Iterator$ConcatIteratorCell.prototype.headIterator__sc_Iterator = (function() {
  return this.sc_Iterator$ConcatIteratorCell__f_head.apply__O().iterator__sc_Iterator();
});
var $d_sc_Iterator$ConcatIteratorCell = new $TypeData().initClass($c_sc_Iterator$ConcatIteratorCell, "scala.collection.Iterator$ConcatIteratorCell", ({
  sc_Iterator$ConcatIteratorCell: 1
}));
export { $d_sc_Iterator$ConcatIteratorCell as $d_sc_Iterator$ConcatIteratorCell };
function $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps($thiz) {
  if ((!$thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0)) {
    $thiz.sc_LinearSeqIterator$LazyCell__f_v = $thiz.sc_LinearSeqIterator$LazyCell__f_st.apply__O();
    $thiz.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = true;
  }
  $thiz.sc_LinearSeqIterator$LazyCell__f_st = null;
  return $thiz.sc_LinearSeqIterator$LazyCell__f_v;
}
export { $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps as $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps };
/** @constructor */
function $c_sc_LinearSeqIterator$LazyCell(outer, st) {
  this.sc_LinearSeqIterator$LazyCell__f_v = null;
  this.sc_LinearSeqIterator$LazyCell__f_st = null;
  this.sc_LinearSeqIterator$LazyCell__f_bitmap$0 = false;
  this.sc_LinearSeqIterator$LazyCell__f_st = st;
}
export { $c_sc_LinearSeqIterator$LazyCell as $c_sc_LinearSeqIterator$LazyCell };
$c_sc_LinearSeqIterator$LazyCell.prototype = new $h_O();
$c_sc_LinearSeqIterator$LazyCell.prototype.constructor = $c_sc_LinearSeqIterator$LazyCell;
/** @constructor */
function $h_sc_LinearSeqIterator$LazyCell() {
}
export { $h_sc_LinearSeqIterator$LazyCell as $h_sc_LinearSeqIterator$LazyCell };
$h_sc_LinearSeqIterator$LazyCell.prototype = $c_sc_LinearSeqIterator$LazyCell.prototype;
$c_sc_LinearSeqIterator$LazyCell.prototype.v__sc_LinearSeqOps = (function() {
  return ((!this.sc_LinearSeqIterator$LazyCell__f_bitmap$0) ? $p_sc_LinearSeqIterator$LazyCell__v$lzycompute__sc_LinearSeqOps(this) : this.sc_LinearSeqIterator$LazyCell__f_v);
});
var $d_sc_LinearSeqIterator$LazyCell = new $TypeData().initClass($c_sc_LinearSeqIterator$LazyCell, "scala.collection.LinearSeqIterator$LazyCell", ({
  sc_LinearSeqIterator$LazyCell: 1
}));
export { $d_sc_LinearSeqIterator$LazyCell as $d_sc_LinearSeqIterator$LazyCell };
/** @constructor */
function $c_sc_StringOps$() {
  this.sc_StringOps$__f_fallback = null;
  $n_sc_StringOps$ = this;
  this.sc_StringOps$__f_fallback = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2$2) => $m_sc_StringOps$().sc_StringOps$__f_fallback));
}
export { $c_sc_StringOps$ as $c_sc_StringOps$ };
$c_sc_StringOps$.prototype = new $h_O();
$c_sc_StringOps$.prototype.constructor = $c_sc_StringOps$;
/** @constructor */
function $h_sc_StringOps$() {
}
export { $h_sc_StringOps$ as $h_sc_StringOps$ };
$h_sc_StringOps$.prototype = $c_sc_StringOps$.prototype;
$c_sc_StringOps$.prototype.contains$extension__T__C__Z = (function(this$, elem) {
  return ($f_T__indexOf__I__I(this$, elem) >= 0);
});
$c_sc_StringOps$.prototype.slice$extension__T__I__I__T = (function(this$, from, until) {
  var start = ((from > 0) ? from : 0);
  var that = this$.length;
  var end = ((until < that) ? until : that);
  return ((start >= end) ? "" : this$.substring(start, end));
});
$c_sc_StringOps$.prototype.$times$extension__T__I__T = (function(this$, n) {
  if ((n <= 0)) {
    return "";
  } else {
    var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), Math.imul(this$.length, n));
    var i = 0;
    while ((i < n)) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + this$);
      i = ((1 + i) | 0);
    }
    return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
});
$c_sc_StringOps$.prototype.stripPrefix$extension__T__T__T = (function(this$, prefix) {
  if ((!(!this$.startsWith(prefix)))) {
    var beginIndex = prefix.length;
    return this$.substring(beginIndex);
  } else {
    return this$;
  }
});
$c_sc_StringOps$.prototype.stripSuffix$extension__T__T__T = (function(this$, suffix) {
  if ((!(!this$.endsWith(suffix)))) {
    var endIndex = ((this$.length - suffix.length) | 0);
    return this$.substring(0, endIndex);
  } else {
    return this$;
  }
});
$c_sc_StringOps$.prototype.stripMargin$extension__T__C__T = (function(this$, marginChar) {
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), this$.length);
  var this$3 = new $c_sc_StringOps$$anon$1(this$, false);
  while ((this$3.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this$3.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    var x0 = this$3.next__T();
    var len = x0.length;
    var index = 0;
    while (true) {
      if ((index < len)) {
        var index$1 = index;
        var $x_1 = (x0.charCodeAt(index$1) <= 32);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        index = ((1 + index) | 0);
      } else {
        break;
      }
    }
    if ((index < len)) {
      var index$2 = index;
      var $x_2 = (x0.charCodeAt(index$2) === marginChar);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var beginIndex = ((1 + index) | 0);
      var stripped = x0.substring(beginIndex);
    } else {
      var stripped = x0;
    }
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + stripped);
  }
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sc_StringOps$.prototype.escape$extension__T__C__T = (function(this$, ch) {
  return (((((ch >= 97) && (ch <= 122)) || ((ch >= 65) && (ch <= 90))) || ((ch >= 48) && (ch <= 57))) ? ("" + $cToS(ch)) : ("\\" + $cToS(ch)));
});
$c_sc_StringOps$.prototype.split$extension__T__C__AT = (function(this$, separator) {
  var regex = $m_sc_StringOps$().escape$extension__T__C__T(this$, separator);
  return $f_T__split__T__I__AT(this$, regex, 0);
});
$c_sc_StringOps$.prototype.toBooleanImpl$extension__T__T__Z = (function(this$, s) {
  if ((s === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "For input string: \"null\"");
  } else {
    _return: {
      var len = s.length;
      if ((len === 4)) {
        var i = 0;
        while ((i !== len)) {
          var index = i;
          var c = s.charCodeAt(index);
          var $x_2 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
          var index$1 = i;
          var c$1 = "true".charCodeAt(index$1);
          if (($x_2 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
            var $x_1 = false;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      return true;
    } else {
      _return$1: {
        var len$1 = s.length;
        if ((len$1 === 5)) {
          var i$1 = 0;
          while ((i$1 !== len$1)) {
            var index$2 = i$1;
            var c$2 = s.charCodeAt(index$2);
            var $x_4 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$2));
            var index$3 = i$1;
            var c$3 = "false".charCodeAt(index$3);
            if (($x_4 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$3)))) {
              var $x_3 = false;
              break _return$1;
            }
            i$1 = ((1 + i$1) | 0);
          }
          var $x_3 = true;
        } else {
          var $x_3 = false;
        }
      }
      if ($x_3) {
        return false;
      } else {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("For input string: \"" + s) + "\""));
      }
    }
  }
});
$c_sc_StringOps$.prototype.unwrapArg$extension__T__O__O = (function(this$, arg) {
  return ((arg instanceof $c_s_math_ScalaNumber) ? arg.underlying__O() : arg);
});
$c_sc_StringOps$.prototype.format$extension__T__sci_Seq__T = (function(this$, args) {
  var args$1 = args.map__F1__O(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((arg$2$2) => $m_sc_StringOps$().unwrapArg$extension__T__O__O(this$, arg$2$2)))).toArray__s_reflect_ClassTag__O($m_s_reflect_ManifestFactory$ObjectManifest$());
  return $m_jl_String$().format__T__AO__T(this$, args$1);
});
$c_sc_StringOps$.prototype.head$extension__T__C = (function(this$) {
  if ((this$ === "")) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty String");
  } else {
    return this$.charCodeAt(0);
  }
});
$c_sc_StringOps$.prototype.headOption$extension__T__s_Option = (function(this$) {
  return ((this$ === "") ? $m_s_None$() : new $c_s_Some($bC(this$.charCodeAt(0))));
});
$c_sc_StringOps$.prototype.reverse$extension__T__T = (function(this$) {
  return $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), this$).reverse__jl_StringBuilder().jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sc_StringOps$.prototype.tail$extension__T__T = (function(this$) {
  if ((this$ === "")) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty String");
  } else {
    return $m_sc_StringOps$().slice$extension__T__I__I__T(this$, 1, this$.length);
  }
});
$c_sc_StringOps$.prototype.init$extension__T__T = (function(this$) {
  if ((this$ === "")) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "init of empty String");
  } else {
    return $m_sc_StringOps$().slice$extension__T__I__I__T(this$, 0, (((-1) + this$.length) | 0));
  }
});
$c_sc_StringOps$.prototype.take$extension__T__I__T = (function(this$, n) {
  var $x_1 = $m_sc_StringOps$();
  var y = this$.length;
  return $x_1.slice$extension__T__I__I__T(this$, 0, ((n < y) ? n : y));
});
$c_sc_StringOps$.prototype.drop$extension__T__I__T = (function(this$, n) {
  var $x_1 = $m_sc_StringOps$();
  var y = this$.length;
  return $x_1.slice$extension__T__I__I__T(this$, ((n < y) ? n : y), this$.length);
});
$c_sc_StringOps$.prototype.takeRight$extension__T__I__T = (function(this$, n) {
  return $m_sc_StringOps$().drop$extension__T__I__T(this$, ((this$.length - ((n > 0) ? n : 0)) | 0));
});
$c_sc_StringOps$.prototype.dropRight$extension__T__I__T = (function(this$, n) {
  return $m_sc_StringOps$().take$extension__T__I__T(this$, ((this$.length - ((n > 0) ? n : 0)) | 0));
});
$c_sc_StringOps$.prototype.splitAt$extension__T__I__T2 = (function(this$, n) {
  return $ct_T2__O__O__(new $c_T2(), $m_sc_StringOps$().take$extension__T__I__T(this$, n), $m_sc_StringOps$().drop$extension__T__I__T(this$, n));
});
var $d_sc_StringOps$ = new $TypeData().initClass($c_sc_StringOps$, "scala.collection.StringOps$", ({
  sc_StringOps$: 1
}));
export { $d_sc_StringOps$ as $d_sc_StringOps$ };
var $n_sc_StringOps$;
function $m_sc_StringOps$() {
  if ((!$n_sc_StringOps$)) {
    $n_sc_StringOps$ = new $c_sc_StringOps$();
  }
  return $n_sc_StringOps$;
}
export { $m_sc_StringOps$ as $m_sc_StringOps$ };
function $p_sc_StringParsers$__rec$1__I__I__I__I__Z__T__s_Option($thiz, i, agg, min$1, len$1, isPositive$1, from$1) {
  while (true) {
    if ((agg < min$1)) {
      return $m_s_None$();
    } else if ((i === len$1)) {
      return ((!isPositive$1) ? new $c_s_Some(agg) : ((agg === min$1) ? $m_s_None$() : new $c_s_Some(((-agg) | 0))));
    } else {
      var index = i;
      var ch = from$1.charCodeAt(index);
      var this$1 = $m_jl_Character$();
      var codePoint = ch;
      var digit = this$1.digitWithValidRadix__I__I__I(codePoint, 10);
      if ((digit === (-1))) {
        return $m_s_None$();
      } else {
        var temp$i = ((1 + i) | 0);
        var temp$agg = ((Math.imul(10, agg) - digit) | 0);
        i = temp$i;
        agg = temp$agg;
      }
    }
  }
}
export { $p_sc_StringParsers$__rec$1__I__I__I__I__Z__T__s_Option as $p_sc_StringParsers$__rec$1__I__I__I__I__Z__T__s_Option };
function $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option($thiz, i, agg, isPositive, len$2, from$2) {
  while (true) {
    if ((i === len$2)) {
      return ((!isPositive) ? new $c_s_Some(agg) : ((agg === (-2147483648)) ? $m_s_None$() : new $c_s_Some(((-agg) | 0))));
    } else if ((agg < (-214748364))) {
      return $m_s_None$();
    } else {
      var index = i;
      var ch = from$2.charCodeAt(index);
      var this$1 = $m_jl_Character$();
      var codePoint = ch;
      var digit = this$1.digitWithValidRadix__I__I__I(codePoint, 10);
      if (((digit === (-1)) || ((agg === (-214748364)) && (digit === 9)))) {
        return $m_s_None$();
      } else {
        var temp$i = ((1 + i) | 0);
        var temp$agg = ((Math.imul(10, agg) - digit) | 0);
        i = temp$i;
        agg = temp$agg;
      }
    }
  }
}
export { $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option as $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option };
function $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option($thiz, i, agg, isPositive, len$3, from$3) {
  while (true) {
    if ((i === len$3)) {
      if (isPositive) {
        var a = agg;
        var $x_1 = ((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === (-2147483648)));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return $m_s_None$();
      } else if (isPositive) {
        var b = agg;
        var blo = b.RTLong__f_lo;
        var lo = ((-blo) | 0);
        var hi = ((((-b.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
        return new $c_s_Some(new $c_RTLong(lo, hi));
      } else {
        return new $c_s_Some(agg);
      }
    } else {
      var a$1 = agg;
      var ahi = a$1.RTLong__f_hi;
      if (((ahi === (-214748365)) ? ((a$1.RTLong__f_lo >>> 0) < 858993460) : (ahi < (-214748365)))) {
        return $m_s_None$();
      } else {
        var index = i;
        var ch = from$3.charCodeAt(index);
        var this$4 = $m_jl_Character$();
        var codePoint = ch;
        var digit = this$4.digitWithValidRadix__I__I__I(codePoint, 10);
        if ((digit === (-1))) {
          var $x_2 = true;
        } else {
          var a$2 = agg;
          if (((a$2.RTLong__f_lo === 858993460) && (a$2.RTLong__f_hi === (-214748365)))) {
            var $x_2 = (digit === 9);
          } else {
            var $x_2 = false;
          }
        }
        if ($x_2) {
          return $m_s_None$();
        } else {
          var temp$i = ((1 + i) | 0);
          var b$1 = agg;
          var blo$1 = b$1.RTLong__f_lo;
          var b0 = (65535 & blo$1);
          var b1 = ((blo$1 >>> 16) | 0);
          var a0b0 = Math.imul(10, b0);
          var a0b1 = Math.imul(10, b1);
          var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi$1 = ((Math.imul(10, b$1.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
          var hi$2 = (digit >> 31);
          var lo$2 = ((lo$1 - digit) | 0);
          var hi$3 = ((((hi$1 - hi$2) | 0) + ((((~lo$1) & digit) | ((~(lo$1 ^ digit)) & lo$2)) >> 31)) | 0);
          i = temp$i;
          agg = new $c_RTLong(lo$2, hi$3);
        }
      }
    }
  }
}
export { $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option as $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option };
/** @constructor */
function $c_sc_StringParsers$() {
}
export { $c_sc_StringParsers$ as $c_sc_StringParsers$ };
$c_sc_StringParsers$.prototype = new $h_O();
$c_sc_StringParsers$.prototype.constructor = $c_sc_StringParsers$;
/** @constructor */
function $h_sc_StringParsers$() {
}
export { $h_sc_StringParsers$ as $h_sc_StringParsers$ };
$h_sc_StringParsers$.prototype = $c_sc_StringParsers$.prototype;
$c_sc_StringParsers$.prototype.parseShort__T__s_Option = (function(from) {
  var len = from.length;
  if ((len === 0)) {
    return $m_s_None$();
  } else {
    var first = from.charCodeAt(0);
    var this$1 = $m_jl_Character$();
    var codePoint = first;
    var v = this$1.digitWithValidRadix__I__I__I(codePoint, 10);
    if ((len === 1)) {
      return ((v > (-1)) ? new $c_s_Some(((v << 16) >> 16)) : $m_s_None$());
    } else if ((v > (-1))) {
      var agg = ((-v) | 0);
      var this$2 = $p_sc_StringParsers$__rec$1__I__I__I__I__Z__T__s_Option(this, 1, agg, (-32768), len, true, from);
      if (this$2.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var x0 = this$2.get__O();
        var x$4$2 = (x0 | 0);
        return new $c_s_Some(((x$4$2 << 16) >> 16));
      }
    } else if ((first === 43)) {
      var this$3 = $p_sc_StringParsers$__rec$1__I__I__I__I__Z__T__s_Option(this, 1, 0, (-32768), len, true, from);
      if (this$3.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var x0$1 = this$3.get__O();
        var x$5$2 = (x0$1 | 0);
        return new $c_s_Some(((x$5$2 << 16) >> 16));
      }
    } else if ((first === 45)) {
      var this$4 = $p_sc_StringParsers$__rec$1__I__I__I__I__Z__T__s_Option(this, 1, 0, (-32768), len, false, from);
      if (this$4.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var x0$2 = this$4.get__O();
        var x$6$2 = (x0$2 | 0);
        return new $c_s_Some(((x$6$2 << 16) >> 16));
      }
    } else {
      return $m_s_None$();
    }
  }
});
$c_sc_StringParsers$.prototype.parseInt__T__s_Option = (function(from) {
  var len = from.length;
  if ((len === 0)) {
    return $m_s_None$();
  } else {
    var first = from.charCodeAt(0);
    var this$1 = $m_jl_Character$();
    var codePoint = first;
    var v = this$1.digitWithValidRadix__I__I__I(codePoint, 10);
    return ((len === 1) ? ((v > (-1)) ? new $c_s_Some(v) : $m_s_None$()) : ((v > (-1)) ? $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option(this, 1, ((-v) | 0), true, len, from) : ((first === 43) ? $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option(this, 1, 0, true, len, from) : ((first === 45) ? $p_sc_StringParsers$__step$1__I__I__Z__I__T__s_Option(this, 1, 0, false, len, from) : $m_s_None$()))));
  }
});
$c_sc_StringParsers$.prototype.parseLong__T__s_Option = (function(from) {
  var len = from.length;
  if ((len === 0)) {
    return $m_s_None$();
  } else {
    var first = from.charCodeAt(0);
    var this$1 = $m_jl_Character$();
    var codePoint = first;
    var value = this$1.digitWithValidRadix__I__I__I(codePoint, 10);
    var hi = (value >> 31);
    if ((len === 1)) {
      return ((hi > (-1)) ? new $c_s_Some(new $c_RTLong(value, hi)) : $m_s_None$());
    } else if ((hi > (-1))) {
      var lo = ((-value) | 0);
      var hi$1 = ((((-hi) | 0) + ((value | lo) >> 31)) | 0);
      return $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, new $c_RTLong(lo, hi$1), true, len, from);
    } else {
      return ((first === 43) ? $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, $L0, true, len, from) : ((first === 45) ? $p_sc_StringParsers$__step$2__I__J__Z__I__T__s_Option(this, 1, $L0, false, len, from) : $m_s_None$()));
    }
  }
});
var $d_sc_StringParsers$ = new $TypeData().initClass($c_sc_StringParsers$, "scala.collection.StringParsers$", ({
  sc_StringParsers$: 1
}));
export { $d_sc_StringParsers$ as $d_sc_StringParsers$ };
var $n_sc_StringParsers$;
function $m_sc_StringParsers$() {
  if ((!$n_sc_StringParsers$)) {
    $n_sc_StringParsers$ = new $c_sc_StringParsers$();
  }
  return $n_sc_StringParsers$;
}
export { $m_sc_StringParsers$ as $m_sc_StringParsers$ };
function $f_sc_convert_AsJavaConverters__asJava__sc_Set__ju_Set($thiz, s) {
  return ((s === null) ? null : ((s instanceof $c_sc_convert_JavaCollectionWrappers$JSetWrapper) ? s.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying : new $c_sc_convert_JavaCollectionWrappers$SetWrapper(s)));
}
export { $f_sc_convert_AsJavaConverters__asJava__sc_Set__ju_Set as $f_sc_convert_AsJavaConverters__asJava__sc_Set__ju_Set };
/** @constructor */
function $c_sc_convert_AsJavaExtensions$SetHasAsJava(outer, s) {
  this.sc_convert_AsJavaExtensions$SetHasAsJava__f_s = null;
  this.sc_convert_AsJavaExtensions$SetHasAsJava__f_s = s;
}
export { $c_sc_convert_AsJavaExtensions$SetHasAsJava as $c_sc_convert_AsJavaExtensions$SetHasAsJava };
$c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype = new $h_O();
$c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype.constructor = $c_sc_convert_AsJavaExtensions$SetHasAsJava;
/** @constructor */
function $h_sc_convert_AsJavaExtensions$SetHasAsJava() {
}
export { $h_sc_convert_AsJavaExtensions$SetHasAsJava as $h_sc_convert_AsJavaExtensions$SetHasAsJava };
$h_sc_convert_AsJavaExtensions$SetHasAsJava.prototype = $c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype;
$c_sc_convert_AsJavaExtensions$SetHasAsJava.prototype.asJava__ju_Set = (function() {
  var this$1 = $m_s_jdk_javaapi_CollectionConverters$();
  var s = this.sc_convert_AsJavaExtensions$SetHasAsJava__f_s;
  return $f_sc_convert_AsJavaConverters__asJava__sc_Set__ju_Set(this$1, s);
});
var $d_sc_convert_AsJavaExtensions$SetHasAsJava = new $TypeData().initClass($c_sc_convert_AsJavaExtensions$SetHasAsJava, "scala.collection.convert.AsJavaExtensions$SetHasAsJava", ({
  sc_convert_AsJavaExtensions$SetHasAsJava: 1
}));
export { $d_sc_convert_AsJavaExtensions$SetHasAsJava as $d_sc_convert_AsJavaExtensions$SetHasAsJava };
function $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator($thiz, i) {
  return ((i === null) ? null : (false ? i.underlying__sc_Iterator() : new $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper(i)));
}
export { $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator as $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator };
function $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set($thiz, s) {
  return ((s === null) ? null : (false ? s.underlying__scm_Set() : new $c_sc_convert_JavaCollectionWrappers$JSetWrapper(s)));
}
export { $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set as $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set };
/** @constructor */
function $c_sc_convert_AsScalaExtensions$IteratorHasAsScala(outer, i) {
  this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i = null;
  this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i = i;
}
export { $c_sc_convert_AsScalaExtensions$IteratorHasAsScala as $c_sc_convert_AsScalaExtensions$IteratorHasAsScala };
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype = new $h_O();
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype.constructor = $c_sc_convert_AsScalaExtensions$IteratorHasAsScala;
/** @constructor */
function $h_sc_convert_AsScalaExtensions$IteratorHasAsScala() {
}
export { $h_sc_convert_AsScalaExtensions$IteratorHasAsScala as $h_sc_convert_AsScalaExtensions$IteratorHasAsScala };
$h_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype = $c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype;
$c_sc_convert_AsScalaExtensions$IteratorHasAsScala.prototype.asScala__sc_Iterator = (function() {
  var this$1 = $m_s_jdk_javaapi_CollectionConverters$();
  var i = this.sc_convert_AsScalaExtensions$IteratorHasAsScala__f_i;
  return $f_sc_convert_AsScalaConverters__asScala__ju_Iterator__sc_Iterator(this$1, i);
});
var $d_sc_convert_AsScalaExtensions$IteratorHasAsScala = new $TypeData().initClass($c_sc_convert_AsScalaExtensions$IteratorHasAsScala, "scala.collection.convert.AsScalaExtensions$IteratorHasAsScala", ({
  sc_convert_AsScalaExtensions$IteratorHasAsScala: 1
}));
export { $d_sc_convert_AsScalaExtensions$IteratorHasAsScala as $d_sc_convert_AsScalaExtensions$IteratorHasAsScala };
/** @constructor */
function $c_sc_convert_AsScalaExtensions$SetHasAsScala(outer, s) {
  this.sc_convert_AsScalaExtensions$SetHasAsScala__f_s = null;
  this.sc_convert_AsScalaExtensions$SetHasAsScala__f_s = s;
}
export { $c_sc_convert_AsScalaExtensions$SetHasAsScala as $c_sc_convert_AsScalaExtensions$SetHasAsScala };
$c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype = new $h_O();
$c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype.constructor = $c_sc_convert_AsScalaExtensions$SetHasAsScala;
/** @constructor */
function $h_sc_convert_AsScalaExtensions$SetHasAsScala() {
}
export { $h_sc_convert_AsScalaExtensions$SetHasAsScala as $h_sc_convert_AsScalaExtensions$SetHasAsScala };
$h_sc_convert_AsScalaExtensions$SetHasAsScala.prototype = $c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype;
$c_sc_convert_AsScalaExtensions$SetHasAsScala.prototype.asScala__scm_Set = (function() {
  var this$1 = $m_s_jdk_javaapi_CollectionConverters$();
  var s = this.sc_convert_AsScalaExtensions$SetHasAsScala__f_s;
  return $f_sc_convert_AsScalaConverters__asScala__ju_Set__scm_Set(this$1, s);
});
var $d_sc_convert_AsScalaExtensions$SetHasAsScala = new $TypeData().initClass($c_sc_convert_AsScalaExtensions$SetHasAsScala, "scala.collection.convert.AsScalaExtensions$SetHasAsScala", ({
  sc_convert_AsScalaExtensions$SetHasAsScala: 1
}));
export { $d_sc_convert_AsScalaExtensions$SetHasAsScala as $d_sc_convert_AsScalaExtensions$SetHasAsScala };
/** @constructor */
function $c_scg_CommonErrors$() {
}
export { $c_scg_CommonErrors$ as $c_scg_CommonErrors$ };
$c_scg_CommonErrors$.prototype = new $h_O();
$c_scg_CommonErrors$.prototype.constructor = $c_scg_CommonErrors$;
/** @constructor */
function $h_scg_CommonErrors$() {
}
export { $h_scg_CommonErrors$ as $h_scg_CommonErrors$ };
$h_scg_CommonErrors$.prototype = $c_scg_CommonErrors$.prototype;
$c_scg_CommonErrors$.prototype.indexOutOfBounds__I__I__jl_IndexOutOfBoundsException = (function(index, max) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((index + " is out of bounds (min 0, max ") + max) + ")"));
});
$c_scg_CommonErrors$.prototype.indexOutOfBounds__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (min 0, max unknown)"));
});
var $d_scg_CommonErrors$ = new $TypeData().initClass($c_scg_CommonErrors$, "scala.collection.generic.CommonErrors$", ({
  scg_CommonErrors$: 1
}));
export { $d_scg_CommonErrors$ as $d_scg_CommonErrors$ };
var $n_scg_CommonErrors$;
function $m_scg_CommonErrors$() {
  if ((!$n_scg_CommonErrors$)) {
    $n_scg_CommonErrors$ = new $c_scg_CommonErrors$();
  }
  return $n_scg_CommonErrors$;
}
export { $m_scg_CommonErrors$ as $m_scg_CommonErrors$ };
function $ps_sci_IndexedSeqDefaults$__liftedTree1$1__I() {
  try {
    var x = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.IndexedSeq.defaultApplyPreferredMaxLength", "64");
    var this$4 = $m_jl_Integer$();
    return this$4.java$lang$Integer$$parseIntImpl__T__I__I__I(x, 10, 214748364);
  } catch (e) {
    if (false) {
      return 64;
    } else {
      throw e;
    }
  }
}
export { $ps_sci_IndexedSeqDefaults$__liftedTree1$1__I as $ps_sci_IndexedSeqDefaults$__liftedTree1$1__I };
/** @constructor */
function $c_sci_IndexedSeqDefaults$() {
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = 0;
  $n_sci_IndexedSeqDefaults$ = this;
  this.sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength = $ps_sci_IndexedSeqDefaults$__liftedTree1$1__I();
}
export { $c_sci_IndexedSeqDefaults$ as $c_sci_IndexedSeqDefaults$ };
$c_sci_IndexedSeqDefaults$.prototype = new $h_O();
$c_sci_IndexedSeqDefaults$.prototype.constructor = $c_sci_IndexedSeqDefaults$;
/** @constructor */
function $h_sci_IndexedSeqDefaults$() {
}
export { $h_sci_IndexedSeqDefaults$ as $h_sci_IndexedSeqDefaults$ };
$h_sci_IndexedSeqDefaults$.prototype = $c_sci_IndexedSeqDefaults$.prototype;
var $d_sci_IndexedSeqDefaults$ = new $TypeData().initClass($c_sci_IndexedSeqDefaults$, "scala.collection.immutable.IndexedSeqDefaults$", ({
  sci_IndexedSeqDefaults$: 1
}));
export { $d_sci_IndexedSeqDefaults$ as $d_sci_IndexedSeqDefaults$ };
var $n_sci_IndexedSeqDefaults$;
function $m_sci_IndexedSeqDefaults$() {
  if ((!$n_sci_IndexedSeqDefaults$)) {
    $n_sci_IndexedSeqDefaults$ = new $c_sci_IndexedSeqDefaults$();
  }
  return $n_sci_IndexedSeqDefaults$;
}
export { $m_sci_IndexedSeqDefaults$ as $m_sci_IndexedSeqDefaults$ };
/** @constructor */
function $c_sci_LazyList$EmptyMarker$() {
}
export { $c_sci_LazyList$EmptyMarker$ as $c_sci_LazyList$EmptyMarker$ };
$c_sci_LazyList$EmptyMarker$.prototype = new $h_O();
$c_sci_LazyList$EmptyMarker$.prototype.constructor = $c_sci_LazyList$EmptyMarker$;
/** @constructor */
function $h_sci_LazyList$EmptyMarker$() {
}
export { $h_sci_LazyList$EmptyMarker$ as $h_sci_LazyList$EmptyMarker$ };
$h_sci_LazyList$EmptyMarker$.prototype = $c_sci_LazyList$EmptyMarker$.prototype;
var $d_sci_LazyList$EmptyMarker$ = new $TypeData().initClass($c_sci_LazyList$EmptyMarker$, "scala.collection.immutable.LazyList$EmptyMarker$", ({
  sci_LazyList$EmptyMarker$: 1
}));
export { $d_sci_LazyList$EmptyMarker$ as $d_sci_LazyList$EmptyMarker$ };
var $n_sci_LazyList$EmptyMarker$;
function $m_sci_LazyList$EmptyMarker$() {
  if ((!$n_sci_LazyList$EmptyMarker$)) {
    $n_sci_LazyList$EmptyMarker$ = new $c_sci_LazyList$EmptyMarker$();
  }
  return $n_sci_LazyList$EmptyMarker$;
}
export { $m_sci_LazyList$EmptyMarker$ as $m_sci_LazyList$EmptyMarker$ };
/** @constructor */
function $c_sci_LazyList$LazyBuilder$DeferredState() {
  this.sci_LazyList$LazyBuilder$DeferredState__f__tail = null;
}
export { $c_sci_LazyList$LazyBuilder$DeferredState as $c_sci_LazyList$LazyBuilder$DeferredState };
$c_sci_LazyList$LazyBuilder$DeferredState.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.constructor = $c_sci_LazyList$LazyBuilder$DeferredState;
/** @constructor */
function $h_sci_LazyList$LazyBuilder$DeferredState() {
}
export { $h_sci_LazyList$LazyBuilder$DeferredState as $h_sci_LazyList$LazyBuilder$DeferredState };
$h_sci_LazyList$LazyBuilder$DeferredState.prototype = $c_sci_LazyList$LazyBuilder$DeferredState.prototype;
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.eval__sci_LazyList = (function() {
  var state = this.sci_LazyList$LazyBuilder$DeferredState__f__tail;
  if ((state === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "uninitialized");
  }
  return state.apply__O();
});
$c_sci_LazyList$LazyBuilder$DeferredState.prototype.init__F0__V = (function(state) {
  if ((this.sci_LazyList$LazyBuilder$DeferredState__f__tail !== null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "already initialized");
  }
  this.sci_LazyList$LazyBuilder$DeferredState__f__tail = state;
});
var $d_sci_LazyList$LazyBuilder$DeferredState = new $TypeData().initClass($c_sci_LazyList$LazyBuilder$DeferredState, "scala.collection.immutable.LazyList$LazyBuilder$DeferredState", ({
  sci_LazyList$LazyBuilder$DeferredState: 1
}));
export { $d_sci_LazyList$LazyBuilder$DeferredState as $d_sci_LazyList$LazyBuilder$DeferredState };
/** @constructor */
function $c_sci_LazyList$MidEvaluation$() {
}
export { $c_sci_LazyList$MidEvaluation$ as $c_sci_LazyList$MidEvaluation$ };
$c_sci_LazyList$MidEvaluation$.prototype = new $h_O();
$c_sci_LazyList$MidEvaluation$.prototype.constructor = $c_sci_LazyList$MidEvaluation$;
/** @constructor */
function $h_sci_LazyList$MidEvaluation$() {
}
export { $h_sci_LazyList$MidEvaluation$ as $h_sci_LazyList$MidEvaluation$ };
$h_sci_LazyList$MidEvaluation$.prototype = $c_sci_LazyList$MidEvaluation$.prototype;
var $d_sci_LazyList$MidEvaluation$ = new $TypeData().initClass($c_sci_LazyList$MidEvaluation$, "scala.collection.immutable.LazyList$MidEvaluation$", ({
  sci_LazyList$MidEvaluation$: 1
}));
export { $d_sci_LazyList$MidEvaluation$ as $d_sci_LazyList$MidEvaluation$ };
var $n_sci_LazyList$MidEvaluation$;
function $m_sci_LazyList$MidEvaluation$() {
  if ((!$n_sci_LazyList$MidEvaluation$)) {
    $n_sci_LazyList$MidEvaluation$ = new $c_sci_LazyList$MidEvaluation$();
  }
  return $n_sci_LazyList$MidEvaluation$;
}
export { $m_sci_LazyList$MidEvaluation$ as $m_sci_LazyList$MidEvaluation$ };
/** @constructor */
function $c_sci_LazyList$cons$() {
}
export { $c_sci_LazyList$cons$ as $c_sci_LazyList$cons$ };
$c_sci_LazyList$cons$.prototype = new $h_O();
$c_sci_LazyList$cons$.prototype.constructor = $c_sci_LazyList$cons$;
/** @constructor */
function $h_sci_LazyList$cons$() {
}
export { $h_sci_LazyList$cons$ as $h_sci_LazyList$cons$ };
$h_sci_LazyList$cons$.prototype = $c_sci_LazyList$cons$.prototype;
$c_sci_LazyList$cons$.prototype.apply__F0__F0__sci_LazyList = (function(hd, tl) {
  $m_sci_LazyList$();
  var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    $m_sci_LazyList$();
    var hd$1 = hd.apply__O();
    $m_sci_LazyList$();
    var tl$1 = $ct_sci_LazyList__O__(new $c_sci_LazyList(), tl);
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd$1, tl$1);
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
});
var $d_sci_LazyList$cons$ = new $TypeData().initClass($c_sci_LazyList$cons$, "scala.collection.immutable.LazyList$cons$", ({
  sci_LazyList$cons$: 1
}));
export { $d_sci_LazyList$cons$ as $d_sci_LazyList$cons$ };
var $n_sci_LazyList$cons$;
function $m_sci_LazyList$cons$() {
  if ((!$n_sci_LazyList$cons$)) {
    $n_sci_LazyList$cons$ = new $c_sci_LazyList$cons$();
  }
  return $n_sci_LazyList$cons$;
}
export { $m_sci_LazyList$cons$ as $m_sci_LazyList$cons$ };
/** @constructor */
function $c_sci_MapNode$() {
  this.sci_MapNode$__f_EmptyMapNode = null;
  $n_sci_MapNode$ = this;
  this.sci_MapNode$__f_EmptyMapNode = new $c_sci_BitmapIndexedMapNode(0, 0, new $ac_O(0), new $ac_I(0), 0, 0);
}
export { $c_sci_MapNode$ as $c_sci_MapNode$ };
$c_sci_MapNode$.prototype = new $h_O();
$c_sci_MapNode$.prototype.constructor = $c_sci_MapNode$;
/** @constructor */
function $h_sci_MapNode$() {
}
export { $h_sci_MapNode$ as $h_sci_MapNode$ };
$h_sci_MapNode$.prototype = $c_sci_MapNode$.prototype;
var $d_sci_MapNode$ = new $TypeData().initClass($c_sci_MapNode$, "scala.collection.immutable.MapNode$", ({
  sci_MapNode$: 1
}));
export { $d_sci_MapNode$ as $d_sci_MapNode$ };
var $n_sci_MapNode$;
function $m_sci_MapNode$() {
  if ((!$n_sci_MapNode$)) {
    $n_sci_MapNode$ = new $c_sci_MapNode$();
  }
  return $n_sci_MapNode$;
}
export { $m_sci_MapNode$ as $m_sci_MapNode$ };
function $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException($thiz, as, ix) {
  return $ct_jl_ArrayIndexOutOfBoundsException__T__(new $c_jl_ArrayIndexOutOfBoundsException(), ((ix + " is out of bounds (min 0, max ") + (((-1) + $m_jl_reflect_Array$().getLength__O__I(as)) | 0)));
}
export { $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException as $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException };
/** @constructor */
function $c_sci_Node() {
}
export { $c_sci_Node as $c_sci_Node };
$c_sci_Node.prototype = new $h_O();
$c_sci_Node.prototype.constructor = $c_sci_Node;
/** @constructor */
function $h_sci_Node() {
}
export { $h_sci_Node as $h_sci_Node };
$h_sci_Node.prototype = $c_sci_Node.prototype;
$c_sci_Node.prototype.removeElement__AI__I__AI = (function(as, ix) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  if ((ix > (((-1) + as.u.length) | 0))) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  var result = new $ac_I((((-1) + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  var srcPos = ((1 + ix) | 0);
  var length = (((-1) + ((as.u.length - ix) | 0)) | 0);
  as.copyTo(srcPos, result, ix, length);
  return result;
});
$c_sci_Node.prototype.insertElement__AI__I__I__AI = (function(as, ix, elem) {
  if ((ix < 0)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  if ((ix > as.u.length)) {
    throw $p_sci_Node__arrayIndexOutOfBounds__O__I__jl_ArrayIndexOutOfBoundsException(this, as, ix);
  }
  var result = new $ac_I(((1 + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  result.u[ix] = elem;
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  as.copyTo(ix, result, destPos, length);
  return result;
});
var $d_sci_Node = new $TypeData().initClass(0, "scala.collection.immutable.Node", ({
  sci_Node: 1
}));
export { $d_sci_Node as $d_sci_Node };
/** @constructor */
function $c_sci_Node$() {
  this.sci_Node$__f_MaxDepth = 0;
  $n_sci_Node$ = this;
  this.sci_Node$__f_MaxDepth = $doubleToInt((+Math.ceil(6.4)));
}
export { $c_sci_Node$ as $c_sci_Node$ };
$c_sci_Node$.prototype = new $h_O();
$c_sci_Node$.prototype.constructor = $c_sci_Node$;
/** @constructor */
function $h_sci_Node$() {
}
export { $h_sci_Node$ as $h_sci_Node$ };
$h_sci_Node$.prototype = $c_sci_Node$.prototype;
$c_sci_Node$.prototype.maskFrom__I__I__I = (function(hash, shift) {
  return (31 & ((hash >>> shift) | 0));
});
$c_sci_Node$.prototype.bitposFrom__I__I = (function(mask) {
  return (1 << mask);
});
$c_sci_Node$.prototype.indexFrom__I__I__I = (function(bitmap, bitpos) {
  var i = (bitmap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_Node$.prototype.indexFrom__I__I__I__I = (function(bitmap, mask, bitpos) {
  return ((bitmap === (-1)) ? mask : this.indexFrom__I__I__I(bitmap, bitpos));
});
var $d_sci_Node$ = new $TypeData().initClass($c_sci_Node$, "scala.collection.immutable.Node$", ({
  sci_Node$: 1
}));
export { $d_sci_Node$ as $d_sci_Node$ };
var $n_sci_Node$;
function $m_sci_Node$() {
  if ((!$n_sci_Node$)) {
    $n_sci_Node$ = new $c_sci_Node$();
  }
  return $n_sci_Node$;
}
export { $m_sci_Node$ as $m_sci_Node$ };
/** @constructor */
function $c_sci_SetNode$() {
  this.sci_SetNode$__f_EmptySetNode = null;
  $n_sci_SetNode$ = this;
  this.sci_SetNode$__f_EmptySetNode = new $c_sci_BitmapIndexedSetNode(0, 0, new $ac_O(0), new $ac_I(0), 0, 0);
}
export { $c_sci_SetNode$ as $c_sci_SetNode$ };
$c_sci_SetNode$.prototype = new $h_O();
$c_sci_SetNode$.prototype.constructor = $c_sci_SetNode$;
/** @constructor */
function $h_sci_SetNode$() {
}
export { $h_sci_SetNode$ as $h_sci_SetNode$ };
$h_sci_SetNode$.prototype = $c_sci_SetNode$.prototype;
var $d_sci_SetNode$ = new $TypeData().initClass($c_sci_SetNode$, "scala.collection.immutable.SetNode$", ({
  sci_SetNode$: 1
}));
export { $d_sci_SetNode$ as $d_sci_SetNode$ };
var $n_sci_SetNode$;
function $m_sci_SetNode$() {
  if ((!$n_sci_SetNode$)) {
    $n_sci_SetNode$ = new $c_sci_SetNode$();
  }
  return $n_sci_SetNode$;
}
export { $m_sci_SetNode$ as $m_sci_SetNode$ };
function $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, n, a, lo, hi) {
  while (true) {
    if ((n === 1)) {
      var a$1 = a;
      var start = lo;
      var end = hi;
      $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, 1, (((start === 0) && (end === a$1.u.length)) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, start, end)));
    } else {
      var bitsN = Math.imul(5, (((-1) + n) | 0));
      var widthN = (1 << bitsN);
      var loN = ((lo >>> bitsN) | 0);
      var hiN = ((hi >>> bitsN) | 0);
      var loRest = (lo & (((-1) + widthN) | 0));
      var hiRest = (hi & (((-1) + widthN) | 0));
      if ((loRest === 0)) {
        if ((hiRest === 0)) {
          var $x_1 = n;
          var a$2 = a;
          $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_1, (((loN === 0) && (hiN === a$2.u.length)) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, loN, hiN)));
        } else {
          if ((hiN > loN)) {
            var $x_2 = n;
            var a$3 = a;
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_2, (((loN === 0) && (hiN === a$3.u.length)) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, loN, hiN)));
          }
          var temp$n = (((-1) + n) | 0);
          var temp$a = a.u[hiN];
          n = temp$n;
          a = temp$a;
          lo = 0;
          hi = hiRest;
          continue;
        }
      } else if ((hiN === loN)) {
        var temp$n$2 = (((-1) + n) | 0);
        var temp$a$2 = a.u[loN];
        n = temp$n$2;
        a = temp$a$2;
        lo = loRest;
        hi = hiRest;
        continue;
      } else {
        $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V($thiz, (((-1) + n) | 0), a.u[loN], loRest, widthN);
        if ((hiRest === 0)) {
          if ((hiN > ((1 + loN) | 0))) {
            var $x_3 = n;
            var a$4 = a;
            var start$1 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_3, (((start$1 === 0) && (hiN === a$4.u.length)) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, start$1, hiN)));
          }
        } else {
          if ((hiN > ((1 + loN) | 0))) {
            var $x_4 = n;
            var a$5 = a;
            var start$2 = ((1 + loN) | 0);
            $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, $x_4, (((start$2 === 0) && (hiN === a$5.u.length)) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, start$2, hiN)));
          }
          var temp$n$3 = (((-1) + n) | 0);
          var temp$a$3 = a.u[hiN];
          n = temp$n$3;
          a = temp$a$3;
          lo = 0;
          hi = hiRest;
          continue;
        }
      }
    }
    return (void 0);
  }
}
export { $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V as $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V };
function $p_sci_VectorSliceBuilder__add__I__AO__V($thiz, n, a) {
  if ((n <= $thiz.sci_VectorSliceBuilder__f_maxDim)) {
    var idx = ((11 - n) | 0);
  } else {
    $thiz.sci_VectorSliceBuilder__f_maxDim = n;
    var idx = (((-1) + n) | 0);
  }
  $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[idx] = a;
}
export { $p_sci_VectorSliceBuilder__add__I__AO__V as $p_sci_VectorSliceBuilder__add__I__AO__V };
function $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, n) {
  if (($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[(((-1) + n) | 0)] === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[(((-1) + n) | 0)] = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[((11 - n) | 0)];
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[((11 - n) | 0)] = null;
    } else {
      $p_sci_VectorSliceBuilder__balancePrefix__I__V($thiz, ((1 + n) | 0));
      var $x_1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var preN1 = $x_1.u[(((-1) + n$1) | 0)];
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[(((-1) + n) | 0)] = preN1.u[0];
      if ((preN1.u.length === 1)) {
        var $x_2 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$2 = ((1 + n) | 0);
        $x_2.u[(((-1) + n$2) | 0)] = null;
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $x_4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $x_3 = ($x_4.u[((11 - n$3) | 0)] === null);
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n;
        }
      } else {
        var $x_5 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$4 = ((1 + n) | 0);
        var to = preN1.u.length;
        $x_5.u[(((-1) + n$4) | 0)] = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(preN1, 1, to);
      }
    }
  }
}
export { $p_sci_VectorSliceBuilder__balancePrefix__I__V as $p_sci_VectorSliceBuilder__balancePrefix__I__V };
function $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, n) {
  if (($thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[((11 - n) | 0)] === null)) {
    if ((n === $thiz.sci_VectorSliceBuilder__f_maxDim)) {
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[((11 - n) | 0)] = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[(((-1) + n) | 0)];
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[(((-1) + n) | 0)] = null;
    } else {
      $p_sci_VectorSliceBuilder__balanceSuffix__I__V($thiz, ((1 + n) | 0));
      var $x_1 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = ((1 + n) | 0);
      var sufN1 = $x_1.u[((11 - n$1) | 0)];
      $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[((11 - n) | 0)] = sufN1.u[(((-1) + sufN1.u.length) | 0)];
      if ((sufN1.u.length === 1)) {
        var $x_2 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$2 = ((1 + n) | 0);
        $x_2.u[((11 - n$2) | 0)] = null;
        if (($thiz.sci_VectorSliceBuilder__f_maxDim === ((1 + n) | 0))) {
          var $x_4 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = ((1 + n) | 0);
          var $x_3 = ($x_4.u[(((-1) + n$3) | 0)] === null);
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          $thiz.sci_VectorSliceBuilder__f_maxDim = n;
        }
      } else {
        var $x_5 = $thiz.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
        var n$4 = ((1 + n) | 0);
        var to = (((-1) + sufN1.u.length) | 0);
        $x_5.u[((11 - n$4) | 0)] = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(sufN1, 0, to);
      }
    }
  }
}
export { $p_sci_VectorSliceBuilder__balanceSuffix__I__V as $p_sci_VectorSliceBuilder__balanceSuffix__I__V };
/** @constructor */
function $c_sci_VectorSliceBuilder(lo, hi) {
  this.sci_VectorSliceBuilder__f_lo = 0;
  this.sci_VectorSliceBuilder__f_hi = 0;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = null;
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0;
  this.sci_VectorSliceBuilder__f_lo = lo;
  this.sci_VectorSliceBuilder__f_hi = hi;
  this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices = new ($d_O.getArrayOf().getArrayOf().constr)(11);
  this.sci_VectorSliceBuilder__f_len = 0;
  this.sci_VectorSliceBuilder__f_pos = 0;
  this.sci_VectorSliceBuilder__f_maxDim = 0;
}
export { $c_sci_VectorSliceBuilder as $c_sci_VectorSliceBuilder };
$c_sci_VectorSliceBuilder.prototype = new $h_O();
$c_sci_VectorSliceBuilder.prototype.constructor = $c_sci_VectorSliceBuilder;
/** @constructor */
function $h_sci_VectorSliceBuilder() {
}
export { $h_sci_VectorSliceBuilder as $h_sci_VectorSliceBuilder };
$h_sci_VectorSliceBuilder.prototype = $c_sci_VectorSliceBuilder.prototype;
$c_sci_VectorSliceBuilder.prototype.consider__I__AO__V = (function(n, a) {
  var count = Math.imul(a.u.length, (1 << Math.imul(5, (((-1) + n) | 0))));
  var a$1 = ((this.sci_VectorSliceBuilder__f_lo - this.sci_VectorSliceBuilder__f_pos) | 0);
  var lo0 = ((a$1 > 0) ? a$1 : 0);
  var a$2 = ((this.sci_VectorSliceBuilder__f_hi - this.sci_VectorSliceBuilder__f_pos) | 0);
  var hi0 = ((a$2 < count) ? a$2 : count);
  if ((hi0 > lo0)) {
    $p_sci_VectorSliceBuilder__addSlice__I__AO__I__I__V(this, n, a, lo0, hi0);
    this.sci_VectorSliceBuilder__f_len = ((this.sci_VectorSliceBuilder__f_len + ((hi0 - lo0) | 0)) | 0);
  }
  this.sci_VectorSliceBuilder__f_pos = ((this.sci_VectorSliceBuilder__f_pos + count) | 0);
});
$c_sci_VectorSliceBuilder.prototype.result__sci_Vector = (function() {
  if ((this.sci_VectorSliceBuilder__f_len <= 32)) {
    if ((this.sci_VectorSliceBuilder__f_len === 0)) {
      return $m_sci_Vector0$();
    } else {
      var prefix1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[0];
      var suffix1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[10];
      if ((prefix1 !== null)) {
        if ((suffix1 !== null)) {
          var newLength = ((prefix1.u.length + suffix1.u.length) | 0);
          var dest = $m_ju_Arrays$().copyOf__AO__I__AO(prefix1, newLength);
          var destPos = prefix1.u.length;
          var length = suffix1.u.length;
          suffix1.copyTo(0, dest, destPos, length);
          var a = dest;
        } else {
          var a = prefix1;
        }
      } else if ((suffix1 !== null)) {
        var a = suffix1;
      } else {
        var prefix2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[1];
        if ((prefix2 !== null)) {
          var a = prefix2.u[0];
        } else {
          var suffix2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[9];
          var a = suffix2.u[0];
        }
      }
      return new $c_sci_Vector1(a);
    }
  } else {
    $p_sci_VectorSliceBuilder__balancePrefix__I__V(this, 1);
    $p_sci_VectorSliceBuilder__balanceSuffix__I__V(this, 1);
    var resultDim = this.sci_VectorSliceBuilder__f_maxDim;
    if ((resultDim < 6)) {
      var $x_1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n = this.sci_VectorSliceBuilder__f_maxDim;
      var pre = $x_1.u[(((-1) + n) | 0)];
      var $x_2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
      var n$1 = this.sci_VectorSliceBuilder__f_maxDim;
      var suf = $x_2.u[((11 - n$1) | 0)];
      if (((pre !== null) && (suf !== null))) {
        if ((((pre.u.length + suf.u.length) | 0) <= 30)) {
          var $x_3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$2 = this.sci_VectorSliceBuilder__f_maxDim;
          var newLength$1 = ((pre.u.length + suf.u.length) | 0);
          var dest$1 = $m_ju_Arrays$().copyOf__AO__I__AO(pre, newLength$1);
          var destPos$1 = pre.u.length;
          var length$1 = suf.u.length;
          suf.copyTo(0, dest$1, destPos$1, length$1);
          $x_3.u[(((-1) + n$2) | 0)] = dest$1;
          var $x_4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices;
          var n$3 = this.sci_VectorSliceBuilder__f_maxDim;
          $x_4.u[((11 - n$3) | 0)] = null;
        } else {
          resultDim = ((1 + resultDim) | 0);
        }
      } else {
        var one = ((pre !== null) ? pre : suf);
        if ((one.u.length > 30)) {
          resultDim = ((1 + resultDim) | 0);
        }
      }
    }
    var prefix1$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[0];
    var suffix1$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[10];
    var len1 = prefix1$2.u.length;
    var x1 = resultDim;
    switch (x1) {
      case 2: {
        var a$1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[1];
        if ((p !== null)) {
          var $x_5 = p;
        } else {
          var s = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[9];
          var $x_5 = ((s !== null) ? s : a$1);
        }
        var data2 = $x_5;
        var res = new $c_sci_Vector2(prefix1$2, len1, data2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 3: {
        var a$2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[1];
        var prefix2$2 = ((p$1 !== null) ? p$1 : a$2);
        var a$3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[2];
        if ((p$2 !== null)) {
          var $x_6 = p$2;
        } else {
          var s$1 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[8];
          var $x_6 = ((s$1 !== null) ? s$1 : a$3);
        }
        var data3 = $x_6;
        var a$4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$2 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[9];
        var suffix2$2 = ((s$2 !== null) ? s$2 : a$4);
        var len12 = ((len1 + (prefix2$2.u.length << 5)) | 0);
        var res = new $c_sci_Vector3(prefix1$2, len1, prefix2$2, len12, data3, suffix2$2, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 4: {
        var a$5 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[1];
        var prefix2$3 = ((p$3 !== null) ? p$3 : a$5);
        var a$6 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[2];
        var prefix3 = ((p$4 !== null) ? p$4 : a$6);
        var a$7 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$5 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[3];
        if ((p$5 !== null)) {
          var $x_7 = p$5;
        } else {
          var s$3 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[7];
          var $x_7 = ((s$3 !== null) ? s$3 : a$7);
        }
        var data4 = $x_7;
        var a$8 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$4 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[8];
        var suffix3 = ((s$4 !== null) ? s$4 : a$8);
        var a$9 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$5 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[9];
        var suffix2$3 = ((s$5 !== null) ? s$5 : a$9);
        var len12$2 = ((len1 + (prefix2$3.u.length << 5)) | 0);
        var len123 = ((len12$2 + (prefix3.u.length << 10)) | 0);
        var res = new $c_sci_Vector4(prefix1$2, len1, prefix2$3, len12$2, prefix3, len123, data4, suffix3, suffix2$3, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 5: {
        var a$10 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$6 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[1];
        var prefix2$4 = ((p$6 !== null) ? p$6 : a$10);
        var a$11 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$7 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[2];
        var prefix3$2 = ((p$7 !== null) ? p$7 : a$11);
        var a$12 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$8 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[3];
        var prefix4 = ((p$8 !== null) ? p$8 : a$12);
        var a$13 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$9 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[4];
        if ((p$9 !== null)) {
          var $x_8 = p$9;
        } else {
          var s$6 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[6];
          var $x_8 = ((s$6 !== null) ? s$6 : a$13);
        }
        var data5 = $x_8;
        var a$14 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$7 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[7];
        var suffix4 = ((s$7 !== null) ? s$7 : a$14);
        var a$15 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$8 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[8];
        var suffix3$2 = ((s$8 !== null) ? s$8 : a$15);
        var a$16 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$9 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[9];
        var suffix2$4 = ((s$9 !== null) ? s$9 : a$16);
        var len12$3 = ((len1 + (prefix2$4.u.length << 5)) | 0);
        var len123$2 = ((len12$3 + (prefix3$2.u.length << 10)) | 0);
        var len1234 = ((len123$2 + (prefix4.u.length << 15)) | 0);
        var res = new $c_sci_Vector5(prefix1$2, len1, prefix2$4, len12$3, prefix3$2, len123$2, prefix4, len1234, data5, suffix4, suffix3$2, suffix2$4, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      case 6: {
        var a$17 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var p$10 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[1];
        var prefix2$5 = ((p$10 !== null) ? p$10 : a$17);
        var a$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var p$11 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[2];
        var prefix3$3 = ((p$11 !== null) ? p$11 : a$18);
        var a$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var p$12 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[3];
        var prefix4$2 = ((p$12 !== null) ? p$12 : a$19);
        var a$20 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var p$13 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[4];
        var prefix5 = ((p$13 !== null) ? p$13 : a$20);
        var a$21 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
        var p$14 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[5];
        if ((p$14 !== null)) {
          var $x_9 = p$14;
        } else {
          var s$10 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[5];
          var $x_9 = ((s$10 !== null) ? s$10 : a$21);
        }
        var data6 = $x_9;
        var a$22 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
        var s$11 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[6];
        var suffix5 = ((s$11 !== null) ? s$11 : a$22);
        var a$23 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
        var s$12 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[7];
        var suffix4$2 = ((s$12 !== null) ? s$12 : a$23);
        var a$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
        var s$13 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[8];
        var suffix3$3 = ((s$13 !== null) ? s$13 : a$24);
        var a$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
        var s$14 = this.sci_VectorSliceBuilder__f_scala$collection$immutable$VectorSliceBuilder$$slices.u[9];
        var suffix2$5 = ((s$14 !== null) ? s$14 : a$25);
        var len12$4 = ((len1 + (prefix2$5.u.length << 5)) | 0);
        var len123$3 = ((len12$4 + (prefix3$3.u.length << 10)) | 0);
        var len1234$2 = ((len123$3 + (prefix4$2.u.length << 15)) | 0);
        var len12345 = ((len1234$2 + (prefix5.u.length << 20)) | 0);
        var res = new $c_sci_Vector6(prefix1$2, len1, prefix2$5, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data6, suffix5, suffix4$2, suffix3$3, suffix2$5, suffix1$2, this.sci_VectorSliceBuilder__f_len);
        break;
      }
      default: {
        var res;
        throw new $c_s_MatchError(x1);
      }
    }
    return res;
  }
});
$c_sci_VectorSliceBuilder.prototype.toString__T = (function() {
  return (((((((((("VectorSliceBuilder(lo=" + this.sci_VectorSliceBuilder__f_lo) + ", hi=") + this.sci_VectorSliceBuilder__f_hi) + ", len=") + this.sci_VectorSliceBuilder__f_len) + ", pos=") + this.sci_VectorSliceBuilder__f_pos) + ", maxDim=") + this.sci_VectorSliceBuilder__f_maxDim) + ")");
});
var $d_sci_VectorSliceBuilder = new $TypeData().initClass($c_sci_VectorSliceBuilder, "scala.collection.immutable.VectorSliceBuilder", ({
  sci_VectorSliceBuilder: 1
}));
export { $d_sci_VectorSliceBuilder as $d_sci_VectorSliceBuilder };
/** @constructor */
function $c_sci_VectorStatics$() {
  this.sci_VectorStatics$__f_empty1 = null;
  this.sci_VectorStatics$__f_empty2 = null;
  this.sci_VectorStatics$__f_empty3 = null;
  this.sci_VectorStatics$__f_empty4 = null;
  this.sci_VectorStatics$__f_empty5 = null;
  this.sci_VectorStatics$__f_empty6 = null;
  $n_sci_VectorStatics$ = this;
  this.sci_VectorStatics$__f_empty1 = new $ac_O(0);
  this.sci_VectorStatics$__f_empty2 = new ($d_O.getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
  this.sci_VectorStatics$__f_empty6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(0);
}
export { $c_sci_VectorStatics$ as $c_sci_VectorStatics$ };
$c_sci_VectorStatics$.prototype = new $h_O();
$c_sci_VectorStatics$.prototype.constructor = $c_sci_VectorStatics$;
/** @constructor */
function $h_sci_VectorStatics$() {
}
export { $h_sci_VectorStatics$ as $h_sci_VectorStatics$ };
$h_sci_VectorStatics$.prototype = $c_sci_VectorStatics$.prototype;
$c_sci_VectorStatics$.prototype.copyAppend1__AO__O__AO = (function(a, elem) {
  var alen = a.u.length;
  var ac = new $ac_O(((1 + alen) | 0));
  a.copyTo(0, ac, 0, alen);
  ac.u[alen] = elem;
  return ac;
});
$c_sci_VectorStatics$.prototype.copyAppend__AO__O__AO = (function(a, elem) {
  var newLength = ((1 + a.u.length) | 0);
  var ac = $m_ju_Arrays$().copyOf__AO__I__AO(a, newLength);
  ac.u[(((-1) + ac.u.length) | 0)] = elem;
  return ac;
});
$c_sci_VectorStatics$.prototype.copyPrepend1__O__AO__AO = (function(elem, a) {
  var ac = new $ac_O(((1 + a.u.length) | 0));
  var length = a.u.length;
  a.copyTo(0, ac, 1, length);
  ac.u[0] = elem;
  return ac;
});
$c_sci_VectorStatics$.prototype.copyPrepend__O__AO__AO = (function(elem, a) {
  var this$1 = $objectGetClass(a);
  var componentType = this$1.data.getComponentType();
  var length = ((1 + a.u.length) | 0);
  var ac = componentType.data.newArray(length);
  var length$1 = a.u.length;
  a.copyTo(0, ac, 1, length$1);
  ac.u[0] = elem;
  return ac;
});
$c_sci_VectorStatics$.prototype.foreachRec__I__AO__F1__V = (function(level, a, f) {
  var i = 0;
  var len = a.u.length;
  if ((level === 0)) {
    while ((i < len)) {
      f.apply__O__O(a.u[i]);
      i = ((1 + i) | 0);
    }
  } else {
    var l = (((-1) + level) | 0);
    while ((i < len)) {
      this.foreachRec__I__AO__F1__V(l, a.u[i], f);
      i = ((1 + i) | 0);
    }
  }
});
$c_sci_VectorStatics$.prototype.mapElems1__AO__F1__AO = (function(a, f) {
  var i = 0;
  while ((i < a.u.length)) {
    var v1 = a.u[i];
    var v2 = f.apply__O__O(v1);
    if ((!Object.is(v1, v2))) {
      return this.mapElems1Rest__AO__F1__I__O__AO(a, f, i, v2);
    }
    i = ((1 + i) | 0);
  }
  return a;
});
$c_sci_VectorStatics$.prototype.mapElems1Rest__AO__F1__I__O__AO = (function(a, f, at, v2) {
  var ac = new $ac_O(a.u.length);
  if ((at > 0)) {
    a.copyTo(0, ac, 0, at);
  }
  ac.u[at] = v2;
  var i = ((1 + at) | 0);
  while ((i < a.u.length)) {
    ac.u[i] = f.apply__O__O(a.u[i]);
    i = ((1 + i) | 0);
  }
  return ac;
});
$c_sci_VectorStatics$.prototype.mapElems__I__AO__F1__AO = (function(n, a, f) {
  if ((n === 1)) {
    return this.mapElems1__AO__F1__AO(a, f);
  } else {
    var i = 0;
    while ((i < a.u.length)) {
      var v1 = a.u[i];
      var v2 = this.mapElems__I__AO__F1__AO((((-1) + n) | 0), v1, f);
      if ((v1 !== v2)) {
        return this.mapElemsRest__I__AO__F1__I__O__AO(n, a, f, i, v2);
      }
      i = ((1 + i) | 0);
    }
    return a;
  }
});
$c_sci_VectorStatics$.prototype.mapElemsRest__I__AO__F1__I__O__AO = (function(n, a, f, at, v2) {
  var this$1 = $objectGetClass(a);
  var componentType = this$1.data.getComponentType();
  var length = a.u.length;
  var ac = componentType.data.newArray(length);
  if ((at > 0)) {
    a.copyTo(0, ac, 0, at);
  }
  ac.u[at] = v2;
  var i = ((1 + at) | 0);
  while ((i < a.u.length)) {
    ac.u[i] = this.mapElems__I__AO__F1__AO((((-1) + n) | 0), a.u[i], f);
    i = ((1 + i) | 0);
  }
  return ac;
});
$c_sci_VectorStatics$.prototype.append1IfSpace__AO__sc_IterableOnce__AO = (function(suffix1, xs) {
  if ($is_sci_Iterable(xs)) {
    if ((xs.sizeCompare__I__I(((32 - suffix1.u.length) | 0)) <= 0)) {
      var x1$2 = xs.size__I();
      switch (x1$2) {
        case 0: {
          return null;
          break;
        }
        case 1: {
          return this.copyAppend__AO__O__AO(suffix1, xs.head__O());
          break;
        }
        default: {
          var newLength = ((suffix1.u.length + x1$2) | 0);
          var suffix1b = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength);
          var start = suffix1.u.length;
          xs.copyToArray__O__I__I__I(suffix1b, start, 2147483647);
          return suffix1b;
        }
      }
    } else {
      return null;
    }
  } else {
    var s = xs.knownSize__I();
    if (((s > 0) && (s <= ((32 - suffix1.u.length) | 0)))) {
      var newLength$1 = ((suffix1.u.length + s) | 0);
      var suffix1b$2 = $m_ju_Arrays$().copyOf__AO__I__AO(suffix1, newLength$1);
      var this$1 = xs.iterator__sc_Iterator();
      var start$1 = suffix1.u.length;
      this$1.copyToArray__O__I__I__I(suffix1b$2, start$1, 2147483647);
      return suffix1b$2;
    } else {
      return null;
    }
  }
});
var $d_sci_VectorStatics$ = new $TypeData().initClass($c_sci_VectorStatics$, "scala.collection.immutable.VectorStatics$", ({
  sci_VectorStatics$: 1
}));
export { $d_sci_VectorStatics$ as $d_sci_VectorStatics$ };
var $n_sci_VectorStatics$;
function $m_sci_VectorStatics$() {
  if ((!$n_sci_VectorStatics$)) {
    $n_sci_VectorStatics$ = new $c_sci_VectorStatics$();
  }
  return $n_sci_VectorStatics$;
}
export { $m_sci_VectorStatics$ as $m_sci_VectorStatics$ };
/** @constructor */
function $c_scm_HashMap$Node(_key, _hash, _value, _next) {
  this.scm_HashMap$Node__f__key = null;
  this.scm_HashMap$Node__f__hash = 0;
  this.scm_HashMap$Node__f__value = null;
  this.scm_HashMap$Node__f__next = null;
  this.scm_HashMap$Node__f__key = _key;
  this.scm_HashMap$Node__f__hash = _hash;
  this.scm_HashMap$Node__f__value = _value;
  this.scm_HashMap$Node__f__next = _next;
}
export { $c_scm_HashMap$Node as $c_scm_HashMap$Node };
$c_scm_HashMap$Node.prototype = new $h_O();
$c_scm_HashMap$Node.prototype.constructor = $c_scm_HashMap$Node;
/** @constructor */
function $h_scm_HashMap$Node() {
}
export { $h_scm_HashMap$Node as $h_scm_HashMap$Node };
$h_scm_HashMap$Node.prototype = $c_scm_HashMap$Node.prototype;
$c_scm_HashMap$Node.prototype.findNode__O__I__scm_HashMap$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.scm_HashMap$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, _$this.scm_HashMap$Node__f__key))) {
      return _$this;
    } else if (((_$this.scm_HashMap$Node__f__next === null) || (_$this.scm_HashMap$Node__f__hash > h))) {
      return null;
    } else {
      _$this = _$this.scm_HashMap$Node__f__next;
    }
  }
});
$c_scm_HashMap$Node.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    f.apply__O__O($ct_T2__O__O__(new $c_T2(), _$this.scm_HashMap$Node__f__key, _$this.scm_HashMap$Node__f__value));
    if ((_$this.scm_HashMap$Node__f__next !== null)) {
      _$this = _$this.scm_HashMap$Node__f__next;
      continue;
    }
    break;
  }
});
$c_scm_HashMap$Node.prototype.foreachEntry__F2__V = (function(f) {
  var _$this = this;
  while (true) {
    f.apply__O__O__O(_$this.scm_HashMap$Node__f__key, _$this.scm_HashMap$Node__f__value);
    if ((_$this.scm_HashMap$Node__f__next !== null)) {
      _$this = _$this.scm_HashMap$Node__f__next;
      continue;
    }
    break;
  }
});
$c_scm_HashMap$Node.prototype.toString__T = (function() {
  return ((((((("Node(" + this.scm_HashMap$Node__f__key) + ", ") + this.scm_HashMap$Node__f__value) + ", ") + this.scm_HashMap$Node__f__hash) + ") -> ") + this.scm_HashMap$Node__f__next);
});
var $d_scm_HashMap$Node = new $TypeData().initClass($c_scm_HashMap$Node, "scala.collection.mutable.HashMap$Node", ({
  scm_HashMap$Node: 1
}));
export { $d_scm_HashMap$Node as $d_scm_HashMap$Node };
/** @constructor */
function $c_scm_HashSet$Node(_key, _hash, _next) {
  this.scm_HashSet$Node__f__key = null;
  this.scm_HashSet$Node__f__hash = 0;
  this.scm_HashSet$Node__f__next = null;
  this.scm_HashSet$Node__f__key = _key;
  this.scm_HashSet$Node__f__hash = _hash;
  this.scm_HashSet$Node__f__next = _next;
}
export { $c_scm_HashSet$Node as $c_scm_HashSet$Node };
$c_scm_HashSet$Node.prototype = new $h_O();
$c_scm_HashSet$Node.prototype.constructor = $c_scm_HashSet$Node;
/** @constructor */
function $h_scm_HashSet$Node() {
}
export { $h_scm_HashSet$Node as $h_scm_HashSet$Node };
$h_scm_HashSet$Node.prototype = $c_scm_HashSet$Node.prototype;
$c_scm_HashSet$Node.prototype.findNode__O__I__scm_HashSet$Node = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.scm_HashSet$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, _$this.scm_HashSet$Node__f__key))) {
      return _$this;
    } else if (((_$this.scm_HashSet$Node__f__next === null) || (_$this.scm_HashSet$Node__f__hash > h))) {
      return null;
    } else {
      _$this = _$this.scm_HashSet$Node__f__next;
    }
  }
});
$c_scm_HashSet$Node.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    f.apply__O__O(_$this.scm_HashSet$Node__f__key);
    if ((_$this.scm_HashSet$Node__f__next !== null)) {
      _$this = _$this.scm_HashSet$Node__f__next;
      continue;
    }
    break;
  }
});
$c_scm_HashSet$Node.prototype.toString__T = (function() {
  return ((((("Node(" + this.scm_HashSet$Node__f__key) + ", ") + this.scm_HashSet$Node__f__hash) + ") -> ") + this.scm_HashSet$Node__f__next);
});
var $d_scm_HashSet$Node = new $TypeData().initClass($c_scm_HashSet$Node, "scala.collection.mutable.HashSet$Node", ({
  scm_HashSet$Node: 1
}));
export { $d_scm_HashSet$Node as $d_scm_HashSet$Node };
/** @constructor */
function $c_scm_LinkedHashMap$LinkedEntry(key, hash, value) {
  this.scm_LinkedHashMap$LinkedEntry__f_key = null;
  this.scm_LinkedHashMap$LinkedEntry__f_hash = 0;
  this.scm_LinkedHashMap$LinkedEntry__f_value = null;
  this.scm_LinkedHashMap$LinkedEntry__f_earlier = null;
  this.scm_LinkedHashMap$LinkedEntry__f_later = null;
  this.scm_LinkedHashMap$LinkedEntry__f_next = null;
  this.scm_LinkedHashMap$LinkedEntry__f_key = key;
  this.scm_LinkedHashMap$LinkedEntry__f_hash = hash;
  this.scm_LinkedHashMap$LinkedEntry__f_value = value;
  this.scm_LinkedHashMap$LinkedEntry__f_earlier = null;
  this.scm_LinkedHashMap$LinkedEntry__f_later = null;
  this.scm_LinkedHashMap$LinkedEntry__f_next = null;
}
export { $c_scm_LinkedHashMap$LinkedEntry as $c_scm_LinkedHashMap$LinkedEntry };
$c_scm_LinkedHashMap$LinkedEntry.prototype = new $h_O();
$c_scm_LinkedHashMap$LinkedEntry.prototype.constructor = $c_scm_LinkedHashMap$LinkedEntry;
/** @constructor */
function $h_scm_LinkedHashMap$LinkedEntry() {
}
export { $h_scm_LinkedHashMap$LinkedEntry as $h_scm_LinkedHashMap$LinkedEntry };
$h_scm_LinkedHashMap$LinkedEntry.prototype = $c_scm_LinkedHashMap$LinkedEntry.prototype;
$c_scm_LinkedHashMap$LinkedEntry.prototype.findEntry__O__I__scm_LinkedHashMap$LinkedEntry = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.scm_LinkedHashMap$LinkedEntry__f_hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, _$this.scm_LinkedHashMap$LinkedEntry__f_key))) {
      return _$this;
    } else if (((_$this.scm_LinkedHashMap$LinkedEntry__f_next === null) || (_$this.scm_LinkedHashMap$LinkedEntry__f_hash > h))) {
      return null;
    } else {
      _$this = _$this.scm_LinkedHashMap$LinkedEntry__f_next;
    }
  }
});
var $d_scm_LinkedHashMap$LinkedEntry = new $TypeData().initClass($c_scm_LinkedHashMap$LinkedEntry, "scala.collection.mutable.LinkedHashMap$LinkedEntry", ({
  scm_LinkedHashMap$LinkedEntry: 1
}));
export { $d_scm_LinkedHashMap$LinkedEntry as $d_scm_LinkedHashMap$LinkedEntry };
/** @constructor */
function $c_scm_LinkedHashSet$Entry(key, hash) {
  this.scm_LinkedHashSet$Entry__f_key = null;
  this.scm_LinkedHashSet$Entry__f_hash = 0;
  this.scm_LinkedHashSet$Entry__f_earlier = null;
  this.scm_LinkedHashSet$Entry__f_later = null;
  this.scm_LinkedHashSet$Entry__f_next = null;
  this.scm_LinkedHashSet$Entry__f_key = key;
  this.scm_LinkedHashSet$Entry__f_hash = hash;
  this.scm_LinkedHashSet$Entry__f_earlier = null;
  this.scm_LinkedHashSet$Entry__f_later = null;
  this.scm_LinkedHashSet$Entry__f_next = null;
}
export { $c_scm_LinkedHashSet$Entry as $c_scm_LinkedHashSet$Entry };
$c_scm_LinkedHashSet$Entry.prototype = new $h_O();
$c_scm_LinkedHashSet$Entry.prototype.constructor = $c_scm_LinkedHashSet$Entry;
/** @constructor */
function $h_scm_LinkedHashSet$Entry() {
}
export { $h_scm_LinkedHashSet$Entry as $h_scm_LinkedHashSet$Entry };
$h_scm_LinkedHashSet$Entry.prototype = $c_scm_LinkedHashSet$Entry.prototype;
$c_scm_LinkedHashSet$Entry.prototype.findEntry__O__I__scm_LinkedHashSet$Entry = (function(k, h) {
  var _$this = this;
  while (true) {
    if (((h === _$this.scm_LinkedHashSet$Entry__f_hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(k, _$this.scm_LinkedHashSet$Entry__f_key))) {
      return _$this;
    } else if (((_$this.scm_LinkedHashSet$Entry__f_next === null) || (_$this.scm_LinkedHashSet$Entry__f_hash > h))) {
      return null;
    } else {
      _$this = _$this.scm_LinkedHashSet$Entry__f_next;
    }
  }
});
var $d_scm_LinkedHashSet$Entry = new $TypeData().initClass($c_scm_LinkedHashSet$Entry, "scala.collection.mutable.LinkedHashSet$Entry", ({
  scm_LinkedHashSet$Entry: 1
}));
export { $d_scm_LinkedHashSet$Entry as $d_scm_LinkedHashSet$Entry };
/** @constructor */
function $c_scm_MutationTracker$() {
}
export { $c_scm_MutationTracker$ as $c_scm_MutationTracker$ };
$c_scm_MutationTracker$.prototype = new $h_O();
$c_scm_MutationTracker$.prototype.constructor = $c_scm_MutationTracker$;
/** @constructor */
function $h_scm_MutationTracker$() {
}
export { $h_scm_MutationTracker$ as $h_scm_MutationTracker$ };
$h_scm_MutationTracker$.prototype = $c_scm_MutationTracker$.prototype;
$c_scm_MutationTracker$.prototype.checkMutations__I__I__T__V = (function(expectedCount, actualCount, message) {
  if ((actualCount !== expectedCount)) {
    throw new $c_ju_ConcurrentModificationException(message);
  }
});
var $d_scm_MutationTracker$ = new $TypeData().initClass($c_scm_MutationTracker$, "scala.collection.mutable.MutationTracker$", ({
  scm_MutationTracker$: 1
}));
export { $d_scm_MutationTracker$ as $d_scm_MutationTracker$ };
var $n_scm_MutationTracker$;
function $m_scm_MutationTracker$() {
  if ((!$n_scm_MutationTracker$)) {
    $n_scm_MutationTracker$ = new $c_scm_MutationTracker$();
  }
  return $n_scm_MutationTracker$;
}
export { $m_scm_MutationTracker$ as $m_scm_MutationTracker$ };
/** @constructor */
function $c_sc_package$$colon$plus$() {
}
export { $c_sc_package$$colon$plus$ as $c_sc_package$$colon$plus$ };
$c_sc_package$$colon$plus$.prototype = new $h_O();
$c_sc_package$$colon$plus$.prototype.constructor = $c_sc_package$$colon$plus$;
/** @constructor */
function $h_sc_package$$colon$plus$() {
}
export { $h_sc_package$$colon$plus$ as $h_sc_package$$colon$plus$ };
$h_sc_package$$colon$plus$.prototype = $c_sc_package$$colon$plus$.prototype;
$c_sc_package$$colon$plus$.prototype.unapply__sc_SeqOps__s_Option = (function(t) {
  if (t.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var self = t.init__O();
    var y = t.last__O();
    return new $c_s_Some($ct_T2__O__O__(new $c_T2(), self, y));
  }
});
var $d_sc_package$$colon$plus$ = new $TypeData().initClass($c_sc_package$$colon$plus$, "scala.collection.package$$colon$plus$", ({
  sc_package$$colon$plus$: 1
}));
export { $d_sc_package$$colon$plus$ as $d_sc_package$$colon$plus$ };
var $n_sc_package$$colon$plus$;
function $m_sc_package$$colon$plus$() {
  if ((!$n_sc_package$$colon$plus$)) {
    $n_sc_package$$colon$plus$ = new $c_sc_package$$colon$plus$();
  }
  return $n_sc_package$$colon$plus$;
}
export { $m_sc_package$$colon$plus$ as $m_sc_package$$colon$plus$ };
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt$() {
}
export { $c_s_concurrent_duration_package$DurationInt$ as $c_s_concurrent_duration_package$DurationInt$ };
$c_s_concurrent_duration_package$DurationInt$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt$.prototype.constructor = $c_s_concurrent_duration_package$DurationInt$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt$() {
}
export { $h_s_concurrent_duration_package$DurationInt$ as $h_s_concurrent_duration_package$DurationInt$ };
$h_s_concurrent_duration_package$DurationInt$.prototype = $c_s_concurrent_duration_package$DurationInt$.prototype;
$c_s_concurrent_duration_package$DurationInt$.prototype.equals$extension__I__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationInt)) {
    var DurationInt$1 = x$1.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
    return (this$ === DurationInt$1);
  } else {
    return false;
  }
});
var $d_s_concurrent_duration_package$DurationInt$ = new $TypeData().initClass($c_s_concurrent_duration_package$DurationInt$, "scala.concurrent.duration.package$DurationInt$", ({
  s_concurrent_duration_package$DurationInt$: 1
}));
export { $d_s_concurrent_duration_package$DurationInt$ as $d_s_concurrent_duration_package$DurationInt$ };
var $n_s_concurrent_duration_package$DurationInt$;
function $m_s_concurrent_duration_package$DurationInt$() {
  if ((!$n_s_concurrent_duration_package$DurationInt$)) {
    $n_s_concurrent_duration_package$DurationInt$ = new $c_s_concurrent_duration_package$DurationInt$();
  }
  return $n_s_concurrent_duration_package$DurationInt$;
}
export { $m_s_concurrent_duration_package$DurationInt$ as $m_s_concurrent_duration_package$DurationInt$ };
/** @constructor */
function $c_s_concurrent_duration_package$DurationLong$() {
}
export { $c_s_concurrent_duration_package$DurationLong$ as $c_s_concurrent_duration_package$DurationLong$ };
$c_s_concurrent_duration_package$DurationLong$.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationLong$.prototype.constructor = $c_s_concurrent_duration_package$DurationLong$;
/** @constructor */
function $h_s_concurrent_duration_package$DurationLong$() {
}
export { $h_s_concurrent_duration_package$DurationLong$ as $h_s_concurrent_duration_package$DurationLong$ };
$h_s_concurrent_duration_package$DurationLong$.prototype = $c_s_concurrent_duration_package$DurationLong$.prototype;
$c_s_concurrent_duration_package$DurationLong$.prototype.equals$extension__J__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_s_concurrent_duration_package$DurationLong)) {
    var t = x$1.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return ((this$.RTLong__f_lo === lo) && (this$.RTLong__f_hi === hi));
  } else {
    return false;
  }
});
var $d_s_concurrent_duration_package$DurationLong$ = new $TypeData().initClass($c_s_concurrent_duration_package$DurationLong$, "scala.concurrent.duration.package$DurationLong$", ({
  s_concurrent_duration_package$DurationLong$: 1
}));
export { $d_s_concurrent_duration_package$DurationLong$ as $d_s_concurrent_duration_package$DurationLong$ };
var $n_s_concurrent_duration_package$DurationLong$;
function $m_s_concurrent_duration_package$DurationLong$() {
  if ((!$n_s_concurrent_duration_package$DurationLong$)) {
    $n_s_concurrent_duration_package$DurationLong$ = new $c_s_concurrent_duration_package$DurationLong$();
  }
  return $n_s_concurrent_duration_package$DurationLong$;
}
export { $m_s_concurrent_duration_package$DurationLong$ as $m_s_concurrent_duration_package$DurationLong$ };
function $ct_s_math_Numeric$NumericOps__s_math_Numeric__O__($thiz, outer, lhs) {
  $thiz.s_math_Numeric$NumericOps__f_lhs = lhs;
  $thiz.s_math_Numeric$NumericOps__f_$outer = outer;
  return $thiz;
}
export { $ct_s_math_Numeric$NumericOps__s_math_Numeric__O__ as $ct_s_math_Numeric$NumericOps__s_math_Numeric__O__ };
/** @constructor */
function $c_s_math_Numeric$NumericOps() {
  this.s_math_Numeric$NumericOps__f_lhs = null;
  this.s_math_Numeric$NumericOps__f_$outer = null;
}
export { $c_s_math_Numeric$NumericOps as $c_s_math_Numeric$NumericOps };
$c_s_math_Numeric$NumericOps.prototype = new $h_O();
$c_s_math_Numeric$NumericOps.prototype.constructor = $c_s_math_Numeric$NumericOps;
/** @constructor */
function $h_s_math_Numeric$NumericOps() {
}
export { $h_s_math_Numeric$NumericOps as $h_s_math_Numeric$NumericOps };
$h_s_math_Numeric$NumericOps.prototype = $c_s_math_Numeric$NumericOps.prototype;
$c_s_math_Numeric$NumericOps.prototype.$plus__O__O = (function(rhs) {
  return this.s_math_Numeric$NumericOps__f_$outer.plus__O__O__O(this.s_math_Numeric$NumericOps__f_lhs, rhs);
});
$c_s_math_Numeric$NumericOps.prototype.$minus__O__O = (function(rhs) {
  return this.s_math_Numeric$NumericOps__f_$outer.minus__O__O__O(this.s_math_Numeric$NumericOps__f_lhs, rhs);
});
$c_s_math_Numeric$NumericOps.prototype.$times__O__O = (function(rhs) {
  return this.s_math_Numeric$NumericOps__f_$outer.times__O__O__O(this.s_math_Numeric$NumericOps__f_lhs, rhs);
});
$c_s_math_Numeric$NumericOps.prototype.unary_$minus__O = (function() {
  return this.s_math_Numeric$NumericOps__f_$outer.negate__O__O(this.s_math_Numeric$NumericOps__f_lhs);
});
/** @constructor */
function $c_s_math_Ordering$OrderingOps(outer, lhs) {
  this.s_math_Ordering$OrderingOps__f_lhs = null;
  this.s_math_Ordering$OrderingOps__f_$outer = null;
  this.s_math_Ordering$OrderingOps__f_lhs = lhs;
  this.s_math_Ordering$OrderingOps__f_$outer = outer;
}
export { $c_s_math_Ordering$OrderingOps as $c_s_math_Ordering$OrderingOps };
$c_s_math_Ordering$OrderingOps.prototype = new $h_O();
$c_s_math_Ordering$OrderingOps.prototype.constructor = $c_s_math_Ordering$OrderingOps;
/** @constructor */
function $h_s_math_Ordering$OrderingOps() {
}
export { $h_s_math_Ordering$OrderingOps as $h_s_math_Ordering$OrderingOps };
$h_s_math_Ordering$OrderingOps.prototype = $c_s_math_Ordering$OrderingOps.prototype;
$c_s_math_Ordering$OrderingOps.prototype.$greater__O__Z = (function(rhs) {
  return this.s_math_Ordering$OrderingOps__f_$outer.gt__O__O__Z(this.s_math_Ordering$OrderingOps__f_lhs, rhs);
});
var $d_s_math_Ordering$OrderingOps = new $TypeData().initClass($c_s_math_Ordering$OrderingOps, "scala.math.Ordering$OrderingOps", ({
  s_math_Ordering$OrderingOps: 1
}));
export { $d_s_math_Ordering$OrderingOps as $d_s_math_Ordering$OrderingOps };
function $f_s_math_ScalaNumericAnyConversions__isValidByte__Z($thiz) {
  return ($thiz.isWhole__Z() && ($thiz.intValue__I() === $thiz.byteValue__B()));
}
export { $f_s_math_ScalaNumericAnyConversions__isValidByte__Z as $f_s_math_ScalaNumericAnyConversions__isValidByte__Z };
function $f_s_math_ScalaNumericAnyConversions__isValidShort__Z($thiz) {
  return ($thiz.isWhole__Z() && ($thiz.intValue__I() === $thiz.shortValue__S()));
}
export { $f_s_math_ScalaNumericAnyConversions__isValidShort__Z as $f_s_math_ScalaNumericAnyConversions__isValidShort__Z };
function $f_s_math_ScalaNumericAnyConversions__isValidInt__Z($thiz) {
  if ($thiz.isWhole__Z()) {
    var a = $thiz.longValue__J();
    var value = $thiz.intValue__I();
    var hi = (value >> 31);
    return ((a.RTLong__f_lo === value) && (a.RTLong__f_hi === hi));
  } else {
    return false;
  }
}
export { $f_s_math_ScalaNumericAnyConversions__isValidInt__Z as $f_s_math_ScalaNumericAnyConversions__isValidInt__Z };
function $f_s_math_ScalaNumericAnyConversions__isValidChar__Z($thiz) {
  return ($thiz.isWhole__Z() && (($thiz.intValue__I() >= 0) && ($thiz.intValue__I() <= 65535)));
}
export { $f_s_math_ScalaNumericAnyConversions__isValidChar__Z as $f_s_math_ScalaNumericAnyConversions__isValidChar__Z };
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I($thiz) {
  var t = $thiz.longValue__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return ((((hi === (-1)) ? ((lo >>> 0) >= 2147483648) : (hi > (-1))) && ((hi === 0) ? ((lo >>> 0) <= 2147483647) : (hi < 0))) ? lo : $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi)));
}
export { $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I as $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I };
function $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z($thiz, x) {
  if ((x instanceof $Char)) {
    var x2 = $uC(x);
    return ($thiz.isValidChar__Z() && ($thiz.intValue__I() === x2));
  } else if ($isByte(x)) {
    var x3 = (x | 0);
    return ($thiz.isValidByte__Z() && ($thiz.byteValue__B() === x3));
  } else if ($isShort(x)) {
    var x4 = (x | 0);
    return ($thiz.isValidShort__Z() && ($thiz.shortValue__S() === x4));
  } else if ($isInt(x)) {
    var x5 = (x | 0);
    return ($thiz.isValidInt__Z() && ($thiz.intValue__I() === x5));
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var a = $thiz.longValue__J();
    return ((a.RTLong__f_lo === lo) && (a.RTLong__f_hi === hi));
  } else if ($isFloat(x)) {
    var x7 = Math.fround(x);
    return ($thiz.floatValue__F() === x7);
  } else if (((typeof x) === "number")) {
    var x8 = (+x);
    return ($thiz.doubleValue__D() === x8);
  } else {
    return false;
  }
}
export { $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z as $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z };
/** @constructor */
function $c_s_math_package$() {
}
export { $c_s_math_package$ as $c_s_math_package$ };
$c_s_math_package$.prototype = new $h_O();
$c_s_math_package$.prototype.constructor = $c_s_math_package$;
/** @constructor */
function $h_s_math_package$() {
}
export { $h_s_math_package$ as $h_s_math_package$ };
$h_s_math_package$.prototype = $c_s_math_package$.prototype;
$c_s_math_package$.prototype.signum__J__J = (function(x) {
  var hi = x.RTLong__f_hi;
  var lo = (hi >> 31);
  var blo = x.RTLong__f_lo;
  var lo$1 = ((-blo) | 0);
  var hi$2 = ((((-x.RTLong__f_hi) | 0) + ((blo | lo$1) >> 31)) | 0);
  var lo$2 = ((hi$2 >>> 31) | 0);
  var lo$3 = (lo | lo$2);
  var hi$3 = (lo$3 >> 31);
  return new $c_RTLong(lo$3, hi$3);
});
var $d_s_math_package$ = new $TypeData().initClass($c_s_math_package$, "scala.math.package$", ({
  s_math_package$: 1
}));
export { $d_s_math_package$ as $d_s_math_package$ };
var $n_s_math_package$;
function $m_s_math_package$() {
  if ((!$n_s_math_package$)) {
    $n_s_math_package$ = new $c_s_math_package$();
  }
  return $n_s_math_package$;
}
export { $m_s_math_package$ as $m_s_math_package$ };
function $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$($thiz) {
  if (((((1 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigDecimal = $m_s_math_BigDecimal$();
    $thiz.s_package$__f_bitmap$0 = (((1 | $thiz.s_package$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.s_package$__f_BigDecimal;
}
export { $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$ as $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$ };
function $p_s_package$__BigInt$lzycompute__s_math_BigInt$($thiz) {
  if (((((2 & $thiz.s_package$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.s_package$__f_BigInt = $m_s_math_BigInt$();
    $thiz.s_package$__f_bitmap$0 = (((2 | $thiz.s_package$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.s_package$__f_BigInt;
}
export { $p_s_package$__BigInt$lzycompute__s_math_BigInt$ as $p_s_package$__BigInt$lzycompute__s_math_BigInt$ };
/** @constructor */
function $c_s_package$() {
  this.s_package$__f_BigDecimal = null;
  this.s_package$__f_BigInt = null;
  this.s_package$__f_Iterable = null;
  this.s_package$__f_Seq = null;
  this.s_package$__f_Iterator = null;
  this.s_package$__f_List = null;
  this.s_package$__f_Nil = null;
  this.s_package$__f_$colon$plus = null;
  this.s_package$__f_Stream = null;
  this.s_package$__f_LazyList = null;
  this.s_package$__f_Vector = null;
  this.s_package$__f_Ordering = null;
  this.s_package$__f_Either = null;
  this.s_package$__f_Left = null;
  this.s_package$__f_Right = null;
  this.s_package$__f_bitmap$0 = 0;
  $n_s_package$ = this;
  this.s_package$__f_Iterable = $m_sc_Iterable$();
  this.s_package$__f_Seq = $m_sci_Seq$();
  $m_sci_IndexedSeq$();
  this.s_package$__f_Iterator = $m_sc_Iterator$();
  this.s_package$__f_List = $m_sci_List$();
  this.s_package$__f_Nil = $m_sci_Nil$();
  this.s_package$__f_$colon$plus = $m_sc_package$$colon$plus$();
  this.s_package$__f_Stream = $m_sci_Stream$();
  this.s_package$__f_LazyList = $m_sci_LazyList$();
  this.s_package$__f_Vector = $m_sci_Vector$();
  this.s_package$__f_Ordering = $m_s_math_Ordering$();
  this.s_package$__f_Either = $m_s_util_Either$();
  this.s_package$__f_Left = $m_s_util_Left$();
  this.s_package$__f_Right = $m_s_util_Right$();
}
export { $c_s_package$ as $c_s_package$ };
$c_s_package$.prototype = new $h_O();
$c_s_package$.prototype.constructor = $c_s_package$;
/** @constructor */
function $h_s_package$() {
}
export { $h_s_package$ as $h_s_package$ };
$h_s_package$.prototype = $c_s_package$.prototype;
$c_s_package$.prototype.BigDecimal__s_math_BigDecimal$ = (function() {
  return (((((1 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigDecimal$lzycompute__s_math_BigDecimal$(this) : this.s_package$__f_BigDecimal);
});
$c_s_package$.prototype.BigInt__s_math_BigInt$ = (function() {
  return (((((2 & this.s_package$__f_bitmap$0) << 24) >> 24) === 0) ? $p_s_package$__BigInt$lzycompute__s_math_BigInt$(this) : this.s_package$__f_BigInt);
});
var $d_s_package$ = new $TypeData().initClass($c_s_package$, "scala.package$", ({
  s_package$: 1
}));
export { $d_s_package$ as $d_s_package$ };
var $n_s_package$;
function $m_s_package$() {
  if ((!$n_s_package$)) {
    $n_s_package$ = new $c_s_package$();
  }
  return $n_s_package$;
}
export { $m_s_package$ as $m_s_package$ };
/** @constructor */
function $c_sr_BoxesRunTime$() {
}
export { $c_sr_BoxesRunTime$ as $c_sr_BoxesRunTime$ };
$c_sr_BoxesRunTime$.prototype = new $h_O();
$c_sr_BoxesRunTime$.prototype.constructor = $c_sr_BoxesRunTime$;
/** @constructor */
function $h_sr_BoxesRunTime$() {
}
export { $h_sr_BoxesRunTime$ as $h_sr_BoxesRunTime$ };
$h_sr_BoxesRunTime$.prototype = $c_sr_BoxesRunTime$.prototype;
$c_sr_BoxesRunTime$.prototype.equals__O__O__Z = (function(x, y) {
  return ((x === y) || ($is_jl_Number(x) ? this.equalsNumObject__jl_Number__O__Z(x, y) : ((x instanceof $Char) ? this.equalsCharObject__jl_Character__O__Z(x, y) : ((x === null) ? (y === null) : $dp_equals__O__Z(x, y)))));
});
$c_sr_BoxesRunTime$.prototype.equalsNumObject__jl_Number__O__Z = (function(xn, y) {
  if ($is_jl_Number(y)) {
    return this.equalsNumNum__jl_Number__jl_Number__Z(xn, y);
  } else if ((y instanceof $Char)) {
    if (((typeof xn) === "number")) {
      var x2 = (+xn);
      var this$1 = y.c;
      return (x2 === this$1);
    } else if ((xn instanceof $c_RTLong)) {
      var t = $uJ(xn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var this$2 = y.c;
      var value = this$2;
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1));
    } else {
      return ((xn === null) ? (y === null) : $dp_equals__O__Z(xn, y));
    }
  } else {
    return ((xn === null) ? (y === null) : $dp_equals__O__Z(xn, y));
  }
});
$c_sr_BoxesRunTime$.prototype.equalsNumNum__jl_Number__jl_Number__Z = (function(xn, yn) {
  if (((typeof xn) === "number")) {
    var x2 = (+xn);
    if (((typeof yn) === "number")) {
      var x2$2 = (+yn);
      return (x2 === x2$2);
    } else if ((yn instanceof $c_RTLong)) {
      var t = $uJ(yn);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return (x2 === ((4.294967296E9 * hi) + (lo >>> 0.0)));
    } else {
      return ((yn instanceof $c_s_math_ScalaNumber) && yn.equals__O__Z(x2));
    }
  } else if ((xn instanceof $c_RTLong)) {
    var t$1 = $uJ(xn);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((yn instanceof $c_RTLong)) {
      var t$2 = $uJ(yn);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      return ((lo$1 === lo$2) && (hi$1 === hi$2));
    } else if (((typeof yn) === "number")) {
      var x3$3 = (+yn);
      return (((4.294967296E9 * hi$1) + (lo$1 >>> 0.0)) === x3$3);
    } else {
      return ((yn instanceof $c_s_math_ScalaNumber) && yn.equals__O__Z(new $c_RTLong(lo$1, hi$1)));
    }
  } else {
    return ((xn === null) ? (yn === null) : $dp_equals__O__Z(xn, yn));
  }
});
$c_sr_BoxesRunTime$.prototype.equalsCharObject__jl_Character__O__Z = (function(xc, y) {
  if ((y instanceof $Char)) {
    var this$1 = xc.c;
    var this$2 = y.c;
    return (this$1 === this$2);
  } else if ($is_jl_Number(y)) {
    if (((typeof y) === "number")) {
      var x2 = (+y);
      var this$3 = xc.c;
      return (x2 === this$3);
    } else if ((y instanceof $c_RTLong)) {
      var t = $uJ(y);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var this$4 = xc.c;
      var value = this$4;
      var hi$1 = (value >> 31);
      return ((lo === value) && (hi === hi$1));
    } else {
      return ((y === null) ? (xc === null) : $dp_equals__O__Z(y, xc));
    }
  } else {
    return ((xc === null) && (y === null));
  }
});
var $d_sr_BoxesRunTime$ = new $TypeData().initClass($c_sr_BoxesRunTime$, "scala.runtime.BoxesRunTime$", ({
  sr_BoxesRunTime$: 1
}));
export { $d_sr_BoxesRunTime$ as $d_sr_BoxesRunTime$ };
var $n_sr_BoxesRunTime$;
function $m_sr_BoxesRunTime$() {
  if ((!$n_sr_BoxesRunTime$)) {
    $n_sr_BoxesRunTime$ = new $c_sr_BoxesRunTime$();
  }
  return $n_sr_BoxesRunTime$;
}
export { $m_sr_BoxesRunTime$ as $m_sr_BoxesRunTime$ };
var $d_sr_Null$ = new $TypeData().initClass(0, "scala.runtime.Null$", ({
  sr_Null$: 1
}));
export { $d_sr_Null$ as $d_sr_Null$ };
/** @constructor */
function $c_sr_RichBoolean$() {
}
export { $c_sr_RichBoolean$ as $c_sr_RichBoolean$ };
$c_sr_RichBoolean$.prototype = new $h_O();
$c_sr_RichBoolean$.prototype.constructor = $c_sr_RichBoolean$;
/** @constructor */
function $h_sr_RichBoolean$() {
}
export { $h_sr_RichBoolean$ as $h_sr_RichBoolean$ };
$h_sr_RichBoolean$.prototype = $c_sr_RichBoolean$.prototype;
$c_sr_RichBoolean$.prototype.equals$extension__Z__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichBoolean)) {
    var RichBoolean$1 = x$1.sr_RichBoolean__f_self;
    return (this$ === RichBoolean$1);
  } else {
    return false;
  }
});
var $d_sr_RichBoolean$ = new $TypeData().initClass($c_sr_RichBoolean$, "scala.runtime.RichBoolean$", ({
  sr_RichBoolean$: 1
}));
export { $d_sr_RichBoolean$ as $d_sr_RichBoolean$ };
var $n_sr_RichBoolean$;
function $m_sr_RichBoolean$() {
  if ((!$n_sr_RichBoolean$)) {
    $n_sr_RichBoolean$ = new $c_sr_RichBoolean$();
  }
  return $n_sr_RichBoolean$;
}
export { $m_sr_RichBoolean$ as $m_sr_RichBoolean$ };
/** @constructor */
function $c_sr_RichChar$() {
}
export { $c_sr_RichChar$ as $c_sr_RichChar$ };
$c_sr_RichChar$.prototype = new $h_O();
$c_sr_RichChar$.prototype.constructor = $c_sr_RichChar$;
/** @constructor */
function $h_sr_RichChar$() {
}
export { $h_sr_RichChar$ as $h_sr_RichChar$ };
$h_sr_RichChar$.prototype = $c_sr_RichChar$.prototype;
$c_sr_RichChar$.prototype.equals$extension__C__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichChar)) {
    var RichChar$1 = x$1.sr_RichChar__f_self;
    return (this$ === RichChar$1);
  } else {
    return false;
  }
});
var $d_sr_RichChar$ = new $TypeData().initClass($c_sr_RichChar$, "scala.runtime.RichChar$", ({
  sr_RichChar$: 1
}));
export { $d_sr_RichChar$ as $d_sr_RichChar$ };
var $n_sr_RichChar$;
function $m_sr_RichChar$() {
  if ((!$n_sr_RichChar$)) {
    $n_sr_RichChar$ = new $c_sr_RichChar$();
  }
  return $n_sr_RichChar$;
}
export { $m_sr_RichChar$ as $m_sr_RichChar$ };
/** @constructor */
function $c_sr_RichInt$() {
}
export { $c_sr_RichInt$ as $c_sr_RichInt$ };
$c_sr_RichInt$.prototype = new $h_O();
$c_sr_RichInt$.prototype.constructor = $c_sr_RichInt$;
/** @constructor */
function $h_sr_RichInt$() {
}
export { $h_sr_RichInt$ as $h_sr_RichInt$ };
$h_sr_RichInt$.prototype = $c_sr_RichInt$.prototype;
$c_sr_RichInt$.prototype.equals$extension__I__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichInt)) {
    var RichInt$1 = x$1.sr_RichInt__f_self;
    return (this$ === RichInt$1);
  } else {
    return false;
  }
});
var $d_sr_RichInt$ = new $TypeData().initClass($c_sr_RichInt$, "scala.runtime.RichInt$", ({
  sr_RichInt$: 1
}));
export { $d_sr_RichInt$ as $d_sr_RichInt$ };
var $n_sr_RichInt$;
function $m_sr_RichInt$() {
  if ((!$n_sr_RichInt$)) {
    $n_sr_RichInt$ = new $c_sr_RichInt$();
  }
  return $n_sr_RichInt$;
}
export { $m_sr_RichInt$ as $m_sr_RichInt$ };
/** @constructor */
function $c_sr_RichLong$() {
}
export { $c_sr_RichLong$ as $c_sr_RichLong$ };
$c_sr_RichLong$.prototype = new $h_O();
$c_sr_RichLong$.prototype.constructor = $c_sr_RichLong$;
/** @constructor */
function $h_sr_RichLong$() {
}
export { $h_sr_RichLong$ as $h_sr_RichLong$ };
$h_sr_RichLong$.prototype = $c_sr_RichLong$.prototype;
$c_sr_RichLong$.prototype.isValidByte$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 24) >> 24);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi));
});
$c_sr_RichLong$.prototype.isValidShort$extension__J__Z = (function(this$) {
  var value = ((this$.RTLong__f_lo << 16) >> 16);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi));
});
$c_sr_RichLong$.prototype.isValidChar$extension__J__Z = (function(this$) {
  var value = (65535 & this$.RTLong__f_lo);
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi));
});
$c_sr_RichLong$.prototype.isValidInt$extension__J__Z = (function(this$) {
  var value = this$.RTLong__f_lo;
  var hi = (value >> 31);
  return ((value === this$.RTLong__f_lo) && (hi === this$.RTLong__f_hi));
});
$c_sr_RichLong$.prototype.equals$extension__J__O__Z = (function(this$, x$1) {
  if ((x$1 instanceof $c_sr_RichLong)) {
    var t = x$1.sr_RichLong__f_self;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return ((this$.RTLong__f_lo === lo) && (this$.RTLong__f_hi === hi));
  } else {
    return false;
  }
});
var $d_sr_RichLong$ = new $TypeData().initClass($c_sr_RichLong$, "scala.runtime.RichLong$", ({
  sr_RichLong$: 1
}));
export { $d_sr_RichLong$ as $d_sr_RichLong$ };
var $n_sr_RichLong$;
function $m_sr_RichLong$() {
  if ((!$n_sr_RichLong$)) {
    $n_sr_RichLong$ = new $c_sr_RichLong$();
  }
  return $n_sr_RichLong$;
}
export { $m_sr_RichLong$ as $m_sr_RichLong$ };
/** @constructor */
function $c_sr_Scala3RunTime$() {
}
export { $c_sr_Scala3RunTime$ as $c_sr_Scala3RunTime$ };
$c_sr_Scala3RunTime$.prototype = new $h_O();
$c_sr_Scala3RunTime$.prototype.constructor = $c_sr_Scala3RunTime$;
/** @constructor */
function $h_sr_Scala3RunTime$() {
}
export { $h_sr_Scala3RunTime$ as $h_sr_Scala3RunTime$ };
$h_sr_Scala3RunTime$.prototype = $c_sr_Scala3RunTime$.prototype;
$c_sr_Scala3RunTime$.prototype.assertFailed__E = (function() {
  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "assertion failed");
});
$c_sr_Scala3RunTime$.prototype.nnFail__E = (function() {
  throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "tried to cast away nullability, but value is null");
});
var $d_sr_Scala3RunTime$ = new $TypeData().initClass($c_sr_Scala3RunTime$, "scala.runtime.Scala3RunTime$", ({
  sr_Scala3RunTime$: 1
}));
export { $d_sr_Scala3RunTime$ as $d_sr_Scala3RunTime$ };
var $n_sr_Scala3RunTime$;
function $m_sr_Scala3RunTime$() {
  if ((!$n_sr_Scala3RunTime$)) {
    $n_sr_Scala3RunTime$ = new $c_sr_Scala3RunTime$();
  }
  return $n_sr_Scala3RunTime$;
}
export { $m_sr_Scala3RunTime$ as $m_sr_Scala3RunTime$ };
function $p_sr_ScalaRunTime$__isArrayClass__jl_Class__I__Z($thiz, clazz, atLevel) {
  while (true) {
    if ((clazz !== null)) {
      var this$1 = clazz;
      var $x_1 = this$1.data.isArrayClass;
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      if ((atLevel === 1)) {
        return true;
      } else {
        var this$2 = clazz;
        var temp$clazz = this$2.data.getComponentType();
        var temp$atLevel = (((-1) + atLevel) | 0);
        clazz = temp$clazz;
        atLevel = temp$atLevel;
      }
    } else {
      return false;
    }
  }
}
export { $p_sr_ScalaRunTime$__isArrayClass__jl_Class__I__Z as $p_sr_ScalaRunTime$__isArrayClass__jl_Class__I__Z };
/** @constructor */
function $c_sr_ScalaRunTime$() {
}
export { $c_sr_ScalaRunTime$ as $c_sr_ScalaRunTime$ };
$c_sr_ScalaRunTime$.prototype = new $h_O();
$c_sr_ScalaRunTime$.prototype.constructor = $c_sr_ScalaRunTime$;
/** @constructor */
function $h_sr_ScalaRunTime$() {
}
export { $h_sr_ScalaRunTime$ as $h_sr_ScalaRunTime$ };
$h_sr_ScalaRunTime$.prototype = $c_sr_ScalaRunTime$.prototype;
$c_sr_ScalaRunTime$.prototype.isArray__O__I__Z = (function(x, atLevel) {
  return ((x !== null) && $p_sr_ScalaRunTime$__isArrayClass__jl_Class__I__Z(this, $objectGetClass(x), atLevel));
});
$c_sr_ScalaRunTime$.prototype.array_apply__O__I__O = (function(xs, idx) {
  if ((xs instanceof $ac_O)) {
    return xs.u[idx];
  } else if ((xs instanceof $ac_I)) {
    return xs.u[idx];
  } else if ((xs instanceof $ac_D)) {
    return xs.u[idx];
  } else if ((xs instanceof $ac_J)) {
    return xs.u[idx];
  } else if ((xs instanceof $ac_F)) {
    return xs.u[idx];
  } else if ((xs instanceof $ac_C)) {
    return $bC(xs.u[idx]);
  } else if ((xs instanceof $ac_B)) {
    return xs.u[idx];
  } else if ((xs instanceof $ac_S)) {
    return xs.u[idx];
  } else if ((xs instanceof $ac_Z)) {
    return xs.u[idx];
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$c_sr_ScalaRunTime$.prototype.array_update__O__I__O__V = (function(xs, idx, value) {
  if ((xs instanceof $ac_O)) {
    xs.u[idx] = value;
  } else if ((xs instanceof $ac_I)) {
    xs.u[idx] = (value | 0);
  } else if ((xs instanceof $ac_D)) {
    xs.u[idx] = (+value);
  } else if ((xs instanceof $ac_J)) {
    xs.u[idx] = $uJ(value);
  } else if ((xs instanceof $ac_F)) {
    xs.u[idx] = Math.fround(value);
  } else if ((xs instanceof $ac_C)) {
    xs.u[idx] = $uC(value);
  } else if ((xs instanceof $ac_B)) {
    xs.u[idx] = (value | 0);
  } else if ((xs instanceof $ac_S)) {
    xs.u[idx] = (value | 0);
  } else if ((xs instanceof $ac_Z)) {
    xs.u[idx] = (!(!value));
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$c_sr_ScalaRunTime$.prototype.array_clone__O__O = (function(xs) {
  if ((xs instanceof $ac_O)) {
    return xs.clone__O();
  } else if ((xs instanceof $ac_I)) {
    return xs.clone__O();
  } else if ((xs instanceof $ac_D)) {
    return xs.clone__O();
  } else if ((xs instanceof $ac_J)) {
    return xs.clone__O();
  } else if ((xs instanceof $ac_F)) {
    return xs.clone__O();
  } else if ((xs instanceof $ac_C)) {
    return xs.clone__O();
  } else if ((xs instanceof $ac_B)) {
    return xs.clone__O();
  } else if ((xs instanceof $ac_S)) {
    return xs.clone__O();
  } else if ((xs instanceof $ac_Z)) {
    return xs.clone__O();
  } else if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(xs);
  }
});
$c_sr_ScalaRunTime$.prototype._toString__s_Product__T = (function(x) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(x.productIterator__sc_Iterator(), (x.productPrefix__T() + "("), ",", ")");
});
$c_sr_ScalaRunTime$.prototype.genericWrapArray__O__sci_ArraySeq = (function(xs) {
  return ((xs === null) ? null : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(xs));
});
$c_sr_ScalaRunTime$.prototype.wrapRefArray__AO__sci_ArraySeq = (function(xs) {
  if ((xs === null)) {
    return null;
  } else if ((xs.u.length === 0)) {
    var this$1 = $m_sci_ArraySeq$();
    return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this$1);
  } else {
    return new $c_sci_ArraySeq$ofRef(xs);
  }
});
$c_sr_ScalaRunTime$.prototype.wrapIntArray__AI__sci_ArraySeq = (function(xs) {
  return ((xs !== null) ? new $c_sci_ArraySeq$ofInt(xs) : null);
});
$c_sr_ScalaRunTime$.prototype.wrapCharArray__AC__sci_ArraySeq = (function(xs) {
  return ((xs !== null) ? new $c_sci_ArraySeq$ofChar(xs) : null);
});
$c_sr_ScalaRunTime$.prototype.wrapByteArray__AB__sci_ArraySeq = (function(xs) {
  return ((xs !== null) ? new $c_sci_ArraySeq$ofByte(xs) : null);
});
$c_sr_ScalaRunTime$.prototype.wrapUnitArray__Ajl_Void__sci_ArraySeq = (function(xs) {
  return ((xs !== null) ? new $c_sci_ArraySeq$ofUnit(xs) : null);
});
var $d_sr_ScalaRunTime$ = new $TypeData().initClass($c_sr_ScalaRunTime$, "scala.runtime.ScalaRunTime$", ({
  sr_ScalaRunTime$: 1
}));
export { $d_sr_ScalaRunTime$ as $d_sr_ScalaRunTime$ };
var $n_sr_ScalaRunTime$;
function $m_sr_ScalaRunTime$() {
  if ((!$n_sr_ScalaRunTime$)) {
    $n_sr_ScalaRunTime$ = new $c_sr_ScalaRunTime$();
  }
  return $n_sr_ScalaRunTime$;
}
export { $m_sr_ScalaRunTime$ as $m_sr_ScalaRunTime$ };
/** @constructor */
function $c_sr_Statics$() {
}
export { $c_sr_Statics$ as $c_sr_Statics$ };
$c_sr_Statics$.prototype = new $h_O();
$c_sr_Statics$.prototype.constructor = $c_sr_Statics$;
/** @constructor */
function $h_sr_Statics$() {
}
export { $h_sr_Statics$ as $h_sr_Statics$ };
$h_sr_Statics$.prototype = $c_sr_Statics$.prototype;
$c_sr_Statics$.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0);
});
$c_sr_Statics$.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$c_sr_Statics$.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.avalanche__I__I((hash ^ length));
});
$c_sr_Statics$.prototype.avalanche__I__I = (function(h0) {
  var h = h0;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
$c_sr_Statics$.prototype.longHash__J__I = (function(lv) {
  var lo = lv.RTLong__f_lo;
  var hi = lv.RTLong__f_hi;
  return ((hi === (lo >> 31)) ? lo : (lo ^ hi));
});
$c_sr_Statics$.prototype.doubleHash__D__I = (function(dv) {
  var iv = $doubleToInt(dv);
  if ((iv === dv)) {
    return iv;
  } else {
    var this$1 = $m_RTLong$();
    var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(dv);
    var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if ((((4.294967296E9 * hi) + (lo >>> 0.0)) === dv)) {
      return (lo ^ hi);
    } else {
      var valueInt = (dv | 0);
      if (((valueInt === dv) && ((1.0 / dv) !== (-Infinity)))) {
        return valueInt;
      } else if ((dv !== dv)) {
        return 2146959360;
      } else {
        var fpBitsDataView = $fpBitsDataView;
        fpBitsDataView.setFloat64(0, dv, true);
        var lo$1 = (fpBitsDataView.getInt32(0, true) | 0);
        var hi$1 = (fpBitsDataView.getInt32(4, true) | 0);
        return (lo$1 ^ hi$1);
      }
    }
  }
});
$c_sr_Statics$.prototype.anyHash__O__I = (function(x) {
  if ((x === null)) {
    return 0;
  } else if (((typeof x) === "number")) {
    var x3 = (+x);
    return this.doubleHash__D__I(x3);
  } else if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return this.longHash__J__I(new $c_RTLong(lo, hi));
  } else {
    return $dp_hashCode__I(x);
  }
});
$c_sr_Statics$.prototype.ioobe__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_sr_Statics$ = new $TypeData().initClass($c_sr_Statics$, "scala.runtime.Statics$", ({
  sr_Statics$: 1
}));
export { $d_sr_Statics$ as $d_sr_Statics$ };
var $n_sr_Statics$;
function $m_sr_Statics$() {
  if ((!$n_sr_Statics$)) {
    $n_sr_Statics$ = new $c_sr_Statics$();
  }
  return $n_sr_Statics$;
}
export { $m_sr_Statics$ as $m_sr_Statics$ };
/** @constructor */
function $c_sr_Statics$PFMarker$() {
}
export { $c_sr_Statics$PFMarker$ as $c_sr_Statics$PFMarker$ };
$c_sr_Statics$PFMarker$.prototype = new $h_O();
$c_sr_Statics$PFMarker$.prototype.constructor = $c_sr_Statics$PFMarker$;
/** @constructor */
function $h_sr_Statics$PFMarker$() {
}
export { $h_sr_Statics$PFMarker$ as $h_sr_Statics$PFMarker$ };
$h_sr_Statics$PFMarker$.prototype = $c_sr_Statics$PFMarker$.prototype;
var $d_sr_Statics$PFMarker$ = new $TypeData().initClass($c_sr_Statics$PFMarker$, "scala.runtime.Statics$PFMarker$", ({
  sr_Statics$PFMarker$: 1
}));
export { $d_sr_Statics$PFMarker$ as $d_sr_Statics$PFMarker$ };
var $n_sr_Statics$PFMarker$;
function $m_sr_Statics$PFMarker$() {
  if ((!$n_sr_Statics$PFMarker$)) {
    $n_sr_Statics$PFMarker$ = new $c_sr_Statics$PFMarker$();
  }
  return $n_sr_Statics$PFMarker$;
}
export { $m_sr_Statics$PFMarker$ as $m_sr_Statics$PFMarker$ };
function $p_sr_Tuples$__xxlAppend__O__sr_TupleXXL__sr_TupleXXL($thiz, x, xxl) {
  var arr = new $ac_O(((1 + xxl.productArity__I()) | 0));
  arr.u[xxl.productArity__I()] = x;
  var src = xxl.sr_TupleXXL__f_es;
  var length = xxl.productArity__I();
  src.copyTo(0, arr, 0, length);
  return new $c_sr_TupleXXL(arr);
}
export { $p_sr_Tuples$__xxlAppend__O__sr_TupleXXL__sr_TupleXXL as $p_sr_Tuples$__xxlAppend__O__sr_TupleXXL__sr_TupleXXL };
function $p_sr_Tuples$__specialCaseAppend__O__s_Product__s_Product($thiz, x, self) {
  var x$2 = $m_T$package$EmptyTuple$();
  if ((x$2 === self)) {
    return new $c_T1(x);
  }
  if ((self instanceof $c_T1)) {
    var _1 = self.T1__f__1;
    return $ct_T2__O__O__(new $c_T2(), _1, x);
  }
  if ((self instanceof $c_T2)) {
    var _1$1 = self._1__O();
    var _2 = self._2__O();
    return new $c_T3(_1$1, _2, x);
  }
  if ((self instanceof $c_T3)) {
    var _1$2 = self.T3__f__1;
    var _2$1 = self.T3__f__2;
    var _3 = self.T3__f__3;
    return new $c_T4(_1$2, _2$1, _3, x);
  }
  if ((self instanceof $c_T4)) {
    var _1$3 = self.T4__f__1;
    var _2$2 = self.T4__f__2;
    var _3$1 = self.T4__f__3;
    var _4 = self.T4__f__4;
    return new $c_T5(_1$3, _2$2, _3$1, _4, x);
  }
  if ((self instanceof $c_T5)) {
    var _1$4 = self.T5__f__1;
    var _2$3 = self.T5__f__2;
    var _3$2 = self.T5__f__3;
    var _4$1 = self.T5__f__4;
    var _5 = self.T5__f__5;
    return new $c_T6(_1$4, _2$3, _3$2, _4$1, _5, x);
  }
  if ((self instanceof $c_T6)) {
    var _1$5 = self.T6__f__1;
    var _2$4 = self.T6__f__2;
    var _3$3 = self.T6__f__3;
    var _4$2 = self.T6__f__4;
    var _5$1 = self.T6__f__5;
    var _6 = self.T6__f__6;
    return new $c_T7(_1$5, _2$4, _3$3, _4$2, _5$1, _6, x);
  }
  if ((self instanceof $c_T7)) {
    var _1$6 = self.T7__f__1;
    var _2$5 = self.T7__f__2;
    var _3$4 = self.T7__f__3;
    var _4$3 = self.T7__f__4;
    var _5$2 = self.T7__f__5;
    var _6$1 = self.T7__f__6;
    var _7 = self.T7__f__7;
    return new $c_T8(_1$6, _2$5, _3$4, _4$3, _5$2, _6$1, _7, x);
  }
  if ((self instanceof $c_T8)) {
    var _1$7 = self.T8__f__1;
    var _2$6 = self.T8__f__2;
    var _3$5 = self.T8__f__3;
    var _4$4 = self.T8__f__4;
    var _5$3 = self.T8__f__5;
    var _6$2 = self.T8__f__6;
    var _7$1 = self.T8__f__7;
    var _8 = self.T8__f__8;
    return new $c_T9(_1$7, _2$6, _3$5, _4$4, _5$3, _6$2, _7$1, _8, x);
  }
  if ((self instanceof $c_T9)) {
    var _1$8 = self.T9__f__1;
    var _2$7 = self.T9__f__2;
    var _3$6 = self.T9__f__3;
    var _4$5 = self.T9__f__4;
    var _5$4 = self.T9__f__5;
    var _6$3 = self.T9__f__6;
    var _7$2 = self.T9__f__7;
    var _8$1 = self.T9__f__8;
    var _9 = self.T9__f__9;
    return new $c_T10(_1$8, _2$7, _3$6, _4$5, _5$4, _6$3, _7$2, _8$1, _9, x);
  }
  if ((self instanceof $c_T10)) {
    var _1$9 = self.T10__f__1;
    var _2$8 = self.T10__f__2;
    var _3$7 = self.T10__f__3;
    var _4$6 = self.T10__f__4;
    var _5$5 = self.T10__f__5;
    var _6$4 = self.T10__f__6;
    var _7$3 = self.T10__f__7;
    var _8$2 = self.T10__f__8;
    var _9$1 = self.T10__f__9;
    var _10 = self.T10__f__10;
    return new $c_T11(_1$9, _2$8, _3$7, _4$6, _5$5, _6$4, _7$3, _8$2, _9$1, _10, x);
  }
  if ((self instanceof $c_T11)) {
    var _1$10 = self.T11__f__1;
    var _2$9 = self.T11__f__2;
    var _3$8 = self.T11__f__3;
    var _4$7 = self.T11__f__4;
    var _5$6 = self.T11__f__5;
    var _6$5 = self.T11__f__6;
    var _7$4 = self.T11__f__7;
    var _8$3 = self.T11__f__8;
    var _9$2 = self.T11__f__9;
    var _10$1 = self.T11__f__10;
    var _11 = self.T11__f__11;
    return new $c_T12(_1$10, _2$9, _3$8, _4$7, _5$6, _6$5, _7$4, _8$3, _9$2, _10$1, _11, x);
  }
  if ((self instanceof $c_T12)) {
    var _1$11 = self.T12__f__1;
    var _2$10 = self.T12__f__2;
    var _3$9 = self.T12__f__3;
    var _4$8 = self.T12__f__4;
    var _5$7 = self.T12__f__5;
    var _6$6 = self.T12__f__6;
    var _7$5 = self.T12__f__7;
    var _8$4 = self.T12__f__8;
    var _9$3 = self.T12__f__9;
    var _10$2 = self.T12__f__10;
    var _11$1 = self.T12__f__11;
    var _12 = self.T12__f__12;
    return new $c_T13(_1$11, _2$10, _3$9, _4$8, _5$7, _6$6, _7$5, _8$4, _9$3, _10$2, _11$1, _12, x);
  }
  if ((self instanceof $c_T13)) {
    var _1$12 = self.T13__f__1;
    var _2$11 = self.T13__f__2;
    var _3$10 = self.T13__f__3;
    var _4$9 = self.T13__f__4;
    var _5$8 = self.T13__f__5;
    var _6$7 = self.T13__f__6;
    var _7$6 = self.T13__f__7;
    var _8$5 = self.T13__f__8;
    var _9$4 = self.T13__f__9;
    var _10$3 = self.T13__f__10;
    var _11$2 = self.T13__f__11;
    var _12$1 = self.T13__f__12;
    var _13 = self.T13__f__13;
    return new $c_T14(_1$12, _2$11, _3$10, _4$9, _5$8, _6$7, _7$6, _8$5, _9$4, _10$3, _11$2, _12$1, _13, x);
  }
  if ((self instanceof $c_T14)) {
    var _1$13 = self.T14__f__1;
    var _2$12 = self.T14__f__2;
    var _3$11 = self.T14__f__3;
    var _4$10 = self.T14__f__4;
    var _5$9 = self.T14__f__5;
    var _6$8 = self.T14__f__6;
    var _7$7 = self.T14__f__7;
    var _8$6 = self.T14__f__8;
    var _9$5 = self.T14__f__9;
    var _10$4 = self.T14__f__10;
    var _11$3 = self.T14__f__11;
    var _12$2 = self.T14__f__12;
    var _13$1 = self.T14__f__13;
    var _14 = self.T14__f__14;
    return new $c_T15(_1$13, _2$12, _3$11, _4$10, _5$9, _6$8, _7$7, _8$6, _9$5, _10$4, _11$3, _12$2, _13$1, _14, x);
  }
  if ((self instanceof $c_T15)) {
    var _1$14 = self.T15__f__1;
    var _2$13 = self.T15__f__2;
    var _3$12 = self.T15__f__3;
    var _4$11 = self.T15__f__4;
    var _5$10 = self.T15__f__5;
    var _6$9 = self.T15__f__6;
    var _7$8 = self.T15__f__7;
    var _8$7 = self.T15__f__8;
    var _9$6 = self.T15__f__9;
    var _10$5 = self.T15__f__10;
    var _11$4 = self.T15__f__11;
    var _12$3 = self.T15__f__12;
    var _13$2 = self.T15__f__13;
    var _14$1 = self.T15__f__14;
    var _15 = self.T15__f__15;
    return new $c_T16(_1$14, _2$13, _3$12, _4$11, _5$10, _6$9, _7$8, _8$7, _9$6, _10$5, _11$4, _12$3, _13$2, _14$1, _15, x);
  }
  if ((self instanceof $c_T16)) {
    var _1$15 = self.T16__f__1;
    var _2$14 = self.T16__f__2;
    var _3$13 = self.T16__f__3;
    var _4$12 = self.T16__f__4;
    var _5$11 = self.T16__f__5;
    var _6$10 = self.T16__f__6;
    var _7$9 = self.T16__f__7;
    var _8$8 = self.T16__f__8;
    var _9$7 = self.T16__f__9;
    var _10$6 = self.T16__f__10;
    var _11$5 = self.T16__f__11;
    var _12$4 = self.T16__f__12;
    var _13$3 = self.T16__f__13;
    var _14$2 = self.T16__f__14;
    var _15$1 = self.T16__f__15;
    var _16 = self.T16__f__16;
    return new $c_T17(_1$15, _2$14, _3$13, _4$12, _5$11, _6$10, _7$9, _8$8, _9$7, _10$6, _11$5, _12$4, _13$3, _14$2, _15$1, _16, x);
  }
  if ((self instanceof $c_T17)) {
    var _1$16 = self.T17__f__1;
    var _2$15 = self.T17__f__2;
    var _3$14 = self.T17__f__3;
    var _4$13 = self.T17__f__4;
    var _5$12 = self.T17__f__5;
    var _6$11 = self.T17__f__6;
    var _7$10 = self.T17__f__7;
    var _8$9 = self.T17__f__8;
    var _9$8 = self.T17__f__9;
    var _10$7 = self.T17__f__10;
    var _11$6 = self.T17__f__11;
    var _12$5 = self.T17__f__12;
    var _13$4 = self.T17__f__13;
    var _14$3 = self.T17__f__14;
    var _15$2 = self.T17__f__15;
    var _16$1 = self.T17__f__16;
    var _17 = self.T17__f__17;
    return new $c_T18(_1$16, _2$15, _3$14, _4$13, _5$12, _6$11, _7$10, _8$9, _9$8, _10$7, _11$6, _12$5, _13$4, _14$3, _15$2, _16$1, _17, x);
  }
  if ((self instanceof $c_T18)) {
    var _1$17 = self.T18__f__1;
    var _2$16 = self.T18__f__2;
    var _3$15 = self.T18__f__3;
    var _4$14 = self.T18__f__4;
    var _5$13 = self.T18__f__5;
    var _6$12 = self.T18__f__6;
    var _7$11 = self.T18__f__7;
    var _8$10 = self.T18__f__8;
    var _9$9 = self.T18__f__9;
    var _10$8 = self.T18__f__10;
    var _11$7 = self.T18__f__11;
    var _12$6 = self.T18__f__12;
    var _13$5 = self.T18__f__13;
    var _14$4 = self.T18__f__14;
    var _15$3 = self.T18__f__15;
    var _16$2 = self.T18__f__16;
    var _17$1 = self.T18__f__17;
    var _18 = self.T18__f__18;
    return new $c_T19(_1$17, _2$16, _3$15, _4$14, _5$13, _6$12, _7$11, _8$10, _9$9, _10$8, _11$7, _12$6, _13$5, _14$4, _15$3, _16$2, _17$1, _18, x);
  }
  if ((self instanceof $c_T19)) {
    var _1$18 = self.T19__f__1;
    var _2$17 = self.T19__f__2;
    var _3$16 = self.T19__f__3;
    var _4$15 = self.T19__f__4;
    var _5$14 = self.T19__f__5;
    var _6$13 = self.T19__f__6;
    var _7$12 = self.T19__f__7;
    var _8$11 = self.T19__f__8;
    var _9$10 = self.T19__f__9;
    var _10$9 = self.T19__f__10;
    var _11$8 = self.T19__f__11;
    var _12$7 = self.T19__f__12;
    var _13$6 = self.T19__f__13;
    var _14$5 = self.T19__f__14;
    var _15$4 = self.T19__f__15;
    var _16$3 = self.T19__f__16;
    var _17$2 = self.T19__f__17;
    var _18$1 = self.T19__f__18;
    var _19 = self.T19__f__19;
    return new $c_T20(_1$18, _2$17, _3$16, _4$15, _5$14, _6$13, _7$12, _8$11, _9$10, _10$9, _11$8, _12$7, _13$6, _14$5, _15$4, _16$3, _17$2, _18$1, _19, x);
  }
  if ((self instanceof $c_T20)) {
    var _1$19 = self.T20__f__1;
    var _2$18 = self.T20__f__2;
    var _3$17 = self.T20__f__3;
    var _4$16 = self.T20__f__4;
    var _5$15 = self.T20__f__5;
    var _6$14 = self.T20__f__6;
    var _7$13 = self.T20__f__7;
    var _8$12 = self.T20__f__8;
    var _9$11 = self.T20__f__9;
    var _10$10 = self.T20__f__10;
    var _11$9 = self.T20__f__11;
    var _12$8 = self.T20__f__12;
    var _13$7 = self.T20__f__13;
    var _14$6 = self.T20__f__14;
    var _15$5 = self.T20__f__15;
    var _16$4 = self.T20__f__16;
    var _17$3 = self.T20__f__17;
    var _18$2 = self.T20__f__18;
    var _19$1 = self.T20__f__19;
    var _20 = self.T20__f__20;
    return new $c_T21(_1$19, _2$18, _3$17, _4$16, _5$15, _6$14, _7$13, _8$12, _9$11, _10$10, _11$9, _12$8, _13$7, _14$6, _15$5, _16$4, _17$3, _18$2, _19$1, _20, x);
  }
  if ((self instanceof $c_T21)) {
    var _1$20 = self.T21__f__1;
    var _2$19 = self.T21__f__2;
    var _3$18 = self.T21__f__3;
    var _4$17 = self.T21__f__4;
    var _5$16 = self.T21__f__5;
    var _6$15 = self.T21__f__6;
    var _7$14 = self.T21__f__7;
    var _8$13 = self.T21__f__8;
    var _9$12 = self.T21__f__9;
    var _10$11 = self.T21__f__10;
    var _11$10 = self.T21__f__11;
    var _12$9 = self.T21__f__12;
    var _13$8 = self.T21__f__13;
    var _14$7 = self.T21__f__14;
    var _15$6 = self.T21__f__15;
    var _16$5 = self.T21__f__16;
    var _17$4 = self.T21__f__17;
    var _18$3 = self.T21__f__18;
    var _19$2 = self.T21__f__19;
    var _20$1 = self.T21__f__20;
    var _21 = self.T21__f__21;
    return new $c_T22(_1$20, _2$19, _3$18, _4$17, _5$16, _6$15, _7$14, _8$13, _9$12, _10$11, _11$10, _12$9, _13$8, _14$7, _15$6, _16$5, _17$4, _18$3, _19$2, _20$1, _21, x);
  }
  if ((self instanceof $c_T22)) {
    var arr = new $ac_O([self.T22__f__1, self.T22__f__2, self.T22__f__3, self.T22__f__4, self.T22__f__5, self.T22__f__6, self.T22__f__7, self.T22__f__8, self.T22__f__9, self.T22__f__10, self.T22__f__11, self.T22__f__12, self.T22__f__13, self.T22__f__14, self.T22__f__15, self.T22__f__16, self.T22__f__17, self.T22__f__18, self.T22__f__19, self.T22__f__20, self.T22__f__21, self.T22__f__22, x]);
    return new $c_sr_TupleXXL(arr);
  }
  throw new $c_s_MatchError(self);
}
export { $p_sr_Tuples$__specialCaseAppend__O__s_Product__s_Product as $p_sr_Tuples$__specialCaseAppend__O__s_Product__s_Product };
/** @constructor */
function $c_sr_Tuples$() {
}
export { $c_sr_Tuples$ as $c_sr_Tuples$ };
$c_sr_Tuples$.prototype = new $h_O();
$c_sr_Tuples$.prototype.constructor = $c_sr_Tuples$;
/** @constructor */
function $h_sr_Tuples$() {
}
export { $h_sr_Tuples$ as $h_sr_Tuples$ };
$h_sr_Tuples$.prototype = $c_sr_Tuples$.prototype;
$c_sr_Tuples$.prototype.toArray__s_Product__AO = (function(self) {
  var x = $m_T$package$EmptyTuple$();
  if ((x === self)) {
    return $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray;
  }
  if ((self instanceof $c_sr_TupleXXL)) {
    return self.toArray__AO();
  }
  if ((self !== null)) {
    return this.productToArray__s_Product__AO(self);
  }
  throw new $c_s_MatchError(self);
});
$c_sr_Tuples$.prototype.productToArray__s_Product__AO = (function(self) {
  var arr = new $ac_O(self.productArity__I());
  var i = 0;
  while ((i < arr.u.length)) {
    arr.u[i] = self.productElement__I__O(i);
    i = ((1 + i) | 0);
  }
  return arr;
});
$c_sr_Tuples$.prototype.fromArray__AO__s_Product = (function(xs) {
  var x7 = xs.u.length;
  switch (x7) {
    case 0: {
      return $m_T$package$EmptyTuple$();
      break;
    }
    case 1: {
      var _1 = xs.u[0];
      return new $c_T1(_1);
      break;
    }
    case 2: {
      var _1$1 = xs.u[0];
      var _2 = xs.u[1];
      return $ct_T2__O__O__(new $c_T2(), _1$1, _2);
      break;
    }
    case 3: {
      var _1$2 = xs.u[0];
      var _2$1 = xs.u[1];
      var _3 = xs.u[2];
      return new $c_T3(_1$2, _2$1, _3);
      break;
    }
    case 4: {
      var _1$3 = xs.u[0];
      var _2$2 = xs.u[1];
      var _3$1 = xs.u[2];
      var _4 = xs.u[3];
      return new $c_T4(_1$3, _2$2, _3$1, _4);
      break;
    }
    case 5: {
      var _1$4 = xs.u[0];
      var _2$3 = xs.u[1];
      var _3$2 = xs.u[2];
      var _4$1 = xs.u[3];
      var _5 = xs.u[4];
      return new $c_T5(_1$4, _2$3, _3$2, _4$1, _5);
      break;
    }
    case 6: {
      var _1$5 = xs.u[0];
      var _2$4 = xs.u[1];
      var _3$3 = xs.u[2];
      var _4$2 = xs.u[3];
      var _5$1 = xs.u[4];
      var _6 = xs.u[5];
      return new $c_T6(_1$5, _2$4, _3$3, _4$2, _5$1, _6);
      break;
    }
    case 7: {
      var _1$6 = xs.u[0];
      var _2$5 = xs.u[1];
      var _3$4 = xs.u[2];
      var _4$3 = xs.u[3];
      var _5$2 = xs.u[4];
      var _6$1 = xs.u[5];
      var _7 = xs.u[6];
      return new $c_T7(_1$6, _2$5, _3$4, _4$3, _5$2, _6$1, _7);
      break;
    }
    case 8: {
      var _1$7 = xs.u[0];
      var _2$6 = xs.u[1];
      var _3$5 = xs.u[2];
      var _4$4 = xs.u[3];
      var _5$3 = xs.u[4];
      var _6$2 = xs.u[5];
      var _7$1 = xs.u[6];
      var _8 = xs.u[7];
      return new $c_T8(_1$7, _2$6, _3$5, _4$4, _5$3, _6$2, _7$1, _8);
      break;
    }
    case 9: {
      var _1$8 = xs.u[0];
      var _2$7 = xs.u[1];
      var _3$6 = xs.u[2];
      var _4$5 = xs.u[3];
      var _5$4 = xs.u[4];
      var _6$3 = xs.u[5];
      var _7$2 = xs.u[6];
      var _8$1 = xs.u[7];
      var _9 = xs.u[8];
      return new $c_T9(_1$8, _2$7, _3$6, _4$5, _5$4, _6$3, _7$2, _8$1, _9);
      break;
    }
    case 10: {
      var _1$9 = xs.u[0];
      var _2$8 = xs.u[1];
      var _3$7 = xs.u[2];
      var _4$6 = xs.u[3];
      var _5$5 = xs.u[4];
      var _6$4 = xs.u[5];
      var _7$3 = xs.u[6];
      var _8$2 = xs.u[7];
      var _9$1 = xs.u[8];
      var _10 = xs.u[9];
      return new $c_T10(_1$9, _2$8, _3$7, _4$6, _5$5, _6$4, _7$3, _8$2, _9$1, _10);
      break;
    }
    case 11: {
      var _1$10 = xs.u[0];
      var _2$9 = xs.u[1];
      var _3$8 = xs.u[2];
      var _4$7 = xs.u[3];
      var _5$6 = xs.u[4];
      var _6$5 = xs.u[5];
      var _7$4 = xs.u[6];
      var _8$3 = xs.u[7];
      var _9$2 = xs.u[8];
      var _10$1 = xs.u[9];
      var _11 = xs.u[10];
      return new $c_T11(_1$10, _2$9, _3$8, _4$7, _5$6, _6$5, _7$4, _8$3, _9$2, _10$1, _11);
      break;
    }
    case 12: {
      var _1$11 = xs.u[0];
      var _2$10 = xs.u[1];
      var _3$9 = xs.u[2];
      var _4$8 = xs.u[3];
      var _5$7 = xs.u[4];
      var _6$6 = xs.u[5];
      var _7$5 = xs.u[6];
      var _8$4 = xs.u[7];
      var _9$3 = xs.u[8];
      var _10$2 = xs.u[9];
      var _11$1 = xs.u[10];
      var _12 = xs.u[11];
      return new $c_T12(_1$11, _2$10, _3$9, _4$8, _5$7, _6$6, _7$5, _8$4, _9$3, _10$2, _11$1, _12);
      break;
    }
    case 13: {
      var _1$12 = xs.u[0];
      var _2$11 = xs.u[1];
      var _3$10 = xs.u[2];
      var _4$9 = xs.u[3];
      var _5$8 = xs.u[4];
      var _6$7 = xs.u[5];
      var _7$6 = xs.u[6];
      var _8$5 = xs.u[7];
      var _9$4 = xs.u[8];
      var _10$3 = xs.u[9];
      var _11$2 = xs.u[10];
      var _12$1 = xs.u[11];
      var _13 = xs.u[12];
      return new $c_T13(_1$12, _2$11, _3$10, _4$9, _5$8, _6$7, _7$6, _8$5, _9$4, _10$3, _11$2, _12$1, _13);
      break;
    }
    case 14: {
      var _1$13 = xs.u[0];
      var _2$12 = xs.u[1];
      var _3$11 = xs.u[2];
      var _4$10 = xs.u[3];
      var _5$9 = xs.u[4];
      var _6$8 = xs.u[5];
      var _7$7 = xs.u[6];
      var _8$6 = xs.u[7];
      var _9$5 = xs.u[8];
      var _10$4 = xs.u[9];
      var _11$3 = xs.u[10];
      var _12$2 = xs.u[11];
      var _13$1 = xs.u[12];
      var _14 = xs.u[13];
      return new $c_T14(_1$13, _2$12, _3$11, _4$10, _5$9, _6$8, _7$7, _8$6, _9$5, _10$4, _11$3, _12$2, _13$1, _14);
      break;
    }
    case 15: {
      var _1$14 = xs.u[0];
      var _2$13 = xs.u[1];
      var _3$12 = xs.u[2];
      var _4$11 = xs.u[3];
      var _5$10 = xs.u[4];
      var _6$9 = xs.u[5];
      var _7$8 = xs.u[6];
      var _8$7 = xs.u[7];
      var _9$6 = xs.u[8];
      var _10$5 = xs.u[9];
      var _11$4 = xs.u[10];
      var _12$3 = xs.u[11];
      var _13$2 = xs.u[12];
      var _14$1 = xs.u[13];
      var _15 = xs.u[14];
      return new $c_T15(_1$14, _2$13, _3$12, _4$11, _5$10, _6$9, _7$8, _8$7, _9$6, _10$5, _11$4, _12$3, _13$2, _14$1, _15);
      break;
    }
    case 16: {
      var _1$15 = xs.u[0];
      var _2$14 = xs.u[1];
      var _3$13 = xs.u[2];
      var _4$12 = xs.u[3];
      var _5$11 = xs.u[4];
      var _6$10 = xs.u[5];
      var _7$9 = xs.u[6];
      var _8$8 = xs.u[7];
      var _9$7 = xs.u[8];
      var _10$6 = xs.u[9];
      var _11$5 = xs.u[10];
      var _12$4 = xs.u[11];
      var _13$3 = xs.u[12];
      var _14$2 = xs.u[13];
      var _15$1 = xs.u[14];
      var _16 = xs.u[15];
      return new $c_T16(_1$15, _2$14, _3$13, _4$12, _5$11, _6$10, _7$9, _8$8, _9$7, _10$6, _11$5, _12$4, _13$3, _14$2, _15$1, _16);
      break;
    }
    case 17: {
      var _1$16 = xs.u[0];
      var _2$15 = xs.u[1];
      var _3$14 = xs.u[2];
      var _4$13 = xs.u[3];
      var _5$12 = xs.u[4];
      var _6$11 = xs.u[5];
      var _7$10 = xs.u[6];
      var _8$9 = xs.u[7];
      var _9$8 = xs.u[8];
      var _10$7 = xs.u[9];
      var _11$6 = xs.u[10];
      var _12$5 = xs.u[11];
      var _13$4 = xs.u[12];
      var _14$3 = xs.u[13];
      var _15$2 = xs.u[14];
      var _16$1 = xs.u[15];
      var _17 = xs.u[16];
      return new $c_T17(_1$16, _2$15, _3$14, _4$13, _5$12, _6$11, _7$10, _8$9, _9$8, _10$7, _11$6, _12$5, _13$4, _14$3, _15$2, _16$1, _17);
      break;
    }
    case 18: {
      var _1$17 = xs.u[0];
      var _2$16 = xs.u[1];
      var _3$15 = xs.u[2];
      var _4$14 = xs.u[3];
      var _5$13 = xs.u[4];
      var _6$12 = xs.u[5];
      var _7$11 = xs.u[6];
      var _8$10 = xs.u[7];
      var _9$9 = xs.u[8];
      var _10$8 = xs.u[9];
      var _11$7 = xs.u[10];
      var _12$6 = xs.u[11];
      var _13$5 = xs.u[12];
      var _14$4 = xs.u[13];
      var _15$3 = xs.u[14];
      var _16$2 = xs.u[15];
      var _17$1 = xs.u[16];
      var _18 = xs.u[17];
      return new $c_T18(_1$17, _2$16, _3$15, _4$14, _5$13, _6$12, _7$11, _8$10, _9$9, _10$8, _11$7, _12$6, _13$5, _14$4, _15$3, _16$2, _17$1, _18);
      break;
    }
    case 19: {
      var _1$18 = xs.u[0];
      var _2$17 = xs.u[1];
      var _3$16 = xs.u[2];
      var _4$15 = xs.u[3];
      var _5$14 = xs.u[4];
      var _6$13 = xs.u[5];
      var _7$12 = xs.u[6];
      var _8$11 = xs.u[7];
      var _9$10 = xs.u[8];
      var _10$9 = xs.u[9];
      var _11$8 = xs.u[10];
      var _12$7 = xs.u[11];
      var _13$6 = xs.u[12];
      var _14$5 = xs.u[13];
      var _15$4 = xs.u[14];
      var _16$3 = xs.u[15];
      var _17$2 = xs.u[16];
      var _18$1 = xs.u[17];
      var _19 = xs.u[18];
      return new $c_T19(_1$18, _2$17, _3$16, _4$15, _5$14, _6$13, _7$12, _8$11, _9$10, _10$9, _11$8, _12$7, _13$6, _14$5, _15$4, _16$3, _17$2, _18$1, _19);
      break;
    }
    case 20: {
      var _1$19 = xs.u[0];
      var _2$18 = xs.u[1];
      var _3$17 = xs.u[2];
      var _4$16 = xs.u[3];
      var _5$15 = xs.u[4];
      var _6$14 = xs.u[5];
      var _7$13 = xs.u[6];
      var _8$12 = xs.u[7];
      var _9$11 = xs.u[8];
      var _10$10 = xs.u[9];
      var _11$9 = xs.u[10];
      var _12$8 = xs.u[11];
      var _13$7 = xs.u[12];
      var _14$6 = xs.u[13];
      var _15$5 = xs.u[14];
      var _16$4 = xs.u[15];
      var _17$3 = xs.u[16];
      var _18$2 = xs.u[17];
      var _19$1 = xs.u[18];
      var _20 = xs.u[19];
      return new $c_T20(_1$19, _2$18, _3$17, _4$16, _5$15, _6$14, _7$13, _8$12, _9$11, _10$10, _11$9, _12$8, _13$7, _14$6, _15$5, _16$4, _17$3, _18$2, _19$1, _20);
      break;
    }
    case 21: {
      var _1$20 = xs.u[0];
      var _2$19 = xs.u[1];
      var _3$18 = xs.u[2];
      var _4$17 = xs.u[3];
      var _5$16 = xs.u[4];
      var _6$15 = xs.u[5];
      var _7$14 = xs.u[6];
      var _8$13 = xs.u[7];
      var _9$12 = xs.u[8];
      var _10$11 = xs.u[9];
      var _11$10 = xs.u[10];
      var _12$9 = xs.u[11];
      var _13$8 = xs.u[12];
      var _14$7 = xs.u[13];
      var _15$6 = xs.u[14];
      var _16$5 = xs.u[15];
      var _17$4 = xs.u[16];
      var _18$3 = xs.u[17];
      var _19$2 = xs.u[18];
      var _20$1 = xs.u[19];
      var _21 = xs.u[20];
      return new $c_T21(_1$20, _2$19, _3$18, _4$17, _5$16, _6$15, _7$14, _8$13, _9$12, _10$11, _11$10, _12$9, _13$8, _14$7, _15$6, _16$5, _17$4, _18$3, _19$2, _20$1, _21);
      break;
    }
    case 22: {
      var _1$21 = xs.u[0];
      var _2$20 = xs.u[1];
      var _3$19 = xs.u[2];
      var _4$18 = xs.u[3];
      var _5$17 = xs.u[4];
      var _6$16 = xs.u[5];
      var _7$15 = xs.u[6];
      var _8$14 = xs.u[7];
      var _9$13 = xs.u[8];
      var _10$12 = xs.u[9];
      var _11$11 = xs.u[10];
      var _12$10 = xs.u[11];
      var _13$9 = xs.u[12];
      var _14$8 = xs.u[13];
      var _15$7 = xs.u[14];
      var _16$6 = xs.u[15];
      var _17$5 = xs.u[16];
      var _18$4 = xs.u[17];
      var _19$3 = xs.u[18];
      var _20$2 = xs.u[19];
      var _21$1 = xs.u[20];
      var _22 = xs.u[21];
      return new $c_T22(_1$21, _2$20, _3$19, _4$18, _5$17, _6$16, _7$15, _8$14, _9$13, _10$12, _11$11, _12$10, _13$9, _14$8, _15$7, _16$6, _17$5, _18$4, _19$3, _20$2, _21$1, _22);
      break;
    }
    default: {
      var elems = xs.clone__O();
      return new $c_sr_TupleXXL(elems);
    }
  }
});
$c_sr_Tuples$.prototype.fromIArray__AO__s_Product = (function(xs) {
  return ((xs.u.length <= 22) ? this.fromArray__AO__s_Product(xs) : new $c_sr_TupleXXL(xs));
});
$c_sr_Tuples$.prototype.fromProduct__s_Product__s_Product = (function(xs) {
  var x54 = xs.productArity__I();
  switch (x54) {
    case 0: {
      return $m_T$package$EmptyTuple$();
      break;
    }
    case 1: {
      if ((xs instanceof $c_T1)) {
        return xs;
      } else {
        var _1 = xs.productElement__I__O(0);
        return new $c_T1(_1);
      }
      break;
    }
    case 2: {
      if ((xs instanceof $c_T2)) {
        return xs;
      } else {
        var _1$1 = xs.productElement__I__O(0);
        var _2 = xs.productElement__I__O(1);
        return $ct_T2__O__O__(new $c_T2(), _1$1, _2);
      }
      break;
    }
    case 3: {
      if ((xs instanceof $c_T3)) {
        return xs;
      } else {
        var _1$2 = xs.productElement__I__O(0);
        var _2$1 = xs.productElement__I__O(1);
        var _3 = xs.productElement__I__O(2);
        return new $c_T3(_1$2, _2$1, _3);
      }
      break;
    }
    case 4: {
      if ((xs instanceof $c_T4)) {
        return xs;
      } else {
        var _1$3 = xs.productElement__I__O(0);
        var _2$2 = xs.productElement__I__O(1);
        var _3$1 = xs.productElement__I__O(2);
        var _4 = xs.productElement__I__O(3);
        return new $c_T4(_1$3, _2$2, _3$1, _4);
      }
      break;
    }
    case 5: {
      if ((xs instanceof $c_T5)) {
        return xs;
      } else {
        var _1$4 = xs.productElement__I__O(0);
        var _2$3 = xs.productElement__I__O(1);
        var _3$2 = xs.productElement__I__O(2);
        var _4$1 = xs.productElement__I__O(3);
        var _5 = xs.productElement__I__O(4);
        return new $c_T5(_1$4, _2$3, _3$2, _4$1, _5);
      }
      break;
    }
    case 6: {
      if ((xs instanceof $c_T6)) {
        return xs;
      } else {
        var _1$5 = xs.productElement__I__O(0);
        var _2$4 = xs.productElement__I__O(1);
        var _3$3 = xs.productElement__I__O(2);
        var _4$2 = xs.productElement__I__O(3);
        var _5$1 = xs.productElement__I__O(4);
        var _6 = xs.productElement__I__O(5);
        return new $c_T6(_1$5, _2$4, _3$3, _4$2, _5$1, _6);
      }
      break;
    }
    case 7: {
      if ((xs instanceof $c_T7)) {
        return xs;
      } else {
        var _1$6 = xs.productElement__I__O(0);
        var _2$5 = xs.productElement__I__O(1);
        var _3$4 = xs.productElement__I__O(2);
        var _4$3 = xs.productElement__I__O(3);
        var _5$2 = xs.productElement__I__O(4);
        var _6$1 = xs.productElement__I__O(5);
        var _7 = xs.productElement__I__O(6);
        return new $c_T7(_1$6, _2$5, _3$4, _4$3, _5$2, _6$1, _7);
      }
      break;
    }
    case 8: {
      if ((xs instanceof $c_T8)) {
        return xs;
      } else {
        var _1$7 = xs.productElement__I__O(0);
        var _2$6 = xs.productElement__I__O(1);
        var _3$5 = xs.productElement__I__O(2);
        var _4$4 = xs.productElement__I__O(3);
        var _5$3 = xs.productElement__I__O(4);
        var _6$2 = xs.productElement__I__O(5);
        var _7$1 = xs.productElement__I__O(6);
        var _8 = xs.productElement__I__O(7);
        return new $c_T8(_1$7, _2$6, _3$5, _4$4, _5$3, _6$2, _7$1, _8);
      }
      break;
    }
    case 9: {
      if ((xs instanceof $c_T9)) {
        return xs;
      } else {
        var _1$8 = xs.productElement__I__O(0);
        var _2$7 = xs.productElement__I__O(1);
        var _3$6 = xs.productElement__I__O(2);
        var _4$5 = xs.productElement__I__O(3);
        var _5$4 = xs.productElement__I__O(4);
        var _6$3 = xs.productElement__I__O(5);
        var _7$2 = xs.productElement__I__O(6);
        var _8$1 = xs.productElement__I__O(7);
        var _9 = xs.productElement__I__O(8);
        return new $c_T9(_1$8, _2$7, _3$6, _4$5, _5$4, _6$3, _7$2, _8$1, _9);
      }
      break;
    }
    case 10: {
      if ((xs instanceof $c_T10)) {
        return xs;
      } else {
        var _1$9 = xs.productElement__I__O(0);
        var _2$8 = xs.productElement__I__O(1);
        var _3$7 = xs.productElement__I__O(2);
        var _4$6 = xs.productElement__I__O(3);
        var _5$5 = xs.productElement__I__O(4);
        var _6$4 = xs.productElement__I__O(5);
        var _7$3 = xs.productElement__I__O(6);
        var _8$2 = xs.productElement__I__O(7);
        var _9$1 = xs.productElement__I__O(8);
        var _10 = xs.productElement__I__O(9);
        return new $c_T10(_1$9, _2$8, _3$7, _4$6, _5$5, _6$4, _7$3, _8$2, _9$1, _10);
      }
      break;
    }
    case 11: {
      if ((xs instanceof $c_T11)) {
        return xs;
      } else {
        var _1$10 = xs.productElement__I__O(0);
        var _2$9 = xs.productElement__I__O(1);
        var _3$8 = xs.productElement__I__O(2);
        var _4$7 = xs.productElement__I__O(3);
        var _5$6 = xs.productElement__I__O(4);
        var _6$5 = xs.productElement__I__O(5);
        var _7$4 = xs.productElement__I__O(6);
        var _8$3 = xs.productElement__I__O(7);
        var _9$2 = xs.productElement__I__O(8);
        var _10$1 = xs.productElement__I__O(9);
        var _11 = xs.productElement__I__O(10);
        return new $c_T11(_1$10, _2$9, _3$8, _4$7, _5$6, _6$5, _7$4, _8$3, _9$2, _10$1, _11);
      }
      break;
    }
    case 12: {
      if ((xs instanceof $c_T12)) {
        return xs;
      } else {
        var _1$11 = xs.productElement__I__O(0);
        var _2$10 = xs.productElement__I__O(1);
        var _3$9 = xs.productElement__I__O(2);
        var _4$8 = xs.productElement__I__O(3);
        var _5$7 = xs.productElement__I__O(4);
        var _6$6 = xs.productElement__I__O(5);
        var _7$5 = xs.productElement__I__O(6);
        var _8$4 = xs.productElement__I__O(7);
        var _9$3 = xs.productElement__I__O(8);
        var _10$2 = xs.productElement__I__O(9);
        var _11$1 = xs.productElement__I__O(10);
        var _12 = xs.productElement__I__O(11);
        return new $c_T12(_1$11, _2$10, _3$9, _4$8, _5$7, _6$6, _7$5, _8$4, _9$3, _10$2, _11$1, _12);
      }
      break;
    }
    case 13: {
      if ((xs instanceof $c_T13)) {
        return xs;
      } else {
        var _1$12 = xs.productElement__I__O(0);
        var _2$11 = xs.productElement__I__O(1);
        var _3$10 = xs.productElement__I__O(2);
        var _4$9 = xs.productElement__I__O(3);
        var _5$8 = xs.productElement__I__O(4);
        var _6$7 = xs.productElement__I__O(5);
        var _7$6 = xs.productElement__I__O(6);
        var _8$5 = xs.productElement__I__O(7);
        var _9$4 = xs.productElement__I__O(8);
        var _10$3 = xs.productElement__I__O(9);
        var _11$2 = xs.productElement__I__O(10);
        var _12$1 = xs.productElement__I__O(11);
        var _13 = xs.productElement__I__O(12);
        return new $c_T13(_1$12, _2$11, _3$10, _4$9, _5$8, _6$7, _7$6, _8$5, _9$4, _10$3, _11$2, _12$1, _13);
      }
      break;
    }
    case 14: {
      if ((xs instanceof $c_T14)) {
        return xs;
      } else {
        var _1$13 = xs.productElement__I__O(0);
        var _2$12 = xs.productElement__I__O(1);
        var _3$11 = xs.productElement__I__O(2);
        var _4$10 = xs.productElement__I__O(3);
        var _5$9 = xs.productElement__I__O(4);
        var _6$8 = xs.productElement__I__O(5);
        var _7$7 = xs.productElement__I__O(6);
        var _8$6 = xs.productElement__I__O(7);
        var _9$5 = xs.productElement__I__O(8);
        var _10$4 = xs.productElement__I__O(9);
        var _11$3 = xs.productElement__I__O(10);
        var _12$2 = xs.productElement__I__O(11);
        var _13$1 = xs.productElement__I__O(12);
        var _14 = xs.productElement__I__O(13);
        return new $c_T14(_1$13, _2$12, _3$11, _4$10, _5$9, _6$8, _7$7, _8$6, _9$5, _10$4, _11$3, _12$2, _13$1, _14);
      }
      break;
    }
    case 15: {
      if ((xs instanceof $c_T15)) {
        return xs;
      } else {
        var _1$14 = xs.productElement__I__O(0);
        var _2$13 = xs.productElement__I__O(1);
        var _3$12 = xs.productElement__I__O(2);
        var _4$11 = xs.productElement__I__O(3);
        var _5$10 = xs.productElement__I__O(4);
        var _6$9 = xs.productElement__I__O(5);
        var _7$8 = xs.productElement__I__O(6);
        var _8$7 = xs.productElement__I__O(7);
        var _9$6 = xs.productElement__I__O(8);
        var _10$5 = xs.productElement__I__O(9);
        var _11$4 = xs.productElement__I__O(10);
        var _12$3 = xs.productElement__I__O(11);
        var _13$2 = xs.productElement__I__O(12);
        var _14$1 = xs.productElement__I__O(13);
        var _15 = xs.productElement__I__O(14);
        return new $c_T15(_1$14, _2$13, _3$12, _4$11, _5$10, _6$9, _7$8, _8$7, _9$6, _10$5, _11$4, _12$3, _13$2, _14$1, _15);
      }
      break;
    }
    case 16: {
      if ((xs instanceof $c_T16)) {
        return xs;
      } else {
        var _1$15 = xs.productElement__I__O(0);
        var _2$14 = xs.productElement__I__O(1);
        var _3$13 = xs.productElement__I__O(2);
        var _4$12 = xs.productElement__I__O(3);
        var _5$11 = xs.productElement__I__O(4);
        var _6$10 = xs.productElement__I__O(5);
        var _7$9 = xs.productElement__I__O(6);
        var _8$8 = xs.productElement__I__O(7);
        var _9$7 = xs.productElement__I__O(8);
        var _10$6 = xs.productElement__I__O(9);
        var _11$5 = xs.productElement__I__O(10);
        var _12$4 = xs.productElement__I__O(11);
        var _13$3 = xs.productElement__I__O(12);
        var _14$2 = xs.productElement__I__O(13);
        var _15$1 = xs.productElement__I__O(14);
        var _16 = xs.productElement__I__O(15);
        return new $c_T16(_1$15, _2$14, _3$13, _4$12, _5$11, _6$10, _7$9, _8$8, _9$7, _10$6, _11$5, _12$4, _13$3, _14$2, _15$1, _16);
      }
      break;
    }
    case 17: {
      if ((xs instanceof $c_T17)) {
        return xs;
      } else {
        var _1$16 = xs.productElement__I__O(0);
        var _2$15 = xs.productElement__I__O(1);
        var _3$14 = xs.productElement__I__O(2);
        var _4$13 = xs.productElement__I__O(3);
        var _5$12 = xs.productElement__I__O(4);
        var _6$11 = xs.productElement__I__O(5);
        var _7$10 = xs.productElement__I__O(6);
        var _8$9 = xs.productElement__I__O(7);
        var _9$8 = xs.productElement__I__O(8);
        var _10$7 = xs.productElement__I__O(9);
        var _11$6 = xs.productElement__I__O(10);
        var _12$5 = xs.productElement__I__O(11);
        var _13$4 = xs.productElement__I__O(12);
        var _14$3 = xs.productElement__I__O(13);
        var _15$2 = xs.productElement__I__O(14);
        var _16$1 = xs.productElement__I__O(15);
        var _17 = xs.productElement__I__O(16);
        return new $c_T17(_1$16, _2$15, _3$14, _4$13, _5$12, _6$11, _7$10, _8$9, _9$8, _10$7, _11$6, _12$5, _13$4, _14$3, _15$2, _16$1, _17);
      }
      break;
    }
    case 18: {
      if ((xs instanceof $c_T18)) {
        return xs;
      } else {
        var _1$17 = xs.productElement__I__O(0);
        var _2$16 = xs.productElement__I__O(1);
        var _3$15 = xs.productElement__I__O(2);
        var _4$14 = xs.productElement__I__O(3);
        var _5$13 = xs.productElement__I__O(4);
        var _6$12 = xs.productElement__I__O(5);
        var _7$11 = xs.productElement__I__O(6);
        var _8$10 = xs.productElement__I__O(7);
        var _9$9 = xs.productElement__I__O(8);
        var _10$8 = xs.productElement__I__O(9);
        var _11$7 = xs.productElement__I__O(10);
        var _12$6 = xs.productElement__I__O(11);
        var _13$5 = xs.productElement__I__O(12);
        var _14$4 = xs.productElement__I__O(13);
        var _15$3 = xs.productElement__I__O(14);
        var _16$2 = xs.productElement__I__O(15);
        var _17$1 = xs.productElement__I__O(16);
        var _18 = xs.productElement__I__O(17);
        return new $c_T18(_1$17, _2$16, _3$15, _4$14, _5$13, _6$12, _7$11, _8$10, _9$9, _10$8, _11$7, _12$6, _13$5, _14$4, _15$3, _16$2, _17$1, _18);
      }
      break;
    }
    case 19: {
      if ((xs instanceof $c_T19)) {
        return xs;
      } else {
        var _1$18 = xs.productElement__I__O(0);
        var _2$17 = xs.productElement__I__O(1);
        var _3$16 = xs.productElement__I__O(2);
        var _4$15 = xs.productElement__I__O(3);
        var _5$14 = xs.productElement__I__O(4);
        var _6$13 = xs.productElement__I__O(5);
        var _7$12 = xs.productElement__I__O(6);
        var _8$11 = xs.productElement__I__O(7);
        var _9$10 = xs.productElement__I__O(8);
        var _10$9 = xs.productElement__I__O(9);
        var _11$8 = xs.productElement__I__O(10);
        var _12$7 = xs.productElement__I__O(11);
        var _13$6 = xs.productElement__I__O(12);
        var _14$5 = xs.productElement__I__O(13);
        var _15$4 = xs.productElement__I__O(14);
        var _16$3 = xs.productElement__I__O(15);
        var _17$2 = xs.productElement__I__O(16);
        var _18$1 = xs.productElement__I__O(17);
        var _19 = xs.productElement__I__O(18);
        return new $c_T19(_1$18, _2$17, _3$16, _4$15, _5$14, _6$13, _7$12, _8$11, _9$10, _10$9, _11$8, _12$7, _13$6, _14$5, _15$4, _16$3, _17$2, _18$1, _19);
      }
      break;
    }
    case 20: {
      if ((xs instanceof $c_T20)) {
        return xs;
      } else {
        var _1$19 = xs.productElement__I__O(0);
        var _2$18 = xs.productElement__I__O(1);
        var _3$17 = xs.productElement__I__O(2);
        var _4$16 = xs.productElement__I__O(3);
        var _5$15 = xs.productElement__I__O(4);
        var _6$14 = xs.productElement__I__O(5);
        var _7$13 = xs.productElement__I__O(6);
        var _8$12 = xs.productElement__I__O(7);
        var _9$11 = xs.productElement__I__O(8);
        var _10$10 = xs.productElement__I__O(9);
        var _11$9 = xs.productElement__I__O(10);
        var _12$8 = xs.productElement__I__O(11);
        var _13$7 = xs.productElement__I__O(12);
        var _14$6 = xs.productElement__I__O(13);
        var _15$5 = xs.productElement__I__O(14);
        var _16$4 = xs.productElement__I__O(15);
        var _17$3 = xs.productElement__I__O(16);
        var _18$2 = xs.productElement__I__O(17);
        var _19$1 = xs.productElement__I__O(18);
        var _20 = xs.productElement__I__O(19);
        return new $c_T20(_1$19, _2$18, _3$17, _4$16, _5$15, _6$14, _7$13, _8$12, _9$11, _10$10, _11$9, _12$8, _13$7, _14$6, _15$5, _16$4, _17$3, _18$2, _19$1, _20);
      }
      break;
    }
    case 21: {
      if ((xs instanceof $c_T21)) {
        return xs;
      } else {
        var _1$20 = xs.productElement__I__O(0);
        var _2$19 = xs.productElement__I__O(1);
        var _3$18 = xs.productElement__I__O(2);
        var _4$17 = xs.productElement__I__O(3);
        var _5$16 = xs.productElement__I__O(4);
        var _6$15 = xs.productElement__I__O(5);
        var _7$14 = xs.productElement__I__O(6);
        var _8$13 = xs.productElement__I__O(7);
        var _9$12 = xs.productElement__I__O(8);
        var _10$11 = xs.productElement__I__O(9);
        var _11$10 = xs.productElement__I__O(10);
        var _12$9 = xs.productElement__I__O(11);
        var _13$8 = xs.productElement__I__O(12);
        var _14$7 = xs.productElement__I__O(13);
        var _15$6 = xs.productElement__I__O(14);
        var _16$5 = xs.productElement__I__O(15);
        var _17$4 = xs.productElement__I__O(16);
        var _18$3 = xs.productElement__I__O(17);
        var _19$2 = xs.productElement__I__O(18);
        var _20$1 = xs.productElement__I__O(19);
        var _21 = xs.productElement__I__O(20);
        return new $c_T21(_1$20, _2$19, _3$18, _4$17, _5$16, _6$15, _7$14, _8$13, _9$12, _10$11, _11$10, _12$9, _13$8, _14$7, _15$6, _16$5, _17$4, _18$3, _19$2, _20$1, _21);
      }
      break;
    }
    case 22: {
      if ((xs instanceof $c_T22)) {
        return xs;
      } else {
        var _1$21 = xs.productElement__I__O(0);
        var _2$20 = xs.productElement__I__O(1);
        var _3$19 = xs.productElement__I__O(2);
        var _4$18 = xs.productElement__I__O(3);
        var _5$17 = xs.productElement__I__O(4);
        var _6$16 = xs.productElement__I__O(5);
        var _7$15 = xs.productElement__I__O(6);
        var _8$14 = xs.productElement__I__O(7);
        var _9$13 = xs.productElement__I__O(8);
        var _10$12 = xs.productElement__I__O(9);
        var _11$11 = xs.productElement__I__O(10);
        var _12$10 = xs.productElement__I__O(11);
        var _13$9 = xs.productElement__I__O(12);
        var _14$8 = xs.productElement__I__O(13);
        var _15$7 = xs.productElement__I__O(14);
        var _16$6 = xs.productElement__I__O(15);
        var _17$5 = xs.productElement__I__O(16);
        var _18$4 = xs.productElement__I__O(17);
        var _19$3 = xs.productElement__I__O(18);
        var _20$2 = xs.productElement__I__O(19);
        var _21$1 = xs.productElement__I__O(20);
        var _22 = xs.productElement__I__O(21);
        return new $c_T22(_1$21, _2$20, _3$19, _4$18, _5$17, _6$16, _7$15, _8$14, _9$13, _10$12, _11$11, _12$10, _13$9, _14$8, _15$7, _16$6, _17$5, _18$4, _19$3, _20$2, _21$1, _22);
      }
      break;
    }
    default: {
      if ((xs instanceof $c_sr_TupleXXL)) {
        return xs;
      } else {
        var this$23 = xs.productIterator__sc_Iterator();
        var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => _$1));
        var this$25 = new $c_sc_Iterator$$anon$9(this$23, f);
        if ((this$25.knownSize__I() >= 0)) {
          var len = this$25.knownSize__I();
          var destination = new $ac_O(len);
          $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$25, destination, 0, 2147483647);
          var elems = destination;
        } else {
          var capacity = 0;
          var size = 0;
          var jsElems = null;
          capacity = 0;
          size = 0;
          jsElems = [];
          while (this$25.hasNext__Z()) {
            var elem = this$25.next__O();
            var unboxedElem = ((elem === null) ? null : elem);
            jsElems.push(unboxedElem);
          }
          var elems = new $ac_O(jsElems);
        }
        return new $c_sr_TupleXXL(elems);
      }
    }
  }
});
$c_sr_Tuples$.prototype.append__O__s_Product__s_Product = (function(x, self) {
  return ((self instanceof $c_sr_TupleXXL) ? $p_sr_Tuples$__xxlAppend__O__sr_TupleXXL__sr_TupleXXL(this, x, self) : $p_sr_Tuples$__specialCaseAppend__O__s_Product__s_Product(this, x, self));
});
$c_sr_Tuples$.prototype.isInstanceOfNonEmptyTuple__O__Z = (function(x) {
  if ($is_s_Product(x)) {
    var x203 = x.productArity__I();
    switch (x203) {
      case 1: {
        return (x instanceof $c_T1);
        break;
      }
      case 2: {
        return (x instanceof $c_T2);
        break;
      }
      case 3: {
        return (x instanceof $c_T3);
        break;
      }
      case 4: {
        return (x instanceof $c_T4);
        break;
      }
      case 5: {
        return (x instanceof $c_T5);
        break;
      }
      case 6: {
        return (x instanceof $c_T6);
        break;
      }
      case 7: {
        return (x instanceof $c_T7);
        break;
      }
      case 8: {
        return (x instanceof $c_T8);
        break;
      }
      case 9: {
        return (x instanceof $c_T9);
        break;
      }
      case 10: {
        return (x instanceof $c_T10);
        break;
      }
      case 11: {
        return (x instanceof $c_T11);
        break;
      }
      case 12: {
        return (x instanceof $c_T12);
        break;
      }
      case 13: {
        return (x instanceof $c_T13);
        break;
      }
      case 14: {
        return (x instanceof $c_T14);
        break;
      }
      case 15: {
        return (x instanceof $c_T15);
        break;
      }
      case 16: {
        return (x instanceof $c_T16);
        break;
      }
      case 17: {
        return (x instanceof $c_T17);
        break;
      }
      case 18: {
        return (x instanceof $c_T18);
        break;
      }
      case 19: {
        return (x instanceof $c_T19);
        break;
      }
      case 20: {
        return (x instanceof $c_T20);
        break;
      }
      case 21: {
        return (x instanceof $c_T21);
        break;
      }
      case 22: {
        return (x instanceof $c_T22);
        break;
      }
      default: {
        return (x instanceof $c_sr_TupleXXL);
      }
    }
  } else {
    return false;
  }
});
var $d_sr_Tuples$ = new $TypeData().initClass($c_sr_Tuples$, "scala.runtime.Tuples$", ({
  sr_Tuples$: 1
}));
export { $d_sr_Tuples$ as $d_sr_Tuples$ };
var $n_sr_Tuples$;
function $m_sr_Tuples$() {
  if ((!$n_sr_Tuples$)) {
    $n_sr_Tuples$ = new $c_sr_Tuples$();
  }
  return $n_sr_Tuples$;
}
export { $m_sr_Tuples$ as $m_sr_Tuples$ };
/** @constructor */
function $c_sjs_js_JSConverters$JSRichFuture$() {
}
export { $c_sjs_js_JSConverters$JSRichFuture$ as $c_sjs_js_JSConverters$JSRichFuture$ };
$c_sjs_js_JSConverters$JSRichFuture$.prototype = new $h_O();
$c_sjs_js_JSConverters$JSRichFuture$.prototype.constructor = $c_sjs_js_JSConverters$JSRichFuture$;
/** @constructor */
function $h_sjs_js_JSConverters$JSRichFuture$() {
}
export { $h_sjs_js_JSConverters$JSRichFuture$ as $h_sjs_js_JSConverters$JSRichFuture$ };
$h_sjs_js_JSConverters$JSRichFuture$.prototype = $c_sjs_js_JSConverters$JSRichFuture$.prototype;
$c_sjs_js_JSConverters$JSRichFuture$.prototype.toJSPromise$extension__s_concurrent_Future__s_concurrent_ExecutionContext__sjs_js_Promise = (function(this$, ec) {
  return new Promise(((arg1$2, arg2$2) => {
    this$.onComplete__F1__s_concurrent_ExecutionContext__V(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x0$1$2$2) => {
      if ((x0$1$2$2 instanceof $c_s_util_Success)) {
        var value = x0$1$2$2.s_util_Success__f_value;
        return arg1$2(value);
      } else if ((x0$1$2$2 instanceof $c_s_util_Failure)) {
        var th = x0$1$2$2.s_util_Failure__f_exception;
        var $x_2 = th;
        var $x_1 = (($x_2 instanceof $c_sjs_js_JavaScriptException) ? $x_2.sjs_js_JavaScriptException__f_exception : $x_2);
        return arg2$2($x_1);
      } else {
        throw new $c_s_MatchError(x0$1$2$2);
      }
    })), ec);
  }));
});
var $d_sjs_js_JSConverters$JSRichFuture$ = new $TypeData().initClass($c_sjs_js_JSConverters$JSRichFuture$, "scala.scalajs.js.JSConverters$JSRichFuture$", ({
  sjs_js_JSConverters$JSRichFuture$: 1
}));
export { $d_sjs_js_JSConverters$JSRichFuture$ as $d_sjs_js_JSConverters$JSRichFuture$ };
var $n_sjs_js_JSConverters$JSRichFuture$;
function $m_sjs_js_JSConverters$JSRichFuture$() {
  if ((!$n_sjs_js_JSConverters$JSRichFuture$)) {
    $n_sjs_js_JSConverters$JSRichFuture$ = new $c_sjs_js_JSConverters$JSRichFuture$();
  }
  return $n_sjs_js_JSConverters$JSRichFuture$;
}
export { $m_sjs_js_JSConverters$JSRichFuture$ as $m_sjs_js_JSConverters$JSRichFuture$ };
/** @constructor */
function $c_sjs_js_defined$() {
}
export { $c_sjs_js_defined$ as $c_sjs_js_defined$ };
$c_sjs_js_defined$.prototype = new $h_O();
$c_sjs_js_defined$.prototype.constructor = $c_sjs_js_defined$;
/** @constructor */
function $h_sjs_js_defined$() {
}
export { $h_sjs_js_defined$ as $h_sjs_js_defined$ };
$h_sjs_js_defined$.prototype = $c_sjs_js_defined$.prototype;
$c_sjs_js_defined$.prototype.apply__O__sjs_js_$bar = (function(a) {
  return a;
});
var $d_sjs_js_defined$ = new $TypeData().initClass($c_sjs_js_defined$, "scala.scalajs.js.defined$", ({
  sjs_js_defined$: 1
}));
export { $d_sjs_js_defined$ as $d_sjs_js_defined$ };
var $n_sjs_js_defined$;
function $m_sjs_js_defined$() {
  if ((!$n_sjs_js_defined$)) {
    $n_sjs_js_defined$ = new $c_sjs_js_defined$();
  }
  return $n_sjs_js_defined$;
}
export { $m_sjs_js_defined$ as $m_sjs_js_defined$ };
/** @constructor */
function $c_sjs_js_timers_package$() {
}
export { $c_sjs_js_timers_package$ as $c_sjs_js_timers_package$ };
$c_sjs_js_timers_package$.prototype = new $h_O();
$c_sjs_js_timers_package$.prototype.constructor = $c_sjs_js_timers_package$;
/** @constructor */
function $h_sjs_js_timers_package$() {
}
export { $h_sjs_js_timers_package$ as $h_sjs_js_timers_package$ };
$h_sjs_js_timers_package$.prototype = $c_sjs_js_timers_package$.prototype;
$c_sjs_js_timers_package$.prototype.setTimeout__D__F0__sjs_js_timers_SetTimeoutHandle = (function(interval, body) {
  return setTimeout((() => {
    body.apply__O();
  }), interval);
});
$c_sjs_js_timers_package$.prototype.setTimeout__s_concurrent_duration_FiniteDuration__F0__sjs_js_timers_SetTimeoutHandle = (function(interval, body) {
  var $x_1 = setTimeout;
  var a = interval.s_concurrent_duration_FiniteDuration__f_unit.toMillis__J__J(interval.s_concurrent_duration_FiniteDuration__f_length);
  var lo = a.RTLong__f_lo;
  var hi = a.RTLong__f_hi;
  return $x_1((() => {
    body.apply__O();
  }), ((4.294967296E9 * hi) + (lo >>> 0.0)));
});
$c_sjs_js_timers_package$.prototype.clearTimeout__sjs_js_timers_SetTimeoutHandle__V = (function(handle) {
  clearTimeout(handle);
});
var $d_sjs_js_timers_package$ = new $TypeData().initClass($c_sjs_js_timers_package$, "scala.scalajs.js.timers.package$", ({
  sjs_js_timers_package$: 1
}));
export { $d_sjs_js_timers_package$ as $d_sjs_js_timers_package$ };
var $n_sjs_js_timers_package$;
function $m_sjs_js_timers_package$() {
  if ((!$n_sjs_js_timers_package$)) {
    $n_sjs_js_timers_package$ = new $c_sjs_js_timers_package$();
  }
  return $n_sjs_js_timers_package$;
}
export { $m_sjs_js_timers_package$ as $m_sjs_js_timers_package$ };
/** @constructor */
function $c_sjs_reflect_Reflect$() {
  this.sjs_reflect_Reflect$__f_loadableModuleClasses = null;
  this.sjs_reflect_Reflect$__f_instantiatableClasses = null;
  $n_sjs_reflect_Reflect$ = this;
  this.sjs_reflect_Reflect$__f_loadableModuleClasses = $ct_scm_HashMap__(new $c_scm_HashMap());
  this.sjs_reflect_Reflect$__f_instantiatableClasses = $ct_scm_HashMap__(new $c_scm_HashMap());
}
export { $c_sjs_reflect_Reflect$ as $c_sjs_reflect_Reflect$ };
$c_sjs_reflect_Reflect$.prototype = new $h_O();
$c_sjs_reflect_Reflect$.prototype.constructor = $c_sjs_reflect_Reflect$;
/** @constructor */
function $h_sjs_reflect_Reflect$() {
}
export { $h_sjs_reflect_Reflect$ as $h_sjs_reflect_Reflect$ };
$h_sjs_reflect_Reflect$.prototype = $c_sjs_reflect_Reflect$.prototype;
var $d_sjs_reflect_Reflect$ = new $TypeData().initClass($c_sjs_reflect_Reflect$, "scala.scalajs.reflect.Reflect$", ({
  sjs_reflect_Reflect$: 1
}));
export { $d_sjs_reflect_Reflect$ as $d_sjs_reflect_Reflect$ };
var $n_sjs_reflect_Reflect$;
function $m_sjs_reflect_Reflect$() {
  if ((!$n_sjs_reflect_Reflect$)) {
    $n_sjs_reflect_Reflect$ = new $c_sjs_reflect_Reflect$();
  }
  return $n_sjs_reflect_Reflect$;
}
export { $m_sjs_reflect_Reflect$ as $m_sjs_reflect_Reflect$ };
/** @constructor */
function $c_sjsr_Compat$() {
}
export { $c_sjsr_Compat$ as $c_sjsr_Compat$ };
$c_sjsr_Compat$.prototype = new $h_O();
$c_sjsr_Compat$.prototype.constructor = $c_sjsr_Compat$;
/** @constructor */
function $h_sjsr_Compat$() {
}
export { $h_sjsr_Compat$ as $h_sjsr_Compat$ };
$h_sjsr_Compat$.prototype = $c_sjsr_Compat$.prototype;
$c_sjsr_Compat$.prototype.toJSVarArgsImpl__sci_Seq__sjs_js_Array = (function(seq) {
  if ((seq instanceof $c_sjsr_WrappedVarArgs)) {
    return seq.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array;
  } else {
    var result = [];
    seq.foreach__F1__V(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => (result.push(x$2$2) | 0))));
    return result;
  }
});
var $d_sjsr_Compat$ = new $TypeData().initClass($c_sjsr_Compat$, "scala.scalajs.runtime.Compat$", ({
  sjsr_Compat$: 1
}));
export { $d_sjsr_Compat$ as $d_sjsr_Compat$ };
var $n_sjsr_Compat$;
function $m_sjsr_Compat$() {
  if ((!$n_sjsr_Compat$)) {
    $n_sjsr_Compat$ = new $c_sjsr_Compat$();
  }
  return $n_sjsr_Compat$;
}
export { $m_sjsr_Compat$ as $m_sjsr_Compat$ };
/** @constructor */
function $c_s_sys_package$() {
}
export { $c_s_sys_package$ as $c_s_sys_package$ };
$c_s_sys_package$.prototype = new $h_O();
$c_s_sys_package$.prototype.constructor = $c_s_sys_package$;
/** @constructor */
function $h_s_sys_package$() {
}
export { $h_s_sys_package$ as $h_s_sys_package$ };
$h_s_sys_package$.prototype = $c_s_sys_package$.prototype;
$c_s_sys_package$.prototype.error__T__E = (function(message) {
  throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), message);
});
var $d_s_sys_package$ = new $TypeData().initClass($c_s_sys_package$, "scala.sys.package$", ({
  s_sys_package$: 1
}));
export { $d_s_sys_package$ as $d_s_sys_package$ };
var $n_s_sys_package$;
function $m_s_sys_package$() {
  if ((!$n_s_sys_package$)) {
    $n_s_sys_package$ = new $c_s_sys_package$();
  }
  return $n_s_sys_package$;
}
export { $m_s_sys_package$ as $m_s_sys_package$ };
/** @constructor */
function $c_s_util_Sorting$() {
}
export { $c_s_util_Sorting$ as $c_s_util_Sorting$ };
$c_s_util_Sorting$.prototype = new $h_O();
$c_s_util_Sorting$.prototype.constructor = $c_s_util_Sorting$;
/** @constructor */
function $h_s_util_Sorting$() {
}
export { $h_s_util_Sorting$ as $h_s_util_Sorting$ };
$h_s_util_Sorting$.prototype = $c_s_util_Sorting$.prototype;
$c_s_util_Sorting$.prototype.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V = (function(a, i0, iN, ord) {
  var n = ((iN - i0) | 0);
  if ((n < 2)) {
    return (void 0);
  }
  if ((ord.compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0))) > 0)) {
    var temp = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i0);
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i0, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((1 + i0) | 0)));
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ((1 + i0) | 0), temp);
  }
  var m = 2;
  while ((m < n)) {
    var next = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ((i0 + m) | 0));
    if ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + ((i0 + m) | 0)) | 0))) < 0)) {
      var iA = i0;
      var iB = (((-1) + ((i0 + m) | 0)) | 0);
      while ((((iB - iA) | 0) > 1)) {
        var ix = ((((iA + iB) | 0) >>> 1) | 0);
        if ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, ix)) < 0)) {
          iB = ix;
        } else {
          iA = ix;
        }
      }
      var ix$2 = ((iA + ((ord.compare__O__O__I(next, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iA)) < 0) ? 0 : 1)) | 0);
      var i = ((i0 + m) | 0);
      while ((i > ix$2)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, i, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + i) | 0)));
        i = (((-1) + i) | 0);
      }
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, ix$2, next);
    }
    m = ((1 + m) | 0);
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V = (function(a, i0, iN, ord, scratch, evidence$2) {
  if ((((iN - i0) | 0) < 32)) {
    this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, i0, iN, ord);
  } else {
    var iK = ((((i0 + iN) | 0) >>> 1) | 0);
    var sc = ((scratch === null) ? evidence$2.newArray__I__O(((iK - i0) | 0)) : scratch);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, i0, iK, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK, iN, ord, sc, evidence$2);
    this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, i0, iK, iN, ord, sc);
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V = (function(a, i0, iK, iN, ord, scratch) {
  if ((ord.compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, (((-1) + iK) | 0)), $m_sr_ScalaRunTime$().array_apply__O__I__O(a, iK)) > 0)) {
    var i = i0;
    var jN = ((iK - i0) | 0);
    var j = 0;
    while ((i < iK)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(scratch, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
      i = ((1 + i) | 0);
      j = ((1 + j) | 0);
    }
    var k = i0;
    j = 0;
    while (((i < iN) && (j < jN))) {
      if ((ord.compare__O__O__I($m_sr_ScalaRunTime$().array_apply__O__I__O(a, i), $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j)) < 0)) {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i));
        i = ((1 + i) | 0);
      } else {
        $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
        j = ((1 + j) | 0);
      }
      k = ((1 + k) | 0);
    }
    while ((j < jN)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(a, k, $m_sr_ScalaRunTime$().array_apply__O__I__O(scratch, j));
      j = ((1 + j) | 0);
      k = ((1 + k) | 0);
    }
  }
});
$c_s_util_Sorting$.prototype.scala$util$Sorting$$booleanSort__AZ__I__I__V = (function(a, from, until) {
  var i = from;
  var n = 0;
  while ((i < until)) {
    if ((!a.u[i])) {
      n = ((1 + n) | 0);
    }
    i = ((1 + i) | 0);
  }
  i = 0;
  while ((i < n)) {
    a.u[((from + i) | 0)] = false;
    i = ((1 + i) | 0);
  }
  while ((((from + i) | 0) < until)) {
    a.u[((from + i) | 0)] = true;
    i = ((1 + i) | 0);
  }
});
$c_s_util_Sorting$.prototype.stableSort__O__I__I__s_math_Ordering__V = (function(a, from, until, evidence$4) {
  if ((a instanceof $ac_O)) {
    if ((($m_jl_reflect_Array$().getLength__O__I(a) > 1) && (evidence$4 === null))) {
      throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "Ordering");
    }
    $m_ju_Arrays$().sort__AO__I__I__ju_Comparator__V(a, from, until, evidence$4);
  } else if ((a instanceof $ac_I)) {
    if ((evidence$4 === $m_s_math_Ordering$Int$())) {
      $m_ju_Arrays$().sort__AI__I__I__V(a, from, until);
    } else {
      var evidence$2 = $m_s_reflect_ManifestFactory$IntManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, until, evidence$4);
      } else {
        var iK = ((((from + until) | 0) >>> 1) | 0);
        var len = ((iK - from) | 0);
        var sc = new $ac_I(len);
        if ((((iK - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, iK, evidence$4);
        } else {
          var iK$1 = ((((from + iK) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, from, iK$1, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$1, iK, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$1, iK, evidence$4, sc);
        }
        if ((((until - iK) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, iK, until, evidence$4);
        } else {
          var iK$2 = ((((iK + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK, iK$2, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$2, until, evidence$4, sc, evidence$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, iK, iK$2, until, evidence$4, sc);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK, until, evidence$4, sc);
      }
    }
  } else if ((a instanceof $ac_D)) {
    var evidence$2$1 = $m_s_reflect_ManifestFactory$DoubleManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, until, evidence$4);
    } else {
      var iK$3 = ((((from + until) | 0) >>> 1) | 0);
      var len$1 = ((iK$3 - from) | 0);
      var sc$1 = new $ac_D(len$1);
      if ((((iK$3 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, iK$3, evidence$4);
      } else {
        var iK$4 = ((((from + iK$3) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, from, iK$4, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$4, iK$3, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$4, iK$3, evidence$4, sc$1);
      }
      if ((((until - iK$3) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, iK$3, until, evidence$4);
      } else {
        var iK$5 = ((((iK$3 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$3, iK$5, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$5, until, evidence$4, sc$1, evidence$2$1);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, iK$3, iK$5, until, evidence$4, sc$1);
      }
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$3, until, evidence$4, sc$1);
    }
  } else if ((a instanceof $ac_J)) {
    if ((evidence$4 === $m_s_math_Ordering$Long$())) {
      $m_ju_Arrays$().sort__AJ__I__I__V(a, from, until);
    } else {
      var evidence$2$2 = $m_s_reflect_ManifestFactory$LongManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, until, evidence$4);
      } else {
        var iK$6 = ((((from + until) | 0) >>> 1) | 0);
        var len$2 = ((iK$6 - from) | 0);
        var sc$2 = new $ac_J(len$2);
        if ((((iK$6 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, iK$6, evidence$4);
        } else {
          var iK$7 = ((((from + iK$6) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, from, iK$7, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$7, iK$6, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$7, iK$6, evidence$4, sc$2);
        }
        if ((((until - iK$6) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, iK$6, until, evidence$4);
        } else {
          var iK$8 = ((((iK$6 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$6, iK$8, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$8, until, evidence$4, sc$2, evidence$2$2);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, iK$6, iK$8, until, evidence$4, sc$2);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$6, until, evidence$4, sc$2);
      }
    }
  } else if ((a instanceof $ac_F)) {
    var evidence$2$3 = $m_s_reflect_ManifestFactory$FloatManifest$();
    if ((((until - from) | 0) < 32)) {
      this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, until, evidence$4);
    } else {
      var iK$9 = ((((from + until) | 0) >>> 1) | 0);
      var len$3 = ((iK$9 - from) | 0);
      var sc$3 = new $ac_F(len$3);
      if ((((iK$9 - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, iK$9, evidence$4);
      } else {
        var iK$10 = ((((from + iK$9) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, from, iK$10, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$10, iK$9, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$10, iK$9, evidence$4, sc$3);
      }
      if ((((until - iK$9) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, iK$9, until, evidence$4);
      } else {
        var iK$11 = ((((iK$9 + until) | 0) >>> 1) | 0);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$9, iK$11, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$11, until, evidence$4, sc$3, evidence$2$3);
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, iK$9, iK$11, until, evidence$4, sc$3);
      }
      this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$9, until, evidence$4, sc$3);
    }
  } else if ((a instanceof $ac_C)) {
    if ((evidence$4 === $m_s_math_Ordering$Char$())) {
      $m_ju_Arrays$().sort__AC__I__I__V(a, from, until);
    } else {
      var evidence$2$4 = $m_s_reflect_ManifestFactory$CharManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, until, evidence$4);
      } else {
        var iK$12 = ((((from + until) | 0) >>> 1) | 0);
        var len$4 = ((iK$12 - from) | 0);
        var sc$4 = new $ac_C(len$4);
        if ((((iK$12 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, iK$12, evidence$4);
        } else {
          var iK$13 = ((((from + iK$12) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, from, iK$13, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$13, iK$12, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$13, iK$12, evidence$4, sc$4);
        }
        if ((((until - iK$12) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, iK$12, until, evidence$4);
        } else {
          var iK$14 = ((((iK$12 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$12, iK$14, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$14, until, evidence$4, sc$4, evidence$2$4);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, iK$12, iK$14, until, evidence$4, sc$4);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$12, until, evidence$4, sc$4);
      }
    }
  } else if ((a instanceof $ac_B)) {
    if ((evidence$4 === $m_s_math_Ordering$Byte$())) {
      $m_ju_Arrays$().sort__AB__I__I__V(a, from, until);
    } else {
      var evidence$2$5 = $m_s_reflect_ManifestFactory$ByteManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, until, evidence$4);
      } else {
        var iK$15 = ((((from + until) | 0) >>> 1) | 0);
        var len$5 = ((iK$15 - from) | 0);
        var sc$5 = new $ac_B(len$5);
        if ((((iK$15 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, iK$15, evidence$4);
        } else {
          var iK$16 = ((((from + iK$15) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, from, iK$16, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$16, iK$15, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$16, iK$15, evidence$4, sc$5);
        }
        if ((((until - iK$15) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, iK$15, until, evidence$4);
        } else {
          var iK$17 = ((((iK$15 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$15, iK$17, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$17, until, evidence$4, sc$5, evidence$2$5);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, iK$15, iK$17, until, evidence$4, sc$5);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$15, until, evidence$4, sc$5);
      }
    }
  } else if ((a instanceof $ac_S)) {
    if ((evidence$4 === $m_s_math_Ordering$Short$())) {
      $m_ju_Arrays$().sort__AS__I__I__V(a, from, until);
    } else {
      var evidence$2$6 = $m_s_reflect_ManifestFactory$ShortManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, until, evidence$4);
      } else {
        var iK$18 = ((((from + until) | 0) >>> 1) | 0);
        var len$6 = ((iK$18 - from) | 0);
        var sc$6 = new $ac_S(len$6);
        if ((((iK$18 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, iK$18, evidence$4);
        } else {
          var iK$19 = ((((from + iK$18) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, from, iK$19, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$19, iK$18, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$19, iK$18, evidence$4, sc$6);
        }
        if ((((until - iK$18) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, iK$18, until, evidence$4);
        } else {
          var iK$20 = ((((iK$18 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$18, iK$20, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$20, until, evidence$4, sc$6, evidence$2$6);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, iK$18, iK$20, until, evidence$4, sc$6);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$18, until, evidence$4, sc$6);
      }
    }
  } else if ((a instanceof $ac_Z)) {
    if ((evidence$4 === $m_s_math_Ordering$Boolean$())) {
      this.scala$util$Sorting$$booleanSort__AZ__I__I__V(a, from, until);
    } else {
      var evidence$2$7 = $m_s_reflect_ManifestFactory$BooleanManifest$();
      if ((((until - from) | 0) < 32)) {
        this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, until, evidence$4);
      } else {
        var iK$21 = ((((from + until) | 0) >>> 1) | 0);
        var len$7 = ((iK$21 - from) | 0);
        var sc$7 = new $ac_Z(len$7);
        if ((((iK$21 - from) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, from, iK$21, evidence$4);
        } else {
          var iK$22 = ((((from + iK$21) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, from, iK$22, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$22, iK$21, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$22, iK$21, evidence$4, sc$7);
        }
        if ((((until - iK$21) | 0) < 32)) {
          this.scala$util$Sorting$$insertionSort__O__I__I__s_math_Ordering__V(a, iK$21, until, evidence$4);
        } else {
          var iK$23 = ((((iK$21 + until) | 0) >>> 1) | 0);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$21, iK$23, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSort__O__I__I__s_math_Ordering__O__s_reflect_ClassTag__V(a, iK$23, until, evidence$4, sc$7, evidence$2$7);
          this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, iK$21, iK$23, until, evidence$4, sc$7);
        }
        this.scala$util$Sorting$$mergeSorted__O__I__I__I__s_math_Ordering__O__V(a, from, iK$21, until, evidence$4, sc$7);
      }
    }
  } else if ((a === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  } else {
    throw new $c_s_MatchError(a);
  }
});
var $d_s_util_Sorting$ = new $TypeData().initClass($c_s_util_Sorting$, "scala.util.Sorting$", ({
  s_util_Sorting$: 1
}));
export { $d_s_util_Sorting$ as $d_s_util_Sorting$ };
var $n_s_util_Sorting$;
function $m_s_util_Sorting$() {
  if ((!$n_s_util_Sorting$)) {
    $n_s_util_Sorting$ = new $c_s_util_Sorting$();
  }
  return $n_s_util_Sorting$;
}
export { $m_s_util_Sorting$ as $m_s_util_Sorting$ };
/** @constructor */
function $c_s_util_control_NonFatal$() {
}
export { $c_s_util_control_NonFatal$ as $c_s_util_control_NonFatal$ };
$c_s_util_control_NonFatal$.prototype = new $h_O();
$c_s_util_control_NonFatal$.prototype.constructor = $c_s_util_control_NonFatal$;
/** @constructor */
function $h_s_util_control_NonFatal$() {
}
export { $h_s_util_control_NonFatal$ as $h_s_util_control_NonFatal$ };
$h_s_util_control_NonFatal$.prototype = $c_s_util_control_NonFatal$.prototype;
$c_s_util_control_NonFatal$.prototype.apply__jl_Throwable__Z = (function(t) {
  return (!((t instanceof $c_jl_VirtualMachineError) || (false || (false || (false || (t instanceof $c_s_util_control_ControlThrowable))))));
});
$c_s_util_control_NonFatal$.prototype.unapply__jl_Throwable__s_Option = (function(t) {
  return (this.apply__jl_Throwable__Z(t) ? new $c_s_Some(t) : $m_s_None$());
});
var $d_s_util_control_NonFatal$ = new $TypeData().initClass($c_s_util_control_NonFatal$, "scala.util.control.NonFatal$", ({
  s_util_control_NonFatal$: 1
}));
export { $d_s_util_control_NonFatal$ as $d_s_util_control_NonFatal$ };
var $n_s_util_control_NonFatal$;
function $m_s_util_control_NonFatal$() {
  if ((!$n_s_util_control_NonFatal$)) {
    $n_s_util_control_NonFatal$ = new $c_s_util_control_NonFatal$();
  }
  return $n_s_util_control_NonFatal$;
}
export { $m_s_util_control_NonFatal$ as $m_s_util_control_NonFatal$ };
/** @constructor */
function $c_s_util_hashing_MurmurHash3() {
}
export { $c_s_util_hashing_MurmurHash3 as $c_s_util_hashing_MurmurHash3 };
$c_s_util_hashing_MurmurHash3.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3.prototype.constructor = $c_s_util_hashing_MurmurHash3;
/** @constructor */
function $h_s_util_hashing_MurmurHash3() {
}
export { $h_s_util_hashing_MurmurHash3 as $h_s_util_hashing_MurmurHash3 };
$h_s_util_hashing_MurmurHash3.prototype = $c_s_util_hashing_MurmurHash3.prototype;
$c_s_util_hashing_MurmurHash3.prototype.mix__I__I__I = (function(hash, data) {
  var h = this.mixLast__I__I__I(hash, data);
  var i = h;
  h = ((i << 13) | ((i >>> 19) | 0));
  return (((-430675100) + Math.imul(5, h)) | 0);
});
$c_s_util_hashing_MurmurHash3.prototype.mixLast__I__I__I = (function(hash, data) {
  var k = data;
  k = Math.imul((-862048943), k);
  var i = k;
  k = ((i << 15) | ((i >>> 17) | 0));
  k = Math.imul(461845907, k);
  return (hash ^ k);
});
$c_s_util_hashing_MurmurHash3.prototype.finalizeHash__I__I__I = (function(hash, length) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I((hash ^ length));
});
$c_s_util_hashing_MurmurHash3.prototype.scala$util$hashing$MurmurHash3$$avalanche__I__I = (function(hash) {
  var h = hash;
  h = (h ^ ((h >>> 16) | 0));
  h = Math.imul((-2048144789), h);
  h = (h ^ ((h >>> 13) | 0));
  h = Math.imul((-1028477387), h);
  h = (h ^ ((h >>> 16) | 0));
  return h;
});
$c_s_util_hashing_MurmurHash3.prototype.tuple2Hash__I__I__I__I = (function(x, y, seed) {
  var h = seed;
  h = this.mix__I__I__I(h, $f_T__hashCode__I("Tuple2"));
  h = this.mix__I__I__I(h, x);
  h = this.mix__I__I__I(h, y);
  return this.finalizeHash__I__I__I(h, 2);
});
$c_s_util_hashing_MurmurHash3.prototype.productHash__s_Product__I__Z__I = (function(x, seed, ignorePrefix) {
  var arr = x.productArity__I();
  if ((arr === 0)) {
    return ((!ignorePrefix) ? $f_T__hashCode__I(x.productPrefix__T()) : seed);
  } else {
    var h = seed;
    if ((!ignorePrefix)) {
      h = this.mix__I__I__I(h, $f_T__hashCode__I(x.productPrefix__T()));
    }
    var i = 0;
    while ((i < arr)) {
      var $x_1 = h;
      var x$1 = x.productElement__I__O(i);
      h = this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x$1));
      i = ((1 + i) | 0);
    }
    return this.finalizeHash__I__I__I(h, arr);
  }
});
$c_s_util_hashing_MurmurHash3.prototype.caseClassHash__s_Product__I__T__I = (function(x, seed, caseClassName) {
  var arr = x.productArity__I();
  var aye = $f_T__hashCode__I(((caseClassName !== null) ? caseClassName : x.productPrefix__T()));
  if ((arr === 0)) {
    return aye;
  } else {
    var h = seed;
    h = this.mix__I__I__I(h, aye);
    var i = 0;
    while ((i < arr)) {
      var $x_1 = h;
      var x$1 = x.productElement__I__O(i);
      h = this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x$1));
      i = ((1 + i) | 0);
    }
    return this.finalizeHash__I__I__I(h, arr);
  }
});
$c_s_util_hashing_MurmurHash3.prototype.stringHash__T__I__I = (function(str, seed) {
  var h = seed;
  var i = 0;
  while ((((1 + i) | 0) < str.length)) {
    var index = i;
    var index$1 = ((1 + i) | 0);
    var data = (((str.charCodeAt(index) << 16) + str.charCodeAt(index$1)) | 0);
    h = this.mix__I__I__I(h, data);
    i = ((2 + i) | 0);
  }
  if ((i < str.length)) {
    var $x_1 = h;
    var index$2 = i;
    h = this.mixLast__I__I__I($x_1, str.charCodeAt(index$2));
  }
  return this.finalizeHash__I__I__I(h, str.length);
});
$c_s_util_hashing_MurmurHash3.prototype.unorderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var a = 0;
  var b = 0;
  var n = 0;
  var c = 1;
  var iterator = xs.iterator__sc_Iterator();
  while (iterator.hasNext__Z()) {
    var x = iterator.next__O();
    var h = $m_sr_Statics$().anyHash__O__I(x);
    a = ((a + h) | 0);
    b = (b ^ h);
    c = Math.imul(c, (1 | h));
    n = ((1 + n) | 0);
  }
  var h$2 = seed;
  h$2 = this.mix__I__I__I(h$2, a);
  h$2 = this.mix__I__I__I(h$2, b);
  h$2 = this.mixLast__I__I__I(h$2, c);
  return this.finalizeHash__I__I__I(h$2, n);
});
$c_s_util_hashing_MurmurHash3.prototype.orderedHash__sc_IterableOnce__I__I = (function(xs, seed) {
  var it = xs.iterator__sc_Iterator();
  var h = seed;
  if ((!it.hasNext__Z())) {
    return this.finalizeHash__I__I__I(h, 0);
  }
  var x0 = it.next__O();
  if ((!it.hasNext__Z())) {
    return this.finalizeHash__I__I__I(this.mix__I__I__I(h, $m_sr_Statics$().anyHash__O__I(x0)), 1);
  }
  var x1 = it.next__O();
  var initial = $m_sr_Statics$().anyHash__O__I(x0);
  h = this.mix__I__I__I(h, initial);
  var h0 = h;
  var prev = $m_sr_Statics$().anyHash__O__I(x1);
  var rangeDiff = ((prev - initial) | 0);
  var i = 2;
  while (it.hasNext__Z()) {
    h = this.mix__I__I__I(h, prev);
    var x = it.next__O();
    var hash = $m_sr_Statics$().anyHash__O__I(x);
    if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
      h = this.mix__I__I__I(h, hash);
      i = ((1 + i) | 0);
      while (it.hasNext__Z()) {
        var $x_1 = h;
        var x$1 = it.next__O();
        h = this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x$1));
        i = ((1 + i) | 0);
      }
      return this.finalizeHash__I__I__I(h, i);
    }
    prev = hash;
    i = ((1 + i) | 0);
  }
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash__O__I__I = (function(a, seed) {
  var h = seed;
  var l = $m_jl_reflect_Array$().getLength__O__I(a);
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var x = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break;
    }
    default: {
      var x$1 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, 1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var x$4 = $m_sr_ScalaRunTime$().array_apply__O__I__O(a, i);
            h = this.mix__I__I__I($x_2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.rangeHash__I__I__I__I__I = (function(start, step, last, seed) {
  return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(this.mix__I__I__I(seed, start), step), last));
});
$c_s_util_hashing_MurmurHash3.prototype.bytesHash__AB__I__I = (function(data, seed) {
  var len = data.u.length;
  var h = seed;
  var i = 0;
  while ((len >= 4)) {
    var k = (255 & data.u[i]);
    k = (k | ((255 & data.u[((1 + i) | 0)]) << 8));
    k = (k | ((255 & data.u[((2 + i) | 0)]) << 16));
    k = (k | (data.u[((3 + i) | 0)] << 24));
    h = this.mix__I__I__I(h, k);
    i = ((4 + i) | 0);
    len = (((-4) + len) | 0);
  }
  var k$2 = 0;
  if ((len === 3)) {
    k$2 = (k$2 ^ ((255 & data.u[((2 + i) | 0)]) << 16));
  }
  if ((len >= 2)) {
    k$2 = (k$2 ^ ((255 & data.u[((1 + i) | 0)]) << 8));
  }
  if ((len >= 1)) {
    k$2 = (k$2 ^ (255 & data.u[i]));
    h = this.mixLast__I__I__I(h, k$2);
  }
  return this.finalizeHash__I__I__I(h, data.u.length);
});
$c_s_util_hashing_MurmurHash3.prototype.indexedSeqHash__sc_IndexedSeq__I__I = (function(a, seed) {
  var h = seed;
  var l = a.length__I();
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var x = a.apply__I__O(0);
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x)), 1);
      break;
    }
    default: {
      var x$1 = a.apply__I__O(0);
      var initial = $m_sr_Statics$().anyHash__O__I(x$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var x$2 = a.apply__I__O(1);
      var prev = $m_sr_Statics$().anyHash__O__I(x$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var x$3 = a.apply__I__O(i);
        var hash = $m_sr_Statics$().anyHash__O__I(x$3);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var x$4 = a.apply__I__O(i);
            h = this.mix__I__I__I($x_2, $m_sr_Statics$().anyHash__O__I(x$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.listHash__sci_List__I__I = (function(xs, seed) {
  var n = 0;
  var h = seed;
  var rangeState = 0;
  var rangeDiff = 0;
  var prev = 0;
  var initial = 0;
  var elems = xs;
  while ((!elems.isEmpty__Z())) {
    var head = elems.head__O();
    var tail = elems.tail__O();
    var hash = $m_sr_Statics$().anyHash__O__I(head);
    h = this.mix__I__I__I(h, hash);
    var x1 = rangeState;
    switch (x1) {
      case 0: {
        initial = hash;
        rangeState = 1;
        break;
      }
      case 1: {
        rangeDiff = ((hash - prev) | 0);
        rangeState = 2;
        break;
      }
      case 2: {
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          rangeState = 3;
        }
        break;
      }
    }
    prev = hash;
    n = ((1 + n) | 0);
    elems = tail;
  }
  return ((rangeState === 2) ? this.rangeHash__I__I__I__I__I(initial, rangeDiff, prev, seed) : this.finalizeHash__I__I__I(h, n));
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mZc$sp__AZ__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, (a.u[0] ? 1231 : 1237)), 1);
      break;
    }
    default: {
      var initial = (a.u[0] ? 1231 : 1237);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = (a.u[1] ? 1231 : 1237);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = (a.u[i] ? 1231 : 1237);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, (a.u[i] ? 1231 : 1237));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mBc$sp__AB__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.u[0]), 1);
      break;
    }
    default: {
      var initial = a.u[0];
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.u[1];
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.u[i];
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.u[i]);
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mCc$sp__AC__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.u[0]), 1);
      break;
    }
    default: {
      var initial = a.u[0];
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.u[1];
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.u[i];
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.u[i]);
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mDc$sp__AD__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var dv = a.u[0];
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, $m_sr_Statics$().doubleHash__D__I(dv)), 1);
      break;
    }
    default: {
      var dv$1 = a.u[0];
      var initial = $m_sr_Statics$().doubleHash__D__I(dv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var dv$2 = a.u[1];
      var prev = $m_sr_Statics$().doubleHash__D__I(dv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var dv$3 = a.u[i];
        var hash = $m_sr_Statics$().doubleHash__D__I(dv$3);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var dv$4 = a.u[i];
            h = this.mix__I__I__I($x_2, $m_sr_Statics$().doubleHash__D__I(dv$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mFc$sp__AF__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var fv = a.u[0];
      var this$1 = $m_sr_Statics$();
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, this$1.doubleHash__D__I(fv)), 1);
      break;
    }
    default: {
      var fv$1 = a.u[0];
      var this$2 = $m_sr_Statics$();
      var initial = this$2.doubleHash__D__I(fv$1);
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var fv$2 = a.u[1];
      var this$3 = $m_sr_Statics$();
      var prev = this$3.doubleHash__D__I(fv$2);
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var fv$3 = a.u[i];
        var this$4 = $m_sr_Statics$();
        var hash = this$4.doubleHash__D__I(fv$3);
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var fv$4 = a.u[i];
            var this$5 = $m_sr_Statics$();
            h = this.mix__I__I__I($x_2, this$5.doubleHash__D__I(fv$4));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mIc$sp__AI__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.u[0]), 1);
      break;
    }
    default: {
      var initial = a.u[0];
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.u[1];
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.u[i];
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.u[i]);
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mJc$sp__AJ__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      var $x_1 = h;
      var t = a.u[0];
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return this.finalizeHash__I__I__I(this.mix__I__I__I($x_1, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi))), 1);
      break;
    }
    default: {
      var t$1 = a.u[0];
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var initial = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$1, hi$1));
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var t$2 = a.u[1];
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      var prev = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$2, hi$2));
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var t$3 = a.u[i];
        var lo$3 = t$3.RTLong__f_lo;
        var hi$3 = t$3.RTLong__f_hi;
        var hash = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$3, hi$3));
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            var $x_2 = h;
            var t$4 = a.u[i];
            var lo$4 = t$4.RTLong__f_lo;
            var hi$4 = t$4.RTLong__f_hi;
            h = this.mix__I__I__I($x_2, $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$4, hi$4)));
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mSc$sp__AS__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, a.u[0]), 1);
      break;
    }
    default: {
      var initial = a.u[0];
      h = this.mix__I__I__I(h, initial);
      var h0 = h;
      var prev = a.u[1];
      var rangeDiff = ((prev - initial) | 0);
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        var hash = a.u[i];
        if (((rangeDiff !== ((hash - prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, hash);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, a.u[i]);
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = hash;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
$c_s_util_hashing_MurmurHash3.prototype.arrayHash$mVc$sp__Ajl_Void__I__I = (function(a, seed) {
  var h = seed;
  var l = a.u.length;
  switch (l) {
    case 0: {
      return this.finalizeHash__I__I__I(h, 0);
      break;
    }
    case 1: {
      return this.finalizeHash__I__I__I(this.mix__I__I__I(h, 0), 1);
      break;
    }
    default: {
      h = this.mix__I__I__I(h, 0);
      var h0 = h;
      var prev = 0;
      var rangeDiff = prev;
      var i = 2;
      while ((i < l)) {
        h = this.mix__I__I__I(h, prev);
        if (((rangeDiff !== ((-prev) | 0)) || (rangeDiff === 0))) {
          h = this.mix__I__I__I(h, 0);
          i = ((1 + i) | 0);
          while ((i < l)) {
            h = this.mix__I__I__I(h, 0);
            i = ((1 + i) | 0);
          }
          return this.finalizeHash__I__I__I(h, l);
        }
        prev = 0;
        i = ((1 + i) | 0);
      }
      return this.scala$util$hashing$MurmurHash3$$avalanche__I__I(this.mix__I__I__I(this.mix__I__I__I(h0, rangeDiff), prev));
    }
  }
});
function $f_Lscodec_Decoder__decodeValue__Lscodec_bits_BitVector__Lscodec_Attempt($thiz, bits) {
  return $thiz.decode__Lscodec_bits_BitVector__Lscodec_Attempt(bits).map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.Lscodec_DecodeResult__f_value)));
}
export { $f_Lscodec_Decoder__decodeValue__Lscodec_bits_BitVector__Lscodec_Attempt as $f_Lscodec_Decoder__decodeValue__Lscodec_bits_BitVector__Lscodec_Attempt };
function $f_Lscodec_DecoderFunctions__decodeBothCombine__Lscodec_Decoder__Lscodec_Decoder__Lscodec_bits_BitVector__F2__Lscodec_Attempt($thiz, decA, decB, buffer, f) {
  return decA.decode__Lscodec_bits_BitVector__Lscodec_Attempt(buffer).flatMap__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((aResult) => decB.decode__Lscodec_bits_BitVector__Lscodec_Attempt(aResult.Lscodec_DecodeResult__f_remainder).map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((aResult$2) => ((bResult) => {
    var x0 = bResult.Lscodec_DecodeResult__f_value;
    var value = f.apply__O__O__O(aResult$2.Lscodec_DecodeResult__f_value, x0);
    var remainder = bResult.Lscodec_DecodeResult__f_remainder;
    return new $c_Lscodec_DecodeResult(value, remainder);
  }))(aResult))))));
}
export { $f_Lscodec_DecoderFunctions__decodeBothCombine__Lscodec_Decoder__Lscodec_Decoder__Lscodec_bits_BitVector__F2__Lscodec_Attempt as $f_Lscodec_DecoderFunctions__decodeBothCombine__Lscodec_Decoder__Lscodec_Decoder__Lscodec_bits_BitVector__F2__Lscodec_Attempt };
function $f_Lscodec_EncoderFunctions__encodeBoth__Lscodec_Encoder__Lscodec_Encoder__O__O__Lscodec_Attempt($thiz, encA, encB, a, b) {
  return encA.encode__O__Lscodec_Attempt(a).flatMap__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((encodedA) => encB.encode__O__Lscodec_Attempt(b).map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((encodedA$2) => ((encodedB) => encodedA$2.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(encodedB)))(encodedA))))));
}
export { $f_Lscodec_EncoderFunctions__encodeBoth__Lscodec_Encoder__Lscodec_Encoder__O__O__Lscodec_Attempt as $f_Lscodec_EncoderFunctions__encodeBoth__Lscodec_Encoder__Lscodec_Encoder__O__O__Lscodec_Attempt };
function $f_Lscodec_Err__messageWithContext__T($thiz) {
  if ($thiz.context__sci_List().isEmpty__Z()) {
    var $x_1 = "";
  } else {
    var this$1 = $thiz.context__sci_List();
    var $x_1 = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", "/", ": ");
  }
  return (("" + $x_1) + $thiz.message__T());
}
export { $f_Lscodec_Err__messageWithContext__T as $f_Lscodec_Err__messageWithContext__T };
/** @constructor */
function $c_Lscodec_Platform$() {
  this.Lscodec_Platform$__f_utf8 = null;
  this.Lscodec_Platform$__f_ascii = null;
  $n_Lscodec_Platform$ = this;
  this.Lscodec_Platform$__f_utf8 = $m_Ljava_nio_charset_UTF\uff3f8$();
  this.Lscodec_Platform$__f_ascii = $m_Ljava_nio_charset_US\uff3fASCII$();
}
export { $c_Lscodec_Platform$ as $c_Lscodec_Platform$ };
$c_Lscodec_Platform$.prototype = new $h_O();
$c_Lscodec_Platform$.prototype.constructor = $c_Lscodec_Platform$;
/** @constructor */
function $h_Lscodec_Platform$() {
}
export { $h_Lscodec_Platform$ as $h_Lscodec_Platform$ };
$h_Lscodec_Platform$.prototype = $c_Lscodec_Platform$.prototype;
var $d_Lscodec_Platform$ = new $TypeData().initClass($c_Lscodec_Platform$, "scodec.Platform$", ({
  Lscodec_Platform$: 1
}));
export { $d_Lscodec_Platform$ as $d_Lscodec_Platform$ };
var $n_Lscodec_Platform$;
function $m_Lscodec_Platform$() {
  if ((!$n_Lscodec_Platform$)) {
    $n_Lscodec_Platform$ = new $c_Lscodec_Platform$();
  }
  return $n_Lscodec_Platform$;
}
export { $m_Lscodec_Platform$ as $m_Lscodec_Platform$ };
function $f_Lscodec_Transform__xmap__O__F1__F1__O($thiz, fa, f, g) {
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
    var a$1 = f.apply__O__O(a);
    return new $c_Lscodec_Attempt$Successful(a$1);
  }));
  var g$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => {
    var a$2 = g.apply__O__O(b);
    return new $c_Lscodec_Attempt$Successful(a$2);
  }));
  return new $c_Lscodec_Codec$$anon$1(g$1, f$1, fa);
}
export { $f_Lscodec_Transform__xmap__O__F1__F1__O as $f_Lscodec_Transform__xmap__O__F1__F1__O };
function $f_Lscodec_Transform__widen__O__F1__F1__O($thiz, fa, f, g) {
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
    var a$1 = f.apply__O__O(a);
    return new $c_Lscodec_Attempt$Successful(a$1);
  }));
  return new $c_Lscodec_Codec$$anon$1(g, f$1, fa);
}
export { $f_Lscodec_Transform__widen__O__F1__F1__O as $f_Lscodec_Transform__widen__O__F1__F1__O };
/** @constructor */
function $c_Lscodec_bits_ByteVector$At() {
}
export { $c_Lscodec_bits_ByteVector$At as $c_Lscodec_bits_ByteVector$At };
$c_Lscodec_bits_ByteVector$At.prototype = new $h_O();
$c_Lscodec_bits_ByteVector$At.prototype.constructor = $c_Lscodec_bits_ByteVector$At;
/** @constructor */
function $h_Lscodec_bits_ByteVector$At() {
}
export { $h_Lscodec_bits_ByteVector$At as $h_Lscodec_bits_ByteVector$At };
$h_Lscodec_bits_ByteVector$At.prototype = $c_Lscodec_bits_ByteVector$At.prototype;
$c_Lscodec_bits_ByteVector$At.prototype.asByteBuffer__J__I__Ljava_nio_ByteBuffer = (function(offset, size) {
  var dimensions = new $ac_I(new Int32Array([size]));
  var arr = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_B.getClassOf(), dimensions);
  this.copyToArray__AB__I__J__I__V(arr, 0, offset, size);
  var length = arr.u.length;
  return $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(arr, 0, arr.u.length, 0, length, false);
});
$c_Lscodec_bits_ByteVector$At.prototype.copyToArray__AB__I__J__I__V = (function(xs, start, offset, size) {
  var i = 0;
  while ((i < size)) {
    var $x_1 = i;
    var value = i;
    var hi = (value >> 31);
    var alo = offset.RTLong__f_lo;
    var lo = ((alo + value) | 0);
    var hi$1 = ((((offset.RTLong__f_hi + hi) | 0) + ((((alo & value) | ((alo | value) & (~lo))) >>> 31) | 0)) | 0);
    xs.u[((start + $x_1) | 0)] = this.apply__J__B(new $c_RTLong(lo, hi$1));
    i = ((1 + i) | 0);
  }
});
/** @constructor */
function $c_Lscodec_bits_ByteVector$F1BU() {
}
export { $c_Lscodec_bits_ByteVector$F1BU as $c_Lscodec_bits_ByteVector$F1BU };
$c_Lscodec_bits_ByteVector$F1BU.prototype = new $h_O();
$c_Lscodec_bits_ByteVector$F1BU.prototype.constructor = $c_Lscodec_bits_ByteVector$F1BU;
/** @constructor */
function $h_Lscodec_bits_ByteVector$F1BU() {
}
export { $h_Lscodec_bits_ByteVector$F1BU as $h_Lscodec_bits_ByteVector$F1BU };
$h_Lscodec_bits_ByteVector$F1BU.prototype = $c_Lscodec_bits_ByteVector$F1BU.prototype;
/** @constructor */
function $c_Lscodec_bits_ByteVector$F2B() {
}
export { $c_Lscodec_bits_ByteVector$F2B as $c_Lscodec_bits_ByteVector$F2B };
$c_Lscodec_bits_ByteVector$F2B.prototype = new $h_O();
$c_Lscodec_bits_ByteVector$F2B.prototype.constructor = $c_Lscodec_bits_ByteVector$F2B;
/** @constructor */
function $h_Lscodec_bits_ByteVector$F2B() {
}
export { $h_Lscodec_bits_ByteVector$F2B as $h_Lscodec_bits_ByteVector$F2B };
$h_Lscodec_bits_ByteVector$F2B.prototype = $c_Lscodec_bits_ByteVector$F2B.prototype;
/** @constructor */
function $c_Lscodec_codecs_NeedDiscriminatorCodec() {
}
export { $c_Lscodec_codecs_NeedDiscriminatorCodec as $c_Lscodec_codecs_NeedDiscriminatorCodec };
$c_Lscodec_codecs_NeedDiscriminatorCodec.prototype = new $h_O();
$c_Lscodec_codecs_NeedDiscriminatorCodec.prototype.constructor = $c_Lscodec_codecs_NeedDiscriminatorCodec;
/** @constructor */
function $h_Lscodec_codecs_NeedDiscriminatorCodec() {
}
export { $h_Lscodec_codecs_NeedDiscriminatorCodec as $h_Lscodec_codecs_NeedDiscriminatorCodec };
$h_Lscodec_codecs_NeedDiscriminatorCodec.prototype = $c_Lscodec_codecs_NeedDiscriminatorCodec.prototype;
/** @constructor */
function $c_Lscodec_codecs_VarIntCodec$() {
  this.Lscodec_codecs_VarIntCodec$__f_scodec$codecs$VarIntCodec$$$toPositiveLong = null;
  $n_Lscodec_codecs_VarIntCodec$ = this;
  this.Lscodec_codecs_VarIntCodec$__f_scodec$codecs$VarIntCodec$$$toPositiveLong = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((i) => {
    var i$1 = (i | 0);
    if ((i$1 >= 0)) {
      var hi = (i$1 >> 31);
      return new $c_RTLong(i$1, hi);
    } else {
      return new $c_RTLong(i$1, 0);
    }
  }));
}
export { $c_Lscodec_codecs_VarIntCodec$ as $c_Lscodec_codecs_VarIntCodec$ };
$c_Lscodec_codecs_VarIntCodec$.prototype = new $h_O();
$c_Lscodec_codecs_VarIntCodec$.prototype.constructor = $c_Lscodec_codecs_VarIntCodec$;
/** @constructor */
function $h_Lscodec_codecs_VarIntCodec$() {
}
export { $h_Lscodec_codecs_VarIntCodec$ as $h_Lscodec_codecs_VarIntCodec$ };
$h_Lscodec_codecs_VarIntCodec$.prototype = $c_Lscodec_codecs_VarIntCodec$.prototype;
var $d_Lscodec_codecs_VarIntCodec$ = new $TypeData().initClass($c_Lscodec_codecs_VarIntCodec$, "scodec.codecs.VarIntCodec$", ({
  Lscodec_codecs_VarIntCodec$: 1
}));
export { $d_Lscodec_codecs_VarIntCodec$ as $d_Lscodec_codecs_VarIntCodec$ };
var $n_Lscodec_codecs_VarIntCodec$;
function $m_Lscodec_codecs_VarIntCodec$() {
  if ((!$n_Lscodec_codecs_VarIntCodec$)) {
    $n_Lscodec_codecs_VarIntCodec$ = new $c_Lscodec_codecs_VarIntCodec$();
  }
  return $n_Lscodec_codecs_VarIntCodec$;
}
export { $m_Lscodec_codecs_VarIntCodec$ as $m_Lscodec_codecs_VarIntCodec$ };
/** @constructor */
function $c_Lscodec_codecs_VarIntZigZagCodec$() {
  this.Lscodec_codecs_VarIntZigZagCodec$__f_scodec$codecs$VarIntZigZagCodec$$$zigZagEncode = null;
  this.Lscodec_codecs_VarIntZigZagCodec$__f_scodec$codecs$VarIntZigZagCodec$$$zigZagDecode = null;
  $n_Lscodec_codecs_VarIntZigZagCodec$ = this;
  this.Lscodec_codecs_VarIntZigZagCodec$__f_scodec$codecs$VarIntZigZagCodec$$$zigZagEncode = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => {
    var value$1 = (value | 0);
    return ((value$1 << 1) ^ (value$1 >> 31));
  }));
  this.Lscodec_codecs_VarIntZigZagCodec$__f_scodec$codecs$VarIntZigZagCodec$$$zigZagDecode = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value$2) => {
    var value$3 = (value$2 | 0);
    return (((value$3 >>> 1) | 0) ^ ((-(1 & value$3)) | 0));
  }));
}
export { $c_Lscodec_codecs_VarIntZigZagCodec$ as $c_Lscodec_codecs_VarIntZigZagCodec$ };
$c_Lscodec_codecs_VarIntZigZagCodec$.prototype = new $h_O();
$c_Lscodec_codecs_VarIntZigZagCodec$.prototype.constructor = $c_Lscodec_codecs_VarIntZigZagCodec$;
/** @constructor */
function $h_Lscodec_codecs_VarIntZigZagCodec$() {
}
export { $h_Lscodec_codecs_VarIntZigZagCodec$ as $h_Lscodec_codecs_VarIntZigZagCodec$ };
$h_Lscodec_codecs_VarIntZigZagCodec$.prototype = $c_Lscodec_codecs_VarIntZigZagCodec$.prototype;
var $d_Lscodec_codecs_VarIntZigZagCodec$ = new $TypeData().initClass($c_Lscodec_codecs_VarIntZigZagCodec$, "scodec.codecs.VarIntZigZagCodec$", ({
  Lscodec_codecs_VarIntZigZagCodec$: 1
}));
export { $d_Lscodec_codecs_VarIntZigZagCodec$ as $d_Lscodec_codecs_VarIntZigZagCodec$ };
var $n_Lscodec_codecs_VarIntZigZagCodec$;
function $m_Lscodec_codecs_VarIntZigZagCodec$() {
  if ((!$n_Lscodec_codecs_VarIntZigZagCodec$)) {
    $n_Lscodec_codecs_VarIntZigZagCodec$ = new $c_Lscodec_codecs_VarIntZigZagCodec$();
  }
  return $n_Lscodec_codecs_VarIntZigZagCodec$;
}
export { $m_Lscodec_codecs_VarIntZigZagCodec$ as $m_Lscodec_codecs_VarIntZigZagCodec$ };
/** @constructor */
function $c_Lscodec_codecs_VarLongCodec$() {
  this.Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$RelevantDataBits = $L0;
  this.Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MoreBytesMask = 0;
  this.Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MostSignificantBit = 0;
  this.Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$BitsPerByte = 0;
  $n_Lscodec_codecs_VarLongCodec$ = this;
  this.Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$RelevantDataBits = new $c_RTLong(127, 0);
  var a = this.Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$RelevantDataBits;
  this.Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MoreBytesMask = (~a.RTLong__f_lo);
  this.Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MostSignificantBit = 128;
  this.Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$BitsPerByte = 7;
}
export { $c_Lscodec_codecs_VarLongCodec$ as $c_Lscodec_codecs_VarLongCodec$ };
$c_Lscodec_codecs_VarLongCodec$.prototype = new $h_O();
$c_Lscodec_codecs_VarLongCodec$.prototype.constructor = $c_Lscodec_codecs_VarLongCodec$;
/** @constructor */
function $h_Lscodec_codecs_VarLongCodec$() {
}
export { $h_Lscodec_codecs_VarLongCodec$ as $h_Lscodec_codecs_VarLongCodec$ };
$h_Lscodec_codecs_VarLongCodec$.prototype = $c_Lscodec_codecs_VarLongCodec$.prototype;
var $d_Lscodec_codecs_VarLongCodec$ = new $TypeData().initClass($c_Lscodec_codecs_VarLongCodec$, "scodec.codecs.VarLongCodec$", ({
  Lscodec_codecs_VarLongCodec$: 1
}));
export { $d_Lscodec_codecs_VarLongCodec$ as $d_Lscodec_codecs_VarLongCodec$ };
var $n_Lscodec_codecs_VarLongCodec$;
function $m_Lscodec_codecs_VarLongCodec$() {
  if ((!$n_Lscodec_codecs_VarLongCodec$)) {
    $n_Lscodec_codecs_VarLongCodec$ = new $c_Lscodec_codecs_VarLongCodec$();
  }
  return $n_Lscodec_codecs_VarLongCodec$;
}
export { $m_Lscodec_codecs_VarLongCodec$ as $m_Lscodec_codecs_VarLongCodec$ };
/** @constructor */
function $c_Lscodec_codecs_VarLongZigZagCodec$() {
  this.Lscodec_codecs_VarLongZigZagCodec$__f_scodec$codecs$VarLongZigZagCodec$$$zigZagEncode = null;
  this.Lscodec_codecs_VarLongZigZagCodec$__f_scodec$codecs$VarLongZigZagCodec$$$zigZagDecode = null;
  $n_Lscodec_codecs_VarLongZigZagCodec$ = this;
  this.Lscodec_codecs_VarLongZigZagCodec$__f_scodec$codecs$VarLongZigZagCodec$$$zigZagEncode = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => {
    var t = $uJ(value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var lo$1 = (lo << 1);
    var hi$1 = (((lo >>> 31) | 0) | (hi << 1));
    var lo$2 = (hi >> 31);
    var hi$2 = (hi >> 31);
    var lo$3 = (lo$1 ^ lo$2);
    var hi$3 = (hi$1 ^ hi$2);
    return new $c_RTLong(lo$3, hi$3);
  }));
  this.Lscodec_codecs_VarLongZigZagCodec$__f_scodec$codecs$VarLongZigZagCodec$$$zigZagDecode = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value$2) => {
    var t$1 = $uJ(value$2);
    var lo$4 = t$1.RTLong__f_lo;
    var hi$4 = t$1.RTLong__f_hi;
    var lo$5 = (((lo$4 >>> 1) | 0) | (hi$4 << 31));
    var hi$5 = ((hi$4 >>> 1) | 0);
    var lo$6 = (1 & lo$4);
    var lo$7 = ((-lo$6) | 0);
    var hi$6 = ((lo$6 | lo$7) >> 31);
    var lo$8 = (lo$5 ^ lo$7);
    var hi$7 = (hi$5 ^ hi$6);
    return new $c_RTLong(lo$8, hi$7);
  }));
}
export { $c_Lscodec_codecs_VarLongZigZagCodec$ as $c_Lscodec_codecs_VarLongZigZagCodec$ };
$c_Lscodec_codecs_VarLongZigZagCodec$.prototype = new $h_O();
$c_Lscodec_codecs_VarLongZigZagCodec$.prototype.constructor = $c_Lscodec_codecs_VarLongZigZagCodec$;
/** @constructor */
function $h_Lscodec_codecs_VarLongZigZagCodec$() {
}
export { $h_Lscodec_codecs_VarLongZigZagCodec$ as $h_Lscodec_codecs_VarLongZigZagCodec$ };
$h_Lscodec_codecs_VarLongZigZagCodec$.prototype = $c_Lscodec_codecs_VarLongZigZagCodec$.prototype;
var $d_Lscodec_codecs_VarLongZigZagCodec$ = new $TypeData().initClass($c_Lscodec_codecs_VarLongZigZagCodec$, "scodec.codecs.VarLongZigZagCodec$", ({
  Lscodec_codecs_VarLongZigZagCodec$: 1
}));
export { $d_Lscodec_codecs_VarLongZigZagCodec$ as $d_Lscodec_codecs_VarLongZigZagCodec$ };
var $n_Lscodec_codecs_VarLongZigZagCodec$;
function $m_Lscodec_codecs_VarLongZigZagCodec$() {
  if ((!$n_Lscodec_codecs_VarLongZigZagCodec$)) {
    $n_Lscodec_codecs_VarLongZigZagCodec$ = new $c_Lscodec_codecs_VarLongZigZagCodec$();
  }
  return $n_Lscodec_codecs_VarLongZigZagCodec$;
}
export { $m_Lscodec_codecs_VarLongZigZagCodec$ as $m_Lscodec_codecs_VarLongZigZagCodec$ };
/** @constructor */
function $c_Lscodec_codecs_codecs$package$() {
  this.Lscodec_codecs_codecs$package$__f_bits = null;
  this.Lscodec_codecs_codecs$package$__f_int32 = null;
  this.Lscodec_codecs_codecs$package$__f_int64 = null;
  this.Lscodec_codecs_codecs$package$__f_uint8 = null;
  this.Lscodec_codecs_codecs$package$__f_int32L = null;
  this.Lscodec_codecs_codecs$package$__f_ascii = null;
  this.Lscodec_codecs_codecs$package$__f_uuid = null;
  $n_Lscodec_codecs_codecs$package$ = this;
  this.Lscodec_codecs_codecs$package$__f_bits = new $c_Lscodec_codecs_codecs$package$$anon$1();
  var Transform_this = $m_Lscodec_Codec$given\uff3fTransform\uff3fCodec$();
  var f$proxy1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.toByteVector__Lscodec_bits_ByteVector()));
  var g$proxy1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => $m_Lscodec_bits_BitVector$().apply__Lscodec_bits_ByteVector__Lscodec_bits_BitVector(_$2)));
  var fa = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_bits;
  var this$4 = $f_Lscodec_Transform__xmap__O__F1__F1__O(Transform_this, fa, f$proxy1, g$proxy1);
  var str = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => "bytes"));
  new $c_Lscodec_Codec$$anon$8(str, this$4);
  new $c_Lscodec_codecs_ByteCodec(8, true);
  new $c_Lscodec_codecs_ShortCodec(8, false, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_ShortCodec(16, true, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_IntCodec(8, true, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_IntCodec(16, true, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_IntCodec(24, true, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  this.Lscodec_codecs_codecs$package$__f_int32 = new $c_Lscodec_codecs_IntCodec(32, true, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  this.Lscodec_codecs_codecs$package$__f_int64 = new $c_Lscodec_codecs_LongCodec(64, true, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_IntCodec(2, false, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_IntCodec(4, false, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  this.Lscodec_codecs_codecs$package$__f_uint8 = new $c_Lscodec_codecs_IntCodec(8, false, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_IntCodec(16, false, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_IntCodec(24, false, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_LongCodec(32, false, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_BigIntCodec(64, false, $m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_ShortCodec(16, true, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_IntCodec(8, true, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_IntCodec(16, true, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_IntCodec(24, true, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  this.Lscodec_codecs_codecs$package$__f_int32L = new $c_Lscodec_codecs_IntCodec(32, true, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_LongCodec(64, true, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_IntCodec(2, false, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_IntCodec(4, false, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_IntCodec(8, false, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_IntCodec(16, false, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_IntCodec(24, false, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_LongCodec(32, false, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_BigIntCodec(64, false, $m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_VarIntCodec($m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_VarIntCodec($m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_VarLongCodec($m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_VarLongCodec($m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_VarIntZigZagCodec($m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_VarIntZigZagCodec($m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_VarLongZigZagCodec($m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_VarLongZigZagCodec($m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_FloatCodec($m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_FloatCodec($m_Lscodec_bits_ByteOrdering$LittleEndian$());
  new $c_Lscodec_codecs_DoubleCodec($m_Lscodec_bits_ByteOrdering$BigEndian$());
  new $c_Lscodec_codecs_DoubleCodec($m_Lscodec_bits_ByteOrdering$LittleEndian$());
  $m_Lscodec_codecs_codecs$package$();
  var charset = $m_Lscodec_Platform$().Lscodec_Platform$__f_ascii;
  this.Lscodec_codecs_codecs$package$__f_ascii = new $c_Lscodec_codecs_StringCodec(charset);
  $m_Lscodec_codecs_codecs$package$();
  $m_Lscodec_Platform$();
  $m_Lscodec_codecs_codecs$package$().nulTerminatedString__Lscodec_Codec__Lscodec_Codec($m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_ascii);
  $m_Lscodec_codecs_codecs$package$().string32__Ljava_nio_charset_Charset__Lscodec_Codec($m_Lscodec_Platform$().Lscodec_Platform$__f_ascii);
  $m_Lscodec_codecs_codecs$package$().string32L__Ljava_nio_charset_Charset__Lscodec_Codec($m_Lscodec_Platform$().Lscodec_Platform$__f_ascii);
  $m_Lscodec_codecs_codecs$package$().string32__Ljava_nio_charset_Charset__Lscodec_Codec($m_Lscodec_Platform$().Lscodec_Platform$__f_utf8);
  $m_Lscodec_codecs_codecs$package$().string32L__Ljava_nio_charset_Charset__Lscodec_Codec($m_Lscodec_Platform$().Lscodec_Platform$__f_utf8);
  this.Lscodec_codecs_codecs$package$__f_uuid = $m_Lscodec_codecs_UuidCodec$();
}
export { $c_Lscodec_codecs_codecs$package$ as $c_Lscodec_codecs_codecs$package$ };
$c_Lscodec_codecs_codecs$package$.prototype = new $h_O();
$c_Lscodec_codecs_codecs$package$.prototype.constructor = $c_Lscodec_codecs_codecs$package$;
/** @constructor */
function $h_Lscodec_codecs_codecs$package$() {
}
export { $h_Lscodec_codecs_codecs$package$ as $h_Lscodec_codecs_codecs$package$ };
$h_Lscodec_codecs_codecs$package$.prototype = $c_Lscodec_codecs_codecs$package$.prototype;
$c_Lscodec_codecs_codecs$package$.prototype.bits__J__Lscodec_Codec = (function(size) {
  $m_Lscodec_codecs_codecs$package$();
  var codec = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_bits;
  var this$2 = new $c_Lscodec_codecs_FixedSizeCodec(size, codec);
  var str = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (("bits(" + size) + ")")));
  return new $c_Lscodec_Codec$$anon$8(str, this$2);
});
$c_Lscodec_codecs_codecs$package$.prototype.nulTerminatedString__Lscodec_Codec__Lscodec_Codec = (function(stringCodec) {
  var noNullFound = new $c_sci_$colon$colon("Does not contain a 'NUL' termination byte.", $m_sci_Nil$());
  $m_Lscodec_codecs_codecs$package$();
  var filter = new $c_Lscodec_codecs_codecs$package$$anon$6(noNullFound);
  var this$2 = new $c_Lscodec_codecs_codecs$package$$anon$20(filter, stringCodec);
  var str = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (("nulTerminatedString(" + stringCodec) + ")")));
  return new $c_Lscodec_Codec$$anon$8(str, this$2);
});
$c_Lscodec_codecs_codecs$package$.prototype.string32__Ljava_nio_charset_Charset__Lscodec_Codec = (function(charset) {
  var this$2 = $m_Lscodec_codecs_codecs$package$().variableSizeBytes__Lscodec_Codec__Lscodec_Codec__I__Lscodec_Codec($m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_int32, ($m_Lscodec_codecs_codecs$package$(), new $c_Lscodec_codecs_StringCodec(charset)), ($m_Lscodec_codecs_codecs$package$(), 0));
  var str = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (("string32(" + charset.Ljava_nio_charset_Charset__f_canonicalName) + ")")));
  return new $c_Lscodec_Codec$$anon$8(str, this$2);
});
$c_Lscodec_codecs_codecs$package$.prototype.string32L__Ljava_nio_charset_Charset__Lscodec_Codec = (function(charset) {
  var this$2 = $m_Lscodec_codecs_codecs$package$().variableSizeBytes__Lscodec_Codec__Lscodec_Codec__I__Lscodec_Codec($m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_int32L, ($m_Lscodec_codecs_codecs$package$(), new $c_Lscodec_codecs_StringCodec(charset)), ($m_Lscodec_codecs_codecs$package$(), 0));
  var str = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (("string32(" + charset.Ljava_nio_charset_Charset__f_canonicalName) + ")")));
  return new $c_Lscodec_Codec$$anon$8(str, this$2);
});
$c_Lscodec_codecs_codecs$package$.prototype.variableSizeBytes__Lscodec_Codec__Lscodec_Codec__I__Lscodec_Codec = (function(size, value, sizePadding) {
  $m_Lscodec_codecs_codecs$package$();
  var size$1 = $m_Lscodec_codecs_codecs$package$().widenIntToLong__Lscodec_Codec__Lscodec_Codec(size);
  var hi = (sizePadding >> 31);
  return new $c_Lscodec_codecs_codecs$package$$anon$11(size$1, value, new $c_RTLong(sizePadding, hi));
});
$c_Lscodec_codecs_codecs$package$.prototype.widenIntToLong__Lscodec_Codec__Lscodec_Codec = (function(c) {
  var this$10 = $m_Lscodec_Codec$given\uff3fTransform\uff3fCodec$();
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((i) => {
    var i$1 = (i | 0);
    var hi = (i$1 >> 31);
    return new $c_RTLong(i$1, hi);
  }));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((l) => {
    var t = $uJ(l);
    var lo = t.RTLong__f_lo;
    var hi$1 = t.RTLong__f_hi;
    if ((((hi$1 === 0) ? ((lo >>> 0) > 2147483647) : (hi$1 > 0)) || ((hi$1 === (-1)) ? ((lo >>> 0) < 2147483648) : (hi$1 < (-1))))) {
      var message = (new $c_RTLong(lo, hi$1) + " cannot be converted to an integer");
      var err = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message);
      return new $c_Lscodec_Attempt$Failure(err);
    } else {
      return new $c_Lscodec_Attempt$Successful(lo);
    }
  }));
  var this$11 = $f_Lscodec_Transform__widen__O__F1__F1__O(this$10, c, f, g);
  var str = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.toString__T()));
  return new $c_Lscodec_Codec$$anon$8(str, this$11);
});
$c_Lscodec_codecs_codecs$package$.prototype.bitsToBytesDivisible__J__Lscodec_Attempt = (function(n) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(n.RTLong__f_lo, n.RTLong__f_hi, 8, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((lo === 0) && (hi === 0))) {
    var this$3 = $m_RTLong$();
    var lo$1 = this$3.divideImpl__I__I__I__I__I(n.RTLong__f_lo, n.RTLong__f_hi, 8, 0);
    var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_Lscodec_Attempt$Successful(new $c_RTLong(lo$1, hi$1));
  } else {
    var message = (n + " is not evenly divisible by 8");
    var err = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message);
    return new $c_Lscodec_Attempt$Failure(err);
  }
});
$c_Lscodec_codecs_codecs$package$.prototype.optional__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec = (function(guard, target) {
  var this$2 = $m_Lscodec_codecs_codecs$package$().either__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec(guard, ($m_Lscodec_codecs_codecs$package$(), new $c_Lscodec_codecs_ProvideCodec((void 0))), target);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$18) => _$18.toOption__s_Option()));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$19) => (_$19.isEmpty__Z() ? new $c_s_util_Left((void 0)) : new $c_s_util_Right(_$19.get__O()))));
  var this$3 = new $c_Lscodec_Codec$$anon$2(g, f, this$2);
  var str = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => (((("optional(" + guard) + ", ") + target) + ")")));
  return new $c_Lscodec_Codec$$anon$8(str, this$3);
});
$c_Lscodec_codecs_codecs$package$.prototype.either__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec = (function(indicator, left, right) {
  return ($m_Lscodec_codecs_codecs$package$(), new $c_Lscodec_codecs_codecs$package$$anon$22()).by__Lscodec_Codec__Lscodec_codecs_DiscriminatorCodec(indicator).caseP__O__s_PartialFunction__F1__Lscodec_Codec__Lscodec_codecs_DiscriminatorCodec(false, new $c_Lscodec_codecs_codecs$package$$anon$16(), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => new $c_s_util_Left(value))), left).caseP__O__s_PartialFunction__F1__Lscodec_Codec__Lscodec_codecs_DiscriminatorCodec(true, new $c_Lscodec_codecs_codecs$package$$anon$17(), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value$2) => new $c_s_util_Right(value$2))), right);
});
var $d_Lscodec_codecs_codecs$package$ = new $TypeData().initClass($c_Lscodec_codecs_codecs$package$, "scodec.codecs.codecs$package$", ({
  Lscodec_codecs_codecs$package$: 1
}));
export { $d_Lscodec_codecs_codecs$package$ as $d_Lscodec_codecs_codecs$package$ };
var $n_Lscodec_codecs_codecs$package$;
function $m_Lscodec_codecs_codecs$package$() {
  if ((!$n_Lscodec_codecs_codecs$package$)) {
    $n_Lscodec_codecs_codecs$package$ = new $c_Lscodec_codecs_codecs$package$();
  }
  return $n_Lscodec_codecs_codecs$package$;
}
export { $m_Lscodec_codecs_codecs$package$ as $m_Lscodec_codecs_codecs$package$ };
function $f_Lsquants_Dimension__equals__O__Z($thiz, that) {
  return ($is_Lsquants_Dimension(that) && ($objectClassName(that) === $objectClassName($thiz)));
}
export { $f_Lsquants_Dimension__equals__O__Z as $f_Lsquants_Dimension__equals__O__Z };
function $f_Lsquants_Dimension__hashCode__I($thiz) {
  return $f_T__hashCode__I($objectClassName($thiz));
}
export { $f_Lsquants_Dimension__hashCode__I as $f_Lsquants_Dimension__hashCode__I };
function $is_Lsquants_Dimension(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsquants_Dimension)));
}
export { $is_Lsquants_Dimension as $is_Lsquants_Dimension };
function $isArrayOf_Lsquants_Dimension(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsquants_Dimension)));
}
export { $isArrayOf_Lsquants_Dimension as $isArrayOf_Lsquants_Dimension };
/** @constructor */
function $c_Lsquants_Platform$() {
}
export { $c_Lsquants_Platform$ as $c_Lsquants_Platform$ };
$c_Lsquants_Platform$.prototype = new $h_O();
$c_Lsquants_Platform$.prototype.constructor = $c_Lsquants_Platform$;
/** @constructor */
function $h_Lsquants_Platform$() {
}
export { $h_Lsquants_Platform$ as $h_Lsquants_Platform$ };
$h_Lsquants_Platform$.prototype = $c_Lsquants_Platform$.prototype;
$c_Lsquants_Platform$.prototype.crossFormat__D__T = (function(d) {
  var this$1 = $m_RTLong$();
  var lo = this$1.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(d);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((((4.294967296E9 * hi) + (lo >>> 0.0)) === d)) {
    return $m_sc_StringOps$().format$extension__T__sci_Seq__T("%.1f", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([d])));
  } else {
    return ("" + d);
  }
});
var $d_Lsquants_Platform$ = new $TypeData().initClass($c_Lsquants_Platform$, "squants.Platform$", ({
  Lsquants_Platform$: 1
}));
export { $d_Lsquants_Platform$ as $d_Lsquants_Platform$ };
var $n_Lsquants_Platform$;
function $m_Lsquants_Platform$() {
  if ((!$n_Lsquants_Platform$)) {
    $n_Lsquants_Platform$ = new $c_Lsquants_Platform$();
  }
  return $n_Lsquants_Platform$;
}
export { $m_Lsquants_Platform$ as $m_Lsquants_Platform$ };
function $f_Lsquants_UnitConverter__converterTo__F1($thiz) {
  return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => {
    var value$1 = (+value);
    return (value$1 / $thiz.conversionFactor__D());
  }));
}
export { $f_Lsquants_UnitConverter__converterTo__F1 as $f_Lsquants_UnitConverter__converterTo__F1 };
function $f_Lsquants_UnitConverter__converterFrom__F1($thiz) {
  return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => {
    var value$1 = (+value);
    return (value$1 * $thiz.conversionFactor__D());
  }));
}
export { $f_Lsquants_UnitConverter__converterFrom__F1 as $f_Lsquants_UnitConverter__converterFrom__F1 };
function $f_Lsttp_model_HasHeaders__header__T__s_Option($thiz, h) {
  var this$2 = $thiz.headers__sci_Seq().find__F1__s_Option(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    var this$1 = _$2.Lsttp_model_Header__f_name;
    var len = this$1.length;
    if ((!((h === null) || (h.length !== len)))) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = this$1.charCodeAt(index);
        var $x_1 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = h.charCodeAt(index$1);
        if (($x_1 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    } else {
      return false;
    }
  })));
  if (this$2.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var x0 = this$2.get__O();
    return new $c_s_Some(x0.Lsttp_model_Header__f_value);
  }
}
export { $f_Lsttp_model_HasHeaders__header__T__s_Option as $f_Lsttp_model_HasHeaders__header__T__s_Option };
function $f_Lsttp_model_HasHeaders__headers__T__sci_Seq($thiz, h) {
  return $thiz.headers__sci_Seq().filter__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => {
    var this$1 = _$4.Lsttp_model_Header__f_name;
    var len = this$1.length;
    if ((!((h === null) || (h.length !== len)))) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = this$1.charCodeAt(index);
        var $x_1 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = h.charCodeAt(index$1);
        if (($x_1 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    } else {
      return false;
    }
  }))).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => _$5.Lsttp_model_Header__f_value)));
}
export { $f_Lsttp_model_HasHeaders__headers__T__sci_Seq as $f_Lsttp_model_HasHeaders__headers__T__sci_Seq };
/** @constructor */
function $c_Lsttp_model_Header(name, value) {
  this.Lsttp_model_Header__f_name = null;
  this.Lsttp_model_Header__f_value = null;
  this.Lsttp_model_Header__f_name = name;
  this.Lsttp_model_Header__f_value = value;
}
export { $c_Lsttp_model_Header as $c_Lsttp_model_Header };
$c_Lsttp_model_Header.prototype = new $h_O();
$c_Lsttp_model_Header.prototype.constructor = $c_Lsttp_model_Header;
/** @constructor */
function $h_Lsttp_model_Header() {
}
export { $h_Lsttp_model_Header as $h_Lsttp_model_Header };
$h_Lsttp_model_Header.prototype = $c_Lsttp_model_Header.prototype;
$c_Lsttp_model_Header.prototype.toString__T = (function() {
  return ((this.Lsttp_model_Header__f_name + ": ") + this.Lsttp_model_Header__f_value);
});
$c_Lsttp_model_Header.prototype.hashCode__I = (function() {
  var $x_1 = $m_s_util_hashing_MurmurHash3$();
  var this$1 = this.Lsttp_model_Header__f_name;
  return $x_1.mixLast__I__I__I($f_T__hashCode__I(this$1.toLowerCase()), $f_T__hashCode__I(this.Lsttp_model_Header__f_value));
});
$c_Lsttp_model_Header.prototype.equals__O__Z = (function(that) {
  if ((that !== null)) {
    if ((this === that)) {
      return true;
    }
  }
  if ((that instanceof $c_Lsttp_model_Header)) {
    var otherName = that.Lsttp_model_Header__f_name;
    var this$1 = this.Lsttp_model_Header__f_name;
    _return: {
      var len = this$1.length;
      if ((!((otherName === null) || (otherName.length !== len)))) {
        var i = 0;
        while ((i !== len)) {
          var index = i;
          var c = this$1.charCodeAt(index);
          var $x_2 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
          var index$1 = i;
          var c$1 = otherName.charCodeAt(index$1);
          if (($x_2 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
            var $x_1 = false;
            break _return;
          }
          i = ((1 + i) | 0);
        }
        var $x_1 = true;
      } else {
        var $x_1 = false;
      }
    }
    if ($x_1) {
      return (this.Lsttp_model_Header__f_value === that.Lsttp_model_Header__f_value);
    } else {
      return false;
    }
  }
  return false;
});
$c_Lsttp_model_Header.prototype.toStringSafe__sci_Set__T = (function(sensitiveHeaders) {
  var $x_1 = this.Lsttp_model_Header__f_name;
  var this$1 = $m_Lsttp_model_HeaderNames$();
  var headerName = this.Lsttp_model_Header__f_name;
  return (($x_1 + ": ") + ($f_Lsttp_model_HeaderNames__isSensitive__T__sci_Set__Z(this$1, headerName, sensitiveHeaders) ? "***" : this.Lsttp_model_Header__f_value));
});
function $isArrayOf_Lsttp_model_Header(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Header)));
}
export { $isArrayOf_Lsttp_model_Header as $isArrayOf_Lsttp_model_Header };
var $d_Lsttp_model_Header = new $TypeData().initClass($c_Lsttp_model_Header, "sttp.model.Header", ({
  Lsttp_model_Header: 1
}));
export { $d_Lsttp_model_Header as $d_Lsttp_model_Header };
/** @constructor */
function $c_Lsttp_model_Header$() {
  $n_Lsttp_model_Header$ = this;
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["mon", "tue", "wed", "thu", "fri", "sat", "sun"]));
  this$1.from__sc_IterableOnce__sci_Set(elems);
}
export { $c_Lsttp_model_Header$ as $c_Lsttp_model_Header$ };
$c_Lsttp_model_Header$.prototype = new $h_O();
$c_Lsttp_model_Header$.prototype.constructor = $c_Lsttp_model_Header$;
/** @constructor */
function $h_Lsttp_model_Header$() {
}
export { $h_Lsttp_model_Header$ as $h_Lsttp_model_Header$ };
$h_Lsttp_model_Header$.prototype = $c_Lsttp_model_Header$.prototype;
var $d_Lsttp_model_Header$ = new $TypeData().initClass($c_Lsttp_model_Header$, "sttp.model.Header$", ({
  Lsttp_model_Header$: 1
}));
export { $d_Lsttp_model_Header$ as $d_Lsttp_model_Header$ };
var $n_Lsttp_model_Header$;
function $m_Lsttp_model_Header$() {
  if ((!$n_Lsttp_model_Header$)) {
    $n_Lsttp_model_Header$ = new $c_Lsttp_model_Header$();
  }
  return $n_Lsttp_model_Header$;
}
export { $m_Lsttp_model_Header$ as $m_Lsttp_model_Header$ };
function $f_Lsttp_model_HeaderNames__$init$__V($thiz) {
  $thiz.Lsttp_model_HeaderNames$__f_AcceptEncoding = "Accept-Encoding";
  $thiz.Lsttp_model_HeaderNames$__f_Authorization = "Authorization";
  $thiz.Lsttp_model_HeaderNames$__f_ContentLength = "Content-Length";
  $thiz.Lsttp_model_HeaderNames$__f_ContentMd5 = "Content-MD5";
  $thiz.Lsttp_model_HeaderNames$__f_ContentType = "Content-Type";
  $thiz.Lsttp_model_HeaderNames$__f_Cookie = "Cookie";
  $thiz.Lsttp_model_HeaderNames$__f_ProxyAuthorization = "Proxy-Authorization";
  $thiz.Lsttp_model_HeaderNames$__f_SetCookie = "Set-Cookie";
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentLength, $m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType, $m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentMd5]));
  this$1.from__sc_IterableOnce__sci_Set(elems).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.toLowerCase())));
  var this$2 = $m_sci_Set$();
  var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_Authorization, $m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ProxyAuthorization, $m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_Cookie, $m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_SetCookie]));
  $thiz.Lsttp_model_HeaderNames$__f_SensitiveHeaders = this$2.from__sc_IterableOnce__sci_Set(elems$1).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => _$2.toLowerCase())));
}
export { $f_Lsttp_model_HeaderNames__$init$__V as $f_Lsttp_model_HeaderNames__$init$__V };
function $f_Lsttp_model_HeaderNames__isSensitive__T__sci_Set__Z($thiz, headerName, sensitiveHeaders) {
  return sensitiveHeaders.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => _$3.toLowerCase()))).contains__O__Z($f_T__trim__T(headerName.toLowerCase()));
}
export { $f_Lsttp_model_HeaderNames__isSensitive__T__sci_Set__Z as $f_Lsttp_model_HeaderNames__isSensitive__T__sci_Set__Z };
function $f_Lsttp_model_MediaTypes__$init$__V($thiz) {
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("application", "gzip", charset, otherParameters);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$1 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$1 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("application", "zip", charset$1, otherParameters$1);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$2 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$2 = $m_sci_Map$EmptyMap$();
  $thiz.Lsttp_model_MediaType$__f_ApplicationJson = new $c_Lsttp_model_MediaType("application", "json", charset$2, otherParameters$2);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$3 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$3 = $m_sci_Map$EmptyMap$();
  $thiz.Lsttp_model_MediaType$__f_ApplicationOctetStream = new $c_Lsttp_model_MediaType("application", "octet-stream", charset$3, otherParameters$3);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$4 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$4 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("application", "pdf", charset$4, otherParameters$4);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$5 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$5 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("application", "rtf", charset$5, otherParameters$5);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$6 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$6 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("application", "xhtml+xml", charset$6, otherParameters$6);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$7 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$7 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("application", "xml", charset$7, otherParameters$7);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$8 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$8 = $m_sci_Map$EmptyMap$();
  $thiz.Lsttp_model_MediaType$__f_ApplicationXWwwFormUrlencoded = new $c_Lsttp_model_MediaType("application", "x-www-form-urlencoded", charset$8, otherParameters$8);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$9 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$9 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("image", "gif", charset$9, otherParameters$9);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$10 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$10 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("image", "jpeg", charset$10, otherParameters$10);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$11 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$11 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("image", "png", charset$11, otherParameters$11);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$12 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$12 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("image", "tiff", charset$12, otherParameters$12);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$13 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$13 = $m_sci_Map$EmptyMap$();
  $thiz.Lsttp_model_MediaType$__f_MultipartFormData = new $c_Lsttp_model_MediaType("multipart", "form-data", charset$13, otherParameters$13);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$14 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$14 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("multipart", "mixed", charset$14, otherParameters$14);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$15 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$15 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("multipart", "alternative", charset$15, otherParameters$15);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$16 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$16 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("text", "cache-manifest", charset$16, otherParameters$16);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$17 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$17 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("text", "calendar", charset$17, otherParameters$17);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$18 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$18 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("text", "css", charset$18, otherParameters$18);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$19 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$19 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("text", "csv", charset$19, otherParameters$19);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$20 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$20 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("text", "event-stream", charset$20, otherParameters$20);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$21 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$21 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("text", "javascript", charset$21, otherParameters$21);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$22 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$22 = $m_sci_Map$EmptyMap$();
  $thiz.Lsttp_model_MediaType$__f_TextHtml = new $c_Lsttp_model_MediaType("text", "html", charset$22, otherParameters$22);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$23 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$23 = $m_sci_Map$EmptyMap$();
  $thiz.Lsttp_model_MediaType$__f_TextPlain = new $c_Lsttp_model_MediaType("text", "plain", charset$23, otherParameters$23);
  $m_Lsttp_model_MediaType$();
  var charset$24 = new $c_s_Some("utf-8");
  $m_Lsttp_model_MediaType$();
  var otherParameters$24 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("text", "plain", charset$24, otherParameters$24);
}
export { $f_Lsttp_model_MediaTypes__$init$__V as $f_Lsttp_model_MediaTypes__$init$__V };
/** @constructor */
function $c_Lsttp_model_Uri$FragmentEncoding$() {
  this.Lsttp_model_Uri$FragmentEncoding$__f_Standard = null;
  $n_Lsttp_model_Uri$FragmentEncoding$ = this;
  var allowedCharacters$6 = $m_Lsttp_model_internal_Rfc3986$().Lsttp_model_internal_Rfc3986$__f_Fragment;
  $m_Lsttp_model_internal_Rfc3986$();
  var spaceAsPlus$2 = false;
  $m_Lsttp_model_internal_Rfc3986$();
  var encodePlus$4 = false;
  this.Lsttp_model_Uri$FragmentEncoding$__f_Standard = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    var this$2 = $m_Lsttp_model_internal_Rfc3986$();
    return $p_Lsttp_model_internal_Rfc3986$__encode__T__T__sci_Set__Z__Z__T(this$2, s, "UTF-8", allowedCharacters$6, spaceAsPlus$2, encodePlus$4);
  }));
}
export { $c_Lsttp_model_Uri$FragmentEncoding$ as $c_Lsttp_model_Uri$FragmentEncoding$ };
$c_Lsttp_model_Uri$FragmentEncoding$.prototype = new $h_O();
$c_Lsttp_model_Uri$FragmentEncoding$.prototype.constructor = $c_Lsttp_model_Uri$FragmentEncoding$;
/** @constructor */
function $h_Lsttp_model_Uri$FragmentEncoding$() {
}
export { $h_Lsttp_model_Uri$FragmentEncoding$ as $h_Lsttp_model_Uri$FragmentEncoding$ };
$h_Lsttp_model_Uri$FragmentEncoding$.prototype = $c_Lsttp_model_Uri$FragmentEncoding$.prototype;
var $d_Lsttp_model_Uri$FragmentEncoding$ = new $TypeData().initClass($c_Lsttp_model_Uri$FragmentEncoding$, "sttp.model.Uri$FragmentEncoding$", ({
  Lsttp_model_Uri$FragmentEncoding$: 1
}));
export { $d_Lsttp_model_Uri$FragmentEncoding$ as $d_Lsttp_model_Uri$FragmentEncoding$ };
var $n_Lsttp_model_Uri$FragmentEncoding$;
function $m_Lsttp_model_Uri$FragmentEncoding$() {
  if ((!$n_Lsttp_model_Uri$FragmentEncoding$)) {
    $n_Lsttp_model_Uri$FragmentEncoding$ = new $c_Lsttp_model_Uri$FragmentEncoding$();
  }
  return $n_Lsttp_model_Uri$FragmentEncoding$;
}
export { $m_Lsttp_model_Uri$FragmentEncoding$ as $m_Lsttp_model_Uri$FragmentEncoding$ };
/** @constructor */
function $c_Lsttp_model_Uri$HostEncoding$() {
  this.Lsttp_model_Uri$HostEncoding$__f_IpV6Pattern = null;
  this.Lsttp_model_Uri$HostEncoding$__f_Standard = null;
  $n_Lsttp_model_Uri$HostEncoding$ = this;
  this.Lsttp_model_Uri$HostEncoding$__f_IpV6Pattern = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[0-9a-fA-F:]+", $m_sci_Nil$());
  this.Lsttp_model_Uri$HostEncoding$__f_Standard = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var x152 = this.Lsttp_model_Uri$HostEncoding$__f_IpV6Pattern.unapplySeq__jl_CharSequence__s_Option(x$1);
      if ((!x152.isEmpty__Z())) {
        var x153 = x152.get__O();
        if ((x153.lengthCompare__I__I(0) === 0)) {
          var i = 0;
          var res = 0;
          var len = x$1.length;
          while ((i < len)) {
            var index = i;
            var x0 = x$1.charCodeAt(index);
            if ((x0 === 58)) {
              res = ((1 + res) | 0);
            }
            i = ((1 + i) | 0);
          }
          if ((res >= 2)) {
            return (("[" + x$1) + "]");
          }
        }
      }
    }
    return $m_Lsttp_model_internal_UriCompatibility$().encodeDNSHost__T__T(x$1);
  }));
}
export { $c_Lsttp_model_Uri$HostEncoding$ as $c_Lsttp_model_Uri$HostEncoding$ };
$c_Lsttp_model_Uri$HostEncoding$.prototype = new $h_O();
$c_Lsttp_model_Uri$HostEncoding$.prototype.constructor = $c_Lsttp_model_Uri$HostEncoding$;
/** @constructor */
function $h_Lsttp_model_Uri$HostEncoding$() {
}
export { $h_Lsttp_model_Uri$HostEncoding$ as $h_Lsttp_model_Uri$HostEncoding$ };
$h_Lsttp_model_Uri$HostEncoding$.prototype = $c_Lsttp_model_Uri$HostEncoding$.prototype;
var $d_Lsttp_model_Uri$HostEncoding$ = new $TypeData().initClass($c_Lsttp_model_Uri$HostEncoding$, "sttp.model.Uri$HostEncoding$", ({
  Lsttp_model_Uri$HostEncoding$: 1
}));
export { $d_Lsttp_model_Uri$HostEncoding$ as $d_Lsttp_model_Uri$HostEncoding$ };
var $n_Lsttp_model_Uri$HostEncoding$;
function $m_Lsttp_model_Uri$HostEncoding$() {
  if ((!$n_Lsttp_model_Uri$HostEncoding$)) {
    $n_Lsttp_model_Uri$HostEncoding$ = new $c_Lsttp_model_Uri$HostEncoding$();
  }
  return $n_Lsttp_model_Uri$HostEncoding$;
}
export { $m_Lsttp_model_Uri$HostEncoding$ as $m_Lsttp_model_Uri$HostEncoding$ };
/** @constructor */
function $c_Lsttp_model_Uri$PathSegmentEncoding$() {
  this.Lsttp_model_Uri$PathSegmentEncoding$__f_Standard = null;
  $n_Lsttp_model_Uri$PathSegmentEncoding$ = this;
  var allowedCharacters$1 = $m_Lsttp_model_internal_Rfc3986$().Lsttp_model_internal_Rfc3986$__f_PathSegment;
  $m_Lsttp_model_internal_Rfc3986$();
  var spaceAsPlus$1 = false;
  $m_Lsttp_model_internal_Rfc3986$();
  var encodePlus$1 = false;
  this.Lsttp_model_Uri$PathSegmentEncoding$__f_Standard = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    var this$2 = $m_Lsttp_model_internal_Rfc3986$();
    return $p_Lsttp_model_internal_Rfc3986$__encode__T__T__sci_Set__Z__Z__T(this$2, s, "UTF-8", allowedCharacters$1, spaceAsPlus$1, encodePlus$1);
  }));
}
export { $c_Lsttp_model_Uri$PathSegmentEncoding$ as $c_Lsttp_model_Uri$PathSegmentEncoding$ };
$c_Lsttp_model_Uri$PathSegmentEncoding$.prototype = new $h_O();
$c_Lsttp_model_Uri$PathSegmentEncoding$.prototype.constructor = $c_Lsttp_model_Uri$PathSegmentEncoding$;
/** @constructor */
function $h_Lsttp_model_Uri$PathSegmentEncoding$() {
}
export { $h_Lsttp_model_Uri$PathSegmentEncoding$ as $h_Lsttp_model_Uri$PathSegmentEncoding$ };
$h_Lsttp_model_Uri$PathSegmentEncoding$.prototype = $c_Lsttp_model_Uri$PathSegmentEncoding$.prototype;
var $d_Lsttp_model_Uri$PathSegmentEncoding$ = new $TypeData().initClass($c_Lsttp_model_Uri$PathSegmentEncoding$, "sttp.model.Uri$PathSegmentEncoding$", ({
  Lsttp_model_Uri$PathSegmentEncoding$: 1
}));
export { $d_Lsttp_model_Uri$PathSegmentEncoding$ as $d_Lsttp_model_Uri$PathSegmentEncoding$ };
var $n_Lsttp_model_Uri$PathSegmentEncoding$;
function $m_Lsttp_model_Uri$PathSegmentEncoding$() {
  if ((!$n_Lsttp_model_Uri$PathSegmentEncoding$)) {
    $n_Lsttp_model_Uri$PathSegmentEncoding$ = new $c_Lsttp_model_Uri$PathSegmentEncoding$();
  }
  return $n_Lsttp_model_Uri$PathSegmentEncoding$;
}
export { $m_Lsttp_model_Uri$PathSegmentEncoding$ as $m_Lsttp_model_Uri$PathSegmentEncoding$ };
function $f_Lsttp_model_Uri$PathSegments__addSegments__sc_Seq__Lsttp_model_Uri$PathSegments($thiz, ss) {
  var this$1 = $thiz.segments__sc_Seq().lastOption__s_Option();
  if ((!this$1.isEmpty__Z())) {
    var x0 = this$1.get__O();
    var this$2 = x0.Lsttp_model_Uri$Segment__f_v;
    var $x_1 = (this$2 === "");
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var base = $thiz.segments__sc_Seq().init__O();
  } else {
    var base = $thiz.segments__sc_Seq();
  }
  var suffix = ss.toList__sci_List();
  return $thiz.withSegments__sc_Seq__Lsttp_model_Uri$PathSegments(base.appendedAll__sc_IterableOnce__O(suffix));
}
export { $f_Lsttp_model_Uri$PathSegments__addSegments__sc_Seq__Lsttp_model_Uri$PathSegments as $f_Lsttp_model_Uri$PathSegments__addSegments__sc_Seq__Lsttp_model_Uri$PathSegments };
/** @constructor */
function $c_Lsttp_model_Uri$QuerySegmentEncoding$() {
  this.Lsttp_model_Uri$QuerySegmentEncoding$__f_Standard = null;
  this.Lsttp_model_Uri$QuerySegmentEncoding$__f_StandardValue = null;
  $n_Lsttp_model_Uri$QuerySegmentEncoding$ = this;
  var this$3 = $m_Lsttp_model_internal_Rfc3986$().Lsttp_model_internal_Rfc3986$__f_Query;
  var this$2 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([38, 61])));
  var that = this$2.from__sc_IterableOnce__sci_Set(elems);
  var allowedCharacters$2 = this$3.removedAll__sc_IterableOnce__sci_SetOps(that);
  this.Lsttp_model_Uri$QuerySegmentEncoding$__f_Standard = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    var this$4 = $m_Lsttp_model_internal_Rfc3986$();
    return $p_Lsttp_model_internal_Rfc3986$__encode__T__T__sci_Set__Z__Z__T(this$4, s, "UTF-8", allowedCharacters$2, true, true);
  }));
  var this$6 = $m_Lsttp_model_internal_Rfc3986$().Lsttp_model_internal_Rfc3986$__f_Query;
  var this$5 = $m_sci_Set$();
  var elems$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([38])));
  var that$1 = this$5.from__sc_IterableOnce__sci_Set(elems$1);
  var allowedCharacters$3 = this$6.removedAll__sc_IterableOnce__sci_SetOps(that$1);
  this.Lsttp_model_Uri$QuerySegmentEncoding$__f_StandardValue = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$2) => {
    var this$7 = $m_Lsttp_model_internal_Rfc3986$();
    return $p_Lsttp_model_internal_Rfc3986$__encode__T__T__sci_Set__Z__Z__T(this$7, s$2, "UTF-8", allowedCharacters$3, true, true);
  }));
  var allowedCharacters$4 = $m_Lsttp_model_internal_Rfc3986$().Lsttp_model_internal_Rfc3986$__f_Query;
  $m_Lsttp_model_internal_Rfc3986$();
  var allowedCharacters$5 = $m_Lsttp_model_internal_Rfc3986$().Lsttp_model_internal_Rfc3986$__f_QueryWithBrackets;
  $m_Lsttp_model_internal_Rfc3986$();
}
export { $c_Lsttp_model_Uri$QuerySegmentEncoding$ as $c_Lsttp_model_Uri$QuerySegmentEncoding$ };
$c_Lsttp_model_Uri$QuerySegmentEncoding$.prototype = new $h_O();
$c_Lsttp_model_Uri$QuerySegmentEncoding$.prototype.constructor = $c_Lsttp_model_Uri$QuerySegmentEncoding$;
/** @constructor */
function $h_Lsttp_model_Uri$QuerySegmentEncoding$() {
}
export { $h_Lsttp_model_Uri$QuerySegmentEncoding$ as $h_Lsttp_model_Uri$QuerySegmentEncoding$ };
$h_Lsttp_model_Uri$QuerySegmentEncoding$.prototype = $c_Lsttp_model_Uri$QuerySegmentEncoding$.prototype;
var $d_Lsttp_model_Uri$QuerySegmentEncoding$ = new $TypeData().initClass($c_Lsttp_model_Uri$QuerySegmentEncoding$, "sttp.model.Uri$QuerySegmentEncoding$", ({
  Lsttp_model_Uri$QuerySegmentEncoding$: 1
}));
export { $d_Lsttp_model_Uri$QuerySegmentEncoding$ as $d_Lsttp_model_Uri$QuerySegmentEncoding$ };
var $n_Lsttp_model_Uri$QuerySegmentEncoding$;
function $m_Lsttp_model_Uri$QuerySegmentEncoding$() {
  if ((!$n_Lsttp_model_Uri$QuerySegmentEncoding$)) {
    $n_Lsttp_model_Uri$QuerySegmentEncoding$ = new $c_Lsttp_model_Uri$QuerySegmentEncoding$();
  }
  return $n_Lsttp_model_Uri$QuerySegmentEncoding$;
}
export { $m_Lsttp_model_Uri$QuerySegmentEncoding$ as $m_Lsttp_model_Uri$QuerySegmentEncoding$ };
function $p_Lsttp_model_UriInterpolator$__tokenize__s_StringContext__sci_Seq__scm_ArrayBuffer($thiz, sc, args) {
  var strings = sc.s_StringContext__f_parts.iterator__sc_Iterator();
  var expressions = args.iterator__sc_Iterator();
  var tokens = $ct_scm_ArrayBuffer__I__(new $c_scm_ArrayBuffer(), 32);
  var elem = $m_Lsttp_model_UriInterpolator$Tokenizer$Scheme$().tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(tokens, strings.next__O());
  var elem$1 = null;
  elem$1 = elem;
  while (strings.hasNext__Z()) {
    var nextExpression = expressions.next__O();
    var nextExpressionStr = $dp_toString__T(nextExpression);
    var nextStr = strings.next__O();
    if ((tokens.scm_ArrayBuffer__f_size0 === 1)) {
      var that = new $c_sci_$colon$colon($thiz.Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$emptyStringToken, $m_sci_Nil$());
      var $x_1 = $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z(tokens, that, 0);
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (((nextExpressionStr.indexOf("://") | 0) !== (-1)) || ((nextStr.indexOf("://") | 0) === (-1))))) {
      elem$1 = elem$1.tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(tokens, $dp_toString__T(nextExpression));
      var initLength = tokens.scm_ArrayBuffer__f_size0;
      elem$1 = elem$1.tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(tokens, nextStr);
      if ((initLength < tokens.scm_ArrayBuffer__f_size0)) {
        var x = tokens.apply__I__O(initLength);
        var x$2 = $thiz.Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$emptyStringToken;
        var $x_2 = ((x === null) ? (x$2 === null) : $dp_equals__O__Z(x, x$2));
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        tokens.update__I__O__V(initLength, null);
      }
      var this$2 = $p_Lsttp_model_UriInterpolator$__nextNonNull__scm_ArrayBuffer__I__s_Option($thiz, tokens, initLength);
      if (this$2.isEmpty__Z()) {
        var $x_3 = true;
      } else {
        var x0 = this$2.get__O();
        var x$1 = x0._2__O();
        var x$2$1 = $m_Lsttp_model_UriInterpolator$SlashInPath$();
        var $x_3 = ((x$1 !== null) && $dp_equals__O__Z(x$1, x$2$1));
      }
      if ($x_3) {
        var this$3 = this$2;
      } else {
        var this$3 = $m_s_None$();
      }
      var p = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$1) => ((x$1$1 !== null) && ((x$1$1._1__O() | 0), true))));
      var this$4 = new $c_s_Option$WithFilter(this$3, p);
      var this$5 = this$4.s_Option$WithFilter__f_$outer;
      var p$1 = this$4.s_Option$WithFilter__f_p;
      var this$6 = ((this$5.isEmpty__Z() || (!(!p$1.apply__O__O(this$5.get__O())))) ? this$5 : $m_s_None$());
      if ((!this$6.isEmpty__Z())) {
        var x0$1 = this$6.get__O();
        matchResult7: {
          if ((x0$1 !== null)) {
            var slashInPathIdx$1 = (x0$1._1__O() | 0);
            var this$7 = $p_Lsttp_model_UriInterpolator$__lastNonNull__scm_ArrayBuffer__I__s_Option($thiz, tokens, (((-1) + initLength) | 0));
            if (this$7.isEmpty__Z()) {
              var $x_4 = true;
            } else {
              var x0$2 = this$7.get__O();
              var x$3 = x0$2._2__O();
              var x$2$2 = $m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$emptyStringToken;
              var $x_4 = ((x$3 === null) ? (x$2$2 === null) : $dp_equals__O__Z(x$3, x$2$2));
            }
            if ($x_4) {
              var this$8 = this$7;
            } else {
              var this$8 = $m_s_None$();
            }
            var p$2 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => ((x$1$2 !== null) && ((x$1$2._1__O() | 0), true))));
            var this$9 = new $c_s_Option$WithFilter(this$8, p$2);
            var this$10 = this$9.s_Option$WithFilter__f_$outer;
            var p$3 = this$9.s_Option$WithFilter__f_p;
            var this$11 = ((this$10.isEmpty__Z() || (!(!p$3.apply__O__O(this$10.get__O())))) ? this$10 : $m_s_None$());
            if ((!this$11.isEmpty__Z())) {
              var x0$3 = this$11.get__O();
              if ((x0$3 !== null)) {
                var emptyStringTokenIdx$1 = (x0$3._1__O() | 0);
                var this$12 = $p_Lsttp_model_UriInterpolator$__lastNonNull__scm_ArrayBuffer__I__s_Option($thiz, tokens, (((-1) + emptyStringTokenIdx$1) | 0));
                if (this$12.isEmpty__Z()) {
                  var $x_5 = true;
                } else {
                  var x0$4 = this$12.get__O();
                  var $x_5 = $p_Lsttp_model_UriInterpolator$__isSlash$1__Lsttp_model_UriInterpolator$Token__Z($thiz, x0$4._2__O());
                }
                if ($x_5) {
                  var this$13 = this$12;
                } else {
                  var this$13 = $m_s_None$();
                }
                if ((!this$13.isEmpty__Z())) {
                  this$13.get__O();
                  tokens.update__I__O__V(slashInPathIdx$1, null);
                  tokens.update__I__O__V(emptyStringTokenIdx$1, null);
                  break matchResult7;
                } else {
                  break matchResult7;
                }
              }
              throw new $c_s_MatchError(x0$3);
            } else {
              break matchResult7;
            }
          }
          throw new $c_s_MatchError(x0$1);
        }
      }
    } else {
      var elem$2 = new $c_Lsttp_model_UriInterpolator$ExpressionToken(nextExpression);
      tokens.addOne__O__scm_ArrayBuffer(elem$2);
      elem$1 = elem$1.tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(tokens, nextStr);
    }
  }
  var this$15 = elem$1.endToken__s_Option();
  if ((!this$15.isEmpty__Z())) {
    var x0$6 = this$15.get__O();
    tokens.addOne__O__scm_ArrayBuffer(x0$6);
  }
  $p_Lsttp_model_UriInterpolator$__removeEmptyTokensAroundExp__scm_ArrayBuffer__V($thiz, tokens);
  $p_Lsttp_model_UriInterpolator$__addPathStartAfterAuthorityOrSchemeEnd__scm_ArrayBuffer__V($thiz, tokens);
  return tokens;
}
export { $p_Lsttp_model_UriInterpolator$__tokenize__s_StringContext__sci_Seq__scm_ArrayBuffer as $p_Lsttp_model_UriInterpolator$__tokenize__s_StringContext__sci_Seq__scm_ArrayBuffer };
function $p_Lsttp_model_UriInterpolator$__removeEmptyTokensAroundExp__scm_ArrayBuffer__V($thiz, tokens) {
  var elem = false;
  elem = false;
  var elem$1 = false;
  elem$1 = false;
  var end = tokens.scm_ArrayBuffer__f_size0;
  var isEmpty = (end <= 0);
  var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
  if ((!isEmpty)) {
    var i = 0;
    while (true) {
      var x0 = i;
      matchResult84: {
        var x297 = tokens.apply__I__O(x0);
        var x = $m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$emptyStringToken;
        if (((x === null) ? (x297 === null) : x.equals__O__Z(x297))) {
          if (elem$1) {
            tokens.update__I__O__V(x0, null);
            elem$1 = false;
            break matchResult84;
          } else {
            elem = true;
            break matchResult84;
          }
        }
        if ((x297 instanceof $c_Lsttp_model_UriInterpolator$ExpressionToken)) {
          if (elem) {
            tokens.update__I__O__V((((-1) + x0) | 0), null);
            elem = false;
          }
          elem$1 = true;
          break matchResult84;
        }
        if ((x297 === null)) {
          break matchResult84;
        }
        elem$1 = false;
        elem = false;
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
}
export { $p_Lsttp_model_UriInterpolator$__removeEmptyTokensAroundExp__scm_ArrayBuffer__V as $p_Lsttp_model_UriInterpolator$__removeEmptyTokensAroundExp__scm_ArrayBuffer__V };
function $p_Lsttp_model_UriInterpolator$__addPathStartAfterAuthorityOrSchemeEnd__scm_ArrayBuffer__V($thiz, tokens) {
  matchResult85: {
    var endIndex;
    var elem = $m_Lsttp_model_UriInterpolator$AuthorityEnd$();
    var x301 = $f_sc_SeqOps__indexOf__O__I__I(tokens, elem, 0);
    if ((x301 === (-1))) {
      var elem$1 = $m_Lsttp_model_UriInterpolator$SchemeEnd$();
      var endIndex = $f_sc_SeqOps__indexOf__O__I__I(tokens, elem$1, 0);
      break matchResult85;
    }
    var endIndex = x301;
  }
  var this$1 = $p_Lsttp_model_UriInterpolator$__nextNonNull__scm_ArrayBuffer__I__s_Option($thiz, tokens, ((1 + endIndex) | 0));
  if ((!this$1.isEmpty__Z())) {
    var x0 = this$1.get__O();
    matchResult86: {
      if ((x0 !== null)) {
        var afterEndIndex = x0._2__O();
        var x$2 = $m_Lsttp_model_UriInterpolator$PathStart$();
        if ((!((afterEndIndex !== null) && afterEndIndex.equals__O__Z(x$2)))) {
          var x$4 = $m_Lsttp_model_UriInterpolator$QueryStart$();
          var $x_2 = (!((afterEndIndex !== null) && afterEndIndex.equals__O__Z(x$4)));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          var x$6 = $m_Lsttp_model_UriInterpolator$FragmentStart$();
          var $x_1 = (!((afterEndIndex !== null) && afterEndIndex.equals__O__Z(x$6)));
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          if ((endIndex === (-1))) {
            tokens.prepend__O__scm_ArrayBuffer($m_Lsttp_model_UriInterpolator$PathStart$());
          } else {
            tokens.insert__I__O__V(((1 + endIndex) | 0), $m_Lsttp_model_UriInterpolator$PathStart$());
          }
          break matchResult86;
        } else {
          break matchResult86;
        }
      }
      throw new $c_s_MatchError(x0);
    }
  }
}
export { $p_Lsttp_model_UriInterpolator$__addPathStartAfterAuthorityOrSchemeEnd__scm_ArrayBuffer__V as $p_Lsttp_model_UriInterpolator$__addPathStartAfterAuthorityOrSchemeEnd__scm_ArrayBuffer__V };
function $p_Lsttp_model_UriInterpolator$__filterNulls__scm_ArrayBuffer__Lsttp_model_internal_ArrayView($thiz, tokens) {
  var array = new ($d_Lsttp_model_UriInterpolator$Token.getArrayOf().constr)(tokens.scm_ArrayBuffer__f_size0);
  var elem = 0;
  elem = 0;
  var it = tokens.view__scm_ArrayBufferView().iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var x0 = it.next__O();
    if ((x0 !== null)) {
      array.u[elem] = x0;
      elem = ((1 + elem) | 0);
    }
  }
  return new $c_Lsttp_model_internal_ArrayView(array, 0, elem);
}
export { $p_Lsttp_model_UriInterpolator$__filterNulls__scm_ArrayBuffer__Lsttp_model_internal_ArrayView as $p_Lsttp_model_UriInterpolator$__filterNulls__scm_ArrayBuffer__Lsttp_model_internal_ArrayView };
function $p_Lsttp_model_UriInterpolator$__lastNonNull__scm_ArrayBuffer__I__s_Option($thiz, tokens, from) {
  var i = (((-1) + tokens.scm_ArrayBuffer__f_size0) | 0);
  var it = tokens.view__scm_ArrayBufferView().reverseIterator__sc_Iterator();
  while (true) {
    if (it.hasNext__Z()) {
      var elem = it.next__O();
      var $x_1 = ((i > from) || (elem === null));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      i = (((-1) + i) | 0);
    } else {
      break;
    }
  }
  var idx = i;
  if ((idx === (-1))) {
    return $m_s_None$();
  } else {
    var _2 = tokens.apply__I__O(idx);
    var value = $ct_T2__O__O__(new $c_T2(), idx, _2);
    return new $c_s_Some(value);
  }
}
export { $p_Lsttp_model_UriInterpolator$__lastNonNull__scm_ArrayBuffer__I__s_Option as $p_Lsttp_model_UriInterpolator$__lastNonNull__scm_ArrayBuffer__I__s_Option };
function $p_Lsttp_model_UriInterpolator$__nextNonNull__scm_ArrayBuffer__I__s_Option($thiz, tokens, from) {
  var this$1 = tokens.view__scm_ArrayBufferView().iterator__sc_Iterator();
  _return: {
    var i = ((from > 0) ? from : 0);
    var dropped = this$1.drop__I__sc_Iterator(from);
    while (dropped.hasNext__Z()) {
      var x0 = dropped.next__O();
      if ((x0 !== null)) {
        var idx = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var idx = (-1);
  }
  if ((idx === (-1))) {
    return $m_s_None$();
  } else {
    var _2 = tokens.apply__I__O(idx);
    var value = $ct_T2__O__O__(new $c_T2(), idx, _2);
    return new $c_s_Some(value);
  }
}
export { $p_Lsttp_model_UriInterpolator$__nextNonNull__scm_ArrayBuffer__I__s_Option as $p_Lsttp_model_UriInterpolator$__nextNonNull__scm_ArrayBuffer__I__s_Option };
function $p_Lsttp_model_UriInterpolator$__isSlash$1__Lsttp_model_UriInterpolator$Token__Z($thiz, t) {
  var x$2 = $m_Lsttp_model_UriInterpolator$SlashInPath$();
  if (((t !== null) && t.equals__O__Z(x$2))) {
    return true;
  } else {
    var x$4 = $m_Lsttp_model_UriInterpolator$PathStart$();
    return ((t !== null) && t.equals__O__Z(x$4));
  }
}
export { $p_Lsttp_model_UriInterpolator$__isSlash$1__Lsttp_model_UriInterpolator$Token__Z as $p_Lsttp_model_UriInterpolator$__isSlash$1__Lsttp_model_UriInterpolator$Token__Z };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$() {
  this.Lsttp_model_UriInterpolator$__f_startingUri = null;
  this.Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag = null;
  this.Lsttp_model_UriInterpolator$__f_builders = null;
  this.Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$emptyStringToken = null;
  $n_Lsttp_model_UriInterpolator$ = this;
  $m_Lsttp_model_Uri$();
  var scheme = $m_s_None$();
  var authority = $m_s_None$();
  var pathSegments = $m_Lsttp_model_Uri$EmptyPath$();
  var querySegments = $m_sci_Nil$();
  var fragmentSegment = $m_s_None$();
  this.Lsttp_model_UriInterpolator$__f_startingUri = new $c_Lsttp_model_Uri(scheme, authority, pathSegments, querySegments, fragmentSegment);
  this.Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag = new $c_s_reflect_ClassTag$GenericClassTag($d_Lsttp_model_UriInterpolator$Token.getClassOf());
  this.Lsttp_model_UriInterpolator$__f_builders = new $c_sci_$colon$colon($m_Lsttp_model_UriInterpolator$UriBuilder$Scheme$(), new $c_sci_$colon$colon($m_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$(), new $c_sci_$colon$colon($m_Lsttp_model_UriInterpolator$UriBuilder$HostPort$(), new $c_sci_$colon$colon($m_Lsttp_model_UriInterpolator$UriBuilder$Path$(), new $c_sci_$colon$colon($m_Lsttp_model_UriInterpolator$UriBuilder$Query$(), new $c_sci_$colon$colon($m_Lsttp_model_UriInterpolator$UriBuilder$Fragment$(), $m_sci_Nil$()))))));
  this.Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$emptyStringToken = new $c_Lsttp_model_UriInterpolator$StringToken("");
}
export { $c_Lsttp_model_UriInterpolator$ as $c_Lsttp_model_UriInterpolator$ };
$c_Lsttp_model_UriInterpolator$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$.prototype.constructor = $c_Lsttp_model_UriInterpolator$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$() {
}
export { $h_Lsttp_model_UriInterpolator$ as $h_Lsttp_model_UriInterpolator$ };
$h_Lsttp_model_UriInterpolator$.prototype = $c_Lsttp_model_UriInterpolator$.prototype;
$c_Lsttp_model_UriInterpolator$.prototype.interpolate__s_StringContext__sci_Seq__Lsttp_model_Uri = (function(sc, args) {
  var isScEmptyString = sc.s_StringContext__f_parts.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => $f_T__trim__T(_$1)))).forall__F1__Z(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => (_$2 === ""))));
  var areArgsEmptyString = args.forall__F1__Z(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => $dp_equals__O__Z(_$3, ""))));
  if ((isScEmptyString && areArgsEmptyString)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "empty string is not valid uri");
  }
  var tokens = $p_Lsttp_model_UriInterpolator$__tokenize__s_StringContext__sci_Seq__scm_ArrayBuffer(this, sc, args);
  matchResult2: {
    var \u03b41$___1;
    var \u03b41$___2;
    var this$2 = this.Lsttp_model_UriInterpolator$__f_builders;
    var _1 = this.Lsttp_model_UriInterpolator$__f_startingUri;
    var _2 = $p_Lsttp_model_UriInterpolator$__filterNulls__scm_ArrayBuffer__Lsttp_model_internal_ArrayView(this, tokens);
    var z = $ct_T2__O__O__(new $c_T2(), _1, _2);
    var acc = z;
    var these = this$2;
    while ((!these.isEmpty__Z())) {
      var x0 = acc;
      var x1 = these.head__O();
      matchResult1: {
        var x1$1 = $ct_T2__O__O__(new $c_T2(), x0, x1);
        var x2 = x1$1.T2__f__1;
        if ((x2 !== null)) {
          var u = x2._1__O();
          var t = x2._2__O();
          var builder = x1$1.T2__f__2;
          acc = builder.fromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__T2(u, t);
          break matchResult1;
        }
        throw new $c_s_MatchError(x1$1);
      }
      these = these.tail__O();
    }
    var x6 = acc;
    if ((x6 !== null)) {
      var uri = x6._1__O();
      var leftTokens = x6._2__O();
      var \u03b41$___1 = uri;
      var \u03b41$___2 = leftTokens;
      break matchResult2;
    }
    throw new $c_s_MatchError(x6);
  }
  var uri$2 = \u03b41$___1;
  var leftTokens$2 = \u03b41$___2;
  if (leftTokens$2.nonEmpty__Z()) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Tokens left after building the whole uri: " + leftTokens$2) + ", result so far: ") + uri$2));
  }
  return uri$2;
});
var $d_Lsttp_model_UriInterpolator$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$, "sttp.model.UriInterpolator$", ({
  Lsttp_model_UriInterpolator$: 1
}));
export { $d_Lsttp_model_UriInterpolator$ as $d_Lsttp_model_UriInterpolator$ };
var $n_Lsttp_model_UriInterpolator$;
function $m_Lsttp_model_UriInterpolator$() {
  if ((!$n_Lsttp_model_UriInterpolator$)) {
    $n_Lsttp_model_UriInterpolator$ = new $c_Lsttp_model_UriInterpolator$();
  }
  return $n_Lsttp_model_UriInterpolator$;
}
export { $m_Lsttp_model_UriInterpolator$ as $m_Lsttp_model_UriInterpolator$ };
var $d_Lsttp_model_UriInterpolator$Token = new $TypeData().initClass(1, "sttp.model.UriInterpolator$Token", ({
  Lsttp_model_UriInterpolator$Token: 1
}));
export { $d_Lsttp_model_UriInterpolator$Token as $d_Lsttp_model_UriInterpolator$Token };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$UriContext(outer, sc) {
  this.Lsttp_model_UriInterpolator$UriContext__f_sc = null;
  this.Lsttp_model_UriInterpolator$UriContext__f_sc = sc;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Lsttp_model_UriInterpolator$UriContext as $c_Lsttp_model_UriInterpolator$UriContext };
$c_Lsttp_model_UriInterpolator$UriContext.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$UriContext.prototype.constructor = $c_Lsttp_model_UriInterpolator$UriContext;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$UriContext() {
}
export { $h_Lsttp_model_UriInterpolator$UriContext as $h_Lsttp_model_UriInterpolator$UriContext };
$h_Lsttp_model_UriInterpolator$UriContext.prototype = $c_Lsttp_model_UriInterpolator$UriContext.prototype;
var $d_Lsttp_model_UriInterpolator$UriContext = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$UriContext, "sttp.model.UriInterpolator$UriContext", ({
  Lsttp_model_UriInterpolator$UriContext: 1
}));
export { $d_Lsttp_model_UriInterpolator$UriContext as $d_Lsttp_model_UriInterpolator$UriContext };
/** @constructor */
function $c_Lsttp_model_internal_ArrayView(arr, from, till) {
  this.Lsttp_model_internal_ArrayView__f_arr = null;
  this.Lsttp_model_internal_ArrayView__f_from = 0;
  this.Lsttp_model_internal_ArrayView__f_till = 0;
  this.Lsttp_model_internal_ArrayView__f_arr = arr;
  this.Lsttp_model_internal_ArrayView__f_from = from;
  this.Lsttp_model_internal_ArrayView__f_till = till;
}
export { $c_Lsttp_model_internal_ArrayView as $c_Lsttp_model_internal_ArrayView };
$c_Lsttp_model_internal_ArrayView.prototype = new $h_O();
$c_Lsttp_model_internal_ArrayView.prototype.constructor = $c_Lsttp_model_internal_ArrayView;
/** @constructor */
function $h_Lsttp_model_internal_ArrayView() {
}
export { $h_Lsttp_model_internal_ArrayView as $h_Lsttp_model_internal_ArrayView };
$h_Lsttp_model_internal_ArrayView.prototype = $c_Lsttp_model_internal_ArrayView.prototype;
$c_Lsttp_model_internal_ArrayView.prototype.isEmpty__Z = (function() {
  return (this.Lsttp_model_internal_ArrayView__f_till <= this.Lsttp_model_internal_ArrayView__f_from);
});
$c_Lsttp_model_internal_ArrayView.prototype.nonEmpty__Z = (function() {
  return (this.Lsttp_model_internal_ArrayView__f_from < this.Lsttp_model_internal_ArrayView__f_till);
});
$c_Lsttp_model_internal_ArrayView.prototype.get__I__O = (function(i) {
  return $m_sr_ScalaRunTime$().array_apply__O__I__O(this.Lsttp_model_internal_ArrayView__f_arr, ((this.Lsttp_model_internal_ArrayView__f_from + i) | 0));
});
$c_Lsttp_model_internal_ArrayView.prototype.size__I = (function() {
  return ((this.Lsttp_model_internal_ArrayView__f_till - this.Lsttp_model_internal_ArrayView__f_from) | 0);
});
$c_Lsttp_model_internal_ArrayView.prototype.headOption__s_Option = (function() {
  if (this.nonEmpty__Z()) {
    var value = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.Lsttp_model_internal_ArrayView__f_arr, this.Lsttp_model_internal_ArrayView__f_from);
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Lsttp_model_internal_ArrayView.prototype.startsWith__O__Z = (function(t) {
  if (this.nonEmpty__Z()) {
    var x = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.Lsttp_model_internal_ArrayView__f_arr, this.Lsttp_model_internal_ArrayView__f_from);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, t);
  } else {
    return false;
  }
});
$c_Lsttp_model_internal_ArrayView.prototype.lastOption__s_Option = (function() {
  if (this.nonEmpty__Z()) {
    var value = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.Lsttp_model_internal_ArrayView__f_arr, (((-1) + this.Lsttp_model_internal_ArrayView__f_till) | 0));
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Lsttp_model_internal_ArrayView.prototype.indexOf__O__I = (function(t) {
  var i = this.Lsttp_model_internal_ArrayView__f_from;
  while (true) {
    if ((i < this.Lsttp_model_internal_ArrayView__f_till)) {
      var x = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.Lsttp_model_internal_ArrayView__f_arr, i);
      var $x_1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x, t));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      i = ((1 + i) | 0);
    } else {
      break;
    }
  }
  return ((i === this.Lsttp_model_internal_ArrayView__f_till) ? (-1) : ((i - this.Lsttp_model_internal_ArrayView__f_from) | 0));
});
$c_Lsttp_model_internal_ArrayView.prototype.indexWhere__F1__I = (function(pred) {
  var i = this.Lsttp_model_internal_ArrayView__f_from;
  while (((i < this.Lsttp_model_internal_ArrayView__f_till) && (!(!(!pred.apply__O__O($m_sr_ScalaRunTime$().array_apply__O__I__O(this.Lsttp_model_internal_ArrayView__f_arr, i))))))) {
    i = ((1 + i) | 0);
  }
  return ((i === this.Lsttp_model_internal_ArrayView__f_till) ? (-1) : ((i - this.Lsttp_model_internal_ArrayView__f_from) | 0));
});
$c_Lsttp_model_internal_ArrayView.prototype.take__I__Lsttp_model_internal_ArrayView = (function(i) {
  return new $c_Lsttp_model_internal_ArrayView(this.Lsttp_model_internal_ArrayView__f_arr, this.Lsttp_model_internal_ArrayView__f_from, ((this.Lsttp_model_internal_ArrayView__f_from + i) | 0));
});
$c_Lsttp_model_internal_ArrayView.prototype.drop__I__Lsttp_model_internal_ArrayView = (function(i) {
  return new $c_Lsttp_model_internal_ArrayView(this.Lsttp_model_internal_ArrayView__f_arr, ((this.Lsttp_model_internal_ArrayView__f_from + i) | 0), this.Lsttp_model_internal_ArrayView__f_till);
});
$c_Lsttp_model_internal_ArrayView.prototype.shiftLeft__Lsttp_model_internal_ArrayView = (function() {
  return new $c_Lsttp_model_internal_ArrayView(this.Lsttp_model_internal_ArrayView__f_arr, (((-1) + this.Lsttp_model_internal_ArrayView__f_from) | 0), this.Lsttp_model_internal_ArrayView__f_till);
});
$c_Lsttp_model_internal_ArrayView.prototype.$plus$colon__O__s_reflect_ClassTag__Lsttp_model_internal_ArrayView = (function(t, ev) {
  var currentSize = this.size__I();
  var length = ((1 + currentSize) | 0);
  var newArr = ev.newArray__I__O(length);
  $m_sr_ScalaRunTime$().array_update__O__I__O__V(newArr, 0, t);
  $m_s_Array$().copy__O__I__O__I__I__V(this.Lsttp_model_internal_ArrayView__f_arr, this.Lsttp_model_internal_ArrayView__f_from, newArr, 1, currentSize);
  return new $c_Lsttp_model_internal_ArrayView(newArr, 0, ((1 + currentSize) | 0));
});
$c_Lsttp_model_internal_ArrayView.prototype.toString__T = (function() {
  var list = $ct_ju_ArrayList__I__(new $c_ju_ArrayList(), this.size__I());
  var i = this.Lsttp_model_internal_ArrayView__f_from;
  while ((i < this.Lsttp_model_internal_ArrayView__f_till)) {
    var x0 = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.Lsttp_model_internal_ArrayView__f_arr, i);
    list.add__O__Z(x0);
    i = ((1 + i) | 0);
  }
  return list.toString__T();
});
var $d_Lsttp_model_internal_ArrayView = new $TypeData().initClass($c_Lsttp_model_internal_ArrayView, "sttp.model.internal.ArrayView", ({
  Lsttp_model_internal_ArrayView: 1
}));
export { $d_Lsttp_model_internal_ArrayView as $d_Lsttp_model_internal_ArrayView };
/** @constructor */
function $c_Lsttp_model_internal_ArrayView$() {
}
export { $c_Lsttp_model_internal_ArrayView$ as $c_Lsttp_model_internal_ArrayView$ };
$c_Lsttp_model_internal_ArrayView$.prototype = new $h_O();
$c_Lsttp_model_internal_ArrayView$.prototype.constructor = $c_Lsttp_model_internal_ArrayView$;
/** @constructor */
function $h_Lsttp_model_internal_ArrayView$() {
}
export { $h_Lsttp_model_internal_ArrayView$ as $h_Lsttp_model_internal_ArrayView$ };
$h_Lsttp_model_internal_ArrayView$.prototype = $c_Lsttp_model_internal_ArrayView$.prototype;
$c_Lsttp_model_internal_ArrayView$.prototype.empty__s_reflect_ClassTag__Lsttp_model_internal_ArrayView = (function(evidence$1) {
  return new $c_Lsttp_model_internal_ArrayView(evidence$1.newArray__I__O(0), 0, 0);
});
var $d_Lsttp_model_internal_ArrayView$ = new $TypeData().initClass($c_Lsttp_model_internal_ArrayView$, "sttp.model.internal.ArrayView$", ({
  Lsttp_model_internal_ArrayView$: 1
}));
export { $d_Lsttp_model_internal_ArrayView$ as $d_Lsttp_model_internal_ArrayView$ };
var $n_Lsttp_model_internal_ArrayView$;
function $m_Lsttp_model_internal_ArrayView$() {
  if ((!$n_Lsttp_model_internal_ArrayView$)) {
    $n_Lsttp_model_internal_ArrayView$ = new $c_Lsttp_model_internal_ArrayView$();
  }
  return $n_Lsttp_model_internal_ArrayView$;
}
export { $m_Lsttp_model_internal_ArrayView$ as $m_Lsttp_model_internal_ArrayView$ };
/** @constructor */
function $c_Lsttp_model_internal_ParseUtils$() {
}
export { $c_Lsttp_model_internal_ParseUtils$ as $c_Lsttp_model_internal_ParseUtils$ };
$c_Lsttp_model_internal_ParseUtils$.prototype = new $h_O();
$c_Lsttp_model_internal_ParseUtils$.prototype.constructor = $c_Lsttp_model_internal_ParseUtils$;
/** @constructor */
function $h_Lsttp_model_internal_ParseUtils$() {
}
export { $h_Lsttp_model_internal_ParseUtils$ as $h_Lsttp_model_internal_ParseUtils$ };
$h_Lsttp_model_internal_ParseUtils$.prototype = $c_Lsttp_model_internal_ParseUtils$.prototype;
$c_Lsttp_model_internal_ParseUtils$.prototype.toLongOption__T__s_Option = (function(s) {
  return $m_sc_StringParsers$().parseLong__T__s_Option(s);
});
$c_Lsttp_model_internal_ParseUtils$.prototype.toIntOption__T__s_Option = (function(s) {
  return $m_sc_StringParsers$().parseInt__T__s_Option(s);
});
var $d_Lsttp_model_internal_ParseUtils$ = new $TypeData().initClass($c_Lsttp_model_internal_ParseUtils$, "sttp.model.internal.ParseUtils$", ({
  Lsttp_model_internal_ParseUtils$: 1
}));
export { $d_Lsttp_model_internal_ParseUtils$ as $d_Lsttp_model_internal_ParseUtils$ };
var $n_Lsttp_model_internal_ParseUtils$;
function $m_Lsttp_model_internal_ParseUtils$() {
  if ((!$n_Lsttp_model_internal_ParseUtils$)) {
    $n_Lsttp_model_internal_ParseUtils$ = new $c_Lsttp_model_internal_ParseUtils$();
  }
  return $n_Lsttp_model_internal_ParseUtils$;
}
export { $m_Lsttp_model_internal_ParseUtils$ as $m_Lsttp_model_internal_ParseUtils$ };
/** @constructor */
function $c_Lsttp_model_internal_Patterns$() {
  this.Lsttp_model_internal_Patterns$__f_TypeSubtype = null;
  this.Lsttp_model_internal_Patterns$__f_Parameter = null;
  $n_Lsttp_model_internal_Patterns$ = this;
  $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("([a-zA-Z0-9-!#$%&'*+.^_`{|}~]+)", 0);
  this.Lsttp_model_internal_Patterns$__f_TypeSubtype = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("([a-zA-Z0-9-!#$%&'*+.^_`{|}~]+)/([a-zA-Z0-9-!#$%&'*+.^_`{|}~]+)|([*])", 0);
  this.Lsttp_model_internal_Patterns$__f_Parameter = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(";\\s*(?:([a-zA-Z0-9-!#$%&'*+.^_`{|}~]+)=(?:([a-zA-Z0-9-!#$%&'*+.^_`{|}~]+)|\"([^\"]*)\"))?", 0);
  $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("(0\\.?\\d{0,3}?|\\.\\d{1,3}?|1\\.0{1,3}?)", 0);
}
export { $c_Lsttp_model_internal_Patterns$ as $c_Lsttp_model_internal_Patterns$ };
$c_Lsttp_model_internal_Patterns$.prototype = new $h_O();
$c_Lsttp_model_internal_Patterns$.prototype.constructor = $c_Lsttp_model_internal_Patterns$;
/** @constructor */
function $h_Lsttp_model_internal_Patterns$() {
}
export { $h_Lsttp_model_internal_Patterns$ as $h_Lsttp_model_internal_Patterns$ };
$h_Lsttp_model_internal_Patterns$.prototype = $c_Lsttp_model_internal_Patterns$.prototype;
$c_Lsttp_model_internal_Patterns$.prototype.parseMediaTypeParameters__T__I__s_util_Either = (function(t, offset) {
  var parameters = $m_sci_Map$EmptyMap$();
  var this$2 = this.Lsttp_model_internal_Patterns$__f_Parameter;
  var parameter = new $c_ju_regex_Matcher(this$2, t);
  var s = offset;
  var length = t.length;
  while ((s < length)) {
    parameter.region__I__I__ju_regex_Matcher(s, length);
    if ((!parameter.lookingAt__Z())) {
      var beginIndex = s;
      var value = (((("Parameter is not formatted correctly: \"" + t.substring(beginIndex)) + "\" for: \"") + t) + "\"");
      return new $c_s_util_Left(value);
    }
    var name = parameter.group__I__T(1);
    if ((name === null)) {
      s = parameter.end__I();
    } else {
      var token = parameter.group__I__T(2);
      matchResult1: {
        var strippedToken;
        var x1 = parameter.group__I__T(2);
        if ((x1 === null)) {
          var strippedToken = parameter.group__I__T(3);
          break matchResult1;
        }
        if ((((!(!token.startsWith("'"))) && (!(!token.endsWith("'")))) && (token.length > 2))) {
          var endIndex = (((-1) + token.length) | 0);
          var strippedToken = token.substring(1, endIndex);
          break matchResult1;
        }
        var strippedToken = token;
      }
      var x2 = parameters.get__O__s_Option(name);
      if ((x2 instanceof $c_s_Some)) {
        var duplicate = x2.s_Some__f_value;
        var value$1 = (((((((("Multiple \"" + name) + "\" defined: \"") + duplicate) + "\" and: \"") + strippedToken) + "\" for: \"") + t) + "\"");
        return new $c_s_util_Left(value$1);
      }
      parameters = parameters.$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), name, strippedToken));
      s = parameter.end__I();
    }
  }
  var value$2 = parameters;
  return new $c_s_util_Right(value$2);
});
var $d_Lsttp_model_internal_Patterns$ = new $TypeData().initClass($c_Lsttp_model_internal_Patterns$, "sttp.model.internal.Patterns$", ({
  Lsttp_model_internal_Patterns$: 1
}));
export { $d_Lsttp_model_internal_Patterns$ as $d_Lsttp_model_internal_Patterns$ };
var $n_Lsttp_model_internal_Patterns$;
function $m_Lsttp_model_internal_Patterns$() {
  if ((!$n_Lsttp_model_internal_Patterns$)) {
    $n_Lsttp_model_internal_Patterns$ = new $c_Lsttp_model_internal_Patterns$();
  }
  return $n_Lsttp_model_internal_Patterns$;
}
export { $m_Lsttp_model_internal_Patterns$ as $m_Lsttp_model_internal_Patterns$ };
/** @constructor */
function $c_Lsttp_model_internal_Rfc2616$() {
  this.Lsttp_model_internal_Rfc2616$__f_CTL = null;
  this.Lsttp_model_internal_Rfc2616$__f_Separators = null;
  this.Lsttp_model_internal_Rfc2616$__f_Token = null;
  $n_Lsttp_model_internal_Rfc2616$ = this;
  this.Lsttp_model_internal_Rfc2616$__f_CTL = "\\x00-\\x1F\\x7F";
  this.Lsttp_model_internal_Rfc2616$__f_Separators = "()<>@,;:\\\\\"/\\[\\]?={} \\x09";
  var TokenRegexPart = ((("[^" + this.Lsttp_model_internal_Rfc2616$__f_Separators) + this.Lsttp_model_internal_Rfc2616$__f_CTL) + "]*");
  this.Lsttp_model_internal_Rfc2616$__f_Token = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), TokenRegexPart, $m_sci_Nil$());
  $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "TokenRegexPart=TokenRegexPart", $m_sci_Nil$());
}
export { $c_Lsttp_model_internal_Rfc2616$ as $c_Lsttp_model_internal_Rfc2616$ };
$c_Lsttp_model_internal_Rfc2616$.prototype = new $h_O();
$c_Lsttp_model_internal_Rfc2616$.prototype.constructor = $c_Lsttp_model_internal_Rfc2616$;
/** @constructor */
function $h_Lsttp_model_internal_Rfc2616$() {
}
export { $h_Lsttp_model_internal_Rfc2616$ as $h_Lsttp_model_internal_Rfc2616$ };
$h_Lsttp_model_internal_Rfc2616$.prototype = $c_Lsttp_model_internal_Rfc2616$.prototype;
$c_Lsttp_model_internal_Rfc2616$.prototype.validateToken__T__T__s_Option = (function(componentName, v) {
  if ($m_Lsttp_model_internal_Rfc2616$().Lsttp_model_internal_Rfc2616$__f_Token.unapplySeq__jl_CharSequence__s_Option(v).isEmpty__Z()) {
    var value = (componentName + " can not contain separators: ()<>@,;:\"/[]?={}, or whitespace.");
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
var $d_Lsttp_model_internal_Rfc2616$ = new $TypeData().initClass($c_Lsttp_model_internal_Rfc2616$, "sttp.model.internal.Rfc2616$", ({
  Lsttp_model_internal_Rfc2616$: 1
}));
export { $d_Lsttp_model_internal_Rfc2616$ as $d_Lsttp_model_internal_Rfc2616$ };
var $n_Lsttp_model_internal_Rfc2616$;
function $m_Lsttp_model_internal_Rfc2616$() {
  if ((!$n_Lsttp_model_internal_Rfc2616$)) {
    $n_Lsttp_model_internal_Rfc2616$ = new $c_Lsttp_model_internal_Rfc2616$();
  }
  return $n_Lsttp_model_internal_Rfc2616$;
}
export { $m_Lsttp_model_internal_Rfc2616$ as $m_Lsttp_model_internal_Rfc2616$ };
function $p_Lsttp_model_internal_Rfc3986$__encode__T__T__sci_Set__Z__Z__T($thiz, s, enc, allowedCharacters, spaceAsPlus, encodePlus) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var bytes = $f_T__getBytes__T__AB(s, enc);
  var i = 0;
  while ((i < bytes.u.length)) {
    var b = bytes.u[i];
    var c = (65535 & (255 & b));
    if (((c === 43) && encodePlus)) {
      sb.append__T__scm_StringBuilder("%2B");
    } else if (allowedCharacters.contains__O__Z($bC(c))) {
      sb.append__C__scm_StringBuilder(c);
    } else if (((c === 32) && spaceAsPlus)) {
      sb.append__C__scm_StringBuilder(43);
    } else {
      sb.append__T__scm_StringBuilder("%");
      sb.append__T__scm_StringBuilder($m_Lsttp_model_internal_Rfc3986Compatibility$().formatByte__B__T(b));
    }
    i = ((1 + i) | 0);
  }
  return sb.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
}
export { $p_Lsttp_model_internal_Rfc3986$__encode__T__T__sci_Set__Z__Z__T as $p_Lsttp_model_internal_Rfc3986$__encode__T__T__sci_Set__Z__Z__T };
/** @constructor */
function $c_Lsttp_model_internal_Rfc3986$() {
  this.Lsttp_model_internal_Rfc3986$__f_AlphaNum = null;
  this.Lsttp_model_internal_Rfc3986$__f_Unreserved = null;
  this.Lsttp_model_internal_Rfc3986$__f_SubDelims = null;
  this.Lsttp_model_internal_Rfc3986$__f_PChar = null;
  this.Lsttp_model_internal_Rfc3986$__f_Scheme = null;
  this.Lsttp_model_internal_Rfc3986$__f_UserInfo = null;
  this.Lsttp_model_internal_Rfc3986$__f_PathSegment = null;
  this.Lsttp_model_internal_Rfc3986$__f_Query = null;
  this.Lsttp_model_internal_Rfc3986$__f_Fragment = null;
  this.Lsttp_model_internal_Rfc3986$__f_QueryWithBrackets = null;
  $n_Lsttp_model_internal_Rfc3986$ = this;
  var this$2 = new $c_sr_RichChar(97);
  var this$5 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$2, $bC(122));
  var this$4 = new $c_sr_RichChar(65);
  var suffix = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$4, $bC(90));
  var this$8 = $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this$5, suffix);
  var this$7 = new $c_sr_RichChar(48);
  var suffix$1 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$7, $bC(57));
  var this$9 = this$8.concat__sc_IterableOnce__O(suffix$1);
  this.Lsttp_model_internal_Rfc3986$__f_AlphaNum = $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$9);
  var this$11 = this.Lsttp_model_internal_Rfc3986$__f_AlphaNum;
  var this$10 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([45, 46, 95, 126])));
  var that = this$10.from__sc_IterableOnce__sci_Set(elems);
  this.Lsttp_model_internal_Rfc3986$__f_Unreserved = this$11.concat__sc_IterableOnce__sc_SetOps(that);
  var this$12 = $m_sci_Set$();
  var elems$1 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([33, 36, 38, 39, 40, 41, 42, 43, 44, 59, 61])));
  this.Lsttp_model_internal_Rfc3986$__f_SubDelims = this$12.from__sc_IterableOnce__sci_Set(elems$1);
  var this$13 = this.Lsttp_model_internal_Rfc3986$__f_Unreserved;
  var that$1 = this.Lsttp_model_internal_Rfc3986$__f_SubDelims;
  var this$15 = this$13.concat__sc_IterableOnce__sc_SetOps(that$1);
  var this$14 = $m_sci_Set$();
  var elems$2 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([58, 64])));
  var that$2 = this$14.from__sc_IterableOnce__sci_Set(elems$2);
  this.Lsttp_model_internal_Rfc3986$__f_PChar = this$15.concat__sc_IterableOnce__sc_SetOps(that$2);
  var this$17 = this.Lsttp_model_internal_Rfc3986$__f_AlphaNum;
  var this$16 = $m_sci_Set$();
  var elems$3 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([43, 45, 46])));
  var that$3 = this$16.from__sc_IterableOnce__sci_Set(elems$3);
  this.Lsttp_model_internal_Rfc3986$__f_Scheme = this$17.concat__sc_IterableOnce__sc_SetOps(that$3);
  var this$18 = this.Lsttp_model_internal_Rfc3986$__f_Unreserved;
  var that$4 = this.Lsttp_model_internal_Rfc3986$__f_SubDelims;
  this.Lsttp_model_internal_Rfc3986$__f_UserInfo = this$18.concat__sc_IterableOnce__sc_SetOps(that$4);
  var this$19 = this.Lsttp_model_internal_Rfc3986$__f_Unreserved;
  var that$5 = this.Lsttp_model_internal_Rfc3986$__f_SubDelims;
  this$19.concat__sc_IterableOnce__sc_SetOps(that$5);
  this.Lsttp_model_internal_Rfc3986$__f_PathSegment = this.Lsttp_model_internal_Rfc3986$__f_PChar;
  var this$21 = this.Lsttp_model_internal_Rfc3986$__f_PChar;
  var this$20 = $m_sci_Set$();
  var elems$4 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([47, 63])));
  var that$6 = this$20.from__sc_IterableOnce__sci_Set(elems$4);
  this.Lsttp_model_internal_Rfc3986$__f_Query = this$21.concat__sc_IterableOnce__sc_SetOps(that$6);
  this.Lsttp_model_internal_Rfc3986$__f_Fragment = this.Lsttp_model_internal_Rfc3986$__f_Query;
  var this$23 = this.Lsttp_model_internal_Rfc3986$__f_Query;
  var this$22 = $m_sci_Set$();
  var elems$5 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([91, 93])));
  var that$7 = this$22.from__sc_IterableOnce__sci_Set(elems$5);
  this.Lsttp_model_internal_Rfc3986$__f_QueryWithBrackets = this$23.concat__sc_IterableOnce__sc_SetOps(that$7);
}
export { $c_Lsttp_model_internal_Rfc3986$ as $c_Lsttp_model_internal_Rfc3986$ };
$c_Lsttp_model_internal_Rfc3986$.prototype = new $h_O();
$c_Lsttp_model_internal_Rfc3986$.prototype.constructor = $c_Lsttp_model_internal_Rfc3986$;
/** @constructor */
function $h_Lsttp_model_internal_Rfc3986$() {
}
export { $h_Lsttp_model_internal_Rfc3986$ as $h_Lsttp_model_internal_Rfc3986$ };
$h_Lsttp_model_internal_Rfc3986$.prototype = $c_Lsttp_model_internal_Rfc3986$.prototype;
$c_Lsttp_model_internal_Rfc3986$.prototype.decode__Z__T__T__T = (function(plusAsSpace, s, enc) {
  var needToChange = false;
  var numChars = s.length;
  var sb = $ct_jl_StringBuffer__I__(new $c_jl_StringBuffer(), ((numChars > 500) ? ((numChars / 2) | 0) : numChars));
  var i = 0;
  var c = 0;
  var bytes = null;
  while ((i < numChars)) {
    var index = i;
    c = s.charCodeAt(index);
    matchResult1: {
      var x1 = c;
      if (((x1 === 43) && plusAsSpace)) {
        sb.append__C__jl_StringBuffer(32);
        i = ((1 + i) | 0);
        needToChange = true;
        break matchResult1;
      }
      if ((x1 === 37)) {
        try {
          if ((bytes === null)) {
            bytes = new $ac_B(((((numChars - i) | 0) / 3) | 0));
          }
          var pos = 0;
          while (((((2 + i) | 0) < numChars) && (c === 37))) {
            var beginIndex = ((1 + i) | 0);
            var endIndex = ((3 + i) | 0);
            var s$1 = s.substring(beginIndex, endIndex);
            var this$1 = $m_jl_Integer$();
            var v = this$1.java$lang$Integer$$parseIntImpl__T__I__I__I(s$1, 16, 134217728);
            if ((v < 0)) {
              throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "URLDecoder: Illegal hex characters in escape (%) pattern - negative value");
            }
            bytes.u[pos] = ((v << 24) >> 24);
            pos = ((1 + pos) | 0);
            i = ((3 + i) | 0);
            if ((i < numChars)) {
              var index$1 = i;
              c = s.charCodeAt(index$1);
            }
          }
          if (((i < numChars) && (c === 37))) {
            throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "URLDecoder: Incomplete trailing escape (%) pattern");
          }
          var bytes$1 = bytes;
          var length = pos;
          sb.append__T__jl_StringBuffer($m_jl_String$().new__AB__I__I__T__T(bytes$1, 0, length, enc));
        } catch (e) {
          if ((e instanceof $c_jl_NumberFormatException)) {
            var e$2 = e;
            throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("URLDecoder: Illegal hex characters in escape (%) pattern - " + e$2.jl_Throwable__f_s));
          } else {
            throw e;
          }
        }
        needToChange = true;
        break matchResult1;
      }
      sb.append__C__jl_StringBuffer(c);
      i = ((1 + i) | 0);
    }
  }
  return (needToChange ? sb.toString__T() : s);
});
var $d_Lsttp_model_internal_Rfc3986$ = new $TypeData().initClass($c_Lsttp_model_internal_Rfc3986$, "sttp.model.internal.Rfc3986$", ({
  Lsttp_model_internal_Rfc3986$: 1
}));
export { $d_Lsttp_model_internal_Rfc3986$ as $d_Lsttp_model_internal_Rfc3986$ };
var $n_Lsttp_model_internal_Rfc3986$;
function $m_Lsttp_model_internal_Rfc3986$() {
  if ((!$n_Lsttp_model_internal_Rfc3986$)) {
    $n_Lsttp_model_internal_Rfc3986$ = new $c_Lsttp_model_internal_Rfc3986$();
  }
  return $n_Lsttp_model_internal_Rfc3986$;
}
export { $m_Lsttp_model_internal_Rfc3986$ as $m_Lsttp_model_internal_Rfc3986$ };
/** @constructor */
function $c_Lsttp_model_internal_Rfc3986Compatibility$() {
}
export { $c_Lsttp_model_internal_Rfc3986Compatibility$ as $c_Lsttp_model_internal_Rfc3986Compatibility$ };
$c_Lsttp_model_internal_Rfc3986Compatibility$.prototype = new $h_O();
$c_Lsttp_model_internal_Rfc3986Compatibility$.prototype.constructor = $c_Lsttp_model_internal_Rfc3986Compatibility$;
/** @constructor */
function $h_Lsttp_model_internal_Rfc3986Compatibility$() {
}
export { $h_Lsttp_model_internal_Rfc3986Compatibility$ as $h_Lsttp_model_internal_Rfc3986Compatibility$ };
$h_Lsttp_model_internal_Rfc3986Compatibility$.prototype = $c_Lsttp_model_internal_Rfc3986Compatibility$.prototype;
$c_Lsttp_model_internal_Rfc3986Compatibility$.prototype.formatByte__B__T = (function(byte) {
  var $x_1 = $m_sc_StringOps$();
  var x = $m_sc_StringOps$().format$extension__T__sci_Seq__T("%02X", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([byte])));
  return $x_1.takeRight$extension__T__I__T(x, 2);
});
var $d_Lsttp_model_internal_Rfc3986Compatibility$ = new $TypeData().initClass($c_Lsttp_model_internal_Rfc3986Compatibility$, "sttp.model.internal.Rfc3986Compatibility$", ({
  Lsttp_model_internal_Rfc3986Compatibility$: 1
}));
export { $d_Lsttp_model_internal_Rfc3986Compatibility$ as $d_Lsttp_model_internal_Rfc3986Compatibility$ };
var $n_Lsttp_model_internal_Rfc3986Compatibility$;
function $m_Lsttp_model_internal_Rfc3986Compatibility$() {
  if ((!$n_Lsttp_model_internal_Rfc3986Compatibility$)) {
    $n_Lsttp_model_internal_Rfc3986Compatibility$ = new $c_Lsttp_model_internal_Rfc3986Compatibility$();
  }
  return $n_Lsttp_model_internal_Rfc3986Compatibility$;
}
export { $m_Lsttp_model_internal_Rfc3986Compatibility$ as $m_Lsttp_model_internal_Rfc3986Compatibility$ };
/** @constructor */
function $c_Lsttp_model_internal_Singleton$() {
}
export { $c_Lsttp_model_internal_Singleton$ as $c_Lsttp_model_internal_Singleton$ };
$c_Lsttp_model_internal_Singleton$.prototype = new $h_O();
$c_Lsttp_model_internal_Singleton$.prototype.constructor = $c_Lsttp_model_internal_Singleton$;
/** @constructor */
function $h_Lsttp_model_internal_Singleton$() {
}
export { $h_Lsttp_model_internal_Singleton$ as $h_Lsttp_model_internal_Singleton$ };
$h_Lsttp_model_internal_Singleton$.prototype = $c_Lsttp_model_internal_Singleton$.prototype;
$c_Lsttp_model_internal_Singleton$.prototype.unapply__Lsttp_model_internal_ArrayView__s_Option = (function(v) {
  if ((v.size__I() === 1)) {
    var value = v.get__I__O(0);
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
var $d_Lsttp_model_internal_Singleton$ = new $TypeData().initClass($c_Lsttp_model_internal_Singleton$, "sttp.model.internal.Singleton$", ({
  Lsttp_model_internal_Singleton$: 1
}));
export { $d_Lsttp_model_internal_Singleton$ as $d_Lsttp_model_internal_Singleton$ };
var $n_Lsttp_model_internal_Singleton$;
function $m_Lsttp_model_internal_Singleton$() {
  if ((!$n_Lsttp_model_internal_Singleton$)) {
    $n_Lsttp_model_internal_Singleton$ = new $c_Lsttp_model_internal_Singleton$();
  }
  return $n_Lsttp_model_internal_Singleton$;
}
export { $m_Lsttp_model_internal_Singleton$ as $m_Lsttp_model_internal_Singleton$ };
/** @constructor */
function $c_Lsttp_model_internal_UriCompatibility$() {
}
export { $c_Lsttp_model_internal_UriCompatibility$ as $c_Lsttp_model_internal_UriCompatibility$ };
$c_Lsttp_model_internal_UriCompatibility$.prototype = new $h_O();
$c_Lsttp_model_internal_UriCompatibility$.prototype.constructor = $c_Lsttp_model_internal_UriCompatibility$;
/** @constructor */
function $h_Lsttp_model_internal_UriCompatibility$() {
}
export { $h_Lsttp_model_internal_UriCompatibility$ as $h_Lsttp_model_internal_UriCompatibility$ };
$h_Lsttp_model_internal_UriCompatibility$.prototype = $c_Lsttp_model_internal_UriCompatibility$.prototype;
$c_Lsttp_model_internal_UriCompatibility$.prototype.encodeDNSHost__T__T = (function(s) {
  return new URL(("http://" + s)).host;
});
var $d_Lsttp_model_internal_UriCompatibility$ = new $TypeData().initClass($c_Lsttp_model_internal_UriCompatibility$, "sttp.model.internal.UriCompatibility$", ({
  Lsttp_model_internal_UriCompatibility$: 1
}));
export { $d_Lsttp_model_internal_UriCompatibility$ as $d_Lsttp_model_internal_UriCompatibility$ };
var $n_Lsttp_model_internal_UriCompatibility$;
function $m_Lsttp_model_internal_UriCompatibility$() {
  if ((!$n_Lsttp_model_internal_UriCompatibility$)) {
    $n_Lsttp_model_internal_UriCompatibility$ = new $c_Lsttp_model_internal_UriCompatibility$();
  }
  return $n_Lsttp_model_internal_UriCompatibility$;
}
export { $m_Lsttp_model_internal_UriCompatibility$ as $m_Lsttp_model_internal_UriCompatibility$ };
/** @constructor */
function $c_Lsttp_tapir_AttributeKey(typeName) {
  this.Lsttp_tapir_AttributeKey__f_typeName = null;
  this.Lsttp_tapir_AttributeKey__f_typeName = typeName;
}
export { $c_Lsttp_tapir_AttributeKey as $c_Lsttp_tapir_AttributeKey };
$c_Lsttp_tapir_AttributeKey.prototype = new $h_O();
$c_Lsttp_tapir_AttributeKey.prototype.constructor = $c_Lsttp_tapir_AttributeKey;
/** @constructor */
function $h_Lsttp_tapir_AttributeKey() {
}
export { $h_Lsttp_tapir_AttributeKey as $h_Lsttp_tapir_AttributeKey };
$h_Lsttp_tapir_AttributeKey.prototype = $c_Lsttp_tapir_AttributeKey.prototype;
$c_Lsttp_tapir_AttributeKey.prototype.equals__O__Z = (function(other) {
  return ((other instanceof $c_Lsttp_tapir_AttributeKey) && (this.Lsttp_tapir_AttributeKey__f_typeName === other.Lsttp_tapir_AttributeKey__f_typeName));
});
$c_Lsttp_tapir_AttributeKey.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I(this.Lsttp_tapir_AttributeKey__f_typeName);
});
function $isArrayOf_Lsttp_tapir_AttributeKey(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_AttributeKey)));
}
export { $isArrayOf_Lsttp_tapir_AttributeKey as $isArrayOf_Lsttp_tapir_AttributeKey };
var $d_Lsttp_tapir_AttributeKey = new $TypeData().initClass($c_Lsttp_tapir_AttributeKey, "sttp.tapir.AttributeKey", ({
  Lsttp_tapir_AttributeKey: 1
}));
export { $d_Lsttp_tapir_AttributeKey as $d_Lsttp_tapir_AttributeKey };
function $f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult($thiz, l) {
  var \u03b41$ = $thiz.schema__Lsttp_tapir_Schema();
  matchResult1$1: {
    var r$1;
    try {
      var r1 = $thiz.rawDecode__O__Lsttp_tapir_DecodeResult(l);
      var x1 = new $c_s_util_Success(r1);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var x1;
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          var x1 = new $c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    }
    if ((x1 instanceof $c_s_util_Success)) {
      var r = x1.s_util_Success__f_value;
      var r$1 = r;
      break matchResult1$1;
    }
    if ((x1 instanceof $c_s_util_Failure)) {
      var e$1 = x1.s_util_Failure__f_exception;
      var original = $dp_toString__T(l);
      var r$1 = new $c_Lsttp_tapir_DecodeResult$Error(original, e$1);
      break matchResult1$1;
    }
    throw new $c_s_MatchError(x1);
  }
  if ((r$1 instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
    var x9 = r$1.Lsttp_tapir_DecodeResult$Value__f_v;
    var validationErrors = \u03b41$.applyValidation__O__sci_List(x9);
    var _1 = (validationErrors.isEmpty__Z() ? new $c_Lsttp_tapir_DecodeResult$Value(x9) : new $c_Lsttp_tapir_DecodeResult$InvalidValue(validationErrors));
  } else {
    var _1 = r$1;
  }
  var _2 = $thiz.schema__Lsttp_tapir_Schema().Lsttp_tapir_Schema__f_default;
  var x = $m_Lsttp_tapir_DecodeResult$Missing$();
  if (((x === _1) && (_2 instanceof $c_s_Some))) {
    var x7 = _2.s_Some__f_value;
    if ((x7 !== null)) {
      var d = x7._1__O();
      return new $c_Lsttp_tapir_DecodeResult$Value(d);
    }
  }
  return _1;
}
export { $f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult as $f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult };
function $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec($thiz, f, g) {
  var mapping = new $c_Lsttp_tapir_Mapping$$anon$4(f, g);
  return new $c_Lsttp_tapir_Codec$$anon$1(mapping, $thiz);
}
export { $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec as $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec };
function $f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec($thiz, f, g) {
  return $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec($thiz, f.andThen__F1__F1(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => new $c_Lsttp_tapir_DecodeResult$Value(_$1)))), g);
}
export { $f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec as $f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec };
function $f_Lsttp_tapir_Codec__mapEither__F1__F1__Lsttp_tapir_Codec($thiz, f, g) {
  return $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec($thiz, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => $m_Lsttp_tapir_DecodeResult$().fromEitherString__T__s_util_Either__Lsttp_tapir_DecodeResult($dp_toString__T(s), f.apply__O__O(s)))), g);
}
export { $f_Lsttp_tapir_Codec__mapEither__F1__F1__Lsttp_tapir_Codec as $f_Lsttp_tapir_Codec__mapEither__F1__F1__Lsttp_tapir_Codec };
function $f_Lsttp_tapir_Mapping__decode__O__Lsttp_tapir_DecodeResult($thiz, l) {
  var \u03b41$ = $thiz.validator__Lsttp_tapir_Validator();
  matchResult1: {
    var r$1;
    try {
      var r1 = $thiz.rawDecode__O__Lsttp_tapir_DecodeResult(l);
      var x1 = new $c_s_util_Success(r1);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var x1;
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          var x1 = new $c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    }
    if ((x1 instanceof $c_s_util_Success)) {
      var r = x1.s_util_Success__f_value;
      var r$1 = r;
      break matchResult1;
    }
    if ((x1 instanceof $c_s_util_Failure)) {
      var e$1 = x1.s_util_Failure__f_exception;
      var original = $dp_toString__T(l);
      var r$1 = new $c_Lsttp_tapir_DecodeResult$Error(original, e$1);
      break matchResult1;
    }
    throw new $c_s_MatchError(x1);
  }
  if ((r$1 instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
    var x9 = r$1.Lsttp_tapir_DecodeResult$Value__f_v;
    var validationErrors = \u03b41$.apply__O__sci_List(x9);
    return (validationErrors.isEmpty__Z() ? new $c_Lsttp_tapir_DecodeResult$Value(x9) : new $c_Lsttp_tapir_DecodeResult$InvalidValue(validationErrors));
  } else {
    return r$1;
  }
}
export { $f_Lsttp_tapir_Mapping__decode__O__Lsttp_tapir_DecodeResult as $f_Lsttp_tapir_Mapping__decode__O__Lsttp_tapir_DecodeResult };
function $p_Lsttp_tapir_Mapping$__cropPrefix__T__T__Lsttp_tapir_DecodeResult($thiz, s, prefix) {
  var prefixLength = prefix.length;
  var prefixLower = prefix.toLowerCase();
  var this$1 = s.toLowerCase();
  if ((!(!this$1.startsWith(prefixLower)))) {
    var v = s.substring(prefixLength);
    var $x_1 = new $c_Lsttp_tapir_DecodeResult$Value(v);
  } else {
    var error = $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The given value doesn't start with " + prefix));
    var $x_1 = new $c_Lsttp_tapir_DecodeResult$Error(s, error);
  }
  return $x_1;
}
export { $p_Lsttp_tapir_Mapping$__cropPrefix__T__T__Lsttp_tapir_DecodeResult as $p_Lsttp_tapir_Mapping$__cropPrefix__T__T__Lsttp_tapir_DecodeResult };
function $p_Lsttp_tapir_Mapping$__removePrefix$1__T__sci_List__Lsttp_tapir_DecodeResult($thiz, prefix$3, v) {
  var $x_2 = $m_Lsttp_tapir_DecodeResult$();
  var f = ((s) => $p_Lsttp_tapir_Mapping$__cropPrefix__T__T__Lsttp_tapir_DecodeResult($m_Lsttp_tapir_Mapping$(), s, prefix$3));
  if ((v === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = v.head__O();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = v.tail__O();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    var $x_1 = h;
  }
  return $x_2.sequence__sci_Seq__Lsttp_tapir_DecodeResult($x_1).map__F1__Lsttp_tapir_DecodeResult(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => _$3.toList__sci_List())));
}
export { $p_Lsttp_tapir_Mapping$__removePrefix$1__T__sci_List__Lsttp_tapir_DecodeResult as $p_Lsttp_tapir_Mapping$__removePrefix$1__T__sci_List__Lsttp_tapir_DecodeResult };
/** @constructor */
function $c_Lsttp_tapir_Mapping$() {
}
export { $c_Lsttp_tapir_Mapping$ as $c_Lsttp_tapir_Mapping$ };
$c_Lsttp_tapir_Mapping$.prototype = new $h_O();
$c_Lsttp_tapir_Mapping$.prototype.constructor = $c_Lsttp_tapir_Mapping$;
/** @constructor */
function $h_Lsttp_tapir_Mapping$() {
}
export { $h_Lsttp_tapir_Mapping$ as $h_Lsttp_tapir_Mapping$ };
$h_Lsttp_tapir_Mapping$.prototype = $c_Lsttp_tapir_Mapping$.prototype;
$c_Lsttp_tapir_Mapping$.prototype.from__F1__F1__Lsttp_tapir_Mapping = (function(f, g) {
  var f$1 = f.andThen__F1__F1(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => new $c_Lsttp_tapir_DecodeResult$Value(_$1))));
  return new $c_Lsttp_tapir_Mapping$$anon$4(f$1, g);
});
$c_Lsttp_tapir_Mapping$.prototype.stringPrefixCaseInsensitiveForList__T__Lsttp_tapir_Mapping = (function(prefix) {
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v) => $p_Lsttp_tapir_Mapping$__removePrefix$1__T__sci_List__Lsttp_tapir_DecodeResult(this, prefix, v)));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v$2) => {
    var f = ((d) => (("" + prefix) + d));
    if ((v$2 === $m_sci_Nil$())) {
      return $m_sci_Nil$();
    } else {
      var x0 = v$2.head__O();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = v$2.tail__O();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.head__O();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
        rest = rest.tail__O();
      }
      return h;
    }
  }));
  return new $c_Lsttp_tapir_Mapping$$anon$4(f$1, g);
});
var $d_Lsttp_tapir_Mapping$ = new $TypeData().initClass($c_Lsttp_tapir_Mapping$, "sttp.tapir.Mapping$", ({
  Lsttp_tapir_Mapping$: 1
}));
export { $d_Lsttp_tapir_Mapping$ as $d_Lsttp_tapir_Mapping$ };
var $n_Lsttp_tapir_Mapping$;
function $m_Lsttp_tapir_Mapping$() {
  if ((!$n_Lsttp_tapir_Mapping$)) {
    $n_Lsttp_tapir_Mapping$ = new $c_Lsttp_tapir_Mapping$();
  }
  return $n_Lsttp_tapir_Mapping$;
}
export { $m_Lsttp_tapir_Mapping$ as $m_Lsttp_tapir_Mapping$ };
/** @constructor */
function $c_Lsttp_tapir_TapirFile$() {
}
export { $c_Lsttp_tapir_TapirFile$ as $c_Lsttp_tapir_TapirFile$ };
$c_Lsttp_tapir_TapirFile$.prototype = new $h_O();
$c_Lsttp_tapir_TapirFile$.prototype.constructor = $c_Lsttp_tapir_TapirFile$;
/** @constructor */
function $h_Lsttp_tapir_TapirFile$() {
}
export { $h_Lsttp_tapir_TapirFile$ as $h_Lsttp_tapir_TapirFile$ };
$h_Lsttp_tapir_TapirFile$.prototype = $c_Lsttp_tapir_TapirFile$.prototype;
$c_Lsttp_tapir_TapirFile$.prototype.name__Lorg_scalajs_dom_File__T = (function(f) {
  return f.name;
});
var $d_Lsttp_tapir_TapirFile$ = new $TypeData().initClass($c_Lsttp_tapir_TapirFile$, "sttp.tapir.TapirFile$", ({
  Lsttp_tapir_TapirFile$: 1
}));
export { $d_Lsttp_tapir_TapirFile$ as $d_Lsttp_tapir_TapirFile$ };
var $n_Lsttp_tapir_TapirFile$;
function $m_Lsttp_tapir_TapirFile$() {
  if ((!$n_Lsttp_tapir_TapirFile$)) {
    $n_Lsttp_tapir_TapirFile$ = new $c_Lsttp_tapir_TapirFile$();
  }
  return $n_Lsttp_tapir_TapirFile$;
}
export { $m_Lsttp_tapir_TapirFile$ as $m_Lsttp_tapir_TapirFile$ };
function $f_Lsttp_tapir_Validator__and__Lsttp_tapir_Validator__Lsttp_tapir_Validator($thiz, other) {
  return $m_Lsttp_tapir_Validator$().all__sci_Seq__Lsttp_tapir_Validator($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsttp_tapir_Validator.getArrayOf().constr)([$thiz, other])));
}
export { $f_Lsttp_tapir_Validator__and__Lsttp_tapir_Validator__Lsttp_tapir_Validator as $f_Lsttp_tapir_Validator__and__Lsttp_tapir_Validator__Lsttp_tapir_Validator };
var $d_Lsttp_tapir_Validator = new $TypeData().initClass(1, "sttp.tapir.Validator", ({
  Lsttp_tapir_Validator: 1
}));
export { $d_Lsttp_tapir_Validator as $d_Lsttp_tapir_Validator };
/** @constructor */
function $c_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$() {
  this.Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache = null;
  $n_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$ = this;
  this.Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache = $ct_jl_ThreadLocal__(new $c_jl_ThreadLocal());
}
export { $c_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$ as $c_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$ };
$c_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$.prototype = new $h_O();
$c_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$.prototype.constructor = $c_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$;
/** @constructor */
function $h_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$() {
}
export { $h_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$ as $h_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$ };
$h_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$.prototype = $c_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$.prototype;
var $d_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$ = new $TypeData().initClass($c_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$, "sttp.tapir.generic.auto.SchemaMagnoliaDerivation$", ({
  Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$: 1
}));
export { $d_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$ as $d_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$ };
var $n_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$;
function $m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$() {
  if ((!$n_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$)) {
    $n_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$ = new $c_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$();
  }
  return $n_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$;
}
export { $m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$ as $m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$ };
/** @constructor */
function $c_Lsttp_tapir_internal_ParamsToSeq$() {
}
export { $c_Lsttp_tapir_internal_ParamsToSeq$ as $c_Lsttp_tapir_internal_ParamsToSeq$ };
$c_Lsttp_tapir_internal_ParamsToSeq$.prototype = new $h_O();
$c_Lsttp_tapir_internal_ParamsToSeq$.prototype.constructor = $c_Lsttp_tapir_internal_ParamsToSeq$;
/** @constructor */
function $h_Lsttp_tapir_internal_ParamsToSeq$() {
}
export { $h_Lsttp_tapir_internal_ParamsToSeq$ as $h_Lsttp_tapir_internal_ParamsToSeq$ };
$h_Lsttp_tapir_internal_ParamsToSeq$.prototype = $c_Lsttp_tapir_internal_ParamsToSeq$.prototype;
$c_Lsttp_tapir_internal_ParamsToSeq$.prototype.apply__O__sci_Seq = (function(a) {
  if ((a instanceof $c_T2)) {
    var v1 = a._1__O();
    var v2 = a._2__O();
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1, v2])));
  } else if ((a instanceof $c_T3)) {
    var v1$2 = a.T3__f__1;
    var v2$2 = a.T3__f__2;
    var v3 = a.T3__f__3;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$2, v2$2, v3])));
  } else if ((a instanceof $c_T4)) {
    var v1$3 = a.T4__f__1;
    var v2$3 = a.T4__f__2;
    var v3$2 = a.T4__f__3;
    var v4 = a.T4__f__4;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$3, v2$3, v3$2, v4])));
  } else if ((a instanceof $c_T5)) {
    var v1$4 = a.T5__f__1;
    var v2$4 = a.T5__f__2;
    var v3$3 = a.T5__f__3;
    var v4$2 = a.T5__f__4;
    var v5 = a.T5__f__5;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$4, v2$4, v3$3, v4$2, v5])));
  } else if ((a instanceof $c_T6)) {
    var v1$5 = a.T6__f__1;
    var v2$5 = a.T6__f__2;
    var v3$4 = a.T6__f__3;
    var v4$3 = a.T6__f__4;
    var v5$2 = a.T6__f__5;
    var v6 = a.T6__f__6;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$5, v2$5, v3$4, v4$3, v5$2, v6])));
  } else if ((a instanceof $c_T7)) {
    var v1$6 = a.T7__f__1;
    var v2$6 = a.T7__f__2;
    var v3$5 = a.T7__f__3;
    var v4$4 = a.T7__f__4;
    var v5$3 = a.T7__f__5;
    var v6$2 = a.T7__f__6;
    var v7 = a.T7__f__7;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$6, v2$6, v3$5, v4$4, v5$3, v6$2, v7])));
  } else if ((a instanceof $c_T8)) {
    var v1$7 = a.T8__f__1;
    var v2$7 = a.T8__f__2;
    var v3$6 = a.T8__f__3;
    var v4$5 = a.T8__f__4;
    var v5$4 = a.T8__f__5;
    var v6$3 = a.T8__f__6;
    var v7$2 = a.T8__f__7;
    var v8 = a.T8__f__8;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$7, v2$7, v3$6, v4$5, v5$4, v6$3, v7$2, v8])));
  } else if ((a instanceof $c_T9)) {
    var v1$8 = a.T9__f__1;
    var v2$8 = a.T9__f__2;
    var v3$7 = a.T9__f__3;
    var v4$6 = a.T9__f__4;
    var v5$5 = a.T9__f__5;
    var v6$4 = a.T9__f__6;
    var v7$3 = a.T9__f__7;
    var v8$2 = a.T9__f__8;
    var v9 = a.T9__f__9;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$8, v2$8, v3$7, v4$6, v5$5, v6$4, v7$3, v8$2, v9])));
  } else if ((a instanceof $c_T10)) {
    var v1$9 = a.T10__f__1;
    var v2$9 = a.T10__f__2;
    var v3$8 = a.T10__f__3;
    var v4$7 = a.T10__f__4;
    var v5$6 = a.T10__f__5;
    var v6$5 = a.T10__f__6;
    var v7$4 = a.T10__f__7;
    var v8$3 = a.T10__f__8;
    var v9$2 = a.T10__f__9;
    var v10 = a.T10__f__10;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$9, v2$9, v3$8, v4$7, v5$6, v6$5, v7$4, v8$3, v9$2, v10])));
  } else if ((a instanceof $c_T11)) {
    var v1$10 = a.T11__f__1;
    var v2$10 = a.T11__f__2;
    var v3$9 = a.T11__f__3;
    var v4$8 = a.T11__f__4;
    var v5$7 = a.T11__f__5;
    var v6$6 = a.T11__f__6;
    var v7$5 = a.T11__f__7;
    var v8$4 = a.T11__f__8;
    var v9$3 = a.T11__f__9;
    var v10$2 = a.T11__f__10;
    var v11 = a.T11__f__11;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$10, v2$10, v3$9, v4$8, v5$7, v6$6, v7$5, v8$4, v9$3, v10$2, v11])));
  } else if ((a instanceof $c_T12)) {
    var v1$11 = a.T12__f__1;
    var v2$11 = a.T12__f__2;
    var v3$10 = a.T12__f__3;
    var v4$9 = a.T12__f__4;
    var v5$8 = a.T12__f__5;
    var v6$7 = a.T12__f__6;
    var v7$6 = a.T12__f__7;
    var v8$5 = a.T12__f__8;
    var v9$4 = a.T12__f__9;
    var v10$3 = a.T12__f__10;
    var v11$2 = a.T12__f__11;
    var v12 = a.T12__f__12;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$11, v2$11, v3$10, v4$9, v5$8, v6$7, v7$6, v8$5, v9$4, v10$3, v11$2, v12])));
  } else if ((a instanceof $c_T13)) {
    var v1$12 = a.T13__f__1;
    var v2$12 = a.T13__f__2;
    var v3$11 = a.T13__f__3;
    var v4$10 = a.T13__f__4;
    var v5$9 = a.T13__f__5;
    var v6$8 = a.T13__f__6;
    var v7$7 = a.T13__f__7;
    var v8$6 = a.T13__f__8;
    var v9$5 = a.T13__f__9;
    var v10$4 = a.T13__f__10;
    var v11$3 = a.T13__f__11;
    var v12$2 = a.T13__f__12;
    var v13 = a.T13__f__13;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$12, v2$12, v3$11, v4$10, v5$9, v6$8, v7$7, v8$6, v9$5, v10$4, v11$3, v12$2, v13])));
  } else if ((a instanceof $c_T14)) {
    var v1$13 = a.T14__f__1;
    var v2$13 = a.T14__f__2;
    var v3$12 = a.T14__f__3;
    var v4$11 = a.T14__f__4;
    var v5$10 = a.T14__f__5;
    var v6$9 = a.T14__f__6;
    var v7$8 = a.T14__f__7;
    var v8$7 = a.T14__f__8;
    var v9$6 = a.T14__f__9;
    var v10$5 = a.T14__f__10;
    var v11$4 = a.T14__f__11;
    var v12$3 = a.T14__f__12;
    var v13$2 = a.T14__f__13;
    var v14 = a.T14__f__14;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$13, v2$13, v3$12, v4$11, v5$10, v6$9, v7$8, v8$7, v9$6, v10$5, v11$4, v12$3, v13$2, v14])));
  } else if ((a instanceof $c_T15)) {
    var v1$14 = a.T15__f__1;
    var v2$14 = a.T15__f__2;
    var v3$13 = a.T15__f__3;
    var v4$12 = a.T15__f__4;
    var v5$11 = a.T15__f__5;
    var v6$10 = a.T15__f__6;
    var v7$9 = a.T15__f__7;
    var v8$8 = a.T15__f__8;
    var v9$7 = a.T15__f__9;
    var v10$6 = a.T15__f__10;
    var v11$5 = a.T15__f__11;
    var v12$4 = a.T15__f__12;
    var v13$3 = a.T15__f__13;
    var v14$2 = a.T15__f__14;
    var v15 = a.T15__f__15;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$14, v2$14, v3$13, v4$12, v5$11, v6$10, v7$9, v8$8, v9$7, v10$6, v11$5, v12$4, v13$3, v14$2, v15])));
  } else if ((a instanceof $c_T16)) {
    var v1$15 = a.T16__f__1;
    var v2$15 = a.T16__f__2;
    var v3$14 = a.T16__f__3;
    var v4$13 = a.T16__f__4;
    var v5$12 = a.T16__f__5;
    var v6$11 = a.T16__f__6;
    var v7$10 = a.T16__f__7;
    var v8$9 = a.T16__f__8;
    var v9$8 = a.T16__f__9;
    var v10$7 = a.T16__f__10;
    var v11$6 = a.T16__f__11;
    var v12$5 = a.T16__f__12;
    var v13$4 = a.T16__f__13;
    var v14$3 = a.T16__f__14;
    var v15$2 = a.T16__f__15;
    var v16 = a.T16__f__16;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$15, v2$15, v3$14, v4$13, v5$12, v6$11, v7$10, v8$9, v9$8, v10$7, v11$6, v12$5, v13$4, v14$3, v15$2, v16])));
  } else if ((a instanceof $c_T17)) {
    var v1$16 = a.T17__f__1;
    var v2$16 = a.T17__f__2;
    var v3$15 = a.T17__f__3;
    var v4$14 = a.T17__f__4;
    var v5$13 = a.T17__f__5;
    var v6$12 = a.T17__f__6;
    var v7$11 = a.T17__f__7;
    var v8$10 = a.T17__f__8;
    var v9$9 = a.T17__f__9;
    var v10$8 = a.T17__f__10;
    var v11$7 = a.T17__f__11;
    var v12$6 = a.T17__f__12;
    var v13$5 = a.T17__f__13;
    var v14$4 = a.T17__f__14;
    var v15$3 = a.T17__f__15;
    var v16$2 = a.T17__f__16;
    var v17 = a.T17__f__17;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$16, v2$16, v3$15, v4$14, v5$13, v6$12, v7$11, v8$10, v9$9, v10$8, v11$7, v12$6, v13$5, v14$4, v15$3, v16$2, v17])));
  } else if ((a instanceof $c_T18)) {
    var v1$17 = a.T18__f__1;
    var v2$17 = a.T18__f__2;
    var v3$16 = a.T18__f__3;
    var v4$15 = a.T18__f__4;
    var v5$14 = a.T18__f__5;
    var v6$13 = a.T18__f__6;
    var v7$12 = a.T18__f__7;
    var v8$11 = a.T18__f__8;
    var v9$10 = a.T18__f__9;
    var v10$9 = a.T18__f__10;
    var v11$8 = a.T18__f__11;
    var v12$7 = a.T18__f__12;
    var v13$6 = a.T18__f__13;
    var v14$5 = a.T18__f__14;
    var v15$4 = a.T18__f__15;
    var v16$3 = a.T18__f__16;
    var v17$2 = a.T18__f__17;
    var v18 = a.T18__f__18;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$17, v2$17, v3$16, v4$15, v5$14, v6$13, v7$12, v8$11, v9$10, v10$9, v11$8, v12$7, v13$6, v14$5, v15$4, v16$3, v17$2, v18])));
  } else if ((a instanceof $c_T19)) {
    var v1$18 = a.T19__f__1;
    var v2$18 = a.T19__f__2;
    var v3$17 = a.T19__f__3;
    var v4$16 = a.T19__f__4;
    var v5$15 = a.T19__f__5;
    var v6$14 = a.T19__f__6;
    var v7$13 = a.T19__f__7;
    var v8$12 = a.T19__f__8;
    var v9$11 = a.T19__f__9;
    var v10$10 = a.T19__f__10;
    var v11$9 = a.T19__f__11;
    var v12$8 = a.T19__f__12;
    var v13$7 = a.T19__f__13;
    var v14$6 = a.T19__f__14;
    var v15$5 = a.T19__f__15;
    var v16$4 = a.T19__f__16;
    var v17$3 = a.T19__f__17;
    var v18$2 = a.T19__f__18;
    var v19 = a.T19__f__19;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$18, v2$18, v3$17, v4$16, v5$15, v6$14, v7$13, v8$12, v9$11, v10$10, v11$9, v12$8, v13$7, v14$6, v15$5, v16$4, v17$3, v18$2, v19])));
  } else if ((a instanceof $c_T20)) {
    var v1$19 = a.T20__f__1;
    var v2$19 = a.T20__f__2;
    var v3$18 = a.T20__f__3;
    var v4$17 = a.T20__f__4;
    var v5$16 = a.T20__f__5;
    var v6$15 = a.T20__f__6;
    var v7$14 = a.T20__f__7;
    var v8$13 = a.T20__f__8;
    var v9$12 = a.T20__f__9;
    var v10$11 = a.T20__f__10;
    var v11$10 = a.T20__f__11;
    var v12$9 = a.T20__f__12;
    var v13$8 = a.T20__f__13;
    var v14$7 = a.T20__f__14;
    var v15$6 = a.T20__f__15;
    var v16$5 = a.T20__f__16;
    var v17$4 = a.T20__f__17;
    var v18$3 = a.T20__f__18;
    var v19$2 = a.T20__f__19;
    var v20 = a.T20__f__20;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$19, v2$19, v3$18, v4$17, v5$16, v6$15, v7$14, v8$13, v9$12, v10$11, v11$10, v12$9, v13$8, v14$7, v15$6, v16$5, v17$4, v18$3, v19$2, v20])));
  } else if ((a instanceof $c_T21)) {
    var v1$20 = a.T21__f__1;
    var v2$20 = a.T21__f__2;
    var v3$19 = a.T21__f__3;
    var v4$18 = a.T21__f__4;
    var v5$17 = a.T21__f__5;
    var v6$16 = a.T21__f__6;
    var v7$15 = a.T21__f__7;
    var v8$14 = a.T21__f__8;
    var v9$13 = a.T21__f__9;
    var v10$12 = a.T21__f__10;
    var v11$11 = a.T21__f__11;
    var v12$10 = a.T21__f__12;
    var v13$9 = a.T21__f__13;
    var v14$8 = a.T21__f__14;
    var v15$7 = a.T21__f__15;
    var v16$6 = a.T21__f__16;
    var v17$5 = a.T21__f__17;
    var v18$4 = a.T21__f__18;
    var v19$3 = a.T21__f__19;
    var v20$2 = a.T21__f__20;
    var v21 = a.T21__f__21;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$20, v2$20, v3$19, v4$18, v5$17, v6$16, v7$15, v8$14, v9$13, v10$12, v11$11, v12$10, v13$9, v14$8, v15$7, v16$6, v17$5, v18$4, v19$3, v20$2, v21])));
  } else if ((a instanceof $c_T22)) {
    var v1$21 = a.T22__f__1;
    var v2$21 = a.T22__f__2;
    var v3$20 = a.T22__f__3;
    var v4$19 = a.T22__f__4;
    var v5$18 = a.T22__f__5;
    var v6$17 = a.T22__f__6;
    var v7$16 = a.T22__f__7;
    var v8$15 = a.T22__f__8;
    var v9$14 = a.T22__f__9;
    var v10$13 = a.T22__f__10;
    var v11$12 = a.T22__f__11;
    var v12$11 = a.T22__f__12;
    var v13$10 = a.T22__f__13;
    var v14$9 = a.T22__f__14;
    var v15$8 = a.T22__f__15;
    var v16$7 = a.T22__f__16;
    var v17$6 = a.T22__f__17;
    var v18$5 = a.T22__f__18;
    var v19$4 = a.T22__f__19;
    var v20$3 = a.T22__f__20;
    var v21$2 = a.T22__f__21;
    var v22 = a.T22__f__22;
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([v1$21, v2$21, v3$20, v4$19, v5$18, v6$17, v7$16, v8$15, v9$14, v10$13, v11$12, v12$11, v13$10, v14$9, v15$8, v16$7, v17$6, v18$5, v19$4, v20$3, v21$2, v22])));
  } else {
    return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([a])));
  }
});
var $d_Lsttp_tapir_internal_ParamsToSeq$ = new $TypeData().initClass($c_Lsttp_tapir_internal_ParamsToSeq$, "sttp.tapir.internal.ParamsToSeq$", ({
  Lsttp_tapir_internal_ParamsToSeq$: 1
}));
export { $d_Lsttp_tapir_internal_ParamsToSeq$ as $d_Lsttp_tapir_internal_ParamsToSeq$ };
var $n_Lsttp_tapir_internal_ParamsToSeq$;
function $m_Lsttp_tapir_internal_ParamsToSeq$() {
  if ((!$n_Lsttp_tapir_internal_ParamsToSeq$)) {
    $n_Lsttp_tapir_internal_ParamsToSeq$ = new $c_Lsttp_tapir_internal_ParamsToSeq$();
  }
  return $n_Lsttp_tapir_internal_ParamsToSeq$;
}
export { $m_Lsttp_tapir_internal_ParamsToSeq$ as $m_Lsttp_tapir_internal_ParamsToSeq$ };
/** @constructor */
function $c_Lsttp_tapir_internal_SeqToParams$() {
}
export { $c_Lsttp_tapir_internal_SeqToParams$ as $c_Lsttp_tapir_internal_SeqToParams$ };
$c_Lsttp_tapir_internal_SeqToParams$.prototype = new $h_O();
$c_Lsttp_tapir_internal_SeqToParams$.prototype.constructor = $c_Lsttp_tapir_internal_SeqToParams$;
/** @constructor */
function $h_Lsttp_tapir_internal_SeqToParams$() {
}
export { $h_Lsttp_tapir_internal_SeqToParams$ as $h_Lsttp_tapir_internal_SeqToParams$ };
$h_Lsttp_tapir_internal_SeqToParams$.prototype = $c_Lsttp_tapir_internal_SeqToParams$.prototype;
$c_Lsttp_tapir_internal_SeqToParams$.prototype.apply__sci_Seq__O = (function(seq) {
  if ((seq !== null)) {
    if ((seq.lengthCompare__I__I(0) === 0)) {
      return (void 0);
    }
    if ((seq.lengthCompare__I__I(1) === 0)) {
      var x276 = seq.apply__I__O(0);
      return x276;
    }
    if ((seq.lengthCompare__I__I(2) === 0)) {
      var x273 = seq.apply__I__O(0);
      var x274 = seq.apply__I__O(1);
      return $ct_T2__O__O__(new $c_T2(), x273, x274);
    }
    if ((seq.lengthCompare__I__I(3) === 0)) {
      var x269 = seq.apply__I__O(0);
      var x270 = seq.apply__I__O(1);
      var x271 = seq.apply__I__O(2);
      return new $c_T3(x269, x270, x271);
    }
    if ((seq.lengthCompare__I__I(4) === 0)) {
      var x264 = seq.apply__I__O(0);
      var x265 = seq.apply__I__O(1);
      var x266 = seq.apply__I__O(2);
      var x267 = seq.apply__I__O(3);
      return new $c_T4(x264, x265, x266, x267);
    }
    if ((seq.lengthCompare__I__I(5) === 0)) {
      var x258 = seq.apply__I__O(0);
      var x259 = seq.apply__I__O(1);
      var x260 = seq.apply__I__O(2);
      var x261 = seq.apply__I__O(3);
      var x262 = seq.apply__I__O(4);
      return new $c_T5(x258, x259, x260, x261, x262);
    }
    if ((seq.lengthCompare__I__I(6) === 0)) {
      var x251 = seq.apply__I__O(0);
      var x252 = seq.apply__I__O(1);
      var x253 = seq.apply__I__O(2);
      var x254 = seq.apply__I__O(3);
      var x255 = seq.apply__I__O(4);
      var x256 = seq.apply__I__O(5);
      return new $c_T6(x251, x252, x253, x254, x255, x256);
    }
    if ((seq.lengthCompare__I__I(7) === 0)) {
      var x243 = seq.apply__I__O(0);
      var x244 = seq.apply__I__O(1);
      var x245 = seq.apply__I__O(2);
      var x246 = seq.apply__I__O(3);
      var x247 = seq.apply__I__O(4);
      var x248 = seq.apply__I__O(5);
      var x249 = seq.apply__I__O(6);
      return new $c_T7(x243, x244, x245, x246, x247, x248, x249);
    }
    if ((seq.lengthCompare__I__I(8) === 0)) {
      var x234 = seq.apply__I__O(0);
      var x235 = seq.apply__I__O(1);
      var x236 = seq.apply__I__O(2);
      var x237 = seq.apply__I__O(3);
      var x238 = seq.apply__I__O(4);
      var x239 = seq.apply__I__O(5);
      var x240 = seq.apply__I__O(6);
      var x241 = seq.apply__I__O(7);
      return new $c_T8(x234, x235, x236, x237, x238, x239, x240, x241);
    }
    if ((seq.lengthCompare__I__I(9) === 0)) {
      var x224 = seq.apply__I__O(0);
      var x225 = seq.apply__I__O(1);
      var x226 = seq.apply__I__O(2);
      var x227 = seq.apply__I__O(3);
      var x228 = seq.apply__I__O(4);
      var x229 = seq.apply__I__O(5);
      var x230 = seq.apply__I__O(6);
      var x231 = seq.apply__I__O(7);
      var x232 = seq.apply__I__O(8);
      return new $c_T9(x224, x225, x226, x227, x228, x229, x230, x231, x232);
    }
    if ((seq.lengthCompare__I__I(10) === 0)) {
      var x213 = seq.apply__I__O(0);
      var x214 = seq.apply__I__O(1);
      var x215 = seq.apply__I__O(2);
      var x216 = seq.apply__I__O(3);
      var x217 = seq.apply__I__O(4);
      var x218 = seq.apply__I__O(5);
      var x219 = seq.apply__I__O(6);
      var x220 = seq.apply__I__O(7);
      var x221 = seq.apply__I__O(8);
      var x222 = seq.apply__I__O(9);
      return new $c_T10(x213, x214, x215, x216, x217, x218, x219, x220, x221, x222);
    }
    if ((seq.lengthCompare__I__I(11) === 0)) {
      var x201 = seq.apply__I__O(0);
      var x202 = seq.apply__I__O(1);
      var x203 = seq.apply__I__O(2);
      var x204 = seq.apply__I__O(3);
      var x205 = seq.apply__I__O(4);
      var x206 = seq.apply__I__O(5);
      var x207 = seq.apply__I__O(6);
      var x208 = seq.apply__I__O(7);
      var x209 = seq.apply__I__O(8);
      var x210 = seq.apply__I__O(9);
      var x211 = seq.apply__I__O(10);
      return new $c_T11(x201, x202, x203, x204, x205, x206, x207, x208, x209, x210, x211);
    }
    if ((seq.lengthCompare__I__I(12) === 0)) {
      var x188 = seq.apply__I__O(0);
      var x189 = seq.apply__I__O(1);
      var x190 = seq.apply__I__O(2);
      var x191 = seq.apply__I__O(3);
      var x192 = seq.apply__I__O(4);
      var x193 = seq.apply__I__O(5);
      var x194 = seq.apply__I__O(6);
      var x195 = seq.apply__I__O(7);
      var x196 = seq.apply__I__O(8);
      var x197 = seq.apply__I__O(9);
      var x198 = seq.apply__I__O(10);
      var x199 = seq.apply__I__O(11);
      return new $c_T12(x188, x189, x190, x191, x192, x193, x194, x195, x196, x197, x198, x199);
    }
    if ((seq.lengthCompare__I__I(13) === 0)) {
      var x174 = seq.apply__I__O(0);
      var x175 = seq.apply__I__O(1);
      var x176 = seq.apply__I__O(2);
      var x177 = seq.apply__I__O(3);
      var x178 = seq.apply__I__O(4);
      var x179 = seq.apply__I__O(5);
      var x180 = seq.apply__I__O(6);
      var x181 = seq.apply__I__O(7);
      var x182 = seq.apply__I__O(8);
      var x183 = seq.apply__I__O(9);
      var x184 = seq.apply__I__O(10);
      var x185 = seq.apply__I__O(11);
      var x186 = seq.apply__I__O(12);
      return new $c_T13(x174, x175, x176, x177, x178, x179, x180, x181, x182, x183, x184, x185, x186);
    }
    if ((seq.lengthCompare__I__I(14) === 0)) {
      var x159 = seq.apply__I__O(0);
      var x160 = seq.apply__I__O(1);
      var x161 = seq.apply__I__O(2);
      var x162 = seq.apply__I__O(3);
      var x163 = seq.apply__I__O(4);
      var x164 = seq.apply__I__O(5);
      var x165 = seq.apply__I__O(6);
      var x166 = seq.apply__I__O(7);
      var x167 = seq.apply__I__O(8);
      var x168 = seq.apply__I__O(9);
      var x169 = seq.apply__I__O(10);
      var x170 = seq.apply__I__O(11);
      var x171 = seq.apply__I__O(12);
      var x172 = seq.apply__I__O(13);
      return new $c_T14(x159, x160, x161, x162, x163, x164, x165, x166, x167, x168, x169, x170, x171, x172);
    }
    if ((seq.lengthCompare__I__I(15) === 0)) {
      var x143 = seq.apply__I__O(0);
      var x144 = seq.apply__I__O(1);
      var x145 = seq.apply__I__O(2);
      var x146 = seq.apply__I__O(3);
      var x147 = seq.apply__I__O(4);
      var x148 = seq.apply__I__O(5);
      var x149 = seq.apply__I__O(6);
      var x150 = seq.apply__I__O(7);
      var x151 = seq.apply__I__O(8);
      var x152 = seq.apply__I__O(9);
      var x153 = seq.apply__I__O(10);
      var x154 = seq.apply__I__O(11);
      var x155 = seq.apply__I__O(12);
      var x156 = seq.apply__I__O(13);
      var x157 = seq.apply__I__O(14);
      return new $c_T15(x143, x144, x145, x146, x147, x148, x149, x150, x151, x152, x153, x154, x155, x156, x157);
    }
    if ((seq.lengthCompare__I__I(16) === 0)) {
      var x126 = seq.apply__I__O(0);
      var x127 = seq.apply__I__O(1);
      var x128 = seq.apply__I__O(2);
      var x129 = seq.apply__I__O(3);
      var x130 = seq.apply__I__O(4);
      var x131 = seq.apply__I__O(5);
      var x132 = seq.apply__I__O(6);
      var x133 = seq.apply__I__O(7);
      var x134 = seq.apply__I__O(8);
      var x135 = seq.apply__I__O(9);
      var x136 = seq.apply__I__O(10);
      var x137 = seq.apply__I__O(11);
      var x138 = seq.apply__I__O(12);
      var x139 = seq.apply__I__O(13);
      var x140 = seq.apply__I__O(14);
      var x141 = seq.apply__I__O(15);
      return new $c_T16(x126, x127, x128, x129, x130, x131, x132, x133, x134, x135, x136, x137, x138, x139, x140, x141);
    }
    if ((seq.lengthCompare__I__I(17) === 0)) {
      var x108 = seq.apply__I__O(0);
      var x109 = seq.apply__I__O(1);
      var x110 = seq.apply__I__O(2);
      var x111 = seq.apply__I__O(3);
      var x112 = seq.apply__I__O(4);
      var x113 = seq.apply__I__O(5);
      var x114 = seq.apply__I__O(6);
      var x115 = seq.apply__I__O(7);
      var x116 = seq.apply__I__O(8);
      var x117 = seq.apply__I__O(9);
      var x118 = seq.apply__I__O(10);
      var x119 = seq.apply__I__O(11);
      var x120 = seq.apply__I__O(12);
      var x121 = seq.apply__I__O(13);
      var x122 = seq.apply__I__O(14);
      var x123 = seq.apply__I__O(15);
      var x124 = seq.apply__I__O(16);
      return new $c_T17(x108, x109, x110, x111, x112, x113, x114, x115, x116, x117, x118, x119, x120, x121, x122, x123, x124);
    }
    if ((seq.lengthCompare__I__I(18) === 0)) {
      var x89 = seq.apply__I__O(0);
      var x90 = seq.apply__I__O(1);
      var x91 = seq.apply__I__O(2);
      var x92 = seq.apply__I__O(3);
      var x93 = seq.apply__I__O(4);
      var x94 = seq.apply__I__O(5);
      var x95 = seq.apply__I__O(6);
      var x96 = seq.apply__I__O(7);
      var x97 = seq.apply__I__O(8);
      var x98 = seq.apply__I__O(9);
      var x99 = seq.apply__I__O(10);
      var x100 = seq.apply__I__O(11);
      var x101 = seq.apply__I__O(12);
      var x102 = seq.apply__I__O(13);
      var x103 = seq.apply__I__O(14);
      var x104 = seq.apply__I__O(15);
      var x105 = seq.apply__I__O(16);
      var x106 = seq.apply__I__O(17);
      return new $c_T18(x89, x90, x91, x92, x93, x94, x95, x96, x97, x98, x99, x100, x101, x102, x103, x104, x105, x106);
    }
    if ((seq.lengthCompare__I__I(19) === 0)) {
      var x69 = seq.apply__I__O(0);
      var x70 = seq.apply__I__O(1);
      var x71 = seq.apply__I__O(2);
      var x72 = seq.apply__I__O(3);
      var x73 = seq.apply__I__O(4);
      var x74 = seq.apply__I__O(5);
      var x75 = seq.apply__I__O(6);
      var x76 = seq.apply__I__O(7);
      var x77 = seq.apply__I__O(8);
      var x78 = seq.apply__I__O(9);
      var x79 = seq.apply__I__O(10);
      var x80 = seq.apply__I__O(11);
      var x81 = seq.apply__I__O(12);
      var x82 = seq.apply__I__O(13);
      var x83 = seq.apply__I__O(14);
      var x84 = seq.apply__I__O(15);
      var x85 = seq.apply__I__O(16);
      var x86 = seq.apply__I__O(17);
      var x87 = seq.apply__I__O(18);
      return new $c_T19(x69, x70, x71, x72, x73, x74, x75, x76, x77, x78, x79, x80, x81, x82, x83, x84, x85, x86, x87);
    }
    if ((seq.lengthCompare__I__I(20) === 0)) {
      var x48 = seq.apply__I__O(0);
      var x49 = seq.apply__I__O(1);
      var x50 = seq.apply__I__O(2);
      var x51 = seq.apply__I__O(3);
      var x52 = seq.apply__I__O(4);
      var x53 = seq.apply__I__O(5);
      var x54 = seq.apply__I__O(6);
      var x55 = seq.apply__I__O(7);
      var x56 = seq.apply__I__O(8);
      var x57 = seq.apply__I__O(9);
      var x58 = seq.apply__I__O(10);
      var x59 = seq.apply__I__O(11);
      var x60 = seq.apply__I__O(12);
      var x61 = seq.apply__I__O(13);
      var x62 = seq.apply__I__O(14);
      var x63 = seq.apply__I__O(15);
      var x64 = seq.apply__I__O(16);
      var x65 = seq.apply__I__O(17);
      var x66 = seq.apply__I__O(18);
      var x67 = seq.apply__I__O(19);
      return new $c_T20(x48, x49, x50, x51, x52, x53, x54, x55, x56, x57, x58, x59, x60, x61, x62, x63, x64, x65, x66, x67);
    }
    if ((seq.lengthCompare__I__I(21) === 0)) {
      var x26 = seq.apply__I__O(0);
      var x27 = seq.apply__I__O(1);
      var x28 = seq.apply__I__O(2);
      var x29 = seq.apply__I__O(3);
      var x30 = seq.apply__I__O(4);
      var x31 = seq.apply__I__O(5);
      var x32 = seq.apply__I__O(6);
      var x33 = seq.apply__I__O(7);
      var x34 = seq.apply__I__O(8);
      var x35 = seq.apply__I__O(9);
      var x36 = seq.apply__I__O(10);
      var x37 = seq.apply__I__O(11);
      var x38 = seq.apply__I__O(12);
      var x39 = seq.apply__I__O(13);
      var x40 = seq.apply__I__O(14);
      var x41 = seq.apply__I__O(15);
      var x42 = seq.apply__I__O(16);
      var x43 = seq.apply__I__O(17);
      var x44 = seq.apply__I__O(18);
      var x45 = seq.apply__I__O(19);
      var x46 = seq.apply__I__O(20);
      return new $c_T21(x26, x27, x28, x29, x30, x31, x32, x33, x34, x35, x36, x37, x38, x39, x40, x41, x42, x43, x44, x45, x46);
    }
    if ((seq.lengthCompare__I__I(22) === 0)) {
      var x3 = seq.apply__I__O(0);
      var x4 = seq.apply__I__O(1);
      var x5 = seq.apply__I__O(2);
      var x6 = seq.apply__I__O(3);
      var x7 = seq.apply__I__O(4);
      var x8 = seq.apply__I__O(5);
      var x9 = seq.apply__I__O(6);
      var x10 = seq.apply__I__O(7);
      var x11 = seq.apply__I__O(8);
      var x12 = seq.apply__I__O(9);
      var x13 = seq.apply__I__O(10);
      var x14 = seq.apply__I__O(11);
      var x15 = seq.apply__I__O(12);
      var x16 = seq.apply__I__O(13);
      var x17 = seq.apply__I__O(14);
      var x18 = seq.apply__I__O(15);
      var x19 = seq.apply__I__O(16);
      var x20 = seq.apply__I__O(17);
      var x21 = seq.apply__I__O(18);
      var x22 = seq.apply__I__O(19);
      var x23 = seq.apply__I__O(20);
      var x24 = seq.apply__I__O(21);
      return new $c_T22(x3, x4, x5, x6, x7, x8, x9, x10, x11, x12, x13, x14, x15, x16, x17, x18, x19, x20, x21, x22, x23, x24);
    }
  }
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("Cannot convert " + seq) + " to params!"));
});
var $d_Lsttp_tapir_internal_SeqToParams$ = new $TypeData().initClass($c_Lsttp_tapir_internal_SeqToParams$, "sttp.tapir.internal.SeqToParams$", ({
  Lsttp_tapir_internal_SeqToParams$: 1
}));
export { $d_Lsttp_tapir_internal_SeqToParams$ as $d_Lsttp_tapir_internal_SeqToParams$ };
var $n_Lsttp_tapir_internal_SeqToParams$;
function $m_Lsttp_tapir_internal_SeqToParams$() {
  if ((!$n_Lsttp_tapir_internal_SeqToParams$)) {
    $n_Lsttp_tapir_internal_SeqToParams$ = new $c_Lsttp_tapir_internal_SeqToParams$();
  }
  return $n_Lsttp_tapir_internal_SeqToParams$;
}
export { $m_Lsttp_tapir_internal_SeqToParams$ as $m_Lsttp_tapir_internal_SeqToParams$ };
/** @constructor */
function $c_Lsttp_tapir_internal_UrlencodedData$() {
}
export { $c_Lsttp_tapir_internal_UrlencodedData$ as $c_Lsttp_tapir_internal_UrlencodedData$ };
$c_Lsttp_tapir_internal_UrlencodedData$.prototype = new $h_O();
$c_Lsttp_tapir_internal_UrlencodedData$.prototype.constructor = $c_Lsttp_tapir_internal_UrlencodedData$;
/** @constructor */
function $h_Lsttp_tapir_internal_UrlencodedData$() {
}
export { $h_Lsttp_tapir_internal_UrlencodedData$ as $h_Lsttp_tapir_internal_UrlencodedData$ };
$h_Lsttp_tapir_internal_UrlencodedData$.prototype = $c_Lsttp_tapir_internal_UrlencodedData$.prototype;
$c_Lsttp_tapir_internal_UrlencodedData$.prototype.decode__T__Ljava_nio_charset_Charset__sci_Seq = (function(s, charset) {
  var this$1 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(s, "&", 0));
  var this$3 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1);
  var rest = this$3;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.head__O();
    matchResult1: {
      var $x_1;
      var x1 = $f_T__split__T__I__AT(x0, "=", 2);
      if ((x1 !== null)) {
        if (($m_s_Array$UnapplySeqWrapper$().lengthCompare$extension__O__I__I(x1, 2) === 0)) {
          var x3 = x1.u[0];
          var x4 = x1.u[1];
          var _1 = decodeURIComponent(x3.split("+").join(" "));
          var _2 = decodeURIComponent(x4.split("+").join(" "));
          var value = $ct_T2__O__O__(new $c_T2(), _1, _2);
          var $x_1 = new $c_s_Some(value);
          break matchResult1;
        }
      }
      var $x_1 = $m_s_None$();
    }
    var it = $x_1.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $m_sci_Nil$() : h);
});
$c_Lsttp_tapir_internal_UrlencodedData$.prototype.encode__sci_Seq__Ljava_nio_charset_Charset__T = (function(s, charset) {
  var this$2 = s.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var k = x$1._1__O();
      var v = x$1._2__O();
      var in$1 = encodeURIComponent(k);
      var $x_1 = in$1.split("%20").join("+");
      var in$2 = encodeURIComponent(v);
      return (($x_1 + "=") + in$2.split("%20").join("+"));
    }
    throw new $c_s_MatchError(x$1);
  })));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "&", "");
});
var $d_Lsttp_tapir_internal_UrlencodedData$ = new $TypeData().initClass($c_Lsttp_tapir_internal_UrlencodedData$, "sttp.tapir.internal.UrlencodedData$", ({
  Lsttp_tapir_internal_UrlencodedData$: 1
}));
export { $d_Lsttp_tapir_internal_UrlencodedData$ as $d_Lsttp_tapir_internal_UrlencodedData$ };
var $n_Lsttp_tapir_internal_UrlencodedData$;
function $m_Lsttp_tapir_internal_UrlencodedData$() {
  if ((!$n_Lsttp_tapir_internal_UrlencodedData$)) {
    $n_Lsttp_tapir_internal_UrlencodedData$ = new $c_Lsttp_tapir_internal_UrlencodedData$();
  }
  return $n_Lsttp_tapir_internal_UrlencodedData$;
}
export { $m_Lsttp_tapir_internal_UrlencodedData$ as $m_Lsttp_tapir_internal_UrlencodedData$ };
/** @constructor */
function $c_Lsttp_tapir_internal_package$() {
}
export { $c_Lsttp_tapir_internal_package$ as $c_Lsttp_tapir_internal_package$ };
$c_Lsttp_tapir_internal_package$.prototype = new $h_O();
$c_Lsttp_tapir_internal_package$.prototype.constructor = $c_Lsttp_tapir_internal_package$;
/** @constructor */
function $h_Lsttp_tapir_internal_package$() {
}
export { $h_Lsttp_tapir_internal_package$ as $h_Lsttp_tapir_internal_package$ };
$h_Lsttp_tapir_internal_package$.prototype = $c_Lsttp_tapir_internal_package$.prototype;
$c_Lsttp_tapir_internal_package$.prototype.mkCombine__Lsttp_tapir_typelevel_BinaryTupleOp__F2 = (function(op) {
  var _1 = op.leftArity__I();
  var _2 = op.rightArity__I();
  if ((_1 === 0)) {
    return new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$1, p2) => p2));
  }
  if ((_2 === 0)) {
    return new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((p1, _$2) => p1));
  }
  if ((_1 === 1)) {
    if ((_2 === 1)) {
      return new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((p1$2, p2$2) => {
        var this$2 = $m_sci_Vector$();
        var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([p1$2.asAny__O(), p2$2.asAny__O()]));
        var asVector = this$2.from__sc_IterableOnce__sci_Vector(elems);
        return new $c_Lsttp_tapir_internal_package$ParamsAsVector(asVector);
      }));
    }
    return new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((p1$3, p2$3) => {
      var elem$1 = p1$3.asAny__O();
      var this$4 = p2$3.asVector__sci_Vector();
      var asVector$1 = this$4.prepended__O__sci_Vector(elem$1);
      return new $c_Lsttp_tapir_internal_package$ParamsAsVector(asVector$1);
    }));
  }
  if ((_2 === 1)) {
    return new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((p1$4, p2$4) => {
      var this$6 = p1$4.asVector__sci_Vector();
      var elem = p2$4.asAny__O();
      var asVector$2 = this$6.appended__O__O(elem);
      return new $c_Lsttp_tapir_internal_package$ParamsAsVector(asVector$2);
    }));
  }
  return new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((p1$5, p2$5) => {
    var this$8 = p1$5.asVector__sci_Vector();
    var suffix = p2$5.asVector__sci_Vector();
    var asVector$3 = this$8.appendedAll__sc_IterableOnce__sci_Vector(suffix);
    return new $c_Lsttp_tapir_internal_package$ParamsAsVector(asVector$3);
  }));
});
$c_Lsttp_tapir_internal_package$.prototype.mkSplit__Lsttp_tapir_typelevel_BinaryTupleOp__F1 = (function(op) {
  var _1 = op.leftArity__I();
  var _2 = op.rightArity__I();
  if ((_1 === 0)) {
    return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((p) => {
      var _1$1 = new $c_Lsttp_tapir_internal_package$ParamsAsAny((void 0));
      return $ct_T2__O__O__(new $c_T2(), _1$1, p);
    }));
  }
  if ((_2 === 0)) {
    return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((p$2) => {
      var _2$1 = new $c_Lsttp_tapir_internal_package$ParamsAsAny((void 0));
      return $ct_T2__O__O__(new $c_T2(), p$2, _2$1);
    }));
  }
  if ((_1 === 1)) {
    if ((_2 === 1)) {
      return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((p$3) => {
        var asAny = p$3.asVector__sci_Vector().head__O();
        var _1$2 = new $c_Lsttp_tapir_internal_package$ParamsAsAny(asAny);
        var asAny$1 = p$3.asVector__sci_Vector().last__O();
        var _2$2 = new $c_Lsttp_tapir_internal_package$ParamsAsAny(asAny$1);
        return $ct_T2__O__O__(new $c_T2(), _1$2, _2$2);
      }));
    }
    return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((p$4) => {
      var asAny$2 = p$4.asVector__sci_Vector().head__O();
      var _1$3 = new $c_Lsttp_tapir_internal_package$ParamsAsAny(asAny$2);
      var asVector = p$4.asVector__sci_Vector().tail__sci_Vector();
      var _2$3 = new $c_Lsttp_tapir_internal_package$ParamsAsVector(asVector);
      return $ct_T2__O__O__(new $c_T2(), _1$3, _2$3);
    }));
  }
  if ((_2 === 1)) {
    return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((p$5) => {
      var asVector$1 = p$5.asVector__sci_Vector().init__sci_Vector();
      var _1$4 = new $c_Lsttp_tapir_internal_package$ParamsAsVector(asVector$1);
      var asAny$3 = p$5.asVector__sci_Vector().last__O();
      var _2$4 = new $c_Lsttp_tapir_internal_package$ParamsAsAny(asAny$3);
      return $ct_T2__O__O__(new $c_T2(), _1$4, _2$4);
    }));
  }
  return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((p$6) => {
    var this$15 = p$6.asVector__sci_Vector();
    var asVector$2 = this$15.slice__I__I__sci_Vector(0, _1);
    var _1$5 = new $c_Lsttp_tapir_internal_package$ParamsAsVector(asVector$2);
    var this$17 = p$6.asVector__sci_Vector();
    var from = ((this$17.length__I() - ((_2 > 0) ? _2 : 0)) | 0);
    var until = this$17.length__I();
    var asVector$3 = this$17.slice__I__I__sci_Vector(from, until);
    var _2$5 = new $c_Lsttp_tapir_internal_package$ParamsAsVector(asVector$3);
    return $ct_T2__O__O__(new $c_T2(), _1$5, _2$5);
  }));
});
$c_Lsttp_tapir_internal_package$.prototype.charset__Lsttp_tapir_RawBodyType__s_Option = (function(bodyType) {
  if ((bodyType instanceof $c_Lsttp_tapir_RawBodyType$StringBody)) {
    var x237 = bodyType.Lsttp_tapir_RawBodyType$StringBody__f_charset;
    return new $c_s_Some(x237);
  } else {
    return $m_s_None$();
  }
});
$c_Lsttp_tapir_internal_package$.prototype.isBasicValue__O__Z = (function(v) {
  return (((typeof v) === "string") || ($isInt(v) || ((v instanceof $c_RTLong) || ($isFloat(v) || (((typeof v) === "number") || (((typeof v) === "boolean") || ((v instanceof $c_s_math_BigDecimal) || ((v instanceof $c_s_math_BigInt) || (v === null)))))))));
});
var $d_Lsttp_tapir_internal_package$ = new $TypeData().initClass($c_Lsttp_tapir_internal_package$, "sttp.tapir.internal.package$", ({
  Lsttp_tapir_internal_package$: 1
}));
export { $d_Lsttp_tapir_internal_package$ as $d_Lsttp_tapir_internal_package$ };
var $n_Lsttp_tapir_internal_package$;
function $m_Lsttp_tapir_internal_package$() {
  if ((!$n_Lsttp_tapir_internal_package$)) {
    $n_Lsttp_tapir_internal_package$ = new $c_Lsttp_tapir_internal_package$();
  }
  return $n_Lsttp_tapir_internal_package$;
}
export { $m_Lsttp_tapir_internal_package$ as $m_Lsttp_tapir_internal_package$ };
/** @constructor */
function $c_Lsttp_tapir_internal_package$IterableToListMap(xs) {
  this.Lsttp_tapir_internal_package$IterableToListMap__f_xs = null;
  this.Lsttp_tapir_internal_package$IterableToListMap__f_xs = xs;
}
export { $c_Lsttp_tapir_internal_package$IterableToListMap as $c_Lsttp_tapir_internal_package$IterableToListMap };
$c_Lsttp_tapir_internal_package$IterableToListMap.prototype = new $h_O();
$c_Lsttp_tapir_internal_package$IterableToListMap.prototype.constructor = $c_Lsttp_tapir_internal_package$IterableToListMap;
/** @constructor */
function $h_Lsttp_tapir_internal_package$IterableToListMap() {
}
export { $h_Lsttp_tapir_internal_package$IterableToListMap as $h_Lsttp_tapir_internal_package$IterableToListMap };
$h_Lsttp_tapir_internal_package$IterableToListMap.prototype = $c_Lsttp_tapir_internal_package$IterableToListMap.prototype;
$c_Lsttp_tapir_internal_package$IterableToListMap.prototype.toListMap__s_$less$colon$less__sci_ListMap = (function(ev) {
  var b = new $c_sci_ListMapBuilder();
  this.Lsttp_tapir_internal_package$IterableToListMap__f_xs.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => b.addOne__O__O__sci_ListMapBuilder(x._1__O(), x._2__O()))));
  return b.result__sci_ListMap();
});
var $d_Lsttp_tapir_internal_package$IterableToListMap = new $TypeData().initClass($c_Lsttp_tapir_internal_package$IterableToListMap, "sttp.tapir.internal.package$IterableToListMap", ({
  Lsttp_tapir_internal_package$IterableToListMap: 1
}));
export { $d_Lsttp_tapir_internal_package$IterableToListMap as $d_Lsttp_tapir_internal_package$IterableToListMap };
function $p_Lsttp_tapir_internal_package$ValidatorSyntax__toPrimitives$1__Lsttp_tapir_Validator__sci_Seq($thiz, v) {
  var v$tailLocal1 = v;
  while (true) {
    var x259 = v$tailLocal1;
    if ((x259 instanceof $c_Lsttp_tapir_Validator$Mapped)) {
      var x273 = x259.Lsttp_tapir_Validator$Mapped__f_wrapped;
      v$tailLocal1 = x273;
      continue;
    }
    if ((x259 instanceof $c_Lsttp_tapir_Validator$All)) {
      var x270 = x259.Lsttp_tapir_Validator$All__f_validators;
      return x270.flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v$2) => $p_Lsttp_tapir_internal_package$ValidatorSyntax__toPrimitives$1__Lsttp_tapir_Validator__sci_Seq($thiz, v$2))));
    }
    if ((x259 instanceof $c_Lsttp_tapir_Validator$Any)) {
      $m_Lsttp_tapir_Validator$Any$();
      var x267 = x259.Lsttp_tapir_Validator$Any__f_validators;
      return x267.flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v$3) => $p_Lsttp_tapir_internal_package$ValidatorSyntax__toPrimitives$1__Lsttp_tapir_Validator__sci_Seq($thiz, v$3))));
    }
    if ((x259 instanceof $c_Lsttp_tapir_Validator$Custom)) {
      return $m_sci_Nil$();
    }
    if ($is_Lsttp_tapir_Validator$Primitive(x259)) {
      return new $c_sci_$colon$colon(x259, $m_sci_Nil$());
    }
    throw new $c_s_MatchError(x259);
  }
}
export { $p_Lsttp_tapir_internal_package$ValidatorSyntax__toPrimitives$1__Lsttp_tapir_Validator__sci_Seq as $p_Lsttp_tapir_internal_package$ValidatorSyntax__toPrimitives$1__Lsttp_tapir_Validator__sci_Seq };
/** @constructor */
function $c_Lsttp_tapir_internal_package$ValidatorSyntax(v) {
  this.Lsttp_tapir_internal_package$ValidatorSyntax__f_v = null;
  this.Lsttp_tapir_internal_package$ValidatorSyntax__f_v = v;
}
export { $c_Lsttp_tapir_internal_package$ValidatorSyntax as $c_Lsttp_tapir_internal_package$ValidatorSyntax };
$c_Lsttp_tapir_internal_package$ValidatorSyntax.prototype = new $h_O();
$c_Lsttp_tapir_internal_package$ValidatorSyntax.prototype.constructor = $c_Lsttp_tapir_internal_package$ValidatorSyntax;
/** @constructor */
function $h_Lsttp_tapir_internal_package$ValidatorSyntax() {
}
export { $h_Lsttp_tapir_internal_package$ValidatorSyntax as $h_Lsttp_tapir_internal_package$ValidatorSyntax };
$h_Lsttp_tapir_internal_package$ValidatorSyntax.prototype = $c_Lsttp_tapir_internal_package$ValidatorSyntax.prototype;
$c_Lsttp_tapir_internal_package$ValidatorSyntax.prototype.asPrimitiveValidators__sci_Seq = (function() {
  return $p_Lsttp_tapir_internal_package$ValidatorSyntax__toPrimitives$1__Lsttp_tapir_Validator__sci_Seq(this, this.Lsttp_tapir_internal_package$ValidatorSyntax__f_v);
});
$c_Lsttp_tapir_internal_package$ValidatorSyntax.prototype.inferEnumerationEncode__Lsttp_tapir_Validator = (function() {
  matchResult41: {
    var $x_1;
    var x275 = this.Lsttp_tapir_internal_package$ValidatorSyntax__f_v;
    if ((x275 instanceof $c_Lsttp_tapir_Validator$Enumeration)) {
      var x288 = x275.Lsttp_tapir_Validator$Enumeration__f_possibleValues;
      var x289 = x275.Lsttp_tapir_Validator$Enumeration__f_encode;
      var x290 = x275.Lsttp_tapir_Validator$Enumeration__f_name;
      var x = $m_s_None$();
      if ((x === x289)) {
        _return: {
          var these = x288;
          while ((!these.isEmpty__Z())) {
            var x0 = these.head__O();
            if ((!$m_Lsttp_tapir_internal_package$().isBasicValue__O__Z(x0))) {
              var $x_2 = false;
              break _return;
            }
            these = these.tail__O();
          }
          var $x_2 = true;
        }
        if ($x_2) {
          var value = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$3) => new $c_s_Some(x$3)));
          var encode = new $c_s_Some(value);
          var $x_1 = new $c_Lsttp_tapir_Validator$Enumeration(x288, encode, x290);
          break matchResult41;
        } else {
          var $x_1 = this.Lsttp_tapir_internal_package$ValidatorSyntax__f_v;
          break matchResult41;
        }
      }
    }
    if ((x275 instanceof $c_Lsttp_tapir_Validator$Mapped)) {
      var x284 = x275.Lsttp_tapir_Validator$Mapped__f_wrapped;
      var x285 = x275.Lsttp_tapir_Validator$Mapped__f_g;
      var wrapped = new $c_Lsttp_tapir_internal_package$ValidatorSyntax(x284).inferEnumerationEncode__Lsttp_tapir_Validator();
      var $x_1 = new $c_Lsttp_tapir_Validator$Mapped(wrapped, x285);
      break matchResult41;
    }
    if ((x275 instanceof $c_Lsttp_tapir_Validator$All)) {
      var x281 = x275.Lsttp_tapir_Validator$All__f_validators;
      var validators = x281.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$21) => new $c_Lsttp_tapir_internal_package$ValidatorSyntax(_$21).inferEnumerationEncode__Lsttp_tapir_Validator())));
      var $x_1 = new $c_Lsttp_tapir_Validator$All(validators);
      break matchResult41;
    }
    if ((x275 instanceof $c_Lsttp_tapir_Validator$Any)) {
      $m_Lsttp_tapir_Validator$Any$();
      var x278 = x275.Lsttp_tapir_Validator$Any__f_validators;
      $m_Lsttp_tapir_Validator$Any$();
      var validators$1 = x278.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$22) => new $c_Lsttp_tapir_internal_package$ValidatorSyntax(_$22).inferEnumerationEncode__Lsttp_tapir_Validator())));
      var $x_1 = new $c_Lsttp_tapir_Validator$Any(validators$1);
      break matchResult41;
    }
    var $x_1 = this.Lsttp_tapir_internal_package$ValidatorSyntax__f_v;
  }
  return $x_1;
});
var $d_Lsttp_tapir_internal_package$ValidatorSyntax = new $TypeData().initClass($c_Lsttp_tapir_internal_package$ValidatorSyntax, "sttp.tapir.internal.package$ValidatorSyntax", ({
  Lsttp_tapir_internal_package$ValidatorSyntax: 1
}));
export { $d_Lsttp_tapir_internal_package$ValidatorSyntax as $d_Lsttp_tapir_internal_package$ValidatorSyntax };
function $f_Lyantl_Newtype$WithoutValidation__apply__O__O($thiz, input) {
  var x6 = $thiz.make__Lyantl_INewtype$make$().apply__O__s_util_Either(input);
  if ((x6 instanceof $c_s_util_Left)) {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "impossible");
  }
  if ((x6 instanceof $c_s_util_Right)) {
    var value = x6.s_util_Right__f_value;
    return value;
  }
  throw new $c_s_MatchError(x6);
}
export { $f_Lyantl_Newtype$WithoutValidation__apply__O__O as $f_Lyantl_Newtype$WithoutValidation__apply__O__O };
/** @constructor */
function $c_Lyantl_Validate$() {
  this.Lyantl_Validate$__f_noOp = null;
  $n_Lyantl_Validate$ = this;
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }));
  this.Lyantl_Validate$__f_noOp = new $c_Lyantl_Validate$$anon$6(f);
}
export { $c_Lyantl_Validate$ as $c_Lyantl_Validate$ };
$c_Lyantl_Validate$.prototype = new $h_O();
$c_Lyantl_Validate$.prototype.constructor = $c_Lyantl_Validate$;
/** @constructor */
function $h_Lyantl_Validate$() {
}
export { $h_Lyantl_Validate$ as $h_Lyantl_Validate$ };
$h_Lyantl_Validate$.prototype = $c_Lyantl_Validate$.prototype;
var $d_Lyantl_Validate$ = new $TypeData().initClass($c_Lyantl_Validate$, "yantl.Validate$", ({
  Lyantl_Validate$: 1
}));
export { $d_Lyantl_Validate$ as $d_Lyantl_Validate$ };
var $n_Lyantl_Validate$;
function $m_Lyantl_Validate$() {
  if ((!$n_Lyantl_Validate$)) {
    $n_Lyantl_Validate$ = new $c_Lyantl_Validate$();
  }
  return $n_Lyantl_Validate$;
}
export { $m_Lyantl_Validate$ as $m_Lyantl_Validate$ };
/** @constructor */
function $c_Lyantl_Validator$() {
  $n_Lyantl_Validator$ = this;
  this.fromRules__ALyantl_ValidatorRule__Lyantl_Validator(new ($d_Lyantl_ValidatorRule.getArrayOf().constr)(0));
}
export { $c_Lyantl_Validator$ as $c_Lyantl_Validator$ };
$c_Lyantl_Validator$.prototype = new $h_O();
$c_Lyantl_Validator$.prototype.constructor = $c_Lyantl_Validator$;
/** @constructor */
function $h_Lyantl_Validator$() {
}
export { $h_Lyantl_Validator$ as $h_Lyantl_Validator$ };
$h_Lyantl_Validator$.prototype = $c_Lyantl_Validator$.prototype;
$c_Lyantl_Validator$.prototype.of__sci_Seq__Lyantl_Validator = (function(rules) {
  var len = rules.length__I();
  var array = new ($d_Lyantl_ValidatorRule.getArrayOf().constr)(len);
  var iterator = rules.iterator__sc_Iterator();
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  return this.fromRules__ALyantl_ValidatorRule__Lyantl_Validator(array);
});
$c_Lyantl_Validator$.prototype.fromRules__ALyantl_ValidatorRule__Lyantl_Validator = (function(rules) {
  return new $c_Lyantl_Validator$$anon$7(rules);
});
$c_Lyantl_Validator$.prototype.errorsToString__sci_Vector__Lyantl_AsString__T = (function(errors, asString) {
  var x = errors.length__I();
  if ((((x === 1) ? 0 : ((x < 1) ? (-1) : 1)) === 0)) {
    var _$1 = errors.head__O();
    return $dp_toString__T(_$1);
  } else {
    var $x_1 = errors.length__I();
    var this$3 = errors.iterator__sc_Iterator();
    var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => $dp_toString__T(a)));
    var this$4 = new $c_sc_Iterator$$anon$9(this$3, f);
    var x$1 = ((("Multiple errors (" + $x_1) + ") were encountered while validating a value:\n        |\n        |- ") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$4, "", "\n\n- ", ""));
    return $m_sc_StringOps$().stripMargin$extension__T__C__T(x$1, 124);
  }
});
$c_Lyantl_Validator$.prototype.yantl$Validator$$$_$rules_$2__F0__ALyantl_ValidatorRule = (function(rules$1) {
  var xs = rules$1.apply__O();
  var len = xs.length__I();
  var array = new ($d_Lyantl_ValidatorRule.getArrayOf().constr)(len);
  var iterator = xs.iterator__sc_Iterator();
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  return array;
});
var $d_Lyantl_Validator$ = new $TypeData().initClass($c_Lyantl_Validator$, "yantl.Validator$", ({
  Lyantl_Validator$: 1
}));
export { $d_Lyantl_Validator$ as $d_Lyantl_Validator$ };
var $n_Lyantl_Validator$;
function $m_Lyantl_Validator$() {
  if ((!$n_Lyantl_Validator$)) {
    $n_Lyantl_Validator$ = new $c_Lyantl_Validator$();
  }
  return $n_Lyantl_Validator$;
}
export { $m_Lyantl_Validator$ as $m_Lyantl_Validator$ };
var $d_Lyantl_ValidatorRule = new $TypeData().initClass(1, "yantl.ValidatorRule", ({
  Lyantl_ValidatorRule: 1
}));
export { $d_Lyantl_ValidatorRule as $d_Lyantl_ValidatorRule };
/** @constructor */
function $c_Lcats_Eval() {
}
export { $c_Lcats_Eval as $c_Lcats_Eval };
$c_Lcats_Eval.prototype = new $h_O();
$c_Lcats_Eval.prototype.constructor = $c_Lcats_Eval;
/** @constructor */
function $h_Lcats_Eval() {
}
export { $h_Lcats_Eval as $h_Lcats_Eval };
$h_Lcats_Eval.prototype = $c_Lcats_Eval.prototype;
$c_Lcats_Eval.prototype.map__F1__Lcats_Eval = (function(f) {
  return this.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
    var value = f.apply__O__O(a);
    return new $c_Lcats_Now(value);
  })));
});
$c_Lcats_Eval.prototype.flatMap__F1__Lcats_Eval = (function(f) {
  return ((this instanceof $c_Lcats_Eval$FlatMap) ? new $c_Lcats_Eval$$anon$1(this, f) : ((this instanceof $c_Lcats_Eval$Defer) ? new $c_Lcats_Eval$$anon$3(this, f) : new $c_Lcats_Eval$$anon$4(f, this)));
});
/** @constructor */
function $c_Lcats_EvalInstances0() {
}
export { $c_Lcats_EvalInstances0 as $c_Lcats_EvalInstances0 };
$c_Lcats_EvalInstances0.prototype = new $h_Lcats_EvalInstances1();
$c_Lcats_EvalInstances0.prototype.constructor = $c_Lcats_EvalInstances0;
/** @constructor */
function $h_Lcats_EvalInstances0() {
}
export { $h_Lcats_EvalInstances0 as $h_Lcats_EvalInstances0 };
$h_Lcats_EvalInstances0.prototype = $c_Lcats_EvalInstances0.prototype;
/** @constructor */
function $c_Lcats_Foldable$Source$$anon$3() {
}
export { $c_Lcats_Foldable$Source$$anon$3 as $c_Lcats_Foldable$Source$$anon$3 };
$c_Lcats_Foldable$Source$$anon$3.prototype = new $h_Lcats_Foldable$Source();
$c_Lcats_Foldable$Source$$anon$3.prototype.constructor = $c_Lcats_Foldable$Source$$anon$3;
/** @constructor */
function $h_Lcats_Foldable$Source$$anon$3() {
}
export { $h_Lcats_Foldable$Source$$anon$3 as $h_Lcats_Foldable$Source$$anon$3 };
$h_Lcats_Foldable$Source$$anon$3.prototype = $c_Lcats_Foldable$Source$$anon$3.prototype;
$c_Lcats_Foldable$Source$$anon$3.prototype.uncons__s_Option = (function() {
  return $m_s_None$();
});
var $d_Lcats_Foldable$Source$$anon$3 = new $TypeData().initClass($c_Lcats_Foldable$Source$$anon$3, "cats.Foldable$Source$$anon$3", ({
  Lcats_Foldable$Source$$anon$3: 1,
  Lcats_Foldable$Source: 1
}));
export { $d_Lcats_Foldable$Source$$anon$3 as $d_Lcats_Foldable$Source$$anon$3 };
/** @constructor */
function $c_Lcats_Foldable$Source$$anon$4(a$5, src$10) {
  this.Lcats_Foldable$Source$$anon$4__f_a$2 = null;
  this.Lcats_Foldable$Source$$anon$4__f_src$6 = null;
  this.Lcats_Foldable$Source$$anon$4__f_a$2 = a$5;
  this.Lcats_Foldable$Source$$anon$4__f_src$6 = src$10;
}
export { $c_Lcats_Foldable$Source$$anon$4 as $c_Lcats_Foldable$Source$$anon$4 };
$c_Lcats_Foldable$Source$$anon$4.prototype = new $h_Lcats_Foldable$Source();
$c_Lcats_Foldable$Source$$anon$4.prototype.constructor = $c_Lcats_Foldable$Source$$anon$4;
/** @constructor */
function $h_Lcats_Foldable$Source$$anon$4() {
}
export { $h_Lcats_Foldable$Source$$anon$4 as $h_Lcats_Foldable$Source$$anon$4 };
$h_Lcats_Foldable$Source$$anon$4.prototype = $c_Lcats_Foldable$Source$$anon$4.prototype;
$c_Lcats_Foldable$Source$$anon$4.prototype.uncons__s_Option = (function() {
  var _1 = this.Lcats_Foldable$Source$$anon$4__f_a$2;
  var _2 = this.Lcats_Foldable$Source$$anon$4__f_src$6;
  var value = $ct_T2__O__O__(new $c_T2(), _1, _2);
  return new $c_s_Some(value);
});
var $d_Lcats_Foldable$Source$$anon$4 = new $TypeData().initClass($c_Lcats_Foldable$Source$$anon$4, "cats.Foldable$Source$$anon$4", ({
  Lcats_Foldable$Source$$anon$4: 1,
  Lcats_Foldable$Source: 1
}));
export { $d_Lcats_Foldable$Source$$anon$4 as $d_Lcats_Foldable$Source$$anon$4 };
/** @constructor */
function $c_Lcats_Show$ToShowOps$$anon$3(target$1, tc$1) {
  this.Lcats_Show$ToShowOps$$anon$3__f_self = null;
  this.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance = null;
  this.Lcats_Show$ToShowOps$$anon$3__f_self = target$1;
  this.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance = tc$1;
}
export { $c_Lcats_Show$ToShowOps$$anon$3 as $c_Lcats_Show$ToShowOps$$anon$3 };
$c_Lcats_Show$ToShowOps$$anon$3.prototype = new $h_O();
$c_Lcats_Show$ToShowOps$$anon$3.prototype.constructor = $c_Lcats_Show$ToShowOps$$anon$3;
/** @constructor */
function $h_Lcats_Show$ToShowOps$$anon$3() {
}
export { $h_Lcats_Show$ToShowOps$$anon$3 as $h_Lcats_Show$ToShowOps$$anon$3 };
$h_Lcats_Show$ToShowOps$$anon$3.prototype = $c_Lcats_Show$ToShowOps$$anon$3.prototype;
var $d_Lcats_Show$ToShowOps$$anon$3 = new $TypeData().initClass($c_Lcats_Show$ToShowOps$$anon$3, "cats.Show$ToShowOps$$anon$3", ({
  Lcats_Show$ToShowOps$$anon$3: 1,
  Lcats_Show$Ops: 1
}));
export { $d_Lcats_Show$ToShowOps$$anon$3 as $d_Lcats_Show$ToShowOps$$anon$3 };
function $f_Lcats_UnorderedFoldable__size__O__J($thiz, fa) {
  return $uJ($thiz.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => new $c_RTLong(1, 0))), $m_Lcats_kernel_instances_long_package$().Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong));
}
export { $f_Lcats_UnorderedFoldable__size__O__J as $f_Lcats_UnorderedFoldable__size__O__J };
function $ps_Lcats_data_Chain__loop$2__Lcats_data_Chain$NonEmpty__sci_List__J__J(head, tail, acc) {
  var lo = acc.RTLong__f_lo;
  var hi = acc.RTLong__f_hi;
  var acc$tailLocal3__lo = lo;
  var acc$tailLocal3__hi = hi;
  var tail$tailLocal2 = tail;
  var head$tailLocal1 = head;
  while (true) {
    var x196 = head$tailLocal1;
    if ((x196 instanceof $c_Lcats_data_Chain$Append)) {
      var x205 = x196.Lcats_data_Chain$Append__f_leftNE;
      var x206 = x196.Lcats_data_Chain$Append__f_rightNE;
      var this$2 = tail$tailLocal2;
      var tail$tailLocal2$tmp1 = new $c_sci_$colon$colon(x206, this$2);
      head$tailLocal1 = x205;
      tail$tailLocal2 = tail$tailLocal2$tmp1;
      continue;
    }
    if ((x196 instanceof $c_Lcats_data_Chain$Singleton)) {
      var b__lo = acc$tailLocal3__lo;
      var b__hi = acc$tailLocal3__hi;
      var blo = b__lo;
      var lo$1 = ((1 + blo) | 0);
      var hi$1 = ((b__hi + (((blo & (~lo$1)) >>> 31) | 0)) | 0);
      var x188 = tail$tailLocal2;
      if ((x188 instanceof $c_sci_$colon$colon)) {
        var x191 = x188.sci_$colon$colon__f_next;
        var h1 = x188.sci_$colon$colon__f_head;
        head$tailLocal1 = h1;
        tail$tailLocal2 = x191;
        var $x_1__lo = lo$1;
        var $x_1__hi = hi$1;
        acc$tailLocal3__lo = $x_1__lo;
        acc$tailLocal3__hi = $x_1__hi;
        continue;
      }
      return new $c_RTLong(lo$1, hi$1);
    }
    if ((x196 instanceof $c_Lcats_data_Chain$Wrap)) {
      var x199 = x196.Lcats_data_Chain$Wrap__f_seq;
      var a__lo = acc$tailLocal3__lo;
      var a__hi = acc$tailLocal3__hi;
      var value = x199.length__I();
      var hi$2 = (value >> 31);
      var alo = a__lo;
      var lo$2 = ((alo + value) | 0);
      var hi$3 = ((((a__hi + hi$2) | 0) + ((((alo & value) | ((alo | value) & (~lo$2))) >>> 31) | 0)) | 0);
      var x192 = tail$tailLocal2;
      if ((x192 instanceof $c_sci_$colon$colon)) {
        var x195 = x192.sci_$colon$colon__f_next;
        var h1$2 = x192.sci_$colon$colon__f_head;
        head$tailLocal1 = h1$2;
        tail$tailLocal2 = x195;
        var $x_2__lo = lo$2;
        var $x_2__hi = hi$3;
        acc$tailLocal3__lo = $x_2__lo;
        acc$tailLocal3__hi = $x_2__hi;
        continue;
      }
      return new $c_RTLong(lo$2, hi$3);
    }
    throw new $c_s_MatchError(x196);
  }
}
export { $ps_Lcats_data_Chain__loop$2__Lcats_data_Chain$NonEmpty__sci_List__J__J as $ps_Lcats_data_Chain__loop$2__Lcats_data_Chain$NonEmpty__sci_List__J__J };
/** @constructor */
function $c_Lcats_data_Chain() {
}
export { $c_Lcats_data_Chain as $c_Lcats_data_Chain };
$c_Lcats_data_Chain.prototype = new $h_O();
$c_Lcats_data_Chain.prototype.constructor = $c_Lcats_data_Chain;
/** @constructor */
function $h_Lcats_data_Chain() {
}
export { $h_Lcats_data_Chain as $h_Lcats_data_Chain };
$h_Lcats_data_Chain.prototype = $c_Lcats_data_Chain.prototype;
$c_Lcats_data_Chain.prototype.uncons__s_Option = (function() {
  if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
    var c = this;
    var rights = null;
    var result = null;
    while ((result === null)) {
      var x3 = c;
      if ((x3 instanceof $c_Lcats_data_Chain$Singleton)) {
        var x13 = x3.Lcats_data_Chain$Singleton__f_a;
        var next = ((rights === null) ? $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil : rights);
        result = $ct_T2__O__O__(new $c_T2(), x13, next);
        continue;
      }
      if ((x3 instanceof $c_Lcats_data_Chain$Append)) {
        var x9 = x3.Lcats_data_Chain$Append__f_leftNE;
        var x10 = x3.Lcats_data_Chain$Append__f_rightNE;
        if ((rights === null)) {
          rights = x10;
        } else {
          var rightNE = rights;
          rights = $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__(new $c_Lcats_data_Chain$Append(), x10, rightNE);
        }
        c = x9;
        continue;
      }
      if ((x3 instanceof $c_Lcats_data_Chain$Wrap)) {
        var x6 = x3.Lcats_data_Chain$Wrap__f_seq;
        var this$6 = $m_Lcats_data_Chain$();
        var s = x6.tail__O();
        var tail = $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$6, s);
        if ((rights === null)) {
          var next$2 = tail;
        } else if ((tail instanceof $c_Lcats_data_Chain$NonEmpty)) {
          var rightNE$1 = rights;
          var next$2 = $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__(new $c_Lcats_data_Chain$Append(), tail, rightNE$1);
        } else {
          var next$2 = rights;
        }
        var _1 = x6.head__O();
        result = $ct_T2__O__O__(new $c_T2(), _1, next$2);
        continue;
      }
      throw new $c_s_MatchError(x3);
    }
    var value = result;
    return new $c_s_Some(value);
  } else {
    return $m_s_None$();
  }
});
$c_Lcats_data_Chain.prototype.isEmpty__Z = (function() {
  return (!(this instanceof $c_Lcats_data_Chain$NonEmpty));
});
$c_Lcats_data_Chain.prototype.prepend__O__Lcats_data_Chain = (function(a) {
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(($m_Lcats_data_Chain$(), new $c_Lcats_data_Chain$Singleton(a)), this);
});
$c_Lcats_data_Chain.prototype.append__O__Lcats_data_Chain = (function(a) {
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this, ($m_Lcats_data_Chain$(), new $c_Lcats_data_Chain$Singleton(a)));
});
$c_Lcats_data_Chain.prototype.map__F1__Lcats_data_Chain = (function(f) {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x34 = this.Lcats_data_Chain$Wrap__f_seq;
    var seq = x34.map__F1__O(f);
    return new $c_Lcats_data_Chain$Wrap(seq);
  } else {
    var this$5 = $m_Lcats_data_Chain$();
    var this$3 = this.iterator__sc_Iterator();
    var this$4 = new $c_sc_Iterator$$anon$9(this$3, f);
    var s = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$4);
    return $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$5, s);
  }
});
$c_Lcats_data_Chain.prototype.flatMap__F1__Lcats_data_Chain = (function(f) {
  var this$1 = $m_Lcats_data_Chain$();
  var result = this$1.Lcats_data_Chain$__f_nil;
  var iter = this.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var this$2 = result;
    var c = f.apply__O__O(iter.next__O());
    result = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$2, c);
  }
  return result;
});
$c_Lcats_data_Chain.prototype.foldLeft__O__F2__O = (function(z, f) {
  var result = z;
  var iter = this.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    result = f.apply__O__O__O(result, iter.next__O());
  }
  return result;
});
$c_Lcats_data_Chain.prototype.collect__s_PartialFunction__Lcats_data_Chain = (function(pf) {
  var z = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  var result = z;
  var iter = this.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var x0 = result;
    var x1 = iter.next__O();
    var x = pf.applyOrElse__O__F1__O(x1, $m_Lcats_data_Chain$().Lcats_data_Chain$__f_cats$data$Chain$$$sentinel);
    result = ((x !== $m_Lcats_data_Chain$().Lcats_data_Chain$__f_cats$data$Chain$$$sentinel) ? x0.append__O__Lcats_data_Chain(x) : x0);
  }
  return result;
});
$c_Lcats_data_Chain.prototype.exists__F1__Z = (function(f) {
  var result = new $c_sr_BooleanRef(false);
  var f$1 = ((a) => {
    var b = (!(!f.apply__O__O(a)));
    if (b) {
      result.sr_BooleanRef__f_elem = true;
    }
    return b;
  });
  _return: {
    if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var c = this;
      var rights = $m_sci_Nil$();
      while ((c !== null)) {
        var x159 = c;
        if ((x159 instanceof $c_Lcats_data_Chain$Singleton)) {
          var x169 = x159.Lcats_data_Chain$Singleton__f_a;
          var b$1 = (!(!f$1(x169)));
          if (b$1) {
            break;
          }
          if (rights.isEmpty__Z()) {
            c = null;
          } else {
            var head = rights.head__O();
            rights = rights.tail__O();
            c = head;
          }
          continue;
        }
        if ((x159 instanceof $c_Lcats_data_Chain$Append)) {
          var x165 = x159.Lcats_data_Chain$Append__f_leftNE;
          var x166 = x159.Lcats_data_Chain$Append__f_rightNE;
          var this$4 = rights;
          rights = new $c_sci_$colon$colon(x166, this$4);
          c = x165;
          continue;
        }
        if ((x159 instanceof $c_Lcats_data_Chain$Wrap)) {
          var x162 = x159.Lcats_data_Chain$Wrap__f_seq;
          var iterator = x162.iterator__sc_Iterator();
          while (iterator.hasNext__Z()) {
            var x0 = iterator.next__O();
            var b$2 = (!(!f$1(x0)));
            if (b$2) {
              break _return;
            }
          }
          if (rights.isEmpty__Z()) {
            c = null;
          } else {
            var head$2 = rights.head__O();
            rights = rights.tail__O();
            c = head$2;
          }
          continue;
        }
        throw new $c_s_MatchError(x159);
      }
    }
  }
  return result.sr_BooleanRef__f_elem;
});
$c_Lcats_data_Chain.prototype.iterator__sc_Iterator = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x179 = this.Lcats_data_Chain$Wrap__f_seq;
    return x179.iterator__sc_Iterator();
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x176 = this.Lcats_data_Chain$Singleton__f_a;
    return new $c_sc_Iterator$$anon$20(x176);
  } else {
    return ((this instanceof $c_Lcats_data_Chain$Append) ? new $c_Lcats_data_Chain$ChainIterator(this) : $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty);
  }
});
$c_Lcats_data_Chain.prototype.length__J = (function() {
  return ((this instanceof $c_Lcats_data_Chain$NonEmpty) ? $ps_Lcats_data_Chain__loop$2__Lcats_data_Chain$NonEmpty__sci_List__J__J(this, $m_sci_Nil$(), $L0) : $L0);
});
$c_Lcats_data_Chain.prototype.toList__sci_List = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x237 = this.Lcats_data_Chain$Wrap__f_seq;
    return x237.toList__sci_List();
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x234 = this.Lcats_data_Chain$Singleton__f_a;
    var this$3 = $m_sci_Nil$();
    return new $c_sci_$colon$colon(x234, this$3);
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var this$4 = new $c_Lcats_data_Chain$ChainIterator(this);
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4);
  } else {
    return $m_sci_Nil$();
  }
});
$c_Lcats_data_Chain.prototype.toVector__sci_Vector = (function() {
  if ((this instanceof $c_Lcats_data_Chain$Wrap)) {
    var x245 = this.Lcats_data_Chain$Wrap__f_seq;
    return x245.toVector__sci_Vector();
  } else if ((this instanceof $c_Lcats_data_Chain$Singleton)) {
    var x242 = this.Lcats_data_Chain$Singleton__f_a;
    $m_sci_Vector$();
    var this$4 = $m_sci_Vector0$();
    return this$4.appended__O__sci_Vector(x242);
  } else if ((this instanceof $c_Lcats_data_Chain$Append)) {
    var this$5 = new $c_Lcats_data_Chain$ChainIterator(this);
    return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$5);
  } else {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }
});
$c_Lcats_data_Chain.prototype.$eq$eq$eq__Lcats_data_Chain__Lcats_kernel_Eq__Z = (function(that, A) {
  if ((this === that)) {
    return true;
  } else {
    var iterX = this.iterator__sc_Iterator();
    var iterY = that.iterator__sc_Iterator();
    while ((iterX.hasNext__Z() && iterY.hasNext__Z())) {
      if ((!A.eqv__O__O__Z(iterX.next__O(), iterY.next__O()))) {
        return false;
      }
    }
    return (iterX.hasNext__Z() === iterY.hasNext__Z());
  }
});
$c_Lcats_data_Chain.prototype.show__Lcats_Show__T = (function(AA) {
  var builder = $ct_scm_StringBuilder__T__(new $c_scm_StringBuilder(), "Chain(");
  var first = new $c_sr_BooleanRef(true);
  var f = ((a) => {
    if (first.sr_BooleanRef__f_elem) {
      var s = AA.show__O__T(a);
      builder.addAll__T__scm_StringBuilder(s);
      first.sr_BooleanRef__f_elem = false;
    } else {
      var s$1 = (", " + AA.show__O__T(a));
      builder.addAll__T__scm_StringBuilder(s$1);
    }
    return false;
  });
  _return: {
    if ((this instanceof $c_Lcats_data_Chain$NonEmpty)) {
      var c = this;
      var rights = $m_sci_Nil$();
      while ((c !== null)) {
        var x159 = c;
        if ((x159 instanceof $c_Lcats_data_Chain$Singleton)) {
          var x169 = x159.Lcats_data_Chain$Singleton__f_a;
          var b = (!(!f(x169)));
          if (b) {
            break;
          }
          if (rights.isEmpty__Z()) {
            c = null;
          } else {
            var head = rights.head__O();
            rights = rights.tail__O();
            c = head;
          }
          continue;
        }
        if ((x159 instanceof $c_Lcats_data_Chain$Append)) {
          var x165 = x159.Lcats_data_Chain$Append__f_leftNE;
          var x166 = x159.Lcats_data_Chain$Append__f_rightNE;
          var this$4 = rights;
          rights = new $c_sci_$colon$colon(x166, this$4);
          c = x165;
          continue;
        }
        if ((x159 instanceof $c_Lcats_data_Chain$Wrap)) {
          var x162 = x159.Lcats_data_Chain$Wrap__f_seq;
          var iterator = x162.iterator__sc_Iterator();
          while (iterator.hasNext__Z()) {
            var x0 = iterator.next__O();
            var b$2 = (!(!f(x0)));
            if (b$2) {
              break _return;
            }
          }
          if (rights.isEmpty__Z()) {
            c = null;
          } else {
            var head$2 = rights.head__O();
            rights = rights.tail__O();
            c = head$2;
          }
          continue;
        }
        throw new $c_s_MatchError(x159);
      }
    }
  }
  builder.addOne__C__scm_StringBuilder(41);
  return builder.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Lcats_data_Chain.prototype.toString__T = (function() {
  return this.show__Lcats_Show__T(new $c_Lcats_Show$$anon$5());
});
$c_Lcats_data_Chain.prototype.equals__O__Z = (function(o) {
  return ((o instanceof $c_Lcats_data_Chain) && this.$eq$eq$eq__Lcats_data_Chain__Lcats_kernel_Eq__Z(o, ($m_Lcats_package$(), new $c_Lcats_kernel_Eq$$anon$6())));
});
$c_Lcats_data_Chain.prototype.hashCode__I = (function() {
  $m_Lcats_package$();
  var hashA = new $c_Lcats_kernel_Hash$$anon$3();
  return $m_Lcats_kernel_instances_StaticMethods$().orderedHash__sc_IterableOnce__Lcats_kernel_Hash__I(this.iterator__sc_Iterator(), hashA);
});
function $isArrayOf_Lcats_data_Chain(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain)));
}
export { $isArrayOf_Lcats_data_Chain as $isArrayOf_Lcats_data_Chain };
/** @constructor */
function $c_Lcats_data_ChainInstances2() {
}
export { $c_Lcats_data_ChainInstances2 as $c_Lcats_data_ChainInstances2 };
$c_Lcats_data_ChainInstances2.prototype = new $h_Lcats_data_ChainInstances3();
$c_Lcats_data_ChainInstances2.prototype.constructor = $c_Lcats_data_ChainInstances2;
/** @constructor */
function $h_Lcats_data_ChainInstances2() {
}
export { $h_Lcats_data_ChainInstances2 as $h_Lcats_data_ChainInstances2 };
$h_Lcats_data_ChainInstances2.prototype = $c_Lcats_data_ChainInstances2.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances0() {
}
export { $c_Lcats_data_NonEmptyListInstances0 as $c_Lcats_data_NonEmptyListInstances0 };
$c_Lcats_data_NonEmptyListInstances0.prototype = new $h_Lcats_data_NonEmptyListInstances1();
$c_Lcats_data_NonEmptyListInstances0.prototype.constructor = $c_Lcats_data_NonEmptyListInstances0;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances0() {
}
export { $h_Lcats_data_NonEmptyListInstances0 as $h_Lcats_data_NonEmptyListInstances0 };
$h_Lcats_data_NonEmptyListInstances0.prototype = $c_Lcats_data_NonEmptyListInstances0.prototype;
/** @constructor */
function $c_Lcats_data_NonEmptyVector(toVector) {
  this.Lcats_data_NonEmptyVector__f_toVector = null;
  this.Lcats_data_NonEmptyVector__f_toVector = toVector;
}
export { $c_Lcats_data_NonEmptyVector as $c_Lcats_data_NonEmptyVector };
$c_Lcats_data_NonEmptyVector.prototype = new $h_O();
$c_Lcats_data_NonEmptyVector.prototype.constructor = $c_Lcats_data_NonEmptyVector;
/** @constructor */
function $h_Lcats_data_NonEmptyVector() {
}
export { $h_Lcats_data_NonEmptyVector as $h_Lcats_data_NonEmptyVector };
$h_Lcats_data_NonEmptyVector.prototype = $c_Lcats_data_NonEmptyVector.prototype;
$c_Lcats_data_NonEmptyVector.prototype.hashCode__I = (function() {
  $m_Lcats_data_NonEmptyVector$();
  var this$ = this.Lcats_data_NonEmptyVector__f_toVector;
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this$);
});
$c_Lcats_data_NonEmptyVector.prototype.equals__O__Z = (function(x$0) {
  return $m_Lcats_data_NonEmptyVector$().equals$extension__sci_Vector__O__Z(this.Lcats_data_NonEmptyVector__f_toVector, x$0);
});
$c_Lcats_data_NonEmptyVector.prototype.toString__T = (function() {
  return $m_Lcats_data_NonEmptyVector$().toString$extension__sci_Vector__T(this.Lcats_data_NonEmptyVector__f_toVector);
});
function $isArrayOf_Lcats_data_NonEmptyVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_NonEmptyVector)));
}
export { $isArrayOf_Lcats_data_NonEmptyVector as $isArrayOf_Lcats_data_NonEmptyVector };
var $d_Lcats_data_NonEmptyVector = new $TypeData().initClass($c_Lcats_data_NonEmptyVector, "cats.data.NonEmptyVector", ({
  Lcats_data_NonEmptyVector: 1,
  Lcats_data_NonEmptyCollection: 1
}));
export { $d_Lcats_data_NonEmptyVector as $d_Lcats_data_NonEmptyVector };
/** @constructor */
function $c_Lcats_data_NonEmptyVectorInstances1() {
}
export { $c_Lcats_data_NonEmptyVectorInstances1 as $c_Lcats_data_NonEmptyVectorInstances1 };
$c_Lcats_data_NonEmptyVectorInstances1.prototype = new $h_Lcats_data_NonEmptyVectorInstances2();
$c_Lcats_data_NonEmptyVectorInstances1.prototype.constructor = $c_Lcats_data_NonEmptyVectorInstances1;
/** @constructor */
function $h_Lcats_data_NonEmptyVectorInstances1() {
}
export { $h_Lcats_data_NonEmptyVectorInstances1 as $h_Lcats_data_NonEmptyVectorInstances1 };
$h_Lcats_data_NonEmptyVectorInstances1.prototype = $c_Lcats_data_NonEmptyVectorInstances1.prototype;
/** @constructor */
function $c_Lcats_data_ValidatedInstances1() {
}
export { $c_Lcats_data_ValidatedInstances1 as $c_Lcats_data_ValidatedInstances1 };
$c_Lcats_data_ValidatedInstances1.prototype = new $h_Lcats_data_ValidatedInstances2();
$c_Lcats_data_ValidatedInstances1.prototype.constructor = $c_Lcats_data_ValidatedInstances1;
/** @constructor */
function $h_Lcats_data_ValidatedInstances1() {
}
export { $h_Lcats_data_ValidatedInstances1 as $h_Lcats_data_ValidatedInstances1 };
$h_Lcats_data_ValidatedInstances1.prototype = $c_Lcats_data_ValidatedInstances1.prototype;
function $ps_Lcats_effect_SyncIO__interpret$1__Lcats_effect_kernel_Sync__Lcats_effect_SyncIO__O(F$1, sio) {
  if ((sio instanceof $c_Lcats_effect_SyncIO$Pure)) {
    var x32 = sio.Lcats_effect_SyncIO$Pure__f_value;
    return F$1.pure__O__O(x32);
  }
  if ((sio instanceof $c_Lcats_effect_SyncIO$Suspend)) {
    var x28 = sio.Lcats_effect_SyncIO$Suspend__f_hint;
    var x29 = sio.Lcats_effect_SyncIO$Suspend__f_thunk;
    return F$1.suspend__Lcats_effect_kernel_Sync$Type__F0__O(x28, x29);
  }
  if ((sio instanceof $c_Lcats_effect_SyncIO$Error)) {
    var x25 = sio.Lcats_effect_SyncIO$Error__f_t;
    return F$1.raiseError__O__O(x25);
  }
  if ((sio instanceof $c_Lcats_effect_SyncIO$Map)) {
    var x21 = sio.Lcats_effect_SyncIO$Map__f_ioe;
    var x22 = sio.Lcats_effect_SyncIO$Map__f_f;
    var target = $ps_Lcats_effect_SyncIO__interpret$1__Lcats_effect_kernel_Sync__Lcats_effect_SyncIO__O(F$1, x21);
    var this$6 = new $c_Lcats_Functor$ToFunctorOps$$anon$5(target, F$1);
    return this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance.map__O__F1__O(this$6.Lcats_Functor$ToFunctorOps$$anon$5__f_self, x22);
  }
  if ((sio instanceof $c_Lcats_effect_SyncIO$FlatMap)) {
    var x17 = sio.Lcats_effect_SyncIO$FlatMap__f_ioe;
    var x18 = sio.Lcats_effect_SyncIO$FlatMap__f_f;
    var target$1 = $ps_Lcats_effect_SyncIO__interpret$1__Lcats_effect_kernel_Sync__Lcats_effect_SyncIO__O(F$1, x17);
    var this$9 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$1, F$1);
    var f = x18.andThen__F1__F1(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((sio$2) => $ps_Lcats_effect_SyncIO__interpret$1__Lcats_effect_kernel_Sync__Lcats_effect_SyncIO__O(F$1, sio$2))));
    return this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$9.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  }
  if ((sio instanceof $c_Lcats_effect_SyncIO$HandleErrorWith)) {
    var x13 = sio.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
    var x14 = sio.Lcats_effect_SyncIO$HandleErrorWith__f_f;
    var fa = $ps_Lcats_effect_SyncIO__interpret$1__Lcats_effect_kernel_Sync__Lcats_effect_SyncIO__O(F$1, x13);
    var f$1 = x14.andThen__F1__F1(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((sio$3) => $ps_Lcats_effect_SyncIO__interpret$1__Lcats_effect_kernel_Sync__Lcats_effect_SyncIO__O(F$1, sio$3))));
    return F$1.handleErrorWith__O__F1__O(fa, f$1);
  }
  matchAlts1: {
    matchAlts2: {
      if ((sio instanceof $c_Lcats_effect_SyncIO$Success)) {
        break matchAlts2;
      }
      if ((sio instanceof $c_Lcats_effect_SyncIO$Failure)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    $m_s_sys_package$().error__T__E("impossible");
  }
  if ((sio instanceof $c_Lcats_effect_SyncIO$Attempt)) {
    var x4 = sio.Lcats_effect_SyncIO$Attempt__f_ioa;
    var fa$1 = $ps_Lcats_effect_SyncIO__interpret$1__Lcats_effect_kernel_Sync__Lcats_effect_SyncIO__O(F$1, x4);
    return F$1.attempt__O__O(fa$1);
  }
  var x = $m_Lcats_effect_SyncIO$RealTime$();
  if ((x === sio)) {
    return F$1.realTime__O();
  }
  var x$3 = $m_Lcats_effect_SyncIO$Monotonic$();
  if ((x$3 === sio)) {
    return F$1.monotonic__O();
  }
  throw new $c_s_MatchError(sio);
}
export { $ps_Lcats_effect_SyncIO__interpret$1__Lcats_effect_kernel_Sync__Lcats_effect_SyncIO__O as $ps_Lcats_effect_SyncIO__interpret$1__Lcats_effect_kernel_Sync__Lcats_effect_SyncIO__O };
function $ps_Lcats_effect_SyncIO__runLoop$1__sjs_js_Array__sr_ObjectRef__Lcats_effect_SyncIO__O(objectState$1, conts$1, cur0) {
  var cur0$tailLocal1 = cur0;
  while (true) {
    var x34 = cur0$tailLocal1.tag__B();
    switch (x34) {
      case 0: {
        var cur = cur0$tailLocal1;
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, cur.Lcats_effect_SyncIO$Pure__f_value, 0);
        break;
      }
      case 1: {
        var cur$2 = cur0$tailLocal1;
        var error = null;
        try {
          var r = cur$2.Lcats_effect_SyncIO$Suspend__f_thunk.apply__O();
        } catch (e) {
          var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
          matchResult2: {
            if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
              error = e$2;
              break matchResult2;
            }
            throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
          }
          var r = (void 0);
        }
        var next = ((error === null) ? $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, r, 0) : $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$1, objectState$1, error, 0));
        cur0$tailLocal1 = next;
        break;
      }
      case 2: {
        var cur$3 = cur0$tailLocal1;
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$1, objectState$1, cur$3.Lcats_effect_SyncIO$Error__f_t, 0);
        break;
      }
      case 3: {
        var cur$4 = cur0$tailLocal1;
        var a = cur$4.Lcats_effect_SyncIO$Map__f_f;
        objectState$1.push(a);
        var stack = conts$1.sr_ObjectRef__f_elem;
        var c = (stack[0] | 0);
        var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < (stack.length | 0)) ? stack : (stack.push(0), stack));
        var s = ((1 + (c >> 3)) | 0);
        var shift = ((7 & c) << 2);
        use[s] = ((use[s] | 0) & (~((-1) << shift)));
        use[0] = ((1 + (use[0] | 0)) | 0);
        conts$1.sr_ObjectRef__f_elem = use;
        cur0$tailLocal1 = cur$4.Lcats_effect_SyncIO$Map__f_ioe;
        break;
      }
      case 4: {
        var cur$5 = cur0$tailLocal1;
        var a$1 = cur$5.Lcats_effect_SyncIO$FlatMap__f_f;
        objectState$1.push(a$1);
        var stack$1 = conts$1.sr_ObjectRef__f_elem;
        var c$1 = (stack$1[0] | 0);
        var use$1 = ((((1 + (((1 + c$1) | 0) >> 3)) | 0) < (stack$1.length | 0)) ? stack$1 : (stack$1.push(0), stack$1));
        var s$1 = ((1 + (c$1 >> 3)) | 0);
        var shift$1 = ((7 & c$1) << 2);
        use$1[s$1] = (((use$1[s$1] | 0) & (~((-1) << shift$1))) | (1 << shift$1));
        use$1[0] = ((1 + (use$1[0] | 0)) | 0);
        conts$1.sr_ObjectRef__f_elem = use$1;
        cur0$tailLocal1 = cur$5.Lcats_effect_SyncIO$FlatMap__f_ioe;
        break;
      }
      case 5: {
        var cur$6 = cur0$tailLocal1;
        var a$2 = cur$6.Lcats_effect_SyncIO$HandleErrorWith__f_f;
        objectState$1.push(a$2);
        var stack$2 = conts$1.sr_ObjectRef__f_elem;
        var c$2 = (stack$2[0] | 0);
        var use$2 = ((((1 + (((1 + c$2) | 0) >> 3)) | 0) < (stack$2.length | 0)) ? stack$2 : (stack$2.push(0), stack$2));
        var s$2 = ((1 + (c$2 >> 3)) | 0);
        var shift$2 = ((7 & c$2) << 2);
        use$2[s$2] = (((use$2[s$2] | 0) & (~((-1) << shift$2))) | (2 << shift$2));
        use$2[0] = ((1 + (use$2[0] | 0)) | 0);
        conts$1.sr_ObjectRef__f_elem = use$2;
        cur0$tailLocal1 = cur$6.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
        break;
      }
      case 6: {
        var cur$7 = cur0$tailLocal1;
        return cur$7.Lcats_effect_SyncIO$Success__f_value;
        break;
      }
      case 7: {
        var cur$8 = cur0$tailLocal1;
        var $x_1 = cur$8.Lcats_effect_SyncIO$Failure__f_t;
        throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
        break;
      }
      case 8: {
        var cur$9 = cur0$tailLocal1;
        var stack$3 = conts$1.sr_ObjectRef__f_elem;
        var c$3 = (stack$3[0] | 0);
        var use$3 = ((((1 + (((1 + c$3) | 0) >> 3)) | 0) < (stack$3.length | 0)) ? stack$3 : (stack$3.push(0), stack$3));
        var s$3 = ((1 + (c$3 >> 3)) | 0);
        var shift$3 = ((7 & c$3) << 2);
        use$3[s$3] = (((use$3[s$3] | 0) & (~((-1) << shift$3))) | (4 << shift$3));
        use$3[0] = ((1 + (use$3[0] | 0)) | 0);
        conts$1.sr_ObjectRef__f_elem = use$3;
        cur0$tailLocal1 = cur$9.Lcats_effect_SyncIO$Attempt__f_ioa;
        break;
      }
      case 9: {
        var value = (+Date.now());
        var this$9 = $m_RTLong$();
        var lo = this$9.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
        var hi = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$11 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo, hi));
        var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
        var t = this$11.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
        var lo$1 = t.RTLong__f_lo;
        var hi$1 = t.RTLong__f_hi;
        $m_s_concurrent_duration_Duration$();
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$1, hi$1), unit), 0);
        break;
      }
      case 10: {
        var value$1 = (1000000.0 * (+$m_jl_System$NanoTime$().jl_System$NanoTime$__f_highPrecisionTimer.now()));
        var this$15 = $m_RTLong$();
        var lo$2 = this$15.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value$1);
        var hi$2 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$17 = new $c_s_concurrent_duration_package$DurationLong(new $c_RTLong(lo$2, hi$2));
        var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
        var t$1 = this$17.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
        var lo$3 = t$1.RTLong__f_lo;
        var hi$3 = t$1.RTLong__f_hi;
        $m_s_concurrent_duration_Duration$();
        cur0$tailLocal1 = $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$1, objectState$1, new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$3, hi$3), unit$1), 0);
        break;
      }
      default: {
        throw new $c_s_MatchError(x34);
      }
    }
  }
}
export { $ps_Lcats_effect_SyncIO__runLoop$1__sjs_js_Array__sr_ObjectRef__Lcats_effect_SyncIO__O as $ps_Lcats_effect_SyncIO__runLoop$1__sjs_js_Array__sr_ObjectRef__Lcats_effect_SyncIO__O };
function $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$2, objectState$2, result, depth) {
  var depth$tailLocal1 = depth;
  var result$tailLocal1 = result;
  while (true) {
    var stack = conts$2.sr_ObjectRef__f_elem;
    var c = (((-1) + (stack[0] | 0)) | 0);
    if ((c < 0)) {
      throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (((stack[((1 + (c >> 3)) | 0)] | 0) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (((-1) + (stack[0] | 0)) | 0);
    switch (op) {
      case 0: {
        return $ps_Lcats_effect_SyncIO__mapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO(objectState$2, conts$2, result$tailLocal1, depth$tailLocal1);
        break;
      }
      case 1: {
        return $ps_Lcats_effect_SyncIO__flatMapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO(objectState$2, conts$2, result$tailLocal1, depth$tailLocal1);
        break;
      }
      case 2: {
        objectState$2.pop();
        break;
      }
      case 3: {
        var value = result$tailLocal1;
        return new $c_Lcats_effect_SyncIO$Success(value);
        break;
      }
      case 4: {
        var value$1 = result$tailLocal1;
        var result$tailLocal1$tmp1 = new $c_s_util_Right(value$1);
        var depth$tailLocal1$tmp1 = ((1 + depth$tailLocal1) | 0);
        result$tailLocal1 = result$tailLocal1$tmp1;
        depth$tailLocal1 = depth$tailLocal1$tmp1;
        break;
      }
      default: {
        throw new $c_s_MatchError(op);
      }
    }
  }
}
export { $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO as $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO };
function $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$3, objectState$3, error, depth) {
  while (true) {
    var stack = conts$3.sr_ObjectRef__f_elem;
    var c = (((-1) + (stack[0] | 0)) | 0);
    if ((c < 0)) {
      throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
    }
    var op = (((15 & (((stack[((1 + (c >> 3)) | 0)] | 0) >>> ((7 & c) << 2)) | 0)) << 24) >> 24);
    stack[0] = (((-1) + (stack[0] | 0)) | 0);
    switch (op) {
      case 0:
      case 1: {
        objectState$3.pop();
        break;
      }
      case 2: {
        return $ps_Lcats_effect_SyncIO__handleErrorWithK$1__sjs_js_Array__sr_ObjectRef__jl_Throwable__I__Lcats_effect_SyncIO(objectState$3, conts$3, error, depth);
        break;
      }
      case 3: {
        return new $c_Lcats_effect_SyncIO$Failure(error);
        break;
      }
      case 4: {
        return $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$3, objectState$3, new $c_s_util_Left(error), ((1 + depth) | 0));
        break;
      }
      default: {
        throw new $c_s_MatchError(op);
      }
    }
  }
}
export { $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO as $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO };
function $ps_Lcats_effect_SyncIO__mapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO(objectState$4, conts$4, result, depth) {
  var f = objectState$4.pop();
  var error = null;
  try {
    var transformed = f.apply__O__O(result);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchResult6: {
      if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
        error = e$2;
        break matchResult6;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
    var transformed = (void 0);
  }
  if ((depth > 512)) {
    if ((error === null)) {
      var $x_1 = new $c_Lcats_effect_SyncIO$Pure(transformed);
    } else {
      var t = error;
      var $x_1 = new $c_Lcats_effect_SyncIO$Error(t);
    }
    return $x_1;
  } else {
    return ((error === null) ? $ps_Lcats_effect_SyncIO__succeeded$1__sr_ObjectRef__sjs_js_Array__O__I__Lcats_effect_SyncIO(conts$4, objectState$4, transformed, ((1 + depth) | 0)) : $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$4, objectState$4, error, ((1 + depth) | 0)));
  }
}
export { $ps_Lcats_effect_SyncIO__mapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO as $ps_Lcats_effect_SyncIO__mapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO };
function $ps_Lcats_effect_SyncIO__flatMapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO(objectState$5, conts$5, result, depth) {
  var f = objectState$5.pop();
  try {
    return f.apply__O__O(result);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
      return $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$5, objectState$5, e$2, ((1 + depth) | 0));
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
}
export { $ps_Lcats_effect_SyncIO__flatMapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO as $ps_Lcats_effect_SyncIO__flatMapK$1__sjs_js_Array__sr_ObjectRef__O__I__Lcats_effect_SyncIO };
function $ps_Lcats_effect_SyncIO__handleErrorWithK$1__sjs_js_Array__sr_ObjectRef__jl_Throwable__I__Lcats_effect_SyncIO(objectState$6, conts$6, t, depth) {
  var f = objectState$6.pop();
  try {
    return f.apply__O__O(t);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_Lcats_effect_unsafe_UnsafeNonFatal$().apply__jl_Throwable__Z(e$2)) {
      return $ps_Lcats_effect_SyncIO__failed$1__sr_ObjectRef__sjs_js_Array__jl_Throwable__I__Lcats_effect_SyncIO(conts$6, objectState$6, e$2, ((1 + depth) | 0));
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
}
export { $ps_Lcats_effect_SyncIO__handleErrorWithK$1__sjs_js_Array__sr_ObjectRef__jl_Throwable__I__Lcats_effect_SyncIO as $ps_Lcats_effect_SyncIO__handleErrorWithK$1__sjs_js_Array__sr_ObjectRef__jl_Throwable__I__Lcats_effect_SyncIO };
/** @constructor */
function $c_Lcats_effect_SyncIO() {
}
export { $c_Lcats_effect_SyncIO as $c_Lcats_effect_SyncIO };
$c_Lcats_effect_SyncIO.prototype = new $h_O();
$c_Lcats_effect_SyncIO.prototype.constructor = $c_Lcats_effect_SyncIO;
/** @constructor */
function $h_Lcats_effect_SyncIO() {
}
export { $h_Lcats_effect_SyncIO as $h_Lcats_effect_SyncIO };
$h_Lcats_effect_SyncIO.prototype = $c_Lcats_effect_SyncIO.prototype;
$c_Lcats_effect_SyncIO.prototype.toString__T = (function() {
  return "SyncIO(...)";
});
$c_Lcats_effect_SyncIO.prototype.to__Lcats_effect_kernel_Sync__O = (function(F) {
  var wrapped = $ps_Lcats_effect_SyncIO__interpret$1__Lcats_effect_kernel_Sync__Lcats_effect_SyncIO__O(F, this);
  return $m_Lcats_effect_kernel_syntax_MonadCancelOps\uff3f$().uncancelable$extension__O__Lcats_effect_kernel_MonadCancel__O(wrapped, F);
});
$c_Lcats_effect_SyncIO.prototype.unsafeRunSync__O = (function() {
  var elem = [0];
  var conts = new $c_sr_ObjectRef(elem);
  var objectState = [];
  var stack = conts.sr_ObjectRef__f_elem;
  var c = (stack[0] | 0);
  var use = ((((1 + (((1 + c) | 0) >> 3)) | 0) < (stack.length | 0)) ? stack : (stack.push(0), stack));
  var s = ((1 + (c >> 3)) | 0);
  var shift = ((7 & c) << 2);
  use[s] = (((use[s] | 0) & (~((-1) << shift))) | (3 << shift));
  use[0] = ((1 + (use[0] | 0)) | 0);
  conts.sr_ObjectRef__f_elem = use;
  return $ps_Lcats_effect_SyncIO__runLoop$1__sjs_js_Array__sr_ObjectRef__Lcats_effect_SyncIO__O(objectState, conts, this);
});
/** @constructor */
function $c_Lcats_effect_kernel_Unique$Token() {
}
export { $c_Lcats_effect_kernel_Unique$Token as $c_Lcats_effect_kernel_Unique$Token };
$c_Lcats_effect_kernel_Unique$Token.prototype = new $h_O();
$c_Lcats_effect_kernel_Unique$Token.prototype.constructor = $c_Lcats_effect_kernel_Unique$Token;
/** @constructor */
function $h_Lcats_effect_kernel_Unique$Token() {
}
export { $h_Lcats_effect_kernel_Unique$Token as $h_Lcats_effect_kernel_Unique$Token };
$h_Lcats_effect_kernel_Unique$Token.prototype = $c_Lcats_effect_kernel_Unique$Token.prototype;
var $d_Lcats_effect_kernel_Unique$Token = new $TypeData().initClass($c_Lcats_effect_kernel_Unique$Token, "cats.effect.kernel.Unique$Token", ({
  Lcats_effect_kernel_Unique$Token: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_kernel_Unique$Token as $d_Lcats_effect_kernel_Unique$Token };
function $f_Lcats_kernel_Eq__neqv__O__O__Z($thiz, x, y) {
  return (!$thiz.eqv__O__O__Z(x, y));
}
export { $f_Lcats_kernel_Eq__neqv__O__O__Z as $f_Lcats_kernel_Eq__neqv__O__O__Z };
/** @constructor */
function $c_Lcats_kernel_HashFunctions() {
}
export { $c_Lcats_kernel_HashFunctions as $c_Lcats_kernel_HashFunctions };
$c_Lcats_kernel_HashFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_HashFunctions.prototype.constructor = $c_Lcats_kernel_HashFunctions;
/** @constructor */
function $h_Lcats_kernel_HashFunctions() {
}
export { $h_Lcats_kernel_HashFunctions as $h_Lcats_kernel_HashFunctions };
$h_Lcats_kernel_HashFunctions.prototype = $c_Lcats_kernel_HashFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_MonoidFunctions() {
}
export { $c_Lcats_kernel_MonoidFunctions as $c_Lcats_kernel_MonoidFunctions };
$c_Lcats_kernel_MonoidFunctions.prototype = new $h_Lcats_kernel_SemigroupFunctions();
$c_Lcats_kernel_MonoidFunctions.prototype.constructor = $c_Lcats_kernel_MonoidFunctions;
/** @constructor */
function $h_Lcats_kernel_MonoidFunctions() {
}
export { $h_Lcats_kernel_MonoidFunctions as $h_Lcats_kernel_MonoidFunctions };
$h_Lcats_kernel_MonoidFunctions.prototype = $c_Lcats_kernel_MonoidFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_PartialOrderFunctions() {
}
export { $c_Lcats_kernel_PartialOrderFunctions as $c_Lcats_kernel_PartialOrderFunctions };
$c_Lcats_kernel_PartialOrderFunctions.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_PartialOrderFunctions.prototype.constructor = $c_Lcats_kernel_PartialOrderFunctions;
/** @constructor */
function $h_Lcats_kernel_PartialOrderFunctions() {
}
export { $h_Lcats_kernel_PartialOrderFunctions as $h_Lcats_kernel_PartialOrderFunctions };
$h_Lcats_kernel_PartialOrderFunctions.prototype = $c_Lcats_kernel_PartialOrderFunctions.prototype;
/** @constructor */
function $c_Lcats_kernel_instances_StaticMethods$() {
}
export { $c_Lcats_kernel_instances_StaticMethods$ as $c_Lcats_kernel_instances_StaticMethods$ };
$c_Lcats_kernel_instances_StaticMethods$.prototype = new $h_Lcats_kernel_compat_HashCompat();
$c_Lcats_kernel_instances_StaticMethods$.prototype.constructor = $c_Lcats_kernel_instances_StaticMethods$;
/** @constructor */
function $h_Lcats_kernel_instances_StaticMethods$() {
}
export { $h_Lcats_kernel_instances_StaticMethods$ as $h_Lcats_kernel_instances_StaticMethods$ };
$h_Lcats_kernel_instances_StaticMethods$.prototype = $c_Lcats_kernel_instances_StaticMethods$.prototype;
$c_Lcats_kernel_instances_StaticMethods$.prototype.combineAllIterable__scm_Builder__sc_IterableOnce__O = (function(b, xs) {
  var this$1 = xs.iterator__sc_Iterator();
  while (this$1.hasNext__Z()) {
    var x0 = this$1.next__O();
    b.addAll__sc_IterableOnce__scm_Growable(x0);
  }
  return b.result__O();
});
var $d_Lcats_kernel_instances_StaticMethods$ = new $TypeData().initClass($c_Lcats_kernel_instances_StaticMethods$, "cats.kernel.instances.StaticMethods$", ({
  Lcats_kernel_instances_StaticMethods$: 1,
  Lcats_kernel_compat_HashCompat: 1
}));
export { $d_Lcats_kernel_instances_StaticMethods$ as $d_Lcats_kernel_instances_StaticMethods$ };
var $n_Lcats_kernel_instances_StaticMethods$;
function $m_Lcats_kernel_instances_StaticMethods$() {
  if ((!$n_Lcats_kernel_instances_StaticMethods$)) {
    $n_Lcats_kernel_instances_StaticMethods$ = new $c_Lcats_kernel_instances_StaticMethods$();
  }
  return $n_Lcats_kernel_instances_StaticMethods$;
}
export { $m_Lcats_kernel_instances_StaticMethods$ as $m_Lcats_kernel_instances_StaticMethods$ };
/** @constructor */
function $c_Lcats_kernel_instances_long_package$() {
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdOrderForLong = null;
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong = null;
  $n_Lcats_kernel_instances_long_package$ = this;
  $f_Lcats_kernel_instances_LongInstances__$init$__V(this);
}
export { $c_Lcats_kernel_instances_long_package$ as $c_Lcats_kernel_instances_long_package$ };
$c_Lcats_kernel_instances_long_package$.prototype = new $h_O();
$c_Lcats_kernel_instances_long_package$.prototype.constructor = $c_Lcats_kernel_instances_long_package$;
/** @constructor */
function $h_Lcats_kernel_instances_long_package$() {
}
export { $h_Lcats_kernel_instances_long_package$ as $h_Lcats_kernel_instances_long_package$ };
$h_Lcats_kernel_instances_long_package$.prototype = $c_Lcats_kernel_instances_long_package$.prototype;
$c_Lcats_kernel_instances_long_package$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdOrderForLong = x$0;
});
$c_Lcats_kernel_instances_long_package$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
  this.Lcats_kernel_instances_long_package$__f_catsKernelStdGroupForLong = x$0;
});
var $d_Lcats_kernel_instances_long_package$ = new $TypeData().initClass($c_Lcats_kernel_instances_long_package$, "cats.kernel.instances.long.package$", ({
  Lcats_kernel_instances_long_package$: 1,
  Lcats_kernel_instances_LongInstances: 1
}));
export { $d_Lcats_kernel_instances_long_package$ as $d_Lcats_kernel_instances_long_package$ };
var $n_Lcats_kernel_instances_long_package$;
function $m_Lcats_kernel_instances_long_package$() {
  if ((!$n_Lcats_kernel_instances_long_package$)) {
    $n_Lcats_kernel_instances_long_package$ = new $c_Lcats_kernel_instances_long_package$();
  }
  return $n_Lcats_kernel_instances_long_package$;
}
export { $m_Lcats_kernel_instances_long_package$ as $m_Lcats_kernel_instances_long_package$ };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
  $ct_jl_ThreadLocal__(this);
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1 as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1 };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1.prototype = new $h_jl_ThreadLocal();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1 as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1 };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1.prototype;
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1.prototype.initialValue__T3 = (function() {
  var buf = new $ac_B(512);
  var charBuf$1 = new $ac_C(512);
  $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$();
  var head$1 = 0;
  $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$();
  var tail$1 = 0;
  $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$();
  var mark$1 = (-1);
  $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$();
  var bbuf$1 = null;
  $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$();
  var in$1 = null;
  $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$();
  var t = $L0;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader$();
  var config$1 = null;
  return new $c_T3(new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader(buf, head$1, tail$1, mark$1, charBuf$1, bbuf$1, in$1, new $c_RTLong(lo, hi), config$1), buf, new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter(buf, ($m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$(), 0), ($m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$(), 32768), ($m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$(), 0), ($m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$(), false), ($m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$(), false), ($m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$(), null), ($m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$(), null), ($m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonWriter$(), null)));
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1.prototype.initialValue__O = (function() {
  return this.initialValue__T3();
});
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1 = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1, "com.github.plokhotnyuk.jsoniter_scala.circe.CirceCodecs$$anon$1", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1: 1,
  jl_ThreadLocal: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1 as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$1 };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig(preferredBufSize, preferredCharBufSize, maxBufSize, maxCharBufSize, checkForEndOfInput, throwReaderExceptionWithStackTrace, appendHexDumpToParseException, hexDumpSize) {
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredBufSize = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredCharBufSize = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxBufSize = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxCharBufSize = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_checkForEndOfInput = false;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_throwReaderExceptionWithStackTrace = false;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_appendHexDumpToParseException = false;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_hexDumpSize = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredBufSize = preferredBufSize;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredCharBufSize = preferredCharBufSize;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxBufSize = maxBufSize;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxCharBufSize = maxCharBufSize;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_checkForEndOfInput = checkForEndOfInput;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_throwReaderExceptionWithStackTrace = throwReaderExceptionWithStackTrace;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_appendHexDumpToParseException = appendHexDumpToParseException;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_hexDumpSize = hexDumpSize;
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig.prototype = new $h_O();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig.prototype;
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig.prototype.withMaxBufSize__I__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig = (function(maxBufSize) {
  if ((maxBufSize < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredBufSize)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "'maxBufSize' should be not less than 'preferredBufSize'");
  }
  if ((maxBufSize > 2147483645)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "'maxBufSize' should be not greater than 2147483645");
  }
  var preferredBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredBufSize;
  var preferredCharBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredCharBufSize;
  var maxCharBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxCharBufSize;
  var checkForEndOfInput = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_checkForEndOfInput;
  var throwReaderExceptionWithStackTrace = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_throwReaderExceptionWithStackTrace;
  var appendHexDumpToParseException = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_appendHexDumpToParseException;
  var hexDumpSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_hexDumpSize;
  return new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig(preferredBufSize, preferredCharBufSize, maxBufSize, maxCharBufSize, checkForEndOfInput, throwReaderExceptionWithStackTrace, appendHexDumpToParseException, hexDumpSize);
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig.prototype.withMaxCharBufSize__I__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig = (function(maxCharBufSize) {
  if ((maxCharBufSize < this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredCharBufSize)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "'maxCharBufSize' should be not less than 'preferredCharBufSize'");
  }
  if ((maxCharBufSize > 2147483645)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "'maxCharBufSize' should be not greater than 2147483645");
  }
  var preferredBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredBufSize;
  var preferredCharBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredCharBufSize;
  var maxBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxBufSize;
  var checkForEndOfInput = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_checkForEndOfInput;
  var throwReaderExceptionWithStackTrace = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_throwReaderExceptionWithStackTrace;
  var appendHexDumpToParseException = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_appendHexDumpToParseException;
  var hexDumpSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_hexDumpSize;
  return new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig(preferredBufSize, preferredCharBufSize, maxBufSize, maxCharBufSize, checkForEndOfInput, throwReaderExceptionWithStackTrace, appendHexDumpToParseException, hexDumpSize);
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig.prototype.withPreferredBufSize__I__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig = (function(preferredBufSize) {
  if ((preferredBufSize < 12)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "'preferredBufSize' should be not less than 12");
  }
  if ((preferredBufSize > this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxBufSize)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "'preferredBufSize' should be not greater than 'maxBufSize'");
  }
  var preferredCharBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredCharBufSize;
  var maxBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxBufSize;
  var maxCharBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxCharBufSize;
  var checkForEndOfInput = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_checkForEndOfInput;
  var throwReaderExceptionWithStackTrace = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_throwReaderExceptionWithStackTrace;
  var appendHexDumpToParseException = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_appendHexDumpToParseException;
  var hexDumpSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_hexDumpSize;
  return new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig(preferredBufSize, preferredCharBufSize, maxBufSize, maxCharBufSize, checkForEndOfInput, throwReaderExceptionWithStackTrace, appendHexDumpToParseException, hexDumpSize);
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig.prototype.withPreferredCharBufSize__I__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig = (function(preferredCharBufSize) {
  if ((preferredCharBufSize < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "'preferredCharBufSize' should be not less than 0");
  }
  if ((preferredCharBufSize > this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxCharBufSize)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "'preferredCharBufSize' should be not greater than 'maxCharBufSize'");
  }
  var preferredBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_preferredBufSize;
  var maxBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxBufSize;
  var maxCharBufSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_maxCharBufSize;
  var checkForEndOfInput = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_checkForEndOfInput;
  var throwReaderExceptionWithStackTrace = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_throwReaderExceptionWithStackTrace;
  var appendHexDumpToParseException = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_appendHexDumpToParseException;
  var hexDumpSize = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig__f_hexDumpSize;
  return new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig(preferredBufSize, preferredCharBufSize, maxBufSize, maxCharBufSize, checkForEndOfInput, throwReaderExceptionWithStackTrace, appendHexDumpToParseException, hexDumpSize);
});
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig, "com.github.plokhotnyuk.jsoniter_scala.core.ReaderConfig", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_ReaderConfig };
function $ct_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__I__I__Z__Z__($thiz, indentionStep, preferredBufSize, escapeUnicode, throwWriterExceptionWithStackTrace) {
  $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_indentionStep = indentionStep;
  $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_preferredBufSize = preferredBufSize;
  $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_escapeUnicode = escapeUnicode;
  $thiz.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_throwWriterExceptionWithStackTrace = throwWriterExceptionWithStackTrace;
  return $thiz;
}
export { $ct_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__I__I__Z__Z__ as $ct_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__I__I__Z__Z__ };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig() {
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_indentionStep = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_preferredBufSize = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_escapeUnicode = false;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_throwWriterExceptionWithStackTrace = false;
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig.prototype = new $h_O();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig.prototype;
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig.prototype.withPreferredBufSize__I__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig = (function(preferredBufSize) {
  if ((preferredBufSize <= 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "'preferredBufSize' should be not less than 1");
  }
  var indentionStep = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_indentionStep;
  var throwWriterExceptionWithStackTrace = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_throwWriterExceptionWithStackTrace;
  var escapeUnicode = this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_escapeUnicode;
  return $ct_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__I__I__Z__Z__(new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig(), indentionStep, preferredBufSize, escapeUnicode, throwWriterExceptionWithStackTrace);
});
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig, "com.github.plokhotnyuk.jsoniter_scala.core.WriterConfig", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig };
function $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  nextValue.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    $thiz.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(_$1, transaction);
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    $thiz.onNext__O__Lcom_raquo_airstream_core_Transaction__V(_$2, transaction);
  })));
}
export { $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V };
var $d_Lcom_raquo_airstream_common_InternalParentObserver = new $TypeData().initClass(1, "com.raquo.airstream.common.InternalParentObserver", ({
  Lcom_raquo_airstream_common_InternalParentObserver: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1
}));
export { $d_Lcom_raquo_airstream_common_InternalParentObserver as $d_Lcom_raquo_airstream_common_InternalParentObserver };
function $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  $thiz.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(new $c_s_util_Success(nextValue), transaction);
}
export { $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, nextError, transaction) {
  $thiz.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(new $c_s_util_Failure(nextError), transaction);
}
export { $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V };
/** @constructor */
function $c_Lcom_raquo_airstream_core_EventStream$() {
  this.Lcom_raquo_airstream_core_EventStream$__f_empty = null;
  $n_Lcom_raquo_airstream_core_EventStream$ = this;
  this.Lcom_raquo_airstream_core_EventStream$__f_empty = this.fromCustomSource__F1__F4__F1__Lcom_raquo_airstream_core_EventStream(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$10) => false)), new $c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b(((_$11, _$12, _$13, _$14) => (void 0))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v1) => (void 0))));
}
export { $c_Lcom_raquo_airstream_core_EventStream$ as $c_Lcom_raquo_airstream_core_EventStream$ };
$c_Lcom_raquo_airstream_core_EventStream$.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_EventStream$.prototype.constructor = $c_Lcom_raquo_airstream_core_EventStream$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_EventStream$() {
}
export { $h_Lcom_raquo_airstream_core_EventStream$ as $h_Lcom_raquo_airstream_core_EventStream$ };
$h_Lcom_raquo_airstream_core_EventStream$.prototype = $c_Lcom_raquo_airstream_core_EventStream$.prototype;
$c_Lcom_raquo_airstream_core_EventStream$.prototype.fromValue__O__Z__Lcom_raquo_airstream_core_EventStream = (function(event, emitOnce) {
  return this.fromCustomSource__F1__F4__F1__Lcom_raquo_airstream_core_EventStream(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((startIndex) => {
    var startIndex$1 = (startIndex | 0);
    return ((!emitOnce) || (startIndex$1 === 1));
  })), new $c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b(((fireEvent, _$20, _$21, _$22) => {
    fireEvent.apply__O__O(event);
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v1) => (void 0))));
});
$c_Lcom_raquo_airstream_core_EventStream$.prototype.fromFuture__F0__Z__s_concurrent_ExecutionContext__Lcom_raquo_airstream_core_EventStream = (function(future, emitOnce, ec) {
  var promise = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var f = future.apply__O();
    return $m_sjs_js_JSConverters$JSRichFuture$().toJSPromise$extension__s_concurrent_Future__s_concurrent_ExecutionContext__sjs_js_Promise(f, ec);
  }));
  return new $c_Lcom_raquo_airstream_timing_JsPromiseStream(promise, emitOnce);
});
$c_Lcom_raquo_airstream_core_EventStream$.prototype.fromCustomSource__F1__F4__F1__Lcom_raquo_airstream_core_EventStream = (function(shouldStart, start, stop) {
  return new $c_Lcom_raquo_airstream_custom_CustomStreamSource(new $c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b(((fireValue, fireError, getStartIndex, getIsStarted) => $m_Lcom_raquo_airstream_custom_CustomSource$Config$().apply__F0__F0__Lcom_raquo_airstream_custom_CustomSource$Config(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((fireValue$2, fireError$2, getStartIndex$2, getIsStarted$2) => (() => {
    start.apply__O__O__O__O__O(fireValue$2, fireError$2, getStartIndex$2, getIsStarted$2);
  }))(fireValue, fireError, getStartIndex, getIsStarted)), new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((getStartIndex$3) => (() => {
    stop.apply__O__O(getStartIndex$3.apply__O());
  }))(getStartIndex))).when__F0__Lcom_raquo_airstream_custom_CustomSource$Config(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((getStartIndex$4) => (() => (!(!shouldStart.apply__O__O(getStartIndex$4.apply__O())))))(getStartIndex))))));
});
$c_Lcom_raquo_airstream_core_EventStream$.prototype.delay__I__O__Z__Lcom_raquo_airstream_core_EventStream = (function(ms, event, emitOnce) {
  var this$1 = $m_Lcom_raquo_airstream_core_EventStream$().fromValue__O__Z__Lcom_raquo_airstream_core_EventStream(event, emitOnce);
  return new $c_Lcom_raquo_airstream_timing_DelayStream(this$1, ms);
});
$c_Lcom_raquo_airstream_core_EventStream$.prototype.periodic__I__Z__Lcom_raquo_airstream_timing_PeriodicStream = (function(intervalMs, resetOnStop) {
  return new $c_Lcom_raquo_airstream_timing_PeriodicStream(0, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((eventNumber) => {
    var eventNumber$1 = (eventNumber | 0);
    var _1 = ((1 + eventNumber$1) | 0);
    var value = $ct_T2__O__O__(new $c_T2(), _1, intervalMs);
    return new $c_s_Some(value);
  })), resetOnStop);
});
$c_Lcom_raquo_airstream_core_EventStream$.prototype.merge__sci_Seq__Lcom_raquo_airstream_core_EventStream = (function(streams) {
  return new $c_Lcom_raquo_airstream_combine_MergeStream($m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray(streams));
});
var $d_Lcom_raquo_airstream_core_EventStream$ = new $TypeData().initClass($c_Lcom_raquo_airstream_core_EventStream$, "com.raquo.airstream.core.EventStream$", ({
  Lcom_raquo_airstream_core_EventStream$: 1,
  Lcom_raquo_airstream_dynamicImport_StreamObjDynamicImportOps: 1
}));
export { $d_Lcom_raquo_airstream_core_EventStream$ as $d_Lcom_raquo_airstream_core_EventStream$ };
var $n_Lcom_raquo_airstream_core_EventStream$;
function $m_Lcom_raquo_airstream_core_EventStream$() {
  if ((!$n_Lcom_raquo_airstream_core_EventStream$)) {
    $n_Lcom_raquo_airstream_core_EventStream$ = new $c_Lcom_raquo_airstream_core_EventStream$();
  }
  return $n_Lcom_raquo_airstream_core_EventStream$;
}
export { $m_Lcom_raquo_airstream_core_EventStream$ as $m_Lcom_raquo_airstream_core_EventStream$ };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Signal$() {
  this.Lcom_raquo_airstream_core_Signal$__f_lastUpdateId = 0;
  this.Lcom_raquo_airstream_core_Signal$__f_lastUpdateId = 0;
}
export { $c_Lcom_raquo_airstream_core_Signal$ as $c_Lcom_raquo_airstream_core_Signal$ };
$c_Lcom_raquo_airstream_core_Signal$.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_Signal$.prototype.constructor = $c_Lcom_raquo_airstream_core_Signal$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Signal$() {
}
export { $h_Lcom_raquo_airstream_core_Signal$ as $h_Lcom_raquo_airstream_core_Signal$ };
$h_Lcom_raquo_airstream_core_Signal$.prototype = $c_Lcom_raquo_airstream_core_Signal$.prototype;
$c_Lcom_raquo_airstream_core_Signal$.prototype.fromFuture__F0__s_concurrent_ExecutionContext__Lcom_raquo_airstream_core_Signal = (function(future, ec) {
  var promise = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var f = future.apply__O();
    return $m_sjs_js_JSConverters$JSRichFuture$().toJSPromise$extension__s_concurrent_Future__s_concurrent_ExecutionContext__sjs_js_Promise(f, ec);
  }));
  return new $c_Lcom_raquo_airstream_timing_JsPromiseSignal(promise);
});
$c_Lcom_raquo_airstream_core_Signal$.prototype.nextUpdateId__I = (function() {
  if ((this.Lcom_raquo_airstream_core_Signal$__f_lastUpdateId === 2147483647)) {
    this.Lcom_raquo_airstream_core_Signal$__f_lastUpdateId = 1;
  } else {
    this.Lcom_raquo_airstream_core_Signal$__f_lastUpdateId = ((1 + this.Lcom_raquo_airstream_core_Signal$__f_lastUpdateId) | 0);
  }
  return this.Lcom_raquo_airstream_core_Signal$__f_lastUpdateId;
});
var $d_Lcom_raquo_airstream_core_Signal$ = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Signal$, "com.raquo.airstream.core.Signal$", ({
  Lcom_raquo_airstream_core_Signal$: 1,
  Lcom_raquo_airstream_dynamicImport_SignalObjDynamicImportOps: 1
}));
export { $d_Lcom_raquo_airstream_core_Signal$ as $d_Lcom_raquo_airstream_core_Signal$ };
var $n_Lcom_raquo_airstream_core_Signal$;
function $m_Lcom_raquo_airstream_core_Signal$() {
  if ((!$n_Lcom_raquo_airstream_core_Signal$)) {
    $n_Lcom_raquo_airstream_core_Signal$ = new $c_Lcom_raquo_airstream_core_Signal$();
  }
  return $n_Lcom_raquo_airstream_core_Signal$;
}
export { $m_Lcom_raquo_airstream_core_Signal$ as $m_Lcom_raquo_airstream_core_Signal$ };
function $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V($thiz, subscription) {
  var index = ($thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_subscriptions.indexOf(subscription) | 0);
  if ((index !== (-1))) {
    if ((!$m_Lcom_raquo_airstream_ownership_DynamicOwner$().Lcom_raquo_airstream_ownership_DynamicOwner$__f_TEMP_UNSAFE_USE_PRE_V18_DELAYED_DYNSUB_REMOVAL)) {
      if (($thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_numRemovedSubs !== (-1))) {
        var numSubsRemovedFromList = ($m_Lcom_raquo_airstream_ownership_DynamicOwner$().Lcom_raquo_airstream_ownership_DynamicOwner$__f_TEMP_UNSAFE_USE_PRE_V18_DELAYED_DYNSUB_REMOVAL ? 0 : $thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_numRemovedSubs);
        var $x_1 = (index < (((($thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_numPrependedSubs + $thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_initialNumSubs) | 0) - numSubsRemovedFromList) | 0));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        $thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_numRemovedSubs = ((1 + $thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_numRemovedSubs) | 0);
      }
      if ((($thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx !== (-1)) && ($thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx >= index))) {
        $thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx = (((-1) + $thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx) | 0);
      }
    }
    $thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_subscriptions.splice(index, 1);
    var this$1 = $thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
    if ((!this$1.isEmpty__Z())) {
      subscription.onDeactivate__V();
    }
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Can not remove DynamicSubscription from DynamicOwner: subscription not found. Did you already kill it?");
  }
}
export { $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V as $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V };
function $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V($thiz) {
  while ((($thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_pendingSubscriptionRemovals.length | 0) > 0)) {
    var subscriptionToRemove = $thiz.Lcom_raquo_airstream_ownership_DynamicOwner__f_pendingSubscriptionRemovals.shift();
    $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V($thiz, subscriptionToRemove);
  }
}
export { $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V as $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V };
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_DynamicOwner(onAccessAfterKilled) {
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_onAccessAfterKilled = null;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_subscriptions = null;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_isSafeToRemoveSubscription = false;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_pendingSubscriptionRemovals = null;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner = null;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_initialNumSubs = 0;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numPrependedSubs = 0;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx = 0;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numRemovedSubs = 0;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_onAccessAfterKilled = onAccessAfterKilled;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_maybeDisplayName = (void 0);
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_subscriptions = $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_ownership_DynamicSubscription.getArrayOf().constr)([])));
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_isSafeToRemoveSubscription = true;
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_pendingSubscriptionRemovals = $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_ownership_DynamicSubscription.getArrayOf().constr)([])));
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner = $m_s_None$();
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_initialNumSubs = (-1);
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numPrependedSubs = (-1);
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx = (-1);
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numRemovedSubs = (-1);
}
export { $c_Lcom_raquo_airstream_ownership_DynamicOwner as $c_Lcom_raquo_airstream_ownership_DynamicOwner };
$c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype = new $h_O();
$c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype.constructor = $c_Lcom_raquo_airstream_ownership_DynamicOwner;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_DynamicOwner() {
}
export { $h_Lcom_raquo_airstream_ownership_DynamicOwner as $h_Lcom_raquo_airstream_ownership_DynamicOwner };
$h_Lcom_raquo_airstream_ownership_DynamicOwner.prototype = $c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype;
$c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_ownership_DynamicOwner__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_ownership_DynamicOwner__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype.activate__V = (function() {
  var this$1 = this.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
  if ((!(!this$1.isEmpty__Z()))) {
    var this$4 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
    var f = (() => {
      var newOwner = new $c_Lcom_raquo_airstream_ownership_OneTimeOwner(this.Lcom_raquo_airstream_ownership_DynamicOwner__f_onAccessAfterKilled);
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner = new $c_s_Some(newOwner);
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numPrependedSubs = 0;
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx = 0;
      if ($m_Lcom_raquo_airstream_ownership_DynamicOwner$().Lcom_raquo_airstream_ownership_DynamicOwner$__f_TEMP_UNSAFE_USE_PRE_V18_DELAYED_DYNSUB_REMOVAL) {
        this.Lcom_raquo_airstream_ownership_DynamicOwner__f_isSafeToRemoveSubscription = false;
      } else {
        this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numRemovedSubs = 0;
      }
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f_initialNumSubs = (this.Lcom_raquo_airstream_ownership_DynamicOwner__f_subscriptions.length | 0);
      while (true) {
        var $x_1 = this.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx;
        var numSubsRemovedFromList = ($m_Lcom_raquo_airstream_ownership_DynamicOwner$().Lcom_raquo_airstream_ownership_DynamicOwner$__f_TEMP_UNSAFE_USE_PRE_V18_DELAYED_DYNSUB_REMOVAL ? 0 : this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numRemovedSubs);
        if (($x_1 < ((((this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numPrependedSubs + this.Lcom_raquo_airstream_ownership_DynamicOwner__f_initialNumSubs) | 0) - numSubsRemovedFromList) | 0))) {
          var sub = this.Lcom_raquo_airstream_ownership_DynamicOwner__f_subscriptions[this.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx];
          sub.onActivate__Lcom_raquo_airstream_ownership_Owner__V(newOwner);
          this.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx = ((1 + this.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx) | 0);
        } else {
          break;
        }
      }
      if ($m_Lcom_raquo_airstream_ownership_DynamicOwner$().Lcom_raquo_airstream_ownership_DynamicOwner$__f_TEMP_UNSAFE_USE_PRE_V18_DELAYED_DYNSUB_REMOVAL) {
        $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V(this);
        this.Lcom_raquo_airstream_ownership_DynamicOwner__f_isSafeToRemoveSubscription = true;
      } else {
        this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numRemovedSubs = (-1);
      }
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numPrependedSubs = (-1);
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx = (-1);
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f_initialNumSubs = (-1);
    });
    $m_Lcom_raquo_airstream_core_Transaction$onStart$();
    var when = true;
    if ((this$4.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart || (!when))) {
      f();
    } else {
      this$4.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = true;
      try {
        f();
      } finally {
        this$4.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = false;
        $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$4);
      }
    }
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), (("Can not activate " + this) + ": it is already active"));
  }
});
$c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype.deactivate__V = (function() {
  var this$1 = this.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
  if ((!this$1.isEmpty__Z())) {
    var this$6 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
    var f = (() => {
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f_isSafeToRemoveSubscription = false;
      var arr = this.Lcom_raquo_airstream_ownership_DynamicOwner__f_subscriptions;
      var i = 0;
      var len = (arr.length | 0);
      while ((i < len)) {
        var _$1 = arr[i];
        _$1.onDeactivate__V();
        i = ((1 + i) | 0);
      }
      $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V(this);
      var this$5 = this.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
      if ((!this$5.isEmpty__Z())) {
        var x0 = this$5.get__O();
        x0.killSubscriptions__V();
      }
      $p_Lcom_raquo_airstream_ownership_DynamicOwner__removePendingSubscriptionsNow__V(this);
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f_isSafeToRemoveSubscription = true;
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner = $m_s_None$();
    });
    $m_Lcom_raquo_airstream_core_Transaction$onStart$();
    var when = true;
    if ((this$6.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart || (!when))) {
      f();
    } else {
      this$6.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = true;
      try {
        f();
      } finally {
        this$6.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = false;
        $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$6);
      }
    }
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), (("Can not deactivate " + this) + ": it is not active"));
  }
});
$c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype.addSubscription__Lcom_raquo_airstream_ownership_DynamicSubscription__Z__V = (function(subscription, prepend) {
  if (prepend) {
    if ((this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numPrependedSubs !== (-1))) {
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numPrependedSubs = ((1 + this.Lcom_raquo_airstream_ownership_DynamicOwner__f_numPrependedSubs) | 0);
      this.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx = ((1 + this.Lcom_raquo_airstream_ownership_DynamicOwner__f_activationSubIx) | 0);
    }
    this.Lcom_raquo_airstream_ownership_DynamicOwner__f_subscriptions.unshift(subscription);
  } else {
    this.Lcom_raquo_airstream_ownership_DynamicOwner__f_subscriptions.push(subscription);
  }
  var this$1 = this.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
  if ((!this$1.isEmpty__Z())) {
    var x0 = this$1.get__O();
    subscription.onActivate__Lcom_raquo_airstream_ownership_Owner__V(x0);
  }
});
$c_Lcom_raquo_airstream_ownership_DynamicOwner.prototype.removeSubscription__Lcom_raquo_airstream_ownership_DynamicSubscription__V = (function(subscription) {
  if (this.Lcom_raquo_airstream_ownership_DynamicOwner__f_isSafeToRemoveSubscription) {
    $p_Lcom_raquo_airstream_ownership_DynamicOwner__removeSubscriptionNow__Lcom_raquo_airstream_ownership_DynamicSubscription__V(this, subscription);
  } else {
    this.Lcom_raquo_airstream_ownership_DynamicOwner__f_pendingSubscriptionRemovals.push(subscription);
  }
});
var $d_Lcom_raquo_airstream_ownership_DynamicOwner = new $TypeData().initClass($c_Lcom_raquo_airstream_ownership_DynamicOwner, "com.raquo.airstream.ownership.DynamicOwner", ({
  Lcom_raquo_airstream_ownership_DynamicOwner: 1,
  Lcom_raquo_airstream_core_Named: 1
}));
export { $d_Lcom_raquo_airstream_ownership_DynamicOwner as $d_Lcom_raquo_airstream_ownership_DynamicOwner };
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_DynamicSubscription(dynamicOwner, activate, prepend) {
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_dynamicOwner = null;
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_activate = null;
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_maybeCurrentSubscription = null;
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_isPendingDeactivation = false;
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_dynamicOwner = dynamicOwner;
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_activate = activate;
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_maybeDisplayName = (void 0);
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_maybeCurrentSubscription = $m_s_None$();
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_isPendingDeactivation = false;
  dynamicOwner.addSubscription__Lcom_raquo_airstream_ownership_DynamicSubscription__Z__V(this, prepend);
}
export { $c_Lcom_raquo_airstream_ownership_DynamicSubscription as $c_Lcom_raquo_airstream_ownership_DynamicSubscription };
$c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype = new $h_O();
$c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype.constructor = $c_Lcom_raquo_airstream_ownership_DynamicSubscription;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_DynamicSubscription() {
}
export { $h_Lcom_raquo_airstream_ownership_DynamicSubscription as $h_Lcom_raquo_airstream_ownership_DynamicSubscription };
$h_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype = $c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype;
$c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype.kill__V = (function() {
  this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_dynamicOwner.removeSubscription__Lcom_raquo_airstream_ownership_DynamicSubscription__V(this);
});
$c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype.onActivate__Lcom_raquo_airstream_ownership_Owner__V = (function(owner) {
  var this$2 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_isPendingDeactivation = false;
    this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_maybeCurrentSubscription = this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_activate.apply__O__O(owner);
    if (this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_isPendingDeactivation) {
      this.onDeactivate__V();
      this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_isPendingDeactivation = false;
    }
  });
  $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var when = true;
  if ((this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart || (!when))) {
    f();
  } else {
    this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = true;
    try {
      f();
    } finally {
      this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = false;
      $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$2);
    }
  }
});
$c_Lcom_raquo_airstream_ownership_DynamicSubscription.prototype.onDeactivate__V = (function() {
  var this$3 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    var this$2 = this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_maybeCurrentSubscription;
    if (this$2.isEmpty__Z()) {
      this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_isPendingDeactivation = true;
    } else {
      var x0 = this$2.get__O();
      x0.kill__V();
      this.Lcom_raquo_airstream_ownership_DynamicSubscription__f_maybeCurrentSubscription = $m_s_None$();
    }
  });
  $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var when = true;
  if ((this$3.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart || (!when))) {
    f();
  } else {
    this$3.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = true;
    try {
      f();
    } finally {
      this$3.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = false;
      $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$3);
    }
  }
});
var $d_Lcom_raquo_airstream_ownership_DynamicSubscription = new $TypeData().initClass($c_Lcom_raquo_airstream_ownership_DynamicSubscription, "com.raquo.airstream.ownership.DynamicSubscription", ({
  Lcom_raquo_airstream_ownership_DynamicSubscription: 1,
  Lcom_raquo_airstream_core_Named: 1
}));
export { $d_Lcom_raquo_airstream_ownership_DynamicSubscription as $d_Lcom_raquo_airstream_ownership_DynamicSubscription };
function $f_Lcom_raquo_airstream_ownership_Owner__$init$__V($thiz) {
  $thiz.com$raquo$airstream$ownership$Owner$_setter_$subscriptions_$eq__Lcom_raquo_ew_JsArray__V($m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_ownership_Subscription.getArrayOf().constr)([]))));
}
export { $f_Lcom_raquo_airstream_ownership_Owner__$init$__V as $f_Lcom_raquo_airstream_ownership_Owner__$init$__V };
function $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V($thiz) {
  var arr = $thiz.subscriptions__Lcom_raquo_ew_JsArray();
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$1 = arr[i];
    $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V(_$1);
    i = ((1 + i) | 0);
  }
  $thiz.subscriptions__Lcom_raquo_ew_JsArray().length = 0;
}
export { $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V as $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V };
function $f_Lcom_raquo_airstream_ownership_Owner__onKilledExternally__Lcom_raquo_airstream_ownership_Subscription__V($thiz, subscription) {
  var index = ($thiz.subscriptions__Lcom_raquo_ew_JsArray().indexOf(subscription) | 0);
  if ((index !== (-1))) {
    $thiz.subscriptions__Lcom_raquo_ew_JsArray().splice(index, 1);
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Can not remove Subscription from Owner: subscription not found.");
  }
}
export { $f_Lcom_raquo_airstream_ownership_Owner__onKilledExternally__Lcom_raquo_airstream_ownership_Subscription__V as $f_Lcom_raquo_airstream_ownership_Owner__onKilledExternally__Lcom_raquo_airstream_ownership_Subscription__V };
function $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V($thiz, subscription) {
  $thiz.subscriptions__Lcom_raquo_ew_JsArray().push(subscription);
}
export { $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V as $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V };
function $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V($thiz) {
  if ((!$thiz.Lcom_raquo_airstream_ownership_Subscription__f__isKilled)) {
    $thiz.Lcom_raquo_airstream_ownership_Subscription__f_cleanup.apply__O();
    $thiz.Lcom_raquo_airstream_ownership_Subscription__f__isKilled = true;
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Can not kill Subscription: it was already killed.");
  }
}
export { $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V as $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V };
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_Subscription(owner, cleanup) {
  this.Lcom_raquo_airstream_ownership_Subscription__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_ownership_Subscription__f_owner = null;
  this.Lcom_raquo_airstream_ownership_Subscription__f_cleanup = null;
  this.Lcom_raquo_airstream_ownership_Subscription__f__isKilled = false;
  this.Lcom_raquo_airstream_ownership_Subscription__f_owner = owner;
  this.Lcom_raquo_airstream_ownership_Subscription__f_cleanup = cleanup;
  this.Lcom_raquo_airstream_ownership_Subscription__f_maybeDisplayName = (void 0);
  this.Lcom_raquo_airstream_ownership_Subscription__f__isKilled = false;
  owner.own__Lcom_raquo_airstream_ownership_Subscription__V(this);
}
export { $c_Lcom_raquo_airstream_ownership_Subscription as $c_Lcom_raquo_airstream_ownership_Subscription };
$c_Lcom_raquo_airstream_ownership_Subscription.prototype = new $h_O();
$c_Lcom_raquo_airstream_ownership_Subscription.prototype.constructor = $c_Lcom_raquo_airstream_ownership_Subscription;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_Subscription() {
}
export { $h_Lcom_raquo_airstream_ownership_Subscription as $h_Lcom_raquo_airstream_ownership_Subscription };
$h_Lcom_raquo_airstream_ownership_Subscription.prototype = $c_Lcom_raquo_airstream_ownership_Subscription.prototype;
$c_Lcom_raquo_airstream_ownership_Subscription.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_ownership_Subscription__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_ownership_Subscription.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_ownership_Subscription__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_ownership_Subscription.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_ownership_Subscription.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_ownership_Subscription.prototype.kill__V = (function() {
  $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V(this);
  $f_Lcom_raquo_airstream_ownership_Owner__onKilledExternally__Lcom_raquo_airstream_ownership_Subscription__V(this.Lcom_raquo_airstream_ownership_Subscription__f_owner, this);
});
var $d_Lcom_raquo_airstream_ownership_Subscription = new $TypeData().initClass($c_Lcom_raquo_airstream_ownership_Subscription, "com.raquo.airstream.ownership.Subscription", ({
  Lcom_raquo_airstream_ownership_Subscription: 1,
  Lcom_raquo_airstream_core_Named: 1
}));
export { $d_Lcom_raquo_airstream_ownership_Subscription as $d_Lcom_raquo_airstream_ownership_Subscription };
/** @constructor */
function $c_Lcom_raquo_laminar_api_Laminar$aria$(outer) {
  this.Lcom_raquo_laminar_api_Laminar$aria$__f_label$lzy1 = null;
  this.Lcom_raquo_laminar_api_Laminar$aria$__f_labelbitmap$1 = false;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Lcom_raquo_laminar_api_Laminar$aria$ as $c_Lcom_raquo_laminar_api_Laminar$aria$ };
$c_Lcom_raquo_laminar_api_Laminar$aria$.prototype = new $h_O();
$c_Lcom_raquo_laminar_api_Laminar$aria$.prototype.constructor = $c_Lcom_raquo_laminar_api_Laminar$aria$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Laminar$aria$() {
}
export { $h_Lcom_raquo_laminar_api_Laminar$aria$ as $h_Lcom_raquo_laminar_api_Laminar$aria$ };
$h_Lcom_raquo_laminar_api_Laminar$aria$.prototype = $c_Lcom_raquo_laminar_api_Laminar$aria$.prototype;
$c_Lcom_raquo_laminar_api_Laminar$aria$.prototype.label__Lcom_raquo_laminar_keys_AriaAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_Laminar$aria$__f_labelbitmap$1)) {
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_Laminar$aria$__f_label$lzy1 = new $c_Lcom_raquo_laminar_keys_AriaAttr("label", codec);
    this.Lcom_raquo_laminar_api_Laminar$aria$__f_labelbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_Laminar$aria$__f_label$lzy1;
});
var $d_Lcom_raquo_laminar_api_Laminar$aria$ = new $TypeData().initClass($c_Lcom_raquo_laminar_api_Laminar$aria$, "com.raquo.laminar.api.Laminar$aria$", ({
  Lcom_raquo_laminar_api_Laminar$aria$: 1,
  Lcom_raquo_laminar_defs_attrs_AriaAttrs: 1
}));
export { $d_Lcom_raquo_laminar_api_Laminar$aria$ as $d_Lcom_raquo_laminar_api_Laminar$aria$ };
/** @constructor */
function $c_Lcom_raquo_laminar_codecs_Codec$$anon$3() {
}
export { $c_Lcom_raquo_laminar_codecs_Codec$$anon$3 as $c_Lcom_raquo_laminar_codecs_Codec$$anon$3 };
$c_Lcom_raquo_laminar_codecs_Codec$$anon$3.prototype = new $h_O();
$c_Lcom_raquo_laminar_codecs_Codec$$anon$3.prototype.constructor = $c_Lcom_raquo_laminar_codecs_Codec$$anon$3;
/** @constructor */
function $h_Lcom_raquo_laminar_codecs_Codec$$anon$3() {
}
export { $h_Lcom_raquo_laminar_codecs_Codec$$anon$3 as $h_Lcom_raquo_laminar_codecs_Codec$$anon$3 };
$h_Lcom_raquo_laminar_codecs_Codec$$anon$3.prototype = $c_Lcom_raquo_laminar_codecs_Codec$$anon$3.prototype;
$c_Lcom_raquo_laminar_codecs_Codec$$anon$3.prototype.encode__O__O = (function(scalaValue) {
  return scalaValue;
});
$c_Lcom_raquo_laminar_codecs_Codec$$anon$3.prototype.decode__O__O = (function(domValue) {
  return domValue;
});
var $d_Lcom_raquo_laminar_codecs_Codec$$anon$3 = new $TypeData().initClass($c_Lcom_raquo_laminar_codecs_Codec$$anon$3, "com.raquo.laminar.codecs.Codec$$anon$3", ({
  Lcom_raquo_laminar_codecs_Codec$$anon$3: 1,
  Lcom_raquo_laminar_codecs_Codec: 1
}));
export { $d_Lcom_raquo_laminar_codecs_Codec$$anon$3 as $d_Lcom_raquo_laminar_codecs_Codec$$anon$3 };
/** @constructor */
function $c_Lcom_raquo_laminar_codecs_Codec$$anon$4() {
}
export { $c_Lcom_raquo_laminar_codecs_Codec$$anon$4 as $c_Lcom_raquo_laminar_codecs_Codec$$anon$4 };
$c_Lcom_raquo_laminar_codecs_Codec$$anon$4.prototype = new $h_O();
$c_Lcom_raquo_laminar_codecs_Codec$$anon$4.prototype.constructor = $c_Lcom_raquo_laminar_codecs_Codec$$anon$4;
/** @constructor */
function $h_Lcom_raquo_laminar_codecs_Codec$$anon$4() {
}
export { $h_Lcom_raquo_laminar_codecs_Codec$$anon$4 as $h_Lcom_raquo_laminar_codecs_Codec$$anon$4 };
$h_Lcom_raquo_laminar_codecs_Codec$$anon$4.prototype = $c_Lcom_raquo_laminar_codecs_Codec$$anon$4.prototype;
$c_Lcom_raquo_laminar_codecs_Codec$$anon$4.prototype.decode__T__I = (function(domValue) {
  var this$3 = $m_jl_Integer$();
  return this$3.java$lang$Integer$$parseIntImpl__T__I__I__I(domValue, 10, 214748364);
});
$c_Lcom_raquo_laminar_codecs_Codec$$anon$4.prototype.decode__O__O = (function(domValue) {
  return this.decode__T__I(domValue);
});
$c_Lcom_raquo_laminar_codecs_Codec$$anon$4.prototype.encode__O__O = (function(scalaValue) {
  var scalaValue$1 = (scalaValue | 0);
  return ("" + scalaValue$1);
});
var $d_Lcom_raquo_laminar_codecs_Codec$$anon$4 = new $TypeData().initClass($c_Lcom_raquo_laminar_codecs_Codec$$anon$4, "com.raquo.laminar.codecs.Codec$$anon$4", ({
  Lcom_raquo_laminar_codecs_Codec$$anon$4: 1,
  Lcom_raquo_laminar_codecs_Codec: 1
}));
export { $d_Lcom_raquo_laminar_codecs_Codec$$anon$4 as $d_Lcom_raquo_laminar_codecs_Codec$$anon$4 };
/** @constructor */
function $c_Lcom_raquo_laminar_codecs_CompositeCodec(separator) {
  this.Lcom_raquo_laminar_codecs_CompositeCodec__f_separator = null;
  this.Lcom_raquo_laminar_codecs_CompositeCodec__f_separator = separator;
}
export { $c_Lcom_raquo_laminar_codecs_CompositeCodec as $c_Lcom_raquo_laminar_codecs_CompositeCodec };
$c_Lcom_raquo_laminar_codecs_CompositeCodec.prototype = new $h_O();
$c_Lcom_raquo_laminar_codecs_CompositeCodec.prototype.constructor = $c_Lcom_raquo_laminar_codecs_CompositeCodec;
/** @constructor */
function $h_Lcom_raquo_laminar_codecs_CompositeCodec() {
}
export { $h_Lcom_raquo_laminar_codecs_CompositeCodec as $h_Lcom_raquo_laminar_codecs_CompositeCodec };
$h_Lcom_raquo_laminar_codecs_CompositeCodec.prototype = $c_Lcom_raquo_laminar_codecs_CompositeCodec.prototype;
$c_Lcom_raquo_laminar_codecs_CompositeCodec.prototype.decode__T__sci_List = (function(domValue) {
  return $m_Lcom_raquo_laminar_codecs_CompositeCodec$().normalize__T__T__sci_List(domValue, this.Lcom_raquo_laminar_codecs_CompositeCodec__f_separator);
});
$c_Lcom_raquo_laminar_codecs_CompositeCodec.prototype.encode__sc_Iterable__T = (function(scalaValue) {
  var sep = this.Lcom_raquo_laminar_codecs_CompositeCodec__f_separator;
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(scalaValue, "", sep, "");
});
$c_Lcom_raquo_laminar_codecs_CompositeCodec.prototype.decode__O__O = (function(domValue) {
  return this.decode__T__sci_List(domValue);
});
$c_Lcom_raquo_laminar_codecs_CompositeCodec.prototype.encode__O__O = (function(scalaValue) {
  return this.encode__sc_Iterable__T(scalaValue);
});
var $d_Lcom_raquo_laminar_codecs_CompositeCodec = new $TypeData().initClass($c_Lcom_raquo_laminar_codecs_CompositeCodec, "com.raquo.laminar.codecs.CompositeCodec", ({
  Lcom_raquo_laminar_codecs_CompositeCodec: 1,
  Lcom_raquo_laminar_codecs_Codec: 1
}));
export { $d_Lcom_raquo_laminar_codecs_CompositeCodec as $d_Lcom_raquo_laminar_codecs_CompositeCodec };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeAttr(name, separator) {
  this.Lcom_raquo_laminar_keys_CompositeKey__f_codec = null;
  this.Lcom_raquo_laminar_keys_CompositeAttr__f_name = null;
  this.Lcom_raquo_laminar_keys_CompositeAttr__f_separator = null;
  this.Lcom_raquo_laminar_keys_CompositeAttr__f_name = name;
  this.Lcom_raquo_laminar_keys_CompositeAttr__f_separator = separator;
  $ct_Lcom_raquo_laminar_keys_CompositeKey__(this);
}
export { $c_Lcom_raquo_laminar_keys_CompositeAttr as $c_Lcom_raquo_laminar_keys_CompositeAttr };
$c_Lcom_raquo_laminar_keys_CompositeAttr.prototype = new $h_Lcom_raquo_laminar_keys_CompositeKey();
$c_Lcom_raquo_laminar_keys_CompositeAttr.prototype.constructor = $c_Lcom_raquo_laminar_keys_CompositeAttr;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeAttr() {
}
export { $h_Lcom_raquo_laminar_keys_CompositeAttr as $h_Lcom_raquo_laminar_keys_CompositeAttr };
$h_Lcom_raquo_laminar_keys_CompositeAttr.prototype = $c_Lcom_raquo_laminar_keys_CompositeAttr.prototype;
var $d_Lcom_raquo_laminar_keys_CompositeAttr = new $TypeData().initClass($c_Lcom_raquo_laminar_keys_CompositeAttr, "com.raquo.laminar.keys.CompositeAttr", ({
  Lcom_raquo_laminar_keys_CompositeAttr: 1,
  Lcom_raquo_laminar_keys_CompositeKey: 1
}));
export { $d_Lcom_raquo_laminar_keys_CompositeAttr as $d_Lcom_raquo_laminar_keys_CompositeAttr };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$ as $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$ };
$c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$.prototype = new $h_O();
$c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$.prototype.constructor = $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$() {
}
export { $h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$ as $h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$ };
$h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$.prototype = $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$.prototype;
$c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$.prototype.toNormalizedList__sc_Seq__T__sci_List = (function(items, separator) {
  var this$3 = items.toList__sci_List();
  var this$2 = $m_s_$less$colon$less$();
  var toIterableOnce = this$2.s_$less$colon$less$__f_singleton;
  var this$4 = $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$3, toIterableOnce);
  var rest = this$4;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.head__O();
    var it = $m_Lcom_raquo_laminar_codecs_CompositeCodec$().normalize__T__T__sci_List(x0, separator).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $m_sci_Nil$() : h);
});
$c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$.prototype.toNormalizedList__O__T__sci_List = (function(value, separator) {
  return this.toNormalizedList__sc_Seq__T__sci_List(value, separator);
});
var $d_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$ = new $TypeData().initClass($c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$, "com.raquo.laminar.keys.CompositeValueMapper$Implicits$StringSeqSeqValueMapper$", ({
  Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$: 1,
  Lcom_raquo_laminar_keys_CompositeValueMapper: 1
}));
export { $d_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$ as $d_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$ };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$ as $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$ };
$c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$.prototype = new $h_O();
$c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$.prototype.constructor = $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$() {
}
export { $h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$ as $h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$ };
$h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$.prototype = $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$.prototype;
$c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$.prototype.toNormalizedList__sc_Seq__T__sci_List = (function(items, separator) {
  var this$1 = items.toList__sci_List();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.head__O();
    var it = $m_Lcom_raquo_laminar_codecs_CompositeCodec$().normalize__T__T__sci_List(x0, separator).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $m_sci_Nil$() : h);
});
$c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$.prototype.toNormalizedList__O__T__sci_List = (function(value, separator) {
  return this.toNormalizedList__sc_Seq__T__sci_List(value, separator);
});
var $d_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$ = new $TypeData().initClass($c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$, "com.raquo.laminar.keys.CompositeValueMapper$Implicits$StringSeqValueMapper$", ({
  Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$: 1,
  Lcom_raquo_laminar_keys_CompositeValueMapper: 1
}));
export { $d_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$ as $d_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$ };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$ as $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$ };
$c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$.prototype = new $h_O();
$c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$.prototype.constructor = $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$() {
}
export { $h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$ as $h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$ };
$h_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$.prototype = $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$.prototype;
$c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$.prototype.toNormalizedList__O__T__sci_List = (function(value, separator) {
  return $m_Lcom_raquo_laminar_codecs_CompositeCodec$().normalize__T__T__sci_List(value, separator);
});
var $d_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$ = new $TypeData().initClass($c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$, "com.raquo.laminar.keys.CompositeValueMapper$Implicits$StringValueMapper$", ({
  Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$: 1,
  Lcom_raquo_laminar_keys_CompositeValueMapper: 1
}));
export { $d_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$ as $d_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$ };
function $ct_Lcom_raquo_laminar_keys_HtmlProp__T__s_Option__($thiz, name, reflectedAttrName) {
  $thiz.Lcom_raquo_laminar_keys_HtmlProp__f_name = name;
  $thiz.Lcom_raquo_laminar_keys_HtmlProp__f_reflectedAttrName = reflectedAttrName;
  return $thiz;
}
export { $ct_Lcom_raquo_laminar_keys_HtmlProp__T__s_Option__ as $ct_Lcom_raquo_laminar_keys_HtmlProp__T__s_Option__ };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_HtmlProp() {
  this.Lcom_raquo_laminar_keys_HtmlProp__f_name = null;
  this.Lcom_raquo_laminar_keys_HtmlProp__f_reflectedAttrName = null;
}
export { $c_Lcom_raquo_laminar_keys_HtmlProp as $c_Lcom_raquo_laminar_keys_HtmlProp };
$c_Lcom_raquo_laminar_keys_HtmlProp.prototype = new $h_O();
$c_Lcom_raquo_laminar_keys_HtmlProp.prototype.constructor = $c_Lcom_raquo_laminar_keys_HtmlProp;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_HtmlProp() {
}
export { $h_Lcom_raquo_laminar_keys_HtmlProp as $h_Lcom_raquo_laminar_keys_HtmlProp };
$h_Lcom_raquo_laminar_keys_HtmlProp.prototype = $c_Lcom_raquo_laminar_keys_HtmlProp.prototype;
$c_Lcom_raquo_laminar_keys_HtmlProp.prototype.$colon$eq__O__Lcom_raquo_laminar_modifiers_SimpleKeySetter = (function(value) {
  var setOrRemoveF = new $c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(((element, prop, value$2) => {
    var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    $f_Lcom_raquo_laminar_domapi_DomKeys__setHtmlProperty__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__Lcom_raquo_laminar_keys_HtmlProp__O__V(this$1, element, prop, value$2);
  }));
  return new $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1(this, value, setOrRemoveF);
});
$c_Lcom_raquo_laminar_keys_HtmlProp.prototype.$less$minus$minus__Lcom_raquo_airstream_core_Source__F1__Lcom_raquo_laminar_modifiers_SimpleKeyUpdater = (function(values, ev) {
  var update = ((this.Lcom_raquo_laminar_keys_HtmlProp__f_name === "value") ? new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((element, nextValue) => {
    var _nextValue = ev.apply__O__O(nextValue);
    var this$2 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    var x = $f_Lcom_raquo_laminar_domapi_DomKeys__getHtmlProperty__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__Lcom_raquo_laminar_keys_HtmlProp__O(this$2, element, this);
    if ((!((x !== (void 0)) && $m_sr_BoxesRunTime$().equals__O__O__Z(_nextValue, x)))) {
      var this$8 = $m_Lcom_raquo_laminar_domapi_DomApi$();
      $f_Lcom_raquo_laminar_domapi_DomKeys__setHtmlProperty__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__Lcom_raquo_laminar_keys_HtmlProp__O__V(this$8, element, this, _nextValue);
    }
  })) : new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((element$2, nextValue$2) => {
    var _nextValue$1 = ev.apply__O__O(nextValue$2);
    var this$9 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    $f_Lcom_raquo_laminar_domapi_DomKeys__setHtmlProperty__Lcom_raquo_laminar_nodes_ReactiveHtmlElement__Lcom_raquo_laminar_keys_HtmlProp__O__V(this$9, element$2, this, _nextValue$1);
  })));
  return new $c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater(this, values.toObservable__Lcom_raquo_airstream_core_Observable(), update);
});
function $isArrayOf_Lcom_raquo_laminar_keys_HtmlProp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_laminar_keys_HtmlProp)));
}
export { $isArrayOf_Lcom_raquo_laminar_keys_HtmlProp as $isArrayOf_Lcom_raquo_laminar_keys_HtmlProp };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1() {
}
export { $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 as $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 };
$c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$1() {
}
export { $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 as $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 };
$h_Lcom_raquo_laminar_modifiers_Modifier$$anon$1.prototype = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1.prototype;
$c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(element) {
});
var $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_Modifier$$anon$1, "com.raquo.laminar.modifiers.Modifier$$anon$1", ({
  Lcom_raquo_laminar_modifiers_Modifier$$anon$1: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 as $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2(f$2) {
  this.Lcom_raquo_laminar_modifiers_Modifier$$anon$2__f_f$1 = null;
  this.Lcom_raquo_laminar_modifiers_Modifier$$anon$2__f_f$1 = f$2;
}
export { $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 as $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 };
$c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$2() {
}
export { $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 as $h_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 };
$h_Lcom_raquo_laminar_modifiers_Modifier$$anon$2.prototype = $c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2.prototype;
$c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(element) {
  var this$2 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    this.Lcom_raquo_laminar_modifiers_Modifier$$anon$2__f_f$1.apply__O__O(element);
  });
  $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var when = true;
  if ((this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart || (!when))) {
    f();
  } else {
    this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = true;
    try {
      f();
    } finally {
      this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = false;
      $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$2);
    }
  }
});
var $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_Modifier$$anon$2, "com.raquo.laminar.modifiers.Modifier$$anon$2", ({
  Lcom_raquo_laminar_modifiers_Modifier$$anon$2: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 as $d_Lcom_raquo_laminar_modifiers_Modifier$$anon$2 };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1() {
}
export { $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1 as $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1 };
$c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1() {
}
export { $h_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1 as $h_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1 };
$h_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1.prototype = $c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1.prototype;
$c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1.prototype.asNodeSeq__Lcom_raquo_laminar_Seq__Lcom_raquo_laminar_Seq = (function(values) {
  return values;
});
$c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1.prototype.asNode__O__Lcom_raquo_laminar_nodes_ChildNode = (function(value) {
  return value;
});
var $d_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1, "com.raquo.laminar.modifiers.RenderableNode$$anon$1", ({
  Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1: 1,
  Lcom_raquo_laminar_modifiers_RenderableNode: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1 as $d_Lcom_raquo_laminar_modifiers_RenderableNode$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(render$2) {
  this.Lcom_raquo_laminar_modifiers_RenderableText$$anon$1__f_render$1 = null;
  this.Lcom_raquo_laminar_modifiers_RenderableText$$anon$1__f_render$1 = render$2;
}
export { $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 as $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 };
$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1() {
}
export { $h_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 as $h_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 };
$h_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1.prototype = $c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1.prototype;
$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1.prototype.asString__O__T = (function(value) {
  return this.Lcom_raquo_laminar_modifiers_RenderableText$$anon$1__f_render$1.apply__O__O(value);
});
var $d_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1, "com.raquo.laminar.modifiers.RenderableText$$anon$1", ({
  Lcom_raquo_laminar_modifiers_RenderableText$$anon$1: 1,
  Lcom_raquo_laminar_modifiers_RenderableText: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 as $d_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1 };
function $f_Lcom_raquo_laminar_nodes_ParentNode__$init$__V($thiz) {
  $thiz.com$raquo$laminar$nodes$ParentNode$_setter_$dynamicOwner_$eq__Lcom_raquo_airstream_ownership_DynamicOwner__V(new $c_Lcom_raquo_airstream_ownership_DynamicOwner(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var this$3 = $m_Lcom_raquo_laminar_domapi_DomApi$();
    var element = $thiz.ref__Lorg_scalajs_dom_Node();
    $m_Lcom_raquo_laminar_domapi_DomApi$();
    var initial = $m_sci_Nil$();
    var this$4 = $f_Lcom_raquo_laminar_domapi_DomDebug__debugPath__Lorg_scalajs_dom_Node__sci_List__sci_List(this$3, element, initial);
    var path = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$4, "", " > ", "");
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), ("Attempting to use owner of unmounted element: " + path));
  }))));
}
export { $f_Lcom_raquo_laminar_nodes_ParentNode__$init$__V as $f_Lcom_raquo_laminar_nodes_ParentNode__$init$__V };
/** @constructor */
function $c_Lcom_raquo_laminar_tags_HtmlTag(name, void$1) {
  this.Lcom_raquo_laminar_tags_HtmlTag__f_name = null;
  this.Lcom_raquo_laminar_tags_HtmlTag__f_name = name;
}
export { $c_Lcom_raquo_laminar_tags_HtmlTag as $c_Lcom_raquo_laminar_tags_HtmlTag };
$c_Lcom_raquo_laminar_tags_HtmlTag.prototype = new $h_O();
$c_Lcom_raquo_laminar_tags_HtmlTag.prototype.constructor = $c_Lcom_raquo_laminar_tags_HtmlTag;
/** @constructor */
function $h_Lcom_raquo_laminar_tags_HtmlTag() {
}
export { $h_Lcom_raquo_laminar_tags_HtmlTag as $h_Lcom_raquo_laminar_tags_HtmlTag };
$h_Lcom_raquo_laminar_tags_HtmlTag.prototype = $c_Lcom_raquo_laminar_tags_HtmlTag.prototype;
$c_Lcom_raquo_laminar_tags_HtmlTag.prototype.name__T = (function() {
  return this.Lcom_raquo_laminar_tags_HtmlTag__f_name;
});
$c_Lcom_raquo_laminar_tags_HtmlTag.prototype.apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement = (function(modifiers) {
  var element = this.build__Lcom_raquo_laminar_nodes_ReactiveHtmlElement();
  modifiers.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((modifier) => {
    modifier.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V(element);
  })));
  return element;
});
$c_Lcom_raquo_laminar_tags_HtmlTag.prototype.build__Lcom_raquo_laminar_nodes_ReactiveHtmlElement = (function() {
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  return new $c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, $f_Lcom_raquo_laminar_domapi_DomTags__createHtmlElement__Lcom_raquo_laminar_tags_HtmlTag__Lorg_scalajs_dom_HTMLElement(this$1, this));
});
function $isArrayOf_Lcom_raquo_laminar_tags_HtmlTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_laminar_tags_HtmlTag)));
}
export { $isArrayOf_Lcom_raquo_laminar_tags_HtmlTag as $isArrayOf_Lcom_raquo_laminar_tags_HtmlTag };
var $d_Lcom_raquo_laminar_tags_HtmlTag = new $TypeData().initClass($c_Lcom_raquo_laminar_tags_HtmlTag, "com.raquo.laminar.tags.HtmlTag", ({
  Lcom_raquo_laminar_tags_HtmlTag: 1,
  Lcom_raquo_laminar_tags_Tag: 1
}));
export { $d_Lcom_raquo_laminar_tags_HtmlTag as $d_Lcom_raquo_laminar_tags_HtmlTag };
/** @constructor */
function $c_Lcom_raquo_laminar_tags_SvgTag(name, void$1) {
  this.Lcom_raquo_laminar_tags_SvgTag__f_name = null;
  this.Lcom_raquo_laminar_tags_SvgTag__f_name = name;
}
export { $c_Lcom_raquo_laminar_tags_SvgTag as $c_Lcom_raquo_laminar_tags_SvgTag };
$c_Lcom_raquo_laminar_tags_SvgTag.prototype = new $h_O();
$c_Lcom_raquo_laminar_tags_SvgTag.prototype.constructor = $c_Lcom_raquo_laminar_tags_SvgTag;
/** @constructor */
function $h_Lcom_raquo_laminar_tags_SvgTag() {
}
export { $h_Lcom_raquo_laminar_tags_SvgTag as $h_Lcom_raquo_laminar_tags_SvgTag };
$h_Lcom_raquo_laminar_tags_SvgTag.prototype = $c_Lcom_raquo_laminar_tags_SvgTag.prototype;
$c_Lcom_raquo_laminar_tags_SvgTag.prototype.name__T = (function() {
  return this.Lcom_raquo_laminar_tags_SvgTag__f_name;
});
function $isArrayOf_Lcom_raquo_laminar_tags_SvgTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_laminar_tags_SvgTag)));
}
export { $isArrayOf_Lcom_raquo_laminar_tags_SvgTag as $isArrayOf_Lcom_raquo_laminar_tags_SvgTag };
var $d_Lcom_raquo_laminar_tags_SvgTag = new $TypeData().initClass($c_Lcom_raquo_laminar_tags_SvgTag, "com.raquo.laminar.tags.SvgTag", ({
  Lcom_raquo_laminar_tags_SvgTag: 1,
  Lcom_raquo_laminar_tags_Tag: 1
}));
export { $d_Lcom_raquo_laminar_tags_SvgTag as $d_Lcom_raquo_laminar_tags_SvgTag };
/** @constructor */
function $c_Lframework_data_PageCursorDirection$namedEnum$() {
  this.Lframework_data_PageCursorDirection$namedEnum$__f_byName = null;
  this.Lframework_data_PageCursorDirection$namedEnum$__f_values$lzy1 = null;
  this.Lframework_data_PageCursorDirection$namedEnum$__f_valuesbitmap$1 = false;
  $n_Lframework_data_PageCursorDirection$namedEnum$ = this;
  $f_Lframework_utils_NamedEnum__$init$__V(this);
}
export { $c_Lframework_data_PageCursorDirection$namedEnum$ as $c_Lframework_data_PageCursorDirection$namedEnum$ };
$c_Lframework_data_PageCursorDirection$namedEnum$.prototype = new $h_O();
$c_Lframework_data_PageCursorDirection$namedEnum$.prototype.constructor = $c_Lframework_data_PageCursorDirection$namedEnum$;
/** @constructor */
function $h_Lframework_data_PageCursorDirection$namedEnum$() {
}
export { $h_Lframework_data_PageCursorDirection$namedEnum$ as $h_Lframework_data_PageCursorDirection$namedEnum$ };
$h_Lframework_data_PageCursorDirection$namedEnum$.prototype = $c_Lframework_data_PageCursorDirection$namedEnum$.prototype;
$c_Lframework_data_PageCursorDirection$namedEnum$.prototype.byName__sci_Map = (function() {
  return this.Lframework_data_PageCursorDirection$namedEnum$__f_byName;
});
$c_Lframework_data_PageCursorDirection$namedEnum$.prototype.framework$utils$NamedEnum$_setter_$byName_$eq__sci_Map__V = (function(x$0) {
  this.Lframework_data_PageCursorDirection$namedEnum$__f_byName = x$0;
});
$c_Lframework_data_PageCursorDirection$namedEnum$.prototype.values__sci_Vector = (function() {
  if ((!this.Lframework_data_PageCursorDirection$namedEnum$__f_valuesbitmap$1)) {
    var $x_1 = $m_Lcats_data_NonEmptyVector$();
    var this$2 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($m_Lframework_data_PageCursorDirection$().values__ALframework_data_PageCursorDirection());
    this.Lframework_data_PageCursorDirection$namedEnum$__f_values$lzy1 = $x_1.fromVectorUnsafe__sci_Vector__sci_Vector($m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$2));
    this.Lframework_data_PageCursorDirection$namedEnum$__f_valuesbitmap$1 = true;
  }
  return this.Lframework_data_PageCursorDirection$namedEnum$__f_values$lzy1;
});
$c_Lframework_data_PageCursorDirection$namedEnum$.prototype.toName__Lframework_data_PageCursorDirection__T = (function(a) {
  var x = $s_Lframework_data_PageCursorDirection$__Backward__Lframework_data_PageCursorDirection();
  if ((x === a)) {
    return "bwd";
  }
  var x$3 = $s_Lframework_data_PageCursorDirection$__Forward__Lframework_data_PageCursorDirection();
  if ((x$3 === a)) {
    return "fwd";
  }
  throw new $c_s_MatchError(a);
});
$c_Lframework_data_PageCursorDirection$namedEnum$.prototype.toName__O__T = (function(a) {
  return this.toName__Lframework_data_PageCursorDirection__T(a);
});
var $d_Lframework_data_PageCursorDirection$namedEnum$ = new $TypeData().initClass($c_Lframework_data_PageCursorDirection$namedEnum$, "framework.data.PageCursorDirection$namedEnum$", ({
  Lframework_data_PageCursorDirection$namedEnum$: 1,
  Lframework_utils_NamedEnum: 1
}));
export { $d_Lframework_data_PageCursorDirection$namedEnum$ as $d_Lframework_data_PageCursorDirection$namedEnum$ };
var $n_Lframework_data_PageCursorDirection$namedEnum$;
function $m_Lframework_data_PageCursorDirection$namedEnum$() {
  if ((!$n_Lframework_data_PageCursorDirection$namedEnum$)) {
    $n_Lframework_data_PageCursorDirection$namedEnum$ = new $c_Lframework_data_PageCursorDirection$namedEnum$();
  }
  return $n_Lframework_data_PageCursorDirection$namedEnum$;
}
export { $m_Lframework_data_PageCursorDirection$namedEnum$ as $m_Lframework_data_PageCursorDirection$namedEnum$ };
/** @constructor */
function $c_Lframework_exts_TapirCodecExts$package$$anon$1(codec$3, schema$2) {
  this.Lframework_exts_TapirCodecExts$package$$anon$1__f_codec$1 = null;
  this.Lframework_exts_TapirCodecExts$package$$anon$1__f_schema$1 = null;
  this.Lframework_exts_TapirCodecExts$package$$anon$1__f_format = null;
  this.Lframework_exts_TapirCodecExts$package$$anon$1__f_codec$1 = codec$3;
  this.Lframework_exts_TapirCodecExts$package$$anon$1__f_schema$1 = schema$2;
  this.Lframework_exts_TapirCodecExts$package$$anon$1__f_format = new $c_Lsttp_tapir_CodecFormat$TextPlain();
}
export { $c_Lframework_exts_TapirCodecExts$package$$anon$1 as $c_Lframework_exts_TapirCodecExts$package$$anon$1 };
$c_Lframework_exts_TapirCodecExts$package$$anon$1.prototype = new $h_O();
$c_Lframework_exts_TapirCodecExts$package$$anon$1.prototype.constructor = $c_Lframework_exts_TapirCodecExts$package$$anon$1;
/** @constructor */
function $h_Lframework_exts_TapirCodecExts$package$$anon$1() {
}
export { $h_Lframework_exts_TapirCodecExts$package$$anon$1 as $h_Lframework_exts_TapirCodecExts$package$$anon$1 };
$h_Lframework_exts_TapirCodecExts$package$$anon$1.prototype = $c_Lframework_exts_TapirCodecExts$package$$anon$1.prototype;
$c_Lframework_exts_TapirCodecExts$package$$anon$1.prototype.encode__O__T = (function(h) {
  var x1 = this.Lframework_exts_TapirCodecExts$package$$anon$1__f_codec$1.encode__O__Lscodec_Attempt(h);
  if ((x1 instanceof $c_Lscodec_Attempt$Successful)) {
    var x7 = x1.Lscodec_Attempt$Successful__f_value;
    var this$2 = x7.toByteVector__Lscodec_bits_ByteVector();
    return this$2.toBase64__Lscodec_bits_Bases$Base64Alphabet__T($m_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$());
  }
  if ((x1 instanceof $c_Lscodec_Attempt$Failure)) {
    var x4 = x1.Lscodec_Attempt$Failure__f_cause;
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), $f_Lscodec_Err__messageWithContext__T(x4));
  }
  throw new $c_s_MatchError(x1);
});
$c_Lframework_exts_TapirCodecExts$package$$anon$1.prototype.rawDecode__T__Lsttp_tapir_DecodeResult = (function(l) {
  var $x_2 = $m_Lsttp_tapir_DecodeResult$();
  var this$1 = $m_Lscodec_bits_BitVector$().fromBase64Descriptive__T__Lscodec_bits_Bases$Base64Alphabet__s_util_Either(l, $m_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$());
  if ((this$1 instanceof $c_s_util_Right)) {
    var b = this$1.s_util_Right__f_value;
    var this$2 = $f_Lscodec_Decoder__decodeValue__Lscodec_bits_BitVector__Lscodec_Attempt(this.Lframework_exts_TapirCodecExts$package$$anon$1__f_codec$1, b).toEither__s_util_Either();
    var this$3 = new $c_s_util_Either$LeftProjection(this$2);
    var x1 = this$3.s_util_Either$LeftProjection__f_e;
    if ((x1 instanceof $c_s_util_Left)) {
      var a = x1.s_util_Left__f_value;
      var $x_1 = new $c_s_util_Left($f_Lscodec_Err__messageWithContext__T(a));
    } else {
      var $x_1 = this$3.s_util_Either$LeftProjection__f_e;
    }
  } else {
    var $x_1 = this$1;
  }
  return $x_2.fromEitherString__T__s_util_Either__Lsttp_tapir_DecodeResult(l, $x_1);
});
$c_Lframework_exts_TapirCodecExts$package$$anon$1.prototype.schema__Lsttp_tapir_Schema = (function() {
  return this.Lframework_exts_TapirCodecExts$package$$anon$1__f_schema$1;
});
$c_Lframework_exts_TapirCodecExts$package$$anon$1.prototype.encode__O__O = (function(h) {
  return this.encode__O__T(h);
});
$c_Lframework_exts_TapirCodecExts$package$$anon$1.prototype.rawDecode__O__Lsttp_tapir_DecodeResult = (function(l) {
  return this.rawDecode__T__Lsttp_tapir_DecodeResult(l);
});
$c_Lframework_exts_TapirCodecExts$package$$anon$1.prototype.format__Lsttp_tapir_CodecFormat = (function() {
  return this.Lframework_exts_TapirCodecExts$package$$anon$1__f_format;
});
var $d_Lframework_exts_TapirCodecExts$package$$anon$1 = new $TypeData().initClass($c_Lframework_exts_TapirCodecExts$package$$anon$1, "framework.exts.TapirCodecExts$package$$anon$1", ({
  Lframework_exts_TapirCodecExts$package$$anon$1: 1,
  Lsttp_tapir_Codec: 1
}));
export { $d_Lframework_exts_TapirCodecExts$package$$anon$1 as $d_Lframework_exts_TapirCodecExts$package$$anon$1 };
/** @constructor */
function $c_Lframework_localization_LocalizationSupport$$anon$2(localize$4, outer) {
  this.Lframework_localization_LocalizationSupport$$anon$2__f_localize$1 = null;
  this.Lframework_localization_LocalizationSupport$$anon$2__f_$outer = null;
  this.Lframework_localization_LocalizationSupport$$anon$2__f_localize$1 = localize$4;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_localization_LocalizationSupport$$anon$2__f_$outer = outer;
}
export { $c_Lframework_localization_LocalizationSupport$$anon$2 as $c_Lframework_localization_LocalizationSupport$$anon$2 };
$c_Lframework_localization_LocalizationSupport$$anon$2.prototype = new $h_O();
$c_Lframework_localization_LocalizationSupport$$anon$2.prototype.constructor = $c_Lframework_localization_LocalizationSupport$$anon$2;
/** @constructor */
function $h_Lframework_localization_LocalizationSupport$$anon$2() {
}
export { $h_Lframework_localization_LocalizationSupport$$anon$2 as $h_Lframework_localization_LocalizationSupport$$anon$2 };
$h_Lframework_localization_LocalizationSupport$$anon$2.prototype = $c_Lframework_localization_LocalizationSupport$$anon$2.prototype;
$c_Lframework_localization_LocalizationSupport$$anon$2.prototype.text__O__T = (function(locale) {
  return this.Lframework_localization_LocalizationSupport$$anon$2__f_localize$1.apply__O__O(locale);
});
$c_Lframework_localization_LocalizationSupport$$anon$2.prototype.framework$localization$LocalizationSupport$LocalizedText$$$outer__Lframework_localization_LocalizationSupport = (function() {
  return this.Lframework_localization_LocalizationSupport$$anon$2__f_$outer.Lframework_localization_LocalizationSupport$LocalizedText$__f_$outer;
});
var $d_Lframework_localization_LocalizationSupport$$anon$2 = new $TypeData().initClass($c_Lframework_localization_LocalizationSupport$$anon$2, "framework.localization.LocalizationSupport$$anon$2", ({
  Lframework_localization_LocalizationSupport$$anon$2: 1,
  Lframework_localization_LocalizationSupport$LocalizedText: 1
}));
export { $d_Lframework_localization_LocalizationSupport$$anon$2 as $d_Lframework_localization_LocalizationSupport$$anon$2 };
/** @constructor */
function $c_Lframework_localization_LocalizationSupport$$anon$8(localize$6, outer) {
  this.Lframework_localization_LocalizationSupport$$anon$8__f_localize$3 = null;
  this.Lframework_localization_LocalizationSupport$$anon$8__f_$outer = null;
  this.Lframework_localization_LocalizationSupport$$anon$8__f_localize$3 = localize$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_localization_LocalizationSupport$$anon$8__f_$outer = outer;
}
export { $c_Lframework_localization_LocalizationSupport$$anon$8 as $c_Lframework_localization_LocalizationSupport$$anon$8 };
$c_Lframework_localization_LocalizationSupport$$anon$8.prototype = new $h_O();
$c_Lframework_localization_LocalizationSupport$$anon$8.prototype.constructor = $c_Lframework_localization_LocalizationSupport$$anon$8;
/** @constructor */
function $h_Lframework_localization_LocalizationSupport$$anon$8() {
}
export { $h_Lframework_localization_LocalizationSupport$$anon$8 as $h_Lframework_localization_LocalizationSupport$$anon$8 };
$h_Lframework_localization_LocalizationSupport$$anon$8.prototype = $c_Lframework_localization_LocalizationSupport$$anon$8.prototype;
$c_Lframework_localization_LocalizationSupport$$anon$8.prototype.localizedText__O__Lframework_localization_LocalizationSupport$LocalizedText = (function(value) {
  var this$2 = this.Lframework_localization_LocalizationSupport$$anon$8__f_$outer.Lframework_localization_LocalizationSupport$LocalizedTextOfValue$__f_$outer.LocalizedText__Lframework_localization_LocalizationSupport$LocalizedText$();
  var localize = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((locale) => this.Lframework_localization_LocalizationSupport$$anon$8__f_localize$3.apply__O__O__O(value, locale)));
  return new $c_Lframework_localization_LocalizationSupport$$anon$2(localize, this$2);
});
var $d_Lframework_localization_LocalizationSupport$$anon$8 = new $TypeData().initClass($c_Lframework_localization_LocalizationSupport$$anon$8, "framework.localization.LocalizationSupport$$anon$8", ({
  Lframework_localization_LocalizationSupport$$anon$8: 1,
  Lframework_localization_LocalizationSupport$LocalizedTextOfValue: 1
}));
export { $d_Lframework_localization_LocalizationSupport$$anon$8 as $d_Lframework_localization_LocalizationSupport$$anon$8 };
/** @constructor */
function $c_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$(outer) {
  this.Lframework_localization_LocalizationSupport$LocalizedTextOfValue$__f_forLocalizedText$lzy1 = null;
  this.Lframework_localization_LocalizationSupport$LocalizedTextOfValue$__f_forLocalizedTextbitmap$1 = false;
  this.Lframework_localization_LocalizationSupport$LocalizedTextOfValue$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_localization_LocalizationSupport$LocalizedTextOfValue$__f_$outer = outer;
}
export { $c_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$ as $c_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$ };
$c_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$.prototype = new $h_O();
$c_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$.prototype.constructor = $c_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$;
/** @constructor */
function $h_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$() {
}
export { $h_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$ as $h_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$ };
$h_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$.prototype = $c_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$.prototype;
$c_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$.prototype.text__Lframework_localization_LocalizationSupport$LocalizedTextOfValue__O__O__T = (function(lto, value, x$3) {
  return lto.localizedText__O__Lframework_localization_LocalizationSupport$LocalizedText(value).text__O__T(x$3);
});
$c_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$.prototype.forLocalizedText__Lframework_localization_LocalizationSupport$LocalizedTextOfValue = (function() {
  if ((!this.Lframework_localization_LocalizationSupport$LocalizedTextOfValue$__f_forLocalizedTextbitmap$1)) {
    var localize = new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((localizedText, locale) => localizedText.text__O__T(locale)));
    this.Lframework_localization_LocalizationSupport$LocalizedTextOfValue$__f_forLocalizedText$lzy1 = new $c_Lframework_localization_LocalizationSupport$$anon$8(localize, this);
    this.Lframework_localization_LocalizationSupport$LocalizedTextOfValue$__f_forLocalizedTextbitmap$1 = true;
  }
  return this.Lframework_localization_LocalizationSupport$LocalizedTextOfValue$__f_forLocalizedText$lzy1;
});
var $d_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$ = new $TypeData().initClass($c_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$, "framework.localization.LocalizationSupport$LocalizedTextOfValue$", ({
  Lframework_localization_LocalizationSupport$LocalizedTextOfValue$: 1,
  Lframework_localization_LocalizationSupport$LocalizedTextOfValueLowPriorityImplicits: 1
}));
export { $d_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$ as $d_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$ };
function $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__($thiz, lastCursor, lastOp) {
  $thiz.Lio_circe_ACursor__f_lastCursor = lastCursor;
  $thiz.Lio_circe_ACursor__f_lastOp = lastOp;
  return $thiz;
}
export { $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__ as $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__ };
function $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor) {
  var x1 = cursor.Lio_circe_ACursor__f_lastCursor;
  if ((x1 instanceof $c_Lio_circe_cursor_ArrayCursor)) {
    return x1.Lio_circe_cursor_ArrayCursor__f_parent;
  }
  return x1;
}
export { $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor as $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor };
function $ps_Lio_circe_ACursor__loop$1__Lio_circe_ACursor__sci_Vector__sci_Vector(cursor, acc) {
  var acc$tailLocal1 = acc;
  var cursor$tailLocal1 = cursor;
  while (true) {
    if ((cursor$tailLocal1 === null)) {
      return acc$tailLocal1;
    } else {
      var this$1 = cursor$tailLocal1;
      if ((!this$1.succeeded__Z())) {
        var x5 = cursor$tailLocal1.Lio_circe_ACursor__f_lastOp;
        if (false) {
          var x14 = x5.Lio_circe_CursorOp$Field__f_k;
          var cursor$tailLocal1$tmp1 = $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor$tailLocal1);
          var elem$1 = new $c_Lio_circe_PathToRoot$PathElem$ObjectKey(x14);
          var this$4 = $m_Lio_circe_PathToRoot$();
          var this$ = acc$tailLocal1;
          var acc$tailLocal1$tmp1 = this$4.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$, elem$1);
          cursor$tailLocal1 = cursor$tailLocal1$tmp1;
          acc$tailLocal1 = acc$tailLocal1$tmp1;
          continue;
        }
        if ((x5 instanceof $c_Lio_circe_CursorOp$DownField)) {
          var x11 = x5.Lio_circe_CursorOp$DownField__f_k;
          var cursor$tailLocal1$tmp2 = $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor$tailLocal1);
          var elem$2 = new $c_Lio_circe_PathToRoot$PathElem$ObjectKey(x11);
          var this$7 = $m_Lio_circe_PathToRoot$();
          var this$$1 = acc$tailLocal1;
          var acc$tailLocal1$tmp2 = this$7.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$1, elem$2);
          cursor$tailLocal1 = cursor$tailLocal1$tmp2;
          acc$tailLocal1 = acc$tailLocal1$tmp2;
          continue;
        }
        var x = $m_Lio_circe_CursorOp$DownArray$();
        if ((x === x5)) {
          var cursor$tailLocal1$tmp3 = $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor$tailLocal1);
          var elem$3 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex($L0);
          var this$10 = $m_Lio_circe_PathToRoot$();
          var this$$2 = acc$tailLocal1;
          var acc$tailLocal1$tmp3 = this$10.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$2, elem$3);
          cursor$tailLocal1 = cursor$tailLocal1$tmp3;
          acc$tailLocal1 = acc$tailLocal1$tmp3;
          continue;
        }
        if ((x5 instanceof $c_Lio_circe_CursorOp$DownN)) {
          var x8 = x5.Lio_circe_CursorOp$DownN__f_n;
          var cursor$tailLocal1$tmp4 = $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor$tailLocal1);
          var hi = (x8 >> 31);
          var elem$4 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(new $c_RTLong(x8, hi));
          var this$15 = $m_Lio_circe_PathToRoot$();
          var this$$3 = acc$tailLocal1;
          var acc$tailLocal1$tmp4 = this$15.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$3, elem$4);
          cursor$tailLocal1 = cursor$tailLocal1$tmp4;
          acc$tailLocal1 = acc$tailLocal1$tmp4;
          continue;
        }
        var x$3 = $m_Lio_circe_CursorOp$MoveLeft$();
        if ((x$3 === x5)) {
          var cursor$tailLocal1$tmp5 = $ps_Lio_circe_ACursor__lastCursorParentOrLastCursor$1__Lio_circe_ACursor__Lio_circe_ACursor(cursor$tailLocal1);
          var elem$5 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(new $c_RTLong((-1), (-1)));
          var this$18 = $m_Lio_circe_PathToRoot$();
          var this$$4 = acc$tailLocal1;
          var acc$tailLocal1$tmp5 = this$18.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$4, elem$5);
          cursor$tailLocal1 = cursor$tailLocal1$tmp5;
          acc$tailLocal1 = acc$tailLocal1$tmp5;
          continue;
        }
        var x$5 = $m_Lio_circe_CursorOp$MoveRight$();
        if ((x$5 === x5)) {
          var x3 = cursor$tailLocal1.Lio_circe_ACursor__f_lastCursor;
          if ((x3 instanceof $c_Lio_circe_cursor_ArrayCursor)) {
            var cursor$tailLocal1$tmp6 = x3.Lio_circe_cursor_ArrayCursor__f_parent;
            var value = x3.Lio_circe_cursor_ArrayCursor__f_indexValue;
            var hi$1 = (value >> 31);
            var lo = ((1 + value) | 0);
            var hi$2 = ((hi$1 + (((value & (~lo)) >>> 31) | 0)) | 0);
            var elem$6 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(new $c_RTLong(lo, hi$2));
            var this$22 = $m_Lio_circe_PathToRoot$();
            var this$$5 = acc$tailLocal1;
            var acc$tailLocal1$tmp6 = this$22.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$5, elem$6);
            cursor$tailLocal1 = cursor$tailLocal1$tmp6;
            acc$tailLocal1 = acc$tailLocal1$tmp6;
            continue;
          }
          cursor$tailLocal1 = cursor$tailLocal1.Lio_circe_ACursor__f_lastCursor;
          continue;
        }
        cursor$tailLocal1 = cursor$tailLocal1.Lio_circe_ACursor__f_lastCursor;
      } else {
        var x15 = cursor$tailLocal1;
        if ((x15 instanceof $c_Lio_circe_cursor_ArrayCursor)) {
          var cursor$tailLocal1$tmp7 = x15.Lio_circe_cursor_ArrayCursor__f_parent;
          var value$1 = x15.Lio_circe_cursor_ArrayCursor__f_indexValue;
          var hi$3 = (value$1 >> 31);
          var elem$7 = new $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(new $c_RTLong(value$1, hi$3));
          var this$26 = $m_Lio_circe_PathToRoot$();
          var this$$6 = acc$tailLocal1;
          var acc$tailLocal1$tmp7 = this$26.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$6, elem$7);
          cursor$tailLocal1 = cursor$tailLocal1$tmp7;
          acc$tailLocal1 = acc$tailLocal1$tmp7;
          continue;
        }
        if ((x15 instanceof $c_Lio_circe_cursor_ObjectCursor)) {
          var cursor$tailLocal1$tmp8 = x15.Lio_circe_cursor_ObjectCursor__f_parent;
          var keyName = x15.Lio_circe_cursor_ObjectCursor__f_keyValue;
          var elem$8 = new $c_Lio_circe_PathToRoot$PathElem$ObjectKey(keyName);
          var this$28 = $m_Lio_circe_PathToRoot$();
          var this$$7 = acc$tailLocal1;
          var acc$tailLocal1$tmp8 = this$28.prependElem$extension__sci_Vector__Lio_circe_PathToRoot$PathElem__sci_Vector(this$$7, elem$8);
          cursor$tailLocal1 = cursor$tailLocal1$tmp8;
          acc$tailLocal1 = acc$tailLocal1$tmp8;
          continue;
        }
        if ((x15 instanceof $c_Lio_circe_cursor_TopCursor)) {
          return acc$tailLocal1;
        }
        cursor$tailLocal1 = cursor$tailLocal1.Lio_circe_ACursor__f_lastCursor;
      }
    }
  }
}
export { $ps_Lio_circe_ACursor__loop$1__Lio_circe_ACursor__sci_Vector__sci_Vector as $ps_Lio_circe_ACursor__loop$1__Lio_circe_ACursor__sci_Vector__sci_Vector };
/** @constructor */
function $c_Lio_circe_ACursor() {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
}
export { $c_Lio_circe_ACursor as $c_Lio_circe_ACursor };
$c_Lio_circe_ACursor.prototype = new $h_O();
$c_Lio_circe_ACursor.prototype.constructor = $c_Lio_circe_ACursor;
/** @constructor */
function $h_Lio_circe_ACursor() {
}
export { $h_Lio_circe_ACursor as $h_Lio_circe_ACursor };
$h_Lio_circe_ACursor.prototype = $c_Lio_circe_ACursor.prototype;
$c_Lio_circe_ACursor.prototype.history__sci_List = (function() {
  var next = this;
  var builder = new $c_scm_ListBuffer();
  while ((next !== null)) {
    if ((next.Lio_circe_ACursor__f_lastOp !== null)) {
      var elem = next.Lio_circe_ACursor__f_lastOp;
      builder.addOne__O__scm_ListBuffer(elem);
    }
    next = next.Lio_circe_ACursor__f_lastCursor;
  }
  return builder.toList__sci_List();
});
function $f_Lio_circe_Decoder__decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated($thiz, c) {
  var x1 = $thiz.apply__Lio_circe_HCursor__s_util_Either(c);
  if ((x1 instanceof $c_s_util_Right)) {
    var a = x1.s_util_Right__f_value;
    $m_Lcats_data_Validated$();
    return new $c_Lcats_data_Validated$Valid(a);
  }
  if ((x1 instanceof $c_s_util_Left)) {
    var e = x1.s_util_Left__f_value;
    var this$3 = $m_Lcats_data_Validated$();
    return $f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated(this$3, e);
  }
  throw new $c_s_MatchError(x1);
}
export { $f_Lio_circe_Decoder__decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated as $f_Lio_circe_Decoder__decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated };
function $p_Lio_circe_Decoder__cursorToDecodingFailure__Lio_circe_ACursor__Lio_circe_DecodingFailure($thiz, cursor) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    matchResult2: {
      var $x_1;
      if ((cursor instanceof $c_Lio_circe_FailedCursor)) {
        if (cursor.missingField__Z()) {
          var $x_1 = $m_Lio_circe_DecodingFailure$Reason$MissingField$();
          break matchResult2;
        }
      }
      var field = $f_T__replaceFirst__T__T__T($m_Lio_circe_PathToRoot$().toPathString__sci_Vector__T($ps_Lio_circe_ACursor__loop$1__Lio_circe_ACursor__sci_Vector__sci_Vector(cursor, $m_Lio_circe_PathToRoot$().Lio_circe_PathToRoot$__f_empty)), "^\\.", "");
      var message = ("Couldn't decode " + field);
      var $x_1 = new $c_Lio_circe_DecodingFailure$Reason$CustomReason(message);
    }
    return $x_1;
  }));
  var reason = new $c_Lcats_Later(a);
  $m_Lio_circe_DecodingFailure$();
  var value = new $c_Lio_circe_PathToRoot($ps_Lio_circe_ACursor__loop$1__Lio_circe_ACursor__sci_Vector__sci_Vector(cursor, $m_Lio_circe_PathToRoot$().Lio_circe_PathToRoot$__f_empty));
  var pathToRoot = new $c_s_Some(value);
  $m_Lcats_Eval$();
  var a$1 = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => cursor.history__sci_List()));
  var ops = new $c_Lcats_Later(a$1);
  return new $c_Lio_circe_DecodingFailure$DecodingFailureImpl(reason, pathToRoot, ops);
}
export { $p_Lio_circe_Decoder__cursorToDecodingFailure__Lio_circe_ACursor__Lio_circe_DecodingFailure as $p_Lio_circe_Decoder__cursorToDecodingFailure__Lio_circe_ACursor__Lio_circe_DecodingFailure };
function $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either($thiz, c) {
  if ((c instanceof $c_Lio_circe_HCursor)) {
    return $thiz.apply__Lio_circe_HCursor__s_util_Either(c);
  } else {
    var value = $p_Lio_circe_Decoder__cursorToDecodingFailure__Lio_circe_ACursor__Lio_circe_DecodingFailure($thiz, c);
    return new $c_s_util_Left(value);
  }
}
export { $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either as $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either };
function $f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated($thiz, c) {
  if ((c instanceof $c_Lio_circe_HCursor)) {
    return $thiz.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(c);
  } else {
    var this$1 = $m_Lcats_data_Validated$();
    var e = $p_Lio_circe_Decoder__cursorToDecodingFailure__Lio_circe_ACursor__Lio_circe_DecodingFailure($thiz, c);
    return $f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated(this$1, e);
  }
}
export { $f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated as $f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated };
function $f_Lio_circe_Decoder__decodeJson__Lio_circe_Json__s_util_Either($thiz, j) {
  return $thiz.apply__Lio_circe_HCursor__s_util_Either(new $c_Lio_circe_cursor_TopCursor(j, null, null));
}
export { $f_Lio_circe_Decoder__decodeJson__Lio_circe_Json__s_util_Either as $f_Lio_circe_Decoder__decodeJson__Lio_circe_Json__s_util_Either };
/** @constructor */
function $c_Lio_circe_JsonNumber() {
}
export { $c_Lio_circe_JsonNumber as $c_Lio_circe_JsonNumber };
$c_Lio_circe_JsonNumber.prototype = new $h_O();
$c_Lio_circe_JsonNumber.prototype.constructor = $c_Lio_circe_JsonNumber;
/** @constructor */
function $h_Lio_circe_JsonNumber() {
}
export { $h_Lio_circe_JsonNumber as $h_Lio_circe_JsonNumber };
$h_Lio_circe_JsonNumber.prototype = $c_Lio_circe_JsonNumber.prototype;
$c_Lio_circe_JsonNumber.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_Lio_circe_JsonNumber) && $m_Lio_circe_JsonNumber$().Lio_circe_JsonNumber$__f_eqJsonNumber.eqv__O__O__Z(this, that));
});
$c_Lio_circe_JsonNumber.prototype.hashCode__I = (function() {
  return this.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal().hashCode__I();
});
function $isArrayOf_Lio_circe_JsonNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonNumber)));
}
export { $isArrayOf_Lio_circe_JsonNumber as $isArrayOf_Lio_circe_JsonNumber };
/** @constructor */
function $c_Lio_circe_JsonObject() {
}
export { $c_Lio_circe_JsonObject as $c_Lio_circe_JsonObject };
$c_Lio_circe_JsonObject.prototype = new $h_O();
$c_Lio_circe_JsonObject.prototype.constructor = $c_Lio_circe_JsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject() {
}
export { $h_Lio_circe_JsonObject as $h_Lio_circe_JsonObject };
$h_Lio_circe_JsonObject.prototype = $c_Lio_circe_JsonObject.prototype;
$c_Lio_circe_JsonObject.prototype.toString__T = (function() {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this.toIterable__sc_Iterable().map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var k = x$1._1__O();
      var v = x$1._2__O();
      return ((k + " -> ") + $m_Lio_circe_Json$().Lio_circe_Json$__f_showJson.show__O__T(v));
    }
    throw new $c_s_MatchError(x$1);
  }))), "object[", ",", "]");
});
$c_Lio_circe_JsonObject.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_JsonObject)) {
    if ((this.size__I() === that.size__I())) {
      var x = this.toMap__sci_Map();
      var x$2 = that.toMap__sci_Map();
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lio_circe_JsonObject.prototype.hashCode__I = (function() {
  return this.toMap__sci_Map().hashCode__I();
});
function $isArrayOf_Lio_circe_JsonObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonObject)));
}
export { $isArrayOf_Lio_circe_JsonObject as $isArrayOf_Lio_circe_JsonObject };
/** @constructor */
function $c_Lio_circe_Printer$$anon$2() {
  this.jl_ThreadLocal__f_hasValue = false;
  this.jl_ThreadLocal__f_v = null;
  $ct_jl_ThreadLocal__(this);
}
export { $c_Lio_circe_Printer$$anon$2 as $c_Lio_circe_Printer$$anon$2 };
$c_Lio_circe_Printer$$anon$2.prototype = new $h_jl_ThreadLocal();
$c_Lio_circe_Printer$$anon$2.prototype.constructor = $c_Lio_circe_Printer$$anon$2;
/** @constructor */
function $h_Lio_circe_Printer$$anon$2() {
}
export { $h_Lio_circe_Printer$$anon$2 as $h_Lio_circe_Printer$$anon$2 };
$h_Lio_circe_Printer$$anon$2.prototype = $c_Lio_circe_Printer$$anon$2.prototype;
$c_Lio_circe_Printer$$anon$2.prototype.initialValue__O = (function() {
  return $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
});
var $d_Lio_circe_Printer$$anon$2 = new $TypeData().initClass($c_Lio_circe_Printer$$anon$2, "io.circe.Printer$$anon$2", ({
  Lio_circe_Printer$$anon$2: 1,
  jl_ThreadLocal: 1
}));
export { $d_Lio_circe_Printer$$anon$2 as $d_Lio_circe_Printer$$anon$2 };
/** @constructor */
function $c_Lio_circe_Printer$PiecesAtDepth() {
}
export { $c_Lio_circe_Printer$PiecesAtDepth as $c_Lio_circe_Printer$PiecesAtDepth };
$c_Lio_circe_Printer$PiecesAtDepth.prototype = new $h_O();
$c_Lio_circe_Printer$PiecesAtDepth.prototype.constructor = $c_Lio_circe_Printer$PiecesAtDepth;
/** @constructor */
function $h_Lio_circe_Printer$PiecesAtDepth() {
}
export { $h_Lio_circe_Printer$PiecesAtDepth as $h_Lio_circe_Printer$PiecesAtDepth };
$h_Lio_circe_Printer$PiecesAtDepth.prototype = $c_Lio_circe_Printer$PiecesAtDepth.prototype;
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal() {
}
export { $c_Lio_circe_numbers_BiggerDecimal as $c_Lio_circe_numbers_BiggerDecimal };
$c_Lio_circe_numbers_BiggerDecimal.prototype = new $h_O();
$c_Lio_circe_numbers_BiggerDecimal.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal() {
}
export { $h_Lio_circe_numbers_BiggerDecimal as $h_Lio_circe_numbers_BiggerDecimal };
$h_Lio_circe_numbers_BiggerDecimal.prototype = $c_Lio_circe_numbers_BiggerDecimal.prototype;
/** @constructor */
function $c_jl_Byte$() {
}
export { $c_jl_Byte$ as $c_jl_Byte$ };
$c_jl_Byte$.prototype = new $h_O();
$c_jl_Byte$.prototype.constructor = $c_jl_Byte$;
/** @constructor */
function $h_jl_Byte$() {
}
export { $h_jl_Byte$ as $h_jl_Byte$ };
$h_jl_Byte$.prototype = $c_jl_Byte$.prototype;
$c_jl_Byte$.prototype.parseByte__T__I__B = (function(s, radix) {
  var this$1 = $m_jl_Integer$();
  if (((radix < 2) || (radix > 36))) {
    this$1.parseIntFail__T__E(s);
  }
  var r = this$1.java$lang$Integer$$parseIntImpl__T__I__I__I(s, radix, ((2147483648 / ($checkIntDivisor(radix) >>> 0)) | 0));
  if (((r < (-128)) || (r > 127))) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
  } else {
    return ((r << 24) >> 24);
  }
});
var $d_jl_Byte$ = new $TypeData().initClass($c_jl_Byte$, "java.lang.Byte$", ({
  jl_Byte$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_Byte$ as $d_jl_Byte$ };
var $n_jl_Byte$;
function $m_jl_Byte$() {
  if ((!$n_jl_Byte$)) {
    $n_jl_Byte$ = new $c_jl_Byte$();
  }
  return $n_jl_Byte$;
}
export { $m_jl_Byte$ as $m_jl_Byte$ };
function $p_jl_Character$__getTypeGE256__I__I($thiz, codePoint) {
  return $p_jl_Character$__charTypes__AI($thiz).u[$p_jl_Character$__findIndexOfRange__AI__I__Z__I($thiz, $p_jl_Character$__charTypeIndices__AI($thiz), codePoint, false)];
}
export { $p_jl_Character$__getTypeGE256__I__I as $p_jl_Character$__getTypeGE256__I__I };
function $p_jl_Character$__java$lang$Character$$charTypesFirst256$lzycompute__AI($thiz) {
  if (((((1 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_java$lang$Character$$charTypesFirst256 = new $ac_I(new Int32Array([15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 12, 24, 24, 24, 26, 24, 24, 24, 21, 22, 24, 25, 24, 20, 24, 24, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 24, 24, 25, 25, 25, 24, 24, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 21, 24, 22, 27, 23, 27, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 21, 25, 22, 25, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 12, 24, 26, 26, 26, 26, 28, 24, 27, 28, 5, 29, 25, 16, 28, 27, 28, 25, 11, 11, 27, 2, 24, 24, 27, 11, 5, 30, 11, 11, 11, 24, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 25, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 25, 2, 2, 2, 2, 2, 2, 2, 2]));
    $thiz.jl_Character$__f_bitmap$0 = (((1 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Character$__f_java$lang$Character$$charTypesFirst256;
}
export { $p_jl_Character$__java$lang$Character$$charTypesFirst256$lzycompute__AI as $p_jl_Character$__java$lang$Character$$charTypesFirst256$lzycompute__AI };
function $p_jl_Character$__charTypeIndices$lzycompute__AI($thiz) {
  if (((((2 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    var deltas = new $ac_I(new Int32Array([257, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 3, 2, 1, 1, 1, 2, 1, 3, 2, 4, 1, 2, 1, 3, 3, 2, 1, 2, 1, 1, 1, 1, 1, 2, 1, 1, 2, 1, 1, 2, 1, 3, 1, 1, 1, 2, 2, 1, 1, 3, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 7, 2, 1, 2, 2, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 69, 1, 27, 18, 4, 12, 14, 5, 7, 1, 1, 1, 17, 112, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 3, 1, 1, 4, 2, 1, 1, 3, 1, 1, 1, 2, 1, 17, 1, 9, 35, 1, 2, 3, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 1, 1, 1, 1, 2, 2, 51, 48, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 38, 2, 1, 6, 41, 1, 1, 2, 2, 1, 1, 45, 1, 1, 1, 2, 1, 2, 1, 1, 8, 27, 4, 4, 2, 11, 6, 3, 2, 1, 2, 2, 11, 1, 1, 3, 32, 1, 10, 21, 10, 4, 2, 1, 99, 1, 1, 7, 1, 1, 6, 2, 2, 1, 4, 2, 10, 3, 2, 1, 14, 1, 1, 1, 1, 30, 27, 2, 89, 11, 1, 14, 10, 33, 9, 2, 1, 3, 1, 2, 1, 2, 22, 4, 1, 9, 1, 3, 1, 5, 2, 15, 1, 25, 3, 2, 1, 1, 11, 5, 24, 1, 6, 1, 2, 6, 8, 41, 1, 24, 1, 32, 1, 54, 1, 1, 1, 1, 3, 8, 4, 1, 2, 1, 7, 10, 2, 2, 10, 1, 1, 15, 1, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 1, 3, 4, 2, 1, 1, 3, 4, 2, 2, 2, 2, 1, 1, 8, 1, 4, 2, 1, 3, 2, 2, 10, 2, 2, 6, 1, 1, 1, 1, 1, 2, 2, 1, 1, 6, 4, 2, 2, 22, 1, 7, 1, 2, 1, 2, 1, 2, 2, 1, 1, 3, 2, 4, 2, 2, 3, 3, 1, 7, 4, 1, 1, 7, 10, 2, 3, 1, 1, 10, 2, 1, 1, 9, 1, 3, 1, 22, 1, 7, 1, 2, 1, 5, 2, 1, 1, 3, 5, 1, 2, 1, 1, 2, 1, 2, 1, 15, 2, 2, 2, 10, 1, 1, 7, 1, 6, 1, 1, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 2, 1, 5, 2, 1, 1, 1, 1, 1, 4, 2, 2, 2, 2, 1, 7, 2, 1, 4, 2, 1, 3, 2, 2, 10, 1, 1, 6, 10, 1, 1, 1, 6, 3, 3, 1, 4, 3, 2, 1, 1, 1, 2, 3, 2, 3, 3, 3, 12, 4, 2, 1, 2, 3, 3, 1, 3, 1, 2, 1, 6, 1, 14, 10, 3, 6, 1, 1, 5, 1, 3, 1, 8, 1, 3, 1, 23, 1, 16, 2, 1, 1, 3, 4, 1, 3, 1, 4, 7, 2, 1, 3, 2, 1, 2, 2, 2, 2, 10, 7, 1, 7, 1, 1, 1, 2, 1, 8, 1, 3, 1, 23, 1, 10, 1, 5, 2, 1, 1, 1, 1, 5, 1, 1, 2, 1, 2, 2, 7, 2, 6, 2, 1, 2, 2, 2, 10, 1, 2, 1, 12, 2, 2, 9, 1, 3, 1, 41, 2, 1, 3, 4, 1, 3, 1, 3, 1, 1, 1, 4, 3, 1, 7, 3, 2, 2, 10, 9, 1, 6, 1, 1, 2, 1, 18, 3, 24, 1, 9, 1, 1, 2, 7, 3, 1, 4, 3, 3, 1, 1, 1, 8, 6, 10, 2, 2, 1, 12, 48, 1, 2, 7, 4, 1, 6, 1, 8, 1, 10, 2, 37, 2, 1, 1, 1, 5, 1, 24, 1, 1, 1, 10, 1, 2, 9, 1, 2, 5, 1, 1, 1, 7, 1, 10, 2, 4, 32, 1, 3, 15, 1, 1, 3, 2, 6, 10, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 8, 1, 36, 4, 14, 1, 5, 1, 2, 5, 11, 1, 36, 1, 8, 1, 6, 1, 2, 5, 4, 2, 37, 43, 2, 4, 1, 6, 1, 2, 2, 2, 1, 10, 6, 6, 2, 2, 4, 3, 1, 3, 2, 7, 3, 4, 13, 1, 2, 2, 6, 1, 1, 1, 10, 3, 1, 2, 38, 1, 1, 5, 1, 2, 43, 1, 1, 3, 329, 1, 4, 2, 7, 1, 1, 1, 4, 2, 41, 1, 4, 2, 33, 1, 4, 2, 7, 1, 1, 1, 4, 2, 15, 1, 57, 1, 4, 2, 67, 2, 3, 9, 20, 3, 16, 10, 6, 86, 2, 6, 2, 1, 620, 1, 1, 17, 1, 26, 1, 1, 3, 75, 3, 3, 8, 7, 18, 3, 1, 9, 19, 2, 1, 2, 9, 18, 2, 12, 13, 1, 3, 1, 2, 12, 52, 2, 1, 7, 8, 1, 2, 11, 3, 1, 3, 1, 1, 1, 2, 10, 6, 10, 6, 6, 1, 4, 3, 1, 1, 10, 6, 35, 1, 53, 7, 5, 2, 34, 1, 1, 5, 70, 10, 31, 1, 3, 4, 2, 3, 4, 2, 1, 6, 3, 4, 1, 3, 2, 10, 30, 2, 5, 11, 44, 4, 26, 6, 10, 1, 3, 34, 23, 2, 2, 1, 2, 2, 53, 1, 1, 1, 7, 1, 1, 1, 1, 2, 8, 6, 10, 2, 1, 10, 6, 10, 6, 7, 1, 6, 2, 14, 1, 16, 49, 4, 1, 47, 1, 1, 5, 1, 1, 5, 1, 2, 8, 3, 10, 7, 10, 9, 9, 2, 1, 2, 1, 30, 1, 4, 2, 2, 1, 3, 2, 10, 44, 1, 1, 2, 3, 1, 1, 3, 2, 8, 4, 36, 8, 8, 2, 2, 3, 5, 10, 3, 3, 10, 30, 6, 2, 9, 7, 43, 2, 3, 8, 8, 3, 1, 13, 1, 7, 4, 1, 6, 1, 2, 1, 2, 1, 5, 44, 63, 13, 1, 34, 37, 64, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 8, 6, 2, 6, 2, 8, 8, 8, 8, 6, 2, 6, 2, 8, 1, 1, 1, 1, 1, 1, 1, 1, 8, 8, 14, 2, 8, 8, 8, 8, 8, 8, 5, 1, 2, 4, 1, 1, 1, 3, 3, 1, 2, 4, 1, 3, 4, 2, 2, 4, 1, 3, 8, 5, 3, 2, 3, 1, 2, 4, 1, 2, 1, 11, 5, 6, 2, 1, 1, 1, 2, 1, 1, 1, 8, 1, 1, 5, 1, 9, 1, 1, 4, 2, 3, 1, 1, 1, 11, 1, 1, 1, 10, 1, 5, 1, 10, 1, 1, 2, 6, 3, 1, 1, 1, 10, 3, 1, 1, 1, 13, 3, 33, 15, 13, 4, 1, 3, 12, 15, 2, 1, 4, 1, 2, 1, 3, 2, 3, 1, 1, 1, 2, 1, 5, 6, 1, 1, 1, 1, 1, 1, 4, 1, 1, 4, 1, 4, 1, 2, 2, 2, 5, 1, 4, 1, 1, 2, 1, 1, 16, 35, 1, 1, 4, 1, 2, 4, 5, 5, 2, 4, 1, 2, 1, 2, 1, 7, 1, 31, 2, 2, 1, 1, 1, 31, 268, 8, 1, 1, 1, 1, 20, 2, 7, 1, 1, 81, 1, 30, 25, 40, 6, 69, 25, 11, 21, 60, 78, 22, 183, 1, 9, 1, 54, 8, 111, 1, 248, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 30, 44, 5, 1, 1, 31, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 16, 256, 131, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 63, 1, 1, 1, 1, 32, 1, 1, 258, 48, 21, 2, 6, 39, 2, 32, 1, 105, 48, 48, 1, 1, 3, 2, 1, 1, 1, 1, 1, 1, 4, 1, 1, 2, 1, 6, 2, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 6, 1, 1, 1, 1, 3, 1, 1, 5, 4, 1, 2, 38, 1, 1, 5, 1, 2, 56, 7, 1, 1, 14, 1, 23, 9, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 7, 1, 32, 2, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 9, 1, 2, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 10, 2, 4, 1, 1, 1, 13, 2, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 34, 26, 1, 89, 12, 214, 26, 12, 4, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 9, 4, 2, 1, 5, 2, 3, 1, 1, 1, 2, 1, 86, 2, 2, 2, 2, 1, 1, 90, 1, 3, 1, 5, 43, 1, 94, 1, 2, 4, 10, 32, 36, 12, 16, 31, 1, 10, 30, 8, 1, 15, 32, 10, 39, 15, 320, 6592, 64, 21013, 1, 1143, 3, 55, 9, 40, 6, 2, 268, 1, 3, 16, 10, 2, 20, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 70, 10, 2, 6, 8, 23, 9, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 8, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 5, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 5, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 24, 3, 1, 1, 1, 2, 1, 7, 1, 3, 1, 4, 1, 23, 2, 2, 1, 4, 1, 3, 6, 2, 1, 1, 6, 52, 4, 8, 2, 50, 16, 2, 8, 2, 10, 6, 18, 6, 3, 1, 1, 2, 1, 10, 28, 8, 2, 23, 11, 2, 11, 1, 29, 3, 3, 1, 47, 1, 2, 4, 2, 2, 3, 13, 1, 1, 10, 4, 2, 5, 1, 1, 9, 10, 5, 1, 41, 6, 2, 2, 2, 2, 9, 3, 1, 8, 1, 1, 2, 10, 2, 4, 16, 1, 6, 3, 1, 1, 1, 1, 50, 1, 1, 3, 2, 2, 5, 2, 1, 1, 1, 24, 2, 1, 2, 11, 1, 2, 2, 2, 1, 2, 1, 1, 10, 6, 2, 6, 2, 6, 9, 7, 1, 7, 1, 43, 1, 4, 9, 1, 2, 4, 80, 35, 2, 1, 2, 1, 2, 1, 1, 1, 2, 10, 6, 11172, 12, 23, 4, 49, 4, 2048, 6400, 366, 2, 106, 38, 7, 12, 5, 5, 1, 1, 10, 1, 13, 1, 5, 1, 1, 1, 2, 1, 2, 1, 108, 17, 16, 363, 1, 1, 16, 64, 2, 54, 7, 1, 32, 12, 1, 3, 16, 7, 1, 1, 1, 6, 16, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 4, 3, 3, 1, 4, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 3, 1, 1, 1, 2, 4, 5, 1, 135, 2, 1, 1, 3, 1, 3, 1, 1, 1, 1, 1, 1, 2, 10, 2, 3, 2, 26, 1, 1, 1, 1, 1, 1, 26, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 10, 1, 45, 2, 31, 3, 6, 2, 6, 2, 6, 2, 3, 3, 2, 1, 1, 1, 2, 1, 1, 4, 2, 10, 3, 2, 2, 12, 1, 26, 1, 19, 1, 2, 1, 15, 2, 14, 34, 123, 5, 3, 4, 45, 3, 9, 53, 4, 17, 2, 3, 1, 13, 3, 1, 47, 45, 1, 130, 29, 3, 49, 15, 1, 27, 4, 32, 4, 9, 20, 1, 8, 1, 5, 38, 5, 5, 30, 1, 1, 36, 4, 8, 1, 5, 42, 40, 40, 78, 2, 10, 6, 36, 4, 36, 4, 40, 8, 52, 11, 1, 11, 1, 15, 1, 7, 1, 2, 1, 11, 1, 15, 1, 7, 1, 2, 67, 311, 9, 22, 10, 8, 24, 6, 1, 42, 1, 9, 69, 6, 2, 1, 1, 44, 1, 2, 3, 1, 2, 23, 1, 1, 8, 23, 2, 7, 31, 8, 9, 48, 19, 1, 2, 5, 5, 22, 6, 3, 1, 26, 5, 1, 64, 56, 4, 2, 2, 16, 2, 46, 1, 3, 1, 2, 5, 4, 4, 1, 3, 1, 29, 2, 3, 4, 1, 9, 7, 9, 7, 29, 2, 1, 29, 3, 32, 8, 1, 28, 2, 4, 5, 7, 9, 54, 3, 7, 22, 2, 8, 19, 5, 8, 18, 7, 4, 12, 7, 80, 73, 55, 51, 13, 51, 7, 6, 36, 4, 8, 10, 294, 31, 1, 42, 1, 2, 1, 2, 2, 75, 3, 29, 10, 1, 8, 22, 11, 4, 5, 22, 18, 4, 4, 38, 21, 7, 20, 23, 9, 1, 1, 1, 53, 15, 7, 4, 20, 10, 1, 2, 2, 1, 9, 3, 1, 45, 3, 4, 2, 2, 2, 1, 4, 1, 10, 1, 2, 25, 7, 10, 6, 3, 36, 5, 1, 8, 1, 10, 4, 1, 2, 1, 8, 35, 1, 2, 1, 9, 2, 1, 48, 3, 9, 2, 4, 4, 4, 1, 1, 1, 10, 1, 1, 1, 3, 1, 20, 11, 18, 1, 25, 3, 3, 2, 1, 1, 2, 6, 1, 2, 1, 62, 7, 1, 1, 1, 4, 1, 15, 1, 10, 1, 6, 47, 1, 3, 8, 5, 10, 6, 2, 2, 1, 8, 2, 2, 2, 22, 1, 7, 1, 2, 1, 5, 1, 2, 1, 2, 1, 4, 2, 2, 2, 3, 2, 1, 6, 1, 5, 5, 2, 2, 7, 3, 5, 139, 53, 3, 8, 2, 3, 1, 1, 4, 5, 10, 2, 1, 1, 1, 3, 30, 48, 3, 6, 1, 1, 4, 2, 1, 2, 2, 1, 1, 8, 10, 166, 47, 3, 4, 2, 4, 2, 1, 2, 23, 4, 2, 34, 48, 3, 8, 2, 1, 1, 2, 3, 1, 11, 10, 6, 13, 19, 43, 1, 1, 1, 2, 6, 1, 1, 1, 1, 6, 10, 54, 27, 2, 3, 2, 4, 1, 5, 4, 10, 2, 3, 1, 7, 185, 44, 3, 9, 1, 2, 1, 100, 32, 32, 10, 9, 12, 8, 2, 1, 2, 8, 1, 2, 1, 24, 6, 1, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 3, 9, 10, 70, 8, 2, 39, 3, 4, 2, 2, 4, 1, 1, 1, 1, 1, 27, 1, 10, 40, 6, 1, 1, 4, 8, 1, 8, 1, 6, 2, 3, 46, 13, 1, 2, 3, 1, 5, 13, 73, 7, 10, 246, 9, 1, 37, 1, 7, 1, 6, 1, 1, 1, 5, 10, 10, 19, 3, 2, 30, 2, 22, 1, 1, 7, 1, 2, 1, 2, 73, 7, 1, 2, 1, 38, 6, 3, 1, 1, 2, 1, 7, 1, 1, 8, 10, 6, 6, 1, 2, 1, 32, 5, 1, 2, 1, 2, 1, 1, 1, 1, 7, 10, 310, 19, 2, 2, 2, 7, 2, 1, 1, 13, 1, 34, 2, 5, 3, 2, 1, 1, 1, 13, 10, 86, 1, 15, 21, 8, 4, 17, 13, 1, 922, 102, 111, 1, 5, 11, 196, 2636, 97, 2, 13, 1072, 16, 1, 6, 15, 4010, 583, 8633, 569, 7, 31, 1, 10, 4, 2, 79, 1, 10, 6, 30, 2, 5, 1, 10, 48, 7, 5, 4, 4, 1, 1, 10, 10, 1, 7, 1, 21, 5, 19, 688, 32, 32, 23, 4, 101, 75, 4, 1, 1, 55, 7, 4, 13, 64, 2, 1, 1, 1, 11, 2, 14, 6136, 8, 1238, 42, 9, 8935, 4, 1, 7, 1, 2, 1, 291, 15, 1, 29, 3, 2, 1, 14, 4, 8, 396, 2308, 107, 5, 13, 3, 9, 7, 10, 2, 1, 2, 1, 4, 4700, 46, 2, 23, 9, 116, 60, 246, 10, 39, 2, 60, 2, 3, 3, 6, 8, 8, 2, 7, 30, 4, 61, 21, 66, 3, 1, 122, 20, 12, 20, 12, 87, 9, 25, 135, 26, 26, 26, 7, 1, 18, 26, 26, 1, 1, 2, 2, 1, 2, 2, 2, 4, 1, 8, 4, 1, 1, 1, 7, 1, 11, 26, 26, 2, 1, 4, 2, 8, 1, 7, 1, 26, 2, 1, 4, 1, 5, 1, 1, 3, 7, 1, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 28, 2, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 25, 1, 25, 1, 6, 1, 1, 2, 50, 512, 55, 4, 50, 8, 1, 14, 1, 2, 5, 15, 5, 1, 15, 1104, 10, 1, 20, 6, 6, 213, 7, 1, 17, 2, 7, 1, 2, 1, 5, 5, 62, 33, 1, 112, 45, 3, 7, 7, 2, 10, 4, 1, 1, 320, 30, 1, 17, 44, 4, 10, 5, 1, 464, 27, 1, 4, 10, 742, 7, 1, 4, 1, 2, 1, 15, 1, 197, 2, 9, 7, 41, 34, 34, 7, 1, 4, 10, 4, 2, 785, 59, 1, 3, 1, 4, 76, 45, 1, 15, 194, 4, 1, 27, 1, 2, 1, 1, 2, 1, 1, 10, 1, 4, 1, 1, 1, 1, 6, 1, 4, 1, 1, 1, 1, 1, 1, 3, 1, 2, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 2, 4, 1, 7, 1, 4, 1, 4, 1, 1, 1, 10, 1, 17, 5, 3, 1, 5, 1, 17, 52, 2, 270, 44, 4, 100, 12, 15, 2, 15, 1, 15, 1, 37, 10, 13, 161, 56, 29, 13, 44, 4, 9, 7, 2, 14, 6, 154, 251, 5, 728, 4, 17, 3, 13, 3, 119, 4, 95, 6, 12, 4, 1, 15, 12, 4, 56, 8, 10, 6, 40, 8, 30, 2, 2, 78, 340, 12, 14, 2, 13, 3, 9, 7, 46, 1, 7, 8, 14, 4, 9, 7, 9, 7, 147, 1, 55, 37, 10, 1030, 42720, 32, 4154, 6, 222, 2, 5762, 14, 7473, 3103, 542, 1506, 4939, 5, 4192, 711761, 1, 30, 96, 128, 240, 65040, 65534, 2, 65534]));
    $thiz.jl_Character$__f_charTypeIndices = $p_jl_Character$__uncompressDeltas__AI__AI($thiz, deltas);
    $thiz.jl_Character$__f_bitmap$0 = (((2 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Character$__f_charTypeIndices;
}
export { $p_jl_Character$__charTypeIndices$lzycompute__AI as $p_jl_Character$__charTypeIndices$lzycompute__AI };
function $p_jl_Character$__charTypeIndices__AI($thiz) {
  return (((((2 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__charTypeIndices$lzycompute__AI($thiz) : $thiz.jl_Character$__f_charTypeIndices);
}
export { $p_jl_Character$__charTypeIndices__AI as $p_jl_Character$__charTypeIndices__AI };
function $p_jl_Character$__charTypes$lzycompute__AI($thiz) {
  if (((((4 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_charTypes = new $ac_I(new Int32Array([1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 1, 2, 5, 1, 3, 2, 1, 3, 2, 1, 3, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 3, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 2, 4, 27, 4, 27, 4, 27, 4, 27, 4, 27, 6, 1, 2, 1, 2, 4, 27, 1, 2, 0, 4, 2, 24, 1, 0, 27, 1, 24, 1, 0, 1, 0, 1, 2, 1, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 25, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 28, 6, 7, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 0, 4, 24, 2, 24, 20, 0, 28, 26, 0, 6, 20, 6, 24, 6, 24, 6, 24, 6, 0, 5, 0, 5, 24, 0, 16, 25, 24, 26, 24, 28, 6, 24, 16, 24, 5, 4, 5, 6, 9, 24, 5, 6, 5, 24, 5, 6, 16, 28, 6, 4, 6, 28, 6, 5, 9, 5, 28, 5, 24, 0, 16, 5, 6, 5, 6, 0, 5, 6, 5, 0, 9, 5, 6, 4, 28, 24, 4, 0, 6, 26, 5, 6, 4, 6, 4, 6, 4, 6, 0, 24, 0, 5, 6, 0, 24, 0, 5, 0, 5, 27, 5, 0, 16, 0, 6, 5, 4, 6, 16, 6, 8, 5, 6, 8, 6, 5, 8, 6, 8, 6, 8, 5, 6, 5, 6, 24, 9, 24, 4, 5, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 0, 8, 0, 8, 6, 5, 0, 8, 0, 5, 0, 5, 6, 0, 9, 5, 26, 11, 28, 26, 5, 24, 6, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 0, 8, 6, 0, 6, 0, 6, 0, 6, 0, 5, 0, 5, 0, 9, 6, 5, 6, 24, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 0, 6, 8, 0, 8, 6, 0, 5, 0, 5, 6, 0, 9, 24, 26, 0, 5, 6, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 6, 0, 8, 0, 8, 6, 0, 6, 8, 0, 5, 0, 5, 6, 0, 9, 28, 5, 11, 0, 6, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 8, 6, 8, 0, 8, 0, 8, 6, 0, 5, 0, 8, 0, 9, 11, 28, 26, 28, 0, 6, 8, 6, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 6, 8, 0, 6, 0, 6, 0, 6, 0, 5, 0, 5, 0, 5, 6, 0, 9, 0, 24, 11, 28, 5, 6, 8, 24, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 0, 6, 8, 0, 8, 6, 0, 8, 0, 5, 0, 5, 6, 0, 9, 0, 5, 8, 0, 6, 8, 5, 0, 5, 0, 5, 6, 5, 8, 6, 0, 8, 0, 8, 6, 5, 28, 0, 5, 8, 11, 5, 6, 0, 9, 11, 28, 5, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 0, 8, 6, 0, 6, 0, 8, 0, 9, 0, 8, 24, 0, 5, 6, 5, 6, 0, 26, 5, 4, 6, 24, 9, 24, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 6, 5, 6, 5, 0, 5, 0, 4, 0, 6, 0, 9, 0, 5, 0, 5, 28, 24, 28, 24, 28, 6, 28, 9, 11, 28, 6, 28, 6, 28, 6, 21, 22, 21, 22, 8, 5, 0, 5, 0, 6, 8, 6, 24, 6, 5, 6, 0, 6, 0, 28, 6, 28, 0, 28, 24, 28, 24, 0, 5, 8, 6, 8, 6, 8, 6, 8, 6, 5, 9, 24, 5, 8, 6, 5, 6, 5, 8, 5, 8, 5, 6, 5, 6, 8, 6, 8, 6, 5, 8, 9, 8, 6, 28, 1, 0, 1, 0, 1, 0, 2, 24, 4, 2, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 24, 11, 0, 5, 28, 0, 1, 0, 2, 0, 20, 5, 28, 24, 5, 12, 5, 21, 22, 0, 5, 24, 10, 5, 0, 5, 6, 8, 0, 5, 6, 8, 24, 0, 5, 6, 0, 5, 0, 5, 0, 6, 0, 5, 6, 8, 6, 8, 6, 8, 6, 24, 4, 24, 26, 5, 6, 0, 9, 0, 11, 0, 24, 20, 24, 6, 16, 6, 9, 0, 5, 4, 5, 0, 5, 6, 5, 6, 5, 0, 5, 0, 5, 0, 6, 8, 6, 8, 0, 8, 6, 8, 6, 0, 28, 0, 24, 9, 5, 0, 5, 0, 5, 0, 5, 0, 9, 11, 0, 28, 5, 6, 8, 6, 0, 24, 5, 8, 6, 8, 6, 0, 6, 8, 6, 8, 6, 8, 6, 0, 6, 9, 0, 9, 0, 24, 4, 24, 0, 6, 7, 6, 0, 6, 8, 5, 6, 8, 6, 8, 6, 8, 6, 8, 5, 0, 9, 24, 28, 6, 28, 24, 0, 6, 8, 5, 8, 6, 8, 6, 8, 6, 5, 9, 5, 6, 8, 6, 8, 6, 8, 6, 8, 0, 24, 5, 8, 6, 8, 6, 0, 24, 9, 0, 5, 9, 5, 4, 24, 2, 0, 1, 0, 1, 24, 0, 6, 24, 6, 8, 6, 5, 6, 5, 6, 5, 8, 6, 5, 0, 2, 4, 2, 4, 2, 4, 6, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 0, 2, 1, 2, 1, 2, 0, 1, 0, 2, 0, 1, 0, 1, 0, 1, 0, 1, 2, 1, 2, 0, 2, 3, 2, 3, 2, 3, 2, 0, 2, 1, 3, 27, 2, 27, 2, 0, 2, 1, 3, 27, 2, 0, 2, 1, 0, 27, 2, 1, 27, 0, 2, 0, 2, 1, 3, 27, 0, 12, 16, 20, 24, 29, 30, 21, 29, 30, 21, 29, 24, 13, 14, 16, 12, 24, 29, 30, 24, 23, 24, 25, 21, 22, 24, 25, 24, 23, 24, 12, 16, 0, 16, 11, 4, 0, 11, 25, 21, 22, 4, 11, 25, 21, 22, 0, 4, 0, 26, 0, 6, 7, 6, 7, 6, 0, 28, 1, 28, 1, 28, 2, 1, 2, 1, 2, 28, 1, 28, 25, 1, 28, 1, 28, 1, 28, 1, 28, 1, 28, 2, 1, 2, 5, 2, 28, 2, 1, 25, 1, 2, 28, 25, 28, 2, 28, 11, 10, 1, 2, 10, 11, 28, 0, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 25, 28, 21, 22, 21, 22, 28, 25, 28, 21, 22, 28, 25, 28, 25, 28, 25, 28, 0, 28, 0, 11, 28, 11, 28, 25, 28, 25, 28, 25, 28, 25, 28, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 11, 28, 25, 21, 22, 25, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 25, 28, 25, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 25, 21, 22, 21, 22, 25, 21, 22, 25, 28, 25, 28, 25, 28, 0, 28, 0, 28, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 28, 1, 2, 1, 2, 6, 1, 2, 0, 24, 11, 24, 2, 0, 2, 0, 2, 0, 5, 0, 4, 24, 0, 6, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 24, 29, 30, 29, 30, 24, 29, 30, 24, 29, 30, 24, 20, 24, 20, 24, 29, 30, 24, 29, 30, 21, 22, 21, 22, 21, 22, 21, 22, 24, 4, 24, 20, 24, 20, 24, 21, 24, 28, 24, 21, 22, 21, 22, 21, 22, 21, 22, 20, 0, 28, 0, 28, 0, 28, 0, 28, 0, 12, 24, 28, 4, 5, 10, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 28, 21, 22, 21, 22, 21, 22, 21, 22, 20, 21, 22, 28, 10, 6, 8, 20, 4, 28, 10, 4, 5, 24, 28, 0, 5, 0, 6, 27, 4, 5, 20, 5, 24, 4, 5, 0, 5, 0, 5, 0, 28, 11, 28, 5, 28, 0, 5, 28, 0, 11, 28, 11, 28, 11, 28, 11, 28, 11, 28, 5, 28, 5, 4, 5, 0, 28, 0, 5, 4, 24, 5, 4, 24, 5, 9, 5, 0, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 5, 6, 7, 24, 6, 24, 4, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 6, 5, 10, 6, 24, 0, 27, 4, 27, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 4, 27, 1, 2, 1, 2, 5, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 2, 0, 2, 0, 2, 1, 2, 1, 2, 0, 4, 1, 2, 5, 4, 2, 5, 6, 5, 6, 5, 6, 5, 8, 6, 8, 28, 6, 0, 11, 28, 26, 28, 0, 5, 24, 0, 8, 5, 8, 6, 0, 24, 9, 0, 6, 5, 24, 5, 24, 5, 6, 9, 5, 6, 24, 5, 6, 8, 0, 24, 5, 0, 6, 8, 5, 6, 8, 6, 8, 6, 8, 24, 0, 4, 9, 0, 24, 5, 6, 4, 5, 9, 5, 0, 5, 6, 8, 6, 8, 6, 0, 5, 6, 5, 6, 8, 0, 9, 0, 24, 5, 4, 5, 28, 5, 8, 6, 8, 5, 6, 5, 6, 5, 6, 5, 6, 5, 6, 5, 0, 5, 4, 24, 5, 8, 6, 8, 24, 5, 4, 8, 6, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 2, 27, 4, 2, 4, 27, 0, 2, 5, 8, 6, 8, 6, 8, 24, 8, 6, 0, 9, 0, 5, 0, 5, 0, 5, 0, 19, 18, 5, 0, 5, 0, 2, 0, 2, 0, 5, 6, 5, 25, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 27, 0, 5, 22, 21, 28, 5, 0, 5, 0, 28, 0, 5, 26, 28, 6, 24, 21, 22, 24, 0, 6, 24, 20, 23, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 21, 22, 24, 21, 22, 24, 23, 24, 0, 24, 20, 21, 22, 21, 22, 21, 22, 24, 25, 20, 25, 0, 24, 26, 24, 0, 5, 0, 5, 0, 16, 0, 24, 26, 24, 21, 22, 24, 25, 24, 20, 24, 9, 24, 25, 24, 1, 21, 24, 22, 27, 23, 27, 2, 21, 25, 22, 25, 21, 22, 24, 21, 22, 24, 5, 4, 5, 4, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 26, 25, 27, 28, 26, 0, 28, 25, 28, 0, 16, 28, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 24, 0, 11, 0, 28, 10, 11, 28, 11, 28, 0, 28, 0, 28, 0, 28, 6, 0, 5, 0, 5, 0, 6, 11, 0, 5, 11, 0, 5, 10, 5, 10, 0, 5, 6, 0, 5, 0, 24, 5, 0, 5, 24, 10, 0, 1, 2, 5, 0, 9, 0, 1, 0, 2, 0, 5, 0, 5, 0, 24, 1, 0, 1, 0, 1, 0, 1, 0, 2, 0, 2, 0, 2, 0, 2, 0, 5, 0, 5, 0, 5, 0, 4, 0, 4, 0, 4, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 24, 11, 5, 28, 11, 5, 0, 11, 0, 5, 0, 5, 0, 11, 5, 11, 0, 24, 5, 0, 24, 0, 5, 0, 11, 5, 11, 0, 11, 5, 6, 0, 6, 0, 6, 5, 0, 5, 0, 5, 0, 6, 0, 6, 11, 0, 24, 0, 5, 11, 24, 5, 11, 0, 5, 28, 5, 6, 0, 11, 24, 0, 5, 0, 24, 5, 0, 11, 5, 0, 11, 5, 0, 24, 0, 11, 0, 5, 0, 1, 0, 2, 0, 11, 5, 6, 0, 9, 0, 11, 0, 5, 0, 6, 20, 0, 5, 0, 6, 5, 11, 5, 0, 5, 6, 11, 24, 0, 5, 6, 24, 0, 5, 11, 0, 5, 0, 8, 6, 8, 5, 6, 24, 0, 11, 9, 6, 5, 6, 5, 0, 6, 8, 5, 8, 6, 8, 6, 24, 16, 24, 6, 0, 16, 0, 5, 0, 9, 0, 6, 5, 6, 8, 6, 0, 9, 24, 5, 8, 5, 0, 5, 6, 24, 5, 0, 6, 8, 5, 8, 6, 8, 5, 24, 6, 24, 8, 6, 9, 5, 24, 5, 24, 0, 11, 0, 5, 0, 5, 8, 6, 8, 6, 8, 6, 24, 6, 5, 6, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 24, 0, 5, 6, 8, 6, 0, 9, 0, 6, 8, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 6, 5, 8, 6, 8, 0, 8, 0, 8, 0, 5, 0, 8, 0, 5, 8, 0, 6, 0, 6, 0, 5, 8, 6, 8, 6, 8, 6, 5, 24, 9, 24, 0, 24, 6, 5, 0, 5, 8, 6, 8, 6, 8, 6, 8, 6, 5, 24, 5, 0, 9, 0, 5, 8, 6, 0, 8, 6, 8, 6, 24, 5, 6, 0, 5, 8, 6, 8, 6, 8, 6, 24, 5, 0, 9, 0, 24, 0, 5, 6, 8, 6, 8, 6, 8, 6, 5, 24, 0, 9, 0, 5, 0, 6, 8, 6, 8, 6, 0, 9, 11, 24, 28, 5, 0, 5, 8, 6, 8, 6, 24, 0, 1, 2, 9, 11, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 8, 0, 8, 0, 6, 8, 6, 5, 8, 5, 8, 6, 24, 0, 9, 0, 5, 0, 5, 8, 6, 0, 6, 8, 6, 5, 24, 5, 8, 0, 5, 6, 5, 6, 8, 5, 6, 24, 6, 0, 5, 6, 8, 6, 5, 6, 8, 6, 24, 5, 24, 0, 5, 0, 24, 0, 5, 0, 5, 8, 6, 0, 6, 8, 6, 5, 24, 0, 9, 11, 0, 24, 5, 0, 6, 0, 8, 6, 8, 6, 8, 6, 0, 5, 0, 5, 0, 5, 6, 0, 6, 0, 6, 0, 6, 5, 6, 0, 9, 0, 5, 0, 5, 0, 5, 8, 0, 6, 0, 8, 6, 8, 6, 5, 0, 9, 0, 5, 6, 8, 24, 0, 6, 5, 8, 5, 0, 5, 8, 6, 0, 8, 6, 8, 6, 24, 9, 0, 5, 0, 11, 28, 26, 28, 0, 24, 5, 0, 10, 0, 24, 0, 5, 0, 5, 24, 0, 5, 16, 6, 5, 6, 0, 5, 0, 5, 0, 5, 0, 9, 0, 24, 5, 0, 9, 0, 5, 0, 6, 24, 0, 5, 6, 24, 28, 4, 24, 28, 0, 9, 0, 11, 0, 5, 0, 5, 0, 1, 2, 11, 24, 0, 5, 0, 6, 5, 8, 0, 6, 4, 0, 4, 24, 4, 6, 0, 8, 0, 5, 0, 5, 0, 5, 0, 4, 0, 4, 0, 4, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 28, 6, 24, 16, 0, 6, 0, 6, 0, 28, 0, 28, 0, 28, 0, 28, 8, 6, 28, 8, 16, 6, 28, 6, 28, 6, 28, 0, 28, 6, 28, 0, 11, 0, 11, 0, 28, 0, 11, 0, 1, 2, 1, 2, 0, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 2, 0, 2, 0, 2, 0, 2, 1, 2, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 1, 2, 0, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 25, 2, 25, 2, 1, 2, 0, 9, 28, 6, 28, 6, 28, 6, 28, 6, 28, 24, 0, 6, 0, 6, 0, 2, 5, 2, 0, 2, 0, 6, 0, 6, 0, 6, 0, 6, 0, 6, 0, 4, 0, 6, 0, 5, 0, 6, 4, 0, 9, 0, 5, 28, 0, 5, 6, 0, 5, 6, 9, 0, 26, 0, 5, 4, 6, 9, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 11, 6, 0, 1, 2, 6, 4, 0, 9, 0, 24, 0, 11, 28, 11, 26, 11, 0, 11, 28, 11, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 25, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 11, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 27, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 28, 0, 9, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 5, 0, 16, 0, 16, 0, 6, 0, 18, 0, 18, 0]));
    $thiz.jl_Character$__f_bitmap$0 = (((4 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Character$__f_charTypes;
}
export { $p_jl_Character$__charTypes$lzycompute__AI as $p_jl_Character$__charTypes$lzycompute__AI };
function $p_jl_Character$__charTypes__AI($thiz) {
  return (((((4 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__charTypes$lzycompute__AI($thiz) : $thiz.jl_Character$__f_charTypes);
}
export { $p_jl_Character$__charTypes__AI as $p_jl_Character$__charTypes__AI };
function $p_jl_Character$__combiningClassNoneOrAboveOrOtherIndices$lzycompute__AI($thiz) {
  if (((((16 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    var deltas = new $ac_I(new Int32Array([768, 21, 40, 0, 8, 1, 0, 1, 3, 0, 3, 2, 1, 3, 4, 0, 1, 3, 0, 1, 7, 0, 13, 0, 275, 5, 0, 265, 0, 1, 0, 4, 1, 0, 3, 2, 0, 6, 6, 0, 2, 1, 0, 2, 2, 0, 1, 14, 1, 0, 1, 1, 0, 2, 1, 1, 1, 1, 0, 1, 72, 8, 3, 48, 0, 8, 0, 2, 2, 0, 5, 1, 0, 2, 1, 16, 0, 1, 101, 7, 0, 2, 4, 1, 0, 1, 0, 2, 2, 0, 1, 0, 1, 0, 2, 1, 35, 0, 1, 30, 1, 1, 0, 2, 1, 0, 2, 3, 0, 1, 2, 0, 1, 1, 0, 3, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 2, 0, 160, 7, 1, 0, 1, 0, 9, 0, 1, 24, 4, 0, 1, 9, 0, 1, 3, 0, 1, 5, 0, 43, 0, 3, 59, 2, 3, 0, 4, 0, 42, 5, 5, 0, 14, 0, 1, 0, 1, 0, 2, 1, 0, 2, 1, 0, 3, 6, 0, 3, 1, 0, 2, 2, 0, 5, 0, 60, 0, 1, 16, 0, 1, 3, 1, 1, 0, 2, 0, 103, 0, 1, 16, 0, 1, 48, 1, 0, 61, 0, 1, 16, 0, 1, 110, 0, 1, 16, 0, 1, 110, 0, 1, 16, 0, 1, 127, 0, 1, 110, 0, 1, 16, 0, 1, 7, 0, 2, 101, 0, 1, 16, 0, 1, 109, 0, 2, 16, 0, 1, 124, 0, 1, 109, 0, 3, 13, 0, 4, 108, 0, 3, 13, 0, 4, 76, 0, 2, 27, 0, 1, 1, 0, 1, 1, 0, 1, 55, 0, 2, 1, 0, 1, 5, 0, 4, 2, 0, 1, 1, 2, 1, 1, 2, 0, 62, 0, 1, 112, 0, 1, 1, 0, 2, 82, 0, 1, 719, 3, 0, 948, 0, 2, 30, 0, 1, 157, 0, 1, 10, 1, 0, 203, 0, 1, 143, 0, 1, 0, 1, 1, 219, 1, 1, 71, 0, 1, 20, 8, 0, 2, 0, 1, 48, 5, 6, 0, 2, 1, 1, 0, 2, 0, 2, 2, 0, 5, 1, 0, 4, 0, 101, 0, 1, 15, 0, 1, 38, 1, 1, 0, 7, 0, 54, 0, 2, 58, 0, 1, 11, 0, 2, 67, 0, 1, 152, 3, 0, 1, 0, 6, 0, 2, 4, 0, 1, 0, 1, 0, 7, 4, 0, 1, 6, 1, 0, 3, 2, 0, 198, 2, 1, 0, 7, 1, 0, 2, 4, 0, 37, 5, 0, 1, 2, 0, 1, 1, 720, 2, 2, 0, 4, 3, 0, 2, 0, 4, 1, 0, 3, 0, 2, 0, 1, 1, 0, 1, 6, 0, 1, 0, 3070, 3, 0, 141, 0, 1, 96, 32, 0, 554, 0, 6, 105, 0, 2, 30164, 1, 0, 4, 10, 0, 32, 2, 0, 80, 2, 0, 276, 0, 1, 37, 0, 1, 151, 0, 1, 27, 18, 0, 57, 0, 3, 37, 0, 1, 95, 0, 1, 12, 0, 1, 239, 1, 0, 1, 2, 1, 2, 2, 0, 5, 2, 0, 1, 1, 0, 52, 0, 1, 246, 0, 1, 20272, 0, 1, 769, 7, 7, 0, 2, 0, 973, 0, 1, 226, 0, 1, 149, 5, 0, 1682, 0, 1, 1, 1, 0, 40, 1, 2, 4, 0, 1, 165, 1, 1, 573, 4, 0, 65, 5, 0, 317, 2, 0, 80, 0, 3, 70, 0, 2, 0, 3, 1, 0, 1, 4, 49, 1, 1, 0, 1, 1, 192, 0, 1, 41, 0, 1, 14, 0, 1, 57, 0, 2, 69, 3, 0, 48, 0, 2, 62, 0, 1, 76, 0, 1, 9, 0, 1, 106, 0, 2, 178, 0, 2, 80, 0, 2, 16, 0, 1, 24, 7, 0, 3, 5, 0, 89, 0, 3, 113, 0, 1, 3, 0, 1, 23, 1, 0, 99, 0, 2, 251, 0, 2, 126, 0, 1, 118, 0, 2, 115, 0, 1, 269, 0, 2, 258, 0, 2, 4, 0, 1, 156, 0, 1, 83, 0, 1, 18, 0, 1, 81, 0, 1, 421, 0, 1, 258, 0, 1, 1, 0, 2, 81, 0, 1, 425, 0, 2, 16876, 0, 1, 2496, 0, 5, 59, 7, 0, 1209, 0, 2, 19628, 0, 1, 5318, 0, 5, 3, 0, 6, 8, 0, 8, 2, 5, 2, 30, 4, 0, 148, 3, 0, 3515, 7, 0, 1, 17, 0, 2, 7, 0, 1, 2, 0, 1, 5, 0, 100, 1, 0, 160, 7, 0, 375, 1, 0, 61, 4, 0, 508, 0, 3, 0, 1, 0, 254, 1, 1, 736, 0, 7, 109, 6, 1]));
    $thiz.jl_Character$__f_combiningClassNoneOrAboveOrOtherIndices = $p_jl_Character$__uncompressDeltas__AI__AI($thiz, deltas);
    $thiz.jl_Character$__f_bitmap$0 = (((16 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Character$__f_combiningClassNoneOrAboveOrOtherIndices;
}
export { $p_jl_Character$__combiningClassNoneOrAboveOrOtherIndices$lzycompute__AI as $p_jl_Character$__combiningClassNoneOrAboveOrOtherIndices$lzycompute__AI };
function $p_jl_Character$__combiningClassNoneOrAboveOrOtherIndices__AI($thiz) {
  return (((((16 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__combiningClassNoneOrAboveOrOtherIndices$lzycompute__AI($thiz) : $thiz.jl_Character$__f_combiningClassNoneOrAboveOrOtherIndices);
}
export { $p_jl_Character$__combiningClassNoneOrAboveOrOtherIndices__AI as $p_jl_Character$__combiningClassNoneOrAboveOrOtherIndices__AI };
function $p_jl_Character$__uncompressDeltas__AI__AI($thiz, deltas) {
  var acc = deltas.u[0];
  var i = 1;
  var len = deltas.u.length;
  while ((i !== len)) {
    acc = ((acc + deltas.u[i]) | 0);
    deltas.u[i] = acc;
    i = ((1 + i) | 0);
  }
  return deltas;
}
export { $p_jl_Character$__uncompressDeltas__AI__AI as $p_jl_Character$__uncompressDeltas__AI__AI };
function $p_jl_Character$__findIndexOfRange__AI__I__Z__I($thiz, startOfRangesArray, value, hasEmptyRanges) {
  var i = $m_ju_Arrays$().binarySearch__AI__I__I(startOfRangesArray, value);
  if ((i >= 0)) {
    if (hasEmptyRanges) {
      var j = ((1 + i) | 0);
      while (((j < startOfRangesArray.u.length) && (startOfRangesArray.u[j] === value))) {
        j = ((1 + j) | 0);
      }
      return j;
    } else {
      return ((1 + i) | 0);
    }
  } else {
    return (((-1) - i) | 0);
  }
}
export { $p_jl_Character$__findIndexOfRange__AI__I__Z__I as $p_jl_Character$__findIndexOfRange__AI__I__Z__I };
function $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) {
  if (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints = new $ac_I(new Int32Array([1632, 1776, 1984, 2406, 2534, 2662, 2790, 2918, 3046, 3174, 3302, 3430, 3558, 3664, 3792, 3872, 4160, 4240, 6112, 6160, 6470, 6608, 6784, 6800, 6992, 7088, 7232, 7248, 42528, 43216, 43264, 43472, 43504, 43600, 44016, 65296, 66720, 68912, 69734, 69872, 69942, 70096, 70384, 70736, 70864, 71248, 71360, 71472, 71904, 72016, 72784, 73040, 73120, 73552, 92768, 92864, 93008, 120782, 120792, 120802, 120812, 120822, 123200, 123632, 124144, 125264, 130032]));
    $thiz.jl_Character$__f_bitmap$0 = (((32 | $thiz.jl_Character$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints;
}
export { $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI as $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI };
function $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI($thiz) {
  return (((((32 & $thiz.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__nonASCIIZeroDigitCodePoints$lzycompute__AI($thiz) : $thiz.jl_Character$__f_nonASCIIZeroDigitCodePoints);
}
export { $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI as $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI };
function $p_jl_Character$__isSeparator$1__I__Z($thiz, tpe) {
  return (((tpe === 12) || (tpe === 13)) || (tpe === 14));
}
export { $p_jl_Character$__isSeparator$1__I__Z as $p_jl_Character$__isSeparator$1__I__Z };
/** @constructor */
function $c_jl_Character$() {
  this.jl_Character$__f_java$lang$Character$$charTypesFirst256 = null;
  this.jl_Character$__f_charTypeIndices = null;
  this.jl_Character$__f_charTypes = null;
  this.jl_Character$__f_combiningClassNoneOrAboveOrOtherIndices = null;
  this.jl_Character$__f_nonASCIIZeroDigitCodePoints = null;
  this.jl_Character$__f_bitmap$0 = 0;
}
export { $c_jl_Character$ as $c_jl_Character$ };
$c_jl_Character$.prototype = new $h_O();
$c_jl_Character$.prototype.constructor = $c_jl_Character$;
/** @constructor */
function $h_jl_Character$() {
}
export { $h_jl_Character$ as $h_jl_Character$ };
$h_jl_Character$.prototype = $c_jl_Character$.prototype;
$c_jl_Character$.prototype.toString__I__T = (function(codePoint) {
  if ((!((codePoint >= 0) && (codePoint <= 1114111)))) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  return String.fromCodePoint(codePoint);
});
$c_jl_Character$.prototype.getType__I__I = (function(codePoint) {
  return ((codePoint < 0) ? 0 : ((codePoint < 256) ? this.java$lang$Character$$charTypesFirst256__AI().u[codePoint] : $p_jl_Character$__getTypeGE256__I__I(this, codePoint)));
});
$c_jl_Character$.prototype.digitWithValidRadix__I__I__I = (function(codePoint, radix) {
  if ((codePoint < 256)) {
    var value = (((codePoint >= 48) && (codePoint <= 57)) ? (((-48) + codePoint) | 0) : (((codePoint >= 65) && (codePoint <= 90)) ? (((-55) + codePoint) | 0) : (((codePoint >= 97) && (codePoint <= 122)) ? (((-87) + codePoint) | 0) : (-1))));
  } else if (((codePoint >= 65313) && (codePoint <= 65338))) {
    var value = (((-65303) + codePoint) | 0);
  } else if (((codePoint >= 65345) && (codePoint <= 65370))) {
    var value = (((-65335) + codePoint) | 0);
  } else {
    var p = $m_ju_Arrays$().binarySearch__AI__I__I($p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this), codePoint);
    var zeroCodePointIndex = ((p < 0) ? (((-2) - p) | 0) : p);
    if ((zeroCodePointIndex < 0)) {
      var value = (-1);
    } else {
      var v = ((codePoint - $p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this).u[zeroCodePointIndex]) | 0);
      var value = ((v > 9) ? (-1) : v);
    }
  }
  return ((value < radix) ? value : (-1));
});
$c_jl_Character$.prototype.isZeroDigit__C__Z = (function(ch) {
  return ((ch < 256) ? (ch === 48) : ($m_ju_Arrays$().binarySearch__AI__I__I($p_jl_Character$__nonASCIIZeroDigitCodePoints__AI(this), ch) >= 0));
});
$c_jl_Character$.prototype.forDigit__I__I__C = (function(digit, radix) {
  if ((((radix < 2) || (radix > 36)) || ((digit >>> 0) >= (radix >>> 0)))) {
    return 0;
  } else {
    var overBaseTen = (((-10) + digit) | 0);
    var result = ((overBaseTen < 0) ? ((48 + digit) | 0) : ((97 + overBaseTen) | 0));
    return (65535 & result);
  }
});
$c_jl_Character$.prototype.isISOControl__I__Z = (function(codePoint) {
  return (((codePoint >= 0) && (codePoint <= 31)) || ((codePoint >= 127) && (codePoint <= 159)));
});
$c_jl_Character$.prototype.isWhitespace__I__Z = (function(codePoint) {
  return ((codePoint < 256) ? (((((((codePoint === 9) || (codePoint === 10)) || (codePoint === 11)) || (codePoint === 12)) || (codePoint === 13)) || ((codePoint >= 28) && (codePoint <= 31))) || ((codePoint !== 160) && $p_jl_Character$__isSeparator$1__I__Z(this, this.java$lang$Character$$charTypesFirst256__AI().u[codePoint]))) : (((codePoint !== 8199) && (codePoint !== 8239)) && $p_jl_Character$__isSeparator$1__I__Z(this, $p_jl_Character$__getTypeGE256__I__I(this, codePoint))));
});
$c_jl_Character$.prototype.isDigit__I__Z = (function(cp) {
  if ((cp < 256)) {
    return ((cp >= 48) && (cp <= 57));
  } else {
    var tpe = $p_jl_Character$__getTypeGE256__I__I(this, cp);
    return (tpe === 9);
  }
});
$c_jl_Character$.prototype.isLetter__I__Z = (function(cp) {
  var tpe = this.getType__I__I(cp);
  return (((((tpe === 1) || (tpe === 2)) || (tpe === 3)) || (tpe === 4)) || (tpe === 5));
});
$c_jl_Character$.prototype.isLetterOrDigit__I__Z = (function(cp) {
  var tpe = this.getType__I__I(cp);
  return ((tpe === 9) || (((((tpe === 1) || (tpe === 2)) || (tpe === 3)) || (tpe === 4)) || (tpe === 5)));
});
$c_jl_Character$.prototype.isUnicodeIdentifierStart__I__Z = (function(codePoint) {
  var tpe = this.getType__I__I(codePoint);
  return ((((((tpe === 1) || (tpe === 2)) || (tpe === 3)) || (tpe === 4)) || (tpe === 5)) || (tpe === 10));
});
$c_jl_Character$.prototype.isUnicodeIdentifierPart__I__Z = (function(codePoint) {
  return this.isUnicodeIdentifierPartImpl__I__I__Z(codePoint, this.getType__I__I(codePoint));
});
$c_jl_Character$.prototype.isUnicodeIdentifierPartImpl__I__I__Z = (function(codePoint, tpe) {
  return ((((((tpe === 23) || (tpe === 9)) || (tpe === 8)) || (tpe === 6)) || ((((((tpe === 1) || (tpe === 2)) || (tpe === 3)) || (tpe === 4)) || (tpe === 5)) || (tpe === 10))) || (((((codePoint >= 0) && (codePoint <= 8)) || ((codePoint >= 14) && (codePoint <= 27))) || ((codePoint >= 127) && (codePoint <= 159))) || (tpe === 16)));
});
$c_jl_Character$.prototype.toUpperCase__C__C = (function(ch) {
  return (65535 & this.toUpperCase__I__I(ch));
});
$c_jl_Character$.prototype.toUpperCase__I__I = (function(codePoint) {
  switch (codePoint) {
    case 8115:
    case 8131:
    case 8179: {
      return ((9 + codePoint) | 0);
      break;
    }
    default: {
      if (((codePoint >= 8064) && (codePoint <= 8111))) {
        return (8 | codePoint);
      } else {
        var this$1 = this.toString__I__T(codePoint);
        var upperChars = this$1.toUpperCase();
        var x1$2 = upperChars.length;
        switch (x1$2) {
          case 1: {
            return upperChars.charCodeAt(0);
            break;
          }
          case 2: {
            var high = upperChars.charCodeAt(0);
            var low = upperChars.charCodeAt(1);
            return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
            break;
          }
          default: {
            return codePoint;
          }
        }
      }
    }
  }
});
$c_jl_Character$.prototype.toLowerCase__C__C = (function(ch) {
  return (65535 & this.toLowerCase__I__I(ch));
});
$c_jl_Character$.prototype.toLowerCase__I__I = (function(codePoint) {
  if ((codePoint === 304)) {
    return 105;
  } else {
    var this$1 = this.toString__I__T(codePoint);
    var lowerChars = this$1.toLowerCase();
    var x1$2 = lowerChars.length;
    switch (x1$2) {
      case 1: {
        return lowerChars.charCodeAt(0);
        break;
      }
      case 2: {
        var high = lowerChars.charCodeAt(0);
        var low = lowerChars.charCodeAt(1);
        return ((((-67044352) & ((high << 16) | low)) === (-671032320)) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : codePoint);
        break;
      }
      default: {
        return codePoint;
      }
    }
  }
});
$c_jl_Character$.prototype.java$lang$Character$$charTypesFirst256__AI = (function() {
  return (((((1 & this.jl_Character$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Character$__java$lang$Character$$charTypesFirst256$lzycompute__AI(this) : this.jl_Character$__f_java$lang$Character$$charTypesFirst256);
});
$c_jl_Character$.prototype.combiningClassNoneOrAboveOrOther__I__I = (function(cp) {
  var indexOfRange = $p_jl_Character$__findIndexOfRange__AI__I__Z__I(this, $p_jl_Character$__combiningClassNoneOrAboveOrOtherIndices__AI(this), cp, true);
  return ((indexOfRange % 3) | 0);
});
var $d_jl_Character$ = new $TypeData().initClass($c_jl_Character$, "java.lang.Character$", ({
  jl_Character$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_Character$ as $d_jl_Character$ };
var $n_jl_Character$;
function $m_jl_Character$() {
  if ((!$n_jl_Character$)) {
    $n_jl_Character$ = new $c_jl_Character$();
  }
  return $n_jl_Character$;
}
export { $m_jl_Character$ as $m_jl_Character$ };
function $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) {
  if (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrPat = new RegExp("^[\\x00-\\x20]*([+-]?(?:NaN|Infinity|(?:\\d+\\.?\\d*|\\.\\d+)(?:[eE][+-]?\\d+)?)[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((1 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Double$__f_doubleStrPat;
}
export { $p_jl_Double$__doubleStrPat$lzycompute__O as $p_jl_Double$__doubleStrPat$lzycompute__O };
function $p_jl_Double$__doubleStrPat__O($thiz) {
  return (((((1 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrPat);
}
export { $p_jl_Double$__doubleStrPat__O as $p_jl_Double$__doubleStrPat__O };
function $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) {
  if (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.jl_Double$__f_doubleStrHexPat = new RegExp("^[\\x00-\\x20]*([+-]?)0[xX]([0-9A-Fa-f]*)\\.?([0-9A-Fa-f]*)[pP]([+-]?\\d+)[fFdD]?[\\x00-\\x20]*$");
    $thiz.jl_Double$__f_bitmap$0 = (((2 | $thiz.jl_Double$__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.jl_Double$__f_doubleStrHexPat;
}
export { $p_jl_Double$__doubleStrHexPat$lzycompute__O as $p_jl_Double$__doubleStrHexPat$lzycompute__O };
function $p_jl_Double$__doubleStrHexPat__O($thiz) {
  return (((((2 & $thiz.jl_Double$__f_bitmap$0) << 24) >> 24) === 0) ? $p_jl_Double$__doubleStrHexPat$lzycompute__O($thiz) : $thiz.jl_Double$__f_doubleStrHexPat);
}
export { $p_jl_Double$__doubleStrHexPat__O as $p_jl_Double$__doubleStrHexPat__O };
function $p_jl_Double$__parseDoubleSlowPath__T__D($thiz, s) {
  var groups = $p_jl_Double$__doubleStrHexPat__O($thiz).exec(s);
  if ((groups === null)) {
    $ps_jl_Double$__fail$1__T__E(s);
  }
  var x = groups[1];
  var x$1 = groups[2];
  var x$2 = groups[3];
  var x$3 = groups[4];
  if (((x$1 === "") && (x$2 === ""))) {
    $ps_jl_Double$__fail$1__T__E(s);
  }
  var absResult = $thiz.parseHexDoubleImpl__T__T__T__I__D(x$1, x$2, x$3, 15);
  return ((x === "-") ? (-absResult) : absResult);
}
export { $p_jl_Double$__parseDoubleSlowPath__T__D as $p_jl_Double$__parseDoubleSlowPath__T__D };
function $ps_jl_Double$__fail$1__T__E(s$1) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s$1) + "\""));
}
export { $ps_jl_Double$__fail$1__T__E as $ps_jl_Double$__fail$1__T__E };
/** @constructor */
function $c_jl_Double$() {
  this.jl_Double$__f_doubleStrPat = null;
  this.jl_Double$__f_doubleStrHexPat = null;
  this.jl_Double$__f_bitmap$0 = 0;
}
export { $c_jl_Double$ as $c_jl_Double$ };
$c_jl_Double$.prototype = new $h_O();
$c_jl_Double$.prototype.constructor = $c_jl_Double$;
/** @constructor */
function $h_jl_Double$() {
}
export { $h_jl_Double$ as $h_jl_Double$ };
$h_jl_Double$.prototype = $c_jl_Double$.prototype;
$c_jl_Double$.prototype.parseDouble__T__D = (function(s) {
  var groups = $p_jl_Double$__doubleStrPat__O(this).exec(s);
  if ((groups !== null)) {
    var $x_2 = parseFloat;
    var x = groups[1];
    var $x_1 = $x_2(x);
    return (+$x_1);
  } else {
    return $p_jl_Double$__parseDoubleSlowPath__T__D(this, s);
  }
});
$c_jl_Double$.prototype.parseHexDoubleImpl__T__T__T__I__D = (function(integralPartStr, fractionalPartStr, binaryExpStr, maxPrecisionChars) {
  var mantissaStr0 = (("" + integralPartStr) + fractionalPartStr);
  var correction1 = ((-(fractionalPartStr.length << 2)) | 0);
  var limit = (((-1) + mantissaStr0.length) | 0);
  var i = 0;
  while (true) {
    if ((i !== limit)) {
      var index = i;
      var $x_1 = (mantissaStr0.charCodeAt(index) === 48);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      i = ((1 + i) | 0);
    } else {
      break;
    }
  }
  var beginIndex = i;
  var mantissaStr = mantissaStr0.substring(beginIndex);
  var mantissaStrLen = mantissaStr.length;
  var needsCorrection2 = (mantissaStrLen > maxPrecisionChars);
  if (needsCorrection2) {
    var hasNonZeroChar = false;
    var j = maxPrecisionChars;
    while (((!hasNonZeroChar) && (j !== mantissaStrLen))) {
      var index$1 = j;
      if ((mantissaStr.charCodeAt(index$1) !== 48)) {
        hasNonZeroChar = true;
      }
      j = ((1 + j) | 0);
    }
    var compressedTail = (hasNonZeroChar ? "1" : "0");
    var truncatedMantissaStr = (mantissaStr.substring(0, maxPrecisionChars) + compressedTail);
  } else {
    var truncatedMantissaStr = mantissaStr;
  }
  var correction2 = (needsCorrection2 ? (((mantissaStr.length - ((1 + maxPrecisionChars) | 0)) | 0) << 2) : 0);
  var fullCorrection = ((correction1 + correction2) | 0);
  var mantissa = (+parseInt(truncatedMantissaStr, 16));
  var binaryExpDouble = (+parseInt(binaryExpStr, 10));
  var binaryExp = $doubleToInt(binaryExpDouble);
  return $m_jl_Math$().scalb__D__I__D(mantissa, ((binaryExp + fullCorrection) | 0));
});
$c_jl_Double$.prototype.compare__D__D__I = (function(a, b) {
  if ((a !== a)) {
    return ((b !== b) ? 0 : 1);
  } else if ((b !== b)) {
    return (-1);
  } else if ((a === b)) {
    if ((a === 0.0)) {
      var ainf = (1.0 / a);
      return ((ainf === (1.0 / b)) ? 0 : ((ainf < 0.0) ? (-1) : 1));
    } else {
      return 0;
    }
  } else {
    return ((a < b) ? (-1) : 1);
  }
});
var $d_jl_Double$ = new $TypeData().initClass($c_jl_Double$, "java.lang.Double$", ({
  jl_Double$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_Double$ as $d_jl_Double$ };
var $n_jl_Double$;
function $m_jl_Double$() {
  if ((!$n_jl_Double$)) {
    $n_jl_Double$ = new $c_jl_Double$();
  }
  return $n_jl_Double$;
}
export { $m_jl_Double$ as $m_jl_Double$ };
function $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) {
  if ((!$thiz.jl_Float$__f_bitmap$0)) {
    $thiz.jl_Float$__f_parseFloatRegExp = new RegExp("^[\\x00-\\x20]*([+-]?)(?:(NaN)|(Infinity)|(?:((?:(\\d+)(?:\\.(\\d*))?|\\.(\\d+))(?:[eE]([+-]?\\d+))?)|(0[xX](?:([0-9A-Fa-f]+)(?:\\.([0-9A-Fa-f]*))?|\\.([0-9A-Fa-f]+))[pP]([+-]?\\d+)))[fFdD]?)[\\x00-\\x20]*$");
    $thiz.jl_Float$__f_bitmap$0 = true;
  }
  return $thiz.jl_Float$__f_parseFloatRegExp;
}
export { $p_jl_Float$__parseFloatRegExp$lzycompute__O as $p_jl_Float$__parseFloatRegExp$lzycompute__O };
function $p_jl_Float$__parseFloatRegExp__O($thiz) {
  return ((!$thiz.jl_Float$__f_bitmap$0) ? $p_jl_Float$__parseFloatRegExp$lzycompute__O($thiz) : $thiz.jl_Float$__f_parseFloatRegExp);
}
export { $p_jl_Float$__parseFloatRegExp__O as $p_jl_Float$__parseFloatRegExp__O };
function $p_jl_Float$__parseFloatDecimal__T__T__T__T__F($thiz, fullNumberStr, integralPartStr, fractionalPartStr, exponentStr) {
  var z0 = (+parseFloat(fullNumberStr));
  var z = Math.fround(z0);
  var zDouble = z;
  if ((zDouble === z0)) {
    return z;
  } else if ((zDouble === Infinity)) {
    return ((z0 === 3.4028235677973366E38) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, 3.4028234663852886E38, z, 3.4028235677973366E38) : z);
  } else if ((zDouble < z0)) {
    var zUp = $m_jl_Math$().nextUp__F__F(z);
    var mid$2 = ((zDouble + zUp) / 2.0);
    return ((z0 === mid$2) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, z, zUp, mid$2) : z);
  } else {
    var zDown = $m_jl_Math$().nextDown__F__F(z);
    var mid$3 = ((zDouble + zDown) / 2.0);
    return ((z0 === mid$3) ? $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, z, mid$3) : z);
  }
}
export { $p_jl_Float$__parseFloatDecimal__T__T__T__T__F as $p_jl_Float$__parseFloatDecimal__T__T__T__T__F };
function $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F($thiz, integralPartStr, fractionalPartStr, exponentStr, zDown, zUp, mid) {
  var str = (("" + integralPartStr) + fractionalPartStr);
  var f = $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), str);
  var this$1 = $m_jl_Integer$();
  var e = ((this$1.java$lang$Integer$$parseIntImpl__T__I__I__I(exponentStr, 10, 214748364) - fractionalPartStr.length) | 0);
  var fpBitsDataView = $fpBitsDataView;
  fpBitsDataView.setFloat64(0, mid, true);
  var lo = (fpBitsDataView.getInt32(0, true) | 0);
  var hi = (fpBitsDataView.getInt32(4, true) | 0);
  var lo$1 = (hi >> 20);
  if ((lo$1 === 0)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), ("parseFloatCorrection was given a subnormal mid: " + mid));
  }
  var hi$2 = (1048575 & hi);
  var hi$3 = (1048576 | hi$2);
  var m = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$3));
  var k = (((-1075) + lo$1) | 0);
  if ((e >= 0)) {
    if ((k >= 0)) {
      var x = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e));
      var y = m.shiftLeft__I__Ljava_math_BigInteger(k);
      var cmp = x.compareTo__Ljava_math_BigInteger__I(y);
    } else {
      var v = f.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e));
      var e$1 = ((-k) | 0);
      var x$1 = v.shiftLeft__I__Ljava_math_BigInteger(e$1);
      var cmp = x$1.compareTo__Ljava_math_BigInteger__I(m);
    }
  } else if ((k >= 0)) {
    var e$2 = ((-e) | 0);
    var v$1 = m.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e$2));
    var y$1 = v$1.shiftLeft__I__Ljava_math_BigInteger(k);
    var cmp = f.compareTo__Ljava_math_BigInteger__I(y$1);
  } else {
    var e$3 = ((-k) | 0);
    var x$2 = f.shiftLeft__I__Ljava_math_BigInteger(e$3);
    var e$4 = ((-e) | 0);
    var y$2 = m.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN.pow__I__Ljava_math_BigInteger(e$4));
    var cmp = x$2.compareTo__Ljava_math_BigInteger__I(y$2);
  }
  return ((cmp < 0) ? zDown : ((cmp > 0) ? zUp : (((1 & $floatToBits(zDown)) === 0) ? zDown : zUp)));
}
export { $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F as $p_jl_Float$__parseFloatDecimalCorrection__T__T__T__F__F__D__F };
function $p_jl_Float$__parseFloatHexadecimal__T__T__T__F($thiz, integralPartStr, fractionalPartStr, binaryExpStr) {
  var doubleValue = $m_jl_Double$().parseHexDoubleImpl__T__T__T__I__D(integralPartStr, fractionalPartStr, binaryExpStr, 7);
  return Math.fround(doubleValue);
}
export { $p_jl_Float$__parseFloatHexadecimal__T__T__T__F as $p_jl_Float$__parseFloatHexadecimal__T__T__T__F };
/** @constructor */
function $c_jl_Float$() {
  this.jl_Float$__f_parseFloatRegExp = null;
  this.jl_Float$__f_bitmap$0 = false;
}
export { $c_jl_Float$ as $c_jl_Float$ };
$c_jl_Float$.prototype = new $h_O();
$c_jl_Float$.prototype.constructor = $c_jl_Float$;
/** @constructor */
function $h_jl_Float$() {
}
export { $h_jl_Float$ as $h_jl_Float$ };
$h_jl_Float$.prototype = $c_jl_Float$.prototype;
$c_jl_Float$.prototype.parseFloat__T__F = (function(s) {
  var groups = $p_jl_Float$__parseFloatRegExp__O(this).exec(s);
  if ((groups === null)) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
  }
  var x = groups[2];
  if ((x !== (void 0))) {
    var absResult = (NaN);
  } else {
    var x$1 = groups[3];
    if ((x$1 !== (void 0))) {
      var absResult = Infinity;
    } else {
      var x$2 = groups[4];
      if ((x$2 !== (void 0))) {
        var x$3 = groups[4];
        var x$4 = groups[5];
        var integralPartStr = ((x$4 !== (void 0)) ? x$4 : "");
        var x$5 = groups[6];
        var x$6 = groups[7];
        var fractionalPartStr = (("" + ((x$5 !== (void 0)) ? x$5 : "")) + ((x$6 !== (void 0)) ? x$6 : ""));
        var x$7 = groups[8];
        var exponentStr = ((x$7 !== (void 0)) ? x$7 : "0");
        var absResult = $p_jl_Float$__parseFloatDecimal__T__T__T__T__F(this, x$3, integralPartStr, fractionalPartStr, exponentStr);
      } else {
        var x$8 = groups[10];
        var integralPartStr$2 = ((x$8 !== (void 0)) ? x$8 : "");
        var x$9 = groups[11];
        var x$10 = groups[12];
        var fractionalPartStr$2 = (("" + ((x$9 !== (void 0)) ? x$9 : "")) + ((x$10 !== (void 0)) ? x$10 : ""));
        var x$11 = groups[13];
        var absResult = $p_jl_Float$__parseFloatHexadecimal__T__T__T__F(this, integralPartStr$2, fractionalPartStr$2, x$11);
      }
    }
  }
  var x$12 = groups[1];
  return ((x$12 === "-") ? Math.fround((-absResult)) : absResult);
});
var $d_jl_Float$ = new $TypeData().initClass($c_jl_Float$, "java.lang.Float$", ({
  jl_Float$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_Float$ as $d_jl_Float$ };
var $n_jl_Float$;
function $m_jl_Float$() {
  if ((!$n_jl_Float$)) {
    $n_jl_Float$ = new $c_jl_Float$();
  }
  return $n_jl_Float$;
}
export { $m_jl_Float$ as $m_jl_Float$ };
/** @constructor */
function $c_jl_Integer$() {
}
export { $c_jl_Integer$ as $c_jl_Integer$ };
$c_jl_Integer$.prototype = new $h_O();
$c_jl_Integer$.prototype.constructor = $c_jl_Integer$;
/** @constructor */
function $h_jl_Integer$() {
}
export { $h_jl_Integer$ as $h_jl_Integer$ };
$h_jl_Integer$.prototype = $c_jl_Integer$.prototype;
$c_jl_Integer$.prototype.parseIntFail__T__E = (function(s) {
  throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
});
$c_jl_Integer$.prototype.java$lang$Integer$$parseIntImpl__T__I__I__I = (function(s, radix, overflowBarrier) {
  if ((s === null)) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  }
  var len = s.length;
  if ((len === 0)) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  }
  var character = $m_jl_Character$();
  var firstChar = s.charCodeAt(0);
  var negative = (firstChar === 45);
  var sign = (negative ? (-1) : 0);
  var i = ((negative || (firstChar === 43)) ? 1 : 0);
  if ((i >= len)) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  }
  var java$lang$IntFloatBits$Int32Box$$value = 0;
  java$lang$IntFloatBits$Int32Box$$value = 0;
  while ((i !== len)) {
    var index = i;
    var x = character.digitWithValidRadix__I__I__I(s.charCodeAt(index), radix);
    if ((x < 0)) {
      var $x_1 = true;
    } else {
      var x$1 = java$lang$IntFloatBits$Int32Box$$value;
      var $x_1 = ((x$1 >>> 0) > (overflowBarrier >>> 0));
    }
    if ($x_1) {
      $m_jl_Integer$().parseIntFail__T__E(s);
    }
    var x$2 = java$lang$IntFloatBits$Int32Box$$value;
    var x$3 = Math.imul(x$2, radix);
    var v = ((x$3 + x) | 0);
    java$lang$IntFloatBits$Int32Box$$value = v;
    i = ((1 + i) | 0);
  }
  var x$4 = java$lang$IntFloatBits$Int32Box$$value;
  var y = ((2147483647 - sign) | 0);
  if (((x$4 >>> 0) > (y >>> 0))) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  }
  var x$5 = java$lang$IntFloatBits$Int32Box$$value;
  var x$6 = (x$5 ^ sign);
  return ((x$6 - sign) | 0);
});
$c_jl_Integer$.prototype.bitCount__I__I = (function(i) {
  var t1 = ((i - (1431655765 & (i >> 1))) | 0);
  var t2 = (((858993459 & t1) + (858993459 & (t1 >> 2))) | 0);
  return (Math.imul(16843009, (252645135 & ((t2 + (t2 >> 4)) | 0))) >> 24);
});
var $d_jl_Integer$ = new $TypeData().initClass($c_jl_Integer$, "java.lang.Integer$", ({
  jl_Integer$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_Integer$ as $d_jl_Integer$ };
var $n_jl_Integer$;
function $m_jl_Integer$() {
  if ((!$n_jl_Integer$)) {
    $n_jl_Integer$ = new $c_jl_Integer$();
  }
  return $n_jl_Integer$;
}
export { $m_jl_Integer$ as $m_jl_Integer$ };
function $p_jl_Long$__java$lang$Long$$StringRadixInfos$lzycompute__O($thiz) {
  if ((!$thiz.jl_Long$__f_bitmap$0)) {
    var r = [];
    var i = 0;
    while ((i < 2)) {
      r.push(null);
      i = ((1 + i) | 0);
    }
    var i$1 = 2;
    while ((i$1 <= 36)) {
      var value$1 = i$1;
      var barrier = ((1073741824 / ($checkIntDivisor(value$1) >>> 0)) | 0);
      var radixPowLength = value$1;
      var chunkLength = 1;
      var paddingZeros = "0";
      while ((radixPowLength <= barrier)) {
        radixPowLength = Math.imul(radixPowLength, value$1);
        chunkLength = ((1 + chunkLength) | 0);
        paddingZeros = (paddingZeros + "0");
      }
      var x = radixPowLength;
      var this$9 = $m_RTLong$();
      var lo = this$9.divideUnsignedImpl__I__I__I__I__I((-1), (-1), x, 0);
      var hi = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      r.push(new $c_jl_Long$StringRadixInfo(chunkLength, radixPowLength, (1.0 / radixPowLength), paddingZeros, new $c_RTLong(lo, hi)));
      i$1 = ((1 + i$1) | 0);
    }
    $thiz.jl_Long$__f_java$lang$Long$$StringRadixInfos = r;
    $thiz.jl_Long$__f_bitmap$0 = true;
  }
  return $thiz.jl_Long$__f_java$lang$Long$$StringRadixInfos;
}
export { $p_jl_Long$__java$lang$Long$$StringRadixInfos$lzycompute__O as $p_jl_Long$__java$lang$Long$$StringRadixInfos$lzycompute__O };
function $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I($thiz, chunkStart, chunkEnd, s$1, radix$1) {
  var result = 0;
  var i = chunkStart;
  while ((i !== chunkEnd)) {
    var $x_1 = $m_jl_Character$();
    var index = i;
    var digit = $x_1.digitWithValidRadix__I__I__I(s$1.charCodeAt(index), radix$1);
    if ((digit === (-1))) {
      $m_jl_Integer$().parseIntFail__T__E(s$1);
    }
    result = ((Math.imul(result, radix$1) + digit) | 0);
    i = ((1 + i) | 0);
  }
  return result;
}
export { $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I as $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I };
/** @constructor */
function $c_jl_Long$() {
  this.jl_Long$__f_java$lang$Long$$StringRadixInfos = null;
  this.jl_Long$__f_bitmap$0 = false;
}
export { $c_jl_Long$ as $c_jl_Long$ };
$c_jl_Long$.prototype = new $h_O();
$c_jl_Long$.prototype.constructor = $c_jl_Long$;
/** @constructor */
function $h_jl_Long$() {
}
export { $h_jl_Long$ as $h_jl_Long$ };
$h_jl_Long$.prototype = $c_jl_Long$.prototype;
$c_jl_Long$.prototype.java$lang$Long$$StringRadixInfos__O = (function() {
  return ((!this.jl_Long$__f_bitmap$0) ? $p_jl_Long$__java$lang$Long$$StringRadixInfos$lzycompute__O(this) : this.jl_Long$__f_java$lang$Long$$StringRadixInfos);
});
$c_jl_Long$.prototype.java$lang$Long$$toStringImpl__J__I__T = (function(i, radix) {
  var lo = i.RTLong__f_lo;
  var hi = i.RTLong__f_hi;
  if (((lo >> 31) === hi)) {
    return lo.toString(radix);
  } else if ((((-2097152) & (hi ^ (hi >> 10))) === 0)) {
    var lo$1 = i.RTLong__f_lo;
    var hi$1 = i.RTLong__f_hi;
    var $x_1 = ((4.294967296E9 * hi$1) + (lo$1 >>> 0.0)).toString(radix);
    return $x_1;
  } else {
    var lo$2 = i.RTLong__f_lo;
    var hi$2 = i.RTLong__f_hi;
    var sign = (hi$2 >> 31);
    var xlo = (lo$2 ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi$2 ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var radixInfo = this.java$lang$Long$$StringRadixInfos__O()[radix];
    var divisor = radixInfo.jl_Long$StringRadixInfo__f_radixPowLength;
    var divisorInv = radixInfo.jl_Long$StringRadixInfo__f_radixPowLengthInverse;
    var paddingZeros = radixInfo.jl_Long$StringRadixInfo__f_paddingZeros;
    var approxNum = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var a = (approxNum * divisorInv);
    var approxQuot = (+Math.floor(a));
    var n = approxQuot;
    var approxRem = ((rlo - Math.imul(divisor, (n | 0.0))) | 0);
    if ((approxRem < 0)) {
      approxQuot = (approxQuot - 1.0);
      approxRem = ((approxRem + divisor) | 0);
    } else if ((approxRem >= divisor)) {
      approxQuot = (approxQuot + 1.0);
      approxRem = ((approxRem - divisor) | 0);
    }
    var remStr = approxRem.toString(radix);
    var s = ((("" + approxQuot.toString(radix)) + paddingZeros.substring(remStr.length)) + remStr);
    return ((hi < 0) ? ("-" + s) : s);
  }
});
$c_jl_Long$.prototype.parseLongImplJS__T__I__J = (function(s, radix) {
  if ((s === "")) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  }
  var start = 0;
  var neg = false;
  var x1 = s.charCodeAt(0);
  switch (x1) {
    case 43: {
      start = 1;
      break;
    }
    case 45: {
      start = 1;
      neg = true;
      break;
    }
  }
  var t = this.parseUnsignedLongJSInternal__T__I__I__J(s, radix, start);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (neg) {
    var lo$1 = ((-lo) | 0);
    var hi$1 = ((((-hi) | 0) + ((lo | lo$1) >> 31)) | 0);
    if (((hi$1 === 0) ? (lo$1 !== 0) : (hi$1 > 0))) {
      $m_jl_Integer$().parseIntFail__T__E(s);
    }
    return new $c_RTLong(lo$1, hi$1);
  } else {
    if ((hi < 0)) {
      $m_jl_Integer$().parseIntFail__T__E(s);
    }
    return new $c_RTLong(lo, hi);
  }
});
$c_jl_Long$.prototype.parseUnsignedLongJSInternal__T__I__I__J = (function(s, radix, start) {
  var length = s.length;
  if ((start >= length)) {
    $m_jl_Integer$().parseIntFail__T__E(s);
  } else {
    var radixInfo = this.java$lang$Long$$StringRadixInfos__O()[radix];
    var chunkLen = radixInfo.jl_Long$StringRadixInfo__f_chunkLength;
    var firstChunkStart = start;
    while (true) {
      if ((firstChunkStart < length)) {
        var $x_2 = $m_jl_Character$();
        var index = firstChunkStart;
        var $x_1 = $x_2.isZeroDigit__C__Z(s.charCodeAt(index));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        firstChunkStart = ((1 + firstChunkStart) | 0);
      } else {
        break;
      }
    }
    if ((((length - firstChunkStart) | 0) > Math.imul(3, chunkLen))) {
      $m_jl_Integer$().parseIntFail__T__E(s);
    }
    var firstChunkLength = ((1 + (((((-1) + ((length - firstChunkStart) | 0)) | 0) % $checkIntDivisor(chunkLen)) | 0)) | 0);
    var firstChunkEnd = ((firstChunkStart + firstChunkLength) | 0);
    var chunkStart = firstChunkStart;
    var x = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, chunkStart, firstChunkEnd, s, radix);
    if ((firstChunkEnd === length)) {
      return new $c_RTLong(x, 0);
    } else {
      var x$1 = radixInfo.jl_Long$StringRadixInfo__f_radixPowLength;
      var secondChunkEnd = ((firstChunkEnd + chunkLen) | 0);
      var a0 = (65535 & x);
      var a1 = ((x >>> 16) | 0);
      var b0 = (65535 & x$1);
      var b1 = ((x$1 >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi = ((((Math.imul(a1, b1) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var x$2 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, firstChunkEnd, secondChunkEnd, s, radix);
      var lo$1 = ((lo + x$2) | 0);
      var hi$1 = ((hi + ((((lo & x$2) | ((lo | x$2) & (~lo$1))) >>> 31) | 0)) | 0);
      if ((secondChunkEnd === length)) {
        return new $c_RTLong(lo$1, hi$1);
      } else {
        var t = radixInfo.jl_Long$StringRadixInfo__f_overflowBarrier;
        var lo$2 = t.RTLong__f_lo;
        var hi$2 = t.RTLong__f_hi;
        var x$3 = $p_jl_Long$__parseChunkAsUInt$1__I__I__T__I__I(this, secondChunkEnd, length, s, radix);
        if (((hi$1 === hi$2) ? ((lo$1 >>> 0) > (lo$2 >>> 0)) : (hi$1 > hi$2))) {
          $m_jl_Integer$().parseIntFail__T__E(s);
        }
        var a0$1 = (65535 & lo$1);
        var a1$1 = ((lo$1 >>> 16) | 0);
        var b0$1 = (65535 & x$1);
        var b1$1 = ((x$1 >>> 16) | 0);
        var a0b0$1 = Math.imul(a0$1, b0$1);
        var a1b0$1 = Math.imul(a1$1, b0$1);
        var a0b1$1 = Math.imul(a0$1, b1$1);
        var lo$3 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$3 = ((((((Math.imul(hi$1, x$1) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$4 = ((lo$3 + x$3) | 0);
        var hi$4 = ((hi$3 + ((((lo$3 & x$3) | ((lo$3 | x$3) & (~lo$4))) >>> 31) | 0)) | 0);
        if (((hi$4 === 0) && ((lo$4 >>> 0) < (x$3 >>> 0)))) {
          $m_jl_Integer$().parseIntFail__T__E(s);
        }
        return new $c_RTLong(lo$4, hi$4);
      }
    }
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toHexString__I__I__T = (function(lo, hi) {
  if ((hi !== 0)) {
    var $x_1 = (hi >>> 0.0).toString(16);
    var s = (lo >>> 0.0).toString(16);
    var beginIndex = s.length;
    return ($x_1 + (("" + "00000000".substring(beginIndex)) + s));
  } else {
    return (lo >>> 0.0).toString(16);
  }
});
$c_jl_Long$.prototype.java$lang$Long$$toOctalString__I__I__T = (function(lo, hi) {
  var lp = (1073741823 & lo);
  var mp = (1073741823 & ((((lo >>> 30) | 0) + (hi << 2)) | 0));
  var hp = ((hi >>> 28) | 0);
  if ((hp !== 0)) {
    var $x_2 = (hp >>> 0.0).toString(8);
    var s = (mp >>> 0.0).toString(8);
    var beginIndex = s.length;
    var $x_1 = "0000000000".substring(beginIndex);
    var s$1 = (lp >>> 0.0).toString(8);
    var beginIndex$1 = s$1.length;
    return (($x_2 + (("" + $x_1) + s)) + (("" + "0000000000".substring(beginIndex$1)) + s$1));
  } else if ((mp !== 0)) {
    var $x_3 = (mp >>> 0.0).toString(8);
    var s$2 = (lp >>> 0.0).toString(8);
    var beginIndex$2 = s$2.length;
    return ($x_3 + (("" + "0000000000".substring(beginIndex$2)) + s$2));
  } else {
    return (lp >>> 0.0).toString(8);
  }
});
var $d_jl_Long$ = new $TypeData().initClass($c_jl_Long$, "java.lang.Long$", ({
  jl_Long$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_Long$ as $d_jl_Long$ };
var $n_jl_Long$;
function $m_jl_Long$() {
  if ((!$n_jl_Long$)) {
    $n_jl_Long$ = new $c_jl_Long$();
  }
  return $n_jl_Long$;
}
export { $m_jl_Long$ as $m_jl_Long$ };
/** @constructor */
function $c_jl_Number() {
}
export { $c_jl_Number as $c_jl_Number };
$c_jl_Number.prototype = new $h_O();
$c_jl_Number.prototype.constructor = $c_jl_Number;
/** @constructor */
function $h_jl_Number() {
}
export { $h_jl_Number as $h_jl_Number };
$h_jl_Number.prototype = $c_jl_Number.prototype;
function $is_jl_Number(obj) {
  return (((obj instanceof $c_jl_Number) || ((typeof obj) === "number")) || (obj instanceof $c_RTLong));
}
export { $is_jl_Number as $is_jl_Number };
function $isArrayOf_jl_Number(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Number)));
}
export { $isArrayOf_jl_Number as $isArrayOf_jl_Number };
/** @constructor */
function $c_jl_Short$() {
}
export { $c_jl_Short$ as $c_jl_Short$ };
$c_jl_Short$.prototype = new $h_O();
$c_jl_Short$.prototype.constructor = $c_jl_Short$;
/** @constructor */
function $h_jl_Short$() {
}
export { $h_jl_Short$ as $h_jl_Short$ };
$h_jl_Short$.prototype = $c_jl_Short$.prototype;
$c_jl_Short$.prototype.parseShort__T__I__S = (function(s, radix) {
  var this$1 = $m_jl_Integer$();
  if (((radix < 2) || (radix > 36))) {
    this$1.parseIntFail__T__E(s);
  }
  var r = this$1.java$lang$Integer$$parseIntImpl__T__I__I__I(s, radix, ((2147483648 / ($checkIntDivisor(radix) >>> 0)) | 0));
  if (((r < (-32768)) || (r > 32767))) {
    throw new $c_jl_NumberFormatException((("For input string: \"" + s) + "\""));
  } else {
    return ((r << 16) >> 16);
  }
});
var $d_jl_Short$ = new $TypeData().initClass($c_jl_Short$, "java.lang.Short$", ({
  jl_Short$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_Short$ as $d_jl_Short$ };
var $n_jl_Short$;
function $m_jl_Short$() {
  if ((!$n_jl_Short$)) {
    $n_jl_Short$ = new $c_jl_Short$();
  }
  return $n_jl_Short$;
}
export { $m_jl_Short$ as $m_jl_Short$ };
function $ct_jl_StackTraceElement__T__T__T__I__I__($thiz, declaringClass, methodName, fileName, lineNumber, columnNumber) {
  $thiz.jl_StackTraceElement__f_declaringClass = declaringClass;
  $thiz.jl_StackTraceElement__f_methodName = methodName;
  $thiz.jl_StackTraceElement__f_fileName = fileName;
  $thiz.jl_StackTraceElement__f_lineNumber = lineNumber;
  $thiz.jl_StackTraceElement__f_columnNumber = columnNumber;
  return $thiz;
}
export { $ct_jl_StackTraceElement__T__T__T__I__I__ as $ct_jl_StackTraceElement__T__T__T__I__I__ };
function $ct_jl_StackTraceElement__T__T__T__I__($thiz, declaringClass, methodName, fileName, lineNumber) {
  $ct_jl_StackTraceElement__T__T__T__I__I__($thiz, declaringClass, methodName, fileName, lineNumber, (-1));
  return $thiz;
}
export { $ct_jl_StackTraceElement__T__T__T__I__ as $ct_jl_StackTraceElement__T__T__T__I__ };
/** @constructor */
function $c_jl_StackTraceElement() {
  this.jl_StackTraceElement__f_declaringClass = null;
  this.jl_StackTraceElement__f_methodName = null;
  this.jl_StackTraceElement__f_fileName = null;
  this.jl_StackTraceElement__f_lineNumber = 0;
  this.jl_StackTraceElement__f_columnNumber = 0;
}
export { $c_jl_StackTraceElement as $c_jl_StackTraceElement };
$c_jl_StackTraceElement.prototype = new $h_O();
$c_jl_StackTraceElement.prototype.constructor = $c_jl_StackTraceElement;
/** @constructor */
function $h_jl_StackTraceElement() {
}
export { $h_jl_StackTraceElement as $h_jl_StackTraceElement };
$h_jl_StackTraceElement.prototype = $c_jl_StackTraceElement.prototype;
$c_jl_StackTraceElement.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_jl_StackTraceElement) && (((((this.jl_StackTraceElement__f_fileName === that.jl_StackTraceElement__f_fileName) && (this.jl_StackTraceElement__f_lineNumber === that.jl_StackTraceElement__f_lineNumber)) && (this.jl_StackTraceElement__f_columnNumber === that.jl_StackTraceElement__f_columnNumber)) && (this.jl_StackTraceElement__f_declaringClass === that.jl_StackTraceElement__f_declaringClass)) && (this.jl_StackTraceElement__f_methodName === that.jl_StackTraceElement__f_methodName)));
});
$c_jl_StackTraceElement.prototype.toString__T = (function() {
  var result = "";
  if ((this.jl_StackTraceElement__f_declaringClass !== "<jscode>")) {
    result = ((("" + result) + this.jl_StackTraceElement__f_declaringClass) + ".");
  }
  result = (("" + result) + this.jl_StackTraceElement__f_methodName);
  if ((this.jl_StackTraceElement__f_fileName === null)) {
    result = (result + "(Unknown Source)");
  } else {
    result = ((result + "(") + this.jl_StackTraceElement__f_fileName);
    if ((this.jl_StackTraceElement__f_lineNumber >= 0)) {
      result = ((result + ":") + this.jl_StackTraceElement__f_lineNumber);
      if ((this.jl_StackTraceElement__f_columnNumber >= 0)) {
        result = ((result + ":") + this.jl_StackTraceElement__f_columnNumber);
      }
    }
    result = (result + ")");
  }
  return result;
});
$c_jl_StackTraceElement.prototype.hashCode__I = (function() {
  return (((($f_T__hashCode__I(this.jl_StackTraceElement__f_declaringClass) ^ $f_T__hashCode__I(this.jl_StackTraceElement__f_methodName)) ^ $f_T__hashCode__I(this.jl_StackTraceElement__f_fileName)) ^ this.jl_StackTraceElement__f_lineNumber) ^ this.jl_StackTraceElement__f_columnNumber);
});
function $isArrayOf_jl_StackTraceElement(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_StackTraceElement)));
}
export { $isArrayOf_jl_StackTraceElement as $isArrayOf_jl_StackTraceElement };
var $d_jl_StackTraceElement = new $TypeData().initClass($c_jl_StackTraceElement, "java.lang.StackTraceElement", ({
  jl_StackTraceElement: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_StackTraceElement as $d_jl_StackTraceElement };
/** @constructor */
function $c_jl_String$() {
}
export { $c_jl_String$ as $c_jl_String$ };
$c_jl_String$.prototype = new $h_O();
$c_jl_String$.prototype.constructor = $c_jl_String$;
/** @constructor */
function $h_jl_String$() {
}
export { $h_jl_String$ as $h_jl_String$ };
$h_jl_String$.prototype = $c_jl_String$.prototype;
$c_jl_String$.prototype.new__AC__I__I__T = (function(value, offset, count) {
  var end = ((offset + count) | 0);
  if ((((offset < 0) || (end < offset)) || (end > value.u.length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException());
  }
  var result = "";
  var i = offset;
  while ((i !== end)) {
    var $x_1 = result;
    var this$1 = value.u[i];
    result = ($x_1 + ("" + $cToS(this$1)));
    i = ((1 + i) | 0);
  }
  return result;
});
$c_jl_String$.prototype.new__AB__T__T = (function(bytes, charsetName) {
  return this.new__AB__Ljava_nio_charset_Charset__T(bytes, $m_Ljava_nio_charset_Charset$().forName__T__Ljava_nio_charset_Charset(charsetName));
});
$c_jl_String$.prototype.new__AB__Ljava_nio_charset_Charset__T = (function(bytes, charset) {
  var length = bytes.u.length;
  var bb = $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(bytes, 0, bytes.u.length, 0, length, false);
  return $p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder(charset).decode__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer(bb).toString__T();
});
$c_jl_String$.prototype.new__AB__I__I__T__T = (function(bytes, offset, length, charsetName) {
  return this.new__AB__I__I__Ljava_nio_charset_Charset__T(bytes, offset, length, $m_Ljava_nio_charset_Charset$().forName__T__Ljava_nio_charset_Charset(charsetName));
});
$c_jl_String$.prototype.new__AB__I__I__Ljava_nio_charset_Charset__T = (function(bytes, offset, length, charset) {
  var bb = $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(bytes, 0, bytes.u.length, offset, length, false);
  return $p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder(charset).decode__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer(bb).toString__T();
});
$c_jl_String$.prototype.format__T__AO__T = (function(format, args) {
  return $ct_ju_Formatter__(new $c_ju_Formatter()).format__T__AO__ju_Formatter(format, args).toString__T();
});
var $d_jl_String$ = new $TypeData().initClass($c_jl_String$, "java.lang.String$", ({
  jl_String$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_String$ as $d_jl_String$ };
var $n_jl_String$;
function $m_jl_String$() {
  if ((!$n_jl_String$)) {
    $n_jl_String$ = new $c_jl_String$();
  }
  return $n_jl_String$;
}
export { $m_jl_String$ as $m_jl_String$ };
function $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, e, enableSuppression, writableStackTrace) {
  $thiz.jl_Throwable__f_s = s;
  $thiz.jl_Throwable__f_e = e;
  $thiz.jl_Throwable__f_writableStackTrace = writableStackTrace;
  if (writableStackTrace) {
    $thiz.fillInStackTrace__jl_Throwable();
  }
  return $thiz;
}
export { $ct_jl_Throwable__T__jl_Throwable__Z__Z__ as $ct_jl_Throwable__T__jl_Throwable__Z__Z__ };
class $c_jl_Throwable extends Error {
  constructor() {
    super();
    this.jl_Throwable__f_s = null;
    this.jl_Throwable__f_e = null;
    this.jl_Throwable__f_writableStackTrace = false;
    this.jl_Throwable__f_jsErrorForStackTrace = null;
    this.jl_Throwable__f_stackTrace = null;
  }
  initCause__jl_Throwable__jl_Throwable(cause) {
    this.jl_Throwable__f_e = cause;
    return this;
  }
  getMessage__T() {
    return this.jl_Throwable__f_s;
  }
  fillInStackTrace__jl_Throwable() {
    var reference = ((this instanceof $c_sjs_js_JavaScriptException) ? this.sjs_js_JavaScriptException__f_exception : this);
    var identifyingString = Object.prototype.toString.call(reference);
    this.jl_Throwable__f_jsErrorForStackTrace = ((identifyingString === "[object Error]") ? reference : (((Error.captureStackTrace === (void 0)) || (!(!Object.isSealed(this)))) ? new Error() : (Error.captureStackTrace(this), this)));
    return this;
  }
  getStackTrace__Ajl_StackTraceElement() {
    if ((this.jl_Throwable__f_stackTrace === null)) {
      if (this.jl_Throwable__f_writableStackTrace) {
        this.jl_Throwable__f_stackTrace = $m_jl_StackTrace$().extract__O__Ajl_StackTraceElement(this.jl_Throwable__f_jsErrorForStackTrace);
      } else {
        this.jl_Throwable__f_stackTrace = new ($d_jl_StackTraceElement.getArrayOf().constr)(0);
      }
    }
    return this.jl_Throwable__f_stackTrace;
  }
  setStackTrace__Ajl_StackTraceElement__V(stackTrace) {
    if (this.jl_Throwable__f_writableStackTrace) {
      var i = 0;
      while ((i < stackTrace.u.length)) {
        if ((stackTrace.u[i] === null)) {
          throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
        }
        i = ((1 + i) | 0);
      }
      this.jl_Throwable__f_stackTrace = stackTrace.clone__O();
    }
  }
  printStackTrace__Ljava_io_PrintStream__V(s) {
    this.getStackTrace__Ajl_StackTraceElement();
    var t = this.toString__T();
    s.println__T__V(t);
    if ((this.jl_Throwable__f_stackTrace.u.length !== 0)) {
      var i = 0;
      while ((i < this.jl_Throwable__f_stackTrace.u.length)) {
        var t$1 = ("  at " + this.jl_Throwable__f_stackTrace.u[i]);
        s.println__T__V(t$1);
        i = ((1 + i) | 0);
      }
    } else {
      s.println__T__V("  <no stack trace available>");
    }
    var wCause = this;
    while (true) {
      var $x_3 = wCause;
      var this$1 = wCause;
      if (($x_3 !== this$1.jl_Throwable__f_e)) {
        var this$2 = wCause;
        var $x_2 = (this$2.jl_Throwable__f_e !== null);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        var parentTrace = wCause.getStackTrace__Ajl_StackTraceElement();
        var this$3 = wCause;
        wCause = this$3.jl_Throwable__f_e;
        var thisTrace = wCause.getStackTrace__Ajl_StackTraceElement();
        var thisLength = thisTrace.u.length;
        var parentLength = parentTrace.u.length;
        var t$2 = ("Caused by: " + wCause);
        s.println__T__V(t$2);
        if ((thisLength !== 0)) {
          var sameFrameCount = 0;
          while (true) {
            if (((sameFrameCount < thisLength) && (sameFrameCount < parentLength))) {
              var x = thisTrace.u[(((-1) + ((thisLength - sameFrameCount) | 0)) | 0)];
              var x$2 = parentTrace.u[(((-1) + ((parentLength - sameFrameCount) | 0)) | 0)];
              var $x_1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
            } else {
              var $x_1 = false;
            }
            if ($x_1) {
              sameFrameCount = ((1 + sameFrameCount) | 0);
            } else {
              break;
            }
          }
          if ((sameFrameCount > 0)) {
            sameFrameCount = (((-1) + sameFrameCount) | 0);
          }
          var lengthToPrint = ((thisLength - sameFrameCount) | 0);
          var i$2 = 0;
          while ((i$2 < lengthToPrint)) {
            var t$3 = ("  at " + thisTrace.u[i$2]);
            s.println__T__V(t$3);
            i$2 = ((1 + i$2) | 0);
          }
          if ((sameFrameCount > 0)) {
            var t$4 = (("  ... " + sameFrameCount) + " more");
            s.println__T__V(t$4);
          }
        } else {
          s.println__T__V("  <no stack trace available>");
        }
      } else {
        break;
      }
    }
  }
  toString__T() {
    var className = $objectClassName(this);
    var message = this.getMessage__T();
    return ((message === null) ? className : ((className + ": ") + message));
  }
  hashCode__I() {
    return $c_O.prototype.hashCode__I.call(this);
  }
  equals__O__Z(that) {
    return $c_O.prototype.equals__O__Z.call(this, that);
  }
  get "message"() {
    var m = this.getMessage__T();
    return ((m === null) ? "" : m);
  }
  get "name"() {
    return $objectClassName(this);
  }
  "toString"() {
    return this.toString__T();
  }
}
export { $c_jl_Throwable as $c_jl_Throwable };
function $isArrayOf_jl_Throwable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Throwable)));
}
export { $isArrayOf_jl_Throwable as $isArrayOf_jl_Throwable };
var $d_jl_Throwable = new $TypeData().initClass(0, "java.lang.Throwable", ({
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_Throwable as $d_jl_Throwable };
function $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1) {
  return $thiz.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.u[diffScale$1];
}
export { $p_Ljava_math_BigDecimal$__powLen$1__I__I as $p_Ljava_math_BigDecimal$__powLen$1__I__I };
function $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1) {
  return ((augend$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $p_Ljava_math_BigDecimal$__powLen$1__I__I($thiz, diffScale$1)) | 0);
}
export { $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I as $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I };
function $p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I($thiz, thisValue$1, augend$1, diffScale$1) {
  var a = thisValue$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var b = $p_Ljava_math_BigDecimal$__augPlusPowLength$1__Ljava_math_BigDecimal__I__I($thiz, augend$1, diffScale$1);
  return ((1 + ((a > b) ? a : b)) | 0);
}
export { $p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I as $p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I };
/** @constructor */
function $c_Ljava_math_BigDecimal$() {
  this.Ljava_math_BigDecimal$__f_ZERO = null;
  this.Ljava_math_BigDecimal$__f_ONE = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = null;
  this.Ljava_math_BigDecimal$__f_LongTenPows = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = null;
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = null;
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = null;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = null;
  $n_Ljava_math_BigDecimal$ = this;
  this.Ljava_math_BigDecimal$__f_ZERO = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 0);
  this.Ljava_math_BigDecimal$__f_ONE = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 1, 0);
  $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 10, 0);
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows = this.newArrayOfPows__I__I__AJ(28, 5);
  var len = this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows.u.length;
  var result = new $ac_I(len);
  var i = 0;
  while ((i < len)) {
    var value = i;
    result.u[value] = $m_Ljava_math_BigDecimal$().bitLength__J__I($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongFivePows.u[value]);
    i = ((1 + i) | 0);
  }
  this.Ljava_math_BigDecimal$__f_LongTenPows = this.newArrayOfPows__I__I__AJ(19, 10);
  var len$2 = this.Ljava_math_BigDecimal$__f_LongTenPows.u.length;
  var result$2 = new $ac_I(len$2);
  var i$1 = 0;
  while ((i$1 < len$2)) {
    var value$1 = i$1;
    result$2.u[value$1] = $m_Ljava_math_BigDecimal$().bitLength__J__I($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u[value$1]);
    i$1 = ((1 + i$1) | 0);
  }
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength = result$2;
  var result$3 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$2 = 0;
  while ((i$2 < 11)) {
    var value$2 = i$2;
    result$3.u[value$2] = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), value$2, 0);
    i$2 = ((1 + i$2) | 0);
  }
  this.Ljava_math_BigDecimal$__f_BigIntScaledByZero = result$3;
  var result$4 = new ($d_Ljava_math_BigDecimal.getArrayOf().constr)(11);
  var i$3 = 0;
  while ((i$3 < 11)) {
    var value$3 = i$3;
    result$4.u[value$3] = $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, value$3);
    i$3 = ((1 + i$3) | 0);
  }
  this.Ljava_math_BigDecimal$__f_ZeroScaledBy = result$4;
  this.Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros = "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000";
}
export { $c_Ljava_math_BigDecimal$ as $c_Ljava_math_BigDecimal$ };
$c_Ljava_math_BigDecimal$.prototype = new $h_O();
$c_Ljava_math_BigDecimal$.prototype.constructor = $c_Ljava_math_BigDecimal$;
/** @constructor */
function $h_Ljava_math_BigDecimal$() {
}
export { $h_Ljava_math_BigDecimal$ as $h_Ljava_math_BigDecimal$ };
$h_Ljava_math_BigDecimal$.prototype = $c_Ljava_math_BigDecimal$.prototype;
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__I__Ljava_math_BigDecimal = (function(unscaledVal, scale) {
  return ((scale === 0) ? this.valueOf__J__Ljava_math_BigDecimal(unscaledVal) : (((((unscaledVal.RTLong__f_lo === 0) && (unscaledVal.RTLong__f_hi === 0)) && (scale >= 0)) && (scale < this.Ljava_math_BigDecimal$__f_ZeroScaledBy.u.length)) ? this.Ljava_math_BigDecimal$__f_ZeroScaledBy.u[scale] : $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, scale)));
});
$c_Ljava_math_BigDecimal$.prototype.valueOf__J__Ljava_math_BigDecimal = (function(unscaledVal) {
  var ahi = unscaledVal.RTLong__f_hi;
  if ((ahi >= 0)) {
    var ahi$1 = unscaledVal.RTLong__f_hi;
    var $x_1 = ((ahi$1 === 0) ? ((unscaledVal.RTLong__f_lo >>> 0) < 11) : (ahi$1 < 0));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return this.Ljava_math_BigDecimal$__f_BigIntScaledByZero.u[unscaledVal.RTLong__f_lo];
  } else {
    return $ct_Ljava_math_BigDecimal__J__I__(new $c_Ljava_math_BigDecimal(), unscaledVal, 0);
  }
});
$c_Ljava_math_BigDecimal$.prototype.valueOf__D__Ljava_math_BigDecimal = (function(d) {
  if ((((d === Infinity) || (d === (-Infinity))) || (d !== d))) {
    throw new $c_jl_NumberFormatException(("Infinity or NaN: " + d));
  }
  return $ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), ("" + d));
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal = (function(thisValue, augend, diffScale) {
  if (((diffScale < this.Ljava_math_BigDecimal$__f_LongTenPows.u.length) && ($p_Ljava_math_BigDecimal$__maxLen$1__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__I(this, thisValue, augend, diffScale) < 64))) {
    var a = augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var b = this.Ljava_math_BigDecimal$__f_LongTenPows.u[diffScale];
    var alo = a.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    var a$1 = thisValue.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var alo$1 = a$1.RTLong__f_lo;
    var lo$1 = ((alo$1 + lo) | 0);
    var hi$1 = ((((a$1.RTLong__f_hi + hi) | 0) + ((((alo$1 & lo) | ((alo$1 | lo) & (~lo$1))) >>> 31) | 0)) | 0);
    return this.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1), thisValue.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
  } else {
    var $x_2 = $m_Ljava_math_Multiplication$();
    var $x_1 = augend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var hi$2 = (diffScale >> 31);
    var bi = $x_2.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($x_1, new $c_RTLong(diffScale, hi$2));
    var this$4 = thisValue.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$4, bi), thisValue.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$divideBigIntegers__Ljava_math_BigInteger__Ljava_math_BigInteger__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(scaledDividend, scaledDivisor, scale, roundingMode) {
  var qr = scaledDividend.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(scaledDivisor);
  var this$1 = qr.Ljava_math_BigInteger$QuotAndRem__f_rem;
  if ((this$1.Ljava_math_BigInteger__f_sign === 0)) {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), qr.Ljava_math_BigInteger$QuotAndRem__f_quot, scale);
  } else {
    var sign = Math.imul(scaledDividend.Ljava_math_BigInteger__f_sign, scaledDivisor.Ljava_math_BigInteger__f_sign);
    var parityBit = (qr.Ljava_math_BigInteger$QuotAndRem__f_quot.testBit__I__Z(0) ? 1 : 0);
    if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(scaledDivisor) < 63)) {
      var t = qr.Ljava_math_BigInteger$QuotAndRem__f_rem.longValue__J();
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = scaledDivisor.longValue__J();
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var sign$1 = (hi >> 31);
      var xlo = (lo ^ sign$1);
      var rlo = ((xlo - sign$1) | 0);
      var rhi = (((hi ^ sign$1) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
      var lo$2 = (rlo << 1);
      var hi$2 = (((rlo >>> 31) | 0) | (rhi << 1));
      var $x_1 = new $c_RTLong(lo$2, hi$2);
      var sign$2 = (hi$1 >> 31);
      var xlo$1 = (lo$1 ^ sign$2);
      var rlo$1 = ((xlo$1 - sign$2) | 0);
      var rhi$1 = (((hi$1 ^ sign$2) + (((xlo$1 & (~rlo$1)) >>> 31) | 0)) | 0);
      var compRem = this.java$math$BigDecimal$$longCompareTo__J__J__I($x_1, new $c_RTLong(rlo$1, rhi$1));
      var compRem$3 = this.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, Math.imul(sign, ((5 + compRem) | 0)), roundingMode);
    } else {
      var compRem$2 = qr.Ljava_math_BigInteger$QuotAndRem__f_rem.abs__Ljava_math_BigInteger().shiftLeftOneBit__Ljava_math_BigInteger().compareTo__Ljava_math_BigInteger__I(scaledDivisor.abs__Ljava_math_BigInteger());
      var compRem$3 = this.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, Math.imul(sign, ((5 + compRem$2) | 0)), roundingMode);
    }
    if ((compRem$3 !== 0)) {
      var this$5 = qr.Ljava_math_BigInteger$QuotAndRem__f_quot;
      if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$5) < 63)) {
        var a = qr.Ljava_math_BigInteger$QuotAndRem__f_quot.longValue__J();
        var hi$3 = (compRem$3 >> 31);
        var alo = a.RTLong__f_lo;
        var lo$3 = ((alo + compRem$3) | 0);
        var hi$4 = ((((a.RTLong__f_hi + hi$3) | 0) + ((((alo & compRem$3) | ((alo | compRem$3) & (~lo$3))) >>> 31) | 0)) | 0);
        return this.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$3, hi$4), scale);
      } else {
        var this$9 = qr.Ljava_math_BigInteger$QuotAndRem__f_quot;
        var $x_2 = $m_Ljava_math_BigInteger$();
        var hi$5 = (compRem$3 >> 31);
        var bi = $x_2.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(compRem$3, hi$5));
        var quotient2 = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$9, bi);
        return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), quotient2, scale);
      }
    } else {
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), qr.Ljava_math_BigInteger$QuotAndRem__f_quot, scale);
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(scaledDividend, scaledDivisor, scale, roundingMode) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(scaledDividend.RTLong__f_lo, scaledDividend.RTLong__f_hi, scaledDivisor.RTLong__f_lo, scaledDivisor.RTLong__f_hi);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var alo = scaledDivisor.RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(alo, hi) + Math.imul(scaledDivisor.RTLong__f_hi, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var alo$1 = scaledDividend.RTLong__f_lo;
  var lo$2 = ((alo$1 - lo$1) | 0);
  var hi$2 = ((((scaledDividend.RTLong__f_hi - hi$1) | 0) + ((((~alo$1) & lo$1) | ((~(alo$1 ^ lo$1)) & lo$2)) >> 31)) | 0);
  var hi$3 = scaledDividend.RTLong__f_hi;
  var lo$3 = (hi$3 >> 31);
  var blo = scaledDividend.RTLong__f_lo;
  var lo$4 = ((-blo) | 0);
  var hi$5 = ((((-scaledDividend.RTLong__f_hi) | 0) + ((blo | lo$4) >> 31)) | 0);
  var lo$5 = ((hi$5 >>> 31) | 0);
  var lo$6 = (lo$3 | lo$5);
  var hi$6 = scaledDivisor.RTLong__f_hi;
  var lo$7 = (hi$6 >> 31);
  var blo$1 = scaledDivisor.RTLong__f_lo;
  var lo$8 = ((-blo$1) | 0);
  var hi$8 = ((((-scaledDivisor.RTLong__f_hi) | 0) + ((blo$1 | lo$8) >> 31)) | 0);
  var lo$9 = ((hi$8 >>> 31) | 0);
  var lo$10 = (lo$7 | lo$9);
  var sign = Math.imul(lo$6, lo$10);
  if ((!((lo$2 === 0) && (hi$2 === 0)))) {
    var sign$1 = (hi$2 >> 31);
    var xlo = (lo$2 ^ sign$1);
    var rlo = ((xlo - sign$1) | 0);
    var rhi = (((hi$2 ^ sign$1) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var lo$11 = (rlo << 1);
    var hi$9 = (((rlo >>> 31) | 0) | (rhi << 1));
    var $x_1 = new $c_RTLong(lo$11, hi$9);
    var lo$12 = scaledDivisor.RTLong__f_lo;
    var hi$10 = scaledDivisor.RTLong__f_hi;
    var sign$2 = (hi$10 >> 31);
    var xlo$1 = (lo$12 ^ sign$2);
    var rlo$1 = ((xlo$1 - sign$2) | 0);
    var rhi$1 = (((hi$10 ^ sign$2) + (((xlo$1 & (~rlo$1)) >>> 31) | 0)) | 0);
    var compRem = this.java$math$BigDecimal$$longCompareTo__J__J__I($x_1, new $c_RTLong(rlo$1, rhi$1));
    var value = this.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I((1 & lo), Math.imul(sign, ((5 + compRem) | 0)), roundingMode);
    var hi$11 = (value >> 31);
    var lo$13 = ((lo + value) | 0);
    var hi$12 = ((((hi + hi$11) | 0) + ((((lo & value) | ((lo | value) & (~lo$13))) >>> 31) | 0)) | 0);
    var quotient__lo = lo$13;
    var quotient__hi = hi$12;
  } else {
    var quotient__lo = lo;
    var quotient__hi = hi;
  }
  return this.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(quotient__lo, quotient__hi), scale);
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$longCompareTo__J__J__I = (function(value1, value2) {
  var ahi = value1.RTLong__f_hi;
  var bhi = value2.RTLong__f_hi;
  if (((ahi === bhi) ? ((value1.RTLong__f_lo >>> 0) > (value2.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
    return 1;
  } else {
    var ahi$1 = value1.RTLong__f_hi;
    var bhi$1 = value2.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? ((value1.RTLong__f_lo >>> 0) < (value2.RTLong__f_lo >>> 0)) : (ahi$1 < bhi$1))) {
      return (-1);
    } else {
      return 0;
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.newArrayOfPows__I__I__AJ = (function(len, pow) {
  var result = new $ac_J(len);
  result.u[0] = new $c_RTLong(1, 0);
  var i = 1;
  while ((i < len)) {
    var value = i;
    var a = result.u[(((-1) + value) | 0)];
    var hi = (pow >> 31);
    var alo = a.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & pow);
    var b1 = ((pow >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((((((((Math.imul(alo, hi) + Math.imul(a.RTLong__f_hi, pow)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    result.u[value] = new $c_RTLong(lo, hi$1);
    i = ((1 + i) | 0);
  }
  return result;
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I = (function(parityBit, fraction, roundingMode) {
  var sign = (fraction >> 31);
  var absFraction = (((fraction ^ sign) - sign) | 0);
  var sigFraction = ((fraction >> 31) | ((((-fraction) | 0) >>> 31) | 0));
  var x = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UP;
  if ((x === roundingMode)) {
    return sigFraction;
  } else {
    var x$3 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_DOWN;
    if ((x$3 === roundingMode)) {
      return 0;
    } else {
      var x$5 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_CEILING;
      if ((x$5 === roundingMode)) {
        return ((sigFraction > 0) ? sigFraction : 0);
      } else {
        var x$7 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR;
        if ((x$7 === roundingMode)) {
          return ((sigFraction < 0) ? sigFraction : 0);
        } else {
          var x$9 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_UP;
          if ((x$9 === roundingMode)) {
            return ((absFraction >= 5) ? sigFraction : 0);
          } else {
            var x$11 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_DOWN;
            if ((x$11 === roundingMode)) {
              return ((absFraction > 5) ? sigFraction : 0);
            } else {
              var x$13 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN;
              if ((x$13 === roundingMode)) {
                return ((((absFraction + parityBit) | 0) > 5) ? sigFraction : 0);
              } else {
                var x$15 = $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_UNNECESSARY;
                if ((x$15 === roundingMode)) {
                  if ((fraction === 0)) {
                    return 0;
                  } else {
                    throw new $c_jl_ArithmeticException("Rounding necessary");
                  }
                } else {
                  throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), roundingMode);
                }
              }
            }
          }
        }
      }
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$safeLongToInt__J__I = (function(longValue) {
  var ahi = longValue.RTLong__f_hi;
  if (((ahi === (-1)) ? ((longValue.RTLong__f_lo >>> 0) < 2147483648) : (ahi < (-1)))) {
    var $x_1 = true;
  } else {
    var ahi$1 = longValue.RTLong__f_hi;
    var $x_1 = ((ahi$1 === 0) ? ((longValue.RTLong__f_lo >>> 0) > 2147483647) : (ahi$1 > 0));
  }
  if ($x_1) {
    throw new $c_jl_ArithmeticException(("Out of int range: " + longValue));
  }
  return longValue.RTLong__f_lo;
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal = (function(longScale) {
  var value = longScale.RTLong__f_lo;
  var hi = (value >> 31);
  if (((longScale.RTLong__f_lo === value) && (longScale.RTLong__f_hi === hi))) {
    return this.valueOf__J__I__Ljava_math_BigDecimal($L0, longScale.RTLong__f_lo);
  } else {
    var ahi = longScale.RTLong__f_hi;
    if ((ahi >= 0)) {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, 2147483647);
    } else {
      return $ct_Ljava_math_BigDecimal__I__I__(new $c_Ljava_math_BigDecimal(), 0, (-2147483648));
    }
  }
});
$c_Ljava_math_BigDecimal$.prototype.bitLength__J__I = (function(sValue) {
  var ahi = sValue.RTLong__f_hi;
  if ((ahi < 0)) {
    var lo = (~sValue.RTLong__f_lo);
    var hi = (~sValue.RTLong__f_hi);
    var x__lo = lo;
    var x__hi = hi;
    var t = new $c_RTLong(x__lo, x__hi);
  } else {
    var t = sValue;
  }
  var lo$1 = t.RTLong__f_lo;
  var hi$1 = t.RTLong__f_hi;
  return ((64 - ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo$1)) | 0))) | 0);
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$bitLength__I__I = (function(sValue) {
  var smallValue = ((sValue < 0) ? (~sValue) : sValue);
  return ((32 - Math.clz32(smallValue)) | 0);
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$charNotEqualTo__C__AC__Z = (function(c, cs) {
  return (!this.java$math$BigDecimal$$charEqualTo__C__AC__Z(c, cs));
});
$c_Ljava_math_BigDecimal$.prototype.java$math$BigDecimal$$charEqualTo__C__AC__Z = (function(c, cs) {
  var len = cs.u.length;
  var i = 0;
  while ((i !== len)) {
    if ((cs.u[i] === c)) {
      return true;
    }
    i = ((1 + i) | 0);
  }
  return false;
});
var $d_Ljava_math_BigDecimal$ = new $TypeData().initClass($c_Ljava_math_BigDecimal$, "java.math.BigDecimal$", ({
  Ljava_math_BigDecimal$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_math_BigDecimal$ as $d_Ljava_math_BigDecimal$ };
var $n_Ljava_math_BigDecimal$;
function $m_Ljava_math_BigDecimal$() {
  if ((!$n_Ljava_math_BigDecimal$)) {
    $n_Ljava_math_BigDecimal$ = new $c_Ljava_math_BigDecimal$();
  }
  return $n_Ljava_math_BigDecimal$;
}
export { $m_Ljava_math_BigDecimal$ as $m_Ljava_math_BigDecimal$ };
/** @constructor */
function $c_Ljava_math_BigInteger$() {
  this.Ljava_math_BigInteger$__f_ONE = null;
  this.Ljava_math_BigInteger$__f_TEN = null;
  this.Ljava_math_BigInteger$__f_ZERO = null;
  this.Ljava_math_BigInteger$__f_MINUS_ONE = null;
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = null;
  this.Ljava_math_BigInteger$__f_TWO_POWS = null;
  $n_Ljava_math_BigInteger$ = this;
  this.Ljava_math_BigInteger$__f_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 1);
  this.Ljava_math_BigInteger$__f_TEN = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 10);
  this.Ljava_math_BigInteger$__f_ZERO = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 0, 0);
  this.Ljava_math_BigInteger$__f_MINUS_ONE = $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), (-1), 1);
  this.Ljava_math_BigInteger$__f_SMALL_VALUES = new ($d_Ljava_math_BigInteger.getArrayOf().constr)([this.Ljava_math_BigInteger$__f_ZERO, this.Ljava_math_BigInteger$__f_ONE, $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 2), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 3), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 4), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 5), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 6), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 7), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 8), $ct_Ljava_math_BigInteger__I__I__(new $c_Ljava_math_BigInteger(), 1, 9), this.Ljava_math_BigInteger$__f_TEN]);
  var result = new ($d_Ljava_math_BigInteger.getArrayOf().constr)(32);
  var i = 0;
  while ((i < 32)) {
    var value = i;
    var $x_1 = $m_Ljava_math_BigInteger$();
    var lo = (((32 & value) === 0) ? (1 << value) : 0);
    var hi = (((32 & value) === 0) ? 0 : (1 << value));
    result.u[value] = $x_1.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi));
    i = ((1 + i) | 0);
  }
  this.Ljava_math_BigInteger$__f_TWO_POWS = result;
}
export { $c_Ljava_math_BigInteger$ as $c_Ljava_math_BigInteger$ };
$c_Ljava_math_BigInteger$.prototype = new $h_O();
$c_Ljava_math_BigInteger$.prototype.constructor = $c_Ljava_math_BigInteger$;
/** @constructor */
function $h_Ljava_math_BigInteger$() {
}
export { $h_Ljava_math_BigInteger$ as $h_Ljava_math_BigInteger$ };
$h_Ljava_math_BigInteger$.prototype = $c_Ljava_math_BigInteger$.prototype;
$c_Ljava_math_BigInteger$.prototype.valueOf__J__Ljava_math_BigInteger = (function(lVal) {
  var ahi = lVal.RTLong__f_hi;
  if ((ahi < 0)) {
    if ((!((lVal.RTLong__f_lo === (-1)) && (lVal.RTLong__f_hi === (-1))))) {
      var blo = lVal.RTLong__f_lo;
      var lo = ((-blo) | 0);
      var hi = ((((-lVal.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), (-1), new $c_RTLong(lo, hi));
    } else {
      return this.Ljava_math_BigInteger$__f_MINUS_ONE;
    }
  } else {
    var ahi$1 = lVal.RTLong__f_hi;
    if (((ahi$1 === 0) ? ((lVal.RTLong__f_lo >>> 0) <= 10) : (ahi$1 < 0))) {
      return this.Ljava_math_BigInteger$__f_SMALL_VALUES.u[lVal.RTLong__f_lo];
    } else {
      return $ct_Ljava_math_BigInteger__I__J__(new $c_Ljava_math_BigInteger(), 1, lVal);
    }
  }
});
$c_Ljava_math_BigInteger$.prototype.getPowerOfTwo__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < this.Ljava_math_BigInteger$__f_TWO_POWS.u.length)) {
    return this.Ljava_math_BigInteger$__f_TWO_POWS.u[exp];
  } else {
    var intCount = (exp >> 5);
    var bitN = (31 & exp);
    var resDigits = new $ac_I(((1 + intCount) | 0));
    resDigits.u[intCount] = (1 << bitN);
    return $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, ((1 + intCount) | 0), resDigits);
  }
});
$c_Ljava_math_BigInteger$.prototype.checkRangeBasedOnIntArrayLength__I__V = (function(byteLength) {
  if (((byteLength < 0) || (byteLength >= 67108864))) {
    throw new $c_jl_ArithmeticException("BigInteger would overflow supported range");
  }
});
var $d_Ljava_math_BigInteger$ = new $TypeData().initClass($c_Ljava_math_BigInteger$, "java.math.BigInteger$", ({
  Ljava_math_BigInteger$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_math_BigInteger$ as $d_Ljava_math_BigInteger$ };
var $n_Ljava_math_BigInteger$;
function $m_Ljava_math_BigInteger$() {
  if ((!$n_Ljava_math_BigInteger$)) {
    $n_Ljava_math_BigInteger$ = new $c_Ljava_math_BigInteger$();
  }
  return $n_Ljava_math_BigInteger$;
}
export { $m_Ljava_math_BigInteger$ as $m_Ljava_math_BigInteger$ };
/** @constructor */
function $c_Ljava_math_RoundingMode$() {
  this.Ljava_math_RoundingMode$__f_UP = null;
  this.Ljava_math_RoundingMode$__f_DOWN = null;
  this.Ljava_math_RoundingMode$__f_CEILING = null;
  this.Ljava_math_RoundingMode$__f_FLOOR = null;
  this.Ljava_math_RoundingMode$__f_HALF_UP = null;
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = null;
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = null;
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = null;
  $n_Ljava_math_RoundingMode$ = this;
  this.Ljava_math_RoundingMode$__f_UP = new $c_Ljava_math_RoundingMode("UP", 0);
  this.Ljava_math_RoundingMode$__f_DOWN = new $c_Ljava_math_RoundingMode("DOWN", 1);
  this.Ljava_math_RoundingMode$__f_CEILING = new $c_Ljava_math_RoundingMode("CEILING", 2);
  this.Ljava_math_RoundingMode$__f_FLOOR = new $c_Ljava_math_RoundingMode("FLOOR", 3);
  this.Ljava_math_RoundingMode$__f_HALF_UP = new $c_Ljava_math_RoundingMode("HALF_UP", 4);
  this.Ljava_math_RoundingMode$__f_HALF_DOWN = new $c_Ljava_math_RoundingMode("HALF_DOWN", 5);
  this.Ljava_math_RoundingMode$__f_HALF_EVEN = new $c_Ljava_math_RoundingMode("HALF_EVEN", 6);
  this.Ljava_math_RoundingMode$__f_UNNECESSARY = new $c_Ljava_math_RoundingMode("UNNECESSARY", 7);
}
export { $c_Ljava_math_RoundingMode$ as $c_Ljava_math_RoundingMode$ };
$c_Ljava_math_RoundingMode$.prototype = new $h_O();
$c_Ljava_math_RoundingMode$.prototype.constructor = $c_Ljava_math_RoundingMode$;
/** @constructor */
function $h_Ljava_math_RoundingMode$() {
}
export { $h_Ljava_math_RoundingMode$ as $h_Ljava_math_RoundingMode$ };
$h_Ljava_math_RoundingMode$.prototype = $c_Ljava_math_RoundingMode$.prototype;
var $d_Ljava_math_RoundingMode$ = new $TypeData().initClass($c_Ljava_math_RoundingMode$, "java.math.RoundingMode$", ({
  Ljava_math_RoundingMode$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_math_RoundingMode$ as $d_Ljava_math_RoundingMode$ };
var $n_Ljava_math_RoundingMode$;
function $m_Ljava_math_RoundingMode$() {
  if ((!$n_Ljava_math_RoundingMode$)) {
    $n_Ljava_math_RoundingMode$ = new $c_Ljava_math_RoundingMode$();
  }
  return $n_Ljava_math_RoundingMode$;
}
export { $m_Ljava_math_RoundingMode$ as $m_Ljava_math_RoundingMode$ };
function $p_Ljava_nio_charset_Charset__cachedDecoder$lzycompute__Ljava_nio_charset_CharsetDecoder($thiz) {
  if (((((2 & $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_nio_charset_Charset__f_cachedDecoder = $thiz.newDecoder__Ljava_nio_charset_CharsetDecoder().onMalformedInput__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetDecoder($m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE).onUnmappableCharacter__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetDecoder($m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE);
    $thiz.Ljava_nio_charset_Charset__f_bitmap$0 = (((2 | $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.Ljava_nio_charset_Charset__f_cachedDecoder;
}
export { $p_Ljava_nio_charset_Charset__cachedDecoder$lzycompute__Ljava_nio_charset_CharsetDecoder as $p_Ljava_nio_charset_Charset__cachedDecoder$lzycompute__Ljava_nio_charset_CharsetDecoder };
function $p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder($thiz) {
  return (((((2 & $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_nio_charset_Charset__cachedDecoder$lzycompute__Ljava_nio_charset_CharsetDecoder($thiz) : $thiz.Ljava_nio_charset_Charset__f_cachedDecoder);
}
export { $p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder as $p_Ljava_nio_charset_Charset__cachedDecoder__Ljava_nio_charset_CharsetDecoder };
function $p_Ljava_nio_charset_Charset__cachedEncoder$lzycompute__Ljava_nio_charset_CharsetEncoder($thiz) {
  if (((((4 & $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.Ljava_nio_charset_Charset__f_cachedEncoder = $thiz.newEncoder__Ljava_nio_charset_CharsetEncoder().onMalformedInput__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder($m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE).onUnmappableCharacter__Ljava_nio_charset_CodingErrorAction__Ljava_nio_charset_CharsetEncoder($m_Ljava_nio_charset_CodingErrorAction$().Ljava_nio_charset_CodingErrorAction$__f_REPLACE);
    $thiz.Ljava_nio_charset_Charset__f_bitmap$0 = (((4 | $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.Ljava_nio_charset_Charset__f_cachedEncoder;
}
export { $p_Ljava_nio_charset_Charset__cachedEncoder$lzycompute__Ljava_nio_charset_CharsetEncoder as $p_Ljava_nio_charset_Charset__cachedEncoder$lzycompute__Ljava_nio_charset_CharsetEncoder };
function $p_Ljava_nio_charset_Charset__cachedEncoder__Ljava_nio_charset_CharsetEncoder($thiz) {
  return (((((4 & $thiz.Ljava_nio_charset_Charset__f_bitmap$0) << 24) >> 24) === 0) ? $p_Ljava_nio_charset_Charset__cachedEncoder$lzycompute__Ljava_nio_charset_CharsetEncoder($thiz) : $thiz.Ljava_nio_charset_Charset__f_cachedEncoder);
}
export { $p_Ljava_nio_charset_Charset__cachedEncoder__Ljava_nio_charset_CharsetEncoder as $p_Ljava_nio_charset_Charset__cachedEncoder__Ljava_nio_charset_CharsetEncoder };
function $ct_Ljava_nio_charset_Charset__T__AT__($thiz, canonicalName, _aliases) {
  $thiz.Ljava_nio_charset_Charset__f_canonicalName = canonicalName;
  $thiz.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = _aliases;
  return $thiz;
}
export { $ct_Ljava_nio_charset_Charset__T__AT__ as $ct_Ljava_nio_charset_Charset__T__AT__ };
/** @constructor */
function $c_Ljava_nio_charset_Charset() {
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_cachedEncoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
}
export { $c_Ljava_nio_charset_Charset as $c_Ljava_nio_charset_Charset };
$c_Ljava_nio_charset_Charset.prototype = new $h_O();
$c_Ljava_nio_charset_Charset.prototype.constructor = $c_Ljava_nio_charset_Charset;
/** @constructor */
function $h_Ljava_nio_charset_Charset() {
}
export { $h_Ljava_nio_charset_Charset as $h_Ljava_nio_charset_Charset };
$h_Ljava_nio_charset_Charset.prototype = $c_Ljava_nio_charset_Charset.prototype;
$c_Ljava_nio_charset_Charset.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_Ljava_nio_charset_Charset) && (this.Ljava_nio_charset_Charset__f_canonicalName === that.Ljava_nio_charset_Charset__f_canonicalName));
});
$c_Ljava_nio_charset_Charset.prototype.toString__T = (function() {
  return this.Ljava_nio_charset_Charset__f_canonicalName;
});
$c_Ljava_nio_charset_Charset.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I(this.Ljava_nio_charset_Charset__f_canonicalName);
});
$c_Ljava_nio_charset_Charset.prototype.encode__T__Ljava_nio_ByteBuffer = (function(str) {
  var this$1 = $m_Ljava_nio_CharBuffer$();
  var cb = this$1.wrap__jl_CharSequence__I__I__Ljava_nio_CharBuffer(str, 0, str.length);
  return $p_Ljava_nio_charset_Charset__cachedEncoder__Ljava_nio_charset_CharsetEncoder(this).encode__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer(cb);
});
$c_Ljava_nio_charset_Charset.prototype.compareTo__O__I = (function(o) {
  return $f_T__compareToIgnoreCase__T__I(this.Ljava_nio_charset_Charset__f_canonicalName, o.Ljava_nio_charset_Charset__f_canonicalName);
});
function $isArrayOf_Ljava_nio_charset_Charset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_charset_Charset)));
}
export { $isArrayOf_Ljava_nio_charset_Charset as $isArrayOf_Ljava_nio_charset_Charset };
/** @constructor */
function $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder(outer) {
  this.Ljava_nio_charset_CharsetDecoder__f__averageCharsPerByte = 0.0;
  this.Ljava_nio_charset_CharsetDecoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f_status = 0;
  this.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder__f_$outer = null;
  this.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder__f_$outer = outer;
  $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__(this, outer, 1.0, 1.0);
}
export { $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder as $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder };
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder.prototype = new $h_Ljava_nio_charset_CharsetDecoder();
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder.prototype.constructor = $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder;
/** @constructor */
function $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder() {
}
export { $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder as $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder };
$h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder.prototype = $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder.prototype;
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder.prototype.decodeLoop__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult = (function(in$1, out) {
  var maxValue = this.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder__f_$outer.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon__f_java$nio$charset$ISO_8859_1_And_US_ASCII_Common$$maxValue;
  var inRemaining = ((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
  if ((inRemaining === 0)) {
    return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
  } else {
    var outRemaining = ((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
    var overflow = (outRemaining < inRemaining);
    var rem = (overflow ? outRemaining : inRemaining);
    if ((((in$1.Ljava_nio_ByteBuffer__f__array !== null) && (!in$1.Ljava_nio_HeapByteBuffer__f__readOnly)) && ((out.Ljava_nio_CharBuffer__f__array !== null) && (!out.isReadOnly__Z())))) {
      var a = in$1.Ljava_nio_ByteBuffer__f__array;
      if ((a === null)) {
        throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
      }
      if (in$1.Ljava_nio_HeapByteBuffer__f__readOnly) {
        throw new $c_Ljava_nio_ReadOnlyBufferException();
      }
      var o = in$1.Ljava_nio_ByteBuffer__f__arrayOffset;
      if ((o === (-1))) {
        throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
      }
      if (in$1.Ljava_nio_HeapByteBuffer__f__readOnly) {
        throw new $c_Ljava_nio_ReadOnlyBufferException();
      }
      var inStart = ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o) | 0);
      var inEnd = ((inStart + rem) | 0);
      var a$1 = out.Ljava_nio_CharBuffer__f__array;
      if ((a$1 === null)) {
        throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
      }
      if (out.isReadOnly__Z()) {
        throw new $c_Ljava_nio_ReadOnlyBufferException();
      }
      var o$1 = out.Ljava_nio_CharBuffer__f__arrayOffset;
      if ((o$1 === (-1))) {
        throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
      }
      if (out.isReadOnly__Z()) {
        throw new $c_Ljava_nio_ReadOnlyBufferException();
      }
      var outStart = ((out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o$1) | 0);
      var inPos = inStart;
      var outPos = outStart;
      while ((inPos !== inEnd)) {
        var c = (255 & a.u[inPos]);
        if ((c > maxValue)) {
          var newPosition = ((inPos - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition);
          var newPosition$1 = ((outPos - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$1);
          var this$13 = $m_Ljava_nio_charset_CoderResult$();
          return this$13.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
        }
        a$1.u[outPos] = (65535 & c);
        inPos = ((1 + inPos) | 0);
        outPos = ((1 + outPos) | 0);
      }
      var newPosition$2 = ((inPos - o) | 0);
      $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$2);
      var newPosition$3 = ((outPos - o$1) | 0);
      $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$3);
    } else {
      var i = 0;
      while ((i !== rem)) {
        var c$2 = (255 & in$1.get__B());
        if ((c$2 > maxValue)) {
          var newPosition$4 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$4);
          var this$14 = $m_Ljava_nio_charset_CoderResult$();
          return this$14.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
        }
        out.put__C__Ljava_nio_CharBuffer((65535 & c$2));
        i = ((1 + i) | 0);
      }
    }
    return (overflow ? $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW : $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW);
  }
});
var $d_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder = new $TypeData().initClass($c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder, "java.nio.charset.ISO_8859_1_And_US_ASCII_Common$Decoder", ({
  Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder: 1,
  Ljava_nio_charset_CharsetDecoder: 1
}));
export { $d_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder as $d_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder };
/** @constructor */
function $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder(outer) {
  this.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar = 0.0;
  this.Ljava_nio_charset_CharsetEncoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f_status = 0;
  this.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder__f_$outer = null;
  this.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder__f_$outer = outer;
  $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__(this, outer, 1.0, 1.0);
}
export { $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder as $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder };
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder.prototype = new $h_Ljava_nio_charset_CharsetEncoder();
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder.prototype.constructor = $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder;
/** @constructor */
function $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder() {
}
export { $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder as $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder };
$h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder.prototype = $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder.prototype;
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder.prototype.encodeLoop__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult = (function(in$1, out) {
  var maxValue = this.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder__f_$outer.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon__f_java$nio$charset$ISO_8859_1_And_US_ASCII_Common$$maxValue;
  var inRemaining = ((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
  if ((inRemaining === 0)) {
    return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
  } else if ((((in$1.Ljava_nio_CharBuffer__f__array !== null) && (!in$1.isReadOnly__Z())) && ((out.Ljava_nio_ByteBuffer__f__array !== null) && (!out.Ljava_nio_HeapByteBuffer__f__readOnly)))) {
    var outRemaining = ((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
    var overflow = (outRemaining < inRemaining);
    var rem = (overflow ? outRemaining : inRemaining);
    var a = in$1.Ljava_nio_CharBuffer__f__array;
    if ((a === null)) {
      throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
    }
    if (in$1.isReadOnly__Z()) {
      throw new $c_Ljava_nio_ReadOnlyBufferException();
    }
    var o = in$1.Ljava_nio_CharBuffer__f__arrayOffset;
    if ((o === (-1))) {
      throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
    }
    if (in$1.isReadOnly__Z()) {
      throw new $c_Ljava_nio_ReadOnlyBufferException();
    }
    var inStart = ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o) | 0);
    var inEnd = ((inStart + rem) | 0);
    var a$1 = out.Ljava_nio_ByteBuffer__f__array;
    if ((a$1 === null)) {
      throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
    }
    if (out.Ljava_nio_HeapByteBuffer__f__readOnly) {
      throw new $c_Ljava_nio_ReadOnlyBufferException();
    }
    var o$1 = out.Ljava_nio_ByteBuffer__f__arrayOffset;
    if ((o$1 === (-1))) {
      throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
    }
    if (out.Ljava_nio_HeapByteBuffer__f__readOnly) {
      throw new $c_Ljava_nio_ReadOnlyBufferException();
    }
    var outStart = ((out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o$1) | 0);
    var inPos = inStart;
    var outPos = outStart;
    while (true) {
      if ((inPos === inEnd)) {
        var result = (overflow ? $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW : $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW);
        var inPos$1 = inPos;
        var outPos$1 = outPos;
        var newPosition = ((inPos$1 - o) | 0);
        $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition);
        var newPosition$1 = ((outPos$1 - o$1) | 0);
        $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$1);
        return result;
      } else {
        var c = a.u[inPos];
        if ((c <= maxValue)) {
          a$1.u[outPos] = ((c << 24) >> 24);
          var temp$inPos = ((1 + inPos) | 0);
          var temp$outPos = ((1 + outPos) | 0);
          inPos = temp$inPos;
          outPos = temp$outPos;
        } else {
          if (((64512 & c) === 56320)) {
            var this$14 = $m_Ljava_nio_charset_CoderResult$();
            var result$1 = this$14.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
          } else if (((64512 & c) === 55296)) {
            if ((((1 + inPos) | 0) < in$1.Ljava_nio_Buffer__f__limit)) {
              var c2 = a.u[((1 + inPos) | 0)];
              if (((64512 & c2) === 56320)) {
                var this$17 = $m_Ljava_nio_charset_CoderResult$();
                var result$1 = this$17.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable2;
              } else {
                var this$18 = $m_Ljava_nio_charset_CoderResult$();
                var result$1 = this$18.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
              }
            } else {
              var result$1 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
            }
          } else {
            var this$19 = $m_Ljava_nio_charset_CoderResult$();
            var result$1 = this$19.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable1;
          }
          var inPos$1$1 = inPos;
          var outPos$1$1 = outPos;
          var newPosition$2 = ((inPos$1$1 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$2);
          var newPosition$3 = ((outPos$1$1 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$3);
          return result$1;
        }
      }
    }
  } else {
    while (true) {
      if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === in$1.Ljava_nio_Buffer__f__limit)) {
        return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      } else if ((out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === out.Ljava_nio_Buffer__f__limit)) {
        return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
      } else {
        var c$1 = in$1.get__C();
        if ((c$1 <= maxValue)) {
          out.put__B__Ljava_nio_ByteBuffer(((c$1 << 24) >> 24));
        } else if (((64512 & c$1) === 56320)) {
          var newPosition$4 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$4);
          var this$21 = $m_Ljava_nio_charset_CoderResult$();
          return this$21.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
        } else if (((64512 & c$1) === 55296)) {
          if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== in$1.Ljava_nio_Buffer__f__limit)) {
            var c2$1 = in$1.get__C();
            var newPosition$5 = (((-2) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$5);
            if (((64512 & c2$1) === 56320)) {
              var this$24 = $m_Ljava_nio_charset_CoderResult$();
              return this$24.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable2;
            } else {
              var this$25 = $m_Ljava_nio_charset_CoderResult$();
              return this$25.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
            }
          } else {
            var newPosition$6 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$6);
            return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
          }
        } else {
          var newPosition$7 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$7);
          var this$26 = $m_Ljava_nio_charset_CoderResult$();
          return this$26.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Unmappable1;
        }
      }
    }
  }
});
var $d_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder = new $TypeData().initClass($c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder, "java.nio.charset.ISO_8859_1_And_US_ASCII_Common$Encoder", ({
  Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder: 1,
  Ljava_nio_charset_CharsetEncoder: 1
}));
export { $d_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder as $d_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder };
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder(outer) {
  this.Ljava_nio_charset_CharsetDecoder__f__averageCharsPerByte = 0.0;
  this.Ljava_nio_charset_CharsetDecoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f_status = 0;
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder__f_java$nio$charset$UTF_16_Common$Decoder$$endianness = 0;
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder__f_$outer = null;
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder__f_$outer = outer;
  $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__(this, outer, 0.5, 1.0);
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder__f_java$nio$charset$UTF_16_Common$Decoder$$endianness = outer.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness;
}
export { $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder as $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder };
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder.prototype = new $h_Ljava_nio_charset_CharsetDecoder();
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder() {
}
export { $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder as $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder };
$h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder.prototype = $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder.prototype;
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder.prototype.implReset__V = (function() {
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder__f_java$nio$charset$UTF_16_Common$Decoder$$endianness = this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder__f_$outer.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness;
});
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder.prototype.decodeLoop__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult = (function(in$1, out) {
  while (true) {
    if ((((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 2)) {
      return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
    } else {
      var b1 = (255 & in$1.get__B());
      var b2 = (255 & in$1.get__B());
      if ((this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder__f_java$nio$charset$UTF_16_Common$Decoder$$endianness === 0)) {
        if (((b1 === 254) && (b2 === 255))) {
          this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder__f_java$nio$charset$UTF_16_Common$Decoder$$endianness = 1;
          var wasBOM = true;
        } else if (((b1 === 255) && (b2 === 254))) {
          this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder__f_java$nio$charset$UTF_16_Common$Decoder$$endianness = 2;
          var wasBOM = true;
        } else {
          this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder__f_java$nio$charset$UTF_16_Common$Decoder$$endianness = 1;
          var wasBOM = false;
        }
      } else {
        var wasBOM = false;
      }
      if (wasBOM) {
      } else {
        var bigEndian = (this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder__f_java$nio$charset$UTF_16_Common$Decoder$$endianness === 1);
        var c1 = (65535 & (bigEndian ? ((b1 << 8) | b2) : ((b2 << 8) | b1)));
        if (((64512 & c1) === 56320)) {
          var newPosition = (((-2) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition);
          var this$2 = $m_Ljava_nio_charset_CoderResult$();
          return this$2.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2;
        } else if (((64512 & c1) !== 55296)) {
          if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) === 0)) {
            var newPosition$1 = (((-2) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$1);
            return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
          } else {
            out.put__C__Ljava_nio_CharBuffer(c1);
          }
        } else if ((((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 2)) {
          var newPosition$2 = (((-2) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$2);
          return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
        } else {
          var b3 = (255 & in$1.get__B());
          var b4 = (255 & in$1.get__B());
          var c2 = (65535 & (bigEndian ? ((b3 << 8) | b4) : ((b4 << 8) | b3)));
          if (((64512 & c2) !== 56320)) {
            var newPosition$3 = (((-4) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$3);
            var this$5 = $m_Ljava_nio_charset_CoderResult$();
            return this$5.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed4;
          } else if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 2)) {
            var newPosition$4 = (((-4) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$4);
            return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
          } else {
            out.put__C__Ljava_nio_CharBuffer(c1);
            out.put__C__Ljava_nio_CharBuffer(c2);
          }
        }
      }
    }
  }
});
var $d_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder = new $TypeData().initClass($c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder, "java.nio.charset.UTF_16_Common$Decoder", ({
  Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder: 1,
  Ljava_nio_charset_CharsetDecoder: 1
}));
export { $d_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder as $d_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder };
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder(outer) {
  this.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar = 0.0;
  this.Ljava_nio_charset_CharsetEncoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f_status = 0;
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder__f_needToWriteBOM = false;
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder__f_$outer = null;
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder__f_$outer = outer;
  $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__AB__(this, outer, 2.0, ((outer.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness === 0) ? 4.0 : 2.0), ((outer.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness === 2) ? new $ac_B(new Int8Array([(-3), (-1)])) : new $ac_B(new Int8Array([(-1), (-3)]))));
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder__f_needToWriteBOM = (outer.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness === 0);
}
export { $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder as $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder };
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder.prototype = new $h_Ljava_nio_charset_CharsetEncoder();
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder() {
}
export { $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder as $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder };
$h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder.prototype = $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder.prototype;
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder.prototype.implReset__V = (function() {
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder__f_needToWriteBOM = (this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder__f_$outer.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness === 0);
});
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder.prototype.encodeLoop__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult = (function(in$1, out) {
  if (this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder__f_needToWriteBOM) {
    if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 2)) {
      return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
    } else {
      out.put__B__Ljava_nio_ByteBuffer((-2));
      out.put__B__Ljava_nio_ByteBuffer((-1));
      this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder__f_needToWriteBOM = false;
    }
  }
  var bigEndian = (this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder__f_$outer.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness !== 2);
  while (true) {
    if ((((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) === 0)) {
      return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
    } else {
      var c1 = in$1.get__C();
      if (((64512 & c1) === 56320)) {
        var newPosition = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
        $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition);
        var this$2 = $m_Ljava_nio_charset_CoderResult$();
        return this$2.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
      } else if (((64512 & c1) !== 55296)) {
        if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 2)) {
          var newPosition$1 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$1);
          return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
        } else if (bigEndian) {
          out.put__B__Ljava_nio_ByteBuffer((((c1 >> 8) << 24) >> 24));
          out.put__B__Ljava_nio_ByteBuffer(((c1 << 24) >> 24));
        } else {
          out.put__B__Ljava_nio_ByteBuffer(((c1 << 24) >> 24));
          out.put__B__Ljava_nio_ByteBuffer((((c1 >> 8) << 24) >> 24));
        }
      } else if ((((in$1.Ljava_nio_Buffer__f__limit - in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 1)) {
        var newPosition$2 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
        $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$2);
        return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      } else {
        var c2 = in$1.get__C();
        if (((64512 & c2) !== 56320)) {
          var newPosition$3 = (((-2) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$3);
          var this$5 = $m_Ljava_nio_charset_CoderResult$();
          return this$5.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
        } else if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 4)) {
          var newPosition$4 = (((-2) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$4);
          return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
        } else {
          if (bigEndian) {
            out.put__B__Ljava_nio_ByteBuffer((((c1 >> 8) << 24) >> 24));
            out.put__B__Ljava_nio_ByteBuffer(((c1 << 24) >> 24));
          } else {
            out.put__B__Ljava_nio_ByteBuffer(((c1 << 24) >> 24));
            out.put__B__Ljava_nio_ByteBuffer((((c1 >> 8) << 24) >> 24));
          }
          if (bigEndian) {
            out.put__B__Ljava_nio_ByteBuffer((((c2 >> 8) << 24) >> 24));
            out.put__B__Ljava_nio_ByteBuffer(((c2 << 24) >> 24));
          } else {
            out.put__B__Ljava_nio_ByteBuffer(((c2 << 24) >> 24));
            out.put__B__Ljava_nio_ByteBuffer((((c2 >> 8) << 24) >> 24));
          }
        }
      }
    }
  }
});
var $d_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder = new $TypeData().initClass($c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder, "java.nio.charset.UTF_16_Common$Encoder", ({
  Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder: 1,
  Ljava_nio_charset_CharsetEncoder: 1
}));
export { $d_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder as $d_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder };
function $p_Ljava_nio_charset_UTF\uff3f8$Decoder__decodeLoopArray__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult($thiz, in$1, out) {
  var a = in$1.Ljava_nio_ByteBuffer__f__array;
  if ((a === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (in$1.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var o = in$1.Ljava_nio_ByteBuffer__f__arrayOffset;
  if ((o === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (in$1.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var inStart = ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o) | 0);
  var inEnd = ((in$1.Ljava_nio_Buffer__f__limit + o) | 0);
  var a$1 = out.Ljava_nio_CharBuffer__f__array;
  if ((a$1 === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (out.isReadOnly__Z()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var o$1 = out.Ljava_nio_CharBuffer__f__arrayOffset;
  if ((o$1 === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (out.isReadOnly__Z()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var outStart = ((out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o$1) | 0);
  var outEnd = ((out.Ljava_nio_Buffer__f__limit + o$1) | 0);
  var inPos = inStart;
  var outPos = outStart;
  while (true) {
    if ((inPos === inEnd)) {
      var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      var inPos$1 = inPos;
      var outPos$1 = outPos;
      var newPosition = ((inPos$1 - o) | 0);
      $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition);
      var newPosition$1 = ((outPos$1 - o$1) | 0);
      $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$1);
      return result;
    } else {
      var leading = a.u[inPos];
      if ((leading >= 0)) {
        if ((outPos === outEnd)) {
          var result$1 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
          var inPos$1$1 = inPos;
          var outPos$1$1 = outPos;
          var newPosition$2 = ((inPos$1$1 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$2);
          var newPosition$3 = ((outPos$1$1 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$3);
          return result$1;
        } else {
          a$1.u[outPos] = (65535 & leading);
          var temp$inPos = ((1 + inPos) | 0);
          var temp$outPos = ((1 + outPos) | 0);
          inPos = temp$inPos;
          outPos = temp$outPos;
        }
      } else {
        var length = $m_Ljava_nio_charset_UTF\uff3f8$().Ljava_nio_charset_UTF\uff3f8$__f_java$nio$charset$UTF_8$$lengthByLeading.u[(127 & leading)];
        if ((length === (-1))) {
          var this$9 = $m_Ljava_nio_charset_CoderResult$();
          var result$2 = this$9.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
          var inPos$1$2 = inPos;
          var outPos$1$2 = outPos;
          var newPosition$4 = ((inPos$1$2 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$4);
          var newPosition$5 = ((outPos$1$2 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$5);
          return result$2;
        } else {
          if ((((1 + inPos) | 0) >= inEnd)) {
            var failure = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
            var decoded__failure = failure;
            var decoded__high = 0;
            var decoded__low = 0;
          } else {
            var b2 = a.u[((1 + inPos) | 0)];
            var b = b2;
            if (((192 & b) !== 128)) {
              var this$11 = $m_Ljava_nio_charset_CoderResult$();
              var failure$1 = this$11.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
              var decoded__failure = failure$1;
              var decoded__high = 0;
              var decoded__low = 0;
            } else if ((length === 2)) {
              var b2$1 = b2;
              var codePoint = (((31 & leading) << 6) | (63 & b2$1));
              if ((codePoint < 128)) {
                var this$13 = $m_Ljava_nio_charset_CoderResult$();
                var failure$2 = this$13.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                var decoded__failure = failure$2;
                var decoded__high = 0;
                var decoded__low = 0;
              } else {
                var single = (65535 & codePoint);
                var decoded__failure = null;
                var decoded__high = single;
                var decoded__low = 0;
              }
            } else if ((((2 + inPos) | 0) >= inEnd)) {
              var failure$3 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
              var decoded__failure = failure$3;
              var decoded__high = 0;
              var decoded__low = 0;
            } else {
              var b3 = a.u[((2 + inPos) | 0)];
              var b$1 = b3;
              if (((192 & b$1) !== 128)) {
                var this$17 = $m_Ljava_nio_charset_CoderResult$();
                var failure$4 = this$17.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2;
                var decoded__failure = failure$4;
                var decoded__high = 0;
                var decoded__low = 0;
              } else if ((length === 3)) {
                var b2$2 = b2;
                var b3$1 = b3;
                var codePoint$1 = ((((15 & leading) << 12) | ((63 & b2$2) << 6)) | (63 & b3$1));
                if ((codePoint$1 < 2048)) {
                  var this$19 = $m_Ljava_nio_charset_CoderResult$();
                  var failure$5 = this$19.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                  var decoded__failure = failure$5;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else if (((codePoint$1 >= 55296) && (codePoint$1 <= 57343))) {
                  var this$21 = $m_Ljava_nio_charset_CoderResult$();
                  var failure$6 = this$21.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
                  var decoded__failure = failure$6;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var single$1 = (65535 & codePoint$1);
                  var decoded__failure = null;
                  var decoded__high = single$1;
                  var decoded__low = 0;
                }
              } else if ((((3 + inPos) | 0) >= inEnd)) {
                var failure$7 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
                var decoded__failure = failure$7;
                var decoded__high = 0;
                var decoded__low = 0;
              } else {
                var b4 = a.u[((3 + inPos) | 0)];
                var b$2 = b4;
                if (((192 & b$2) !== 128)) {
                  var this$25 = $m_Ljava_nio_charset_CoderResult$();
                  var failure$8 = this$25.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
                  var decoded__failure = failure$8;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var b2$3 = b2;
                  var b3$2 = b3;
                  var b4$1 = b4;
                  var codePoint$2 = (((((7 & leading) << 18) | ((63 & b2$3) << 12)) | ((63 & b3$2) << 6)) | (63 & b4$1));
                  if (((codePoint$2 < 65536) || (codePoint$2 > 1114111))) {
                    var this$27 = $m_Ljava_nio_charset_CoderResult$();
                    var failure$9 = this$27.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                    var decoded__failure = failure$9;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else {
                    var offsetCodePoint = (((-65536) + codePoint$2) | 0);
                    var high = (65535 & (55296 | (offsetCodePoint >> 10)));
                    var low = (65535 & (56320 | (1023 & offsetCodePoint)));
                    var decoded__failure = null;
                    var decoded__high = high;
                    var decoded__low = low;
                  }
                }
              }
            }
          }
          if ((decoded__failure !== null)) {
            var result$3 = decoded__failure;
            var inPos$1$3 = inPos;
            var outPos$1$3 = outPos;
            var newPosition$6 = ((inPos$1$3 - o) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$6);
            var newPosition$7 = ((outPos$1$3 - o$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$7);
            return result$3;
          } else if ((decoded__low === 0)) {
            if ((outPos === outEnd)) {
              var result$4 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
              var inPos$1$4 = inPos;
              var outPos$1$4 = outPos;
              var newPosition$8 = ((inPos$1$4 - o) | 0);
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$8);
              var newPosition$9 = ((outPos$1$4 - o$1) | 0);
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$9);
              return result$4;
            } else {
              a$1.u[outPos] = decoded__high;
              var temp$inPos$2 = ((inPos + length) | 0);
              var temp$outPos$2 = ((1 + outPos) | 0);
              inPos = temp$inPos$2;
              outPos = temp$outPos$2;
            }
          } else if ((((2 + outPos) | 0) > outEnd)) {
            var result$5 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var inPos$1$5 = inPos;
            var outPos$1$5 = outPos;
            var newPosition$10 = ((inPos$1$5 - o) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$10);
            var newPosition$11 = ((outPos$1$5 - o$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$11);
            return result$5;
          } else {
            a$1.u[outPos] = decoded__high;
            a$1.u[((1 + outPos) | 0)] = decoded__low;
            var temp$inPos$3 = ((inPos + length) | 0);
            var temp$outPos$3 = ((2 + outPos) | 0);
            inPos = temp$inPos$3;
            outPos = temp$outPos$3;
          }
        }
      }
    }
  }
}
export { $p_Ljava_nio_charset_UTF\uff3f8$Decoder__decodeLoopArray__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult as $p_Ljava_nio_charset_UTF\uff3f8$Decoder__decodeLoopArray__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult };
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$Decoder() {
  this.Ljava_nio_charset_CharsetDecoder__f__averageCharsPerByte = 0.0;
  this.Ljava_nio_charset_CharsetDecoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetDecoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetDecoder__f_status = 0;
  $ct_Ljava_nio_charset_CharsetDecoder__Ljava_nio_charset_Charset__F__F__(this, $m_Ljava_nio_charset_UTF\uff3f8$(), 1.0, 1.0);
}
export { $c_Ljava_nio_charset_UTF\uff3f8$Decoder as $c_Ljava_nio_charset_UTF\uff3f8$Decoder };
$c_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype = new $h_Ljava_nio_charset_CharsetDecoder();
$c_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f8$Decoder;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$Decoder() {
}
export { $h_Ljava_nio_charset_UTF\uff3f8$Decoder as $h_Ljava_nio_charset_UTF\uff3f8$Decoder };
$h_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype = $c_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype;
$c_Ljava_nio_charset_UTF\uff3f8$Decoder.prototype.decodeLoop__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult = (function(in$1, out) {
  if ((((in$1.Ljava_nio_ByteBuffer__f__array !== null) && (!in$1.Ljava_nio_HeapByteBuffer__f__readOnly)) && ((out.Ljava_nio_CharBuffer__f__array !== null) && (!out.isReadOnly__Z())))) {
    return $p_Ljava_nio_charset_UTF\uff3f8$Decoder__decodeLoopArray__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer__Ljava_nio_charset_CoderResult(this, in$1, out);
  } else {
    while (true) {
      var startPosition = in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
      if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === in$1.Ljava_nio_Buffer__f__limit)) {
        return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      } else {
        var leading = in$1.get__B();
        if ((leading >= 0)) {
          if ((out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === out.Ljava_nio_Buffer__f__limit)) {
            var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, startPosition);
            return result;
          } else {
            out.put__C__Ljava_nio_CharBuffer((65535 & leading));
          }
        } else {
          var length = $m_Ljava_nio_charset_UTF\uff3f8$().Ljava_nio_charset_UTF\uff3f8$__f_java$nio$charset$UTF_8$$lengthByLeading.u[(127 & leading)];
          if ((length === (-1))) {
            var this$5 = $m_Ljava_nio_charset_CoderResult$();
            var result$1 = this$5.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, startPosition);
            return result$1;
          } else {
            if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== in$1.Ljava_nio_Buffer__f__limit)) {
              var b2 = in$1.get__B();
              var b = b2;
              if (((192 & b) !== 128)) {
                var this$6 = $m_Ljava_nio_charset_CoderResult$();
                var failure = this$6.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                var decoded__failure = failure;
                var decoded__high = 0;
                var decoded__low = 0;
              } else if ((length === 2)) {
                var b2$1 = b2;
                var codePoint = (((31 & leading) << 6) | (63 & b2$1));
                if ((codePoint < 128)) {
                  var this$8 = $m_Ljava_nio_charset_CoderResult$();
                  var failure$1 = this$8.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                  var decoded__failure = failure$1;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else {
                  var single = (65535 & codePoint);
                  var decoded__failure = null;
                  var decoded__high = single;
                  var decoded__low = 0;
                }
              } else if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== in$1.Ljava_nio_Buffer__f__limit)) {
                var b3 = in$1.get__B();
                var b$1 = b3;
                if (((192 & b$1) !== 128)) {
                  var this$11 = $m_Ljava_nio_charset_CoderResult$();
                  var failure$2 = this$11.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed2;
                  var decoded__failure = failure$2;
                  var decoded__high = 0;
                  var decoded__low = 0;
                } else if ((length === 3)) {
                  var b2$2 = b2;
                  var b3$1 = b3;
                  var codePoint$1 = ((((15 & leading) << 12) | ((63 & b2$2) << 6)) | (63 & b3$1));
                  if ((codePoint$1 < 2048)) {
                    var this$13 = $m_Ljava_nio_charset_CoderResult$();
                    var failure$3 = this$13.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                    var decoded__failure = failure$3;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else if (((codePoint$1 >= 55296) && (codePoint$1 <= 57343))) {
                    var this$15 = $m_Ljava_nio_charset_CoderResult$();
                    var failure$4 = this$15.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
                    var decoded__failure = failure$4;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else {
                    var single$1 = (65535 & codePoint$1);
                    var decoded__failure = null;
                    var decoded__high = single$1;
                    var decoded__low = 0;
                  }
                } else if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== in$1.Ljava_nio_Buffer__f__limit)) {
                  var b4 = in$1.get__B();
                  var b$2 = b4;
                  if (((192 & b$2) !== 128)) {
                    var this$18 = $m_Ljava_nio_charset_CoderResult$();
                    var failure$5 = this$18.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed3;
                    var decoded__failure = failure$5;
                    var decoded__high = 0;
                    var decoded__low = 0;
                  } else {
                    var b2$3 = b2;
                    var b3$2 = b3;
                    var b4$1 = b4;
                    var codePoint$2 = (((((7 & leading) << 18) | ((63 & b2$3) << 12)) | ((63 & b3$2) << 6)) | (63 & b4$1));
                    if (((codePoint$2 < 65536) || (codePoint$2 > 1114111))) {
                      var this$20 = $m_Ljava_nio_charset_CoderResult$();
                      var failure$6 = this$20.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
                      var decoded__failure = failure$6;
                      var decoded__high = 0;
                      var decoded__low = 0;
                    } else {
                      var offsetCodePoint = (((-65536) + codePoint$2) | 0);
                      var high = (65535 & (55296 | (offsetCodePoint >> 10)));
                      var low = (65535 & (56320 | (1023 & offsetCodePoint)));
                      var decoded__failure = null;
                      var decoded__high = high;
                      var decoded__low = low;
                    }
                  }
                } else {
                  var failure$7 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
                  var decoded__failure = failure$7;
                  var decoded__high = 0;
                  var decoded__low = 0;
                }
              } else {
                var failure$8 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
                var decoded__failure = failure$8;
                var decoded__high = 0;
                var decoded__low = 0;
              }
            } else {
              var failure$9 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
              var decoded__failure = failure$9;
              var decoded__high = 0;
              var decoded__low = 0;
            }
            if ((decoded__failure !== null)) {
              var result$2 = decoded__failure;
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, startPosition);
              return result$2;
            } else if ((decoded__low === 0)) {
              if ((out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === out.Ljava_nio_Buffer__f__limit)) {
                var result$3 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
                $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, startPosition);
                return result$3;
              } else {
                out.put__C__Ljava_nio_CharBuffer(decoded__high);
              }
            } else if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 2)) {
              var result$4 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, startPosition);
              return result$4;
            } else {
              out.put__C__Ljava_nio_CharBuffer(decoded__high);
              out.put__C__Ljava_nio_CharBuffer(decoded__low);
            }
          }
        }
      }
    }
  }
});
var $d_Ljava_nio_charset_UTF\uff3f8$Decoder = new $TypeData().initClass($c_Ljava_nio_charset_UTF\uff3f8$Decoder, "java.nio.charset.UTF_8$Decoder", ({
  Ljava_nio_charset_UTF\uff3f8$Decoder: 1,
  Ljava_nio_charset_CharsetDecoder: 1
}));
export { $d_Ljava_nio_charset_UTF\uff3f8$Decoder as $d_Ljava_nio_charset_UTF\uff3f8$Decoder };
function $p_Ljava_nio_charset_UTF\uff3f8$Encoder__encodeLoopArray__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult($thiz, in$1, out) {
  var a = in$1.Ljava_nio_CharBuffer__f__array;
  if ((a === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (in$1.isReadOnly__Z()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var o = in$1.Ljava_nio_CharBuffer__f__arrayOffset;
  if ((o === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (in$1.isReadOnly__Z()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var inStart = ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o) | 0);
  var inEnd = ((in$1.Ljava_nio_Buffer__f__limit + o) | 0);
  var a$1 = out.Ljava_nio_ByteBuffer__f__array;
  if ((a$1 === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (out.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var o$1 = out.Ljava_nio_ByteBuffer__f__arrayOffset;
  if ((o$1 === (-1))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  if (out.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var outStart = ((out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + o$1) | 0);
  var outEnd = ((out.Ljava_nio_Buffer__f__limit + o$1) | 0);
  var inPos = inStart;
  var outPos = outStart;
  while (true) {
    if ((inPos === inEnd)) {
      var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      var inPos$2 = inPos;
      var outPos$2 = outPos;
      var newPosition = ((inPos$2 - o) | 0);
      $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition);
      var newPosition$1 = ((outPos$2 - o$1) | 0);
      $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$1);
      return result;
    } else {
      var c1 = a.u[inPos];
      if ((c1 < 128)) {
        if ((outPos === outEnd)) {
          var result$1 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
          var inPos$2$1 = inPos;
          var outPos$2$1 = outPos;
          var newPosition$2 = ((inPos$2$1 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$2);
          var newPosition$3 = ((outPos$2$1 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$3);
          return result$1;
        } else {
          a$1.u[outPos] = ((c1 << 24) >> 24);
          var temp$inPos = ((1 + inPos) | 0);
          var temp$outPos = ((1 + outPos) | 0);
          inPos = temp$inPos;
          outPos = temp$outPos;
        }
      } else if ((c1 < 2048)) {
        if ((((2 + outPos) | 0) > outEnd)) {
          var result$2 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
          var inPos$2$2 = inPos;
          var outPos$2$2 = outPos;
          var newPosition$4 = ((inPos$2$2 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$4);
          var newPosition$5 = ((outPos$2$2 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$5);
          return result$2;
        } else {
          a$1.u[outPos] = (((192 | (c1 >> 6)) << 24) >> 24);
          a$1.u[((1 + outPos) | 0)] = (((128 | (63 & c1)) << 24) >> 24);
          var temp$inPos$2 = ((1 + inPos) | 0);
          var temp$outPos$2 = ((2 + outPos) | 0);
          inPos = temp$inPos$2;
          outPos = temp$outPos$2;
        }
      } else if ((!($m_Ljava_nio_charset_UTF\uff3f8$(), ((63488 & c1) === 55296)))) {
        if ((((3 + outPos) | 0) > outEnd)) {
          var result$3 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
          var inPos$2$3 = inPos;
          var outPos$2$3 = outPos;
          var newPosition$6 = ((inPos$2$3 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$6);
          var newPosition$7 = ((outPos$2$3 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$7);
          return result$3;
        } else {
          a$1.u[outPos] = (((224 | (c1 >> 12)) << 24) >> 24);
          a$1.u[((1 + outPos) | 0)] = (((128 | (63 & (c1 >> 6))) << 24) >> 24);
          a$1.u[((2 + outPos) | 0)] = (((128 | (63 & c1)) << 24) >> 24);
          var temp$inPos$3 = ((1 + inPos) | 0);
          var temp$outPos$3 = ((3 + outPos) | 0);
          inPos = temp$inPos$3;
          outPos = temp$outPos$3;
        }
      } else if (((64512 & c1) === 55296)) {
        if ((((1 + inPos) | 0) === inEnd)) {
          var result$4 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
          var inPos$2$4 = inPos;
          var outPos$2$4 = outPos;
          var newPosition$8 = ((inPos$2$4 - o) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$8);
          var newPosition$9 = ((outPos$2$4 - o$1) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$9);
          return result$4;
        } else {
          var c2 = a.u[((1 + inPos) | 0)];
          if (((64512 & c2) !== 56320)) {
            var this$12 = $m_Ljava_nio_charset_CoderResult$();
            var result$5 = this$12.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
            var inPos$2$5 = inPos;
            var outPos$2$5 = outPos;
            var newPosition$10 = ((inPos$2$5 - o) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$10);
            var newPosition$11 = ((outPos$2$5 - o$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$11);
            return result$5;
          } else if ((((4 + outPos) | 0) > outEnd)) {
            var result$6 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var inPos$2$6 = inPos;
            var outPos$2$6 = outPos;
            var newPosition$12 = ((inPos$2$6 - o) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$12);
            var newPosition$13 = ((outPos$2$6 - o$1) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$13);
            return result$6;
          } else {
            var cp = ((((64 + (1023 & c1)) | 0) << 10) | (1023 & c2));
            a$1.u[outPos] = (((240 | (cp >> 18)) << 24) >> 24);
            a$1.u[((1 + outPos) | 0)] = (((128 | (63 & (cp >> 12))) << 24) >> 24);
            a$1.u[((2 + outPos) | 0)] = (((128 | (63 & (cp >> 6))) << 24) >> 24);
            a$1.u[((3 + outPos) | 0)] = (((128 | (63 & cp)) << 24) >> 24);
            var temp$inPos$4 = ((2 + inPos) | 0);
            var temp$outPos$4 = ((4 + outPos) | 0);
            inPos = temp$inPos$4;
            outPos = temp$outPos$4;
          }
        }
      } else {
        var this$14 = $m_Ljava_nio_charset_CoderResult$();
        var result$7 = this$14.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
        var inPos$2$7 = inPos;
        var outPos$2$7 = outPos;
        var newPosition$14 = ((inPos$2$7 - o) | 0);
        $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$14);
        var newPosition$15 = ((outPos$2$7 - o$1) | 0);
        $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(out, newPosition$15);
        return result$7;
      }
    }
  }
}
export { $p_Ljava_nio_charset_UTF\uff3f8$Encoder__encodeLoopArray__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult as $p_Ljava_nio_charset_UTF\uff3f8$Encoder__encodeLoopArray__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult };
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$Encoder() {
  this.Ljava_nio_charset_CharsetEncoder__f__averageBytesPerChar = 0.0;
  this.Ljava_nio_charset_CharsetEncoder__f__replacement = null;
  this.Ljava_nio_charset_CharsetEncoder__f__malformedInputAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f__unmappableCharacterAction = null;
  this.Ljava_nio_charset_CharsetEncoder__f_status = 0;
  $ct_Ljava_nio_charset_CharsetEncoder__Ljava_nio_charset_Charset__F__F__(this, $m_Ljava_nio_charset_UTF\uff3f8$(), 1.100000023841858, 3.0);
}
export { $c_Ljava_nio_charset_UTF\uff3f8$Encoder as $c_Ljava_nio_charset_UTF\uff3f8$Encoder };
$c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype = new $h_Ljava_nio_charset_CharsetEncoder();
$c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f8$Encoder;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$Encoder() {
}
export { $h_Ljava_nio_charset_UTF\uff3f8$Encoder as $h_Ljava_nio_charset_UTF\uff3f8$Encoder };
$h_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype = $c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype;
$c_Ljava_nio_charset_UTF\uff3f8$Encoder.prototype.encodeLoop__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult = (function(in$1, out) {
  if ((((in$1.Ljava_nio_CharBuffer__f__array !== null) && (!in$1.isReadOnly__Z())) && ((out.Ljava_nio_ByteBuffer__f__array !== null) && (!out.Ljava_nio_HeapByteBuffer__f__readOnly)))) {
    return $p_Ljava_nio_charset_UTF\uff3f8$Encoder__encodeLoopArray__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer__Ljava_nio_charset_CoderResult(this, in$1, out);
  } else {
    while (true) {
      if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === in$1.Ljava_nio_Buffer__f__limit)) {
        return $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
      } else {
        var c1 = in$1.get__C();
        if ((c1 < 128)) {
          if ((out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === out.Ljava_nio_Buffer__f__limit)) {
            var result = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var newPosition = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition);
            return result;
          } else {
            out.put__B__Ljava_nio_ByteBuffer(((c1 << 24) >> 24));
          }
        } else if ((c1 < 2048)) {
          if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 2)) {
            var result$1 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var newPosition$1 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$1);
            return result$1;
          } else {
            out.put__B__Ljava_nio_ByteBuffer((((192 | (c1 >> 6)) << 24) >> 24));
            out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & c1)) << 24) >> 24));
          }
        } else if ((!($m_Ljava_nio_charset_UTF\uff3f8$(), ((63488 & c1) === 55296)))) {
          if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 3)) {
            var result$2 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
            var newPosition$2 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$2);
            return result$2;
          } else {
            out.put__B__Ljava_nio_ByteBuffer((((224 | (c1 >> 12)) << 24) >> 24));
            out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & (c1 >> 6))) << 24) >> 24));
            out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & c1)) << 24) >> 24));
          }
        } else if (((64512 & c1) === 55296)) {
          if ((in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === in$1.Ljava_nio_Buffer__f__limit)) {
            var result$3 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_UNDERFLOW;
            var newPosition$3 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
            $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$3);
            return result$3;
          } else {
            var c2 = in$1.get__C();
            if (((64512 & c2) !== 56320)) {
              var this$8 = $m_Ljava_nio_charset_CoderResult$();
              var result$4 = this$8.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
              var newPosition$4 = (((-2) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$4);
              return result$4;
            } else if ((((out.Ljava_nio_Buffer__f__limit - out.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0) < 4)) {
              var result$5 = $m_Ljava_nio_charset_CoderResult$().Ljava_nio_charset_CoderResult$__f_OVERFLOW;
              var newPosition$5 = (((-2) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$5);
              return result$5;
            } else {
              var cp = ((((64 + (1023 & c1)) | 0) << 10) | (1023 & c2));
              out.put__B__Ljava_nio_ByteBuffer((((240 | (cp >> 18)) << 24) >> 24));
              out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & (cp >> 12))) << 24) >> 24));
              out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & (cp >> 6))) << 24) >> 24));
              out.put__B__Ljava_nio_ByteBuffer((((128 | (63 & cp)) << 24) >> 24));
            }
          }
        } else {
          var this$10 = $m_Ljava_nio_charset_CoderResult$();
          var result$6 = this$10.Ljava_nio_charset_CoderResult$__f_java$nio$charset$CoderResult$$Malformed1;
          var newPosition$6 = (((-1) + in$1.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
          $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(in$1, newPosition$6);
          return result$6;
        }
      }
    }
  }
});
var $d_Ljava_nio_charset_UTF\uff3f8$Encoder = new $TypeData().initClass($c_Ljava_nio_charset_UTF\uff3f8$Encoder, "java.nio.charset.UTF_8$Encoder", ({
  Ljava_nio_charset_UTF\uff3f8$Encoder: 1,
  Ljava_nio_charset_CharsetEncoder: 1
}));
export { $d_Ljava_nio_charset_UTF\uff3f8$Encoder as $d_Ljava_nio_charset_UTF\uff3f8$Encoder };
/** @constructor */
function $c_Ljava_text_DateFormatSymbols(locale) {
  this.Ljava_text_DateFormatSymbols__f_eras = null;
  this.Ljava_text_DateFormatSymbols__f_months = null;
  this.Ljava_text_DateFormatSymbols__f_shortMonths = null;
  this.Ljava_text_DateFormatSymbols__f_weekdays = null;
  this.Ljava_text_DateFormatSymbols__f_shortWeekdays = null;
  this.Ljava_text_DateFormatSymbols__f_amPmStrings = null;
  this.Ljava_text_DateFormatSymbols__f_zoneStrings = null;
  this.Ljava_text_DateFormatSymbols__f_localPatternChars = null;
  this.Ljava_text_DateFormatSymbols__f_eras = new ($d_T.getArrayOf().constr)([]);
  this.Ljava_text_DateFormatSymbols__f_months = new ($d_T.getArrayOf().constr)([]);
  this.Ljava_text_DateFormatSymbols__f_shortMonths = new ($d_T.getArrayOf().constr)([]);
  this.Ljava_text_DateFormatSymbols__f_weekdays = new ($d_T.getArrayOf().constr)([]);
  this.Ljava_text_DateFormatSymbols__f_shortWeekdays = new ($d_T.getArrayOf().constr)([]);
  this.Ljava_text_DateFormatSymbols__f_amPmStrings = new ($d_T.getArrayOf().constr)([]);
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().getArrayOf().constr)([]));
  var len = xs.length__I();
  var array = new ($d_T.getArrayOf().getArrayOf().constr)(len);
  var iterator = xs.iterator__sc_Iterator();
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  this.Ljava_text_DateFormatSymbols__f_zoneStrings = array;
  this.Ljava_text_DateFormatSymbols__f_localPatternChars = "";
  $m_Ljava_text_DateFormatSymbols$().java$text$DateFormatSymbols$$$initialize__ju_Locale__Ljava_text_DateFormatSymbols__Ljava_text_DateFormatSymbols(locale, this);
}
export { $c_Ljava_text_DateFormatSymbols as $c_Ljava_text_DateFormatSymbols };
$c_Ljava_text_DateFormatSymbols.prototype = new $h_O();
$c_Ljava_text_DateFormatSymbols.prototype.constructor = $c_Ljava_text_DateFormatSymbols;
/** @constructor */
function $h_Ljava_text_DateFormatSymbols() {
}
export { $h_Ljava_text_DateFormatSymbols as $h_Ljava_text_DateFormatSymbols };
$h_Ljava_text_DateFormatSymbols.prototype = $c_Ljava_text_DateFormatSymbols.prototype;
$c_Ljava_text_DateFormatSymbols.prototype.setEras__AT__V = (function(eras) {
  if ((eras === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(eras);
  var len = xs.length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = xs.iterator__sc_Iterator();
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  this.Ljava_text_DateFormatSymbols__f_eras = array;
});
$c_Ljava_text_DateFormatSymbols.prototype.setMonths__AT__V = (function(months) {
  if ((months === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(months);
  var len = xs.length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = xs.iterator__sc_Iterator();
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  this.Ljava_text_DateFormatSymbols__f_months = array;
});
$c_Ljava_text_DateFormatSymbols.prototype.setShortMonths__AT__V = (function(shortMonths) {
  if ((shortMonths === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(shortMonths);
  var len = xs.length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = xs.iterator__sc_Iterator();
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  this.Ljava_text_DateFormatSymbols__f_shortMonths = array;
});
$c_Ljava_text_DateFormatSymbols.prototype.setWeekdays__AT__V = (function(weekdays) {
  if ((weekdays === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(weekdays);
  var len = xs.length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = xs.iterator__sc_Iterator();
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  this.Ljava_text_DateFormatSymbols__f_weekdays = array;
});
$c_Ljava_text_DateFormatSymbols.prototype.setShortWeekdays__AT__V = (function(shortWeekdays) {
  if ((shortWeekdays === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(shortWeekdays);
  var len = xs.length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = xs.iterator__sc_Iterator();
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  this.Ljava_text_DateFormatSymbols__f_shortWeekdays = array;
});
$c_Ljava_text_DateFormatSymbols.prototype.setAmPmStrings__AT__V = (function(amPmStrings) {
  if ((amPmStrings === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(amPmStrings);
  var len = xs.length__I();
  var array = new ($d_T.getArrayOf().constr)(len);
  var iterator = xs.iterator__sc_Iterator();
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  this.Ljava_text_DateFormatSymbols__f_amPmStrings = array;
});
$c_Ljava_text_DateFormatSymbols.prototype.hashCode__I = (function() {
  var $x_2 = $m_sci_Seq$();
  var $x_1 = $m_sr_ScalaRunTime$();
  var xs = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(this.Ljava_text_DateFormatSymbols__f_eras);
  var len = xs.length__I();
  var array = new $ac_O(len);
  var iterator = xs.iterator__sc_Iterator();
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  var xs$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(this.Ljava_text_DateFormatSymbols__f_months);
  var len$1 = xs$1.length__I();
  var array$1 = new $ac_O(len$1);
  var iterator$1 = xs$1.iterator__sc_Iterator();
  var i$1 = 0;
  while (iterator$1.hasNext__Z()) {
    array$1.u[i$1] = iterator$1.next__O();
    i$1 = ((1 + i$1) | 0);
  }
  var xs$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(this.Ljava_text_DateFormatSymbols__f_shortMonths);
  var len$2 = xs$2.length__I();
  var array$2 = new $ac_O(len$2);
  var iterator$2 = xs$2.iterator__sc_Iterator();
  var i$2 = 0;
  while (iterator$2.hasNext__Z()) {
    array$2.u[i$2] = iterator$2.next__O();
    i$2 = ((1 + i$2) | 0);
  }
  var xs$3 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(this.Ljava_text_DateFormatSymbols__f_weekdays);
  var len$3 = xs$3.length__I();
  var array$3 = new $ac_O(len$3);
  var iterator$3 = xs$3.iterator__sc_Iterator();
  var i$3 = 0;
  while (iterator$3.hasNext__Z()) {
    array$3.u[i$3] = iterator$3.next__O();
    i$3 = ((1 + i$3) | 0);
  }
  var xs$4 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(this.Ljava_text_DateFormatSymbols__f_shortWeekdays);
  var len$4 = xs$4.length__I();
  var array$4 = new $ac_O(len$4);
  var iterator$4 = xs$4.iterator__sc_Iterator();
  var i$4 = 0;
  while (iterator$4.hasNext__Z()) {
    array$4.u[i$4] = iterator$4.next__O();
    i$4 = ((1 + i$4) | 0);
  }
  var xs$5 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(this.Ljava_text_DateFormatSymbols__f_amPmStrings);
  var len$5 = xs$5.length__I();
  var array$5 = new $ac_O(len$5);
  var iterator$5 = xs$5.iterator__sc_Iterator();
  var i$5 = 0;
  while (iterator$5.hasNext__Z()) {
    array$5.u[i$5] = iterator$5.next__O();
    i$5 = ((1 + i$5) | 0);
  }
  var state = $x_2.apply__sci_Seq__sc_SeqOps($x_1.wrapRefArray__AO__sci_ArraySeq(new ($d_O.getArrayOf().getArrayOf().constr)([array, array$1, array$2, array$3, array$4, array$5])));
  var s = (state.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$0) => $m_ju_Arrays$().hashCode__AO__I(x$0)))).foldLeft__O__F2__O(0, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a, b) => {
    var a$1 = (a | 0);
    var b$1 = (b | 0);
    return ((Math.imul(31, a$1) + b$1) | 0);
  }))) | 0);
  var xs$6 = this.Ljava_text_DateFormatSymbols__f_zoneStrings;
  var f = ((_$11) => {
    var xs$7 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(_$11);
    var len$6 = xs$7.length__I();
    var array$6 = new $ac_O(len$6);
    var iterator$6 = xs$7.iterator__sc_Iterator();
    var i$6 = 0;
    while (iterator$6.hasNext__Z()) {
      array$6.u[i$6] = iterator$6.next__O();
      i$6 = ((1 + i$6) | 0);
    }
    return array$6;
  });
  var len$7 = xs$6.u.length;
  var ys = new ($d_O.getArrayOf().getArrayOf().constr)(len$7);
  if ((len$7 > 0)) {
    var i$7 = 0;
    if ((xs$6 !== null)) {
      while ((i$7 < len$7)) {
        var $x_3 = i$7;
        var x0 = xs$6.u[i$7];
        ys.u[$x_3] = f(x0);
        i$7 = ((1 + i$7) | 0);
      }
    } else if ((xs$6 instanceof $ac_I)) {
      while ((i$7 < len$7)) {
        var $x_4 = i$7;
        var x0$1 = xs$6.u[i$7];
        ys.u[$x_4] = f(x0$1);
        i$7 = ((1 + i$7) | 0);
      }
    } else if ((xs$6 instanceof $ac_D)) {
      while ((i$7 < len$7)) {
        var $x_5 = i$7;
        var x0$2 = xs$6.u[i$7];
        ys.u[$x_5] = f(x0$2);
        i$7 = ((1 + i$7) | 0);
      }
    } else if ((xs$6 instanceof $ac_J)) {
      while ((i$7 < len$7)) {
        var $x_6 = i$7;
        var t = xs$6.u[i$7];
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.u[$x_6] = f(new $c_RTLong(lo, hi));
        i$7 = ((1 + i$7) | 0);
      }
    } else if ((xs$6 instanceof $ac_F)) {
      while ((i$7 < len$7)) {
        var $x_7 = i$7;
        var x0$3 = xs$6.u[i$7];
        ys.u[$x_7] = f(x0$3);
        i$7 = ((1 + i$7) | 0);
      }
    } else if ((xs$6 instanceof $ac_C)) {
      while ((i$7 < len$7)) {
        var $x_8 = i$7;
        var x0$4 = xs$6.u[i$7];
        ys.u[$x_8] = f($bC(x0$4));
        i$7 = ((1 + i$7) | 0);
      }
    } else if ((xs$6 instanceof $ac_B)) {
      while ((i$7 < len$7)) {
        var $x_9 = i$7;
        var x0$5 = xs$6.u[i$7];
        ys.u[$x_9] = f(x0$5);
        i$7 = ((1 + i$7) | 0);
      }
    } else if ((xs$6 instanceof $ac_S)) {
      while ((i$7 < len$7)) {
        var $x_10 = i$7;
        var x0$6 = xs$6.u[i$7];
        ys.u[$x_10] = f(x0$6);
        i$7 = ((1 + i$7) | 0);
      }
    } else if ((xs$6 instanceof $ac_Z)) {
      while ((i$7 < len$7)) {
        var $x_11 = i$7;
        var x0$7 = xs$6.u[i$7];
        ys.u[$x_11] = f(x0$7);
        i$7 = ((1 + i$7) | 0);
      }
    } else {
      throw new $c_s_MatchError(xs$6);
    }
  }
  var xs$8 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(ys);
  var len$8 = xs$8.length__I();
  var array$7 = new $ac_O(len$8);
  var iterator$7 = xs$8.iterator__sc_Iterator();
  var i$8 = 0;
  while (iterator$7.hasNext__Z()) {
    array$7.u[i$8] = iterator$7.next__O();
    i$8 = ((1 + i$8) | 0);
  }
  return ((Math.imul(31, ((Math.imul(31, s) + $m_ju_Arrays$().hashCode__AO__I(array$7)) | 0)) + $f_T__hashCode__I(this.Ljava_text_DateFormatSymbols__f_localPatternChars)) | 0);
});
$c_Ljava_text_DateFormatSymbols.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_text_DateFormatSymbols)) {
    var this$1 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_eras);
    var that = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(other.Ljava_text_DateFormatSymbols__f_eras);
    if ($f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$1, that)) {
      var this$2 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_months);
      var that$1 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(other.Ljava_text_DateFormatSymbols__f_months);
      var $x_6 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$2, that$1);
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var this$3 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_shortMonths);
      var that$2 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(other.Ljava_text_DateFormatSymbols__f_shortMonths);
      var $x_5 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$3, that$2);
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var this$4 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_weekdays);
      var that$3 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(other.Ljava_text_DateFormatSymbols__f_weekdays);
      var $x_4 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$4, that$3);
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var this$5 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_shortWeekdays);
      var that$4 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(other.Ljava_text_DateFormatSymbols__f_shortWeekdays);
      var $x_3 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$5, that$4);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var this$6 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_amPmStrings);
      var that$5 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(other.Ljava_text_DateFormatSymbols__f_amPmStrings);
      var $x_2 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$6, that$5);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var this$7 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.Ljava_text_DateFormatSymbols__f_zoneStrings);
      var that$6 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(other.Ljava_text_DateFormatSymbols__f_zoneStrings);
      var $x_1 = $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this$7, that$6);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.Ljava_text_DateFormatSymbols__f_localPatternChars === other.Ljava_text_DateFormatSymbols__f_localPatternChars);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
function $isArrayOf_Ljava_text_DateFormatSymbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_text_DateFormatSymbols)));
}
export { $isArrayOf_Ljava_text_DateFormatSymbols as $isArrayOf_Ljava_text_DateFormatSymbols };
var $d_Ljava_text_DateFormatSymbols = new $TypeData().initClass($c_Ljava_text_DateFormatSymbols, "java.text.DateFormatSymbols", ({
  Ljava_text_DateFormatSymbols: 1,
  jl_Cloneable: 1
}));
export { $d_Ljava_text_DateFormatSymbols as $d_Ljava_text_DateFormatSymbols };
/** @constructor */
function $c_Ljava_time_LocalDateTime$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Ljava_time_LocalDateTime$$anon$1 as $c_Ljava_time_LocalDateTime$$anon$1 };
$c_Ljava_time_LocalDateTime$$anon$1.prototype = new $h_O();
$c_Ljava_time_LocalDateTime$$anon$1.prototype.constructor = $c_Ljava_time_LocalDateTime$$anon$1;
/** @constructor */
function $h_Ljava_time_LocalDateTime$$anon$1() {
}
export { $h_Ljava_time_LocalDateTime$$anon$1 as $h_Ljava_time_LocalDateTime$$anon$1 };
$h_Ljava_time_LocalDateTime$$anon$1.prototype = $c_Ljava_time_LocalDateTime$$anon$1.prototype;
$c_Ljava_time_LocalDateTime$$anon$1.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(temporal);
});
var $d_Ljava_time_LocalDateTime$$anon$1 = new $TypeData().initClass($c_Ljava_time_LocalDateTime$$anon$1, "java.time.LocalDateTime$$anon$1", ({
  Ljava_time_LocalDateTime$$anon$1: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
export { $d_Ljava_time_LocalDateTime$$anon$1 as $d_Ljava_time_LocalDateTime$$anon$1 };
function $ct_Ljava_time_ZoneId__($thiz) {
  if ((($objectGetClass($thiz) !== $d_Ljava_time_ZoneOffset.getClassOf()) && ($objectGetClass($thiz) !== $d_Ljava_time_ZoneRegion.getClassOf()))) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "Invalid subclass");
  }
  return $thiz;
}
export { $ct_Ljava_time_ZoneId__ as $ct_Ljava_time_ZoneId__ };
/** @constructor */
function $c_Ljava_time_ZoneId() {
}
export { $c_Ljava_time_ZoneId as $c_Ljava_time_ZoneId };
$c_Ljava_time_ZoneId.prototype = new $h_O();
$c_Ljava_time_ZoneId.prototype.constructor = $c_Ljava_time_ZoneId;
/** @constructor */
function $h_Ljava_time_ZoneId() {
}
export { $h_Ljava_time_ZoneId as $h_Ljava_time_ZoneId };
$h_Ljava_time_ZoneId.prototype = $c_Ljava_time_ZoneId.prototype;
$c_Ljava_time_ZoneId.prototype.normalized__Ljava_time_ZoneId = (function() {
  try {
    var rules = this.getRules__Ljava_time_zone_ZoneRules();
    if (rules.isFixedOffset__Z()) {
      return rules.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant());
    }
  } catch (e) {
    if ((!(e instanceof $c_Ljava_time_zone_ZoneRulesException))) {
      throw e;
    }
  }
  return this;
});
$c_Ljava_time_ZoneId.prototype.equals__O__Z = (function(obj) {
  return ((obj instanceof $c_Ljava_time_ZoneId) && ((this === obj) || (this.getId__T() === obj.getId__T())));
});
$c_Ljava_time_ZoneId.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I(this.getId__T());
});
$c_Ljava_time_ZoneId.prototype.toString__T = (function() {
  return this.getId__T();
});
function $isArrayOf_Ljava_time_ZoneId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZoneId)));
}
export { $isArrayOf_Ljava_time_ZoneId as $isArrayOf_Ljava_time_ZoneId };
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3 as $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3 };
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype = new $h_O();
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder$$anon$3() {
}
export { $h_Ljava_time_format_DateTimeFormatterBuilder$$anon$3 as $h_Ljava_time_format_DateTimeFormatterBuilder$$anon$3 };
$h_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype = $c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype;
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype.compare__T__T__I = (function(str1, str2) {
  return ((str1.length === str2.length) ? $f_T__compareTo__T__I(str1, str2) : ((str1.length - str2.length) | 0));
});
$c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3.prototype.compare__O__O__I = (function(x$0, x$1) {
  return this.compare__T__T__I(x$0, x$1);
});
var $d_Ljava_time_format_DateTimeFormatterBuilder$$anon$3 = new $TypeData().initClass($c_Ljava_time_format_DateTimeFormatterBuilder$$anon$3, "java.time.format.DateTimeFormatterBuilder$$anon$3", ({
  Ljava_time_format_DateTimeFormatterBuilder$$anon$3: 1,
  ju_Comparator: 1
}));
export { $d_Ljava_time_format_DateTimeFormatterBuilder$$anon$3 as $d_Ljava_time_format_DateTimeFormatterBuilder$$anon$3 };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser(literal) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal = literal;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var c = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal;
  var str = ("" + $cToS(c));
  buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var length = $dp_length__I(text);
  if ((position === length)) {
    return (~position);
  }
  if (((position < 0) || (position > length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException());
  }
  var ch = $dp_charAt__I__C(text, position);
  if ((!context.charEquals__C__C__Z(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal, ch))) {
    return (~position);
  }
  return ((1 + position) | 0);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser.prototype.toString__T = (function() {
  return ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal === 39) ? "''" : (("'" + $cToS(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser__f_literal)) + "'"));
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser };
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__($thiz, printerParsers, optional) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers = printerParsers;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional = optional;
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__ };
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__($thiz, printerParsers, optional) {
  var dimensions = new $ac_I(new Int32Array([printerParsers.size__I()]));
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__($thiz, printerParsers.toArray__AO__AO($m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_format_internal_DateTimePrinterParser.getClassOf(), dimensions)), optional);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional = false;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.withOptional__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser = (function(optional) {
  return ((optional === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) ? this : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ALjava_time_format_internal_DateTimePrinterParser__Z__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers, optional));
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var nonLocalReturnKey1 = $ct_O__(new $c_O());
  try {
    var length = buf.length__I();
    if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) {
      context.startOptional__V();
    }
    try {
      var xs = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
      var f = ((pp) => {
        if ((!pp.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf))) {
          buf.setLength__I__V(length);
          throw new $c_sr_NonLocalReturnControl(nonLocalReturnKey1, true);
        }
      });
      var len = xs.u.length;
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var x0 = xs.u[i];
          f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var x0$1 = xs.u[i];
          f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var x0$2 = xs.u[i];
          f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var x0$3 = xs.u[i];
          f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var x0$4 = xs.u[i];
          f($bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var x0$5 = xs.u[i];
          f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var x0$6 = xs.u[i];
          f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var x0$7 = xs.u[i];
          f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    } finally {
      if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) {
        context.endOptional__V();
      }
    }
    return true;
  } catch (e) {
    if ((e instanceof $c_sr_NonLocalReturnControl)) {
      var ex = e;
      if (Object.is(ex.sr_NonLocalReturnControl__f_key, nonLocalReturnKey1)) {
        return (!(!ex.sr_NonLocalReturnControl__f_value));
      } else {
        throw ex;
      }
    } else {
      throw e;
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var nonLocalReturnKey2 = $ct_O__(new $c_O());
  try {
    if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional) {
      context.startOptional__V();
      var pos = new $c_sr_IntRef(position);
      var xs = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
      var f = ((pp) => {
        var ev$5 = pp.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, text, pos.sr_IntRef__f_elem);
        pos.sr_IntRef__f_elem = ev$5;
        if ((pos.sr_IntRef__f_elem < 0)) {
          context.endOptional__Z__V(false);
          throw new $c_sr_NonLocalReturnControl(nonLocalReturnKey2, position);
        }
      });
      var len = xs.u.length;
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var x0 = xs.u[i];
          f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var x0$1 = xs.u[i];
          f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var x0$2 = xs.u[i];
          f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var x0$3 = xs.u[i];
          f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var x0$4 = xs.u[i];
          f($bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var x0$5 = xs.u[i];
          f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var x0$6 = xs.u[i];
          f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var x0$7 = xs.u[i];
          f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
      context.endOptional__Z__V(true);
      return pos.sr_IntRef__f_elem;
    } else {
      var xs$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
      var f$1 = ((x$1, x$2) => {
        var x$1$1 = (x$1 | 0);
        return ((x$1$1 < 0) ? x$1$1 : x$2.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, text, x$1$1));
      });
      if ((xs$1 === null)) {
        throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
      }
      if ((xs$1 !== null)) {
        var length = xs$1.u.length;
        var v = position;
        var i$1 = 0;
        while ((i$1 < length)) {
          var x0$8 = v;
          var x1 = i$1;
          var x1$1 = xs$1.u[x1];
          v = f$1(x0$8, x1$1);
          i$1 = ((1 + i$1) | 0);
        }
        var $x_1 = v;
      } else if ((xs$1 instanceof $ac_I)) {
        var length$1 = xs$1.u.length;
        var v$1 = position;
        var i$2 = 0;
        while ((i$2 < length$1)) {
          var x0$9 = v$1;
          var x1$2 = xs$1.u[i$2];
          v$1 = f$1(x0$9, x1$2);
          i$2 = ((1 + i$2) | 0);
        }
        var $x_1 = v$1;
      } else if ((xs$1 instanceof $ac_D)) {
        var length$2 = xs$1.u.length;
        var v$2 = position;
        var i$3 = 0;
        while ((i$3 < length$2)) {
          var x0$10 = v$2;
          var x1$3 = xs$1.u[i$3];
          v$2 = f$1(x0$10, x1$3);
          i$3 = ((1 + i$3) | 0);
        }
        var $x_1 = v$2;
      } else if ((xs$1 instanceof $ac_J)) {
        var length$3 = xs$1.u.length;
        var v$3 = position;
        var i$4 = 0;
        while ((i$4 < length$3)) {
          var x0$11 = v$3;
          var t$1 = xs$1.u[i$4];
          var lo$1 = t$1.RTLong__f_lo;
          var hi$1 = t$1.RTLong__f_hi;
          v$3 = f$1(x0$11, new $c_RTLong(lo$1, hi$1));
          i$4 = ((1 + i$4) | 0);
        }
        var $x_1 = v$3;
      } else if ((xs$1 instanceof $ac_F)) {
        var length$4 = xs$1.u.length;
        var v$4 = position;
        var i$5 = 0;
        while ((i$5 < length$4)) {
          var x0$12 = v$4;
          var x1$4 = xs$1.u[i$5];
          v$4 = f$1(x0$12, x1$4);
          i$5 = ((1 + i$5) | 0);
        }
        var $x_1 = v$4;
      } else if ((xs$1 instanceof $ac_C)) {
        var length$5 = xs$1.u.length;
        var v$5 = position;
        var i$6 = 0;
        while ((i$6 < length$5)) {
          var x0$13 = v$5;
          var x1$5 = xs$1.u[i$6];
          v$5 = f$1(x0$13, $bC(x1$5));
          i$6 = ((1 + i$6) | 0);
        }
        var $x_1 = v$5;
      } else if ((xs$1 instanceof $ac_B)) {
        var length$6 = xs$1.u.length;
        var v$6 = position;
        var i$7 = 0;
        while ((i$7 < length$6)) {
          var x0$14 = v$6;
          var x1$6 = xs$1.u[i$7];
          v$6 = f$1(x0$14, x1$6);
          i$7 = ((1 + i$7) | 0);
        }
        var $x_1 = v$6;
      } else if ((xs$1 instanceof $ac_S)) {
        var length$7 = xs$1.u.length;
        var v$7 = position;
        var i$8 = 0;
        while ((i$8 < length$7)) {
          var x0$15 = v$7;
          var x1$7 = xs$1.u[i$8];
          v$7 = f$1(x0$15, x1$7);
          i$8 = ((1 + i$8) | 0);
        }
        var $x_1 = v$7;
      } else if ((xs$1 instanceof $ac_Z)) {
        var length$8 = xs$1.u.length;
        var v$8 = position;
        var i$9 = 0;
        while ((i$9 < length$8)) {
          var x0$16 = v$8;
          var x1$8 = xs$1.u[i$9];
          v$8 = f$1(x0$16, x1$8);
          i$9 = ((1 + i$9) | 0);
        }
        var $x_1 = v$8;
      } else {
        if ((!$isArrayOf_jl_Void(xs$1, 1))) {
          throw new $c_s_MatchError(xs$1);
        }
        var length$9 = xs$1.u.length;
        var v$9 = position;
        var i$10 = 0;
        while ((i$10 < length$9)) {
          var x0$17 = v$9;
          var x1$9 = xs$1.u[i$10];
          v$9 = f$1(x0$17, x1$9);
          i$10 = ((1 + i$10) | 0);
        }
        var $x_1 = v$9;
      }
      return ($x_1 | 0);
    }
  } catch (e) {
    if ((e instanceof $c_sr_NonLocalReturnControl)) {
      var ex = e;
      if (Object.is(ex.sr_NonLocalReturnControl__f_key, nonLocalReturnKey2)) {
        return (ex.sr_NonLocalReturnControl__f_value | 0);
      } else {
        throw ex;
      }
    } else {
      throw e;
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser.prototype.toString__T = (function() {
  var buf = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers !== null)) {
    var str = (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional ? "[" : "(");
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
    var xs = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_printerParsers;
    var f = ((pp) => {
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + pp);
      return buf;
    });
    var len = xs.u.length;
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var x0 = xs.u[i];
        f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_I)) {
      while ((i < len)) {
        var x0$1 = xs.u[i];
        f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_D)) {
      while ((i < len)) {
        var x0$2 = xs.u[i];
        f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_J)) {
      while ((i < len)) {
        var t = xs.u[i];
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        f(new $c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_F)) {
      while ((i < len)) {
        var x0$3 = xs.u[i];
        f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_C)) {
      while ((i < len)) {
        var x0$4 = xs.u[i];
        f($bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_B)) {
      while ((i < len)) {
        var x0$5 = xs.u[i];
        f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_S)) {
      while ((i < len)) {
        var x0$6 = xs.u[i];
        f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_Z)) {
      while ((i < len)) {
        var x0$7 = xs.u[i];
        f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $c_s_MatchError(xs);
    }
    var str$1 = (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__f_optional ? "]" : ")");
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
  }
  return buf.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$CompositePrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser };
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal($thiz, value) {
  var range = $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field.range__Ljava_time_temporal_ValueRange();
  range.checkValidValue__J__Ljava_time_temporal_TemporalField__J($uJ(value), $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field);
  var t = range.Ljava_time_temporal_ValueRange__f_minSmallest;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var minBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi));
  var t$1 = range.Ljava_time_temporal_ValueRange__f_maxLargest;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var rangeBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1)).subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ONE);
  var t$2 = $uJ(value);
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var valueBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo$2, hi$2)).subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD);
  var fraction = valueBD.divide__Ljava_math_BigDecimal__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(rangeBD, 9, $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR);
  return ((fraction.compareTo__Ljava_math_BigDecimal__I($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO) === 0) ? $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO : fraction.stripTrailingZeros__Ljava_math_BigDecimal());
}
export { $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal as $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal };
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long($thiz, fraction) {
  var range = $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field.range__Ljava_time_temporal_ValueRange();
  var t = range.Ljava_time_temporal_ValueRange__f_minSmallest;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var minBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi));
  var t$1 = range.Ljava_time_temporal_ValueRange__f_maxLargest;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var rangeBD = $m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$1)).subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal($m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ONE);
  var this$1 = fraction.multiply__Ljava_math_BigDecimal__Ljava_math_BigDecimal(rangeBD).setScale__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(0, $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR).add__Ljava_math_BigDecimal__Ljava_math_BigDecimal(minBD);
  var t$2 = $p_Ljava_math_BigDecimal__valueExact__I__J(this$1, 64);
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  return new $c_RTLong(lo$2, hi$2);
}
export { $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long as $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser(field, minWidth, maxWidth, decimalPoint) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint = false;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field = field;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth = minWidth;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth = maxWidth;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint = decimalPoint;
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field");
  }
  if ((!field.range__Ljava_time_temporal_ValueRange().isFixed__Z())) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Field must have a fixed set of values: " + field));
  }
  if (((minWidth < 0) || (minWidth > 9))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Minimum width must be from 0 to 9 inclusive but was " + minWidth));
  }
  if (((maxWidth < 1) || (maxWidth > 9))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Maximum width must be from 1 to 9 inclusive but was " + maxWidth));
  }
  if ((maxWidth < minWidth)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((("Maximum width must exceed or equal the minimum width but " + maxWidth) + " < ") + minWidth));
  }
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var value = context.getValue__Ljava_time_temporal_TemporalField__jl_Long(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field);
  if ((value === null)) {
    return false;
  }
  var symbols = context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols;
  var fraction = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertToFraction__jl_Long__Ljava_math_BigDecimal(this, value);
  var this$1 = fraction;
  if ((this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0)) {
    if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth > 0)) {
      if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint) {
        var c = symbols.Ljava_time_format_DecimalStyle__f_decimalSeparator;
        var str = ("" + $cToS(c));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
      }
      var i = 0;
      while ((i < this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth)) {
        var c$1 = symbols.Ljava_time_format_DecimalStyle__f_zeroDigit;
        var str$1 = ("" + $cToS(c$1));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
        i = ((1 + i) | 0);
      }
    }
  } else {
    var this$4 = fraction;
    var a = this$4.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var b = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth;
    var a$1 = ((a > b) ? a : b);
    var b$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth;
    var outputScale = ((a$1 < b$1) ? a$1 : b$1);
    fraction = fraction.setScale__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(outputScale, $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_FLOOR);
    var this$7 = fraction.toPlainString__T();
    var str$2 = this$7.substring(2);
    str$2 = symbols.convertNumberToI18N__T__T(str$2);
    if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint) {
      var c$2 = symbols.Ljava_time_format_DecimalStyle__f_decimalSeparator;
      var str$3 = ("" + $cToS(c$2));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$3);
    }
    var str$4 = str$2;
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$4);
  }
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var _position = position;
  var effectiveMin = (context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict ? this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth : 0);
  var effectiveMax = (context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict ? this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth : 9);
  var length = $dp_length__I(text);
  if ((_position === length)) {
    return ((effectiveMin > 0) ? (~_position) : _position);
  }
  if (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint) {
    var $x_1 = $dp_charAt__I__C(text, _position);
    var this$1 = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols;
    if (($x_1 !== this$1.Ljava_time_format_DecimalStyle__f_decimalSeparator)) {
      return ((effectiveMin > 0) ? (~_position) : _position);
    }
    _position = ((1 + _position) | 0);
  }
  var minEndPos = ((_position + effectiveMin) | 0);
  if ((minEndPos > length)) {
    return (~_position);
  }
  var a = ((_position + effectiveMax) | 0);
  var maxEndPos = ((a < length) ? a : length);
  var total = 0;
  var pos = _position;
  var break$1 = false;
  while (((!break$1) && (pos < maxEndPos))) {
    var ch = $dp_charAt__I__C(text, pos);
    pos = ((1 + pos) | 0);
    var digit = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols.convertToDigit__C__I(ch);
    if ((digit < 0)) {
      if ((pos < minEndPos)) {
        return (~_position);
      }
      pos = (((-1) + pos) | 0);
      break$1 = true;
    }
    if ((!break$1)) {
      total = ((Math.imul(10, total) + digit) | 0);
    }
  }
  var fraction = $ct_Ljava_math_BigDecimal__I__(new $c_Ljava_math_BigDecimal(), total).movePointLeft__I__Ljava_math_BigDecimal(((pos - _position) | 0));
  var value = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__convertFromFraction__Ljava_math_BigDecimal__jl_Long(this, fraction);
  return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field, $uJ(value), _position, pos);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser.prototype.toString__T = (function() {
  var decimal = (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_decimalPoint ? ",DecimalPoint" : "");
  return ((((((("Fraction(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_minWidth) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser__f_maxWidth) + decimal) + ")");
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$FractionPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser(fractionalDigits) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits = fractionalDigits;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var inSecs = context.getValue__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
  var inNanos = $L0;
  if (context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var t = context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    inNanos = new $c_RTLong(lo, hi);
  }
  if ((inSecs === null)) {
    return false;
  }
  var this$4 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var x = inNanos;
  var t$1 = $uJ(x);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var inNano = this$4.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$1, hi$1), this$4);
  var a = $uJ(inSecs);
  var x$1 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
  var b = $uJ(x$1);
  var blo = b.RTLong__f_lo;
  var lo$2 = ((-blo) | 0);
  var hi$2 = ((((-b.RTLong__f_hi) | 0) + ((blo | lo$2) >> 31)) | 0);
  var ahi = a.RTLong__f_hi;
  if (((ahi === hi$2) ? ((a.RTLong__f_lo >>> 0) >= (lo$2 >>> 0)) : (ahi > hi$2))) {
    var a$1 = $uJ(inSecs);
    var x$2 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var b$1 = $uJ(x$2);
    var alo = a$1.RTLong__f_lo;
    var blo$1 = b$1.RTLong__f_lo;
    var lo$3 = ((alo - blo$1) | 0);
    var hi$3 = ((((a$1.RTLong__f_hi - b$1.RTLong__f_hi) | 0) + ((((~alo) & blo$1) | ((~(alo ^ blo$1)) & lo$3)) >> 31)) | 0);
    var x$3 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var b$2 = $uJ(x$3);
    var blo$2 = b$2.RTLong__f_lo;
    var lo$4 = ((lo$3 + blo$2) | 0);
    var hi$4 = ((((hi$3 + b$2.RTLong__f_hi) | 0) + ((((lo$3 & blo$2) | ((lo$3 | blo$2) & (~lo$4))) >>> 31) | 0)) | 0);
    var x$4 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var t$2 = $uJ(x$4);
    var lo$5 = t$2.RTLong__f_lo;
    var hi$5 = t$2.RTLong__f_hi;
    var this$18 = $m_RTLong$();
    var lo$6 = this$18.divideImpl__I__I__I__I__I(lo$4, hi$4, lo$5, hi$5);
    var hi$6 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var hi$7 = (hi$4 ^ hi$5);
    if ((hi$7 >= 0)) {
      var $x_1 = true;
    } else {
      var a0 = (65535 & lo$6);
      var a1 = ((lo$6 >>> 16) | 0);
      var b0 = (65535 & lo$5);
      var b1 = ((lo$5 >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$8 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$8 = ((((((((Math.imul(lo$6, hi$5) + Math.imul(hi$6, lo$5)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var $x_1 = ((lo$8 === lo$4) && (hi$8 === hi$4));
    }
    if ($x_1) {
      var b$3__lo = lo$6;
      var b$3__hi = hi$6;
    } else {
      var lo$9 = (((-1) + lo$6) | 0);
      var hi$9 = (((((-1) + hi$6) | 0) + (((lo$6 | (~lo$9)) >>> 31) | 0)) | 0);
      var b$3__lo = lo$9;
      var b$3__hi = hi$9;
    }
    var blo$3 = b$3__lo;
    var lo$10 = ((1 + blo$3) | 0);
    var hi$10 = ((b$3__hi + (((blo$3 & (~lo$10)) >>> 31) | 0)) | 0);
    var x$5 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var t$3 = $uJ(x$5);
    var lo$11 = t$3.RTLong__f_lo;
    var hi$11 = t$3.RTLong__f_hi;
    var this$29 = $m_RTLong$();
    var lo$12 = this$29.remainderImpl__I__I__I__I__I(lo$4, hi$4, lo$11, hi$11);
    var hi$12 = this$29.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var hi$13 = (hi$4 ^ hi$11);
    if (((hi$13 >= 0) || ((lo$12 === 0) && (hi$12 === 0)))) {
      var x$6__lo = lo$12;
      var x$6__hi = hi$12;
    } else {
      var lo$14 = ((lo$12 + lo$11) | 0);
      var hi$14 = ((((hi$12 + hi$11) | 0) + ((((lo$12 & lo$11) | ((lo$12 | lo$11) & (~lo$14))) >>> 31) | 0)) | 0);
      var x$6__lo = lo$14;
      var x$6__hi = hi$14;
    }
    var $x_2 = $m_Ljava_time_LocalDateTime$();
    var x$7 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var b$4 = $uJ(x$7);
    var alo$1 = x$6__lo;
    var blo$4 = b$4.RTLong__f_lo;
    var lo$15 = ((alo$1 - blo$4) | 0);
    var hi$15 = ((((x$6__hi - b$4.RTLong__f_hi) | 0) + ((((~alo$1) & blo$4) | ((~(alo$1 ^ blo$4)) & lo$15)) >> 31)) | 0);
    var ldt = $x_2.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(new $c_RTLong(lo$15, hi$15), 0, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    if (((hi$10 === 0) ? (lo$10 !== 0) : (hi$10 > 0))) {
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + "+");
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + new $c_RTLong(lo$10, hi$10));
    }
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + ldt);
    var this$41 = ldt.Ljava_time_LocalDateTime__f_time;
    if ((this$41.Ljava_time_LocalTime__f_second === 0)) {
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":00");
    }
  } else {
    var a$2 = $uJ(inSecs);
    var x$8 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var b$5 = $uJ(x$8);
    var alo$2 = a$2.RTLong__f_lo;
    var blo$5 = b$5.RTLong__f_lo;
    var lo$16 = ((alo$2 + blo$5) | 0);
    var hi$16 = ((((a$2.RTLong__f_hi + b$5.RTLong__f_hi) | 0) + ((((alo$2 & blo$5) | ((alo$2 | blo$5) & (~lo$16))) >>> 31) | 0)) | 0);
    var x$9 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var b$6 = $uJ(x$9);
    var this$48 = $m_RTLong$();
    var lo$17 = this$48.divideImpl__I__I__I__I__I(lo$16, hi$16, b$6.RTLong__f_lo, b$6.RTLong__f_hi);
    var hi$17 = this$48.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var x$10 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var b$7 = $uJ(x$10);
    var this$52 = $m_RTLong$();
    var lo$18 = this$52.remainderImpl__I__I__I__I__I(lo$16, hi$16, b$7.RTLong__f_lo, b$7.RTLong__f_hi);
    var hi$18 = this$52.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var $x_3 = $m_Ljava_time_LocalDateTime$();
    var x$11 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_0000_TO_1970;
    var b$8 = $uJ(x$11);
    var blo$6 = b$8.RTLong__f_lo;
    var lo$19 = ((lo$18 - blo$6) | 0);
    var hi$19 = ((((hi$18 - b$8.RTLong__f_hi) | 0) + ((((~lo$18) & blo$6) | ((~(lo$18 ^ blo$6)) & lo$19)) >> 31)) | 0);
    var ldt$2 = $x_3.ofEpochSecond__J__I__Ljava_time_ZoneOffset__Ljava_time_LocalDateTime(new $c_RTLong(lo$19, hi$19), 0, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var pos = buf.length__I();
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + ldt$2);
    var this$57 = ldt$2.Ljava_time_LocalDateTime__f_time;
    if ((this$57.Ljava_time_LocalTime__f_second === 0)) {
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":00");
    }
    if ((hi$17 < 0)) {
      var this$60 = ldt$2.Ljava_time_LocalDateTime__f_date;
      if ((this$60.Ljava_time_LocalDate__f_year === (-10000))) {
        var lo$20 = (((-1) + lo$17) | 0);
        var hi$20 = (((((-1) + hi$17) | 0) + (((lo$17 | (~lo$20)) >>> 31) | 0)) | 0);
        var this$63 = $m_RTLong$();
        buf.replace__I__I__T__jl_StringBuilder(pos, ((2 + pos) | 0), this$63.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$20, hi$20));
      } else if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(new $c_RTLong(lo$18, hi$18), 0)) {
        buf.insert__I__T__jl_StringBuilder(pos, ("" + new $c_RTLong(lo$17, hi$17)));
      } else {
        var offset = ((1 + pos) | 0);
        var sign = (hi$17 >> 31);
        var xlo = (lo$17 ^ sign);
        var rlo = ((xlo - sign) | 0);
        var rhi = (((hi$17 ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
        var this$67 = $m_RTLong$();
        buf.insert__I__T__jl_StringBuilder(offset, this$67.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(rlo, rhi));
      }
    }
  }
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-2))) {
    if ((inNano !== 0)) {
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + ".");
      if ((((inNano % 1000000) | 0) === 0)) {
        var i = ((1000 + ((inNano / 1000000) | 0)) | 0);
        var this$70 = ("" + i);
        var str = this$70.substring(1);
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      } else if ((((inNano % 1000) | 0) === 0)) {
        var i$1 = ((1000000 + ((inNano / 1000) | 0)) | 0);
        var this$72 = ("" + i$1);
        var str$1 = this$72.substring(1);
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
      } else {
        var i$2 = ((1000000000 + inNano) | 0);
        var this$74 = ("" + i$2);
        var str$2 = this$74.substring(1);
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2);
      }
    }
  } else if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits > 0) || ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-1)) && (inNano > 0)))) {
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + ".");
    var div = 100000000;
    var i$3 = 0;
    while ((((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits === (-1)) && (inNano > 0)) || (i$3 < this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits))) {
      var digit = ((inNano / $checkIntDivisor(div)) | 0);
      var c = (65535 & ((48 + digit) | 0));
      var str$3 = ("" + $cToS(c));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$3);
      inNano = ((inNano - Math.imul(digit, div)) | 0);
      div = ((div / 10) | 0);
      i$3 = ((1 + i$3) | 0);
    }
  }
  buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + "Z");
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var newContext = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), context);
  var minDigits = ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits < 0) ? 0 : this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits);
  var maxDigits = ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits < 0) ? 9 : this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser__f_fractionalDigits);
  var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).append__Ljava_time_format_DateTimeFormatter__Ljava_time_format_DateTimeFormatterBuilder($m_Ljava_time_format_DateTimeFormatter$().ISO_LOCAL_DATE__Ljava_time_format_DateTimeFormatter()).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(84).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), 2).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(58).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField(), 2).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(58).appendValue__Ljava_time_temporal_TemporalField__I__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField(), 2).appendFraction__Ljava_time_temporal_TemporalField__I__I__Z__Ljava_time_format_DateTimeFormatterBuilder($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), minDigits, maxDigits, true).appendLiteral__C__Ljava_time_format_DateTimeFormatterBuilder(90);
  var this$2 = $m_ju_Locale$();
  var this$3 = this$1.toFormatter__ju_Locale__Ljava_time_format_DateTimeFormatter(this$2.ju_Locale$__f_defaultLocale);
  var parser = this$3.Ljava_time_format_DateTimeFormatter__f_printerParser.withOptional__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(false);
  var pos = parser.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(newContext, text, position);
  if ((pos < 0)) {
    return pos;
  }
  var yearParsed = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
  var this$4 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
  var month = this$4.RTLong__f_lo;
  var this$5 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
  var day = this$5.RTLong__f_lo;
  var this$6 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
  var hour = this$6.RTLong__f_lo;
  var this$7 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
  var min = this$7.RTLong__f_lo;
  var secVal = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
  var nanoVal = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
  var sec = ((secVal !== null) ? secVal.RTLong__f_lo : 0);
  var nano = ((nanoVal !== null) ? nanoVal.RTLong__f_lo : 0);
  var a = $uJ(yearParsed);
  var year = ((a.RTLong__f_lo % 10000) | 0);
  var days = 0;
  if (((((hour === 24) && (min === 0)) && (sec === 0)) && (nano === 0))) {
    hour = 0;
    days = 1;
  } else if ((((hour === 23) && (min === 59)) && (sec === 60))) {
    $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(context).Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond = true;
    sec = 59;
  }
  var instantSecs = $L0;
  try {
    var $x_1 = $m_Ljava_time_LocalDateTime$().of__I__I__I__I__I__I__I__Ljava_time_LocalDateTime(year, month, day, hour, min, sec, 0);
    var value = days;
    var hi = (value >> 31);
    var ldt = $x_1.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(value, hi));
    var t = ldt.toEpochSecond__Ljava_time_ZoneOffset__J($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
    var lo = t.RTLong__f_lo;
    var hi$1 = t.RTLong__f_hi;
    instantSecs = new $c_RTLong(lo, hi$1);
    var x = instantSecs;
    var a$2 = $uJ(x);
    var a$1 = $uJ(yearParsed);
    var this$15 = $m_RTLong$();
    var lo$1 = this$15.divideImpl__I__I__I__I__I(a$1.RTLong__f_lo, a$1.RTLong__f_hi, 10000, 0);
    var hi$2 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var x$1 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$InstantPrinterParser$$$SECONDS_PER_10000_YEARS;
    var t$1 = $uJ(x$1);
    var lo$2 = t$1.RTLong__f_lo;
    var hi$3 = t$1.RTLong__f_hi;
    var this$17 = $m_jl_Math$();
    var a0 = (65535 & lo$1);
    var a1 = ((lo$1 >>> 16) | 0);
    var b0 = (65535 & lo$2);
    var b1 = ((lo$2 >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$3 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$4 = ((((((((Math.imul(lo$1, hi$3) + Math.imul(hi$2, lo$2)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    if (((hi$2 < 0) && ((lo$2 === 0) && (hi$3 === (-2147483648))))) {
      var $x_2 = true;
    } else if ((!((lo$1 === 0) && (hi$2 === 0)))) {
      var this$22 = $m_RTLong$();
      var lo$4 = this$22.divideImpl__I__I__I__I__I(lo$3, hi$4, lo$1, hi$2);
      var hi$5 = this$22.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $x_2 = (!((lo$4 === lo$2) && (hi$5 === hi$3)));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      this$17.java$lang$Math$$longOverflow__E();
    }
    var alo = a$2.RTLong__f_lo;
    var lo$5 = ((alo + lo$3) | 0);
    var hi$6 = ((((a$2.RTLong__f_hi + hi$4) | 0) + ((((alo & lo$3) | ((alo | lo$3) & (~lo$5))) >>> 31) | 0)) | 0);
    instantSecs = new $c_RTLong(lo$5, hi$6);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ((e$2 instanceof $c_jl_RuntimeException)) {
      return (~position);
    } else {
      throw e;
    }
  }
  var successPos = pos;
  var $x_3 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
  var x$2 = instantSecs;
  successPos = context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($x_3, $uJ(x$2), position, successPos);
  var $x_4 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var hi$7 = (nano >> 31);
  return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($x_4, new $c_RTLong(nano, hi$7), position, successPos);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype.toString__T = (function() {
  return "Instant()";
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$InstantPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser(style) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser__f_style = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser__f_style = style;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var offsetSecs = context.getValue__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
  if ((offsetSecs === null)) {
    return false;
  }
  buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + "GMT");
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser__f_style === $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle())) {
    return new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser("", "+HH:MM:ss").print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf);
  }
  var t = $uJ(offsetSecs);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$2 = $m_jl_Math$();
  var hi$1 = (lo >> 31);
  if ((hi$1 !== hi)) {
    this$2.java$lang$Math$$intOverflow__E();
  }
  if ((lo !== 0)) {
    var a = ((((lo / 3600) | 0) % 100) | 0);
    var sign = (a >> 31);
    var absHours = (((a ^ sign) - sign) | 0);
    var a$1 = ((((lo / 60) | 0) % 60) | 0);
    var sign$1 = (a$1 >> 31);
    var absMinutes = (((a$1 ^ sign$1) - sign$1) | 0);
    var a$2 = ((lo % 60) | 0);
    var sign$2 = (a$2 >> 31);
    var absSeconds = (((a$2 ^ sign$2) - sign$2) | 0);
    var str = ((lo < 0) ? "-" : "+");
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
    var str$1 = ("" + absHours);
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
    if (((absMinutes > 0) || (absSeconds > 0))) {
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":");
      var c = (65535 & ((48 + ((absMinutes / 10) | 0)) | 0));
      var str$2 = ("" + $cToS(c));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$2);
      var c$1 = (65535 & ((48 + ((absMinutes % 10) | 0)) | 0));
      var str$3 = ("" + $cToS(c$1));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$3);
      if ((absSeconds > 0)) {
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":");
        var c$2 = (65535 & ((48 + ((absSeconds / 10) | 0)) | 0));
        var str$4 = ("" + $cToS(c$2));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$4);
        var c$3 = (65535 & ((48 + ((absSeconds % 10) | 0)) | 0));
        var str$5 = ("" + $cToS(c$3));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$5);
      }
    }
  }
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var _position = position;
  if ((!context.subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z(text, _position, "GMT", 0, 3))) {
    return (~_position);
  }
  _position = ((3 + _position) | 0);
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser__f_style === $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle())) {
    return new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser("", "+HH:MM:ss").parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, text, _position);
  }
  var end = $dp_length__I(text);
  if ((_position === end)) {
    return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, _position, _position);
  }
  var sign = $dp_charAt__I__C(text, _position);
  if (((sign !== 43) && (sign !== 45))) {
    return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, _position, _position);
  }
  var negative = ((sign === 45) ? (-1) : 1);
  if ((_position === end)) {
    return (~_position);
  }
  _position = ((1 + _position) | 0);
  var ch = $dp_charAt__I__C(text, _position);
  if (((ch < 48) || (ch > 57))) {
    return (~_position);
  }
  _position = ((1 + _position) | 0);
  var hour = (((-48) + ch) | 0);
  if ((_position !== end)) {
    ch = $dp_charAt__I__C(text, _position);
    if (((ch >= 48) && (ch <= 57))) {
      hour = ((Math.imul(10, hour) + (((-48) + ch) | 0)) | 0);
      if ((hour > 23)) {
        return (~_position);
      }
      _position = ((1 + _position) | 0);
    }
  }
  if (((_position === end) || ($dp_charAt__I__C(text, _position) !== 58))) {
    var offset = Math.imul(Math.imul(3600, negative), hour);
    var $x_1 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    var hi = (offset >> 31);
    return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($x_1, new $c_RTLong(offset, hi), _position, _position);
  }
  _position = ((1 + _position) | 0);
  if ((_position > (((-2) + end) | 0))) {
    return (~_position);
  }
  ch = $dp_charAt__I__C(text, _position);
  if (((ch < 48) || (ch > 57))) {
    return (~_position);
  }
  _position = ((1 + _position) | 0);
  var min = (((-48) + ch) | 0);
  ch = $dp_charAt__I__C(text, _position);
  if (((ch < 48) || (ch > 57))) {
    return (~_position);
  }
  _position = ((1 + _position) | 0);
  min = ((Math.imul(10, min) + (((-48) + ch) | 0)) | 0);
  if ((min > 59)) {
    return (~_position);
  }
  if (((_position === end) || ($dp_charAt__I__C(text, _position) !== 58))) {
    var offset$2 = Math.imul(negative, ((Math.imul(3600, hour) + Math.imul(60, min)) | 0));
    var $x_2 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    var hi$1 = (offset$2 >> 31);
    return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($x_2, new $c_RTLong(offset$2, hi$1), _position, _position);
  }
  _position = ((1 + _position) | 0);
  if ((_position > (((-2) + end) | 0))) {
    return (~_position);
  }
  ch = $dp_charAt__I__C(text, _position);
  if (((ch < 48) || (ch > 57))) {
    return (~_position);
  }
  _position = ((1 + _position) | 0);
  var sec = (((-48) + ch) | 0);
  ch = $dp_charAt__I__C(text, _position);
  if (((ch < 48) || (ch > 57))) {
    return (~_position);
  }
  _position = ((1 + _position) | 0);
  sec = ((Math.imul(10, sec) + (((-48) + ch) | 0)) | 0);
  if ((sec > 59)) {
    return (~_position);
  }
  var offset$3 = Math.imul(negative, ((((Math.imul(3600, hour) + Math.imul(60, min)) | 0) + sec) | 0));
  var $x_3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  var hi$2 = (offset$3 >> 31);
  return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($x_3, new $c_RTLong(offset$3, hi$2), _position, _position);
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$LocalizedOffsetPrinterParser };
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__($thiz, field, minWidth, maxWidth, signStyle, subsequentWidth) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field = field;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth = minWidth;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth = maxWidth;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle = signStyle;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth = subsequentWidth;
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__ };
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__($thiz, field, minWidth, maxWidth, signStyle) {
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__($thiz, field, minWidth, maxWidth, signStyle, 0);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth = 0;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.withFixedWidth__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = (function() {
  return ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth === (-1)) ? this : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle, (-1)));
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = (function(subsequentWidth) {
  return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle, ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth + subsequentWidth) | 0));
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var valueLong = context.getValue__Ljava_time_temporal_TemporalField__jl_Long(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field);
  if ((valueLong === null)) {
    return false;
  }
  var value = this.getValue__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_Long__jl_Long(context, valueLong);
  var symbols = context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_symbols;
  if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(value, new $c_RTLong(0, (-2147483648)))) {
    var str = "9223372036854775808";
  } else {
    var t = $uJ(value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var sign = (hi >> 31);
    var xlo = (lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var this$3 = $m_RTLong$();
    var str = this$3.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(rlo, rhi);
  }
  var this$4 = str;
  if ((this$4.length > this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Field " + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + " cannot be printed as the value ") + value) + " exceeds the maximum print width of ") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth));
  }
  str = symbols.convertNumberToI18N__T__T(str);
  var a = $uJ(value);
  var ahi = a.RTLong__f_hi;
  if ((ahi >= 0)) {
    matchResult5: {
      var x9 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle;
      var x = $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle();
      if ((x === x9)) {
        if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth < 19)) {
          var a$1 = $uJ(value);
          var value$1 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS.u[this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth];
          var hi$1 = (value$1 >> 31);
          var ahi$1 = a$1.RTLong__f_hi;
          var $x_1 = ((ahi$1 === hi$1) ? ((a$1.RTLong__f_lo >>> 0) >= (value$1 >>> 0)) : (ahi$1 > hi$1));
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          var c = symbols.Ljava_time_format_DecimalStyle__f_positiveSign;
          var str$1 = ("" + $cToS(c));
          buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
          break matchResult5;
        } else {
          break matchResult5;
        }
      }
      var x$3 = $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle();
      if ((x$3 === x9)) {
        var c$1 = symbols.Ljava_time_format_DecimalStyle__f_positiveSign;
        var str$2 = ("" + $cToS(c$1));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$2);
        break matchResult5;
      }
    }
  } else {
    matchResult6: {
      var x10 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle;
      matchAlts1: {
        matchAlts2: {
          var x$5 = $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle();
          if ((x$5 === x10)) {
            break matchAlts2;
          }
          var x$7 = $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle();
          if ((x$7 === x10)) {
            break matchAlts2;
          }
          var x$9 = $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle();
          if ((x$9 === x10)) {
            break matchAlts2;
          }
          break matchAlts1;
        }
        var c$2 = symbols.Ljava_time_format_DecimalStyle__f_negativeSign;
        var str$3 = ("" + $cToS(c$2));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$3);
        break matchResult6;
      }
      var x$11 = $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle();
      if ((x$11 === x10)) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), (((("Field " + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + " cannot be printed as the value ") + value) + " cannot be negative according to the SignStyle"));
      }
    }
  }
  var i = 0;
  while (true) {
    var $x_3 = i;
    var $x_2 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth;
    var this$13 = str;
    if (($x_3 < (($x_2 - this$13.length) | 0))) {
      var c$3 = symbols.Ljava_time_format_DecimalStyle__f_zeroDigit;
      var str$4 = ("" + $cToS(c$3));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$4);
      i = ((1 + i) | 0);
    } else {
      break;
    }
  }
  var str$5 = str;
  buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$5);
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.getValue__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_Long__jl_Long = (function(context, value) {
  return ((context !== null) ? value : value);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z = (function(context) {
  return ((context !== null) ? ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth === (-1)) || (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth > 0) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))) : ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth === (-1)) || (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth > 0) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))));
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var _position = position;
  var length = $dp_length__I(text);
  if ((_position === length)) {
    return (~_position);
  }
  if (((_position < 0) || (position > length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__(new $c_jl_StringIndexOutOfBoundsException());
  }
  var sign = $dp_charAt__I__C(text, _position);
  var negative = false;
  var positive = false;
  var this$1 = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols;
  if ((sign === this$1.Ljava_time_format_DecimalStyle__f_positiveSign)) {
    if ((!this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle.parse__Z__Z__Z__Z(true, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict, (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)))) {
      return (~_position);
    }
    positive = true;
    _position = ((1 + _position) | 0);
  } else {
    var this$2 = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols;
    if ((sign === this$2.Ljava_time_format_DecimalStyle__f_negativeSign)) {
      if ((!this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle.parse__Z__Z__Z__Z(false, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict, (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth)))) {
        return (~_position);
      }
      negative = true;
      _position = ((1 + _position) | 0);
    } else if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle()) && context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict)) {
      return (~_position);
    }
  }
  var effMinWidth = ((context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict || this.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z(context)) ? this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth : 1);
  var minEndPos = ((_position + effMinWidth) | 0);
  if ((minEndPos > length)) {
    return (~_position);
  }
  var $x_1 = ((context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict || this.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z(context)) ? this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth : 9);
  var a = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth;
  var effMaxWidth = (($x_1 + ((a > 0) ? a : 0)) | 0);
  var total = $L0;
  var totalBig = null;
  var pos = _position;
  var pass = 0;
  var outerBreak = false;
  while (((!outerBreak) && (pass < 2))) {
    var a$1 = ((pos + effMaxWidth) | 0);
    var maxEndPos = ((a$1 < length) ? a$1 : length);
    var break$1 = false;
    while (((!break$1) && (pos < maxEndPos))) {
      var ch = $dp_charAt__I__C(text, pos);
      pos = ((1 + pos) | 0);
      var digit = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_symbols.convertToDigit__C__I(ch);
      if ((digit < 0)) {
        pos = (((-1) + pos) | 0);
        if ((pos < minEndPos)) {
          return (~_position);
        }
        break$1 = true;
      }
      if ((!break$1)) {
        if ((((pos - _position) | 0) > 18)) {
          if ((totalBig === null)) {
            var x = total;
            var t = $uJ(x);
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            totalBig = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi));
          }
          var this$8 = totalBig.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
          var hi$1 = (digit >> 31);
          var bi = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(digit, hi$1));
          totalBig = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, bi);
        } else {
          var x$1 = total;
          var b = $uJ(x$1);
          var blo = b.RTLong__f_lo;
          var b0 = (65535 & blo);
          var b1 = ((blo >>> 16) | 0);
          var a0b0 = Math.imul(10, b0);
          var a0b1 = Math.imul(10, b1);
          var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
          var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
          var hi$2 = ((Math.imul(10, b.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
          var hi$3 = (digit >> 31);
          var lo$2 = ((lo$1 + digit) | 0);
          var hi$4 = ((((hi$2 + hi$3) | 0) + ((((lo$1 & digit) | ((lo$1 | digit) & (~lo$2))) >>> 31) | 0)) | 0);
          total = new $c_RTLong(lo$2, hi$4);
        }
      }
    }
    if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth > 0) && (pass === 0))) {
      var parseLen = ((pos - _position) | 0);
      var b$1 = ((parseLen - this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth) | 0);
      effMaxWidth = ((effMinWidth > b$1) ? effMinWidth : b$1);
      pos = _position;
      total = $L0;
      totalBig = null;
      pass = ((1 + pass) | 0);
    } else {
      outerBreak = true;
    }
  }
  if (negative) {
    if ((totalBig !== null)) {
      var xn = totalBig;
      var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      if (($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn) && context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict)) {
        return (~(((-1) + _position) | 0));
      }
      totalBig = totalBig.negate__Ljava_math_BigInteger();
    } else {
      var xn$1 = total;
      if (($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn$1, 0) && context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict)) {
        return (~(((-1) + _position) | 0));
      }
      var x$2 = total;
      var b$2 = $uJ(x$2);
      var blo$1 = b$2.RTLong__f_lo;
      var lo$3 = ((-blo$1) | 0);
      var hi$5 = ((((-b$2.RTLong__f_hi) | 0) + ((blo$1 | lo$3) >> 31)) | 0);
      total = new $c_RTLong(lo$3, hi$5);
    }
  } else if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle()) && context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict)) {
    var parseLen$2 = ((pos - _position) | 0);
    if (positive) {
      if ((parseLen$2 <= this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth)) {
        return (~(((-1) + _position) | 0));
      }
    } else if ((parseLen$2 > this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth)) {
      return (~_position);
    }
  }
  if ((totalBig !== null)) {
    var this$19 = totalBig;
    if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$19) > 63)) {
      totalBig = totalBig.divide__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
      pos = (((-1) + pos) | 0);
    }
    var t$1 = totalBig.longValue__J();
    var lo$4 = t$1.RTLong__f_lo;
    var hi$6 = t$1.RTLong__f_hi;
    return this.setValue__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_Long__I__I__I(context, new $c_RTLong(lo$4, hi$6), _position, pos);
  }
  return this.setValue__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_Long__I__I__I(context, total, _position, pos);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.setValue__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_Long__I__I__I = (function(context, value, errorPos, successPos) {
  return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, $uJ(value), errorPos, successPos);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.toString__T = (function() {
  return ((((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === 1) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth === 19)) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle())) ? (("Value(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + ")") : (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth) && (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle === $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle())) ? (((("Value(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth) + ")") : (((((((("Value(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle) + ")")));
});
function $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser)));
}
export { $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser as $isArrayOf_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser };
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser };
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__checkPattern__T__I($thiz, pattern) {
  var i = 0;
  while ((i < $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS.u.length)) {
    if (($m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS.u[i] === pattern)) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid zone offset pattern: " + pattern));
}
export { $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__checkPattern__T__I as $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__checkPattern__T__I };
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z($thiz, array, arrayIndex, parseText, required) {
  if ((((((3 + $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type) | 0) / 2) | 0) < arrayIndex)) {
    return false;
  }
  var pos = array.u[0];
  if ((((($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type % 2) | 0) === 0) && (arrayIndex > 1))) {
    if (((((1 + pos) | 0) > $dp_length__I(parseText)) || ($dp_charAt__I__C(parseText, pos) !== 58))) {
      return required;
    }
    pos = ((1 + pos) | 0);
  }
  if ((((2 + pos) | 0) > $dp_length__I(parseText))) {
    return required;
  }
  var ch1 = $dp_charAt__I__C(parseText, pos);
  pos = ((1 + pos) | 0);
  var ch2 = $dp_charAt__I__C(parseText, pos);
  pos = ((1 + pos) | 0);
  if (((((ch1 < 48) || (ch1 > 57)) || (ch2 < 48)) || (ch2 > 57))) {
    return required;
  }
  var value = ((Math.imul(10, (((-48) + ch1) | 0)) + (((-48) + ch2) | 0)) | 0);
  if (((value < 0) || (value > 59))) {
    return required;
  }
  array.u[arrayIndex] = value;
  array.u[0] = pos;
  return false;
}
export { $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z as $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser(noOffsetText, pattern) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText = noOffsetText;
  if ((noOffsetText === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "noOffsetText");
  }
  if ((pattern === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "pattern");
  }
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__checkPattern__T__I(this, pattern);
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var offsetSecs = context.getValue__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
  if ((offsetSecs === null)) {
    return false;
  }
  var t = $uJ(offsetSecs);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$2 = $m_jl_Math$();
  var hi$1 = (lo >> 31);
  if ((hi$1 !== hi)) {
    this$2.java$lang$Math$$intOverflow__E();
  }
  if ((lo === 0)) {
    var str = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText;
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  } else {
    var a = ((((lo / 3600) | 0) % 100) | 0);
    var sign = (a >> 31);
    var absHours = (((a ^ sign) - sign) | 0);
    var a$1 = ((((lo / 60) | 0) % 60) | 0);
    var sign$1 = (a$1 >> 31);
    var absMinutes = (((a$1 ^ sign$1) - sign$1) | 0);
    var a$2 = ((lo % 60) | 0);
    var sign$2 = (a$2 >> 31);
    var absSeconds = (((a$2 ^ sign$2) - sign$2) | 0);
    var bufPos = buf.length__I();
    var output = absHours;
    var str$1 = ((lo < 0) ? "-" : "+");
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
    var c = (65535 & ((48 + ((absHours / 10) | 0)) | 0));
    var str$2 = ("" + $cToS(c));
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$2);
    var c$1 = (65535 & ((48 + ((absHours % 10) | 0)) | 0));
    var str$3 = ("" + $cToS(c$1));
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$3);
    if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type >= 3) || ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type >= 1) && (absMinutes > 0)))) {
      var str$4 = ((((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type % 2) | 0) === 0) ? ":" : "");
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$4);
      var c$2 = (65535 & ((48 + ((absMinutes / 10) | 0)) | 0));
      var str$5 = ("" + $cToS(c$2));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$5);
      var c$3 = (65535 & ((48 + ((absMinutes % 10) | 0)) | 0));
      var str$6 = ("" + $cToS(c$3));
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$6);
      output = ((output + absMinutes) | 0);
      if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type >= 7) || ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type >= 5) && (absSeconds > 0)))) {
        var str$7 = ((((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type % 2) | 0) === 0) ? ":" : "");
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$7);
        var c$4 = (65535 & ((48 + ((absSeconds / 10) | 0)) | 0));
        var str$8 = ("" + $cToS(c$4));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$8);
        var c$5 = (65535 & ((48 + ((absSeconds % 10) | 0)) | 0));
        var str$9 = ("" + $cToS(c$5));
        buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (buf.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$9);
        output = ((output + absSeconds) | 0);
      }
    }
    if ((output === 0)) {
      buf.setLength__I__V(bufPos);
      var str$10 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText;
      buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$10);
    }
  }
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var length = $dp_length__I(text);
  var this$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText;
  var noOffsetLen = this$1.length;
  if ((noOffsetLen === 0)) {
    if ((position === length)) {
      return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, position, position);
    }
  } else {
    if ((position === length)) {
      return (~position);
    }
    if (context.subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z(text, position, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText, 0, noOffsetLen)) {
      return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, position, ((position + noOffsetLen) | 0));
    }
  }
  var sign = $dp_charAt__I__C(text, position);
  if (((sign === 43) || (sign === 45))) {
    var negative = ((sign === 45) ? (-1) : 1);
    var dimensions = new $ac_I(new Int32Array([4]));
    var array = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_I.getClassOf(), dimensions);
    array.u[0] = ((1 + position) | 0);
    if ((!(($p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z(this, array, 1, text, true) || $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z(this, array, 2, text, (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type >= 3))) || $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__parseNumber__AI__I__jl_CharSequence__Z__Z(this, array, 3, text, false)))) {
      var hi = (negative >> 31);
      var value = array.u[1];
      var hi$1 = (value >> 31);
      var b0 = (65535 & value);
      var b1 = ((value >>> 16) | 0);
      var a0b0 = Math.imul(3600, b0);
      var a0b1 = Math.imul(3600, b1);
      var lo = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((Math.imul(3600, hi$1) + ((c1part >>> 16) | 0)) | 0);
      var value$1 = array.u[2];
      var hi$3 = (value$1 >> 31);
      var b0$1 = (65535 & value$1);
      var b1$1 = ((value$1 >>> 16) | 0);
      var a0b0$1 = Math.imul(60, b0$1);
      var a0b1$1 = Math.imul(60, b1$1);
      var lo$1 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$4 = ((Math.imul(60, hi$3) + ((c1part$1 >>> 16) | 0)) | 0);
      var lo$2 = ((lo + lo$1) | 0);
      var hi$5 = ((((hi$2 + hi$4) | 0) + ((((lo & lo$1) | ((lo | lo$1) & (~lo$2))) >>> 31) | 0)) | 0);
      var value$2 = array.u[3];
      var hi$6 = (value$2 >> 31);
      var lo$3 = ((lo$2 + value$2) | 0);
      var hi$7 = ((((hi$5 + hi$6) | 0) + ((((lo$2 & value$2) | ((lo$2 | value$2) & (~lo$3))) >>> 31) | 0)) | 0);
      var a0 = (65535 & negative);
      var a1 = ((negative >>> 16) | 0);
      var b0$2 = (65535 & lo$3);
      var b1$2 = ((lo$3 >>> 16) | 0);
      var a0b0$2 = Math.imul(a0, b0$2);
      var a1b0 = Math.imul(a1, b0$2);
      var a0b1$2 = Math.imul(a0, b1$2);
      var lo$4 = ((a0b0$2 + (((a1b0 + a0b1$2) | 0) << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$8 = ((((((((Math.imul(negative, hi$7) + Math.imul(hi, lo$3)) | 0) + Math.imul(a1, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0) | 0) >>> 16) | 0)) | 0);
      return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), new $c_RTLong(lo$4, hi$8), position, array.u[0]);
    }
  }
  if ((noOffsetLen === 0)) {
    return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), $L0, position, ((position + noOffsetLen) | 0));
  }
  return (~position);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser.prototype.toString__T = (function() {
  var this$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_noOffsetText;
  var converted = this$1.split("'").join("''");
  return (((("Offset(" + $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_PATTERNS.u[this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser__f_type]) + ",'") + converted) + "')");
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator(printerParser, padWidth, padChar) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser = printerParser;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth = padWidth;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar = padChar;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var preLen = buf.length__I();
  if ((!this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf))) {
    return false;
  }
  var len = ((buf.length__I() - preLen) | 0);
  if ((len > this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Cannot print as output of " + len) + " characters exceeds pad width of ") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth));
  }
  var i = 0;
  while ((i < ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth - len) | 0))) {
    var c = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar;
    buf.insert__I__T__jl_StringBuilder(preLen, ("" + $cToS(c)));
    i = ((1 + i) | 0);
  }
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var _text = text;
  var strict = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict;
  var caseSensitive = context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive;
  if ((position > $dp_length__I(_text))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  if ((position === $dp_length__I(_text))) {
    return (~position);
  }
  var endPos = ((position + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth) | 0);
  if ((endPos > $dp_length__I(_text))) {
    if (strict) {
      return (~position);
    }
    endPos = $dp_length__I(_text);
  }
  var pos = position;
  while (((pos < endPos) && (caseSensitive ? ($dp_charAt__I__C(_text, pos) === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar) : context.charEquals__C__C__Z($dp_charAt__I__C(_text, pos), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar)))) {
    pos = ((1 + pos) | 0);
  }
  _text = $dp_subSequence__I__I__jl_CharSequence(_text, 0, endPos);
  var resultPos = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, _text, pos);
  if (((resultPos !== endPos) && strict)) {
    return (~((position + pos) | 0));
  }
  return resultPos;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator.prototype.toString__T = (function() {
  return (((("Pad(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_printerParser) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padWidth) + ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar === 32) ? ")" : ((",'" + $cToS(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator__f_padChar)) + "')")));
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator, "java.time.format.internal.TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser(literal) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal = literal;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var str = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal;
  buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var length = $dp_length__I(text);
  if (((position > length) || (position < 0))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  } else {
    var $x_1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal;
    var this$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal;
    if ((!context.subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z(text, position, $x_1, 0, this$1.length))) {
      return (~position);
    } else {
      var this$2 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal;
      return ((position + this$2.length) | 0);
    }
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser.prototype.toString__T = (function() {
  var this$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser__f_literal;
  var converted = this$1.split("'").join("''");
  return (("'" + converted) + "'");
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$StringLiteralPrinterParser };
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__numberPrinterParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser($thiz) {
  if (($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f__numberPrinterParser === null)) {
    $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f__numberPrinterParser = $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field, 1, 19, $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle());
  }
  return $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f__numberPrinterParser;
}
export { $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__numberPrinterParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser as $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__numberPrinterParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser(field, textStyle, provider) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_provider = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f__numberPrinterParser = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field = field;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle = textStyle;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_provider = provider;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f__numberPrinterParser = null;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var value = context.getValue__Ljava_time_temporal_TemporalField__jl_Long(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field);
  if ((value === null)) {
    return false;
  }
  var text = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_provider.getText__Ljava_time_temporal_TemporalField__J__Ljava_time_format_TextStyle__ju_Locale__T(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field, $uJ(value), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle, context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale);
  if ((text === null)) {
    return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__numberPrinterParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(this).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf);
  }
  buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + text);
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, parseText, position) {
  var length = $dp_length__I(parseText);
  if (((position < 0) || (position > length))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var style = (context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict ? this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle : null);
  var it = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_provider.getTextIterator__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__ju_Locale__sc_Iterator(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field, style, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale);
  if ((it !== null)) {
    while (it.hasNext__Z()) {
      var entry = it.next__O();
      var itText = entry._1__O();
      if (context.subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z(itText, 0, parseText, position, itText.length)) {
        return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field, $uJ(entry._2__O()), position, ((position + itText.length) | 0));
      }
    }
    if (context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict) {
      return (~position);
    }
  }
  return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__numberPrinterParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(this).parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, parseText, position);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser.prototype.toString__T = (function() {
  return ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle === $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle()) ? (("Text(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field) + ")") : (((("Text(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser__f_textStyle) + ")"));
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$TextPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$TextPrinterParser };
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__evaluate__Ljava_time_temporal_WeekFields__Ljava_time_format_internal_DateTimePrinterParser($thiz, weekFields) {
  var x11 = $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter;
  switch (x11) {
    case 101: {
      return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), weekFields.Ljava_time_temporal_WeekFields__f_dayOfWeek, $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count, 2, $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle());
      break;
    }
    case 99: {
      return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), weekFields.Ljava_time_temporal_WeekFields__f_dayOfWeek, $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count, 2, $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle());
      break;
    }
    case 119: {
      return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), weekFields.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear, $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count, 2, $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle());
      break;
    }
    case 87: {
      return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), weekFields.Ljava_time_temporal_WeekFields__f_weekOfMonth, 1, 2, $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle());
      break;
    }
    case 89: {
      return (($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count === 2) ? $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser(), weekFields.Ljava_time_temporal_WeekFields__f_weekBasedYear, 2, 2, 0, $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser$__f_BASE_DATE) : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), weekFields.Ljava_time_temporal_WeekFields__f_weekBasedYear, $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count, 19, (($thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count < 4) ? $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle() : $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle()), (-1)));
      break;
    }
    default: {
      throw new $c_s_MatchError($bC(x11));
    }
  }
}
export { $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__evaluate__Ljava_time_temporal_WeekFields__Ljava_time_format_internal_DateTimePrinterParser as $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__evaluate__Ljava_time_temporal_WeekFields__Ljava_time_format_internal_DateTimePrinterParser };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser(letter, count) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter = letter;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count = count;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__evaluate__Ljava_time_temporal_WeekFields__Ljava_time_format_internal_DateTimePrinterParser(this, $m_Ljava_time_temporal_WeekFields$().of__ju_Locale__Ljava_time_temporal_WeekFields(context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale)).print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z(context, buf);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__evaluate__Ljava_time_temporal_WeekFields__Ljava_time_format_internal_DateTimePrinterParser(this, $m_Ljava_time_temporal_WeekFields$().of__ju_Locale__Ljava_time_temporal_WeekFields(context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale)).parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(context, text, position);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser.prototype.toString__T = (function() {
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 30);
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "Localized(");
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter === 89)) {
    if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count === 1)) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "WeekBasedYear");
    } else if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count === 2)) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "ReducedValue(WeekBasedYear,2,2,2000-01-01)");
    } else {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "WeekBasedYear,");
      var i = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count;
      var str = ("" + i);
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "19");
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
      var obj = ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count < 4) ? $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle() : $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle());
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    }
  } else {
    if (((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter === 99) || (this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter === 101))) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "DayOfWeek");
    } else if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter === 119)) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "WeekOfWeekBasedYear");
    } else if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_letter === 87)) {
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "WeekOfMonth");
    }
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
    var i$1 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser__f_count;
    var str$1 = ("" + i$1);
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
  }
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + ")");
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$WeekFieldsPrinterParser };
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__convertToZone__ju_Set__T__Z__Ljava_time_ZoneId($thiz, regionIds, parsedZoneId, caseSensitive) {
  if ((parsedZoneId === null)) {
    return null;
  } else if (caseSensitive) {
    return (regionIds.contains__O__Z(parsedZoneId) ? $m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId(parsedZoneId) : null);
  } else {
    var regionIdsIterator = regionIds.iterator__ju_Iterator();
    while (regionIdsIterator.hasNext__Z()) {
      var regionId = regionIdsIterator.next__O();
      _return$1: {
        var len = regionId.length;
        if ((!((parsedZoneId === null) || (parsedZoneId.length !== len)))) {
          var i = 0;
          while ((i !== len)) {
            var index = i;
            var c = regionId.charCodeAt(index);
            var $x_2 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
            var index$1 = i;
            var c$1 = parsedZoneId.charCodeAt(index$1);
            if (($x_2 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
              var $x_1 = false;
              break _return$1;
            }
            i = ((1 + i) | 0);
          }
          var $x_1 = true;
        } else {
          var $x_1 = false;
        }
      }
      if ($x_1) {
        return $m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId(regionId);
      }
    }
    return null;
  }
}
export { $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__convertToZone__ju_Set__T__Z__Ljava_time_ZoneId as $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__convertToZone__ju_Set__T__Z__Ljava_time_ZoneId };
function $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I($thiz, context, text, prefixPos, position) {
  var this$1 = $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(text, prefixPos, position));
  var prefix = this$1.toUpperCase();
  var newContext = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), context);
  if (((position < $dp_length__I(text)) && context.charEquals__C__C__Z($dp_charAt__I__C(text, position), 90))) {
    context.setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneId$().ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId(prefix, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset()));
    return position;
  }
  var endPos = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(newContext, text, position);
  if ((endPos < 0)) {
    context.setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneId$().ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId(prefix, $m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset()));
    return position;
  }
  var this$2 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
  var offsetSecs = this$2.RTLong__f_lo;
  var offset = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(offsetSecs);
  context.setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneId$().ofOffset__T__Ljava_time_ZoneOffset__Ljava_time_ZoneId(prefix, offset));
  return endPos;
}
export { $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I as $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser(query, description) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_query = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_description = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_query = query;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_description = description;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var zone = context.getValue__Ljava_time_temporal_TemporalQuery__O(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_query);
  if ((zone !== null)) {
    var str = zone.getId__T();
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
    return true;
  } else {
    return false;
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var length = $dp_length__I(text);
  if ((position > length)) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  if ((position === length)) {
    return (~position);
  }
  var nextChar = $dp_charAt__I__C(text, position);
  if (((nextChar === 43) || (nextChar === 45))) {
    var newContext = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), context);
    var endPos = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$OffsetIdPrinterParser$__f_INSTANCE_ID.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I(newContext, text, position);
    if ((endPos < 0)) {
      return endPos;
    }
    var this$1 = newContext.getParsed__Ljava_time_temporal_TemporalField__jl_Long($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
    var offset = this$1.RTLong__f_lo;
    context.setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(offset));
    return endPos;
  } else if ((length >= ((2 + position) | 0))) {
    var nextNextChar = $dp_charAt__I__C(text, ((1 + position) | 0));
    if ((context.charEquals__C__C__Z(nextChar, 85) && context.charEquals__C__C__Z(nextNextChar, 84))) {
      if (((length >= ((3 + position) | 0)) && context.charEquals__C__C__Z($dp_charAt__I__C(text, ((2 + position) | 0)), 67))) {
        return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I(this, context, text, position, ((3 + position) | 0));
      }
      return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I(this, context, text, position, ((2 + position) | 0));
    } else if ((((context.charEquals__C__C__Z(nextChar, 71) && (length >= ((3 + position) | 0))) && context.charEquals__C__C__Z(nextNextChar, 77)) && context.charEquals__C__C__Z($dp_charAt__I__C(text, ((2 + position) | 0)), 84))) {
      return $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__parsePrefixedOffset__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I__I(this, context, text, position, ((3 + position) | 0));
    }
  }
  var regionIds = $m_Ljava_time_zone_ZoneRulesProvider$().getAvailableZoneIds__ju_Set();
  var regionIdsSize = regionIds.size__I();
  var cached = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$cachedSubstringTree;
  if ((cached === null)) {
    var $x_1 = true;
  } else {
    var x = cached.getKey__O();
    var $x_1 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x, regionIdsSize));
  }
  if ($x_1) {
    cached = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$cachedSubstringTree;
    if ((cached === null)) {
      var $x_2 = true;
    } else {
      var x$1 = cached.getKey__O();
      var $x_2 = (!$m_sr_BoxesRunTime$().equals__O__O__Z(x$1, regionIdsSize));
    }
    if ($x_2) {
      var $x_3 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$();
      cached = new $c_ju_AbstractMap$SimpleImmutableEntry(regionIdsSize, $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$prepareParser__ju_Set__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(regionIds));
      $x_3.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$__f_java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$$$cachedSubstringTree = cached;
    }
  }
  var tree = cached.getValue__O();
  var parsedZoneId = null;
  var lastZoneId = null;
  var break$1 = false;
  while (((!break$1) && (tree !== null))) {
    var nodeLength = tree.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree__f_length;
    if ((((position + nodeLength) | 0) > length)) {
      break$1 = true;
    } else {
      lastZoneId = parsedZoneId;
      parsedZoneId = $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(text, position, ((position + nodeLength) | 0)));
      tree = tree.get__jl_CharSequence__Z__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser$SubstringTree(parsedZoneId, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive);
    }
  }
  var zone = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__convertToZone__ju_Set__T__Z__Ljava_time_ZoneId(this, regionIds, parsedZoneId, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive);
  if ((zone === null)) {
    zone = $p_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__convertToZone__ju_Set__T__Z__Ljava_time_ZoneId(this, regionIds, lastZoneId, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive);
    if ((zone === null)) {
      if (context.charEquals__C__C__Z(nextChar, 90)) {
        context.setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneOffset$().UTC__Ljava_time_ZoneOffset());
        return ((1 + position) | 0);
      }
      return (~position);
    }
    parsedZoneId = lastZoneId;
  }
  context.setParsed__Ljava_time_ZoneId__V(zone);
  var this$4 = parsedZoneId;
  return ((position + this$4.length) | 0);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser.prototype.toString__T = (function() {
  return this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser__f_description;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneIdPrinterParser };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser(textStyle) {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser__f_textStyle = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser__f_textStyle = textStyle;
  if ((textStyle === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "textStyle");
  }
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  var zone = context.getValue__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery());
  if ((zone === null)) {
    return false;
  }
  if ((zone.normalized__Ljava_time_ZoneId() instanceof $c_Ljava_time_ZoneOffset)) {
    var str = zone.getId__T();
    buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
    return true;
  }
  var temporal = context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal;
  var daylight = false;
  if (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
    var this$1 = $m_Ljava_time_Instant$();
    var t = temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var instant = this$1.java$time$Instant$$$create__J__I__Ljava_time_Instant(new $c_RTLong(lo, hi), 0);
    daylight = zone.getRules__Ljava_time_zone_ZoneRules().isDaylightSavings__Ljava_time_Instant__Z(instant);
  }
  var tz = $m_ju_TimeZone$().getTimeZone__T__ju_TimeZone(zone.getId__T());
  var tzstyle = ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser__f_textStyle.asNormal__Ljava_time_format_TextStyle() === $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle()) ? 1 : 0);
  var text = tz.getDisplayName__Z__I__ju_Locale__T(daylight, tzstyle, context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_locale);
  buf.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + buf.jl_StringBuilder__f_java$lang$StringBuilder$$content) + text);
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var ids = $ct_ju_HashMap__(new $c_ju_HashMap());
  var this$2 = $ct_ju_HashSet__ju_Collection__(new $c_ju_HashSet(), $m_Ljava_time_zone_ZoneRulesProvider$().getAvailableZoneIds__ju_Set());
  var idIterator = this$2.ju_HashSet__f_innerKeySet.iterator__ju_Iterator();
  while (idIterator.hasNext__Z()) {
    var id = idIterator.next__O();
    if ((id === null)) {
      var $x_1 = 0;
    } else {
      var originalHash = $f_T__hashCode__I(id);
      var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    ids.java$util$HashMap$$put0__O__O__I__Z__O(id, id, $x_1, false);
    var tz = $m_ju_TimeZone$().getTimeZone__T__ju_TimeZone(id);
    var tzstyle = ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser__f_textStyle.asNormal__Ljava_time_format_TextStyle() === $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle()) ? 1 : 0);
    var textWinter = tz.getDisplayName__Z__I__ju_Locale__T(false, tzstyle, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale);
    if ((((textWinter !== null) && (!(!id.startsWith("Etc/")))) || ((!(!(!textWinter.startsWith("GMT+")))) && (!(!(!textWinter.startsWith("GMT+"))))))) {
      if ((textWinter === null)) {
        var $x_2 = 0;
      } else {
        var originalHash$1 = $f_T__hashCode__I(textWinter);
        var $x_2 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
      }
      ids.java$util$HashMap$$put0__O__O__I__Z__O(textWinter, id, $x_2, false);
    } else if ((textWinter === null)) {
      var key = tz.getDisplayName__Z__I__ju_Locale__T(false, tzstyle, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale);
      if ((key === null)) {
        var $x_3 = 0;
      } else {
        var originalHash$2 = $f_T__hashCode__I(key);
        var $x_3 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0));
      }
      ids.java$util$HashMap$$put0__O__O__I__Z__O(key, id, $x_3, false);
    }
    var textSummer = tz.getDisplayName__Z__I__ju_Locale__T(true, tzstyle, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale);
    if ((((textSummer !== null) && (!(!id.startsWith("Etc/")))) || ((!(!(!textSummer.startsWith("GMT+")))) && (!(!(!textSummer.startsWith("GMT+"))))))) {
      if ((textSummer === null)) {
        var $x_4 = 0;
      } else {
        var originalHash$3 = $f_T__hashCode__I(textSummer);
        var $x_4 = (originalHash$3 ^ ((originalHash$3 >>> 16) | 0));
      }
      ids.java$util$HashMap$$put0__O__O__I__Z__O(textSummer, id, $x_4, false);
    } else if ((textSummer === null)) {
      var key$1 = tz.getDisplayName__Z__I__ju_Locale__T(true, tzstyle, context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_locale);
      if ((key$1 === null)) {
        var $x_5 = 0;
      } else {
        var originalHash$4 = $f_T__hashCode__I(key$1);
        var $x_5 = (originalHash$4 ^ ((originalHash$4 >>> 16) | 0));
      }
      ids.java$util$HashMap$$put0__O__O__I__Z__O(key$1, id, $x_5, false);
    }
  }
  var tmpIds = $ct_ju_ArrayList__ju_Collection__(new $c_ju_ArrayList(), new $c_ju_HashMap$EntrySet(ids));
  var c = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$().java$time$format$internal$TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$$LENGTH_COMPARATOR__s_math_Ordering();
  $f_ju_List__sort__ju_Comparator__V(tmpIds, c);
  var i = tmpIds.listIterator__I__ju_ListIterator(0);
  while (i.hasNext__Z()) {
    var v = i.next__O();
    var name = v.getKey__O();
    if (context.subSequenceEquals__jl_CharSequence__I__jl_CharSequence__I__I__Z(text, position, name, 0, name.length)) {
      context.setParsed__Ljava_time_ZoneId__V($m_Ljava_time_ZoneId$().of__T__Ljava_time_ZoneId(v.getValue__O()));
      return ((position + name.length) | 0);
    }
  }
  return (~position);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser.prototype.toString__T = (function() {
  return (("ZoneText(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser__f_textStyle) + ")");
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(outer) {
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_excessDays = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_callbacks = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer = outer;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone = null;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond = false;
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_excessDays = $m_Ljava_time_Period$().ZERO__Ljava_time_Period();
  this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_callbacks = null;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed as $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed };
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed as $h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed };
$h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field);
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.copy__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed = (function() {
  var cloned = new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer);
  cloned.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono;
  cloned.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone;
  cloned.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.putAll__ju_Map__V(this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues);
  cloned.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_leapSecond;
  return cloned;
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.toString__T = (function() {
  return ((((this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.toString__T() + ",") + this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono) + ",") + this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone);
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.containsKey__O__Z(field);
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((!this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.containsKey__O__Z(field))) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  }
  var x = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.get__O__O(field);
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$2 = $m_jl_Math$();
  var hi$1 = (lo >> 31);
  if ((hi$1 !== hi)) {
    this$2.java$lang$Math$$intOverflow__E();
  }
  return lo;
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((!this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.containsKey__O__Z(field))) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var x = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues.get__O__O(field);
    return $uJ(x);
  }
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_chrono : (((query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) ? this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone : $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query)));
});
$c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype.toBuilder__Ljava_time_format_DateTimeBuilder = (function() {
  var builder = new $c_Ljava_time_format_DateTimeBuilder();
  builder.Ljava_time_format_DateTimeBuilder__f_fieldValues.putAll__ju_Map__V(this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_fieldValues);
  builder.Ljava_time_format_DateTimeBuilder__f_chrono = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer.getEffectiveChronology__Ljava_time_chrono_Chronology();
  if ((this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone !== null)) {
    builder.Ljava_time_format_DateTimeBuilder__f_zone = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_zone;
  } else {
    builder.Ljava_time_format_DateTimeBuilder__f_zone = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_$outer.Ljava_time_format_internal_TTBPDateTimeParseContext__f_overrideZone;
  }
  builder.Ljava_time_format_DateTimeBuilder__f_excessDays = this.Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed__f_excessDays;
  return builder;
});
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed, "java.time.format.internal.TTBPDateTimeParseContext$Parsed", ({
  Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed: 1,
  Ljava_time_temporal_TemporalAccessor: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed as $d_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1(effectiveDate$2, temporal$4, effectiveChrono$2, effectiveZone$2, outer) {
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 = null;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 = effectiveDate$2;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2 = temporal$4;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 = effectiveChrono$2;
  this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 = effectiveZone$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 as $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 };
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 as $h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 };
$h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype;
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && field.isDateBased__Z())) {
    var this$1 = this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1;
    return $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this$1, field);
  } else {
    return this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2.isSupported__Ljava_time_temporal_TemporalField__Z(field);
  }
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && field.isDateBased__Z()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field) : this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field));
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  return (((this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1 !== null) && field.isDateBased__Z()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveDate$1.getLong__Ljava_time_temporal_TemporalField__J(field) : this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2.getLong__Ljava_time_temporal_TemporalField__J(field));
});
$c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveChrono$1 : ((query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_effectiveZone$1 : ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1__f_temporal$2.query__Ljava_time_temporal_TemporalQuery__O(query) : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this))));
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1, "java.time.format.internal.TTBPDateTimePrintContext$$anon$1", ({
  Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1: 1,
  Ljava_time_temporal_TemporalAccessor: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 as $d_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 };
function $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__findStore__Ljava_time_temporal_TemporalField__ju_Locale__O($thiz, field, locale) {
  var key = $ct_T2__O__O__(new $c_T2(), field, locale);
  var store = $thiz.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__f_cache.get__O__O(key);
  if ((store === null)) {
    store = $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__createStore__Ljava_time_temporal_TemporalField__ju_Locale__O($thiz, field, locale);
    $thiz.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__f_cache.put__O__O__O(key, store);
    store = $thiz.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__f_cache.get__O__O(key);
  }
  return store;
}
export { $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__findStore__Ljava_time_temporal_TemporalField__ju_Locale__O as $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__findStore__Ljava_time_temporal_TemporalField__ju_Locale__O };
function $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__createStore__Ljava_time_temporal_TemporalField__ju_Locale__O($thiz, field, locale) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    var oldSymbols = $m_Ljava_text_DateFormatSymbols$().getInstance__ju_Locale__Ljava_text_DateFormatSymbols(locale);
    var array = oldSymbols.Ljava_text_DateFormatSymbols__f_months;
    var this$25 = $m_sci_Map$();
    var $x_12 = $m_sr_ScalaRunTime$();
    var y = array.u[0];
    var $x_11 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y);
    var y$1 = array.u[1];
    var $x_10 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$1);
    var y$2 = array.u[2];
    var $x_9 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$2);
    var y$3 = array.u[3];
    var $x_8 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$3);
    var y$4 = array.u[4];
    var $x_7 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$4);
    var y$5 = array.u[5];
    var $x_6 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$5);
    var y$6 = array.u[6];
    var $x_5 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$6);
    var y$7 = array.u[7];
    var $x_4 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(8, 0), y$7);
    var y$8 = array.u[8];
    var $x_3 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(9, 0), y$8);
    var y$9 = array.u[9];
    var $x_2 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(10, 0), y$9);
    var y$10 = array.u[10];
    var $x_1 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(11, 0), y$10);
    var y$11 = array.u[11];
    var elems = $x_12.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_11, $x_10, $x_9, $x_8, $x_7, $x_6, $x_5, $x_4, $x_3, $x_2, $x_1, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(12, 0), y$11)]));
    var mapF = this$25.from__sc_IterableOnce__sci_Map(elems);
    var this$62 = $m_sci_Map$();
    var $x_24 = $m_sr_ScalaRunTime$();
    var this$27 = array.u[0];
    var y$12 = this$27.substring(0, 1);
    var $x_23 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$12);
    var this$30 = array.u[1];
    var y$13 = this$30.substring(0, 1);
    var $x_22 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$13);
    var this$33 = array.u[2];
    var y$14 = this$33.substring(0, 1);
    var $x_21 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$14);
    var this$36 = array.u[3];
    var y$15 = this$36.substring(0, 1);
    var $x_20 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$15);
    var this$39 = array.u[4];
    var y$16 = this$39.substring(0, 1);
    var $x_19 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$16);
    var this$42 = array.u[5];
    var y$17 = this$42.substring(0, 1);
    var $x_18 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$17);
    var this$45 = array.u[6];
    var y$18 = this$45.substring(0, 1);
    var $x_17 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$18);
    var this$48 = array.u[7];
    var y$19 = this$48.substring(0, 1);
    var $x_16 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(8, 0), y$19);
    var this$51 = array.u[8];
    var y$20 = this$51.substring(0, 1);
    var $x_15 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(9, 0), y$20);
    var this$54 = array.u[9];
    var y$21 = this$54.substring(0, 1);
    var $x_14 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(10, 0), y$21);
    var this$57 = array.u[10];
    var y$22 = this$57.substring(0, 1);
    var $x_13 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(11, 0), y$22);
    var this$60 = array.u[11];
    var y$23 = this$60.substring(0, 1);
    var elems$1 = $x_24.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_23, $x_22, $x_21, $x_20, $x_19, $x_18, $x_17, $x_16, $x_15, $x_14, $x_13, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(12, 0), y$23)]));
    var mapN = this$62.from__sc_IterableOnce__sci_Map(elems$1);
    array = oldSymbols.Ljava_text_DateFormatSymbols__f_shortMonths;
    var this$87 = $m_sci_Map$();
    var $x_36 = $m_sr_ScalaRunTime$();
    var y$24 = array.u[0];
    var $x_35 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$24);
    var y$25 = array.u[1];
    var $x_34 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$25);
    var y$26 = array.u[2];
    var $x_33 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$26);
    var y$27 = array.u[3];
    var $x_32 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$27);
    var y$28 = array.u[4];
    var $x_31 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$28);
    var y$29 = array.u[5];
    var $x_30 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$29);
    var y$30 = array.u[6];
    var $x_29 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$30);
    var y$31 = array.u[7];
    var $x_28 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(8, 0), y$31);
    var y$32 = array.u[8];
    var $x_27 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(9, 0), y$32);
    var y$33 = array.u[9];
    var $x_26 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(10, 0), y$33);
    var y$34 = array.u[10];
    var $x_25 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(11, 0), y$34);
    var y$35 = array.u[11];
    var elems$2 = $x_36.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_35, $x_34, $x_33, $x_32, $x_31, $x_30, $x_29, $x_28, $x_27, $x_26, $x_25, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(12, 0), y$35)]));
    var mapS = this$87.from__sc_IterableOnce__sci_Map(elems$2);
    var this$94 = $m_sci_Map$();
    var $x_39 = $m_sr_ScalaRunTime$();
    var self = $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle();
    var $x_38 = $ct_T2__O__O__(new $c_T2(), self, mapF);
    var self$1 = $s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle();
    var $x_37 = $ct_T2__O__O__(new $c_T2(), self$1, mapN);
    var self$2 = $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle();
    var elems$3 = $x_39.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_38, $x_37, $ct_T2__O__O__(new $c_T2(), self$2, mapS)]));
    var styleMap = this$94.from__sc_IterableOnce__sci_Map(elems$3);
    return $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$().java$time$format$internal$TTBPSimpleDateTimeTextProvider$$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(styleMap);
  }
  if ((field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    var oldSymbols$2 = $m_Ljava_text_DateFormatSymbols$().getInstance__ju_Locale__Ljava_text_DateFormatSymbols(locale);
    var array$2 = oldSymbols$2.Ljava_text_DateFormatSymbols__f_weekdays;
    var this$109 = $m_sci_Map$();
    var $x_46 = $m_sr_ScalaRunTime$();
    var y$36 = array$2.u[2];
    var $x_45 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$36);
    var y$37 = array$2.u[3];
    var $x_44 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$37);
    var y$38 = array$2.u[4];
    var $x_43 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$38);
    var y$39 = array$2.u[5];
    var $x_42 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$39);
    var y$40 = array$2.u[6];
    var $x_41 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$40);
    var y$41 = array$2.u[7];
    var $x_40 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$41);
    var y$42 = array$2.u[1];
    var elems$4 = $x_46.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_45, $x_44, $x_43, $x_42, $x_41, $x_40, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$42)]));
    var mapF$2 = this$109.from__sc_IterableOnce__sci_Map(elems$4);
    var this$131 = $m_sci_Map$();
    var $x_53 = $m_sr_ScalaRunTime$();
    var this$111 = array$2.u[2];
    var y$43 = this$111.substring(0, 1);
    var $x_52 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$43);
    var this$114 = array$2.u[3];
    var y$44 = this$114.substring(0, 1);
    var $x_51 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$44);
    var this$117 = array$2.u[4];
    var y$45 = this$117.substring(0, 1);
    var $x_50 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$45);
    var this$120 = array$2.u[5];
    var y$46 = this$120.substring(0, 1);
    var $x_49 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$46);
    var this$123 = array$2.u[6];
    var y$47 = this$123.substring(0, 1);
    var $x_48 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$47);
    var this$126 = array$2.u[7];
    var y$48 = this$126.substring(0, 1);
    var $x_47 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$48);
    var this$129 = array$2.u[1];
    var y$49 = this$129.substring(0, 1);
    var elems$5 = $x_53.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_52, $x_51, $x_50, $x_49, $x_48, $x_47, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$49)]));
    var mapN$2 = this$131.from__sc_IterableOnce__sci_Map(elems$5);
    array$2 = oldSymbols$2.Ljava_text_DateFormatSymbols__f_shortWeekdays;
    var this$146 = $m_sci_Map$();
    var $x_60 = $m_sr_ScalaRunTime$();
    var y$50 = array$2.u[2];
    var $x_59 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$50);
    var y$51 = array$2.u[3];
    var $x_58 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), y$51);
    var y$52 = array$2.u[4];
    var $x_57 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), y$52);
    var y$53 = array$2.u[5];
    var $x_56 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), y$53);
    var y$54 = array$2.u[6];
    var $x_55 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(5, 0), y$54);
    var y$55 = array$2.u[7];
    var $x_54 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(6, 0), y$55);
    var y$56 = array$2.u[1];
    var elems$6 = $x_60.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_59, $x_58, $x_57, $x_56, $x_55, $x_54, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(7, 0), y$56)]));
    var mapS$2 = this$146.from__sc_IterableOnce__sci_Map(elems$6);
    var this$153 = $m_sci_Map$();
    var $x_63 = $m_sr_ScalaRunTime$();
    var self$3 = $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle();
    var $x_62 = $ct_T2__O__O__(new $c_T2(), self$3, mapF$2);
    var self$4 = $s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle();
    var $x_61 = $ct_T2__O__O__(new $c_T2(), self$4, mapN$2);
    var self$5 = $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle();
    var elems$7 = $x_63.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_62, $x_61, $ct_T2__O__O__(new $c_T2(), self$5, mapS$2)]));
    var styleMap$2 = this$153.from__sc_IterableOnce__sci_Map(elems$7);
    return $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$().java$time$format$internal$TTBPSimpleDateTimeTextProvider$$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(styleMap$2);
  }
  if ((field === $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var oldSymbols$3 = $m_Ljava_text_DateFormatSymbols$().getInstance__ju_Locale__Ljava_text_DateFormatSymbols(locale);
    var array$3 = oldSymbols$3.Ljava_text_DateFormatSymbols__f_amPmStrings;
    var this$158 = $m_sci_Map$();
    var $x_65 = $m_sr_ScalaRunTime$();
    var y$57 = array$3.u[0];
    var $x_64 = $ct_T2__O__O__(new $c_T2(), $L0, y$57);
    var y$58 = array$3.u[1];
    var elems$8 = $x_65.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_64, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$58)]));
    var map = this$158.from__sc_IterableOnce__sci_Map(elems$8);
    var this$163 = $m_sci_Map$();
    var $x_67 = $m_sr_ScalaRunTime$();
    var self$6 = $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle();
    var $x_66 = $ct_T2__O__O__(new $c_T2(), self$6, map);
    var self$7 = $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle();
    var elems$9 = $x_67.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_66, $ct_T2__O__O__(new $c_T2(), self$7, map)]));
    var styleMap$3 = this$163.from__sc_IterableOnce__sci_Map(elems$9);
    return $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$().java$time$format$internal$TTBPSimpleDateTimeTextProvider$$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(styleMap$3);
  }
  if ((field === $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField())) {
    var oldSymbols$4 = $m_Ljava_text_DateFormatSymbols$().getInstance__ju_Locale__Ljava_text_DateFormatSymbols(locale);
    var array$4 = oldSymbols$4.Ljava_text_DateFormatSymbols__f_eras;
    var this$168 = $m_sci_Map$();
    var $x_69 = $m_sr_ScalaRunTime$();
    var y$59 = array$4.u[0];
    var $x_68 = $ct_T2__O__O__(new $c_T2(), $L0, y$59);
    var y$60 = array$4.u[1];
    var elems$10 = $x_69.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_68, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$60)]));
    var mapS$3 = this$168.from__sc_IterableOnce__sci_Map(elems$10);
    if ((locale.getLanguage__T() === $m_ju_Locale$().ENGLISH__ju_Locale().getLanguage__T())) {
      var this$173 = $m_sci_Map$();
      var elems$11 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), $L0, "Before Christ"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), "Anno Domini")]));
      var mapF$3 = this$173.from__sc_IterableOnce__sci_Map(elems$11);
    } else {
      var mapF$3 = mapS$3;
    }
    var this$180 = $m_sci_Map$();
    var $x_71 = $m_sr_ScalaRunTime$();
    var this$175 = array$4.u[0];
    var y$61 = this$175.substring(0, 1);
    var $x_70 = $ct_T2__O__O__(new $c_T2(), $L0, y$61);
    var this$178 = array$4.u[1];
    var y$62 = this$178.substring(0, 1);
    var elems$12 = $x_71.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_70, $ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), y$62)]));
    var mapN$3 = this$180.from__sc_IterableOnce__sci_Map(elems$12);
    var this$187 = $m_sci_Map$();
    var $x_74 = $m_sr_ScalaRunTime$();
    var self$8 = $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle();
    var $x_73 = $ct_T2__O__O__(new $c_T2(), self$8, mapS$3);
    var self$9 = $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle();
    var $x_72 = $ct_T2__O__O__(new $c_T2(), self$9, mapF$3);
    var self$10 = $s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle();
    var elems$13 = $x_74.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_73, $x_72, $ct_T2__O__O__(new $c_T2(), self$10, mapN$3)]));
    var styleMap$4 = this$187.from__sc_IterableOnce__sci_Map(elems$13);
    return $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$().java$time$format$internal$TTBPSimpleDateTimeTextProvider$$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(styleMap$4);
  }
  if ((field === $m_Ljava_time_temporal_IsoFields$().QUARTER_OF_YEAR__Ljava_time_temporal_TemporalField())) {
    var this$196 = $m_sci_Map$();
    var elems$14 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), "Q1"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), "Q2"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), "Q3"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), "Q4")]));
    var mapS$4 = this$196.from__sc_IterableOnce__sci_Map(elems$14);
    var this$205 = $m_sci_Map$();
    var elems$15 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), new $c_RTLong(1, 0), "1st quarter"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(2, 0), "2nd quarter"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(3, 0), "3rd quarter"), $ct_T2__O__O__(new $c_T2(), new $c_RTLong(4, 0), "4th quarter")]));
    var mapF$4 = this$205.from__sc_IterableOnce__sci_Map(elems$15);
    var this$210 = $m_sci_Map$();
    var $x_76 = $m_sr_ScalaRunTime$();
    var self$11 = $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle();
    var $x_75 = $ct_T2__O__O__(new $c_T2(), self$11, mapS$4);
    var self$12 = $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle();
    var elems$16 = $x_76.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_75, $ct_T2__O__O__(new $c_T2(), self$12, mapF$4)]));
    var styleMap$5 = this$210.from__sc_IterableOnce__sci_Map(elems$16);
    return $m_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$().java$time$format$internal$TTBPSimpleDateTimeTextProvider$$$createLocaleStore__sci_Map__Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(styleMap$5);
  }
  return "";
}
export { $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__createStore__Ljava_time_temporal_TemporalField__ju_Locale__O as $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__createStore__Ljava_time_temporal_TemporalField__ju_Locale__O };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider() {
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__f_cache = null;
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__f_cache = $ct_ju_HashMap__(new $c_ju_HashMap());
}
export { $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider as $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider };
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeTextProvider();
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype.constructor = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider() {
}
export { $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider as $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider };
$h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype;
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype.getText__Ljava_time_temporal_TemporalField__J__Ljava_time_format_TextStyle__ju_Locale__T = (function(field, value, style, locale) {
  var x1 = $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__findStore__Ljava_time_temporal_TemporalField__ju_Locale__O(this, field, locale);
  if ((x1 instanceof $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore)) {
    return x1.getText__J__Ljava_time_format_TextStyle__T(value, style);
  }
  return null;
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider.prototype.getTextIterator__Ljava_time_temporal_TemporalField__Ljava_time_format_TextStyle__ju_Locale__sc_Iterator = (function(field, style, locale) {
  var x3 = $p_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider__findStore__Ljava_time_temporal_TemporalField__ju_Locale__O(this, field, locale);
  if ((x3 instanceof $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore)) {
    return x3.getTextIterator__Ljava_time_format_TextStyle__sc_Iterator(style);
  }
  return null;
});
var $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider, "java.time.format.internal.TTBPSimpleDateTimeTextProvider", ({
  Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider: 1,
  Ljava_time_format_internal_TTBPDateTimeTextProvider: 1
}));
export { $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider as $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider };
/** @constructor */
function $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(relative, dayOfWeek) {
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative = 0;
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue = 0;
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative = relative;
  if ((dayOfWeek === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "dayOfWeek");
  }
  this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue = dayOfWeek.getValue__I();
}
export { $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek as $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek };
$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype.constructor = $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek;
/** @constructor */
function $h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek() {
}
export { $h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek as $h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek };
$h_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype = $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype;
$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var calDow = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  if (((this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative < 2) && (calDow === this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue))) {
    return temporal;
  } else if (((1 & this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_relative) === 0)) {
    var daysDiff = ((calDow - this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue) | 0);
    if ((daysDiff >= 0)) {
      var hi = (daysDiff >> 31);
      var lo = ((7 - daysDiff) | 0);
      var hi$1 = ((((-hi) | 0) + ((daysDiff | lo) >> 31)) | 0);
      var x__lo = lo;
      var x__hi = hi$1;
    } else {
      var hi$2 = (daysDiff >> 31);
      var lo$1 = ((-daysDiff) | 0);
      var hi$3 = ((((-hi$2) | 0) + ((daysDiff | lo$1) >> 31)) | 0);
      var x__lo = lo$1;
      var x__hi = hi$3;
    }
    return temporal.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(x__lo, x__hi), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit());
  } else {
    var daysDiff$2 = ((this.Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek__f_dowValue - calDow) | 0);
    if ((daysDiff$2 >= 0)) {
      var hi$4 = (daysDiff$2 >> 31);
      var lo$2 = ((7 - daysDiff$2) | 0);
      var hi$5 = ((((-hi$4) | 0) + ((daysDiff$2 | lo$2) >> 31)) | 0);
      var x$1__lo = lo$2;
      var x$1__hi = hi$5;
    } else {
      var hi$6 = (daysDiff$2 >> 31);
      var lo$3 = ((-daysDiff$2) | 0);
      var hi$7 = ((((-hi$6) | 0) + ((daysDiff$2 | lo$3) >> 31)) | 0);
      var x$1__lo = lo$3;
      var x$1__hi = hi$7;
    }
    return temporal.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(x$1__lo, x$1__hi), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit());
  }
});
var $d_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek = new $TypeData().initClass($c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek, "java.time.temporal.TemporalAdjusters$RelativeDayOfWeek", ({
  Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek: 1,
  Ljava_time_temporal_TemporalAdjuster: 1
}));
export { $d_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek as $d_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$1 as $c_Ljava_time_temporal_TemporalQueries$$anon$1 };
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$1() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$1 as $h_Ljava_time_temporal_TemporalQueries$$anon$1 };
$h_Ljava_time_temporal_TemporalQueries$$anon$1.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$1.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return temporal.query__Ljava_time_temporal_TemporalQuery__O(this);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$1 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$1, "java.time.temporal.TemporalQueries$$anon$1", ({
  Ljava_time_temporal_TemporalQueries$$anon$1: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$1 as $d_Ljava_time_temporal_TemporalQueries$$anon$1 };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$2(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$2 as $c_Ljava_time_temporal_TemporalQueries$$anon$2 };
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$2() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$2 as $h_Ljava_time_temporal_TemporalQueries$$anon$2 };
$h_Ljava_time_temporal_TemporalQueries$$anon$2.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$2.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return temporal.query__Ljava_time_temporal_TemporalQuery__O(this);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$2 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$2, "java.time.temporal.TemporalQueries$$anon$2", ({
  Ljava_time_temporal_TemporalQueries$$anon$2: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$2 as $d_Ljava_time_temporal_TemporalQueries$$anon$2 };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$3(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$3 as $c_Ljava_time_temporal_TemporalQueries$$anon$3 };
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$3() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$3 as $h_Ljava_time_temporal_TemporalQueries$$anon$3 };
$h_Ljava_time_temporal_TemporalQueries$$anon$3.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$3.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return temporal.query__Ljava_time_temporal_TemporalQuery__O(this);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$3 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$3, "java.time.temporal.TemporalQueries$$anon$3", ({
  Ljava_time_temporal_TemporalQueries$$anon$3: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$3 as $d_Ljava_time_temporal_TemporalQueries$$anon$3 };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$4(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$4 as $c_Ljava_time_temporal_TemporalQueries$$anon$4 };
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$4() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$4 as $h_Ljava_time_temporal_TemporalQueries$$anon$4 };
$h_Ljava_time_temporal_TemporalQueries$$anon$4.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset = (function(temporal) {
  return (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()) ? $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) : null);
});
$c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneOffset(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$4 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$4, "java.time.temporal.TemporalQueries$$anon$4", ({
  Ljava_time_temporal_TemporalQueries$$anon$4: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$4 as $d_Ljava_time_temporal_TemporalQueries$$anon$4 };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$5(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$5 as $c_Ljava_time_temporal_TemporalQueries$$anon$5 };
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$5() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$5 as $h_Ljava_time_temporal_TemporalQueries$$anon$5 };
$h_Ljava_time_temporal_TemporalQueries$$anon$5.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId = (function(temporal) {
  var zone = temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery());
  return ((zone !== null) ? zone : temporal.query__Ljava_time_temporal_TemporalQuery__O($m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery()));
});
$c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZoneId(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$5 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$5, "java.time.temporal.TemporalQueries$$anon$5", ({
  Ljava_time_temporal_TemporalQueries$$anon$5: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$5 as $d_Ljava_time_temporal_TemporalQueries$$anon$5 };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$6(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$6 as $c_Ljava_time_temporal_TemporalQueries$$anon$6 };
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$6() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$6 as $h_Ljava_time_temporal_TemporalQueries$$anon$6 };
$h_Ljava_time_temporal_TemporalQueries$$anon$6.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate = (function(temporal) {
  return (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField()) ? $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) : null);
});
$c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$6 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$6, "java.time.temporal.TemporalQueries$$anon$6", ({
  Ljava_time_temporal_TemporalQueries$$anon$6: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$6 as $d_Ljava_time_temporal_TemporalQueries$$anon$6 };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$7(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$7 as $c_Ljava_time_temporal_TemporalQueries$$anon$7 };
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype = new $h_O();
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$7() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$7 as $h_Ljava_time_temporal_TemporalQueries$$anon$7 };
$h_Ljava_time_temporal_TemporalQueries$$anon$7.prototype = $c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype;
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime = (function(temporal) {
  return (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField()) ? $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField())) : null);
});
$c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype.queryFrom__Ljava_time_temporal_TemporalAccessor__O = (function(temporal) {
  return this.queryFrom__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$7 = new $TypeData().initClass($c_Ljava_time_temporal_TemporalQueries$$anon$7, "java.time.temporal.TemporalQueries$$anon$7", ({
  Ljava_time_temporal_TemporalQueries$$anon$7: 1,
  Ljava_time_temporal_TemporalQuery: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$7 as $d_Ljava_time_temporal_TemporalQueries$$anon$7 };
/** @constructor */
function $c_Ljava_time_temporal_ValueRange(minSmallest, minLargest, maxSmallest, maxLargest) {
  this.Ljava_time_temporal_ValueRange__f_minSmallest = $L0;
  this.Ljava_time_temporal_ValueRange__f_minLargest = $L0;
  this.Ljava_time_temporal_ValueRange__f_maxSmallest = $L0;
  this.Ljava_time_temporal_ValueRange__f_maxLargest = $L0;
  this.Ljava_time_temporal_ValueRange__f_minSmallest = minSmallest;
  this.Ljava_time_temporal_ValueRange__f_minLargest = minLargest;
  this.Ljava_time_temporal_ValueRange__f_maxSmallest = maxSmallest;
  this.Ljava_time_temporal_ValueRange__f_maxLargest = maxLargest;
}
export { $c_Ljava_time_temporal_ValueRange as $c_Ljava_time_temporal_ValueRange };
$c_Ljava_time_temporal_ValueRange.prototype = new $h_O();
$c_Ljava_time_temporal_ValueRange.prototype.constructor = $c_Ljava_time_temporal_ValueRange;
/** @constructor */
function $h_Ljava_time_temporal_ValueRange() {
}
export { $h_Ljava_time_temporal_ValueRange as $h_Ljava_time_temporal_ValueRange };
$h_Ljava_time_temporal_ValueRange.prototype = $c_Ljava_time_temporal_ValueRange.prototype;
$c_Ljava_time_temporal_ValueRange.prototype.isFixed__Z = (function() {
  var a = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var b = this.Ljava_time_temporal_ValueRange__f_minLargest;
  if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
    var a$1 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
    var b$1 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
    return ((a$1.RTLong__f_lo === b$1.RTLong__f_lo) && (a$1.RTLong__f_hi === b$1.RTLong__f_hi));
  } else {
    return false;
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.isIntValue__Z = (function() {
  var a = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var ahi = a.RTLong__f_hi;
  if (((ahi === (-1)) ? ((a.RTLong__f_lo >>> 0) >= 2147483648) : (ahi > (-1)))) {
    var a$1 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
    var ahi$1 = a$1.RTLong__f_hi;
    return ((ahi$1 === 0) ? ((a$1.RTLong__f_lo >>> 0) <= 2147483647) : (ahi$1 < 0));
  } else {
    return false;
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.isValidValue__J__Z = (function(value) {
  var b = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var ahi = value.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? ((value.RTLong__f_lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
    var b$1 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
    var ahi$1 = value.RTLong__f_hi;
    var bhi$1 = b$1.RTLong__f_hi;
    return ((ahi$1 === bhi$1) ? ((value.RTLong__f_lo >>> 0) <= (b$1.RTLong__f_lo >>> 0)) : (ahi$1 < bhi$1));
  } else {
    return false;
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.isValidIntValue__J__Z = (function(value) {
  return (this.isIntValue__Z() && this.isValidValue__J__Z(value));
});
$c_Ljava_time_temporal_ValueRange.prototype.checkValidValue__J__Ljava_time_temporal_TemporalField__J = (function(value, field) {
  if ((!this.isValidValue__J__Z(value))) {
    if ((field !== null)) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Invalid value for " + field) + " (valid values ") + this) + "): ") + value));
    } else {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid value (valid values " + this) + "): ") + value));
    }
  } else {
    return value;
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I = (function(value, field) {
  if ((!this.isValidIntValue__J__Z(value))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((("Invalid int value for " + field) + ": ") + value));
  } else {
    return value.RTLong__f_lo;
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_temporal_ValueRange)) {
    if ((this === obj)) {
      return true;
    } else {
      var a = this.Ljava_time_temporal_ValueRange__f_minSmallest;
      var b = obj.Ljava_time_temporal_ValueRange__f_minSmallest;
      if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
        var a$1 = this.Ljava_time_temporal_ValueRange__f_minLargest;
        var b$1 = obj.Ljava_time_temporal_ValueRange__f_minLargest;
        var $x_2 = ((a$1.RTLong__f_lo === b$1.RTLong__f_lo) && (a$1.RTLong__f_hi === b$1.RTLong__f_hi));
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        var a$2 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
        var b$2 = obj.Ljava_time_temporal_ValueRange__f_maxSmallest;
        var $x_1 = ((a$2.RTLong__f_lo === b$2.RTLong__f_lo) && (a$2.RTLong__f_hi === b$2.RTLong__f_hi));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var a$3 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
        var b$3 = obj.Ljava_time_temporal_ValueRange__f_maxLargest;
        return ((a$3.RTLong__f_lo === b$3.RTLong__f_lo) && (a$3.RTLong__f_hi === b$3.RTLong__f_hi));
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_temporal_ValueRange.prototype.hashCode__I = (function() {
  var a = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var b = this.Ljava_time_temporal_ValueRange__f_minLargest;
  var alo = a.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var lo = ((alo + blo) | 0);
  var hi = ((((a.RTLong__f_hi + b.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
  var b$1 = this.Ljava_time_temporal_ValueRange__f_minLargest;
  var blo$1 = b$1.RTLong__f_lo;
  var lo$1 = ((16 + blo$1) | 0);
  var lo$2 = (((32 & lo$1) === 0) ? (lo << lo$1) : 0);
  var hi$2 = (((32 & lo$1) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - lo$1) | 0)) | 0) | (hi << lo$1)) : (lo << lo$1));
  var b$2 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
  var blo$2 = b$2.RTLong__f_lo;
  var lo$3 = ((48 + blo$2) | 0);
  var lo$4 = (((32 & lo$3) === 0) ? (((lo$2 >>> lo$3) | 0) | ((hi$2 << 1) << ((31 - lo$3) | 0))) : (hi$2 >> lo$3));
  var hi$4 = (((32 & lo$3) === 0) ? (hi$2 >> lo$3) : (hi$2 >> 31));
  var b$3 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
  var blo$3 = b$3.RTLong__f_lo;
  var lo$5 = ((32 + blo$3) | 0);
  var lo$6 = (((32 & lo$5) === 0) ? (lo$4 << lo$5) : 0);
  var hi$6 = (((32 & lo$5) === 0) ? (((((lo$4 >>> 1) | 0) >>> ((31 - lo$5) | 0)) | 0) | (hi$4 << lo$5)) : (lo$4 << lo$5));
  var b$4 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
  var blo$4 = b$4.RTLong__f_lo;
  var lo$7 = ((32 + blo$4) | 0);
  var lo$8 = (((32 & lo$7) === 0) ? (((lo$6 >>> lo$7) | 0) | ((hi$6 << 1) << ((31 - lo$7) | 0))) : (hi$6 >> lo$7));
  var hi$8 = (((32 & lo$7) === 0) ? (hi$6 >> lo$7) : (hi$6 >> 31));
  var b$5 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
  var blo$5 = b$5.RTLong__f_lo;
  var lo$9 = ((48 + blo$5) | 0);
  var lo$10 = (((32 & lo$9) === 0) ? (lo$8 << lo$9) : 0);
  var hi$10 = (((32 & lo$9) === 0) ? (((((lo$8 >>> 1) | 0) >>> ((31 - lo$9) | 0)) | 0) | (hi$8 << lo$9)) : (lo$8 << lo$9));
  var lo$11 = (((lo$10 >>> 16) | 0) | (hi$10 << 16));
  var hi$11 = (hi$10 >> 16);
  var lo$12 = (lo$11 ^ hi$11);
  return lo$12;
});
$c_Ljava_time_temporal_ValueRange.prototype.toString__T = (function() {
  var a = this.Ljava_time_temporal_ValueRange__f_minSmallest;
  var b = this.Ljava_time_temporal_ValueRange__f_minLargest;
  if ((!((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi)))) {
    var ss = ("/" + this.Ljava_time_temporal_ValueRange__f_minLargest);
  } else {
    var ss = "";
  }
  var a$1 = this.Ljava_time_temporal_ValueRange__f_maxSmallest;
  var b$1 = this.Ljava_time_temporal_ValueRange__f_maxLargest;
  if ((!((a$1.RTLong__f_lo === b$1.RTLong__f_lo) && (a$1.RTLong__f_hi === b$1.RTLong__f_hi)))) {
    var sl = ("/" + this.Ljava_time_temporal_ValueRange__f_maxLargest);
  } else {
    var sl = "";
  }
  return ((((this.Ljava_time_temporal_ValueRange__f_minSmallest + ss) + " - ") + this.Ljava_time_temporal_ValueRange__f_maxSmallest) + sl);
});
function $isArrayOf_Ljava_time_temporal_ValueRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ValueRange)));
}
export { $isArrayOf_Ljava_time_temporal_ValueRange as $isArrayOf_Ljava_time_temporal_ValueRange };
var $d_Ljava_time_temporal_ValueRange = new $TypeData().initClass($c_Ljava_time_temporal_ValueRange, "java.time.temporal.ValueRange", ({
  Ljava_time_temporal_ValueRange: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_temporal_ValueRange as $d_Ljava_time_temporal_ValueRange };
/** @constructor */
function $c_Ljava_time_temporal_WeekFields(firstDayOfWeek, minimalDays) {
  this.Ljava_time_temporal_WeekFields__f_firstDayOfWeek = null;
  this.Ljava_time_temporal_WeekFields__f_minimalDays = 0;
  this.Ljava_time_temporal_WeekFields__f_dayOfWeek = null;
  this.Ljava_time_temporal_WeekFields__f_weekOfMonth = null;
  this.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear = null;
  this.Ljava_time_temporal_WeekFields__f_weekBasedYear = null;
  this.Ljava_time_temporal_WeekFields__f_firstDayOfWeek = firstDayOfWeek;
  this.Ljava_time_temporal_WeekFields__f_minimalDays = minimalDays;
  if ((firstDayOfWeek === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "firstDayOfWeek");
  }
  if (((minimalDays < 1) || (minimalDays > 7))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Minimal number of days is invalid");
  }
  this.Ljava_time_temporal_WeekFields__f_dayOfWeek = new $c_Ljava_time_temporal_WeekFields$ComputedDayOfField("DayOfWeek", this, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(7, 0)));
  this.Ljava_time_temporal_WeekFields__f_weekOfMonth = new $c_Ljava_time_temporal_WeekFields$ComputedDayOfField("WeekOfMonth", this, $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1, 0), new $c_RTLong(4, 0), new $c_RTLong(6, 0)));
  $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  $m_Ljava_time_temporal_ValueRange$().of__J__J__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1, 0), new $c_RTLong(52, 0), new $c_RTLong(54, 0));
  var $x_2 = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
  var $x_1 = $m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit();
  var this$6 = $m_Ljava_time_temporal_ValueRange$();
  this.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear = new $c_Ljava_time_temporal_WeekFields$ComputedDayOfField("WeekOfYWeekBasedYear", this, $x_2, $x_1, this$6.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(52, 0), new $c_RTLong(53, 0)));
  var $x_4 = $m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit();
  var $x_3 = $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
  var this$8 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  this.Ljava_time_temporal_WeekFields__f_weekBasedYear = new $c_Ljava_time_temporal_WeekFields$ComputedDayOfField("WeekBasedYear", this, $x_4, $x_3, this$8.Ljava_time_temporal_ChronoField__f__range);
}
export { $c_Ljava_time_temporal_WeekFields as $c_Ljava_time_temporal_WeekFields };
$c_Ljava_time_temporal_WeekFields.prototype = new $h_O();
$c_Ljava_time_temporal_WeekFields.prototype.constructor = $c_Ljava_time_temporal_WeekFields;
/** @constructor */
function $h_Ljava_time_temporal_WeekFields() {
}
export { $h_Ljava_time_temporal_WeekFields as $h_Ljava_time_temporal_WeekFields };
$h_Ljava_time_temporal_WeekFields.prototype = $c_Ljava_time_temporal_WeekFields.prototype;
$c_Ljava_time_temporal_WeekFields.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_Ljava_time_temporal_WeekFields) && ((this === that) || (this.hashCode__I() === that.hashCode__I())));
});
$c_Ljava_time_temporal_WeekFields.prototype.hashCode__I = (function() {
  return ((Math.imul(7, this.Ljava_time_temporal_WeekFields__f_firstDayOfWeek.jl_Enum__f__ordinal) + this.Ljava_time_temporal_WeekFields__f_minimalDays) | 0);
});
$c_Ljava_time_temporal_WeekFields.prototype.toString__T = (function() {
  return (((("WeekFields[" + this.Ljava_time_temporal_WeekFields__f_firstDayOfWeek) + ",") + this.Ljava_time_temporal_WeekFields__f_minimalDays) + "]");
});
function $isArrayOf_Ljava_time_temporal_WeekFields(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_WeekFields)));
}
export { $isArrayOf_Ljava_time_temporal_WeekFields as $isArrayOf_Ljava_time_temporal_WeekFields };
var $d_Ljava_time_temporal_WeekFields = new $TypeData().initClass($c_Ljava_time_temporal_WeekFields, "java.time.temporal.WeekFields", ({
  Ljava_time_temporal_WeekFields: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_temporal_WeekFields as $d_Ljava_time_temporal_WeekFields };
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I($thiz, temporal, sow) {
  var isoDow = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var a = ((isoDow - sow) | 0);
  var rem = ((a % 7) | 0);
  return ((1 + ((((7 ^ a) >= 0) || (rem === 0)) ? rem : ((7 + rem) | 0))) | 0);
}
export { $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I as $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I };
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfMonth__Ljava_time_temporal_TemporalAccessor__I__J($thiz, temporal, dow) {
  var dom = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
  var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, dom, dow);
  var value = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, dom);
  var hi = (value >> 31);
  return new $c_RTLong(value, hi);
}
export { $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfMonth__Ljava_time_temporal_TemporalAccessor__I__J as $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfMonth__Ljava_time_temporal_TemporalAccessor__I__J };
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J($thiz, temporal, dow) {
  var doy = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField());
  var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, doy, dow);
  var value = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, doy);
  var hi = (value >> 31);
  return new $c_RTLong(value, hi);
}
export { $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J as $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J };
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWOWBY__Ljava_time_temporal_TemporalAccessor__I($thiz, temporal) {
  var this$1 = $thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
  var sow = this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek.getValue__I();
  var isoDow = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var a = ((isoDow - sow) | 0);
  var rem = ((a % 7) | 0);
  var dow = ((1 + ((((7 ^ a) >= 0) || (rem === 0)) ? rem : ((7 + rem) | 0))) | 0);
  var t = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J($thiz, temporal, dow);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (((lo === 0) && (hi === 0))) {
    var this$5 = ($m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(temporal), $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal));
    var unit = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
    var previous = this$5.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(1, 0), unit);
    var a$1 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J($thiz, previous, dow);
    return ((1 + a$1.RTLong__f_lo) | 0);
  } else if (((hi === 0) ? ((lo >>> 0) >= 53) : (hi > 0))) {
    var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField()), dow);
    var year = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
    var $x_1 = $m_Ljava_time_Year$();
    var hi$1 = (year >> 31);
    if ($x_1.isLeap__J__Z(new $c_RTLong(year, hi$1))) {
      var yearLen = 366;
    } else {
      var yearLen = 365;
    }
    var this$9 = $thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
    var weekIndexOfFirstWeekNextYear = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, ((yearLen + this$9.Ljava_time_temporal_WeekFields__f_minimalDays) | 0));
    var hi$2 = (weekIndexOfFirstWeekNextYear >> 31);
    if (((hi === hi$2) ? ((lo >>> 0) >= (weekIndexOfFirstWeekNextYear >>> 0)) : (hi > hi$2))) {
      var value = (((-1) + weekIndexOfFirstWeekNextYear) | 0);
      var lo$1 = ((lo - value) | 0);
      return lo$1;
    }
  }
  return lo;
}
export { $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWOWBY__Ljava_time_temporal_TemporalAccessor__I as $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWOWBY__Ljava_time_temporal_TemporalAccessor__I };
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWBY__Ljava_time_temporal_TemporalAccessor__I($thiz, temporal) {
  var this$1 = $thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
  var sow = this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek.getValue__I();
  var isoDow = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var a = ((isoDow - sow) | 0);
  var rem = ((a % 7) | 0);
  var dow = ((1 + ((((7 ^ a) >= 0) || (rem === 0)) ? rem : ((7 + rem) | 0))) | 0);
  var year = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
  var t = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J($thiz, temporal, dow);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (((lo === 0) && (hi === 0))) {
    return (((-1) + year) | 0);
  } else if (((hi === 0) ? ((lo >>> 0) < 53) : (hi < 0))) {
    return year;
  }
  var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField()), dow);
  var $x_1 = $m_Ljava_time_Year$();
  var hi$1 = (year >> 31);
  if ($x_1.isLeap__J__Z(new $c_RTLong(year, hi$1))) {
    var yearLen = 366;
  } else {
    var yearLen = 365;
  }
  var this$6 = $thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
  var weekIndexOfFirstWeekNextYear = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, ((yearLen + this$6.Ljava_time_temporal_WeekFields__f_minimalDays) | 0));
  var hi$2 = (weekIndexOfFirstWeekNextYear >> 31);
  if (((hi === hi$2) ? ((lo >>> 0) >= (weekIndexOfFirstWeekNextYear >>> 0)) : (hi > hi$2))) {
    return ((1 + year) | 0);
  }
  return year;
}
export { $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWBY__Ljava_time_temporal_TemporalAccessor__I as $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWBY__Ljava_time_temporal_TemporalAccessor__I };
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, day, dow) {
  var a = ((day - dow) | 0);
  var rem = ((a % 7) | 0);
  var weekStart = ((((7 ^ a) >= 0) || (rem === 0)) ? rem : ((7 + rem) | 0));
  var offset = ((-weekStart) | 0);
  var this$2 = $thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
  if ((((1 + weekStart) | 0) > this$2.Ljava_time_temporal_WeekFields__f_minimalDays)) {
    offset = ((7 - weekStart) | 0);
  }
  return offset;
}
export { $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I as $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I };
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, day) {
  return ((((((7 + offset) | 0) + (((-1) + day) | 0)) | 0) / 7) | 0);
}
export { $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I as $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I };
function $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__rangeWOWBY__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange($thiz, temporal) {
  var temporal$tailLocal1 = temporal;
  while (true) {
    var this$1 = $thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
    var sow = this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek.getValue__I();
    var isoDow = temporal$tailLocal1.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
    var a = ((isoDow - sow) | 0);
    var rem = ((a % 7) | 0);
    var dow = ((1 + ((((7 ^ a) >= 0) || (rem === 0)) ? rem : ((7 + rem) | 0))) | 0);
    var t = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J($thiz, temporal$tailLocal1, dow);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if (((lo === 0) && (hi === 0))) {
      $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(temporal$tailLocal1);
      var temporal$1 = temporal$tailLocal1;
      var this$5 = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal$1);
      var unit = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
      temporal$tailLocal1 = this$5.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(2, 0), unit);
      continue;
    }
    var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I($thiz, temporal$tailLocal1.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField()), dow);
    var year = temporal$tailLocal1.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
    var $x_1 = $m_Ljava_time_Year$();
    var hi$1 = (year >> 31);
    if ($x_1.isLeap__J__Z(new $c_RTLong(year, hi$1))) {
      var yearLen = 366;
    } else {
      var yearLen = 365;
    }
    var this$7 = $thiz.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
    var weekIndexOfFirstWeekNextYear = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I($thiz, offset, ((yearLen + this$7.Ljava_time_temporal_WeekFields__f_minimalDays) | 0));
    var hi$2 = (weekIndexOfFirstWeekNextYear >> 31);
    if (((hi === hi$2) ? ((lo >>> 0) >= (weekIndexOfFirstWeekNextYear >>> 0)) : (hi > hi$2))) {
      $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(temporal$tailLocal1);
      var temporal$2 = temporal$tailLocal1;
      var this$11 = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal$2);
      var unit$1 = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
      temporal$tailLocal1 = this$11.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(2, 0), unit$1);
      continue;
    }
    var $x_2 = $m_Ljava_time_temporal_ValueRange$();
    var hi$3 = (weekIndexOfFirstWeekNextYear >> 31);
    var lo$1 = (((-1) + weekIndexOfFirstWeekNextYear) | 0);
    var hi$4 = (((((-1) + hi$3) | 0) + (((weekIndexOfFirstWeekNextYear | (~lo$1)) >>> 31) | 0)) | 0);
    return $x_2.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(lo$1, hi$4));
  }
}
export { $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__rangeWOWBY__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange as $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__rangeWOWBY__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange };
/** @constructor */
function $c_Ljava_time_temporal_WeekFields$ComputedDayOfField(name, weekDef, baseUnit, rangeUnit, range) {
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_name = null;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef = null;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_baseUnit = null;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit = null;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range = null;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_name = name;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef = weekDef;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_baseUnit = baseUnit;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit = rangeUnit;
  this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range = range;
}
export { $c_Ljava_time_temporal_WeekFields$ComputedDayOfField as $c_Ljava_time_temporal_WeekFields$ComputedDayOfField };
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype = new $h_O();
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.constructor = $c_Ljava_time_temporal_WeekFields$ComputedDayOfField;
/** @constructor */
function $h_Ljava_time_temporal_WeekFields$ComputedDayOfField() {
}
export { $h_Ljava_time_temporal_WeekFields$ComputedDayOfField as $h_Ljava_time_temporal_WeekFields$ComputedDayOfField };
$h_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype = $c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype;
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.range__Ljava_time_temporal_ValueRange = (function() {
  return this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range;
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.getFrom__Ljava_time_temporal_TemporalAccessor__J = (function(temporal) {
  var this$1 = this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
  var sow = this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek.getValue__I();
  var isoDow = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var a = ((isoDow - sow) | 0);
  var rem = ((a % 7) | 0);
  var dow = ((1 + ((((7 ^ a) >= 0) || (rem === 0)) ? rem : ((7 + rem) | 0))) | 0);
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit())) {
    var hi = (dow >> 31);
    return new $c_RTLong(dow, hi);
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit())) {
    var dom = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
    var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I(this, dom, dow);
    var value = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I(this, offset, dom);
    var hi$1 = (value >> 31);
    return new $c_RTLong(value, hi$1);
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit())) {
    var doy = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField());
    var offset$2 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I(this, doy, dow);
    var value$1 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I(this, offset$2, doy);
    var hi$2 = (value$1 >> 31);
    return new $c_RTLong(value$1, hi$2);
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit())) {
    var value$2 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWOWBY__Ljava_time_temporal_TemporalAccessor__I(this, temporal);
    var hi$3 = (value$2 >> 31);
    return new $c_RTLong(value$2, hi$3);
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit())) {
    var value$3 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWBY__Ljava_time_temporal_TemporalAccessor__I(this, temporal);
    var hi$4 = (value$3 >> 31);
    return new $c_RTLong(value$3, hi$4);
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "unreachable");
  }
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal = (function(temporal, newValue) {
  var newVal = this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue, this);
  var currentVal = temporal.get__Ljava_time_temporal_TemporalField__I(this);
  if ((newVal === currentVal)) {
    return temporal;
  }
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit())) {
    var baseWowby = temporal.get__Ljava_time_temporal_TemporalField__I(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear);
    var hi = (currentVal >> 31);
    var alo = newValue.RTLong__f_lo;
    var lo = ((alo - currentVal) | 0);
    var hi$1 = ((((newValue.RTLong__f_hi - hi) | 0) + ((((~alo) & currentVal) | ((~(alo ^ currentVal)) & lo)) >> 31)) | 0);
    var value = (52.1775 * ((4.294967296E9 * hi$1) + (lo >>> 0.0)));
    var this$4 = $m_RTLong$();
    var lo$1 = this$4.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi$2 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var result = temporal.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(lo$1, hi$2), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit());
    if ((result.get__Ljava_time_temporal_TemporalField__I(this) > newVal)) {
      var newWowby = result.get__Ljava_time_temporal_TemporalField__I(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear);
      var $x_1 = result;
      var hi$3 = (newWowby >> 31);
      result = $x_1.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(newWowby, hi$3), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit());
    } else {
      if ((result.get__Ljava_time_temporal_TemporalField__I(this) < newVal)) {
        result = result.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(2, 0), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit());
      }
      var newWowby$2 = result.get__Ljava_time_temporal_TemporalField__I(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear);
      var $x_2 = result;
      var hi$4 = (baseWowby >> 31);
      var hi$5 = (newWowby$2 >> 31);
      var lo$2 = ((baseWowby - newWowby$2) | 0);
      var hi$6 = ((((hi$4 - hi$5) | 0) + ((((~baseWowby) & newWowby$2) | ((~(baseWowby ^ newWowby$2)) & lo$2)) >> 31)) | 0);
      result = $x_2.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(lo$2, hi$6), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit());
      if ((result.get__Ljava_time_temporal_TemporalField__I(this) > newVal)) {
        result = result.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(1, 0), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit());
      }
    }
    return result;
  }
  var delta = ((newVal - currentVal) | 0);
  var hi$7 = (delta >> 31);
  return temporal.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(delta, hi$7), this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_baseUnit);
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.resolve__ju_Map__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_ResolverStyle__Ljava_time_temporal_TemporalAccessor = (function(fieldValues, partialTemporal, resolverStyle) {
  var this$1 = this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
  var sow = this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek.getValue__I();
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit())) {
    var x = fieldValues.remove__O__O(this);
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var localDow = this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo, hi), this);
    var a = (((((-1) + sow) | 0) + (((-1) + localDow) | 0)) | 0);
    var rem = ((a % 7) | 0);
    var isoDow = ((1 + ((((7 ^ a) >= 0) || (rem === 0)) ? rem : ((7 + rem) | 0))) | 0);
    var $x_1 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    var hi$1 = (isoDow >> 31);
    fieldValues.put__O__O__O($x_1, new $c_RTLong(isoDow, hi$1));
    return null;
  }
  if ((!fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()))) {
    return null;
  }
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit())) {
    if ((!fieldValues.containsKey__O__Z(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear))) {
      return null;
    }
    $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(partialTemporal);
    var this$7 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    var x$1 = fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
    var t$1 = $uJ(x$1);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$2 = t$1.RTLong__f_hi;
    var isoDow$2 = this$7.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$1, hi$2), this$7);
    var a$1 = ((isoDow$2 - sow) | 0);
    var rem$1 = ((a$1 % 7) | 0);
    var dow = ((1 + ((((7 ^ a$1) >= 0) || (rem$1 === 0)) ? rem$1 : ((7 + rem$1) | 0))) | 0);
    var $x_2 = this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range;
    var x$2 = fieldValues.get__O__O(this);
    var wby = $x_2.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($uJ(x$2), this);
    var date = null;
    var days__lo = 0;
    var days__hi = 0;
    if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$10 = this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
      var dayOfMonth = this$10.Ljava_time_temporal_WeekFields__f_minimalDays;
      date = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(wby, 1, dayOfMonth);
      var x$3 = fieldValues.get__O__O(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear);
      var t$2 = $uJ(x$3);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$3 = t$2.RTLong__f_hi;
      var dateDow = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date, sow);
      var b = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J(this, date, dateDow);
      var blo = b.RTLong__f_lo;
      var lo$3 = ((lo$2 - blo) | 0);
      var hi$4 = ((((hi$3 - b.RTLong__f_hi) | 0) + ((((~lo$2) & blo) | ((~(lo$2 ^ blo)) & lo$3)) >> 31)) | 0);
      var b0 = (65535 & lo$3);
      var b1 = ((lo$3 >>> 16) | 0);
      var a0b0 = Math.imul(7, b0);
      var a0b1 = Math.imul(7, b1);
      var lo$4 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$5 = ((Math.imul(7, hi$4) + ((c1part >>> 16) | 0)) | 0);
      var value = ((dow - dateDow) | 0);
      var hi$6 = (value >> 31);
      var lo$5 = ((lo$4 + value) | 0);
      var hi$7 = ((((hi$5 + hi$6) | 0) + ((((lo$4 & value) | ((lo$4 | value) & (~lo$5))) >>> 31) | 0)) | 0);
      var $x_3__lo = lo$5;
      var $x_3__hi = hi$7;
      days__lo = $x_3__lo;
      days__hi = $x_3__hi;
    } else {
      var this$16 = this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
      var dayOfMonth$1 = this$16.Ljava_time_temporal_WeekFields__f_minimalDays;
      date = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(wby, 1, dayOfMonth$1);
      var $x_4 = this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear.range__Ljava_time_temporal_ValueRange();
      var x$4 = fieldValues.get__O__O(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear);
      var value$1 = $x_4.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($uJ(x$4), this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear);
      var hi$8 = (value$1 >> 31);
      var dateDow$2 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date, sow);
      var b$1 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J(this, date, dateDow$2);
      var blo$1 = b$1.RTLong__f_lo;
      var lo$6 = ((value$1 - blo$1) | 0);
      var hi$9 = ((((hi$8 - b$1.RTLong__f_hi) | 0) + ((((~value$1) & blo$1) | ((~(value$1 ^ blo$1)) & lo$6)) >> 31)) | 0);
      var b0$1 = (65535 & lo$6);
      var b1$1 = ((lo$6 >>> 16) | 0);
      var a0b0$1 = Math.imul(7, b0$1);
      var a0b1$1 = Math.imul(7, b1$1);
      var lo$7 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$10 = ((Math.imul(7, hi$9) + ((c1part$1 >>> 16) | 0)) | 0);
      var value$2 = ((dow - dateDow$2) | 0);
      var hi$11 = (value$2 >> 31);
      var lo$8 = ((lo$7 + value$2) | 0);
      var hi$12 = ((((hi$10 + hi$11) | 0) + ((((lo$7 & value$2) | ((lo$7 | value$2) & (~lo$8))) >>> 31) | 0)) | 0);
      var $x_5__lo = lo$8;
      var $x_5__hi = hi$12;
      days__lo = $x_5__lo;
      days__hi = $x_5__hi;
    }
    var this$23 = date;
    var amountToAdd__lo = days__lo;
    var amountToAdd__hi = days__hi;
    var unit = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    date = this$23.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(amountToAdd__lo, amountToAdd__hi), unit);
    if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle())) {
      var t$3 = date.getLong__Ljava_time_temporal_TemporalField__J(this);
      var lo$9 = t$3.RTLong__f_lo;
      var hi$13 = t$3.RTLong__f_hi;
      var y = fieldValues.get__O__O(this);
      if ((!$m_sr_BoxesRunTime$().equalsNumObject__jl_Number__O__Z(new $c_RTLong(lo$9, hi$13), y))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different year");
      }
    }
    fieldValues.remove__O__O(this);
    fieldValues.remove__O__O(this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef.Ljava_time_temporal_WeekFields__f_weekOfWeekBasedYear);
    fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
    return date;
  }
  if ((!fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()))) {
    return null;
  }
  var this$25 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
  var x$5 = fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var t$4 = $uJ(x$5);
  var lo$10 = t$4.RTLong__f_lo;
  var hi$14 = t$4.RTLong__f_hi;
  var isoDow$3 = this$25.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$10, hi$14), this$25);
  var a$2 = ((isoDow$3 - sow) | 0);
  var rem$2 = ((a$2 % 7) | 0);
  var dow$2 = ((1 + ((((7 ^ a$2) >= 0) || (rem$2 === 0)) ? rem$2 : ((7 + rem$2) | 0))) | 0);
  var this$28 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var x$6 = fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
  var t$5 = $uJ(x$6);
  var lo$11 = t$5.RTLong__f_lo;
  var hi$15 = t$5.RTLong__f_hi;
  var year = this$28.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$11, hi$15), this$28);
  $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(partialTemporal);
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit())) {
    if ((!fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()))) {
      return null;
    }
    var x$7 = fieldValues.remove__O__O(this);
    var t$6 = $uJ(x$7);
    var lo$12 = t$6.RTLong__f_lo;
    var hi$16 = t$6.RTLong__f_hi;
    var date$2 = null;
    var days$2__lo = 0;
    var days$2__hi = 0;
    if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var x$8 = fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
      var t$7 = $uJ(x$8);
      var lo$13 = t$7.RTLong__f_lo;
      var hi$17 = t$7.RTLong__f_hi;
      date$2 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, 1, 1);
      var this$32 = date$2;
      var lo$14 = (((-1) + lo$13) | 0);
      var hi$18 = (((((-1) + hi$17) | 0) + (((lo$13 | (~lo$14)) >>> 31) | 0)) | 0);
      var unit$1 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
      date$2 = this$32.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(lo$14, hi$18), unit$1);
      var dateDow$3 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date$2, sow);
      var b$2 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfMonth__Ljava_time_temporal_TemporalAccessor__I__J(this, date$2, dateDow$3);
      var blo$2 = b$2.RTLong__f_lo;
      var lo$15 = ((lo$12 - blo$2) | 0);
      var hi$19 = ((((hi$16 - b$2.RTLong__f_hi) | 0) + ((((~lo$12) & blo$2) | ((~(lo$12 ^ blo$2)) & lo$15)) >> 31)) | 0);
      var b0$2 = (65535 & lo$15);
      var b1$2 = ((lo$15 >>> 16) | 0);
      var a0b0$2 = Math.imul(7, b0$2);
      var a0b1$2 = Math.imul(7, b1$2);
      var lo$16 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$20 = ((Math.imul(7, hi$19) + ((c1part$2 >>> 16) | 0)) | 0);
      var value$3 = ((dow$2 - dateDow$3) | 0);
      var hi$21 = (value$3 >> 31);
      var lo$17 = ((lo$16 + value$3) | 0);
      var hi$22 = ((((hi$20 + hi$21) | 0) + ((((lo$16 & value$3) | ((lo$16 | value$3) & (~lo$17))) >>> 31) | 0)) | 0);
      var $x_6__lo = lo$17;
      var $x_6__hi = hi$22;
      days$2__lo = $x_6__lo;
      days$2__hi = $x_6__hi;
    } else {
      var this$38 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
      var x$9 = fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
      var t$8 = $uJ(x$9);
      var lo$18 = t$8.RTLong__f_lo;
      var hi$23 = t$8.RTLong__f_hi;
      var month$2 = this$38.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$18, hi$23), this$38);
      date$2 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, month$2, 8);
      var dateDow$4 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date$2, sow);
      var wom = this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$12, hi$16), this);
      var hi$24 = (wom >> 31);
      var b$3 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfMonth__Ljava_time_temporal_TemporalAccessor__I__J(this, date$2, dateDow$4);
      var blo$3 = b$3.RTLong__f_lo;
      var lo$19 = ((wom - blo$3) | 0);
      var hi$25 = ((((hi$24 - b$3.RTLong__f_hi) | 0) + ((((~wom) & blo$3) | ((~(wom ^ blo$3)) & lo$19)) >> 31)) | 0);
      var b0$3 = (65535 & lo$19);
      var b1$3 = ((lo$19 >>> 16) | 0);
      var a0b0$3 = Math.imul(7, b0$3);
      var a0b1$3 = Math.imul(7, b1$3);
      var lo$20 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$26 = ((Math.imul(7, hi$25) + ((c1part$3 >>> 16) | 0)) | 0);
      var value$4 = ((dow$2 - dateDow$4) | 0);
      var hi$27 = (value$4 >> 31);
      var lo$21 = ((lo$20 + value$4) | 0);
      var hi$28 = ((((hi$26 + hi$27) | 0) + ((((lo$20 & value$4) | ((lo$20 | value$4) & (~lo$21))) >>> 31) | 0)) | 0);
      var $x_7__lo = lo$21;
      var $x_7__hi = hi$28;
      days$2__lo = $x_7__lo;
      days$2__hi = $x_7__hi;
    }
    var this$44 = date$2;
    var amountToAdd$1__lo = days$2__lo;
    var amountToAdd$1__hi = days$2__hi;
    var unit$2 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    date$2 = this$44.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(amountToAdd$1__lo, amountToAdd$1__hi), unit$2);
    if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle())) {
      var t$9 = date$2.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
      var lo$22 = t$9.RTLong__f_lo;
      var hi$29 = t$9.RTLong__f_hi;
      var y$1 = fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
      if ((!$m_sr_BoxesRunTime$().equalsNumObject__jl_Number__O__Z(new $c_RTLong(lo$22, hi$29), y$1))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month");
      }
    }
    fieldValues.remove__O__O(this);
    fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
    fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
    fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
    return date$2;
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit())) {
    var x$10 = fieldValues.remove__O__O(this);
    var t$10 = $uJ(x$10);
    var lo$23 = t$10.RTLong__f_lo;
    var hi$30 = t$10.RTLong__f_hi;
    var date$3 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(year, 1, 1);
    var days$3__lo = 0;
    var days$3__hi = 0;
    if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var dateDow$5 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date$3, sow);
      var b$4 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J(this, date$3, dateDow$5);
      var blo$4 = b$4.RTLong__f_lo;
      var lo$24 = ((lo$23 - blo$4) | 0);
      var hi$31 = ((((hi$30 - b$4.RTLong__f_hi) | 0) + ((((~lo$23) & blo$4) | ((~(lo$23 ^ blo$4)) & lo$24)) >> 31)) | 0);
      var b0$4 = (65535 & lo$24);
      var b1$4 = ((lo$24 >>> 16) | 0);
      var a0b0$4 = Math.imul(7, b0$4);
      var a0b1$4 = Math.imul(7, b1$4);
      var lo$25 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
      var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
      var hi$32 = ((Math.imul(7, hi$31) + ((c1part$4 >>> 16) | 0)) | 0);
      var value$5 = ((dow$2 - dateDow$5) | 0);
      var hi$33 = (value$5 >> 31);
      var lo$26 = ((lo$25 + value$5) | 0);
      var hi$34 = ((((hi$32 + hi$33) | 0) + ((((lo$25 & value$5) | ((lo$25 | value$5) & (~lo$26))) >>> 31) | 0)) | 0);
      var $x_8__lo = lo$26;
      var $x_8__hi = hi$34;
      days$3__lo = $x_8__lo;
      days$3__hi = $x_8__hi;
    } else {
      var dateDow$6 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedDayOfWeek__Ljava_time_temporal_TemporalAccessor__I__I(this, date$3, sow);
      var woy = this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$23, hi$30), this);
      var hi$35 = (woy >> 31);
      var b$5 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__localizedWeekOfYear__Ljava_time_temporal_TemporalAccessor__I__J(this, date$3, dateDow$6);
      var blo$5 = b$5.RTLong__f_lo;
      var lo$27 = ((woy - blo$5) | 0);
      var hi$36 = ((((hi$35 - b$5.RTLong__f_hi) | 0) + ((((~woy) & blo$5) | ((~(woy ^ blo$5)) & lo$27)) >> 31)) | 0);
      var b0$5 = (65535 & lo$27);
      var b1$5 = ((lo$27 >>> 16) | 0);
      var a0b0$5 = Math.imul(7, b0$5);
      var a0b1$5 = Math.imul(7, b1$5);
      var lo$28 = ((a0b0$5 + (a0b1$5 << 16)) | 0);
      var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
      var hi$37 = ((Math.imul(7, hi$36) + ((c1part$5 >>> 16) | 0)) | 0);
      var value$6 = ((dow$2 - dateDow$6) | 0);
      var hi$38 = (value$6 >> 31);
      var lo$29 = ((lo$28 + value$6) | 0);
      var hi$39 = ((((hi$37 + hi$38) | 0) + ((((lo$28 & value$6) | ((lo$28 | value$6) & (~lo$29))) >>> 31) | 0)) | 0);
      var $x_9__lo = lo$29;
      var $x_9__hi = hi$39;
      days$3__lo = $x_9__lo;
      days$3__hi = $x_9__hi;
    }
    var this$55 = date$3;
    var amountToAdd$2__lo = days$3__lo;
    var amountToAdd$2__hi = days$3__hi;
    var unit$3 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    date$3 = this$55.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(amountToAdd$2__lo, amountToAdd$2__hi), unit$3);
    if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle())) {
      var t$11 = date$3.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
      var lo$30 = t$11.RTLong__f_lo;
      var hi$40 = t$11.RTLong__f_hi;
      var y$2 = fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
      if ((!$m_sr_BoxesRunTime$().equalsNumObject__jl_Number__O__Z(new $c_RTLong(lo$30, hi$40), y$2))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different year");
      }
    }
    fieldValues.remove__O__O(this);
    fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
    fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
    return date$3;
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "unreachable");
  }
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.isDateBased__Z = (function() {
  return true;
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.isTimeBased__Z = (function() {
  return false;
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z = (function(temporal) {
  return (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()) && ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit()) || ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit()) ? temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField()) : ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit()) ? temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField()) : ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit()) ? temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField()) : ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit()) && temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())))))));
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange = (function(temporal) {
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit())) {
    return this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_range;
  }
  var field = null;
  if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit())) {
    field = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit())) {
    field = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEARS__Ljava_time_temporal_TemporalUnit())) {
    return $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__rangeWOWBY__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this, temporal);
  } else if ((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_rangeUnit === $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit())) {
    return temporal.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "unreachable");
  }
  var this$1 = this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef;
  var sow = this$1.Ljava_time_temporal_WeekFields__f_firstDayOfWeek.getValue__I();
  var isoDow = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
  var a = ((isoDow - sow) | 0);
  var rem = ((a % 7) | 0);
  var dow = ((1 + ((((7 ^ a) >= 0) || (rem === 0)) ? rem : ((7 + rem) | 0))) | 0);
  var offset = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__startOfWeekOffset__I__I__I(this, temporal.get__Ljava_time_temporal_TemporalField__I(field), dow);
  var fieldRange = temporal.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field);
  var $x_2 = $m_Ljava_time_temporal_ValueRange$();
  var a$1 = fieldRange.Ljava_time_temporal_ValueRange__f_minSmallest;
  var value = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I(this, offset, a$1.RTLong__f_lo);
  var hi = (value >> 31);
  var $x_1 = new $c_RTLong(value, hi);
  var a$2 = fieldRange.Ljava_time_temporal_ValueRange__f_maxLargest;
  var value$1 = $p_Ljava_time_temporal_WeekFields$ComputedDayOfField__computeWeek__I__I__I(this, offset, a$2.RTLong__f_lo);
  var hi$1 = (value$1 >> 31);
  return $x_2.of__J__J__Ljava_time_temporal_ValueRange($x_1, new $c_RTLong(value$1, hi$1));
});
$c_Ljava_time_temporal_WeekFields$ComputedDayOfField.prototype.toString__T = (function() {
  return (((this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_name + "[") + this.Ljava_time_temporal_WeekFields$ComputedDayOfField__f_weekDef.toString__T()) + "]");
});
var $d_Ljava_time_temporal_WeekFields$ComputedDayOfField = new $TypeData().initClass($c_Ljava_time_temporal_WeekFields$ComputedDayOfField, "java.time.temporal.WeekFields$ComputedDayOfField", ({
  Ljava_time_temporal_WeekFields$ComputedDayOfField: 1,
  Ljava_time_temporal_TemporalField: 1
}));
export { $d_Ljava_time_temporal_WeekFields$ComputedDayOfField as $d_Ljava_time_temporal_WeekFields$ComputedDayOfField };
/** @constructor */
function $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider() {
}
export { $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider as $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider };
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype = new $h_Ljava_time_zone_ZoneRulesProvider();
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype.constructor = $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider;
/** @constructor */
function $h_Ljava_time_zone_DefaultTzdbZoneRulesProvider() {
}
export { $h_Ljava_time_zone_DefaultTzdbZoneRulesProvider as $h_Ljava_time_zone_DefaultTzdbZoneRulesProvider };
$h_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype = $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype;
$c_Ljava_time_zone_DefaultTzdbZoneRulesProvider.prototype.provideZoneIds__ju_Set = (function() {
  var zones = $ct_ju_HashSet__(new $c_ju_HashSet());
  zones.add__O__Z("UTC");
  zones.add__O__Z("GMT");
  return zones;
});
var $d_Ljava_time_zone_DefaultTzdbZoneRulesProvider = new $TypeData().initClass($c_Ljava_time_zone_DefaultTzdbZoneRulesProvider, "java.time.zone.DefaultTzdbZoneRulesProvider", ({
  Ljava_time_zone_DefaultTzdbZoneRulesProvider: 1,
  Ljava_time_zone_ZoneRulesProvider: 1
}));
export { $d_Ljava_time_zone_DefaultTzdbZoneRulesProvider as $d_Ljava_time_zone_DefaultTzdbZoneRulesProvider };
/** @constructor */
function $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer() {
}
export { $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer as $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer };
$c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype = new $h_Ljava_time_zone_ZoneRulesInitializer();
$c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype.constructor = $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer;
/** @constructor */
function $h_Ljava_time_zone_ServiceLoaderZoneRulesInitializer() {
}
export { $h_Ljava_time_zone_ServiceLoaderZoneRulesInitializer as $h_Ljava_time_zone_ServiceLoaderZoneRulesInitializer };
$h_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype = $c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype;
$c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer.prototype.initializeProviders__V = (function() {
  var $x_1 = $m_s_Predef$();
  var this$1 = $objectClassName(this);
  var xs = $f_T__split__T__I__AT(this$1, "\\.", 0);
  var this$3 = $x_1.wrapRefArray__AO__scm_ArraySeq$ofRef($m_sc_ArrayOps$().init$extension__O__O(xs));
  var packageName = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", ".", "");
  var fqcn = (packageName + ".TzdbZoneRulesProvider");
  var this$5 = $m_sjs_reflect_Reflect$();
  var optClassData = this$5.sjs_reflect_Reflect$__f_instantiatableClasses.get__O__s_Option(fqcn);
  if (optClassData.isEmpty__Z()) {
    var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ljava_time_zone_ZoneRulesProvider.getArrayOf().constr)([new $c_Ljava_time_zone_DefaultTzdbZoneRulesProvider()]));
    var $x_2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  } else {
    var x0 = optClassData.get__O();
    var instance = x0.newInstance__O();
    var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Ljava_time_zone_ZoneRulesProvider.getArrayOf().constr)([instance]));
    var $x_2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  }
  var this$8 = $x_2;
  var these = this$8;
  while ((!these.isEmpty__Z())) {
    var x0$1 = these.head__O();
    $m_Ljava_time_zone_ZoneRulesProvider$().registerProvider__Ljava_time_zone_ZoneRulesProvider__V(x0$1);
    these = these.tail__O();
  }
});
var $d_Ljava_time_zone_ServiceLoaderZoneRulesInitializer = new $TypeData().initClass($c_Ljava_time_zone_ServiceLoaderZoneRulesInitializer, "java.time.zone.ServiceLoaderZoneRulesInitializer", ({
  Ljava_time_zone_ServiceLoaderZoneRulesInitializer: 1,
  Ljava_time_zone_ZoneRulesInitializer: 1
}));
export { $d_Ljava_time_zone_ServiceLoaderZoneRulesInitializer as $d_Ljava_time_zone_ServiceLoaderZoneRulesInitializer };
var $d_Ljava_time_zone_ZoneOffsetTransitionRule = new $TypeData().initClass(0, "java.time.zone.ZoneOffsetTransitionRule", ({
  Ljava_time_zone_ZoneOffsetTransitionRule: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_zone_ZoneOffsetTransitionRule as $d_Ljava_time_zone_ZoneOffsetTransitionRule };
/** @constructor */
function $c_ju_AbstractMap() {
}
export { $c_ju_AbstractMap as $c_ju_AbstractMap };
$c_ju_AbstractMap.prototype = new $h_O();
$c_ju_AbstractMap.prototype.constructor = $c_ju_AbstractMap;
/** @constructor */
function $h_ju_AbstractMap() {
}
export { $h_ju_AbstractMap as $h_ju_AbstractMap };
$h_ju_AbstractMap.prototype = $c_ju_AbstractMap.prototype;
$c_ju_AbstractMap.prototype.putAll__ju_Map__V = (function(m) {
  var _\uff3fself = m.entrySet__ju_Set();
  var _\uff3fself$1 = _\uff3fself.iterator__ju_Iterator();
  while (_\uff3fself$1.hasNext__Z()) {
    var t = _\uff3fself$1.next__O();
    this.put__O__O__O(t.getKey__O(), t.getValue__O());
  }
});
$c_ju_AbstractMap.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true;
  } else if ($is_ju_Map(o)) {
    if ((this.size__I() === o.size__I())) {
      var _\uff3fself = this.entrySet__ju_Set();
      var _\uff3fself$1 = _\uff3fself.iterator__ju_Iterator();
      _return: {
        while (_\uff3fself$1.hasNext__Z()) {
          var t = _\uff3fself$1.next__O();
          var a = o.get__O__O(t.getKey__O());
          var b = t.getValue__O();
          if ((!((a === null) ? (b === null) : $dp_equals__O__Z(a, b)))) {
            var $x_1 = true;
            break _return;
          }
        }
        var $x_1 = false;
      }
      return (!$x_1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_AbstractMap.prototype.hashCode__I = (function() {
  var _\uff3fself = this.entrySet__ju_Set();
  var _\uff3fself$1 = _\uff3fself.iterator__ju_Iterator();
  var result = 0;
  while (_\uff3fself$1.hasNext__Z()) {
    var t = result;
    var u = _\uff3fself$1.next__O();
    var t$1 = (t | 0);
    result = ((u.hashCode__I() + t$1) | 0);
  }
  return (result | 0);
});
$c_ju_AbstractMap.prototype.toString__T = (function() {
  var result = "{";
  var first = true;
  var iter = this.entrySet__ju_Set().iterator__ju_Iterator();
  while (iter.hasNext__Z()) {
    var entry = iter.next__O();
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (((("" + result) + entry.getKey__O()) + "=") + entry.getValue__O());
  }
  return (result + "}");
});
/** @constructor */
function $c_ju_Arrays$NaturalComparator$() {
}
export { $c_ju_Arrays$NaturalComparator$ as $c_ju_Arrays$NaturalComparator$ };
$c_ju_Arrays$NaturalComparator$.prototype = new $h_O();
$c_ju_Arrays$NaturalComparator$.prototype.constructor = $c_ju_Arrays$NaturalComparator$;
/** @constructor */
function $h_ju_Arrays$NaturalComparator$() {
}
export { $h_ju_Arrays$NaturalComparator$ as $h_ju_Arrays$NaturalComparator$ };
$h_ju_Arrays$NaturalComparator$.prototype = $c_ju_Arrays$NaturalComparator$.prototype;
$c_ju_Arrays$NaturalComparator$.prototype.compare__O__O__I = (function(o1, o2) {
  return $dp_compareTo__O__I(o1, o2);
});
var $d_ju_Arrays$NaturalComparator$ = new $TypeData().initClass($c_ju_Arrays$NaturalComparator$, "java.util.Arrays$NaturalComparator$", ({
  ju_Arrays$NaturalComparator$: 1,
  ju_Comparator: 1
}));
export { $d_ju_Arrays$NaturalComparator$ as $d_ju_Arrays$NaturalComparator$ };
var $n_ju_Arrays$NaturalComparator$;
function $m_ju_Arrays$NaturalComparator$() {
  if ((!$n_ju_Arrays$NaturalComparator$)) {
    $n_ju_Arrays$NaturalComparator$ = new $c_ju_Arrays$NaturalComparator$();
  }
  return $n_ju_Arrays$NaturalComparator$;
}
export { $m_ju_Arrays$NaturalComparator$ as $m_ju_Arrays$NaturalComparator$ };
function $is_ju_Collection(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_Collection)));
}
export { $is_ju_Collection as $is_ju_Collection };
function $isArrayOf_ju_Collection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Collection)));
}
export { $isArrayOf_ju_Collection as $isArrayOf_ju_Collection };
/** @constructor */
function $c_ju_Formatter$RootLocaleInfo$() {
}
export { $c_ju_Formatter$RootLocaleInfo$ as $c_ju_Formatter$RootLocaleInfo$ };
$c_ju_Formatter$RootLocaleInfo$.prototype = new $h_ju_Formatter$LocaleInfo();
$c_ju_Formatter$RootLocaleInfo$.prototype.constructor = $c_ju_Formatter$RootLocaleInfo$;
/** @constructor */
function $h_ju_Formatter$RootLocaleInfo$() {
}
export { $h_ju_Formatter$RootLocaleInfo$ as $h_ju_Formatter$RootLocaleInfo$ };
$h_ju_Formatter$RootLocaleInfo$.prototype = $c_ju_Formatter$RootLocaleInfo$.prototype;
var $d_ju_Formatter$RootLocaleInfo$ = new $TypeData().initClass($c_ju_Formatter$RootLocaleInfo$, "java.util.Formatter$RootLocaleInfo$", ({
  ju_Formatter$RootLocaleInfo$: 1,
  ju_Formatter$LocaleInfo: 1
}));
export { $d_ju_Formatter$RootLocaleInfo$ as $d_ju_Formatter$RootLocaleInfo$ };
var $n_ju_Formatter$RootLocaleInfo$;
function $m_ju_Formatter$RootLocaleInfo$() {
  if ((!$n_ju_Formatter$RootLocaleInfo$)) {
    $n_ju_Formatter$RootLocaleInfo$ = new $c_ju_Formatter$RootLocaleInfo$();
  }
  return $n_ju_Formatter$RootLocaleInfo$;
}
export { $m_ju_Formatter$RootLocaleInfo$ as $m_ju_Formatter$RootLocaleInfo$ };
function $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__($thiz, outer) {
  $thiz.ju_HashMap$AbstractHashMapIterator__f_$outer = outer;
  $thiz.ju_HashMap$AbstractHashMapIterator__f_len = outer.ju_HashMap__f_java$util$HashMap$$table.u.length;
  return $thiz;
}
export { $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__ as $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__ };
/** @constructor */
function $c_ju_HashMap$AbstractHashMapIterator() {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
}
export { $c_ju_HashMap$AbstractHashMapIterator as $c_ju_HashMap$AbstractHashMapIterator };
$c_ju_HashMap$AbstractHashMapIterator.prototype = new $h_O();
$c_ju_HashMap$AbstractHashMapIterator.prototype.constructor = $c_ju_HashMap$AbstractHashMapIterator;
/** @constructor */
function $h_ju_HashMap$AbstractHashMapIterator() {
}
export { $h_ju_HashMap$AbstractHashMapIterator as $h_ju_HashMap$AbstractHashMapIterator };
$h_ju_HashMap$AbstractHashMapIterator.prototype = $c_ju_HashMap$AbstractHashMapIterator.prototype;
$c_ju_HashMap$AbstractHashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.ju_HashMap$AbstractHashMapIterator__f_nextNode !== null)) {
    return true;
  } else {
    while ((this.ju_HashMap$AbstractHashMapIterator__f_nextIdx < this.ju_HashMap$AbstractHashMapIterator__f_len)) {
      var node = this.ju_HashMap$AbstractHashMapIterator__f_$outer.ju_HashMap__f_java$util$HashMap$$table.u[this.ju_HashMap$AbstractHashMapIterator__f_nextIdx];
      this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = ((1 + this.ju_HashMap$AbstractHashMapIterator__f_nextIdx) | 0);
      if ((node !== null)) {
        this.ju_HashMap$AbstractHashMapIterator__f_nextNode = node;
        return true;
      }
    }
    return false;
  }
});
$c_ju_HashMap$AbstractHashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
  }
  var node = this.ju_HashMap$AbstractHashMapIterator__f_nextNode;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = node;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = node.ju_HashMap$Node__f_next;
  return this.extract__ju_HashMap$Node__O(node);
});
$c_ju_HashMap$AbstractHashMapIterator.prototype.remove__V = (function() {
  var last = this.ju_HashMap$AbstractHashMapIterator__f_lastNode;
  if ((last === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove");
  }
  this.ju_HashMap$AbstractHashMapIterator__f_$outer.removeNode__ju_HashMap$Node__V(last);
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
});
function $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__($thiz, key, hash, value, previous, next) {
  $thiz.ju_HashMap$Node__f_key = key;
  $thiz.ju_HashMap$Node__f_hash = hash;
  $thiz.ju_HashMap$Node__f_value = value;
  $thiz.ju_HashMap$Node__f_previous = previous;
  $thiz.ju_HashMap$Node__f_next = next;
  return $thiz;
}
export { $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ as $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ };
/** @constructor */
function $c_ju_HashMap$Node() {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
}
export { $c_ju_HashMap$Node as $c_ju_HashMap$Node };
$c_ju_HashMap$Node.prototype = new $h_O();
$c_ju_HashMap$Node.prototype.constructor = $c_ju_HashMap$Node;
/** @constructor */
function $h_ju_HashMap$Node() {
}
export { $h_ju_HashMap$Node as $h_ju_HashMap$Node };
$h_ju_HashMap$Node.prototype = $c_ju_HashMap$Node.prototype;
$c_ju_HashMap$Node.prototype.getKey__O = (function() {
  return this.ju_HashMap$Node__f_key;
});
$c_ju_HashMap$Node.prototype.getValue__O = (function() {
  return this.ju_HashMap$Node__f_value;
});
$c_ju_HashMap$Node.prototype.equals__O__Z = (function(that) {
  if ($is_ju_Map$Entry(that)) {
    var a = this.ju_HashMap$Node__f_key;
    var b = that.getKey__O();
    if (((a === null) ? (b === null) : $dp_equals__O__Z(a, b))) {
      var a$1 = this.ju_HashMap$Node__f_value;
      var b$1 = that.getValue__O();
      return ((a$1 === null) ? (b$1 === null) : $dp_equals__O__Z(a$1, b$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_HashMap$Node.prototype.hashCode__I = (function() {
  var improvedHash = this.ju_HashMap$Node__f_hash;
  var o = this.ju_HashMap$Node__f_value;
  return ((improvedHash ^ ((improvedHash >>> 16) | 0)) ^ ((o === null) ? 0 : $dp_hashCode__I(o)));
});
$c_ju_HashMap$Node.prototype.toString__T = (function() {
  return ((this.ju_HashMap$Node__f_key + "=") + this.ju_HashMap$Node__f_value);
});
var $d_ju_HashMap$Node = new $TypeData().initClass($c_ju_HashMap$Node, "java.util.HashMap$Node", ({
  ju_HashMap$Node: 1,
  ju_Map$Entry: 1
}));
export { $d_ju_HashMap$Node as $d_ju_HashMap$Node };
function $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__($thiz, outer) {
  $thiz.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = outer;
  $thiz.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = outer.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest;
  return $thiz;
}
export { $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__ as $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__ };
/** @constructor */
function $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null;
}
export { $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator as $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator };
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = new $h_O();
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.constructor = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator;
/** @constructor */
function $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator() {
}
export { $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator as $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator };
$h_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype = $c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype;
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.hasNext__Z = (function() {
  return (this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode !== null);
});
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
  }
  var node = this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = node;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = node.ju_LinkedHashMap$Node__f_younger;
  return this.extract__ju_LinkedHashMap$Node__O(node);
});
$c_ju_LinkedHashMap$AbstractLinkedHashMapIterator.prototype.remove__V = (function() {
  var last = this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode;
  if ((last === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove");
  }
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer.removeNode__ju_HashMap$Node__V(last);
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
});
function $ps_ju_UUID$__fail$1__T__E(name$1) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Invalid UUID string: " + name$1));
}
export { $ps_ju_UUID$__fail$1__T__E as $ps_ju_UUID$__fail$1__T__E };
/** @constructor */
function $c_ju_UUID$() {
}
export { $c_ju_UUID$ as $c_ju_UUID$ };
$c_ju_UUID$.prototype = new $h_O();
$c_ju_UUID$.prototype.constructor = $c_ju_UUID$;
/** @constructor */
function $h_ju_UUID$() {
}
export { $h_ju_UUID$ as $h_ju_UUID$ };
$h_ju_UUID$.prototype = $c_ju_UUID$.prototype;
$c_ju_UUID$.prototype.fromString__T__ju_UUID = (function(name) {
  if ((((((name.length !== 36) || (name.charCodeAt(8) !== 45)) || (name.charCodeAt(13) !== 45)) || (name.charCodeAt(18) !== 45)) || (name.charCodeAt(23) !== 45))) {
    $ps_ju_UUID$__fail$1__T__E(name);
  }
  try {
    var his = name.substring(0, 4);
    var los = name.substring(4, 8);
    var this$1 = $m_jl_Integer$();
    var $x_1 = this$1.java$lang$Integer$$parseIntImpl__T__I__I__I(his, 16, 134217728);
    var this$3 = $m_jl_Integer$();
    var i1 = (($x_1 << 16) | this$3.java$lang$Integer$$parseIntImpl__T__I__I__I(los, 16, 134217728));
    var his$1 = name.substring(9, 13);
    var los$1 = name.substring(14, 18);
    var this$5 = $m_jl_Integer$();
    var $x_2 = this$5.java$lang$Integer$$parseIntImpl__T__I__I__I(his$1, 16, 134217728);
    var this$7 = $m_jl_Integer$();
    var i2 = (($x_2 << 16) | this$7.java$lang$Integer$$parseIntImpl__T__I__I__I(los$1, 16, 134217728));
    var his$2 = name.substring(19, 23);
    var los$2 = name.substring(24, 28);
    var this$9 = $m_jl_Integer$();
    var $x_3 = this$9.java$lang$Integer$$parseIntImpl__T__I__I__I(his$2, 16, 134217728);
    var this$11 = $m_jl_Integer$();
    var i3 = (($x_3 << 16) | this$11.java$lang$Integer$$parseIntImpl__T__I__I__I(los$2, 16, 134217728));
    var his$3 = name.substring(28, 32);
    var los$3 = name.substring(32, 36);
    var this$13 = $m_jl_Integer$();
    var $x_4 = this$13.java$lang$Integer$$parseIntImpl__T__I__I__I(his$3, 16, 134217728);
    var this$15 = $m_jl_Integer$();
    var i4 = (($x_4 << 16) | this$15.java$lang$Integer$$parseIntImpl__T__I__I__I(los$3, 16, 134217728));
    return new $c_ju_UUID(new $c_RTLong(i2, i1), new $c_RTLong(i4, i3));
  } catch (e) {
    if ((e instanceof $c_jl_NumberFormatException)) {
      $ps_ju_UUID$__fail$1__T__E(name);
    } else {
      throw e;
    }
  }
});
var $d_ju_UUID$ = new $TypeData().initClass($c_ju_UUID$, "java.util.UUID$", ({
  ju_UUID$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_UUID$ as $d_ju_UUID$ };
var $n_ju_UUID$;
function $m_ju_UUID$() {
  if ((!$n_ju_UUID$)) {
    $n_ju_UUID$ = new $c_ju_UUID$();
  }
  return $n_ju_UUID$;
}
export { $m_ju_UUID$ as $m_ju_UUID$ };
function $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__($thiz, outer) {
  $thiz.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = outer;
  var this$1 = outer.java$util$concurrent$ConcurrentHashMap$InnerHashMap$$makeSnapshot__ju_ArrayList();
  $thiz.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = this$1.listIterator__I__ju_ListIterator(0);
  return $thiz;
}
export { $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__ as $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__ };
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator() {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null;
}
export { $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator as $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator };
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype = new $h_O();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator() {
}
export { $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator as $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator };
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.hasNext__Z = (function() {
  return this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter.hasNext__Z();
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.next__O = (function() {
  var node = this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter.next__O();
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = node;
  return this.extract__ju_HashMap$Node__O(node);
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator.prototype.remove__V = (function() {
  var last = this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode;
  if ((last === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove");
  }
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer.removeNode__ju_HashMap$Node__V(last);
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
});
/** @constructor */
function $c_ju_concurrent_TimeUnit$() {
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = null;
  this.ju_concurrent_TimeUnit$__f_SECONDS = null;
  this.ju_concurrent_TimeUnit$__f_MINUTES = null;
  this.ju_concurrent_TimeUnit$__f_HOURS = null;
  this.ju_concurrent_TimeUnit$__f_DAYS = null;
  $n_ju_concurrent_TimeUnit$ = this;
  this.ju_concurrent_TimeUnit$__f_NANOSECONDS = new $c_ju_concurrent_TimeUnit$$anon$1();
  this.ju_concurrent_TimeUnit$__f_MICROSECONDS = new $c_ju_concurrent_TimeUnit$$anon$2();
  this.ju_concurrent_TimeUnit$__f_MILLISECONDS = new $c_ju_concurrent_TimeUnit$$anon$3();
  this.ju_concurrent_TimeUnit$__f_SECONDS = new $c_ju_concurrent_TimeUnit$$anon$4();
  this.ju_concurrent_TimeUnit$__f_MINUTES = new $c_ju_concurrent_TimeUnit$$anon$5();
  this.ju_concurrent_TimeUnit$__f_HOURS = new $c_ju_concurrent_TimeUnit$$anon$6();
  this.ju_concurrent_TimeUnit$__f_DAYS = new $c_ju_concurrent_TimeUnit$$anon$7();
}
export { $c_ju_concurrent_TimeUnit$ as $c_ju_concurrent_TimeUnit$ };
$c_ju_concurrent_TimeUnit$.prototype = new $h_O();
$c_ju_concurrent_TimeUnit$.prototype.constructor = $c_ju_concurrent_TimeUnit$;
/** @constructor */
function $h_ju_concurrent_TimeUnit$() {
}
export { $h_ju_concurrent_TimeUnit$ as $h_ju_concurrent_TimeUnit$ };
$h_ju_concurrent_TimeUnit$.prototype = $c_ju_concurrent_TimeUnit$.prototype;
$c_ju_concurrent_TimeUnit$.prototype.java$util$concurrent$TimeUnit$$x__J__J__J__J = (function(a, b, max) {
  var ahi = a.RTLong__f_hi;
  var bhi = max.RTLong__f_hi;
  if (((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) > (max.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
    return new $c_RTLong((-1), 2147483647);
  } else {
    var blo = max.RTLong__f_lo;
    var lo = ((-blo) | 0);
    var hi = ((((-max.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
    var ahi$1 = a.RTLong__f_hi;
    if (((ahi$1 === hi) ? ((a.RTLong__f_lo >>> 0) < (lo >>> 0)) : (ahi$1 < hi))) {
      return new $c_RTLong(1, (-2147483648));
    } else {
      var alo = a.RTLong__f_lo;
      var blo$1 = b.RTLong__f_lo;
      var a0 = (65535 & alo);
      var a1 = ((alo >>> 16) | 0);
      var b0 = (65535 & blo$1);
      var b1 = ((blo$1 >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo$1)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return new $c_RTLong(lo$1, hi$1);
    }
  }
});
var $d_ju_concurrent_TimeUnit$ = new $TypeData().initClass($c_ju_concurrent_TimeUnit$, "java.util.concurrent.TimeUnit$", ({
  ju_concurrent_TimeUnit$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_TimeUnit$ as $d_ju_concurrent_TimeUnit$ };
var $n_ju_concurrent_TimeUnit$;
function $m_ju_concurrent_TimeUnit$() {
  if ((!$n_ju_concurrent_TimeUnit$)) {
    $n_ju_concurrent_TimeUnit$ = new $c_ju_concurrent_TimeUnit$();
  }
  return $n_ju_concurrent_TimeUnit$;
}
export { $m_ju_concurrent_TimeUnit$ as $m_ju_concurrent_TimeUnit$ };
function $ct_ju_concurrent_atomic_AtomicBoolean__Z__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicBoolean__f_value = value;
  return $thiz;
}
export { $ct_ju_concurrent_atomic_AtomicBoolean__Z__ as $ct_ju_concurrent_atomic_AtomicBoolean__Z__ };
/** @constructor */
function $c_ju_concurrent_atomic_AtomicBoolean() {
  this.ju_concurrent_atomic_AtomicBoolean__f_value = false;
}
export { $c_ju_concurrent_atomic_AtomicBoolean as $c_ju_concurrent_atomic_AtomicBoolean };
$c_ju_concurrent_atomic_AtomicBoolean.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicBoolean.prototype.constructor = $c_ju_concurrent_atomic_AtomicBoolean;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicBoolean() {
}
export { $h_ju_concurrent_atomic_AtomicBoolean as $h_ju_concurrent_atomic_AtomicBoolean };
$h_ju_concurrent_atomic_AtomicBoolean.prototype = $c_ju_concurrent_atomic_AtomicBoolean.prototype;
$c_ju_concurrent_atomic_AtomicBoolean.prototype.compareAndSet__Z__Z__Z = (function(expect, update) {
  if ((expect === this.ju_concurrent_atomic_AtomicBoolean__f_value)) {
    this.ju_concurrent_atomic_AtomicBoolean__f_value = update;
    return true;
  } else {
    return false;
  }
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.getAndSet__Z__Z = (function(newValue) {
  var old = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  this.ju_concurrent_atomic_AtomicBoolean__f_value = newValue;
  return old;
});
$c_ju_concurrent_atomic_AtomicBoolean.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_atomic_AtomicBoolean__f_value;
  return ("" + this$1);
});
var $d_ju_concurrent_atomic_AtomicBoolean = new $TypeData().initClass($c_ju_concurrent_atomic_AtomicBoolean, "java.util.concurrent.atomic.AtomicBoolean", ({
  ju_concurrent_atomic_AtomicBoolean: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_atomic_AtomicBoolean as $d_ju_concurrent_atomic_AtomicBoolean };
function $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, value) {
  $thiz.ju_concurrent_atomic_AtomicReference__f_value = value;
  return $thiz;
}
export { $ct_ju_concurrent_atomic_AtomicReference__O__ as $ct_ju_concurrent_atomic_AtomicReference__O__ };
function $ct_ju_concurrent_atomic_AtomicReference__($thiz) {
  $ct_ju_concurrent_atomic_AtomicReference__O__($thiz, null);
  return $thiz;
}
export { $ct_ju_concurrent_atomic_AtomicReference__ as $ct_ju_concurrent_atomic_AtomicReference__ };
/** @constructor */
function $c_ju_concurrent_atomic_AtomicReference() {
  this.ju_concurrent_atomic_AtomicReference__f_value = null;
}
export { $c_ju_concurrent_atomic_AtomicReference as $c_ju_concurrent_atomic_AtomicReference };
$c_ju_concurrent_atomic_AtomicReference.prototype = new $h_O();
$c_ju_concurrent_atomic_AtomicReference.prototype.constructor = $c_ju_concurrent_atomic_AtomicReference;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicReference() {
}
export { $h_ju_concurrent_atomic_AtomicReference as $h_ju_concurrent_atomic_AtomicReference };
$h_ju_concurrent_atomic_AtomicReference.prototype = $c_ju_concurrent_atomic_AtomicReference.prototype;
$c_ju_concurrent_atomic_AtomicReference.prototype.compareAndSet__O__O__Z = (function(expect, update) {
  if (Object.is(expect, this.ju_concurrent_atomic_AtomicReference__f_value)) {
    this.ju_concurrent_atomic_AtomicReference__f_value = update;
    return true;
  } else {
    return false;
  }
});
$c_ju_concurrent_atomic_AtomicReference.prototype.getAndSet__O__O = (function(newValue) {
  var old = this.ju_concurrent_atomic_AtomicReference__f_value;
  this.ju_concurrent_atomic_AtomicReference__f_value = newValue;
  return old;
});
$c_ju_concurrent_atomic_AtomicReference.prototype.toString__T = (function() {
  var obj = this.ju_concurrent_atomic_AtomicReference__f_value;
  return ("" + obj);
});
var $d_ju_concurrent_atomic_AtomicReference = new $TypeData().initClass($c_ju_concurrent_atomic_AtomicReference, "java.util.concurrent.atomic.AtomicReference", ({
  ju_concurrent_atomic_AtomicReference: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_atomic_AtomicReference as $d_ju_concurrent_atomic_AtomicReference };
/** @constructor */
function $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
}
export { $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ as $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ };
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
}
export { $h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ as $h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ };
$h_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  a.u[i] = v;
});
$c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$.prototype.get__O__I__O = (function(a, i) {
  return a.u[i];
});
var $d_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$, "java.util.internal.GenericArrayOps$ReusableAnyRefArrayOps$", ({
  ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1
}));
export { $d_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ as $d_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ };
var $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
function $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ = new $c_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$;
}
export { $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ as $m_ju_internal_GenericArrayOps$ReusableAnyRefArrayOps$ };
function $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher($thiz) {
  $thiz.ju_regex_Matcher__f_position = 0;
  $thiz.ju_regex_Matcher__f_lastMatch = null;
  $thiz.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos = 0;
  return $thiz;
}
export { $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher as $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher };
function $p_ju_regex_Matcher__ensureLastMatch__O($thiz) {
  if (($thiz.ju_regex_Matcher__f_lastMatch === null)) {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "No match available");
  }
  return $thiz.ju_regex_Matcher__f_lastMatch;
}
export { $p_ju_regex_Matcher__ensureLastMatch__O as $p_ju_regex_Matcher__ensureLastMatch__O };
/** @constructor */
function $c_ju_regex_Matcher(pattern0, input0) {
  this.ju_regex_Matcher__f_pattern0 = null;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = null;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr = null;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos = 0;
  this.ju_regex_Matcher__f_pattern0 = pattern0;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0 = input0;
  this.ju_regex_Matcher__f_regionStart0 = 0;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr = this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0;
  this.ju_regex_Matcher__f_position = 0;
  this.ju_regex_Matcher__f_lastMatch = null;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos = 0;
}
export { $c_ju_regex_Matcher as $c_ju_regex_Matcher };
$c_ju_regex_Matcher.prototype = new $h_O();
$c_ju_regex_Matcher.prototype.constructor = $c_ju_regex_Matcher;
/** @constructor */
function $h_ju_regex_Matcher() {
}
export { $h_ju_regex_Matcher as $h_ju_regex_Matcher };
$h_ju_regex_Matcher.prototype = $c_ju_regex_Matcher.prototype;
$c_ju_regex_Matcher.prototype.matches__Z = (function() {
  $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
  this.ju_regex_Matcher__f_lastMatch = this.ju_regex_Matcher__f_pattern0.execMatches__T__O(this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr);
  return (this.ju_regex_Matcher__f_lastMatch !== null);
});
$c_ju_regex_Matcher.prototype.lookingAt__Z = (function() {
  $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
  this.find__Z();
  if (((this.ju_regex_Matcher__f_lastMatch !== null) && (($p_ju_regex_Matcher__ensureLastMatch__O(this).index | 0) !== 0))) {
    $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
  }
  return (this.ju_regex_Matcher__f_lastMatch !== null);
});
$c_ju_regex_Matcher.prototype.find__Z = (function() {
  var this$1 = this.ju_regex_Matcher__f_pattern0;
  var input = this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr;
  var start = this.ju_regex_Matcher__f_position;
  var mtch = this$1.java$util$regex$Pattern$$execFindInternal__T__I__O(input, start);
  var end = (this$1.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind.lastIndex | 0);
  if ((mtch !== null)) {
    var $x_1 = ((end === (mtch.index | 0)) ? ((1 + end) | 0) : end);
  } else {
    var this$2 = this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr;
    var $x_1 = ((1 + this$2.length) | 0);
  }
  this.ju_regex_Matcher__f_position = $x_1;
  this.ju_regex_Matcher__f_lastMatch = mtch;
  return (mtch !== null);
});
$c_ju_regex_Matcher.prototype.appendReplacement__jl_StringBuilder__T__ju_regex_Matcher = (function(sb, replacement) {
  var this$1 = this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr;
  var beginIndex = this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos;
  var endIndex = this.start__I();
  var csq = this$1.substring(beginIndex, endIndex);
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + csq);
  var len = replacement.length;
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x1 = replacement.charCodeAt(index);
    switch (x1) {
      case 36: {
        i = ((1 + i) | 0);
        var j = i;
        while (true) {
          if ((i < len)) {
            var index$1 = i;
            var c = replacement.charCodeAt(index$1);
            var $x_1 = ((c >= 48) && (c <= 57));
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            i = ((1 + i) | 0);
          } else {
            break;
          }
        }
        var this$2 = $m_jl_Integer$();
        var endIndex$1 = i;
        var s = replacement.substring(j, endIndex$1);
        var group = this$2.java$lang$Integer$$parseIntImpl__T__I__I__I(s, 10, 214748364);
        var replaced = this.group__I__T(group);
        if ((replaced !== null)) {
          sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + replaced);
        }
        break;
      }
      case 92: {
        i = ((1 + i) | 0);
        if ((i < len)) {
          var index$2 = i;
          var c$1 = replacement.charCodeAt(index$2);
          var str = ("" + $cToS(c$1));
          sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
        }
        i = ((1 + i) | 0);
        break;
      }
      default: {
        var str$1 = ("" + $cToS(x1));
        sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
        i = ((1 + i) | 0);
      }
    }
  }
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos = this.end__I();
  return this;
});
$c_ju_regex_Matcher.prototype.appendTail__jl_StringBuilder__jl_StringBuilder = (function(sb) {
  var this$1 = this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr;
  var beginIndex = this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos;
  var str = this$1.substring(beginIndex);
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  var this$2 = this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$appendPos = this$2.length;
  return sb;
});
$c_ju_regex_Matcher.prototype.replaceFirst__T__T = (function(replacement) {
  this.reset__ju_regex_Matcher();
  if (this.find__Z()) {
    var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
    this.appendReplacement__jl_StringBuilder__T__ju_regex_Matcher(sb, replacement);
    this.appendTail__jl_StringBuilder__jl_StringBuilder(sb);
    return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  } else {
    return this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr;
  }
});
$c_ju_regex_Matcher.prototype.replaceAll__T__T = (function(replacement) {
  this.reset__ju_regex_Matcher();
  var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  while (this.find__Z()) {
    this.appendReplacement__jl_StringBuilder__T__ju_regex_Matcher(sb, replacement);
  }
  this.appendTail__jl_StringBuilder__jl_StringBuilder(sb);
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_ju_regex_Matcher.prototype.reset__ju_regex_Matcher = (function() {
  this.ju_regex_Matcher__f_regionStart0 = 0;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr = this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0;
  return $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
});
$c_ju_regex_Matcher.prototype.start__I = (function() {
  return ((($p_ju_regex_Matcher__ensureLastMatch__O(this).index | 0) + this.ju_regex_Matcher__f_regionStart0) | 0);
});
$c_ju_regex_Matcher.prototype.end__I = (function() {
  var $x_1 = this.start__I();
  var this$1 = this.group__T();
  return (($x_1 + this$1.length) | 0);
});
$c_ju_regex_Matcher.prototype.group__T = (function() {
  var x = $p_ju_regex_Matcher__ensureLastMatch__O(this)[0];
  return x;
});
$c_ju_regex_Matcher.prototype.group__I__T = (function(group) {
  var x = $p_ju_regex_Matcher__ensureLastMatch__O(this)[this.ju_regex_Matcher__f_pattern0.numberedGroup__I__I(group)];
  return ((x !== (void 0)) ? x : null);
});
$c_ju_regex_Matcher.prototype.region__I__I__ju_regex_Matcher = (function(start, end) {
  this.ju_regex_Matcher__f_regionStart0 = start;
  var this$1 = this.ju_regex_Matcher__f_java$util$regex$Matcher$$input0;
  this.ju_regex_Matcher__f_java$util$regex$Matcher$$inputstr = this$1.substring(start, end);
  return $p_ju_regex_Matcher__resetMatch__ju_regex_Matcher(this);
});
var $d_ju_regex_Matcher = new $TypeData().initClass($c_ju_regex_Matcher, "java.util.regex.Matcher", ({
  ju_regex_Matcher: 1,
  ju_regex_MatchResult: 1
}));
export { $d_ju_regex_Matcher as $d_ju_regex_Matcher };
/** @constructor */
function $c_ju_regex_Pattern(_pattern, _flags, jsPattern, jsFlags, sticky, groupCount, groupNumberMap, namedGroups) {
  this.ju_regex_Pattern__f__pattern = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = false;
  this.ju_regex_Pattern__f_groupCount = 0;
  this.ju_regex_Pattern__f_groupNumberMap = null;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = null;
  this.ju_regex_Pattern__f_jsRegExpForMatches = null;
  this.ju_regex_Pattern__f__pattern = _pattern;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags = jsFlags;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky = sticky;
  this.ju_regex_Pattern__f_groupCount = groupCount;
  this.ju_regex_Pattern__f_groupNumberMap = groupNumberMap;
  this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind = new RegExp(jsPattern, (this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsFlags + (this.ju_regex_Pattern__f_java$util$regex$Pattern$$sticky ? "gy" : "g")));
  this.ju_regex_Pattern__f_jsRegExpForMatches = new RegExp((("^(?:" + jsPattern) + ")$"), jsFlags);
}
export { $c_ju_regex_Pattern as $c_ju_regex_Pattern };
$c_ju_regex_Pattern.prototype = new $h_O();
$c_ju_regex_Pattern.prototype.constructor = $c_ju_regex_Pattern;
/** @constructor */
function $h_ju_regex_Pattern() {
}
export { $h_ju_regex_Pattern as $h_ju_regex_Pattern };
$h_ju_regex_Pattern.prototype = $c_ju_regex_Pattern.prototype;
$c_ju_regex_Pattern.prototype.execMatches__T__O = (function(input) {
  return this.ju_regex_Pattern__f_jsRegExpForMatches.exec(input);
});
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$execFindInternal__T__I__O = (function(input, start) {
  var regexp = this.ju_regex_Pattern__f_java$util$regex$Pattern$$jsRegExpForFind;
  regexp.lastIndex = start;
  return regexp.exec(input);
});
$c_ju_regex_Pattern.prototype.numberedGroup__I__I = (function(group) {
  if (((group < 0) || (group > this.ju_regex_Pattern__f_groupCount))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + group));
  }
  return (this.ju_regex_Pattern__f_groupNumberMap[group] | 0);
});
$c_ju_regex_Pattern.prototype.toString__T = (function() {
  return this.ju_regex_Pattern__f__pattern;
});
$c_ju_regex_Pattern.prototype.java$util$regex$Pattern$$split__T__I__AT = (function(inputStr, limit) {
  if ((inputStr === "")) {
    return new ($d_T.getArrayOf().constr)([""]);
  } else {
    var lim = ((limit > 0) ? limit : 2147483647);
    var matcher = new $c_ju_regex_Matcher(this, inputStr);
    var result = [];
    var prevEnd = 0;
    while ((((result.length | 0) < (((-1) + lim) | 0)) && matcher.find__Z())) {
      if ((matcher.end__I() !== 0)) {
        var beginIndex = prevEnd;
        var endIndex = matcher.start__I();
        var $x_1 = result.push(inputStr.substring(beginIndex, endIndex));
      }
      prevEnd = matcher.end__I();
    }
    var beginIndex$1 = prevEnd;
    result.push(inputStr.substring(beginIndex$1));
    var actualLength = (result.length | 0);
    if ((limit === 0)) {
      while (true) {
        if ((actualLength !== 0)) {
          var x = result[(((-1) + actualLength) | 0)];
          var $x_2 = ((x !== null) && $dp_equals__O__Z(x, ""));
        } else {
          var $x_2 = false;
        }
        if ($x_2) {
          actualLength = (((-1) + actualLength) | 0);
        } else {
          break;
        }
      }
    }
    var r = new ($d_T.getArrayOf().constr)(actualLength);
    var end = actualLength;
    var i = 0;
    while ((i < end)) {
      var value = i;
      r.u[value] = result[value];
      i = ((1 + i) | 0);
    }
    return r;
  }
});
var $d_ju_regex_Pattern = new $TypeData().initClass($c_ju_regex_Pattern, "java.util.regex.Pattern", ({
  ju_regex_Pattern: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_regex_Pattern as $d_ju_regex_Pattern };
/** @constructor */
function $c_Llocales_cldr_fallback_LocalesProvider$() {
}
export { $c_Llocales_cldr_fallback_LocalesProvider$ as $c_Llocales_cldr_fallback_LocalesProvider$ };
$c_Llocales_cldr_fallback_LocalesProvider$.prototype = new $h_O();
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.constructor = $c_Llocales_cldr_fallback_LocalesProvider$;
/** @constructor */
function $h_Llocales_cldr_fallback_LocalesProvider$() {
}
export { $h_Llocales_cldr_fallback_LocalesProvider$ as $h_Llocales_cldr_fallback_LocalesProvider$ };
$h_Llocales_cldr_fallback_LocalesProvider$.prototype = $c_Llocales_cldr_fallback_LocalesProvider$.prototype;
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.ldmls__sci_Map = (function() {
  var $x_10 = $m_s_Predef$();
  var xs = $m_Llocales_cldr_fallback_data_\uff3fall\uff3f$().all__ALlocales_cldr_LDML();
  var f = ((x$1) => {
    var _1 = x$1.toLocale__ju_Locale().toLanguageTag__T();
    return $ct_T2__O__O__(new $c_T2(), _1, x$1);
  });
  var len = xs.u.length;
  var ys = new ($d_T2.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = xs.u[i];
        ys.u[$x_1] = f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = xs.u[i];
        ys.u[$x_2] = f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = xs.u[i];
        ys.u[$x_3] = f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_J)) {
      while ((i < len)) {
        var $x_4 = i;
        var t = xs.u[i];
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.u[$x_4] = f(new $c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_F)) {
      while ((i < len)) {
        var $x_5 = i;
        var x0$3 = xs.u[i];
        ys.u[$x_5] = f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_C)) {
      while ((i < len)) {
        var $x_6 = i;
        var x0$4 = xs.u[i];
        ys.u[$x_6] = f($bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_B)) {
      while ((i < len)) {
        var $x_7 = i;
        var x0$5 = xs.u[i];
        ys.u[$x_7] = f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_S)) {
      while ((i < len)) {
        var $x_8 = i;
        var x0$6 = xs.u[i];
        ys.u[$x_8] = f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_Z)) {
      while ((i < len)) {
        var $x_9 = i;
        var x0$7 = xs.u[i];
        ys.u[$x_9] = f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $c_s_MatchError(xs);
    }
  }
  var this$8 = $x_10.wrapRefArray__AO__scm_ArraySeq$ofRef(ys);
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$8);
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.currencyData__Llocales_cldr_CurrencyData = (function() {
  return new $c_Llocales_cldr_CurrencyData($m_sci_Seq$().empty__sc_SeqOps(), $m_sci_Seq$().empty__sc_SeqOps(), $m_sci_Seq$().empty__sc_SeqOps(), $m_sci_Seq$().empty__sc_SeqOps());
});
$c_Llocales_cldr_fallback_LocalesProvider$.prototype.metadata__Llocales_cldr_CLDRMetadata = (function() {
  return new $c_Llocales_cldr_CLDRMetadata(new ($d_T.getArrayOf().constr)(0), $m_sci_Map$EmptyMap$(), new ($d_T.getArrayOf().constr)(0), $m_sci_Map$EmptyMap$(), new ($d_T.getArrayOf().constr)(0));
});
var $d_Llocales_cldr_fallback_LocalesProvider$ = new $TypeData().initClass($c_Llocales_cldr_fallback_LocalesProvider$, "locales.cldr.fallback.LocalesProvider$", ({
  Llocales_cldr_fallback_LocalesProvider$: 1,
  Llocales_cldr_LocalesProvider: 1
}));
export { $d_Llocales_cldr_fallback_LocalesProvider$ as $d_Llocales_cldr_fallback_LocalesProvider$ };
var $n_Llocales_cldr_fallback_LocalesProvider$;
function $m_Llocales_cldr_fallback_LocalesProvider$() {
  if ((!$n_Llocales_cldr_fallback_LocalesProvider$)) {
    $n_Llocales_cldr_fallback_LocalesProvider$ = new $c_Llocales_cldr_fallback_LocalesProvider$();
  }
  return $n_Llocales_cldr_fallback_LocalesProvider$;
}
export { $m_Llocales_cldr_fallback_LocalesProvider$ as $m_Llocales_cldr_fallback_LocalesProvider$ };
/** @constructor */
function $c_Lmagnolia1_CallByNeed(eval$1, supportDynamicValueEvaluation) {
  this.Lmagnolia1_CallByNeed__f_eval = null;
  this.Lmagnolia1_CallByNeed__f_supportDynamicValueEvaluation = null;
  this.Lmagnolia1_CallByNeed__f_valueEvaluator = null;
  this.Lmagnolia1_CallByNeed__f_value$lzy1 = null;
  this.Lmagnolia1_CallByNeed__f_valuebitmap$1 = false;
  this.Lmagnolia1_CallByNeed__f_eval = eval$1;
  this.Lmagnolia1_CallByNeed__f_supportDynamicValueEvaluation = supportDynamicValueEvaluation;
  if ((!(!this.Lmagnolia1_CallByNeed__f_supportDynamicValueEvaluation.apply__O()))) {
    var value = this.Lmagnolia1_CallByNeed__f_eval;
    var res = new $c_s_Some(value);
    this.Lmagnolia1_CallByNeed__f_eval = null;
    var finalRes = res;
  } else {
    var finalRes = $m_s_None$();
  }
  this.Lmagnolia1_CallByNeed__f_supportDynamicValueEvaluation = null;
  this.Lmagnolia1_CallByNeed__f_valueEvaluator = finalRes;
}
export { $c_Lmagnolia1_CallByNeed as $c_Lmagnolia1_CallByNeed };
$c_Lmagnolia1_CallByNeed.prototype = new $h_O();
$c_Lmagnolia1_CallByNeed.prototype.constructor = $c_Lmagnolia1_CallByNeed;
/** @constructor */
function $h_Lmagnolia1_CallByNeed() {
}
export { $h_Lmagnolia1_CallByNeed as $h_Lmagnolia1_CallByNeed };
$h_Lmagnolia1_CallByNeed.prototype = $c_Lmagnolia1_CallByNeed.prototype;
$c_Lmagnolia1_CallByNeed.prototype.value__O = (function() {
  if ((!this.Lmagnolia1_CallByNeed__f_valuebitmap$1)) {
    if ((this.Lmagnolia1_CallByNeed__f_eval === null)) {
      var $x_1 = this.Lmagnolia1_CallByNeed__f_valueEvaluator.get__O().apply__O();
    } else {
      var result = this.Lmagnolia1_CallByNeed__f_eval.apply__O();
      this.Lmagnolia1_CallByNeed__f_eval = null;
      var $x_1 = result;
    }
    this.Lmagnolia1_CallByNeed__f_value$lzy1 = $x_1;
    this.Lmagnolia1_CallByNeed__f_valuebitmap$1 = true;
  }
  return this.Lmagnolia1_CallByNeed__f_value$lzy1;
});
var $d_Lmagnolia1_CallByNeed = new $TypeData().initClass($c_Lmagnolia1_CallByNeed, "magnolia1.CallByNeed", ({
  Lmagnolia1_CallByNeed: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lmagnolia1_CallByNeed as $d_Lmagnolia1_CallByNeed };
function $ct_Lmagnolia1_CaseClass__Lmagnolia1_TypeInfo__Z__Z__ALmagnolia1_CaseClass$Param__O__O__O__($thiz, typeInfo, isObject, isValueClass, parameters, annotations, inheritedAnnotations, typeAnnotations) {
  $thiz.Lmagnolia1_CaseClass__f_typeInfo = typeInfo;
  $thiz.Lmagnolia1_CaseClass__f_isValueClass = isValueClass;
  $thiz.Lmagnolia1_CaseClass__f_parameters = parameters;
  $thiz.Lmagnolia1_CaseClass__f_annotations = annotations;
  $thiz.Lmagnolia1_CaseClass__f_inheritedAnnotations = inheritedAnnotations;
  return $thiz;
}
export { $ct_Lmagnolia1_CaseClass__Lmagnolia1_TypeInfo__Z__Z__ALmagnolia1_CaseClass$Param__O__O__O__ as $ct_Lmagnolia1_CaseClass__Lmagnolia1_TypeInfo__Z__Z__ALmagnolia1_CaseClass$Param__O__O__O__ };
/** @constructor */
function $c_Lmagnolia1_CaseClass() {
  this.Lmagnolia1_CaseClass__f_typeInfo = null;
  this.Lmagnolia1_CaseClass__f_isValueClass = false;
  this.Lmagnolia1_CaseClass__f_parameters = null;
  this.Lmagnolia1_CaseClass__f_annotations = null;
  this.Lmagnolia1_CaseClass__f_inheritedAnnotations = null;
}
export { $c_Lmagnolia1_CaseClass as $c_Lmagnolia1_CaseClass };
$c_Lmagnolia1_CaseClass.prototype = new $h_O();
$c_Lmagnolia1_CaseClass.prototype.constructor = $c_Lmagnolia1_CaseClass;
/** @constructor */
function $h_Lmagnolia1_CaseClass() {
}
export { $h_Lmagnolia1_CaseClass as $h_Lmagnolia1_CaseClass };
$h_Lmagnolia1_CaseClass.prototype = $c_Lmagnolia1_CaseClass.prototype;
$c_Lmagnolia1_CaseClass.prototype.toString__T = (function() {
  var $x_1 = this.Lmagnolia1_CaseClass__f_typeInfo.full__T();
  var this$1 = $m_s_IArray$package$IArray$().wrapRefArray__AO__sci_ArraySeq$ofRef(this.Lmagnolia1_CaseClass__f_parameters);
  return (((("CaseClass(" + $x_1) + ", ") + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", ",", "")) + ")");
});
function $f_Lmagnolia1_CaseClass$Param__toString__T($thiz) {
  return (("Param(" + $thiz.Lmagnolia1_CaseClass$Param$$anon$2__f_label) + ")");
}
export { $f_Lmagnolia1_CaseClass$Param__toString__T as $f_Lmagnolia1_CaseClass$Param__toString__T };
var $d_Lmagnolia1_CaseClass$Param = new $TypeData().initClass(1, "magnolia1.CaseClass$Param", ({
  Lmagnolia1_CaseClass$Param: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lmagnolia1_CaseClass$Param as $d_Lmagnolia1_CaseClass$Param };
/** @constructor */
function $c_s_$less$colon$less$() {
  this.s_$less$colon$less$__f_singleton = null;
  $n_s_$less$colon$less$ = this;
  this.s_$less$colon$less$__f_singleton = new $c_s_$less$colon$less$$anon$1();
}
export { $c_s_$less$colon$less$ as $c_s_$less$colon$less$ };
$c_s_$less$colon$less$.prototype = new $h_O();
$c_s_$less$colon$less$.prototype.constructor = $c_s_$less$colon$less$;
/** @constructor */
function $h_s_$less$colon$less$() {
}
export { $h_s_$less$colon$less$ as $h_s_$less$colon$less$ };
$h_s_$less$colon$less$.prototype = $c_s_$less$colon$less$.prototype;
var $d_s_$less$colon$less$ = new $TypeData().initClass($c_s_$less$colon$less$, "scala.$less$colon$less$", ({
  s_$less$colon$less$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_$less$colon$less$ as $d_s_$less$colon$less$ };
var $n_s_$less$colon$less$;
function $m_s_$less$colon$less$() {
  if ((!$n_s_$less$colon$less$)) {
    $n_s_$less$colon$less$ = new $c_s_$less$colon$less$();
  }
  return $n_s_$less$colon$less$;
}
export { $m_s_$less$colon$less$ as $m_s_$less$colon$less$ };
function $p_s_Array$__slowcopy__O__I__O__I__I__V($thiz, src, srcPos, dest, destPos, length) {
  var i = srcPos;
  var j = destPos;
  var srcUntil = ((srcPos + length) | 0);
  while ((i < srcUntil)) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest, j, $m_sr_ScalaRunTime$().array_apply__O__I__O(src, i));
    i = ((1 + i) | 0);
    j = ((1 + j) | 0);
  }
}
export { $p_s_Array$__slowcopy__O__I__O__I__I__V as $p_s_Array$__slowcopy__O__I__O__I__I__V };
function $p_s_Array$__newUnitArray__I__Ajl_Void($thiz, len) {
  var result = new ($d_jl_Void.getArrayOf().constr)(len);
  $m_ju_Arrays$().fill__AO__O__V(result, (void 0));
  return result;
}
export { $p_s_Array$__newUnitArray__I__Ajl_Void as $p_s_Array$__newUnitArray__I__Ajl_Void };
/** @constructor */
function $c_s_Array$() {
}
export { $c_s_Array$ as $c_s_Array$ };
$c_s_Array$.prototype = new $h_O();
$c_s_Array$.prototype.constructor = $c_s_Array$;
/** @constructor */
function $h_s_Array$() {
}
export { $h_s_Array$ as $h_s_Array$ };
$h_s_Array$.prototype = $c_s_Array$.prototype;
$c_s_Array$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__O = (function(it, evidence$3) {
  var n = it.knownSize__I();
  if ((n > (-1))) {
    var elements = evidence$3.newArray__I__O(n);
    var iterator = it.iterator__sc_Iterator();
    var i = 0;
    while ((i < n)) {
      $m_sr_ScalaRunTime$().array_update__O__I__O__V(elements, i, iterator.next__O());
      i = ((1 + i) | 0);
    }
    return elements;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$3.runtimeClass__jl_Class();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
    jsElems = [];
    var iterator$2 = it.iterator__sc_Iterator();
    while (iterator$2.hasNext__Z()) {
      var elem = iterator$2.next__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.data.zero : elem));
      jsElems.push(unboxedElem);
    }
    var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
    return elemRuntimeClass.data.getArrayOf().wrapArray(jsElems);
  }
});
$c_s_Array$.prototype.copy__O__I__O__I__I__V = (function(src, srcPos, dest, destPos, length) {
  var srcClass = $objectGetClass(src);
  if (srcClass.data.isArrayClass) {
    var this$1 = $objectGetClass(dest);
    var $x_1 = this$1.data.isAssignableFrom(srcClass.data);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    src.copyTo(srcPos, dest, destPos, length);
  } else {
    $p_s_Array$__slowcopy__O__I__O__I__I__V(this, src, srcPos, dest, destPos, length);
  }
});
$c_s_Array$.prototype.copyOf__O__I__O = (function(original, newLength) {
  if ($isArrayOf_jl_Void(original, 1)) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength);
  } else if ((original instanceof $ac_O)) {
    return $m_ju_Arrays$().copyOf__AO__I__AO(original, newLength);
  } else if ((original instanceof $ac_I)) {
    return $m_ju_Arrays$().copyOf__AI__I__AI(original, newLength);
  } else if ((original instanceof $ac_D)) {
    return $m_ju_Arrays$().copyOf__AD__I__AD(original, newLength);
  } else if ((original instanceof $ac_J)) {
    return $m_ju_Arrays$().copyOf__AJ__I__AJ(original, newLength);
  } else if ((original instanceof $ac_F)) {
    return $m_ju_Arrays$().copyOf__AF__I__AF(original, newLength);
  } else if ((original instanceof $ac_C)) {
    return $m_ju_Arrays$().copyOf__AC__I__AC(original, newLength);
  } else if ((original instanceof $ac_B)) {
    return $m_ju_Arrays$().copyOf__AB__I__AB(original, newLength);
  } else if ((original instanceof $ac_S)) {
    return $m_ju_Arrays$().copyOf__AS__I__AS(original, newLength);
  } else if ((original instanceof $ac_Z)) {
    return $m_ju_Arrays$().copyOf__AZ__I__AZ(original, newLength);
  } else {
    throw new $c_s_MatchError(original);
  }
});
$c_s_Array$.prototype.copyAs__O__I__s_reflect_ClassTag__O = (function(original, newLength, ct) {
  var runtimeClass = ct.runtimeClass__jl_Class();
  if (((runtimeClass !== null) && (runtimeClass === $d_V.getClassOf()))) {
    return $p_s_Array$__newUnitArray__I__Ajl_Void(this, newLength);
  } else {
    var this$1 = $objectGetClass(original);
    var that = this$1.data.getComponentType();
    if (runtimeClass.data.isAssignableFrom(that.data)) {
      if (runtimeClass.data.isPrimitive) {
        return this.copyOf__O__I__O(original, newLength);
      } else {
        var this$3 = runtimeClass.data.newArray(0);
        var destArrayClass = $objectGetClass(this$3);
        return $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, destArrayClass);
      }
    } else {
      var dest = ct.newArray__I__O(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(original));
      return dest;
    }
  }
});
$c_s_Array$.prototype.apply__sci_Seq__s_reflect_ClassTag__O = (function(xs, evidence$5) {
  var array = evidence$5.newArray__I__O(xs.length__I());
  var iterator = xs.iterator__sc_Iterator();
  var i = 0;
  while (iterator.hasNext__Z()) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(array, i, iterator.next__O());
    i = ((1 + i) | 0);
  }
  return array;
});
$c_s_Array$.prototype.equals__AO__AO__Z = (function(xs, ys) {
  if ((xs === ys)) {
    return true;
  }
  if ((xs.u.length !== ys.u.length)) {
    return false;
  }
  var len = xs.u.length;
  var i = 0;
  while ((i < len)) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(xs.u[i], ys.u[i]))) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
var $d_s_Array$ = new $TypeData().initClass($c_s_Array$, "scala.Array$", ({
  s_Array$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_Array$ as $d_s_Array$ };
var $n_s_Array$;
function $m_s_Array$() {
  if ((!$n_s_Array$)) {
    $n_s_Array$ = new $c_s_Array$();
  }
  return $n_s_Array$;
}
export { $m_s_Array$ as $m_s_Array$ };
/** @constructor */
function $c_s_CanEqual$derived$() {
}
export { $c_s_CanEqual$derived$ as $c_s_CanEqual$derived$ };
$c_s_CanEqual$derived$.prototype = new $h_O();
$c_s_CanEqual$derived$.prototype.constructor = $c_s_CanEqual$derived$;
/** @constructor */
function $h_s_CanEqual$derived$() {
}
export { $h_s_CanEqual$derived$ as $h_s_CanEqual$derived$ };
$h_s_CanEqual$derived$.prototype = $c_s_CanEqual$derived$.prototype;
var $d_s_CanEqual$derived$ = new $TypeData().initClass($c_s_CanEqual$derived$, "scala.CanEqual$derived$", ({
  s_CanEqual$derived$: 1,
  s_CanEqual: 1
}));
export { $d_s_CanEqual$derived$ as $d_s_CanEqual$derived$ };
var $n_s_CanEqual$derived$;
function $m_s_CanEqual$derived$() {
  if ((!$n_s_CanEqual$derived$)) {
    $n_s_CanEqual$derived$ = new $c_s_CanEqual$derived$();
  }
  return $n_s_CanEqual$derived$;
}
export { $m_s_CanEqual$derived$ as $m_s_CanEqual$derived$ };
/** @constructor */
function $c_s_Conversion() {
}
export { $c_s_Conversion as $c_s_Conversion };
$c_s_Conversion.prototype = new $h_O();
$c_s_Conversion.prototype.constructor = $c_s_Conversion;
/** @constructor */
function $h_s_Conversion() {
}
export { $h_s_Conversion as $h_s_Conversion };
$h_s_Conversion.prototype = $c_s_Conversion.prototype;
$c_s_Conversion.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_Conversion.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_s_Conversion.prototype.toString__T = (function() {
  return "<function1>";
});
$c_s_Conversion.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!this.apply__O__O(v1)));
});
/** @constructor */
function $c_s_LowPriorityImplicits() {
}
export { $c_s_LowPriorityImplicits as $c_s_LowPriorityImplicits };
$c_s_LowPriorityImplicits.prototype = new $h_s_LowPriorityImplicits2();
$c_s_LowPriorityImplicits.prototype.constructor = $c_s_LowPriorityImplicits;
/** @constructor */
function $h_s_LowPriorityImplicits() {
}
export { $h_s_LowPriorityImplicits as $h_s_LowPriorityImplicits };
$h_s_LowPriorityImplicits.prototype = $c_s_LowPriorityImplicits.prototype;
$c_s_LowPriorityImplicits.prototype.wrapRefArray__AO__scm_ArraySeq$ofRef = (function(xs) {
  if ((xs === null)) {
    return null;
  } else if ((xs.u.length === 0)) {
    var this$1 = $m_scm_ArraySeq$();
    return this$1.scm_ArraySeq$__f_EmptyArraySeq;
  } else {
    return new $c_scm_ArraySeq$ofRef(xs);
  }
});
$c_s_LowPriorityImplicits.prototype.wrapString__T__sci_WrappedString = (function(s) {
  return ((s !== null) ? new $c_sci_WrappedString(s) : null);
});
/** @constructor */
function $c_s_Option$() {
}
export { $c_s_Option$ as $c_s_Option$ };
$c_s_Option$.prototype = new $h_O();
$c_s_Option$.prototype.constructor = $c_s_Option$;
/** @constructor */
function $h_s_Option$() {
}
export { $h_s_Option$ as $h_s_Option$ };
$h_s_Option$.prototype = $c_s_Option$.prototype;
$c_s_Option$.prototype.option2Iterable__s_Option__sc_Iterable = (function(xo) {
  if (xo.isEmpty__Z()) {
    return $m_sc_Iterable$().empty__O();
  } else {
    var a = xo.get__O();
    return new $c_sc_Iterable$$anon$1(a);
  }
});
$c_s_Option$.prototype.apply__O__s_Option = (function(x) {
  return ((x === null) ? $m_s_None$() : new $c_s_Some(x));
});
$c_s_Option$.prototype.when__Z__F0__s_Option = (function(cond, a) {
  return (cond ? new $c_s_Some(a.apply__O()) : $m_s_None$());
});
var $d_s_Option$ = new $TypeData().initClass($c_s_Option$, "scala.Option$", ({
  s_Option$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_Option$ as $d_s_Option$ };
var $n_s_Option$;
function $m_s_Option$() {
  if ((!$n_s_Option$)) {
    $n_s_Option$ = new $c_s_Option$();
  }
  return $n_s_Option$;
}
export { $m_s_Option$ as $m_s_Option$ };
function $f_s_PartialFunction__andThen__F1__s_PartialFunction($thiz, k) {
  return ($is_s_PartialFunction(k) ? new $c_s_PartialFunction$Combined($thiz, k) : new $c_s_PartialFunction$AndThen($thiz, k));
}
export { $f_s_PartialFunction__andThen__F1__s_PartialFunction as $f_s_PartialFunction__andThen__F1__s_PartialFunction };
function $f_s_PartialFunction__applyOrElse__O__F1__O($thiz, x, default$1) {
  return ($thiz.isDefinedAt__O__Z(x) ? $thiz.apply__O__O(x) : default$1.apply__O__O(x));
}
export { $f_s_PartialFunction__applyOrElse__O__F1__O as $f_s_PartialFunction__applyOrElse__O__F1__O };
function $f_s_PartialFunction__runWith__F1__F1($thiz, action) {
  return new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => {
    var z = $thiz.applyOrElse__O__F1__O(x$2$2, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
    return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) && (action.apply__O__O(z), true));
  }));
}
export { $f_s_PartialFunction__runWith__F1__F1 as $f_s_PartialFunction__runWith__F1__F1 };
function $is_s_PartialFunction(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_PartialFunction)));
}
export { $is_s_PartialFunction as $is_s_PartialFunction };
function $isArrayOf_s_PartialFunction(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_PartialFunction)));
}
export { $isArrayOf_s_PartialFunction as $isArrayOf_s_PartialFunction };
function $f_s_Product__productElementName__I__T($thiz, n) {
  if (((n >= 0) && (n < $thiz.productArity__I()))) {
    return "";
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((n + " is out of bounds (min 0, max ") + (((-1) + $thiz.productArity__I()) | 0)) + ")"));
  }
}
export { $f_s_Product__productElementName__I__T as $f_s_Product__productElementName__I__T };
function $is_s_Product(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_Product)));
}
export { $is_s_Product as $is_s_Product };
function $isArrayOf_s_Product(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Product)));
}
export { $isArrayOf_s_Product as $isArrayOf_s_Product };
function $p_s_StringContext$__readUEscape__T__I__T2($thiz, src, startindex) {
  var len = src.length;
  return $p_s_StringContext$__loop$1__I__I__I__T__T2($thiz, startindex, startindex, len, src);
}
export { $p_s_StringContext$__readUEscape__T__I__T2 as $p_s_StringContext$__readUEscape__T__I__T2 };
function $p_s_StringContext$__replace__T__I__T($thiz, str, first) {
  var len = str.length;
  var b = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  return $p_s_StringContext$__loop$2__I__I__jl_StringBuilder__T__I__T($thiz, 0, first, b, str, len);
}
export { $p_s_StringContext$__replace__T__I__T as $p_s_StringContext$__replace__T__I__T };
function $p_s_StringContext$__loopCP$1__I__I__I__I__I__T__T2($thiz, dindex, codepoint, uindex$1, startindex$1, len$1, src$1) {
  while (true) {
    if ((dindex >= 4)) {
      var usRead = ((uindex$1 - startindex$1) | 0);
      var digitsRead = dindex;
      return new $c_T2$mcCI$sp((65535 & codepoint), ((usRead + digitsRead) | 0));
    } else if ((((dindex + uindex$1) | 0) >= len$1)) {
      throw new $c_s_StringContext$InvalidUnicodeEscapeException(src$1, startindex$1, ((uindex$1 + dindex) | 0));
    } else {
      var i = ((dindex + uindex$1) | 0);
      var ch = src$1.charCodeAt(i);
      var this$5 = $m_jl_Character$();
      var codePoint = ch;
      var e = this$5.digitWithValidRadix__I__I__I(codePoint, 36);
      if (((e >= 0) && (e <= 15))) {
        var temp$dindex = ((1 + dindex) | 0);
        var temp$codepoint = (((codepoint << 4) + e) | 0);
        dindex = temp$dindex;
        codepoint = temp$codepoint;
      } else {
        throw new $c_s_StringContext$InvalidUnicodeEscapeException(src$1, startindex$1, ((uindex$1 + dindex) | 0));
      }
    }
  }
}
export { $p_s_StringContext$__loopCP$1__I__I__I__I__I__T__T2 as $p_s_StringContext$__loopCP$1__I__I__I__I__I__T__T2 };
function $p_s_StringContext$__loop$1__I__I__I__T__T2($thiz, uindex, startindex$1, len$1, src$1) {
  while (true) {
    if ((uindex >= len$1)) {
      throw new $c_s_StringContext$InvalidUnicodeEscapeException(src$1, startindex$1, (((-1) + uindex) | 0));
    } else {
      var i = uindex;
      if ((src$1.charCodeAt(i) === 117)) {
        uindex = ((1 + uindex) | 0);
      } else {
        return $p_s_StringContext$__loopCP$1__I__I__I__I__I__T__T2($thiz, 0, 0, uindex, startindex$1, len$1, src$1);
      }
    }
  }
}
export { $p_s_StringContext$__loop$1__I__I__I__T__T2 as $p_s_StringContext$__loop$1__I__I__I__T__T2 };
function $p_s_StringContext$__loop$2__I__I__jl_StringBuilder__T__I__T($thiz, i, next, b$2, str$1, len$2) {
  while ((next >= 0)) {
    if ((next > i)) {
      b$2.append__jl_CharSequence__I__I__jl_StringBuilder(str$1, i, next);
    }
    var idx = ((1 + next) | 0);
    if ((idx >= len$2)) {
      throw new $c_s_StringContext$InvalidEscapeException(str$1, next);
    }
    var i$1 = idx;
    var x1 = str$1.charCodeAt(i$1);
    switch (x1) {
      case 117: {
        var c = 117;
        break;
      }
      case 98: {
        var c = 8;
        break;
      }
      case 116: {
        var c = 9;
        break;
      }
      case 110: {
        var c = 10;
        break;
      }
      case 102: {
        var c = 12;
        break;
      }
      case 114: {
        var c = 13;
        break;
      }
      case 34: {
        var c = 34;
        break;
      }
      case 39: {
        var c = 39;
        break;
      }
      case 92: {
        var c = 92;
        break;
      }
      default: {
        var c;
        throw new $c_s_StringContext$InvalidEscapeException(str$1, next);
      }
    }
    var x1$2 = ((c === 117) ? $p_s_StringContext$__readUEscape__T__I__T2($thiz, str$1, idx) : new $c_T2$mcCI$sp(c, 1));
    if ((x1$2 === null)) {
      throw new $c_s_MatchError(x1$2);
    }
    var ch = x1$2._1$mcC$sp__C();
    var advance = x1$2._2$mcI$sp__I();
    idx = ((idx + advance) | 0);
    var str = ("" + $cToS(ch));
    b$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b$2.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
    var temp$i = idx;
    var temp$next = $f_T__indexOf__I__I__I(str$1, 92, idx);
    i = temp$i;
    next = temp$next;
  }
  if ((i < len$2)) {
    b$2.append__jl_CharSequence__I__I__jl_StringBuilder(str$1, i, len$2);
  }
  return b$2.jl_StringBuilder__f_java$lang$StringBuilder$$content;
}
export { $p_s_StringContext$__loop$2__I__I__jl_StringBuilder__T__I__T as $p_s_StringContext$__loop$2__I__I__jl_StringBuilder__T__I__T };
/** @constructor */
function $c_s_StringContext$() {
}
export { $c_s_StringContext$ as $c_s_StringContext$ };
$c_s_StringContext$.prototype = new $h_O();
$c_s_StringContext$.prototype.constructor = $c_s_StringContext$;
/** @constructor */
function $h_s_StringContext$() {
}
export { $h_s_StringContext$ as $h_s_StringContext$ };
$h_s_StringContext$.prototype = $c_s_StringContext$.prototype;
$c_s_StringContext$.prototype.processEscapes__T__T = (function(str) {
  var x1 = $f_T__indexOf__I__I(str, 92);
  return ((x1 === (-1)) ? str : $p_s_StringContext$__replace__T__I__T(this, str, x1));
});
$c_s_StringContext$.prototype.checkLengths__sc_Seq__sci_Seq__V = (function(args, parts) {
  if ((parts.length__I() !== ((1 + args.length__I()) | 0))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("wrong number of arguments (" + args.length__I()) + ") for interpolated string with ") + parts.length__I()) + " parts"));
  }
});
var $d_s_StringContext$ = new $TypeData().initClass($c_s_StringContext$, "scala.StringContext$", ({
  s_StringContext$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_StringContext$ as $d_s_StringContext$ };
var $n_s_StringContext$;
function $m_s_StringContext$() {
  if ((!$n_s_StringContext$)) {
    $n_s_StringContext$ = new $c_s_StringContext$();
  }
  return $n_s_StringContext$;
}
export { $m_s_StringContext$ as $m_s_StringContext$ };
/** @constructor */
function $c_sc_WithFilter() {
}
export { $c_sc_WithFilter as $c_sc_WithFilter };
$c_sc_WithFilter.prototype = new $h_O();
$c_sc_WithFilter.prototype.constructor = $c_sc_WithFilter;
/** @constructor */
function $h_sc_WithFilter() {
}
export { $h_sc_WithFilter as $h_sc_WithFilter };
$h_sc_WithFilter.prototype = $c_sc_WithFilter.prototype;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1(outer) {
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer = outer;
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui = outer.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying.iterator__sc_Iterator();
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = $m_s_None$();
}
export { $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1 as $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1 };
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype = new $h_O();
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1() {
}
export { $h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1 as $h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1 };
$h_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype = $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype;
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.hasNext__Z = (function() {
  return this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui.hasNext__Z();
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.next__O = (function() {
  var e = this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_ui.next__O();
  this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = new $c_s_Some(e);
  return e;
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1.prototype.remove__V = (function() {
  var x1 = this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev;
  if ((x1 instanceof $c_s_Some)) {
    var e = x1.s_Some__f_value;
    var x1$2 = this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_$outer.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying;
    if ($is_scm_Set(x1$2)) {
      x1$2.remove__O__Z(e);
      this.sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1__f_prev = $m_s_None$();
    } else {
      throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "remove");
    }
  } else {
    throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "next must be called at least once before remove");
  }
});
var $d_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1 = new $TypeData().initClass($c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1, "scala.collection.convert.JavaCollectionWrappers$SetWrapper$$anon$1", ({
  sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1: 1,
  ju_Iterator: 1
}));
export { $d_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1 as $d_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1 };
/** @constructor */
function $c_sci_LazyList$Uninitialized$() {
}
export { $c_sci_LazyList$Uninitialized$ as $c_sci_LazyList$Uninitialized$ };
$c_sci_LazyList$Uninitialized$.prototype = new $h_O();
$c_sci_LazyList$Uninitialized$.prototype.constructor = $c_sci_LazyList$Uninitialized$;
/** @constructor */
function $h_sci_LazyList$Uninitialized$() {
}
export { $h_sci_LazyList$Uninitialized$ as $h_sci_LazyList$Uninitialized$ };
$h_sci_LazyList$Uninitialized$.prototype = $c_sci_LazyList$Uninitialized$.prototype;
var $d_sci_LazyList$Uninitialized$ = new $TypeData().initClass($c_sci_LazyList$Uninitialized$, "scala.collection.immutable.LazyList$Uninitialized$", ({
  sci_LazyList$Uninitialized$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_LazyList$Uninitialized$ as $d_sci_LazyList$Uninitialized$ };
var $n_sci_LazyList$Uninitialized$;
function $m_sci_LazyList$Uninitialized$() {
  if ((!$n_sci_LazyList$Uninitialized$)) {
    $n_sci_LazyList$Uninitialized$ = new $c_sci_LazyList$Uninitialized$();
  }
  return $n_sci_LazyList$Uninitialized$;
}
export { $m_sci_LazyList$Uninitialized$ as $m_sci_LazyList$Uninitialized$ };
/** @constructor */
function $c_sci_List$$anon$1() {
}
export { $c_sci_List$$anon$1 as $c_sci_List$$anon$1 };
$c_sci_List$$anon$1.prototype = new $h_O();
$c_sci_List$$anon$1.prototype.constructor = $c_sci_List$$anon$1;
/** @constructor */
function $h_sci_List$$anon$1() {
}
export { $h_sci_List$$anon$1 as $h_sci_List$$anon$1 };
$h_sci_List$$anon$1.prototype = $c_sci_List$$anon$1.prototype;
$c_sci_List$$anon$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this;
});
$c_sci_List$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sci_List$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sci_List$$anon$1.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sci_List$$anon$1.prototype.apply__O__O = (function(x) {
  return this;
});
var $d_sci_List$$anon$1 = new $TypeData().initClass($c_sci_List$$anon$1, "scala.collection.immutable.List$$anon$1", ({
  sci_List$$anon$1: 1,
  F1: 1
}));
export { $d_sci_List$$anon$1 as $d_sci_List$$anon$1 };
/** @constructor */
function $c_sci_MapNode() {
}
export { $c_sci_MapNode as $c_sci_MapNode };
$c_sci_MapNode.prototype = new $h_sci_Node();
$c_sci_MapNode.prototype.constructor = $c_sci_MapNode;
/** @constructor */
function $h_sci_MapNode() {
}
export { $h_sci_MapNode as $h_sci_MapNode };
$h_sci_MapNode.prototype = $c_sci_MapNode.prototype;
function $p_sci_NumericRange$__bigDecimalCheckUnderflow__O__O__O__s_math_Integral__V($thiz, start, end, step, num) {
  if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(num.minus__O__O__O(num.plus__O__O__O(start, step), start), step))) {
    $ps_sci_NumericRange$__FAIL$1__O__O__V(start, step);
  }
  if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(num.minus__O__O__O(end, num.minus__O__O__O(end, step)), step))) {
    $ps_sci_NumericRange$__FAIL$1__O__O__V(end, step);
  }
}
export { $p_sci_NumericRange$__bigDecimalCheckUnderflow__O__O__O__s_math_Integral__V as $p_sci_NumericRange$__bigDecimalCheckUnderflow__O__O__O__s_math_Integral__V };
function $ps_sci_NumericRange$__FAIL$1__O__O__V(boundary, step) {
  if ((boundary instanceof $c_s_math_BigDecimal)) {
    var this$1 = boundary.s_math_BigDecimal__f_mc;
    var msg = ("Precision " + this$1.Ljava_math_MathContext__f_precision);
  } else {
    var msg = "Precision";
  }
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((msg + " inadequate to represent steps of size ") + step) + " near ") + boundary));
}
export { $ps_sci_NumericRange$__FAIL$1__O__O__V as $ps_sci_NumericRange$__FAIL$1__O__O__V };
function $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O(t, num$1, limit$1) {
  if ($f_s_math_Ordering__gt__O__O__Z(num$1, t, limit$1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "More than Int.MaxValue elements.");
  } else {
    return t;
  }
}
export { $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O as $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O };
/** @constructor */
function $c_sci_NumericRange$() {
  this.sci_NumericRange$__f_defaultOrdering = null;
  $n_sci_NumericRange$ = this;
  var this$14 = $m_sci_Map$();
  var self = $m_s_math_Numeric$IntIsIntegral$();
  var y = $m_s_math_Ordering$Int$();
  var x0 = $ct_T2__O__O__(new $c_T2(), self, y);
  var self$1 = $m_s_math_Numeric$ShortIsIntegral$();
  var y$1 = $m_s_math_Ordering$Short$();
  var x1 = $ct_T2__O__O__(new $c_T2(), self$1, y$1);
  var self$2 = $m_s_math_Numeric$ByteIsIntegral$();
  var y$2 = $m_s_math_Ordering$Byte$();
  var x2 = $ct_T2__O__O__(new $c_T2(), self$2, y$2);
  var self$3 = $m_s_math_Numeric$CharIsIntegral$();
  var y$3 = $m_s_math_Ordering$Char$();
  var x3 = $ct_T2__O__O__(new $c_T2(), self$3, y$3);
  var self$4 = $m_s_math_Numeric$LongIsIntegral$();
  var y$4 = $m_s_math_Ordering$Long$();
  var x4 = $ct_T2__O__O__(new $c_T2(), self$4, y$4);
  var array = [x0, x1, x2, x3, x4];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.sci_NumericRange$__f_defaultOrdering = this$14.from__sc_IterableOnce__sci_Map(elems);
}
export { $c_sci_NumericRange$ as $c_sci_NumericRange$ };
$c_sci_NumericRange$.prototype = new $h_O();
$c_sci_NumericRange$.prototype.constructor = $c_sci_NumericRange$;
/** @constructor */
function $h_sci_NumericRange$() {
}
export { $h_sci_NumericRange$ as $h_sci_NumericRange$ };
$h_sci_NumericRange$.prototype = $c_sci_NumericRange$.prototype;
$c_sci_NumericRange$.prototype.count__O__O__O__Z__s_math_Integral__I = (function(start, end, step, isInclusive, num) {
  var zero = num.fromInt__I__O(0);
  var upward = $f_s_math_Ordering__lt__O__O__Z(num, start, end);
  var posStep = $f_s_math_Ordering__gt__O__O__Z(num, step, zero);
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(step, zero)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(start, end)) {
    return (isInclusive ? 1 : 0);
  } else if ((upward !== posStep)) {
    return 0;
  } else {
    var startint = num.toInt__O__I(start);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(start, num.fromInt__I__O(startint))) {
      var endint = num.toInt__O__I(end);
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(end, num.fromInt__I__O(endint))) {
        var stepint = num.toInt__O__I(step);
        if ($m_sr_BoxesRunTime$().equals__O__O__Z(step, num.fromInt__I__O(stepint))) {
          if (isInclusive) {
            var isEmpty = ((stepint >= 0) ? (startint > endint) : (startint < endint));
            if ((stepint === 0)) {
              throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
            }
            var stepSign = (stepint >> 31);
            var gap = (((((endint - startint) | 0) ^ stepSign) - stepSign) | 0);
            var absStep = (((stepint ^ stepSign) - stepSign) | 0);
            var div = (((gap >>> 0) / ($checkIntDivisor(absStep) >>> 0)) | 0);
            var scala$collection$immutable$Range$$numRangeElements = ((1 + div) | 0);
            return (isEmpty ? 0 : ((scala$collection$immutable$Range$$numRangeElements > 0) ? scala$collection$immutable$Range$$numRangeElements : $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(startint, endint, stepint, true)));
          } else {
            var isEmpty$1 = ((stepint >= 0) ? (startint >= endint) : (startint <= endint));
            if ((stepint === 0)) {
              throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
            }
            var stepSign$1 = (stepint >> 31);
            var gap$1 = (((((endint - startint) | 0) ^ stepSign$1) - stepSign$1) | 0);
            var absStep$1 = (((stepint ^ stepSign$1) - stepSign$1) | 0);
            var div$1 = (((gap$1 >>> 0) / ($checkIntDivisor(absStep$1) >>> 0)) | 0);
            var scala$collection$immutable$Range$$numRangeElements$1 = ((Math.imul(absStep$1, div$1) !== gap$1) ? ((1 + div$1) | 0) : div$1);
            return (isEmpty$1 ? 0 : ((scala$collection$immutable$Range$$numRangeElements$1 > 0) ? scala$collection$immutable$Range$$numRangeElements$1 : $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(startint, endint, stepint, false)));
          }
        }
      }
    }
    if ($is_s_math_Numeric$BigDecimalAsIfIntegral(num)) {
      $p_sci_NumericRange$__bigDecimalCheckUnderflow__O__O__O__s_math_Integral__V(this, start, end, step, num);
    }
    var one = num.fromInt__I__O(1);
    var limit = num.fromInt__I__O(2147483647);
    var startside = num.sign__O__O(start);
    var endside = num.sign__O__O(end);
    if ($f_s_math_Ordering__gteq__O__O__Z(num, num.times__O__O__O(startside, endside), zero)) {
      var diff = num.minus__O__O__O(end, start);
      var quotient = $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O(num.quot__O__O__O(diff, step), num, limit);
      var remainder = num.minus__O__O__O(diff, num.times__O__O__O(quotient, step));
      var $x_1 = (((!isInclusive) && $m_sr_BoxesRunTime$().equals__O__O__Z(zero, remainder)) ? quotient : $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O(num.plus__O__O__O(quotient, one), num, limit));
    } else {
      var negone = num.fromInt__I__O((-1));
      var startlim = (posStep ? negone : one);
      var startdiff = (((posStep && $f_s_math_Ordering__lt__O__O__Z(num, startlim, start)) || ((!posStep) && $f_s_math_Ordering__gt__O__O__Z(num, startlim, start))) ? start : num.minus__O__O__O(startlim, start));
      var startq = $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O(num.quot__O__O__O(startdiff, step), num, limit);
      var waypointA = ($m_sr_BoxesRunTime$().equals__O__O__Z(startq, zero) ? start : num.plus__O__O__O(start, num.times__O__O__O(startq, step)));
      var waypointB = num.plus__O__O__O(waypointA, step);
      if (($f_s_math_Ordering__lt__O__O__Z(num, waypointB, end) !== upward)) {
        var $x_2 = ((isInclusive && $m_sr_BoxesRunTime$().equals__O__O__Z(waypointB, end)) ? num.plus__O__O__O(startq, num.fromInt__I__O(2)) : num.plus__O__O__O(startq, one));
      } else {
        var enddiff = num.minus__O__O__O(end, waypointB);
        var endq = $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O(num.quot__O__O__O(enddiff, step), num, limit);
        var last = ($m_sr_BoxesRunTime$().equals__O__O__Z(endq, zero) ? waypointB : num.plus__O__O__O(waypointB, num.times__O__O__O(endq, step)));
        var $x_2 = num.plus__O__O__O(startq, num.plus__O__O__O(endq, (((!isInclusive) && $m_sr_BoxesRunTime$().equals__O__O__Z(last, end)) ? one : num.fromInt__I__O(2))));
      }
      var $x_1 = $ps_sci_NumericRange$__check$1__O__s_math_Integral__O__O($x_2, num, limit);
    }
    return num.toInt__O__I($x_1);
  }
});
var $d_sci_NumericRange$ = new $TypeData().initClass($c_sci_NumericRange$, "scala.collection.immutable.NumericRange$", ({
  sci_NumericRange$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_NumericRange$ as $d_sci_NumericRange$ };
var $n_sci_NumericRange$;
function $m_sci_NumericRange$() {
  if ((!$n_sci_NumericRange$)) {
    $n_sci_NumericRange$ = new $c_sci_NumericRange$();
  }
  return $n_sci_NumericRange$;
}
export { $m_sci_NumericRange$ as $m_sci_NumericRange$ };
function $p_sci_Range$__description__I__I__I__Z__T($thiz, start, end, step, isInclusive) {
  return ((((start + (isInclusive ? " to " : " until ")) + end) + " by ") + step);
}
export { $p_sci_Range$__description__I__I__I__Z__T as $p_sci_Range$__description__I__I__I__Z__T };
/** @constructor */
function $c_sci_Range$() {
}
export { $c_sci_Range$ as $c_sci_Range$ };
$c_sci_Range$.prototype = new $h_O();
$c_sci_Range$.prototype.constructor = $c_sci_Range$;
/** @constructor */
function $h_sci_Range$() {
}
export { $h_sci_Range$ as $h_sci_Range$ };
$h_sci_Range$.prototype = $c_sci_Range$.prototype;
$c_sci_Range$.prototype.scala$collection$immutable$Range$$fail__I__I__I__Z__E = (function(start, end, step, isInclusive) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ($p_sci_Range$__description__I__I__I__Z__T(this, start, end, step, isInclusive) + ": seqs cannot contain more than Int.MaxValue elements."));
});
$c_sci_Range$.prototype.scala$collection$immutable$Range$$emptyRangeError__T__jl_Throwable = (function(what) {
  return $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), (what + " on empty Range"));
});
var $d_sci_Range$ = new $TypeData().initClass($c_sci_Range$, "scala.collection.immutable.Range$", ({
  sci_Range$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Range$ as $d_sci_Range$ };
var $n_sci_Range$;
function $m_sci_Range$() {
  if ((!$n_sci_Range$)) {
    $n_sci_Range$ = new $c_sci_Range$();
  }
  return $n_sci_Range$;
}
export { $m_sci_Range$ as $m_sci_Range$ };
/** @constructor */
function $c_sci_SetNode() {
}
export { $c_sci_SetNode as $c_sci_SetNode };
$c_sci_SetNode.prototype = new $h_sci_Node();
$c_sci_SetNode.prototype.constructor = $c_sci_SetNode;
/** @constructor */
function $h_sci_SetNode() {
}
export { $h_sci_SetNode as $h_sci_SetNode };
$h_sci_SetNode.prototype = $c_sci_SetNode.prototype;
function $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable($thiz, elems) {
  if ((elems === $thiz)) {
    $thiz.addAll__sc_IterableOnce__scm_Growable($m_scm_Buffer$().from__sc_IterableOnce__sc_SeqOps(elems));
  } else {
    var it = elems.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      $thiz.addOne__O__scm_Growable(it.next__O());
    }
  }
  return $thiz;
}
export { $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable as $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable };
function $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, s) {
  var $x_1 = $m_s_Predef$();
  var this$1 = $f_T__trim__T(s);
  var this$2 = $x_1.wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(this$1, "\\s+", 0));
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$2);
}
export { $p_s_concurrent_duration_Duration$__words__T__sci_List as $p_s_concurrent_duration_Duration$__words__T__sci_List };
function $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($thiz, labels) {
  var x1 = $p_s_concurrent_duration_Duration$__words__T__sci_List($thiz, labels);
  if ((!(x1 instanceof $c_sci_$colon$colon))) {
    throw new $c_s_MatchError(x1);
  }
  var hd = x1.sci_$colon$colon__f_head;
  var rest = x1.sci_$colon$colon__f_next;
  var rest$1 = rest;
  var h = null;
  var t = null;
  while ((rest$1 !== $m_sci_Nil$())) {
    var x0 = rest$1.head__O();
    var x1$1 = (x0 + "s");
    var array = [x0, x1$1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    var it = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest$1 = rest$1.tail__O();
  }
  var this$5 = ((h === null) ? $m_sci_Nil$() : h);
  return new $c_sci_$colon$colon(hd, this$5);
}
export { $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List as $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List };
/** @constructor */
function $c_s_concurrent_duration_Duration$() {
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = null;
  this.s_concurrent_duration_Duration$__f_timeUnitName = null;
  this.s_concurrent_duration_Duration$__f_timeUnit = null;
  this.s_concurrent_duration_Duration$__f_Zero = null;
  this.s_concurrent_duration_Duration$__f_Undefined = null;
  this.s_concurrent_duration_Duration$__f_Inf = null;
  this.s_concurrent_duration_Duration$__f_MinusInf = null;
  $n_s_concurrent_duration_Duration$ = this;
  var self = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
  var x0 = $ct_T2__O__O__(new $c_T2(), self, "d day");
  var self$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
  var x1 = $ct_T2__O__O__(new $c_T2(), self$1, "h hr hour");
  var self$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
  var x2 = $ct_T2__O__O__(new $c_T2(), self$2, "m min minute");
  var self$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
  var x3 = $ct_T2__O__O__(new $c_T2(), self$3, "s sec second");
  var self$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
  var x4 = $ct_T2__O__O__(new $c_T2(), self$4, "ms milli millisecond");
  var self$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
  var x5 = $ct_T2__O__O__(new $c_T2(), self$5, "\u00b5s micro microsecond");
  var self$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  var x6 = $ct_T2__O__O__(new $c_T2(), self$6, "ns nano nanosecond");
  var array = [x0, x1, x2, x3, x4, x5, x6];
  var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
  this.s_concurrent_duration_Duration$__f_timeUnitLabels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var this$20 = this.s_concurrent_duration_Duration$__f_timeUnitLabels;
  var this$21 = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$20);
  var this$22 = new $c_sc_MapView$Id(this$21);
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((s$2$2) => $p_s_concurrent_duration_Duration$__words__T__sci_List($m_s_concurrent_duration_Duration$(), s$2$2).last__O()));
  var this$24 = new $c_sc_MapView$MapValues(this$22, f);
  this.s_concurrent_duration_Duration$__f_timeUnitName = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$24);
  var this$25 = this.s_concurrent_duration_Duration$__f_timeUnitLabels;
  var rest = this$25;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0$1 = rest.head__O();
    if ((x0$1 === null)) {
      throw new $c_s_MatchError(x0$1);
    }
    var unit = x0$1._1__O();
    var names = x0$1._2__O();
    var this$28 = $p_s_concurrent_duration_Duration$__expandLabels__T__sci_List($m_s_concurrent_duration_Duration$(), names);
    var f$1 = ((unit) => ((x$5$2$2) => $ct_T2__O__O__(new $c_T2(), x$5$2$2, unit)))(unit);
    if ((this$28 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0$2 = this$28.head__O();
      var h$1 = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
      var t$1 = h$1;
      var rest$1 = this$28.tail__O();
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$3 = rest$1.head__O();
        var nx = new $c_sci_$colon$colon(f$1(x0$3), $m_sci_Nil$());
        t$1.sci_$colon$colon__f_next = nx;
        t$1 = nx;
        rest$1 = rest$1.tail__O();
      }
      var $x_1 = h$1;
    }
    var it = $x_1.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx$1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1;
      } else {
        t.sci_$colon$colon__f_next = nx$1;
      }
      t = nx$1;
    }
    rest = rest.tail__O();
  }
  var this$30 = ((h === null) ? $m_sci_Nil$() : h);
  this.s_concurrent_duration_Duration$__f_timeUnit = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$30);
  this.s_concurrent_duration_Duration$__f_Zero = new $c_s_concurrent_duration_FiniteDuration($L0, $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS);
  this.s_concurrent_duration_Duration$__f_Undefined = new $c_s_concurrent_duration_Duration$$anon$1();
  this.s_concurrent_duration_Duration$__f_Inf = new $c_s_concurrent_duration_Duration$$anon$2();
  this.s_concurrent_duration_Duration$__f_MinusInf = new $c_s_concurrent_duration_Duration$$anon$3();
}
export { $c_s_concurrent_duration_Duration$ as $c_s_concurrent_duration_Duration$ };
$c_s_concurrent_duration_Duration$.prototype = new $h_O();
$c_s_concurrent_duration_Duration$.prototype.constructor = $c_s_concurrent_duration_Duration$;
/** @constructor */
function $h_s_concurrent_duration_Duration$() {
}
export { $h_s_concurrent_duration_Duration$ as $h_s_concurrent_duration_Duration$ };
$h_s_concurrent_duration_Duration$.prototype = $c_s_concurrent_duration_Duration$.prototype;
$c_s_concurrent_duration_Duration$.prototype.apply__D__ju_concurrent_TimeUnit__s_concurrent_duration_Duration = (function(length, unit) {
  var a = unit.toNanos__J__J(new $c_RTLong(1, 0));
  var lo = a.RTLong__f_lo;
  var hi = a.RTLong__f_hi;
  return this.fromNanos__D__s_concurrent_duration_Duration((((4.294967296E9 * hi) + (lo >>> 0.0)) * length));
});
$c_s_concurrent_duration_Duration$.prototype.apply__T__s_concurrent_duration_Duration = (function(s) {
  var len = s.length;
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), len);
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x = s.charCodeAt(index);
    var this$6 = $m_jl_Character$();
    if ((!this$6.isWhitespace__I__Z(x))) {
      var str = ("" + $cToS(x));
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
    }
    i = ((1 + i) | 0);
  }
  var s1 = ((len === sb.length__I()) ? s : sb.jl_StringBuilder__f_java$lang$StringBuilder$$content);
  switch (s1) {
    case "Inf":
    case "PlusInf":
    case "+Inf":
    case "Duration.Inf": {
      return this.s_concurrent_duration_Duration$__f_Inf;
      break;
    }
    case "MinusInf":
    case "-Inf":
    case "Duration.MinusInf": {
      return this.s_concurrent_duration_Duration$__f_MinusInf;
      break;
    }
    case "Duration.Undefined": {
      return this.s_concurrent_duration_Duration$__f_Undefined;
      break;
    }
    default: {
      var $x_1 = $m_sc_StringOps$();
      var x$1 = $m_sc_StringOps$().reverse$extension__T__T(s1);
      _return: {
        var len$1 = x$1.length;
        var i$1 = 0;
        while ((i$1 < len$1)) {
          var index$1 = i$1;
          var x0 = x$1.charCodeAt(index$1);
          var this$14 = $m_jl_Character$();
          if ((!this$14.isLetter__I__Z(x0))) {
            var x1 = i$1;
            break _return;
          }
          i$1 = ((1 + i$1) | 0);
        }
        var x1 = (-1);
      }
      var x$2 = ((x1 === (-1)) ? x$1 : x$1.substring(0, x1));
      var unitName = $x_1.reverse$extension__T__T(x$2);
      var x1$2 = this.s_concurrent_duration_Duration$__f_timeUnit.get__O__s_Option(unitName);
      if ((x1$2 instanceof $c_s_Some)) {
        var unit = x1$2.s_Some__f_value;
        var valueStr = $m_sc_StringOps$().dropRight$extension__T__I__T(s1, unitName.length);
        var this$17 = $m_sc_StringParsers$().parseLong__T__s_Option(valueStr);
        if (this$17.isEmpty__Z()) {
          var this$19 = $m_s_None$();
        } else {
          var x0$1 = this$17.get__O();
          var t = $uJ(x0$1);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          $m_s_concurrent_duration_Duration$();
          var this$19 = new $c_s_Some(new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi), unit));
        }
        return (this$19.isEmpty__Z() ? $m_s_concurrent_duration_Duration$().apply__D__ju_concurrent_TimeUnit__s_concurrent_duration_Duration($m_jl_Double$().parseDouble__T__D(valueStr), unit) : this$19.get__O());
      } else {
        throw new $c_jl_NumberFormatException(("format error " + s));
      }
    }
  }
});
$c_s_concurrent_duration_Duration$.prototype.fromNanos__D__s_concurrent_duration_Duration = (function(nanos) {
  if (((nanos === Infinity) || (nanos === (-Infinity)))) {
    return ((nanos > 0.0) ? this.s_concurrent_duration_Duration$__f_Inf : this.s_concurrent_duration_Duration$__f_MinusInf);
  } else if ((nanos !== nanos)) {
    return this.s_concurrent_duration_Duration$__f_Undefined;
  } else if (((nanos > 9.223372036854776E18) || (nanos < (-9.223372036854776E18)))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("trying to construct too large duration with " + nanos) + "ns"));
  } else {
    var value = (+Math.round(nanos));
    var this$8 = $m_RTLong$();
    var lo = this$8.org$scalajs$linker$runtime$RuntimeLong$$fromDoubleImpl__D__I(value);
    var hi = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return this.fromNanos__J__s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi));
  }
});
$c_s_concurrent_duration_Duration$.prototype.fromNanos__J__s_concurrent_duration_FiniteDuration = (function(nanos) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-1857093632), 20116);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((lo === 0) && (hi === 0))) {
    $m_s_concurrent_duration_Duration$();
    var this$3 = $m_RTLong$();
    var lo$1 = this$3.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-1857093632), 20116);
    var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
    return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$1, hi$1), unit);
  } else {
    var this$5 = $m_RTLong$();
    var lo$2 = this$5.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 817405952, 838);
    var hi$2 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((lo$2 === 0) && (hi$2 === 0))) {
      $m_s_concurrent_duration_Duration$();
      var this$7 = $m_RTLong$();
      var lo$3 = this$7.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 817405952, 838);
      var hi$3 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
      return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$3, hi$3), unit$1);
    } else {
      var this$9 = $m_RTLong$();
      var lo$4 = this$9.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-129542144), 13);
      var hi$4 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      if (((lo$4 === 0) && (hi$4 === 0))) {
        $m_s_concurrent_duration_Duration$();
        var this$11 = $m_RTLong$();
        var lo$5 = this$11.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-129542144), 13);
        var hi$5 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var unit$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
        return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$5, hi$5), unit$2);
      } else {
        var this$13 = $m_RTLong$();
        var lo$6 = this$13.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
        var hi$6 = this$13.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        if (((lo$6 === 0) && (hi$6 === 0))) {
          $m_s_concurrent_duration_Duration$();
          var this$15 = $m_RTLong$();
          var lo$7 = this$15.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000000, 0);
          var hi$7 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var unit$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
          return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$7, hi$7), unit$3);
        } else {
          var this$17 = $m_RTLong$();
          var lo$8 = this$17.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000, 0);
          var hi$8 = this$17.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          if (((lo$8 === 0) && (hi$8 === 0))) {
            $m_s_concurrent_duration_Duration$();
            var this$19 = $m_RTLong$();
            var lo$9 = this$19.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000000, 0);
            var hi$9 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            var unit$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
            return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$9, hi$9), unit$4);
          } else {
            var this$21 = $m_RTLong$();
            var lo$10 = this$21.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000, 0);
            var hi$10 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
            if (((lo$10 === 0) && (hi$10 === 0))) {
              $m_s_concurrent_duration_Duration$();
              var this$23 = $m_RTLong$();
              var lo$11 = this$23.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, 1000, 0);
              var hi$11 = this$23.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
              var unit$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
              return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo$11, hi$11), unit$5);
            } else {
              $m_s_concurrent_duration_Duration$();
              var unit$6 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
              return new $c_s_concurrent_duration_FiniteDuration(nanos, unit$6);
            }
          }
        }
      }
    }
  }
});
var $d_s_concurrent_duration_Duration$ = new $TypeData().initClass($c_s_concurrent_duration_Duration$, "scala.concurrent.duration.Duration$", ({
  s_concurrent_duration_Duration$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_concurrent_duration_Duration$ as $d_s_concurrent_duration_Duration$ };
var $n_s_concurrent_duration_Duration$;
function $m_s_concurrent_duration_Duration$() {
  if ((!$n_s_concurrent_duration_Duration$)) {
    $n_s_concurrent_duration_Duration$ = new $c_s_concurrent_duration_Duration$();
  }
  return $n_s_concurrent_duration_Duration$;
}
export { $m_s_concurrent_duration_Duration$ as $m_s_concurrent_duration_Duration$ };
/** @constructor */
function $c_s_concurrent_duration_package$DurationInt(n) {
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = 0;
  this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n = n;
}
export { $c_s_concurrent_duration_package$DurationInt as $c_s_concurrent_duration_package$DurationInt };
$c_s_concurrent_duration_package$DurationInt.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationInt.prototype.constructor = $c_s_concurrent_duration_package$DurationInt;
/** @constructor */
function $h_s_concurrent_duration_package$DurationInt() {
}
export { $h_s_concurrent_duration_package$DurationInt as $h_s_concurrent_duration_package$DurationInt };
$h_s_concurrent_duration_package$DurationInt.prototype = $c_s_concurrent_duration_package$DurationInt.prototype;
$c_s_concurrent_duration_package$DurationInt.prototype.hashCode__I = (function() {
  var this$ = this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
  return this$;
});
$c_s_concurrent_duration_package$DurationInt.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationInt$().equals$extension__I__O__Z(this.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n, x$1);
});
function $isArrayOf_s_concurrent_duration_package$DurationInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationInt)));
}
export { $isArrayOf_s_concurrent_duration_package$DurationInt as $isArrayOf_s_concurrent_duration_package$DurationInt };
var $d_s_concurrent_duration_package$DurationInt = new $TypeData().initClass($c_s_concurrent_duration_package$DurationInt, "scala.concurrent.duration.package$DurationInt", ({
  s_concurrent_duration_package$DurationInt: 1,
  s_concurrent_duration_DurationConversions: 1
}));
export { $d_s_concurrent_duration_package$DurationInt as $d_s_concurrent_duration_package$DurationInt };
/** @constructor */
function $c_s_concurrent_duration_package$DurationLong(n) {
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n = $L0;
  this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n = n;
}
export { $c_s_concurrent_duration_package$DurationLong as $c_s_concurrent_duration_package$DurationLong };
$c_s_concurrent_duration_package$DurationLong.prototype = new $h_O();
$c_s_concurrent_duration_package$DurationLong.prototype.constructor = $c_s_concurrent_duration_package$DurationLong;
/** @constructor */
function $h_s_concurrent_duration_package$DurationLong() {
}
export { $h_s_concurrent_duration_package$DurationLong as $h_s_concurrent_duration_package$DurationLong };
$h_s_concurrent_duration_package$DurationLong.prototype = $c_s_concurrent_duration_package$DurationLong.prototype;
$c_s_concurrent_duration_package$DurationLong.prototype.hashCode__I = (function() {
  var t = this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi);
});
$c_s_concurrent_duration_package$DurationLong.prototype.equals__O__Z = (function(x$1) {
  return $m_s_concurrent_duration_package$DurationLong$().equals$extension__J__O__Z(this.s_concurrent_duration_package$DurationLong__f_scala$concurrent$duration$DurationLong$$n, x$1);
});
function $isArrayOf_s_concurrent_duration_package$DurationLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_package$DurationLong)));
}
export { $isArrayOf_s_concurrent_duration_package$DurationLong as $isArrayOf_s_concurrent_duration_package$DurationLong };
var $d_s_concurrent_duration_package$DurationLong = new $TypeData().initClass($c_s_concurrent_duration_package$DurationLong, "scala.concurrent.duration.package$DurationLong", ({
  s_concurrent_duration_package$DurationLong: 1,
  s_concurrent_duration_DurationConversions: 1
}));
export { $d_s_concurrent_duration_package$DurationLong as $d_s_concurrent_duration_package$DurationLong };
function $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) {
  if ((!$thiz.s_math_BigDecimal$__f_bitmap$0)) {
    $thiz.s_math_BigDecimal$__f_cache = new ($d_s_math_BigDecimal.getArrayOf().constr)(((1 + (($thiz.s_math_BigDecimal$__f_maxCached - $thiz.s_math_BigDecimal$__f_minCached) | 0)) | 0));
    $thiz.s_math_BigDecimal$__f_bitmap$0 = true;
  }
  return $thiz.s_math_BigDecimal$__f_cache;
}
export { $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal as $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal };
function $p_s_math_BigDecimal$__cache__As_math_BigDecimal($thiz) {
  return ((!$thiz.s_math_BigDecimal$__f_bitmap$0) ? $p_s_math_BigDecimal$__cache$lzycompute__As_math_BigDecimal($thiz) : $thiz.s_math_BigDecimal$__f_cache);
}
export { $p_s_math_BigDecimal$__cache__As_math_BigDecimal as $p_s_math_BigDecimal$__cache__As_math_BigDecimal };
/** @constructor */
function $c_s_math_BigDecimal$() {
  this.s_math_BigDecimal$__f_cache = null;
  this.s_math_BigDecimal$__f_minCached = 0;
  this.s_math_BigDecimal$__f_maxCached = 0;
  this.s_math_BigDecimal$__f_defaultMathContext = null;
  this.s_math_BigDecimal$__f_bitmap$0 = false;
  $n_s_math_BigDecimal$ = this;
  this.s_math_BigDecimal$__f_minCached = (-512);
  this.s_math_BigDecimal$__f_maxCached = 512;
  this.s_math_BigDecimal$__f_defaultMathContext = $m_Ljava_math_MathContext$().Ljava_math_MathContext$__f_DECIMAL128;
}
export { $c_s_math_BigDecimal$ as $c_s_math_BigDecimal$ };
$c_s_math_BigDecimal$.prototype = new $h_O();
$c_s_math_BigDecimal$.prototype.constructor = $c_s_math_BigDecimal$;
/** @constructor */
function $h_s_math_BigDecimal$() {
}
export { $h_s_math_BigDecimal$ as $h_s_math_BigDecimal$ };
$h_s_math_BigDecimal$.prototype = $c_s_math_BigDecimal$.prototype;
$c_s_math_BigDecimal$.prototype.decimal__D__Ljava_math_MathContext__s_math_BigDecimal = (function(d, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), ("" + d), mc), mc);
});
$c_s_math_BigDecimal$.prototype.exact__Ljava_math_BigDecimal__s_math_BigDecimal = (function(repr) {
  var $x_1 = repr.precision__I();
  var this$1 = this.s_math_BigDecimal$__f_defaultMathContext;
  if (($x_1 <= this$1.Ljava_math_MathContext__f_precision)) {
    var mc = this.s_math_BigDecimal$__f_defaultMathContext;
  } else {
    var mc = new $c_Ljava_math_MathContext(repr.precision__I(), $m_Ljava_math_RoundingMode$().Ljava_math_RoundingMode$__f_HALF_EVEN);
  }
  return new $c_s_math_BigDecimal(repr, mc);
});
$c_s_math_BigDecimal$.prototype.exact__T__s_math_BigDecimal = (function(s) {
  return this.exact__Ljava_math_BigDecimal__s_math_BigDecimal($ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), s));
});
$c_s_math_BigDecimal$.prototype.apply__I__Ljava_math_MathContext__s_math_BigDecimal = (function(i, mc) {
  var x$2 = this.s_math_BigDecimal$__f_defaultMathContext;
  if (((((mc === null) ? (x$2 === null) : mc.equals__O__Z(x$2)) && (this.s_math_BigDecimal$__f_minCached <= i)) && (i <= this.s_math_BigDecimal$__f_maxCached))) {
    var offset = ((i - this.s_math_BigDecimal$__f_minCached) | 0);
    var n = $p_s_math_BigDecimal$__cache__As_math_BigDecimal(this).u[offset];
    if ((n === null)) {
      var hi = (i >> 31);
      n = new $c_s_math_BigDecimal($m_Ljava_math_BigDecimal$().valueOf__J__Ljava_math_BigDecimal(new $c_RTLong(i, hi)), mc);
      $p_s_math_BigDecimal$__cache__As_math_BigDecimal(this).u[offset] = n;
    }
    return n;
  } else {
    var hi$1 = (i >> 31);
    return this.apply__J__Ljava_math_MathContext__s_math_BigDecimal(new $c_RTLong(i, hi$1), mc);
  }
});
$c_s_math_BigDecimal$.prototype.apply__J__Ljava_math_MathContext__s_math_BigDecimal = (function(l, mc) {
  return new $c_s_math_BigDecimal($ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__(new $c_Ljava_math_BigDecimal(), l, mc), mc);
});
var $d_s_math_BigDecimal$ = new $TypeData().initClass($c_s_math_BigDecimal$, "scala.math.BigDecimal$", ({
  s_math_BigDecimal$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_BigDecimal$ as $d_s_math_BigDecimal$ };
var $n_s_math_BigDecimal$;
function $m_s_math_BigDecimal$() {
  if ((!$n_s_math_BigDecimal$)) {
    $n_s_math_BigDecimal$ = new $c_s_math_BigDecimal$();
  }
  return $n_s_math_BigDecimal$;
}
export { $m_s_math_BigDecimal$ as $m_s_math_BigDecimal$ };
function $p_s_math_BigInt$__getCached__I__s_math_BigInt($thiz, i) {
  var offset = ((i - $thiz.s_math_BigInt$__f_minCached) | 0);
  var n = $thiz.s_math_BigInt$__f_cache.u[offset];
  if ((n === null)) {
    var hi = (i >> 31);
    n = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, new $c_RTLong(i, hi));
    $thiz.s_math_BigInt$__f_cache.u[offset] = n;
  }
  return n;
}
export { $p_s_math_BigInt$__getCached__I__s_math_BigInt as $p_s_math_BigInt$__getCached__I__s_math_BigInt };
/** @constructor */
function $c_s_math_BigInt$() {
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = null;
  this.s_math_BigInt$__f_longMinValue = null;
  this.s_math_BigInt$__f_minCached = 0;
  this.s_math_BigInt$__f_maxCached = 0;
  this.s_math_BigInt$__f_cache = null;
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = null;
  $n_s_math_BigInt$ = this;
  this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(0, (-2147483648)));
  this.s_math_BigInt$__f_longMinValue = $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), this.s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger, new $c_RTLong(0, (-2147483648)));
  this.s_math_BigInt$__f_minCached = (-1024);
  this.s_math_BigInt$__f_maxCached = 1024;
  this.s_math_BigInt$__f_cache = new ($d_s_math_BigInt.getArrayOf().constr)(((1 + ((this.s_math_BigInt$__f_maxCached - this.s_math_BigInt$__f_minCached) | 0)) | 0));
  this.s_math_BigInt$__f_scala$math$BigInt$$minusOne = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong((-1), (-1)));
}
export { $c_s_math_BigInt$ as $c_s_math_BigInt$ };
$c_s_math_BigInt$.prototype = new $h_O();
$c_s_math_BigInt$.prototype.constructor = $c_s_math_BigInt$;
/** @constructor */
function $h_s_math_BigInt$() {
}
export { $h_s_math_BigInt$ as $h_s_math_BigInt$ };
$h_s_math_BigInt$.prototype = $c_s_math_BigInt$.prototype;
$c_s_math_BigInt$.prototype.apply__I__s_math_BigInt = (function(i) {
  if (((this.s_math_BigInt$__f_minCached <= i) && (i <= this.s_math_BigInt$__f_maxCached))) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, i);
  } else {
    var hi = (i >> 31);
    return this.apply__J__s_math_BigInt(new $c_RTLong(i, hi));
  }
});
$c_s_math_BigInt$.prototype.apply__J__s_math_BigInt = (function(l) {
  var value = this.s_math_BigInt$__f_minCached;
  var hi = (value >> 31);
  var bhi = l.RTLong__f_hi;
  if (((hi === bhi) ? ((value >>> 0) <= (l.RTLong__f_lo >>> 0)) : (hi < bhi))) {
    var value$1 = this.s_math_BigInt$__f_maxCached;
    var hi$1 = (value$1 >> 31);
    var ahi = l.RTLong__f_hi;
    var $x_1 = ((ahi === hi$1) ? ((l.RTLong__f_lo >>> 0) <= (value$1 >>> 0)) : (ahi < hi$1));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, l.RTLong__f_lo);
  } else {
    return (((l.RTLong__f_lo === 0) && (l.RTLong__f_hi === (-2147483648))) ? this.s_math_BigInt$__f_longMinValue : $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), null, l));
  }
});
$c_s_math_BigInt$.prototype.apply__AB__s_math_BigInt = (function(x) {
  return this.apply__Ljava_math_BigInteger__s_math_BigInt($ct_Ljava_math_BigInteger__AB__(new $c_Ljava_math_BigInteger(), x));
});
$c_s_math_BigInt$.prototype.apply__T__s_math_BigInt = (function(x) {
  return this.apply__Ljava_math_BigInteger__s_math_BigInt($ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), x));
});
$c_s_math_BigInt$.prototype.apply__Ljava_math_BigInteger__s_math_BigInt = (function(x) {
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(x) <= 63)) {
    var t = x.longValue__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var value = this.s_math_BigInt$__f_minCached;
    var hi$1 = (value >> 31);
    if (((hi$1 === hi) ? ((value >>> 0) <= (lo >>> 0)) : (hi$1 < hi))) {
      var value$1 = this.s_math_BigInt$__f_maxCached;
      var hi$2 = (value$1 >> 31);
      var $x_1 = ((hi === hi$2) ? ((lo >>> 0) <= (value$1 >>> 0)) : (hi < hi$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return $p_s_math_BigInt$__getCached__I__s_math_BigInt(this, lo);
    } else {
      return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, new $c_RTLong(lo, hi));
    }
  } else {
    return $ct_s_math_BigInt__Ljava_math_BigInteger__J__(new $c_s_math_BigInt(), x, new $c_RTLong(0, (-2147483648)));
  }
});
var $d_s_math_BigInt$ = new $TypeData().initClass($c_s_math_BigInt$, "scala.math.BigInt$", ({
  s_math_BigInt$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_BigInt$ as $d_s_math_BigInt$ };
var $n_s_math_BigInt$;
function $m_s_math_BigInt$() {
  if ((!$n_s_math_BigInt$)) {
    $n_s_math_BigInt$ = new $c_s_math_BigInt$();
  }
  return $n_s_math_BigInt$;
}
export { $m_s_math_BigInt$ as $m_s_math_BigInt$ };
/** @constructor */
function $c_s_math_Integral$IntegralOps(outer, lhs) {
  this.s_math_Numeric$NumericOps__f_lhs = null;
  this.s_math_Numeric$NumericOps__f_$outer = null;
  this.s_math_Integral$IntegralOps__f_lhs = null;
  this.s_math_Integral$IntegralOps__f_lhs = lhs;
  $ct_s_math_Numeric$NumericOps__s_math_Numeric__O__(this, outer, lhs);
}
export { $c_s_math_Integral$IntegralOps as $c_s_math_Integral$IntegralOps };
$c_s_math_Integral$IntegralOps.prototype = new $h_s_math_Numeric$NumericOps();
$c_s_math_Integral$IntegralOps.prototype.constructor = $c_s_math_Integral$IntegralOps;
/** @constructor */
function $h_s_math_Integral$IntegralOps() {
}
export { $h_s_math_Integral$IntegralOps as $h_s_math_Integral$IntegralOps };
$h_s_math_Integral$IntegralOps.prototype = $c_s_math_Integral$IntegralOps.prototype;
$c_s_math_Integral$IntegralOps.prototype.$div__O__O = (function(rhs) {
  return this.s_math_Numeric$NumericOps__f_$outer.quot__O__O__O(this.s_math_Integral$IntegralOps__f_lhs, rhs);
});
var $d_s_math_Integral$IntegralOps = new $TypeData().initClass($c_s_math_Integral$IntegralOps, "scala.math.Integral$IntegralOps", ({
  s_math_Integral$IntegralOps: 1,
  s_math_Numeric$NumericOps: 1
}));
export { $d_s_math_Integral$IntegralOps as $d_s_math_Integral$IntegralOps };
function $f_s_math_Ordered__$less__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) < 0);
}
export { $f_s_math_Ordered__$less__O__Z as $f_s_math_Ordered__$less__O__Z };
function $f_s_math_Ordered__$greater__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) > 0);
}
export { $f_s_math_Ordered__$greater__O__Z as $f_s_math_Ordered__$greater__O__Z };
function $f_s_math_Ordered__$less$eq__O__Z($thiz, that) {
  return ($thiz.compare__O__I(that) <= 0);
}
export { $f_s_math_Ordered__$less$eq__O__Z as $f_s_math_Ordered__$less$eq__O__Z };
/** @constructor */
function $c_s_reflect_ClassTag$() {
  this.s_reflect_ClassTag$__f_Byte = null;
  this.s_reflect_ClassTag$__f_Short = null;
  this.s_reflect_ClassTag$__f_Char = null;
  this.s_reflect_ClassTag$__f_Int = null;
  this.s_reflect_ClassTag$__f_Long = null;
  this.s_reflect_ClassTag$__f_Float = null;
  this.s_reflect_ClassTag$__f_Double = null;
  this.s_reflect_ClassTag$__f_Boolean = null;
  this.s_reflect_ClassTag$__f_Unit = null;
  this.s_reflect_ClassTag$__f_Any = null;
  this.s_reflect_ClassTag$__f_Object = null;
  this.s_reflect_ClassTag$__f_AnyRef = null;
  this.s_reflect_ClassTag$__f_Nothing = null;
  this.s_reflect_ClassTag$__f_Null = null;
  $n_s_reflect_ClassTag$ = this;
  this.s_reflect_ClassTag$__f_Byte = $m_s_reflect_ManifestFactory$ByteManifest$();
  this.s_reflect_ClassTag$__f_Short = $m_s_reflect_ManifestFactory$ShortManifest$();
  this.s_reflect_ClassTag$__f_Char = $m_s_reflect_ManifestFactory$CharManifest$();
  this.s_reflect_ClassTag$__f_Int = $m_s_reflect_ManifestFactory$IntManifest$();
  this.s_reflect_ClassTag$__f_Long = $m_s_reflect_ManifestFactory$LongManifest$();
  this.s_reflect_ClassTag$__f_Float = $m_s_reflect_ManifestFactory$FloatManifest$();
  this.s_reflect_ClassTag$__f_Double = $m_s_reflect_ManifestFactory$DoubleManifest$();
  this.s_reflect_ClassTag$__f_Boolean = $m_s_reflect_ManifestFactory$BooleanManifest$();
  this.s_reflect_ClassTag$__f_Unit = $m_s_reflect_ManifestFactory$UnitManifest$();
  this.s_reflect_ClassTag$__f_Any = $m_s_reflect_ManifestFactory$AnyManifest$();
  this.s_reflect_ClassTag$__f_Object = $m_s_reflect_ManifestFactory$ObjectManifest$();
  this.s_reflect_ClassTag$__f_AnyRef = $m_s_reflect_ManifestFactory$ObjectManifest$();
  this.s_reflect_ClassTag$__f_Nothing = $m_s_reflect_ManifestFactory$NothingManifest$();
  this.s_reflect_ClassTag$__f_Null = $m_s_reflect_ManifestFactory$NullManifest$();
}
export { $c_s_reflect_ClassTag$ as $c_s_reflect_ClassTag$ };
$c_s_reflect_ClassTag$.prototype = new $h_O();
$c_s_reflect_ClassTag$.prototype.constructor = $c_s_reflect_ClassTag$;
/** @constructor */
function $h_s_reflect_ClassTag$() {
}
export { $h_s_reflect_ClassTag$ as $h_s_reflect_ClassTag$ };
$h_s_reflect_ClassTag$.prototype = $c_s_reflect_ClassTag$.prototype;
$c_s_reflect_ClassTag$.prototype.apply__jl_Class__s_reflect_ClassTag = (function(runtimeClass1) {
  return ((runtimeClass1 === $d_B.getClassOf()) ? $m_s_reflect_ManifestFactory$ByteManifest$() : ((runtimeClass1 === $d_S.getClassOf()) ? $m_s_reflect_ManifestFactory$ShortManifest$() : ((runtimeClass1 === $d_C.getClassOf()) ? $m_s_reflect_ManifestFactory$CharManifest$() : ((runtimeClass1 === $d_I.getClassOf()) ? $m_s_reflect_ManifestFactory$IntManifest$() : ((runtimeClass1 === $d_J.getClassOf()) ? $m_s_reflect_ManifestFactory$LongManifest$() : ((runtimeClass1 === $d_F.getClassOf()) ? $m_s_reflect_ManifestFactory$FloatManifest$() : ((runtimeClass1 === $d_D.getClassOf()) ? $m_s_reflect_ManifestFactory$DoubleManifest$() : ((runtimeClass1 === $d_Z.getClassOf()) ? $m_s_reflect_ManifestFactory$BooleanManifest$() : ((runtimeClass1 === $d_V.getClassOf()) ? $m_s_reflect_ManifestFactory$UnitManifest$() : ((runtimeClass1 === $d_O.getClassOf()) ? $m_s_reflect_ManifestFactory$ObjectManifest$() : ((runtimeClass1 === $d_sr_Nothing$.getClassOf()) ? $m_s_reflect_ManifestFactory$NothingManifest$() : ((runtimeClass1 === $d_sr_Null$.getClassOf()) ? $m_s_reflect_ManifestFactory$NullManifest$() : new $c_s_reflect_ClassTag$GenericClassTag(runtimeClass1)))))))))))));
});
var $d_s_reflect_ClassTag$ = new $TypeData().initClass($c_s_reflect_ClassTag$, "scala.reflect.ClassTag$", ({
  s_reflect_ClassTag$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_reflect_ClassTag$ as $d_s_reflect_ClassTag$ };
var $n_s_reflect_ClassTag$;
function $m_s_reflect_ClassTag$() {
  if ((!$n_s_reflect_ClassTag$)) {
    $n_s_reflect_ClassTag$ = new $c_s_reflect_ClassTag$();
  }
  return $n_s_reflect_ClassTag$;
}
export { $m_s_reflect_ClassTag$ as $m_s_reflect_ClassTag$ };
/** @constructor */
function $c_sr_AbstractFunction0() {
}
export { $c_sr_AbstractFunction0 as $c_sr_AbstractFunction0 };
$c_sr_AbstractFunction0.prototype = new $h_O();
$c_sr_AbstractFunction0.prototype.constructor = $c_sr_AbstractFunction0;
/** @constructor */
function $h_sr_AbstractFunction0() {
}
export { $h_sr_AbstractFunction0 as $h_sr_AbstractFunction0 };
$h_sr_AbstractFunction0.prototype = $c_sr_AbstractFunction0.prototype;
$c_sr_AbstractFunction0.prototype.toString__T = (function() {
  return "<function0>";
});
/** @constructor */
function $c_sr_AbstractFunction1() {
}
export { $c_sr_AbstractFunction1 as $c_sr_AbstractFunction1 };
$c_sr_AbstractFunction1.prototype = new $h_O();
$c_sr_AbstractFunction1.prototype.constructor = $c_sr_AbstractFunction1;
/** @constructor */
function $h_sr_AbstractFunction1() {
}
export { $h_sr_AbstractFunction1 as $h_sr_AbstractFunction1 };
$h_sr_AbstractFunction1.prototype = $c_sr_AbstractFunction1.prototype;
$c_sr_AbstractFunction1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!this.apply__O__O(v1)));
});
$c_sr_AbstractFunction1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sr_AbstractFunction1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sr_AbstractFunction1.prototype.toString__T = (function() {
  return "<function1>";
});
/** @constructor */
function $c_sr_AbstractFunction2() {
}
export { $c_sr_AbstractFunction2 as $c_sr_AbstractFunction2 };
$c_sr_AbstractFunction2.prototype = new $h_O();
$c_sr_AbstractFunction2.prototype.constructor = $c_sr_AbstractFunction2;
/** @constructor */
function $h_sr_AbstractFunction2() {
}
export { $h_sr_AbstractFunction2 as $h_sr_AbstractFunction2 };
$h_sr_AbstractFunction2.prototype = $c_sr_AbstractFunction2.prototype;
$c_sr_AbstractFunction2.prototype.toString__T = (function() {
  return "<function2>";
});
/** @constructor */
function $c_sr_AbstractFunction3() {
}
export { $c_sr_AbstractFunction3 as $c_sr_AbstractFunction3 };
$c_sr_AbstractFunction3.prototype = new $h_O();
$c_sr_AbstractFunction3.prototype.constructor = $c_sr_AbstractFunction3;
/** @constructor */
function $h_sr_AbstractFunction3() {
}
export { $h_sr_AbstractFunction3 as $h_sr_AbstractFunction3 };
$h_sr_AbstractFunction3.prototype = $c_sr_AbstractFunction3.prototype;
$c_sr_AbstractFunction3.prototype.toString__T = (function() {
  return "<function3>";
});
/** @constructor */
function $c_sr_AbstractFunction4() {
}
export { $c_sr_AbstractFunction4 as $c_sr_AbstractFunction4 };
$c_sr_AbstractFunction4.prototype = new $h_O();
$c_sr_AbstractFunction4.prototype.constructor = $c_sr_AbstractFunction4;
/** @constructor */
function $h_sr_AbstractFunction4() {
}
export { $h_sr_AbstractFunction4 as $h_sr_AbstractFunction4 };
$h_sr_AbstractFunction4.prototype = $c_sr_AbstractFunction4.prototype;
$c_sr_AbstractFunction4.prototype.toString__T = (function() {
  return "<function4>";
});
/** @constructor */
function $c_sr_BooleanRef(elem) {
  this.sr_BooleanRef__f_elem = false;
  this.sr_BooleanRef__f_elem = elem;
}
export { $c_sr_BooleanRef as $c_sr_BooleanRef };
$c_sr_BooleanRef.prototype = new $h_O();
$c_sr_BooleanRef.prototype.constructor = $c_sr_BooleanRef;
/** @constructor */
function $h_sr_BooleanRef() {
}
export { $h_sr_BooleanRef as $h_sr_BooleanRef };
$h_sr_BooleanRef.prototype = $c_sr_BooleanRef.prototype;
$c_sr_BooleanRef.prototype.toString__T = (function() {
  var b = this.sr_BooleanRef__f_elem;
  return ("" + b);
});
var $d_sr_BooleanRef = new $TypeData().initClass($c_sr_BooleanRef, "scala.runtime.BooleanRef", ({
  sr_BooleanRef: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sr_BooleanRef as $d_sr_BooleanRef };
/** @constructor */
function $c_sr_IntRef(elem) {
  this.sr_IntRef__f_elem = 0;
  this.sr_IntRef__f_elem = elem;
}
export { $c_sr_IntRef as $c_sr_IntRef };
$c_sr_IntRef.prototype = new $h_O();
$c_sr_IntRef.prototype.constructor = $c_sr_IntRef;
/** @constructor */
function $h_sr_IntRef() {
}
export { $h_sr_IntRef as $h_sr_IntRef };
$h_sr_IntRef.prototype = $c_sr_IntRef.prototype;
$c_sr_IntRef.prototype.toString__T = (function() {
  var i = this.sr_IntRef__f_elem;
  return ("" + i);
});
var $d_sr_IntRef = new $TypeData().initClass($c_sr_IntRef, "scala.runtime.IntRef", ({
  sr_IntRef: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sr_IntRef as $d_sr_IntRef };
/** @constructor */
function $c_sr_LazyRef() {
  this.sr_LazyRef__f__initialized = false;
  this.sr_LazyRef__f__value = null;
}
export { $c_sr_LazyRef as $c_sr_LazyRef };
$c_sr_LazyRef.prototype = new $h_O();
$c_sr_LazyRef.prototype.constructor = $c_sr_LazyRef;
/** @constructor */
function $h_sr_LazyRef() {
}
export { $h_sr_LazyRef as $h_sr_LazyRef };
$h_sr_LazyRef.prototype = $c_sr_LazyRef.prototype;
$c_sr_LazyRef.prototype.initialize__O__O = (function(value) {
  this.sr_LazyRef__f__value = value;
  this.sr_LazyRef__f__initialized = true;
  return value;
});
$c_sr_LazyRef.prototype.toString__T = (function() {
  return ("LazyRef " + (this.sr_LazyRef__f__initialized ? ("of: " + this.sr_LazyRef__f__value) : "thunk"));
});
var $d_sr_LazyRef = new $TypeData().initClass($c_sr_LazyRef, "scala.runtime.LazyRef", ({
  sr_LazyRef: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sr_LazyRef as $d_sr_LazyRef };
/** @constructor */
function $c_sr_ObjectRef(elem) {
  this.sr_ObjectRef__f_elem = null;
  this.sr_ObjectRef__f_elem = elem;
}
export { $c_sr_ObjectRef as $c_sr_ObjectRef };
$c_sr_ObjectRef.prototype = new $h_O();
$c_sr_ObjectRef.prototype.constructor = $c_sr_ObjectRef;
/** @constructor */
function $h_sr_ObjectRef() {
}
export { $h_sr_ObjectRef as $h_sr_ObjectRef };
$h_sr_ObjectRef.prototype = $c_sr_ObjectRef.prototype;
$c_sr_ObjectRef.prototype.toString__T = (function() {
  var obj = this.sr_ObjectRef__f_elem;
  return ("" + obj);
});
var $d_sr_ObjectRef = new $TypeData().initClass($c_sr_ObjectRef, "scala.runtime.ObjectRef", ({
  sr_ObjectRef: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sr_ObjectRef as $d_sr_ObjectRef };
var $d_sjs_js_timers_SetTimeoutHandle = new $TypeData().initClass(2, "scala.scalajs.js.timers.SetTimeoutHandle", ({
  sjs_js_timers_SetTimeoutHandle: 1,
  sjs_js_Any: 1
}), $noIsInstance);
export { $d_sjs_js_timers_SetTimeoutHandle as $d_sjs_js_timers_SetTimeoutHandle };
/** @constructor */
function $c_s_util_Either$() {
}
export { $c_s_util_Either$ as $c_s_util_Either$ };
$c_s_util_Either$.prototype = new $h_O();
$c_s_util_Either$.prototype.constructor = $c_s_util_Either$;
/** @constructor */
function $h_s_util_Either$() {
}
export { $h_s_util_Either$ as $h_s_util_Either$ };
$h_s_util_Either$.prototype = $c_s_util_Either$.prototype;
var $d_s_util_Either$ = new $TypeData().initClass($c_s_util_Either$, "scala.util.Either$", ({
  s_util_Either$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_Either$ as $d_s_util_Either$ };
var $n_s_util_Either$;
function $m_s_util_Either$() {
  if ((!$n_s_util_Either$)) {
    $n_s_util_Either$ = new $c_s_util_Either$();
  }
  return $n_s_util_Either$;
}
export { $m_s_util_Either$ as $m_s_util_Either$ };
/** @constructor */
function $c_s_util_Left$() {
}
export { $c_s_util_Left$ as $c_s_util_Left$ };
$c_s_util_Left$.prototype = new $h_O();
$c_s_util_Left$.prototype.constructor = $c_s_util_Left$;
/** @constructor */
function $h_s_util_Left$() {
}
export { $h_s_util_Left$ as $h_s_util_Left$ };
$h_s_util_Left$.prototype = $c_s_util_Left$.prototype;
$c_s_util_Left$.prototype.toString__T = (function() {
  return "Left";
});
var $d_s_util_Left$ = new $TypeData().initClass($c_s_util_Left$, "scala.util.Left$", ({
  s_util_Left$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_Left$ as $d_s_util_Left$ };
var $n_s_util_Left$;
function $m_s_util_Left$() {
  if ((!$n_s_util_Left$)) {
    $n_s_util_Left$ = new $c_s_util_Left$();
  }
  return $n_s_util_Left$;
}
export { $m_s_util_Left$ as $m_s_util_Left$ };
/** @constructor */
function $c_s_util_Right$() {
}
export { $c_s_util_Right$ as $c_s_util_Right$ };
$c_s_util_Right$.prototype = new $h_O();
$c_s_util_Right$.prototype.constructor = $c_s_util_Right$;
/** @constructor */
function $h_s_util_Right$() {
}
export { $h_s_util_Right$ as $h_s_util_Right$ };
$h_s_util_Right$.prototype = $c_s_util_Right$.prototype;
$c_s_util_Right$.prototype.toString__T = (function() {
  return "Right";
});
var $d_s_util_Right$ = new $TypeData().initClass($c_s_util_Right$, "scala.util.Right$", ({
  s_util_Right$: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_Right$ as $d_s_util_Right$ };
var $n_s_util_Right$;
function $m_s_util_Right$() {
  if ((!$n_s_util_Right$)) {
    $n_s_util_Right$ = new $c_s_util_Right$();
  }
  return $n_s_util_Right$;
}
export { $m_s_util_Right$ as $m_s_util_Right$ };
/** @constructor */
function $c_s_util_hashing_MurmurHash3$() {
  this.s_util_hashing_MurmurHash3$__f_seqSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_mapSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_setSeed = 0;
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = 0;
  $n_s_util_hashing_MurmurHash3$ = this;
  this.s_util_hashing_MurmurHash3$__f_seqSeed = $f_T__hashCode__I("Seq");
  this.s_util_hashing_MurmurHash3$__f_mapSeed = $f_T__hashCode__I("Map");
  this.s_util_hashing_MurmurHash3$__f_setSeed = $f_T__hashCode__I("Set");
  this.s_util_hashing_MurmurHash3$__f_emptyMapHash = this.unorderedHash__sc_IterableOnce__I__I($m_sci_Nil$(), this.s_util_hashing_MurmurHash3$__f_mapSeed);
}
export { $c_s_util_hashing_MurmurHash3$ as $c_s_util_hashing_MurmurHash3$ };
$c_s_util_hashing_MurmurHash3$.prototype = new $h_s_util_hashing_MurmurHash3();
$c_s_util_hashing_MurmurHash3$.prototype.constructor = $c_s_util_hashing_MurmurHash3$;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$() {
}
export { $h_s_util_hashing_MurmurHash3$ as $h_s_util_hashing_MurmurHash3$ };
$h_s_util_hashing_MurmurHash3$.prototype = $c_s_util_hashing_MurmurHash3$.prototype;
$c_s_util_hashing_MurmurHash3$.prototype.tuple2Hash__O__O__I = (function(x, y) {
  return this.tuple2Hash__I__I__I__I($m_sr_Statics$().anyHash__O__I(x), $m_sr_Statics$().anyHash__O__I(y), (-889275714));
});
$c_s_util_hashing_MurmurHash3$.prototype.seqHash__sc_Seq__I = (function(xs) {
  return ($is_sc_IndexedSeq(xs) ? this.indexedSeqHash__sc_IndexedSeq__I__I(xs, this.s_util_hashing_MurmurHash3$__f_seqSeed) : ((xs instanceof $c_sci_List) ? this.listHash__sci_List__I__I(xs, this.s_util_hashing_MurmurHash3$__f_seqSeed) : this.orderedHash__sc_IterableOnce__I__I(xs, this.s_util_hashing_MurmurHash3$__f_seqSeed)));
});
$c_s_util_hashing_MurmurHash3$.prototype.mapHash__sc_Map__I = (function(xs) {
  if (xs.isEmpty__Z()) {
    return this.s_util_hashing_MurmurHash3$__f_emptyMapHash;
  } else {
    var accum = new $c_s_util_hashing_MurmurHash3$accum$1();
    var h = this.s_util_hashing_MurmurHash3$__f_mapSeed;
    xs.foreachEntry__F2__V(accum);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_a);
    h = this.mix__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_b);
    h = this.mixLast__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_c);
    return this.finalizeHash__I__I__I(h, accum.s_util_hashing_MurmurHash3$accum$1__f_n);
  }
});
var $d_s_util_hashing_MurmurHash3$ = new $TypeData().initClass($c_s_util_hashing_MurmurHash3$, "scala.util.hashing.MurmurHash3$", ({
  s_util_hashing_MurmurHash3$: 1,
  s_util_hashing_MurmurHash3: 1
}));
export { $d_s_util_hashing_MurmurHash3$ as $d_s_util_hashing_MurmurHash3$ };
var $n_s_util_hashing_MurmurHash3$;
function $m_s_util_hashing_MurmurHash3$() {
  if ((!$n_s_util_hashing_MurmurHash3$)) {
    $n_s_util_hashing_MurmurHash3$ = new $c_s_util_hashing_MurmurHash3$();
  }
  return $n_s_util_hashing_MurmurHash3$;
}
export { $m_s_util_hashing_MurmurHash3$ as $m_s_util_hashing_MurmurHash3$ };
/** @constructor */
function $c_s_util_hashing_MurmurHash3$accum$1() {
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_a = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_b = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_n = 0;
  this.s_util_hashing_MurmurHash3$accum$1__f_c = 1;
}
export { $c_s_util_hashing_MurmurHash3$accum$1 as $c_s_util_hashing_MurmurHash3$accum$1 };
$c_s_util_hashing_MurmurHash3$accum$1.prototype = new $h_O();
$c_s_util_hashing_MurmurHash3$accum$1.prototype.constructor = $c_s_util_hashing_MurmurHash3$accum$1;
/** @constructor */
function $h_s_util_hashing_MurmurHash3$accum$1() {
}
export { $h_s_util_hashing_MurmurHash3$accum$1 as $h_s_util_hashing_MurmurHash3$accum$1 };
$h_s_util_hashing_MurmurHash3$accum$1.prototype = $c_s_util_hashing_MurmurHash3$accum$1.prototype;
$c_s_util_hashing_MurmurHash3$accum$1.prototype.toString__T = (function() {
  return "<function2>";
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__V = (function(k, v) {
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(k, v);
  this.s_util_hashing_MurmurHash3$accum$1__f_a = ((this.s_util_hashing_MurmurHash3$accum$1__f_a + h) | 0);
  this.s_util_hashing_MurmurHash3$accum$1__f_b = (this.s_util_hashing_MurmurHash3$accum$1__f_b ^ h);
  this.s_util_hashing_MurmurHash3$accum$1__f_c = Math.imul(this.s_util_hashing_MurmurHash3$accum$1__f_c, (1 | h));
  this.s_util_hashing_MurmurHash3$accum$1__f_n = ((1 + this.s_util_hashing_MurmurHash3$accum$1__f_n) | 0);
});
$c_s_util_hashing_MurmurHash3$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2);
});
var $d_s_util_hashing_MurmurHash3$accum$1 = new $TypeData().initClass($c_s_util_hashing_MurmurHash3$accum$1, "scala.util.hashing.MurmurHash3$accum$1", ({
  s_util_hashing_MurmurHash3$accum$1: 1,
  F2: 1
}));
export { $d_s_util_hashing_MurmurHash3$accum$1 as $d_s_util_hashing_MurmurHash3$accum$1 };
function $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, pattern, groupNames) {
  $thiz.s_util_matching_Regex__f_pattern = pattern;
  return $thiz;
}
export { $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__ as $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__ };
function $ct_s_util_matching_Regex__T__sci_Seq__($thiz, regex, groupNames) {
  $ct_s_util_matching_Regex__ju_regex_Pattern__sci_Seq__($thiz, $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0), groupNames);
  return $thiz;
}
export { $ct_s_util_matching_Regex__T__sci_Seq__ as $ct_s_util_matching_Regex__T__sci_Seq__ };
/** @constructor */
function $c_s_util_matching_Regex() {
  this.s_util_matching_Regex__f_pattern = null;
}
export { $c_s_util_matching_Regex as $c_s_util_matching_Regex };
$c_s_util_matching_Regex.prototype = new $h_O();
$c_s_util_matching_Regex.prototype.constructor = $c_s_util_matching_Regex;
/** @constructor */
function $h_s_util_matching_Regex() {
}
export { $h_s_util_matching_Regex as $h_s_util_matching_Regex };
$h_s_util_matching_Regex.prototype = $c_s_util_matching_Regex.prototype;
$c_s_util_matching_Regex.prototype.unapplySeq__jl_CharSequence__s_Option = (function(s) {
  var this$1 = this.s_util_matching_Regex__f_pattern;
  var m = new $c_ju_regex_Matcher(this$1, $dp_toString__T(s));
  if (m.matches__Z()) {
    var n = m.ju_regex_Matcher__f_pattern0.ju_regex_Pattern__f_groupCount;
    var b = new $c_scm_ListBuffer();
    var i = 0;
    while ((i < n)) {
      var x0 = i;
      var elem = m.group__I__T(((1 + x0) | 0));
      b.addOne__O__scm_ListBuffer(elem);
      i = ((1 + i) | 0);
    }
    return new $c_s_Some(b.toList__sci_List());
  } else {
    return $m_s_None$();
  }
});
$c_s_util_matching_Regex.prototype.matches__jl_CharSequence__Z = (function(source) {
  var this$1 = this.s_util_matching_Regex__f_pattern;
  var m = new $c_ju_regex_Matcher(this$1, $dp_toString__T(source));
  return m.matches__Z();
});
$c_s_util_matching_Regex.prototype.toString__T = (function() {
  return this.s_util_matching_Regex__f_pattern.ju_regex_Pattern__f__pattern;
});
var $d_s_util_matching_Regex = new $TypeData().initClass($c_s_util_matching_Regex, "scala.util.matching.Regex", ({
  s_util_matching_Regex: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_matching_Regex as $d_s_util_matching_Regex };
/** @constructor */
function $c_Lscodec_Codec$given\uff3fTransform\uff3fCodec$() {
}
export { $c_Lscodec_Codec$given\uff3fTransform\uff3fCodec$ as $c_Lscodec_Codec$given\uff3fTransform\uff3fCodec$ };
$c_Lscodec_Codec$given\uff3fTransform\uff3fCodec$.prototype = new $h_O();
$c_Lscodec_Codec$given\uff3fTransform\uff3fCodec$.prototype.constructor = $c_Lscodec_Codec$given\uff3fTransform\uff3fCodec$;
/** @constructor */
function $h_Lscodec_Codec$given\uff3fTransform\uff3fCodec$() {
}
export { $h_Lscodec_Codec$given\uff3fTransform\uff3fCodec$ as $h_Lscodec_Codec$given\uff3fTransform\uff3fCodec$ };
$h_Lscodec_Codec$given\uff3fTransform\uff3fCodec$.prototype = $c_Lscodec_Codec$given\uff3fTransform\uff3fCodec$.prototype;
var $d_Lscodec_Codec$given\uff3fTransform\uff3fCodec$ = new $TypeData().initClass($c_Lscodec_Codec$given\uff3fTransform\uff3fCodec$, "scodec.Codec$given_Transform_Codec$", ({
  Lscodec_Codec$given\uff3fTransform\uff3fCodec$: 1,
  Lscodec_Transform: 1
}));
export { $d_Lscodec_Codec$given\uff3fTransform\uff3fCodec$ as $d_Lscodec_Codec$given\uff3fTransform\uff3fCodec$ };
var $n_Lscodec_Codec$given\uff3fTransform\uff3fCodec$;
function $m_Lscodec_Codec$given\uff3fTransform\uff3fCodec$() {
  if ((!$n_Lscodec_Codec$given\uff3fTransform\uff3fCodec$)) {
    $n_Lscodec_Codec$given\uff3fTransform\uff3fCodec$ = new $c_Lscodec_Codec$given\uff3fTransform\uff3fCodec$();
  }
  return $n_Lscodec_Codec$given\uff3fTransform\uff3fCodec$;
}
export { $m_Lscodec_Codec$given\uff3fTransform\uff3fCodec$ as $m_Lscodec_Codec$given\uff3fTransform\uff3fCodec$ };
/** @constructor */
function $c_Lscodec_Decoder$$anon$1(f$9, outer) {
  this.Lscodec_Decoder$$anon$1__f_f$1 = null;
  this.Lscodec_Decoder$$anon$1__f_$outer = null;
  this.Lscodec_Decoder$$anon$1__f_f$1 = f$9;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lscodec_Decoder$$anon$1__f_$outer = outer;
}
export { $c_Lscodec_Decoder$$anon$1 as $c_Lscodec_Decoder$$anon$1 };
$c_Lscodec_Decoder$$anon$1.prototype = new $h_O();
$c_Lscodec_Decoder$$anon$1.prototype.constructor = $c_Lscodec_Decoder$$anon$1;
/** @constructor */
function $h_Lscodec_Decoder$$anon$1() {
}
export { $h_Lscodec_Decoder$$anon$1 as $h_Lscodec_Decoder$$anon$1 };
$h_Lscodec_Decoder$$anon$1.prototype = $c_Lscodec_Decoder$$anon$1.prototype;
$c_Lscodec_Decoder$$anon$1.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(bits) {
  return this.Lscodec_Decoder$$anon$1__f_$outer.decode__Lscodec_bits_BitVector__Lscodec_Attempt(bits).map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => _$2.map__F1__Lscodec_DecodeResult(this.Lscodec_Decoder$$anon$1__f_f$1))));
});
var $d_Lscodec_Decoder$$anon$1 = new $TypeData().initClass($c_Lscodec_Decoder$$anon$1, "scodec.Decoder$$anon$1", ({
  Lscodec_Decoder$$anon$1: 1,
  Lscodec_Decoder: 1
}));
export { $d_Lscodec_Decoder$$anon$1 as $d_Lscodec_Decoder$$anon$1 };
/** @constructor */
function $c_Lscodec_Decoder$$anon$2(f$10, outer) {
  this.Lscodec_Decoder$$anon$2__f_f$2 = null;
  this.Lscodec_Decoder$$anon$2__f_$outer = null;
  this.Lscodec_Decoder$$anon$2__f_f$2 = f$10;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lscodec_Decoder$$anon$2__f_$outer = outer;
}
export { $c_Lscodec_Decoder$$anon$2 as $c_Lscodec_Decoder$$anon$2 };
$c_Lscodec_Decoder$$anon$2.prototype = new $h_O();
$c_Lscodec_Decoder$$anon$2.prototype.constructor = $c_Lscodec_Decoder$$anon$2;
/** @constructor */
function $h_Lscodec_Decoder$$anon$2() {
}
export { $h_Lscodec_Decoder$$anon$2 as $h_Lscodec_Decoder$$anon$2 };
$h_Lscodec_Decoder$$anon$2.prototype = $c_Lscodec_Decoder$$anon$2.prototype;
$c_Lscodec_Decoder$$anon$2.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(bits) {
  return this.Lscodec_Decoder$$anon$2__f_$outer.decode__Lscodec_bits_BitVector__Lscodec_Attempt(bits).flatMap__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((result) => this.Lscodec_Decoder$$anon$2__f_f$2.apply__O__O(result.Lscodec_DecodeResult__f_value).decode__Lscodec_bits_BitVector__Lscodec_Attempt(result.Lscodec_DecodeResult__f_remainder))));
});
var $d_Lscodec_Decoder$$anon$2 = new $TypeData().initClass($c_Lscodec_Decoder$$anon$2, "scodec.Decoder$$anon$2", ({
  Lscodec_Decoder$$anon$2: 1,
  Lscodec_Decoder: 1
}));
export { $d_Lscodec_Decoder$$anon$2 as $d_Lscodec_Decoder$$anon$2 };
/** @constructor */
function $c_Lscodec_Decoder$$anon$3(f$11, outer) {
  this.Lscodec_Decoder$$anon$3__f_f$3 = null;
  this.Lscodec_Decoder$$anon$3__f_$outer = null;
  this.Lscodec_Decoder$$anon$3__f_f$3 = f$11;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lscodec_Decoder$$anon$3__f_$outer = outer;
}
export { $c_Lscodec_Decoder$$anon$3 as $c_Lscodec_Decoder$$anon$3 };
$c_Lscodec_Decoder$$anon$3.prototype = new $h_O();
$c_Lscodec_Decoder$$anon$3.prototype.constructor = $c_Lscodec_Decoder$$anon$3;
/** @constructor */
function $h_Lscodec_Decoder$$anon$3() {
}
export { $h_Lscodec_Decoder$$anon$3 as $h_Lscodec_Decoder$$anon$3 };
$h_Lscodec_Decoder$$anon$3.prototype = $c_Lscodec_Decoder$$anon$3.prototype;
$c_Lscodec_Decoder$$anon$3.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(bits) {
  return this.Lscodec_Decoder$$anon$3__f_$outer.decode__Lscodec_bits_BitVector__Lscodec_Attempt(bits).flatMap__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((result) => this.Lscodec_Decoder$$anon$3__f_f$3.apply__O__O(result.Lscodec_DecodeResult__f_value).map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((result$2) => ((b) => {
    var remainder = result$2.Lscodec_DecodeResult__f_remainder;
    return new $c_Lscodec_DecodeResult(b, remainder);
  }))(result))))));
});
var $d_Lscodec_Decoder$$anon$3 = new $TypeData().initClass($c_Lscodec_Decoder$$anon$3, "scodec.Decoder$$anon$3", ({
  Lscodec_Decoder$$anon$3: 1,
  Lscodec_Decoder: 1
}));
export { $d_Lscodec_Decoder$$anon$3 as $d_Lscodec_Decoder$$anon$3 };
/** @constructor */
function $c_Lscodec_Decoder$$anon$9(attempt$2) {
  this.Lscodec_Decoder$$anon$9__f_attempt$1 = null;
  this.Lscodec_Decoder$$anon$9__f_attempt$1 = attempt$2;
}
export { $c_Lscodec_Decoder$$anon$9 as $c_Lscodec_Decoder$$anon$9 };
$c_Lscodec_Decoder$$anon$9.prototype = new $h_O();
$c_Lscodec_Decoder$$anon$9.prototype.constructor = $c_Lscodec_Decoder$$anon$9;
/** @constructor */
function $h_Lscodec_Decoder$$anon$9() {
}
export { $h_Lscodec_Decoder$$anon$9 as $h_Lscodec_Decoder$$anon$9 };
$h_Lscodec_Decoder$$anon$9.prototype = $c_Lscodec_Decoder$$anon$9.prototype;
$c_Lscodec_Decoder$$anon$9.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(b) {
  return this.Lscodec_Decoder$$anon$9__f_attempt$1.map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => new $c_Lscodec_DecodeResult(a, b))));
});
$c_Lscodec_Decoder$$anon$9.prototype.toString__T = (function() {
  return (("constAttempt(" + this.Lscodec_Decoder$$anon$9__f_attempt$1) + ")");
});
var $d_Lscodec_Decoder$$anon$9 = new $TypeData().initClass($c_Lscodec_Decoder$$anon$9, "scodec.Decoder$$anon$9", ({
  Lscodec_Decoder$$anon$9: 1,
  Lscodec_Decoder: 1
}));
export { $d_Lscodec_Decoder$$anon$9 as $d_Lscodec_Decoder$$anon$9 };
/** @constructor */
function $c_Lscodec_Encoder$() {
}
export { $c_Lscodec_Encoder$ as $c_Lscodec_Encoder$ };
$c_Lscodec_Encoder$.prototype = new $h_O();
$c_Lscodec_Encoder$.prototype.constructor = $c_Lscodec_Encoder$;
/** @constructor */
function $h_Lscodec_Encoder$() {
}
export { $h_Lscodec_Encoder$ as $h_Lscodec_Encoder$ };
$h_Lscodec_Encoder$.prototype = $c_Lscodec_Encoder$.prototype;
var $d_Lscodec_Encoder$ = new $TypeData().initClass($c_Lscodec_Encoder$, "scodec.Encoder$", ({
  Lscodec_Encoder$: 1,
  Lscodec_EncoderFunctions: 1
}));
export { $d_Lscodec_Encoder$ as $d_Lscodec_Encoder$ };
var $n_Lscodec_Encoder$;
function $m_Lscodec_Encoder$() {
  if ((!$n_Lscodec_Encoder$)) {
    $n_Lscodec_Encoder$ = new $c_Lscodec_Encoder$();
  }
  return $n_Lscodec_Encoder$;
}
export { $m_Lscodec_Encoder$ as $m_Lscodec_Encoder$ };
/** @constructor */
function $c_Lscodec_Encoder$$anon$3(f$7, outer) {
  this.Lscodec_Encoder$$anon$3__f_f$3 = null;
  this.Lscodec_Encoder$$anon$3__f_$outer = null;
  this.Lscodec_Encoder$$anon$3__f_f$3 = f$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lscodec_Encoder$$anon$3__f_$outer = outer;
}
export { $c_Lscodec_Encoder$$anon$3 as $c_Lscodec_Encoder$$anon$3 };
$c_Lscodec_Encoder$$anon$3.prototype = new $h_O();
$c_Lscodec_Encoder$$anon$3.prototype.constructor = $c_Lscodec_Encoder$$anon$3;
/** @constructor */
function $h_Lscodec_Encoder$$anon$3() {
}
export { $h_Lscodec_Encoder$$anon$3 as $h_Lscodec_Encoder$$anon$3 };
$h_Lscodec_Encoder$$anon$3.prototype = $c_Lscodec_Encoder$$anon$3.prototype;
$c_Lscodec_Encoder$$anon$3.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_Encoder$$anon$3__f_$outer.sizeBound__Lscodec_SizeBound();
});
$c_Lscodec_Encoder$$anon$3.prototype.encode__O__Lscodec_Attempt = (function(b) {
  return this.Lscodec_Encoder$$anon$3__f_f$3.apply__O__O(b).flatMap__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => this.Lscodec_Encoder$$anon$3__f_$outer.encode__O__Lscodec_Attempt(value))));
});
var $d_Lscodec_Encoder$$anon$3 = new $TypeData().initClass($c_Lscodec_Encoder$$anon$3, "scodec.Encoder$$anon$3", ({
  Lscodec_Encoder$$anon$3: 1,
  Lscodec_Encoder: 1
}));
export { $d_Lscodec_Encoder$$anon$3 as $d_Lscodec_Encoder$$anon$3 };
/** @constructor */
function $c_Lscodec_bits_ByteVector$$anon$13(f$28) {
  this.Lscodec_bits_ByteVector$$anon$13__f_f$14 = null;
  this.Lscodec_bits_ByteVector$$anon$13__f_f$14 = f$28;
}
export { $c_Lscodec_bits_ByteVector$$anon$13 as $c_Lscodec_bits_ByteVector$$anon$13 };
$c_Lscodec_bits_ByteVector$$anon$13.prototype = new $h_Lscodec_bits_ByteVector$F2B();
$c_Lscodec_bits_ByteVector$$anon$13.prototype.constructor = $c_Lscodec_bits_ByteVector$$anon$13;
/** @constructor */
function $h_Lscodec_bits_ByteVector$$anon$13() {
}
export { $h_Lscodec_bits_ByteVector$$anon$13 as $h_Lscodec_bits_ByteVector$$anon$13 };
$h_Lscodec_bits_ByteVector$$anon$13.prototype = $c_Lscodec_bits_ByteVector$$anon$13.prototype;
$c_Lscodec_bits_ByteVector$$anon$13.prototype.apply__B__B__B = (function(b, b2) {
  return (this.Lscodec_bits_ByteVector$$anon$13__f_f$14.apply__O__O__O(b, b2) | 0);
});
var $d_Lscodec_bits_ByteVector$$anon$13 = new $TypeData().initClass($c_Lscodec_bits_ByteVector$$anon$13, "scodec.bits.ByteVector$$anon$13", ({
  Lscodec_bits_ByteVector$$anon$13: 1,
  Lscodec_bits_ByteVector$F2B: 1
}));
export { $d_Lscodec_bits_ByteVector$$anon$13 as $d_Lscodec_bits_ByteVector$$anon$13 };
/** @constructor */
function $c_Lscodec_bits_ByteVector$$anon$16(f$31, other$5, outer) {
  this.Lscodec_bits_ByteVector$$anon$16__f_f$17 = null;
  this.Lscodec_bits_ByteVector$$anon$16__f_other$1 = null;
  this.Lscodec_bits_ByteVector$$anon$16__f_$outer = null;
  this.Lscodec_bits_ByteVector$$anon$16__f_f$17 = f$31;
  this.Lscodec_bits_ByteVector$$anon$16__f_other$1 = other$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lscodec_bits_ByteVector$$anon$16__f_$outer = outer;
}
export { $c_Lscodec_bits_ByteVector$$anon$16 as $c_Lscodec_bits_ByteVector$$anon$16 };
$c_Lscodec_bits_ByteVector$$anon$16.prototype = new $h_Lscodec_bits_ByteVector$At();
$c_Lscodec_bits_ByteVector$$anon$16.prototype.constructor = $c_Lscodec_bits_ByteVector$$anon$16;
/** @constructor */
function $h_Lscodec_bits_ByteVector$$anon$16() {
}
export { $h_Lscodec_bits_ByteVector$$anon$16 as $h_Lscodec_bits_ByteVector$$anon$16 };
$h_Lscodec_bits_ByteVector$$anon$16.prototype = $c_Lscodec_bits_ByteVector$$anon$16.prototype;
$c_Lscodec_bits_ByteVector$$anon$16.prototype.apply__J__B = (function(i) {
  var $x_2 = this.Lscodec_bits_ByteVector$$anon$16__f_f$17;
  var this$1 = this.Lscodec_bits_ByteVector$$anon$16__f_$outer;
  var $x_1 = this$1.get__J__B(i);
  var this$2 = this.Lscodec_bits_ByteVector$$anon$16__f_other$1;
  return $x_2.apply__B__B__B($x_1, this$2.get__J__B(i));
});
var $d_Lscodec_bits_ByteVector$$anon$16 = new $TypeData().initClass($c_Lscodec_bits_ByteVector$$anon$16, "scodec.bits.ByteVector$$anon$16", ({
  Lscodec_bits_ByteVector$$anon$16: 1,
  Lscodec_bits_ByteVector$At: 1
}));
export { $d_Lscodec_bits_ByteVector$$anon$16 as $d_Lscodec_bits_ByteVector$$anon$16 };
/** @constructor */
function $c_Lscodec_bits_ByteVector$$anon$19(at$3) {
  this.Lscodec_bits_ByteVector$$anon$19__f_at$1 = null;
  this.Lscodec_bits_ByteVector$$anon$19__f_at$1 = at$3;
}
export { $c_Lscodec_bits_ByteVector$$anon$19 as $c_Lscodec_bits_ByteVector$$anon$19 };
$c_Lscodec_bits_ByteVector$$anon$19.prototype = new $h_Lscodec_bits_ByteVector$At();
$c_Lscodec_bits_ByteVector$$anon$19.prototype.constructor = $c_Lscodec_bits_ByteVector$$anon$19;
/** @constructor */
function $h_Lscodec_bits_ByteVector$$anon$19() {
}
export { $h_Lscodec_bits_ByteVector$$anon$19 as $h_Lscodec_bits_ByteVector$$anon$19 };
$h_Lscodec_bits_ByteVector$$anon$19.prototype = $c_Lscodec_bits_ByteVector$$anon$19.prototype;
$c_Lscodec_bits_ByteVector$$anon$19.prototype.apply__J__B = (function(i) {
  return (this.Lscodec_bits_ByteVector$$anon$19__f_at$1.apply__O__O(i) | 0);
});
var $d_Lscodec_bits_ByteVector$$anon$19 = new $TypeData().initClass($c_Lscodec_bits_ByteVector$$anon$19, "scodec.bits.ByteVector$$anon$19", ({
  Lscodec_bits_ByteVector$$anon$19: 1,
  Lscodec_bits_ByteVector$At: 1
}));
export { $d_Lscodec_bits_ByteVector$$anon$19 as $d_Lscodec_bits_ByteVector$$anon$19 };
/** @constructor */
function $c_Lscodec_bits_ByteVector$$anon$21(value$2) {
  this.Lscodec_bits_ByteVector$$anon$21__f_value$1 = 0;
  this.Lscodec_bits_ByteVector$$anon$21__f_value$1 = value$2;
}
export { $c_Lscodec_bits_ByteVector$$anon$21 as $c_Lscodec_bits_ByteVector$$anon$21 };
$c_Lscodec_bits_ByteVector$$anon$21.prototype = new $h_Lscodec_bits_ByteVector$At();
$c_Lscodec_bits_ByteVector$$anon$21.prototype.constructor = $c_Lscodec_bits_ByteVector$$anon$21;
/** @constructor */
function $h_Lscodec_bits_ByteVector$$anon$21() {
}
export { $h_Lscodec_bits_ByteVector$$anon$21 as $h_Lscodec_bits_ByteVector$$anon$21 };
$h_Lscodec_bits_ByteVector$$anon$21.prototype = $c_Lscodec_bits_ByteVector$$anon$21.prototype;
$c_Lscodec_bits_ByteVector$$anon$21.prototype.apply__J__B = (function(i) {
  return this.Lscodec_bits_ByteVector$$anon$21__f_value$1;
});
var $d_Lscodec_bits_ByteVector$$anon$21 = new $TypeData().initClass($c_Lscodec_bits_ByteVector$$anon$21, "scodec.bits.ByteVector$$anon$21", ({
  Lscodec_bits_ByteVector$$anon$21: 1,
  Lscodec_bits_ByteVector$At: 1
}));
export { $d_Lscodec_bits_ByteVector$$anon$21 as $d_Lscodec_bits_ByteVector$$anon$21 };
/** @constructor */
function $c_Lscodec_bits_ByteVector$$anon$8(out$5, i$11, alphabet$10, outer) {
  this.Lscodec_bits_ByteVector$$anon$8__f_out$3 = null;
  this.Lscodec_bits_ByteVector$$anon$8__f_i$8 = null;
  this.Lscodec_bits_ByteVector$$anon$8__f_alphabet$7 = null;
  this.Lscodec_bits_ByteVector$$anon$8__f_out$3 = out$5;
  this.Lscodec_bits_ByteVector$$anon$8__f_i$8 = i$11;
  this.Lscodec_bits_ByteVector$$anon$8__f_alphabet$7 = alphabet$10;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Lscodec_bits_ByteVector$$anon$8 as $c_Lscodec_bits_ByteVector$$anon$8 };
$c_Lscodec_bits_ByteVector$$anon$8.prototype = new $h_Lscodec_bits_ByteVector$F1BU();
$c_Lscodec_bits_ByteVector$$anon$8.prototype.constructor = $c_Lscodec_bits_ByteVector$$anon$8;
/** @constructor */
function $h_Lscodec_bits_ByteVector$$anon$8() {
}
export { $h_Lscodec_bits_ByteVector$$anon$8 as $h_Lscodec_bits_ByteVector$$anon$8 };
$h_Lscodec_bits_ByteVector$$anon$8.prototype = $c_Lscodec_bits_ByteVector$$anon$8.prototype;
$c_Lscodec_bits_ByteVector$$anon$8.prototype.apply__B__V = (function(b) {
  $s_Lscodec_bits_ByteVector__scodec$bits$ByteVector$$_$update$1__AC__sr_IntRef__Lscodec_bits_Bases$HexAlphabet__B__V(this.Lscodec_bits_ByteVector$$anon$8__f_out$3, this.Lscodec_bits_ByteVector$$anon$8__f_i$8, this.Lscodec_bits_ByteVector$$anon$8__f_alphabet$7, b);
});
var $d_Lscodec_bits_ByteVector$$anon$8 = new $TypeData().initClass($c_Lscodec_bits_ByteVector$$anon$8, "scodec.bits.ByteVector$$anon$8", ({
  Lscodec_bits_ByteVector$$anon$8: 1,
  Lscodec_bits_ByteVector$F1BU: 1
}));
export { $d_Lscodec_bits_ByteVector$$anon$8 as $d_Lscodec_bits_ByteVector$$anon$8 };
/** @constructor */
function $c_Lscodec_bits_ByteVector$AtArray(arr) {
  this.Lscodec_bits_ByteVector$AtArray__f_arr = null;
  this.Lscodec_bits_ByteVector$AtArray__f_arr = arr;
}
export { $c_Lscodec_bits_ByteVector$AtArray as $c_Lscodec_bits_ByteVector$AtArray };
$c_Lscodec_bits_ByteVector$AtArray.prototype = new $h_Lscodec_bits_ByteVector$At();
$c_Lscodec_bits_ByteVector$AtArray.prototype.constructor = $c_Lscodec_bits_ByteVector$AtArray;
/** @constructor */
function $h_Lscodec_bits_ByteVector$AtArray() {
}
export { $h_Lscodec_bits_ByteVector$AtArray as $h_Lscodec_bits_ByteVector$AtArray };
$h_Lscodec_bits_ByteVector$AtArray.prototype = $c_Lscodec_bits_ByteVector$AtArray.prototype;
$c_Lscodec_bits_ByteVector$AtArray.prototype.apply__J__B = (function(i) {
  return this.Lscodec_bits_ByteVector$AtArray__f_arr.u[i.RTLong__f_lo];
});
$c_Lscodec_bits_ByteVector$AtArray.prototype.asByteBuffer__J__I__Ljava_nio_ByteBuffer = (function(start, size) {
  return this.asByteBufferUnsafe__J__I__Ljava_nio_ByteBuffer(start, size).asReadOnlyBuffer__Ljava_nio_ByteBuffer();
});
$c_Lscodec_bits_ByteVector$AtArray.prototype.asByteBufferUnsafe__J__I__Ljava_nio_ByteBuffer = (function(start, size) {
  var array = this.Lscodec_bits_ByteVector$AtArray__f_arr;
  var offset = start.RTLong__f_lo;
  var b = $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(array, 0, array.u.length, offset, size, false);
  return ((((start.RTLong__f_lo === 0) && (start.RTLong__f_hi === 0)) && (size === this.Lscodec_bits_ByteVector$AtArray__f_arr.u.length)) ? b : b.slice__Ljava_nio_ByteBuffer());
});
$c_Lscodec_bits_ByteVector$AtArray.prototype.copyToArray__AB__I__J__I__V = (function(xs, start, offset, size) {
  var src = this.Lscodec_bits_ByteVector$AtArray__f_arr;
  var srcPos = offset.RTLong__f_lo;
  src.copyTo(srcPos, xs, start, size);
});
function $isArrayOf_Lscodec_bits_ByteVector$AtArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_ByteVector$AtArray)));
}
export { $isArrayOf_Lscodec_bits_ByteVector$AtArray as $isArrayOf_Lscodec_bits_ByteVector$AtArray };
var $d_Lscodec_bits_ByteVector$AtArray = new $TypeData().initClass($c_Lscodec_bits_ByteVector$AtArray, "scodec.bits.ByteVector$AtArray", ({
  Lscodec_bits_ByteVector$AtArray: 1,
  Lscodec_bits_ByteVector$At: 1
}));
export { $d_Lscodec_bits_ByteVector$AtArray as $d_Lscodec_bits_ByteVector$AtArray };
/** @constructor */
function $c_Lscodec_bits_ByteVector$AtByteBuffer(buf) {
  this.Lscodec_bits_ByteVector$AtByteBuffer__f_buf = null;
  this.Lscodec_bits_ByteVector$AtByteBuffer__f_buf = buf;
}
export { $c_Lscodec_bits_ByteVector$AtByteBuffer as $c_Lscodec_bits_ByteVector$AtByteBuffer };
$c_Lscodec_bits_ByteVector$AtByteBuffer.prototype = new $h_Lscodec_bits_ByteVector$At();
$c_Lscodec_bits_ByteVector$AtByteBuffer.prototype.constructor = $c_Lscodec_bits_ByteVector$AtByteBuffer;
/** @constructor */
function $h_Lscodec_bits_ByteVector$AtByteBuffer() {
}
export { $h_Lscodec_bits_ByteVector$AtByteBuffer as $h_Lscodec_bits_ByteVector$AtByteBuffer };
$h_Lscodec_bits_ByteVector$AtByteBuffer.prototype = $c_Lscodec_bits_ByteVector$AtByteBuffer.prototype;
$c_Lscodec_bits_ByteVector$AtByteBuffer.prototype.apply__J__B = (function(i) {
  return this.Lscodec_bits_ByteVector$AtByteBuffer__f_buf.get__I__B(i.RTLong__f_lo);
});
$c_Lscodec_bits_ByteVector$AtByteBuffer.prototype.copyToArray__AB__I__J__I__V = (function(xs, start, offset, size) {
  var n = this.Lscodec_bits_ByteVector$AtByteBuffer__f_buf.duplicate__Ljava_nio_ByteBuffer();
  var newPosition = offset.RTLong__f_lo;
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(n, newPosition);
  n.get__AB__I__I__Ljava_nio_ByteBuffer(xs, start, size);
});
$c_Lscodec_bits_ByteVector$AtByteBuffer.prototype.asByteBuffer__J__I__Ljava_nio_ByteBuffer = (function(offset, size) {
  return this.asByteBufferUnsafe__J__I__Ljava_nio_ByteBuffer(offset, size).asReadOnlyBuffer__Ljava_nio_ByteBuffer();
});
$c_Lscodec_bits_ByteVector$AtByteBuffer.prototype.asByteBufferUnsafe__J__I__Ljava_nio_ByteBuffer = (function(offset, size) {
  var b = this.Lscodec_bits_ByteVector$AtByteBuffer__f_buf.duplicate__Ljava_nio_ByteBuffer();
  if (((((offset.RTLong__f_lo === 0) && (offset.RTLong__f_hi === 0)) && (b.Ljava_nio_Buffer__f_java$nio$Buffer$$_position === 0)) && (size === ((b.Ljava_nio_Buffer__f__limit - b.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0)))) {
    return b;
  } else {
    var newPosition = offset.RTLong__f_lo;
    $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(b, newPosition);
    var newLimit = ((offset.RTLong__f_lo + size) | 0);
    $c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer.call(b, newLimit);
    return b.slice__Ljava_nio_ByteBuffer();
  }
});
function $isArrayOf_Lscodec_bits_ByteVector$AtByteBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_ByteVector$AtByteBuffer)));
}
export { $isArrayOf_Lscodec_bits_ByteVector$AtByteBuffer as $isArrayOf_Lscodec_bits_ByteVector$AtByteBuffer };
var $d_Lscodec_bits_ByteVector$AtByteBuffer = new $TypeData().initClass($c_Lscodec_bits_ByteVector$AtByteBuffer, "scodec.bits.ByteVector$AtByteBuffer", ({
  Lscodec_bits_ByteVector$AtByteBuffer: 1,
  Lscodec_bits_ByteVector$At: 1
}));
export { $d_Lscodec_bits_ByteVector$AtByteBuffer as $d_Lscodec_bits_ByteVector$AtByteBuffer };
/** @constructor */
function $c_Lscodec_bits_ByteVector$AtEmpty$() {
}
export { $c_Lscodec_bits_ByteVector$AtEmpty$ as $c_Lscodec_bits_ByteVector$AtEmpty$ };
$c_Lscodec_bits_ByteVector$AtEmpty$.prototype = new $h_Lscodec_bits_ByteVector$At();
$c_Lscodec_bits_ByteVector$AtEmpty$.prototype.constructor = $c_Lscodec_bits_ByteVector$AtEmpty$;
/** @constructor */
function $h_Lscodec_bits_ByteVector$AtEmpty$() {
}
export { $h_Lscodec_bits_ByteVector$AtEmpty$ as $h_Lscodec_bits_ByteVector$AtEmpty$ };
$h_Lscodec_bits_ByteVector$AtEmpty$.prototype = $c_Lscodec_bits_ByteVector$AtEmpty$.prototype;
$c_Lscodec_bits_ByteVector$AtEmpty$.prototype.apply__J__B = (function(i) {
  throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "empty view");
});
$c_Lscodec_bits_ByteVector$AtEmpty$.prototype.asByteBuffer__J__I__Ljava_nio_ByteBuffer = (function(start, size) {
  return $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(0);
});
var $d_Lscodec_bits_ByteVector$AtEmpty$ = new $TypeData().initClass($c_Lscodec_bits_ByteVector$AtEmpty$, "scodec.bits.ByteVector$AtEmpty$", ({
  Lscodec_bits_ByteVector$AtEmpty$: 1,
  Lscodec_bits_ByteVector$At: 1
}));
export { $d_Lscodec_bits_ByteVector$AtEmpty$ as $d_Lscodec_bits_ByteVector$AtEmpty$ };
var $n_Lscodec_bits_ByteVector$AtEmpty$;
function $m_Lscodec_bits_ByteVector$AtEmpty$() {
  if ((!$n_Lscodec_bits_ByteVector$AtEmpty$)) {
    $n_Lscodec_bits_ByteVector$AtEmpty$ = new $c_Lscodec_bits_ByteVector$AtEmpty$();
  }
  return $n_Lscodec_bits_ByteVector$AtEmpty$;
}
export { $m_Lscodec_bits_ByteVector$AtEmpty$ as $m_Lscodec_bits_ByteVector$AtEmpty$ };
/** @constructor */
function $c_Lscodec_codecs_codecs$package$$anon$22() {
}
export { $c_Lscodec_codecs_codecs$package$$anon$22 as $c_Lscodec_codecs_codecs$package$$anon$22 };
$c_Lscodec_codecs_codecs$package$$anon$22.prototype = new $h_Lscodec_codecs_NeedDiscriminatorCodec();
$c_Lscodec_codecs_codecs$package$$anon$22.prototype.constructor = $c_Lscodec_codecs_codecs$package$$anon$22;
/** @constructor */
function $h_Lscodec_codecs_codecs$package$$anon$22() {
}
export { $h_Lscodec_codecs_codecs$package$$anon$22 as $h_Lscodec_codecs_codecs$package$$anon$22 };
$h_Lscodec_codecs_codecs$package$$anon$22.prototype = $c_Lscodec_codecs_codecs$package$$anon$22.prototype;
$c_Lscodec_codecs_codecs$package$$anon$22.prototype.by__Lscodec_Codec__Lscodec_codecs_DiscriminatorCodec = (function(discriminatorCodec) {
  var this$1 = $m_sci_Vector$();
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  return new $c_Lscodec_codecs_DiscriminatorCodec(discriminatorCodec, this$1.from__sc_IterableOnce__sci_Vector(elems), new $c_Lscodec_codecs_codecs$package$$anon$23());
});
var $d_Lscodec_codecs_codecs$package$$anon$22 = new $TypeData().initClass($c_Lscodec_codecs_codecs$package$$anon$22, "scodec.codecs.codecs$package$$anon$22", ({
  Lscodec_codecs_codecs$package$$anon$22: 1,
  Lscodec_codecs_NeedDiscriminatorCodec: 1
}));
export { $d_Lscodec_codecs_codecs$package$$anon$22 as $d_Lscodec_codecs_codecs$package$$anon$22 };
/** @constructor */
function $c_Lscodec_codecs_codecs$package$$anon$23() {
}
export { $c_Lscodec_codecs_codecs$package$$anon$23 as $c_Lscodec_codecs_codecs$package$$anon$23 };
$c_Lscodec_codecs_codecs$package$$anon$23.prototype = new $h_O();
$c_Lscodec_codecs_codecs$package$$anon$23.prototype.constructor = $c_Lscodec_codecs_codecs$package$$anon$23;
/** @constructor */
function $h_Lscodec_codecs_codecs$package$$anon$23() {
}
export { $h_Lscodec_codecs_codecs$package$$anon$23 as $h_Lscodec_codecs_codecs$package$$anon$23 };
$h_Lscodec_codecs_codecs$package$$anon$23.prototype = $c_Lscodec_codecs_codecs$package$$anon$23.prototype;
$c_Lscodec_codecs_codecs$package$$anon$23.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lscodec_codecs_codecs$package$$anon$23.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_Lscodec_codecs_codecs$package$$anon$23.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lscodec_codecs_codecs$package$$anon$23.prototype.apply__O__O = (function(x) {
  return x;
});
$c_Lscodec_codecs_codecs$package$$anon$23.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return v1;
});
var $d_Lscodec_codecs_codecs$package$$anon$23 = new $TypeData().initClass($c_Lscodec_codecs_codecs$package$$anon$23, "scodec.codecs.codecs$package$$anon$23", ({
  Lscodec_codecs_codecs$package$$anon$23: 1,
  F1: 1
}));
export { $d_Lscodec_codecs_codecs$package$$anon$23 as $d_Lscodec_codecs_codecs$package$$anon$23 };
function $f_Lsquants_PrimaryUnit__converterTo__F1($thiz) {
  return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => {
    var value$1 = (+value);
    return value$1;
  }));
}
export { $f_Lsquants_PrimaryUnit__converterTo__F1 as $f_Lsquants_PrimaryUnit__converterTo__F1 };
function $f_Lsquants_PrimaryUnit__converterFrom__F1($thiz) {
  return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => {
    var value$1 = (+value);
    return value$1;
  }));
}
export { $f_Lsquants_PrimaryUnit__converterFrom__F1 as $f_Lsquants_PrimaryUnit__converterFrom__F1 };
function $f_Lsquants_UnitOfMeasure__convertTo__O__s_math_Numeric__D($thiz, n, num) {
  return (+$thiz.converterTo__F1().apply__O__O(num.toDouble__O__D(n)));
}
export { $f_Lsquants_UnitOfMeasure__convertTo__O__s_math_Numeric__D as $f_Lsquants_UnitOfMeasure__convertTo__O__s_math_Numeric__D };
function $f_Lsquants_UnitOfMeasure__convertFrom__O__s_math_Numeric__D($thiz, n, num) {
  return (+$thiz.converterFrom__F1().apply__O__O(num.toDouble__O__D(n)));
}
export { $f_Lsquants_UnitOfMeasure__convertFrom__O__s_math_Numeric__D as $f_Lsquants_UnitOfMeasure__convertFrom__O__s_math_Numeric__D };
/** @constructor */
function $c_Lsttp_model_HeaderNames$() {
  this.Lsttp_model_HeaderNames$__f_AcceptEncoding = null;
  this.Lsttp_model_HeaderNames$__f_Authorization = null;
  this.Lsttp_model_HeaderNames$__f_ContentLength = null;
  this.Lsttp_model_HeaderNames$__f_ContentMd5 = null;
  this.Lsttp_model_HeaderNames$__f_ContentType = null;
  this.Lsttp_model_HeaderNames$__f_Cookie = null;
  this.Lsttp_model_HeaderNames$__f_ProxyAuthorization = null;
  this.Lsttp_model_HeaderNames$__f_SetCookie = null;
  this.Lsttp_model_HeaderNames$__f_SensitiveHeaders = null;
  $n_Lsttp_model_HeaderNames$ = this;
  $f_Lsttp_model_HeaderNames__$init$__V(this);
}
export { $c_Lsttp_model_HeaderNames$ as $c_Lsttp_model_HeaderNames$ };
$c_Lsttp_model_HeaderNames$.prototype = new $h_O();
$c_Lsttp_model_HeaderNames$.prototype.constructor = $c_Lsttp_model_HeaderNames$;
/** @constructor */
function $h_Lsttp_model_HeaderNames$() {
}
export { $h_Lsttp_model_HeaderNames$ as $h_Lsttp_model_HeaderNames$ };
$h_Lsttp_model_HeaderNames$.prototype = $c_Lsttp_model_HeaderNames$.prototype;
var $d_Lsttp_model_HeaderNames$ = new $TypeData().initClass($c_Lsttp_model_HeaderNames$, "sttp.model.HeaderNames$", ({
  Lsttp_model_HeaderNames$: 1,
  Lsttp_model_HeaderNames: 1
}));
export { $d_Lsttp_model_HeaderNames$ as $d_Lsttp_model_HeaderNames$ };
var $n_Lsttp_model_HeaderNames$;
function $m_Lsttp_model_HeaderNames$() {
  if ((!$n_Lsttp_model_HeaderNames$)) {
    $n_Lsttp_model_HeaderNames$ = new $c_Lsttp_model_HeaderNames$();
  }
  return $n_Lsttp_model_HeaderNames$;
}
export { $m_Lsttp_model_HeaderNames$ as $m_Lsttp_model_HeaderNames$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$() {
  this.Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$__f_AuthorityTerminators = null;
  $n_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$ = this;
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([47, 63, 35])));
  var set = this$1.from__sc_IterableOnce__sci_Set(elems);
  this.Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$__f_AuthorityTerminators = new $c_Lsttp_model_internal_FastCharSet(set);
}
export { $c_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$ as $c_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$ };
$c_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$.prototype.constructor = $c_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$() {
}
export { $h_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$ as $h_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$ };
$h_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$.prototype = $c_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$.prototype;
$c_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$.prototype.endToken__s_Option = (function() {
  return $m_s_None$();
});
$c_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$.prototype.tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer = (function(buffer, s) {
  if ((s === "")) {
    var elem = $m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$emptyStringToken;
    buffer.addOne__O__scm_ArrayBuffer(elem);
    return this;
  } else if ((!(!s.startsWith("//")))) {
    return $m_Lsttp_model_UriInterpolator$Tokenizer$Authority$().tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(buffer, s.substring(2));
  } else {
    var first = s.charCodeAt(0);
    if (this.Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$__f_AuthorityTerminators.contains__C__Z(first)) {
      matchResult37: {
        var \u03b42$___1;
        var \u03b42$___2;
        var x57 = $m_Lsttp_model_UriInterpolator$Tokenizer$().sttp$model$UriInterpolator$Tokenizer$$$separatorTokenizerAndToken__C__T2(first);
        if ((x57 !== null)) {
          var tokenizer = x57._1__O();
          var token = x57._2__O();
          var \u03b42$___1 = tokenizer;
          var \u03b42$___2 = token;
          break matchResult37;
        }
        throw new $c_s_MatchError(x57);
      }
      var tokenizer$2 = \u03b42$___1;
      var token$2 = \u03b42$___2;
      var x$2 = $m_Lsttp_model_UriInterpolator$PathStart$();
      if (((token$2 !== null) && token$2.equals__O__Z(x$2))) {
        var elem$1 = $m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$emptyStringToken;
        buffer.addOne__O__scm_ArrayBuffer(elem$1);
        var elem$2 = $m_Lsttp_model_UriInterpolator$SlashInPath$();
        buffer.addOne__O__scm_ArrayBuffer(elem$2);
      } else {
        buffer.addOne__O__scm_ArrayBuffer(token$2);
      }
      return tokenizer$2.tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(buffer, s.substring(1));
    } else {
      return $m_Lsttp_model_UriInterpolator$Tokenizer$Path$().tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(buffer, s);
    }
  }
});
var $d_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$, "sttp.model.UriInterpolator$Tokenizer$AfterScheme$", ({
  Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$: 1,
  Lsttp_model_UriInterpolator$Tokenizer: 1
}));
export { $d_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$ as $d_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$ };
var $n_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$;
function $m_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$() {
  if ((!$n_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$)) {
    $n_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$ = new $c_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$();
  }
  return $n_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$;
}
export { $m_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$ as $m_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$Tokenizer$Authority$() {
  this.Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_sttp$model$UriInterpolator$Tokenizer$Authority$$$HexChars = null;
  this.Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_terminators = null;
  this.Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_separators = null;
  this.Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_escapeSeparators = null;
  $n_Lsttp_model_UriInterpolator$Tokenizer$Authority$ = this;
  var this$3 = $m_sci_Set$();
  var this$2 = new $c_sr_RichChar(48);
  var elems = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$2, $bC(57));
  var this$7 = this$3.from__sc_IterableOnce__sci_Set(elems);
  var this$6 = $m_sci_Set$();
  var this$5 = new $c_sr_RichChar(97);
  var elems$1 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$5, $bC(102));
  var that = this$6.from__sc_IterableOnce__sci_Set(elems$1);
  var this$11 = this$7.concat__sc_IterableOnce__sc_SetOps(that);
  var this$10 = $m_sci_Set$();
  var this$9 = new $c_sr_RichChar(65);
  var elems$2 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$9, $bC(70));
  var that$1 = this$10.from__sc_IterableOnce__sci_Set(elems$2);
  var this$12 = this$11.concat__sc_IterableOnce__sc_SetOps(that$1);
  var set = this$12.incl__O__sci_SetOps($bC(58));
  this.Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_sttp$model$UriInterpolator$Tokenizer$Authority$$$HexChars = new $c_Lsttp_model_internal_FastCharSet(set);
  var this$14 = $m_sci_Set$();
  var elems$3 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([47, 63, 35])));
  var set$1 = this$14.from__sc_IterableOnce__sci_Set(elems$3);
  this.Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_terminators = new $c_Lsttp_model_internal_FastCharSet(set$1);
  var this$22 = $m_sci_Map$();
  var $x_3 = $m_sr_ScalaRunTime$();
  var y = $m_Lsttp_model_UriInterpolator$ColonInAuthority$();
  var $x_2 = $ct_T2__O__O__(new $c_T2(), $bC(58), y);
  var y$1 = $m_Lsttp_model_UriInterpolator$AtInAuthority$();
  var $x_1 = $ct_T2__O__O__(new $c_T2(), $bC(64), y$1);
  var y$2 = $m_Lsttp_model_UriInterpolator$DotInAuthority$();
  var elems$4 = $x_3.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_2, $x_1, $ct_T2__O__O__(new $c_T2(), $bC(46), y$2)]));
  var map = this$22.from__sc_IterableOnce__sci_Map(elems$4);
  this.Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_separators = new $c_Lsttp_model_internal_FastCharMap(map);
  var value = $ct_T2__O__O__(new $c_T2(), $bC(91), $bC(93));
  this.Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_escapeSeparators = new $c_s_Some(value);
}
export { $c_Lsttp_model_UriInterpolator$Tokenizer$Authority$ as $c_Lsttp_model_UriInterpolator$Tokenizer$Authority$ };
$c_Lsttp_model_UriInterpolator$Tokenizer$Authority$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$Tokenizer$Authority$.prototype.constructor = $c_Lsttp_model_UriInterpolator$Tokenizer$Authority$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$Tokenizer$Authority$() {
}
export { $h_Lsttp_model_UriInterpolator$Tokenizer$Authority$ as $h_Lsttp_model_UriInterpolator$Tokenizer$Authority$ };
$h_Lsttp_model_UriInterpolator$Tokenizer$Authority$.prototype = $c_Lsttp_model_UriInterpolator$Tokenizer$Authority$.prototype;
$c_Lsttp_model_UriInterpolator$Tokenizer$Authority$.prototype.sttp$model$UriInterpolator$Tokenizer$Authority$$$isIpV6Like__T__Z = (function(str) {
  var len = str.length;
  if (((len > 2) && (str.charCodeAt(0) === 91))) {
    var index = (((-1) + len) | 0);
    var $x_1 = (str.charCodeAt(index) === 93);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var end = (((-1) + len) | 0);
    var isEmpty = (end <= 1);
    var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
    var res = true;
    var it = new $c_sci_RangeIterator(1, 1, scala$collection$immutable$Range$$lastElement, isEmpty);
    while ((res && it.sci_RangeIterator__f__hasNext)) {
      var x0 = it.next__I();
      res = $m_Lsttp_model_UriInterpolator$Tokenizer$Authority$().Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_sttp$model$UriInterpolator$Tokenizer$Authority$$$HexChars.contains__C__Z(str.charCodeAt(x0));
    }
    return res;
  } else {
    return false;
  }
});
$c_Lsttp_model_UriInterpolator$Tokenizer$Authority$.prototype.tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer = (function(buffer, s) {
  var initSize = buffer.scm_ArrayBuffer__f_size0;
  var tokenizer = $m_Lsttp_model_UriInterpolator$Tokenizer$().sttp$model$UriInterpolator$Tokenizer$$$tokenizeTerminatedFragment__T__Lsttp_model_UriInterpolator$Tokenizer__scm_ArrayBuffer__Lsttp_model_internal_FastCharSet__Lsttp_model_internal_FastCharMap__s_Option__Lsttp_model_UriInterpolator$Tokenizer(s, this, buffer, this.Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_terminators, this.Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_separators, this.Lsttp_model_UriInterpolator$Tokenizer$Authority$__f_escapeSeparators);
  var end = buffer.scm_ArrayBuffer__f_size0;
  var isEmpty = (initSize >= end);
  var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
  if ((!isEmpty)) {
    var i = initSize;
    while (true) {
      var x0 = i;
      matchResult38: {
        var x60 = buffer.apply__I__O(x0);
        if ((x60 instanceof $c_Lsttp_model_UriInterpolator$StringToken)) {
          var x63 = x60.Lsttp_model_UriInterpolator$StringToken__f_s;
          if ($m_Lsttp_model_UriInterpolator$Tokenizer$Authority$().sttp$model$UriInterpolator$Tokenizer$Authority$$$isIpV6Like__T__Z(x63)) {
            var endIndex = (((-1) + x63.length) | 0);
            var s$1 = x63.substring(1, endIndex);
            buffer.update__I__O__V(x0, new $c_Lsttp_model_UriInterpolator$StringToken(s$1));
            break matchResult38;
          }
        }
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
  return tokenizer;
});
$c_Lsttp_model_UriInterpolator$Tokenizer$Authority$.prototype.endToken__s_Option = (function() {
  var value = $m_Lsttp_model_UriInterpolator$AuthorityEnd$();
  return new $c_s_Some(value);
});
var $d_Lsttp_model_UriInterpolator$Tokenizer$Authority$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$Tokenizer$Authority$, "sttp.model.UriInterpolator$Tokenizer$Authority$", ({
  Lsttp_model_UriInterpolator$Tokenizer$Authority$: 1,
  Lsttp_model_UriInterpolator$Tokenizer: 1
}));
export { $d_Lsttp_model_UriInterpolator$Tokenizer$Authority$ as $d_Lsttp_model_UriInterpolator$Tokenizer$Authority$ };
var $n_Lsttp_model_UriInterpolator$Tokenizer$Authority$;
function $m_Lsttp_model_UriInterpolator$Tokenizer$Authority$() {
  if ((!$n_Lsttp_model_UriInterpolator$Tokenizer$Authority$)) {
    $n_Lsttp_model_UriInterpolator$Tokenizer$Authority$ = new $c_Lsttp_model_UriInterpolator$Tokenizer$Authority$();
  }
  return $n_Lsttp_model_UriInterpolator$Tokenizer$Authority$;
}
export { $m_Lsttp_model_UriInterpolator$Tokenizer$Authority$ as $m_Lsttp_model_UriInterpolator$Tokenizer$Authority$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$Tokenizer$Fragment$() {
}
export { $c_Lsttp_model_UriInterpolator$Tokenizer$Fragment$ as $c_Lsttp_model_UriInterpolator$Tokenizer$Fragment$ };
$c_Lsttp_model_UriInterpolator$Tokenizer$Fragment$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$Tokenizer$Fragment$.prototype.constructor = $c_Lsttp_model_UriInterpolator$Tokenizer$Fragment$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$Tokenizer$Fragment$() {
}
export { $h_Lsttp_model_UriInterpolator$Tokenizer$Fragment$ as $h_Lsttp_model_UriInterpolator$Tokenizer$Fragment$ };
$h_Lsttp_model_UriInterpolator$Tokenizer$Fragment$.prototype = $c_Lsttp_model_UriInterpolator$Tokenizer$Fragment$.prototype;
$c_Lsttp_model_UriInterpolator$Tokenizer$Fragment$.prototype.endToken__s_Option = (function() {
  return $m_s_None$();
});
$c_Lsttp_model_UriInterpolator$Tokenizer$Fragment$.prototype.tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer = (function(buffer, s) {
  var elem = new $c_Lsttp_model_UriInterpolator$StringToken(s);
  buffer.addOne__O__scm_ArrayBuffer(elem);
  return this;
});
var $d_Lsttp_model_UriInterpolator$Tokenizer$Fragment$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$Tokenizer$Fragment$, "sttp.model.UriInterpolator$Tokenizer$Fragment$", ({
  Lsttp_model_UriInterpolator$Tokenizer$Fragment$: 1,
  Lsttp_model_UriInterpolator$Tokenizer: 1
}));
export { $d_Lsttp_model_UriInterpolator$Tokenizer$Fragment$ as $d_Lsttp_model_UriInterpolator$Tokenizer$Fragment$ };
var $n_Lsttp_model_UriInterpolator$Tokenizer$Fragment$;
function $m_Lsttp_model_UriInterpolator$Tokenizer$Fragment$() {
  if ((!$n_Lsttp_model_UriInterpolator$Tokenizer$Fragment$)) {
    $n_Lsttp_model_UriInterpolator$Tokenizer$Fragment$ = new $c_Lsttp_model_UriInterpolator$Tokenizer$Fragment$();
  }
  return $n_Lsttp_model_UriInterpolator$Tokenizer$Fragment$;
}
export { $m_Lsttp_model_UriInterpolator$Tokenizer$Fragment$ as $m_Lsttp_model_UriInterpolator$Tokenizer$Fragment$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$Tokenizer$Path$() {
  this.Lsttp_model_UriInterpolator$Tokenizer$Path$__f_terminators = null;
  this.Lsttp_model_UriInterpolator$Tokenizer$Path$__f_separators = null;
  $n_Lsttp_model_UriInterpolator$Tokenizer$Path$ = this;
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([63, 35])));
  var set = this$1.from__sc_IterableOnce__sci_Set(elems);
  this.Lsttp_model_UriInterpolator$Tokenizer$Path$__f_terminators = new $c_Lsttp_model_internal_FastCharSet(set);
  var this$5 = $m_sci_Map$();
  var $x_1 = $m_sr_ScalaRunTime$();
  var y = $m_Lsttp_model_UriInterpolator$SlashInPath$();
  var elems$1 = $x_1.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), $bC(47), y)]));
  var map = this$5.from__sc_IterableOnce__sci_Map(elems$1);
  this.Lsttp_model_UriInterpolator$Tokenizer$Path$__f_separators = new $c_Lsttp_model_internal_FastCharMap(map);
}
export { $c_Lsttp_model_UriInterpolator$Tokenizer$Path$ as $c_Lsttp_model_UriInterpolator$Tokenizer$Path$ };
$c_Lsttp_model_UriInterpolator$Tokenizer$Path$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$Tokenizer$Path$.prototype.constructor = $c_Lsttp_model_UriInterpolator$Tokenizer$Path$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$Tokenizer$Path$() {
}
export { $h_Lsttp_model_UriInterpolator$Tokenizer$Path$ as $h_Lsttp_model_UriInterpolator$Tokenizer$Path$ };
$h_Lsttp_model_UriInterpolator$Tokenizer$Path$.prototype = $c_Lsttp_model_UriInterpolator$Tokenizer$Path$.prototype;
$c_Lsttp_model_UriInterpolator$Tokenizer$Path$.prototype.endToken__s_Option = (function() {
  return $m_s_None$();
});
$c_Lsttp_model_UriInterpolator$Tokenizer$Path$.prototype.tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer = (function(buffer, s) {
  return $m_Lsttp_model_UriInterpolator$Tokenizer$().sttp$model$UriInterpolator$Tokenizer$$$tokenizeTerminatedFragment__T__Lsttp_model_UriInterpolator$Tokenizer__scm_ArrayBuffer__Lsttp_model_internal_FastCharSet__Lsttp_model_internal_FastCharMap__s_Option__Lsttp_model_UriInterpolator$Tokenizer(s, this, buffer, this.Lsttp_model_UriInterpolator$Tokenizer$Path$__f_terminators, this.Lsttp_model_UriInterpolator$Tokenizer$Path$__f_separators, $m_s_None$());
});
var $d_Lsttp_model_UriInterpolator$Tokenizer$Path$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$Tokenizer$Path$, "sttp.model.UriInterpolator$Tokenizer$Path$", ({
  Lsttp_model_UriInterpolator$Tokenizer$Path$: 1,
  Lsttp_model_UriInterpolator$Tokenizer: 1
}));
export { $d_Lsttp_model_UriInterpolator$Tokenizer$Path$ as $d_Lsttp_model_UriInterpolator$Tokenizer$Path$ };
var $n_Lsttp_model_UriInterpolator$Tokenizer$Path$;
function $m_Lsttp_model_UriInterpolator$Tokenizer$Path$() {
  if ((!$n_Lsttp_model_UriInterpolator$Tokenizer$Path$)) {
    $n_Lsttp_model_UriInterpolator$Tokenizer$Path$ = new $c_Lsttp_model_UriInterpolator$Tokenizer$Path$();
  }
  return $n_Lsttp_model_UriInterpolator$Tokenizer$Path$;
}
export { $m_Lsttp_model_UriInterpolator$Tokenizer$Path$ as $m_Lsttp_model_UriInterpolator$Tokenizer$Path$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$Tokenizer$Query$() {
  this.Lsttp_model_UriInterpolator$Tokenizer$Query$__f_terminators = null;
  this.Lsttp_model_UriInterpolator$Tokenizer$Query$__f_separators = null;
  $n_Lsttp_model_UriInterpolator$Tokenizer$Query$ = this;
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([35])));
  var set = this$1.from__sc_IterableOnce__sci_Set(elems);
  this.Lsttp_model_UriInterpolator$Tokenizer$Query$__f_terminators = new $c_Lsttp_model_internal_FastCharSet(set);
  var this$7 = $m_sci_Map$();
  var $x_2 = $m_sr_ScalaRunTime$();
  var y = $m_Lsttp_model_UriInterpolator$AmpInQuery$();
  var $x_1 = $ct_T2__O__O__(new $c_T2(), $bC(38), y);
  var y$1 = $m_Lsttp_model_UriInterpolator$EqInQuery$();
  var elems$1 = $x_2.wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$x_1, $ct_T2__O__O__(new $c_T2(), $bC(61), y$1)]));
  var map = this$7.from__sc_IterableOnce__sci_Map(elems$1);
  this.Lsttp_model_UriInterpolator$Tokenizer$Query$__f_separators = new $c_Lsttp_model_internal_FastCharMap(map);
}
export { $c_Lsttp_model_UriInterpolator$Tokenizer$Query$ as $c_Lsttp_model_UriInterpolator$Tokenizer$Query$ };
$c_Lsttp_model_UriInterpolator$Tokenizer$Query$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$Tokenizer$Query$.prototype.constructor = $c_Lsttp_model_UriInterpolator$Tokenizer$Query$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$Tokenizer$Query$() {
}
export { $h_Lsttp_model_UriInterpolator$Tokenizer$Query$ as $h_Lsttp_model_UriInterpolator$Tokenizer$Query$ };
$h_Lsttp_model_UriInterpolator$Tokenizer$Query$.prototype = $c_Lsttp_model_UriInterpolator$Tokenizer$Query$.prototype;
$c_Lsttp_model_UriInterpolator$Tokenizer$Query$.prototype.endToken__s_Option = (function() {
  return $m_s_None$();
});
$c_Lsttp_model_UriInterpolator$Tokenizer$Query$.prototype.tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer = (function(buffer, s) {
  return $m_Lsttp_model_UriInterpolator$Tokenizer$().sttp$model$UriInterpolator$Tokenizer$$$tokenizeTerminatedFragment__T__Lsttp_model_UriInterpolator$Tokenizer__scm_ArrayBuffer__Lsttp_model_internal_FastCharSet__Lsttp_model_internal_FastCharMap__s_Option__Lsttp_model_UriInterpolator$Tokenizer(s, this, buffer, this.Lsttp_model_UriInterpolator$Tokenizer$Query$__f_terminators, this.Lsttp_model_UriInterpolator$Tokenizer$Query$__f_separators, $m_s_None$());
});
var $d_Lsttp_model_UriInterpolator$Tokenizer$Query$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$Tokenizer$Query$, "sttp.model.UriInterpolator$Tokenizer$Query$", ({
  Lsttp_model_UriInterpolator$Tokenizer$Query$: 1,
  Lsttp_model_UriInterpolator$Tokenizer: 1
}));
export { $d_Lsttp_model_UriInterpolator$Tokenizer$Query$ as $d_Lsttp_model_UriInterpolator$Tokenizer$Query$ };
var $n_Lsttp_model_UriInterpolator$Tokenizer$Query$;
function $m_Lsttp_model_UriInterpolator$Tokenizer$Query$() {
  if ((!$n_Lsttp_model_UriInterpolator$Tokenizer$Query$)) {
    $n_Lsttp_model_UriInterpolator$Tokenizer$Query$ = new $c_Lsttp_model_UriInterpolator$Tokenizer$Query$();
  }
  return $n_Lsttp_model_UriInterpolator$Tokenizer$Query$;
}
export { $m_Lsttp_model_UriInterpolator$Tokenizer$Query$ as $m_Lsttp_model_UriInterpolator$Tokenizer$Query$ };
function $p_Lsttp_model_UriInterpolator$Tokenizer$Scheme$__findPrefix__T__s_Option($thiz, s) {
  var len = s.length;
  if (((len === 0) || (!$thiz.Lsttp_model_UriInterpolator$Tokenizer$Scheme$__f_firstChar.contains__C__Z(s.charCodeAt(0))))) {
    return $m_s_None$();
  } else {
    var i = 1;
    while (true) {
      if ((i < len)) {
        var $x_2 = $thiz.Lsttp_model_UriInterpolator$Tokenizer$Scheme$__f_nonFirstChars;
        var index = i;
        var $x_1 = $x_2.contains__C__Z(s.charCodeAt(index));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        i = ((1 + i) | 0);
      } else {
        break;
      }
    }
    var endIndex = i;
    var value = s.substring(0, endIndex);
    return new $c_s_Some(value);
  }
}
export { $p_Lsttp_model_UriInterpolator$Tokenizer$Scheme$__findPrefix__T__s_Option as $p_Lsttp_model_UriInterpolator$Tokenizer$Scheme$__findPrefix__T__s_Option };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$Tokenizer$Scheme$() {
  this.Lsttp_model_UriInterpolator$Tokenizer$Scheme$__f_firstChar = null;
  this.Lsttp_model_UriInterpolator$Tokenizer$Scheme$__f_nonFirstChars = null;
  $n_Lsttp_model_UriInterpolator$Tokenizer$Scheme$ = this;
  var this$3 = $m_sci_Set$();
  var this$2 = new $c_sr_RichChar(97);
  var elems = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$2, $bC(122));
  var this$7 = this$3.from__sc_IterableOnce__sci_Set(elems);
  var this$6 = $m_sci_Set$();
  var this$5 = new $c_sr_RichChar(65);
  var elems$1 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$5, $bC(90));
  var that = this$6.from__sc_IterableOnce__sci_Set(elems$1);
  var alphabet = this$7.concat__sc_IterableOnce__sc_SetOps(that);
  this.Lsttp_model_UriInterpolator$Tokenizer$Scheme$__f_firstChar = new $c_Lsttp_model_internal_FastCharSet(alphabet);
  var this$11 = $m_sci_Set$();
  var this$10 = new $c_sr_RichChar(48);
  var elems$2 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$10, $bC(57));
  var that$1 = this$11.from__sc_IterableOnce__sci_Set(elems$2);
  var this$13 = alphabet.concat__sc_IterableOnce__sc_SetOps(that$1);
  var this$12 = $m_sci_Set$();
  var elems$3 = $m_sr_ScalaRunTime$().wrapCharArray__AC__sci_ArraySeq(new $ac_C(new Uint16Array([43, 46, 45])));
  var that$2 = this$12.from__sc_IterableOnce__sci_Set(elems$3);
  var set = this$13.concat__sc_IterableOnce__sc_SetOps(that$2);
  this.Lsttp_model_UriInterpolator$Tokenizer$Scheme$__f_nonFirstChars = new $c_Lsttp_model_internal_FastCharSet(set);
}
export { $c_Lsttp_model_UriInterpolator$Tokenizer$Scheme$ as $c_Lsttp_model_UriInterpolator$Tokenizer$Scheme$ };
$c_Lsttp_model_UriInterpolator$Tokenizer$Scheme$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$Tokenizer$Scheme$.prototype.constructor = $c_Lsttp_model_UriInterpolator$Tokenizer$Scheme$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$Tokenizer$Scheme$() {
}
export { $h_Lsttp_model_UriInterpolator$Tokenizer$Scheme$ as $h_Lsttp_model_UriInterpolator$Tokenizer$Scheme$ };
$h_Lsttp_model_UriInterpolator$Tokenizer$Scheme$.prototype = $c_Lsttp_model_UriInterpolator$Tokenizer$Scheme$.prototype;
$c_Lsttp_model_UriInterpolator$Tokenizer$Scheme$.prototype.tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer = (function(buffer, s) {
  var x52 = $p_Lsttp_model_UriInterpolator$Tokenizer$Scheme$__findPrefix__T__s_Option(this, s);
  if ((x52 instanceof $c_s_Some)) {
    var scheme = x52.s_Some__f_value;
    if ((scheme.length === s.length)) {
      return $m_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$().tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(buffer, scheme);
    }
  }
  if ((s === "")) {
    var elem = $m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$emptyStringToken;
    buffer.addOne__O__scm_ArrayBuffer(elem);
    return this;
  }
  if ((x52 instanceof $c_s_Some)) {
    var scheme$2 = x52.s_Some__f_value;
    var i = scheme$2.length;
    if ((s.charCodeAt(i) === 58)) {
      var beginIndex = ((1 + scheme$2.length) | 0);
      var rest = s.substring(beginIndex);
      var elem$1 = new $c_Lsttp_model_UriInterpolator$StringToken(scheme$2);
      buffer.addOne__O__scm_ArrayBuffer(elem$1);
      var elem$2 = $m_Lsttp_model_UriInterpolator$SchemeEnd$();
      buffer.addOne__O__scm_ArrayBuffer(elem$2);
      return $m_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$().tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(buffer, rest);
    }
  }
  if ((!(!s.startsWith(":")))) {
    var elem$3 = $m_Lsttp_model_UriInterpolator$SchemeEnd$();
    buffer.addOne__O__scm_ArrayBuffer(elem$3);
    return $m_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$().tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(buffer, s.substring(1));
  }
  return $m_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$().tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(buffer, s);
});
$c_Lsttp_model_UriInterpolator$Tokenizer$Scheme$.prototype.endToken__s_Option = (function() {
  var value = $m_Lsttp_model_UriInterpolator$SchemeEnd$();
  return new $c_s_Some(value);
});
var $d_Lsttp_model_UriInterpolator$Tokenizer$Scheme$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$Tokenizer$Scheme$, "sttp.model.UriInterpolator$Tokenizer$Scheme$", ({
  Lsttp_model_UriInterpolator$Tokenizer$Scheme$: 1,
  Lsttp_model_UriInterpolator$Tokenizer: 1
}));
export { $d_Lsttp_model_UriInterpolator$Tokenizer$Scheme$ as $d_Lsttp_model_UriInterpolator$Tokenizer$Scheme$ };
var $n_Lsttp_model_UriInterpolator$Tokenizer$Scheme$;
function $m_Lsttp_model_UriInterpolator$Tokenizer$Scheme$() {
  if ((!$n_Lsttp_model_UriInterpolator$Tokenizer$Scheme$)) {
    $n_Lsttp_model_UriInterpolator$Tokenizer$Scheme$ = new $c_Lsttp_model_UriInterpolator$Tokenizer$Scheme$();
  }
  return $n_Lsttp_model_UriInterpolator$Tokenizer$Scheme$;
}
export { $m_Lsttp_model_UriInterpolator$Tokenizer$Scheme$ as $m_Lsttp_model_UriInterpolator$Tokenizer$Scheme$ };
/** @constructor */
function $c_Lsttp_tapir_Codec$$anon$1(mapping$2, outer) {
  this.Lsttp_tapir_Codec$$anon$1__f_mapping$1 = null;
  this.Lsttp_tapir_Codec$$anon$1__f_$outer = null;
  this.Lsttp_tapir_Codec$$anon$1__f_mapping$1 = mapping$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lsttp_tapir_Codec$$anon$1__f_$outer = outer;
}
export { $c_Lsttp_tapir_Codec$$anon$1 as $c_Lsttp_tapir_Codec$$anon$1 };
$c_Lsttp_tapir_Codec$$anon$1.prototype = new $h_O();
$c_Lsttp_tapir_Codec$$anon$1.prototype.constructor = $c_Lsttp_tapir_Codec$$anon$1;
/** @constructor */
function $h_Lsttp_tapir_Codec$$anon$1() {
}
export { $h_Lsttp_tapir_Codec$$anon$1 as $h_Lsttp_tapir_Codec$$anon$1 };
$h_Lsttp_tapir_Codec$$anon$1.prototype = $c_Lsttp_tapir_Codec$$anon$1.prototype;
$c_Lsttp_tapir_Codec$$anon$1.prototype.rawDecode__O__Lsttp_tapir_DecodeResult = (function(l) {
  return this.Lsttp_tapir_Codec$$anon$1__f_$outer.rawDecode__O__Lsttp_tapir_DecodeResult(l).flatMap__F1__Lsttp_tapir_DecodeResult(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((l$2) => this.Lsttp_tapir_Codec$$anon$1__f_mapping$1.rawDecode__O__Lsttp_tapir_DecodeResult(l$2))));
});
$c_Lsttp_tapir_Codec$$anon$1.prototype.encode__O__O = (function(hh) {
  return this.Lsttp_tapir_Codec$$anon$1__f_$outer.encode__O__O(this.Lsttp_tapir_Codec$$anon$1__f_mapping$1.encode__O__O(hh));
});
$c_Lsttp_tapir_Codec$$anon$1.prototype.schema__Lsttp_tapir_Schema = (function() {
  var this$1 = this.Lsttp_tapir_Codec$$anon$1__f_$outer.schema__Lsttp_tapir_Schema();
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((h) => this.Lsttp_tapir_Codec$$anon$1__f_mapping$1.encode__O__O(h)));
  var schemaType$1 = this$1.Lsttp_tapir_Schema__f_schemaType.contramap__F1__Lsttp_tapir_SchemaType(g);
  var this$3 = this$1.Lsttp_tapir_Schema__f_default;
  if (this$3.isEmpty__Z()) {
    var default$1 = $m_s_None$();
  } else {
    var x0 = this$3.get__O();
    matchResult4: {
      var default$1;
      if ((x0 !== null)) {
        var t = x0._1__O();
        var raw = x0._2__O();
        matchResult2: {
          var this$6;
          var x10 = $f_Lsttp_tapir_Mapping__decode__O__Lsttp_tapir_DecodeResult(this.Lsttp_tapir_Codec$$anon$1__f_mapping$1, t);
          if ($is_Lsttp_tapir_DecodeResult$Failure(x10)) {
            var this$6 = $m_s_None$();
            break matchResult2;
          }
          if ((x10 instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
            var x13 = x10.Lsttp_tapir_DecodeResult$Value__f_v;
            var this$6 = new $c_s_Some(x13);
            break matchResult2;
          }
          throw new $c_s_MatchError(x10);
        }
        if (this$6.isEmpty__Z()) {
          var default$1 = $m_s_None$();
          break matchResult4;
        } else {
          var x0$1 = this$6.get__O();
          var default$1 = new $c_s_Some($ct_T2__O__O__(new $c_T2(), x0$1, raw));
          break matchResult4;
        }
      }
      throw new $c_s_MatchError(x0);
    }
  }
  var validator$1 = this$1.Lsttp_tapir_Schema__f_validator.contramap__F1__Lsttp_tapir_Validator(g);
  var name$1 = this$1.Lsttp_tapir_Schema__f_name;
  var isOptional$1 = this$1.Lsttp_tapir_Schema__f_isOptional;
  var description$1 = this$1.Lsttp_tapir_Schema__f_description;
  var format$1 = this$1.Lsttp_tapir_Schema__f_format;
  var encodedExample$1 = this$1.Lsttp_tapir_Schema__f_encodedExample;
  var deprecated$1 = this$1.Lsttp_tapir_Schema__f_deprecated;
  var hidden$1 = this$1.Lsttp_tapir_Schema__f_hidden;
  var attributes$1 = this$1.Lsttp_tapir_Schema__f_attributes;
  return new $c_Lsttp_tapir_Schema(schemaType$1, name$1, isOptional$1, description$1, default$1, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1).validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(this.Lsttp_tapir_Codec$$anon$1__f_mapping$1.validator__Lsttp_tapir_Validator());
});
$c_Lsttp_tapir_Codec$$anon$1.prototype.format__Lsttp_tapir_CodecFormat = (function() {
  return this.Lsttp_tapir_Codec$$anon$1__f_$outer.format__Lsttp_tapir_CodecFormat();
});
var $d_Lsttp_tapir_Codec$$anon$1 = new $TypeData().initClass($c_Lsttp_tapir_Codec$$anon$1, "sttp.tapir.Codec$$anon$1", ({
  Lsttp_tapir_Codec$$anon$1: 1,
  Lsttp_tapir_Codec: 1
}));
export { $d_Lsttp_tapir_Codec$$anon$1 as $d_Lsttp_tapir_Codec$$anon$1 };
/** @constructor */
function $c_Lsttp_tapir_Codec$$anon$2(s2$2, outer) {
  this.Lsttp_tapir_Codec$$anon$2__f_s2$1 = null;
  this.Lsttp_tapir_Codec$$anon$2__f_$outer = null;
  this.Lsttp_tapir_Codec$$anon$2__f_s2$1 = s2$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lsttp_tapir_Codec$$anon$2__f_$outer = outer;
}
export { $c_Lsttp_tapir_Codec$$anon$2 as $c_Lsttp_tapir_Codec$$anon$2 };
$c_Lsttp_tapir_Codec$$anon$2.prototype = new $h_O();
$c_Lsttp_tapir_Codec$$anon$2.prototype.constructor = $c_Lsttp_tapir_Codec$$anon$2;
/** @constructor */
function $h_Lsttp_tapir_Codec$$anon$2() {
}
export { $h_Lsttp_tapir_Codec$$anon$2 as $h_Lsttp_tapir_Codec$$anon$2 };
$h_Lsttp_tapir_Codec$$anon$2.prototype = $c_Lsttp_tapir_Codec$$anon$2.prototype;
$c_Lsttp_tapir_Codec$$anon$2.prototype.rawDecode__O__Lsttp_tapir_DecodeResult = (function(l) {
  return $f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(this.Lsttp_tapir_Codec$$anon$2__f_$outer, l);
});
$c_Lsttp_tapir_Codec$$anon$2.prototype.encode__O__O = (function(h) {
  return this.Lsttp_tapir_Codec$$anon$2__f_$outer.encode__O__O(h);
});
$c_Lsttp_tapir_Codec$$anon$2.prototype.schema__Lsttp_tapir_Schema = (function() {
  return this.Lsttp_tapir_Codec$$anon$2__f_s2$1;
});
$c_Lsttp_tapir_Codec$$anon$2.prototype.format__Lsttp_tapir_CodecFormat = (function() {
  return this.Lsttp_tapir_Codec$$anon$2__f_$outer.format__Lsttp_tapir_CodecFormat();
});
var $d_Lsttp_tapir_Codec$$anon$2 = new $TypeData().initClass($c_Lsttp_tapir_Codec$$anon$2, "sttp.tapir.Codec$$anon$2", ({
  Lsttp_tapir_Codec$$anon$2: 1,
  Lsttp_tapir_Codec: 1
}));
export { $d_Lsttp_tapir_Codec$$anon$2 as $d_Lsttp_tapir_Codec$$anon$2 };
/** @constructor */
function $c_Lsttp_tapir_Codec$$anon$3(f$6, outer) {
  this.Lsttp_tapir_Codec$$anon$3__f_f$3 = null;
  this.Lsttp_tapir_Codec$$anon$3__f_$outer = null;
  this.Lsttp_tapir_Codec$$anon$3__f_f$3 = f$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lsttp_tapir_Codec$$anon$3__f_$outer = outer;
}
export { $c_Lsttp_tapir_Codec$$anon$3 as $c_Lsttp_tapir_Codec$$anon$3 };
$c_Lsttp_tapir_Codec$$anon$3.prototype = new $h_O();
$c_Lsttp_tapir_Codec$$anon$3.prototype.constructor = $c_Lsttp_tapir_Codec$$anon$3;
/** @constructor */
function $h_Lsttp_tapir_Codec$$anon$3() {
}
export { $h_Lsttp_tapir_Codec$$anon$3 as $h_Lsttp_tapir_Codec$$anon$3 };
$h_Lsttp_tapir_Codec$$anon$3.prototype = $c_Lsttp_tapir_Codec$$anon$3.prototype;
$c_Lsttp_tapir_Codec$$anon$3.prototype.rawDecode__O__Lsttp_tapir_DecodeResult = (function(l) {
  return $f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(this.Lsttp_tapir_Codec$$anon$3__f_$outer, l);
});
$c_Lsttp_tapir_Codec$$anon$3.prototype.encode__O__O = (function(h) {
  return this.Lsttp_tapir_Codec$$anon$3__f_$outer.encode__O__O(h);
});
$c_Lsttp_tapir_Codec$$anon$3.prototype.schema__Lsttp_tapir_Schema = (function() {
  return this.Lsttp_tapir_Codec$$anon$3__f_$outer.schema__Lsttp_tapir_Schema();
});
$c_Lsttp_tapir_Codec$$anon$3.prototype.format__Lsttp_tapir_CodecFormat = (function() {
  return this.Lsttp_tapir_Codec$$anon$3__f_f$3;
});
var $d_Lsttp_tapir_Codec$$anon$3 = new $TypeData().initClass($c_Lsttp_tapir_Codec$$anon$3, "sttp.tapir.Codec$$anon$3", ({
  Lsttp_tapir_Codec$$anon$3: 1,
  Lsttp_tapir_Codec: 1
}));
export { $d_Lsttp_tapir_Codec$$anon$3 as $d_Lsttp_tapir_Codec$$anon$3 };
/** @constructor */
function $c_Lsttp_tapir_Codec$$anon$4(s$2, f$7) {
  this.Lsttp_tapir_Codec$$anon$4__f_s$1 = null;
  this.Lsttp_tapir_Codec$$anon$4__f_f$4 = null;
  this.Lsttp_tapir_Codec$$anon$4__f_s$1 = s$2;
  this.Lsttp_tapir_Codec$$anon$4__f_f$4 = f$7;
}
export { $c_Lsttp_tapir_Codec$$anon$4 as $c_Lsttp_tapir_Codec$$anon$4 };
$c_Lsttp_tapir_Codec$$anon$4.prototype = new $h_O();
$c_Lsttp_tapir_Codec$$anon$4.prototype.constructor = $c_Lsttp_tapir_Codec$$anon$4;
/** @constructor */
function $h_Lsttp_tapir_Codec$$anon$4() {
}
export { $h_Lsttp_tapir_Codec$$anon$4 as $h_Lsttp_tapir_Codec$$anon$4 };
$h_Lsttp_tapir_Codec$$anon$4.prototype = $c_Lsttp_tapir_Codec$$anon$4.prototype;
$c_Lsttp_tapir_Codec$$anon$4.prototype.rawDecode__O__Lsttp_tapir_DecodeResult = (function(l) {
  return new $c_Lsttp_tapir_DecodeResult$Value(l);
});
$c_Lsttp_tapir_Codec$$anon$4.prototype.encode__O__O = (function(h) {
  return h;
});
$c_Lsttp_tapir_Codec$$anon$4.prototype.schema__Lsttp_tapir_Schema = (function() {
  return this.Lsttp_tapir_Codec$$anon$4__f_s$1;
});
$c_Lsttp_tapir_Codec$$anon$4.prototype.format__Lsttp_tapir_CodecFormat = (function() {
  return this.Lsttp_tapir_Codec$$anon$4__f_f$4;
});
var $d_Lsttp_tapir_Codec$$anon$4 = new $TypeData().initClass($c_Lsttp_tapir_Codec$$anon$4, "sttp.tapir.Codec$$anon$4", ({
  Lsttp_tapir_Codec$$anon$4: 1,
  Lsttp_tapir_Codec: 1
}));
export { $d_Lsttp_tapir_Codec$$anon$4 as $d_Lsttp_tapir_Codec$$anon$4 };
function $p_Lsttp_tapir_Codec$$anon$5__partCodec__T__s_Option($thiz, name) {
  var this$1 = $thiz.Lsttp_tapir_Codec$$anon$5__f_partCodecs$1.get__O__s_Option(name);
  return (this$1.isEmpty__Z() ? $thiz.Lsttp_tapir_Codec$$anon$5__f_defaultCodec$1 : this$1);
}
export { $p_Lsttp_tapir_Codec$$anon$5__partCodec__T__s_Option as $p_Lsttp_tapir_Codec$$anon$5__partCodec__T__s_Option };
/** @constructor */
function $c_Lsttp_tapir_Codec$$anon$5(partCodecs$2, defaultCodec$2) {
  this.Lsttp_tapir_Codec$$anon$5__f_partCodecs$1 = null;
  this.Lsttp_tapir_Codec$$anon$5__f_defaultCodec$1 = null;
  this.Lsttp_tapir_Codec$$anon$5__f_partCodecs$1 = partCodecs$2;
  this.Lsttp_tapir_Codec$$anon$5__f_defaultCodec$1 = defaultCodec$2;
}
export { $c_Lsttp_tapir_Codec$$anon$5 as $c_Lsttp_tapir_Codec$$anon$5 };
$c_Lsttp_tapir_Codec$$anon$5.prototype = new $h_O();
$c_Lsttp_tapir_Codec$$anon$5.prototype.constructor = $c_Lsttp_tapir_Codec$$anon$5;
/** @constructor */
function $h_Lsttp_tapir_Codec$$anon$5() {
}
export { $h_Lsttp_tapir_Codec$$anon$5 as $h_Lsttp_tapir_Codec$$anon$5 };
$h_Lsttp_tapir_Codec$$anon$5.prototype = $c_Lsttp_tapir_Codec$$anon$5.prototype;
$c_Lsttp_tapir_Codec$$anon$5.prototype.encode__sci_ListMap__sci_Seq = (function(t) {
  var this$2 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(t);
  var rest = this$2;
  var h = null;
  var t$1 = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.head__O();
    matchResult6: {
      var $x_1;
      if ((x0 !== null)) {
        var name = x0._1__O();
        var body = x0._2__O();
        var this$3 = $p_Lsttp_tapir_Codec$$anon$5__partCodec__T__s_Option(this, name).toList__sci_List();
        var rest$1 = this$3;
        var h$1 = null;
        var t$2 = null;
        while ((rest$1 !== $m_sci_Nil$())) {
          var x0$1 = rest$1.head__O();
          matchResult5: {
            var $x_2;
            if ((x0$1 !== null)) {
              var x21 = x0$1.Lsttp_tapir_PartCodec__f_rawBodyType;
              var x22 = x0$1.Lsttp_tapir_PartCodec__f_codec;
              var partList = x22.encode__O__O(body);
              var f = ((name, x21, x22) => ((part) => {
                var $x_3 = $m_Lsttp_tapir_Codec$();
                var body$1 = part.Lsttp_model_Part__f_body;
                var otherDispositionParams = part.Lsttp_model_Part__f_otherDispositionParams;
                var headers = part.Lsttp_model_Part__f_headers;
                var partWithContentType = $p_Lsttp_tapir_Codec$__withContentType__Lsttp_model_Part__Lsttp_tapir_RawBodyType__Lsttp_model_MediaType__Lsttp_model_Part($x_3, new $c_Lsttp_model_Part(name, body$1, otherDispositionParams, headers), x21, x22.format__Lsttp_tapir_CodecFormat().mediaType__Lsttp_model_MediaType());
                if ((!part.Lsttp_model_Part__f_otherDispositionParams.contains__O__Z("filename"))) {
                  matchResult4: {
                    var this$6;
                    var x16 = part.Lsttp_model_Part__f_body;
                    if ((x16 instanceof $c_Lsttp_tapir_FileRange)) {
                      var value = $m_Lsttp_tapir_TapirFile$().name__Lorg_scalajs_dom_File__T(x16.Lsttp_tapir_FileRange__f_file);
                      var this$6 = new $c_s_Some(value);
                      break matchResult4;
                    }
                    var this$6 = $m_s_None$();
                  }
                  if (this$6.isEmpty__Z()) {
                    var this$7 = $m_s_None$();
                  } else {
                    var x0$2 = this$6.get__O();
                    var this$7 = new $c_s_Some(partWithContentType.dispositionParam__T__T__Lsttp_model_Part("filename", x0$2));
                  }
                  return (this$7.isEmpty__Z() ? partWithContentType : this$7.get__O());
                } else {
                  return partWithContentType;
                }
              }))(name, x21, x22);
              if ((partList === $m_sci_Nil$())) {
                var $x_2 = $m_sci_Nil$();
                break matchResult5;
              } else {
                var x0$3 = partList.head__O();
                var h$2 = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
                var t$3 = h$2;
                var rest$2 = partList.tail__O();
                while ((rest$2 !== $m_sci_Nil$())) {
                  var x0$4 = rest$2.head__O();
                  var nx = new $c_sci_$colon$colon(f(x0$4), $m_sci_Nil$());
                  t$3.sci_$colon$colon__f_next = nx;
                  t$3 = nx;
                  rest$2 = rest$2.tail__O();
                }
                var $x_2 = h$2;
                break matchResult5;
              }
            }
            throw new $c_s_MatchError(x0$1);
          }
          var it = $x_2.iterator__sc_Iterator();
          while (it.hasNext__Z()) {
            var nx$1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
            if ((t$2 === null)) {
              h$1 = nx$1;
            } else {
              t$2.sci_$colon$colon__f_next = nx$1;
            }
            t$2 = nx$1;
          }
          rest$1 = rest$1.tail__O();
        }
        var $x_1 = ((h$1 === null) ? $m_sci_Nil$() : h$1);
        break matchResult6;
      }
      throw new $c_s_MatchError(x0);
    }
    var it$1 = $x_1.iterator__sc_Iterator();
    while (it$1.hasNext__Z()) {
      var nx$2 = new $c_sci_$colon$colon(it$1.next__O(), $m_sci_Nil$());
      if ((t$1 === null)) {
        h = nx$2;
      } else {
        t$1.sci_$colon$colon__f_next = nx$2;
      }
      t$1 = nx$2;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $m_sci_Nil$() : h);
});
$c_Lsttp_tapir_Codec$$anon$5.prototype.rawDecode__sci_Seq__Lsttp_tapir_DecodeResult = (function(l) {
  var m = $m_scm_Map$().empty__O();
  var it = l.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var key = elem.Lsttp_model_Part__f_name;
    var bldr = m.getOrElseUpdate__O__F0__O(key, new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((this$1) => (() => this$1.newSpecificBuilder__scm_Builder()))(l)));
    bldr.addOne__O__scm_Growable(elem);
  }
  var this$2 = $m_sci_HashMap$();
  var result = this$2.sci_HashMap$__f_EmptyMap;
  var mapIt = m.iterator__sc_Iterator();
  while (mapIt.hasNext__Z()) {
    var x1 = mapIt.next__O();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1._1__O();
    var v = x1._2__O();
    result = result.updated__O__O__sci_HashMap(k, v.result__O());
  }
  var rawPartsByName = result;
  var this$3 = this.Lsttp_tapir_Codec$$anon$5__f_defaultCodec$1;
  if ((!this$3.isEmpty__Z())) {
    var inputPartNamesToDecode = l.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$34) => _$34.Lsttp_model_Part__f_name)));
  } else {
    var inputPartNamesToDecode = l.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$35) => _$35.Lsttp_model_Part__f_name))).filter__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$36) => {
      var this$5 = this.Lsttp_tapir_Codec$$anon$5__f_partCodecs$1.keys__sc_Iterable();
      return $m_sci_Set$().from__sc_IterableOnce__sci_Set(this$5).contains__O__Z(_$36);
    })));
  }
  var suffix = this.Lsttp_tapir_Codec$$anon$5__f_partCodecs$1.keys__sc_Iterable();
  var this$6 = inputPartNamesToDecode.appendedAll__sc_IterableOnce__O(suffix).toList__sci_List();
  var partNamesToDecode = $f_sc_SeqOps__distinct__O(this$6);
  var f = ((name) => {
    var codec = $p_Lsttp_tapir_Codec$$anon$5__partCodec__T__s_Option(this, name).get__O().Lsttp_tapir_PartCodec__f_codec;
    var this$9 = rawPartsByName.get__O__s_Option(name).toList__sci_List();
    var this$8 = $m_s_$less$colon$less$();
    var toIterableOnce = this$8.s_$less$colon$less$__f_singleton;
    var rawParts = $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this$9, toIterableOnce);
    var y = codec.rawDecode__O__Lsttp_tapir_DecodeResult(rawParts);
    return $ct_T2__O__O__(new $c_T2(), name, y);
  });
  if ((partNamesToDecode === $m_sci_Nil$())) {
    var anyParts = $m_sci_Nil$();
  } else {
    var x0 = partNamesToDecode.head__O();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = partNamesToDecode.tail__O();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    var anyParts = h;
  }
  var partFailures = anyParts.collect__s_PartialFunction__sci_List(new $c_Lsttp_tapir_Codec$$anon$6());
  if ((!partFailures.isEmpty__Z())) {
    var error = new $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException(partFailures);
    var $x_1 = new $c_Lsttp_tapir_DecodeResult$Error("", error);
  } else {
    var xs = anyParts.collect__s_PartialFunction__sci_List(new $c_Lsttp_tapir_Codec$$anon$7());
    var $x_2 = new $c_Lsttp_tapir_internal_package$IterableToListMap(xs);
    var this$15 = $m_s_$less$colon$less$();
    var v$1 = $x_2.toListMap__s_$less$colon$less__sci_ListMap(this$15.s_$less$colon$less$__f_singleton);
    var $x_1 = new $c_Lsttp_tapir_DecodeResult$Value(v$1);
  }
  return $x_1;
});
$c_Lsttp_tapir_Codec$$anon$5.prototype.schema__Lsttp_tapir_Schema = (function() {
  $m_Lsttp_tapir_Schema$();
  $m_Lsttp_tapir_Schema$();
  var schemaType = new $c_Lsttp_tapir_SchemaType$SBinary();
  $m_Lsttp_tapir_Schema$();
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  return new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
});
$c_Lsttp_tapir_Codec$$anon$5.prototype.encode__O__O = (function(h) {
  return this.encode__sci_ListMap__sci_Seq(h);
});
$c_Lsttp_tapir_Codec$$anon$5.prototype.rawDecode__O__Lsttp_tapir_DecodeResult = (function(l) {
  return this.rawDecode__sci_Seq__Lsttp_tapir_DecodeResult(l);
});
$c_Lsttp_tapir_Codec$$anon$5.prototype.format__Lsttp_tapir_CodecFormat = (function() {
  return new $c_Lsttp_tapir_CodecFormat$MultipartFormData();
});
var $d_Lsttp_tapir_Codec$$anon$5 = new $TypeData().initClass($c_Lsttp_tapir_Codec$$anon$5, "sttp.tapir.Codec$$anon$5", ({
  Lsttp_tapir_Codec$$anon$5: 1,
  Lsttp_tapir_Codec: 1
}));
export { $d_Lsttp_tapir_Codec$$anon$5 as $d_Lsttp_tapir_Codec$$anon$5 };
/** @constructor */
function $c_Lsttp_tapir_Codec$$anon$8(f$8, g$2, evidence$1$2, cf$2) {
  this.Lsttp_tapir_Codec$$anon$8__f_f$5 = null;
  this.Lsttp_tapir_Codec$$anon$8__f_g$1 = null;
  this.Lsttp_tapir_Codec$$anon$8__f_evidence$1$1 = null;
  this.Lsttp_tapir_Codec$$anon$8__f_cf$1 = null;
  this.Lsttp_tapir_Codec$$anon$8__f_f$5 = f$8;
  this.Lsttp_tapir_Codec$$anon$8__f_g$1 = g$2;
  this.Lsttp_tapir_Codec$$anon$8__f_evidence$1$1 = evidence$1$2;
  this.Lsttp_tapir_Codec$$anon$8__f_cf$1 = cf$2;
}
export { $c_Lsttp_tapir_Codec$$anon$8 as $c_Lsttp_tapir_Codec$$anon$8 };
$c_Lsttp_tapir_Codec$$anon$8.prototype = new $h_O();
$c_Lsttp_tapir_Codec$$anon$8.prototype.constructor = $c_Lsttp_tapir_Codec$$anon$8;
/** @constructor */
function $h_Lsttp_tapir_Codec$$anon$8() {
}
export { $h_Lsttp_tapir_Codec$$anon$8 as $h_Lsttp_tapir_Codec$$anon$8 };
$h_Lsttp_tapir_Codec$$anon$8.prototype = $c_Lsttp_tapir_Codec$$anon$8.prototype;
$c_Lsttp_tapir_Codec$$anon$8.prototype.rawDecode__O__Lsttp_tapir_DecodeResult = (function(l) {
  return this.Lsttp_tapir_Codec$$anon$8__f_f$5.apply__O__O(l);
});
$c_Lsttp_tapir_Codec$$anon$8.prototype.encode__O__O = (function(h) {
  return this.Lsttp_tapir_Codec$$anon$8__f_g$1.apply__O__O(h);
});
$c_Lsttp_tapir_Codec$$anon$8.prototype.schema__Lsttp_tapir_Schema = (function() {
  var e = this.Lsttp_tapir_Codec$$anon$8__f_evidence$1$1;
  return e;
});
$c_Lsttp_tapir_Codec$$anon$8.prototype.format__Lsttp_tapir_CodecFormat = (function() {
  return this.Lsttp_tapir_Codec$$anon$8__f_cf$1;
});
var $d_Lsttp_tapir_Codec$$anon$8 = new $TypeData().initClass($c_Lsttp_tapir_Codec$$anon$8, "sttp.tapir.Codec$$anon$8", ({
  Lsttp_tapir_Codec$$anon$8: 1,
  Lsttp_tapir_Codec: 1
}));
export { $d_Lsttp_tapir_Codec$$anon$8 as $d_Lsttp_tapir_Codec$$anon$8 };
function $is_Lsttp_tapir_DecodeResult$Failure(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsttp_tapir_DecodeResult$Failure)));
}
export { $is_Lsttp_tapir_DecodeResult$Failure as $is_Lsttp_tapir_DecodeResult$Failure };
function $isArrayOf_Lsttp_tapir_DecodeResult$Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_DecodeResult$Failure)));
}
export { $isArrayOf_Lsttp_tapir_DecodeResult$Failure as $isArrayOf_Lsttp_tapir_DecodeResult$Failure };
/** @constructor */
function $c_Lsttp_tapir_Mapping$$anon$4(f$2, g$2) {
  this.Lsttp_tapir_Mapping$$anon$4__f_f$1 = null;
  this.Lsttp_tapir_Mapping$$anon$4__f_g$1 = null;
  this.Lsttp_tapir_Mapping$$anon$4__f_f$1 = f$2;
  this.Lsttp_tapir_Mapping$$anon$4__f_g$1 = g$2;
}
export { $c_Lsttp_tapir_Mapping$$anon$4 as $c_Lsttp_tapir_Mapping$$anon$4 };
$c_Lsttp_tapir_Mapping$$anon$4.prototype = new $h_O();
$c_Lsttp_tapir_Mapping$$anon$4.prototype.constructor = $c_Lsttp_tapir_Mapping$$anon$4;
/** @constructor */
function $h_Lsttp_tapir_Mapping$$anon$4() {
}
export { $h_Lsttp_tapir_Mapping$$anon$4 as $h_Lsttp_tapir_Mapping$$anon$4 };
$h_Lsttp_tapir_Mapping$$anon$4.prototype = $c_Lsttp_tapir_Mapping$$anon$4.prototype;
$c_Lsttp_tapir_Mapping$$anon$4.prototype.rawDecode__O__Lsttp_tapir_DecodeResult = (function(l) {
  return this.Lsttp_tapir_Mapping$$anon$4__f_f$1.apply__O__O(l);
});
$c_Lsttp_tapir_Mapping$$anon$4.prototype.encode__O__O = (function(h) {
  return this.Lsttp_tapir_Mapping$$anon$4__f_g$1.apply__O__O(h);
});
$c_Lsttp_tapir_Mapping$$anon$4.prototype.validator__Lsttp_tapir_Validator = (function() {
  return $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
});
var $d_Lsttp_tapir_Mapping$$anon$4 = new $TypeData().initClass($c_Lsttp_tapir_Mapping$$anon$4, "sttp.tapir.Mapping$$anon$4", ({
  Lsttp_tapir_Mapping$$anon$4: 1,
  Lsttp_tapir_Mapping: 1
}));
export { $d_Lsttp_tapir_Mapping$$anon$4 as $d_Lsttp_tapir_Mapping$$anon$4 };
function $f_Lsttp_tapir_SchemaType$SProductField__equals__O__Z($thiz, other) {
  if ($is_Lsttp_tapir_SchemaType$SProductField(other)) {
    var x = other.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name;
    var x$2 = $thiz.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = other.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema;
      var x$4 = $thiz.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
}
export { $f_Lsttp_tapir_SchemaType$SProductField__equals__O__Z as $f_Lsttp_tapir_SchemaType$SProductField__equals__O__Z };
function $f_Lsttp_tapir_SchemaType$SProductField__toString__T($thiz) {
  return (((("SProductField(" + $thiz.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name) + ",") + $thiz.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema) + ")");
}
export { $f_Lsttp_tapir_SchemaType$SProductField__toString__T as $f_Lsttp_tapir_SchemaType$SProductField__toString__T };
function $is_Lsttp_tapir_SchemaType$SProductField(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsttp_tapir_SchemaType$SProductField)));
}
export { $is_Lsttp_tapir_SchemaType$SProductField as $is_Lsttp_tapir_SchemaType$SProductField };
function $isArrayOf_Lsttp_tapir_SchemaType$SProductField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SProductField)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SProductField as $isArrayOf_Lsttp_tapir_SchemaType$SProductField };
var $d_Lsttp_tapir_SchemaType$SProductField = new $TypeData().initClass(1, "sttp.tapir.SchemaType$SProductField", ({
  Lsttp_tapir_SchemaType$SProductField: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SProductField as $d_Lsttp_tapir_SchemaType$SProductField };
/** @constructor */
function $c_Lsttp_tapir_Validator$() {
  this.Lsttp_tapir_Validator$__f__pass = null;
  $n_Lsttp_tapir_Validator$ = this;
  this.Lsttp_tapir_Validator$__f__pass = this.all__sci_Seq__Lsttp_tapir_Validator($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsttp_tapir_Validator.getArrayOf().constr)([])));
  this.any__sci_Seq__Lsttp_tapir_Validator($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsttp_tapir_Validator.getArrayOf().constr)([])));
}
export { $c_Lsttp_tapir_Validator$ as $c_Lsttp_tapir_Validator$ };
$c_Lsttp_tapir_Validator$.prototype = new $h_O();
$c_Lsttp_tapir_Validator$.prototype.constructor = $c_Lsttp_tapir_Validator$;
/** @constructor */
function $h_Lsttp_tapir_Validator$() {
}
export { $h_Lsttp_tapir_Validator$ as $h_Lsttp_tapir_Validator$ };
$h_Lsttp_tapir_Validator$.prototype = $c_Lsttp_tapir_Validator$.prototype;
$c_Lsttp_tapir_Validator$.prototype.all__sci_Seq__Lsttp_tapir_Validator = (function(v) {
  if ((v.length__I() === 1)) {
    return v.head__O();
  } else {
    var validators = v.toList__sci_List();
    return new $c_Lsttp_tapir_Validator$All(validators);
  }
});
$c_Lsttp_tapir_Validator$.prototype.any__sci_Seq__Lsttp_tapir_Validator = (function(v) {
  if ((v.length__I() === 1)) {
    return v.head__O();
  } else {
    $m_Lsttp_tapir_Validator$Any$();
    var validators = v.toList__sci_List();
    return new $c_Lsttp_tapir_Validator$Any(validators);
  }
});
var $d_Lsttp_tapir_Validator$ = new $TypeData().initClass($c_Lsttp_tapir_Validator$, "sttp.tapir.Validator$", ({
  Lsttp_tapir_Validator$: 1,
  Lsttp_tapir_macros_ValidatorMacros: 1
}));
export { $d_Lsttp_tapir_Validator$ as $d_Lsttp_tapir_Validator$ };
var $n_Lsttp_tapir_Validator$;
function $m_Lsttp_tapir_Validator$() {
  if ((!$n_Lsttp_tapir_Validator$)) {
    $n_Lsttp_tapir_Validator$ = new $c_Lsttp_tapir_Validator$();
  }
  return $n_Lsttp_tapir_Validator$;
}
export { $m_Lsttp_tapir_Validator$ as $m_Lsttp_tapir_Validator$ };
function $f_Lsttp_tapir_Validator$Primitive__apply__O__sci_List($thiz, t) {
  var x2 = $thiz.doValidate__O__Lsttp_tapir_ValidationResult(t);
  var x = $m_Lsttp_tapir_ValidationResult$Valid$();
  if ((x === x2)) {
    return $m_sci_Nil$();
  }
  if ((x2 instanceof $c_Lsttp_tapir_ValidationResult$Invalid)) {
    var x5 = x2.Lsttp_tapir_ValidationResult$Invalid__f_customMessage;
    var x$3 = $m_sci_Nil$();
    if (x$3.equals__O__Z(x5)) {
      var path = $m_sci_Nil$();
      var customMessage = $m_s_None$();
      return new $c_sci_$colon$colon(new $c_Lsttp_tapir_ValidationError($thiz, t, path, customMessage), $m_sci_Nil$());
    } else {
      var f = ((m) => {
        var path$1 = $m_sci_Nil$();
        var customMessage$1 = new $c_s_Some(m);
        return new $c_Lsttp_tapir_ValidationError($thiz, t, path$1, customMessage$1);
      });
      if ((x5 === $m_sci_Nil$())) {
        return $m_sci_Nil$();
      } else {
        var x0 = x5.head__O();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t$1 = h;
        var rest = x5.tail__O();
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = rest.head__O();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          t$1.sci_$colon$colon__f_next = nx;
          t$1 = nx;
          rest = rest.tail__O();
        }
        return h;
      }
    }
  }
  throw new $c_s_MatchError(x2);
}
export { $f_Lsttp_tapir_Validator$Primitive__apply__O__sci_List as $f_Lsttp_tapir_Validator$Primitive__apply__O__sci_List };
function $is_Lsttp_tapir_Validator$Primitive(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lsttp_tapir_Validator$Primitive)));
}
export { $is_Lsttp_tapir_Validator$Primitive as $is_Lsttp_tapir_Validator$Primitive };
function $isArrayOf_Lsttp_tapir_Validator$Primitive(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Validator$Primitive)));
}
export { $isArrayOf_Lsttp_tapir_Validator$Primitive as $isArrayOf_Lsttp_tapir_Validator$Primitive };
/** @constructor */
function $c_Lurldsl_errors_DummyError$$anon$1(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Lurldsl_errors_DummyError$$anon$1 as $c_Lurldsl_errors_DummyError$$anon$1 };
$c_Lurldsl_errors_DummyError$$anon$1.prototype = new $h_O();
$c_Lurldsl_errors_DummyError$$anon$1.prototype.constructor = $c_Lurldsl_errors_DummyError$$anon$1;
/** @constructor */
function $h_Lurldsl_errors_DummyError$$anon$1() {
}
export { $h_Lurldsl_errors_DummyError$$anon$1 as $h_Lurldsl_errors_DummyError$$anon$1 };
$h_Lurldsl_errors_DummyError$$anon$1.prototype = $c_Lurldsl_errors_DummyError$$anon$1.prototype;
var $d_Lurldsl_errors_DummyError$$anon$1 = new $TypeData().initClass($c_Lurldsl_errors_DummyError$$anon$1, "urldsl.errors.DummyError$$anon$1", ({
  Lurldsl_errors_DummyError$$anon$1: 1,
  Lurldsl_errors_ParamMatchingError: 1
}));
export { $d_Lurldsl_errors_DummyError$$anon$1 as $d_Lurldsl_errors_DummyError$$anon$1 };
/** @constructor */
function $c_Lurldsl_errors_DummyError$$anon$2(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Lurldsl_errors_DummyError$$anon$2 as $c_Lurldsl_errors_DummyError$$anon$2 };
$c_Lurldsl_errors_DummyError$$anon$2.prototype = new $h_O();
$c_Lurldsl_errors_DummyError$$anon$2.prototype.constructor = $c_Lurldsl_errors_DummyError$$anon$2;
/** @constructor */
function $h_Lurldsl_errors_DummyError$$anon$2() {
}
export { $h_Lurldsl_errors_DummyError$$anon$2 as $h_Lurldsl_errors_DummyError$$anon$2 };
$h_Lurldsl_errors_DummyError$$anon$2.prototype = $c_Lurldsl_errors_DummyError$$anon$2.prototype;
var $d_Lurldsl_errors_DummyError$$anon$2 = new $TypeData().initClass($c_Lurldsl_errors_DummyError$$anon$2, "urldsl.errors.DummyError$$anon$2", ({
  Lurldsl_errors_DummyError$$anon$2: 1,
  Lurldsl_errors_PathMatchingError: 1
}));
export { $d_Lurldsl_errors_DummyError$$anon$2 as $d_Lurldsl_errors_DummyError$$anon$2 };
/** @constructor */
function $c_Lurldsl_errors_DummyError$$anon$3(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Lurldsl_errors_DummyError$$anon$3 as $c_Lurldsl_errors_DummyError$$anon$3 };
$c_Lurldsl_errors_DummyError$$anon$3.prototype = new $h_O();
$c_Lurldsl_errors_DummyError$$anon$3.prototype.constructor = $c_Lurldsl_errors_DummyError$$anon$3;
/** @constructor */
function $h_Lurldsl_errors_DummyError$$anon$3() {
}
export { $h_Lurldsl_errors_DummyError$$anon$3 as $h_Lurldsl_errors_DummyError$$anon$3 };
$h_Lurldsl_errors_DummyError$$anon$3.prototype = $c_Lurldsl_errors_DummyError$$anon$3.prototype;
var $d_Lurldsl_errors_DummyError$$anon$3 = new $TypeData().initClass($c_Lurldsl_errors_DummyError$$anon$3, "urldsl.errors.DummyError$$anon$3", ({
  Lurldsl_errors_DummyError$$anon$3: 1,
  Lurldsl_errors_FragmentMatchingError: 1
}));
export { $d_Lurldsl_errors_DummyError$$anon$3 as $d_Lurldsl_errors_DummyError$$anon$3 };
/** @constructor */
function $c_Lurldsl_errors_DummyError$$anon$4(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Lurldsl_errors_DummyError$$anon$4 as $c_Lurldsl_errors_DummyError$$anon$4 };
$c_Lurldsl_errors_DummyError$$anon$4.prototype = new $h_O();
$c_Lurldsl_errors_DummyError$$anon$4.prototype.constructor = $c_Lurldsl_errors_DummyError$$anon$4;
/** @constructor */
function $h_Lurldsl_errors_DummyError$$anon$4() {
}
export { $h_Lurldsl_errors_DummyError$$anon$4 as $h_Lurldsl_errors_DummyError$$anon$4 };
$h_Lurldsl_errors_DummyError$$anon$4.prototype = $c_Lurldsl_errors_DummyError$$anon$4.prototype;
var $d_Lurldsl_errors_DummyError$$anon$4 = new $TypeData().initClass($c_Lurldsl_errors_DummyError$$anon$4, "urldsl.errors.DummyError$$anon$4", ({
  Lurldsl_errors_DummyError$$anon$4: 1,
  Lurldsl_errors_ErrorFromThrowable: 1
}));
export { $d_Lurldsl_errors_DummyError$$anon$4 as $d_Lurldsl_errors_DummyError$$anon$4 };
/** @constructor */
function $c_Lurldsl_errors_DummyError$dummyError$() {
}
export { $c_Lurldsl_errors_DummyError$dummyError$ as $c_Lurldsl_errors_DummyError$dummyError$ };
$c_Lurldsl_errors_DummyError$dummyError$.prototype = new $h_O();
$c_Lurldsl_errors_DummyError$dummyError$.prototype.constructor = $c_Lurldsl_errors_DummyError$dummyError$;
/** @constructor */
function $h_Lurldsl_errors_DummyError$dummyError$() {
}
export { $h_Lurldsl_errors_DummyError$dummyError$ as $h_Lurldsl_errors_DummyError$dummyError$ };
$h_Lurldsl_errors_DummyError$dummyError$.prototype = $c_Lurldsl_errors_DummyError$dummyError$.prototype;
var $d_Lurldsl_errors_DummyError$dummyError$ = new $TypeData().initClass($c_Lurldsl_errors_DummyError$dummyError$, "urldsl.errors.DummyError$dummyError$", ({
  Lurldsl_errors_DummyError$dummyError$: 1,
  Lurldsl_errors_DummyError: 1
}));
export { $d_Lurldsl_errors_DummyError$dummyError$ as $d_Lurldsl_errors_DummyError$dummyError$ };
var $n_Lurldsl_errors_DummyError$dummyError$;
function $m_Lurldsl_errors_DummyError$dummyError$() {
  if ((!$n_Lurldsl_errors_DummyError$dummyError$)) {
    $n_Lurldsl_errors_DummyError$dummyError$ = new $c_Lurldsl_errors_DummyError$dummyError$();
  }
  return $n_Lurldsl_errors_DummyError$dummyError$;
}
export { $m_Lurldsl_errors_DummyError$dummyError$ as $m_Lurldsl_errors_DummyError$dummyError$ };
/** @constructor */
function $c_Lyantl_AsString$$anon$1() {
}
export { $c_Lyantl_AsString$$anon$1 as $c_Lyantl_AsString$$anon$1 };
$c_Lyantl_AsString$$anon$1.prototype = new $h_O();
$c_Lyantl_AsString$$anon$1.prototype.constructor = $c_Lyantl_AsString$$anon$1;
/** @constructor */
function $h_Lyantl_AsString$$anon$1() {
}
export { $h_Lyantl_AsString$$anon$1 as $h_Lyantl_AsString$$anon$1 };
$h_Lyantl_AsString$$anon$1.prototype = $c_Lyantl_AsString$$anon$1.prototype;
var $d_Lyantl_AsString$$anon$1 = new $TypeData().initClass($c_Lyantl_AsString$$anon$1, "yantl.AsString$$anon$1", ({
  Lyantl_AsString$$anon$1: 1,
  Lyantl_AsString: 1
}));
export { $d_Lyantl_AsString$$anon$1 as $d_Lyantl_AsString$$anon$1 };
function $f_Lyantl_Make__asStrings__O__Lyantl_AsString__s_util_Either($thiz, input, asString) {
  var this$1 = $thiz.apply__O__s_util_Either(input);
  var this$2 = new $c_s_util_Either$LeftProjection(this$1);
  var x1 = this$2.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var a = x1.s_util_Left__f_value;
    return new $c_s_util_Left(a.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((err) => $dp_toString__T(err)))));
  } else {
    return this$2.s_util_Either$LeftProjection__f_e;
  }
}
export { $f_Lyantl_Make__asStrings__O__Lyantl_AsString__s_util_Either as $f_Lyantl_Make__asStrings__O__Lyantl_AsString__s_util_Either };
function $f_Lyantl_Make__asString__O__Lyantl_AsString__s_util_Either($thiz, input, x$2) {
  var this$1 = $thiz.apply__O__s_util_Either(input);
  var this$2 = new $c_s_util_Either$LeftProjection(this$1);
  var x1 = this$2.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var a = x1.s_util_Left__f_value;
    return new $c_s_util_Left($m_Lyantl_Validator$().errorsToString__sci_Vector__Lyantl_AsString__T(a, x$2));
  } else {
    return this$2.s_util_Either$LeftProjection__f_e;
  }
}
export { $f_Lyantl_Make__asString__O__Lyantl_AsString__s_util_Either as $f_Lyantl_Make__asString__O__Lyantl_AsString__s_util_Either };
function $f_Lyantl_Make__orThrow__O__Lyantl_AsString__O($thiz, input, x$2) {
  var x1 = $f_Lyantl_Make__asString__O__Lyantl_AsString__s_util_Either($thiz, input, x$2);
  if ((x1 instanceof $c_s_util_Left)) {
    var value = x1.s_util_Left__f_value;
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), value);
  }
  if ((x1 instanceof $c_s_util_Right)) {
    var value$2 = x1.s_util_Right__f_value;
    return value$2;
  }
  throw new $c_s_MatchError(x1);
}
export { $f_Lyantl_Make__orThrow__O__Lyantl_AsString__O as $f_Lyantl_Make__orThrow__O__Lyantl_AsString__O };
function $f_Lyantl_Make__validate__O__sci_Vector($thiz, input) {
  var x6 = $thiz.apply__O__s_util_Either(input);
  if ((x6 instanceof $c_s_util_Left)) {
    var value = x6.s_util_Left__f_value;
    return value;
  }
  if ((x6 instanceof $c_s_util_Right)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  }
  throw new $c_s_MatchError(x6);
}
export { $f_Lyantl_Make__validate__O__sci_Vector as $f_Lyantl_Make__validate__O__sci_Vector };
/** @constructor */
function $c_Lyantl_Validate$$anon$6(f$12) {
  this.Lyantl_Validate$$anon$6__f_f$8 = null;
  this.Lyantl_Validate$$anon$6__f_f$8 = f$12;
}
export { $c_Lyantl_Validate$$anon$6 as $c_Lyantl_Validate$$anon$6 };
$c_Lyantl_Validate$$anon$6.prototype = new $h_O();
$c_Lyantl_Validate$$anon$6.prototype.constructor = $c_Lyantl_Validate$$anon$6;
/** @constructor */
function $h_Lyantl_Validate$$anon$6() {
}
export { $h_Lyantl_Validate$$anon$6 as $h_Lyantl_Validate$$anon$6 };
$h_Lyantl_Validate$$anon$6.prototype = $c_Lyantl_Validate$$anon$6.prototype;
$c_Lyantl_Validate$$anon$6.prototype.validate__O__sci_Vector = (function(input) {
  var f$4 = this.Lyantl_Validate$$anon$6__f_f$8;
  return f$4.apply__O__O(input);
});
var $d_Lyantl_Validate$$anon$6 = new $TypeData().initClass($c_Lyantl_Validate$$anon$6, "yantl.Validate$$anon$6", ({
  Lyantl_Validate$$anon$6: 1,
  Lyantl_Validate: 1
}));
export { $d_Lyantl_Validate$$anon$6 as $d_Lyantl_Validate$$anon$6 };
function $f_Lyantl_Validator__validate__O__sci_Vector($thiz, input) {
  var this$1 = $m_s_IArray$package$IArray$().iterator__O__sc_Iterator($thiz.rules__ALyantl_ValidatorRule());
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.validate__O__s_Option(input)));
  var this$2 = new $c_sc_Iterator$$anon$10(this$1, f);
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$2);
}
export { $f_Lyantl_Validator__validate__O__sci_Vector as $f_Lyantl_Validator__validate__O__sci_Vector };
/** @constructor */
function $c_Lyantl_ValidatorRule$$anon$8(num$9, minimum$6, maximum$6) {
  this.Lyantl_ValidatorRule$$anon$8__f_num$6 = null;
  this.Lyantl_ValidatorRule$$anon$8__f_minimum$4 = null;
  this.Lyantl_ValidatorRule$$anon$8__f_maximum$4 = null;
  this.Lyantl_ValidatorRule$$anon$8__f_num$6 = num$9;
  this.Lyantl_ValidatorRule$$anon$8__f_minimum$4 = minimum$6;
  this.Lyantl_ValidatorRule$$anon$8__f_maximum$4 = maximum$6;
}
export { $c_Lyantl_ValidatorRule$$anon$8 as $c_Lyantl_ValidatorRule$$anon$8 };
$c_Lyantl_ValidatorRule$$anon$8.prototype = new $h_O();
$c_Lyantl_ValidatorRule$$anon$8.prototype.constructor = $c_Lyantl_ValidatorRule$$anon$8;
/** @constructor */
function $h_Lyantl_ValidatorRule$$anon$8() {
}
export { $h_Lyantl_ValidatorRule$$anon$8 as $h_Lyantl_ValidatorRule$$anon$8 };
$h_Lyantl_ValidatorRule$$anon$8.prototype = $c_Lyantl_ValidatorRule$$anon$8.prototype;
$c_Lyantl_ValidatorRule$$anon$8.prototype.validate__O__s_Option = (function(a) {
  var num$3 = this.Lyantl_ValidatorRule$$anon$8__f_num$6;
  var minimum$2 = this.Lyantl_ValidatorRule$$anon$8__f_minimum$4;
  var maximum$2 = this.Lyantl_ValidatorRule$$anon$8__f_maximum$4;
  if (num$3.lt__O__O__Z(a, minimum$2)) {
    var value = new $c_Lyantl_ValidatorRule$SmallerThan(minimum$2, a);
    return new $c_s_Some(value);
  } else if (num$3.gt__O__O__Z(a, maximum$2)) {
    var value$1 = new $c_Lyantl_ValidatorRule$LargerThan(maximum$2, a);
    return new $c_s_Some(value$1);
  } else {
    return $m_s_None$();
  }
});
var $d_Lyantl_ValidatorRule$$anon$8 = new $TypeData().initClass($c_Lyantl_ValidatorRule$$anon$8, "yantl.ValidatorRule$$anon$8", ({
  Lyantl_ValidatorRule$$anon$8: 1,
  Lyantl_ValidatorRule: 1
}));
export { $d_Lyantl_ValidatorRule$$anon$8 as $d_Lyantl_ValidatorRule$$anon$8 };
/** @constructor */
function $c_Lalleycats_Empty$$anon$1(a$2) {
  this.Lalleycats_Empty$$anon$1__f_a$1 = null;
  this.Lalleycats_Empty$$anon$1__f_empty$lzy1 = null;
  this.Lalleycats_Empty$$anon$1__f_emptybitmap$1 = false;
  this.Lalleycats_Empty$$anon$1__f_a$1 = a$2;
}
export { $c_Lalleycats_Empty$$anon$1 as $c_Lalleycats_Empty$$anon$1 };
$c_Lalleycats_Empty$$anon$1.prototype = new $h_O();
$c_Lalleycats_Empty$$anon$1.prototype.constructor = $c_Lalleycats_Empty$$anon$1;
/** @constructor */
function $h_Lalleycats_Empty$$anon$1() {
}
export { $h_Lalleycats_Empty$$anon$1 as $h_Lalleycats_Empty$$anon$1 };
$h_Lalleycats_Empty$$anon$1.prototype = $c_Lalleycats_Empty$$anon$1.prototype;
$c_Lalleycats_Empty$$anon$1.prototype.empty__O = (function() {
  if ((!this.Lalleycats_Empty$$anon$1__f_emptybitmap$1)) {
    this.Lalleycats_Empty$$anon$1__f_empty$lzy1 = this.Lalleycats_Empty$$anon$1__f_a$1.apply__O();
    this.Lalleycats_Empty$$anon$1__f_emptybitmap$1 = true;
  }
  return this.Lalleycats_Empty$$anon$1__f_empty$lzy1;
});
var $d_Lalleycats_Empty$$anon$1 = new $TypeData().initClass($c_Lalleycats_Empty$$anon$1, "alleycats.Empty$$anon$1", ({
  Lalleycats_Empty$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lalleycats_Empty: 1
}));
export { $d_Lalleycats_Empty$$anon$1 as $d_Lalleycats_Empty$$anon$1 };
function $f_Lcats_ComposedInvariant__imap__O__F1__F1__O($thiz, fga, f, g) {
  return $thiz.F__Lcats_Invariant().imap__O__F1__F1__O(fga, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ga) => $thiz.G__Lcats_Applicative().imap__O__F1__F1__O(ga, f, g))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((gb) => $thiz.G__Lcats_Applicative().imap__O__F1__F1__O(gb, g, f))));
}
export { $f_Lcats_ComposedInvariant__imap__O__F1__F1__O as $f_Lcats_ComposedInvariant__imap__O__F1__F1__O };
function $ct_Lcats_Eval$Defer__F0__($thiz, thunk) {
  $thiz.Lcats_Eval$Defer__f_thunk = thunk;
  return $thiz;
}
export { $ct_Lcats_Eval$Defer__F0__ as $ct_Lcats_Eval$Defer__F0__ };
/** @constructor */
function $c_Lcats_Eval$Defer() {
  this.Lcats_Eval$Defer__f_thunk = null;
}
export { $c_Lcats_Eval$Defer as $c_Lcats_Eval$Defer };
$c_Lcats_Eval$Defer.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Defer.prototype.constructor = $c_Lcats_Eval$Defer;
/** @constructor */
function $h_Lcats_Eval$Defer() {
}
export { $h_Lcats_Eval$Defer as $h_Lcats_Eval$Defer };
$h_Lcats_Eval$Defer.prototype = $c_Lcats_Eval$Defer.prototype;
$c_Lcats_Eval$Defer.prototype.value__O = (function() {
  return $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this);
});
function $isArrayOf_Lcats_Eval$Defer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Defer)));
}
export { $isArrayOf_Lcats_Eval$Defer as $isArrayOf_Lcats_Eval$Defer };
/** @constructor */
function $c_Lcats_Eval$FlatMap() {
}
export { $c_Lcats_Eval$FlatMap as $c_Lcats_Eval$FlatMap };
$c_Lcats_Eval$FlatMap.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$FlatMap.prototype.constructor = $c_Lcats_Eval$FlatMap;
/** @constructor */
function $h_Lcats_Eval$FlatMap() {
}
export { $h_Lcats_Eval$FlatMap as $h_Lcats_Eval$FlatMap };
$h_Lcats_Eval$FlatMap.prototype = $c_Lcats_Eval$FlatMap.prototype;
$c_Lcats_Eval$FlatMap.prototype.value__O = (function() {
  return $m_Lcats_Eval$().cats$Eval$$$evaluate__Lcats_Eval__O(this);
});
function $isArrayOf_Lcats_Eval$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$FlatMap)));
}
export { $isArrayOf_Lcats_Eval$FlatMap as $isArrayOf_Lcats_Eval$FlatMap };
/** @constructor */
function $c_Lcats_Eval$Leaf() {
}
export { $c_Lcats_Eval$Leaf as $c_Lcats_Eval$Leaf };
$c_Lcats_Eval$Leaf.prototype = new $h_Lcats_Eval();
$c_Lcats_Eval$Leaf.prototype.constructor = $c_Lcats_Eval$Leaf;
/** @constructor */
function $h_Lcats_Eval$Leaf() {
}
export { $h_Lcats_Eval$Leaf as $h_Lcats_Eval$Leaf };
$h_Lcats_Eval$Leaf.prototype = $c_Lcats_Eval$Leaf.prototype;
function $isArrayOf_Lcats_Eval$Leaf(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Leaf)));
}
export { $isArrayOf_Lcats_Eval$Leaf as $isArrayOf_Lcats_Eval$Leaf };
function $ct_Lcats_EvalInstances__($thiz) {
  $thiz.Lcats_EvalInstances__f_catsBimonadForEval = new $c_Lcats_EvalInstances$$anon$6();
  new $c_Lcats_EvalInstances$$anon$9($thiz);
  return $thiz;
}
export { $ct_Lcats_EvalInstances__ as $ct_Lcats_EvalInstances__ };
/** @constructor */
function $c_Lcats_EvalInstances() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null;
}
export { $c_Lcats_EvalInstances as $c_Lcats_EvalInstances };
$c_Lcats_EvalInstances.prototype = new $h_Lcats_EvalInstances0();
$c_Lcats_EvalInstances.prototype.constructor = $c_Lcats_EvalInstances;
/** @constructor */
function $h_Lcats_EvalInstances() {
}
export { $h_Lcats_EvalInstances as $h_Lcats_EvalInstances };
$h_Lcats_EvalInstances.prototype = $c_Lcats_EvalInstances.prototype;
/** @constructor */
function $c_Lcats_EvalInstances$$anon$9(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Lcats_EvalInstances$$anon$9 as $c_Lcats_EvalInstances$$anon$9 };
$c_Lcats_EvalInstances$$anon$9.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$9.prototype.constructor = $c_Lcats_EvalInstances$$anon$9;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$9() {
}
export { $h_Lcats_EvalInstances$$anon$9 as $h_Lcats_EvalInstances$$anon$9 };
$h_Lcats_EvalInstances$$anon$9.prototype = $c_Lcats_EvalInstances$$anon$9.prototype;
var $d_Lcats_EvalInstances$$anon$9 = new $TypeData().initClass($c_Lcats_EvalInstances$$anon$9, "cats.EvalInstances$$anon$9", ({
  Lcats_EvalInstances$$anon$9: 1,
  Ljava_io_Serializable: 1,
  Lcats_Representable: 1
}));
export { $d_Lcats_EvalInstances$$anon$9 as $d_Lcats_EvalInstances$$anon$9 };
/** @constructor */
function $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target$2, tc$2) {
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self = null;
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance = null;
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self = target$2;
  this.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance = tc$2;
}
export { $c_Lcats_FlatMap$ToFlatMapOps$$anon$2 as $c_Lcats_FlatMap$ToFlatMapOps$$anon$2 };
$c_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype = new $h_O();
$c_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype.constructor = $c_Lcats_FlatMap$ToFlatMapOps$$anon$2;
/** @constructor */
function $h_Lcats_FlatMap$ToFlatMapOps$$anon$2() {
}
export { $h_Lcats_FlatMap$ToFlatMapOps$$anon$2 as $h_Lcats_FlatMap$ToFlatMapOps$$anon$2 };
$h_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype = $c_Lcats_FlatMap$ToFlatMapOps$$anon$2.prototype;
var $d_Lcats_FlatMap$ToFlatMapOps$$anon$2 = new $TypeData().initClass($c_Lcats_FlatMap$ToFlatMapOps$$anon$2, "cats.FlatMap$ToFlatMapOps$$anon$2", ({
  Lcats_FlatMap$ToFlatMapOps$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_FlatMap$Ops: 1
}));
export { $d_Lcats_FlatMap$ToFlatMapOps$$anon$2 as $d_Lcats_FlatMap$ToFlatMapOps$$anon$2 };
/** @constructor */
function $c_Lcats_Foldable$ToFoldableOps$$anon$6(target$2, tc$2) {
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_self = null;
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance = null;
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_self = target$2;
  this.Lcats_Foldable$ToFoldableOps$$anon$6__f_typeClassInstance = tc$2;
}
export { $c_Lcats_Foldable$ToFoldableOps$$anon$6 as $c_Lcats_Foldable$ToFoldableOps$$anon$6 };
$c_Lcats_Foldable$ToFoldableOps$$anon$6.prototype = new $h_O();
$c_Lcats_Foldable$ToFoldableOps$$anon$6.prototype.constructor = $c_Lcats_Foldable$ToFoldableOps$$anon$6;
/** @constructor */
function $h_Lcats_Foldable$ToFoldableOps$$anon$6() {
}
export { $h_Lcats_Foldable$ToFoldableOps$$anon$6 as $h_Lcats_Foldable$ToFoldableOps$$anon$6 };
$h_Lcats_Foldable$ToFoldableOps$$anon$6.prototype = $c_Lcats_Foldable$ToFoldableOps$$anon$6.prototype;
var $d_Lcats_Foldable$ToFoldableOps$$anon$6 = new $TypeData().initClass($c_Lcats_Foldable$ToFoldableOps$$anon$6, "cats.Foldable$ToFoldableOps$$anon$6", ({
  Lcats_Foldable$ToFoldableOps$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_Foldable$Ops: 1
}));
export { $d_Lcats_Foldable$ToFoldableOps$$anon$6 as $d_Lcats_Foldable$ToFoldableOps$$anon$6 };
function $f_Lcats_Functor__as__O__O__O($thiz, fa, b) {
  return $thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => b)));
}
export { $f_Lcats_Functor__as__O__O__O as $f_Lcats_Functor__as__O__O__O };
/** @constructor */
function $c_Lcats_Functor$ToFunctorOps$$anon$5(target$2, tc$2) {
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_self = null;
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance = null;
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_self = target$2;
  this.Lcats_Functor$ToFunctorOps$$anon$5__f_typeClassInstance = tc$2;
}
export { $c_Lcats_Functor$ToFunctorOps$$anon$5 as $c_Lcats_Functor$ToFunctorOps$$anon$5 };
$c_Lcats_Functor$ToFunctorOps$$anon$5.prototype = new $h_O();
$c_Lcats_Functor$ToFunctorOps$$anon$5.prototype.constructor = $c_Lcats_Functor$ToFunctorOps$$anon$5;
/** @constructor */
function $h_Lcats_Functor$ToFunctorOps$$anon$5() {
}
export { $h_Lcats_Functor$ToFunctorOps$$anon$5 as $h_Lcats_Functor$ToFunctorOps$$anon$5 };
$h_Lcats_Functor$ToFunctorOps$$anon$5.prototype = $c_Lcats_Functor$ToFunctorOps$$anon$5.prototype;
var $d_Lcats_Functor$ToFunctorOps$$anon$5 = new $TypeData().initClass($c_Lcats_Functor$ToFunctorOps$$anon$5, "cats.Functor$ToFunctorOps$$anon$5", ({
  Lcats_Functor$ToFunctorOps$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_Functor$Ops: 1
}));
export { $d_Lcats_Functor$ToFunctorOps$$anon$5 as $d_Lcats_Functor$ToFunctorOps$$anon$5 };
/** @constructor */
function $c_Lcats_Invariant$ToInvariantOps$$anon$19(target$2, tc$2) {
  this.Lcats_Invariant$ToInvariantOps$$anon$19__f_self = null;
  this.Lcats_Invariant$ToInvariantOps$$anon$19__f_typeClassInstance = null;
  this.Lcats_Invariant$ToInvariantOps$$anon$19__f_self = target$2;
  this.Lcats_Invariant$ToInvariantOps$$anon$19__f_typeClassInstance = tc$2;
}
export { $c_Lcats_Invariant$ToInvariantOps$$anon$19 as $c_Lcats_Invariant$ToInvariantOps$$anon$19 };
$c_Lcats_Invariant$ToInvariantOps$$anon$19.prototype = new $h_O();
$c_Lcats_Invariant$ToInvariantOps$$anon$19.prototype.constructor = $c_Lcats_Invariant$ToInvariantOps$$anon$19;
/** @constructor */
function $h_Lcats_Invariant$ToInvariantOps$$anon$19() {
}
export { $h_Lcats_Invariant$ToInvariantOps$$anon$19 as $h_Lcats_Invariant$ToInvariantOps$$anon$19 };
$h_Lcats_Invariant$ToInvariantOps$$anon$19.prototype = $c_Lcats_Invariant$ToInvariantOps$$anon$19.prototype;
var $d_Lcats_Invariant$ToInvariantOps$$anon$19 = new $TypeData().initClass($c_Lcats_Invariant$ToInvariantOps$$anon$19, "cats.Invariant$ToInvariantOps$$anon$19", ({
  Lcats_Invariant$ToInvariantOps$$anon$19: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant$Ops: 1
}));
export { $d_Lcats_Invariant$ToInvariantOps$$anon$19 as $d_Lcats_Invariant$ToInvariantOps$$anon$19 };
/** @constructor */
function $c_Lcats_SemigroupK$$anon$1(outer) {
  this.Lcats_SemigroupK$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_SemigroupK$$anon$1__f_$outer = outer;
}
export { $c_Lcats_SemigroupK$$anon$1 as $c_Lcats_SemigroupK$$anon$1 };
$c_Lcats_SemigroupK$$anon$1.prototype = new $h_O();
$c_Lcats_SemigroupK$$anon$1.prototype.constructor = $c_Lcats_SemigroupK$$anon$1;
/** @constructor */
function $h_Lcats_SemigroupK$$anon$1() {
}
export { $h_Lcats_SemigroupK$$anon$1 as $h_Lcats_SemigroupK$$anon$1 };
$h_Lcats_SemigroupK$$anon$1.prototype = $c_Lcats_SemigroupK$$anon$1.prototype;
$c_Lcats_SemigroupK$$anon$1.prototype.combine__O__O__O = (function(_$2, _$3) {
  var this$1 = this.Lcats_SemigroupK$$anon$1__f_$outer;
  return this$1.combineK__O__O__O(_$2, _$3);
});
var $d_Lcats_SemigroupK$$anon$1 = new $TypeData().initClass($c_Lcats_SemigroupK$$anon$1, "cats.SemigroupK$$anon$1", ({
  Lcats_SemigroupK$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1
}));
export { $d_Lcats_SemigroupK$$anon$1 as $d_Lcats_SemigroupK$$anon$1 };
/** @constructor */
function $c_Lcats_arrow_FunctionK$$anon$4() {
}
export { $c_Lcats_arrow_FunctionK$$anon$4 as $c_Lcats_arrow_FunctionK$$anon$4 };
$c_Lcats_arrow_FunctionK$$anon$4.prototype = new $h_O();
$c_Lcats_arrow_FunctionK$$anon$4.prototype.constructor = $c_Lcats_arrow_FunctionK$$anon$4;
/** @constructor */
function $h_Lcats_arrow_FunctionK$$anon$4() {
}
export { $h_Lcats_arrow_FunctionK$$anon$4 as $h_Lcats_arrow_FunctionK$$anon$4 };
$h_Lcats_arrow_FunctionK$$anon$4.prototype = $c_Lcats_arrow_FunctionK$$anon$4.prototype;
$c_Lcats_arrow_FunctionK$$anon$4.prototype.apply__O__O = (function(fa) {
  return fa;
});
var $d_Lcats_arrow_FunctionK$$anon$4 = new $TypeData().initClass($c_Lcats_arrow_FunctionK$$anon$4, "cats.arrow.FunctionK$$anon$4", ({
  Lcats_arrow_FunctionK$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1
}));
export { $d_Lcats_arrow_FunctionK$$anon$4 as $d_Lcats_arrow_FunctionK$$anon$4 };
/** @constructor */
function $c_Lcats_data_Chain$$anon$2() {
}
export { $c_Lcats_data_Chain$$anon$2 as $c_Lcats_data_Chain$$anon$2 };
$c_Lcats_data_Chain$$anon$2.prototype = new $h_sr_AbstractFunction1();
$c_Lcats_data_Chain$$anon$2.prototype.constructor = $c_Lcats_data_Chain$$anon$2;
/** @constructor */
function $h_Lcats_data_Chain$$anon$2() {
}
export { $h_Lcats_data_Chain$$anon$2 as $h_Lcats_data_Chain$$anon$2 };
$h_Lcats_data_Chain$$anon$2.prototype = $c_Lcats_data_Chain$$anon$2.prototype;
$c_Lcats_data_Chain$$anon$2.prototype.apply__O__O = (function(a) {
  return this;
});
var $d_Lcats_data_Chain$$anon$2 = new $TypeData().initClass($c_Lcats_data_Chain$$anon$2, "cats.data.Chain$$anon$2", ({
  Lcats_data_Chain$$anon$2: 1,
  sr_AbstractFunction1: 1,
  F1: 1
}));
export { $d_Lcats_data_Chain$$anon$2 as $d_Lcats_data_Chain$$anon$2 };
/** @constructor */
function $c_Lcats_data_Chain$NonEmpty() {
}
export { $c_Lcats_data_Chain$NonEmpty as $c_Lcats_data_Chain$NonEmpty };
$c_Lcats_data_Chain$NonEmpty.prototype = new $h_Lcats_data_Chain();
$c_Lcats_data_Chain$NonEmpty.prototype.constructor = $c_Lcats_data_Chain$NonEmpty;
/** @constructor */
function $h_Lcats_data_Chain$NonEmpty() {
}
export { $h_Lcats_data_Chain$NonEmpty as $h_Lcats_data_Chain$NonEmpty };
$h_Lcats_data_Chain$NonEmpty.prototype = $c_Lcats_data_Chain$NonEmpty.prototype;
function $isArrayOf_Lcats_data_Chain$NonEmpty(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$NonEmpty)));
}
export { $isArrayOf_Lcats_data_Chain$NonEmpty as $isArrayOf_Lcats_data_Chain$NonEmpty };
/** @constructor */
function $c_Lcats_data_ChainInstances1() {
}
export { $c_Lcats_data_ChainInstances1 as $c_Lcats_data_ChainInstances1 };
$c_Lcats_data_ChainInstances1.prototype = new $h_Lcats_data_ChainInstances2();
$c_Lcats_data_ChainInstances1.prototype.constructor = $c_Lcats_data_ChainInstances1;
/** @constructor */
function $h_Lcats_data_ChainInstances1() {
}
export { $h_Lcats_data_ChainInstances1 as $h_Lcats_data_ChainInstances1 };
$h_Lcats_data_ChainInstances1.prototype = $c_Lcats_data_ChainInstances1.prototype;
function $ct_Lcats_data_NonEmptyListInstances__($thiz) {
  $thiz.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyListBinCompat1 = new $c_Lcats_data_NonEmptyListInstances$$anon$2();
  return $thiz;
}
export { $ct_Lcats_data_NonEmptyListInstances__ as $ct_Lcats_data_NonEmptyListInstances__ };
function $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$2$$_$go$2__scm_ListBuffer__F1__Lcats_data_NonEmptyList__V(buf$3, f$10, v) {
  var v$tailLocal1 = v;
  while (true) {
    var x64 = v$tailLocal1.Lcats_data_NonEmptyList__f_head;
    if ((x64 instanceof $c_s_util_Right)) {
      var b = x64.s_util_Right__f_value;
      buf$3.addOne__O__scm_ListBuffer(b);
      var x61 = $m_Lcats_data_NonEmptyList$().fromList__sci_List__s_Option(v$tailLocal1.Lcats_data_NonEmptyList__f_tail);
      if ((x61 instanceof $c_s_Some)) {
        var t = x61.s_Some__f_value;
        v$tailLocal1 = t;
        continue;
      }
      var x = $m_s_None$();
      if ((x === x61)) {
        return (void 0);
      }
      throw new $c_s_MatchError(x61);
    }
    if ((x64 instanceof $c_s_util_Left)) {
      var a = x64.s_util_Left__f_value;
      var this$1 = f$10.apply__O__O(a);
      var l = v$tailLocal1.Lcats_data_NonEmptyList__f_tail;
      v$tailLocal1 = this$1.concat__sci_List__Lcats_data_NonEmptyList(l);
      continue;
    }
    throw new $c_s_MatchError(x64);
  }
}
export { $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$2$$_$go$2__scm_ListBuffer__F1__Lcats_data_NonEmptyList__V as $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$2$$_$go$2__scm_ListBuffer__F1__Lcats_data_NonEmptyList__V };
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances() {
  this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyListBinCompat1 = null;
}
export { $c_Lcats_data_NonEmptyListInstances as $c_Lcats_data_NonEmptyListInstances };
$c_Lcats_data_NonEmptyListInstances.prototype = new $h_Lcats_data_NonEmptyListInstances0();
$c_Lcats_data_NonEmptyListInstances.prototype.constructor = $c_Lcats_data_NonEmptyListInstances;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances() {
}
export { $h_Lcats_data_NonEmptyListInstances as $h_Lcats_data_NonEmptyListInstances };
$h_Lcats_data_NonEmptyListInstances.prototype = $c_Lcats_data_NonEmptyListInstances.prototype;
$c_Lcats_data_NonEmptyListInstances.prototype.catsDataSemigroupForNonEmptyList__Lcats_kernel_Semigroup = (function() {
  var instance = this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyListBinCompat1;
  return instance.algebra__Lcats_kernel_Semigroup();
});
/** @constructor */
function $c_Lcats_data_NonEmptyVectorInstances0() {
}
export { $c_Lcats_data_NonEmptyVectorInstances0 as $c_Lcats_data_NonEmptyVectorInstances0 };
$c_Lcats_data_NonEmptyVectorInstances0.prototype = new $h_Lcats_data_NonEmptyVectorInstances1();
$c_Lcats_data_NonEmptyVectorInstances0.prototype.constructor = $c_Lcats_data_NonEmptyVectorInstances0;
/** @constructor */
function $h_Lcats_data_NonEmptyVectorInstances0() {
}
export { $h_Lcats_data_NonEmptyVectorInstances0 as $h_Lcats_data_NonEmptyVectorInstances0 };
$h_Lcats_data_NonEmptyVectorInstances0.prototype = $c_Lcats_data_NonEmptyVectorInstances0.prototype;
function $ct_Lcats_data_ValidatedInstances__($thiz) {
  return $thiz;
}
export { $ct_Lcats_data_ValidatedInstances__ as $ct_Lcats_data_ValidatedInstances__ };
/** @constructor */
function $c_Lcats_data_ValidatedInstances() {
}
export { $c_Lcats_data_ValidatedInstances as $c_Lcats_data_ValidatedInstances };
$c_Lcats_data_ValidatedInstances.prototype = new $h_Lcats_data_ValidatedInstances1();
$c_Lcats_data_ValidatedInstances.prototype.constructor = $c_Lcats_data_ValidatedInstances;
/** @constructor */
function $h_Lcats_data_ValidatedInstances() {
}
export { $h_Lcats_data_ValidatedInstances as $h_Lcats_data_ValidatedInstances };
$h_Lcats_data_ValidatedInstances.prototype = $c_Lcats_data_ValidatedInstances.prototype;
/** @constructor */
function $c_Lcats_instances_package$int$() {
  this.Lcats_instances_package$int$__f_catsStdShowForInt = null;
  $n_Lcats_instances_package$int$ = this;
  $f_Lcats_kernel_instances_IntInstances__$init$__V(this);
  this.Lcats_instances_package$int$__f_catsStdShowForInt = new $c_Lcats_Show$$anon$5();
}
export { $c_Lcats_instances_package$int$ as $c_Lcats_instances_package$int$ };
$c_Lcats_instances_package$int$.prototype = new $h_O();
$c_Lcats_instances_package$int$.prototype.constructor = $c_Lcats_instances_package$int$;
/** @constructor */
function $h_Lcats_instances_package$int$() {
}
export { $h_Lcats_instances_package$int$ as $h_Lcats_instances_package$int$ };
$h_Lcats_instances_package$int$.prototype = $c_Lcats_instances_package$int$.prototype;
$c_Lcats_instances_package$int$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdOrderForInt_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
});
$c_Lcats_instances_package$int$.prototype.cats$kernel$instances$IntInstances$_setter_$catsKernelStdGroupForInt_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
var $d_Lcats_instances_package$int$ = new $TypeData().initClass($c_Lcats_instances_package$int$, "cats.instances.package$int$", ({
  Lcats_instances_package$int$: 1,
  Lcats_kernel_instances_IntInstances: 1,
  Lcats_instances_IntInstances: 1
}));
export { $d_Lcats_instances_package$int$ as $d_Lcats_instances_package$int$ };
var $n_Lcats_instances_package$int$;
function $m_Lcats_instances_package$int$() {
  if ((!$n_Lcats_instances_package$int$)) {
    $n_Lcats_instances_package$int$ = new $c_Lcats_instances_package$int$();
  }
  return $n_Lcats_instances_package$int$;
}
export { $m_Lcats_instances_package$int$ as $m_Lcats_instances_package$int$ };
/** @constructor */
function $c_Lcats_instances_package$long$() {
  this.Lcats_instances_package$long$__f_catsKernelStdOrderForLong = null;
  this.Lcats_instances_package$long$__f_catsStdShowForLong = null;
  $n_Lcats_instances_package$long$ = this;
  $f_Lcats_kernel_instances_LongInstances__$init$__V(this);
  this.Lcats_instances_package$long$__f_catsStdShowForLong = new $c_Lcats_Show$$anon$5();
}
export { $c_Lcats_instances_package$long$ as $c_Lcats_instances_package$long$ };
$c_Lcats_instances_package$long$.prototype = new $h_O();
$c_Lcats_instances_package$long$.prototype.constructor = $c_Lcats_instances_package$long$;
/** @constructor */
function $h_Lcats_instances_package$long$() {
}
export { $h_Lcats_instances_package$long$ as $h_Lcats_instances_package$long$ };
$h_Lcats_instances_package$long$.prototype = $c_Lcats_instances_package$long$.prototype;
$c_Lcats_instances_package$long$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdOrderForLong_$eq__Lcats_kernel_BoundedEnumerable__V = (function(x$0) {
  this.Lcats_instances_package$long$__f_catsKernelStdOrderForLong = x$0;
});
$c_Lcats_instances_package$long$.prototype.cats$kernel$instances$LongInstances$_setter_$catsKernelStdGroupForLong_$eq__Lcats_kernel_CommutativeGroup__V = (function(x$0) {
});
var $d_Lcats_instances_package$long$ = new $TypeData().initClass($c_Lcats_instances_package$long$, "cats.instances.package$long$", ({
  Lcats_instances_package$long$: 1,
  Lcats_kernel_instances_LongInstances: 1,
  Lcats_instances_LongInstances: 1
}));
export { $d_Lcats_instances_package$long$ as $d_Lcats_instances_package$long$ };
var $n_Lcats_instances_package$long$;
function $m_Lcats_instances_package$long$() {
  if ((!$n_Lcats_instances_package$long$)) {
    $n_Lcats_instances_package$long$ = new $c_Lcats_instances_package$long$();
  }
  return $n_Lcats_instances_package$long$;
}
export { $m_Lcats_instances_package$long$ as $m_Lcats_instances_package$long$ };
/** @constructor */
function $c_Lcats_instances_package$string$() {
  this.Lcats_instances_package$string$__f_catsStdShowForString = null;
  $n_Lcats_instances_package$string$ = this;
  $f_Lcats_kernel_instances_StringInstances__$init$__V(this);
  this.Lcats_instances_package$string$__f_catsStdShowForString = new $c_Lcats_Show$$anon$5();
}
export { $c_Lcats_instances_package$string$ as $c_Lcats_instances_package$string$ };
$c_Lcats_instances_package$string$.prototype = new $h_O();
$c_Lcats_instances_package$string$.prototype.constructor = $c_Lcats_instances_package$string$;
/** @constructor */
function $h_Lcats_instances_package$string$() {
}
export { $h_Lcats_instances_package$string$ as $h_Lcats_instances_package$string$ };
$h_Lcats_instances_package$string$.prototype = $c_Lcats_instances_package$string$.prototype;
$c_Lcats_instances_package$string$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdOrderForString_$eq__Lcats_kernel_Hash__V = (function(x$0) {
});
$c_Lcats_instances_package$string$.prototype.cats$kernel$instances$StringInstances$_setter_$catsKernelStdMonoidForString_$eq__Lcats_kernel_Monoid__V = (function(x$0) {
});
var $d_Lcats_instances_package$string$ = new $TypeData().initClass($c_Lcats_instances_package$string$, "cats.instances.package$string$", ({
  Lcats_instances_package$string$: 1,
  Lcats_kernel_instances_StringInstances: 1,
  Lcats_instances_StringInstances: 1
}));
export { $d_Lcats_instances_package$string$ as $d_Lcats_instances_package$string$ };
var $n_Lcats_instances_package$string$;
function $m_Lcats_instances_package$string$() {
  if ((!$n_Lcats_instances_package$string$)) {
    $n_Lcats_instances_package$string$ = new $c_Lcats_instances_package$string$();
  }
  return $n_Lcats_instances_package$string$;
}
export { $m_Lcats_instances_package$string$ as $m_Lcats_instances_package$string$ };
/** @constructor */
function $c_Lcats_kernel_Comparison$() {
}
export { $c_Lcats_kernel_Comparison$ as $c_Lcats_kernel_Comparison$ };
$c_Lcats_kernel_Comparison$.prototype = new $h_O();
$c_Lcats_kernel_Comparison$.prototype.constructor = $c_Lcats_kernel_Comparison$;
/** @constructor */
function $h_Lcats_kernel_Comparison$() {
}
export { $h_Lcats_kernel_Comparison$ as $h_Lcats_kernel_Comparison$ };
$h_Lcats_kernel_Comparison$.prototype = $c_Lcats_kernel_Comparison$.prototype;
$c_Lcats_kernel_Comparison$.prototype.ordinal__Lcats_kernel_Comparison__I = (function(x$0) {
  if ((x$0 === $m_Lcats_kernel_Comparison$GreaterThan$())) {
    return 0;
  }
  if ((x$0 === $m_Lcats_kernel_Comparison$EqualTo$())) {
    return 1;
  }
  if ((x$0 === $m_Lcats_kernel_Comparison$LessThan$())) {
    return 2;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lcats_kernel_Comparison$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcats_kernel_Comparison__I(x);
});
var $d_Lcats_kernel_Comparison$ = new $TypeData().initClass($c_Lcats_kernel_Comparison$, "cats.kernel.Comparison$", ({
  Lcats_kernel_Comparison$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lcats_kernel_Comparison$ as $d_Lcats_kernel_Comparison$ };
var $n_Lcats_kernel_Comparison$;
function $m_Lcats_kernel_Comparison$() {
  if ((!$n_Lcats_kernel_Comparison$)) {
    $n_Lcats_kernel_Comparison$ = new $c_Lcats_kernel_Comparison$();
  }
  return $n_Lcats_kernel_Comparison$;
}
export { $m_Lcats_kernel_Comparison$ as $m_Lcats_kernel_Comparison$ };
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$5(f$6) {
  this.Lcats_kernel_Eq$$anon$5__f_f$4 = null;
  this.Lcats_kernel_Eq$$anon$5__f_f$4 = f$6;
}
export { $c_Lcats_kernel_Eq$$anon$5 as $c_Lcats_kernel_Eq$$anon$5 };
$c_Lcats_kernel_Eq$$anon$5.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$5.prototype.constructor = $c_Lcats_kernel_Eq$$anon$5;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$5() {
}
export { $h_Lcats_kernel_Eq$$anon$5 as $h_Lcats_kernel_Eq$$anon$5 };
$h_Lcats_kernel_Eq$$anon$5.prototype = $c_Lcats_kernel_Eq$$anon$5.prototype;
$c_Lcats_kernel_Eq$$anon$5.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Eq$$anon$5.prototype.eqv__O__O__Z = (function(_$3, _$4) {
  var f$2 = this.Lcats_kernel_Eq$$anon$5__f_f$4;
  return (!(!f$2.apply__O__O__O(_$3, _$4)));
});
var $d_Lcats_kernel_Eq$$anon$5 = new $TypeData().initClass($c_Lcats_kernel_Eq$$anon$5, "cats.kernel.Eq$$anon$5", ({
  Lcats_kernel_Eq$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
export { $d_Lcats_kernel_Eq$$anon$5 as $d_Lcats_kernel_Eq$$anon$5 };
/** @constructor */
function $c_Lcats_kernel_Eq$$anon$6() {
}
export { $c_Lcats_kernel_Eq$$anon$6 as $c_Lcats_kernel_Eq$$anon$6 };
$c_Lcats_kernel_Eq$$anon$6.prototype = new $h_O();
$c_Lcats_kernel_Eq$$anon$6.prototype.constructor = $c_Lcats_kernel_Eq$$anon$6;
/** @constructor */
function $h_Lcats_kernel_Eq$$anon$6() {
}
export { $h_Lcats_kernel_Eq$$anon$6 as $h_Lcats_kernel_Eq$$anon$6 };
$h_Lcats_kernel_Eq$$anon$6.prototype = $c_Lcats_kernel_Eq$$anon$6.prototype;
$c_Lcats_kernel_Eq$$anon$6.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Eq$$anon$6.prototype.eqv__O__O__Z = (function(_$5, _$6) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(_$5, _$6);
});
var $d_Lcats_kernel_Eq$$anon$6 = new $TypeData().initClass($c_Lcats_kernel_Eq$$anon$6, "cats.kernel.Eq$$anon$6", ({
  Lcats_kernel_Eq$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
export { $d_Lcats_kernel_Eq$$anon$6 as $d_Lcats_kernel_Eq$$anon$6 };
/** @constructor */
function $c_Lcats_kernel_Hash$() {
}
export { $c_Lcats_kernel_Hash$ as $c_Lcats_kernel_Hash$ };
$c_Lcats_kernel_Hash$.prototype = new $h_Lcats_kernel_HashFunctions();
$c_Lcats_kernel_Hash$.prototype.constructor = $c_Lcats_kernel_Hash$;
/** @constructor */
function $h_Lcats_kernel_Hash$() {
}
export { $h_Lcats_kernel_Hash$ as $h_Lcats_kernel_Hash$ };
$h_Lcats_kernel_Hash$.prototype = $c_Lcats_kernel_Hash$.prototype;
var $d_Lcats_kernel_Hash$ = new $TypeData().initClass($c_Lcats_kernel_Hash$, "cats.kernel.Hash$", ({
  Lcats_kernel_Hash$: 1,
  Lcats_kernel_HashFunctions: 1,
  Lcats_kernel_EqFunctions: 1
}));
export { $d_Lcats_kernel_Hash$ as $d_Lcats_kernel_Hash$ };
var $n_Lcats_kernel_Hash$;
function $m_Lcats_kernel_Hash$() {
  if ((!$n_Lcats_kernel_Hash$)) {
    $n_Lcats_kernel_Hash$ = new $c_Lcats_kernel_Hash$();
  }
  return $n_Lcats_kernel_Hash$;
}
export { $m_Lcats_kernel_Hash$ as $m_Lcats_kernel_Hash$ };
function $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O($thiz, as) {
  var this$2 = as.iterator__sc_Iterator();
  var z = $thiz.empty__O();
  var f = ((x, y) => $thiz.combine__O__O__O(x, y));
  if ($is_sc_IndexedSeq(this$2)) {
    var at = 0;
    var end = this$2.length__I();
    var acc = z;
    while (true) {
      if ((at === end)) {
        return acc;
      } else {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$2.apply__I__O(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
      }
    }
  } else {
    var result = z;
    while (this$2.hasNext__Z()) {
      var x0$1 = result;
      var x1$1 = this$2.next__O();
      result = f(x0$1, x1$1);
    }
    return result;
  }
}
export { $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O as $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O };
/** @constructor */
function $c_Lcats_kernel_Monoid$() {
}
export { $c_Lcats_kernel_Monoid$ as $c_Lcats_kernel_Monoid$ };
$c_Lcats_kernel_Monoid$.prototype = new $h_Lcats_kernel_MonoidFunctions();
$c_Lcats_kernel_Monoid$.prototype.constructor = $c_Lcats_kernel_Monoid$;
/** @constructor */
function $h_Lcats_kernel_Monoid$() {
}
export { $h_Lcats_kernel_Monoid$ as $h_Lcats_kernel_Monoid$ };
$h_Lcats_kernel_Monoid$.prototype = $c_Lcats_kernel_Monoid$.prototype;
var $d_Lcats_kernel_Monoid$ = new $TypeData().initClass($c_Lcats_kernel_Monoid$, "cats.kernel.Monoid$", ({
  Lcats_kernel_Monoid$: 1,
  Lcats_kernel_MonoidFunctions: 1,
  Lcats_kernel_SemigroupFunctions: 1
}));
export { $d_Lcats_kernel_Monoid$ as $d_Lcats_kernel_Monoid$ };
var $n_Lcats_kernel_Monoid$;
function $m_Lcats_kernel_Monoid$() {
  if ((!$n_Lcats_kernel_Monoid$)) {
    $n_Lcats_kernel_Monoid$ = new $c_Lcats_kernel_Monoid$();
  }
  return $n_Lcats_kernel_Monoid$;
}
export { $m_Lcats_kernel_Monoid$ as $m_Lcats_kernel_Monoid$ };
/** @constructor */
function $c_Lcats_kernel_OrderFunctions() {
}
export { $c_Lcats_kernel_OrderFunctions as $c_Lcats_kernel_OrderFunctions };
$c_Lcats_kernel_OrderFunctions.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_OrderFunctions.prototype.constructor = $c_Lcats_kernel_OrderFunctions;
/** @constructor */
function $h_Lcats_kernel_OrderFunctions() {
}
export { $h_Lcats_kernel_OrderFunctions as $h_Lcats_kernel_OrderFunctions };
$h_Lcats_kernel_OrderFunctions.prototype = $c_Lcats_kernel_OrderFunctions.prototype;
function $p_Lcats_kernel_instances_ListEq__loop$3__sci_List__sci_List__Z($thiz, xs, ys) {
  var ys$tailLocal3 = ys;
  var xs$tailLocal3 = xs;
  while (true) {
    var x21 = xs$tailLocal3;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x21)) {
      return ys$tailLocal3.isEmpty__Z();
    }
    if ((x21 instanceof $c_sci_$colon$colon)) {
      var x24 = x21.sci_$colon$colon__f_next;
      var x$3 = x21.sci_$colon$colon__f_head;
      var x17 = ys$tailLocal3;
      if ((x17 instanceof $c_sci_$colon$colon)) {
        var x20 = x17.sci_$colon$colon__f_next;
        var y = x17.sci_$colon$colon__f_head;
        if ($thiz.Lcats_kernel_instances_ListEq__f_ev.eqv__O__O__Z(x$3, y)) {
          xs$tailLocal3 = x24;
          ys$tailLocal3 = x20;
          continue;
        } else {
          return false;
        }
      }
      var x$4 = $m_sci_Nil$();
      if (x$4.equals__O__Z(x17)) {
        return false;
      }
      throw new $c_s_MatchError(x17);
    }
    throw new $c_s_MatchError(x21);
  }
}
export { $p_Lcats_kernel_instances_ListEq__loop$3__sci_List__sci_List__Z as $p_Lcats_kernel_instances_ListEq__loop$3__sci_List__sci_List__Z };
/** @constructor */
function $c_Lcats_kernel_instances_ListEq(ev) {
  this.Lcats_kernel_instances_ListEq__f_ev = null;
  this.Lcats_kernel_instances_ListEq__f_ev = ev;
}
export { $c_Lcats_kernel_instances_ListEq as $c_Lcats_kernel_instances_ListEq };
$c_Lcats_kernel_instances_ListEq.prototype = new $h_O();
$c_Lcats_kernel_instances_ListEq.prototype.constructor = $c_Lcats_kernel_instances_ListEq;
/** @constructor */
function $h_Lcats_kernel_instances_ListEq() {
}
export { $h_Lcats_kernel_instances_ListEq as $h_Lcats_kernel_instances_ListEq };
$h_Lcats_kernel_instances_ListEq.prototype = $c_Lcats_kernel_instances_ListEq.prototype;
$c_Lcats_kernel_instances_ListEq.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_ListEq.prototype.eqv__sci_List__sci_List__Z = (function(xs, ys) {
  return ((xs === ys) || $p_Lcats_kernel_instances_ListEq__loop$3__sci_List__sci_List__Z(this, xs, ys));
});
$c_Lcats_kernel_instances_ListEq.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__sci_List__sci_List__Z(x, y);
});
var $d_Lcats_kernel_instances_ListEq = new $TypeData().initClass($c_Lcats_kernel_instances_ListEq, "cats.kernel.instances.ListEq", ({
  Lcats_kernel_instances_ListEq: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1
}));
export { $d_Lcats_kernel_instances_ListEq as $d_Lcats_kernel_instances_ListEq };
/** @constructor */
function $c_Lcats_package$$anon$2() {
  $m_Lcats_package$();
}
export { $c_Lcats_package$$anon$2 as $c_Lcats_package$$anon$2 };
$c_Lcats_package$$anon$2.prototype = new $h_O();
$c_Lcats_package$$anon$2.prototype.constructor = $c_Lcats_package$$anon$2;
/** @constructor */
function $h_Lcats_package$$anon$2() {
}
export { $h_Lcats_package$$anon$2 as $h_Lcats_package$$anon$2 };
$h_Lcats_package$$anon$2.prototype = $c_Lcats_package$$anon$2.prototype;
var $d_Lcats_package$$anon$2 = new $TypeData().initClass($c_Lcats_package$$anon$2, "cats.package$$anon$2", ({
  Lcats_package$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Representable: 1
}));
export { $d_Lcats_package$$anon$2 as $d_Lcats_package$$anon$2 };
/** @constructor */
function $c_Lcats_package$$anon$3() {
  $m_Lcats_package$();
}
export { $c_Lcats_package$$anon$3 as $c_Lcats_package$$anon$3 };
$c_Lcats_package$$anon$3.prototype = new $h_O();
$c_Lcats_package$$anon$3.prototype.constructor = $c_Lcats_package$$anon$3;
/** @constructor */
function $h_Lcats_package$$anon$3() {
}
export { $h_Lcats_package$$anon$3 as $h_Lcats_package$$anon$3 };
$h_Lcats_package$$anon$3.prototype = $c_Lcats_package$$anon$3.prototype;
var $d_Lcats_package$$anon$3 = new $TypeData().initClass($c_Lcats_package$$anon$3, "cats.package$$anon$3", ({
  Lcats_package$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_package$$anon$3 as $d_Lcats_package$$anon$3 };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4() {
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4 as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4 };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4.prototype = new $h_O();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4 as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4 };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4.prototype;
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4.prototype.decodeValue__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__O__O = (function(in$1, default$1) {
  var x = in$1.readInt__Z__I(false);
  if (in$1.hasRemaining__Z()) {
    in$1.decodeError__T__E("expected '\"'");
  }
  return x;
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4.prototype.nullValue__O = (function() {
  return 0;
});
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4 = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4, "com.github.plokhotnyuk.jsoniter_scala.circe.CirceCodecs$$anon$4", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonValueCodec: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4 as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$4 };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5() {
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5 as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5 };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5.prototype = new $h_O();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5 as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5 };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5.prototype;
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5.prototype.decodeValue__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__O__O = (function(in$1, default$1) {
  var t = $uJ(default$1);
  var t$1 = in$1.readLong__Z__J(false);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if (in$1.hasRemaining__Z()) {
    in$1.decodeError__T__E("expected '\"'");
  }
  return new $c_RTLong(lo$1, hi$1);
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5.prototype.nullValue__O = (function() {
  return $L0;
});
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5 = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5, "com.github.plokhotnyuk.jsoniter_scala.circe.CirceCodecs$$anon$5", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonValueCodec: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5 as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$5 };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7() {
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7 as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7 };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7.prototype = new $h_O();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7 as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7 };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7.prototype;
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7.prototype.decodeValue__Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReader__O__O = (function(in$1, default$1) {
  var x = in$1.readDouble__Z__D(false);
  if (in$1.hasRemaining__Z()) {
    in$1.decodeError__T__E("expected '\"'");
  }
  return x;
});
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7.prototype.nullValue__O = (function() {
  return 0.0;
});
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7 = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7, "com.github.plokhotnyuk.jsoniter_scala.circe.CirceCodecs$$anon$7", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7: 1,
  Ljava_io_Serializable: 1,
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonValueCodec: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7 as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$$anon$7 };
/** @constructor */
function $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$() {
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_indentionStep = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_preferredBufSize = 0;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_escapeUnicode = false;
  this.Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__f_throwWriterExceptionWithStackTrace = false;
  $ct_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig__I__I__Z__Z__(this, 0, 32768, false, false);
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$ as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$ };
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$.prototype = new $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig();
$c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$.prototype.constructor = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$;
/** @constructor */
function $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$() {
}
export { $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$ as $h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$ };
$h_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$.prototype = $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$.prototype;
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$ = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$, "com.github.plokhotnyuk.jsoniter_scala.core.WriterConfig$", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$: 1,
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$ as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$ };
var $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$;
function $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$() {
  if ((!$n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$)) {
    $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$ = new $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$();
  }
  return $n_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$;
}
export { $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$ as $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_WriterConfig$ };
class $c_Lcom_raquo_airstream_core_AirstreamError extends $c_jl_Throwable {
}
export { $c_Lcom_raquo_airstream_core_AirstreamError as $c_Lcom_raquo_airstream_core_AirstreamError };
/** @constructor */
function $c_Lcom_raquo_airstream_core_AirstreamError$() {
  this.Lcom_raquo_airstream_core_AirstreamError$__f_unhandledErrorCallbacks = null;
  this.Lcom_raquo_airstream_core_AirstreamError$__f_consoleErrorCallback = null;
  this.Lcom_raquo_airstream_core_AirstreamError$__f_debuggerErrorCallback = null;
  this.Lcom_raquo_airstream_core_AirstreamError$__f_unsafeRethrowErrorCallback = null;
  $n_Lcom_raquo_airstream_core_AirstreamError$ = this;
  this.Lcom_raquo_airstream_core_AirstreamError$__f_unhandledErrorCallbacks = $m_scm_Buffer$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_F1.getArrayOf().constr)([])));
  this.Lcom_raquo_airstream_core_AirstreamError$__f_consoleErrorCallback = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((err) => {
    try {
      console.error(((this.getFullMessage__jl_Throwable__T(err) + "\n") + this.getStackTrace__jl_Throwable__T__T(err, "\n")));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      console.error("Error in AirstreamError.consoleErrorCallback:");
      console.error(e$2);
    }
  }));
  this.Lcom_raquo_airstream_core_AirstreamError$__f_debuggerErrorCallback = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    debugger;
  }));
  this.Lcom_raquo_airstream_core_AirstreamError$__f_unsafeRethrowErrorCallback = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((err$2) => {
    console.warn("Using unsafe rethrow error callback. Note: other registered error callbacks might not run. Use with caution.");
    var $x_1 = err$2;
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
  }));
  this.registerUnhandledErrorCallback__F1__V(this.Lcom_raquo_airstream_core_AirstreamError$__f_consoleErrorCallback);
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$ as $c_Lcom_raquo_airstream_core_AirstreamError$ };
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype.constructor = $c_Lcom_raquo_airstream_core_AirstreamError$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_AirstreamError$() {
}
export { $h_Lcom_raquo_airstream_core_AirstreamError$ as $h_Lcom_raquo_airstream_core_AirstreamError$ };
$h_Lcom_raquo_airstream_core_AirstreamError$.prototype = $c_Lcom_raquo_airstream_core_AirstreamError$.prototype;
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype.getFullMessage__jl_Throwable__T = (function(e) {
  try {
    var errorMessage = e.getMessage__T();
  } catch (e$2) {
    var errorMessage = "(Unable to get the message for this error - exception occurred in its getMessage)";
  }
  return (($objectGetClass(e).getSimpleName__T() + ": ") + errorMessage);
});
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype.getStackTrace__jl_Throwable__T__T = (function(err, newline) {
  try {
    var this$1 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(err.getStackTrace__Ajl_StackTraceElement());
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", newline, "");
  } catch (e) {
    return "(Unable to get the stacktrace for this error - exception occurred in its getStackTrace)";
  }
});
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype.com$raquo$airstream$core$AirstreamError$$$VarError$superArg$1__T__s_Option__T = (function(message, cause) {
  if (cause.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = cause.get__O();
    var $x_1 = new $c_s_Some($m_Lcom_raquo_airstream_core_AirstreamError$().getFullMessage__jl_Throwable__T(x0));
  }
  return ((message + "; cause: ") + $x_1);
});
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype.com$raquo$airstream$core$AirstreamError$$$CombinedError$superArg$1__sci_Seq__T = (function(causes) {
  var this$2 = $m_s_$less$colon$less$();
  var this$3 = causes.flatten__F1__O(this$2.s_$less$colon$less$__f_singleton).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e) => $m_Lcom_raquo_airstream_core_AirstreamError$().getFullMessage__jl_Throwable__T(e))));
  return ("CombinedError: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", "; ", ""));
});
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype.com$raquo$airstream$core$AirstreamError$$$DebugError$superArg$1__jl_Throwable__s_Option__T = (function(error, cause) {
  var $x_2 = this.getFullMessage__jl_Throwable__T(error);
  if (cause.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = cause.get__O();
    var $x_1 = new $c_s_Some($m_Lcom_raquo_airstream_core_AirstreamError$().getFullMessage__jl_Throwable__T(x0));
  }
  return ((("DebugError: " + $x_2) + "; cause: ") + $x_1);
});
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype.registerUnhandledErrorCallback__F1__V = (function(fn) {
  var this$1 = this.Lcom_raquo_airstream_core_AirstreamError$__f_unhandledErrorCallbacks;
  this$1.addOne__O__scm_Growable(fn);
});
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype.unregisterUnhandledErrorCallback__F1__V = (function(fn) {
  var this$1 = this.Lcom_raquo_airstream_core_AirstreamError$__f_unhandledErrorCallbacks;
  var ix = this$1.indexOf__O__I__I(fn, 0);
  if ((ix >= 0)) {
    this.Lcom_raquo_airstream_core_AirstreamError$__f_unhandledErrorCallbacks.remove__I__O(ix);
  } else {
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "This function is not currently registered as unhandled error callback. Make sure you're not accidentally creating a new function value when calling this.");
  }
});
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype.sendUnhandledError__jl_Throwable__V = (function(err) {
  var this$1 = this.Lcom_raquo_airstream_core_AirstreamError$__f_unhandledErrorCallbacks;
  var it = this$1.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var x0 = it.next__O();
    try {
      x0.apply__O__O(err);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      var x$2 = $m_Lcom_raquo_airstream_core_AirstreamError$().Lcom_raquo_airstream_core_AirstreamError$__f_unsafeRethrowErrorCallback;
      if (((x0 === null) ? (x$2 === null) : x0.equals__O__Z(x$2))) {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
      console.warn("Error processing an unhandled error callback:");
      $m_sjs_js_timers_package$().setTimeout__D__F0__sjs_js_timers_SetTimeoutHandle(0.0, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((e$2) => (() => {
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }))(e$2)));
    }
  }
});
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype.ordinal__Lcom_raquo_airstream_core_AirstreamError__I = (function(x$0) {
  if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$VarError)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError)) {
    return 1;
  }
  if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$CombinedError)) {
    return 2;
  }
  if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError)) {
    return 3;
  }
  if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError)) {
    return 4;
  }
  if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$DebugError)) {
    return 5;
  }
  if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded)) {
    return 6;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lcom_raquo_airstream_core_AirstreamError$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcom_raquo_airstream_core_AirstreamError__I(x);
});
var $d_Lcom_raquo_airstream_core_AirstreamError$ = new $TypeData().initClass($c_Lcom_raquo_airstream_core_AirstreamError$, "com.raquo.airstream.core.AirstreamError$", ({
  Lcom_raquo_airstream_core_AirstreamError$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$ as $d_Lcom_raquo_airstream_core_AirstreamError$ };
var $n_Lcom_raquo_airstream_core_AirstreamError$;
function $m_Lcom_raquo_airstream_core_AirstreamError$() {
  if ((!$n_Lcom_raquo_airstream_core_AirstreamError$)) {
    $n_Lcom_raquo_airstream_core_AirstreamError$ = new $c_Lcom_raquo_airstream_core_AirstreamError$();
  }
  return $n_Lcom_raquo_airstream_core_AirstreamError$;
}
export { $m_Lcom_raquo_airstream_core_AirstreamError$ as $m_Lcom_raquo_airstream_core_AirstreamError$ };
function $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V($thiz) {
  $thiz.isSafeToRemoveObserver_$eq__Z__V(true);
  $thiz.maybePendingObserverRemovals_$eq__O__V((void 0));
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V as $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V };
function $f_Lcom_raquo_airstream_core_BaseObservable__mapTo__F0__Lcom_raquo_airstream_core_Observable($thiz, value) {
  return $thiz.map__F1__Lcom_raquo_airstream_core_Observable(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => value.apply__O())));
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__mapTo__F0__Lcom_raquo_airstream_core_Observable as $f_Lcom_raquo_airstream_core_BaseObservable__mapTo__F0__Lcom_raquo_airstream_core_Observable };
function $f_Lcom_raquo_airstream_core_BaseObservable__mapToUnit__Lcom_raquo_airstream_core_Observable($thiz) {
  return $thiz.map__F1__Lcom_raquo_airstream_core_Observable(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => (void 0))));
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__mapToUnit__Lcom_raquo_airstream_core_Observable as $f_Lcom_raquo_airstream_core_BaseObservable__mapToUnit__Lcom_raquo_airstream_core_Observable };
function $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($thiz) {
  return $f_Lcom_raquo_airstream_core_BaseObservable__distinctByFn__F2__Lcom_raquo_airstream_core_Observable($thiz, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$17, _$18) => $m_sr_BoxesRunTime$().equals__O__O__Z(_$17, _$18))));
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable as $f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable };
function $f_Lcom_raquo_airstream_core_BaseObservable__distinctBy__F1__Lcom_raquo_airstream_core_Observable($thiz, key) {
  return $f_Lcom_raquo_airstream_core_BaseObservable__distinctByFn__F2__Lcom_raquo_airstream_core_Observable($thiz, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$19, _$20) => {
    var x = key.apply__O__O(_$19);
    var y = key.apply__O__O(_$20);
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  })));
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__distinctBy__F1__Lcom_raquo_airstream_core_Observable as $f_Lcom_raquo_airstream_core_BaseObservable__distinctBy__F1__Lcom_raquo_airstream_core_Observable };
function $f_Lcom_raquo_airstream_core_BaseObservable__distinctByFn__F2__Lcom_raquo_airstream_core_Observable($thiz, isSame) {
  return $thiz.distinctTry__F2__Lcom_raquo_airstream_core_Observable(new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => {
    if ((x$1 instanceof $c_s_util_Success)) {
      var prev = x$1.s_util_Success__f_value;
      if ((x$2 instanceof $c_s_util_Success)) {
        var next = x$2.s_util_Success__f_value;
        return (!(!isSame.apply__O__O__O(prev, next)));
      }
    }
    return false;
  })));
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__distinctByFn__F2__Lcom_raquo_airstream_core_Observable as $f_Lcom_raquo_airstream_core_BaseObservable__distinctByFn__F2__Lcom_raquo_airstream_core_Observable };
function $f_Lcom_raquo_airstream_core_BaseObservable__toWeakSignal__Lcom_raquo_airstream_core_Signal($thiz) {
  matchResult3: {
    var $x_1;
    if ($is_Lcom_raquo_airstream_core_EventStream($thiz)) {
      var project = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$24) => new $c_s_Some(_$24)));
      var this$2 = new $c_Lcom_raquo_airstream_misc_MapStream($thiz, project, $m_s_None$());
      var initial = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $m_s_None$()));
      var $x_1 = $f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal(this$2, initial, true);
      break matchResult3;
    }
    if ($is_Lcom_raquo_airstream_core_Signal($thiz)) {
      var project$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$26) => new $c_s_Some(_$26)));
      var $x_1 = $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), $thiz, project$1, $m_s_None$());
      break matchResult3;
    }
    throw $ct_jl_Exception__T__(new $c_jl_Exception(), "All Observables must extend EventStream or Signal");
  }
  return $x_1;
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__toWeakSignal__Lcom_raquo_airstream_core_Signal as $f_Lcom_raquo_airstream_core_BaseObservable__toWeakSignal__Lcom_raquo_airstream_core_Signal };
function $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz, onNext, owner) {
  var this$1 = $m_Lcom_raquo_airstream_core_Observer$();
  var observer = this$1.withRecover__F1__s_PartialFunction__Z__Lcom_raquo_airstream_core_Observer(onNext, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf, true);
  return $f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz, observer, owner);
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription as $f_Lcom_raquo_airstream_core_BaseObservable__foreach__F1__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription };
function $f_Lcom_raquo_airstream_core_BaseObservable__removeExternalObserver__Lcom_raquo_airstream_core_Observer__V($thiz, observer) {
  if ($thiz.isSafeToRemoveObserver__Z()) {
    $f_Lcom_raquo_airstream_core_WritableObservable__removeExternalObserverNow__Lcom_raquo_airstream_core_Observer__V($thiz, observer);
  } else {
    $f_Lcom_raquo_airstream_core_BaseObservable__getOrCreatePendingObserverRemovals__Lcom_raquo_ew_JsArray($thiz).push(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      $f_Lcom_raquo_airstream_core_WritableObservable__removeExternalObserverNow__Lcom_raquo_airstream_core_Observer__V($thiz, observer);
    })));
  }
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__removeExternalObserver__Lcom_raquo_airstream_core_Observer__V as $f_Lcom_raquo_airstream_core_BaseObservable__removeExternalObserver__Lcom_raquo_airstream_core_Observer__V };
function $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V($thiz, observer) {
  if ($thiz.isSafeToRemoveObserver__Z()) {
    $f_Lcom_raquo_airstream_core_WritableObservable__removeInternalObserverNow__Lcom_raquo_airstream_core_InternalObserver__V($thiz, observer);
  } else {
    $f_Lcom_raquo_airstream_core_BaseObservable__getOrCreatePendingObserverRemovals__Lcom_raquo_ew_JsArray($thiz).push(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      $f_Lcom_raquo_airstream_core_WritableObservable__removeInternalObserverNow__Lcom_raquo_airstream_core_InternalObserver__V($thiz, observer);
    })));
  }
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V as $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V };
function $f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz) {
  return ($f_Lcom_raquo_airstream_core_WritableObservable__numAllObservers__I($thiz) > 0);
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z as $f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z };
function $f_Lcom_raquo_airstream_core_BaseObservable__getOrCreatePendingObserverRemovals__Lcom_raquo_ew_JsArray($thiz) {
  var x = $thiz.maybePendingObserverRemovals__O();
  if ((x === (void 0))) {
    var newArray = $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_F0.getArrayOf().constr)([])));
    $thiz.maybePendingObserverRemovals_$eq__O__V(newArray);
    return newArray;
  } else {
    return x;
  }
}
export { $f_Lcom_raquo_airstream_core_BaseObservable__getOrCreatePendingObserverRemovals__Lcom_raquo_ew_JsArray as $f_Lcom_raquo_airstream_core_BaseObservable__getOrCreatePendingObserverRemovals__Lcom_raquo_ew_JsArray };
function $f_Lcom_raquo_airstream_core_Observer__contramap__F1__Lcom_raquo_airstream_core_Observer($thiz, project) {
  return $m_Lcom_raquo_airstream_core_Observer$().withRecover__F1__s_PartialFunction__Z__Lcom_raquo_airstream_core_Observer(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextValue) => {
    $thiz.onNext__O__V(project.apply__O__O(nextValue));
  })), new $c_Lcom_raquo_airstream_core_Observer$$anon$1($thiz), ($m_Lcom_raquo_airstream_core_Observer$(), true));
}
export { $f_Lcom_raquo_airstream_core_Observer__contramap__F1__Lcom_raquo_airstream_core_Observer as $f_Lcom_raquo_airstream_core_Observer__contramap__F1__Lcom_raquo_airstream_core_Observer };
function $f_Lcom_raquo_airstream_core_Observer__contramapSome__s_$less$colon$less__Lcom_raquo_airstream_core_Observer($thiz, evidence) {
  return $f_Lcom_raquo_airstream_core_Observer__contramap__F1__Lcom_raquo_airstream_core_Observer($thiz, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => {
    var x = new $c_s_Some(value);
    return x;
  })));
}
export { $f_Lcom_raquo_airstream_core_Observer__contramapSome__s_$less$colon$less__Lcom_raquo_airstream_core_Observer as $f_Lcom_raquo_airstream_core_Observer__contramapSome__s_$less$colon$less__Lcom_raquo_airstream_core_Observer };
var $d_Lcom_raquo_airstream_core_Observer = new $TypeData().initClass(1, "com.raquo.airstream.core.Observer", ({
  Lcom_raquo_airstream_core_Observer: 1,
  Lcom_raquo_airstream_core_Sink: 1,
  Lcom_raquo_airstream_core_Named: 1
}));
export { $d_Lcom_raquo_airstream_core_Observer as $d_Lcom_raquo_airstream_core_Observer };
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_OneTimeOwner(onAccessAfterKilled) {
  this.Lcom_raquo_airstream_ownership_OneTimeOwner__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_ownership_OneTimeOwner__f_subscriptions = null;
  this.Lcom_raquo_airstream_ownership_OneTimeOwner__f_onAccessAfterKilled = null;
  this.Lcom_raquo_airstream_ownership_OneTimeOwner__f__isKilledForever = false;
  this.Lcom_raquo_airstream_ownership_OneTimeOwner__f_onAccessAfterKilled = onAccessAfterKilled;
  this.Lcom_raquo_airstream_ownership_OneTimeOwner__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_ownership_Owner__$init$__V(this);
  this.Lcom_raquo_airstream_ownership_OneTimeOwner__f__isKilledForever = false;
}
export { $c_Lcom_raquo_airstream_ownership_OneTimeOwner as $c_Lcom_raquo_airstream_ownership_OneTimeOwner };
$c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype = new $h_O();
$c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype.constructor = $c_Lcom_raquo_airstream_ownership_OneTimeOwner;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_OneTimeOwner() {
}
export { $h_Lcom_raquo_airstream_ownership_OneTimeOwner as $h_Lcom_raquo_airstream_ownership_OneTimeOwner };
$h_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype = $c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype;
$c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_ownership_OneTimeOwner__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_ownership_OneTimeOwner__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype.subscriptions__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_ownership_OneTimeOwner__f_subscriptions;
});
$c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype.com$raquo$airstream$ownership$Owner$_setter_$subscriptions_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_ownership_OneTimeOwner__f_subscriptions = x$0;
});
$c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype.own__Lcom_raquo_airstream_ownership_Subscription__V = (function(subscription) {
  if (this.Lcom_raquo_airstream_ownership_OneTimeOwner__f__isKilledForever) {
    $p_Lcom_raquo_airstream_ownership_Subscription__safeCleanup__V(subscription);
    this.Lcom_raquo_airstream_ownership_OneTimeOwner__f_onAccessAfterKilled.apply__O();
  } else {
    $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V(this, subscription);
  }
});
$c_Lcom_raquo_airstream_ownership_OneTimeOwner.prototype.killSubscriptions__V = (function() {
  $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V(this);
  this.Lcom_raquo_airstream_ownership_OneTimeOwner__f__isKilledForever = true;
});
var $d_Lcom_raquo_airstream_ownership_OneTimeOwner = new $TypeData().initClass($c_Lcom_raquo_airstream_ownership_OneTimeOwner, "com.raquo.airstream.ownership.OneTimeOwner", ({
  Lcom_raquo_airstream_ownership_OneTimeOwner: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_ownership_Owner: 1
}));
export { $d_Lcom_raquo_airstream_ownership_OneTimeOwner as $d_Lcom_raquo_airstream_ownership_OneTimeOwner };
/** @constructor */
function $c_Lcom_raquo_laminar_api_Laminar$$anon$1() {
  this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onFocus$lzy1 = null;
  this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onFocusbitmap$1 = false;
  this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onDomContentLoaded$lzy1 = null;
  this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onDomContentLoadedbitmap$1 = false;
  this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onVisibilityChange$lzy1 = null;
  this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onVisibilityChangebitmap$1 = false;
}
export { $c_Lcom_raquo_laminar_api_Laminar$$anon$1 as $c_Lcom_raquo_laminar_api_Laminar$$anon$1 };
$c_Lcom_raquo_laminar_api_Laminar$$anon$1.prototype = new $h_O();
$c_Lcom_raquo_laminar_api_Laminar$$anon$1.prototype.constructor = $c_Lcom_raquo_laminar_api_Laminar$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Laminar$$anon$1() {
}
export { $h_Lcom_raquo_laminar_api_Laminar$$anon$1 as $h_Lcom_raquo_laminar_api_Laminar$$anon$1 };
$h_Lcom_raquo_laminar_api_Laminar$$anon$1.prototype = $c_Lcom_raquo_laminar_api_Laminar$$anon$1.prototype;
$c_Lcom_raquo_laminar_api_Laminar$$anon$1.prototype.onFocus__Lcom_raquo_laminar_keys_EventProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onFocusbitmap$1)) {
    this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onFocus$lzy1 = new $c_Lcom_raquo_laminar_keys_EventProp("focus");
    this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onFocusbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onFocus$lzy1;
});
$c_Lcom_raquo_laminar_api_Laminar$$anon$1.prototype.onDomContentLoaded__Lcom_raquo_laminar_keys_EventProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onDomContentLoadedbitmap$1)) {
    this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onDomContentLoaded$lzy1 = new $c_Lcom_raquo_laminar_keys_EventProp("DOMContentLoaded");
    this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onDomContentLoadedbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onDomContentLoaded$lzy1;
});
$c_Lcom_raquo_laminar_api_Laminar$$anon$1.prototype.onVisibilityChange__Lcom_raquo_laminar_keys_EventProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onVisibilityChangebitmap$1)) {
    this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onVisibilityChange$lzy1 = new $c_Lcom_raquo_laminar_keys_EventProp("visibilitychange");
    this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onVisibilityChangebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_Laminar$$anon$1__f_onVisibilityChange$lzy1;
});
var $d_Lcom_raquo_laminar_api_Laminar$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_laminar_api_Laminar$$anon$1, "com.raquo.laminar.api.Laminar$$anon$1", ({
  Lcom_raquo_laminar_api_Laminar$$anon$1: 1,
  Lcom_raquo_laminar_defs_eventProps_GlobalEventProps: 1,
  Lcom_raquo_laminar_defs_eventProps_DocumentEventProps: 1
}));
export { $d_Lcom_raquo_laminar_api_Laminar$$anon$1 as $d_Lcom_raquo_laminar_api_Laminar$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_laminar_api_Laminar$$anon$2() {
  this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onFocus$lzy2 = null;
  this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onFocusbitmap$2 = false;
  this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onPopState$lzy1 = null;
  this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onPopStatebitmap$1 = false;
}
export { $c_Lcom_raquo_laminar_api_Laminar$$anon$2 as $c_Lcom_raquo_laminar_api_Laminar$$anon$2 };
$c_Lcom_raquo_laminar_api_Laminar$$anon$2.prototype = new $h_O();
$c_Lcom_raquo_laminar_api_Laminar$$anon$2.prototype.constructor = $c_Lcom_raquo_laminar_api_Laminar$$anon$2;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Laminar$$anon$2() {
}
export { $h_Lcom_raquo_laminar_api_Laminar$$anon$2 as $h_Lcom_raquo_laminar_api_Laminar$$anon$2 };
$h_Lcom_raquo_laminar_api_Laminar$$anon$2.prototype = $c_Lcom_raquo_laminar_api_Laminar$$anon$2.prototype;
$c_Lcom_raquo_laminar_api_Laminar$$anon$2.prototype.onFocus__Lcom_raquo_laminar_keys_EventProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onFocusbitmap$2)) {
    this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onFocus$lzy2 = new $c_Lcom_raquo_laminar_keys_EventProp("focus");
    this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onFocusbitmap$2 = true;
  }
  return this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onFocus$lzy2;
});
$c_Lcom_raquo_laminar_api_Laminar$$anon$2.prototype.onPopState__Lcom_raquo_laminar_keys_EventProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onPopStatebitmap$1)) {
    this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onPopState$lzy1 = new $c_Lcom_raquo_laminar_keys_EventProp("popstate");
    this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onPopStatebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_Laminar$$anon$2__f_onPopState$lzy1;
});
var $d_Lcom_raquo_laminar_api_Laminar$$anon$2 = new $TypeData().initClass($c_Lcom_raquo_laminar_api_Laminar$$anon$2, "com.raquo.laminar.api.Laminar$$anon$2", ({
  Lcom_raquo_laminar_api_Laminar$$anon$2: 1,
  Lcom_raquo_laminar_defs_eventProps_GlobalEventProps: 1,
  Lcom_raquo_laminar_defs_eventProps_WindowEventProps: 1
}));
export { $d_Lcom_raquo_laminar_api_Laminar$$anon$2 as $d_Lcom_raquo_laminar_api_Laminar$$anon$2 };
/** @constructor */
function $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$(outer) {
  this.Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$__f_maybeDisplayName = null;
  this.Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$__f_subscriptions = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_ownership_Owner__$init$__V(this);
}
export { $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ as $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ };
$c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype = new $h_O();
$c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype.constructor = $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$() {
}
export { $h_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ as $h_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ };
$h_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype = $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype;
$c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$__f_maybeDisplayName;
});
$c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype.subscriptions__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$__f_subscriptions;
});
$c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype.com$raquo$airstream$ownership$Owner$_setter_$subscriptions_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$__f_subscriptions = x$0;
});
$c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype.killSubscriptions__V = (function() {
  $f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V(this);
});
$c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype.own__Lcom_raquo_airstream_ownership_Subscription__V = (function(subscription) {
  $f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V(this, subscription);
});
var $d_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ = new $TypeData().initClass($c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$, "com.raquo.laminar.api.Laminar$unsafeWindowOwner$", ({
  Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_ownership_Owner: 1
}));
export { $d_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ as $d_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ };
/** @constructor */
function $c_Lcom_raquo_laminar_domapi_DomApi$raw$() {
}
export { $c_Lcom_raquo_laminar_domapi_DomApi$raw$ as $c_Lcom_raquo_laminar_domapi_DomApi$raw$ };
$c_Lcom_raquo_laminar_domapi_DomApi$raw$.prototype = new $h_O();
$c_Lcom_raquo_laminar_domapi_DomApi$raw$.prototype.constructor = $c_Lcom_raquo_laminar_domapi_DomApi$raw$;
/** @constructor */
function $h_Lcom_raquo_laminar_domapi_DomApi$raw$() {
}
export { $h_Lcom_raquo_laminar_domapi_DomApi$raw$ as $h_Lcom_raquo_laminar_domapi_DomApi$raw$ };
$h_Lcom_raquo_laminar_domapi_DomApi$raw$.prototype = $c_Lcom_raquo_laminar_domapi_DomApi$raw$.prototype;
var $d_Lcom_raquo_laminar_domapi_DomApi$raw$ = new $TypeData().initClass($c_Lcom_raquo_laminar_domapi_DomApi$raw$, "com.raquo.laminar.domapi.DomApi$raw$", ({
  Lcom_raquo_laminar_domapi_DomApi$raw$: 1,
  Lcom_raquo_laminar_domapi_DomTreeRaw: 1,
  Lcom_raquo_laminar_domapi_DomKeysRaw: 1
}));
export { $d_Lcom_raquo_laminar_domapi_DomApi$raw$ as $d_Lcom_raquo_laminar_domapi_DomApi$raw$ };
var $n_Lcom_raquo_laminar_domapi_DomApi$raw$;
function $m_Lcom_raquo_laminar_domapi_DomApi$raw$() {
  if ((!$n_Lcom_raquo_laminar_domapi_DomApi$raw$)) {
    $n_Lcom_raquo_laminar_domapi_DomApi$raw$ = new $c_Lcom_raquo_laminar_domapi_DomApi$raw$();
  }
  return $n_Lcom_raquo_laminar_domapi_DomApi$raw$;
}
export { $m_Lcom_raquo_laminar_domapi_DomApi$raw$ as $m_Lcom_raquo_laminar_domapi_DomApi$raw$ };
function $is_Lcom_raquo_laminar_inserters_StaticInserter(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_raquo_laminar_inserters_StaticInserter)));
}
export { $is_Lcom_raquo_laminar_inserters_StaticInserter as $is_Lcom_raquo_laminar_inserters_StaticInserter };
function $isArrayOf_Lcom_raquo_laminar_inserters_StaticInserter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_laminar_inserters_StaticInserter)));
}
export { $isArrayOf_Lcom_raquo_laminar_inserters_StaticInserter as $isArrayOf_Lcom_raquo_laminar_inserters_StaticInserter };
function $ct_Lcom_raquo_laminar_keys_GlobalAttr__T__Lcom_raquo_laminar_codecs_Codec__($thiz, name, codec) {
  $thiz.Lcom_raquo_laminar_keys_GlobalAttr__f_name = name;
  $thiz.Lcom_raquo_laminar_keys_GlobalAttr__f_codec = codec;
  $thiz.Lcom_raquo_laminar_keys_GlobalAttr__f_namespaceUri = $m_s_None$();
  return $thiz;
}
export { $ct_Lcom_raquo_laminar_keys_GlobalAttr__T__Lcom_raquo_laminar_codecs_Codec__ as $ct_Lcom_raquo_laminar_keys_GlobalAttr__T__Lcom_raquo_laminar_codecs_Codec__ };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_GlobalAttr() {
  this.Lcom_raquo_laminar_keys_GlobalAttr__f_namespaceUri = null;
  this.Lcom_raquo_laminar_keys_GlobalAttr__f_name = null;
  this.Lcom_raquo_laminar_keys_GlobalAttr__f_codec = null;
}
export { $c_Lcom_raquo_laminar_keys_GlobalAttr as $c_Lcom_raquo_laminar_keys_GlobalAttr };
$c_Lcom_raquo_laminar_keys_GlobalAttr.prototype = new $h_O();
$c_Lcom_raquo_laminar_keys_GlobalAttr.prototype.constructor = $c_Lcom_raquo_laminar_keys_GlobalAttr;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_GlobalAttr() {
}
export { $h_Lcom_raquo_laminar_keys_GlobalAttr as $h_Lcom_raquo_laminar_keys_GlobalAttr };
$h_Lcom_raquo_laminar_keys_GlobalAttr.prototype = $c_Lcom_raquo_laminar_keys_GlobalAttr.prototype;
$c_Lcom_raquo_laminar_keys_GlobalAttr.prototype.namespaceUri__s_Option = (function() {
  return this.Lcom_raquo_laminar_keys_GlobalAttr__f_namespaceUri;
});
$c_Lcom_raquo_laminar_keys_GlobalAttr.prototype.name__T = (function() {
  return this.Lcom_raquo_laminar_keys_GlobalAttr__f_name;
});
$c_Lcom_raquo_laminar_keys_GlobalAttr.prototype.codec__Lcom_raquo_laminar_codecs_Codec = (function() {
  return this.Lcom_raquo_laminar_keys_GlobalAttr__f_codec;
});
var $d_Lcom_raquo_laminar_keys_GlobalAttr = new $TypeData().initClass($c_Lcom_raquo_laminar_keys_GlobalAttr, "com.raquo.laminar.keys.GlobalAttr", ({
  Lcom_raquo_laminar_keys_GlobalAttr: 1,
  Lcom_raquo_laminar_keys_SimpleKey: 1,
  Lcom_raquo_laminar_keys_SimpleAttr: 1
}));
export { $d_Lcom_raquo_laminar_keys_GlobalAttr as $d_Lcom_raquo_laminar_keys_GlobalAttr };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_HtmlAttr(name, codec) {
  this.Lcom_raquo_laminar_keys_HtmlAttr__f_namespaceUri = null;
  this.Lcom_raquo_laminar_keys_HtmlAttr__f_name = null;
  this.Lcom_raquo_laminar_keys_HtmlAttr__f_codec = null;
  this.Lcom_raquo_laminar_keys_HtmlAttr__f_name = name;
  this.Lcom_raquo_laminar_keys_HtmlAttr__f_codec = codec;
  this.Lcom_raquo_laminar_keys_HtmlAttr__f_namespaceUri = $m_s_None$();
}
export { $c_Lcom_raquo_laminar_keys_HtmlAttr as $c_Lcom_raquo_laminar_keys_HtmlAttr };
$c_Lcom_raquo_laminar_keys_HtmlAttr.prototype = new $h_O();
$c_Lcom_raquo_laminar_keys_HtmlAttr.prototype.constructor = $c_Lcom_raquo_laminar_keys_HtmlAttr;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_HtmlAttr() {
}
export { $h_Lcom_raquo_laminar_keys_HtmlAttr as $h_Lcom_raquo_laminar_keys_HtmlAttr };
$h_Lcom_raquo_laminar_keys_HtmlAttr.prototype = $c_Lcom_raquo_laminar_keys_HtmlAttr.prototype;
$c_Lcom_raquo_laminar_keys_HtmlAttr.prototype.namespaceUri__s_Option = (function() {
  return this.Lcom_raquo_laminar_keys_HtmlAttr__f_namespaceUri;
});
$c_Lcom_raquo_laminar_keys_HtmlAttr.prototype.name__T = (function() {
  return this.Lcom_raquo_laminar_keys_HtmlAttr__f_name;
});
$c_Lcom_raquo_laminar_keys_HtmlAttr.prototype.codec__Lcom_raquo_laminar_codecs_Codec = (function() {
  return this.Lcom_raquo_laminar_keys_HtmlAttr__f_codec;
});
var $d_Lcom_raquo_laminar_keys_HtmlAttr = new $TypeData().initClass($c_Lcom_raquo_laminar_keys_HtmlAttr, "com.raquo.laminar.keys.HtmlAttr", ({
  Lcom_raquo_laminar_keys_HtmlAttr: 1,
  Lcom_raquo_laminar_keys_SimpleKey: 1,
  Lcom_raquo_laminar_keys_SimpleAttr: 1
}));
export { $d_Lcom_raquo_laminar_keys_HtmlAttr as $d_Lcom_raquo_laminar_keys_HtmlAttr };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_HtmlProp$$anon$1(name$1, reflectedAttrName$1, _codec$1) {
  this.Lcom_raquo_laminar_keys_HtmlProp__f_name = null;
  this.Lcom_raquo_laminar_keys_HtmlProp__f_reflectedAttrName = null;
  this.Lcom_raquo_laminar_keys_HtmlProp$$anon$1__f_codec = null;
  $ct_Lcom_raquo_laminar_keys_HtmlProp__T__s_Option__(this, name$1, reflectedAttrName$1);
  this.Lcom_raquo_laminar_keys_HtmlProp$$anon$1__f_codec = _codec$1;
}
export { $c_Lcom_raquo_laminar_keys_HtmlProp$$anon$1 as $c_Lcom_raquo_laminar_keys_HtmlProp$$anon$1 };
$c_Lcom_raquo_laminar_keys_HtmlProp$$anon$1.prototype = new $h_Lcom_raquo_laminar_keys_HtmlProp();
$c_Lcom_raquo_laminar_keys_HtmlProp$$anon$1.prototype.constructor = $c_Lcom_raquo_laminar_keys_HtmlProp$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_HtmlProp$$anon$1() {
}
export { $h_Lcom_raquo_laminar_keys_HtmlProp$$anon$1 as $h_Lcom_raquo_laminar_keys_HtmlProp$$anon$1 };
$h_Lcom_raquo_laminar_keys_HtmlProp$$anon$1.prototype = $c_Lcom_raquo_laminar_keys_HtmlProp$$anon$1.prototype;
var $d_Lcom_raquo_laminar_keys_HtmlProp$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_laminar_keys_HtmlProp$$anon$1, "com.raquo.laminar.keys.HtmlProp$$anon$1", ({
  Lcom_raquo_laminar_keys_HtmlProp$$anon$1: 1,
  Lcom_raquo_laminar_keys_HtmlProp: 1,
  Lcom_raquo_laminar_keys_SimpleKey: 1
}));
export { $d_Lcom_raquo_laminar_keys_HtmlProp$$anon$1 as $d_Lcom_raquo_laminar_keys_HtmlProp$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1(fn$3) {
  this.Lcom_raquo_laminar_modifiers_Binder$$anon$1__f_fn$1 = null;
  this.Lcom_raquo_laminar_modifiers_Binder$$anon$1__f_fn$1 = fn$3;
}
export { $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1 as $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1 };
$c_Lcom_raquo_laminar_modifiers_Binder$$anon$1.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_Binder$$anon$1.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_Binder$$anon$1() {
}
export { $h_Lcom_raquo_laminar_modifiers_Binder$$anon$1 as $h_Lcom_raquo_laminar_modifiers_Binder$$anon$1 };
$h_Lcom_raquo_laminar_modifiers_Binder$$anon$1.prototype = $c_Lcom_raquo_laminar_modifiers_Binder$$anon$1.prototype;
$c_Lcom_raquo_laminar_modifiers_Binder$$anon$1.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(element) {
  this.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_airstream_ownership_DynamicSubscription(element);
});
$c_Lcom_raquo_laminar_modifiers_Binder$$anon$1.prototype.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(element) {
  return this.Lcom_raquo_laminar_modifiers_Binder$$anon$1__f_fn$1.apply__O__O(element);
});
var $d_Lcom_raquo_laminar_modifiers_Binder$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_Binder$$anon$1, "com.raquo.laminar.modifiers.Binder$$anon$1", ({
  Lcom_raquo_laminar_modifiers_Binder$$anon$1: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_modifiers_Binder: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_Binder$$anon$1 as $d_Lcom_raquo_laminar_modifiers_Binder$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter(key, itemsToAdd) {
  this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_key = null;
  this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_itemsToAdd = null;
  this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_key = key;
  this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_itemsToAdd = itemsToAdd;
}
export { $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter as $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter };
$c_Lcom_raquo_laminar_modifiers_CompositeKeySetter.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_CompositeKeySetter.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_CompositeKeySetter() {
}
export { $h_Lcom_raquo_laminar_modifiers_CompositeKeySetter as $h_Lcom_raquo_laminar_modifiers_CompositeKeySetter };
$h_Lcom_raquo_laminar_modifiers_CompositeKeySetter.prototype = $c_Lcom_raquo_laminar_modifiers_CompositeKeySetter.prototype;
$c_Lcom_raquo_laminar_modifiers_CompositeKeySetter.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(element) {
  var this$1 = this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_itemsToAdd;
  if ((!this$1.isEmpty__Z())) {
    $f_Lcom_raquo_laminar_nodes_ReactiveElement__updateCompositeValue__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List__sci_List__V(element, this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_key, null, this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_itemsToAdd, $m_sci_Nil$());
  }
});
$c_Lcom_raquo_laminar_modifiers_CompositeKeySetter.prototype.$colon$eq__Z__Lcom_raquo_laminar_modifiers_CompositeKeySetter = (function(include) {
  if (include) {
    var this$1 = this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_key;
    var items = this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_itemsToAdd;
    var mapper = $m_Lcom_raquo_laminar_api_package$().StringSeqValueMapper__Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$();
    return this$1.$colon$eq__sci_Seq__Lcom_raquo_laminar_keys_CompositeValueMapper__Lcom_raquo_laminar_modifiers_CompositeKeySetter(items, mapper);
  } else {
    var this$2 = this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_key;
    var items$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([]));
    var mapper$1 = $m_Lcom_raquo_laminar_api_package$().StringSeqValueMapper__Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$();
    return this$2.$colon$eq__sci_Seq__Lcom_raquo_laminar_keys_CompositeValueMapper__Lcom_raquo_laminar_modifiers_CompositeKeySetter(items$1, mapper$1);
  }
});
$c_Lcom_raquo_laminar_modifiers_CompositeKeySetter.prototype.$less$minus$minus__Lcom_raquo_airstream_core_Source__Lcom_raquo_laminar_modifiers_CompositeKeyUpdater = (function(include) {
  var this$2 = this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_key;
  var items = include.toObservable__Lcom_raquo_airstream_core_Observable().map__F1__Lcom_raquo_airstream_core_Observable(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((include$2) => {
    var include$1 = (!(!include$2));
    return (include$1 ? this.Lcom_raquo_laminar_modifiers_CompositeKeySetter__f_itemsToAdd : $m_sci_Nil$());
  })));
  var valueMapper = $m_Lcom_raquo_laminar_api_package$().StringSeqValueMapper__Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$();
  return new $c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater(this$2, items.toObservable__Lcom_raquo_airstream_core_Observable(), valueMapper);
});
var $d_Lcom_raquo_laminar_modifiers_CompositeKeySetter = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_CompositeKeySetter, "com.raquo.laminar.modifiers.CompositeKeySetter", ({
  Lcom_raquo_laminar_modifiers_CompositeKeySetter: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_modifiers_Setter: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_CompositeKeySetter as $d_Lcom_raquo_laminar_modifiers_CompositeKeySetter };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater(key, values, valueMapper) {
  this.Lcom_raquo_laminar_modifiers_CompositeKeyUpdater__f_key = null;
  this.Lcom_raquo_laminar_modifiers_CompositeKeyUpdater__f_values = null;
  this.Lcom_raquo_laminar_modifiers_CompositeKeyUpdater__f_valueMapper = null;
  this.Lcom_raquo_laminar_modifiers_CompositeKeyUpdater__f_key = key;
  this.Lcom_raquo_laminar_modifiers_CompositeKeyUpdater__f_values = values;
  this.Lcom_raquo_laminar_modifiers_CompositeKeyUpdater__f_valueMapper = valueMapper;
}
export { $c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater as $c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater };
$c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater() {
}
export { $h_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater as $h_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater };
$h_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater.prototype = $c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater.prototype;
$c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(element) {
  this.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_airstream_ownership_DynamicSubscription(element);
});
$c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater.prototype.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(element) {
  var observable = this.Lcom_raquo_laminar_modifiers_CompositeKeyUpdater__f_values;
  var onNext = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => {
    var currentNormalizedItems = $f_Lcom_raquo_laminar_nodes_ReactiveElement__compositeValueItems__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List(element, this.Lcom_raquo_laminar_modifiers_CompositeKeyUpdater__f_key, this);
    var nextNormalizedItems = this.Lcom_raquo_laminar_modifiers_CompositeKeyUpdater__f_valueMapper.toNormalizedList__O__T__sci_List(value, this.Lcom_raquo_laminar_modifiers_CompositeKeyUpdater__f_key.Lcom_raquo_laminar_keys_CompositeAttr__f_separator);
    var f = ((elem) => currentNormalizedItems.contains__O__Z(elem));
    var l = nextNormalizedItems;
    block: {
      var result;
      while (true) {
        if (l.isEmpty__Z()) {
          var result = $m_sci_Nil$();
          break;
        } else {
          var h = l.head__O();
          var t = l.tail__O();
          if (((!(!f(h))) === true)) {
            l = t;
            continue;
          }
          var start = l;
          var remaining = t;
          while (true) {
            if (remaining.isEmpty__Z()) {
              var result = start;
              break block;
            } else {
              var x = remaining.head__O();
              if (((!(!f(x))) !== true)) {
                remaining = remaining.tail__O();
                continue;
              }
              var firstMiss = remaining;
              var newHead = new $c_sci_$colon$colon(start.head__O(), $m_sci_Nil$());
              var toProcess = start.tail__O();
              var currentLast = newHead;
              while ((toProcess !== firstMiss)) {
                var newElem = new $c_sci_$colon$colon(toProcess.head__O(), $m_sci_Nil$());
                currentLast.sci_$colon$colon__f_next = newElem;
                currentLast = newElem;
                toProcess = toProcess.tail__O();
              }
              var next = firstMiss.tail__O();
              var nextToCopy = next;
              while ((!next.isEmpty__Z())) {
                var head = next.head__O();
                if (((!(!f(head))) !== true)) {
                  next = next.tail__O();
                } else {
                  while ((nextToCopy !== next)) {
                    var newElem$2 = new $c_sci_$colon$colon(nextToCopy.head__O(), $m_sci_Nil$());
                    currentLast.sci_$colon$colon__f_next = newElem$2;
                    currentLast = newElem$2;
                    nextToCopy = nextToCopy.tail__O();
                  }
                  nextToCopy = next.tail__O();
                  next = next.tail__O();
                }
              }
              if ((!nextToCopy.isEmpty__Z())) {
                currentLast.sci_$colon$colon__f_next = nextToCopy;
              }
              var result = newHead;
              break block;
            }
          }
        }
      }
    }
    var f$1 = ((elem$2) => nextNormalizedItems.contains__O__Z(elem$2));
    var l$1 = currentNormalizedItems;
    block$2: {
      var result$1;
      while (true) {
        if (l$1.isEmpty__Z()) {
          var result$1 = $m_sci_Nil$();
          break;
        } else {
          var h$1 = l$1.head__O();
          var t$1 = l$1.tail__O();
          if (((!(!f$1(h$1))) === true)) {
            l$1 = t$1;
            continue;
          }
          var start$1 = l$1;
          var remaining$1 = t$1;
          while (true) {
            if (remaining$1.isEmpty__Z()) {
              var result$1 = start$1;
              break block$2;
            } else {
              var x$1 = remaining$1.head__O();
              if (((!(!f$1(x$1))) !== true)) {
                remaining$1 = remaining$1.tail__O();
                continue;
              }
              var firstMiss$1 = remaining$1;
              var newHead$1 = new $c_sci_$colon$colon(start$1.head__O(), $m_sci_Nil$());
              var toProcess$1 = start$1.tail__O();
              var currentLast$1 = newHead$1;
              while ((toProcess$1 !== firstMiss$1)) {
                var newElem$1 = new $c_sci_$colon$colon(toProcess$1.head__O(), $m_sci_Nil$());
                currentLast$1.sci_$colon$colon__f_next = newElem$1;
                currentLast$1 = newElem$1;
                toProcess$1 = toProcess$1.tail__O();
              }
              var next$1 = firstMiss$1.tail__O();
              var nextToCopy$1 = next$1;
              while ((!next$1.isEmpty__Z())) {
                var head$1 = next$1.head__O();
                if (((!(!f$1(head$1))) !== true)) {
                  next$1 = next$1.tail__O();
                } else {
                  while ((nextToCopy$1 !== next$1)) {
                    var newElem$2$1 = new $c_sci_$colon$colon(nextToCopy$1.head__O(), $m_sci_Nil$());
                    currentLast$1.sci_$colon$colon__f_next = newElem$2$1;
                    currentLast$1 = newElem$2$1;
                    nextToCopy$1 = nextToCopy$1.tail__O();
                  }
                  nextToCopy$1 = next$1.tail__O();
                  next$1 = next$1.tail__O();
                }
              }
              if ((!nextToCopy$1.isEmpty__Z())) {
                currentLast$1.sci_$colon$colon__f_next = nextToCopy$1;
              }
              var result$1 = newHead$1;
              break block$2;
            }
          }
        }
      }
    }
    $f_Lcom_raquo_laminar_nodes_ReactiveElement__updateCompositeValue__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List__sci_List__V(element, this.Lcom_raquo_laminar_modifiers_CompositeKeyUpdater__f_key, this, result, result$1);
  }));
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().subscribeFn__Lcom_raquo_airstream_ownership_DynamicOwner__Lcom_raquo_airstream_core_Observable__F1__Lcom_raquo_airstream_ownership_DynamicSubscription(element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), observable, onNext);
});
var $d_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater, "com.raquo.laminar.modifiers.CompositeKeyUpdater", ({
  Lcom_raquo_laminar_modifiers_CompositeKeyUpdater: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_modifiers_Binder: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater as $d_Lcom_raquo_laminar_modifiers_CompositeKeyUpdater };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_EventListener(eventProcessor, callback) {
  this.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor = null;
  this.Lcom_raquo_laminar_modifiers_EventListener__f_callback = null;
  this.Lcom_raquo_laminar_modifiers_EventListener__f_domCallback = null;
  this.Lcom_raquo_laminar_modifiers_EventListener__f_options = null;
  this.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor = eventProcessor;
  this.Lcom_raquo_laminar_modifiers_EventListener__f_callback = callback;
  this.Lcom_raquo_laminar_modifiers_EventListener__f_domCallback = ((ev) => {
    var processor = eventProcessor.Lcom_raquo_laminar_keys_EventProcessor__f_processor;
    var this$2 = processor.apply__O__O(ev);
    if ((!this$2.isEmpty__Z())) {
      callback.apply__O__O(this$2.get__O());
    }
  });
  this.Lcom_raquo_laminar_modifiers_EventListener__f_options = (() => {
    var outer = null;
    outer = this;
    var this$3 = ({});
    if ((outer === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
    var prop = outer.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor;
    this$3.capture = prop.Lcom_raquo_laminar_keys_EventProcessor__f_shouldUseCapture;
    var prop$1 = outer.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor;
    this$3.passive = prop$1.Lcom_raquo_laminar_keys_EventProcessor__f_shouldBePassive;
    return this$3;
  })();
}
export { $c_Lcom_raquo_laminar_modifiers_EventListener as $c_Lcom_raquo_laminar_modifiers_EventListener };
$c_Lcom_raquo_laminar_modifiers_EventListener.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_EventListener.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_EventListener;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_EventListener() {
}
export { $h_Lcom_raquo_laminar_modifiers_EventListener as $h_Lcom_raquo_laminar_modifiers_EventListener };
$h_Lcom_raquo_laminar_modifiers_EventListener.prototype = $c_Lcom_raquo_laminar_modifiers_EventListener.prototype;
$c_Lcom_raquo_laminar_modifiers_EventListener.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(element) {
  this.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(element, false);
});
$c_Lcom_raquo_laminar_modifiers_EventListener.prototype.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(element) {
  return this.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(element, false);
});
$c_Lcom_raquo_laminar_modifiers_EventListener.prototype.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Z__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(element, unsafePrepend) {
  if (($f_Lcom_raquo_laminar_nodes_ReactiveElement__indexOfEventListener__Lcom_raquo_laminar_modifiers_EventListener__I(element, this) === (-1))) {
    var subscribe = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ctx) => {
      var this$2 = $m_Lcom_raquo_laminar_domapi_DomApi$();
      var element$1 = element.ref__Lorg_scalajs_dom_Node();
      $f_Lcom_raquo_laminar_domapi_DomEvents__addEventListener__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_modifiers_EventListener__V(this$2, element$1, this);
      return new $c_Lcom_raquo_airstream_ownership_Subscription(ctx.Lcom_raquo_laminar_lifecycle_MountContext__f_owner, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
        var listenerIndex = $f_Lcom_raquo_laminar_nodes_ReactiveElement__indexOfEventListener__Lcom_raquo_laminar_modifiers_EventListener__I(element, this);
        if ((listenerIndex !== (-1))) {
          $f_Lcom_raquo_laminar_nodes_ReactiveElement__removeEventListener__I__V(element, listenerIndex);
          var this$3 = $m_Lcom_raquo_laminar_domapi_DomApi$();
          var element$2 = element.ref__Lorg_scalajs_dom_Node();
          $f_Lcom_raquo_laminar_domapi_DomEvents__removeEventListener__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_modifiers_EventListener__V(this$3, element$2, this);
        }
      })));
    }));
    var sub = (unsafePrepend ? $m_Lcom_raquo_laminar_nodes_ReactiveElement$().unsafeBindPrependSubscription__Lcom_raquo_laminar_nodes_ReactiveElement__F1__Lcom_raquo_airstream_ownership_DynamicSubscription(element, subscribe) : $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().unsafe__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((owner) => subscribe.apply__O__O(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element, owner)))), false));
    $f_Lcom_raquo_laminar_nodes_ReactiveElement__addEventListener__Lcom_raquo_laminar_modifiers_EventListener__Z__V(element, this, unsafePrepend);
    return sub;
  } else {
    var activate = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => (void 0)));
    return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().subscribeCallback__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((owner$1) => {
      activate.apply__O__O(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element, owner$1));
    })), false);
  }
});
$c_Lcom_raquo_laminar_modifiers_EventListener.prototype.toString__T = (function() {
  var prop = this.Lcom_raquo_laminar_modifiers_EventListener__f_eventProcessor;
  return (("EventListener(" + prop.Lcom_raquo_laminar_keys_EventProcessor__f_eventProp.Lcom_raquo_laminar_keys_EventProp__f_name) + ")");
});
var $d_Lcom_raquo_laminar_modifiers_EventListener = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_EventListener, "com.raquo.laminar.modifiers.EventListener", ({
  Lcom_raquo_laminar_modifiers_EventListener: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_modifiers_Binder: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_EventListener as $d_Lcom_raquo_laminar_modifiers_EventListener };
function $ct_Lcom_raquo_laminar_modifiers_SimpleKeySetter__Lcom_raquo_laminar_keys_SimpleKey__O__F1__F1__($thiz, key, value, set, remove) {
  $thiz.Lcom_raquo_laminar_modifiers_SimpleKeySetter__f_set = set;
  return $thiz;
}
export { $ct_Lcom_raquo_laminar_modifiers_SimpleKeySetter__Lcom_raquo_laminar_keys_SimpleKey__O__F1__F1__ as $ct_Lcom_raquo_laminar_modifiers_SimpleKeySetter__Lcom_raquo_laminar_keys_SimpleKey__O__F1__F1__ };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter() {
  this.Lcom_raquo_laminar_modifiers_SimpleKeySetter__f_set = null;
}
export { $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter as $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter };
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter() {
}
export { $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter as $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter };
$h_Lcom_raquo_laminar_modifiers_SimpleKeySetter.prototype = $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter.prototype;
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(element) {
  this.Lcom_raquo_laminar_modifiers_SimpleKeySetter__f_set.apply__O__O(element);
});
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater(key, values, update) {
  this.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_key = null;
  this.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_values = null;
  this.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_update = null;
  this.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_key = key;
  this.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_values = values;
  this.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_update = update;
}
export { $c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater as $c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater };
$c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater.prototype = new $h_O();
$c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater() {
}
export { $h_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater as $h_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater };
$h_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater.prototype = $c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater.prototype;
$c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(element) {
  this.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_airstream_ownership_DynamicSubscription(element);
});
$c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater.prototype.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(element) {
  element.onBoundKeyUpdater__Lcom_raquo_laminar_keys_SimpleKey__V(this.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_key);
  var observable = this.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_values;
  var onNext = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => {
    this.Lcom_raquo_laminar_modifiers_SimpleKeyUpdater__f_update.apply__O__O__O(element, value);
  }));
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().subscribeFn__Lcom_raquo_airstream_ownership_DynamicOwner__Lcom_raquo_airstream_core_Observable__F1__Lcom_raquo_airstream_ownership_DynamicSubscription(element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), observable, onNext);
});
var $d_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater, "com.raquo.laminar.modifiers.SimpleKeyUpdater", ({
  Lcom_raquo_laminar_modifiers_SimpleKeyUpdater: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_modifiers_Binder: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater as $d_Lcom_raquo_laminar_modifiers_SimpleKeyUpdater };
function $isArrayOf_Lcom_raquo_laminar_tags_CustomHtmlTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_laminar_tags_CustomHtmlTag)));
}
export { $isArrayOf_Lcom_raquo_laminar_tags_CustomHtmlTag as $isArrayOf_Lcom_raquo_laminar_tags_CustomHtmlTag };
function $s_Lframework_components_TextKind$__SingleLine__Lframework_components_TextKind() {
  $m_Lframework_components_TextKind$();
  return $t_Lframework_components_TextKind$__SingleLine;
}
export { $s_Lframework_components_TextKind$__SingleLine__Lframework_components_TextKind as $s_Lframework_components_TextKind$__SingleLine__Lframework_components_TextKind };
function $s_Lframework_components_TextKind$__MultiLine__Lframework_components_TextKind() {
  $m_Lframework_components_TextKind$();
  return $t_Lframework_components_TextKind$__MultiLine;
}
export { $s_Lframework_components_TextKind$__MultiLine__Lframework_components_TextKind as $s_Lframework_components_TextKind$__MultiLine__Lframework_components_TextKind };
/** @constructor */
function $c_Lframework_components_TextKind$() {
  $n_Lframework_components_TextKind$ = this;
  $t_Lframework_components_TextKind$__SingleLine = new $c_Lframework_components_TextKind$$anon$1("SingleLine", 0);
  $t_Lframework_components_TextKind$__MultiLine = new $c_Lframework_components_TextKind$$anon$1("MultiLine", 1);
  $s_Lframework_components_TextKind$__SingleLine__Lframework_components_TextKind();
  $s_Lframework_components_TextKind$__MultiLine__Lframework_components_TextKind();
}
export { $c_Lframework_components_TextKind$ as $c_Lframework_components_TextKind$ };
$c_Lframework_components_TextKind$.prototype = new $h_O();
$c_Lframework_components_TextKind$.prototype.constructor = $c_Lframework_components_TextKind$;
/** @constructor */
function $h_Lframework_components_TextKind$() {
}
export { $h_Lframework_components_TextKind$ as $h_Lframework_components_TextKind$ };
$h_Lframework_components_TextKind$.prototype = $c_Lframework_components_TextKind$.prototype;
$c_Lframework_components_TextKind$.prototype.ordinal__O__I = (function(x) {
  return x.Lframework_components_TextKind$$anon$1__f__$ordinal$1;
});
var $d_Lframework_components_TextKind$ = new $TypeData().initClass($c_Lframework_components_TextKind$, "framework.components.TextKind$", ({
  Lframework_components_TextKind$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_components_TextKind$ as $d_Lframework_components_TextKind$ };
var $n_Lframework_components_TextKind$;
function $m_Lframework_components_TextKind$() {
  if ((!$n_Lframework_components_TextKind$)) {
    $n_Lframework_components_TextKind$ = new $c_Lframework_components_TextKind$();
  }
  return $n_Lframework_components_TextKind$;
}
export { $m_Lframework_components_TextKind$ as $m_Lframework_components_TextKind$ };
/** @constructor */
function $c_Lframework_components_TextKindFor$() {
  this.Lframework_components_TextKindFor$__f_singleLine = null;
  this.Lframework_components_TextKindFor$__f_multiLine = null;
  $n_Lframework_components_TextKindFor$ = this;
  $m_Lframework_components_TextKindFor$();
  var textKind = $s_Lframework_components_TextKind$__SingleLine__Lframework_components_TextKind();
  this.Lframework_components_TextKindFor$__f_singleLine = new $c_Lframework_components_TextKindFor(textKind);
  $m_Lframework_components_TextKindFor$();
  var textKind$1 = $s_Lframework_components_TextKind$__MultiLine__Lframework_components_TextKind();
  this.Lframework_components_TextKindFor$__f_multiLine = new $c_Lframework_components_TextKindFor(textKind$1);
}
export { $c_Lframework_components_TextKindFor$ as $c_Lframework_components_TextKindFor$ };
$c_Lframework_components_TextKindFor$.prototype = new $h_O();
$c_Lframework_components_TextKindFor$.prototype.constructor = $c_Lframework_components_TextKindFor$;
/** @constructor */
function $h_Lframework_components_TextKindFor$() {
}
export { $h_Lframework_components_TextKindFor$ as $h_Lframework_components_TextKindFor$ };
$h_Lframework_components_TextKindFor$.prototype = $c_Lframework_components_TextKindFor$.prototype;
$c_Lframework_components_TextKindFor$.prototype.fromProduct__s_Product__Lframework_components_TextKindFor = (function(x$0) {
  var textKind$1 = x$0.productElement__I__O(0);
  return new $c_Lframework_components_TextKindFor(textKind$1);
});
$c_Lframework_components_TextKindFor$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_components_TextKindFor(p);
});
var $d_Lframework_components_TextKindFor$ = new $TypeData().initClass($c_Lframework_components_TextKindFor$, "framework.components.TextKindFor$", ({
  Lframework_components_TextKindFor$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_components_TextKindFor$ as $d_Lframework_components_TextKindFor$ };
var $n_Lframework_components_TextKindFor$;
function $m_Lframework_components_TextKindFor$() {
  if ((!$n_Lframework_components_TextKindFor$)) {
    $n_Lframework_components_TextKindFor$ = new $c_Lframework_components_TextKindFor$();
  }
  return $n_Lframework_components_TextKindFor$;
}
export { $m_Lframework_components_TextKindFor$ as $m_Lframework_components_TextKindFor$ };
/** @constructor */
function $c_Lframework_data_Base64Id$() {
  this.Lframework_data_Base64Id$__f_codec$lzy1 = null;
  this.Lframework_data_Base64Id$__f_codecbitmap$1 = false;
  this.Lframework_data_Base64Id$__f_circeCodec$lzy1 = null;
  this.Lframework_data_Base64Id$__f_circeCodecbitmap$1 = false;
  this.Lframework_data_Base64Id$__f_circeKeyCodec$lzy1 = null;
  this.Lframework_data_Base64Id$__f_circeKeyCodecbitmap$1 = false;
}
export { $c_Lframework_data_Base64Id$ as $c_Lframework_data_Base64Id$ };
$c_Lframework_data_Base64Id$.prototype = new $h_O();
$c_Lframework_data_Base64Id$.prototype.constructor = $c_Lframework_data_Base64Id$;
/** @constructor */
function $h_Lframework_data_Base64Id$() {
}
export { $h_Lframework_data_Base64Id$ as $h_Lframework_data_Base64Id$ };
$h_Lframework_data_Base64Id$.prototype = $c_Lframework_data_Base64Id$.prototype;
$c_Lframework_data_Base64Id$.prototype.codec__Lsttp_tapir_Codec = (function() {
  if ((!this.Lframework_data_Base64Id$__f_codecbitmap$1)) {
    this.Lframework_data_Base64Id$__f_codec$lzy1 = $f_Lsttp_tapir_Codec__mapEither__F1__F1__Lsttp_tapir_Codec($m_Lsttp_tapir_Codec$().Lsttp_tapir_Codec$__f_string, new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((s) => {
      var this$1 = $m_Lframework_data_Base64Id$().fromBase64__T__s_Option(s);
      return (this$1.isEmpty__Z() ? new $c_s_util_Left("Invalid Base64Id") : new $c_s_util_Right(this$1.get__O()));
    })), new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => _$3.asString__T())));
    this.Lframework_data_Base64Id$__f_codecbitmap$1 = true;
  }
  return this.Lframework_data_Base64Id$__f_codec$lzy1;
});
$c_Lframework_data_Base64Id$.prototype.circeCodec__Lio_circe_Codec = (function() {
  if ((!this.Lframework_data_Base64Id$__f_circeCodecbitmap$1)) {
    var dec = $m_Lio_circe_Decoder$().Lio_circe_Decoder$__f_decodeString;
    var enc = $m_Lio_circe_Encoder$().Lio_circe_Encoder$__f_encodeString;
    var this$6 = new $c_Lio_circe_Codec$$anon$4(dec, enc);
    var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$4) => {
      var this$5 = $m_Lframework_data_Base64Id$().fromBase64__T__s_Option(_$4);
      return (this$5.isEmpty__Z() ? new $c_s_util_Left("Invalid Base64Id") : new $c_s_util_Right(this$5.get__O()));
    }));
    var g = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$5) => _$5.asString__T()));
    this.Lframework_data_Base64Id$__f_circeCodec$lzy1 = $f_Lio_circe_Codec__iemap__F1__F1__Lio_circe_Codec(this$6, f, g);
    this.Lframework_data_Base64Id$__f_circeCodecbitmap$1 = true;
  }
  return this.Lframework_data_Base64Id$__f_circeCodec$lzy1;
});
$c_Lframework_data_Base64Id$.prototype.circeKeyCodec__Lframework_utils_CirceKeyCodec = (function() {
  if ((!this.Lframework_data_Base64Id$__f_circeKeyCodecbitmap$1)) {
    var decode = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((string) => $m_Lframework_data_Base64Id$().fromBase64__T__s_Option(string)));
    var encode = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$6) => _$6.asString__T()));
    this.Lframework_data_Base64Id$__f_circeKeyCodec$lzy1 = new $c_Lframework_utils_CirceKeyCodec$$anon$2(decode, encode);
    this.Lframework_data_Base64Id$__f_circeKeyCodecbitmap$1 = true;
  }
  return this.Lframework_data_Base64Id$__f_circeKeyCodec$lzy1;
});
$c_Lframework_data_Base64Id$.prototype.schemaFor__Lsttp_tapir_Schema = (function() {
  $m_Lsttp_tapir_Schema$();
  var schemaType = new $c_Lsttp_tapir_SchemaType$SString();
  $m_Lsttp_tapir_Schema$();
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  return new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes).format__T__Lsttp_tapir_Schema("Base64 without the trailing = characters");
});
$c_Lframework_data_Base64Id$.prototype.fromBase64__T__s_Option = (function(string) {
  try {
    var this$1 = $m_ju_Base64$();
    var bytes = this$1.ju_Base64$__f_urlSafeDecoder.decode__T__AB(string);
    var value = new $c_Lframework_data_Base64Id(bytes);
    return new $c_s_Some(value);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    var x6 = $m_s_util_control_NonFatal$().unapply__jl_Throwable__s_Option(e$2);
    if ((!x6.isEmpty__Z())) {
      x6.get__O();
      return $m_s_None$();
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
$c_Lframework_data_Base64Id$.prototype.fromProduct__s_Product__Lframework_data_Base64Id = (function(x$0) {
  var bytes$1 = x$0.productElement__I__O(0);
  return new $c_Lframework_data_Base64Id(bytes$1);
});
$c_Lframework_data_Base64Id$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_Base64Id(p);
});
var $d_Lframework_data_Base64Id$ = new $TypeData().initClass($c_Lframework_data_Base64Id$, "framework.data.Base64Id$", ({
  Lframework_data_Base64Id$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_Base64Id$ as $d_Lframework_data_Base64Id$ };
var $n_Lframework_data_Base64Id$;
function $m_Lframework_data_Base64Id$() {
  if ((!$n_Lframework_data_Base64Id$)) {
    $n_Lframework_data_Base64Id$ = new $c_Lframework_data_Base64Id$();
  }
  return $n_Lframework_data_Base64Id$;
}
export { $m_Lframework_data_Base64Id$ as $m_Lframework_data_Base64Id$ };
/** @constructor */
function $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$(outer) {
  this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError$__f_$outer = outer;
}
export { $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$ as $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$ };
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$.prototype = new $h_O();
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$.prototype.constructor = $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$;
/** @constructor */
function $h_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$() {
}
export { $h_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$ as $h_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$ };
$h_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$.prototype = $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$.prototype;
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$.prototype.apply__T__T__Ljava_time_format_DateTimeFormatter__Lframework_data_FrameworkDateTime$Newtype$CannotParseError = (function(value, error, formatter) {
  return new $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError(this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError$__f_$outer, value, error, formatter);
});
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$.prototype.toString__T = (function() {
  return "CannotParseError";
});
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$.prototype.fromProduct__s_Product__Lframework_data_FrameworkDateTime$Newtype$CannotParseError = (function(x$0) {
  var value$1 = x$0.productElement__I__O(0);
  var error$1 = x$0.productElement__I__O(1);
  var formatter$1 = x$0.productElement__I__O(2);
  return new $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError(this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError$__f_$outer, value$1, error$1, formatter$1);
});
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_FrameworkDateTime$Newtype$CannotParseError(p);
});
var $d_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$ = new $TypeData().initClass($c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$, "framework.data.FrameworkDateTime$Newtype$CannotParseError$", ({
  Lframework_data_FrameworkDateTime$Newtype$CannotParseError$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$ as $d_Lframework_data_FrameworkDateTime$Newtype$CannotParseError$ };
/** @constructor */
function $c_Lframework_data_LengthIn$() {
}
export { $c_Lframework_data_LengthIn$ as $c_Lframework_data_LengthIn$ };
$c_Lframework_data_LengthIn$.prototype = new $h_O();
$c_Lframework_data_LengthIn$.prototype.constructor = $c_Lframework_data_LengthIn$;
/** @constructor */
function $h_Lframework_data_LengthIn$() {
}
export { $h_Lframework_data_LengthIn$ as $h_Lframework_data_LengthIn$ };
$h_Lframework_data_LengthIn$.prototype = $c_Lframework_data_LengthIn$.prototype;
$c_Lframework_data_LengthIn$.prototype.schema__Lsquants_space_LengthUnit__Lsttp_tapir_Schema = (function(unit) {
  $m_Lsttp_tapir_Schema$();
  var schemaType = new $c_Lsttp_tapir_SchemaType$SNumber();
  $m_Lsttp_tapir_Schema$();
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  return new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes).description__T__Lsttp_tapir_Schema((((("Length in " + unit) + " (") + unit.symbol__T()) + ")"));
});
$c_Lframework_data_LengthIn$.prototype.circeCodec__Lsquants_space_LengthUnit__Lio_circe_Codec = (function(unit) {
  var dec = $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_doubleC3C;
  var enc = $m_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$().Lcom_github_plokhotnyuk_jsoniter\uff3fscala_circe_CirceCodecs$__f_doubleC3C;
  var target = new $c_Lio_circe_Codec$$anon$4(dec, enc);
  var tc = $m_Lio_circe_Codec$().Lio_circe_Codec$__f_codecInvariant;
  var this$9 = new $c_Lcats_Invariant$ToInvariantOps$$anon$19(target, tc);
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v) => {
    var v$1 = (+v);
    var num = $m_s_math_Numeric$DoubleIsFractional$();
    var length = $m_Lsquants_space_Length$().apply__O__Lsquants_space_LengthUnit__s_math_Numeric__Lsquants_space_Length(v$1, unit, num);
    return new $c_Lframework_data_LengthIn(length);
  }));
  var g = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => _$2.valueIn__Lsquants_space_LengthUnit__D(unit)));
  return this$9.Lcats_Invariant$ToInvariantOps$$anon$19__f_typeClassInstance.imap__O__F1__F1__O(this$9.Lcats_Invariant$ToInvariantOps$$anon$19__f_self, f, g);
});
$c_Lframework_data_LengthIn$.prototype.fromValue__D__Lsquants_space_LengthUnit__Lframework_data_LengthIn = (function(value, unit) {
  var num = $m_s_math_Numeric$DoubleIsFractional$();
  var length = $m_Lsquants_space_Length$().apply__O__Lsquants_space_LengthUnit__s_math_Numeric__Lsquants_space_Length(value, unit, num);
  return new $c_Lframework_data_LengthIn(length);
});
$c_Lframework_data_LengthIn$.prototype.fromProduct__s_Product__Lframework_data_LengthIn = (function(x$0) {
  var length$1 = x$0.productElement__I__O(0);
  return new $c_Lframework_data_LengthIn(length$1);
});
$c_Lframework_data_LengthIn$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_LengthIn(p);
});
var $d_Lframework_data_LengthIn$ = new $TypeData().initClass($c_Lframework_data_LengthIn$, "framework.data.LengthIn$", ({
  Lframework_data_LengthIn$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_LengthIn$ as $d_Lframework_data_LengthIn$ };
var $n_Lframework_data_LengthIn$;
function $m_Lframework_data_LengthIn$() {
  if ((!$n_Lframework_data_LengthIn$)) {
    $n_Lframework_data_LengthIn$ = new $c_Lframework_data_LengthIn$();
  }
  return $n_Lframework_data_LengthIn$;
}
export { $m_Lframework_data_LengthIn$ as $m_Lframework_data_LengthIn$ };
function $p_Lframework_data_PageCursor$__componentCodecs$lzyINIT1$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec($thiz, componentCodecs$lzy1$1, secondaryCodec$2, primaryCodec$2) {
  if (componentCodecs$lzy1$1.sr_LazyRef__f__initialized) {
    var $x_1 = componentCodecs$lzy1$1.sr_LazyRef__f__value;
  } else {
    var acc$proxy1 = $m_sci_Nil$();
    var elem$1 = $m_Lscodec_Codec$().given_Codec_Int__Lscodec_Codec();
    var acc$proxy2 = new $c_sci_$colon$colon(elem$1, acc$proxy1);
    var acc$proxy3 = new $c_sci_$colon$colon(secondaryCodec$2, acc$proxy2);
    var acc$proxy4 = new $c_sci_$colon$colon(primaryCodec$2, acc$proxy3);
    var elem$1$4 = $m_Lframework_data_PageCursorDirection$().scodecCodec__Lscodec_Codec();
    var this$2 = new $c_sci_$colon$colon(elem$1$4, acc$proxy4);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var unlabelled = new ($d_Lscodec_Codec.getArrayOf().constr)(jsElems);
    var Tuple_this = new $c_T4("direction", "primary", "secondary", "index");
    var this$7 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    var labels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$7);
    var xs = $m_sc_ArrayOps$().zip$extension__O__sc_IterableOnce__AT2(unlabelled, labels);
    var f = ((x$1) => {
      var codec = x$1._1__O();
      var label = x$1._2__O();
      return new $c_Lscodec_Codec$$anon$7(label, codec);
    });
    var len = xs.u.length;
    var ys = new ($d_Lscodec_Codec.getArrayOf().constr)(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0 = xs.u[i];
          ys.u[$x_2] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$1 = xs.u[i];
          ys.u[$x_3] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var $x_4 = i;
          var x0$2 = xs.u[i];
          ys.u[$x_4] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var $x_5 = i;
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.u[$x_5] = f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var $x_6 = i;
          var x0$3 = xs.u[i];
          ys.u[$x_6] = f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$4 = xs.u[i];
          ys.u[$x_7] = f($bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$5 = xs.u[i];
          ys.u[$x_8] = f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$6 = xs.u[i];
          ys.u[$x_9] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$7 = xs.u[i];
          ys.u[$x_10] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    }
    var $x_1 = componentCodecs$lzy1$1.initialize__O__O(ys);
  }
  return $x_1;
}
export { $p_Lframework_data_PageCursor$__componentCodecs$lzyINIT1$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec as $p_Lframework_data_PageCursor$__componentCodecs$lzyINIT1$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec };
function $p_Lframework_data_PageCursor$__componentCodecs$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec($thiz, componentCodecs$lzy1$2, secondaryCodec$3, primaryCodec$3) {
  return (componentCodecs$lzy1$2.sr_LazyRef__f__initialized ? componentCodecs$lzy1$2.sr_LazyRef__f__value : $p_Lframework_data_PageCursor$__componentCodecs$lzyINIT1$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec($thiz, componentCodecs$lzy1$2, secondaryCodec$3, primaryCodec$3));
}
export { $p_Lframework_data_PageCursor$__componentCodecs$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec as $p_Lframework_data_PageCursor$__componentCodecs$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec };
function $p_Lframework_data_PageCursor$__given_SCodecCodec_Cursor$lzyINIT1$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec($thiz, given_SCodecCodec_Cursor$lzy1$1, secondaryCodec$1, primaryCodec$1) {
  if (given_SCodecCodec_Cursor$lzy1$1.sr_LazyRef__f__initialized) {
    var $x_1 = given_SCodecCodec_Cursor$lzy1$1.sr_LazyRef__f__value;
  } else {
    var m$proxy1 = $m_Lframework_data_PageCursor$Cursor$();
    var componentCodecs$lzy1 = new $c_sr_LazyRef();
    var componentCodecs$lzy1$2$1 = componentCodecs$lzy1;
    var this$4 = new $c_Lscodec_Codec$inlineImplementations$TupleCodec(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((componentCodecs$lzy1$2) => (() => $p_Lframework_data_PageCursor$__componentCodecs$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec($thiz, componentCodecs$lzy1$2, secondaryCodec$1, primaryCodec$1)))(componentCodecs$lzy1$2$1)));
    var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((met) => m$proxy1.fromProduct__s_Product__Lframework_data_PageCursor$Cursor(met)));
    var g = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a) => $m_sr_Tuples$().fromProduct__s_Product__s_Product(a)));
    var $x_1 = given_SCodecCodec_Cursor$lzy1$1.initialize__O__O(new $c_Lscodec_Codec$$anon$2(g, f, this$4));
  }
  return $x_1;
}
export { $p_Lframework_data_PageCursor$__given_SCodecCodec_Cursor$lzyINIT1$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec as $p_Lframework_data_PageCursor$__given_SCodecCodec_Cursor$lzyINIT1$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec };
function $p_Lframework_data_PageCursor$__given_SCodecCodec_Cursor$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec($thiz, given_SCodecCodec_Cursor$lzy1$2, secondaryCodec$4, primaryCodec$4) {
  return (given_SCodecCodec_Cursor$lzy1$2.sr_LazyRef__f__initialized ? given_SCodecCodec_Cursor$lzy1$2.sr_LazyRef__f__value : $p_Lframework_data_PageCursor$__given_SCodecCodec_Cursor$lzyINIT1$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec($thiz, given_SCodecCodec_Cursor$lzy1$2, secondaryCodec$4, primaryCodec$4));
}
export { $p_Lframework_data_PageCursor$__given_SCodecCodec_Cursor$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec as $p_Lframework_data_PageCursor$__given_SCodecCodec_Cursor$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec };
function $p_Lframework_data_PageCursor$__componentCodecs$lzyINIT2$1__sr_LazyRef__Lscodec_Codec__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec($thiz, componentCodecs$lzy2$1, pageSizeCodec$4, given_SCodecCodec_Cursor$lzy1$3, secondaryCodec$5, primaryCodec$5) {
  if (componentCodecs$lzy2$1.sr_LazyRef__f__initialized) {
    var $x_1 = componentCodecs$lzy2$1.sr_LazyRef__f__value;
  } else {
    var acc$proxy5 = $m_sci_Nil$();
    var acc$proxy6 = new $c_sci_$colon$colon(pageSizeCodec$4, acc$proxy5);
    var cguard = $m_Lscodec_Codec$().given_Codec_Boolean__Lscodec_Codec();
    var ca = $p_Lframework_data_PageCursor$__given_SCodecCodec_Cursor$1__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec($thiz, given_SCodecCodec_Cursor$lzy1$3, secondaryCodec$5, primaryCodec$5);
    var elem$1$2 = $m_Lscodec_codecs_codecs$package$().optional__Lscodec_Codec__Lscodec_Codec__Lscodec_Codec(cguard, ca);
    var this$3 = new $c_sci_$colon$colon(elem$1$2, acc$proxy6);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$3);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var unlabelled = new ($d_Lscodec_Codec.getArrayOf().constr)(jsElems);
    var Tuple_this = $ct_T2__O__O__(new $c_T2(), "cursor", "pageSize");
    var this$8 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    var labels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$8);
    var xs = $m_sc_ArrayOps$().zip$extension__O__sc_IterableOnce__AT2(unlabelled, labels);
    var f = ((x$1) => {
      var codec = x$1._1__O();
      var label = x$1._2__O();
      return new $c_Lscodec_Codec$$anon$7(label, codec);
    });
    var len = xs.u.length;
    var ys = new ($d_Lscodec_Codec.getArrayOf().constr)(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0 = xs.u[i];
          ys.u[$x_2] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$1 = xs.u[i];
          ys.u[$x_3] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var $x_4 = i;
          var x0$2 = xs.u[i];
          ys.u[$x_4] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var $x_5 = i;
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.u[$x_5] = f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var $x_6 = i;
          var x0$3 = xs.u[i];
          ys.u[$x_6] = f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$4 = xs.u[i];
          ys.u[$x_7] = f($bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$5 = xs.u[i];
          ys.u[$x_8] = f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$6 = xs.u[i];
          ys.u[$x_9] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$7 = xs.u[i];
          ys.u[$x_10] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    }
    var $x_1 = componentCodecs$lzy2$1.initialize__O__O(ys);
  }
  return $x_1;
}
export { $p_Lframework_data_PageCursor$__componentCodecs$lzyINIT2$1__sr_LazyRef__Lscodec_Codec__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec as $p_Lframework_data_PageCursor$__componentCodecs$lzyINIT2$1__sr_LazyRef__Lscodec_Codec__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec };
function $p_Lframework_data_PageCursor$__componentCodecs$2__sr_LazyRef__Lscodec_Codec__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec($thiz, componentCodecs$lzy2$2, pageSizeCodec$5, given_SCodecCodec_Cursor$lzy1$4, secondaryCodec$6, primaryCodec$6) {
  return (componentCodecs$lzy2$2.sr_LazyRef__f__initialized ? componentCodecs$lzy2$2.sr_LazyRef__f__value : $p_Lframework_data_PageCursor$__componentCodecs$lzyINIT2$1__sr_LazyRef__Lscodec_Codec__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec($thiz, componentCodecs$lzy2$2, pageSizeCodec$5, given_SCodecCodec_Cursor$lzy1$4, secondaryCodec$6, primaryCodec$6));
}
export { $p_Lframework_data_PageCursor$__componentCodecs$2__sr_LazyRef__Lscodec_Codec__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec as $p_Lframework_data_PageCursor$__componentCodecs$2__sr_LazyRef__Lscodec_Codec__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec };
function $s_Lframework_data_PageCursor$__framework$data$PageCursor$Cursor$$anon$3$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.Lmagnolia1_TypeInfo__f_typeParams.toList__sci_List();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.head__O();
    var this$2 = $s_Lframework_data_PageCursor$__framework$data$PageCursor$Cursor$$anon$3$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(x0);
    var it = this$2.prepended__O__O(x0).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $m_sci_Nil$() : h);
}
export { $s_Lframework_data_PageCursor$__framework$data$PageCursor$Cursor$$anon$3$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq as $s_Lframework_data_PageCursor$__framework$data$PageCursor$Cursor$$anon$3$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq };
function $s_Lframework_data_PageCursor$__framework$data$PageCursor$$anon$14$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq(tn) {
  var this$1 = tn.Lmagnolia1_TypeInfo__f_typeParams.toList__sci_List();
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.head__O();
    var this$2 = $s_Lframework_data_PageCursor$__framework$data$PageCursor$$anon$14$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq(x0);
    var it = this$2.prepended__O__O(x0).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $m_sci_Nil$() : h);
}
export { $s_Lframework_data_PageCursor$__framework$data$PageCursor$$anon$14$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq as $s_Lframework_data_PageCursor$__framework$data$PageCursor$$anon$14$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq };
/** @constructor */
function $c_Lframework_data_PageCursor$() {
}
export { $c_Lframework_data_PageCursor$ as $c_Lframework_data_PageCursor$ };
$c_Lframework_data_PageCursor$.prototype = new $h_O();
$c_Lframework_data_PageCursor$.prototype.constructor = $c_Lframework_data_PageCursor$;
/** @constructor */
function $h_Lframework_data_PageCursor$() {
}
export { $h_Lframework_data_PageCursor$ as $h_Lframework_data_PageCursor$ };
$h_Lframework_data_PageCursor$.prototype = $c_Lframework_data_PageCursor$.prototype;
$c_Lframework_data_PageCursor$.prototype.collectAll__Lframework_data_PageCursor__F1__F1__F1__Lcats_Monad__O = (function(firstCursor, fetchPage, getCursorColumns, mapItem, F) {
  $m_sci_Vector$();
  var _2 = $m_sci_Vector0$();
  return F.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), firstCursor, _2), new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ((x$1 !== null)) {
      var cursor = x$1._1__O();
      var acc = x$1._2__O();
      return F.map__O__F1__O(fetchPage.apply__O__O(cursor), new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((page) => {
        var items = page.Lframework_data_HasSurroundingPages__f_data.map__F1__O(mapItem);
        var accWithPage = acc.appendedAll__sc_IterableOnce__sci_Vector(items);
        if ((!page.Lframework_data_HasSurroundingPages__f_pages.Lframework_data_HasSurroundingPages$Pages__f_hasNext)) {
          var x5 = $m_s_None$();
        } else {
          var x0 = page.Lframework_data_HasSurroundingPages__f_data;
          var this$3 = $f_sc_IterableOps__lastOption__s_Option(x0);
          var this$4 = (this$3.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(getCursorColumns.apply__O__O(this$3.get__O())));
          if (this$4.isEmpty__Z()) {
            var x5 = $m_s_None$();
          } else {
            var x0$1 = this$4.get__O();
            matchResult4$1: {
              var $x_1;
              if ((x0$1 !== null)) {
                var id = x0$1._1__O();
                var timestamp = x0$1._2__O();
                var $x_1 = cursor.next__O__O__Lframework_data_PageCursor(id, timestamp);
                break matchResult4$1;
              }
              throw new $c_s_MatchError(x0$1);
            }
            var x5 = new $c_s_Some($x_1);
          }
        }
        var x = $m_s_None$();
        if ((x === x5)) {
          return new $c_s_util_Right(accWithPage);
        }
        if ((x5 instanceof $c_s_Some)) {
          var next = x5.s_Some__f_value;
          var value = $ct_T2__O__O__(new $c_T2(), next, accWithPage);
          return new $c_s_util_Left(value);
        }
        throw new $c_s_MatchError(x5);
      })));
    }
    throw new $c_s_MatchError(x$1);
  })));
});
$c_Lframework_data_PageCursor$.prototype.empty__Lalleycats_Empty__Lalleycats_Empty = (function(evidence$1) {
  var a = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var cursor = $m_s_None$();
    var pageSize = evidence$1.empty__O();
    return new $c_Lframework_data_PageCursor(cursor, pageSize);
  }));
  return new $c_Lalleycats_Empty$$anon$1(a);
});
$c_Lframework_data_PageCursor$.prototype.tapirCodecBinaryBase64__Lscodec_Codec__Lsttp_tapir_Schema__Lscodec_Codec__Lsttp_tapir_Schema__Lscodec_Codec__Lsttp_tapir_Schema__Lsttp_tapir_Codec = (function(primaryCodec, primarySchema, secondaryCodec, secondarySchema, pageSizeCodec, pageSizeSchema) {
  var given_SCodecCodec_Cursor$lzy1 = new $c_sr_LazyRef();
  var m$proxy2 = $m_Lframework_data_PageCursor$();
  var componentCodecs$lzy2 = new $c_sr_LazyRef();
  var componentCodecs$lzy2$2$1 = componentCodecs$lzy2;
  var given_SCodecCodec_Cursor$lzy1$2$1 = given_SCodecCodec_Cursor$lzy1;
  var this$4 = new $c_Lscodec_Codec$inlineImplementations$TupleCodec(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((componentCodecs$lzy2$2, given_SCodecCodec_Cursor$lzy1$2) => (() => $p_Lframework_data_PageCursor$__componentCodecs$2__sr_LazyRef__Lscodec_Codec__sr_LazyRef__Lscodec_Codec__Lscodec_Codec__ALscodec_Codec(this, componentCodecs$lzy2$2, pageSizeCodec, given_SCodecCodec_Cursor$lzy1$2, secondaryCodec, primaryCodec)))(componentCodecs$lzy2$2$1, given_SCodecCodec_Cursor$lzy1$2$1)));
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((met) => m$proxy2.fromProduct__s_Product__Lframework_data_PageCursor(met)));
  var g = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a) => $m_sr_Tuples$().fromProduct__s_Product__s_Product(a)));
  var codec = new $c_Lscodec_Codec$$anon$2(g, f, this$4);
  $m_Lsttp_tapir_Codec$();
  var schema = this.derived$Schema__Lsttp_tapir_Schema__Lsttp_tapir_Schema__Lsttp_tapir_Schema__Lsttp_tapir_Schema(primarySchema, secondarySchema, pageSizeSchema);
  return new $c_Lframework_exts_TapirCodecExts$package$$anon$1(codec, schema);
});
$c_Lframework_data_PageCursor$.prototype.derived$Schema__Lsttp_tapir_Schema__Lsttp_tapir_Schema__Lsttp_tapir_Schema__Lsttp_tapir_Schema = (function(x$0, x$1, x$2) {
  var SchemaMagnoliaDerivation_this = $m_Lsttp_tapir_Schema$();
  var m$proxy5 = $m_Lframework_data_PageCursor$();
  var derivation = new $c_Lframework_data_PageCursor$$anon$14(SchemaMagnoliaDerivation_this);
  var this$2 = $m_sci_Nil$();
  var factory = $m_sci_Map$();
  var factory$1 = new $c_sc_MapFactory$ToFactory(factory);
  var annotations$proxy2 = factory$1.fromSpecific__sc_IterableOnce__O(this$2);
  var _2 = $m_sci_Nil$();
  var $x_1 = $ct_T2__O__O__(new $c_T2(), "pageSize", _2);
  var _2$1 = $m_sci_Nil$();
  var this$6 = new $c_sci_$colon$colon($x_1, new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "cursor", _2$1), $m_sci_Nil$()));
  var factory$2 = $m_sci_Map$();
  var factory$3 = new $c_sc_MapFactory$ToFactory(factory$2);
  var inheritedAnnotations$proxy2 = factory$3.fromSpecific__sc_IterableOnce__O(this$6);
  var this$8 = $m_sci_Nil$();
  var factory$4 = $m_sci_Map$();
  var factory$5 = new $c_sc_MapFactory$ToFactory(factory$4);
  var typeAnnotations$proxy2 = factory$5.fromSpecific__sc_IterableOnce__O(this$8);
  var this$15 = new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "PrimaryColumn", false), new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "SecondaryColumn", false), new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "PageSize", false), new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "cursor", false), new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "pageSize", false), $m_sci_Nil$())))));
  var factory$6 = $m_sci_Map$();
  var factory$7 = new $c_sc_MapFactory$ToFactory(factory$6);
  var repeated$proxy2 = factory$7.fromSpecific__sc_IterableOnce__O(this$15);
  var _2$2 = $m_s_None$();
  var $x_2 = $ct_T2__O__O__(new $c_T2(), "cursor", _2$2);
  var _2$3 = $m_s_None$();
  var this$19 = new $c_sci_$colon$colon($x_2, new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "pageSize", _2$3), $m_sci_Nil$()));
  var factory$8 = $m_sci_Map$();
  var factory$9 = new $c_sc_MapFactory$ToFactory(factory$8);
  var defaults$proxy2 = factory$9.fromSpecific__sc_IterableOnce__O(this$19);
  var tc = new $c_Lframework_data_PageCursor$$anon$17(x$0, x$1);
  matchResult38: {
    var d;
    var $x_3 = defaults$proxy2.get__O__s_Option("cursor");
    var this$20 = $m_s_$less$colon$less$();
    var x146 = $x_3.flatten__s_$less$colon$less__s_Option(this$20.s_$less$colon$less$__f_singleton);
    if ((x146 instanceof $c_s_Some)) {
      var evaluator = x146.s_Some__f_value;
      var d = new $c_Lframework_data_PageCursor$$anon$18(evaluator);
      break matchResult38;
    }
    var d = $m_Lmagnolia1_CaseClassDerivation$().Lmagnolia1_CaseClassDerivation$__f_returningNone;
  }
  var this$21 = $m_Lmagnolia1_CaseClassDerivation$();
  var tc$1 = $m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc);
  var d$1 = $m_Lmagnolia1_CallByNeed$().createValueEvaluator__F0__Lmagnolia1_CallByNeed(d);
  var elem$1 = $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param(this$21, "cursor", tc$1, d$1, repeated$proxy2, annotations$proxy2, inheritedAnnotations$proxy2, typeAnnotations$proxy2, 0);
  var tc$2 = new $c_Lframework_data_PageCursor$$anon$19(x$2);
  matchResult39: {
    var d$2;
    var $x_4 = defaults$proxy2.get__O__s_Option("pageSize");
    var this$22 = $m_s_$less$colon$less$();
    var x149 = $x_4.flatten__s_$less$colon$less__s_Option(this$22.s_$less$colon$less$__f_singleton);
    if ((x149 instanceof $c_s_Some)) {
      var evaluator$2 = x149.s_Some__f_value;
      var d$2 = new $c_Lframework_data_PageCursor$$anon$20(evaluator$2);
      break matchResult39;
    }
    var d$2 = $m_Lmagnolia1_CaseClassDerivation$().Lmagnolia1_CaseClassDerivation$__f_returningNone;
  }
  var this$23 = $m_Lmagnolia1_CaseClassDerivation$();
  var tc$3 = $m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc$2);
  var d$3 = $m_Lmagnolia1_CallByNeed$().createValueEvaluator__F0__Lmagnolia1_CallByNeed(d$2);
  var elem$1$2 = $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param(this$23, "pageSize", tc$3, d$3, repeated$proxy2, annotations$proxy2, inheritedAnnotations$proxy2, typeAnnotations$proxy2, 1);
  var this$24 = $m_sci_Nil$();
  var this$25 = new $c_sci_$colon$colon(elem$1$2, this$24);
  var xs = new $c_sci_$colon$colon(elem$1, this$25);
  var len = xs.length__I();
  var array = new ($d_Lmagnolia1_CaseClass$Param.getArrayOf().constr)(len);
  var iterator = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(xs);
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  var typeParams = $m_sci_Nil$();
  var $x_6 = new $c_Lmagnolia1_TypeInfo("framework.data.PageCursor.derived$Schema", "PrimaryColumn", typeParams);
  var typeParams$1 = $m_sci_Nil$();
  var $x_5 = new $c_Lmagnolia1_TypeInfo("framework.data.PageCursor.derived$Schema", "SecondaryColumn", typeParams$1);
  var typeParams$2 = $m_sci_Nil$();
  var typeParams$3 = new $c_sci_$colon$colon($x_6, new $c_sci_$colon$colon($x_5, new $c_sci_$colon$colon(new $c_Lmagnolia1_TypeInfo("framework.data.PageCursor.derived$Schema", "PageSize", typeParams$2), $m_sci_Nil$())));
  var $x_7 = new $c_Lmagnolia1_TypeInfo("framework.data", "PageCursor", typeParams$3);
  var xs$1 = $m_sci_Nil$();
  var len$1 = xs$1.length__I();
  var array$1 = new $ac_O(len$1);
  var iterator$1 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$1 = 0;
  while (iterator$1.hasNext__Z()) {
    array$1.u[i$1] = iterator$1.next__O();
    i$1 = ((1 + i$1) | 0);
  }
  var xs$2 = $m_sci_Nil$();
  var len$2 = xs$2.length__I();
  var array$2 = new $ac_O(len$2);
  var iterator$2 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$2 = 0;
  while (iterator$2.hasNext__Z()) {
    array$2.u[i$2] = iterator$2.next__O();
    i$2 = ((1 + i$2) | 0);
  }
  var xs$3 = $m_sci_Nil$();
  var len$3 = xs$3.length__I();
  var array$3 = new $ac_O(len$3);
  var iterator$3 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$3 = 0;
  while (iterator$3.hasNext__Z()) {
    array$3.u[i$3] = iterator$3.next__O();
    i$3 = ((1 + i$3) | 0);
  }
  var caseClass = new $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass($x_7, false, false, array, array$1, array$2, array$3, m$proxy5);
  return derivation.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema(caseClass);
});
$c_Lframework_data_PageCursor$.prototype.fromProduct__s_Product__Lframework_data_PageCursor = (function(x$0) {
  var cursor$1 = x$0.productElement__I__O(0);
  var pageSize$1 = x$0.productElement__I__O(1);
  return new $c_Lframework_data_PageCursor(cursor$1, pageSize$1);
});
$c_Lframework_data_PageCursor$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_PageCursor(p);
});
var $d_Lframework_data_PageCursor$ = new $TypeData().initClass($c_Lframework_data_PageCursor$, "framework.data.PageCursor$", ({
  Lframework_data_PageCursor$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_PageCursor$ as $d_Lframework_data_PageCursor$ };
var $n_Lframework_data_PageCursor$;
function $m_Lframework_data_PageCursor$() {
  if ((!$n_Lframework_data_PageCursor$)) {
    $n_Lframework_data_PageCursor$ = new $c_Lframework_data_PageCursor$();
  }
  return $n_Lframework_data_PageCursor$;
}
export { $m_Lframework_data_PageCursor$ as $m_Lframework_data_PageCursor$ };
/** @constructor */
function $c_Lframework_data_PageCursor$Cursor$() {
}
export { $c_Lframework_data_PageCursor$Cursor$ as $c_Lframework_data_PageCursor$Cursor$ };
$c_Lframework_data_PageCursor$Cursor$.prototype = new $h_O();
$c_Lframework_data_PageCursor$Cursor$.prototype.constructor = $c_Lframework_data_PageCursor$Cursor$;
/** @constructor */
function $h_Lframework_data_PageCursor$Cursor$() {
}
export { $h_Lframework_data_PageCursor$Cursor$ as $h_Lframework_data_PageCursor$Cursor$ };
$h_Lframework_data_PageCursor$Cursor$.prototype = $c_Lframework_data_PageCursor$Cursor$.prototype;
$c_Lframework_data_PageCursor$Cursor$.prototype.derived$Schema__Lsttp_tapir_Schema__Lsttp_tapir_Schema__Lsttp_tapir_Schema = (function(x$0, x$1) {
  var SchemaMagnoliaDerivation_this = $m_Lsttp_tapir_Schema$();
  var m$proxy4 = $m_Lframework_data_PageCursor$Cursor$();
  var derivation = new $c_Lframework_data_PageCursor$Cursor$$anon$3(SchemaMagnoliaDerivation_this);
  var this$2 = $m_sci_Nil$();
  var factory = $m_sci_Map$();
  var factory$1 = new $c_sc_MapFactory$ToFactory(factory);
  var annotations$proxy1 = factory$1.fromSpecific__sc_IterableOnce__O(this$2);
  var _2 = $m_sci_Nil$();
  var $x_3 = $ct_T2__O__O__(new $c_T2(), "direction", _2);
  var _2$1 = $m_sci_Nil$();
  var $x_2 = $ct_T2__O__O__(new $c_T2(), "secondary", _2$1);
  var _2$2 = $m_sci_Nil$();
  var $x_1 = $ct_T2__O__O__(new $c_T2(), "primary", _2$2);
  var _2$3 = $m_sci_Nil$();
  var this$8 = new $c_sci_$colon$colon($x_3, new $c_sci_$colon$colon($x_2, new $c_sci_$colon$colon($x_1, new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "index", _2$3), $m_sci_Nil$()))));
  var factory$2 = $m_sci_Map$();
  var factory$3 = new $c_sc_MapFactory$ToFactory(factory$2);
  var inheritedAnnotations$proxy1 = factory$3.fromSpecific__sc_IterableOnce__O(this$8);
  var this$10 = $m_sci_Nil$();
  var factory$4 = $m_sci_Map$();
  var factory$5 = new $c_sc_MapFactory$ToFactory(factory$4);
  var typeAnnotations$proxy1 = factory$5.fromSpecific__sc_IterableOnce__O(this$10);
  var this$18 = new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "PrimaryColumn", false), new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "SecondaryColumn", false), new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "direction", false), new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "primary", false), new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "secondary", false), new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "index", false), $m_sci_Nil$()))))));
  var factory$6 = $m_sci_Map$();
  var factory$7 = new $c_sc_MapFactory$ToFactory(factory$6);
  var repeated$proxy1 = factory$7.fromSpecific__sc_IterableOnce__O(this$18);
  var _2$4 = $m_s_None$();
  var $x_6 = $ct_T2__O__O__(new $c_T2(), "direction", _2$4);
  var _2$5 = $m_s_None$();
  var $x_5 = $ct_T2__O__O__(new $c_T2(), "primary", _2$5);
  var _2$6 = $m_s_None$();
  var $x_4 = $ct_T2__O__O__(new $c_T2(), "secondary", _2$6);
  var _2$7 = $m_s_None$();
  var this$24 = new $c_sci_$colon$colon($x_6, new $c_sci_$colon$colon($x_5, new $c_sci_$colon$colon($x_4, new $c_sci_$colon$colon($ct_T2__O__O__(new $c_T2(), "index", _2$7), $m_sci_Nil$()))));
  var factory$8 = $m_sci_Map$();
  var factory$9 = new $c_sc_MapFactory$ToFactory(factory$8);
  var defaults$proxy1 = factory$9.fromSpecific__sc_IterableOnce__O(this$24);
  var tc = new $c_Lframework_data_PageCursor$Cursor$$anon$6();
  matchResult23: {
    var d;
    var $x_7 = defaults$proxy1.get__O__s_Option("direction");
    var this$25 = $m_s_$less$colon$less$();
    var x85 = $x_7.flatten__s_$less$colon$less__s_Option(this$25.s_$less$colon$less$__f_singleton);
    if ((x85 instanceof $c_s_Some)) {
      var evaluator = x85.s_Some__f_value;
      var d = new $c_Lframework_data_PageCursor$Cursor$$anon$7(evaluator);
      break matchResult23;
    }
    var d = $m_Lmagnolia1_CaseClassDerivation$().Lmagnolia1_CaseClassDerivation$__f_returningNone;
  }
  var this$26 = $m_Lmagnolia1_CaseClassDerivation$();
  var tc$1 = $m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc);
  var d$1 = $m_Lmagnolia1_CallByNeed$().createValueEvaluator__F0__Lmagnolia1_CallByNeed(d);
  var s1 = $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param(this$26, "direction", tc$1, d$1, repeated$proxy1, annotations$proxy1, inheritedAnnotations$proxy1, typeAnnotations$proxy1, 0);
  var tc$2 = new $c_Lframework_data_PageCursor$Cursor$$anon$8(x$0);
  matchResult24: {
    var d$2;
    var $x_8 = defaults$proxy1.get__O__s_Option("primary");
    var this$27 = $m_s_$less$colon$less$();
    var x88 = $x_8.flatten__s_$less$colon$less__s_Option(this$27.s_$less$colon$less$__f_singleton);
    if ((x88 instanceof $c_s_Some)) {
      var evaluator$2 = x88.s_Some__f_value;
      var d$2 = new $c_Lframework_data_PageCursor$Cursor$$anon$9(evaluator$2);
      break matchResult24;
    }
    var d$2 = $m_Lmagnolia1_CaseClassDerivation$().Lmagnolia1_CaseClassDerivation$__f_returningNone;
  }
  var this$28 = $m_Lmagnolia1_CaseClassDerivation$();
  var tc$3 = $m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc$2);
  var d$3 = $m_Lmagnolia1_CallByNeed$().createValueEvaluator__F0__Lmagnolia1_CallByNeed(d$2);
  var s2 = $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param(this$28, "primary", tc$3, d$3, repeated$proxy1, annotations$proxy1, inheritedAnnotations$proxy1, typeAnnotations$proxy1, 1);
  var tc$3$1 = new $c_Lframework_data_PageCursor$Cursor$$anon$10(x$1);
  matchResult25: {
    var d$3$1;
    var $x_9 = defaults$proxy1.get__O__s_Option("secondary");
    var this$29 = $m_s_$less$colon$less$();
    var x91 = $x_9.flatten__s_$less$colon$less__s_Option(this$29.s_$less$colon$less$__f_singleton);
    if ((x91 instanceof $c_s_Some)) {
      var evaluator$3 = x91.s_Some__f_value;
      var d$3$1 = new $c_Lframework_data_PageCursor$Cursor$$anon$11(evaluator$3);
      break matchResult25;
    }
    var d$3$1 = $m_Lmagnolia1_CaseClassDerivation$().Lmagnolia1_CaseClassDerivation$__f_returningNone;
  }
  var this$30 = $m_Lmagnolia1_CaseClassDerivation$();
  var tc$4 = $m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc$3$1);
  var d$4 = $m_Lmagnolia1_CallByNeed$().createValueEvaluator__F0__Lmagnolia1_CallByNeed(d$3$1);
  var s3 = $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param(this$30, "secondary", tc$4, d$4, repeated$proxy1, annotations$proxy1, inheritedAnnotations$proxy1, typeAnnotations$proxy1, 2);
  var tc$4$1 = new $c_Lframework_data_PageCursor$Cursor$$anon$12();
  matchResult26: {
    var d$4$1;
    var $x_10 = defaults$proxy1.get__O__s_Option("index");
    var this$31 = $m_s_$less$colon$less$();
    var x94 = $x_10.flatten__s_$less$colon$less__s_Option(this$31.s_$less$colon$less$__f_singleton);
    if ((x94 instanceof $c_s_Some)) {
      var evaluator$4 = x94.s_Some__f_value;
      var d$4$1 = new $c_Lframework_data_PageCursor$Cursor$$anon$13(evaluator$4);
      break matchResult26;
    }
    var d$4$1 = $m_Lmagnolia1_CaseClassDerivation$().Lmagnolia1_CaseClassDerivation$__f_returningNone;
  }
  var this$32 = $m_Lmagnolia1_CaseClassDerivation$();
  var tc$5 = $m_Lmagnolia1_CallByNeed$().createLazy__F0__Lmagnolia1_CallByNeed(tc$4$1);
  var d$5 = $m_Lmagnolia1_CallByNeed$().createValueEvaluator__F0__Lmagnolia1_CallByNeed(d$4$1);
  var s4 = $p_Lmagnolia1_CaseClassDerivation$__paramFromMaps__T__Lmagnolia1_CallByNeed__Lmagnolia1_CallByNeed__sci_Map__sci_Map__sci_Map__sci_Map__I__Lmagnolia1_CaseClass$Param(this$32, "index", tc$5, d$5, repeated$proxy1, annotations$proxy1, inheritedAnnotations$proxy1, typeAnnotations$proxy1, 3);
  var this$33 = $m_sci_Nil$();
  var this$34 = new $c_sci_$colon$colon(s4, this$33);
  var this$35 = new $c_sci_$colon$colon(s3, this$34);
  var this$36 = new $c_sci_$colon$colon(s2, this$35);
  var xs = new $c_sci_$colon$colon(s1, this$36);
  var len = xs.length__I();
  var array = new ($d_Lmagnolia1_CaseClass$Param.getArrayOf().constr)(len);
  var iterator = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(xs);
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  var typeParams = $m_sci_Nil$();
  var $x_11 = new $c_Lmagnolia1_TypeInfo("framework.data.PageCursor.Cursor.derived$Schema", "PrimaryColumn", typeParams);
  var typeParams$1 = $m_sci_Nil$();
  var typeParams$2 = new $c_sci_$colon$colon($x_11, new $c_sci_$colon$colon(new $c_Lmagnolia1_TypeInfo("framework.data.PageCursor.Cursor.derived$Schema", "SecondaryColumn", typeParams$1), $m_sci_Nil$()));
  var $x_12 = new $c_Lmagnolia1_TypeInfo("framework.data.PageCursor", "Cursor", typeParams$2);
  var xs$1 = $m_sci_Nil$();
  var len$1 = xs$1.length__I();
  var array$1 = new $ac_O(len$1);
  var iterator$1 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$1 = 0;
  while (iterator$1.hasNext__Z()) {
    array$1.u[i$1] = iterator$1.next__O();
    i$1 = ((1 + i$1) | 0);
  }
  var xs$2 = $m_sci_Nil$();
  var len$2 = xs$2.length__I();
  var array$2 = new $ac_O(len$2);
  var iterator$2 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$2 = 0;
  while (iterator$2.hasNext__Z()) {
    array$2.u[i$2] = iterator$2.next__O();
    i$2 = ((1 + i$2) | 0);
  }
  var xs$3 = $m_sci_Nil$();
  var len$3 = xs$3.length__I();
  var array$3 = new $ac_O(len$3);
  var iterator$3 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$3 = 0;
  while (iterator$3.hasNext__Z()) {
    array$3.u[i$3] = iterator$3.next__O();
    i$3 = ((1 + i$3) | 0);
  }
  var caseClass = new $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass($x_12, false, false, array, array$1, array$2, array$3, m$proxy4);
  return derivation.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema(caseClass);
});
$c_Lframework_data_PageCursor$Cursor$.prototype.fromProduct__s_Product__Lframework_data_PageCursor$Cursor = (function(x$0) {
  var direction$1 = x$0.productElement__I__O(0);
  var primary$1 = x$0.productElement__I__O(1);
  var secondary$1 = x$0.productElement__I__O(2);
  var index$1 = (x$0.productElement__I__O(3) | 0);
  return new $c_Lframework_data_PageCursor$Cursor(direction$1, primary$1, secondary$1, index$1);
});
$c_Lframework_data_PageCursor$Cursor$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lframework_data_PageCursor$Cursor(p);
});
var $d_Lframework_data_PageCursor$Cursor$ = new $TypeData().initClass($c_Lframework_data_PageCursor$Cursor$, "framework.data.PageCursor$Cursor$", ({
  Lframework_data_PageCursor$Cursor$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lframework_data_PageCursor$Cursor$ as $d_Lframework_data_PageCursor$Cursor$ };
var $n_Lframework_data_PageCursor$Cursor$;
function $m_Lframework_data_PageCursor$Cursor$() {
  if ((!$n_Lframework_data_PageCursor$Cursor$)) {
    $n_Lframework_data_PageCursor$Cursor$ = new $c_Lframework_data_PageCursor$Cursor$();
  }
  return $n_Lframework_data_PageCursor$Cursor$;
}
export { $m_Lframework_data_PageCursor$Cursor$ as $m_Lframework_data_PageCursor$Cursor$ };
function $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT1$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy1$1) {
  if (componentCodecs$lzy1$1.sr_LazyRef__f__initialized) {
    var $x_1 = componentCodecs$lzy1$1.sr_LazyRef__f__value;
  } else {
    var this$2 = $m_sci_Nil$();
    var destination = new ($d_Lscodec_Codec.getArrayOf().constr)(0);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
    var Tuple_this = $m_T$package$EmptyTuple$();
    var this$4 = new $c_s_Product$$anon$1(Tuple_this);
    var labels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4);
    var xs = $m_sc_ArrayOps$().zip$extension__O__sc_IterableOnce__AT2(destination, labels);
    var f = ((x$1) => {
      var codec = x$1._1__O();
      var label = x$1._2__O();
      return new $c_Lscodec_Codec$$anon$7(label, codec);
    });
    var len = xs.u.length;
    var ys = new ($d_Lscodec_Codec.getArrayOf().constr)(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0 = xs.u[i];
          ys.u[$x_2] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$1 = xs.u[i];
          ys.u[$x_3] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var $x_4 = i;
          var x0$2 = xs.u[i];
          ys.u[$x_4] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var $x_5 = i;
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.u[$x_5] = f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var $x_6 = i;
          var x0$3 = xs.u[i];
          ys.u[$x_6] = f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$4 = xs.u[i];
          ys.u[$x_7] = f($bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$5 = xs.u[i];
          ys.u[$x_8] = f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$6 = xs.u[i];
          ys.u[$x_9] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$7 = xs.u[i];
          ys.u[$x_10] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    }
    var $x_1 = componentCodecs$lzy1$1.initialize__O__O(ys);
  }
  return $x_1;
}
export { $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT1$1__sr_LazyRef__ALscodec_Codec as $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT1$1__sr_LazyRef__ALscodec_Codec };
function $p_Lframework_data_PageCursorDirection$__componentCodecs$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy1$2) {
  return (componentCodecs$lzy1$2.sr_LazyRef__f__initialized ? componentCodecs$lzy1$2.sr_LazyRef__f__value : $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT1$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy1$2));
}
export { $p_Lframework_data_PageCursorDirection$__componentCodecs$1__sr_LazyRef__ALscodec_Codec as $p_Lframework_data_PageCursorDirection$__componentCodecs$1__sr_LazyRef__ALscodec_Codec };
function $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT2$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy2$1) {
  if (componentCodecs$lzy2$1.sr_LazyRef__f__initialized) {
    var $x_1 = componentCodecs$lzy2$1.sr_LazyRef__f__value;
  } else {
    var this$2 = $m_sci_Nil$();
    var destination = new ($d_Lscodec_Codec.getArrayOf().constr)(0);
    $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this$2, destination, 0, 2147483647);
    var Tuple_this = $m_T$package$EmptyTuple$();
    var this$4 = new $c_s_Product$$anon$1(Tuple_this);
    var labels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$4);
    var xs = $m_sc_ArrayOps$().zip$extension__O__sc_IterableOnce__AT2(destination, labels);
    var f = ((x$1) => {
      var codec = x$1._1__O();
      var label = x$1._2__O();
      return new $c_Lscodec_Codec$$anon$7(label, codec);
    });
    var len = xs.u.length;
    var ys = new ($d_Lscodec_Codec.getArrayOf().constr)(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0 = xs.u[i];
          ys.u[$x_2] = f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$1 = xs.u[i];
          ys.u[$x_3] = f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var $x_4 = i;
          var x0$2 = xs.u[i];
          ys.u[$x_4] = f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var $x_5 = i;
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.u[$x_5] = f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var $x_6 = i;
          var x0$3 = xs.u[i];
          ys.u[$x_6] = f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$4 = xs.u[i];
          ys.u[$x_7] = f($bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$5 = xs.u[i];
          ys.u[$x_8] = f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$6 = xs.u[i];
          ys.u[$x_9] = f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$7 = xs.u[i];
          ys.u[$x_10] = f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    }
    var $x_1 = componentCodecs$lzy2$1.initialize__O__O(ys);
  }
  return $x_1;
}
export { $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT2$1__sr_LazyRef__ALscodec_Codec as $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT2$1__sr_LazyRef__ALscodec_Codec };
function $p_Lframework_data_PageCursorDirection$__componentCodecs$2__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy2$2) {
  return (componentCodecs$lzy2$2.sr_LazyRef__f__initialized ? componentCodecs$lzy2$2.sr_LazyRef__f__value : $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT2$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy2$2));
}
export { $p_Lframework_data_PageCursorDirection$__componentCodecs$2__sr_LazyRef__ALscodec_Codec as $p_Lframework_data_PageCursorDirection$__componentCodecs$2__sr_LazyRef__ALscodec_Codec };
function $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT3$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy3$1) {
  if (componentCodecs$lzy3$1.sr_LazyRef__f__initialized) {
    var $x_1 = componentCodecs$lzy3$1.sr_LazyRef__f__value;
  } else {
    var acc$proxy1 = $m_sci_Nil$();
    var m$proxy2 = $s_Lframework_data_PageCursorDirection$__Forward__Lframework_data_PageCursorDirection();
    var componentCodecs$lzy1 = new $c_sr_LazyRef();
    var componentCodecs$lzy1$2$1 = componentCodecs$lzy1;
    var this$4 = new $c_Lscodec_Codec$inlineImplementations$TupleCodec(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((componentCodecs$lzy1$2) => (() => $p_Lframework_data_PageCursorDirection$__componentCodecs$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy1$2)))(componentCodecs$lzy1$2$1)));
    var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((met) => m$proxy2));
    var g = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a) => $m_sr_Tuples$().fromProduct__s_Product__s_Product(a)));
    var elem$1 = new $c_Lscodec_Codec$$anon$2(g, f, this$4);
    var acc$proxy2 = new $c_sci_$colon$colon(elem$1, acc$proxy1);
    var m$proxy3 = $s_Lframework_data_PageCursorDirection$__Backward__Lframework_data_PageCursorDirection();
    var componentCodecs$lzy2 = new $c_sr_LazyRef();
    var componentCodecs$lzy2$2$1 = componentCodecs$lzy2;
    var this$7 = new $c_Lscodec_Codec$inlineImplementations$TupleCodec(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((componentCodecs$lzy2$2) => (() => $p_Lframework_data_PageCursorDirection$__componentCodecs$2__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy2$2)))(componentCodecs$lzy2$2$1)));
    var f$1 = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((met$2) => m$proxy3));
    var g$1 = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((a$2) => $m_sr_Tuples$().fromProduct__s_Product__s_Product(a$2)));
    var elem$1$2 = new $c_Lscodec_Codec$$anon$2(g$1, f$1, this$7);
    var this$9 = new $c_sci_$colon$colon(elem$1$2, acc$proxy2);
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$9);
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
    }
    var unlabelled = new ($d_Lscodec_Codec.getArrayOf().constr)(jsElems);
    var Tuple_this = $ct_T2__O__O__(new $c_T2(), "Backward", "Forward");
    var this$14 = new $c_sr_ScalaRunTime$$anon$1(Tuple_this);
    var labels = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$14);
    var xs = $m_sc_ArrayOps$().zip$extension__O__sc_IterableOnce__AT2(unlabelled, labels);
    var f$2 = ((x$1) => {
      var codec = x$1._1__O();
      var label = x$1._2__O();
      return new $c_Lscodec_Codec$$anon$7(label, codec);
    });
    var len = xs.u.length;
    var ys = new ($d_Lscodec_Codec.getArrayOf().constr)(len);
    if ((len > 0)) {
      var i = 0;
      if ((xs !== null)) {
        while ((i < len)) {
          var $x_2 = i;
          var x0 = xs.u[i];
          ys.u[$x_2] = f$2(x0);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_I)) {
        while ((i < len)) {
          var $x_3 = i;
          var x0$1 = xs.u[i];
          ys.u[$x_3] = f$2(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_D)) {
        while ((i < len)) {
          var $x_4 = i;
          var x0$2 = xs.u[i];
          ys.u[$x_4] = f$2(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_J)) {
        while ((i < len)) {
          var $x_5 = i;
          var t = xs.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          ys.u[$x_5] = f$2(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_F)) {
        while ((i < len)) {
          var $x_6 = i;
          var x0$3 = xs.u[i];
          ys.u[$x_6] = f$2(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_C)) {
        while ((i < len)) {
          var $x_7 = i;
          var x0$4 = xs.u[i];
          ys.u[$x_7] = f$2($bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_B)) {
        while ((i < len)) {
          var $x_8 = i;
          var x0$5 = xs.u[i];
          ys.u[$x_8] = f$2(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_S)) {
        while ((i < len)) {
          var $x_9 = i;
          var x0$6 = xs.u[i];
          ys.u[$x_9] = f$2(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((xs instanceof $ac_Z)) {
        while ((i < len)) {
          var $x_10 = i;
          var x0$7 = xs.u[i];
          ys.u[$x_10] = f$2(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(xs);
      }
    }
    var $x_1 = componentCodecs$lzy3$1.initialize__O__O(ys);
  }
  return $x_1;
}
export { $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT3$1__sr_LazyRef__ALscodec_Codec as $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT3$1__sr_LazyRef__ALscodec_Codec };
function $p_Lframework_data_PageCursorDirection$__componentCodecs$3__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy3$2) {
  return (componentCodecs$lzy3$2.sr_LazyRef__f__initialized ? componentCodecs$lzy3$2.sr_LazyRef__f__value : $p_Lframework_data_PageCursorDirection$__componentCodecs$lzyINIT3$1__sr_LazyRef__ALscodec_Codec($thiz, componentCodecs$lzy3$2));
}
export { $p_Lframework_data_PageCursorDirection$__componentCodecs$3__sr_LazyRef__ALscodec_Codec as $p_Lframework_data_PageCursorDirection$__componentCodecs$3__sr_LazyRef__ALscodec_Codec };
function $s_Lframework_data_PageCursorDirection$__Backward__Lframework_data_PageCursorDirection() {
  $m_Lframework_data_PageCursorDirection$();
  return $t_Lframework_data_PageCursorDirection$__Backward;
}
export { $s_Lframework_data_PageCursorDirection$__Backward__Lframework_data_PageCursorDirection as $s_Lframework_data_PageCursorDirection$__Backward__Lframework_data_PageCursorDirection };
function $s_Lframework_data_PageCursorDirection$__Forward__Lframework_data_PageCursorDirection() {
  $m_Lframework_data_PageCursorDirection$();
  return $t_Lframework_data_PageCursorDirection$__Forward;
}
export { $s_Lframework_data_PageCursorDirection$__Forward__Lframework_data_PageCursorDirection as $s_Lframework_data_PageCursorDirection$__Forward__Lframework_data_PageCursorDirection };
/** @constructor */
function $c_Lframework_data_PageCursorDirection$() {
  this.Lframework_data_PageCursorDirection$__f_$values = null;
  this.Lframework_data_PageCursorDirection$__f_schema$lzy1 = null;
  this.Lframework_data_PageCursorDirection$__f_schemabitmap$1 = false;
  this.Lframework_data_PageCursorDirection$__f_scodecCodec$lzy1 = null;
  this.Lframework_data_PageCursorDirection$__f_scodecCodecbitmap$1 = false;
  $n_Lframework_data_PageCursorDirection$ = this;
  $t_Lframework_data_PageCursorDirection$__Backward = new $c_Lframework_data_PageCursorDirection$$anon$1("Backward", 0);
  $t_Lframework_data_PageCursorDirection$__Forward = new $c_Lframework_data_PageCursorDirection$$anon$1("Forward", 1);
  this.Lframework_data_PageCursorDirection$__f_$values = new ($d_Lframework_data_PageCursorDirection.getArrayOf().constr)([$s_Lframework_data_PageCursorDirection$__Backward__Lframework_data_PageCursorDirection(), $s_Lframework_data_PageCursorDirection$__Forward__Lframework_data_PageCursorDirection()]);
}
export { $c_Lframework_data_PageCursorDirection$ as $c_Lframework_data_PageCursorDirection$ };
$c_Lframework_data_PageCursorDirection$.prototype = new $h_O();
$c_Lframework_data_PageCursorDirection$.prototype.constructor = $c_Lframework_data_PageCursorDirection$;
/** @constructor */
function $h_Lframework_data_PageCursorDirection$() {
}
export { $h_Lframework_data_PageCursorDirection$ as $h_Lframework_data_PageCursorDirection$ };
$h_Lframework_data_PageCursorDirection$.prototype = $c_Lframework_data_PageCursorDirection$.prototype;
$c_Lframework_data_PageCursorDirection$.prototype.values__ALframework_data_PageCursorDirection = (function() {
  var this$1 = this.Lframework_data_PageCursorDirection$__f_$values;
  return this$1.clone__O();
});
$c_Lframework_data_PageCursorDirection$.prototype.schema__Lsttp_tapir_Schema = (function() {
  if ((!this.Lframework_data_PageCursorDirection$__f_schemabitmap$1)) {
    var this$1 = $m_Lframework_data_PageCursorDirection$namedEnum$();
    this.Lframework_data_PageCursorDirection$__f_schema$lzy1 = $f_Lframework_utils_NamedEnum__schema__Lsttp_tapir_Schema(this$1);
    this.Lframework_data_PageCursorDirection$__f_schemabitmap$1 = true;
  }
  return this.Lframework_data_PageCursorDirection$__f_schema$lzy1;
});
$c_Lframework_data_PageCursorDirection$.prototype.scodecCodec__Lscodec_Codec = (function() {
  if ((!this.Lframework_data_PageCursorDirection$__f_scodecCodecbitmap$1)) {
    var m$proxy1 = $m_Lframework_data_PageCursorDirection$();
    var componentCodecs$lzy3 = new $c_sr_LazyRef();
    var componentCodecs$lzy3$2$1 = componentCodecs$lzy3;
    this.Lframework_data_PageCursorDirection$__f_scodecCodec$lzy1 = new $c_Lscodec_Codec$inlineImplementations$SumCodec(m$proxy1, new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((componentCodecs$lzy3$2) => (() => $p_Lframework_data_PageCursorDirection$__componentCodecs$3__sr_LazyRef__ALscodec_Codec(this, componentCodecs$lzy3$2)))(componentCodecs$lzy3$2$1)));
    this.Lframework_data_PageCursorDirection$__f_scodecCodecbitmap$1 = true;
  }
  return this.Lframework_data_PageCursorDirection$__f_scodecCodec$lzy1;
});
$c_Lframework_data_PageCursorDirection$.prototype.ordinal__O__I = (function(x) {
  return x.Lframework_data_PageCursorDirection$$anon$1__f__$ordinal$1;
});
var $d_Lframework_data_PageCursorDirection$ = new $TypeData().initClass($c_Lframework_data_PageCursorDirection$, "framework.data.PageCursorDirection$", ({
  Lframework_data_PageCursorDirection$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lframework_data_PageCursorDirection$ as $d_Lframework_data_PageCursorDirection$ };
var $n_Lframework_data_PageCursorDirection$;
function $m_Lframework_data_PageCursorDirection$() {
  if ((!$n_Lframework_data_PageCursorDirection$)) {
    $n_Lframework_data_PageCursorDirection$ = new $c_Lframework_data_PageCursorDirection$();
  }
  return $n_Lframework_data_PageCursorDirection$;
}
export { $m_Lframework_data_PageCursorDirection$ as $m_Lframework_data_PageCursorDirection$ };
/** @constructor */
function $c_Lframework_localization_LocalizationSupport$$anon$5(localize$5, outer) {
  this.Lframework_localization_LocalizationSupport$$anon$5__f_localize$2 = null;
  this.Lframework_localization_LocalizationSupport$$anon$5__f_$outer = null;
  this.Lframework_localization_LocalizationSupport$$anon$5__f_localize$2 = localize$5;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_localization_LocalizationSupport$$anon$5__f_$outer = outer;
}
export { $c_Lframework_localization_LocalizationSupport$$anon$5 as $c_Lframework_localization_LocalizationSupport$$anon$5 };
$c_Lframework_localization_LocalizationSupport$$anon$5.prototype = new $h_O();
$c_Lframework_localization_LocalizationSupport$$anon$5.prototype.constructor = $c_Lframework_localization_LocalizationSupport$$anon$5;
/** @constructor */
function $h_Lframework_localization_LocalizationSupport$$anon$5() {
}
export { $h_Lframework_localization_LocalizationSupport$$anon$5 as $h_Lframework_localization_LocalizationSupport$$anon$5 };
$h_Lframework_localization_LocalizationSupport$$anon$5.prototype = $c_Lframework_localization_LocalizationSupport$$anon$5.prototype;
$c_Lframework_localization_LocalizationSupport$$anon$5.prototype.text__O__T = (function(locale) {
  return this.Lframework_localization_LocalizationSupport$$anon$5__f_localize$2.apply__O__O(locale);
});
$c_Lframework_localization_LocalizationSupport$$anon$5.prototype.framework$localization$LocalizationSupport$LocalizedText$$$outer__Lframework_localization_LocalizationSupport = (function() {
  return this.Lframework_localization_LocalizationSupport$$anon$5__f_$outer.Lframework_localization_LocalizationSupport$LocalizedTextOf$__f_$outer;
});
var $d_Lframework_localization_LocalizationSupport$$anon$5 = new $TypeData().initClass($c_Lframework_localization_LocalizationSupport$$anon$5, "framework.localization.LocalizationSupport$$anon$5", ({
  Lframework_localization_LocalizationSupport$$anon$5: 1,
  Lframework_localization_LocalizationSupport$LocalizedText: 1,
  Lframework_localization_LocalizationSupport$LocalizedTextOf: 1
}));
export { $d_Lframework_localization_LocalizationSupport$$anon$5 as $d_Lframework_localization_LocalizationSupport$$anon$5 };
/** @constructor */
function $c_Lframework_localization_LocalizationSupport$$anon$6(localizedText$2, outer) {
  this.Lframework_localization_LocalizationSupport$$anon$6__f_localizedText$1 = null;
  this.Lframework_localization_LocalizationSupport$$anon$6__f_$outer = null;
  this.Lframework_localization_LocalizationSupport$$anon$6__f_localizedText$1 = localizedText$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_localization_LocalizationSupport$$anon$6__f_$outer = outer;
}
export { $c_Lframework_localization_LocalizationSupport$$anon$6 as $c_Lframework_localization_LocalizationSupport$$anon$6 };
$c_Lframework_localization_LocalizationSupport$$anon$6.prototype = new $h_O();
$c_Lframework_localization_LocalizationSupport$$anon$6.prototype.constructor = $c_Lframework_localization_LocalizationSupport$$anon$6;
/** @constructor */
function $h_Lframework_localization_LocalizationSupport$$anon$6() {
}
export { $h_Lframework_localization_LocalizationSupport$$anon$6 as $h_Lframework_localization_LocalizationSupport$$anon$6 };
$h_Lframework_localization_LocalizationSupport$$anon$6.prototype = $c_Lframework_localization_LocalizationSupport$$anon$6.prototype;
$c_Lframework_localization_LocalizationSupport$$anon$6.prototype.text__O__T = (function(x$1) {
  return this.Lframework_localization_LocalizationSupport$$anon$6__f_localizedText$1.text__O__T(x$1);
});
$c_Lframework_localization_LocalizationSupport$$anon$6.prototype.framework$localization$LocalizationSupport$LocalizedText$$$outer__Lframework_localization_LocalizationSupport = (function() {
  return this.Lframework_localization_LocalizationSupport$$anon$6__f_$outer.Lframework_localization_LocalizationSupport$LocalizedTextOf$__f_$outer;
});
var $d_Lframework_localization_LocalizationSupport$$anon$6 = new $TypeData().initClass($c_Lframework_localization_LocalizationSupport$$anon$6, "framework.localization.LocalizationSupport$$anon$6", ({
  Lframework_localization_LocalizationSupport$$anon$6: 1,
  Lframework_localization_LocalizationSupport$LocalizedText: 1,
  Lframework_localization_LocalizationSupport$LocalizedTextOf: 1
}));
export { $d_Lframework_localization_LocalizationSupport$$anon$6 as $d_Lframework_localization_LocalizationSupport$$anon$6 };
/** @constructor */
function $c_Lframework_localization_LocalizationSupport$$anon$7(outer) {
  this.Lframework_localization_LocalizationSupport$$anon$7__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_localization_LocalizationSupport$$anon$7__f_$outer = outer;
}
export { $c_Lframework_localization_LocalizationSupport$$anon$7 as $c_Lframework_localization_LocalizationSupport$$anon$7 };
$c_Lframework_localization_LocalizationSupport$$anon$7.prototype = new $h_s_Conversion();
$c_Lframework_localization_LocalizationSupport$$anon$7.prototype.constructor = $c_Lframework_localization_LocalizationSupport$$anon$7;
/** @constructor */
function $h_Lframework_localization_LocalizationSupport$$anon$7() {
}
export { $h_Lframework_localization_LocalizationSupport$$anon$7 as $h_Lframework_localization_LocalizationSupport$$anon$7 };
$h_Lframework_localization_LocalizationSupport$$anon$7.prototype = $c_Lframework_localization_LocalizationSupport$$anon$7.prototype;
$c_Lframework_localization_LocalizationSupport$$anon$7.prototype.apply__Lframework_localization_LocalizationSupport$LocalizedText__Lframework_localization_LocalizationSupport$LocalizedTextOf = (function(localizedText) {
  var this$1 = this.Lframework_localization_LocalizationSupport$$anon$7__f_$outer;
  return new $c_Lframework_localization_LocalizationSupport$$anon$6(localizedText, this$1);
});
$c_Lframework_localization_LocalizationSupport$$anon$7.prototype.apply__O__O = (function(x) {
  return this.apply__Lframework_localization_LocalizationSupport$LocalizedText__Lframework_localization_LocalizationSupport$LocalizedTextOf(x);
});
var $d_Lframework_localization_LocalizationSupport$$anon$7 = new $TypeData().initClass($c_Lframework_localization_LocalizationSupport$$anon$7, "framework.localization.LocalizationSupport$$anon$7", ({
  Lframework_localization_LocalizationSupport$$anon$7: 1,
  s_Conversion: 1,
  F1: 1
}));
export { $d_Lframework_localization_LocalizationSupport$$anon$7 as $d_Lframework_localization_LocalizationSupport$$anon$7 };
/** @constructor */
function $c_Lframework_utils_NewtypeInt$$anon$2(outer) {
  this.Lframework_utils_NewtypeInt$$anon$2__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_utils_NewtypeInt$$anon$2__f_$outer = outer;
}
export { $c_Lframework_utils_NewtypeInt$$anon$2 as $c_Lframework_utils_NewtypeInt$$anon$2 };
$c_Lframework_utils_NewtypeInt$$anon$2.prototype = new $h_s_Conversion();
$c_Lframework_utils_NewtypeInt$$anon$2.prototype.constructor = $c_Lframework_utils_NewtypeInt$$anon$2;
/** @constructor */
function $h_Lframework_utils_NewtypeInt$$anon$2() {
}
export { $h_Lframework_utils_NewtypeInt$$anon$2 as $h_Lframework_utils_NewtypeInt$$anon$2 };
$h_Lframework_utils_NewtypeInt$$anon$2.prototype = $c_Lframework_utils_NewtypeInt$$anon$2.prototype;
$c_Lframework_utils_NewtypeInt$$anon$2.prototype.apply__I__I = (function(v) {
  return v;
});
$c_Lframework_utils_NewtypeInt$$anon$2.prototype.apply__O__O = (function(x) {
  return this.apply__I__I((x | 0));
});
var $d_Lframework_utils_NewtypeInt$$anon$2 = new $TypeData().initClass($c_Lframework_utils_NewtypeInt$$anon$2, "framework.utils.NewtypeInt$$anon$2", ({
  Lframework_utils_NewtypeInt$$anon$2: 1,
  s_Conversion: 1,
  F1: 1
}));
export { $d_Lframework_utils_NewtypeInt$$anon$2 as $d_Lframework_utils_NewtypeInt$$anon$2 };
function $isArrayOf_Lio_circe_BiggerDecimalJsonNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_BiggerDecimalJsonNumber)));
}
export { $isArrayOf_Lio_circe_BiggerDecimalJsonNumber as $isArrayOf_Lio_circe_BiggerDecimalJsonNumber };
/** @constructor */
function $c_Lio_circe_Codec$$anon$1() {
}
export { $c_Lio_circe_Codec$$anon$1 as $c_Lio_circe_Codec$$anon$1 };
$c_Lio_circe_Codec$$anon$1.prototype = new $h_O();
$c_Lio_circe_Codec$$anon$1.prototype.constructor = $c_Lio_circe_Codec$$anon$1;
/** @constructor */
function $h_Lio_circe_Codec$$anon$1() {
}
export { $h_Lio_circe_Codec$$anon$1 as $h_Lio_circe_Codec$$anon$1 };
$h_Lio_circe_Codec$$anon$1.prototype = $c_Lio_circe_Codec$$anon$1.prototype;
$c_Lio_circe_Codec$$anon$1.prototype.imap__Lio_circe_Codec__F1__F1__Lio_circe_Codec = (function(fa, f, g) {
  var decodeA = new $c_Lio_circe_Decoder$$anon$1(f, fa);
  var encodeA = new $c_Lio_circe_Encoder$$anon$1(g, fa);
  return new $c_Lio_circe_Codec$$anon$4(decodeA, encodeA);
});
$c_Lio_circe_Codec$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.imap__Lio_circe_Codec__F1__F1__Lio_circe_Codec(fa, f, g);
});
var $d_Lio_circe_Codec$$anon$1 = new $TypeData().initClass($c_Lio_circe_Codec$$anon$1, "io.circe.Codec$$anon$1", ({
  Lio_circe_Codec$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1
}));
export { $d_Lio_circe_Codec$$anon$1 as $d_Lio_circe_Codec$$anon$1 };
/** @constructor */
function $c_Lio_circe_CursorOp$() {
  this.Lio_circe_CursorOp$__f_showCursorOp = null;
  this.Lio_circe_CursorOp$__f_eqCursorOp = null;
  this.Lio_circe_CursorOp$__f_eqCursorOpList = null;
  $n_Lio_circe_CursorOp$ = this;
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    var x = $m_Lio_circe_CursorOp$MoveLeft$();
    if ((x === x$1)) {
      return "<-";
    }
    var x$3 = $m_Lio_circe_CursorOp$MoveRight$();
    if ((x$3 === x$1)) {
      return "->";
    }
    var x$5 = $m_Lio_circe_CursorOp$MoveUp$();
    if ((x$5 === x$1)) {
      return "_/";
    }
    if (false) {
      var x32 = x$1.Lio_circe_CursorOp$Field__f_k;
      return (("--(" + x32) + ")");
    }
    if ((x$1 instanceof $c_Lio_circe_CursorOp$DownField)) {
      var x29 = x$1.Lio_circe_CursorOp$DownField__f_k;
      return (("--\\(" + x29) + ")");
    }
    var x$7 = $m_Lio_circe_CursorOp$DownArray$();
    if ((x$7 === x$1)) {
      return "\\\\";
    }
    if ((x$1 instanceof $c_Lio_circe_CursorOp$DownN)) {
      var x26 = x$1.Lio_circe_CursorOp$DownN__f_n;
      return (("=\\(" + x26) + ")");
    }
    var x$9 = $m_Lio_circe_CursorOp$DeleteGoParent$();
    if ((x$9 === x$1)) {
      return "!_/";
    }
    throw new $c_s_MatchError(x$1);
  }));
  this.Lio_circe_CursorOp$__f_showCursorOp = new $c_Lcats_Show$$anon$4(f);
  this.Lio_circe_CursorOp$__f_eqCursorOp = ($m_Lcats_package$(), new $c_Lcats_kernel_Eq$$anon$6());
  $m_Lcats_instances_package$list$();
  var evidence$1 = this.Lio_circe_CursorOp$__f_eqCursorOp;
  this.Lio_circe_CursorOp$__f_eqCursorOpList = new $c_Lcats_kernel_instances_ListEq(evidence$1);
}
export { $c_Lio_circe_CursorOp$ as $c_Lio_circe_CursorOp$ };
$c_Lio_circe_CursorOp$.prototype = new $h_O();
$c_Lio_circe_CursorOp$.prototype.constructor = $c_Lio_circe_CursorOp$;
/** @constructor */
function $h_Lio_circe_CursorOp$() {
}
export { $h_Lio_circe_CursorOp$ as $h_Lio_circe_CursorOp$ };
$h_Lio_circe_CursorOp$.prototype = $c_Lio_circe_CursorOp$.prototype;
$c_Lio_circe_CursorOp$.prototype.opsToPath__sci_List__T = (function(history) {
  var z = $m_sci_Nil$();
  var acc = z;
  var these = history.reverse__sci_List();
  while ((!these.isEmpty__Z())) {
    var x0 = these.head__O();
    var x1 = acc;
    matchResult30: {
      if ((x0 instanceof $c_Lio_circe_CursorOp$DownField)) {
        var x75 = x0.Lio_circe_CursorOp$DownField__f_k;
        var elem$1 = new $c_Lio_circe_CursorOp$SelectField(x75);
        acc = new $c_sci_$colon$colon(elem$1, x1);
        break matchResult30;
      }
      var x = $m_Lio_circe_CursorOp$DownArray$();
      if ((x === x0)) {
        var elem$2 = new $c_Lio_circe_CursorOp$SelectIndex(0);
        acc = new $c_sci_$colon$colon(elem$2, x1);
        break matchResult30;
      }
      var x$4 = $m_Lio_circe_CursorOp$MoveUp$();
      if (((x$4 === x0) && (x1 instanceof $c_sci_$colon$colon))) {
        var x68 = x1.sci_$colon$colon__f_next;
        acc = x68;
        break matchResult30;
      }
      var x$6 = $m_Lio_circe_CursorOp$MoveRight$();
      if (((x$6 === x0) && (x1 instanceof $c_sci_$colon$colon))) {
        var x59 = x1.sci_$colon$colon__f_head;
        var x60 = x1.sci_$colon$colon__f_next;
        if ((x59 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
          var x63 = x59.Lio_circe_CursorOp$SelectIndex__f_index;
          var index = ((1 + x63) | 0);
          var elem$3 = new $c_Lio_circe_CursorOp$SelectIndex(index);
          acc = new $c_sci_$colon$colon(elem$3, x60);
          break matchResult30;
        }
      }
      var x$8 = $m_Lio_circe_CursorOp$MoveLeft$();
      if (((x$8 === x0) && (x1 instanceof $c_sci_$colon$colon))) {
        var x51 = x1.sci_$colon$colon__f_head;
        var x52 = x1.sci_$colon$colon__f_next;
        if ((x51 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
          var x55 = x51.Lio_circe_CursorOp$SelectIndex__f_index;
          var index$1 = (((-1) + x55) | 0);
          var elem$4 = new $c_Lio_circe_CursorOp$SelectIndex(index$1);
          acc = new $c_sci_$colon$colon(elem$4, x52);
          break matchResult30;
        }
      }
      var elem$5 = new $c_Lio_circe_CursorOp$Op(x0);
      acc = new $c_sci_$colon$colon(elem$5, x1);
    }
    these = these.tail__O();
  }
  var selections = acc;
  var acc$1 = "";
  var these$1 = selections;
  while ((!these$1.isEmpty__Z())) {
    var x0$1 = acc$1;
    var x1$1 = these$1.head__O();
    matchResult31: {
      var x76 = $ct_T2__O__O__(new $c_T2(), x0$1, x1$1);
      var x87 = x76.T2__f__1;
      var x88 = x76.T2__f__2;
      if ((x88 instanceof $c_Lio_circe_CursorOp$SelectField)) {
        var x91 = x88.Lio_circe_CursorOp$SelectField__f_field;
        acc$1 = (("." + x91) + x87);
        break matchResult31;
      }
      if ((x88 instanceof $c_Lio_circe_CursorOp$SelectIndex)) {
        var x86 = x88.Lio_circe_CursorOp$SelectIndex__f_index;
        acc$1 = ((("[" + x86) + "]") + x87);
        break matchResult31;
      }
      if ((x88 instanceof $c_Lio_circe_CursorOp$Op)) {
        var x81 = x88.Lio_circe_CursorOp$Op__f_op;
        var instance = $m_Lio_circe_CursorOp$().Lio_circe_CursorOp$__f_showCursorOp;
        acc$1 = ((("{" + instance.show__O__T(x81)) + "}") + x87);
        break matchResult31;
      }
      throw new $c_s_MatchError(x76);
    }
    these$1 = these$1.tail__O();
  }
  return acc$1;
});
$c_Lio_circe_CursorOp$.prototype.ordinal__Lio_circe_CursorOp__I = (function(x$0) {
  if ((x$0 instanceof $c_Lio_circe_CursorOp$ObjectOp)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lio_circe_CursorOp$ArrayOp)) {
    return 1;
  }
  if ((x$0 instanceof $c_Lio_circe_CursorOp$UnconstrainedOp)) {
    return 2;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lio_circe_CursorOp$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lio_circe_CursorOp__I(x);
});
var $d_Lio_circe_CursorOp$ = new $TypeData().initClass($c_Lio_circe_CursorOp$, "io.circe.CursorOp$", ({
  Lio_circe_CursorOp$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lio_circe_CursorOp$ as $d_Lio_circe_CursorOp$ };
var $n_Lio_circe_CursorOp$;
function $m_Lio_circe_CursorOp$() {
  if ((!$n_Lio_circe_CursorOp$)) {
    $n_Lio_circe_CursorOp$ = new $c_Lio_circe_CursorOp$();
  }
  return $n_Lio_circe_CursorOp$;
}
export { $m_Lio_circe_CursorOp$ as $m_Lio_circe_CursorOp$ };
/** @constructor */
function $c_Lio_circe_Decoder$$anon$1(f$14, outer) {
  this.Lio_circe_Decoder$$anon$1__f_f$1 = null;
  this.Lio_circe_Decoder$$anon$1__f_$outer = null;
  this.Lio_circe_Decoder$$anon$1__f_f$1 = f$14;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lio_circe_Decoder$$anon$1__f_$outer = outer;
}
export { $c_Lio_circe_Decoder$$anon$1 as $c_Lio_circe_Decoder$$anon$1 };
$c_Lio_circe_Decoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$1.prototype.constructor = $c_Lio_circe_Decoder$$anon$1;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$1() {
}
export { $h_Lio_circe_Decoder$$anon$1 as $h_Lio_circe_Decoder$$anon$1 };
$h_Lio_circe_Decoder$$anon$1.prototype = $c_Lio_circe_Decoder$$anon$1.prototype;
$c_Lio_circe_Decoder$$anon$1.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c);
});
$c_Lio_circe_Decoder$$anon$1.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  var x12 = this.Lio_circe_Decoder$$anon$1__f_$outer.tryDecode__Lio_circe_ACursor__s_util_Either(c);
  if ((x12 instanceof $c_s_util_Right)) {
    var a = x12.s_util_Right__f_value;
    var value = this.Lio_circe_Decoder$$anon$1__f_f$1.apply__O__O(a);
    return new $c_s_util_Right(value);
  }
  if ((x12 instanceof $c_s_util_Left)) {
    return x12;
  }
  throw new $c_s_MatchError(x12);
});
$c_Lio_circe_Decoder$$anon$1.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return this.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(c);
});
$c_Lio_circe_Decoder$$anon$1.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return this.Lio_circe_Decoder$$anon$1__f_$outer.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(c).map__F1__Lcats_data_Validated(this.Lio_circe_Decoder$$anon$1__f_f$1);
});
var $d_Lio_circe_Decoder$$anon$1 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$1, "io.circe.Decoder$$anon$1", ({
  Lio_circe_Decoder$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
export { $d_Lio_circe_Decoder$$anon$1 as $d_Lio_circe_Decoder$$anon$1 };
/** @constructor */
function $c_Lio_circe_Decoder$$anon$13(f$18, outer) {
  this.Lio_circe_Decoder$$anon$13__f_f$5 = null;
  this.Lio_circe_Decoder$$anon$13__f_$outer = null;
  this.Lio_circe_Decoder$$anon$13__f_f$5 = f$18;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lio_circe_Decoder$$anon$13__f_$outer = outer;
}
export { $c_Lio_circe_Decoder$$anon$13 as $c_Lio_circe_Decoder$$anon$13 };
$c_Lio_circe_Decoder$$anon$13.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$13.prototype.constructor = $c_Lio_circe_Decoder$$anon$13;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$13() {
}
export { $h_Lio_circe_Decoder$$anon$13 as $h_Lio_circe_Decoder$$anon$13 };
$h_Lio_circe_Decoder$$anon$13.prototype = $c_Lio_circe_Decoder$$anon$13.prototype;
$c_Lio_circe_Decoder$$anon$13.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.tryDecode__Lio_circe_ACursor__s_util_Either(c);
});
$c_Lio_circe_Decoder$$anon$13.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  var x109 = this.Lio_circe_Decoder$$anon$13__f_$outer.tryDecode__Lio_circe_ACursor__s_util_Either(c);
  if ((x109 instanceof $c_s_util_Right)) {
    var a = x109.s_util_Right__f_value;
    var x104 = this.Lio_circe_Decoder$$anon$13__f_f$5.apply__O__O(a);
    if ((x104 instanceof $c_s_util_Right)) {
      return x104;
    }
    if ((x104 instanceof $c_s_util_Left)) {
      var message = x104.s_util_Left__f_value;
      var value = $m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure(message, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
      return new $c_s_util_Left(value);
    }
    throw new $c_s_MatchError(x104);
  }
  if ((x109 instanceof $c_s_util_Left)) {
    return x109;
  }
  throw new $c_s_MatchError(x109);
});
$c_Lio_circe_Decoder$$anon$13.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return this.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(c);
});
$c_Lio_circe_Decoder$$anon$13.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  var x119 = this.Lio_circe_Decoder$$anon$13__f_$outer.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(c);
  if ((x119 instanceof $c_Lcats_data_Validated$Valid)) {
    var x125 = x119.Lcats_data_Validated$Valid__f_a;
    var x114 = this.Lio_circe_Decoder$$anon$13__f_f$5.apply__O__O(x125);
    if ((x114 instanceof $c_s_util_Right)) {
      var b = x114.s_util_Right__f_value;
      $m_Lcats_data_Validated$();
      return new $c_Lcats_data_Validated$Valid(b);
    }
    if ((x114 instanceof $c_s_util_Left)) {
      var message = x114.s_util_Left__f_value;
      var this$4 = $m_Lcats_data_Validated$();
      var e = $m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure(message, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
      return $f_Lcats_data_ValidatedFunctions__invalidNel__O__Lcats_data_Validated(this$4, e);
    }
    throw new $c_s_MatchError(x114);
  }
  if ((x119 instanceof $c_Lcats_data_Validated$Invalid)) {
    return x119;
  }
  throw new $c_s_MatchError(x119);
});
var $d_Lio_circe_Decoder$$anon$13 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$13, "io.circe.Decoder$$anon$13", ({
  Lio_circe_Decoder$$anon$13: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
export { $d_Lio_circe_Decoder$$anon$13 as $d_Lio_circe_Decoder$$anon$13 };
/** @constructor */
function $c_Lio_circe_Decoder$$anon$19() {
}
export { $c_Lio_circe_Decoder$$anon$19 as $c_Lio_circe_Decoder$$anon$19 };
$c_Lio_circe_Decoder$$anon$19.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$19.prototype.constructor = $c_Lio_circe_Decoder$$anon$19;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$19() {
}
export { $h_Lio_circe_Decoder$$anon$19 as $h_Lio_circe_Decoder$$anon$19 };
$h_Lio_circe_Decoder$$anon$19.prototype = $c_Lio_circe_Decoder$$anon$19.prototype;
$c_Lio_circe_Decoder$$anon$19.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_Decoder$$anon$19.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_Decoder$$anon$19.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_Decoder$$anon$19.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x164 = c.value__Lio_circe_Json();
  if ((x164 instanceof $c_Lio_circe_Json$JString)) {
    var x167 = x164.Lio_circe_Json$JString__f_value;
    return new $c_s_util_Right(x167);
  }
  var value = $m_Lio_circe_DecodingFailure$().apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("string", x164), new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
  return new $c_s_util_Left(value);
});
var $d_Lio_circe_Decoder$$anon$19 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$19, "io.circe.Decoder$$anon$19", ({
  Lio_circe_Decoder$$anon$19: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
export { $d_Lio_circe_Decoder$$anon$19 as $d_Lio_circe_Decoder$$anon$19 };
/** @constructor */
function $c_Lio_circe_Decoder$$anon$21() {
}
export { $c_Lio_circe_Decoder$$anon$21 as $c_Lio_circe_Decoder$$anon$21 };
$c_Lio_circe_Decoder$$anon$21.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$21.prototype.constructor = $c_Lio_circe_Decoder$$anon$21;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$21() {
}
export { $h_Lio_circe_Decoder$$anon$21 as $h_Lio_circe_Decoder$$anon$21 };
$h_Lio_circe_Decoder$$anon$21.prototype = $c_Lio_circe_Decoder$$anon$21.prototype;
$c_Lio_circe_Decoder$$anon$21.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_Decoder$$anon$21.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_Decoder$$anon$21.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_Decoder$$anon$21.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x175 = c.value__Lio_circe_Json();
  if ((x175 instanceof $c_Lio_circe_Json$JBoolean)) {
    var x178 = x175.Lio_circe_Json$JBoolean__f_value;
    return new $c_s_util_Right(x178);
  }
  var value = $m_Lio_circe_DecodingFailure$().apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("'true' or 'false'", x175), new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
  return new $c_s_util_Left(value);
});
var $d_Lio_circe_Decoder$$anon$21 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$21, "io.circe.Decoder$$anon$21", ({
  Lio_circe_Decoder$$anon$21: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
export { $d_Lio_circe_Decoder$$anon$21 as $d_Lio_circe_Decoder$$anon$21 };
/** @constructor */
function $c_Lio_circe_Decoder$$anon$43() {
}
export { $c_Lio_circe_Decoder$$anon$43 as $c_Lio_circe_Decoder$$anon$43 };
$c_Lio_circe_Decoder$$anon$43.prototype = new $h_O();
$c_Lio_circe_Decoder$$anon$43.prototype.constructor = $c_Lio_circe_Decoder$$anon$43;
/** @constructor */
function $h_Lio_circe_Decoder$$anon$43() {
}
export { $h_Lio_circe_Decoder$$anon$43 as $h_Lio_circe_Decoder$$anon$43 };
$h_Lio_circe_Decoder$$anon$43.prototype = $c_Lio_circe_Decoder$$anon$43.prototype;
$c_Lio_circe_Decoder$$anon$43.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_Decoder$$anon$43.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_Decoder$$anon$43.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_Decoder$$anon$43.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x281 = c.value__Lio_circe_Json();
  if ((x281 instanceof $c_Lio_circe_Json$JString)) {
    var x284 = x281.Lio_circe_Json$JString__f_value;
    if ((x284.length === 36)) {
      try {
        var value = $m_ju_UUID$().fromString__T__ju_UUID(x284);
        return new $c_s_util_Right(value);
      } catch (e) {
        if ((e instanceof $c_jl_IllegalArgumentException)) {
          var value$1 = $m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure("Couldn't decode a valid UUID", new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
          return new $c_s_util_Left(value$1);
        } else {
          throw e;
        }
      }
    }
  }
  var value$2 = $m_Lio_circe_DecodingFailure$().apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation("string", x281), new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List())));
  return new $c_s_util_Left(value$2);
});
var $d_Lio_circe_Decoder$$anon$43 = new $TypeData().initClass($c_Lio_circe_Decoder$$anon$43, "io.circe.Decoder$$anon$43", ({
  Lio_circe_Decoder$$anon$43: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1
}));
export { $d_Lio_circe_Decoder$$anon$43 as $d_Lio_circe_Decoder$$anon$43 };
/** @constructor */
function $c_Lio_circe_Encoder$$anon$1(f$10, outer) {
  this.Lio_circe_Encoder$$anon$1__f_f$1 = null;
  this.Lio_circe_Encoder$$anon$1__f_$outer = null;
  this.Lio_circe_Encoder$$anon$1__f_f$1 = f$10;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lio_circe_Encoder$$anon$1__f_$outer = outer;
}
export { $c_Lio_circe_Encoder$$anon$1 as $c_Lio_circe_Encoder$$anon$1 };
$c_Lio_circe_Encoder$$anon$1.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$1.prototype.constructor = $c_Lio_circe_Encoder$$anon$1;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$1() {
}
export { $h_Lio_circe_Encoder$$anon$1 as $h_Lio_circe_Encoder$$anon$1 };
$h_Lio_circe_Encoder$$anon$1.prototype = $c_Lio_circe_Encoder$$anon$1.prototype;
$c_Lio_circe_Encoder$$anon$1.prototype.apply__O__Lio_circe_Json = (function(a) {
  return this.Lio_circe_Encoder$$anon$1__f_$outer.apply__O__Lio_circe_Json(this.Lio_circe_Encoder$$anon$1__f_f$1.apply__O__O(a));
});
var $d_Lio_circe_Encoder$$anon$1 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$1, "io.circe.Encoder$$anon$1", ({
  Lio_circe_Encoder$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
}));
export { $d_Lio_circe_Encoder$$anon$1 as $d_Lio_circe_Encoder$$anon$1 };
/** @constructor */
function $c_Lio_circe_Encoder$$anon$23() {
}
export { $c_Lio_circe_Encoder$$anon$23 as $c_Lio_circe_Encoder$$anon$23 };
$c_Lio_circe_Encoder$$anon$23.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$23.prototype.constructor = $c_Lio_circe_Encoder$$anon$23;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$23() {
}
export { $h_Lio_circe_Encoder$$anon$23 as $h_Lio_circe_Encoder$$anon$23 };
$h_Lio_circe_Encoder$$anon$23.prototype = $c_Lio_circe_Encoder$$anon$23.prototype;
$c_Lio_circe_Encoder$$anon$23.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $m_Lio_circe_Json$().fromString__T__Lio_circe_Json(a.toString__T());
});
var $d_Lio_circe_Encoder$$anon$23 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$23, "io.circe.Encoder$$anon$23", ({
  Lio_circe_Encoder$$anon$23: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
}));
export { $d_Lio_circe_Encoder$$anon$23 as $d_Lio_circe_Encoder$$anon$23 };
/** @constructor */
function $c_Lio_circe_Encoder$$anon$6() {
}
export { $c_Lio_circe_Encoder$$anon$6 as $c_Lio_circe_Encoder$$anon$6 };
$c_Lio_circe_Encoder$$anon$6.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$6.prototype.constructor = $c_Lio_circe_Encoder$$anon$6;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$6() {
}
export { $h_Lio_circe_Encoder$$anon$6 as $h_Lio_circe_Encoder$$anon$6 };
$h_Lio_circe_Encoder$$anon$6.prototype = $c_Lio_circe_Encoder$$anon$6.prototype;
$c_Lio_circe_Encoder$$anon$6.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $m_Lio_circe_Json$().fromString__T__Lio_circe_Json(a);
});
var $d_Lio_circe_Encoder$$anon$6 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$6, "io.circe.Encoder$$anon$6", ({
  Lio_circe_Encoder$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
}));
export { $d_Lio_circe_Encoder$$anon$6 as $d_Lio_circe_Encoder$$anon$6 };
/** @constructor */
function $c_Lio_circe_Encoder$$anon$8() {
}
export { $c_Lio_circe_Encoder$$anon$8 as $c_Lio_circe_Encoder$$anon$8 };
$c_Lio_circe_Encoder$$anon$8.prototype = new $h_O();
$c_Lio_circe_Encoder$$anon$8.prototype.constructor = $c_Lio_circe_Encoder$$anon$8;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$8() {
}
export { $h_Lio_circe_Encoder$$anon$8 as $h_Lio_circe_Encoder$$anon$8 };
$h_Lio_circe_Encoder$$anon$8.prototype = $c_Lio_circe_Encoder$$anon$8.prototype;
$c_Lio_circe_Encoder$$anon$8.prototype.apply__O__Lio_circe_Json = (function(a) {
  var a$1 = (!(!a));
  return $m_Lio_circe_Json$().fromBoolean__Z__Lio_circe_Json(a$1);
});
var $d_Lio_circe_Encoder$$anon$8 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$8, "io.circe.Encoder$$anon$8", ({
  Lio_circe_Encoder$$anon$8: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1
}));
export { $d_Lio_circe_Encoder$$anon$8 as $d_Lio_circe_Encoder$$anon$8 };
/** @constructor */
function $c_Lio_circe_FailedCursor(lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_FailedCursor__f_lastCursor = null;
  this.Lio_circe_FailedCursor__f_lastOp = null;
  this.Lio_circe_FailedCursor__f_lastCursor = lastCursor;
  this.Lio_circe_FailedCursor__f_lastOp = lastOp;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp);
}
export { $c_Lio_circe_FailedCursor as $c_Lio_circe_FailedCursor };
$c_Lio_circe_FailedCursor.prototype = new $h_Lio_circe_ACursor();
$c_Lio_circe_FailedCursor.prototype.constructor = $c_Lio_circe_FailedCursor;
/** @constructor */
function $h_Lio_circe_FailedCursor() {
}
export { $h_Lio_circe_FailedCursor as $h_Lio_circe_FailedCursor };
$h_Lio_circe_FailedCursor.prototype = $c_Lio_circe_FailedCursor.prototype;
$c_Lio_circe_FailedCursor.prototype.incorrectFocus__Z = (function() {
  return ((this.Lio_circe_FailedCursor__f_lastOp.requiresObject__Z() && (!this.Lio_circe_FailedCursor__f_lastCursor.value__Lio_circe_Json().isObject__Z())) || (this.Lio_circe_FailedCursor__f_lastOp.requiresArray__Z() && (!this.Lio_circe_FailedCursor__f_lastCursor.value__Lio_circe_Json().isArray__Z())));
});
$c_Lio_circe_FailedCursor.prototype.missingField__Z = (function() {
  var x1 = this.Lio_circe_FailedCursor__f_lastOp;
  matchAlts1: {
    matchAlts2: {
      if (false) {
        break matchAlts2;
      }
      if ((x1 instanceof $c_Lio_circe_CursorOp$DownField)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return true;
  }
  return false;
});
$c_Lio_circe_FailedCursor.prototype.succeeded__Z = (function() {
  return false;
});
$c_Lio_circe_FailedCursor.prototype.focus__s_Option = (function() {
  return $m_s_None$();
});
$c_Lio_circe_FailedCursor.prototype.right__Lio_circe_ACursor = (function() {
  return this;
});
$c_Lio_circe_FailedCursor.prototype.delete__Lio_circe_ACursor = (function() {
  return this;
});
function $isArrayOf_Lio_circe_FailedCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_FailedCursor)));
}
export { $isArrayOf_Lio_circe_FailedCursor as $isArrayOf_Lio_circe_FailedCursor };
var $d_Lio_circe_FailedCursor = new $TypeData().initClass($c_Lio_circe_FailedCursor, "io.circe.FailedCursor", ({
  Lio_circe_FailedCursor: 1,
  Lio_circe_ACursor: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_FailedCursor as $d_Lio_circe_FailedCursor };
/** @constructor */
function $c_Lio_circe_HCursor() {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
}
export { $c_Lio_circe_HCursor as $c_Lio_circe_HCursor };
$c_Lio_circe_HCursor.prototype = new $h_Lio_circe_ACursor();
$c_Lio_circe_HCursor.prototype.constructor = $c_Lio_circe_HCursor;
/** @constructor */
function $h_Lio_circe_HCursor() {
}
export { $h_Lio_circe_HCursor as $h_Lio_circe_HCursor };
$h_Lio_circe_HCursor.prototype = $c_Lio_circe_HCursor.prototype;
$c_Lio_circe_HCursor.prototype.succeeded__Z = (function() {
  return true;
});
$c_Lio_circe_HCursor.prototype.focus__s_Option = (function() {
  var value = this.value__Lio_circe_Json();
  return new $c_s_Some(value);
});
$c_Lio_circe_HCursor.prototype.keys__s_Option = (function() {
  var x5 = this.value__Lio_circe_Json();
  if ((x5 instanceof $c_Lio_circe_Json$JObject)) {
    var x8 = x5.Lio_circe_Json$JObject__f_value;
    var value = x8.keys__sc_Iterable();
    return new $c_s_Some(value);
  }
  return $m_s_None$();
});
$c_Lio_circe_HCursor.prototype.downArray__Lio_circe_ACursor = (function() {
  var x9 = this.value__Lio_circe_Json();
  if ((x9 instanceof $c_Lio_circe_Json$JArray)) {
    var x12 = x9.Lio_circe_Json$JArray__f_value;
    if ((!$f_sc_SeqOps__isEmpty__Z(x12))) {
      return new $c_Lio_circe_cursor_ArrayCursor(x12, 0, this, false, this, $m_Lio_circe_CursorOp$DownArray$());
    }
  }
  var op = $m_Lio_circe_CursorOp$DownArray$();
  return new $c_Lio_circe_FailedCursor(this, op);
});
$c_Lio_circe_HCursor.prototype.downField__T__Lio_circe_ACursor = (function(k) {
  var x15 = this.value__Lio_circe_Json();
  if ((x15 instanceof $c_Lio_circe_Json$JObject)) {
    var x18 = x15.Lio_circe_Json$JObject__f_value;
    if ((!x18.contains__T__Z(k))) {
      var op = new $c_Lio_circe_CursorOp$DownField(k);
      return new $c_Lio_circe_FailedCursor(this, op);
    } else {
      return new $c_Lio_circe_cursor_ObjectCursor(x18, k, this, false, this, new $c_Lio_circe_CursorOp$DownField(k));
    }
  }
  var op$1 = new $c_Lio_circe_CursorOp$DownField(k);
  return new $c_Lio_circe_FailedCursor(this, op$1);
});
$c_Lio_circe_HCursor.prototype.downN__I__Lio_circe_ACursor = (function(n) {
  var x19 = this.value__Lio_circe_Json();
  if ((x19 instanceof $c_Lio_circe_Json$JArray)) {
    var x22 = x19.Lio_circe_Json$JArray__f_value;
    if ((n >= 0)) {
      var x = x22.length__I();
      var $x_1 = (((x === n) ? 0 : ((x < n) ? (-1) : 1)) > 0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return new $c_Lio_circe_cursor_ArrayCursor(x22, n, this, false, this, new $c_Lio_circe_CursorOp$DownN(n));
    }
  }
  var op = new $c_Lio_circe_CursorOp$DownN(n);
  return new $c_Lio_circe_FailedCursor(this, op);
});
function $isArrayOf_Lio_circe_HCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_HCursor)));
}
export { $isArrayOf_Lio_circe_HCursor as $isArrayOf_Lio_circe_HCursor };
function $p_Lio_circe_Json$__arrayEq__sci_Vector__sci_Vector__Z($thiz, x, y) {
  if ((x.length__I() !== y.length__I())) {
    return false;
  }
  var it0 = x.iterator__sc_Iterator();
  var it1 = y.iterator__sc_Iterator();
  while (it0.hasNext__Z()) {
    if ($m_Lio_circe_Json$().Lio_circe_Json$__f_eqJson.neqv__O__O__Z(it0.next__O(), it1.next__O())) {
      return false;
    }
  }
  return true;
}
export { $p_Lio_circe_Json$__arrayEq__sci_Vector__sci_Vector__Z as $p_Lio_circe_Json$__arrayEq__sci_Vector__sci_Vector__Z };
/** @constructor */
function $c_Lio_circe_Json$() {
  this.Lio_circe_Json$__f_Null = null;
  this.Lio_circe_Json$__f_True = null;
  this.Lio_circe_Json$__f_False = null;
  this.Lio_circe_Json$__f_EmptyArray = null;
  this.Lio_circe_Json$__f_EmptyString = null;
  this.Lio_circe_Json$__f_eqJson = null;
  this.Lio_circe_Json$__f_showJson = null;
  $n_Lio_circe_Json$ = this;
  this.Lio_circe_Json$__f_Null = $m_Lio_circe_Json$JNull$();
  this.Lio_circe_Json$__f_True = new $c_Lio_circe_Json$JBoolean(true);
  this.Lio_circe_Json$__f_False = new $c_Lio_circe_Json$JBoolean(false);
  $m_sci_Vector$();
  var value = $m_sci_Vector0$();
  this.Lio_circe_Json$__f_EmptyArray = new $c_Lio_circe_Json$JArray(value);
  this.Lio_circe_Json$__f_EmptyString = new $c_Lio_circe_Json$JString("");
  $m_Lcats_package$();
  var f = new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => {
    if ((x$1 instanceof $c_Lio_circe_Json$JObject)) {
      var x146 = x$1.Lio_circe_Json$JObject__f_value;
      if ((x$2 instanceof $c_Lio_circe_Json$JObject)) {
        var x143 = x$2.Lio_circe_Json$JObject__f_value;
        return $m_Lio_circe_JsonObject$().Lio_circe_JsonObject$__f_eqJsonObject.eqv__O__O__Z(x146, x143);
      }
    }
    if ((x$1 instanceof $c_Lio_circe_Json$JString)) {
      var x138 = x$1.Lio_circe_Json$JString__f_value;
      if ((x$2 instanceof $c_Lio_circe_Json$JString)) {
        var x135 = x$2.Lio_circe_Json$JString__f_value;
        return (x138 === x135);
      }
    }
    if ((x$1 instanceof $c_Lio_circe_Json$JNumber)) {
      var x130 = x$1.Lio_circe_Json$JNumber__f_value;
      if ((x$2 instanceof $c_Lio_circe_Json$JNumber)) {
        var x127 = x$2.Lio_circe_Json$JNumber__f_value;
        return $m_Lio_circe_JsonNumber$().Lio_circe_JsonNumber$__f_eqJsonNumber.eqv__O__O__Z(x130, x127);
      }
    }
    if ((x$1 instanceof $c_Lio_circe_Json$JBoolean)) {
      var x122 = x$1.Lio_circe_Json$JBoolean__f_value;
      if ((x$2 instanceof $c_Lio_circe_Json$JBoolean)) {
        var x119 = x$2.Lio_circe_Json$JBoolean__f_value;
        return (x122 === x119);
      }
    }
    if ((x$1 instanceof $c_Lio_circe_Json$JArray)) {
      var x114 = x$1.Lio_circe_Json$JArray__f_value;
      if ((x$2 instanceof $c_Lio_circe_Json$JArray)) {
        var x111 = x$2.Lio_circe_Json$JArray__f_value;
        return $p_Lio_circe_Json$__arrayEq__sci_Vector__sci_Vector__Z(this, x114, x111);
      }
    }
    return (x$1.isNull__Z() && x$2.isNull__Z());
  }));
  this.Lio_circe_Json$__f_eqJson = new $c_Lcats_kernel_Eq$$anon$5(f);
  this.Lio_circe_Json$__f_showJson = new $c_Lcats_Show$$anon$5();
}
export { $c_Lio_circe_Json$ as $c_Lio_circe_Json$ };
$c_Lio_circe_Json$.prototype = new $h_O();
$c_Lio_circe_Json$.prototype.constructor = $c_Lio_circe_Json$;
/** @constructor */
function $h_Lio_circe_Json$() {
}
export { $h_Lio_circe_Json$ as $h_Lio_circe_Json$ };
$h_Lio_circe_Json$.prototype = $c_Lio_circe_Json$.prototype;
$c_Lio_circe_Json$.prototype.fromFields__sc_Iterable__Lio_circe_Json = (function(fields) {
  var value = $m_Lio_circe_JsonObject$().fromIterable__sc_Iterable__Lio_circe_JsonObject(fields);
  return new $c_Lio_circe_Json$JObject(value);
});
$c_Lio_circe_Json$.prototype.fromValues__sc_Iterable__Lio_circe_Json = (function(values) {
  if (values.isEmpty__Z()) {
    return this.Lio_circe_Json$__f_EmptyArray;
  } else {
    var value = values.toVector__sci_Vector();
    return new $c_Lio_circe_Json$JArray(value);
  }
});
$c_Lio_circe_Json$.prototype.fromString__T__Lio_circe_Json = (function(value) {
  return ((value === "") ? this.Lio_circe_Json$__f_EmptyString : new $c_Lio_circe_Json$JString(value));
});
$c_Lio_circe_Json$.prototype.fromBoolean__Z__Lio_circe_Json = (function(value) {
  return (value ? this.Lio_circe_Json$__f_True : this.Lio_circe_Json$__f_False);
});
$c_Lio_circe_Json$.prototype.fromDoubleOrNull__D__Lio_circe_Json = (function(value) {
  if (((value === value) && (!((value === Infinity) || (value === (-Infinity)))))) {
    var value$1 = new $c_Lio_circe_JsonDouble(value);
    return new $c_Lio_circe_Json$JNumber(value$1);
  } else {
    return this.Lio_circe_Json$__f_Null;
  }
});
$c_Lio_circe_Json$.prototype.ordinal__Lio_circe_Json__I = (function(x$0) {
  if ((x$0 === $m_Lio_circe_Json$JNull$())) {
    return 0;
  }
  if ((x$0 instanceof $c_Lio_circe_Json$JBoolean)) {
    return 1;
  }
  if ((x$0 instanceof $c_Lio_circe_Json$JNumber)) {
    return 2;
  }
  if ((x$0 instanceof $c_Lio_circe_Json$JString)) {
    return 3;
  }
  if ((x$0 instanceof $c_Lio_circe_Json$JArray)) {
    return 4;
  }
  if ((x$0 instanceof $c_Lio_circe_Json$JObject)) {
    return 5;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lio_circe_Json$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lio_circe_Json__I(x);
});
var $d_Lio_circe_Json$ = new $TypeData().initClass($c_Lio_circe_Json$, "io.circe.Json$", ({
  Lio_circe_Json$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lio_circe_Json$ as $d_Lio_circe_Json$ };
var $n_Lio_circe_Json$;
function $m_Lio_circe_Json$() {
  if ((!$n_Lio_circe_Json$)) {
    $n_Lio_circe_Json$ = new $c_Lio_circe_Json$();
  }
  return $n_Lio_circe_Json$;
}
export { $m_Lio_circe_Json$ as $m_Lio_circe_Json$ };
/** @constructor */
function $c_Lio_circe_JsonNumber$() {
  this.Lio_circe_JsonNumber$__f_jsonLongConstantPool = null;
  this.Lio_circe_JsonNumber$__f_bigDecimalMinLong = null;
  this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong = null;
  this.Lio_circe_JsonNumber$__f_eqJsonNumber = null;
  $n_Lio_circe_JsonNumber$ = this;
  var array = new ($d_Lio_circe_Json$JNumber.getArrayOf().constr)(256);
  var i = 0;
  while ((i < 256)) {
    var $x_1 = i;
    var x0 = i;
    var value = (((-128) + x0) | 0);
    var hi = (value >> 31);
    var value$1 = new $c_Lio_circe_JsonLong(new $c_RTLong(value, hi));
    array.u[$x_1] = new $c_Lio_circe_Json$JNumber(value$1);
    i = ((1 + i) | 0);
  }
  this.Lio_circe_JsonNumber$__f_jsonLongConstantPool = array;
  this.Lio_circe_JsonNumber$__f_bigDecimalMinLong = $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong(0, (-2147483648)));
  this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong = $ct_Ljava_math_BigDecimal__J__(new $c_Ljava_math_BigDecimal(), new $c_RTLong((-1), 2147483647));
  var f = new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => {
    if ((x$1 instanceof $c_Lio_circe_JsonLong)) {
      var t = x$1.Lio_circe_JsonLong__f_value;
      var lo = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      if ((x$2 instanceof $c_Lio_circe_JsonLong)) {
        var t$1 = x$2.Lio_circe_JsonLong__f_value;
        var lo$1 = t$1.RTLong__f_lo;
        var hi$2 = t$1.RTLong__f_hi;
        return ((lo === lo$1) && (hi$1 === hi$2));
      }
    }
    if ((x$1 instanceof $c_Lio_circe_JsonDouble)) {
      var x50 = x$1.Lio_circe_JsonDouble__f_value;
      if ((x$2 instanceof $c_Lio_circe_JsonDouble)) {
        var x47 = x$2.Lio_circe_JsonDouble__f_value;
        return ($m_jl_Double$().compare__D__D__I(x50, x47) === 0);
      }
    }
    if (false) {
      var x42 = x$1.Lio_circe_JsonFloat__f_value;
      if (false) {
        var x39 = x$2.Lio_circe_JsonFloat__f_value;
        return ($m_jl_Double$().compare__D__D__I(x42, x39) === 0);
      }
    }
    if (false) {
      var x34 = x$1.Lio_circe_JsonBigDecimal__f_value;
      if (false) {
        var x31 = x$2.Lio_circe_JsonBigDecimal__f_value;
        return (x34.compareTo__Ljava_math_BigDecimal__I(x31) === 0);
      }
    }
    var x$6 = x$1.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal();
    var x$7 = x$2.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal();
    return ((x$6 === null) ? (x$7 === null) : x$6.equals__O__Z(x$7));
  }));
  this.Lio_circe_JsonNumber$__f_eqJsonNumber = new $c_Lcats_kernel_Eq$$anon$5(f);
}
export { $c_Lio_circe_JsonNumber$ as $c_Lio_circe_JsonNumber$ };
$c_Lio_circe_JsonNumber$.prototype = new $h_O();
$c_Lio_circe_JsonNumber$.prototype.constructor = $c_Lio_circe_JsonNumber$;
/** @constructor */
function $h_Lio_circe_JsonNumber$() {
}
export { $h_Lio_circe_JsonNumber$ as $h_Lio_circe_JsonNumber$ };
$h_Lio_circe_JsonNumber$.prototype = $c_Lio_circe_JsonNumber$.prototype;
$c_Lio_circe_JsonNumber$.prototype.fromLong__J__Lio_circe_Json$JNumber = (function(value) {
  var blo = value.RTLong__f_lo;
  var lo = ((128 + blo) | 0);
  var hi = ((value.RTLong__f_hi + (((blo & (~lo)) >>> 31) | 0)) | 0);
  if ((hi >= 0)) {
    var value$1 = this.Lio_circe_JsonNumber$__f_jsonLongConstantPool.u.length;
    var hi$1 = (value$1 >> 31);
    var $x_1 = ((hi === hi$1) ? ((lo >>> 0) < (value$1 >>> 0)) : (hi < hi$1));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return this.Lio_circe_JsonNumber$__f_jsonLongConstantPool.u[lo];
  } else {
    var value$2 = new $c_Lio_circe_JsonLong(value);
    return new $c_Lio_circe_Json$JNumber(value$2);
  }
});
$c_Lio_circe_JsonNumber$.prototype.bigDecimalIsWhole__Ljava_math_BigDecimal__Z = (function(value) {
  if (((value.signum__I() === 0) || (value.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0))) {
    return true;
  } else {
    var this$1 = value.stripTrailingZeros__Ljava_math_BigDecimal();
    return (this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0);
  }
});
$c_Lio_circe_JsonNumber$.prototype.bigDecimalIsValidLong__Ljava_math_BigDecimal__Z = (function(value) {
  return ((this.bigDecimalIsWhole__Ljava_math_BigDecimal__Z(value) && (value.compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsonNumber$__f_bigDecimalMinLong) >= 0)) && (value.compareTo__Ljava_math_BigDecimal__I(this.Lio_circe_JsonNumber$__f_bigDecimalMaxLong) <= 0));
});
$c_Lio_circe_JsonNumber$.prototype.ordinal__Lio_circe_JsonNumber__I = (function(x$0) {
  if (false) {
    return 0;
  }
  if (false) {
    return 1;
  }
  if ((x$0 instanceof $c_Lio_circe_JsonLong)) {
    return 2;
  }
  if ((x$0 instanceof $c_Lio_circe_JsonDouble)) {
    return 3;
  }
  if (false) {
    return 4;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lio_circe_JsonNumber$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lio_circe_JsonNumber__I(x);
});
var $d_Lio_circe_JsonNumber$ = new $TypeData().initClass($c_Lio_circe_JsonNumber$, "io.circe.JsonNumber$", ({
  Lio_circe_JsonNumber$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lio_circe_JsonNumber$ as $d_Lio_circe_JsonNumber$ };
var $n_Lio_circe_JsonNumber$;
function $m_Lio_circe_JsonNumber$() {
  if ((!$n_Lio_circe_JsonNumber$)) {
    $n_Lio_circe_JsonNumber$ = new $c_Lio_circe_JsonNumber$();
  }
  return $n_Lio_circe_JsonNumber$;
}
export { $m_Lio_circe_JsonNumber$ as $m_Lio_circe_JsonNumber$ };
function $p_Lio_circe_JsonObject$LinkedHashMapJsonObject__toMapAndVectorJsonObject__Lio_circe_JsonObject$MapAndVectorJsonObject($thiz) {
  var mapBuilder = new $c_sci_MapBuilderImpl();
  $m_sci_Vector$();
  var keyBuilder = new $c_sci_VectorBuilder();
  $thiz.size__I();
  $thiz.size__I();
  var this$3 = $thiz.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields;
  var iterator = new $c_ju_HashMap$EntrySet(this$3).iterator__ju_Iterator();
  while (iterator.hasNext__Z()) {
    var next = iterator.next__O();
    var key = next.getKey__O();
    var _2 = next.getValue__O();
    mapBuilder.addOne__O__O__sci_MapBuilderImpl(key, _2);
    keyBuilder.addOne__O__sci_VectorBuilder(key);
  }
  return new $c_Lio_circe_JsonObject$MapAndVectorJsonObject(mapBuilder.result__sci_Map(), keyBuilder.result__sci_Vector());
}
export { $p_Lio_circe_JsonObject$LinkedHashMapJsonObject__toMapAndVectorJsonObject__Lio_circe_JsonObject$MapAndVectorJsonObject as $p_Lio_circe_JsonObject$LinkedHashMapJsonObject__toMapAndVectorJsonObject__Lio_circe_JsonObject$MapAndVectorJsonObject };
/** @constructor */
function $c_Lio_circe_JsonObject$LinkedHashMapJsonObject(fields) {
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields = null;
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields = fields;
}
export { $c_Lio_circe_JsonObject$LinkedHashMapJsonObject as $c_Lio_circe_JsonObject$LinkedHashMapJsonObject };
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype = new $h_Lio_circe_JsonObject();
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.constructor = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject$LinkedHashMapJsonObject() {
}
export { $h_Lio_circe_JsonObject$LinkedHashMapJsonObject as $h_Lio_circe_JsonObject$LinkedHashMapJsonObject };
$h_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype;
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.applyUnsafe__T__Lio_circe_Json = (function(key) {
  var this$1 = this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields;
  return $p_ju_HashMap__getOrDefaultImpl__O__O__O(this$1, key, null);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.size__I = (function() {
  return this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields.ju_HashMap__f_contentSize;
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.contains__T__Z = (function(k) {
  return this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields.containsKey__O__Z(k);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.keys__sc_Iterable = (function() {
  return new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.toMap__sci_Map = (function() {
  var builder = new $c_sci_MapBuilderImpl();
  this.size__I();
  var this$2 = this.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields;
  var iterator = new $c_ju_HashMap$EntrySet(this$2).iterator__ju_Iterator();
  while (iterator.hasNext__Z()) {
    var next = iterator.next__O();
    var _1 = next.getKey__O();
    var _2 = next.getValue__O();
    builder.addOne__O__O__sci_MapBuilderImpl(_1, _2);
  }
  return builder.result__sci_Map();
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.toIterable__sc_Iterable = (function() {
  return new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.appendToFolder__Lio_circe_Printer$PrintingFolder__V = (function(folder) {
  var originalDepth = folder.Lio_circe_Printer$PrintingFolder__f_depth;
  var p = folder.Lio_circe_Printer$PrintingFolder__f_pieces.apply__I__Lio_circe_Printer$Pieces(folder.Lio_circe_Printer$PrintingFolder__f_depth);
  var first = true;
  if (folder.Lio_circe_Printer$PrintingFolder__f_sortKeys) {
    var this$1 = new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(this);
    var this$2 = $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$1);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => _$4._1__O()));
    var ord = $m_s_math_Ordering$String$();
    var iterable = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$2, f, ord);
  } else {
    var iterable = new $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(this);
  }
  var iterator = iterable.iterator__sc_Iterator();
  folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_lBraces);
  while (iterator.hasNext__Z()) {
    var next = iterator.next__O();
    var key = next._1__O();
    var value = next._2__O();
    if (((!folder.Lio_circe_Printer$PrintingFolder__f_dropNullValues) || (!value.isNull__Z()))) {
      if ((!first)) {
        folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_objectCommas);
      }
      folder.onString__T__V(key);
      folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_colons);
      folder.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + folder.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      value.foldWith__Lio_circe_Json$Folder__O(folder);
      folder.Lio_circe_Printer$PrintingFolder__f_depth = originalDepth;
      first = false;
    }
  }
  folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_rBraces);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.add__T__Lio_circe_Json__Lio_circe_JsonObject = (function(k, j) {
  return $p_Lio_circe_JsonObject$LinkedHashMapJsonObject__toMapAndVectorJsonObject__Lio_circe_JsonObject$MapAndVectorJsonObject(this).add__T__Lio_circe_Json__Lio_circe_JsonObject(k, j);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject.prototype.remove__T__Lio_circe_JsonObject = (function(k) {
  return $p_Lio_circe_JsonObject$LinkedHashMapJsonObject__toMapAndVectorJsonObject__Lio_circe_JsonObject$MapAndVectorJsonObject(this).remove__T__Lio_circe_JsonObject(k);
});
var $d_Lio_circe_JsonObject$LinkedHashMapJsonObject = new $TypeData().initClass($c_Lio_circe_JsonObject$LinkedHashMapJsonObject, "io.circe.JsonObject$LinkedHashMapJsonObject", ({
  Lio_circe_JsonObject$LinkedHashMapJsonObject: 1,
  Lio_circe_JsonObject: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_JsonObject$LinkedHashMapJsonObject as $d_Lio_circe_JsonObject$LinkedHashMapJsonObject };
/** @constructor */
function $c_Lio_circe_JsonObject$MapAndVectorJsonObject(fields, orderedKeys) {
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields = null;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys = null;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields = fields;
  this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys = orderedKeys;
}
export { $c_Lio_circe_JsonObject$MapAndVectorJsonObject as $c_Lio_circe_JsonObject$MapAndVectorJsonObject };
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype = new $h_Lio_circe_JsonObject();
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.constructor = $c_Lio_circe_JsonObject$MapAndVectorJsonObject;
/** @constructor */
function $h_Lio_circe_JsonObject$MapAndVectorJsonObject() {
}
export { $h_Lio_circe_JsonObject$MapAndVectorJsonObject as $h_Lio_circe_JsonObject$MapAndVectorJsonObject };
$h_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype = $c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype;
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.applyUnsafe__T__Lio_circe_Json = (function(key) {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.apply__O__O(key);
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.size__I = (function() {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.size__I();
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.contains__T__Z = (function(key) {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.contains__O__Z(key);
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.keys__sc_Iterable = (function() {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys;
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.toMap__sci_Map = (function() {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields;
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.toIterable__sc_Iterable = (function() {
  return this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((key) => {
    var _2 = this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.apply__O__O(key);
    return $ct_T2__O__O__(new $c_T2(), key, _2);
  })));
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.add__T__Lio_circe_Json__Lio_circe_JsonObject = (function(key, value) {
  if (this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.contains__O__Z(key)) {
    return new $c_Lio_circe_JsonObject$MapAndVectorJsonObject(this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.updated__O__O__sci_MapOps(key, value), this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys);
  } else {
    var $x_1 = this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.updated__O__O__sci_MapOps(key, value);
    var this$1 = this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys;
    return new $c_Lio_circe_JsonObject$MapAndVectorJsonObject($x_1, this$1.appended__O__O(key));
  }
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.remove__T__Lio_circe_JsonObject = (function(key) {
  var this$1 = this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields;
  var $x_1 = this$1.removed__O__sci_MapOps(key);
  var this$2 = this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys;
  var pred = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => (_$6 === key)));
  return new $c_Lio_circe_JsonObject$MapAndVectorJsonObject($x_1, this$2.filterImpl__F1__Z__sci_Vector(pred, true));
});
$c_Lio_circe_JsonObject$MapAndVectorJsonObject.prototype.appendToFolder__Lio_circe_Printer$PrintingFolder__V = (function(folder) {
  var originalDepth = folder.Lio_circe_Printer$PrintingFolder__f_depth;
  var p = folder.Lio_circe_Printer$PrintingFolder__f_pieces.apply__I__Lio_circe_Printer$Pieces(folder.Lio_circe_Printer$PrintingFolder__f_depth);
  var first = true;
  if (folder.Lio_circe_Printer$PrintingFolder__f_sortKeys) {
    var this$1 = this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys;
    var ord = $m_s_math_Ordering$String$();
    var keyIterator = $f_sc_SeqOps__sorted__s_math_Ordering__O(this$1, ord).iterator__sc_Iterator();
  } else {
    var keyIterator = this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_orderedKeys.iterator__sc_Iterator();
  }
  folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_lBraces);
  while (keyIterator.hasNext__Z()) {
    var key = keyIterator.next__O();
    var value = this.Lio_circe_JsonObject$MapAndVectorJsonObject__f_fields.apply__O__O(key);
    if (((!folder.Lio_circe_Printer$PrintingFolder__f_dropNullValues) || (!value.isNull__Z()))) {
      if ((!first)) {
        folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_objectCommas);
      }
      folder.onString__T__V(key);
      folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_colons);
      folder.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + folder.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      value.foldWith__Lio_circe_Json$Folder__O(folder);
      folder.Lio_circe_Printer$PrintingFolder__f_depth = originalDepth;
      first = false;
    }
  }
  folder.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_rBraces);
});
var $d_Lio_circe_JsonObject$MapAndVectorJsonObject = new $TypeData().initClass($c_Lio_circe_JsonObject$MapAndVectorJsonObject, "io.circe.JsonObject$MapAndVectorJsonObject", ({
  Lio_circe_JsonObject$MapAndVectorJsonObject: 1,
  Lio_circe_JsonObject: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_JsonObject$MapAndVectorJsonObject as $d_Lio_circe_JsonObject$MapAndVectorJsonObject };
function $p_Lio_circe_Printer$__toHex__I__C($thiz, nibble) {
  return (65535 & ((nibble + ((nibble >= 10) ? 87 : 48)) | 0));
}
export { $p_Lio_circe_Printer$__toHex__I__C as $p_Lio_circe_Printer$__toHex__I__C };
/** @constructor */
function $c_Lio_circe_Printer$() {
  this.Lio_circe_Printer$__f_noSpaces = null;
  this.Lio_circe_Printer$__f_spaces2 = null;
  $n_Lio_circe_Printer$ = this;
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft = "";
  $m_Lio_circe_Printer$();
  var lbraceRight = "";
  $m_Lio_circe_Printer$();
  var rbraceLeft = "";
  $m_Lio_circe_Printer$();
  var rbraceRight = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft = "";
  $m_Lio_circe_Printer$();
  var lbracketRight = "";
  $m_Lio_circe_Printer$();
  var rbracketLeft = "";
  $m_Lio_circe_Printer$();
  var rbracketRight = "";
  $m_Lio_circe_Printer$();
  var lrbracketsEmpty = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft = "";
  $m_Lio_circe_Printer$();
  var arrayCommaRight = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft = "";
  $m_Lio_circe_Printer$();
  var objectCommaRight = "";
  $m_Lio_circe_Printer$();
  var colonLeft = "";
  $m_Lio_circe_Printer$();
  var colonRight = "";
  $m_Lio_circe_Printer$();
  var reuseWriters = false;
  $m_Lio_circe_Printer$();
  var predictSize = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii = false;
  $m_Lio_circe_Printer$();
  var sortKeys = false;
  this.Lio_circe_Printer$__f_noSpaces = new $c_Lio_circe_Printer(false, "", lbraceLeft, lbraceRight, rbraceLeft, rbraceRight, lbracketLeft, lbracketRight, rbracketLeft, rbracketRight, lrbracketsEmpty, arrayCommaLeft, arrayCommaRight, objectCommaLeft, objectCommaRight, colonLeft, colonRight, reuseWriters, predictSize, escapeNonAscii, sortKeys);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$1 = "";
  $m_Lio_circe_Printer$();
  var lbraceRight$1 = "";
  $m_Lio_circe_Printer$();
  var rbraceLeft$1 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$1 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$1 = "";
  $m_Lio_circe_Printer$();
  var lbracketRight$1 = "";
  $m_Lio_circe_Printer$();
  var rbracketLeft$1 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$1 = "";
  $m_Lio_circe_Printer$();
  var lrbracketsEmpty$1 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$1 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaRight$1 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$1 = "";
  $m_Lio_circe_Printer$();
  var objectCommaRight$1 = "";
  $m_Lio_circe_Printer$();
  var colonLeft$1 = "";
  $m_Lio_circe_Printer$();
  var colonRight$1 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$1 = false;
  $m_Lio_circe_Printer$();
  var predictSize$1 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$1 = false;
  new $c_Lio_circe_Printer(false, "", lbraceLeft$1, lbraceRight$1, rbraceLeft$1, rbraceRight$1, lbracketLeft$1, lbracketRight$1, rbracketLeft$1, rbracketRight$1, lrbracketsEmpty$1, arrayCommaLeft$1, arrayCommaRight$1, objectCommaLeft$1, objectCommaRight$1, colonLeft$1, colonRight$1, reuseWriters$1, predictSize$1, escapeNonAscii$1, true);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$2 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$2 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$2 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$2 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$2 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$2 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$2 = false;
  $m_Lio_circe_Printer$();
  var predictSize$2 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$2 = false;
  this.Lio_circe_Printer$__f_spaces2 = new $c_Lio_circe_Printer(false, "  ", lbraceLeft$2, "\n", "\n", rbraceRight$2, lbracketLeft$2, "\n", "\n", rbracketRight$2, "\n", arrayCommaLeft$2, "\n", objectCommaLeft$2, "\n", " ", " ", reuseWriters$2, predictSize$2, escapeNonAscii$2, false);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$3 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$3 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$3 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$3 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$3 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$3 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$3 = false;
  $m_Lio_circe_Printer$();
  var predictSize$3 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$3 = false;
  new $c_Lio_circe_Printer(false, "  ", lbraceLeft$3, "\n", "\n", rbraceRight$3, lbracketLeft$3, "\n", "\n", rbracketRight$3, "\n", arrayCommaLeft$3, "\n", objectCommaLeft$3, "\n", " ", " ", reuseWriters$3, predictSize$3, escapeNonAscii$3, true);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$4 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$4 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$4 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$4 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$4 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$4 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$4 = false;
  $m_Lio_circe_Printer$();
  var predictSize$4 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$4 = false;
  new $c_Lio_circe_Printer(false, "    ", lbraceLeft$4, "\n", "\n", rbraceRight$4, lbracketLeft$4, "\n", "\n", rbracketRight$4, "\n", arrayCommaLeft$4, "\n", objectCommaLeft$4, "\n", " ", " ", reuseWriters$4, predictSize$4, escapeNonAscii$4, false);
  $m_Lio_circe_Printer$();
  $m_Lio_circe_Printer$();
  var lbraceLeft$5 = "";
  $m_Lio_circe_Printer$();
  var rbraceRight$5 = "";
  $m_Lio_circe_Printer$();
  var lbracketLeft$5 = "";
  $m_Lio_circe_Printer$();
  var rbracketRight$5 = "";
  $m_Lio_circe_Printer$();
  var arrayCommaLeft$5 = "";
  $m_Lio_circe_Printer$();
  var objectCommaLeft$5 = "";
  $m_Lio_circe_Printer$();
  var reuseWriters$5 = false;
  $m_Lio_circe_Printer$();
  var predictSize$5 = false;
  $m_Lio_circe_Printer$();
  var escapeNonAscii$5 = false;
  new $c_Lio_circe_Printer(false, "    ", lbraceLeft$5, "\n", "\n", rbraceRight$5, lbracketLeft$5, "\n", "\n", rbracketRight$5, "\n", arrayCommaLeft$5, "\n", objectCommaLeft$5, "\n", " ", " ", reuseWriters$5, predictSize$5, escapeNonAscii$5, true);
}
export { $c_Lio_circe_Printer$ as $c_Lio_circe_Printer$ };
$c_Lio_circe_Printer$.prototype = new $h_O();
$c_Lio_circe_Printer$.prototype.constructor = $c_Lio_circe_Printer$;
/** @constructor */
function $h_Lio_circe_Printer$() {
}
export { $h_Lio_circe_Printer$ as $h_Lio_circe_Printer$ };
$h_Lio_circe_Printer$.prototype = $c_Lio_circe_Printer$.prototype;
$c_Lio_circe_Printer$.prototype.io$circe$Printer$$$writeEscapedChar__jl_Appendable__C__V = (function(writer, c) {
  writer.append__C__jl_Appendable(117).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 12)))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 8)))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & (c >> 4)))).append__C__jl_Appendable($p_Lio_circe_Printer$__toHex__I__C(this, (15 & c)));
});
$c_Lio_circe_Printer$.prototype.fromProduct__s_Product__Lio_circe_Printer = (function(x$0) {
  return new $c_Lio_circe_Printer((!(!x$0.productElement__I__O(0))), x$0.productElement__I__O(1), x$0.productElement__I__O(2), x$0.productElement__I__O(3), x$0.productElement__I__O(4), x$0.productElement__I__O(5), x$0.productElement__I__O(6), x$0.productElement__I__O(7), x$0.productElement__I__O(8), x$0.productElement__I__O(9), x$0.productElement__I__O(10), x$0.productElement__I__O(11), x$0.productElement__I__O(12), x$0.productElement__I__O(13), x$0.productElement__I__O(14), x$0.productElement__I__O(15), x$0.productElement__I__O(16), (!(!x$0.productElement__I__O(17))), (!(!x$0.productElement__I__O(18))), (!(!x$0.productElement__I__O(19))), (!(!x$0.productElement__I__O(20))));
});
$c_Lio_circe_Printer$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lio_circe_Printer(p);
});
var $d_Lio_circe_Printer$ = new $TypeData().initClass($c_Lio_circe_Printer$, "io.circe.Printer$", ({
  Lio_circe_Printer$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lio_circe_Printer$ as $d_Lio_circe_Printer$ };
var $n_Lio_circe_Printer$;
function $m_Lio_circe_Printer$() {
  if ((!$n_Lio_circe_Printer$)) {
    $n_Lio_circe_Printer$ = new $c_Lio_circe_Printer$();
  }
  return $n_Lio_circe_Printer$;
}
export { $m_Lio_circe_Printer$ as $m_Lio_circe_Printer$ };
/** @constructor */
function $c_Lio_circe_Printer$ConstantPieces(pieces) {
  this.Lio_circe_Printer$ConstantPieces__f_pieces = null;
  this.Lio_circe_Printer$ConstantPieces__f_pieces = pieces;
}
export { $c_Lio_circe_Printer$ConstantPieces as $c_Lio_circe_Printer$ConstantPieces };
$c_Lio_circe_Printer$ConstantPieces.prototype = new $h_Lio_circe_Printer$PiecesAtDepth();
$c_Lio_circe_Printer$ConstantPieces.prototype.constructor = $c_Lio_circe_Printer$ConstantPieces;
/** @constructor */
function $h_Lio_circe_Printer$ConstantPieces() {
}
export { $h_Lio_circe_Printer$ConstantPieces as $h_Lio_circe_Printer$ConstantPieces };
$h_Lio_circe_Printer$ConstantPieces.prototype = $c_Lio_circe_Printer$ConstantPieces.prototype;
$c_Lio_circe_Printer$ConstantPieces.prototype.apply__I__Lio_circe_Printer$Pieces = (function(i) {
  return this.Lio_circe_Printer$ConstantPieces__f_pieces;
});
var $d_Lio_circe_Printer$ConstantPieces = new $TypeData().initClass($c_Lio_circe_Printer$ConstantPieces, "io.circe.Printer$ConstantPieces", ({
  Lio_circe_Printer$ConstantPieces: 1,
  Lio_circe_Printer$PiecesAtDepth: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_Printer$ConstantPieces as $d_Lio_circe_Printer$ConstantPieces };
function $ct_Lio_circe_Printer$MemoizedPieces__T__($thiz, indent) {
  $thiz.Lio_circe_Printer$MemoizedPieces__f_indent = indent;
  var dimensions = new $ac_I(new Int32Array([128]));
  $thiz.Lio_circe_Printer$MemoizedPieces__f_known = $ct_ju_concurrent_CopyOnWriteArrayList__AO__(new $c_ju_concurrent_CopyOnWriteArrayList(), $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Lio_circe_Printer$Pieces.getClassOf(), dimensions));
  return $thiz;
}
export { $ct_Lio_circe_Printer$MemoizedPieces__T__ as $ct_Lio_circe_Printer$MemoizedPieces__T__ };
/** @constructor */
function $c_Lio_circe_Printer$MemoizedPieces() {
  this.Lio_circe_Printer$MemoizedPieces__f_indent = null;
  this.Lio_circe_Printer$MemoizedPieces__f_known = null;
}
export { $c_Lio_circe_Printer$MemoizedPieces as $c_Lio_circe_Printer$MemoizedPieces };
$c_Lio_circe_Printer$MemoizedPieces.prototype = new $h_Lio_circe_Printer$PiecesAtDepth();
$c_Lio_circe_Printer$MemoizedPieces.prototype.constructor = $c_Lio_circe_Printer$MemoizedPieces;
/** @constructor */
function $h_Lio_circe_Printer$MemoizedPieces() {
}
export { $h_Lio_circe_Printer$MemoizedPieces as $h_Lio_circe_Printer$MemoizedPieces };
$h_Lio_circe_Printer$MemoizedPieces.prototype = $c_Lio_circe_Printer$MemoizedPieces.prototype;
$c_Lio_circe_Printer$MemoizedPieces.prototype.addIndentation__jl_StringBuilder__T__I__V = (function(builder, s, depth) {
  var lastNewLineIndex = $f_T__lastIndexOf__I__I(s, 10);
  if ((lastNewLineIndex === (-1))) {
    builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  } else {
    builder.append__jl_CharSequence__I__I__jl_StringBuilder(s, 0, ((1 + lastNewLineIndex) | 0));
    var i = 0;
    while ((i < depth)) {
      var str = this.Lio_circe_Printer$MemoizedPieces__f_indent;
      builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
      i = ((1 + i) | 0);
    }
    builder.append__jl_CharSequence__I__I__jl_StringBuilder(s, ((1 + lastNewLineIndex) | 0), s.length);
  }
});
$c_Lio_circe_Printer$MemoizedPieces.prototype.apply__I__Lio_circe_Printer$Pieces = (function(i) {
  if ((i >= 128)) {
    return this.compute__I__Lio_circe_Printer$Pieces(i);
  } else {
    var res = this.Lio_circe_Printer$MemoizedPieces__f_known.get__I__O(i);
    if ((res !== null)) {
      return res;
    } else {
      var tmp = this.compute__I__Lio_circe_Printer$Pieces(i);
      this.Lio_circe_Printer$MemoizedPieces__f_known.set__I__O__O(i, tmp);
      return tmp;
    }
  }
});
function $ct_Lio_circe_Printer$PrintingFolder__jl_Appendable__Lio_circe_Printer$PiecesAtDepth__Z__Z__Z__($thiz, writer, pieces, dropNullValues, escapeNonAscii, sortKeys) {
  $thiz.Lio_circe_Printer$PrintingFolder__f_writer = writer;
  $thiz.Lio_circe_Printer$PrintingFolder__f_pieces = pieces;
  $thiz.Lio_circe_Printer$PrintingFolder__f_dropNullValues = dropNullValues;
  $thiz.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = escapeNonAscii;
  $thiz.Lio_circe_Printer$PrintingFolder__f_sortKeys = sortKeys;
  $thiz.Lio_circe_Printer$PrintingFolder__f_depth = 0;
  return $thiz;
}
export { $ct_Lio_circe_Printer$PrintingFolder__jl_Appendable__Lio_circe_Printer$PiecesAtDepth__Z__Z__Z__ as $ct_Lio_circe_Printer$PrintingFolder__jl_Appendable__Lio_circe_Printer$PiecesAtDepth__Z__Z__Z__ };
/** @constructor */
function $c_Lio_circe_Printer$PrintingFolder() {
  this.Lio_circe_Printer$PrintingFolder__f_writer = null;
  this.Lio_circe_Printer$PrintingFolder__f_pieces = null;
  this.Lio_circe_Printer$PrintingFolder__f_dropNullValues = false;
  this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = false;
  this.Lio_circe_Printer$PrintingFolder__f_sortKeys = false;
  this.Lio_circe_Printer$PrintingFolder__f_depth = 0;
}
export { $c_Lio_circe_Printer$PrintingFolder as $c_Lio_circe_Printer$PrintingFolder };
$c_Lio_circe_Printer$PrintingFolder.prototype = new $h_O();
$c_Lio_circe_Printer$PrintingFolder.prototype.constructor = $c_Lio_circe_Printer$PrintingFolder;
/** @constructor */
function $h_Lio_circe_Printer$PrintingFolder() {
}
export { $h_Lio_circe_Printer$PrintingFolder as $h_Lio_circe_Printer$PrintingFolder };
$h_Lio_circe_Printer$PrintingFolder.prototype = $c_Lio_circe_Printer$PrintingFolder.prototype;
$c_Lio_circe_Printer$PrintingFolder.prototype.onString__T__V = (function(value) {
  this.Lio_circe_Printer$PrintingFolder__f_writer.append__C__jl_Appendable(34);
  var i = 0;
  var offset = 0;
  while ((i < value.length)) {
    var index = i;
    var c = value.charCodeAt(index);
    var esc;
    switch (c) {
      case 34: {
        var esc = 34;
        break;
      }
      case 92: {
        var esc = 92;
        break;
      }
      case 8: {
        var esc = 98;
        break;
      }
      case 12: {
        var esc = 102;
        break;
      }
      case 10: {
        var esc = 110;
        break;
      }
      case 13: {
        var esc = 114;
        break;
      }
      case 9: {
        var esc = 116;
        break;
      }
      default: {
        if ((this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii && (c > 127))) {
          var $x_1 = true;
        } else {
          var this$1 = $m_jl_Character$();
          var $x_1 = this$1.isISOControl__I__Z(c);
        }
        var esc = (65535 & ($x_1 ? 1 : 0));
      }
    }
    if ((esc !== 0)) {
      this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__I__I__jl_Appendable(value, offset, i).append__C__jl_Appendable(92);
      if ((esc !== 1)) {
        this.Lio_circe_Printer$PrintingFolder__f_writer.append__C__jl_Appendable(esc);
      } else {
        $m_Lio_circe_Printer$().io$circe$Printer$$$writeEscapedChar__jl_Appendable__C__V(this.Lio_circe_Printer$PrintingFolder__f_writer, c);
      }
      offset = ((1 + i) | 0);
    }
    i = ((1 + i) | 0);
  }
  if ((offset < i)) {
    this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__I__I__jl_Appendable(value, offset, i);
  }
  this.Lio_circe_Printer$PrintingFolder__f_writer.append__C__jl_Appendable(34);
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onArray__sci_Vector__V = (function(value) {
  var orig = this.Lio_circe_Printer$PrintingFolder__f_depth;
  var p = this.Lio_circe_Printer$PrintingFolder__f_pieces.apply__I__Lio_circe_Printer$Pieces(this.Lio_circe_Printer$PrintingFolder__f_depth);
  if ($f_sc_SeqOps__isEmpty__Z(value)) {
    this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_lrEmptyBrackets);
  } else {
    var iterator = value.iterator__sc_Iterator();
    this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_lBrackets);
    this.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + this.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
    iterator.next__O().foldWith__Lio_circe_Json$Folder__O(this);
    this.Lio_circe_Printer$PrintingFolder__f_depth = orig;
    while (iterator.hasNext__Z()) {
      this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_arrayCommas);
      this.Lio_circe_Printer$PrintingFolder__f_depth = ((1 + this.Lio_circe_Printer$PrintingFolder__f_depth) | 0);
      iterator.next__O().foldWith__Lio_circe_Json$Folder__O(this);
      this.Lio_circe_Printer$PrintingFolder__f_depth = orig;
    }
    this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(p.Lio_circe_Printer$Pieces__f_rBrackets);
  }
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onNull__O = (function() {
  this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable("null");
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onString__T__O = (function(value) {
  this.onString__T__V(value);
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onArray__sci_Vector__O = (function(value) {
  this.onArray__sci_Vector__V(value);
});
$c_Lio_circe_Printer$PrintingFolder.prototype.onObject__Lio_circe_JsonObject__O = (function(value) {
  value.appendToFolder__Lio_circe_Printer$PrintingFolder__V(this);
});
function $ct_Lio_circe_numbers_BiggerDecimal$Zero__($thiz) {
  var value = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO;
  $thiz.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = new $c_s_Some(value);
  $thiz.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = new $c_s_Some($L0);
  return $thiz;
}
export { $ct_Lio_circe_numbers_BiggerDecimal$Zero__ as $ct_Lio_circe_numbers_BiggerDecimal$Zero__ };
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$Zero() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null;
}
export { $c_Lio_circe_numbers_BiggerDecimal$Zero as $c_Lio_circe_numbers_BiggerDecimal$Zero };
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype = new $h_Lio_circe_numbers_BiggerDecimal();
$c_Lio_circe_numbers_BiggerDecimal$Zero.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$Zero;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$Zero() {
}
export { $h_Lio_circe_numbers_BiggerDecimal$Zero as $h_Lio_circe_numbers_BiggerDecimal$Zero };
$h_Lio_circe_numbers_BiggerDecimal$Zero.prototype = $c_Lio_circe_numbers_BiggerDecimal$Zero.prototype;
function $isArrayOf_Lio_circe_numbers_BiggerDecimal$Zero(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_numbers_BiggerDecimal$Zero)));
}
export { $isArrayOf_Lio_circe_numbers_BiggerDecimal$Zero as $isArrayOf_Lio_circe_numbers_BiggerDecimal$Zero };
/** @constructor */
function $c_Lio_circe_numbers_SigAndExp(unscaled, scale) {
  this.Lio_circe_numbers_SigAndExp__f_unscaled = null;
  this.Lio_circe_numbers_SigAndExp__f_scale = null;
  this.Lio_circe_numbers_SigAndExp__f_unscaled = unscaled;
  this.Lio_circe_numbers_SigAndExp__f_scale = scale;
}
export { $c_Lio_circe_numbers_SigAndExp as $c_Lio_circe_numbers_SigAndExp };
$c_Lio_circe_numbers_SigAndExp.prototype = new $h_Lio_circe_numbers_BiggerDecimal();
$c_Lio_circe_numbers_SigAndExp.prototype.constructor = $c_Lio_circe_numbers_SigAndExp;
/** @constructor */
function $h_Lio_circe_numbers_SigAndExp() {
}
export { $h_Lio_circe_numbers_SigAndExp as $h_Lio_circe_numbers_SigAndExp };
$h_Lio_circe_numbers_SigAndExp.prototype = $c_Lio_circe_numbers_SigAndExp.prototype;
$c_Lio_circe_numbers_SigAndExp.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lio_circe_numbers_SigAndExp)) {
    var xn = this.Lio_circe_numbers_SigAndExp__f_unscaled;
    var yn = that.Lio_circe_numbers_SigAndExp__f_unscaled;
    if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)) {
      var xn$1 = this.Lio_circe_numbers_SigAndExp__f_scale;
      var yn$1 = that.Lio_circe_numbers_SigAndExp__f_scale;
      return $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn$1, yn$1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lio_circe_numbers_SigAndExp.prototype.hashCode__I = (function() {
  return ((this.Lio_circe_numbers_SigAndExp__f_scale.hashCode__I() + this.Lio_circe_numbers_SigAndExp__f_unscaled.hashCode__I()) | 0);
});
$c_Lio_circe_numbers_SigAndExp.prototype.toString__T = (function() {
  var xn = this.Lio_circe_numbers_SigAndExp__f_scale;
  var yn = $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  if ($m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(xn, yn)) {
    var this$1 = this.Lio_circe_numbers_SigAndExp__f_unscaled;
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  } else {
    return ((this.Lio_circe_numbers_SigAndExp__f_unscaled + "e") + this.Lio_circe_numbers_SigAndExp__f_scale.negate__Ljava_math_BigInteger());
  }
});
function $isArrayOf_Lio_circe_numbers_SigAndExp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_numbers_SigAndExp)));
}
export { $isArrayOf_Lio_circe_numbers_SigAndExp as $isArrayOf_Lio_circe_numbers_SigAndExp };
var $d_Lio_circe_numbers_SigAndExp = new $TypeData().initClass($c_Lio_circe_numbers_SigAndExp, "io.circe.numbers.SigAndExp", ({
  Lio_circe_numbers_SigAndExp: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_numbers_SigAndExp as $d_Lio_circe_numbers_SigAndExp };
function $p_jl_Class__computeCachedSimpleNameBestEffort__T($thiz) {
  if ($thiz.data.isArrayClass) {
    return ($thiz.data.getComponentType().getSimpleName__T() + "[]");
  } else {
    var name = $thiz.data.name;
    var idx = (((-1) + name.length) | 0);
    while (true) {
      if ((idx >= 0)) {
        var index = idx;
        var $x_1 = (name.charCodeAt(index) === 36);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        idx = (((-1) + idx) | 0);
      } else {
        break;
      }
    }
    if ((idx >= 0)) {
      var index$1 = idx;
      var c = name.charCodeAt(index$1);
      var $x_2 = ((c >= 48) && (c <= 57));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      idx = (((-1) + idx) | 0);
      while (true) {
        if ((idx >= 0)) {
          var index$2 = idx;
          var c$1 = name.charCodeAt(index$2);
          var $x_3 = ((c$1 >= 48) && (c$1 <= 57));
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          idx = (((-1) + idx) | 0);
        } else {
          break;
        }
      }
      while (true) {
        if ((idx >= 0)) {
          var index$3 = idx;
          var $x_4 = (name.charCodeAt(index$3) === 36);
        } else {
          var $x_4 = false;
        }
        if ($x_4) {
          idx = (((-1) + idx) | 0);
        } else {
          break;
        }
      }
    }
    while (true) {
      if ((idx >= 0)) {
        var index$4 = idx;
        var currChar = name.charCodeAt(index$4);
        var $x_5 = ((currChar !== 46) && (currChar !== 36));
      } else {
        var $x_5 = false;
      }
      if ($x_5) {
        idx = (((-1) + idx) | 0);
      } else {
        break;
      }
    }
    var beginIndex = ((1 + idx) | 0);
    return name.substring(beginIndex);
  }
}
export { $p_jl_Class__computeCachedSimpleNameBestEffort__T as $p_jl_Class__computeCachedSimpleNameBestEffort__T };
/** @constructor */
function $c_jl_Class($data) {
  this.jl_Class__f_cachedSimpleName = null;
  this.data = $data;
}
export { $c_jl_Class as $c_jl_Class };
$c_jl_Class.prototype = new $h_O();
$c_jl_Class.prototype.constructor = $c_jl_Class;
/** @constructor */
function $h_jl_Class() {
}
export { $h_jl_Class as $h_jl_Class };
$h_jl_Class.prototype = $c_jl_Class.prototype;
$c_jl_Class.prototype.toString__T = (function() {
  return ((this.data.isInterface ? "interface " : (this.data.isPrimitive ? "" : "class ")) + this.data.name);
});
$c_jl_Class.prototype.getSimpleName__T = (function() {
  if ((this.jl_Class__f_cachedSimpleName === null)) {
    this.jl_Class__f_cachedSimpleName = $p_jl_Class__computeCachedSimpleNameBestEffort__T(this);
  }
  return this.jl_Class__f_cachedSimpleName;
});
var $d_jl_Class = new $TypeData().initClass($c_jl_Class, "java.lang.Class", ({
  jl_Class: 1,
  Ljava_io_Serializable: 1,
  jl_constant_Constable: 1
}));
export { $d_jl_Class as $d_jl_Class };
function $ct_jl_Enum__T__I__($thiz, _name, _ordinal) {
  $thiz.jl_Enum__f__name = _name;
  $thiz.jl_Enum__f__ordinal = _ordinal;
  return $thiz;
}
export { $ct_jl_Enum__T__I__ as $ct_jl_Enum__T__I__ };
/** @constructor */
function $c_jl_Enum() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
}
export { $c_jl_Enum as $c_jl_Enum };
$c_jl_Enum.prototype = new $h_O();
$c_jl_Enum.prototype.constructor = $c_jl_Enum;
/** @constructor */
function $h_jl_Enum() {
}
export { $h_jl_Enum as $h_jl_Enum };
$h_jl_Enum.prototype = $c_jl_Enum.prototype;
$c_jl_Enum.prototype.toString__T = (function() {
  return this.jl_Enum__f__name;
});
$c_jl_Enum.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_jl_Enum.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_jl_Enum.prototype.compareTo__jl_Enum__I = (function(o) {
  var x = this.jl_Enum__f__ordinal;
  var y = o.jl_Enum__f__ordinal;
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$c_jl_Enum.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__jl_Enum__I(o);
});
function $ct_jl_Error__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_jl_Error__T__ as $ct_jl_Error__T__ };
function $ct_jl_Error__jl_Throwable__($thiz, e) {
  var message = ((e === null) ? null : e.toString__T());
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, e, true, true);
  return $thiz;
}
export { $ct_jl_Error__jl_Throwable__ as $ct_jl_Error__jl_Throwable__ };
class $c_jl_Error extends $c_jl_Throwable {
}
export { $c_jl_Error as $c_jl_Error };
function $isArrayOf_jl_Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Error)));
}
export { $isArrayOf_jl_Error as $isArrayOf_jl_Error };
var $d_jl_Error = new $TypeData().initClass($c_jl_Error, "java.lang.Error", ({
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_Error as $d_jl_Error };
function $ct_jl_Exception__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_jl_Exception__T__ as $ct_jl_Exception__T__ };
class $c_jl_Exception extends $c_jl_Throwable {
}
export { $c_jl_Exception as $c_jl_Exception };
function $isArrayOf_jl_Exception(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Exception)));
}
export { $isArrayOf_jl_Exception as $isArrayOf_jl_Exception };
var $d_jl_Exception = new $TypeData().initClass($c_jl_Exception, "java.lang.Exception", ({
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_Exception as $d_jl_Exception };
function $ct_Ljava_nio_ByteBuffer__I__AB__I__($thiz, _capacity, _array, _arrayOffset) {
  $thiz.Ljava_nio_ByteBuffer__f__array = _array;
  $thiz.Ljava_nio_ByteBuffer__f__arrayOffset = _arrayOffset;
  $ct_Ljava_nio_Buffer__I__($thiz, _capacity);
  $thiz.Ljava_nio_ByteBuffer__f__isBigEndian = true;
  return $thiz;
}
export { $ct_Ljava_nio_ByteBuffer__I__AB__I__ as $ct_Ljava_nio_ByteBuffer__I__AB__I__ };
/** @constructor */
function $c_Ljava_nio_ByteBuffer() {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_ByteBuffer__f__array = null;
  this.Ljava_nio_ByteBuffer__f__arrayOffset = 0;
  this.Ljava_nio_ByteBuffer__f__isBigEndian = false;
}
export { $c_Ljava_nio_ByteBuffer as $c_Ljava_nio_ByteBuffer };
$c_Ljava_nio_ByteBuffer.prototype = new $h_Ljava_nio_Buffer();
$c_Ljava_nio_ByteBuffer.prototype.constructor = $c_Ljava_nio_ByteBuffer;
/** @constructor */
function $h_Ljava_nio_ByteBuffer() {
}
export { $h_Ljava_nio_ByteBuffer as $h_Ljava_nio_ByteBuffer };
$h_Ljava_nio_ByteBuffer.prototype = $c_Ljava_nio_ByteBuffer.prototype;
$c_Ljava_nio_ByteBuffer.prototype.put__Ljava_nio_ByteBuffer__Ljava_nio_ByteBuffer = (function(src) {
  if ((src === this)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var srcLimit = src.Ljava_nio_Buffer__f__limit;
  var srcPos = src.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var length = ((srcLimit - srcPos) | 0);
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var selfPos = p;
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(src, srcLimit);
  var srcArray = src.Ljava_nio_ByteBuffer__f__array;
  if ((srcArray !== null)) {
    var startIndex = selfPos;
    var offset = ((src.Ljava_nio_ByteBuffer__f__arrayOffset + srcPos) | 0);
    var x2 = this.Ljava_nio_ByteBuffer__f__array;
    var x3 = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + startIndex) | 0);
    srcArray.copyTo(offset, x2, x3, length);
  } else {
    while ((srcPos !== srcLimit)) {
      var index$1 = selfPos;
      var index = srcPos;
      var a = src.Ljava_nio_ByteBuffer__f__array;
      var i = ((src.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0);
      var elem = a.u[i];
      var a$1 = this.Ljava_nio_ByteBuffer__f__array;
      var i$1 = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + index$1) | 0);
      a$1.u[i$1] = elem;
      srcPos = ((1 + srcPos) | 0);
      selfPos = ((1 + selfPos) | 0);
    }
  }
  return this;
});
$c_Ljava_nio_ByteBuffer.prototype.hashCode__I = (function() {
  var start = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var end = this.Ljava_nio_Buffer__f__limit;
  var h = (-547316498);
  var i = start;
  while ((i !== end)) {
    var $x_2 = $m_ju_internal_MurmurHash3$();
    var $x_1 = h;
    var index = i;
    var a = this.Ljava_nio_ByteBuffer__f__array;
    var i$1 = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0);
    var this$5 = a.u[i$1];
    h = $x_2.mix__I__I__I($x_1, this$5);
    i = ((1 + i) | 0);
  }
  return $m_ju_internal_MurmurHash3$().finalizeHash__I__I__I(h, ((end - start) | 0));
});
$c_Ljava_nio_ByteBuffer.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_Ljava_nio_ByteBuffer) && (this.compareTo__Ljava_nio_ByteBuffer__I(that) === 0));
});
$c_Ljava_nio_ByteBuffer.prototype.compareTo__Ljava_nio_ByteBuffer__I = (function(that) {
  if ((this === that)) {
    return 0;
  } else {
    var thisStart = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thisRemaining = ((this.Ljava_nio_Buffer__f__limit - thisStart) | 0);
    var thatStart = that.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thatRemaining = ((that.Ljava_nio_Buffer__f__limit - thatStart) | 0);
    var shortestLength = ((thisRemaining < thatRemaining) ? thisRemaining : thatRemaining);
    var i = 0;
    while ((i !== shortestLength)) {
      var index = ((thisStart + i) | 0);
      var a = this.Ljava_nio_ByteBuffer__f__array;
      var i$1 = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0);
      var t = a.u[i$1];
      var index$1 = ((thatStart + i) | 0);
      var a$1 = that.Ljava_nio_ByteBuffer__f__array;
      var i$2 = ((that.Ljava_nio_ByteBuffer__f__arrayOffset + index$1) | 0);
      var u = a$1.u[i$2];
      var cmp = ((t - u) | 0);
      if ((cmp !== 0)) {
        return cmp;
      }
      i = ((1 + i) | 0);
    }
    return ((thisRemaining === thatRemaining) ? 0 : ((thisRemaining < thatRemaining) ? (-1) : 1));
  }
});
$c_Ljava_nio_ByteBuffer.prototype.order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer = (function(bo) {
  if ((bo === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var x$2 = $m_Ljava_nio_ByteOrder$().Ljava_nio_ByteOrder$__f_BIG_ENDIAN;
  this.Ljava_nio_ByteBuffer__f__isBigEndian = (bo === x$2);
  return this;
});
$c_Ljava_nio_ByteBuffer.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_nio_ByteBuffer__I(o);
});
function $isArrayOf_Ljava_nio_ByteBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_ByteBuffer)));
}
export { $isArrayOf_Ljava_nio_ByteBuffer as $isArrayOf_Ljava_nio_ByteBuffer };
function $ct_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon__T__AT__I__($thiz, name, aliases, maxValue) {
  $thiz.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon__f_java$nio$charset$ISO_8859_1_And_US_ASCII_Common$$maxValue = maxValue;
  $ct_Ljava_nio_charset_Charset__T__AT__($thiz, name, aliases);
  return $thiz;
}
export { $ct_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon__T__AT__I__ as $ct_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon__T__AT__I__ };
/** @constructor */
function $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon() {
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_cachedEncoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
  this.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon__f_java$nio$charset$ISO_8859_1_And_US_ASCII_Common$$maxValue = 0;
}
export { $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon as $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon };
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon.prototype = new $h_Ljava_nio_charset_Charset();
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon.prototype.constructor = $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon;
/** @constructor */
function $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon() {
}
export { $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon as $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon };
$h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon.prototype = $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon.prototype;
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon.prototype.newDecoder__Ljava_nio_charset_CharsetDecoder = (function() {
  return new $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Decoder(this);
});
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon.prototype.newEncoder__Ljava_nio_charset_CharsetEncoder = (function() {
  return new $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon$Encoder(this);
});
function $ct_Ljava_nio_charset_UTF\uff3f16\uff3fCommon__T__AT__I__($thiz, name, aliases, endianness) {
  $thiz.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness = endianness;
  $ct_Ljava_nio_charset_Charset__T__AT__($thiz, name, aliases);
  return $thiz;
}
export { $ct_Ljava_nio_charset_UTF\uff3f16\uff3fCommon__T__AT__I__ as $ct_Ljava_nio_charset_UTF\uff3f16\uff3fCommon__T__AT__I__ };
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon() {
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_cachedEncoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness = 0;
}
export { $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon as $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon };
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon.prototype = new $h_Ljava_nio_charset_Charset();
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon() {
}
export { $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon as $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon };
$h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon.prototype = $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon.prototype;
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon.prototype.newDecoder__Ljava_nio_charset_CharsetDecoder = (function() {
  return new $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Decoder(this);
});
$c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon.prototype.newEncoder__Ljava_nio_charset_CharsetEncoder = (function() {
  return new $c_Ljava_nio_charset_UTF\uff3f16\uff3fCommon$Encoder(this);
});
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f8$() {
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_cachedEncoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
  this.Ljava_nio_charset_UTF\uff3f8$__f_java$nio$charset$UTF_8$$lengthByLeading = null;
  $ct_Ljava_nio_charset_Charset__T__AT__(this, "UTF-8", new ($d_T.getArrayOf().constr)(["UTF8", "unicode-1-1-utf-8"]));
  $n_Ljava_nio_charset_UTF\uff3f8$ = this;
  this.Ljava_nio_charset_UTF\uff3f8$__f_java$nio$charset$UTF_8$$lengthByLeading = new $ac_I(new Int32Array([(-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1), 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, (-1), (-1), (-1), (-1), (-1), (-1), (-1), (-1)]));
}
export { $c_Ljava_nio_charset_UTF\uff3f8$ as $c_Ljava_nio_charset_UTF\uff3f8$ };
$c_Ljava_nio_charset_UTF\uff3f8$.prototype = new $h_Ljava_nio_charset_Charset();
$c_Ljava_nio_charset_UTF\uff3f8$.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f8$;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f8$() {
}
export { $h_Ljava_nio_charset_UTF\uff3f8$ as $h_Ljava_nio_charset_UTF\uff3f8$ };
$h_Ljava_nio_charset_UTF\uff3f8$.prototype = $c_Ljava_nio_charset_UTF\uff3f8$.prototype;
$c_Ljava_nio_charset_UTF\uff3f8$.prototype.newDecoder__Ljava_nio_charset_CharsetDecoder = (function() {
  return new $c_Ljava_nio_charset_UTF\uff3f8$Decoder();
});
$c_Ljava_nio_charset_UTF\uff3f8$.prototype.newEncoder__Ljava_nio_charset_CharsetEncoder = (function() {
  return new $c_Ljava_nio_charset_UTF\uff3f8$Encoder();
});
var $d_Ljava_nio_charset_UTF\uff3f8$ = new $TypeData().initClass($c_Ljava_nio_charset_UTF\uff3f8$, "java.nio.charset.UTF_8$", ({
  Ljava_nio_charset_UTF\uff3f8$: 1,
  Ljava_nio_charset_Charset: 1,
  jl_Comparable: 1
}));
export { $d_Ljava_nio_charset_UTF\uff3f8$ as $d_Ljava_nio_charset_UTF\uff3f8$ };
var $n_Ljava_nio_charset_UTF\uff3f8$;
function $m_Ljava_nio_charset_UTF\uff3f8$() {
  if ((!$n_Ljava_nio_charset_UTF\uff3f8$)) {
    $n_Ljava_nio_charset_UTF\uff3f8$ = new $c_Ljava_nio_charset_UTF\uff3f8$();
  }
  return $n_Ljava_nio_charset_UTF\uff3f8$;
}
export { $m_Ljava_nio_charset_UTF\uff3f8$ as $m_Ljava_nio_charset_UTF\uff3f8$ };
/** @constructor */
function $c_Ljava_time_Clock$SystemClock(zone) {
  this.Ljava_time_Clock$SystemClock__f_zone = null;
  this.Ljava_time_Clock$SystemClock__f_zone = zone;
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "'zone' can not be null");
  }
}
export { $c_Ljava_time_Clock$SystemClock as $c_Ljava_time_Clock$SystemClock };
$c_Ljava_time_Clock$SystemClock.prototype = new $h_Ljava_time_Clock();
$c_Ljava_time_Clock$SystemClock.prototype.constructor = $c_Ljava_time_Clock$SystemClock;
/** @constructor */
function $h_Ljava_time_Clock$SystemClock() {
}
export { $h_Ljava_time_Clock$SystemClock as $h_Ljava_time_Clock$SystemClock };
$h_Ljava_time_Clock$SystemClock.prototype = $c_Ljava_time_Clock$SystemClock.prototype;
$c_Ljava_time_Clock$SystemClock.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_Clock$SystemClock)) {
    var x = this.Ljava_time_Clock$SystemClock__f_zone;
    var x$2 = obj.Ljava_time_Clock$SystemClock__f_zone;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Ljava_time_Clock$SystemClock.prototype.hashCode__I = (function() {
  return ((1 + this.Ljava_time_Clock$SystemClock__f_zone.hashCode__I()) | 0);
});
$c_Ljava_time_Clock$SystemClock.prototype.toString__T = (function() {
  return (("SystemClock[" + this.Ljava_time_Clock$SystemClock__f_zone) + "]");
});
function $isArrayOf_Ljava_time_Clock$SystemClock(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Clock$SystemClock)));
}
export { $isArrayOf_Ljava_time_Clock$SystemClock as $isArrayOf_Ljava_time_Clock$SystemClock };
var $d_Ljava_time_Clock$SystemClock = new $TypeData().initClass($c_Ljava_time_Clock$SystemClock, "java.time.Clock$SystemClock", ({
  Ljava_time_Clock$SystemClock: 1,
  Ljava_time_Clock: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_Clock$SystemClock as $d_Ljava_time_Clock$SystemClock };
function $s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__MONDAY;
}
export { $s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__TUESDAY;
}
export { $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__WEDNESDAY;
}
export { $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__THURSDAY;
}
export { $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__FRIDAY;
}
export { $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__SATURDAY;
}
export { $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__SUNDAY;
}
export { $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek };
/** @constructor */
function $c_Ljava_time_DayOfWeek$() {
  this.Ljava_time_DayOfWeek$__f_$values = null;
  this.Ljava_time_DayOfWeek$__f_ENUMS$lzy1 = null;
  this.Ljava_time_DayOfWeek$__f_ENUMSbitmap$1 = false;
  $n_Ljava_time_DayOfWeek$ = this;
  $t_Ljava_time_DayOfWeek$__MONDAY = new $c_Ljava_time_DayOfWeek$$anon$1();
  $t_Ljava_time_DayOfWeek$__TUESDAY = new $c_Ljava_time_DayOfWeek$$anon$2();
  $t_Ljava_time_DayOfWeek$__WEDNESDAY = new $c_Ljava_time_DayOfWeek$$anon$3();
  $t_Ljava_time_DayOfWeek$__THURSDAY = new $c_Ljava_time_DayOfWeek$$anon$4();
  $t_Ljava_time_DayOfWeek$__FRIDAY = new $c_Ljava_time_DayOfWeek$$anon$5();
  $t_Ljava_time_DayOfWeek$__SATURDAY = new $c_Ljava_time_DayOfWeek$$anon$6();
  $t_Ljava_time_DayOfWeek$__SUNDAY = new $c_Ljava_time_DayOfWeek$$anon$7();
  this.Ljava_time_DayOfWeek$__f_$values = new ($d_Ljava_time_DayOfWeek.getArrayOf().constr)([$s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek()]);
}
export { $c_Ljava_time_DayOfWeek$ as $c_Ljava_time_DayOfWeek$ };
$c_Ljava_time_DayOfWeek$.prototype = new $h_O();
$c_Ljava_time_DayOfWeek$.prototype.constructor = $c_Ljava_time_DayOfWeek$;
/** @constructor */
function $h_Ljava_time_DayOfWeek$() {
}
export { $h_Ljava_time_DayOfWeek$ as $h_Ljava_time_DayOfWeek$ };
$h_Ljava_time_DayOfWeek$.prototype = $c_Ljava_time_DayOfWeek$.prototype;
$c_Ljava_time_DayOfWeek$.prototype.values__ALjava_time_DayOfWeek = (function() {
  var this$1 = this.Ljava_time_DayOfWeek$__f_$values;
  return this$1.clone__O();
});
$c_Ljava_time_DayOfWeek$.prototype.java$time$DayOfWeek$$$ENUMS__ALjava_time_DayOfWeek = (function() {
  if ((!this.Ljava_time_DayOfWeek$__f_ENUMSbitmap$1)) {
    this.Ljava_time_DayOfWeek$__f_ENUMS$lzy1 = $m_Ljava_time_DayOfWeek$().values__ALjava_time_DayOfWeek();
    this.Ljava_time_DayOfWeek$__f_ENUMSbitmap$1 = true;
  }
  return this.Ljava_time_DayOfWeek$__f_ENUMS$lzy1;
});
$c_Ljava_time_DayOfWeek$.prototype.of__I__Ljava_time_DayOfWeek = (function(dayOfWeek) {
  if (((dayOfWeek < 1) || (dayOfWeek > 7))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid value for DayOfWeek: " + dayOfWeek));
  } else {
    return this.java$time$DayOfWeek$$$ENUMS__ALjava_time_DayOfWeek().u[(((-1) + dayOfWeek) | 0)];
  }
});
$c_Ljava_time_DayOfWeek$.prototype.ordinal__O__I = (function(x) {
  return x.jl_Enum__f__ordinal;
});
var $d_Ljava_time_DayOfWeek$ = new $TypeData().initClass($c_Ljava_time_DayOfWeek$, "java.time.DayOfWeek$", ({
  Ljava_time_DayOfWeek$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Ljava_time_DayOfWeek$ as $d_Ljava_time_DayOfWeek$ };
var $n_Ljava_time_DayOfWeek$;
function $m_Ljava_time_DayOfWeek$() {
  if ((!$n_Ljava_time_DayOfWeek$)) {
    $n_Ljava_time_DayOfWeek$ = new $c_Ljava_time_DayOfWeek$();
  }
  return $n_Ljava_time_DayOfWeek$;
}
export { $m_Ljava_time_DayOfWeek$ as $m_Ljava_time_DayOfWeek$ };
function $s_Ljava_time_Month$__JANUARY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JANUARY;
}
export { $s_Ljava_time_Month$__JANUARY__Ljava_time_Month as $s_Ljava_time_Month$__JANUARY__Ljava_time_Month };
function $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__FEBRUARY;
}
export { $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month as $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month };
function $s_Ljava_time_Month$__MARCH__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__MARCH;
}
export { $s_Ljava_time_Month$__MARCH__Ljava_time_Month as $s_Ljava_time_Month$__MARCH__Ljava_time_Month };
function $s_Ljava_time_Month$__APRIL__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__APRIL;
}
export { $s_Ljava_time_Month$__APRIL__Ljava_time_Month as $s_Ljava_time_Month$__APRIL__Ljava_time_Month };
function $s_Ljava_time_Month$__MAY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__MAY;
}
export { $s_Ljava_time_Month$__MAY__Ljava_time_Month as $s_Ljava_time_Month$__MAY__Ljava_time_Month };
function $s_Ljava_time_Month$__JUNE__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JUNE;
}
export { $s_Ljava_time_Month$__JUNE__Ljava_time_Month as $s_Ljava_time_Month$__JUNE__Ljava_time_Month };
function $s_Ljava_time_Month$__JULY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JULY;
}
export { $s_Ljava_time_Month$__JULY__Ljava_time_Month as $s_Ljava_time_Month$__JULY__Ljava_time_Month };
function $s_Ljava_time_Month$__AUGUST__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__AUGUST;
}
export { $s_Ljava_time_Month$__AUGUST__Ljava_time_Month as $s_Ljava_time_Month$__AUGUST__Ljava_time_Month };
function $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__SEPTEMBER;
}
export { $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month as $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month };
function $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__OCTOBER;
}
export { $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month as $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month };
function $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__NOVEMBER;
}
export { $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month as $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month };
function $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__DECEMBER;
}
export { $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month as $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month };
/** @constructor */
function $c_Ljava_time_Month$() {
  this.Ljava_time_Month$__f_$values = null;
  this.Ljava_time_Month$__f_ENUMS$lzy1 = null;
  this.Ljava_time_Month$__f_ENUMSbitmap$1 = false;
  $n_Ljava_time_Month$ = this;
  $t_Ljava_time_Month$__JANUARY = new $c_Ljava_time_Month$$anon$1();
  $t_Ljava_time_Month$__FEBRUARY = new $c_Ljava_time_Month$$anon$2();
  $t_Ljava_time_Month$__MARCH = new $c_Ljava_time_Month$$anon$3();
  $t_Ljava_time_Month$__APRIL = new $c_Ljava_time_Month$$anon$4();
  $t_Ljava_time_Month$__MAY = new $c_Ljava_time_Month$$anon$5();
  $t_Ljava_time_Month$__JUNE = new $c_Ljava_time_Month$$anon$6();
  $t_Ljava_time_Month$__JULY = new $c_Ljava_time_Month$$anon$7();
  $t_Ljava_time_Month$__AUGUST = new $c_Ljava_time_Month$$anon$8();
  $t_Ljava_time_Month$__SEPTEMBER = new $c_Ljava_time_Month$$anon$9();
  $t_Ljava_time_Month$__OCTOBER = new $c_Ljava_time_Month$$anon$10();
  $t_Ljava_time_Month$__NOVEMBER = new $c_Ljava_time_Month$$anon$11();
  $t_Ljava_time_Month$__DECEMBER = new $c_Ljava_time_Month$$anon$12();
  this.Ljava_time_Month$__f_$values = new ($d_Ljava_time_Month.getArrayOf().constr)([$s_Ljava_time_Month$__JANUARY__Ljava_time_Month(), $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month(), $s_Ljava_time_Month$__MARCH__Ljava_time_Month(), $s_Ljava_time_Month$__APRIL__Ljava_time_Month(), $s_Ljava_time_Month$__MAY__Ljava_time_Month(), $s_Ljava_time_Month$__JUNE__Ljava_time_Month(), $s_Ljava_time_Month$__JULY__Ljava_time_Month(), $s_Ljava_time_Month$__AUGUST__Ljava_time_Month(), $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month(), $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month(), $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month(), $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month()]);
}
export { $c_Ljava_time_Month$ as $c_Ljava_time_Month$ };
$c_Ljava_time_Month$.prototype = new $h_O();
$c_Ljava_time_Month$.prototype.constructor = $c_Ljava_time_Month$;
/** @constructor */
function $h_Ljava_time_Month$() {
}
export { $h_Ljava_time_Month$ as $h_Ljava_time_Month$ };
$h_Ljava_time_Month$.prototype = $c_Ljava_time_Month$.prototype;
$c_Ljava_time_Month$.prototype.values__ALjava_time_Month = (function() {
  var this$1 = this.Ljava_time_Month$__f_$values;
  return this$1.clone__O();
});
$c_Ljava_time_Month$.prototype.java$time$Month$$$ENUMS__ALjava_time_Month = (function() {
  if ((!this.Ljava_time_Month$__f_ENUMSbitmap$1)) {
    this.Ljava_time_Month$__f_ENUMS$lzy1 = $m_Ljava_time_Month$().values__ALjava_time_Month();
    this.Ljava_time_Month$__f_ENUMSbitmap$1 = true;
  }
  return this.Ljava_time_Month$__f_ENUMS$lzy1;
});
$c_Ljava_time_Month$.prototype.of__I__Ljava_time_Month = (function(month) {
  if (((month < 1) || (month > 12))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid value for MonthOfYear: " + month));
  } else {
    return this.java$time$Month$$$ENUMS__ALjava_time_Month().u[(((-1) + month) | 0)];
  }
});
$c_Ljava_time_Month$.prototype.ordinal__O__I = (function(x) {
  return x.jl_Enum__f__ordinal;
});
var $d_Ljava_time_Month$ = new $TypeData().initClass($c_Ljava_time_Month$, "java.time.Month$", ({
  Ljava_time_Month$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Ljava_time_Month$ as $d_Ljava_time_Month$ };
var $n_Ljava_time_Month$;
function $m_Ljava_time_Month$() {
  if ((!$n_Ljava_time_Month$)) {
    $n_Ljava_time_Month$ = new $c_Ljava_time_Month$();
  }
  return $n_Ljava_time_Month$;
}
export { $m_Ljava_time_Month$ as $m_Ljava_time_Month$ };
/** @constructor */
function $c_Ljava_time_ZoneRegion(id, rules) {
  this.Ljava_time_ZoneRegion__f_id = null;
  this.Ljava_time_ZoneRegion__f_rules = null;
  this.Ljava_time_ZoneRegion__f_id = id;
  this.Ljava_time_ZoneRegion__f_rules = rules;
  $ct_Ljava_time_ZoneId__(this);
}
export { $c_Ljava_time_ZoneRegion as $c_Ljava_time_ZoneRegion };
$c_Ljava_time_ZoneRegion.prototype = new $h_Ljava_time_ZoneId();
$c_Ljava_time_ZoneRegion.prototype.constructor = $c_Ljava_time_ZoneRegion;
/** @constructor */
function $h_Ljava_time_ZoneRegion() {
}
export { $h_Ljava_time_ZoneRegion as $h_Ljava_time_ZoneRegion };
$h_Ljava_time_ZoneRegion.prototype = $c_Ljava_time_ZoneRegion.prototype;
$c_Ljava_time_ZoneRegion.prototype.getId__T = (function() {
  return this.Ljava_time_ZoneRegion__f_id;
});
$c_Ljava_time_ZoneRegion.prototype.getRules__Ljava_time_zone_ZoneRules = (function() {
  return ((this.Ljava_time_ZoneRegion__f_rules !== null) ? this.Ljava_time_ZoneRegion__f_rules : $m_Ljava_time_zone_ZoneRulesProvider$().getRules__T__Z__Ljava_time_zone_ZoneRules(this.Ljava_time_ZoneRegion__f_id, false));
});
var $d_Ljava_time_ZoneRegion = new $TypeData().initClass($c_Ljava_time_ZoneRegion, "java.time.ZoneRegion", ({
  Ljava_time_ZoneRegion: 1,
  Ljava_time_ZoneId: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_ZoneRegion as $d_Ljava_time_ZoneRegion };
function $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V($thiz, fieldValues, field, value) {
  var current = fieldValues.get__O__O(field);
  if (((current !== null) && (!((current.RTLong__f_lo === value.RTLong__f_lo) && (current.RTLong__f_hi === value.RTLong__f_hi))))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((("Invalid state, field: " + field) + " ") + current) + " conflicts with ") + field) + " ") + value));
  } else {
    fieldValues.put__O__O__O(field, value);
  }
}
export { $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V as $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V };
function $f_Ljava_time_chrono_Chronology__equals__O__Z($thiz, obj) {
  return ($is_Ljava_time_chrono_Chronology(obj) && (($thiz === obj) || ($f_T__compareTo__T__I("ISO", "ISO") === 0)));
}
export { $f_Ljava_time_chrono_Chronology__equals__O__Z as $f_Ljava_time_chrono_Chronology__equals__O__Z };
function $f_Ljava_time_chrono_Chronology__hashCode__I($thiz) {
  var this$1 = $objectGetClass($thiz);
  return ($systemIdentityHashCode(this$1) ^ $f_T__hashCode__I("ISO"));
}
export { $f_Ljava_time_chrono_Chronology__hashCode__I as $f_Ljava_time_chrono_Chronology__hashCode__I };
function $is_Ljava_time_chrono_Chronology(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_Chronology)));
}
export { $is_Ljava_time_chrono_Chronology as $is_Ljava_time_chrono_Chronology };
function $isArrayOf_Ljava_time_chrono_Chronology(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_Chronology)));
}
export { $isArrayOf_Ljava_time_chrono_Chronology as $isArrayOf_Ljava_time_chrono_Chronology };
function $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($thiz, field, value) {
  $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.put__O__O__O(field, value);
  return $thiz;
}
export { $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder as $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder };
function $p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z($thiz, resolverStyle) {
  var changes = 0;
  var entries = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.entrySet__ju_Set().iterator__ju_Iterator();
  var break$1 = false;
  while (((!break$1) && entries.hasNext__Z())) {
    var entry = entries.next__O();
    var targetField = entry.getKey__O();
    var resolvedObject = targetField.resolve__ju_Map__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_ResolverStyle__Ljava_time_temporal_TemporalAccessor($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues, $thiz, resolverStyle);
    matchResult1: {
      var x1 = resolvedObject;
      if ($is_Ljava_time_chrono_ChronoZonedDateTime(x1)) {
        if (($thiz.Ljava_time_format_DateTimeBuilder__f_zone === null)) {
          $thiz.Ljava_time_format_DateTimeBuilder__f_zone = x1.Ljava_time_ZonedDateTime__f_zone;
        } else {
          var x = $thiz.Ljava_time_format_DateTimeBuilder__f_zone;
          var x$2 = x1.Ljava_time_ZonedDateTime__f_zone;
          if ((!((x === null) ? (x$2 === null) : x.equals__O__Z(x$2)))) {
            throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("ChronoZonedDateTime must use the effective parsed zone: " + $thiz.Ljava_time_format_DateTimeBuilder__f_zone));
          }
        }
        resolvedObject = x1.Ljava_time_ZonedDateTime__f_dateTime;
        break matchResult1;
      }
      if ($is_Ljava_time_chrono_ChronoLocalDate(x1)) {
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, x1);
        changes = ((1 + changes) | 0);
        break$1 = true;
        break matchResult1;
      }
      if ((x1 instanceof $c_Ljava_time_LocalTime)) {
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, x1);
        changes = ((1 + changes) | 0);
        break$1 = true;
        break matchResult1;
      }
      if ((x1 instanceof $c_Ljava_time_chrono_ChronoLocalDateTime)) {
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, x1.Ljava_time_LocalDateTime__f_date);
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, x1.Ljava_time_LocalDateTime__f_time);
        changes = ((1 + changes) | 0);
        break$1 = true;
        break matchResult1;
      }
      if ((x1 === null)) {
        if ((!$thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z(targetField))) {
          changes = ((1 + changes) | 0);
          break$1 = true;
          break matchResult1;
        } else {
          break matchResult1;
        }
      }
      var this$1 = resolvedObject;
      var this$2 = $objectGetClass(this$1);
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Unknown type: " + this$2.data.name));
    }
  }
  if ((changes === 100)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Badly written field");
  }
  return (changes > 0);
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z as $p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z };
function $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, date) {
  var x = $thiz.Ljava_time_format_DateTimeBuilder__f_chrono;
  var x$2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  if ((!((x === null) ? (x$2 === null) : $f_Ljava_time_chrono_Chronology__equals__O__Z(x, x$2)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("ChronoLocalDate must use the effective parsed chronology: " + $thiz.Ljava_time_format_DateTimeBuilder__f_chrono));
  }
  var t = date.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var old = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.put__O__O__O($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField(), new $c_RTLong(lo, hi));
  if (((old !== null) && (!((old.RTLong__f_lo === lo) && (old.RTLong__f_hi === hi))))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Conflict found: " + $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate($uJ(old))) + " differs from ") + $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi))) + " while resolving  ") + targetField));
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V as $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V };
function $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, time) {
  var t = time.toNanoOfDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var old = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.put__O__O__O($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField(), new $c_RTLong(lo, hi));
  if (((old !== null) && (!((old.RTLong__f_lo === lo) && (old.RTLong__f_hi === hi))))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((("Conflict found: " + $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime($uJ(old))) + " differs from ") + time) + " while resolving  ") + targetField));
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V as $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V };
function $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_chrono instanceof $c_Ljava_time_chrono_IsoChronology)) {
    $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology().resolveDate__ju_Map__Ljava_time_format_ResolverStyle__Ljava_time_LocalDate($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues, resolverStyle));
  } else if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_1 = $m_Ljava_time_LocalDate$();
    var x = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField());
    $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, $x_1.ofEpochDay__J__Ljava_time_LocalDate($uJ(x)));
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V as $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V };
function $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, date) {
  if ((date !== null)) {
    $thiz.Ljava_time_format_DateTimeBuilder__f_date = date;
    var fields = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.keySet__ju_Set().iterator__ju_Iterator();
    var break$1 = false;
    while (((!break$1) && fields.hasNext__Z())) {
      var field = fields.next__O();
      if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
        if (field.isDateBased__Z()) {
          var val1__lo = 0;
          var val1__hi = 0;
          try {
            var t = date.getLong__Ljava_time_temporal_TemporalField__J(field);
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            var $x_1__lo = lo;
            var $x_1__hi = hi;
            val1__lo = $x_1__lo;
            val1__hi = $x_1__hi;
          } catch (e) {
            if ((e instanceof $c_Ljava_time_DateTimeException)) {
              break$1 = true;
            } else {
              throw e;
            }
          }
          if ((!break$1)) {
            var x = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O(field);
            var t$1 = $uJ(x);
            var lo$1 = t$1.RTLong__f_lo;
            var hi$1 = t$1.RTLong__f_hi;
            var a__lo = val1__lo;
            var a__hi = val1__hi;
            if ((!((a__lo === lo$1) && (a__hi === hi$1)))) {
              throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((((("Conflict found: Field " + field) + " ") + new $c_RTLong(val1__lo, val1__hi)) + " differs from ") + field) + " ") + new $c_RTLong(lo$1, hi$1)) + " derived from ") + date));
            }
          }
        }
      }
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V as $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V };
function $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      if ((!((resolverStyle === $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle()) && ((lo === 0) && (hi === 0))))) {
        var this$3 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
        this$3.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo, hi), this$3);
      }
    }
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), (((lo === 24) && (hi === 0)) ? $L0 : new $c_RTLong(lo, hi)));
  }
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField())) {
    var x$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField());
    var t$1 = $uJ(x$1);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      if ((!((resolverStyle === $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle()) && ((lo$1 === 0) && (hi$1 === 0))))) {
        var this$7 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
        this$7.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$1, hi$1), this$7);
      }
    }
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), (((lo$1 === 12) && (hi$1 === 0)) ? $L0 : new $c_RTLong(lo$1, hi$1)));
  }
  if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
    if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField())) {
      var this$10 = $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
      var x$2 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField());
      var t$2 = $uJ(x$2);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      this$10.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$2, hi$2), this$10);
    }
    if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField())) {
      var this$12 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
      var x$3 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField());
      var t$3 = $uJ(x$3);
      var lo$3 = t$3.RTLong__f_lo;
      var hi$3 = t$3.RTLong__f_hi;
      this$12.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$3, hi$3), this$12);
    }
  }
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField()) && $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField()))) {
    var x$4 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField());
    var t$4 = $uJ(x$4);
    var lo$4 = t$4.RTLong__f_lo;
    var hi$4 = t$4.RTLong__f_hi;
    var x$5 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField());
    var t$5 = $uJ(x$5);
    var lo$5 = t$5.RTLong__f_lo;
    var hi$5 = t$5.RTLong__f_hi;
    var $x_1 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var b0 = (65535 & lo$4);
    var b1 = ((lo$4 >>> 16) | 0);
    var a0b0 = Math.imul(12, b0);
    var a0b1 = Math.imul(12, b1);
    var lo$6 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$6 = ((Math.imul(12, hi$4) + ((c1part >>> 16) | 0)) | 0);
    var lo$7 = ((lo$6 + lo$5) | 0);
    var hi$7 = ((((hi$6 + hi$5) | 0) + ((((lo$6 & lo$5) | ((lo$6 | lo$5) & (~lo$7))) >>> 31) | 0)) | 0);
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_1, new $c_RTLong(lo$7, hi$7));
  }
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$6 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField());
    var t$6 = $uJ(x$6);
    var lo$8 = t$6.RTLong__f_lo;
    var hi$8 = t$6.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$18 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
      this$18.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$8, hi$8), this$18);
    }
    var $x_2 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$19 = $m_RTLong$();
    var lo$9 = this$19.divideImpl__I__I__I__I__I(lo$8, hi$8, 1000000000, 0);
    var hi$9 = this$19.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_2, new $c_RTLong(lo$9, hi$9));
    var $x_3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$20 = $m_RTLong$();
    var lo$10 = this$20.remainderImpl__I__I__I__I__I(lo$8, hi$8, 1000000000, 0);
    var hi$10 = this$20.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_3, new $c_RTLong(lo$10, hi$10));
  }
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$7 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField());
    var t$7 = $uJ(x$7);
    var lo$11 = t$7.RTLong__f_lo;
    var hi$11 = t$7.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$22 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
      this$22.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$11, hi$11), this$22);
    }
    var $x_4 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$23 = $m_RTLong$();
    var lo$12 = this$23.divideImpl__I__I__I__I__I(lo$11, hi$11, 1000000, 0);
    var hi$12 = this$23.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_4, new $c_RTLong(lo$12, hi$12));
    var $x_5 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$24 = $m_RTLong$();
    var lo$13 = this$24.remainderImpl__I__I__I__I__I(lo$11, hi$11, 1000000, 0);
    var hi$13 = this$24.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_5, new $c_RTLong(lo$13, hi$13));
  }
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$8 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField());
    var t$8 = $uJ(x$8);
    var lo$14 = t$8.RTLong__f_lo;
    var hi$14 = t$8.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$26 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
      this$26.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$14, hi$14), this$26);
    }
    var $x_6 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$27 = $m_RTLong$();
    var lo$15 = this$27.divideImpl__I__I__I__I__I(lo$14, hi$14, 1000, 0);
    var hi$15 = this$27.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_6, new $c_RTLong(lo$15, hi$15));
    var $x_7 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$28 = $m_RTLong$();
    var lo$16 = this$28.remainderImpl__I__I__I__I__I(lo$14, hi$14, 1000, 0);
    var hi$16 = this$28.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_7, new $c_RTLong(lo$16, hi$16));
  }
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$9 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField());
    var t$9 = $uJ(x$9);
    var lo$17 = t$9.RTLong__f_lo;
    var hi$17 = t$9.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$30 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
      this$30.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$17, hi$17), this$30);
    }
    var $x_8 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$31 = $m_RTLong$();
    var lo$18 = this$31.divideImpl__I__I__I__I__I(lo$17, hi$17, 3600, 0);
    var hi$18 = this$31.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_8, new $c_RTLong(lo$18, hi$18));
    var $x_9 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var this$32 = $m_RTLong$();
    var lo$19 = this$32.divideImpl__I__I__I__I__I(lo$17, hi$17, 60, 0);
    var hi$19 = this$32.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$33 = $m_RTLong$();
    var lo$20 = this$33.remainderImpl__I__I__I__I__I(lo$19, hi$19, 60, 0);
    var hi$20 = this$33.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_9, new $c_RTLong(lo$20, hi$20));
    var $x_10 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    var this$34 = $m_RTLong$();
    var lo$21 = this$34.remainderImpl__I__I__I__I__I(lo$17, hi$17, 60, 0);
    var hi$21 = this$34.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_10, new $c_RTLong(lo$21, hi$21));
  }
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var x$10 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField());
    var t$10 = $uJ(x$10);
    var lo$22 = t$10.RTLong__f_lo;
    var hi$22 = t$10.RTLong__f_hi;
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$36 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
      this$36.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$22, hi$22), this$36);
    }
    var $x_11 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var this$37 = $m_RTLong$();
    var lo$23 = this$37.divideImpl__I__I__I__I__I(lo$22, hi$22, 60, 0);
    var hi$23 = this$37.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_11, new $c_RTLong(lo$23, hi$23));
    var $x_12 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var this$38 = $m_RTLong$();
    var lo$24 = this$38.remainderImpl__I__I__I__I__I(lo$22, hi$22, 60, 0);
    var hi$24 = this$38.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_12, new $c_RTLong(lo$24, hi$24));
  }
  if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
    if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var this$40 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
      var x$11 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField());
      var t$11 = $uJ(x$11);
      var lo$25 = t$11.RTLong__f_lo;
      var hi$25 = t$11.RTLong__f_hi;
      this$40.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$25, hi$25), this$40);
    }
    if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var this$42 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      var x$12 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField());
      var t$12 = $uJ(x$12);
      var lo$26 = t$12.RTLong__f_lo;
      var hi$26 = t$12.RTLong__f_hi;
      this$42.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$26, hi$26), this$42);
    }
  }
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()) && $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var x$13 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField());
    var t$13 = $uJ(x$13);
    var lo$27 = t$13.RTLong__f_lo;
    var hi$27 = t$13.RTLong__f_hi;
    var x$14 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var t$14 = $uJ(x$14);
    var lo$28 = t$14.RTLong__f_lo;
    var hi$28 = t$14.RTLong__f_hi;
    var $x_13 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$1 = (65535 & lo$27);
    var b1$1 = ((lo$27 >>> 16) | 0);
    var a0b0$1 = Math.imul(1000, b0$1);
    var a0b1$1 = Math.imul(1000, b1$1);
    var lo$29 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$29 = ((Math.imul(1000, hi$27) + ((c1part$1 >>> 16) | 0)) | 0);
    var this$46 = $m_RTLong$();
    var lo$30 = this$46.remainderImpl__I__I__I__I__I(lo$28, hi$28, 1000, 0);
    var hi$30 = this$46.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$31 = ((lo$29 + lo$30) | 0);
    var hi$31 = ((((hi$29 + hi$30) | 0) + ((((lo$29 & lo$30) | ((lo$29 | lo$30) & (~lo$31))) >>> 31) | 0)) | 0);
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_13, new $c_RTLong(lo$31, hi$31));
  }
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()) && $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var x$15 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var t$15 = $uJ(x$15);
    var lo$32 = t$15.RTLong__f_lo;
    var hi$32 = t$15.RTLong__f_hi;
    var $x_14 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$49 = $m_RTLong$();
    var lo$33 = this$49.divideImpl__I__I__I__I__I(lo$32, hi$32, 1000, 0);
    var hi$33 = this$49.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_14, new $c_RTLong(lo$33, hi$33));
    $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField());
  }
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()) && $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var x$16 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var t$16 = $uJ(x$16);
    var lo$34 = t$16.RTLong__f_lo;
    var hi$34 = t$16.RTLong__f_hi;
    var $x_15 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    var this$51 = $m_RTLong$();
    var lo$35 = this$51.divideImpl__I__I__I__I__I(lo$34, hi$34, 1000000, 0);
    var hi$35 = this$51.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_15, new $c_RTLong(lo$35, hi$35));
    $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField());
  }
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var x$17 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var t$17 = $uJ(x$17);
    var lo$36 = t$17.RTLong__f_lo;
    var hi$36 = t$17.RTLong__f_hi;
    var $x_16 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$2 = (65535 & lo$36);
    var b1$2 = ((lo$36 >>> 16) | 0);
    var a0b0$2 = Math.imul(1000, b0$2);
    var a0b1$2 = Math.imul(1000, b1$2);
    var lo$37 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
    var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
    var hi$37 = ((Math.imul(1000, hi$36) + ((c1part$2 >>> 16) | 0)) | 0);
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_16, new $c_RTLong(lo$37, hi$37));
  } else if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var x$18 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField());
    var t$18 = $uJ(x$18);
    var lo$38 = t$18.RTLong__f_lo;
    var hi$38 = t$18.RTLong__f_hi;
    var $x_17 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$3 = (65535 & lo$38);
    var b1$3 = ((lo$38 >>> 16) | 0);
    var a0b0$3 = Math.imul(16960, b0$3);
    var a1b0 = Math.imul(15, b0$3);
    var a0b1$3 = Math.imul(16960, b1$3);
    var lo$39 = ((a0b0$3 + (((a1b0 + a0b1$3) | 0) << 16)) | 0);
    var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
    var hi$39 = ((((((Math.imul(1000000, hi$38) + Math.imul(15, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0) | 0) >>> 16) | 0)) | 0);
    $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_17, new $c_RTLong(lo$39, hi$39));
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V as $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V };
function $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  var hod = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
  var moh = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
  var som = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
  var nos = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
  if ((hod === null)) {
    return (void 0);
  }
  if (((moh === null) && ((som !== null) || (nos !== null)))) {
    return (void 0);
  }
  if ((((moh !== null) && (som === null)) && (nos !== null))) {
    return (void 0);
  }
  if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
    if ((hod !== null)) {
      if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle())) {
        var this$1 = hod;
        var $x_2 = ((this$1.RTLong__f_lo === 24) && (this$1.RTLong__f_hi === 0));
      } else {
        var $x_2 = false;
      }
      if ((($x_2 && ((moh === null) || ((moh.RTLong__f_lo === 0) && (moh.RTLong__f_hi === 0)))) && ((som === null) || ((som.RTLong__f_lo === 0) && (som.RTLong__f_hi === 0))))) {
        if ((nos === null)) {
          var $x_1 = true;
        } else {
          var this$5 = nos;
          var $x_1 = ((this$5.RTLong__f_lo === 0) && (this$5.RTLong__f_hi === 0));
        }
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        hod = $L0;
        var this$8 = $m_Ljava_time_Period$();
        $thiz.Ljava_time_format_DateTimeBuilder__f_excessDays = this$8.java$time$Period$$$create__I__I__I__Ljava_time_Period(0, 0, 1);
      }
      var this$10 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
      var x = hod;
      var t = $uJ(x);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var hodVal = this$10.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo, hi), this$10);
      if ((moh !== null)) {
        var this$12 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
        var t$1 = $uJ(moh);
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        var mohVal = this$12.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$1, hi$1), this$12);
        if ((som !== null)) {
          var this$14 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
          var t$2 = $uJ(som);
          var lo$2 = t$2.RTLong__f_lo;
          var hi$2 = t$2.RTLong__f_hi;
          var somVal = this$14.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$2, hi$2), this$14);
          if ((nos !== null)) {
            var this$16 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
            var x$1 = nos;
            var t$3 = $uJ(x$1);
            var lo$3 = t$3.RTLong__f_lo;
            var hi$3 = t$3.RTLong__f_hi;
            var nosVal = this$16.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$3, hi$3), this$16);
            var time = $m_Ljava_time_LocalTime$().of__I__I__I__I__Ljava_time_LocalTime(hodVal, mohVal, somVal, nosVal);
            $thiz.Ljava_time_format_DateTimeBuilder__f_time = time;
          } else {
            var time$1 = $m_Ljava_time_LocalTime$().of__I__I__I__Ljava_time_LocalTime(hodVal, mohVal, somVal);
            $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$1;
          }
        } else if ((nos === null)) {
          var time$2 = $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(hodVal, mohVal);
          $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$2;
        }
      } else if (((som === null) && (nos === null))) {
        var time$3 = $m_Ljava_time_LocalTime$().of__I__I__Ljava_time_LocalTime(hodVal, 0);
        $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$3;
      }
    }
  } else if ((hod !== null)) {
    var x$2 = hod;
    var t$4 = $uJ(x$2);
    var lo$4 = t$4.RTLong__f_lo;
    var hi$4 = t$4.RTLong__f_hi;
    var hodVal$2__lo = lo$4;
    var hodVal$2__hi = hi$4;
    if ((moh !== null)) {
      if ((som !== null)) {
        if ((nos === null)) {
          nos = $L0;
        }
        var a__lo = hodVal$2__lo;
        var a__hi = hodVal$2__hi;
        var this$19 = $m_jl_Math$();
        var blo = a__lo;
        var b0 = (65535 & blo);
        var b1 = ((blo >>> 16) | 0);
        var a0b0 = Math.imul(40960, b0);
        var a1b0 = Math.imul(12472, b0);
        var a0b1 = Math.imul(40960, b1);
        var lo$5 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$5 = ((((((((Math.imul(817405952, a__hi) + Math.imul(838, blo)) | 0) + Math.imul(12472, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        if ((!((a__lo === 0) && (a__hi === 0)))) {
          var this$23 = $m_RTLong$();
          var lo$6 = this$23.divideImpl__I__I__I__I__I(lo$5, hi$5, a__lo, a__hi);
          var hi$6 = this$23.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_3 = (!((lo$6 === 817405952) && (hi$6 === 838)));
        } else {
          var $x_3 = false;
        }
        if ($x_3) {
          this$19.java$lang$Math$$longOverflow__E();
        }
        var totalNanos__lo = lo$5;
        var totalNanos__hi = hi$5;
        var a$1__lo = totalNanos__lo;
        var a$1__hi = totalNanos__hi;
        var t$5 = $uJ(moh);
        var lo$7 = t$5.RTLong__f_lo;
        var hi$7 = t$5.RTLong__f_hi;
        var this$26 = $m_jl_Math$();
        var b0$1 = (65535 & lo$7);
        var b1$1 = ((lo$7 >>> 16) | 0);
        var a0b0$1 = Math.imul(22528, b0$1);
        var a1b0$1 = Math.imul(63559, b0$1);
        var a0b1$1 = Math.imul(22528, b1$1);
        var lo$8 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$8 = ((((((((Math.imul((-129542144), hi$7) + Math.imul(13, lo$7)) | 0) + Math.imul(63559, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        if ((!((lo$7 === 0) && (hi$7 === 0)))) {
          var this$30 = $m_RTLong$();
          var lo$9 = this$30.divideImpl__I__I__I__I__I(lo$8, hi$8, lo$7, hi$7);
          var hi$9 = this$30.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_4 = (!((lo$9 === (-129542144)) && (hi$9 === 13)));
        } else {
          var $x_4 = false;
        }
        if ($x_4) {
          this$26.java$lang$Math$$longOverflow__E();
        }
        var this$32 = $m_jl_Math$();
        var alo = a$1__lo;
        var lo$10 = ((alo + lo$8) | 0);
        var hi$10 = ((((a$1__hi + hi$8) | 0) + ((((alo & lo$8) | ((alo | lo$8) & (~lo$10))) >>> 31) | 0)) | 0);
        var hi$11 = (hi$10 ^ a$1__hi);
        var hi$12 = (hi$10 ^ hi$8);
        var hi$13 = (hi$11 & hi$12);
        if ((hi$13 < 0)) {
          this$32.java$lang$Math$$longOverflow__E();
        }
        var $x_5__lo = lo$10;
        var $x_5__hi = hi$10;
        totalNanos__lo = $x_5__lo;
        totalNanos__hi = $x_5__hi;
        var a$2__lo = totalNanos__lo;
        var a$2__hi = totalNanos__hi;
        var t$6 = $uJ(som);
        var lo$14 = t$6.RTLong__f_lo;
        var hi$14 = t$6.RTLong__f_hi;
        var this$39 = $m_jl_Math$();
        var b0$2 = (65535 & lo$14);
        var b1$2 = ((lo$14 >>> 16) | 0);
        var a0b0$2 = Math.imul(51712, b0$2);
        var a1b0$2 = Math.imul(15258, b0$2);
        var a0b1$2 = Math.imul(51712, b1$2);
        var lo$15 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
        var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
        var hi$15 = ((((((Math.imul(1000000000, hi$14) + Math.imul(15258, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
        if ((!((lo$14 === 0) && (hi$14 === 0)))) {
          var this$43 = $m_RTLong$();
          var lo$16 = this$43.divideImpl__I__I__I__I__I(lo$15, hi$15, lo$14, hi$14);
          var hi$16 = this$43.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_6 = (!((lo$16 === 1000000000) && (hi$16 === 0)));
        } else {
          var $x_6 = false;
        }
        if ($x_6) {
          this$39.java$lang$Math$$longOverflow__E();
        }
        var this$45 = $m_jl_Math$();
        var alo$1 = a$2__lo;
        var lo$17 = ((alo$1 + lo$15) | 0);
        var hi$17 = ((((a$2__hi + hi$15) | 0) + ((((alo$1 & lo$15) | ((alo$1 | lo$15) & (~lo$17))) >>> 31) | 0)) | 0);
        var hi$18 = (hi$17 ^ a$2__hi);
        var hi$19 = (hi$17 ^ hi$15);
        var hi$20 = (hi$18 & hi$19);
        if ((hi$20 < 0)) {
          this$45.java$lang$Math$$longOverflow__E();
        }
        var $x_7__lo = lo$17;
        var $x_7__hi = hi$17;
        totalNanos__lo = $x_7__lo;
        totalNanos__hi = $x_7__hi;
        var a$3__lo = totalNanos__lo;
        var a$3__hi = totalNanos__hi;
        var x$3 = nos;
        var t$7 = $uJ(x$3);
        var lo$21 = t$7.RTLong__f_lo;
        var hi$21 = t$7.RTLong__f_hi;
        var this$52 = $m_jl_Math$();
        var alo$2 = a$3__lo;
        var lo$22 = ((alo$2 + lo$21) | 0);
        var hi$22 = ((((a$3__hi + hi$21) | 0) + ((((alo$2 & lo$21) | ((alo$2 | lo$21) & (~lo$22))) >>> 31) | 0)) | 0);
        var hi$23 = (hi$22 ^ a$3__hi);
        var hi$24 = (hi$22 ^ hi$21);
        var hi$25 = (hi$23 & hi$24);
        if ((hi$25 < 0)) {
          this$52.java$lang$Math$$longOverflow__E();
        }
        var $x_8__lo = lo$22;
        var $x_8__hi = hi$22;
        totalNanos__lo = $x_8__lo;
        totalNanos__hi = $x_8__hi;
        var a$4__lo = totalNanos__lo;
        var a$4__hi = totalNanos__hi;
        var this$59 = $m_RTLong$();
        var lo$26 = this$59.divideImpl__I__I__I__I__I(a$4__lo, a$4__hi, (-1857093632), 20116);
        var hi$26 = this$59.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var hi$27 = (20116 ^ a$4__hi);
        if ((hi$27 >= 0)) {
          var $x_9 = true;
        } else {
          var b0$3 = (65535 & lo$26);
          var b1$3 = ((lo$26 >>> 16) | 0);
          var a1b0$3 = Math.imul(37199, b0$3);
          var lo$28 = (a1b0$3 << 16);
          var hi$28 = ((((((Math.imul((-1857093632), hi$26) + Math.imul(20116, lo$26)) | 0) + Math.imul(37199, b1$3)) | 0) + ((a1b0$3 >>> 16) | 0)) | 0);
          var $x_9 = ((lo$28 === a$4__lo) && (hi$28 === a$4__hi));
        }
        if ($x_9) {
          var a$5__lo = lo$26;
          var a$5__hi = hi$26;
        } else {
          var lo$29 = (((-1) + lo$26) | 0);
          var hi$29 = (((((-1) + hi$26) | 0) + (((lo$26 | (~lo$29)) >>> 31) | 0)) | 0);
          var a$5__lo = lo$29;
          var a$5__hi = hi$29;
        }
        var excessDays = a$5__lo;
        var a$6__lo = totalNanos__lo;
        var a$6__hi = totalNanos__hi;
        var this$67 = $m_RTLong$();
        var lo$30 = this$67.remainderImpl__I__I__I__I__I(a$6__lo, a$6__hi, (-1857093632), 20116);
        var hi$30 = this$67.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var hi$31 = (20116 ^ a$6__hi);
        if (((hi$31 >= 0) || ((lo$30 === 0) && (hi$30 === 0)))) {
          var nod__lo = lo$30;
          var nod__hi = hi$30;
        } else {
          var lo$32 = (((-1857093632) + lo$30) | 0);
          var hi$32 = ((((20116 + hi$30) | 0) + (((lo$30 | (~lo$32)) >>> 31) | 0)) | 0);
          var nod__lo = lo$32;
          var nod__hi = hi$32;
        }
        var time$4 = $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(nod__lo, nod__hi));
        $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$4;
        var this$72 = $m_Ljava_time_Period$();
        $thiz.Ljava_time_format_DateTimeBuilder__f_excessDays = this$72.java$time$Period$$$create__I__I__I__Ljava_time_Period(0, 0, excessDays);
      } else {
        var a$7__lo = hodVal$2__lo;
        var a$7__hi = hodVal$2__hi;
        var this$73 = $m_jl_Math$();
        var blo$1 = a$7__lo;
        var b0$4 = (65535 & blo$1);
        var b1$4 = ((blo$1 >>> 16) | 0);
        var a0b0$3 = Math.imul(3600, b0$4);
        var a0b1$3 = Math.imul(3600, b1$4);
        var lo$33 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
        var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
        var hi$33 = ((Math.imul(3600, a$7__hi) + ((c1part$3 >>> 16) | 0)) | 0);
        if ((!((a$7__lo === 0) && (a$7__hi === 0)))) {
          var this$77 = $m_RTLong$();
          var lo$34 = this$77.divideImpl__I__I__I__I__I(lo$33, hi$33, a$7__lo, a$7__hi);
          var hi$34 = this$77.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_10 = (!((lo$34 === 3600) && (hi$34 === 0)));
        } else {
          var $x_10 = false;
        }
        if ($x_10) {
          this$73.java$lang$Math$$longOverflow__E();
        }
        var totalSecs__lo = lo$33;
        var totalSecs__hi = hi$33;
        var a$8__lo = totalSecs__lo;
        var a$8__hi = totalSecs__hi;
        var t$8 = $uJ(moh);
        var lo$35 = t$8.RTLong__f_lo;
        var hi$35 = t$8.RTLong__f_hi;
        var this$80 = $m_jl_Math$();
        var b0$5 = (65535 & lo$35);
        var b1$5 = ((lo$35 >>> 16) | 0);
        var a0b0$4 = Math.imul(60, b0$5);
        var a0b1$4 = Math.imul(60, b1$5);
        var lo$36 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
        var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
        var hi$36 = ((Math.imul(60, hi$35) + ((c1part$4 >>> 16) | 0)) | 0);
        if ((!((lo$35 === 0) && (hi$35 === 0)))) {
          var this$84 = $m_RTLong$();
          var lo$37 = this$84.divideImpl__I__I__I__I__I(lo$36, hi$36, lo$35, hi$35);
          var hi$37 = this$84.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_11 = (!((lo$37 === 60) && (hi$37 === 0)));
        } else {
          var $x_11 = false;
        }
        if ($x_11) {
          this$80.java$lang$Math$$longOverflow__E();
        }
        var this$86 = $m_jl_Math$();
        var alo$3 = a$8__lo;
        var lo$38 = ((alo$3 + lo$36) | 0);
        var hi$38 = ((((a$8__hi + hi$36) | 0) + ((((alo$3 & lo$36) | ((alo$3 | lo$36) & (~lo$38))) >>> 31) | 0)) | 0);
        var hi$39 = (hi$38 ^ a$8__hi);
        var hi$40 = (hi$38 ^ hi$36);
        var hi$41 = (hi$39 & hi$40);
        if ((hi$41 < 0)) {
          this$86.java$lang$Math$$longOverflow__E();
        }
        var $x_12__lo = lo$38;
        var $x_12__hi = hi$38;
        totalSecs__lo = $x_12__lo;
        totalSecs__hi = $x_12__hi;
        var a$9__lo = totalSecs__lo;
        var a$9__hi = totalSecs__hi;
        var this$93 = $m_RTLong$();
        var lo$42 = this$93.divideImpl__I__I__I__I__I(a$9__lo, a$9__hi, 86400, 0);
        var hi$42 = this$93.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var hi$43 = a$9__hi;
        if ((hi$43 >= 0)) {
          var $x_13 = true;
        } else {
          var b0$6 = (65535 & lo$42);
          var b1$6 = ((lo$42 >>> 16) | 0);
          var a0b0$5 = Math.imul(20864, b0$6);
          var a0b1$5 = Math.imul(20864, b1$6);
          var lo$44 = ((a0b0$5 + (((b0$6 + a0b1$5) | 0) << 16)) | 0);
          var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
          var hi$44 = ((((((Math.imul(86400, hi$42) + b1$6) | 0) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + b0$6) | 0) >>> 16) | 0)) | 0);
          var $x_13 = ((lo$44 === a$9__lo) && (hi$44 === a$9__hi));
        }
        if ($x_13) {
          var a$10__lo = lo$42;
          var a$10__hi = hi$42;
        } else {
          var lo$45 = (((-1) + lo$42) | 0);
          var hi$45 = (((((-1) + hi$42) | 0) + (((lo$42 | (~lo$45)) >>> 31) | 0)) | 0);
          var a$10__lo = lo$45;
          var a$10__hi = hi$45;
        }
        var excessDays$2 = a$10__lo;
        var a$11__lo = totalSecs__lo;
        var a$11__hi = totalSecs__hi;
        var this$101 = $m_RTLong$();
        var lo$46 = this$101.remainderImpl__I__I__I__I__I(a$11__lo, a$11__hi, 86400, 0);
        var hi$46 = this$101.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var hi$47 = a$11__hi;
        if (((hi$47 >= 0) || ((lo$46 === 0) && (hi$46 === 0)))) {
          var sod__lo = lo$46;
          var sod__hi = hi$46;
        } else {
          var lo$48 = ((86400 + lo$46) | 0);
          var hi$48 = ((hi$46 + (((lo$46 & (~lo$48)) >>> 31) | 0)) | 0);
          var sod__lo = lo$48;
          var sod__hi = hi$48;
        }
        var time$5 = $m_Ljava_time_LocalTime$().ofSecondOfDay__J__Ljava_time_LocalTime(new $c_RTLong(sod__lo, sod__hi));
        $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$5;
        var this$106 = $m_Ljava_time_Period$();
        $thiz.Ljava_time_format_DateTimeBuilder__f_excessDays = this$106.java$time$Period$$$create__I__I__I__Ljava_time_Period(0, 0, excessDays$2);
      }
    } else {
      var a$12__lo = hodVal$2__lo;
      var a$12__hi = hodVal$2__hi;
      var this$108 = $m_RTLong$();
      var lo$49 = this$108.divideImpl__I__I__I__I__I(a$12__lo, a$12__hi, 24, 0);
      var hi$49 = this$108.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var hi$50 = a$12__hi;
      if ((hi$50 >= 0)) {
        var $x_14 = true;
      } else {
        var b0$7 = (65535 & lo$49);
        var b1$7 = ((lo$49 >>> 16) | 0);
        var a0b0$6 = Math.imul(24, b0$7);
        var a0b1$6 = Math.imul(24, b1$7);
        var lo$51 = ((a0b0$6 + (a0b1$6 << 16)) | 0);
        var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
        var hi$51 = ((Math.imul(24, hi$49) + ((c1part$6 >>> 16) | 0)) | 0);
        var $x_14 = ((lo$51 === a$12__lo) && (hi$51 === a$12__hi));
      }
      if ($x_14) {
        var a$13__lo = lo$49;
        var a$13__hi = hi$49;
      } else {
        var lo$52 = (((-1) + lo$49) | 0);
        var hi$52 = (((((-1) + hi$49) | 0) + (((lo$49 | (~lo$52)) >>> 31) | 0)) | 0);
        var a$13__lo = lo$52;
        var a$13__hi = hi$52;
      }
      var this$114 = $m_jl_Math$();
      var res = a$13__lo;
      var hi$53 = (res >> 31);
      if ((!((res === a$13__lo) && (hi$53 === a$13__hi)))) {
        this$114.java$lang$Math$$intOverflow__E();
      }
      var a$14__lo = hodVal$2__lo;
      var a$14__hi = hodVal$2__hi;
      var this$119 = $m_RTLong$();
      var lo$53 = this$119.remainderImpl__I__I__I__I__I(a$14__lo, a$14__hi, 24, 0);
      var hi$54 = this$119.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var hi$55 = a$14__hi;
      if (((hi$55 >= 0) || ((lo$53 === 0) && (hi$54 === 0)))) {
        var $x_15__lo = lo$53;
        var $x_15__hi = hi$54;
        hodVal$2__lo = $x_15__lo;
        hodVal$2__hi = $x_15__hi;
      } else {
        var lo$55 = ((24 + lo$53) | 0);
        var hi$56 = ((hi$54 + (((lo$53 & (~lo$55)) >>> 31) | 0)) | 0);
        var $x_16__lo = lo$55;
        var $x_16__hi = hi$56;
        hodVal$2__lo = $x_16__lo;
        hodVal$2__hi = $x_16__hi;
      }
      var $x_17 = $m_Ljava_time_LocalTime$();
      var a$15__lo = hodVal$2__lo;
      var a$15__hi = hodVal$2__hi;
      var time$6 = $x_17.of__I__I__Ljava_time_LocalTime(a$15__lo, 0);
      $thiz.Ljava_time_format_DateTimeBuilder__f_time = time$6;
      var this$125 = $m_Ljava_time_Period$();
      $thiz.Ljava_time_format_DateTimeBuilder__f_excessDays = this$125.java$time$Period$$$create__I__I__I__Ljava_time_Period(0, 0, res);
    }
  }
  $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
  $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
  $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
  $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V as $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V };
function $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V($thiz) {
  if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
    if (($thiz.Ljava_time_format_DateTimeBuilder__f_zone !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, $thiz.Ljava_time_format_DateTimeBuilder__f_zone);
    } else {
      var offsetSecs = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
      if ((offsetSecs !== null)) {
        var offset = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(offsetSecs.RTLong__f_lo);
        $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, offset);
      }
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V as $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V };
function $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, selectedZone) {
  var this$2 = $m_Ljava_time_Instant$();
  var x = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var instant = this$2.java$time$Instant$$$create__J__I__Ljava_time_Instant(new $c_RTLong(lo, hi), 0);
  var zdt = $m_Ljava_time_ZonedDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(instant, selectedZone);
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_date === null)) {
    var this$4 = zdt.Ljava_time_ZonedDateTime__f_dateTime;
    var date = this$4.Ljava_time_LocalDateTime__f_date;
    $thiz.Ljava_time_format_DateTimeBuilder__f_date = date;
  } else {
    var $x_1 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    var this$5 = zdt.Ljava_time_ZonedDateTime__f_dateTime;
    $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, $x_1, this$5.Ljava_time_LocalDateTime__f_date);
  }
  var $x_2 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  var this$6 = zdt.Ljava_time_ZonedDateTime__f_dateTime;
  var value = this$6.Ljava_time_LocalDateTime__f_time.toSecondOfDay__I();
  var hi$1 = (value >> 31);
  $thiz.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($x_2, new $c_RTLong(value, hi$1));
}
export { $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V as $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V };
function $p_Ljava_time_format_DateTimeBuilder__crossCheck__V($thiz) {
  if (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.size__I() > 0)) {
    if ((($thiz.Ljava_time_format_DateTimeBuilder__f_date !== null) && ($thiz.Ljava_time_format_DateTimeBuilder__f_time !== null))) {
      var this$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_date;
      var localTime = $thiz.Ljava_time_format_DateTimeBuilder__f_time;
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$1, localTime));
    } else if (($thiz.Ljava_time_format_DateTimeBuilder__f_date !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $thiz.Ljava_time_format_DateTimeBuilder__f_date);
    } else if (($thiz.Ljava_time_format_DateTimeBuilder__f_time !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $thiz.Ljava_time_format_DateTimeBuilder__f_time);
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__crossCheck__V as $p_Ljava_time_format_DateTimeBuilder__crossCheck__V };
function $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, temporal) {
  var it = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.entrySet__ju_Set().iterator__ju_Iterator();
  while (it.hasNext__Z()) {
    var entry = it.next__O();
    var field = entry.getKey__O();
    var x = entry.getValue__O();
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if (temporal.isSupported__Ljava_time_temporal_TemporalField__Z(field)) {
      var temporalValue__lo = 0;
      var temporalValue__hi = 0;
      try {
        var t$1 = temporal.getLong__Ljava_time_temporal_TemporalField__J(field);
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        var $x_1__lo = lo$1;
        var $x_1__hi = hi$1;
        temporalValue__lo = $x_1__lo;
        temporalValue__hi = $x_1__hi;
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        if ((!(e$2 instanceof $c_jl_RuntimeException))) {
          throw e;
        }
      }
      var a__lo = temporalValue__lo;
      var a__hi = temporalValue__hi;
      if ((!((a__lo === lo) && (a__hi === hi)))) {
        throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((("Cross check failed: " + field) + " ") + new $c_RTLong(temporalValue__lo, temporalValue__hi)) + " vs ") + field) + " ") + new $c_RTLong(lo, hi)));
      }
      it.remove__V();
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V as $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V };
function $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V($thiz) {
  if ((($thiz.Ljava_time_format_DateTimeBuilder__f_time === null) && (($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField())) || $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField())))) {
    if ($thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var x = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
      var t = $uJ(x);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var $x_2 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var $x_1 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      var this$2 = $m_RTLong$();
      var lo$1 = this$2.divideImpl__I__I__I__I__I(lo, hi, 1000, 0);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      $x_2.put__O__O__O($x_1, new $c_RTLong(lo$1, hi$1));
      var $x_4 = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues;
      var $x_3 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
      var this$4 = $m_RTLong$();
      var lo$2 = this$4.divideImpl__I__I__I__I__I(lo, hi, 1000000, 0);
      var hi$2 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      $x_4.put__O__O__O($x_3, new $c_RTLong(lo$2, hi$2));
    } else {
      $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.put__O__O__O($s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), $L0);
      $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.put__O__O__O($s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField(), $L0);
      $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.put__O__O__O($s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField(), $L0);
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V as $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V };
function $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V($thiz) {
  if ((($thiz.Ljava_time_format_DateTimeBuilder__f_date !== null) && ($thiz.Ljava_time_format_DateTimeBuilder__f_time !== null))) {
    var offsetSecs = $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField());
    if ((offsetSecs !== null)) {
      var offset = $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(offsetSecs.RTLong__f_lo);
      var this$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_date;
      var localTime = $thiz.Ljava_time_format_DateTimeBuilder__f_time;
      var this$2 = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$1, localTime);
      var this$3 = $m_Ljava_time_ZonedDateTime$();
      var t = this$3.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this$2, offset, null).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.put__O__O__O($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), new $c_RTLong(lo, hi));
    } else if (($thiz.Ljava_time_format_DateTimeBuilder__f_zone !== null)) {
      var this$5 = $thiz.Ljava_time_format_DateTimeBuilder__f_date;
      var localTime$1 = $thiz.Ljava_time_format_DateTimeBuilder__f_time;
      var this$6 = $m_Ljava_time_LocalDateTime$().of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$5, localTime$1);
      var zone = $thiz.Ljava_time_format_DateTimeBuilder__f_zone;
      var this$7 = $m_Ljava_time_ZonedDateTime$();
      var t$1 = this$7.ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this$6, zone, null).getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      $thiz.Ljava_time_format_DateTimeBuilder__f_fieldValues.put__O__O__O($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), new $c_RTLong(lo$1, hi$1));
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V as $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V };
/** @constructor */
function $c_Ljava_time_format_DateTimeBuilder() {
  this.Ljava_time_format_DateTimeBuilder__f_fieldValues = null;
  this.Ljava_time_format_DateTimeBuilder__f_chrono = null;
  this.Ljava_time_format_DateTimeBuilder__f_zone = null;
  this.Ljava_time_format_DateTimeBuilder__f_date = null;
  this.Ljava_time_format_DateTimeBuilder__f_time = null;
  this.Ljava_time_format_DateTimeBuilder__f_excessDays = null;
  this.Ljava_time_format_DateTimeBuilder__f_fieldValues = $ct_ju_HashMap__(new $c_ju_HashMap());
  this.Ljava_time_format_DateTimeBuilder__f_chrono = null;
  this.Ljava_time_format_DateTimeBuilder__f_zone = null;
  this.Ljava_time_format_DateTimeBuilder__f_date = null;
  this.Ljava_time_format_DateTimeBuilder__f_time = null;
  this.Ljava_time_format_DateTimeBuilder__f_excessDays = null;
}
export { $c_Ljava_time_format_DateTimeBuilder as $c_Ljava_time_format_DateTimeBuilder };
$c_Ljava_time_format_DateTimeBuilder.prototype = new $h_O();
$c_Ljava_time_format_DateTimeBuilder.prototype.constructor = $c_Ljava_time_format_DateTimeBuilder;
/** @constructor */
function $h_Ljava_time_format_DateTimeBuilder() {
}
export { $h_Ljava_time_format_DateTimeBuilder as $h_Ljava_time_format_DateTimeBuilder };
$h_Ljava_time_format_DateTimeBuilder.prototype = $c_Ljava_time_format_DateTimeBuilder.prototype;
$c_Ljava_time_format_DateTimeBuilder.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field);
});
$c_Ljava_time_format_DateTimeBuilder.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
});
$c_Ljava_time_format_DateTimeBuilder.prototype.addFieldValue__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder = (function(field, value) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field");
  }
  var old = this.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O(field);
  if (((old !== null) && (!((old.RTLong__f_lo === value.RTLong__f_lo) && (old.RTLong__f_hi === value.RTLong__f_hi))))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ((((((((("Conflict found: " + field) + " ") + old) + " differs from ") + field) + " ") + value) + ": ") + this));
  } else {
    return $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder(this, field, value);
  }
});
$c_Ljava_time_format_DateTimeBuilder.prototype.resolve__Ljava_time_format_ResolverStyle__ju_Set__Ljava_time_format_DateTimeBuilder = (function(resolverStyle, resolverFields) {
  if ((resolverFields !== null)) {
    this.Ljava_time_format_DateTimeBuilder__f_fieldValues.keySet__ju_Set().retainAll__ju_Collection__Z(resolverFields);
  }
  $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V(this);
  $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  if ($p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z(this, resolverStyle)) {
    $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V(this);
    $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
    $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  }
  $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  $p_Ljava_time_format_DateTimeBuilder__crossCheck__V(this);
  if (((((this.Ljava_time_format_DateTimeBuilder__f_excessDays !== null) && (!this.Ljava_time_format_DateTimeBuilder__f_excessDays.isZero__Z())) && (this.Ljava_time_format_DateTimeBuilder__f_date !== null)) && (this.Ljava_time_format_DateTimeBuilder__f_time !== null))) {
    var this$1 = this.Ljava_time_format_DateTimeBuilder__f_date;
    var amount = this.Ljava_time_format_DateTimeBuilder__f_excessDays;
    this.Ljava_time_format_DateTimeBuilder__f_date = amount.addTo__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this$1);
    this.Ljava_time_format_DateTimeBuilder__f_excessDays = $m_Ljava_time_Period$().ZERO__Ljava_time_Period();
  }
  $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V(this);
  $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V(this);
  return this;
});
$c_Ljava_time_format_DateTimeBuilder.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  if ((field !== null)) {
    if (this.Ljava_time_format_DateTimeBuilder__f_fieldValues.containsKey__O__Z(field)) {
      var $x_1 = true;
    } else if ((this.Ljava_time_format_DateTimeBuilder__f_date !== null)) {
      var this$1 = this.Ljava_time_format_DateTimeBuilder__f_date;
      var $x_1 = $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this$1, field);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return true;
    } else {
      return ((this.Ljava_time_format_DateTimeBuilder__f_time !== null) && this.Ljava_time_format_DateTimeBuilder__f_time.isSupported__Ljava_time_temporal_TemporalField__Z(field));
    }
  } else {
    return false;
  }
});
$c_Ljava_time_format_DateTimeBuilder.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "field");
  }
  var value = this.Ljava_time_format_DateTimeBuilder__f_fieldValues.get__O__O(field);
  if ((value === null)) {
    if ((this.Ljava_time_format_DateTimeBuilder__f_date !== null)) {
      var this$2 = this.Ljava_time_format_DateTimeBuilder__f_date;
      var $x_1 = $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this$2, field);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return this.Ljava_time_format_DateTimeBuilder__f_date.getLong__Ljava_time_temporal_TemporalField__J(field);
    }
    if (((this.Ljava_time_format_DateTimeBuilder__f_time !== null) && this.Ljava_time_format_DateTimeBuilder__f_time.isSupported__Ljava_time_temporal_TemporalField__Z(field))) {
      return this.Ljava_time_format_DateTimeBuilder__f_time.getLong__Ljava_time_temporal_TemporalField__J(field);
    }
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field not found: " + field));
  }
  return $uJ(value);
});
$c_Ljava_time_format_DateTimeBuilder.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_DateTimeBuilder__f_zone : ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_DateTimeBuilder__f_chrono : ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) ? ((this.Ljava_time_format_DateTimeBuilder__f_date !== null) ? $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(this.Ljava_time_format_DateTimeBuilder__f_date) : null) : ((query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_format_DateTimeBuilder__f_time : (((query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this) : ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? null : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)))))));
});
$c_Ljava_time_format_DateTimeBuilder.prototype.toString__T = (function() {
  var fields = ((this.Ljava_time_format_DateTimeBuilder__f_fieldValues.size__I() > 0) ? (("fields=" + this.Ljava_time_format_DateTimeBuilder__f_fieldValues) + ", ") : "");
  return (((((((((("DateTimeBuilder[" + fields) + " ") + this.Ljava_time_format_DateTimeBuilder__f_chrono) + ", ") + this.Ljava_time_format_DateTimeBuilder__f_zone) + ", ") + this.Ljava_time_format_DateTimeBuilder__f_date) + ", ") + this.Ljava_time_format_DateTimeBuilder__f_time) + "]");
});
var $d_Ljava_time_format_DateTimeBuilder = new $TypeData().initClass($c_Ljava_time_format_DateTimeBuilder, "java.time.format.DateTimeBuilder", ({
  Ljava_time_format_DateTimeBuilder: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  jl_Cloneable: 1
}));
export { $d_Ljava_time_format_DateTimeBuilder as $d_Ljava_time_format_DateTimeBuilder };
function $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__STRICT;
}
export { $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle as $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle };
function $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__SMART;
}
export { $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle as $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle };
function $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle() {
  $m_Ljava_time_format_ResolverStyle$();
  return $t_Ljava_time_format_ResolverStyle$__LENIENT;
}
export { $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle as $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle };
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$() {
  $n_Ljava_time_format_ResolverStyle$ = this;
  $t_Ljava_time_format_ResolverStyle$__STRICT = new $c_Ljava_time_format_ResolverStyle$$anon$1();
  $t_Ljava_time_format_ResolverStyle$__SMART = new $c_Ljava_time_format_ResolverStyle$$anon$2();
  $t_Ljava_time_format_ResolverStyle$__LENIENT = new $c_Ljava_time_format_ResolverStyle$$anon$3();
  $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
  $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle();
  $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle();
}
export { $c_Ljava_time_format_ResolverStyle$ as $c_Ljava_time_format_ResolverStyle$ };
$c_Ljava_time_format_ResolverStyle$.prototype = new $h_O();
$c_Ljava_time_format_ResolverStyle$.prototype.constructor = $c_Ljava_time_format_ResolverStyle$;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$() {
}
export { $h_Ljava_time_format_ResolverStyle$ as $h_Ljava_time_format_ResolverStyle$ };
$h_Ljava_time_format_ResolverStyle$.prototype = $c_Ljava_time_format_ResolverStyle$.prototype;
$c_Ljava_time_format_ResolverStyle$.prototype.ordinal__O__I = (function(x) {
  return x.jl_Enum__f__ordinal;
});
var $d_Ljava_time_format_ResolverStyle$ = new $TypeData().initClass($c_Ljava_time_format_ResolverStyle$, "java.time.format.ResolverStyle$", ({
  Ljava_time_format_ResolverStyle$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Ljava_time_format_ResolverStyle$ as $d_Ljava_time_format_ResolverStyle$ };
var $n_Ljava_time_format_ResolverStyle$;
function $m_Ljava_time_format_ResolverStyle$() {
  if ((!$n_Ljava_time_format_ResolverStyle$)) {
    $n_Ljava_time_format_ResolverStyle$ = new $c_Ljava_time_format_ResolverStyle$();
  }
  return $n_Ljava_time_format_ResolverStyle$;
}
export { $m_Ljava_time_format_ResolverStyle$ as $m_Ljava_time_format_ResolverStyle$ };
function $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__NORMAL;
}
export { $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle as $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle };
function $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__ALWAYS;
}
export { $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle as $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle };
function $s_Ljava_time_format_SignStyle$__NEVER__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__NEVER;
}
export { $s_Ljava_time_format_SignStyle$__NEVER__Ljava_time_format_SignStyle as $s_Ljava_time_format_SignStyle$__NEVER__Ljava_time_format_SignStyle };
function $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE;
}
export { $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle as $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle };
function $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle() {
  $m_Ljava_time_format_SignStyle$();
  return $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD;
}
export { $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle as $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle };
/** @constructor */
function $c_Ljava_time_format_SignStyle$() {
  $n_Ljava_time_format_SignStyle$ = this;
  $t_Ljava_time_format_SignStyle$__NORMAL = new $c_Ljava_time_format_SignStyle$$anon$1();
  $t_Ljava_time_format_SignStyle$__ALWAYS = new $c_Ljava_time_format_SignStyle$$anon$2();
  $t_Ljava_time_format_SignStyle$__NEVER = new $c_Ljava_time_format_SignStyle$$anon$3();
  $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE = new $c_Ljava_time_format_SignStyle$$anon$4();
  $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD = new $c_Ljava_time_format_SignStyle$$anon$5();
  $s_Ljava_time_format_SignStyle$__NORMAL__Ljava_time_format_SignStyle();
  $s_Ljava_time_format_SignStyle$__ALWAYS__Ljava_time_format_SignStyle();
  $s_Ljava_time_format_SignStyle$__NEVER__Ljava_time_format_SignStyle();
  $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle();
  $s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle();
}
export { $c_Ljava_time_format_SignStyle$ as $c_Ljava_time_format_SignStyle$ };
$c_Ljava_time_format_SignStyle$.prototype = new $h_O();
$c_Ljava_time_format_SignStyle$.prototype.constructor = $c_Ljava_time_format_SignStyle$;
/** @constructor */
function $h_Ljava_time_format_SignStyle$() {
}
export { $h_Ljava_time_format_SignStyle$ as $h_Ljava_time_format_SignStyle$ };
$h_Ljava_time_format_SignStyle$.prototype = $c_Ljava_time_format_SignStyle$.prototype;
$c_Ljava_time_format_SignStyle$.prototype.ordinal__O__I = (function(x) {
  return x.jl_Enum__f__ordinal;
});
var $d_Ljava_time_format_SignStyle$ = new $TypeData().initClass($c_Ljava_time_format_SignStyle$, "java.time.format.SignStyle$", ({
  Ljava_time_format_SignStyle$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Ljava_time_format_SignStyle$ as $d_Ljava_time_format_SignStyle$ };
var $n_Ljava_time_format_SignStyle$;
function $m_Ljava_time_format_SignStyle$() {
  if ((!$n_Ljava_time_format_SignStyle$)) {
    $n_Ljava_time_format_SignStyle$ = new $c_Ljava_time_format_SignStyle$();
  }
  return $n_Ljava_time_format_SignStyle$;
}
export { $m_Ljava_time_format_SignStyle$ as $m_Ljava_time_format_SignStyle$ };
function $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle() {
  $m_Ljava_time_format_TextStyle$();
  return $t_Ljava_time_format_TextStyle$__FULL;
}
export { $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle as $s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle };
function $s_Ljava_time_format_TextStyle$__FULL_STANDALONE__Ljava_time_format_TextStyle() {
  $m_Ljava_time_format_TextStyle$();
  return $t_Ljava_time_format_TextStyle$__FULL_STANDALONE;
}
export { $s_Ljava_time_format_TextStyle$__FULL_STANDALONE__Ljava_time_format_TextStyle as $s_Ljava_time_format_TextStyle$__FULL_STANDALONE__Ljava_time_format_TextStyle };
function $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle() {
  $m_Ljava_time_format_TextStyle$();
  return $t_Ljava_time_format_TextStyle$__SHORT;
}
export { $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle as $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle };
function $s_Ljava_time_format_TextStyle$__SHORT_STANDALONE__Ljava_time_format_TextStyle() {
  $m_Ljava_time_format_TextStyle$();
  return $t_Ljava_time_format_TextStyle$__SHORT_STANDALONE;
}
export { $s_Ljava_time_format_TextStyle$__SHORT_STANDALONE__Ljava_time_format_TextStyle as $s_Ljava_time_format_TextStyle$__SHORT_STANDALONE__Ljava_time_format_TextStyle };
function $s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle() {
  $m_Ljava_time_format_TextStyle$();
  return $t_Ljava_time_format_TextStyle$__NARROW;
}
export { $s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle as $s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle };
function $s_Ljava_time_format_TextStyle$__NARROW_STANDALONE__Ljava_time_format_TextStyle() {
  $m_Ljava_time_format_TextStyle$();
  return $t_Ljava_time_format_TextStyle$__NARROW_STANDALONE;
}
export { $s_Ljava_time_format_TextStyle$__NARROW_STANDALONE__Ljava_time_format_TextStyle as $s_Ljava_time_format_TextStyle$__NARROW_STANDALONE__Ljava_time_format_TextStyle };
/** @constructor */
function $c_Ljava_time_format_TextStyle$() {
  this.Ljava_time_format_TextStyle$__f_$values = null;
  $n_Ljava_time_format_TextStyle$ = this;
  $t_Ljava_time_format_TextStyle$__FULL = new $c_Ljava_time_format_TextStyle$$anon$1();
  $t_Ljava_time_format_TextStyle$__FULL_STANDALONE = new $c_Ljava_time_format_TextStyle$$anon$2();
  $t_Ljava_time_format_TextStyle$__SHORT = new $c_Ljava_time_format_TextStyle$$anon$3();
  $t_Ljava_time_format_TextStyle$__SHORT_STANDALONE = new $c_Ljava_time_format_TextStyle$$anon$4();
  $t_Ljava_time_format_TextStyle$__NARROW = new $c_Ljava_time_format_TextStyle$$anon$5();
  $t_Ljava_time_format_TextStyle$__NARROW_STANDALONE = new $c_Ljava_time_format_TextStyle$$anon$6();
  this.Ljava_time_format_TextStyle$__f_$values = new ($d_Ljava_time_format_TextStyle.getArrayOf().constr)([$s_Ljava_time_format_TextStyle$__FULL__Ljava_time_format_TextStyle(), $s_Ljava_time_format_TextStyle$__FULL_STANDALONE__Ljava_time_format_TextStyle(), $s_Ljava_time_format_TextStyle$__SHORT__Ljava_time_format_TextStyle(), $s_Ljava_time_format_TextStyle$__SHORT_STANDALONE__Ljava_time_format_TextStyle(), $s_Ljava_time_format_TextStyle$__NARROW__Ljava_time_format_TextStyle(), $s_Ljava_time_format_TextStyle$__NARROW_STANDALONE__Ljava_time_format_TextStyle()]);
}
export { $c_Ljava_time_format_TextStyle$ as $c_Ljava_time_format_TextStyle$ };
$c_Ljava_time_format_TextStyle$.prototype = new $h_O();
$c_Ljava_time_format_TextStyle$.prototype.constructor = $c_Ljava_time_format_TextStyle$;
/** @constructor */
function $h_Ljava_time_format_TextStyle$() {
}
export { $h_Ljava_time_format_TextStyle$ as $h_Ljava_time_format_TextStyle$ };
$h_Ljava_time_format_TextStyle$.prototype = $c_Ljava_time_format_TextStyle$.prototype;
$c_Ljava_time_format_TextStyle$.prototype.values__ALjava_time_format_TextStyle = (function() {
  var this$1 = this.Ljava_time_format_TextStyle$__f_$values;
  return this$1.clone__O();
});
$c_Ljava_time_format_TextStyle$.prototype.ordinal__O__I = (function(x) {
  return x.jl_Enum__f__ordinal;
});
var $d_Ljava_time_format_TextStyle$ = new $TypeData().initClass($c_Ljava_time_format_TextStyle$, "java.time.format.TextStyle$", ({
  Ljava_time_format_TextStyle$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Ljava_time_format_TextStyle$ as $d_Ljava_time_format_TextStyle$ };
var $n_Ljava_time_format_TextStyle$;
function $m_Ljava_time_format_TextStyle$() {
  if ((!$n_Ljava_time_format_TextStyle$)) {
    $n_Ljava_time_format_TextStyle$ = new $c_Ljava_time_format_TextStyle$();
  }
  return $n_Ljava_time_format_TextStyle$;
}
export { $m_Ljava_time_format_TextStyle$ as $m_Ljava_time_format_TextStyle$ };
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__I__($thiz, field, minWidth, maxWidth, baseValue, baseDate, subsequentWidth) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue = baseValue;
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate = baseDate;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__I__($thiz, field, minWidth, maxWidth, $s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle(), subsequentWidth);
  if (((minWidth < 1) || (minWidth > 10))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The width must be from 1 to 10 inclusive but was " + minWidth));
  }
  if (((maxWidth < 1) || (maxWidth > 10))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("The maxWidth must be from 1 to 10 inclusive but was " + maxWidth));
  }
  if ((maxWidth < minWidth)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "The maxWidth must be greater than the width");
  }
  if ((baseDate === null)) {
    var $x_1 = field.range__Ljava_time_temporal_ValueRange();
    var hi = (baseValue >> 31);
    if ((!$x_1.isValidValue__J__Z(new $c_RTLong(baseValue, hi)))) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "The base value must be within the range of the field");
    }
    var hi$1 = (baseValue >> 31);
    var value = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS.u[minWidth];
    var hi$2 = (value >> 31);
    var lo = ((baseValue + value) | 0);
    var hi$3 = ((((hi$1 + hi$2) | 0) + ((((baseValue & value) | ((baseValue | value) & (~lo))) >>> 31) | 0)) | 0);
    if (((hi$3 === 0) ? ((lo >>> 0) > 2147483647) : (hi$3 > 0))) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Unable to add printer-parser as the range exceeds the capacity of an int");
    }
  }
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__I__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__I__ };
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__($thiz, field, minWidth, maxWidth, baseValue, baseDate) {
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__I__($thiz, field, minWidth, maxWidth, baseValue, baseDate, 0);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser() {
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_signStyle = null;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate = null;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.getValue__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_Long__jl_Long = (function(context, value) {
  var t = $uJ(value);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var sign = (hi >> 31);
  var xlo = (lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((hi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
  var baseValue = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue;
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate !== null)) {
    $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(context.Ljava_time_format_internal_TTBPDateTimePrintContext__f_temporal);
    var temporal = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate;
    baseValue = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal).get__Ljava_time_temporal_TemporalField__I(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field);
  }
  var a = $uJ(value);
  var value$1 = baseValue;
  var hi$1 = (value$1 >> 31);
  var ahi = a.RTLong__f_hi;
  if (((ahi === hi$1) ? ((a.RTLong__f_lo >>> 0) >= (value$1 >>> 0)) : (ahi > hi$1))) {
    var a$1 = $uJ(value);
    var value$2 = ((baseValue + $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS.u[this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth]) | 0);
    var hi$2 = (value$2 >> 31);
    var ahi$1 = a$1.RTLong__f_hi;
    var $x_1 = ((ahi$1 === hi$2) ? ((a$1.RTLong__f_lo >>> 0) < (value$2 >>> 0)) : (ahi$1 < hi$2));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var value$3 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS.u[this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth];
    var hi$3 = (value$3 >> 31);
    var this$12 = $m_RTLong$();
    var lo$1 = this$12.remainderImpl__I__I__I__I__I(rlo, rhi, value$3, hi$3);
    var hi$4 = this$12.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$1, hi$4);
  }
  var value$4 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS.u[this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth];
  var hi$5 = (value$4 >> 31);
  var this$16 = $m_RTLong$();
  var lo$2 = this$16.remainderImpl__I__I__I__I__I(rlo, rhi, value$4, hi$5);
  var hi$6 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo$2, hi$6);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.setValue__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_Long__I__I__I = (function(context, value, errorPos, successPos) {
  var _value = value;
  var baseValue = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue;
  if ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate !== null)) {
    context.getEffectiveChronology__Ljava_time_chrono_Chronology();
    var temporal = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate;
    baseValue = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal).get__Ljava_time_temporal_TemporalField__I(this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field);
    var x = _value;
    context.addChronologyChangedParser__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__J__I__I__V(this, $uJ(x), errorPos, successPos);
  }
  var parseLen = ((successPos - errorPos) | 0);
  if ((parseLen === this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth)) {
    var x$1 = _value;
    var a = $uJ(x$1);
    var ahi = a.RTLong__f_hi;
    var $x_1 = (ahi >= 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var value$1 = $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$().Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$__f_EXCEED_POINTS.u[this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth];
    var hi = (value$1 >> 31);
    var value$2 = baseValue;
    var hi$1 = (value$2 >> 31);
    var this$8 = $m_RTLong$();
    var lo = this$8.remainderImpl__I__I__I__I__I(value$2, hi$1, value$1, hi);
    var hi$2 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var value$3 = baseValue;
    var hi$3 = (value$3 >> 31);
    var lo$1 = ((value$3 - lo) | 0);
    var hi$4 = ((((hi$3 - hi$2) | 0) + ((((~value$3) & lo) | ((~(value$3 ^ lo)) & lo$1)) >> 31)) | 0);
    if ((baseValue > 0)) {
      var x$2 = _value;
      var b = $uJ(x$2);
      var blo = b.RTLong__f_lo;
      var lo$2 = ((lo$1 + blo) | 0);
      var hi$5 = ((((hi$4 + b.RTLong__f_hi) | 0) + ((((lo$1 & blo) | ((lo$1 | blo) & (~lo$2))) >>> 31) | 0)) | 0);
      _value = new $c_RTLong(lo$2, hi$5);
    } else {
      var x$3 = _value;
      var b$1 = $uJ(x$3);
      var blo$1 = b$1.RTLong__f_lo;
      var lo$3 = ((lo$1 - blo$1) | 0);
      var hi$6 = ((((hi$4 - b$1.RTLong__f_hi) | 0) + ((((~lo$1) & blo$1) | ((~(lo$1 ^ blo$1)) & lo$3)) >> 31)) | 0);
      _value = new $c_RTLong(lo$3, hi$6);
    }
    var x$4 = _value;
    var a$1 = $uJ(x$4);
    var value$4 = baseValue;
    var hi$7 = (value$4 >> 31);
    var ahi$1 = a$1.RTLong__f_hi;
    if (((ahi$1 === hi$7) ? ((a$1.RTLong__f_lo >>> 0) < (value$4 >>> 0)) : (ahi$1 < hi$7))) {
      var x$5 = _value;
      var a$2 = $uJ(x$5);
      var alo = a$2.RTLong__f_lo;
      var lo$4 = ((alo + value$1) | 0);
      var hi$8 = ((((a$2.RTLong__f_hi + hi) | 0) + ((((alo & value$1) | ((alo | value$1) & (~lo$4))) >>> 31) | 0)) | 0);
      _value = new $c_RTLong(lo$4, hi$8);
    }
  }
  var $x_2 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field;
  var x$6 = _value;
  return context.setParsedField__Ljava_time_temporal_TemporalField__J__I__I__I($x_2, $uJ(x$6), errorPos, successPos);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.withFixedWidth__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = (function() {
  return ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth === (-1)) ? this : $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate, (-1)));
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser = (function(subsequentWidth) {
  return $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__Ljava_time_temporal_TemporalField__I__I__I__Ljava_time_chrono_ChronoLocalDate__I__(new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser(), this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue, this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate, ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_subsequentWidth + subsequentWidth) | 0));
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z = (function(context) {
  return (context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict && $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser.prototype.isFixedWidth__Ljava_time_format_internal_TTBPDateTimeParseContext__Z.call(this, context));
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.toString__T = (function() {
  return (((((((("ReducedValue(" + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_field) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_minWidth) + ",") + this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__f_maxWidth) + ",") + ((this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate !== null) ? this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseDate : this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser__f_baseValue)) + ")");
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser.prototype.withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser = (function(subsequentWidth) {
  return this.withSubsequentWidth__I__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser(subsequentWidth);
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ReducedPrinterParser", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ReducedPrinterParser };
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE;
}
export { $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser as $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser };
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE;
}
export { $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser as $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser };
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT;
}
export { $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser as $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser };
function $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  return $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT;
}
export { $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser as $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ = this;
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1();
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2();
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3();
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4();
  $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
  $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
  $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
  $s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$.prototype.ordinal__O__I = (function(x) {
  return x.jl_Enum__f__ordinal;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ };
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ as $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$ };
function $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND;
}
export { $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY;
}
export { $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND;
}
export { $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY;
}
export { $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND;
}
export { $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY;
}
export { $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE;
}
export { $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY;
}
export { $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR;
}
export { $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY;
}
export { $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM;
}
export { $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM;
}
export { $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY;
}
export { $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY;
}
export { $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY;
}
export { $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK;
}
export { $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH;
}
export { $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR;
}
export { $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH;
}
export { $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR;
}
export { $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY;
}
export { $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH;
}
export { $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR;
}
export { $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR;
}
export { $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH;
}
export { $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA;
}
export { $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__YEAR;
}
export { $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__ERA;
}
export { $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS;
}
export { $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField };
function $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField() {
  $m_Ljava_time_temporal_ChronoField$();
  return $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS;
}
export { $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField as $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$() {
  this.Ljava_time_temporal_ChronoField$__f_$values = null;
  $n_Ljava_time_temporal_ChronoField$ = this;
  $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND = new $c_Ljava_time_temporal_ChronoField$$anon$1();
  $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$2();
  $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND = new $c_Ljava_time_temporal_ChronoField$$anon$3();
  $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$4();
  $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND = new $c_Ljava_time_temporal_ChronoField$$anon$5();
  $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$6();
  $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE = new $c_Ljava_time_temporal_ChronoField$$anon$7();
  $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$8();
  $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR = new $c_Ljava_time_temporal_ChronoField$$anon$9();
  $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$10();
  $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM = new $c_Ljava_time_temporal_ChronoField$$anon$11();
  $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM = new $c_Ljava_time_temporal_ChronoField$$anon$12();
  $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$13();
  $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$14();
  $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$15();
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK = new $c_Ljava_time_temporal_ChronoField$$anon$16();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$17();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$18();
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$19();
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$20();
  $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY = new $c_Ljava_time_temporal_ChronoField$$anon$21();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$22();
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$23();
  $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$24();
  $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH = new $c_Ljava_time_temporal_ChronoField$$anon$25();
  $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA = new $c_Ljava_time_temporal_ChronoField$$anon$26();
  $t_Ljava_time_temporal_ChronoField$__YEAR = new $c_Ljava_time_temporal_ChronoField$$anon$27();
  $t_Ljava_time_temporal_ChronoField$__ERA = new $c_Ljava_time_temporal_ChronoField$$anon$28();
  $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS = new $c_Ljava_time_temporal_ChronoField$$anon$29();
  $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS = new $c_Ljava_time_temporal_ChronoField$$anon$30();
  this.Ljava_time_temporal_ChronoField$__f_$values = new ($d_Ljava_time_temporal_ChronoField.getArrayOf().constr)([$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()]);
}
export { $c_Ljava_time_temporal_ChronoField$ as $c_Ljava_time_temporal_ChronoField$ };
$c_Ljava_time_temporal_ChronoField$.prototype = new $h_O();
$c_Ljava_time_temporal_ChronoField$.prototype.constructor = $c_Ljava_time_temporal_ChronoField$;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$() {
}
export { $h_Ljava_time_temporal_ChronoField$ as $h_Ljava_time_temporal_ChronoField$ };
$h_Ljava_time_temporal_ChronoField$.prototype = $c_Ljava_time_temporal_ChronoField$.prototype;
$c_Ljava_time_temporal_ChronoField$.prototype.values__ALjava_time_temporal_ChronoField = (function() {
  var this$1 = this.Ljava_time_temporal_ChronoField$__f_$values;
  return this$1.clone__O();
});
$c_Ljava_time_temporal_ChronoField$.prototype.ordinal__O__I = (function(x) {
  return x.jl_Enum__f__ordinal;
});
var $d_Ljava_time_temporal_ChronoField$ = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$, "java.time.temporal.ChronoField$", ({
  Ljava_time_temporal_ChronoField$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Ljava_time_temporal_ChronoField$ as $d_Ljava_time_temporal_ChronoField$ };
var $n_Ljava_time_temporal_ChronoField$;
function $m_Ljava_time_temporal_ChronoField$() {
  if ((!$n_Ljava_time_temporal_ChronoField$)) {
    $n_Ljava_time_temporal_ChronoField$ = new $c_Ljava_time_temporal_ChronoField$();
  }
  return $n_Ljava_time_temporal_ChronoField$;
}
export { $m_Ljava_time_temporal_ChronoField$ as $m_Ljava_time_temporal_ChronoField$ };
function $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__NANOS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MICROS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MILLIS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__SECONDS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MINUTES;
}
export { $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__HOURS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__DAYS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__WEEKS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MONTHS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__YEARS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__DECADES;
}
export { $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__CENTURIES;
}
export { $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA;
}
export { $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__ERAS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__FOREVER;
}
export { $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$() {
  $n_Ljava_time_temporal_ChronoUnit$ = this;
  $t_Ljava_time_temporal_ChronoUnit$__NANOS = new $c_Ljava_time_temporal_ChronoUnit$$anon$1();
  $t_Ljava_time_temporal_ChronoUnit$__MICROS = new $c_Ljava_time_temporal_ChronoUnit$$anon$2();
  $t_Ljava_time_temporal_ChronoUnit$__MILLIS = new $c_Ljava_time_temporal_ChronoUnit$$anon$3();
  $t_Ljava_time_temporal_ChronoUnit$__SECONDS = new $c_Ljava_time_temporal_ChronoUnit$$anon$4();
  $t_Ljava_time_temporal_ChronoUnit$__MINUTES = new $c_Ljava_time_temporal_ChronoUnit$$anon$5();
  $t_Ljava_time_temporal_ChronoUnit$__HOURS = new $c_Ljava_time_temporal_ChronoUnit$$anon$6();
  $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS = new $c_Ljava_time_temporal_ChronoUnit$$anon$7();
  $t_Ljava_time_temporal_ChronoUnit$__DAYS = new $c_Ljava_time_temporal_ChronoUnit$$anon$8();
  $t_Ljava_time_temporal_ChronoUnit$__WEEKS = new $c_Ljava_time_temporal_ChronoUnit$$anon$9();
  $t_Ljava_time_temporal_ChronoUnit$__MONTHS = new $c_Ljava_time_temporal_ChronoUnit$$anon$10();
  $t_Ljava_time_temporal_ChronoUnit$__YEARS = new $c_Ljava_time_temporal_ChronoUnit$$anon$11();
  $t_Ljava_time_temporal_ChronoUnit$__DECADES = new $c_Ljava_time_temporal_ChronoUnit$$anon$12();
  $t_Ljava_time_temporal_ChronoUnit$__CENTURIES = new $c_Ljava_time_temporal_ChronoUnit$$anon$13();
  $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA = new $c_Ljava_time_temporal_ChronoUnit$$anon$14();
  $t_Ljava_time_temporal_ChronoUnit$__ERAS = new $c_Ljava_time_temporal_ChronoUnit$$anon$15();
  $t_Ljava_time_temporal_ChronoUnit$__FOREVER = new $c_Ljava_time_temporal_ChronoUnit$$anon$16();
  $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
}
export { $c_Ljava_time_temporal_ChronoUnit$ as $c_Ljava_time_temporal_ChronoUnit$ };
$c_Ljava_time_temporal_ChronoUnit$.prototype = new $h_O();
$c_Ljava_time_temporal_ChronoUnit$.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$() {
}
export { $h_Ljava_time_temporal_ChronoUnit$ as $h_Ljava_time_temporal_ChronoUnit$ };
$h_Ljava_time_temporal_ChronoUnit$.prototype = $c_Ljava_time_temporal_ChronoUnit$.prototype;
$c_Ljava_time_temporal_ChronoUnit$.prototype.ordinal__O__I = (function(x) {
  return x.jl_Enum__f__ordinal;
});
var $d_Ljava_time_temporal_ChronoUnit$ = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$, "java.time.temporal.ChronoUnit$", ({
  Ljava_time_temporal_ChronoUnit$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$ as $d_Ljava_time_temporal_ChronoUnit$ };
var $n_Ljava_time_temporal_ChronoUnit$;
function $m_Ljava_time_temporal_ChronoUnit$() {
  if ((!$n_Ljava_time_temporal_ChronoUnit$)) {
    $n_Ljava_time_temporal_ChronoUnit$ = new $c_Ljava_time_temporal_ChronoUnit$();
  }
  return $n_Ljava_time_temporal_ChronoUnit$;
}
export { $m_Ljava_time_temporal_ChronoUnit$ as $m_Ljava_time_temporal_ChronoUnit$ };
function $s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field() {
  $m_Ljava_time_temporal_IsoFields$Field$();
  return $t_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER;
}
export { $s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field as $s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field };
function $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field() {
  $m_Ljava_time_temporal_IsoFields$Field$();
  return $t_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR;
}
export { $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field as $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field };
function $s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field() {
  $m_Ljava_time_temporal_IsoFields$Field$();
  return $t_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR;
}
export { $s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field as $s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field };
function $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field() {
  $m_Ljava_time_temporal_IsoFields$Field$();
  return $t_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR;
}
export { $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field as $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field };
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Field$() {
  $n_Ljava_time_temporal_IsoFields$Field$ = this;
  $t_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER = new $c_Ljava_time_temporal_IsoFields$Field$$anon$1();
  $t_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR = new $c_Ljava_time_temporal_IsoFields$Field$$anon$2();
  $t_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR = new $c_Ljava_time_temporal_IsoFields$Field$$anon$3();
  $t_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR = new $c_Ljava_time_temporal_IsoFields$Field$$anon$4();
  $s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field();
  $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field();
  $s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
}
export { $c_Ljava_time_temporal_IsoFields$Field$ as $c_Ljava_time_temporal_IsoFields$Field$ };
$c_Ljava_time_temporal_IsoFields$Field$.prototype = new $h_O();
$c_Ljava_time_temporal_IsoFields$Field$.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Field$;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Field$() {
}
export { $h_Ljava_time_temporal_IsoFields$Field$ as $h_Ljava_time_temporal_IsoFields$Field$ };
$h_Ljava_time_temporal_IsoFields$Field$.prototype = $c_Ljava_time_temporal_IsoFields$Field$.prototype;
$c_Ljava_time_temporal_IsoFields$Field$.prototype.ordinal__O__I = (function(x) {
  return x.jl_Enum__f__ordinal;
});
var $d_Ljava_time_temporal_IsoFields$Field$ = new $TypeData().initClass($c_Ljava_time_temporal_IsoFields$Field$, "java.time.temporal.IsoFields$Field$", ({
  Ljava_time_temporal_IsoFields$Field$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Ljava_time_temporal_IsoFields$Field$ as $d_Ljava_time_temporal_IsoFields$Field$ };
var $n_Ljava_time_temporal_IsoFields$Field$;
function $m_Ljava_time_temporal_IsoFields$Field$() {
  if ((!$n_Ljava_time_temporal_IsoFields$Field$)) {
    $n_Ljava_time_temporal_IsoFields$Field$ = new $c_Ljava_time_temporal_IsoFields$Field$();
  }
  return $n_Ljava_time_temporal_IsoFields$Field$;
}
export { $m_Ljava_time_temporal_IsoFields$Field$ as $m_Ljava_time_temporal_IsoFields$Field$ };
function $s_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS__Ljava_time_temporal_IsoFields$Unit() {
  $m_Ljava_time_temporal_IsoFields$Unit$();
  return $t_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS;
}
export { $s_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS__Ljava_time_temporal_IsoFields$Unit as $s_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS__Ljava_time_temporal_IsoFields$Unit };
function $s_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS__Ljava_time_temporal_IsoFields$Unit() {
  $m_Ljava_time_temporal_IsoFields$Unit$();
  return $t_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS;
}
export { $s_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS__Ljava_time_temporal_IsoFields$Unit as $s_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS__Ljava_time_temporal_IsoFields$Unit };
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Unit$() {
  $n_Ljava_time_temporal_IsoFields$Unit$ = this;
  $t_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS = new $c_Ljava_time_temporal_IsoFields$Unit$$anon$5();
  $t_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS = new $c_Ljava_time_temporal_IsoFields$Unit$$anon$6();
  $s_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS__Ljava_time_temporal_IsoFields$Unit();
  $s_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS__Ljava_time_temporal_IsoFields$Unit();
}
export { $c_Ljava_time_temporal_IsoFields$Unit$ as $c_Ljava_time_temporal_IsoFields$Unit$ };
$c_Ljava_time_temporal_IsoFields$Unit$.prototype = new $h_O();
$c_Ljava_time_temporal_IsoFields$Unit$.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Unit$;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Unit$() {
}
export { $h_Ljava_time_temporal_IsoFields$Unit$ as $h_Ljava_time_temporal_IsoFields$Unit$ };
$h_Ljava_time_temporal_IsoFields$Unit$.prototype = $c_Ljava_time_temporal_IsoFields$Unit$.prototype;
$c_Ljava_time_temporal_IsoFields$Unit$.prototype.ordinal__O__I = (function(x) {
  return x.jl_Enum__f__ordinal;
});
var $d_Ljava_time_temporal_IsoFields$Unit$ = new $TypeData().initClass($c_Ljava_time_temporal_IsoFields$Unit$, "java.time.temporal.IsoFields$Unit$", ({
  Ljava_time_temporal_IsoFields$Unit$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Ljava_time_temporal_IsoFields$Unit$ as $d_Ljava_time_temporal_IsoFields$Unit$ };
var $n_Ljava_time_temporal_IsoFields$Unit$;
function $m_Ljava_time_temporal_IsoFields$Unit$() {
  if ((!$n_Ljava_time_temporal_IsoFields$Unit$)) {
    $n_Ljava_time_temporal_IsoFields$Unit$ = new $c_Ljava_time_temporal_IsoFields$Unit$();
  }
  return $n_Ljava_time_temporal_IsoFields$Unit$;
}
export { $m_Ljava_time_temporal_IsoFields$Unit$ as $m_Ljava_time_temporal_IsoFields$Unit$ };
function $p_Ljava_time_zone_StandardZoneRules__getOffsetInfo__Ljava_time_LocalDateTime__s_util_Either($thiz, dt) {
  var nonLocalReturnKey1 = $ct_O__(new $c_O());
  try {
    if ((($thiz.Ljava_time_zone_StandardZoneRules__f_lastRules.u.length > 0) && dt.isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z($thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.u[(((-1) + $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.u.length) | 0)]))) {
      var this$1 = dt.Ljava_time_LocalDateTime__f_date;
      var transArray = $p_Ljava_time_zone_StandardZoneRules__findTransitionArray__I__ALjava_time_zone_ZoneOffsetTransition($thiz, this$1.Ljava_time_LocalDate__f_year);
      var info = new $c_sr_ObjectRef(null);
      var f = ((trans) => {
        var ev$3 = $p_Ljava_time_zone_StandardZoneRules__findOffsetInfo__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition__s_util_Either($thiz, dt, trans);
        info.sr_ObjectRef__f_elem = ev$3;
        ev$3 = null;
        if (info.sr_ObjectRef__f_elem.isLeft__Z()) {
          var $x_1 = true;
        } else {
          var x = info.sr_ObjectRef__f_elem;
          var value = trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
          var x$2 = new $c_s_util_Right(value);
          var $x_1 = ((x !== null) && x.equals__O__Z(x$2));
        }
        if ($x_1) {
          throw new $c_sr_NonLocalReturnControl(nonLocalReturnKey1, info.sr_ObjectRef__f_elem);
        }
      });
      var len = transArray.u.length;
      var i = 0;
      if ((transArray !== null)) {
        while ((i < len)) {
          var x0 = transArray.u[i];
          f(x0);
          i = ((1 + i) | 0);
        }
      } else if ((transArray instanceof $ac_I)) {
        while ((i < len)) {
          var x0$1 = transArray.u[i];
          f(x0$1);
          i = ((1 + i) | 0);
        }
      } else if ((transArray instanceof $ac_D)) {
        while ((i < len)) {
          var x0$2 = transArray.u[i];
          f(x0$2);
          i = ((1 + i) | 0);
        }
      } else if ((transArray instanceof $ac_J)) {
        while ((i < len)) {
          var t = transArray.u[i];
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          f(new $c_RTLong(lo, hi));
          i = ((1 + i) | 0);
        }
      } else if ((transArray instanceof $ac_F)) {
        while ((i < len)) {
          var x0$3 = transArray.u[i];
          f(x0$3);
          i = ((1 + i) | 0);
        }
      } else if ((transArray instanceof $ac_C)) {
        while ((i < len)) {
          var x0$4 = transArray.u[i];
          f($bC(x0$4));
          i = ((1 + i) | 0);
        }
      } else if ((transArray instanceof $ac_B)) {
        while ((i < len)) {
          var x0$5 = transArray.u[i];
          f(x0$5);
          i = ((1 + i) | 0);
        }
      } else if ((transArray instanceof $ac_S)) {
        while ((i < len)) {
          var x0$6 = transArray.u[i];
          f(x0$6);
          i = ((1 + i) | 0);
        }
      } else if ((transArray instanceof $ac_Z)) {
        while ((i < len)) {
          var x0$7 = transArray.u[i];
          f(x0$7);
          i = ((1 + i) | 0);
        }
      } else {
        throw new $c_s_MatchError(transArray);
      }
      return info.sr_ObjectRef__f_elem;
    }
    var a = $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions;
    var index = $m_ju_Arrays$().binarySearch__AO__O__I(a, dt);
    if ((index === (-1))) {
      var value$1 = $thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets.u[0];
      return new $c_s_util_Right(value$1);
    }
    if ((index < 0)) {
      index = (((-2) - index) | 0);
    } else {
      if ((index < (((-1) + $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.u.length) | 0))) {
        var x$1 = $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.u[index];
        var x$2$1 = $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.u[((1 + index) | 0)];
        var $x_2 = ((x$1 === null) ? (x$2$1 === null) : x$1.equals__O__Z(x$2$1));
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        index = ((1 + index) | 0);
      }
    }
    if (((1 & index) === 0)) {
      var dtBefore = $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.u[index];
      var dtAfter = $thiz.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions.u[((1 + index) | 0)];
      var offsetBefore = $thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets.u[((index / 2) | 0)];
      var offsetAfter = $thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets.u[((1 + ((index / 2) | 0)) | 0)];
      if ((offsetAfter.Ljava_time_ZoneOffset__f_totalSeconds > offsetBefore.Ljava_time_ZoneOffset__f_totalSeconds)) {
        var value$2 = new $c_Ljava_time_zone_ZoneOffsetTransition(dtBefore, offsetBefore, offsetAfter);
        return new $c_s_util_Left(value$2);
      } else {
        var value$3 = new $c_Ljava_time_zone_ZoneOffsetTransition(dtAfter, offsetBefore, offsetAfter);
        return new $c_s_util_Left(value$3);
      }
    } else {
      var value$4 = $thiz.Ljava_time_zone_StandardZoneRules__f_wallOffsets.u[((1 + ((index / 2) | 0)) | 0)];
      return new $c_s_util_Right(value$4);
    }
  } catch (e) {
    if ((e instanceof $c_sr_NonLocalReturnControl)) {
      var ex = e;
      if (Object.is(ex.sr_NonLocalReturnControl__f_key, nonLocalReturnKey1)) {
        return ex.sr_NonLocalReturnControl__f_value;
      } else {
        throw ex;
      }
    } else {
      throw e;
    }
  }
}
export { $p_Ljava_time_zone_StandardZoneRules__getOffsetInfo__Ljava_time_LocalDateTime__s_util_Either as $p_Ljava_time_zone_StandardZoneRules__getOffsetInfo__Ljava_time_LocalDateTime__s_util_Either };
function $p_Ljava_time_zone_StandardZoneRules__findOffsetInfo__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition__s_util_Either($thiz, dt, trans) {
  var localTransition = trans.Ljava_time_zone_ZoneOffsetTransition__f_transition;
  if (trans.isGap__Z()) {
    if (dt.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z(localTransition)) {
      var value = trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
      return new $c_s_util_Right(value);
    } else {
      var this$3 = trans.Ljava_time_zone_ZoneOffsetTransition__f_transition;
      var value$1 = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(trans);
      var hi = (value$1 >> 31);
      if (dt.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$3, this$3.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value$1, hi), $L0, 1))) {
        return new $c_s_util_Left(trans);
      } else {
        var value$2 = trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
        return new $c_s_util_Right(value$2);
      }
    }
  } else if ((!dt.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z(localTransition))) {
    var value$3 = trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
    return new $c_s_util_Right(value$3);
  } else {
    var this$8 = trans.Ljava_time_zone_ZoneOffsetTransition__f_transition;
    var value$4 = $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I(trans);
    var hi$1 = (value$4 >> 31);
    if (dt.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z($p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$8, this$8.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(value$4, hi$1), $L0, 1))) {
      var value$5 = trans.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
      return new $c_s_util_Right(value$5);
    } else {
      return new $c_s_util_Left(trans);
    }
  }
}
export { $p_Ljava_time_zone_StandardZoneRules__findOffsetInfo__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition__s_util_Either as $p_Ljava_time_zone_StandardZoneRules__findOffsetInfo__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition__s_util_Either };
function $p_Ljava_time_zone_StandardZoneRules__findTransitionArray__I__ALjava_time_zone_ZoneOffsetTransition($thiz, year) {
  var transArray = $thiz.Ljava_time_zone_StandardZoneRules__f_lastRulesCache.get__O__O(year);
  if ((transArray !== null)) {
    return transArray;
  }
  var ruleArray = $thiz.Ljava_time_zone_StandardZoneRules__f_lastRules;
  var dimensions = new $ac_I(new Int32Array([ruleArray.u.length]));
  transArray = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_Ljava_time_zone_ZoneOffsetTransition.getClassOf(), dimensions);
  var i = 0;
  while ((i < ruleArray.u.length)) {
    transArray.u[i] = ruleArray.u[i].createTransition__I__Ljava_time_zone_ZoneOffsetTransition(year);
    i = ((1 + i) | 0);
  }
  if ((year < 2100)) {
    $thiz.Ljava_time_zone_StandardZoneRules__f_lastRulesCache.put__O__O__O(year, transArray);
  }
  return transArray;
}
export { $p_Ljava_time_zone_StandardZoneRules__findTransitionArray__I__ALjava_time_zone_ZoneOffsetTransition as $p_Ljava_time_zone_StandardZoneRules__findTransitionArray__I__ALjava_time_zone_ZoneOffsetTransition };
function $p_Ljava_time_zone_StandardZoneRules__findYear__J__Ljava_time_ZoneOffset__I($thiz, epochSecond, offset) {
  var value = offset.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  var alo = epochSecond.RTLong__f_lo;
  var lo = ((alo + value) | 0);
  var hi$1 = ((((epochSecond.RTLong__f_hi + hi) | 0) + ((((alo & value) | ((alo | value) & (~lo))) >>> 31) | 0)) | 0);
  var this$4 = $m_RTLong$();
  var lo$1 = this$4.divideImpl__I__I__I__I__I(lo, hi$1, 86400, 0);
  var hi$2 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((hi$1 >= 0)) {
    var $x_1 = true;
  } else {
    var b0 = (65535 & lo$1);
    var b1 = ((lo$1 >>> 16) | 0);
    var a0b0 = Math.imul(20864, b0);
    var a0b1 = Math.imul(20864, b1);
    var lo$3 = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$3 = ((((((Math.imul(86400, hi$2) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
    var $x_1 = ((lo$3 === lo) && (hi$3 === hi$1));
  }
  if ($x_1) {
    var localEpochDay__lo = lo$1;
    var localEpochDay__hi = hi$2;
  } else {
    var lo$4 = (((-1) + lo$1) | 0);
    var hi$4 = (((((-1) + hi$2) | 0) + (((lo$1 | (~lo$4)) >>> 31) | 0)) | 0);
    var localEpochDay__lo = lo$4;
    var localEpochDay__hi = hi$4;
  }
  var this$10 = $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(localEpochDay__lo, localEpochDay__hi));
  return this$10.Ljava_time_LocalDate__f_year;
}
export { $p_Ljava_time_zone_StandardZoneRules__findYear__J__Ljava_time_ZoneOffset__I as $p_Ljava_time_zone_StandardZoneRules__findYear__J__Ljava_time_ZoneOffset__I };
/** @constructor */
function $c_Ljava_time_zone_StandardZoneRules(standardTransitions, standardOffsets, savingsInstantTransitions, wallOffsets, lastRules, savingsLocalTransitions) {
  this.Ljava_time_zone_StandardZoneRules__f_standardTransitions = null;
  this.Ljava_time_zone_StandardZoneRules__f_standardOffsets = null;
  this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions = null;
  this.Ljava_time_zone_StandardZoneRules__f_wallOffsets = null;
  this.Ljava_time_zone_StandardZoneRules__f_lastRules = null;
  this.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions = null;
  this.Ljava_time_zone_StandardZoneRules__f_lastRulesCache = null;
  this.Ljava_time_zone_StandardZoneRules__f_standardTransitions = standardTransitions;
  this.Ljava_time_zone_StandardZoneRules__f_standardOffsets = standardOffsets;
  this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions = savingsInstantTransitions;
  this.Ljava_time_zone_StandardZoneRules__f_wallOffsets = wallOffsets;
  this.Ljava_time_zone_StandardZoneRules__f_lastRules = lastRules;
  this.Ljava_time_zone_StandardZoneRules__f_savingsLocalTransitions = savingsLocalTransitions;
  this.Ljava_time_zone_StandardZoneRules__f_lastRulesCache = $ct_ju_HashMap__(new $c_ju_HashMap());
}
export { $c_Ljava_time_zone_StandardZoneRules as $c_Ljava_time_zone_StandardZoneRules };
$c_Ljava_time_zone_StandardZoneRules.prototype = new $h_Ljava_time_zone_ZoneRules();
$c_Ljava_time_zone_StandardZoneRules.prototype.constructor = $c_Ljava_time_zone_StandardZoneRules;
/** @constructor */
function $h_Ljava_time_zone_StandardZoneRules() {
}
export { $h_Ljava_time_zone_StandardZoneRules as $h_Ljava_time_zone_StandardZoneRules };
$h_Ljava_time_zone_StandardZoneRules.prototype = $c_Ljava_time_zone_StandardZoneRules.prototype;
$c_Ljava_time_zone_StandardZoneRules.prototype.isFixedOffset__Z = (function() {
  return (this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions.u.length === 0);
});
$c_Ljava_time_zone_StandardZoneRules.prototype.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset = (function(instant) {
  var t = instant.Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if ((this.Ljava_time_zone_StandardZoneRules__f_lastRules.u.length > 0)) {
    var b = this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions.u[(((-1) + this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions.u.length) | 0)];
    var bhi = b.RTLong__f_hi;
    var $x_1 = ((hi === bhi) ? ((lo >>> 0) > (b.RTLong__f_lo >>> 0)) : (hi > bhi));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var year = $p_Ljava_time_zone_StandardZoneRules__findYear__J__Ljava_time_ZoneOffset__I(this, new $c_RTLong(lo, hi), this.Ljava_time_zone_StandardZoneRules__f_wallOffsets.u[(((-1) + this.Ljava_time_zone_StandardZoneRules__f_wallOffsets.u.length) | 0)]);
    var transArray = $p_Ljava_time_zone_StandardZoneRules__findTransitionArray__I__ALjava_time_zone_ZoneOffsetTransition(this, year);
    var trans = null;
    var i = 0;
    while ((i < transArray.u.length)) {
      trans = transArray.u[i];
      var this$2 = trans;
      var b$1 = this$2.Ljava_time_zone_ZoneOffsetTransition__f_transition.toEpochSecond__Ljava_time_ZoneOffset__J(this$2.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
      var bhi$1 = b$1.RTLong__f_hi;
      if (((hi === bhi$1) ? ((lo >>> 0) < (b$1.RTLong__f_lo >>> 0)) : (hi < bhi$1))) {
        var this$4 = trans;
        return this$4.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
      }
      i = ((1 + i) | 0);
    }
    var this$5 = trans;
    return this$5.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
  }
  var a = this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
  var index = $m_ju_Arrays$().binarySearch__AJ__J__I(a, new $c_RTLong(lo, hi));
  if ((index < 0)) {
    index = (((-2) - index) | 0);
  }
  return this.Ljava_time_zone_StandardZoneRules__f_wallOffsets.u[((1 + index) | 0)];
});
$c_Ljava_time_zone_StandardZoneRules.prototype.getValidOffsets__Ljava_time_LocalDateTime__ju_List = (function(localDateTime) {
  var x6 = $p_Ljava_time_zone_StandardZoneRules__getOffsetInfo__Ljava_time_LocalDateTime__s_util_Either(this, localDateTime);
  if ((x6 instanceof $c_s_util_Left)) {
    var transition = x6.s_util_Left__f_value;
    return transition.getValidOffsets__ju_List();
  }
  if ((x6 instanceof $c_s_util_Right)) {
    var offset = x6.s_util_Right__f_value;
    return $m_ju_Collections$().singletonList__O__ju_List(offset);
  }
  throw new $c_s_MatchError(x6);
});
$c_Ljava_time_zone_StandardZoneRules.prototype.getTransition__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition = (function(localDateTime) {
  var x11 = $p_Ljava_time_zone_StandardZoneRules__getOffsetInfo__Ljava_time_LocalDateTime__s_util_Either(this, localDateTime);
  if ((x11 instanceof $c_s_util_Left)) {
    var transition = x11.s_util_Left__f_value;
    return transition;
  }
  return null;
});
$c_Ljava_time_zone_StandardZoneRules.prototype.isValidOffset__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Z = (function(localDateTime, offset) {
  return this.getValidOffsets__Ljava_time_LocalDateTime__ju_List(localDateTime).contains__O__Z(offset);
});
$c_Ljava_time_zone_StandardZoneRules.prototype.getStandardOffset__Ljava_time_Instant__Ljava_time_ZoneOffset = (function(instant) {
  var t = instant.Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var a = this.Ljava_time_zone_StandardZoneRules__f_standardTransitions;
  var index = $m_ju_Arrays$().binarySearch__AJ__J__I(a, new $c_RTLong(lo, hi));
  if ((index < 0)) {
    index = (((-2) - index) | 0);
  }
  return this.Ljava_time_zone_StandardZoneRules__f_standardOffsets.u[((1 + index) | 0)];
});
$c_Ljava_time_zone_StandardZoneRules.prototype.isDaylightSavings__Ljava_time_Instant__Z = (function(instant) {
  var x = this.getStandardOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(instant);
  var x$2 = this.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset(instant);
  return (!((x === null) ? (x$2 === null) : x.equals__O__Z(x$2)));
});
$c_Ljava_time_zone_StandardZoneRules.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_zone_StandardZoneRules)) {
    if ((this === obj)) {
      return true;
    } else {
      var a = this.Ljava_time_zone_StandardZoneRules__f_standardTransitions;
      var b = obj.Ljava_time_zone_StandardZoneRules__f_standardTransitions;
      if ($m_ju_Arrays$().equals__AJ__AJ__Z(a, b)) {
        var a$1 = this.Ljava_time_zone_StandardZoneRules__f_standardOffsets;
        var b$1 = obj.Ljava_time_zone_StandardZoneRules__f_standardOffsets;
        var $x_3 = $m_ju_Arrays$().equals__AO__AO__Z(a$1, b$1);
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        var a$2 = this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
        var b$2 = obj.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
        var $x_2 = $m_ju_Arrays$().equals__AJ__AJ__Z(a$2, b$2);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        var a$3 = this.Ljava_time_zone_StandardZoneRules__f_wallOffsets;
        var b$3 = obj.Ljava_time_zone_StandardZoneRules__f_wallOffsets;
        var $x_1 = $m_ju_Arrays$().equals__AO__AO__Z(a$3, b$3);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var a$4 = this.Ljava_time_zone_StandardZoneRules__f_lastRules;
        var b$4 = obj.Ljava_time_zone_StandardZoneRules__f_lastRules;
        return $m_ju_Arrays$().equals__AO__AO__Z(a$4, b$4);
      } else {
        return false;
      }
    }
  } else if ((obj instanceof $c_Ljava_time_zone_ZoneRules$Fixed)) {
    if (this.isFixedOffset__Z()) {
      var x = this.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant());
      $m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant();
      var x$2 = obj.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ljava_time_zone_StandardZoneRules.prototype.hashCode__I = (function() {
  var a = this.Ljava_time_zone_StandardZoneRules__f_standardTransitions;
  var $x_4 = $m_ju_Arrays$().hashCode__AJ__I(a);
  var a$1 = this.Ljava_time_zone_StandardZoneRules__f_standardOffsets;
  var $x_3 = $m_ju_Arrays$().hashCode__AO__I(a$1);
  var a$2 = this.Ljava_time_zone_StandardZoneRules__f_savingsInstantTransitions;
  var $x_2 = $m_ju_Arrays$().hashCode__AJ__I(a$2);
  var a$3 = this.Ljava_time_zone_StandardZoneRules__f_wallOffsets;
  var $x_1 = $m_ju_Arrays$().hashCode__AO__I(a$3);
  var a$4 = this.Ljava_time_zone_StandardZoneRules__f_lastRules;
  return (((($x_4 ^ $x_3) ^ $x_2) ^ $x_1) ^ $m_ju_Arrays$().hashCode__AO__I(a$4));
});
$c_Ljava_time_zone_StandardZoneRules.prototype.toString__T = (function() {
  return (("StandardZoneRules[currentStandardOffset=" + this.Ljava_time_zone_StandardZoneRules__f_standardOffsets.u[(((-1) + this.Ljava_time_zone_StandardZoneRules__f_standardOffsets.u.length) | 0)]) + "]");
});
function $isArrayOf_Ljava_time_zone_StandardZoneRules(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_StandardZoneRules)));
}
export { $isArrayOf_Ljava_time_zone_StandardZoneRules as $isArrayOf_Ljava_time_zone_StandardZoneRules };
var $d_Ljava_time_zone_StandardZoneRules = new $TypeData().initClass($c_Ljava_time_zone_StandardZoneRules, "java.time.zone.StandardZoneRules", ({
  Ljava_time_zone_StandardZoneRules: 1,
  Ljava_time_zone_ZoneRules: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_zone_StandardZoneRules as $d_Ljava_time_zone_StandardZoneRules };
/** @constructor */
function $c_Ljava_time_zone_ZoneRules$Fixed(offset) {
  this.Ljava_time_zone_ZoneRules$Fixed__f_offset = null;
  this.Ljava_time_zone_ZoneRules$Fixed__f_offset = offset;
}
export { $c_Ljava_time_zone_ZoneRules$Fixed as $c_Ljava_time_zone_ZoneRules$Fixed };
$c_Ljava_time_zone_ZoneRules$Fixed.prototype = new $h_Ljava_time_zone_ZoneRules();
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.constructor = $c_Ljava_time_zone_ZoneRules$Fixed;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules$Fixed() {
}
export { $h_Ljava_time_zone_ZoneRules$Fixed as $h_Ljava_time_zone_ZoneRules$Fixed };
$h_Ljava_time_zone_ZoneRules$Fixed.prototype = $c_Ljava_time_zone_ZoneRules$Fixed.prototype;
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.isFixedOffset__Z = (function() {
  return true;
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset = (function(instant) {
  return this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.getValidOffsets__Ljava_time_LocalDateTime__ju_List = (function(localDateTime) {
  var o = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  return $m_ju_Collections$().singletonList__O__ju_List(o);
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.getTransition__Ljava_time_LocalDateTime__Ljava_time_zone_ZoneOffsetTransition = (function(localDateTime) {
  return null;
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.isValidOffset__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Z = (function(dateTime, offset) {
  var x = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  return ((x === null) ? (offset === null) : x.equals__O__Z(offset));
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.getStandardOffset__Ljava_time_Instant__Ljava_time_ZoneOffset = (function(instant) {
  return this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.isDaylightSavings__Ljava_time_Instant__Z = (function(instant) {
  return false;
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_zone_ZoneRules$Fixed)) {
    if ((this === obj)) {
      return true;
    } else {
      var x = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      var x$2 = obj.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    }
  } else if ((obj instanceof $c_Ljava_time_zone_StandardZoneRules)) {
    if (obj.isFixedOffset__Z()) {
      var x$3 = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
      var x$4 = obj.getOffset__Ljava_time_Instant__Ljava_time_ZoneOffset($m_Ljava_time_Instant$().EPOCH__Ljava_time_Instant());
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.hashCode__I = (function() {
  var this$1 = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  var $x_1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = this.Ljava_time_zone_ZoneRules$Fixed__f_offset;
  return (1 ^ (((31 + $x_1) | 0) ^ ((31 + this$2.Ljava_time_ZoneOffset__f_totalSeconds) | 0)));
});
$c_Ljava_time_zone_ZoneRules$Fixed.prototype.toString__T = (function() {
  return ("FixedRules:" + this.Ljava_time_zone_ZoneRules$Fixed__f_offset);
});
function $isArrayOf_Ljava_time_zone_ZoneRules$Fixed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRules$Fixed)));
}
export { $isArrayOf_Ljava_time_zone_ZoneRules$Fixed as $isArrayOf_Ljava_time_zone_ZoneRules$Fixed };
var $d_Ljava_time_zone_ZoneRules$Fixed = new $TypeData().initClass($c_Ljava_time_zone_ZoneRules$Fixed, "java.time.zone.ZoneRules$Fixed", ({
  Ljava_time_zone_ZoneRules$Fixed: 1,
  Ljava_time_zone_ZoneRules: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_zone_ZoneRules$Fixed as $d_Ljava_time_zone_ZoneRules$Fixed };
function $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z($thiz, iter, o$2) {
  while (true) {
    if (iter.hasNext__Z()) {
      var a = iter.next__O();
      if (((a === null) ? (o$2 === null) : $dp_equals__O__Z(a, o$2))) {
        iter.remove__V();
        return true;
      }
    } else {
      return false;
    }
  }
}
export { $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z as $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z };
/** @constructor */
function $c_ju_AbstractCollection() {
}
export { $c_ju_AbstractCollection as $c_ju_AbstractCollection };
$c_ju_AbstractCollection.prototype = new $h_O();
$c_ju_AbstractCollection.prototype.constructor = $c_ju_AbstractCollection;
/** @constructor */
function $h_ju_AbstractCollection() {
}
export { $h_ju_AbstractCollection as $h_ju_AbstractCollection };
$h_ju_AbstractCollection.prototype = $c_ju_AbstractCollection.prototype;
$c_ju_AbstractCollection.prototype.isEmpty__Z = (function() {
  return (this.size__I() === 0);
});
$c_ju_AbstractCollection.prototype.contains__O__Z = (function(o) {
  var _\uff3fself = this.iterator__ju_Iterator();
  while (_\uff3fself.hasNext__Z()) {
    var t = _\uff3fself.next__O();
    if (((o === null) ? (t === null) : $dp_equals__O__Z(o, t))) {
      return true;
    }
  }
  return false;
});
$c_ju_AbstractCollection.prototype.toArray__AO = (function() {
  return this.toArray__AO__AO(new $ac_O(this.size__I()));
});
$c_ju_AbstractCollection.prototype.toArray__AO__AO = (function(a) {
  if ((a.u.length >= this.size__I())) {
    var toFill = a;
  } else {
    var this$1 = $objectGetClass(a);
    var componentType = this$1.data.getComponentType();
    var length = this.size__I();
    var toFill = componentType.data.newArray(length);
  }
  var iter = this.iterator__ju_Iterator();
  var end = this.size__I();
  var i = 0;
  while ((i < end)) {
    var value = i;
    toFill.u[value] = iter.next__O();
    i = ((1 + i) | 0);
  }
  if ((toFill.u.length > this.size__I())) {
    toFill.u[this.size__I()] = null;
  }
  return toFill;
});
$c_ju_AbstractCollection.prototype.add__O__Z = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_AbstractCollection.prototype.remove__O__Z = (function(o) {
  return $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z(this, this.iterator__ju_Iterator(), o);
});
$c_ju_AbstractCollection.prototype.containsAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = c.iterator__ju_Iterator();
  _return: {
    while (_\uff3fself.hasNext__Z()) {
      var t = _\uff3fself.next__O();
      if ((!this.contains__O__Z(t))) {
        var $x_1 = true;
        break _return;
      }
    }
    var $x_1 = false;
  }
  return (!$x_1);
});
$c_ju_AbstractCollection.prototype.addAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = c.iterator__ju_Iterator();
  var result = false;
  while (_\uff3fself.hasNext__Z()) {
    var t = result;
    var u = _\uff3fself.next__O();
    var t$1 = (!(!t));
    result = (this.add__O__Z(u) || t$1);
  }
  return (!(!result));
});
$c_ju_AbstractCollection.prototype.retainAll__ju_Collection__Z = (function(c) {
  var iter = this.iterator__ju_Iterator();
  var changed = false;
  while (iter.hasNext__Z()) {
    var t = iter.next__O();
    if ((!c.contains__O__Z(t))) {
      iter.remove__V();
      changed = true;
    }
  }
  return changed;
});
$c_ju_AbstractCollection.prototype.toString__T = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = "[";
  var first = true;
  while (_\uff3fself.hasNext__Z()) {
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (("" + result) + _\uff3fself.next__O());
  }
  return (result + "]");
});
/** @constructor */
function $c_ju_AbstractMap$SimpleImmutableEntry(key, value) {
  this.ju_AbstractMap$SimpleImmutableEntry__f_key = null;
  this.ju_AbstractMap$SimpleImmutableEntry__f_value = null;
  this.ju_AbstractMap$SimpleImmutableEntry__f_key = key;
  this.ju_AbstractMap$SimpleImmutableEntry__f_value = value;
}
export { $c_ju_AbstractMap$SimpleImmutableEntry as $c_ju_AbstractMap$SimpleImmutableEntry };
$c_ju_AbstractMap$SimpleImmutableEntry.prototype = new $h_O();
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.constructor = $c_ju_AbstractMap$SimpleImmutableEntry;
/** @constructor */
function $h_ju_AbstractMap$SimpleImmutableEntry() {
}
export { $h_ju_AbstractMap$SimpleImmutableEntry as $h_ju_AbstractMap$SimpleImmutableEntry };
$h_ju_AbstractMap$SimpleImmutableEntry.prototype = $c_ju_AbstractMap$SimpleImmutableEntry.prototype;
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.getKey__O = (function() {
  return this.ju_AbstractMap$SimpleImmutableEntry__f_key;
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.getValue__O = (function() {
  return this.ju_AbstractMap$SimpleImmutableEntry__f_value;
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.equals__O__Z = (function(o) {
  return $m_ju_AbstractMap$().java$util$AbstractMap$$entryEquals__ju_Map$Entry__O__Z(this, o);
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.hashCode__I = (function() {
  return $m_ju_AbstractMap$().java$util$AbstractMap$$entryHashCode__ju_Map$Entry__I(this);
});
$c_ju_AbstractMap$SimpleImmutableEntry.prototype.toString__T = (function() {
  return ((this.ju_AbstractMap$SimpleImmutableEntry__f_key + "=") + this.ju_AbstractMap$SimpleImmutableEntry__f_value);
});
var $d_ju_AbstractMap$SimpleImmutableEntry = new $TypeData().initClass($c_ju_AbstractMap$SimpleImmutableEntry, "java.util.AbstractMap$SimpleImmutableEntry", ({
  ju_AbstractMap$SimpleImmutableEntry: 1,
  ju_Map$Entry: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_AbstractMap$SimpleImmutableEntry as $d_ju_AbstractMap$SimpleImmutableEntry };
function $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__($thiz, inner) {
  $thiz.ju_Collections$UnmodifiableIterator__f_inner = inner;
  return $thiz;
}
export { $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__ as $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__ };
/** @constructor */
function $c_ju_Collections$UnmodifiableIterator() {
  this.ju_Collections$UnmodifiableIterator__f_inner = null;
}
export { $c_ju_Collections$UnmodifiableIterator as $c_ju_Collections$UnmodifiableIterator };
$c_ju_Collections$UnmodifiableIterator.prototype = new $h_O();
$c_ju_Collections$UnmodifiableIterator.prototype.constructor = $c_ju_Collections$UnmodifiableIterator;
/** @constructor */
function $h_ju_Collections$UnmodifiableIterator() {
}
export { $h_ju_Collections$UnmodifiableIterator as $h_ju_Collections$UnmodifiableIterator };
$h_ju_Collections$UnmodifiableIterator.prototype = $c_ju_Collections$UnmodifiableIterator.prototype;
$c_ju_Collections$UnmodifiableIterator.prototype.hasNext__Z = (function() {
  return this.ju_Collections$UnmodifiableIterator__f_inner.hasNext__Z();
});
$c_ju_Collections$UnmodifiableIterator.prototype.next__O = (function() {
  return this.ju_Collections$UnmodifiableIterator__f_inner.next__O();
});
$c_ju_Collections$UnmodifiableIterator.prototype.remove__V = (function() {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
var $d_ju_Collections$UnmodifiableIterator = new $TypeData().initClass($c_ju_Collections$UnmodifiableIterator, "java.util.Collections$UnmodifiableIterator", ({
  ju_Collections$UnmodifiableIterator: 1,
  ju_Collections$WrappedIterator: 1,
  ju_Iterator: 1
}));
export { $d_ju_Collections$UnmodifiableIterator as $d_ju_Collections$UnmodifiableIterator };
/** @constructor */
function $c_ju_HashMap$KeyIterator(outer) {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
  $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__(this, outer);
}
export { $c_ju_HashMap$KeyIterator as $c_ju_HashMap$KeyIterator };
$c_ju_HashMap$KeyIterator.prototype = new $h_ju_HashMap$AbstractHashMapIterator();
$c_ju_HashMap$KeyIterator.prototype.constructor = $c_ju_HashMap$KeyIterator;
/** @constructor */
function $h_ju_HashMap$KeyIterator() {
}
export { $h_ju_HashMap$KeyIterator as $h_ju_HashMap$KeyIterator };
$h_ju_HashMap$KeyIterator.prototype = $c_ju_HashMap$KeyIterator.prototype;
$c_ju_HashMap$KeyIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node.ju_HashMap$Node__f_key;
});
var $d_ju_HashMap$KeyIterator = new $TypeData().initClass($c_ju_HashMap$KeyIterator, "java.util.HashMap$KeyIterator", ({
  ju_HashMap$KeyIterator: 1,
  ju_HashMap$AbstractHashMapIterator: 1,
  ju_Iterator: 1
}));
export { $d_ju_HashMap$KeyIterator as $d_ju_HashMap$KeyIterator };
/** @constructor */
function $c_ju_HashMap$NodeIterator(outer) {
  this.ju_HashMap$AbstractHashMapIterator__f_len = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextIdx = 0;
  this.ju_HashMap$AbstractHashMapIterator__f_nextNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_lastNode = null;
  this.ju_HashMap$AbstractHashMapIterator__f_$outer = null;
  $ct_ju_HashMap$AbstractHashMapIterator__ju_HashMap__(this, outer);
}
export { $c_ju_HashMap$NodeIterator as $c_ju_HashMap$NodeIterator };
$c_ju_HashMap$NodeIterator.prototype = new $h_ju_HashMap$AbstractHashMapIterator();
$c_ju_HashMap$NodeIterator.prototype.constructor = $c_ju_HashMap$NodeIterator;
/** @constructor */
function $h_ju_HashMap$NodeIterator() {
}
export { $h_ju_HashMap$NodeIterator as $h_ju_HashMap$NodeIterator };
$h_ju_HashMap$NodeIterator.prototype = $c_ju_HashMap$NodeIterator.prototype;
$c_ju_HashMap$NodeIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node;
});
var $d_ju_HashMap$NodeIterator = new $TypeData().initClass($c_ju_HashMap$NodeIterator, "java.util.HashMap$NodeIterator", ({
  ju_HashMap$NodeIterator: 1,
  ju_HashMap$AbstractHashMapIterator: 1,
  ju_Iterator: 1
}));
export { $d_ju_HashMap$NodeIterator as $d_ju_HashMap$NodeIterator };
/** @constructor */
function $c_ju_LinkedHashMap$KeyIterator(outer) {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer);
}
export { $c_ju_LinkedHashMap$KeyIterator as $c_ju_LinkedHashMap$KeyIterator };
$c_ju_LinkedHashMap$KeyIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$c_ju_LinkedHashMap$KeyIterator.prototype.constructor = $c_ju_LinkedHashMap$KeyIterator;
/** @constructor */
function $h_ju_LinkedHashMap$KeyIterator() {
}
export { $h_ju_LinkedHashMap$KeyIterator as $h_ju_LinkedHashMap$KeyIterator };
$h_ju_LinkedHashMap$KeyIterator.prototype = $c_ju_LinkedHashMap$KeyIterator.prototype;
$c_ju_LinkedHashMap$KeyIterator.prototype.extract__ju_LinkedHashMap$Node__O = (function(node) {
  return node.ju_HashMap$Node__f_key;
});
var $d_ju_LinkedHashMap$KeyIterator = new $TypeData().initClass($c_ju_LinkedHashMap$KeyIterator, "java.util.LinkedHashMap$KeyIterator", ({
  ju_LinkedHashMap$KeyIterator: 1,
  ju_LinkedHashMap$AbstractLinkedHashMapIterator: 1,
  ju_Iterator: 1
}));
export { $d_ju_LinkedHashMap$KeyIterator as $d_ju_LinkedHashMap$KeyIterator };
/** @constructor */
function $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, older, younger) {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
  this.ju_LinkedHashMap$Node__f_older = null;
  this.ju_LinkedHashMap$Node__f_younger = null;
  this.ju_LinkedHashMap$Node__f_older = older;
  this.ju_LinkedHashMap$Node__f_younger = younger;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next);
}
export { $c_ju_LinkedHashMap$Node as $c_ju_LinkedHashMap$Node };
$c_ju_LinkedHashMap$Node.prototype = new $h_ju_HashMap$Node();
$c_ju_LinkedHashMap$Node.prototype.constructor = $c_ju_LinkedHashMap$Node;
/** @constructor */
function $h_ju_LinkedHashMap$Node() {
}
export { $h_ju_LinkedHashMap$Node as $h_ju_LinkedHashMap$Node };
$h_ju_LinkedHashMap$Node.prototype = $c_ju_LinkedHashMap$Node.prototype;
var $d_ju_LinkedHashMap$Node = new $TypeData().initClass($c_ju_LinkedHashMap$Node, "java.util.LinkedHashMap$Node", ({
  ju_LinkedHashMap$Node: 1,
  ju_HashMap$Node: 1,
  ju_Map$Entry: 1
}));
export { $d_ju_LinkedHashMap$Node as $d_ju_LinkedHashMap$Node };
/** @constructor */
function $c_ju_LinkedHashMap$NodeIterator(outer) {
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_nextNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_lastNode = null;
  this.ju_LinkedHashMap$AbstractLinkedHashMapIterator__f_$outer = null;
  $ct_ju_LinkedHashMap$AbstractLinkedHashMapIterator__ju_LinkedHashMap__(this, outer);
}
export { $c_ju_LinkedHashMap$NodeIterator as $c_ju_LinkedHashMap$NodeIterator };
$c_ju_LinkedHashMap$NodeIterator.prototype = new $h_ju_LinkedHashMap$AbstractLinkedHashMapIterator();
$c_ju_LinkedHashMap$NodeIterator.prototype.constructor = $c_ju_LinkedHashMap$NodeIterator;
/** @constructor */
function $h_ju_LinkedHashMap$NodeIterator() {
}
export { $h_ju_LinkedHashMap$NodeIterator as $h_ju_LinkedHashMap$NodeIterator };
$h_ju_LinkedHashMap$NodeIterator.prototype = $c_ju_LinkedHashMap$NodeIterator.prototype;
$c_ju_LinkedHashMap$NodeIterator.prototype.extract__ju_LinkedHashMap$Node__O = (function(node) {
  return node;
});
var $d_ju_LinkedHashMap$NodeIterator = new $TypeData().initClass($c_ju_LinkedHashMap$NodeIterator, "java.util.LinkedHashMap$NodeIterator", ({
  ju_LinkedHashMap$NodeIterator: 1,
  ju_LinkedHashMap$AbstractLinkedHashMapIterator: 1,
  ju_Iterator: 1
}));
export { $d_ju_LinkedHashMap$NodeIterator as $d_ju_LinkedHashMap$NodeIterator };
function $s_ju_Locale$Category$__DISPLAY__ju_Locale$Category() {
  $m_ju_Locale$Category$();
  return $t_ju_Locale$Category$__DISPLAY;
}
export { $s_ju_Locale$Category$__DISPLAY__ju_Locale$Category as $s_ju_Locale$Category$__DISPLAY__ju_Locale$Category };
function $s_ju_Locale$Category$__FORMAT__ju_Locale$Category() {
  $m_ju_Locale$Category$();
  return $t_ju_Locale$Category$__FORMAT;
}
export { $s_ju_Locale$Category$__FORMAT__ju_Locale$Category as $s_ju_Locale$Category$__FORMAT__ju_Locale$Category };
/** @constructor */
function $c_ju_Locale$Category$() {
  this.ju_Locale$Category$__f_$values = null;
  $n_ju_Locale$Category$ = this;
  $t_ju_Locale$Category$__DISPLAY = new $c_ju_Locale$Category$$anon$2();
  $t_ju_Locale$Category$__FORMAT = new $c_ju_Locale$Category$$anon$3();
  this.ju_Locale$Category$__f_$values = new ($d_ju_Locale$Category.getArrayOf().constr)([$s_ju_Locale$Category$__DISPLAY__ju_Locale$Category(), $s_ju_Locale$Category$__FORMAT__ju_Locale$Category()]);
}
export { $c_ju_Locale$Category$ as $c_ju_Locale$Category$ };
$c_ju_Locale$Category$.prototype = new $h_O();
$c_ju_Locale$Category$.prototype.constructor = $c_ju_Locale$Category$;
/** @constructor */
function $h_ju_Locale$Category$() {
}
export { $h_ju_Locale$Category$ as $h_ju_Locale$Category$ };
$h_ju_Locale$Category$.prototype = $c_ju_Locale$Category$.prototype;
$c_ju_Locale$Category$.prototype.values__Aju_Locale$Category = (function() {
  var this$1 = this.ju_Locale$Category$__f_$values;
  return this$1.clone__O();
});
$c_ju_Locale$Category$.prototype.ordinal__O__I = (function(x) {
  return x.jl_Enum__f__ordinal;
});
var $d_ju_Locale$Category$ = new $TypeData().initClass($c_ju_Locale$Category$, "java.util.Locale$Category$", ({
  ju_Locale$Category$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_ju_Locale$Category$ as $d_ju_Locale$Category$ };
var $n_ju_Locale$Category$;
function $m_ju_Locale$Category$() {
  if ((!$n_ju_Locale$Category$)) {
    $n_ju_Locale$Category$ = new $c_ju_Locale$Category$();
  }
  return $n_ju_Locale$Category$;
}
export { $m_ju_Locale$Category$ as $m_ju_Locale$Category$ };
/** @constructor */
function $c_ju_NullRejectingHashMap$Node(key, hash, value, previous, next) {
  this.ju_HashMap$Node__f_key = null;
  this.ju_HashMap$Node__f_hash = 0;
  this.ju_HashMap$Node__f_value = null;
  this.ju_HashMap$Node__f_previous = null;
  this.ju_HashMap$Node__f_next = null;
  $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(this, key, hash, value, previous, next);
}
export { $c_ju_NullRejectingHashMap$Node as $c_ju_NullRejectingHashMap$Node };
$c_ju_NullRejectingHashMap$Node.prototype = new $h_ju_HashMap$Node();
$c_ju_NullRejectingHashMap$Node.prototype.constructor = $c_ju_NullRejectingHashMap$Node;
/** @constructor */
function $h_ju_NullRejectingHashMap$Node() {
}
export { $h_ju_NullRejectingHashMap$Node as $h_ju_NullRejectingHashMap$Node };
$h_ju_NullRejectingHashMap$Node.prototype = $c_ju_NullRejectingHashMap$Node.prototype;
var $d_ju_NullRejectingHashMap$Node = new $TypeData().initClass($c_ju_NullRejectingHashMap$Node, "java.util.NullRejectingHashMap$Node", ({
  ju_NullRejectingHashMap$Node: 1,
  ju_HashMap$Node: 1,
  ju_Map$Entry: 1
}));
export { $d_ju_NullRejectingHashMap$Node as $d_ju_NullRejectingHashMap$Node };
function $ct_ju_TimeZone__($thiz) {
  return $thiz;
}
export { $ct_ju_TimeZone__ as $ct_ju_TimeZone__ };
function $ps_ju_TimeZone__atIndex$1__AT__I__s_Option(strs, idx) {
  return (((idx >= 0) && (idx < strs.u.length)) ? $m_s_Option$().apply__O__s_Option(strs.u[idx]) : $m_s_None$());
}
export { $ps_ju_TimeZone__atIndex$1__AT__I__s_Option as $ps_ju_TimeZone__atIndex$1__AT__I__s_Option };
function $ps_ju_TimeZone__currentIdStrings$1__T__AT__Z(id$1, strs) {
  return $ps_ju_TimeZone__atIndex$1__AT__I__s_Option(strs, 0).contains__O__Z(id$1);
}
export { $ps_ju_TimeZone__currentIdStrings$1__T__AT__Z as $ps_ju_TimeZone__currentIdStrings$1__T__AT__Z };
/** @constructor */
function $c_ju_TimeZone() {
}
export { $c_ju_TimeZone as $c_ju_TimeZone };
$c_ju_TimeZone.prototype = new $h_O();
$c_ju_TimeZone.prototype.constructor = $c_ju_TimeZone;
/** @constructor */
function $h_ju_TimeZone() {
}
export { $h_ju_TimeZone as $h_ju_TimeZone };
$h_ju_TimeZone.prototype = $c_ju_TimeZone.prototype;
$c_ju_TimeZone.prototype.getDisplayName__Z__I__ju_Locale__T = (function(daylight, style, locale) {
  if (((style !== 0) && (style !== 1))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("Illegal timezone style: " + style));
  }
  var id = this.ju_SimpleTimeZone__f_ID;
  var zoneStrings = $m_Ljava_text_DateFormatSymbols$().getInstance__ju_Locale__Ljava_text_DateFormatSymbols(locale).Ljava_text_DateFormatSymbols__f_zoneStrings;
  _return: {
    var i = 0;
    while ((i < zoneStrings.u.length)) {
      var x1 = i;
      var x0 = zoneStrings.u[x1];
      if ($ps_ju_TimeZone__currentIdStrings$1__T__AT__Z(id, x0)) {
        var idx = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var idx = (-1);
  }
  var this$4 = ((idx === (-1)) ? $m_s_None$() : new $c_s_Some(zoneStrings.u[idx]));
  if (this$4.isEmpty__Z()) {
    var zoneName = $m_s_None$();
  } else {
    var x0$1 = this$4.get__O();
    matchResult1: {
      var zoneName;
      if ((daylight === false)) {
        if ((style === 1)) {
          var zoneName = $ps_ju_TimeZone__atIndex$1__AT__I__s_Option(x0$1, 1);
          break matchResult1;
        }
        if ((style === 0)) {
          var zoneName = $ps_ju_TimeZone__atIndex$1__AT__I__s_Option(x0$1, 2);
          break matchResult1;
        }
      }
      if ((daylight === true)) {
        if ((style === 1)) {
          var zoneName = $ps_ju_TimeZone__atIndex$1__AT__I__s_Option(x0$1, 3);
          break matchResult1;
        }
        if ((style === 0)) {
          var zoneName = $ps_ju_TimeZone__atIndex$1__AT__I__s_Option(x0$1, 4);
          break matchResult1;
        }
      }
      var zoneName = $m_s_None$();
    }
  }
  var this$8 = (zoneName.isEmpty__Z() ? (((!(!id.startsWith("GMT+"))) || (!(!id.startsWith("GMT-")))) ? new $c_s_Some(id) : $m_s_None$()) : zoneName);
  return (this$8.isEmpty__Z() ? null : this$8.get__O());
});
/** @constructor */
function $c_ju_UUID(mostSigBits, leastSigBits) {
  this.ju_UUID__f_java$util$UUID$$mostSigBits = $L0;
  this.ju_UUID__f_java$util$UUID$$leastSigBits = $L0;
  this.ju_UUID__f_java$util$UUID$$mostSigBits = mostSigBits;
  this.ju_UUID__f_java$util$UUID$$leastSigBits = leastSigBits;
}
export { $c_ju_UUID as $c_ju_UUID };
$c_ju_UUID.prototype = new $h_O();
$c_ju_UUID.prototype.constructor = $c_ju_UUID;
/** @constructor */
function $h_ju_UUID() {
}
export { $h_ju_UUID as $h_ju_UUID };
$h_ju_UUID.prototype = $c_ju_UUID.prototype;
$c_ju_UUID.prototype.toString__T = (function() {
  var t = this.ju_UUID__f_java$util$UUID$$mostSigBits;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = this.ju_UUID__f_java$util$UUID$$leastSigBits;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var s = (hi >>> 0.0).toString(16);
  var beginIndex = s.length;
  var $x_5 = "00000000".substring(beginIndex);
  var lo$2 = (((lo >>> 16) | 0) | (hi << 16));
  var i = (65535 & lo$2);
  var s$1 = (i >>> 0.0).toString(16);
  var beginIndex$1 = s$1.length;
  var $x_4 = "0000".substring(beginIndex$1);
  var i$1 = (65535 & lo);
  var s$2 = (i$1 >>> 0.0).toString(16);
  var beginIndex$2 = s$2.length;
  var $x_3 = "0000".substring(beginIndex$2);
  var lo$3 = ((hi$1 >>> 16) | 0);
  var i$2 = (65535 & lo$3);
  var s$3 = (i$2 >>> 0.0).toString(16);
  var beginIndex$3 = s$3.length;
  var $x_2 = "0000".substring(beginIndex$3);
  var i$3 = (65535 & hi$1);
  var s$4 = (i$3 >>> 0.0).toString(16);
  var beginIndex$4 = s$4.length;
  var $x_1 = "0000".substring(beginIndex$4);
  var s$5 = (lo$1 >>> 0.0).toString(16);
  var beginIndex$5 = s$5.length;
  return ((((((((((("" + $x_5) + s) + "-") + (("" + $x_4) + s$1)) + "-") + (("" + $x_3) + s$2)) + "-") + (("" + $x_2) + s$3)) + "-") + (("" + $x_1) + s$4)) + (("" + "00000000".substring(beginIndex$5)) + s$5));
});
$c_ju_UUID.prototype.hashCode__I = (function() {
  var t = this.ju_UUID__f_java$util$UUID$$mostSigBits;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = this.ju_UUID__f_java$util$UUID$$leastSigBits;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return ((lo ^ hi) ^ (lo$1 ^ hi$1));
});
$c_ju_UUID.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_ju_UUID)) {
    var a = this.ju_UUID__f_java$util$UUID$$mostSigBits;
    var b = that.ju_UUID__f_java$util$UUID$$mostSigBits;
    if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
      var a$1 = this.ju_UUID__f_java$util$UUID$$leastSigBits;
      var b$1 = that.ju_UUID__f_java$util$UUID$$leastSigBits;
      return ((a$1.RTLong__f_lo === b$1.RTLong__f_lo) && (a$1.RTLong__f_hi === b$1.RTLong__f_hi));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_UUID.prototype.compareTo__ju_UUID__I = (function(that) {
  var t = this.ju_UUID__f_java$util$UUID$$mostSigBits;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = that.ju_UUID__f_java$util$UUID$$mostSigBits;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if ((!((lo === lo$1) && (hi === hi$1)))) {
    return (((hi === hi$1) ? ((lo >>> 0) < (lo$1 >>> 0)) : (hi < hi$1)) ? (-1) : 1);
  } else {
    var t$2 = this.ju_UUID__f_java$util$UUID$$leastSigBits;
    var lo$2 = t$2.RTLong__f_lo;
    var hi$2 = t$2.RTLong__f_hi;
    var t$3 = that.ju_UUID__f_java$util$UUID$$leastSigBits;
    var lo$3 = t$3.RTLong__f_lo;
    var hi$3 = t$3.RTLong__f_hi;
    return ((!((lo$2 === lo$3) && (hi$2 === hi$3))) ? (((hi$2 === hi$3) ? ((lo$2 >>> 0) < (lo$3 >>> 0)) : (hi$2 < hi$3)) ? (-1) : 1) : 0);
  }
});
$c_ju_UUID.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__ju_UUID__I(o);
});
function $isArrayOf_ju_UUID(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_UUID)));
}
export { $isArrayOf_ju_UUID as $isArrayOf_ju_UUID };
var $d_ju_UUID = new $TypeData().initClass($c_ju_UUID, "java.util.UUID", ({
  ju_UUID: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}));
export { $d_ju_UUID as $d_ju_UUID };
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator(outer) {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null;
  $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__(this, outer);
}
export { $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator as $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator };
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator.prototype = new $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator() {
}
export { $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator as $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator };
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node.ju_HashMap$Node__f_key;
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator, "java.util.concurrent.ConcurrentHashMap$InnerHashMap$KeyIterator", ({
  ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator: 1,
  ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator: 1,
  ju_Iterator: 1
}));
export { $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator as $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator };
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator(outer) {
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_innerIter = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_lastNode = null;
  this.ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__f_$outer = null;
  $ct_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator__ju_concurrent_ConcurrentHashMap$InnerHashMap__(this, outer);
}
export { $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator as $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator };
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype = new $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator() {
}
export { $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator as $h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator };
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator.prototype.extract__ju_HashMap$Node__O = (function(node) {
  return node;
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator, "java.util.concurrent.ConcurrentHashMap$InnerHashMap$NodeIterator", ({
  ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator: 1,
  ju_concurrent_ConcurrentHashMap$InnerHashMap$AbstractCHMIterator: 1,
  ju_Iterator: 1
}));
export { $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator as $d_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator };
/** @constructor */
function $c_ju_concurrent_atomic_AtomicLong(value) {
  this.ju_concurrent_atomic_AtomicLong__f_java$util$concurrent$atomic$AtomicLong$$value = $L0;
  this.ju_concurrent_atomic_AtomicLong__f_java$util$concurrent$atomic$AtomicLong$$value = value;
}
export { $c_ju_concurrent_atomic_AtomicLong as $c_ju_concurrent_atomic_AtomicLong };
$c_ju_concurrent_atomic_AtomicLong.prototype = new $h_jl_Number();
$c_ju_concurrent_atomic_AtomicLong.prototype.constructor = $c_ju_concurrent_atomic_AtomicLong;
/** @constructor */
function $h_ju_concurrent_atomic_AtomicLong() {
}
export { $h_ju_concurrent_atomic_AtomicLong as $h_ju_concurrent_atomic_AtomicLong };
$h_ju_concurrent_atomic_AtomicLong.prototype = $c_ju_concurrent_atomic_AtomicLong.prototype;
$c_ju_concurrent_atomic_AtomicLong.prototype.compareAndSet__J__J__Z = (function(expect, update) {
  var b = this.ju_concurrent_atomic_AtomicLong__f_java$util$concurrent$atomic$AtomicLong$$value;
  if ((!(!((expect.RTLong__f_lo === b.RTLong__f_lo) && (expect.RTLong__f_hi === b.RTLong__f_hi))))) {
    this.ju_concurrent_atomic_AtomicLong__f_java$util$concurrent$atomic$AtomicLong$$value = update;
    return true;
  } else {
    return false;
  }
});
$c_ju_concurrent_atomic_AtomicLong.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_atomic_AtomicLong__f_java$util$concurrent$atomic$AtomicLong$$value;
  var this$2 = $m_RTLong$();
  return this$2.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$1.RTLong__f_lo, this$1.RTLong__f_hi);
});
var $d_ju_concurrent_atomic_AtomicLong = new $TypeData().initClass($c_ju_concurrent_atomic_AtomicLong, "java.util.concurrent.atomic.AtomicLong", ({
  ju_concurrent_atomic_AtomicLong: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_atomic_AtomicLong as $d_ju_concurrent_atomic_AtomicLong };
/** @constructor */
function $c_Llocales_cldr_CalendarPatterns$() {
  $n_Llocales_cldr_CalendarPatterns$ = this;
  $m_Llocales_cldr_CalendarPatterns$();
}
export { $c_Llocales_cldr_CalendarPatterns$ as $c_Llocales_cldr_CalendarPatterns$ };
$c_Llocales_cldr_CalendarPatterns$.prototype = new $h_O();
$c_Llocales_cldr_CalendarPatterns$.prototype.constructor = $c_Llocales_cldr_CalendarPatterns$;
/** @constructor */
function $h_Llocales_cldr_CalendarPatterns$() {
}
export { $h_Llocales_cldr_CalendarPatterns$ as $h_Llocales_cldr_CalendarPatterns$ };
$h_Llocales_cldr_CalendarPatterns$.prototype = $c_Llocales_cldr_CalendarPatterns$.prototype;
$c_Llocales_cldr_CalendarPatterns$.prototype.fromProduct__s_Product__Llocales_cldr_CalendarPatterns = (function(x$0) {
  return new $c_Llocales_cldr_CalendarPatterns(x$0.productElement__I__O(0), x$0.productElement__I__O(1));
});
$c_Llocales_cldr_CalendarPatterns$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Llocales_cldr_CalendarPatterns(p);
});
var $d_Llocales_cldr_CalendarPatterns$ = new $TypeData().initClass($c_Llocales_cldr_CalendarPatterns$, "locales.cldr.CalendarPatterns$", ({
  Llocales_cldr_CalendarPatterns$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Llocales_cldr_CalendarPatterns$ as $d_Llocales_cldr_CalendarPatterns$ };
var $n_Llocales_cldr_CalendarPatterns$;
function $m_Llocales_cldr_CalendarPatterns$() {
  if ((!$n_Llocales_cldr_CalendarPatterns$)) {
    $n_Llocales_cldr_CalendarPatterns$ = new $c_Llocales_cldr_CalendarPatterns$();
  }
  return $n_Llocales_cldr_CalendarPatterns$;
}
export { $m_Llocales_cldr_CalendarPatterns$ as $m_Llocales_cldr_CalendarPatterns$ };
/** @constructor */
function $c_Lmagnolia1_CaseClass$Param$$anon$2(name$2, idx$3, repeated$2, annotations$2, typeAnnotations$2, defaultVal$3, cbn$3, inheritedAnns$3) {
  this.Lmagnolia1_CaseClass$Param$$anon$2__f_cbn$4 = null;
  this.Lmagnolia1_CaseClass$Param$$anon$2__f_inheritedAnns$4 = null;
  this.Lmagnolia1_CaseClass$Param$$anon$2__f_idx$4 = 0;
  this.Lmagnolia1_CaseClass$Param$$anon$2__f_label = null;
  this.Lmagnolia1_CaseClass$Param$$anon$2__f_annotations = null;
  this.Lmagnolia1_CaseClass$Param$$anon$2__f_cbn$4 = cbn$3;
  this.Lmagnolia1_CaseClass$Param$$anon$2__f_inheritedAnns$4 = inheritedAnns$3;
  this.Lmagnolia1_CaseClass$Param$$anon$2__f_idx$4 = idx$3;
  this.Lmagnolia1_CaseClass$Param$$anon$2__f_label = name$2;
  this.Lmagnolia1_CaseClass$Param$$anon$2__f_annotations = annotations$2;
}
export { $c_Lmagnolia1_CaseClass$Param$$anon$2 as $c_Lmagnolia1_CaseClass$Param$$anon$2 };
$c_Lmagnolia1_CaseClass$Param$$anon$2.prototype = new $h_O();
$c_Lmagnolia1_CaseClass$Param$$anon$2.prototype.constructor = $c_Lmagnolia1_CaseClass$Param$$anon$2;
/** @constructor */
function $h_Lmagnolia1_CaseClass$Param$$anon$2() {
}
export { $h_Lmagnolia1_CaseClass$Param$$anon$2 as $h_Lmagnolia1_CaseClass$Param$$anon$2 };
$h_Lmagnolia1_CaseClass$Param$$anon$2.prototype = $c_Lmagnolia1_CaseClass$Param$$anon$2.prototype;
$c_Lmagnolia1_CaseClass$Param$$anon$2.prototype.toString__T = (function() {
  return $f_Lmagnolia1_CaseClass$Param__toString__T(this);
});
$c_Lmagnolia1_CaseClass$Param$$anon$2.prototype.typeclass__O = (function() {
  return this.Lmagnolia1_CaseClass$Param$$anon$2__f_cbn$4.value__O();
});
$c_Lmagnolia1_CaseClass$Param$$anon$2.prototype.deref__O__O = (function(value) {
  return value.productElement__I__O(this.Lmagnolia1_CaseClass$Param$$anon$2__f_idx$4);
});
var $d_Lmagnolia1_CaseClass$Param$$anon$2 = new $TypeData().initClass($c_Lmagnolia1_CaseClass$Param$$anon$2, "magnolia1.CaseClass$Param$$anon$2", ({
  Lmagnolia1_CaseClass$Param$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_CaseClass$Param: 1
}));
export { $d_Lmagnolia1_CaseClass$Param$$anon$2 as $d_Lmagnolia1_CaseClass$Param$$anon$2 };
/** @constructor */
function $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass(typeInfo, isObject, isValueClass, parameters, annotations, inheritedAnnotations, typeAnnotations, product) {
  this.Lmagnolia1_CaseClass__f_typeInfo = null;
  this.Lmagnolia1_CaseClass__f_isValueClass = false;
  this.Lmagnolia1_CaseClass__f_parameters = null;
  this.Lmagnolia1_CaseClass__f_annotations = null;
  this.Lmagnolia1_CaseClass__f_inheritedAnnotations = null;
  $ct_Lmagnolia1_CaseClass__Lmagnolia1_TypeInfo__Z__Z__ALmagnolia1_CaseClass$Param__O__O__O__(this, typeInfo, isObject, isValueClass, parameters, annotations, inheritedAnnotations, typeAnnotations);
}
export { $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass as $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass };
$c_Lmagnolia1_CaseClassDerivation$ProductCaseClass.prototype = new $h_Lmagnolia1_CaseClass();
$c_Lmagnolia1_CaseClassDerivation$ProductCaseClass.prototype.constructor = $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass;
/** @constructor */
function $h_Lmagnolia1_CaseClassDerivation$ProductCaseClass() {
}
export { $h_Lmagnolia1_CaseClassDerivation$ProductCaseClass as $h_Lmagnolia1_CaseClassDerivation$ProductCaseClass };
$h_Lmagnolia1_CaseClassDerivation$ProductCaseClass.prototype = $c_Lmagnolia1_CaseClassDerivation$ProductCaseClass.prototype;
var $d_Lmagnolia1_CaseClassDerivation$ProductCaseClass = new $TypeData().initClass($c_Lmagnolia1_CaseClassDerivation$ProductCaseClass, "magnolia1.CaseClassDerivation$ProductCaseClass", ({
  Lmagnolia1_CaseClassDerivation$ProductCaseClass: 1,
  Lmagnolia1_CaseClass: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lmagnolia1_CaseClassDerivation$ProductCaseClass as $d_Lmagnolia1_CaseClassDerivation$ProductCaseClass };
/** @constructor */
function $c_s_$less$colon$less() {
}
export { $c_s_$less$colon$less as $c_s_$less$colon$less };
$c_s_$less$colon$less.prototype = new $h_O();
$c_s_$less$colon$less.prototype.constructor = $c_s_$less$colon$less;
/** @constructor */
function $h_s_$less$colon$less() {
}
export { $h_s_$less$colon$less as $h_s_$less$colon$less };
$h_s_$less$colon$less.prototype = $c_s_$less$colon$less.prototype;
$c_s_$less$colon$less.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return v1;
});
/** @constructor */
function $c_s_Predef$() {
  this.s_Predef$__f_Map = null;
  this.s_Predef$__f_Set = null;
  $n_s_Predef$ = this;
  this.s_Predef$__f_Map = $m_sci_Map$();
  this.s_Predef$__f_Set = $m_sci_Set$();
}
export { $c_s_Predef$ as $c_s_Predef$ };
$c_s_Predef$.prototype = new $h_s_LowPriorityImplicits();
$c_s_Predef$.prototype.constructor = $c_s_Predef$;
/** @constructor */
function $h_s_Predef$() {
}
export { $h_s_Predef$ as $h_s_Predef$ };
$h_s_Predef$.prototype = $c_s_Predef$.prototype;
$c_s_Predef$.prototype.assert__Z__V = (function(assertion) {
  if ((!assertion)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "assertion failed");
  }
});
$c_s_Predef$.prototype.require__Z__V = (function(requirement) {
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed");
  }
});
var $d_s_Predef$ = new $TypeData().initClass($c_s_Predef$, "scala.Predef$", ({
  s_Predef$: 1,
  s_LowPriorityImplicits: 1,
  s_LowPriorityImplicits2: 1
}));
export { $d_s_Predef$ as $d_s_Predef$ };
var $n_s_Predef$;
function $m_s_Predef$() {
  if ((!$n_s_Predef$)) {
    $n_s_Predef$ = new $c_s_Predef$();
  }
  return $n_s_Predef$;
}
export { $m_s_Predef$ as $m_s_Predef$ };
function $f_s_Product1__productElement__I__O($thiz, n) {
  if ((n === 0)) {
    return $thiz.T1__f__1;
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 0)"));
  }
}
export { $f_s_Product1__productElement__I__O as $f_s_Product1__productElement__I__O };
function $f_s_Product10__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T10__f__1;
      break;
    }
    case 1: {
      return $thiz.T10__f__2;
      break;
    }
    case 2: {
      return $thiz.T10__f__3;
      break;
    }
    case 3: {
      return $thiz.T10__f__4;
      break;
    }
    case 4: {
      return $thiz.T10__f__5;
      break;
    }
    case 5: {
      return $thiz.T10__f__6;
      break;
    }
    case 6: {
      return $thiz.T10__f__7;
      break;
    }
    case 7: {
      return $thiz.T10__f__8;
      break;
    }
    case 8: {
      return $thiz.T10__f__9;
      break;
    }
    case 9: {
      return $thiz.T10__f__10;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 9)"));
    }
  }
}
export { $f_s_Product10__productElement__I__O as $f_s_Product10__productElement__I__O };
function $f_s_Product11__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T11__f__1;
      break;
    }
    case 1: {
      return $thiz.T11__f__2;
      break;
    }
    case 2: {
      return $thiz.T11__f__3;
      break;
    }
    case 3: {
      return $thiz.T11__f__4;
      break;
    }
    case 4: {
      return $thiz.T11__f__5;
      break;
    }
    case 5: {
      return $thiz.T11__f__6;
      break;
    }
    case 6: {
      return $thiz.T11__f__7;
      break;
    }
    case 7: {
      return $thiz.T11__f__8;
      break;
    }
    case 8: {
      return $thiz.T11__f__9;
      break;
    }
    case 9: {
      return $thiz.T11__f__10;
      break;
    }
    case 10: {
      return $thiz.T11__f__11;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 10)"));
    }
  }
}
export { $f_s_Product11__productElement__I__O as $f_s_Product11__productElement__I__O };
function $f_s_Product12__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T12__f__1;
      break;
    }
    case 1: {
      return $thiz.T12__f__2;
      break;
    }
    case 2: {
      return $thiz.T12__f__3;
      break;
    }
    case 3: {
      return $thiz.T12__f__4;
      break;
    }
    case 4: {
      return $thiz.T12__f__5;
      break;
    }
    case 5: {
      return $thiz.T12__f__6;
      break;
    }
    case 6: {
      return $thiz.T12__f__7;
      break;
    }
    case 7: {
      return $thiz.T12__f__8;
      break;
    }
    case 8: {
      return $thiz.T12__f__9;
      break;
    }
    case 9: {
      return $thiz.T12__f__10;
      break;
    }
    case 10: {
      return $thiz.T12__f__11;
      break;
    }
    case 11: {
      return $thiz.T12__f__12;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 11)"));
    }
  }
}
export { $f_s_Product12__productElement__I__O as $f_s_Product12__productElement__I__O };
function $f_s_Product13__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T13__f__1;
      break;
    }
    case 1: {
      return $thiz.T13__f__2;
      break;
    }
    case 2: {
      return $thiz.T13__f__3;
      break;
    }
    case 3: {
      return $thiz.T13__f__4;
      break;
    }
    case 4: {
      return $thiz.T13__f__5;
      break;
    }
    case 5: {
      return $thiz.T13__f__6;
      break;
    }
    case 6: {
      return $thiz.T13__f__7;
      break;
    }
    case 7: {
      return $thiz.T13__f__8;
      break;
    }
    case 8: {
      return $thiz.T13__f__9;
      break;
    }
    case 9: {
      return $thiz.T13__f__10;
      break;
    }
    case 10: {
      return $thiz.T13__f__11;
      break;
    }
    case 11: {
      return $thiz.T13__f__12;
      break;
    }
    case 12: {
      return $thiz.T13__f__13;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 12)"));
    }
  }
}
export { $f_s_Product13__productElement__I__O as $f_s_Product13__productElement__I__O };
function $f_s_Product14__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T14__f__1;
      break;
    }
    case 1: {
      return $thiz.T14__f__2;
      break;
    }
    case 2: {
      return $thiz.T14__f__3;
      break;
    }
    case 3: {
      return $thiz.T14__f__4;
      break;
    }
    case 4: {
      return $thiz.T14__f__5;
      break;
    }
    case 5: {
      return $thiz.T14__f__6;
      break;
    }
    case 6: {
      return $thiz.T14__f__7;
      break;
    }
    case 7: {
      return $thiz.T14__f__8;
      break;
    }
    case 8: {
      return $thiz.T14__f__9;
      break;
    }
    case 9: {
      return $thiz.T14__f__10;
      break;
    }
    case 10: {
      return $thiz.T14__f__11;
      break;
    }
    case 11: {
      return $thiz.T14__f__12;
      break;
    }
    case 12: {
      return $thiz.T14__f__13;
      break;
    }
    case 13: {
      return $thiz.T14__f__14;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 13)"));
    }
  }
}
export { $f_s_Product14__productElement__I__O as $f_s_Product14__productElement__I__O };
function $f_s_Product15__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T15__f__1;
      break;
    }
    case 1: {
      return $thiz.T15__f__2;
      break;
    }
    case 2: {
      return $thiz.T15__f__3;
      break;
    }
    case 3: {
      return $thiz.T15__f__4;
      break;
    }
    case 4: {
      return $thiz.T15__f__5;
      break;
    }
    case 5: {
      return $thiz.T15__f__6;
      break;
    }
    case 6: {
      return $thiz.T15__f__7;
      break;
    }
    case 7: {
      return $thiz.T15__f__8;
      break;
    }
    case 8: {
      return $thiz.T15__f__9;
      break;
    }
    case 9: {
      return $thiz.T15__f__10;
      break;
    }
    case 10: {
      return $thiz.T15__f__11;
      break;
    }
    case 11: {
      return $thiz.T15__f__12;
      break;
    }
    case 12: {
      return $thiz.T15__f__13;
      break;
    }
    case 13: {
      return $thiz.T15__f__14;
      break;
    }
    case 14: {
      return $thiz.T15__f__15;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 14)"));
    }
  }
}
export { $f_s_Product15__productElement__I__O as $f_s_Product15__productElement__I__O };
function $f_s_Product16__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T16__f__1;
      break;
    }
    case 1: {
      return $thiz.T16__f__2;
      break;
    }
    case 2: {
      return $thiz.T16__f__3;
      break;
    }
    case 3: {
      return $thiz.T16__f__4;
      break;
    }
    case 4: {
      return $thiz.T16__f__5;
      break;
    }
    case 5: {
      return $thiz.T16__f__6;
      break;
    }
    case 6: {
      return $thiz.T16__f__7;
      break;
    }
    case 7: {
      return $thiz.T16__f__8;
      break;
    }
    case 8: {
      return $thiz.T16__f__9;
      break;
    }
    case 9: {
      return $thiz.T16__f__10;
      break;
    }
    case 10: {
      return $thiz.T16__f__11;
      break;
    }
    case 11: {
      return $thiz.T16__f__12;
      break;
    }
    case 12: {
      return $thiz.T16__f__13;
      break;
    }
    case 13: {
      return $thiz.T16__f__14;
      break;
    }
    case 14: {
      return $thiz.T16__f__15;
      break;
    }
    case 15: {
      return $thiz.T16__f__16;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 15)"));
    }
  }
}
export { $f_s_Product16__productElement__I__O as $f_s_Product16__productElement__I__O };
function $f_s_Product17__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T17__f__1;
      break;
    }
    case 1: {
      return $thiz.T17__f__2;
      break;
    }
    case 2: {
      return $thiz.T17__f__3;
      break;
    }
    case 3: {
      return $thiz.T17__f__4;
      break;
    }
    case 4: {
      return $thiz.T17__f__5;
      break;
    }
    case 5: {
      return $thiz.T17__f__6;
      break;
    }
    case 6: {
      return $thiz.T17__f__7;
      break;
    }
    case 7: {
      return $thiz.T17__f__8;
      break;
    }
    case 8: {
      return $thiz.T17__f__9;
      break;
    }
    case 9: {
      return $thiz.T17__f__10;
      break;
    }
    case 10: {
      return $thiz.T17__f__11;
      break;
    }
    case 11: {
      return $thiz.T17__f__12;
      break;
    }
    case 12: {
      return $thiz.T17__f__13;
      break;
    }
    case 13: {
      return $thiz.T17__f__14;
      break;
    }
    case 14: {
      return $thiz.T17__f__15;
      break;
    }
    case 15: {
      return $thiz.T17__f__16;
      break;
    }
    case 16: {
      return $thiz.T17__f__17;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 16)"));
    }
  }
}
export { $f_s_Product17__productElement__I__O as $f_s_Product17__productElement__I__O };
function $f_s_Product18__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T18__f__1;
      break;
    }
    case 1: {
      return $thiz.T18__f__2;
      break;
    }
    case 2: {
      return $thiz.T18__f__3;
      break;
    }
    case 3: {
      return $thiz.T18__f__4;
      break;
    }
    case 4: {
      return $thiz.T18__f__5;
      break;
    }
    case 5: {
      return $thiz.T18__f__6;
      break;
    }
    case 6: {
      return $thiz.T18__f__7;
      break;
    }
    case 7: {
      return $thiz.T18__f__8;
      break;
    }
    case 8: {
      return $thiz.T18__f__9;
      break;
    }
    case 9: {
      return $thiz.T18__f__10;
      break;
    }
    case 10: {
      return $thiz.T18__f__11;
      break;
    }
    case 11: {
      return $thiz.T18__f__12;
      break;
    }
    case 12: {
      return $thiz.T18__f__13;
      break;
    }
    case 13: {
      return $thiz.T18__f__14;
      break;
    }
    case 14: {
      return $thiz.T18__f__15;
      break;
    }
    case 15: {
      return $thiz.T18__f__16;
      break;
    }
    case 16: {
      return $thiz.T18__f__17;
      break;
    }
    case 17: {
      return $thiz.T18__f__18;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 17)"));
    }
  }
}
export { $f_s_Product18__productElement__I__O as $f_s_Product18__productElement__I__O };
function $f_s_Product19__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T19__f__1;
      break;
    }
    case 1: {
      return $thiz.T19__f__2;
      break;
    }
    case 2: {
      return $thiz.T19__f__3;
      break;
    }
    case 3: {
      return $thiz.T19__f__4;
      break;
    }
    case 4: {
      return $thiz.T19__f__5;
      break;
    }
    case 5: {
      return $thiz.T19__f__6;
      break;
    }
    case 6: {
      return $thiz.T19__f__7;
      break;
    }
    case 7: {
      return $thiz.T19__f__8;
      break;
    }
    case 8: {
      return $thiz.T19__f__9;
      break;
    }
    case 9: {
      return $thiz.T19__f__10;
      break;
    }
    case 10: {
      return $thiz.T19__f__11;
      break;
    }
    case 11: {
      return $thiz.T19__f__12;
      break;
    }
    case 12: {
      return $thiz.T19__f__13;
      break;
    }
    case 13: {
      return $thiz.T19__f__14;
      break;
    }
    case 14: {
      return $thiz.T19__f__15;
      break;
    }
    case 15: {
      return $thiz.T19__f__16;
      break;
    }
    case 16: {
      return $thiz.T19__f__17;
      break;
    }
    case 17: {
      return $thiz.T19__f__18;
      break;
    }
    case 18: {
      return $thiz.T19__f__19;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 18)"));
    }
  }
}
export { $f_s_Product19__productElement__I__O as $f_s_Product19__productElement__I__O };
function $f_s_Product2__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz._1__O();
      break;
    }
    case 1: {
      return $thiz._2__O();
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 1)"));
    }
  }
}
export { $f_s_Product2__productElement__I__O as $f_s_Product2__productElement__I__O };
function $f_s_Product20__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T20__f__1;
      break;
    }
    case 1: {
      return $thiz.T20__f__2;
      break;
    }
    case 2: {
      return $thiz.T20__f__3;
      break;
    }
    case 3: {
      return $thiz.T20__f__4;
      break;
    }
    case 4: {
      return $thiz.T20__f__5;
      break;
    }
    case 5: {
      return $thiz.T20__f__6;
      break;
    }
    case 6: {
      return $thiz.T20__f__7;
      break;
    }
    case 7: {
      return $thiz.T20__f__8;
      break;
    }
    case 8: {
      return $thiz.T20__f__9;
      break;
    }
    case 9: {
      return $thiz.T20__f__10;
      break;
    }
    case 10: {
      return $thiz.T20__f__11;
      break;
    }
    case 11: {
      return $thiz.T20__f__12;
      break;
    }
    case 12: {
      return $thiz.T20__f__13;
      break;
    }
    case 13: {
      return $thiz.T20__f__14;
      break;
    }
    case 14: {
      return $thiz.T20__f__15;
      break;
    }
    case 15: {
      return $thiz.T20__f__16;
      break;
    }
    case 16: {
      return $thiz.T20__f__17;
      break;
    }
    case 17: {
      return $thiz.T20__f__18;
      break;
    }
    case 18: {
      return $thiz.T20__f__19;
      break;
    }
    case 19: {
      return $thiz.T20__f__20;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 19)"));
    }
  }
}
export { $f_s_Product20__productElement__I__O as $f_s_Product20__productElement__I__O };
function $f_s_Product21__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T21__f__1;
      break;
    }
    case 1: {
      return $thiz.T21__f__2;
      break;
    }
    case 2: {
      return $thiz.T21__f__3;
      break;
    }
    case 3: {
      return $thiz.T21__f__4;
      break;
    }
    case 4: {
      return $thiz.T21__f__5;
      break;
    }
    case 5: {
      return $thiz.T21__f__6;
      break;
    }
    case 6: {
      return $thiz.T21__f__7;
      break;
    }
    case 7: {
      return $thiz.T21__f__8;
      break;
    }
    case 8: {
      return $thiz.T21__f__9;
      break;
    }
    case 9: {
      return $thiz.T21__f__10;
      break;
    }
    case 10: {
      return $thiz.T21__f__11;
      break;
    }
    case 11: {
      return $thiz.T21__f__12;
      break;
    }
    case 12: {
      return $thiz.T21__f__13;
      break;
    }
    case 13: {
      return $thiz.T21__f__14;
      break;
    }
    case 14: {
      return $thiz.T21__f__15;
      break;
    }
    case 15: {
      return $thiz.T21__f__16;
      break;
    }
    case 16: {
      return $thiz.T21__f__17;
      break;
    }
    case 17: {
      return $thiz.T21__f__18;
      break;
    }
    case 18: {
      return $thiz.T21__f__19;
      break;
    }
    case 19: {
      return $thiz.T21__f__20;
      break;
    }
    case 20: {
      return $thiz.T21__f__21;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 20)"));
    }
  }
}
export { $f_s_Product21__productElement__I__O as $f_s_Product21__productElement__I__O };
function $f_s_Product22__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T22__f__1;
      break;
    }
    case 1: {
      return $thiz.T22__f__2;
      break;
    }
    case 2: {
      return $thiz.T22__f__3;
      break;
    }
    case 3: {
      return $thiz.T22__f__4;
      break;
    }
    case 4: {
      return $thiz.T22__f__5;
      break;
    }
    case 5: {
      return $thiz.T22__f__6;
      break;
    }
    case 6: {
      return $thiz.T22__f__7;
      break;
    }
    case 7: {
      return $thiz.T22__f__8;
      break;
    }
    case 8: {
      return $thiz.T22__f__9;
      break;
    }
    case 9: {
      return $thiz.T22__f__10;
      break;
    }
    case 10: {
      return $thiz.T22__f__11;
      break;
    }
    case 11: {
      return $thiz.T22__f__12;
      break;
    }
    case 12: {
      return $thiz.T22__f__13;
      break;
    }
    case 13: {
      return $thiz.T22__f__14;
      break;
    }
    case 14: {
      return $thiz.T22__f__15;
      break;
    }
    case 15: {
      return $thiz.T22__f__16;
      break;
    }
    case 16: {
      return $thiz.T22__f__17;
      break;
    }
    case 17: {
      return $thiz.T22__f__18;
      break;
    }
    case 18: {
      return $thiz.T22__f__19;
      break;
    }
    case 19: {
      return $thiz.T22__f__20;
      break;
    }
    case 20: {
      return $thiz.T22__f__21;
      break;
    }
    case 21: {
      return $thiz.T22__f__22;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 21)"));
    }
  }
}
export { $f_s_Product22__productElement__I__O as $f_s_Product22__productElement__I__O };
function $f_s_Product3__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T3__f__1;
      break;
    }
    case 1: {
      return $thiz.T3__f__2;
      break;
    }
    case 2: {
      return $thiz.T3__f__3;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 2)"));
    }
  }
}
export { $f_s_Product3__productElement__I__O as $f_s_Product3__productElement__I__O };
function $f_s_Product4__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T4__f__1;
      break;
    }
    case 1: {
      return $thiz.T4__f__2;
      break;
    }
    case 2: {
      return $thiz.T4__f__3;
      break;
    }
    case 3: {
      return $thiz.T4__f__4;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 3)"));
    }
  }
}
export { $f_s_Product4__productElement__I__O as $f_s_Product4__productElement__I__O };
function $f_s_Product5__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T5__f__1;
      break;
    }
    case 1: {
      return $thiz.T5__f__2;
      break;
    }
    case 2: {
      return $thiz.T5__f__3;
      break;
    }
    case 3: {
      return $thiz.T5__f__4;
      break;
    }
    case 4: {
      return $thiz.T5__f__5;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 4)"));
    }
  }
}
export { $f_s_Product5__productElement__I__O as $f_s_Product5__productElement__I__O };
function $f_s_Product6__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T6__f__1;
      break;
    }
    case 1: {
      return $thiz.T6__f__2;
      break;
    }
    case 2: {
      return $thiz.T6__f__3;
      break;
    }
    case 3: {
      return $thiz.T6__f__4;
      break;
    }
    case 4: {
      return $thiz.T6__f__5;
      break;
    }
    case 5: {
      return $thiz.T6__f__6;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 5)"));
    }
  }
}
export { $f_s_Product6__productElement__I__O as $f_s_Product6__productElement__I__O };
function $f_s_Product7__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T7__f__1;
      break;
    }
    case 1: {
      return $thiz.T7__f__2;
      break;
    }
    case 2: {
      return $thiz.T7__f__3;
      break;
    }
    case 3: {
      return $thiz.T7__f__4;
      break;
    }
    case 4: {
      return $thiz.T7__f__5;
      break;
    }
    case 5: {
      return $thiz.T7__f__6;
      break;
    }
    case 6: {
      return $thiz.T7__f__7;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 6)"));
    }
  }
}
export { $f_s_Product7__productElement__I__O as $f_s_Product7__productElement__I__O };
function $f_s_Product8__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T8__f__1;
      break;
    }
    case 1: {
      return $thiz.T8__f__2;
      break;
    }
    case 2: {
      return $thiz.T8__f__3;
      break;
    }
    case 3: {
      return $thiz.T8__f__4;
      break;
    }
    case 4: {
      return $thiz.T8__f__5;
      break;
    }
    case 5: {
      return $thiz.T8__f__6;
      break;
    }
    case 6: {
      return $thiz.T8__f__7;
      break;
    }
    case 7: {
      return $thiz.T8__f__8;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 7)"));
    }
  }
}
export { $f_s_Product8__productElement__I__O as $f_s_Product8__productElement__I__O };
function $f_s_Product9__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.T9__f__1;
      break;
    }
    case 1: {
      return $thiz.T9__f__2;
      break;
    }
    case 2: {
      return $thiz.T9__f__3;
      break;
    }
    case 3: {
      return $thiz.T9__f__4;
      break;
    }
    case 4: {
      return $thiz.T9__f__5;
      break;
    }
    case 5: {
      return $thiz.T9__f__6;
      break;
    }
    case 6: {
      return $thiz.T9__f__7;
      break;
    }
    case 7: {
      return $thiz.T9__f__8;
      break;
    }
    case 8: {
      return $thiz.T9__f__9;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 8)"));
    }
  }
}
export { $f_s_Product9__productElement__I__O as $f_s_Product9__productElement__I__O };
function $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__($thiz, delegate) {
  $thiz.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = delegate;
  return $thiz;
}
export { $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__ as $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__ };
/** @constructor */
function $c_sc_ClassTagIterableFactory$AnyIterableDelegate() {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null;
}
export { $c_sc_ClassTagIterableFactory$AnyIterableDelegate as $c_sc_ClassTagIterableFactory$AnyIterableDelegate };
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = new $h_O();
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.constructor = $c_sc_ClassTagIterableFactory$AnyIterableDelegate;
/** @constructor */
function $h_sc_ClassTagIterableFactory$AnyIterableDelegate() {
}
export { $h_sc_ClassTagIterableFactory$AnyIterableDelegate as $h_sc_ClassTagIterableFactory$AnyIterableDelegate };
$h_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype = $c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype;
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.empty__O = (function() {
  return this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate.empty__O__O($m_s_reflect_ManifestFactory$AnyManifest$());
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate.from__sc_IterableOnce__O__O(it, $m_s_reflect_ManifestFactory$AnyManifest$());
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.newBuilder__scm_Builder = (function() {
  var this$1 = this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate;
  var x0 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$1.newBuilder__s_reflect_ClassTag__scm_Builder(x0);
});
$c_sc_ClassTagIterableFactory$AnyIterableDelegate.prototype.apply__sci_Seq__O = (function(elems) {
  var this$1 = this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate;
  var evidence$7 = $m_s_reflect_ManifestFactory$AnyManifest$();
  return this$1.from__sc_IterableOnce__O__O(elems, evidence$7);
});
function $ct_sc_IterableFactory$Delegate__sc_IterableFactory__($thiz, delegate) {
  $thiz.sc_IterableFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
export { $ct_sc_IterableFactory$Delegate__sc_IterableFactory__ as $ct_sc_IterableFactory$Delegate__sc_IterableFactory__ };
/** @constructor */
function $c_sc_IterableFactory$Delegate() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
}
export { $c_sc_IterableFactory$Delegate as $c_sc_IterableFactory$Delegate };
$c_sc_IterableFactory$Delegate.prototype = new $h_O();
$c_sc_IterableFactory$Delegate.prototype.constructor = $c_sc_IterableFactory$Delegate;
/** @constructor */
function $h_sc_IterableFactory$Delegate() {
}
export { $h_sc_IterableFactory$Delegate as $h_sc_IterableFactory$Delegate };
$h_sc_IterableFactory$Delegate.prototype = $c_sc_IterableFactory$Delegate.prototype;
$c_sc_IterableFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return this.sc_IterableFactory$Delegate__f_delegate.apply__sci_Seq__O(elems);
});
$c_sc_IterableFactory$Delegate.prototype.empty__O = (function() {
  return this.sc_IterableFactory$Delegate__f_delegate.empty__O();
});
$c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.sc_IterableFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it);
});
$c_sc_IterableFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_IterableFactory$Delegate__f_delegate.newBuilder__scm_Builder();
});
/** @constructor */
function $c_sc_IterableOnceOps$$anon$1(outer) {
}
export { $c_sc_IterableOnceOps$$anon$1 as $c_sc_IterableOnceOps$$anon$1 };
$c_sc_IterableOnceOps$$anon$1.prototype = new $h_sr_AbstractFunction1();
$c_sc_IterableOnceOps$$anon$1.prototype.constructor = $c_sc_IterableOnceOps$$anon$1;
/** @constructor */
function $h_sc_IterableOnceOps$$anon$1() {
}
export { $h_sc_IterableOnceOps$$anon$1 as $h_sc_IterableOnceOps$$anon$1 };
$h_sc_IterableOnceOps$$anon$1.prototype = $c_sc_IterableOnceOps$$anon$1.prototype;
$c_sc_IterableOnceOps$$anon$1.prototype.apply__O__O = (function(v1) {
  return this;
});
var $d_sc_IterableOnceOps$$anon$1 = new $TypeData().initClass($c_sc_IterableOnceOps$$anon$1, "scala.collection.IterableOnceOps$$anon$1", ({
  sc_IterableOnceOps$$anon$1: 1,
  sr_AbstractFunction1: 1,
  F1: 1
}));
export { $d_sc_IterableOnceOps$$anon$1 as $d_sc_IterableOnceOps$$anon$1 };
/** @constructor */
function $c_sc_IterableOnceOps$Maximized(outer, descriptor, f, cmp) {
  this.sc_IterableOnceOps$Maximized__f_descriptor = null;
  this.sc_IterableOnceOps$Maximized__f_f = null;
  this.sc_IterableOnceOps$Maximized__f_cmp = null;
  this.sc_IterableOnceOps$Maximized__f_maxElem = null;
  this.sc_IterableOnceOps$Maximized__f_maxF = null;
  this.sc_IterableOnceOps$Maximized__f_nonEmpty = false;
  this.sc_IterableOnceOps$Maximized__f_descriptor = descriptor;
  this.sc_IterableOnceOps$Maximized__f_f = f;
  this.sc_IterableOnceOps$Maximized__f_cmp = cmp;
  this.sc_IterableOnceOps$Maximized__f_maxElem = null;
  this.sc_IterableOnceOps$Maximized__f_maxF = null;
  this.sc_IterableOnceOps$Maximized__f_nonEmpty = false;
}
export { $c_sc_IterableOnceOps$Maximized as $c_sc_IterableOnceOps$Maximized };
$c_sc_IterableOnceOps$Maximized.prototype = new $h_sr_AbstractFunction2();
$c_sc_IterableOnceOps$Maximized.prototype.constructor = $c_sc_IterableOnceOps$Maximized;
/** @constructor */
function $h_sc_IterableOnceOps$Maximized() {
}
export { $h_sc_IterableOnceOps$Maximized as $h_sc_IterableOnceOps$Maximized };
$h_sc_IterableOnceOps$Maximized.prototype = $c_sc_IterableOnceOps$Maximized.prototype;
$c_sc_IterableOnceOps$Maximized.prototype.result__O = (function() {
  if (this.sc_IterableOnceOps$Maximized__f_nonEmpty) {
    return this.sc_IterableOnceOps$Maximized__f_maxElem;
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), ("empty." + this.sc_IterableOnceOps$Maximized__f_descriptor));
  }
});
$c_sc_IterableOnceOps$Maximized.prototype.apply__sc_IterableOnceOps$Maximized__O__sc_IterableOnceOps$Maximized = (function(m, a) {
  if (m.sc_IterableOnceOps$Maximized__f_nonEmpty) {
    var fa = this.sc_IterableOnceOps$Maximized__f_f.apply__O__O(a);
    if ((!(!this.sc_IterableOnceOps$Maximized__f_cmp.apply__O__O__O(fa, this.sc_IterableOnceOps$Maximized__f_maxF)))) {
      this.sc_IterableOnceOps$Maximized__f_maxF = fa;
      this.sc_IterableOnceOps$Maximized__f_maxElem = a;
    }
    return m;
  } else {
    m.sc_IterableOnceOps$Maximized__f_nonEmpty = true;
    m.sc_IterableOnceOps$Maximized__f_maxElem = a;
    m.sc_IterableOnceOps$Maximized__f_maxF = this.sc_IterableOnceOps$Maximized__f_f.apply__O__O(a);
    return m;
  }
});
$c_sc_IterableOnceOps$Maximized.prototype.apply__O__O__O = (function(v1, v2) {
  return this.apply__sc_IterableOnceOps$Maximized__O__sc_IterableOnceOps$Maximized(v1, v2);
});
var $d_sc_IterableOnceOps$Maximized = new $TypeData().initClass($c_sc_IterableOnceOps$Maximized, "scala.collection.IterableOnceOps$Maximized", ({
  sc_IterableOnceOps$Maximized: 1,
  sr_AbstractFunction2: 1,
  F2: 1
}));
export { $d_sc_IterableOnceOps$Maximized as $d_sc_IterableOnceOps$Maximized };
function $f_sc_IterableOps__headOption__s_Option($thiz) {
  var it = $thiz.iterator__sc_Iterator();
  return (it.hasNext__Z() ? new $c_s_Some(it.next__O()) : $m_s_None$());
}
export { $f_sc_IterableOps__headOption__s_Option as $f_sc_IterableOps__headOption__s_Option };
function $f_sc_IterableOps__last__O($thiz) {
  var it = $thiz.iterator__sc_Iterator();
  var lst = it.next__O();
  while (it.hasNext__Z()) {
    lst = it.next__O();
  }
  return lst;
}
export { $f_sc_IterableOps__last__O as $f_sc_IterableOps__last__O };
function $f_sc_IterableOps__lastOption__s_Option($thiz) {
  return ($thiz.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($thiz.last__O()));
}
export { $f_sc_IterableOps__lastOption__s_Option as $f_sc_IterableOps__lastOption__s_Option };
function $f_sc_IterableOps__sizeCompare__I__I($thiz, otherSize) {
  if ((otherSize < 0)) {
    return 1;
  } else {
    var known = $thiz.knownSize__I();
    if ((known >= 0)) {
      return ((known === otherSize) ? 0 : ((known < otherSize) ? (-1) : 1));
    } else {
      var i = 0;
      var it = $thiz.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        if ((i === otherSize)) {
          return 1;
        }
        it.next__O();
        i = ((1 + i) | 0);
      }
      return ((i - otherSize) | 0);
    }
  }
}
export { $f_sc_IterableOps__sizeCompare__I__I as $f_sc_IterableOps__sizeCompare__I__I };
function $f_sc_IterableOps__filter__F1__O($thiz, pred) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$Filter($thiz, pred, false));
}
export { $f_sc_IterableOps__filter__F1__O as $f_sc_IterableOps__filter__F1__O };
function $f_sc_IterableOps__filterNot__F1__O($thiz, pred) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$Filter($thiz, pred, true));
}
export { $f_sc_IterableOps__filterNot__F1__O as $f_sc_IterableOps__filterNot__F1__O };
function $f_sc_IterableOps__partition__F1__T2($thiz, p) {
  var first = new $c_sc_View$Filter($thiz, p, false);
  var second = new $c_sc_View$Filter($thiz, p, true);
  return $ct_T2__O__O__(new $c_T2(), $thiz.fromSpecific__sc_IterableOnce__O(first), $thiz.fromSpecific__sc_IterableOnce__O(second));
}
export { $f_sc_IterableOps__partition__F1__T2 as $f_sc_IterableOps__partition__F1__T2 };
function $f_sc_IterableOps__splitAt__I__T2($thiz, n) {
  return $ct_T2__O__O__(new $c_T2(), $thiz.take__I__O(n), $thiz.drop__I__O(n));
}
export { $f_sc_IterableOps__splitAt__I__T2 as $f_sc_IterableOps__splitAt__I__T2 };
function $f_sc_IterableOps__take__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Take__sc_IterableOps__I__(new $c_sc_View$Take(), $thiz, n));
}
export { $f_sc_IterableOps__take__I__O as $f_sc_IterableOps__take__I__O };
function $f_sc_IterableOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$Drop__sc_IterableOps__I__(new $c_sc_View$Drop(), $thiz, n));
}
export { $f_sc_IterableOps__drop__I__O as $f_sc_IterableOps__drop__I__O };
function $f_sc_IterableOps__dropRight__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_View$DropRight__sc_IterableOps__I__(new $c_sc_View$DropRight(), $thiz, n));
}
export { $f_sc_IterableOps__dropRight__I__O as $f_sc_IterableOps__dropRight__I__O };
function $f_sc_IterableOps__tail__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  return $thiz.drop__I__O(1);
}
export { $f_sc_IterableOps__tail__O as $f_sc_IterableOps__tail__O };
function $f_sc_IterableOps__init__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  return $thiz.dropRight__I__O(1);
}
export { $f_sc_IterableOps__init__O as $f_sc_IterableOps__init__O };
function $f_sc_IterableOps__map__F1__O($thiz, f) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f));
}
export { $f_sc_IterableOps__map__F1__O as $f_sc_IterableOps__map__F1__O };
function $f_sc_IterableOps__flatMap__F1__O($thiz, f) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(new $c_sc_View$FlatMap($thiz, f));
}
export { $f_sc_IterableOps__flatMap__F1__O as $f_sc_IterableOps__flatMap__F1__O };
function $f_sc_IterableOps__collect__s_PartialFunction__O($thiz, pf) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(new $c_sc_View$Collect($thiz, pf));
}
export { $f_sc_IterableOps__collect__s_PartialFunction__O as $f_sc_IterableOps__collect__s_PartialFunction__O };
function $f_sc_IterableOps__concat__sc_IterableOnce__O($thiz, suffix) {
  var $x_2 = $thiz.iterableFactory__sc_IterableFactory();
  if ($is_sc_Iterable(suffix)) {
    var $x_1 = new $c_sc_View$Concat($thiz, suffix);
  } else {
    var this$1 = $thiz.iterator__sc_Iterator();
    var xs = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => suffix.iterator__sc_Iterator()));
    var $x_1 = this$1.concat__F0__sc_Iterator(xs);
  }
  return $x_2.from__sc_IterableOnce__O($x_1);
}
export { $f_sc_IterableOps__concat__sc_IterableOnce__O as $f_sc_IterableOps__concat__sc_IterableOnce__O };
function $f_sc_IterableOps__zipWithIndex__O($thiz) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(new $c_sc_View$ZipWithIndex($thiz));
}
export { $f_sc_IterableOps__zipWithIndex__O as $f_sc_IterableOps__zipWithIndex__O };
function $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__($thiz, self, p) {
  $thiz.sc_IterableOps$WithFilter__f_self = self;
  $thiz.sc_IterableOps$WithFilter__f_p = p;
  return $thiz;
}
export { $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__ as $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__ };
/** @constructor */
function $c_sc_IterableOps$WithFilter() {
  this.sc_IterableOps$WithFilter__f_self = null;
  this.sc_IterableOps$WithFilter__f_p = null;
}
export { $c_sc_IterableOps$WithFilter as $c_sc_IterableOps$WithFilter };
$c_sc_IterableOps$WithFilter.prototype = new $h_sc_WithFilter();
$c_sc_IterableOps$WithFilter.prototype.constructor = $c_sc_IterableOps$WithFilter;
/** @constructor */
function $h_sc_IterableOps$WithFilter() {
}
export { $h_sc_IterableOps$WithFilter as $h_sc_IterableOps$WithFilter };
$h_sc_IterableOps$WithFilter.prototype = $c_sc_IterableOps$WithFilter.prototype;
$c_sc_IterableOps$WithFilter.prototype.filtered__sc_Iterable = (function() {
  return new $c_sc_View$Filter(this.sc_IterableOps$WithFilter__f_self, this.sc_IterableOps$WithFilter__f_p, false);
});
$c_sc_IterableOps$WithFilter.prototype.foreach__F1__V = (function(f) {
  this.filtered__sc_Iterable().foreach__F1__V(f);
});
var $d_sc_IterableOps$WithFilter = new $TypeData().initClass($c_sc_IterableOps$WithFilter, "scala.collection.IterableOps$WithFilter", ({
  sc_IterableOps$WithFilter: 1,
  sc_WithFilter: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_IterableOps$WithFilter as $d_sc_IterableOps$WithFilter };
function $f_sc_Iterator__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var dropped = $thiz.drop__I__sc_Iterator(from);
  while (dropped.hasNext__Z()) {
    if ((!(!p.apply__O__O(dropped.next__O())))) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
}
export { $f_sc_Iterator__indexWhere__F1__I__I as $f_sc_Iterator__indexWhere__F1__I__I };
function $f_sc_Iterator__distinct__sc_Iterator($thiz) {
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => x$2$2));
  return new $c_sc_Iterator$$anon$8($thiz, f);
}
export { $f_sc_Iterator__distinct__sc_Iterator as $f_sc_Iterator__distinct__sc_Iterator };
function $f_sc_Iterator__concat__F0__sc_Iterator($thiz, xs) {
  return new $c_sc_Iterator$ConcatIterator($thiz).concat__F0__sc_Iterator(xs);
}
export { $f_sc_Iterator__concat__F0__sc_Iterator as $f_sc_Iterator__concat__F0__sc_Iterator };
function $f_sc_Iterator__take__I__sc_Iterator($thiz, n) {
  return $thiz.sliceIterator__I__I__sc_Iterator(0, ((n > 0) ? n : 0));
}
export { $f_sc_Iterator__take__I__sc_Iterator as $f_sc_Iterator__take__I__sc_Iterator };
function $f_sc_Iterator__sliceIterator__I__I__sc_Iterator($thiz, from, until) {
  var lo = ((from > 0) ? from : 0);
  var rest = ((until < 0) ? (-1) : ((until <= lo) ? 0 : ((until - lo) | 0)));
  return ((rest === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_Iterator$SliceIterator($thiz, lo, rest));
}
export { $f_sc_Iterator__sliceIterator__I__I__sc_Iterator as $f_sc_Iterator__sliceIterator__I__I__sc_Iterator };
function $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz, that) {
  var those = that.iterator__sc_Iterator();
  while ($thiz.hasNext__Z()) {
    if ((!those.hasNext__Z())) {
      return false;
    }
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z($thiz.next__O(), those.next__O()))) {
      return false;
    }
  }
  return (!those.hasNext__Z());
}
export { $f_sc_Iterator__sameElements__sc_IterableOnce__Z as $f_sc_Iterator__sameElements__sc_IterableOnce__Z };
function $is_sc_Iterator(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterator)));
}
export { $is_sc_Iterator as $is_sc_Iterator };
function $isArrayOf_sc_Iterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator)));
}
export { $isArrayOf_sc_Iterator as $isArrayOf_sc_Iterator };
/** @constructor */
function $c_sc_Iterator$() {
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = null;
  $n_sc_Iterator$ = this;
  this.sc_Iterator$__f_scala$collection$Iterator$$_empty = new $c_sc_Iterator$$anon$19();
}
export { $c_sc_Iterator$ as $c_sc_Iterator$ };
$c_sc_Iterator$.prototype = new $h_O();
$c_sc_Iterator$.prototype.constructor = $c_sc_Iterator$;
/** @constructor */
function $h_sc_Iterator$() {
}
export { $h_sc_Iterator$ as $h_sc_Iterator$ };
$h_sc_Iterator$.prototype = $c_sc_Iterator$.prototype;
$c_sc_Iterator$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sc_Iterator$$anon$21();
});
$c_sc_Iterator$.prototype.apply__sci_Seq__O = (function(elems) {
  return elems.iterator__sc_Iterator();
});
$c_sc_Iterator$.prototype.empty__O = (function() {
  return this.sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sc_Iterator$.prototype.from__sc_IterableOnce__O = (function(source) {
  return source.iterator__sc_Iterator();
});
var $d_sc_Iterator$ = new $TypeData().initClass($c_sc_Iterator$, "scala.collection.Iterator$", ({
  sc_Iterator$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_Iterator$ as $d_sc_Iterator$ };
var $n_sc_Iterator$;
function $m_sc_Iterator$() {
  if ((!$n_sc_Iterator$)) {
    $n_sc_Iterator$ = new $c_sc_Iterator$();
  }
  return $n_sc_Iterator$;
}
export { $m_sc_Iterator$ as $m_sc_Iterator$ };
function $ct_sc_MapFactory$Delegate__sc_MapFactory__($thiz, delegate) {
  $thiz.sc_MapFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
export { $ct_sc_MapFactory$Delegate__sc_MapFactory__ as $ct_sc_MapFactory$Delegate__sc_MapFactory__ };
/** @constructor */
function $c_sc_MapFactory$Delegate() {
  this.sc_MapFactory$Delegate__f_delegate = null;
}
export { $c_sc_MapFactory$Delegate as $c_sc_MapFactory$Delegate };
$c_sc_MapFactory$Delegate.prototype = new $h_O();
$c_sc_MapFactory$Delegate.prototype.constructor = $c_sc_MapFactory$Delegate;
/** @constructor */
function $h_sc_MapFactory$Delegate() {
}
export { $h_sc_MapFactory$Delegate as $h_sc_MapFactory$Delegate };
$h_sc_MapFactory$Delegate.prototype = $c_sc_MapFactory$Delegate.prototype;
$c_sc_MapFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return this.sc_MapFactory$Delegate__f_delegate.apply__sci_Seq__O(elems);
});
$c_sc_MapFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.sc_MapFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it);
});
$c_sc_MapFactory$Delegate.prototype.empty__O = (function() {
  return this.sc_MapFactory$Delegate__f_delegate.empty__O();
});
$c_sc_MapFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_MapFactory$Delegate__f_delegate.newBuilder__scm_Builder();
});
/** @constructor */
function $c_sc_MapFactory$ToFactory(factory) {
  this.sc_MapFactory$ToFactory__f_factory = null;
  this.sc_MapFactory$ToFactory__f_factory = factory;
}
export { $c_sc_MapFactory$ToFactory as $c_sc_MapFactory$ToFactory };
$c_sc_MapFactory$ToFactory.prototype = new $h_O();
$c_sc_MapFactory$ToFactory.prototype.constructor = $c_sc_MapFactory$ToFactory;
/** @constructor */
function $h_sc_MapFactory$ToFactory() {
}
export { $h_sc_MapFactory$ToFactory as $h_sc_MapFactory$ToFactory };
$h_sc_MapFactory$ToFactory.prototype = $c_sc_MapFactory$ToFactory.prototype;
$c_sc_MapFactory$ToFactory.prototype.fromSpecific__sc_IterableOnce__O = (function(it) {
  return this.sc_MapFactory$ToFactory__f_factory.from__sc_IterableOnce__O(it);
});
$c_sc_MapFactory$ToFactory.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_MapFactory$ToFactory__f_factory.newBuilder__scm_Builder();
});
var $d_sc_MapFactory$ToFactory = new $TypeData().initClass($c_sc_MapFactory$ToFactory, "scala.collection.MapFactory$ToFactory", ({
  sc_MapFactory$ToFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_MapFactory$ToFactory as $d_sc_MapFactory$ToFactory };
/** @constructor */
function $c_sc_View$() {
}
export { $c_sc_View$ as $c_sc_View$ };
$c_sc_View$.prototype = new $h_O();
$c_sc_View$.prototype.constructor = $c_sc_View$;
/** @constructor */
function $h_sc_View$() {
}
export { $h_sc_View$ as $h_sc_View$ };
$h_sc_View$.prototype = $c_sc_View$.prototype;
$c_sc_View$.prototype.from__sc_IterableOnce__sc_View = (function(it) {
  if ($is_sc_View(it)) {
    return it;
  } else if ($is_sc_Iterable(it)) {
    var it$1 = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((x3) => (() => x3.iterator__sc_Iterator()))(it));
    return new $c_sc_View$$anon$1(it$1);
  } else {
    var this$2 = $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(it);
    return $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), this$2);
  }
});
$c_sc_View$.prototype.newBuilder__scm_Builder = (function() {
  $m_scm_ArrayBuffer$();
  var this$2 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((it$2$2) => $m_sc_View$().from__sc_IterableOnce__sc_View(it$2$2)));
  return new $c_scm_Builder$$anon$1(this$2, f);
});
$c_sc_View$.prototype.dropRightIterator__sc_Iterator__I__sc_Iterator = (function(it, n) {
  if ((n <= 0)) {
    return it;
  } else {
    var k = it.knownSize__I();
    return ((k >= 0) ? it.take__I__sc_Iterator(((k - n) | 0)) : new $c_sc_View$DropRightIterator(it, n));
  }
});
$c_sc_View$.prototype.apply__sci_Seq__O = (function(elems) {
  return new $c_sc_View$Elems(elems);
});
$c_sc_View$.prototype.empty__O = (function() {
  return $m_sc_View$Empty$();
});
$c_sc_View$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_View(source);
});
var $d_sc_View$ = new $TypeData().initClass($c_sc_View$, "scala.collection.View$", ({
  sc_View$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$ as $d_sc_View$ };
var $n_sc_View$;
function $m_sc_View$() {
  if ((!$n_sc_View$)) {
    $n_sc_View$ = new $c_sc_View$();
  }
  return $n_sc_View$;
}
export { $m_sc_View$ as $m_sc_View$ };
/** @constructor */
function $c_sci_BitmapIndexedMapNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedMapNode__f_dataMap = 0;
  this.sci_BitmapIndexedMapNode__f_nodeMap = 0;
  this.sci_BitmapIndexedMapNode__f_content = null;
  this.sci_BitmapIndexedMapNode__f_originalHashes = null;
  this.sci_BitmapIndexedMapNode__f_size = 0;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedMapNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedMapNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedMapNode__f_content = content;
  this.sci_BitmapIndexedMapNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedMapNode__f_size = size;
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode;
}
export { $c_sci_BitmapIndexedMapNode as $c_sci_BitmapIndexedMapNode };
$c_sci_BitmapIndexedMapNode.prototype = new $h_sci_MapNode();
$c_sci_BitmapIndexedMapNode.prototype.constructor = $c_sci_BitmapIndexedMapNode;
/** @constructor */
function $h_sci_BitmapIndexedMapNode() {
}
export { $h_sci_BitmapIndexedMapNode as $h_sci_BitmapIndexedMapNode };
$h_sci_BitmapIndexedMapNode.prototype = $c_sci_BitmapIndexedMapNode.prototype;
$c_sci_BitmapIndexedMapNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_size;
});
$c_sci_BitmapIndexedMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode;
});
$c_sci_BitmapIndexedMapNode.prototype.getKey__I__O = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_content.u[(index << 1)];
});
$c_sci_BitmapIndexedMapNode.prototype.getValue__I__O = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_content.u[((1 + (index << 1)) | 0)];
});
$c_sci_BitmapIndexedMapNode.prototype.getPayload__I__T2 = (function(index) {
  return $ct_T2__O__O__(new $c_T2(), this.sci_BitmapIndexedMapNode__f_content.u[(index << 1)], this.sci_BitmapIndexedMapNode__f_content.u[((1 + (index << 1)) | 0)]);
});
$c_sci_BitmapIndexedMapNode.prototype.getHash__I__I = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_originalHashes.u[index];
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  return this.sci_BitmapIndexedMapNode__f_content.u[(((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - index) | 0)];
});
$c_sci_BitmapIndexedMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index))) {
      return this.getValue__I__O(index);
    } else {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    return this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos)).apply__O__I__I__I__O(key, originalHash, keyHash, ((5 + shift) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_BitmapIndexedMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? new $c_s_Some(this.getValue__I__O(index)) : $m_s_None$());
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_MapNode(index$2).get__O__I__I__I__s_Option(key, originalHash, keyHash, ((5 + shift) | 0));
  } else {
    return $m_s_None$();
  }
});
$c_sci_BitmapIndexedMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, keyHash, shift, f) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, key0) ? this.getValue__I__O(index) : f.apply__O());
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_MapNode(index$2).getOrElse__O__I__I__I__F0__O(key, originalHash, keyHash, ((5 + shift) | 0), f);
  } else {
    return f.apply__O();
  }
});
$c_sci_BitmapIndexedMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    return ((this.sci_BitmapIndexedMapNode__f_originalHashes.u[index] === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.getKey__I__O(index)));
  } else {
    return (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0) && this.getNode__I__sci_MapNode($m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos)).containsKey__O__I__I__I__Z(key, originalHash, keyHash, ((5 + shift) | 0)));
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode = (function(key, value, originalHash, keyHash, shift, replaceValue) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      if (replaceValue) {
        var value0 = this.getValue__I__O(index);
        return ((Object.is(key0, key) && Object.is(value0, value)) ? this : this.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode(bitpos, key, value));
      } else {
        return this;
      }
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      return this.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew);
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew$2 = subNode.updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), replaceValue);
    return ((subNodeNew$2 === subNode) ? this : this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew$2));
  } else {
    return this.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode(bitpos, key, originalHash, keyHash, value);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.updateWithShallowMutations__O__O__I__I__I__I__I = (function(key, value, originalHash, keyHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    var key0UnimprovedHash = this.getHash__I__I(index);
    if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
      var value0 = this.getValue__I__O(index);
      if ((!(Object.is(key0, key) && Object.is(value0, value)))) {
        var dataIx = this.dataIndex__I__I(bitpos);
        var idx = (dataIx << 1);
        this.sci_BitmapIndexedMapNode__f_content.u[((1 + idx) | 0)] = value;
      }
      return shallowlyMutableNodeMap;
    } else {
      var value0$2 = this.getValue__I__O(index);
      var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0$2, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
      this.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew);
      return (shallowlyMutableNodeMap | bitpos);
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeSize = subNode.size__I();
    var subNodeHashCode = subNode.cachedJavaKeySetHashCode__I();
    var returnMutableNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$2;
      if ((subNode instanceof $c_sci_BitmapIndexedMapNode)) {
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          subNode.updateWithShallowMutations__O__O__I__I__I__I__I(key, value, originalHash, keyHash, ((5 + shift) | 0), 0);
          var subNodeNew$2 = subNode;
          break matchEnd4;
        }
      }
      var result = subNode.updated__O__O__I__I__I__Z__sci_MapNode(key, value, originalHash, keyHash, ((5 + shift) | 0), true);
      if ((result !== subNode)) {
        returnMutableNodeMap = (returnMutableNodeMap | bitpos);
      }
      var subNodeNew$2 = result;
    }
    this.sci_BitmapIndexedMapNode__f_content.u[(((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0)] = subNodeNew$2;
    this.sci_BitmapIndexedMapNode__f_size = ((((this.sci_BitmapIndexedMapNode__f_size - subNodeSize) | 0) + subNodeNew$2.size__I()) | 0);
    this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - subNodeHashCode) | 0) + subNodeNew$2.cachedJavaKeySetHashCode__I()) | 0);
    return returnMutableNodeMap;
  } else {
    var dataIx$2 = this.dataIndex__I__I(bitpos);
    var idx$2 = (dataIx$2 << 1);
    var src = this.sci_BitmapIndexedMapNode__f_content;
    var dst = new $ac_O(((2 + src.u.length) | 0));
    src.copyTo(0, dst, 0, idx$2);
    dst.u[idx$2] = key;
    dst.u[((1 + idx$2) | 0)] = value;
    var destPos = ((2 + idx$2) | 0);
    var length = ((src.u.length - idx$2) | 0);
    src.copyTo(idx$2, dst, destPos, length);
    this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap | bitpos);
    this.sci_BitmapIndexedMapNode__f_content = dst;
    this.sci_BitmapIndexedMapNode__f_originalHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx$2, originalHash);
    this.sci_BitmapIndexedMapNode__f_size = ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0);
    this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0);
    return shallowlyMutableNodeMap;
  }
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_BitmapIndexedMapNode = (function(key, originalHash, keyHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
    var key0 = this.getKey__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(key0, key)) {
      var i = this.sci_BitmapIndexedMapNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
        var $x_1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(keyHash, 0)));
        return ((index === 0) ? new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(1), this.getValue__I__O(1)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedMapNode__f_originalHashes.u[1]])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(1))) : new $c_sci_BitmapIndexedMapNode(newDataMap, 0, new $ac_O([this.getKey__I__O(0), this.getValue__I__O(0)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedMapNode__f_originalHashes.u[0]])), 1, $m_sc_Hashing$().improve__I__I(this.getHash__I__I(0))));
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode(bitpos, keyHash);
      }
    } else {
      return this;
    }
  } else if (((this.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_MapNode(index$2);
    var subNodeNew = subNode.removed__O__I__I__I__sci_MapNode(key, originalHash, keyHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this;
    }
    var subNodeNewSize = subNodeNew.size__I();
    return ((subNodeNewSize === 1) ? ((this.sci_BitmapIndexedMapNode__f_size === subNode.size__I()) ? subNodeNew : this.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew)) : ((subNodeNewSize > 1) ? this.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, subNode, subNodeNew) : this));
  } else {
    return this;
  }
});
$c_sci_BitmapIndexedMapNode.prototype.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode = (function(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var x0 = $ct_T2__O__O__(new $c_T2(), key0, value0);
    var x1 = $ct_T2__O__O__(new $c_T2(), key1, value1);
    var array = [x0, x1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionMapNode(originalHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems));
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    var newCachedHash = ((keyHash0 + keyHash1) | 0);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key0, value0, key1, value1]), new $ac_I(new Int32Array([originalHash0, originalHash1])), 2, newCachedHash) : new $c_sci_BitmapIndexedMapNode(dataMap, 0, new $ac_O([key1, value1, key0, value0]), new $ac_I(new Int32Array([originalHash1, originalHash0])), 2, newCachedHash));
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, originalHash0, keyHash0, key1, value1, originalHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedMapNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, node.size__I(), node.cachedJavaKeySetHashCode__I());
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_nodeMap !== 0);
});
$c_sci_BitmapIndexedMapNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedMapNode__f_dataMap !== 0);
});
$c_sci_BitmapIndexedMapNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedMapNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetValue__I__O__O__sci_BitmapIndexedMapNode = (function(bitpos, newKey, newValue) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  src.copyTo(0, dst, 0, length);
  dst.u[((1 + idx) | 0)] = newValue;
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode);
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndSetNode__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  src.copyTo(0, dst, 0, length);
  dst.u[idx] = newNode;
  return new $c_sci_BitmapIndexedMapNode(this.sci_BitmapIndexedMapNode__f_dataMap, this.sci_BitmapIndexedMapNode__f_nodeMap, dst, this.sci_BitmapIndexedMapNode__f_originalHashes, ((((this.sci_BitmapIndexedMapNode__f_size - oldNode.size__I()) | 0) + newNode.size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + newNode.cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndInsertValue__I__O__I__I__O__sci_BitmapIndexedMapNode = (function(bitpos, key, originalHash, keyHash, value) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + src.u.length) | 0));
  src.copyTo(0, dst, 0, idx);
  dst.u[idx] = key;
  dst.u[((1 + idx) | 0)] = value;
  var destPos = ((2 + idx) | 0);
  var length = ((src.u.length - idx) | 0);
  src.copyTo(idx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedMapNode = (function(bitpos, keyHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-2) + src.u.length) | 0));
  src.copyTo(0, dst, 0, idx);
  var srcPos = ((2 + idx) | 0);
  var length = (((-2) + ((src.u.length - idx) | 0)) | 0);
  src.copyTo(srcPos, dst, idx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedMapNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0), ((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  src.copyTo(0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  src.copyTo(srcPos, dst, idxOld, length);
  dst.u[idxNew] = node;
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + ((src.u.length - idxNew) | 0)) | 0);
  src.copyTo(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedMapNode__f_dataMap = (this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedMapNode__f_nodeMap = (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedMapNode__f_content = dst;
  this.sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  this.sci_BitmapIndexedMapNode__f_size = (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + node.size__I()) | 0);
  this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0);
  return this;
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxOld = (dataIx << 1);
  var idxNew = (((((-2) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  src.copyTo(0, dst, 0, idxOld);
  var srcPos = ((2 + idxOld) | 0);
  var length = ((idxNew - idxOld) | 0);
  src.copyTo(srcPos, dst, idxOld, length);
  dst.u[idxNew] = node;
  var srcPos$1 = ((2 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-2) + ((src.u.length - idxNew) | 0)) | 0);
  src.copyTo(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedMapNode__f_size) | 0) + node.size__I()) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.copyAndMigrateFromNodeToInline__I__sci_MapNode__sci_MapNode__sci_BitmapIndexedMapNode = (function(bitpos, oldNode, node) {
  var idxOld = (((((-1) + this.sci_BitmapIndexedMapNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var idxNew = (dataIxNew << 1);
  var key = node.getKey__I__O(0);
  var value = node.getValue__I__O(0);
  var src = this.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  src.copyTo(0, dst, 0, idxNew);
  dst.u[idxNew] = key;
  dst.u[((1 + idxNew) | 0)] = value;
  var destPos = ((2 + idxNew) | 0);
  var length = ((idxOld - idxNew) | 0);
  src.copyTo(idxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((2 + idxOld) | 0);
  var length$1 = (((-1) + ((src.u.length - idxOld) | 0)) | 0);
  src.copyTo(srcPos, dst, destPos$1, length$1);
  var hash = node.getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedMapNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedMapNode((this.sci_BitmapIndexedMapNode__f_dataMap | bitpos), (this.sci_BitmapIndexedMapNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedMapNode__f_size - oldNode.size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + node.cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedMapNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.apply__O__O(this.getPayload__I__T2(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreach__F1__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachEntry__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.apply__O__O__O(this.getKey__I__O(i$1), this.getValue__I__O(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreachEntry__F2__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var i = 0;
  var i$1 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i$1);
  while ((i < iN)) {
    f.apply__O__O__O__O(this.getKey__I__O(i), this.getValue__I__O(i), this.getHash__I__I(i));
    i = ((1 + i) | 0);
  }
  var i$2 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_MapNode(j).foreachWithHash__F3__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    if ((this === that)) {
      return true;
    } else {
      if (((((this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode === that.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedMapNode__f_nodeMap === that.sci_BitmapIndexedMapNode__f_nodeMap)) && (this.sci_BitmapIndexedMapNode__f_dataMap === that.sci_BitmapIndexedMapNode__f_dataMap)) && (this.sci_BitmapIndexedMapNode__f_size === that.sci_BitmapIndexedMapNode__f_size))) {
        var a = this.sci_BitmapIndexedMapNode__f_originalHashes;
        var b = that.sci_BitmapIndexedMapNode__f_originalHashes;
        var $x_1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var a1 = this.sci_BitmapIndexedMapNode__f_content;
        var a2 = that.sci_BitmapIndexedMapNode__f_content;
        var length = this.sci_BitmapIndexedMapNode__f_content.u.length;
        if ((a1 === a2)) {
          return true;
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z(a1.u[i], a2.u[i]);
            i = ((1 + i) | 0);
          }
          return isEqual;
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_sci_BitmapIndexedMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_BitmapIndexedMapNode.prototype.toString__T = (function() {
  var i = $systemIdentityHashCode(this);
  return (($objectClassName(this) + "@") + (i >>> 0.0).toString(16));
});
$c_sci_BitmapIndexedMapNode.prototype.concat__sci_MapNode__I__sci_BitmapIndexedMapNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    if ((this.sci_BitmapIndexedMapNode__f_size === 0)) {
      return that;
    } else if (((that.sci_BitmapIndexedMapNode__f_size === 0) || (that === this))) {
      return this;
    } else if ((that.sci_BitmapIndexedMapNode__f_size === 1)) {
      var originalHash = that.getHash__I__I(0);
      return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(that.getKey__I__O(0), that.getValue__I__O(0), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), shift, true);
    }
    var anyChangesMadeSoFar = false;
    var allMap = (((this.sci_BitmapIndexedMapNode__f_dataMap | that.sci_BitmapIndexedMapNode__f_dataMap) | this.sci_BitmapIndexedMapNode__f_nodeMap) | that.sci_BitmapIndexedMapNode__f_nodeMap);
    var $x_1 = $m_sci_Node$();
    var i = ((~allMap) & (((-1) + allMap) | 0));
    var minimumBitPos = $x_1.bitposFrom__I__I(((32 - Math.clz32(i)) | 0));
    var maximumBitPos = $m_sci_Node$().bitposFrom__I__I(((31 - Math.clz32(allMap)) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataRightOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        if (((bitpos & that.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          var leftOriginalHash = this.getHash__I__I(leftIdx);
          if (((leftOriginalHash === that.getHash__I__I(rightIdx)) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.getKey__I__O(leftIdx), that.getKey__I__O(rightIdx)))) {
            leftDataRightDataRightOverwrites = (leftDataRightDataRightOverwrites | bitpos);
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I($m_sc_Hashing$().improve__I__I(leftOriginalHash), shift)));
          }
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & that.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos);
        } else {
          leftDataOnly = (leftDataOnly | bitpos);
        }
        leftIdx = ((1 + leftIdx) | 0);
      } else if (((bitpos & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        if (((bitpos & that.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & that.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos);
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos);
        }
      } else if (((bitpos & that.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0);
      } else if (((bitpos & that.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos);
      }
      if ((bitpos === maximumBitPos)) {
        finished = true;
      } else {
        bitpos = (bitpos << 1);
      }
    }
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataRightOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (rightDataOnly | leftDataRightDataRightOverwrites)) && (newNodeMap === rightNodeOnly))) {
      return that;
    }
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var rightNode = that.getNode__I__sci_MapNode(rightNodeIdx);
        var newNode = this.getNode__I__sci_MapNode(leftNodeIdx).concat__sci_MapNode__I__sci_MapNode(rightNode, nextShift);
        if ((rightNode !== newNode)) {
          anyChangesMadeSoFar = true;
        }
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = newNode;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        var n = that.getNode__I__sci_MapNode(rightNodeIdx);
        var leftKey = this.getKey__I__O(leftDataIdx);
        var leftValue = this.getValue__I__O(leftDataIdx);
        var leftOriginalHash$2 = this.getHash__I__I(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().improve__I__I(leftOriginalHash$2);
        var updated = n.updated__O__O__I__I__I__Z__sci_MapNode(leftKey, leftValue, leftOriginalHash$2, leftImproved, nextShift, false);
        if ((updated !== n)) {
          anyChangesMadeSoFar = true;
        }
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = updated;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + updated.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + updated.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        anyChangesMadeSoFar = true;
        var rightOriginalHash = that.getHash__I__I(rightDataIdx);
        var newNode$3 = this.getNode__I__sci_MapNode(leftNodeIdx).updated__O__O__I__I__I__Z__sci_MapNode(that.getKey__I__O(rightDataIdx), that.getValue__I__O(rightDataIdx), that.getHash__I__I(rightDataIdx), $m_sc_Hashing$().improve__I__I(rightOriginalHash), nextShift, true);
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = newNode$3;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$3.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$3.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$2 = this.sci_BitmapIndexedMapNode__f_originalHashes.u[leftDataIdx];
        newContent.u[(compressedDataIdx << 1)] = this.getKey__I__O(leftDataIdx);
        newContent.u[((1 + (compressedDataIdx << 1)) | 0)] = this.getValue__I__O(leftDataIdx);
        newOriginalHashes.u[compressedDataIdx] = originalHash$2;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$2)) | 0);
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        var originalHash$3 = that.sci_BitmapIndexedMapNode__f_originalHashes.u[rightDataIdx];
        newContent.u[(compressedDataIdx << 1)] = that.getKey__I__O(rightDataIdx);
        newContent.u[((1 + (compressedDataIdx << 1)) | 0)] = that.getValue__I__O(rightDataIdx);
        newOriginalHashes.u[compressedDataIdx] = originalHash$3;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$3)) | 0);
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$4 = this.getNode__I__sci_MapNode(leftNodeIdx);
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = newNode$4;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode$4.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$4.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        var newNode$5 = that.getNode__I__sci_MapNode(rightNodeIdx);
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = newNode$5;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + newNode$5.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$5.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$3 = this.getHash__I__I(leftDataIdx);
        var rightOriginalHash$2 = that.getHash__I__I(rightDataIdx);
        var newNode$6 = that.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(this.getKey__I__O(leftDataIdx), this.getValue__I__O(leftDataIdx), leftOriginalHash$3, $m_sc_Hashing$().improve__I__I(leftOriginalHash$3), that.getKey__I__O(rightDataIdx), that.getValue__I__O(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().improve__I__I(rightOriginalHash$2), nextShift);
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = newNode$6;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$6.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$6.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightDataRightOverwrites) !== 0)) {
        var originalHash$4 = that.sci_BitmapIndexedMapNode__f_originalHashes.u[rightDataIdx];
        newContent.u[(compressedDataIdx << 1)] = that.getKey__I__O(rightDataIdx);
        newContent.u[((1 + (compressedDataIdx << 1)) | 0)] = that.getValue__I__O(rightDataIdx);
        newOriginalHashes.u[compressedDataIdx] = originalHash$4;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
      }
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true;
      } else {
        bitpos$2 = (bitpos$2 << 1);
      }
    }
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedMapNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : that);
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode");
  }
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_BitmapIndexedMapNode = (function() {
  var this$1 = this.sci_BitmapIndexedMapNode__f_content;
  var contentClone = this$1.clone__O();
  var contentLength = contentClone.u.length;
  var i = this.sci_BitmapIndexedMapNode__f_dataMap;
  var i$1 = ($m_jl_Integer$().bitCount__I__I(i) << 1);
  while ((i$1 < contentLength)) {
    contentClone.u[i$1] = contentClone.u[i$1].copy__sci_MapNode();
    i$1 = ((1 + i$1) | 0);
  }
  var $x_2 = this.sci_BitmapIndexedMapNode__f_dataMap;
  var $x_1 = this.sci_BitmapIndexedMapNode__f_nodeMap;
  var this$2 = this.sci_BitmapIndexedMapNode__f_originalHashes;
  return new $c_sci_BitmapIndexedMapNode($x_2, $x_1, contentClone, this$2.clone__O(), this.sci_BitmapIndexedMapNode__f_size, this.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode);
});
$c_sci_BitmapIndexedMapNode.prototype.filterImpl__F1__Z__sci_BitmapIndexedMapNode = (function(pred, flipped) {
  if ((this.sci_BitmapIndexedMapNode__f_size === 0)) {
    return this;
  } else if ((this.sci_BitmapIndexedMapNode__f_size === 1)) {
    if (((!(!pred.apply__O__O(this.getPayload__I__T2(0)))) !== flipped)) {
      return this;
    } else {
      var this$1 = $m_sci_MapNode$();
      return this$1.sci_MapNode$__f_EmptyMapNode;
    }
  } else if ((this.sci_BitmapIndexedMapNode__f_nodeMap === 0)) {
    var i = this.sci_BitmapIndexedMapNode__f_dataMap;
    var i$1 = ((~i) & (((-1) + i) | 0));
    var minimumIndex = ((32 - Math.clz32(i$1)) | 0);
    var i$2 = this.sci_BitmapIndexedMapNode__f_dataMap;
    var maximumIndex = ((32 - Math.clz32(i$2)) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i$3);
      if (((bitpos & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        var payload = this.getPayload__I__T2(dataIndex);
        var passed = ((!(!pred.apply__O__O(payload))) !== flipped);
        if (passed) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex))) | 0);
        }
        dataIndex = ((1 + dataIndex) | 0);
      }
      i$3 = ((1 + i$3) | 0);
    }
    if ((newDataMap === 0)) {
      var this$4 = $m_sci_MapNode$();
      return this$4.sci_MapNode$__f_EmptyMapNode;
    } else if ((newDataMap === this.sci_BitmapIndexedMapNode__f_dataMap)) {
      return this;
    } else {
      var i$4 = newDataMap;
      var newSize = $m_jl_Integer$().bitCount__I__I(i$4);
      var newContent = new $ac_O((newSize << 1));
      var newOriginalHashCodes = new $ac_I(newSize);
      var i$5 = newDataMap;
      var newMaximumIndex = ((32 - Math.clz32(i$5)) | 0);
      var i$6 = newDataMap;
      var i$7 = ((~i$6) & (((-1) + i$6) | 0));
      var j = ((32 - Math.clz32(i$7)) | 0);
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().bitposFrom__I__I(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedMapNode__f_dataMap, bitpos$2);
          newContent.u[(newDataIndex << 1)] = this.sci_BitmapIndexedMapNode__f_content.u[(oldIndex << 1)];
          newContent.u[((1 + (newDataIndex << 1)) | 0)] = this.sci_BitmapIndexedMapNode__f_content.u[((1 + (oldIndex << 1)) | 0)];
          newOriginalHashCodes.u[newDataIndex] = this.sci_BitmapIndexedMapNode__f_originalHashes.u[oldIndex];
          newDataIndex = ((1 + newDataIndex) | 0);
        }
        j = ((1 + j) | 0);
      }
      return new $c_sci_BitmapIndexedMapNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode);
    }
  } else {
    var allMap = (this.sci_BitmapIndexedMapNode__f_dataMap | this.sci_BitmapIndexedMapNode__f_nodeMap);
    var i$8 = ((~allMap) & (((-1) + allMap) | 0));
    var minimumIndex$2 = ((32 - Math.clz32(i$8)) | 0);
    var maximumIndex$2 = ((32 - Math.clz32(allMap)) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().bitposFrom__I__I(i$2$1);
      if (((bitpos$3 & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
        var payload$2 = this.getPayload__I__T2(dataIndex$2);
        var passed$2 = ((!(!pred.apply__O__O(payload$2))) !== flipped);
        if (passed$2) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex$2))) | 0);
        }
        dataIndex$2 = ((1 + dataIndex$2) | 0);
      } else if (((bitpos$3 & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
        var oldSubNode = this.getNode__I__sci_MapNode(nodeIndex);
        var newSubNode = oldSubNode.filterImpl__F1__Z__sci_MapNode(pred, flipped);
        newSize$2 = ((newSize$2 + newSubNode.size__I()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + newSubNode.cachedJavaKeySetHashCode__I()) | 0);
        if ((newSubNode.size__I() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3);
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
            }
            var this$10 = newNodes;
            this$10.addOne__O__scm_ArrayDeque(newSubNode);
          }
        } else if ((newSubNode.size__I() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            var elems = $m_sci_Nil$();
            var this$12 = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
            nodesToMigrateToData = this$12.addAll__sc_IterableOnce__scm_ArrayDeque(elems);
          }
          var this$13 = nodesToMigrateToData;
          this$13.addOne__O__scm_ArrayDeque(newSubNode);
        }
        nodeIndex = ((1 + nodeIndex) | 0);
      }
      i$2$1 = ((1 + i$2$1) | 0);
    }
    if ((newSize$2 === 0)) {
      var this$14 = $m_sci_MapNode$();
      return this$14.sci_MapNode$__f_EmptyMapNode;
    } else if ((newSize$2 === this.sci_BitmapIndexedMapNode__f_size)) {
      return this;
    } else {
      var i$9 = newDataMap$2;
      var newDataSize = $m_jl_Integer$().bitCount__I__I(i$9);
      var i$10 = newNodeMap;
      var newContentSize = (((newDataSize << 1) + $m_jl_Integer$().bitCount__I__I(i$10)) | 0);
      var newContent$2 = new $ac_O(newContentSize);
      var newOriginalHashes = new $ac_I(newDataSize);
      var newAllMap = (newDataMap$2 | newNodeMap);
      var maxIndex = ((32 - Math.clz32(newAllMap)) | 0);
      var i$3$1 = minimumIndex$2;
      var oldDataIndex = 0;
      var oldNodeIndex = 0;
      var newDataIndex$2 = 0;
      var newNodeIndex = 0;
      while ((i$3$1 < maxIndex)) {
        var bitpos$4 = $m_sci_Node$().bitposFrom__I__I(i$3$1);
        if (((bitpos$4 & oldDataPassThrough) !== 0)) {
          newContent$2.u[(newDataIndex$2 << 1)] = this.getKey__I__O(oldDataIndex);
          newContent$2.u[((1 + (newDataIndex$2 << 1)) | 0)] = this.getValue__I__O(oldDataIndex);
          newOriginalHashes.u[newDataIndex$2] = this.getHash__I__I(oldDataIndex);
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldDataIndex = ((1 + oldDataIndex) | 0);
        } else if (((bitpos$4 & nodesToPassThroughMap) !== 0)) {
          newContent$2.u[(((-1) + ((newContentSize - newNodeIndex) | 0)) | 0)] = this.getNode__I__sci_MapNode(oldNodeIndex);
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & nodeMigrateToDataTargetMap) !== 0)) {
          var this$16 = nodesToMigrateToData;
          var node = this$16.removeHead__Z__O(false);
          newContent$2.u[(newDataIndex$2 << 1)] = node.getKey__I__O(0);
          newContent$2.u[((1 + (newDataIndex$2 << 1)) | 0)] = node.getValue__I__O(0);
          newOriginalHashes.u[newDataIndex$2] = node.getHash__I__I(0);
          newDataIndex$2 = ((1 + newDataIndex$2) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & mapOfNewNodes) !== 0)) {
          var $x_1 = newNodeIndex;
          var this$17 = newNodes;
          newContent$2.u[(((-1) + ((newContentSize - $x_1) | 0)) | 0)] = this$17.removeHead__Z__O(false);
          newNodeIndex = ((1 + newNodeIndex) | 0);
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        } else if (((bitpos$4 & this.sci_BitmapIndexedMapNode__f_dataMap) !== 0)) {
          oldDataIndex = ((1 + oldDataIndex) | 0);
        } else if (((bitpos$4 & this.sci_BitmapIndexedMapNode__f_nodeMap) !== 0)) {
          oldNodeIndex = ((1 + oldNodeIndex) | 0);
        }
        i$3$1 = ((1 + i$3$1) | 0);
      }
      return new $c_sci_BitmapIndexedMapNode(newDataMap$2, newNodeMap, newContent$2, newOriginalHashes, newSize$2, newCachedHashCode$2);
    }
  }
});
$c_sci_BitmapIndexedMapNode.prototype.filterImpl__F1__Z__sci_MapNode = (function(pred, isFlipped) {
  return this.filterImpl__F1__Z__sci_BitmapIndexedMapNode(pred, isFlipped);
});
$c_sci_BitmapIndexedMapNode.prototype.copy__sci_MapNode = (function() {
  return this.copy__sci_BitmapIndexedMapNode();
});
$c_sci_BitmapIndexedMapNode.prototype.concat__sci_MapNode__I__sci_MapNode = (function(that, shift) {
  return this.concat__sci_MapNode__I__sci_BitmapIndexedMapNode(that, shift);
});
$c_sci_BitmapIndexedMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedMapNode(key, originalHash, hash, shift);
});
$c_sci_BitmapIndexedMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  return this.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, hash, shift, replaceValue);
});
$c_sci_BitmapIndexedMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index);
});
function $isArrayOf_sci_BitmapIndexedMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedMapNode)));
}
export { $isArrayOf_sci_BitmapIndexedMapNode as $isArrayOf_sci_BitmapIndexedMapNode };
var $d_sci_BitmapIndexedMapNode = new $TypeData().initClass($c_sci_BitmapIndexedMapNode, "scala.collection.immutable.BitmapIndexedMapNode", ({
  sci_BitmapIndexedMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1
}));
export { $d_sci_BitmapIndexedMapNode as $d_sci_BitmapIndexedMapNode };
function $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode($thiz, newSize, newDataMap, newNodeMap, minimumIndex, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode) {
  if ((newSize === 0)) {
    var this$1 = $m_sci_SetNode$();
    return this$1.sci_SetNode$__f_EmptySetNode;
  } else if ((newSize === $thiz.sci_BitmapIndexedSetNode__f_size)) {
    return $thiz;
  } else {
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newAllMap = (newDataMap | newNodeMap);
    var maxIndex = ((32 - Math.clz32(newAllMap)) | 0);
    var i = minimumIndex;
    var oldDataIndex = 0;
    var oldNodeIndex = 0;
    var newDataIndex = 0;
    var newNodeIndex = 0;
    while ((i < maxIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i);
      if (((bitpos & oldDataPassThrough) !== 0)) {
        newContent.u[newDataIndex] = $thiz.getPayload__I__O(oldDataIndex);
        newOriginalHashes.u[newDataIndex] = $thiz.getHash__I__I(oldDataIndex);
        newDataIndex = ((1 + newDataIndex) | 0);
        oldDataIndex = ((1 + oldDataIndex) | 0);
      } else if (((bitpos & nodesToPassThroughMap) !== 0)) {
        newContent.u[(((-1) + ((newContentSize - newNodeIndex) | 0)) | 0)] = $thiz.getNode__I__sci_SetNode(oldNodeIndex);
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & nodeMigrateToDataTargetMap) !== 0)) {
        var node = nodesToMigrateToData.removeHead__Z__O(false);
        newContent.u[newDataIndex] = node.getPayload__I__O(0);
        newOriginalHashes.u[newDataIndex] = node.getHash__I__I(0);
        newDataIndex = ((1 + newDataIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & mapOfNewNodes) !== 0)) {
        newContent.u[(((-1) + ((newContentSize - newNodeIndex) | 0)) | 0)] = newNodes.removeHead__Z__O(false);
        newNodeIndex = ((1 + newNodeIndex) | 0);
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      } else if (((bitpos & $thiz.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        oldDataIndex = ((1 + oldDataIndex) | 0);
      } else if (((bitpos & $thiz.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        oldNodeIndex = ((1 + oldNodeIndex) | 0);
      }
      i = ((1 + i) | 0);
    }
    return new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode);
  }
}
export { $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode as $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode };
/** @constructor */
function $c_sci_BitmapIndexedSetNode(dataMap, nodeMap, content, originalHashes, size, cachedJavaKeySetHashCode) {
  this.sci_BitmapIndexedSetNode__f_dataMap = 0;
  this.sci_BitmapIndexedSetNode__f_nodeMap = 0;
  this.sci_BitmapIndexedSetNode__f_content = null;
  this.sci_BitmapIndexedSetNode__f_originalHashes = null;
  this.sci_BitmapIndexedSetNode__f_size = 0;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = 0;
  this.sci_BitmapIndexedSetNode__f_dataMap = dataMap;
  this.sci_BitmapIndexedSetNode__f_nodeMap = nodeMap;
  this.sci_BitmapIndexedSetNode__f_content = content;
  this.sci_BitmapIndexedSetNode__f_originalHashes = originalHashes;
  this.sci_BitmapIndexedSetNode__f_size = size;
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = cachedJavaKeySetHashCode;
}
export { $c_sci_BitmapIndexedSetNode as $c_sci_BitmapIndexedSetNode };
$c_sci_BitmapIndexedSetNode.prototype = new $h_sci_SetNode();
$c_sci_BitmapIndexedSetNode.prototype.constructor = $c_sci_BitmapIndexedSetNode;
/** @constructor */
function $h_sci_BitmapIndexedSetNode() {
}
export { $h_sci_BitmapIndexedSetNode as $h_sci_BitmapIndexedSetNode };
$h_sci_BitmapIndexedSetNode.prototype = $c_sci_BitmapIndexedSetNode.prototype;
$c_sci_BitmapIndexedSetNode.prototype.size__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_size;
});
$c_sci_BitmapIndexedSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode;
});
$c_sci_BitmapIndexedSetNode.prototype.getPayload__I__O = (function(index) {
  return this.sci_BitmapIndexedSetNode__f_content.u[index];
});
$c_sci_BitmapIndexedSetNode.prototype.getHash__I__I = (function(index) {
  return this.sci_BitmapIndexedSetNode__f_originalHashes.u[index];
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  return this.sci_BitmapIndexedSetNode__f_content.u[(((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - index) | 0)];
});
$c_sci_BitmapIndexedSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    return ((this.sci_BitmapIndexedSetNode__f_originalHashes.u[index] === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element, this.getPayload__I__O(index)));
  }
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    return this.getNode__I__sci_SetNode(index$2).contains__O__I__I__I__Z(element, originalHash, elementHash, ((5 + shift) | 0));
  }
  return false;
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if (Object.is(element0, element)) {
      return this;
    } else {
      var element0UnimprovedHash = this.getHash__I__I(index);
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      if (((originalHash === element0UnimprovedHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        return this;
      } else {
        var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        return this.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew);
      }
    }
  }
  if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew$2 = subNode.updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNode === subNodeNew$2)) {
      return this;
    } else {
      return this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew$2);
    }
  }
  return this.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode(bitpos, element, originalHash, elementHash);
});
$c_sci_BitmapIndexedSetNode.prototype.updateWithShallowMutations__O__I__I__I__I__I = (function(element, originalHash, elementHash, shift, shallowlyMutableNodeMap) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    var element0UnimprovedHash = this.getHash__I__I(index);
    if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
      return shallowlyMutableNodeMap;
    } else {
      var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
      var subNodeNew = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
      this.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew);
      return (shallowlyMutableNodeMap | bitpos);
    }
  } else if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeSize = subNode.size__I();
    var subNodeCachedJavaKeySetHashCode = subNode.cachedJavaKeySetHashCode__I();
    var returnNodeMap = shallowlyMutableNodeMap;
    matchEnd4: {
      var subNodeNew$3;
      if ((subNode instanceof $c_sci_BitmapIndexedSetNode)) {
        if (((bitpos & shallowlyMutableNodeMap) !== 0)) {
          subNode.updateWithShallowMutations__O__I__I__I__I__I(element, originalHash, elementHash, ((5 + shift) | 0), 0);
          var subNodeNew$3 = subNode;
          break matchEnd4;
        }
      }
      var subNodeNew$2 = subNode.updated__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
      if ((subNodeNew$2 !== subNode)) {
        returnNodeMap = (returnNodeMap | bitpos);
      }
      var subNodeNew$3 = subNodeNew$2;
    }
    this.sci_BitmapIndexedSetNode__f_content.u[(((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0)] = subNodeNew$3;
    this.sci_BitmapIndexedSetNode__f_size = ((((this.sci_BitmapIndexedSetNode__f_size - subNodeSize) | 0) + subNodeNew$3.size__I()) | 0);
    this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - subNodeCachedJavaKeySetHashCode) | 0) + subNodeNew$3.cachedJavaKeySetHashCode__I()) | 0);
    return returnNodeMap;
  } else {
    var dataIx = this.dataIndex__I__I(bitpos);
    var src = this.sci_BitmapIndexedSetNode__f_content;
    var dst = new $ac_O(((1 + src.u.length) | 0));
    src.copyTo(0, dst, 0, dataIx);
    dst.u[dataIx] = element;
    var destPos = ((1 + dataIx) | 0);
    var length = ((src.u.length - dataIx) | 0);
    src.copyTo(dataIx, dst, destPos, length);
    var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
    this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
    this.sci_BitmapIndexedSetNode__f_content = dst;
    this.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
    this.sci_BitmapIndexedSetNode__f_size = ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0);
    this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0);
    return shallowlyMutableNodeMap;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash, shift) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(element0, element)) {
      var i = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $x_1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var newDataMap = ((shift === 0) ? (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos) : $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(elementHash, 0)));
        return ((index === 0) ? new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(1)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedSetNode__f_originalHashes.u[1]])), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I(this.sci_BitmapIndexedSetNode__f_originalHashes.u[1])) : new $c_sci_BitmapIndexedSetNode(newDataMap, 0, new $ac_O([this.getPayload__I__O(0)]), new $ac_I(new Int32Array([this.sci_BitmapIndexedSetNode__f_originalHashes.u[0]])), (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), $m_sc_Hashing$().improve__I__I(this.sci_BitmapIndexedSetNode__f_originalHashes.u[0])));
      } else {
        return this.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode(bitpos, elementHash);
      }
    } else {
      return this;
    }
  } else if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew = subNode.removed__O__I__I__I__sci_SetNode(element, originalHash, elementHash, ((5 + shift) | 0));
    if ((subNodeNew === subNode)) {
      return this;
    } else {
      var x1 = subNodeNew.size__I();
      return ((x1 === 1) ? ((this.sci_BitmapIndexedSetNode__f_size === subNode.size__I()) ? subNodeNew : this.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, elementHash, subNode, subNodeNew)) : ((x1 > 1) ? this.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, subNode, subNodeNew) : this));
    }
  } else {
    return this;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.removeWithShallowMutations__O__I__I__sci_BitmapIndexedSetNode = (function(element, originalHash, elementHash) {
  var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, 0);
  var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
  if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
    var index = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
    var element0 = this.getPayload__I__O(index);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(element0, element)) {
      var i = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i) === 2)) {
        var i$1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $x_1 = ($m_jl_Integer$().bitCount__I__I(i$1) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var newDataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
        if ((index === 0)) {
          var newContent = new $ac_O([this.getPayload__I__O(1)]);
          var newOriginalHashes = new $ac_I(new Int32Array([this.sci_BitmapIndexedSetNode__f_originalHashes.u[1]]));
          var newCachedJavaKeySetHashCode = $m_sc_Hashing$().improve__I__I(this.getHash__I__I(1));
          this.sci_BitmapIndexedSetNode__f_content = newContent;
          this.sci_BitmapIndexedSetNode__f_originalHashes = newOriginalHashes;
          this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = newCachedJavaKeySetHashCode;
        } else {
          var newContent$2 = new $ac_O([this.getPayload__I__O(0)]);
          var newOriginalHashes$2 = new $ac_I(new Int32Array([this.sci_BitmapIndexedSetNode__f_originalHashes.u[0]]));
          var newCachedJavaKeySetHashCode$2 = $m_sc_Hashing$().improve__I__I(this.getHash__I__I(0));
          this.sci_BitmapIndexedSetNode__f_content = newContent$2;
          this.sci_BitmapIndexedSetNode__f_originalHashes = newOriginalHashes$2;
          this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = newCachedJavaKeySetHashCode$2;
        }
        this.sci_BitmapIndexedSetNode__f_dataMap = newDataMap;
        this.sci_BitmapIndexedSetNode__f_nodeMap = 0;
        this.sci_BitmapIndexedSetNode__f_size = 1;
        return this;
      } else {
        var dataIx = this.dataIndex__I__I(bitpos);
        var src = this.sci_BitmapIndexedSetNode__f_content;
        var dst = new $ac_O((((-1) + src.u.length) | 0));
        src.copyTo(0, dst, 0, dataIx);
        var srcPos = ((1 + dataIx) | 0);
        var length = (((-1) + ((src.u.length - dataIx) | 0)) | 0);
        src.copyTo(srcPos, dst, dataIx, length);
        var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
        this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
        this.sci_BitmapIndexedSetNode__f_content = dst;
        this.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
        this.sci_BitmapIndexedSetNode__f_size = (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0);
        this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0);
        return this;
      }
    } else {
      return this;
    }
  } else if (((this.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
    var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
    var subNode = this.getNode__I__sci_SetNode(index$2);
    var subNodeNew = subNode.removed__O__I__I__I__sci_SetNode(element, originalHash, elementHash, 5);
    if ((subNodeNew === subNode)) {
      return this;
    }
    if ((subNodeNew.sci_BitmapIndexedSetNode__f_size === 1)) {
      var i$2 = this.sci_BitmapIndexedSetNode__f_dataMap;
      if (($m_jl_Integer$().bitCount__I__I(i$2) === 0)) {
        var i$3 = this.sci_BitmapIndexedSetNode__f_nodeMap;
        var $x_2 = ($m_jl_Integer$().bitCount__I__I(i$3) === 1);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        this.sci_BitmapIndexedSetNode__f_dataMap = subNodeNew.sci_BitmapIndexedSetNode__f_dataMap;
        this.sci_BitmapIndexedSetNode__f_nodeMap = subNodeNew.sci_BitmapIndexedSetNode__f_nodeMap;
        this.sci_BitmapIndexedSetNode__f_content = subNodeNew.sci_BitmapIndexedSetNode__f_content;
        this.sci_BitmapIndexedSetNode__f_originalHashes = subNodeNew.sci_BitmapIndexedSetNode__f_originalHashes;
        this.sci_BitmapIndexedSetNode__f_size = subNodeNew.sci_BitmapIndexedSetNode__f_size;
        this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = subNodeNew.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode;
        return this;
      } else {
        this.migrateFromNodeToInlineInPlace__I__I__I__sci_SetNode__sci_SetNode__V(bitpos, originalHash, elementHash, subNode, subNodeNew);
        return this;
      }
    } else {
      this.sci_BitmapIndexedSetNode__f_content.u[(((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0)] = subNodeNew;
      this.sci_BitmapIndexedSetNode__f_size = (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0);
      this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - subNode.cachedJavaKeySetHashCode__I()) | 0) + subNodeNew.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode) | 0);
      return this;
    }
  } else {
    return this;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode = (function(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, shift) {
  if ((shift >= 32)) {
    var this$4 = $m_sci_Vector$();
    var array = [key0, key1];
    var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
    return new $c_sci_HashCollisionSetNode(originalKeyHash0, keyHash0, this$4.from__sc_IterableOnce__sci_Vector(elems));
  } else {
    var mask0 = $m_sci_Node$().maskFrom__I__I__I(keyHash0, shift);
    var mask1 = $m_sci_Node$().maskFrom__I__I__I(keyHash1, shift);
    if ((mask0 !== mask1)) {
      var dataMap = ($m_sci_Node$().bitposFrom__I__I(mask0) | $m_sci_Node$().bitposFrom__I__I(mask1));
      var newCachedHashCode = ((keyHash0 + keyHash1) | 0);
      return ((mask0 < mask1) ? new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key0, key1]), new $ac_I(new Int32Array([originalKeyHash0, originalKeyHash1])), 2, newCachedHashCode) : new $c_sci_BitmapIndexedSetNode(dataMap, 0, new $ac_O([key1, key0]), new $ac_I(new Int32Array([originalKeyHash1, originalKeyHash0])), 2, newCachedHashCode));
    } else {
      var nodeMap = $m_sci_Node$().bitposFrom__I__I(mask0);
      var node = this.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(key0, originalKeyHash0, keyHash0, key1, originalKeyHash1, keyHash1, ((5 + shift) | 0));
      return new $c_sci_BitmapIndexedSetNode(0, nodeMap, new $ac_O([node]), $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, node.size__I(), node.cachedJavaKeySetHashCode__I());
    }
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hasPayload__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_dataMap !== 0);
});
$c_sci_BitmapIndexedSetNode.prototype.payloadArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.hasNodes__Z = (function() {
  return (this.sci_BitmapIndexedSetNode__f_nodeMap !== 0);
});
$c_sci_BitmapIndexedSetNode.prototype.nodeArity__I = (function() {
  var i = this.sci_BitmapIndexedSetNode__f_nodeMap;
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.dataIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_dataMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.nodeIndex__I__I = (function(bitpos) {
  var i = (this.sci_BitmapIndexedSetNode__f_nodeMap & (((-1) + bitpos) | 0));
  return $m_jl_Integer$().bitCount__I__I(i);
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndSetNode__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, oldNode, newNode) {
  var idx = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  var length = src.u.length;
  src.copyTo(0, dst, 0, length);
  dst.u[idx] = newNode;
  return new $c_sci_BitmapIndexedSetNode(this.sci_BitmapIndexedSetNode__f_dataMap, this.sci_BitmapIndexedSetNode__f_nodeMap, dst, this.sci_BitmapIndexedSetNode__f_originalHashes, ((((this.sci_BitmapIndexedSetNode__f_size - oldNode.size__I()) | 0) + newNode.size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + newNode.cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndInsertValue__I__O__I__I__sci_BitmapIndexedSetNode = (function(bitpos, key, originalHash, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  src.copyTo(0, dst, 0, dataIx);
  dst.u[dataIx] = key;
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.u.length - dataIx) | 0);
  src.copyTo(dataIx, dst, destPos, length);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, ((1 + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + elementHash) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndRemoveValue__I__I__sci_BitmapIndexedSetNode = (function(bitpos, elementHash) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O((((-1) + src.u.length) | 0));
  src.copyTo(0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = (((-1) + ((src.u.length - dataIx) | 0)) | 0);
  src.copyTo(srcPos, dst, dataIx, length);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), this.sci_BitmapIndexedSetNode__f_nodeMap, dst, dstHashes, (((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0), ((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromInlineToNode__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  src.copyTo(0, dst, 0, dataIx);
  var srcPos = ((1 + dataIx) | 0);
  var length = ((idxNew - dataIx) | 0);
  src.copyTo(srcPos, dst, dataIx, length);
  dst.u[idxNew] = node;
  var srcPos$1 = ((1 + idxNew) | 0);
  var destPos = ((1 + idxNew) | 0);
  var length$1 = (((-1) + ((src.u.length - idxNew) | 0)) | 0);
  src.copyTo(srcPos$1, dst, destPos, length$1);
  var dstHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos), dst, dstHashes, (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + node.size__I()) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - elementHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, keyHash, node) {
  var dataIx = this.dataIndex__I__I(bitpos);
  var idxNew = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var srcPos = ((1 + dataIx) | 0);
  var dest = this.sci_BitmapIndexedSetNode__f_content;
  var length = ((idxNew - dataIx) | 0);
  src.copyTo(srcPos, dest, dataIx, length);
  this.sci_BitmapIndexedSetNode__f_content.u[idxNew] = node;
  this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap ^ bitpos);
  this.sci_BitmapIndexedSetNode__f_nodeMap = (this.sci_BitmapIndexedSetNode__f_nodeMap | bitpos);
  this.sci_BitmapIndexedSetNode__f_originalHashes = this.removeElement__AI__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIx);
  this.sci_BitmapIndexedSetNode__f_size = (((((-1) + this.sci_BitmapIndexedSetNode__f_size) | 0) + node.size__I()) | 0);
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - keyHash) | 0) + node.cachedJavaKeySetHashCode__I()) | 0);
  return this;
});
$c_sci_BitmapIndexedSetNode.prototype.copyAndMigrateFromNodeToInline__I__I__sci_SetNode__sci_SetNode__sci_BitmapIndexedSetNode = (function(bitpos, elementHash, oldNode, node) {
  var idxOld = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(src.u.length);
  src.copyTo(0, dst, 0, dataIxNew);
  dst.u[dataIxNew] = node.getPayload__I__O(0);
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  src.copyTo(dataIxNew, dst, destPos, length);
  var srcPos = ((1 + idxOld) | 0);
  var destPos$1 = ((1 + idxOld) | 0);
  var length$1 = (((-1) + ((src.u.length - idxOld) | 0)) | 0);
  src.copyTo(srcPos, dst, destPos$1, length$1);
  var hash = node.getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIxNew, hash);
  return new $c_sci_BitmapIndexedSetNode((this.sci_BitmapIndexedSetNode__f_dataMap | bitpos), (this.sci_BitmapIndexedSetNode__f_nodeMap ^ bitpos), dst, dstHashes, ((1 + ((this.sci_BitmapIndexedSetNode__f_size - oldNode.size__I()) | 0)) | 0), ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + node.cachedJavaKeySetHashCode__I()) | 0));
});
$c_sci_BitmapIndexedSetNode.prototype.migrateFromNodeToInlineInPlace__I__I__I__sci_SetNode__sci_SetNode__V = (function(bitpos, originalHash, elementHash, oldNode, node) {
  var idxOld = (((((-1) + this.sci_BitmapIndexedSetNode__f_content.u.length) | 0) - this.nodeIndex__I__I(bitpos)) | 0);
  var dataIxNew = this.dataIndex__I__I(bitpos);
  var element = node.getPayload__I__O(0);
  var src = this.sci_BitmapIndexedSetNode__f_content;
  var dest = this.sci_BitmapIndexedSetNode__f_content;
  var destPos = ((1 + dataIxNew) | 0);
  var length = ((idxOld - dataIxNew) | 0);
  src.copyTo(dataIxNew, dest, destPos, length);
  this.sci_BitmapIndexedSetNode__f_content.u[dataIxNew] = element;
  var hash = node.getHash__I__I(0);
  var dstHashes = this.insertElement__AI__I__I__AI(this.sci_BitmapIndexedSetNode__f_originalHashes, dataIxNew, hash);
  this.sci_BitmapIndexedSetNode__f_dataMap = (this.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
  this.sci_BitmapIndexedSetNode__f_nodeMap = (this.sci_BitmapIndexedSetNode__f_nodeMap ^ bitpos);
  this.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
  this.sci_BitmapIndexedSetNode__f_size = ((1 + ((this.sci_BitmapIndexedSetNode__f_size - oldNode.size__I()) | 0)) | 0);
  this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode - oldNode.cachedJavaKeySetHashCode__I()) | 0) + node.cachedJavaKeySetHashCode__I()) | 0);
});
$c_sci_BitmapIndexedSetNode.prototype.foreach__F1__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var thisPayloadArity = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < thisPayloadArity)) {
    f.apply__O__O(this.getPayload__I__O(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var thisNodeArity = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < thisNodeArity)) {
    this.getNode__I__sci_SetNode(j).foreach__F1__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedSetNode.prototype.subsetOf__sci_SetNode__I__Z = (function(that, shift) {
  if ((this === that)) {
    return true;
  } else if ((!(that instanceof $c_sci_HashCollisionSetNode))) {
    if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
      var thisBitmap = (this.sci_BitmapIndexedSetNode__f_dataMap | this.sci_BitmapIndexedSetNode__f_nodeMap);
      var nodeBitmap = (that.sci_BitmapIndexedSetNode__f_dataMap | that.sci_BitmapIndexedSetNode__f_nodeMap);
      if (((thisBitmap | nodeBitmap) !== nodeBitmap)) {
        return false;
      }
      var bitmap = (thisBitmap & nodeBitmap);
      var i = bitmap;
      var i$1 = ((~i) & (((-1) + i) | 0));
      var bitsToSkip = ((32 - Math.clz32(i$1)) | 0);
      var isValidSubset = true;
      while ((isValidSubset && (bitsToSkip < 32))) {
        var bitpos = $m_sci_Node$().bitposFrom__I__I(bitsToSkip);
        if (((this.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
          if (((that.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
            var payload0 = this.getPayload__I__O($m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, bitpos));
            var payload1 = that.getPayload__I__O($m_sci_Node$().indexFrom__I__I__I(that.sci_BitmapIndexedSetNode__f_dataMap, bitpos));
            isValidSubset = $m_sr_BoxesRunTime$().equals__O__O__Z(payload0, payload1);
          } else {
            var thisDataIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, bitpos);
            var payload = this.getPayload__I__O(thisDataIndex);
            var subNode = that.getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I(that.sci_BitmapIndexedSetNode__f_nodeMap, bitpos));
            var elementUnimprovedHash = this.getHash__I__I(thisDataIndex);
            var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
            isValidSubset = subNode.contains__O__I__I__I__Z(payload, elementUnimprovedHash, elementHash, ((5 + shift) | 0));
          }
        } else if (((that.sci_BitmapIndexedSetNode__f_dataMap & bitpos) === 0)) {
          var subNode0 = this.getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_nodeMap, bitpos));
          var subNode1 = that.getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I(that.sci_BitmapIndexedSetNode__f_nodeMap, bitpos));
          isValidSubset = subNode0.subsetOf__sci_SetNode__I__Z(subNode1, ((5 + shift) | 0));
        } else {
          isValidSubset = false;
        }
        var newBitmap = (bitmap ^ bitpos);
        bitmap = newBitmap;
        var i$2 = ((~newBitmap) & (((-1) + newBitmap) | 0));
        bitsToSkip = ((32 - Math.clz32(i$2)) | 0);
      }
      return isValidSubset;
    } else {
      throw new $c_s_MatchError(that);
    }
  } else {
    return false;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.filterImpl__F1__Z__sci_BitmapIndexedSetNode = (function(pred, flipped) {
  if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
    return this;
  } else if ((this.sci_BitmapIndexedSetNode__f_size === 1)) {
    if (((!(!pred.apply__O__O(this.getPayload__I__O(0)))) !== flipped)) {
      return this;
    } else {
      var this$1 = $m_sci_SetNode$();
      return this$1.sci_SetNode$__f_EmptySetNode;
    }
  } else if ((this.sci_BitmapIndexedSetNode__f_nodeMap === 0)) {
    var i = this.sci_BitmapIndexedSetNode__f_dataMap;
    var i$1 = ((~i) & (((-1) + i) | 0));
    var minimumIndex = ((32 - Math.clz32(i$1)) | 0);
    var i$2 = this.sci_BitmapIndexedSetNode__f_dataMap;
    var maximumIndex = ((32 - Math.clz32(i$2)) | 0);
    var newDataMap = 0;
    var newCachedHashCode = 0;
    var dataIndex = 0;
    var i$3 = minimumIndex;
    while ((i$3 < maximumIndex)) {
      var bitpos = $m_sci_Node$().bitposFrom__I__I(i$3);
      if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        var payload = this.getPayload__I__O(dataIndex);
        var passed = ((!(!pred.apply__O__O(payload))) !== flipped);
        if (passed) {
          newDataMap = (newDataMap | bitpos);
          newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex))) | 0);
        }
        dataIndex = ((1 + dataIndex) | 0);
      }
      i$3 = ((1 + i$3) | 0);
    }
    if ((newDataMap === 0)) {
      var this$4 = $m_sci_SetNode$();
      return this$4.sci_SetNode$__f_EmptySetNode;
    } else if ((newDataMap === this.sci_BitmapIndexedSetNode__f_dataMap)) {
      return this;
    } else {
      var i$4 = newDataMap;
      var newSize = $m_jl_Integer$().bitCount__I__I(i$4);
      var newContent = new $ac_O(newSize);
      var newOriginalHashCodes = new $ac_I(newSize);
      var i$5 = newDataMap;
      var newMaximumIndex = ((32 - Math.clz32(i$5)) | 0);
      var i$6 = newDataMap;
      var i$7 = ((~i$6) & (((-1) + i$6) | 0));
      var j = ((32 - Math.clz32(i$7)) | 0);
      var newDataIndex = 0;
      while ((j < newMaximumIndex)) {
        var bitpos$2 = $m_sci_Node$().bitposFrom__I__I(j);
        if (((bitpos$2 & newDataMap) !== 0)) {
          var oldIndex = $m_sci_Node$().indexFrom__I__I__I(this.sci_BitmapIndexedSetNode__f_dataMap, bitpos$2);
          newContent.u[newDataIndex] = this.sci_BitmapIndexedSetNode__f_content.u[oldIndex];
          newOriginalHashCodes.u[newDataIndex] = this.sci_BitmapIndexedSetNode__f_originalHashes.u[oldIndex];
          newDataIndex = ((1 + newDataIndex) | 0);
        }
        j = ((1 + j) | 0);
      }
      return new $c_sci_BitmapIndexedSetNode(newDataMap, 0, newContent, newOriginalHashCodes, newSize, newCachedHashCode);
    }
  } else {
    var allMap = (this.sci_BitmapIndexedSetNode__f_dataMap | this.sci_BitmapIndexedSetNode__f_nodeMap);
    var i$8 = ((~allMap) & (((-1) + allMap) | 0));
    var minimumIndex$2 = ((32 - Math.clz32(i$8)) | 0);
    var maximumIndex$2 = ((32 - Math.clz32(allMap)) | 0);
    var oldDataPassThrough = 0;
    var nodeMigrateToDataTargetMap = 0;
    var nodesToMigrateToData = null;
    var nodesToPassThroughMap = 0;
    var mapOfNewNodes = 0;
    var newNodes = null;
    var newDataMap$2 = 0;
    var newNodeMap = 0;
    var newSize$2 = 0;
    var newCachedHashCode$2 = 0;
    var dataIndex$2 = 0;
    var nodeIndex = 0;
    var i$2$1 = minimumIndex$2;
    while ((i$2$1 < maximumIndex$2)) {
      var bitpos$3 = $m_sci_Node$().bitposFrom__I__I(i$2$1);
      if (((bitpos$3 & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        var payload$2 = this.getPayload__I__O(dataIndex$2);
        var passed$2 = ((!(!pred.apply__O__O(payload$2))) !== flipped);
        if (passed$2) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          oldDataPassThrough = (oldDataPassThrough | bitpos$3);
          newSize$2 = ((1 + newSize$2) | 0);
          newCachedHashCode$2 = ((newCachedHashCode$2 + $m_sc_Hashing$().improve__I__I(this.getHash__I__I(dataIndex$2))) | 0);
        }
        dataIndex$2 = ((1 + dataIndex$2) | 0);
      } else if (((bitpos$3 & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        var oldSubNode = this.getNode__I__sci_SetNode(nodeIndex);
        var newSubNode = oldSubNode.filterImpl__F1__Z__sci_SetNode(pred, flipped);
        newSize$2 = ((newSize$2 + newSubNode.size__I()) | 0);
        newCachedHashCode$2 = ((newCachedHashCode$2 + newSubNode.cachedJavaKeySetHashCode__I()) | 0);
        if ((newSubNode.size__I() > 1)) {
          newNodeMap = (newNodeMap | bitpos$3);
          if ((oldSubNode === newSubNode)) {
            nodesToPassThroughMap = (nodesToPassThroughMap | bitpos$3);
          } else {
            mapOfNewNodes = (mapOfNewNodes | bitpos$3);
            if ((newNodes === null)) {
              newNodes = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
            }
            var this$10 = newNodes;
            this$10.addOne__O__scm_ArrayDeque(newSubNode);
          }
        } else if ((newSubNode.size__I() === 1)) {
          newDataMap$2 = (newDataMap$2 | bitpos$3);
          nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos$3);
          if ((nodesToMigrateToData === null)) {
            nodesToMigrateToData = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
          }
          var this$12 = nodesToMigrateToData;
          this$12.addOne__O__scm_ArrayDeque(newSubNode);
        }
        nodeIndex = ((1 + nodeIndex) | 0);
      }
      i$2$1 = ((1 + i$2$1) | 0);
    }
    return $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode(this, newSize$2, newDataMap$2, newNodeMap, minimumIndex$2, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode$2);
  }
});
$c_sci_BitmapIndexedSetNode.prototype.diff__sci_SetNode__I__sci_BitmapIndexedSetNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
      return this;
    } else if ((this.sci_BitmapIndexedSetNode__f_size === 1)) {
      var h = this.getHash__I__I(0);
      if (that.contains__O__I__I__I__Z(this.getPayload__I__O(0), h, $m_sc_Hashing$().improve__I__I(h), shift)) {
        var this$1 = $m_sci_SetNode$();
        return this$1.sci_SetNode$__f_EmptySetNode;
      } else {
        return this;
      }
    } else {
      var allMap = (this.sci_BitmapIndexedSetNode__f_dataMap | this.sci_BitmapIndexedSetNode__f_nodeMap);
      var i = ((~allMap) & (((-1) + allMap) | 0));
      var minimumIndex = ((32 - Math.clz32(i)) | 0);
      var maximumIndex = ((32 - Math.clz32(allMap)) | 0);
      var oldDataPassThrough = 0;
      var nodeMigrateToDataTargetMap = 0;
      var nodesToMigrateToData = null;
      var nodesToPassThroughMap = 0;
      var mapOfNewNodes = 0;
      var newNodes = null;
      var newDataMap = 0;
      var newNodeMap = 0;
      var newSize = 0;
      var newCachedHashCode = 0;
      var dataIndex = 0;
      var nodeIndex = 0;
      var i$1 = minimumIndex;
      while ((i$1 < maximumIndex)) {
        var bitpos = $m_sci_Node$().bitposFrom__I__I(i$1);
        if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          var payload = this.getPayload__I__O(dataIndex);
          var originalHash = this.getHash__I__I(dataIndex);
          var hash = $m_sc_Hashing$().improve__I__I(originalHash);
          if ((!that.contains__O__I__I__I__Z(payload, originalHash, hash, shift))) {
            newDataMap = (newDataMap | bitpos);
            oldDataPassThrough = (oldDataPassThrough | bitpos);
            newSize = ((1 + newSize) | 0);
            newCachedHashCode = ((newCachedHashCode + hash) | 0);
          }
          dataIndex = ((1 + dataIndex) | 0);
        } else if (((bitpos & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          var oldSubNode = this.getNode__I__sci_SetNode(nodeIndex);
          if (((bitpos & that.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
            var thatDataIndex = $m_sci_Node$().indexFrom__I__I__I(that.sci_BitmapIndexedSetNode__f_dataMap, bitpos);
            var thatPayload = that.getPayload__I__O(thatDataIndex);
            var thatOriginalHash = that.getHash__I__I(thatDataIndex);
            var thatHash = $m_sc_Hashing$().improve__I__I(thatOriginalHash);
            var newSubNode = oldSubNode.removed__O__I__I__I__sci_SetNode(thatPayload, thatOriginalHash, thatHash, ((5 + shift) | 0));
          } else {
            var newSubNode = (((bitpos & that.sci_BitmapIndexedSetNode__f_nodeMap) !== 0) ? oldSubNode.diff__sci_SetNode__I__sci_SetNode(that.getNode__I__sci_SetNode($m_sci_Node$().indexFrom__I__I__I(that.sci_BitmapIndexedSetNode__f_nodeMap, bitpos)), ((5 + shift) | 0)) : oldSubNode);
          }
          newSize = ((newSize + newSubNode.size__I()) | 0);
          newCachedHashCode = ((newCachedHashCode + newSubNode.cachedJavaKeySetHashCode__I()) | 0);
          if ((newSubNode.size__I() > 1)) {
            newNodeMap = (newNodeMap | bitpos);
            if ((oldSubNode === newSubNode)) {
              nodesToPassThroughMap = (nodesToPassThroughMap | bitpos);
            } else {
              mapOfNewNodes = (mapOfNewNodes | bitpos);
              if ((newNodes === null)) {
                newNodes = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
              }
              var this$5 = newNodes;
              this$5.addOne__O__scm_ArrayDeque(newSubNode);
            }
          } else if ((newSubNode.size__I() === 1)) {
            newDataMap = (newDataMap | bitpos);
            nodeMigrateToDataTargetMap = (nodeMigrateToDataTargetMap | bitpos);
            if ((nodesToMigrateToData === null)) {
              nodesToMigrateToData = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
            }
            var this$7 = nodesToMigrateToData;
            this$7.addOne__O__scm_ArrayDeque(newSubNode);
          }
          nodeIndex = ((1 + nodeIndex) | 0);
        }
        i$1 = ((1 + i$1) | 0);
      }
      return $p_sci_BitmapIndexedSetNode__newNodeFrom__I__I__I__I__I__I__I__scm_Queue__I__scm_Queue__I__sci_BitmapIndexedSetNode(this, newSize, newDataMap, newNodeMap, minimumIndex, oldDataPassThrough, nodesToPassThroughMap, nodeMigrateToDataTargetMap, nodesToMigrateToData, mapOfNewNodes, newNodes, newCachedHashCode);
    }
  } else if ((that instanceof $c_sci_HashCollisionSetNode)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "BitmapIndexedSetNode diff HashCollisionSetNode");
  } else {
    throw new $c_s_MatchError(that);
  }
});
$c_sci_BitmapIndexedSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    if ((this === that)) {
      return true;
    } else {
      if (((((this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode === that.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode) && (this.sci_BitmapIndexedSetNode__f_nodeMap === that.sci_BitmapIndexedSetNode__f_nodeMap)) && (this.sci_BitmapIndexedSetNode__f_dataMap === that.sci_BitmapIndexedSetNode__f_dataMap)) && (this.sci_BitmapIndexedSetNode__f_size === that.sci_BitmapIndexedSetNode__f_size))) {
        var a = this.sci_BitmapIndexedSetNode__f_originalHashes;
        var b = that.sci_BitmapIndexedSetNode__f_originalHashes;
        var $x_1 = $m_ju_Arrays$().equals__AI__AI__Z(a, b);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var a1 = this.sci_BitmapIndexedSetNode__f_content;
        var a2 = that.sci_BitmapIndexedSetNode__f_content;
        var length = this.sci_BitmapIndexedSetNode__f_content.u.length;
        if ((a1 === a2)) {
          return true;
        } else {
          var isEqual = true;
          var i = 0;
          while ((isEqual && (i < length))) {
            isEqual = $m_sr_BoxesRunTime$().equals__O__O__Z(a1.u[i], a2.u[i]);
            i = ((1 + i) | 0);
          }
          return isEqual;
        }
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_sci_BitmapIndexedSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_BitmapIndexedSetNode.prototype.toString__T = (function() {
  var $x_1 = $m_sc_StringOps$();
  var x0 = this.sci_BitmapIndexedSetNode__f_size;
  var x1 = this.sci_BitmapIndexedSetNode__f_dataMap;
  var x2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var array = [x0, x1, x2];
  return $x_1.format$extension__T__sci_Seq__T("BitmapIndexedSetNode(size=%s, dataMap=%x, nodeMap=%x)", $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array));
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_BitmapIndexedSetNode = (function() {
  var this$1 = this.sci_BitmapIndexedSetNode__f_content;
  var contentClone = this$1.clone__O();
  var contentLength = contentClone.u.length;
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var i$1 = $m_jl_Integer$().bitCount__I__I(i);
  while ((i$1 < contentLength)) {
    contentClone.u[i$1] = contentClone.u[i$1].copy__sci_SetNode();
    i$1 = ((1 + i$1) | 0);
  }
  var $x_2 = this.sci_BitmapIndexedSetNode__f_dataMap;
  var $x_1 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var this$2 = this.sci_BitmapIndexedSetNode__f_originalHashes;
  return new $c_sci_BitmapIndexedSetNode($x_2, $x_1, contentClone, this$2.clone__O(), this.sci_BitmapIndexedSetNode__f_size, this.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode);
});
$c_sci_BitmapIndexedSetNode.prototype.concat__sci_SetNode__I__sci_BitmapIndexedSetNode = (function(that, shift) {
  if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    if ((this.sci_BitmapIndexedSetNode__f_size === 0)) {
      return that;
    } else if (((that.sci_BitmapIndexedSetNode__f_size === 0) || (that === this))) {
      return this;
    } else if ((that.sci_BitmapIndexedSetNode__f_size === 1)) {
      var originalHash = that.getHash__I__I(0);
      return this.updated__O__I__I__I__sci_BitmapIndexedSetNode(that.getPayload__I__O(0), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), shift);
    }
    var anyChangesMadeSoFar = false;
    var allMap = (((this.sci_BitmapIndexedSetNode__f_dataMap | that.sci_BitmapIndexedSetNode__f_dataMap) | this.sci_BitmapIndexedSetNode__f_nodeMap) | that.sci_BitmapIndexedSetNode__f_nodeMap);
    var $x_1 = $m_sci_Node$();
    var i = ((~allMap) & (((-1) + allMap) | 0));
    var minimumBitPos = $x_1.bitposFrom__I__I(((32 - Math.clz32(i)) | 0));
    var maximumBitPos = $m_sci_Node$().bitposFrom__I__I(((31 - Math.clz32(allMap)) | 0));
    var leftNodeRightNode = 0;
    var leftDataRightNode = 0;
    var leftNodeRightData = 0;
    var leftDataOnly = 0;
    var rightDataOnly = 0;
    var leftNodeOnly = 0;
    var rightNodeOnly = 0;
    var leftDataRightDataMigrateToNode = 0;
    var leftDataRightDataLeftOverwrites = 0;
    var dataToNodeMigrationTargets = 0;
    var bitpos = minimumBitPos;
    var leftIdx = 0;
    var rightIdx = 0;
    var finished = false;
    while ((!finished)) {
      if (((bitpos & this.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        if (((bitpos & that.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          if (((this.getHash__I__I(leftIdx) === that.getHash__I__I(rightIdx)) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.getPayload__I__O(leftIdx), that.getPayload__I__O(rightIdx)))) {
            leftDataRightDataLeftOverwrites = (leftDataRightDataLeftOverwrites | bitpos);
          } else {
            leftDataRightDataMigrateToNode = (leftDataRightDataMigrateToNode | bitpos);
            dataToNodeMigrationTargets = (dataToNodeMigrationTargets | $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I($m_sc_Hashing$().improve__I__I(this.getHash__I__I(leftIdx)), shift)));
          }
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & that.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          leftDataRightNode = (leftDataRightNode | bitpos);
        } else {
          leftDataOnly = (leftDataOnly | bitpos);
        }
        leftIdx = ((1 + leftIdx) | 0);
      } else if (((bitpos & this.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        if (((bitpos & that.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
          leftNodeRightData = (leftNodeRightData | bitpos);
          rightIdx = ((1 + rightIdx) | 0);
        } else if (((bitpos & that.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
          leftNodeRightNode = (leftNodeRightNode | bitpos);
        } else {
          leftNodeOnly = (leftNodeOnly | bitpos);
        }
      } else if (((bitpos & that.sci_BitmapIndexedSetNode__f_dataMap) !== 0)) {
        rightDataOnly = (rightDataOnly | bitpos);
        rightIdx = ((1 + rightIdx) | 0);
      } else if (((bitpos & that.sci_BitmapIndexedSetNode__f_nodeMap) !== 0)) {
        rightNodeOnly = (rightNodeOnly | bitpos);
      }
      if ((bitpos === maximumBitPos)) {
        finished = true;
      } else {
        bitpos = (bitpos << 1);
      }
    }
    var newDataMap = ((leftDataOnly | rightDataOnly) | leftDataRightDataLeftOverwrites);
    var newNodeMap = (((((leftNodeRightNode | leftDataRightNode) | leftNodeRightData) | leftNodeOnly) | rightNodeOnly) | dataToNodeMigrationTargets);
    if (((newDataMap === (leftDataOnly | leftDataRightDataLeftOverwrites)) && (newNodeMap === leftNodeOnly))) {
      return this;
    }
    var newDataSize = $m_jl_Integer$().bitCount__I__I(newDataMap);
    var newContentSize = ((newDataSize + $m_jl_Integer$().bitCount__I__I(newNodeMap)) | 0);
    var newContent = new $ac_O(newContentSize);
    var newOriginalHashes = new $ac_I(newDataSize);
    var newSize = 0;
    var newCachedHashCode = 0;
    var leftDataIdx = 0;
    var rightDataIdx = 0;
    var leftNodeIdx = 0;
    var rightNodeIdx = 0;
    var nextShift = ((5 + shift) | 0);
    var compressedDataIdx = 0;
    var compressedNodeIdx = 0;
    var bitpos$2 = minimumBitPos;
    var finished$2 = false;
    while ((!finished$2)) {
      if (((bitpos$2 & leftNodeRightNode) !== 0)) {
        var leftNode = this.getNode__I__sci_SetNode(leftNodeIdx);
        var newNode = leftNode.concat__sci_SetNode__I__sci_SetNode(that.getNode__I__sci_SetNode(rightNodeIdx), nextShift);
        if ((leftNode !== newNode)) {
          anyChangesMadeSoFar = true;
        }
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = newNode;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var n = that.getNode__I__sci_SetNode(rightNodeIdx);
        var leftPayload = this.getPayload__I__O(leftDataIdx);
        var leftOriginalHash = this.getHash__I__I(leftDataIdx);
        var leftImproved = $m_sc_Hashing$().improve__I__I(leftOriginalHash);
        var newNode$2 = n.updated__O__I__I__I__sci_SetNode(leftPayload, leftOriginalHash, leftImproved, nextShift);
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = newNode$2;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((newSize + newNode$2.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$2.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftNodeRightData) !== 0)) {
        var rightOriginalHash = that.getHash__I__I(rightDataIdx);
        var leftNode$2 = this.getNode__I__sci_SetNode(leftNodeIdx);
        var updated = leftNode$2.updated__O__I__I__I__sci_SetNode(that.getPayload__I__O(rightDataIdx), that.getHash__I__I(rightDataIdx), $m_sc_Hashing$().improve__I__I(rightOriginalHash), nextShift);
        if ((updated !== leftNode$2)) {
          anyChangesMadeSoFar = true;
        }
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = updated;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + updated.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + updated.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataOnly) !== 0)) {
        var originalHash$2 = this.sci_BitmapIndexedSetNode__f_originalHashes.u[leftDataIdx];
        newContent.u[compressedDataIdx] = this.getPayload__I__O(leftDataIdx);
        newOriginalHashes.u[compressedDataIdx] = originalHash$2;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$2)) | 0);
      } else if (((bitpos$2 & rightDataOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var originalHash$3 = that.sci_BitmapIndexedSetNode__f_originalHashes.u[rightDataIdx];
        newContent.u[compressedDataIdx] = that.getPayload__I__O(rightDataIdx);
        newOriginalHashes.u[compressedDataIdx] = originalHash$3;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$3)) | 0);
      } else if (((bitpos$2 & leftNodeOnly) !== 0)) {
        var newNode$4 = this.getNode__I__sci_SetNode(leftNodeIdx);
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = newNode$4;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftNodeIdx = ((1 + leftNodeIdx) | 0);
        newSize = ((newSize + newNode$4.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$4.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & rightNodeOnly) !== 0)) {
        anyChangesMadeSoFar = true;
        var newNode$5 = that.getNode__I__sci_SetNode(rightNodeIdx);
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = newNode$5;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        rightNodeIdx = ((1 + rightNodeIdx) | 0);
        newSize = ((newSize + newNode$5.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$5.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightDataMigrateToNode) !== 0)) {
        anyChangesMadeSoFar = true;
        var leftOriginalHash$2 = this.getHash__I__I(leftDataIdx);
        var rightOriginalHash$2 = that.getHash__I__I(rightDataIdx);
        var newNode$6 = that.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(this.getPayload__I__O(leftDataIdx), leftOriginalHash$2, $m_sc_Hashing$().improve__I__I(leftOriginalHash$2), that.getPayload__I__O(rightDataIdx), rightOriginalHash$2, $m_sc_Hashing$().improve__I__I(rightOriginalHash$2), nextShift);
        newContent.u[(((-1) + ((newContentSize - compressedNodeIdx) | 0)) | 0)] = newNode$6;
        compressedNodeIdx = ((1 + compressedNodeIdx) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((newSize + newNode$6.size__I()) | 0);
        newCachedHashCode = ((newCachedHashCode + newNode$6.cachedJavaKeySetHashCode__I()) | 0);
      } else if (((bitpos$2 & leftDataRightDataLeftOverwrites) !== 0)) {
        var originalHash$4 = that.sci_BitmapIndexedSetNode__f_originalHashes.u[rightDataIdx];
        newContent.u[compressedDataIdx] = that.getPayload__I__O(rightDataIdx);
        newOriginalHashes.u[compressedDataIdx] = originalHash$4;
        compressedDataIdx = ((1 + compressedDataIdx) | 0);
        rightDataIdx = ((1 + rightDataIdx) | 0);
        newSize = ((1 + newSize) | 0);
        newCachedHashCode = ((newCachedHashCode + $m_sc_Hashing$().improve__I__I(originalHash$4)) | 0);
        leftDataIdx = ((1 + leftDataIdx) | 0);
      }
      if ((bitpos$2 === maximumBitPos)) {
        finished$2 = true;
      } else {
        bitpos$2 = (bitpos$2 << 1);
      }
    }
    return (anyChangesMadeSoFar ? new $c_sci_BitmapIndexedSetNode(newDataMap, newNodeMap, newContent, newOriginalHashes, newSize, newCachedHashCode) : this);
  } else {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode");
  }
});
$c_sci_BitmapIndexedSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var i = this.sci_BitmapIndexedSetNode__f_dataMap;
  var iN = $m_jl_Integer$().bitCount__I__I(i);
  var i$1 = 0;
  while ((i$1 < iN)) {
    f.apply__O__O__O(this.getPayload__I__O(i$1), this.getHash__I__I(i$1));
    i$1 = ((1 + i$1) | 0);
  }
  var i$2 = this.sci_BitmapIndexedSetNode__f_nodeMap;
  var jN = $m_jl_Integer$().bitCount__I__I(i$2);
  var j = 0;
  while ((j < jN)) {
    this.getNode__I__sci_SetNode(j).foreachWithHash__F2__V(f);
    j = ((1 + j) | 0);
  }
});
$c_sci_BitmapIndexedSetNode.prototype.concat__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  return this.concat__sci_SetNode__I__sci_BitmapIndexedSetNode(that, shift);
});
$c_sci_BitmapIndexedSetNode.prototype.copy__sci_SetNode = (function() {
  return this.copy__sci_BitmapIndexedSetNode();
});
$c_sci_BitmapIndexedSetNode.prototype.diff__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  return this.diff__sci_SetNode__I__sci_BitmapIndexedSetNode(that, shift);
});
$c_sci_BitmapIndexedSetNode.prototype.filterImpl__F1__Z__sci_SetNode = (function(pred, flipped) {
  return this.filterImpl__F1__Z__sci_BitmapIndexedSetNode(pred, flipped);
});
$c_sci_BitmapIndexedSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.removed__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift);
});
$c_sci_BitmapIndexedSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return this.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash, hash, shift);
});
$c_sci_BitmapIndexedSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index);
});
function $isArrayOf_sci_BitmapIndexedSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BitmapIndexedSetNode)));
}
export { $isArrayOf_sci_BitmapIndexedSetNode as $isArrayOf_sci_BitmapIndexedSetNode };
var $d_sci_BitmapIndexedSetNode = new $TypeData().initClass($c_sci_BitmapIndexedSetNode, "scala.collection.immutable.BitmapIndexedSetNode", ({
  sci_BitmapIndexedSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1
}));
export { $d_sci_BitmapIndexedSetNode as $d_sci_BitmapIndexedSetNode };
/** @constructor */
function $c_sci_HashCollisionMapNode(originalHash, hash, content) {
  this.sci_HashCollisionMapNode__f_originalHash = 0;
  this.sci_HashCollisionMapNode__f_hash = 0;
  this.sci_HashCollisionMapNode__f_content = null;
  this.sci_HashCollisionMapNode__f_originalHash = originalHash;
  this.sci_HashCollisionMapNode__f_hash = hash;
  this.sci_HashCollisionMapNode__f_content = content;
  $m_s_Predef$().require__Z__V((this.sci_HashCollisionMapNode__f_content.length__I() >= 2));
}
export { $c_sci_HashCollisionMapNode as $c_sci_HashCollisionMapNode };
$c_sci_HashCollisionMapNode.prototype = new $h_sci_MapNode();
$c_sci_HashCollisionMapNode.prototype.constructor = $c_sci_HashCollisionMapNode;
/** @constructor */
function $h_sci_HashCollisionMapNode() {
}
export { $h_sci_HashCollisionMapNode as $h_sci_HashCollisionMapNode };
$h_sci_HashCollisionMapNode.prototype = $c_sci_HashCollisionMapNode.prototype;
$c_sci_HashCollisionMapNode.prototype.indexOf__O__I = (function(key) {
  var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
  var i = 0;
  while (iter.hasNext__Z()) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(iter.next__O()._1__O(), key)) {
      return i;
    }
    i = ((1 + i) | 0);
  }
  return (-1);
});
$c_sci_HashCollisionMapNode.prototype.size__I = (function() {
  return this.sci_HashCollisionMapNode__f_content.length__I();
});
$c_sci_HashCollisionMapNode.prototype.apply__O__I__I__I__O = (function(key, originalHash, hash, shift) {
  var this$1 = this.get__O__I__I__I__s_Option(key, originalHash, hash, shift);
  if (this$1.isEmpty__Z()) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
    throw new $c_jl_ClassCastException();
  } else {
    return this$1.get__O();
  }
});
$c_sci_HashCollisionMapNode.prototype.get__O__I__I__I__s_Option = (function(key, originalHash, hash, shift) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var index = this.indexOf__O__I(key);
    return ((index >= 0) ? new $c_s_Some(this.sci_HashCollisionMapNode__f_content.apply__I__O(index)._2__O()) : $m_s_None$());
  } else {
    return $m_s_None$();
  }
});
$c_sci_HashCollisionMapNode.prototype.getOrElse__O__I__I__I__F0__O = (function(key, originalHash, hash, shift, f) {
  if ((this.sci_HashCollisionMapNode__f_hash === hash)) {
    var x1 = this.indexOf__O__I(key);
    return ((x1 === (-1)) ? f.apply__O() : this.sci_HashCollisionMapNode__f_content.apply__I__O(x1)._2__O());
  } else {
    return f.apply__O();
  }
});
$c_sci_HashCollisionMapNode.prototype.containsKey__O__I__I__I__Z = (function(key, originalHash, hash, shift) {
  return ((this.sci_HashCollisionMapNode__f_hash === hash) && (this.indexOf__O__I(key) >= 0));
});
$c_sci_HashCollisionMapNode.prototype.updated__O__O__I__I__I__Z__sci_MapNode = (function(key, value, originalHash, hash, shift, replaceValue) {
  var index = this.indexOf__O__I(key);
  return ((index >= 0) ? (replaceValue ? (Object.is(this.sci_HashCollisionMapNode__f_content.apply__I__O(index)._2__O(), value) ? this : new $c_sci_HashCollisionMapNode(originalHash, hash, this.sci_HashCollisionMapNode__f_content.updated__I__O__sci_Vector(index, $ct_T2__O__O__(new $c_T2(), key, value)))) : this) : new $c_sci_HashCollisionMapNode(originalHash, hash, this.sci_HashCollisionMapNode__f_content.appended__O__sci_Vector($ct_T2__O__O__(new $c_T2(), key, value))));
});
$c_sci_HashCollisionMapNode.prototype.removed__O__I__I__I__sci_MapNode = (function(key, originalHash, hash, shift) {
  if ((!this.containsKey__O__I__I__I__Z(key, originalHash, hash, shift))) {
    return this;
  } else {
    var this$1 = this.sci_HashCollisionMapNode__f_content;
    var pred = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((keyValuePair$2$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(keyValuePair$2$2._1__O(), key)));
    var updatedContent = this$1.filterImpl__F1__Z__sci_Vector(pred, true);
    var x1 = updatedContent.length__I();
    if ((x1 === 1)) {
      var x1$2 = updatedContent.apply__I__O(0);
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2);
      }
      var k = x1$2._1__O();
      var v = x1$2._2__O();
      return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([originalHash])), 1, hash);
    } else {
      return new $c_sci_HashCollisionMapNode(originalHash, hash, updatedContent);
    }
  }
});
$c_sci_HashCollisionMapNode.prototype.hasNodes__Z = (function() {
  return false;
});
$c_sci_HashCollisionMapNode.prototype.nodeArity__I = (function() {
  return 0;
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_MapNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.");
});
$c_sci_HashCollisionMapNode.prototype.hasPayload__Z = (function() {
  return true;
});
$c_sci_HashCollisionMapNode.prototype.payloadArity__I = (function() {
  return this.sci_HashCollisionMapNode__f_content.length__I();
});
$c_sci_HashCollisionMapNode.prototype.getKey__I__O = (function(index) {
  return this.sci_HashCollisionMapNode__f_content.apply__I__O(index)._1__O();
});
$c_sci_HashCollisionMapNode.prototype.getValue__I__O = (function(index) {
  return this.sci_HashCollisionMapNode__f_content.apply__I__O(index)._2__O();
});
$c_sci_HashCollisionMapNode.prototype.getPayload__I__T2 = (function(index) {
  return this.sci_HashCollisionMapNode__f_content.apply__I__O(index);
});
$c_sci_HashCollisionMapNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionMapNode__f_originalHash;
});
$c_sci_HashCollisionMapNode.prototype.foreach__F1__V = (function(f) {
  this.sci_HashCollisionMapNode__f_content.foreach__F1__V(f);
});
$c_sci_HashCollisionMapNode.prototype.foreachEntry__F2__V = (function(f) {
  this.sci_HashCollisionMapNode__f_content.foreach__F1__V(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x0$1$2$2) => {
    if ((x0$1$2$2 !== null)) {
      var k = x0$1$2$2._1__O();
      var v = x0$1$2$2._2__O();
      return f.apply__O__O__O(k, v);
    } else {
      throw new $c_s_MatchError(x0$1$2$2);
    }
  })));
});
$c_sci_HashCollisionMapNode.prototype.foreachWithHash__F3__V = (function(f) {
  var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var next = iter.next__O();
    f.apply__O__O__O__O(next._1__O(), next._2__O(), this.sci_HashCollisionMapNode__f_originalHash);
  }
});
$c_sci_HashCollisionMapNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    if ((this === that)) {
      return true;
    } else if (((this.sci_HashCollisionMapNode__f_hash === that.sci_HashCollisionMapNode__f_hash) && (this.sci_HashCollisionMapNode__f_content.length__I() === that.sci_HashCollisionMapNode__f_content.length__I()))) {
      var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var x1$2 = iter.next__O();
        if ((x1$2 === null)) {
          throw new $c_s_MatchError(x1$2);
        }
        var key = x1$2._1__O();
        var value = x1$2._2__O();
        var index = that.indexOf__O__I(key);
        if (((index < 0) || (!$m_sr_BoxesRunTime$().equals__O__O__Z(value, that.sci_HashCollisionMapNode__f_content.apply__I__O(index)._2__O())))) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_sci_HashCollisionMapNode.prototype.concat__sci_MapNode__I__sci_HashCollisionMapNode = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionMapNode)) {
    if ((that === this)) {
      return this;
    } else {
      var newContent = null;
      var iter = this.sci_HashCollisionMapNode__f_content.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var nextPayload = iter.next__O();
        if ((that.indexOf__O__I(nextPayload._1__O()) < 0)) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            newContent.addAll__sc_IterableOnce__sci_VectorBuilder(that.sci_HashCollisionMapNode__f_content);
          }
          newContent.addOne__O__sci_VectorBuilder(nextPayload);
        }
      }
      return ((newContent === null) ? that : new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, newContent.result__sci_Vector()));
    }
  } else if ((that instanceof $c_sci_BitmapIndexedMapNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionMapNode with a BitmapIndexedMapNode");
  } else {
    throw new $c_s_MatchError(that);
  }
});
$c_sci_HashCollisionMapNode.prototype.filterImpl__F1__Z__sci_MapNode = (function(pred, flipped) {
  var newContent = this.sci_HashCollisionMapNode__f_content.filterImpl__F1__Z__sci_Vector(pred, flipped);
  var newContentLength = newContent.length__I();
  if ((newContentLength === 0)) {
    var this$1 = $m_sci_MapNode$();
    return this$1.sci_MapNode$__f_EmptyMapNode;
  } else if ((newContentLength === 1)) {
    var x1 = newContent.head__O();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1._1__O();
    var v = x1._2__O();
    return new $c_sci_BitmapIndexedMapNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(this.sci_HashCollisionMapNode__f_hash, 0)), 0, new $ac_O([k, v]), new $ac_I(new Int32Array([this.sci_HashCollisionMapNode__f_originalHash])), 1, this.sci_HashCollisionMapNode__f_hash);
  } else {
    return ((newContentLength === this.sci_HashCollisionMapNode__f_content.length__I()) ? this : new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, newContent));
  }
});
$c_sci_HashCollisionMapNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_HashCollisionMapNode.prototype.toString__T = (function() {
  var i = $systemIdentityHashCode(this);
  return (($objectClassName(this) + "@") + (i >>> 0.0).toString(16));
});
$c_sci_HashCollisionMapNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul(this.sci_HashCollisionMapNode__f_content.length__I(), this.sci_HashCollisionMapNode__f_hash);
});
$c_sci_HashCollisionMapNode.prototype.copy__sci_MapNode = (function() {
  return new $c_sci_HashCollisionMapNode(this.sci_HashCollisionMapNode__f_originalHash, this.sci_HashCollisionMapNode__f_hash, this.sci_HashCollisionMapNode__f_content);
});
$c_sci_HashCollisionMapNode.prototype.concat__sci_MapNode__I__sci_MapNode = (function(that, shift) {
  return this.concat__sci_MapNode__I__sci_HashCollisionMapNode(that, shift);
});
$c_sci_HashCollisionMapNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_MapNode(index);
});
function $isArrayOf_sci_HashCollisionMapNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionMapNode)));
}
export { $isArrayOf_sci_HashCollisionMapNode as $isArrayOf_sci_HashCollisionMapNode };
var $d_sci_HashCollisionMapNode = new $TypeData().initClass($c_sci_HashCollisionMapNode, "scala.collection.immutable.HashCollisionMapNode", ({
  sci_HashCollisionMapNode: 1,
  sci_MapNode: 1,
  sci_Node: 1
}));
export { $d_sci_HashCollisionMapNode as $d_sci_HashCollisionMapNode };
/** @constructor */
function $c_sci_HashCollisionSetNode(originalHash, hash, content) {
  this.sci_HashCollisionSetNode__f_originalHash = 0;
  this.sci_HashCollisionSetNode__f_hash = 0;
  this.sci_HashCollisionSetNode__f_content = null;
  this.sci_HashCollisionSetNode__f_originalHash = originalHash;
  this.sci_HashCollisionSetNode__f_hash = hash;
  this.sci_HashCollisionSetNode__f_content = content;
  $m_s_Predef$().require__Z__V((this.sci_HashCollisionSetNode__f_content.length__I() >= 2));
}
export { $c_sci_HashCollisionSetNode as $c_sci_HashCollisionSetNode };
$c_sci_HashCollisionSetNode.prototype = new $h_sci_SetNode();
$c_sci_HashCollisionSetNode.prototype.constructor = $c_sci_HashCollisionSetNode;
/** @constructor */
function $h_sci_HashCollisionSetNode() {
}
export { $h_sci_HashCollisionSetNode as $h_sci_HashCollisionSetNode };
$h_sci_HashCollisionSetNode.prototype = $c_sci_HashCollisionSetNode.prototype;
$c_sci_HashCollisionSetNode.prototype.contains__O__I__I__I__Z = (function(element, originalHash, hash, shift) {
  if ((this.sci_HashCollisionSetNode__f_hash === hash)) {
    var this$1 = this.sci_HashCollisionSetNode__f_content;
    return $f_sc_SeqOps__contains__O__Z(this$1, element);
  } else {
    return false;
  }
});
$c_sci_HashCollisionSetNode.prototype.updated__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  return (this.contains__O__I__I__I__Z(element, originalHash, hash, shift) ? this : new $c_sci_HashCollisionSetNode(originalHash, hash, this.sci_HashCollisionSetNode__f_content.appended__O__sci_Vector(element)));
});
$c_sci_HashCollisionSetNode.prototype.removed__O__I__I__I__sci_SetNode = (function(element, originalHash, hash, shift) {
  if ((!this.contains__O__I__I__I__Z(element, originalHash, hash, shift))) {
    return this;
  } else {
    var this$1 = this.sci_HashCollisionSetNode__f_content;
    var pred = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((element0$2$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(element0$2$2, element)));
    var updatedContent = this$1.filterImpl__F1__Z__sci_Vector(pred, true);
    var x1 = updatedContent.length__I();
    return ((x1 === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(hash, 0)), 0, new $ac_O([updatedContent.apply__I__O(0)]), new $ac_I(new Int32Array([originalHash])), 1, hash) : new $c_sci_HashCollisionSetNode(originalHash, hash, updatedContent));
  }
});
$c_sci_HashCollisionSetNode.prototype.hasNodes__Z = (function() {
  return false;
});
$c_sci_HashCollisionSetNode.prototype.nodeArity__I = (function() {
  return 0;
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_SetNode = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), "No sub-nodes present in hash-collision leaf node.");
});
$c_sci_HashCollisionSetNode.prototype.hasPayload__Z = (function() {
  return true;
});
$c_sci_HashCollisionSetNode.prototype.payloadArity__I = (function() {
  return this.sci_HashCollisionSetNode__f_content.length__I();
});
$c_sci_HashCollisionSetNode.prototype.getPayload__I__O = (function(index) {
  return this.sci_HashCollisionSetNode__f_content.apply__I__O(index);
});
$c_sci_HashCollisionSetNode.prototype.getHash__I__I = (function(index) {
  return this.sci_HashCollisionSetNode__f_originalHash;
});
$c_sci_HashCollisionSetNode.prototype.size__I = (function() {
  return this.sci_HashCollisionSetNode__f_content.length__I();
});
$c_sci_HashCollisionSetNode.prototype.foreach__F1__V = (function(f) {
  var iter = this.sci_HashCollisionSetNode__f_content.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    f.apply__O__O(iter.next__O());
  }
});
$c_sci_HashCollisionSetNode.prototype.cachedJavaKeySetHashCode__I = (function() {
  return Math.imul(this.sci_HashCollisionSetNode__f_content.length__I(), this.sci_HashCollisionSetNode__f_hash);
});
$c_sci_HashCollisionSetNode.prototype.subsetOf__sci_SetNode__I__Z = (function(that, shift) {
  if ((this === that)) {
    return true;
  } else if ((that instanceof $c_sci_HashCollisionSetNode)) {
    if ((this.sci_HashCollisionSetNode__f_content.length__I() <= that.sci_HashCollisionSetNode__f_content.length__I())) {
      var this$1 = this.sci_HashCollisionSetNode__f_content;
      var eta$0$1 = that.sci_HashCollisionSetNode__f_content;
      var res = true;
      var it = this$1.iterator__sc_Iterator();
      while ((res && it.hasNext__Z())) {
        var x0 = it.next__O();
        res = $f_sc_SeqOps__contains__O__Z(eta$0$1, x0);
      }
      return res;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_sci_HashCollisionSetNode.prototype.filterImpl__F1__Z__sci_SetNode = (function(pred, flipped) {
  var newContent = this.sci_HashCollisionSetNode__f_content.filterImpl__F1__Z__sci_Vector(pred, flipped);
  var newContentLength = newContent.length__I();
  if ((newContentLength === 0)) {
    var this$1 = $m_sci_SetNode$();
    return this$1.sci_SetNode$__f_EmptySetNode;
  } else {
    return ((newContentLength === 1) ? new $c_sci_BitmapIndexedSetNode($m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(this.sci_HashCollisionSetNode__f_hash, 0)), 0, new $ac_O([newContent.head__O()]), new $ac_I(new Int32Array([this.sci_HashCollisionSetNode__f_originalHash])), 1, this.sci_HashCollisionSetNode__f_hash) : ((newContent.length__I() === this.sci_HashCollisionSetNode__f_content.length__I()) ? this : new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, newContent)));
  }
});
$c_sci_HashCollisionSetNode.prototype.diff__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  return this.filterImpl__F1__Z__sci_SetNode(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2$2) => that.contains__O__I__I__I__Z(x$1$2$2, this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, shift))), true);
});
$c_sci_HashCollisionSetNode.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    if ((this === that)) {
      return true;
    } else {
      if ((this.sci_HashCollisionSetNode__f_hash === that.sci_HashCollisionSetNode__f_hash)) {
        var this$1 = this.sci_HashCollisionSetNode__f_content;
        var $x_2 = this$1.length__I();
        var this$2 = that.sci_HashCollisionSetNode__f_content;
        var $x_1 = ($x_2 === this$2.length__I());
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var this$3 = this.sci_HashCollisionSetNode__f_content;
        var eta$0$1 = that.sci_HashCollisionSetNode__f_content;
        var res = true;
        var it = this$3.iterator__sc_Iterator();
        while ((res && it.hasNext__Z())) {
          var x0 = it.next__O();
          res = $f_sc_SeqOps__contains__O__Z(eta$0$1, x0);
        }
        return res;
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_sci_HashCollisionSetNode.prototype.hashCode__I = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Trie nodes do not support hashing.");
});
$c_sci_HashCollisionSetNode.prototype.concat__sci_SetNode__I__sci_SetNode = (function(that, shift) {
  if ((that instanceof $c_sci_HashCollisionSetNode)) {
    if ((that === this)) {
      return this;
    } else {
      var newContent = null;
      var iter = that.sci_HashCollisionSetNode__f_content.iterator__sc_Iterator();
      while (iter.hasNext__Z()) {
        var nextPayload = iter.next__O();
        var this$1 = this.sci_HashCollisionSetNode__f_content;
        if ((!$f_sc_SeqOps__contains__O__Z(this$1, nextPayload))) {
          if ((newContent === null)) {
            newContent = new $c_sci_VectorBuilder();
            newContent.addAll__sc_IterableOnce__sci_VectorBuilder(this.sci_HashCollisionSetNode__f_content);
          }
          newContent.addOne__O__sci_VectorBuilder(nextPayload);
        }
      }
      return ((newContent === null) ? this : new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, newContent.result__sci_Vector()));
    }
  } else if ((that instanceof $c_sci_BitmapIndexedSetNode)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "Cannot concatenate a HashCollisionSetNode with a BitmapIndexedSetNode");
  } else {
    throw new $c_s_MatchError(that);
  }
});
$c_sci_HashCollisionSetNode.prototype.foreachWithHash__F2__V = (function(f) {
  var iter = this.sci_HashCollisionSetNode__f_content.iterator__sc_Iterator();
  while (iter.hasNext__Z()) {
    var next = iter.next__O();
    f.apply__O__O__O(next, this.sci_HashCollisionSetNode__f_originalHash);
  }
});
$c_sci_HashCollisionSetNode.prototype.copy__sci_SetNode = (function() {
  return new $c_sci_HashCollisionSetNode(this.sci_HashCollisionSetNode__f_originalHash, this.sci_HashCollisionSetNode__f_hash, this.sci_HashCollisionSetNode__f_content);
});
$c_sci_HashCollisionSetNode.prototype.getNode__I__sci_Node = (function(index) {
  return this.getNode__I__sci_SetNode(index);
});
function $isArrayOf_sci_HashCollisionSetNode(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashCollisionSetNode)));
}
export { $isArrayOf_sci_HashCollisionSetNode as $isArrayOf_sci_HashCollisionSetNode };
var $d_sci_HashCollisionSetNode = new $TypeData().initClass($c_sci_HashCollisionSetNode, "scala.collection.immutable.HashCollisionSetNode", ({
  sci_HashCollisionSetNode: 1,
  sci_SetNode: 1,
  sci_Node: 1
}));
export { $d_sci_HashCollisionSetNode as $d_sci_HashCollisionSetNode };
/** @constructor */
function $c_sci_HashMap$() {
  this.sci_HashMap$__f_EmptyMap = null;
  $n_sci_HashMap$ = this;
  var this$1 = $m_sci_MapNode$();
  this.sci_HashMap$__f_EmptyMap = new $c_sci_HashMap(this$1.sci_MapNode$__f_EmptyMapNode);
}
export { $c_sci_HashMap$ as $c_sci_HashMap$ };
$c_sci_HashMap$.prototype = new $h_O();
$c_sci_HashMap$.prototype.constructor = $c_sci_HashMap$;
/** @constructor */
function $h_sci_HashMap$() {
}
export { $h_sci_HashMap$ as $h_sci_HashMap$ };
$h_sci_HashMap$.prototype = $c_sci_HashMap$.prototype;
$c_sci_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_HashMap(elems);
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__sci_HashMap = (function(source) {
  if ((source instanceof $c_sci_HashMap)) {
    return source;
  } else {
    var this$1 = new $c_sci_HashMapBuilder();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_HashMapBuilder(source);
    return this$2.result__sci_HashMap();
  }
});
$c_sci_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashMapBuilder();
});
$c_sci_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_HashMap(it);
});
$c_sci_HashMap$.prototype.empty__O = (function() {
  return this.sci_HashMap$__f_EmptyMap;
});
var $d_sci_HashMap$ = new $TypeData().initClass($c_sci_HashMap$, "scala.collection.immutable.HashMap$", ({
  sci_HashMap$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_HashMap$ as $d_sci_HashMap$ };
var $n_sci_HashMap$;
function $m_sci_HashMap$() {
  if ((!$n_sci_HashMap$)) {
    $n_sci_HashMap$ = new $c_sci_HashMap$();
  }
  return $n_sci_HashMap$;
}
export { $m_sci_HashMap$ as $m_sci_HashMap$ };
/** @constructor */
function $c_sci_HashSet$() {
  this.sci_HashSet$__f_EmptySet = null;
  $n_sci_HashSet$ = this;
  var this$1 = $m_sci_SetNode$();
  this.sci_HashSet$__f_EmptySet = new $c_sci_HashSet(this$1.sci_SetNode$__f_EmptySetNode);
}
export { $c_sci_HashSet$ as $c_sci_HashSet$ };
$c_sci_HashSet$.prototype = new $h_O();
$c_sci_HashSet$.prototype.constructor = $c_sci_HashSet$;
/** @constructor */
function $h_sci_HashSet$() {
}
export { $h_sci_HashSet$ as $h_sci_HashSet$ };
$h_sci_HashSet$.prototype = $c_sci_HashSet$.prototype;
$c_sci_HashSet$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_HashSet(elems);
});
$c_sci_HashSet$.prototype.from__sc_IterableOnce__sci_HashSet = (function(source) {
  if ((source instanceof $c_sci_HashSet)) {
    return source;
  } else if ((source.knownSize__I() === 0)) {
    return this.sci_HashSet$__f_EmptySet;
  } else {
    var this$1 = new $c_sci_HashSetBuilder();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_HashSetBuilder(source);
    return this$2.result__sci_HashSet();
  }
});
$c_sci_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_HashSetBuilder();
});
$c_sci_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_HashSet(source);
});
$c_sci_HashSet$.prototype.empty__O = (function() {
  return this.sci_HashSet$__f_EmptySet;
});
var $d_sci_HashSet$ = new $TypeData().initClass($c_sci_HashSet$, "scala.collection.immutable.HashSet$", ({
  sci_HashSet$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_HashSet$ as $d_sci_HashSet$ };
var $n_sci_HashSet$;
function $m_sci_HashSet$() {
  if ((!$n_sci_HashSet$)) {
    $n_sci_HashSet$ = new $c_sci_HashSet$();
  }
  return $n_sci_HashSet$;
}
export { $m_sci_HashSet$ as $m_sci_HashSet$ };
/** @constructor */
function $c_sci_LazyList$WithFilter(lazyList, p) {
  this.sci_LazyList$WithFilter__f_filtered = null;
  this.sci_LazyList$WithFilter__f_filtered = lazyList.filter__F1__sci_LazyList(p);
}
export { $c_sci_LazyList$WithFilter as $c_sci_LazyList$WithFilter };
$c_sci_LazyList$WithFilter.prototype = new $h_sc_WithFilter();
$c_sci_LazyList$WithFilter.prototype.constructor = $c_sci_LazyList$WithFilter;
/** @constructor */
function $h_sci_LazyList$WithFilter() {
}
export { $h_sci_LazyList$WithFilter as $h_sci_LazyList$WithFilter };
$h_sci_LazyList$WithFilter.prototype = $c_sci_LazyList$WithFilter.prototype;
$c_sci_LazyList$WithFilter.prototype.foreach__F1__V = (function(f) {
  this.sci_LazyList$WithFilter__f_filtered.foreach__F1__V(f);
});
var $d_sci_LazyList$WithFilter = new $TypeData().initClass($c_sci_LazyList$WithFilter, "scala.collection.immutable.LazyList$WithFilter", ({
  sci_LazyList$WithFilter: 1,
  sc_WithFilter: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_LazyList$WithFilter as $d_sci_LazyList$WithFilter };
/** @constructor */
function $c_sci_ListMap$() {
}
export { $c_sci_ListMap$ as $c_sci_ListMap$ };
$c_sci_ListMap$.prototype = new $h_O();
$c_sci_ListMap$.prototype.constructor = $c_sci_ListMap$;
/** @constructor */
function $h_sci_ListMap$() {
}
export { $h_sci_ListMap$ as $h_sci_ListMap$ };
$h_sci_ListMap$.prototype = $c_sci_ListMap$.prototype;
$c_sci_ListMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_ListMap(elems);
});
$c_sci_ListMap$.prototype.from__sc_IterableOnce__sci_ListMap = (function(it) {
  if ((it instanceof $c_sci_ListMap)) {
    return it;
  } else if ((it instanceof $c_scm_LinkedHashMap)) {
    var current = $m_sci_ListMap$EmptyListMap$();
    var firstEntry = it.scm_LinkedHashMap__f_firstEntry;
    while ((firstEntry !== null)) {
      current = new $c_sci_ListMap$Node(firstEntry.scm_LinkedHashMap$LinkedEntry__f_key, firstEntry.scm_LinkedHashMap$LinkedEntry__f_value, current);
      firstEntry = firstEntry.scm_LinkedHashMap$LinkedEntry__f_later;
    }
    return current;
  } else if (($is_sc_Map(it) || $is_sc_MapView(it))) {
    var current$2 = $m_sci_ListMap$EmptyListMap$();
    var iter = it.iterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var x1$2 = iter.next__O();
      if ((x1$2 === null)) {
        throw new $c_s_MatchError(x1$2);
      }
      var k = x1$2._1__O();
      var v = x1$2._2__O();
      current$2 = new $c_sci_ListMap$Node(k, v, current$2);
    }
    return current$2;
  } else {
    var this$1 = new $c_sci_ListMapBuilder();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_ListMapBuilder(it);
    return this$2.result__sci_ListMap();
  }
});
$c_sci_ListMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_ListMapBuilder();
});
$c_sci_ListMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_ListMap(it);
});
$c_sci_ListMap$.prototype.empty__O = (function() {
  return $m_sci_ListMap$EmptyListMap$();
});
var $d_sci_ListMap$ = new $TypeData().initClass($c_sci_ListMap$, "scala.collection.immutable.ListMap$", ({
  sci_ListMap$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ListMap$ as $d_sci_ListMap$ };
var $n_sci_ListMap$;
function $m_sci_ListMap$() {
  if ((!$n_sci_ListMap$)) {
    $n_sci_ListMap$ = new $c_sci_ListMap$();
  }
  return $n_sci_ListMap$;
}
export { $m_sci_ListMap$ as $m_sci_ListMap$ };
/** @constructor */
function $c_sci_Map$() {
}
export { $c_sci_Map$ as $c_sci_Map$ };
$c_sci_Map$.prototype = new $h_O();
$c_sci_Map$.prototype.constructor = $c_sci_Map$;
/** @constructor */
function $h_sci_Map$() {
}
export { $h_sci_Map$ as $h_sci_Map$ };
$h_sci_Map$.prototype = $c_sci_Map$.prototype;
$c_sci_Map$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Map(elems);
});
$c_sci_Map$.prototype.from__sc_IterableOnce__sci_Map = (function(it) {
  if ($is_sci_Iterable(it)) {
    if (it.isEmpty__Z()) {
      return $m_sci_Map$EmptyMap$();
    }
  }
  if ((it instanceof $c_sci_HashMap)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map1)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map2)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map3)) {
    return it;
  }
  if ((it instanceof $c_sci_Map$Map4)) {
    return it;
  }
  if ((it instanceof $c_sci_ListMap)) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  if (false) {
    return it;
  }
  var this$1 = new $c_sci_MapBuilderImpl();
  var this$2 = this$1.addAll__sc_IterableOnce__sci_MapBuilderImpl(it);
  return this$2.result__sci_Map();
});
$c_sci_Map$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_MapBuilderImpl();
});
$c_sci_Map$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Map(it);
});
$c_sci_Map$.prototype.empty__O = (function() {
  return $m_sci_Map$EmptyMap$();
});
var $d_sci_Map$ = new $TypeData().initClass($c_sci_Map$, "scala.collection.immutable.Map$", ({
  sci_Map$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Map$ as $d_sci_Map$ };
var $n_sci_Map$;
function $m_sci_Map$() {
  if ((!$n_sci_Map$)) {
    $n_sci_Map$ = new $c_sci_Map$();
  }
  return $n_sci_Map$;
}
export { $m_sci_Map$ as $m_sci_Map$ };
/** @constructor */
function $c_sci_Set$() {
}
export { $c_sci_Set$ as $c_sci_Set$ };
$c_sci_Set$.prototype = new $h_O();
$c_sci_Set$.prototype.constructor = $c_sci_Set$;
/** @constructor */
function $h_sci_Set$() {
}
export { $h_sci_Set$ as $h_sci_Set$ };
$h_sci_Set$.prototype = $c_sci_Set$.prototype;
$c_sci_Set$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Set(elems);
});
$c_sci_Set$.prototype.from__sc_IterableOnce__sci_Set = (function(it) {
  if ((it.knownSize__I() === 0)) {
    return $m_sci_Set$EmptySet$();
  } else if ((it instanceof $c_sci_HashSet)) {
    return it;
  } else if (false) {
    return it;
  } else if ((it instanceof $c_sci_Set$Set1)) {
    return it;
  } else if ((it instanceof $c_sci_Set$Set2)) {
    return it;
  } else if ((it instanceof $c_sci_Set$Set3)) {
    return it;
  } else if ((it instanceof $c_sci_Set$Set4)) {
    return it;
  } else if ((it instanceof $c_sci_HashMap$HashKeySet)) {
    return it;
  } else if ((it instanceof $c_sci_MapOps$ImmutableKeySet)) {
    return it;
  } else {
    var this$1 = new $c_sci_SetBuilderImpl();
    var this$2 = this$1.addAll__sc_IterableOnce__sci_SetBuilderImpl(it);
    return this$2.result__sci_Set();
  }
});
$c_sci_Set$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_SetBuilderImpl();
});
$c_sci_Set$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Set(source);
});
$c_sci_Set$.prototype.empty__O = (function() {
  return $m_sci_Set$EmptySet$();
});
var $d_sci_Set$ = new $TypeData().initClass($c_sci_Set$, "scala.collection.immutable.Set$", ({
  sci_Set$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Set$ as $d_sci_Set$ };
var $n_sci_Set$;
function $m_sci_Set$() {
  if ((!$n_sci_Set$)) {
    $n_sci_Set$ = new $c_sci_Set$();
  }
  return $n_sci_Set$;
}
export { $m_sci_Set$ as $m_sci_Set$ };
function $p_sci_Stream$WithFilter__filtered$lzycompute__sci_Stream($thiz) {
  if ((!$thiz.sci_Stream$WithFilter__f_bitmap$0)) {
    var this$1 = $thiz.sci_Stream$WithFilter__f_s;
    var pred = $thiz.sci_Stream$WithFilter__f_p;
    var f = this$1.filterImpl__F1__Z__sci_Stream(pred, false);
    $thiz.sci_Stream$WithFilter__f_s = null;
    $thiz.sci_Stream$WithFilter__f_filtered = f;
    $thiz.sci_Stream$WithFilter__f_bitmap$0 = true;
  }
  return $thiz.sci_Stream$WithFilter__f_filtered;
}
export { $p_sci_Stream$WithFilter__filtered$lzycompute__sci_Stream as $p_sci_Stream$WithFilter__filtered$lzycompute__sci_Stream };
function $p_sci_Stream$WithFilter__filtered__sci_Stream($thiz) {
  return ((!$thiz.sci_Stream$WithFilter__f_bitmap$0) ? $p_sci_Stream$WithFilter__filtered$lzycompute__sci_Stream($thiz) : $thiz.sci_Stream$WithFilter__f_filtered);
}
export { $p_sci_Stream$WithFilter__filtered__sci_Stream as $p_sci_Stream$WithFilter__filtered__sci_Stream };
/** @constructor */
function $c_sci_Stream$WithFilter(l, p) {
  this.sci_Stream$WithFilter__f_filtered = null;
  this.sci_Stream$WithFilter__f_p = null;
  this.sci_Stream$WithFilter__f_s = null;
  this.sci_Stream$WithFilter__f_bitmap$0 = false;
  this.sci_Stream$WithFilter__f_p = p;
  this.sci_Stream$WithFilter__f_s = l;
}
export { $c_sci_Stream$WithFilter as $c_sci_Stream$WithFilter };
$c_sci_Stream$WithFilter.prototype = new $h_sc_WithFilter();
$c_sci_Stream$WithFilter.prototype.constructor = $c_sci_Stream$WithFilter;
/** @constructor */
function $h_sci_Stream$WithFilter() {
}
export { $h_sci_Stream$WithFilter as $h_sci_Stream$WithFilter };
$h_sci_Stream$WithFilter.prototype = $c_sci_Stream$WithFilter.prototype;
$c_sci_Stream$WithFilter.prototype.foreach__F1__V = (function(f) {
  $p_sci_Stream$WithFilter__filtered__sci_Stream(this).foreach__F1__V(f);
});
var $d_sci_Stream$WithFilter = new $TypeData().initClass($c_sci_Stream$WithFilter, "scala.collection.immutable.Stream$WithFilter", ({
  sci_Stream$WithFilter: 1,
  sc_WithFilter: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Stream$WithFilter as $d_sci_Stream$WithFilter };
function $f_scm_Builder__sizeHint__sc_IterableOnce__I__V($thiz, coll, delta) {
  var x1 = coll.knownSize__I();
  if ((x1 !== (-1))) {
    var that = ((x1 + delta) | 0);
    $thiz.sizeHint__I__V(((that < 0) ? 0 : that));
  }
}
export { $f_scm_Builder__sizeHint__sc_IterableOnce__I__V as $f_scm_Builder__sizeHint__sc_IterableOnce__I__V };
/** @constructor */
function $c_scm_HashMap$() {
}
export { $c_scm_HashMap$ as $c_scm_HashMap$ };
$c_scm_HashMap$.prototype = new $h_O();
$c_scm_HashMap$.prototype.constructor = $c_scm_HashMap$;
/** @constructor */
function $h_scm_HashMap$() {
}
export { $h_scm_HashMap$ as $h_scm_HashMap$ };
$h_scm_HashMap$.prototype = $c_scm_HashMap$.prototype;
$c_scm_HashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_HashMap(elems);
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__scm_HashMap = (function(it) {
  var k = it.knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  return $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), cap, 0.75).addAll__sc_IterableOnce__scm_HashMap(it);
});
$c_scm_HashMap$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashMap$$anon$6(16, 0.75);
});
$c_scm_HashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__scm_HashMap(it);
});
$c_scm_HashMap$.prototype.empty__O = (function() {
  return $ct_scm_HashMap__(new $c_scm_HashMap());
});
var $d_scm_HashMap$ = new $TypeData().initClass($c_scm_HashMap$, "scala.collection.mutable.HashMap$", ({
  scm_HashMap$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_HashMap$ as $d_scm_HashMap$ };
var $n_scm_HashMap$;
function $m_scm_HashMap$() {
  if ((!$n_scm_HashMap$)) {
    $n_scm_HashMap$ = new $c_scm_HashMap$();
  }
  return $n_scm_HashMap$;
}
export { $m_scm_HashMap$ as $m_scm_HashMap$ };
/** @constructor */
function $c_scm_HashSet$() {
}
export { $c_scm_HashSet$ as $c_scm_HashSet$ };
$c_scm_HashSet$.prototype = new $h_O();
$c_scm_HashSet$.prototype.constructor = $c_scm_HashSet$;
/** @constructor */
function $h_scm_HashSet$() {
}
export { $h_scm_HashSet$ as $h_scm_HashSet$ };
$h_scm_HashSet$.prototype = $c_scm_HashSet$.prototype;
$c_scm_HashSet$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_HashSet(elems);
});
$c_scm_HashSet$.prototype.from__sc_IterableOnce__scm_HashSet = (function(it) {
  var k = it.knownSize__I();
  var cap = ((k > 0) ? $doubleToInt((((1 + k) | 0) / 0.75)) : 16);
  var this$1 = $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), cap, 0.75);
  return this$1.addAll__sc_IterableOnce__scm_HashSet(it);
});
$c_scm_HashSet$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_HashSet$$anon$4(16, 0.75);
});
$c_scm_HashSet$.prototype.empty__O = (function() {
  return $ct_scm_HashSet__(new $c_scm_HashSet());
});
$c_scm_HashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_HashSet(source);
});
var $d_scm_HashSet$ = new $TypeData().initClass($c_scm_HashSet$, "scala.collection.mutable.HashSet$", ({
  scm_HashSet$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_HashSet$ as $d_scm_HashSet$ };
var $n_scm_HashSet$;
function $m_scm_HashSet$() {
  if ((!$n_scm_HashSet$)) {
    $n_scm_HashSet$ = new $c_scm_HashSet$();
  }
  return $n_scm_HashSet$;
}
export { $m_scm_HashSet$ as $m_scm_HashSet$ };
/** @constructor */
function $c_scm_LinkedHashMap$() {
}
export { $c_scm_LinkedHashMap$ as $c_scm_LinkedHashMap$ };
$c_scm_LinkedHashMap$.prototype = new $h_O();
$c_scm_LinkedHashMap$.prototype.constructor = $c_scm_LinkedHashMap$;
/** @constructor */
function $h_scm_LinkedHashMap$() {
}
export { $h_scm_LinkedHashMap$ as $h_scm_LinkedHashMap$ };
$h_scm_LinkedHashMap$.prototype = $c_scm_LinkedHashMap$.prototype;
$c_scm_LinkedHashMap$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_LinkedHashMap(elems);
});
$c_scm_LinkedHashMap$.prototype.from__sc_IterableOnce__scm_LinkedHashMap = (function(it) {
  var newlhm = new $c_scm_LinkedHashMap();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(newlhm, it, 0);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(newlhm, it);
  return newlhm;
});
$c_scm_LinkedHashMap$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_LinkedHashMap());
});
$c_scm_LinkedHashMap$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__scm_LinkedHashMap(it);
});
$c_scm_LinkedHashMap$.prototype.empty__O = (function() {
  return new $c_scm_LinkedHashMap();
});
var $d_scm_LinkedHashMap$ = new $TypeData().initClass($c_scm_LinkedHashMap$, "scala.collection.mutable.LinkedHashMap$", ({
  scm_LinkedHashMap$: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_LinkedHashMap$ as $d_scm_LinkedHashMap$ };
var $n_scm_LinkedHashMap$;
function $m_scm_LinkedHashMap$() {
  if ((!$n_scm_LinkedHashMap$)) {
    $n_scm_LinkedHashMap$ = new $c_scm_LinkedHashMap$();
  }
  return $n_scm_LinkedHashMap$;
}
export { $m_scm_LinkedHashMap$ as $m_scm_LinkedHashMap$ };
/** @constructor */
function $c_scm_LinkedHashSet$() {
}
export { $c_scm_LinkedHashSet$ as $c_scm_LinkedHashSet$ };
$c_scm_LinkedHashSet$.prototype = new $h_O();
$c_scm_LinkedHashSet$.prototype.constructor = $c_scm_LinkedHashSet$;
/** @constructor */
function $h_scm_LinkedHashSet$() {
}
export { $h_scm_LinkedHashSet$ as $h_scm_LinkedHashSet$ };
$h_scm_LinkedHashSet$.prototype = $c_scm_LinkedHashSet$.prototype;
$c_scm_LinkedHashSet$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_LinkedHashSet(elems);
});
$c_scm_LinkedHashSet$.prototype.from__sc_IterableOnce__scm_LinkedHashSet = (function(it) {
  var newlhs = new $c_scm_LinkedHashSet();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(newlhs, it, 0);
  $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(newlhs, it);
  return newlhs;
});
$c_scm_LinkedHashSet$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_LinkedHashSet());
});
$c_scm_LinkedHashSet$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_LinkedHashSet(source);
});
$c_scm_LinkedHashSet$.prototype.empty__O = (function() {
  return new $c_scm_LinkedHashSet();
});
var $d_scm_LinkedHashSet$ = new $TypeData().initClass($c_scm_LinkedHashSet$, "scala.collection.mutable.LinkedHashSet$", ({
  scm_LinkedHashSet$: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_LinkedHashSet$ as $d_scm_LinkedHashSet$ };
var $n_scm_LinkedHashSet$;
function $m_scm_LinkedHashSet$() {
  if ((!$n_scm_LinkedHashSet$)) {
    $n_scm_LinkedHashSet$ = new $c_scm_LinkedHashSet$();
  }
  return $n_scm_LinkedHashSet$;
}
export { $m_scm_LinkedHashSet$ as $m_scm_LinkedHashSet$ };
/** @constructor */
function $c_s_jdk_CollectionConverters$() {
}
export { $c_s_jdk_CollectionConverters$ as $c_s_jdk_CollectionConverters$ };
$c_s_jdk_CollectionConverters$.prototype = new $h_O();
$c_s_jdk_CollectionConverters$.prototype.constructor = $c_s_jdk_CollectionConverters$;
/** @constructor */
function $h_s_jdk_CollectionConverters$() {
}
export { $h_s_jdk_CollectionConverters$ as $h_s_jdk_CollectionConverters$ };
$h_s_jdk_CollectionConverters$.prototype = $c_s_jdk_CollectionConverters$.prototype;
var $d_s_jdk_CollectionConverters$ = new $TypeData().initClass($c_s_jdk_CollectionConverters$, "scala.jdk.CollectionConverters$", ({
  s_jdk_CollectionConverters$: 1,
  sc_convert_AsJavaExtensions: 1,
  sc_convert_AsScalaExtensions: 1
}));
export { $d_s_jdk_CollectionConverters$ as $d_s_jdk_CollectionConverters$ };
var $n_s_jdk_CollectionConverters$;
function $m_s_jdk_CollectionConverters$() {
  if ((!$n_s_jdk_CollectionConverters$)) {
    $n_s_jdk_CollectionConverters$ = new $c_s_jdk_CollectionConverters$();
  }
  return $n_s_jdk_CollectionConverters$;
}
export { $m_s_jdk_CollectionConverters$ as $m_s_jdk_CollectionConverters$ };
/** @constructor */
function $c_s_jdk_javaapi_CollectionConverters$() {
}
export { $c_s_jdk_javaapi_CollectionConverters$ as $c_s_jdk_javaapi_CollectionConverters$ };
$c_s_jdk_javaapi_CollectionConverters$.prototype = new $h_O();
$c_s_jdk_javaapi_CollectionConverters$.prototype.constructor = $c_s_jdk_javaapi_CollectionConverters$;
/** @constructor */
function $h_s_jdk_javaapi_CollectionConverters$() {
}
export { $h_s_jdk_javaapi_CollectionConverters$ as $h_s_jdk_javaapi_CollectionConverters$ };
$h_s_jdk_javaapi_CollectionConverters$.prototype = $c_s_jdk_javaapi_CollectionConverters$.prototype;
var $d_s_jdk_javaapi_CollectionConverters$ = new $TypeData().initClass($c_s_jdk_javaapi_CollectionConverters$, "scala.jdk.javaapi.CollectionConverters$", ({
  s_jdk_javaapi_CollectionConverters$: 1,
  sc_convert_AsJavaConverters: 1,
  sc_convert_AsScalaConverters: 1
}));
export { $d_s_jdk_javaapi_CollectionConverters$ as $d_s_jdk_javaapi_CollectionConverters$ };
var $n_s_jdk_javaapi_CollectionConverters$;
function $m_s_jdk_javaapi_CollectionConverters$() {
  if ((!$n_s_jdk_javaapi_CollectionConverters$)) {
    $n_s_jdk_javaapi_CollectionConverters$ = new $c_s_jdk_javaapi_CollectionConverters$();
  }
  return $n_s_jdk_javaapi_CollectionConverters$;
}
export { $m_s_jdk_javaapi_CollectionConverters$ as $m_s_jdk_javaapi_CollectionConverters$ };
/** @constructor */
function $c_s_math_Ordering$() {
}
export { $c_s_math_Ordering$ as $c_s_math_Ordering$ };
$c_s_math_Ordering$.prototype = new $h_O();
$c_s_math_Ordering$.prototype.constructor = $c_s_math_Ordering$;
/** @constructor */
function $h_s_math_Ordering$() {
}
export { $h_s_math_Ordering$ as $h_s_math_Ordering$ };
$h_s_math_Ordering$.prototype = $c_s_math_Ordering$.prototype;
var $d_s_math_Ordering$ = new $TypeData().initClass($c_s_math_Ordering$, "scala.math.Ordering$", ({
  s_math_Ordering$: 1,
  s_math_LowPriorityOrderingImplicits: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_Ordering$ as $d_s_math_Ordering$ };
var $n_s_math_Ordering$;
function $m_s_math_Ordering$() {
  if ((!$n_s_math_Ordering$)) {
    $n_s_math_Ordering$ = new $c_s_math_Ordering$();
  }
  return $n_s_math_Ordering$;
}
export { $m_s_math_Ordering$ as $m_s_math_Ordering$ };
/** @constructor */
function $c_s_math_ScalaNumber() {
}
export { $c_s_math_ScalaNumber as $c_s_math_ScalaNumber };
$c_s_math_ScalaNumber.prototype = new $h_jl_Number();
$c_s_math_ScalaNumber.prototype.constructor = $c_s_math_ScalaNumber;
/** @constructor */
function $h_s_math_ScalaNumber() {
}
export { $h_s_math_ScalaNumber as $h_s_math_ScalaNumber };
$h_s_math_ScalaNumber.prototype = $c_s_math_ScalaNumber.prototype;
function $isArrayOf_s_math_ScalaNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_ScalaNumber)));
}
export { $isArrayOf_s_math_ScalaNumber as $isArrayOf_s_math_ScalaNumber };
/** @constructor */
function $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(f) {
  this.sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855__f_f = null;
  this.sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855__f_f = f;
}
export { $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855 as $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855 };
$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855.prototype = new $h_sr_AbstractFunction0();
$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855.prototype.constructor = $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855;
/** @constructor */
function $h_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855() {
}
export { $h_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855 as $h_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855 };
$h_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855.prototype = $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855.prototype;
$c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855.prototype.apply__O = (function() {
  return (0, this.sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855__f_f)();
});
var $d_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855 = new $TypeData().initClass($c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855, "scala.runtime.AbstractFunction0.$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855", ({
  sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855: 1,
  sr_AbstractFunction0: 1,
  F0: 1
}));
export { $d_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855 as $d_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855 };
/** @constructor */
function $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(f) {
  this.sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28__f_f = null;
  this.sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28__f_f = f;
}
export { $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28 as $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28 };
$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28.prototype = new $h_sr_AbstractFunction1();
$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28.prototype.constructor = $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28;
/** @constructor */
function $h_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28() {
}
export { $h_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28 as $h_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28 };
$h_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28.prototype = $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28.prototype;
$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28.prototype.apply__O__O = (function(x0) {
  return (0, this.sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28__f_f)(x0);
});
var $d_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28 = new $TypeData().initClass($c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28, "scala.runtime.AbstractFunction1.$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28", ({
  sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28: 1,
  sr_AbstractFunction1: 1,
  F1: 1
}));
export { $d_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28 as $d_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28 };
/** @constructor */
function $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(f) {
  this.sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc__f_f = null;
  this.sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc__f_f = f;
}
export { $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc as $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc };
$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc.prototype = new $h_sr_AbstractFunction2();
$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc.prototype.constructor = $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc;
/** @constructor */
function $h_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc() {
}
export { $h_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc as $h_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc };
$h_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc.prototype = $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc.prototype;
$c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc.prototype.apply__O__O__O = (function(x0, x1) {
  return (0, this.sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc__f_f)(x0, x1);
});
var $d_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc = new $TypeData().initClass($c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc, "scala.runtime.AbstractFunction2.$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc", ({
  sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc: 1,
  sr_AbstractFunction2: 1,
  F2: 1
}));
export { $d_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc as $d_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc };
/** @constructor */
function $c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1(f) {
  this.sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1__f_f = null;
  this.sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1__f_f = f;
}
export { $c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1 as $c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1 };
$c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1.prototype = new $h_sr_AbstractFunction3();
$c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1.prototype.constructor = $c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1;
/** @constructor */
function $h_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1() {
}
export { $h_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1 as $h_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1 };
$h_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1.prototype = $c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1.prototype;
$c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1.prototype.apply__O__O__O__O = (function(x0, x1, x2) {
  return (0, this.sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1__f_f)(x0, x1, x2);
});
var $d_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1 = new $TypeData().initClass($c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1, "scala.runtime.AbstractFunction3.$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1", ({
  sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1: 1,
  sr_AbstractFunction3: 1,
  F3: 1
}));
export { $d_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1 as $d_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1 };
/** @constructor */
function $c_sr_AbstractPartialFunction() {
}
export { $c_sr_AbstractPartialFunction as $c_sr_AbstractPartialFunction };
$c_sr_AbstractPartialFunction.prototype = new $h_O();
$c_sr_AbstractPartialFunction.prototype.constructor = $c_sr_AbstractPartialFunction;
/** @constructor */
function $h_sr_AbstractPartialFunction() {
}
export { $h_sr_AbstractPartialFunction as $h_sr_AbstractPartialFunction };
$h_sr_AbstractPartialFunction.prototype = $c_sr_AbstractPartialFunction.prototype;
$c_sr_AbstractPartialFunction.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sr_AbstractPartialFunction.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sr_AbstractPartialFunction.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sr_AbstractPartialFunction.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sr_AbstractPartialFunction.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sr_AbstractPartialFunction.prototype.apply__O__O = (function(x) {
  return this.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf);
});
$c_sr_AbstractPartialFunction.prototype.apply$mcZI$sp__I__Z = (function(x) {
  return (!(!this.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_empty_pf)));
});
$c_sr_AbstractPartialFunction.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
var $d_sr_Nothing$ = new $TypeData().initClass(0, "scala.runtime.Nothing$", ({
  sr_Nothing$: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sr_Nothing$ as $d_sr_Nothing$ };
/** @constructor */
function $c_sr_TupleXXL(es) {
  this.sr_TupleXXL__f_es = null;
  this.sr_TupleXXL__f_es = es;
  if ((es.u.length <= 22)) {
    $m_sr_Scala3RunTime$().assertFailed__E();
  }
}
export { $c_sr_TupleXXL as $c_sr_TupleXXL };
$c_sr_TupleXXL.prototype = new $h_O();
$c_sr_TupleXXL.prototype.constructor = $c_sr_TupleXXL;
/** @constructor */
function $h_sr_TupleXXL() {
}
export { $h_sr_TupleXXL as $h_sr_TupleXXL };
$h_sr_TupleXXL.prototype = $c_sr_TupleXXL.prototype;
$c_sr_TupleXXL.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_sr_TupleXXL.prototype.productElementName__I__T = (function(n) {
  return $f_s_Product__productElementName__I__T(this, n);
});
$c_sr_TupleXXL.prototype.productElement__I__O = (function(n) {
  var arr = this.sr_TupleXXL__f_es;
  return arr.u[n];
});
$c_sr_TupleXXL.prototype.productArity__I = (function() {
  var arr = this.sr_TupleXXL__f_es;
  return arr.u.length;
});
$c_sr_TupleXXL.prototype.productPrefix__T = (function() {
  return "Tuple";
});
$c_sr_TupleXXL.prototype.toString__T = (function() {
  var this$1 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef(this.sr_TupleXXL__f_es);
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "(", ",", ")");
});
$c_sr_TupleXXL.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_sr_TupleXXL.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sr_TupleXXL)) {
    if ((this.sr_TupleXXL__f_es === that.sr_TupleXXL__f_es)) {
      return true;
    } else {
      var arr = this.sr_TupleXXL__f_es;
      var arr$1 = that.sr_TupleXXL__f_es;
      if ((arr.u.length !== arr$1.u.length)) {
        return false;
      }
      var i = 0;
      while (true) {
        var $x_1 = i;
        var arr$2 = this.sr_TupleXXL__f_es;
        if (($x_1 < arr$2.u.length)) {
          var arr$3 = this.sr_TupleXXL__f_es;
          var n = i;
          var x = arr$3.u[n];
          var arr$4 = that.sr_TupleXXL__f_es;
          var n$1 = i;
          var y = arr$4.u[n$1];
          if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(x, y))) {
            return false;
          }
          i = ((1 + i) | 0);
        } else {
          break;
        }
      }
      return true;
    }
  } else {
    return false;
  }
});
$c_sr_TupleXXL.prototype.toArray__AO = (function() {
  var this$1 = this.sr_TupleXXL__f_es;
  return this$1.clone__O();
});
function $isArrayOf_sr_TupleXXL(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_TupleXXL)));
}
export { $isArrayOf_sr_TupleXXL as $isArrayOf_sr_TupleXXL };
var $d_sr_TupleXXL = new $TypeData().initClass($c_sr_TupleXXL, "scala.runtime.TupleXXL", ({
  sr_TupleXXL: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_sr_TupleXXL as $d_sr_TupleXXL };
/** @constructor */
function $c_sjsr_AnonFunction0() {
}
export { $c_sjsr_AnonFunction0 as $c_sjsr_AnonFunction0 };
$c_sjsr_AnonFunction0.prototype = new $h_sr_AbstractFunction0();
$c_sjsr_AnonFunction0.prototype.constructor = $c_sjsr_AnonFunction0;
/** @constructor */
function $h_sjsr_AnonFunction0() {
}
export { $h_sjsr_AnonFunction0 as $h_sjsr_AnonFunction0 };
$h_sjsr_AnonFunction0.prototype = $c_sjsr_AnonFunction0.prototype;
/** @constructor */
function $c_sjsr_AnonFunction1() {
}
export { $c_sjsr_AnonFunction1 as $c_sjsr_AnonFunction1 };
$c_sjsr_AnonFunction1.prototype = new $h_sr_AbstractFunction1();
$c_sjsr_AnonFunction1.prototype.constructor = $c_sjsr_AnonFunction1;
/** @constructor */
function $h_sjsr_AnonFunction1() {
}
export { $h_sjsr_AnonFunction1 as $h_sjsr_AnonFunction1 };
$h_sjsr_AnonFunction1.prototype = $c_sjsr_AnonFunction1.prototype;
/** @constructor */
function $c_sjsr_AnonFunction2() {
}
export { $c_sjsr_AnonFunction2 as $c_sjsr_AnonFunction2 };
$c_sjsr_AnonFunction2.prototype = new $h_sr_AbstractFunction2();
$c_sjsr_AnonFunction2.prototype.constructor = $c_sjsr_AnonFunction2;
/** @constructor */
function $h_sjsr_AnonFunction2() {
}
export { $h_sjsr_AnonFunction2 as $h_sjsr_AnonFunction2 };
$h_sjsr_AnonFunction2.prototype = $c_sjsr_AnonFunction2.prototype;
/** @constructor */
function $c_sjsr_AnonFunction3() {
}
export { $c_sjsr_AnonFunction3 as $c_sjsr_AnonFunction3 };
$c_sjsr_AnonFunction3.prototype = new $h_sr_AbstractFunction3();
$c_sjsr_AnonFunction3.prototype.constructor = $c_sjsr_AnonFunction3;
/** @constructor */
function $h_sjsr_AnonFunction3() {
}
export { $h_sjsr_AnonFunction3 as $h_sjsr_AnonFunction3 };
$h_sjsr_AnonFunction3.prototype = $c_sjsr_AnonFunction3.prototype;
/** @constructor */
function $c_sjsr_AnonFunction4() {
}
export { $c_sjsr_AnonFunction4 as $c_sjsr_AnonFunction4 };
$c_sjsr_AnonFunction4.prototype = new $h_sr_AbstractFunction4();
$c_sjsr_AnonFunction4.prototype.constructor = $c_sjsr_AnonFunction4;
/** @constructor */
function $h_sjsr_AnonFunction4() {
}
export { $h_sjsr_AnonFunction4 as $h_sjsr_AnonFunction4 };
$h_sjsr_AnonFunction4.prototype = $c_sjsr_AnonFunction4.prototype;
class $c_s_util_control_ControlThrowable extends $c_jl_Throwable {
}
export { $c_s_util_control_ControlThrowable as $c_s_util_control_ControlThrowable };
function $isArrayOf_s_util_control_ControlThrowable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_control_ControlThrowable)));
}
export { $isArrayOf_s_util_control_ControlThrowable as $isArrayOf_s_util_control_ControlThrowable };
/** @constructor */
function $c_Lscodec_Attempt$() {
}
export { $c_Lscodec_Attempt$ as $c_Lscodec_Attempt$ };
$c_Lscodec_Attempt$.prototype = new $h_O();
$c_Lscodec_Attempt$.prototype.constructor = $c_Lscodec_Attempt$;
/** @constructor */
function $h_Lscodec_Attempt$() {
}
export { $h_Lscodec_Attempt$ as $h_Lscodec_Attempt$ };
$h_Lscodec_Attempt$.prototype = $c_Lscodec_Attempt$.prototype;
$c_Lscodec_Attempt$.prototype.fromEither__s_util_Either__Lscodec_Attempt = (function(e) {
  if ((e instanceof $c_s_util_Right)) {
    var b = e.s_util_Right__f_value;
    var $x_1 = new $c_Lscodec_Attempt$Successful(b);
  } else {
    if ((!(e instanceof $c_s_util_Left))) {
      throw new $c_s_MatchError(e);
    }
    var a = e.s_util_Left__f_value;
    var $x_1 = new $c_Lscodec_Attempt$Failure(a);
  }
  return $x_1;
});
$c_Lscodec_Attempt$.prototype.ordinal__Lscodec_Attempt__I = (function(x$0) {
  if ((x$0 instanceof $c_Lscodec_Attempt$Successful)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lscodec_Attempt$Failure)) {
    return 1;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lscodec_Attempt$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lscodec_Attempt__I(x);
});
var $d_Lscodec_Attempt$ = new $TypeData().initClass($c_Lscodec_Attempt$, "scodec.Attempt$", ({
  Lscodec_Attempt$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lscodec_Attempt$ as $d_Lscodec_Attempt$ };
var $n_Lscodec_Attempt$;
function $m_Lscodec_Attempt$() {
  if ((!$n_Lscodec_Attempt$)) {
    $n_Lscodec_Attempt$ = new $c_Lscodec_Attempt$();
  }
  return $n_Lscodec_Attempt$;
}
export { $m_Lscodec_Attempt$ as $m_Lscodec_Attempt$ };
var $d_Lscodec_Codec = new $TypeData().initClass(1, "scodec.Codec", ({
  Lscodec_Codec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1
}));
export { $d_Lscodec_Codec as $d_Lscodec_Codec };
/** @constructor */
function $c_Lscodec_Codec$() {
  this.Lscodec_Codec$__f_given_Codec_Int$lzy1 = null;
  this.Lscodec_Codec$__f_given_Codec_Intbitmap$1 = false;
  this.Lscodec_Codec$__f_given_Codec_Long$lzy1 = null;
  this.Lscodec_Codec$__f_given_Codec_Longbitmap$1 = false;
  this.Lscodec_Codec$__f_given_Codec_Boolean$lzy1 = null;
  this.Lscodec_Codec$__f_given_Codec_Booleanbitmap$1 = false;
  this.Lscodec_Codec$__f_given_Codec_UUID$lzy1 = null;
  this.Lscodec_Codec$__f_given_Codec_UUIDbitmap$1 = false;
}
export { $c_Lscodec_Codec$ as $c_Lscodec_Codec$ };
$c_Lscodec_Codec$.prototype = new $h_O();
$c_Lscodec_Codec$.prototype.constructor = $c_Lscodec_Codec$;
/** @constructor */
function $h_Lscodec_Codec$() {
}
export { $h_Lscodec_Codec$ as $h_Lscodec_Codec$ };
$h_Lscodec_Codec$.prototype = $c_Lscodec_Codec$.prototype;
$c_Lscodec_Codec$.prototype.given_Codec_Int__Lscodec_Codec = (function() {
  if ((!this.Lscodec_Codec$__f_given_Codec_Intbitmap$1)) {
    this.Lscodec_Codec$__f_given_Codec_Int$lzy1 = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_int32;
    this.Lscodec_Codec$__f_given_Codec_Intbitmap$1 = true;
  }
  return this.Lscodec_Codec$__f_given_Codec_Int$lzy1;
});
$c_Lscodec_Codec$.prototype.given_Codec_Long__Lscodec_Codec = (function() {
  if ((!this.Lscodec_Codec$__f_given_Codec_Longbitmap$1)) {
    this.Lscodec_Codec$__f_given_Codec_Long$lzy1 = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_int64;
    this.Lscodec_Codec$__f_given_Codec_Longbitmap$1 = true;
  }
  return this.Lscodec_Codec$__f_given_Codec_Long$lzy1;
});
$c_Lscodec_Codec$.prototype.given_Codec_Boolean__Lscodec_Codec = (function() {
  if ((!this.Lscodec_Codec$__f_given_Codec_Booleanbitmap$1)) {
    this.Lscodec_Codec$__f_given_Codec_Boolean$lzy1 = ($m_Lscodec_codecs_codecs$package$(), new $c_Lscodec_codecs_codecs$package$$anon$5(new $c_RTLong(8, 0)));
    this.Lscodec_Codec$__f_given_Codec_Booleanbitmap$1 = true;
  }
  return this.Lscodec_Codec$__f_given_Codec_Boolean$lzy1;
});
$c_Lscodec_Codec$.prototype.given_Codec_UUID__Lscodec_Codec = (function() {
  if ((!this.Lscodec_Codec$__f_given_Codec_UUIDbitmap$1)) {
    this.Lscodec_Codec$__f_given_Codec_UUID$lzy1 = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_uuid;
    this.Lscodec_Codec$__f_given_Codec_UUIDbitmap$1 = true;
  }
  return this.Lscodec_Codec$__f_given_Codec_UUID$lzy1;
});
var $d_Lscodec_Codec$ = new $TypeData().initClass($c_Lscodec_Codec$, "scodec.Codec$", ({
  Lscodec_Codec$: 1,
  Lscodec_EncoderFunctions: 1,
  Lscodec_DecoderFunctions: 1
}));
export { $d_Lscodec_Codec$ as $d_Lscodec_Codec$ };
var $n_Lscodec_Codec$;
function $m_Lscodec_Codec$() {
  if ((!$n_Lscodec_Codec$)) {
    $n_Lscodec_Codec$ = new $c_Lscodec_Codec$();
  }
  return $n_Lscodec_Codec$;
}
export { $m_Lscodec_Codec$ as $m_Lscodec_Codec$ };
/** @constructor */
function $c_Lscodec_SizeBound$() {
  this.Lscodec_SizeBound$__f_unknown = null;
  $n_Lscodec_SizeBound$ = this;
  $m_Lscodec_SizeBound$();
  var upperBound = $m_s_None$();
  this.Lscodec_SizeBound$__f_unknown = new $c_Lscodec_SizeBound($L0, upperBound);
}
export { $c_Lscodec_SizeBound$ as $c_Lscodec_SizeBound$ };
$c_Lscodec_SizeBound$.prototype = new $h_O();
$c_Lscodec_SizeBound$.prototype.constructor = $c_Lscodec_SizeBound$;
/** @constructor */
function $h_Lscodec_SizeBound$() {
}
export { $h_Lscodec_SizeBound$ as $h_Lscodec_SizeBound$ };
$h_Lscodec_SizeBound$.prototype = $c_Lscodec_SizeBound$.prototype;
$c_Lscodec_SizeBound$.prototype.exact__J__Lscodec_SizeBound = (function(size) {
  $m_Lscodec_SizeBound$();
  var upperBound = new $c_s_Some(size);
  return new $c_Lscodec_SizeBound(size, upperBound);
});
$c_Lscodec_SizeBound$.prototype.bounded__J__J__Lscodec_SizeBound = (function(lower, upper) {
  $m_Lscodec_SizeBound$();
  var upperBound = new $c_s_Some(upper);
  return new $c_Lscodec_SizeBound(lower, upperBound);
});
$c_Lscodec_SizeBound$.prototype.choice__sc_Iterable__Lscodec_SizeBound = (function(bounds) {
  if (bounds.isEmpty__Z()) {
    return $m_Lscodec_SizeBound$().exact__J__Lscodec_SizeBound($L0);
  } else {
    var op = new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$10, _$11) => _$10.$bar__Lscodec_SizeBound__Lscodec_SizeBound(_$11)));
    return bounds.reduceLeft__F2__O(op);
  }
});
$c_Lscodec_SizeBound$.prototype.fromProduct__s_Product__Lscodec_SizeBound = (function(x$0) {
  return new $c_Lscodec_SizeBound($uJ(x$0.productElement__I__O(0)), x$0.productElement__I__O(1));
});
$c_Lscodec_SizeBound$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lscodec_SizeBound(p);
});
var $d_Lscodec_SizeBound$ = new $TypeData().initClass($c_Lscodec_SizeBound$, "scodec.SizeBound$", ({
  Lscodec_SizeBound$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lscodec_SizeBound$ as $d_Lscodec_SizeBound$ };
var $n_Lscodec_SizeBound$;
function $m_Lscodec_SizeBound$() {
  if ((!$n_Lscodec_SizeBound$)) {
    $n_Lscodec_SizeBound$ = new $c_Lscodec_SizeBound$();
  }
  return $n_Lscodec_SizeBound$;
}
export { $m_Lscodec_SizeBound$ as $m_Lscodec_SizeBound$ };
/** @constructor */
function $c_Lscodec_bits_Bases$Alphabets$Base64UrlBase$() {
  this.Lscodec_bits_Bases$Alphabets$Base64UrlBase$__f_scodec$bits$Bases$Alphabets$Base64UrlBase$$$Chars = null;
  $n_Lscodec_bits_Bases$Alphabets$Base64UrlBase$ = this;
  var this$2 = new $c_sr_RichChar(65);
  var this$5 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$2, $bC(90));
  var this$4 = new $c_sr_RichChar(97);
  var suffix = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$4, $bC(122));
  var this$8 = $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this$5, suffix);
  var this$7 = new $c_sr_RichChar(48);
  var suffix$1 = $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive(this$7, $bC(57));
  var this$9 = this$8.concat__sc_IterableOnce__O(suffix$1);
  var this$10 = this$9.appended__O__O($bC(45));
  this.Lscodec_bits_Bases$Alphabets$Base64UrlBase$__f_scodec$bits$Bases$Alphabets$Base64UrlBase$$$Chars = this$10.appended__O__O($bC(95)).toArray__s_reflect_ClassTag__O($m_s_reflect_ManifestFactory$CharManifest$());
}
export { $c_Lscodec_bits_Bases$Alphabets$Base64UrlBase$ as $c_Lscodec_bits_Bases$Alphabets$Base64UrlBase$ };
$c_Lscodec_bits_Bases$Alphabets$Base64UrlBase$.prototype = new $h_O();
$c_Lscodec_bits_Bases$Alphabets$Base64UrlBase$.prototype.constructor = $c_Lscodec_bits_Bases$Alphabets$Base64UrlBase$;
/** @constructor */
function $h_Lscodec_bits_Bases$Alphabets$Base64UrlBase$() {
}
export { $h_Lscodec_bits_Bases$Alphabets$Base64UrlBase$ as $h_Lscodec_bits_Bases$Alphabets$Base64UrlBase$ };
$h_Lscodec_bits_Bases$Alphabets$Base64UrlBase$.prototype = $c_Lscodec_bits_Bases$Alphabets$Base64UrlBase$.prototype;
$c_Lscodec_bits_Bases$Alphabets$Base64UrlBase$.prototype.ordinal__Lscodec_bits_Bases$Alphabets$Base64UrlBase__I = (function(x$0) {
  if ((x$0 === $m_Lscodec_bits_Bases$Alphabets$Base64Url$())) {
    return 0;
  }
  if ((x$0 === $m_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$())) {
    return 1;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lscodec_bits_Bases$Alphabets$Base64UrlBase$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lscodec_bits_Bases$Alphabets$Base64UrlBase__I(x);
});
var $d_Lscodec_bits_Bases$Alphabets$Base64UrlBase$ = new $TypeData().initClass($c_Lscodec_bits_Bases$Alphabets$Base64UrlBase$, "scodec.bits.Bases$Alphabets$Base64UrlBase$", ({
  Lscodec_bits_Bases$Alphabets$Base64UrlBase$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lscodec_bits_Bases$Alphabets$Base64UrlBase$ as $d_Lscodec_bits_Bases$Alphabets$Base64UrlBase$ };
var $n_Lscodec_bits_Bases$Alphabets$Base64UrlBase$;
function $m_Lscodec_bits_Bases$Alphabets$Base64UrlBase$() {
  if ((!$n_Lscodec_bits_Bases$Alphabets$Base64UrlBase$)) {
    $n_Lscodec_bits_Bases$Alphabets$Base64UrlBase$ = new $c_Lscodec_bits_Bases$Alphabets$Base64UrlBase$();
  }
  return $n_Lscodec_bits_Bases$Alphabets$Base64UrlBase$;
}
export { $m_Lscodec_bits_Bases$Alphabets$Base64UrlBase$ as $m_Lscodec_bits_Bases$Alphabets$Base64UrlBase$ };
/** @constructor */
function $c_Lscodec_bits_Bases$Alphabets$LenientHex() {
}
export { $c_Lscodec_bits_Bases$Alphabets$LenientHex as $c_Lscodec_bits_Bases$Alphabets$LenientHex };
$c_Lscodec_bits_Bases$Alphabets$LenientHex.prototype = new $h_O();
$c_Lscodec_bits_Bases$Alphabets$LenientHex.prototype.constructor = $c_Lscodec_bits_Bases$Alphabets$LenientHex;
/** @constructor */
function $h_Lscodec_bits_Bases$Alphabets$LenientHex() {
}
export { $h_Lscodec_bits_Bases$Alphabets$LenientHex as $h_Lscodec_bits_Bases$Alphabets$LenientHex };
$h_Lscodec_bits_Bases$Alphabets$LenientHex.prototype = $c_Lscodec_bits_Bases$Alphabets$LenientHex.prototype;
/** @constructor */
function $c_Lscodec_bits_ByteVector$() {
  this.Lscodec_bits_ByteVector$__f_empty = null;
  this.Lscodec_bits_ByteVector$__f_Base64PaddingError = null;
  $n_Lscodec_bits_ByteVector$ = this;
  $m_Lscodec_bits_ByteVector$View$();
  var at = $m_Lscodec_bits_ByteVector$AtEmpty$();
  var bytes = new $c_Lscodec_bits_ByteVector$View(at, $L0, $L0);
  this.Lscodec_bits_ByteVector$__f_empty = new $c_Lscodec_bits_ByteVector$Chunk(bytes);
  this.Lscodec_bits_ByteVector$__f_Base64PaddingError = new $c_s_util_Left("Malformed padding - final quantum may optionally be padded with one or two padding characters such that the quantum is completed");
}
export { $c_Lscodec_bits_ByteVector$ as $c_Lscodec_bits_ByteVector$ };
$c_Lscodec_bits_ByteVector$.prototype = new $h_O();
$c_Lscodec_bits_ByteVector$.prototype.constructor = $c_Lscodec_bits_ByteVector$;
/** @constructor */
function $h_Lscodec_bits_ByteVector$() {
}
export { $h_Lscodec_bits_ByteVector$ as $h_Lscodec_bits_ByteVector$ };
$h_Lscodec_bits_ByteVector$.prototype = $c_Lscodec_bits_ByteVector$.prototype;
$c_Lscodec_bits_ByteVector$.prototype.apply__sci_Seq__s_math_Integral__Lscodec_bits_ByteVector = (function(bytes, evidence$1) {
  var dimensions = new $ac_I(new Int32Array([bytes.length__I()]));
  var buf = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_B.getClassOf(), dimensions);
  var i = new $c_sr_IntRef(0);
  bytes.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => {
    buf.u[i.sr_IntRef__f_elem] = ((evidence$1.toInt__O__I(b) << 24) >> 24);
    i.sr_IntRef__f_elem = ((1 + i.sr_IntRef__f_elem) | 0);
  })));
  return this.view__AB__Lscodec_bits_ByteVector(buf);
});
$c_Lscodec_bits_ByteVector$.prototype.apply__AB__Lscodec_bits_ByteVector = (function(bytes) {
  var copy = bytes.clone__O();
  return this.view__AB__Lscodec_bits_ByteVector(copy);
});
$c_Lscodec_bits_ByteVector$.prototype.apply__Ljava_nio_ByteBuffer__Lscodec_bits_ByteVector = (function(buffer) {
  var c = buffer.duplicate__Ljava_nio_ByteBuffer();
  var dimensions = new $ac_I(new Int32Array([((c.Ljava_nio_Buffer__f__limit - c.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0)]));
  var arr = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_B.getClassOf(), dimensions);
  c.get__AB__I__I__Ljava_nio_ByteBuffer(arr, 0, arr.u.length);
  return this.view__AB__Lscodec_bits_ByteVector(arr);
});
$c_Lscodec_bits_ByteVector$.prototype.view__AB__Lscodec_bits_ByteVector = (function(bytes) {
  $m_Lscodec_bits_ByteVector$View$();
  var at = new $c_Lscodec_bits_ByteVector$AtArray(bytes);
  var value = bytes.u.length;
  var hi = (value >> 31);
  var bytes$1 = new $c_Lscodec_bits_ByteVector$View(at, $L0, new $c_RTLong(value, hi));
  return new $c_Lscodec_bits_ByteVector$Chunk(bytes$1);
});
$c_Lscodec_bits_ByteVector$.prototype.view__Ljava_nio_ByteBuffer__Lscodec_bits_ByteVector = (function(bytes) {
  var slice = bytes.slice__Ljava_nio_ByteBuffer();
  $m_Lscodec_bits_ByteVector$View$();
  var at = new $c_Lscodec_bits_ByteVector$AtByteBuffer(slice);
  var value = ((slice.Ljava_nio_Buffer__f__limit - slice.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
  var hi = (value >> 31);
  var bytes$1 = new $c_Lscodec_bits_ByteVector$View(at, $L0, new $c_RTLong(value, hi));
  return new $c_Lscodec_bits_ByteVector$Chunk(bytes$1);
});
$c_Lscodec_bits_ByteVector$.prototype.viewAt__F1__J__Lscodec_bits_ByteVector = (function(at, size) {
  $m_Lscodec_bits_ByteVector$View$();
  var at$1 = new $c_Lscodec_bits_ByteVector$$anon$19(at);
  var bytes = new $c_Lscodec_bits_ByteVector$View(at$1, $L0, size);
  return new $c_Lscodec_bits_ByteVector$Chunk(bytes);
});
$c_Lscodec_bits_ByteVector$.prototype.fill__J__O__s_math_Integral__Lscodec_bits_ByteVector = (function(size, b, evidence$1) {
  var value = ((evidence$1.toInt__O__I(b) << 24) >> 24);
  $m_Lscodec_bits_ByteVector$View$();
  var at = new $c_Lscodec_bits_ByteVector$$anon$21(value);
  var bytes = new $c_Lscodec_bits_ByteVector$View(at, $L0, size);
  return new $c_Lscodec_bits_ByteVector$Chunk(bytes);
});
$c_Lscodec_bits_ByteVector$.prototype.fromBase64Descriptive__T__Lscodec_bits_Bases$Base64Alphabet__s_util_Either = (function(str, alphabet) {
  var Pad = alphabet.pad__C();
  var idx = 0;
  var bidx = 0;
  var buffer = 0;
  var mod = 0;
  var padding = 0;
  var dimensions = new $ac_I(new Int32Array([Math.imul(3, ((((3 + str.length) | 0) / 4) | 0))]));
  var acc = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_B.getClassOf(), dimensions);
  while ((idx < str.length)) {
    matchResult30: {
      var i = idx;
      var x182 = str.charCodeAt(i);
      if ($f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__ignore__C__Z(alphabet, x182)) {
        break matchResult30;
      }
      if ((padding === 0)) {
        if ((x182 === Pad)) {
          if ((!((mod === 2) || (mod === 3)))) {
            return this.Lscodec_bits_ByteVector$__f_Base64PaddingError;
          }
          padding = ((1 + padding) | 0);
          var cidx = 0;
        } else {
          try {
            var cidx = $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toIndex__C__I(alphabet, x182);
          } catch (e) {
            var cidx;
            if ((e instanceof $c_jl_IllegalArgumentException)) {
              var value = ((("Invalid base 64 character '" + $cToS(x182)) + "' at index ") + idx);
              return new $c_s_util_Left(value);
            } else {
              throw e;
            }
          }
        }
      } else {
        if ((x182 !== Pad)) {
          var value$1 = (((("Unexpected character '" + $cToS(x182)) + "' at index ") + idx) + " after padding character; only '=' and whitespace characters allowed after first padding character");
          return new $c_s_util_Left(value$1);
        }
        if ((!((padding === 1) && (mod === 3)))) {
          return this.Lscodec_bits_ByteVector$__f_Base64PaddingError;
        }
        padding = ((1 + padding) | 0);
        var cidx = 0;
      }
      var x181 = mod;
      switch (x181) {
        case 0: {
          buffer = (63 & cidx);
          mod = ((1 + mod) | 0);
          break;
        }
        case 1: {
          buffer = ((buffer << 6) | (63 & cidx));
          mod = ((1 + mod) | 0);
          break;
        }
        case 2: {
          buffer = ((buffer << 6) | (63 & cidx));
          mod = ((1 + mod) | 0);
          break;
        }
        case 3: {
          buffer = ((buffer << 6) | (63 & cidx));
          mod = 0;
          var c$3 = (255 & buffer);
          var b = (255 & (buffer >> 8));
          var a = (255 & (buffer >> 16));
          acc.u[bidx] = ((a << 24) >> 24);
          acc.u[((1 + bidx) | 0)] = ((b << 24) >> 24);
          acc.u[((2 + bidx) | 0)] = ((c$3 << 24) >> 24);
          bidx = ((3 + bidx) | 0);
          break;
        }
        default: {
          throw new $c_s_MatchError(x181);
        }
      }
    }
    idx = ((1 + idx) | 0);
  }
  if (((padding !== 0) && (mod !== 0))) {
    return this.Lscodec_bits_ByteVector$__f_Base64PaddingError;
  } else {
    var x183 = mod;
    switch (x183) {
      case 0: {
        var $x_1 = $m_Lscodec_bits_ByteVector$().apply__AB__Lscodec_bits_ByteVector(acc);
        var value$2 = ((bidx - padding) | 0);
        var hi = (value$2 >> 31);
        var value$3 = $x_1.take__J__Lscodec_bits_ByteVector(new $c_RTLong(value$2, hi));
        return new $c_s_util_Right(value$3);
        break;
      }
      case 1: {
        return new $c_s_util_Left("Final base 64 quantum had only 1 digit - must have at least 2 digits");
        break;
      }
      case 2: {
        acc.u[bidx] = (((255 & (buffer >> 4)) << 24) >> 24);
        bidx = ((1 + bidx) | 0);
        var $x_2 = $m_Lscodec_bits_ByteVector$().apply__AB__Lscodec_bits_ByteVector(acc);
        var value$4 = bidx;
        var hi$1 = (value$4 >> 31);
        var value$5 = $x_2.take__J__Lscodec_bits_ByteVector(new $c_RTLong(value$4, hi$1));
        return new $c_s_util_Right(value$5);
        break;
      }
      case 3: {
        acc.u[bidx] = (((255 & (buffer >> 10)) << 24) >> 24);
        acc.u[((1 + bidx) | 0)] = (((255 & (buffer >> 2)) << 24) >> 24);
        bidx = ((2 + bidx) | 0);
        var $x_3 = $m_Lscodec_bits_ByteVector$().apply__AB__Lscodec_bits_ByteVector(acc);
        var value$6 = bidx;
        var hi$2 = (value$6 >> 31);
        var value$7 = $x_3.take__J__Lscodec_bits_ByteVector(new $c_RTLong(value$6, hi$2));
        return new $c_s_util_Right(value$7);
        break;
      }
      default: {
        throw new $c_s_MatchError(x183);
      }
    }
  }
});
$c_Lscodec_bits_ByteVector$.prototype.toIntSize__J__I = (function(size) {
  var ahi = size.RTLong__f_hi;
  if (((ahi === 0) ? ((size.RTLong__f_lo >>> 0) <= 2147483647) : (ahi < 0))) {
    return size.RTLong__f_lo;
  } else {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ("size must be <= Int.MaxValue but is " + size));
  }
});
var $d_Lscodec_bits_ByteVector$ = new $TypeData().initClass($c_Lscodec_bits_ByteVector$, "scodec.bits.ByteVector$", ({
  Lscodec_bits_ByteVector$: 1,
  Lscodec_bits_ByteVectorPlatform: 1,
  Lscodec_bits_ByteVectorCompanionCrossPlatform: 1
}));
export { $d_Lscodec_bits_ByteVector$ as $d_Lscodec_bits_ByteVector$ };
var $n_Lscodec_bits_ByteVector$;
function $m_Lscodec_bits_ByteVector$() {
  if ((!$n_Lscodec_bits_ByteVector$)) {
    $n_Lscodec_bits_ByteVector$ = new $c_Lscodec_bits_ByteVector$();
  }
  return $n_Lscodec_bits_ByteVector$;
}
export { $m_Lscodec_bits_ByteVector$ as $m_Lscodec_bits_ByteVector$ };
/** @constructor */
function $c_Lscodec_bits_ByteVector$View$() {
  this.Lscodec_bits_ByteVector$View$__f_empty = null;
  $n_Lscodec_bits_ByteVector$View$ = this;
  $m_Lscodec_bits_ByteVector$View$();
  var at = $m_Lscodec_bits_ByteVector$AtEmpty$();
  this.Lscodec_bits_ByteVector$View$__f_empty = new $c_Lscodec_bits_ByteVector$View(at, $L0, $L0);
}
export { $c_Lscodec_bits_ByteVector$View$ as $c_Lscodec_bits_ByteVector$View$ };
$c_Lscodec_bits_ByteVector$View$.prototype = new $h_O();
$c_Lscodec_bits_ByteVector$View$.prototype.constructor = $c_Lscodec_bits_ByteVector$View$;
/** @constructor */
function $h_Lscodec_bits_ByteVector$View$() {
}
export { $h_Lscodec_bits_ByteVector$View$ as $h_Lscodec_bits_ByteVector$View$ };
$h_Lscodec_bits_ByteVector$View$.prototype = $c_Lscodec_bits_ByteVector$View$.prototype;
$c_Lscodec_bits_ByteVector$View$.prototype.fromProduct__s_Product__Lscodec_bits_ByteVector$View = (function(x$0) {
  return new $c_Lscodec_bits_ByteVector$View(x$0.productElement__I__O(0), $uJ(x$0.productElement__I__O(1)), $uJ(x$0.productElement__I__O(2)));
});
$c_Lscodec_bits_ByteVector$View$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lscodec_bits_ByteVector$View(p);
});
var $d_Lscodec_bits_ByteVector$View$ = new $TypeData().initClass($c_Lscodec_bits_ByteVector$View$, "scodec.bits.ByteVector$View$", ({
  Lscodec_bits_ByteVector$View$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lscodec_bits_ByteVector$View$ as $d_Lscodec_bits_ByteVector$View$ };
var $n_Lscodec_bits_ByteVector$View$;
function $m_Lscodec_bits_ByteVector$View$() {
  if ((!$n_Lscodec_bits_ByteVector$View$)) {
    $n_Lscodec_bits_ByteVector$View$ = new $c_Lscodec_bits_ByteVector$View$();
  }
  return $n_Lscodec_bits_ByteVector$View$;
}
export { $m_Lscodec_bits_ByteVector$View$ as $m_Lscodec_bits_ByteVector$View$ };
/** @constructor */
function $c_Lsquants_space_Length$() {
}
export { $c_Lsquants_space_Length$ as $c_Lsquants_space_Length$ };
$c_Lsquants_space_Length$.prototype = new $h_O();
$c_Lsquants_space_Length$.prototype.constructor = $c_Lsquants_space_Length$;
/** @constructor */
function $h_Lsquants_space_Length$() {
}
export { $h_Lsquants_space_Length$ as $h_Lsquants_space_Length$ };
$h_Lsquants_space_Length$.prototype = $c_Lsquants_space_Length$.prototype;
$c_Lsquants_space_Length$.prototype.equals__O__Z = (function(that) {
  return $f_Lsquants_Dimension__equals__O__Z(this, that);
});
$c_Lsquants_space_Length$.prototype.hashCode__I = (function() {
  return $f_Lsquants_Dimension__hashCode__I(this);
});
$c_Lsquants_space_Length$.prototype.apply__O__Lsquants_space_LengthUnit__s_math_Numeric__Lsquants_space_Length = (function(n, unit, num) {
  return new $c_Lsquants_space_Length(num.toDouble__O__D(n), unit);
});
var $d_Lsquants_space_Length$ = new $TypeData().initClass($c_Lsquants_space_Length$, "squants.space.Length$", ({
  Lsquants_space_Length$: 1,
  Lsquants_Dimension: 1,
  Lsquants_BaseDimension: 1
}));
export { $d_Lsquants_space_Length$ as $d_Lsquants_space_Length$ };
var $n_Lsquants_space_Length$;
function $m_Lsquants_space_Length$() {
  if ((!$n_Lsquants_space_Length$)) {
    $n_Lsquants_space_Length$ = new $c_Lsquants_space_Length$();
  }
  return $n_Lsquants_space_Length$;
}
export { $m_Lsquants_space_Length$ as $m_Lsquants_space_Length$ };
/** @constructor */
function $c_Lsttp_model_ContentTypeRange$() {
  this.Lsttp_model_ContentTypeRange$__f_Wildcard = null;
  this.Lsttp_model_ContentTypeRange$__f_EmptyParameters = null;
  $n_Lsttp_model_ContentTypeRange$ = this;
  this.Lsttp_model_ContentTypeRange$__f_Wildcard = "*";
  this.Lsttp_model_ContentTypeRange$__f_EmptyParameters = $m_sci_Map$EmptyMap$();
  $m_Lsttp_model_ContentTypeRange$();
  $m_Lsttp_model_ContentTypeRange$();
  $m_Lsttp_model_ContentTypeRange$();
  $m_Lsttp_model_ContentTypeRange$();
  $m_Lsttp_model_ContentTypeRange$();
  $m_Lsttp_model_ContentTypeRange$();
  $m_Lsttp_model_ContentTypeRange$();
  $m_Lsttp_model_ContentTypeRange$();
  $m_Lsttp_model_ContentTypeRange$();
  $m_Lsttp_model_ContentTypeRange$();
  $m_Lsttp_model_ContentTypeRange$();
}
export { $c_Lsttp_model_ContentTypeRange$ as $c_Lsttp_model_ContentTypeRange$ };
$c_Lsttp_model_ContentTypeRange$.prototype = new $h_O();
$c_Lsttp_model_ContentTypeRange$.prototype.constructor = $c_Lsttp_model_ContentTypeRange$;
/** @constructor */
function $h_Lsttp_model_ContentTypeRange$() {
}
export { $h_Lsttp_model_ContentTypeRange$ as $h_Lsttp_model_ContentTypeRange$ };
$h_Lsttp_model_ContentTypeRange$.prototype = $c_Lsttp_model_ContentTypeRange$.prototype;
$c_Lsttp_model_ContentTypeRange$.prototype.fromProduct__s_Product__Lsttp_model_ContentTypeRange = (function(x$0) {
  return new $c_Lsttp_model_ContentTypeRange(x$0.productElement__I__O(0), x$0.productElement__I__O(1), x$0.productElement__I__O(2), x$0.productElement__I__O(3));
});
$c_Lsttp_model_ContentTypeRange$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_ContentTypeRange(p);
});
var $d_Lsttp_model_ContentTypeRange$ = new $TypeData().initClass($c_Lsttp_model_ContentTypeRange$, "sttp.model.ContentTypeRange$", ({
  Lsttp_model_ContentTypeRange$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_ContentTypeRange$ as $d_Lsttp_model_ContentTypeRange$ };
var $n_Lsttp_model_ContentTypeRange$;
function $m_Lsttp_model_ContentTypeRange$() {
  if ((!$n_Lsttp_model_ContentTypeRange$)) {
    $n_Lsttp_model_ContentTypeRange$ = new $c_Lsttp_model_ContentTypeRange$();
  }
  return $n_Lsttp_model_ContentTypeRange$;
}
export { $m_Lsttp_model_ContentTypeRange$ as $m_Lsttp_model_ContentTypeRange$ };
/** @constructor */
function $c_Lsttp_model_Uri$Authority$() {
  this.Lsttp_model_Uri$Authority$__f_Empty = null;
  $n_Lsttp_model_Uri$Authority$ = this;
  this.Lsttp_model_Uri$Authority$__f_Empty = $m_Lsttp_model_Uri$Authority$().apply__T__Lsttp_model_Uri$Authority("");
}
export { $c_Lsttp_model_Uri$Authority$ as $c_Lsttp_model_Uri$Authority$ };
$c_Lsttp_model_Uri$Authority$.prototype = new $h_O();
$c_Lsttp_model_Uri$Authority$.prototype.constructor = $c_Lsttp_model_Uri$Authority$;
/** @constructor */
function $h_Lsttp_model_Uri$Authority$() {
}
export { $h_Lsttp_model_Uri$Authority$ as $h_Lsttp_model_Uri$Authority$ };
$h_Lsttp_model_Uri$Authority$.prototype = $c_Lsttp_model_Uri$Authority$.prototype;
$c_Lsttp_model_Uri$Authority$.prototype.apply__T__Lsttp_model_Uri$Authority = (function(host) {
  $m_Lsttp_model_Uri$Authority$();
  var userInfo = $m_s_None$();
  var encoding = $m_Lsttp_model_Uri$HostEncoding$().Lsttp_model_Uri$HostEncoding$__f_Standard;
  var hostSegment = new $c_Lsttp_model_Uri$Segment(host, encoding);
  var port = $m_s_None$();
  return new $c_Lsttp_model_Uri$Authority(userInfo, hostSegment, port);
});
$c_Lsttp_model_Uri$Authority$.prototype.apply__T__I__Lsttp_model_Uri$Authority = (function(host, port) {
  $m_Lsttp_model_Uri$Authority$();
  var userInfo = $m_s_None$();
  var encoding = $m_Lsttp_model_Uri$HostEncoding$().Lsttp_model_Uri$HostEncoding$__f_Standard;
  var hostSegment = new $c_Lsttp_model_Uri$Segment(host, encoding);
  var port$1 = new $c_s_Some(port);
  return new $c_Lsttp_model_Uri$Authority(userInfo, hostSegment, port$1);
});
$c_Lsttp_model_Uri$Authority$.prototype.fromProduct__s_Product__Lsttp_model_Uri$Authority = (function(x$0) {
  return new $c_Lsttp_model_Uri$Authority(x$0.productElement__I__O(0), x$0.productElement__I__O(1), x$0.productElement__I__O(2));
});
$c_Lsttp_model_Uri$Authority$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_Uri$Authority(p);
});
var $d_Lsttp_model_Uri$Authority$ = new $TypeData().initClass($c_Lsttp_model_Uri$Authority$, "sttp.model.Uri$Authority$", ({
  Lsttp_model_Uri$Authority$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_Uri$Authority$ as $d_Lsttp_model_Uri$Authority$ };
var $n_Lsttp_model_Uri$Authority$;
function $m_Lsttp_model_Uri$Authority$() {
  if ((!$n_Lsttp_model_Uri$Authority$)) {
    $n_Lsttp_model_Uri$Authority$ = new $c_Lsttp_model_Uri$Authority$();
  }
  return $n_Lsttp_model_Uri$Authority$;
}
export { $m_Lsttp_model_Uri$Authority$ as $m_Lsttp_model_Uri$Authority$ };
/** @constructor */
function $c_Lsttp_model_Uri$QuerySegment$() {
}
export { $c_Lsttp_model_Uri$QuerySegment$ as $c_Lsttp_model_Uri$QuerySegment$ };
$c_Lsttp_model_Uri$QuerySegment$.prototype = new $h_O();
$c_Lsttp_model_Uri$QuerySegment$.prototype.constructor = $c_Lsttp_model_Uri$QuerySegment$;
/** @constructor */
function $h_Lsttp_model_Uri$QuerySegment$() {
}
export { $h_Lsttp_model_Uri$QuerySegment$ as $h_Lsttp_model_Uri$QuerySegment$ };
$h_Lsttp_model_Uri$QuerySegment$.prototype = $c_Lsttp_model_Uri$QuerySegment$.prototype;
$c_Lsttp_model_Uri$QuerySegment$.prototype.fromQueryParams__Lsttp_model_QueryParams__sc_Iterable = (function(mqp) {
  return mqp.Lsttp_model_QueryParams__f_ps.flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var k = x$1._1__O();
      var vs = x$1._2__O();
      if ((vs !== null)) {
        if ((vs.lengthCompare__I__I(0) === 0)) {
          var encoding = $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_StandardValue;
          return new $c_sci_$colon$colon(new $c_Lsttp_model_Uri$QuerySegment$Value(k, encoding), $m_sci_Nil$());
        }
      }
      return vs.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v) => {
        var keyEncoding = $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_Standard;
        var valueEncoding = $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_Standard;
        return new $c_Lsttp_model_Uri$QuerySegment$KeyValue(k, v, keyEncoding, valueEncoding);
      })));
    }
    throw new $c_s_MatchError(x$1);
  })));
});
$c_Lsttp_model_Uri$QuerySegment$.prototype.ordinal__Lsttp_model_Uri$QuerySegment__I = (function(x$0) {
  if ((x$0 instanceof $c_Lsttp_model_Uri$QuerySegment$KeyValue)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lsttp_model_Uri$QuerySegment$Value)) {
    return 1;
  }
  if (false) {
    return 2;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lsttp_model_Uri$QuerySegment$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lsttp_model_Uri$QuerySegment__I(x);
});
var $d_Lsttp_model_Uri$QuerySegment$ = new $TypeData().initClass($c_Lsttp_model_Uri$QuerySegment$, "sttp.model.Uri$QuerySegment$", ({
  Lsttp_model_Uri$QuerySegment$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lsttp_model_Uri$QuerySegment$ as $d_Lsttp_model_Uri$QuerySegment$ };
var $n_Lsttp_model_Uri$QuerySegment$;
function $m_Lsttp_model_Uri$QuerySegment$() {
  if ((!$n_Lsttp_model_Uri$QuerySegment$)) {
    $n_Lsttp_model_Uri$QuerySegment$ = new $c_Lsttp_model_Uri$QuerySegment$();
  }
  return $n_Lsttp_model_Uri$QuerySegment$;
}
export { $m_Lsttp_model_Uri$QuerySegment$ as $m_Lsttp_model_Uri$QuerySegment$ };
function $p_Lsttp_model_UriInterpolator$Tokenizer$__tokenizeAfterSeparator__scm_ArrayBuffer__C__T__Lsttp_model_UriInterpolator$Tokenizer($thiz, acc, separator, s) {
  matchResult41: {
    var \u03b43$___1;
    var \u03b43$___2;
    var x76 = $thiz.sttp$model$UriInterpolator$Tokenizer$$$separatorTokenizerAndToken__C__T2(separator);
    if ((x76 !== null)) {
      var next = x76._1__O();
      var separatorToken = x76._2__O();
      var \u03b43$___1 = next;
      var \u03b43$___2 = separatorToken;
      break matchResult41;
    }
    throw new $c_s_MatchError(x76);
  }
  var next$2 = \u03b43$___1;
  var separatorToken$2 = \u03b43$___2;
  acc.addOne__O__scm_ArrayBuffer(separatorToken$2);
  return next$2.tokenize__scm_ArrayBuffer__T__Lsttp_model_UriInterpolator$Tokenizer(acc, s);
}
export { $p_Lsttp_model_UriInterpolator$Tokenizer$__tokenizeAfterSeparator__scm_ArrayBuffer__C__T__Lsttp_model_UriInterpolator$Tokenizer as $p_Lsttp_model_UriInterpolator$Tokenizer$__tokenizeAfterSeparator__scm_ArrayBuffer__C__T__Lsttp_model_UriInterpolator$Tokenizer };
function $p_Lsttp_model_UriInterpolator$Tokenizer$__split__T__Lsttp_model_internal_FastCharSet__s_Option__s_util_Either($thiz, s, sep, escape) {
  var x = $m_s_None$();
  if ((x === escape)) {
    return $p_Lsttp_model_UriInterpolator$Tokenizer$__splitNoEscape__T__Lsttp_model_internal_FastCharSet__s_util_Either($thiz, s, sep);
  }
  if ((escape instanceof $c_s_Some)) {
    var e = escape.s_Some__f_value;
    return $p_Lsttp_model_UriInterpolator$Tokenizer$__splitWithEscape__T__Lsttp_model_internal_FastCharSet__T2__s_util_Either($thiz, s, sep, e);
  }
  throw new $c_s_MatchError(escape);
}
export { $p_Lsttp_model_UriInterpolator$Tokenizer$__split__T__Lsttp_model_internal_FastCharSet__s_Option__s_util_Either as $p_Lsttp_model_UriInterpolator$Tokenizer$__split__T__Lsttp_model_internal_FastCharSet__s_Option__s_util_Either };
function $p_Lsttp_model_UriInterpolator$Tokenizer$__splitNoEscape__T__Lsttp_model_internal_FastCharSet__s_util_Either($thiz, s, sep) {
  _return: {
    var len = s.length;
    var i = 0;
    while ((i < len)) {
      var index = i;
      var x0 = s.charCodeAt(index);
      if (sep.contains__C__Z(x0)) {
        var i$1 = i;
        break _return;
      }
      i = ((1 + i) | 0);
    }
    var i$1 = (-1);
  }
  if ((i$1 === (-1))) {
    return new $c_s_util_Left(s);
  } else {
    var _1 = s.substring(0, i$1);
    var _2 = s.charCodeAt(i$1);
    var beginIndex = ((1 + i$1) | 0);
    var _3 = s.substring(beginIndex);
    var value = new $c_T3(_1, $bC(_2), _3);
    return new $c_s_util_Right(value);
  }
}
export { $p_Lsttp_model_UriInterpolator$Tokenizer$__splitNoEscape__T__Lsttp_model_internal_FastCharSet__s_util_Either as $p_Lsttp_model_UriInterpolator$Tokenizer$__splitNoEscape__T__Lsttp_model_internal_FastCharSet__s_util_Either };
function $p_Lsttp_model_UriInterpolator$Tokenizer$__splitWithEscape__T__Lsttp_model_internal_FastCharSet__T2__s_util_Either($thiz, s, sep, escape) {
  var sLength = s.length;
  return $p_Lsttp_model_UriInterpolator$Tokenizer$__run$1__I__T__T2__Lsttp_model_internal_FastCharSet__I__Z__s_util_Either($thiz, sLength, s, escape, sep, 0, false);
}
export { $p_Lsttp_model_UriInterpolator$Tokenizer$__splitWithEscape__T__Lsttp_model_internal_FastCharSet__T2__s_util_Either as $p_Lsttp_model_UriInterpolator$Tokenizer$__splitWithEscape__T__Lsttp_model_internal_FastCharSet__T2__s_util_Either };
function $p_Lsttp_model_UriInterpolator$Tokenizer$__tokenizeFragment$1__scm_ArrayBuffer__Lsttp_model_internal_FastCharMap__s_Option__T__V($thiz, buffer$2, separatorsToTokens$1, separatorsEscape$1, f) {
  var initLength = buffer$2.scm_ArrayBuffer__f_size0;
  var sep = separatorsToTokens$1.Lsttp_model_internal_FastCharMap__f_keySet;
  $p_Lsttp_model_UriInterpolator$Tokenizer$__doSplit$1__Lsttp_model_internal_FastCharSet__s_Option__scm_ArrayBuffer__T__V($thiz, sep, separatorsEscape$1, buffer$2, f);
  var end = buffer$2.scm_ArrayBuffer__f_size0;
  var isEmpty = (initLength >= end);
  var scala$collection$immutable$Range$$lastElement = (((-1) + end) | 0);
  if ((!isEmpty)) {
    var i = initLength;
    while (true) {
      var x0 = i;
      matchResult39: {
        var x64 = buffer$2.apply__I__O(x0);
        if ((x64 instanceof $c_Lsttp_model_UriInterpolator$StringToken)) {
          var x67 = x64.Lsttp_model_UriInterpolator$StringToken__f_s;
          var this$7 = $m_sc_StringOps$().headOption$extension__T__s_Option(x67);
          if (this$7.isEmpty__Z()) {
            var $x_1 = $m_s_None$();
          } else {
            var x0$1 = this$7.get__O();
            var ch = $uC(x0$1);
            var $x_1 = separatorsToTokens$1.get__C__s_Option(ch);
          }
          var this$8 = $x_1;
          if ((!this$8.isEmpty__Z())) {
            var x0$2 = this$8.get__O();
            buffer$2.update__I__O__V(x0, x0$2);
            break matchResult39;
          } else {
            break matchResult39;
          }
        }
      }
      if ((i === scala$collection$immutable$Range$$lastElement)) {
        break;
      }
      i = ((1 + i) | 0);
    }
  }
}
export { $p_Lsttp_model_UriInterpolator$Tokenizer$__tokenizeFragment$1__scm_ArrayBuffer__Lsttp_model_internal_FastCharMap__s_Option__T__V as $p_Lsttp_model_UriInterpolator$Tokenizer$__tokenizeFragment$1__scm_ArrayBuffer__Lsttp_model_internal_FastCharMap__s_Option__T__V };
function $p_Lsttp_model_UriInterpolator$Tokenizer$__doSplit$1__Lsttp_model_internal_FastCharSet__s_Option__scm_ArrayBuffer__T__V($thiz, sep$1, escape$1, acc$1, s) {
  var s$tailLocal1 = s;
  while (true) {
    var x80 = $p_Lsttp_model_UriInterpolator$Tokenizer$__split__T__Lsttp_model_internal_FastCharSet__s_Option__s_util_Either($thiz, s$tailLocal1, sep$1, escape$1);
    if ((x80 instanceof $c_s_util_Left)) {
      var x = x80.s_util_Left__f_value;
      var elem = new $c_Lsttp_model_UriInterpolator$StringToken(x);
      acc$1.addOne__O__scm_ArrayBuffer(elem);
      return (void 0);
    }
    if ((x80 instanceof $c_s_util_Right)) {
      var x82 = x80.s_util_Right__f_value;
      if ((x82 !== null)) {
        var before = x82.T3__f__1;
        var separator = $uC(x82.T3__f__2);
        var after = x82.T3__f__3;
        var elem$1 = new $c_Lsttp_model_UriInterpolator$StringToken(before);
        acc$1.addOne__O__scm_ArrayBuffer(elem$1);
        var s$1 = ("" + $cToS(separator));
        var elem$2 = new $c_Lsttp_model_UriInterpolator$StringToken(s$1);
        acc$1.addOne__O__scm_ArrayBuffer(elem$2);
        s$tailLocal1 = after;
        continue;
      }
    }
    throw new $c_s_MatchError(x80);
  }
}
export { $p_Lsttp_model_UriInterpolator$Tokenizer$__doSplit$1__Lsttp_model_internal_FastCharSet__s_Option__scm_ArrayBuffer__T__V as $p_Lsttp_model_UriInterpolator$Tokenizer$__doSplit$1__Lsttp_model_internal_FastCharSet__s_Option__scm_ArrayBuffer__T__V };
function $p_Lsttp_model_UriInterpolator$Tokenizer$__run$1__I__T__T2__Lsttp_model_internal_FastCharSet__I__Z__s_util_Either($thiz, sLength$1, s$1, escape$2, sep$3, i, inEscape) {
  var inEscape$tailLocal1 = inEscape;
  var i$tailLocal1 = i;
  while (true) {
    if ((i$tailLocal1 === sLength$1)) {
      return new $c_s_util_Left(s$1);
    } else {
      var i$1 = i$tailLocal1;
      var c = s$1.charCodeAt(i$1);
      if ((inEscape$tailLocal1 && (c === $uC(escape$2._2__O())))) {
        var i$tailLocal1$tmp1 = ((1 + i$tailLocal1) | 0);
        i$tailLocal1 = i$tailLocal1$tmp1;
        inEscape$tailLocal1 = false;
      } else if (((!inEscape$tailLocal1) && (c === $uC(escape$2._1__O())))) {
        var i$tailLocal1$tmp2 = ((1 + i$tailLocal1) | 0);
        i$tailLocal1 = i$tailLocal1$tmp2;
        inEscape$tailLocal1 = true;
      } else if (((!inEscape$tailLocal1) && sep$3.contains__C__Z(c))) {
        var endIndex = i$tailLocal1;
        var _1 = s$1.substring(0, endIndex);
        var index = i$tailLocal1;
        var _2 = s$1.charCodeAt(index);
        var beginIndex = ((1 + i$tailLocal1) | 0);
        var _3 = s$1.substring(beginIndex);
        var value = new $c_T3(_1, $bC(_2), _3);
        return new $c_s_util_Right(value);
      } else {
        i$tailLocal1 = ((1 + i$tailLocal1) | 0);
      }
    }
  }
}
export { $p_Lsttp_model_UriInterpolator$Tokenizer$__run$1__I__T__T2__Lsttp_model_internal_FastCharSet__I__Z__s_util_Either as $p_Lsttp_model_UriInterpolator$Tokenizer$__run$1__I__T__T2__Lsttp_model_internal_FastCharSet__I__Z__s_util_Either };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$Tokenizer$() {
}
export { $c_Lsttp_model_UriInterpolator$Tokenizer$ as $c_Lsttp_model_UriInterpolator$Tokenizer$ };
$c_Lsttp_model_UriInterpolator$Tokenizer$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$Tokenizer$.prototype.constructor = $c_Lsttp_model_UriInterpolator$Tokenizer$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$Tokenizer$() {
}
export { $h_Lsttp_model_UriInterpolator$Tokenizer$ as $h_Lsttp_model_UriInterpolator$Tokenizer$ };
$h_Lsttp_model_UriInterpolator$Tokenizer$.prototype = $c_Lsttp_model_UriInterpolator$Tokenizer$.prototype;
$c_Lsttp_model_UriInterpolator$Tokenizer$.prototype.sttp$model$UriInterpolator$Tokenizer$$$tokenizeTerminatedFragment__T__Lsttp_model_UriInterpolator$Tokenizer__scm_ArrayBuffer__Lsttp_model_internal_FastCharSet__Lsttp_model_internal_FastCharMap__s_Option__Lsttp_model_UriInterpolator$Tokenizer = (function(s, current, buffer, terminators, separatorsToTokens, separatorsEscape) {
  var x68 = $p_Lsttp_model_UriInterpolator$Tokenizer$__split__T__Lsttp_model_internal_FastCharSet__s_Option__s_util_Either(this, s, terminators, $m_s_None$());
  if ((x68 instanceof $c_s_util_Right)) {
    var x72 = x68.s_util_Right__f_value;
    if ((x72 !== null)) {
      var fragment = x72.T3__f__1;
      var separator = $uC(x72.T3__f__2);
      var rest = x72.T3__f__3;
      $p_Lsttp_model_UriInterpolator$Tokenizer$__tokenizeFragment$1__scm_ArrayBuffer__Lsttp_model_internal_FastCharMap__s_Option__T__V(this, buffer, separatorsToTokens, separatorsEscape, fragment);
      var this$1 = current.endToken__s_Option();
      if ((!this$1.isEmpty__Z())) {
        var x0 = this$1.get__O();
        buffer.addOne__O__scm_ArrayBuffer(x0);
      }
      return $p_Lsttp_model_UriInterpolator$Tokenizer$__tokenizeAfterSeparator__scm_ArrayBuffer__C__T__Lsttp_model_UriInterpolator$Tokenizer(this, buffer, separator, rest);
    }
  }
  if ((x68 instanceof $c_s_util_Left)) {
    var fragment$2 = x68.s_util_Left__f_value;
    $p_Lsttp_model_UriInterpolator$Tokenizer$__tokenizeFragment$1__scm_ArrayBuffer__Lsttp_model_internal_FastCharMap__s_Option__T__V(this, buffer, separatorsToTokens, separatorsEscape, fragment$2);
    return current;
  }
  throw new $c_s_MatchError(x68);
});
$c_Lsttp_model_UriInterpolator$Tokenizer$.prototype.sttp$model$UriInterpolator$Tokenizer$$$separatorTokenizerAndToken__C__T2 = (function(separator) {
  switch (separator) {
    case 47: {
      var _1 = $m_Lsttp_model_UriInterpolator$Tokenizer$Path$();
      var _2 = $m_Lsttp_model_UriInterpolator$PathStart$();
      return $ct_T2__O__O__(new $c_T2(), _1, _2);
      break;
    }
    case 63: {
      var _1$1 = $m_Lsttp_model_UriInterpolator$Tokenizer$Query$();
      var _2$1 = $m_Lsttp_model_UriInterpolator$QueryStart$();
      return $ct_T2__O__O__(new $c_T2(), _1$1, _2$1);
      break;
    }
    case 35: {
      var _1$2 = $m_Lsttp_model_UriInterpolator$Tokenizer$Fragment$();
      var _2$2 = $m_Lsttp_model_UriInterpolator$FragmentStart$();
      return $ct_T2__O__O__(new $c_T2(), _1$2, _2$2);
      break;
    }
    default: {
      throw new $c_s_MatchError($bC(separator));
    }
  }
});
$c_Lsttp_model_UriInterpolator$Tokenizer$.prototype.ordinal__Lsttp_model_UriInterpolator$Tokenizer__I = (function(x$0) {
  if ((x$0 === $m_Lsttp_model_UriInterpolator$Tokenizer$Scheme$())) {
    return 0;
  }
  if ((x$0 === $m_Lsttp_model_UriInterpolator$Tokenizer$AfterScheme$())) {
    return 1;
  }
  if ((x$0 === $m_Lsttp_model_UriInterpolator$Tokenizer$Authority$())) {
    return 2;
  }
  if ((x$0 === $m_Lsttp_model_UriInterpolator$Tokenizer$Path$())) {
    return 3;
  }
  if ((x$0 === $m_Lsttp_model_UriInterpolator$Tokenizer$Query$())) {
    return 4;
  }
  if ((x$0 === $m_Lsttp_model_UriInterpolator$Tokenizer$Fragment$())) {
    return 5;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lsttp_model_UriInterpolator$Tokenizer$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lsttp_model_UriInterpolator$Tokenizer__I(x);
});
var $d_Lsttp_model_UriInterpolator$Tokenizer$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$Tokenizer$, "sttp.model.UriInterpolator$Tokenizer$", ({
  Lsttp_model_UriInterpolator$Tokenizer$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lsttp_model_UriInterpolator$Tokenizer$ as $d_Lsttp_model_UriInterpolator$Tokenizer$ };
var $n_Lsttp_model_UriInterpolator$Tokenizer$;
function $m_Lsttp_model_UriInterpolator$Tokenizer$() {
  if ((!$n_Lsttp_model_UriInterpolator$Tokenizer$)) {
    $n_Lsttp_model_UriInterpolator$Tokenizer$ = new $c_Lsttp_model_UriInterpolator$Tokenizer$();
  }
  return $n_Lsttp_model_UriInterpolator$Tokenizer$;
}
export { $m_Lsttp_model_UriInterpolator$Tokenizer$ as $m_Lsttp_model_UriInterpolator$Tokenizer$ };
function $p_Lsttp_model_UriInterpolator$UriBuilder$__isValueToken$1__Lsttp_model_UriInterpolator$Token__Z($thiz, t) {
  if ((t instanceof $c_Lsttp_model_UriInterpolator$ExpressionToken)) {
    return true;
  } else if ((t instanceof $c_Lsttp_model_UriInterpolator$StringToken)) {
    return true;
  } else {
    var x = $m_Lsttp_model_UriInterpolator$EqInQuery$();
    return (x === t);
  }
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$__isValueToken$1__Lsttp_model_UriInterpolator$Token__Z as $p_Lsttp_model_UriInterpolator$UriBuilder$__isValueToken$1__Lsttp_model_UriInterpolator$Token__Z };
function $p_Lsttp_model_UriInterpolator$UriBuilder$__doToSeq$1__sci_VectorBuilder__Z__Lsttp_model_internal_ArrayView__V($thiz, b$1, decodePlusAsSpace$1, ts) {
  var ts$tailLocal1 = ts;
  while (true) {
    var this$1 = ts$tailLocal1;
    var i = this$1.Lsttp_model_internal_ArrayView__f_from;
    var xs = this$1.Lsttp_model_internal_ArrayView__f_arr;
    var len = $m_jl_reflect_Array$().getLength__O__I(xs);
    while (true) {
      if ((i < len)) {
        var x0 = $m_sr_ScalaRunTime$().array_apply__O__I__O(this$1.Lsttp_model_internal_ArrayView__f_arr, i);
        var $x_1 = (!$p_Lsttp_model_UriInterpolator$UriBuilder$__isValueToken$1__Lsttp_model_UriInterpolator$Token__Z($thiz, x0));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        i = ((1 + i) | 0);
      } else {
        break;
      }
    }
    var tsWithValuesPrefix = new $c_Lsttp_model_internal_ArrayView(this$1.Lsttp_model_internal_ArrayView__f_arr, i, this$1.Lsttp_model_internal_ArrayView__f_till);
    var i$1 = tsWithValuesPrefix.Lsttp_model_internal_ArrayView__f_from;
    while (true) {
      if ((i$1 < tsWithValuesPrefix.Lsttp_model_internal_ArrayView__f_till)) {
        var x0$1 = $m_sr_ScalaRunTime$().array_apply__O__I__O(tsWithValuesPrefix.Lsttp_model_internal_ArrayView__f_arr, i$1);
        var $x_2 = $p_Lsttp_model_UriInterpolator$UriBuilder$__isValueToken$1__Lsttp_model_UriInterpolator$Token__Z($thiz, x0$1);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        i$1 = ((1 + i$1) | 0);
      } else {
        break;
      }
    }
    var _1 = new $c_Lsttp_model_internal_ArrayView(tsWithValuesPrefix.Lsttp_model_internal_ArrayView__f_arr, tsWithValuesPrefix.Lsttp_model_internal_ArrayView__f_from, i$1);
    var _2 = new $c_Lsttp_model_internal_ArrayView(tsWithValuesPrefix.Lsttp_model_internal_ArrayView__f_arr, ((1 + i$1) | 0), tsWithValuesPrefix.Lsttp_model_internal_ArrayView__f_till);
    var \u03b47$___1 = _1;
    var \u03b47$___2 = _2;
    var valueTs$2 = \u03b47$___1;
    var tailTs$2 = \u03b47$___2;
    if (valueTs$2.nonEmpty__Z()) {
      if ((valueTs$2 !== null)) {
        var x268 = $m_Lsttp_model_internal_Singleton$().unapply__Lsttp_model_internal_ArrayView__s_Option(valueTs$2);
        if ((!x268.isEmpty__Z())) {
          var x269 = x268.get__O();
          if ((x269 instanceof $c_Lsttp_model_UriInterpolator$ExpressionToken)) {
            var x273 = x269.Lsttp_model_UriInterpolator$ExpressionToken__f_e;
            if ($is_sc_Iterable(x273)) {
              var elems = x273.flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$anyToStringOpt__O__s_Option(a))));
              b$1.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
              ts$tailLocal1 = tailTs$2;
              continue;
            }
            if ($m_sr_ScalaRunTime$().isArray__O__I__Z(x273, 1)) {
              var $x_3 = $m_s_Predef$();
              var capacity = 0;
              var size = 0;
              var jsElems = null;
              capacity = 0;
              size = 0;
              jsElems = [];
              var i$2 = 0;
              while ((i$2 < $m_jl_reflect_Array$().getLength__O__I(x273))) {
                var x0$2 = $m_sr_ScalaRunTime$().array_apply__O__I__O(x273, i$2);
                var elems$1 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$anyToStringOpt__O__s_Option(x0$2);
                var it = elems$1.iterator__sc_Iterator();
                while (it.hasNext__Z()) {
                  var elem = it.next__O();
                  var unboxedElem = ((elem === null) ? null : elem);
                  jsElems.push(unboxedElem);
                }
                i$2 = ((1 + i$2) | 0);
              }
              var elems$2 = $x_3.wrapRefArray__AO__scm_ArraySeq$ofRef(new ($d_T.getArrayOf().constr)(jsElems));
              b$1.addAll__sc_IterableOnce__sci_VectorBuilder(elems$2);
              ts$tailLocal1 = tailTs$2;
              continue;
            }
          }
        }
      }
      if ((valueTs$2.size__I() === 1)) {
        matchResult77: {
          var x246 = valueTs$2.get__I__O(0);
          if ((x246 instanceof $c_Lsttp_model_UriInterpolator$StringToken)) {
            var x252 = x246.Lsttp_model_UriInterpolator$StringToken__f_s;
            var elem$1 = $thiz.sttp$model$UriInterpolator$UriBuilder$$$decode__T__Z__T(x252, decodePlusAsSpace$1);
            b$1.addOne__O__sci_VectorBuilder(elem$1);
            break matchResult77;
          }
          if ((x246 instanceof $c_Lsttp_model_UriInterpolator$ExpressionToken)) {
            var x249 = x246.Lsttp_model_UriInterpolator$ExpressionToken__f_e;
            var this$14 = $thiz.sttp$model$UriInterpolator$UriBuilder$$$anyToStringOpt__O__s_Option(x249);
            if ((!this$14.isEmpty__Z())) {
              var x0$3 = this$14.get__O();
              b$1.addOne__O__sci_VectorBuilder(x0$3);
              break matchResult77;
            } else {
              break matchResult77;
            }
          }
          var x = $m_Lsttp_model_UriInterpolator$EqInQuery$();
          if ((x === x246)) {
            b$1.addOne__O__sci_VectorBuilder("=");
            break matchResult77;
          }
        }
        ts$tailLocal1 = tailTs$2;
        continue;
      }
      var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 128);
      var elem$2 = false;
      elem$2 = true;
      var i$3 = valueTs$2.Lsttp_model_internal_ArrayView__f_from;
      while ((i$3 < valueTs$2.Lsttp_model_internal_ArrayView__f_till)) {
        var x0$4 = $m_sr_ScalaRunTime$().array_apply__O__I__O(valueTs$2.Lsttp_model_internal_ArrayView__f_arr, i$3);
        if ((x0$4 instanceof $c_Lsttp_model_UriInterpolator$StringToken)) {
          var x259 = x0$4.Lsttp_model_UriInterpolator$StringToken__f_s;
          var value = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$decode__T__Z__T(x259, decodePlusAsSpace$1);
          var $x_4 = new $c_s_Some(value);
        } else if ((x0$4 instanceof $c_Lsttp_model_UriInterpolator$ExpressionToken)) {
          var x256 = x0$4.Lsttp_model_UriInterpolator$ExpressionToken__f_e;
          var $x_4 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$anyToStringOpt__O__s_Option(x256);
        } else {
          var x$1 = $m_Lsttp_model_UriInterpolator$EqInQuery$();
          if ((x$1 === x0$4)) {
            var $x_4 = new $c_s_Some("=");
          } else {
            var $x_4 = $m_s_None$();
          }
        }
        var this$20 = $x_4;
        if ((!this$20.isEmpty__Z())) {
          var x0$5 = this$20.get__O();
          sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + x0$5);
          elem$2 = false;
        }
        i$3 = ((1 + i$3) | 0);
      }
      if (elem$2) {
        var mbStr = $m_s_None$();
      } else {
        var value$1 = sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
        var mbStr = new $c_s_Some(value$1);
      }
      if ((!mbStr.isEmpty__Z())) {
        var x0$6 = mbStr.get__O();
        b$1.addOne__O__sci_VectorBuilder(x0$6);
      }
      ts$tailLocal1 = tailTs$2;
    } else {
      return (void 0);
    }
  }
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$__doToSeq$1__sci_VectorBuilder__Z__Lsttp_model_internal_ArrayView__V as $p_Lsttp_model_UriInterpolator$UriBuilder$__doToSeq$1__sci_VectorBuilder__Z__Lsttp_model_internal_ArrayView__V };
function $p_Lsttp_model_UriInterpolator$UriBuilder$__doSplit$2__O__sci_VectorBuilder__Lsttp_model_internal_ArrayView__V($thiz, sep$5, b$4, vv) {
  var vv$tailLocal1 = vv;
  while (true) {
    var x289 = vv$tailLocal1.indexOf__O__I(sep$5);
    if ((x289 === (-1))) {
      var elem = vv$tailLocal1;
      b$4.addOne__O__sci_VectorBuilder(elem);
      return (void 0);
    }
    var elem$1 = vv$tailLocal1.take__I__Lsttp_model_internal_ArrayView(x289);
    b$4.addOne__O__sci_VectorBuilder(elem$1);
    vv$tailLocal1 = vv$tailLocal1.drop__I__Lsttp_model_internal_ArrayView(((1 + x289) | 0));
  }
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$__doSplit$2__O__sci_VectorBuilder__Lsttp_model_internal_ArrayView__V as $p_Lsttp_model_UriInterpolator$UriBuilder$__doSplit$2__O__sci_VectorBuilder__Lsttp_model_internal_ArrayView__V };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$UriBuilder$() {
}
export { $c_Lsttp_model_UriInterpolator$UriBuilder$ as $c_Lsttp_model_UriInterpolator$UriBuilder$ };
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype.constructor = $c_Lsttp_model_UriInterpolator$UriBuilder$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$UriBuilder$() {
}
export { $h_Lsttp_model_UriInterpolator$UriBuilder$ as $h_Lsttp_model_UriInterpolator$UriBuilder$ };
$h_Lsttp_model_UriInterpolator$UriBuilder$.prototype = $c_Lsttp_model_UriInterpolator$UriBuilder$.prototype;
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype.sttp$model$UriInterpolator$UriBuilder$$$anyToString__O__T = (function(a) {
  var this$1 = this.sttp$model$UriInterpolator$UriBuilder$$$anyToStringOpt__O__s_Option(a);
  return (this$1.isEmpty__Z() ? "" : this$1.get__O());
});
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype.sttp$model$UriInterpolator$UriBuilder$$$anyToStringOpt__O__s_Option = (function(a) {
  var x = $m_s_None$();
  if ((x === a)) {
    return $m_s_None$();
  } else if ((a === null)) {
    return $m_s_None$();
  } else if ((a instanceof $c_s_Some)) {
    var x$3 = a.s_Some__f_value;
    var value = $dp_toString__T(x$3);
    return new $c_s_Some(value);
  } else {
    var value$1 = $dp_toString__T(a);
    return new $c_s_Some(value$1);
  }
});
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype.sttp$model$UriInterpolator$UriBuilder$$$tokensToStringSeq__Lsttp_model_internal_ArrayView__Z__sci_Seq = (function(tokens, decodePlusAsSpace) {
  var b = new $c_sci_VectorBuilder();
  $p_Lsttp_model_UriInterpolator$UriBuilder$__doToSeq$1__sci_VectorBuilder__Z__Lsttp_model_internal_ArrayView__V(this, b, decodePlusAsSpace, tokens);
  return b.result__sci_Vector();
});
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype.sttp$model$UriInterpolator$UriBuilder$$$tokensToStringOpt__Lsttp_model_internal_ArrayView__Z__s_Option = (function(t, decodePlusAsSpace) {
  if (t.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    if ((t !== null)) {
      var x276 = $m_Lsttp_model_internal_Singleton$().unapply__Lsttp_model_internal_ArrayView__s_Option(t);
      if ((!x276.isEmpty__Z())) {
        var x277 = x276.get__O();
        if ((x277 instanceof $c_Lsttp_model_UriInterpolator$ExpressionToken)) {
          var x281 = x277.Lsttp_model_UriInterpolator$ExpressionToken__f_e;
          return this.sttp$model$UriInterpolator$UriBuilder$$$anyToStringOpt__O__s_Option(x281);
        }
      }
    }
    var value = this.sttp$model$UriInterpolator$UriBuilder$$$tokensToString__Lsttp_model_internal_ArrayView__Z__T(t, decodePlusAsSpace);
    return new $c_s_Some(value);
  }
});
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype.sttp$model$UriInterpolator$UriBuilder$$$tokensToString__Lsttp_model_internal_ArrayView__Z__T = (function(t, decodePlusAsSpace) {
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 128);
  var i = t.Lsttp_model_internal_ArrayView__f_from;
  while ((i < t.Lsttp_model_internal_ArrayView__f_till)) {
    var x0 = $m_sr_ScalaRunTime$().array_apply__O__I__O(t.Lsttp_model_internal_ArrayView__f_arr, i);
    if ((x0 instanceof $c_Lsttp_model_UriInterpolator$StringToken)) {
      var x288 = x0.Lsttp_model_UriInterpolator$StringToken__f_s;
      var str = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$decode__T__Z__T(x288, decodePlusAsSpace);
    } else if ((x0 instanceof $c_Lsttp_model_UriInterpolator$ExpressionToken)) {
      var x285 = x0.Lsttp_model_UriInterpolator$ExpressionToken__f_e;
      var str = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$anyToString__O__T(x285);
    } else {
      var str = "";
    }
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
    i = ((1 + i) | 0);
  }
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype.sttp$model$UriInterpolator$UriBuilder$$$split__Lsttp_model_internal_ArrayView__O__s_util_Either = (function(v, sep) {
  var i = v.indexOf__O__I(sep);
  if ((i === (-1))) {
    return new $c_s_util_Left(v);
  } else {
    var _1 = v.take__I__Lsttp_model_internal_ArrayView(i);
    var _2 = v.get__I__O(i);
    var _3 = v.drop__I__Lsttp_model_internal_ArrayView(((1 + i) | 0));
    var value = new $c_T3(_1, _2, _3);
    return new $c_s_util_Right(value);
  }
});
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype.sttp$model$UriInterpolator$UriBuilder$$$splitToGroups__Lsttp_model_internal_ArrayView__O__sci_Vector = (function(v, sep) {
  var elem = 0;
  elem = 0;
  var i = v.Lsttp_model_internal_ArrayView__f_from;
  while ((i < v.Lsttp_model_internal_ArrayView__f_till)) {
    var x0 = $m_sr_ScalaRunTime$().array_apply__O__I__O(v.Lsttp_model_internal_ArrayView__f_arr, i);
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x0, sep)) {
      elem = ((1 + elem) | 0);
    }
    i = ((1 + i) | 0);
  }
  var b = new $c_sci_VectorBuilder();
  $p_Lsttp_model_UriInterpolator$UriBuilder$__doSplit$2__O__sci_VectorBuilder__Lsttp_model_internal_ArrayView__V(this, sep, b, v);
  return b.result__sci_Vector();
});
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype.sttp$model$UriInterpolator$UriBuilder$$$decode__T__Z__T = (function(s, decodePlusAsSpace) {
  return $m_Lsttp_model_internal_Rfc3986$().decode__Z__T__T__T(decodePlusAsSpace, s, ($m_Lsttp_model_internal_Rfc3986$(), "utf-8"));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype.ordinal__Lsttp_model_UriInterpolator$UriBuilder__I = (function(x$0) {
  if ((x$0 === $m_Lsttp_model_UriInterpolator$UriBuilder$Scheme$())) {
    return 0;
  }
  if ((x$0 === $m_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$())) {
    return 1;
  }
  if ((x$0 === $m_Lsttp_model_UriInterpolator$UriBuilder$HostPort$())) {
    return 2;
  }
  if ((x$0 === $m_Lsttp_model_UriInterpolator$UriBuilder$Path$())) {
    return 3;
  }
  if ((x$0 === $m_Lsttp_model_UriInterpolator$UriBuilder$Query$())) {
    return 4;
  }
  if ((x$0 === $m_Lsttp_model_UriInterpolator$UriBuilder$Fragment$())) {
    return 5;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lsttp_model_UriInterpolator$UriBuilder__I(x);
});
var $d_Lsttp_model_UriInterpolator$UriBuilder$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$UriBuilder$, "sttp.model.UriInterpolator$UriBuilder$", ({
  Lsttp_model_UriInterpolator$UriBuilder$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lsttp_model_UriInterpolator$UriBuilder$ as $d_Lsttp_model_UriInterpolator$UriBuilder$ };
var $n_Lsttp_model_UriInterpolator$UriBuilder$;
function $m_Lsttp_model_UriInterpolator$UriBuilder$() {
  if ((!$n_Lsttp_model_UriInterpolator$UriBuilder$)) {
    $n_Lsttp_model_UriInterpolator$UriBuilder$ = new $c_Lsttp_model_UriInterpolator$UriBuilder$();
  }
  return $n_Lsttp_model_UriInterpolator$UriBuilder$;
}
export { $m_Lsttp_model_UriInterpolator$UriBuilder$ as $m_Lsttp_model_UriInterpolator$UriBuilder$ };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$() {
  this.Lsttp_model_headers_CacheDirective$__f_MaxAgePattern = null;
  this.Lsttp_model_headers_CacheDirective$__f_MaxStalePattern = null;
  this.Lsttp_model_headers_CacheDirective$__f_MinFreshPattern = null;
  this.Lsttp_model_headers_CacheDirective$__f_SMaxagePattern = null;
  this.Lsttp_model_headers_CacheDirective$__f_StaleWhileRevalidatePattern = null;
  this.Lsttp_model_headers_CacheDirective$__f_StaleIfErrorPattern = null;
  $n_Lsttp_model_headers_CacheDirective$ = this;
  this.Lsttp_model_headers_CacheDirective$__f_MaxAgePattern = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "max-age=(\\d+)", $m_sci_Nil$());
  this.Lsttp_model_headers_CacheDirective$__f_MaxStalePattern = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "max-stale(=\\d+)?", $m_sci_Nil$());
  this.Lsttp_model_headers_CacheDirective$__f_MinFreshPattern = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "min-fresh=(\\d+)", $m_sci_Nil$());
  this.Lsttp_model_headers_CacheDirective$__f_SMaxagePattern = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "s-maxage=(\\d+)", $m_sci_Nil$());
  this.Lsttp_model_headers_CacheDirective$__f_StaleWhileRevalidatePattern = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "stale-while-revalidate=(\\d+)", $m_sci_Nil$());
  this.Lsttp_model_headers_CacheDirective$__f_StaleIfErrorPattern = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "stale-if-error=(\\d+)", $m_sci_Nil$());
}
export { $c_Lsttp_model_headers_CacheDirective$ as $c_Lsttp_model_headers_CacheDirective$ };
$c_Lsttp_model_headers_CacheDirective$.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$() {
}
export { $h_Lsttp_model_headers_CacheDirective$ as $h_Lsttp_model_headers_CacheDirective$ };
$h_Lsttp_model_headers_CacheDirective$.prototype = $c_Lsttp_model_headers_CacheDirective$.prototype;
$c_Lsttp_model_headers_CacheDirective$.prototype.parse__T__sci_List = (function(s) {
  var $x_10 = $m_s_Predef$();
  var xs = $f_T__split__T__I__AT(s, ",", 0);
  var f = ((_$2) => {
    var this$2 = $f_T__trim__T(_$2);
    return this$2.toLowerCase();
  });
  var len = xs.u.length;
  var ys = new ($d_T.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((xs !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = xs.u[i];
        ys.u[$x_1] = f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = xs.u[i];
        ys.u[$x_2] = f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = xs.u[i];
        ys.u[$x_3] = f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_J)) {
      while ((i < len)) {
        var $x_4 = i;
        var t = xs.u[i];
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        ys.u[$x_4] = f(new $c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_F)) {
      while ((i < len)) {
        var $x_5 = i;
        var x0$3 = xs.u[i];
        ys.u[$x_5] = f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_C)) {
      while ((i < len)) {
        var $x_6 = i;
        var x0$4 = xs.u[i];
        ys.u[$x_6] = f($bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_B)) {
      while ((i < len)) {
        var $x_7 = i;
        var x0$5 = xs.u[i];
        ys.u[$x_7] = f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_S)) {
      while ((i < len)) {
        var $x_8 = i;
        var x0$6 = xs.u[i];
        ys.u[$x_8] = f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((xs instanceof $ac_Z)) {
      while ((i < len)) {
        var $x_9 = i;
        var x0$7 = xs.u[i];
        ys.u[$x_9] = f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $c_s_MatchError(xs);
    }
  }
  var this$6 = $x_10.wrapRefArray__AO__scm_ArraySeq$ofRef(ys);
  var this$72 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$6);
  var f$1 = ((x$1) => {
    if ((x$1 !== null)) {
      var x59 = $m_Lsttp_model_headers_CacheDirective$().Lsttp_model_headers_CacheDirective$__f_MaxAgePattern.unapplySeq__jl_CharSequence__s_Option(x$1);
      if ((!x59.isEmpty__Z())) {
        var x60 = x59.get__O();
        if ((x60.lengthCompare__I__I(1) === 0)) {
          var x61 = $f_sc_LinearSeqOps__apply__I__O(x60, 0);
          var this$8 = $m_Lsttp_model_internal_ParseUtils$().toIntOption__T__s_Option(x61);
          if (this$8.isEmpty__Z()) {
            var this$15 = $m_s_None$();
          } else {
            var x0$8 = this$8.get__O();
            var s$1 = (x0$8 | 0);
            var this$10 = new $c_s_concurrent_duration_package$DurationInt(s$1);
            var unit = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
            var this$ = this$10.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
            $m_s_concurrent_duration_Duration$();
            var hi$1 = (this$ >> 31);
            var d = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$, hi$1), unit);
            var this$15 = new $c_s_Some(new $c_Lsttp_model_headers_CacheDirective$MaxAge(d));
          }
          return (this$15.isEmpty__Z() ? new $c_s_util_Left($m_sc_StringOps$().format$extension__T__sci_Seq__T("Unable to parse string: %s", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x61])))) : new $c_s_util_Right(this$15.get__O()));
        }
      }
      var x56 = $m_Lsttp_model_headers_CacheDirective$().Lsttp_model_headers_CacheDirective$__f_MaxStalePattern.unapplySeq__jl_CharSequence__s_Option(x$1);
      if ((!x56.isEmpty__Z())) {
        var x57 = x56.get__O();
        if ((x57.lengthCompare__I__I(1) === 0)) {
          var x58 = $f_sc_LinearSeqOps__apply__I__O(x57, 0);
          var this$17 = $m_s_Option$().apply__O__s_Option(x58);
          if (this$17.isEmpty__Z()) {
            var $x_11 = $m_s_None$();
          } else {
            var x0$9 = this$17.get__O();
            var $x_11 = $m_Lsttp_model_internal_ParseUtils$().toIntOption__T__s_Option(x0$9.substring(1));
          }
          var this$18 = $x_11;
          if (this$18.isEmpty__Z()) {
            var d$1 = $m_s_None$();
          } else {
            var x0$10 = this$18.get__O();
            var _$3 = (x0$10 | 0);
            var this$20 = new $c_s_concurrent_duration_package$DurationInt(_$3);
            var unit$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
            var this$$1 = this$20.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
            $m_s_concurrent_duration_Duration$();
            var hi$2 = (this$$1 >> 31);
            var d$1 = new $c_s_Some(new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$$1, hi$2), unit$1));
          }
          var value = new $c_Lsttp_model_headers_CacheDirective$MaxStale(d$1);
          return new $c_s_util_Right(value);
        }
      }
      var x53 = $m_Lsttp_model_headers_CacheDirective$().Lsttp_model_headers_CacheDirective$__f_MinFreshPattern.unapplySeq__jl_CharSequence__s_Option(x$1);
      if ((!x53.isEmpty__Z())) {
        var x54 = x53.get__O();
        if ((x54.lengthCompare__I__I(1) === 0)) {
          var x55 = $f_sc_LinearSeqOps__apply__I__O(x54, 0);
          var this$26 = $m_Lsttp_model_internal_ParseUtils$().toIntOption__T__s_Option(x55);
          if (this$26.isEmpty__Z()) {
            var this$33 = $m_s_None$();
          } else {
            var x0$11 = this$26.get__O();
            var s$2 = (x0$11 | 0);
            var this$28 = new $c_s_concurrent_duration_package$DurationInt(s$2);
            var unit$2 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
            var this$$2 = this$28.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
            $m_s_concurrent_duration_Duration$();
            var hi$3 = (this$$2 >> 31);
            var d$2 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$$2, hi$3), unit$2);
            var this$33 = new $c_s_Some(new $c_Lsttp_model_headers_CacheDirective$MinFresh(d$2));
          }
          return (this$33.isEmpty__Z() ? new $c_s_util_Left($m_sc_StringOps$().format$extension__T__sci_Seq__T("Unable to parse string: %s", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x55])))) : new $c_s_util_Right(this$33.get__O()));
        }
      }
    }
    switch (x$1) {
      case "no-cache": {
        var value$1 = $m_Lsttp_model_headers_CacheDirective$NoCache$();
        return new $c_s_util_Right(value$1);
        break;
      }
      case "no-store": {
        var value$2 = $m_Lsttp_model_headers_CacheDirective$NoStore$();
        return new $c_s_util_Right(value$2);
        break;
      }
      case "no-transform": {
        var value$3 = $m_Lsttp_model_headers_CacheDirective$NoTransform$();
        return new $c_s_util_Right(value$3);
        break;
      }
      case "only-if-cached": {
        var value$4 = $m_Lsttp_model_headers_CacheDirective$OnlyIfCached$();
        return new $c_s_util_Right(value$4);
        break;
      }
      case "must-revalidate": {
        var value$5 = $m_Lsttp_model_headers_CacheDirective$MustRevalidate$();
        return new $c_s_util_Right(value$5);
        break;
      }
      case "public": {
        var value$6 = $m_Lsttp_model_headers_CacheDirective$Public$();
        return new $c_s_util_Right(value$6);
        break;
      }
      case "private": {
        var value$7 = $m_Lsttp_model_headers_CacheDirective$Private$();
        return new $c_s_util_Right(value$7);
        break;
      }
      case "proxy-revalidate": {
        var value$8 = $m_Lsttp_model_headers_CacheDirective$ProxyRevalidate$();
        return new $c_s_util_Right(value$8);
        break;
      }
      default: {
        if ((x$1 !== null)) {
          var x50 = $m_Lsttp_model_headers_CacheDirective$().Lsttp_model_headers_CacheDirective$__f_SMaxagePattern.unapplySeq__jl_CharSequence__s_Option(x$1);
          if ((!x50.isEmpty__Z())) {
            var x51 = x50.get__O();
            if ((x51.lengthCompare__I__I(1) === 0)) {
              var x52 = $f_sc_LinearSeqOps__apply__I__O(x51, 0);
              var this$43 = $m_Lsttp_model_internal_ParseUtils$().toIntOption__T__s_Option(x52);
              if (this$43.isEmpty__Z()) {
                var this$50 = $m_s_None$();
              } else {
                var x0$12 = this$43.get__O();
                var s$3 = (x0$12 | 0);
                var this$45 = new $c_s_concurrent_duration_package$DurationInt(s$3);
                var unit$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
                var this$$3 = this$45.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
                $m_s_concurrent_duration_Duration$();
                var hi$4 = (this$$3 >> 31);
                var d$3 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$$3, hi$4), unit$3);
                var this$50 = new $c_s_Some(new $c_Lsttp_model_headers_CacheDirective$SMaxage(d$3));
              }
              return (this$50.isEmpty__Z() ? new $c_s_util_Left($m_sc_StringOps$().format$extension__T__sci_Seq__T("Unable to parse string: %s", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x52])))) : new $c_s_util_Right(this$50.get__O()));
            }
          }
        }
        if ((x$1 === "immutable")) {
          var value$9 = $m_Lsttp_model_headers_CacheDirective$Immutable$();
          return new $c_s_util_Right(value$9);
        }
        if ((x$1 !== null)) {
          var x47 = $m_Lsttp_model_headers_CacheDirective$().Lsttp_model_headers_CacheDirective$__f_StaleWhileRevalidatePattern.unapplySeq__jl_CharSequence__s_Option(x$1);
          if ((!x47.isEmpty__Z())) {
            var x48 = x47.get__O();
            if ((x48.lengthCompare__I__I(1) === 0)) {
              var x49 = $f_sc_LinearSeqOps__apply__I__O(x48, 0);
              var this$53 = $m_Lsttp_model_internal_ParseUtils$().toIntOption__T__s_Option(x49);
              if (this$53.isEmpty__Z()) {
                var this$60 = $m_s_None$();
              } else {
                var x0$13 = this$53.get__O();
                var s$4 = (x0$13 | 0);
                var this$55 = new $c_s_concurrent_duration_package$DurationInt(s$4);
                var unit$4 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
                var this$$4 = this$55.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
                $m_s_concurrent_duration_Duration$();
                var hi$5 = (this$$4 >> 31);
                var d$4 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$$4, hi$5), unit$4);
                var this$60 = new $c_s_Some(new $c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate(d$4));
              }
              return (this$60.isEmpty__Z() ? new $c_s_util_Left($m_sc_StringOps$().format$extension__T__sci_Seq__T("Unable to parse string: %s", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x49])))) : new $c_s_util_Right(this$60.get__O()));
            }
          }
          var x44 = $m_Lsttp_model_headers_CacheDirective$().Lsttp_model_headers_CacheDirective$__f_StaleIfErrorPattern.unapplySeq__jl_CharSequence__s_Option(x$1);
          if ((!x44.isEmpty__Z())) {
            var x45 = x44.get__O();
            if ((x45.lengthCompare__I__I(1) === 0)) {
              var x46 = $f_sc_LinearSeqOps__apply__I__O(x45, 0);
              var this$62 = $m_Lsttp_model_internal_ParseUtils$().toIntOption__T__s_Option(x46);
              if (this$62.isEmpty__Z()) {
                var this$69 = $m_s_None$();
              } else {
                var x0$14 = this$62.get__O();
                var s$5 = (x0$14 | 0);
                var this$64 = new $c_s_concurrent_duration_package$DurationInt(s$5);
                var unit$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
                var this$$5 = this$64.s_concurrent_duration_package$DurationInt__f_scala$concurrent$duration$DurationInt$$n;
                $m_s_concurrent_duration_Duration$();
                var hi$6 = (this$$5 >> 31);
                var d$5 = new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(this$$5, hi$6), unit$5);
                var this$69 = new $c_s_Some(new $c_Lsttp_model_headers_CacheDirective$StaleIfError(d$5));
              }
              return (this$69.isEmpty__Z() ? new $c_s_util_Left($m_sc_StringOps$().format$extension__T__sci_Seq__T("Unable to parse string: %s", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x46])))) : new $c_s_util_Right(this$69.get__O()));
            }
          }
        }
        var value$10 = ("Unknown cache directive: " + x$1);
        return new $c_s_util_Left(value$10);
      }
    }
  });
  if ((this$72 === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var x0$15 = this$72.head__O();
    var h = new $c_sci_$colon$colon(f$1(x0$15), $m_sci_Nil$());
    var t$1 = h;
    var rest = this$72.tail__O();
    while ((rest !== $m_sci_Nil$())) {
      var x0$16 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f$1(x0$16), $m_sci_Nil$());
      t$1.sci_$colon$colon__f_next = nx;
      t$1 = nx;
      rest = rest.tail__O();
    }
    return h;
  }
});
$c_Lsttp_model_headers_CacheDirective$.prototype.ordinal__Lsttp_model_headers_CacheDirective__I = (function(x$0) {
  if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$MaxAge)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$MaxStale)) {
    return 1;
  }
  if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$MinFresh)) {
    return 2;
  }
  if ((x$0 === $m_Lsttp_model_headers_CacheDirective$NoCache$())) {
    return 3;
  }
  if ((x$0 === $m_Lsttp_model_headers_CacheDirective$NoStore$())) {
    return 4;
  }
  if ((x$0 === $m_Lsttp_model_headers_CacheDirective$NoTransform$())) {
    return 5;
  }
  if ((x$0 === $m_Lsttp_model_headers_CacheDirective$OnlyIfCached$())) {
    return 6;
  }
  if ((x$0 === $m_Lsttp_model_headers_CacheDirective$MustRevalidate$())) {
    return 7;
  }
  if ((x$0 === $m_Lsttp_model_headers_CacheDirective$Public$())) {
    return 8;
  }
  if ((x$0 === $m_Lsttp_model_headers_CacheDirective$Private$())) {
    return 9;
  }
  if ((x$0 === $m_Lsttp_model_headers_CacheDirective$ProxyRevalidate$())) {
    return 10;
  }
  if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$SMaxage)) {
    return 11;
  }
  if ((x$0 === $m_Lsttp_model_headers_CacheDirective$Immutable$())) {
    return 12;
  }
  if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate)) {
    return 13;
  }
  if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$StaleIfError)) {
    return 14;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lsttp_model_headers_CacheDirective$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lsttp_model_headers_CacheDirective__I(x);
});
var $d_Lsttp_model_headers_CacheDirective$ = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$, "sttp.model.headers.CacheDirective$", ({
  Lsttp_model_headers_CacheDirective$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$ as $d_Lsttp_model_headers_CacheDirective$ };
var $n_Lsttp_model_headers_CacheDirective$;
function $m_Lsttp_model_headers_CacheDirective$() {
  if ((!$n_Lsttp_model_headers_CacheDirective$)) {
    $n_Lsttp_model_headers_CacheDirective$ = new $c_Lsttp_model_headers_CacheDirective$();
  }
  return $n_Lsttp_model_headers_CacheDirective$;
}
export { $m_Lsttp_model_headers_CacheDirective$ as $m_Lsttp_model_headers_CacheDirective$ };
function $p_Lsttp_model_headers_ContentRange$__processString__T__T__T__s_util_Either($thiz, unit, possibleRange, possibleSize) {
  matchResult8: {
    var range;
    var x17 = $f_T__split__T__I__AT(possibleRange, "-", 0);
    if ((x17 !== null)) {
      if (($m_s_Array$UnapplySeqWrapper$().lengthCompare$extension__O__I__I(x17, 1) === 0)) {
        var x22 = x17.u[0];
        if ((x22 === "*")) {
          var value = $m_s_None$();
          var range = new $c_s_util_Right(value);
          break matchResult8;
        }
      }
      if (($m_s_Array$UnapplySeqWrapper$().lengthCompare$extension__O__I__I(x17, 2) === 0)) {
        var x19 = x17.u[0];
        var x20 = x17.u[1];
        var this$6 = $m_Lsttp_model_internal_ParseUtils$().toLongOption__T__s_Option(x19);
        var this$7 = (this$6.isEmpty__Z() ? new $c_s_util_Left(("Invalid start of range: " + x19)) : new $c_s_util_Right(this$6.get__O()));
        if ((this$7 instanceof $c_s_util_Right)) {
          var b = this$7.s_util_Right__f_value;
          var t = $uJ(b);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          var this$8 = $m_Lsttp_model_internal_ParseUtils$().toLongOption__T__s_Option(x20);
          var this$9 = (this$8.isEmpty__Z() ? new $c_s_util_Left(("Invalid end of range: " + x20)) : new $c_s_util_Right(this$8.get__O()));
          if ((this$9 instanceof $c_s_util_Right)) {
            var b$1 = this$9.s_util_Right__f_value;
            var t$1 = $uJ(b$1);
            var lo$1 = t$1.RTLong__f_lo;
            var hi$1 = t$1.RTLong__f_hi;
            var value$1 = $ct_T2__O__O__(new $c_T2(), new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
            var range = new $c_s_util_Right(new $c_s_Some(value$1));
            break matchResult8;
          } else {
            var range = this$9;
            break matchResult8;
          }
        } else {
          var range = this$7;
          break matchResult8;
        }
      }
    }
    var value$2 = ("Invalid range: " + possibleRange);
    var range = new $c_s_util_Left(value$2);
  }
  if ((possibleSize === "*")) {
    var value$3 = $m_s_None$();
    var size = new $c_s_util_Right(value$3);
  } else {
    var this$14 = $m_Lsttp_model_internal_ParseUtils$().toLongOption__T__s_Option(possibleSize);
    if (this$14.isEmpty__Z()) {
      var this$16 = $m_s_None$();
    } else {
      var x0 = this$14.get__O();
      var t$2 = $uJ(x0);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      var this$16 = new $c_s_Some(new $c_s_Some(new $c_RTLong(lo$2, hi$2)));
    }
    var size = (this$16.isEmpty__Z() ? new $c_s_util_Left($m_sc_StringOps$().format$extension__T__sci_Seq__T("Invalid size: %s", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([possibleSize])))) : new $c_s_util_Right(this$16.get__O()));
  }
  if ((range instanceof $c_s_util_Right)) {
    var b$2 = range.s_util_Right__f_value;
    if ((size instanceof $c_s_util_Right)) {
      var b$3 = size.s_util_Right__f_value;
      var contentRange = new $c_Lsttp_model_headers_ContentRange(unit, b$2, b$3);
      var this$20 = new $c_s_util_Right($ct_T2__O__O__(new $c_T2(), b$3, contentRange));
    } else {
      var this$20 = size;
    }
    if ((this$20 instanceof $c_s_util_Right)) {
      var b$4 = this$20.s_util_Right__f_value;
      if ((b$4 !== null)) {
        b$4._1__O();
        var contentRange$1 = b$4._2__O();
        var this$23 = ($p_Lsttp_model_headers_ContentRange$__isValid__Lsttp_model_headers_ContentRange__Z($m_Lsttp_model_headers_ContentRange$(), contentRange$1) ? new $c_s_util_Right(contentRange$1) : new $c_s_util_Left("Invalid Content-Range"));
        if ((this$23 instanceof $c_s_util_Right)) {
          var b$5 = this$23.s_util_Right__f_value;
          return new $c_s_util_Right(b$5);
        } else {
          return this$23;
        }
      }
      throw new $c_s_MatchError(b$4);
    } else {
      return this$20;
    }
  } else {
    return range;
  }
}
export { $p_Lsttp_model_headers_ContentRange$__processString__T__T__T__s_util_Either as $p_Lsttp_model_headers_ContentRange$__processString__T__T__T__s_util_Either };
function $p_Lsttp_model_headers_ContentRange$__isValid__Lsttp_model_headers_ContentRange__Z($thiz, contentRange) {
  var isSyntaxInvalid = (contentRange.Lsttp_model_headers_ContentRange__f_range.isEmpty__Z() && contentRange.Lsttp_model_headers_ContentRange__f_size.isEmpty__Z());
  var x29 = contentRange.Lsttp_model_headers_ContentRange__f_range;
  if ((x29 instanceof $c_s_Some)) {
    var range = x29.s_Some__f_value;
    var a = $uJ(range._1__O());
    var b = $uJ(range._2__O());
    var ahi = a.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    var isRangeValid = ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) < (b.RTLong__f_lo >>> 0)) : (ahi < bhi));
    var x26 = contentRange.Lsttp_model_headers_ContentRange__f_size;
    if ((x26 instanceof $c_s_Some)) {
      var t = $uJ(x26.s_Some__f_value);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var a$1 = $uJ(range._1__O());
      var ahi$1 = a$1.RTLong__f_hi;
      var $x_1 = ((ahi$1 === hi) ? ((a$1.RTLong__f_lo >>> 0) < (lo >>> 0)) : (ahi$1 < hi));
      var a$2 = $uJ(range._2__O());
      var ahi$2 = a$2.RTLong__f_hi;
      var isRangeAndSizeValid = (!(!($x_1 & ((ahi$2 === hi) ? ((a$2.RTLong__f_lo >>> 0) <= (lo >>> 0)) : (ahi$2 < hi)))));
      return ((isRangeValid && (!isSyntaxInvalid)) && isRangeAndSizeValid);
    }
    var x = $m_s_None$();
    if ((x === x26)) {
      return (isRangeValid && (!isSyntaxInvalid));
    }
    throw new $c_s_MatchError(x26);
  }
  var x$3 = $m_s_None$();
  if ((x$3 === x29)) {
    return (!isSyntaxInvalid);
  }
  throw new $c_s_MatchError(x29);
}
export { $p_Lsttp_model_headers_ContentRange$__isValid__Lsttp_model_headers_ContentRange__Z as $p_Lsttp_model_headers_ContentRange$__isValid__Lsttp_model_headers_ContentRange__Z };
/** @constructor */
function $c_Lsttp_model_headers_ContentRange$() {
}
export { $c_Lsttp_model_headers_ContentRange$ as $c_Lsttp_model_headers_ContentRange$ };
$c_Lsttp_model_headers_ContentRange$.prototype = new $h_O();
$c_Lsttp_model_headers_ContentRange$.prototype.constructor = $c_Lsttp_model_headers_ContentRange$;
/** @constructor */
function $h_Lsttp_model_headers_ContentRange$() {
}
export { $h_Lsttp_model_headers_ContentRange$ as $h_Lsttp_model_headers_ContentRange$ };
$h_Lsttp_model_headers_ContentRange$.prototype = $c_Lsttp_model_headers_ContentRange$.prototype;
$c_Lsttp_model_headers_ContentRange$.prototype.parse__T__s_util_Either = (function(str) {
  var this$1 = $f_T__trim__T(str);
  var x13 = $f_T__split__T__I__AT(this$1, " ", 0);
  if ((x13 !== null)) {
    if (($m_s_Array$UnapplySeqWrapper$().lengthCompare$extension__O__I__I(x13, 2) === 0)) {
      var x15 = x13.u[0];
      var x16 = x13.u[1];
      var x9 = $f_T__split__T__I__AT(x16, "/", 0);
      if ((x9 !== null)) {
        if (($m_s_Array$UnapplySeqWrapper$().lengthCompare$extension__O__I__I(x9, 2) === 0)) {
          var x11 = x9.u[0];
          var x12 = x9.u[1];
          return $p_Lsttp_model_headers_ContentRange$__processString__T__T__T__s_util_Either(this, x15, x11, x12);
        }
      }
      var value = $m_sc_StringOps$().format$extension__T__sci_Seq__T("Expected string in the format: \"range/size\", but got: %s", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x16])));
      return new $c_s_util_Left(value);
    }
  }
  var value$1 = $m_sc_StringOps$().format$extension__T__sci_Seq__T("Expected content-range in the format: \"unit range/size\", but got: %s", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([str])));
  return new $c_s_util_Left(value$1);
});
$c_Lsttp_model_headers_ContentRange$.prototype.fromProduct__s_Product__Lsttp_model_headers_ContentRange = (function(x$0) {
  return new $c_Lsttp_model_headers_ContentRange(x$0.productElement__I__O(0), x$0.productElement__I__O(1), x$0.productElement__I__O(2));
});
$c_Lsttp_model_headers_ContentRange$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_headers_ContentRange(p);
});
var $d_Lsttp_model_headers_ContentRange$ = new $TypeData().initClass($c_Lsttp_model_headers_ContentRange$, "sttp.model.headers.ContentRange$", ({
  Lsttp_model_headers_ContentRange$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_headers_ContentRange$ as $d_Lsttp_model_headers_ContentRange$ };
var $n_Lsttp_model_headers_ContentRange$;
function $m_Lsttp_model_headers_ContentRange$() {
  if ((!$n_Lsttp_model_headers_ContentRange$)) {
    $n_Lsttp_model_headers_ContentRange$ = new $c_Lsttp_model_headers_ContentRange$();
  }
  return $n_Lsttp_model_headers_ContentRange$;
}
export { $m_Lsttp_model_headers_ContentRange$ as $m_Lsttp_model_headers_ContentRange$ };
/** @constructor */
function $c_Lsttp_model_headers_Cookie$() {
  this.Lsttp_model_headers_Cookie$__f_AllowedValueCharacters = null;
  $n_Lsttp_model_headers_Cookie$ = this;
  var x = (("[^" + $m_Lsttp_model_internal_Rfc2616$().Lsttp_model_internal_Rfc2616$__f_CTL) + "]*");
  this.Lsttp_model_headers_Cookie$__f_AllowedValueCharacters = $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), x, $m_sci_Nil$());
}
export { $c_Lsttp_model_headers_Cookie$ as $c_Lsttp_model_headers_Cookie$ };
$c_Lsttp_model_headers_Cookie$.prototype = new $h_O();
$c_Lsttp_model_headers_Cookie$.prototype.constructor = $c_Lsttp_model_headers_Cookie$;
/** @constructor */
function $h_Lsttp_model_headers_Cookie$() {
}
export { $h_Lsttp_model_headers_Cookie$ as $h_Lsttp_model_headers_Cookie$ };
$h_Lsttp_model_headers_Cookie$.prototype = $c_Lsttp_model_headers_Cookie$.prototype;
$c_Lsttp_model_headers_Cookie$.prototype.validateValue__T__s_Option = (function(value) {
  return (this.Lsttp_model_headers_Cookie$__f_AllowedValueCharacters.unapplySeq__jl_CharSequence__s_Option(value).isEmpty__Z() ? new $c_s_Some("Cookie value can not contain control characters") : $m_s_None$());
});
$c_Lsttp_model_headers_Cookie$.prototype.safeApply__T__T__s_util_Either = (function(name, value) {
  var validationErrors = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_s_Option.getArrayOf().constr)([$m_Lsttp_model_internal_Rfc2616$().validateToken__T__T__s_Option("Cookie name", name), this.validateValue__T__s_Option(value)]));
  var pf = new $c_Lsttp_model_internal_Validate$$anon$1();
  var x7 = $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(validationErrors, pf);
  if ((x7 instanceof $c_s_Some)) {
    var e = x7.s_Some__f_value;
    return new $c_s_util_Left(e);
  }
  var x = $m_s_None$();
  if ((x === x7)) {
    var value$1 = new $c_Lsttp_model_headers_Cookie(name, value);
    return new $c_s_util_Right(value$1);
  }
  throw new $c_s_MatchError(x7);
});
$c_Lsttp_model_headers_Cookie$.prototype.parse__T__s_util_Either = (function(s) {
  var ss = $f_T__split__T__I__AT(s, ";", 0);
  var cs = new $c_scm_ListBuffer();
  var i = 0;
  while ((i < ss.u.length)) {
    var vs = $f_T__split__T__I__AT(ss.u[i], "=", 2);
    matchResult4: {
      var x5 = ((vs.u.length === 1) ? $m_Lsttp_model_headers_Cookie$().safeApply__T__T__s_util_Either($f_T__trim__T(vs.u[0]), "") : $m_Lsttp_model_headers_Cookie$().safeApply__T__T__s_util_Either($f_T__trim__T(vs.u[0]), $f_T__trim__T(vs.u[1])));
      if ((x5 instanceof $c_s_util_Right)) {
        var c = x5.s_util_Right__f_value;
        cs.addOne__O__scm_ListBuffer(c);
        break matchResult4;
      }
      if ((x5 instanceof $c_s_util_Left)) {
        var error = x5.s_util_Left__f_value;
        return new $c_s_util_Left(error);
      }
      throw new $c_s_MatchError(x5);
    }
    i = ((1 + i) | 0);
  }
  var value = cs.toList__sci_List();
  return new $c_s_util_Right(value);
});
$c_Lsttp_model_headers_Cookie$.prototype.toString__sci_List__T = (function(cs) {
  var f = ((_$1) => _$1.toString__T());
  if ((cs === $m_sci_Nil$())) {
    var this$1 = $m_sci_Nil$();
  } else {
    var x0 = cs.head__O();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = cs.tail__O();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    var this$1 = h;
  }
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", "; ", "");
});
$c_Lsttp_model_headers_Cookie$.prototype.fromProduct__s_Product__Lsttp_model_headers_Cookie = (function(x$0) {
  return new $c_Lsttp_model_headers_Cookie(x$0.productElement__I__O(0), x$0.productElement__I__O(1));
});
$c_Lsttp_model_headers_Cookie$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_headers_Cookie(p);
});
var $d_Lsttp_model_headers_Cookie$ = new $TypeData().initClass($c_Lsttp_model_headers_Cookie$, "sttp.model.headers.Cookie$", ({
  Lsttp_model_headers_Cookie$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_headers_Cookie$ as $d_Lsttp_model_headers_Cookie$ };
var $n_Lsttp_model_headers_Cookie$;
function $m_Lsttp_model_headers_Cookie$() {
  if ((!$n_Lsttp_model_headers_Cookie$)) {
    $n_Lsttp_model_headers_Cookie$ = new $c_Lsttp_model_headers_Cookie$();
  }
  return $n_Lsttp_model_headers_Cookie$;
}
export { $m_Lsttp_model_headers_Cookie$ as $m_Lsttp_model_headers_Cookie$ };
/** @constructor */
function $c_Lsttp_model_headers_ETag$() {
  this.Lsttp_model_headers_ETag$__f_sttp$model$headers$ETag$$$WeakPrefix = null;
  this.Lsttp_model_headers_ETag$__f_sttp$model$headers$ETag$$$WeakPrefix = "W/";
}
export { $c_Lsttp_model_headers_ETag$ as $c_Lsttp_model_headers_ETag$ };
$c_Lsttp_model_headers_ETag$.prototype = new $h_O();
$c_Lsttp_model_headers_ETag$.prototype.constructor = $c_Lsttp_model_headers_ETag$;
/** @constructor */
function $h_Lsttp_model_headers_ETag$() {
}
export { $h_Lsttp_model_headers_ETag$ as $h_Lsttp_model_headers_ETag$ };
$h_Lsttp_model_headers_ETag$.prototype = $c_Lsttp_model_headers_ETag$.prototype;
$c_Lsttp_model_headers_ETag$.prototype.parse__T__s_util_Either = (function(s) {
  if ((!(!s.startsWith("W/")))) {
    var _1 = s.substring(2);
    var \u03b41$___1 = _1;
    var \u03b41$___2 = true;
  } else {
    var \u03b41$___1 = s;
    var \u03b41$___2 = false;
  }
  var s2 = \u03b41$___1;
  var weak = (!(!\u03b41$___2));
  if (((!(!(!s2.startsWith("\"")))) || (!(!(!s2.endsWith("\"")))))) {
    return new $c_s_util_Left("ETags must be enclosed in double quotes");
  } else {
    var endIndex = (((-1) + s2.length) | 0);
    var tag = s2.substring(1, endIndex);
    var value = new $c_Lsttp_model_headers_ETag(tag, weak);
    return new $c_s_util_Right(value);
  }
});
$c_Lsttp_model_headers_ETag$.prototype.fromProduct__s_Product__Lsttp_model_headers_ETag = (function(x$0) {
  return new $c_Lsttp_model_headers_ETag(x$0.productElement__I__O(0), (!(!x$0.productElement__I__O(1))));
});
$c_Lsttp_model_headers_ETag$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_headers_ETag(p);
});
var $d_Lsttp_model_headers_ETag$ = new $TypeData().initClass($c_Lsttp_model_headers_ETag$, "sttp.model.headers.ETag$", ({
  Lsttp_model_headers_ETag$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_headers_ETag$ as $d_Lsttp_model_headers_ETag$ };
var $n_Lsttp_model_headers_ETag$;
function $m_Lsttp_model_headers_ETag$() {
  if ((!$n_Lsttp_model_headers_ETag$)) {
    $n_Lsttp_model_headers_ETag$ = new $c_Lsttp_model_headers_ETag$();
  }
  return $n_Lsttp_model_headers_ETag$;
}
export { $m_Lsttp_model_headers_ETag$ as $m_Lsttp_model_headers_ETag$ };
function $p_Lsttp_model_headers_Range$__processString__T__T__s_util_Either($thiz, s, unit) {
  var this$1 = $m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($f_T__split__T__I__AT(s, ",", 0));
  return $p_Lsttp_model_headers_Range$__run$1__T__sci_List__sci_List__s_util_Either($thiz, unit, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$1), $m_sci_Nil$());
}
export { $p_Lsttp_model_headers_Range$__processString__T__T__s_util_Either as $p_Lsttp_model_headers_Range$__processString__T__T__s_util_Either };
function $p_Lsttp_model_headers_Range$__parseSingleRange__T__T__s_util_Either($thiz, rangeString, unit) {
  var this$1 = $f_T__trim__T(rangeString);
  var x38 = $f_T__split__T__I__AT(this$1, "-", 0);
  if ((x38 !== null)) {
    if (($m_s_Array$UnapplySeqWrapper$().lengthCompare$extension__O__I__I(x38, 2) === 0)) {
      var x45 = x38.u[0];
      var x46 = x38.u[1];
      var this$5 = $f_T__trim__T(x45);
      if ((this$5 === "")) {
        var this$6 = $m_Lsttp_model_internal_ParseUtils$().toLongOption__T__s_Option(x46);
        var this$7 = (this$6.isEmpty__Z() ? new $c_s_util_Left(("Invalid end of range: " + x46)) : new $c_s_util_Right(this$6.get__O()));
        if ((this$7 instanceof $c_s_util_Right)) {
          var b = this$7.s_util_Right__f_value;
          var t = $uJ(b);
          var lo = t.RTLong__f_lo;
          var hi = t.RTLong__f_hi;
          var start = $m_s_None$();
          var end = new $c_s_Some(new $c_RTLong(lo, hi));
          return new $c_s_util_Right(new $c_Lsttp_model_headers_Range(start, end, unit));
        } else {
          return this$7;
        }
      }
      var this$10 = $m_Lsttp_model_internal_ParseUtils$().toLongOption__T__s_Option(x45);
      var this$11 = (this$10.isEmpty__Z() ? new $c_s_util_Left(("Invalid start of range: " + x45)) : new $c_s_util_Right(this$10.get__O()));
      if ((this$11 instanceof $c_s_util_Right)) {
        var b$1 = this$11.s_util_Right__f_value;
        var t$1 = $uJ(b$1);
        var lo$1 = t$1.RTLong__f_lo;
        var hi$1 = t$1.RTLong__f_hi;
        var this$12 = $m_Lsttp_model_internal_ParseUtils$().toLongOption__T__s_Option(x46);
        var this$13 = (this$12.isEmpty__Z() ? new $c_s_util_Left(("Invalid end of range: " + x46)) : new $c_s_util_Right(this$12.get__O()));
        if ((this$13 instanceof $c_s_util_Right)) {
          var b$2 = this$13.s_util_Right__f_value;
          var t$2 = $uJ(b$2);
          var lo$2 = t$2.RTLong__f_lo;
          var hi$2 = t$2.RTLong__f_hi;
          var start$1 = new $c_s_Some(new $c_RTLong(lo$1, hi$1));
          var end$1 = new $c_s_Some(new $c_RTLong(lo$2, hi$2));
          return new $c_s_util_Right(new $c_Lsttp_model_headers_Range(start$1, end$1, unit));
        } else {
          return this$13;
        }
      } else {
        return this$11;
      }
    }
    if (($m_s_Array$UnapplySeqWrapper$().lengthCompare$extension__O__I__I(x38, 1) === 0)) {
      var x40 = x38.u[0];
      var this$18 = $m_Lsttp_model_internal_ParseUtils$().toLongOption__T__s_Option(x40);
      var this$19 = (this$18.isEmpty__Z() ? new $c_s_util_Left(("Invalid start of range: " + x40)) : new $c_s_util_Right(this$18.get__O()));
      if ((this$19 instanceof $c_s_util_Right)) {
        var b$3 = this$19.s_util_Right__f_value;
        var t$3 = $uJ(b$3);
        var lo$3 = t$3.RTLong__f_lo;
        var hi$3 = t$3.RTLong__f_hi;
        var start$2 = new $c_s_Some(new $c_RTLong(lo$3, hi$3));
        var end$2 = $m_s_None$();
        return new $c_s_util_Right(new $c_Lsttp_model_headers_Range(start$2, end$2, unit));
      } else {
        return this$19;
      }
    }
  }
  var start$3 = $m_s_None$();
  var end$3 = $m_s_None$();
  var value = new $c_Lsttp_model_headers_Range(start$3, end$3, unit);
  return new $c_s_util_Right(value);
}
export { $p_Lsttp_model_headers_Range$__parseSingleRange__T__T__s_util_Either as $p_Lsttp_model_headers_Range$__parseSingleRange__T__T__s_util_Either };
function $p_Lsttp_model_headers_Range$__validateRange__Lsttp_model_headers_Range__Z($thiz, range) {
  var _1 = range.Lsttp_model_headers_Range__f_start;
  var _2 = range.Lsttp_model_headers_Range__f_end;
  if ((_1 instanceof $c_s_Some)) {
    var t = $uJ(_1.s_Some__f_value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if ((_2 instanceof $c_s_Some)) {
      var t$1 = $uJ(_2.s_Some__f_value);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      return ((hi === hi$1) ? ((lo >>> 0) <= (lo$1 >>> 0)) : (hi < hi$1));
    }
  }
  var x = $m_s_None$();
  if ((x === _1)) {
    var x$3 = $m_s_None$();
    var $x_1 = (x$3 === _2);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return false;
  }
  return true;
}
export { $p_Lsttp_model_headers_Range$__validateRange__Lsttp_model_headers_Range__Z as $p_Lsttp_model_headers_Range$__validateRange__Lsttp_model_headers_Range__Z };
function $p_Lsttp_model_headers_Range$__run$1__T__sci_List__sci_List__s_util_Either($thiz, unit$1, raw, acc) {
  var acc$tailLocal1 = acc;
  var raw$tailLocal1 = raw;
  while (true) {
    var x34 = raw$tailLocal1;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x34)) {
      var value = acc$tailLocal1.reverse__sci_List();
      return new $c_s_util_Right(value);
    }
    if ((x34 instanceof $c_sci_$colon$colon)) {
      var x37 = x34.sci_$colon$colon__f_next;
      var head = x34.sci_$colon$colon__f_head;
      var x29 = $p_Lsttp_model_headers_Range$__parseSingleRange__T__T__s_util_Either($thiz, head, unit$1);
      if ((x29 instanceof $c_s_util_Right)) {
        var r = x29.s_util_Right__f_value;
        var this$2 = acc$tailLocal1;
        var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon(r, this$2);
        raw$tailLocal1 = x37;
        acc$tailLocal1 = acc$tailLocal1$tmp1;
        continue;
      }
      if ((x29 instanceof $c_s_util_Left)) {
        var e = x29.s_util_Left__f_value;
        return new $c_s_util_Left(e);
      }
      throw new $c_s_MatchError(x29);
    }
    throw new $c_s_MatchError(x34);
  }
}
export { $p_Lsttp_model_headers_Range$__run$1__T__sci_List__sci_List__s_util_Either as $p_Lsttp_model_headers_Range$__run$1__T__sci_List__sci_List__s_util_Either };
/** @constructor */
function $c_Lsttp_model_headers_Range$() {
}
export { $c_Lsttp_model_headers_Range$ as $c_Lsttp_model_headers_Range$ };
$c_Lsttp_model_headers_Range$.prototype = new $h_O();
$c_Lsttp_model_headers_Range$.prototype.constructor = $c_Lsttp_model_headers_Range$;
/** @constructor */
function $h_Lsttp_model_headers_Range$() {
}
export { $h_Lsttp_model_headers_Range$ as $h_Lsttp_model_headers_Range$ };
$h_Lsttp_model_headers_Range$.prototype = $c_Lsttp_model_headers_Range$.prototype;
$c_Lsttp_model_headers_Range$.prototype.parse__T__s_util_Either = (function(str) {
  var x25 = $f_T__split__T__I__AT(str, "=", 0);
  if ((x25 !== null)) {
    if (($m_s_Array$UnapplySeqWrapper$().lengthCompare$extension__O__I__I(x25, 2) === 0)) {
      var x27 = x25.u[0];
      var x28 = x25.u[1];
      var this$4 = $p_Lsttp_model_headers_Range$__processString__T__T__s_util_Either(this, x28, x27);
      if ((this$4 instanceof $c_s_util_Right)) {
        var b = this$4.s_util_Right__f_value;
        _return: {
          var these = b;
          while ((!these.isEmpty__Z())) {
            var x0 = these.head__O();
            if ((!$p_Lsttp_model_headers_Range$__validateRange__Lsttp_model_headers_Range__Z($m_Lsttp_model_headers_Range$(), x0))) {
              var $x_1 = false;
              break _return;
            }
            these = these.tail__O();
          }
          var $x_1 = true;
        }
        if (($x_1 && (!b.isEmpty__Z()))) {
          var this$7 = new $c_s_util_Right((void 0));
        } else {
          var this$7 = new $c_s_util_Left("Invalid Range");
        }
        if ((this$7 instanceof $c_s_util_Right)) {
          var $x_2;
          var $x_2 = b;
          return new $c_s_util_Right($x_2);
        } else {
          return this$7;
        }
      } else {
        return this$4;
      }
    }
  }
  var value = $m_sc_StringOps$().format$extension__T__sci_Seq__T("Expected range in the format: \"unit=start/end\", but got: %s", $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([str])));
  return new $c_s_util_Left(value);
});
$c_Lsttp_model_headers_Range$.prototype.fromProduct__s_Product__Lsttp_model_headers_Range = (function(x$0) {
  return new $c_Lsttp_model_headers_Range(x$0.productElement__I__O(0), x$0.productElement__I__O(1), x$0.productElement__I__O(2));
});
$c_Lsttp_model_headers_Range$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_headers_Range(p);
});
var $d_Lsttp_model_headers_Range$ = new $TypeData().initClass($c_Lsttp_model_headers_Range$, "sttp.model.headers.Range$", ({
  Lsttp_model_headers_Range$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_headers_Range$ as $d_Lsttp_model_headers_Range$ };
var $n_Lsttp_model_headers_Range$;
function $m_Lsttp_model_headers_Range$() {
  if ((!$n_Lsttp_model_headers_Range$)) {
    $n_Lsttp_model_headers_Range$ = new $c_Lsttp_model_headers_Range$();
  }
  return $n_Lsttp_model_headers_Range$;
}
export { $m_Lsttp_model_headers_Range$ as $m_Lsttp_model_headers_Range$ };
/** @constructor */
function $c_Lsttp_tapir_AttributeMap$() {
  this.Lsttp_tapir_AttributeMap$__f_Empty = null;
  $n_Lsttp_tapir_AttributeMap$ = this;
  $m_Lsttp_tapir_AttributeMap$();
  var storage = $m_sci_Map$EmptyMap$();
  this.Lsttp_tapir_AttributeMap$__f_Empty = new $c_Lsttp_tapir_AttributeMap(storage);
}
export { $c_Lsttp_tapir_AttributeMap$ as $c_Lsttp_tapir_AttributeMap$ };
$c_Lsttp_tapir_AttributeMap$.prototype = new $h_O();
$c_Lsttp_tapir_AttributeMap$.prototype.constructor = $c_Lsttp_tapir_AttributeMap$;
/** @constructor */
function $h_Lsttp_tapir_AttributeMap$() {
}
export { $h_Lsttp_tapir_AttributeMap$ as $h_Lsttp_tapir_AttributeMap$ };
$h_Lsttp_tapir_AttributeMap$.prototype = $c_Lsttp_tapir_AttributeMap$.prototype;
$c_Lsttp_tapir_AttributeMap$.prototype.fromProduct__s_Product__Lsttp_tapir_AttributeMap = (function(x$0) {
  return new $c_Lsttp_tapir_AttributeMap(x$0.productElement__I__O(0));
});
$c_Lsttp_tapir_AttributeMap$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_AttributeMap(p);
});
var $d_Lsttp_tapir_AttributeMap$ = new $TypeData().initClass($c_Lsttp_tapir_AttributeMap$, "sttp.tapir.AttributeMap$", ({
  Lsttp_tapir_AttributeMap$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_AttributeMap$ as $d_Lsttp_tapir_AttributeMap$ };
var $n_Lsttp_tapir_AttributeMap$;
function $m_Lsttp_tapir_AttributeMap$() {
  if ((!$n_Lsttp_tapir_AttributeMap$)) {
    $n_Lsttp_tapir_AttributeMap$ = new $c_Lsttp_tapir_AttributeMap$();
  }
  return $n_Lsttp_tapir_AttributeMap$;
}
export { $m_Lsttp_tapir_AttributeMap$ as $m_Lsttp_tapir_AttributeMap$ };
/** @constructor */
function $c_Lsttp_tapir_DecodeResult$() {
}
export { $c_Lsttp_tapir_DecodeResult$ as $c_Lsttp_tapir_DecodeResult$ };
$c_Lsttp_tapir_DecodeResult$.prototype = new $h_O();
$c_Lsttp_tapir_DecodeResult$.prototype.constructor = $c_Lsttp_tapir_DecodeResult$;
/** @constructor */
function $h_Lsttp_tapir_DecodeResult$() {
}
export { $h_Lsttp_tapir_DecodeResult$ as $h_Lsttp_tapir_DecodeResult$ };
$h_Lsttp_tapir_DecodeResult$.prototype = $c_Lsttp_tapir_DecodeResult$.prototype;
$c_Lsttp_tapir_DecodeResult$.prototype.sequence__sci_Seq__Lsttp_tapir_DecodeResult = (function(results) {
  var v = $m_sci_Nil$();
  return results.foldRight__O__F2__O(new $c_Lsttp_tapir_DecodeResult$Value(v), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => {
    var x49 = $ct_T2__O__O__(new $c_T2(), x$1, x$2);
    var x58 = x49.T2__f__1;
    var x59 = x49.T2__f__2;
    if ((x58 instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
      var x65 = x58.Lsttp_tapir_DecodeResult$Value__f_v;
      if ((x59 instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
        var x62 = x59.Lsttp_tapir_DecodeResult$Value__f_v;
        var v$1 = x62.prepended__O__O(x65);
        return new $c_Lsttp_tapir_DecodeResult$Value(v$1);
      }
    }
    if ((x58 instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
      return x59;
    }
    if ($is_Lsttp_tapir_DecodeResult$Failure(x58)) {
      return x58;
    }
    throw new $c_s_MatchError(x49);
  })));
});
$c_Lsttp_tapir_DecodeResult$.prototype.fromEitherString__T__s_util_Either__Lsttp_tapir_DecodeResult = (function(original, o) {
  matchResult31: {
    var $x_1;
    if ((o instanceof $c_s_util_Left)) {
      var e = o.s_util_Left__f_value;
      var error = $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), e);
      var $x_1 = new $c_Lsttp_tapir_DecodeResult$Error(original, error);
      break matchResult31;
    }
    if ((o instanceof $c_s_util_Right)) {
      var value = o.s_util_Right__f_value;
      var $x_1 = new $c_Lsttp_tapir_DecodeResult$Value(value);
      break matchResult31;
    }
    throw new $c_s_MatchError(o);
  }
  return $x_1;
});
$c_Lsttp_tapir_DecodeResult$.prototype.ordinal__Lsttp_tapir_DecodeResult__I = (function(x$0) {
  if ($is_Lsttp_tapir_DecodeResult$Failure(x$0)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
    return 1;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lsttp_tapir_DecodeResult$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lsttp_tapir_DecodeResult__I(x);
});
var $d_Lsttp_tapir_DecodeResult$ = new $TypeData().initClass($c_Lsttp_tapir_DecodeResult$, "sttp.tapir.DecodeResult$", ({
  Lsttp_tapir_DecodeResult$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lsttp_tapir_DecodeResult$ as $d_Lsttp_tapir_DecodeResult$ };
var $n_Lsttp_tapir_DecodeResult$;
function $m_Lsttp_tapir_DecodeResult$() {
  if ((!$n_Lsttp_tapir_DecodeResult$)) {
    $n_Lsttp_tapir_DecodeResult$ = new $c_Lsttp_tapir_DecodeResult$();
  }
  return $n_Lsttp_tapir_DecodeResult$;
}
export { $m_Lsttp_tapir_DecodeResult$ as $m_Lsttp_tapir_DecodeResult$ };
/** @constructor */
function $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$() {
}
export { $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$ as $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$ };
$c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$.prototype = new $h_O();
$c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$.prototype.constructor = $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$;
/** @constructor */
function $h_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$() {
}
export { $h_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$ as $h_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$ };
$h_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$.prototype = $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$.prototype;
$c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$.prototype.causeOrNull__sci_List__jl_Throwable = (function(partFailures) {
  var pf = new $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1();
  var this$2 = $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(partFailures, pf);
  return (this$2.isEmpty__Z() ? null : this$2.get__O());
});
$c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$.prototype.fromProduct__s_Product__Lsttp_tapir_DecodeResult$Error$MultipartDecodeException = (function(x$0) {
  return new $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException(x$0.productElement__I__O(0));
});
$c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_DecodeResult$Error$MultipartDecodeException(p);
});
var $d_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$ = new $TypeData().initClass($c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$, "sttp.tapir.DecodeResult$Error$MultipartDecodeException$", ({
  Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$ as $d_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$ };
var $n_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$;
function $m_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$() {
  if ((!$n_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$)) {
    $n_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$ = new $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$();
  }
  return $n_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$;
}
export { $m_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$ as $m_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$ };
/** @constructor */
function $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue$() {
  this.Lsttp_tapir_Schema$EncodedDiscriminatorValue$__f_Attribute = null;
  $n_Lsttp_tapir_Schema$EncodedDiscriminatorValue$ = this;
  this.Lsttp_tapir_Schema$EncodedDiscriminatorValue$__f_Attribute = new $c_Lsttp_tapir_AttributeKey("sttp.tapir.Schema.EncodedDiscriminatorValue");
}
export { $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue$ as $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue$ };
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue$.prototype = new $h_O();
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue$.prototype.constructor = $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue$;
/** @constructor */
function $h_Lsttp_tapir_Schema$EncodedDiscriminatorValue$() {
}
export { $h_Lsttp_tapir_Schema$EncodedDiscriminatorValue$ as $h_Lsttp_tapir_Schema$EncodedDiscriminatorValue$ };
$h_Lsttp_tapir_Schema$EncodedDiscriminatorValue$.prototype = $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue$.prototype;
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue$.prototype.fromProduct__s_Product__Lsttp_tapir_Schema$EncodedDiscriminatorValue = (function(x$0) {
  return new $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue(x$0.productElement__I__O(0));
});
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_Schema$EncodedDiscriminatorValue(p);
});
var $d_Lsttp_tapir_Schema$EncodedDiscriminatorValue$ = new $TypeData().initClass($c_Lsttp_tapir_Schema$EncodedDiscriminatorValue$, "sttp.tapir.Schema$EncodedDiscriminatorValue$", ({
  Lsttp_tapir_Schema$EncodedDiscriminatorValue$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_Schema$EncodedDiscriminatorValue$ as $d_Lsttp_tapir_Schema$EncodedDiscriminatorValue$ };
var $n_Lsttp_tapir_Schema$EncodedDiscriminatorValue$;
function $m_Lsttp_tapir_Schema$EncodedDiscriminatorValue$() {
  if ((!$n_Lsttp_tapir_Schema$EncodedDiscriminatorValue$)) {
    $n_Lsttp_tapir_Schema$EncodedDiscriminatorValue$ = new $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue$();
  }
  return $n_Lsttp_tapir_Schema$EncodedDiscriminatorValue$;
}
export { $m_Lsttp_tapir_Schema$EncodedDiscriminatorValue$ as $m_Lsttp_tapir_Schema$EncodedDiscriminatorValue$ };
/** @constructor */
function $c_Lsttp_tapir_Schema$SName$() {
  $n_Lsttp_tapir_Schema$SName$ = this;
  $m_Lsttp_tapir_Schema$SName$();
  $m_Lsttp_tapir_Schema$SName$();
}
export { $c_Lsttp_tapir_Schema$SName$ as $c_Lsttp_tapir_Schema$SName$ };
$c_Lsttp_tapir_Schema$SName$.prototype = new $h_O();
$c_Lsttp_tapir_Schema$SName$.prototype.constructor = $c_Lsttp_tapir_Schema$SName$;
/** @constructor */
function $h_Lsttp_tapir_Schema$SName$() {
}
export { $h_Lsttp_tapir_Schema$SName$ as $h_Lsttp_tapir_Schema$SName$ };
$h_Lsttp_tapir_Schema$SName$.prototype = $c_Lsttp_tapir_Schema$SName$.prototype;
$c_Lsttp_tapir_Schema$SName$.prototype.fromProduct__s_Product__Lsttp_tapir_Schema$SName = (function(x$0) {
  return new $c_Lsttp_tapir_Schema$SName(x$0.productElement__I__O(0), x$0.productElement__I__O(1));
});
$c_Lsttp_tapir_Schema$SName$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_Schema$SName(p);
});
var $d_Lsttp_tapir_Schema$SName$ = new $TypeData().initClass($c_Lsttp_tapir_Schema$SName$, "sttp.tapir.Schema$SName$", ({
  Lsttp_tapir_Schema$SName$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_Schema$SName$ as $d_Lsttp_tapir_Schema$SName$ };
var $n_Lsttp_tapir_Schema$SName$;
function $m_Lsttp_tapir_Schema$SName$() {
  if ((!$n_Lsttp_tapir_Schema$SName$)) {
    $n_Lsttp_tapir_Schema$SName$ = new $c_Lsttp_tapir_Schema$SName$();
  }
  return $n_Lsttp_tapir_Schema$SName$;
}
export { $m_Lsttp_tapir_Schema$SName$ as $m_Lsttp_tapir_Schema$SName$ };
/** @constructor */
function $c_Lsttp_tapir_Schema$Title$() {
  this.Lsttp_tapir_Schema$Title$__f_Attribute = null;
  $n_Lsttp_tapir_Schema$Title$ = this;
  this.Lsttp_tapir_Schema$Title$__f_Attribute = new $c_Lsttp_tapir_AttributeKey("sttp.tapir.Schema.Title");
}
export { $c_Lsttp_tapir_Schema$Title$ as $c_Lsttp_tapir_Schema$Title$ };
$c_Lsttp_tapir_Schema$Title$.prototype = new $h_O();
$c_Lsttp_tapir_Schema$Title$.prototype.constructor = $c_Lsttp_tapir_Schema$Title$;
/** @constructor */
function $h_Lsttp_tapir_Schema$Title$() {
}
export { $h_Lsttp_tapir_Schema$Title$ as $h_Lsttp_tapir_Schema$Title$ };
$h_Lsttp_tapir_Schema$Title$.prototype = $c_Lsttp_tapir_Schema$Title$.prototype;
$c_Lsttp_tapir_Schema$Title$.prototype.fromProduct__s_Product__Lsttp_tapir_Schema$Title = (function(x$0) {
  return new $c_Lsttp_tapir_Schema$Title(x$0.productElement__I__O(0));
});
$c_Lsttp_tapir_Schema$Title$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_Schema$Title(p);
});
var $d_Lsttp_tapir_Schema$Title$ = new $TypeData().initClass($c_Lsttp_tapir_Schema$Title$, "sttp.tapir.Schema$Title$", ({
  Lsttp_tapir_Schema$Title$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_Schema$Title$ as $d_Lsttp_tapir_Schema$Title$ };
var $n_Lsttp_tapir_Schema$Title$;
function $m_Lsttp_tapir_Schema$Title$() {
  if ((!$n_Lsttp_tapir_Schema$Title$)) {
    $n_Lsttp_tapir_Schema$Title$ = new $c_Lsttp_tapir_Schema$Title$();
  }
  return $n_Lsttp_tapir_Schema$Title$;
}
export { $m_Lsttp_tapir_Schema$Title$ as $m_Lsttp_tapir_Schema$Title$ };
/** @constructor */
function $c_Lsttp_tapir_Schema$Tuple$() {
  this.Lsttp_tapir_Schema$Tuple$__f_Attribute = null;
  $n_Lsttp_tapir_Schema$Tuple$ = this;
  this.Lsttp_tapir_Schema$Tuple$__f_Attribute = new $c_Lsttp_tapir_AttributeKey("sttp.tapir.Schema.Tuple");
}
export { $c_Lsttp_tapir_Schema$Tuple$ as $c_Lsttp_tapir_Schema$Tuple$ };
$c_Lsttp_tapir_Schema$Tuple$.prototype = new $h_O();
$c_Lsttp_tapir_Schema$Tuple$.prototype.constructor = $c_Lsttp_tapir_Schema$Tuple$;
/** @constructor */
function $h_Lsttp_tapir_Schema$Tuple$() {
}
export { $h_Lsttp_tapir_Schema$Tuple$ as $h_Lsttp_tapir_Schema$Tuple$ };
$h_Lsttp_tapir_Schema$Tuple$.prototype = $c_Lsttp_tapir_Schema$Tuple$.prototype;
$c_Lsttp_tapir_Schema$Tuple$.prototype.fromProduct__s_Product__Lsttp_tapir_Schema$Tuple = (function(x$0) {
  return new $c_Lsttp_tapir_Schema$Tuple((!(!x$0.productElement__I__O(0))));
});
$c_Lsttp_tapir_Schema$Tuple$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_Schema$Tuple(p);
});
var $d_Lsttp_tapir_Schema$Tuple$ = new $TypeData().initClass($c_Lsttp_tapir_Schema$Tuple$, "sttp.tapir.Schema$Tuple$", ({
  Lsttp_tapir_Schema$Tuple$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_Schema$Tuple$ as $d_Lsttp_tapir_Schema$Tuple$ };
var $n_Lsttp_tapir_Schema$Tuple$;
function $m_Lsttp_tapir_Schema$Tuple$() {
  if ((!$n_Lsttp_tapir_Schema$Tuple$)) {
    $n_Lsttp_tapir_Schema$Tuple$ = new $c_Lsttp_tapir_Schema$Tuple$();
  }
  return $n_Lsttp_tapir_Schema$Tuple$;
}
export { $m_Lsttp_tapir_Schema$Tuple$ as $m_Lsttp_tapir_Schema$Tuple$ };
/** @constructor */
function $c_Lsttp_tapir_Schema$UniqueItems$() {
  this.Lsttp_tapir_Schema$UniqueItems$__f_Attribute = null;
  $n_Lsttp_tapir_Schema$UniqueItems$ = this;
  this.Lsttp_tapir_Schema$UniqueItems$__f_Attribute = new $c_Lsttp_tapir_AttributeKey("sttp.tapir.Schema.UniqueItems");
}
export { $c_Lsttp_tapir_Schema$UniqueItems$ as $c_Lsttp_tapir_Schema$UniqueItems$ };
$c_Lsttp_tapir_Schema$UniqueItems$.prototype = new $h_O();
$c_Lsttp_tapir_Schema$UniqueItems$.prototype.constructor = $c_Lsttp_tapir_Schema$UniqueItems$;
/** @constructor */
function $h_Lsttp_tapir_Schema$UniqueItems$() {
}
export { $h_Lsttp_tapir_Schema$UniqueItems$ as $h_Lsttp_tapir_Schema$UniqueItems$ };
$h_Lsttp_tapir_Schema$UniqueItems$.prototype = $c_Lsttp_tapir_Schema$UniqueItems$.prototype;
$c_Lsttp_tapir_Schema$UniqueItems$.prototype.fromProduct__s_Product__Lsttp_tapir_Schema$UniqueItems = (function(x$0) {
  return new $c_Lsttp_tapir_Schema$UniqueItems((!(!x$0.productElement__I__O(0))));
});
$c_Lsttp_tapir_Schema$UniqueItems$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_Schema$UniqueItems(p);
});
var $d_Lsttp_tapir_Schema$UniqueItems$ = new $TypeData().initClass($c_Lsttp_tapir_Schema$UniqueItems$, "sttp.tapir.Schema$UniqueItems$", ({
  Lsttp_tapir_Schema$UniqueItems$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_Schema$UniqueItems$ as $d_Lsttp_tapir_Schema$UniqueItems$ };
var $n_Lsttp_tapir_Schema$UniqueItems$;
function $m_Lsttp_tapir_Schema$UniqueItems$() {
  if ((!$n_Lsttp_tapir_Schema$UniqueItems$)) {
    $n_Lsttp_tapir_Schema$UniqueItems$ = new $c_Lsttp_tapir_Schema$UniqueItems$();
  }
  return $n_Lsttp_tapir_Schema$UniqueItems$;
}
export { $m_Lsttp_tapir_Schema$UniqueItems$ as $m_Lsttp_tapir_Schema$UniqueItems$ };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SProductField$$anon$1(_name$1, _schema$1, _get$1) {
  this.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name = null;
  this.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema = null;
  this.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_get = null;
  this.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name = _name$1;
  this.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema = _schema$1;
  this.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_get = _get$1;
}
export { $c_Lsttp_tapir_SchemaType$SProductField$$anon$1 as $c_Lsttp_tapir_SchemaType$SProductField$$anon$1 };
$c_Lsttp_tapir_SchemaType$SProductField$$anon$1.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SProductField$$anon$1.prototype.constructor = $c_Lsttp_tapir_SchemaType$SProductField$$anon$1;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SProductField$$anon$1() {
}
export { $h_Lsttp_tapir_SchemaType$SProductField$$anon$1 as $h_Lsttp_tapir_SchemaType$SProductField$$anon$1 };
$h_Lsttp_tapir_SchemaType$SProductField$$anon$1.prototype = $c_Lsttp_tapir_SchemaType$SProductField$$anon$1.prototype;
$c_Lsttp_tapir_SchemaType$SProductField$$anon$1.prototype.equals__O__Z = (function(other) {
  return $f_Lsttp_tapir_SchemaType$SProductField__equals__O__Z(this, other);
});
$c_Lsttp_tapir_SchemaType$SProductField$$anon$1.prototype.toString__T = (function() {
  return $f_Lsttp_tapir_SchemaType$SProductField__toString__T(this);
});
var $d_Lsttp_tapir_SchemaType$SProductField$$anon$1 = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SProductField$$anon$1, "sttp.tapir.SchemaType$SProductField$$anon$1", ({
  Lsttp_tapir_SchemaType$SProductField$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lsttp_tapir_SchemaType$SProductField: 1
}));
export { $d_Lsttp_tapir_SchemaType$SProductField$$anon$1 as $d_Lsttp_tapir_SchemaType$SProductField$$anon$1 };
/** @constructor */
function $c_Lsttp_tapir_ValidationResult$() {
}
export { $c_Lsttp_tapir_ValidationResult$ as $c_Lsttp_tapir_ValidationResult$ };
$c_Lsttp_tapir_ValidationResult$.prototype = new $h_O();
$c_Lsttp_tapir_ValidationResult$.prototype.constructor = $c_Lsttp_tapir_ValidationResult$;
/** @constructor */
function $h_Lsttp_tapir_ValidationResult$() {
}
export { $h_Lsttp_tapir_ValidationResult$ as $h_Lsttp_tapir_ValidationResult$ };
$h_Lsttp_tapir_ValidationResult$.prototype = $c_Lsttp_tapir_ValidationResult$.prototype;
$c_Lsttp_tapir_ValidationResult$.prototype.validWhen__Z__Lsttp_tapir_ValidationResult = (function(condition) {
  if (condition) {
    var $x_1 = $m_Lsttp_tapir_ValidationResult$Valid$();
  } else {
    var customMessage = $m_sci_Nil$();
    var $x_1 = new $c_Lsttp_tapir_ValidationResult$Invalid(customMessage);
  }
  return $x_1;
});
$c_Lsttp_tapir_ValidationResult$.prototype.ordinal__Lsttp_tapir_ValidationResult__I = (function(x$0) {
  if ((x$0 === $m_Lsttp_tapir_ValidationResult$Valid$())) {
    return 0;
  }
  if ((x$0 instanceof $c_Lsttp_tapir_ValidationResult$Invalid)) {
    return 1;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lsttp_tapir_ValidationResult$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lsttp_tapir_ValidationResult__I(x);
});
var $d_Lsttp_tapir_ValidationResult$ = new $TypeData().initClass($c_Lsttp_tapir_ValidationResult$, "sttp.tapir.ValidationResult$", ({
  Lsttp_tapir_ValidationResult$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lsttp_tapir_ValidationResult$ as $d_Lsttp_tapir_ValidationResult$ };
var $n_Lsttp_tapir_ValidationResult$;
function $m_Lsttp_tapir_ValidationResult$() {
  if ((!$n_Lsttp_tapir_ValidationResult$)) {
    $n_Lsttp_tapir_ValidationResult$ = new $c_Lsttp_tapir_ValidationResult$();
  }
  return $n_Lsttp_tapir_ValidationResult$;
}
export { $m_Lsttp_tapir_ValidationResult$ as $m_Lsttp_tapir_ValidationResult$ };
/** @constructor */
function $c_Lsttp_tapir_ValidationResult$Invalid$() {
}
export { $c_Lsttp_tapir_ValidationResult$Invalid$ as $c_Lsttp_tapir_ValidationResult$Invalid$ };
$c_Lsttp_tapir_ValidationResult$Invalid$.prototype = new $h_O();
$c_Lsttp_tapir_ValidationResult$Invalid$.prototype.constructor = $c_Lsttp_tapir_ValidationResult$Invalid$;
/** @constructor */
function $h_Lsttp_tapir_ValidationResult$Invalid$() {
}
export { $h_Lsttp_tapir_ValidationResult$Invalid$ as $h_Lsttp_tapir_ValidationResult$Invalid$ };
$h_Lsttp_tapir_ValidationResult$Invalid$.prototype = $c_Lsttp_tapir_ValidationResult$Invalid$.prototype;
$c_Lsttp_tapir_ValidationResult$Invalid$.prototype.apply__T__Lsttp_tapir_ValidationResult$Invalid = (function(customMessage) {
  var customMessage$1 = new $c_sci_$colon$colon(customMessage, $m_sci_Nil$());
  return new $c_Lsttp_tapir_ValidationResult$Invalid(customMessage$1);
});
$c_Lsttp_tapir_ValidationResult$Invalid$.prototype.fromProduct__s_Product__Lsttp_tapir_ValidationResult$Invalid = (function(x$0) {
  return new $c_Lsttp_tapir_ValidationResult$Invalid(x$0.productElement__I__O(0));
});
$c_Lsttp_tapir_ValidationResult$Invalid$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_ValidationResult$Invalid(p);
});
var $d_Lsttp_tapir_ValidationResult$Invalid$ = new $TypeData().initClass($c_Lsttp_tapir_ValidationResult$Invalid$, "sttp.tapir.ValidationResult$Invalid$", ({
  Lsttp_tapir_ValidationResult$Invalid$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_ValidationResult$Invalid$ as $d_Lsttp_tapir_ValidationResult$Invalid$ };
var $n_Lsttp_tapir_ValidationResult$Invalid$;
function $m_Lsttp_tapir_ValidationResult$Invalid$() {
  if ((!$n_Lsttp_tapir_ValidationResult$Invalid$)) {
    $n_Lsttp_tapir_ValidationResult$Invalid$ = new $c_Lsttp_tapir_ValidationResult$Invalid$();
  }
  return $n_Lsttp_tapir_ValidationResult$Invalid$;
}
export { $m_Lsttp_tapir_ValidationResult$Invalid$ as $m_Lsttp_tapir_ValidationResult$Invalid$ };
/** @constructor */
function $c_Lsttp_tapir_Validator$Any$() {
  this.Lsttp_tapir_Validator$Any$__f__primitiveRejectValidator = null;
  $n_Lsttp_tapir_Validator$Any$ = this;
  var validationLogic = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$10) => $m_Lsttp_tapir_ValidationResult$Invalid$().apply__T__Lsttp_tapir_ValidationResult$Invalid("Validation rejected")));
  var showMessage = $m_s_None$();
  this.Lsttp_tapir_Validator$Any$__f__primitiveRejectValidator = new $c_Lsttp_tapir_Validator$Custom(validationLogic, showMessage);
}
export { $c_Lsttp_tapir_Validator$Any$ as $c_Lsttp_tapir_Validator$Any$ };
$c_Lsttp_tapir_Validator$Any$.prototype = new $h_O();
$c_Lsttp_tapir_Validator$Any$.prototype.constructor = $c_Lsttp_tapir_Validator$Any$;
/** @constructor */
function $h_Lsttp_tapir_Validator$Any$() {
}
export { $h_Lsttp_tapir_Validator$Any$ as $h_Lsttp_tapir_Validator$Any$ };
$h_Lsttp_tapir_Validator$Any$.prototype = $c_Lsttp_tapir_Validator$Any$.prototype;
$c_Lsttp_tapir_Validator$Any$.prototype.fromProduct__s_Product__Lsttp_tapir_Validator$Any = (function(x$0) {
  return new $c_Lsttp_tapir_Validator$Any(x$0.productElement__I__O(0));
});
$c_Lsttp_tapir_Validator$Any$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_Validator$Any(p);
});
var $d_Lsttp_tapir_Validator$Any$ = new $TypeData().initClass($c_Lsttp_tapir_Validator$Any$, "sttp.tapir.Validator$Any$", ({
  Lsttp_tapir_Validator$Any$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_Validator$Any$ as $d_Lsttp_tapir_Validator$Any$ };
var $n_Lsttp_tapir_Validator$Any$;
function $m_Lsttp_tapir_Validator$Any$() {
  if ((!$n_Lsttp_tapir_Validator$Any$)) {
    $n_Lsttp_tapir_Validator$Any$ = new $c_Lsttp_tapir_Validator$Any$();
  }
  return $n_Lsttp_tapir_Validator$Any$;
}
export { $m_Lsttp_tapir_Validator$Any$ as $m_Lsttp_tapir_Validator$Any$ };
/** @constructor */
function $c_Lsttp_tapir_generic_Configuration$() {
  this.Lsttp_tapir_generic_Configuration$__f_basePattern = null;
  this.Lsttp_tapir_generic_Configuration$__f_swapPattern = null;
  this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$snakeCaseTransformation = null;
  this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$screamingSnakeCaseTransformation = null;
  this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$kebabCaseTransformation = null;
  this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$fullIdentitySubtypeTransformation = null;
  this.Lsttp_tapir_generic_Configuration$__f_default = null;
  $n_Lsttp_tapir_generic_Configuration$ = this;
  this.Lsttp_tapir_generic_Configuration$__f_basePattern = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("([A-Z]+)([A-Z][a-z])", 0);
  this.Lsttp_tapir_generic_Configuration$__f_swapPattern = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern("([a-z\\d])([A-Z])", 0);
  this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$snakeCaseTransformation = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    var this$4 = this.Lsttp_tapir_generic_Configuration$__f_basePattern;
    var partial = new $c_ju_regex_Matcher(this$4, s).replaceAll__T__T("$1_$2");
    var this$5 = this.Lsttp_tapir_generic_Configuration$__f_swapPattern;
    var this$6 = new $c_ju_regex_Matcher(this$5, partial).replaceAll__T__T("$1_$2");
    return this$6.toLowerCase();
  }));
  this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$screamingSnakeCaseTransformation = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$2) => {
    var this$7 = this.Lsttp_tapir_generic_Configuration$__f_basePattern;
    var partial$1 = new $c_ju_regex_Matcher(this$7, s$2).replaceAll__T__T("$1_$2");
    var this$8 = this.Lsttp_tapir_generic_Configuration$__f_swapPattern;
    var this$9 = new $c_ju_regex_Matcher(this$8, partial$1).replaceAll__T__T("$1_$2");
    return this$9.toUpperCase();
  }));
  this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$kebabCaseTransformation = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$3) => {
    var this$10 = this.Lsttp_tapir_generic_Configuration$__f_basePattern;
    var partial$2 = new $c_ju_regex_Matcher(this$10, s$3).replaceAll__T__T("$1-$2");
    var this$11 = this.Lsttp_tapir_generic_Configuration$__f_swapPattern;
    var this$12 = new $c_ju_regex_Matcher(this$11, partial$2).replaceAll__T__T("$1-$2");
    return this$12.toLowerCase();
  }));
  this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$fullIdentitySubtypeTransformation = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    var $x_1 = $m_sc_StringOps$();
    var x = _$1.Lsttp_tapir_Schema$SName__f_fullName;
    return $x_1.stripSuffix$extension__T__T__T(x, "$");
  }));
  this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$fullIdentitySubtypeTransformation.andThen__F1__F1(this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$snakeCaseTransformation);
  this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$fullIdentitySubtypeTransformation.andThen__F1__F1(this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$kebabCaseTransformation);
  var shortIdentitySubtypeTransformation = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    var $x_3 = $m_sc_StringOps$();
    var $x_2 = $m_sc_StringOps$();
    var x$1 = _$2.Lsttp_tapir_Schema$SName__f_fullName;
    var xs = $x_2.split$extension__T__C__AT(x$1, 46);
    var x$2 = $m_sc_ArrayOps$().last$extension__O__O(xs);
    return $x_3.stripSuffix$extension__T__T__T(x$2, "$");
  }));
  var g = this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$snakeCaseTransformation;
  $f_F1__andThen__F1__F1(shortIdentitySubtypeTransformation, g);
  var g$1 = this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$screamingSnakeCaseTransformation;
  $f_F1__andThen__F1__F1(shortIdentitySubtypeTransformation, g$1);
  var g$2 = this.Lsttp_tapir_generic_Configuration$__f_sttp$tapir$generic$Configuration$$$kebabCaseTransformation;
  $f_F1__andThen__F1__F1(shortIdentitySubtypeTransformation, g$2);
  $m_Lsttp_tapir_generic_Configuration$();
  var toEncodedName = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$3) => x$3));
  var discriminator = $m_s_None$();
  this.Lsttp_tapir_generic_Configuration$__f_default = new $c_Lsttp_tapir_generic_Configuration(toEncodedName, discriminator, shortIdentitySubtypeTransformation);
}
export { $c_Lsttp_tapir_generic_Configuration$ as $c_Lsttp_tapir_generic_Configuration$ };
$c_Lsttp_tapir_generic_Configuration$.prototype = new $h_O();
$c_Lsttp_tapir_generic_Configuration$.prototype.constructor = $c_Lsttp_tapir_generic_Configuration$;
/** @constructor */
function $h_Lsttp_tapir_generic_Configuration$() {
}
export { $h_Lsttp_tapir_generic_Configuration$ as $h_Lsttp_tapir_generic_Configuration$ };
$h_Lsttp_tapir_generic_Configuration$.prototype = $c_Lsttp_tapir_generic_Configuration$.prototype;
$c_Lsttp_tapir_generic_Configuration$.prototype.fromProduct__s_Product__Lsttp_tapir_generic_Configuration = (function(x$0) {
  return new $c_Lsttp_tapir_generic_Configuration(x$0.productElement__I__O(0), x$0.productElement__I__O(1), x$0.productElement__I__O(2));
});
$c_Lsttp_tapir_generic_Configuration$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_generic_Configuration(p);
});
var $d_Lsttp_tapir_generic_Configuration$ = new $TypeData().initClass($c_Lsttp_tapir_generic_Configuration$, "sttp.tapir.generic.Configuration$", ({
  Lsttp_tapir_generic_Configuration$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_generic_Configuration$ as $d_Lsttp_tapir_generic_Configuration$ };
var $n_Lsttp_tapir_generic_Configuration$;
function $m_Lsttp_tapir_generic_Configuration$() {
  if ((!$n_Lsttp_tapir_generic_Configuration$)) {
    $n_Lsttp_tapir_generic_Configuration$ = new $c_Lsttp_tapir_generic_Configuration$();
  }
  return $n_Lsttp_tapir_generic_Configuration$;
}
export { $m_Lsttp_tapir_generic_Configuration$ as $m_Lsttp_tapir_generic_Configuration$ };
/** @constructor */
function $c_Lurldsl_errors_DummyError$() {
  this.Lurldsl_errors_DummyError$__f_dummyErrorIsParamMatchingError$lzy1 = null;
  this.Lurldsl_errors_DummyError$__f_dummyErrorIsParamMatchingErrorbitmap$1 = false;
  this.Lurldsl_errors_DummyError$__f_dummyErrorIsPathMatchingError$lzy1 = null;
  this.Lurldsl_errors_DummyError$__f_dummyErrorIsPathMatchingErrorbitmap$1 = false;
  this.Lurldsl_errors_DummyError$__f_dummyErrorIsFragmentMatchingError$lzy1 = null;
  this.Lurldsl_errors_DummyError$__f_dummyErrorIsFragmentMatchingErrorbitmap$1 = false;
  this.Lurldsl_errors_DummyError$__f_dummyErrorIsFromThrowable$lzy1 = null;
  this.Lurldsl_errors_DummyError$__f_dummyErrorIsFromThrowablebitmap$1 = false;
}
export { $c_Lurldsl_errors_DummyError$ as $c_Lurldsl_errors_DummyError$ };
$c_Lurldsl_errors_DummyError$.prototype = new $h_O();
$c_Lurldsl_errors_DummyError$.prototype.constructor = $c_Lurldsl_errors_DummyError$;
/** @constructor */
function $h_Lurldsl_errors_DummyError$() {
}
export { $h_Lurldsl_errors_DummyError$ as $h_Lurldsl_errors_DummyError$ };
$h_Lurldsl_errors_DummyError$.prototype = $c_Lurldsl_errors_DummyError$.prototype;
$c_Lurldsl_errors_DummyError$.prototype.dummyErrorIsParamMatchingError__Lurldsl_errors_ParamMatchingError = (function() {
  if ((!this.Lurldsl_errors_DummyError$__f_dummyErrorIsParamMatchingErrorbitmap$1)) {
    this.Lurldsl_errors_DummyError$__f_dummyErrorIsParamMatchingError$lzy1 = new $c_Lurldsl_errors_DummyError$$anon$1(this);
    this.Lurldsl_errors_DummyError$__f_dummyErrorIsParamMatchingErrorbitmap$1 = true;
  }
  return this.Lurldsl_errors_DummyError$__f_dummyErrorIsParamMatchingError$lzy1;
});
$c_Lurldsl_errors_DummyError$.prototype.dummyErrorIsPathMatchingError__Lurldsl_errors_PathMatchingError = (function() {
  if ((!this.Lurldsl_errors_DummyError$__f_dummyErrorIsPathMatchingErrorbitmap$1)) {
    this.Lurldsl_errors_DummyError$__f_dummyErrorIsPathMatchingError$lzy1 = new $c_Lurldsl_errors_DummyError$$anon$2(this);
    this.Lurldsl_errors_DummyError$__f_dummyErrorIsPathMatchingErrorbitmap$1 = true;
  }
  return this.Lurldsl_errors_DummyError$__f_dummyErrorIsPathMatchingError$lzy1;
});
$c_Lurldsl_errors_DummyError$.prototype.dummyErrorIsFragmentMatchingError__Lurldsl_errors_FragmentMatchingError = (function() {
  if ((!this.Lurldsl_errors_DummyError$__f_dummyErrorIsFragmentMatchingErrorbitmap$1)) {
    this.Lurldsl_errors_DummyError$__f_dummyErrorIsFragmentMatchingError$lzy1 = new $c_Lurldsl_errors_DummyError$$anon$3(this);
    this.Lurldsl_errors_DummyError$__f_dummyErrorIsFragmentMatchingErrorbitmap$1 = true;
  }
  return this.Lurldsl_errors_DummyError$__f_dummyErrorIsFragmentMatchingError$lzy1;
});
$c_Lurldsl_errors_DummyError$.prototype.dummyErrorIsFromThrowable__Lurldsl_errors_ErrorFromThrowable = (function() {
  if ((!this.Lurldsl_errors_DummyError$__f_dummyErrorIsFromThrowablebitmap$1)) {
    this.Lurldsl_errors_DummyError$__f_dummyErrorIsFromThrowable$lzy1 = new $c_Lurldsl_errors_DummyError$$anon$4(this);
    this.Lurldsl_errors_DummyError$__f_dummyErrorIsFromThrowablebitmap$1 = true;
  }
  return this.Lurldsl_errors_DummyError$__f_dummyErrorIsFromThrowable$lzy1;
});
$c_Lurldsl_errors_DummyError$.prototype.ordinal__Lurldsl_errors_DummyError__I = (function(x$0) {
  if ((x$0 === $m_Lurldsl_errors_DummyError$dummyError$())) {
    return 0;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lurldsl_errors_DummyError$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lurldsl_errors_DummyError__I(x);
});
var $d_Lurldsl_errors_DummyError$ = new $TypeData().initClass($c_Lurldsl_errors_DummyError$, "urldsl.errors.DummyError$", ({
  Lurldsl_errors_DummyError$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lurldsl_errors_DummyError$ as $d_Lurldsl_errors_DummyError$ };
var $n_Lurldsl_errors_DummyError$;
function $m_Lurldsl_errors_DummyError$() {
  if ((!$n_Lurldsl_errors_DummyError$)) {
    $n_Lurldsl_errors_DummyError$ = new $c_Lurldsl_errors_DummyError$();
  }
  return $n_Lurldsl_errors_DummyError$;
}
export { $m_Lurldsl_errors_DummyError$ as $m_Lurldsl_errors_DummyError$ };
/** @constructor */
function $c_Lyantl_INewtype$defaultMake$(outer) {
  this.Lyantl_INewtype$defaultMake$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lyantl_INewtype$defaultMake$__f_$outer = outer;
}
export { $c_Lyantl_INewtype$defaultMake$ as $c_Lyantl_INewtype$defaultMake$ };
$c_Lyantl_INewtype$defaultMake$.prototype = new $h_O();
$c_Lyantl_INewtype$defaultMake$.prototype.constructor = $c_Lyantl_INewtype$defaultMake$;
/** @constructor */
function $h_Lyantl_INewtype$defaultMake$() {
}
export { $h_Lyantl_INewtype$defaultMake$ as $h_Lyantl_INewtype$defaultMake$ };
$h_Lyantl_INewtype$defaultMake$.prototype = $c_Lyantl_INewtype$defaultMake$.prototype;
$c_Lyantl_INewtype$defaultMake$.prototype.validate__O__sci_Vector = (function(input) {
  return $f_Lyantl_Make__validate__O__sci_Vector(this, input);
});
$c_Lyantl_INewtype$defaultMake$.prototype.apply__O__s_util_Either = (function(input) {
  var errors = this.Lyantl_INewtype$defaultMake$__f_$outer.validate__Lyantl_Validate().validate__O__sci_Vector(input);
  if ($f_sc_SeqOps__isEmpty__Z(errors)) {
    var value = this.Lyantl_INewtype$defaultMake$__f_$outer.wrap__O__O(input);
    return new $c_s_util_Right(value);
  } else {
    return new $c_s_util_Left(errors);
  }
});
var $d_Lyantl_INewtype$defaultMake$ = new $TypeData().initClass($c_Lyantl_INewtype$defaultMake$, "yantl.INewtype$defaultMake$", ({
  Lyantl_INewtype$defaultMake$: 1,
  Lyantl_Validate: 1,
  Lyantl_Make: 1
}));
export { $d_Lyantl_INewtype$defaultMake$ as $d_Lyantl_INewtype$defaultMake$ };
/** @constructor */
function $c_Lyantl_INewtype$make$(outer) {
  this.Lyantl_INewtype$make$__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lyantl_INewtype$make$__f_$outer = outer;
}
export { $c_Lyantl_INewtype$make$ as $c_Lyantl_INewtype$make$ };
$c_Lyantl_INewtype$make$.prototype = new $h_O();
$c_Lyantl_INewtype$make$.prototype.constructor = $c_Lyantl_INewtype$make$;
/** @constructor */
function $h_Lyantl_INewtype$make$() {
}
export { $h_Lyantl_INewtype$make$ as $h_Lyantl_INewtype$make$ };
$h_Lyantl_INewtype$make$.prototype = $c_Lyantl_INewtype$make$.prototype;
$c_Lyantl_INewtype$make$.prototype.validate__O__sci_Vector = (function(input) {
  return $f_Lyantl_Make__validate__O__sci_Vector(this, input);
});
$c_Lyantl_INewtype$make$.prototype.apply__O__s_util_Either = (function(input) {
  return this.Lyantl_INewtype$make$__f_$outer.resolveMake__Lyantl_Make().apply__O__s_util_Either(input);
});
var $d_Lyantl_INewtype$make$ = new $TypeData().initClass($c_Lyantl_INewtype$make$, "yantl.INewtype$make$", ({
  Lyantl_INewtype$make$: 1,
  Lyantl_Validate: 1,
  Lyantl_Make: 1
}));
export { $d_Lyantl_INewtype$make$ as $d_Lyantl_INewtype$make$ };
/** @constructor */
function $c_Lyantl_Validator$$anon$6(rules$3) {
  this.Lyantl_Validator$$anon$6__f_rules$2 = null;
  this.Lyantl_Validator$$anon$6__f_rules$lzy1 = null;
  this.Lyantl_Validator$$anon$6__f_rulesbitmap$1 = false;
  this.Lyantl_Validator$$anon$6__f_rules$2 = rules$3;
}
export { $c_Lyantl_Validator$$anon$6 as $c_Lyantl_Validator$$anon$6 };
$c_Lyantl_Validator$$anon$6.prototype = new $h_O();
$c_Lyantl_Validator$$anon$6.prototype.constructor = $c_Lyantl_Validator$$anon$6;
/** @constructor */
function $h_Lyantl_Validator$$anon$6() {
}
export { $h_Lyantl_Validator$$anon$6 as $h_Lyantl_Validator$$anon$6 };
$h_Lyantl_Validator$$anon$6.prototype = $c_Lyantl_Validator$$anon$6.prototype;
$c_Lyantl_Validator$$anon$6.prototype.validate__O__sci_Vector = (function(input) {
  return $f_Lyantl_Validator__validate__O__sci_Vector(this, input);
});
$c_Lyantl_Validator$$anon$6.prototype.rules__ALyantl_ValidatorRule = (function() {
  if ((!this.Lyantl_Validator$$anon$6__f_rulesbitmap$1)) {
    this.Lyantl_Validator$$anon$6__f_rules$lzy1 = $m_Lyantl_Validator$().yantl$Validator$$$_$rules_$2__F0__ALyantl_ValidatorRule(this.Lyantl_Validator$$anon$6__f_rules$2);
    this.Lyantl_Validator$$anon$6__f_rulesbitmap$1 = true;
  }
  return this.Lyantl_Validator$$anon$6__f_rules$lzy1;
});
var $d_Lyantl_Validator$$anon$6 = new $TypeData().initClass($c_Lyantl_Validator$$anon$6, "yantl.Validator$$anon$6", ({
  Lyantl_Validator$$anon$6: 1,
  Lyantl_Validate: 1,
  Lyantl_Validator: 1
}));
export { $d_Lyantl_Validator$$anon$6 as $d_Lyantl_Validator$$anon$6 };
/** @constructor */
function $c_Lyantl_Validator$$anon$7(rules_$1) {
  this.Lyantl_Validator$$anon$7__f_rules = null;
  this.Lyantl_Validator$$anon$7__f_rules = rules_$1;
}
export { $c_Lyantl_Validator$$anon$7 as $c_Lyantl_Validator$$anon$7 };
$c_Lyantl_Validator$$anon$7.prototype = new $h_O();
$c_Lyantl_Validator$$anon$7.prototype.constructor = $c_Lyantl_Validator$$anon$7;
/** @constructor */
function $h_Lyantl_Validator$$anon$7() {
}
export { $h_Lyantl_Validator$$anon$7 as $h_Lyantl_Validator$$anon$7 };
$h_Lyantl_Validator$$anon$7.prototype = $c_Lyantl_Validator$$anon$7.prototype;
$c_Lyantl_Validator$$anon$7.prototype.validate__O__sci_Vector = (function(input) {
  return $f_Lyantl_Validator__validate__O__sci_Vector(this, input);
});
$c_Lyantl_Validator$$anon$7.prototype.rules__ALyantl_ValidatorRule = (function() {
  return this.Lyantl_Validator$$anon$7__f_rules;
});
var $d_Lyantl_Validator$$anon$7 = new $TypeData().initClass($c_Lyantl_Validator$$anon$7, "yantl.Validator$$anon$7", ({
  Lyantl_Validator$$anon$7: 1,
  Lyantl_Validate: 1,
  Lyantl_Validator: 1
}));
export { $d_Lyantl_Validator$$anon$7 as $d_Lyantl_Validator$$anon$7 };
/** @constructor */
function $c_Lcats_Always(f) {
  this.Lcats_Always__f_f = null;
  this.Lcats_Always__f_f = f;
}
export { $c_Lcats_Always as $c_Lcats_Always };
$c_Lcats_Always.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Always.prototype.constructor = $c_Lcats_Always;
/** @constructor */
function $h_Lcats_Always() {
}
export { $h_Lcats_Always as $h_Lcats_Always };
$h_Lcats_Always.prototype = $c_Lcats_Always.prototype;
$c_Lcats_Always.prototype.value__O = (function() {
  return this.Lcats_Always__f_f.apply__O();
});
var $d_Lcats_Always = new $TypeData().initClass($c_Lcats_Always, "cats.Always", ({
  Lcats_Always: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_Always as $d_Lcats_Always };
function $p_Lcats_Eval$__addToMemo$1__Lcats_Eval$Memoize__F1($thiz, m) {
  return new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
    m.Lcats_Eval$Memoize__f_result = new $c_s_Some(a);
    return new $c_Lcats_Now(a);
  }));
}
export { $p_Lcats_Eval$__addToMemo$1__Lcats_Eval$Memoize__F1 as $p_Lcats_Eval$__addToMemo$1__Lcats_Eval$Memoize__F1 };
function $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O($thiz, curr, fs) {
  var fs$tailLocal1 = fs;
  var curr$tailLocal1 = curr;
  while (true) {
    var x52 = curr$tailLocal1;
    if ((x52 instanceof $c_Lcats_Eval$FlatMap)) {
      var x26 = x52.start__F0().apply__O();
      if ((x26 instanceof $c_Lcats_Eval$FlatMap)) {
        var first = x52.run__F1();
        var rest = fs$tailLocal1;
        var nextFs = new $c_Lcats_Eval$Many(first, rest);
        var curr$tailLocal1$tmp1 = x26.start__F0().apply__O();
        var first$1 = x26.run__F1();
        var fs$tailLocal1$tmp1 = new $c_Lcats_Eval$Many(first$1, nextFs);
        curr$tailLocal1 = curr$tailLocal1$tmp1;
        fs$tailLocal1 = fs$tailLocal1$tmp1;
        continue;
      }
      if ((x26 instanceof $c_Lcats_Eval$Defer)) {
        var curr$tailLocal1$tmp2 = x26.Lcats_Eval$Defer__f_thunk.apply__O();
        var first$2 = x52.run__F1();
        var rest$1 = fs$tailLocal1;
        var fs$tailLocal1$tmp2 = new $c_Lcats_Eval$Many(first$2, rest$1);
        curr$tailLocal1 = curr$tailLocal1$tmp2;
        fs$tailLocal1 = fs$tailLocal1$tmp2;
        continue;
      }
      if (false) {
        var x30 = x26.Lcats_Eval$Memoize__f_eval;
        var x23 = x26.Lcats_Eval$Memoize__f_result;
        if ((x23 instanceof $c_s_Some)) {
          var a = x23.s_Some__f_value;
          curr$tailLocal1 = x52.run__F1().apply__O__O(a);
          continue;
        }
        var x = $m_s_None$();
        if ((x === x23)) {
          var first$3 = x52.run__F1();
          var rest$2 = fs$tailLocal1;
          var nextFs$2 = new $c_Lcats_Eval$Many(first$3, rest$2);
          var first$4 = $p_Lcats_Eval$__addToMemo$1__Lcats_Eval$Memoize__F1($thiz, x26);
          var fs$tailLocal1$tmp3 = new $c_Lcats_Eval$Many(first$4, nextFs$2);
          curr$tailLocal1 = x30;
          fs$tailLocal1 = fs$tailLocal1$tmp3;
          continue;
        }
        throw new $c_s_MatchError(x23);
      }
      if ((x26 instanceof $c_Lcats_Eval$Leaf)) {
        curr$tailLocal1 = x52.run__F1().apply__O__O(x26.value__O());
        continue;
      }
      throw new $c_s_MatchError(x26);
    }
    if ((x52 instanceof $c_Lcats_Eval$Defer)) {
      curr$tailLocal1 = x52.Lcats_Eval$Defer__f_thunk.apply__O();
      continue;
    }
    if (false) {
      var x41 = x52.Lcats_Eval$Memoize__f_result;
      if ((x41 instanceof $c_s_Some)) {
        var a$2 = x41.s_Some__f_value;
        var x33 = fs$tailLocal1;
        if ((x33 instanceof $c_Lcats_Eval$Many)) {
          var x39 = x33.Lcats_Eval$Many__f_first;
          var x40 = x33.Lcats_Eval$Many__f_rest;
          var curr$tailLocal1$tmp4 = x39.apply__O__O(a$2);
          curr$tailLocal1 = curr$tailLocal1$tmp4;
          fs$tailLocal1 = x40;
          continue;
        }
        if ((x33 instanceof $c_Lcats_Eval$Ident)) {
          return a$2;
        }
        throw new $c_s_MatchError(x33);
      }
      var x$3 = $m_s_None$();
      if ((x$3 === x41)) {
        var curr$tailLocal1$tmp5 = x52.Lcats_Eval$Memoize__f_eval;
        var first$5 = $p_Lcats_Eval$__addToMemo$1__Lcats_Eval$Memoize__F1($thiz, x52);
        var rest$3 = fs$tailLocal1;
        var fs$tailLocal1$tmp5 = new $c_Lcats_Eval$Many(first$5, rest$3);
        curr$tailLocal1 = curr$tailLocal1$tmp5;
        fs$tailLocal1 = fs$tailLocal1$tmp5;
        continue;
      }
      throw new $c_s_MatchError(x41);
    }
    if ((x52 instanceof $c_Lcats_Eval$Leaf)) {
      var a1 = x52.value__O();
      var x44 = fs$tailLocal1;
      if ((x44 instanceof $c_Lcats_Eval$Many)) {
        var x50 = x44.Lcats_Eval$Many__f_first;
        var x51 = x44.Lcats_Eval$Many__f_rest;
        var curr$tailLocal1$tmp6 = x50.apply__O__O(a1);
        curr$tailLocal1 = curr$tailLocal1$tmp6;
        fs$tailLocal1 = x51;
        continue;
      }
      if ((x44 instanceof $c_Lcats_Eval$Ident)) {
        return a1;
      }
      throw new $c_s_MatchError(x44);
    }
    throw new $c_s_MatchError(x52);
  }
}
export { $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O as $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O };
/** @constructor */
function $c_Lcats_Eval$() {
  this.Lcats_EvalInstances__f_catsBimonadForEval = null;
  this.Lcats_Eval$__f_Unit = null;
  this.Lcats_Eval$__f_True = null;
  this.Lcats_Eval$__f_False = null;
  $ct_Lcats_EvalInstances__(this);
  $n_Lcats_Eval$ = this;
  this.Lcats_Eval$__f_Unit = new $c_Lcats_Now((void 0));
  this.Lcats_Eval$__f_True = new $c_Lcats_Now(true);
  this.Lcats_Eval$__f_False = new $c_Lcats_Now(false);
}
export { $c_Lcats_Eval$ as $c_Lcats_Eval$ };
$c_Lcats_Eval$.prototype = new $h_Lcats_EvalInstances();
$c_Lcats_Eval$.prototype.constructor = $c_Lcats_Eval$;
/** @constructor */
function $h_Lcats_Eval$() {
}
export { $h_Lcats_Eval$ as $h_Lcats_Eval$ };
$h_Lcats_Eval$.prototype = $c_Lcats_Eval$.prototype;
$c_Lcats_Eval$.prototype.cats$Eval$$$evaluate__Lcats_Eval__O = (function(e) {
  var this$1 = $m_s_$less$colon$less$();
  var e$1 = this$1.s_$less$colon$less$__f_singleton;
  return $p_Lcats_Eval$__loop$1__Lcats_Eval__Lcats_Eval$FnStack__O(this, e, new $c_Lcats_Eval$Ident(e$1));
});
var $d_Lcats_Eval$ = new $TypeData().initClass($c_Lcats_Eval$, "cats.Eval$", ({
  Lcats_Eval$: 1,
  Lcats_EvalInstances: 1,
  Lcats_EvalInstances0: 1,
  Lcats_EvalInstances1: 1
}));
export { $d_Lcats_Eval$ as $d_Lcats_Eval$ };
var $n_Lcats_Eval$;
function $m_Lcats_Eval$() {
  if ((!$n_Lcats_Eval$)) {
    $n_Lcats_Eval$ = new $c_Lcats_Eval$();
  }
  return $n_Lcats_Eval$;
}
export { $m_Lcats_Eval$ as $m_Lcats_Eval$ };
/** @constructor */
function $c_Lcats_Eval$$anon$1(c$1, f$2) {
  this.Lcats_Eval$$anon$1__f_start = null;
  this.Lcats_Eval$$anon$1__f_run = null;
  this.Lcats_Eval$$anon$1__f_start = c$1.start__F0();
  this.Lcats_Eval$$anon$1__f_run = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => new $c_Lcats_Eval$$anon$2(c$1, s, f$2, this)));
}
export { $c_Lcats_Eval$$anon$1 as $c_Lcats_Eval$$anon$1 };
$c_Lcats_Eval$$anon$1.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$1.prototype.constructor = $c_Lcats_Eval$$anon$1;
/** @constructor */
function $h_Lcats_Eval$$anon$1() {
}
export { $h_Lcats_Eval$$anon$1 as $h_Lcats_Eval$$anon$1 };
$h_Lcats_Eval$$anon$1.prototype = $c_Lcats_Eval$$anon$1.prototype;
$c_Lcats_Eval$$anon$1.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$1__f_start;
});
$c_Lcats_Eval$$anon$1.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$1__f_run;
});
var $d_Lcats_Eval$$anon$1 = new $TypeData().initClass($c_Lcats_Eval$$anon$1, "cats.Eval$$anon$1", ({
  Lcats_Eval$$anon$1: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_Eval$$anon$1 as $d_Lcats_Eval$$anon$1 };
/** @constructor */
function $c_Lcats_Eval$$anon$2(c$3, s$1, f$4, outer) {
  this.Lcats_Eval$$anon$2__f_start = null;
  this.Lcats_Eval$$anon$2__f_run = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_Eval$$anon$2__f_start = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c$3.run__F1().apply__O__O(s$1)));
  this.Lcats_Eval$$anon$2__f_run = f$4;
}
export { $c_Lcats_Eval$$anon$2 as $c_Lcats_Eval$$anon$2 };
$c_Lcats_Eval$$anon$2.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$2.prototype.constructor = $c_Lcats_Eval$$anon$2;
/** @constructor */
function $h_Lcats_Eval$$anon$2() {
}
export { $h_Lcats_Eval$$anon$2 as $h_Lcats_Eval$$anon$2 };
$h_Lcats_Eval$$anon$2.prototype = $c_Lcats_Eval$$anon$2.prototype;
$c_Lcats_Eval$$anon$2.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$2__f_start;
});
$c_Lcats_Eval$$anon$2.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$2__f_run;
});
var $d_Lcats_Eval$$anon$2 = new $TypeData().initClass($c_Lcats_Eval$$anon$2, "cats.Eval$$anon$2", ({
  Lcats_Eval$$anon$2: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_Eval$$anon$2 as $d_Lcats_Eval$$anon$2 };
/** @constructor */
function $c_Lcats_Eval$$anon$3(c$5, f$5) {
  this.Lcats_Eval$$anon$3__f_start = null;
  this.Lcats_Eval$$anon$3__f_run = null;
  this.Lcats_Eval$$anon$3__f_start = c$5.Lcats_Eval$Defer__f_thunk;
  this.Lcats_Eval$$anon$3__f_run = f$5;
}
export { $c_Lcats_Eval$$anon$3 as $c_Lcats_Eval$$anon$3 };
$c_Lcats_Eval$$anon$3.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$3.prototype.constructor = $c_Lcats_Eval$$anon$3;
/** @constructor */
function $h_Lcats_Eval$$anon$3() {
}
export { $h_Lcats_Eval$$anon$3 as $h_Lcats_Eval$$anon$3 };
$h_Lcats_Eval$$anon$3.prototype = $c_Lcats_Eval$$anon$3.prototype;
$c_Lcats_Eval$$anon$3.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$3__f_start;
});
$c_Lcats_Eval$$anon$3.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$3__f_run;
});
var $d_Lcats_Eval$$anon$3 = new $TypeData().initClass($c_Lcats_Eval$$anon$3, "cats.Eval$$anon$3", ({
  Lcats_Eval$$anon$3: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_Eval$$anon$3 as $d_Lcats_Eval$$anon$3 };
/** @constructor */
function $c_Lcats_Eval$$anon$4(f$6, outer) {
  this.Lcats_Eval$$anon$4__f_start = null;
  this.Lcats_Eval$$anon$4__f_run = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_Eval$$anon$4__f_start = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => outer));
  this.Lcats_Eval$$anon$4__f_run = f$6;
}
export { $c_Lcats_Eval$$anon$4 as $c_Lcats_Eval$$anon$4 };
$c_Lcats_Eval$$anon$4.prototype = new $h_Lcats_Eval$FlatMap();
$c_Lcats_Eval$$anon$4.prototype.constructor = $c_Lcats_Eval$$anon$4;
/** @constructor */
function $h_Lcats_Eval$$anon$4() {
}
export { $h_Lcats_Eval$$anon$4 as $h_Lcats_Eval$$anon$4 };
$h_Lcats_Eval$$anon$4.prototype = $c_Lcats_Eval$$anon$4.prototype;
$c_Lcats_Eval$$anon$4.prototype.start__F0 = (function() {
  return this.Lcats_Eval$$anon$4__f_start;
});
$c_Lcats_Eval$$anon$4.prototype.run__F1 = (function() {
  return this.Lcats_Eval$$anon$4__f_run;
});
var $d_Lcats_Eval$$anon$4 = new $TypeData().initClass($c_Lcats_Eval$$anon$4, "cats.Eval$$anon$4", ({
  Lcats_Eval$$anon$4: 1,
  Lcats_Eval$FlatMap: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_Eval$$anon$4 as $d_Lcats_Eval$$anon$4 };
/** @constructor */
function $c_Lcats_Eval$$anon$5(a$2) {
  this.Lcats_Eval$Defer__f_thunk = null;
  $ct_Lcats_Eval$Defer__F0__(this, ($m_Lcats_Eval$(), a$2));
}
export { $c_Lcats_Eval$$anon$5 as $c_Lcats_Eval$$anon$5 };
$c_Lcats_Eval$$anon$5.prototype = new $h_Lcats_Eval$Defer();
$c_Lcats_Eval$$anon$5.prototype.constructor = $c_Lcats_Eval$$anon$5;
/** @constructor */
function $h_Lcats_Eval$$anon$5() {
}
export { $h_Lcats_Eval$$anon$5 as $h_Lcats_Eval$$anon$5 };
$h_Lcats_Eval$$anon$5.prototype = $c_Lcats_Eval$$anon$5.prototype;
var $d_Lcats_Eval$$anon$5 = new $TypeData().initClass($c_Lcats_Eval$$anon$5, "cats.Eval$$anon$5", ({
  Lcats_Eval$$anon$5: 1,
  Lcats_Eval$Defer: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_Eval$$anon$5 as $d_Lcats_Eval$$anon$5 };
function $f_Lcats_Foldable__foldMap__O__F1__Lcats_kernel_Monoid__O($thiz, fa, f, B) {
  return $thiz.foldLeft__O__O__F2__O(fa, B.empty__O(), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((b, a) => B.combine__O__O__O(b, f.apply__O__O(a)))));
}
export { $f_Lcats_Foldable__foldMap__O__F1__Lcats_kernel_Monoid__O as $f_Lcats_Foldable__foldMap__O__F1__Lcats_kernel_Monoid__O };
function $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O($thiz, fa, z, f, G) {
  var src = $m_Lcats_Foldable$Source$().fromFoldable__O__Lcats_Foldable__Lcats_Foldable$Source(fa, $thiz);
  return G.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), z, src), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var b = x$1._1__O();
      var src$1 = x$1._2__O();
      var x63 = src$1.uncons__s_Option();
      if ((x63 instanceof $c_s_Some)) {
        var x65 = x63.s_Some__f_value;
        if ((x65 !== null)) {
          var a = x65._1__O();
          var src$2 = x65._2__O();
          return G.map__O__F1__O(f.apply__O__O__O(b, a), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b$2) => {
            var _2 = src$2.value__O();
            var value = $ct_T2__O__O__(new $c_T2(), b$2, _2);
            return new $c_s_util_Left(value);
          })));
        }
      }
      var x = $m_s_None$();
      if ((x === x63)) {
        return G.pure__O__O(new $c_s_util_Right(b));
      }
      throw new $c_s_MatchError(x63);
    }
    throw new $c_s_MatchError(x$1);
  })));
}
export { $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O as $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O };
function $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O($thiz, fa, f, G) {
  var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => G.unit__O()));
  return $thiz.foldRight__O__Lcats_Eval__F2__Lcats_Eval(fa, new $c_Lcats_Always(a), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a$1, acc) => G.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f.apply__O__O(a$1), acc, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$17, _$18) => (void 0))))))).value__O();
}
export { $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O as $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O };
function $f_Lcats_Foldable__exists__O__F1__Z($thiz, fa, p) {
  return $thiz.toIterable__O__sc_Iterable(fa).exists__F1__Z(p);
}
export { $f_Lcats_Foldable__exists__O__F1__Z as $f_Lcats_Foldable__exists__O__F1__Z };
function $f_Lcats_Foldable__toList__O__sci_List($thiz, fa) {
  return $thiz.foldLeft__O__O__F2__O(fa, new $c_scm_ListBuffer(), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((buf, a) => buf.addOne__O__scm_ListBuffer(a)))).toList__sci_List();
}
export { $f_Lcats_Foldable__toList__O__sci_List as $f_Lcats_Foldable__toList__O__sci_List };
/** @constructor */
function $c_Lcats_Later(f) {
  this.Lcats_Later__f_thunk = null;
  this.Lcats_Later__f_value$lzy1 = null;
  this.Lcats_Later__f_valuebitmap$1 = false;
  this.Lcats_Later__f_thunk = f;
}
export { $c_Lcats_Later as $c_Lcats_Later };
$c_Lcats_Later.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Later.prototype.constructor = $c_Lcats_Later;
/** @constructor */
function $h_Lcats_Later() {
}
export { $h_Lcats_Later as $h_Lcats_Later };
$h_Lcats_Later.prototype = $c_Lcats_Later.prototype;
$c_Lcats_Later.prototype.value__O = (function() {
  if ((!this.Lcats_Later__f_valuebitmap$1)) {
    var result = this.Lcats_Later__f_thunk.apply__O();
    this.Lcats_Later__f_thunk = null;
    this.Lcats_Later__f_value$lzy1 = result;
    this.Lcats_Later__f_valuebitmap$1 = true;
  }
  return this.Lcats_Later__f_value$lzy1;
});
var $d_Lcats_Later = new $TypeData().initClass($c_Lcats_Later, "cats.Later", ({
  Lcats_Later: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_Later as $d_Lcats_Later };
/** @constructor */
function $c_Lcats_MonoidK$$anon$1(outer) {
  this.Lcats_MonoidK$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_MonoidK$$anon$1__f_$outer = outer;
}
export { $c_Lcats_MonoidK$$anon$1 as $c_Lcats_MonoidK$$anon$1 };
$c_Lcats_MonoidK$$anon$1.prototype = new $h_O();
$c_Lcats_MonoidK$$anon$1.prototype.constructor = $c_Lcats_MonoidK$$anon$1;
/** @constructor */
function $h_Lcats_MonoidK$$anon$1() {
}
export { $h_Lcats_MonoidK$$anon$1 as $h_Lcats_MonoidK$$anon$1 };
$h_Lcats_MonoidK$$anon$1.prototype = $c_Lcats_MonoidK$$anon$1.prototype;
$c_Lcats_MonoidK$$anon$1.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_MonoidK$$anon$1.prototype.empty__O = (function() {
  return this.Lcats_MonoidK$$anon$1__f_$outer.empty__O();
});
$c_Lcats_MonoidK$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return this.Lcats_MonoidK$$anon$1__f_$outer.combineK__O__O__O(x, y);
});
var $d_Lcats_MonoidK$$anon$1 = new $TypeData().initClass($c_Lcats_MonoidK$$anon$1, "cats.MonoidK$$anon$1", ({
  Lcats_MonoidK$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
export { $d_Lcats_MonoidK$$anon$1 as $d_Lcats_MonoidK$$anon$1 };
/** @constructor */
function $c_Lcats_Parallel$$anon$2(evidence$1$1) {
  this.Lcats_Parallel$$anon$2__f_monad = null;
  this.Lcats_Parallel$$anon$2__f_applicative = null;
  this.Lcats_Parallel$$anon$2__f_sequential = null;
  this.Lcats_Parallel$$anon$2__f_parallel = null;
  this.Lcats_Parallel$$anon$2__f_monad = evidence$1$1;
  this.Lcats_Parallel$$anon$2__f_applicative = evidence$1$1;
  this.Lcats_Parallel$$anon$2__f_sequential = new $c_Lcats_arrow_FunctionK$$anon$4();
  this.Lcats_Parallel$$anon$2__f_parallel = new $c_Lcats_arrow_FunctionK$$anon$4();
}
export { $c_Lcats_Parallel$$anon$2 as $c_Lcats_Parallel$$anon$2 };
$c_Lcats_Parallel$$anon$2.prototype = new $h_O();
$c_Lcats_Parallel$$anon$2.prototype.constructor = $c_Lcats_Parallel$$anon$2;
/** @constructor */
function $h_Lcats_Parallel$$anon$2() {
}
export { $h_Lcats_Parallel$$anon$2 as $h_Lcats_Parallel$$anon$2 };
$h_Lcats_Parallel$$anon$2.prototype = $c_Lcats_Parallel$$anon$2.prototype;
$c_Lcats_Parallel$$anon$2.prototype.monad__Lcats_Monad = (function() {
  return this.Lcats_Parallel$$anon$2__f_monad;
});
$c_Lcats_Parallel$$anon$2.prototype.applicative__Lcats_Applicative = (function() {
  return this.Lcats_Parallel$$anon$2__f_applicative;
});
$c_Lcats_Parallel$$anon$2.prototype.sequential__Lcats_arrow_FunctionK = (function() {
  return this.Lcats_Parallel$$anon$2__f_sequential;
});
$c_Lcats_Parallel$$anon$2.prototype.parallel__Lcats_arrow_FunctionK = (function() {
  return this.Lcats_Parallel$$anon$2__f_parallel;
});
var $d_Lcats_Parallel$$anon$2 = new $TypeData().initClass($c_Lcats_Parallel$$anon$2, "cats.Parallel$$anon$2", ({
  Lcats_Parallel$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_NonEmptyParallel: 1,
  Lcats_Parallel: 1
}));
export { $d_Lcats_Parallel$$anon$2 as $d_Lcats_Parallel$$anon$2 };
/** @constructor */
function $c_Lcats_Show$$anon$4(f$6) {
  this.Lcats_Show$$anon$4__f_f$4 = null;
  this.Lcats_Show$$anon$4__f_f$4 = f$6;
}
export { $c_Lcats_Show$$anon$4 as $c_Lcats_Show$$anon$4 };
$c_Lcats_Show$$anon$4.prototype = new $h_O();
$c_Lcats_Show$$anon$4.prototype.constructor = $c_Lcats_Show$$anon$4;
/** @constructor */
function $h_Lcats_Show$$anon$4() {
}
export { $h_Lcats_Show$$anon$4 as $h_Lcats_Show$$anon$4 };
$h_Lcats_Show$$anon$4.prototype = $c_Lcats_Show$$anon$4.prototype;
$c_Lcats_Show$$anon$4.prototype.show__O__T = (function(_$1) {
  var f$2 = this.Lcats_Show$$anon$4__f_f$4;
  return f$2.apply__O__O(_$1);
});
var $d_Lcats_Show$$anon$4 = new $TypeData().initClass($c_Lcats_Show$$anon$4, "cats.Show$$anon$4", ({
  Lcats_Show$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lcats_Show$$anon$4 as $d_Lcats_Show$$anon$4 };
/** @constructor */
function $c_Lcats_Show$$anon$5() {
}
export { $c_Lcats_Show$$anon$5 as $c_Lcats_Show$$anon$5 };
$c_Lcats_Show$$anon$5.prototype = new $h_O();
$c_Lcats_Show$$anon$5.prototype.constructor = $c_Lcats_Show$$anon$5;
/** @constructor */
function $h_Lcats_Show$$anon$5() {
}
export { $h_Lcats_Show$$anon$5 as $h_Lcats_Show$$anon$5 };
$h_Lcats_Show$$anon$5.prototype = $c_Lcats_Show$$anon$5.prototype;
$c_Lcats_Show$$anon$5.prototype.show__O__T = (function(_$2) {
  return $dp_toString__T(_$2);
});
var $d_Lcats_Show$$anon$5 = new $TypeData().initClass($c_Lcats_Show$$anon$5, "cats.Show$$anon$5", ({
  Lcats_Show$$anon$5: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lcats_Show$$anon$5 as $d_Lcats_Show$$anon$5 };
/** @constructor */
function $c_Lcats_Show$Shown(toString) {
  this.Lcats_Show$Shown__f_toString = null;
  this.Lcats_Show$Shown__f_toString = toString;
}
export { $c_Lcats_Show$Shown as $c_Lcats_Show$Shown };
$c_Lcats_Show$Shown.prototype = new $h_O();
$c_Lcats_Show$Shown.prototype.constructor = $c_Lcats_Show$Shown;
/** @constructor */
function $h_Lcats_Show$Shown() {
}
export { $h_Lcats_Show$Shown as $h_Lcats_Show$Shown };
$h_Lcats_Show$Shown.prototype = $c_Lcats_Show$Shown.prototype;
$c_Lcats_Show$Shown.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Show$Shown.prototype.hashCode__I = (function() {
  var this$ = this.Lcats_Show$Shown__f_toString;
  return $f_T__hashCode__I(this$);
});
$c_Lcats_Show$Shown.prototype.equals__O__Z = (function(x$0) {
  return $m_Lcats_Show$Shown$().equals$extension__T__O__Z(this.Lcats_Show$Shown__f_toString, x$0);
});
$c_Lcats_Show$Shown.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_Show$Shown.prototype.productPrefix__T = (function() {
  return "Shown";
});
$c_Lcats_Show$Shown.prototype.productElement__I__O = (function(n) {
  return $m_Lcats_Show$Shown$().productElement$extension__T__I__O(this.Lcats_Show$Shown__f_toString, n);
});
$c_Lcats_Show$Shown.prototype.productElementName__I__T = (function(n) {
  return $m_Lcats_Show$Shown$().productElementName$extension__T__I__T(this.Lcats_Show$Shown__f_toString, n);
});
$c_Lcats_Show$Shown.prototype.toString__T = (function() {
  return this.Lcats_Show$Shown__f_toString;
});
function $isArrayOf_Lcats_Show$Shown(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Show$Shown)));
}
export { $isArrayOf_Lcats_Show$Shown as $isArrayOf_Lcats_Show$Shown };
var $d_Lcats_Show$Shown = new $TypeData().initClass($c_Lcats_Show$Shown, "cats.Show$Shown", ({
  Lcats_Show$Shown: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_Show$Shown as $d_Lcats_Show$Shown };
/** @constructor */
function $c_Lcats_UnorderedFoldable$() {
  $n_Lcats_UnorderedFoldable$ = this;
  new $c_Lcats_UnorderedFoldable$$anon$1();
  new $c_Lcats_UnorderedFoldable$$anon$2();
}
export { $c_Lcats_UnorderedFoldable$ as $c_Lcats_UnorderedFoldable$ };
$c_Lcats_UnorderedFoldable$.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$.prototype.constructor = $c_Lcats_UnorderedFoldable$;
/** @constructor */
function $h_Lcats_UnorderedFoldable$() {
}
export { $h_Lcats_UnorderedFoldable$ as $h_Lcats_UnorderedFoldable$ };
$h_Lcats_UnorderedFoldable$.prototype = $c_Lcats_UnorderedFoldable$.prototype;
var $d_Lcats_UnorderedFoldable$ = new $TypeData().initClass($c_Lcats_UnorderedFoldable$, "cats.UnorderedFoldable$", ({
  Lcats_UnorderedFoldable$: 1,
  Lcats_ScalaVersionSpecificTraverseInstances: 1,
  Lcats_instances_NTupleUnorderedFoldableInstances: 1,
  Lcats_UnorderedFoldableLowPriority: 1
}));
export { $d_Lcats_UnorderedFoldable$ as $d_Lcats_UnorderedFoldable$ };
var $n_Lcats_UnorderedFoldable$;
function $m_Lcats_UnorderedFoldable$() {
  if ((!$n_Lcats_UnorderedFoldable$)) {
    $n_Lcats_UnorderedFoldable$ = new $c_Lcats_UnorderedFoldable$();
  }
  return $n_Lcats_UnorderedFoldable$;
}
export { $m_Lcats_UnorderedFoldable$ as $m_Lcats_UnorderedFoldable$ };
function $p_Lcats_data_Chain$ChainIterator__go$7__O($thiz) {
  while (true) {
    if ((($thiz.Lcats_data_Chain$ChainIterator__f_currentIterator !== null) && $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator.hasNext__Z())) {
      return $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator.next__O();
    } else {
      $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
      var x278 = $thiz.Lcats_data_Chain$ChainIterator__f_c;
      if ((x278 instanceof $c_Lcats_data_Chain$Singleton)) {
        var x288 = x278.Lcats_data_Chain$Singleton__f_a;
        if ($thiz.Lcats_data_Chain$ChainIterator__f_rights.isEmpty__Z()) {
          var $x_1 = null;
        } else {
          var head = $thiz.Lcats_data_Chain$ChainIterator__f_rights.head__O();
          $thiz.Lcats_data_Chain$ChainIterator__f_rights = $thiz.Lcats_data_Chain$ChainIterator__f_rights.tail__O();
          var $x_1 = head;
        }
        $thiz.Lcats_data_Chain$ChainIterator__f_c = $x_1;
        return x288;
      }
      if ((x278 instanceof $c_Lcats_data_Chain$Append)) {
        var x284 = x278.Lcats_data_Chain$Append__f_leftNE;
        var x285 = x278.Lcats_data_Chain$Append__f_rightNE;
        $thiz.Lcats_data_Chain$ChainIterator__f_c = x284;
        var this$3 = $thiz.Lcats_data_Chain$ChainIterator__f_rights;
        $thiz.Lcats_data_Chain$ChainIterator__f_rights = new $c_sci_$colon$colon(x285, this$3);
        continue;
      }
      if ((x278 instanceof $c_Lcats_data_Chain$Wrap)) {
        var x281 = x278.Lcats_data_Chain$Wrap__f_seq;
        if ($thiz.Lcats_data_Chain$ChainIterator__f_rights.isEmpty__Z()) {
          var $x_2 = null;
        } else {
          var head$2 = $thiz.Lcats_data_Chain$ChainIterator__f_rights.head__O();
          $thiz.Lcats_data_Chain$ChainIterator__f_rights = $thiz.Lcats_data_Chain$ChainIterator__f_rights.tail__O();
          var $x_2 = head$2;
        }
        $thiz.Lcats_data_Chain$ChainIterator__f_c = $x_2;
        $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator = x281.iterator__sc_Iterator();
        return $thiz.Lcats_data_Chain$ChainIterator__f_currentIterator.next__O();
      }
      if ((x278 === null)) {
        throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next called on empty iterator");
      }
      throw new $c_s_MatchError(x278);
    }
  }
}
export { $p_Lcats_data_Chain$ChainIterator__go$7__O as $p_Lcats_data_Chain$ChainIterator__go$7__O };
/** @constructor */
function $c_Lcats_data_Chain$ChainIterator(self) {
  this.Lcats_data_Chain$ChainIterator__f_c = null;
  this.Lcats_data_Chain$ChainIterator__f_rights = null;
  this.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
  this.Lcats_data_Chain$ChainIterator__f_c = self;
  this.Lcats_data_Chain$ChainIterator__f_rights = $m_sci_Nil$();
  this.Lcats_data_Chain$ChainIterator__f_currentIterator = null;
}
export { $c_Lcats_data_Chain$ChainIterator as $c_Lcats_data_Chain$ChainIterator };
$c_Lcats_data_Chain$ChainIterator.prototype = new $h_O();
$c_Lcats_data_Chain$ChainIterator.prototype.constructor = $c_Lcats_data_Chain$ChainIterator;
/** @constructor */
function $h_Lcats_data_Chain$ChainIterator() {
}
export { $h_Lcats_data_Chain$ChainIterator as $h_Lcats_data_Chain$ChainIterator };
$h_Lcats_data_Chain$ChainIterator.prototype = $c_Lcats_data_Chain$ChainIterator.prototype;
$c_Lcats_data_Chain$ChainIterator.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lcats_data_Chain$ChainIterator.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lcats_data_Chain$ChainIterator.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lcats_data_Chain$ChainIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lcats_data_Chain$ChainIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lcats_data_Chain$ChainIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lcats_data_Chain$ChainIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lcats_data_Chain$ChainIterator.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_Lcats_data_Chain$ChainIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lcats_data_Chain$ChainIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lcats_data_Chain$ChainIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lcats_data_Chain$ChainIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lcats_data_Chain$ChainIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lcats_data_Chain$ChainIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lcats_data_Chain$ChainIterator.prototype.hasNext__Z = (function() {
  return ((this.Lcats_data_Chain$ChainIterator__f_c !== null) || ((this.Lcats_data_Chain$ChainIterator__f_currentIterator !== null) && this.Lcats_data_Chain$ChainIterator__f_currentIterator.hasNext__Z()));
});
$c_Lcats_data_Chain$ChainIterator.prototype.next__O = (function() {
  return $p_Lcats_data_Chain$ChainIterator__go$7__O(this);
});
var $d_Lcats_data_Chain$ChainIterator = new $TypeData().initClass($c_Lcats_data_Chain$ChainIterator, "cats.data.Chain$ChainIterator", ({
  Lcats_data_Chain$ChainIterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
export { $d_Lcats_data_Chain$ChainIterator as $d_Lcats_data_Chain$ChainIterator };
function $ct_Lcats_data_ChainInstances__($thiz) {
  $thiz.Lcats_data_ChainInstances__f_catsDataInstancesForChain = new $c_Lcats_data_ChainInstances$$anon$3();
  return $thiz;
}
export { $ct_Lcats_data_ChainInstances__ as $ct_Lcats_data_ChainInstances__ };
function $ps_Lcats_data_ChainInstances__loop$6__F2__Lcats_Eval__Lcats_data_Chain__Lcats_Eval(f$18, lb$1, as) {
  var x305 = as.uncons__s_Option();
  if ((x305 instanceof $c_s_Some)) {
    var x307 = x305.s_Some__f_value;
    if ((x307 !== null)) {
      var h = x307._1__O();
      var t = x307._2__O();
      $m_Lcats_Eval$();
      var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $ps_Lcats_data_ChainInstances__loop$6__F2__Lcats_Eval__Lcats_data_Chain__Lcats_Eval(f$18, lb$1, t)));
      return f$18.apply__O__O__O(h, new $c_Lcats_Eval$$anon$5(a));
    }
  }
  var x = $m_s_None$();
  if ((x === x305)) {
    return lb$1;
  }
  throw new $c_s_MatchError(x305);
}
export { $ps_Lcats_data_ChainInstances__loop$6__F2__Lcats_Eval__Lcats_data_Chain__Lcats_Eval as $ps_Lcats_data_ChainInstances__loop$6__F2__Lcats_Eval__Lcats_data_Chain__Lcats_Eval };
function $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$10__F1__Lcats_Applicative__Lcats_data_Chain$NonEmpty__Lcats_data_Chain__O__O(f$22, G$13, fa, rhs, acc) {
  var acc$tailLocal4 = acc;
  var rhs$tailLocal4 = rhs;
  var fa$tailLocal1 = fa;
  while (true) {
    var x321 = fa$tailLocal1;
    if ((x321 instanceof $c_Lcats_data_Chain$Append)) {
      var x330 = x321.Lcats_data_Chain$Append__f_leftNE;
      var x331 = x321.Lcats_data_Chain$Append__f_rightNE;
      if (rhs$tailLocal4.isEmpty__Z()) {
        var rhs$tailLocal4$tmp1 = x331;
      } else {
        var right = rhs$tailLocal4;
        var rhs$tailLocal4$tmp1 = $ct_Lcats_data_Chain$Append__Lcats_data_Chain__Lcats_data_Chain__(new $c_Lcats_data_Chain$Append(), x331, right);
      }
      fa$tailLocal1 = x330;
      rhs$tailLocal4 = rhs$tailLocal4$tmp1;
      continue;
    }
    if ((x321 instanceof $c_Lcats_data_Chain$Wrap)) {
      var x327 = x321.Lcats_data_Chain$Wrap__f_seq;
      $m_Lcats_UnorderedFoldable$();
      var instance = $m_Lcats_instances_package$seq$().Lcats_instances_package$seq$__f_catsStdInstancesForSeq;
      var va = instance.traverseVoid__O__F1__Lcats_Applicative__O(x327, f$22, G$13);
      var acc1 = G$13.productL__O__O__O(acc$tailLocal4, va);
      var x317 = rhs$tailLocal4;
      var x = $m_Lcats_data_Chain$Empty$();
      if (x.equals__O__Z(x317)) {
        return acc1;
      }
      if ((x317 instanceof $c_Lcats_data_Chain$NonEmpty)) {
        var rhs$tailLocal4$tmp2 = $m_Lcats_data_Chain$Empty$();
        fa$tailLocal1 = x317;
        rhs$tailLocal4 = rhs$tailLocal4$tmp2;
        acc$tailLocal4 = acc1;
        continue;
      }
      throw new $c_s_MatchError(x317);
    }
    if ((x321 instanceof $c_Lcats_data_Chain$Singleton)) {
      var x324 = x321.Lcats_data_Chain$Singleton__f_a;
      var acc1$2 = G$13.productL__O__O__O(acc$tailLocal4, f$22.apply__O__O(x324));
      var x319 = rhs$tailLocal4;
      var x$3 = $m_Lcats_data_Chain$Empty$();
      if (x$3.equals__O__Z(x319)) {
        return acc1$2;
      }
      if ((x319 instanceof $c_Lcats_data_Chain$NonEmpty)) {
        var rhs$tailLocal4$tmp3 = $m_Lcats_data_Chain$Empty$();
        fa$tailLocal1 = x319;
        rhs$tailLocal4 = rhs$tailLocal4$tmp3;
        acc$tailLocal4 = acc1$2;
        continue;
      }
      throw new $c_s_MatchError(x319);
    }
    throw new $c_s_MatchError(x321);
  }
}
export { $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$10__F1__Lcats_Applicative__Lcats_data_Chain$NonEmpty__Lcats_data_Chain__O__O as $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$10__F1__Lcats_Applicative__Lcats_data_Chain$NonEmpty__Lcats_data_Chain__O__O };
function $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$11__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain(f$23, rest, acc) {
  var acc$tailLocal5 = acc;
  var rest$tailLocal1 = rest;
  while (true) {
    var x346 = rest$tailLocal1;
    if ((x346 instanceof $c_sci_$colon$colon)) {
      var x349 = x346.sci_$colon$colon__f_next;
      var hd = x346.sci_$colon$colon__f_head;
      var x341 = hd.uncons__s_Option();
      if ((x341 instanceof $c_s_Some)) {
        var x343 = x341.s_Some__f_value;
        if ((x343 !== null)) {
          var hdh = x343._1__O();
          var hdt = x343._2__O();
          if ((hdh instanceof $c_s_util_Right)) {
            var b = hdh.s_util_Right__f_value;
            var rest$tailLocal1$tmp1 = new $c_sci_$colon$colon(hdt, x349);
            var this$1 = acc$tailLocal5;
            var acc$tailLocal5$tmp1 = this$1.append__O__Lcats_data_Chain(b);
            rest$tailLocal1 = rest$tailLocal1$tmp1;
            acc$tailLocal5 = acc$tailLocal5$tmp1;
            continue;
          }
          if ((hdh instanceof $c_s_util_Left)) {
            var a = hdh.s_util_Left__f_value;
            var elem$3 = f$23.apply__O__O(a);
            var this$2 = new $c_sci_$colon$colon(hdt, x349);
            rest$tailLocal1 = new $c_sci_$colon$colon(elem$3, this$2);
            continue;
          }
          throw new $c_s_MatchError(hdh);
        }
      }
      var x = $m_s_None$();
      if ((x === x341)) {
        rest$tailLocal1 = x349;
        continue;
      }
      throw new $c_s_MatchError(x341);
    }
    return acc$tailLocal5;
  }
}
export { $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$11__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain as $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$11__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain };
/** @constructor */
function $c_Lcats_data_ChainInstances() {
  this.Lcats_data_ChainInstances__f_catsDataInstancesForChain = null;
}
export { $c_Lcats_data_ChainInstances as $c_Lcats_data_ChainInstances };
$c_Lcats_data_ChainInstances.prototype = new $h_Lcats_data_ChainInstances1();
$c_Lcats_data_ChainInstances.prototype.constructor = $c_Lcats_data_ChainInstances;
/** @constructor */
function $h_Lcats_data_ChainInstances() {
}
export { $h_Lcats_data_ChainInstances as $h_Lcats_data_ChainInstances };
$h_Lcats_data_ChainInstances.prototype = $c_Lcats_data_ChainInstances.prototype;
function $ct_Lcats_data_NonEmptyVectorInstances__($thiz) {
  $thiz.Lcats_data_NonEmptyVectorInstances__f_catsDataInstancesForNonEmptyVectorBinCompat1 = new $c_Lcats_data_NonEmptyVectorInstances$$anon$1();
  return $thiz;
}
export { $ct_Lcats_data_NonEmptyVectorInstances__ as $ct_Lcats_data_NonEmptyVectorInstances__ };
function $s_Lcats_data_NonEmptyVectorInstances__cats$data$NonEmptyVectorInstances$$anon$1$$_$go$1__sci_VectorBuilder__F1__sci_Vector__V(buf$1, f$8, v) {
  var v$tailLocal1 = v;
  while (true) {
    $m_Lcats_data_NonEmptyVector$();
    var this$ = v$tailLocal1;
    var x45 = this$.head__O();
    if ((x45 instanceof $c_s_util_Right)) {
      var b = x45.s_util_Right__f_value;
      buf$1.addOne__O__sci_VectorBuilder(b);
      var $x_1 = $m_Lcats_data_NonEmptyVector$();
      $m_Lcats_data_NonEmptyVector$();
      var this$$1 = v$tailLocal1;
      var x42 = $x_1.fromVector__sci_Vector__s_Option(this$$1.tail__sci_Vector());
      if ((x42 instanceof $c_s_Some)) {
        var ev$4 = x42.s_Some__f_value;
        var t = ((ev$4 === null) ? null : ev$4.Lcats_data_NonEmptyVector__f_toVector);
        v$tailLocal1 = t;
        continue;
      }
      var x = $m_s_None$();
      if ((x === x42)) {
        return (void 0);
      }
      throw new $c_s_MatchError(x42);
    }
    if ((x45 instanceof $c_s_util_Left)) {
      var a = x45.s_util_Left__f_value;
      var ev$5 = f$8.apply__O__O(a);
      var ev$1 = ((ev$5 === null) ? null : ev$5.Lcats_data_NonEmptyVector__f_toVector);
      $m_Lcats_data_NonEmptyVector$();
      $m_Lcats_data_NonEmptyVector$();
      var this$$2 = v$tailLocal1;
      var other = this$$2.tail__sci_Vector();
      v$tailLocal1 = ev$1.appendedAll__sc_IterableOnce__sci_Vector(other);
      continue;
    }
    throw new $c_s_MatchError(x45);
  }
}
export { $s_Lcats_data_NonEmptyVectorInstances__cats$data$NonEmptyVectorInstances$$anon$1$$_$go$1__sci_VectorBuilder__F1__sci_Vector__V as $s_Lcats_data_NonEmptyVectorInstances__cats$data$NonEmptyVectorInstances$$anon$1$$_$go$1__sci_VectorBuilder__F1__sci_Vector__V };
/** @constructor */
function $c_Lcats_data_NonEmptyVectorInstances() {
  this.Lcats_data_NonEmptyVectorInstances__f_catsDataInstancesForNonEmptyVectorBinCompat1 = null;
}
export { $c_Lcats_data_NonEmptyVectorInstances as $c_Lcats_data_NonEmptyVectorInstances };
$c_Lcats_data_NonEmptyVectorInstances.prototype = new $h_Lcats_data_NonEmptyVectorInstances0();
$c_Lcats_data_NonEmptyVectorInstances.prototype.constructor = $c_Lcats_data_NonEmptyVectorInstances;
/** @constructor */
function $h_Lcats_data_NonEmptyVectorInstances() {
}
export { $h_Lcats_data_NonEmptyVectorInstances as $h_Lcats_data_NonEmptyVectorInstances };
$h_Lcats_data_NonEmptyVectorInstances.prototype = $c_Lcats_data_NonEmptyVectorInstances.prototype;
/** @constructor */
function $c_Lcats_data_Validated() {
}
export { $c_Lcats_data_Validated as $c_Lcats_data_Validated };
$c_Lcats_data_Validated.prototype = new $h_O();
$c_Lcats_data_Validated.prototype.constructor = $c_Lcats_data_Validated;
/** @constructor */
function $h_Lcats_data_Validated() {
}
export { $h_Lcats_data_Validated as $h_Lcats_data_Validated };
$h_Lcats_data_Validated.prototype = $c_Lcats_data_Validated.prototype;
$c_Lcats_data_Validated.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Validated.prototype.toEither__s_util_Either = (function() {
  if ((this instanceof $c_Lcats_data_Validated$Invalid)) {
    var x63 = this.Lcats_data_Validated$Invalid__f_e;
    return new $c_s_util_Left(x63);
  }
  if ((this instanceof $c_Lcats_data_Validated$Valid)) {
    var x60 = this.Lcats_data_Validated$Valid__f_a;
    return new $c_s_util_Right(x60);
  }
  throw new $c_s_MatchError(this);
});
$c_Lcats_data_Validated.prototype.ap__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated = (function(f, EE) {
  var x171 = $ct_T2__O__O__(new $c_T2(), this, f);
  var x190 = x171.T2__f__1;
  var x191 = x171.T2__f__2;
  if ((x190 instanceof $c_Lcats_data_Validated$Valid)) {
    var x197 = x190.Lcats_data_Validated$Valid__f_a;
    if ((x191 instanceof $c_Lcats_data_Validated$Valid)) {
      var x194 = x191.Lcats_data_Validated$Valid__f_a;
      var a = x194.apply__O__O(x197);
      return new $c_Lcats_data_Validated$Valid(a);
    }
  }
  if ((x190 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x189 = x190.Lcats_data_Validated$Invalid__f_e;
    if ((x191 instanceof $c_Lcats_data_Validated$Invalid)) {
      var x186 = x191.Lcats_data_Validated$Invalid__f_e;
      var e = EE.combine__O__O__O(x186, x189);
      return new $c_Lcats_data_Validated$Invalid(e);
    }
    return x190;
  }
  if ((x191 instanceof $c_Lcats_data_Validated$Invalid)) {
    return x191;
  }
  throw new $c_s_MatchError(x171);
});
$c_Lcats_data_Validated.prototype.product__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated = (function(fb, EE) {
  var x198 = $ct_T2__O__O__(new $c_T2(), this, fb);
  var x217 = x198.T2__f__1;
  var x218 = x198.T2__f__2;
  if ((x217 instanceof $c_Lcats_data_Validated$Valid)) {
    var x224 = x217.Lcats_data_Validated$Valid__f_a;
    if ((x218 instanceof $c_Lcats_data_Validated$Valid)) {
      var x221 = x218.Lcats_data_Validated$Valid__f_a;
      var a = $ct_T2__O__O__(new $c_T2(), x224, x221);
      return new $c_Lcats_data_Validated$Valid(a);
    }
  }
  if ((x217 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x216 = x217.Lcats_data_Validated$Invalid__f_e;
    if ((x218 instanceof $c_Lcats_data_Validated$Invalid)) {
      var x213 = x218.Lcats_data_Validated$Invalid__f_e;
      var e = EE.combine__O__O__O(x216, x213);
      return new $c_Lcats_data_Validated$Invalid(e);
    }
    return x217;
  }
  if ((x218 instanceof $c_Lcats_data_Validated$Invalid)) {
    return x218;
  }
  throw new $c_s_MatchError(x198);
});
$c_Lcats_data_Validated.prototype.map__F1__Lcats_data_Validated = (function(f) {
  if ((this instanceof $c_Lcats_data_Validated$Invalid)) {
    return this;
  }
  if ((this instanceof $c_Lcats_data_Validated$Valid)) {
    var x228 = this.Lcats_data_Validated$Valid__f_a;
    var a = f.apply__O__O(x228);
    return new $c_Lcats_data_Validated$Valid(a);
  }
  throw new $c_s_MatchError(this);
});
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9() {
}
export { $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9 as $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9 };
$c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype = new $h_O();
$c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9() {
}
export { $h_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9 as $h_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9 };
$h_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype = $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype;
$c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9.prototype.apply__O__O = (function(fa) {
  return fa;
});
var $d_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9 = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9, "cats.effect.kernel.MonadCancel$Uncancelable$$anon$9", ({
  Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9: 1,
  Ljava_io_Serializable: 1,
  Lcats_arrow_FunctionK: 1,
  Lcats_effect_kernel_Poll: 1
}));
export { $d_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9 as $d_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9 };
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__V(buf$1, f$4, lists) {
  var lists$tailLocal1 = lists;
  while (true) {
    var x6 = lists$tailLocal1;
    if ((x6 instanceof $c_sci_$colon$colon)) {
      var x11 = x6.sci_$colon$colon__f_head;
      var x12 = x6.sci_$colon$colon__f_next;
      if ((x11 instanceof $c_sci_$colon$colon)) {
        var x15 = x11.sci_$colon$colon__f_next;
        var ab = x11.sci_$colon$colon__f_head;
        if ((ab instanceof $c_s_util_Right)) {
          var b = ab.s_util_Right__f_value;
          buf$1.addOne__O__scm_Growable(b);
          lists$tailLocal1 = new $c_sci_$colon$colon(x15, x12);
          continue;
        }
        if ((ab instanceof $c_s_util_Left)) {
          var a = ab.s_util_Left__f_value;
          var elem$1 = f$4.apply__O__O(a);
          var this$1 = new $c_sci_$colon$colon(x15, x12);
          lists$tailLocal1 = new $c_sci_$colon$colon(elem$1, this$1);
          continue;
        }
        throw new $c_s_MatchError(ab);
      }
      var x = $m_sci_Nil$();
      if (x.equals__O__Z(x11)) {
        lists$tailLocal1 = x12;
        continue;
      }
    }
    var x$3 = $m_sci_Nil$();
    if (x$3.equals__O__Z(x6)) {
      return (void 0);
    }
    throw new $c_s_MatchError(x6);
  }
}
export { $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__V as $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__V };
function $ps_Lcats_instances_ListInstances__loop$2__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$1, f$6, as) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(as)) {
    return lb$1;
  }
  if ((as instanceof $c_sci_$colon$colon)) {
    var x23 = as.sci_$colon$colon__f_next;
    var h = as.sci_$colon$colon__f_head;
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $ps_Lcats_instances_ListInstances__loop$2__Lcats_Eval__F2__sci_List__Lcats_Eval(lb$1, f$6, x23)));
    return f$6.apply__O__O__O(h, new $c_Lcats_Eval$$anon$5(a));
  }
  throw new $c_s_MatchError(as);
}
export { $ps_Lcats_instances_ListInstances__loop$2__Lcats_Eval__F2__sci_List__Lcats_Eval as $ps_Lcats_instances_ListInstances__loop$2__Lcats_Eval__F2__sci_List__Lcats_Eval };
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G$4, f$12, size, fa) {
  if ((size > 1)) {
    var leftSize = ((size / 2) | 0);
    var rightSize = ((size - leftSize) | 0);
    matchResult7: {
      var \u03b41$___1;
      var \u03b41$___2;
      var x30 = fa.splitAt__I__T2(leftSize);
      if ((x30 !== null)) {
        var leftL = x30._1__O();
        var rightL = x30._2__O();
        var \u03b41$___1 = leftL;
        var \u03b41$___2 = rightL;
        break matchResult7;
      }
      throw new $c_s_MatchError(x30);
    }
    var leftL$2 = \u03b41$___1;
    var rightL$2 = \u03b41$___2;
    return $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G$4, f$12, leftSize, leftL$2).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((left) => {
      var right = $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G$4, f$12, rightSize, rightL$2);
      return G$4.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(left, right, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$6, _$7) => (void 0))));
    })));
  } else {
    var a = fa.head__O();
    $m_Lcats_Eval$();
    var a$1 = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      var gb = f$12.apply__O__O(a);
      return G$4.void__O__O(gb);
    }));
    return new $c_Lcats_Always(a$1);
  }
}
export { $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval as $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval };
function $ps_Lcats_instances_ListInstances__step$1__Lcats_Monad__F2__T2__O(G$6, f$18, in$1) {
  if ((in$1 !== null)) {
    var x65 = in$1._1__O();
    var x66 = in$1._2__O();
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x65)) {
      return G$6.pure__O__O(new $c_s_util_Right(x66));
    }
    if ((x65 instanceof $c_sci_$colon$colon)) {
      var x64 = x65.sci_$colon$colon__f_next;
      var a = x65.sci_$colon$colon__f_head;
      return G$6.map__O__F1__O(f$18.apply__O__O__O(x66, a), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((bnext) => {
        var value = $ct_T2__O__O__(new $c_T2(), x64, bnext);
        return new $c_s_util_Left(value);
      })));
    }
  }
  throw new $c_s_MatchError(in$1);
}
export { $ps_Lcats_instances_ListInstances__step$1__Lcats_Monad__F2__T2__O as $ps_Lcats_instances_ListInstances__step$1__Lcats_Monad__F2__T2__O };
function $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$build$1__sci_List__sci_List__sci_List(fa, acc) {
  var acc$tailLocal1 = acc;
  var fa$tailLocal2 = fa;
  while (true) {
    if (fa$tailLocal2.isEmpty__Z()) {
      return acc$tailLocal1;
    } else {
      var fa$tailLocal2$tmp1 = fa$tailLocal2.tail__O();
      var this$1 = acc$tailLocal1;
      var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon((void 0), this$1);
      fa$tailLocal2 = fa$tailLocal2$tmp1;
      acc$tailLocal1 = acc$tailLocal1$tmp1;
    }
  }
}
export { $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$build$1__sci_List__sci_List__sci_List as $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$build$1__sci_List__sci_List__sci_List };
/** @constructor */
function $c_Lcats_instances_ListInstancesBinCompat0$$anon$6() {
  $m_Lcats_instances_package$list$();
}
export { $c_Lcats_instances_ListInstancesBinCompat0$$anon$6 as $c_Lcats_instances_ListInstancesBinCompat0$$anon$6 };
$c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype = new $h_O();
$c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype.constructor = $c_Lcats_instances_ListInstancesBinCompat0$$anon$6;
/** @constructor */
function $h_Lcats_instances_ListInstancesBinCompat0$$anon$6() {
}
export { $h_Lcats_instances_ListInstancesBinCompat0$$anon$6 as $h_Lcats_instances_ListInstancesBinCompat0$$anon$6 };
$h_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype = $c_Lcats_instances_ListInstancesBinCompat0$$anon$6.prototype;
var $d_Lcats_instances_ListInstancesBinCompat0$$anon$6 = new $TypeData().initClass($c_Lcats_instances_ListInstancesBinCompat0$$anon$6, "cats.instances.ListInstancesBinCompat0$$anon$6", ({
  Lcats_instances_ListInstancesBinCompat0$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
export { $d_Lcats_instances_ListInstancesBinCompat0$$anon$6 as $d_Lcats_instances_ListInstancesBinCompat0$$anon$6 };
function $f_Lcats_instances_SeqInstances__$init$__V($thiz) {
  $thiz.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V(new $c_Lcats_instances_SeqInstances$$anon$1());
  $thiz.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V(new $c_Lcats_instances_SeqInstances$$anon$2());
}
export { $f_Lcats_instances_SeqInstances__$init$__V as $f_Lcats_instances_SeqInstances__$init$__V };
/** @constructor */
function $c_Lcats_instances_SeqInstances$$anon$2() {
  $m_Lcats_instances_package$seq$();
}
export { $c_Lcats_instances_SeqInstances$$anon$2 as $c_Lcats_instances_SeqInstances$$anon$2 };
$c_Lcats_instances_SeqInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_SeqInstances$$anon$2.prototype.constructor = $c_Lcats_instances_SeqInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_SeqInstances$$anon$2() {
}
export { $h_Lcats_instances_SeqInstances$$anon$2 as $h_Lcats_instances_SeqInstances$$anon$2 };
$h_Lcats_instances_SeqInstances$$anon$2.prototype = $c_Lcats_instances_SeqInstances$$anon$2.prototype;
var $d_Lcats_instances_SeqInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_SeqInstances$$anon$2, "cats.instances.SeqInstances$$anon$2", ({
  Lcats_instances_SeqInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
export { $d_Lcats_instances_SeqInstances$$anon$2 as $d_Lcats_instances_SeqInstances$$anon$2 };
function $ps_Lcats_instances_VectorInstances__loop$2__sci_Vector__F2__Lcats_Eval__I__Lcats_Eval(fa$2, f$5, lb$1, i) {
  if ((i < fa$2.length__I())) {
    var $x_1 = fa$2.apply__I__O(i);
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $ps_Lcats_instances_VectorInstances__loop$2__sci_Vector__F2__Lcats_Eval__I__Lcats_Eval(fa$2, f$5, lb$1, ((1 + i) | 0))));
    return f$5.apply__O__O__O($x_1, new $c_Lcats_Eval$$anon$5(a));
  } else {
    return lb$1;
  }
}
export { $ps_Lcats_instances_VectorInstances__loop$2__sci_Vector__F2__Lcats_Eval__I__Lcats_Eval as $ps_Lcats_instances_VectorInstances__loop$2__sci_Vector__F2__Lcats_Eval__I__Lcats_Eval };
function $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G$4, fa$7, f$10, size, idx) {
  if ((size > 1)) {
    var leftSize = ((size / 2) | 0);
    var rightSize = ((size - leftSize) | 0);
    return $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G$4, fa$7, f$10, leftSize, idx).flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((left) => {
      var right = $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G$4, fa$7, f$10, rightSize, ((idx + leftSize) | 0));
      return G$4.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(left, right, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$6, _$7) => (void 0))));
    })));
  } else {
    var a = fa$7.apply__I__O(idx);
    $m_Lcats_Eval$();
    var a$1 = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
      var gb = f$10.apply__O__O(a);
      return G$4.void__O__O(gb);
    }));
    return new $c_Lcats_Always(a$1);
  }
}
export { $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval as $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval };
/** @constructor */
function $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6() {
  $m_Lcats_instances_package$vector$();
}
export { $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6 as $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6 };
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype = new $h_O();
$c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype.constructor = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6;
/** @constructor */
function $h_Lcats_instances_VectorInstancesBinCompat0$$anon$6() {
}
export { $h_Lcats_instances_VectorInstancesBinCompat0$$anon$6 as $h_Lcats_instances_VectorInstancesBinCompat0$$anon$6 };
$h_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype = $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6.prototype;
var $d_Lcats_instances_VectorInstancesBinCompat0$$anon$6 = new $TypeData().initClass($c_Lcats_instances_VectorInstancesBinCompat0$$anon$6, "cats.instances.VectorInstancesBinCompat0$$anon$6", ({
  Lcats_instances_VectorInstancesBinCompat0$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_FunctorFilter: 1,
  Lcats_TraverseFilter: 1
}));
export { $d_Lcats_instances_VectorInstancesBinCompat0$$anon$6 as $d_Lcats_instances_VectorInstancesBinCompat0$$anon$6 };
function $ct_Lcats_kernel_Comparison__I__D__($thiz, toInt, toDouble) {
  return $thiz;
}
export { $ct_Lcats_kernel_Comparison__I__D__ as $ct_Lcats_kernel_Comparison__I__D__ };
/** @constructor */
function $c_Lcats_kernel_Comparison() {
}
export { $c_Lcats_kernel_Comparison as $c_Lcats_kernel_Comparison };
$c_Lcats_kernel_Comparison.prototype = new $h_O();
$c_Lcats_kernel_Comparison.prototype.constructor = $c_Lcats_kernel_Comparison;
/** @constructor */
function $h_Lcats_kernel_Comparison() {
}
export { $h_Lcats_kernel_Comparison as $h_Lcats_kernel_Comparison };
$h_Lcats_kernel_Comparison.prototype = $c_Lcats_kernel_Comparison.prototype;
$c_Lcats_kernel_Comparison.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lcats_kernel_Hash$$anon$3() {
}
export { $c_Lcats_kernel_Hash$$anon$3 as $c_Lcats_kernel_Hash$$anon$3 };
$c_Lcats_kernel_Hash$$anon$3.prototype = new $h_O();
$c_Lcats_kernel_Hash$$anon$3.prototype.constructor = $c_Lcats_kernel_Hash$$anon$3;
/** @constructor */
function $h_Lcats_kernel_Hash$$anon$3() {
}
export { $h_Lcats_kernel_Hash$$anon$3 as $h_Lcats_kernel_Hash$$anon$3 };
$h_Lcats_kernel_Hash$$anon$3.prototype = $c_Lcats_kernel_Hash$$anon$3.prototype;
$c_Lcats_kernel_Hash$$anon$3.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Eq__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Hash$$anon$3.prototype.hash__O__I = (function(x) {
  return $dp_hashCode__I(x);
});
$c_Lcats_kernel_Hash$$anon$3.prototype.eqv__O__O__Z = (function(x, y) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
});
var $d_Lcats_kernel_Hash$$anon$3 = new $TypeData().initClass($c_Lcats_kernel_Hash$$anon$3, "cats.kernel.Hash$$anon$3", ({
  Lcats_kernel_Hash$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_Hash: 1
}));
export { $d_Lcats_kernel_Hash$$anon$3 as $d_Lcats_kernel_Hash$$anon$3 };
function $f_Lcats_kernel_Order__partialCompare__O__O__D($thiz, x, y) {
  return $thiz.compare__O__O__I(x, y);
}
export { $f_Lcats_kernel_Order__partialCompare__O__O__D as $f_Lcats_kernel_Order__partialCompare__O__O__D };
function $f_Lcats_kernel_Order__eqv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0);
}
export { $f_Lcats_kernel_Order__eqv__O__O__Z as $f_Lcats_kernel_Order__eqv__O__O__Z };
function $f_Lcats_kernel_Order__neqv__O__O__Z($thiz, x, y) {
  return (!$thiz.eqv__O__O__Z(x, y));
}
export { $f_Lcats_kernel_Order__neqv__O__O__Z as $f_Lcats_kernel_Order__neqv__O__O__Z };
function $f_Lcats_kernel_Order__lt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) < 0);
}
export { $f_Lcats_kernel_Order__lt__O__O__Z as $f_Lcats_kernel_Order__lt__O__O__Z };
function $f_Lcats_kernel_Order__gt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) > 0);
}
export { $f_Lcats_kernel_Order__gt__O__O__Z as $f_Lcats_kernel_Order__gt__O__O__Z };
/** @constructor */
function $c_Lcats_kernel_PartialOrder$() {
}
export { $c_Lcats_kernel_PartialOrder$ as $c_Lcats_kernel_PartialOrder$ };
$c_Lcats_kernel_PartialOrder$.prototype = new $h_Lcats_kernel_PartialOrderFunctions();
$c_Lcats_kernel_PartialOrder$.prototype.constructor = $c_Lcats_kernel_PartialOrder$;
/** @constructor */
function $h_Lcats_kernel_PartialOrder$() {
}
export { $h_Lcats_kernel_PartialOrder$ as $h_Lcats_kernel_PartialOrder$ };
$h_Lcats_kernel_PartialOrder$.prototype = $c_Lcats_kernel_PartialOrder$.prototype;
var $d_Lcats_kernel_PartialOrder$ = new $TypeData().initClass($c_Lcats_kernel_PartialOrder$, "cats.kernel.PartialOrder$", ({
  Lcats_kernel_PartialOrder$: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  Lcats_kernel_PartialOrderToPartialOrderingConversion: 1
}));
export { $d_Lcats_kernel_PartialOrder$ as $d_Lcats_kernel_PartialOrder$ };
var $n_Lcats_kernel_PartialOrder$;
function $m_Lcats_kernel_PartialOrder$() {
  if ((!$n_Lcats_kernel_PartialOrder$)) {
    $n_Lcats_kernel_PartialOrder$ = new $c_Lcats_kernel_PartialOrder$();
  }
  return $n_Lcats_kernel_PartialOrder$;
}
export { $m_Lcats_kernel_PartialOrder$ as $m_Lcats_kernel_PartialOrder$ };
/** @constructor */
function $c_Lcats_kernel_instances_ListMonoid() {
}
export { $c_Lcats_kernel_instances_ListMonoid as $c_Lcats_kernel_instances_ListMonoid };
$c_Lcats_kernel_instances_ListMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_ListMonoid.prototype.constructor = $c_Lcats_kernel_instances_ListMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_ListMonoid() {
}
export { $h_Lcats_kernel_instances_ListMonoid as $h_Lcats_kernel_instances_ListMonoid };
$h_Lcats_kernel_instances_ListMonoid.prototype = $c_Lcats_kernel_instances_ListMonoid.prototype;
$c_Lcats_kernel_instances_ListMonoid.prototype.combineAll__sc_IterableOnce__sci_List = (function(xs) {
  return $m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O(new $c_scm_ListBuffer(), xs);
});
$c_Lcats_kernel_instances_ListMonoid.prototype.empty__O = (function() {
  return $m_sci_Nil$();
});
$c_Lcats_kernel_instances_ListMonoid.prototype.combine__O__O__O = (function(x, y) {
  return y.$colon$colon$colon__sci_List__sci_List(x);
});
$c_Lcats_kernel_instances_ListMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_List(as);
});
var $d_Lcats_kernel_instances_ListMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_ListMonoid, "cats.kernel.instances.ListMonoid", ({
  Lcats_kernel_instances_ListMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
export { $d_Lcats_kernel_instances_ListMonoid as $d_Lcats_kernel_instances_ListMonoid };
/** @constructor */
function $c_Lcats_kernel_instances_SeqMonoid() {
}
export { $c_Lcats_kernel_instances_SeqMonoid as $c_Lcats_kernel_instances_SeqMonoid };
$c_Lcats_kernel_instances_SeqMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_SeqMonoid.prototype.constructor = $c_Lcats_kernel_instances_SeqMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_SeqMonoid() {
}
export { $h_Lcats_kernel_instances_SeqMonoid as $h_Lcats_kernel_instances_SeqMonoid };
$h_Lcats_kernel_instances_SeqMonoid.prototype = $c_Lcats_kernel_instances_SeqMonoid.prototype;
$c_Lcats_kernel_instances_SeqMonoid.prototype.empty__O = (function() {
  return $m_sci_Seq$().empty__sc_SeqOps();
});
$c_Lcats_kernel_instances_SeqMonoid.prototype.combine__O__O__O = (function(x, y) {
  return x.appendedAll__sc_IterableOnce__O(y);
});
$c_Lcats_kernel_instances_SeqMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O($m_sci_Seq$().newBuilder__scm_Builder(), as);
});
var $d_Lcats_kernel_instances_SeqMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_SeqMonoid, "cats.kernel.instances.SeqMonoid", ({
  Lcats_kernel_instances_SeqMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
export { $d_Lcats_kernel_instances_SeqMonoid as $d_Lcats_kernel_instances_SeqMonoid };
/** @constructor */
function $c_Lcats_kernel_instances_StringMonoid() {
}
export { $c_Lcats_kernel_instances_StringMonoid as $c_Lcats_kernel_instances_StringMonoid };
$c_Lcats_kernel_instances_StringMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_StringMonoid.prototype.constructor = $c_Lcats_kernel_instances_StringMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_StringMonoid() {
}
export { $h_Lcats_kernel_instances_StringMonoid as $h_Lcats_kernel_instances_StringMonoid };
$h_Lcats_kernel_instances_StringMonoid.prototype = $c_Lcats_kernel_instances_StringMonoid.prototype;
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__T__T__T = (function(x, y) {
  return (("" + x) + y);
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combineAll__sc_IterableOnce__T = (function(xs) {
  var sb = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var this$1 = xs.iterator__sc_Iterator();
  while (this$1.hasNext__Z()) {
    var x0 = this$1.next__O();
    sb.append__T__scm_StringBuilder(x0);
  }
  return sb.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Lcats_kernel_instances_StringMonoid.prototype.empty__O = (function() {
  return "";
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__T__T__T(x, y);
});
$c_Lcats_kernel_instances_StringMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__T(as);
});
var $d_Lcats_kernel_instances_StringMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_StringMonoid, "cats.kernel.instances.StringMonoid", ({
  Lcats_kernel_instances_StringMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
export { $d_Lcats_kernel_instances_StringMonoid as $d_Lcats_kernel_instances_StringMonoid };
/** @constructor */
function $c_Lcats_kernel_instances_VectorMonoid() {
}
export { $c_Lcats_kernel_instances_VectorMonoid as $c_Lcats_kernel_instances_VectorMonoid };
$c_Lcats_kernel_instances_VectorMonoid.prototype = new $h_O();
$c_Lcats_kernel_instances_VectorMonoid.prototype.constructor = $c_Lcats_kernel_instances_VectorMonoid;
/** @constructor */
function $h_Lcats_kernel_instances_VectorMonoid() {
}
export { $h_Lcats_kernel_instances_VectorMonoid as $h_Lcats_kernel_instances_VectorMonoid };
$h_Lcats_kernel_instances_VectorMonoid.prototype = $c_Lcats_kernel_instances_VectorMonoid.prototype;
$c_Lcats_kernel_instances_VectorMonoid.prototype.combineAll__sc_IterableOnce__sci_Vector = (function(xs) {
  return $m_Lcats_kernel_instances_StaticMethods$().combineAllIterable__scm_Builder__sc_IterableOnce__O(($m_sci_Vector$(), new $c_sci_VectorBuilder()), xs);
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.empty__O = (function() {
  $m_sci_Vector$();
  return $m_sci_Vector0$();
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.combine__O__O__O = (function(x, y) {
  return x.appendedAll__sc_IterableOnce__sci_Vector(y);
});
$c_Lcats_kernel_instances_VectorMonoid.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return this.combineAll__sc_IterableOnce__sci_Vector(as);
});
var $d_Lcats_kernel_instances_VectorMonoid = new $TypeData().initClass($c_Lcats_kernel_instances_VectorMonoid, "cats.kernel.instances.VectorMonoid", ({
  Lcats_kernel_instances_VectorMonoid: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1
}));
export { $d_Lcats_kernel_instances_VectorMonoid as $d_Lcats_kernel_instances_VectorMonoid };
/** @constructor */
function $c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2(parentParam$2, onTryParam$1) {
  this.Lcom_raquo_airstream_common_InternalParentObserver$$anon$2__f_onTryParam$2 = null;
  this.Lcom_raquo_airstream_common_InternalParentObserver$$anon$2__f_parent = null;
  this.Lcom_raquo_airstream_common_InternalParentObserver$$anon$2__f_onTryParam$2 = onTryParam$1;
  this.Lcom_raquo_airstream_common_InternalParentObserver$$anon$2__f_parent = parentParam$2;
}
export { $c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2 as $c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2 };
$c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2.prototype = new $h_O();
$c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2.prototype.constructor = $c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2;
/** @constructor */
function $h_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2() {
}
export { $h_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2 as $h_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2 };
$h_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2.prototype = $c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2.prototype;
$c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  this.Lcom_raquo_airstream_common_InternalParentObserver$$anon$2__f_onTryParam$2.apply__O__O__O(nextValue, transaction);
});
var $d_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2 = new $TypeData().initClass($c_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2, "com.raquo.airstream.common.InternalParentObserver$$anon$2", ({
  Lcom_raquo_airstream_common_InternalParentObserver$$anon$2: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalParentObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1
}));
export { $d_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2 as $d_Lcom_raquo_airstream_common_InternalParentObserver$$anon$2 };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$$anon$10(observers$2) {
  this.Lcom_raquo_airstream_core_Observer$$anon$10__f_observers$1 = null;
  this.Lcom_raquo_airstream_core_Observer$$anon$10__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_core_Observer$$anon$10__f_observers$1 = observers$2;
  this.Lcom_raquo_airstream_core_Observer$$anon$10__f_maybeDisplayName = (void 0);
}
export { $c_Lcom_raquo_airstream_core_Observer$$anon$10 as $c_Lcom_raquo_airstream_core_Observer$$anon$10 };
$c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype.constructor = $c_Lcom_raquo_airstream_core_Observer$$anon$10;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$$anon$10() {
}
export { $h_Lcom_raquo_airstream_core_Observer$$anon$10 as $h_Lcom_raquo_airstream_core_Observer$$anon$10 };
$h_Lcom_raquo_airstream_core_Observer$$anon$10.prototype = $c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype;
$c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_core_Observer$$anon$10__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_core_Observer$$anon$10__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype.toObserver__Lcom_raquo_airstream_core_Observer = (function() {
  return this;
});
$c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype.onNext__O__V = (function(nextValue) {
  this.Lcom_raquo_airstream_core_Observer$$anon$10__f_observers$1.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => {
    _$5.onNext__O__V(nextValue);
  })));
});
$c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype.onError__jl_Throwable__V = (function(err) {
  this.Lcom_raquo_airstream_core_Observer$$anon$10__f_observers$1.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => {
    _$6.onError__jl_Throwable__V(err);
  })));
});
$c_Lcom_raquo_airstream_core_Observer$$anon$10.prototype.onTry__s_util_Try__V = (function(nextValue) {
  this.Lcom_raquo_airstream_core_Observer$$anon$10__f_observers$1.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$7) => {
    _$7.onTry__s_util_Try__V(nextValue);
  })));
});
var $d_Lcom_raquo_airstream_core_Observer$$anon$10 = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Observer$$anon$10, "com.raquo.airstream.core.Observer$$anon$10", ({
  Lcom_raquo_airstream_core_Observer$$anon$10: 1,
  Lcom_raquo_airstream_core_Sink: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_Observer: 1
}));
export { $d_Lcom_raquo_airstream_core_Observer$$anon$10 as $d_Lcom_raquo_airstream_core_Observer$$anon$10 };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$$anon$8(onNextParam$2, handleObserverErrors$3, onErrorParam$2) {
  this.Lcom_raquo_airstream_core_Observer$$anon$8__f_onNextParam$1 = null;
  this.Lcom_raquo_airstream_core_Observer$$anon$8__f_handleObserverErrors$1 = false;
  this.Lcom_raquo_airstream_core_Observer$$anon$8__f_onErrorParam$1 = null;
  this.Lcom_raquo_airstream_core_Observer$$anon$8__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_core_Observer$$anon$8__f_onNextParam$1 = onNextParam$2;
  this.Lcom_raquo_airstream_core_Observer$$anon$8__f_handleObserverErrors$1 = handleObserverErrors$3;
  this.Lcom_raquo_airstream_core_Observer$$anon$8__f_onErrorParam$1 = onErrorParam$2;
  this.Lcom_raquo_airstream_core_Observer$$anon$8__f_maybeDisplayName = (void 0);
}
export { $c_Lcom_raquo_airstream_core_Observer$$anon$8 as $c_Lcom_raquo_airstream_core_Observer$$anon$8 };
$c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype.constructor = $c_Lcom_raquo_airstream_core_Observer$$anon$8;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$$anon$8() {
}
export { $h_Lcom_raquo_airstream_core_Observer$$anon$8 as $h_Lcom_raquo_airstream_core_Observer$$anon$8 };
$h_Lcom_raquo_airstream_core_Observer$$anon$8.prototype = $c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype;
$c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_core_Observer$$anon$8__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_core_Observer$$anon$8__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype.toObserver__Lcom_raquo_airstream_core_Observer = (function() {
  return this;
});
$c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype.onNext__O__V = (function(nextValue) {
  try {
    this.Lcom_raquo_airstream_core_Observer$$anon$8__f_onNextParam$1.apply__O__O(nextValue);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if (this.Lcom_raquo_airstream_core_Observer$$anon$8__f_handleObserverErrors$1) {
      this.onError__jl_Throwable__V(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
    } else {
      $m_Lcom_raquo_airstream_core_AirstreamError$().sendUnhandledError__jl_Throwable__V(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
    }
  }
});
$c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype.onError__jl_Throwable__V = (function(error) {
  try {
    if (this.Lcom_raquo_airstream_core_Observer$$anon$8__f_onErrorParam$1.isDefinedAt__O__Z(error)) {
      this.Lcom_raquo_airstream_core_Observer$$anon$8__f_onErrorParam$1.apply__O__O(error);
    } else {
      $m_Lcom_raquo_airstream_core_AirstreamError$().sendUnhandledError__jl_Throwable__V(error);
    }
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    $m_Lcom_raquo_airstream_core_AirstreamError$().sendUnhandledError__jl_Throwable__V(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError(e$2, error));
  }
});
$c_Lcom_raquo_airstream_core_Observer$$anon$8.prototype.onTry__s_util_Try__V = (function(nextValue) {
  nextValue.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((error) => {
    this.onError__jl_Throwable__V(error);
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextValue$2) => {
    this.onNext__O__V(nextValue$2);
  })));
});
var $d_Lcom_raquo_airstream_core_Observer$$anon$8 = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Observer$$anon$8, "com.raquo.airstream.core.Observer$$anon$8", ({
  Lcom_raquo_airstream_core_Observer$$anon$8: 1,
  Lcom_raquo_airstream_core_Sink: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_Observer: 1
}));
export { $d_Lcom_raquo_airstream_core_Observer$$anon$8 as $d_Lcom_raquo_airstream_core_Observer$$anon$8 };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$$anon$9(onTryParam$2, handleObserverErrors$4) {
  this.Lcom_raquo_airstream_core_Observer$$anon$9__f_onTryParam$1 = null;
  this.Lcom_raquo_airstream_core_Observer$$anon$9__f_handleObserverErrors$2 = false;
  this.Lcom_raquo_airstream_core_Observer$$anon$9__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_core_Observer$$anon$9__f_onTryParam$1 = onTryParam$2;
  this.Lcom_raquo_airstream_core_Observer$$anon$9__f_handleObserverErrors$2 = handleObserverErrors$4;
  this.Lcom_raquo_airstream_core_Observer$$anon$9__f_maybeDisplayName = (void 0);
}
export { $c_Lcom_raquo_airstream_core_Observer$$anon$9 as $c_Lcom_raquo_airstream_core_Observer$$anon$9 };
$c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype = new $h_O();
$c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype.constructor = $c_Lcom_raquo_airstream_core_Observer$$anon$9;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$$anon$9() {
}
export { $h_Lcom_raquo_airstream_core_Observer$$anon$9 as $h_Lcom_raquo_airstream_core_Observer$$anon$9 };
$h_Lcom_raquo_airstream_core_Observer$$anon$9.prototype = $c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype;
$c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_core_Observer$$anon$9__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_core_Observer$$anon$9__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype.toObserver__Lcom_raquo_airstream_core_Observer = (function() {
  return this;
});
$c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype.onNext__O__V = (function(nextValue) {
  this.onTry__s_util_Try__V(new $c_s_util_Success(nextValue));
});
$c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype.onError__jl_Throwable__V = (function(error) {
  this.onTry__s_util_Try__V(new $c_s_util_Failure(error));
});
$c_Lcom_raquo_airstream_core_Observer$$anon$9.prototype.onTry__s_util_Try__V = (function(nextValue) {
  try {
    if (this.Lcom_raquo_airstream_core_Observer$$anon$9__f_onTryParam$1.isDefinedAt__O__Z(nextValue)) {
      this.Lcom_raquo_airstream_core_Observer$$anon$9__f_onTryParam$1.apply__O__O(nextValue);
    } else {
      nextValue.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((err) => {
        $m_Lcom_raquo_airstream_core_AirstreamError$().sendUnhandledError__jl_Throwable__V(err);
      })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => (void 0))));
    }
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ((this.Lcom_raquo_airstream_core_Observer$$anon$9__f_handleObserverErrors$2 && nextValue.isSuccess__Z())) {
      this.onError__jl_Throwable__V(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
    } else {
      nextValue.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((originalError) => {
        $m_Lcom_raquo_airstream_core_AirstreamError$().sendUnhandledError__jl_Throwable__V(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError(e$2, originalError));
      })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => {
        $m_Lcom_raquo_airstream_core_AirstreamError$().sendUnhandledError__jl_Throwable__V(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
      })));
    }
  }
});
var $d_Lcom_raquo_airstream_core_Observer$$anon$9 = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Observer$$anon$9, "com.raquo.airstream.core.Observer$$anon$9", ({
  Lcom_raquo_airstream_core_Observer$$anon$9: 1,
  Lcom_raquo_airstream_core_Sink: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_Observer: 1
}));
export { $d_Lcom_raquo_airstream_core_Observer$$anon$9 as $d_Lcom_raquo_airstream_core_Observer$$anon$9 };
/** @constructor */
function $c_Lcom_raquo_airstream_eventbus_WriteBus(parentDisplayName, displayNameSuffix) {
  this.Lcom_raquo_airstream_eventbus_WriteBus__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_eventbus_WriteBus__f_parentDisplayName = null;
  this.Lcom_raquo_airstream_eventbus_WriteBus__f_displayNameSuffix = null;
  this.Lcom_raquo_airstream_eventbus_WriteBus__f_stream = null;
  this.Lcom_raquo_airstream_eventbus_WriteBus__f_parentDisplayName = parentDisplayName;
  this.Lcom_raquo_airstream_eventbus_WriteBus__f_displayNameSuffix = displayNameSuffix;
  this.Lcom_raquo_airstream_eventbus_WriteBus__f_maybeDisplayName = (void 0);
  this.Lcom_raquo_airstream_eventbus_WriteBus__f_stream = new $c_Lcom_raquo_airstream_eventbus_EventBusStream(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $f_Lcom_raquo_airstream_core_Named__displayName__T(this))));
}
export { $c_Lcom_raquo_airstream_eventbus_WriteBus as $c_Lcom_raquo_airstream_eventbus_WriteBus };
$c_Lcom_raquo_airstream_eventbus_WriteBus.prototype = new $h_O();
$c_Lcom_raquo_airstream_eventbus_WriteBus.prototype.constructor = $c_Lcom_raquo_airstream_eventbus_WriteBus;
/** @constructor */
function $h_Lcom_raquo_airstream_eventbus_WriteBus() {
}
export { $h_Lcom_raquo_airstream_eventbus_WriteBus as $h_Lcom_raquo_airstream_eventbus_WriteBus };
$h_Lcom_raquo_airstream_eventbus_WriteBus.prototype = $c_Lcom_raquo_airstream_eventbus_WriteBus.prototype;
$c_Lcom_raquo_airstream_eventbus_WriteBus.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_eventbus_WriteBus__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_eventbus_WriteBus.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_eventbus_WriteBus__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_eventbus_WriteBus.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_eventbus_WriteBus.prototype.toObserver__Lcom_raquo_airstream_core_Observer = (function() {
  return this;
});
$c_Lcom_raquo_airstream_eventbus_WriteBus.prototype.onNext__O__V = (function(nextValue) {
  var this$1 = this.Lcom_raquo_airstream_eventbus_WriteBus__f_stream;
  if ($f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this$1)) {
    var observer = this.Lcom_raquo_airstream_eventbus_WriteBus__f_stream;
    observer.onNext__O__Lcom_raquo_airstream_core_Transaction__V(nextValue, null);
  }
});
$c_Lcom_raquo_airstream_eventbus_WriteBus.prototype.onError__jl_Throwable__V = (function(nextError) {
  var this$1 = this.Lcom_raquo_airstream_eventbus_WriteBus__f_stream;
  if ($f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this$1)) {
    var observer = this.Lcom_raquo_airstream_eventbus_WriteBus__f_stream;
    observer.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(nextError, null);
  }
});
$c_Lcom_raquo_airstream_eventbus_WriteBus.prototype.onTry__s_util_Try__V = (function(nextValue) {
  nextValue.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextError) => {
    this.onError__jl_Throwable__V(nextError);
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextValue$2) => {
    this.onNext__O__V(nextValue$2);
  })));
});
$c_Lcom_raquo_airstream_eventbus_WriteBus.prototype.defaultDisplayName__T = (function() {
  return (("" + this.Lcom_raquo_airstream_eventbus_WriteBus__f_parentDisplayName.apply__O()) + this.Lcom_raquo_airstream_eventbus_WriteBus__f_displayNameSuffix);
});
var $d_Lcom_raquo_airstream_eventbus_WriteBus = new $TypeData().initClass($c_Lcom_raquo_airstream_eventbus_WriteBus, "com.raquo.airstream.eventbus.WriteBus", ({
  Lcom_raquo_airstream_eventbus_WriteBus: 1,
  Lcom_raquo_airstream_core_Sink: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_Observer: 1
}));
export { $d_Lcom_raquo_airstream_eventbus_WriteBus as $d_Lcom_raquo_airstream_eventbus_WriteBus };
/** @constructor */
function $c_Lcom_raquo_laminar_inserters_DynamicInserter(initialContext, insertFn, hooks) {
  this.Lcom_raquo_laminar_inserters_DynamicInserter__f_initialContext = null;
  this.Lcom_raquo_laminar_inserters_DynamicInserter__f_insertFn = null;
  this.Lcom_raquo_laminar_inserters_DynamicInserter__f_hooks = null;
  this.Lcom_raquo_laminar_inserters_DynamicInserter__f_initialContext = initialContext;
  this.Lcom_raquo_laminar_inserters_DynamicInserter__f_insertFn = insertFn;
  this.Lcom_raquo_laminar_inserters_DynamicInserter__f_hooks = hooks;
}
export { $c_Lcom_raquo_laminar_inserters_DynamicInserter as $c_Lcom_raquo_laminar_inserters_DynamicInserter };
$c_Lcom_raquo_laminar_inserters_DynamicInserter.prototype = new $h_O();
$c_Lcom_raquo_laminar_inserters_DynamicInserter.prototype.constructor = $c_Lcom_raquo_laminar_inserters_DynamicInserter;
/** @constructor */
function $h_Lcom_raquo_laminar_inserters_DynamicInserter() {
}
export { $h_Lcom_raquo_laminar_inserters_DynamicInserter as $h_Lcom_raquo_laminar_inserters_DynamicInserter };
$h_Lcom_raquo_laminar_inserters_DynamicInserter.prototype = $c_Lcom_raquo_laminar_inserters_DynamicInserter.prototype;
$c_Lcom_raquo_laminar_inserters_DynamicInserter.prototype.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(element) {
  var this$1 = this.Lcom_raquo_laminar_inserters_DynamicInserter__f_initialContext;
  var insertContext = (this$1.isEmpty__Z() ? $m_Lcom_raquo_laminar_inserters_InsertContext$().reserveSpotContext__Lcom_raquo_laminar_nodes_ReactiveElement__O__Lcom_raquo_laminar_inserters_InsertContext(element, this.Lcom_raquo_laminar_inserters_DynamicInserter__f_hooks) : this$1.get__O());
  var subscribe = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((mountContext) => this.Lcom_raquo_laminar_inserters_DynamicInserter__f_insertFn.apply__O__O__O__O(insertContext, mountContext.Lcom_raquo_laminar_lifecycle_MountContext__f_owner, this.Lcom_raquo_laminar_inserters_DynamicInserter__f_hooks)));
  return $m_Lcom_raquo_airstream_ownership_DynamicSubscription$().unsafe__Lcom_raquo_airstream_ownership_DynamicOwner__F1__Z__Lcom_raquo_airstream_ownership_DynamicSubscription(element.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner(), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((owner) => subscribe.apply__O__O(new $c_Lcom_raquo_laminar_lifecycle_MountContext(element, owner)))), false);
});
$c_Lcom_raquo_laminar_inserters_DynamicInserter.prototype.subscribe__Lcom_raquo_laminar_inserters_InsertContext__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription = (function(insertContext, owner) {
  return this.Lcom_raquo_laminar_inserters_DynamicInserter__f_insertFn.apply__O__O__O__O(insertContext, owner, this.Lcom_raquo_laminar_inserters_DynamicInserter__f_hooks);
});
$c_Lcom_raquo_laminar_inserters_DynamicInserter.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(element) {
  this.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Lcom_raquo_airstream_ownership_DynamicSubscription(element);
});
$c_Lcom_raquo_laminar_inserters_DynamicInserter.prototype.withContext__Lcom_raquo_laminar_inserters_InsertContext__Lcom_raquo_laminar_inserters_DynamicInserter = (function(context) {
  return new $c_Lcom_raquo_laminar_inserters_DynamicInserter(new $c_s_Some(context), this.Lcom_raquo_laminar_inserters_DynamicInserter__f_insertFn, this.Lcom_raquo_laminar_inserters_DynamicInserter__f_hooks);
});
function $isArrayOf_Lcom_raquo_laminar_inserters_DynamicInserter(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_laminar_inserters_DynamicInserter)));
}
export { $isArrayOf_Lcom_raquo_laminar_inserters_DynamicInserter as $isArrayOf_Lcom_raquo_laminar_inserters_DynamicInserter };
var $d_Lcom_raquo_laminar_inserters_DynamicInserter = new $TypeData().initClass($c_Lcom_raquo_laminar_inserters_DynamicInserter, "com.raquo.laminar.inserters.DynamicInserter", ({
  Lcom_raquo_laminar_inserters_DynamicInserter: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_inserters_Inserter: 1,
  Lcom_raquo_laminar_inserters_Hookable: 1
}));
export { $d_Lcom_raquo_laminar_inserters_DynamicInserter as $d_Lcom_raquo_laminar_inserters_DynamicInserter };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_AriaAttr(suffix, codec) {
  this.Lcom_raquo_laminar_keys_GlobalAttr__f_namespaceUri = null;
  this.Lcom_raquo_laminar_keys_GlobalAttr__f_name = null;
  this.Lcom_raquo_laminar_keys_GlobalAttr__f_codec = null;
  this.Lcom_raquo_laminar_keys_AriaAttr__f_codec = null;
  this.Lcom_raquo_laminar_keys_AriaAttr__f_codec = codec;
  $ct_Lcom_raquo_laminar_keys_GlobalAttr__T__Lcom_raquo_laminar_codecs_Codec__(this, ("aria-" + suffix), codec);
}
export { $c_Lcom_raquo_laminar_keys_AriaAttr as $c_Lcom_raquo_laminar_keys_AriaAttr };
$c_Lcom_raquo_laminar_keys_AriaAttr.prototype = new $h_Lcom_raquo_laminar_keys_GlobalAttr();
$c_Lcom_raquo_laminar_keys_AriaAttr.prototype.constructor = $c_Lcom_raquo_laminar_keys_AriaAttr;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_AriaAttr() {
}
export { $h_Lcom_raquo_laminar_keys_AriaAttr as $h_Lcom_raquo_laminar_keys_AriaAttr };
$h_Lcom_raquo_laminar_keys_AriaAttr.prototype = $c_Lcom_raquo_laminar_keys_AriaAttr.prototype;
$c_Lcom_raquo_laminar_keys_AriaAttr.prototype.codec__Lcom_raquo_laminar_codecs_Codec = (function() {
  return this.Lcom_raquo_laminar_keys_AriaAttr__f_codec;
});
var $d_Lcom_raquo_laminar_keys_AriaAttr = new $TypeData().initClass($c_Lcom_raquo_laminar_keys_AriaAttr, "com.raquo.laminar.keys.AriaAttr", ({
  Lcom_raquo_laminar_keys_AriaAttr: 1,
  Lcom_raquo_laminar_keys_GlobalAttr: 1,
  Lcom_raquo_laminar_keys_SimpleKey: 1,
  Lcom_raquo_laminar_keys_SimpleAttr: 1
}));
export { $d_Lcom_raquo_laminar_keys_AriaAttr as $d_Lcom_raquo_laminar_keys_AriaAttr };
/** @constructor */
function $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1(key$1, value$1, setOrRemoveF$1) {
  this.Lcom_raquo_laminar_modifiers_SimpleKeySetter__f_set = null;
  $ct_Lcom_raquo_laminar_modifiers_SimpleKeySetter__Lcom_raquo_laminar_keys_SimpleKey__O__F1__F1__(this, key$1, value$1, $m_Lcom_raquo_laminar_modifiers_SimpleKeySetter$().com$raquo$laminar$modifiers$SimpleKeySetter$$$_$$anon$superArg$1$1__F3__Lcom_raquo_laminar_keys_SimpleKey__O__F1(setOrRemoveF$1, key$1, value$1), $m_Lcom_raquo_laminar_modifiers_SimpleKeySetter$().com$raquo$laminar$modifiers$SimpleKeySetter$$$_$$anon$superArg$2$1__F3__Lcom_raquo_laminar_keys_SimpleKey__F1(setOrRemoveF$1, key$1));
}
export { $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1 as $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1 };
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1.prototype = new $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter();
$c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1.prototype.constructor = $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1() {
}
export { $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1 as $h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1 };
$h_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1.prototype = $c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1.prototype;
var $d_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1, "com.raquo.laminar.modifiers.SimpleKeySetter$$anon$1", ({
  Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1: 1,
  Lcom_raquo_laminar_modifiers_SimpleKeySetter: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_modifiers_Setter: 1
}));
export { $d_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1 as $d_Lcom_raquo_laminar_modifiers_SimpleKeySetter$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_CommentNode(initialText) {
  this.Lcom_raquo_laminar_nodes_CommentNode__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = null;
  this.Lcom_raquo_laminar_nodes_CommentNode__f_ref = null;
  this.Lcom_raquo_laminar_nodes_CommentNode__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = $m_s_None$();
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  this.Lcom_raquo_laminar_nodes_CommentNode__f_ref = $f_Lcom_raquo_laminar_domapi_DomTags__createCommentNode__T__Lorg_scalajs_dom_Comment(this$1, initialText);
}
export { $c_Lcom_raquo_laminar_nodes_CommentNode as $c_Lcom_raquo_laminar_nodes_CommentNode };
$c_Lcom_raquo_laminar_nodes_CommentNode.prototype = new $h_O();
$c_Lcom_raquo_laminar_nodes_CommentNode.prototype.constructor = $c_Lcom_raquo_laminar_nodes_CommentNode;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_CommentNode() {
}
export { $h_Lcom_raquo_laminar_nodes_CommentNode as $h_Lcom_raquo_laminar_nodes_CommentNode };
$h_Lcom_raquo_laminar_nodes_CommentNode.prototype = $c_Lcom_raquo_laminar_nodes_CommentNode.prototype;
$c_Lcom_raquo_laminar_nodes_CommentNode.prototype.com$raquo$laminar$nodes$ChildNode$$_maybeParent__s_Option = (function() {
  return this.Lcom_raquo_laminar_nodes_CommentNode__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent;
});
$c_Lcom_raquo_laminar_nodes_CommentNode.prototype.setParent__s_Option__V = (function(maybeNextParent) {
  this.Lcom_raquo_laminar_nodes_CommentNode__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = maybeNextParent;
});
$c_Lcom_raquo_laminar_nodes_CommentNode.prototype.willSetParent__s_Option__V = (function(maybeNextParent) {
});
$c_Lcom_raquo_laminar_nodes_CommentNode.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(parentNode) {
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  $f_Lcom_raquo_laminar_domapi_DomTree__appendChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$1, parentNode, this, (void 0));
});
$c_Lcom_raquo_laminar_nodes_CommentNode.prototype.ref__Lorg_scalajs_dom_Node = (function() {
  return this.Lcom_raquo_laminar_nodes_CommentNode__f_ref;
});
var $d_Lcom_raquo_laminar_nodes_CommentNode = new $TypeData().initClass($c_Lcom_raquo_laminar_nodes_CommentNode, "com.raquo.laminar.nodes.CommentNode", ({
  Lcom_raquo_laminar_nodes_CommentNode: 1,
  Lcom_raquo_laminar_nodes_ReactiveNode: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_nodes_ChildNode: 1
}));
export { $d_Lcom_raquo_laminar_nodes_CommentNode as $d_Lcom_raquo_laminar_nodes_CommentNode };
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_TextNode(initialText) {
  this.Lcom_raquo_laminar_nodes_TextNode__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = null;
  this.Lcom_raquo_laminar_nodes_TextNode__f_ref = null;
  this.Lcom_raquo_laminar_nodes_TextNode__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = $m_s_None$();
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  this.Lcom_raquo_laminar_nodes_TextNode__f_ref = $f_Lcom_raquo_laminar_domapi_DomTags__createTextNode__T__Lorg_scalajs_dom_Text(this$1, initialText);
}
export { $c_Lcom_raquo_laminar_nodes_TextNode as $c_Lcom_raquo_laminar_nodes_TextNode };
$c_Lcom_raquo_laminar_nodes_TextNode.prototype = new $h_O();
$c_Lcom_raquo_laminar_nodes_TextNode.prototype.constructor = $c_Lcom_raquo_laminar_nodes_TextNode;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_TextNode() {
}
export { $h_Lcom_raquo_laminar_nodes_TextNode as $h_Lcom_raquo_laminar_nodes_TextNode };
$h_Lcom_raquo_laminar_nodes_TextNode.prototype = $c_Lcom_raquo_laminar_nodes_TextNode.prototype;
$c_Lcom_raquo_laminar_nodes_TextNode.prototype.com$raquo$laminar$nodes$ChildNode$$_maybeParent__s_Option = (function() {
  return this.Lcom_raquo_laminar_nodes_TextNode__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent;
});
$c_Lcom_raquo_laminar_nodes_TextNode.prototype.setParent__s_Option__V = (function(maybeNextParent) {
  this.Lcom_raquo_laminar_nodes_TextNode__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = maybeNextParent;
});
$c_Lcom_raquo_laminar_nodes_TextNode.prototype.willSetParent__s_Option__V = (function(maybeNextParent) {
});
$c_Lcom_raquo_laminar_nodes_TextNode.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(parentNode) {
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  $f_Lcom_raquo_laminar_domapi_DomTree__appendChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$1, parentNode, this, (void 0));
});
$c_Lcom_raquo_laminar_nodes_TextNode.prototype.text__T = (function() {
  return this.Lcom_raquo_laminar_nodes_TextNode__f_ref.data;
});
$c_Lcom_raquo_laminar_nodes_TextNode.prototype.ref__Lorg_scalajs_dom_Node = (function() {
  return this.Lcom_raquo_laminar_nodes_TextNode__f_ref;
});
var $d_Lcom_raquo_laminar_nodes_TextNode = new $TypeData().initClass($c_Lcom_raquo_laminar_nodes_TextNode, "com.raquo.laminar.nodes.TextNode", ({
  Lcom_raquo_laminar_nodes_TextNode: 1,
  Lcom_raquo_laminar_nodes_ReactiveNode: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_nodes_ChildNode: 1
}));
export { $d_Lcom_raquo_laminar_nodes_TextNode as $d_Lcom_raquo_laminar_nodes_TextNode };
/** @constructor */
function $c_Lframework_components_TextKindFor(textKind) {
  this.Lframework_components_TextKindFor__f_textKind = null;
  this.Lframework_components_TextKindFor__f_textKind = textKind;
}
export { $c_Lframework_components_TextKindFor as $c_Lframework_components_TextKindFor };
$c_Lframework_components_TextKindFor.prototype = new $h_O();
$c_Lframework_components_TextKindFor.prototype.constructor = $c_Lframework_components_TextKindFor;
/** @constructor */
function $h_Lframework_components_TextKindFor() {
}
export { $h_Lframework_components_TextKindFor as $h_Lframework_components_TextKindFor };
$h_Lframework_components_TextKindFor.prototype = $c_Lframework_components_TextKindFor.prototype;
$c_Lframework_components_TextKindFor.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lframework_components_TextKindFor.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 623309034, true);
});
$c_Lframework_components_TextKindFor.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_components_TextKindFor)) {
    var x = this.Lframework_components_TextKindFor__f_textKind;
    var x$2 = x$0.Lframework_components_TextKindFor__f_textKind;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_Lframework_components_TextKindFor.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_components_TextKindFor.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_components_TextKindFor.prototype.productPrefix__T = (function() {
  return "TextKindFor";
});
$c_Lframework_components_TextKindFor.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_components_TextKindFor__f_textKind;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_components_TextKindFor.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "textKind";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lframework_components_TextKindFor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_components_TextKindFor)));
}
export { $isArrayOf_Lframework_components_TextKindFor as $isArrayOf_Lframework_components_TextKindFor };
var $d_Lframework_components_TextKindFor = new $TypeData().initClass($c_Lframework_components_TextKindFor, "framework.components.TextKindFor", ({
  Lframework_components_TextKindFor: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_components_TextKindFor as $d_Lframework_components_TextKindFor };
/** @constructor */
function $c_Lframework_data_Base64Id(bytes) {
  this.Lframework_data_Base64Id__f_bytes = null;
  this.Lframework_data_Base64Id__f_asString$lzy1 = null;
  this.Lframework_data_Base64Id__f_asStringbitmap$1 = false;
  this.Lframework_data_Base64Id__f_bytes = bytes;
}
export { $c_Lframework_data_Base64Id as $c_Lframework_data_Base64Id };
$c_Lframework_data_Base64Id.prototype = new $h_O();
$c_Lframework_data_Base64Id.prototype.constructor = $c_Lframework_data_Base64Id;
/** @constructor */
function $h_Lframework_data_Base64Id() {
}
export { $h_Lframework_data_Base64Id as $h_Lframework_data_Base64Id };
$h_Lframework_data_Base64Id.prototype = $c_Lframework_data_Base64Id.prototype;
$c_Lframework_data_Base64Id.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lframework_data_Base64Id.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-364544137), true);
});
$c_Lframework_data_Base64Id.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_Base64Id.prototype.productPrefix__T = (function() {
  return "Base64Id";
});
$c_Lframework_data_Base64Id.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_Base64Id__f_bytes;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_Base64Id.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "bytes";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_Base64Id.prototype.toString__T = (function() {
  var target = this.asString__T();
  var tc = $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString;
  var this$3 = new $c_Lcats_Show$ToShowOps$$anon$3(target, tc);
  return (("Base64Id(" + this$3.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance.show__O__T(this$3.Lcats_Show$ToShowOps$$anon$3__f_self)) + ")");
});
$c_Lframework_data_Base64Id.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Lframework_data_Base64Id)) {
    var this$1 = $m_s_IArray$package$IArray$().wrapByteIArray__AB__sci_ArraySeq$ofByte(this.Lframework_data_Base64Id__f_bytes);
    var o = $m_s_IArray$package$IArray$().wrapByteIArray__AB__sci_ArraySeq$ofByte(obj.Lframework_data_Base64Id__f_bytes);
    return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this$1, o);
  } else {
    return false;
  }
});
$c_Lframework_data_Base64Id.prototype.asString__T = (function() {
  if ((!this.Lframework_data_Base64Id__f_asStringbitmap$1)) {
    var this$1 = $m_ju_Base64$();
    this.Lframework_data_Base64Id__f_asString$lzy1 = this$1.ju_Base64$__f_urlSafeEncoder.withoutPadding__ju_Base64$Encoder().encodeToString__AB__T($m_s_IArray$package$IArray$().wrapByteIArray__AB__sci_ArraySeq$ofByte(this.Lframework_data_Base64Id__f_bytes).sci_ArraySeq$ofByte__f_unsafeArray);
    this.Lframework_data_Base64Id__f_asStringbitmap$1 = true;
  }
  return this.Lframework_data_Base64Id__f_asString$lzy1;
});
function $isArrayOf_Lframework_data_Base64Id(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_Base64Id)));
}
export { $isArrayOf_Lframework_data_Base64Id as $isArrayOf_Lframework_data_Base64Id };
var $d_Lframework_data_Base64Id = new $TypeData().initClass($c_Lframework_data_Base64Id, "framework.data.Base64Id", ({
  Lframework_data_Base64Id: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_Base64Id as $d_Lframework_data_Base64Id };
/** @constructor */
function $c_Lframework_data_FrameworkDateTime$$anon$1() {
}
export { $c_Lframework_data_FrameworkDateTime$$anon$1 as $c_Lframework_data_FrameworkDateTime$$anon$1 };
$c_Lframework_data_FrameworkDateTime$$anon$1.prototype = new $h_O();
$c_Lframework_data_FrameworkDateTime$$anon$1.prototype.constructor = $c_Lframework_data_FrameworkDateTime$$anon$1;
/** @constructor */
function $h_Lframework_data_FrameworkDateTime$$anon$1() {
}
export { $h_Lframework_data_FrameworkDateTime$$anon$1 as $h_Lframework_data_FrameworkDateTime$$anon$1 };
$h_Lframework_data_FrameworkDateTime$$anon$1.prototype = $c_Lframework_data_FrameworkDateTime$$anon$1.prototype;
$c_Lframework_data_FrameworkDateTime$$anon$1.prototype.show__O__T = (function(t) {
  var _$7 = ((t === null) ? null : t.Lframework_data_FrameworkDateTime__f_ldt);
  $m_Lframework_data_FrameworkDateTime$();
  var formatter = $m_Lframework_data_FrameworkDateTime$().Lframework_data_FrameworkDateTime$__f_HumanReadableFormatter;
  return $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.format__Ljava_time_format_DateTimeFormatter__T.call(_$7, formatter);
});
var $d_Lframework_data_FrameworkDateTime$$anon$1 = new $TypeData().initClass($c_Lframework_data_FrameworkDateTime$$anon$1, "framework.data.FrameworkDateTime$$anon$1", ({
  Lframework_data_FrameworkDateTime$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_data_FrameworkDateTime$$anon$1 as $d_Lframework_data_FrameworkDateTime$$anon$1 };
/** @constructor */
function $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError(outer, value, error, formatter) {
  this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_value = null;
  this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_error = null;
  this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_formatter = null;
  this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_$outer = null;
  this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_value = value;
  this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_error = error;
  this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_formatter = formatter;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_$outer = outer;
}
export { $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError as $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError };
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype = new $h_O();
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype.constructor = $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError;
/** @constructor */
function $h_Lframework_data_FrameworkDateTime$Newtype$CannotParseError() {
}
export { $h_Lframework_data_FrameworkDateTime$Newtype$CannotParseError as $h_Lframework_data_FrameworkDateTime$Newtype$CannotParseError };
$h_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype = $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype;
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-89716435), true);
});
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError) && (x$0.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_$outer === this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_$outer))) {
    if (((this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_value === x$0.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_value) && (this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_error === x$0.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_error))) {
      var x = this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_formatter;
      var x$2 = x$0.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_formatter;
      return (x === x$2);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype.productArity__I = (function() {
  return 3;
});
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype.productPrefix__T = (function() {
  return "CannotParseError";
});
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_value;
      break;
    }
    case 1: {
      return this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_error;
      break;
    }
    case 2: {
      return this.Lframework_data_FrameworkDateTime$Newtype$CannotParseError__f_formatter;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "value";
      break;
    }
    case 1: {
      return "error";
      break;
    }
    case 2: {
      return "formatter";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lframework_data_FrameworkDateTime$Newtype$CannotParseError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_FrameworkDateTime$Newtype$CannotParseError)));
}
export { $isArrayOf_Lframework_data_FrameworkDateTime$Newtype$CannotParseError as $isArrayOf_Lframework_data_FrameworkDateTime$Newtype$CannotParseError };
var $d_Lframework_data_FrameworkDateTime$Newtype$CannotParseError = new $TypeData().initClass($c_Lframework_data_FrameworkDateTime$Newtype$CannotParseError, "framework.data.FrameworkDateTime$Newtype$CannotParseError", ({
  Lframework_data_FrameworkDateTime$Newtype$CannotParseError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_FrameworkDateTime$Newtype$CannotParseError as $d_Lframework_data_FrameworkDateTime$Newtype$CannotParseError };
/** @constructor */
function $c_Lframework_data_LengthIn(length) {
  this.Lframework_data_LengthIn__f_length = null;
  this.Lframework_data_LengthIn__f_length = length;
}
export { $c_Lframework_data_LengthIn as $c_Lframework_data_LengthIn };
$c_Lframework_data_LengthIn.prototype = new $h_O();
$c_Lframework_data_LengthIn.prototype.constructor = $c_Lframework_data_LengthIn;
/** @constructor */
function $h_Lframework_data_LengthIn() {
}
export { $h_Lframework_data_LengthIn as $h_Lframework_data_LengthIn };
$h_Lframework_data_LengthIn.prototype = $c_Lframework_data_LengthIn.prototype;
$c_Lframework_data_LengthIn.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lframework_data_LengthIn.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1967100935), true);
});
$c_Lframework_data_LengthIn.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_LengthIn)) {
    var x = this.Lframework_data_LengthIn__f_length;
    var x$2 = x$0.Lframework_data_LengthIn__f_length;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lframework_data_LengthIn.prototype.productArity__I = (function() {
  return 1;
});
$c_Lframework_data_LengthIn.prototype.productPrefix__T = (function() {
  return "LengthIn";
});
$c_Lframework_data_LengthIn.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_LengthIn__f_length;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_LengthIn.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "length";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_LengthIn.prototype.value__Lsquants_space_LengthUnit__D = (function(unit) {
  return this.Lframework_data_LengthIn__f_length.in__Lsquants_UnitOfMeasure__Lsquants_Quantity(unit).Lsquants_space_Length__f_value;
});
$c_Lframework_data_LengthIn.prototype.valueIn__Lsquants_space_LengthUnit__D = (function(unit) {
  return this.Lframework_data_LengthIn__f_length.in__Lsquants_UnitOfMeasure__Lsquants_Quantity(unit).Lsquants_space_Length__f_value;
});
$c_Lframework_data_LengthIn.prototype.toString__T = (function() {
  var this$1 = this.Lframework_data_LengthIn__f_length;
  return this$1.toString__Lsquants_UnitOfMeasure__T(this$1.Lsquants_space_Length__f_unit);
});
function $isArrayOf_Lframework_data_LengthIn(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_LengthIn)));
}
export { $isArrayOf_Lframework_data_LengthIn as $isArrayOf_Lframework_data_LengthIn };
var $d_Lframework_data_LengthIn = new $TypeData().initClass($c_Lframework_data_LengthIn, "framework.data.LengthIn", ({
  Lframework_data_LengthIn: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_LengthIn as $d_Lframework_data_LengthIn };
function $p_Lframework_data_PageCursor$$anon$14__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct($thiz, ctx) {
  var $x_10 = $m_s_IArray$package$IArray$();
  var arr = ctx.Lmagnolia1_CaseClass__f_parameters;
  var f = ((p) => {
    var annotations = $p_Lframework_data_PageCursor$$anon$14__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_annotations), $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_inheritedAnns$4));
    var pSchema = $p_Lframework_data_PageCursor$$anon$14__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, p.typeclass__O(), annotations);
    var this$2 = annotations.collectFirst__s_PartialFunction__s_Option(new $c_Lframework_data_PageCursor$$anon$16());
    var encodedName = (this$2.isEmpty__Z() ? $m_Lsttp_tapir_generic_Configuration$().Lsttp_tapir_generic_Configuration$__f_default.Lsttp_tapir_generic_Configuration__f_toEncodedName.apply__O__O(p.Lmagnolia1_CaseClass$Param$$anon$2__f_label) : this$2.get__O());
    var name = p.Lmagnolia1_CaseClass$Param$$anon$2__f_label;
    var _name = new $c_Lsttp_tapir_FieldName(name, encodedName);
    var _get = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p$3) => ((t) => {
      var value = p$3.deref__O__O(t);
      return new $c_s_Some(value);
    }))(p));
    return new $c_Lsttp_tapir_SchemaType$SProductField$$anon$1(_name, pSchema, _get);
  });
  var len = arr.u.length;
  var ys = new ($d_Lsttp_tapir_SchemaType$SProductField.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((arr !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = arr.u[i];
        ys.u[$x_1] = f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = arr.u[i];
        ys.u[$x_2] = f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = arr.u[i];
        ys.u[$x_3] = f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_J)) {
      while ((i < len)) {
        var $x_4 = i;
        var t$1 = arr.u[i];
        var lo = t$1.RTLong__f_lo;
        var hi = t$1.RTLong__f_hi;
        ys.u[$x_4] = f(new $c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_F)) {
      while ((i < len)) {
        var $x_5 = i;
        var x0$3 = arr.u[i];
        ys.u[$x_5] = f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_C)) {
      while ((i < len)) {
        var $x_6 = i;
        var x0$4 = arr.u[i];
        ys.u[$x_6] = f($bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_B)) {
      while ((i < len)) {
        var $x_7 = i;
        var x0$5 = arr.u[i];
        ys.u[$x_7] = f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_S)) {
      while ((i < len)) {
        var $x_8 = i;
        var x0$6 = arr.u[i];
        ys.u[$x_8] = f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_Z)) {
      while ((i < len)) {
        var $x_9 = i;
        var x0$7 = arr.u[i];
        ys.u[$x_9] = f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $c_s_MatchError(arr);
    }
  }
  var this$11 = $x_10.wrapRefArray__AO__sci_ArraySeq$ofRef(ys);
  var fields = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$11);
  return new $c_Lsttp_tapir_SchemaType$SProduct(fields);
}
export { $p_Lframework_data_PageCursor$$anon$14__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct as $p_Lframework_data_PageCursor$$anon$14__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct };
function $p_Lframework_data_PageCursor$$anon$14__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName($thiz, typeName, annotations) {
  var x105 = annotations.collectFirst__s_PartialFunction__s_Option(new $c_Lframework_data_PageCursor$$anon$15());
  if ((x105 instanceof $c_s_Some)) {
    var altName = x105.s_Some__f_value;
    $m_Lsttp_tapir_Schema$SName$();
    var typeParameterShortNames = $m_sci_Nil$();
    return new $c_Lsttp_tapir_Schema$SName(altName, typeParameterShortNames);
  }
  var x = $m_s_None$();
  if ((x === x105)) {
    $m_Lsttp_tapir_Schema$SName$();
    var fullName = typeName.full__T();
    var typeParameterShortNames$1 = $s_Lframework_data_PageCursor$__framework$data$PageCursor$$anon$14$$_$allTypeArguments$2__Lmagnolia1_TypeInfo__sci_Seq(typeName).map__F1__O(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => _$1.full__T()))).toList__sci_List();
    return new $c_Lsttp_tapir_Schema$SName(fullName, typeParameterShortNames$1);
  }
  throw new $c_s_MatchError(x105);
}
export { $p_Lframework_data_PageCursor$$anon$14__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName as $p_Lframework_data_PageCursor$$anon$14__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName };
function $p_Lframework_data_PageCursor$$anon$14__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, schema, annotations) {
  return annotations.foldLeft__O__F2__O(schema, new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$1, x$2) => {
    if (false) {
      return x$1.description__T__Lsttp_tapir_Schema(x$2.text__T());
    } else if (false) {
      return x$1.encodedExample__O__Lsttp_tapir_Schema(x$2.example__O());
    } else if (false) {
      return x$1.default__O__s_Option__Lsttp_tapir_Schema(x$2.default__O(), x$2.encoded__s_Option());
    } else if (false) {
      return x$1.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(x$2.v__Lsttp_tapir_Validator());
    } else if (false) {
      var fields = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_ModifyCollectionElements]));
      var modify = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((ann$6) => ((_$2) => _$2.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(ann$6.v__Lsttp_tapir_Validator())))(x$2));
      return $p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(x$1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(fields), modify);
    } else if (false) {
      return x$1.format__T__Lsttp_tapir_Schema(x$2.format__T());
    } else if (false) {
      return x$1.title__T__Lsttp_tapir_Schema(x$2.name__T());
    } else if (false) {
      var schemaType = x$1.Lsttp_tapir_Schema__f_schemaType;
      var name = x$1.Lsttp_tapir_Schema__f_name;
      var isOptional = x$1.Lsttp_tapir_Schema__f_isOptional;
      var description = x$1.Lsttp_tapir_Schema__f_description;
      var default$1 = x$1.Lsttp_tapir_Schema__f_default;
      var format = x$1.Lsttp_tapir_Schema__f_format;
      var encodedExample = x$1.Lsttp_tapir_Schema__f_encodedExample;
      var hidden = x$1.Lsttp_tapir_Schema__f_hidden;
      var validator = x$1.Lsttp_tapir_Schema__f_validator;
      var attributes = x$1.Lsttp_tapir_Schema__f_attributes;
      return new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, true, hidden, validator, attributes);
    } else {
      return (false ? x$2.f__F1().apply__O__O(x$1) : x$1);
    }
  })));
}
export { $p_Lframework_data_PageCursor$$anon$14__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema as $p_Lframework_data_PageCursor$$anon$14__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema };
function $p_Lframework_data_PageCursor$$anon$14__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, primary, inherited) {
  var suffix = inherited.distinct__O().filter__F1__O(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => (!primary.exists__F1__Z(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => {
    var this$1 = $objectGetClass(_$3);
    var that = $objectGetClass(x$1);
    return (this$1 === that);
  })))))));
  return primary.appendedAll__sc_IterableOnce__O(suffix);
}
export { $p_Lframework_data_PageCursor$$anon$14__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq as $p_Lframework_data_PageCursor$$anon$14__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq };
/** @constructor */
function $c_Lframework_data_PageCursor$$anon$14(SchemaMagnoliaDerivation_this$4) {
  this.Lframework_data_PageCursor$$anon$14__f_SchemaMagnoliaDerivation_this$2 = null;
  this.Lframework_data_PageCursor$$anon$14__f_SchemaMagnoliaDerivation_this$2 = SchemaMagnoliaDerivation_this$4;
}
export { $c_Lframework_data_PageCursor$$anon$14 as $c_Lframework_data_PageCursor$$anon$14 };
$c_Lframework_data_PageCursor$$anon$14.prototype = new $h_O();
$c_Lframework_data_PageCursor$$anon$14.prototype.constructor = $c_Lframework_data_PageCursor$$anon$14;
/** @constructor */
function $h_Lframework_data_PageCursor$$anon$14() {
}
export { $h_Lframework_data_PageCursor$$anon$14 as $h_Lframework_data_PageCursor$$anon$14 };
$h_Lframework_data_PageCursor$$anon$14.prototype = $c_Lframework_data_PageCursor$$anon$14.prototype;
$c_Lframework_data_PageCursor$$anon$14.prototype.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema = (function(ctx) {
  var typeName = ctx.Lmagnolia1_CaseClass__f_typeInfo;
  var annotations = $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations);
  var cacheKey = typeName.full__T();
  var inProgressOrNull = $m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.get__O();
  var newCache = (inProgressOrNull === null);
  if (newCache) {
    var newInProgress = $m_scm_Set$().apply__sci_Seq__O($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([])));
    $m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.set__O__V(newInProgress);
    var inProgress = newInProgress;
  } else {
    if ((inProgressOrNull === null)) {
      $m_sr_Scala3RunTime$().nnFail__E();
    }
    var inProgress = inProgressOrNull;
  }
  if (inProgress.contains__O__Z(cacheKey)) {
    $m_Lsttp_tapir_Schema$();
    var name = $p_Lframework_data_PageCursor$$anon$14__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, typeName, annotations);
    var schemaType = new $c_Lsttp_tapir_SchemaType$SRef(name);
    $m_Lsttp_tapir_Schema$();
    var name$1 = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $m_Lsttp_tapir_Schema$();
    var description = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var default$1 = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var format = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var encodedExample = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $m_Lsttp_tapir_Schema$();
    var hidden = false;
    $m_Lsttp_tapir_Schema$();
    var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $m_Lsttp_tapir_Schema$();
    var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    return new $c_Lsttp_tapir_Schema(schemaType, name$1, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  } else {
    try {
      inProgress.add__O__Z(cacheKey);
      if (ctx.Lmagnolia1_CaseClass__f_isValueClass) {
        var requirement = $m_s_IArray$package$IArray$().nonEmpty__O__Z(ctx.Lmagnolia1_CaseClass__f_parameters);
        if ((!requirement)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "Cannot derive schema for generic value class: ") + ctx.Lmagnolia1_CaseClass__f_typeInfo.Lmagnolia1_TypeInfo__f_owner));
        }
        var valueSchema = $m_s_IArray$package$IArray$().head__O__O(ctx.Lmagnolia1_CaseClass__f_parameters).typeclass__O();
        var schemaType$1 = valueSchema.Lsttp_tapir_Schema__f_schemaType;
        $m_Lsttp_tapir_Schema$();
        var name$1$1 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var isOptional$1 = false;
        $m_Lsttp_tapir_Schema$();
        var description$1 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var default$1$1 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var encodedExample$1 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var deprecated$1 = false;
        $m_Lsttp_tapir_Schema$();
        var hidden$1 = false;
        $m_Lsttp_tapir_Schema$();
        var validator$1 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $m_Lsttp_tapir_Schema$();
        var attributes$1 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        $m_Lsttp_tapir_Schema$();
        var format$1 = valueSchema.Lsttp_tapir_Schema__f_format;
        var result = new $c_Lsttp_tapir_Schema(schemaType$1, name$1$1, isOptional$1, description$1, default$1$1, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
      } else {
        $m_Lsttp_tapir_Schema$();
        var schemaType$2 = $p_Lframework_data_PageCursor$$anon$14__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct(this, ctx);
        var value = $p_Lframework_data_PageCursor$$anon$14__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, ctx.Lmagnolia1_CaseClass__f_typeInfo, $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations));
        var name$2 = new $c_s_Some(value);
        $m_Lsttp_tapir_Schema$();
        var isOptional$2 = false;
        $m_Lsttp_tapir_Schema$();
        var description$2 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var default$2 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var format$2 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var encodedExample$2 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var deprecated$2 = false;
        $m_Lsttp_tapir_Schema$();
        var hidden$2 = false;
        $m_Lsttp_tapir_Schema$();
        var validator$2 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $m_Lsttp_tapir_Schema$();
        var attributes$2 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        var result = new $c_Lsttp_tapir_Schema(schemaType$2, name$2, isOptional$2, description$2, default$2, format$2, encodedExample$2, deprecated$2, hidden$2, validator$2, attributes$2);
      }
      var this$28 = ctx.Lmagnolia1_CaseClass__f_typeInfo.full__T();
      if ((!(!this$28.startsWith("scala.Tuple")))) {
        result = result.tuple__Lsttp_tapir_Schema();
      }
      var schema = $p_Lframework_data_PageCursor$$anon$14__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema(this, result, $p_Lframework_data_PageCursor$$anon$14__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq(this, $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations), $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_inheritedAnnotations)));
      return schema;
    } finally {
      inProgress.remove__O__Z(cacheKey);
      if (newCache) {
        $m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.remove__V();
      }
    }
  }
});
var $d_Lframework_data_PageCursor$$anon$14 = new $TypeData().initClass($c_Lframework_data_PageCursor$$anon$14, "framework.data.PageCursor$$anon$14", ({
  Lframework_data_PageCursor$$anon$14: 1,
  Lmagnolia1_CommonDerivation: 1,
  Lmagnolia1_SealedTraitDerivation: 1,
  Lmagnolia1_Derivation: 1
}));
export { $d_Lframework_data_PageCursor$$anon$14 as $d_Lframework_data_PageCursor$$anon$14 };
/** @constructor */
function $c_Lframework_data_PageCursor$$anon$17(x$0$4, x$1$4) {
  this.Lframework_data_PageCursor$$anon$17__f_x$0$2 = null;
  this.Lframework_data_PageCursor$$anon$17__f_x$1$2 = null;
  this.Lframework_data_PageCursor$$anon$17__f_x$0$2 = x$0$4;
  this.Lframework_data_PageCursor$$anon$17__f_x$1$2 = x$1$4;
}
export { $c_Lframework_data_PageCursor$$anon$17 as $c_Lframework_data_PageCursor$$anon$17 };
$c_Lframework_data_PageCursor$$anon$17.prototype = new $h_O();
$c_Lframework_data_PageCursor$$anon$17.prototype.constructor = $c_Lframework_data_PageCursor$$anon$17;
/** @constructor */
function $h_Lframework_data_PageCursor$$anon$17() {
}
export { $h_Lframework_data_PageCursor$$anon$17 as $h_Lframework_data_PageCursor$$anon$17 };
$h_Lframework_data_PageCursor$$anon$17.prototype = $c_Lframework_data_PageCursor$$anon$17.prototype;
$c_Lframework_data_PageCursor$$anon$17.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$$anon$17.prototype.apply__Lsttp_tapir_Schema = (function() {
  return $m_Lsttp_tapir_Schema$().schemaForOption__Lsttp_tapir_Schema__Lsttp_tapir_Schema($m_Lframework_data_PageCursor$Cursor$().derived$Schema__Lsttp_tapir_Schema__Lsttp_tapir_Schema__Lsttp_tapir_Schema(this.Lframework_data_PageCursor$$anon$17__f_x$0$2, this.Lframework_data_PageCursor$$anon$17__f_x$1$2));
});
$c_Lframework_data_PageCursor$$anon$17.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lframework_data_PageCursor$$anon$17 = new $TypeData().initClass($c_Lframework_data_PageCursor$$anon$17, "framework.data.PageCursor$$anon$17", ({
  Lframework_data_PageCursor$$anon$17: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$$anon$17 as $d_Lframework_data_PageCursor$$anon$17 };
/** @constructor */
function $c_Lframework_data_PageCursor$$anon$18(evaluator$11) {
  this.Lframework_data_PageCursor$$anon$18__f_evaluator$5 = null;
  this.Lframework_data_PageCursor$$anon$18__f_evaluator$5 = evaluator$11;
}
export { $c_Lframework_data_PageCursor$$anon$18 as $c_Lframework_data_PageCursor$$anon$18 };
$c_Lframework_data_PageCursor$$anon$18.prototype = new $h_O();
$c_Lframework_data_PageCursor$$anon$18.prototype.constructor = $c_Lframework_data_PageCursor$$anon$18;
/** @constructor */
function $h_Lframework_data_PageCursor$$anon$18() {
}
export { $h_Lframework_data_PageCursor$$anon$18 as $h_Lframework_data_PageCursor$$anon$18 };
$h_Lframework_data_PageCursor$$anon$18.prototype = $c_Lframework_data_PageCursor$$anon$18.prototype;
$c_Lframework_data_PageCursor$$anon$18.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$$anon$18.prototype.apply__s_Option = (function() {
  var v = this.Lframework_data_PageCursor$$anon$18__f_evaluator$5.apply__O();
  return ((v instanceof $c_s_Option) ? new $c_s_Some(v) : $m_s_None$());
});
$c_Lframework_data_PageCursor$$anon$18.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lframework_data_PageCursor$$anon$18 = new $TypeData().initClass($c_Lframework_data_PageCursor$$anon$18, "framework.data.PageCursor$$anon$18", ({
  Lframework_data_PageCursor$$anon$18: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$$anon$18 as $d_Lframework_data_PageCursor$$anon$18 };
/** @constructor */
function $c_Lframework_data_PageCursor$$anon$19(x$2$2) {
  this.Lframework_data_PageCursor$$anon$19__f_x$2$1 = null;
  this.Lframework_data_PageCursor$$anon$19__f_x$2$1 = x$2$2;
}
export { $c_Lframework_data_PageCursor$$anon$19 as $c_Lframework_data_PageCursor$$anon$19 };
$c_Lframework_data_PageCursor$$anon$19.prototype = new $h_O();
$c_Lframework_data_PageCursor$$anon$19.prototype.constructor = $c_Lframework_data_PageCursor$$anon$19;
/** @constructor */
function $h_Lframework_data_PageCursor$$anon$19() {
}
export { $h_Lframework_data_PageCursor$$anon$19 as $h_Lframework_data_PageCursor$$anon$19 };
$h_Lframework_data_PageCursor$$anon$19.prototype = $c_Lframework_data_PageCursor$$anon$19.prototype;
$c_Lframework_data_PageCursor$$anon$19.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$$anon$19.prototype.apply__O = (function() {
  return this.Lframework_data_PageCursor$$anon$19__f_x$2$1;
});
var $d_Lframework_data_PageCursor$$anon$19 = new $TypeData().initClass($c_Lframework_data_PageCursor$$anon$19, "framework.data.PageCursor$$anon$19", ({
  Lframework_data_PageCursor$$anon$19: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$$anon$19 as $d_Lframework_data_PageCursor$$anon$19 };
/** @constructor */
function $c_Lframework_data_PageCursor$$anon$20(evaluator$12) {
  this.Lframework_data_PageCursor$$anon$20__f_evaluator$6 = null;
  this.Lframework_data_PageCursor$$anon$20__f_evaluator$6 = evaluator$12;
}
export { $c_Lframework_data_PageCursor$$anon$20 as $c_Lframework_data_PageCursor$$anon$20 };
$c_Lframework_data_PageCursor$$anon$20.prototype = new $h_O();
$c_Lframework_data_PageCursor$$anon$20.prototype.constructor = $c_Lframework_data_PageCursor$$anon$20;
/** @constructor */
function $h_Lframework_data_PageCursor$$anon$20() {
}
export { $h_Lframework_data_PageCursor$$anon$20 as $h_Lframework_data_PageCursor$$anon$20 };
$h_Lframework_data_PageCursor$$anon$20.prototype = $c_Lframework_data_PageCursor$$anon$20.prototype;
$c_Lframework_data_PageCursor$$anon$20.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$$anon$20.prototype.apply__s_Option = (function() {
  var v = this.Lframework_data_PageCursor$$anon$20__f_evaluator$6.apply__O();
  return ((v !== null) ? new $c_s_Some(v) : $m_s_None$());
});
$c_Lframework_data_PageCursor$$anon$20.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lframework_data_PageCursor$$anon$20 = new $TypeData().initClass($c_Lframework_data_PageCursor$$anon$20, "framework.data.PageCursor$$anon$20", ({
  Lframework_data_PageCursor$$anon$20: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$$anon$20 as $d_Lframework_data_PageCursor$$anon$20 };
/** @constructor */
function $c_Lframework_data_PageCursor$Cursor(direction, primary, secondary, index) {
  this.Lframework_data_PageCursor$Cursor__f_direction = null;
  this.Lframework_data_PageCursor$Cursor__f_primary = null;
  this.Lframework_data_PageCursor$Cursor__f_secondary = null;
  this.Lframework_data_PageCursor$Cursor__f_index = 0;
  this.Lframework_data_PageCursor$Cursor__f_direction = direction;
  this.Lframework_data_PageCursor$Cursor__f_primary = primary;
  this.Lframework_data_PageCursor$Cursor__f_secondary = secondary;
  this.Lframework_data_PageCursor$Cursor__f_index = index;
}
export { $c_Lframework_data_PageCursor$Cursor as $c_Lframework_data_PageCursor$Cursor };
$c_Lframework_data_PageCursor$Cursor.prototype = new $h_O();
$c_Lframework_data_PageCursor$Cursor.prototype.constructor = $c_Lframework_data_PageCursor$Cursor;
/** @constructor */
function $h_Lframework_data_PageCursor$Cursor() {
}
export { $h_Lframework_data_PageCursor$Cursor as $h_Lframework_data_PageCursor$Cursor };
$h_Lframework_data_PageCursor$Cursor.prototype = $c_Lframework_data_PageCursor$Cursor.prototype;
$c_Lframework_data_PageCursor$Cursor.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lframework_data_PageCursor$Cursor.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $m_sr_Statics$().mix__I__I__I(hash, 2029715318);
  var hash$1 = acc;
  var x = this.Lframework_data_PageCursor$Cursor__f_direction;
  var data = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var x$1 = this.Lframework_data_PageCursor$Cursor__f_primary;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var x$2 = this.Lframework_data_PageCursor$Cursor__f_secondary;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  var data$3 = this.Lframework_data_PageCursor$Cursor__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$3);
  var hash$5 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$5, 4);
});
$c_Lframework_data_PageCursor$Cursor.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_PageCursor$Cursor)) {
    if ((this.Lframework_data_PageCursor$Cursor__f_index === x$0.Lframework_data_PageCursor$Cursor__f_index)) {
      var x = this.Lframework_data_PageCursor$Cursor__f_direction;
      var x$2 = x$0.Lframework_data_PageCursor$Cursor__f_direction;
      var $x_2 = (x === x$2);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$1 = this.Lframework_data_PageCursor$Cursor__f_primary;
      var y = x$0.Lframework_data_PageCursor$Cursor__f_primary;
      var $x_1 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lframework_data_PageCursor$Cursor__f_secondary;
      var y$1 = x$0.Lframework_data_PageCursor$Cursor__f_secondary;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$3, y$1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_PageCursor$Cursor.prototype.productArity__I = (function() {
  return 4;
});
$c_Lframework_data_PageCursor$Cursor.prototype.productPrefix__T = (function() {
  return "Cursor";
});
$c_Lframework_data_PageCursor$Cursor.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lframework_data_PageCursor$Cursor__f_direction;
      break;
    }
    case 1: {
      return this.Lframework_data_PageCursor$Cursor__f_primary;
      break;
    }
    case 2: {
      return this.Lframework_data_PageCursor$Cursor__f_secondary;
      break;
    }
    case 3: {
      return this.Lframework_data_PageCursor$Cursor__f_index;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_data_PageCursor$Cursor.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "direction";
      break;
    }
    case 1: {
      return "primary";
      break;
    }
    case 2: {
      return "secondary";
      break;
    }
    case 3: {
      return "index";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lframework_data_PageCursor$Cursor.prototype.toString__T = (function() {
  return (((((((("Cursor(" + this.Lframework_data_PageCursor$Cursor__f_direction) + ", primary = ") + this.Lframework_data_PageCursor$Cursor__f_primary) + ", secondary = ") + this.Lframework_data_PageCursor$Cursor__f_secondary) + ", current page index = ") + this.Lframework_data_PageCursor$Cursor__f_index) + ")");
});
function $isArrayOf_Lframework_data_PageCursor$Cursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_PageCursor$Cursor)));
}
export { $isArrayOf_Lframework_data_PageCursor$Cursor as $isArrayOf_Lframework_data_PageCursor$Cursor };
var $d_Lframework_data_PageCursor$Cursor = new $TypeData().initClass($c_Lframework_data_PageCursor$Cursor, "framework.data.PageCursor$Cursor", ({
  Lframework_data_PageCursor$Cursor: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_PageCursor$Cursor as $d_Lframework_data_PageCursor$Cursor };
/** @constructor */
function $c_Lframework_data_PageCursor$Cursor$$anon$10(x$1$3) {
  this.Lframework_data_PageCursor$Cursor$$anon$10__f_x$1$1 = null;
  this.Lframework_data_PageCursor$Cursor$$anon$10__f_x$1$1 = x$1$3;
}
export { $c_Lframework_data_PageCursor$Cursor$$anon$10 as $c_Lframework_data_PageCursor$Cursor$$anon$10 };
$c_Lframework_data_PageCursor$Cursor$$anon$10.prototype = new $h_O();
$c_Lframework_data_PageCursor$Cursor$$anon$10.prototype.constructor = $c_Lframework_data_PageCursor$Cursor$$anon$10;
/** @constructor */
function $h_Lframework_data_PageCursor$Cursor$$anon$10() {
}
export { $h_Lframework_data_PageCursor$Cursor$$anon$10 as $h_Lframework_data_PageCursor$Cursor$$anon$10 };
$h_Lframework_data_PageCursor$Cursor$$anon$10.prototype = $c_Lframework_data_PageCursor$Cursor$$anon$10.prototype;
$c_Lframework_data_PageCursor$Cursor$$anon$10.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$Cursor$$anon$10.prototype.apply__O = (function() {
  return this.Lframework_data_PageCursor$Cursor$$anon$10__f_x$1$1;
});
var $d_Lframework_data_PageCursor$Cursor$$anon$10 = new $TypeData().initClass($c_Lframework_data_PageCursor$Cursor$$anon$10, "framework.data.PageCursor$Cursor$$anon$10", ({
  Lframework_data_PageCursor$Cursor$$anon$10: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$Cursor$$anon$10 as $d_Lframework_data_PageCursor$Cursor$$anon$10 };
/** @constructor */
function $c_Lframework_data_PageCursor$Cursor$$anon$11(evaluator$9) {
  this.Lframework_data_PageCursor$Cursor$$anon$11__f_evaluator$3 = null;
  this.Lframework_data_PageCursor$Cursor$$anon$11__f_evaluator$3 = evaluator$9;
}
export { $c_Lframework_data_PageCursor$Cursor$$anon$11 as $c_Lframework_data_PageCursor$Cursor$$anon$11 };
$c_Lframework_data_PageCursor$Cursor$$anon$11.prototype = new $h_O();
$c_Lframework_data_PageCursor$Cursor$$anon$11.prototype.constructor = $c_Lframework_data_PageCursor$Cursor$$anon$11;
/** @constructor */
function $h_Lframework_data_PageCursor$Cursor$$anon$11() {
}
export { $h_Lframework_data_PageCursor$Cursor$$anon$11 as $h_Lframework_data_PageCursor$Cursor$$anon$11 };
$h_Lframework_data_PageCursor$Cursor$$anon$11.prototype = $c_Lframework_data_PageCursor$Cursor$$anon$11.prototype;
$c_Lframework_data_PageCursor$Cursor$$anon$11.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$Cursor$$anon$11.prototype.apply__s_Option = (function() {
  var v = this.Lframework_data_PageCursor$Cursor$$anon$11__f_evaluator$3.apply__O();
  return ((v !== null) ? new $c_s_Some(v) : $m_s_None$());
});
$c_Lframework_data_PageCursor$Cursor$$anon$11.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lframework_data_PageCursor$Cursor$$anon$11 = new $TypeData().initClass($c_Lframework_data_PageCursor$Cursor$$anon$11, "framework.data.PageCursor$Cursor$$anon$11", ({
  Lframework_data_PageCursor$Cursor$$anon$11: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$Cursor$$anon$11 as $d_Lframework_data_PageCursor$Cursor$$anon$11 };
/** @constructor */
function $c_Lframework_data_PageCursor$Cursor$$anon$12() {
}
export { $c_Lframework_data_PageCursor$Cursor$$anon$12 as $c_Lframework_data_PageCursor$Cursor$$anon$12 };
$c_Lframework_data_PageCursor$Cursor$$anon$12.prototype = new $h_O();
$c_Lframework_data_PageCursor$Cursor$$anon$12.prototype.constructor = $c_Lframework_data_PageCursor$Cursor$$anon$12;
/** @constructor */
function $h_Lframework_data_PageCursor$Cursor$$anon$12() {
}
export { $h_Lframework_data_PageCursor$Cursor$$anon$12 as $h_Lframework_data_PageCursor$Cursor$$anon$12 };
$h_Lframework_data_PageCursor$Cursor$$anon$12.prototype = $c_Lframework_data_PageCursor$Cursor$$anon$12.prototype;
$c_Lframework_data_PageCursor$Cursor$$anon$12.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$Cursor$$anon$12.prototype.apply__O = (function() {
  return $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForInt;
});
var $d_Lframework_data_PageCursor$Cursor$$anon$12 = new $TypeData().initClass($c_Lframework_data_PageCursor$Cursor$$anon$12, "framework.data.PageCursor$Cursor$$anon$12", ({
  Lframework_data_PageCursor$Cursor$$anon$12: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$Cursor$$anon$12 as $d_Lframework_data_PageCursor$Cursor$$anon$12 };
/** @constructor */
function $c_Lframework_data_PageCursor$Cursor$$anon$13(evaluator$10) {
  this.Lframework_data_PageCursor$Cursor$$anon$13__f_evaluator$4 = null;
  this.Lframework_data_PageCursor$Cursor$$anon$13__f_evaluator$4 = evaluator$10;
}
export { $c_Lframework_data_PageCursor$Cursor$$anon$13 as $c_Lframework_data_PageCursor$Cursor$$anon$13 };
$c_Lframework_data_PageCursor$Cursor$$anon$13.prototype = new $h_O();
$c_Lframework_data_PageCursor$Cursor$$anon$13.prototype.constructor = $c_Lframework_data_PageCursor$Cursor$$anon$13;
/** @constructor */
function $h_Lframework_data_PageCursor$Cursor$$anon$13() {
}
export { $h_Lframework_data_PageCursor$Cursor$$anon$13 as $h_Lframework_data_PageCursor$Cursor$$anon$13 };
$h_Lframework_data_PageCursor$Cursor$$anon$13.prototype = $c_Lframework_data_PageCursor$Cursor$$anon$13.prototype;
$c_Lframework_data_PageCursor$Cursor$$anon$13.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$Cursor$$anon$13.prototype.apply__s_Option = (function() {
  var v = this.Lframework_data_PageCursor$Cursor$$anon$13__f_evaluator$4.apply__O();
  return ($isInt(v) ? new $c_s_Some(v) : $m_s_None$());
});
$c_Lframework_data_PageCursor$Cursor$$anon$13.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lframework_data_PageCursor$Cursor$$anon$13 = new $TypeData().initClass($c_Lframework_data_PageCursor$Cursor$$anon$13, "framework.data.PageCursor$Cursor$$anon$13", ({
  Lframework_data_PageCursor$Cursor$$anon$13: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$Cursor$$anon$13 as $d_Lframework_data_PageCursor$Cursor$$anon$13 };
function $p_Lframework_data_PageCursor$Cursor$$anon$3__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct($thiz, ctx) {
  var $x_10 = $m_s_IArray$package$IArray$();
  var arr = ctx.Lmagnolia1_CaseClass__f_parameters;
  var f = ((p) => {
    var annotations = $p_Lframework_data_PageCursor$Cursor$$anon$3__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_annotations), $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(p.Lmagnolia1_CaseClass$Param$$anon$2__f_inheritedAnns$4));
    var pSchema = $p_Lframework_data_PageCursor$Cursor$$anon$3__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, p.typeclass__O(), annotations);
    var this$2 = annotations.collectFirst__s_PartialFunction__s_Option(new $c_Lframework_data_PageCursor$$anon$5());
    var encodedName = (this$2.isEmpty__Z() ? $m_Lsttp_tapir_generic_Configuration$().Lsttp_tapir_generic_Configuration$__f_default.Lsttp_tapir_generic_Configuration__f_toEncodedName.apply__O__O(p.Lmagnolia1_CaseClass$Param$$anon$2__f_label) : this$2.get__O());
    var name = p.Lmagnolia1_CaseClass$Param$$anon$2__f_label;
    var _name = new $c_Lsttp_tapir_FieldName(name, encodedName);
    var _get = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((p$3) => ((t) => {
      var value = p$3.deref__O__O(t);
      return new $c_s_Some(value);
    }))(p));
    return new $c_Lsttp_tapir_SchemaType$SProductField$$anon$1(_name, pSchema, _get);
  });
  var len = arr.u.length;
  var ys = new ($d_Lsttp_tapir_SchemaType$SProductField.getArrayOf().constr)(len);
  if ((len > 0)) {
    var i = 0;
    if ((arr !== null)) {
      while ((i < len)) {
        var $x_1 = i;
        var x0 = arr.u[i];
        ys.u[$x_1] = f(x0);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_I)) {
      while ((i < len)) {
        var $x_2 = i;
        var x0$1 = arr.u[i];
        ys.u[$x_2] = f(x0$1);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_D)) {
      while ((i < len)) {
        var $x_3 = i;
        var x0$2 = arr.u[i];
        ys.u[$x_3] = f(x0$2);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_J)) {
      while ((i < len)) {
        var $x_4 = i;
        var t$1 = arr.u[i];
        var lo = t$1.RTLong__f_lo;
        var hi = t$1.RTLong__f_hi;
        ys.u[$x_4] = f(new $c_RTLong(lo, hi));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_F)) {
      while ((i < len)) {
        var $x_5 = i;
        var x0$3 = arr.u[i];
        ys.u[$x_5] = f(x0$3);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_C)) {
      while ((i < len)) {
        var $x_6 = i;
        var x0$4 = arr.u[i];
        ys.u[$x_6] = f($bC(x0$4));
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_B)) {
      while ((i < len)) {
        var $x_7 = i;
        var x0$5 = arr.u[i];
        ys.u[$x_7] = f(x0$5);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_S)) {
      while ((i < len)) {
        var $x_8 = i;
        var x0$6 = arr.u[i];
        ys.u[$x_8] = f(x0$6);
        i = ((1 + i) | 0);
      }
    } else if ((arr instanceof $ac_Z)) {
      while ((i < len)) {
        var $x_9 = i;
        var x0$7 = arr.u[i];
        ys.u[$x_9] = f(x0$7);
        i = ((1 + i) | 0);
      }
    } else {
      throw new $c_s_MatchError(arr);
    }
  }
  var this$11 = $x_10.wrapRefArray__AO__sci_ArraySeq$ofRef(ys);
  var fields = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$11);
  return new $c_Lsttp_tapir_SchemaType$SProduct(fields);
}
export { $p_Lframework_data_PageCursor$Cursor$$anon$3__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct as $p_Lframework_data_PageCursor$Cursor$$anon$3__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct };
function $p_Lframework_data_PageCursor$Cursor$$anon$3__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName($thiz, typeName, annotations) {
  var x44 = annotations.collectFirst__s_PartialFunction__s_Option(new $c_Lframework_data_PageCursor$$anon$4());
  if ((x44 instanceof $c_s_Some)) {
    var altName = x44.s_Some__f_value;
    $m_Lsttp_tapir_Schema$SName$();
    var typeParameterShortNames = $m_sci_Nil$();
    return new $c_Lsttp_tapir_Schema$SName(altName, typeParameterShortNames);
  }
  var x = $m_s_None$();
  if ((x === x44)) {
    $m_Lsttp_tapir_Schema$SName$();
    var fullName = typeName.full__T();
    var typeParameterShortNames$1 = $s_Lframework_data_PageCursor$__framework$data$PageCursor$Cursor$$anon$3$$_$allTypeArguments$1__Lmagnolia1_TypeInfo__sci_Seq(typeName).map__F1__O(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => _$1.full__T()))).toList__sci_List();
    return new $c_Lsttp_tapir_Schema$SName(fullName, typeParameterShortNames$1);
  }
  throw new $c_s_MatchError(x44);
}
export { $p_Lframework_data_PageCursor$Cursor$$anon$3__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName as $p_Lframework_data_PageCursor$Cursor$$anon$3__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName };
function $p_Lframework_data_PageCursor$Cursor$$anon$3__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema($thiz, schema, annotations) {
  return annotations.foldLeft__O__F2__O(schema, new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((x$1, x$2) => {
    if (false) {
      return x$1.description__T__Lsttp_tapir_Schema(x$2.text__T());
    } else if (false) {
      return x$1.encodedExample__O__Lsttp_tapir_Schema(x$2.example__O());
    } else if (false) {
      return x$1.default__O__s_Option__Lsttp_tapir_Schema(x$2.default__O(), x$2.encoded__s_Option());
    } else if (false) {
      return x$1.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(x$2.v__Lsttp_tapir_Validator());
    } else if (false) {
      var fields = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_ModifyCollectionElements]));
      var modify = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((ann$6) => ((_$2) => _$2.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema(ann$6.v__Lsttp_tapir_Validator())))(x$2));
      return $p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(x$1, $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(fields), modify);
    } else if (false) {
      return x$1.format__T__Lsttp_tapir_Schema(x$2.format__T());
    } else if (false) {
      return x$1.title__T__Lsttp_tapir_Schema(x$2.name__T());
    } else if (false) {
      var schemaType = x$1.Lsttp_tapir_Schema__f_schemaType;
      var name = x$1.Lsttp_tapir_Schema__f_name;
      var isOptional = x$1.Lsttp_tapir_Schema__f_isOptional;
      var description = x$1.Lsttp_tapir_Schema__f_description;
      var default$1 = x$1.Lsttp_tapir_Schema__f_default;
      var format = x$1.Lsttp_tapir_Schema__f_format;
      var encodedExample = x$1.Lsttp_tapir_Schema__f_encodedExample;
      var hidden = x$1.Lsttp_tapir_Schema__f_hidden;
      var validator = x$1.Lsttp_tapir_Schema__f_validator;
      var attributes = x$1.Lsttp_tapir_Schema__f_attributes;
      return new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, true, hidden, validator, attributes);
    } else {
      return (false ? x$2.f__F1().apply__O__O(x$1) : x$1);
    }
  })));
}
export { $p_Lframework_data_PageCursor$Cursor$$anon$3__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema as $p_Lframework_data_PageCursor$Cursor$$anon$3__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema };
function $p_Lframework_data_PageCursor$Cursor$$anon$3__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq($thiz, primary, inherited) {
  var suffix = inherited.distinct__O().filter__F1__O(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => (!primary.exists__F1__Z(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => {
    var this$1 = $objectGetClass(_$3);
    var that = $objectGetClass(x$1);
    return (this$1 === that);
  })))))));
  return primary.appendedAll__sc_IterableOnce__O(suffix);
}
export { $p_Lframework_data_PageCursor$Cursor$$anon$3__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq as $p_Lframework_data_PageCursor$Cursor$$anon$3__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq };
/** @constructor */
function $c_Lframework_data_PageCursor$Cursor$$anon$3(SchemaMagnoliaDerivation_this$3) {
  this.Lframework_data_PageCursor$Cursor$$anon$3__f_SchemaMagnoliaDerivation_this$1 = null;
  this.Lframework_data_PageCursor$Cursor$$anon$3__f_SchemaMagnoliaDerivation_this$1 = SchemaMagnoliaDerivation_this$3;
}
export { $c_Lframework_data_PageCursor$Cursor$$anon$3 as $c_Lframework_data_PageCursor$Cursor$$anon$3 };
$c_Lframework_data_PageCursor$Cursor$$anon$3.prototype = new $h_O();
$c_Lframework_data_PageCursor$Cursor$$anon$3.prototype.constructor = $c_Lframework_data_PageCursor$Cursor$$anon$3;
/** @constructor */
function $h_Lframework_data_PageCursor$Cursor$$anon$3() {
}
export { $h_Lframework_data_PageCursor$Cursor$$anon$3 as $h_Lframework_data_PageCursor$Cursor$$anon$3 };
$h_Lframework_data_PageCursor$Cursor$$anon$3.prototype = $c_Lframework_data_PageCursor$Cursor$$anon$3.prototype;
$c_Lframework_data_PageCursor$Cursor$$anon$3.prototype.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema = (function(ctx) {
  var typeName = ctx.Lmagnolia1_CaseClass__f_typeInfo;
  var annotations = $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations);
  var cacheKey = typeName.full__T();
  var inProgressOrNull = $m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.get__O();
  var newCache = (inProgressOrNull === null);
  if (newCache) {
    var newInProgress = $m_scm_Set$().apply__sci_Seq__O($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([])));
    $m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.set__O__V(newInProgress);
    var inProgress = newInProgress;
  } else {
    if ((inProgressOrNull === null)) {
      $m_sr_Scala3RunTime$().nnFail__E();
    }
    var inProgress = inProgressOrNull;
  }
  if (inProgress.contains__O__Z(cacheKey)) {
    $m_Lsttp_tapir_Schema$();
    var name = $p_Lframework_data_PageCursor$Cursor$$anon$3__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, typeName, annotations);
    var schemaType = new $c_Lsttp_tapir_SchemaType$SRef(name);
    $m_Lsttp_tapir_Schema$();
    var name$1 = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var isOptional = false;
    $m_Lsttp_tapir_Schema$();
    var description = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var default$1 = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var format = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var encodedExample = $m_s_None$();
    $m_Lsttp_tapir_Schema$();
    var deprecated = false;
    $m_Lsttp_tapir_Schema$();
    var hidden = false;
    $m_Lsttp_tapir_Schema$();
    var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
    $m_Lsttp_tapir_Schema$();
    var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
    return new $c_Lsttp_tapir_Schema(schemaType, name$1, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  } else {
    try {
      inProgress.add__O__Z(cacheKey);
      if (ctx.Lmagnolia1_CaseClass__f_isValueClass) {
        var requirement = $m_s_IArray$package$IArray$().nonEmpty__O__Z(ctx.Lmagnolia1_CaseClass__f_parameters);
        if ((!requirement)) {
          throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "Cannot derive schema for generic value class: ") + ctx.Lmagnolia1_CaseClass__f_typeInfo.Lmagnolia1_TypeInfo__f_owner));
        }
        var valueSchema = $m_s_IArray$package$IArray$().head__O__O(ctx.Lmagnolia1_CaseClass__f_parameters).typeclass__O();
        var schemaType$1 = valueSchema.Lsttp_tapir_Schema__f_schemaType;
        $m_Lsttp_tapir_Schema$();
        var name$1$1 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var isOptional$1 = false;
        $m_Lsttp_tapir_Schema$();
        var description$1 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var default$1$1 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var encodedExample$1 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var deprecated$1 = false;
        $m_Lsttp_tapir_Schema$();
        var hidden$1 = false;
        $m_Lsttp_tapir_Schema$();
        var validator$1 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $m_Lsttp_tapir_Schema$();
        var attributes$1 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        $m_Lsttp_tapir_Schema$();
        var format$1 = valueSchema.Lsttp_tapir_Schema__f_format;
        var result = new $c_Lsttp_tapir_Schema(schemaType$1, name$1$1, isOptional$1, description$1, default$1$1, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
      } else {
        $m_Lsttp_tapir_Schema$();
        var schemaType$2 = $p_Lframework_data_PageCursor$Cursor$$anon$3__productSchemaType__Lmagnolia1_CaseClass__Lsttp_tapir_SchemaType$SProduct(this, ctx);
        var value = $p_Lframework_data_PageCursor$Cursor$$anon$3__typeNameToSchemaName__Lmagnolia1_TypeInfo__sci_Seq__Lsttp_tapir_Schema$SName(this, ctx.Lmagnolia1_CaseClass__f_typeInfo, $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations));
        var name$2 = new $c_s_Some(value);
        $m_Lsttp_tapir_Schema$();
        var isOptional$2 = false;
        $m_Lsttp_tapir_Schema$();
        var description$2 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var default$2 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var format$2 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var encodedExample$2 = $m_s_None$();
        $m_Lsttp_tapir_Schema$();
        var deprecated$2 = false;
        $m_Lsttp_tapir_Schema$();
        var hidden$2 = false;
        $m_Lsttp_tapir_Schema$();
        var validator$2 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
        $m_Lsttp_tapir_Schema$();
        var attributes$2 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
        var result = new $c_Lsttp_tapir_Schema(schemaType$2, name$2, isOptional$2, description$2, default$2, format$2, encodedExample$2, deprecated$2, hidden$2, validator$2, attributes$2);
      }
      var this$28 = ctx.Lmagnolia1_CaseClass__f_typeInfo.full__T();
      if ((!(!this$28.startsWith("scala.Tuple")))) {
        result = result.tuple__Lsttp_tapir_Schema();
      }
      var schema = $p_Lframework_data_PageCursor$Cursor$$anon$3__enrichSchema__Lsttp_tapir_Schema__sci_Seq__Lsttp_tapir_Schema(this, result, $p_Lframework_data_PageCursor$Cursor$$anon$3__mergeAnnotations__sci_Seq__sci_Seq__sci_Seq(this, $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_annotations), $m_s_IArray$package$IArray$().genericWrapArray__O__sci_ArraySeq(ctx.Lmagnolia1_CaseClass__f_inheritedAnnotations)));
      return schema;
    } finally {
      inProgress.remove__O__Z(cacheKey);
      if (newCache) {
        $m_Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$().Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation$__f_deriveCache.remove__V();
      }
    }
  }
});
var $d_Lframework_data_PageCursor$Cursor$$anon$3 = new $TypeData().initClass($c_Lframework_data_PageCursor$Cursor$$anon$3, "framework.data.PageCursor$Cursor$$anon$3", ({
  Lframework_data_PageCursor$Cursor$$anon$3: 1,
  Lmagnolia1_CommonDerivation: 1,
  Lmagnolia1_SealedTraitDerivation: 1,
  Lmagnolia1_Derivation: 1
}));
export { $d_Lframework_data_PageCursor$Cursor$$anon$3 as $d_Lframework_data_PageCursor$Cursor$$anon$3 };
/** @constructor */
function $c_Lframework_data_PageCursor$Cursor$$anon$6() {
}
export { $c_Lframework_data_PageCursor$Cursor$$anon$6 as $c_Lframework_data_PageCursor$Cursor$$anon$6 };
$c_Lframework_data_PageCursor$Cursor$$anon$6.prototype = new $h_O();
$c_Lframework_data_PageCursor$Cursor$$anon$6.prototype.constructor = $c_Lframework_data_PageCursor$Cursor$$anon$6;
/** @constructor */
function $h_Lframework_data_PageCursor$Cursor$$anon$6() {
}
export { $h_Lframework_data_PageCursor$Cursor$$anon$6 as $h_Lframework_data_PageCursor$Cursor$$anon$6 };
$h_Lframework_data_PageCursor$Cursor$$anon$6.prototype = $c_Lframework_data_PageCursor$Cursor$$anon$6.prototype;
$c_Lframework_data_PageCursor$Cursor$$anon$6.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$Cursor$$anon$6.prototype.apply__O = (function() {
  return $m_Lframework_data_PageCursorDirection$().schema__Lsttp_tapir_Schema();
});
var $d_Lframework_data_PageCursor$Cursor$$anon$6 = new $TypeData().initClass($c_Lframework_data_PageCursor$Cursor$$anon$6, "framework.data.PageCursor$Cursor$$anon$6", ({
  Lframework_data_PageCursor$Cursor$$anon$6: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$Cursor$$anon$6 as $d_Lframework_data_PageCursor$Cursor$$anon$6 };
/** @constructor */
function $c_Lframework_data_PageCursor$Cursor$$anon$7(evaluator$7) {
  this.Lframework_data_PageCursor$Cursor$$anon$7__f_evaluator$1 = null;
  this.Lframework_data_PageCursor$Cursor$$anon$7__f_evaluator$1 = evaluator$7;
}
export { $c_Lframework_data_PageCursor$Cursor$$anon$7 as $c_Lframework_data_PageCursor$Cursor$$anon$7 };
$c_Lframework_data_PageCursor$Cursor$$anon$7.prototype = new $h_O();
$c_Lframework_data_PageCursor$Cursor$$anon$7.prototype.constructor = $c_Lframework_data_PageCursor$Cursor$$anon$7;
/** @constructor */
function $h_Lframework_data_PageCursor$Cursor$$anon$7() {
}
export { $h_Lframework_data_PageCursor$Cursor$$anon$7 as $h_Lframework_data_PageCursor$Cursor$$anon$7 };
$h_Lframework_data_PageCursor$Cursor$$anon$7.prototype = $c_Lframework_data_PageCursor$Cursor$$anon$7.prototype;
$c_Lframework_data_PageCursor$Cursor$$anon$7.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$Cursor$$anon$7.prototype.apply__s_Option = (function() {
  var v = this.Lframework_data_PageCursor$Cursor$$anon$7__f_evaluator$1.apply__O();
  return ((v instanceof $c_Lframework_data_PageCursorDirection) ? new $c_s_Some(v) : $m_s_None$());
});
$c_Lframework_data_PageCursor$Cursor$$anon$7.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lframework_data_PageCursor$Cursor$$anon$7 = new $TypeData().initClass($c_Lframework_data_PageCursor$Cursor$$anon$7, "framework.data.PageCursor$Cursor$$anon$7", ({
  Lframework_data_PageCursor$Cursor$$anon$7: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$Cursor$$anon$7 as $d_Lframework_data_PageCursor$Cursor$$anon$7 };
/** @constructor */
function $c_Lframework_data_PageCursor$Cursor$$anon$8(x$0$3) {
  this.Lframework_data_PageCursor$Cursor$$anon$8__f_x$0$1 = null;
  this.Lframework_data_PageCursor$Cursor$$anon$8__f_x$0$1 = x$0$3;
}
export { $c_Lframework_data_PageCursor$Cursor$$anon$8 as $c_Lframework_data_PageCursor$Cursor$$anon$8 };
$c_Lframework_data_PageCursor$Cursor$$anon$8.prototype = new $h_O();
$c_Lframework_data_PageCursor$Cursor$$anon$8.prototype.constructor = $c_Lframework_data_PageCursor$Cursor$$anon$8;
/** @constructor */
function $h_Lframework_data_PageCursor$Cursor$$anon$8() {
}
export { $h_Lframework_data_PageCursor$Cursor$$anon$8 as $h_Lframework_data_PageCursor$Cursor$$anon$8 };
$h_Lframework_data_PageCursor$Cursor$$anon$8.prototype = $c_Lframework_data_PageCursor$Cursor$$anon$8.prototype;
$c_Lframework_data_PageCursor$Cursor$$anon$8.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$Cursor$$anon$8.prototype.apply__O = (function() {
  return this.Lframework_data_PageCursor$Cursor$$anon$8__f_x$0$1;
});
var $d_Lframework_data_PageCursor$Cursor$$anon$8 = new $TypeData().initClass($c_Lframework_data_PageCursor$Cursor$$anon$8, "framework.data.PageCursor$Cursor$$anon$8", ({
  Lframework_data_PageCursor$Cursor$$anon$8: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$Cursor$$anon$8 as $d_Lframework_data_PageCursor$Cursor$$anon$8 };
/** @constructor */
function $c_Lframework_data_PageCursor$Cursor$$anon$9(evaluator$8) {
  this.Lframework_data_PageCursor$Cursor$$anon$9__f_evaluator$2 = null;
  this.Lframework_data_PageCursor$Cursor$$anon$9__f_evaluator$2 = evaluator$8;
}
export { $c_Lframework_data_PageCursor$Cursor$$anon$9 as $c_Lframework_data_PageCursor$Cursor$$anon$9 };
$c_Lframework_data_PageCursor$Cursor$$anon$9.prototype = new $h_O();
$c_Lframework_data_PageCursor$Cursor$$anon$9.prototype.constructor = $c_Lframework_data_PageCursor$Cursor$$anon$9;
/** @constructor */
function $h_Lframework_data_PageCursor$Cursor$$anon$9() {
}
export { $h_Lframework_data_PageCursor$Cursor$$anon$9 as $h_Lframework_data_PageCursor$Cursor$$anon$9 };
$h_Lframework_data_PageCursor$Cursor$$anon$9.prototype = $c_Lframework_data_PageCursor$Cursor$$anon$9.prototype;
$c_Lframework_data_PageCursor$Cursor$$anon$9.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lframework_data_PageCursor$Cursor$$anon$9.prototype.apply__s_Option = (function() {
  var v = this.Lframework_data_PageCursor$Cursor$$anon$9__f_evaluator$2.apply__O();
  return ((v !== null) ? new $c_s_Some(v) : $m_s_None$());
});
$c_Lframework_data_PageCursor$Cursor$$anon$9.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lframework_data_PageCursor$Cursor$$anon$9 = new $TypeData().initClass($c_Lframework_data_PageCursor$Cursor$$anon$9, "framework.data.PageCursor$Cursor$$anon$9", ({
  Lframework_data_PageCursor$Cursor$$anon$9: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lframework_data_PageCursor$Cursor$$anon$9 as $d_Lframework_data_PageCursor$Cursor$$anon$9 };
function $f_Lframework_utils_NewtypeInt__given_Ordering_Type__s_math_Ordering($thiz) {
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v) => {
    var v$1 = (v | 0);
    return v$1;
  }));
  var ord = $m_s_math_Ordering$Int$();
  return new $c_s_math_Ordering$$anon$5(ord, f);
}
export { $f_Lframework_utils_NewtypeInt__given_Ordering_Type__s_math_Ordering as $f_Lframework_utils_NewtypeInt__given_Ordering_Type__s_math_Ordering };
/** @constructor */
function $c_Lframework_utils_NewtypeULID$$anon$1(outer) {
  this.Lframework_utils_NewtypeULID$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_utils_NewtypeULID$$anon$1__f_$outer = outer;
}
export { $c_Lframework_utils_NewtypeULID$$anon$1 as $c_Lframework_utils_NewtypeULID$$anon$1 };
$c_Lframework_utils_NewtypeULID$$anon$1.prototype = new $h_O();
$c_Lframework_utils_NewtypeULID$$anon$1.prototype.constructor = $c_Lframework_utils_NewtypeULID$$anon$1;
/** @constructor */
function $h_Lframework_utils_NewtypeULID$$anon$1() {
}
export { $h_Lframework_utils_NewtypeULID$$anon$1 as $h_Lframework_utils_NewtypeULID$$anon$1 };
$h_Lframework_utils_NewtypeULID$$anon$1.prototype = $c_Lframework_utils_NewtypeULID$$anon$1.prototype;
$c_Lframework_utils_NewtypeULID$$anon$1.prototype.show__Ljkugiya_ulid_ULID__T = (function(_$1) {
  var this$1 = this.Lframework_utils_NewtypeULID$$anon$1__f_$outer;
  return $f_Lframework_utils_NewtypeULID__toBase64__Ljkugiya_ulid_ULID__Lframework_data_Base64Id(this$1, _$1).asString__T();
});
$c_Lframework_utils_NewtypeULID$$anon$1.prototype.show__O__T = (function(t) {
  return this.show__Ljkugiya_ulid_ULID__T(t);
});
var $d_Lframework_utils_NewtypeULID$$anon$1 = new $TypeData().initClass($c_Lframework_utils_NewtypeULID$$anon$1, "framework.utils.NewtypeULID$$anon$1", ({
  Lframework_utils_NewtypeULID$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Show$ContravariantShow: 1,
  Lcats_Show: 1
}));
export { $d_Lframework_utils_NewtypeULID$$anon$1 as $d_Lframework_utils_NewtypeULID$$anon$1 };
/** @constructor */
function $c_Lframework_utils_UrlConvertible$fromCodec(codec, errorFromThrowable) {
  this.Lframework_utils_UrlConvertible$fromCodec__f_codec = null;
  this.Lframework_utils_UrlConvertible$fromCodec__f_errorFromThrowable = null;
  this.Lframework_utils_UrlConvertible$fromCodec__f_codec = codec;
  this.Lframework_utils_UrlConvertible$fromCodec__f_errorFromThrowable = errorFromThrowable;
}
export { $c_Lframework_utils_UrlConvertible$fromCodec as $c_Lframework_utils_UrlConvertible$fromCodec };
$c_Lframework_utils_UrlConvertible$fromCodec.prototype = new $h_O();
$c_Lframework_utils_UrlConvertible$fromCodec.prototype.constructor = $c_Lframework_utils_UrlConvertible$fromCodec;
/** @constructor */
function $h_Lframework_utils_UrlConvertible$fromCodec() {
}
export { $h_Lframework_utils_UrlConvertible$fromCodec as $h_Lframework_utils_UrlConvertible$fromCodec };
$h_Lframework_utils_UrlConvertible$fromCodec.prototype = $c_Lframework_utils_UrlConvertible$fromCodec.prototype;
$c_Lframework_utils_UrlConvertible$fromCodec.prototype.fromString__T__s_util_Either = (function(str) {
  var x1 = $f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(this.Lframework_utils_UrlConvertible$fromCodec__f_codec, str);
  if ($is_Lsttp_tapir_DecodeResult$Failure(x1)) {
    $ct_jl_Exception__T__(new $c_jl_Exception(), x1.toString__T());
    var value = $m_Lurldsl_errors_DummyError$dummyError$();
    return new $c_s_util_Left(value);
  }
  if ((x1 instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
    var x4 = x1.Lsttp_tapir_DecodeResult$Value__f_v;
    return new $c_s_util_Right(x4);
  }
  throw new $c_s_MatchError(x1);
});
$c_Lframework_utils_UrlConvertible$fromCodec.prototype.print__O__T = (function(t) {
  return this.Lframework_utils_UrlConvertible$fromCodec__f_codec.encode__O__O(t);
});
var $d_Lframework_utils_UrlConvertible$fromCodec = new $TypeData().initClass($c_Lframework_utils_UrlConvertible$fromCodec, "framework.utils.UrlConvertible$fromCodec", ({
  Lframework_utils_UrlConvertible$fromCodec: 1,
  Lurldsl_vocabulary_FromString: 1,
  Lurldsl_vocabulary_Printer: 1,
  Lframework_utils_UrlConvertible: 1
}));
export { $d_Lframework_utils_UrlConvertible$fromCodec as $d_Lframework_utils_UrlConvertible$fromCodec };
function $f_Lio_circe_Codec__iemap__F1__F1__Lio_circe_Codec($thiz, f, g) {
  var decodeA = new $c_Lio_circe_Decoder$$anon$13(f, $thiz);
  var encodeA = new $c_Lio_circe_Encoder$$anon$1(g, $thiz);
  return new $c_Lio_circe_Codec$$anon$4(decodeA, encodeA);
}
export { $f_Lio_circe_Codec__iemap__F1__F1__Lio_circe_Codec as $f_Lio_circe_Codec__iemap__F1__F1__Lio_circe_Codec };
/** @constructor */
function $c_Lio_circe_CursorOp() {
}
export { $c_Lio_circe_CursorOp as $c_Lio_circe_CursorOp };
$c_Lio_circe_CursorOp.prototype = new $h_O();
$c_Lio_circe_CursorOp.prototype.constructor = $c_Lio_circe_CursorOp;
/** @constructor */
function $h_Lio_circe_CursorOp() {
}
export { $h_Lio_circe_CursorOp as $h_Lio_circe_CursorOp };
$h_Lio_circe_CursorOp.prototype = $c_Lio_circe_CursorOp.prototype;
$c_Lio_circe_CursorOp.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json($thiz, a) {
  $m_Lio_circe_Json$();
  var value = $thiz.encodeObject__O__Lio_circe_JsonObject(a);
  return new $c_Lio_circe_Json$JObject(value);
}
export { $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json as $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json };
class $c_Lio_circe_Error extends $c_jl_Exception {
  fillInStackTrace__jl_Throwable() {
    return this;
  }
}
export { $c_Lio_circe_Error as $c_Lio_circe_Error };
/** @constructor */
function $c_Lio_circe_Json() {
}
export { $c_Lio_circe_Json as $c_Lio_circe_Json };
$c_Lio_circe_Json.prototype = new $h_O();
$c_Lio_circe_Json.prototype.constructor = $c_Lio_circe_Json;
/** @constructor */
function $h_Lio_circe_Json() {
}
export { $h_Lio_circe_Json as $h_Lio_circe_Json };
$h_Lio_circe_Json.prototype = $c_Lio_circe_Json.prototype;
$c_Lio_circe_Json.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_Json.prototype.toString__T = (function() {
  return $m_Lio_circe_Printer$().Lio_circe_Printer$__f_spaces2.print__Lio_circe_Json__T(this);
});
$c_Lio_circe_Json.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_Lio_circe_Json) && $m_Lio_circe_Json$().Lio_circe_Json$__f_eqJson.eqv__O__O__Z(this, that));
});
function $isArrayOf_Lio_circe_Json(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json)));
}
export { $isArrayOf_Lio_circe_Json as $isArrayOf_Lio_circe_Json };
var $d_Lio_circe_Json = new $TypeData().initClass(0, "io.circe.Json", ({
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_Json as $d_Lio_circe_Json };
/** @constructor */
function $c_Lio_circe_JsonObject$$anon$2(outer) {
  this.Lio_circe_JsonObject$$anon$2__f_underlying = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var this$1 = outer.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1__f_$outer.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields;
  this.Lio_circe_JsonObject$$anon$2__f_underlying = new $c_ju_HashMap$KeySet(this$1).iterator__ju_Iterator();
}
export { $c_Lio_circe_JsonObject$$anon$2 as $c_Lio_circe_JsonObject$$anon$2 };
$c_Lio_circe_JsonObject$$anon$2.prototype = new $h_O();
$c_Lio_circe_JsonObject$$anon$2.prototype.constructor = $c_Lio_circe_JsonObject$$anon$2;
/** @constructor */
function $h_Lio_circe_JsonObject$$anon$2() {
}
export { $h_Lio_circe_JsonObject$$anon$2 as $h_Lio_circe_JsonObject$$anon$2 };
$h_Lio_circe_JsonObject$$anon$2.prototype = $c_Lio_circe_JsonObject$$anon$2.prototype;
$c_Lio_circe_JsonObject$$anon$2.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lio_circe_JsonObject$$anon$2.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lio_circe_JsonObject$$anon$2.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lio_circe_JsonObject$$anon$2.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lio_circe_JsonObject$$anon$2.prototype.hasNext__Z = (function() {
  return this.Lio_circe_JsonObject$$anon$2__f_underlying.hasNext__Z();
});
$c_Lio_circe_JsonObject$$anon$2.prototype.next__T = (function() {
  return this.Lio_circe_JsonObject$$anon$2__f_underlying.next__O();
});
$c_Lio_circe_JsonObject$$anon$2.prototype.next__O = (function() {
  return this.next__T();
});
var $d_Lio_circe_JsonObject$$anon$2 = new $TypeData().initClass($c_Lio_circe_JsonObject$$anon$2, "io.circe.JsonObject$$anon$2", ({
  Lio_circe_JsonObject$$anon$2: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
export { $d_Lio_circe_JsonObject$$anon$2 as $d_Lio_circe_JsonObject$$anon$2 };
/** @constructor */
function $c_Lio_circe_JsonObject$$anon$6(outer) {
  this.Lio_circe_JsonObject$$anon$6__f_underlying = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var this$1 = outer.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5__f_$outer.Lio_circe_JsonObject$LinkedHashMapJsonObject__f_io$circe$JsonObject$LinkedHashMapJsonObject$$fields;
  this.Lio_circe_JsonObject$$anon$6__f_underlying = new $c_ju_HashMap$EntrySet(this$1).iterator__ju_Iterator();
}
export { $c_Lio_circe_JsonObject$$anon$6 as $c_Lio_circe_JsonObject$$anon$6 };
$c_Lio_circe_JsonObject$$anon$6.prototype = new $h_O();
$c_Lio_circe_JsonObject$$anon$6.prototype.constructor = $c_Lio_circe_JsonObject$$anon$6;
/** @constructor */
function $h_Lio_circe_JsonObject$$anon$6() {
}
export { $h_Lio_circe_JsonObject$$anon$6 as $h_Lio_circe_JsonObject$$anon$6 };
$h_Lio_circe_JsonObject$$anon$6.prototype = $c_Lio_circe_JsonObject$$anon$6.prototype;
$c_Lio_circe_JsonObject$$anon$6.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_Lio_circe_JsonObject$$anon$6.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.drop__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, n, (-1));
});
$c_Lio_circe_JsonObject$$anon$6.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_Lio_circe_JsonObject$$anon$6.prototype.hasNext__Z = (function() {
  return this.Lio_circe_JsonObject$$anon$6__f_underlying.hasNext__Z();
});
$c_Lio_circe_JsonObject$$anon$6.prototype.next__T2 = (function() {
  var field = this.Lio_circe_JsonObject$$anon$6__f_underlying.next__O();
  var _1 = field.getKey__O();
  var _2 = field.getValue__O();
  return $ct_T2__O__O__(new $c_T2(), _1, _2);
});
$c_Lio_circe_JsonObject$$anon$6.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_Lio_circe_JsonObject$$anon$6 = new $TypeData().initClass($c_Lio_circe_JsonObject$$anon$6, "io.circe.JsonObject$$anon$6", ({
  Lio_circe_JsonObject$$anon$6: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_Iterator: 1
}));
export { $d_Lio_circe_JsonObject$$anon$6 as $d_Lio_circe_JsonObject$$anon$6 };
/** @constructor */
function $c_Lio_circe_PathToRoot(value) {
  this.Lio_circe_PathToRoot__f_value = null;
  this.Lio_circe_PathToRoot__f_value = value;
}
export { $c_Lio_circe_PathToRoot as $c_Lio_circe_PathToRoot };
$c_Lio_circe_PathToRoot.prototype = new $h_O();
$c_Lio_circe_PathToRoot.prototype.constructor = $c_Lio_circe_PathToRoot;
/** @constructor */
function $h_Lio_circe_PathToRoot() {
}
export { $h_Lio_circe_PathToRoot as $h_Lio_circe_PathToRoot };
$h_Lio_circe_PathToRoot.prototype = $c_Lio_circe_PathToRoot.prototype;
$c_Lio_circe_PathToRoot.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_PathToRoot.prototype.hashCode__I = (function() {
  $m_Lio_circe_PathToRoot$();
  var this$ = this.Lio_circe_PathToRoot__f_value;
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this$);
});
$c_Lio_circe_PathToRoot.prototype.equals__O__Z = (function(x$0) {
  return $m_Lio_circe_PathToRoot$().equals$extension__sci_Vector__O__Z(this.Lio_circe_PathToRoot__f_value, x$0);
});
$c_Lio_circe_PathToRoot.prototype.toString__T = (function() {
  return $m_Lio_circe_PathToRoot$().toString$extension__sci_Vector__T(this.Lio_circe_PathToRoot__f_value);
});
$c_Lio_circe_PathToRoot.prototype.productArity__I = (function() {
  $m_Lio_circe_PathToRoot$();
  return 1;
});
$c_Lio_circe_PathToRoot.prototype.productPrefix__T = (function() {
  $m_Lio_circe_PathToRoot$();
  return "PathToRoot";
});
$c_Lio_circe_PathToRoot.prototype.productElement__I__O = (function(n) {
  return $m_Lio_circe_PathToRoot$().productElement$extension__sci_Vector__I__O(this.Lio_circe_PathToRoot__f_value, n);
});
$c_Lio_circe_PathToRoot.prototype.productElementName__I__T = (function(n) {
  return $m_Lio_circe_PathToRoot$().productElementName$extension__sci_Vector__I__T(this.Lio_circe_PathToRoot__f_value, n);
});
function $isArrayOf_Lio_circe_PathToRoot(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_PathToRoot)));
}
export { $isArrayOf_Lio_circe_PathToRoot as $isArrayOf_Lio_circe_PathToRoot };
var $d_Lio_circe_PathToRoot = new $TypeData().initClass($c_Lio_circe_PathToRoot, "io.circe.PathToRoot", ({
  Lio_circe_PathToRoot: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_PathToRoot as $d_Lio_circe_PathToRoot };
/** @constructor */
function $c_Lio_circe_PathToRoot$PathElem() {
}
export { $c_Lio_circe_PathToRoot$PathElem as $c_Lio_circe_PathToRoot$PathElem };
$c_Lio_circe_PathToRoot$PathElem.prototype = new $h_O();
$c_Lio_circe_PathToRoot$PathElem.prototype.constructor = $c_Lio_circe_PathToRoot$PathElem;
/** @constructor */
function $h_Lio_circe_PathToRoot$PathElem() {
}
export { $h_Lio_circe_PathToRoot$PathElem as $h_Lio_circe_PathToRoot$PathElem };
$h_Lio_circe_PathToRoot$PathElem.prototype = $c_Lio_circe_PathToRoot$PathElem.prototype;
$c_Lio_circe_PathToRoot$PathElem.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $p_Lio_circe_Printer__concat__T__T__T__T($thiz, left, text, right) {
  var builder = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + left);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + text);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + builder.jl_StringBuilder__f_java$lang$StringBuilder$$content) + right);
  return builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
}
export { $p_Lio_circe_Printer__concat__T__T__T__T as $p_Lio_circe_Printer__concat__T__T__T__T };
/** @constructor */
function $c_Lio_circe_Printer(dropNullValues, indent, lbraceLeft, lbraceRight, rbraceLeft, rbraceRight, lbracketLeft, lbracketRight, rbracketLeft, rbracketRight, lrbracketsEmpty, arrayCommaLeft, arrayCommaRight, objectCommaLeft, objectCommaRight, colonLeft, colonRight, reuseWriters, predictSize, escapeNonAscii, sortKeys) {
  this.Lio_circe_Printer__f_dropNullValues = false;
  this.Lio_circe_Printer__f_indent = null;
  this.Lio_circe_Printer__f_lbraceLeft = null;
  this.Lio_circe_Printer__f_lbraceRight = null;
  this.Lio_circe_Printer__f_rbraceLeft = null;
  this.Lio_circe_Printer__f_rbraceRight = null;
  this.Lio_circe_Printer__f_lbracketLeft = null;
  this.Lio_circe_Printer__f_lbracketRight = null;
  this.Lio_circe_Printer__f_rbracketLeft = null;
  this.Lio_circe_Printer__f_rbracketRight = null;
  this.Lio_circe_Printer__f_lrbracketsEmpty = null;
  this.Lio_circe_Printer__f_arrayCommaLeft = null;
  this.Lio_circe_Printer__f_arrayCommaRight = null;
  this.Lio_circe_Printer__f_objectCommaLeft = null;
  this.Lio_circe_Printer__f_objectCommaRight = null;
  this.Lio_circe_Printer__f_colonLeft = null;
  this.Lio_circe_Printer__f_colonRight = null;
  this.Lio_circe_Printer__f_reuseWriters = false;
  this.Lio_circe_Printer__f_predictSize = false;
  this.Lio_circe_Printer__f_escapeNonAscii = false;
  this.Lio_circe_Printer__f_sortKeys = false;
  this.Lio_circe_Printer__f_io$circe$Printer$$pieces = null;
  this.Lio_circe_Printer__f_stringWriter = null;
  this.Lio_circe_Printer__f_dropNullValues = dropNullValues;
  this.Lio_circe_Printer__f_indent = indent;
  this.Lio_circe_Printer__f_lbraceLeft = lbraceLeft;
  this.Lio_circe_Printer__f_lbraceRight = lbraceRight;
  this.Lio_circe_Printer__f_rbraceLeft = rbraceLeft;
  this.Lio_circe_Printer__f_rbraceRight = rbraceRight;
  this.Lio_circe_Printer__f_lbracketLeft = lbracketLeft;
  this.Lio_circe_Printer__f_lbracketRight = lbracketRight;
  this.Lio_circe_Printer__f_rbracketLeft = rbracketLeft;
  this.Lio_circe_Printer__f_rbracketRight = rbracketRight;
  this.Lio_circe_Printer__f_lrbracketsEmpty = lrbracketsEmpty;
  this.Lio_circe_Printer__f_arrayCommaLeft = arrayCommaLeft;
  this.Lio_circe_Printer__f_arrayCommaRight = arrayCommaRight;
  this.Lio_circe_Printer__f_objectCommaLeft = objectCommaLeft;
  this.Lio_circe_Printer__f_objectCommaRight = objectCommaRight;
  this.Lio_circe_Printer__f_colonLeft = colonLeft;
  this.Lio_circe_Printer__f_colonRight = colonRight;
  this.Lio_circe_Printer__f_reuseWriters = reuseWriters;
  this.Lio_circe_Printer__f_predictSize = predictSize;
  this.Lio_circe_Printer__f_escapeNonAscii = escapeNonAscii;
  this.Lio_circe_Printer__f_sortKeys = sortKeys;
  if ((indent === "")) {
    var lBraces = $p_Lio_circe_Printer__concat__T__T__T__T(this, lbraceLeft, "{", lbraceRight);
    var rBraces = $p_Lio_circe_Printer__concat__T__T__T__T(this, rbraceRight, "}", rbraceLeft);
    var lBrackets = $p_Lio_circe_Printer__concat__T__T__T__T(this, lbracketLeft, "[", lbracketRight);
    var rBrackets = $p_Lio_circe_Printer__concat__T__T__T__T(this, rbracketLeft, "]", rbracketRight);
    var lrEmptyBrackets = $p_Lio_circe_Printer__concat__T__T__T__T(this, "[", lrbracketsEmpty, "]");
    var arrayCommas = $p_Lio_circe_Printer__concat__T__T__T__T(this, arrayCommaLeft, ",", arrayCommaRight);
    var objectCommas = $p_Lio_circe_Printer__concat__T__T__T__T(this, objectCommaLeft, ",", objectCommaRight);
    var colons = $p_Lio_circe_Printer__concat__T__T__T__T(this, colonLeft, ":", colonRight);
    var $x_1 = new $c_Lio_circe_Printer$ConstantPieces(new $c_Lio_circe_Printer$Pieces(lBraces, rBraces, lBrackets, rBrackets, lrEmptyBrackets, arrayCommas, objectCommas, colons));
  } else {
    var $x_1 = new $c_Lio_circe_Printer$$anon$1(this);
  }
  this.Lio_circe_Printer__f_io$circe$Printer$$pieces = $x_1;
  this.Lio_circe_Printer__f_stringWriter = new $c_Lio_circe_Printer$$anon$2();
}
export { $c_Lio_circe_Printer as $c_Lio_circe_Printer };
$c_Lio_circe_Printer.prototype = new $h_O();
$c_Lio_circe_Printer.prototype.constructor = $c_Lio_circe_Printer;
/** @constructor */
function $h_Lio_circe_Printer() {
}
export { $h_Lio_circe_Printer as $h_Lio_circe_Printer };
$h_Lio_circe_Printer.prototype = $c_Lio_circe_Printer.prototype;
$c_Lio_circe_Printer.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_Printer.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Printer");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lio_circe_Printer__f_dropNullValues ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lio_circe_Printer__f_indent;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lio_circe_Printer__f_lbraceLeft;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.Lio_circe_Printer__f_lbraceRight;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.Lio_circe_Printer__f_rbraceLeft;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.Lio_circe_Printer__f_rbraceRight;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.Lio_circe_Printer__f_lbracketLeft;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$6 = this.Lio_circe_Printer__f_lbracketRight;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  var x$7 = this.Lio_circe_Printer__f_rbracketLeft;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$9);
  var hash$10 = acc;
  var x$8 = this.Lio_circe_Printer__f_rbracketRight;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$8);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$10);
  var hash$11 = acc;
  var x$9 = this.Lio_circe_Printer__f_lrbracketsEmpty;
  var data$11 = $m_sr_Statics$().anyHash__O__I(x$9);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$11);
  var hash$12 = acc;
  var x$10 = this.Lio_circe_Printer__f_arrayCommaLeft;
  var data$12 = $m_sr_Statics$().anyHash__O__I(x$10);
  acc = $m_sr_Statics$().mix__I__I__I(hash$12, data$12);
  var hash$13 = acc;
  var x$11 = this.Lio_circe_Printer__f_arrayCommaRight;
  var data$13 = $m_sr_Statics$().anyHash__O__I(x$11);
  acc = $m_sr_Statics$().mix__I__I__I(hash$13, data$13);
  var hash$14 = acc;
  var x$12 = this.Lio_circe_Printer__f_objectCommaLeft;
  var data$14 = $m_sr_Statics$().anyHash__O__I(x$12);
  acc = $m_sr_Statics$().mix__I__I__I(hash$14, data$14);
  var hash$15 = acc;
  var x$13 = this.Lio_circe_Printer__f_objectCommaRight;
  var data$15 = $m_sr_Statics$().anyHash__O__I(x$13);
  acc = $m_sr_Statics$().mix__I__I__I(hash$15, data$15);
  var hash$16 = acc;
  var x$14 = this.Lio_circe_Printer__f_colonLeft;
  var data$16 = $m_sr_Statics$().anyHash__O__I(x$14);
  acc = $m_sr_Statics$().mix__I__I__I(hash$16, data$16);
  var hash$17 = acc;
  var x$15 = this.Lio_circe_Printer__f_colonRight;
  var data$17 = $m_sr_Statics$().anyHash__O__I(x$15);
  acc = $m_sr_Statics$().mix__I__I__I(hash$17, data$17);
  var hash$18 = acc;
  var data$18 = (this.Lio_circe_Printer__f_reuseWriters ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$18, data$18);
  var hash$19 = acc;
  var data$19 = (this.Lio_circe_Printer__f_predictSize ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$19, data$19);
  var hash$20 = acc;
  var data$20 = (this.Lio_circe_Printer__f_escapeNonAscii ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$20, data$20);
  var hash$21 = acc;
  var data$21 = (this.Lio_circe_Printer__f_sortKeys ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$21, data$21);
  var hash$22 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$22, 21);
});
$c_Lio_circe_Printer.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_circe_Printer) && (((((((((((((((((((((this.Lio_circe_Printer__f_dropNullValues === x$0.Lio_circe_Printer__f_dropNullValues) && (this.Lio_circe_Printer__f_reuseWriters === x$0.Lio_circe_Printer__f_reuseWriters)) && (this.Lio_circe_Printer__f_predictSize === x$0.Lio_circe_Printer__f_predictSize)) && (this.Lio_circe_Printer__f_escapeNonAscii === x$0.Lio_circe_Printer__f_escapeNonAscii)) && (this.Lio_circe_Printer__f_sortKeys === x$0.Lio_circe_Printer__f_sortKeys)) && (this.Lio_circe_Printer__f_indent === x$0.Lio_circe_Printer__f_indent)) && (this.Lio_circe_Printer__f_lbraceLeft === x$0.Lio_circe_Printer__f_lbraceLeft)) && (this.Lio_circe_Printer__f_lbraceRight === x$0.Lio_circe_Printer__f_lbraceRight)) && (this.Lio_circe_Printer__f_rbraceLeft === x$0.Lio_circe_Printer__f_rbraceLeft)) && (this.Lio_circe_Printer__f_rbraceRight === x$0.Lio_circe_Printer__f_rbraceRight)) && (this.Lio_circe_Printer__f_lbracketLeft === x$0.Lio_circe_Printer__f_lbracketLeft)) && (this.Lio_circe_Printer__f_lbracketRight === x$0.Lio_circe_Printer__f_lbracketRight)) && (this.Lio_circe_Printer__f_rbracketLeft === x$0.Lio_circe_Printer__f_rbracketLeft)) && (this.Lio_circe_Printer__f_rbracketRight === x$0.Lio_circe_Printer__f_rbracketRight)) && (this.Lio_circe_Printer__f_lrbracketsEmpty === x$0.Lio_circe_Printer__f_lrbracketsEmpty)) && (this.Lio_circe_Printer__f_arrayCommaLeft === x$0.Lio_circe_Printer__f_arrayCommaLeft)) && (this.Lio_circe_Printer__f_arrayCommaRight === x$0.Lio_circe_Printer__f_arrayCommaRight)) && (this.Lio_circe_Printer__f_objectCommaLeft === x$0.Lio_circe_Printer__f_objectCommaLeft)) && (this.Lio_circe_Printer__f_objectCommaRight === x$0.Lio_circe_Printer__f_objectCommaRight)) && (this.Lio_circe_Printer__f_colonLeft === x$0.Lio_circe_Printer__f_colonLeft)) && (this.Lio_circe_Printer__f_colonRight === x$0.Lio_circe_Printer__f_colonRight))));
});
$c_Lio_circe_Printer.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_Printer.prototype.productArity__I = (function() {
  return 21;
});
$c_Lio_circe_Printer.prototype.productPrefix__T = (function() {
  return "Printer";
});
$c_Lio_circe_Printer.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lio_circe_Printer__f_dropNullValues;
      break;
    }
    case 1: {
      return this.Lio_circe_Printer__f_indent;
      break;
    }
    case 2: {
      return this.Lio_circe_Printer__f_lbraceLeft;
      break;
    }
    case 3: {
      return this.Lio_circe_Printer__f_lbraceRight;
      break;
    }
    case 4: {
      return this.Lio_circe_Printer__f_rbraceLeft;
      break;
    }
    case 5: {
      return this.Lio_circe_Printer__f_rbraceRight;
      break;
    }
    case 6: {
      return this.Lio_circe_Printer__f_lbracketLeft;
      break;
    }
    case 7: {
      return this.Lio_circe_Printer__f_lbracketRight;
      break;
    }
    case 8: {
      return this.Lio_circe_Printer__f_rbracketLeft;
      break;
    }
    case 9: {
      return this.Lio_circe_Printer__f_rbracketRight;
      break;
    }
    case 10: {
      return this.Lio_circe_Printer__f_lrbracketsEmpty;
      break;
    }
    case 11: {
      return this.Lio_circe_Printer__f_arrayCommaLeft;
      break;
    }
    case 12: {
      return this.Lio_circe_Printer__f_arrayCommaRight;
      break;
    }
    case 13: {
      return this.Lio_circe_Printer__f_objectCommaLeft;
      break;
    }
    case 14: {
      return this.Lio_circe_Printer__f_objectCommaRight;
      break;
    }
    case 15: {
      return this.Lio_circe_Printer__f_colonLeft;
      break;
    }
    case 16: {
      return this.Lio_circe_Printer__f_colonRight;
      break;
    }
    case 17: {
      return this.Lio_circe_Printer__f_reuseWriters;
      break;
    }
    case 18: {
      return this.Lio_circe_Printer__f_predictSize;
      break;
    }
    case 19: {
      return this.Lio_circe_Printer__f_escapeNonAscii;
      break;
    }
    case 20: {
      return this.Lio_circe_Printer__f_sortKeys;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lio_circe_Printer.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "dropNullValues";
      break;
    }
    case 1: {
      return "indent";
      break;
    }
    case 2: {
      return "lbraceLeft";
      break;
    }
    case 3: {
      return "lbraceRight";
      break;
    }
    case 4: {
      return "rbraceLeft";
      break;
    }
    case 5: {
      return "rbraceRight";
      break;
    }
    case 6: {
      return "lbracketLeft";
      break;
    }
    case 7: {
      return "lbracketRight";
      break;
    }
    case 8: {
      return "rbracketLeft";
      break;
    }
    case 9: {
      return "rbracketRight";
      break;
    }
    case 10: {
      return "lrbracketsEmpty";
      break;
    }
    case 11: {
      return "arrayCommaLeft";
      break;
    }
    case 12: {
      return "arrayCommaRight";
      break;
    }
    case 13: {
      return "objectCommaLeft";
      break;
    }
    case 14: {
      return "objectCommaRight";
      break;
    }
    case 15: {
      return "colonLeft";
      break;
    }
    case 16: {
      return "colonRight";
      break;
    }
    case 17: {
      return "reuseWriters";
      break;
    }
    case 18: {
      return "predictSize";
      break;
    }
    case 19: {
      return "escapeNonAscii";
      break;
    }
    case 20: {
      return "sortKeys";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lio_circe_Printer.prototype.print__Lio_circe_Json__T = (function(json) {
  if ((this.Lio_circe_Printer__f_reuseWriters && (this.Lio_circe_Printer__f_stringWriter !== null))) {
    var w = this.Lio_circe_Printer__f_stringWriter.get__O();
    w.setLength__I__V(0);
    var writer = w;
  } else {
    var writer = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  }
  this.unsafePrintToAppendable__Lio_circe_Json__jl_Appendable__V(json, writer);
  return writer.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Lio_circe_Printer.prototype.unsafePrintToAppendable__Lio_circe_Json__jl_Appendable__V = (function(json, out) {
  var folder = new $c_Lio_circe_Printer$AppendableFolder(this, out);
  json.foldWith__Lio_circe_Json$Folder__O(folder);
});
function $isArrayOf_Lio_circe_Printer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Printer)));
}
export { $isArrayOf_Lio_circe_Printer as $isArrayOf_Lio_circe_Printer };
var $d_Lio_circe_Printer = new $TypeData().initClass($c_Lio_circe_Printer, "io.circe.Printer", ({
  Lio_circe_Printer: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_Printer as $d_Lio_circe_Printer };
/** @constructor */
function $c_Lio_circe_Printer$$anon$1(outer) {
  this.Lio_circe_Printer$MemoizedPieces__f_indent = null;
  this.Lio_circe_Printer$MemoizedPieces__f_known = null;
  this.Lio_circe_Printer$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lio_circe_Printer$$anon$1__f_$outer = outer;
  $ct_Lio_circe_Printer$MemoizedPieces__T__(this, outer.Lio_circe_Printer__f_indent);
}
export { $c_Lio_circe_Printer$$anon$1 as $c_Lio_circe_Printer$$anon$1 };
$c_Lio_circe_Printer$$anon$1.prototype = new $h_Lio_circe_Printer$MemoizedPieces();
$c_Lio_circe_Printer$$anon$1.prototype.constructor = $c_Lio_circe_Printer$$anon$1;
/** @constructor */
function $h_Lio_circe_Printer$$anon$1() {
}
export { $h_Lio_circe_Printer$$anon$1 as $h_Lio_circe_Printer$$anon$1 };
$h_Lio_circe_Printer$$anon$1.prototype = $c_Lio_circe_Printer$$anon$1.prototype;
$c_Lio_circe_Printer$$anon$1.prototype.compute__I__Lio_circe_Printer$Pieces = (function(i) {
  var builder = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_lbraceLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "{");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_lbraceRight, ((1 + i) | 0));
  var lBraces = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_rbraceLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "}");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_rbraceRight, ((1 + i) | 0));
  var rBraces = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_lbracketLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "[");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_lbracketRight, ((1 + i) | 0));
  var lBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_rbracketLeft, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "]");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_rbracketRight, ((1 + i) | 0));
  var rBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "[");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_lrbracketsEmpty, i);
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + "]");
  var lrEmptyBrackets = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_arrayCommaLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_arrayCommaRight, ((1 + i) | 0));
  var arrayCommas = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_objectCommaLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ",");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_objectCommaRight, ((1 + i) | 0));
  var objectCommas = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  builder.setLength__I__V(0);
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_colonLeft, ((1 + i) | 0));
  builder.jl_StringBuilder__f_java$lang$StringBuilder$$content = (builder.jl_StringBuilder__f_java$lang$StringBuilder$$content + ":");
  this.addIndentation__jl_StringBuilder__T__I__V(builder, this.Lio_circe_Printer$$anon$1__f_$outer.Lio_circe_Printer__f_colonRight, ((1 + i) | 0));
  var colons = builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return new $c_Lio_circe_Printer$Pieces(lBraces, rBraces, lBrackets, rBrackets, lrEmptyBrackets, arrayCommas, objectCommas, colons);
});
var $d_Lio_circe_Printer$$anon$1 = new $TypeData().initClass($c_Lio_circe_Printer$$anon$1, "io.circe.Printer$$anon$1", ({
  Lio_circe_Printer$$anon$1: 1,
  Lio_circe_Printer$MemoizedPieces: 1,
  Lio_circe_Printer$PiecesAtDepth: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_Printer$$anon$1 as $d_Lio_circe_Printer$$anon$1 };
/** @constructor */
function $c_Lio_circe_Printer$AppendableFolder(outer, writer) {
  this.Lio_circe_Printer$PrintingFolder__f_writer = null;
  this.Lio_circe_Printer$PrintingFolder__f_pieces = null;
  this.Lio_circe_Printer$PrintingFolder__f_dropNullValues = false;
  this.Lio_circe_Printer$PrintingFolder__f_escapeNonAscii = false;
  this.Lio_circe_Printer$PrintingFolder__f_sortKeys = false;
  this.Lio_circe_Printer$PrintingFolder__f_depth = 0;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $ct_Lio_circe_Printer$PrintingFolder__jl_Appendable__Lio_circe_Printer$PiecesAtDepth__Z__Z__Z__(this, writer, outer.Lio_circe_Printer__f_io$circe$Printer$$pieces, outer.Lio_circe_Printer__f_dropNullValues, outer.Lio_circe_Printer__f_escapeNonAscii, outer.Lio_circe_Printer__f_sortKeys);
}
export { $c_Lio_circe_Printer$AppendableFolder as $c_Lio_circe_Printer$AppendableFolder };
$c_Lio_circe_Printer$AppendableFolder.prototype = new $h_Lio_circe_Printer$PrintingFolder();
$c_Lio_circe_Printer$AppendableFolder.prototype.constructor = $c_Lio_circe_Printer$AppendableFolder;
/** @constructor */
function $h_Lio_circe_Printer$AppendableFolder() {
}
export { $h_Lio_circe_Printer$AppendableFolder as $h_Lio_circe_Printer$AppendableFolder };
$h_Lio_circe_Printer$AppendableFolder.prototype = $c_Lio_circe_Printer$AppendableFolder.prototype;
$c_Lio_circe_Printer$AppendableFolder.prototype.onBoolean__Z__V = (function(value) {
  this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(("" + value));
});
$c_Lio_circe_Printer$AppendableFolder.prototype.onBoolean__Z__O = (function(value) {
  this.onBoolean__Z__V(value);
});
$c_Lio_circe_Printer$AppendableFolder.prototype.onNumber__Lio_circe_JsonNumber__O = (function(value) {
  this.Lio_circe_Printer$PrintingFolder__f_writer.append__jl_CharSequence__jl_Appendable(value.toString__T());
});
var $d_Lio_circe_Printer$AppendableFolder = new $TypeData().initClass($c_Lio_circe_Printer$AppendableFolder, "io.circe.Printer$AppendableFolder", ({
  Lio_circe_Printer$AppendableFolder: 1,
  Lio_circe_Printer$PrintingFolder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Json$Folder: 1
}));
export { $d_Lio_circe_Printer$AppendableFolder as $d_Lio_circe_Printer$AppendableFolder };
/** @constructor */
function $c_Lio_circe_Printer$Pieces(lBraces, rBraces, lBrackets, rBrackets, lrEmptyBrackets, arrayCommas, objectCommas, colons) {
  this.Lio_circe_Printer$Pieces__f_lBraces = null;
  this.Lio_circe_Printer$Pieces__f_rBraces = null;
  this.Lio_circe_Printer$Pieces__f_lBrackets = null;
  this.Lio_circe_Printer$Pieces__f_rBrackets = null;
  this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets = null;
  this.Lio_circe_Printer$Pieces__f_arrayCommas = null;
  this.Lio_circe_Printer$Pieces__f_objectCommas = null;
  this.Lio_circe_Printer$Pieces__f_colons = null;
  this.Lio_circe_Printer$Pieces__f_lBraces = lBraces;
  this.Lio_circe_Printer$Pieces__f_rBraces = rBraces;
  this.Lio_circe_Printer$Pieces__f_lBrackets = lBrackets;
  this.Lio_circe_Printer$Pieces__f_rBrackets = rBrackets;
  this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets = lrEmptyBrackets;
  this.Lio_circe_Printer$Pieces__f_arrayCommas = arrayCommas;
  this.Lio_circe_Printer$Pieces__f_objectCommas = objectCommas;
  this.Lio_circe_Printer$Pieces__f_colons = colons;
}
export { $c_Lio_circe_Printer$Pieces as $c_Lio_circe_Printer$Pieces };
$c_Lio_circe_Printer$Pieces.prototype = new $h_O();
$c_Lio_circe_Printer$Pieces.prototype.constructor = $c_Lio_circe_Printer$Pieces;
/** @constructor */
function $h_Lio_circe_Printer$Pieces() {
}
export { $h_Lio_circe_Printer$Pieces as $h_Lio_circe_Printer$Pieces };
$h_Lio_circe_Printer$Pieces.prototype = $c_Lio_circe_Printer$Pieces.prototype;
$c_Lio_circe_Printer$Pieces.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_Printer$Pieces.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_circe_Printer$Pieces.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_circe_Printer$Pieces) && ((((((((this.Lio_circe_Printer$Pieces__f_lBraces === x$0.Lio_circe_Printer$Pieces__f_lBraces) && (this.Lio_circe_Printer$Pieces__f_rBraces === x$0.Lio_circe_Printer$Pieces__f_rBraces)) && (this.Lio_circe_Printer$Pieces__f_lBrackets === x$0.Lio_circe_Printer$Pieces__f_lBrackets)) && (this.Lio_circe_Printer$Pieces__f_rBrackets === x$0.Lio_circe_Printer$Pieces__f_rBrackets)) && (this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets === x$0.Lio_circe_Printer$Pieces__f_lrEmptyBrackets)) && (this.Lio_circe_Printer$Pieces__f_arrayCommas === x$0.Lio_circe_Printer$Pieces__f_arrayCommas)) && (this.Lio_circe_Printer$Pieces__f_objectCommas === x$0.Lio_circe_Printer$Pieces__f_objectCommas)) && (this.Lio_circe_Printer$Pieces__f_colons === x$0.Lio_circe_Printer$Pieces__f_colons))));
});
$c_Lio_circe_Printer$Pieces.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_Printer$Pieces.prototype.productArity__I = (function() {
  return 8;
});
$c_Lio_circe_Printer$Pieces.prototype.productPrefix__T = (function() {
  return "Pieces";
});
$c_Lio_circe_Printer$Pieces.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lio_circe_Printer$Pieces__f_lBraces;
      break;
    }
    case 1: {
      return this.Lio_circe_Printer$Pieces__f_rBraces;
      break;
    }
    case 2: {
      return this.Lio_circe_Printer$Pieces__f_lBrackets;
      break;
    }
    case 3: {
      return this.Lio_circe_Printer$Pieces__f_rBrackets;
      break;
    }
    case 4: {
      return this.Lio_circe_Printer$Pieces__f_lrEmptyBrackets;
      break;
    }
    case 5: {
      return this.Lio_circe_Printer$Pieces__f_arrayCommas;
      break;
    }
    case 6: {
      return this.Lio_circe_Printer$Pieces__f_objectCommas;
      break;
    }
    case 7: {
      return this.Lio_circe_Printer$Pieces__f_colons;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lio_circe_Printer$Pieces.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "lBraces";
      break;
    }
    case 1: {
      return "rBraces";
      break;
    }
    case 2: {
      return "lBrackets";
      break;
    }
    case 3: {
      return "rBrackets";
      break;
    }
    case 4: {
      return "lrEmptyBrackets";
      break;
    }
    case 5: {
      return "arrayCommas";
      break;
    }
    case 6: {
      return "objectCommas";
      break;
    }
    case 7: {
      return "colons";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_circe_Printer$Pieces(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Printer$Pieces)));
}
export { $isArrayOf_Lio_circe_Printer$Pieces as $isArrayOf_Lio_circe_Printer$Pieces };
var $d_Lio_circe_Printer$Pieces = new $TypeData().initClass($c_Lio_circe_Printer$Pieces, "io.circe.Printer$Pieces", ({
  Lio_circe_Printer$Pieces: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lio_circe_Printer$Pieces as $d_Lio_circe_Printer$Pieces };
function $p_Lio_circe_cursor_ArrayCursor__valuesExcept__sci_Vector($thiz) {
  var this$1 = $thiz.Lio_circe_cursor_ArrayCursor__f_values;
  var n = $thiz.Lio_circe_cursor_ArrayCursor__f_indexValue;
  var this$3 = this$1.slice__I__I__sci_Vector(0, n);
  var this$2 = $thiz.Lio_circe_cursor_ArrayCursor__f_values;
  var n$1 = ((1 + $thiz.Lio_circe_cursor_ArrayCursor__f_indexValue) | 0);
  var until = this$2.length__I();
  var suffix = this$2.slice__I__I__sci_Vector(n$1, until);
  return this$3.appendedAll__sc_IterableOnce__sci_Vector(suffix);
}
export { $p_Lio_circe_cursor_ArrayCursor__valuesExcept__sci_Vector as $p_Lio_circe_cursor_ArrayCursor__valuesExcept__sci_Vector };
/** @constructor */
function $c_Lio_circe_cursor_ArrayCursor(values, indexValue, parent, changed, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_ArrayCursor__f_values = null;
  this.Lio_circe_cursor_ArrayCursor__f_indexValue = 0;
  this.Lio_circe_cursor_ArrayCursor__f_parent = null;
  this.Lio_circe_cursor_ArrayCursor__f_changed = false;
  this.Lio_circe_cursor_ArrayCursor__f_values = values;
  this.Lio_circe_cursor_ArrayCursor__f_indexValue = indexValue;
  this.Lio_circe_cursor_ArrayCursor__f_parent = parent;
  this.Lio_circe_cursor_ArrayCursor__f_changed = changed;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp);
}
export { $c_Lio_circe_cursor_ArrayCursor as $c_Lio_circe_cursor_ArrayCursor };
$c_Lio_circe_cursor_ArrayCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_ArrayCursor.prototype.constructor = $c_Lio_circe_cursor_ArrayCursor;
/** @constructor */
function $h_Lio_circe_cursor_ArrayCursor() {
}
export { $h_Lio_circe_cursor_ArrayCursor as $h_Lio_circe_cursor_ArrayCursor };
$h_Lio_circe_cursor_ArrayCursor.prototype = $c_Lio_circe_cursor_ArrayCursor.prototype;
$c_Lio_circe_cursor_ArrayCursor.prototype.value__Lio_circe_Json = (function() {
  return this.Lio_circe_cursor_ArrayCursor__f_values.apply__I__O(this.Lio_circe_cursor_ArrayCursor__f_indexValue);
});
$c_Lio_circe_cursor_ArrayCursor.prototype.replace__Lio_circe_Json__Lio_circe_HCursor__Lio_circe_CursorOp__Lio_circe_HCursor = (function(newValue, cursor, op) {
  return new $c_Lio_circe_cursor_ArrayCursor(this.Lio_circe_cursor_ArrayCursor__f_values.updated__I__O__sci_Vector(this.Lio_circe_cursor_ArrayCursor__f_indexValue, newValue), this.Lio_circe_cursor_ArrayCursor__f_indexValue, this.Lio_circe_cursor_ArrayCursor__f_parent, true, cursor, op);
});
$c_Lio_circe_cursor_ArrayCursor.prototype.delete__Lio_circe_ACursor = (function() {
  return this.Lio_circe_cursor_ArrayCursor__f_parent.replace__Lio_circe_Json__Lio_circe_HCursor__Lio_circe_CursorOp__Lio_circe_HCursor($m_Lio_circe_Json$().fromValues__sc_Iterable__Lio_circe_Json($p_Lio_circe_cursor_ArrayCursor__valuesExcept__sci_Vector(this)), this, $m_Lio_circe_CursorOp$DeleteGoParent$());
});
$c_Lio_circe_cursor_ArrayCursor.prototype.right__Lio_circe_ACursor = (function() {
  var $x_1 = this.Lio_circe_cursor_ArrayCursor__f_indexValue;
  var this$1 = this.Lio_circe_cursor_ArrayCursor__f_values;
  if (($x_1 === (((-1) + this$1.length__I()) | 0))) {
    var op = $m_Lio_circe_CursorOp$MoveRight$();
    return new $c_Lio_circe_FailedCursor(this, op);
  } else {
    return new $c_Lio_circe_cursor_ArrayCursor(this.Lio_circe_cursor_ArrayCursor__f_values, ((1 + this.Lio_circe_cursor_ArrayCursor__f_indexValue) | 0), this.Lio_circe_cursor_ArrayCursor__f_parent, this.Lio_circe_cursor_ArrayCursor__f_changed, this, $m_Lio_circe_CursorOp$MoveRight$());
  }
});
function $isArrayOf_Lio_circe_cursor_ArrayCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_cursor_ArrayCursor)));
}
export { $isArrayOf_Lio_circe_cursor_ArrayCursor as $isArrayOf_Lio_circe_cursor_ArrayCursor };
var $d_Lio_circe_cursor_ArrayCursor = new $TypeData().initClass($c_Lio_circe_cursor_ArrayCursor, "io.circe.cursor.ArrayCursor", ({
  Lio_circe_cursor_ArrayCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_cursor_ArrayCursor as $d_Lio_circe_cursor_ArrayCursor };
/** @constructor */
function $c_Lio_circe_cursor_ObjectCursor(obj, keyValue, parent, changed, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_ObjectCursor__f_obj = null;
  this.Lio_circe_cursor_ObjectCursor__f_keyValue = null;
  this.Lio_circe_cursor_ObjectCursor__f_parent = null;
  this.Lio_circe_cursor_ObjectCursor__f_obj = obj;
  this.Lio_circe_cursor_ObjectCursor__f_keyValue = keyValue;
  this.Lio_circe_cursor_ObjectCursor__f_parent = parent;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp);
}
export { $c_Lio_circe_cursor_ObjectCursor as $c_Lio_circe_cursor_ObjectCursor };
$c_Lio_circe_cursor_ObjectCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_ObjectCursor.prototype.constructor = $c_Lio_circe_cursor_ObjectCursor;
/** @constructor */
function $h_Lio_circe_cursor_ObjectCursor() {
}
export { $h_Lio_circe_cursor_ObjectCursor as $h_Lio_circe_cursor_ObjectCursor };
$h_Lio_circe_cursor_ObjectCursor.prototype = $c_Lio_circe_cursor_ObjectCursor.prototype;
$c_Lio_circe_cursor_ObjectCursor.prototype.value__Lio_circe_Json = (function() {
  return this.Lio_circe_cursor_ObjectCursor__f_obj.applyUnsafe__T__Lio_circe_Json(this.Lio_circe_cursor_ObjectCursor__f_keyValue);
});
$c_Lio_circe_cursor_ObjectCursor.prototype.replace__Lio_circe_Json__Lio_circe_HCursor__Lio_circe_CursorOp__Lio_circe_HCursor = (function(newValue, cursor, op) {
  return new $c_Lio_circe_cursor_ObjectCursor(this.Lio_circe_cursor_ObjectCursor__f_obj.add__T__Lio_circe_Json__Lio_circe_JsonObject(this.Lio_circe_cursor_ObjectCursor__f_keyValue, newValue), this.Lio_circe_cursor_ObjectCursor__f_keyValue, this.Lio_circe_cursor_ObjectCursor__f_parent, true, cursor, op);
});
$c_Lio_circe_cursor_ObjectCursor.prototype.delete__Lio_circe_ACursor = (function() {
  var $x_1 = this.Lio_circe_cursor_ObjectCursor__f_parent;
  $m_Lio_circe_Json$();
  var value = this.Lio_circe_cursor_ObjectCursor__f_obj.remove__T__Lio_circe_JsonObject(this.Lio_circe_cursor_ObjectCursor__f_keyValue);
  return $x_1.replace__Lio_circe_Json__Lio_circe_HCursor__Lio_circe_CursorOp__Lio_circe_HCursor(new $c_Lio_circe_Json$JObject(value), this, $m_Lio_circe_CursorOp$DeleteGoParent$());
});
$c_Lio_circe_cursor_ObjectCursor.prototype.right__Lio_circe_ACursor = (function() {
  var op = $m_Lio_circe_CursorOp$MoveRight$();
  return new $c_Lio_circe_FailedCursor(this, op);
});
function $isArrayOf_Lio_circe_cursor_ObjectCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_cursor_ObjectCursor)));
}
export { $isArrayOf_Lio_circe_cursor_ObjectCursor as $isArrayOf_Lio_circe_cursor_ObjectCursor };
var $d_Lio_circe_cursor_ObjectCursor = new $TypeData().initClass($c_Lio_circe_cursor_ObjectCursor, "io.circe.cursor.ObjectCursor", ({
  Lio_circe_cursor_ObjectCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_cursor_ObjectCursor as $d_Lio_circe_cursor_ObjectCursor };
/** @constructor */
function $c_Lio_circe_cursor_TopCursor(value, lastCursor, lastOp) {
  this.Lio_circe_ACursor__f_lastCursor = null;
  this.Lio_circe_ACursor__f_lastOp = null;
  this.Lio_circe_cursor_TopCursor__f_value = null;
  this.Lio_circe_cursor_TopCursor__f_value = value;
  $ct_Lio_circe_ACursor__Lio_circe_HCursor__Lio_circe_CursorOp__(this, lastCursor, lastOp);
}
export { $c_Lio_circe_cursor_TopCursor as $c_Lio_circe_cursor_TopCursor };
$c_Lio_circe_cursor_TopCursor.prototype = new $h_Lio_circe_HCursor();
$c_Lio_circe_cursor_TopCursor.prototype.constructor = $c_Lio_circe_cursor_TopCursor;
/** @constructor */
function $h_Lio_circe_cursor_TopCursor() {
}
export { $h_Lio_circe_cursor_TopCursor as $h_Lio_circe_cursor_TopCursor };
$h_Lio_circe_cursor_TopCursor.prototype = $c_Lio_circe_cursor_TopCursor.prototype;
$c_Lio_circe_cursor_TopCursor.prototype.value__Lio_circe_Json = (function() {
  return this.Lio_circe_cursor_TopCursor__f_value;
});
$c_Lio_circe_cursor_TopCursor.prototype.replace__Lio_circe_Json__Lio_circe_HCursor__Lio_circe_CursorOp__Lio_circe_HCursor = (function(newValue, cursor, op) {
  return new $c_Lio_circe_cursor_TopCursor(newValue, cursor, op);
});
$c_Lio_circe_cursor_TopCursor.prototype.delete__Lio_circe_ACursor = (function() {
  var op = $m_Lio_circe_CursorOp$DeleteGoParent$();
  return new $c_Lio_circe_FailedCursor(this, op);
});
$c_Lio_circe_cursor_TopCursor.prototype.right__Lio_circe_ACursor = (function() {
  var op = $m_Lio_circe_CursorOp$MoveRight$();
  return new $c_Lio_circe_FailedCursor(this, op);
});
function $isArrayOf_Lio_circe_cursor_TopCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_cursor_TopCursor)));
}
export { $isArrayOf_Lio_circe_cursor_TopCursor as $isArrayOf_Lio_circe_cursor_TopCursor };
var $d_Lio_circe_cursor_TopCursor = new $TypeData().initClass($c_Lio_circe_cursor_TopCursor, "io.circe.cursor.TopCursor", ({
  Lio_circe_cursor_TopCursor: 1,
  Lio_circe_HCursor: 1,
  Lio_circe_ACursor: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_cursor_TopCursor as $d_Lio_circe_cursor_TopCursor };
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$$anon$1() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null;
  $ct_Lio_circe_numbers_BiggerDecimal$Zero__(this);
}
export { $c_Lio_circe_numbers_BiggerDecimal$$anon$1 as $c_Lio_circe_numbers_BiggerDecimal$$anon$1 };
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype = new $h_Lio_circe_numbers_BiggerDecimal$Zero();
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$$anon$1;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$$anon$1() {
}
export { $h_Lio_circe_numbers_BiggerDecimal$$anon$1 as $h_Lio_circe_numbers_BiggerDecimal$$anon$1 };
$h_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype = $c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype;
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.isNegativeZero__Z = (function() {
  return false;
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_Lio_circe_numbers_BiggerDecimal$Zero) && (!that.isNegativeZero__Z()));
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.hashCode__I = (function() {
  var valueInt = (0.0 | 0);
  return ((valueInt === 0.0) ? valueInt : 0);
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$1.prototype.toString__T = (function() {
  return "0";
});
var $d_Lio_circe_numbers_BiggerDecimal$$anon$1 = new $TypeData().initClass($c_Lio_circe_numbers_BiggerDecimal$$anon$1, "io.circe.numbers.BiggerDecimal$$anon$1", ({
  Lio_circe_numbers_BiggerDecimal$$anon$1: 1,
  Lio_circe_numbers_BiggerDecimal$Zero: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_numbers_BiggerDecimal$$anon$1 as $d_Lio_circe_numbers_BiggerDecimal$$anon$1 };
/** @constructor */
function $c_Lio_circe_numbers_BiggerDecimal$$anon$2() {
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toBigDecimal = null;
  this.Lio_circe_numbers_BiggerDecimal$Zero__f_toLong = null;
  $ct_Lio_circe_numbers_BiggerDecimal$Zero__(this);
}
export { $c_Lio_circe_numbers_BiggerDecimal$$anon$2 as $c_Lio_circe_numbers_BiggerDecimal$$anon$2 };
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype = new $h_Lio_circe_numbers_BiggerDecimal$Zero();
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.constructor = $c_Lio_circe_numbers_BiggerDecimal$$anon$2;
/** @constructor */
function $h_Lio_circe_numbers_BiggerDecimal$$anon$2() {
}
export { $h_Lio_circe_numbers_BiggerDecimal$$anon$2 as $h_Lio_circe_numbers_BiggerDecimal$$anon$2 };
$h_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype = $c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype;
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.isNegativeZero__Z = (function() {
  return true;
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_Lio_circe_numbers_BiggerDecimal$Zero) && that.isNegativeZero__Z());
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.hashCode__I = (function() {
  var valueInt = ((-0) | 0);
  return (-2147483648);
});
$c_Lio_circe_numbers_BiggerDecimal$$anon$2.prototype.toString__T = (function() {
  return "-0";
});
var $d_Lio_circe_numbers_BiggerDecimal$$anon$2 = new $TypeData().initClass($c_Lio_circe_numbers_BiggerDecimal$$anon$2, "io.circe.numbers.BiggerDecimal$$anon$2", ({
  Lio_circe_numbers_BiggerDecimal$$anon$2: 1,
  Lio_circe_numbers_BiggerDecimal$Zero: 1,
  Lio_circe_numbers_BiggerDecimal: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_numbers_BiggerDecimal$$anon$2 as $d_Lio_circe_numbers_BiggerDecimal$$anon$2 };
class $c_Ljava_io_IOException extends $c_jl_Exception {
}
export { $c_Ljava_io_IOException as $c_Ljava_io_IOException };
function $isArrayOf_Ljava_io_IOException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_io_IOException)));
}
export { $isArrayOf_Ljava_io_IOException as $isArrayOf_Ljava_io_IOException };
function $ct_jl_AssertionError__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
export { $ct_jl_AssertionError__ as $ct_jl_AssertionError__ };
function $ct_jl_AssertionError__O__($thiz, detailMessage) {
  var message = ("" + detailMessage);
  var cause = ((detailMessage instanceof $c_jl_Throwable) ? detailMessage : null);
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  return $thiz;
}
export { $ct_jl_AssertionError__O__ as $ct_jl_AssertionError__O__ };
class $c_jl_AssertionError extends $c_jl_Error {
}
export { $c_jl_AssertionError as $c_jl_AssertionError };
var $d_jl_AssertionError = new $TypeData().initClass($c_jl_AssertionError, "java.lang.AssertionError", ({
  jl_AssertionError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_AssertionError as $d_jl_AssertionError };
function $f_jl_Boolean__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
export { $f_jl_Boolean__equals__O__Z as $f_jl_Boolean__equals__O__Z };
function $f_jl_Boolean__hashCode__I($thiz) {
  return ($thiz ? 1231 : 1237);
}
export { $f_jl_Boolean__hashCode__I as $f_jl_Boolean__hashCode__I };
function $f_jl_Boolean__toString__T($thiz) {
  return ("" + $thiz);
}
export { $f_jl_Boolean__toString__T as $f_jl_Boolean__toString__T };
function $f_jl_Boolean__compareTo__O__I($thiz, o) {
  return (($thiz === o) ? 0 : ($thiz ? 1 : (-1)));
}
export { $f_jl_Boolean__compareTo__O__I as $f_jl_Boolean__compareTo__O__I };
function $isArrayOf_jl_Boolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Boolean)));
}
export { $isArrayOf_jl_Boolean as $isArrayOf_jl_Boolean };
var $d_jl_Boolean = new $TypeData().initClass(0, "java.lang.Boolean", ({
  jl_Boolean: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => ((typeof x) === "boolean")));
export { $d_jl_Boolean as $d_jl_Boolean };
function $f_jl_Character__hashCode__I($thiz) {
  return $thiz;
}
export { $f_jl_Character__hashCode__I as $f_jl_Character__hashCode__I };
function $f_jl_Character__equals__O__Z($thiz, that) {
  if ((that instanceof $Char)) {
    var this$1 = that.c;
    return ($thiz === this$1);
  } else {
    return false;
  }
}
export { $f_jl_Character__equals__O__Z as $f_jl_Character__equals__O__Z };
function $f_jl_Character__toString__T($thiz) {
  return ("" + $cToS($thiz));
}
export { $f_jl_Character__toString__T as $f_jl_Character__toString__T };
function $f_jl_Character__compareTo__O__I($thiz, o) {
  var this$1 = o.c;
  return (($thiz - this$1) | 0);
}
export { $f_jl_Character__compareTo__O__I as $f_jl_Character__compareTo__O__I };
function $isArrayOf_jl_Character(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Character)));
}
export { $isArrayOf_jl_Character as $isArrayOf_jl_Character };
var $d_jl_Character = new $TypeData().initClass(0, "java.lang.Character", ({
  jl_Character: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => (x instanceof $Char)));
export { $d_jl_Character as $d_jl_Character };
function $isArrayOf_jl_InterruptedException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_InterruptedException)));
}
export { $isArrayOf_jl_InterruptedException as $isArrayOf_jl_InterruptedException };
function $isArrayOf_jl_LinkageError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_LinkageError)));
}
export { $isArrayOf_jl_LinkageError as $isArrayOf_jl_LinkageError };
function $ct_jl_RuntimeException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_jl_RuntimeException__T__ as $ct_jl_RuntimeException__T__ };
class $c_jl_RuntimeException extends $c_jl_Exception {
}
export { $c_jl_RuntimeException as $c_jl_RuntimeException };
function $isArrayOf_jl_RuntimeException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_RuntimeException)));
}
export { $isArrayOf_jl_RuntimeException as $isArrayOf_jl_RuntimeException };
var $d_jl_RuntimeException = new $TypeData().initClass($c_jl_RuntimeException, "java.lang.RuntimeException", ({
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_RuntimeException as $d_jl_RuntimeException };
function $ct_jl_StringBuffer__jl_StringBuilder__($thiz, builder) {
  $thiz.jl_StringBuffer__f_builder = builder;
  return $thiz;
}
export { $ct_jl_StringBuffer__jl_StringBuilder__ as $ct_jl_StringBuffer__jl_StringBuilder__ };
function $ct_jl_StringBuffer__I__($thiz, capacity) {
  $ct_jl_StringBuffer__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), capacity));
  return $thiz;
}
export { $ct_jl_StringBuffer__I__ as $ct_jl_StringBuffer__I__ };
/** @constructor */
function $c_jl_StringBuffer() {
  this.jl_StringBuffer__f_builder = null;
}
export { $c_jl_StringBuffer as $c_jl_StringBuffer };
$c_jl_StringBuffer.prototype = new $h_O();
$c_jl_StringBuffer.prototype.constructor = $c_jl_StringBuffer;
/** @constructor */
function $h_jl_StringBuffer() {
}
export { $h_jl_StringBuffer as $h_jl_StringBuffer };
$h_jl_StringBuffer.prototype = $c_jl_StringBuffer.prototype;
$c_jl_StringBuffer.prototype.length__I = (function() {
  return this.jl_StringBuffer__f_builder.length__I();
});
$c_jl_StringBuffer.prototype.charAt__I__C = (function(index) {
  return this.jl_StringBuffer__f_builder.charAt__I__C(index);
});
$c_jl_StringBuffer.prototype.append__T__jl_StringBuffer = (function(str) {
  var this$1 = this.jl_StringBuffer__f_builder;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this;
});
$c_jl_StringBuffer.prototype.append__jl_CharSequence__jl_StringBuffer = (function(s) {
  var this$1 = this.jl_StringBuffer__f_builder;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this;
});
$c_jl_StringBuffer.prototype.append__jl_CharSequence__I__I__jl_StringBuffer = (function(s, start, end) {
  this.jl_StringBuffer__f_builder.append__jl_CharSequence__I__I__jl_StringBuilder(s, start, end);
  return this;
});
$c_jl_StringBuffer.prototype.append__C__jl_StringBuffer = (function(c) {
  var this$1 = this.jl_StringBuffer__f_builder;
  var str = ("" + $cToS(c));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_jl_StringBuffer.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  var this$1 = this.jl_StringBuffer__f_builder;
  return this$1.substring__I__I__T(start, end);
});
$c_jl_StringBuffer.prototype.toString__T = (function() {
  return this.jl_StringBuffer__f_builder.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_jl_StringBuffer.prototype.append__C__jl_Appendable = (function(c) {
  return this.append__C__jl_StringBuffer(c);
});
$c_jl_StringBuffer.prototype.append__jl_CharSequence__I__I__jl_Appendable = (function(csq, start, end) {
  return this.append__jl_CharSequence__I__I__jl_StringBuffer(csq, start, end);
});
$c_jl_StringBuffer.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  return this.append__jl_CharSequence__jl_StringBuffer(csq);
});
var $d_jl_StringBuffer = new $TypeData().initClass($c_jl_StringBuffer, "java.lang.StringBuffer", ({
  jl_StringBuffer: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_StringBuffer as $d_jl_StringBuffer };
function $ct_jl_StringBuilder__($thiz) {
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = "";
  return $thiz;
}
export { $ct_jl_StringBuilder__ as $ct_jl_StringBuilder__ };
function $ct_jl_StringBuilder__T__($thiz, str) {
  $ct_jl_StringBuilder__($thiz);
  if ((str === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.jl_StringBuilder__f_java$lang$StringBuilder$$content = str;
  return $thiz;
}
export { $ct_jl_StringBuilder__T__ as $ct_jl_StringBuilder__T__ };
function $ct_jl_StringBuilder__I__($thiz, initialCapacity) {
  $ct_jl_StringBuilder__($thiz);
  if ((initialCapacity < 0)) {
    throw new $c_jl_NegativeArraySizeException();
  }
  return $thiz;
}
export { $ct_jl_StringBuilder__I__ as $ct_jl_StringBuilder__I__ };
/** @constructor */
function $c_jl_StringBuilder() {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = null;
}
export { $c_jl_StringBuilder as $c_jl_StringBuilder };
$c_jl_StringBuilder.prototype = new $h_O();
$c_jl_StringBuilder.prototype.constructor = $c_jl_StringBuilder;
/** @constructor */
function $h_jl_StringBuilder() {
}
export { $h_jl_StringBuilder as $h_jl_StringBuilder };
$h_jl_StringBuilder.prototype = $c_jl_StringBuilder.prototype;
$c_jl_StringBuilder.prototype.append__jl_CharSequence__I__I__jl_StringBuilder = (function(s, start, end) {
  var s$1 = $dp_subSequence__I__I__jl_CharSequence(((s === null) ? "null" : s), start, end);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s$1);
  return this;
});
$c_jl_StringBuilder.prototype.append__AC__jl_StringBuilder = (function(str) {
  var this$1 = $m_jl_String$();
  var count = str.u.length;
  var str$1 = this$1.new__AC__I__I__T(str, 0, count);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
  return this;
});
$c_jl_StringBuilder.prototype.deleteCharAt__I__jl_StringBuilder = (function(index) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  if (((index < 0) || (index >= oldContent.length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), index);
  }
  var $x_1 = oldContent.substring(0, index);
  var beginIndex = ((1 + index) | 0);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + $x_1) + oldContent.substring(beginIndex));
  return this;
});
$c_jl_StringBuilder.prototype.replace__I__I__T__jl_StringBuilder = (function(start, end, str) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var length = oldContent.length;
  if ((((start < 0) || (start > length)) || (start > end))) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), start);
  }
  var firstPart = (("" + oldContent.substring(0, start)) + str);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = ((end >= length) ? firstPart : (firstPart + oldContent.substring(end)));
  return this;
});
$c_jl_StringBuilder.prototype.insert__I__T__jl_StringBuilder = (function(offset, str) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  if (((offset < 0) || (offset > oldContent.length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), offset);
  }
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = ((("" + oldContent.substring(0, offset)) + str) + oldContent.substring(offset));
  return this;
});
$c_jl_StringBuilder.prototype.reverse__jl_StringBuilder = (function() {
  var original = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var result = "";
  var i = (((-1) + original.length) | 0);
  while ((i > 0)) {
    var index = i;
    var c = original.charCodeAt(index);
    if (((64512 & c) === 56320)) {
      var index$1 = (((-1) + i) | 0);
      var c2 = original.charCodeAt(index$1);
      if (((64512 & c2) === 55296)) {
        result = ((((result + "") + $cToS(c2)) + "") + $cToS(c));
        i = (((-2) + i) | 0);
      } else {
        result = ((result + "") + $cToS(c));
        i = (((-1) + i) | 0);
      }
    } else {
      result = ((result + "") + $cToS(c));
      i = (((-1) + i) | 0);
    }
  }
  if ((i === 0)) {
    var $x_1 = result;
    var this$7 = original.charCodeAt(0);
    result = ($x_1 + ("" + $cToS(this$7)));
  }
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = result;
  return this;
});
$c_jl_StringBuilder.prototype.toString__T = (function() {
  return this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_jl_StringBuilder.prototype.length__I = (function() {
  var this$1 = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return this$1.length;
});
$c_jl_StringBuilder.prototype.setLength__I__V = (function(newLength) {
  if ((newLength < 0)) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), newLength);
  }
  var newContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  var this$1 = newContent;
  var additional = ((newLength - this$1.length) | 0);
  if ((additional < 0)) {
    var this$2 = newContent;
    newContent = this$2.substring(0, newLength);
  } else {
    var i = 0;
    while ((i !== additional)) {
      newContent = (newContent + "\u0000");
      i = ((1 + i) | 0);
    }
  }
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = newContent;
});
$c_jl_StringBuilder.prototype.charAt__I__C = (function(index) {
  var this$1 = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return this$1.charCodeAt(index);
});
$c_jl_StringBuilder.prototype.getChars__I__I__AC__I__V = (function(srcBegin, srcEnd, dst, dstBegin) {
  $f_T__getChars__I__I__AC__I__V(this.jl_StringBuilder__f_java$lang$StringBuilder$$content, srcBegin, srcEnd, dst, dstBegin);
});
$c_jl_StringBuilder.prototype.setCharAt__I__C__V = (function(index, ch) {
  var oldContent = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  if (((index < 0) || (index >= oldContent.length))) {
    throw $ct_jl_StringIndexOutOfBoundsException__I__(new $c_jl_StringIndexOutOfBoundsException(), index);
  }
  var $x_1 = oldContent.substring(0, index);
  var beginIndex = ((1 + index) | 0);
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (($x_1 + $cToS(ch)) + oldContent.substring(beginIndex));
});
$c_jl_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.substring__I__I__T(start, end);
});
$c_jl_StringBuilder.prototype.substring__I__I__T = (function(start, end) {
  var this$1 = this.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  return this$1.substring(start, end);
});
$c_jl_StringBuilder.prototype.append__C__jl_Appendable = (function(c) {
  var str = ("" + $cToS(c));
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_jl_StringBuilder.prototype.append__jl_CharSequence__I__I__jl_Appendable = (function(csq, start, end) {
  return this.append__jl_CharSequence__I__I__jl_StringBuilder(csq, start, end);
});
$c_jl_StringBuilder.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  this.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this.jl_StringBuilder__f_java$lang$StringBuilder$$content) + csq);
  return this;
});
function $isArrayOf_jl_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_StringBuilder)));
}
export { $isArrayOf_jl_StringBuilder as $isArrayOf_jl_StringBuilder };
var $d_jl_StringBuilder = new $TypeData().initClass($c_jl_StringBuilder, "java.lang.StringBuilder", ({
  jl_StringBuilder: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_StringBuilder as $d_jl_StringBuilder };
function $isArrayOf_jl_ThreadDeath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ThreadDeath)));
}
export { $isArrayOf_jl_ThreadDeath as $isArrayOf_jl_ThreadDeath };
class $c_jl_VirtualMachineError extends $c_jl_Error {
}
export { $c_jl_VirtualMachineError as $c_jl_VirtualMachineError };
function $isArrayOf_jl_VirtualMachineError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_VirtualMachineError)));
}
export { $isArrayOf_jl_VirtualMachineError as $isArrayOf_jl_VirtualMachineError };
function $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I($thiz, value) {
  if (((value.RTLong__f_lo === 0) && (value.RTLong__f_hi === (-2147483648)))) {
    return 19;
  } else {
    var $x_2 = $m_ju_Arrays$();
    var $x_1 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows;
    var lo = value.RTLong__f_lo;
    var hi = value.RTLong__f_hi;
    var sign = (hi >> 31);
    var xlo = (lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var index = $x_2.binarySearch__AJ__J__I($x_1, new $c_RTLong(rlo, rhi));
    return ((index < 0) ? (((-1) - index) | 0) : ((1 + index) | 0));
  }
}
export { $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I as $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I };
function $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc) {
  var mcPrecision = mc.Ljava_math_MathContext__f_precision;
  var discardedPrecision = (($thiz.precision__I() - mcPrecision) | 0);
  var mcPrecGood = (($p_Ljava_math_BigDecimal__approxPrecision__I($thiz) < mcPrecision) || (mcPrecision === 0));
  if ((!(mcPrecGood || (discardedPrecision <= 0)))) {
    if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision);
    } else {
      var $x_1 = $m_Ljava_math_Multiplication$();
      var hi = (discardedPrecision >> 31);
      var sizeOfFraction = $x_1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(discardedPrecision, hi));
      var integerAndFraction = $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger(sizeOfFraction);
      var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value >> 31);
      var hi$2 = (discardedPrecision >> 31);
      var lo = ((value - discardedPrecision) | 0);
      var hi$3 = ((((hi$1 - hi$2) | 0) + ((((~value) & discardedPrecision) | ((~(value ^ discardedPrecision)) & lo)) >> 31)) | 0);
      var this$5 = integerAndFraction.u[1];
      if ((this$5.Ljava_math_BigInteger__f_sign !== 0)) {
        var absBi = integerAndFraction.u[1].abs__Ljava_math_BigInteger();
        var compRem = absBi.shiftLeftOneBit__Ljava_math_BigInteger().compareTo__Ljava_math_BigInteger__I(sizeOfFraction);
        var parityBit = (integerAndFraction.u[0].testBit__I__Z(0) ? 1 : 0);
        var this$6 = integerAndFraction.u[1];
        var frac = Math.imul(this$6.Ljava_math_BigInteger__f_sign, ((5 + compRem) | 0));
        var carry = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I(parityBit, frac, mc.Ljava_math_MathContext__f_roundingMode);
        if ((carry !== 0)) {
          var $x_2 = $m_Ljava_math_BigInteger$();
          var hi$4 = (carry >> 31);
          var bi = $x_2.valueOf__J__Ljava_math_BigInteger(new $c_RTLong(carry, hi$4));
          var this$8 = integerAndFraction.u[0];
          integerAndFraction.u[0] = $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$8, bi);
        }
        var tempBD = $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__(new $c_Ljava_math_BigDecimal(), integerAndFraction.u[0]);
        if ((tempBD.precision__I() > mcPrecision)) {
          integerAndFraction.u[0] = integerAndFraction.u[0].divide__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_TEN);
          var lo$1 = (((-1) + lo) | 0);
          var hi$5 = (((((-1) + hi$3) | 0) + (((lo | (~lo$1)) >>> 31) | 0)) | 0);
          var newScale__lo = lo$1;
          var newScale__hi = hi$5;
        } else {
          var newScale__lo = lo;
          var newScale__hi = hi$3;
        }
      } else {
        var newScale__lo = lo;
        var newScale__hi = hi$3;
      }
      $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(newScale__lo, newScale__hi));
      $thiz.Ljava_math_BigDecimal__f__precision = mcPrecision;
      $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, integerAndFraction.u[0]);
    }
  }
}
export { $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V as $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V };
function $p_Ljava_math_BigDecimal__isZero__Z($thiz) {
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
    var a = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    return (!((a.RTLong__f_lo === (-1)) && (a.RTLong__f_hi === (-1))));
  } else {
    return false;
  }
}
export { $p_Ljava_math_BigDecimal__isZero__Z as $p_Ljava_math_BigDecimal__isZero__Z };
function $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal($thiz, newScale) {
  if ($p_Ljava_math_BigDecimal__isZero__Z($thiz)) {
    var $x_1 = $m_Ljava_math_BigDecimal$();
    var ahi = newScale.RTLong__f_hi;
    return $x_1.java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal((((ahi === 0) ? (newScale.RTLong__f_lo !== 0) : (ahi > 0)) ? newScale : $L0));
  } else {
    var ahi$1 = newScale.RTLong__f_hi;
    if ((ahi$1 >= 0)) {
      return (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64) ? $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(newScale)) : $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(newScale)));
    } else {
      var blo = newScale.RTLong__f_lo;
      var lo = ((-blo) | 0);
      var hi = ((((-newScale.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
      var value = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length;
      var hi$1 = (value >> 31);
      if ((((hi === hi$1) ? ((lo >>> 0) < (value >>> 0)) : (hi < hi$1)) && ((($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $ps_Ljava_math_BigDecimal__lptbLen$1__J__I(newScale)) | 0) < 64))) {
        var $x_2 = $m_Ljava_math_BigDecimal$();
        var a = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u[((-newScale.RTLong__f_lo) | 0)];
        var alo = a.RTLong__f_lo;
        var blo$1 = b.RTLong__f_lo;
        var a0 = (65535 & alo);
        var a1 = ((alo >>> 16) | 0);
        var b0 = (65535 & blo$1);
        var b1 = ((blo$1 >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo$1)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        return $x_2.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$2), 0);
      } else {
        var $x_5 = $m_Ljava_math_Multiplication$();
        var $x_4 = $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
        var $x_3 = $m_Ljava_math_BigDecimal$();
        var blo$2 = newScale.RTLong__f_lo;
        var lo$2 = ((-blo$2) | 0);
        var hi$3 = ((((-newScale.RTLong__f_hi) | 0) + ((blo$2 | lo$2) >> 31)) | 0);
        var value$1 = $x_3.java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$2, hi$3));
        var hi$4 = (value$1 >> 31);
        return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $x_5.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($x_4, new $c_RTLong(value$1, hi$4)), 0);
      }
    }
  }
}
export { $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal as $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal };
function $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V($thiz, mc, discardedPrecision) {
  var t = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u[discardedPrecision];
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value >> 31);
  var hi$2 = (discardedPrecision >> 31);
  var lo$1 = ((value - discardedPrecision) | 0);
  var hi$3 = ((((hi$1 - hi$2) | 0) + ((((~value) & discardedPrecision) | ((~(value ^ discardedPrecision)) & lo$1)) >> 31)) | 0);
  var t$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
  var lo$2 = t$1.RTLong__f_lo;
  var hi$4 = t$1.RTLong__f_hi;
  var this$4 = $m_RTLong$();
  var lo$3 = this$4.divideImpl__I__I__I__I__I(lo$2, hi$4, lo, hi);
  var hi$5 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var a0 = (65535 & lo);
  var a1 = ((lo >>> 16) | 0);
  var b0 = (65535 & lo$3);
  var b1 = ((lo$3 >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$6 = ((((((((Math.imul(lo, hi$5) + Math.imul(hi, lo$3)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$5 = ((lo$2 - lo$4) | 0);
  var hi$7 = ((((hi$4 - hi$6) | 0) + ((((~lo$2) & lo$4) | ((~(lo$2 ^ lo$4)) & lo$5)) >> 31)) | 0);
  if ((!((lo$5 === 0) && (hi$7 === 0)))) {
    var $x_1 = $m_Ljava_math_BigDecimal$();
    var sign = (hi$7 >> 31);
    var xlo = (lo$5 ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi$7 ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
    var lo$6 = (rlo << 1);
    var hi$8 = (((rlo >>> 31) | 0) | (rhi << 1));
    var compRem = $x_1.java$math$BigDecimal$$longCompareTo__J__J__I(new $c_RTLong(lo$6, hi$8), new $c_RTLong(lo, hi));
    var lo$7 = (hi$7 >> 31);
    var lo$8 = ((-lo$5) | 0);
    var hi$10 = ((((-hi$7) | 0) + ((lo$5 | lo$8) >> 31)) | 0);
    var lo$9 = ((hi$10 >>> 31) | 0);
    var lo$10 = (lo$7 | lo$9);
    var frac = Math.imul(lo$10, ((5 + compRem) | 0));
    var value$1 = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$roundingBehavior__I__I__Ljava_math_RoundingMode__I((1 & lo$3), frac, mc.Ljava_math_MathContext__f_roundingMode);
    var hi$11 = (value$1 >> 31);
    var lo$11 = ((lo$3 + value$1) | 0);
    var hi$12 = ((((hi$5 + hi$11) | 0) + ((((lo$3 & value$1) | ((lo$3 | value$1) & (~lo$11))) >>> 31) | 0)) | 0);
    var sign$1 = (hi$12 >> 31);
    var xlo$1 = (lo$11 ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((hi$12 ^ sign$1) + (((xlo$1 & (~rlo$1)) >>> 31) | 0)) | 0);
    var a = ((4.294967296E9 * rhi$1) + (rlo$1 >>> 0.0));
    if (((+Math.log10(a)) >= mc.Ljava_math_MathContext__f_precision)) {
      var lo$12 = (((-1) + lo$1) | 0);
      var hi$13 = (((((-1) + hi$3) | 0) + (((lo$1 | (~lo$12)) >>> 31) | 0)) | 0);
      var this$23 = $m_RTLong$();
      var lo$13 = this$23.divideImpl__I__I__I__I__I(lo$11, hi$12, 10, 0);
      var hi$14 = this$23.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var x1___1 = new $c_RTLong(lo$12, hi$13);
      var x1___2 = new $c_RTLong(lo$13, hi$14);
    } else {
      var x1___1 = new $c_RTLong(lo$1, hi$3);
      var x1___2 = new $c_RTLong(lo$11, hi$12);
    }
  } else {
    var x1___1 = new $c_RTLong(lo$1, hi$3);
    var x1___2 = new $c_RTLong(lo$3, hi$5);
  }
  var t$2 = $uJ(x1___1);
  var lo$14 = t$2.RTLong__f_lo;
  var hi$15 = t$2.RTLong__f_hi;
  var t$3 = $uJ(x1___2);
  var lo$15 = t$3.RTLong__f_lo;
  var hi$16 = t$3.RTLong__f_hi;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$14, hi$15));
  $thiz.Ljava_math_BigDecimal__f__precision = mc.Ljava_math_MathContext__f_precision;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(lo$15, hi$16);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(new $c_RTLong(lo$15, hi$16));
  $thiz.Ljava_math_BigDecimal__f__intVal = null;
}
export { $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V as $p_Ljava_math_BigDecimal__smallRound__Ljava_math_MathContext__I__V };
function $p_Ljava_math_BigDecimal__valueExact__I__J($thiz, bitLengthOfType) {
  var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var lo = ((-value) | 0);
  var hi$1 = ((((-hi) | 0) + ((value | lo) >> 31)) | 0);
  var value$1 = $p_Ljava_math_BigDecimal__approxPrecision__I($thiz);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo & value$1) | ((lo | value$1) & (~lo$1))) >>> 31) | 0)) | 0);
  if (((hi$3 === 0) ? ((lo$1 >>> 0) > 19) : (hi$3 > 0))) {
    throw new $c_jl_ArithmeticException("Rounding necessary");
  }
  var bigInteger = $thiz.toBigIntegerExact__Ljava_math_BigInteger();
  if (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(bigInteger) < bitLengthOfType)) {
    return bigInteger.longValue__J();
  } else {
    throw new $c_jl_ArithmeticException("Rounding necessary");
  }
}
export { $p_Ljava_math_BigDecimal__valueExact__I__J as $p_Ljava_math_BigDecimal__valueExact__I__J };
function $p_Ljava_math_BigDecimal__approxPrecision__I($thiz) {
  return (($thiz.Ljava_math_BigDecimal__f__precision > 0) ? $thiz.Ljava_math_BigDecimal__f__precision : ((1 + $doubleToInt((0.3010299956639812 * (((-1) + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0));
}
export { $p_Ljava_math_BigDecimal__approxPrecision__I as $p_Ljava_math_BigDecimal__approxPrecision__I };
function $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal) {
  $thiz.Ljava_math_BigDecimal__f__intVal = unscaledVal;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(unscaledVal);
  if (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = unscaledVal.longValue__J();
  }
}
export { $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V as $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V };
function $ps_Ljava_math_BigDecimal__powTenLen$1__I__I(diffScale$2) {
  return $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.u[diffScale$2];
}
export { $ps_Ljava_math_BigDecimal__powTenLen$1__I__I as $ps_Ljava_math_BigDecimal__powTenLen$1__I__I };
function $p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I($thiz, subtrahend$1, diffScale$2) {
  var a = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  var b = ((subtrahend$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $ps_Ljava_math_BigDecimal__powTenLen$1__I__I(diffScale$2)) | 0);
  return ((1 + ((a > b) ? a : b)) | 0);
}
export { $p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I as $p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I };
function $ps_Ljava_math_BigDecimal__powTenLen$2__I__I(negDiffScale$1) {
  return $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.u[negDiffScale$1];
}
export { $ps_Ljava_math_BigDecimal__powTenLen$2__I__I as $ps_Ljava_math_BigDecimal__powTenLen$2__I__I };
function $p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I($thiz, subtrahend$1, negDiffScale$1) {
  var a = (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $ps_Ljava_math_BigDecimal__powTenLen$2__I__I(negDiffScale$1)) | 0);
  var b = subtrahend$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
  return ((1 + ((a > b) ? a : b)) | 0);
}
export { $p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I as $p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I };
function $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal($thiz, divisor$1, diffScale$3, scale$1, roundingMode$1) {
  var scaledDividend0 = $thiz.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var scaledDivisor0 = divisor$1.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  if ((diffScale$3 > 0)) {
    var $x_1 = $m_Ljava_math_Multiplication$();
    var hi = (diffScale$3 >> 31);
    var _2 = $x_1.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger(scaledDivisor0, new $c_RTLong(diffScale$3, hi));
    var x1___1 = scaledDividend0;
    var x1___2 = _2;
  } else if ((diffScale$3 < 0)) {
    var $x_2 = $m_Ljava_math_Multiplication$();
    var value = ((-diffScale$3) | 0);
    var hi$1 = (value >> 31);
    var _1 = $x_2.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger(scaledDividend0, new $c_RTLong(value, hi$1));
    var x1___1 = _1;
    var x1___2 = scaledDivisor0;
  } else {
    var x1___1 = scaledDividend0;
    var x1___2 = scaledDivisor0;
  }
  var scaledDividend = x1___1;
  var scaledDivisor = x1___2;
  return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$divideBigIntegers__Ljava_math_BigInteger__Ljava_math_BigInteger__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(scaledDividend, scaledDivisor, scale$1, roundingMode$1);
}
export { $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal as $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal };
function $p_Ljava_math_BigDecimal__cmp$1__J__I($thiz, diffScale$6) {
  return (($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.u[diffScale$6.RTLong__f_lo]) | 0);
}
export { $p_Ljava_math_BigDecimal__cmp$1__J__I as $p_Ljava_math_BigDecimal__cmp$1__J__I };
function $ps_Ljava_math_BigDecimal__lptbLen$1__J__I(newScale$2) {
  return $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.u[((-newScale$2.RTLong__f_lo) | 0)];
}
export { $ps_Ljava_math_BigDecimal__lptbLen$1__J__I as $ps_Ljava_math_BigDecimal__lptbLen$1__J__I };
function $ct_Ljava_math_BigDecimal__($thiz) {
  $thiz.Ljava_math_BigDecimal__f__toStringImage = null;
  $thiz.Ljava_math_BigDecimal__f__hashCode = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  $thiz.Ljava_math_BigDecimal__f__precision = 0;
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__ as $ct_Ljava_math_BigDecimal__ };
function $ct_Ljava_math_BigDecimal__J__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = smallValue;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I(smallValue);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__J__I__ as $ct_Ljava_math_BigDecimal__J__I__ };
function $ct_Ljava_math_BigDecimal__I__I__($thiz, smallValue, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var hi = (smallValue >> 31);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = new $c_RTLong(smallValue, hi);
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$bitLength__I__I(smallValue);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__I__I__ as $ct_Ljava_math_BigDecimal__I__I__ };
function $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, in$1, offset, len) {
  $ct_Ljava_math_BigDecimal__($thiz);
  var last = (((-1) + ((offset + len) | 0)) | 0);
  if ((in$1 === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "in == null");
  }
  if (((((last >= in$1.u.length) || (offset < 0)) || (len <= 0)) || (last < 0))) {
    throw new $c_jl_NumberFormatException(((((("Bad offset/length: offset=" + offset) + " len=") + len) + " in.length=") + in$1.u.length));
  }
  var index = offset;
  if (((offset <= last) && (in$1.u[offset] === 43))) {
    index = ((1 + index) | 0);
    if (((index < last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z(in$1.u[index], new $ac_C(new Uint16Array([43, 45]))))) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.toString__T()));
    }
  } else {
    var isMinus = ((index <= last) && (in$1.u[index] === 45));
    var nextIsSign = ((((1 + index) | 0) < last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z(in$1.u[((1 + index) | 0)], new $ac_C(new Uint16Array([43, 45]))));
    if ((isMinus && nextIsSign)) {
      throw new $c_jl_NumberFormatException(("For input string: " + in$1.toString__T()));
    }
  }
  var begin = index;
  var counter = 0;
  var wasNonZero = false;
  while (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charNotEqualTo__C__AC__Z(in$1.u[index], new $ac_C(new Uint16Array([46, 101, 69]))))) {
    if ((!wasNonZero)) {
      if ((in$1.u[index] === 48)) {
        counter = ((1 + counter) | 0);
      } else {
        wasNonZero = true;
      }
    }
    index = ((1 + index) | 0);
  }
  var count = ((index - begin) | 0);
  var this$1 = $m_jl_String$();
  var u = this$1.new__AC__I__I__T(in$1, begin, count);
  var b = ((index - begin) | 0);
  if (((index <= last) && (in$1.u[index] === 46))) {
    index = ((1 + index) | 0);
    var begin$2 = index;
    while (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charNotEqualTo__C__AC__Z(in$1.u[index], new $ac_C(new Uint16Array([101, 69]))))) {
      if ((!wasNonZero)) {
        if ((in$1.u[index] === 48)) {
          counter = ((1 + counter) | 0);
        } else {
          wasNonZero = true;
        }
      }
      index = ((1 + index) | 0);
    }
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = ((index - begin$2) | 0);
    var count$1 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var this$2 = $m_jl_String$();
    var _1 = (("" + u) + this$2.new__AC__I__I__T(in$1, begin$2, count$1));
    var _2 = ((b + $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    var x1___1 = _1;
    var x1___2 = _2;
  } else {
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
    var x1___1 = u;
    var x1___2 = b;
  }
  var unscaled = x1___1;
  var bufLength = (x1___2 | 0);
  if (((index <= last) && $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$charEqualTo__C__AC__Z(in$1.u[index], new $ac_C(new Uint16Array([101, 69]))))) {
    index = ((1 + index) | 0);
    var indexIsPlus = ((index <= last) && (in$1.u[index] === 43));
    var nextIsNotMinus = ((((1 + index) | 0) <= last) && (in$1.u[((1 + index) | 0)] !== 45));
    var begin$3 = ((indexIsPlus && nextIsNotMinus) ? ((1 + index) | 0) : index);
    var count$2 = ((((1 + last) | 0) - begin$3) | 0);
    var this$3 = $m_jl_String$();
    var scaleString = this$3.new__AC__I__I__T(in$1, begin$3, count$2);
    var value = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var this$5 = $m_jl_Integer$();
    var value$1 = this$5.java$lang$Integer$$parseIntImpl__T__I__I__I(scaleString, 10, 214748364);
    var hi$1 = (value$1 >> 31);
    var lo = ((value - value$1) | 0);
    var hi$2 = ((((hi - hi$1) | 0) + ((((~value) & value$1) | ((~(value ^ value$1)) & lo)) >> 31)) | 0);
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = lo;
    var value$2 = $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$3 = (value$2 >> 31);
    if ((!((lo === value$2) && (hi$2 === hi$3)))) {
      throw new $c_jl_NumberFormatException("Scale out of range");
    }
  }
  if ((bufLength < 19)) {
    var this$11 = $m_jl_Long$();
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = this$11.parseLongImplJS__T__I__J(unscaled, 10);
    $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = $m_Ljava_math_BigDecimal$().bitLength__J__I($thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue);
  } else {
    $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), unscaled));
  }
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__AC__I__I__ as $ct_Ljava_math_BigDecimal__AC__I__I__ };
function $ct_Ljava_math_BigDecimal__T__($thiz, sVal) {
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $f_T__toCharArray__AC(sVal), 0, sVal.length);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__T__ as $ct_Ljava_math_BigDecimal__T__ };
function $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__($thiz, sVal, mc) {
  $ct_Ljava_math_BigDecimal__AC__I__I__($thiz, $f_T__toCharArray__AC(sVal), 0, sVal.length);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__ as $ct_Ljava_math_BigDecimal__T__Ljava_math_MathContext__ };
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, unscaledVal, scale) {
  $ct_Ljava_math_BigDecimal__($thiz);
  if ((unscaledVal === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "unscaledVal == null");
  }
  $thiz.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = scale;
  $p_Ljava_math_BigDecimal__setUnscaledValue__Ljava_math_BigInteger__V($thiz, unscaledVal);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__ as $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__ };
function $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__($thiz, bi) {
  $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__($thiz, bi, 0);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__ as $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__ };
function $ct_Ljava_math_BigDecimal__I__($thiz, iVal) {
  $ct_Ljava_math_BigDecimal__I__I__($thiz, iVal, 0);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__I__ as $ct_Ljava_math_BigDecimal__I__ };
function $ct_Ljava_math_BigDecimal__J__($thiz, lVal) {
  $ct_Ljava_math_BigDecimal__J__I__($thiz, lVal, 0);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__J__ as $ct_Ljava_math_BigDecimal__J__ };
function $ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__($thiz, lVal, mc) {
  $ct_Ljava_math_BigDecimal__J__I__($thiz, lVal, 0);
  $p_Ljava_math_BigDecimal__inplaceRound__Ljava_math_MathContext__V($thiz, mc);
  return $thiz;
}
export { $ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__ as $ct_Ljava_math_BigDecimal__J__Ljava_math_MathContext__ };
/** @constructor */
function $c_Ljava_math_BigDecimal() {
  this.Ljava_math_BigDecimal__f__toStringImage = null;
  this.Ljava_math_BigDecimal__f__hashCode = 0;
  this.Ljava_math_BigDecimal__f__intVal = null;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength = 0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue = $L0;
  this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale = 0;
  this.Ljava_math_BigDecimal__f__precision = 0;
}
export { $c_Ljava_math_BigDecimal as $c_Ljava_math_BigDecimal };
$c_Ljava_math_BigDecimal.prototype = new $h_jl_Number();
$c_Ljava_math_BigDecimal.prototype.constructor = $c_Ljava_math_BigDecimal;
/** @constructor */
function $h_Ljava_math_BigDecimal() {
}
export { $h_Ljava_math_BigDecimal as $h_Ljava_math_BigDecimal };
$h_Ljava_math_BigDecimal.prototype = $c_Ljava_math_BigDecimal.prototype;
$c_Ljava_math_BigDecimal.prototype.add__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(augend) {
  var diffScale = ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale - augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) && (diffScale <= 0))) {
    return augend;
  } else if (($p_Ljava_math_BigDecimal__isZero__Z(augend) && ($p_Ljava_math_BigDecimal__isZero__Z(this) || (diffScale >= 0)))) {
    return this;
  } else if ((diffScale === 0)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    var b = augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    if ((((1 + ((a > b) ? a : b)) | 0) < 64)) {
      var $x_1 = $m_Ljava_math_BigDecimal$();
      var a$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b$1 = augend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo = a$1.RTLong__f_lo;
      var blo = b$1.RTLong__f_lo;
      var lo = ((alo + blo) | 0);
      var hi = ((((a$1.RTLong__f_hi + b$1.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
      return $x_1.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo, hi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    } else {
      var this$3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var bi = augend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$3, bi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    }
  } else {
    return ((diffScale > 0) ? $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(this, augend, diffScale) : $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$addAndMult10__Ljava_math_BigDecimal__Ljava_math_BigDecimal__I__Ljava_math_BigDecimal(augend, this, ((-diffScale) | 0)));
  }
});
$c_Ljava_math_BigDecimal.prototype.subtract__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(subtrahend) {
  var diffScale = ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale - subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) && (diffScale <= 0))) {
    return subtrahend.negate__Ljava_math_BigDecimal();
  } else if (($p_Ljava_math_BigDecimal__isZero__Z(subtrahend) && ($p_Ljava_math_BigDecimal__isZero__Z(this) || (diffScale >= 0)))) {
    return this;
  } else if ((diffScale === 0)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    var b = subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength;
    if ((((1 + ((a > b) ? a : b)) | 0) < 64)) {
      var $x_1 = $m_Ljava_math_BigDecimal$();
      var a$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b$1 = subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo = a$1.RTLong__f_lo;
      var blo = b$1.RTLong__f_lo;
      var lo = ((alo - blo) | 0);
      var hi = ((((a$1.RTLong__f_hi - b$1.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
      return $x_1.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo, hi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    } else {
      var this$3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var bi = subtrahend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$3, bi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    }
  } else if ((diffScale > 0)) {
    if (((diffScale < $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length) && ($p_Ljava_math_BigDecimal__maxLen$2__Ljava_math_BigDecimal__I__I(this, subtrahend, diffScale) < 64))) {
      var t = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u[diffScale];
      var lo$1 = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      var $x_2 = $m_Ljava_math_BigDecimal$();
      var a$3 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var a$2 = subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo$1 = a$2.RTLong__f_lo;
      var a0 = (65535 & alo$1);
      var a1 = ((alo$1 >>> 16) | 0);
      var b0 = (65535 & lo$1);
      var b1 = ((lo$1 >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((((((((Math.imul(alo$1, hi$1) + Math.imul(a$2.RTLong__f_hi, lo$1)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var alo$2 = a$3.RTLong__f_lo;
      var lo$3 = ((alo$2 - lo$2) | 0);
      var hi$3 = ((((a$3.RTLong__f_hi - hi$2) | 0) + ((((~alo$2) & lo$2) | ((~(alo$2 ^ lo$2)) & lo$3)) >> 31)) | 0);
      return $x_2.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$3, hi$3), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    } else {
      var $x_4 = $m_Ljava_math_Multiplication$();
      var $x_3 = subtrahend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var hi$4 = (diffScale >> 31);
      var mult = $x_4.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($x_3, new $c_RTLong(diffScale, hi$4));
      var this$7 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$7, mult), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    }
  } else {
    var negDiffScale = ((-diffScale) | 0);
    if (((negDiffScale < $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length) && ($p_Ljava_math_BigDecimal__maxLen$3__Ljava_math_BigDecimal__I__I(this, subtrahend, negDiffScale) < 64))) {
      var t$1 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u[negDiffScale];
      var lo$4 = t$1.RTLong__f_lo;
      var hi$5 = t$1.RTLong__f_hi;
      var $x_5 = $m_Ljava_math_BigDecimal$();
      var a$4 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var alo$3 = a$4.RTLong__f_lo;
      var a0$1 = (65535 & alo$3);
      var a1$1 = ((alo$3 >>> 16) | 0);
      var b0$1 = (65535 & lo$4);
      var b1$1 = ((lo$4 >>> 16) | 0);
      var a0b0$1 = Math.imul(a0$1, b0$1);
      var a1b0$1 = Math.imul(a1$1, b0$1);
      var a0b1$1 = Math.imul(a0$1, b1$1);
      var lo$5 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$6 = ((((((((Math.imul(alo$3, hi$5) + Math.imul(a$4.RTLong__f_hi, lo$4)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      var b$2 = subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var blo$1 = b$2.RTLong__f_lo;
      var lo$6 = ((lo$5 - blo$1) | 0);
      var hi$7 = ((((hi$6 - b$2.RTLong__f_hi) | 0) + ((((~lo$5) & blo$1) | ((~(lo$5 ^ blo$1)) & lo$6)) >> 31)) | 0);
      return $x_5.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$6, hi$7), subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    } else {
      var $x_7 = $m_Ljava_math_Multiplication$();
      var $x_6 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var hi$8 = (negDiffScale >> 31);
      var mult$2 = $x_7.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($x_6, new $c_RTLong(negDiffScale, hi$8));
      var bi$1 = subtrahend.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var multSub = $m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(mult$2, bi$1);
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), multSub, subtrahend.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.multiply__Ljava_math_BigDecimal__Ljava_math_BigDecimal = (function(multiplicand) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var value$1 = multiplicand.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value$1 >> 31);
  var lo = ((value + value$1) | 0);
  var hi$2 = ((((hi + hi$1) | 0) + ((((value & value$1) | ((value | value$1) & (~lo))) >>> 31) | 0)) | 0);
  if (($p_Ljava_math_BigDecimal__isZero__Z(this) || $p_Ljava_math_BigDecimal__isZero__Z(multiplicand))) {
    return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi$2));
  } else if ((((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + multiplicand.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0) < 64)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var b = multiplicand.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var alo = a.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var a0 = (65535 & alo);
    var a1 = ((alo >>> 16) | 0);
    var b0 = (65535 & blo);
    var b1 = ((blo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$3 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    if (((lo$1 === 0) && (hi$3 === (-2147483648)))) {
      var a$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi = a$1.RTLong__f_hi;
      var $x_2 = (ahi < 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var a$2 = multiplicand.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi$1 = a$2.RTLong__f_hi;
      var $x_1 = (ahi$1 < 0);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $m_Ljava_math_BigInteger$().getPowerOfTwo__I__Ljava_math_BigInteger(63), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)));
    } else {
      return $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$3), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)));
    }
  } else {
    var unscaled = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(multiplicand.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger());
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), unscaled, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)));
  }
});
$c_Ljava_math_BigDecimal.prototype.divide__Ljava_math_BigDecimal__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(divisor, scale, roundingMode) {
  if ((roundingMode === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "roundingMode == null");
  } else if ($p_Ljava_math_BigDecimal__isZero__Z(divisor)) {
    throw new $c_jl_ArithmeticException("Division by zero");
  }
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var value$1 = divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value$1 >> 31);
  var lo = ((value - value$1) | 0);
  var hi$2 = ((((hi - hi$1) | 0) + ((((~value) & value$1) | ((~(value ^ value$1)) & lo)) >> 31)) | 0);
  var hi$3 = (scale >> 31);
  var lo$1 = ((lo - scale) | 0);
  var hi$4 = ((((hi$2 - hi$3) | 0) + ((((~lo) & scale) | ((~(lo ^ scale)) & lo$1)) >> 31)) | 0);
  var hi$5 = (lo$1 >> 31);
  if ((hi$5 !== hi$4)) {
    throw new $c_jl_ArithmeticException((("Unable to scale as difference is too big (" + new $c_RTLong(lo$1, hi$4)) + ")"));
  }
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64) && (divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64))) {
    var lptLen = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length;
    if ((lo$1 === 0)) {
      var t = divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var lo$2 = t.RTLong__f_lo;
      var hi$6 = t.RTLong__f_hi;
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, new $c_RTLong(lo$2, hi$6), scale, roundingMode);
    } else if ((lo$1 > 0)) {
      if (((lo$1 < lptLen) && (((divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.u[lo$1]) | 0) < 64))) {
        var a = divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u[lo$1];
        var alo = a.RTLong__f_lo;
        var blo = b.RTLong__f_lo;
        var a0 = (65535 & alo);
        var a1 = ((alo >>> 16) | 0);
        var b0 = (65535 & blo);
        var b1 = ((blo >>> 16) | 0);
        var a0b0 = Math.imul(a0, b0);
        var a1b0 = Math.imul(a1, b0);
        var a0b1 = Math.imul(a0, b1);
        var lo$3 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$7 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, new $c_RTLong(lo$3, hi$7), scale, roundingMode);
      } else {
        return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode);
      }
    } else if (((lo$1 > ((-lptLen) | 0)) && (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$LongTenPowsBitLength.u[((-lo$1) | 0)]) | 0) < 64))) {
      var a$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b$1 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u[((-lo$1) | 0)];
      var alo$1 = a$1.RTLong__f_lo;
      var blo$1 = b$1.RTLong__f_lo;
      var a0$1 = (65535 & alo$1);
      var a1$1 = ((alo$1 >>> 16) | 0);
      var b0$1 = (65535 & blo$1);
      var b1$1 = ((blo$1 >>> 16) | 0);
      var a0b0$1 = Math.imul(a0$1, b0$1);
      var a1b0$1 = Math.imul(a1$1, b0$1);
      var a0b1$1 = Math.imul(a0$1, b1$1);
      var lo$4 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$8 = ((((((((Math.imul(alo$1, b$1.RTLong__f_hi) + Math.imul(a$1.RTLong__f_hi, blo$1)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(new $c_RTLong(lo$4, hi$8), divisor.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, scale, roundingMode);
    } else {
      return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode);
    }
  } else {
    return $p_Ljava_math_BigDecimal__default$1__Ljava_math_BigDecimal__I__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this, divisor, lo$1, scale, roundingMode);
  }
});
$c_Ljava_math_BigDecimal.prototype.negate__Ljava_math_BigDecimal = (function() {
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 63)) {
    var $x_1 = true;
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 63)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var $x_1 = (!((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === (-2147483648))));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var $x_2 = $m_Ljava_math_BigDecimal$();
    var b = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var blo = b.RTLong__f_lo;
    var lo = ((-blo) | 0);
    var hi = ((((-b.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
    return $x_2.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo, hi), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().negate__Ljava_math_BigInteger(), this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
  }
});
$c_Ljava_math_BigDecimal.prototype.signum__I = (function() {
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var ahi = a.RTLong__f_hi;
    if ((ahi < 0)) {
      return (-1);
    } else {
      var a$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi$1 = a$1.RTLong__f_hi;
      if (((ahi$1 === 0) ? (a$1.RTLong__f_lo !== 0) : (ahi$1 > 0))) {
        return 1;
      } else {
        return 0;
      }
    }
  } else {
    var this$3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    return this$3.Ljava_math_BigInteger__f_sign;
  }
});
$c_Ljava_math_BigDecimal.prototype.precision__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__precision === 0)) {
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength === 0)) {
      var $x_1 = 1;
    } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      var $x_1 = $p_Ljava_math_BigDecimal__decimalDigitsInLong__J__I(this, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue);
    } else {
      var decimalDigits = ((1 + $doubleToInt((0.3010299956639812 * (((-1) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength) | 0)))) | 0);
      var $x_3 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var $x_2 = $m_Ljava_math_Multiplication$();
      var hi = (decimalDigits >> 31);
      var this$2 = $x_3.divide__Ljava_math_BigInteger__Ljava_math_BigInteger($x_2.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(decimalDigits, hi)));
      if ((this$2.Ljava_math_BigInteger__f_sign !== 0)) {
        var $x_1 = ((1 + decimalDigits) | 0);
      } else {
        var $x_1 = decimalDigits;
      }
    }
    this.Ljava_math_BigDecimal__f__precision = $x_1;
  }
  return this.Ljava_math_BigDecimal__f__precision;
});
$c_Ljava_math_BigDecimal.prototype.setScale__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal = (function(newScale, roundingMode) {
  if ((roundingMode === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "roundingMode == null");
  }
  var hi = (newScale >> 31);
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi$1 = (value >> 31);
  var lo = ((newScale - value) | 0);
  var hi$2 = ((((hi - hi$1) | 0) + ((((~newScale) & value) | ((~(newScale ^ value)) & lo)) >> 31)) | 0);
  if (((lo === 0) && (hi$2 === 0))) {
    return this;
  } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
    var value$1 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length;
    var hi$3 = (value$1 >> 31);
    if ((((hi$2 === hi$3) ? ((lo >>> 0) < (value$1 >>> 0)) : (hi$2 < hi$3)) && ($p_Ljava_math_BigDecimal__cmp$1__J__I(this, new $c_RTLong(lo, hi$2)) < 64))) {
      var $x_1 = $m_Ljava_math_BigDecimal$();
      var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u[lo];
      var alo = a.RTLong__f_lo;
      var blo = b.RTLong__f_lo;
      var a0 = (65535 & alo);
      var a1 = ((alo >>> 16) | 0);
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$4 = ((((((((Math.imul(alo, b.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $x_1.valueOf__J__I__Ljava_math_BigDecimal(new $c_RTLong(lo$1, hi$4), newScale);
    } else {
      var $x_3 = $m_Ljava_math_Multiplication$();
      var $x_2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      var hi$5 = (lo >> 31);
      return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), $x_3.multiplyByTenPow__Ljava_math_BigInteger__J__Ljava_math_BigInteger($x_2, new $c_RTLong(lo, hi$5)), newScale);
    }
  } else {
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
      var lo$2 = ((-lo) | 0);
      var hi$6 = ((((-hi$2) | 0) + ((lo | lo$2) >> 31)) | 0);
      var value$2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u.length;
      var hi$7 = (value$2 >> 31);
      var $x_4 = ((hi$6 === hi$7) ? ((lo$2 >>> 0) < (value$2 >>> 0)) : (hi$6 < hi$7));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var t = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_LongTenPows.u[((-lo) | 0)];
      var lo$3 = t.RTLong__f_lo;
      var hi$8 = t.RTLong__f_hi;
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$dividePrimitiveLongs__J__J__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, new $c_RTLong(lo$3, hi$8), newScale, roundingMode);
    } else {
      var $x_5 = $m_Ljava_math_Multiplication$();
      var lo$4 = ((-lo) | 0);
      var hi$9 = ((((-hi$2) | 0) + ((lo | lo$4) >> 31)) | 0);
      var powTen = $x_5.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo$4, hi$9));
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$divideBigIntegers__Ljava_math_BigInteger__Ljava_math_BigInteger__I__Ljava_math_RoundingMode__Ljava_math_BigDecimal(this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), powTen, newScale, roundingMode);
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.movePointLeft__I__Ljava_math_BigDecimal = (function(n) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value + n) | 0);
  var hi$2 = ((((hi + hi$1) | 0) + ((((value & n) | ((value | n) & (~lo))) >>> 31) | 0)) | 0);
  return $p_Ljava_math_BigDecimal__movePoint__J__Ljava_math_BigDecimal(this, new $c_RTLong(lo, hi$2));
});
$c_Ljava_math_BigDecimal.prototype.scaleByPowerOfTen__I__Ljava_math_BigDecimal = (function(n) {
  var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
  var hi = (value >> 31);
  var hi$1 = (n >> 31);
  var lo = ((value - n) | 0);
  var hi$2 = ((((hi - hi$1) | 0) + ((((~value) & n) | ((~(value ^ n)) & lo)) >> 31)) | 0);
  if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    if (((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === 0))) {
      return $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$zeroScaledBy__J__Ljava_math_BigDecimal(new $c_RTLong(lo, hi$2));
    } else {
      return $m_Ljava_math_BigDecimal$().valueOf__J__I__Ljava_math_BigDecimal(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)));
    }
  } else {
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger(), $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo, hi$2)));
  }
});
$c_Ljava_math_BigDecimal.prototype.stripTrailingZeros__Ljava_math_BigDecimal = (function() {
  if ($p_Ljava_math_BigDecimal__isZero__Z(this)) {
    return $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_ZERO;
  } else {
    var lastPow = (((-1) + $m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.u.length) | 0);
    var i = 1;
    var strippedBI = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var scale__lo = value;
    var scale__hi = hi;
    var x1___1;
    var x1___2;
    while (true) {
      if ((!strippedBI.testBit__I__Z(0))) {
        var qr = strippedBI.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_Multiplication$().Ljava_math_Multiplication$__f_BigTenPows.u[i]);
        var this$2 = qr.Ljava_math_BigInteger$QuotAndRem__f_rem;
        if ((this$2.Ljava_math_BigInteger__f_sign === 0)) {
          var temp$i = ((i < lastPow) ? ((1 + i) | 0) : i);
          var temp$strippedBI = qr.Ljava_math_BigInteger$QuotAndRem__f_quot;
          var a__lo = scale__lo;
          var a__hi = scale__hi;
          var value$1 = i;
          var hi$1 = (value$1 >> 31);
          var alo = a__lo;
          var lo = ((alo - value$1) | 0);
          var hi$2 = ((((a__hi - hi$1) | 0) + ((((~alo) & value$1) | ((~(alo ^ value$1)) & lo)) >> 31)) | 0);
          i = temp$i;
          strippedBI = temp$strippedBI;
          var $x_1__lo = lo;
          var $x_1__hi = hi$2;
          scale__lo = $x_1__lo;
          scale__hi = $x_1__hi;
          continue;
        }
        if ((i !== 1)) {
          i = 1;
          continue;
        }
        var _1 = strippedBI;
        var _2__lo = scale__lo;
        var _2__hi = scale__hi;
        var x1___1 = _1;
        var x1___2 = new $c_RTLong(_2__lo, _2__hi);
        break;
      } else {
        var _1$1 = strippedBI;
        var _2$1__lo = scale__lo;
        var _2$1__hi = scale__hi;
        var x1___1 = _1$1;
        var x1___2 = new $c_RTLong(_2$1__lo, _2$1__hi);
        break;
      }
    }
    var strippedBI$1 = x1___1;
    var t = $uJ(x1___2);
    var lo$1 = t.RTLong__f_lo;
    var hi$3 = t.RTLong__f_hi;
    return $ct_Ljava_math_BigDecimal__Ljava_math_BigInteger__I__(new $c_Ljava_math_BigDecimal(), strippedBI$1, $m_Ljava_math_BigDecimal$().java$math$BigDecimal$$safeLongToInt__J__I(new $c_RTLong(lo$1, hi$3)));
  }
});
$c_Ljava_math_BigDecimal.prototype.compareTo__Ljava_math_BigDecimal__I = (function(bi) {
  var thisSign = this.signum__I();
  var valueSign = bi.signum__I();
  if ((thisSign === valueSign)) {
    if ((((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) && (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) && (bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64))) {
      var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var b = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
      var ahi = a.RTLong__f_hi;
      var bhi = b.RTLong__f_hi;
      if (((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) < (b.RTLong__f_lo >>> 0)) : (ahi < bhi))) {
        return (-1);
      } else {
        var a$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b$1 = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var ahi$1 = a$1.RTLong__f_hi;
        var bhi$1 = b$1.RTLong__f_hi;
        if (((ahi$1 === bhi$1) ? ((a$1.RTLong__f_lo >>> 0) > (b$1.RTLong__f_lo >>> 0)) : (ahi$1 > bhi$1))) {
          return 1;
        } else {
          return 0;
        }
      }
    } else {
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var value$1 = bi.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi$1 = (value$1 >> 31);
      var lo = ((value - value$1) | 0);
      var hi$2 = ((((hi - hi$1) | 0) + ((((~value) & value$1) | ((~(value ^ value$1)) & lo)) >> 31)) | 0);
      var diffPrecision = (($p_Ljava_math_BigDecimal__approxPrecision__I(this) - $p_Ljava_math_BigDecimal__approxPrecision__I(bi)) | 0);
      var hi$3 = (diffPrecision >> 31);
      var lo$1 = ((1 + lo) | 0);
      var hi$4 = ((hi$2 + (((lo & (~lo$1)) >>> 31) | 0)) | 0);
      if (((hi$3 === hi$4) ? ((diffPrecision >>> 0) > (lo$1 >>> 0)) : (hi$3 > hi$4))) {
        return thisSign;
      } else {
        var hi$5 = (diffPrecision >> 31);
        var lo$2 = (((-1) + lo) | 0);
        var hi$6 = (((((-1) + hi$2) | 0) + (((lo | (~lo$2)) >>> 31) | 0)) | 0);
        if (((hi$5 === hi$6) ? ((diffPrecision >>> 0) < (lo$2 >>> 0)) : (hi$5 < hi$6))) {
          return ((-thisSign) | 0);
        } else {
          var t = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          var v = bi.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
          if ((hi$2 < 0)) {
            var $x_1 = $m_Ljava_math_Multiplication$();
            var lo$3 = ((-lo) | 0);
            var hi$7 = ((((-hi$2) | 0) + ((lo | lo$3) >> 31)) | 0);
            var _1 = t.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($x_1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo$3, hi$7)));
            var x1___1 = _1;
            var x1___2 = v;
          } else if (((hi$2 === 0) ? (lo !== 0) : (hi$2 > 0))) {
            var _2 = v.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($m_Ljava_math_Multiplication$().powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$2)));
            var x1___1 = t;
            var x1___2 = _2;
          } else {
            var x1___1 = t;
            var x1___2 = v;
          }
          var thisUnscaled = x1___1;
          var valUnscaled = x1___2;
          return thisUnscaled.compareTo__Ljava_math_BigInteger__I(valUnscaled);
        }
      }
    }
  } else {
    return ((thisSign < valueSign) ? (-1) : 1);
  }
});
$c_Ljava_math_BigDecimal.prototype.equals__O__Z = (function(x) {
  if ((x instanceof $c_Ljava_math_BigDecimal)) {
    if ((x.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale)) {
      if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
        var a = x.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        var b = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
        return ((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi));
      } else {
        return this.Ljava_math_BigDecimal__f__intVal.equals__O__Z(x.Ljava_math_BigDecimal__f__intVal);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Ljava_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigDecimal__f__hashCode !== 0)) {
    return this.Ljava_math_BigDecimal__f__hashCode;
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 64)) {
    var a = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    this.Ljava_math_BigDecimal__f__hashCode = a.RTLong__f_lo;
    var $x_1 = this.Ljava_math_BigDecimal__f__hashCode;
    var a$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue;
    var hi = a$1.RTLong__f_hi;
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(33, $x_1) + hi) | 0);
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, this.Ljava_math_BigDecimal__f__hashCode) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode;
  } else {
    this.Ljava_math_BigDecimal__f__hashCode = ((Math.imul(17, this.Ljava_math_BigDecimal__f__intVal.hashCode__I()) + this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
    return this.Ljava_math_BigDecimal__f__hashCode;
  }
});
$c_Ljava_math_BigDecimal.prototype.toString__T = (function() {
  if ((this.Ljava_math_BigDecimal__f__toStringImage !== null)) {
    return this.Ljava_math_BigDecimal__f__toStringImage;
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_bitLength < 32)) {
    this.Ljava_math_BigDecimal__f__toStringImage = $m_Ljava_math_Conversion$().toDecimalScaledString__J__I__T(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue, this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
    return this.Ljava_math_BigDecimal__f__toStringImage;
  } else {
    var this$1 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var intString = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0)) {
      return intString;
    } else {
      var this$2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
      if ((this$2.Ljava_math_BigInteger__f_sign < 0)) {
        var begin = 2;
      } else {
        var begin = 1;
      }
      var end = intString.length;
      var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
      var hi = (value >> 31);
      var lo = ((-value) | 0);
      var hi$1 = ((((-hi) | 0) + ((value | lo) >> 31)) | 0);
      var hi$2 = (end >> 31);
      var lo$1 = ((lo + end) | 0);
      var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo & end) | ((lo | end) & (~lo$1))) >>> 31) | 0)) | 0);
      var hi$4 = (begin >> 31);
      var lo$2 = ((lo$1 - begin) | 0);
      var hi$5 = ((((hi$3 - hi$4) | 0) + ((((~lo$1) & begin) | ((~(lo$1 ^ begin)) & lo$2)) >> 31)) | 0);
      if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > 0) && ((hi$5 === (-1)) ? ((lo$2 >>> 0) >= 4294967290) : (hi$5 > (-1))))) {
        if ((hi$5 >= 0)) {
          $m_Ljava_math_BigDecimal$();
          var pos = ((end - this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0);
          $m_Ljava_math_BigDecimal$();
          var result = ((intString.substring(0, pos) + ".") + intString.substring(pos));
        } else {
          $m_Ljava_math_BigDecimal$();
          $m_Ljava_math_BigDecimal$();
          var pos$1 = (((-1) + begin) | 0);
          $m_Ljava_math_BigDecimal$();
          var s = ((intString.substring(0, pos$1) + "0.") + intString.substring(pos$1));
          var pos$2 = ((1 + begin) | 0);
          var s2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros;
          var s2Len = (((-1) - lo$2) | 0);
          $m_Ljava_math_BigDecimal$();
          var s2$1 = s2.substring(0, s2Len);
          var result = ((("" + s.substring(0, pos$2)) + s2$1) + s.substring(pos$2));
        }
      } else {
        var r0 = ((((end - begin) | 0) >= 1) ? ($m_Ljava_math_BigDecimal$(), $m_Ljava_math_BigDecimal$(), ((intString.substring(0, begin) + ".") + intString.substring(begin))) : intString);
        var r1 = (r0 + "E");
        var r2 = (((hi$5 === 0) ? (lo$2 !== 0) : (hi$5 > 0)) ? (r1 + "+") : r1);
        var this$25 = $m_RTLong$();
        var result = (r2 + this$25.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$2, hi$5));
      }
      this.Ljava_math_BigDecimal__f__toStringImage = result;
      return this.Ljava_math_BigDecimal__f__toStringImage;
    }
  }
});
$c_Ljava_math_BigDecimal.prototype.toPlainString__T = (function() {
  var this$1 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  var intStr = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1);
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || ($p_Ljava_math_BigDecimal__isZero__Z(this) && (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)))) {
    return intStr;
  } else {
    var begin = ((this.signum__I() < 0) ? 1 : 0);
    var delta = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var result = ((begin === 1) ? "-" : "");
    if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > 0)) {
      delta = ((delta - ((intStr.length - begin) | 0)) | 0);
      if ((delta >= 0)) {
        result = (result + "0.");
        while ((delta > 100)) {
          result = (("" + result) + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros);
          delta = (((-100) + delta) | 0);
        }
        var $x_1 = result;
        var this$2 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros;
        var endIndex = delta;
        result = ((("" + $x_1) + this$2.substring(0, endIndex)) + intStr.substring(begin));
      } else {
        delta = ((begin - delta) | 0);
        var $x_3 = result;
        var endIndex$1 = delta;
        var $x_2 = intStr.substring(begin, endIndex$1);
        var beginIndex = delta;
        result = (($x_3 + ($x_2 + ".")) + intStr.substring(beginIndex));
      }
    } else {
      result = (("" + result) + intStr.substring(begin));
      while ((delta < (-100))) {
        result = (("" + result) + $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros);
        delta = ((100 + delta) | 0);
      }
      var $x_4 = result;
      var this$3 = $m_Ljava_math_BigDecimal$().Ljava_math_BigDecimal$__f_java$math$BigDecimal$$CharZeros;
      var endIndex$2 = ((-delta) | 0);
      result = (("" + $x_4) + this$3.substring(0, endIndex$2));
    }
    return result;
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigInteger__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $x_2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $x_1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((((-hi) | 0) + ((value | lo) >> 31)) | 0);
    return $x_2.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($x_1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)));
  } else {
    var $x_4 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $x_3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    return $x_4.divide__Ljava_math_BigInteger__Ljava_math_BigInteger($x_3.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)));
  }
});
$c_Ljava_math_BigDecimal.prototype.toBigIntegerExact__Ljava_math_BigInteger = (function() {
  if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale === 0) || $p_Ljava_math_BigDecimal__isZero__Z(this))) {
    return this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
  } else if ((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale < 0)) {
    var $x_2 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $x_1 = $m_Ljava_math_Multiplication$();
    var value = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi = (value >> 31);
    var lo = ((-value) | 0);
    var hi$1 = ((((-hi) | 0) + ((value | lo) >> 31)) | 0);
    return $x_2.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger($x_1.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi$1)));
  } else {
    if (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger().getLowestSetBit__I()))) {
      throw new $c_jl_ArithmeticException("Rounding necessary");
    }
    var $x_4 = this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger();
    var $x_3 = $m_Ljava_math_Multiplication$();
    var value$1 = this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale;
    var hi$2 = (value$1 >> 31);
    var integerAndFraction = $x_4.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger($x_3.powerOf10__J__Ljava_math_BigInteger(new $c_RTLong(value$1, hi$2)));
    var this$4 = integerAndFraction.u[1];
    if ((this$4.Ljava_math_BigInteger__f_sign !== 0)) {
      throw new $c_jl_ArithmeticException("Rounding necessary");
    }
    return integerAndFraction.u[0];
  }
});
$c_Ljava_math_BigDecimal.prototype.longValue__J = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-64)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? $L0 : this.toBigInteger__Ljava_math_BigInteger().longValue__J());
});
$c_Ljava_math_BigDecimal.prototype.intValue__I = (function() {
  return (((this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= (-32)) || (this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale > $p_Ljava_math_BigDecimal__approxPrecision__I(this))) ? 0 : this.toBigInteger__Ljava_math_BigInteger().intValue__I());
});
$c_Ljava_math_BigDecimal.prototype.intValueExact__I = (function() {
  var a = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 32);
  return a.RTLong__f_lo;
});
$c_Ljava_math_BigDecimal.prototype.shortValueExact__S = (function() {
  var a = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 16);
  return ((a.RTLong__f_lo << 16) >> 16);
});
$c_Ljava_math_BigDecimal.prototype.byteValueExact__B = (function() {
  var a = $p_Ljava_math_BigDecimal__valueExact__I__J(this, 8);
  return ((a.RTLong__f_lo << 24) >> 24);
});
$c_Ljava_math_BigDecimal.prototype.floatValue__F = (function() {
  return $m_jl_Float$().parseFloat__T__F(((this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger() + "e") + ((-this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)));
});
$c_Ljava_math_BigDecimal.prototype.doubleValue__D = (function() {
  return $m_jl_Double$().parseDouble__T__D(((this.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger() + "e") + ((-this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)));
});
$c_Ljava_math_BigDecimal.prototype.java$math$BigDecimal$$getUnscaledValue__Ljava_math_BigInteger = (function() {
  if ((this.Ljava_math_BigDecimal__f__intVal === null)) {
    this.Ljava_math_BigDecimal__f__intVal = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(this.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_smallValue);
  }
  return this.Ljava_math_BigDecimal__f__intVal;
});
$c_Ljava_math_BigDecimal.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_math_BigDecimal__I(o);
});
function $isArrayOf_Ljava_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigDecimal)));
}
export { $isArrayOf_Ljava_math_BigDecimal as $isArrayOf_Ljava_math_BigDecimal };
var $d_Ljava_math_BigDecimal = new $TypeData().initClass($c_Ljava_math_BigDecimal, "java.math.BigDecimal", ({
  Ljava_math_BigDecimal: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}));
export { $d_Ljava_math_BigDecimal as $d_Ljava_math_BigDecimal };
function $p_Ljava_math_BigInteger__putBytesNegativeToIntegers__AB__V($thiz, byteValues) {
  var elem = byteValues.u.length;
  var elem$1 = 0;
  elem$1 = elem;
  var highBytes = (3 & elem$1);
  $thiz.Ljava_math_BigInteger__f_numberLength = (((elem$1 >> 2) + ((highBytes === 0) ? 0 : 1)) | 0);
  $thiz.Ljava_math_BigInteger__f_digits = new $ac_I($thiz.Ljava_math_BigInteger__f_numberLength);
  var elem$2 = 0;
  elem$2 = 0;
  $thiz.Ljava_math_BigInteger__f_digits.u[(((-1) + $thiz.Ljava_math_BigInteger__f_numberLength) | 0)] = (-1);
  while (true) {
    if ((elem$1 > highBytes)) {
      $thiz.Ljava_math_BigInteger__f_digits.u[elem$2] = ((((255 & byteValues.u[(((-1) + elem$1) | 0)]) | ((255 & byteValues.u[(((-2) + elem$1) | 0)]) << 8)) | ((255 & byteValues.u[(((-3) + elem$1) | 0)]) << 16)) | (byteValues.u[(((-4) + elem$1) | 0)] << 24));
      elem$1 = (((-4) + elem$1) | 0);
      if (($thiz.Ljava_math_BigInteger__f_digits.u[elem$2] !== 0)) {
        $thiz.Ljava_math_BigInteger__f_digits.u[elem$2] = ((-$thiz.Ljava_math_BigInteger__f_digits.u[elem$2]) | 0);
        $thiz.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = elem$2;
        elem$2 = ((1 + elem$2) | 0);
        while ((elem$1 > highBytes)) {
          $thiz.Ljava_math_BigInteger__f_digits.u[elem$2] = ((((255 & byteValues.u[(((-1) + elem$1) | 0)]) | ((255 & byteValues.u[(((-2) + elem$1) | 0)]) << 8)) | ((255 & byteValues.u[(((-3) + elem$1) | 0)]) << 16)) | (byteValues.u[(((-4) + elem$1) | 0)] << 24));
          elem$1 = (((-4) + elem$1) | 0);
          $thiz.Ljava_math_BigInteger__f_digits.u[elem$2] = (~$thiz.Ljava_math_BigInteger__f_digits.u[elem$2]);
          elem$2 = ((1 + elem$2) | 0);
        }
      } else {
        elem$2 = ((1 + elem$2) | 0);
        continue;
      }
    }
    break;
  }
  if ((highBytes !== 0)) {
    if (($thiz.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit !== (-2))) {
      var end = elem$1;
      var i = 0;
      while ((i < end)) {
        var value = i;
        $thiz.Ljava_math_BigInteger__f_digits.u[elem$2] = (($thiz.Ljava_math_BigInteger__f_digits.u[elem$2] << 8) | (255 & byteValues.u[value]));
        i = ((1 + i) | 0);
      }
      $thiz.Ljava_math_BigInteger__f_digits.u[elem$2] = (~$thiz.Ljava_math_BigInteger__f_digits.u[elem$2]);
    } else {
      var end$1 = elem$1;
      var i$1 = 0;
      while ((i$1 < end$1)) {
        var value$1 = i$1;
        $thiz.Ljava_math_BigInteger__f_digits.u[elem$2] = (($thiz.Ljava_math_BigInteger__f_digits.u[elem$2] << 8) | (255 & byteValues.u[value$1]));
        i$1 = ((1 + i$1) | 0);
      }
      $thiz.Ljava_math_BigInteger__f_digits.u[elem$2] = ((-$thiz.Ljava_math_BigInteger__f_digits.u[elem$2]) | 0);
    }
  }
}
export { $p_Ljava_math_BigInteger__putBytesNegativeToIntegers__AB__V as $p_Ljava_math_BigInteger__putBytesNegativeToIntegers__AB__V };
function $p_Ljava_math_BigInteger__putBytesPositiveToIntegers__AB__V($thiz, byteValues) {
  var bytesLen = byteValues.u.length;
  var highBytes = (3 & bytesLen);
  $thiz.Ljava_math_BigInteger__f_numberLength = (((bytesLen >> 2) + ((highBytes === 0) ? 0 : 1)) | 0);
  $thiz.Ljava_math_BigInteger__f_digits = new $ac_I($thiz.Ljava_math_BigInteger__f_numberLength);
  var elem = 0;
  elem = 0;
  while ((bytesLen > highBytes)) {
    $thiz.Ljava_math_BigInteger__f_digits.u[elem] = ((((255 & byteValues.u[(((-1) + bytesLen) | 0)]) | ((255 & byteValues.u[(((-2) + bytesLen) | 0)]) << 8)) | ((255 & byteValues.u[(((-3) + bytesLen) | 0)]) << 16)) | (byteValues.u[(((-4) + bytesLen) | 0)] << 24));
    bytesLen = (((-4) + bytesLen) | 0);
    elem = ((1 + elem) | 0);
  }
  var end = bytesLen;
  var i = 0;
  while ((i < end)) {
    var value = i;
    $thiz.Ljava_math_BigInteger__f_digits.u[elem] = (($thiz.Ljava_math_BigInteger__f_digits.u[elem] << 8) | (255 & byteValues.u[value]));
    i = ((1 + i) | 0);
  }
}
export { $p_Ljava_math_BigInteger__putBytesPositiveToIntegers__AB__V as $p_Ljava_math_BigInteger__putBytesPositiveToIntegers__AB__V };
function $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix) {
  if ((((s === "") || (s === "+")) || (s === "-"))) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger");
  }
  var stringLength0 = s.length;
  if ((s.charCodeAt(0) === 45)) {
    var _3 = (((-1) + stringLength0) | 0);
    var x1___1 = (-1);
    var x1___2 = 1;
    var x1___3 = _3;
  } else if ((s.charCodeAt(0) === 43)) {
    var _3$1 = (((-1) + stringLength0) | 0);
    var x1___1 = 1;
    var x1___2 = 1;
    var x1___3 = _3$1;
  } else {
    var x1___1 = 1;
    var x1___2 = 0;
    var x1___3 = stringLength0;
  }
  var _sign = (x1___1 | 0);
  var startChar = (x1___2 | 0);
  var stringLength = (x1___3 | 0);
  var i = startChar;
  while ((i < stringLength0)) {
    var value = i;
    var c = s.charCodeAt(value);
    if (((c === 43) || (c === 45))) {
      throw new $c_jl_NumberFormatException("Illegal embedded sign character");
    }
    i = ((1 + i) | 0);
  }
  var charsPerInt = $m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_DigitFitInInt.u[radix];
  var bigRadixDigitsLength = ((stringLength / $checkIntDivisor(charsPerInt)) | 0);
  var topChars = ((stringLength % $checkIntDivisor(charsPerInt)) | 0);
  if ((topChars !== 0)) {
    bigRadixDigitsLength = ((1 + bigRadixDigitsLength) | 0);
  }
  var _digits = new $ac_I(bigRadixDigitsLength);
  var bigRadix = $m_Ljava_math_Conversion$().Ljava_math_Conversion$__f_BigRadices.u[(((-2) + radix) | 0)];
  var digitIndex = 0;
  var substrEnd = ((startChar + ((topChars === 0) ? charsPerInt : topChars)) | 0);
  var newDigit = 0;
  var substrStart = startChar;
  while ((substrStart < stringLength0)) {
    var this$3 = $m_jl_Integer$();
    var beginIndex = substrStart;
    var endIndex = substrEnd;
    var s$1 = s.substring(beginIndex, endIndex);
    if (((radix < 2) || (radix > 36))) {
      this$3.parseIntFail__T__E(s$1);
    }
    var bigRadixDigit = this$3.java$lang$Integer$$parseIntImpl__T__I__I__I(s$1, radix, ((2147483648 / ($checkIntDivisor(radix) >>> 0)) | 0));
    var this$5 = $m_Ljava_math_Multiplication$();
    var aSize = digitIndex;
    newDigit = $p_Ljava_math_Multiplication$__multiplyByInt__AI__AI__I__I__I(this$5, _digits, _digits, aSize, bigRadix);
    newDigit = ((newDigit + $m_Ljava_math_Elementary$().inplaceAdd__AI__I__I__I(_digits, digitIndex, bigRadixDigit)) | 0);
    _digits.u[digitIndex] = newDigit;
    digitIndex = ((1 + digitIndex) | 0);
    substrStart = substrEnd;
    substrEnd = ((substrStart + charsPerInt) | 0);
  }
  $thiz.Ljava_math_BigInteger__f_sign = _sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = digitIndex;
  $thiz.Ljava_math_BigInteger__f_digits = _digits;
  $thiz.cutOffLeadingZeroes__V();
}
export { $p_Ljava_math_BigInteger__setFromString__T__I__V as $p_Ljava_math_BigInteger__setFromString__T__I__V };
function $ct_Ljava_math_BigInteger__($thiz) {
  $thiz.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = (-2);
  $thiz.Ljava_math_BigInteger__f__hashCode = 0;
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__ as $ct_Ljava_math_BigInteger__ };
function $ct_Ljava_math_BigInteger__AB__($thiz, byteArray) {
  $ct_Ljava_math_BigInteger__($thiz);
  if ((byteArray.u.length === 0)) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger");
  }
  if ((byteArray.u[0] < 0)) {
    $thiz.Ljava_math_BigInteger__f_sign = (-1);
    $p_Ljava_math_BigInteger__putBytesNegativeToIntegers__AB__V($thiz, byteArray);
  } else {
    $thiz.Ljava_math_BigInteger__f_sign = 1;
    $p_Ljava_math_BigInteger__putBytesPositiveToIntegers__AB__V($thiz, byteArray);
  }
  $thiz.cutOffLeadingZeroes__V();
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__AB__ as $ct_Ljava_math_BigInteger__AB__ };
function $ct_Ljava_math_BigInteger__T__I__($thiz, s, radix) {
  $ct_Ljava_math_BigInteger__($thiz);
  $m_Ljava_math_BigInteger$();
  if ((s === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if (((radix < 2) || (radix > 36))) {
    throw new $c_jl_NumberFormatException("Radix out of range");
  }
  if ((s === "")) {
    throw new $c_jl_NumberFormatException("Zero length BigInteger");
  }
  $p_Ljava_math_BigInteger__setFromString__T__I__V($thiz, s, radix);
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__T__I__ as $ct_Ljava_math_BigInteger__T__I__ };
function $ct_Ljava_math_BigInteger__T__($thiz, s) {
  $ct_Ljava_math_BigInteger__T__I__($thiz, s, 10);
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__T__ as $ct_Ljava_math_BigInteger__T__ };
function $ct_Ljava_math_BigInteger__I__I__($thiz, sign, value) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = 1;
  $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([value]));
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__I__I__ as $ct_Ljava_math_BigInteger__I__I__ };
function $ct_Ljava_math_BigInteger__I__AI__($thiz, signum, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  if ((digits.u.length === 0)) {
    $thiz.Ljava_math_BigInteger__f_sign = 0;
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([0]));
  } else {
    $thiz.Ljava_math_BigInteger__f_sign = signum;
    $thiz.Ljava_math_BigInteger__f_numberLength = digits.u.length;
    $thiz.Ljava_math_BigInteger__f_digits = digits;
    $thiz.cutOffLeadingZeroes__V();
  }
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__I__AI__ as $ct_Ljava_math_BigInteger__I__AI__ };
function $ct_Ljava_math_BigInteger__I__I__AI__($thiz, sign, numberLength, digits) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  $thiz.Ljava_math_BigInteger__f_numberLength = numberLength;
  $thiz.Ljava_math_BigInteger__f_digits = digits;
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__I__I__AI__ as $ct_Ljava_math_BigInteger__I__I__AI__ };
function $ct_Ljava_math_BigInteger__I__J__($thiz, sign, lVal) {
  $ct_Ljava_math_BigInteger__($thiz);
  $thiz.Ljava_math_BigInteger__f_sign = sign;
  var hi = lVal.RTLong__f_hi;
  if ((hi === 0)) {
    $thiz.Ljava_math_BigInteger__f_numberLength = 1;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal.RTLong__f_lo]));
  } else {
    $thiz.Ljava_math_BigInteger__f_numberLength = 2;
    $thiz.Ljava_math_BigInteger__f_digits = new $ac_I(new Int32Array([lVal.RTLong__f_lo, hi]));
  }
  return $thiz;
}
export { $ct_Ljava_math_BigInteger__I__J__ as $ct_Ljava_math_BigInteger__I__J__ };
/** @constructor */
function $c_Ljava_math_BigInteger() {
  this.Ljava_math_BigInteger__f_digits = null;
  this.Ljava_math_BigInteger__f_numberLength = 0;
  this.Ljava_math_BigInteger__f_sign = 0;
  this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = 0;
  this.Ljava_math_BigInteger__f__hashCode = 0;
}
export { $c_Ljava_math_BigInteger as $c_Ljava_math_BigInteger };
$c_Ljava_math_BigInteger.prototype = new $h_jl_Number();
$c_Ljava_math_BigInteger.prototype.constructor = $c_Ljava_math_BigInteger;
/** @constructor */
function $h_Ljava_math_BigInteger() {
}
export { $h_Ljava_math_BigInteger as $h_Ljava_math_BigInteger };
$h_Ljava_math_BigInteger.prototype = $c_Ljava_math_BigInteger.prototype;
$c_Ljava_math_BigInteger.prototype.abs__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign < 0) ? $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), 1, this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits) : this);
});
$c_Ljava_math_BigInteger.prototype.compareTo__Ljava_math_BigInteger__I = (function(bi) {
  return ((this.Ljava_math_BigInteger__f_sign > bi.Ljava_math_BigInteger__f_sign) ? 1 : ((this.Ljava_math_BigInteger__f_sign < bi.Ljava_math_BigInteger__f_sign) ? (-1) : ((this.Ljava_math_BigInteger__f_numberLength > bi.Ljava_math_BigInteger__f_numberLength) ? this.Ljava_math_BigInteger__f_sign : ((this.Ljava_math_BigInteger__f_numberLength < bi.Ljava_math_BigInteger__f_numberLength) ? ((-bi.Ljava_math_BigInteger__f_sign) | 0) : Math.imul(this.Ljava_math_BigInteger__f_sign, $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, bi.Ljava_math_BigInteger__f_digits, this.Ljava_math_BigInteger__f_numberLength))))));
});
$c_Ljava_math_BigInteger.prototype.divide__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(divisor) {
  if ((divisor.Ljava_math_BigInteger__f_sign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorSign = divisor.Ljava_math_BigInteger__f_sign;
  if (divisor.isOne__Z()) {
    return ((divisor.Ljava_math_BigInteger__f_sign > 0) ? this : this.negate__Ljava_math_BigInteger());
  } else {
    var thisSign = this.Ljava_math_BigInteger__f_sign;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var divisorLen = divisor.Ljava_math_BigInteger__f_numberLength;
    if ((((thisLen + divisorLen) | 0) === 2)) {
      var dividend = this.Ljava_math_BigInteger__f_digits.u[0];
      var divisor$1 = divisor.Ljava_math_BigInteger__f_digits.u[0];
      var x = (((dividend >>> 0) / ($checkIntDivisor(divisor$1) >>> 0)) | 0);
      if ((thisSign !== divisorSign)) {
        var lo = ((-x) | 0);
        var hi = ((x | lo) >> 31);
        var bi__lo = lo;
        var bi__hi = hi;
      } else {
        var bi__lo = x;
        var bi__hi = 0;
      }
      return $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(bi__lo, bi__hi));
    } else {
      var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(this.Ljava_math_BigInteger__f_digits, divisor.Ljava_math_BigInteger__f_digits, thisLen));
      if ((cmp === 0)) {
        return ((thisSign === divisorSign) ? $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE : $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_MINUS_ONE);
      } else if ((cmp === (-1))) {
        return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
      } else {
        var resLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
        var resDigits = new $ac_I(resLength);
        var resSign = ((thisSign === divisorSign) ? 1 : (-1));
        if ((divisorLen === 1)) {
          $m_Ljava_math_Division$().divideArrayByInt__AI__AI__I__I__I(resDigits, this.Ljava_math_BigInteger__f_digits, thisLen, divisor.Ljava_math_BigInteger__f_digits.u[0]);
        } else {
          $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(resDigits, resLength, this.Ljava_math_BigInteger__f_digits, thisLen, divisor.Ljava_math_BigInteger__f_digits, divisorLen);
        }
        var result = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), resSign, resLength, resDigits);
        result.cutOffLeadingZeroes__V();
        return result;
      }
    }
  }
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainder__Ljava_math_BigInteger__ALjava_math_BigInteger = (function(divisor) {
  return this.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem(divisor).toArray__ALjava_math_BigInteger();
});
$c_Ljava_math_BigInteger.prototype.divideAndRemainderImpl__Ljava_math_BigInteger__Ljava_math_BigInteger$QuotAndRem = (function(divisor) {
  var divisorSign = divisor.Ljava_math_BigInteger__f_sign;
  if ((divisorSign === 0)) {
    throw new $c_jl_ArithmeticException("BigInteger divide by zero");
  }
  var divisorLen = divisor.Ljava_math_BigInteger__f_numberLength;
  var divisorDigits = divisor.Ljava_math_BigInteger__f_digits;
  if ((divisorLen === 1)) {
    return $m_Ljava_math_Division$().divideAndRemainderByInteger__Ljava_math_BigInteger__I__I__Ljava_math_BigInteger$QuotAndRem(this, divisorDigits.u[0], divisorSign);
  } else {
    var thisDigits = this.Ljava_math_BigInteger__f_digits;
    var thisLen = this.Ljava_math_BigInteger__f_numberLength;
    var cmp = ((thisLen !== divisorLen) ? ((thisLen > divisorLen) ? 1 : (-1)) : $m_Ljava_math_Elementary$().compareArrays__AI__AI__I__I(thisDigits, divisorDigits, thisLen));
    if ((cmp < 0)) {
      return new $c_Ljava_math_BigInteger$QuotAndRem($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO, this);
    } else {
      var thisSign = this.Ljava_math_BigInteger__f_sign;
      var quotientLength = ((1 + ((thisLen - divisorLen) | 0)) | 0);
      var quotientSign = ((thisSign === divisorSign) ? 1 : (-1));
      var quotientDigits = new $ac_I(quotientLength);
      var remainderDigits = $m_Ljava_math_Division$().divide__AI__I__AI__I__AI__I__AI(quotientDigits, quotientLength, thisDigits, thisLen, divisorDigits, divisorLen);
      var result0 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), quotientSign, quotientLength, quotientDigits);
      var result1 = $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), thisSign, divisorLen, remainderDigits);
      result0.cutOffLeadingZeroes__V();
      result1.cutOffLeadingZeroes__V();
      return new $c_Ljava_math_BigInteger$QuotAndRem(result0, result1);
    }
  }
});
$c_Ljava_math_BigInteger.prototype.equals__O__Z = (function(x) {
  return ((x instanceof $c_Ljava_math_BigInteger) && (((this.Ljava_math_BigInteger__f_sign === x.Ljava_math_BigInteger__f_sign) && (this.Ljava_math_BigInteger__f_numberLength === x.Ljava_math_BigInteger__f_numberLength)) && this.equalsArrays__AI__Z(x.Ljava_math_BigInteger__f_digits)));
});
$c_Ljava_math_BigInteger.prototype.getLowestSetBit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_sign === 0)) {
    return (-1);
  } else {
    var i = this.getFirstNonzeroDigit__I();
    var i$1 = this.Ljava_math_BigInteger__f_digits.u[i];
    var i$2 = ((~i$1) & (((-1) + i$1) | 0));
    return (((i << 5) + ((32 - Math.clz32(i$2)) | 0)) | 0);
  }
});
$c_Ljava_math_BigInteger.prototype.hashCode__I = (function() {
  if ((this.Ljava_math_BigInteger__f__hashCode !== 0)) {
    return this.Ljava_math_BigInteger__f__hashCode;
  } else {
    var end = this.Ljava_math_BigInteger__f_numberLength;
    var i = 0;
    while ((i < end)) {
      var value = i;
      this.Ljava_math_BigInteger__f__hashCode = ((Math.imul(33, this.Ljava_math_BigInteger__f__hashCode) + this.Ljava_math_BigInteger__f_digits.u[value]) | 0);
      i = ((1 + i) | 0);
    }
    this.Ljava_math_BigInteger__f__hashCode = Math.imul(this.Ljava_math_BigInteger__f__hashCode, this.Ljava_math_BigInteger__f_sign);
    return this.Ljava_math_BigInteger__f__hashCode;
  }
});
$c_Ljava_math_BigInteger.prototype.intValue__I = (function() {
  return Math.imul(this.Ljava_math_BigInteger__f_sign, this.Ljava_math_BigInteger__f_digits.u[0]);
});
$c_Ljava_math_BigInteger.prototype.longValue__J = (function() {
  if ((this.Ljava_math_BigInteger__f_numberLength > 1)) {
    var value = this.Ljava_math_BigInteger__f_digits.u[1];
    var value$1 = this.Ljava_math_BigInteger__f_digits.u[0];
    var value$3__lo = value$1;
    var value$3__hi = value;
  } else {
    var value$2 = this.Ljava_math_BigInteger__f_digits.u[0];
    var value$3__lo = value$2;
    var value$3__hi = 0;
  }
  var value$4 = this.Ljava_math_BigInteger__f_sign;
  var hi$3 = (value$4 >> 31);
  var blo = value$3__lo;
  var a0 = (65535 & value$4);
  var a1 = ((value$4 >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((((((Math.imul(value$4, value$3__hi) + Math.imul(hi$3, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi$4);
});
$c_Ljava_math_BigInteger.prototype.multiply__Ljava_math_BigInteger__Ljava_math_BigInteger = (function(bi) {
  if (((bi.Ljava_math_BigInteger__f_sign === 0) || (this.Ljava_math_BigInteger__f_sign === 0))) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO;
  } else {
    var this$1 = $m_Ljava_math_Multiplication$();
    return this$1.karatsuba__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this, bi);
  }
});
$c_Ljava_math_BigInteger.prototype.negate__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $ct_Ljava_math_BigInteger__I__I__AI__(new $c_Ljava_math_BigInteger(), ((-this.Ljava_math_BigInteger__f_sign) | 0), this.Ljava_math_BigInteger__f_numberLength, this.Ljava_math_BigInteger__f_digits));
});
$c_Ljava_math_BigInteger.prototype.pow__I__Ljava_math_BigInteger = (function(exp) {
  if ((exp < 0)) {
    throw new $c_jl_ArithmeticException("Negative exponent");
  } else if ((exp === 0)) {
    return $m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE;
  } else if ((((exp === 1) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ONE)) || this.equals__O__Z($m_Ljava_math_BigInteger$().Ljava_math_BigInteger$__f_ZERO))) {
    return this;
  } else if ((!this.testBit__I__Z(0))) {
    var x = 1;
    while ((!this.testBit__I__Z(x))) {
      x = ((1 + x) | 0);
    }
    return $m_Ljava_math_BigInteger$().getPowerOfTwo__I__Ljava_math_BigInteger(Math.imul(x, exp)).multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(this.shiftRight__I__Ljava_math_BigInteger(x).pow__I__Ljava_math_BigInteger(exp));
  } else {
    return $m_Ljava_math_Multiplication$().pow__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, exp);
  }
});
$c_Ljava_math_BigInteger.prototype.shiftLeft__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))));
});
$c_Ljava_math_BigInteger.prototype.shiftRight__I__Ljava_math_BigInteger = (function(n) {
  return (((n === 0) || (this.Ljava_math_BigInteger__f_sign === 0)) ? this : ((n > 0) ? $m_Ljava_math_BitLevel$().shiftRight__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, n) : $m_Ljava_math_BitLevel$().shiftLeft__Ljava_math_BigInteger__I__Ljava_math_BigInteger(this, ((-n) | 0))));
});
$c_Ljava_math_BigInteger.prototype.testBit__I__Z = (function(n) {
  var intCount = (n >> 5);
  if ((n === 0)) {
    return ((1 & this.Ljava_math_BigInteger__f_digits.u[0]) !== 0);
  } else if ((n < 0)) {
    throw new $c_jl_ArithmeticException("Negative bit address");
  } else if ((intCount >= this.Ljava_math_BigInteger__f_numberLength)) {
    return (this.Ljava_math_BigInteger__f_sign < 0);
  } else if ((!((this.Ljava_math_BigInteger__f_sign < 0) && (intCount < this.getFirstNonzeroDigit__I())))) {
    var digit = this.Ljava_math_BigInteger__f_digits.u[intCount];
    if ((this.Ljava_math_BigInteger__f_sign < 0)) {
      digit = ((this.getFirstNonzeroDigit__I() === intCount) ? ((-digit) | 0) : (~digit));
    }
    var i = (1 << (31 & n));
    return ((digit & i) !== 0);
  } else {
    return false;
  }
});
$c_Ljava_math_BigInteger.prototype.toByteArray__AB = (function() {
  if ((this.Ljava_math_BigInteger__f_sign === 0)) {
    return new $ac_B(new Int8Array([0]));
  }
  var bitLen = $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this);
  var firstNonZeroDigit = this.getFirstNonzeroDigit__I();
  var elem = ((1 + (bitLen >> 3)) | 0);
  var elem$1 = 0;
  elem$1 = elem;
  var bytes = new $ac_B(elem$1);
  var elem$2 = 0;
  elem$2 = 0;
  var elem$3 = 0;
  elem$3 = firstNonZeroDigit;
  var elem$4 = 0;
  elem$4 = 4;
  var elem$5 = 0;
  elem$5 = 0;
  if ((((elem$1 - (this.Ljava_math_BigInteger__f_numberLength << 2)) | 0) === 1)) {
    var bytesZero = ((this.Ljava_math_BigInteger__f_sign < 0) ? (-1) : 0);
    bytes.u[0] = ((bytesZero << 24) >> 24);
    elem$2 = ((1 + elem$2) | 0);
    var highBytes = 4;
  } else {
    var hB = (3 & elem$1);
    var highBytes = ((hB === 0) ? 4 : hB);
  }
  elem$1 = ((elem$1 - (firstNonZeroDigit << 2)) | 0);
  if ((this.Ljava_math_BigInteger__f_sign < 0)) {
    var tempDigit = ((-this.Ljava_math_BigInteger__f_digits.u[elem$3]) | 0);
    elem$5 = tempDigit;
    elem$3 = ((1 + elem$3) | 0);
    if ((elem$3 === this.Ljava_math_BigInteger__f_numberLength)) {
      elem$4 = highBytes;
    }
    var end = elem$4;
    var i = 0;
    while ((i < end)) {
      elem$1 = (((-1) + elem$1) | 0);
      bytes.u[elem$1] = ((elem$5 << 24) >> 24);
      elem$5 = (elem$5 >> 8);
      i = ((1 + i) | 0);
    }
    while ((elem$1 > elem$2)) {
      var value$1 = elem$3;
      var tempDigit$1 = (~this.Ljava_math_BigInteger__f_digits.u[value$1]);
      elem$5 = tempDigit$1;
      elem$3 = ((1 + elem$3) | 0);
      if ((elem$3 === this.Ljava_math_BigInteger__f_numberLength)) {
        elem$4 = highBytes;
      }
      var end$1 = elem$4;
      var i$1 = 0;
      while ((i$1 < end$1)) {
        elem$1 = (((-1) + elem$1) | 0);
        bytes.u[elem$1] = ((elem$5 << 24) >> 24);
        elem$5 = (elem$5 >> 8);
        i$1 = ((1 + i$1) | 0);
      }
    }
  } else {
    while ((elem$1 > elem$2)) {
      var value$3 = elem$3;
      var tempDigit$2 = this.Ljava_math_BigInteger__f_digits.u[value$3];
      elem$5 = tempDigit$2;
      elem$3 = ((1 + elem$3) | 0);
      if ((elem$3 === this.Ljava_math_BigInteger__f_numberLength)) {
        elem$4 = highBytes;
      }
      var end$2 = elem$4;
      var i$2 = 0;
      while ((i$2 < end$2)) {
        elem$1 = (((-1) + elem$1) | 0);
        bytes.u[elem$1] = ((elem$5 << 24) >> 24);
        elem$5 = (elem$5 >> 8);
        i$2 = ((1 + i$2) | 0);
      }
    }
  }
  return bytes;
});
$c_Ljava_math_BigInteger.prototype.toString__T = (function() {
  return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this);
});
$c_Ljava_math_BigInteger.prototype.cutOffLeadingZeroes__V = (function() {
  while (true) {
    if ((this.Ljava_math_BigInteger__f_numberLength > 0)) {
      this.Ljava_math_BigInteger__f_numberLength = (((-1) + this.Ljava_math_BigInteger__f_numberLength) | 0);
      if ((this.Ljava_math_BigInteger__f_digits.u[this.Ljava_math_BigInteger__f_numberLength] === 0)) {
        continue;
      }
    }
    break;
  }
  if ((this.Ljava_math_BigInteger__f_digits.u[this.Ljava_math_BigInteger__f_numberLength] === 0)) {
    this.Ljava_math_BigInteger__f_sign = 0;
  }
  this.Ljava_math_BigInteger__f_numberLength = ((1 + this.Ljava_math_BigInteger__f_numberLength) | 0);
});
$c_Ljava_math_BigInteger.prototype.equalsArrays__AI__Z = (function(b) {
  var i = 0;
  while ((i !== this.Ljava_math_BigInteger__f_numberLength)) {
    if ((this.Ljava_math_BigInteger__f_digits.u[i] !== b.u[i])) {
      return false;
    }
    i = ((1 + i) | 0);
  }
  return true;
});
$c_Ljava_math_BigInteger.prototype.getFirstNonzeroDigit__I = (function() {
  if ((this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit === (-2))) {
    if ((this.Ljava_math_BigInteger__f_sign === 0)) {
      var $x_1 = (-1);
    } else {
      var i = 0;
      while ((this.Ljava_math_BigInteger__f_digits.u[i] === 0)) {
        i = ((1 + i) | 0);
      }
      var $x_1 = i;
    }
    this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit = $x_1;
  }
  return this.Ljava_math_BigInteger__f_java$math$BigInteger$$firstNonzeroDigit;
});
$c_Ljava_math_BigInteger.prototype.isOne__Z = (function() {
  return ((this.Ljava_math_BigInteger__f_numberLength === 1) && (this.Ljava_math_BigInteger__f_digits.u[0] === 1));
});
$c_Ljava_math_BigInteger.prototype.shiftLeftOneBit__Ljava_math_BigInteger = (function() {
  return ((this.Ljava_math_BigInteger__f_sign === 0) ? this : $m_Ljava_math_BitLevel$().shiftLeftOneBit__Ljava_math_BigInteger__Ljava_math_BigInteger(this));
});
$c_Ljava_math_BigInteger.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_math_BigInteger__I(o);
});
function $isArrayOf_Ljava_math_BigInteger(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_math_BigInteger)));
}
export { $isArrayOf_Ljava_math_BigInteger as $isArrayOf_Ljava_math_BigInteger };
var $d_Ljava_math_BigInteger = new $TypeData().initClass($c_Ljava_math_BigInteger, "java.math.BigInteger", ({
  Ljava_math_BigInteger: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1
}));
export { $d_Ljava_math_BigInteger as $d_Ljava_math_BigInteger };
/** @constructor */
function $c_Ljava_math_RoundingMode(name, ordinal) {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, name, ordinal);
}
export { $c_Ljava_math_RoundingMode as $c_Ljava_math_RoundingMode };
$c_Ljava_math_RoundingMode.prototype = new $h_jl_Enum();
$c_Ljava_math_RoundingMode.prototype.constructor = $c_Ljava_math_RoundingMode;
/** @constructor */
function $h_Ljava_math_RoundingMode() {
}
export { $h_Ljava_math_RoundingMode as $h_Ljava_math_RoundingMode };
$h_Ljava_math_RoundingMode.prototype = $c_Ljava_math_RoundingMode.prototype;
var $d_Ljava_math_RoundingMode = new $TypeData().initClass($c_Ljava_math_RoundingMode, "java.math.RoundingMode", ({
  Ljava_math_RoundingMode: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_math_RoundingMode as $d_Ljava_math_RoundingMode };
/** @constructor */
function $c_Ljava_nio_HeapByteBuffer(_capacity, _array0, _arrayOffset0, _initialPosition, _initialLimit, _readOnly) {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_ByteBuffer__f__array = null;
  this.Ljava_nio_ByteBuffer__f__arrayOffset = 0;
  this.Ljava_nio_ByteBuffer__f__isBigEndian = false;
  this.Ljava_nio_HeapByteBuffer__f__readOnly = false;
  this.Ljava_nio_HeapByteBuffer__f__readOnly = _readOnly;
  $ct_Ljava_nio_ByteBuffer__I__AB__I__(this, _capacity, _array0, _arrayOffset0);
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer.call(this, _initialLimit);
}
export { $c_Ljava_nio_HeapByteBuffer as $c_Ljava_nio_HeapByteBuffer };
$c_Ljava_nio_HeapByteBuffer.prototype = new $h_Ljava_nio_ByteBuffer();
$c_Ljava_nio_HeapByteBuffer.prototype.constructor = $c_Ljava_nio_HeapByteBuffer;
/** @constructor */
function $h_Ljava_nio_HeapByteBuffer() {
}
export { $h_Ljava_nio_HeapByteBuffer as $h_Ljava_nio_HeapByteBuffer };
$h_Ljava_nio_HeapByteBuffer.prototype = $c_Ljava_nio_HeapByteBuffer.prototype;
$c_Ljava_nio_HeapByteBuffer.prototype.slice__Ljava_nio_ByteBuffer = (function() {
  var newCapacity = ((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
  var readOnly = this.Ljava_nio_HeapByteBuffer__f__readOnly;
  return new $c_Ljava_nio_HeapByteBuffer(newCapacity, array, arrayOffset, 0, newCapacity, readOnly);
});
$c_Ljava_nio_HeapByteBuffer.prototype.duplicate__Ljava_nio_ByteBuffer = (function() {
  var capacity = this.Ljava_nio_Buffer__f__capacity;
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var initialPosition = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var initialLimit = this.Ljava_nio_Buffer__f__limit;
  var readOnly = this.Ljava_nio_HeapByteBuffer__f__readOnly;
  var result = new $c_Ljava_nio_HeapByteBuffer(capacity, array, arrayOffset, initialPosition, initialLimit, readOnly);
  result.Ljava_nio_Buffer__f__mark = this.Ljava_nio_Buffer__f__mark;
  return result;
});
$c_Ljava_nio_HeapByteBuffer.prototype.asReadOnlyBuffer__Ljava_nio_ByteBuffer = (function() {
  var capacity = this.Ljava_nio_Buffer__f__capacity;
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var initialPosition = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var initialLimit = this.Ljava_nio_Buffer__f__limit;
  var result = new $c_Ljava_nio_HeapByteBuffer(capacity, array, arrayOffset, initialPosition, initialLimit, true);
  result.Ljava_nio_Buffer__f__mark = this.Ljava_nio_Buffer__f__mark;
  return result;
});
$c_Ljava_nio_HeapByteBuffer.prototype.get__B = (function() {
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  var a = this.Ljava_nio_ByteBuffer__f__array;
  var i = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + p) | 0);
  return a.u[i];
});
$c_Ljava_nio_HeapByteBuffer.prototype.put__B__Ljava_nio_ByteBuffer = (function(b) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  var a = this.Ljava_nio_ByteBuffer__f__array;
  var i = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + p) | 0);
  a.u[i] = b;
  return this;
});
$c_Ljava_nio_HeapByteBuffer.prototype.get__I__B = (function(index) {
  if (((index < 0) || (index >= this.Ljava_nio_Buffer__f__limit))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var a = this.Ljava_nio_ByteBuffer__f__array;
  var i = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + index) | 0);
  return a.u[i];
});
$c_Ljava_nio_HeapByteBuffer.prototype.get__AB__I__I__Ljava_nio_ByteBuffer = (function(dst, offset, length) {
  if ((((offset < 0) || (length < 0)) || (offset > ((dst.u.length - length) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var x0 = this.Ljava_nio_ByteBuffer__f__array;
  var x1 = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + p) | 0);
  x0.copyTo(x1, dst, offset, length);
  return this;
});
$c_Ljava_nio_HeapByteBuffer.prototype.put__AB__I__I__Ljava_nio_ByteBuffer = (function(src, offset, length) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  if ((((offset < 0) || (length < 0)) || (offset > ((src.u.length - length) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var x2 = this.Ljava_nio_ByteBuffer__f__array;
  var x3 = ((this.Ljava_nio_ByteBuffer__f__arrayOffset + p) | 0);
  src.copyTo(offset, x2, x3, length);
  return this;
});
$c_Ljava_nio_HeapByteBuffer.prototype.getShort__S = (function() {
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((2 + p) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var idx = ((p + arrayOffset) | 0);
  var _1 = array.u[idx];
  var _2 = array.u[((1 + idx) | 0)];
  return (isBigEndian ? ((((_1 << 8) | (255 & _2)) << 16) >> 16) : ((((_2 << 8) | (255 & _1)) << 16) >> 16));
});
$c_Ljava_nio_HeapByteBuffer.prototype.putShort__S__Ljava_nio_ByteBuffer = (function(value) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((2 + p) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var _1 = (((value >> 8) << 24) >> 24);
  var _2 = ((value << 24) >> 24);
  if (isBigEndian) {
    var bs___1 = _1;
    var bs___2 = _2;
  } else {
    var bs___1 = _2;
    var bs___2 = _1;
  }
  var idx = ((p + arrayOffset) | 0);
  array.u[idx] = (bs___1 | 0);
  array.u[((1 + idx) | 0)] = (bs___2 | 0);
  return this;
});
$c_Ljava_nio_HeapByteBuffer.prototype.getInt__I = (function() {
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((4 + p) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var idx = ((p + arrayOffset) | 0);
  var _1 = array.u[idx];
  var _2 = array.u[((1 + idx) | 0)];
  var _3 = array.u[((2 + idx) | 0)];
  var _4 = array.u[((3 + idx) | 0)];
  return (isBigEndian ? ((((_1 << 24) | ((255 & _2) << 16)) | ((255 & _3) << 8)) | (255 & _4)) : ((((_4 << 24) | ((255 & _3) << 16)) | ((255 & _2) << 8)) | (255 & _1)));
});
$c_Ljava_nio_HeapByteBuffer.prototype.putInt__I__Ljava_nio_ByteBuffer = (function(value) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((4 + p) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var _1 = (((value >> 24) << 24) >> 24);
  var _2 = (((value >> 16) << 24) >> 24);
  var _3 = (((value >> 8) << 24) >> 24);
  var _4 = ((value << 24) >> 24);
  if (isBigEndian) {
    var bs___1 = _1;
    var bs___2 = _2;
    var bs___3 = _3;
    var bs___4 = _4;
  } else {
    var bs___1 = _4;
    var bs___2 = _3;
    var bs___3 = _2;
    var bs___4 = _1;
  }
  var idx = ((p + arrayOffset) | 0);
  array.u[idx] = (bs___1 | 0);
  array.u[((1 + idx) | 0)] = (bs___2 | 0);
  array.u[((2 + idx) | 0)] = (bs___3 | 0);
  array.u[((3 + idx) | 0)] = (bs___4 | 0);
  return this;
});
$c_Ljava_nio_HeapByteBuffer.prototype.getLong__J = (function() {
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((8 + p) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var idx = ((p + arrayOffset) | 0);
  var _1 = array.u[idx];
  var _2 = array.u[((1 + idx) | 0)];
  var _3 = array.u[((2 + idx) | 0)];
  var _4 = array.u[((3 + idx) | 0)];
  var _5 = array.u[((4 + idx) | 0)];
  var _6 = array.u[((5 + idx) | 0)];
  var _7 = array.u[((6 + idx) | 0)];
  var _8 = array.u[((7 + idx) | 0)];
  if (isBigEndian) {
    var value = ((((_1 << 24) | ((255 & _2) << 16)) | ((255 & _3) << 8)) | (255 & _4));
    var value$1 = ((((_5 << 24) | ((255 & _6) << 16)) | ((255 & _7) << 8)) | (255 & _8));
    return new $c_RTLong(value$1, value);
  } else {
    var value$2 = ((((_8 << 24) | ((255 & _7) << 16)) | ((255 & _6) << 8)) | (255 & _5));
    var value$3 = ((((_4 << 24) | ((255 & _3) << 16)) | ((255 & _2) << 8)) | (255 & _1));
    return new $c_RTLong(value$3, value$2);
  }
});
$c_Ljava_nio_HeapByteBuffer.prototype.putLong__J__Ljava_nio_ByteBuffer = (function(value) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((8 + p) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var hi = value.RTLong__f_hi;
  var _1 = (((hi >> 24) << 24) >> 24);
  var _2 = (((hi >> 16) << 24) >> 24);
  var _3 = (((hi >> 8) << 24) >> 24);
  var _4 = ((hi << 24) >> 24);
  var i = value.RTLong__f_lo;
  var _1$1 = (((i >> 24) << 24) >> 24);
  var _2$1 = (((i >> 16) << 24) >> 24);
  var _3$1 = (((i >> 8) << 24) >> 24);
  var _4$1 = ((i << 24) >> 24);
  if (isBigEndian) {
    var bs___1 = _1;
    var bs___2 = _2;
    var bs___3 = _3;
    var bs___4 = _4;
    var bs___5 = _1$1;
    var bs___6 = _2$1;
    var bs___7 = _3$1;
    var bs___8 = _4$1;
  } else {
    var bs___1 = _4$1;
    var bs___2 = _3$1;
    var bs___3 = _2$1;
    var bs___4 = _1$1;
    var bs___5 = _4;
    var bs___6 = _3;
    var bs___7 = _2;
    var bs___8 = _1;
  }
  var idx = ((p + arrayOffset) | 0);
  array.u[idx] = (bs___1 | 0);
  array.u[((1 + idx) | 0)] = (bs___2 | 0);
  array.u[((2 + idx) | 0)] = (bs___3 | 0);
  array.u[((3 + idx) | 0)] = (bs___4 | 0);
  array.u[((4 + idx) | 0)] = (bs___5 | 0);
  array.u[((5 + idx) | 0)] = (bs___6 | 0);
  array.u[((6 + idx) | 0)] = (bs___7 | 0);
  array.u[((7 + idx) | 0)] = (bs___8 | 0);
  return this;
});
$c_Ljava_nio_HeapByteBuffer.prototype.getFloat__F = (function() {
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((4 + p) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var idx = ((p + arrayOffset) | 0);
  var _1 = array.u[idx];
  var _2 = array.u[((1 + idx) | 0)];
  var _3 = array.u[((2 + idx) | 0)];
  var _4 = array.u[((3 + idx) | 0)];
  var bits = (isBigEndian ? ((((_1 << 24) | ((255 & _2) << 16)) | ((255 & _3) << 8)) | (255 & _4)) : ((((_4 << 24) | ((255 & _3) << 16)) | ((255 & _2) << 8)) | (255 & _1)));
  return $floatFromBits(bits);
});
$c_Ljava_nio_HeapByteBuffer.prototype.putFloat__F__Ljava_nio_ByteBuffer = (function(value) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((4 + p) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var i = $floatToBits(value);
  var _1 = (((i >> 24) << 24) >> 24);
  var _2 = (((i >> 16) << 24) >> 24);
  var _3 = (((i >> 8) << 24) >> 24);
  var _4 = ((i << 24) >> 24);
  if (isBigEndian) {
    var bs___1 = _1;
    var bs___2 = _2;
    var bs___3 = _3;
    var bs___4 = _4;
  } else {
    var bs___1 = _4;
    var bs___2 = _3;
    var bs___3 = _2;
    var bs___4 = _1;
  }
  var idx = ((p + arrayOffset) | 0);
  array.u[idx] = (bs___1 | 0);
  array.u[((1 + idx) | 0)] = (bs___2 | 0);
  array.u[((2 + idx) | 0)] = (bs___3 | 0);
  array.u[((3 + idx) | 0)] = (bs___4 | 0);
  return this;
});
$c_Ljava_nio_HeapByteBuffer.prototype.getDouble__D = (function() {
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((8 + p) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var idx = ((p + arrayOffset) | 0);
  var _1 = array.u[idx];
  var _2 = array.u[((1 + idx) | 0)];
  var _3 = array.u[((2 + idx) | 0)];
  var _4 = array.u[((3 + idx) | 0)];
  var _5 = array.u[((4 + idx) | 0)];
  var _6 = array.u[((5 + idx) | 0)];
  var _7 = array.u[((6 + idx) | 0)];
  var _8 = array.u[((7 + idx) | 0)];
  if (isBigEndian) {
    var value = ((((_1 << 24) | ((255 & _2) << 16)) | ((255 & _3) << 8)) | (255 & _4));
    var value$1 = ((((_5 << 24) | ((255 & _6) << 16)) | ((255 & _7) << 8)) | (255 & _8));
    var bits__lo = value$1;
    var bits__hi = value;
  } else {
    var value$2 = ((((_8 << 24) | ((255 & _7) << 16)) | ((255 & _6) << 8)) | (255 & _5));
    var value$3 = ((((_4 << 24) | ((255 & _3) << 16)) | ((255 & _2) << 8)) | (255 & _1));
    var bits__lo = value$3;
    var bits__hi = value$2;
  }
  var fpBitsDataView = $fpBitsDataView;
  fpBitsDataView.setInt32(0, bits__lo, true);
  fpBitsDataView.setInt32(4, bits__hi, true);
  return (+fpBitsDataView.getFloat64(0, true));
});
$c_Ljava_nio_HeapByteBuffer.prototype.putDouble__D__Ljava_nio_ByteBuffer = (function(value) {
  if (this.Ljava_nio_HeapByteBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var array = this.Ljava_nio_ByteBuffer__f__array;
  var arrayOffset = this.Ljava_nio_ByteBuffer__f__arrayOffset;
  var isBigEndian = this.Ljava_nio_ByteBuffer__f__isBigEndian;
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((8 + p) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var fpBitsDataView = $fpBitsDataView;
  fpBitsDataView.setFloat64(0, value, true);
  var lo = (fpBitsDataView.getInt32(0, true) | 0);
  var hi = (fpBitsDataView.getInt32(4, true) | 0);
  var _1 = (((hi >> 24) << 24) >> 24);
  var _2 = (((hi >> 16) << 24) >> 24);
  var _3 = (((hi >> 8) << 24) >> 24);
  var _4 = ((hi << 24) >> 24);
  var _1$1 = (((lo >> 24) << 24) >> 24);
  var _2$1 = (((lo >> 16) << 24) >> 24);
  var _3$1 = (((lo >> 8) << 24) >> 24);
  var _4$1 = ((lo << 24) >> 24);
  if (isBigEndian) {
    var bs___1 = _1;
    var bs___2 = _2;
    var bs___3 = _3;
    var bs___4 = _4;
    var bs___5 = _1$1;
    var bs___6 = _2$1;
    var bs___7 = _3$1;
    var bs___8 = _4$1;
  } else {
    var bs___1 = _4$1;
    var bs___2 = _3$1;
    var bs___3 = _2$1;
    var bs___4 = _1$1;
    var bs___5 = _4;
    var bs___6 = _3;
    var bs___7 = _2;
    var bs___8 = _1;
  }
  var idx = ((p + arrayOffset) | 0);
  array.u[idx] = (bs___1 | 0);
  array.u[((1 + idx) | 0)] = (bs___2 | 0);
  array.u[((2 + idx) | 0)] = (bs___3 | 0);
  array.u[((3 + idx) | 0)] = (bs___4 | 0);
  array.u[((4 + idx) | 0)] = (bs___5 | 0);
  array.u[((5 + idx) | 0)] = (bs___6 | 0);
  array.u[((6 + idx) | 0)] = (bs___7 | 0);
  array.u[((7 + idx) | 0)] = (bs___8 | 0);
  return this;
});
var $d_Ljava_nio_HeapByteBuffer = new $TypeData().initClass($c_Ljava_nio_HeapByteBuffer, "java.nio.HeapByteBuffer", ({
  Ljava_nio_HeapByteBuffer: 1,
  Ljava_nio_ByteBuffer: 1,
  Ljava_nio_Buffer: 1,
  jl_Comparable: 1
}));
export { $d_Ljava_nio_HeapByteBuffer as $d_Ljava_nio_HeapByteBuffer };
class $c_Ljava_nio_charset_CoderMalfunctionError extends $c_jl_Error {
  constructor(cause) {
    super();
    $ct_jl_Error__jl_Throwable__(this, cause);
  }
}
export { $c_Ljava_nio_charset_CoderMalfunctionError as $c_Ljava_nio_charset_CoderMalfunctionError };
var $d_Ljava_nio_charset_CoderMalfunctionError = new $TypeData().initClass($c_Ljava_nio_charset_CoderMalfunctionError, "java.nio.charset.CoderMalfunctionError", ({
  Ljava_nio_charset_CoderMalfunctionError: 1,
  jl_Error: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_nio_charset_CoderMalfunctionError as $d_Ljava_nio_charset_CoderMalfunctionError };
/** @constructor */
function $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1$() {
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_cachedEncoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
  this.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon__f_java$nio$charset$ISO_8859_1_And_US_ASCII_Common$$maxValue = 0;
  $ct_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon__T__AT__I__(this, "ISO-8859-1", new ($d_T.getArrayOf().constr)(["csISOLatin1", "IBM-819", "iso-ir-100", "8859_1", "ISO_8859-1", "l1", "ISO8859-1", "ISO_8859_1", "cp819", "ISO8859_1", "latin1", "ISO_8859-1:1987", "819", "IBM819"]), 255);
}
export { $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1$ as $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1$ };
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1$.prototype = new $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon();
$c_Ljava_nio_charset_ISO\uff3f8859\uff3f1$.prototype.constructor = $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1$;
/** @constructor */
function $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1$() {
}
export { $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1$ as $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1$ };
$h_Ljava_nio_charset_ISO\uff3f8859\uff3f1$.prototype = $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1$.prototype;
var $d_Ljava_nio_charset_ISO\uff3f8859\uff3f1$ = new $TypeData().initClass($c_Ljava_nio_charset_ISO\uff3f8859\uff3f1$, "java.nio.charset.ISO_8859_1$", ({
  Ljava_nio_charset_ISO\uff3f8859\uff3f1$: 1,
  Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon: 1,
  Ljava_nio_charset_Charset: 1,
  jl_Comparable: 1
}));
export { $d_Ljava_nio_charset_ISO\uff3f8859\uff3f1$ as $d_Ljava_nio_charset_ISO\uff3f8859\uff3f1$ };
var $n_Ljava_nio_charset_ISO\uff3f8859\uff3f1$;
function $m_Ljava_nio_charset_ISO\uff3f8859\uff3f1$() {
  if ((!$n_Ljava_nio_charset_ISO\uff3f8859\uff3f1$)) {
    $n_Ljava_nio_charset_ISO\uff3f8859\uff3f1$ = new $c_Ljava_nio_charset_ISO\uff3f8859\uff3f1$();
  }
  return $n_Ljava_nio_charset_ISO\uff3f8859\uff3f1$;
}
export { $m_Ljava_nio_charset_ISO\uff3f8859\uff3f1$ as $m_Ljava_nio_charset_ISO\uff3f8859\uff3f1$ };
/** @constructor */
function $c_Ljava_nio_charset_US\uff3fASCII$() {
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_cachedEncoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
  this.Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon__f_java$nio$charset$ISO_8859_1_And_US_ASCII_Common$$maxValue = 0;
  $ct_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon__T__AT__I__(this, "US-ASCII", new ($d_T.getArrayOf().constr)(["cp367", "ascii7", "ISO646-US", "646", "csASCII", "us", "iso_646.irv:1983", "ISO_646.irv:1991", "IBM367", "ASCII", "default", "ANSI_X3.4-1986", "ANSI_X3.4-1968", "iso-ir-6"]), 127);
}
export { $c_Ljava_nio_charset_US\uff3fASCII$ as $c_Ljava_nio_charset_US\uff3fASCII$ };
$c_Ljava_nio_charset_US\uff3fASCII$.prototype = new $h_Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon();
$c_Ljava_nio_charset_US\uff3fASCII$.prototype.constructor = $c_Ljava_nio_charset_US\uff3fASCII$;
/** @constructor */
function $h_Ljava_nio_charset_US\uff3fASCII$() {
}
export { $h_Ljava_nio_charset_US\uff3fASCII$ as $h_Ljava_nio_charset_US\uff3fASCII$ };
$h_Ljava_nio_charset_US\uff3fASCII$.prototype = $c_Ljava_nio_charset_US\uff3fASCII$.prototype;
var $d_Ljava_nio_charset_US\uff3fASCII$ = new $TypeData().initClass($c_Ljava_nio_charset_US\uff3fASCII$, "java.nio.charset.US_ASCII$", ({
  Ljava_nio_charset_US\uff3fASCII$: 1,
  Ljava_nio_charset_ISO\uff3f8859\uff3f1\uff3fAnd\uff3fUS\uff3fASCII\uff3fCommon: 1,
  Ljava_nio_charset_Charset: 1,
  jl_Comparable: 1
}));
export { $d_Ljava_nio_charset_US\uff3fASCII$ as $d_Ljava_nio_charset_US\uff3fASCII$ };
var $n_Ljava_nio_charset_US\uff3fASCII$;
function $m_Ljava_nio_charset_US\uff3fASCII$() {
  if ((!$n_Ljava_nio_charset_US\uff3fASCII$)) {
    $n_Ljava_nio_charset_US\uff3fASCII$ = new $c_Ljava_nio_charset_US\uff3fASCII$();
  }
  return $n_Ljava_nio_charset_US\uff3fASCII$;
}
export { $m_Ljava_nio_charset_US\uff3fASCII$ as $m_Ljava_nio_charset_US\uff3fASCII$ };
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f16$() {
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_cachedEncoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness = 0;
  $ct_Ljava_nio_charset_UTF\uff3f16\uff3fCommon__T__AT__I__(this, "UTF-16", new ($d_T.getArrayOf().constr)(["utf16", "UTF_16", "UnicodeBig", "unicode"]), 0);
}
export { $c_Ljava_nio_charset_UTF\uff3f16$ as $c_Ljava_nio_charset_UTF\uff3f16$ };
$c_Ljava_nio_charset_UTF\uff3f16$.prototype = new $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon();
$c_Ljava_nio_charset_UTF\uff3f16$.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f16$;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f16$() {
}
export { $h_Ljava_nio_charset_UTF\uff3f16$ as $h_Ljava_nio_charset_UTF\uff3f16$ };
$h_Ljava_nio_charset_UTF\uff3f16$.prototype = $c_Ljava_nio_charset_UTF\uff3f16$.prototype;
var $d_Ljava_nio_charset_UTF\uff3f16$ = new $TypeData().initClass($c_Ljava_nio_charset_UTF\uff3f16$, "java.nio.charset.UTF_16$", ({
  Ljava_nio_charset_UTF\uff3f16$: 1,
  Ljava_nio_charset_UTF\uff3f16\uff3fCommon: 1,
  Ljava_nio_charset_Charset: 1,
  jl_Comparable: 1
}));
export { $d_Ljava_nio_charset_UTF\uff3f16$ as $d_Ljava_nio_charset_UTF\uff3f16$ };
var $n_Ljava_nio_charset_UTF\uff3f16$;
function $m_Ljava_nio_charset_UTF\uff3f16$() {
  if ((!$n_Ljava_nio_charset_UTF\uff3f16$)) {
    $n_Ljava_nio_charset_UTF\uff3f16$ = new $c_Ljava_nio_charset_UTF\uff3f16$();
  }
  return $n_Ljava_nio_charset_UTF\uff3f16$;
}
export { $m_Ljava_nio_charset_UTF\uff3f16$ as $m_Ljava_nio_charset_UTF\uff3f16$ };
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f16BE$() {
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_cachedEncoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness = 0;
  $ct_Ljava_nio_charset_UTF\uff3f16\uff3fCommon__T__AT__I__(this, "UTF-16BE", new ($d_T.getArrayOf().constr)(["X-UTF-16BE", "UTF_16BE", "ISO-10646-UCS-2", "UnicodeBigUnmarked"]), 1);
}
export { $c_Ljava_nio_charset_UTF\uff3f16BE$ as $c_Ljava_nio_charset_UTF\uff3f16BE$ };
$c_Ljava_nio_charset_UTF\uff3f16BE$.prototype = new $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon();
$c_Ljava_nio_charset_UTF\uff3f16BE$.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f16BE$;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f16BE$() {
}
export { $h_Ljava_nio_charset_UTF\uff3f16BE$ as $h_Ljava_nio_charset_UTF\uff3f16BE$ };
$h_Ljava_nio_charset_UTF\uff3f16BE$.prototype = $c_Ljava_nio_charset_UTF\uff3f16BE$.prototype;
var $d_Ljava_nio_charset_UTF\uff3f16BE$ = new $TypeData().initClass($c_Ljava_nio_charset_UTF\uff3f16BE$, "java.nio.charset.UTF_16BE$", ({
  Ljava_nio_charset_UTF\uff3f16BE$: 1,
  Ljava_nio_charset_UTF\uff3f16\uff3fCommon: 1,
  Ljava_nio_charset_Charset: 1,
  jl_Comparable: 1
}));
export { $d_Ljava_nio_charset_UTF\uff3f16BE$ as $d_Ljava_nio_charset_UTF\uff3f16BE$ };
var $n_Ljava_nio_charset_UTF\uff3f16BE$;
function $m_Ljava_nio_charset_UTF\uff3f16BE$() {
  if ((!$n_Ljava_nio_charset_UTF\uff3f16BE$)) {
    $n_Ljava_nio_charset_UTF\uff3f16BE$ = new $c_Ljava_nio_charset_UTF\uff3f16BE$();
  }
  return $n_Ljava_nio_charset_UTF\uff3f16BE$;
}
export { $m_Ljava_nio_charset_UTF\uff3f16BE$ as $m_Ljava_nio_charset_UTF\uff3f16BE$ };
/** @constructor */
function $c_Ljava_nio_charset_UTF\uff3f16LE$() {
  this.Ljava_nio_charset_Charset__f_cachedDecoder = null;
  this.Ljava_nio_charset_Charset__f_cachedEncoder = null;
  this.Ljava_nio_charset_Charset__f_canonicalName = null;
  this.Ljava_nio_charset_Charset__f_java$nio$charset$Charset$$_aliases = null;
  this.Ljava_nio_charset_Charset__f_bitmap$0 = 0;
  this.Ljava_nio_charset_UTF\uff3f16\uff3fCommon__f_java$nio$charset$UTF_16_Common$$endianness = 0;
  $ct_Ljava_nio_charset_UTF\uff3f16\uff3fCommon__T__AT__I__(this, "UTF-16LE", new ($d_T.getArrayOf().constr)(["UnicodeLittleUnmarked", "UTF_16LE", "X-UTF-16LE"]), 2);
}
export { $c_Ljava_nio_charset_UTF\uff3f16LE$ as $c_Ljava_nio_charset_UTF\uff3f16LE$ };
$c_Ljava_nio_charset_UTF\uff3f16LE$.prototype = new $h_Ljava_nio_charset_UTF\uff3f16\uff3fCommon();
$c_Ljava_nio_charset_UTF\uff3f16LE$.prototype.constructor = $c_Ljava_nio_charset_UTF\uff3f16LE$;
/** @constructor */
function $h_Ljava_nio_charset_UTF\uff3f16LE$() {
}
export { $h_Ljava_nio_charset_UTF\uff3f16LE$ as $h_Ljava_nio_charset_UTF\uff3f16LE$ };
$h_Ljava_nio_charset_UTF\uff3f16LE$.prototype = $c_Ljava_nio_charset_UTF\uff3f16LE$.prototype;
var $d_Ljava_nio_charset_UTF\uff3f16LE$ = new $TypeData().initClass($c_Ljava_nio_charset_UTF\uff3f16LE$, "java.nio.charset.UTF_16LE$", ({
  Ljava_nio_charset_UTF\uff3f16LE$: 1,
  Ljava_nio_charset_UTF\uff3f16\uff3fCommon: 1,
  Ljava_nio_charset_Charset: 1,
  jl_Comparable: 1
}));
export { $d_Ljava_nio_charset_UTF\uff3f16LE$ as $d_Ljava_nio_charset_UTF\uff3f16LE$ };
var $n_Ljava_nio_charset_UTF\uff3f16LE$;
function $m_Ljava_nio_charset_UTF\uff3f16LE$() {
  if ((!$n_Ljava_nio_charset_UTF\uff3f16LE$)) {
    $n_Ljava_nio_charset_UTF\uff3f16LE$ = new $c_Ljava_nio_charset_UTF\uff3f16LE$();
  }
  return $n_Ljava_nio_charset_UTF\uff3f16LE$;
}
export { $m_Ljava_nio_charset_UTF\uff3f16LE$ as $m_Ljava_nio_charset_UTF\uff3f16LE$ };
/** @constructor */
function $c_Ljava_time_Period(years, months, days) {
  this.Ljava_time_Period__f_years = 0;
  this.Ljava_time_Period__f_months = 0;
  this.Ljava_time_Period__f_days = 0;
  this.Ljava_time_Period__f_years = years;
  this.Ljava_time_Period__f_months = months;
  this.Ljava_time_Period__f_days = days;
}
export { $c_Ljava_time_Period as $c_Ljava_time_Period };
$c_Ljava_time_Period.prototype = new $h_O();
$c_Ljava_time_Period.prototype.constructor = $c_Ljava_time_Period;
/** @constructor */
function $h_Ljava_time_Period() {
}
export { $h_Ljava_time_Period as $h_Ljava_time_Period };
$h_Ljava_time_Period.prototype = $c_Ljava_time_Period.prototype;
$c_Ljava_time_Period.prototype.isZero__Z = (function() {
  return (this === $m_Ljava_time_Period$().ZERO__Ljava_time_Period());
});
$c_Ljava_time_Period.prototype.toTotalMonths__J = (function() {
  var value = this.Ljava_time_Period__f_years;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var value$1 = this.Ljava_time_Period__f_months;
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo & value$1) | ((lo | value$1) & (~lo$1))) >>> 31) | 0)) | 0);
  return new $c_RTLong(lo$1, hi$3);
});
$c_Ljava_time_Period.prototype.addTo__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var _temporal = temporal;
  var obj = _temporal;
  if ((obj === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "temporal");
  }
  if ((this.Ljava_time_Period__f_years !== 0)) {
    if ((this.Ljava_time_Period__f_months !== 0)) {
      _temporal = _temporal.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(this.toTotalMonths__J(), $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit());
    } else {
      var $x_1 = _temporal;
      var value = this.Ljava_time_Period__f_years;
      var hi = (value >> 31);
      _temporal = $x_1.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(value, hi), $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit());
    }
  } else if ((this.Ljava_time_Period__f_months !== 0)) {
    var $x_2 = _temporal;
    var value$1 = this.Ljava_time_Period__f_months;
    var hi$1 = (value$1 >> 31);
    _temporal = $x_2.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(value$1, hi$1), $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit());
  }
  if ((this.Ljava_time_Period__f_days !== 0)) {
    var $x_3 = _temporal;
    var value$2 = this.Ljava_time_Period__f_days;
    var hi$2 = (value$2 >> 31);
    _temporal = $x_3.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(value$2, hi$2), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit());
  }
  return _temporal;
});
$c_Ljava_time_Period.prototype.equals__O__Z = (function(obj) {
  return ((obj instanceof $c_Ljava_time_Period) && ((this === obj) || (((this.Ljava_time_Period__f_years === obj.Ljava_time_Period__f_years) && (this.Ljava_time_Period__f_months === obj.Ljava_time_Period__f_months)) && (this.Ljava_time_Period__f_days === obj.Ljava_time_Period__f_days))));
});
$c_Ljava_time_Period.prototype.hashCode__I = (function() {
  var $x_1 = this.Ljava_time_Period__f_years;
  var i = this.Ljava_time_Period__f_months;
  var i$1 = this.Ljava_time_Period__f_days;
  return (((($x_1 + ((i << 8) | ((i >>> 24) | 0))) | 0) + ((i$1 << 16) | ((i$1 >>> 16) | 0))) | 0);
});
$c_Ljava_time_Period.prototype.toString__T = (function() {
  if ((this === $m_Ljava_time_Period$().ZERO__Ljava_time_Period())) {
    return "P0D";
  } else {
    var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
    buf.append__C__scm_StringBuilder(80);
    if ((this.Ljava_time_Period__f_years !== 0)) {
      buf.append__I__scm_StringBuilder(this.Ljava_time_Period__f_years).append__C__scm_StringBuilder(89);
    }
    if ((this.Ljava_time_Period__f_months !== 0)) {
      buf.append__I__scm_StringBuilder(this.Ljava_time_Period__f_months).append__C__scm_StringBuilder(77);
    }
    if ((this.Ljava_time_Period__f_days !== 0)) {
      buf.append__I__scm_StringBuilder(this.Ljava_time_Period__f_days).append__C__scm_StringBuilder(68);
    }
    return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
});
function $isArrayOf_Ljava_time_Period(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Period)));
}
export { $isArrayOf_Ljava_time_Period as $isArrayOf_Ljava_time_Period };
var $d_Ljava_time_Period = new $TypeData().initClass($c_Ljava_time_Period, "java.time.Period", ({
  Ljava_time_Period: 1,
  Ljava_time_temporal_TemporalAmount: 1,
  Ljava_time_chrono_ChronoPeriod: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_Period as $d_Ljava_time_Period };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(valueTextMap) {
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap = null;
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_parsable = null;
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap = valueTextMap;
  var _1 = $m_sci_Nil$();
  var _2 = $m_sci_Map$EmptyMap$();
  var z = $ct_T2__O__O__(new $c_T2(), _1, _2);
  var f$2 = ((x$1, x$2) => {
    var x20 = $ct_T2__O__O__(new $c_T2(), x$1, x$2);
    var x21 = x20.T2__f__1;
    var x22 = x20.T2__f__2;
    if ((x21 !== null)) {
      var all = x21._1__O();
      var map = x21._2__O();
      if ((x22 !== null)) {
        var style = x22._1__O();
        var entries = x22._2__O();
        var this$6 = entries.toList__sci_List();
        var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => $uJ(_$1._1__O())));
        var ord = $m_s_math_Ordering$Long$();
        var $x_1 = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$6, f, ord);
        var _2$1 = $m_sci_Map$EmptyMap$();
        var reverse = $x_1.foldLeft__O__F2__O($ct_T2__O__O__(new $c_T2(), true, _2$1), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1$2, x$2$2) => {
          var x9 = $ct_T2__O__O__(new $c_T2(), x$1$2, x$2$2);
          var x16 = x9.T2__f__1;
          var x17 = x9.T2__f__2;
          if ((x16 !== null)) {
            var x18 = (!(!x16._1__O()));
            if ((x18 === false)) {
              return x16;
            }
            if ((x18 === true)) {
              var acc = x16._2__O();
              if ((x17 !== null)) {
                var t = $uJ(x17._1__O());
                var lo = t.RTLong__f_lo;
                var hi = t.RTLong__f_hi;
                var v = x17._2__O();
                var continue$1 = (!acc.contains__O__Z(v));
                var y = $ct_T2__O__O__(new $c_T2(), v, new $c_RTLong(lo, hi));
                var _2$2 = acc.$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), v, y));
                return $ct_T2__O__O__(new $c_T2(), continue$1, _2$2);
              }
            }
          }
          throw new $c_s_MatchError(x9);
        })));
        var this$16 = reverse._2__O().values__sc_Iterable().toList__sci_List();
        var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => {
          var this$15 = x._1__O();
          return ((-this$15.length) | 0);
        }));
        var ord$1 = $m_s_math_Ordering$Int$();
        var list = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(this$16, f$1, ord$1);
        var _1$1 = list.$colon$colon$colon__sci_List__sci_List(all);
        var _2$3 = map.$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), style, list));
        return $ct_T2__O__O__(new $c_T2(), _1$1, _2$3);
      }
    }
    throw new $c_s_MatchError(x20);
  });
  if ($is_sc_IndexedSeq(valueTextMap)) {
    var at = 0;
    var end = valueTextMap.length__I();
    var acc$1 = z;
    var $x_2;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc$1;
        var x1 = valueTextMap.apply__I__O(at);
        var temp$acc = f$2(x0, x1);
        at = temp$at;
        acc$1 = temp$acc;
        continue;
      }
      var $x_2 = acc$1;
      break;
    }
  } else {
    var result = z;
    var it = valueTextMap.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var x0$1 = result;
      var x1$1 = it.next__O();
      result = f$2(x0$1, x1$1);
    }
    var $x_2 = result;
  }
  var u = $x_2;
  var _1$2 = $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(u._1__O(), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$3) => {
    var this$20 = x$3._1__O();
    return ((-this$20.length) | 0);
  })), $m_s_math_Ordering$Int$());
  var _2$4 = u._2__O();
  this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_parsable = $ct_T2__O__O__(new $c_T2(), _1$2, _2$4);
}
export { $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore as $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore };
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.constructor = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore() {
}
export { $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore as $h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore };
$h_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype = $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype;
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore)) {
    var x = this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap;
    var x$2 = x$0.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.productArity__I = (function() {
  return 1;
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.productPrefix__T = (function() {
  return "LocaleStore";
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "valueTextMap";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.getText__J__Ljava_time_format_TextStyle__T = (function(value, style) {
  var this$1 = this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_valueTextMap.get__O__s_Option(style);
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var $x_1 = x0.get__O__s_Option(value);
  }
  var this$3 = $x_1;
  return (this$3.isEmpty__Z() ? null : this$3.get__O());
});
$c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore.prototype.getTextIterator__Ljava_time_format_TextStyle__sc_Iterator = (function(style) {
  return this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_parsable._2__O().getOrElse__O__F0__O(style, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => this.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore__f_parsable._1__O()))).iterator__sc_Iterator();
});
function $isArrayOf_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore)));
}
export { $isArrayOf_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore as $isArrayOf_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore };
var $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore, "java.time.format.internal.TTBPSimpleDateTimeTextProvider$LocaleStore", ({
  Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore as $d_Ljava_time_format_internal_TTBPSimpleDateTimeTextProvider$LocaleStore };
function $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I($thiz) {
  var this$1 = $thiz.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
  var $x_1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = $thiz.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
  return (($x_1 - this$2.Ljava_time_ZoneOffset__f_totalSeconds) | 0);
}
export { $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I as $p_Ljava_time_zone_ZoneOffsetTransition__getDurationSeconds__I };
/** @constructor */
function $c_Ljava_time_zone_ZoneOffsetTransition(transition, offsetBefore, offsetAfter) {
  this.Ljava_time_zone_ZoneOffsetTransition__f_transition = null;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore = null;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter = null;
  this.Ljava_time_zone_ZoneOffsetTransition__f_transition = transition;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore = offsetBefore;
  this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter = offsetAfter;
}
export { $c_Ljava_time_zone_ZoneOffsetTransition as $c_Ljava_time_zone_ZoneOffsetTransition };
$c_Ljava_time_zone_ZoneOffsetTransition.prototype = new $h_O();
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.constructor = $c_Ljava_time_zone_ZoneOffsetTransition;
/** @constructor */
function $h_Ljava_time_zone_ZoneOffsetTransition() {
}
export { $h_Ljava_time_zone_ZoneOffsetTransition as $h_Ljava_time_zone_ZoneOffsetTransition };
$h_Ljava_time_zone_ZoneOffsetTransition.prototype = $c_Ljava_time_zone_ZoneOffsetTransition.prototype;
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.isGap__Z = (function() {
  var this$1 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
  var $x_1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
  return ($x_1 > this$2.Ljava_time_ZoneOffset__f_totalSeconds);
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.getValidOffsets__ju_List = (function() {
  if (this.isGap__Z()) {
    var this$1 = $m_ju_Collections$();
    return this$1.EMPTY_LIST__ju_List();
  } else {
    var a = new ($d_Ljava_time_ZoneOffset.getArrayOf().constr)([this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore, this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter]);
    return $m_ju_Arrays$().asList__AO__ju_List(a);
  }
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_zone_ZoneOffsetTransition)) {
    if ((this === other)) {
      return true;
    } else {
      var x = this.Ljava_time_zone_ZoneOffsetTransition__f_transition;
      var x$2 = other.Ljava_time_zone_ZoneOffsetTransition__f_transition;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
        var x$4 = other.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
        var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var x$5 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
        var x$6 = other.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
        return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.hashCode__I = (function() {
  var $x_2 = this.Ljava_time_zone_ZoneOffsetTransition__f_transition.hashCode__I();
  var this$1 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore;
  var $x_1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$2 = this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter;
  var i = this$2.Ljava_time_ZoneOffset__f_totalSeconds;
  return (($x_2 ^ $x_1) ^ ((i << 16) | ((i >>> 16) | 0)));
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.toString__T = (function() {
  var buf = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  buf.append__T__scm_StringBuilder("Transition[").append__T__scm_StringBuilder((this.isGap__Z() ? "Gap" : "Overlap")).append__T__scm_StringBuilder(" at ").append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransition__f_transition).append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore).append__T__scm_StringBuilder(" to ").append__O__scm_StringBuilder(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetAfter).append__C__scm_StringBuilder(93);
  return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.compare__O__I = (function(that) {
  var this$1 = this.Ljava_time_zone_ZoneOffsetTransition__f_transition.toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
  var other = that.Ljava_time_zone_ZoneOffsetTransition__f_transition.toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant(that.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
  return this$1.compare__Ljava_time_Instant__I(other);
});
$c_Ljava_time_zone_ZoneOffsetTransition.prototype.compareTo__O__I = (function(that) {
  var this$1 = this.Ljava_time_zone_ZoneOffsetTransition__f_transition.toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant(this.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
  var other = that.Ljava_time_zone_ZoneOffsetTransition__f_transition.toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant(that.Ljava_time_zone_ZoneOffsetTransition__f_offsetBefore);
  return this$1.compare__Ljava_time_Instant__I(other);
});
function $isArrayOf_Ljava_time_zone_ZoneOffsetTransition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneOffsetTransition)));
}
export { $isArrayOf_Ljava_time_zone_ZoneOffsetTransition as $isArrayOf_Ljava_time_zone_ZoneOffsetTransition };
var $d_Ljava_time_zone_ZoneOffsetTransition = new $TypeData().initClass($c_Ljava_time_zone_ZoneOffsetTransition, "java.time.zone.ZoneOffsetTransition", ({
  Ljava_time_zone_ZoneOffsetTransition: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_zone_ZoneOffsetTransition as $d_Ljava_time_zone_ZoneOffsetTransition };
function $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V($thiz) {
  if (($thiz.ju_AbstractRandomAccessListIterator__f_last === (-1))) {
    throw $ct_jl_IllegalStateException__(new $c_jl_IllegalStateException());
  }
}
export { $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V as $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V };
function $ct_ju_AbstractRandomAccessListIterator__I__I__I__($thiz, i, start, end) {
  $thiz.ju_AbstractRandomAccessListIterator__f_i = i;
  $thiz.ju_AbstractRandomAccessListIterator__f_end = end;
  $thiz.ju_AbstractRandomAccessListIterator__f_last = (-1);
  return $thiz;
}
export { $ct_ju_AbstractRandomAccessListIterator__I__I__I__ as $ct_ju_AbstractRandomAccessListIterator__I__I__I__ };
/** @constructor */
function $c_ju_AbstractRandomAccessListIterator() {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
}
export { $c_ju_AbstractRandomAccessListIterator as $c_ju_AbstractRandomAccessListIterator };
$c_ju_AbstractRandomAccessListIterator.prototype = new $h_O();
$c_ju_AbstractRandomAccessListIterator.prototype.constructor = $c_ju_AbstractRandomAccessListIterator;
/** @constructor */
function $h_ju_AbstractRandomAccessListIterator() {
}
export { $h_ju_AbstractRandomAccessListIterator as $h_ju_AbstractRandomAccessListIterator };
$h_ju_AbstractRandomAccessListIterator.prototype = $c_ju_AbstractRandomAccessListIterator.prototype;
$c_ju_AbstractRandomAccessListIterator.prototype.hasNext__Z = (function() {
  return (this.ju_AbstractRandomAccessListIterator__f_i < this.ju_AbstractRandomAccessListIterator__f_end);
});
$c_ju_AbstractRandomAccessListIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    throw $ct_ju_NoSuchElementException__(new $c_ju_NoSuchElementException());
  }
  this.ju_AbstractRandomAccessListIterator__f_last = this.ju_AbstractRandomAccessListIterator__f_i;
  this.ju_AbstractRandomAccessListIterator__f_i = ((1 + this.ju_AbstractRandomAccessListIterator__f_i) | 0);
  return this.get__I__O(this.ju_AbstractRandomAccessListIterator__f_last);
});
$c_ju_AbstractRandomAccessListIterator.prototype.remove__V = (function() {
  $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V(this);
  this.remove__I__V(this.ju_AbstractRandomAccessListIterator__f_last);
  if ((this.ju_AbstractRandomAccessListIterator__f_last < this.ju_AbstractRandomAccessListIterator__f_i)) {
    this.ju_AbstractRandomAccessListIterator__f_i = (((-1) + this.ju_AbstractRandomAccessListIterator__f_i) | 0);
  }
  this.ju_AbstractRandomAccessListIterator__f_last = (-1);
  this.ju_AbstractRandomAccessListIterator__f_end = (((-1) + this.ju_AbstractRandomAccessListIterator__f_end) | 0);
});
$c_ju_AbstractRandomAccessListIterator.prototype.set__O__V = (function(e) {
  $p_ju_AbstractRandomAccessListIterator__checkThatHasLast__V(this);
  this.set__I__O__V(this.ju_AbstractRandomAccessListIterator__f_last, e);
});
function $p_ju_Formatter__sendToDest__T__V($thiz, s) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (("" + $thiz.ju_Formatter__f_stringOutput) + s);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s]);
  }
}
export { $p_ju_Formatter__sendToDest__T__V as $p_ju_Formatter__sendToDest__T__V };
function $p_ju_Formatter__sendToDest__T__T__V($thiz, s1, s2) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = ((("" + $thiz.ju_Formatter__f_stringOutput) + s1) + s2);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2]);
  }
}
export { $p_ju_Formatter__sendToDest__T__T__V as $p_ju_Formatter__sendToDest__T__T__V };
function $p_ju_Formatter__sendToDest__T__T__T__V($thiz, s1, s2, s3) {
  if (($thiz.ju_Formatter__f_dest === null)) {
    $thiz.ju_Formatter__f_stringOutput = (($thiz.ju_Formatter__f_stringOutput + (("" + s1) + s2)) + s3);
  } else {
    $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, [s1, s2, s3]);
  }
}
export { $p_ju_Formatter__sendToDest__T__T__T__V as $p_ju_Formatter__sendToDest__T__T__T__V };
function $p_ju_Formatter__sendToDestSlowPath__O__V($thiz, ss) {
  try {
    var len = (ss.length | 0);
    var i = 0;
    while ((i !== len)) {
      var t = ss[i];
      $thiz.ju_Formatter__f_dest.append__jl_CharSequence__jl_Appendable(t);
      i = ((1 + i) | 0);
    }
  } catch (e) {
    if ((!(e instanceof $c_Ljava_io_IOException))) {
      throw e;
    }
  }
}
export { $p_ju_Formatter__sendToDestSlowPath__O__V as $p_ju_Formatter__sendToDestSlowPath__O__V };
function $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter($thiz, localeInfo, format, args) {
  if ($thiz.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException();
  }
  var lastImplicitArgIndex = 0;
  var lastArgIndex = 0;
  var fmtLength = format.length;
  var fmtIndex = 0;
  while ((fmtIndex !== fmtLength)) {
    var fromIndex = fmtIndex;
    var nextPercentIndex = (format.indexOf("%", fromIndex) | 0);
    if ((nextPercentIndex < 0)) {
      var beginIndex = fmtIndex;
      $p_ju_Formatter__sendToDest__T__V($thiz, format.substring(beginIndex));
      return $thiz;
    }
    var beginIndex$1 = fmtIndex;
    $p_ju_Formatter__sendToDest__T__V($thiz, format.substring(beginIndex$1, nextPercentIndex));
    var formatSpecifierIndex = ((1 + nextPercentIndex) | 0);
    var re = $m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$FormatSpecifier;
    re.lastIndex = formatSpecifierIndex;
    var execResult = re.exec(format);
    if (((execResult === null) || ((execResult.index | 0) !== formatSpecifierIndex))) {
      var conversion = ((formatSpecifierIndex === fmtLength) ? 37 : format.charCodeAt(formatSpecifierIndex));
      $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion);
    }
    fmtIndex = (re.lastIndex | 0);
    var index = (((-1) + fmtIndex) | 0);
    var conversion$2 = format.charCodeAt(index);
    var flags = $p_ju_Formatter__parseFlags__T__C__I($thiz, execResult[2], conversion$2);
    var width = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[3]);
    var precision = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[4]);
    if ((width === (-2))) {
      $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, (-2147483648));
    }
    if ((precision === (-2))) {
      $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, (-2147483648));
    }
    if ((conversion$2 === 110)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if ((width !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width);
      }
      if ((flags !== 0)) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags);
      }
      $p_ju_Formatter__sendToDest__T__V($thiz, "\n");
    } else if ((conversion$2 === 37)) {
      if ((precision !== (-1))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags);
      }
      if ((((1 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      if ((((-2) & flags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(37, flags, (-2));
      }
      $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, "%");
    } else {
      var conversionLower = (((256 & flags) !== 0) ? (65535 & ((32 + conversion$2) | 0)) : conversion$2);
      var illegalFlags = $m_ju_Formatter$().ju_Formatter$__f_java$util$Formatter$$ConversionsIllegalFlags.u[(((-97) + conversionLower) | 0)];
      if (((illegalFlags === (-1)) || (((256 & flags) & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion$2);
      }
      if ((((17 & flags) !== 0) && (width === (-1)))) {
        $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      if ((((17 & flags) === 17) || ((12 & flags) === 12))) {
        $thiz.java$util$Formatter$$throwIllegalFormatFlagsException__I__E(flags);
      }
      if (((precision !== (-1)) && ((512 & illegalFlags) !== 0))) {
        $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision);
      }
      if (((flags & illegalFlags) !== 0)) {
        $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, illegalFlags);
      }
      if (((128 & flags) !== 0)) {
        var argIndex = lastArgIndex;
      } else {
        var i = $p_ju_Formatter__parsePositiveInt__O__I($thiz, execResult[1]);
        if ((i === (-1))) {
          lastImplicitArgIndex = ((1 + lastImplicitArgIndex) | 0);
          var argIndex = lastImplicitArgIndex;
        } else {
          if ((i <= 0)) {
            $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, i);
          }
          var argIndex = i;
        }
      }
      if (((argIndex <= 0) || (argIndex > args.u.length))) {
        $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult));
      }
      lastArgIndex = argIndex;
      var arg = args.u[(((-1) + argIndex) | 0)];
      if ((((arg === null) && (conversionLower !== 98)) && (conversionLower !== 115))) {
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, "null");
      } else {
        $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision);
      }
    }
  }
  return $thiz;
}
export { $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter as $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter };
function $p_ju_Formatter__parseFlags__T__C__I($thiz, flags, conversion) {
  var bits = (((conversion >= 65) && (conversion <= 90)) ? 256 : 0);
  var len = flags.length;
  var i = 0;
  while ((i !== len)) {
    var index = i;
    var f = flags.charCodeAt(index);
    switch (f) {
      case 45: {
        var bit = 1;
        break;
      }
      case 35: {
        var bit = 2;
        break;
      }
      case 43: {
        var bit = 4;
        break;
      }
      case 32: {
        var bit = 8;
        break;
      }
      case 48: {
        var bit = 16;
        break;
      }
      case 44: {
        var bit = 32;
        break;
      }
      case 40: {
        var bit = 64;
        break;
      }
      case 60: {
        var bit = 128;
        break;
      }
      default: {
        var bit;
        throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), $bC(f));
      }
    }
    if (((bits & bit) !== 0)) {
      $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, f);
    }
    bits = (bits | bit);
    i = ((1 + i) | 0);
  }
  return bits;
}
export { $p_ju_Formatter__parseFlags__T__C__I as $p_ju_Formatter__parseFlags__T__C__I };
function $p_ju_Formatter__parsePositiveInt__O__I($thiz, capture) {
  if ((capture !== (void 0))) {
    var x = (+parseInt(capture, 10));
    return ((x <= 2.147483647E9) ? $doubleToInt(x) : (-2));
  } else {
    return (-1);
  }
}
export { $p_ju_Formatter__parsePositiveInt__O__I as $p_ju_Formatter__parsePositiveInt__O__I };
function $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V($thiz, localeInfo, arg, conversionLower, flags, width, precision) {
  switch (conversionLower) {
    case 98: {
      var str = (((arg === false) || (arg === null)) ? "false" : "true");
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str);
      break;
    }
    case 104: {
      var i = $dp_hashCode__I(arg);
      var str$2 = (i >>> 0.0).toString(16);
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, precision, str$2);
      break;
    }
    case 115: {
      if ($is_ju_Formattable(arg)) {
        var formattableFlags = (((((1 & flags) !== 0) ? 1 : 0) | (((2 & flags) !== 0) ? 4 : 0)) | (((256 & flags) !== 0) ? 2 : 0));
        arg.formatTo__ju_Formatter__I__I__I__V($thiz, formattableFlags, width, precision);
      } else {
        if (((2 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 2);
        }
        var str$3 = ("" + arg);
        $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str$3);
      }
      break;
    }
    case 99: {
      if ((arg instanceof $Char)) {
        var x2$2 = $uC(arg);
        var str$4 = ("" + $cToS(x2$2));
      } else {
        if ((!$isInt(arg))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
        }
        var x3 = (arg | 0);
        if ((!((x3 >= 0) && (x3 <= 1114111)))) {
          $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, x3);
        }
        var str$4 = ((x3 < 65536) ? String.fromCharCode(x3) : String.fromCharCode((55296 | (((-64) + (x3 >> 10)) | 0)), (56320 | (1023 & x3))));
      }
      $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, (-1), str$4);
      break;
    }
    case 100: {
      if ($isInt(arg)) {
        var x2$3 = (arg | 0);
        var str$5 = ("" + x2$3);
      } else if ((arg instanceof $c_RTLong)) {
        var t = $uJ(arg);
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        var this$12 = $m_RTLong$();
        var str$5 = this$12.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi);
      } else {
        if ((!(arg instanceof $c_Ljava_math_BigInteger))) {
          $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
        }
        var str$5 = $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(arg);
      }
      $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str$5, "");
      break;
    }
    case 111:
    case 120: {
      var isOctal = (conversionLower === 111);
      var prefix = (((2 & flags) === 0) ? "" : (isOctal ? "0" : (((256 & flags) !== 0) ? "0X" : "0x")));
      if ((arg instanceof $c_Ljava_math_BigInteger)) {
        var radix = (isOctal ? 8 : 16);
        $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, $m_Ljava_math_Conversion$().bigInteger2String__Ljava_math_BigInteger__I__T(arg, radix), prefix);
      } else {
        if ($isInt(arg)) {
          var x2$5 = (arg | 0);
          var str$6 = (isOctal ? (x2$5 >>> 0.0).toString(8) : (x2$5 >>> 0.0).toString(16));
        } else {
          if ((!(arg instanceof $c_RTLong))) {
            $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
          }
          var t$1 = $uJ(arg);
          var lo$1 = t$1.RTLong__f_lo;
          var hi$1 = t$1.RTLong__f_hi;
          if (isOctal) {
            var this$21 = $m_jl_Long$();
            var str$6 = this$21.java$lang$Long$$toOctalString__I__I__T(lo$1, hi$1);
          } else {
            var this$25 = $m_jl_Long$();
            var str$6 = this$25.java$lang$Long$$toHexString__I__I__T(lo$1, hi$1);
          }
        }
        if (((76 & flags) !== 0)) {
          $thiz.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E(conversionLower, flags, 76);
        }
        $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str$6));
      }
      break;
    }
    case 101:
    case 102:
    case 103: {
      if (((typeof arg) === "number")) {
        var x2$6 = (+arg);
        if (((x2$6 !== x2$6) || ((x2$6 === Infinity) || (x2$6 === (-Infinity))))) {
          $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x2$6);
        } else {
          $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$numberToDecimal__D__ju_Formatter$Decimal(x2$6), flags, precision, conversionLower, localeInfo, width);
        }
      } else if ((arg instanceof $c_Ljava_math_BigDecimal)) {
        $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, $m_ju_Formatter$().java$util$Formatter$$bigDecimalToDecimal__Ljava_math_BigDecimal__ju_Formatter$Decimal(arg), flags, precision, conversionLower, localeInfo, width);
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
      }
      break;
    }
    case 97: {
      if (((typeof arg) === "number")) {
        var x2$7 = (+arg);
        $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, x2$7);
      } else {
        $thiz.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E(conversionLower, arg);
      }
      break;
    }
    default: {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), (("Unknown conversion '" + $cToS(conversionLower)) + "' was not rejected earlier"));
    }
  }
}
export { $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V as $p_ju_Formatter__formatArg__ju_Formatter$LocaleInfo__O__C__I__I__I__V };
function $p_ju_Formatter__flagsToString__I__T($thiz, flags) {
  return ((((((((((1 & flags) !== 0) ? "-" : "") + (((2 & flags) !== 0) ? "#" : "")) + (((4 & flags) !== 0) ? "+" : "")) + (((8 & flags) !== 0) ? " " : "")) + (((16 & flags) !== 0) ? "0" : "")) + (((32 & flags) !== 0) ? "," : "")) + (((64 & flags) !== 0) ? "(" : "")) + (((128 & flags) !== 0) ? "<" : ""));
}
export { $p_ju_Formatter__flagsToString__I__T as $p_ju_Formatter__flagsToString__I__T };
function $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, digitsAfterDot, forceDecimalSep) {
  var rounded = x.round__I__ju_Formatter$Decimal(((1 + digitsAfterDot) | 0));
  var signStr = (rounded.ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = rounded.ju_Formatter$Decimal__f_unscaledValue;
  var fractionalDigitCount = (((-1) + intStr.length) | 0);
  var missingZeros = ((digitsAfterDot - fractionalDigitCount) | 0);
  var integerPart = intStr.substring(0, 1);
  var fractionalPart = (("" + intStr.substring(1)) + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(missingZeros));
  var significandStr = (((fractionalPart === "") && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + fractionalPart));
  var exponent = ((fractionalDigitCount - rounded.ju_Formatter$Decimal__f_scale) | 0);
  var exponentSign = ((exponent < 0) ? "-" : "+");
  var sign = (exponent >> 31);
  var this$2 = (((exponent ^ sign) - sign) | 0);
  var exponentAbsStr0 = ("" + this$2);
  var exponentAbsStr = ((exponentAbsStr0.length === 1) ? ("0" + exponentAbsStr0) : exponentAbsStr0);
  return ((((signStr + significandStr) + "e") + exponentSign) + exponentAbsStr);
}
export { $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T as $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T };
function $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, scale, forceDecimalSep) {
  var rounded = x.setScale__I__ju_Formatter$Decimal(scale);
  var signStr = (rounded.ju_Formatter$Decimal__f_negative ? "-" : "");
  var intStr = rounded.ju_Formatter$Decimal__f_unscaledValue;
  var intStrLen = intStr.length;
  var minDigits = ((1 + scale) | 0);
  var expandedIntStr = ((intStrLen >= minDigits) ? intStr : (("" + $m_ju_Formatter$().java$util$Formatter$$strOfZeros__I__T(((minDigits - intStrLen) | 0))) + intStr));
  var dotPos = ((expandedIntStr.length - scale) | 0);
  var integerPart = (signStr + expandedIntStr.substring(0, dotPos));
  return (((scale === 0) && (!forceDecimalSep)) ? integerPart : ((integerPart + ".") + expandedIntStr.substring(dotPos)));
}
export { $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T as $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T };
function $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, precision, forceDecimalSep) {
  var p = ((precision === 0) ? 1 : precision);
  var rounded = x.round__I__ju_Formatter$Decimal(p);
  var this$1 = rounded.ju_Formatter$Decimal__f_unscaledValue;
  var orderOfMagnitude = (((((-1) + this$1.length) | 0) - rounded.ju_Formatter$Decimal__f_scale) | 0);
  if (((orderOfMagnitude >= (-4)) && (orderOfMagnitude < p))) {
    var b = (((-1) + ((p - orderOfMagnitude) | 0)) | 0);
    return $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, ((b < 0) ? 0 : b), forceDecimalSep);
  } else {
    return $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, rounded, (((-1) + p) | 0), forceDecimalSep);
  }
}
export { $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T as $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T };
function $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V($thiz, flags, width, precision, arg) {
  if (((arg !== arg) || ((arg === Infinity) || (arg === (-Infinity))))) {
    $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, arg);
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, arg, true);
    var lo = (fpBitsDataView.getInt32(0, true) | 0);
    var hi = (fpBitsDataView.getInt32(4, true) | 0);
    var negative = (hi < 0);
    var hi$1 = (1048575 & hi);
    var lo$1 = ((hi >>> 20) | 0);
    var biasedExponent = (2047 & lo$1);
    var actualPrecision = ((precision === 0) ? 1 : ((precision > 12) ? (-1) : precision));
    var signStr = (negative ? "-" : (((4 & flags) !== 0) ? "+" : (((8 & flags) !== 0) ? " " : "")));
    if ((biasedExponent === 0)) {
      if (((lo === 0) && (hi$1 === 0))) {
        var x1___1 = "0";
        var x1___2 = $L0;
        var x1___3 = 0;
      } else if ((actualPrecision === (-1))) {
        var x1___1 = "0";
        var x1___2 = new $c_RTLong(lo, hi$1);
        var x1___3 = (-1022);
      } else {
        var leadingZeros = ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo)) | 0));
        var shift = (((-11) + leadingZeros) | 0);
        var lo$2 = (((32 & shift) === 0) ? (lo << shift) : 0);
        var hi$2 = (((32 & shift) === 0) ? (((((lo >>> 1) | 0) >>> ((31 - shift) | 0)) | 0) | (hi$1 << shift)) : (lo << shift));
        var hi$3 = (1048575 & hi$2);
        var normalizedExponent = (((-1022) - shift) | 0);
        var x1___1 = "1";
        var x1___2 = new $c_RTLong(lo$2, hi$3);
        var x1___3 = normalizedExponent;
      }
    } else {
      var _3 = (((-1023) + biasedExponent) | 0);
      var x1___1 = "1";
      var x1___2 = new $c_RTLong(lo, hi$1);
      var x1___3 = _3;
    }
    var implicitBitStr = x1___1;
    var t = $uJ(x1___2);
    var lo$3 = t.RTLong__f_lo;
    var hi$4 = t.RTLong__f_hi;
    var exponent = (x1___3 | 0);
    if ((actualPrecision === (-1))) {
      var roundedMantissa__lo = lo$3;
      var roundedMantissa__hi = hi$4;
    } else {
      var n = ((52 - (actualPrecision << 2)) | 0);
      var lo$4 = (((32 & n) === 0) ? (1 << n) : 0);
      var hi$5 = (((32 & n) === 0) ? 0 : (1 << n));
      var lo$5 = (((-1) + lo$4) | 0);
      var hi$6 = (((((-1) + hi$5) | 0) + (((lo$4 | (~lo$5)) >>> 31) | 0)) | 0);
      var lo$6 = (((lo$4 >>> 1) | 0) | (hi$5 << 31));
      var hi$7 = (hi$5 >> 1);
      var lo$7 = (~lo$5);
      var hi$8 = (~hi$6);
      var lo$8 = (lo$3 & lo$7);
      var hi$9 = (hi$4 & hi$8);
      var lo$9 = (lo$3 & lo$5);
      var hi$10 = (hi$4 & hi$6);
      if (((hi$10 === hi$7) ? ((lo$9 >>> 0) < (lo$6 >>> 0)) : (hi$10 < hi$7))) {
        var roundedMantissa__lo = lo$8;
        var roundedMantissa__hi = hi$9;
      } else if (((hi$10 === hi$7) ? ((lo$9 >>> 0) > (lo$6 >>> 0)) : (hi$10 > hi$7))) {
        var lo$10 = ((lo$8 + lo$4) | 0);
        var hi$11 = ((((hi$9 + hi$5) | 0) + ((((lo$8 & lo$4) | ((lo$8 | lo$4) & (~lo$10))) >>> 31) | 0)) | 0);
        var roundedMantissa__lo = lo$10;
        var roundedMantissa__hi = hi$11;
      } else {
        var lo$11 = (lo$8 & lo$4);
        var hi$12 = (hi$9 & hi$5);
        if (((lo$11 === 0) && (hi$12 === 0))) {
          var roundedMantissa__lo = lo$8;
          var roundedMantissa__hi = hi$9;
        } else {
          var lo$12 = ((lo$8 + lo$4) | 0);
          var hi$13 = ((((hi$9 + hi$5) | 0) + ((((lo$8 & lo$4) | ((lo$8 | lo$4) & (~lo$12))) >>> 31) | 0)) | 0);
          var roundedMantissa__lo = lo$12;
          var roundedMantissa__hi = hi$13;
        }
      }
    }
    var this$30 = $m_jl_Long$();
    var hi$14 = roundedMantissa__hi;
    var baseStr = this$30.java$lang$Long$$toHexString__I__I__T(roundedMantissa__lo, hi$14);
    var beginIndex = baseStr.length;
    var padded = (("" + "0000000000000".substring(beginIndex)) + baseStr);
    $m_ju_Formatter$();
    var condition = (padded.length === 13);
    if ((!condition)) {
      throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "padded mantissa does not have the right number of bits");
    }
    var minLength = ((actualPrecision < 1) ? 1 : actualPrecision);
    var len = padded.length;
    while (true) {
      if ((len > minLength)) {
        var index = (((-1) + len) | 0);
        var $x_1 = (padded.charCodeAt(index) === 48);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        len = (((-1) + len) | 0);
      } else {
        break;
      }
    }
    var endIndex = len;
    var mantissaStr = padded.substring(0, endIndex);
    var exponentStr = ("" + exponent);
    var prefix = (signStr + (((256 & flags) !== 0) ? "0X" : "0x"));
    var rest = ((((implicitBitStr + ".") + mantissaStr) + "p") + exponentStr);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, $m_ju_Formatter$RootLocaleInfo$(), flags, width, prefix, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest));
  }
}
export { $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V as $p_ju_Formatter__formatHexFloatingPoint__I__I__I__D__V };
function $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V($thiz, localeInfo, flags, width, precision, str) {
  var truncatedStr = (((precision < 0) || (precision >= str.length)) ? str : str.substring(0, precision));
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, truncatedStr));
}
export { $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V as $p_ju_Formatter__formatNonNumericString__ju_Formatter$LocaleInfo__I__I__I__T__V };
function $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V($thiz, flags, width, x) {
  var str = ((x !== x) ? "NaN" : ((x > 0.0) ? (((4 & flags) !== 0) ? "+Infinity" : (((8 & flags) !== 0) ? " Infinity" : "Infinity")) : (((64 & flags) !== 0) ? "(Infinity)" : "-Infinity")));
  $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str));
}
export { $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V as $p_ju_Formatter__formatNaNOrInfinite__I__I__D__V };
function $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, str, basePrefix) {
  if (((str.length >= width) && ((110 & flags) === 0))) {
    var str$1 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str);
    $p_ju_Formatter__sendToDest__T__V($thiz, str$1);
  } else if (((126 & flags) === 0)) {
    $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str));
  } else {
    if ((str.charCodeAt(0) !== 45)) {
      if (((4 & flags) !== 0)) {
        var x1___1 = "+";
        var x1___2 = str;
      } else if (((8 & flags) !== 0)) {
        var x1___1 = " ";
        var x1___2 = str;
      } else {
        var x1___1 = "";
        var x1___2 = str;
      }
    } else if (((64 & flags) !== 0)) {
      var _2 = (str.substring(1) + ")");
      var x1___1 = "(";
      var x1___2 = _2;
    } else {
      var _2$1 = str.substring(1);
      var x1___1 = "-";
      var x1___2 = _2$1;
    }
    var numberPrefix = x1___1;
    var rest0 = x1___2;
    var prefix = (("" + numberPrefix) + basePrefix);
    var rest = (((32 & flags) !== 0) ? $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, rest0) : rest0);
    var str$2 = $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, rest);
    $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str$2);
  }
}
export { $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V as $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V };
function $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T($thiz, localeInfo, s) {
  var len = s.length;
  var index = 0;
  while (true) {
    if ((index !== len)) {
      var index$1 = index;
      var c = s.charCodeAt(index$1);
      var $x_1 = ((c >= 48) && (c <= 57));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      index = ((1 + index) | 0);
    } else {
      break;
    }
  }
  index = (((-3) + index) | 0);
  if ((index <= 0)) {
    return s;
  } else {
    var beginIndex = index;
    var result = s.substring(beginIndex);
    while ((index > 3)) {
      var next = (((-3) + index) | 0);
      var endIndex = index;
      result = ((s.substring(next, endIndex) + ",") + result);
      index = next;
    }
    var endIndex$1 = index;
    return ((s.substring(0, endIndex$1) + ",") + result);
  }
}
export { $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T as $p_ju_Formatter__insertGroupingCommas__ju_Formatter$LocaleInfo__T__T };
function $p_ju_Formatter__applyNumberUpperCase__I__T__T($thiz, flags, str) {
  return (((256 & flags) !== 0) ? str.toUpperCase() : str);
}
export { $p_ju_Formatter__applyNumberUpperCase__I__T__T as $p_ju_Formatter__applyNumberUpperCase__I__T__T };
function $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T($thiz, localeInfo, flags, str) {
  return (((256 & flags) !== 0) ? str.toUpperCase() : str);
}
export { $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T as $p_ju_Formatter__applyUpperCase__ju_Formatter$LocaleInfo__I__T__T };
function $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V($thiz, flags, width, str) {
  var len = str.length;
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__V($thiz, str);
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)));
  } else {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), str);
  }
}
export { $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V as $p_ju_Formatter__padAndSendToDestNoZeroPad__I__I__T__V };
function $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo, flags, width, prefix, str) {
  var len = ((prefix.length + str.length) | 0);
  if ((len >= width)) {
    $p_ju_Formatter__sendToDest__T__T__V($thiz, prefix, str);
  } else if (((16 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, $p_ju_Formatter__strRepeat__T__I__T($thiz, "0", ((width - len) | 0)), str);
  } else if (((1 & flags) !== 0)) {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, prefix, str, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)));
  } else {
    $p_ju_Formatter__sendToDest__T__T__T__V($thiz, $p_ju_Formatter__strRepeat__T__I__T($thiz, " ", ((width - len) | 0)), prefix, str);
  }
}
export { $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V as $p_ju_Formatter__padAndSendToDest__ju_Formatter$LocaleInfo__I__I__T__T__V };
function $p_ju_Formatter__strRepeat__T__I__T($thiz, s, times) {
  var result = "";
  var i = 0;
  while ((i !== times)) {
    result = (("" + result) + s);
    i = ((1 + i) | 0);
  }
  return result;
}
export { $p_ju_Formatter__strRepeat__T__I__T as $p_ju_Formatter__strRepeat__T__I__T };
function $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E($thiz, flag) {
  throw new $c_ju_DuplicateFormatFlagsException(("" + $cToS(flag)));
}
export { $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E as $p_ju_Formatter__throwDuplicateFormatFlagsException__C__E };
function $p_ju_Formatter__throwUnknownFormatConversionException__C__E($thiz, conversion) {
  throw new $c_ju_UnknownFormatConversionException(("" + $cToS(conversion)));
}
export { $p_ju_Formatter__throwUnknownFormatConversionException__C__E as $p_ju_Formatter__throwUnknownFormatConversionException__C__E };
function $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E($thiz, precision) {
  throw new $c_ju_IllegalFormatPrecisionException(precision);
}
export { $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E as $p_ju_Formatter__throwIllegalFormatPrecisionException__I__E };
function $p_ju_Formatter__throwIllegalFormatWidthException__I__E($thiz, width) {
  throw new $c_ju_IllegalFormatWidthException(width);
}
export { $p_ju_Formatter__throwIllegalFormatWidthException__I__E as $p_ju_Formatter__throwIllegalFormatWidthException__I__E };
function $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E($thiz, index) {
  var msg = ((index === 0) ? "Illegal format argument index = 0" : "Format argument index: (not representable as int)");
  throw new $c_ju_IllegalFormatArgumentIndexException(msg);
}
export { $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E as $p_ju_Formatter__throwIllegalFormatArgumentIndexException__I__E };
function $p_ju_Formatter__throwMissingFormatWidthException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatWidthException(fullFormatSpecifier);
}
export { $p_ju_Formatter__throwMissingFormatWidthException__T__E as $p_ju_Formatter__throwMissingFormatWidthException__T__E };
function $p_ju_Formatter__throwMissingFormatArgumentException__T__E($thiz, fullFormatSpecifier) {
  throw new $c_ju_MissingFormatArgumentException(fullFormatSpecifier);
}
export { $p_ju_Formatter__throwMissingFormatArgumentException__T__E as $p_ju_Formatter__throwMissingFormatArgumentException__T__E };
function $p_ju_Formatter__throwIllegalFormatCodePointException__I__E($thiz, arg) {
  throw new $c_ju_IllegalFormatCodePointException(arg);
}
export { $p_ju_Formatter__throwIllegalFormatCodePointException__I__E as $p_ju_Formatter__throwIllegalFormatCodePointException__I__E };
function $ps_ju_Formatter__fullFormatSpecifier$1__O__T(execResult$1) {
  return ("%" + execResult$1[0]);
}
export { $ps_ju_Formatter__fullFormatSpecifier$1__O__T as $ps_ju_Formatter__fullFormatSpecifier$1__O__T };
function $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V($thiz, x, flags$1, precision$1, conversionLower$1, localeInfo$1, width$1) {
  var forceDecimalSep = ((2 & flags$1) !== 0);
  var actualPrecision = ((precision$1 >= 0) ? precision$1 : 6);
  switch (conversionLower$1) {
    case 101: {
      var notation = $p_ju_Formatter__computerizedScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break;
    }
    case 102: {
      var notation = $p_ju_Formatter__decimalNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
      break;
    }
    default: {
      var notation = $p_ju_Formatter__generalScientificNotation__ju_Formatter$Decimal__I__Z__T($thiz, x, actualPrecision, forceDecimalSep);
    }
  }
  $p_ju_Formatter__formatNumericString__ju_Formatter$LocaleInfo__I__I__T__T__V($thiz, localeInfo$1, flags$1, width$1, notation, "");
}
export { $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V as $p_ju_Formatter__formatDecimal$1__ju_Formatter$Decimal__I__I__C__ju_Formatter$LocaleInfo__I__V };
function $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, dest, formatterLocaleInfo) {
  $thiz.ju_Formatter__f_dest = dest;
  $thiz.ju_Formatter__f_formatterLocaleInfo = formatterLocaleInfo;
  $thiz.ju_Formatter__f_stringOutput = "";
  $thiz.ju_Formatter__f_java$util$Formatter$$closed = false;
  return $thiz;
}
export { $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__ as $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__ };
function $ct_ju_Formatter__($thiz) {
  $ct_ju_Formatter__jl_Appendable__ju_Formatter$LocaleInfo__($thiz, null, $m_ju_Formatter$RootLocaleInfo$());
  return $thiz;
}
export { $ct_ju_Formatter__ as $ct_ju_Formatter__ };
/** @constructor */
function $c_ju_Formatter() {
  this.ju_Formatter__f_dest = null;
  this.ju_Formatter__f_formatterLocaleInfo = null;
  this.ju_Formatter__f_stringOutput = null;
  this.ju_Formatter__f_java$util$Formatter$$closed = false;
}
export { $c_ju_Formatter as $c_ju_Formatter };
$c_ju_Formatter.prototype = new $h_O();
$c_ju_Formatter.prototype.constructor = $c_ju_Formatter;
/** @constructor */
function $h_ju_Formatter() {
}
export { $h_ju_Formatter as $h_ju_Formatter };
$h_ju_Formatter.prototype = $c_ju_Formatter.prototype;
$c_ju_Formatter.prototype.format__T__AO__ju_Formatter = (function(format, args) {
  return $p_ju_Formatter__format__ju_Formatter$LocaleInfo__T__AO__ju_Formatter(this, this.ju_Formatter__f_formatterLocaleInfo, format, args);
});
$c_ju_Formatter.prototype.toString__T = (function() {
  if (this.ju_Formatter__f_java$util$Formatter$$closed) {
    throw new $c_ju_FormatterClosedException();
  }
  return ((this.ju_Formatter__f_dest === null) ? this.ju_Formatter__f_stringOutput : this.ju_Formatter__f_dest.toString__T());
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatFlagsException__I__E = (function(flags) {
  throw new $c_ju_IllegalFormatFlagsException($p_ju_Formatter__flagsToString__I__T(this, flags));
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwFormatFlagsConversionMismatchException__C__I__I__E = (function(conversionLower, flags, illegalFlags) {
  throw new $c_ju_FormatFlagsConversionMismatchException($p_ju_Formatter__flagsToString__I__T(this, (flags & illegalFlags)), conversionLower);
});
$c_ju_Formatter.prototype.java$util$Formatter$$throwIllegalFormatConversionException__C__O__E = (function(conversionLower, arg) {
  throw new $c_ju_IllegalFormatConversionException(conversionLower, $objectGetClass(arg));
});
var $d_ju_Formatter = new $TypeData().initClass($c_ju_Formatter, "java.util.Formatter", ({
  ju_Formatter: 1,
  Ljava_io_Closeable: 1,
  jl_AutoCloseable: 1,
  Ljava_io_Flushable: 1
}));
export { $d_ju_Formatter as $d_ju_Formatter };
function $f_ju_List__sort__ju_Comparator__V($thiz, c) {
  var arrayBuf = $thiz.toArray__AO();
  $m_ju_Arrays$().sort__AO__ju_Comparator__V(arrayBuf, c);
  var len = arrayBuf.u.length;
  if ($is_ju_RandomAccess($thiz)) {
    var i = 0;
    while ((i !== len)) {
      $thiz.set__I__O__O(i, arrayBuf.u[i]);
      i = ((1 + i) | 0);
    }
  } else {
    var i$2 = 0;
    var iter = $thiz.listIterator__ju_ListIterator();
    while ((i$2 !== len)) {
      iter.next__O();
      iter.set__O__V(arrayBuf.u[i$2]);
      i$2 = ((1 + i$2) | 0);
    }
  }
}
export { $f_ju_List__sort__ju_Comparator__V as $f_ju_List__sort__ju_Comparator__V };
function $is_ju_List(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.ju_List)));
}
export { $is_ju_List as $is_ju_List };
function $isArrayOf_ju_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_List)));
}
export { $isArrayOf_ju_List as $isArrayOf_ju_List };
/** @constructor */
function $c_ju_Locale$LocaleBuilder(strict, language, region, variant, script, extensions, unicodeExtensions, unicodeAttributes) {
  this.ju_Locale$LocaleBuilder__f_strict = false;
  this.ju_Locale$LocaleBuilder__f_language = null;
  this.ju_Locale$LocaleBuilder__f_region = null;
  this.ju_Locale$LocaleBuilder__f_variant = null;
  this.ju_Locale$LocaleBuilder__f_script = null;
  this.ju_Locale$LocaleBuilder__f_extensions = null;
  this.ju_Locale$LocaleBuilder__f_unicodeExtensions = null;
  this.ju_Locale$LocaleBuilder__f_unicodeAttributes = null;
  this.ju_Locale$LocaleBuilder__f_strict = strict;
  this.ju_Locale$LocaleBuilder__f_language = language;
  this.ju_Locale$LocaleBuilder__f_region = region;
  this.ju_Locale$LocaleBuilder__f_variant = variant;
  this.ju_Locale$LocaleBuilder__f_script = script;
  this.ju_Locale$LocaleBuilder__f_extensions = extensions;
  this.ju_Locale$LocaleBuilder__f_unicodeExtensions = unicodeExtensions;
  this.ju_Locale$LocaleBuilder__f_unicodeAttributes = unicodeAttributes;
}
export { $c_ju_Locale$LocaleBuilder as $c_ju_Locale$LocaleBuilder };
$c_ju_Locale$LocaleBuilder.prototype = new $h_O();
$c_ju_Locale$LocaleBuilder.prototype.constructor = $c_ju_Locale$LocaleBuilder;
/** @constructor */
function $h_ju_Locale$LocaleBuilder() {
}
export { $h_ju_Locale$LocaleBuilder as $h_ju_Locale$LocaleBuilder };
$h_ju_Locale$LocaleBuilder.prototype = $c_ju_Locale$LocaleBuilder.prototype;
$c_ju_Locale$LocaleBuilder.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_ju_Locale$LocaleBuilder.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("LocaleBuilder");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.ju_Locale$LocaleBuilder__f_strict ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.ju_Locale$LocaleBuilder__f_language;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.ju_Locale$LocaleBuilder__f_region;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  var x$2 = this.ju_Locale$LocaleBuilder__f_variant;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$4);
  var hash$5 = acc;
  var x$3 = this.ju_Locale$LocaleBuilder__f_script;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$5);
  var hash$6 = acc;
  var x$4 = this.ju_Locale$LocaleBuilder__f_extensions;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$6);
  var hash$7 = acc;
  var x$5 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
  var data$7 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$7);
  var hash$8 = acc;
  var x$6 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
  var data$8 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$8);
  var hash$9 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$9, 8);
});
$c_ju_Locale$LocaleBuilder.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_ju_Locale$LocaleBuilder)) {
    if ((this.ju_Locale$LocaleBuilder__f_strict === x$0.ju_Locale$LocaleBuilder__f_strict)) {
      var x = this.ju_Locale$LocaleBuilder__f_language;
      var x$2 = x$0.ju_Locale$LocaleBuilder__f_language;
      var $x_6 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3 = this.ju_Locale$LocaleBuilder__f_region;
      var x$4 = x$0.ju_Locale$LocaleBuilder__f_region;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$5 = this.ju_Locale$LocaleBuilder__f_variant;
      var x$6 = x$0.ju_Locale$LocaleBuilder__f_variant;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.ju_Locale$LocaleBuilder__f_script;
      var x$8 = x$0.ju_Locale$LocaleBuilder__f_script;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.ju_Locale$LocaleBuilder__f_extensions;
      var x$10 = x$0.ju_Locale$LocaleBuilder__f_extensions;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
      var x$12 = x$0.ju_Locale$LocaleBuilder__f_unicodeExtensions;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
      var x$14 = x$0.ju_Locale$LocaleBuilder__f_unicodeAttributes;
      return ((x$13 === null) ? (x$14 === null) : x$13.equals__O__Z(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_Locale$LocaleBuilder.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_ju_Locale$LocaleBuilder.prototype.productArity__I = (function() {
  return 8;
});
$c_ju_Locale$LocaleBuilder.prototype.productPrefix__T = (function() {
  return "LocaleBuilder";
});
$c_ju_Locale$LocaleBuilder.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.ju_Locale$LocaleBuilder__f_strict;
      break;
    }
    case 1: {
      return this.ju_Locale$LocaleBuilder__f_language;
      break;
    }
    case 2: {
      return this.ju_Locale$LocaleBuilder__f_region;
      break;
    }
    case 3: {
      return this.ju_Locale$LocaleBuilder__f_variant;
      break;
    }
    case 4: {
      return this.ju_Locale$LocaleBuilder__f_script;
      break;
    }
    case 5: {
      return this.ju_Locale$LocaleBuilder__f_extensions;
      break;
    }
    case 6: {
      return this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
      break;
    }
    case 7: {
      return this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_ju_Locale$LocaleBuilder.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "strict";
      break;
    }
    case 1: {
      return "language";
      break;
    }
    case 2: {
      return "region";
      break;
    }
    case 3: {
      return "variant";
      break;
    }
    case 4: {
      return "script";
      break;
    }
    case 5: {
      return "extensions";
      break;
    }
    case 6: {
      return "unicodeExtensions";
      break;
    }
    case 7: {
      return "unicodeAttributes";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_ju_Locale$LocaleBuilder.prototype.language__T__s_Option = (function(language) {
  if (((language === null) || (language === ""))) {
    var language$3 = $m_s_None$();
    var strict$1 = this.ju_Locale$LocaleBuilder__f_strict;
    var region$1 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$3 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$3 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$1 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$1 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$1 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$1, language$3, region$1, variant$3, script$3, extensions$1, unicodeExtensions$1, unicodeAttributes$1);
    return new $c_s_Some(value);
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkLanguage__T__Z(language))) {
    var value$1 = language.toLowerCase();
    var language$4 = new $c_s_Some(value$1);
    var strict$2 = this.ju_Locale$LocaleBuilder__f_strict;
    var region$2 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$4 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$4 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$2 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$2 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$2 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$2, language$4, region$2, variant$4, script$4, extensions$2, unicodeExtensions$2, unicodeAttributes$2);
    return new $c_s_Some(value$2);
  } else {
    return $m_s_None$();
  }
});
$c_ju_Locale$LocaleBuilder.prototype.script__T__s_Option = (function(script) {
  if (((script === null) || (script === ""))) {
    var script$5 = $m_s_None$();
    var strict$3 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$5 = this.ju_Locale$LocaleBuilder__f_language;
    var region$3 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$5 = this.ju_Locale$LocaleBuilder__f_variant;
    var extensions$3 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$3 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$3 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$3, language$5, region$3, variant$5, script$5, extensions$3, unicodeExtensions$3, unicodeAttributes$3);
    return new $c_s_Some(value);
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkScript__T__Z(script))) {
    var c = script.charCodeAt(0);
    var value$1 = ($cToS($m_jl_Character$().toUpperCase__C__C(c)) + script.substring(1));
    var script$6 = new $c_s_Some(value$1);
    var strict$4 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$6 = this.ju_Locale$LocaleBuilder__f_language;
    var region$4 = this.ju_Locale$LocaleBuilder__f_region;
    var variant$6 = this.ju_Locale$LocaleBuilder__f_variant;
    var extensions$4 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$4 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$4 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$4, language$6, region$4, variant$6, script$6, extensions$4, unicodeExtensions$4, unicodeAttributes$4);
    return new $c_s_Some(value$2);
  } else {
    return $m_s_None$();
  }
});
$c_ju_Locale$LocaleBuilder.prototype.region__T__s_Option = (function(region) {
  if (((region === null) || (region === ""))) {
    var region$5 = $m_s_None$();
    var strict$5 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$7 = this.ju_Locale$LocaleBuilder__f_language;
    var variant$7 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$7 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$5 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$5 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$5 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$5, language$7, region$5, variant$7, script$7, extensions$5, unicodeExtensions$5, unicodeAttributes$5);
    return new $c_s_Some(value);
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkRegion__T__Z(region))) {
    var value$1 = region.toUpperCase();
    var region$6 = new $c_s_Some(value$1);
    var strict$6 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$8 = this.ju_Locale$LocaleBuilder__f_language;
    var variant$8 = this.ju_Locale$LocaleBuilder__f_variant;
    var script$8 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$6 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$6 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$6 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$6, language$8, region$6, variant$8, script$8, extensions$6, unicodeExtensions$6, unicodeAttributes$6);
    return new $c_s_Some(value$2);
  } else {
    return $m_s_None$();
  }
});
$c_ju_Locale$LocaleBuilder.prototype.variant__T__s_Option = (function(variant) {
  if (((variant === null) || (variant === ""))) {
    var variant$10 = $m_s_None$();
    var strict$8 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$10 = this.ju_Locale$LocaleBuilder__f_language;
    var region$8 = this.ju_Locale$LocaleBuilder__f_region;
    var script$10 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$8 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$8 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$8 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value = new $c_ju_Locale$LocaleBuilder(strict$8, language$10, region$8, variant$10, script$10, extensions$8, unicodeExtensions$8, unicodeAttributes$8);
    return new $c_s_Some(value);
  } else if (((!this.ju_Locale$LocaleBuilder__f_strict) || $m_ju_Locale$().checkVariant__T__Z(variant))) {
    var value$1 = variant.split("-").join("_");
    var variant$11 = new $c_s_Some(value$1);
    var strict$9 = this.ju_Locale$LocaleBuilder__f_strict;
    var language$11 = this.ju_Locale$LocaleBuilder__f_language;
    var region$9 = this.ju_Locale$LocaleBuilder__f_region;
    var script$11 = this.ju_Locale$LocaleBuilder__f_script;
    var extensions$9 = this.ju_Locale$LocaleBuilder__f_extensions;
    var unicodeExtensions$9 = this.ju_Locale$LocaleBuilder__f_unicodeExtensions;
    var unicodeAttributes$9 = this.ju_Locale$LocaleBuilder__f_unicodeAttributes;
    var value$2 = new $c_ju_Locale$LocaleBuilder(strict$9, language$11, region$9, variant$11, script$11, extensions$9, unicodeExtensions$9, unicodeAttributes$9);
    return new $c_s_Some(value$2);
  } else {
    return $m_s_None$();
  }
});
$c_ju_Locale$LocaleBuilder.prototype.build__ju_Locale = (function() {
  var this$1 = this.ju_Locale$LocaleBuilder__f_language;
  var $x_2 = (this$1.isEmpty__Z() ? "" : this$1.get__O());
  var this$2 = this.ju_Locale$LocaleBuilder__f_region;
  var $x_1 = (this$2.isEmpty__Z() ? "" : this$2.get__O());
  var this$3 = this.ju_Locale$LocaleBuilder__f_variant;
  return new $c_ju_Locale($x_2, $x_1, (this$3.isEmpty__Z() ? "" : this$3.get__O()), this.ju_Locale$LocaleBuilder__f_script, this.ju_Locale$LocaleBuilder__f_extensions, this.ju_Locale$LocaleBuilder__f_unicodeExtensions, this.ju_Locale$LocaleBuilder__f_unicodeAttributes, ($m_ju_Locale$(), true));
});
function $isArrayOf_ju_Locale$LocaleBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_Locale$LocaleBuilder)));
}
export { $isArrayOf_ju_Locale$LocaleBuilder as $isArrayOf_ju_Locale$LocaleBuilder };
var $d_ju_Locale$LocaleBuilder = new $TypeData().initClass($c_ju_Locale$LocaleBuilder, "java.util.Locale$LocaleBuilder", ({
  ju_Locale$LocaleBuilder: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_Locale$LocaleBuilder as $d_ju_Locale$LocaleBuilder };
/** @constructor */
function $c_ju_SimpleTimeZone(rawOffset, ID) {
  this.ju_SimpleTimeZone__f_ID = null;
  this.ju_SimpleTimeZone__f_ID = ID;
  $ct_ju_TimeZone__(this);
}
export { $c_ju_SimpleTimeZone as $c_ju_SimpleTimeZone };
$c_ju_SimpleTimeZone.prototype = new $h_ju_TimeZone();
$c_ju_SimpleTimeZone.prototype.constructor = $c_ju_SimpleTimeZone;
/** @constructor */
function $h_ju_SimpleTimeZone() {
}
export { $h_ju_SimpleTimeZone as $h_ju_SimpleTimeZone };
$h_ju_SimpleTimeZone.prototype = $c_ju_SimpleTimeZone.prototype;
var $d_ju_SimpleTimeZone = new $TypeData().initClass($c_ju_SimpleTimeZone, "java.util.SimpleTimeZone", ({
  ju_SimpleTimeZone: 1,
  ju_TimeZone: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
}));
export { $d_ju_SimpleTimeZone as $d_ju_SimpleTimeZone };
/** @constructor */
function $c_ju_concurrent_TimeUnit() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
}
export { $c_ju_concurrent_TimeUnit as $c_ju_concurrent_TimeUnit };
$c_ju_concurrent_TimeUnit.prototype = new $h_jl_Enum();
$c_ju_concurrent_TimeUnit.prototype.constructor = $c_ju_concurrent_TimeUnit;
/** @constructor */
function $h_ju_concurrent_TimeUnit() {
}
export { $h_ju_concurrent_TimeUnit as $h_ju_concurrent_TimeUnit };
$h_ju_concurrent_TimeUnit.prototype = $c_ju_concurrent_TimeUnit.prototype;
/** @constructor */
function $c_ju_internal_GenericArrayOps$ByteArrayOps$() {
}
export { $c_ju_internal_GenericArrayOps$ByteArrayOps$ as $c_ju_internal_GenericArrayOps$ByteArrayOps$ };
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ByteArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ByteArrayOps$() {
}
export { $h_ju_internal_GenericArrayOps$ByteArrayOps$ as $h_ju_internal_GenericArrayOps$ByteArrayOps$ };
$h_ju_internal_GenericArrayOps$ByteArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = (o1 | 0);
  var y = (o2 | 0);
  return ((x - y) | 0);
});
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var v$1 = (v | 0);
  a.u[i] = v$1;
});
$c_ju_internal_GenericArrayOps$ByteArrayOps$.prototype.get__O__I__O = (function(a, i) {
  return a.u[i];
});
var $d_ju_internal_GenericArrayOps$ByteArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$ByteArrayOps$, "java.util.internal.GenericArrayOps$ByteArrayOps$", ({
  ju_internal_GenericArrayOps$ByteArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
export { $d_ju_internal_GenericArrayOps$ByteArrayOps$ as $d_ju_internal_GenericArrayOps$ByteArrayOps$ };
var $n_ju_internal_GenericArrayOps$ByteArrayOps$;
function $m_ju_internal_GenericArrayOps$ByteArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ByteArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ByteArrayOps$ = new $c_ju_internal_GenericArrayOps$ByteArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ByteArrayOps$;
}
export { $m_ju_internal_GenericArrayOps$ByteArrayOps$ as $m_ju_internal_GenericArrayOps$ByteArrayOps$ };
/** @constructor */
function $c_ju_internal_GenericArrayOps$CharArrayOps$() {
}
export { $c_ju_internal_GenericArrayOps$CharArrayOps$ as $c_ju_internal_GenericArrayOps$CharArrayOps$ };
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$CharArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$CharArrayOps$() {
}
export { $h_ju_internal_GenericArrayOps$CharArrayOps$ as $h_ju_internal_GenericArrayOps$CharArrayOps$ };
$h_ju_internal_GenericArrayOps$CharArrayOps$.prototype = $c_ju_internal_GenericArrayOps$CharArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = $uC(o1);
  var y = $uC(o2);
  return ((x - y) | 0);
});
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var v$1 = $uC(v);
  a.u[i] = v$1;
});
$c_ju_internal_GenericArrayOps$CharArrayOps$.prototype.get__O__I__O = (function(a, i) {
  return $bC(a.u[i]);
});
var $d_ju_internal_GenericArrayOps$CharArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$CharArrayOps$, "java.util.internal.GenericArrayOps$CharArrayOps$", ({
  ju_internal_GenericArrayOps$CharArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
export { $d_ju_internal_GenericArrayOps$CharArrayOps$ as $d_ju_internal_GenericArrayOps$CharArrayOps$ };
var $n_ju_internal_GenericArrayOps$CharArrayOps$;
function $m_ju_internal_GenericArrayOps$CharArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$CharArrayOps$)) {
    $n_ju_internal_GenericArrayOps$CharArrayOps$ = new $c_ju_internal_GenericArrayOps$CharArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$CharArrayOps$;
}
export { $m_ju_internal_GenericArrayOps$CharArrayOps$ as $m_ju_internal_GenericArrayOps$CharArrayOps$ };
/** @constructor */
function $c_ju_internal_GenericArrayOps$IntArrayOps$() {
}
export { $c_ju_internal_GenericArrayOps$IntArrayOps$ as $c_ju_internal_GenericArrayOps$IntArrayOps$ };
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$IntArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$IntArrayOps$() {
}
export { $h_ju_internal_GenericArrayOps$IntArrayOps$ as $h_ju_internal_GenericArrayOps$IntArrayOps$ };
$h_ju_internal_GenericArrayOps$IntArrayOps$.prototype = $c_ju_internal_GenericArrayOps$IntArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = (o1 | 0);
  var y = (o2 | 0);
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var v$1 = (v | 0);
  a.u[i] = v$1;
});
$c_ju_internal_GenericArrayOps$IntArrayOps$.prototype.get__O__I__O = (function(a, i) {
  return a.u[i];
});
var $d_ju_internal_GenericArrayOps$IntArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$IntArrayOps$, "java.util.internal.GenericArrayOps$IntArrayOps$", ({
  ju_internal_GenericArrayOps$IntArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
export { $d_ju_internal_GenericArrayOps$IntArrayOps$ as $d_ju_internal_GenericArrayOps$IntArrayOps$ };
var $n_ju_internal_GenericArrayOps$IntArrayOps$;
function $m_ju_internal_GenericArrayOps$IntArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$IntArrayOps$)) {
    $n_ju_internal_GenericArrayOps$IntArrayOps$ = new $c_ju_internal_GenericArrayOps$IntArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$IntArrayOps$;
}
export { $m_ju_internal_GenericArrayOps$IntArrayOps$ as $m_ju_internal_GenericArrayOps$IntArrayOps$ };
/** @constructor */
function $c_ju_internal_GenericArrayOps$LongArrayOps$() {
}
export { $c_ju_internal_GenericArrayOps$LongArrayOps$ as $c_ju_internal_GenericArrayOps$LongArrayOps$ };
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$LongArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$LongArrayOps$() {
}
export { $h_ju_internal_GenericArrayOps$LongArrayOps$ as $h_ju_internal_GenericArrayOps$LongArrayOps$ };
$h_ju_internal_GenericArrayOps$LongArrayOps$.prototype = $c_ju_internal_GenericArrayOps$LongArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var t = $uJ(o1);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(o2);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
});
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var t = $uJ(v);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  a.u[i] = new $c_RTLong(lo, hi);
});
$c_ju_internal_GenericArrayOps$LongArrayOps$.prototype.get__O__I__O = (function(a, i) {
  return a.u[i];
});
var $d_ju_internal_GenericArrayOps$LongArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$LongArrayOps$, "java.util.internal.GenericArrayOps$LongArrayOps$", ({
  ju_internal_GenericArrayOps$LongArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
export { $d_ju_internal_GenericArrayOps$LongArrayOps$ as $d_ju_internal_GenericArrayOps$LongArrayOps$ };
var $n_ju_internal_GenericArrayOps$LongArrayOps$;
function $m_ju_internal_GenericArrayOps$LongArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$LongArrayOps$)) {
    $n_ju_internal_GenericArrayOps$LongArrayOps$ = new $c_ju_internal_GenericArrayOps$LongArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$LongArrayOps$;
}
export { $m_ju_internal_GenericArrayOps$LongArrayOps$ as $m_ju_internal_GenericArrayOps$LongArrayOps$ };
/** @constructor */
function $c_ju_internal_GenericArrayOps$ShortArrayOps$() {
}
export { $c_ju_internal_GenericArrayOps$ShortArrayOps$ as $c_ju_internal_GenericArrayOps$ShortArrayOps$ };
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = new $h_O();
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.constructor = $c_ju_internal_GenericArrayOps$ShortArrayOps$;
/** @constructor */
function $h_ju_internal_GenericArrayOps$ShortArrayOps$() {
}
export { $h_ju_internal_GenericArrayOps$ShortArrayOps$ as $h_ju_internal_GenericArrayOps$ShortArrayOps$ };
$h_ju_internal_GenericArrayOps$ShortArrayOps$.prototype = $c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype;
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.compare__O__O__I = (function(o1, o2) {
  var x = (o1 | 0);
  var y = (o2 | 0);
  return ((x - y) | 0);
});
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.set__O__I__O__V = (function(a, i, v) {
  var v$1 = (v | 0);
  a.u[i] = v$1;
});
$c_ju_internal_GenericArrayOps$ShortArrayOps$.prototype.get__O__I__O = (function(a, i) {
  return a.u[i];
});
var $d_ju_internal_GenericArrayOps$ShortArrayOps$ = new $TypeData().initClass($c_ju_internal_GenericArrayOps$ShortArrayOps$, "java.util.internal.GenericArrayOps$ShortArrayOps$", ({
  ju_internal_GenericArrayOps$ShortArrayOps$: 1,
  ju_internal_GenericArrayOps$ArrayOps: 1,
  ju_internal_GenericArrayOps$ArrayCreateOps: 1,
  ju_Comparator: 1
}));
export { $d_ju_internal_GenericArrayOps$ShortArrayOps$ as $d_ju_internal_GenericArrayOps$ShortArrayOps$ };
var $n_ju_internal_GenericArrayOps$ShortArrayOps$;
function $m_ju_internal_GenericArrayOps$ShortArrayOps$() {
  if ((!$n_ju_internal_GenericArrayOps$ShortArrayOps$)) {
    $n_ju_internal_GenericArrayOps$ShortArrayOps$ = new $c_ju_internal_GenericArrayOps$ShortArrayOps$();
  }
  return $n_ju_internal_GenericArrayOps$ShortArrayOps$;
}
export { $m_ju_internal_GenericArrayOps$ShortArrayOps$ as $m_ju_internal_GenericArrayOps$ShortArrayOps$ };
/** @constructor */
function $c_Llocales_cldr_CLDRMetadata(isoCountries, iso3Countries, isoLanguages, iso3Languages, scripts) {
  this.Llocales_cldr_CLDRMetadata__f_isoCountries = null;
  this.Llocales_cldr_CLDRMetadata__f_iso3Countries = null;
  this.Llocales_cldr_CLDRMetadata__f_isoLanguages = null;
  this.Llocales_cldr_CLDRMetadata__f_iso3Languages = null;
  this.Llocales_cldr_CLDRMetadata__f_scripts = null;
  this.Llocales_cldr_CLDRMetadata__f_isoCountries = isoCountries;
  this.Llocales_cldr_CLDRMetadata__f_iso3Countries = iso3Countries;
  this.Llocales_cldr_CLDRMetadata__f_isoLanguages = isoLanguages;
  this.Llocales_cldr_CLDRMetadata__f_iso3Languages = iso3Languages;
  this.Llocales_cldr_CLDRMetadata__f_scripts = scripts;
}
export { $c_Llocales_cldr_CLDRMetadata as $c_Llocales_cldr_CLDRMetadata };
$c_Llocales_cldr_CLDRMetadata.prototype = new $h_O();
$c_Llocales_cldr_CLDRMetadata.prototype.constructor = $c_Llocales_cldr_CLDRMetadata;
/** @constructor */
function $h_Llocales_cldr_CLDRMetadata() {
}
export { $h_Llocales_cldr_CLDRMetadata as $h_Llocales_cldr_CLDRMetadata };
$h_Llocales_cldr_CLDRMetadata.prototype = $c_Llocales_cldr_CLDRMetadata.prototype;
$c_Llocales_cldr_CLDRMetadata.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_CLDRMetadata.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_CLDRMetadata.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CLDRMetadata)) {
    var x = this.Llocales_cldr_CLDRMetadata__f_isoCountries;
    var x$2 = x$0.Llocales_cldr_CLDRMetadata__f_isoCountries;
    if ((x === x$2)) {
      var x$3 = this.Llocales_cldr_CLDRMetadata__f_iso3Countries;
      var x$4 = x$0.Llocales_cldr_CLDRMetadata__f_iso3Countries;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Llocales_cldr_CLDRMetadata__f_isoLanguages;
      var x$6 = x$0.Llocales_cldr_CLDRMetadata__f_isoLanguages;
      var $x_2 = (x$5 === x$6);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Llocales_cldr_CLDRMetadata__f_iso3Languages;
      var x$8 = x$0.Llocales_cldr_CLDRMetadata__f_iso3Languages;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.Llocales_cldr_CLDRMetadata__f_scripts;
      var x$10 = x$0.Llocales_cldr_CLDRMetadata__f_scripts;
      return (x$9 === x$10);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_CLDRMetadata.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_CLDRMetadata.prototype.productArity__I = (function() {
  return 5;
});
$c_Llocales_cldr_CLDRMetadata.prototype.productPrefix__T = (function() {
  return "CLDRMetadata";
});
$c_Llocales_cldr_CLDRMetadata.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_CLDRMetadata__f_isoCountries;
      break;
    }
    case 1: {
      return this.Llocales_cldr_CLDRMetadata__f_iso3Countries;
      break;
    }
    case 2: {
      return this.Llocales_cldr_CLDRMetadata__f_isoLanguages;
      break;
    }
    case 3: {
      return this.Llocales_cldr_CLDRMetadata__f_iso3Languages;
      break;
    }
    case 4: {
      return this.Llocales_cldr_CLDRMetadata__f_scripts;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llocales_cldr_CLDRMetadata.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "isoCountries";
      break;
    }
    case 1: {
      return "iso3Countries";
      break;
    }
    case 2: {
      return "isoLanguages";
      break;
    }
    case 3: {
      return "iso3Languages";
      break;
    }
    case 4: {
      return "scripts";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_CLDRMetadata(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CLDRMetadata)));
}
export { $isArrayOf_Llocales_cldr_CLDRMetadata as $isArrayOf_Llocales_cldr_CLDRMetadata };
var $d_Llocales_cldr_CLDRMetadata = new $TypeData().initClass($c_Llocales_cldr_CLDRMetadata, "locales.cldr.CLDRMetadata", ({
  Llocales_cldr_CLDRMetadata: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Llocales_cldr_CLDRMetadata as $d_Llocales_cldr_CLDRMetadata };
/** @constructor */
function $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns) {
  this.Llocales_cldr_CalendarPatterns__f_datePatterns = null;
  this.Llocales_cldr_CalendarPatterns__f_timePatterns = null;
  this.Llocales_cldr_CalendarPatterns__f_datePatterns = datePatterns;
  this.Llocales_cldr_CalendarPatterns__f_timePatterns = timePatterns;
}
export { $c_Llocales_cldr_CalendarPatterns as $c_Llocales_cldr_CalendarPatterns };
$c_Llocales_cldr_CalendarPatterns.prototype = new $h_O();
$c_Llocales_cldr_CalendarPatterns.prototype.constructor = $c_Llocales_cldr_CalendarPatterns;
/** @constructor */
function $h_Llocales_cldr_CalendarPatterns() {
}
export { $h_Llocales_cldr_CalendarPatterns as $h_Llocales_cldr_CalendarPatterns };
$h_Llocales_cldr_CalendarPatterns.prototype = $c_Llocales_cldr_CalendarPatterns.prototype;
$c_Llocales_cldr_CalendarPatterns.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_CalendarPatterns.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_CalendarPatterns.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CalendarPatterns)) {
    var x = this.Llocales_cldr_CalendarPatterns__f_datePatterns;
    var x$2 = x$0.Llocales_cldr_CalendarPatterns__f_datePatterns;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CalendarPatterns__f_timePatterns;
      var x$4 = x$0.Llocales_cldr_CalendarPatterns__f_timePatterns;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_CalendarPatterns.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_CalendarPatterns.prototype.productArity__I = (function() {
  return 2;
});
$c_Llocales_cldr_CalendarPatterns.prototype.productPrefix__T = (function() {
  return "CalendarPatterns";
});
$c_Llocales_cldr_CalendarPatterns.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llocales_cldr_CalendarPatterns__f_datePatterns;
  }
  if ((n === 1)) {
    return this.Llocales_cldr_CalendarPatterns__f_timePatterns;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llocales_cldr_CalendarPatterns.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "datePatterns";
  }
  if ((n === 1)) {
    return "timePatterns";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Llocales_cldr_CalendarPatterns(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CalendarPatterns)));
}
export { $isArrayOf_Llocales_cldr_CalendarPatterns as $isArrayOf_Llocales_cldr_CalendarPatterns };
var $d_Llocales_cldr_CalendarPatterns = new $TypeData().initClass($c_Llocales_cldr_CalendarPatterns, "locales.cldr.CalendarPatterns", ({
  Llocales_cldr_CalendarPatterns: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Llocales_cldr_CalendarPatterns as $d_Llocales_cldr_CalendarPatterns };
/** @constructor */
function $c_Llocales_cldr_CalendarSymbols(months, shortMonths, weekdays, shortWeekdays, amPm, eras) {
  this.Llocales_cldr_CalendarSymbols__f_months = null;
  this.Llocales_cldr_CalendarSymbols__f_shortMonths = null;
  this.Llocales_cldr_CalendarSymbols__f_weekdays = null;
  this.Llocales_cldr_CalendarSymbols__f_shortWeekdays = null;
  this.Llocales_cldr_CalendarSymbols__f_amPm = null;
  this.Llocales_cldr_CalendarSymbols__f_eras = null;
  this.Llocales_cldr_CalendarSymbols__f_months = months;
  this.Llocales_cldr_CalendarSymbols__f_shortMonths = shortMonths;
  this.Llocales_cldr_CalendarSymbols__f_weekdays = weekdays;
  this.Llocales_cldr_CalendarSymbols__f_shortWeekdays = shortWeekdays;
  this.Llocales_cldr_CalendarSymbols__f_amPm = amPm;
  this.Llocales_cldr_CalendarSymbols__f_eras = eras;
}
export { $c_Llocales_cldr_CalendarSymbols as $c_Llocales_cldr_CalendarSymbols };
$c_Llocales_cldr_CalendarSymbols.prototype = new $h_O();
$c_Llocales_cldr_CalendarSymbols.prototype.constructor = $c_Llocales_cldr_CalendarSymbols;
/** @constructor */
function $h_Llocales_cldr_CalendarSymbols() {
}
export { $h_Llocales_cldr_CalendarSymbols as $h_Llocales_cldr_CalendarSymbols };
$h_Llocales_cldr_CalendarSymbols.prototype = $c_Llocales_cldr_CalendarSymbols.prototype;
$c_Llocales_cldr_CalendarSymbols.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_CalendarSymbols.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_CalendarSymbols.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CalendarSymbols)) {
    var x = this.Llocales_cldr_CalendarSymbols__f_months;
    var x$2 = x$0.Llocales_cldr_CalendarSymbols__f_months;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CalendarSymbols__f_shortMonths;
      var x$4 = x$0.Llocales_cldr_CalendarSymbols__f_shortMonths;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.Llocales_cldr_CalendarSymbols__f_weekdays;
      var x$6 = x$0.Llocales_cldr_CalendarSymbols__f_weekdays;
      var $x_3 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      var x$8 = x$0.Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      var $x_2 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.Llocales_cldr_CalendarSymbols__f_amPm;
      var x$10 = x$0.Llocales_cldr_CalendarSymbols__f_amPm;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.Llocales_cldr_CalendarSymbols__f_eras;
      var x$12 = x$0.Llocales_cldr_CalendarSymbols__f_eras;
      return ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_CalendarSymbols.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_CalendarSymbols.prototype.productArity__I = (function() {
  return 6;
});
$c_Llocales_cldr_CalendarSymbols.prototype.productPrefix__T = (function() {
  return "CalendarSymbols";
});
$c_Llocales_cldr_CalendarSymbols.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_CalendarSymbols__f_months;
      break;
    }
    case 1: {
      return this.Llocales_cldr_CalendarSymbols__f_shortMonths;
      break;
    }
    case 2: {
      return this.Llocales_cldr_CalendarSymbols__f_weekdays;
      break;
    }
    case 3: {
      return this.Llocales_cldr_CalendarSymbols__f_shortWeekdays;
      break;
    }
    case 4: {
      return this.Llocales_cldr_CalendarSymbols__f_amPm;
      break;
    }
    case 5: {
      return this.Llocales_cldr_CalendarSymbols__f_eras;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llocales_cldr_CalendarSymbols.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "months";
      break;
    }
    case 1: {
      return "shortMonths";
      break;
    }
    case 2: {
      return "weekdays";
      break;
    }
    case 3: {
      return "shortWeekdays";
      break;
    }
    case 4: {
      return "amPm";
      break;
    }
    case 5: {
      return "eras";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_CalendarSymbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CalendarSymbols)));
}
export { $isArrayOf_Llocales_cldr_CalendarSymbols as $isArrayOf_Llocales_cldr_CalendarSymbols };
var $d_Llocales_cldr_CalendarSymbols = new $TypeData().initClass($c_Llocales_cldr_CalendarSymbols, "locales.cldr.CalendarSymbols", ({
  Llocales_cldr_CalendarSymbols: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Llocales_cldr_CalendarSymbols as $d_Llocales_cldr_CalendarSymbols };
/** @constructor */
function $c_Llocales_cldr_CurrencyData(currencyTypes, fractions, regions, numericCodes) {
  this.Llocales_cldr_CurrencyData__f_currencyTypes = null;
  this.Llocales_cldr_CurrencyData__f_fractions = null;
  this.Llocales_cldr_CurrencyData__f_regions = null;
  this.Llocales_cldr_CurrencyData__f_numericCodes = null;
  this.Llocales_cldr_CurrencyData__f_currencyTypes = currencyTypes;
  this.Llocales_cldr_CurrencyData__f_fractions = fractions;
  this.Llocales_cldr_CurrencyData__f_regions = regions;
  this.Llocales_cldr_CurrencyData__f_numericCodes = numericCodes;
}
export { $c_Llocales_cldr_CurrencyData as $c_Llocales_cldr_CurrencyData };
$c_Llocales_cldr_CurrencyData.prototype = new $h_O();
$c_Llocales_cldr_CurrencyData.prototype.constructor = $c_Llocales_cldr_CurrencyData;
/** @constructor */
function $h_Llocales_cldr_CurrencyData() {
}
export { $h_Llocales_cldr_CurrencyData as $h_Llocales_cldr_CurrencyData };
$h_Llocales_cldr_CurrencyData.prototype = $c_Llocales_cldr_CurrencyData.prototype;
$c_Llocales_cldr_CurrencyData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_CurrencyData.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_CurrencyData.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CurrencyData)) {
    var x = this.Llocales_cldr_CurrencyData__f_currencyTypes;
    var x$2 = x$0.Llocales_cldr_CurrencyData__f_currencyTypes;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_CurrencyData__f_fractions;
      var x$4 = x$0.Llocales_cldr_CurrencyData__f_fractions;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Llocales_cldr_CurrencyData__f_regions;
      var x$6 = x$0.Llocales_cldr_CurrencyData__f_regions;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Llocales_cldr_CurrencyData__f_numericCodes;
      var x$8 = x$0.Llocales_cldr_CurrencyData__f_numericCodes;
      return ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_CurrencyData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_CurrencyData.prototype.productArity__I = (function() {
  return 4;
});
$c_Llocales_cldr_CurrencyData.prototype.productPrefix__T = (function() {
  return "CurrencyData";
});
$c_Llocales_cldr_CurrencyData.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_CurrencyData__f_currencyTypes;
      break;
    }
    case 1: {
      return this.Llocales_cldr_CurrencyData__f_fractions;
      break;
    }
    case 2: {
      return this.Llocales_cldr_CurrencyData__f_regions;
      break;
    }
    case 3: {
      return this.Llocales_cldr_CurrencyData__f_numericCodes;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llocales_cldr_CurrencyData.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "currencyTypes";
      break;
    }
    case 1: {
      return "fractions";
      break;
    }
    case 2: {
      return "regions";
      break;
    }
    case 3: {
      return "numericCodes";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_CurrencyData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_CurrencyData)));
}
export { $isArrayOf_Llocales_cldr_CurrencyData as $isArrayOf_Llocales_cldr_CurrencyData };
var $d_Llocales_cldr_CurrencyData = new $TypeData().initClass($c_Llocales_cldr_CurrencyData, "locales.cldr.CurrencyData", ({
  Llocales_cldr_CurrencyData: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Llocales_cldr_CurrencyData as $d_Llocales_cldr_CurrencyData };
function $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__($thiz, parent, locale, defaultNS, digitSymbols, calendarSymbols, calendarPatterns, currencies, numberPatterns) {
  $thiz.Llocales_cldr_LDML__f_parent = parent;
  $thiz.Llocales_cldr_LDML__f_locale = locale;
  $thiz.Llocales_cldr_LDML__f_defaultNS = defaultNS;
  $thiz.Llocales_cldr_LDML__f_digitSymbols = digitSymbols;
  $thiz.Llocales_cldr_LDML__f_calendarSymbols = calendarSymbols;
  $thiz.Llocales_cldr_LDML__f_calendarPatterns = calendarPatterns;
  $thiz.Llocales_cldr_LDML__f_currencies = currencies;
  $thiz.Llocales_cldr_LDML__f_numberPatterns = numberPatterns;
  var m = $m_scm_Map$().empty__O();
  var it = currencies.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var key = elem.currencyCode__T();
    var bldr = m.getOrElseUpdate__O__F0__O(key, new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $c_scm_ListBuffer())));
    bldr.addOne__O__scm_Growable(elem);
  }
  var this$3 = $m_sci_HashMap$();
  var result = this$3.sci_HashMap$__f_EmptyMap;
  var mapIt = m.iterator__sc_Iterator();
  while (mapIt.hasNext__Z()) {
    var x1 = mapIt.next__O();
    if ((x1 === null)) {
      throw new $c_s_MatchError(x1);
    }
    var k = x1._1__O();
    var v = x1._2__O();
    result = result.updated__O__O__sci_HashMap(k, v.result__O());
  }
  var this$4 = result;
  $m_sci_HashMap$();
  var b = new $c_sci_HashMapBuilder();
  var it$1 = this$4.iterator__sc_Iterator();
  while (it$1.hasNext__Z()) {
    var x0 = it$1.next__O();
    matchResult10: {
      var elem$1___1;
      var elem$1___2;
      if ((x0 !== null)) {
        var code = x0._1__O();
        var list = x0._2__O();
        var self = code.toUpperCase();
        var y = list.head__O();
        var elem$1___1 = self;
        var elem$1___2 = y;
        break matchResult10;
      }
      throw new $c_s_MatchError(x0);
    }
    $p_sci_HashMapBuilder__ensureUnaliased__V(b);
    var x = elem$1___1;
    var h = $m_sr_Statics$().anyHash__O__I(x);
    var im = $m_sc_Hashing$().improve__I__I(h);
    b.update__sci_MapNode__O__O__I__I__I__V(b.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem$1___1, elem$1___2, h, im, 0);
  }
  b.result__sci_HashMap();
  return $thiz;
}
export { $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__ as $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__ };
/** @constructor */
function $c_Llocales_cldr_LDML() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
}
export { $c_Llocales_cldr_LDML as $c_Llocales_cldr_LDML };
$c_Llocales_cldr_LDML.prototype = new $h_O();
$c_Llocales_cldr_LDML.prototype.constructor = $c_Llocales_cldr_LDML;
/** @constructor */
function $h_Llocales_cldr_LDML() {
}
export { $h_Llocales_cldr_LDML as $h_Llocales_cldr_LDML };
$h_Llocales_cldr_LDML.prototype = $c_Llocales_cldr_LDML.prototype;
$c_Llocales_cldr_LDML.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_LDML.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_LDML.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_LDML)) {
    var x = this.Llocales_cldr_LDML__f_parent;
    var x$2 = x$0.Llocales_cldr_LDML__f_parent;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_LDML__f_locale;
      var x$4 = x$0.Llocales_cldr_LDML__f_locale;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.Llocales_cldr_LDML__f_defaultNS;
      var x$6 = x$0.Llocales_cldr_LDML__f_defaultNS;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.Llocales_cldr_LDML__f_digitSymbols;
      var x$8 = x$0.Llocales_cldr_LDML__f_digitSymbols;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.Llocales_cldr_LDML__f_calendarSymbols;
      var x$10 = x$0.Llocales_cldr_LDML__f_calendarSymbols;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.Llocales_cldr_LDML__f_calendarPatterns;
      var x$12 = x$0.Llocales_cldr_LDML__f_calendarPatterns;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.Llocales_cldr_LDML__f_currencies;
      var x$14 = x$0.Llocales_cldr_LDML__f_currencies;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.equals__O__Z(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.Llocales_cldr_LDML__f_numberPatterns;
      var x$16 = x$0.Llocales_cldr_LDML__f_numberPatterns;
      return ((x$15 === null) ? (x$16 === null) : x$15.equals__O__Z(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_LDML.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_LDML.prototype.productArity__I = (function() {
  return 8;
});
$c_Llocales_cldr_LDML.prototype.productPrefix__T = (function() {
  return "LDML";
});
$c_Llocales_cldr_LDML.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_LDML__f_parent;
      break;
    }
    case 1: {
      return this.Llocales_cldr_LDML__f_locale;
      break;
    }
    case 2: {
      return this.Llocales_cldr_LDML__f_defaultNS;
      break;
    }
    case 3: {
      return this.Llocales_cldr_LDML__f_digitSymbols;
      break;
    }
    case 4: {
      return this.Llocales_cldr_LDML__f_calendarSymbols;
      break;
    }
    case 5: {
      return this.Llocales_cldr_LDML__f_calendarPatterns;
      break;
    }
    case 6: {
      return this.Llocales_cldr_LDML__f_currencies;
      break;
    }
    case 7: {
      return this.Llocales_cldr_LDML__f_numberPatterns;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llocales_cldr_LDML.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "parent";
      break;
    }
    case 1: {
      return "locale";
      break;
    }
    case 2: {
      return "defaultNS";
      break;
    }
    case 3: {
      return "digitSymbols";
      break;
    }
    case 4: {
      return "calendarSymbols";
      break;
    }
    case 5: {
      return "calendarPatterns";
      break;
    }
    case 6: {
      return "currencies";
      break;
    }
    case 7: {
      return "numberPatterns";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llocales_cldr_LDML.prototype.toLocale__ju_Locale = (function() {
  if ((this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_language === "root")) {
    var $x_3 = new $c_ju_Locale$Builder().setLanguage__T__ju_Locale$Builder("");
    var this$1 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_territory;
    var $x_2 = $x_3.setRegion__T__ju_Locale$Builder((this$1.isEmpty__Z() ? "" : this$1.get__O()));
    var this$2 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_script;
    var $x_1 = $x_2.setScript__T__ju_Locale$Builder((this$2.isEmpty__Z() ? "" : this$2.get__O()));
    var this$3 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_variant;
    return $x_1.setVariant__T__ju_Locale$Builder((this$3.isEmpty__Z() ? "" : this$3.get__O())).build__ju_Locale();
  } else {
    var $x_6 = new $c_ju_Locale$Builder().setLanguage__T__ju_Locale$Builder(this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_language);
    var this$4 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_territory;
    var $x_5 = $x_6.setRegion__T__ju_Locale$Builder((this$4.isEmpty__Z() ? "" : this$4.get__O()));
    var this$5 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_script;
    var $x_4 = $x_5.setScript__T__ju_Locale$Builder((this$5.isEmpty__Z() ? "" : this$5.get__O()));
    var this$6 = this.Llocales_cldr_LDML__f_locale.Llocales_cldr_LDMLLocale__f_variant;
    return $x_4.setVariant__T__ju_Locale$Builder((this$6.isEmpty__Z() ? "" : this$6.get__O())).build__ju_Locale();
  }
});
function $isArrayOf_Llocales_cldr_LDML(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_LDML)));
}
export { $isArrayOf_Llocales_cldr_LDML as $isArrayOf_Llocales_cldr_LDML };
var $d_Llocales_cldr_LDML = new $TypeData().initClass(0, "locales.cldr.LDML", ({
  Llocales_cldr_LDML: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Llocales_cldr_LDML as $d_Llocales_cldr_LDML };
/** @constructor */
function $c_Llocales_cldr_LDMLLocale(language, territory, variant, script) {
  this.Llocales_cldr_LDMLLocale__f_language = null;
  this.Llocales_cldr_LDMLLocale__f_territory = null;
  this.Llocales_cldr_LDMLLocale__f_variant = null;
  this.Llocales_cldr_LDMLLocale__f_script = null;
  this.Llocales_cldr_LDMLLocale__f_language = language;
  this.Llocales_cldr_LDMLLocale__f_territory = territory;
  this.Llocales_cldr_LDMLLocale__f_variant = variant;
  this.Llocales_cldr_LDMLLocale__f_script = script;
}
export { $c_Llocales_cldr_LDMLLocale as $c_Llocales_cldr_LDMLLocale };
$c_Llocales_cldr_LDMLLocale.prototype = new $h_O();
$c_Llocales_cldr_LDMLLocale.prototype.constructor = $c_Llocales_cldr_LDMLLocale;
/** @constructor */
function $h_Llocales_cldr_LDMLLocale() {
}
export { $h_Llocales_cldr_LDMLLocale as $h_Llocales_cldr_LDMLLocale };
$h_Llocales_cldr_LDMLLocale.prototype = $c_Llocales_cldr_LDMLLocale.prototype;
$c_Llocales_cldr_LDMLLocale.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_LDMLLocale.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_LDMLLocale.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_LDMLLocale)) {
    if ((this.Llocales_cldr_LDMLLocale__f_language === x$0.Llocales_cldr_LDMLLocale__f_language)) {
      var x = this.Llocales_cldr_LDMLLocale__f_territory;
      var x$2 = x$0.Llocales_cldr_LDMLLocale__f_territory;
      var $x_2 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Llocales_cldr_LDMLLocale__f_variant;
      var x$4 = x$0.Llocales_cldr_LDMLLocale__f_variant;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Llocales_cldr_LDMLLocale__f_script;
      var x$6 = x$0.Llocales_cldr_LDMLLocale__f_script;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_LDMLLocale.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_LDMLLocale.prototype.productArity__I = (function() {
  return 4;
});
$c_Llocales_cldr_LDMLLocale.prototype.productPrefix__T = (function() {
  return "LDMLLocale";
});
$c_Llocales_cldr_LDMLLocale.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_LDMLLocale__f_language;
      break;
    }
    case 1: {
      return this.Llocales_cldr_LDMLLocale__f_territory;
      break;
    }
    case 2: {
      return this.Llocales_cldr_LDMLLocale__f_variant;
      break;
    }
    case 3: {
      return this.Llocales_cldr_LDMLLocale__f_script;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llocales_cldr_LDMLLocale.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "language";
      break;
    }
    case 1: {
      return "territory";
      break;
    }
    case 2: {
      return "variant";
      break;
    }
    case 3: {
      return "script";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_LDMLLocale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_LDMLLocale)));
}
export { $isArrayOf_Llocales_cldr_LDMLLocale as $isArrayOf_Llocales_cldr_LDMLLocale };
var $d_Llocales_cldr_LDMLLocale = new $TypeData().initClass($c_Llocales_cldr_LDMLLocale, "locales.cldr.LDMLLocale", ({
  Llocales_cldr_LDMLLocale: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Llocales_cldr_LDMLLocale as $d_Llocales_cldr_LDMLLocale };
/** @constructor */
function $c_Llocales_cldr_NumberPatterns(decimalFormat, percentFormat, currencyFormat) {
  this.Llocales_cldr_NumberPatterns__f_decimalFormat = null;
  this.Llocales_cldr_NumberPatterns__f_percentFormat = null;
  this.Llocales_cldr_NumberPatterns__f_currencyFormat = null;
  this.Llocales_cldr_NumberPatterns__f_decimalFormat = decimalFormat;
  this.Llocales_cldr_NumberPatterns__f_percentFormat = percentFormat;
  this.Llocales_cldr_NumberPatterns__f_currencyFormat = currencyFormat;
}
export { $c_Llocales_cldr_NumberPatterns as $c_Llocales_cldr_NumberPatterns };
$c_Llocales_cldr_NumberPatterns.prototype = new $h_O();
$c_Llocales_cldr_NumberPatterns.prototype.constructor = $c_Llocales_cldr_NumberPatterns;
/** @constructor */
function $h_Llocales_cldr_NumberPatterns() {
}
export { $h_Llocales_cldr_NumberPatterns as $h_Llocales_cldr_NumberPatterns };
$h_Llocales_cldr_NumberPatterns.prototype = $c_Llocales_cldr_NumberPatterns.prototype;
$c_Llocales_cldr_NumberPatterns.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_NumberPatterns.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_NumberPatterns.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_NumberPatterns)) {
    var x = this.Llocales_cldr_NumberPatterns__f_decimalFormat;
    var x$2 = x$0.Llocales_cldr_NumberPatterns__f_decimalFormat;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_NumberPatterns__f_percentFormat;
      var x$4 = x$0.Llocales_cldr_NumberPatterns__f_percentFormat;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Llocales_cldr_NumberPatterns__f_currencyFormat;
      var x$6 = x$0.Llocales_cldr_NumberPatterns__f_currencyFormat;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_NumberPatterns.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_NumberPatterns.prototype.productArity__I = (function() {
  return 3;
});
$c_Llocales_cldr_NumberPatterns.prototype.productPrefix__T = (function() {
  return "NumberPatterns";
});
$c_Llocales_cldr_NumberPatterns.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_NumberPatterns__f_decimalFormat;
      break;
    }
    case 1: {
      return this.Llocales_cldr_NumberPatterns__f_percentFormat;
      break;
    }
    case 2: {
      return this.Llocales_cldr_NumberPatterns__f_currencyFormat;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llocales_cldr_NumberPatterns.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "decimalFormat";
      break;
    }
    case 1: {
      return "percentFormat";
      break;
    }
    case 2: {
      return "currencyFormat";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_NumberPatterns(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_NumberPatterns)));
}
export { $isArrayOf_Llocales_cldr_NumberPatterns as $isArrayOf_Llocales_cldr_NumberPatterns };
var $d_Llocales_cldr_NumberPatterns = new $TypeData().initClass($c_Llocales_cldr_NumberPatterns, "locales.cldr.NumberPatterns", ({
  Llocales_cldr_NumberPatterns: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Llocales_cldr_NumberPatterns as $d_Llocales_cldr_NumberPatterns };
/** @constructor */
function $c_Llocales_cldr_NumberingSystem(id, digits) {
  this.Llocales_cldr_NumberingSystem__f_id = null;
  this.Llocales_cldr_NumberingSystem__f_digits = null;
  this.Llocales_cldr_NumberingSystem__f_id = id;
  this.Llocales_cldr_NumberingSystem__f_digits = digits;
}
export { $c_Llocales_cldr_NumberingSystem as $c_Llocales_cldr_NumberingSystem };
$c_Llocales_cldr_NumberingSystem.prototype = new $h_O();
$c_Llocales_cldr_NumberingSystem.prototype.constructor = $c_Llocales_cldr_NumberingSystem;
/** @constructor */
function $h_Llocales_cldr_NumberingSystem() {
}
export { $h_Llocales_cldr_NumberingSystem as $h_Llocales_cldr_NumberingSystem };
$h_Llocales_cldr_NumberingSystem.prototype = $c_Llocales_cldr_NumberingSystem.prototype;
$c_Llocales_cldr_NumberingSystem.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_NumberingSystem.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_NumberingSystem.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_NumberingSystem)) {
    if ((this.Llocales_cldr_NumberingSystem__f_id === x$0.Llocales_cldr_NumberingSystem__f_id)) {
      var x = this.Llocales_cldr_NumberingSystem__f_digits;
      var x$2 = x$0.Llocales_cldr_NumberingSystem__f_digits;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_NumberingSystem.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_NumberingSystem.prototype.productArity__I = (function() {
  return 2;
});
$c_Llocales_cldr_NumberingSystem.prototype.productPrefix__T = (function() {
  return "NumberingSystem";
});
$c_Llocales_cldr_NumberingSystem.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Llocales_cldr_NumberingSystem__f_id;
  }
  if ((n === 1)) {
    return this.Llocales_cldr_NumberingSystem__f_digits;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Llocales_cldr_NumberingSystem.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "digits";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Llocales_cldr_NumberingSystem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_NumberingSystem)));
}
export { $isArrayOf_Llocales_cldr_NumberingSystem as $isArrayOf_Llocales_cldr_NumberingSystem };
var $d_Llocales_cldr_NumberingSystem = new $TypeData().initClass($c_Llocales_cldr_NumberingSystem, "locales.cldr.NumberingSystem", ({
  Llocales_cldr_NumberingSystem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Llocales_cldr_NumberingSystem as $d_Llocales_cldr_NumberingSystem };
/** @constructor */
function $c_Llocales_cldr_Symbols(ns, aliasOf, decimal, group, list, percent, minus, perMille, infinity, nan, exp) {
  this.Llocales_cldr_Symbols__f_ns = null;
  this.Llocales_cldr_Symbols__f_aliasOf = null;
  this.Llocales_cldr_Symbols__f_decimal = null;
  this.Llocales_cldr_Symbols__f_group = null;
  this.Llocales_cldr_Symbols__f_list = null;
  this.Llocales_cldr_Symbols__f_percent = null;
  this.Llocales_cldr_Symbols__f_minus = null;
  this.Llocales_cldr_Symbols__f_perMille = null;
  this.Llocales_cldr_Symbols__f_infinity = null;
  this.Llocales_cldr_Symbols__f_nan = null;
  this.Llocales_cldr_Symbols__f_exp = null;
  this.Llocales_cldr_Symbols__f_ns = ns;
  this.Llocales_cldr_Symbols__f_aliasOf = aliasOf;
  this.Llocales_cldr_Symbols__f_decimal = decimal;
  this.Llocales_cldr_Symbols__f_group = group;
  this.Llocales_cldr_Symbols__f_list = list;
  this.Llocales_cldr_Symbols__f_percent = percent;
  this.Llocales_cldr_Symbols__f_minus = minus;
  this.Llocales_cldr_Symbols__f_perMille = perMille;
  this.Llocales_cldr_Symbols__f_infinity = infinity;
  this.Llocales_cldr_Symbols__f_nan = nan;
  this.Llocales_cldr_Symbols__f_exp = exp;
}
export { $c_Llocales_cldr_Symbols as $c_Llocales_cldr_Symbols };
$c_Llocales_cldr_Symbols.prototype = new $h_O();
$c_Llocales_cldr_Symbols.prototype.constructor = $c_Llocales_cldr_Symbols;
/** @constructor */
function $h_Llocales_cldr_Symbols() {
}
export { $h_Llocales_cldr_Symbols as $h_Llocales_cldr_Symbols };
$h_Llocales_cldr_Symbols.prototype = $c_Llocales_cldr_Symbols.prototype;
$c_Llocales_cldr_Symbols.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Llocales_cldr_Symbols.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Llocales_cldr_Symbols.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_Symbols)) {
    var x = this.Llocales_cldr_Symbols__f_ns;
    var x$2 = x$0.Llocales_cldr_Symbols__f_ns;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Llocales_cldr_Symbols__f_aliasOf;
      var x$4 = x$0.Llocales_cldr_Symbols__f_aliasOf;
      var $x_9 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$5 = this.Llocales_cldr_Symbols__f_decimal;
      var x$6 = x$0.Llocales_cldr_Symbols__f_decimal;
      var $x_8 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$7 = this.Llocales_cldr_Symbols__f_group;
      var x$8 = x$0.Llocales_cldr_Symbols__f_group;
      var $x_7 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$9 = this.Llocales_cldr_Symbols__f_list;
      var x$10 = x$0.Llocales_cldr_Symbols__f_list;
      var $x_6 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$11 = this.Llocales_cldr_Symbols__f_percent;
      var x$12 = x$0.Llocales_cldr_Symbols__f_percent;
      var $x_5 = ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$13 = this.Llocales_cldr_Symbols__f_minus;
      var x$14 = x$0.Llocales_cldr_Symbols__f_minus;
      var $x_4 = ((x$13 === null) ? (x$14 === null) : x$13.equals__O__Z(x$14));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$15 = this.Llocales_cldr_Symbols__f_perMille;
      var x$16 = x$0.Llocales_cldr_Symbols__f_perMille;
      var $x_3 = ((x$15 === null) ? (x$16 === null) : x$15.equals__O__Z(x$16));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$17 = this.Llocales_cldr_Symbols__f_infinity;
      var x$18 = x$0.Llocales_cldr_Symbols__f_infinity;
      var $x_2 = ((x$17 === null) ? (x$18 === null) : x$17.equals__O__Z(x$18));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$19 = this.Llocales_cldr_Symbols__f_nan;
      var x$20 = x$0.Llocales_cldr_Symbols__f_nan;
      var $x_1 = ((x$19 === null) ? (x$20 === null) : x$19.equals__O__Z(x$20));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$21 = this.Llocales_cldr_Symbols__f_exp;
      var x$22 = x$0.Llocales_cldr_Symbols__f_exp;
      return ((x$21 === null) ? (x$22 === null) : x$21.equals__O__Z(x$22));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Llocales_cldr_Symbols.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Llocales_cldr_Symbols.prototype.productArity__I = (function() {
  return 11;
});
$c_Llocales_cldr_Symbols.prototype.productPrefix__T = (function() {
  return "Symbols";
});
$c_Llocales_cldr_Symbols.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Llocales_cldr_Symbols__f_ns;
      break;
    }
    case 1: {
      return this.Llocales_cldr_Symbols__f_aliasOf;
      break;
    }
    case 2: {
      return this.Llocales_cldr_Symbols__f_decimal;
      break;
    }
    case 3: {
      return this.Llocales_cldr_Symbols__f_group;
      break;
    }
    case 4: {
      return this.Llocales_cldr_Symbols__f_list;
      break;
    }
    case 5: {
      return this.Llocales_cldr_Symbols__f_percent;
      break;
    }
    case 6: {
      return this.Llocales_cldr_Symbols__f_minus;
      break;
    }
    case 7: {
      return this.Llocales_cldr_Symbols__f_perMille;
      break;
    }
    case 8: {
      return this.Llocales_cldr_Symbols__f_infinity;
      break;
    }
    case 9: {
      return this.Llocales_cldr_Symbols__f_nan;
      break;
    }
    case 10: {
      return this.Llocales_cldr_Symbols__f_exp;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Llocales_cldr_Symbols.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "ns";
      break;
    }
    case 1: {
      return "aliasOf";
      break;
    }
    case 2: {
      return "decimal";
      break;
    }
    case 3: {
      return "group";
      break;
    }
    case 4: {
      return "list";
      break;
    }
    case 5: {
      return "percent";
      break;
    }
    case 6: {
      return "minus";
      break;
    }
    case 7: {
      return "perMille";
      break;
    }
    case 8: {
      return "infinity";
      break;
    }
    case 9: {
      return "nan";
      break;
    }
    case 10: {
      return "exp";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_Symbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Llocales_cldr_Symbols)));
}
export { $isArrayOf_Llocales_cldr_Symbols as $isArrayOf_Llocales_cldr_Symbols };
var $d_Llocales_cldr_Symbols = new $TypeData().initClass($c_Llocales_cldr_Symbols, "locales.cldr.Symbols", ({
  Llocales_cldr_Symbols: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Llocales_cldr_Symbols as $d_Llocales_cldr_Symbols };
/** @constructor */
function $c_Lmagnolia1_CaseClassDerivation$$anon$1() {
}
export { $c_Lmagnolia1_CaseClassDerivation$$anon$1 as $c_Lmagnolia1_CaseClassDerivation$$anon$1 };
$c_Lmagnolia1_CaseClassDerivation$$anon$1.prototype = new $h_O();
$c_Lmagnolia1_CaseClassDerivation$$anon$1.prototype.constructor = $c_Lmagnolia1_CaseClassDerivation$$anon$1;
/** @constructor */
function $h_Lmagnolia1_CaseClassDerivation$$anon$1() {
}
export { $h_Lmagnolia1_CaseClassDerivation$$anon$1 as $h_Lmagnolia1_CaseClassDerivation$$anon$1 };
$h_Lmagnolia1_CaseClassDerivation$$anon$1.prototype = $c_Lmagnolia1_CaseClassDerivation$$anon$1.prototype;
$c_Lmagnolia1_CaseClassDerivation$$anon$1.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lmagnolia1_CaseClassDerivation$$anon$1.prototype.apply__O = (function() {
  return $m_s_None$();
});
var $d_Lmagnolia1_CaseClassDerivation$$anon$1 = new $TypeData().initClass($c_Lmagnolia1_CaseClassDerivation$$anon$1, "magnolia1.CaseClassDerivation$$anon$1", ({
  Lmagnolia1_CaseClassDerivation$$anon$1: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lmagnolia1_CaseClassDerivation$$anon$1 as $d_Lmagnolia1_CaseClassDerivation$$anon$1 };
/** @constructor */
function $c_Lmagnolia1_TypeInfo(owner, short, typeParams) {
  this.Lmagnolia1_TypeInfo__f_owner = null;
  this.Lmagnolia1_TypeInfo__f_short = null;
  this.Lmagnolia1_TypeInfo__f_typeParams = null;
  this.Lmagnolia1_TypeInfo__f_owner = owner;
  this.Lmagnolia1_TypeInfo__f_short = short;
  this.Lmagnolia1_TypeInfo__f_typeParams = typeParams;
}
export { $c_Lmagnolia1_TypeInfo as $c_Lmagnolia1_TypeInfo };
$c_Lmagnolia1_TypeInfo.prototype = new $h_O();
$c_Lmagnolia1_TypeInfo.prototype.constructor = $c_Lmagnolia1_TypeInfo;
/** @constructor */
function $h_Lmagnolia1_TypeInfo() {
}
export { $h_Lmagnolia1_TypeInfo as $h_Lmagnolia1_TypeInfo };
$h_Lmagnolia1_TypeInfo.prototype = $c_Lmagnolia1_TypeInfo.prototype;
$c_Lmagnolia1_TypeInfo.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lmagnolia1_TypeInfo.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lmagnolia1_TypeInfo.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmagnolia1_TypeInfo)) {
    if (((this.Lmagnolia1_TypeInfo__f_owner === x$0.Lmagnolia1_TypeInfo__f_owner) && (this.Lmagnolia1_TypeInfo__f_short === x$0.Lmagnolia1_TypeInfo__f_short))) {
      var x = this.Lmagnolia1_TypeInfo__f_typeParams;
      var x$2 = x$0.Lmagnolia1_TypeInfo__f_typeParams;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lmagnolia1_TypeInfo.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lmagnolia1_TypeInfo.prototype.productArity__I = (function() {
  return 3;
});
$c_Lmagnolia1_TypeInfo.prototype.productPrefix__T = (function() {
  return "TypeInfo";
});
$c_Lmagnolia1_TypeInfo.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lmagnolia1_TypeInfo__f_owner;
      break;
    }
    case 1: {
      return this.Lmagnolia1_TypeInfo__f_short;
      break;
    }
    case 2: {
      return this.Lmagnolia1_TypeInfo__f_typeParams;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lmagnolia1_TypeInfo.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "owner";
      break;
    }
    case 1: {
      return "short";
      break;
    }
    case 2: {
      return "typeParams";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lmagnolia1_TypeInfo.prototype.full__T = (function() {
  return ((this.Lmagnolia1_TypeInfo__f_owner + ".") + this.Lmagnolia1_TypeInfo__f_short);
});
function $isArrayOf_Lmagnolia1_TypeInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lmagnolia1_TypeInfo)));
}
export { $isArrayOf_Lmagnolia1_TypeInfo as $isArrayOf_Lmagnolia1_TypeInfo };
var $d_Lmagnolia1_TypeInfo = new $TypeData().initClass($c_Lmagnolia1_TypeInfo, "magnolia1.TypeInfo", ({
  Lmagnolia1_TypeInfo: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lmagnolia1_TypeInfo as $d_Lmagnolia1_TypeInfo };
/** @constructor */
function $c_s_$eq$colon$eq() {
}
export { $c_s_$eq$colon$eq as $c_s_$eq$colon$eq };
$c_s_$eq$colon$eq.prototype = new $h_s_$less$colon$less();
$c_s_$eq$colon$eq.prototype.constructor = $c_s_$eq$colon$eq;
/** @constructor */
function $h_s_$eq$colon$eq() {
}
export { $h_s_$eq$colon$eq as $h_s_$eq$colon$eq };
$h_s_$eq$colon$eq.prototype = $c_s_$eq$colon$eq.prototype;
/** @constructor */
function $c_s_PartialFunction$$anon$1() {
  this.s_PartialFunction$$anon$1__f_lift = null;
  this.s_PartialFunction$$anon$1__f_lift = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => $m_s_None$()));
}
export { $c_s_PartialFunction$$anon$1 as $c_s_PartialFunction$$anon$1 };
$c_s_PartialFunction$$anon$1.prototype = new $h_O();
$c_s_PartialFunction$$anon$1.prototype.constructor = $c_s_PartialFunction$$anon$1;
/** @constructor */
function $h_s_PartialFunction$$anon$1() {
}
export { $h_s_PartialFunction$$anon$1 as $h_s_PartialFunction$$anon$1 };
$h_s_PartialFunction$$anon$1.prototype = $c_s_PartialFunction$$anon$1.prototype;
$c_s_PartialFunction$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_s_PartialFunction$$anon$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  this.apply__O__E(v1);
});
$c_s_PartialFunction$$anon$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_PartialFunction$$anon$1.prototype.toString__T = (function() {
  return "<function1>";
});
$c_s_PartialFunction$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__E = (function(x) {
  throw new $c_s_MatchError(x);
});
$c_s_PartialFunction$$anon$1.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return this;
});
$c_s_PartialFunction$$anon$1.prototype.lift__F1 = (function() {
  return this.s_PartialFunction$$anon$1__f_lift;
});
$c_s_PartialFunction$$anon$1.prototype.runWith__F1__F1 = (function(action) {
  return $m_s_PartialFunction$().s_PartialFunction$__f_scala$PartialFunction$$constFalse;
});
$c_s_PartialFunction$$anon$1.prototype.andThen__F1__F1 = (function(g) {
  return this;
});
$c_s_PartialFunction$$anon$1.prototype.apply__O__O = (function(v1) {
  this.apply__O__E(v1);
});
var $d_s_PartialFunction$$anon$1 = new $TypeData().initClass($c_s_PartialFunction$$anon$1, "scala.PartialFunction$$anon$1", ({
  s_PartialFunction$$anon$1: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_PartialFunction$$anon$1 as $d_s_PartialFunction$$anon$1 };
/** @constructor */
function $c_s_PartialFunction$AndThen(pf, k) {
  this.s_PartialFunction$AndThen__f_pf = null;
  this.s_PartialFunction$AndThen__f_k = null;
  this.s_PartialFunction$AndThen__f_pf = pf;
  this.s_PartialFunction$AndThen__f_k = k;
}
export { $c_s_PartialFunction$AndThen as $c_s_PartialFunction$AndThen };
$c_s_PartialFunction$AndThen.prototype = new $h_O();
$c_s_PartialFunction$AndThen.prototype.constructor = $c_s_PartialFunction$AndThen;
/** @constructor */
function $h_s_PartialFunction$AndThen() {
}
export { $h_s_PartialFunction$AndThen as $h_s_PartialFunction$AndThen };
$h_s_PartialFunction$AndThen.prototype = $c_s_PartialFunction$AndThen.prototype;
$c_s_PartialFunction$AndThen.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_s_PartialFunction$AndThen.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_s_PartialFunction$AndThen.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_s_PartialFunction$AndThen.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!this.apply__O__O(v1)));
});
$c_s_PartialFunction$AndThen.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_PartialFunction$AndThen.prototype.toString__T = (function() {
  return "<function1>";
});
$c_s_PartialFunction$AndThen.prototype.isDefinedAt__O__Z = (function(x) {
  return this.s_PartialFunction$AndThen__f_pf.isDefinedAt__O__Z(x);
});
$c_s_PartialFunction$AndThen.prototype.apply__O__O = (function(x) {
  return this.s_PartialFunction$AndThen__f_k.apply__O__O(this.s_PartialFunction$AndThen__f_pf.apply__O__O(x));
});
$c_s_PartialFunction$AndThen.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var z = this.s_PartialFunction$AndThen__f_pf.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? this.s_PartialFunction$AndThen__f_k.apply__O__O(z) : default$1.apply__O__O(x));
});
$c_s_PartialFunction$AndThen.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
var $d_s_PartialFunction$AndThen = new $TypeData().initClass($c_s_PartialFunction$AndThen, "scala.PartialFunction$AndThen", ({
  s_PartialFunction$AndThen: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_PartialFunction$AndThen as $d_s_PartialFunction$AndThen };
/** @constructor */
function $c_s_PartialFunction$Combined(pf, k) {
  this.s_PartialFunction$Combined__f_pf = null;
  this.s_PartialFunction$Combined__f_k = null;
  this.s_PartialFunction$Combined__f_pf = pf;
  this.s_PartialFunction$Combined__f_k = k;
}
export { $c_s_PartialFunction$Combined as $c_s_PartialFunction$Combined };
$c_s_PartialFunction$Combined.prototype = new $h_O();
$c_s_PartialFunction$Combined.prototype.constructor = $c_s_PartialFunction$Combined;
/** @constructor */
function $h_s_PartialFunction$Combined() {
}
export { $h_s_PartialFunction$Combined as $h_s_PartialFunction$Combined };
$h_s_PartialFunction$Combined.prototype = $c_s_PartialFunction$Combined.prototype;
$c_s_PartialFunction$Combined.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_s_PartialFunction$Combined.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_s_PartialFunction$Combined.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_s_PartialFunction$Combined.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!this.apply__O__O(v1)));
});
$c_s_PartialFunction$Combined.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_s_PartialFunction$Combined.prototype.toString__T = (function() {
  return "<function1>";
});
$c_s_PartialFunction$Combined.prototype.isDefinedAt__O__Z = (function(x) {
  var b = this.s_PartialFunction$Combined__f_pf.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(b)) && this.s_PartialFunction$Combined__f_k.isDefinedAt__O__Z(b));
});
$c_s_PartialFunction$Combined.prototype.apply__O__O = (function(x) {
  return this.s_PartialFunction$Combined__f_k.apply__O__O(this.s_PartialFunction$Combined__f_pf.apply__O__O(x));
});
$c_s_PartialFunction$Combined.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  var pfv = this.s_PartialFunction$Combined__f_pf.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(pfv)) ? this.s_PartialFunction$Combined__f_k.applyOrElse__O__F1__O(pfv, new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2$2) => default$1.apply__O__O(x)))) : default$1.apply__O__O(x));
});
$c_s_PartialFunction$Combined.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
var $d_s_PartialFunction$Combined = new $TypeData().initClass($c_s_PartialFunction$Combined, "scala.PartialFunction$Combined", ({
  s_PartialFunction$Combined: 1,
  s_PartialFunction: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_PartialFunction$Combined as $d_s_PartialFunction$Combined };
/** @constructor */
function $c_s_PartialFunction$Lifted(pf) {
  this.s_PartialFunction$Lifted__f_pf = null;
  this.s_PartialFunction$Lifted__f_pf = pf;
}
export { $c_s_PartialFunction$Lifted as $c_s_PartialFunction$Lifted };
$c_s_PartialFunction$Lifted.prototype = new $h_sr_AbstractFunction1();
$c_s_PartialFunction$Lifted.prototype.constructor = $c_s_PartialFunction$Lifted;
/** @constructor */
function $h_s_PartialFunction$Lifted() {
}
export { $h_s_PartialFunction$Lifted as $h_s_PartialFunction$Lifted };
$h_s_PartialFunction$Lifted.prototype = $c_s_PartialFunction$Lifted.prototype;
$c_s_PartialFunction$Lifted.prototype.apply__O__s_Option = (function(x) {
  var z = this.s_PartialFunction$Lifted__f_pf.applyOrElse__O__F1__O(x, $m_s_PartialFunction$().s_PartialFunction$__f_fallback_fn);
  return ((!$m_s_PartialFunction$().scala$PartialFunction$$fallbackOccurred__O__Z(z)) ? new $c_s_Some(z) : $m_s_None$());
});
$c_s_PartialFunction$Lifted.prototype.apply__O__O = (function(v1) {
  return this.apply__O__s_Option(v1);
});
var $d_s_PartialFunction$Lifted = new $TypeData().initClass($c_s_PartialFunction$Lifted, "scala.PartialFunction$Lifted", ({
  s_PartialFunction$Lifted: 1,
  sr_AbstractFunction1: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_PartialFunction$Lifted as $d_s_PartialFunction$Lifted };
/** @constructor */
function $c_s_StringContext(parts) {
  this.s_StringContext__f_parts = null;
  this.s_StringContext__f_parts = parts;
}
export { $c_s_StringContext as $c_s_StringContext };
$c_s_StringContext.prototype = new $h_O();
$c_s_StringContext.prototype.constructor = $c_s_StringContext;
/** @constructor */
function $h_s_StringContext() {
}
export { $h_s_StringContext as $h_s_StringContext };
$h_s_StringContext.prototype = $c_s_StringContext.prototype;
$c_s_StringContext.prototype.productPrefix__T = (function() {
  return "StringContext";
});
$c_s_StringContext.prototype.productArity__I = (function() {
  return 1;
});
$c_s_StringContext.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_StringContext__f_parts : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_StringContext.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_StringContext.prototype.productElementName__I__T = (function(x$1) {
  return ((x$1 === 0) ? "parts" : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_StringContext.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 517060505, true);
});
$c_s_StringContext.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_StringContext.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_StringContext)) {
    var x = this.s_StringContext__f_parts;
    var x$2 = x$1.s_StringContext__f_parts;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
function $isArrayOf_s_StringContext(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_StringContext)));
}
export { $isArrayOf_s_StringContext as $isArrayOf_s_StringContext };
var $d_s_StringContext = new $TypeData().initClass($c_s_StringContext, "scala.StringContext", ({
  s_StringContext: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_StringContext as $d_s_StringContext };
/** @constructor */
function $c_sc_AbstractIterator() {
}
export { $c_sc_AbstractIterator as $c_sc_AbstractIterator };
$c_sc_AbstractIterator.prototype = new $h_O();
$c_sc_AbstractIterator.prototype.constructor = $c_sc_AbstractIterator;
/** @constructor */
function $h_sc_AbstractIterator() {
}
export { $h_sc_AbstractIterator as $h_sc_AbstractIterator };
$h_sc_AbstractIterator.prototype = $c_sc_AbstractIterator.prototype;
$c_sc_AbstractIterator.prototype.iterator__sc_Iterator = (function() {
  return this;
});
$c_sc_AbstractIterator.prototype.concat__F0__sc_Iterator = (function(xs) {
  return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
});
$c_sc_AbstractIterator.prototype.take__I__sc_Iterator = (function(n) {
  return $f_sc_Iterator__take__I__sc_Iterator(this, n);
});
$c_sc_AbstractIterator.prototype.drop__I__sc_Iterator = (function(n) {
  return this.sliceIterator__I__I__sc_Iterator(n, (-1));
});
$c_sc_AbstractIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return $f_sc_Iterator__sliceIterator__I__I__sc_Iterator(this, from, until);
});
$c_sc_AbstractIterator.prototype.toString__T = (function() {
  return "<iterator>";
});
$c_sc_AbstractIterator.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sc_AbstractIterator.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_sc_AbstractIterator.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_AbstractIterator.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sc_AbstractIterator.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sc_AbstractIterator.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_AbstractIterator.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_AbstractIterator.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sc_AbstractIterator.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_AbstractIterator.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_AbstractIterator.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_sc_AbstractIterator.prototype.knownSize__I = (function() {
  return (-1);
});
/** @constructor */
function $c_sc_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Iterable$());
}
export { $c_sc_Iterable$ as $c_sc_Iterable$ };
$c_sc_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Iterable$.prototype.constructor = $c_sc_Iterable$;
/** @constructor */
function $h_sc_Iterable$() {
}
export { $h_sc_Iterable$ as $h_sc_Iterable$ };
$h_sc_Iterable$.prototype = $c_sc_Iterable$.prototype;
var $d_sc_Iterable$ = new $TypeData().initClass($c_sc_Iterable$, "scala.collection.Iterable$", ({
  sc_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_Iterable$ as $d_sc_Iterable$ };
var $n_sc_Iterable$;
function $m_sc_Iterable$() {
  if ((!$n_sc_Iterable$)) {
    $n_sc_Iterable$ = new $c_sc_Iterable$();
  }
  return $n_sc_Iterable$;
}
export { $m_sc_Iterable$ as $m_sc_Iterable$ };
/** @constructor */
function $c_sc_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  this.sc_Map$__f_DefaultSentinel = null;
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_sci_Map$());
  $n_sc_Map$ = this;
  this.sc_Map$__f_DefaultSentinel = $ct_O__(new $c_O());
  this.sc_Map$__f_scala$collection$Map$$DefaultSentinelFn = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_sc_Map$().sc_Map$__f_DefaultSentinel));
}
export { $c_sc_Map$ as $c_sc_Map$ };
$c_sc_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_sc_Map$.prototype.constructor = $c_sc_Map$;
/** @constructor */
function $h_sc_Map$() {
}
export { $h_sc_Map$ as $h_sc_Map$ };
$h_sc_Map$.prototype = $c_sc_Map$.prototype;
var $d_sc_Map$ = new $TypeData().initClass($c_sc_Map$, "scala.collection.Map$", ({
  sc_Map$: 1,
  sc_MapFactory$Delegate: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_Map$ as $d_sc_Map$ };
var $n_sc_Map$;
function $m_sc_Map$() {
  if ((!$n_sc_Map$)) {
    $n_sc_Map$ = new $c_sc_Map$();
  }
  return $n_sc_Map$;
}
export { $m_sc_Map$ as $m_sc_Map$ };
/** @constructor */
function $c_sc_MapView$() {
  this.sc_MapView$__f_EmptyMapView = null;
  $n_sc_MapView$ = this;
  this.sc_MapView$__f_EmptyMapView = new $c_sc_MapView$$anon$1();
}
export { $c_sc_MapView$ as $c_sc_MapView$ };
$c_sc_MapView$.prototype = new $h_O();
$c_sc_MapView$.prototype.constructor = $c_sc_MapView$;
/** @constructor */
function $h_sc_MapView$() {
}
export { $h_sc_MapView$ as $h_sc_MapView$ };
$h_sc_MapView$.prototype = $c_sc_MapView$.prototype;
$c_sc_MapView$.prototype.newBuilder__scm_Builder = (function() {
  var this$2 = new $c_scm_HashMap$$anon$6(16, 0.75);
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2$2) => new $c_sc_MapView$Id(x$1$2$2)));
  return new $c_scm_Builder$$anon$1(this$2, f);
});
$c_sc_MapView$.prototype.from__sc_MapOps__sc_MapView = (function(it) {
  return ($is_sc_MapView(it) ? it : new $c_sc_MapView$Id(it));
});
$c_sc_MapView$.prototype.apply__sci_Seq__sc_MapView = (function(elems) {
  return this.from__sc_MapOps__sc_MapView($m_sci_Map$().from__sc_IterableOnce__sci_Map(elems));
});
$c_sc_MapView$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_MapView(elems);
});
$c_sc_MapView$.prototype.from__sc_IterableOnce__O = (function(it) {
  return $m_sc_View$().from__sc_IterableOnce__sc_View(it);
});
$c_sc_MapView$.prototype.empty__O = (function() {
  return this.sc_MapView$__f_EmptyMapView;
});
var $d_sc_MapView$ = new $TypeData().initClass($c_sc_MapView$, "scala.collection.MapView$", ({
  sc_MapView$: 1,
  sc_MapViewFactory: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_MapView$ as $d_sc_MapView$ };
var $n_sc_MapView$;
function $m_sc_MapView$() {
  if ((!$n_sc_MapView$)) {
    $n_sc_MapView$ = new $c_sc_MapView$();
  }
  return $n_sc_MapView$;
}
export { $m_sc_MapView$ as $m_sc_MapView$ };
function $ct_sc_SeqFactory$Delegate__sc_SeqFactory__($thiz, delegate) {
  $thiz.sc_SeqFactory$Delegate__f_delegate = delegate;
  return $thiz;
}
export { $ct_sc_SeqFactory$Delegate__sc_SeqFactory__ as $ct_sc_SeqFactory$Delegate__sc_SeqFactory__ };
/** @constructor */
function $c_sc_SeqFactory$Delegate() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
}
export { $c_sc_SeqFactory$Delegate as $c_sc_SeqFactory$Delegate };
$c_sc_SeqFactory$Delegate.prototype = new $h_O();
$c_sc_SeqFactory$Delegate.prototype.constructor = $c_sc_SeqFactory$Delegate;
/** @constructor */
function $h_sc_SeqFactory$Delegate() {
}
export { $h_sc_SeqFactory$Delegate as $h_sc_SeqFactory$Delegate };
$h_sc_SeqFactory$Delegate.prototype = $c_sc_SeqFactory$Delegate.prototype;
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__sc_SeqOps = (function(elems) {
  return this.sc_SeqFactory$Delegate__f_delegate.apply__sci_Seq__O(elems);
});
$c_sc_SeqFactory$Delegate.prototype.empty__sc_SeqOps = (function() {
  return this.sc_SeqFactory$Delegate__f_delegate.empty__O();
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.sc_SeqFactory$Delegate__f_delegate.from__sc_IterableOnce__O(it);
});
$c_sc_SeqFactory$Delegate.prototype.newBuilder__scm_Builder = (function() {
  return this.sc_SeqFactory$Delegate__f_delegate.newBuilder__scm_Builder();
});
$c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sc_SeqOps(source);
});
$c_sc_SeqFactory$Delegate.prototype.empty__O = (function() {
  return this.empty__sc_SeqOps();
});
$c_sc_SeqFactory$Delegate.prototype.apply__sci_Seq__O = (function(elems) {
  return this.apply__sci_Seq__sc_SeqOps(elems);
});
function $f_sc_SeqOps__appended__O__O($thiz, elem) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O($ct_sc_View$Appended__sc_IterableOps__O__(new $c_sc_View$Appended(), $thiz, elem));
}
export { $f_sc_SeqOps__appended__O__O as $f_sc_SeqOps__appended__O__O };
function $f_sc_SeqOps__distinct__O($thiz) {
  return $thiz.distinctBy__F1__O(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => x$2$2)));
}
export { $f_sc_SeqOps__distinct__O as $f_sc_SeqOps__distinct__O };
function $f_sc_SeqOps__distinctBy__F1__O($thiz, f) {
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_View$DistinctBy($thiz, f));
}
export { $f_sc_SeqOps__distinctBy__F1__O as $f_sc_SeqOps__distinctBy__F1__O };
function $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z($thiz, that, offset) {
  var i = $thiz.iterator__sc_Iterator().drop__I__sc_Iterator(offset);
  var j = that.iterator__sc_Iterator();
  while ((j.hasNext__Z() && i.hasNext__Z())) {
    if ((!$m_sr_BoxesRunTime$().equals__O__O__Z(i.next__O(), j.next__O()))) {
      return false;
    }
  }
  return (!j.hasNext__Z());
}
export { $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z as $f_sc_SeqOps__startsWith__sc_IterableOnce__I__Z };
function $f_sc_SeqOps__isDefinedAt__I__Z($thiz, idx) {
  return ((idx >= 0) && ($thiz.lengthCompare__I__I(idx) > 0));
}
export { $f_sc_SeqOps__isDefinedAt__I__Z as $f_sc_SeqOps__isDefinedAt__I__Z };
function $f_sc_SeqOps__indexOf__O__I__I($thiz, elem, from) {
  return $thiz.indexWhere__F1__I__I(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(elem, x$1$2$2))), from);
}
export { $f_sc_SeqOps__indexOf__O__I__I as $f_sc_SeqOps__indexOf__O__I__I };
function $f_sc_SeqOps__contains__O__Z($thiz, elem) {
  return $thiz.exists__F1__Z(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$3$2$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(x$3$2$2, elem))));
}
export { $f_sc_SeqOps__contains__O__Z as $f_sc_SeqOps__contains__O__Z };
function $f_sc_SeqOps__sorted__s_math_Ordering__O($thiz, ord) {
  var len = $thiz.length__I();
  var b = $thiz.newSpecificBuilder__scm_Builder();
  if ((len === 1)) {
    var elem = $thiz.head__O();
    b.addOne__O__scm_Growable(elem);
  } else if ((len > 1)) {
    b.sizeHint__I__V(len);
    var arr = new $ac_O(len);
    $thiz.copyToArray__O__I__I__I(arr, 0, 2147483647);
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, ord);
    var i = 0;
    while ((i < len)) {
      var elem$1 = arr.u[i];
      b.addOne__O__scm_Growable(elem$1);
      i = ((1 + i) | 0);
    }
  }
  return b.result__O();
}
export { $f_sc_SeqOps__sorted__s_math_Ordering__O as $f_sc_SeqOps__sorted__s_math_Ordering__O };
function $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O($thiz, f, ord) {
  return $thiz.sorted__s_math_Ordering__O(new $c_s_math_Ordering$$anon$1(ord, f));
}
export { $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O as $f_sc_SeqOps__sortBy__F1__s_math_Ordering__O };
function $f_sc_SeqOps__isEmpty__Z($thiz) {
  return ($thiz.lengthCompare__I__I(0) === 0);
}
export { $f_sc_SeqOps__isEmpty__Z as $f_sc_SeqOps__isEmpty__Z };
function $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  var thisKnownSize = $thiz.knownSize__I();
  if ((thisKnownSize !== (-1))) {
    var thatKnownSize = that.knownSize__I();
    if ((thatKnownSize !== (-1))) {
      if ((thisKnownSize !== thatKnownSize)) {
        return false;
      }
      if ((thisKnownSize === 0)) {
        return true;
      }
    }
  }
  return $f_sc_Iterator__sameElements__sc_IterableOnce__Z($thiz.iterator__sc_Iterator(), that);
}
export { $f_sc_SeqOps__sameElements__sc_IterableOnce__Z as $f_sc_SeqOps__sameElements__sc_IterableOnce__Z };
function $f_sc_SeqOps__diff__sc_Seq__O($thiz, that) {
  var occ = $f_sc_SeqOps__occCounts__sc_Seq__scm_Map($thiz, that);
  var this$2 = $thiz.iterator__sc_Iterator();
  var p = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => {
    var include = new $c_sr_BooleanRef(false);
    occ.updateWith__O__F1__s_Option(x$2$2, new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x0$1$2$2) => {
      var rc8 = false;
      var x3 = null;
      var x = $m_s_None$();
      if ((x === x0$1$2$2)) {
        include.sr_BooleanRef__f_elem = true;
        return $m_s_None$();
      }
      if ((x0$1$2$2 instanceof $c_s_Some)) {
        rc8 = true;
        x3 = x0$1$2$2;
        var p4 = (x3.s_Some__f_value | 0);
        if ((p4 === 1)) {
          return $m_s_None$();
        }
      }
      if (rc8) {
        var n = (x3.s_Some__f_value | 0);
        return new $c_s_Some((((-1) + n) | 0));
      }
      throw new $c_s_MatchError(x0$1$2$2);
    })));
    return include.sr_BooleanRef__f_elem;
  }));
  return $thiz.fromSpecific__sc_IterableOnce__O(new $c_sc_Iterator$$anon$6(this$2, p, false));
}
export { $f_sc_SeqOps__diff__sc_Seq__O as $f_sc_SeqOps__diff__sc_Seq__O };
function $f_sc_SeqOps__updated__I__O__O($thiz, index, elem) {
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
  var k = $thiz.knownSize__I();
  if (((k >= 0) && (index >= k))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(new $c_sc_View$Updated($thiz, index, elem));
}
export { $f_sc_SeqOps__updated__I__O__O as $f_sc_SeqOps__updated__I__O__O };
function $f_sc_SeqOps__occCounts__sc_Seq__scm_Map($thiz, sq) {
  var occ = $ct_scm_HashMap__(new $c_scm_HashMap());
  sq.foreach__F1__V(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((y$2$2) => {
    var originalHash = $m_sr_Statics$().anyHash__O__I(y$2$2);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var indexedHash = (hash & (((-1) + occ.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
    var elem = null;
    elem = null;
    var elem$1 = null;
    elem$1 = null;
    var x1 = occ.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[indexedHash];
    if ((x1 !== null)) {
      var prev = null;
      var nd = x1;
      while (true) {
        if (((hash === nd.scm_HashMap$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(y$2$2, nd.scm_HashMap$Node__f__key))) {
          elem$1 = prev;
          elem = nd;
        } else if ((!((nd.scm_HashMap$Node__f__next === null) || (nd.scm_HashMap$Node__f__hash > hash)))) {
          var temp$prev = nd;
          var temp$nd = nd.scm_HashMap$Node__f__next;
          prev = temp$prev;
          nd = temp$nd;
          continue;
        }
        break;
      }
    }
    var x1$2 = elem;
    var previousValue = ((x1$2 === null) ? $m_s_None$() : new $c_s_Some(x1$2.scm_HashMap$Node__f__value));
    var x = $m_s_None$();
    if ((x === previousValue)) {
      var nextValue = new $c_s_Some(1);
    } else {
      if ((!(previousValue instanceof $c_s_Some))) {
        throw new $c_s_MatchError(previousValue);
      }
      var n = (previousValue.s_Some__f_value | 0);
      var nextValue = new $c_s_Some(((1 + n) | 0));
    }
    var x1$3 = $ct_T2__O__O__(new $c_T2(), previousValue, nextValue);
    matchEnd21: {
      var p2 = x1$3.T2__f__1;
      var p3 = x1$3.T2__f__2;
      var x$3 = $m_s_None$();
      if ((x$3 === p2)) {
        var x$5 = $m_s_None$();
        var $x_1 = (x$5 === p3);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        break matchEnd21;
      }
      var p6 = x1$3.T2__f__1;
      var p7 = x1$3.T2__f__2;
      if ((p6 instanceof $c_s_Some)) {
        var x$7 = $m_s_None$();
        var $x_2 = (x$7 === p7);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        if ((elem$1 !== null)) {
          elem$1.scm_HashMap$Node__f__next = elem.scm_HashMap$Node__f__next;
        } else {
          occ.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[indexedHash] = elem.scm_HashMap$Node__f__next;
        }
        occ.scm_HashMap__f_contentSize = (((-1) + occ.scm_HashMap__f_contentSize) | 0);
        break matchEnd21;
      }
      var p11 = x1$3.T2__f__1;
      var p12 = x1$3.T2__f__2;
      var x$9 = $m_s_None$();
      if (((x$9 === p11) && (p12 instanceof $c_s_Some))) {
        var value = p12.s_Some__f_value;
        var newIndexedHash = ((((1 + occ.scm_HashMap__f_contentSize) | 0) >= occ.scm_HashMap__f_threshold) ? ($p_scm_HashMap__growTable__I__V(occ, (occ.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1)), (hash & (((-1) + occ.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0))) : indexedHash);
        $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(occ, y$2$2, value, false, hash, newIndexedHash);
        break matchEnd21;
      }
      var p15 = x1$3.T2__f__1;
      var p16 = x1$3.T2__f__2;
      if (((p15 instanceof $c_s_Some) && (p16 instanceof $c_s_Some))) {
        var newValue = p16.s_Some__f_value;
        elem.scm_HashMap$Node__f__value = newValue;
        break matchEnd21;
      }
      throw new $c_s_MatchError(x1$3);
    }
    return nextValue;
  })));
  return occ;
}
export { $f_sc_SeqOps__occCounts__sc_Seq__scm_Map as $f_sc_SeqOps__occCounts__sc_Seq__scm_Map };
/** @constructor */
function $c_sc_Set$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_Set$());
}
export { $c_sc_Set$ as $c_sc_Set$ };
$c_sc_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sc_Set$.prototype.constructor = $c_sc_Set$;
/** @constructor */
function $h_sc_Set$() {
}
export { $h_sc_Set$ as $h_sc_Set$ };
$h_sc_Set$.prototype = $c_sc_Set$.prototype;
var $d_sc_Set$ = new $TypeData().initClass($c_sc_Set$, "scala.collection.Set$", ({
  sc_Set$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_Set$ as $d_sc_Set$ };
var $n_sc_Set$;
function $m_sc_Set$() {
  if ((!$n_sc_Set$)) {
    $n_sc_Set$ = new $c_sc_Set$();
  }
  return $n_sc_Set$;
}
export { $m_sc_Set$ as $m_sc_Set$ };
function $f_sc_StrictOptimizedIterableOps__partition__F1__T2($thiz, p) {
  var l = $thiz.newSpecificBuilder__scm_Builder();
  var r = $thiz.newSpecificBuilder__scm_Builder();
  var this$1 = $thiz.iterator__sc_Iterator();
  while (this$1.hasNext__Z()) {
    var x0 = this$1.next__O();
    var this$2 = ((!(!p.apply__O__O(x0))) ? l : r);
    this$2.addOne__O__scm_Growable(x0);
  }
  return $ct_T2__O__O__(new $c_T2(), l.result__O(), r.result__O());
}
export { $f_sc_StrictOptimizedIterableOps__partition__F1__T2 as $f_sc_StrictOptimizedIterableOps__partition__F1__T2 };
function $f_sc_StrictOptimizedIterableOps__map__F1__O($thiz, f) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = f.apply__O__O(it.next__O());
    b.addOne__O__scm_Growable(elem);
  }
  return b.result__O();
}
export { $f_sc_StrictOptimizedIterableOps__map__F1__O as $f_sc_StrictOptimizedIterableOps__map__F1__O };
function $f_sc_StrictOptimizedIterableOps__flatMap__F1__O($thiz, f) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elems = f.apply__O__O(it.next__O());
    b.addAll__sc_IterableOnce__scm_Growable(elems);
  }
  return b.result__O();
}
export { $f_sc_StrictOptimizedIterableOps__flatMap__F1__O as $f_sc_StrictOptimizedIterableOps__flatMap__F1__O };
function $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O($thiz, pf) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var v = pf.applyOrElse__O__F1__O(elem, new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((marker) => ((x$2$2) => marker))(marker)));
    if ((marker !== v)) {
      b.addOne__O__scm_Growable(v);
    }
  }
  return b.result__O();
}
export { $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O as $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O };
function $f_sc_StrictOptimizedIterableOps__flatten__F1__O($thiz, toIterableOnce) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elems = toIterableOnce.apply__O__O(it.next__O());
    b.addAll__sc_IterableOnce__scm_Growable(elems);
  }
  return b.result__O();
}
export { $f_sc_StrictOptimizedIterableOps__flatten__F1__O as $f_sc_StrictOptimizedIterableOps__flatten__F1__O };
function $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O($thiz, that) {
  var b = $thiz.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
  var it1 = $thiz.iterator__sc_Iterator();
  var it2 = that.iterator__sc_Iterator();
  while ((it1.hasNext__Z() && it2.hasNext__Z())) {
    var elem = $ct_T2__O__O__(new $c_T2(), it1.next__O(), it2.next__O());
    b.addOne__O__scm_Growable(elem);
  }
  return b.result__O();
}
export { $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O as $f_sc_StrictOptimizedIterableOps__zip__sc_IterableOnce__O };
function $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O($thiz, pred, isFlipped) {
  var b = $thiz.newSpecificBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    if (((!(!pred.apply__O__O(elem))) !== isFlipped)) {
      b.addOne__O__scm_Growable(elem);
    }
  }
  return b.result__O();
}
export { $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O as $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O };
function $f_sc_StrictOptimizedIterableOps__dropRight__I__O($thiz, n) {
  var b = $thiz.newSpecificBuilder__scm_Builder();
  if ((n >= 0)) {
    $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, $thiz, ((-n) | 0));
  }
  var lead = $thiz.iterator__sc_Iterator().drop__I__sc_Iterator(n);
  var it = $thiz.iterator__sc_Iterator();
  while (lead.hasNext__Z()) {
    var elem = it.next__O();
    b.addOne__O__scm_Growable(elem);
    lead.next__O();
  }
  return b.result__O();
}
export { $f_sc_StrictOptimizedIterableOps__dropRight__I__O as $f_sc_StrictOptimizedIterableOps__dropRight__I__O };
function $isArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$IteratorWrapper)));
}
export { $isArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper as $isArrayOf_sc_convert_JavaCollectionWrappers$IteratorWrapper };
/** @constructor */
function $c_sci_HashMap$accum$1(outer) {
  this.sci_HashMap$accum$1__f_changed = false;
  this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = 0;
  this.sci_HashMap$accum$1__f_current = null;
  this.sci_HashMap$accum$1__f_$outer = null;
  this.sci_HashMap$accum$1__f_$outer = outer;
  this.sci_HashMap$accum$1__f_changed = false;
  this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = 0;
  this.sci_HashMap$accum$1__f_current = outer.sci_HashMap__f_rootNode;
}
export { $c_sci_HashMap$accum$1 as $c_sci_HashMap$accum$1 };
$c_sci_HashMap$accum$1.prototype = new $h_sr_AbstractFunction2();
$c_sci_HashMap$accum$1.prototype.constructor = $c_sci_HashMap$accum$1;
/** @constructor */
function $h_sci_HashMap$accum$1() {
}
export { $h_sci_HashMap$accum$1 as $h_sci_HashMap$accum$1 };
$h_sci_HashMap$accum$1.prototype = $c_sci_HashMap$accum$1.prototype;
$c_sci_HashMap$accum$1.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (this.apply__O__O__V(v1._1__O(), v1._2__O()), (void 0));
});
$c_sci_HashMap$accum$1.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sci_HashMap$accum$1.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sci_HashMap$accum$1.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sci_HashMap$accum$1.prototype.apply__O__O__V = (function(key, value) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var improved = $m_sc_Hashing$().improve__I__I(originalHash);
  if ((!this.sci_HashMap$accum$1__f_changed)) {
    this.sci_HashMap$accum$1__f_current = this.sci_HashMap$accum$1__f_current.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, originalHash, improved, 0, true);
    if ((this.sci_HashMap$accum$1__f_current !== this.sci_HashMap$accum$1__f_$outer.sci_HashMap__f_rootNode)) {
      this.sci_HashMap$accum$1__f_changed = true;
      this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
    }
  } else {
    this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap = this.sci_HashMap$accum$1__f_current.updateWithShallowMutations__O__O__I__I__I__I__I(key, value, originalHash, improved, 0, this.sci_HashMap$accum$1__f_shallowlyMutableNodeMap);
  }
});
$c_sci_HashMap$accum$1.prototype.apply__O__O__O = (function(v1, v2) {
  this.apply__O__O__V(v1, v2);
});
$c_sci_HashMap$accum$1.prototype.apply__O__O = (function(v1) {
  this.apply__O__O__V(v1._1__O(), v1._2__O());
});
var $d_sci_HashMap$accum$1 = new $TypeData().initClass($c_sci_HashMap$accum$1, "scala.collection.immutable.HashMap$accum$1", ({
  sci_HashMap$accum$1: 1,
  sr_AbstractFunction2: 1,
  F2: 1,
  F1: 1
}));
export { $d_sci_HashMap$accum$1 as $d_sci_HashMap$accum$1 };
/** @constructor */
function $c_sci_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_sci_List$());
}
export { $c_sci_Iterable$ as $c_sci_Iterable$ };
$c_sci_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_sci_Iterable$.prototype.constructor = $c_sci_Iterable$;
/** @constructor */
function $h_sci_Iterable$() {
}
export { $h_sci_Iterable$ as $h_sci_Iterable$ };
$h_sci_Iterable$.prototype = $c_sci_Iterable$.prototype;
$c_sci_Iterable$.prototype.from__sc_IterableOnce__sci_Iterable = (function(it) {
  return ($is_sci_Iterable(it) ? it : $c_sc_IterableFactory$Delegate.prototype.from__sc_IterableOnce__O.call(this, it));
});
$c_sci_Iterable$.prototype.from__sc_IterableOnce__O = (function(it) {
  return this.from__sc_IterableOnce__sci_Iterable(it);
});
var $d_sci_Iterable$ = new $TypeData().initClass($c_sci_Iterable$, "scala.collection.immutable.Iterable$", ({
  sci_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Iterable$ as $d_sci_Iterable$ };
var $n_sci_Iterable$;
function $m_sci_Iterable$() {
  if ((!$n_sci_Iterable$)) {
    $n_sci_Iterable$ = new $c_sci_Iterable$();
  }
  return $n_sci_Iterable$;
}
export { $m_sci_Iterable$ as $m_sci_Iterable$ };
/** @constructor */
function $c_sci_LazyList$() {
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty = null;
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = null;
  $n_sci_LazyList$ = this;
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty = $ct_sci_LazyList__O__(new $c_sci_LazyList(), $m_sci_LazyList$EmptyMarker$());
  this.sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$10$2$2) => $m_sr_Statics$PFMarker$()));
}
export { $c_sci_LazyList$ as $c_sci_LazyList$ };
$c_sci_LazyList$.prototype = new $h_O();
$c_sci_LazyList$.prototype.constructor = $c_sci_LazyList$;
/** @constructor */
function $h_sci_LazyList$() {
}
export { $h_sci_LazyList$ as $h_sci_LazyList$ };
$h_sci_LazyList$.prototype = $c_sci_LazyList$.prototype;
$c_sci_LazyList$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_LazyList(elems);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList = (function(ll, p, isFlipped) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var elem = null;
    var found = false;
    var rest = restRef.sr_ObjectRef__f_elem;
    while (true) {
      if ((!found)) {
        var this$2 = rest;
        var $x_1 = (!(this$2.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        elem = rest.head__O();
        found = ((!(!p.apply__O__O(elem))) !== isFlipped);
        rest = rest.tail__sci_LazyList();
        restRef.sr_ObjectRef__f_elem = rest;
      } else {
        break;
      }
    }
    if (found) {
      $m_sci_LazyList$();
      var hd = elem;
      var tl = $m_sci_LazyList$().scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList(rest, p, isFlipped);
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
    } else {
      return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
    }
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList = (function(ll, f) {
  var restRef = new $c_sr_ObjectRef(ll);
  var state$1 = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var it = new $c_sr_ObjectRef(null);
    var itHasNext = false;
    var elem = restRef.sr_ObjectRef__f_elem;
    var rest = new $c_sr_ObjectRef(elem);
    while (true) {
      if ((!itHasNext)) {
        var this$4 = rest.sr_ObjectRef__f_elem;
        var $x_1 = (!(this$4.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        it.sr_ObjectRef__f_elem = f.apply__O__O(rest.sr_ObjectRef__f_elem.head__O()).iterator__sc_Iterator();
        itHasNext = it.sr_ObjectRef__f_elem.hasNext__Z();
        if ((!itHasNext)) {
          rest.sr_ObjectRef__f_elem = rest.sr_ObjectRef__f_elem.tail__sci_LazyList();
          restRef.sr_ObjectRef__f_elem = rest.sr_ObjectRef__f_elem;
        }
      } else {
        break;
      }
    }
    if (itHasNext) {
      var head = it.sr_ObjectRef__f_elem.next__O();
      rest.sr_ObjectRef__f_elem = rest.sr_ObjectRef__f_elem.tail__sci_LazyList();
      restRef.sr_ObjectRef__f_elem = rest.sr_ObjectRef__f_elem;
      $m_sci_LazyList$();
      $m_sci_LazyList$();
      var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadPrependIterator__sc_Iterator__F0__sci_LazyList(it.sr_ObjectRef__f_elem, new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList(rest.sr_ObjectRef__f_elem, f))))));
      var tl = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), head, tl);
    } else {
      return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
    }
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state$1);
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList = (function(ll, n) {
  var restRef = new $c_sr_ObjectRef(ll);
  var iRef = new $c_sr_IntRef(n);
  var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    var rest = restRef.sr_ObjectRef__f_elem;
    var i = iRef.sr_IntRef__f_elem;
    while (true) {
      if ((i > 0)) {
        var this$3 = rest;
        var $x_1 = (!(this$3.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        rest = rest.tail__sci_LazyList();
        restRef.sr_ObjectRef__f_elem = rest;
        i = (((-1) + i) | 0);
        iRef.sr_IntRef__f_elem = i;
      } else {
        break;
      }
    }
    return rest;
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__sci_LazyList = (function(coll) {
  if ((coll instanceof $c_sci_LazyList)) {
    return coll;
  } else if ((coll.knownSize__I() === 0)) {
    return this.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  } else {
    var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadFromIterator__sc_Iterator__sci_LazyList(coll.iterator__sc_Iterator())));
    return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$eagerHeadPrependIterator__sc_Iterator__F0__sci_LazyList = (function(it, suffix) {
  if (it.hasNext__Z()) {
    var hd = it.next__O();
    var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadPrependIterator__sc_Iterator__F0__sci_LazyList(it, suffix)));
    var tl = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
  } else {
    return suffix.apply__O();
  }
});
$c_sci_LazyList$.prototype.scala$collection$immutable$LazyList$$eagerHeadFromIterator__sc_Iterator__sci_LazyList = (function(it) {
  if (it.hasNext__Z()) {
    var hd = it.next__O();
    var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadFromIterator__sc_Iterator__sci_LazyList(it)));
    var tl = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
  } else {
    return this.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  }
});
$c_sci_LazyList$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_LazyList$LazyBuilder();
});
$c_sci_LazyList$.prototype.empty__O = (function() {
  return this.sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
});
$c_sci_LazyList$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_LazyList(source);
});
var $d_sci_LazyList$ = new $TypeData().initClass($c_sci_LazyList$, "scala.collection.immutable.LazyList$", ({
  sci_LazyList$: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_LazyList$ as $d_sci_LazyList$ };
var $n_sci_LazyList$;
function $m_sci_LazyList$() {
  if ((!$n_sci_LazyList$)) {
    $n_sci_LazyList$ = new $c_sci_LazyList$();
  }
  return $n_sci_LazyList$;
}
export { $m_sci_LazyList$ as $m_sci_LazyList$ };
/** @constructor */
function $c_sci_Stream$() {
}
export { $c_sci_Stream$ as $c_sci_Stream$ };
$c_sci_Stream$.prototype = new $h_O();
$c_sci_Stream$.prototype.constructor = $c_sci_Stream$;
/** @constructor */
function $h_sci_Stream$() {
}
export { $h_sci_Stream$ as $h_sci_Stream$ };
$h_sci_Stream$.prototype = $c_sci_Stream$.prototype;
$c_sci_Stream$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Stream(elems);
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__sci_Stream = (function(coll) {
  return ((coll instanceof $c_sci_Stream) ? coll : this.fromIterator__sc_Iterator__sci_Stream(coll.iterator__sc_Iterator()));
});
$c_sci_Stream$.prototype.fromIterator__sc_Iterator__sci_Stream = (function(it) {
  return (it.hasNext__Z() ? new $c_sci_Stream$Cons(it.next__O(), new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_sci_Stream$().fromIterator__sc_Iterator__sci_Stream(it)))) : $m_sci_Stream$Empty$());
});
$c_sci_Stream$.prototype.newBuilder__scm_Builder = (function() {
  $m_scm_ArrayBuffer$();
  var this$2 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((array$2$2) => $m_sci_Stream$().from__sc_IterableOnce__sci_Stream(array$2$2)));
  return new $c_scm_Builder$$anon$1(this$2, f);
});
$c_sci_Stream$.prototype.filteredTail__sci_Stream__F1__Z__sci_Stream = (function(stream, p, isFlipped) {
  var hd = stream.head__O();
  var tl = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => stream.tail__O().filterImpl__F1__Z__sci_Stream(p, isFlipped)));
  return new $c_sci_Stream$Cons(hd, tl);
});
$c_sci_Stream$.prototype.empty__O = (function() {
  return $m_sci_Stream$Empty$();
});
$c_sci_Stream$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Stream(source);
});
var $d_sci_Stream$ = new $TypeData().initClass($c_sci_Stream$, "scala.collection.immutable.Stream$", ({
  sci_Stream$: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Stream$ as $d_sci_Stream$ };
var $n_sci_Stream$;
function $m_sci_Stream$() {
  if ((!$n_sci_Stream$)) {
    $n_sci_Stream$ = new $c_sci_Stream$();
  }
  return $n_sci_Stream$;
}
export { $m_sci_Stream$ as $m_sci_Stream$ };
/** @constructor */
function $c_sci_WrappedString$() {
}
export { $c_sci_WrappedString$ as $c_sci_WrappedString$ };
$c_sci_WrappedString$.prototype = new $h_O();
$c_sci_WrappedString$.prototype.constructor = $c_sci_WrappedString$;
/** @constructor */
function $h_sci_WrappedString$() {
}
export { $h_sci_WrappedString$ as $h_sci_WrappedString$ };
$h_sci_WrappedString$.prototype = $c_sci_WrappedString$.prototype;
$c_sci_WrappedString$.prototype.fromSpecific__sc_IterableOnce__sci_WrappedString = (function(it) {
  var b = this.newBuilder__scm_Builder();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, it, 0);
  b.addAll__sc_IterableOnce__scm_Growable(it);
  return b.result__O();
});
$c_sci_WrappedString$.prototype.newBuilder__scm_Builder = (function() {
  var this$1 = $ct_scm_StringBuilder__(new $c_scm_StringBuilder());
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => new $c_sci_WrappedString(x$2$2)));
  return new $c_scm_Builder$$anon$1(this$1, f);
});
var $d_sci_WrappedString$ = new $TypeData().initClass($c_sci_WrappedString$, "scala.collection.immutable.WrappedString$", ({
  sci_WrappedString$: 1,
  sc_SpecificIterableFactory: 1,
  sc_Factory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_WrappedString$ as $d_sci_WrappedString$ };
var $n_sci_WrappedString$;
function $m_sci_WrappedString$() {
  if ((!$n_sci_WrappedString$)) {
    $n_sci_WrappedString$ = new $c_sci_WrappedString$();
  }
  return $n_sci_WrappedString$;
}
export { $m_sci_WrappedString$ as $m_sci_WrappedString$ };
/** @constructor */
function $c_scm_Builder$$anon$1(outer, f$1) {
  this.scm_Builder$$anon$1__f_$outer = null;
  this.scm_Builder$$anon$1__f_f$1 = null;
  this.scm_Builder$$anon$1__f_$outer = outer;
  this.scm_Builder$$anon$1__f_f$1 = f$1;
}
export { $c_scm_Builder$$anon$1 as $c_scm_Builder$$anon$1 };
$c_scm_Builder$$anon$1.prototype = new $h_O();
$c_scm_Builder$$anon$1.prototype.constructor = $c_scm_Builder$$anon$1;
/** @constructor */
function $h_scm_Builder$$anon$1() {
}
export { $h_scm_Builder$$anon$1 as $h_scm_Builder$$anon$1 };
$h_scm_Builder$$anon$1.prototype = $c_scm_Builder$$anon$1.prototype;
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Builder$$anon$1 = (function(x) {
  var this$1 = this.scm_Builder$$anon$1__f_$outer;
  this$1.addOne__O__scm_Growable(x);
  return this;
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Builder$$anon$1 = (function(xs) {
  var this$1 = this.scm_Builder$$anon$1__f_$outer;
  this$1.addAll__sc_IterableOnce__scm_Growable(xs);
  return this;
});
$c_scm_Builder$$anon$1.prototype.sizeHint__I__V = (function(size) {
  this.scm_Builder$$anon$1__f_$outer.sizeHint__I__V(size);
});
$c_scm_Builder$$anon$1.prototype.result__O = (function() {
  return this.scm_Builder$$anon$1__f_f$1.apply__O__O(this.scm_Builder$$anon$1__f_$outer.result__O());
});
$c_scm_Builder$$anon$1.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_Builder$$anon$1(elems);
});
$c_scm_Builder$$anon$1.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_Builder$$anon$1(elem);
});
var $d_scm_Builder$$anon$1 = new $TypeData().initClass($c_scm_Builder$$anon$1, "scala.collection.mutable.Builder$$anon$1", ({
  scm_Builder$$anon$1: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_scm_Builder$$anon$1 as $d_scm_Builder$$anon$1 };
function $ct_scm_GrowableBuilder__scm_Growable__($thiz, elems) {
  $thiz.scm_GrowableBuilder__f_elems = elems;
  return $thiz;
}
export { $ct_scm_GrowableBuilder__scm_Growable__ as $ct_scm_GrowableBuilder__scm_Growable__ };
/** @constructor */
function $c_scm_GrowableBuilder() {
  this.scm_GrowableBuilder__f_elems = null;
}
export { $c_scm_GrowableBuilder as $c_scm_GrowableBuilder };
$c_scm_GrowableBuilder.prototype = new $h_O();
$c_scm_GrowableBuilder.prototype.constructor = $c_scm_GrowableBuilder;
/** @constructor */
function $h_scm_GrowableBuilder() {
}
export { $h_scm_GrowableBuilder as $h_scm_GrowableBuilder };
$h_scm_GrowableBuilder.prototype = $c_scm_GrowableBuilder.prototype;
$c_scm_GrowableBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_GrowableBuilder = (function(elem) {
  var this$1 = this.scm_GrowableBuilder__f_elems;
  this$1.addOne__O__scm_Growable(elem);
  return this;
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_GrowableBuilder = (function(xs) {
  this.scm_GrowableBuilder__f_elems.addAll__sc_IterableOnce__scm_Growable(xs);
  return this;
});
$c_scm_GrowableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_GrowableBuilder(elems);
});
$c_scm_GrowableBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_GrowableBuilder(elem);
});
$c_scm_GrowableBuilder.prototype.result__O = (function() {
  return this.scm_GrowableBuilder__f_elems;
});
var $d_scm_GrowableBuilder = new $TypeData().initClass($c_scm_GrowableBuilder, "scala.collection.mutable.GrowableBuilder", ({
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_scm_GrowableBuilder as $d_scm_GrowableBuilder };
/** @constructor */
function $c_scm_Iterable$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_ArrayBuffer$());
}
export { $c_scm_Iterable$ as $c_scm_Iterable$ };
$c_scm_Iterable$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Iterable$.prototype.constructor = $c_scm_Iterable$;
/** @constructor */
function $h_scm_Iterable$() {
}
export { $h_scm_Iterable$ as $h_scm_Iterable$ };
$h_scm_Iterable$.prototype = $c_scm_Iterable$.prototype;
var $d_scm_Iterable$ = new $TypeData().initClass($c_scm_Iterable$, "scala.collection.mutable.Iterable$", ({
  scm_Iterable$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_Iterable$ as $d_scm_Iterable$ };
var $n_scm_Iterable$;
function $m_scm_Iterable$() {
  if ((!$n_scm_Iterable$)) {
    $n_scm_Iterable$ = new $c_scm_Iterable$();
  }
  return $n_scm_Iterable$;
}
export { $m_scm_Iterable$ as $m_scm_Iterable$ };
/** @constructor */
function $c_scm_Map$() {
  this.sc_MapFactory$Delegate__f_delegate = null;
  $ct_sc_MapFactory$Delegate__sc_MapFactory__(this, $m_scm_HashMap$());
}
export { $c_scm_Map$ as $c_scm_Map$ };
$c_scm_Map$.prototype = new $h_sc_MapFactory$Delegate();
$c_scm_Map$.prototype.constructor = $c_scm_Map$;
/** @constructor */
function $h_scm_Map$() {
}
export { $h_scm_Map$ as $h_scm_Map$ };
$h_scm_Map$.prototype = $c_scm_Map$.prototype;
var $d_scm_Map$ = new $TypeData().initClass($c_scm_Map$, "scala.collection.mutable.Map$", ({
  scm_Map$: 1,
  sc_MapFactory$Delegate: 1,
  sc_MapFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_Map$ as $d_scm_Map$ };
var $n_scm_Map$;
function $m_scm_Map$() {
  if ((!$n_scm_Map$)) {
    $n_scm_Map$ = new $c_scm_Map$();
  }
  return $n_scm_Map$;
}
export { $m_scm_Map$ as $m_scm_Map$ };
/** @constructor */
function $c_scm_Set$() {
  this.sc_IterableFactory$Delegate__f_delegate = null;
  $ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $m_scm_HashSet$());
}
export { $c_scm_Set$ as $c_scm_Set$ };
$c_scm_Set$.prototype = new $h_sc_IterableFactory$Delegate();
$c_scm_Set$.prototype.constructor = $c_scm_Set$;
/** @constructor */
function $h_scm_Set$() {
}
export { $h_scm_Set$ as $h_scm_Set$ };
$h_scm_Set$.prototype = $c_scm_Set$.prototype;
var $d_scm_Set$ = new $TypeData().initClass($c_scm_Set$, "scala.collection.mutable.Set$", ({
  scm_Set$: 1,
  sc_IterableFactory$Delegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_Set$ as $d_scm_Set$ };
var $n_scm_Set$;
function $m_scm_Set$() {
  if ((!$n_scm_Set$)) {
    $n_scm_Set$ = new $c_scm_Set$();
  }
  return $n_scm_Set$;
}
export { $m_scm_Set$ as $m_scm_Set$ };
/** @constructor */
function $c_s_concurrent_duration_Duration() {
}
export { $c_s_concurrent_duration_Duration as $c_s_concurrent_duration_Duration };
$c_s_concurrent_duration_Duration.prototype = new $h_O();
$c_s_concurrent_duration_Duration.prototype.constructor = $c_s_concurrent_duration_Duration;
/** @constructor */
function $h_s_concurrent_duration_Duration() {
}
export { $h_s_concurrent_duration_Duration as $h_s_concurrent_duration_Duration };
$h_s_concurrent_duration_Duration.prototype = $c_s_concurrent_duration_Duration.prototype;
$c_s_concurrent_duration_Duration.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I(that);
});
function $f_sr_EnumValue__productElement__I__O($thiz, n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
}
export { $f_sr_EnumValue__productElement__I__O as $f_sr_EnumValue__productElement__I__O };
function $f_sr_EnumValue__productElementName__I__T($thiz, n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
}
export { $f_sr_EnumValue__productElementName__I__T as $f_sr_EnumValue__productElementName__I__T };
class $c_sr_NonLocalReturnControl extends $c_s_util_control_ControlThrowable {
  constructor(key, value) {
    super();
    this.sr_NonLocalReturnControl__f_key = null;
    this.sr_NonLocalReturnControl__f_value = null;
    this.sr_NonLocalReturnControl__f_key = key;
    this.sr_NonLocalReturnControl__f_value = value;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, false, false);
  }
  fillInStackTrace__jl_Throwable() {
    return this;
  }
}
export { $c_sr_NonLocalReturnControl as $c_sr_NonLocalReturnControl };
function $isArrayOf_sr_NonLocalReturnControl(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_NonLocalReturnControl)));
}
export { $isArrayOf_sr_NonLocalReturnControl as $isArrayOf_sr_NonLocalReturnControl };
var $d_sr_NonLocalReturnControl = new $TypeData().initClass($c_sr_NonLocalReturnControl, "scala.runtime.NonLocalReturnControl", ({
  sr_NonLocalReturnControl: 1,
  s_util_control_ControlThrowable: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sr_NonLocalReturnControl as $d_sr_NonLocalReturnControl };
/** @constructor */
function $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(f) {
  this.sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1__f_f = null;
  this.sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1__f_f = f;
}
export { $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1 as $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1 };
$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1.prototype = new $h_sjsr_AnonFunction0();
$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1.prototype.constructor = $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1;
/** @constructor */
function $h_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1() {
}
export { $h_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1 as $h_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1 };
$h_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1.prototype = $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1.prototype;
$c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1.prototype.apply__O = (function() {
  return (0, this.sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1__f_f)();
});
var $d_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1 = new $TypeData().initClass($c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1, "scala.scalajs.runtime.AnonFunction0.$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1", ({
  sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1: 1,
  sjsr_AnonFunction0: 1,
  sr_AbstractFunction0: 1,
  F0: 1
}));
export { $d_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1 as $d_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1 };
/** @constructor */
function $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(f) {
  this.sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab__f_f = null;
  this.sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab__f_f = f;
}
export { $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab as $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab };
$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab.prototype = new $h_sjsr_AnonFunction1();
$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab.prototype.constructor = $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab;
/** @constructor */
function $h_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab() {
}
export { $h_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab as $h_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab };
$h_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab.prototype = $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab.prototype;
$c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab.prototype.apply__O__O = (function(x0) {
  return (0, this.sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab__f_f)(x0);
});
var $d_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab = new $TypeData().initClass($c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab, "scala.scalajs.runtime.AnonFunction1.$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab", ({
  sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab: 1,
  sjsr_AnonFunction1: 1,
  sr_AbstractFunction1: 1,
  F1: 1
}));
export { $d_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab as $d_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab };
/** @constructor */
function $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(f) {
  this.sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2__f_f = null;
  this.sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2__f_f = f;
}
export { $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2 as $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2 };
$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2.prototype = new $h_sjsr_AnonFunction2();
$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2.prototype.constructor = $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2;
/** @constructor */
function $h_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2() {
}
export { $h_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2 as $h_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2 };
$h_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2.prototype = $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2.prototype;
$c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2.prototype.apply__O__O__O = (function(x0, x1) {
  return (0, this.sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2__f_f)(x0, x1);
});
var $d_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2 = new $TypeData().initClass($c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2, "scala.scalajs.runtime.AnonFunction2.$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2", ({
  sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2: 1,
  sjsr_AnonFunction2: 1,
  sr_AbstractFunction2: 1,
  F2: 1
}));
export { $d_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2 as $d_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2 };
/** @constructor */
function $c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491(f) {
  this.sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491__f_f = null;
  this.sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491__f_f = f;
}
export { $c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491 as $c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491 };
$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491.prototype = new $h_sjsr_AnonFunction3();
$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491.prototype.constructor = $c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491;
/** @constructor */
function $h_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491() {
}
export { $h_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491 as $h_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491 };
$h_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491.prototype = $c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491.prototype;
$c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491.prototype.apply__O__O__O__O = (function(x0, x1, x2) {
  return (0, this.sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491__f_f)(x0, x1, x2);
});
var $d_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491 = new $TypeData().initClass($c_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491, "scala.scalajs.runtime.AnonFunction3.$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491", ({
  sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491: 1,
  sjsr_AnonFunction3: 1,
  sr_AbstractFunction3: 1,
  F3: 1
}));
export { $d_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491 as $d_sjsr_AnonFunction3_$$Lambda$0321b7865d991d5a3e10ec941cd6461a4b204491 };
/** @constructor */
function $c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b(f) {
  this.sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b__f_f = null;
  this.sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b__f_f = f;
}
export { $c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b as $c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b };
$c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b.prototype = new $h_sjsr_AnonFunction4();
$c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b.prototype.constructor = $c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b;
/** @constructor */
function $h_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b() {
}
export { $h_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b as $h_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b };
$h_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b.prototype = $c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b.prototype;
$c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b.prototype.apply__O__O__O__O__O = (function(x0, x1, x2, x3) {
  return (0, this.sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b__f_f)(x0, x1, x2, x3);
});
var $d_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b = new $TypeData().initClass($c_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b, "scala.scalajs.runtime.AnonFunction4.$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b", ({
  sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b: 1,
  sjsr_AnonFunction4: 1,
  sr_AbstractFunction4: 1,
  F4: 1
}));
export { $d_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b as $d_sjsr_AnonFunction4_$$Lambda$06f9c6daa9fb22f000f9d0ee75fdbad9d7687b0b };
/** @constructor */
function $c_s_util_Either() {
}
export { $c_s_util_Either as $c_s_util_Either };
$c_s_util_Either.prototype = new $h_O();
$c_s_util_Either.prototype.constructor = $c_s_util_Either;
/** @constructor */
function $h_s_util_Either() {
}
export { $h_s_util_Either as $h_s_util_Either };
$h_s_util_Either.prototype = $c_s_util_Either.prototype;
$c_s_util_Either.prototype.fold__F1__F1__O = (function(fa, fb) {
  if ((this instanceof $c_s_util_Right)) {
    var b = this.s_util_Right__f_value;
    return fb.apply__O__O(b);
  } else if ((this instanceof $c_s_util_Left)) {
    var a = this.s_util_Left__f_value;
    return fa.apply__O__O(a);
  } else {
    throw new $c_s_MatchError(this);
  }
});
$c_s_util_Either.prototype.swap__s_util_Either = (function() {
  if ((this instanceof $c_s_util_Left)) {
    var a = this.s_util_Left__f_value;
    return new $c_s_util_Right(a);
  } else if ((this instanceof $c_s_util_Right)) {
    var b = this.s_util_Right__f_value;
    return new $c_s_util_Left(b);
  } else {
    throw new $c_s_MatchError(this);
  }
});
$c_s_util_Either.prototype.exists__F1__Z = (function(p) {
  if ((this instanceof $c_s_util_Right)) {
    var b = this.s_util_Right__f_value;
    return (!(!p.apply__O__O(b)));
  } else {
    return false;
  }
});
$c_s_util_Either.prototype.flatMap__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var b = this.s_util_Right__f_value;
    return f.apply__O__O(b);
  } else {
    return this;
  }
});
$c_s_util_Either.prototype.map__F1__s_util_Either = (function(f) {
  if ((this instanceof $c_s_util_Right)) {
    var b = this.s_util_Right__f_value;
    return new $c_s_util_Right(f.apply__O__O(b));
  } else {
    return this;
  }
});
$c_s_util_Either.prototype.toOption__s_Option = (function() {
  if ((this instanceof $c_s_util_Right)) {
    var b = this.s_util_Right__f_value;
    return new $c_s_Some(b);
  } else {
    return $m_s_None$();
  }
});
/** @constructor */
function $c_s_util_Either$LeftProjection(e) {
  this.s_util_Either$LeftProjection__f_e = null;
  this.s_util_Either$LeftProjection__f_e = e;
}
export { $c_s_util_Either$LeftProjection as $c_s_util_Either$LeftProjection };
$c_s_util_Either$LeftProjection.prototype = new $h_O();
$c_s_util_Either$LeftProjection.prototype.constructor = $c_s_util_Either$LeftProjection;
/** @constructor */
function $h_s_util_Either$LeftProjection() {
}
export { $h_s_util_Either$LeftProjection as $h_s_util_Either$LeftProjection };
$h_s_util_Either$LeftProjection.prototype = $c_s_util_Either$LeftProjection.prototype;
$c_s_util_Either$LeftProjection.prototype.toOption__s_Option = (function() {
  var x1 = this.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var a = x1.s_util_Left__f_value;
    return new $c_s_Some(a);
  } else {
    return $m_s_None$();
  }
});
$c_s_util_Either$LeftProjection.prototype.productPrefix__T = (function() {
  return "LeftProjection";
});
$c_s_util_Either$LeftProjection.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Either$LeftProjection.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Either$LeftProjection__f_e : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Either$LeftProjection.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Either$LeftProjection.prototype.productElementName__I__T = (function(x$1) {
  return ((x$1 === 0) ? "e" : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Either$LeftProjection.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-44939558), true);
});
$c_s_util_Either$LeftProjection.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Either$LeftProjection.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Either$LeftProjection)) {
    var x = this.s_util_Either$LeftProjection__f_e;
    var x$2 = x$1.s_util_Either$LeftProjection__f_e;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
function $isArrayOf_s_util_Either$LeftProjection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Either$LeftProjection)));
}
export { $isArrayOf_s_util_Either$LeftProjection as $isArrayOf_s_util_Either$LeftProjection };
var $d_s_util_Either$LeftProjection = new $TypeData().initClass($c_s_util_Either$LeftProjection, "scala.util.Either$LeftProjection", ({
  s_util_Either$LeftProjection: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_Either$LeftProjection as $d_s_util_Either$LeftProjection };
/** @constructor */
function $c_s_util_Try() {
}
export { $c_s_util_Try as $c_s_util_Try };
$c_s_util_Try.prototype = new $h_O();
$c_s_util_Try.prototype.constructor = $c_s_util_Try;
/** @constructor */
function $h_s_util_Try() {
}
export { $h_s_util_Try as $h_s_util_Try };
$h_s_util_Try.prototype = $c_s_util_Try.prototype;
function $isArrayOf_s_util_Try(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Try)));
}
export { $isArrayOf_s_util_Try as $isArrayOf_s_util_Try };
var $d_s_util_Try = new $TypeData().initClass(0, "scala.util.Try", ({
  s_util_Try: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_Try as $d_s_util_Try };
/** @constructor */
function $c_Lscodec_Attempt() {
}
export { $c_Lscodec_Attempt as $c_Lscodec_Attempt };
$c_Lscodec_Attempt.prototype = new $h_O();
$c_Lscodec_Attempt.prototype.constructor = $c_Lscodec_Attempt;
/** @constructor */
function $h_Lscodec_Attempt() {
}
export { $h_Lscodec_Attempt as $h_Lscodec_Attempt };
$h_Lscodec_Attempt.prototype = $c_Lscodec_Attempt.prototype;
$c_Lscodec_Attempt.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lscodec_Codec$$anon$1(g$4, f$6, outer) {
  this.Lscodec_Codec$$anon$1__f_g$1 = null;
  this.Lscodec_Codec$$anon$1__f_f$1 = null;
  this.Lscodec_Codec$$anon$1__f_$outer = null;
  this.Lscodec_Codec$$anon$1__f_g$1 = g$4;
  this.Lscodec_Codec$$anon$1__f_f$1 = f$6;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lscodec_Codec$$anon$1__f_$outer = outer;
}
export { $c_Lscodec_Codec$$anon$1 as $c_Lscodec_Codec$$anon$1 };
$c_Lscodec_Codec$$anon$1.prototype = new $h_O();
$c_Lscodec_Codec$$anon$1.prototype.constructor = $c_Lscodec_Codec$$anon$1;
/** @constructor */
function $h_Lscodec_Codec$$anon$1() {
}
export { $h_Lscodec_Codec$$anon$1 as $h_Lscodec_Codec$$anon$1 };
$h_Lscodec_Codec$$anon$1.prototype = $c_Lscodec_Codec$$anon$1.prototype;
$c_Lscodec_Codec$$anon$1.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_Codec$$anon$1__f_$outer.sizeBound__Lscodec_SizeBound();
});
$c_Lscodec_Codec$$anon$1.prototype.encode__O__Lscodec_Attempt = (function(b) {
  var this$1 = this.Lscodec_Codec$$anon$1__f_$outer;
  var f = this.Lscodec_Codec$$anon$1__f_g$1;
  return new $c_Lscodec_Encoder$$anon$3(f, this$1).encode__O__Lscodec_Attempt(b);
});
$c_Lscodec_Codec$$anon$1.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  var this$1 = this.Lscodec_Codec$$anon$1__f_$outer;
  var f = this.Lscodec_Codec$$anon$1__f_f$1;
  return new $c_Lscodec_Decoder$$anon$3(f, this$1).decode__Lscodec_bits_BitVector__Lscodec_Attempt(buffer);
});
var $d_Lscodec_Codec$$anon$1 = new $TypeData().initClass($c_Lscodec_Codec$$anon$1, "scodec.Codec$$anon$1", ({
  Lscodec_Codec$$anon$1: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_Codec$$anon$1 as $d_Lscodec_Codec$$anon$1 };
/** @constructor */
function $c_Lscodec_Codec$$anon$2(g$5, f$7, outer) {
  this.Lscodec_Codec$$anon$2__f_g$2 = null;
  this.Lscodec_Codec$$anon$2__f_f$2 = null;
  this.Lscodec_Codec$$anon$2__f_$outer = null;
  this.Lscodec_Codec$$anon$2__f_g$2 = g$5;
  this.Lscodec_Codec$$anon$2__f_f$2 = f$7;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lscodec_Codec$$anon$2__f_$outer = outer;
}
export { $c_Lscodec_Codec$$anon$2 as $c_Lscodec_Codec$$anon$2 };
$c_Lscodec_Codec$$anon$2.prototype = new $h_O();
$c_Lscodec_Codec$$anon$2.prototype.constructor = $c_Lscodec_Codec$$anon$2;
/** @constructor */
function $h_Lscodec_Codec$$anon$2() {
}
export { $h_Lscodec_Codec$$anon$2 as $h_Lscodec_Codec$$anon$2 };
$h_Lscodec_Codec$$anon$2.prototype = $c_Lscodec_Codec$$anon$2.prototype;
$c_Lscodec_Codec$$anon$2.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_Codec$$anon$2__f_$outer.sizeBound__Lscodec_SizeBound();
});
$c_Lscodec_Codec$$anon$2.prototype.encode__O__Lscodec_Attempt = (function(b) {
  return this.Lscodec_Codec$$anon$2__f_$outer.encode__O__Lscodec_Attempt(this.Lscodec_Codec$$anon$2__f_g$2.apply__O__O(b));
});
$c_Lscodec_Codec$$anon$2.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  return this.Lscodec_Codec$$anon$2__f_$outer.decode__Lscodec_bits_BitVector__Lscodec_Attempt(buffer).map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => _$1.map__F1__Lscodec_DecodeResult(this.Lscodec_Codec$$anon$2__f_f$2))));
});
var $d_Lscodec_Codec$$anon$2 = new $TypeData().initClass($c_Lscodec_Codec$$anon$2, "scodec.Codec$$anon$2", ({
  Lscodec_Codec$$anon$2: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_Codec$$anon$2 as $d_Lscodec_Codec$$anon$2 };
/** @constructor */
function $c_Lscodec_Codec$$anon$7(context$2, outer) {
  this.Lscodec_Codec$$anon$7__f_context$1 = null;
  this.Lscodec_Codec$$anon$7__f_$outer = null;
  this.Lscodec_Codec$$anon$7__f_context$1 = context$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lscodec_Codec$$anon$7__f_$outer = outer;
}
export { $c_Lscodec_Codec$$anon$7 as $c_Lscodec_Codec$$anon$7 };
$c_Lscodec_Codec$$anon$7.prototype = new $h_O();
$c_Lscodec_Codec$$anon$7.prototype.constructor = $c_Lscodec_Codec$$anon$7;
/** @constructor */
function $h_Lscodec_Codec$$anon$7() {
}
export { $h_Lscodec_Codec$$anon$7 as $h_Lscodec_Codec$$anon$7 };
$h_Lscodec_Codec$$anon$7.prototype = $c_Lscodec_Codec$$anon$7.prototype;
$c_Lscodec_Codec$$anon$7.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_Codec$$anon$7__f_$outer.sizeBound__Lscodec_SizeBound();
});
$c_Lscodec_Codec$$anon$7.prototype.encode__O__Lscodec_Attempt = (function(a) {
  return this.Lscodec_Codec$$anon$7__f_$outer.encode__O__Lscodec_Attempt(a).mapErr__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => _$8.pushContext__T__Lscodec_Err(this.Lscodec_Codec$$anon$7__f_context$1))));
});
$c_Lscodec_Codec$$anon$7.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  return this.Lscodec_Codec$$anon$7__f_$outer.decode__Lscodec_bits_BitVector__Lscodec_Attempt(buffer).mapErr__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$9) => _$9.pushContext__T__Lscodec_Err(this.Lscodec_Codec$$anon$7__f_context$1))));
});
$c_Lscodec_Codec$$anon$7.prototype.toString__T = (function() {
  return (((this.Lscodec_Codec$$anon$7__f_context$1 + "(") + this.Lscodec_Codec$$anon$7__f_$outer) + ")");
});
var $d_Lscodec_Codec$$anon$7 = new $TypeData().initClass($c_Lscodec_Codec$$anon$7, "scodec.Codec$$anon$7", ({
  Lscodec_Codec$$anon$7: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_Codec$$anon$7 as $d_Lscodec_Codec$$anon$7 };
/** @constructor */
function $c_Lscodec_Codec$$anon$8(str$2, outer) {
  this.Lscodec_Codec$$anon$8__f_str$1 = null;
  this.Lscodec_Codec$$anon$8__f_$outer = null;
  this.Lscodec_Codec$$anon$8__f_str$1 = str$2;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lscodec_Codec$$anon$8__f_$outer = outer;
}
export { $c_Lscodec_Codec$$anon$8 as $c_Lscodec_Codec$$anon$8 };
$c_Lscodec_Codec$$anon$8.prototype = new $h_O();
$c_Lscodec_Codec$$anon$8.prototype.constructor = $c_Lscodec_Codec$$anon$8;
/** @constructor */
function $h_Lscodec_Codec$$anon$8() {
}
export { $h_Lscodec_Codec$$anon$8 as $h_Lscodec_Codec$$anon$8 };
$h_Lscodec_Codec$$anon$8.prototype = $c_Lscodec_Codec$$anon$8.prototype;
$c_Lscodec_Codec$$anon$8.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_Codec$$anon$8__f_$outer.sizeBound__Lscodec_SizeBound();
});
$c_Lscodec_Codec$$anon$8.prototype.encode__O__Lscodec_Attempt = (function(a) {
  return this.Lscodec_Codec$$anon$8__f_$outer.encode__O__Lscodec_Attempt(a);
});
$c_Lscodec_Codec$$anon$8.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  return this.Lscodec_Codec$$anon$8__f_$outer.decode__Lscodec_bits_BitVector__Lscodec_Attempt(buffer);
});
$c_Lscodec_Codec$$anon$8.prototype.toString__T = (function() {
  return this.Lscodec_Codec$$anon$8__f_str$1.apply__O();
});
var $d_Lscodec_Codec$$anon$8 = new $TypeData().initClass($c_Lscodec_Codec$$anon$8, "scodec.Codec$$anon$8", ({
  Lscodec_Codec$$anon$8: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_Codec$$anon$8 as $d_Lscodec_Codec$$anon$8 };
function $p_Lscodec_Codec$inlineImplementations$SumCodec__caseCodecs__ALscodec_Codec($thiz) {
  if ((!$thiz.Lscodec_Codec$inlineImplementations$SumCodec__f_caseCodecsbitmap$1)) {
    $thiz.Lscodec_Codec$inlineImplementations$SumCodec__f_caseCodecs$lzy1 = $thiz.Lscodec_Codec$inlineImplementations$SumCodec__f_caseCodecs0.apply__O();
    $thiz.Lscodec_Codec$inlineImplementations$SumCodec__f_caseCodecsbitmap$1 = true;
    $thiz.Lscodec_Codec$inlineImplementations$SumCodec__f_caseCodecs0 = null;
  }
  return $thiz.Lscodec_Codec$inlineImplementations$SumCodec__f_caseCodecs$lzy1;
}
export { $p_Lscodec_Codec$inlineImplementations$SumCodec__caseCodecs__ALscodec_Codec as $p_Lscodec_Codec$inlineImplementations$SumCodec__caseCodecs__ALscodec_Codec };
/** @constructor */
function $c_Lscodec_Codec$inlineImplementations$SumCodec(mirror, caseCodecs0) {
  this.Lscodec_Codec$inlineImplementations$SumCodec__f_mirror = null;
  this.Lscodec_Codec$inlineImplementations$SumCodec__f_caseCodecs0 = null;
  this.Lscodec_Codec$inlineImplementations$SumCodec__f_caseCodecs$lzy1 = null;
  this.Lscodec_Codec$inlineImplementations$SumCodec__f_caseCodecsbitmap$1 = false;
  this.Lscodec_Codec$inlineImplementations$SumCodec__f_mirror = mirror;
  this.Lscodec_Codec$inlineImplementations$SumCodec__f_caseCodecs0 = caseCodecs0;
}
export { $c_Lscodec_Codec$inlineImplementations$SumCodec as $c_Lscodec_Codec$inlineImplementations$SumCodec };
$c_Lscodec_Codec$inlineImplementations$SumCodec.prototype = new $h_O();
$c_Lscodec_Codec$inlineImplementations$SumCodec.prototype.constructor = $c_Lscodec_Codec$inlineImplementations$SumCodec;
/** @constructor */
function $h_Lscodec_Codec$inlineImplementations$SumCodec() {
}
export { $h_Lscodec_Codec$inlineImplementations$SumCodec as $h_Lscodec_Codec$inlineImplementations$SumCodec };
$h_Lscodec_Codec$inlineImplementations$SumCodec.prototype = $c_Lscodec_Codec$inlineImplementations$SumCodec.prototype;
$c_Lscodec_Codec$inlineImplementations$SumCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  var xs = $p_Lscodec_Codec$inlineImplementations$SumCodec__caseCodecs__ALscodec_Codec(this);
  var z = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_uint8.sizeBound__Lscodec_SizeBound();
  var f = ((_$18, _$19) => _$18.$plus__Lscodec_SizeBound__Lscodec_SizeBound(_$19.sizeBound__Lscodec_SizeBound()));
  if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((xs !== null)) {
    var length = xs.u.length;
    var v = z;
    var i = 0;
    while ((i < length)) {
      var x0 = v;
      var x1 = i;
      var x1$1 = xs.u[x1];
      v = f(x0, x1$1);
      i = ((1 + i) | 0);
    }
    var $x_1 = v;
  } else if ((xs instanceof $ac_I)) {
    var length$1 = xs.u.length;
    var v$1 = z;
    var i$1 = 0;
    while ((i$1 < length$1)) {
      var x0$1 = v$1;
      var x1$2 = xs.u[i$1];
      v$1 = f(x0$1, x1$2);
      i$1 = ((1 + i$1) | 0);
    }
    var $x_1 = v$1;
  } else if ((xs instanceof $ac_D)) {
    var length$2 = xs.u.length;
    var v$2 = z;
    var i$2 = 0;
    while ((i$2 < length$2)) {
      var x0$2 = v$2;
      var x1$3 = xs.u[i$2];
      v$2 = f(x0$2, x1$3);
      i$2 = ((1 + i$2) | 0);
    }
    var $x_1 = v$2;
  } else if ((xs instanceof $ac_J)) {
    var length$3 = xs.u.length;
    var v$3 = z;
    var i$3 = 0;
    while ((i$3 < length$3)) {
      var x0$3 = v$3;
      var t = xs.u[i$3];
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      v$3 = f(x0$3, new $c_RTLong(lo, hi));
      i$3 = ((1 + i$3) | 0);
    }
    var $x_1 = v$3;
  } else if ((xs instanceof $ac_F)) {
    var length$4 = xs.u.length;
    var v$4 = z;
    var i$4 = 0;
    while ((i$4 < length$4)) {
      var x0$4 = v$4;
      var x1$4 = xs.u[i$4];
      v$4 = f(x0$4, x1$4);
      i$4 = ((1 + i$4) | 0);
    }
    var $x_1 = v$4;
  } else if ((xs instanceof $ac_C)) {
    var length$5 = xs.u.length;
    var v$5 = z;
    var i$5 = 0;
    while ((i$5 < length$5)) {
      var x0$5 = v$5;
      var x1$5 = xs.u[i$5];
      v$5 = f(x0$5, $bC(x1$5));
      i$5 = ((1 + i$5) | 0);
    }
    var $x_1 = v$5;
  } else if ((xs instanceof $ac_B)) {
    var length$6 = xs.u.length;
    var v$6 = z;
    var i$6 = 0;
    while ((i$6 < length$6)) {
      var x0$6 = v$6;
      var x1$6 = xs.u[i$6];
      v$6 = f(x0$6, x1$6);
      i$6 = ((1 + i$6) | 0);
    }
    var $x_1 = v$6;
  } else if ((xs instanceof $ac_S)) {
    var length$7 = xs.u.length;
    var v$7 = z;
    var i$7 = 0;
    while ((i$7 < length$7)) {
      var x0$7 = v$7;
      var x1$7 = xs.u[i$7];
      v$7 = f(x0$7, x1$7);
      i$7 = ((1 + i$7) | 0);
    }
    var $x_1 = v$7;
  } else if ((xs instanceof $ac_Z)) {
    var length$8 = xs.u.length;
    var v$8 = z;
    var i$8 = 0;
    while ((i$8 < length$8)) {
      var x0$8 = v$8;
      var x1$8 = xs.u[i$8];
      v$8 = f(x0$8, x1$8);
      i$8 = ((1 + i$8) | 0);
    }
    var $x_1 = v$8;
  } else {
    if ((!$isArrayOf_jl_Void(xs, 1))) {
      throw new $c_s_MatchError(xs);
    }
    var length$9 = xs.u.length;
    var v$9 = z;
    var i$9 = 0;
    while ((i$9 < length$9)) {
      var x0$9 = v$9;
      var x1$9 = xs.u[i$9];
      v$9 = f(x0$9, x1$9);
      i$9 = ((1 + i$9) | 0);
    }
    var $x_1 = v$9;
  }
  return $x_1;
});
$c_Lscodec_Codec$inlineImplementations$SumCodec.prototype.encode__O__Lscodec_Attempt = (function(a) {
  var ordinal = this.Lscodec_Codec$inlineImplementations$SumCodec__f_mirror.ordinal__O__I(a);
  var this$1 = $m_Lscodec_Encoder$();
  var encA = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_uint8;
  var encB = $p_Lscodec_Codec$inlineImplementations$SumCodec__caseCodecs__ALscodec_Codec(this).u[ordinal];
  return $f_Lscodec_EncoderFunctions__encodeBoth__Lscodec_Encoder__Lscodec_Encoder__O__O__Lscodec_Attempt(this$1, encA, encB, ordinal, a);
});
$c_Lscodec_Codec$inlineImplementations$SumCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(bits) {
  var this$2 = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_uint8;
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ordinal) => {
    var ordinal$1 = (ordinal | 0);
    return $p_Lscodec_Codec$inlineImplementations$SumCodec__caseCodecs__ALscodec_Codec(this).u[ordinal$1];
  }));
  return new $c_Lscodec_Decoder$$anon$2(f, this$2).decode__Lscodec_bits_BitVector__Lscodec_Attempt(bits);
});
$c_Lscodec_Codec$inlineImplementations$SumCodec.prototype.toString__T = (function() {
  return "SumCodec";
});
var $d_Lscodec_Codec$inlineImplementations$SumCodec = new $TypeData().initClass($c_Lscodec_Codec$inlineImplementations$SumCodec, "scodec.Codec$inlineImplementations$SumCodec", ({
  Lscodec_Codec$inlineImplementations$SumCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_Codec$inlineImplementations$SumCodec as $d_Lscodec_Codec$inlineImplementations$SumCodec };
function $p_Lscodec_Codec$inlineImplementations$TupleCodec__componentCodecs__ALscodec_Codec($thiz) {
  if ((!$thiz.Lscodec_Codec$inlineImplementations$TupleCodec__f_componentCodecsbitmap$1)) {
    $thiz.Lscodec_Codec$inlineImplementations$TupleCodec__f_componentCodecs$lzy1 = $thiz.Lscodec_Codec$inlineImplementations$TupleCodec__f_componentCodecs0.apply__O();
    $thiz.Lscodec_Codec$inlineImplementations$TupleCodec__f_componentCodecsbitmap$1 = true;
    $thiz.Lscodec_Codec$inlineImplementations$TupleCodec__f_componentCodecs0 = null;
  }
  return $thiz.Lscodec_Codec$inlineImplementations$TupleCodec__f_componentCodecs$lzy1;
}
export { $p_Lscodec_Codec$inlineImplementations$TupleCodec__componentCodecs__ALscodec_Codec as $p_Lscodec_Codec$inlineImplementations$TupleCodec__componentCodecs__ALscodec_Codec };
/** @constructor */
function $c_Lscodec_Codec$inlineImplementations$TupleCodec(componentCodecs0) {
  this.Lscodec_Codec$inlineImplementations$TupleCodec__f_componentCodecs0 = null;
  this.Lscodec_Codec$inlineImplementations$TupleCodec__f_componentCodecs$lzy1 = null;
  this.Lscodec_Codec$inlineImplementations$TupleCodec__f_componentCodecsbitmap$1 = false;
  this.Lscodec_Codec$inlineImplementations$TupleCodec__f_componentCodecs0 = componentCodecs0;
}
export { $c_Lscodec_Codec$inlineImplementations$TupleCodec as $c_Lscodec_Codec$inlineImplementations$TupleCodec };
$c_Lscodec_Codec$inlineImplementations$TupleCodec.prototype = new $h_O();
$c_Lscodec_Codec$inlineImplementations$TupleCodec.prototype.constructor = $c_Lscodec_Codec$inlineImplementations$TupleCodec;
/** @constructor */
function $h_Lscodec_Codec$inlineImplementations$TupleCodec() {
}
export { $h_Lscodec_Codec$inlineImplementations$TupleCodec as $h_Lscodec_Codec$inlineImplementations$TupleCodec };
$h_Lscodec_Codec$inlineImplementations$TupleCodec.prototype = $c_Lscodec_Codec$inlineImplementations$TupleCodec.prototype;
$c_Lscodec_Codec$inlineImplementations$TupleCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  var xs = $p_Lscodec_Codec$inlineImplementations$TupleCodec__componentCodecs__ALscodec_Codec(this);
  var z = $m_Lscodec_SizeBound$().exact__J__Lscodec_SizeBound($L0);
  var f = ((_$16, _$17) => _$16.$plus__Lscodec_SizeBound__Lscodec_SizeBound(_$17.sizeBound__Lscodec_SizeBound()));
  if ((xs === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((xs !== null)) {
    var length = xs.u.length;
    var v = z;
    var i = 0;
    while ((i < length)) {
      var x0 = v;
      var x1 = i;
      var x1$1 = xs.u[x1];
      v = f(x0, x1$1);
      i = ((1 + i) | 0);
    }
    var $x_1 = v;
  } else if ((xs instanceof $ac_I)) {
    var length$1 = xs.u.length;
    var v$1 = z;
    var i$1 = 0;
    while ((i$1 < length$1)) {
      var x0$1 = v$1;
      var x1$2 = xs.u[i$1];
      v$1 = f(x0$1, x1$2);
      i$1 = ((1 + i$1) | 0);
    }
    var $x_1 = v$1;
  } else if ((xs instanceof $ac_D)) {
    var length$2 = xs.u.length;
    var v$2 = z;
    var i$2 = 0;
    while ((i$2 < length$2)) {
      var x0$2 = v$2;
      var x1$3 = xs.u[i$2];
      v$2 = f(x0$2, x1$3);
      i$2 = ((1 + i$2) | 0);
    }
    var $x_1 = v$2;
  } else if ((xs instanceof $ac_J)) {
    var length$3 = xs.u.length;
    var v$3 = z;
    var i$3 = 0;
    while ((i$3 < length$3)) {
      var x0$3 = v$3;
      var t = xs.u[i$3];
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      v$3 = f(x0$3, new $c_RTLong(lo, hi));
      i$3 = ((1 + i$3) | 0);
    }
    var $x_1 = v$3;
  } else if ((xs instanceof $ac_F)) {
    var length$4 = xs.u.length;
    var v$4 = z;
    var i$4 = 0;
    while ((i$4 < length$4)) {
      var x0$4 = v$4;
      var x1$4 = xs.u[i$4];
      v$4 = f(x0$4, x1$4);
      i$4 = ((1 + i$4) | 0);
    }
    var $x_1 = v$4;
  } else if ((xs instanceof $ac_C)) {
    var length$5 = xs.u.length;
    var v$5 = z;
    var i$5 = 0;
    while ((i$5 < length$5)) {
      var x0$5 = v$5;
      var x1$5 = xs.u[i$5];
      v$5 = f(x0$5, $bC(x1$5));
      i$5 = ((1 + i$5) | 0);
    }
    var $x_1 = v$5;
  } else if ((xs instanceof $ac_B)) {
    var length$6 = xs.u.length;
    var v$6 = z;
    var i$6 = 0;
    while ((i$6 < length$6)) {
      var x0$6 = v$6;
      var x1$6 = xs.u[i$6];
      v$6 = f(x0$6, x1$6);
      i$6 = ((1 + i$6) | 0);
    }
    var $x_1 = v$6;
  } else if ((xs instanceof $ac_S)) {
    var length$7 = xs.u.length;
    var v$7 = z;
    var i$7 = 0;
    while ((i$7 < length$7)) {
      var x0$7 = v$7;
      var x1$7 = xs.u[i$7];
      v$7 = f(x0$7, x1$7);
      i$7 = ((1 + i$7) | 0);
    }
    var $x_1 = v$7;
  } else if ((xs instanceof $ac_Z)) {
    var length$8 = xs.u.length;
    var v$8 = z;
    var i$8 = 0;
    while ((i$8 < length$8)) {
      var x0$8 = v$8;
      var x1$8 = xs.u[i$8];
      v$8 = f(x0$8, x1$8);
      i$8 = ((1 + i$8) | 0);
    }
    var $x_1 = v$8;
  } else {
    if ((!$isArrayOf_jl_Void(xs, 1))) {
      throw new $c_s_MatchError(xs);
    }
    var length$9 = xs.u.length;
    var v$9 = z;
    var i$9 = 0;
    while ((i$9 < length$9)) {
      var x0$9 = v$9;
      var x1$9 = xs.u[i$9];
      v$9 = f(x0$9, x1$9);
      i$9 = ((1 + i$9) | 0);
    }
    var $x_1 = v$9;
  }
  return $x_1;
});
$c_Lscodec_Codec$inlineImplementations$TupleCodec.prototype.encode__s_Product__Lscodec_Attempt = (function(t) {
  var components = $m_sr_Tuples$().toArray__s_Product__AO(t);
  var i = 0;
  var result = null;
  var acc = $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_empty;
  while (true) {
    var $x_1 = i;
    var xs = $p_Lscodec_Codec$inlineImplementations$TupleCodec__componentCodecs__ALscodec_Codec(this);
    if ((($x_1 < xs.u.length) && (result === null))) {
      var codec = $p_Lscodec_Codec$inlineImplementations$TupleCodec__componentCodecs__ALscodec_Codec(this).u[i];
      matchResult9: {
        var x31 = codec.encode__O__Lscodec_Attempt(components.u[i]);
        if ((x31 instanceof $c_Lscodec_Attempt$Successful)) {
          var x37 = x31.Lscodec_Attempt$Successful__f_value;
          acc = acc.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(x37);
          i = ((1 + i) | 0);
          break matchResult9;
        }
        if ((x31 instanceof $c_Lscodec_Attempt$Failure)) {
          result = x31;
          break matchResult9;
        }
        throw new $c_s_MatchError(x31);
      }
    } else {
      break;
    }
  }
  if ((result !== null)) {
    return result;
  } else {
    var value = acc;
    return new $c_Lscodec_Attempt$Successful(value);
  }
});
$c_Lscodec_Codec$inlineImplementations$TupleCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(b) {
  var remaining = b;
  var xs = $p_Lscodec_Codec$inlineImplementations$TupleCodec__componentCodecs__ALscodec_Codec(this);
  var dimensions = new $ac_I(new Int32Array([xs.u.length]));
  var components = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_O.getClassOf(), dimensions);
  var i = 0;
  var result = null;
  while (((i < $p_Lscodec_Codec$inlineImplementations$TupleCodec__componentCodecs__ALscodec_Codec(this).u.length) && (result === null))) {
    var codec = $p_Lscodec_Codec$inlineImplementations$TupleCodec__componentCodecs__ALscodec_Codec(this).u[i];
    matchResult10: {
      var x38 = codec.decode__Lscodec_bits_BitVector__Lscodec_Attempt(remaining);
      if ((x38 instanceof $c_Lscodec_Attempt$Successful)) {
        var x44 = x38.Lscodec_Attempt$Successful__f_value;
        if ((x44 !== null)) {
          var x46 = x44.Lscodec_DecodeResult__f_value;
          var x47 = x44.Lscodec_DecodeResult__f_remainder;
          components.u[i] = x46;
          i = ((1 + i) | 0);
          remaining = x47;
          break matchResult10;
        }
      }
      if ((x38 instanceof $c_Lscodec_Attempt$Failure)) {
        result = x38;
        break matchResult10;
      }
      throw new $c_s_MatchError(x38);
    }
  }
  if ((result !== null)) {
    return result;
  } else {
    var value = $m_T$().fromArray__O__s_Product(components);
    var remainder = remaining;
    var value$1 = new $c_Lscodec_DecodeResult(value, remainder);
    return new $c_Lscodec_Attempt$Successful(value$1);
  }
});
$c_Lscodec_Codec$inlineImplementations$TupleCodec.prototype.toString__T = (function() {
  return "TupleCodec";
});
$c_Lscodec_Codec$inlineImplementations$TupleCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__s_Product__Lscodec_Attempt(value);
});
var $d_Lscodec_Codec$inlineImplementations$TupleCodec = new $TypeData().initClass($c_Lscodec_Codec$inlineImplementations$TupleCodec, "scodec.Codec$inlineImplementations$TupleCodec", ({
  Lscodec_Codec$inlineImplementations$TupleCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_Codec$inlineImplementations$TupleCodec as $d_Lscodec_Codec$inlineImplementations$TupleCodec };
/** @constructor */
function $c_Lscodec_DecodeResult(value, remainder) {
  this.Lscodec_DecodeResult__f_value = null;
  this.Lscodec_DecodeResult__f_remainder = null;
  this.Lscodec_DecodeResult__f_value = value;
  this.Lscodec_DecodeResult__f_remainder = remainder;
}
export { $c_Lscodec_DecodeResult as $c_Lscodec_DecodeResult };
$c_Lscodec_DecodeResult.prototype = new $h_O();
$c_Lscodec_DecodeResult.prototype.constructor = $c_Lscodec_DecodeResult;
/** @constructor */
function $h_Lscodec_DecodeResult() {
}
export { $h_Lscodec_DecodeResult as $h_Lscodec_DecodeResult };
$h_Lscodec_DecodeResult.prototype = $c_Lscodec_DecodeResult.prototype;
$c_Lscodec_DecodeResult.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_DecodeResult.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lscodec_DecodeResult.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscodec_DecodeResult)) {
    var x = this.Lscodec_DecodeResult__f_value;
    var y = x$0.Lscodec_DecodeResult__f_value;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lscodec_DecodeResult__f_remainder;
      var x$2 = x$0.Lscodec_DecodeResult__f_remainder;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lscodec_DecodeResult.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lscodec_DecodeResult.prototype.productArity__I = (function() {
  return 2;
});
$c_Lscodec_DecodeResult.prototype.productPrefix__T = (function() {
  return "DecodeResult";
});
$c_Lscodec_DecodeResult.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_DecodeResult__f_value;
  }
  if ((n === 1)) {
    return this.Lscodec_DecodeResult__f_remainder;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_DecodeResult.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  if ((n === 1)) {
    return "remainder";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_DecodeResult.prototype.map__F1__Lscodec_DecodeResult = (function(f) {
  var value = f.apply__O__O(this.Lscodec_DecodeResult__f_value);
  var remainder = this.Lscodec_DecodeResult__f_remainder;
  return new $c_Lscodec_DecodeResult(value, remainder);
});
function $isArrayOf_Lscodec_DecodeResult(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_DecodeResult)));
}
export { $isArrayOf_Lscodec_DecodeResult as $isArrayOf_Lscodec_DecodeResult };
var $d_Lscodec_DecodeResult = new $TypeData().initClass($c_Lscodec_DecodeResult, "scodec.DecodeResult", ({
  Lscodec_DecodeResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_DecodeResult as $d_Lscodec_DecodeResult };
/** @constructor */
function $c_Lscodec_SizeBound(lowerBound, upperBound) {
  this.Lscodec_SizeBound__f_lowerBound = $L0;
  this.Lscodec_SizeBound__f_upperBound = null;
  this.Lscodec_SizeBound__f_lowerBound = lowerBound;
  this.Lscodec_SizeBound__f_upperBound = upperBound;
  var $x_1 = $m_s_Predef$();
  var ahi = lowerBound.RTLong__f_hi;
  $x_1.require__Z__V((ahi >= 0));
  var $x_2 = $m_s_Predef$();
  var a = $uJ((upperBound.isEmpty__Z() ? $L0 : upperBound.get__O()));
  var ahi$1 = a.RTLong__f_hi;
  $x_2.require__Z__V((ahi$1 >= 0));
  var $x_3 = $m_s_Predef$();
  var a$1 = $uJ((upperBound.isEmpty__Z() ? lowerBound : upperBound.get__O()));
  var ahi$2 = a$1.RTLong__f_hi;
  var bhi = lowerBound.RTLong__f_hi;
  $x_3.require__Z__V(((ahi$2 === bhi) ? ((a$1.RTLong__f_lo >>> 0) >= (lowerBound.RTLong__f_lo >>> 0)) : (ahi$2 > bhi)));
}
export { $c_Lscodec_SizeBound as $c_Lscodec_SizeBound };
$c_Lscodec_SizeBound.prototype = new $h_O();
$c_Lscodec_SizeBound.prototype.constructor = $c_Lscodec_SizeBound;
/** @constructor */
function $h_Lscodec_SizeBound() {
}
export { $h_Lscodec_SizeBound as $h_Lscodec_SizeBound };
$h_Lscodec_SizeBound.prototype = $c_Lscodec_SizeBound.prototype;
$c_Lscodec_SizeBound.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_SizeBound.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("SizeBound");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lscodec_SizeBound__f_lowerBound;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var x = this.Lscodec_SizeBound__f_upperBound;
  var data$2 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lscodec_SizeBound.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscodec_SizeBound)) {
    var a = this.Lscodec_SizeBound__f_lowerBound;
    var b = x$0.Lscodec_SizeBound__f_lowerBound;
    if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
      var x = this.Lscodec_SizeBound__f_upperBound;
      var x$2 = x$0.Lscodec_SizeBound__f_upperBound;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lscodec_SizeBound.prototype.productArity__I = (function() {
  return 2;
});
$c_Lscodec_SizeBound.prototype.productPrefix__T = (function() {
  return "SizeBound";
});
$c_Lscodec_SizeBound.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_SizeBound__f_lowerBound;
  }
  if ((n === 1)) {
    return this.Lscodec_SizeBound__f_upperBound;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_SizeBound.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "lowerBound";
  }
  if ((n === 1)) {
    return "upperBound";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_SizeBound.prototype.atLeast__Lscodec_SizeBound = (function() {
  var upperBound$1 = $m_s_None$();
  var t = this.Lscodec_SizeBound__f_lowerBound;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_Lscodec_SizeBound(new $c_RTLong(lo, hi), upperBound$1);
});
$c_Lscodec_SizeBound.prototype.$plus__Lscodec_SizeBound__Lscodec_SizeBound = (function(that) {
  $m_Lscodec_SizeBound$();
  var t = this.Lscodec_SizeBound__f_lowerBound;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = that.Lscodec_SizeBound__f_lowerBound;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var lo$2 = ((lo + lo$1) | 0);
  var hi$2 = ((((hi + hi$1) | 0) + ((((lo & lo$1) | ((lo | lo$1) & (~lo$2))) >>> 31) | 0)) | 0);
  var this$2 = this.Lscodec_SizeBound__f_upperBound;
  if (this$2.isEmpty__Z()) {
    var upperBound = $m_s_None$();
  } else {
    var x0 = this$2.get__O();
    var t$2 = $uJ(x0);
    var lo$3 = t$2.RTLong__f_lo;
    var hi$3 = t$2.RTLong__f_hi;
    var this$3 = that.Lscodec_SizeBound__f_upperBound;
    if (this$3.isEmpty__Z()) {
      var upperBound = $m_s_None$();
    } else {
      var x0$1 = this$3.get__O();
      var t$3 = $uJ(x0$1);
      var lo$4 = t$3.RTLong__f_lo;
      var hi$4 = t$3.RTLong__f_hi;
      var lo$5 = ((lo$3 + lo$4) | 0);
      var hi$5 = ((((hi$3 + hi$4) | 0) + ((((lo$3 & lo$4) | ((lo$3 | lo$4) & (~lo$5))) >>> 31) | 0)) | 0);
      var upperBound = new $c_s_Some(new $c_RTLong(lo$5, hi$5));
    }
  }
  return new $c_Lscodec_SizeBound(new $c_RTLong(lo$2, hi$2), upperBound);
});
$c_Lscodec_SizeBound.prototype.$times__J__Lscodec_SizeBound = (function(n) {
  $m_Lscodec_SizeBound$();
  var a = this.Lscodec_SizeBound__f_lowerBound;
  var alo = a.RTLong__f_lo;
  var blo = n.RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(alo, n.RTLong__f_hi) + Math.imul(a.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var this$2 = this.Lscodec_SizeBound__f_upperBound;
  if (this$2.isEmpty__Z()) {
    var upperBound = $m_s_None$();
  } else {
    var x0 = this$2.get__O();
    var t = $uJ(x0);
    var lo$1 = t.RTLong__f_lo;
    var hi$1 = t.RTLong__f_hi;
    var blo$1 = n.RTLong__f_lo;
    var a0$1 = (65535 & lo$1);
    var a1$1 = ((lo$1 >>> 16) | 0);
    var b0$1 = (65535 & blo$1);
    var b1$1 = ((blo$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0$1, b0$1);
    var a1b0$1 = Math.imul(a1$1, b0$1);
    var a0b1$1 = Math.imul(a0$1, b1$1);
    var lo$2 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$2 = ((((((((Math.imul(lo$1, n.RTLong__f_hi) + Math.imul(hi$1, blo$1)) | 0) + Math.imul(a1$1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
    var upperBound = new $c_s_Some(new $c_RTLong(lo$2, hi$2));
  }
  return new $c_Lscodec_SizeBound(new $c_RTLong(lo, hi), upperBound);
});
$c_Lscodec_SizeBound.prototype.$bar__Lscodec_SizeBound__Lscodec_SizeBound = (function(that) {
  $m_Lscodec_SizeBound$();
  var t = this.Lscodec_SizeBound__f_lowerBound;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = that.Lscodec_SizeBound__f_lowerBound;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if (((hi === hi$1) ? ((lo >>> 0) < (lo$1 >>> 0)) : (hi < hi$1))) {
    var lowerBound__lo = lo;
    var lowerBound__hi = hi;
  } else {
    var lowerBound__lo = lo$1;
    var lowerBound__hi = hi$1;
  }
  var this$6 = this.Lscodec_SizeBound__f_upperBound;
  if (this$6.isEmpty__Z()) {
    var upperBound = $m_s_None$();
  } else {
    var x0 = this$6.get__O();
    var t$2 = $uJ(x0);
    var lo$2 = t$2.RTLong__f_lo;
    var hi$2 = t$2.RTLong__f_hi;
    var this$7 = that.Lscodec_SizeBound__f_upperBound;
    if (this$7.isEmpty__Z()) {
      var upperBound = $m_s_None$();
    } else {
      var x0$1 = this$7.get__O();
      var t$3 = $uJ(x0$1);
      var lo$3 = t$3.RTLong__f_lo;
      var hi$3 = t$3.RTLong__f_hi;
      if (((hi$2 === hi$3) ? ((lo$2 >>> 0) > (lo$3 >>> 0)) : (hi$2 > hi$3))) {
        var x__lo = lo$2;
        var x__hi = hi$2;
      } else {
        var x__lo = lo$3;
        var x__hi = hi$3;
      }
      var upperBound = new $c_s_Some(new $c_RTLong(x__lo, x__hi));
    }
  }
  return new $c_Lscodec_SizeBound(new $c_RTLong(lowerBound__lo, lowerBound__hi), upperBound);
});
$c_Lscodec_SizeBound.prototype.toString__T = (function() {
  var x8 = this.Lscodec_SizeBound__f_upperBound;
  if ((x8 instanceof $c_s_Some)) {
    var t = $uJ(x8.s_Some__f_value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var a = this.Lscodec_SizeBound__f_lowerBound;
    if (((a.RTLong__f_lo === lo) && (a.RTLong__f_hi === hi))) {
      var this$2 = $m_RTLong$();
      return this$2.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi);
    }
    return (((("[" + this.Lscodec_SizeBound__f_lowerBound) + ", ") + new $c_RTLong(lo, hi)) + "]");
  }
  var x = $m_s_None$();
  if ((x === x8)) {
    return (("[" + this.Lscodec_SizeBound__f_lowerBound) + ", \u221e)");
  }
  throw new $c_s_MatchError(x8);
});
function $isArrayOf_Lscodec_SizeBound(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_SizeBound)));
}
export { $isArrayOf_Lscodec_SizeBound as $isArrayOf_Lscodec_SizeBound };
var $d_Lscodec_SizeBound = new $TypeData().initClass($c_Lscodec_SizeBound, "scodec.SizeBound", ({
  Lscodec_SizeBound: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_SizeBound as $d_Lscodec_SizeBound };
function $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C($thiz, i) {
  return $m_Lscodec_bits_Bases$Alphabets$Base64UrlBase$().Lscodec_bits_Bases$Alphabets$Base64UrlBase$__f_scodec$bits$Bases$Alphabets$Base64UrlBase$$$Chars.u[i];
}
export { $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C as $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C };
function $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toIndex__C__I($thiz, c) {
  if (((c >= 65) && (c <= 90))) {
    return (((-65) + c) | 0);
  }
  if (((c >= 97) && (c <= 122))) {
    return (((-71) + c) | 0);
  }
  if (((c >= 48) && (c <= 57))) {
    return ((4 + c) | 0);
  }
  if ((c === 45)) {
    return 62;
  }
  if ((c === 95)) {
    return 63;
  }
  if ($f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__ignore__C__Z($thiz, c)) {
    return (-1);
  }
  throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
}
export { $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toIndex__C__I as $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toIndex__C__I };
function $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__ignore__C__Z($thiz, c) {
  var this$3 = $m_jl_Character$();
  return this$3.isWhitespace__I__Z(c);
}
export { $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__ignore__C__Z as $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__ignore__C__Z };
/** @constructor */
function $c_Lscodec_bits_Bases$Alphabets$HexLowercase$() {
  this.Lscodec_bits_Bases$Alphabets$HexLowercase$__f_Chars = null;
  $n_Lscodec_bits_Bases$Alphabets$HexLowercase$ = this;
  this.Lscodec_bits_Bases$Alphabets$HexLowercase$__f_Chars = new $ac_C(new Uint16Array([48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 97, 98, 99, 100, 101, 102]));
}
export { $c_Lscodec_bits_Bases$Alphabets$HexLowercase$ as $c_Lscodec_bits_Bases$Alphabets$HexLowercase$ };
$c_Lscodec_bits_Bases$Alphabets$HexLowercase$.prototype = new $h_Lscodec_bits_Bases$Alphabets$LenientHex();
$c_Lscodec_bits_Bases$Alphabets$HexLowercase$.prototype.constructor = $c_Lscodec_bits_Bases$Alphabets$HexLowercase$;
/** @constructor */
function $h_Lscodec_bits_Bases$Alphabets$HexLowercase$() {
}
export { $h_Lscodec_bits_Bases$Alphabets$HexLowercase$ as $h_Lscodec_bits_Bases$Alphabets$HexLowercase$ };
$h_Lscodec_bits_Bases$Alphabets$HexLowercase$.prototype = $c_Lscodec_bits_Bases$Alphabets$HexLowercase$.prototype;
$c_Lscodec_bits_Bases$Alphabets$HexLowercase$.prototype.toChar__I__C = (function(i) {
  return this.Lscodec_bits_Bases$Alphabets$HexLowercase$__f_Chars.u[i];
});
var $d_Lscodec_bits_Bases$Alphabets$HexLowercase$ = new $TypeData().initClass($c_Lscodec_bits_Bases$Alphabets$HexLowercase$, "scodec.bits.Bases$Alphabets$HexLowercase$", ({
  Lscodec_bits_Bases$Alphabets$HexLowercase$: 1,
  Lscodec_bits_Bases$Alphabets$LenientHex: 1,
  Lscodec_bits_Bases$Alphabet: 1,
  Lscodec_bits_Bases$HexAlphabet: 1
}));
export { $d_Lscodec_bits_Bases$Alphabets$HexLowercase$ as $d_Lscodec_bits_Bases$Alphabets$HexLowercase$ };
var $n_Lscodec_bits_Bases$Alphabets$HexLowercase$;
function $m_Lscodec_bits_Bases$Alphabets$HexLowercase$() {
  if ((!$n_Lscodec_bits_Bases$Alphabets$HexLowercase$)) {
    $n_Lscodec_bits_Bases$Alphabets$HexLowercase$ = new $c_Lscodec_bits_Bases$Alphabets$HexLowercase$();
  }
  return $n_Lscodec_bits_Bases$Alphabets$HexLowercase$;
}
export { $m_Lscodec_bits_Bases$Alphabets$HexLowercase$ as $m_Lscodec_bits_Bases$Alphabets$HexLowercase$ };
/** @constructor */
function $c_Lscodec_bits_ByteVector$View(at, offset, size) {
  this.Lscodec_bits_ByteVector$View__f_at = null;
  this.Lscodec_bits_ByteVector$View__f_offset = $L0;
  this.Lscodec_bits_ByteVector$View__f_size = $L0;
  this.Lscodec_bits_ByteVector$View__f_at = at;
  this.Lscodec_bits_ByteVector$View__f_offset = offset;
  this.Lscodec_bits_ByteVector$View__f_size = size;
}
export { $c_Lscodec_bits_ByteVector$View as $c_Lscodec_bits_ByteVector$View };
$c_Lscodec_bits_ByteVector$View.prototype = new $h_O();
$c_Lscodec_bits_ByteVector$View.prototype.constructor = $c_Lscodec_bits_ByteVector$View;
/** @constructor */
function $h_Lscodec_bits_ByteVector$View() {
}
export { $h_Lscodec_bits_ByteVector$View as $h_Lscodec_bits_ByteVector$View };
$h_Lscodec_bits_ByteVector$View.prototype = $c_Lscodec_bits_ByteVector$View.prototype;
$c_Lscodec_bits_ByteVector$View.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_bits_ByteVector$View.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("View");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lscodec_bits_ByteVector$View__f_at;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var t = this.Lscodec_bits_ByteVector$View__f_offset;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$2 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var t$1 = this.Lscodec_bits_ByteVector$View__f_size;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var data$3 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$1, hi$1));
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lscodec_bits_ByteVector$View.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscodec_bits_ByteVector$View)) {
    var a = this.Lscodec_bits_ByteVector$View__f_offset;
    var b = x$0.Lscodec_bits_ByteVector$View__f_offset;
    if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
      var a$1 = this.Lscodec_bits_ByteVector$View__f_size;
      var b$1 = x$0.Lscodec_bits_ByteVector$View__f_size;
      var $x_1 = ((a$1.RTLong__f_lo === b$1.RTLong__f_lo) && (a$1.RTLong__f_hi === b$1.RTLong__f_hi));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x = this.Lscodec_bits_ByteVector$View__f_at;
      var x$2 = x$0.Lscodec_bits_ByteVector$View__f_at;
      return (x === x$2);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lscodec_bits_ByteVector$View.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lscodec_bits_ByteVector$View.prototype.productArity__I = (function() {
  return 3;
});
$c_Lscodec_bits_ByteVector$View.prototype.productPrefix__T = (function() {
  return "View";
});
$c_Lscodec_bits_ByteVector$View.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lscodec_bits_ByteVector$View__f_at;
      break;
    }
    case 1: {
      return this.Lscodec_bits_ByteVector$View__f_offset;
      break;
    }
    case 2: {
      return this.Lscodec_bits_ByteVector$View__f_size;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lscodec_bits_ByteVector$View.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "at";
      break;
    }
    case 1: {
      return "offset";
      break;
    }
    case 2: {
      return "size";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lscodec_bits_ByteVector$View.prototype.apply__J__B = (function(n) {
  var $x_1 = this.Lscodec_bits_ByteVector$View__f_at;
  var a = this.Lscodec_bits_ByteVector$View__f_offset;
  var alo = a.RTLong__f_lo;
  var blo = n.RTLong__f_lo;
  var lo = ((alo + blo) | 0);
  var hi = ((((a.RTLong__f_hi + n.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
  return $x_1.apply__J__B(new $c_RTLong(lo, hi));
});
$c_Lscodec_bits_ByteVector$View.prototype.foreach__Lscodec_bits_ByteVector$F1BU__V = (function(f) {
  var i__lo = 0;
  var i__hi = 0;
  while (true) {
    var a__lo = i__lo;
    var a__hi = i__hi;
    var b = this.Lscodec_bits_ByteVector$View__f_size;
    var ahi = a__hi;
    var bhi = b.RTLong__f_hi;
    if (((ahi === bhi) ? ((a__lo >>> 0) < (b.RTLong__f_lo >>> 0)) : (ahi < bhi))) {
      var $x_1 = this.Lscodec_bits_ByteVector$View__f_at;
      var a$1 = this.Lscodec_bits_ByteVector$View__f_offset;
      var b$1__lo = i__lo;
      var b$1__hi = i__hi;
      var alo = a$1.RTLong__f_lo;
      var blo = b$1__lo;
      var lo = ((alo + blo) | 0);
      var hi = ((((a$1.RTLong__f_hi + b$1__hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
      f.apply__B__V($x_1.apply__J__B(new $c_RTLong(lo, hi)));
      var b$2__lo = i__lo;
      var b$2__hi = i__hi;
      var blo$1 = b$2__lo;
      var lo$1 = ((1 + blo$1) | 0);
      var hi$1 = ((b$2__hi + (((blo$1 & (~lo$1)) >>> 31) | 0)) | 0);
      var $x_2__lo = lo$1;
      var $x_2__hi = hi$1;
      i__lo = $x_2__lo;
      i__hi = $x_2__hi;
    } else {
      break;
    }
  }
});
$c_Lscodec_bits_ByteVector$View.prototype.asByteBuffer__Ljava_nio_ByteBuffer = (function() {
  return this.Lscodec_bits_ByteVector$View__f_at.asByteBuffer__J__I__Ljava_nio_ByteBuffer(this.Lscodec_bits_ByteVector$View__f_offset, $m_Lscodec_bits_ByteVector$().toIntSize__J__I(this.Lscodec_bits_ByteVector$View__f_size));
});
$c_Lscodec_bits_ByteVector$View.prototype.copyToArray__AB__I__V = (function(xs, start) {
  this.Lscodec_bits_ByteVector$View__f_at.copyToArray__AB__I__J__I__V(xs, start, this.Lscodec_bits_ByteVector$View__f_offset, $m_Lscodec_bits_ByteVector$().toIntSize__J__I(this.Lscodec_bits_ByteVector$View__f_size));
});
$c_Lscodec_bits_ByteVector$View.prototype.take__J__Lscodec_bits_ByteVector$View = (function(n) {
  var ahi = n.RTLong__f_hi;
  if (((ahi === 0) ? (n.RTLong__f_lo === 0) : (ahi < 0))) {
    return $m_Lscodec_bits_ByteVector$View$().Lscodec_bits_ByteVector$View$__f_empty;
  } else {
    var b = this.Lscodec_bits_ByteVector$View__f_size;
    var ahi$1 = n.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    if (((ahi$1 === bhi) ? ((n.RTLong__f_lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (ahi$1 > bhi))) {
      return this;
    } else {
      $m_Lscodec_bits_ByteVector$View$();
      var at = this.Lscodec_bits_ByteVector$View__f_at;
      var t = this.Lscodec_bits_ByteVector$View__f_offset;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return new $c_Lscodec_bits_ByteVector$View(at, new $c_RTLong(lo, hi), n);
    }
  }
});
$c_Lscodec_bits_ByteVector$View.prototype.drop__J__Lscodec_bits_ByteVector$View = (function(n) {
  var ahi = n.RTLong__f_hi;
  if (((ahi === 0) ? (n.RTLong__f_lo === 0) : (ahi < 0))) {
    return this;
  } else {
    var b = this.Lscodec_bits_ByteVector$View__f_size;
    var ahi$1 = n.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    if (((ahi$1 === bhi) ? ((n.RTLong__f_lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (ahi$1 > bhi))) {
      return $m_Lscodec_bits_ByteVector$View$().Lscodec_bits_ByteVector$View$__f_empty;
    } else {
      $m_Lscodec_bits_ByteVector$View$();
      var at = this.Lscodec_bits_ByteVector$View__f_at;
      var a = this.Lscodec_bits_ByteVector$View__f_offset;
      var alo = a.RTLong__f_lo;
      var blo = n.RTLong__f_lo;
      var lo = ((alo + blo) | 0);
      var hi = ((((a.RTLong__f_hi + n.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
      var a$1 = this.Lscodec_bits_ByteVector$View__f_size;
      var alo$1 = a$1.RTLong__f_lo;
      var blo$1 = n.RTLong__f_lo;
      var lo$1 = ((alo$1 - blo$1) | 0);
      var hi$1 = ((((a$1.RTLong__f_hi - n.RTLong__f_hi) | 0) + ((((~alo$1) & blo$1) | ((~(alo$1 ^ blo$1)) & lo$1)) >> 31)) | 0);
      return new $c_Lscodec_bits_ByteVector$View(at, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
    }
  }
});
function $isArrayOf_Lscodec_bits_ByteVector$View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_ByteVector$View)));
}
export { $isArrayOf_Lscodec_bits_ByteVector$View as $isArrayOf_Lscodec_bits_ByteVector$View };
var $d_Lscodec_bits_ByteVector$View = new $TypeData().initClass($c_Lscodec_bits_ByteVector$View, "scodec.bits.ByteVector$View", ({
  Lscodec_bits_ByteVector$View: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_bits_ByteVector$View as $d_Lscodec_bits_ByteVector$View };
function $p_Lscodec_codecs_BigIntCodec__description__T($thiz) {
  return ((($thiz.Lscodec_codecs_BigIntCodec__f_bits + "-bit ") + ($thiz.Lscodec_codecs_BigIntCodec__f_signed ? "signed" : "unsigned")) + " integer");
}
export { $p_Lscodec_codecs_BigIntCodec__description__T as $p_Lscodec_codecs_BigIntCodec__description__T };
/** @constructor */
function $c_Lscodec_codecs_BigIntCodec(bits, signed, ordering) {
  this.Lscodec_codecs_BigIntCodec__f_bits = 0;
  this.Lscodec_codecs_BigIntCodec__f_signed = false;
  this.Lscodec_codecs_BigIntCodec__f_ordering = null;
  this.Lscodec_codecs_BigIntCodec__f_MaxValue = null;
  this.Lscodec_codecs_BigIntCodec__f_MinValue = null;
  this.Lscodec_codecs_BigIntCodec__f_bitsL = $L0;
  this.Lscodec_codecs_BigIntCodec__f_bits = bits;
  this.Lscodec_codecs_BigIntCodec__f_signed = signed;
  this.Lscodec_codecs_BigIntCodec__f_ordering = ordering;
  var requirement = (bits > 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bits must be non-zero");
  }
  var $x_1 = $m_s_package$().BigInt__s_math_BigInt$().apply__J__s_math_BigInt(new $c_RTLong(1, 0)).$less$less__I__s_math_BigInt((signed ? (((-1) + bits) | 0) : bits));
  var this$2 = $m_s_math_BigInt$();
  this.Lscodec_codecs_BigIntCodec__f_MaxValue = $x_1.$minus__s_math_BigInt__s_math_BigInt(this$2.apply__I__s_math_BigInt(1));
  this.Lscodec_codecs_BigIntCodec__f_MinValue = (signed ? $m_s_package$().BigInt__s_math_BigInt$().apply__J__s_math_BigInt(new $c_RTLong(1, 0)).$less$less__I__s_math_BigInt((((-1) + bits) | 0)).unary_$minus__s_math_BigInt() : $m_s_package$().BigInt__s_math_BigInt$().apply__I__s_math_BigInt(0));
  var hi = (bits >> 31);
  this.Lscodec_codecs_BigIntCodec__f_bitsL = new $c_RTLong(bits, hi);
}
export { $c_Lscodec_codecs_BigIntCodec as $c_Lscodec_codecs_BigIntCodec };
$c_Lscodec_codecs_BigIntCodec.prototype = new $h_O();
$c_Lscodec_codecs_BigIntCodec.prototype.constructor = $c_Lscodec_codecs_BigIntCodec;
/** @constructor */
function $h_Lscodec_codecs_BigIntCodec() {
}
export { $h_Lscodec_codecs_BigIntCodec as $h_Lscodec_codecs_BigIntCodec };
$h_Lscodec_codecs_BigIntCodec.prototype = $c_Lscodec_codecs_BigIntCodec.prototype;
$c_Lscodec_codecs_BigIntCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().exact__J__Lscodec_SizeBound(this.Lscodec_codecs_BigIntCodec__f_bitsL);
});
$c_Lscodec_codecs_BigIntCodec.prototype.encode__s_math_BigInt__Lscodec_Attempt = (function(i) {
  var that = this.Lscodec_codecs_BigIntCodec__f_MaxValue;
  if ($f_s_math_Ordered__$greater__O__Z(i, that)) {
    var message = ((((i + " is greater than maximum value ") + this.Lscodec_codecs_BigIntCodec__f_MaxValue) + " for ") + $p_Lscodec_codecs_BigIntCodec__description__T(this));
    var err = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message);
    return new $c_Lscodec_Attempt$Failure(err);
  } else {
    var that$1 = this.Lscodec_codecs_BigIntCodec__f_MinValue;
    if ($f_s_math_Ordered__$less__O__Z(i, that$1)) {
      var message$1 = ((((i + " is less than minimum value ") + this.Lscodec_codecs_BigIntCodec__f_MinValue) + " for ") + $p_Lscodec_codecs_BigIntCodec__description__T(this));
      var err$1 = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message$1);
      return new $c_Lscodec_Attempt$Failure(err$1);
    } else {
      var $x_1 = $m_Lscodec_bits_BitVector$();
      var value = this.Lscodec_codecs_BigIntCodec__f_bits;
      var a = $x_1.fromBigInt__s_math_BigInt__s_Option__Lscodec_bits_ByteOrdering__Lscodec_bits_BitVector(i, new $c_s_Some(value), this.Lscodec_codecs_BigIntCodec__f_ordering);
      return new $c_Lscodec_Attempt$Successful(a);
    }
  }
});
$c_Lscodec_codecs_BigIntCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  if (buffer.sizeGreaterThanOrEqual__J__Z(this.Lscodec_codecs_BigIntCodec__f_bitsL)) {
    var value = buffer.take__J__Lscodec_bits_BitVector(this.Lscodec_codecs_BigIntCodec__f_bitsL).toBigInt__Z__Lscodec_bits_ByteOrdering__s_math_BigInt(this.Lscodec_codecs_BigIntCodec__f_signed, this.Lscodec_codecs_BigIntCodec__f_ordering);
    var remainder = buffer.drop__J__Lscodec_bits_BitVector(this.Lscodec_codecs_BigIntCodec__f_bitsL);
    var a = new $c_Lscodec_DecodeResult(value, remainder);
    return new $c_Lscodec_Attempt$Successful(a);
  } else {
    var t = this.Lscodec_codecs_BigIntCodec__f_bitsL;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = buffer.size__J();
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var err = $ct_Lscodec_Err$InsufficientBits__J__J__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
    return new $c_Lscodec_Attempt$Failure(err);
  }
});
$c_Lscodec_codecs_BigIntCodec.prototype.toString__T = (function() {
  return $p_Lscodec_codecs_BigIntCodec__description__T(this);
});
$c_Lscodec_codecs_BigIntCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__s_math_BigInt__Lscodec_Attempt(value);
});
var $d_Lscodec_codecs_BigIntCodec = new $TypeData().initClass($c_Lscodec_codecs_BigIntCodec, "scodec.codecs.BigIntCodec", ({
  Lscodec_codecs_BigIntCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_BigIntCodec as $d_Lscodec_codecs_BigIntCodec };
function $p_Lscodec_codecs_ByteCodec__description__T($thiz) {
  return ((($thiz.Lscodec_codecs_ByteCodec__f_bits + "-bit ") + ($thiz.Lscodec_codecs_ByteCodec__f_signed ? "signed" : "unsigned")) + " byte");
}
export { $p_Lscodec_codecs_ByteCodec__description__T as $p_Lscodec_codecs_ByteCodec__description__T };
/** @constructor */
function $c_Lscodec_codecs_ByteCodec(bits, signed) {
  this.Lscodec_codecs_ByteCodec__f_bits = 0;
  this.Lscodec_codecs_ByteCodec__f_signed = false;
  this.Lscodec_codecs_ByteCodec__f_MaxValue = 0;
  this.Lscodec_codecs_ByteCodec__f_MinValue = 0;
  this.Lscodec_codecs_ByteCodec__f_bits = bits;
  this.Lscodec_codecs_ByteCodec__f_signed = signed;
  var requirement = ((bits > 0) && (bits <= (signed ? 8 : 7)));
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bits must be in range [1, 8] for signed and [1, 7] for unsigned");
  }
  this.Lscodec_codecs_ByteCodec__f_MaxValue = (((((-1) + (1 << (signed ? (((-1) + bits) | 0) : bits))) | 0) << 24) >> 24);
  this.Lscodec_codecs_ByteCodec__f_MinValue = (((signed ? ((-(1 << (((-1) + bits) | 0))) | 0) : 0) << 24) >> 24);
}
export { $c_Lscodec_codecs_ByteCodec as $c_Lscodec_codecs_ByteCodec };
$c_Lscodec_codecs_ByteCodec.prototype = new $h_O();
$c_Lscodec_codecs_ByteCodec.prototype.constructor = $c_Lscodec_codecs_ByteCodec;
/** @constructor */
function $h_Lscodec_codecs_ByteCodec() {
}
export { $h_Lscodec_codecs_ByteCodec as $h_Lscodec_codecs_ByteCodec };
$h_Lscodec_codecs_ByteCodec.prototype = $c_Lscodec_codecs_ByteCodec.prototype;
$c_Lscodec_codecs_ByteCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  var $x_1 = $m_Lscodec_SizeBound$();
  var value = this.Lscodec_codecs_ByteCodec__f_bits;
  var hi = (value >> 31);
  return $x_1.exact__J__Lscodec_SizeBound(new $c_RTLong(value, hi));
});
$c_Lscodec_codecs_ByteCodec.prototype.encode__B__Lscodec_Attempt = (function(b) {
  if ((b > this.Lscodec_codecs_ByteCodec__f_MaxValue)) {
    var message = ((((b + " is greater than maximum value ") + this.Lscodec_codecs_ByteCodec__f_MaxValue) + " for ") + $p_Lscodec_codecs_ByteCodec__description__T(this));
    var err = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message);
    return new $c_Lscodec_Attempt$Failure(err);
  } else if ((b < this.Lscodec_codecs_ByteCodec__f_MinValue)) {
    var message$1 = ((((b + " is less than minimum value ") + this.Lscodec_codecs_ByteCodec__f_MinValue) + " for ") + $p_Lscodec_codecs_ByteCodec__description__T(this));
    var err$1 = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message$1);
    return new $c_Lscodec_Attempt$Failure(err$1);
  } else {
    var a = $m_Lscodec_bits_BitVector$().fromByte__B__I__Lscodec_bits_BitVector(b, this.Lscodec_codecs_ByteCodec__f_bits);
    return new $c_Lscodec_Attempt$Successful(a);
  }
});
$c_Lscodec_codecs_ByteCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  var value = this.Lscodec_codecs_ByteCodec__f_bits;
  var hi = (value >> 31);
  var x1 = buffer.acquire__J__s_util_Either(new $c_RTLong(value, hi));
  if ((x1 instanceof $c_s_util_Left)) {
    var value$1 = this.Lscodec_codecs_ByteCodec__f_bits;
    var hi$1 = (value$1 >> 31);
    var t = buffer.size__J();
    var lo = t.RTLong__f_lo;
    var hi$2 = t.RTLong__f_hi;
    var err = $ct_Lscodec_Err$InsufficientBits__J__J__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(value$1, hi$1), new $c_RTLong(lo, hi$2));
    return new $c_Lscodec_Attempt$Failure(err);
  }
  if ((x1 instanceof $c_s_util_Right)) {
    var b = x1.s_util_Right__f_value;
    var value$3 = b.toByte__Z__B(this.Lscodec_codecs_ByteCodec__f_signed);
    var value$2 = this.Lscodec_codecs_ByteCodec__f_bits;
    var hi$3 = (value$2 >> 31);
    var remainder = buffer.drop__J__Lscodec_bits_BitVector(new $c_RTLong(value$2, hi$3));
    var a = new $c_Lscodec_DecodeResult(value$3, remainder);
    return new $c_Lscodec_Attempt$Successful(a);
  }
  throw new $c_s_MatchError(x1);
});
$c_Lscodec_codecs_ByteCodec.prototype.toString__T = (function() {
  return $p_Lscodec_codecs_ByteCodec__description__T(this);
});
$c_Lscodec_codecs_ByteCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__B__Lscodec_Attempt((value | 0));
});
var $d_Lscodec_codecs_ByteCodec = new $TypeData().initClass($c_Lscodec_codecs_ByteCodec, "scodec.codecs.ByteCodec", ({
  Lscodec_codecs_ByteCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_ByteCodec as $d_Lscodec_codecs_ByteCodec };
/** @constructor */
function $c_Lscodec_codecs_DiscriminatorCodec$Case(tag, prism) {
  this.Lscodec_codecs_DiscriminatorCodec$Case__f_tag = null;
  this.Lscodec_codecs_DiscriminatorCodec$Case__f_prism = null;
  this.Lscodec_codecs_DiscriminatorCodec$Case__f_tag = tag;
  this.Lscodec_codecs_DiscriminatorCodec$Case__f_prism = prism;
}
export { $c_Lscodec_codecs_DiscriminatorCodec$Case as $c_Lscodec_codecs_DiscriminatorCodec$Case };
$c_Lscodec_codecs_DiscriminatorCodec$Case.prototype = new $h_O();
$c_Lscodec_codecs_DiscriminatorCodec$Case.prototype.constructor = $c_Lscodec_codecs_DiscriminatorCodec$Case;
/** @constructor */
function $h_Lscodec_codecs_DiscriminatorCodec$Case() {
}
export { $h_Lscodec_codecs_DiscriminatorCodec$Case as $h_Lscodec_codecs_DiscriminatorCodec$Case };
$h_Lscodec_codecs_DiscriminatorCodec$Case.prototype = $c_Lscodec_codecs_DiscriminatorCodec$Case.prototype;
$c_Lscodec_codecs_DiscriminatorCodec$Case.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_codecs_DiscriminatorCodec$Case.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lscodec_codecs_DiscriminatorCodec$Case.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscodec_codecs_DiscriminatorCodec$Case)) {
    var x = this.Lscodec_codecs_DiscriminatorCodec$Case__f_tag;
    var y = x$0.Lscodec_codecs_DiscriminatorCodec$Case__f_tag;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lscodec_codecs_DiscriminatorCodec$Case__f_prism;
      var x$2 = x$0.Lscodec_codecs_DiscriminatorCodec$Case__f_prism;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lscodec_codecs_DiscriminatorCodec$Case.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lscodec_codecs_DiscriminatorCodec$Case.prototype.productArity__I = (function() {
  return 2;
});
$c_Lscodec_codecs_DiscriminatorCodec$Case.prototype.productPrefix__T = (function() {
  return "Case";
});
$c_Lscodec_codecs_DiscriminatorCodec$Case.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_codecs_DiscriminatorCodec$Case__f_tag;
  }
  if ((n === 1)) {
    return this.Lscodec_codecs_DiscriminatorCodec$Case__f_prism;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_codecs_DiscriminatorCodec$Case.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "tag";
  }
  if ((n === 1)) {
    return "prism";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lscodec_codecs_DiscriminatorCodec$Case(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_codecs_DiscriminatorCodec$Case)));
}
export { $isArrayOf_Lscodec_codecs_DiscriminatorCodec$Case as $isArrayOf_Lscodec_codecs_DiscriminatorCodec$Case };
var $d_Lscodec_codecs_DiscriminatorCodec$Case = new $TypeData().initClass($c_Lscodec_codecs_DiscriminatorCodec$Case, "scodec.codecs.DiscriminatorCodec$Case", ({
  Lscodec_codecs_DiscriminatorCodec$Case: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_codecs_DiscriminatorCodec$Case as $d_Lscodec_codecs_DiscriminatorCodec$Case };
/** @constructor */
function $c_Lscodec_codecs_DiscriminatorCodec$Prism(preview, review, repCodec) {
  this.Lscodec_codecs_DiscriminatorCodec$Prism__f_preview = null;
  this.Lscodec_codecs_DiscriminatorCodec$Prism__f_review = null;
  this.Lscodec_codecs_DiscriminatorCodec$Prism__f_repCodec = null;
  this.Lscodec_codecs_DiscriminatorCodec$Prism__f_preview = preview;
  this.Lscodec_codecs_DiscriminatorCodec$Prism__f_review = review;
  this.Lscodec_codecs_DiscriminatorCodec$Prism__f_repCodec = repCodec;
}
export { $c_Lscodec_codecs_DiscriminatorCodec$Prism as $c_Lscodec_codecs_DiscriminatorCodec$Prism };
$c_Lscodec_codecs_DiscriminatorCodec$Prism.prototype = new $h_O();
$c_Lscodec_codecs_DiscriminatorCodec$Prism.prototype.constructor = $c_Lscodec_codecs_DiscriminatorCodec$Prism;
/** @constructor */
function $h_Lscodec_codecs_DiscriminatorCodec$Prism() {
}
export { $h_Lscodec_codecs_DiscriminatorCodec$Prism as $h_Lscodec_codecs_DiscriminatorCodec$Prism };
$h_Lscodec_codecs_DiscriminatorCodec$Prism.prototype = $c_Lscodec_codecs_DiscriminatorCodec$Prism.prototype;
$c_Lscodec_codecs_DiscriminatorCodec$Prism.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_codecs_DiscriminatorCodec$Prism.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lscodec_codecs_DiscriminatorCodec$Prism.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscodec_codecs_DiscriminatorCodec$Prism)) {
    var x = this.Lscodec_codecs_DiscriminatorCodec$Prism__f_preview;
    var x$2 = x$0.Lscodec_codecs_DiscriminatorCodec$Prism__f_preview;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lscodec_codecs_DiscriminatorCodec$Prism__f_review;
      var x$4 = x$0.Lscodec_codecs_DiscriminatorCodec$Prism__f_review;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lscodec_codecs_DiscriminatorCodec$Prism__f_repCodec;
      var x$6 = x$0.Lscodec_codecs_DiscriminatorCodec$Prism__f_repCodec;
      return (x$5 === x$6);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lscodec_codecs_DiscriminatorCodec$Prism.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lscodec_codecs_DiscriminatorCodec$Prism.prototype.productArity__I = (function() {
  return 3;
});
$c_Lscodec_codecs_DiscriminatorCodec$Prism.prototype.productPrefix__T = (function() {
  return "Prism";
});
$c_Lscodec_codecs_DiscriminatorCodec$Prism.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lscodec_codecs_DiscriminatorCodec$Prism__f_preview;
      break;
    }
    case 1: {
      return this.Lscodec_codecs_DiscriminatorCodec$Prism__f_review;
      break;
    }
    case 2: {
      return this.Lscodec_codecs_DiscriminatorCodec$Prism__f_repCodec;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lscodec_codecs_DiscriminatorCodec$Prism.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "preview";
      break;
    }
    case 1: {
      return "review";
      break;
    }
    case 2: {
      return "repCodec";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lscodec_codecs_DiscriminatorCodec$Prism(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_codecs_DiscriminatorCodec$Prism)));
}
export { $isArrayOf_Lscodec_codecs_DiscriminatorCodec$Prism as $isArrayOf_Lscodec_codecs_DiscriminatorCodec$Prism };
var $d_Lscodec_codecs_DiscriminatorCodec$Prism = new $TypeData().initClass($c_Lscodec_codecs_DiscriminatorCodec$Prism, "scodec.codecs.DiscriminatorCodec$Prism", ({
  Lscodec_codecs_DiscriminatorCodec$Prism: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_codecs_DiscriminatorCodec$Prism as $d_Lscodec_codecs_DiscriminatorCodec$Prism };
/** @constructor */
function $c_Lscodec_codecs_DoubleCodec(ordering) {
  this.Lscodec_codecs_DoubleCodec__f_byteOrder = null;
  this.Lscodec_codecs_DoubleCodec__f_byteOrder = ordering.toJava__Ljava_nio_ByteOrder();
}
export { $c_Lscodec_codecs_DoubleCodec as $c_Lscodec_codecs_DoubleCodec };
$c_Lscodec_codecs_DoubleCodec.prototype = new $h_O();
$c_Lscodec_codecs_DoubleCodec.prototype.constructor = $c_Lscodec_codecs_DoubleCodec;
/** @constructor */
function $h_Lscodec_codecs_DoubleCodec() {
}
export { $h_Lscodec_codecs_DoubleCodec as $h_Lscodec_codecs_DoubleCodec };
$h_Lscodec_codecs_DoubleCodec.prototype = $c_Lscodec_codecs_DoubleCodec.prototype;
$c_Lscodec_codecs_DoubleCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().exact__J__Lscodec_SizeBound(new $c_RTLong(64, 0));
});
$c_Lscodec_codecs_DoubleCodec.prototype.encode__D__Lscodec_Attempt = (function(value) {
  var x$proxy1 = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(8).order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer(this.Lscodec_codecs_DoubleCodec__f_byteOrder).putDouble__D__Ljava_nio_ByteBuffer(value);
  if ((x$proxy1 === null)) {
    $m_sr_Scala3RunTime$().nnFail__E();
  }
  $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(x$proxy1);
  var a = $m_Lscodec_bits_BitVector$().view__Ljava_nio_ByteBuffer__Lscodec_bits_BitVector(x$proxy1);
  return new $c_Lscodec_Attempt$Successful(a);
});
$c_Lscodec_codecs_DoubleCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  var x1 = buffer.acquire__J__s_util_Either(new $c_RTLong(64, 0));
  if ((x1 instanceof $c_s_util_Left)) {
    var t = buffer.size__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var err = $ct_Lscodec_Err$InsufficientBits__J__J__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(64, 0), new $c_RTLong(lo, hi));
    return new $c_Lscodec_Attempt$Failure(err);
  }
  if ((x1 instanceof $c_s_util_Right)) {
    var b = x1.s_util_Right__f_value;
    var array = b.toByteVector__Lscodec_bits_ByteVector().toArray__AB();
    var length = array.u.length;
    var value = $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(array, 0, array.u.length, 0, length, false).order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer(this.Lscodec_codecs_DoubleCodec__f_byteOrder).getDouble__D();
    var remainder = buffer.drop__J__Lscodec_bits_BitVector(new $c_RTLong(64, 0));
    var a = new $c_Lscodec_DecodeResult(value, remainder);
    return new $c_Lscodec_Attempt$Successful(a);
  }
  throw new $c_s_MatchError(x1);
});
$c_Lscodec_codecs_DoubleCodec.prototype.toString__T = (function() {
  return "double";
});
$c_Lscodec_codecs_DoubleCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__D__Lscodec_Attempt((+value));
});
var $d_Lscodec_codecs_DoubleCodec = new $TypeData().initClass($c_Lscodec_codecs_DoubleCodec, "scodec.codecs.DoubleCodec", ({
  Lscodec_codecs_DoubleCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_DoubleCodec as $d_Lscodec_codecs_DoubleCodec };
/** @constructor */
function $c_Lscodec_codecs_FixedSizeCodec(size, codec) {
  this.Lscodec_codecs_FixedSizeCodec__f_size = $L0;
  this.Lscodec_codecs_FixedSizeCodec__f_codec = null;
  this.Lscodec_codecs_FixedSizeCodec__f_size = size;
  this.Lscodec_codecs_FixedSizeCodec__f_codec = codec;
}
export { $c_Lscodec_codecs_FixedSizeCodec as $c_Lscodec_codecs_FixedSizeCodec };
$c_Lscodec_codecs_FixedSizeCodec.prototype = new $h_O();
$c_Lscodec_codecs_FixedSizeCodec.prototype.constructor = $c_Lscodec_codecs_FixedSizeCodec;
/** @constructor */
function $h_Lscodec_codecs_FixedSizeCodec() {
}
export { $h_Lscodec_codecs_FixedSizeCodec as $h_Lscodec_codecs_FixedSizeCodec };
$h_Lscodec_codecs_FixedSizeCodec.prototype = $c_Lscodec_codecs_FixedSizeCodec.prototype;
$c_Lscodec_codecs_FixedSizeCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().exact__J__Lscodec_SizeBound(this.Lscodec_codecs_FixedSizeCodec__f_size);
});
$c_Lscodec_codecs_FixedSizeCodec.prototype.encode__O__Lscodec_Attempt = (function(a) {
  return this.Lscodec_codecs_FixedSizeCodec__f_codec.encode__O__Lscodec_Attempt(a).flatMap__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((encoded) => {
    var a$1 = encoded.size__J();
    var b = this.Lscodec_codecs_FixedSizeCodec__f_size;
    var ahi = a$1.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    if (((ahi === bhi) ? ((a$1.RTLong__f_lo >>> 0) > (b.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
      var message = (((((("[" + a) + "] requires ") + encoded.size__J()) + " bits but field is fixed size of ") + this.Lscodec_codecs_FixedSizeCodec__f_size) + " bits");
      var err = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message);
      var $x_1 = new $c_Lscodec_Attempt$Failure(err);
    } else {
      var t = this.Lscodec_codecs_FixedSizeCodec__f_size;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var a$2 = encoded.padRight__J__Lscodec_bits_BitVector(new $c_RTLong(lo, hi));
      var $x_1 = new $c_Lscodec_Attempt$Successful(a$2);
    }
    return $x_1.map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((result) => result)));
  })));
});
$c_Lscodec_codecs_FixedSizeCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  if (buffer.sizeGreaterThanOrEqual__J__Z(this.Lscodec_codecs_FixedSizeCodec__f_size)) {
    return this.Lscodec_codecs_FixedSizeCodec__f_codec.decode__Lscodec_bits_BitVector__Lscodec_Attempt(buffer.take__J__Lscodec_bits_BitVector(this.Lscodec_codecs_FixedSizeCodec__f_size)).map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((res) => {
      var value = res.Lscodec_DecodeResult__f_value;
      var remainder = buffer.drop__J__Lscodec_bits_BitVector(this.Lscodec_codecs_FixedSizeCodec__f_size);
      return new $c_Lscodec_DecodeResult(value, remainder);
    })));
  } else {
    var t = this.Lscodec_codecs_FixedSizeCodec__f_size;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = buffer.size__J();
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var err = $ct_Lscodec_Err$InsufficientBits__J__J__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
    return new $c_Lscodec_Attempt$Failure(err);
  }
});
$c_Lscodec_codecs_FixedSizeCodec.prototype.toString__T = (function() {
  return (((("fixedSizeBits(" + this.Lscodec_codecs_FixedSizeCodec__f_size) + ", ") + this.Lscodec_codecs_FixedSizeCodec__f_codec) + ")");
});
var $d_Lscodec_codecs_FixedSizeCodec = new $TypeData().initClass($c_Lscodec_codecs_FixedSizeCodec, "scodec.codecs.FixedSizeCodec", ({
  Lscodec_codecs_FixedSizeCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_FixedSizeCodec as $d_Lscodec_codecs_FixedSizeCodec };
/** @constructor */
function $c_Lscodec_codecs_FloatCodec(ordering) {
  this.Lscodec_codecs_FloatCodec__f_ordering = null;
  this.Lscodec_codecs_FloatCodec__f_byteOrder = null;
  this.Lscodec_codecs_FloatCodec__f_ordering = ordering;
  this.Lscodec_codecs_FloatCodec__f_byteOrder = ordering.toJava__Ljava_nio_ByteOrder();
}
export { $c_Lscodec_codecs_FloatCodec as $c_Lscodec_codecs_FloatCodec };
$c_Lscodec_codecs_FloatCodec.prototype = new $h_O();
$c_Lscodec_codecs_FloatCodec.prototype.constructor = $c_Lscodec_codecs_FloatCodec;
/** @constructor */
function $h_Lscodec_codecs_FloatCodec() {
}
export { $h_Lscodec_codecs_FloatCodec as $h_Lscodec_codecs_FloatCodec };
$h_Lscodec_codecs_FloatCodec.prototype = $c_Lscodec_codecs_FloatCodec.prototype;
$c_Lscodec_codecs_FloatCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().exact__J__Lscodec_SizeBound(new $c_RTLong(32, 0));
});
$c_Lscodec_codecs_FloatCodec.prototype.encode__F__Lscodec_Attempt = (function(value) {
  var x$proxy1 = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(4).order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer(this.Lscodec_codecs_FloatCodec__f_ordering.toJava__Ljava_nio_ByteOrder()).putFloat__F__Ljava_nio_ByteBuffer(value);
  if ((x$proxy1 === null)) {
    $m_sr_Scala3RunTime$().nnFail__E();
  }
  $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(x$proxy1);
  var a = $m_Lscodec_bits_BitVector$().view__Ljava_nio_ByteBuffer__Lscodec_bits_BitVector(x$proxy1);
  return new $c_Lscodec_Attempt$Successful(a);
});
$c_Lscodec_codecs_FloatCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  var x1 = buffer.acquire__J__s_util_Either(new $c_RTLong(32, 0));
  if ((x1 instanceof $c_s_util_Left)) {
    var t = buffer.size__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var err = $ct_Lscodec_Err$InsufficientBits__J__J__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(32, 0), new $c_RTLong(lo, hi));
    return new $c_Lscodec_Attempt$Failure(err);
  }
  if ((x1 instanceof $c_s_util_Right)) {
    var b = x1.s_util_Right__f_value;
    var array = b.toByteVector__Lscodec_bits_ByteVector().toArray__AB();
    var length = array.u.length;
    var value = $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(array, 0, array.u.length, 0, length, false).order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer(this.Lscodec_codecs_FloatCodec__f_byteOrder).getFloat__F();
    var remainder = buffer.drop__J__Lscodec_bits_BitVector(new $c_RTLong(32, 0));
    var a = new $c_Lscodec_DecodeResult(value, remainder);
    return new $c_Lscodec_Attempt$Successful(a);
  }
  throw new $c_s_MatchError(x1);
});
$c_Lscodec_codecs_FloatCodec.prototype.toString__T = (function() {
  return "float";
});
$c_Lscodec_codecs_FloatCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__F__Lscodec_Attempt(Math.fround(value));
});
var $d_Lscodec_codecs_FloatCodec = new $TypeData().initClass($c_Lscodec_codecs_FloatCodec, "scodec.codecs.FloatCodec", ({
  Lscodec_codecs_FloatCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_FloatCodec as $d_Lscodec_codecs_FloatCodec };
function $p_Lscodec_codecs_IntCodec__description__T($thiz) {
  return ((($thiz.Lscodec_codecs_IntCodec__f_bits + "-bit ") + ($thiz.Lscodec_codecs_IntCodec__f_signed ? "signed" : "unsigned")) + " integer");
}
export { $p_Lscodec_codecs_IntCodec__description__T as $p_Lscodec_codecs_IntCodec__description__T };
/** @constructor */
function $c_Lscodec_codecs_IntCodec(bits, signed, ordering) {
  this.Lscodec_codecs_IntCodec__f_bits = 0;
  this.Lscodec_codecs_IntCodec__f_signed = false;
  this.Lscodec_codecs_IntCodec__f_ordering = null;
  this.Lscodec_codecs_IntCodec__f_MaxValue = 0;
  this.Lscodec_codecs_IntCodec__f_MinValue = 0;
  this.Lscodec_codecs_IntCodec__f_bitsL = $L0;
  this.Lscodec_codecs_IntCodec__f_bits = bits;
  this.Lscodec_codecs_IntCodec__f_signed = signed;
  this.Lscodec_codecs_IntCodec__f_ordering = ordering;
  var requirement = ((bits > 0) && (bits <= (signed ? 32 : 31)));
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bits must be in range [1, 32] for signed and [1, 31] for unsigned");
  }
  this.Lscodec_codecs_IntCodec__f_MaxValue = (((-1) + (1 << (signed ? (((-1) + bits) | 0) : bits))) | 0);
  this.Lscodec_codecs_IntCodec__f_MinValue = (signed ? ((-(1 << (((-1) + bits) | 0))) | 0) : 0);
  var hi = (bits >> 31);
  this.Lscodec_codecs_IntCodec__f_bitsL = new $c_RTLong(bits, hi);
}
export { $c_Lscodec_codecs_IntCodec as $c_Lscodec_codecs_IntCodec };
$c_Lscodec_codecs_IntCodec.prototype = new $h_O();
$c_Lscodec_codecs_IntCodec.prototype.constructor = $c_Lscodec_codecs_IntCodec;
/** @constructor */
function $h_Lscodec_codecs_IntCodec() {
}
export { $h_Lscodec_codecs_IntCodec as $h_Lscodec_codecs_IntCodec };
$h_Lscodec_codecs_IntCodec.prototype = $c_Lscodec_codecs_IntCodec.prototype;
$c_Lscodec_codecs_IntCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().exact__J__Lscodec_SizeBound(this.Lscodec_codecs_IntCodec__f_bitsL);
});
$c_Lscodec_codecs_IntCodec.prototype.encode__I__Lscodec_Attempt = (function(i) {
  if ((i > this.Lscodec_codecs_IntCodec__f_MaxValue)) {
    var message = ((((i + " is greater than maximum value ") + this.Lscodec_codecs_IntCodec__f_MaxValue) + " for ") + $p_Lscodec_codecs_IntCodec__description__T(this));
    var err = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message);
    return new $c_Lscodec_Attempt$Failure(err);
  } else if ((i < this.Lscodec_codecs_IntCodec__f_MinValue)) {
    var message$1 = ((((i + " is less than minimum value ") + this.Lscodec_codecs_IntCodec__f_MinValue) + " for ") + $p_Lscodec_codecs_IntCodec__description__T(this));
    var err$1 = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message$1);
    return new $c_Lscodec_Attempt$Failure(err$1);
  } else {
    var a = $m_Lscodec_bits_BitVector$().fromInt__I__I__Lscodec_bits_ByteOrdering__Lscodec_bits_BitVector(i, this.Lscodec_codecs_IntCodec__f_bits, this.Lscodec_codecs_IntCodec__f_ordering);
    return new $c_Lscodec_Attempt$Successful(a);
  }
});
$c_Lscodec_codecs_IntCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  if (buffer.sizeGreaterThanOrEqual__J__Z(this.Lscodec_codecs_IntCodec__f_bitsL)) {
    var value = buffer.take__J__Lscodec_bits_BitVector(this.Lscodec_codecs_IntCodec__f_bitsL).toInt__Z__Lscodec_bits_ByteOrdering__I(this.Lscodec_codecs_IntCodec__f_signed, this.Lscodec_codecs_IntCodec__f_ordering);
    var remainder = buffer.drop__J__Lscodec_bits_BitVector(this.Lscodec_codecs_IntCodec__f_bitsL);
    var a = new $c_Lscodec_DecodeResult(value, remainder);
    return new $c_Lscodec_Attempt$Successful(a);
  } else {
    var t = this.Lscodec_codecs_IntCodec__f_bitsL;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = buffer.size__J();
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var err = $ct_Lscodec_Err$InsufficientBits__J__J__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
    return new $c_Lscodec_Attempt$Failure(err);
  }
});
$c_Lscodec_codecs_IntCodec.prototype.toString__T = (function() {
  return $p_Lscodec_codecs_IntCodec__description__T(this);
});
$c_Lscodec_codecs_IntCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__I__Lscodec_Attempt((value | 0));
});
var $d_Lscodec_codecs_IntCodec = new $TypeData().initClass($c_Lscodec_codecs_IntCodec, "scodec.codecs.IntCodec", ({
  Lscodec_codecs_IntCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_IntCodec as $d_Lscodec_codecs_IntCodec };
function $p_Lscodec_codecs_LongCodec__description__T($thiz) {
  return ((($thiz.Lscodec_codecs_LongCodec__f_bits + "-bit ") + ($thiz.Lscodec_codecs_LongCodec__f_signed ? "signed" : "unsigned")) + " integer");
}
export { $p_Lscodec_codecs_LongCodec__description__T as $p_Lscodec_codecs_LongCodec__description__T };
/** @constructor */
function $c_Lscodec_codecs_LongCodec(bits, signed, ordering) {
  this.Lscodec_codecs_LongCodec__f_bits = 0;
  this.Lscodec_codecs_LongCodec__f_signed = false;
  this.Lscodec_codecs_LongCodec__f_ordering = null;
  this.Lscodec_codecs_LongCodec__f_MaxValue = $L0;
  this.Lscodec_codecs_LongCodec__f_MinValue = $L0;
  this.Lscodec_codecs_LongCodec__f_bitsL = $L0;
  this.Lscodec_codecs_LongCodec__f_bits = bits;
  this.Lscodec_codecs_LongCodec__f_signed = signed;
  this.Lscodec_codecs_LongCodec__f_ordering = ordering;
  var requirement = ((bits > 0) && (bits <= (signed ? 64 : 63)));
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bits must be in range [1, 64] for signed and [1, 63] for unsigned");
  }
  var n = (signed ? (((-1) + bits) | 0) : bits);
  var lo = (((32 & n) === 0) ? (1 << n) : 0);
  var hi = (((32 & n) === 0) ? 0 : (1 << n));
  var lo$1 = (((-1) + lo) | 0);
  var hi$1 = (((((-1) + hi) | 0) + (((lo | (~lo$1)) >>> 31) | 0)) | 0);
  this.Lscodec_codecs_LongCodec__f_MaxValue = new $c_RTLong(lo$1, hi$1);
  if (signed) {
    var n$1 = (((-1) + bits) | 0);
    var lo$2 = (((32 & n$1) === 0) ? (1 << n$1) : 0);
    var hi$2 = (((32 & n$1) === 0) ? 0 : (1 << n$1));
    var lo$3 = ((-lo$2) | 0);
    var hi$3 = ((((-hi$2) | 0) + ((lo$2 | lo$3) >> 31)) | 0);
    var x__lo = lo$3;
    var x__hi = hi$3;
    var $x_1 = new $c_RTLong(x__lo, x__hi);
  } else {
    var $x_1 = $L0;
  }
  this.Lscodec_codecs_LongCodec__f_MinValue = $x_1;
  var hi$4 = (bits >> 31);
  this.Lscodec_codecs_LongCodec__f_bitsL = new $c_RTLong(bits, hi$4);
}
export { $c_Lscodec_codecs_LongCodec as $c_Lscodec_codecs_LongCodec };
$c_Lscodec_codecs_LongCodec.prototype = new $h_O();
$c_Lscodec_codecs_LongCodec.prototype.constructor = $c_Lscodec_codecs_LongCodec;
/** @constructor */
function $h_Lscodec_codecs_LongCodec() {
}
export { $h_Lscodec_codecs_LongCodec as $h_Lscodec_codecs_LongCodec };
$h_Lscodec_codecs_LongCodec.prototype = $c_Lscodec_codecs_LongCodec.prototype;
$c_Lscodec_codecs_LongCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().exact__J__Lscodec_SizeBound(this.Lscodec_codecs_LongCodec__f_bitsL);
});
$c_Lscodec_codecs_LongCodec.prototype.encode__J__Lscodec_Attempt = (function(i) {
  var b = this.Lscodec_codecs_LongCodec__f_MaxValue;
  var ahi = i.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? ((i.RTLong__f_lo >>> 0) > (b.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
    var message = ((((i + " is greater than maximum value ") + this.Lscodec_codecs_LongCodec__f_MaxValue) + " for ") + $p_Lscodec_codecs_LongCodec__description__T(this));
    var err = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message);
    return new $c_Lscodec_Attempt$Failure(err);
  } else {
    var b$1 = this.Lscodec_codecs_LongCodec__f_MinValue;
    var ahi$1 = i.RTLong__f_hi;
    var bhi$1 = b$1.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? ((i.RTLong__f_lo >>> 0) < (b$1.RTLong__f_lo >>> 0)) : (ahi$1 < bhi$1))) {
      var message$1 = ((((i + " is less than minimum value ") + this.Lscodec_codecs_LongCodec__f_MinValue) + " for ") + $p_Lscodec_codecs_LongCodec__description__T(this));
      var err$1 = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message$1);
      return new $c_Lscodec_Attempt$Failure(err$1);
    } else {
      var a = $m_Lscodec_bits_BitVector$().fromLong__J__I__Lscodec_bits_ByteOrdering__Lscodec_bits_BitVector(i, this.Lscodec_codecs_LongCodec__f_bits, this.Lscodec_codecs_LongCodec__f_ordering);
      return new $c_Lscodec_Attempt$Successful(a);
    }
  }
});
$c_Lscodec_codecs_LongCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  if (buffer.sizeGreaterThanOrEqual__J__Z(this.Lscodec_codecs_LongCodec__f_bitsL)) {
    var t = buffer.take__J__Lscodec_bits_BitVector(this.Lscodec_codecs_LongCodec__f_bitsL).toLong__Z__Lscodec_bits_ByteOrdering__J(this.Lscodec_codecs_LongCodec__f_signed, this.Lscodec_codecs_LongCodec__f_ordering);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var remainder = buffer.drop__J__Lscodec_bits_BitVector(this.Lscodec_codecs_LongCodec__f_bitsL);
    var a = new $c_Lscodec_DecodeResult(new $c_RTLong(lo, hi), remainder);
    return new $c_Lscodec_Attempt$Successful(a);
  } else {
    var t$1 = this.Lscodec_codecs_LongCodec__f_bitsL;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var t$2 = buffer.size__J();
    var lo$2 = t$2.RTLong__f_lo;
    var hi$2 = t$2.RTLong__f_hi;
    var err = $ct_Lscodec_Err$InsufficientBits__J__J__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(lo$1, hi$1), new $c_RTLong(lo$2, hi$2));
    return new $c_Lscodec_Attempt$Failure(err);
  }
});
$c_Lscodec_codecs_LongCodec.prototype.toString__T = (function() {
  return $p_Lscodec_codecs_LongCodec__description__T(this);
});
$c_Lscodec_codecs_LongCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__J__Lscodec_Attempt($uJ(value));
});
var $d_Lscodec_codecs_LongCodec = new $TypeData().initClass($c_Lscodec_codecs_LongCodec, "scodec.codecs.LongCodec", ({
  Lscodec_codecs_LongCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_LongCodec as $d_Lscodec_codecs_LongCodec };
/** @constructor */
function $c_Lscodec_codecs_ProvideCodec(value) {
  this.Lscodec_codecs_ProvideCodec__f_value = null;
  this.Lscodec_codecs_ProvideCodec__f_value = value;
}
export { $c_Lscodec_codecs_ProvideCodec as $c_Lscodec_codecs_ProvideCodec };
$c_Lscodec_codecs_ProvideCodec.prototype = new $h_O();
$c_Lscodec_codecs_ProvideCodec.prototype.constructor = $c_Lscodec_codecs_ProvideCodec;
/** @constructor */
function $h_Lscodec_codecs_ProvideCodec() {
}
export { $h_Lscodec_codecs_ProvideCodec as $h_Lscodec_codecs_ProvideCodec };
$h_Lscodec_codecs_ProvideCodec.prototype = $c_Lscodec_codecs_ProvideCodec.prototype;
$c_Lscodec_codecs_ProvideCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().exact__J__Lscodec_SizeBound($L0);
});
$c_Lscodec_codecs_ProvideCodec.prototype.encode__O__Lscodec_Attempt = (function(a) {
  var a$1 = $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_empty;
  return new $c_Lscodec_Attempt$Successful(a$1);
});
$c_Lscodec_codecs_ProvideCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(bv) {
  var value = this.Lscodec_codecs_ProvideCodec__f_value;
  var a = new $c_Lscodec_DecodeResult(value, bv);
  return new $c_Lscodec_Attempt$Successful(a);
});
$c_Lscodec_codecs_ProvideCodec.prototype.toString__T = (function() {
  return (("provide(" + this.Lscodec_codecs_ProvideCodec__f_value) + ")");
});
var $d_Lscodec_codecs_ProvideCodec = new $TypeData().initClass($c_Lscodec_codecs_ProvideCodec, "scodec.codecs.ProvideCodec", ({
  Lscodec_codecs_ProvideCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_ProvideCodec as $d_Lscodec_codecs_ProvideCodec };
function $p_Lscodec_codecs_ShortCodec__description__T($thiz) {
  return ((($thiz.Lscodec_codecs_ShortCodec__f_bits + "-bit ") + ($thiz.Lscodec_codecs_ShortCodec__f_signed ? "signed" : "unsigned")) + " short");
}
export { $p_Lscodec_codecs_ShortCodec__description__T as $p_Lscodec_codecs_ShortCodec__description__T };
/** @constructor */
function $c_Lscodec_codecs_ShortCodec(bits, signed, ordering) {
  this.Lscodec_codecs_ShortCodec__f_bits = 0;
  this.Lscodec_codecs_ShortCodec__f_signed = false;
  this.Lscodec_codecs_ShortCodec__f_ordering = null;
  this.Lscodec_codecs_ShortCodec__f_MaxValue = 0;
  this.Lscodec_codecs_ShortCodec__f_MinValue = 0;
  this.Lscodec_codecs_ShortCodec__f_bitsL = $L0;
  this.Lscodec_codecs_ShortCodec__f_bits = bits;
  this.Lscodec_codecs_ShortCodec__f_signed = signed;
  this.Lscodec_codecs_ShortCodec__f_ordering = ordering;
  var requirement = ((bits > 0) && (bits <= (signed ? 16 : 15)));
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: bits must be in range [1, 16] for signed and [1, 15] for unsigned");
  }
  this.Lscodec_codecs_ShortCodec__f_MaxValue = (((((-1) + (1 << (signed ? (((-1) + bits) | 0) : bits))) | 0) << 16) >> 16);
  this.Lscodec_codecs_ShortCodec__f_MinValue = (((signed ? ((-(1 << (((-1) + bits) | 0))) | 0) : 0) << 16) >> 16);
  var hi = (bits >> 31);
  this.Lscodec_codecs_ShortCodec__f_bitsL = new $c_RTLong(bits, hi);
}
export { $c_Lscodec_codecs_ShortCodec as $c_Lscodec_codecs_ShortCodec };
$c_Lscodec_codecs_ShortCodec.prototype = new $h_O();
$c_Lscodec_codecs_ShortCodec.prototype.constructor = $c_Lscodec_codecs_ShortCodec;
/** @constructor */
function $h_Lscodec_codecs_ShortCodec() {
}
export { $h_Lscodec_codecs_ShortCodec as $h_Lscodec_codecs_ShortCodec };
$h_Lscodec_codecs_ShortCodec.prototype = $c_Lscodec_codecs_ShortCodec.prototype;
$c_Lscodec_codecs_ShortCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  var $x_1 = $m_Lscodec_SizeBound$();
  var value = this.Lscodec_codecs_ShortCodec__f_bits;
  var hi = (value >> 31);
  return $x_1.exact__J__Lscodec_SizeBound(new $c_RTLong(value, hi));
});
$c_Lscodec_codecs_ShortCodec.prototype.encode__S__Lscodec_Attempt = (function(s) {
  if ((s > this.Lscodec_codecs_ShortCodec__f_MaxValue)) {
    var message = ((((s + " is greater than maximum value ") + this.Lscodec_codecs_ShortCodec__f_MaxValue) + " for ") + $p_Lscodec_codecs_ShortCodec__description__T(this));
    var err = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message);
    return new $c_Lscodec_Attempt$Failure(err);
  } else if ((s < this.Lscodec_codecs_ShortCodec__f_MinValue)) {
    var message$1 = ((((s + " is less than minimum value ") + this.Lscodec_codecs_ShortCodec__f_MinValue) + " for ") + $p_Lscodec_codecs_ShortCodec__description__T(this));
    var err$1 = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message$1);
    return new $c_Lscodec_Attempt$Failure(err$1);
  } else {
    var a = $m_Lscodec_bits_BitVector$().fromShort__S__I__Lscodec_bits_ByteOrdering__Lscodec_bits_BitVector(s, this.Lscodec_codecs_ShortCodec__f_bits, this.Lscodec_codecs_ShortCodec__f_ordering);
    return new $c_Lscodec_Attempt$Successful(a);
  }
});
$c_Lscodec_codecs_ShortCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  if (buffer.sizeGreaterThanOrEqual__J__Z(this.Lscodec_codecs_ShortCodec__f_bitsL)) {
    var value = buffer.take__J__Lscodec_bits_BitVector(this.Lscodec_codecs_ShortCodec__f_bitsL).toShort__Z__Lscodec_bits_ByteOrdering__S(this.Lscodec_codecs_ShortCodec__f_signed, this.Lscodec_codecs_ShortCodec__f_ordering);
    var remainder = buffer.drop__J__Lscodec_bits_BitVector(this.Lscodec_codecs_ShortCodec__f_bitsL);
    var a = new $c_Lscodec_DecodeResult(value, remainder);
    return new $c_Lscodec_Attempt$Successful(a);
  } else {
    var t = this.Lscodec_codecs_ShortCodec__f_bitsL;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = buffer.size__J();
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var err = $ct_Lscodec_Err$InsufficientBits__J__J__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
    return new $c_Lscodec_Attempt$Failure(err);
  }
});
$c_Lscodec_codecs_ShortCodec.prototype.toString__T = (function() {
  return $p_Lscodec_codecs_ShortCodec__description__T(this);
});
$c_Lscodec_codecs_ShortCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__S__Lscodec_Attempt((value | 0));
});
var $d_Lscodec_codecs_ShortCodec = new $TypeData().initClass($c_Lscodec_codecs_ShortCodec, "scodec.codecs.ShortCodec", ({
  Lscodec_codecs_ShortCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_ShortCodec as $d_Lscodec_codecs_ShortCodec };
/** @constructor */
function $c_Lscodec_codecs_StringCodec(charset) {
  this.Lscodec_codecs_StringCodec__f_charset = null;
  this.Lscodec_codecs_StringCodec__f_charset = charset;
}
export { $c_Lscodec_codecs_StringCodec as $c_Lscodec_codecs_StringCodec };
$c_Lscodec_codecs_StringCodec.prototype = new $h_O();
$c_Lscodec_codecs_StringCodec.prototype.constructor = $c_Lscodec_codecs_StringCodec;
/** @constructor */
function $h_Lscodec_codecs_StringCodec() {
}
export { $h_Lscodec_codecs_StringCodec as $h_Lscodec_codecs_StringCodec };
$h_Lscodec_codecs_StringCodec.prototype = $c_Lscodec_codecs_StringCodec.prototype;
$c_Lscodec_codecs_StringCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().Lscodec_SizeBound$__f_unknown;
});
$c_Lscodec_codecs_StringCodec.prototype.encode__T__Lscodec_Attempt = (function(str) {
  var x$proxy1 = this.Lscodec_codecs_StringCodec__f_charset.newEncoder__Ljava_nio_charset_CharsetEncoder();
  if ((x$proxy1 === null)) {
    $m_sr_Scala3RunTime$().nnFail__E();
  }
  var this$1 = $m_Ljava_nio_CharBuffer$();
  var x$proxy2 = this$1.wrap__jl_CharSequence__I__I__Ljava_nio_CharBuffer(str, 0, str.length);
  if ((x$proxy2 === null)) {
    $m_sr_Scala3RunTime$().nnFail__E();
  }
  try {
    var $x_1 = $m_Lscodec_bits_BitVector$();
    var x$proxy3 = x$proxy1.encode__Ljava_nio_CharBuffer__Ljava_nio_ByteBuffer(x$proxy2);
    if ((x$proxy3 === null)) {
      $m_sr_Scala3RunTime$().nnFail__E();
    }
    var a = $x_1.apply__Ljava_nio_ByteBuffer__Lscodec_bits_BitVector(x$proxy3);
    return new $c_Lscodec_Attempt$Successful(a);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchAlts1: {
      matchAlts2: {
        if ((e$2 instanceof $c_Ljava_nio_charset_MalformedInputException)) {
          break matchAlts2;
        }
        if ((e$2 instanceof $c_Ljava_nio_charset_UnmappableCharacterException)) {
          break matchAlts2;
        }
        break matchAlts1;
      }
      var this$4 = this.Lscodec_codecs_StringCodec__f_charset;
      var message = (((this$4.Ljava_nio_charset_Charset__f_canonicalName + " cannot encode character '") + $cToS(x$proxy2.charAt__I__C(0))) + "'");
      var err = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message);
      return new $c_Lscodec_Attempt$Failure(err);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
$c_Lscodec_codecs_StringCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  var x$proxy4 = this.Lscodec_codecs_StringCodec__f_charset.newDecoder__Ljava_nio_charset_CharsetDecoder();
  if ((x$proxy4 === null)) {
    $m_sr_Scala3RunTime$().nnFail__E();
  }
  try {
    var array = buffer.toByteVector__Lscodec_bits_ByteVector().toArray__AB();
    var length = array.u.length;
    var asBuffer = $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(array, 0, array.u.length, 0, length, false);
    var value = x$proxy4.decode__Ljava_nio_ByteBuffer__Ljava_nio_CharBuffer(asBuffer).toString__T();
    var remainder = $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_empty;
    var a = new $c_Lscodec_DecodeResult(value, remainder);
    return new $c_Lscodec_Attempt$Successful(a);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchAlts3: {
      matchAlts4: {
        if ((e$2 instanceof $c_Ljava_nio_charset_MalformedInputException)) {
          break matchAlts4;
        }
        if ((e$2 instanceof $c_Ljava_nio_charset_UnmappableCharacterException)) {
          break matchAlts4;
        }
        break matchAlts3;
      }
      var this$5 = this.Lscodec_codecs_StringCodec__f_charset;
      var $x_1 = this$5.Ljava_nio_charset_Charset__f_canonicalName;
      var this$6 = buffer.toByteVector__Lscodec_bits_ByteVector();
      var message = ((($x_1 + " cannot decode string from '0x") + this$6.toHex__Lscodec_bits_Bases$HexAlphabet__T($m_Lscodec_bits_Bases$Alphabets$HexLowercase$())) + "'");
      var err = $ct_Lscodec_Err$General__T__(new $c_Lscodec_Err$General(), message);
      return new $c_Lscodec_Attempt$Failure(err);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
$c_Lscodec_codecs_StringCodec.prototype.toString__T = (function() {
  var this$1 = this.Lscodec_codecs_StringCodec__f_charset;
  var x$proxy5 = this$1.Ljava_nio_charset_Charset__f_canonicalName;
  if ((x$proxy5 === null)) {
    $m_sr_Scala3RunTime$().nnFail__E();
  }
  return x$proxy5;
});
$c_Lscodec_codecs_StringCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__T__Lscodec_Attempt(value);
});
var $d_Lscodec_codecs_StringCodec = new $TypeData().initClass($c_Lscodec_codecs_StringCodec, "scodec.codecs.StringCodec", ({
  Lscodec_codecs_StringCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_StringCodec as $d_Lscodec_codecs_StringCodec };
/** @constructor */
function $c_Lscodec_codecs_UuidCodec$() {
  this.Lscodec_codecs_UuidCodec$__f_mkUUID = null;
  this.Lscodec_codecs_UuidCodec$__f_sizeBound = null;
  $n_Lscodec_codecs_UuidCodec$ = this;
  this.Lscodec_codecs_UuidCodec$__f_mkUUID = new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$1, _$2) => {
    var t = $uJ(_$1);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = $uJ(_$2);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    return new $c_ju_UUID(new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
  }));
  this.Lscodec_codecs_UuidCodec$__f_sizeBound = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_int64.sizeBound__Lscodec_SizeBound().$times__J__Lscodec_SizeBound(new $c_RTLong(2, 0));
}
export { $c_Lscodec_codecs_UuidCodec$ as $c_Lscodec_codecs_UuidCodec$ };
$c_Lscodec_codecs_UuidCodec$.prototype = new $h_O();
$c_Lscodec_codecs_UuidCodec$.prototype.constructor = $c_Lscodec_codecs_UuidCodec$;
/** @constructor */
function $h_Lscodec_codecs_UuidCodec$() {
}
export { $h_Lscodec_codecs_UuidCodec$ as $h_Lscodec_codecs_UuidCodec$ };
$h_Lscodec_codecs_UuidCodec$.prototype = $c_Lscodec_codecs_UuidCodec$.prototype;
$c_Lscodec_codecs_UuidCodec$.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_codecs_UuidCodec$__f_sizeBound;
});
$c_Lscodec_codecs_UuidCodec$.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(bits) {
  var this$1 = $m_Lscodec_Codec$();
  var decA = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_int64;
  var decB = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_int64;
  var f = this.Lscodec_codecs_UuidCodec$__f_mkUUID;
  return $f_Lscodec_DecoderFunctions__decodeBothCombine__Lscodec_Decoder__Lscodec_Decoder__Lscodec_bits_BitVector__F2__Lscodec_Attempt(this$1, decA, decB, bits, f);
});
$c_Lscodec_codecs_UuidCodec$.prototype.toString__T = (function() {
  return "uuid";
});
$c_Lscodec_codecs_UuidCodec$.prototype.encode__O__Lscodec_Attempt = (function(value) {
  var this$1 = $m_Lscodec_Codec$();
  var encA = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_int64;
  var encB = $m_Lscodec_codecs_codecs$package$().Lscodec_codecs_codecs$package$__f_int64;
  var t = value.ju_UUID__f_java$util$UUID$$mostSigBits;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = value.ju_UUID__f_java$util$UUID$$leastSigBits;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_Lscodec_EncoderFunctions__encodeBoth__Lscodec_Encoder__Lscodec_Encoder__O__O__Lscodec_Attempt(this$1, encA, encB, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
});
var $d_Lscodec_codecs_UuidCodec$ = new $TypeData().initClass($c_Lscodec_codecs_UuidCodec$, "scodec.codecs.UuidCodec$", ({
  Lscodec_codecs_UuidCodec$: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_UuidCodec$ as $d_Lscodec_codecs_UuidCodec$ };
var $n_Lscodec_codecs_UuidCodec$;
function $m_Lscodec_codecs_UuidCodec$() {
  if ((!$n_Lscodec_codecs_UuidCodec$)) {
    $n_Lscodec_codecs_UuidCodec$ = new $c_Lscodec_codecs_UuidCodec$();
  }
  return $n_Lscodec_codecs_UuidCodec$;
}
export { $m_Lscodec_codecs_UuidCodec$ as $m_Lscodec_codecs_UuidCodec$ };
/** @constructor */
function $c_Lscodec_codecs_VarIntCodec(ordering) {
  this.Lscodec_codecs_VarIntCodec__f_long = null;
  var this$2 = new $c_Lscodec_codecs_VarLongCodec(ordering);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    var t = $uJ(_$1);
    var lo = t.RTLong__f_lo;
    return lo;
  }));
  var g = $m_Lscodec_codecs_VarIntCodec$().Lscodec_codecs_VarIntCodec$__f_scodec$codecs$VarIntCodec$$$toPositiveLong;
  this.Lscodec_codecs_VarIntCodec__f_long = new $c_Lscodec_Codec$$anon$2(g, f, this$2);
}
export { $c_Lscodec_codecs_VarIntCodec as $c_Lscodec_codecs_VarIntCodec };
$c_Lscodec_codecs_VarIntCodec.prototype = new $h_O();
$c_Lscodec_codecs_VarIntCodec.prototype.constructor = $c_Lscodec_codecs_VarIntCodec;
/** @constructor */
function $h_Lscodec_codecs_VarIntCodec() {
}
export { $h_Lscodec_codecs_VarIntCodec as $h_Lscodec_codecs_VarIntCodec };
$h_Lscodec_codecs_VarIntCodec.prototype = $c_Lscodec_codecs_VarIntCodec.prototype;
$c_Lscodec_codecs_VarIntCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().bounded__J__J__Lscodec_SizeBound(new $c_RTLong(8, 0), new $c_RTLong(40, 0));
});
$c_Lscodec_codecs_VarIntCodec.prototype.encode__I__Lscodec_Attempt = (function(i) {
  return this.Lscodec_codecs_VarIntCodec__f_long.encode__O__Lscodec_Attempt(i);
});
$c_Lscodec_codecs_VarIntCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  return this.Lscodec_codecs_VarIntCodec__f_long.decode__Lscodec_bits_BitVector__Lscodec_Attempt(buffer);
});
$c_Lscodec_codecs_VarIntCodec.prototype.toString__T = (function() {
  return "variable-length integer";
});
$c_Lscodec_codecs_VarIntCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__I__Lscodec_Attempt((value | 0));
});
var $d_Lscodec_codecs_VarIntCodec = new $TypeData().initClass($c_Lscodec_codecs_VarIntCodec, "scodec.codecs.VarIntCodec", ({
  Lscodec_codecs_VarIntCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_VarIntCodec as $d_Lscodec_codecs_VarIntCodec };
/** @constructor */
function $c_Lscodec_codecs_VarIntZigZagCodec(ordering) {
  this.Lscodec_codecs_VarIntZigZagCodec__f_codec = null;
  this.Lscodec_codecs_VarIntZigZagCodec__f_sizeBound = null;
  var this$1 = new $c_Lscodec_codecs_VarIntCodec(ordering);
  var f = $m_Lscodec_codecs_VarIntZigZagCodec$().Lscodec_codecs_VarIntZigZagCodec$__f_scodec$codecs$VarIntZigZagCodec$$$zigZagDecode;
  var g = $m_Lscodec_codecs_VarIntZigZagCodec$().Lscodec_codecs_VarIntZigZagCodec$__f_scodec$codecs$VarIntZigZagCodec$$$zigZagEncode;
  this.Lscodec_codecs_VarIntZigZagCodec__f_codec = new $c_Lscodec_Codec$$anon$2(g, f, this$1);
  this.Lscodec_codecs_VarIntZigZagCodec__f_sizeBound = this.Lscodec_codecs_VarIntZigZagCodec__f_codec.sizeBound__Lscodec_SizeBound();
}
export { $c_Lscodec_codecs_VarIntZigZagCodec as $c_Lscodec_codecs_VarIntZigZagCodec };
$c_Lscodec_codecs_VarIntZigZagCodec.prototype = new $h_O();
$c_Lscodec_codecs_VarIntZigZagCodec.prototype.constructor = $c_Lscodec_codecs_VarIntZigZagCodec;
/** @constructor */
function $h_Lscodec_codecs_VarIntZigZagCodec() {
}
export { $h_Lscodec_codecs_VarIntZigZagCodec as $h_Lscodec_codecs_VarIntZigZagCodec };
$h_Lscodec_codecs_VarIntZigZagCodec.prototype = $c_Lscodec_codecs_VarIntZigZagCodec.prototype;
$c_Lscodec_codecs_VarIntZigZagCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_codecs_VarIntZigZagCodec__f_sizeBound;
});
$c_Lscodec_codecs_VarIntZigZagCodec.prototype.encode__I__Lscodec_Attempt = (function(i) {
  return this.Lscodec_codecs_VarIntZigZagCodec__f_codec.encode__O__Lscodec_Attempt(i);
});
$c_Lscodec_codecs_VarIntZigZagCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  return this.Lscodec_codecs_VarIntZigZagCodec__f_codec.decode__Lscodec_bits_BitVector__Lscodec_Attempt(buffer);
});
$c_Lscodec_codecs_VarIntZigZagCodec.prototype.toString__T = (function() {
  return "variable-length zig-zag signed integer";
});
$c_Lscodec_codecs_VarIntZigZagCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__I__Lscodec_Attempt((value | 0));
});
var $d_Lscodec_codecs_VarIntZigZagCodec = new $TypeData().initClass($c_Lscodec_codecs_VarIntZigZagCodec, "scodec.codecs.VarIntZigZagCodec", ({
  Lscodec_codecs_VarIntZigZagCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_VarIntZigZagCodec as $d_Lscodec_codecs_VarIntZigZagCodec };
function $p_Lscodec_codecs_VarLongCodec__runEncodingBE__J__Ljava_nio_ByteBuffer__I__I($thiz, value, buffer, size) {
  var size$tailLocal1 = size;
  var lo = value.RTLong__f_lo;
  var hi = value.RTLong__f_hi;
  var value$tailLocal1__lo = lo;
  var value$tailLocal1__hi = hi;
  while (true) {
    var a__lo = value$tailLocal1__lo;
    var a__hi = value$tailLocal1__hi;
    var value$1 = $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MoreBytesMask;
    var hi$1 = (value$1 >> 31);
    var lo$1 = (a__lo & value$1);
    var hi$2 = (a__hi & hi$1);
    if ((!((lo$1 === 0) && (hi$2 === 0)))) {
      var a$1__lo = value$tailLocal1__lo;
      var a$1__hi = value$tailLocal1__hi;
      var b = $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$RelevantDataBits;
      var lo$2 = (a$1__lo & b.RTLong__f_lo);
      var value$2 = $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MostSignificantBit;
      var lo$3 = (lo$2 | value$2);
      buffer.put__B__Ljava_nio_ByteBuffer(((lo$3 << 24) >> 24));
      var a$2__lo = value$tailLocal1__lo;
      var a$2__hi = value$tailLocal1__hi;
      var n = $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$BitsPerByte;
      var hi$6 = a$2__hi;
      var lo$4 = (((32 & n) === 0) ? (((a$2__lo >>> n) | 0) | ((hi$6 << 1) << ((31 - n) | 0))) : ((hi$6 >>> n) | 0));
      var hi$7 = (((32 & n) === 0) ? ((hi$6 >>> n) | 0) : 0);
      var size$tailLocal1$tmp1 = ((8 + size$tailLocal1) | 0);
      var $x_1__lo = lo$4;
      var $x_1__hi = hi$7;
      value$tailLocal1__lo = $x_1__lo;
      value$tailLocal1__hi = $x_1__hi;
      size$tailLocal1 = size$tailLocal1$tmp1;
    } else {
      var a$3__lo = value$tailLocal1__lo;
      var a$3__hi = value$tailLocal1__hi;
      buffer.put__B__Ljava_nio_ByteBuffer(((a$3__lo << 24) >> 24));
      return size$tailLocal1;
    }
  }
}
export { $p_Lscodec_codecs_VarLongCodec__runEncodingBE__J__Ljava_nio_ByteBuffer__I__I as $p_Lscodec_codecs_VarLongCodec__runEncodingBE__J__Ljava_nio_ByteBuffer__I__I };
function $p_Lscodec_codecs_VarLongCodec__runEncodingLE__J__Ljava_nio_ByteBuffer__I__I__I($thiz, value, buffer, size, msbMask) {
  var msbMask$tailLocal1 = msbMask;
  var size$tailLocal2 = size;
  var lo = value.RTLong__f_lo;
  var hi = value.RTLong__f_hi;
  var value$tailLocal2__lo = lo;
  var value$tailLocal2__hi = hi;
  while (true) {
    var a__lo = value$tailLocal2__lo;
    var a__hi = value$tailLocal2__hi;
    var value$1 = $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MoreBytesMask;
    var hi$1 = (value$1 >> 31);
    var lo$1 = (a__lo & value$1);
    var hi$2 = (a__hi & hi$1);
    if ((!((lo$1 === 0) && (hi$2 === 0)))) {
      var a$1__lo = value$tailLocal2__lo;
      var a$1__hi = value$tailLocal2__hi;
      var b = $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$RelevantDataBits;
      var lo$2 = (a$1__lo & b.RTLong__f_lo);
      var value$2 = msbMask$tailLocal1;
      var lo$3 = (lo$2 | value$2);
      buffer.put__B__Ljava_nio_ByteBuffer(((lo$3 << 24) >> 24));
      var a$2__lo = value$tailLocal2__lo;
      var a$2__hi = value$tailLocal2__hi;
      var n = $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$BitsPerByte;
      var hi$6 = a$2__hi;
      var lo$4 = (((32 & n) === 0) ? (((a$2__lo >>> n) | 0) | ((hi$6 << 1) << ((31 - n) | 0))) : ((hi$6 >>> n) | 0));
      var hi$7 = (((32 & n) === 0) ? ((hi$6 >>> n) | 0) : 0);
      var size$tailLocal2$tmp1 = ((8 + size$tailLocal2) | 0);
      var msbMask$tailLocal1$tmp1 = $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MostSignificantBit;
      var $x_1__lo = lo$4;
      var $x_1__hi = hi$7;
      value$tailLocal2__lo = $x_1__lo;
      value$tailLocal2__hi = $x_1__hi;
      size$tailLocal2 = size$tailLocal2$tmp1;
      msbMask$tailLocal1 = msbMask$tailLocal1$tmp1;
    } else {
      var a$3__lo = value$tailLocal2__lo;
      var a$3__hi = value$tailLocal2__hi;
      var value$3 = msbMask$tailLocal1;
      var lo$5 = (a$3__lo | value$3);
      buffer.put__B__Ljava_nio_ByteBuffer(((lo$5 << 24) >> 24));
      return size$tailLocal2;
    }
  }
}
export { $p_Lscodec_codecs_VarLongCodec__runEncodingLE__J__Ljava_nio_ByteBuffer__I__I__I as $p_Lscodec_codecs_VarLongCodec__runEncodingLE__J__Ljava_nio_ByteBuffer__I__I__I };
function $p_Lscodec_codecs_VarLongCodec__runDecodingBE__Lscodec_bits_BitVector__B__J__I__Lscodec_Attempt($thiz, buffer, byte, value, shift) {
  var shift$tailLocal1 = shift;
  var lo = value.RTLong__f_lo;
  var hi = value.RTLong__f_hi;
  var value$tailLocal3__lo = lo;
  var value$tailLocal3__hi = hi;
  var byte$tailLocal1 = byte;
  var buffer$tailLocal1 = buffer;
  while (true) {
    if (((byte$tailLocal1 & $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MostSignificantBit) !== 0)) {
      if (buffer$tailLocal1.sizeLessThan__J__Z(new $c_RTLong(8, 0))) {
        var t = buffer$tailLocal1.size__J();
        var lo$1 = t.RTLong__f_lo;
        var hi$1 = t.RTLong__f_hi;
        var context = $m_sci_Nil$();
        var err = $ct_Lscodec_Err$InsufficientBits__J__J__sci_List__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(8, 0), new $c_RTLong(lo$1, hi$1), context);
        return new $c_Lscodec_Attempt$Failure(err);
      } else {
        var nextByte = buffer$tailLocal1.take__J__Lscodec_bits_BitVector(new $c_RTLong(8, 0)).toByte__Z__B(false);
        var a__lo = value$tailLocal3__lo;
        var a__hi = value$tailLocal3__hi;
        var value$1 = nextByte;
        var hi$2 = (value$1 >> 31);
        var b = $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$RelevantDataBits;
        var lo$2 = (value$1 & b.RTLong__f_lo);
        var hi$3 = (hi$2 & b.RTLong__f_hi);
        var n = shift$tailLocal1;
        var lo$3 = (((32 & n) === 0) ? (lo$2 << n) : 0);
        var hi$4 = (((32 & n) === 0) ? (((((lo$2 >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (hi$3 << n)) : (lo$2 << n));
        var lo$4 = (a__lo | lo$3);
        var hi$5 = (a__hi | hi$4);
        var buffer$tailLocal1$tmp1 = buffer$tailLocal1.drop__J__Lscodec_bits_BitVector(new $c_RTLong(8, 0));
        var shift$tailLocal1$tmp1 = ((shift$tailLocal1 + $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$BitsPerByte) | 0);
        buffer$tailLocal1 = buffer$tailLocal1$tmp1;
        byte$tailLocal1 = nextByte;
        var $x_1__lo = lo$4;
        var $x_1__hi = hi$5;
        value$tailLocal3__lo = $x_1__lo;
        value$tailLocal3__hi = $x_1__hi;
        shift$tailLocal1 = shift$tailLocal1$tmp1;
      }
    } else {
      var value$2__lo = value$tailLocal3__lo;
      var value$2__hi = value$tailLocal3__hi;
      var remainder = buffer$tailLocal1;
      var a$1 = new $c_Lscodec_DecodeResult(new $c_RTLong(value$2__lo, value$2__hi), remainder);
      return new $c_Lscodec_Attempt$Successful(a$1);
    }
  }
}
export { $p_Lscodec_codecs_VarLongCodec__runDecodingBE__Lscodec_bits_BitVector__B__J__I__Lscodec_Attempt as $p_Lscodec_codecs_VarLongCodec__runDecodingBE__Lscodec_bits_BitVector__B__J__I__Lscodec_Attempt };
function $p_Lscodec_codecs_VarLongCodec__runDecodingLE__Lscodec_bits_BitVector__B__J__Lscodec_Attempt($thiz, buffer, byte, value) {
  var lo = value.RTLong__f_lo;
  var hi = value.RTLong__f_hi;
  var value$tailLocal4__lo = lo;
  var value$tailLocal4__hi = hi;
  var byte$tailLocal2 = byte;
  var buffer$tailLocal2 = buffer;
  while (true) {
    if (((byte$tailLocal2 & $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MostSignificantBit) !== 0)) {
      if (buffer$tailLocal2.sizeLessThan__J__Z(new $c_RTLong(8, 0))) {
        var t = buffer$tailLocal2.size__J();
        var lo$1 = t.RTLong__f_lo;
        var hi$1 = t.RTLong__f_hi;
        var context = $m_sci_Nil$();
        var err = $ct_Lscodec_Err$InsufficientBits__J__J__sci_List__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(8, 0), new $c_RTLong(lo$1, hi$1), context);
        return new $c_Lscodec_Attempt$Failure(err);
      } else {
        var nextByte = buffer$tailLocal2.take__J__Lscodec_bits_BitVector(new $c_RTLong(8, 0)).toByte__Z__B(false);
        var a__lo = value$tailLocal4__lo;
        var a__hi = value$tailLocal4__hi;
        var n = $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$BitsPerByte;
        var lo$2 = a__lo;
        var lo$3 = (((32 & n) === 0) ? (lo$2 << n) : 0);
        var hi$2 = (((32 & n) === 0) ? (((((lo$2 >>> 1) | 0) >>> ((31 - n) | 0)) | 0) | (a__hi << n)) : (lo$2 << n));
        var value$1 = nextByte;
        var hi$3 = (value$1 >> 31);
        var b = $m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$RelevantDataBits;
        var lo$4 = (value$1 & b.RTLong__f_lo);
        var hi$4 = (hi$3 & b.RTLong__f_hi);
        var lo$5 = (lo$3 | lo$4);
        var hi$5 = (hi$2 | hi$4);
        var buffer$tailLocal2$tmp1 = buffer$tailLocal2.drop__J__Lscodec_bits_BitVector(new $c_RTLong(8, 0));
        buffer$tailLocal2 = buffer$tailLocal2$tmp1;
        byte$tailLocal2 = nextByte;
        var $x_1__lo = lo$5;
        var $x_1__hi = hi$5;
        value$tailLocal4__lo = $x_1__lo;
        value$tailLocal4__hi = $x_1__hi;
      }
    } else {
      var value$2__lo = value$tailLocal4__lo;
      var value$2__hi = value$tailLocal4__hi;
      var remainder = buffer$tailLocal2;
      var a$1 = new $c_Lscodec_DecodeResult(new $c_RTLong(value$2__lo, value$2__hi), remainder);
      return new $c_Lscodec_Attempt$Successful(a$1);
    }
  }
}
export { $p_Lscodec_codecs_VarLongCodec__runDecodingLE__Lscodec_bits_BitVector__B__J__Lscodec_Attempt as $p_Lscodec_codecs_VarLongCodec__runDecodingLE__Lscodec_bits_BitVector__B__J__Lscodec_Attempt };
/** @constructor */
function $c_Lscodec_codecs_VarLongCodec(ordering) {
  this.Lscodec_codecs_VarLongCodec__f_ordering = null;
  this.Lscodec_codecs_VarLongCodec__f_sizeBound = null;
  this.Lscodec_codecs_VarLongCodec__f_BEEncoder = null;
  this.Lscodec_codecs_VarLongCodec__f_LEEncoder = null;
  this.Lscodec_codecs_VarLongCodec__f_BEDecoder = null;
  this.Lscodec_codecs_VarLongCodec__f_LEDecoder = null;
  this.Lscodec_codecs_VarLongCodec__f_ordering = ordering;
  this.Lscodec_codecs_VarLongCodec__f_sizeBound = $m_Lscodec_SizeBound$().bounded__J__J__Lscodec_SizeBound(new $c_RTLong(8, 0), new $c_RTLong(80, 0));
  this.Lscodec_codecs_VarLongCodec__f_BEEncoder = new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((value, buffer) => {
    var t = $uJ(value);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return $p_Lscodec_codecs_VarLongCodec__runEncodingBE__J__Ljava_nio_ByteBuffer__I__I(this, new $c_RTLong(lo, hi), buffer, 8);
  }));
  this.Lscodec_codecs_VarLongCodec__f_LEEncoder = new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((value$2, buffer$2) => {
    var t$1 = $uJ(value$2);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    return $p_Lscodec_codecs_VarLongCodec__runEncodingLE__J__Ljava_nio_ByteBuffer__I__I__I(this, new $c_RTLong(lo$1, hi$1), buffer$2, 8, 0);
  }));
  this.Lscodec_codecs_VarLongCodec__f_BEDecoder = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((buffer$3) => $p_Lscodec_codecs_VarLongCodec__runDecodingBE__Lscodec_bits_BitVector__B__J__I__Lscodec_Attempt(this, buffer$3, (($m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MostSignificantBit << 24) >> 24), $L0, 0)));
  this.Lscodec_codecs_VarLongCodec__f_LEDecoder = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((buffer$4) => $p_Lscodec_codecs_VarLongCodec__runDecodingLE__Lscodec_bits_BitVector__B__J__Lscodec_Attempt(this, buffer$4, (($m_Lscodec_codecs_VarLongCodec$().Lscodec_codecs_VarLongCodec$__f_scodec$codecs$VarLongCodec$$$MostSignificantBit << 24) >> 24), $L0)));
}
export { $c_Lscodec_codecs_VarLongCodec as $c_Lscodec_codecs_VarLongCodec };
$c_Lscodec_codecs_VarLongCodec.prototype = new $h_O();
$c_Lscodec_codecs_VarLongCodec.prototype.constructor = $c_Lscodec_codecs_VarLongCodec;
/** @constructor */
function $h_Lscodec_codecs_VarLongCodec() {
}
export { $h_Lscodec_codecs_VarLongCodec as $h_Lscodec_codecs_VarLongCodec };
$h_Lscodec_codecs_VarLongCodec.prototype = $c_Lscodec_codecs_VarLongCodec.prototype;
$c_Lscodec_codecs_VarLongCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_codecs_VarLongCodec__f_sizeBound;
});
$c_Lscodec_codecs_VarLongCodec.prototype.encode__J__Lscodec_Attempt = (function(i) {
  var x$proxy1 = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(10).order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer($m_Ljava_nio_ByteOrder$().Ljava_nio_ByteOrder$__f_BIG_ENDIAN);
  if ((x$proxy1 === null)) {
    $m_sr_Scala3RunTime$().nnFail__E();
  }
  var x = this.Lscodec_codecs_VarLongCodec__f_ordering;
  var x$2 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
  if (((x !== null) && (x === x$2))) {
    var encoder = this.Lscodec_codecs_VarLongCodec__f_BEEncoder;
  } else {
    var encoder = this.Lscodec_codecs_VarLongCodec__f_LEEncoder;
  }
  var written = (encoder.apply__O__O__O(i, x$proxy1) | 0);
  $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(x$proxy1);
  var $x_1 = $m_Lscodec_bits_BitVector$().view__Ljava_nio_ByteBuffer__Lscodec_bits_BitVector(x$proxy1);
  var hi = (written >> 31);
  var relevantBits = $x_1.take__J__Lscodec_bits_BitVector(new $c_RTLong(written, hi));
  var x$3 = this.Lscodec_codecs_VarLongCodec__f_ordering;
  var x$4 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
  if (((x$3 !== null) && (x$3 === x$4))) {
    var bits = relevantBits;
  } else {
    var bits = relevantBits.reverseByteOrder__Lscodec_bits_BitVector();
  }
  return new $c_Lscodec_Attempt$Successful(bits);
});
$c_Lscodec_codecs_VarLongCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  var x = this.Lscodec_codecs_VarLongCodec__f_ordering;
  var x$2 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
  if (((x !== null) && (x === x$2))) {
    var decoder = this.Lscodec_codecs_VarLongCodec__f_BEDecoder;
  } else {
    var decoder = this.Lscodec_codecs_VarLongCodec__f_LEDecoder;
  }
  return decoder.apply__O__O(buffer);
});
$c_Lscodec_codecs_VarLongCodec.prototype.toString__T = (function() {
  return "variable-length long";
});
$c_Lscodec_codecs_VarLongCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__J__Lscodec_Attempt($uJ(value));
});
var $d_Lscodec_codecs_VarLongCodec = new $TypeData().initClass($c_Lscodec_codecs_VarLongCodec, "scodec.codecs.VarLongCodec", ({
  Lscodec_codecs_VarLongCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_VarLongCodec as $d_Lscodec_codecs_VarLongCodec };
/** @constructor */
function $c_Lscodec_codecs_VarLongZigZagCodec(ordering) {
  this.Lscodec_codecs_VarLongZigZagCodec__f_codec = null;
  this.Lscodec_codecs_VarLongZigZagCodec__f_sizeBound = null;
  var this$1 = new $c_Lscodec_codecs_VarLongCodec(ordering);
  var f = $m_Lscodec_codecs_VarLongZigZagCodec$().Lscodec_codecs_VarLongZigZagCodec$__f_scodec$codecs$VarLongZigZagCodec$$$zigZagDecode;
  var g = $m_Lscodec_codecs_VarLongZigZagCodec$().Lscodec_codecs_VarLongZigZagCodec$__f_scodec$codecs$VarLongZigZagCodec$$$zigZagEncode;
  this.Lscodec_codecs_VarLongZigZagCodec__f_codec = new $c_Lscodec_Codec$$anon$2(g, f, this$1);
  this.Lscodec_codecs_VarLongZigZagCodec__f_sizeBound = this.Lscodec_codecs_VarLongZigZagCodec__f_codec.sizeBound__Lscodec_SizeBound();
}
export { $c_Lscodec_codecs_VarLongZigZagCodec as $c_Lscodec_codecs_VarLongZigZagCodec };
$c_Lscodec_codecs_VarLongZigZagCodec.prototype = new $h_O();
$c_Lscodec_codecs_VarLongZigZagCodec.prototype.constructor = $c_Lscodec_codecs_VarLongZigZagCodec;
/** @constructor */
function $h_Lscodec_codecs_VarLongZigZagCodec() {
}
export { $h_Lscodec_codecs_VarLongZigZagCodec as $h_Lscodec_codecs_VarLongZigZagCodec };
$h_Lscodec_codecs_VarLongZigZagCodec.prototype = $c_Lscodec_codecs_VarLongZigZagCodec.prototype;
$c_Lscodec_codecs_VarLongZigZagCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_codecs_VarLongZigZagCodec__f_sizeBound;
});
$c_Lscodec_codecs_VarLongZigZagCodec.prototype.encode__J__Lscodec_Attempt = (function(i) {
  return this.Lscodec_codecs_VarLongZigZagCodec__f_codec.encode__O__Lscodec_Attempt(i);
});
$c_Lscodec_codecs_VarLongZigZagCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  return this.Lscodec_codecs_VarLongZigZagCodec__f_codec.decode__Lscodec_bits_BitVector__Lscodec_Attempt(buffer);
});
$c_Lscodec_codecs_VarLongZigZagCodec.prototype.toString__T = (function() {
  return "variable-length zig-zag signed long";
});
$c_Lscodec_codecs_VarLongZigZagCodec.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__J__Lscodec_Attempt($uJ(value));
});
var $d_Lscodec_codecs_VarLongZigZagCodec = new $TypeData().initClass($c_Lscodec_codecs_VarLongZigZagCodec, "scodec.codecs.VarLongZigZagCodec", ({
  Lscodec_codecs_VarLongZigZagCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_VarLongZigZagCodec as $d_Lscodec_codecs_VarLongZigZagCodec };
function $p_Lscodec_codecs_VariableSizeCodec__fail__O__T__Lscodec_Err($thiz, a, msg) {
  var message = ((("failed to encode size of [" + a) + "]: ") + msg);
  var context = new $c_sci_$colon$colon("size", $m_sci_Nil$());
  return $ct_Lscodec_Err$General__T__sci_List__(new $c_Lscodec_Err$General(), message, context);
}
export { $p_Lscodec_codecs_VariableSizeCodec__fail__O__T__Lscodec_Err as $p_Lscodec_codecs_VariableSizeCodec__fail__O__T__Lscodec_Err };
/** @constructor */
function $c_Lscodec_codecs_VariableSizeCodec(sizeCodec, valueCodec, sizePadding) {
  this.Lscodec_codecs_VariableSizeCodec__f_sizeCodec = null;
  this.Lscodec_codecs_VariableSizeCodec__f_valueCodec = null;
  this.Lscodec_codecs_VariableSizeCodec__f_sizePadding = $L0;
  this.Lscodec_codecs_VariableSizeCodec__f_decoder = null;
  this.Lscodec_codecs_VariableSizeCodec__f_sizeCodec = sizeCodec;
  this.Lscodec_codecs_VariableSizeCodec__f_valueCodec = valueCodec;
  this.Lscodec_codecs_VariableSizeCodec__f_sizePadding = sizePadding;
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((sz) => {
    var t = $uJ(sz);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    $m_Lscodec_codecs_codecs$package$();
    var blo = sizePadding.RTLong__f_lo;
    var lo$1 = ((lo - blo) | 0);
    var hi$1 = ((((hi - sizePadding.RTLong__f_hi) | 0) + ((((~lo) & blo) | ((~(lo ^ blo)) & lo$1)) >> 31)) | 0);
    return new $c_Lscodec_codecs_FixedSizeCodec(new $c_RTLong(lo$1, hi$1), valueCodec);
  }));
  this.Lscodec_codecs_VariableSizeCodec__f_decoder = new $c_Lscodec_Decoder$$anon$2(f, sizeCodec);
}
export { $c_Lscodec_codecs_VariableSizeCodec as $c_Lscodec_codecs_VariableSizeCodec };
$c_Lscodec_codecs_VariableSizeCodec.prototype = new $h_O();
$c_Lscodec_codecs_VariableSizeCodec.prototype.constructor = $c_Lscodec_codecs_VariableSizeCodec;
/** @constructor */
function $h_Lscodec_codecs_VariableSizeCodec() {
}
export { $h_Lscodec_codecs_VariableSizeCodec as $h_Lscodec_codecs_VariableSizeCodec };
$h_Lscodec_codecs_VariableSizeCodec.prototype = $c_Lscodec_codecs_VariableSizeCodec.prototype;
$c_Lscodec_codecs_VariableSizeCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_codecs_VariableSizeCodec__f_sizeCodec.sizeBound__Lscodec_SizeBound().atLeast__Lscodec_SizeBound();
});
$c_Lscodec_codecs_VariableSizeCodec.prototype.encode__O__Lscodec_Attempt = (function(a) {
  return this.Lscodec_codecs_VariableSizeCodec__f_valueCodec.encode__O__Lscodec_Attempt(a).flatMap__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((encA) => {
    var $x_1 = this.Lscodec_codecs_VariableSizeCodec__f_sizeCodec;
    var a$1 = encA.size__J();
    var b = this.Lscodec_codecs_VariableSizeCodec__f_sizePadding;
    var alo = a$1.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var lo = ((alo + blo) | 0);
    var hi = ((((a$1.RTLong__f_hi + b.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
    return $x_1.encode__O__Lscodec_Attempt(new $c_RTLong(lo, hi)).mapErr__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e) => $p_Lscodec_codecs_VariableSizeCodec__fail__O__T__Lscodec_Err(this, a, $f_Lscodec_Err__messageWithContext__T(e))))).map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((encA$2) => ((encSize) => encSize.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(encA$2)))(encA)));
  })));
});
$c_Lscodec_codecs_VariableSizeCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  return this.Lscodec_codecs_VariableSizeCodec__f_decoder.decode__Lscodec_bits_BitVector__Lscodec_Attempt(buffer);
});
$c_Lscodec_codecs_VariableSizeCodec.prototype.toString__T = (function() {
  return (((("variableSizeBits(" + this.Lscodec_codecs_VariableSizeCodec__f_sizeCodec) + ", ") + this.Lscodec_codecs_VariableSizeCodec__f_valueCodec) + ")");
});
var $d_Lscodec_codecs_VariableSizeCodec = new $TypeData().initClass($c_Lscodec_codecs_VariableSizeCodec, "scodec.codecs.VariableSizeCodec", ({
  Lscodec_codecs_VariableSizeCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_VariableSizeCodec as $d_Lscodec_codecs_VariableSizeCodec };
/** @constructor */
function $c_Lscodec_codecs_codecs$package$$anon$1() {
}
export { $c_Lscodec_codecs_codecs$package$$anon$1 as $c_Lscodec_codecs_codecs$package$$anon$1 };
$c_Lscodec_codecs_codecs$package$$anon$1.prototype = new $h_O();
$c_Lscodec_codecs_codecs$package$$anon$1.prototype.constructor = $c_Lscodec_codecs_codecs$package$$anon$1;
/** @constructor */
function $h_Lscodec_codecs_codecs$package$$anon$1() {
}
export { $h_Lscodec_codecs_codecs$package$$anon$1 as $h_Lscodec_codecs_codecs$package$$anon$1 };
$h_Lscodec_codecs_codecs$package$$anon$1.prototype = $c_Lscodec_codecs_codecs$package$$anon$1.prototype;
$c_Lscodec_codecs_codecs$package$$anon$1.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().Lscodec_SizeBound$__f_unknown;
});
$c_Lscodec_codecs_codecs$package$$anon$1.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(buffer) {
  var remainder = $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_empty;
  var a = new $c_Lscodec_DecodeResult(buffer, remainder);
  return new $c_Lscodec_Attempt$Successful(a);
});
$c_Lscodec_codecs_codecs$package$$anon$1.prototype.toString__T = (function() {
  return "bits";
});
$c_Lscodec_codecs_codecs$package$$anon$1.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return new $c_Lscodec_Attempt$Successful(value);
});
var $d_Lscodec_codecs_codecs$package$$anon$1 = new $TypeData().initClass($c_Lscodec_codecs_codecs$package$$anon$1, "scodec.codecs.codecs$package$$anon$1", ({
  Lscodec_codecs_codecs$package$$anon$1: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_codecs$package$$anon$1 as $d_Lscodec_codecs_codecs$package$$anon$1 };
/** @constructor */
function $c_Lscodec_codecs_codecs$package$$anon$11(size$9, value$1, sizePadding$1) {
  this.Lscodec_codecs_codecs$package$$anon$11__f_size$10 = null;
  this.Lscodec_codecs_codecs$package$$anon$11__f_value$2 = null;
  this.Lscodec_codecs_codecs$package$$anon$11__f_codec = null;
  this.Lscodec_codecs_codecs$package$$anon$11__f_size$10 = size$9;
  this.Lscodec_codecs_codecs$package$$anon$11__f_value$2 = value$1;
  $m_Lscodec_codecs_codecs$package$();
  var this$2 = $m_Lscodec_Codec$given\uff3fTransform\uff3fCodec$();
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$11) => {
    var t = $uJ(_$11);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var lo$1 = (lo << 3);
    var hi$1 = (((lo >>> 29) | 0) | (hi << 3));
    return new $c_RTLong(lo$1, hi$1);
  }));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((n) => {
    var t$1 = $uJ(n);
    var lo$2 = t$1.RTLong__f_lo;
    var hi$2 = t$1.RTLong__f_hi;
    return $m_Lscodec_codecs_codecs$package$().bitsToBytesDivisible__J__Lscodec_Attempt(new $c_RTLong(lo$2, hi$2));
  }));
  var size = $f_Lscodec_Transform__widen__O__F1__F1__O(this$2, size$9, f, g);
  var lo$3 = sizePadding$1.RTLong__f_lo;
  var lo$4 = (lo$3 << 3);
  var hi$3 = (((lo$3 >>> 29) | 0) | (sizePadding$1.RTLong__f_hi << 3));
  this.Lscodec_codecs_codecs$package$$anon$11__f_codec = new $c_Lscodec_codecs_VariableSizeCodec(size, value$1, new $c_RTLong(lo$4, hi$3));
}
export { $c_Lscodec_codecs_codecs$package$$anon$11 as $c_Lscodec_codecs_codecs$package$$anon$11 };
$c_Lscodec_codecs_codecs$package$$anon$11.prototype = new $h_O();
$c_Lscodec_codecs_codecs$package$$anon$11.prototype.constructor = $c_Lscodec_codecs_codecs$package$$anon$11;
/** @constructor */
function $h_Lscodec_codecs_codecs$package$$anon$11() {
}
export { $h_Lscodec_codecs_codecs$package$$anon$11 as $h_Lscodec_codecs_codecs$package$$anon$11 };
$h_Lscodec_codecs_codecs$package$$anon$11.prototype = $c_Lscodec_codecs_codecs$package$$anon$11.prototype;
$c_Lscodec_codecs_codecs$package$$anon$11.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_codecs_codecs$package$$anon$11__f_size$10.sizeBound__Lscodec_SizeBound().$plus__Lscodec_SizeBound__Lscodec_SizeBound(this.Lscodec_codecs_codecs$package$$anon$11__f_value$2.sizeBound__Lscodec_SizeBound());
});
$c_Lscodec_codecs_codecs$package$$anon$11.prototype.encode__O__Lscodec_Attempt = (function(a) {
  return this.Lscodec_codecs_codecs$package$$anon$11__f_codec.encode__O__Lscodec_Attempt(a);
});
$c_Lscodec_codecs_codecs$package$$anon$11.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(b) {
  return this.Lscodec_codecs_codecs$package$$anon$11__f_codec.decode__Lscodec_bits_BitVector__Lscodec_Attempt(b);
});
$c_Lscodec_codecs_codecs$package$$anon$11.prototype.toString__T = (function() {
  return (((("variableSizeBytes(" + this.Lscodec_codecs_codecs$package$$anon$11__f_size$10) + ", ") + this.Lscodec_codecs_codecs$package$$anon$11__f_value$2) + ")");
});
var $d_Lscodec_codecs_codecs$package$$anon$11 = new $TypeData().initClass($c_Lscodec_codecs_codecs$package$$anon$11, "scodec.codecs.codecs$package$$anon$11", ({
  Lscodec_codecs_codecs$package$$anon$11: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_codecs$package$$anon$11 as $d_Lscodec_codecs_codecs$package$$anon$11 };
/** @constructor */
function $c_Lscodec_codecs_codecs$package$$anon$20(filter$2, codec$9) {
  this.Lscodec_codecs_codecs$package$$anon$20__f_filter$1 = null;
  this.Lscodec_codecs_codecs$package$$anon$20__f_codec$7 = null;
  this.Lscodec_codecs_codecs$package$$anon$20__f_filter$1 = filter$2;
  this.Lscodec_codecs_codecs$package$$anon$20__f_codec$7 = codec$9;
}
export { $c_Lscodec_codecs_codecs$package$$anon$20 as $c_Lscodec_codecs_codecs$package$$anon$20 };
$c_Lscodec_codecs_codecs$package$$anon$20.prototype = new $h_O();
$c_Lscodec_codecs_codecs$package$$anon$20.prototype.constructor = $c_Lscodec_codecs_codecs$package$$anon$20;
/** @constructor */
function $h_Lscodec_codecs_codecs$package$$anon$20() {
}
export { $h_Lscodec_codecs_codecs$package$$anon$20 as $h_Lscodec_codecs_codecs$package$$anon$20 };
$h_Lscodec_codecs_codecs$package$$anon$20.prototype = $c_Lscodec_codecs_codecs$package$$anon$20.prototype;
$c_Lscodec_codecs_codecs$package$$anon$20.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_codecs_codecs$package$$anon$20__f_filter$1.sizeBound__Lscodec_SizeBound();
});
$c_Lscodec_codecs_codecs$package$$anon$20.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.Lscodec_codecs_codecs$package$$anon$20__f_codec$7.encode__O__Lscodec_Attempt(value).flatMap__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value$2) => this.Lscodec_codecs_codecs$package$$anon$20__f_filter$1.encode__O__Lscodec_Attempt(value$2))));
});
$c_Lscodec_codecs_codecs$package$$anon$20.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(bits) {
  return this.Lscodec_codecs_codecs$package$$anon$20__f_filter$1.decode__Lscodec_bits_BitVector__Lscodec_Attempt(bits).flatMap__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((r) => this.Lscodec_codecs_codecs$package$$anon$20__f_codec$7.decode__Lscodec_bits_BitVector__Lscodec_Attempt(r.Lscodec_DecodeResult__f_value).map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((r$2) => ((_$29) => {
    var value = _$29.Lscodec_DecodeResult__f_value;
    var x0 = _$29.Lscodec_DecodeResult__f_remainder;
    var remainder = x0.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(r$2.Lscodec_DecodeResult__f_remainder);
    return new $c_Lscodec_DecodeResult(value, remainder);
  }))(r))))));
});
$c_Lscodec_codecs_codecs$package$$anon$20.prototype.toString__T = (function() {
  return (((("filtered(" + this.Lscodec_codecs_codecs$package$$anon$20__f_codec$7) + ", ") + this.Lscodec_codecs_codecs$package$$anon$20__f_filter$1) + ")");
});
var $d_Lscodec_codecs_codecs$package$$anon$20 = new $TypeData().initClass($c_Lscodec_codecs_codecs$package$$anon$20, "scodec.codecs.codecs$package$$anon$20", ({
  Lscodec_codecs_codecs$package$$anon$20: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_codecs$package$$anon$20 as $d_Lscodec_codecs_codecs$package$$anon$20 };
/** @constructor */
function $c_Lscodec_codecs_codecs$package$$anon$5(n$1) {
  this.Lscodec_codecs_codecs$package$$anon$5__f_n$2 = $L0;
  this.Lscodec_codecs_codecs$package$$anon$5__f_zeros = null;
  this.Lscodec_codecs_codecs$package$$anon$5__f_ones = null;
  this.Lscodec_codecs_codecs$package$$anon$5__f_codec = null;
  this.Lscodec_codecs_codecs$package$$anon$5__f_n$2 = n$1;
  var this$1 = $m_Lscodec_bits_BitVector$();
  this.Lscodec_codecs_codecs$package$$anon$5__f_zeros = this$1.fill__J__Z__Lscodec_bits_BitVector(n$1, false);
  var this$2 = $m_Lscodec_bits_BitVector$();
  this.Lscodec_codecs_codecs$package$$anon$5__f_ones = this$2.fill__J__Z__Lscodec_bits_BitVector(n$1, true);
  var this$4 = $m_Lscodec_codecs_codecs$package$().bits__J__Lscodec_Codec(n$1);
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((bits) => {
    var x$2 = this.Lscodec_codecs_codecs$package$$anon$5__f_zeros;
    return (!((bits === null) ? (x$2 === null) : bits.equals__O__Z(x$2)));
  }));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => {
    var b$1 = (!(!b));
    return (b$1 ? this.Lscodec_codecs_codecs$package$$anon$5__f_ones : this.Lscodec_codecs_codecs$package$$anon$5__f_zeros);
  }));
  this.Lscodec_codecs_codecs$package$$anon$5__f_codec = new $c_Lscodec_Codec$$anon$2(g, f, this$4);
}
export { $c_Lscodec_codecs_codecs$package$$anon$5 as $c_Lscodec_codecs_codecs$package$$anon$5 };
$c_Lscodec_codecs_codecs$package$$anon$5.prototype = new $h_O();
$c_Lscodec_codecs_codecs$package$$anon$5.prototype.constructor = $c_Lscodec_codecs_codecs$package$$anon$5;
/** @constructor */
function $h_Lscodec_codecs_codecs$package$$anon$5() {
}
export { $h_Lscodec_codecs_codecs$package$$anon$5 as $h_Lscodec_codecs_codecs$package$$anon$5 };
$h_Lscodec_codecs_codecs$package$$anon$5.prototype = $c_Lscodec_codecs_codecs$package$$anon$5.prototype;
$c_Lscodec_codecs_codecs$package$$anon$5.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().exact__J__Lscodec_SizeBound(this.Lscodec_codecs_codecs$package$$anon$5__f_n$2);
});
$c_Lscodec_codecs_codecs$package$$anon$5.prototype.encode__Z__Lscodec_Attempt = (function(b) {
  return this.Lscodec_codecs_codecs$package$$anon$5__f_codec.encode__O__Lscodec_Attempt(b);
});
$c_Lscodec_codecs_codecs$package$$anon$5.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(b) {
  return this.Lscodec_codecs_codecs$package$$anon$5__f_codec.decode__Lscodec_bits_BitVector__Lscodec_Attempt(b);
});
$c_Lscodec_codecs_codecs$package$$anon$5.prototype.toString__T = (function() {
  return (("bool(" + this.Lscodec_codecs_codecs$package$$anon$5__f_n$2) + ")");
});
$c_Lscodec_codecs_codecs$package$$anon$5.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__Z__Lscodec_Attempt((!(!value)));
});
var $d_Lscodec_codecs_codecs$package$$anon$5 = new $TypeData().initClass($c_Lscodec_codecs_codecs$package$$anon$5, "scodec.codecs.codecs$package$$anon$5", ({
  Lscodec_codecs_codecs$package$$anon$5: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_codecs$package$$anon$5 as $d_Lscodec_codecs_codecs$package$$anon$5 };
/** @constructor */
function $c_Lscodec_codecs_codecs$package$$anon$6(noNullFound$2) {
  this.Lscodec_codecs_codecs$package$$anon$6__f_noNullFound$1 = null;
  this.Lscodec_codecs_codecs$package$$anon$6__f_nul = null;
  this.Lscodec_codecs_codecs$package$$anon$6__f_noNullFound$1 = noNullFound$2;
  this.Lscodec_codecs_codecs$package$$anon$6__f_nul = $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_lowByte;
}
export { $c_Lscodec_codecs_codecs$package$$anon$6 as $c_Lscodec_codecs_codecs$package$$anon$6 };
$c_Lscodec_codecs_codecs$package$$anon$6.prototype = new $h_O();
$c_Lscodec_codecs_codecs$package$$anon$6.prototype.constructor = $c_Lscodec_codecs_codecs$package$$anon$6;
/** @constructor */
function $h_Lscodec_codecs_codecs$package$$anon$6() {
}
export { $h_Lscodec_codecs_codecs$package$$anon$6 as $h_Lscodec_codecs_codecs$package$$anon$6 };
$h_Lscodec_codecs_codecs$package$$anon$6.prototype = $c_Lscodec_codecs_codecs$package$$anon$6.prototype;
$c_Lscodec_codecs_codecs$package$$anon$6.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return $m_Lscodec_SizeBound$().Lscodec_SizeBound$__f_unknown;
});
$c_Lscodec_codecs_codecs$package$$anon$6.prototype.encode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(bits) {
  var a = bits.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(this.Lscodec_codecs_codecs$package$$anon$6__f_nul);
  return new $c_Lscodec_Attempt$Successful(a);
});
$c_Lscodec_codecs_codecs$package$$anon$6.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(bits) {
  var this$2 = bits.toByteVector__Lscodec_bits_ByteVector();
  var this$1 = this.Lscodec_codecs_codecs$package$$anon$6__f_nul;
  var slice = this$1.toByteVector__Lscodec_bits_ByteVector();
  var t = this$2.indexOfSlice__Lscodec_bits_ByteVector__J__J(slice, $L0);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (((lo === (-1)) && (hi === (-1)))) {
    var b = bits.size__J();
    var blo = b.RTLong__f_lo;
    var lo$1 = ((8 + blo) | 0);
    var hi$1 = ((b.RTLong__f_hi + (((blo & (~lo$1)) >>> 31) | 0)) | 0);
    var t$1 = bits.size__J();
    var lo$2 = t$1.RTLong__f_lo;
    var hi$2 = t$1.RTLong__f_hi;
    var context = this.Lscodec_codecs_codecs$package$$anon$6__f_noNullFound$1;
    var err = $ct_Lscodec_Err$InsufficientBits__J__J__sci_List__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(lo$1, hi$1), new $c_RTLong(lo$2, hi$2), context);
    return new $c_Lscodec_Attempt$Failure(err);
  }
  var lo$3 = (lo << 3);
  var hi$3 = (((lo >>> 29) | 0) | (hi << 3));
  var value = bits.take__J__Lscodec_bits_BitVector(new $c_RTLong(lo$3, hi$3));
  var lo$4 = (lo << 3);
  var hi$4 = (((lo >>> 29) | 0) | (hi << 3));
  var lo$5 = ((8 + lo$4) | 0);
  var hi$5 = ((hi$4 + (((lo$4 & (~lo$5)) >>> 31) | 0)) | 0);
  var remainder = bits.drop__J__Lscodec_bits_BitVector(new $c_RTLong(lo$5, hi$5));
  var a = new $c_Lscodec_DecodeResult(value, remainder);
  return new $c_Lscodec_Attempt$Successful(a);
});
$c_Lscodec_codecs_codecs$package$$anon$6.prototype.encode__O__Lscodec_Attempt = (function(value) {
  return this.encode__Lscodec_bits_BitVector__Lscodec_Attempt(value);
});
var $d_Lscodec_codecs_codecs$package$$anon$6 = new $TypeData().initClass($c_Lscodec_codecs_codecs$package$$anon$6, "scodec.codecs.codecs$package$$anon$6", ({
  Lscodec_codecs_codecs$package$$anon$6: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1
}));
export { $d_Lscodec_codecs_codecs$package$$anon$6 as $d_Lscodec_codecs_codecs$package$$anon$6 };
/** @constructor */
function $c_Lsquants_Quantity() {
}
export { $c_Lsquants_Quantity as $c_Lsquants_Quantity };
$c_Lsquants_Quantity.prototype = new $h_O();
$c_Lsquants_Quantity.prototype.constructor = $c_Lsquants_Quantity;
/** @constructor */
function $h_Lsquants_Quantity() {
}
export { $h_Lsquants_Quantity as $h_Lsquants_Quantity };
$h_Lsquants_Quantity.prototype = $c_Lsquants_Quantity.prototype;
$c_Lsquants_Quantity.prototype.compareTo__O__I = (function(that) {
  return this.compare__Lsquants_Quantity__I(that);
});
$c_Lsquants_Quantity.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_Lsquants_Quantity)) {
    var x$2 = $m_Lsquants_space_Length$();
    var x$3 = $m_Lsquants_space_Length$();
    if ($f_Lsquants_Dimension__equals__O__Z(x$2, x$3)) {
      return (this.Lsquants_space_Length__f_value === that.to__Lsquants_UnitOfMeasure__D(this.Lsquants_space_Length__f_unit));
    }
  }
  return false;
});
$c_Lsquants_Quantity.prototype.hashCode__I = (function() {
  var values = new $ac_O([$m_Lsquants_space_Length$(), this.to__Lsquants_UnitOfMeasure__D(($m_Lsquants_space_Length$(), $m_Lsquants_space_Meters$()))]);
  return $m_ju_Arrays$().hashCode__AO__I(values);
});
$c_Lsquants_Quantity.prototype.compare__Lsquants_Quantity__I = (function(that) {
  return ((this.Lsquants_space_Length__f_value > that.to__Lsquants_UnitOfMeasure__D(this.Lsquants_space_Length__f_unit)) ? 1 : ((this.Lsquants_space_Length__f_value < that.to__Lsquants_UnitOfMeasure__D(this.Lsquants_space_Length__f_unit)) ? (-1) : 0));
});
$c_Lsquants_Quantity.prototype.to__Lsquants_UnitOfMeasure__D = (function(uom) {
  var x$2 = this.Lsquants_space_Length__f_unit;
  if ((uom === x$2)) {
    return this.Lsquants_space_Length__f_value;
  } else {
    return $f_Lsquants_UnitOfMeasure__convertTo__O__s_math_Numeric__D(uom, $f_Lsquants_UnitOfMeasure__convertFrom__O__s_math_Numeric__D(this.Lsquants_space_Length__f_unit, this.Lsquants_space_Length__f_value, $m_s_math_Numeric$DoubleIsFractional$()), $m_s_math_Numeric$DoubleIsFractional$());
  }
});
$c_Lsquants_Quantity.prototype.in__Lsquants_UnitOfMeasure__Lsquants_Quantity = (function(uom) {
  var x$2 = this.Lsquants_space_Length__f_unit;
  if ((uom === x$2)) {
    return this;
  } else {
    var n = $f_Lsquants_UnitOfMeasure__convertTo__O__s_math_Numeric__D(uom, $f_Lsquants_UnitOfMeasure__convertFrom__O__s_math_Numeric__D(this.Lsquants_space_Length__f_unit, this.Lsquants_space_Length__f_value, $m_s_math_Numeric$DoubleIsFractional$()), $m_s_math_Numeric$DoubleIsFractional$());
    var num = $m_s_math_Numeric$DoubleIsFractional$();
    return $m_Lsquants_space_Length$().apply__O__Lsquants_space_LengthUnit__s_math_Numeric__Lsquants_space_Length(n, uom, num);
  }
});
$c_Lsquants_Quantity.prototype.toString__T = (function() {
  return this.toString__Lsquants_UnitOfMeasure__T(this.Lsquants_space_Length__f_unit);
});
$c_Lsquants_Quantity.prototype.toString__Lsquants_UnitOfMeasure__T = (function(uom) {
  return (($m_Lsquants_Platform$().crossFormat__D__T(this.to__Lsquants_UnitOfMeasure__D(uom)) + " ") + uom.symbol__T());
});
$c_Lsquants_Quantity.prototype.compare__O__I = (function(that) {
  return this.compare__Lsquants_Quantity__I(that);
});
function $isArrayOf_Lsquants_Quantity(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsquants_Quantity)));
}
export { $isArrayOf_Lsquants_Quantity as $isArrayOf_Lsquants_Quantity };
/** @constructor */
function $c_Lsttp_model_ContentTypeRange(mainType, subType, charset, otherParameters) {
  this.Lsttp_model_ContentTypeRange__f_mainType = null;
  this.Lsttp_model_ContentTypeRange__f_subType = null;
  this.Lsttp_model_ContentTypeRange__f_charset = null;
  this.Lsttp_model_ContentTypeRange__f_otherParameters = null;
  this.Lsttp_model_ContentTypeRange__f_mainType = mainType;
  this.Lsttp_model_ContentTypeRange__f_subType = subType;
  this.Lsttp_model_ContentTypeRange__f_charset = charset;
  this.Lsttp_model_ContentTypeRange__f_otherParameters = otherParameters;
}
export { $c_Lsttp_model_ContentTypeRange as $c_Lsttp_model_ContentTypeRange };
$c_Lsttp_model_ContentTypeRange.prototype = new $h_O();
$c_Lsttp_model_ContentTypeRange.prototype.constructor = $c_Lsttp_model_ContentTypeRange;
/** @constructor */
function $h_Lsttp_model_ContentTypeRange() {
}
export { $h_Lsttp_model_ContentTypeRange as $h_Lsttp_model_ContentTypeRange };
$h_Lsttp_model_ContentTypeRange.prototype = $c_Lsttp_model_ContentTypeRange.prototype;
$c_Lsttp_model_ContentTypeRange.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_ContentTypeRange.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_model_ContentTypeRange.prototype.productPrefix__T = (function() {
  return "ContentTypeRange";
});
$c_Lsttp_model_ContentTypeRange.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_model_ContentTypeRange__f_mainType;
      break;
    }
    case 1: {
      return this.Lsttp_model_ContentTypeRange__f_subType;
      break;
    }
    case 2: {
      return this.Lsttp_model_ContentTypeRange__f_charset;
      break;
    }
    case 3: {
      return this.Lsttp_model_ContentTypeRange__f_otherParameters;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_ContentTypeRange.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "mainType";
      break;
    }
    case 1: {
      return "subType";
      break;
    }
    case 2: {
      return "charset";
      break;
    }
    case 3: {
      return "otherParameters";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_ContentTypeRange.prototype.toString__T = (function() {
  var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 32);
  var str = this.Lsttp_model_ContentTypeRange__f_mainType;
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "/");
  var str$1 = this.Lsttp_model_ContentTypeRange__f_subType;
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
  if ((this.Lsttp_model_ContentTypeRange__f_charset !== $m_Lsttp_model_ContentTypeRange$().Lsttp_model_ContentTypeRange$__f_Wildcard)) {
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "; charset=");
    var str$2 = this.Lsttp_model_ContentTypeRange__f_charset;
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2);
  }
  this.Lsttp_model_ContentTypeRange__f_otherParameters.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var p = x$1._1__O();
      var v = x$1._2__O();
      if ((p !== "charset")) {
        sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "; ");
        sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + p);
        sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "=");
        sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + v);
        return sb;
      } else {
        return (void 0);
      }
    }
    throw new $c_s_MatchError(x$1);
  })));
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Lsttp_model_ContentTypeRange.prototype.hashCode__I = (function() {
  var this$1 = this.toString__T();
  return $f_T__hashCode__I(this$1.toLowerCase());
});
$c_Lsttp_model_ContentTypeRange.prototype.equals__O__Z = (function(that) {
  if ((that !== null)) {
    if ((this === that)) {
      return true;
    }
  }
  if ((that instanceof $c_Lsttp_model_ContentTypeRange)) {
    var this$1 = this.toString__T();
    var anotherString = that.toString__T();
    var len = this$1.length;
    if ((!((anotherString === null) || (anotherString.length !== len)))) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = this$1.charCodeAt(index);
        var $x_1 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = anotherString.charCodeAt(index$1);
        if (($x_1 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    } else {
      return false;
    }
  }
  return false;
});
function $isArrayOf_Lsttp_model_ContentTypeRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_ContentTypeRange)));
}
export { $isArrayOf_Lsttp_model_ContentTypeRange as $isArrayOf_Lsttp_model_ContentTypeRange };
var $d_Lsttp_model_ContentTypeRange = new $TypeData().initClass($c_Lsttp_model_ContentTypeRange, "sttp.model.ContentTypeRange", ({
  Lsttp_model_ContentTypeRange: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_ContentTypeRange as $d_Lsttp_model_ContentTypeRange };
function $p_Lsttp_model_MediaType__toStringCache__T($thiz) {
  if ((!$thiz.Lsttp_model_MediaType__f_toStringCachebitmap$1)) {
    var sb = $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), 32);
    var str = $thiz.Lsttp_model_MediaType__f_mainType;
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "/");
    var str$1 = $thiz.Lsttp_model_MediaType__f_subType;
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
    matchResult3: {
      var x3 = $thiz.Lsttp_model_MediaType__f_charset;
      if ((x3 instanceof $c_s_Some)) {
        sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "; charset=");
        var str$2 = x3.s_Some__f_value;
        sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2);
        break matchResult3;
      }
    }
    $thiz.Lsttp_model_MediaType__f_otherParameters.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
      if ((x$1 !== null)) {
        var p = x$1._1__O();
        var v = x$1._2__O();
        if ((p !== "charset")) {
          sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "; ");
          sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + p);
          sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "=");
          sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + v);
          return sb;
        } else {
          return (void 0);
        }
      }
      throw new $c_s_MatchError(x$1);
    })));
    $thiz.Lsttp_model_MediaType__f_toStringCache$lzy1 = sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
    $thiz.Lsttp_model_MediaType__f_toStringCachebitmap$1 = true;
  }
  return $thiz.Lsttp_model_MediaType__f_toStringCache$lzy1;
}
export { $p_Lsttp_model_MediaType__toStringCache__T as $p_Lsttp_model_MediaType__toStringCache__T };
/** @constructor */
function $c_Lsttp_model_MediaType(mainType, subType, charset, otherParameters) {
  this.Lsttp_model_MediaType__f_mainType = null;
  this.Lsttp_model_MediaType__f_subType = null;
  this.Lsttp_model_MediaType__f_charset = null;
  this.Lsttp_model_MediaType__f_otherParameters = null;
  this.Lsttp_model_MediaType__f_toStringCache$lzy1 = null;
  this.Lsttp_model_MediaType__f_toStringCachebitmap$1 = false;
  this.Lsttp_model_MediaType__f_hashCode$lzy1 = 0;
  this.Lsttp_model_MediaType__f_hashCodebitmap$1 = false;
  this.Lsttp_model_MediaType__f_otherParametersLowerCased = null;
  this.Lsttp_model_MediaType__f_mainType = mainType;
  this.Lsttp_model_MediaType__f_subType = subType;
  this.Lsttp_model_MediaType__f_charset = charset;
  this.Lsttp_model_MediaType__f_otherParameters = otherParameters;
  this.Lsttp_model_MediaType__f_otherParametersLowerCased = otherParameters.map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => {
    var this$1 = x._1__O();
    var _1 = this$1.toLowerCase();
    var this$2 = x._2__O();
    var _2 = this$2.toLowerCase();
    return $ct_T2__O__O__(new $c_T2(), _1, _2);
  })));
}
export { $c_Lsttp_model_MediaType as $c_Lsttp_model_MediaType };
$c_Lsttp_model_MediaType.prototype = new $h_O();
$c_Lsttp_model_MediaType.prototype.constructor = $c_Lsttp_model_MediaType;
/** @constructor */
function $h_Lsttp_model_MediaType() {
}
export { $h_Lsttp_model_MediaType as $h_Lsttp_model_MediaType };
$h_Lsttp_model_MediaType.prototype = $c_Lsttp_model_MediaType.prototype;
$c_Lsttp_model_MediaType.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_MediaType.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_model_MediaType.prototype.productPrefix__T = (function() {
  return "MediaType";
});
$c_Lsttp_model_MediaType.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_model_MediaType__f_mainType;
      break;
    }
    case 1: {
      return this.Lsttp_model_MediaType__f_subType;
      break;
    }
    case 2: {
      return this.Lsttp_model_MediaType__f_charset;
      break;
    }
    case 3: {
      return this.Lsttp_model_MediaType__f_otherParameters;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_MediaType.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "mainType";
      break;
    }
    case 1: {
      return "subType";
      break;
    }
    case 2: {
      return "charset";
      break;
    }
    case 3: {
      return "otherParameters";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_MediaType.prototype.charset__T__Lsttp_model_MediaType = (function(c) {
  var charset$1 = new $c_s_Some(c);
  var mainType$1 = this.Lsttp_model_MediaType__f_mainType;
  var subType$1 = this.Lsttp_model_MediaType__f_subType;
  var otherParameters$1 = this.Lsttp_model_MediaType__f_otherParameters;
  return new $c_Lsttp_model_MediaType(mainType$1, subType$1, charset$1, otherParameters$1);
});
$c_Lsttp_model_MediaType.prototype.matches__Lsttp_model_ContentTypeRange__Z = (function(range) {
  if ((range !== null)) {
    if ((range.Lsttp_model_ContentTypeRange__f_mainType === $m_Lsttp_model_ContentTypeRange$().Lsttp_model_ContentTypeRange$__f_Wildcard)) {
      var $x_2 = true;
    } else {
      var this$1 = this.Lsttp_model_MediaType__f_mainType;
      var anotherString = range.Lsttp_model_ContentTypeRange__f_mainType;
      _return: {
        var len = this$1.length;
        if ((!((anotherString === null) || (anotherString.length !== len)))) {
          var i = 0;
          while ((i !== len)) {
            var index = i;
            var c = this$1.charCodeAt(index);
            var $x_4 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
            var index$1 = i;
            var c$1 = anotherString.charCodeAt(index$1);
            if (($x_4 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
              var $x_3 = false;
              break _return;
            }
            i = ((1 + i) | 0);
          }
          var $x_3 = true;
        } else {
          var $x_3 = false;
        }
      }
      if ($x_3) {
        if ((range.Lsttp_model_ContentTypeRange__f_subType === $m_Lsttp_model_ContentTypeRange$().Lsttp_model_ContentTypeRange$__f_Wildcard)) {
          var $x_2 = true;
        } else {
          var this$2 = this.Lsttp_model_MediaType__f_subType;
          var anotherString$1 = range.Lsttp_model_ContentTypeRange__f_subType;
          _return$1: {
            var len$1 = this$2.length;
            if ((!((anotherString$1 === null) || (anotherString$1.length !== len$1)))) {
              var i$1 = 0;
              while ((i$1 !== len$1)) {
                var index$2 = i$1;
                var c$2 = this$2.charCodeAt(index$2);
                var $x_5 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$2));
                var index$3 = i$1;
                var c$3 = anotherString$1.charCodeAt(index$3);
                if (($x_5 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$3)))) {
                  var $x_2 = false;
                  break _return$1;
                }
                i$1 = ((1 + i$1) | 0);
              }
              var $x_2 = true;
            } else {
              var $x_2 = false;
            }
          }
        }
      } else {
        var $x_2 = false;
      }
    }
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    if ((range.Lsttp_model_ContentTypeRange__f_charset === $m_Lsttp_model_ContentTypeRange$().Lsttp_model_ContentTypeRange$__f_Wildcard)) {
      var $x_1 = true;
    } else {
      var this$3 = this.Lsttp_model_MediaType__f_charset;
      if (this$3.isEmpty__Z()) {
        var $x_1 = true;
      } else {
        var x0 = this$3.get__O();
        var anotherString$2 = range.Lsttp_model_ContentTypeRange__f_charset;
        _return$2: {
          var len$2 = x0.length;
          if ((!((anotherString$2 === null) || (anotherString$2.length !== len$2)))) {
            var i$2 = 0;
            while ((i$2 !== len$2)) {
              var index$4 = i$2;
              var c$4 = x0.charCodeAt(index$4);
              var $x_6 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$4));
              var index$5 = i$2;
              var c$5 = anotherString$2.charCodeAt(index$5);
              if (($x_6 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$5)))) {
                var $x_1 = false;
                break _return$2;
              }
              i$2 = ((1 + i$2) | 0);
            }
            var $x_1 = true;
          } else {
            var $x_1 = false;
          }
        }
      }
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    if (((((range.Lsttp_model_ContentTypeRange__f_mainType === $m_Lsttp_model_ContentTypeRange$().Lsttp_model_ContentTypeRange$__f_Wildcard) || (range.Lsttp_model_ContentTypeRange__f_subType === $m_Lsttp_model_ContentTypeRange$().Lsttp_model_ContentTypeRange$__f_Wildcard)) || range.Lsttp_model_ContentTypeRange__f_otherParameters.isEmpty__Z()) || ((range.Lsttp_model_ContentTypeRange__f_otherParameters.size__I() === 1) && range.Lsttp_model_ContentTypeRange__f_otherParameters.contains__O__Z("q")))) {
      return true;
    } else {
      var this$4 = range.Lsttp_model_ContentTypeRange__f_otherParameters;
      var rangeParametersWithoutQ = this$4.removed__O__sci_MapOps("q");
      var rangeOtherParametersLowerCased = rangeParametersWithoutQ.map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => {
        var this$5 = x._1__O();
        var _1 = this$5.toLowerCase();
        var this$6 = x._2__O();
        var _2 = this$6.toLowerCase();
        return $ct_T2__O__O__(new $c_T2(), _1, _2);
      })));
      var x$3 = this.Lsttp_model_MediaType__f_otherParametersLowerCased;
      return ((rangeOtherParametersLowerCased === null) ? (x$3 === null) : rangeOtherParametersLowerCased.equals__O__Z(x$3));
    }
  } else {
    return false;
  }
});
$c_Lsttp_model_MediaType.prototype.toString__T = (function() {
  return $p_Lsttp_model_MediaType__toStringCache__T(this);
});
$c_Lsttp_model_MediaType.prototype.hashCode__I = (function() {
  if ((!this.Lsttp_model_MediaType__f_hashCodebitmap$1)) {
    var this$1 = $p_Lsttp_model_MediaType__toStringCache__T(this);
    this.Lsttp_model_MediaType__f_hashCode$lzy1 = $f_T__hashCode__I(this$1.toLowerCase());
    this.Lsttp_model_MediaType__f_hashCodebitmap$1 = true;
  }
  return this.Lsttp_model_MediaType__f_hashCode$lzy1;
});
$c_Lsttp_model_MediaType.prototype.equals__O__Z = (function(that) {
  if ((that !== null)) {
    if ((this === that)) {
      return true;
    }
  }
  if ((that instanceof $c_Lsttp_model_MediaType)) {
    var this$1 = $p_Lsttp_model_MediaType__toStringCache__T(this);
    var anotherString = $p_Lsttp_model_MediaType__toStringCache__T(that);
    var len = this$1.length;
    if ((!((anotherString === null) || (anotherString.length !== len)))) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = this$1.charCodeAt(index);
        var $x_1 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = anotherString.charCodeAt(index$1);
        if (($x_1 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    } else {
      return false;
    }
  }
  return false;
});
function $isArrayOf_Lsttp_model_MediaType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_MediaType)));
}
export { $isArrayOf_Lsttp_model_MediaType as $isArrayOf_Lsttp_model_MediaType };
var $d_Lsttp_model_MediaType = new $TypeData().initClass($c_Lsttp_model_MediaType, "sttp.model.MediaType", ({
  Lsttp_model_MediaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_MediaType as $d_Lsttp_model_MediaType };
/** @constructor */
function $c_Lsttp_model_MediaType$() {
  this.Lsttp_model_MediaType$__f_ApplicationJson = null;
  this.Lsttp_model_MediaType$__f_ApplicationOctetStream = null;
  this.Lsttp_model_MediaType$__f_ApplicationXWwwFormUrlencoded = null;
  this.Lsttp_model_MediaType$__f_MultipartFormData = null;
  this.Lsttp_model_MediaType$__f_TextHtml = null;
  this.Lsttp_model_MediaType$__f_TextPlain = null;
  $n_Lsttp_model_MediaType$ = this;
  $f_Lsttp_model_MediaTypes__$init$__V(this);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("application", "problem+json", charset, otherParameters);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$1 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$1 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("application", "problem+xml", charset$1, otherParameters$1);
  $m_Lsttp_model_MediaType$();
  $m_Lsttp_model_MediaType$();
  var charset$2 = $m_s_None$();
  $m_Lsttp_model_MediaType$();
  var otherParameters$2 = $m_sci_Map$EmptyMap$();
  new $c_Lsttp_model_MediaType("application", "yaml", charset$2, otherParameters$2);
}
export { $c_Lsttp_model_MediaType$ as $c_Lsttp_model_MediaType$ };
$c_Lsttp_model_MediaType$.prototype = new $h_O();
$c_Lsttp_model_MediaType$.prototype.constructor = $c_Lsttp_model_MediaType$;
/** @constructor */
function $h_Lsttp_model_MediaType$() {
}
export { $h_Lsttp_model_MediaType$ as $h_Lsttp_model_MediaType$ };
$h_Lsttp_model_MediaType$.prototype = $c_Lsttp_model_MediaType$.prototype;
$c_Lsttp_model_MediaType$.prototype.parse__T__s_util_Either = (function(t) {
  var this$1 = $m_Lsttp_model_internal_Patterns$().Lsttp_model_internal_Patterns$__f_TypeSubtype;
  var typeSubtype = new $c_ju_regex_Matcher(this$1, t);
  if (typeSubtype.lookingAt__Z()) {
    matchResult9: {
      var \u03b41$___1;
      var \u03b41$___2;
      var _1 = typeSubtype.group__I__T(1);
      var _2 = typeSubtype.group__I__T(2);
      var _3 = typeSubtype.group__I__T(3);
      if ((((_1 === null) && (_2 === null)) && ($m_Lsttp_model_ContentTypeRange$().Lsttp_model_ContentTypeRange$__f_Wildcard === _3))) {
        var _1$1 = $m_Lsttp_model_ContentTypeRange$().Lsttp_model_ContentTypeRange$__f_Wildcard;
        var _2$1 = $m_Lsttp_model_ContentTypeRange$().Lsttp_model_ContentTypeRange$__f_Wildcard;
        var \u03b41$___1 = _1$1;
        var \u03b41$___2 = _2$1;
        break matchResult9;
      }
      var _1$2 = _1.toLowerCase();
      var _2$2 = _2.toLowerCase();
      var \u03b41$___1 = _1$2;
      var \u03b41$___2 = _2$2;
    }
    var mainType$2 = \u03b41$___1;
    var subType$2 = \u03b41$___2;
    var this$5 = $m_Lsttp_model_internal_Patterns$().parseMediaTypeParameters__T__I__s_util_Either(t, typeSubtype.end__I());
    if ((this$5 instanceof $c_s_util_Right)) {
      var b = this$5.s_util_Right__f_value;
      $m_Lsttp_model_MediaType$();
      var charset = b.get__O__s_Option("charset");
      var otherParameters = b.removed__O__sci_MapOps("charset");
      return new $c_s_util_Right(new $c_Lsttp_model_MediaType(mainType$2, subType$2, charset, otherParameters));
    } else {
      return this$5;
    }
  } else {
    var value = (("No subtype found for: \"" + t) + "\"");
    return new $c_s_util_Left(value);
  }
});
$c_Lsttp_model_MediaType$.prototype.fromProduct__s_Product__Lsttp_model_MediaType = (function(x$0) {
  return new $c_Lsttp_model_MediaType(x$0.productElement__I__O(0), x$0.productElement__I__O(1), x$0.productElement__I__O(2), x$0.productElement__I__O(3));
});
$c_Lsttp_model_MediaType$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_MediaType(p);
});
var $d_Lsttp_model_MediaType$ = new $TypeData().initClass($c_Lsttp_model_MediaType$, "sttp.model.MediaType$", ({
  Lsttp_model_MediaType$: 1,
  Lsttp_model_MediaTypes: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_MediaType$ as $d_Lsttp_model_MediaType$ };
var $n_Lsttp_model_MediaType$;
function $m_Lsttp_model_MediaType$() {
  if ((!$n_Lsttp_model_MediaType$)) {
    $n_Lsttp_model_MediaType$ = new $c_Lsttp_model_MediaType$();
  }
  return $n_Lsttp_model_MediaType$;
}
export { $m_Lsttp_model_MediaType$ as $m_Lsttp_model_MediaType$ };
/** @constructor */
function $c_Lsttp_model_QueryParams(ps) {
  this.Lsttp_model_QueryParams__f_ps = null;
  this.Lsttp_model_QueryParams__f_ps = ps;
}
export { $c_Lsttp_model_QueryParams as $c_Lsttp_model_QueryParams };
$c_Lsttp_model_QueryParams.prototype = new $h_O();
$c_Lsttp_model_QueryParams.prototype.constructor = $c_Lsttp_model_QueryParams;
/** @constructor */
function $h_Lsttp_model_QueryParams() {
}
export { $h_Lsttp_model_QueryParams as $h_Lsttp_model_QueryParams };
$h_Lsttp_model_QueryParams.prototype = $c_Lsttp_model_QueryParams.prototype;
$c_Lsttp_model_QueryParams.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_QueryParams.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1946455838), true);
});
$c_Lsttp_model_QueryParams.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_QueryParams)) {
    var x = this.Lsttp_model_QueryParams__f_ps;
    var x$2 = x$0.Lsttp_model_QueryParams__f_ps;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_QueryParams.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_QueryParams.prototype.productPrefix__T = (function() {
  return "QueryParams";
});
$c_Lsttp_model_QueryParams.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_QueryParams__f_ps;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_QueryParams.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ps";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_QueryParams.prototype.toSeq__sci_Seq = (function() {
  return this.Lsttp_model_QueryParams__f_ps.flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var k = x$1._1__O();
      var vs = x$1._2__O();
      return vs.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => $ct_T2__O__O__(new $c_T2(), k, _$1))));
    }
    throw new $c_s_MatchError(x$1);
  })));
});
$c_Lsttp_model_QueryParams.prototype.param__T__sci_Seq__Lsttp_model_QueryParams = (function(k, v) {
  var this$3 = this.Lsttp_model_QueryParams__f_ps;
  var elem = $ct_T2__O__O__(new $c_T2(), k, v);
  return new $c_Lsttp_model_QueryParams(this$3.appended__O__O(elem));
});
$c_Lsttp_model_QueryParams.prototype.toString__T = (function() {
  return this.toString__F1__F1__Z__T($m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_Standard, $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_StandardValue, false);
});
$c_Lsttp_model_QueryParams.prototype.toString__F1__F1__Z__T = (function(keyEncoding, valueEncoding, includeBoundary) {
  if (includeBoundary) {
    var this$1 = this.Lsttp_model_QueryParams__f_ps;
    var $x_1 = (!this$1.isEmpty__Z());
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var boundary = "?";
  } else {
    var boundary = "";
  }
  var this$2 = this.Lsttp_model_QueryParams__f_ps.flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var x14 = x$1._1__O();
      var x15 = x$1._2__O();
      if (x15.isEmpty__Z()) {
        return new $c_sci_$colon$colon(keyEncoding.apply__O__O(x14), $m_sci_Nil$());
      }
      return x15.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v) => ((keyEncoding.apply__O__O(x14) + "=") + valueEncoding.apply__O__O(v)))));
    }
    throw new $c_s_MatchError(x$1);
  })));
  return (boundary + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$2, "", "&", ""));
});
function $isArrayOf_Lsttp_model_QueryParams(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_QueryParams)));
}
export { $isArrayOf_Lsttp_model_QueryParams as $isArrayOf_Lsttp_model_QueryParams };
var $d_Lsttp_model_QueryParams = new $TypeData().initClass($c_Lsttp_model_QueryParams, "sttp.model.QueryParams", ({
  Lsttp_model_QueryParams: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_QueryParams as $d_Lsttp_model_QueryParams };
function $p_Lsttp_model_Uri__queryToStringSafe__sci_Set__T($thiz, sensitiveQueryParams) {
  return $ps_Lsttp_model_Uri__encodeQuerySegments$1__sci_Set__sci_List__Z__scm_StringBuilder__T(sensitiveQueryParams, $thiz.Lsttp_model_Uri__f_querySegments.toList__sci_List(), true, $ct_scm_StringBuilder__(new $c_scm_StringBuilder()));
}
export { $p_Lsttp_model_Uri__queryToStringSafe__sci_Set__T as $p_Lsttp_model_Uri__queryToStringSafe__sci_Set__T };
function $ps_Lsttp_model_Uri__encodeQuerySegments$1__sci_Set__sci_List__Z__scm_StringBuilder__T(sensitiveQueryParams$1, qss, previousWasPlain, sb) {
  var sb$tailLocal1 = sb;
  var previousWasPlain$tailLocal1 = previousWasPlain;
  var qss$tailLocal1 = qss;
  while (true) {
    var x75 = qss$tailLocal1;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x75)) {
      var this$1 = sb$tailLocal1;
      return this$1.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
    }
    if ((x75 instanceof $c_sci_$colon$colon)) {
      var x93 = x75.sci_$colon$colon__f_head;
      var x94 = x75.sci_$colon$colon__f_next;
      if (false) {
        var x97 = x93.Lsttp_model_Uri$QuerySegment$Plain__f_v;
        var x98 = x93.Lsttp_model_Uri$QuerySegment$Plain__f_encoding;
        var sb$tailLocal1$tmp1 = sb$tailLocal1.append__T__scm_StringBuilder(x98.apply__O__O(x97));
        qss$tailLocal1 = x94;
        previousWasPlain$tailLocal1 = true;
        sb$tailLocal1 = sb$tailLocal1$tmp1;
        continue;
      }
      if ((x93 instanceof $c_Lsttp_model_Uri$QuerySegment$Value)) {
        var x90 = x93.Lsttp_model_Uri$QuerySegment$Value__f_v;
        var x91 = x93.Lsttp_model_Uri$QuerySegment$Value__f_encoding;
        if ((!previousWasPlain$tailLocal1)) {
          sb$tailLocal1.append__T__scm_StringBuilder("&");
        }
        sb$tailLocal1.append__T__scm_StringBuilder(x91.apply__O__O(x90));
        qss$tailLocal1 = x94;
        previousWasPlain$tailLocal1 = false;
        continue;
      }
      if ((x93 instanceof $c_Lsttp_model_Uri$QuerySegment$KeyValue)) {
        var x81 = x93.Lsttp_model_Uri$QuerySegment$KeyValue__f_k;
        var x82 = x93.Lsttp_model_Uri$QuerySegment$KeyValue__f_v;
        var x83 = x93.Lsttp_model_Uri$QuerySegment$KeyValue__f_keyEncoding;
        var x84 = x93.Lsttp_model_Uri$QuerySegment$KeyValue__f_valueEncoding;
        if ((!previousWasPlain$tailLocal1)) {
          sb$tailLocal1.append__T__scm_StringBuilder("&");
        }
        sb$tailLocal1.append__T__scm_StringBuilder(x83.apply__O__O(x81)).append__T__scm_StringBuilder("=").append__T__scm_StringBuilder((sensitiveQueryParams$1.contains__O__Z(x81) ? "***" : x84.apply__O__O(x82)));
        qss$tailLocal1 = x94;
        previousWasPlain$tailLocal1 = false;
        continue;
      }
    }
    throw new $c_s_MatchError(x75);
  }
}
export { $ps_Lsttp_model_Uri__encodeQuerySegments$1__sci_Set__sci_List__Z__scm_StringBuilder__T as $ps_Lsttp_model_Uri__encodeQuerySegments$1__sci_Set__sci_List__Z__scm_StringBuilder__T };
/** @constructor */
function $c_Lsttp_model_Uri(scheme, authority, pathSegments, querySegments, fragmentSegment) {
  this.Lsttp_model_Uri__f_scheme = null;
  this.Lsttp_model_Uri__f_authority = null;
  this.Lsttp_model_Uri__f_pathSegments = null;
  this.Lsttp_model_Uri__f_querySegments = null;
  this.Lsttp_model_Uri__f_fragmentSegment = null;
  this.Lsttp_model_Uri__f_scheme = scheme;
  this.Lsttp_model_Uri__f_authority = authority;
  this.Lsttp_model_Uri__f_pathSegments = pathSegments;
  this.Lsttp_model_Uri__f_querySegments = querySegments;
  this.Lsttp_model_Uri__f_fragmentSegment = fragmentSegment;
}
export { $c_Lsttp_model_Uri as $c_Lsttp_model_Uri };
$c_Lsttp_model_Uri.prototype = new $h_O();
$c_Lsttp_model_Uri.prototype.constructor = $c_Lsttp_model_Uri;
/** @constructor */
function $h_Lsttp_model_Uri() {
}
export { $h_Lsttp_model_Uri as $h_Lsttp_model_Uri };
$h_Lsttp_model_Uri.prototype = $c_Lsttp_model_Uri.prototype;
$c_Lsttp_model_Uri.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Uri.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1130952780), true);
});
$c_Lsttp_model_Uri.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_Uri)) {
    var x = this.Lsttp_model_Uri__f_scheme;
    var x$2 = x$0.Lsttp_model_Uri__f_scheme;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_model_Uri__f_authority;
      var x$4 = x$0.Lsttp_model_Uri__f_authority;
      var $x_3 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.Lsttp_model_Uri__f_pathSegments;
      var x$6 = x$0.Lsttp_model_Uri__f_pathSegments;
      var $x_2 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.Lsttp_model_Uri__f_querySegments;
      var x$8 = x$0.Lsttp_model_Uri__f_querySegments;
      var $x_1 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.Lsttp_model_Uri__f_fragmentSegment;
      var x$10 = x$0.Lsttp_model_Uri__f_fragmentSegment;
      return ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_model_Uri.prototype.productArity__I = (function() {
  return 5;
});
$c_Lsttp_model_Uri.prototype.productPrefix__T = (function() {
  return "Uri";
});
$c_Lsttp_model_Uri.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_model_Uri__f_scheme;
      break;
    }
    case 1: {
      return this.Lsttp_model_Uri__f_authority;
      break;
    }
    case 2: {
      return this.Lsttp_model_Uri__f_pathSegments;
      break;
    }
    case 3: {
      return this.Lsttp_model_Uri__f_querySegments;
      break;
    }
    case 4: {
      return this.Lsttp_model_Uri__f_fragmentSegment;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_Uri.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "scheme";
      break;
    }
    case 1: {
      return "authority";
      break;
    }
    case 2: {
      return "pathSegments";
      break;
    }
    case 3: {
      return "querySegments";
      break;
    }
    case 4: {
      return "fragmentSegment";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_Uri.prototype.scheme__T__Lsttp_model_Uri = (function(s) {
  var scheme = new $c_s_Some(s);
  var authority = this.Lsttp_model_Uri__f_authority;
  var pathSegments = this.Lsttp_model_Uri__f_pathSegments;
  var querySegments = this.Lsttp_model_Uri__f_querySegments;
  var fragmentSegment = this.Lsttp_model_Uri__f_fragmentSegment;
  return new $c_Lsttp_model_Uri(scheme, authority, pathSegments, querySegments, fragmentSegment);
});
$c_Lsttp_model_Uri.prototype.userInfo__T__Lsttp_model_Uri = (function(username) {
  var password = $m_s_None$();
  var value = new $c_Lsttp_model_Uri$UserInfo(username, password);
  return this.userInfo__s_Option__Lsttp_model_Uri(new $c_s_Some(value));
});
$c_Lsttp_model_Uri.prototype.userInfo__T__T__Lsttp_model_Uri = (function(username, password) {
  var password$1 = new $c_s_Some(password);
  var value = new $c_Lsttp_model_Uri$UserInfo(username, password$1);
  return this.userInfo__s_Option__Lsttp_model_Uri(new $c_s_Some(value));
});
$c_Lsttp_model_Uri.prototype.userInfo__s_Option__Lsttp_model_Uri = (function(ui) {
  if ((ui instanceof $c_s_Some)) {
    var v = ui.s_Some__f_value;
    var this$1 = this.Lsttp_model_Uri__f_authority;
    var this$3 = (this$1.isEmpty__Z() ? $m_Lsttp_model_Uri$Authority$().Lsttp_model_Uri$Authority$__f_Empty : this$1.get__O());
    var ui$1 = new $c_s_Some(v);
    var hostSegment = this$3.Lsttp_model_Uri$Authority__f_hostSegment;
    var port = this$3.Lsttp_model_Uri$Authority__f_port;
    var value = new $c_Lsttp_model_Uri$Authority(ui$1, hostSegment, port);
    var authority$1 = new $c_s_Some(value);
    var scheme$1 = this.Lsttp_model_Uri__f_scheme;
    var pathSegments$1 = this.Lsttp_model_Uri__f_pathSegments;
    var querySegments$1 = this.Lsttp_model_Uri__f_querySegments;
    var fragmentSegment$1 = this.Lsttp_model_Uri__f_fragmentSegment;
    return new $c_Lsttp_model_Uri(scheme$1, authority$1, pathSegments$1, querySegments$1, fragmentSegment$1);
  }
  var x = $m_s_None$();
  if ((x === ui)) {
    var this$5 = this.Lsttp_model_Uri__f_authority;
    if (this$5.isEmpty__Z()) {
      var authority$2 = $m_s_None$();
    } else {
      var x0 = this$5.get__O();
      var ui$2 = $m_s_None$();
      var hostSegment$1 = x0.Lsttp_model_Uri$Authority__f_hostSegment;
      var port$1 = x0.Lsttp_model_Uri$Authority__f_port;
      var authority$2 = new $c_s_Some(new $c_Lsttp_model_Uri$Authority(ui$2, hostSegment$1, port$1));
    }
    var scheme$2 = this.Lsttp_model_Uri__f_scheme;
    var pathSegments$2 = this.Lsttp_model_Uri__f_pathSegments;
    var querySegments$2 = this.Lsttp_model_Uri__f_querySegments;
    var fragmentSegment$2 = this.Lsttp_model_Uri__f_fragmentSegment;
    return new $c_Lsttp_model_Uri(scheme$2, authority$2, pathSegments$2, querySegments$2, fragmentSegment$2);
  }
  throw new $c_s_MatchError(ui);
});
$c_Lsttp_model_Uri.prototype.host__T__Lsttp_model_Uri = (function(h) {
  var encoding = $m_Lsttp_model_Uri$HostEncoding$().Lsttp_model_Uri$HostEncoding$__f_Standard;
  return this.hostSegment__Lsttp_model_Uri$Segment__Lsttp_model_Uri(new $c_Lsttp_model_Uri$Segment(h, encoding));
});
$c_Lsttp_model_Uri.prototype.hostSegment__Lsttp_model_Uri$Segment__Lsttp_model_Uri = (function(s) {
  return this.hostSegment__s_Option__Lsttp_model_Uri(new $c_s_Some(s));
});
$c_Lsttp_model_Uri.prototype.hostSegment__s_Option__Lsttp_model_Uri = (function(s) {
  matchResult5: {
    var authority$3;
    var x8 = this.Lsttp_model_Uri__f_authority;
    if ((x8 instanceof $c_s_Some)) {
      var a = x8.s_Some__f_value;
      if (s.isEmpty__Z()) {
        var authority$3 = $m_s_None$();
        break matchResult5;
      } else {
        var x0 = s.get__O();
        var userInfo = a.Lsttp_model_Uri$Authority__f_userInfo;
        var port = a.Lsttp_model_Uri$Authority__f_port;
        var authority$3 = new $c_s_Some(new $c_Lsttp_model_Uri$Authority(userInfo, x0, port));
        break matchResult5;
      }
    }
    var x = $m_s_None$();
    if ((x === x8)) {
      if (s.isEmpty__Z()) {
        var authority$3 = $m_s_None$();
        break matchResult5;
      } else {
        var x0$1 = s.get__O();
        $m_Lsttp_model_Uri$Authority$();
        var userInfo$1 = $m_s_None$();
        var port$1 = $m_s_None$();
        var authority$3 = new $c_s_Some(new $c_Lsttp_model_Uri$Authority(userInfo$1, x0$1, port$1));
        break matchResult5;
      }
    }
    throw new $c_s_MatchError(x8);
  }
  var scheme$3 = this.Lsttp_model_Uri__f_scheme;
  var pathSegments$3 = this.Lsttp_model_Uri__f_pathSegments;
  var querySegments$3 = this.Lsttp_model_Uri__f_querySegments;
  var fragmentSegment$3 = this.Lsttp_model_Uri__f_fragmentSegment;
  return new $c_Lsttp_model_Uri(scheme$3, authority$3, pathSegments$3, querySegments$3, fragmentSegment$3);
});
$c_Lsttp_model_Uri.prototype.port__s_Option__Lsttp_model_Uri = (function(p) {
  if ((p instanceof $c_s_Some)) {
    var v = (p.s_Some__f_value | 0);
    var this$1 = this.Lsttp_model_Uri__f_authority;
    var value = (this$1.isEmpty__Z() ? $m_Lsttp_model_Uri$Authority$().Lsttp_model_Uri$Authority$__f_Empty : this$1.get__O()).port__I__Lsttp_model_Uri$Authority(v);
    var authority$4 = new $c_s_Some(value);
    var scheme$4 = this.Lsttp_model_Uri__f_scheme;
    var pathSegments$4 = this.Lsttp_model_Uri__f_pathSegments;
    var querySegments$4 = this.Lsttp_model_Uri__f_querySegments;
    var fragmentSegment$4 = this.Lsttp_model_Uri__f_fragmentSegment;
    return new $c_Lsttp_model_Uri(scheme$4, authority$4, pathSegments$4, querySegments$4, fragmentSegment$4);
  }
  var x = $m_s_None$();
  if ((x === p)) {
    var this$3 = this.Lsttp_model_Uri__f_authority;
    if (this$3.isEmpty__Z()) {
      var authority$5 = $m_s_None$();
    } else {
      var x0 = this$3.get__O();
      var p$1 = $m_s_None$();
      var userInfo = x0.Lsttp_model_Uri$Authority__f_userInfo;
      var hostSegment = x0.Lsttp_model_Uri$Authority__f_hostSegment;
      var authority$5 = new $c_s_Some(new $c_Lsttp_model_Uri$Authority(userInfo, hostSegment, p$1));
    }
    var scheme$5 = this.Lsttp_model_Uri__f_scheme;
    var pathSegments$5 = this.Lsttp_model_Uri__f_pathSegments;
    var querySegments$5 = this.Lsttp_model_Uri__f_querySegments;
    var fragmentSegment$5 = this.Lsttp_model_Uri__f_fragmentSegment;
    return new $c_Lsttp_model_Uri(scheme$5, authority$5, pathSegments$5, querySegments$5, fragmentSegment$5);
  }
  throw new $c_s_MatchError(p);
});
$c_Lsttp_model_Uri.prototype.addPath__T__sci_Seq__Lsttp_model_Uri = (function(p, ps) {
  var this$1 = ps.toList__sci_List();
  return this.addPath__sc_Seq__Lsttp_model_Uri(new $c_sci_$colon$colon(p, this$1));
});
$c_Lsttp_model_Uri.prototype.addPath__sc_Seq__Lsttp_model_Uri = (function(ps) {
  var this$3 = ps.toList__sci_List();
  var f = ((_$8) => {
    var encoding = $m_Lsttp_model_Uri$PathSegmentEncoding$().Lsttp_model_Uri$PathSegmentEncoding$__f_Standard;
    return new $c_Lsttp_model_Uri$Segment(_$8, encoding);
  });
  if ((this$3 === $m_sci_Nil$())) {
    var $x_1 = $m_sci_Nil$();
  } else {
    var x0 = this$3.head__O();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$3.tail__O();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    var $x_1 = h;
  }
  return this.addPathSegments__sc_Seq__Lsttp_model_Uri($x_1);
});
$c_Lsttp_model_Uri.prototype.addPathSegments__sc_Seq__Lsttp_model_Uri = (function(ss) {
  var pathSegments$7 = $f_Lsttp_model_Uri$PathSegments__addSegments__sc_Seq__Lsttp_model_Uri$PathSegments(this.Lsttp_model_Uri__f_pathSegments, ss);
  var scheme$7 = this.Lsttp_model_Uri__f_scheme;
  var authority$7 = this.Lsttp_model_Uri__f_authority;
  var querySegments$7 = this.Lsttp_model_Uri__f_querySegments;
  var fragmentSegment$7 = this.Lsttp_model_Uri__f_fragmentSegment;
  return new $c_Lsttp_model_Uri(scheme$7, authority$7, pathSegments$7, querySegments$7, fragmentSegment$7);
});
$c_Lsttp_model_Uri.prototype.path__sci_Seq = (function() {
  return this.Lsttp_model_Uri__f_pathSegments.segments__sc_Seq().map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$10) => _$10.Lsttp_model_Uri$Segment__f_v))).toList__sci_List();
});
$c_Lsttp_model_Uri.prototype.addParam__T__T__Lsttp_model_Uri = (function(k, v) {
  return this.addParams__sci_Seq__Lsttp_model_Uri($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), k, v)])));
});
$c_Lsttp_model_Uri.prototype.addParams__sci_Seq__Lsttp_model_Uri = (function(ps) {
  var this$4 = this.Lsttp_model_Uri__f_querySegments;
  var suffix = ps.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var k = x$1._1__O();
      var v = x$1._2__O();
      var keyEncoding = $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_Standard;
      var valueEncoding = $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_Standard;
      return new $c_Lsttp_model_Uri$QuerySegment$KeyValue(k, v, keyEncoding, valueEncoding);
    }
    throw new $c_s_MatchError(x$1);
  })));
  var querySegments$10 = this$4.appendedAll__sc_IterableOnce__O(suffix);
  var scheme$10 = this.Lsttp_model_Uri__f_scheme;
  var authority$10 = this.Lsttp_model_Uri__f_authority;
  var pathSegments$10 = this.Lsttp_model_Uri__f_pathSegments;
  var fragmentSegment$10 = this.Lsttp_model_Uri__f_fragmentSegment;
  return new $c_Lsttp_model_Uri(scheme$10, authority$10, pathSegments$10, querySegments$10, fragmentSegment$10);
});
$c_Lsttp_model_Uri.prototype.withParams__Lsttp_model_QueryParams__Lsttp_model_Uri = (function(mqp) {
  var querySegments$11 = $m_Lsttp_model_Uri$QuerySegment$().fromQueryParams__Lsttp_model_QueryParams__sc_Iterable(mqp).toList__sci_List();
  var scheme$11 = this.Lsttp_model_Uri__f_scheme;
  var authority$11 = this.Lsttp_model_Uri__f_authority;
  var pathSegments$11 = this.Lsttp_model_Uri__f_pathSegments;
  var fragmentSegment$11 = this.Lsttp_model_Uri__f_fragmentSegment;
  return new $c_Lsttp_model_Uri(scheme$11, authority$11, pathSegments$11, querySegments$11, fragmentSegment$11);
});
$c_Lsttp_model_Uri.prototype.params__Lsttp_model_QueryParams = (function() {
  var m = new $c_scm_LinkedHashMap();
  this.Lsttp_model_Uri__f_querySegments.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    matchResult9: {
      if ((x$1 instanceof $c_Lsttp_model_Uri$QuerySegment$KeyValue)) {
        var x31 = x$1.Lsttp_model_Uri$QuerySegment$KeyValue__f_k;
        var x32 = x$1.Lsttp_model_Uri$QuerySegment$KeyValue__f_v;
        var originalHash = $m_sr_Statics$().anyHash__O__I(x31);
        var hash = (originalHash ^ ((originalHash >>> 16) | 0));
        var x1 = m.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[(hash & (((-1) + m.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0))];
        var nd = ((x1 === null) ? null : x1.findEntry__O__I__scm_LinkedHashMap$LinkedEntry(x31, hash));
        var this$2 = ((nd === null) ? $m_sci_Nil$() : nd.scm_LinkedHashMap$LinkedEntry__f_value);
        var suffix = new $c_sci_$colon$colon(x32, $m_sci_Nil$());
        var value = this$2.concat__sc_IterableOnce__O(suffix);
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(m, x31, value, false);
        break matchResult9;
      }
      if ((x$1 instanceof $c_Lsttp_model_Uri$QuerySegment$Value)) {
        var x27 = x$1.Lsttp_model_Uri$QuerySegment$Value__f_v;
        var originalHash$1 = $m_sr_Statics$().anyHash__O__I(x27);
        var hash$1 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
        var x1$1 = m.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[(hash$1 & (((-1) + m.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0))];
        var nd$1 = ((x1$1 === null) ? null : x1$1.findEntry__O__I__scm_LinkedHashMap$LinkedEntry(x27, hash$1));
        var value$1 = ((nd$1 === null) ? $m_sci_Nil$() : nd$1.scm_LinkedHashMap$LinkedEntry__f_value);
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(m, x27, value$1, false);
        break matchResult9;
      }
      if (false) {
        var x23 = x$1.Lsttp_model_Uri$QuerySegment$Plain__f_v;
        var originalHash$2 = $m_sr_Statics$().anyHash__O__I(x23);
        var hash$2 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0));
        var x1$2 = m.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[(hash$2 & (((-1) + m.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0))];
        var nd$2 = ((x1$2 === null) ? null : x1$2.findEntry__O__I__scm_LinkedHashMap$LinkedEntry(x23, hash$2));
        var value$2 = ((nd$2 === null) ? $m_sci_Nil$() : nd$2.scm_LinkedHashMap$LinkedEntry__f_value);
        $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(m, x23, value$2, false);
        break matchResult9;
      }
      throw new $c_s_MatchError(x$1);
    }
  })));
  var m$1 = $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(m);
  return new $c_Lsttp_model_QueryParams(m$1);
});
$c_Lsttp_model_Uri.prototype.addQuerySegment__Lsttp_model_Uri$QuerySegment__Lsttp_model_Uri = (function(qs) {
  return this.addQuerySegments__sc_Seq__Lsttp_model_Uri(new $c_sci_$colon$colon(qs, $m_sci_Nil$()));
});
$c_Lsttp_model_Uri.prototype.addQuerySegments__sc_Seq__Lsttp_model_Uri = (function(qss) {
  var this$1 = this.Lsttp_model_Uri__f_querySegments;
  var querySegments$13 = this$1.appendedAll__sc_IterableOnce__O(qss);
  var scheme$13 = this.Lsttp_model_Uri__f_scheme;
  var authority$13 = this.Lsttp_model_Uri__f_authority;
  var pathSegments$13 = this.Lsttp_model_Uri__f_pathSegments;
  var fragmentSegment$13 = this.Lsttp_model_Uri__f_fragmentSegment;
  return new $c_Lsttp_model_Uri(scheme$13, authority$13, pathSegments$13, querySegments$13, fragmentSegment$13);
});
$c_Lsttp_model_Uri.prototype.fragment__s_Option__Lsttp_model_Uri = (function(f) {
  if (f.isEmpty__Z()) {
    var s = $m_s_None$();
  } else {
    var x0 = f.get__O();
    var encoding = $m_Lsttp_model_Uri$FragmentEncoding$().Lsttp_model_Uri$FragmentEncoding$__f_Standard;
    var s = new $c_s_Some(new $c_Lsttp_model_Uri$Segment(x0, encoding));
  }
  var scheme = this.Lsttp_model_Uri__f_scheme;
  var authority = this.Lsttp_model_Uri__f_authority;
  var pathSegments = this.Lsttp_model_Uri__f_pathSegments;
  var querySegments = this.Lsttp_model_Uri__f_querySegments;
  return new $c_Lsttp_model_Uri(scheme, authority, pathSegments, querySegments, s);
});
$c_Lsttp_model_Uri.prototype.pathToString__T = (function() {
  matchResult13: {
    var pathPrefixS;
    var x68 = this.Lsttp_model_Uri__f_pathSegments;
    if (this.Lsttp_model_Uri__f_authority.isEmpty__Z()) {
      var this$1 = this.Lsttp_model_Uri__f_scheme;
      var $x_1 = (!this$1.isEmpty__Z());
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var pathPrefixS = "";
      break matchResult13;
    }
    var x = $m_Lsttp_model_Uri$EmptyPath$();
    if ((x === x68)) {
      var pathPrefixS = "";
      break matchResult13;
    }
    if ((x68 instanceof $c_Lsttp_model_Uri$AbsolutePath)) {
      var pathPrefixS = "/";
      break matchResult13;
    }
    if ((x68 instanceof $c_Lsttp_model_Uri$RelativePath)) {
      var pathPrefixS = "";
      break matchResult13;
    }
    throw new $c_s_MatchError(x68);
  }
  var this$4 = this.Lsttp_model_Uri__f_pathSegments.segments__sc_Seq().map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$17) => _$17.Lsttp_model_Uri$Segment__f_encoding.apply__O__O(_$17.Lsttp_model_Uri$Segment__f_v))));
  var pathS = $f_sc_IterableOnceOps__mkString__T__T__T__T(this$4, "", "/", "");
  return (pathPrefixS + pathS);
});
$c_Lsttp_model_Uri.prototype.toString__T = (function() {
  return this.toStringSafe__sci_Set__T($m_sci_Set$EmptySet$());
});
$c_Lsttp_model_Uri.prototype.toStringSafe__sci_Set__T = (function(sensitiveQueryParams) {
  var this$1 = this.Lsttp_model_Uri__f_scheme;
  if (this$1.isEmpty__Z()) {
    var this$3 = $m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var this$2 = $m_Lsttp_model_internal_Rfc3986$();
    var allowedCharacters = $m_Lsttp_model_internal_Rfc3986$().Lsttp_model_internal_Rfc3986$__f_Scheme;
    $m_Lsttp_model_internal_Rfc3986$();
    var spaceAsPlus = false;
    $m_Lsttp_model_internal_Rfc3986$();
    var encodePlus = false;
    var this$3 = new $c_s_Some(($p_Lsttp_model_internal_Rfc3986$__encode__T__T__sci_Set__Z__Z__T(this$2, x0, "UTF-8", allowedCharacters, spaceAsPlus, encodePlus) + ":"));
  }
  var schemeS = (this$3.isEmpty__Z() ? "" : this$3.get__O());
  var this$4 = this.Lsttp_model_Uri__f_authority;
  if (this$4.isEmpty__Z()) {
    var $x_1 = "";
  } else {
    var x0$1 = this$4.get__O();
    var $x_1 = x0$1.toString__T();
  }
  var authorityS = $x_1;
  var pathS = this.pathToString__T();
  var queryPrefixS = (this.Lsttp_model_Uri__f_querySegments.isEmpty__Z() ? "" : "?");
  var queryS = $p_Lsttp_model_Uri__queryToStringSafe__sci_Set__T(this, sensitiveQueryParams);
  var this$5 = this.Lsttp_model_Uri__f_fragmentSegment;
  if (this$5.isEmpty__Z()) {
    var fragS = "";
  } else {
    var x0$2 = this$5.get__O();
    var fragS = ("#" + x0$2.Lsttp_model_Uri$Segment__f_encoding.apply__O__O(x0$2.Lsttp_model_Uri$Segment__f_v));
  }
  return (((((("" + schemeS) + authorityS) + pathS) + queryPrefixS) + queryS) + fragS);
});
function $isArrayOf_Lsttp_model_Uri(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Uri)));
}
export { $isArrayOf_Lsttp_model_Uri as $isArrayOf_Lsttp_model_Uri };
var $d_Lsttp_model_Uri = new $TypeData().initClass($c_Lsttp_model_Uri, "sttp.model.Uri", ({
  Lsttp_model_Uri: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_Uri as $d_Lsttp_model_Uri };
/** @constructor */
function $c_Lsttp_model_Uri$() {
  $n_Lsttp_model_Uri$ = this;
  $ct_s_util_matching_Regex__T__sci_Seq__(new $c_s_util_matching_Regex(), "[a-zA-Z][a-zA-Z0-9+-.]*", $m_sci_Nil$());
}
export { $c_Lsttp_model_Uri$ as $c_Lsttp_model_Uri$ };
$c_Lsttp_model_Uri$.prototype = new $h_O();
$c_Lsttp_model_Uri$.prototype.constructor = $c_Lsttp_model_Uri$;
/** @constructor */
function $h_Lsttp_model_Uri$() {
}
export { $h_Lsttp_model_Uri$ as $h_Lsttp_model_Uri$ };
$h_Lsttp_model_Uri$.prototype = $c_Lsttp_model_Uri$.prototype;
$c_Lsttp_model_Uri$.prototype.apply__T__T__Lsttp_model_Uri = (function(scheme, host) {
  var scheme$1 = new $c_s_Some(scheme);
  var value = $m_Lsttp_model_Uri$Authority$().apply__T__Lsttp_model_Uri$Authority(host);
  var authority = new $c_s_Some(value);
  var pathSegments = $m_Lsttp_model_Uri$EmptyPath$();
  $m_sci_Vector$();
  var querySegments = $m_sci_Vector0$();
  var fragmentSegment = $m_s_None$();
  return new $c_Lsttp_model_Uri(scheme$1, authority, pathSegments, querySegments, fragmentSegment);
});
$c_Lsttp_model_Uri$.prototype.apply__T__T__I__Lsttp_model_Uri = (function(scheme, host, port) {
  var scheme$1 = new $c_s_Some(scheme);
  var value = $m_Lsttp_model_Uri$Authority$().apply__T__I__Lsttp_model_Uri$Authority(host, port);
  var authority = new $c_s_Some(value);
  var pathSegments = $m_Lsttp_model_Uri$EmptyPath$();
  $m_sci_Vector$();
  var querySegments = $m_sci_Vector0$();
  var fragmentSegment = $m_s_None$();
  return new $c_Lsttp_model_Uri(scheme$1, authority, pathSegments, querySegments, fragmentSegment);
});
$c_Lsttp_model_Uri$.prototype.parse__T__s_util_Either = (function(uri) {
  try {
    var this$3 = $m_Lsttp_model_Uri$();
    var parts = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["", ""]));
    var sc = new $c_s_StringContext(parts);
    var this$4 = new $c_Lsttp_model_UriInterpolator$UriContext(this$3, sc);
    var args = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([uri]));
    var r1 = $m_Lsttp_model_UriInterpolator$().interpolate__s_StringContext__sci_Seq__Lsttp_model_Uri(this$4.Lsttp_model_UriInterpolator$UriContext__f_sc, args);
    var x99 = new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var x99;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var x99 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  if ((x99 instanceof $c_s_util_Success)) {
    var u = x99.s_util_Success__f_value;
    return new $c_s_util_Right(u);
  }
  if ((x99 instanceof $c_s_util_Failure)) {
    var x104 = x99.s_util_Failure__f_exception;
    if ((x104 instanceof $c_jl_Exception)) {
      var value = x104.getMessage__T();
      return new $c_s_util_Left(value);
    }
    if ((x104 !== null)) {
      var $x_1 = x104;
      throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
    }
  }
  throw new $c_s_MatchError(x99);
});
$c_Lsttp_model_Uri$.prototype.fromProduct__s_Product__Lsttp_model_Uri = (function(x$0) {
  return new $c_Lsttp_model_Uri(x$0.productElement__I__O(0), x$0.productElement__I__O(1), x$0.productElement__I__O(2), x$0.productElement__I__O(3), x$0.productElement__I__O(4));
});
$c_Lsttp_model_Uri$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_model_Uri(p);
});
var $d_Lsttp_model_Uri$ = new $TypeData().initClass($c_Lsttp_model_Uri$, "sttp.model.Uri$", ({
  Lsttp_model_Uri$: 1,
  Lsttp_model_UriInterpolator: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_model_Uri$ as $d_Lsttp_model_Uri$ };
var $n_Lsttp_model_Uri$;
function $m_Lsttp_model_Uri$() {
  if ((!$n_Lsttp_model_Uri$)) {
    $n_Lsttp_model_Uri$ = new $c_Lsttp_model_Uri$();
  }
  return $n_Lsttp_model_Uri$;
}
export { $m_Lsttp_model_Uri$ as $m_Lsttp_model_Uri$ };
function $p_Lsttp_model_Uri$Authority__encodeUserInfo$1__Lsttp_model_Uri$UserInfo__T($thiz, ui) {
  var this$1 = $m_Lsttp_model_internal_Rfc3986$();
  var allowedCharacters = $m_Lsttp_model_internal_Rfc3986$().Lsttp_model_internal_Rfc3986$__f_UserInfo;
  $m_Lsttp_model_internal_Rfc3986$();
  var spaceAsPlus = false;
  $m_Lsttp_model_internal_Rfc3986$();
  var encodePlus = false;
  var s = ui.Lsttp_model_Uri$UserInfo__f_username;
  var $x_2 = $p_Lsttp_model_internal_Rfc3986$__encode__T__T__sci_Set__Z__Z__T(this$1, s, "UTF-8", allowedCharacters, spaceAsPlus, encodePlus);
  var this$2 = ui.Lsttp_model_Uri$UserInfo__f_password;
  if (this$2.isEmpty__Z()) {
    var $x_1 = "";
  } else {
    var x0 = this$2.get__O();
    var this$3 = $m_Lsttp_model_internal_Rfc3986$();
    var allowedCharacters$1 = $m_Lsttp_model_internal_Rfc3986$().Lsttp_model_internal_Rfc3986$__f_UserInfo;
    $m_Lsttp_model_internal_Rfc3986$();
    var spaceAsPlus$1 = false;
    $m_Lsttp_model_internal_Rfc3986$();
    var encodePlus$1 = false;
    var $x_1 = (":" + $p_Lsttp_model_internal_Rfc3986$__encode__T__T__sci_Set__Z__Z__T(this$3, x0, "UTF-8", allowedCharacters$1, spaceAsPlus$1, encodePlus$1));
  }
  return ($x_2 + $x_1);
}
export { $p_Lsttp_model_Uri$Authority__encodeUserInfo$1__Lsttp_model_Uri$UserInfo__T as $p_Lsttp_model_Uri$Authority__encodeUserInfo$1__Lsttp_model_Uri$UserInfo__T };
/** @constructor */
function $c_Lsttp_model_Uri$Authority(userInfo, hostSegment, port) {
  this.Lsttp_model_Uri$Authority__f_userInfo = null;
  this.Lsttp_model_Uri$Authority__f_hostSegment = null;
  this.Lsttp_model_Uri$Authority__f_port = null;
  this.Lsttp_model_Uri$Authority__f_userInfo = userInfo;
  this.Lsttp_model_Uri$Authority__f_hostSegment = hostSegment;
  this.Lsttp_model_Uri$Authority__f_port = port;
}
export { $c_Lsttp_model_Uri$Authority as $c_Lsttp_model_Uri$Authority };
$c_Lsttp_model_Uri$Authority.prototype = new $h_O();
$c_Lsttp_model_Uri$Authority.prototype.constructor = $c_Lsttp_model_Uri$Authority;
/** @constructor */
function $h_Lsttp_model_Uri$Authority() {
}
export { $h_Lsttp_model_Uri$Authority as $h_Lsttp_model_Uri$Authority };
$h_Lsttp_model_Uri$Authority.prototype = $c_Lsttp_model_Uri$Authority.prototype;
$c_Lsttp_model_Uri$Authority.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Uri$Authority.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 299910105, true);
});
$c_Lsttp_model_Uri$Authority.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_Uri$Authority)) {
    var x = this.Lsttp_model_Uri$Authority__f_userInfo;
    var x$2 = x$0.Lsttp_model_Uri$Authority__f_userInfo;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_model_Uri$Authority__f_hostSegment;
      var x$4 = x$0.Lsttp_model_Uri$Authority__f_hostSegment;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lsttp_model_Uri$Authority__f_port;
      var x$6 = x$0.Lsttp_model_Uri$Authority__f_port;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_model_Uri$Authority.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_model_Uri$Authority.prototype.productPrefix__T = (function() {
  return "Authority";
});
$c_Lsttp_model_Uri$Authority.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_model_Uri$Authority__f_userInfo;
      break;
    }
    case 1: {
      return this.Lsttp_model_Uri$Authority__f_hostSegment;
      break;
    }
    case 2: {
      return this.Lsttp_model_Uri$Authority__f_port;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_Uri$Authority.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "userInfo";
      break;
    }
    case 1: {
      return "hostSegment";
      break;
    }
    case 2: {
      return "port";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_Uri$Authority.prototype.port__I__Lsttp_model_Uri$Authority = (function(p) {
  var p$1 = new $c_s_Some(p);
  var userInfo = this.Lsttp_model_Uri$Authority__f_userInfo;
  var hostSegment = this.Lsttp_model_Uri$Authority__f_hostSegment;
  return new $c_Lsttp_model_Uri$Authority(userInfo, hostSegment, p$1);
});
$c_Lsttp_model_Uri$Authority.prototype.toString__T = (function() {
  var this$1 = this.Lsttp_model_Uri$Authority__f_userInfo;
  if (this$1.isEmpty__Z()) {
    var userInfoS = "";
  } else {
    var x0 = this$1.get__O();
    var userInfoS = ($p_Lsttp_model_Uri$Authority__encodeUserInfo$1__Lsttp_model_Uri$UserInfo__T(this, x0) + "@");
  }
  var this$2 = this.Lsttp_model_Uri$Authority__f_hostSegment;
  var hostS = this$2.Lsttp_model_Uri$Segment__f_encoding.apply__O__O(this$2.Lsttp_model_Uri$Segment__f_v);
  var this$3 = this.Lsttp_model_Uri$Authority__f_port;
  if (this$3.isEmpty__Z()) {
    var portS = "";
  } else {
    var x0$1 = this$3.get__O();
    var _$43 = (x0$1 | 0);
    var portS = (":" + _$43);
  }
  return ((("//" + userInfoS) + hostS) + portS);
});
function $isArrayOf_Lsttp_model_Uri$Authority(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Uri$Authority)));
}
export { $isArrayOf_Lsttp_model_Uri$Authority as $isArrayOf_Lsttp_model_Uri$Authority };
var $d_Lsttp_model_Uri$Authority = new $TypeData().initClass($c_Lsttp_model_Uri$Authority, "sttp.model.Uri$Authority", ({
  Lsttp_model_Uri$Authority: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_Uri$Authority as $d_Lsttp_model_Uri$Authority };
/** @constructor */
function $c_Lsttp_model_Uri$Segment(v, encoding) {
  this.Lsttp_model_Uri$Segment__f_v = null;
  this.Lsttp_model_Uri$Segment__f_encoding = null;
  this.Lsttp_model_Uri$Segment__f_v = v;
  this.Lsttp_model_Uri$Segment__f_encoding = encoding;
}
export { $c_Lsttp_model_Uri$Segment as $c_Lsttp_model_Uri$Segment };
$c_Lsttp_model_Uri$Segment.prototype = new $h_O();
$c_Lsttp_model_Uri$Segment.prototype.constructor = $c_Lsttp_model_Uri$Segment;
/** @constructor */
function $h_Lsttp_model_Uri$Segment() {
}
export { $h_Lsttp_model_Uri$Segment as $h_Lsttp_model_Uri$Segment };
$h_Lsttp_model_Uri$Segment.prototype = $c_Lsttp_model_Uri$Segment.prototype;
$c_Lsttp_model_Uri$Segment.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Uri$Segment.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1810946596), true);
});
$c_Lsttp_model_Uri$Segment.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_Uri$Segment)) {
    if ((this.Lsttp_model_Uri$Segment__f_v === x$0.Lsttp_model_Uri$Segment__f_v)) {
      var x = this.Lsttp_model_Uri$Segment__f_encoding;
      var x$2 = x$0.Lsttp_model_Uri$Segment__f_encoding;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_model_Uri$Segment.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_model_Uri$Segment.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_model_Uri$Segment.prototype.productPrefix__T = (function() {
  return "Segment";
});
$c_Lsttp_model_Uri$Segment.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_Uri$Segment__f_v;
  }
  if ((n === 1)) {
    return this.Lsttp_model_Uri$Segment__f_encoding;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Uri$Segment.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "v";
  }
  if ((n === 1)) {
    return "encoding";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_model_Uri$Segment(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Uri$Segment)));
}
export { $isArrayOf_Lsttp_model_Uri$Segment as $isArrayOf_Lsttp_model_Uri$Segment };
var $d_Lsttp_model_Uri$Segment = new $TypeData().initClass($c_Lsttp_model_Uri$Segment, "sttp.model.Uri$Segment", ({
  Lsttp_model_Uri$Segment: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_Uri$Segment as $d_Lsttp_model_Uri$Segment };
/** @constructor */
function $c_Lsttp_model_Uri$UserInfo(username, password) {
  this.Lsttp_model_Uri$UserInfo__f_username = null;
  this.Lsttp_model_Uri$UserInfo__f_password = null;
  this.Lsttp_model_Uri$UserInfo__f_username = username;
  this.Lsttp_model_Uri$UserInfo__f_password = password;
}
export { $c_Lsttp_model_Uri$UserInfo as $c_Lsttp_model_Uri$UserInfo };
$c_Lsttp_model_Uri$UserInfo.prototype = new $h_O();
$c_Lsttp_model_Uri$UserInfo.prototype.constructor = $c_Lsttp_model_Uri$UserInfo;
/** @constructor */
function $h_Lsttp_model_Uri$UserInfo() {
}
export { $h_Lsttp_model_Uri$UserInfo as $h_Lsttp_model_Uri$UserInfo };
$h_Lsttp_model_Uri$UserInfo.prototype = $c_Lsttp_model_Uri$UserInfo.prototype;
$c_Lsttp_model_Uri$UserInfo.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Uri$UserInfo.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1595824893), true);
});
$c_Lsttp_model_Uri$UserInfo.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_Uri$UserInfo)) {
    if ((this.Lsttp_model_Uri$UserInfo__f_username === x$0.Lsttp_model_Uri$UserInfo__f_username)) {
      var x = this.Lsttp_model_Uri$UserInfo__f_password;
      var x$2 = x$0.Lsttp_model_Uri$UserInfo__f_password;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_model_Uri$UserInfo.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_model_Uri$UserInfo.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_model_Uri$UserInfo.prototype.productPrefix__T = (function() {
  return "UserInfo";
});
$c_Lsttp_model_Uri$UserInfo.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_Uri$UserInfo__f_username;
  }
  if ((n === 1)) {
    return this.Lsttp_model_Uri$UserInfo__f_password;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Uri$UserInfo.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "username";
  }
  if ((n === 1)) {
    return "password";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_model_Uri$UserInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Uri$UserInfo)));
}
export { $isArrayOf_Lsttp_model_Uri$UserInfo as $isArrayOf_Lsttp_model_Uri$UserInfo };
var $d_Lsttp_model_Uri$UserInfo = new $TypeData().initClass($c_Lsttp_model_Uri$UserInfo, "sttp.model.Uri$UserInfo", ({
  Lsttp_model_Uri$UserInfo: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_Uri$UserInfo as $d_Lsttp_model_Uri$UserInfo };
/** @constructor */
function $c_Lsttp_model_headers_ContentRange(unit, range, size) {
  this.Lsttp_model_headers_ContentRange__f_unit = null;
  this.Lsttp_model_headers_ContentRange__f_range = null;
  this.Lsttp_model_headers_ContentRange__f_size = null;
  this.Lsttp_model_headers_ContentRange__f_unit = unit;
  this.Lsttp_model_headers_ContentRange__f_range = range;
  this.Lsttp_model_headers_ContentRange__f_size = size;
}
export { $c_Lsttp_model_headers_ContentRange as $c_Lsttp_model_headers_ContentRange };
$c_Lsttp_model_headers_ContentRange.prototype = new $h_O();
$c_Lsttp_model_headers_ContentRange.prototype.constructor = $c_Lsttp_model_headers_ContentRange;
/** @constructor */
function $h_Lsttp_model_headers_ContentRange() {
}
export { $h_Lsttp_model_headers_ContentRange as $h_Lsttp_model_headers_ContentRange };
$h_Lsttp_model_headers_ContentRange.prototype = $c_Lsttp_model_headers_ContentRange.prototype;
$c_Lsttp_model_headers_ContentRange.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_ContentRange.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-536775157), true);
});
$c_Lsttp_model_headers_ContentRange.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_headers_ContentRange)) {
    if ((this.Lsttp_model_headers_ContentRange__f_unit === x$0.Lsttp_model_headers_ContentRange__f_unit)) {
      var x = this.Lsttp_model_headers_ContentRange__f_range;
      var x$2 = x$0.Lsttp_model_headers_ContentRange__f_range;
      var $x_1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lsttp_model_headers_ContentRange__f_size;
      var x$4 = x$0.Lsttp_model_headers_ContentRange__f_size;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_model_headers_ContentRange.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_model_headers_ContentRange.prototype.productPrefix__T = (function() {
  return "ContentRange";
});
$c_Lsttp_model_headers_ContentRange.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_model_headers_ContentRange__f_unit;
      break;
    }
    case 1: {
      return this.Lsttp_model_headers_ContentRange__f_range;
      break;
    }
    case 2: {
      return this.Lsttp_model_headers_ContentRange__f_size;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_headers_ContentRange.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "unit";
      break;
    }
    case 1: {
      return "range";
      break;
    }
    case 2: {
      return "size";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_headers_ContentRange.prototype.toString__T = (function() {
  var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  var str = this.Lsttp_model_headers_ContentRange__f_unit;
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + " ");
  matchResult4: {
    var x5 = this.Lsttp_model_headers_ContentRange__f_range;
    if ((x5 instanceof $c_s_Some)) {
      var t = $uJ(x5.s_Some__f_value._1__O());
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var this$2 = $m_RTLong$();
      var str$1 = this$2.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi);
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "-");
      var t$1 = $uJ(x5.s_Some__f_value._2__O());
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var this$4 = $m_RTLong$();
      var str$2 = this$4.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$1, hi$1);
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2);
      break matchResult4;
    }
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "*");
  }
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "/");
  matchResult5: {
    var x7 = this.Lsttp_model_headers_ContentRange__f_size;
    if ((x7 instanceof $c_s_Some)) {
      var t$2 = $uJ(x7.s_Some__f_value);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      var this$7 = $m_RTLong$();
      var str$3 = this$7.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$2, hi$2);
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$3);
      break matchResult5;
    }
    sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "*");
  }
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
function $isArrayOf_Lsttp_model_headers_ContentRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_headers_ContentRange)));
}
export { $isArrayOf_Lsttp_model_headers_ContentRange as $isArrayOf_Lsttp_model_headers_ContentRange };
var $d_Lsttp_model_headers_ContentRange = new $TypeData().initClass($c_Lsttp_model_headers_ContentRange, "sttp.model.headers.ContentRange", ({
  Lsttp_model_headers_ContentRange: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_headers_ContentRange as $d_Lsttp_model_headers_ContentRange };
/** @constructor */
function $c_Lsttp_model_headers_Cookie(name, value) {
  this.Lsttp_model_headers_Cookie__f_name = null;
  this.Lsttp_model_headers_Cookie__f_value = null;
  this.Lsttp_model_headers_Cookie__f_name = name;
  this.Lsttp_model_headers_Cookie__f_value = value;
}
export { $c_Lsttp_model_headers_Cookie as $c_Lsttp_model_headers_Cookie };
$c_Lsttp_model_headers_Cookie.prototype = new $h_O();
$c_Lsttp_model_headers_Cookie.prototype.constructor = $c_Lsttp_model_headers_Cookie;
/** @constructor */
function $h_Lsttp_model_headers_Cookie() {
}
export { $h_Lsttp_model_headers_Cookie as $h_Lsttp_model_headers_Cookie };
$h_Lsttp_model_headers_Cookie.prototype = $c_Lsttp_model_headers_Cookie.prototype;
$c_Lsttp_model_headers_Cookie.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_Cookie.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2015920540, true);
});
$c_Lsttp_model_headers_Cookie.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_model_headers_Cookie) && ((this.Lsttp_model_headers_Cookie__f_name === x$0.Lsttp_model_headers_Cookie__f_name) && (this.Lsttp_model_headers_Cookie__f_value === x$0.Lsttp_model_headers_Cookie__f_value))));
});
$c_Lsttp_model_headers_Cookie.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_model_headers_Cookie.prototype.productPrefix__T = (function() {
  return "Cookie";
});
$c_Lsttp_model_headers_Cookie.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_headers_Cookie__f_name;
  }
  if ((n === 1)) {
    return this.Lsttp_model_headers_Cookie__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_Cookie.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  if ((n === 1)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_Cookie.prototype.toString__T = (function() {
  return ((this.Lsttp_model_headers_Cookie__f_name + "=") + this.Lsttp_model_headers_Cookie__f_value);
});
function $isArrayOf_Lsttp_model_headers_Cookie(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_headers_Cookie)));
}
export { $isArrayOf_Lsttp_model_headers_Cookie as $isArrayOf_Lsttp_model_headers_Cookie };
var $d_Lsttp_model_headers_Cookie = new $TypeData().initClass($c_Lsttp_model_headers_Cookie, "sttp.model.headers.Cookie", ({
  Lsttp_model_headers_Cookie: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_headers_Cookie as $d_Lsttp_model_headers_Cookie };
/** @constructor */
function $c_Lsttp_model_headers_ETag(tag, weak) {
  this.Lsttp_model_headers_ETag__f_tag = null;
  this.Lsttp_model_headers_ETag__f_weak = false;
  this.Lsttp_model_headers_ETag__f_tag = tag;
  this.Lsttp_model_headers_ETag__f_weak = weak;
}
export { $c_Lsttp_model_headers_ETag as $c_Lsttp_model_headers_ETag };
$c_Lsttp_model_headers_ETag.prototype = new $h_O();
$c_Lsttp_model_headers_ETag.prototype.constructor = $c_Lsttp_model_headers_ETag;
/** @constructor */
function $h_Lsttp_model_headers_ETag() {
}
export { $h_Lsttp_model_headers_ETag as $h_Lsttp_model_headers_ETag };
$h_Lsttp_model_headers_ETag.prototype = $c_Lsttp_model_headers_ETag.prototype;
$c_Lsttp_model_headers_ETag.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_ETag.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $m_sr_Statics$().mix__I__I__I(hash, 2139413);
  var hash$1 = acc;
  var x = this.Lsttp_model_headers_ETag__f_tag;
  var data = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var data$1 = (this.Lsttp_model_headers_ETag__f_weak ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
});
$c_Lsttp_model_headers_ETag.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_model_headers_ETag) && ((this.Lsttp_model_headers_ETag__f_weak === x$0.Lsttp_model_headers_ETag__f_weak) && (this.Lsttp_model_headers_ETag__f_tag === x$0.Lsttp_model_headers_ETag__f_tag))));
});
$c_Lsttp_model_headers_ETag.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_model_headers_ETag.prototype.productPrefix__T = (function() {
  return "ETag";
});
$c_Lsttp_model_headers_ETag.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_headers_ETag__f_tag;
  }
  if ((n === 1)) {
    return this.Lsttp_model_headers_ETag__f_weak;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_ETag.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "tag";
  }
  if ((n === 1)) {
    return "weak";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_ETag.prototype.toString__T = (function() {
  return ((((this.Lsttp_model_headers_ETag__f_weak ? "W/" : "") + "\"") + this.Lsttp_model_headers_ETag__f_tag) + "\"");
});
function $isArrayOf_Lsttp_model_headers_ETag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_headers_ETag)));
}
export { $isArrayOf_Lsttp_model_headers_ETag as $isArrayOf_Lsttp_model_headers_ETag };
var $d_Lsttp_model_headers_ETag = new $TypeData().initClass($c_Lsttp_model_headers_ETag, "sttp.model.headers.ETag", ({
  Lsttp_model_headers_ETag: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_headers_ETag as $d_Lsttp_model_headers_ETag };
/** @constructor */
function $c_Lsttp_model_headers_Range(start, end, unit) {
  this.Lsttp_model_headers_Range__f_start = null;
  this.Lsttp_model_headers_Range__f_end = null;
  this.Lsttp_model_headers_Range__f_unit = null;
  this.Lsttp_model_headers_Range__f_start = start;
  this.Lsttp_model_headers_Range__f_end = end;
  this.Lsttp_model_headers_Range__f_unit = unit;
  if (((!end.isEmpty__Z()) && (!start.isEmpty__Z()))) {
    var a = $uJ(end.get__O());
    $uJ(start.get__O());
  }
}
export { $c_Lsttp_model_headers_Range as $c_Lsttp_model_headers_Range };
$c_Lsttp_model_headers_Range.prototype = new $h_O();
$c_Lsttp_model_headers_Range.prototype.constructor = $c_Lsttp_model_headers_Range;
/** @constructor */
function $h_Lsttp_model_headers_Range() {
}
export { $h_Lsttp_model_headers_Range as $h_Lsttp_model_headers_Range };
$h_Lsttp_model_headers_Range.prototype = $c_Lsttp_model_headers_Range.prototype;
$c_Lsttp_model_headers_Range.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_Range.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1676068225), true);
});
$c_Lsttp_model_headers_Range.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_headers_Range)) {
    var x = this.Lsttp_model_headers_Range__f_start;
    var x$2 = x$0.Lsttp_model_headers_Range__f_start;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_model_headers_Range__f_end;
      var x$4 = x$0.Lsttp_model_headers_Range__f_end;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.Lsttp_model_headers_Range__f_unit === x$0.Lsttp_model_headers_Range__f_unit);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_model_headers_Range.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_model_headers_Range.prototype.productPrefix__T = (function() {
  return "Range";
});
$c_Lsttp_model_headers_Range.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_model_headers_Range__f_start;
      break;
    }
    case 1: {
      return this.Lsttp_model_headers_Range__f_end;
      break;
    }
    case 2: {
      return this.Lsttp_model_headers_Range__f_unit;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_headers_Range.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "start";
      break;
    }
    case 1: {
      return "end";
      break;
    }
    case 2: {
      return "unit";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_headers_Range.prototype.toString__T = (function() {
  var sb = $ct_jl_StringBuilder__(new $c_jl_StringBuilder());
  var str = this.Lsttp_model_headers_Range__f_unit;
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "=");
  matchResult4: {
    var x5 = this.Lsttp_model_headers_Range__f_start;
    if ((x5 instanceof $c_s_Some)) {
      var t = $uJ(x5.s_Some__f_value);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var this$1 = $m_RTLong$();
      var str$1 = this$1.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi);
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$1);
      break matchResult4;
    }
  }
  sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (sb.jl_StringBuilder__f_java$lang$StringBuilder$$content + "-");
  matchResult5: {
    var x7 = this.Lsttp_model_headers_Range__f_end;
    if ((x7 instanceof $c_s_Some)) {
      var t$1 = $uJ(x7.s_Some__f_value);
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      var this$3 = $m_RTLong$();
      var str$2 = this$3.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo$1, hi$1);
      sb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + sb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str$2);
      break matchResult5;
    }
  }
  return sb.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
function $isArrayOf_Lsttp_model_headers_Range(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_headers_Range)));
}
export { $isArrayOf_Lsttp_model_headers_Range as $isArrayOf_Lsttp_model_headers_Range };
var $d_Lsttp_model_headers_Range = new $TypeData().initClass($c_Lsttp_model_headers_Range, "sttp.model.headers.Range", ({
  Lsttp_model_headers_Range: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_headers_Range as $d_Lsttp_model_headers_Range };
/** @constructor */
function $c_Lsttp_model_internal_FastCharMap(map) {
  this.Lsttp_model_internal_FastCharMap__f_map = null;
  this.Lsttp_model_internal_FastCharMap__f_maxCode = 0;
  this.Lsttp_model_internal_FastCharMap__f_array = null;
  this.Lsttp_model_internal_FastCharMap__f_keySet = null;
  this.Lsttp_model_internal_FastCharMap__f_map = map;
  var codes = map.map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var key = $uC(x$1._1__O());
      var value = x$1._2__O();
      var _1 = key;
      return $ct_T2__O__O__(new $c_T2(), _1, value);
    }
    throw new $c_s_MatchError(x$1);
  })));
  var maxCode = ($f_sc_IterableOnceOps__maxBy__F1__s_math_Ordering__O(codes, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => (_$2._1__O() | 0))), $m_s_math_Ordering$Int$())._1__O() | 0);
  var n = ((1 + maxCode) | 0);
  if ((n <= 0)) {
    var array$1 = new ($d_s_Option.getArrayOf().constr)(0);
  } else {
    var array = new ($d_s_Option.getArrayOf().constr)(n);
    var i = 0;
    while ((i < n)) {
      array.u[i] = $m_s_None$();
      i = ((1 + i) | 0);
    }
    var array$1 = array;
  }
  codes.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1$2) => {
    matchResult8: {
      if ((x$1$2 !== null)) {
        var code = (x$1$2._1__O() | 0);
        var value$1 = x$1$2._2__O();
        array$1.u[code] = new $c_s_Some(value$1);
        break matchResult8;
      }
      throw new $c_s_MatchError(x$1$2);
    }
  })));
  this.Lsttp_model_internal_FastCharMap__f_maxCode = maxCode;
  this.Lsttp_model_internal_FastCharMap__f_array = array$1;
  var set = map.keySet__sci_Set();
  this.Lsttp_model_internal_FastCharMap__f_keySet = new $c_Lsttp_model_internal_FastCharSet(set);
}
export { $c_Lsttp_model_internal_FastCharMap as $c_Lsttp_model_internal_FastCharMap };
$c_Lsttp_model_internal_FastCharMap.prototype = new $h_O();
$c_Lsttp_model_internal_FastCharMap.prototype.constructor = $c_Lsttp_model_internal_FastCharMap;
/** @constructor */
function $h_Lsttp_model_internal_FastCharMap() {
}
export { $h_Lsttp_model_internal_FastCharMap as $h_Lsttp_model_internal_FastCharMap };
$h_Lsttp_model_internal_FastCharMap.prototype = $c_Lsttp_model_internal_FastCharMap.prototype;
$c_Lsttp_model_internal_FastCharMap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_internal_FastCharMap.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1147396484, true);
});
$c_Lsttp_model_internal_FastCharMap.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_internal_FastCharMap)) {
    var x = this.Lsttp_model_internal_FastCharMap__f_map;
    var x$2 = x$0.Lsttp_model_internal_FastCharMap__f_map;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_internal_FastCharMap.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_model_internal_FastCharMap.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_internal_FastCharMap.prototype.productPrefix__T = (function() {
  return "FastCharMap";
});
$c_Lsttp_model_internal_FastCharMap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_internal_FastCharMap__f_map;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_internal_FastCharMap.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "map";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_internal_FastCharMap.prototype.get__C__s_Option = (function(ch) {
  var code = ch;
  return ((code <= this.Lsttp_model_internal_FastCharMap__f_maxCode) ? this.Lsttp_model_internal_FastCharMap__f_array.u[code] : $m_s_None$());
});
function $isArrayOf_Lsttp_model_internal_FastCharMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_internal_FastCharMap)));
}
export { $isArrayOf_Lsttp_model_internal_FastCharMap as $isArrayOf_Lsttp_model_internal_FastCharMap };
var $d_Lsttp_model_internal_FastCharMap = new $TypeData().initClass($c_Lsttp_model_internal_FastCharMap, "sttp.model.internal.FastCharMap", ({
  Lsttp_model_internal_FastCharMap: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_internal_FastCharMap as $d_Lsttp_model_internal_FastCharMap };
/** @constructor */
function $c_Lsttp_model_internal_FastCharSet(set) {
  this.Lsttp_model_internal_FastCharSet__f_set = null;
  this.Lsttp_model_internal_FastCharSet__f_maxCode = 0;
  this.Lsttp_model_internal_FastCharSet__f_array = null;
  this.Lsttp_model_internal_FastCharSet__f_set = set;
  var codes = set.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    var _$1$1 = $uC(_$1);
    return _$1$1;
  })));
  var maxCode = (codes.max__s_math_Ordering__O($m_s_math_Ordering$Int$()) | 0);
  var array = new $ac_Z(((1 + maxCode) | 0));
  codes.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v1) => {
    var code = (v1 | 0);
    array.u[code] = true;
  })));
  this.Lsttp_model_internal_FastCharSet__f_maxCode = maxCode;
  this.Lsttp_model_internal_FastCharSet__f_array = array;
}
export { $c_Lsttp_model_internal_FastCharSet as $c_Lsttp_model_internal_FastCharSet };
$c_Lsttp_model_internal_FastCharSet.prototype = new $h_O();
$c_Lsttp_model_internal_FastCharSet.prototype.constructor = $c_Lsttp_model_internal_FastCharSet;
/** @constructor */
function $h_Lsttp_model_internal_FastCharSet() {
}
export { $h_Lsttp_model_internal_FastCharSet as $h_Lsttp_model_internal_FastCharSet };
$h_Lsttp_model_internal_FastCharSet.prototype = $c_Lsttp_model_internal_FastCharSet.prototype;
$c_Lsttp_model_internal_FastCharSet.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_internal_FastCharSet.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-719479698), true);
});
$c_Lsttp_model_internal_FastCharSet.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_internal_FastCharSet)) {
    var x = this.Lsttp_model_internal_FastCharSet__f_set;
    var x$2 = x$0.Lsttp_model_internal_FastCharSet__f_set;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_internal_FastCharSet.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_model_internal_FastCharSet.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_internal_FastCharSet.prototype.productPrefix__T = (function() {
  return "FastCharSet";
});
$c_Lsttp_model_internal_FastCharSet.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_internal_FastCharSet__f_set;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_internal_FastCharSet.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "set";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_internal_FastCharSet.prototype.contains__C__Z = (function(ch) {
  var code = ch;
  return ((code <= this.Lsttp_model_internal_FastCharSet__f_maxCode) && this.Lsttp_model_internal_FastCharSet__f_array.u[code]);
});
function $isArrayOf_Lsttp_model_internal_FastCharSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_internal_FastCharSet)));
}
export { $isArrayOf_Lsttp_model_internal_FastCharSet as $isArrayOf_Lsttp_model_internal_FastCharSet };
var $d_Lsttp_model_internal_FastCharSet = new $TypeData().initClass($c_Lsttp_model_internal_FastCharSet, "sttp.model.internal.FastCharSet", ({
  Lsttp_model_internal_FastCharSet: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_internal_FastCharSet as $d_Lsttp_model_internal_FastCharSet };
/** @constructor */
function $c_Lsttp_tapir_AttributeMap(storage) {
  this.Lsttp_tapir_AttributeMap__f_storage = null;
  this.Lsttp_tapir_AttributeMap__f_storage = storage;
}
export { $c_Lsttp_tapir_AttributeMap as $c_Lsttp_tapir_AttributeMap };
$c_Lsttp_tapir_AttributeMap.prototype = new $h_O();
$c_Lsttp_tapir_AttributeMap.prototype.constructor = $c_Lsttp_tapir_AttributeMap;
/** @constructor */
function $h_Lsttp_tapir_AttributeMap() {
}
export { $h_Lsttp_tapir_AttributeMap as $h_Lsttp_tapir_AttributeMap };
$h_Lsttp_tapir_AttributeMap.prototype = $c_Lsttp_tapir_AttributeMap.prototype;
$c_Lsttp_tapir_AttributeMap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_AttributeMap.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1683251203), true);
});
$c_Lsttp_tapir_AttributeMap.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_AttributeMap)) {
    var x = this.Lsttp_tapir_AttributeMap__f_storage;
    var x$2 = x$0.Lsttp_tapir_AttributeMap__f_storage;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_AttributeMap.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_AttributeMap.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_AttributeMap.prototype.productPrefix__T = (function() {
  return "AttributeMap";
});
$c_Lsttp_tapir_AttributeMap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_AttributeMap__f_storage;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_AttributeMap.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "storage";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_AttributeMap.prototype.put__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_AttributeMap = (function(k, v) {
  var $x_1 = this.Lsttp_tapir_AttributeMap__f_storage;
  var self = k.Lsttp_tapir_AttributeKey__f_typeName;
  var storage = $x_1.$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), self, v));
  return new $c_Lsttp_tapir_AttributeMap(storage);
});
function $isArrayOf_Lsttp_tapir_AttributeMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_AttributeMap)));
}
export { $isArrayOf_Lsttp_tapir_AttributeMap as $isArrayOf_Lsttp_tapir_AttributeMap };
var $d_Lsttp_tapir_AttributeMap = new $TypeData().initClass($c_Lsttp_tapir_AttributeMap, "sttp.tapir.AttributeMap", ({
  Lsttp_tapir_AttributeMap: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_AttributeMap as $d_Lsttp_tapir_AttributeMap };
/** @constructor */
function $c_Lsttp_tapir_FieldName(name, encodedName) {
  this.Lsttp_tapir_FieldName__f_name = null;
  this.Lsttp_tapir_FieldName__f_encodedName = null;
  this.Lsttp_tapir_FieldName__f_name = name;
  this.Lsttp_tapir_FieldName__f_encodedName = encodedName;
}
export { $c_Lsttp_tapir_FieldName as $c_Lsttp_tapir_FieldName };
$c_Lsttp_tapir_FieldName.prototype = new $h_O();
$c_Lsttp_tapir_FieldName.prototype.constructor = $c_Lsttp_tapir_FieldName;
/** @constructor */
function $h_Lsttp_tapir_FieldName() {
}
export { $h_Lsttp_tapir_FieldName as $h_Lsttp_tapir_FieldName };
$h_Lsttp_tapir_FieldName.prototype = $c_Lsttp_tapir_FieldName.prototype;
$c_Lsttp_tapir_FieldName.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_FieldName.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1351861271, true);
});
$c_Lsttp_tapir_FieldName.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_tapir_FieldName) && ((this.Lsttp_tapir_FieldName__f_name === x$0.Lsttp_tapir_FieldName__f_name) && (this.Lsttp_tapir_FieldName__f_encodedName === x$0.Lsttp_tapir_FieldName__f_encodedName))));
});
$c_Lsttp_tapir_FieldName.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_FieldName.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_FieldName.prototype.productPrefix__T = (function() {
  return "FieldName";
});
$c_Lsttp_tapir_FieldName.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_FieldName__f_name;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_FieldName__f_encodedName;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_FieldName.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  if ((n === 1)) {
    return "encodedName";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_FieldName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_FieldName)));
}
export { $isArrayOf_Lsttp_tapir_FieldName as $isArrayOf_Lsttp_tapir_FieldName };
var $d_Lsttp_tapir_FieldName = new $TypeData().initClass($c_Lsttp_tapir_FieldName, "sttp.tapir.FieldName", ({
  Lsttp_tapir_FieldName: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_FieldName as $d_Lsttp_tapir_FieldName };
/** @constructor */
function $c_Lsttp_tapir_FileRange(file, range) {
  this.Lsttp_tapir_FileRange__f_file = null;
  this.Lsttp_tapir_FileRange__f_range = null;
  this.Lsttp_tapir_FileRange__f_file = file;
  this.Lsttp_tapir_FileRange__f_range = range;
}
export { $c_Lsttp_tapir_FileRange as $c_Lsttp_tapir_FileRange };
$c_Lsttp_tapir_FileRange.prototype = new $h_O();
$c_Lsttp_tapir_FileRange.prototype.constructor = $c_Lsttp_tapir_FileRange;
/** @constructor */
function $h_Lsttp_tapir_FileRange() {
}
export { $h_Lsttp_tapir_FileRange as $h_Lsttp_tapir_FileRange };
$h_Lsttp_tapir_FileRange.prototype = $c_Lsttp_tapir_FileRange.prototype;
$c_Lsttp_tapir_FileRange.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_FileRange.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 719819616, true);
});
$c_Lsttp_tapir_FileRange.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_FileRange)) {
    var x = this.Lsttp_tapir_FileRange__f_file;
    var y = x$0.Lsttp_tapir_FileRange__f_file;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lsttp_tapir_FileRange__f_range;
      var x$2 = x$0.Lsttp_tapir_FileRange__f_range;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_FileRange.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_FileRange.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_FileRange.prototype.productPrefix__T = (function() {
  return "FileRange";
});
$c_Lsttp_tapir_FileRange.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_FileRange__f_file;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_FileRange__f_range;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_FileRange.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "file";
  }
  if ((n === 1)) {
    return "range";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_FileRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_FileRange)));
}
export { $isArrayOf_Lsttp_tapir_FileRange as $isArrayOf_Lsttp_tapir_FileRange };
var $d_Lsttp_tapir_FileRange = new $TypeData().initClass($c_Lsttp_tapir_FileRange, "sttp.tapir.FileRange", ({
  Lsttp_tapir_FileRange: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_FileRange as $d_Lsttp_tapir_FileRange };
/** @constructor */
function $c_Lsttp_tapir_MultipartCodec(rawBodyType, codec) {
  this.Lsttp_tapir_MultipartCodec__f_rawBodyType = null;
  this.Lsttp_tapir_MultipartCodec__f_codec = null;
  this.Lsttp_tapir_MultipartCodec__f_rawBodyType = rawBodyType;
  this.Lsttp_tapir_MultipartCodec__f_codec = codec;
}
export { $c_Lsttp_tapir_MultipartCodec as $c_Lsttp_tapir_MultipartCodec };
$c_Lsttp_tapir_MultipartCodec.prototype = new $h_O();
$c_Lsttp_tapir_MultipartCodec.prototype.constructor = $c_Lsttp_tapir_MultipartCodec;
/** @constructor */
function $h_Lsttp_tapir_MultipartCodec() {
}
export { $h_Lsttp_tapir_MultipartCodec as $h_Lsttp_tapir_MultipartCodec };
$h_Lsttp_tapir_MultipartCodec.prototype = $c_Lsttp_tapir_MultipartCodec.prototype;
$c_Lsttp_tapir_MultipartCodec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_MultipartCodec.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1219097542), true);
});
$c_Lsttp_tapir_MultipartCodec.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_MultipartCodec)) {
    var x = this.Lsttp_tapir_MultipartCodec__f_rawBodyType;
    var x$2 = x$0.Lsttp_tapir_MultipartCodec__f_rawBodyType;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_MultipartCodec__f_codec;
      var x$4 = x$0.Lsttp_tapir_MultipartCodec__f_codec;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_MultipartCodec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_MultipartCodec.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_MultipartCodec.prototype.productPrefix__T = (function() {
  return "MultipartCodec";
});
$c_Lsttp_tapir_MultipartCodec.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_MultipartCodec__f_rawBodyType;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_MultipartCodec__f_codec;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_MultipartCodec.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "rawBodyType";
  }
  if ((n === 1)) {
    return "codec";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_MultipartCodec.prototype.map__Lsttp_tapir_Mapping__Lsttp_tapir_MultipartCodec = (function(mapping) {
  $m_Lsttp_tapir_MultipartCodec$();
  var rawBodyType = this.Lsttp_tapir_MultipartCodec__f_rawBodyType;
  var this$1 = this.Lsttp_tapir_MultipartCodec__f_codec;
  var codec = new $c_Lsttp_tapir_Codec$$anon$1(mapping, this$1);
  return new $c_Lsttp_tapir_MultipartCodec(rawBodyType, codec);
});
$c_Lsttp_tapir_MultipartCodec.prototype.map__F1__F1__Lsttp_tapir_MultipartCodec = (function(f, g) {
  return this.map__Lsttp_tapir_Mapping__Lsttp_tapir_MultipartCodec($m_Lsttp_tapir_Mapping$().from__F1__F1__Lsttp_tapir_Mapping(f, g));
});
function $isArrayOf_Lsttp_tapir_MultipartCodec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_MultipartCodec)));
}
export { $isArrayOf_Lsttp_tapir_MultipartCodec as $isArrayOf_Lsttp_tapir_MultipartCodec };
var $d_Lsttp_tapir_MultipartCodec = new $TypeData().initClass($c_Lsttp_tapir_MultipartCodec, "sttp.tapir.MultipartCodec", ({
  Lsttp_tapir_MultipartCodec: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_MultipartCodec as $d_Lsttp_tapir_MultipartCodec };
/** @constructor */
function $c_Lsttp_tapir_MultipartCodec$() {
  this.Lsttp_tapir_MultipartCodec$__f_Default = null;
  $n_Lsttp_tapir_MultipartCodec$ = this;
  var e = $m_Lsttp_tapir_Codec$().list__Lsttp_tapir_Codec__Lsttp_tapir_Codec($m_Lsttp_tapir_Codec$().part__Lsttp_tapir_Codec__Lsttp_tapir_Codec($m_Lsttp_tapir_Codec$().Lsttp_tapir_Codec$__f_byteArray));
  var $x_2 = $m_Lsttp_tapir_Codec$();
  var $x_1 = $m_sci_Map$EmptyMap$();
  var rawBodyType = $m_Lsttp_tapir_RawBodyType$ByteArrayBody$();
  var value = new $c_Lsttp_tapir_PartCodec(rawBodyType, e);
  this.Lsttp_tapir_MultipartCodec$__f_Default = $x_2.multipart__sci_Map__s_Option__Lsttp_tapir_MultipartCodec($x_1, new $c_s_Some(value)).map__F1__F1__Lsttp_tapir_MultipartCodec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$60) => {
    var this$6 = new $c_sc_MapOps$$anon$1(_$60);
    return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this$6).flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$61) => _$61)));
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((l) => {
    var this$14 = $m_sci_ListMap$();
    var m = $m_scm_Map$().empty__O();
    var it = l.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem = it.next__O();
      var key = elem.Lsttp_model_Part__f_name;
      var bldr = m.getOrElseUpdate__O__F0__O(key, new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855(((this$7) => (() => this$7.newSpecificBuilder__scm_Builder()))(l)));
      bldr.addOne__O__scm_Growable(elem);
    }
    var this$8 = $m_sci_HashMap$();
    var result = this$8.sci_HashMap$__f_EmptyMap;
    var mapIt = m.iterator__sc_Iterator();
    while (mapIt.hasNext__Z()) {
      var x1 = mapIt.next__O();
      if ((x1 === null)) {
        throw new $c_s_MatchError(x1);
      }
      var k = x1._1__O();
      var v = x1._2__O();
      result = result.updated__O__O__sci_HashMap(k, v.result__O());
    }
    var this$9 = result;
    var this$13 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this$9);
    var f = ((x$1) => {
      if ((x$1 !== null)) {
        var name = x$1._1__O();
        var parts = x$1._2__O();
        var y = parts.toList__sci_List();
        return $ct_T2__O__O__(new $c_T2(), name, y);
      }
      throw new $c_s_MatchError(x$1);
    });
    if ((this$13 === $m_sci_Nil$())) {
      var elems = $m_sci_Nil$();
    } else {
      var x0 = this$13.head__O();
      var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
      var t = h;
      var rest = this$13.tail__O();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.head__O();
        var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
        rest = rest.tail__O();
      }
      var elems = h;
    }
    return this$14.from__sc_IterableOnce__sci_ListMap(elems);
  })));
}
export { $c_Lsttp_tapir_MultipartCodec$ as $c_Lsttp_tapir_MultipartCodec$ };
$c_Lsttp_tapir_MultipartCodec$.prototype = new $h_O();
$c_Lsttp_tapir_MultipartCodec$.prototype.constructor = $c_Lsttp_tapir_MultipartCodec$;
/** @constructor */
function $h_Lsttp_tapir_MultipartCodec$() {
}
export { $h_Lsttp_tapir_MultipartCodec$ as $h_Lsttp_tapir_MultipartCodec$ };
$h_Lsttp_tapir_MultipartCodec$.prototype = $c_Lsttp_tapir_MultipartCodec$.prototype;
$c_Lsttp_tapir_MultipartCodec$.prototype.fromProduct__s_Product__Lsttp_tapir_MultipartCodec = (function(x$0) {
  return new $c_Lsttp_tapir_MultipartCodec(x$0.productElement__I__O(0), x$0.productElement__I__O(1));
});
$c_Lsttp_tapir_MultipartCodec$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_MultipartCodec(p);
});
var $d_Lsttp_tapir_MultipartCodec$ = new $TypeData().initClass($c_Lsttp_tapir_MultipartCodec$, "sttp.tapir.MultipartCodec$", ({
  Lsttp_tapir_MultipartCodec$: 1,
  Lsttp_tapir_macros_MultipartCodecMacros: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_MultipartCodec$ as $d_Lsttp_tapir_MultipartCodec$ };
var $n_Lsttp_tapir_MultipartCodec$;
function $m_Lsttp_tapir_MultipartCodec$() {
  if ((!$n_Lsttp_tapir_MultipartCodec$)) {
    $n_Lsttp_tapir_MultipartCodec$ = new $c_Lsttp_tapir_MultipartCodec$();
  }
  return $n_Lsttp_tapir_MultipartCodec$;
}
export { $m_Lsttp_tapir_MultipartCodec$ as $m_Lsttp_tapir_MultipartCodec$ };
/** @constructor */
function $c_Lsttp_tapir_PartCodec(rawBodyType, codec) {
  this.Lsttp_tapir_PartCodec__f_rawBodyType = null;
  this.Lsttp_tapir_PartCodec__f_codec = null;
  this.Lsttp_tapir_PartCodec__f_rawBodyType = rawBodyType;
  this.Lsttp_tapir_PartCodec__f_codec = codec;
}
export { $c_Lsttp_tapir_PartCodec as $c_Lsttp_tapir_PartCodec };
$c_Lsttp_tapir_PartCodec.prototype = new $h_O();
$c_Lsttp_tapir_PartCodec.prototype.constructor = $c_Lsttp_tapir_PartCodec;
/** @constructor */
function $h_Lsttp_tapir_PartCodec() {
}
export { $h_Lsttp_tapir_PartCodec as $h_Lsttp_tapir_PartCodec };
$h_Lsttp_tapir_PartCodec.prototype = $c_Lsttp_tapir_PartCodec.prototype;
$c_Lsttp_tapir_PartCodec.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_PartCodec.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-265622718), true);
});
$c_Lsttp_tapir_PartCodec.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_PartCodec)) {
    var x = this.Lsttp_tapir_PartCodec__f_rawBodyType;
    var x$2 = x$0.Lsttp_tapir_PartCodec__f_rawBodyType;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_PartCodec__f_codec;
      var x$4 = x$0.Lsttp_tapir_PartCodec__f_codec;
      return (x$3 === x$4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_PartCodec.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_PartCodec.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_PartCodec.prototype.productPrefix__T = (function() {
  return "PartCodec";
});
$c_Lsttp_tapir_PartCodec.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_PartCodec__f_rawBodyType;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_PartCodec__f_codec;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_PartCodec.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "rawBodyType";
  }
  if ((n === 1)) {
    return "codec";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_PartCodec(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_PartCodec)));
}
export { $isArrayOf_Lsttp_tapir_PartCodec as $isArrayOf_Lsttp_tapir_PartCodec };
var $d_Lsttp_tapir_PartCodec = new $TypeData().initClass($c_Lsttp_tapir_PartCodec, "sttp.tapir.PartCodec", ({
  Lsttp_tapir_PartCodec: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_PartCodec as $d_Lsttp_tapir_PartCodec };
/** @constructor */
function $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue(v) {
  this.Lsttp_tapir_Schema$EncodedDiscriminatorValue__f_v = null;
  this.Lsttp_tapir_Schema$EncodedDiscriminatorValue__f_v = v;
}
export { $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue as $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue };
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype = new $h_O();
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype.constructor = $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue;
/** @constructor */
function $h_Lsttp_tapir_Schema$EncodedDiscriminatorValue() {
}
export { $h_Lsttp_tapir_Schema$EncodedDiscriminatorValue as $h_Lsttp_tapir_Schema$EncodedDiscriminatorValue };
$h_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype = $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype;
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1080848067), true);
});
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue) && (this.Lsttp_tapir_Schema$EncodedDiscriminatorValue__f_v === x$0.Lsttp_tapir_Schema$EncodedDiscriminatorValue__f_v)));
});
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype.productPrefix__T = (function() {
  return "EncodedDiscriminatorValue";
});
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_Schema$EncodedDiscriminatorValue__f_v;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Schema$EncodedDiscriminatorValue.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "v";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_Schema$EncodedDiscriminatorValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$EncodedDiscriminatorValue)));
}
export { $isArrayOf_Lsttp_tapir_Schema$EncodedDiscriminatorValue as $isArrayOf_Lsttp_tapir_Schema$EncodedDiscriminatorValue };
var $d_Lsttp_tapir_Schema$EncodedDiscriminatorValue = new $TypeData().initClass($c_Lsttp_tapir_Schema$EncodedDiscriminatorValue, "sttp.tapir.Schema$EncodedDiscriminatorValue", ({
  Lsttp_tapir_Schema$EncodedDiscriminatorValue: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Schema$EncodedDiscriminatorValue as $d_Lsttp_tapir_Schema$EncodedDiscriminatorValue };
/** @constructor */
function $c_Lsttp_tapir_Schema$SName(fullName, typeParameterShortNames) {
  this.Lsttp_tapir_Schema$SName__f_fullName = null;
  this.Lsttp_tapir_Schema$SName__f_typeParameterShortNames = null;
  this.Lsttp_tapir_Schema$SName__f_fullName = fullName;
  this.Lsttp_tapir_Schema$SName__f_typeParameterShortNames = typeParameterShortNames;
}
export { $c_Lsttp_tapir_Schema$SName as $c_Lsttp_tapir_Schema$SName };
$c_Lsttp_tapir_Schema$SName.prototype = new $h_O();
$c_Lsttp_tapir_Schema$SName.prototype.constructor = $c_Lsttp_tapir_Schema$SName;
/** @constructor */
function $h_Lsttp_tapir_Schema$SName() {
}
export { $h_Lsttp_tapir_Schema$SName as $h_Lsttp_tapir_Schema$SName };
$h_Lsttp_tapir_Schema$SName.prototype = $c_Lsttp_tapir_Schema$SName.prototype;
$c_Lsttp_tapir_Schema$SName.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Schema$SName.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1428566097), true);
});
$c_Lsttp_tapir_Schema$SName.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_Schema$SName)) {
    if ((this.Lsttp_tapir_Schema$SName__f_fullName === x$0.Lsttp_tapir_Schema$SName__f_fullName)) {
      var x = this.Lsttp_tapir_Schema$SName__f_typeParameterShortNames;
      var x$2 = x$0.Lsttp_tapir_Schema$SName__f_typeParameterShortNames;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_Schema$SName.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Schema$SName.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_Schema$SName.prototype.productPrefix__T = (function() {
  return "SName";
});
$c_Lsttp_tapir_Schema$SName.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_Schema$SName__f_fullName;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_Schema$SName__f_typeParameterShortNames;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Schema$SName.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "fullName";
  }
  if ((n === 1)) {
    return "typeParameterShortNames";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_Schema$SName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$SName)));
}
export { $isArrayOf_Lsttp_tapir_Schema$SName as $isArrayOf_Lsttp_tapir_Schema$SName };
var $d_Lsttp_tapir_Schema$SName = new $TypeData().initClass($c_Lsttp_tapir_Schema$SName, "sttp.tapir.Schema$SName", ({
  Lsttp_tapir_Schema$SName: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Schema$SName as $d_Lsttp_tapir_Schema$SName };
/** @constructor */
function $c_Lsttp_tapir_Schema$Title(value) {
  this.Lsttp_tapir_Schema$Title__f_value = null;
  this.Lsttp_tapir_Schema$Title__f_value = value;
}
export { $c_Lsttp_tapir_Schema$Title as $c_Lsttp_tapir_Schema$Title };
$c_Lsttp_tapir_Schema$Title.prototype = new $h_O();
$c_Lsttp_tapir_Schema$Title.prototype.constructor = $c_Lsttp_tapir_Schema$Title;
/** @constructor */
function $h_Lsttp_tapir_Schema$Title() {
}
export { $h_Lsttp_tapir_Schema$Title as $h_Lsttp_tapir_Schema$Title };
$h_Lsttp_tapir_Schema$Title.prototype = $c_Lsttp_tapir_Schema$Title.prototype;
$c_Lsttp_tapir_Schema$Title.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Schema$Title.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-781383597), true);
});
$c_Lsttp_tapir_Schema$Title.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_tapir_Schema$Title) && (this.Lsttp_tapir_Schema$Title__f_value === x$0.Lsttp_tapir_Schema$Title__f_value)));
});
$c_Lsttp_tapir_Schema$Title.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Schema$Title.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_Schema$Title.prototype.productPrefix__T = (function() {
  return "Title";
});
$c_Lsttp_tapir_Schema$Title.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_Schema$Title__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Schema$Title.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_Schema$Title(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$Title)));
}
export { $isArrayOf_Lsttp_tapir_Schema$Title as $isArrayOf_Lsttp_tapir_Schema$Title };
var $d_Lsttp_tapir_Schema$Title = new $TypeData().initClass($c_Lsttp_tapir_Schema$Title, "sttp.tapir.Schema$Title", ({
  Lsttp_tapir_Schema$Title: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Schema$Title as $d_Lsttp_tapir_Schema$Title };
/** @constructor */
function $c_Lsttp_tapir_Schema$Tuple(isTuple) {
  this.Lsttp_tapir_Schema$Tuple__f_isTuple = false;
  this.Lsttp_tapir_Schema$Tuple__f_isTuple = isTuple;
}
export { $c_Lsttp_tapir_Schema$Tuple as $c_Lsttp_tapir_Schema$Tuple };
$c_Lsttp_tapir_Schema$Tuple.prototype = new $h_O();
$c_Lsttp_tapir_Schema$Tuple.prototype.constructor = $c_Lsttp_tapir_Schema$Tuple;
/** @constructor */
function $h_Lsttp_tapir_Schema$Tuple() {
}
export { $h_Lsttp_tapir_Schema$Tuple as $h_Lsttp_tapir_Schema$Tuple };
$h_Lsttp_tapir_Schema$Tuple.prototype = $c_Lsttp_tapir_Schema$Tuple.prototype;
$c_Lsttp_tapir_Schema$Tuple.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Schema$Tuple.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $m_sr_Statics$().mix__I__I__I(hash, 81172392);
  var hash$1 = acc;
  var data = (this.Lsttp_tapir_Schema$Tuple__f_isTuple ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lsttp_tapir_Schema$Tuple.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_tapir_Schema$Tuple) && (this.Lsttp_tapir_Schema$Tuple__f_isTuple === x$0.Lsttp_tapir_Schema$Tuple__f_isTuple)));
});
$c_Lsttp_tapir_Schema$Tuple.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Schema$Tuple.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_Schema$Tuple.prototype.productPrefix__T = (function() {
  return "Tuple";
});
$c_Lsttp_tapir_Schema$Tuple.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_Schema$Tuple__f_isTuple;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Schema$Tuple.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "isTuple";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_Schema$Tuple(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$Tuple)));
}
export { $isArrayOf_Lsttp_tapir_Schema$Tuple as $isArrayOf_Lsttp_tapir_Schema$Tuple };
var $d_Lsttp_tapir_Schema$Tuple = new $TypeData().initClass($c_Lsttp_tapir_Schema$Tuple, "sttp.tapir.Schema$Tuple", ({
  Lsttp_tapir_Schema$Tuple: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Schema$Tuple as $d_Lsttp_tapir_Schema$Tuple };
/** @constructor */
function $c_Lsttp_tapir_Schema$UniqueItems(uniqueItems) {
  this.Lsttp_tapir_Schema$UniqueItems__f_uniqueItems = false;
  this.Lsttp_tapir_Schema$UniqueItems__f_uniqueItems = uniqueItems;
}
export { $c_Lsttp_tapir_Schema$UniqueItems as $c_Lsttp_tapir_Schema$UniqueItems };
$c_Lsttp_tapir_Schema$UniqueItems.prototype = new $h_O();
$c_Lsttp_tapir_Schema$UniqueItems.prototype.constructor = $c_Lsttp_tapir_Schema$UniqueItems;
/** @constructor */
function $h_Lsttp_tapir_Schema$UniqueItems() {
}
export { $h_Lsttp_tapir_Schema$UniqueItems as $h_Lsttp_tapir_Schema$UniqueItems };
$h_Lsttp_tapir_Schema$UniqueItems.prototype = $c_Lsttp_tapir_Schema$UniqueItems.prototype;
$c_Lsttp_tapir_Schema$UniqueItems.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Schema$UniqueItems.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $m_sr_Statics$().mix__I__I__I(hash, (-272511409));
  var hash$1 = acc;
  var data = (this.Lsttp_tapir_Schema$UniqueItems__f_uniqueItems ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lsttp_tapir_Schema$UniqueItems.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_tapir_Schema$UniqueItems) && (this.Lsttp_tapir_Schema$UniqueItems__f_uniqueItems === x$0.Lsttp_tapir_Schema$UniqueItems__f_uniqueItems)));
});
$c_Lsttp_tapir_Schema$UniqueItems.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Schema$UniqueItems.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_Schema$UniqueItems.prototype.productPrefix__T = (function() {
  return "UniqueItems";
});
$c_Lsttp_tapir_Schema$UniqueItems.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_Schema$UniqueItems__f_uniqueItems;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Schema$UniqueItems.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "uniqueItems";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_Schema$UniqueItems(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$UniqueItems)));
}
export { $isArrayOf_Lsttp_tapir_Schema$UniqueItems as $isArrayOf_Lsttp_tapir_Schema$UniqueItems };
var $d_Lsttp_tapir_Schema$UniqueItems = new $TypeData().initClass($c_Lsttp_tapir_Schema$UniqueItems, "sttp.tapir.Schema$UniqueItems", ({
  Lsttp_tapir_Schema$UniqueItems: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Schema$UniqueItems as $d_Lsttp_tapir_Schema$UniqueItems };
function $isArrayOf_Lsttp_tapir_Schema$annotations$customise(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$annotations$customise)));
}
export { $isArrayOf_Lsttp_tapir_Schema$annotations$customise as $isArrayOf_Lsttp_tapir_Schema$annotations$customise };
function $isArrayOf_Lsttp_tapir_Schema$annotations$default(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$annotations$default)));
}
export { $isArrayOf_Lsttp_tapir_Schema$annotations$default as $isArrayOf_Lsttp_tapir_Schema$annotations$default };
function $isArrayOf_Lsttp_tapir_Schema$annotations$deprecated(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$annotations$deprecated)));
}
export { $isArrayOf_Lsttp_tapir_Schema$annotations$deprecated as $isArrayOf_Lsttp_tapir_Schema$annotations$deprecated };
function $isArrayOf_Lsttp_tapir_Schema$annotations$description(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$annotations$description)));
}
export { $isArrayOf_Lsttp_tapir_Schema$annotations$description as $isArrayOf_Lsttp_tapir_Schema$annotations$description };
function $isArrayOf_Lsttp_tapir_Schema$annotations$encodedExample(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$annotations$encodedExample)));
}
export { $isArrayOf_Lsttp_tapir_Schema$annotations$encodedExample as $isArrayOf_Lsttp_tapir_Schema$annotations$encodedExample };
function $isArrayOf_Lsttp_tapir_Schema$annotations$encodedName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$annotations$encodedName)));
}
export { $isArrayOf_Lsttp_tapir_Schema$annotations$encodedName as $isArrayOf_Lsttp_tapir_Schema$annotations$encodedName };
function $isArrayOf_Lsttp_tapir_Schema$annotations$format(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$annotations$format)));
}
export { $isArrayOf_Lsttp_tapir_Schema$annotations$format as $isArrayOf_Lsttp_tapir_Schema$annotations$format };
function $isArrayOf_Lsttp_tapir_Schema$annotations$title(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$annotations$title)));
}
export { $isArrayOf_Lsttp_tapir_Schema$annotations$title as $isArrayOf_Lsttp_tapir_Schema$annotations$title };
function $isArrayOf_Lsttp_tapir_Schema$annotations$validate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$annotations$validate)));
}
export { $isArrayOf_Lsttp_tapir_Schema$annotations$validate as $isArrayOf_Lsttp_tapir_Schema$annotations$validate };
function $isArrayOf_Lsttp_tapir_Schema$annotations$validateEach(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema$annotations$validateEach)));
}
export { $isArrayOf_Lsttp_tapir_Schema$annotations$validateEach as $isArrayOf_Lsttp_tapir_Schema$annotations$validateEach };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SDiscriminator(name, mapping) {
  this.Lsttp_tapir_SchemaType$SDiscriminator__f_name = null;
  this.Lsttp_tapir_SchemaType$SDiscriminator__f_mapping = null;
  this.Lsttp_tapir_SchemaType$SDiscriminator__f_name = name;
  this.Lsttp_tapir_SchemaType$SDiscriminator__f_mapping = mapping;
}
export { $c_Lsttp_tapir_SchemaType$SDiscriminator as $c_Lsttp_tapir_SchemaType$SDiscriminator };
$c_Lsttp_tapir_SchemaType$SDiscriminator.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SDiscriminator.prototype.constructor = $c_Lsttp_tapir_SchemaType$SDiscriminator;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SDiscriminator() {
}
export { $h_Lsttp_tapir_SchemaType$SDiscriminator as $h_Lsttp_tapir_SchemaType$SDiscriminator };
$h_Lsttp_tapir_SchemaType$SDiscriminator.prototype = $c_Lsttp_tapir_SchemaType$SDiscriminator.prototype;
$c_Lsttp_tapir_SchemaType$SDiscriminator.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SDiscriminator.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 847854896, true);
});
$c_Lsttp_tapir_SchemaType$SDiscriminator.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_SchemaType$SDiscriminator)) {
    var x = this.Lsttp_tapir_SchemaType$SDiscriminator__f_name;
    var x$2 = x$0.Lsttp_tapir_SchemaType$SDiscriminator__f_name;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_SchemaType$SDiscriminator__f_mapping;
      var x$4 = x$0.Lsttp_tapir_SchemaType$SDiscriminator__f_mapping;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_SchemaType$SDiscriminator.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SDiscriminator.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_SchemaType$SDiscriminator.prototype.productPrefix__T = (function() {
  return "SDiscriminator";
});
$c_Lsttp_tapir_SchemaType$SDiscriminator.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_SchemaType$SDiscriminator__f_name;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_SchemaType$SDiscriminator__f_mapping;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SDiscriminator.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  if ((n === 1)) {
    return "mapping";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_SchemaType$SDiscriminator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SDiscriminator)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SDiscriminator as $isArrayOf_Lsttp_tapir_SchemaType$SDiscriminator };
var $d_Lsttp_tapir_SchemaType$SDiscriminator = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SDiscriminator, "sttp.tapir.SchemaType$SDiscriminator", ({
  Lsttp_tapir_SchemaType$SDiscriminator: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SDiscriminator as $d_Lsttp_tapir_SchemaType$SDiscriminator };
/** @constructor */
function $c_Lsttp_tapir_ValidationError(validator, invalidValue, path, customMessage) {
  this.Lsttp_tapir_ValidationError__f_validator = null;
  this.Lsttp_tapir_ValidationError__f_invalidValue = null;
  this.Lsttp_tapir_ValidationError__f_path = null;
  this.Lsttp_tapir_ValidationError__f_customMessage = null;
  this.Lsttp_tapir_ValidationError__f_validator = validator;
  this.Lsttp_tapir_ValidationError__f_invalidValue = invalidValue;
  this.Lsttp_tapir_ValidationError__f_path = path;
  this.Lsttp_tapir_ValidationError__f_customMessage = customMessage;
}
export { $c_Lsttp_tapir_ValidationError as $c_Lsttp_tapir_ValidationError };
$c_Lsttp_tapir_ValidationError.prototype = new $h_O();
$c_Lsttp_tapir_ValidationError.prototype.constructor = $c_Lsttp_tapir_ValidationError;
/** @constructor */
function $h_Lsttp_tapir_ValidationError() {
}
export { $h_Lsttp_tapir_ValidationError as $h_Lsttp_tapir_ValidationError };
$h_Lsttp_tapir_ValidationError.prototype = $c_Lsttp_tapir_ValidationError.prototype;
$c_Lsttp_tapir_ValidationError.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_ValidationError.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1262516101), true);
});
$c_Lsttp_tapir_ValidationError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_ValidationError)) {
    var x = this.Lsttp_tapir_ValidationError__f_validator;
    var x$2 = x$0.Lsttp_tapir_ValidationError__f_validator;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$1 = this.Lsttp_tapir_ValidationError__f_invalidValue;
      var y = x$0.Lsttp_tapir_ValidationError__f_invalidValue;
      var $x_2 = $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Lsttp_tapir_ValidationError__f_path;
      var x$4 = x$0.Lsttp_tapir_ValidationError__f_path;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lsttp_tapir_ValidationError__f_customMessage;
      var x$6 = x$0.Lsttp_tapir_ValidationError__f_customMessage;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_ValidationError.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_ValidationError.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_tapir_ValidationError.prototype.productPrefix__T = (function() {
  return "ValidationError";
});
$c_Lsttp_tapir_ValidationError.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_ValidationError__f_validator;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_ValidationError__f_invalidValue;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_ValidationError__f_path;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_ValidationError__f_customMessage;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_ValidationError.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "validator";
      break;
    }
    case 1: {
      return "invalidValue";
      break;
    }
    case 2: {
      return "path";
      break;
    }
    case 3: {
      return "customMessage";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_ValidationError.prototype.prependPath__Lsttp_tapir_FieldName__Lsttp_tapir_ValidationError = (function(f) {
  var this$1 = this.Lsttp_tapir_ValidationError__f_path;
  var path$1 = new $c_sci_$colon$colon(f, this$1);
  var validator$1 = this.Lsttp_tapir_ValidationError__f_validator;
  var invalidValue$1 = this.Lsttp_tapir_ValidationError__f_invalidValue;
  var customMessage$1 = this.Lsttp_tapir_ValidationError__f_customMessage;
  return new $c_Lsttp_tapir_ValidationError(validator$1, invalidValue$1, path$1, customMessage$1);
});
function $isArrayOf_Lsttp_tapir_ValidationError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_ValidationError)));
}
export { $isArrayOf_Lsttp_tapir_ValidationError as $isArrayOf_Lsttp_tapir_ValidationError };
var $d_Lsttp_tapir_ValidationError = new $TypeData().initClass($c_Lsttp_tapir_ValidationError, "sttp.tapir.ValidationError", ({
  Lsttp_tapir_ValidationError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_ValidationError as $d_Lsttp_tapir_ValidationError };
/** @constructor */
function $c_Lsttp_tapir_generic_Configuration(toEncodedName, discriminator, toDiscriminatorValue) {
  this.Lsttp_tapir_generic_Configuration__f_toEncodedName = null;
  this.Lsttp_tapir_generic_Configuration__f_discriminator = null;
  this.Lsttp_tapir_generic_Configuration__f_toDiscriminatorValue = null;
  this.Lsttp_tapir_generic_Configuration__f_toEncodedName = toEncodedName;
  this.Lsttp_tapir_generic_Configuration__f_discriminator = discriminator;
  this.Lsttp_tapir_generic_Configuration__f_toDiscriminatorValue = toDiscriminatorValue;
}
export { $c_Lsttp_tapir_generic_Configuration as $c_Lsttp_tapir_generic_Configuration };
$c_Lsttp_tapir_generic_Configuration.prototype = new $h_O();
$c_Lsttp_tapir_generic_Configuration.prototype.constructor = $c_Lsttp_tapir_generic_Configuration;
/** @constructor */
function $h_Lsttp_tapir_generic_Configuration() {
}
export { $h_Lsttp_tapir_generic_Configuration as $h_Lsttp_tapir_generic_Configuration };
$h_Lsttp_tapir_generic_Configuration.prototype = $c_Lsttp_tapir_generic_Configuration.prototype;
$c_Lsttp_tapir_generic_Configuration.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_generic_Configuration.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 652995822, true);
});
$c_Lsttp_tapir_generic_Configuration.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_generic_Configuration)) {
    var x = this.Lsttp_tapir_generic_Configuration__f_toEncodedName;
    var x$2 = x$0.Lsttp_tapir_generic_Configuration__f_toEncodedName;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_generic_Configuration__f_discriminator;
      var x$4 = x$0.Lsttp_tapir_generic_Configuration__f_discriminator;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lsttp_tapir_generic_Configuration__f_toDiscriminatorValue;
      var x$6 = x$0.Lsttp_tapir_generic_Configuration__f_toDiscriminatorValue;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_generic_Configuration.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_generic_Configuration.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_tapir_generic_Configuration.prototype.productPrefix__T = (function() {
  return "Configuration";
});
$c_Lsttp_tapir_generic_Configuration.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_generic_Configuration__f_toEncodedName;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_generic_Configuration__f_discriminator;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_generic_Configuration__f_toDiscriminatorValue;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_generic_Configuration.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "toEncodedName";
      break;
    }
    case 1: {
      return "discriminator";
      break;
    }
    case 2: {
      return "toDiscriminatorValue";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lsttp_tapir_generic_Configuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_generic_Configuration)));
}
export { $isArrayOf_Lsttp_tapir_generic_Configuration as $isArrayOf_Lsttp_tapir_generic_Configuration };
var $d_Lsttp_tapir_generic_Configuration = new $TypeData().initClass($c_Lsttp_tapir_generic_Configuration, "sttp.tapir.generic.Configuration", ({
  Lsttp_tapir_generic_Configuration: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_generic_Configuration as $d_Lsttp_tapir_generic_Configuration };
class $c_Lsttp_ws_WebSocketException extends $c_jl_Exception {
}
export { $c_Lsttp_ws_WebSocketException as $c_Lsttp_ws_WebSocketException };
/** @constructor */
function $c_Lyantl_ValidatorRule$LargerThan(maximum, actual) {
  this.Lyantl_ValidatorRule$LargerThan__f_maximum = null;
  this.Lyantl_ValidatorRule$LargerThan__f_actual = null;
  this.Lyantl_ValidatorRule$LargerThan__f_maximum = maximum;
  this.Lyantl_ValidatorRule$LargerThan__f_actual = actual;
}
export { $c_Lyantl_ValidatorRule$LargerThan as $c_Lyantl_ValidatorRule$LargerThan };
$c_Lyantl_ValidatorRule$LargerThan.prototype = new $h_O();
$c_Lyantl_ValidatorRule$LargerThan.prototype.constructor = $c_Lyantl_ValidatorRule$LargerThan;
/** @constructor */
function $h_Lyantl_ValidatorRule$LargerThan() {
}
export { $h_Lyantl_ValidatorRule$LargerThan as $h_Lyantl_ValidatorRule$LargerThan };
$h_Lyantl_ValidatorRule$LargerThan.prototype = $c_Lyantl_ValidatorRule$LargerThan.prototype;
$c_Lyantl_ValidatorRule$LargerThan.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lyantl_ValidatorRule$LargerThan.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lyantl_ValidatorRule$LargerThan.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lyantl_ValidatorRule$LargerThan)) {
    var x = this.Lyantl_ValidatorRule$LargerThan__f_maximum;
    var y = x$0.Lyantl_ValidatorRule$LargerThan__f_maximum;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lyantl_ValidatorRule$LargerThan__f_actual;
      var y$1 = x$0.Lyantl_ValidatorRule$LargerThan__f_actual;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lyantl_ValidatorRule$LargerThan.prototype.productArity__I = (function() {
  return 2;
});
$c_Lyantl_ValidatorRule$LargerThan.prototype.productPrefix__T = (function() {
  return "LargerThan";
});
$c_Lyantl_ValidatorRule$LargerThan.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lyantl_ValidatorRule$LargerThan__f_maximum;
  }
  if ((n === 1)) {
    return this.Lyantl_ValidatorRule$LargerThan__f_actual;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lyantl_ValidatorRule$LargerThan.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "maximum";
  }
  if ((n === 1)) {
    return "actual";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lyantl_ValidatorRule$LargerThan.prototype.toString__T = (function() {
  return (((("Cannot be larger than " + this.Lyantl_ValidatorRule$LargerThan__f_maximum) + ", was ") + this.Lyantl_ValidatorRule$LargerThan__f_actual) + ".");
});
function $isArrayOf_Lyantl_ValidatorRule$LargerThan(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lyantl_ValidatorRule$LargerThan)));
}
export { $isArrayOf_Lyantl_ValidatorRule$LargerThan as $isArrayOf_Lyantl_ValidatorRule$LargerThan };
var $d_Lyantl_ValidatorRule$LargerThan = new $TypeData().initClass($c_Lyantl_ValidatorRule$LargerThan, "yantl.ValidatorRule$LargerThan", ({
  Lyantl_ValidatorRule$LargerThan: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lyantl_ValidatorRule$LargerThan as $d_Lyantl_ValidatorRule$LargerThan };
/** @constructor */
function $c_Lyantl_ValidatorRule$SmallerThan(minimum, actual) {
  this.Lyantl_ValidatorRule$SmallerThan__f_minimum = null;
  this.Lyantl_ValidatorRule$SmallerThan__f_actual = null;
  this.Lyantl_ValidatorRule$SmallerThan__f_minimum = minimum;
  this.Lyantl_ValidatorRule$SmallerThan__f_actual = actual;
}
export { $c_Lyantl_ValidatorRule$SmallerThan as $c_Lyantl_ValidatorRule$SmallerThan };
$c_Lyantl_ValidatorRule$SmallerThan.prototype = new $h_O();
$c_Lyantl_ValidatorRule$SmallerThan.prototype.constructor = $c_Lyantl_ValidatorRule$SmallerThan;
/** @constructor */
function $h_Lyantl_ValidatorRule$SmallerThan() {
}
export { $h_Lyantl_ValidatorRule$SmallerThan as $h_Lyantl_ValidatorRule$SmallerThan };
$h_Lyantl_ValidatorRule$SmallerThan.prototype = $c_Lyantl_ValidatorRule$SmallerThan.prototype;
$c_Lyantl_ValidatorRule$SmallerThan.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lyantl_ValidatorRule$SmallerThan.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lyantl_ValidatorRule$SmallerThan.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lyantl_ValidatorRule$SmallerThan)) {
    var x = this.Lyantl_ValidatorRule$SmallerThan__f_minimum;
    var y = x$0.Lyantl_ValidatorRule$SmallerThan__f_minimum;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lyantl_ValidatorRule$SmallerThan__f_actual;
      var y$1 = x$0.Lyantl_ValidatorRule$SmallerThan__f_actual;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y$1);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lyantl_ValidatorRule$SmallerThan.prototype.productArity__I = (function() {
  return 2;
});
$c_Lyantl_ValidatorRule$SmallerThan.prototype.productPrefix__T = (function() {
  return "SmallerThan";
});
$c_Lyantl_ValidatorRule$SmallerThan.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lyantl_ValidatorRule$SmallerThan__f_minimum;
  }
  if ((n === 1)) {
    return this.Lyantl_ValidatorRule$SmallerThan__f_actual;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lyantl_ValidatorRule$SmallerThan.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "minimum";
  }
  if ((n === 1)) {
    return "actual";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lyantl_ValidatorRule$SmallerThan.prototype.toString__T = (function() {
  return (((("Cannot be smaller than " + this.Lyantl_ValidatorRule$SmallerThan__f_minimum) + ", was ") + this.Lyantl_ValidatorRule$SmallerThan__f_actual) + ".");
});
function $isArrayOf_Lyantl_ValidatorRule$SmallerThan(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lyantl_ValidatorRule$SmallerThan)));
}
export { $isArrayOf_Lyantl_ValidatorRule$SmallerThan as $isArrayOf_Lyantl_ValidatorRule$SmallerThan };
var $d_Lyantl_ValidatorRule$SmallerThan = new $TypeData().initClass($c_Lyantl_ValidatorRule$SmallerThan, "yantl.ValidatorRule$SmallerThan", ({
  Lyantl_ValidatorRule$SmallerThan: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lyantl_ValidatorRule$SmallerThan as $d_Lyantl_ValidatorRule$SmallerThan };
function $f_Lcats_ComposedFunctor__map__O__F1__O($thiz, fga, f) {
  return $thiz.F__Lcats_Functor().map__O__F1__O(fga, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ga) => $thiz.G__Lcats_Applicative().map__O__F1__O(ga, f))));
}
export { $f_Lcats_ComposedFunctor__map__O__F1__O as $f_Lcats_ComposedFunctor__map__O__F1__O };
/** @constructor */
function $c_Lcats_Eval$Ident(ev) {
  this.Lcats_Eval$Ident__f_ev = null;
  this.Lcats_Eval$Ident__f_ev = ev;
}
export { $c_Lcats_Eval$Ident as $c_Lcats_Eval$Ident };
$c_Lcats_Eval$Ident.prototype = new $h_Lcats_Eval$FnStack();
$c_Lcats_Eval$Ident.prototype.constructor = $c_Lcats_Eval$Ident;
/** @constructor */
function $h_Lcats_Eval$Ident() {
}
export { $h_Lcats_Eval$Ident as $h_Lcats_Eval$Ident };
$h_Lcats_Eval$Ident.prototype = $c_Lcats_Eval$Ident.prototype;
$c_Lcats_Eval$Ident.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Eval$Ident.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_Eval$Ident.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_Eval$Ident)) {
    var x = this.Lcats_Eval$Ident__f_ev;
    var x$2 = x$0.Lcats_Eval$Ident__f_ev;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_Lcats_Eval$Ident.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_Eval$Ident.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_Eval$Ident.prototype.productPrefix__T = (function() {
  return "Ident";
});
$c_Lcats_Eval$Ident.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Ident__f_ev;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_Eval$Ident.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ev";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_Eval$Ident(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Ident)));
}
export { $isArrayOf_Lcats_Eval$Ident as $isArrayOf_Lcats_Eval$Ident };
var $d_Lcats_Eval$Ident = new $TypeData().initClass($c_Lcats_Eval$Ident, "cats.Eval$Ident", ({
  Lcats_Eval$Ident: 1,
  Lcats_Eval$FnStack: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_Eval$Ident as $d_Lcats_Eval$Ident };
/** @constructor */
function $c_Lcats_Eval$Many(first, rest) {
  this.Lcats_Eval$Many__f_first = null;
  this.Lcats_Eval$Many__f_rest = null;
  this.Lcats_Eval$Many__f_first = first;
  this.Lcats_Eval$Many__f_rest = rest;
}
export { $c_Lcats_Eval$Many as $c_Lcats_Eval$Many };
$c_Lcats_Eval$Many.prototype = new $h_Lcats_Eval$FnStack();
$c_Lcats_Eval$Many.prototype.constructor = $c_Lcats_Eval$Many;
/** @constructor */
function $h_Lcats_Eval$Many() {
}
export { $h_Lcats_Eval$Many as $h_Lcats_Eval$Many };
$h_Lcats_Eval$Many.prototype = $c_Lcats_Eval$Many.prototype;
$c_Lcats_Eval$Many.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Eval$Many.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_Eval$Many.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_Eval$Many)) {
    var x = this.Lcats_Eval$Many__f_first;
    var x$2 = x$0.Lcats_Eval$Many__f_first;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_Eval$Many__f_rest;
      var x$4 = x$0.Lcats_Eval$Many__f_rest;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_Eval$Many.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_Eval$Many.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_Eval$Many.prototype.productPrefix__T = (function() {
  return "Many";
});
$c_Lcats_Eval$Many.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Eval$Many__f_first;
  }
  if ((n === 1)) {
    return this.Lcats_Eval$Many__f_rest;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_Eval$Many.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "first";
  }
  if ((n === 1)) {
    return "rest";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_Eval$Many(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Many)));
}
export { $isArrayOf_Lcats_Eval$Many as $isArrayOf_Lcats_Eval$Many };
var $d_Lcats_Eval$Many = new $TypeData().initClass($c_Lcats_Eval$Many, "cats.Eval$Many", ({
  Lcats_Eval$Many: 1,
  Lcats_Eval$FnStack: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_Eval$Many as $d_Lcats_Eval$Many };
function $isArrayOf_Lcats_Eval$Memoize(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Eval$Memoize)));
}
export { $isArrayOf_Lcats_Eval$Memoize as $isArrayOf_Lcats_Eval$Memoize };
/** @constructor */
function $c_Lcats_data_NonEmptyList(head, tail) {
  this.Lcats_data_NonEmptyList__f_head = null;
  this.Lcats_data_NonEmptyList__f_tail = null;
  this.Lcats_data_NonEmptyList__f_head = head;
  this.Lcats_data_NonEmptyList__f_tail = tail;
}
export { $c_Lcats_data_NonEmptyList as $c_Lcats_data_NonEmptyList };
$c_Lcats_data_NonEmptyList.prototype = new $h_O();
$c_Lcats_data_NonEmptyList.prototype.constructor = $c_Lcats_data_NonEmptyList;
/** @constructor */
function $h_Lcats_data_NonEmptyList() {
}
export { $h_Lcats_data_NonEmptyList as $h_Lcats_data_NonEmptyList };
$h_Lcats_data_NonEmptyList.prototype = $c_Lcats_data_NonEmptyList.prototype;
$c_Lcats_data_NonEmptyList.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_NonEmptyList.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_NonEmptyList.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_NonEmptyList)) {
    var x = this.Lcats_data_NonEmptyList__f_head;
    var y = x$0.Lcats_data_NonEmptyList__f_head;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lcats_data_NonEmptyList__f_tail;
      var x$2 = x$0.Lcats_data_NonEmptyList__f_tail;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_data_NonEmptyList.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_NonEmptyList.prototype.productPrefix__T = (function() {
  return "NonEmptyList";
});
$c_Lcats_data_NonEmptyList.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_NonEmptyList__f_head;
  }
  if ((n === 1)) {
    return this.Lcats_data_NonEmptyList__f_tail;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_NonEmptyList.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "head";
  }
  if ((n === 1)) {
    return "tail";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_NonEmptyList.prototype.size__I = (function() {
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  return ((1 + this$1.length__I()) | 0);
});
$c_Lcats_data_NonEmptyList.prototype.map__F1__Lcats_data_NonEmptyList = (function(f) {
  $m_Lcats_data_NonEmptyList$();
  var head = f.apply__O__O(this.Lcats_data_NonEmptyList__f_head);
  var tail = this.Lcats_data_NonEmptyList__f_tail.map__F1__sci_List(f);
  return new $c_Lcats_data_NonEmptyList(head, tail);
});
$c_Lcats_data_NonEmptyList.prototype.concat__sci_List__Lcats_data_NonEmptyList = (function(other) {
  $m_Lcats_data_NonEmptyList$();
  var head = this.Lcats_data_NonEmptyList__f_head;
  var tail = other.$colon$colon$colon__sci_List__sci_List(this.Lcats_data_NonEmptyList__f_tail);
  return new $c_Lcats_data_NonEmptyList(head, tail);
});
$c_Lcats_data_NonEmptyList.prototype.concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList = (function(other) {
  $m_Lcats_data_NonEmptyList$();
  var head = this.Lcats_data_NonEmptyList__f_head;
  var this$1 = other.Lcats_data_NonEmptyList__f_tail;
  var elem = other.Lcats_data_NonEmptyList__f_head;
  var tail = new $c_sci_$colon$colon(elem, this$1).$colon$colon$colon__sci_List__sci_List(this.Lcats_data_NonEmptyList__f_tail);
  return new $c_Lcats_data_NonEmptyList(head, tail);
});
$c_Lcats_data_NonEmptyList.prototype.flatMap__F1__Lcats_data_NonEmptyList = (function(f) {
  var this$5 = f.apply__O__O(this.Lcats_data_NonEmptyList__f_head);
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  var rest = this$1;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.head__O();
    var this$2 = f.apply__O__O(x0);
    var this$3 = this$2.Lcats_data_NonEmptyList__f_tail;
    var elem = this$2.Lcats_data_NonEmptyList__f_head;
    var this$4 = new $c_sci_$colon$colon(elem, this$3);
    var it = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$4);
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  var l = ((h === null) ? $m_sci_Nil$() : h);
  return this$5.concat__sci_List__Lcats_data_NonEmptyList(l);
});
$c_Lcats_data_NonEmptyList.prototype.prepend__O__Lcats_data_NonEmptyList = (function(a) {
  $m_Lcats_data_NonEmptyList$();
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  var elem = this.Lcats_data_NonEmptyList__f_head;
  var tail = new $c_sci_$colon$colon(elem, this$1);
  return new $c_Lcats_data_NonEmptyList(a, tail);
});
$c_Lcats_data_NonEmptyList.prototype.exists__F1__Z = (function(p) {
  return ((!(!p.apply__O__O(this.Lcats_data_NonEmptyList__f_head))) || this.Lcats_data_NonEmptyList__f_tail.exists__F1__Z(p));
});
$c_Lcats_data_NonEmptyList.prototype.foldLeft__O__F2__O = (function(b, f) {
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  var z = f.apply__O__O__O(b, this.Lcats_data_NonEmptyList__f_head);
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this$1, z, f);
});
$c_Lcats_data_NonEmptyList.prototype.foldRight__Lcats_Eval__F2__Lcats_Eval = (function(lb, f) {
  $m_Lcats_UnorderedFoldable$();
  var instance = $m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList;
  var this$3 = this.Lcats_data_NonEmptyList__f_tail;
  var elem = this.Lcats_data_NonEmptyList__f_head;
  return instance.foldRight__O__Lcats_Eval__F2__Lcats_Eval(new $c_sci_$colon$colon(elem, this$3), lb, f);
});
$c_Lcats_data_NonEmptyList.prototype.traverse__F1__Lcats_Applicative__O = (function(f, G) {
  var $x_1 = f.apply__O__O(this.Lcats_data_NonEmptyList__f_head);
  var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    $m_Lcats_UnorderedFoldable$();
    var instance = $m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList;
    return instance.traverse__O__F1__Lcats_Applicative__O(this.Lcats_data_NonEmptyList__f_tail, f, G);
  }));
  return G.map2Eval__O__Lcats_Eval__F2__Lcats_Eval($x_1, new $c_Lcats_Always(a), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$2, _$3) => {
    $m_Lcats_data_NonEmptyList$();
    return new $c_Lcats_data_NonEmptyList(_$2, _$3);
  }))).value__O();
});
$c_Lcats_data_NonEmptyList.prototype.toString__T = (function() {
  var this$1 = this.Lcats_data_NonEmptyList__f_tail;
  var elem = this.Lcats_data_NonEmptyList__f_head;
  return ("NonEmpty" + new $c_sci_$colon$colon(elem, this$1));
});
function $isArrayOf_Lcats_data_NonEmptyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_NonEmptyList)));
}
export { $isArrayOf_Lcats_data_NonEmptyList as $isArrayOf_Lcats_data_NonEmptyList };
var $d_Lcats_data_NonEmptyList = new $TypeData().initClass($c_Lcats_data_NonEmptyList, "cats.data.NonEmptyList", ({
  Lcats_data_NonEmptyList: 1,
  Lcats_data_NonEmptyCollection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_NonEmptyList as $d_Lcats_data_NonEmptyList };
/** @constructor */
function $c_Lcats_data_Validated$Invalid(e) {
  this.Lcats_data_Validated$Invalid__f_e = null;
  this.Lcats_data_Validated$Invalid__f_e = e;
}
export { $c_Lcats_data_Validated$Invalid as $c_Lcats_data_Validated$Invalid };
$c_Lcats_data_Validated$Invalid.prototype = new $h_Lcats_data_Validated();
$c_Lcats_data_Validated$Invalid.prototype.constructor = $c_Lcats_data_Validated$Invalid;
/** @constructor */
function $h_Lcats_data_Validated$Invalid() {
}
export { $h_Lcats_data_Validated$Invalid as $h_Lcats_data_Validated$Invalid };
$h_Lcats_data_Validated$Invalid.prototype = $c_Lcats_data_Validated$Invalid.prototype;
$c_Lcats_data_Validated$Invalid.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_Validated$Invalid.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_Validated$Invalid)) {
    var x = this.Lcats_data_Validated$Invalid__f_e;
    var y = x$0.Lcats_data_Validated$Invalid__f_e;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_data_Validated$Invalid.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_Validated$Invalid.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Validated$Invalid.prototype.productPrefix__T = (function() {
  return "Invalid";
});
$c_Lcats_data_Validated$Invalid.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Validated$Invalid__f_e;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_Validated$Invalid.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "e";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_data_Validated$Invalid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated$Invalid)));
}
export { $isArrayOf_Lcats_data_Validated$Invalid as $isArrayOf_Lcats_data_Validated$Invalid };
var $d_Lcats_data_Validated$Invalid = new $TypeData().initClass($c_Lcats_data_Validated$Invalid, "cats.data.Validated$Invalid", ({
  Lcats_data_Validated$Invalid: 1,
  Lcats_data_Validated: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_Validated$Invalid as $d_Lcats_data_Validated$Invalid };
/** @constructor */
function $c_Lcats_data_Validated$Valid(a) {
  this.Lcats_data_Validated$Valid__f_a = null;
  this.Lcats_data_Validated$Valid__f_a = a;
}
export { $c_Lcats_data_Validated$Valid as $c_Lcats_data_Validated$Valid };
$c_Lcats_data_Validated$Valid.prototype = new $h_Lcats_data_Validated();
$c_Lcats_data_Validated$Valid.prototype.constructor = $c_Lcats_data_Validated$Valid;
/** @constructor */
function $h_Lcats_data_Validated$Valid() {
}
export { $h_Lcats_data_Validated$Valid as $h_Lcats_data_Validated$Valid };
$h_Lcats_data_Validated$Valid.prototype = $c_Lcats_data_Validated$Valid.prototype;
$c_Lcats_data_Validated$Valid.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_data_Validated$Valid.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_data_Validated$Valid)) {
    var x = this.Lcats_data_Validated$Valid__f_a;
    var y = x$0.Lcats_data_Validated$Valid__f_a;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_data_Validated$Valid.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_data_Validated$Valid.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Validated$Valid.prototype.productPrefix__T = (function() {
  return "Valid";
});
$c_Lcats_data_Validated$Valid.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Validated$Valid__f_a;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_Validated$Valid.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "a";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_data_Validated$Valid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Validated$Valid)));
}
export { $isArrayOf_Lcats_data_Validated$Valid as $isArrayOf_Lcats_data_Validated$Valid };
var $d_Lcats_data_Validated$Valid = new $TypeData().initClass($c_Lcats_data_Validated$Valid, "cats.data.Validated$Valid", ({
  Lcats_data_Validated$Valid: 1,
  Lcats_data_Validated: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_Validated$Valid as $d_Lcats_data_Validated$Valid };
/** @constructor */
function $c_Lcats_effect_SyncIO$() {
  this.Lcats_effect_SyncIO$__f_Delay = null;
  this.Lcats_effect_SyncIO$__f__syncForSyncIO = null;
  this.Lcats_effect_SyncIO$__f_monotonic = null;
  this.Lcats_effect_SyncIO$__f_realTime = null;
  this.Lcats_effect_SyncIO$__f__unit = null;
  $n_Lcats_effect_SyncIO$ = this;
  this.Lcats_effect_SyncIO$__f_Delay = $m_Lcats_effect_kernel_Sync$Type$Delay$();
  this.Lcats_effect_SyncIO$__f__syncForSyncIO = new $c_Lcats_effect_SyncIO$SyncIOSync();
  this.Lcats_effect_SyncIO$__f_monotonic = $m_Lcats_effect_SyncIO$Monotonic$();
  this.Lcats_effect_SyncIO$__f_realTime = $m_Lcats_effect_SyncIO$RealTime$();
  this.Lcats_effect_SyncIO$__f__unit = new $c_Lcats_effect_SyncIO$Pure((void 0));
}
export { $c_Lcats_effect_SyncIO$ as $c_Lcats_effect_SyncIO$ };
$c_Lcats_effect_SyncIO$.prototype = new $h_O();
$c_Lcats_effect_SyncIO$.prototype.constructor = $c_Lcats_effect_SyncIO$;
/** @constructor */
function $h_Lcats_effect_SyncIO$() {
}
export { $h_Lcats_effect_SyncIO$ as $h_Lcats_effect_SyncIO$ };
$h_Lcats_effect_SyncIO$.prototype = $c_Lcats_effect_SyncIO$.prototype;
$c_Lcats_effect_SyncIO$.prototype.apply__F0__Lcats_effect_SyncIO = (function(thunk) {
  var hint = this.Lcats_effect_SyncIO$__f_Delay;
  return new $c_Lcats_effect_SyncIO$Suspend(hint, thunk);
});
$c_Lcats_effect_SyncIO$.prototype.ordinal__Lcats_effect_SyncIO__I = (function(x$0) {
  if ((x$0 instanceof $c_Lcats_effect_SyncIO$Pure)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lcats_effect_SyncIO$Suspend)) {
    return 1;
  }
  if ((x$0 instanceof $c_Lcats_effect_SyncIO$Error)) {
    return 2;
  }
  if ((x$0 instanceof $c_Lcats_effect_SyncIO$Map)) {
    return 3;
  }
  if ((x$0 instanceof $c_Lcats_effect_SyncIO$FlatMap)) {
    return 4;
  }
  if ((x$0 instanceof $c_Lcats_effect_SyncIO$HandleErrorWith)) {
    return 5;
  }
  if ((x$0 instanceof $c_Lcats_effect_SyncIO$Success)) {
    return 6;
  }
  if ((x$0 instanceof $c_Lcats_effect_SyncIO$Failure)) {
    return 7;
  }
  if ((x$0 instanceof $c_Lcats_effect_SyncIO$Attempt)) {
    return 8;
  }
  if ((x$0 === $m_Lcats_effect_SyncIO$RealTime$())) {
    return 9;
  }
  if ((x$0 === $m_Lcats_effect_SyncIO$Monotonic$())) {
    return 10;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lcats_effect_SyncIO$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcats_effect_SyncIO__I(x);
});
var $d_Lcats_effect_SyncIO$ = new $TypeData().initClass($c_Lcats_effect_SyncIO$, "cats.effect.SyncIO$", ({
  Lcats_effect_SyncIO$: 1,
  Lcats_effect_SyncIOCompanionPlatform: 1,
  Lcats_effect_SyncIOLowPriorityImplicits: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lcats_effect_SyncIO$ as $d_Lcats_effect_SyncIO$ };
var $n_Lcats_effect_SyncIO$;
function $m_Lcats_effect_SyncIO$() {
  if ((!$n_Lcats_effect_SyncIO$)) {
    $n_Lcats_effect_SyncIO$ = new $c_Lcats_effect_SyncIO$();
  }
  return $n_Lcats_effect_SyncIO$;
}
export { $m_Lcats_effect_SyncIO$ as $m_Lcats_effect_SyncIO$ };
/** @constructor */
function $c_Lcats_effect_SyncIO$Attempt(ioa) {
  this.Lcats_effect_SyncIO$Attempt__f_ioa = null;
  this.Lcats_effect_SyncIO$Attempt__f_ioa = ioa;
}
export { $c_Lcats_effect_SyncIO$Attempt as $c_Lcats_effect_SyncIO$Attempt };
$c_Lcats_effect_SyncIO$Attempt.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Attempt.prototype.constructor = $c_Lcats_effect_SyncIO$Attempt;
/** @constructor */
function $h_Lcats_effect_SyncIO$Attempt() {
}
export { $h_Lcats_effect_SyncIO$Attempt as $h_Lcats_effect_SyncIO$Attempt };
$h_Lcats_effect_SyncIO$Attempt.prototype = $c_Lcats_effect_SyncIO$Attempt.prototype;
$c_Lcats_effect_SyncIO$Attempt.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Attempt.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Attempt.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Attempt)) {
    var x = this.Lcats_effect_SyncIO$Attempt__f_ioa;
    var x$2 = x$0.Lcats_effect_SyncIO$Attempt__f_ioa;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productPrefix__T = (function() {
  return "Attempt";
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Attempt__f_ioa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Attempt.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ioa";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Attempt.prototype.tag__B = (function() {
  return 8;
});
function $isArrayOf_Lcats_effect_SyncIO$Attempt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Attempt)));
}
export { $isArrayOf_Lcats_effect_SyncIO$Attempt as $isArrayOf_Lcats_effect_SyncIO$Attempt };
var $d_Lcats_effect_SyncIO$Attempt = new $TypeData().initClass($c_Lcats_effect_SyncIO$Attempt, "cats.effect.SyncIO$Attempt", ({
  Lcats_effect_SyncIO$Attempt: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_SyncIO$Attempt as $d_Lcats_effect_SyncIO$Attempt };
/** @constructor */
function $c_Lcats_effect_SyncIO$Error(t) {
  this.Lcats_effect_SyncIO$Error__f_t = null;
  this.Lcats_effect_SyncIO$Error__f_t = t;
}
export { $c_Lcats_effect_SyncIO$Error as $c_Lcats_effect_SyncIO$Error };
$c_Lcats_effect_SyncIO$Error.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Error.prototype.constructor = $c_Lcats_effect_SyncIO$Error;
/** @constructor */
function $h_Lcats_effect_SyncIO$Error() {
}
export { $h_Lcats_effect_SyncIO$Error as $h_Lcats_effect_SyncIO$Error };
$h_Lcats_effect_SyncIO$Error.prototype = $c_Lcats_effect_SyncIO$Error.prototype;
$c_Lcats_effect_SyncIO$Error.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Error.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Error)) {
    var x = this.Lcats_effect_SyncIO$Error__f_t;
    var x$2 = x$0.Lcats_effect_SyncIO$Error__f_t;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Error.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Error.prototype.productPrefix__T = (function() {
  return "Error";
});
$c_Lcats_effect_SyncIO$Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Error__f_t;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Error.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "t";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Error.prototype.tag__B = (function() {
  return 2;
});
function $isArrayOf_Lcats_effect_SyncIO$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Error)));
}
export { $isArrayOf_Lcats_effect_SyncIO$Error as $isArrayOf_Lcats_effect_SyncIO$Error };
var $d_Lcats_effect_SyncIO$Error = new $TypeData().initClass($c_Lcats_effect_SyncIO$Error, "cats.effect.SyncIO$Error", ({
  Lcats_effect_SyncIO$Error: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_SyncIO$Error as $d_Lcats_effect_SyncIO$Error };
/** @constructor */
function $c_Lcats_effect_SyncIO$Failure(t) {
  this.Lcats_effect_SyncIO$Failure__f_t = null;
  this.Lcats_effect_SyncIO$Failure__f_t = t;
}
export { $c_Lcats_effect_SyncIO$Failure as $c_Lcats_effect_SyncIO$Failure };
$c_Lcats_effect_SyncIO$Failure.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Failure.prototype.constructor = $c_Lcats_effect_SyncIO$Failure;
/** @constructor */
function $h_Lcats_effect_SyncIO$Failure() {
}
export { $h_Lcats_effect_SyncIO$Failure as $h_Lcats_effect_SyncIO$Failure };
$h_Lcats_effect_SyncIO$Failure.prototype = $c_Lcats_effect_SyncIO$Failure.prototype;
$c_Lcats_effect_SyncIO$Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Failure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Failure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Failure)) {
    var x = this.Lcats_effect_SyncIO$Failure__f_t;
    var x$2 = x$0.Lcats_effect_SyncIO$Failure__f_t;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Failure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Failure.prototype.productPrefix__T = (function() {
  return "Failure";
});
$c_Lcats_effect_SyncIO$Failure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Failure__f_t;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Failure.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "t";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Failure.prototype.tag__B = (function() {
  return 7;
});
function $isArrayOf_Lcats_effect_SyncIO$Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Failure)));
}
export { $isArrayOf_Lcats_effect_SyncIO$Failure as $isArrayOf_Lcats_effect_SyncIO$Failure };
var $d_Lcats_effect_SyncIO$Failure = new $TypeData().initClass($c_Lcats_effect_SyncIO$Failure, "cats.effect.SyncIO$Failure", ({
  Lcats_effect_SyncIO$Failure: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_SyncIO$Failure as $d_Lcats_effect_SyncIO$Failure };
/** @constructor */
function $c_Lcats_effect_SyncIO$FlatMap(ioe, f) {
  this.Lcats_effect_SyncIO$FlatMap__f_ioe = null;
  this.Lcats_effect_SyncIO$FlatMap__f_f = null;
  this.Lcats_effect_SyncIO$FlatMap__f_ioe = ioe;
  this.Lcats_effect_SyncIO$FlatMap__f_f = f;
}
export { $c_Lcats_effect_SyncIO$FlatMap as $c_Lcats_effect_SyncIO$FlatMap };
$c_Lcats_effect_SyncIO$FlatMap.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$FlatMap.prototype.constructor = $c_Lcats_effect_SyncIO$FlatMap;
/** @constructor */
function $h_Lcats_effect_SyncIO$FlatMap() {
}
export { $h_Lcats_effect_SyncIO$FlatMap as $h_Lcats_effect_SyncIO$FlatMap };
$h_Lcats_effect_SyncIO$FlatMap.prototype = $c_Lcats_effect_SyncIO$FlatMap.prototype;
$c_Lcats_effect_SyncIO$FlatMap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$FlatMap)) {
    var x = this.Lcats_effect_SyncIO$FlatMap__f_ioe;
    var x$2 = x$0.Lcats_effect_SyncIO$FlatMap__f_ioe;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_SyncIO$FlatMap__f_f;
      var x$4 = x$0.Lcats_effect_SyncIO$FlatMap__f_f;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productPrefix__T = (function() {
  return "FlatMap";
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$FlatMap__f_ioe;
  }
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$FlatMap__f_f;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ioe";
  }
  if ((n === 1)) {
    return "f";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$FlatMap.prototype.tag__B = (function() {
  return 4;
});
function $isArrayOf_Lcats_effect_SyncIO$FlatMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$FlatMap)));
}
export { $isArrayOf_Lcats_effect_SyncIO$FlatMap as $isArrayOf_Lcats_effect_SyncIO$FlatMap };
var $d_Lcats_effect_SyncIO$FlatMap = new $TypeData().initClass($c_Lcats_effect_SyncIO$FlatMap, "cats.effect.SyncIO$FlatMap", ({
  Lcats_effect_SyncIO$FlatMap: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_SyncIO$FlatMap as $d_Lcats_effect_SyncIO$FlatMap };
/** @constructor */
function $c_Lcats_effect_SyncIO$HandleErrorWith(ioa, f) {
  this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa = null;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_f = null;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa = ioa;
  this.Lcats_effect_SyncIO$HandleErrorWith__f_f = f;
}
export { $c_Lcats_effect_SyncIO$HandleErrorWith as $c_Lcats_effect_SyncIO$HandleErrorWith };
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.constructor = $c_Lcats_effect_SyncIO$HandleErrorWith;
/** @constructor */
function $h_Lcats_effect_SyncIO$HandleErrorWith() {
}
export { $h_Lcats_effect_SyncIO$HandleErrorWith as $h_Lcats_effect_SyncIO$HandleErrorWith };
$h_Lcats_effect_SyncIO$HandleErrorWith.prototype = $c_Lcats_effect_SyncIO$HandleErrorWith.prototype;
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$HandleErrorWith)) {
    var x = this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
    var x$2 = x$0.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_SyncIO$HandleErrorWith__f_f;
      var x$4 = x$0.Lcats_effect_SyncIO$HandleErrorWith__f_f;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productPrefix__T = (function() {
  return "HandleErrorWith";
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$HandleErrorWith__f_ioa;
  }
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$HandleErrorWith__f_f;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ioa";
  }
  if ((n === 1)) {
    return "f";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$HandleErrorWith.prototype.tag__B = (function() {
  return 5;
});
function $isArrayOf_Lcats_effect_SyncIO$HandleErrorWith(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$HandleErrorWith)));
}
export { $isArrayOf_Lcats_effect_SyncIO$HandleErrorWith as $isArrayOf_Lcats_effect_SyncIO$HandleErrorWith };
var $d_Lcats_effect_SyncIO$HandleErrorWith = new $TypeData().initClass($c_Lcats_effect_SyncIO$HandleErrorWith, "cats.effect.SyncIO$HandleErrorWith", ({
  Lcats_effect_SyncIO$HandleErrorWith: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_SyncIO$HandleErrorWith as $d_Lcats_effect_SyncIO$HandleErrorWith };
/** @constructor */
function $c_Lcats_effect_SyncIO$Map(ioe, f) {
  this.Lcats_effect_SyncIO$Map__f_ioe = null;
  this.Lcats_effect_SyncIO$Map__f_f = null;
  this.Lcats_effect_SyncIO$Map__f_ioe = ioe;
  this.Lcats_effect_SyncIO$Map__f_f = f;
}
export { $c_Lcats_effect_SyncIO$Map as $c_Lcats_effect_SyncIO$Map };
$c_Lcats_effect_SyncIO$Map.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Map.prototype.constructor = $c_Lcats_effect_SyncIO$Map;
/** @constructor */
function $h_Lcats_effect_SyncIO$Map() {
}
export { $h_Lcats_effect_SyncIO$Map as $h_Lcats_effect_SyncIO$Map };
$h_Lcats_effect_SyncIO$Map.prototype = $c_Lcats_effect_SyncIO$Map.prototype;
$c_Lcats_effect_SyncIO$Map.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Map.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Map.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Map)) {
    var x = this.Lcats_effect_SyncIO$Map__f_ioe;
    var x$2 = x$0.Lcats_effect_SyncIO$Map__f_ioe;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lcats_effect_SyncIO$Map__f_f;
      var x$4 = x$0.Lcats_effect_SyncIO$Map__f_f;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Map.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_SyncIO$Map.prototype.productPrefix__T = (function() {
  return "Map";
});
$c_Lcats_effect_SyncIO$Map.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Map__f_ioe;
  }
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$Map__f_f;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Map.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ioe";
  }
  if ((n === 1)) {
    return "f";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Map.prototype.tag__B = (function() {
  return 3;
});
function $isArrayOf_Lcats_effect_SyncIO$Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Map)));
}
export { $isArrayOf_Lcats_effect_SyncIO$Map as $isArrayOf_Lcats_effect_SyncIO$Map };
var $d_Lcats_effect_SyncIO$Map = new $TypeData().initClass($c_Lcats_effect_SyncIO$Map, "cats.effect.SyncIO$Map", ({
  Lcats_effect_SyncIO$Map: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_SyncIO$Map as $d_Lcats_effect_SyncIO$Map };
/** @constructor */
function $c_Lcats_effect_SyncIO$Pure(value) {
  this.Lcats_effect_SyncIO$Pure__f_value = null;
  this.Lcats_effect_SyncIO$Pure__f_value = value;
}
export { $c_Lcats_effect_SyncIO$Pure as $c_Lcats_effect_SyncIO$Pure };
$c_Lcats_effect_SyncIO$Pure.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Pure.prototype.constructor = $c_Lcats_effect_SyncIO$Pure;
/** @constructor */
function $h_Lcats_effect_SyncIO$Pure() {
}
export { $h_Lcats_effect_SyncIO$Pure as $h_Lcats_effect_SyncIO$Pure };
$h_Lcats_effect_SyncIO$Pure.prototype = $c_Lcats_effect_SyncIO$Pure.prototype;
$c_Lcats_effect_SyncIO$Pure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Pure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Pure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Pure)) {
    var x = this.Lcats_effect_SyncIO$Pure__f_value;
    var y = x$0.Lcats_effect_SyncIO$Pure__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Pure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Pure.prototype.productPrefix__T = (function() {
  return "Pure";
});
$c_Lcats_effect_SyncIO$Pure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Pure__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Pure.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Pure.prototype.tag__B = (function() {
  return 0;
});
$c_Lcats_effect_SyncIO$Pure.prototype.toString__T = (function() {
  return (("SyncIO(" + this.Lcats_effect_SyncIO$Pure__f_value) + ")");
});
function $isArrayOf_Lcats_effect_SyncIO$Pure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Pure)));
}
export { $isArrayOf_Lcats_effect_SyncIO$Pure as $isArrayOf_Lcats_effect_SyncIO$Pure };
var $d_Lcats_effect_SyncIO$Pure = new $TypeData().initClass($c_Lcats_effect_SyncIO$Pure, "cats.effect.SyncIO$Pure", ({
  Lcats_effect_SyncIO$Pure: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_SyncIO$Pure as $d_Lcats_effect_SyncIO$Pure };
/** @constructor */
function $c_Lcats_effect_SyncIO$Success(value) {
  this.Lcats_effect_SyncIO$Success__f_value = null;
  this.Lcats_effect_SyncIO$Success__f_value = value;
}
export { $c_Lcats_effect_SyncIO$Success as $c_Lcats_effect_SyncIO$Success };
$c_Lcats_effect_SyncIO$Success.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Success.prototype.constructor = $c_Lcats_effect_SyncIO$Success;
/** @constructor */
function $h_Lcats_effect_SyncIO$Success() {
}
export { $h_Lcats_effect_SyncIO$Success as $h_Lcats_effect_SyncIO$Success };
$h_Lcats_effect_SyncIO$Success.prototype = $c_Lcats_effect_SyncIO$Success.prototype;
$c_Lcats_effect_SyncIO$Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Success.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Success.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Success)) {
    var x = this.Lcats_effect_SyncIO$Success__f_value;
    var y = x$0.Lcats_effect_SyncIO$Success__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Success.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_SyncIO$Success.prototype.productPrefix__T = (function() {
  return "Success";
});
$c_Lcats_effect_SyncIO$Success.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Success__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Success.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Success.prototype.tag__B = (function() {
  return 6;
});
function $isArrayOf_Lcats_effect_SyncIO$Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Success)));
}
export { $isArrayOf_Lcats_effect_SyncIO$Success as $isArrayOf_Lcats_effect_SyncIO$Success };
var $d_Lcats_effect_SyncIO$Success = new $TypeData().initClass($c_Lcats_effect_SyncIO$Success, "cats.effect.SyncIO$Success", ({
  Lcats_effect_SyncIO$Success: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_SyncIO$Success as $d_Lcats_effect_SyncIO$Success };
/** @constructor */
function $c_Lcats_effect_SyncIO$Suspend(hint, thunk) {
  this.Lcats_effect_SyncIO$Suspend__f_hint = null;
  this.Lcats_effect_SyncIO$Suspend__f_thunk = null;
  this.Lcats_effect_SyncIO$Suspend__f_hint = hint;
  this.Lcats_effect_SyncIO$Suspend__f_thunk = thunk;
}
export { $c_Lcats_effect_SyncIO$Suspend as $c_Lcats_effect_SyncIO$Suspend };
$c_Lcats_effect_SyncIO$Suspend.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Suspend.prototype.constructor = $c_Lcats_effect_SyncIO$Suspend;
/** @constructor */
function $h_Lcats_effect_SyncIO$Suspend() {
}
export { $h_Lcats_effect_SyncIO$Suspend as $h_Lcats_effect_SyncIO$Suspend };
$h_Lcats_effect_SyncIO$Suspend.prototype = $c_Lcats_effect_SyncIO$Suspend.prototype;
$c_Lcats_effect_SyncIO$Suspend.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Suspend.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_SyncIO$Suspend.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_SyncIO$Suspend)) {
    var x = this.Lcats_effect_SyncIO$Suspend__f_hint;
    var x$2 = x$0.Lcats_effect_SyncIO$Suspend__f_hint;
    if ((x === x$2)) {
      var x$3 = this.Lcats_effect_SyncIO$Suspend__f_thunk;
      var x$4 = x$0.Lcats_effect_SyncIO$Suspend__f_thunk;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productPrefix__T = (function() {
  return "Suspend";
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_SyncIO$Suspend__f_hint;
  }
  if ((n === 1)) {
    return this.Lcats_effect_SyncIO$Suspend__f_thunk;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Suspend.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "hint";
  }
  if ((n === 1)) {
    return "thunk";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Suspend.prototype.tag__B = (function() {
  return 1;
});
function $isArrayOf_Lcats_effect_SyncIO$Suspend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_SyncIO$Suspend)));
}
export { $isArrayOf_Lcats_effect_SyncIO$Suspend as $isArrayOf_Lcats_effect_SyncIO$Suspend };
var $d_Lcats_effect_SyncIO$Suspend = new $TypeData().initClass($c_Lcats_effect_SyncIO$Suspend, "cats.effect.SyncIO$Suspend", ({
  Lcats_effect_SyncIO$Suspend: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_effect_SyncIO$Suspend as $d_Lcats_effect_SyncIO$Suspend };
/** @constructor */
function $c_Lcats_effect_kernel_MonadCancel$$anon$1(fin$18, outer) {
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$3 = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer = null;
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$3 = fin$18;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer = outer;
}
export { $c_Lcats_effect_kernel_MonadCancel$$anon$1 as $c_Lcats_effect_kernel_MonadCancel$$anon$1 };
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.constructor = $c_Lcats_effect_kernel_MonadCancel$$anon$1;
/** @constructor */
function $h_Lcats_effect_kernel_MonadCancel$$anon$1() {
}
export { $h_Lcats_effect_kernel_MonadCancel$$anon$1 as $h_Lcats_effect_kernel_MonadCancel$$anon$1 };
$h_Lcats_effect_kernel_MonadCancel$$anon$1.prototype = $c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype;
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return true;
});
$c_Lcats_effect_kernel_MonadCancel$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.Lcats_effect_kernel_MonadCancel$$anon$1__f_$outer.handleError__O__F1__O(this.Lcats_effect_kernel_MonadCancel$$anon$1__f_fin$3.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Errored(x)), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => (void 0))));
});
var $d_Lcats_effect_kernel_MonadCancel$$anon$1 = new $TypeData().initClass($c_Lcats_effect_kernel_MonadCancel$$anon$1, "cats.effect.kernel.MonadCancel$$anon$1", ({
  Lcats_effect_kernel_MonadCancel$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_effect_kernel_MonadCancel$$anon$1 as $d_Lcats_effect_kernel_MonadCancel$$anon$1 };
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Canceled() {
}
export { $c_Lcats_effect_kernel_Outcome$Canceled as $c_Lcats_effect_kernel_Outcome$Canceled };
$c_Lcats_effect_kernel_Outcome$Canceled.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Canceled;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Canceled() {
}
export { $h_Lcats_effect_kernel_Outcome$Canceled as $h_Lcats_effect_kernel_Outcome$Canceled };
$h_Lcats_effect_kernel_Outcome$Canceled.prototype = $c_Lcats_effect_kernel_Outcome$Canceled.prototype;
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lcats_effect_kernel_Outcome$Canceled));
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productPrefix__T = (function() {
  return "Canceled";
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Outcome$Canceled.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_effect_kernel_Outcome$Canceled(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Canceled)));
}
export { $isArrayOf_Lcats_effect_kernel_Outcome$Canceled as $isArrayOf_Lcats_effect_kernel_Outcome$Canceled };
var $d_Lcats_effect_kernel_Outcome$Canceled = new $TypeData().initClass($c_Lcats_effect_kernel_Outcome$Canceled, "cats.effect.kernel.Outcome$Canceled", ({
  Lcats_effect_kernel_Outcome$Canceled: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
}));
export { $d_Lcats_effect_kernel_Outcome$Canceled as $d_Lcats_effect_kernel_Outcome$Canceled };
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Errored(e) {
  this.Lcats_effect_kernel_Outcome$Errored__f_e = null;
  this.Lcats_effect_kernel_Outcome$Errored__f_e = e;
}
export { $c_Lcats_effect_kernel_Outcome$Errored as $c_Lcats_effect_kernel_Outcome$Errored };
$c_Lcats_effect_kernel_Outcome$Errored.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Errored.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Errored;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Errored() {
}
export { $h_Lcats_effect_kernel_Outcome$Errored as $h_Lcats_effect_kernel_Outcome$Errored };
$h_Lcats_effect_kernel_Outcome$Errored.prototype = $c_Lcats_effect_kernel_Outcome$Errored.prototype;
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Outcome$Errored)) {
    var x = this.Lcats_effect_kernel_Outcome$Errored__f_e;
    var y = x$0.Lcats_effect_kernel_Outcome$Errored__f_e;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productPrefix__T = (function() {
  return "Errored";
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Outcome$Errored__f_e;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Outcome$Errored.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "e";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_effect_kernel_Outcome$Errored(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Errored)));
}
export { $isArrayOf_Lcats_effect_kernel_Outcome$Errored as $isArrayOf_Lcats_effect_kernel_Outcome$Errored };
var $d_Lcats_effect_kernel_Outcome$Errored = new $TypeData().initClass($c_Lcats_effect_kernel_Outcome$Errored, "cats.effect.kernel.Outcome$Errored", ({
  Lcats_effect_kernel_Outcome$Errored: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
}));
export { $d_Lcats_effect_kernel_Outcome$Errored as $d_Lcats_effect_kernel_Outcome$Errored };
/** @constructor */
function $c_Lcats_effect_kernel_Outcome$Succeeded(fa) {
  this.Lcats_effect_kernel_Outcome$Succeeded__f_fa = null;
  this.Lcats_effect_kernel_Outcome$Succeeded__f_fa = fa;
}
export { $c_Lcats_effect_kernel_Outcome$Succeeded as $c_Lcats_effect_kernel_Outcome$Succeeded };
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype = new $h_O();
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.constructor = $c_Lcats_effect_kernel_Outcome$Succeeded;
/** @constructor */
function $h_Lcats_effect_kernel_Outcome$Succeeded() {
}
export { $h_Lcats_effect_kernel_Outcome$Succeeded as $h_Lcats_effect_kernel_Outcome$Succeeded };
$h_Lcats_effect_kernel_Outcome$Succeeded.prototype = $c_Lcats_effect_kernel_Outcome$Succeeded.prototype;
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_effect_kernel_Outcome$Succeeded)) {
    var x = this.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    var y = x$0.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productPrefix__T = (function() {
  return "Succeeded";
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_effect_kernel_Outcome$Succeeded__f_fa;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Outcome$Succeeded.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "fa";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_effect_kernel_Outcome$Succeeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_effect_kernel_Outcome$Succeeded)));
}
export { $isArrayOf_Lcats_effect_kernel_Outcome$Succeeded as $isArrayOf_Lcats_effect_kernel_Outcome$Succeeded };
var $d_Lcats_effect_kernel_Outcome$Succeeded = new $TypeData().initClass($c_Lcats_effect_kernel_Outcome$Succeeded, "cats.effect.kernel.Outcome$Succeeded", ({
  Lcats_effect_kernel_Outcome$Succeeded: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Outcome: 1
}));
export { $d_Lcats_effect_kernel_Outcome$Succeeded as $d_Lcats_effect_kernel_Outcome$Succeeded };
/** @constructor */
function $c_Lcats_instances_package$either$() {
}
export { $c_Lcats_instances_package$either$ as $c_Lcats_instances_package$either$ };
$c_Lcats_instances_package$either$.prototype = new $h_O();
$c_Lcats_instances_package$either$.prototype.constructor = $c_Lcats_instances_package$either$;
/** @constructor */
function $h_Lcats_instances_package$either$() {
}
export { $h_Lcats_instances_package$either$ as $h_Lcats_instances_package$either$ };
$h_Lcats_instances_package$either$.prototype = $c_Lcats_instances_package$either$.prototype;
var $d_Lcats_instances_package$either$ = new $TypeData().initClass($c_Lcats_instances_package$either$, "cats.instances.package$either$", ({
  Lcats_instances_package$either$: 1,
  Lcats_kernel_instances_EitherInstances1: 1,
  Lcats_kernel_instances_EitherInstances0: 1,
  Lcats_kernel_instances_EitherInstances: 1,
  Lcats_instances_EitherInstances: 1
}));
export { $d_Lcats_instances_package$either$ as $d_Lcats_instances_package$either$ };
var $n_Lcats_instances_package$either$;
function $m_Lcats_instances_package$either$() {
  if ((!$n_Lcats_instances_package$either$)) {
    $n_Lcats_instances_package$either$ = new $c_Lcats_instances_package$either$();
  }
  return $n_Lcats_instances_package$either$;
}
export { $m_Lcats_instances_package$either$ as $m_Lcats_instances_package$either$ };
/** @constructor */
function $c_Lcats_instances_package$seq$() {
  this.Lcats_instances_package$seq$__f_catsStdInstancesForSeq = null;
  $n_Lcats_instances_package$seq$ = this;
  $f_Lcats_instances_SeqInstances__$init$__V(this);
}
export { $c_Lcats_instances_package$seq$ as $c_Lcats_instances_package$seq$ };
$c_Lcats_instances_package$seq$.prototype = new $h_O();
$c_Lcats_instances_package$seq$.prototype.constructor = $c_Lcats_instances_package$seq$;
/** @constructor */
function $h_Lcats_instances_package$seq$() {
}
export { $h_Lcats_instances_package$seq$ as $h_Lcats_instances_package$seq$ };
$h_Lcats_instances_package$seq$.prototype = $c_Lcats_instances_package$seq$.prototype;
$c_Lcats_instances_package$seq$.prototype.cats$instances$SeqInstances$_setter_$catsStdInstancesForSeq_$eq__Lcats_Align__V = (function(x$0) {
  this.Lcats_instances_package$seq$__f_catsStdInstancesForSeq = x$0;
});
$c_Lcats_instances_package$seq$.prototype.cats$instances$SeqInstances$_setter_$catsStdTraverseFilterForSeq_$eq__Lcats_TraverseFilter__V = (function(x$0) {
});
var $d_Lcats_instances_package$seq$ = new $TypeData().initClass($c_Lcats_instances_package$seq$, "cats.instances.package$seq$", ({
  Lcats_instances_package$seq$: 1,
  Lcats_kernel_instances_SeqInstances2: 1,
  Lcats_kernel_instances_SeqInstances1: 1,
  Lcats_kernel_instances_SeqInstances: 1,
  Lcats_instances_SeqInstances: 1
}));
export { $d_Lcats_instances_package$seq$ as $d_Lcats_instances_package$seq$ };
var $n_Lcats_instances_package$seq$;
function $m_Lcats_instances_package$seq$() {
  if ((!$n_Lcats_instances_package$seq$)) {
    $n_Lcats_instances_package$seq$ = new $c_Lcats_instances_package$seq$();
  }
  return $n_Lcats_instances_package$seq$;
}
export { $m_Lcats_instances_package$seq$ as $m_Lcats_instances_package$seq$ };
/** @constructor */
function $c_Lcats_kernel_Order$() {
}
export { $c_Lcats_kernel_Order$ as $c_Lcats_kernel_Order$ };
$c_Lcats_kernel_Order$.prototype = new $h_Lcats_kernel_OrderFunctions();
$c_Lcats_kernel_Order$.prototype.constructor = $c_Lcats_kernel_Order$;
/** @constructor */
function $h_Lcats_kernel_Order$() {
}
export { $h_Lcats_kernel_Order$ as $h_Lcats_kernel_Order$ };
$h_Lcats_kernel_Order$.prototype = $c_Lcats_kernel_Order$.prototype;
var $d_Lcats_kernel_Order$ = new $TypeData().initClass($c_Lcats_kernel_Order$, "cats.kernel.Order$", ({
  Lcats_kernel_Order$: 1,
  Lcats_kernel_OrderFunctions: 1,
  Lcats_kernel_PartialOrderFunctions: 1,
  Lcats_kernel_EqFunctions: 1,
  Lcats_kernel_OrderToOrderingConversion: 1
}));
export { $d_Lcats_kernel_Order$ as $d_Lcats_kernel_Order$ };
var $n_Lcats_kernel_Order$;
function $m_Lcats_kernel_Order$() {
  if ((!$n_Lcats_kernel_Order$)) {
    $n_Lcats_kernel_Order$ = new $c_Lcats_kernel_Order$();
  }
  return $n_Lcats_kernel_Order$;
}
export { $m_Lcats_kernel_Order$ as $m_Lcats_kernel_Order$ };
/** @constructor */
function $c_Lcats_kernel_Order$$anon$9(ev$4) {
  this.Lcats_kernel_Order$$anon$9__f_ev$2 = null;
  this.Lcats_kernel_Order$$anon$9__f_ev$2 = ev$4;
}
export { $c_Lcats_kernel_Order$$anon$9 as $c_Lcats_kernel_Order$$anon$9 };
$c_Lcats_kernel_Order$$anon$9.prototype = new $h_O();
$c_Lcats_kernel_Order$$anon$9.prototype.constructor = $c_Lcats_kernel_Order$$anon$9;
/** @constructor */
function $h_Lcats_kernel_Order$$anon$9() {
}
export { $h_Lcats_kernel_Order$$anon$9 as $h_Lcats_kernel_Order$$anon$9 };
$h_Lcats_kernel_Order$$anon$9.prototype = $c_Lcats_kernel_Order$$anon$9.prototype;
$c_Lcats_kernel_Order$$anon$9.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_Order$$anon$9.prototype.eqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__eqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$9.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$9.prototype.lt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__lt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$9.prototype.gt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__gt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$9.prototype.compare__O__O__I = (function(x, y) {
  return this.Lcats_kernel_Order$$anon$9__f_ev$2.compare__O__O__I(x, y);
});
$c_Lcats_kernel_Order$$anon$9.prototype.toOrdering__s_math_Ordering = (function() {
  return this.Lcats_kernel_Order$$anon$9__f_ev$2;
});
var $d_Lcats_kernel_Order$$anon$9 = new $TypeData().initClass($c_Lcats_kernel_Order$$anon$9, "cats.kernel.Order$$anon$9", ({
  Lcats_kernel_Order$$anon$9: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1
}));
export { $d_Lcats_kernel_Order$$anon$9 as $d_Lcats_kernel_Order$$anon$9 };
class $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReaderException extends $c_jl_RuntimeException {
  constructor(msg, cause, withStackTrace) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, msg, cause, true, withStackTrace);
  }
}
export { $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReaderException as $c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReaderException };
var $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReaderException = new $TypeData().initClass($c_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReaderException, "com.github.plokhotnyuk.jsoniter_scala.core.JsonReaderException", ({
  Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReaderException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReaderException as $d_Lcom_github_plokhotnyuk_jsoniter\uff3fscala_core_JsonReaderException };
/** @constructor */
function $c_Lcom_raquo_airstream_core_Observer$$anon$1(outer) {
  this.Lcom_raquo_airstream_core_Observer$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcom_raquo_airstream_core_Observer$$anon$1__f_$outer = outer;
}
export { $c_Lcom_raquo_airstream_core_Observer$$anon$1 as $c_Lcom_raquo_airstream_core_Observer$$anon$1 };
$c_Lcom_raquo_airstream_core_Observer$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_raquo_airstream_core_Observer$$anon$1.prototype.constructor = $c_Lcom_raquo_airstream_core_Observer$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Observer$$anon$1() {
}
export { $h_Lcom_raquo_airstream_core_Observer$$anon$1 as $h_Lcom_raquo_airstream_core_Observer$$anon$1 };
$h_Lcom_raquo_airstream_core_Observer$$anon$1.prototype = $c_Lcom_raquo_airstream_core_Observer$$anon$1.prototype;
$c_Lcom_raquo_airstream_core_Observer$$anon$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return true;
});
$c_Lcom_raquo_airstream_core_Observer$$anon$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  this.Lcom_raquo_airstream_core_Observer$$anon$1__f_$outer.onError__jl_Throwable__V(x);
});
$c_Lcom_raquo_airstream_core_Observer$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z(x);
});
$c_Lcom_raquo_airstream_core_Observer$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O(x, default$1);
});
var $d_Lcom_raquo_airstream_core_Observer$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_airstream_core_Observer$$anon$1, "com.raquo.airstream.core.Observer$$anon$1", ({
  Lcom_raquo_airstream_core_Observer$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_raquo_airstream_core_Observer$$anon$1 as $d_Lcom_raquo_airstream_core_Observer$$anon$1 };
function $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V($thiz) {
  $thiz.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V($m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_core_Observer.getArrayOf().constr)([]))));
  $thiz.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V($m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_core_InternalObserver.getArrayOf().constr)([]))));
  $thiz.willStartDone_$eq__Z__V(false);
}
export { $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V as $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V };
function $f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz, observer, owner) {
  var this$2 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V($thiz);
    var subscription = $f_Lcom_raquo_airstream_core_WritableObservable__addExternalObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz, observer, owner);
    $thiz.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V(observer);
    $p_Lcom_raquo_airstream_core_WritableObservable__maybeStart__V($thiz);
    return subscription;
  });
  var when = (!$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz));
  if ((this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart || (!when))) {
    var $x_1 = f();
  } else {
    this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = true;
    try {
      var result = f();
    } finally {
      this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = false;
      $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$2);
    }
    var $x_1 = result;
  }
  return $x_1;
}
export { $f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription as $f_Lcom_raquo_airstream_core_WritableObservable__addObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription };
function $f_Lcom_raquo_airstream_core_WritableObservable__addExternalObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription($thiz, observer, owner) {
  var subscription = new $c_Lcom_raquo_airstream_ownership_Subscription(owner, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    $f_Lcom_raquo_airstream_core_BaseObservable__removeExternalObserver__Lcom_raquo_airstream_core_Observer__V($thiz, observer);
  })));
  var this$ = $thiz.externalObservers__Lcom_raquo_ew_JsArray();
  this$.push(observer);
  return subscription;
}
export { $f_Lcom_raquo_airstream_core_WritableObservable__addExternalObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription as $f_Lcom_raquo_airstream_core_WritableObservable__addExternalObserver__Lcom_raquo_airstream_core_Observer__Lcom_raquo_airstream_ownership_Owner__Lcom_raquo_airstream_ownership_Subscription };
function $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V($thiz, observer, shouldCallMaybeWillStart) {
  var this$3 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    if (((!$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz)) && shouldCallMaybeWillStart)) {
      $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V($thiz);
    }
    var this$ = $thiz.internalObservers__Lcom_raquo_ew_JsArray();
    this$.push(observer);
    $p_Lcom_raquo_airstream_core_WritableObservable__maybeStart__V($thiz);
  });
  var when = (!$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz));
  if ((this$3.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart || (!when))) {
    f();
  } else {
    this$3.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = true;
    try {
      f();
    } finally {
      this$3.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = false;
      $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$3);
    }
  }
}
export { $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V as $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V };
function $f_Lcom_raquo_airstream_core_WritableObservable__removeInternalObserverNow__Lcom_raquo_airstream_core_InternalObserver__V($thiz, observer) {
  var removed = $m_Lcom_raquo_airstream_core_ObserverList$().removeObserverNow$extension__Lcom_raquo_ew_JsArray__O__Z($thiz.internalObservers__Lcom_raquo_ew_JsArray(), observer);
  if (removed) {
    $p_Lcom_raquo_airstream_core_WritableObservable__maybeStop__V($thiz);
  }
}
export { $f_Lcom_raquo_airstream_core_WritableObservable__removeInternalObserverNow__Lcom_raquo_airstream_core_InternalObserver__V as $f_Lcom_raquo_airstream_core_WritableObservable__removeInternalObserverNow__Lcom_raquo_airstream_core_InternalObserver__V };
function $f_Lcom_raquo_airstream_core_WritableObservable__removeExternalObserverNow__Lcom_raquo_airstream_core_Observer__V($thiz, observer) {
  var removed = $m_Lcom_raquo_airstream_core_ObserverList$().removeObserverNow$extension__Lcom_raquo_ew_JsArray__O__Z($thiz.externalObservers__Lcom_raquo_ew_JsArray(), observer);
  if (removed) {
    $p_Lcom_raquo_airstream_core_WritableObservable__maybeStop__V($thiz);
  }
}
export { $f_Lcom_raquo_airstream_core_WritableObservable__removeExternalObserverNow__Lcom_raquo_airstream_core_Observer__V as $f_Lcom_raquo_airstream_core_WritableObservable__removeExternalObserverNow__Lcom_raquo_airstream_core_Observer__V };
function $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V($thiz) {
  if ((!$thiz.willStartDone__Z())) {
    $thiz.onWillStart__V();
    $thiz.willStartDone_$eq__Z__V(true);
  }
}
export { $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V as $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V };
function $p_Lcom_raquo_airstream_core_WritableObservable__maybeStart__V($thiz) {
  var isStarting = ($f_Lcom_raquo_airstream_core_WritableObservable__numAllObservers__I($thiz) === 1);
  if (isStarting) {
    $thiz.onStart__V();
  }
}
export { $p_Lcom_raquo_airstream_core_WritableObservable__maybeStart__V as $p_Lcom_raquo_airstream_core_WritableObservable__maybeStart__V };
function $p_Lcom_raquo_airstream_core_WritableObservable__maybeStop__V($thiz) {
  if ((!$f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz))) {
    $thiz.onStop__V();
    $thiz.willStartDone_$eq__Z__V(false);
  }
}
export { $p_Lcom_raquo_airstream_core_WritableObservable__maybeStop__V as $p_Lcom_raquo_airstream_core_WritableObservable__maybeStop__V };
function $f_Lcom_raquo_airstream_core_WritableObservable__numAllObservers__I($thiz) {
  var this$ = $thiz.externalObservers__Lcom_raquo_ew_JsArray();
  var $x_1 = this$.length;
  var this$$1 = $thiz.internalObservers__Lcom_raquo_ew_JsArray();
  return ((($x_1 | 0) + (this$$1.length | 0)) | 0);
}
export { $f_Lcom_raquo_airstream_core_WritableObservable__numAllObservers__I as $f_Lcom_raquo_airstream_core_WritableObservable__numAllObservers__I };
/** @constructor */
function $c_Lcom_raquo_airstream_custom_CustomSource$$anon$1(outer) {
  this.Lcom_raquo_airstream_custom_CustomSource$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcom_raquo_airstream_custom_CustomSource$$anon$1__f_$outer = outer;
}
export { $c_Lcom_raquo_airstream_custom_CustomSource$$anon$1 as $c_Lcom_raquo_airstream_custom_CustomSource$$anon$1 };
$c_Lcom_raquo_airstream_custom_CustomSource$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_raquo_airstream_custom_CustomSource$$anon$1.prototype.constructor = $c_Lcom_raquo_airstream_custom_CustomSource$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_custom_CustomSource$$anon$1() {
}
export { $h_Lcom_raquo_airstream_custom_CustomSource$$anon$1 as $h_Lcom_raquo_airstream_custom_CustomSource$$anon$1 };
$h_Lcom_raquo_airstream_custom_CustomSource$$anon$1.prototype = $c_Lcom_raquo_airstream_custom_CustomSource$$anon$1.prototype;
$c_Lcom_raquo_airstream_custom_CustomSource$$anon$1.prototype.isDefinedAt__jl_Throwable__Z = (function(x) {
  return (x !== null);
});
$c_Lcom_raquo_airstream_custom_CustomSource$$anon$1.prototype.applyOrElse__jl_Throwable__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
      var this$2 = this.Lcom_raquo_airstream_custom_CustomSource$$anon$1__f_$outer;
      $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this$2, x, _$1);
    }));
    new $c_Lcom_raquo_airstream_core_Transaction(code);
    return (void 0);
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lcom_raquo_airstream_custom_CustomSource$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__jl_Throwable__Z(x);
});
$c_Lcom_raquo_airstream_custom_CustomSource$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__jl_Throwable__F1__O(x, default$1);
});
var $d_Lcom_raquo_airstream_custom_CustomSource$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_airstream_custom_CustomSource$$anon$1, "com.raquo.airstream.custom.CustomSource$$anon$1", ({
  Lcom_raquo_airstream_custom_CustomSource$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_raquo_airstream_custom_CustomSource$$anon$1 as $d_Lcom_raquo_airstream_custom_CustomSource$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_airstream_eventbus_EventBus() {
  this.Lcom_raquo_airstream_eventbus_EventBus__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_eventbus_EventBus__f_writer = null;
  this.Lcom_raquo_airstream_eventbus_EventBus__f_events = null;
  this.Lcom_raquo_airstream_eventbus_EventBus__f_maybeDisplayName = (void 0);
  this.Lcom_raquo_airstream_eventbus_EventBus__f_writer = new $c_Lcom_raquo_airstream_eventbus_WriteBus(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $f_Lcom_raquo_airstream_core_Named__displayName__T(this))), ".writer");
  this.Lcom_raquo_airstream_eventbus_EventBus__f_events = this.Lcom_raquo_airstream_eventbus_EventBus__f_writer.Lcom_raquo_airstream_eventbus_WriteBus__f_stream;
}
export { $c_Lcom_raquo_airstream_eventbus_EventBus as $c_Lcom_raquo_airstream_eventbus_EventBus };
$c_Lcom_raquo_airstream_eventbus_EventBus.prototype = new $h_O();
$c_Lcom_raquo_airstream_eventbus_EventBus.prototype.constructor = $c_Lcom_raquo_airstream_eventbus_EventBus;
/** @constructor */
function $h_Lcom_raquo_airstream_eventbus_EventBus() {
}
export { $h_Lcom_raquo_airstream_eventbus_EventBus as $h_Lcom_raquo_airstream_eventbus_EventBus };
$h_Lcom_raquo_airstream_eventbus_EventBus.prototype = $c_Lcom_raquo_airstream_eventbus_EventBus.prototype;
$c_Lcom_raquo_airstream_eventbus_EventBus.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_eventbus_EventBus__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_eventbus_EventBus.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_eventbus_EventBus__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_eventbus_EventBus.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_eventbus_EventBus.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_eventbus_EventBus.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this.Lcom_raquo_airstream_eventbus_EventBus__f_events;
});
$c_Lcom_raquo_airstream_eventbus_EventBus.prototype.toObserver__Lcom_raquo_airstream_core_Observer = (function() {
  return this.Lcom_raquo_airstream_eventbus_EventBus__f_writer;
});
$c_Lcom_raquo_airstream_eventbus_EventBus.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_eventbus_EventBus__f_events;
});
var $d_Lcom_raquo_airstream_eventbus_EventBus = new $TypeData().initClass($c_Lcom_raquo_airstream_eventbus_EventBus, "com.raquo.airstream.eventbus.EventBus", ({
  Lcom_raquo_airstream_eventbus_EventBus: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_core_Sink: 1,
  Lcom_raquo_airstream_core_Named: 1
}));
export { $d_Lcom_raquo_airstream_eventbus_EventBus as $d_Lcom_raquo_airstream_eventbus_EventBus };
function $f_Lcom_raquo_airstream_state_Var__$init$__V($thiz) {
  $thiz.com$raquo$airstream$state$Var$_setter_$writer_$eq__Lcom_raquo_airstream_core_Observer__V($m_Lcom_raquo_airstream_core_Observer$().fromTry__s_PartialFunction__Z__Lcom_raquo_airstream_core_Observer(new $c_Lcom_raquo_airstream_state_Var$$anon$1($thiz), ($m_Lcom_raquo_airstream_core_Observer$(), true)));
}
export { $f_Lcom_raquo_airstream_state_Var__$init$__V as $f_Lcom_raquo_airstream_state_Var__$init$__V };
function $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var($thiz, in$1, out) {
  var zoomedSignal = new $c_Lcom_raquo_airstream_state_LazyStrictSignal($thiz.signal__Lcom_raquo_airstream_state_StrictSignal(), in$1, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $f_Lcom_raquo_airstream_core_Named__displayName__T($thiz))), ".zoomLazy.signal");
  return new $c_Lcom_raquo_airstream_state_LazyDerivedVar($thiz, zoomedSignal, out, ".zoomLazy");
}
export { $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var as $f_Lcom_raquo_airstream_state_Var__zoomLazy__F1__F2__Lcom_raquo_airstream_state_Var };
function $f_Lcom_raquo_airstream_state_Var__set__O__V($thiz, value) {
  var tryValue = new $c_s_util_Success(value);
  $thiz.writer__Lcom_raquo_airstream_core_Observer().onTry__s_util_Try__V(tryValue);
}
export { $f_Lcom_raquo_airstream_state_Var__set__O__V as $f_Lcom_raquo_airstream_state_Var__set__O__V };
function $f_Lcom_raquo_airstream_state_Var__update__F1__V($thiz, mod) {
  var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((trx) => {
    matchResult12: {
      var x36 = $thiz.signal__Lcom_raquo_airstream_state_StrictSignal().tryNow__s_util_Try();
      if ((x36 instanceof $c_s_util_Success)) {
        var currentValue = x36.s_util_Success__f_value;
        try {
          var r1 = mod.apply__O__O(currentValue);
          var nextValue = new $c_s_util_Success(r1);
        } catch (e) {
          var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
          matchEnd8: {
            var nextValue;
            if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
              var nextValue = new $c_s_util_Failure(e$2);
              break matchEnd8;
            }
            throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
          }
        }
        $thiz.setCurrentValue__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(nextValue, trx);
        break matchResult12;
      }
      if ((x36 instanceof $c_s_util_Failure)) {
        var err = x36.s_util_Failure__f_exception;
        var $x_1 = $m_Lcom_raquo_airstream_core_AirstreamError$();
        var cause = new $c_s_Some(err);
        $x_1.sendUnhandledError__jl_Throwable__V(new $c_Lcom_raquo_airstream_core_AirstreamError$VarError("Unable to update a failed Var. Consider Var#tryUpdate instead.", cause));
        break matchResult12;
      }
      throw new $c_s_MatchError(x36);
    }
  }));
  new $c_Lcom_raquo_airstream_core_Transaction(code);
}
export { $f_Lcom_raquo_airstream_state_Var__update__F1__V as $f_Lcom_raquo_airstream_state_Var__update__F1__V };
/** @constructor */
function $c_Lcom_raquo_airstream_state_Var$$anon$1(outer) {
  this.Lcom_raquo_airstream_state_Var$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcom_raquo_airstream_state_Var$$anon$1__f_$outer = outer;
}
export { $c_Lcom_raquo_airstream_state_Var$$anon$1 as $c_Lcom_raquo_airstream_state_Var$$anon$1 };
$c_Lcom_raquo_airstream_state_Var$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_raquo_airstream_state_Var$$anon$1.prototype.constructor = $c_Lcom_raquo_airstream_state_Var$$anon$1;
/** @constructor */
function $h_Lcom_raquo_airstream_state_Var$$anon$1() {
}
export { $h_Lcom_raquo_airstream_state_Var$$anon$1 as $h_Lcom_raquo_airstream_state_Var$$anon$1 };
$h_Lcom_raquo_airstream_state_Var$$anon$1.prototype = $c_Lcom_raquo_airstream_state_Var$$anon$1.prototype;
$c_Lcom_raquo_airstream_state_Var$$anon$1.prototype.isDefinedAt__s_util_Try__Z = (function(x) {
  return true;
});
$c_Lcom_raquo_airstream_state_Var$$anon$1.prototype.applyOrElse__s_util_Try__F1__O = (function(x, default$1) {
  var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    this.Lcom_raquo_airstream_state_Var$$anon$1__f_$outer.setCurrentValue__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(x, _$1);
  }));
  new $c_Lcom_raquo_airstream_core_Transaction(code);
});
$c_Lcom_raquo_airstream_state_Var$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Try__Z(x);
});
$c_Lcom_raquo_airstream_state_Var$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Try__F1__O(x, default$1);
});
var $d_Lcom_raquo_airstream_state_Var$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_airstream_state_Var$$anon$1, "com.raquo.airstream.state.Var$$anon$1", ({
  Lcom_raquo_airstream_state_Var$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_raquo_airstream_state_Var$$anon$1 as $d_Lcom_raquo_airstream_state_Var$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_laminar_api_Laminar$svg$(outer) {
  this.Lcom_raquo_laminar_api_Laminar$svg$__f_svg$lzy1 = null;
  this.Lcom_raquo_laminar_api_Laminar$svg$__f_svgbitmap$1 = false;
  this.Lcom_raquo_laminar_api_Laminar$svg$__f_className = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $f_Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys__$init$__V(this);
}
export { $c_Lcom_raquo_laminar_api_Laminar$svg$ as $c_Lcom_raquo_laminar_api_Laminar$svg$ };
$c_Lcom_raquo_laminar_api_Laminar$svg$.prototype = new $h_O();
$c_Lcom_raquo_laminar_api_Laminar$svg$.prototype.constructor = $c_Lcom_raquo_laminar_api_Laminar$svg$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Laminar$svg$() {
}
export { $h_Lcom_raquo_laminar_api_Laminar$svg$ as $h_Lcom_raquo_laminar_api_Laminar$svg$ };
$h_Lcom_raquo_laminar_api_Laminar$svg$.prototype = $c_Lcom_raquo_laminar_api_Laminar$svg$.prototype;
$c_Lcom_raquo_laminar_api_Laminar$svg$.prototype.svg__Lcom_raquo_laminar_tags_SvgTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_Laminar$svg$__f_svgbitmap$1)) {
    this.Lcom_raquo_laminar_api_Laminar$svg$__f_svg$lzy1 = new $c_Lcom_raquo_laminar_tags_SvgTag("svg", false);
    this.Lcom_raquo_laminar_api_Laminar$svg$__f_svgbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_Laminar$svg$__f_svg$lzy1;
});
$c_Lcom_raquo_laminar_api_Laminar$svg$.prototype.className__Lcom_raquo_laminar_keys_CompositeAttr = (function() {
  return this.Lcom_raquo_laminar_api_Laminar$svg$__f_className;
});
$c_Lcom_raquo_laminar_api_Laminar$svg$.prototype.com$raquo$laminar$defs$complex$ComplexGlobalKeys$_setter_$className_$eq__Lcom_raquo_laminar_keys_CompositeAttr__V = (function(x$0) {
  this.Lcom_raquo_laminar_api_Laminar$svg$__f_className = x$0;
});
$c_Lcom_raquo_laminar_api_Laminar$svg$.prototype.com$raquo$laminar$defs$complex$ComplexGlobalKeys$_setter_$cls_$eq__Lcom_raquo_laminar_keys_CompositeAttr__V = (function(x$0) {
});
var $d_Lcom_raquo_laminar_api_Laminar$svg$ = new $TypeData().initClass($c_Lcom_raquo_laminar_api_Laminar$svg$, "com.raquo.laminar.api.Laminar$svg$", ({
  Lcom_raquo_laminar_api_Laminar$svg$: 1,
  Lcom_raquo_laminar_defs_tags_SvgTags: 1,
  Lcom_raquo_laminar_defs_attrs_SvgAttrs: 1,
  Lcom_raquo_laminar_defs_attrs_GlobalAttrs: 1,
  Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys: 1
}));
export { $d_Lcom_raquo_laminar_api_Laminar$svg$ as $d_Lcom_raquo_laminar_api_Laminar$svg$ };
/** @constructor */
function $c_Lcom_raquo_laminar_api_package$() {
  this.Lcom_raquo_laminar_api_package$__f_StringValueMapper$lzy2 = null;
  this.Lcom_raquo_laminar_api_package$__f_StringValueMapperbitmap$2 = false;
  this.Lcom_raquo_laminar_api_package$__f_StringSeqValueMapper$lzy2 = null;
  this.Lcom_raquo_laminar_api_package$__f_StringSeqValueMapperbitmap$2 = false;
  this.Lcom_raquo_laminar_api_package$__f_L = null;
  $n_Lcom_raquo_laminar_api_package$ = this;
  this.Lcom_raquo_laminar_api_package$__f_L = new $c_Lcom_raquo_laminar_api_package$$anon$1();
}
export { $c_Lcom_raquo_laminar_api_package$ as $c_Lcom_raquo_laminar_api_package$ };
$c_Lcom_raquo_laminar_api_package$.prototype = new $h_O();
$c_Lcom_raquo_laminar_api_package$.prototype.constructor = $c_Lcom_raquo_laminar_api_package$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_package$() {
}
export { $h_Lcom_raquo_laminar_api_package$ as $h_Lcom_raquo_laminar_api_package$ };
$h_Lcom_raquo_laminar_api_package$.prototype = $c_Lcom_raquo_laminar_api_package$.prototype;
$c_Lcom_raquo_laminar_api_package$.prototype.StringValueMapper__Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$ = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$__f_StringValueMapperbitmap$2)) {
    this.Lcom_raquo_laminar_api_package$__f_StringValueMapper$lzy2 = new $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$(this);
    this.Lcom_raquo_laminar_api_package$__f_StringValueMapperbitmap$2 = true;
  }
  return this.Lcom_raquo_laminar_api_package$__f_StringValueMapper$lzy2;
});
$c_Lcom_raquo_laminar_api_package$.prototype.StringSeqValueMapper__Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$ = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$__f_StringSeqValueMapperbitmap$2)) {
    this.Lcom_raquo_laminar_api_package$__f_StringSeqValueMapper$lzy2 = new $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$(this);
    this.Lcom_raquo_laminar_api_package$__f_StringSeqValueMapperbitmap$2 = true;
  }
  return this.Lcom_raquo_laminar_api_package$__f_StringSeqValueMapper$lzy2;
});
var $d_Lcom_raquo_laminar_api_package$ = new $TypeData().initClass($c_Lcom_raquo_laminar_api_package$, "com.raquo.laminar.api.package$", ({
  Lcom_raquo_laminar_api_package$: 1,
  Lcom_raquo_laminar_api_ImplicitsPlatformSpecific: 1,
  Lcom_raquo_laminar_api_Implicits$LowPriorityImplicits: 1,
  Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits: 1,
  Lcom_raquo_laminar_api_Implicits: 1
}));
export { $d_Lcom_raquo_laminar_api_package$ as $d_Lcom_raquo_laminar_api_package$ };
var $n_Lcom_raquo_laminar_api_package$;
function $m_Lcom_raquo_laminar_api_package$() {
  if ((!$n_Lcom_raquo_laminar_api_package$)) {
    $n_Lcom_raquo_laminar_api_package$ = new $c_Lcom_raquo_laminar_api_package$();
  }
  return $n_Lcom_raquo_laminar_api_package$;
}
export { $m_Lcom_raquo_laminar_api_package$ as $m_Lcom_raquo_laminar_api_package$ };
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__$init$__V($thiz) {
  $thiz.com$raquo$laminar$nodes$ReactiveElement$_setter_$com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription_$eq__Lcom_raquo_airstream_ownership_TransferableSubscription__V(new $c_Lcom_raquo_airstream_ownership_TransferableSubscription(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    $thiz.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner().activate__V();
  })), new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    $thiz.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner().deactivate__V();
  }))));
  $thiz.com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners_$eq__O__V((void 0));
  $thiz.com$raquo$laminar$nodes$ReactiveElement$$_compositeValues_$eq__sci_Map__V($m_sci_Map$EmptyMap$());
}
export { $f_Lcom_raquo_laminar_nodes_ReactiveElement__$init$__V as $f_Lcom_raquo_laminar_nodes_ReactiveElement__$init$__V };
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__addEventListener__Lcom_raquo_laminar_modifiers_EventListener__Z__V($thiz, listener, unsafePrepend) {
  var x = $thiz.com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners__O();
  if ((x === (void 0))) {
    $thiz.com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners_$eq__O__V($m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_modifiers_EventListener.getArrayOf().constr)([listener]))));
  } else if (unsafePrepend) {
    var x$1 = $thiz.com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners__O();
    if ((x$1 === (void 0))) {
      var $x_1;
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
    } else {
      var $x_1 = x$1;
    }
    $x_1.unshift(listener);
  } else {
    var x$2 = $thiz.com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners__O();
    if ((x$2 === (void 0))) {
      var $x_2;
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "undefined.get");
    } else {
      var $x_2 = x$2;
    }
    $x_2.push(listener);
  }
}
export { $f_Lcom_raquo_laminar_nodes_ReactiveElement__addEventListener__Lcom_raquo_laminar_modifiers_EventListener__Z__V as $f_Lcom_raquo_laminar_nodes_ReactiveElement__addEventListener__Lcom_raquo_laminar_modifiers_EventListener__Z__V };
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__removeEventListener__I__V($thiz, index) {
  var x = $thiz.com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners__O();
  if ((x !== (void 0))) {
    x.splice(index, 1);
  }
}
export { $f_Lcom_raquo_laminar_nodes_ReactiveElement__removeEventListener__I__V as $f_Lcom_raquo_laminar_nodes_ReactiveElement__removeEventListener__I__V };
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__indexOfEventListener__Lcom_raquo_laminar_modifiers_EventListener__I($thiz, listener) {
  var x = $thiz.com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners__O();
  if ((x === (void 0))) {
    return (-1);
  } else {
    var found = false;
    var ix = 0;
    while (((!found) && (ix < (x.length | 0)))) {
      var x$1 = x[ix];
      if (((x$1 === null) ? (listener === null) : $dp_equals__O__Z(x$1, listener))) {
        found = true;
      } else {
        ix = ((1 + ix) | 0);
      }
    }
    return (found ? ix : (-1));
  }
}
export { $f_Lcom_raquo_laminar_nodes_ReactiveElement__indexOfEventListener__Lcom_raquo_laminar_modifiers_EventListener__I as $f_Lcom_raquo_laminar_nodes_ReactiveElement__indexOfEventListener__Lcom_raquo_laminar_modifiers_EventListener__I };
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__compositeValueItems__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List($thiz, prop, reason) {
  return $thiz.com$raquo$laminar$nodes$ReactiveElement$$_compositeValues__sci_Map().getOrElse__O__F0__O(prop, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $m_sci_Nil$()))).collect__s_PartialFunction__sci_List(new $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1(reason));
}
export { $f_Lcom_raquo_laminar_nodes_ReactiveElement__compositeValueItems__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List as $f_Lcom_raquo_laminar_nodes_ReactiveElement__compositeValueItems__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List };
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__updateCompositeValue__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List__sci_List__V($thiz, key, reason, addItems, removeItems) {
  var keyItemsWithReason = $thiz.com$raquo$laminar$nodes$ReactiveElement$$_compositeValues__sci_Map().getOrElse__O__F0__O(key, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $m_sci_Nil$())));
  var f = ((item) => {
    var these = keyItemsWithReason;
    while ((!these.isEmpty__Z())) {
      var x0 = these.head__O();
      var x = x0._1__O();
      if (((x === null) ? (item === null) : $dp_equals__O__Z(x, item))) {
        var x$3 = x0._2__O();
        if ((!((x$3 === null) ? (reason === null) : $dp_equals__O__Z(x$3, reason)))) {
          var $x_1 = true;
        } else {
          var $x_1 = (reason === null);
        }
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return true;
      }
      these = these.tail__O();
    }
    return false;
  });
  var itemsToAdd = $f_sc_SeqOps__distinct__O(addItems);
  var l = removeItems;
  block: {
    var result;
    while (true) {
      if (l.isEmpty__Z()) {
        var result = $m_sci_Nil$();
        break;
      } else {
        var h = l.head__O();
        var t = l.tail__O();
        if (((!(!f(h))) === true)) {
          l = t;
          continue;
        }
        var start = l;
        var remaining = t;
        while (true) {
          if (remaining.isEmpty__Z()) {
            var result = start;
            break block;
          } else {
            var x$1 = remaining.head__O();
            if (((!(!f(x$1))) !== true)) {
              remaining = remaining.tail__O();
              continue;
            }
            var firstMiss = remaining;
            var newHead = new $c_sci_$colon$colon(start.head__O(), $m_sci_Nil$());
            var toProcess = start.tail__O();
            var currentLast = newHead;
            while ((toProcess !== firstMiss)) {
              var newElem = new $c_sci_$colon$colon(toProcess.head__O(), $m_sci_Nil$());
              currentLast.sci_$colon$colon__f_next = newElem;
              currentLast = newElem;
              toProcess = toProcess.tail__O();
            }
            var next = firstMiss.tail__O();
            var nextToCopy = next;
            while ((!next.isEmpty__Z())) {
              var head = next.head__O();
              if (((!(!f(head))) !== true)) {
                next = next.tail__O();
              } else {
                while ((nextToCopy !== next)) {
                  var newElem$2 = new $c_sci_$colon$colon(nextToCopy.head__O(), $m_sci_Nil$());
                  currentLast.sci_$colon$colon__f_next = newElem$2;
                  currentLast = newElem$2;
                  nextToCopy = nextToCopy.tail__O();
                }
                nextToCopy = next.tail__O();
                next = next.tail__O();
              }
            }
            if ((!nextToCopy.isEmpty__Z())) {
              currentLast.sci_$colon$colon__f_next = nextToCopy;
            }
            var result = newHead;
            break block;
          }
        }
      }
    }
  }
  var this$1 = $thiz.com$raquo$laminar$nodes$ReactiveElement$$_compositeValues__sci_Map().getOrElse__O__F0__O(key, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $m_sci_Nil$())));
  var f$1 = ((t$1) => result.contains__O__Z(t$1._1__O()));
  var l$1 = this$1;
  block$2: {
    var result$1;
    while (true) {
      if (l$1.isEmpty__Z()) {
        var result$1 = $m_sci_Nil$();
        break;
      } else {
        var h$1 = l$1.head__O();
        var t$2 = l$1.tail__O();
        if (((!(!f$1(h$1))) === true)) {
          l$1 = t$2;
          continue;
        }
        var start$1 = l$1;
        var remaining$1 = t$2;
        while (true) {
          if (remaining$1.isEmpty__Z()) {
            var result$1 = start$1;
            break block$2;
          } else {
            var x$2 = remaining$1.head__O();
            if (((!(!f$1(x$2))) !== true)) {
              remaining$1 = remaining$1.tail__O();
              continue;
            }
            var firstMiss$1 = remaining$1;
            var newHead$1 = new $c_sci_$colon$colon(start$1.head__O(), $m_sci_Nil$());
            var toProcess$1 = start$1.tail__O();
            var currentLast$1 = newHead$1;
            while ((toProcess$1 !== firstMiss$1)) {
              var newElem$1 = new $c_sci_$colon$colon(toProcess$1.head__O(), $m_sci_Nil$());
              currentLast$1.sci_$colon$colon__f_next = newElem$1;
              currentLast$1 = newElem$1;
              toProcess$1 = toProcess$1.tail__O();
            }
            var next$1 = firstMiss$1.tail__O();
            var nextToCopy$1 = next$1;
            while ((!next$1.isEmpty__Z())) {
              var head$1 = next$1.head__O();
              if (((!(!f$1(head$1))) !== true)) {
                next$1 = next$1.tail__O();
              } else {
                while ((nextToCopy$1 !== next$1)) {
                  var newElem$2$1 = new $c_sci_$colon$colon(nextToCopy$1.head__O(), $m_sci_Nil$());
                  currentLast$1.sci_$colon$colon__f_next = newElem$2$1;
                  currentLast$1 = newElem$2$1;
                  nextToCopy$1 = nextToCopy$1.tail__O();
                }
                nextToCopy$1 = next$1.tail__O();
                next$1 = next$1.tail__O();
              }
            }
            if ((!nextToCopy$1.isEmpty__Z())) {
              currentLast$1.sci_$colon$colon__f_next = nextToCopy$1;
            }
            var result$1 = newHead$1;
            break block$2;
          }
        }
      }
    }
  }
  var f$2 = ((_$2) => $ct_T2__O__O__(new $c_T2(), _$2, reason));
  if ((itemsToAdd === $m_sci_Nil$())) {
    var suffix = $m_sci_Nil$();
  } else {
    var x0$1 = itemsToAdd.head__O();
    var h$2 = new $c_sci_$colon$colon(f$2(x0$1), $m_sci_Nil$());
    var t$3 = h$2;
    var rest = itemsToAdd.tail__O();
    while ((rest !== $m_sci_Nil$())) {
      var x0$2 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f$2(x0$2), $m_sci_Nil$());
      t$3.sci_$colon$colon__f_next = nx;
      t$3 = nx;
      rest = rest.tail__O();
    }
    var suffix = h$2;
  }
  var newItems = result$1.appendedAll__sc_IterableOnce__sci_List(suffix);
  $m_Lcom_raquo_laminar_domapi_DomApi$();
  var this$4 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
  var element = $thiz.ref__Lorg_scalajs_dom_Node();
  var localName = key.Lcom_raquo_laminar_keys_CompositeAttr__f_name;
  var x$4 = $f_Lcom_raquo_laminar_domapi_DomKeysRaw__getAttribute__Lorg_scalajs_dom_Element__T__T__O(this$4, element, localName, null);
  if ((x$4 === (void 0))) {
    var x$5 = (void 0);
  } else {
    var a = key.Lcom_raquo_laminar_keys_CompositeKey__f_codec.decode__T__sci_List(x$4);
    var x$5 = a;
  }
  var domValues = ((x$5 === (void 0)) ? $m_sci_Nil$() : x$5);
  var f$3 = ((elem) => result.contains__O__Z(elem));
  var l$2 = domValues;
  block$4: {
    var result$2;
    while (true) {
      if (l$2.isEmpty__Z()) {
        var result$2 = $m_sci_Nil$();
        break;
      } else {
        var h$3 = l$2.head__O();
        var t$4 = l$2.tail__O();
        if (((!(!f$3(h$3))) === true)) {
          l$2 = t$4;
          continue;
        }
        var start$2 = l$2;
        var remaining$2 = t$4;
        while (true) {
          if (remaining$2.isEmpty__Z()) {
            var result$2 = start$2;
            break block$4;
          } else {
            var x$6 = remaining$2.head__O();
            if (((!(!f$3(x$6))) !== true)) {
              remaining$2 = remaining$2.tail__O();
              continue;
            }
            var firstMiss$2 = remaining$2;
            var newHead$2 = new $c_sci_$colon$colon(start$2.head__O(), $m_sci_Nil$());
            var toProcess$2 = start$2.tail__O();
            var currentLast$2 = newHead$2;
            while ((toProcess$2 !== firstMiss$2)) {
              var newElem$3 = new $c_sci_$colon$colon(toProcess$2.head__O(), $m_sci_Nil$());
              currentLast$2.sci_$colon$colon__f_next = newElem$3;
              currentLast$2 = newElem$3;
              toProcess$2 = toProcess$2.tail__O();
            }
            var next$2 = firstMiss$2.tail__O();
            var nextToCopy$2 = next$2;
            while ((!next$2.isEmpty__Z())) {
              var head$2 = next$2.head__O();
              if (((!(!f$3(head$2))) !== true)) {
                next$2 = next$2.tail__O();
              } else {
                while ((nextToCopy$2 !== next$2)) {
                  var newElem$2$2 = new $c_sci_$colon$colon(nextToCopy$2.head__O(), $m_sci_Nil$());
                  currentLast$2.sci_$colon$colon__f_next = newElem$2$2;
                  currentLast$2 = newElem$2$2;
                  nextToCopy$2 = nextToCopy$2.tail__O();
                }
                nextToCopy$2 = next$2.tail__O();
                next$2 = next$2.tail__O();
              }
            }
            if ((!nextToCopy$2.isEmpty__Z())) {
              currentLast$2.sci_$colon$colon__f_next = nextToCopy$2;
            }
            var result$2 = newHead$2;
            break block$4;
          }
        }
      }
    }
  }
  var l$3 = itemsToAdd;
  block$6: {
    var result$3;
    while (true) {
      if (l$3.isEmpty__Z()) {
        var result$3 = $m_sci_Nil$();
        break;
      } else {
        var h$4 = l$3.head__O();
        var t$5 = l$3.tail__O();
        if (((!(!f(h$4))) === true)) {
          l$3 = t$5;
          continue;
        }
        var start$3 = l$3;
        var remaining$3 = t$5;
        while (true) {
          if (remaining$3.isEmpty__Z()) {
            var result$3 = start$3;
            break block$6;
          } else {
            var x$7 = remaining$3.head__O();
            if (((!(!f(x$7))) !== true)) {
              remaining$3 = remaining$3.tail__O();
              continue;
            }
            var firstMiss$3 = remaining$3;
            var newHead$3 = new $c_sci_$colon$colon(start$3.head__O(), $m_sci_Nil$());
            var toProcess$3 = start$3.tail__O();
            var currentLast$3 = newHead$3;
            while ((toProcess$3 !== firstMiss$3)) {
              var newElem$4 = new $c_sci_$colon$colon(toProcess$3.head__O(), $m_sci_Nil$());
              currentLast$3.sci_$colon$colon__f_next = newElem$4;
              currentLast$3 = newElem$4;
              toProcess$3 = toProcess$3.tail__O();
            }
            var next$3 = firstMiss$3.tail__O();
            var nextToCopy$3 = next$3;
            while ((!next$3.isEmpty__Z())) {
              var head$3 = next$3.head__O();
              if (((!(!f(head$3))) !== true)) {
                next$3 = next$3.tail__O();
              } else {
                while ((nextToCopy$3 !== next$3)) {
                  var newElem$2$3 = new $c_sci_$colon$colon(nextToCopy$3.head__O(), $m_sci_Nil$());
                  currentLast$3.sci_$colon$colon__f_next = newElem$2$3;
                  currentLast$3 = newElem$2$3;
                  nextToCopy$3 = nextToCopy$3.tail__O();
                }
                nextToCopy$3 = next$3.tail__O();
                next$3 = next$3.tail__O();
              }
            }
            if ((!nextToCopy$3.isEmpty__Z())) {
              currentLast$3.sci_$colon$colon__f_next = nextToCopy$3;
            }
            var result$3 = newHead$3;
            break block$6;
          }
        }
      }
    }
  }
  var nextDomValues = result$2.appendedAll__sc_IterableOnce__sci_List(result$3);
  $thiz.com$raquo$laminar$nodes$ReactiveElement$$_compositeValues_$eq__sci_Map__V($thiz.com$raquo$laminar$nodes$ReactiveElement$$_compositeValues__sci_Map().updated__O__O__sci_MapOps(key, newItems));
  var value = key.Lcom_raquo_laminar_keys_CompositeKey__f_codec.encode__sc_Iterable__T(nextDomValues);
  $m_Lcom_raquo_laminar_domapi_DomApi$();
  var this$19 = $m_Lcom_raquo_laminar_domapi_DomApi$raw$();
  var element$1 = $thiz.ref__Lorg_scalajs_dom_Node();
  var localName$1 = key.Lcom_raquo_laminar_keys_CompositeAttr__f_name;
  var qualifiedName = key.Lcom_raquo_laminar_keys_CompositeAttr__f_name;
  $f_Lcom_raquo_laminar_domapi_DomKeysRaw__setAttribute__Lorg_scalajs_dom_Element__T__T__T__T__V(this$19, element$1, localName$1, qualifiedName, null, value);
}
export { $f_Lcom_raquo_laminar_nodes_ReactiveElement__updateCompositeValue__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List__sci_List__V as $f_Lcom_raquo_laminar_nodes_ReactiveElement__updateCompositeValue__Lcom_raquo_laminar_keys_CompositeKey__Lcom_raquo_laminar_modifiers_Modifier__sci_List__sci_List__V };
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__events__Lcom_raquo_laminar_keys_EventProcessor__Lcom_raquo_airstream_core_EventStream($thiz, prop) {
  var eventBus = new $c_Lcom_raquo_airstream_eventbus_EventBus();
  var listener = new $c_Lcom_raquo_laminar_modifiers_EventListener(prop, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextValue) => {
    eventBus.Lcom_raquo_airstream_eventbus_EventBus__f_writer.onNext__O__V(nextValue);
  })));
  listener.bind__Lcom_raquo_laminar_nodes_ReactiveElement__Z__Lcom_raquo_airstream_ownership_DynamicSubscription($thiz, false);
  return eventBus.Lcom_raquo_airstream_eventbus_EventBus__f_events;
}
export { $f_Lcom_raquo_laminar_nodes_ReactiveElement__events__Lcom_raquo_laminar_keys_EventProcessor__Lcom_raquo_airstream_core_EventStream as $f_Lcom_raquo_laminar_nodes_ReactiveElement__events__Lcom_raquo_laminar_keys_EventProcessor__Lcom_raquo_airstream_core_EventStream };
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement($thiz, mods) {
  var this$2 = $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var f = (() => {
    mods.foreach__F1__V(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((mod) => {
      mod.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V($thiz);
    })));
    return $thiz;
  });
  $m_Lcom_raquo_airstream_core_Transaction$onStart$();
  var when = true;
  if ((this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart || (!when))) {
    var $x_1 = f();
  } else {
    this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = true;
    try {
      var result = f();
    } finally {
      this$2.Lcom_raquo_airstream_core_Transaction$onStart$__f_isSharedStart = false;
      $p_Lcom_raquo_airstream_core_Transaction$onStart$__resolve__V(this$2);
    }
    var $x_1 = result;
  }
  return $x_1;
}
export { $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement as $f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement };
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__willSetParent__s_Option__V($thiz, maybeNextParent) {
  if ($p_Lcom_raquo_laminar_nodes_ReactiveElement__isUnmounting__s_Option__s_Option__Z($thiz, $thiz.com$raquo$laminar$nodes$ChildNode$$_maybeParent__s_Option(), maybeNextParent)) {
    $p_Lcom_raquo_laminar_nodes_ReactiveElement__setPilotSubscriptionOwner__s_Option__V($thiz, maybeNextParent);
  }
}
export { $f_Lcom_raquo_laminar_nodes_ReactiveElement__willSetParent__s_Option__V as $f_Lcom_raquo_laminar_nodes_ReactiveElement__willSetParent__s_Option__V };
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__setParent__s_Option__V($thiz, maybeNextParent) {
  var maybePrevParent = $thiz.com$raquo$laminar$nodes$ChildNode$$_maybeParent__s_Option();
  $thiz.com$raquo$laminar$nodes$ChildNode$$_maybeParent_$eq__s_Option__V(maybeNextParent);
  if ((!$p_Lcom_raquo_laminar_nodes_ReactiveElement__isUnmounting__s_Option__s_Option__Z($thiz, maybePrevParent, maybeNextParent))) {
    $p_Lcom_raquo_laminar_nodes_ReactiveElement__setPilotSubscriptionOwner__s_Option__V($thiz, maybeNextParent);
  }
}
export { $f_Lcom_raquo_laminar_nodes_ReactiveElement__setParent__s_Option__V as $f_Lcom_raquo_laminar_nodes_ReactiveElement__setParent__s_Option__V };
function $p_Lcom_raquo_laminar_nodes_ReactiveElement__isUnmounting__s_Option__s_Option__Z($thiz, maybePrevParent, maybeNextParent) {
  if ((!maybePrevParent.isEmpty__Z())) {
    var x0 = maybePrevParent.get__O();
    var this$1 = x0.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner();
    var this$2 = this$1.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
    var isPrevParentActive = (!this$2.isEmpty__Z());
  } else {
    var isPrevParentActive = false;
  }
  if ((!maybeNextParent.isEmpty__Z())) {
    var x0$1 = maybeNextParent.get__O();
    var this$3 = x0$1.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner();
    var this$4 = this$3.Lcom_raquo_airstream_ownership_DynamicOwner__f__maybeCurrentOwner;
    var isNextParentActive = (!this$4.isEmpty__Z());
  } else {
    var isNextParentActive = false;
  }
  return (isPrevParentActive && (!isNextParentActive));
}
export { $p_Lcom_raquo_laminar_nodes_ReactiveElement__isUnmounting__s_Option__s_Option__Z as $p_Lcom_raquo_laminar_nodes_ReactiveElement__isUnmounting__s_Option__s_Option__Z };
function $p_Lcom_raquo_laminar_nodes_ReactiveElement__setPilotSubscriptionOwner__s_Option__V($thiz, maybeNextParent) {
  if (maybeNextParent.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = maybeNextParent.get__O();
    var $x_1 = new $c_s_Some(x0.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner());
  }
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__unsafeSetPilotSubscriptionOwner__s_Option__V($thiz, $x_1);
}
export { $p_Lcom_raquo_laminar_nodes_ReactiveElement__setPilotSubscriptionOwner__s_Option__V as $p_Lcom_raquo_laminar_nodes_ReactiveElement__setPilotSubscriptionOwner__s_Option__V };
function $f_Lcom_raquo_laminar_nodes_ReactiveElement__unsafeSetPilotSubscriptionOwner__s_Option__V($thiz, maybeNextOwner) {
  if (maybeNextOwner.isEmpty__Z()) {
    $thiz.com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription__Lcom_raquo_airstream_ownership_TransferableSubscription().clearOwner__V();
  } else {
    var x0 = maybeNextOwner.get__O();
    $thiz.com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription__Lcom_raquo_airstream_ownership_TransferableSubscription().setOwner__Lcom_raquo_airstream_ownership_DynamicOwner__V(x0);
  }
}
export { $f_Lcom_raquo_laminar_nodes_ReactiveElement__unsafeSetPilotSubscriptionOwner__s_Option__V as $f_Lcom_raquo_laminar_nodes_ReactiveElement__unsafeSetPilotSubscriptionOwner__s_Option__V };
var $d_Lcom_raquo_laminar_nodes_ReactiveElement = new $TypeData().initClass(1, "com.raquo.laminar.nodes.ReactiveElement", ({
  Lcom_raquo_laminar_nodes_ReactiveElement: 1,
  Lcom_raquo_laminar_nodes_ReactiveNode: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_nodes_ChildNode: 1,
  Lcom_raquo_laminar_nodes_ParentNode: 1
}));
export { $d_Lcom_raquo_laminar_nodes_ReactiveElement as $d_Lcom_raquo_laminar_nodes_ReactiveElement };
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1(reason$5) {
  this.Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1__f_reason$1 = null;
  this.Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1__f_reason$1 = reason$5;
}
export { $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 as $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 };
$c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype.constructor = $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1() {
}
export { $h_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 as $h_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 };
$h_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype = $c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype;
$c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    x._1__O();
    var r = x._2__O();
    var x$3 = this.Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1__f_reason$1;
    if ((r === x$3)) {
      return true;
    }
  }
  return false;
});
$c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var item = x._1__O();
    var r = x._2__O();
    var x$3 = this.Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1__f_reason$1;
    if ((r === x$3)) {
      return item;
    }
  }
  return default$1.apply__O__O(x);
});
$c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z(x);
});
$c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O(x, default$1);
});
var $d_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1, "com.raquo.laminar.nodes.ReactiveElement$$anon$1", ({
  Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 as $d_Lcom_raquo_laminar_nodes_ReactiveElement$$anon$1 };
/** @constructor */
function $c_Lframework_components_TextKind() {
}
export { $c_Lframework_components_TextKind as $c_Lframework_components_TextKind };
$c_Lframework_components_TextKind.prototype = new $h_O();
$c_Lframework_components_TextKind.prototype.constructor = $c_Lframework_components_TextKind;
/** @constructor */
function $h_Lframework_components_TextKind() {
}
export { $h_Lframework_components_TextKind as $h_Lframework_components_TextKind };
$h_Lframework_components_TextKind.prototype = $c_Lframework_components_TextKind.prototype;
$c_Lframework_components_TextKind.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
/** @constructor */
function $c_Lframework_data_PageCursor(cursor, pageSize) {
  this.Lframework_data_PageCursor__f_cursor = null;
  this.Lframework_data_PageCursor__f_pageSize = null;
  this.Lframework_data_PageCursor__f_cursor = cursor;
  this.Lframework_data_PageCursor__f_pageSize = pageSize;
}
export { $c_Lframework_data_PageCursor as $c_Lframework_data_PageCursor };
$c_Lframework_data_PageCursor.prototype = new $h_O();
$c_Lframework_data_PageCursor.prototype.constructor = $c_Lframework_data_PageCursor;
/** @constructor */
function $h_Lframework_data_PageCursor() {
}
export { $h_Lframework_data_PageCursor as $h_Lframework_data_PageCursor };
$h_Lframework_data_PageCursor.prototype = $c_Lframework_data_PageCursor.prototype;
$c_Lframework_data_PageCursor.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lframework_data_PageCursor.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1514305716), true);
});
$c_Lframework_data_PageCursor.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lframework_data_PageCursor)) {
    var x = this.Lframework_data_PageCursor__f_cursor;
    var x$2 = x$0.Lframework_data_PageCursor__f_cursor;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$1 = this.Lframework_data_PageCursor__f_pageSize;
      var y = x$0.Lframework_data_PageCursor__f_pageSize;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x$1, y);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lframework_data_PageCursor.prototype.productArity__I = (function() {
  return 2;
});
$c_Lframework_data_PageCursor.prototype.productPrefix__T = (function() {
  return "PageCursor";
});
$c_Lframework_data_PageCursor.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lframework_data_PageCursor__f_cursor;
  }
  if ((n === 1)) {
    return this.Lframework_data_PageCursor__f_pageSize;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_PageCursor.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "cursor";
  }
  if ((n === 1)) {
    return "pageSize";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lframework_data_PageCursor.prototype.toString__T = (function() {
  return (((("PageCursor(pageSize = " + this.Lframework_data_PageCursor__f_pageSize) + ", cursor = ") + this.Lframework_data_PageCursor__f_cursor) + ")");
});
$c_Lframework_data_PageCursor.prototype.pageIndex__I = (function() {
  var this$1 = this.Lframework_data_PageCursor__f_cursor;
  if (this$1.isEmpty__Z()) {
    return 0;
  } else {
    var x0 = this$1.get__O();
    return x0.Lframework_data_PageCursor$Cursor__f_index;
  }
});
$c_Lframework_data_PageCursor.prototype.firstPage__Lframework_data_PageCursor = (function() {
  var pageSize = this.Lframework_data_PageCursor__f_pageSize;
  var cursor = $m_s_None$();
  return new $c_Lframework_data_PageCursor(cursor, pageSize);
});
$c_Lframework_data_PageCursor.prototype.next__O__O__Lframework_data_PageCursor = (function(lastPrimary, lastSecondary) {
  var pageSize = this.Lframework_data_PageCursor__f_pageSize;
  return $m_Lframework_data_PageCursor$Builder$().next$extension__O__O__O__I__Lframework_data_PageCursor(pageSize, lastPrimary, lastSecondary, this.pageIndex__I());
});
$c_Lframework_data_PageCursor.prototype.previous__O__O__Lframework_data_PageCursor = (function(firstPrimaryColumn, firstSecondaryColumn) {
  var pageSize = this.Lframework_data_PageCursor__f_pageSize;
  return $m_Lframework_data_PageCursor$Builder$().previous$extension__O__O__O__I__Lframework_data_PageCursor(pageSize, firstPrimaryColumn, firstSecondaryColumn, this.pageIndex__I());
});
function $isArrayOf_Lframework_data_PageCursor(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_PageCursor)));
}
export { $isArrayOf_Lframework_data_PageCursor as $isArrayOf_Lframework_data_PageCursor };
var $d_Lframework_data_PageCursor = new $TypeData().initClass($c_Lframework_data_PageCursor, "framework.data.PageCursor", ({
  Lframework_data_PageCursor: 1,
  Lframework_data_PageCursor$PageIndex: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_PageCursor as $d_Lframework_data_PageCursor };
/** @constructor */
function $c_Lframework_data_PageCursor$$anon$15() {
}
export { $c_Lframework_data_PageCursor$$anon$15 as $c_Lframework_data_PageCursor$$anon$15 };
$c_Lframework_data_PageCursor$$anon$15.prototype = new $h_sr_AbstractPartialFunction();
$c_Lframework_data_PageCursor$$anon$15.prototype.constructor = $c_Lframework_data_PageCursor$$anon$15;
/** @constructor */
function $h_Lframework_data_PageCursor$$anon$15() {
}
export { $h_Lframework_data_PageCursor$$anon$15 as $h_Lframework_data_PageCursor$$anon$15 };
$h_Lframework_data_PageCursor$$anon$15.prototype = $c_Lframework_data_PageCursor$$anon$15.prototype;
$c_Lframework_data_PageCursor$$anon$15.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_Lframework_data_PageCursor$$anon$15.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (false ? x.name__T() : default$1.apply__O__O(x));
});
var $d_Lframework_data_PageCursor$$anon$15 = new $TypeData().initClass($c_Lframework_data_PageCursor$$anon$15, "framework.data.PageCursor$$anon$15", ({
  Lframework_data_PageCursor$$anon$15: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_PageCursor$$anon$15 as $d_Lframework_data_PageCursor$$anon$15 };
/** @constructor */
function $c_Lframework_data_PageCursor$$anon$16() {
}
export { $c_Lframework_data_PageCursor$$anon$16 as $c_Lframework_data_PageCursor$$anon$16 };
$c_Lframework_data_PageCursor$$anon$16.prototype = new $h_sr_AbstractPartialFunction();
$c_Lframework_data_PageCursor$$anon$16.prototype.constructor = $c_Lframework_data_PageCursor$$anon$16;
/** @constructor */
function $h_Lframework_data_PageCursor$$anon$16() {
}
export { $h_Lframework_data_PageCursor$$anon$16 as $h_Lframework_data_PageCursor$$anon$16 };
$h_Lframework_data_PageCursor$$anon$16.prototype = $c_Lframework_data_PageCursor$$anon$16.prototype;
$c_Lframework_data_PageCursor$$anon$16.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_Lframework_data_PageCursor$$anon$16.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (false ? x.name__T() : default$1.apply__O__O(x));
});
var $d_Lframework_data_PageCursor$$anon$16 = new $TypeData().initClass($c_Lframework_data_PageCursor$$anon$16, "framework.data.PageCursor$$anon$16", ({
  Lframework_data_PageCursor$$anon$16: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_PageCursor$$anon$16 as $d_Lframework_data_PageCursor$$anon$16 };
/** @constructor */
function $c_Lframework_data_PageCursor$$anon$4() {
}
export { $c_Lframework_data_PageCursor$$anon$4 as $c_Lframework_data_PageCursor$$anon$4 };
$c_Lframework_data_PageCursor$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$c_Lframework_data_PageCursor$$anon$4.prototype.constructor = $c_Lframework_data_PageCursor$$anon$4;
/** @constructor */
function $h_Lframework_data_PageCursor$$anon$4() {
}
export { $h_Lframework_data_PageCursor$$anon$4 as $h_Lframework_data_PageCursor$$anon$4 };
$h_Lframework_data_PageCursor$$anon$4.prototype = $c_Lframework_data_PageCursor$$anon$4.prototype;
$c_Lframework_data_PageCursor$$anon$4.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_Lframework_data_PageCursor$$anon$4.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (false ? x.name__T() : default$1.apply__O__O(x));
});
var $d_Lframework_data_PageCursor$$anon$4 = new $TypeData().initClass($c_Lframework_data_PageCursor$$anon$4, "framework.data.PageCursor$$anon$4", ({
  Lframework_data_PageCursor$$anon$4: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_PageCursor$$anon$4 as $d_Lframework_data_PageCursor$$anon$4 };
/** @constructor */
function $c_Lframework_data_PageCursor$$anon$5() {
}
export { $c_Lframework_data_PageCursor$$anon$5 as $c_Lframework_data_PageCursor$$anon$5 };
$c_Lframework_data_PageCursor$$anon$5.prototype = new $h_sr_AbstractPartialFunction();
$c_Lframework_data_PageCursor$$anon$5.prototype.constructor = $c_Lframework_data_PageCursor$$anon$5;
/** @constructor */
function $h_Lframework_data_PageCursor$$anon$5() {
}
export { $h_Lframework_data_PageCursor$$anon$5 as $h_Lframework_data_PageCursor$$anon$5 };
$h_Lframework_data_PageCursor$$anon$5.prototype = $c_Lframework_data_PageCursor$$anon$5.prototype;
$c_Lframework_data_PageCursor$$anon$5.prototype.isDefinedAt__O__Z = (function(x) {
  return false;
});
$c_Lframework_data_PageCursor$$anon$5.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return (false ? x.name__T() : default$1.apply__O__O(x));
});
var $d_Lframework_data_PageCursor$$anon$5 = new $TypeData().initClass($c_Lframework_data_PageCursor$$anon$5, "framework.data.PageCursor$$anon$5", ({
  Lframework_data_PageCursor$$anon$5: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_PageCursor$$anon$5 as $d_Lframework_data_PageCursor$$anon$5 };
/** @constructor */
function $c_Lframework_data_PageCursorDirection() {
}
export { $c_Lframework_data_PageCursorDirection as $c_Lframework_data_PageCursorDirection };
$c_Lframework_data_PageCursorDirection.prototype = new $h_O();
$c_Lframework_data_PageCursorDirection.prototype.constructor = $c_Lframework_data_PageCursorDirection;
/** @constructor */
function $h_Lframework_data_PageCursorDirection() {
}
export { $h_Lframework_data_PageCursorDirection as $h_Lframework_data_PageCursorDirection };
$h_Lframework_data_PageCursorDirection.prototype = $c_Lframework_data_PageCursorDirection.prototype;
$c_Lframework_data_PageCursorDirection.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $isArrayOf_Lframework_data_PageCursorDirection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_PageCursorDirection)));
}
export { $isArrayOf_Lframework_data_PageCursorDirection as $isArrayOf_Lframework_data_PageCursorDirection };
var $d_Lframework_data_PageCursorDirection = new $TypeData().initClass(0, "framework.data.PageCursorDirection", ({
  Lframework_data_PageCursorDirection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lframework_data_PageCursorDirection as $d_Lframework_data_PageCursorDirection };
/** @constructor */
function $c_Lframework_utils_CirceKeyCodec$$anon$1(f$3, g$3, outer) {
  this.Lframework_utils_CirceKeyCodec$$anon$1__f_f$1 = null;
  this.Lframework_utils_CirceKeyCodec$$anon$1__f_g$1 = null;
  this.Lframework_utils_CirceKeyCodec$$anon$1__f_$outer = null;
  this.Lframework_utils_CirceKeyCodec$$anon$1__f_f$1 = f$3;
  this.Lframework_utils_CirceKeyCodec$$anon$1__f_g$1 = g$3;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lframework_utils_CirceKeyCodec$$anon$1__f_$outer = outer;
}
export { $c_Lframework_utils_CirceKeyCodec$$anon$1 as $c_Lframework_utils_CirceKeyCodec$$anon$1 };
$c_Lframework_utils_CirceKeyCodec$$anon$1.prototype = new $h_O();
$c_Lframework_utils_CirceKeyCodec$$anon$1.prototype.constructor = $c_Lframework_utils_CirceKeyCodec$$anon$1;
/** @constructor */
function $h_Lframework_utils_CirceKeyCodec$$anon$1() {
}
export { $h_Lframework_utils_CirceKeyCodec$$anon$1 as $h_Lframework_utils_CirceKeyCodec$$anon$1 };
$h_Lframework_utils_CirceKeyCodec$$anon$1.prototype = $c_Lframework_utils_CirceKeyCodec$$anon$1.prototype;
$c_Lframework_utils_CirceKeyCodec$$anon$1.prototype.apply__T__s_Option = (function(key) {
  var this$1 = this.Lframework_utils_CirceKeyCodec$$anon$1__f_$outer.apply__T__s_Option(key);
  var f = this.Lframework_utils_CirceKeyCodec$$anon$1__f_f$1;
  return (this$1.isEmpty__Z() ? $m_s_None$() : f.apply__O__O(this$1.get__O()));
});
$c_Lframework_utils_CirceKeyCodec$$anon$1.prototype.apply__O__T = (function(key) {
  return this.Lframework_utils_CirceKeyCodec$$anon$1__f_$outer.apply__O__T(this.Lframework_utils_CirceKeyCodec$$anon$1__f_g$1.apply__O__O(key));
});
var $d_Lframework_utils_CirceKeyCodec$$anon$1 = new $TypeData().initClass($c_Lframework_utils_CirceKeyCodec$$anon$1, "framework.utils.CirceKeyCodec$$anon$1", ({
  Lframework_utils_CirceKeyCodec$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1,
  Lio_circe_KeyEncoder: 1,
  Lframework_utils_CirceKeyCodec: 1
}));
export { $d_Lframework_utils_CirceKeyCodec$$anon$1 as $d_Lframework_utils_CirceKeyCodec$$anon$1 };
/** @constructor */
function $c_Lframework_utils_CirceKeyCodec$$anon$2(decode$2, encode$2) {
  this.Lframework_utils_CirceKeyCodec$$anon$2__f_decode$1 = null;
  this.Lframework_utils_CirceKeyCodec$$anon$2__f_encode$1 = null;
  this.Lframework_utils_CirceKeyCodec$$anon$2__f_decode$1 = decode$2;
  this.Lframework_utils_CirceKeyCodec$$anon$2__f_encode$1 = encode$2;
}
export { $c_Lframework_utils_CirceKeyCodec$$anon$2 as $c_Lframework_utils_CirceKeyCodec$$anon$2 };
$c_Lframework_utils_CirceKeyCodec$$anon$2.prototype = new $h_O();
$c_Lframework_utils_CirceKeyCodec$$anon$2.prototype.constructor = $c_Lframework_utils_CirceKeyCodec$$anon$2;
/** @constructor */
function $h_Lframework_utils_CirceKeyCodec$$anon$2() {
}
export { $h_Lframework_utils_CirceKeyCodec$$anon$2 as $h_Lframework_utils_CirceKeyCodec$$anon$2 };
$h_Lframework_utils_CirceKeyCodec$$anon$2.prototype = $c_Lframework_utils_CirceKeyCodec$$anon$2.prototype;
$c_Lframework_utils_CirceKeyCodec$$anon$2.prototype.apply__T__s_Option = (function(key) {
  return this.Lframework_utils_CirceKeyCodec$$anon$2__f_decode$1.apply__O__O(key);
});
$c_Lframework_utils_CirceKeyCodec$$anon$2.prototype.apply__O__T = (function(key) {
  return this.Lframework_utils_CirceKeyCodec$$anon$2__f_encode$1.apply__O__O(key);
});
var $d_Lframework_utils_CirceKeyCodec$$anon$2 = new $TypeData().initClass($c_Lframework_utils_CirceKeyCodec$$anon$2, "framework.utils.CirceKeyCodec$$anon$2", ({
  Lframework_utils_CirceKeyCodec$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_KeyDecoder: 1,
  Lio_circe_KeyEncoder: 1,
  Lframework_utils_CirceKeyCodec: 1
}));
export { $d_Lframework_utils_CirceKeyCodec$$anon$2 as $d_Lframework_utils_CirceKeyCodec$$anon$2 };
/** @constructor */
function $c_Lio_circe_Codec$() {
  this.Lio_circe_Codec$__f_codecInvariant = null;
  $n_Lio_circe_Codec$ = this;
  this.Lio_circe_Codec$__f_codecInvariant = new $c_Lio_circe_Codec$$anon$1();
}
export { $c_Lio_circe_Codec$ as $c_Lio_circe_Codec$ };
$c_Lio_circe_Codec$.prototype = new $h_O();
$c_Lio_circe_Codec$.prototype.constructor = $c_Lio_circe_Codec$;
/** @constructor */
function $h_Lio_circe_Codec$() {
}
export { $h_Lio_circe_Codec$ as $h_Lio_circe_Codec$ };
$h_Lio_circe_Codec$.prototype = $c_Lio_circe_Codec$.prototype;
var $d_Lio_circe_Codec$ = new $TypeData().initClass($c_Lio_circe_Codec$, "io.circe.Codec$", ({
  Lio_circe_Codec$: 1,
  Lio_circe_ProductCodecs: 1,
  Lio_circe_ProductTypedCodecs: 1,
  Lio_circe_EnumerationCodecs: 1,
  Lio_circe_CodecDerivationRelaxed: 1
}));
export { $d_Lio_circe_Codec$ as $d_Lio_circe_Codec$ };
var $n_Lio_circe_Codec$;
function $m_Lio_circe_Codec$() {
  if ((!$n_Lio_circe_Codec$)) {
    $n_Lio_circe_Codec$ = new $c_Lio_circe_Codec$();
  }
  return $n_Lio_circe_Codec$;
}
export { $m_Lio_circe_Codec$ as $m_Lio_circe_Codec$ };
/** @constructor */
function $c_Lio_circe_Codec$$anon$4(decodeA$6, encodeA$6) {
  this.Lio_circe_Codec$$anon$4__f_decodeA$3 = null;
  this.Lio_circe_Codec$$anon$4__f_encodeA$3 = null;
  this.Lio_circe_Codec$$anon$4__f_decodeA$3 = decodeA$6;
  this.Lio_circe_Codec$$anon$4__f_encodeA$3 = encodeA$6;
}
export { $c_Lio_circe_Codec$$anon$4 as $c_Lio_circe_Codec$$anon$4 };
$c_Lio_circe_Codec$$anon$4.prototype = new $h_O();
$c_Lio_circe_Codec$$anon$4.prototype.constructor = $c_Lio_circe_Codec$$anon$4;
/** @constructor */
function $h_Lio_circe_Codec$$anon$4() {
}
export { $h_Lio_circe_Codec$$anon$4 as $h_Lio_circe_Codec$$anon$4 };
$h_Lio_circe_Codec$$anon$4.prototype = $c_Lio_circe_Codec$$anon$4.prototype;
$c_Lio_circe_Codec$$anon$4.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  return this.Lio_circe_Codec$$anon$4__f_decodeA$3.apply__Lio_circe_HCursor__s_util_Either(c);
});
$c_Lio_circe_Codec$$anon$4.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return this.Lio_circe_Codec$$anon$4__f_decodeA$3.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(c);
});
$c_Lio_circe_Codec$$anon$4.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return this.Lio_circe_Codec$$anon$4__f_decodeA$3.tryDecode__Lio_circe_ACursor__s_util_Either(c);
});
$c_Lio_circe_Codec$$anon$4.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return this.Lio_circe_Codec$$anon$4__f_decodeA$3.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(c);
});
$c_Lio_circe_Codec$$anon$4.prototype.apply__O__Lio_circe_Json = (function(a) {
  return this.Lio_circe_Codec$$anon$4__f_encodeA$3.apply__O__Lio_circe_Json(a);
});
var $d_Lio_circe_Codec$$anon$4 = new $TypeData().initClass($c_Lio_circe_Codec$$anon$4, "io.circe.Codec$$anon$4", ({
  Lio_circe_Codec$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Codec: 1
}));
export { $d_Lio_circe_Codec$$anon$4 as $d_Lio_circe_Codec$$anon$4 };
/** @constructor */
function $c_Lio_circe_CursorOp$ArrayOp() {
}
export { $c_Lio_circe_CursorOp$ArrayOp as $c_Lio_circe_CursorOp$ArrayOp };
$c_Lio_circe_CursorOp$ArrayOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$ArrayOp.prototype.constructor = $c_Lio_circe_CursorOp$ArrayOp;
/** @constructor */
function $h_Lio_circe_CursorOp$ArrayOp() {
}
export { $h_Lio_circe_CursorOp$ArrayOp as $h_Lio_circe_CursorOp$ArrayOp };
$h_Lio_circe_CursorOp$ArrayOp.prototype = $c_Lio_circe_CursorOp$ArrayOp.prototype;
$c_Lio_circe_CursorOp$ArrayOp.prototype.requiresObject__Z = (function() {
  return false;
});
$c_Lio_circe_CursorOp$ArrayOp.prototype.requiresArray__Z = (function() {
  return true;
});
function $isArrayOf_Lio_circe_CursorOp$ArrayOp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$ArrayOp)));
}
export { $isArrayOf_Lio_circe_CursorOp$ArrayOp as $isArrayOf_Lio_circe_CursorOp$ArrayOp };
/** @constructor */
function $c_Lio_circe_CursorOp$ObjectOp() {
}
export { $c_Lio_circe_CursorOp$ObjectOp as $c_Lio_circe_CursorOp$ObjectOp };
$c_Lio_circe_CursorOp$ObjectOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$ObjectOp.prototype.constructor = $c_Lio_circe_CursorOp$ObjectOp;
/** @constructor */
function $h_Lio_circe_CursorOp$ObjectOp() {
}
export { $h_Lio_circe_CursorOp$ObjectOp as $h_Lio_circe_CursorOp$ObjectOp };
$h_Lio_circe_CursorOp$ObjectOp.prototype = $c_Lio_circe_CursorOp$ObjectOp.prototype;
$c_Lio_circe_CursorOp$ObjectOp.prototype.requiresObject__Z = (function() {
  return true;
});
$c_Lio_circe_CursorOp$ObjectOp.prototype.requiresArray__Z = (function() {
  return false;
});
function $isArrayOf_Lio_circe_CursorOp$ObjectOp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$ObjectOp)));
}
export { $isArrayOf_Lio_circe_CursorOp$ObjectOp as $isArrayOf_Lio_circe_CursorOp$ObjectOp };
/** @constructor */
function $c_Lio_circe_CursorOp$Op(op) {
  this.Lio_circe_CursorOp$Op__f_op = null;
  this.Lio_circe_CursorOp$Op__f_op = op;
}
export { $c_Lio_circe_CursorOp$Op as $c_Lio_circe_CursorOp$Op };
$c_Lio_circe_CursorOp$Op.prototype = new $h_O();
$c_Lio_circe_CursorOp$Op.prototype.constructor = $c_Lio_circe_CursorOp$Op;
/** @constructor */
function $h_Lio_circe_CursorOp$Op() {
}
export { $h_Lio_circe_CursorOp$Op as $h_Lio_circe_CursorOp$Op };
$h_Lio_circe_CursorOp$Op.prototype = $c_Lio_circe_CursorOp$Op.prototype;
$c_Lio_circe_CursorOp$Op.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_CursorOp$Op.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_circe_CursorOp$Op.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_circe_CursorOp$Op)) {
    var x = this.Lio_circe_CursorOp$Op__f_op;
    var x$2 = x$0.Lio_circe_CursorOp$Op__f_op;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lio_circe_CursorOp$Op.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_CursorOp$Op.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_CursorOp$Op.prototype.productPrefix__T = (function() {
  return "Op";
});
$c_Lio_circe_CursorOp$Op.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_CursorOp$Op__f_op;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$Op.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "op";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_circe_CursorOp$Op(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$Op)));
}
export { $isArrayOf_Lio_circe_CursorOp$Op as $isArrayOf_Lio_circe_CursorOp$Op };
var $d_Lio_circe_CursorOp$Op = new $TypeData().initClass($c_Lio_circe_CursorOp$Op, "io.circe.CursorOp$Op", ({
  Lio_circe_CursorOp$Op: 1,
  Lio_circe_CursorOp$Selection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_CursorOp$Op as $d_Lio_circe_CursorOp$Op };
/** @constructor */
function $c_Lio_circe_CursorOp$SelectField(field) {
  this.Lio_circe_CursorOp$SelectField__f_field = null;
  this.Lio_circe_CursorOp$SelectField__f_field = field;
}
export { $c_Lio_circe_CursorOp$SelectField as $c_Lio_circe_CursorOp$SelectField };
$c_Lio_circe_CursorOp$SelectField.prototype = new $h_O();
$c_Lio_circe_CursorOp$SelectField.prototype.constructor = $c_Lio_circe_CursorOp$SelectField;
/** @constructor */
function $h_Lio_circe_CursorOp$SelectField() {
}
export { $h_Lio_circe_CursorOp$SelectField as $h_Lio_circe_CursorOp$SelectField };
$h_Lio_circe_CursorOp$SelectField.prototype = $c_Lio_circe_CursorOp$SelectField.prototype;
$c_Lio_circe_CursorOp$SelectField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_CursorOp$SelectField.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_circe_CursorOp$SelectField.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_circe_CursorOp$SelectField) && (this.Lio_circe_CursorOp$SelectField__f_field === x$0.Lio_circe_CursorOp$SelectField__f_field)));
});
$c_Lio_circe_CursorOp$SelectField.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_CursorOp$SelectField.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_CursorOp$SelectField.prototype.productPrefix__T = (function() {
  return "SelectField";
});
$c_Lio_circe_CursorOp$SelectField.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_CursorOp$SelectField__f_field;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$SelectField.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "field";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_circe_CursorOp$SelectField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$SelectField)));
}
export { $isArrayOf_Lio_circe_CursorOp$SelectField as $isArrayOf_Lio_circe_CursorOp$SelectField };
var $d_Lio_circe_CursorOp$SelectField = new $TypeData().initClass($c_Lio_circe_CursorOp$SelectField, "io.circe.CursorOp$SelectField", ({
  Lio_circe_CursorOp$SelectField: 1,
  Lio_circe_CursorOp$Selection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_CursorOp$SelectField as $d_Lio_circe_CursorOp$SelectField };
/** @constructor */
function $c_Lio_circe_CursorOp$SelectIndex(index) {
  this.Lio_circe_CursorOp$SelectIndex__f_index = 0;
  this.Lio_circe_CursorOp$SelectIndex__f_index = index;
}
export { $c_Lio_circe_CursorOp$SelectIndex as $c_Lio_circe_CursorOp$SelectIndex };
$c_Lio_circe_CursorOp$SelectIndex.prototype = new $h_O();
$c_Lio_circe_CursorOp$SelectIndex.prototype.constructor = $c_Lio_circe_CursorOp$SelectIndex;
/** @constructor */
function $h_Lio_circe_CursorOp$SelectIndex() {
}
export { $h_Lio_circe_CursorOp$SelectIndex as $h_Lio_circe_CursorOp$SelectIndex };
$h_Lio_circe_CursorOp$SelectIndex.prototype = $c_Lio_circe_CursorOp$SelectIndex.prototype;
$c_Lio_circe_CursorOp$SelectIndex.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("SelectIndex");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lio_circe_CursorOp$SelectIndex__f_index;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_circe_CursorOp$SelectIndex) && (this.Lio_circe_CursorOp$SelectIndex__f_index === x$0.Lio_circe_CursorOp$SelectIndex__f_index)));
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.productPrefix__T = (function() {
  return "SelectIndex";
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_CursorOp$SelectIndex__f_index;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$SelectIndex.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_circe_CursorOp$SelectIndex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$SelectIndex)));
}
export { $isArrayOf_Lio_circe_CursorOp$SelectIndex as $isArrayOf_Lio_circe_CursorOp$SelectIndex };
var $d_Lio_circe_CursorOp$SelectIndex = new $TypeData().initClass($c_Lio_circe_CursorOp$SelectIndex, "io.circe.CursorOp$SelectIndex", ({
  Lio_circe_CursorOp$SelectIndex: 1,
  Lio_circe_CursorOp$Selection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_CursorOp$SelectIndex as $d_Lio_circe_CursorOp$SelectIndex };
/** @constructor */
function $c_Lio_circe_CursorOp$UnconstrainedOp() {
}
export { $c_Lio_circe_CursorOp$UnconstrainedOp as $c_Lio_circe_CursorOp$UnconstrainedOp };
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype = new $h_Lio_circe_CursorOp();
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype.constructor = $c_Lio_circe_CursorOp$UnconstrainedOp;
/** @constructor */
function $h_Lio_circe_CursorOp$UnconstrainedOp() {
}
export { $h_Lio_circe_CursorOp$UnconstrainedOp as $h_Lio_circe_CursorOp$UnconstrainedOp };
$h_Lio_circe_CursorOp$UnconstrainedOp.prototype = $c_Lio_circe_CursorOp$UnconstrainedOp.prototype;
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype.requiresObject__Z = (function() {
  return false;
});
$c_Lio_circe_CursorOp$UnconstrainedOp.prototype.requiresArray__Z = (function() {
  return false;
});
function $isArrayOf_Lio_circe_CursorOp$UnconstrainedOp(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$UnconstrainedOp)));
}
export { $isArrayOf_Lio_circe_CursorOp$UnconstrainedOp as $isArrayOf_Lio_circe_CursorOp$UnconstrainedOp };
function $ct_Lio_circe_DecodingFailure__Lcats_Eval__($thiz, lazyReason) {
  $thiz.Lio_circe_DecodingFailure__f_lazyReason = lazyReason;
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
export { $ct_Lio_circe_DecodingFailure__Lcats_Eval__ as $ct_Lio_circe_DecodingFailure__Lcats_Eval__ };
class $c_Lio_circe_DecodingFailure extends $c_Lio_circe_Error {
  constructor() {
    super();
    this.Lio_circe_DecodingFailure__f_lazyReason = null;
  }
  message__T() {
    var x18 = this.Lio_circe_DecodingFailure__f_lazyReason.value__O();
    if ((x18 instanceof $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation)) {
      var x24 = x18.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType;
      var x25 = x18.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue;
      return ((("Got value '" + $m_Lio_circe_Printer$().Lio_circe_Printer$__f_noSpaces.print__Lio_circe_Json__T(x25)) + "' with wrong type, expecting ") + x24);
    }
    var x = $m_Lio_circe_DecodingFailure$Reason$MissingField$();
    if ((x === x18)) {
      return "Missing required field";
    }
    if ((x18 instanceof $c_Lio_circe_DecodingFailure$Reason$CustomReason)) {
      var x21 = x18.Lio_circe_DecodingFailure$Reason$CustomReason__f_message;
      return x21;
    }
    throw new $c_s_MatchError(x18);
  }
  getMessage__T() {
    return $m_Lio_circe_DecodingFailure$().Lio_circe_DecodingFailure$__f_showDecodingFailure.show__O__T(this);
  }
  copy__T__F0__Lio_circe_DecodingFailure(message, history) {
    return $m_Lio_circe_DecodingFailure$().apply__Lio_circe_DecodingFailure$Reason__F0__Lio_circe_DecodingFailure(new $c_Lio_circe_DecodingFailure$Reason$CustomReason(message), history);
  }
  toString__T() {
    var this$1 = this.pathToRootString__s_Option();
    if (this$1.isEmpty__Z()) {
      return (((("DecodingFailure(" + this.message__T()) + ", ") + this.history__sci_List()) + ")");
    } else {
      var x0 = this$1.get__O();
      return ((("DecodingFailure at " + x0) + ": ") + this.message__T());
    }
  }
  equals__O__Z(that) {
    return ((that instanceof $c_Lio_circe_DecodingFailure) && $m_Lio_circe_DecodingFailure$().Lio_circe_DecodingFailure$__f_eqDecodingFailure.eqv__O__O__Z(this, that));
  }
  hashCode__I() {
    return $f_T__hashCode__I(this.message__T());
  }
}
export { $c_Lio_circe_DecodingFailure as $c_Lio_circe_DecodingFailure };
function $isArrayOf_Lio_circe_DecodingFailure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_DecodingFailure)));
}
export { $isArrayOf_Lio_circe_DecodingFailure as $isArrayOf_Lio_circe_DecodingFailure };
/** @constructor */
function $c_Lio_circe_DecodingFailure$Reason$CustomReason(message) {
  this.Lio_circe_DecodingFailure$Reason$CustomReason__f_message = null;
  this.Lio_circe_DecodingFailure$Reason$CustomReason__f_message = message;
}
export { $c_Lio_circe_DecodingFailure$Reason$CustomReason as $c_Lio_circe_DecodingFailure$Reason$CustomReason };
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype = new $h_Lio_circe_DecodingFailure$Reason();
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.constructor = $c_Lio_circe_DecodingFailure$Reason$CustomReason;
/** @constructor */
function $h_Lio_circe_DecodingFailure$Reason$CustomReason() {
}
export { $h_Lio_circe_DecodingFailure$Reason$CustomReason as $h_Lio_circe_DecodingFailure$Reason$CustomReason };
$h_Lio_circe_DecodingFailure$Reason$CustomReason.prototype = $c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype;
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_circe_DecodingFailure$Reason$CustomReason) && (this.Lio_circe_DecodingFailure$Reason$CustomReason__f_message === x$0.Lio_circe_DecodingFailure$Reason$CustomReason__f_message)));
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.productPrefix__T = (function() {
  return "CustomReason";
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_DecodingFailure$Reason$CustomReason__f_message;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_DecodingFailure$Reason$CustomReason.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "message";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_circe_DecodingFailure$Reason$CustomReason(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_DecodingFailure$Reason$CustomReason)));
}
export { $isArrayOf_Lio_circe_DecodingFailure$Reason$CustomReason as $isArrayOf_Lio_circe_DecodingFailure$Reason$CustomReason };
var $d_Lio_circe_DecodingFailure$Reason$CustomReason = new $TypeData().initClass($c_Lio_circe_DecodingFailure$Reason$CustomReason, "io.circe.DecodingFailure$Reason$CustomReason", ({
  Lio_circe_DecodingFailure$Reason$CustomReason: 1,
  Lio_circe_DecodingFailure$Reason: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_DecodingFailure$Reason$CustomReason as $d_Lio_circe_DecodingFailure$Reason$CustomReason };
/** @constructor */
function $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation(expectedJsonFieldType, jsonValue) {
  this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType = null;
  this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue = null;
  this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType = expectedJsonFieldType;
  this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue = jsonValue;
}
export { $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation as $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation };
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype = new $h_Lio_circe_DecodingFailure$Reason();
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.constructor = $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation;
/** @constructor */
function $h_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation() {
}
export { $h_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation as $h_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation };
$h_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype = $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype;
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation)) {
    if ((this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType === x$0.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType)) {
      var x = this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue;
      var x$2 = x$0.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.productArity__I = (function() {
  return 2;
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.productPrefix__T = (function() {
  return "WrongTypeExpectation";
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_expectedJsonFieldType;
  }
  if ((n === 1)) {
    return this.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation__f_jsonValue;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "expectedJsonFieldType";
  }
  if ((n === 1)) {
    return "jsonValue";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_DecodingFailure$Reason$WrongTypeExpectation)));
}
export { $isArrayOf_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation as $isArrayOf_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation };
var $d_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation = new $TypeData().initClass($c_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation, "io.circe.DecodingFailure$Reason$WrongTypeExpectation", ({
  Lio_circe_DecodingFailure$Reason$WrongTypeExpectation: 1,
  Lio_circe_DecodingFailure$Reason: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation as $d_Lio_circe_DecodingFailure$Reason$WrongTypeExpectation };
function $ct_Lio_circe_Encoder$IterableAsObjectEncoder__Lio_circe_KeyEncoder__Lio_circe_Encoder__($thiz, encodeK, encodeV) {
  $thiz.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeK = encodeK;
  $thiz.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeV = encodeV;
  return $thiz;
}
export { $ct_Lio_circe_Encoder$IterableAsObjectEncoder__Lio_circe_KeyEncoder__Lio_circe_Encoder__ as $ct_Lio_circe_Encoder$IterableAsObjectEncoder__Lio_circe_KeyEncoder__Lio_circe_Encoder__ };
/** @constructor */
function $c_Lio_circe_Encoder$IterableAsObjectEncoder() {
  this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeK = null;
  this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeV = null;
}
export { $c_Lio_circe_Encoder$IterableAsObjectEncoder as $c_Lio_circe_Encoder$IterableAsObjectEncoder };
$c_Lio_circe_Encoder$IterableAsObjectEncoder.prototype = new $h_O();
$c_Lio_circe_Encoder$IterableAsObjectEncoder.prototype.constructor = $c_Lio_circe_Encoder$IterableAsObjectEncoder;
/** @constructor */
function $h_Lio_circe_Encoder$IterableAsObjectEncoder() {
}
export { $h_Lio_circe_Encoder$IterableAsObjectEncoder as $h_Lio_circe_Encoder$IterableAsObjectEncoder };
$h_Lio_circe_Encoder$IterableAsObjectEncoder.prototype = $c_Lio_circe_Encoder$IterableAsObjectEncoder.prototype;
$c_Lio_circe_Encoder$IterableAsObjectEncoder.prototype.apply__O__Lio_circe_Json = (function(a) {
  return $f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$c_Lio_circe_Encoder$IterableAsObjectEncoder.prototype.encodeObject__O__Lio_circe_JsonObject = (function(a) {
  var builder = new $c_sci_MapBuilderImpl();
  $m_sci_Vector$();
  var keysBuilder = new $c_sci_VectorBuilder();
  var iterator = this.toIterator__sc_Map__sc_Iterator(a);
  while (iterator.hasNext__Z()) {
    var next = iterator.next__O();
    var key = this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeK.apply__O__T(next._1__O());
    var _2 = this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeV.apply__O__Lio_circe_Json(next._2__O());
    builder.addOne__O__O__sci_MapBuilderImpl(key, _2);
    keysBuilder.addOne__O__sci_VectorBuilder(key);
  }
  $m_Lio_circe_JsonObject$();
  var map = builder.result__sci_Map();
  var keys = keysBuilder.result__sci_Vector();
  return new $c_Lio_circe_JsonObject$MapAndVectorJsonObject(map, keys);
});
/** @constructor */
function $c_Lio_circe_Json$JArray(value) {
  this.Lio_circe_Json$JArray__f_value = null;
  this.Lio_circe_Json$JArray__f_value = value;
}
export { $c_Lio_circe_Json$JArray as $c_Lio_circe_Json$JArray };
$c_Lio_circe_Json$JArray.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JArray.prototype.constructor = $c_Lio_circe_Json$JArray;
/** @constructor */
function $h_Lio_circe_Json$JArray() {
}
export { $h_Lio_circe_Json$JArray as $h_Lio_circe_Json$JArray };
$h_Lio_circe_Json$JArray.prototype = $c_Lio_circe_Json$JArray.prototype;
$c_Lio_circe_Json$JArray.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_circe_Json$JArray.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_Json$JArray.prototype.productPrefix__T = (function() {
  return "JArray";
});
$c_Lio_circe_Json$JArray.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JArray__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JArray.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JArray.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onArray__sci_Vector__O(this.Lio_circe_Json$JArray__f_value);
});
$c_Lio_circe_Json$JArray.prototype.isNull__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JArray.prototype.isArray__Z = (function() {
  return true;
});
$c_Lio_circe_Json$JArray.prototype.isObject__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JArray.prototype.asArray__s_Option = (function() {
  var value = this.Lio_circe_Json$JArray__f_value;
  return new $c_s_Some(value);
});
$c_Lio_circe_Json$JArray.prototype.asObject__s_Option = (function() {
  return $m_s_None$();
});
function $isArrayOf_Lio_circe_Json$JArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JArray)));
}
export { $isArrayOf_Lio_circe_Json$JArray as $isArrayOf_Lio_circe_Json$JArray };
var $d_Lio_circe_Json$JArray = new $TypeData().initClass($c_Lio_circe_Json$JArray, "io.circe.Json$JArray", ({
  Lio_circe_Json$JArray: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_Json$JArray as $d_Lio_circe_Json$JArray };
/** @constructor */
function $c_Lio_circe_Json$JBoolean(value) {
  this.Lio_circe_Json$JBoolean__f_value = false;
  this.Lio_circe_Json$JBoolean__f_value = value;
}
export { $c_Lio_circe_Json$JBoolean as $c_Lio_circe_Json$JBoolean };
$c_Lio_circe_Json$JBoolean.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JBoolean.prototype.constructor = $c_Lio_circe_Json$JBoolean;
/** @constructor */
function $h_Lio_circe_Json$JBoolean() {
}
export { $h_Lio_circe_Json$JBoolean as $h_Lio_circe_Json$JBoolean };
$h_Lio_circe_Json$JBoolean.prototype = $c_Lio_circe_Json$JBoolean.prototype;
$c_Lio_circe_Json$JBoolean.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("JBoolean");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = (this.Lio_circe_Json$JBoolean__f_value ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lio_circe_Json$JBoolean.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_Json$JBoolean.prototype.productPrefix__T = (function() {
  return "JBoolean";
});
$c_Lio_circe_Json$JBoolean.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JBoolean__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JBoolean.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JBoolean.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onBoolean__Z__O(this.Lio_circe_Json$JBoolean__f_value);
});
$c_Lio_circe_Json$JBoolean.prototype.isNull__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JBoolean.prototype.isArray__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JBoolean.prototype.isObject__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JBoolean.prototype.asArray__s_Option = (function() {
  return $m_s_None$();
});
$c_Lio_circe_Json$JBoolean.prototype.asObject__s_Option = (function() {
  return $m_s_None$();
});
function $isArrayOf_Lio_circe_Json$JBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JBoolean)));
}
export { $isArrayOf_Lio_circe_Json$JBoolean as $isArrayOf_Lio_circe_Json$JBoolean };
var $d_Lio_circe_Json$JBoolean = new $TypeData().initClass($c_Lio_circe_Json$JBoolean, "io.circe.Json$JBoolean", ({
  Lio_circe_Json$JBoolean: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_Json$JBoolean as $d_Lio_circe_Json$JBoolean };
/** @constructor */
function $c_Lio_circe_Json$JNumber(value) {
  this.Lio_circe_Json$JNumber__f_value = null;
  this.Lio_circe_Json$JNumber__f_value = value;
}
export { $c_Lio_circe_Json$JNumber as $c_Lio_circe_Json$JNumber };
$c_Lio_circe_Json$JNumber.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JNumber.prototype.constructor = $c_Lio_circe_Json$JNumber;
/** @constructor */
function $h_Lio_circe_Json$JNumber() {
}
export { $h_Lio_circe_Json$JNumber as $h_Lio_circe_Json$JNumber };
$h_Lio_circe_Json$JNumber.prototype = $c_Lio_circe_Json$JNumber.prototype;
$c_Lio_circe_Json$JNumber.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_circe_Json$JNumber.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_Json$JNumber.prototype.productPrefix__T = (function() {
  return "JNumber";
});
$c_Lio_circe_Json$JNumber.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JNumber__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JNumber.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JNumber.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onNumber__Lio_circe_JsonNumber__O(this.Lio_circe_Json$JNumber__f_value);
});
$c_Lio_circe_Json$JNumber.prototype.isNull__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JNumber.prototype.isArray__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JNumber.prototype.isObject__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JNumber.prototype.asArray__s_Option = (function() {
  return $m_s_None$();
});
$c_Lio_circe_Json$JNumber.prototype.asObject__s_Option = (function() {
  return $m_s_None$();
});
function $isArrayOf_Lio_circe_Json$JNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JNumber)));
}
export { $isArrayOf_Lio_circe_Json$JNumber as $isArrayOf_Lio_circe_Json$JNumber };
var $d_Lio_circe_Json$JNumber = new $TypeData().initClass($c_Lio_circe_Json$JNumber, "io.circe.Json$JNumber", ({
  Lio_circe_Json$JNumber: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_Json$JNumber as $d_Lio_circe_Json$JNumber };
/** @constructor */
function $c_Lio_circe_Json$JObject(value) {
  this.Lio_circe_Json$JObject__f_value = null;
  this.Lio_circe_Json$JObject__f_value = value;
}
export { $c_Lio_circe_Json$JObject as $c_Lio_circe_Json$JObject };
$c_Lio_circe_Json$JObject.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JObject.prototype.constructor = $c_Lio_circe_Json$JObject;
/** @constructor */
function $h_Lio_circe_Json$JObject() {
}
export { $h_Lio_circe_Json$JObject as $h_Lio_circe_Json$JObject };
$h_Lio_circe_Json$JObject.prototype = $c_Lio_circe_Json$JObject.prototype;
$c_Lio_circe_Json$JObject.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_circe_Json$JObject.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_Json$JObject.prototype.productPrefix__T = (function() {
  return "JObject";
});
$c_Lio_circe_Json$JObject.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JObject__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JObject.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JObject.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onObject__Lio_circe_JsonObject__O(this.Lio_circe_Json$JObject__f_value);
});
$c_Lio_circe_Json$JObject.prototype.isNull__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JObject.prototype.isArray__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JObject.prototype.isObject__Z = (function() {
  return true;
});
$c_Lio_circe_Json$JObject.prototype.asArray__s_Option = (function() {
  return $m_s_None$();
});
$c_Lio_circe_Json$JObject.prototype.asObject__s_Option = (function() {
  var value = this.Lio_circe_Json$JObject__f_value;
  return new $c_s_Some(value);
});
function $isArrayOf_Lio_circe_Json$JObject(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JObject)));
}
export { $isArrayOf_Lio_circe_Json$JObject as $isArrayOf_Lio_circe_Json$JObject };
var $d_Lio_circe_Json$JObject = new $TypeData().initClass($c_Lio_circe_Json$JObject, "io.circe.Json$JObject", ({
  Lio_circe_Json$JObject: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_Json$JObject as $d_Lio_circe_Json$JObject };
/** @constructor */
function $c_Lio_circe_Json$JString(value) {
  this.Lio_circe_Json$JString__f_value = null;
  this.Lio_circe_Json$JString__f_value = value;
}
export { $c_Lio_circe_Json$JString as $c_Lio_circe_Json$JString };
$c_Lio_circe_Json$JString.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JString.prototype.constructor = $c_Lio_circe_Json$JString;
/** @constructor */
function $h_Lio_circe_Json$JString() {
}
export { $h_Lio_circe_Json$JString as $h_Lio_circe_Json$JString };
$h_Lio_circe_Json$JString.prototype = $c_Lio_circe_Json$JString.prototype;
$c_Lio_circe_Json$JString.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_circe_Json$JString.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_Json$JString.prototype.productPrefix__T = (function() {
  return "JString";
});
$c_Lio_circe_Json$JString.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_Json$JString__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JString.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JString.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onString__T__O(this.Lio_circe_Json$JString__f_value);
});
$c_Lio_circe_Json$JString.prototype.isNull__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JString.prototype.isArray__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JString.prototype.isObject__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JString.prototype.asArray__s_Option = (function() {
  return $m_s_None$();
});
$c_Lio_circe_Json$JString.prototype.asObject__s_Option = (function() {
  return $m_s_None$();
});
function $isArrayOf_Lio_circe_Json$JString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_Json$JString)));
}
export { $isArrayOf_Lio_circe_Json$JString as $isArrayOf_Lio_circe_Json$JString };
var $d_Lio_circe_Json$JString = new $TypeData().initClass($c_Lio_circe_Json$JString, "io.circe.Json$JString", ({
  Lio_circe_Json$JString: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_Json$JString as $d_Lio_circe_Json$JString };
function $isArrayOf_Lio_circe_JsonBigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonBigDecimal)));
}
export { $isArrayOf_Lio_circe_JsonBigDecimal as $isArrayOf_Lio_circe_JsonBigDecimal };
/** @constructor */
function $c_Lio_circe_JsonDouble(value) {
  this.Lio_circe_JsonDouble__f_value = 0.0;
  this.Lio_circe_JsonDouble__f_value = value;
}
export { $c_Lio_circe_JsonDouble as $c_Lio_circe_JsonDouble };
$c_Lio_circe_JsonDouble.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonDouble.prototype.constructor = $c_Lio_circe_JsonDouble;
/** @constructor */
function $h_Lio_circe_JsonDouble() {
}
export { $h_Lio_circe_JsonDouble as $h_Lio_circe_JsonDouble };
$h_Lio_circe_JsonDouble.prototype = $c_Lio_circe_JsonDouble.prototype;
$c_Lio_circe_JsonDouble.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_JsonDouble.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_JsonDouble.prototype.productPrefix__T = (function() {
  return "JsonDouble";
});
$c_Lio_circe_JsonDouble.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_JsonDouble__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_JsonDouble.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_JsonDouble.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return $m_Lio_circe_numbers_BiggerDecimal$().fromDoubleUnsafe__D__Lio_circe_numbers_BiggerDecimal(this.Lio_circe_JsonDouble__f_value);
});
$c_Lio_circe_JsonDouble.prototype.toDouble__D = (function() {
  return this.Lio_circe_JsonDouble__f_value;
});
$c_Lio_circe_JsonDouble.prototype.toLong__s_Option = (function() {
  var d = this.Lio_circe_JsonDouble__f_value;
  var asBigDecimal = $m_Ljava_math_BigDecimal$().valueOf__D__Ljava_math_BigDecimal(d);
  if ($m_Lio_circe_JsonNumber$().bigDecimalIsValidLong__Ljava_math_BigDecimal__Z(asBigDecimal)) {
    var t = asBigDecimal.longValue__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_s_Some(new $c_RTLong(lo, hi));
  } else {
    return $m_s_None$();
  }
});
$c_Lio_circe_JsonDouble.prototype.toString__T = (function() {
  var d = this.Lio_circe_JsonDouble__f_value;
  return ("" + d);
});
function $isArrayOf_Lio_circe_JsonDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonDouble)));
}
export { $isArrayOf_Lio_circe_JsonDouble as $isArrayOf_Lio_circe_JsonDouble };
var $d_Lio_circe_JsonDouble = new $TypeData().initClass($c_Lio_circe_JsonDouble, "io.circe.JsonDouble", ({
  Lio_circe_JsonDouble: 1,
  Lio_circe_JsonNumber: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lio_circe_JsonDouble as $d_Lio_circe_JsonDouble };
function $isArrayOf_Lio_circe_JsonFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonFloat)));
}
export { $isArrayOf_Lio_circe_JsonFloat as $isArrayOf_Lio_circe_JsonFloat };
/** @constructor */
function $c_Lio_circe_JsonLong(value) {
  this.Lio_circe_JsonLong__f_value = $L0;
  this.Lio_circe_JsonLong__f_value = value;
}
export { $c_Lio_circe_JsonLong as $c_Lio_circe_JsonLong };
$c_Lio_circe_JsonLong.prototype = new $h_Lio_circe_JsonNumber();
$c_Lio_circe_JsonLong.prototype.constructor = $c_Lio_circe_JsonLong;
/** @constructor */
function $h_Lio_circe_JsonLong() {
}
export { $h_Lio_circe_JsonLong as $h_Lio_circe_JsonLong };
$h_Lio_circe_JsonLong.prototype = $c_Lio_circe_JsonLong.prototype;
$c_Lio_circe_JsonLong.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_JsonLong.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_JsonLong.prototype.productPrefix__T = (function() {
  return "JsonLong";
});
$c_Lio_circe_JsonLong.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_JsonLong__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_JsonLong.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_JsonLong.prototype.toBiggerDecimal__Lio_circe_numbers_BiggerDecimal = (function() {
  return $m_Lio_circe_numbers_BiggerDecimal$().fromLong__J__Lio_circe_numbers_BiggerDecimal(this.Lio_circe_JsonLong__f_value);
});
$c_Lio_circe_JsonLong.prototype.toDouble__D = (function() {
  var a = this.Lio_circe_JsonLong__f_value;
  var lo = a.RTLong__f_lo;
  var hi = a.RTLong__f_hi;
  return ((4.294967296E9 * hi) + (lo >>> 0.0));
});
$c_Lio_circe_JsonLong.prototype.toLong__s_Option = (function() {
  var t = this.Lio_circe_JsonLong__f_value;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_s_Some(new $c_RTLong(lo, hi));
});
$c_Lio_circe_JsonLong.prototype.toString__T = (function() {
  var t = this.Lio_circe_JsonLong__f_value;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$1 = $m_RTLong$();
  return this$1.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(lo, hi);
});
function $isArrayOf_Lio_circe_JsonLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_JsonLong)));
}
export { $isArrayOf_Lio_circe_JsonLong as $isArrayOf_Lio_circe_JsonLong };
var $d_Lio_circe_JsonLong = new $TypeData().initClass($c_Lio_circe_JsonLong, "io.circe.JsonLong", ({
  Lio_circe_JsonLong: 1,
  Lio_circe_JsonNumber: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lio_circe_JsonLong as $d_Lio_circe_JsonLong };
function $p_Lio_circe_JsoniterScalaCodec$$anon$3__fail__Lio_circe_HCursor__s_util_Either($thiz, c) {
  return new $c_s_util_Left($m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure("Int", new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List()))));
}
export { $p_Lio_circe_JsoniterScalaCodec$$anon$3__fail__Lio_circe_HCursor__s_util_Either as $p_Lio_circe_JsoniterScalaCodec$$anon$3__fail__Lio_circe_HCursor__s_util_Either };
/** @constructor */
function $c_Lio_circe_JsoniterScalaCodec$$anon$3(fromString$11) {
  this.Lio_circe_JsoniterScalaCodec$$anon$3__f_fromString$3 = null;
  this.Lio_circe_JsoniterScalaCodec$$anon$3__f_fromString$3 = fromString$11;
}
export { $c_Lio_circe_JsoniterScalaCodec$$anon$3 as $c_Lio_circe_JsoniterScalaCodec$$anon$3 };
$c_Lio_circe_JsoniterScalaCodec$$anon$3.prototype = new $h_O();
$c_Lio_circe_JsoniterScalaCodec$$anon$3.prototype.constructor = $c_Lio_circe_JsoniterScalaCodec$$anon$3;
/** @constructor */
function $h_Lio_circe_JsoniterScalaCodec$$anon$3() {
}
export { $h_Lio_circe_JsoniterScalaCodec$$anon$3 as $h_Lio_circe_JsoniterScalaCodec$$anon$3 };
$h_Lio_circe_JsoniterScalaCodec$$anon$3.prototype = $c_Lio_circe_JsoniterScalaCodec$$anon$3.prototype;
$c_Lio_circe_JsoniterScalaCodec$$anon$3.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$3.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$3.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$3.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x40 = c.value__Lio_circe_Json();
  if ((x40 instanceof $c_Lio_circe_Json$JNumber)) {
    matchResult12: {
      var x36 = x40.Lio_circe_Json$JNumber__f_value;
      if ((x36 instanceof $c_Lio_circe_JsonLong)) {
        var t = x36.Lio_circe_JsonLong__f_value;
        var lo = t.RTLong__f_lo;
        var hi = t.RTLong__f_hi;
        var hi$1 = (lo >> 31);
        if ((hi$1 === hi)) {
          return new $c_s_util_Right(lo);
        } else {
          break matchResult12;
        }
      }
      if (false) {
        var bd = $m_Lio_circe_JsoniterScalaCodec$().io$circe$JsoniterScalaCodec$$$intValueExact__Ljava_math_BigDecimal__Ljava_math_BigDecimal(x36.Lio_circe_JsonBigDecimal__f_value);
        if ((bd !== null)) {
          return new $c_s_util_Right(bd.intValue__I());
        } else {
          break matchResult12;
        }
      }
      var ol = x36.toLong__s_Option();
      if ((ol !== $m_s_None$())) {
        var t$1 = $uJ(ol.get__O());
        var lo$1 = t$1.RTLong__f_lo;
        var hi$2 = t$1.RTLong__f_hi;
        var hi$3 = (lo$1 >> 31);
        if ((hi$3 === hi$2)) {
          return new $c_s_util_Right(lo$1);
        }
      }
    }
    return $p_Lio_circe_JsoniterScalaCodec$$anon$3__fail__Lio_circe_HCursor__s_util_Either(this, c);
  }
  if ((x40 instanceof $c_Lio_circe_Json$JString)) {
    try {
      return new $c_s_util_Right(this.Lio_circe_JsoniterScalaCodec$$anon$3__f_fromString$3.apply__O__O(x40.Lio_circe_Json$JString__f_value));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        return $p_Lio_circe_JsoniterScalaCodec$$anon$3__fail__Lio_circe_HCursor__s_util_Either(this, c);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  return $p_Lio_circe_JsoniterScalaCodec$$anon$3__fail__Lio_circe_HCursor__s_util_Either(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$3.prototype.apply__O__Lio_circe_Json = (function(a) {
  var x = (a | 0);
  var $x_1 = $m_Lio_circe_JsonNumber$();
  var hi = (x >> 31);
  return $x_1.fromLong__J__Lio_circe_Json$JNumber(new $c_RTLong(x, hi));
});
var $d_Lio_circe_JsoniterScalaCodec$$anon$3 = new $TypeData().initClass($c_Lio_circe_JsoniterScalaCodec$$anon$3, "io.circe.JsoniterScalaCodec$$anon$3", ({
  Lio_circe_JsoniterScalaCodec$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Codec: 1
}));
export { $d_Lio_circe_JsoniterScalaCodec$$anon$3 as $d_Lio_circe_JsoniterScalaCodec$$anon$3 };
function $p_Lio_circe_JsoniterScalaCodec$$anon$4__fail__Lio_circe_HCursor__s_util_Either($thiz, c) {
  return new $c_s_util_Left($m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure("Long", new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List()))));
}
export { $p_Lio_circe_JsoniterScalaCodec$$anon$4__fail__Lio_circe_HCursor__s_util_Either as $p_Lio_circe_JsoniterScalaCodec$$anon$4__fail__Lio_circe_HCursor__s_util_Either };
/** @constructor */
function $c_Lio_circe_JsoniterScalaCodec$$anon$4(fromString$12) {
  this.Lio_circe_JsoniterScalaCodec$$anon$4__f_fromString$4 = null;
  this.Lio_circe_JsoniterScalaCodec$$anon$4__f_fromString$4 = fromString$12;
}
export { $c_Lio_circe_JsoniterScalaCodec$$anon$4 as $c_Lio_circe_JsoniterScalaCodec$$anon$4 };
$c_Lio_circe_JsoniterScalaCodec$$anon$4.prototype = new $h_O();
$c_Lio_circe_JsoniterScalaCodec$$anon$4.prototype.constructor = $c_Lio_circe_JsoniterScalaCodec$$anon$4;
/** @constructor */
function $h_Lio_circe_JsoniterScalaCodec$$anon$4() {
}
export { $h_Lio_circe_JsoniterScalaCodec$$anon$4 as $h_Lio_circe_JsoniterScalaCodec$$anon$4 };
$h_Lio_circe_JsoniterScalaCodec$$anon$4.prototype = $c_Lio_circe_JsoniterScalaCodec$$anon$4.prototype;
$c_Lio_circe_JsoniterScalaCodec$$anon$4.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$4.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$4.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$4.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x47 = c.value__Lio_circe_Json();
  if ((x47 instanceof $c_Lio_circe_Json$JNumber)) {
    matchResult15: {
      var x43 = x47.Lio_circe_Json$JNumber__f_value;
      if ((x43 instanceof $c_Lio_circe_JsonLong)) {
        return new $c_s_util_Right(x43.Lio_circe_JsonLong__f_value);
      }
      if (false) {
        var bd = $m_Lio_circe_JsoniterScalaCodec$().io$circe$JsoniterScalaCodec$$$longValueExact__Ljava_math_BigDecimal__Ljava_math_BigDecimal(x43.Lio_circe_JsonBigDecimal__f_value);
        if ((bd !== null)) {
          return new $c_s_util_Right(bd.longValue__J());
        } else {
          break matchResult15;
        }
      }
      var ol = x43.toLong__s_Option();
      if ((ol !== $m_s_None$())) {
        return new $c_s_util_Right(ol.get__O());
      }
    }
    return $p_Lio_circe_JsoniterScalaCodec$$anon$4__fail__Lio_circe_HCursor__s_util_Either(this, c);
  }
  if ((x47 instanceof $c_Lio_circe_Json$JString)) {
    try {
      return new $c_s_util_Right(this.Lio_circe_JsoniterScalaCodec$$anon$4__f_fromString$4.apply__O__O(x47.Lio_circe_Json$JString__f_value));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        return $p_Lio_circe_JsoniterScalaCodec$$anon$4__fail__Lio_circe_HCursor__s_util_Either(this, c);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  return $p_Lio_circe_JsoniterScalaCodec$$anon$4__fail__Lio_circe_HCursor__s_util_Either(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$4.prototype.apply__O__Lio_circe_Json = (function(a) {
  var t = $uJ(a);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_Lio_circe_JsonNumber$().fromLong__J__Lio_circe_Json$JNumber(new $c_RTLong(lo, hi));
});
var $d_Lio_circe_JsoniterScalaCodec$$anon$4 = new $TypeData().initClass($c_Lio_circe_JsoniterScalaCodec$$anon$4, "io.circe.JsoniterScalaCodec$$anon$4", ({
  Lio_circe_JsoniterScalaCodec$$anon$4: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Codec: 1
}));
export { $d_Lio_circe_JsoniterScalaCodec$$anon$4 as $d_Lio_circe_JsoniterScalaCodec$$anon$4 };
function $p_Lio_circe_JsoniterScalaCodec$$anon$6__fail__Lio_circe_HCursor__s_util_Either($thiz, c) {
  return new $c_s_util_Left($m_Lio_circe_DecodingFailure$().apply__T__F0__Lio_circe_DecodingFailure("Double", new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => c.history__sci_List()))));
}
export { $p_Lio_circe_JsoniterScalaCodec$$anon$6__fail__Lio_circe_HCursor__s_util_Either as $p_Lio_circe_JsoniterScalaCodec$$anon$6__fail__Lio_circe_HCursor__s_util_Either };
/** @constructor */
function $c_Lio_circe_JsoniterScalaCodec$$anon$6(fromString$14) {
  this.Lio_circe_JsoniterScalaCodec$$anon$6__f_fromString$6 = null;
  this.Lio_circe_JsoniterScalaCodec$$anon$6__f_fromString$6 = fromString$14;
}
export { $c_Lio_circe_JsoniterScalaCodec$$anon$6 as $c_Lio_circe_JsoniterScalaCodec$$anon$6 };
$c_Lio_circe_JsoniterScalaCodec$$anon$6.prototype = new $h_O();
$c_Lio_circe_JsoniterScalaCodec$$anon$6.prototype.constructor = $c_Lio_circe_JsoniterScalaCodec$$anon$6;
/** @constructor */
function $h_Lio_circe_JsoniterScalaCodec$$anon$6() {
}
export { $h_Lio_circe_JsoniterScalaCodec$$anon$6 as $h_Lio_circe_JsoniterScalaCodec$$anon$6 };
$h_Lio_circe_JsoniterScalaCodec$$anon$6.prototype = $c_Lio_circe_JsoniterScalaCodec$$anon$6.prototype;
$c_Lio_circe_JsoniterScalaCodec$$anon$6.prototype.decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__decodeAccumulating__Lio_circe_HCursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$6.prototype.tryDecode__Lio_circe_ACursor__s_util_Either = (function(c) {
  return $f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$6.prototype.tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated = (function(c) {
  return $f_Lio_circe_Decoder__tryDecodeAccumulating__Lio_circe_ACursor__Lcats_data_Validated(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$6.prototype.apply__Lio_circe_HCursor__s_util_Either = (function(c) {
  var x55 = c.value__Lio_circe_Json();
  if ((x55 instanceof $c_Lio_circe_Json$JNumber)) {
    return new $c_s_util_Right(x55.Lio_circe_Json$JNumber__f_value.toDouble__D());
  }
  if ((x55 instanceof $c_Lio_circe_Json$JString)) {
    try {
      return new $c_s_util_Right(this.Lio_circe_JsoniterScalaCodec$$anon$6__f_fromString$6.apply__O__O(x55.Lio_circe_Json$JString__f_value));
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        return $p_Lio_circe_JsoniterScalaCodec$$anon$6__fail__Lio_circe_HCursor__s_util_Either(this, c);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  return $p_Lio_circe_JsoniterScalaCodec$$anon$6__fail__Lio_circe_HCursor__s_util_Either(this, c);
});
$c_Lio_circe_JsoniterScalaCodec$$anon$6.prototype.apply__O__Lio_circe_Json = (function(a) {
  var x = (+a);
  return new $c_Lio_circe_Json$JNumber(new $c_Lio_circe_JsonDouble(x));
});
var $d_Lio_circe_JsoniterScalaCodec$$anon$6 = new $TypeData().initClass($c_Lio_circe_JsoniterScalaCodec$$anon$6, "io.circe.JsoniterScalaCodec$$anon$6", ({
  Lio_circe_JsoniterScalaCodec$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Decoder: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Codec: 1
}));
export { $d_Lio_circe_JsoniterScalaCodec$$anon$6 as $d_Lio_circe_JsoniterScalaCodec$$anon$6 };
/** @constructor */
function $c_Lio_circe_PathToRoot$PathElem$ArrayIndex(index) {
  this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index = $L0;
  this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index = index;
}
export { $c_Lio_circe_PathToRoot$PathElem$ArrayIndex as $c_Lio_circe_PathToRoot$PathElem$ArrayIndex };
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype = new $h_Lio_circe_PathToRoot$PathElem();
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.constructor = $c_Lio_circe_PathToRoot$PathElem$ArrayIndex;
/** @constructor */
function $h_Lio_circe_PathToRoot$PathElem$ArrayIndex() {
}
export { $h_Lio_circe_PathToRoot$PathElem$ArrayIndex as $h_Lio_circe_PathToRoot$PathElem$ArrayIndex };
$h_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype = $c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype;
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("ArrayIndex");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_circe_PathToRoot$PathElem$ArrayIndex)) {
    var a = this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index;
    var b = x$0.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index;
    return ((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi));
  } else {
    return false;
  }
});
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.productPrefix__T = (function() {
  return "ArrayIndex";
});
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_PathToRoot$PathElem$ArrayIndex__f_index;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_PathToRoot$PathElem$ArrayIndex.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "index";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_circe_PathToRoot$PathElem$ArrayIndex(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_PathToRoot$PathElem$ArrayIndex)));
}
export { $isArrayOf_Lio_circe_PathToRoot$PathElem$ArrayIndex as $isArrayOf_Lio_circe_PathToRoot$PathElem$ArrayIndex };
var $d_Lio_circe_PathToRoot$PathElem$ArrayIndex = new $TypeData().initClass($c_Lio_circe_PathToRoot$PathElem$ArrayIndex, "io.circe.PathToRoot$PathElem$ArrayIndex", ({
  Lio_circe_PathToRoot$PathElem$ArrayIndex: 1,
  Lio_circe_PathToRoot$PathElem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_PathToRoot$PathElem$ArrayIndex as $d_Lio_circe_PathToRoot$PathElem$ArrayIndex };
/** @constructor */
function $c_Lio_circe_PathToRoot$PathElem$ObjectKey(keyName) {
  this.Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName = null;
  this.Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName = keyName;
}
export { $c_Lio_circe_PathToRoot$PathElem$ObjectKey as $c_Lio_circe_PathToRoot$PathElem$ObjectKey };
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype = new $h_Lio_circe_PathToRoot$PathElem();
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.constructor = $c_Lio_circe_PathToRoot$PathElem$ObjectKey;
/** @constructor */
function $h_Lio_circe_PathToRoot$PathElem$ObjectKey() {
}
export { $h_Lio_circe_PathToRoot$PathElem$ObjectKey as $h_Lio_circe_PathToRoot$PathElem$ObjectKey };
$h_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype = $c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype;
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_circe_PathToRoot$PathElem$ObjectKey) && (this.Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName === x$0.Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName)));
});
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.productPrefix__T = (function() {
  return "ObjectKey";
});
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_PathToRoot$PathElem$ObjectKey__f_keyName;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_PathToRoot$PathElem$ObjectKey.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "keyName";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_circe_PathToRoot$PathElem$ObjectKey(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_PathToRoot$PathElem$ObjectKey)));
}
export { $isArrayOf_Lio_circe_PathToRoot$PathElem$ObjectKey as $isArrayOf_Lio_circe_PathToRoot$PathElem$ObjectKey };
var $d_Lio_circe_PathToRoot$PathElem$ObjectKey = new $TypeData().initClass($c_Lio_circe_PathToRoot$PathElem$ObjectKey, "io.circe.PathToRoot$PathElem$ObjectKey", ({
  Lio_circe_PathToRoot$PathElem$ObjectKey: 1,
  Lio_circe_PathToRoot$PathElem: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_PathToRoot$PathElem$ObjectKey as $d_Lio_circe_PathToRoot$PathElem$ObjectKey };
class $c_jl_ArithmeticException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
export { $c_jl_ArithmeticException as $c_jl_ArithmeticException };
function $isArrayOf_jl_ArithmeticException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ArithmeticException)));
}
export { $isArrayOf_jl_ArithmeticException as $isArrayOf_jl_ArithmeticException };
var $d_jl_ArithmeticException = new $TypeData().initClass($c_jl_ArithmeticException, "java.lang.ArithmeticException", ({
  jl_ArithmeticException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_ArithmeticException as $d_jl_ArithmeticException };
function $f_jl_Byte__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
export { $f_jl_Byte__equals__O__Z as $f_jl_Byte__equals__O__Z };
function $f_jl_Byte__hashCode__I($thiz) {
  return $thiz;
}
export { $f_jl_Byte__hashCode__I as $f_jl_Byte__hashCode__I };
function $f_jl_Byte__toString__T($thiz) {
  return ("" + $thiz);
}
export { $f_jl_Byte__toString__T as $f_jl_Byte__toString__T };
function $f_jl_Byte__compareTo__O__I($thiz, o) {
  return (($thiz - o) | 0);
}
export { $f_jl_Byte__compareTo__O__I as $f_jl_Byte__compareTo__O__I };
function $isArrayOf_jl_Byte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Byte)));
}
export { $isArrayOf_jl_Byte as $isArrayOf_jl_Byte };
var $d_jl_Byte = new $TypeData().initClass(0, "java.lang.Byte", ({
  jl_Byte: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => $isByte(x)));
export { $d_jl_Byte as $d_jl_Byte };
class $c_jl_ClassCastException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
export { $c_jl_ClassCastException as $c_jl_ClassCastException };
function $isArrayOf_jl_ClassCastException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_ClassCastException)));
}
export { $isArrayOf_jl_ClassCastException as $isArrayOf_jl_ClassCastException };
var $d_jl_ClassCastException = new $TypeData().initClass($c_jl_ClassCastException, "java.lang.ClassCastException", ({
  jl_ClassCastException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_ClassCastException as $d_jl_ClassCastException };
function $ct_jl_IllegalArgumentException__T__jl_Throwable__($thiz, s, e) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, e, true, true);
  return $thiz;
}
export { $ct_jl_IllegalArgumentException__T__jl_Throwable__ as $ct_jl_IllegalArgumentException__T__jl_Throwable__ };
function $ct_jl_IllegalArgumentException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_jl_IllegalArgumentException__T__ as $ct_jl_IllegalArgumentException__T__ };
function $ct_jl_IllegalArgumentException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
export { $ct_jl_IllegalArgumentException__ as $ct_jl_IllegalArgumentException__ };
class $c_jl_IllegalArgumentException extends $c_jl_RuntimeException {
}
export { $c_jl_IllegalArgumentException as $c_jl_IllegalArgumentException };
function $isArrayOf_jl_IllegalArgumentException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_IllegalArgumentException)));
}
export { $isArrayOf_jl_IllegalArgumentException as $isArrayOf_jl_IllegalArgumentException };
var $d_jl_IllegalArgumentException = new $TypeData().initClass($c_jl_IllegalArgumentException, "java.lang.IllegalArgumentException", ({
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_IllegalArgumentException as $d_jl_IllegalArgumentException };
function $ct_jl_IllegalStateException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_jl_IllegalStateException__T__ as $ct_jl_IllegalStateException__T__ };
function $ct_jl_IllegalStateException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
export { $ct_jl_IllegalStateException__ as $ct_jl_IllegalStateException__ };
class $c_jl_IllegalStateException extends $c_jl_RuntimeException {
}
export { $c_jl_IllegalStateException as $c_jl_IllegalStateException };
var $d_jl_IllegalStateException = new $TypeData().initClass($c_jl_IllegalStateException, "java.lang.IllegalStateException", ({
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_IllegalStateException as $d_jl_IllegalStateException };
function $ct_jl_IndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_jl_IndexOutOfBoundsException__T__ as $ct_jl_IndexOutOfBoundsException__T__ };
function $ct_jl_IndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
export { $ct_jl_IndexOutOfBoundsException__ as $ct_jl_IndexOutOfBoundsException__ };
class $c_jl_IndexOutOfBoundsException extends $c_jl_RuntimeException {
}
export { $c_jl_IndexOutOfBoundsException as $c_jl_IndexOutOfBoundsException };
var $d_jl_IndexOutOfBoundsException = new $TypeData().initClass($c_jl_IndexOutOfBoundsException, "java.lang.IndexOutOfBoundsException", ({
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_IndexOutOfBoundsException as $d_jl_IndexOutOfBoundsException };
class $c_jl_NegativeArraySizeException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
export { $c_jl_NegativeArraySizeException as $c_jl_NegativeArraySizeException };
var $d_jl_NegativeArraySizeException = new $TypeData().initClass($c_jl_NegativeArraySizeException, "java.lang.NegativeArraySizeException", ({
  jl_NegativeArraySizeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_NegativeArraySizeException as $d_jl_NegativeArraySizeException };
function $ct_jl_NullPointerException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_jl_NullPointerException__T__ as $ct_jl_NullPointerException__T__ };
function $ct_jl_NullPointerException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
export { $ct_jl_NullPointerException__ as $ct_jl_NullPointerException__ };
class $c_jl_NullPointerException extends $c_jl_RuntimeException {
}
export { $c_jl_NullPointerException as $c_jl_NullPointerException };
var $d_jl_NullPointerException = new $TypeData().initClass($c_jl_NullPointerException, "java.lang.NullPointerException", ({
  jl_NullPointerException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_NullPointerException as $d_jl_NullPointerException };
function $isArrayOf_jl_SecurityException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_SecurityException)));
}
export { $isArrayOf_jl_SecurityException as $isArrayOf_jl_SecurityException };
function $f_jl_Short__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
export { $f_jl_Short__equals__O__Z as $f_jl_Short__equals__O__Z };
function $f_jl_Short__hashCode__I($thiz) {
  return $thiz;
}
export { $f_jl_Short__hashCode__I as $f_jl_Short__hashCode__I };
function $f_jl_Short__toString__T($thiz) {
  return ("" + $thiz);
}
export { $f_jl_Short__toString__T as $f_jl_Short__toString__T };
function $f_jl_Short__compareTo__O__I($thiz, o) {
  return (($thiz - o) | 0);
}
export { $f_jl_Short__compareTo__O__I as $f_jl_Short__compareTo__O__I };
function $isArrayOf_jl_Short(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Short)));
}
export { $isArrayOf_jl_Short as $isArrayOf_jl_Short };
var $d_jl_Short = new $TypeData().initClass(0, "java.lang.Short", ({
  jl_Short: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1
}), ((x) => $isShort(x)));
export { $d_jl_Short as $d_jl_Short };
function $ct_jl_UnsupportedOperationException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
export { $ct_jl_UnsupportedOperationException__ as $ct_jl_UnsupportedOperationException__ };
function $ct_jl_UnsupportedOperationException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_jl_UnsupportedOperationException__T__ as $ct_jl_UnsupportedOperationException__T__ };
class $c_jl_UnsupportedOperationException extends $c_jl_RuntimeException {
}
export { $c_jl_UnsupportedOperationException as $c_jl_UnsupportedOperationException };
var $d_jl_UnsupportedOperationException = new $TypeData().initClass($c_jl_UnsupportedOperationException, "java.lang.UnsupportedOperationException", ({
  jl_UnsupportedOperationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_UnsupportedOperationException as $d_jl_UnsupportedOperationException };
class $c_Ljava_nio_BufferOverflowException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
export { $c_Ljava_nio_BufferOverflowException as $c_Ljava_nio_BufferOverflowException };
function $isArrayOf_Ljava_nio_BufferOverflowException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_BufferOverflowException)));
}
export { $isArrayOf_Ljava_nio_BufferOverflowException as $isArrayOf_Ljava_nio_BufferOverflowException };
var $d_Ljava_nio_BufferOverflowException = new $TypeData().initClass($c_Ljava_nio_BufferOverflowException, "java.nio.BufferOverflowException", ({
  Ljava_nio_BufferOverflowException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_nio_BufferOverflowException as $d_Ljava_nio_BufferOverflowException };
class $c_Ljava_nio_BufferUnderflowException extends $c_jl_RuntimeException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
export { $c_Ljava_nio_BufferUnderflowException as $c_Ljava_nio_BufferUnderflowException };
function $isArrayOf_Ljava_nio_BufferUnderflowException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_BufferUnderflowException)));
}
export { $isArrayOf_Ljava_nio_BufferUnderflowException as $isArrayOf_Ljava_nio_BufferUnderflowException };
var $d_Ljava_nio_BufferUnderflowException = new $TypeData().initClass($c_Ljava_nio_BufferUnderflowException, "java.nio.BufferUnderflowException", ({
  Ljava_nio_BufferUnderflowException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_nio_BufferUnderflowException as $d_Ljava_nio_BufferUnderflowException };
class $c_Ljava_nio_charset_CharacterCodingException extends $c_Ljava_io_IOException {
}
export { $c_Ljava_nio_charset_CharacterCodingException as $c_Ljava_nio_charset_CharacterCodingException };
function $ct_Ljava_time_DateTimeException__T__jl_Throwable__($thiz, message, cause) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  return $thiz;
}
export { $ct_Ljava_time_DateTimeException__T__jl_Throwable__ as $ct_Ljava_time_DateTimeException__T__jl_Throwable__ };
function $ct_Ljava_time_DateTimeException__T__($thiz, message) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, null, true, true);
  return $thiz;
}
export { $ct_Ljava_time_DateTimeException__T__ as $ct_Ljava_time_DateTimeException__T__ };
class $c_Ljava_time_DateTimeException extends $c_jl_RuntimeException {
}
export { $c_Ljava_time_DateTimeException as $c_Ljava_time_DateTimeException };
function $isArrayOf_Ljava_time_DateTimeException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_DateTimeException)));
}
export { $isArrayOf_Ljava_time_DateTimeException as $isArrayOf_Ljava_time_DateTimeException };
var $d_Ljava_time_DateTimeException = new $TypeData().initClass($c_Ljava_time_DateTimeException, "java.time.DateTimeException", ({
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_DateTimeException as $d_Ljava_time_DateTimeException };
/** @constructor */
function $c_Ljava_time_Duration(seconds, nanos) {
  this.Ljava_time_Duration__f_seconds = $L0;
  this.Ljava_time_Duration__f_nanos = 0;
  this.Ljava_time_Duration__f_seconds = seconds;
  this.Ljava_time_Duration__f_nanos = nanos;
}
export { $c_Ljava_time_Duration as $c_Ljava_time_Duration };
$c_Ljava_time_Duration.prototype = new $h_O();
$c_Ljava_time_Duration.prototype.constructor = $c_Ljava_time_Duration;
/** @constructor */
function $h_Ljava_time_Duration() {
}
export { $h_Ljava_time_Duration as $h_Ljava_time_Duration };
$h_Ljava_time_Duration.prototype = $c_Ljava_time_Duration.prototype;
$c_Ljava_time_Duration.prototype.toNanos__J = (function() {
  var t = this.Ljava_time_Duration__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$1 = $m_jl_Math$();
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(51712, b0);
  var a1b0 = Math.imul(15258, b0);
  var a0b1 = Math.imul(51712, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((Math.imul(1000000000, hi) + Math.imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  if ((!((lo === 0) && (hi === 0)))) {
    var this$5 = $m_RTLong$();
    var lo$2 = this$5.divideImpl__I__I__I__I__I(lo$1, hi$1, lo, hi);
    var hi$2 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var $x_1 = (!((lo$2 === 1000000000) && (hi$2 === 0)));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    this$1.java$lang$Math$$longOverflow__E();
  }
  var value = this.Ljava_time_Duration__f_nanos;
  var hi$3 = (value >> 31);
  var this$8 = $m_jl_Math$();
  var lo$3 = ((lo$1 + value) | 0);
  var hi$4 = ((((hi$1 + hi$3) | 0) + ((((lo$1 & value) | ((lo$1 | value) & (~lo$3))) >>> 31) | 0)) | 0);
  var hi$5 = (hi$4 ^ hi$1);
  var hi$6 = (hi$4 ^ hi$3);
  var hi$7 = (hi$5 & hi$6);
  if ((hi$7 < 0)) {
    this$8.java$lang$Math$$longOverflow__E();
  }
  return new $c_RTLong(lo$3, hi$4);
});
$c_Ljava_time_Duration.prototype.compare__Ljava_time_Duration__I = (function(otherDuration) {
  var t = this.Ljava_time_Duration__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = otherDuration.Ljava_time_Duration__f_seconds;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  return ((cmp !== 0) ? cmp : ((this.Ljava_time_Duration__f_nanos - otherDuration.Ljava_time_Duration__f_nanos) | 0));
});
$c_Ljava_time_Duration.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_Duration)) {
    if ((this === other)) {
      return true;
    } else {
      var a = this.Ljava_time_Duration__f_seconds;
      var b = other.Ljava_time_Duration__f_seconds;
      if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
        return (this.Ljava_time_Duration__f_nanos === other.Ljava_time_Duration__f_nanos);
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_Duration.prototype.hashCode__I = (function() {
  var a$1 = this.Ljava_time_Duration__f_seconds;
  var a = this.Ljava_time_Duration__f_seconds;
  var hi = a.RTLong__f_hi;
  var lo = (a$1.RTLong__f_lo ^ hi);
  return ((lo + Math.imul(51, this.Ljava_time_Duration__f_nanos)) | 0);
});
$c_Ljava_time_Duration.prototype.toString__T = (function() {
  if ((this === $m_Ljava_time_Duration$().ZERO__Ljava_time_Duration())) {
    return "PT0S";
  }
  var a = this.Ljava_time_Duration__f_seconds;
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var a$1 = this.Ljava_time_Duration__f_seconds;
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.remainderImpl__I__I__I__I__I(a$1.RTLong__f_lo, a$1.RTLong__f_hi, 3600, 0);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$3 = $m_RTLong$();
  var lo$2 = this$3.divideImpl__I__I__I__I__I(lo$1, hi$1, 60, 0);
  var a$2 = this.Ljava_time_Duration__f_seconds;
  var this$5 = $m_RTLong$();
  var lo$3 = this$5.remainderImpl__I__I__I__I__I(a$2.RTLong__f_lo, a$2.RTLong__f_hi, 60, 0);
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 24);
  buf.append__T__scm_StringBuilder("PT");
  if ((!((lo === 0) && (hi === 0)))) {
    buf.append__J__scm_StringBuilder(new $c_RTLong(lo, hi)).append__C__scm_StringBuilder(72);
  }
  if ((lo$2 !== 0)) {
    buf.append__I__scm_StringBuilder(lo$2).append__C__scm_StringBuilder(77);
  }
  if ((((lo$3 === 0) && (this.Ljava_time_Duration__f_nanos === 0)) && (buf.scm_StringBuilder__f_underlying.length__I() > 2))) {
    return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
  }
  if (((lo$3 < 0) && (this.Ljava_time_Duration__f_nanos > 0))) {
    if ((lo$3 === (-1))) {
      buf.append__T__scm_StringBuilder("-0");
    } else {
      buf.append__I__scm_StringBuilder(((1 + lo$3) | 0));
    }
  } else {
    buf.append__I__scm_StringBuilder(lo$3);
  }
  if ((this.Ljava_time_Duration__f_nanos > 0)) {
    var pos = buf.scm_StringBuilder__f_underlying.length__I();
    if ((lo$3 < 0)) {
      buf.append__I__scm_StringBuilder(((2000000000 - this.Ljava_time_Duration__f_nanos) | 0));
    } else {
      buf.append__I__scm_StringBuilder(((1000000000 + this.Ljava_time_Duration__f_nanos) | 0));
    }
    while (true) {
      var index = (((-1) + buf.scm_StringBuilder__f_underlying.length__I()) | 0);
      if ((buf.scm_StringBuilder__f_underlying.charAt__I__C(index) === 48)) {
        var len = (((-1) + buf.scm_StringBuilder__f_underlying.length__I()) | 0);
        buf.scm_StringBuilder__f_underlying.setLength__I__V(len);
      } else {
        break;
      }
    }
    buf.setCharAt__I__C__scm_StringBuilder(pos, 46);
  }
  buf.append__C__scm_StringBuilder(83);
  return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Ljava_time_Duration.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_Duration__I(that);
});
$c_Ljava_time_Duration.prototype.compareTo__O__I = (function(that) {
  return this.compare__Ljava_time_Duration__I(that);
});
function $isArrayOf_Ljava_time_Duration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Duration)));
}
export { $isArrayOf_Ljava_time_Duration as $isArrayOf_Ljava_time_Duration };
var $d_Ljava_time_Duration = new $TypeData().initClass($c_Ljava_time_Duration, "java.time.Duration", ({
  Ljava_time_Duration: 1,
  Ljava_time_temporal_TemporalAmount: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_Duration as $d_Ljava_time_Duration };
function $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I($thiz, field) {
  var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
  if ((x === field)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Field too large for an int: " + field));
  }
  var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  if ((x$3 === field)) {
    var this$1 = $thiz.Ljava_time_ZonedDateTime__f_offset;
    return this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  }
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    return $thiz.Ljava_time_ZonedDateTime__f_dateTime.get__Ljava_time_temporal_TemporalField__I(field);
  }
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I($thiz, field);
}
export { $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I as $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I };
function $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  matchAlts3: {
    matchAlts4: {
      var x = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x === query)) {
        break matchAlts4;
      }
      var x$3 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$3 === query)) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return $thiz.Ljava_time_ZonedDateTime__f_zone;
  }
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x$5 === query)) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  }
  var x$7 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$7 === query)) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  }
  var x$9 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
  if ((x$9 === query)) {
    return $thiz.Ljava_time_ZonedDateTime__f_offset;
  }
  var x$11 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$11 === query)) {
    var $x_1 = $m_Ljava_time_LocalDate$();
    var this$3 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
    return $x_1.ofEpochDay__J__Ljava_time_LocalDate(this$3.Ljava_time_LocalDateTime__f_date.toEpochDay__J());
  }
  var x$13 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$13 === query)) {
    var this$4 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
    return this$4.Ljava_time_LocalDateTime__f_time;
  }
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query);
}
export { $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O as $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O };
function $f_Ljava_time_chrono_ChronoZonedDateTime__toInstant__Ljava_time_Instant($thiz) {
  var $x_2 = $m_Ljava_time_Instant$();
  var $x_1 = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz);
  var this$1 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
  var this$2 = this$1.Ljava_time_LocalDateTime__f_time;
  var value = this$2.Ljava_time_LocalTime__f_nano;
  var hi = (value >> 31);
  return $x_2.ofEpochSecond__J__J__Ljava_time_Instant($x_1, new $c_RTLong(value, hi));
}
export { $f_Ljava_time_chrono_ChronoZonedDateTime__toInstant__Ljava_time_Instant as $f_Ljava_time_chrono_ChronoZonedDateTime__toInstant__Ljava_time_Instant };
function $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz) {
  var this$1 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
  var t = this$1.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(20864, b0);
  var a0b1 = Math.imul(20864, b1);
  var lo$1 = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((Math.imul(86400, hi) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
  var this$3 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
  var value = this$3.Ljava_time_LocalDateTime__f_time.toSecondOfDay__I();
  var hi$2 = (value >> 31);
  var lo$2 = ((lo$1 + value) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo$1 & value) | ((lo$1 | value) & (~lo$2))) >>> 31) | 0)) | 0);
  var secs__lo = lo$2;
  var secs__hi = hi$3;
  var a__lo = secs__lo;
  var a__hi = secs__hi;
  var this$6 = $thiz.Ljava_time_ZonedDateTime__f_offset;
  var value$1 = this$6.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi$4 = (value$1 >> 31);
  var alo = a__lo;
  var lo$3 = ((alo - value$1) | 0);
  var hi$5 = ((((a__hi - hi$4) | 0) + ((((~alo) & value$1) | ((~(alo ^ value$1)) & lo$3)) >> 31)) | 0);
  var $x_1__lo = lo$3;
  var $x_1__hi = hi$5;
  secs__lo = $x_1__lo;
  secs__hi = $x_1__hi;
  return new $c_RTLong(secs__lo, secs__hi);
}
export { $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J as $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J };
function $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I($thiz, other) {
  var t = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(other);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  if ((cmp === 0)) {
    var this$2 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
    var this$3 = this$2.Ljava_time_LocalDateTime__f_time;
    var $x_1 = this$3.Ljava_time_LocalTime__f_nano;
    var this$4 = other.Ljava_time_ZonedDateTime__f_dateTime;
    var this$5 = this$4.Ljava_time_LocalDateTime__f_time;
    cmp = (($x_1 - this$5.Ljava_time_LocalTime__f_nano) | 0);
    if ((cmp === 0)) {
      var this$6 = $thiz.Ljava_time_ZonedDateTime__f_dateTime;
      var that = other.Ljava_time_ZonedDateTime__f_dateTime;
      cmp = this$6.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(that);
      if ((cmp === 0)) {
        cmp = $f_T__compareTo__T__I($thiz.Ljava_time_ZonedDateTime__f_zone.getId__T(), other.Ljava_time_ZonedDateTime__f_zone.getId__T());
        if ((cmp === 0)) {
          $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
          $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
          cmp = $f_T__compareTo__T__I("ISO", "ISO");
        }
      }
    }
  }
  return cmp;
}
export { $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I as $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I };
function $is_Ljava_time_chrono_ChronoZonedDateTime(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_ChronoZonedDateTime)));
}
export { $is_Ljava_time_chrono_ChronoZonedDateTime as $is_Ljava_time_chrono_ChronoZonedDateTime };
function $isArrayOf_Ljava_time_chrono_ChronoZonedDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoZonedDateTime)));
}
export { $isArrayOf_Ljava_time_chrono_ChronoZonedDateTime as $isArrayOf_Ljava_time_chrono_ChronoZonedDateTime };
/** @constructor */
function $c_Ljava_time_chrono_IsoChronology() {
}
export { $c_Ljava_time_chrono_IsoChronology as $c_Ljava_time_chrono_IsoChronology };
$c_Ljava_time_chrono_IsoChronology.prototype = new $h_O();
$c_Ljava_time_chrono_IsoChronology.prototype.constructor = $c_Ljava_time_chrono_IsoChronology;
/** @constructor */
function $h_Ljava_time_chrono_IsoChronology() {
}
export { $h_Ljava_time_chrono_IsoChronology as $h_Ljava_time_chrono_IsoChronology };
$h_Ljava_time_chrono_IsoChronology.prototype = $c_Ljava_time_chrono_IsoChronology.prototype;
$c_Ljava_time_chrono_IsoChronology.prototype.compareTo__O__I = (function(that) {
  return $f_T__compareTo__T__I("ISO", "ISO");
});
$c_Ljava_time_chrono_IsoChronology.prototype.equals__O__Z = (function(obj) {
  return $f_Ljava_time_chrono_Chronology__equals__O__Z(this, obj);
});
$c_Ljava_time_chrono_IsoChronology.prototype.hashCode__I = (function() {
  return $f_Ljava_time_chrono_Chronology__hashCode__I(this);
});
$c_Ljava_time_chrono_IsoChronology.prototype.toString__T = (function() {
  return "ISO";
});
$c_Ljava_time_chrono_IsoChronology.prototype.isLeapYear__J__Z = (function(prolepticYear) {
  var lo = (3 & prolepticYear.RTLong__f_lo);
  if ((lo === 0)) {
    var this$3 = $m_RTLong$();
    var lo$1 = this$3.remainderImpl__I__I__I__I__I(prolepticYear.RTLong__f_lo, prolepticYear.RTLong__f_hi, 100, 0);
    var hi = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if ((!((lo$1 === 0) && (hi === 0)))) {
      return true;
    } else {
      var this$5 = $m_RTLong$();
      var lo$2 = this$5.remainderImpl__I__I__I__I__I(prolepticYear.RTLong__f_lo, prolepticYear.RTLong__f_hi, 400, 0);
      var hi$1 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return ((lo$2 === 0) && (hi$1 === 0));
    }
  } else {
    return false;
  }
});
$c_Ljava_time_chrono_IsoChronology.prototype.resolveDate__ju_Map__Ljava_time_format_ResolverStyle__Ljava_time_LocalDate = (function(fieldValues, resolverStyle) {
  if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_1 = $m_Ljava_time_LocalDate$();
    var x = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField());
    return $x_1.ofEpochDay__J__Ljava_time_LocalDate($uJ(x));
  }
  var prolepticMonth = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField());
  if ((prolepticMonth !== null)) {
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$3 = $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
      var t = $uJ(prolepticMonth);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      this$3.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo, hi), this$3);
    }
    var field = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var t$1 = $uJ(prolepticMonth);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var this$6 = $m_RTLong$();
    var lo$2 = this$6.remainderImpl__I__I__I__I__I(lo$1, hi$1, 12, 0);
    var hi$2 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((hi$1 >= 0) || ((lo$2 === 0) && (hi$2 === 0)))) {
      var b__lo = lo$2;
      var b__hi = hi$2;
    } else {
      var lo$4 = ((12 + lo$2) | 0);
      var hi$3 = ((hi$2 + (((lo$2 & (~lo$4)) >>> 31) | 0)) | 0);
      var b__lo = lo$4;
      var b__hi = hi$3;
    }
    var blo = b__lo;
    var lo$5 = ((1 + blo) | 0);
    var hi$4 = ((b__hi + (((blo & (~lo$5)) >>> 31) | 0)) | 0);
    $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field, new $c_RTLong(lo$5, hi$4));
    var field$1 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var t$2 = $uJ(prolepticMonth);
    var lo$6 = t$2.RTLong__f_lo;
    var hi$5 = t$2.RTLong__f_hi;
    var this$14 = $m_RTLong$();
    var lo$7 = this$14.divideImpl__I__I__I__I__I(lo$6, hi$5, 12, 0);
    var hi$6 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if ((hi$5 >= 0)) {
      var $x_2 = true;
    } else {
      var b0 = (65535 & lo$7);
      var b1 = ((lo$7 >>> 16) | 0);
      var a0b0 = Math.imul(12, b0);
      var a0b1 = Math.imul(12, b1);
      var lo$9 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$7 = ((Math.imul(12, hi$6) + ((c1part >>> 16) | 0)) | 0);
      var $x_2 = ((lo$9 === lo$6) && (hi$7 === hi$5));
    }
    if ($x_2) {
      var value__lo = lo$7;
      var value__hi = hi$6;
    } else {
      var lo$10 = (((-1) + lo$7) | 0);
      var hi$8 = (((((-1) + hi$6) | 0) + (((lo$7 | (~lo$10)) >>> 31) | 0)) | 0);
      var value__lo = lo$10;
      var value__hi = hi$8;
    }
    $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$1, new $c_RTLong(value__lo, value__hi));
  }
  var yoeLong = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField());
  if ((yoeLong !== null)) {
    if ((resolverStyle !== $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$21 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
      var t$3 = $uJ(yoeLong);
      var lo$11 = t$3.RTLong__f_lo;
      var hi$9 = t$3.RTLong__f_hi;
      this$21.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$11, hi$9), this$21);
    }
    var era = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
    if ((era === null)) {
      var year = fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
      if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle())) {
        if ((year !== null)) {
          var field$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
          var a = $uJ(year);
          var ahi = a.RTLong__f_hi;
          if (((ahi === 0) ? (a.RTLong__f_lo !== 0) : (ahi > 0))) {
            var t$5 = $uJ(yoeLong);
          } else {
            var t$4 = $uJ(yoeLong);
            var lo$12 = t$4.RTLong__f_lo;
            var hi$10 = t$4.RTLong__f_hi;
            var this$26 = $m_jl_Math$();
            var lo$13 = ((1 - lo$12) | 0);
            var hi$11 = ((((-hi$10) | 0) + ((lo$12 | lo$13) >> 31)) | 0);
            var hi$12 = (hi$10 & hi$11);
            if ((hi$12 < 0)) {
              this$26.java$lang$Math$$longOverflow__E();
            }
            var x$1__lo = lo$13;
            var x$1__hi = hi$11;
            var t$5 = new $c_RTLong(x$1__lo, x$1__hi);
          }
          var lo$17 = t$5.RTLong__f_lo;
          var hi$13 = t$5.RTLong__f_hi;
          $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$2, new $c_RTLong(lo$17, hi$13));
        } else {
          fieldValues.put__O__O__O($s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField(), yoeLong);
        }
      } else {
        var field$3 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        if ((year === null)) {
          var $x_3 = true;
        } else {
          var a$1 = $uJ(year);
          var ahi$1 = a$1.RTLong__f_hi;
          var $x_3 = ((ahi$1 === 0) ? (a$1.RTLong__f_lo !== 0) : (ahi$1 > 0));
        }
        if ($x_3) {
          var t$7 = $uJ(yoeLong);
        } else {
          var t$6 = $uJ(yoeLong);
          var lo$18 = t$6.RTLong__f_lo;
          var hi$14 = t$6.RTLong__f_hi;
          var this$36 = $m_jl_Math$();
          var lo$19 = ((1 - lo$18) | 0);
          var hi$15 = ((((-hi$14) | 0) + ((lo$18 | lo$19) >> 31)) | 0);
          var hi$16 = (hi$14 & hi$15);
          if ((hi$16 < 0)) {
            this$36.java$lang$Math$$longOverflow__E();
          }
          var x$2__lo = lo$19;
          var x$2__hi = hi$15;
          var t$7 = new $c_RTLong(x$2__lo, x$2__hi);
        }
        var lo$23 = t$7.RTLong__f_lo;
        var hi$17 = t$7.RTLong__f_hi;
        $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$3, new $c_RTLong(lo$23, hi$17));
      }
    } else if (((era.RTLong__f_lo === 1) && (era.RTLong__f_hi === 0))) {
      var field$4 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
      var t$8 = $uJ(yoeLong);
      var lo$24 = t$8.RTLong__f_lo;
      var hi$18 = t$8.RTLong__f_hi;
      $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$4, new $c_RTLong(lo$24, hi$18));
    } else if (((era.RTLong__f_lo === 0) && (era.RTLong__f_hi === 0))) {
      var field$5 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
      var t$9 = $uJ(yoeLong);
      var lo$25 = t$9.RTLong__f_lo;
      var hi$19 = t$9.RTLong__f_hi;
      var this$46 = $m_jl_Math$();
      var lo$26 = ((1 - lo$25) | 0);
      var hi$20 = ((((-hi$19) | 0) + ((lo$25 | lo$26) >> 31)) | 0);
      var hi$21 = (hi$19 & hi$20);
      if ((hi$21 < 0)) {
        this$46.java$lang$Math$$longOverflow__E();
      }
      $f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$5, new $c_RTLong(lo$26, hi$20));
    } else {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Invalid value for era: " + era));
    }
  } else if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField())) {
    var this$53 = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
    var x$3 = fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
    var t$10 = $uJ(x$3);
    var lo$30 = t$10.RTLong__f_lo;
    var hi$22 = t$10.RTLong__f_hi;
    this$53.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$30, hi$22), this$53);
  }
  if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField())) {
    if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField())) {
        var this$55 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        var x$4 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
        var t$11 = $uJ(x$4);
        var lo$31 = t$11.RTLong__f_lo;
        var hi$23 = t$11.RTLong__f_hi;
        var y = this$55.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$31, hi$23), this$55);
        var x$5 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
        var t$12 = $uJ(x$5);
        var lo$32 = t$12.RTLong__f_lo;
        var hi$24 = t$12.RTLong__f_hi;
        var this$57 = $m_jl_Math$();
        var hi$25 = (lo$32 >> 31);
        if ((hi$25 !== hi$24)) {
          this$57.java$lang$Math$$intOverflow__E();
        }
        var x$6 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
        var t$13 = $uJ(x$6);
        var lo$33 = t$13.RTLong__f_lo;
        var hi$26 = t$13.RTLong__f_hi;
        var this$62 = $m_jl_Math$();
        var hi$27 = (lo$33 >> 31);
        if ((hi$27 !== hi$26)) {
          this$62.java$lang$Math$$intOverflow__E();
        }
        var dom = lo$33;
        if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
          var hi$28 = (lo$32 >> 31);
          var this$67 = $m_jl_Math$();
          var lo$34 = (((-1) + lo$32) | 0);
          var hi$29 = (((((-1) + hi$28) | 0) + (((lo$32 | (~lo$34)) >>> 31) | 0)) | 0);
          var hi$30 = (hi$29 ^ hi$28);
          var hi$31 = (hi$28 & hi$30);
          if ((hi$31 < 0)) {
            this$67.java$lang$Math$$longOverflow__E();
          }
          var value$1 = dom;
          var hi$32 = (value$1 >> 31);
          var this$74 = $m_jl_Math$();
          var lo$38 = (((-1) + value$1) | 0);
          var hi$33 = (((((-1) + hi$32) | 0) + (((value$1 | (~lo$38)) >>> 31) | 0)) | 0);
          var hi$34 = (hi$33 ^ hi$32);
          var hi$35 = (hi$32 & hi$34);
          if ((hi$35 < 0)) {
            this$74.java$lang$Math$$longOverflow__E();
          }
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y, 1, 1).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$34, hi$29)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$38, hi$33));
        } else if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle())) {
          var this$81 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
          var value$2 = dom;
          var hi$36 = (value$2 >> 31);
          this$81.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(value$2, hi$36), this$81);
          if (((((lo$32 === 4) || (lo$32 === 6)) || (lo$32 === 9)) || (lo$32 === 11))) {
            var a$2 = dom;
            dom = ((a$2 < 30) ? a$2 : 30);
          } else if ((lo$32 === 2)) {
            var a$3 = dom;
            var $x_5 = $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month();
            var $x_4 = $m_Ljava_time_Year$();
            var hi$37 = (y >> 31);
            var b$1 = $x_5.length__Z__I($x_4.isLeap__J__Z(new $c_RTLong(y, hi$37)));
            dom = ((a$3 < b$1) ? a$3 : b$1);
          }
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y, lo$32, dom);
        } else {
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y, lo$32, dom);
        }
      }
      if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField())) {
        if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField())) {
          var this$86 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
          var x$7 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
          var t$14 = $uJ(x$7);
          var lo$42 = t$14.RTLong__f_lo;
          var hi$38 = t$14.RTLong__f_hi;
          var y$2 = this$86.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$42, hi$38), this$86);
          if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
            var x$8 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
            var t$15 = $uJ(x$8);
            var lo$43 = t$15.RTLong__f_lo;
            var hi$39 = t$15.RTLong__f_hi;
            var this$88 = $m_jl_Math$();
            var lo$44 = (((-1) + lo$43) | 0);
            var hi$40 = (((((-1) + hi$39) | 0) + (((lo$43 | (~lo$44)) >>> 31) | 0)) | 0);
            var hi$41 = (hi$40 ^ hi$39);
            var hi$42 = (hi$39 & hi$41);
            if ((hi$42 < 0)) {
              this$88.java$lang$Math$$longOverflow__E();
            }
            var x$9 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField());
            var t$16 = $uJ(x$9);
            var lo$48 = t$16.RTLong__f_lo;
            var hi$43 = t$16.RTLong__f_hi;
            var this$95 = $m_jl_Math$();
            var lo$49 = (((-1) + lo$48) | 0);
            var hi$44 = (((((-1) + hi$43) | 0) + (((lo$48 | (~lo$49)) >>> 31) | 0)) | 0);
            var hi$45 = (hi$44 ^ hi$43);
            var hi$46 = (hi$43 & hi$45);
            if ((hi$46 < 0)) {
              this$95.java$lang$Math$$longOverflow__E();
            }
            var x$10 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField());
            var t$17 = $uJ(x$10);
            var lo$53 = t$17.RTLong__f_lo;
            var hi$47 = t$17.RTLong__f_hi;
            var this$102 = $m_jl_Math$();
            var lo$54 = (((-1) + lo$53) | 0);
            var hi$48 = (((((-1) + hi$47) | 0) + (((lo$53 | (~lo$54)) >>> 31) | 0)) | 0);
            var hi$49 = (hi$48 ^ hi$47);
            var hi$50 = (hi$47 & hi$49);
            if ((hi$50 < 0)) {
              this$102.java$lang$Math$$longOverflow__E();
            }
            return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$2, 1, 1).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$44, hi$40)).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$49, hi$44)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$54, hi$48));
          }
          var this$109 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
          var x$11 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
          var t$18 = $uJ(x$11);
          var lo$58 = t$18.RTLong__f_lo;
          var hi$51 = t$18.RTLong__f_hi;
          var moy$2 = this$109.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$58, hi$51), this$109);
          var this$111 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
          var x$12 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField());
          var t$19 = $uJ(x$12);
          var lo$59 = t$19.RTLong__f_lo;
          var hi$52 = t$19.RTLong__f_hi;
          var aw = this$111.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$59, hi$52), this$111);
          var this$113 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
          var x$13 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField());
          var t$20 = $uJ(x$13);
          var lo$60 = t$20.RTLong__f_lo;
          var hi$53 = t$20.RTLong__f_hi;
          var ad = this$113.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$60, hi$53), this$113);
          var $x_6 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$2, moy$2, 1);
          var hi$54 = (aw >> 31);
          var lo$61 = (((-1) + aw) | 0);
          var hi$55 = (((((-1) + hi$54) | 0) + (((aw | (~lo$61)) >>> 31) | 0)) | 0);
          var b0$1 = (65535 & lo$61);
          var b1$1 = ((lo$61 >>> 16) | 0);
          var a0b0$1 = Math.imul(7, b0$1);
          var a0b1$1 = Math.imul(7, b1$1);
          var lo$62 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$56 = ((Math.imul(7, hi$55) + ((c1part$1 >>> 16) | 0)) | 0);
          var hi$57 = (ad >> 31);
          var lo$63 = (((-1) + ad) | 0);
          var hi$58 = (((((-1) + hi$57) | 0) + (((ad | (~lo$63)) >>> 31) | 0)) | 0);
          var lo$64 = ((lo$62 + lo$63) | 0);
          var hi$59 = ((((hi$56 + hi$58) | 0) + ((((lo$62 & lo$63) | ((lo$62 | lo$63) & (~lo$64))) >>> 31) | 0)) | 0);
          var date = $x_6.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$64, hi$59));
          if (((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) !== moy$2))) {
            throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month");
          }
          return date;
        }
        if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
          var this$121 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
          var x$14 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
          var t$21 = $uJ(x$14);
          var lo$65 = t$21.RTLong__f_lo;
          var hi$60 = t$21.RTLong__f_hi;
          var y$3 = this$121.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$65, hi$60), this$121);
          if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
            var x$15 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
            var t$22 = $uJ(x$15);
            var lo$66 = t$22.RTLong__f_lo;
            var hi$61 = t$22.RTLong__f_hi;
            var this$123 = $m_jl_Math$();
            var lo$67 = (((-1) + lo$66) | 0);
            var hi$62 = (((((-1) + hi$61) | 0) + (((lo$66 | (~lo$67)) >>> 31) | 0)) | 0);
            var hi$63 = (hi$62 ^ hi$61);
            var hi$64 = (hi$61 & hi$63);
            if ((hi$64 < 0)) {
              this$123.java$lang$Math$$longOverflow__E();
            }
            var x$16 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField());
            var t$23 = $uJ(x$16);
            var lo$71 = t$23.RTLong__f_lo;
            var hi$65 = t$23.RTLong__f_hi;
            var this$130 = $m_jl_Math$();
            var lo$72 = (((-1) + lo$71) | 0);
            var hi$66 = (((((-1) + hi$65) | 0) + (((lo$71 | (~lo$72)) >>> 31) | 0)) | 0);
            var hi$67 = (hi$66 ^ hi$65);
            var hi$68 = (hi$65 & hi$67);
            if ((hi$68 < 0)) {
              this$130.java$lang$Math$$longOverflow__E();
            }
            var x$17 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
            var t$24 = $uJ(x$17);
            var lo$76 = t$24.RTLong__f_lo;
            var hi$69 = t$24.RTLong__f_hi;
            var this$137 = $m_jl_Math$();
            var lo$77 = (((-1) + lo$76) | 0);
            var hi$70 = (((((-1) + hi$69) | 0) + (((lo$76 | (~lo$77)) >>> 31) | 0)) | 0);
            var hi$71 = (hi$70 ^ hi$69);
            var hi$72 = (hi$69 & hi$71);
            if ((hi$72 < 0)) {
              this$137.java$lang$Math$$longOverflow__E();
            }
            return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$3, 1, 1).plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$67, hi$62)).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$72, hi$66)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$77, hi$70));
          }
          var this$144 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
          var x$18 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
          var t$25 = $uJ(x$18);
          var lo$81 = t$25.RTLong__f_lo;
          var hi$73 = t$25.RTLong__f_hi;
          var moy$3 = this$144.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$81, hi$73), this$144);
          var this$146 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
          var x$19 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField());
          var t$26 = $uJ(x$19);
          var lo$82 = t$26.RTLong__f_lo;
          var hi$74 = t$26.RTLong__f_hi;
          var aw$2 = this$146.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$82, hi$74), this$146);
          var this$148 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
          var x$20 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
          var t$27 = $uJ(x$20);
          var lo$83 = t$27.RTLong__f_lo;
          var hi$75 = t$27.RTLong__f_hi;
          var dow = this$148.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$83, hi$75), this$148);
          var $x_8 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$3, moy$3, 1);
          var hi$76 = (aw$2 >> 31);
          var lo$84 = (((-1) + aw$2) | 0);
          var hi$77 = (((((-1) + hi$76) | 0) + (((aw$2 | (~lo$84)) >>> 31) | 0)) | 0);
          var $x_7 = $x_8.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$84, hi$77));
          var dayOfWeek = $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(dow);
          var date$2 = $x_7.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(new $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(0, dayOfWeek));
          if (((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date$2.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) !== moy$3))) {
            throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month");
          }
          return date$2;
        }
      }
    }
    if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      var this$153 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
      var x$21 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
      var t$28 = $uJ(x$21);
      var lo$85 = t$28.RTLong__f_lo;
      var hi$78 = t$28.RTLong__f_hi;
      var y$4 = this$153.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$85, hi$78), this$153);
      if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
        var x$22 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField());
        var t$29 = $uJ(x$22);
        var lo$86 = t$29.RTLong__f_lo;
        var hi$79 = t$29.RTLong__f_hi;
        var this$155 = $m_jl_Math$();
        var lo$87 = (((-1) + lo$86) | 0);
        var hi$80 = (((((-1) + hi$79) | 0) + (((lo$86 | (~lo$87)) >>> 31) | 0)) | 0);
        var hi$81 = (hi$80 ^ hi$79);
        var hi$82 = (hi$79 & hi$81);
        if ((hi$82 < 0)) {
          this$155.java$lang$Math$$longOverflow__E();
        }
        return $m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(y$4, 1).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$87, hi$80));
      }
      var this$162 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
      var x$23 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField());
      var t$30 = $uJ(x$23);
      var lo$91 = t$30.RTLong__f_lo;
      var hi$83 = t$30.RTLong__f_hi;
      var doy = this$162.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$91, hi$83), this$162);
      return $m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(y$4, doy);
    }
    if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField())) {
        var this$164 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        var x$24 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
        var t$31 = $uJ(x$24);
        var lo$92 = t$31.RTLong__f_lo;
        var hi$84 = t$31.RTLong__f_hi;
        var y$5 = this$164.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$92, hi$84), this$164);
        if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
          var x$25 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField());
          var t$32 = $uJ(x$25);
          var lo$93 = t$32.RTLong__f_lo;
          var hi$85 = t$32.RTLong__f_hi;
          var this$166 = $m_jl_Math$();
          var lo$94 = (((-1) + lo$93) | 0);
          var hi$86 = (((((-1) + hi$85) | 0) + (((lo$93 | (~lo$94)) >>> 31) | 0)) | 0);
          var hi$87 = (hi$86 ^ hi$85);
          var hi$88 = (hi$85 & hi$87);
          if ((hi$88 < 0)) {
            this$166.java$lang$Math$$longOverflow__E();
          }
          var x$26 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField());
          var t$33 = $uJ(x$26);
          var lo$98 = t$33.RTLong__f_lo;
          var hi$89 = t$33.RTLong__f_hi;
          var this$173 = $m_jl_Math$();
          var lo$99 = (((-1) + lo$98) | 0);
          var hi$90 = (((((-1) + hi$89) | 0) + (((lo$98 | (~lo$99)) >>> 31) | 0)) | 0);
          var hi$91 = (hi$90 ^ hi$89);
          var hi$92 = (hi$89 & hi$91);
          if ((hi$92 < 0)) {
            this$173.java$lang$Math$$longOverflow__E();
          }
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$5, 1, 1).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$94, hi$86)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$99, hi$90));
        }
        var this$180 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
        var x$27 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField());
        var t$34 = $uJ(x$27);
        var lo$103 = t$34.RTLong__f_lo;
        var hi$93 = t$34.RTLong__f_hi;
        var aw$3 = this$180.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$103, hi$93), this$180);
        var this$182 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
        var x$28 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField());
        var t$35 = $uJ(x$28);
        var lo$104 = t$35.RTLong__f_lo;
        var hi$94 = t$35.RTLong__f_hi;
        var ad$2 = this$182.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$104, hi$94), this$182);
        var $x_9 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$5, 1, 1);
        var hi$95 = (aw$3 >> 31);
        var lo$105 = (((-1) + aw$3) | 0);
        var hi$96 = (((((-1) + hi$95) | 0) + (((aw$3 | (~lo$105)) >>> 31) | 0)) | 0);
        var b0$2 = (65535 & lo$105);
        var b1$2 = ((lo$105 >>> 16) | 0);
        var a0b0$2 = Math.imul(7, b0$2);
        var a0b1$2 = Math.imul(7, b1$2);
        var lo$106 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
        var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
        var hi$97 = ((Math.imul(7, hi$96) + ((c1part$2 >>> 16) | 0)) | 0);
        var value$3 = (((-1) + ad$2) | 0);
        var hi$98 = (value$3 >> 31);
        var lo$107 = ((lo$106 + value$3) | 0);
        var hi$99 = ((((hi$97 + hi$98) | 0) + ((((lo$106 & value$3) | ((lo$106 | value$3) & (~lo$107))) >>> 31) | 0)) | 0);
        var date$3 = $x_9.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$107, hi$99));
        if (((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date$3.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()) !== y$5))) {
          throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different year");
        }
        return date$3;
      }
      if (fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
        var this$189 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        var x$29 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
        var t$36 = $uJ(x$29);
        var lo$108 = t$36.RTLong__f_lo;
        var hi$100 = t$36.RTLong__f_hi;
        var y$6 = this$189.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$108, hi$100), this$189);
        if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
          var x$30 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField());
          var t$37 = $uJ(x$30);
          var lo$109 = t$37.RTLong__f_lo;
          var hi$101 = t$37.RTLong__f_hi;
          var this$191 = $m_jl_Math$();
          var lo$110 = (((-1) + lo$109) | 0);
          var hi$102 = (((((-1) + hi$101) | 0) + (((lo$109 | (~lo$110)) >>> 31) | 0)) | 0);
          var hi$103 = (hi$102 ^ hi$101);
          var hi$104 = (hi$101 & hi$103);
          if ((hi$104 < 0)) {
            this$191.java$lang$Math$$longOverflow__E();
          }
          var x$31 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
          var t$38 = $uJ(x$31);
          var lo$114 = t$38.RTLong__f_lo;
          var hi$105 = t$38.RTLong__f_hi;
          var this$198 = $m_jl_Math$();
          var lo$115 = (((-1) + lo$114) | 0);
          var hi$106 = (((((-1) + hi$105) | 0) + (((lo$114 | (~lo$115)) >>> 31) | 0)) | 0);
          var hi$107 = (hi$106 ^ hi$105);
          var hi$108 = (hi$105 & hi$107);
          if ((hi$108 < 0)) {
            this$198.java$lang$Math$$longOverflow__E();
          }
          return $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$6, 1, 1).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$110, hi$102)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$115, hi$106));
        }
        var this$205 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
        var x$32 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField());
        var t$39 = $uJ(x$32);
        var lo$119 = t$39.RTLong__f_lo;
        var hi$109 = t$39.RTLong__f_hi;
        var aw$4 = this$205.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$119, hi$109), this$205);
        var this$207 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
        var x$33 = fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
        var t$40 = $uJ(x$33);
        var lo$120 = t$40.RTLong__f_lo;
        var hi$110 = t$40.RTLong__f_hi;
        var dow$2 = this$207.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$120, hi$110), this$207);
        var $x_11 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y$6, 1, 1);
        var hi$111 = (aw$4 >> 31);
        var lo$121 = (((-1) + aw$4) | 0);
        var hi$112 = (((((-1) + hi$111) | 0) + (((aw$4 | (~lo$121)) >>> 31) | 0)) | 0);
        var $x_10 = $x_11.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$121, hi$112));
        var dayOfWeek$1 = $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(dow$2);
        var date$4 = $x_10.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(new $c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(0, dayOfWeek$1));
        if (((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date$4.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()) !== y$6))) {
          throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month");
        }
        return date$4;
      }
    }
  }
  return null;
});
$c_Ljava_time_chrono_IsoChronology.prototype.compare__O__I = (function(that) {
  return $f_T__compareTo__T__I("ISO", "ISO");
});
function $isArrayOf_Ljava_time_chrono_IsoChronology(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_IsoChronology)));
}
export { $isArrayOf_Ljava_time_chrono_IsoChronology as $isArrayOf_Ljava_time_chrono_IsoChronology };
var $d_Ljava_time_chrono_IsoChronology = new $TypeData().initClass($c_Ljava_time_chrono_IsoChronology, "java.time.chrono.IsoChronology", ({
  Ljava_time_chrono_IsoChronology: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_time_chrono_Chronology: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_chrono_IsoChronology as $d_Ljava_time_chrono_IsoChronology };
/** @constructor */
function $c_ju_AbstractSet() {
}
export { $c_ju_AbstractSet as $c_ju_AbstractSet };
$c_ju_AbstractSet.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractSet.prototype.constructor = $c_ju_AbstractSet;
/** @constructor */
function $h_ju_AbstractSet() {
}
export { $h_ju_AbstractSet as $h_ju_AbstractSet };
$h_ju_AbstractSet.prototype = $c_ju_AbstractSet.prototype;
$c_ju_AbstractSet.prototype.equals__O__Z = (function(that) {
  return ((that === this) || ($is_ju_Collection(that) && ((that.size__I() === this.size__I()) && this.containsAll__ju_Collection__Z(that))));
});
$c_ju_AbstractSet.prototype.hashCode__I = (function() {
  var _\uff3fself = this.iterator__ju_Iterator();
  var result = 0;
  while (_\uff3fself.hasNext__Z()) {
    var t = result;
    var u = _\uff3fself.next__O();
    var t$1 = (t | 0);
    result = (($dp_hashCode__I(u) + t$1) | 0);
  }
  return (result | 0);
});
function $ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner) {
  $thiz.ju_Collections$UnmodifiableCollection__f_inner = inner;
  $thiz.ju_Collections$UnmodifiableCollection__f_eagerThrow = true;
  return $thiz;
}
export { $ct_ju_Collections$UnmodifiableCollection__ju_Collection__ as $ct_ju_Collections$UnmodifiableCollection__ju_Collection__ };
/** @constructor */
function $c_ju_Collections$UnmodifiableCollection() {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false;
}
export { $c_ju_Collections$UnmodifiableCollection as $c_ju_Collections$UnmodifiableCollection };
$c_ju_Collections$UnmodifiableCollection.prototype = new $h_O();
$c_ju_Collections$UnmodifiableCollection.prototype.constructor = $c_ju_Collections$UnmodifiableCollection;
/** @constructor */
function $h_ju_Collections$UnmodifiableCollection() {
}
export { $h_ju_Collections$UnmodifiableCollection as $h_ju_Collections$UnmodifiableCollection };
$h_ju_Collections$UnmodifiableCollection.prototype = $c_ju_Collections$UnmodifiableCollection.prototype;
$c_ju_Collections$UnmodifiableCollection.prototype.size__I = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.size__I();
});
$c_ju_Collections$UnmodifiableCollection.prototype.isEmpty__Z = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.isEmpty__Z();
});
$c_ju_Collections$UnmodifiableCollection.prototype.contains__O__Z = (function(o) {
  return this.ju_Collections$UnmodifiableCollection__f_inner.contains__O__Z(o);
});
$c_ju_Collections$UnmodifiableCollection.prototype.toArray__AO = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.toArray__AO();
});
$c_ju_Collections$UnmodifiableCollection.prototype.toArray__AO__AO = (function(a) {
  return this.ju_Collections$UnmodifiableCollection__f_inner.toArray__AO__AO(a);
});
$c_ju_Collections$UnmodifiableCollection.prototype.containsAll__ju_Collection__Z = (function(c) {
  return this.ju_Collections$UnmodifiableCollection__f_inner.containsAll__ju_Collection__Z(c);
});
$c_ju_Collections$UnmodifiableCollection.prototype.toString__T = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.toString__T();
});
$c_ju_Collections$UnmodifiableCollection.prototype.eagerThrow__Z = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_eagerThrow;
});
$c_ju_Collections$UnmodifiableCollection.prototype.iterator__ju_Iterator = (function() {
  return $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__(new $c_ju_Collections$UnmodifiableIterator(), this.ju_Collections$UnmodifiableCollection__f_inner.iterator__ju_Iterator());
});
$c_ju_Collections$UnmodifiableCollection.prototype.add__O__Z = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_Collections$UnmodifiableCollection.prototype.remove__O__Z = (function(o) {
  if ((this.eagerThrow__Z() || this.ju_Collections$UnmodifiableCollection__f_inner.contains__O__Z(o))) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  } else {
    return false;
  }
});
$c_ju_Collections$UnmodifiableCollection.prototype.retainAll__ju_Collection__Z = (function(c) {
  if (this.eagerThrow__Z()) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  } else {
    var _\uff3fself = this.iterator__ju_Iterator();
    while (_\uff3fself.hasNext__Z()) {
      var t = _\uff3fself.next__O();
      if ((!c.contains__O__Z(t))) {
        throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
      }
    }
    return false;
  }
});
class $c_ju_ConcurrentModificationException extends $c_jl_RuntimeException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
export { $c_ju_ConcurrentModificationException as $c_ju_ConcurrentModificationException };
var $d_ju_ConcurrentModificationException = new $TypeData().initClass($c_ju_ConcurrentModificationException, "java.util.ConcurrentModificationException", ({
  ju_ConcurrentModificationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_ConcurrentModificationException as $d_ju_ConcurrentModificationException };
function $p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz, key, defaultValue) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var node = $thiz.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + $thiz.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0)));
  return ((node === null) ? defaultValue : ($thiz.nodeWasAccessed__ju_HashMap$Node__V(node), node.ju_HashMap$Node__f_value));
}
export { $p_ju_HashMap__getOrDefaultImpl__O__O__O as $p_ju_HashMap__getOrDefaultImpl__O__O__O };
function $p_ju_HashMap__growTable__V($thiz) {
  var oldTable = $thiz.ju_HashMap__f_java$util$HashMap$$table;
  var oldlen = oldTable.u.length;
  var newlen = (oldlen << 1);
  var newTable = new ($d_ju_HashMap$Node.getArrayOf().constr)(newlen);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = newTable;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((newlen * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  var i = 0;
  while ((i < oldlen)) {
    var lastLow = null;
    var lastHigh = null;
    var node = oldTable.u[i];
    while ((node !== null)) {
      if (((node.ju_HashMap$Node__f_hash & oldlen) === 0)) {
        node.ju_HashMap$Node__f_previous = lastLow;
        if ((lastLow === null)) {
          newTable.u[i] = node;
        } else {
          lastLow.ju_HashMap$Node__f_next = node;
        }
        lastLow = node;
      } else {
        node.ju_HashMap$Node__f_previous = lastHigh;
        if ((lastHigh === null)) {
          newTable.u[((oldlen + i) | 0)] = node;
        } else {
          lastHigh.ju_HashMap$Node__f_next = node;
        }
        lastHigh = node;
      }
      node = node.ju_HashMap$Node__f_next;
    }
    if ((lastLow !== null)) {
      lastLow.ju_HashMap$Node__f_next = null;
    }
    if ((lastHigh !== null)) {
      lastHigh.ju_HashMap$Node__f_next = null;
    }
    i = ((1 + i) | 0);
  }
}
export { $p_ju_HashMap__growTable__V as $p_ju_HashMap__growTable__V };
function $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor = loadFactor;
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "initialCapacity < 0");
  }
  if ((loadFactor <= 0.0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "loadFactor <= 0.0");
  }
  var a = (((-1) + initialCapacity) | 0);
  var i = ((a > 4) ? a : 4);
  var a$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  $thiz.ju_HashMap__f_java$util$HashMap$$table = new ($d_ju_HashMap$Node.getArrayOf().constr)(((a$1 < 1073741824) ? a$1 : 1073741824));
  var size = $thiz.ju_HashMap__f_java$util$HashMap$$table.u.length;
  $thiz.ju_HashMap__f_threshold = $doubleToInt((size * $thiz.ju_HashMap__f_java$util$HashMap$$loadFactor));
  $thiz.ju_HashMap__f_contentSize = 0;
  return $thiz;
}
export { $ct_ju_HashMap__I__F__ as $ct_ju_HashMap__I__F__ };
function $ct_ju_HashMap__($thiz) {
  $ct_ju_HashMap__I__F__($thiz, 16, 0.75);
  return $thiz;
}
export { $ct_ju_HashMap__ as $ct_ju_HashMap__ };
function $ct_ju_HashMap__I__($thiz, initialCapacity) {
  $ct_ju_HashMap__I__F__($thiz, initialCapacity, 0.75);
  return $thiz;
}
export { $ct_ju_HashMap__I__ as $ct_ju_HashMap__I__ };
/** @constructor */
function $c_ju_HashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
}
export { $c_ju_HashMap as $c_ju_HashMap };
$c_ju_HashMap.prototype = new $h_ju_AbstractMap();
$c_ju_HashMap.prototype.constructor = $c_ju_HashMap;
/** @constructor */
function $h_ju_HashMap() {
}
export { $h_ju_HashMap as $h_ju_HashMap };
$h_ju_HashMap.prototype = $c_ju_HashMap.prototype;
$c_ju_HashMap.prototype.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node = (function(key, hash, value, previous, next) {
  return $ct_ju_HashMap$Node__O__I__O__ju_HashMap$Node__ju_HashMap$Node__(new $c_ju_HashMap$Node(), key, hash, value, previous, next);
});
$c_ju_HashMap.prototype.nodeWasAccessed__ju_HashMap$Node__V = (function(node) {
});
$c_ju_HashMap.prototype.nodeWasAdded__ju_HashMap$Node__V = (function(node) {
});
$c_ju_HashMap.prototype.nodeWasRemoved__ju_HashMap$Node__V = (function(node) {
});
$c_ju_HashMap.prototype.size__I = (function() {
  return this.ju_HashMap__f_contentSize;
});
$c_ju_HashMap.prototype.isEmpty__Z = (function() {
  return (this.ju_HashMap__f_contentSize === 0);
});
$c_ju_HashMap.prototype.get__O__O = (function(key) {
  return $p_ju_HashMap__getOrDefaultImpl__O__O__O(this, key, null);
});
$c_ju_HashMap.prototype.containsKey__O__Z = (function(key) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  return (this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0))) !== null);
});
$c_ju_HashMap.prototype.put__O__O__O = (function(key, value) {
  if ((key === null)) {
    var $x_1 = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  return this.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $x_1, false);
});
$c_ju_HashMap.prototype.putAll__ju_Map__V = (function(m) {
  if ((m instanceof $c_ju_HashMap)) {
    var iter = m.nodeIterator__ju_Iterator();
    while (iter.hasNext__Z()) {
      var next = iter.next__O();
      this.java$util$HashMap$$put0__O__O__I__Z__O(next.ju_HashMap$Node__f_key, next.ju_HashMap$Node__f_value, next.ju_HashMap$Node__f_hash, false);
    }
  } else {
    $c_ju_AbstractMap.prototype.putAll__ju_Map__V.call(this, m);
  }
});
$c_ju_HashMap.prototype.remove__O__O = (function(key) {
  var node = this.java$util$HashMap$$remove0__O__ju_HashMap$Node(key);
  return ((node === null) ? null : node.ju_HashMap$Node__f_value);
});
$c_ju_HashMap.prototype.keySet__ju_Set = (function() {
  return new $c_ju_HashMap$KeySet(this);
});
$c_ju_HashMap.prototype.entrySet__ju_Set = (function() {
  return new $c_ju_HashMap$EntrySet(this);
});
$c_ju_HashMap.prototype.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node = (function(key, hash, idx) {
  var node = this.ju_HashMap__f_java$util$HashMap$$table.u[idx];
  while (true) {
    if ((node === null)) {
      return null;
    } else {
      if ((hash === node.ju_HashMap$Node__f_hash)) {
        var b = node.ju_HashMap$Node__f_key;
        var $x_1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        return node;
      } else if ((hash < node.ju_HashMap$Node__f_hash)) {
        return null;
      } else {
        node = node.ju_HashMap$Node__f_next;
      }
    }
  }
});
$c_ju_HashMap.prototype.java$util$HashMap$$put0__O__O__I__Z__O = (function(key, value, hash, ifAbsent) {
  var newContentSize = ((1 + this.ju_HashMap__f_contentSize) | 0);
  if ((newContentSize >= this.ju_HashMap__f_threshold)) {
    $p_ju_HashMap__growTable__V(this);
  }
  var idx = (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0));
  var x1 = this.ju_HashMap__f_java$util$HashMap$$table.u[idx];
  if ((x1 === null)) {
    var newNode = this.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node(key, hash, value, null, null);
    this.ju_HashMap__f_java$util$HashMap$$table.u[idx] = newNode;
    var newNode$3 = newNode;
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.ju_HashMap$Node__f_hash <= hash))) {
      if ((n.ju_HashMap$Node__f_hash === hash)) {
        var b = n.ju_HashMap$Node__f_key;
        var $x_1 = ((key === null) ? (b === null) : $dp_equals__O__Z(key, b));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        this.nodeWasAccessed__ju_HashMap$Node__V(n);
        var old = n.ju_HashMap$Node__f_value;
        if (((!ifAbsent) || (old === null))) {
          n.ju_HashMap$Node__f_value = value;
        }
        return old;
      }
      prev = n;
      n = n.ju_HashMap$Node__f_next;
    }
    var newNode$2 = this.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node(key, hash, value, prev, n);
    if ((prev === null)) {
      this.ju_HashMap__f_java$util$HashMap$$table.u[idx] = newNode$2;
    } else {
      prev.ju_HashMap$Node__f_next = newNode$2;
    }
    if ((n !== null)) {
      n.ju_HashMap$Node__f_previous = newNode$2;
    }
    var newNode$3 = newNode$2;
  }
  this.ju_HashMap__f_contentSize = newContentSize;
  this.nodeWasAdded__ju_HashMap$Node__V(newNode$3);
  return null;
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__O__ju_HashMap$Node = (function(key) {
  if ((key === null)) {
    var hash = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var idx = (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0));
  var node = this.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
  if ((node !== null)) {
    this.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, idx);
  }
  return node;
});
$c_ju_HashMap.prototype.removeNode__ju_HashMap$Node__V = (function(node) {
  var hash = node.ju_HashMap$Node__f_hash;
  this.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, (hash & (((-1) + this.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0)));
});
$c_ju_HashMap.prototype.java$util$HashMap$$remove0__ju_HashMap$Node__I__V = (function(node, idx) {
  var previous = node.ju_HashMap$Node__f_previous;
  var next = node.ju_HashMap$Node__f_next;
  if ((previous === null)) {
    this.ju_HashMap__f_java$util$HashMap$$table.u[idx] = next;
  } else {
    previous.ju_HashMap$Node__f_next = next;
  }
  if ((next !== null)) {
    next.ju_HashMap$Node__f_previous = previous;
  }
  this.ju_HashMap__f_contentSize = (((-1) + this.ju_HashMap__f_contentSize) | 0);
  this.nodeWasRemoved__ju_HashMap$Node__V(node);
});
$c_ju_HashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_HashMap$NodeIterator(this);
});
$c_ju_HashMap.prototype.keyIterator__ju_Iterator = (function() {
  return new $c_ju_HashMap$KeyIterator(this);
});
function $isArrayOf_ju_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.ju_HashMap)));
}
export { $isArrayOf_ju_HashMap as $isArrayOf_ju_HashMap };
var $d_ju_HashMap = new $TypeData().initClass($c_ju_HashMap, "java.util.HashMap", ({
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
}));
export { $d_ju_HashMap as $d_ju_HashMap };
function $ct_ju_IllformedLocaleException__T__I__($thiz, s, errorIndex) {
  var s$1 = (s + ((errorIndex < 0) ? "" : ((" [at index " + errorIndex) + "]")));
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s$1, null, true, true);
  return $thiz;
}
export { $ct_ju_IllformedLocaleException__T__I__ as $ct_ju_IllformedLocaleException__T__I__ };
function $ct_ju_IllformedLocaleException__T__($thiz, s) {
  $ct_ju_IllformedLocaleException__T__I__($thiz, s, (-1));
  return $thiz;
}
export { $ct_ju_IllformedLocaleException__T__ as $ct_ju_IllformedLocaleException__T__ };
class $c_ju_IllformedLocaleException extends $c_jl_RuntimeException {
}
export { $c_ju_IllformedLocaleException as $c_ju_IllformedLocaleException };
var $d_ju_IllformedLocaleException = new $TypeData().initClass($c_ju_IllformedLocaleException, "java.util.IllformedLocaleException", ({
  ju_IllformedLocaleException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_IllformedLocaleException as $d_ju_IllformedLocaleException };
/** @constructor */
function $c_ju_Locale$$anon$1() {
}
export { $c_ju_Locale$$anon$1 as $c_ju_Locale$$anon$1 };
$c_ju_Locale$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_ju_Locale$$anon$1.prototype.constructor = $c_ju_Locale$$anon$1;
/** @constructor */
function $h_ju_Locale$$anon$1() {
}
export { $h_ju_Locale$$anon$1 as $h_ju_Locale$$anon$1 };
$h_ju_Locale$$anon$1.prototype = $c_ju_Locale$$anon$1.prototype;
$c_ju_Locale$$anon$1.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    x._1__O();
    var x7 = x._2__O();
    if ((x7 === "")) {
      return true;
    }
    return true;
  }
  return false;
});
$c_ju_Locale$$anon$1.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x11 = x._1__O();
    var x12 = x._2__O();
    if ((x12 === "")) {
      return x11;
    }
    return ((x11 + "-") + x12);
  }
  return default$1.apply__O__O(x);
});
$c_ju_Locale$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z(x);
});
$c_ju_Locale$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O(x, default$1);
});
var $d_ju_Locale$$anon$1 = new $TypeData().initClass($c_ju_Locale$$anon$1, "java.util.Locale$$anon$1", ({
  ju_Locale$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_Locale$$anon$1 as $d_ju_Locale$$anon$1 };
function $ct_ju_NoSuchElementException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_ju_NoSuchElementException__T__ as $ct_ju_NoSuchElementException__T__ };
function $ct_ju_NoSuchElementException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
export { $ct_ju_NoSuchElementException__ as $ct_ju_NoSuchElementException__ };
class $c_ju_NoSuchElementException extends $c_jl_RuntimeException {
}
export { $c_ju_NoSuchElementException as $c_ju_NoSuchElementException };
var $d_ju_NoSuchElementException = new $TypeData().initClass($c_ju_NoSuchElementException, "java.util.NoSuchElementException", ({
  ju_NoSuchElementException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_NoSuchElementException as $d_ju_NoSuchElementException };
/** @constructor */
function $c_ju_RandomAccessListIterator(list, i, start, end) {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
  this.ju_RandomAccessListIterator__f_list = null;
  this.ju_RandomAccessListIterator__f_list = list;
  $ct_ju_AbstractRandomAccessListIterator__I__I__I__(this, i, start, end);
}
export { $c_ju_RandomAccessListIterator as $c_ju_RandomAccessListIterator };
$c_ju_RandomAccessListIterator.prototype = new $h_ju_AbstractRandomAccessListIterator();
$c_ju_RandomAccessListIterator.prototype.constructor = $c_ju_RandomAccessListIterator;
/** @constructor */
function $h_ju_RandomAccessListIterator() {
}
export { $h_ju_RandomAccessListIterator as $h_ju_RandomAccessListIterator };
$h_ju_RandomAccessListIterator.prototype = $c_ju_RandomAccessListIterator.prototype;
$c_ju_RandomAccessListIterator.prototype.get__I__O = (function(index) {
  return this.ju_RandomAccessListIterator__f_list.get__I__O(index);
});
$c_ju_RandomAccessListIterator.prototype.set__I__O__V = (function(index, e) {
  this.ju_RandomAccessListIterator__f_list.set__I__O__O(index, e);
});
$c_ju_RandomAccessListIterator.prototype.remove__I__V = (function(index) {
  this.ju_RandomAccessListIterator__f_list.remove__I__O(index);
});
var $d_ju_RandomAccessListIterator = new $TypeData().initClass($c_ju_RandomAccessListIterator, "java.util.RandomAccessListIterator", ({
  ju_RandomAccessListIterator: 1,
  ju_AbstractRandomAccessListIterator: 1,
  ju_ListIterator: 1,
  ju_Iterator: 1,
  ju_SizeChangeEvent: 1
}));
export { $d_ju_RandomAccessListIterator as $d_ju_RandomAccessListIterator };
function $ct_ju_concurrent_ConcurrentHashMap__I__F__($thiz, initialCapacity, loadFactor) {
  $thiz.ju_concurrent_ConcurrentHashMap__f_inner = new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap(initialCapacity, loadFactor);
  return $thiz;
}
export { $ct_ju_concurrent_ConcurrentHashMap__I__F__ as $ct_ju_concurrent_ConcurrentHashMap__I__F__ };
function $ct_ju_concurrent_ConcurrentHashMap__I__($thiz, initialCapacity) {
  $ct_ju_concurrent_ConcurrentHashMap__I__F__($thiz, initialCapacity, 0.75);
  return $thiz;
}
export { $ct_ju_concurrent_ConcurrentHashMap__I__ as $ct_ju_concurrent_ConcurrentHashMap__I__ };
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap() {
  this.ju_concurrent_ConcurrentHashMap__f_inner = null;
}
export { $c_ju_concurrent_ConcurrentHashMap as $c_ju_concurrent_ConcurrentHashMap };
$c_ju_concurrent_ConcurrentHashMap.prototype = new $h_ju_AbstractMap();
$c_ju_concurrent_ConcurrentHashMap.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap() {
}
export { $h_ju_concurrent_ConcurrentHashMap as $h_ju_concurrent_ConcurrentHashMap };
$h_ju_concurrent_ConcurrentHashMap.prototype = $c_ju_concurrent_ConcurrentHashMap.prototype;
$c_ju_concurrent_ConcurrentHashMap.prototype.size__I = (function() {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.ju_HashMap__f_contentSize;
});
$c_ju_concurrent_ConcurrentHashMap.prototype.isEmpty__Z = (function() {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.isEmpty__Z();
});
$c_ju_concurrent_ConcurrentHashMap.prototype.get__O__O = (function(key) {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.get__O__O(key);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.containsKey__O__Z = (function(key) {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.containsKey__O__Z(key);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.put__O__O__O = (function(key, value) {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.put__O__O__O(key, value);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.remove__O__O = (function(key) {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.remove__O__O(key);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.keySet__ju_concurrent_ConcurrentHashMap$KeySetView = (function() {
  return new $c_ju_concurrent_ConcurrentHashMap$KeySetView(this.ju_concurrent_ConcurrentHashMap__f_inner, null);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.entrySet__ju_Set = (function() {
  var this$1 = this.ju_concurrent_ConcurrentHashMap__f_inner;
  return new $c_ju_HashMap$EntrySet(this$1);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.hashCode__I = (function() {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.hashCode__I();
});
$c_ju_concurrent_ConcurrentHashMap.prototype.toString__T = (function() {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.toString__T();
});
$c_ju_concurrent_ConcurrentHashMap.prototype.equals__O__Z = (function(o) {
  return this.ju_concurrent_ConcurrentHashMap__f_inner.equals__O__Z(o);
});
$c_ju_concurrent_ConcurrentHashMap.prototype.keySet__ju_Set = (function() {
  return this.keySet__ju_concurrent_ConcurrentHashMap$KeySetView();
});
var $d_ju_concurrent_ConcurrentHashMap = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap, "java.util.concurrent.ConcurrentHashMap", ({
  ju_concurrent_ConcurrentHashMap: 1,
  ju_AbstractMap: 1,
  ju_Map: 1,
  ju_concurrent_ConcurrentMap: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_ConcurrentHashMap as $d_ju_concurrent_ConcurrentHashMap };
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$KeySetView(innerMap, defaultValue) {
  this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap = null;
  this.ju_concurrent_ConcurrentHashMap$KeySetView__f_defaultValue = null;
  this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap = innerMap;
  this.ju_concurrent_ConcurrentHashMap$KeySetView__f_defaultValue = defaultValue;
}
export { $c_ju_concurrent_ConcurrentHashMap$KeySetView as $c_ju_concurrent_ConcurrentHashMap$KeySetView };
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype = new $h_O();
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$KeySetView;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$KeySetView() {
}
export { $h_ju_concurrent_ConcurrentHashMap$KeySetView as $h_ju_concurrent_ConcurrentHashMap$KeySetView };
$h_ju_concurrent_ConcurrentHashMap$KeySetView.prototype = $c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype;
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.contains__O__Z = (function(o) {
  return this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap.containsKey__O__Z(o);
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.remove__O__Z = (function(o) {
  return (this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap.remove__O__O(o) !== null);
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.iterator__ju_Iterator = (function() {
  var this$1 = this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap;
  return new $c_ju_HashMap$KeySet(this$1).iterator__ju_Iterator();
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.size__I = (function() {
  return this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap.ju_HashMap__f_contentSize;
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.isEmpty__Z = (function() {
  return this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap.isEmpty__Z();
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.toArray__AO = (function() {
  var this$1 = this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap;
  return new $c_ju_HashMap$KeySet(this$1).toArray__AO();
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.toArray__AO__AO = (function(a) {
  var this$1 = this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap;
  return new $c_ju_HashMap$KeySet(this$1).toArray__AO__AO(a);
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.add__O__Z = (function(e) {
  if ((this.ju_concurrent_ConcurrentHashMap$KeySetView__f_defaultValue === null)) {
    throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
  }
  return (this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap.putIfAbsent__O__O__O(e, this.ju_concurrent_ConcurrentHashMap$KeySetView__f_defaultValue) === null);
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.toString__T = (function() {
  var this$1 = this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap;
  return new $c_ju_HashMap$KeySet(this$1).toString__T();
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.containsAll__ju_Collection__Z = (function(c) {
  var this$1 = this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap;
  return new $c_ju_HashMap$KeySet(this$1).containsAll__ju_Collection__Z(c);
});
$c_ju_concurrent_ConcurrentHashMap$KeySetView.prototype.retainAll__ju_Collection__Z = (function(c) {
  var this$1 = this.ju_concurrent_ConcurrentHashMap$KeySetView__f_innerMap;
  return new $c_ju_HashMap$KeySet(this$1).retainAll__ju_Collection__Z(c);
});
var $d_ju_concurrent_ConcurrentHashMap$KeySetView = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap$KeySetView, "java.util.concurrent.ConcurrentHashMap$KeySetView", ({
  ju_concurrent_ConcurrentHashMap$KeySetView: 1,
  ju_Set: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_ConcurrentHashMap$KeySetView as $d_ju_concurrent_ConcurrentHashMap$KeySetView };
/** @constructor */
function $c_ju_concurrent_CopyOnWriteArrayListIterator(arraySnapshot, i, start, end) {
  this.ju_AbstractRandomAccessListIterator__f_i = 0;
  this.ju_AbstractRandomAccessListIterator__f_end = 0;
  this.ju_AbstractRandomAccessListIterator__f_last = 0;
  this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot = null;
  this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot = arraySnapshot;
  $ct_ju_AbstractRandomAccessListIterator__I__I__I__(this, i, start, end);
}
export { $c_ju_concurrent_CopyOnWriteArrayListIterator as $c_ju_concurrent_CopyOnWriteArrayListIterator };
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype = new $h_ju_AbstractRandomAccessListIterator();
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.constructor = $c_ju_concurrent_CopyOnWriteArrayListIterator;
/** @constructor */
function $h_ju_concurrent_CopyOnWriteArrayListIterator() {
}
export { $h_ju_concurrent_CopyOnWriteArrayListIterator as $h_ju_concurrent_CopyOnWriteArrayListIterator };
$h_ju_concurrent_CopyOnWriteArrayListIterator.prototype = $c_ju_concurrent_CopyOnWriteArrayListIterator.prototype;
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.remove__V = (function() {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.set__O__V = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.get__I__O = (function(index) {
  var v = this.ju_concurrent_CopyOnWriteArrayListIterator__f_arraySnapshot;
  return v[index];
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.remove__I__V = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_concurrent_CopyOnWriteArrayListIterator.prototype.set__I__O__V = (function(index, e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
var $d_ju_concurrent_CopyOnWriteArrayListIterator = new $TypeData().initClass($c_ju_concurrent_CopyOnWriteArrayListIterator, "java.util.concurrent.CopyOnWriteArrayListIterator", ({
  ju_concurrent_CopyOnWriteArrayListIterator: 1,
  ju_AbstractRandomAccessListIterator: 1,
  ju_ListIterator: 1,
  ju_Iterator: 1,
  ju_SizeChangeEvent: 1
}));
export { $d_ju_concurrent_CopyOnWriteArrayListIterator as $d_ju_concurrent_CopyOnWriteArrayListIterator };
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "NANOSECONDS", 0);
}
export { $c_ju_concurrent_TimeUnit$$anon$1 as $c_ju_concurrent_TimeUnit$$anon$1 };
$c_ju_concurrent_TimeUnit$$anon$1.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$1.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$1;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$1() {
}
export { $h_ju_concurrent_TimeUnit$$anon$1 as $h_ju_concurrent_TimeUnit$$anon$1 };
$h_ju_concurrent_TimeUnit$$anon$1.prototype = $c_ju_concurrent_TimeUnit$$anon$1.prototype;
$c_ju_concurrent_TimeUnit$$anon$1.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toNanos__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toNanos__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMicros__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-129542144), 13);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 817405952, 838);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$1.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-1857093632), 20116);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$1 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$1, "java.util.concurrent.TimeUnit$$anon$1", ({
  ju_concurrent_TimeUnit$$anon$1: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_TimeUnit$$anon$1 as $d_ju_concurrent_TimeUnit$$anon$1 };
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MICROSECONDS", 1);
}
export { $c_ju_concurrent_TimeUnit$$anon$2 as $c_ju_concurrent_TimeUnit$$anon$2 };
$c_ju_concurrent_TimeUnit$$anon$2.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$2.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$2;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$2() {
}
export { $h_ju_concurrent_TimeUnit$$anon$2 as $h_ju_concurrent_TimeUnit$$anon$2 };
$h_ju_concurrent_TimeUnit$$anon$2.prototype = $c_ju_concurrent_TimeUnit$$anon$2.prototype;
$c_ju_concurrent_TimeUnit$$anon$2.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMicros__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483));
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMicros__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMillis__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, (-694967296), 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$2.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 500654080, 20);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$2 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$2, "java.util.concurrent.TimeUnit$$anon$2", ({
  ju_concurrent_TimeUnit$$anon$2: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_TimeUnit$$anon$2 as $d_ju_concurrent_TimeUnit$$anon$2 };
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MILLISECONDS", 2);
}
export { $c_ju_concurrent_TimeUnit$$anon$3 as $c_ju_concurrent_TimeUnit$$anon$3 };
$c_ju_concurrent_TimeUnit$$anon$3.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$3.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$3;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$3() {
}
export { $h_ju_concurrent_TimeUnit$$anon$3 as $h_ju_concurrent_TimeUnit$$anon$3 };
$h_ju_concurrent_TimeUnit$$anon$3.prototype = $c_ju_concurrent_TimeUnit$$anon$3.prototype;
$c_ju_concurrent_TimeUnit$$anon$3.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMillis__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147));
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483));
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMillis__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toSeconds__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$3.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$3 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$3, "java.util.concurrent.TimeUnit$$anon$3", ({
  ju_concurrent_TimeUnit$$anon$3: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_TimeUnit$$anon$3 as $d_ju_concurrent_TimeUnit$$anon$3 };
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "SECONDS", 3);
}
export { $c_ju_concurrent_TimeUnit$$anon$4 as $c_ju_concurrent_TimeUnit$$anon$4 };
$c_ju_concurrent_TimeUnit$$anon$4.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$4.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$4;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$4() {
}
export { $h_ju_concurrent_TimeUnit$$anon$4 as $h_ju_concurrent_TimeUnit$$anon$4 };
$h_ju_concurrent_TimeUnit$$anon$4.prototype = $c_ju_concurrent_TimeUnit$$anon$4.prototype;
$c_ju_concurrent_TimeUnit$$anon$4.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toSeconds__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000000, 0), new $c_RTLong(633437444, 2));
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000000, 0), new $c_RTLong(2077252342, 2147));
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1000, 0), new $c_RTLong((-1511828489), 2147483));
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toSeconds__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toMinutes__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3600, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$4.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 86400, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$4 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$4, "java.util.concurrent.TimeUnit$$anon$4", ({
  ju_concurrent_TimeUnit$$anon$4: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_TimeUnit$$anon$4 as $d_ju_concurrent_TimeUnit$$anon$4 };
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "MINUTES", 4);
}
export { $c_ju_concurrent_TimeUnit$$anon$5 as $c_ju_concurrent_TimeUnit$$anon$5 };
$c_ju_concurrent_TimeUnit$$anon$5.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$5.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$5;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$5() {
}
export { $h_ju_concurrent_TimeUnit$$anon$5 as $h_ju_concurrent_TimeUnit$$anon$5 };
$h_ju_concurrent_TimeUnit$$anon$5.prototype = $c_ju_concurrent_TimeUnit$$anon$5.prototype;
$c_ju_concurrent_TimeUnit$$anon$5.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toMinutes__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-129542144), 13), new $c_RTLong(153722867, 0));
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000000, 0), new $c_RTLong((-895955376), 35));
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60000, 0), new $c_RTLong(1692789776, 35791));
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394));
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toMinutes__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toHours__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 60, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
$c_ju_concurrent_TimeUnit$$anon$5.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1440, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$5 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$5, "java.util.concurrent.TimeUnit$$anon$5", ({
  ju_concurrent_TimeUnit$$anon$5: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_TimeUnit$$anon$5 as $d_ju_concurrent_TimeUnit$$anon$5 };
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "HOURS", 5);
}
export { $c_ju_concurrent_TimeUnit$$anon$6 as $c_ju_concurrent_TimeUnit$$anon$6 };
$c_ju_concurrent_TimeUnit$$anon$6.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$6.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$6;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$6() {
}
export { $h_ju_concurrent_TimeUnit$$anon$6 as $h_ju_concurrent_TimeUnit$$anon$6 };
$h_ju_concurrent_TimeUnit$$anon$6.prototype = $c_ju_concurrent_TimeUnit$$anon$6.prototype;
$c_ju_concurrent_TimeUnit$$anon$6.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toHours__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(817405952, 838), new $c_RTLong(2562047, 0));
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-694967296), 0), new $c_RTLong((-1732919508), 0));
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600000, 0), new $c_RTLong((-2047687697), 596));
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(3600, 0), new $c_RTLong(1011703407, 596523));
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(60, 0), new $c_RTLong(572662306, 35791394));
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toHours__J__J = (function(a) {
  return a;
});
$c_ju_concurrent_TimeUnit$$anon$6.prototype.toDays__J__J = (function(a) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 24, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
});
var $d_ju_concurrent_TimeUnit$$anon$6 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$6, "java.util.concurrent.TimeUnit$$anon$6", ({
  ju_concurrent_TimeUnit$$anon$6: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_TimeUnit$$anon$6 as $d_ju_concurrent_TimeUnit$$anon$6 };
/** @constructor */
function $c_ju_concurrent_TimeUnit$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "DAYS", 6);
}
export { $c_ju_concurrent_TimeUnit$$anon$7 as $c_ju_concurrent_TimeUnit$$anon$7 };
$c_ju_concurrent_TimeUnit$$anon$7.prototype = new $h_ju_concurrent_TimeUnit();
$c_ju_concurrent_TimeUnit$$anon$7.prototype.constructor = $c_ju_concurrent_TimeUnit$$anon$7;
/** @constructor */
function $h_ju_concurrent_TimeUnit$$anon$7() {
}
export { $h_ju_concurrent_TimeUnit$$anon$7 as $h_ju_concurrent_TimeUnit$$anon$7 };
$h_ju_concurrent_TimeUnit$$anon$7.prototype = $c_ju_concurrent_TimeUnit$$anon$7.prototype;
$c_ju_concurrent_TimeUnit$$anon$7.prototype.convert__J__ju_concurrent_TimeUnit__J = (function(a, u) {
  return u.toDays__J__J(a);
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toNanos__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong((-1857093632), 20116), new $c_RTLong(106751, 0));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMicros__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(500654080, 20), new $c_RTLong(106751991, 0));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMillis__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400000, 0), new $c_RTLong((-622191233), 24));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toSeconds__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(86400, 0), new $c_RTLong(579025220, 24855));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toMinutes__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(1440, 0), new $c_RTLong(381774870, 1491308));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toHours__J__J = (function(a) {
  return $m_ju_concurrent_TimeUnit$().java$util$concurrent$TimeUnit$$x__J__J__J__J(a, new $c_RTLong(24, 0), new $c_RTLong(1431655765, 89478485));
});
$c_ju_concurrent_TimeUnit$$anon$7.prototype.toDays__J__J = (function(a) {
  return a;
});
var $d_ju_concurrent_TimeUnit$$anon$7 = new $TypeData().initClass($c_ju_concurrent_TimeUnit$$anon$7, "java.util.concurrent.TimeUnit$$anon$7", ({
  ju_concurrent_TimeUnit$$anon$7: 1,
  ju_concurrent_TimeUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_TimeUnit$$anon$7 as $d_ju_concurrent_TimeUnit$$anon$7 };
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3fen$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  var value = $m_Llocales_cldr_fallback_data_\uff3froot$();
  var $x_8 = new $c_s_Some(value);
  var territory = $m_s_None$();
  var variant = $m_s_None$();
  var script = $m_s_None$();
  var $x_7 = new $c_Llocales_cldr_LDMLLocale("en", territory, variant, script);
  var $x_6 = $m_s_None$();
  var $x_4 = $m_sr_ScalaRunTime$();
  var ns = $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  var aliasOf = $m_s_None$();
  var decimal = new $c_s_Some($bC(46));
  var group = new $c_s_Some($bC(44));
  var list = new $c_s_Some($bC(59));
  var percent = new $c_s_Some($bC(37));
  var minus = new $c_s_Some($bC(45));
  var perMille = new $c_s_Some($bC(8240));
  var infinity = new $c_s_Some("\u221e");
  var nan = new $c_s_Some("NaN");
  var exp = new $c_s_Some("E");
  var elems = $x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_Llocales_cldr_Symbols.getArrayOf().constr)([new $c_Llocales_cldr_Symbols(ns, aliasOf, decimal, group, list, percent, minus, perMille, infinity, nan, exp)]));
  var $x_5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]));
  var months = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  var elems$2 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]));
  var shortMonths = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  var elems$3 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]));
  var weekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3);
  var elems$4 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]));
  var shortWeekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$4);
  var elems$5 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["AM", "PM"]));
  var amPm = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$5);
  var elems$6 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["BC", "AD"]));
  var eras = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$6);
  var value$1 = new $c_Llocales_cldr_CalendarSymbols(months, shortMonths, weekdays, shortWeekdays, amPm, eras);
  var $x_3 = new $c_s_Some(value$1);
  $m_Llocales_cldr_CalendarPatterns$();
  var this$26 = $m_sci_Map$();
  var elems$7 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), 0, "EEEE, MMMM d, y"), $ct_T2__O__O__(new $c_T2(), 1, "MMMM d, y"), $ct_T2__O__O__(new $c_T2(), 2, "MMM d, y"), $ct_T2__O__O__(new $c_T2(), 3, "M/d/yy")]));
  var datePatterns = this$26.from__sc_IterableOnce__sci_Map(elems$7);
  var this$31 = $m_sci_Map$();
  var elems$8 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), 0, "h:mm:ss a zzzz"), $ct_T2__O__O__(new $c_T2(), 1, "h:mm:ss a z"), $ct_T2__O__O__(new $c_T2(), 2, "h:mm:ss a"), $ct_T2__O__O__(new $c_T2(), 3, "h:mm a")]));
  var timePatterns = this$31.from__sc_IterableOnce__sci_Map(elems$8);
  var value$2 = new $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns);
  var $x_2 = new $c_s_Some(value$2);
  var elems$9 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var $x_1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$9);
  var decimalFormat = new $c_s_Some("#,##0.###");
  var percentFormat = new $c_s_Some("#,##0%");
  var currencyFormat = new $c_s_Some("\u00a4#,##0.00;(\u00a4#,##0.00)");
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $x_8, $x_7, $x_6, $x_5, $x_3, $x_2, $x_1, new $c_Llocales_cldr_NumberPatterns(decimalFormat, percentFormat, currencyFormat));
}
export { $c_Llocales_cldr_fallback_data_\uff3fen$ as $c_Llocales_cldr_fallback_data_\uff3fen$ };
$c_Llocales_cldr_fallback_data_\uff3fen$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_fallback_data_\uff3fen$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3fen$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3fen$() {
}
export { $h_Llocales_cldr_fallback_data_\uff3fen$ as $h_Llocales_cldr_fallback_data_\uff3fen$ };
$h_Llocales_cldr_fallback_data_\uff3fen$.prototype = $c_Llocales_cldr_fallback_data_\uff3fen$.prototype;
var $d_Llocales_cldr_fallback_data_\uff3fen$ = new $TypeData().initClass($c_Llocales_cldr_fallback_data_\uff3fen$, "locales.cldr.fallback.data._en$", ({
  Llocales_cldr_fallback_data_\uff3fen$: 1,
  Llocales_cldr_LDML: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Llocales_cldr_fallback_data_\uff3fen$ as $d_Llocales_cldr_fallback_data_\uff3fen$ };
var $n_Llocales_cldr_fallback_data_\uff3fen$;
function $m_Llocales_cldr_fallback_data_\uff3fen$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3fen$)) {
    $n_Llocales_cldr_fallback_data_\uff3fen$ = new $c_Llocales_cldr_fallback_data_\uff3fen$();
  }
  return $n_Llocales_cldr_fallback_data_\uff3fen$;
}
export { $m_Llocales_cldr_fallback_data_\uff3fen$ as $m_Llocales_cldr_fallback_data_\uff3fen$ };
/** @constructor */
function $c_Llocales_cldr_fallback_data_\uff3froot$() {
  this.Llocales_cldr_LDML__f_parent = null;
  this.Llocales_cldr_LDML__f_locale = null;
  this.Llocales_cldr_LDML__f_defaultNS = null;
  this.Llocales_cldr_LDML__f_digitSymbols = null;
  this.Llocales_cldr_LDML__f_calendarSymbols = null;
  this.Llocales_cldr_LDML__f_calendarPatterns = null;
  this.Llocales_cldr_LDML__f_currencies = null;
  this.Llocales_cldr_LDML__f_numberPatterns = null;
  var $x_8 = $m_s_None$();
  var territory = $m_s_None$();
  var variant = $m_s_None$();
  var script = $m_s_None$();
  var $x_7 = new $c_Llocales_cldr_LDMLLocale("root", territory, variant, script);
  var value = $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  var $x_6 = new $c_s_Some(value);
  var $x_4 = $m_sr_ScalaRunTime$();
  var ns = $m_Llocales_cldr_fallback_data_numericsystems$().latn__Llocales_cldr_NumberingSystem();
  var aliasOf = $m_s_None$();
  var decimal = new $c_s_Some($bC(46));
  var group = new $c_s_Some($bC(44));
  var list = new $c_s_Some($bC(59));
  var percent = new $c_s_Some($bC(37));
  var minus = new $c_s_Some($bC(45));
  var perMille = new $c_s_Some($bC(8240));
  var infinity = new $c_s_Some("\u221e");
  var nan = new $c_s_Some("NaN");
  var exp = new $c_s_Some("E");
  var elems = $x_4.wrapRefArray__AO__sci_ArraySeq(new ($d_Llocales_cldr_Symbols.getArrayOf().constr)([new $c_Llocales_cldr_Symbols(ns, aliasOf, decimal, group, list, percent, minus, perMille, infinity, nan, exp)]));
  var $x_5 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  var elems$1 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["M01", "M02", "M03", "M04", "M05", "M06", "M07", "M08", "M09", "M10", "M11", "M12"]));
  var months = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$1);
  var elems$2 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var shortMonths = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$2);
  var elems$3 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]));
  var weekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$3);
  var elems$4 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var shortWeekdays = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$4);
  var elems$5 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var amPm = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$5);
  var elems$6 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)(["BCE", "CE"]));
  var eras = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$6);
  var value$1 = new $c_Llocales_cldr_CalendarSymbols(months, shortMonths, weekdays, shortWeekdays, amPm, eras);
  var $x_3 = new $c_s_Some(value$1);
  $m_Llocales_cldr_CalendarPatterns$();
  var this$26 = $m_sci_Map$();
  var elems$7 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), 0, "y MMMM d, EEEE"), $ct_T2__O__O__(new $c_T2(), 1, "y MMMM d"), $ct_T2__O__O__(new $c_T2(), 2, "y MMM d"), $ct_T2__O__O__(new $c_T2(), 3, "y-MM-dd")]));
  var datePatterns = this$26.from__sc_IterableOnce__sci_Map(elems$7);
  var this$31 = $m_sci_Map$();
  var elems$8 = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([$ct_T2__O__O__(new $c_T2(), 0, "HH:mm:ss zzzz"), $ct_T2__O__O__(new $c_T2(), 1, "HH:mm:ss z"), $ct_T2__O__O__(new $c_T2(), 2, "HH:mm:ss"), $ct_T2__O__O__(new $c_T2(), 3, "HH:mm")]));
  var timePatterns = this$31.from__sc_IterableOnce__sci_Map(elems$8);
  var value$2 = new $c_Llocales_cldr_CalendarPatterns(datePatterns, timePatterns);
  var $x_2 = new $c_s_Some(value$2);
  var elems$9 = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
  var $x_1 = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems$9);
  var decimalFormat = new $c_s_Some("#,##0.###");
  var percentFormat = new $c_s_Some("#,##0%");
  var currencyFormat = new $c_s_Some("\u00a4\u00a0#,##0.00");
  $ct_Llocales_cldr_LDML__s_Option__Llocales_cldr_LDMLLocale__s_Option__sci_List__s_Option__s_Option__sci_List__Llocales_cldr_NumberPatterns__(this, $x_8, $x_7, $x_6, $x_5, $x_3, $x_2, $x_1, new $c_Llocales_cldr_NumberPatterns(decimalFormat, percentFormat, currencyFormat));
}
export { $c_Llocales_cldr_fallback_data_\uff3froot$ as $c_Llocales_cldr_fallback_data_\uff3froot$ };
$c_Llocales_cldr_fallback_data_\uff3froot$.prototype = new $h_Llocales_cldr_LDML();
$c_Llocales_cldr_fallback_data_\uff3froot$.prototype.constructor = $c_Llocales_cldr_fallback_data_\uff3froot$;
/** @constructor */
function $h_Llocales_cldr_fallback_data_\uff3froot$() {
}
export { $h_Llocales_cldr_fallback_data_\uff3froot$ as $h_Llocales_cldr_fallback_data_\uff3froot$ };
$h_Llocales_cldr_fallback_data_\uff3froot$.prototype = $c_Llocales_cldr_fallback_data_\uff3froot$.prototype;
var $d_Llocales_cldr_fallback_data_\uff3froot$ = new $TypeData().initClass($c_Llocales_cldr_fallback_data_\uff3froot$, "locales.cldr.fallback.data._root$", ({
  Llocales_cldr_fallback_data_\uff3froot$: 1,
  Llocales_cldr_LDML: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Llocales_cldr_fallback_data_\uff3froot$ as $d_Llocales_cldr_fallback_data_\uff3froot$ };
var $n_Llocales_cldr_fallback_data_\uff3froot$;
function $m_Llocales_cldr_fallback_data_\uff3froot$() {
  if ((!$n_Llocales_cldr_fallback_data_\uff3froot$)) {
    $n_Llocales_cldr_fallback_data_\uff3froot$ = new $c_Llocales_cldr_fallback_data_\uff3froot$();
  }
  return $n_Llocales_cldr_fallback_data_\uff3froot$;
}
export { $m_Llocales_cldr_fallback_data_\uff3froot$ as $m_Llocales_cldr_fallback_data_\uff3froot$ };
/** @constructor */
function $c_s_$less$colon$less$$anon$1() {
}
export { $c_s_$less$colon$less$$anon$1 as $c_s_$less$colon$less$$anon$1 };
$c_s_$less$colon$less$$anon$1.prototype = new $h_s_$eq$colon$eq();
$c_s_$less$colon$less$$anon$1.prototype.constructor = $c_s_$less$colon$less$$anon$1;
/** @constructor */
function $h_s_$less$colon$less$$anon$1() {
}
export { $h_s_$less$colon$less$$anon$1 as $h_s_$less$colon$less$$anon$1 };
$h_s_$less$colon$less$$anon$1.prototype = $c_s_$less$colon$less$$anon$1.prototype;
$c_s_$less$colon$less$$anon$1.prototype.apply__O__O = (function(x) {
  return x;
});
$c_s_$less$colon$less$$anon$1.prototype.compose__F1__F1 = (function(r) {
  return r;
});
$c_s_$less$colon$less$$anon$1.prototype.andThen__F1__F1 = (function(r) {
  return r;
});
$c_s_$less$colon$less$$anon$1.prototype.toString__T = (function() {
  return "generalized constraint";
});
var $d_s_$less$colon$less$$anon$1 = new $TypeData().initClass($c_s_$less$colon$less$$anon$1, "scala.$less$colon$less$$anon$1", ({
  s_$less$colon$less$$anon$1: 1,
  s_$eq$colon$eq: 1,
  s_$less$colon$less: 1,
  F1: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_$less$colon$less$$anon$1 as $d_s_$less$colon$less$$anon$1 };
function $p_s_MatchError__objString$lzycompute__T($thiz) {
  if ((!$thiz.s_MatchError__f_bitmap$0)) {
    if (($thiz.s_MatchError__f_obj === null)) {
      var $x_1 = "null";
    } else {
      var this$1 = $thiz.s_MatchError__f_obj;
      var cls = $objectGetClass(this$1);
      var ofClass = ((cls === null) ? "of a JS class" : ("of class " + cls.data.name));
      var $x_1 = $p_s_MatchError__liftedTree1$1__T__T($thiz, ofClass);
    }
    $thiz.s_MatchError__f_objString = $x_1;
    $thiz.s_MatchError__f_bitmap$0 = true;
  }
  return $thiz.s_MatchError__f_objString;
}
export { $p_s_MatchError__objString$lzycompute__T as $p_s_MatchError__objString$lzycompute__T };
function $p_s_MatchError__objString__T($thiz) {
  return ((!$thiz.s_MatchError__f_bitmap$0) ? $p_s_MatchError__objString$lzycompute__T($thiz) : $thiz.s_MatchError__f_objString);
}
export { $p_s_MatchError__objString__T as $p_s_MatchError__objString__T };
function $p_s_MatchError__liftedTree1$1__T__T($thiz, ofClass$1) {
  try {
    return ((($thiz.s_MatchError__f_obj + " (") + ofClass$1) + ")");
  } catch (e) {
    return ("an instance " + ofClass$1);
  }
}
export { $p_s_MatchError__liftedTree1$1__T__T as $p_s_MatchError__liftedTree1$1__T__T };
class $c_s_MatchError extends $c_jl_RuntimeException {
  constructor(obj) {
    super();
    this.s_MatchError__f_objString = null;
    this.s_MatchError__f_obj = null;
    this.s_MatchError__f_bitmap$0 = false;
    this.s_MatchError__f_obj = obj;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return $p_s_MatchError__objString__T(this);
  }
}
export { $c_s_MatchError as $c_s_MatchError };
var $d_s_MatchError = new $TypeData().initClass($c_s_MatchError, "scala.MatchError", ({
  s_MatchError: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_MatchError as $d_s_MatchError };
/** @constructor */
function $c_s_Option() {
}
export { $c_s_Option as $c_s_Option };
$c_s_Option.prototype = new $h_O();
$c_s_Option.prototype.constructor = $c_s_Option;
/** @constructor */
function $h_s_Option() {
}
export { $h_s_Option as $h_s_Option };
$h_s_Option.prototype = $c_s_Option.prototype;
$c_s_Option.prototype.productElementName__I__T = (function(n) {
  return $f_s_Product__productElementName__I__T(this, n);
});
$c_s_Option.prototype.isEmpty__Z = (function() {
  return (this === $m_s_None$());
});
$c_s_Option.prototype.knownSize__I = (function() {
  return (this.isEmpty__Z() ? 0 : 1);
});
$c_s_Option.prototype.flatten__s_$less$colon$less__s_Option = (function(ev) {
  if (this.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var x = this.get__O();
    return x;
  }
});
$c_s_Option.prototype.contains__O__Z = (function(elem) {
  return ((!this.isEmpty__Z()) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.get__O(), elem));
});
$c_s_Option.prototype.iterator__sc_Iterator = (function() {
  if (this.isEmpty__Z()) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  } else {
    var a = this.get__O();
    return new $c_sc_Iterator$$anon$20(a);
  }
});
$c_s_Option.prototype.toList__sci_List = (function() {
  return (this.isEmpty__Z() ? $m_sci_Nil$() : new $c_sci_$colon$colon(this.get__O(), $m_sci_Nil$()));
});
function $isArrayOf_s_Option(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Option)));
}
export { $isArrayOf_s_Option as $isArrayOf_s_Option };
var $d_s_Option = new $TypeData().initClass(0, "scala.Option", ({
  s_Option: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_Option as $d_s_Option };
/** @constructor */
function $c_s_Product$$anon$1(outer) {
  this.s_Product$$anon$1__f_c = 0;
  this.s_Product$$anon$1__f_cmax = 0;
  this.s_Product$$anon$1__f_$outer = null;
  this.s_Product$$anon$1__f_$outer = outer;
  this.s_Product$$anon$1__f_c = 0;
  this.s_Product$$anon$1__f_cmax = outer.productArity__I();
}
export { $c_s_Product$$anon$1 as $c_s_Product$$anon$1 };
$c_s_Product$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_s_Product$$anon$1.prototype.constructor = $c_s_Product$$anon$1;
/** @constructor */
function $h_s_Product$$anon$1() {
}
export { $h_s_Product$$anon$1 as $h_s_Product$$anon$1 };
$h_s_Product$$anon$1.prototype = $c_s_Product$$anon$1.prototype;
$c_s_Product$$anon$1.prototype.hasNext__Z = (function() {
  return (this.s_Product$$anon$1__f_c < this.s_Product$$anon$1__f_cmax);
});
$c_s_Product$$anon$1.prototype.next__O = (function() {
  var result = this.s_Product$$anon$1__f_$outer.productElement__I__O(this.s_Product$$anon$1__f_c);
  this.s_Product$$anon$1__f_c = ((1 + this.s_Product$$anon$1__f_c) | 0);
  return result;
});
var $d_s_Product$$anon$1 = new $TypeData().initClass($c_s_Product$$anon$1, "scala.Product$$anon$1", ({
  s_Product$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_s_Product$$anon$1 as $d_s_Product$$anon$1 };
/** @constructor */
function $c_T1(_1) {
  this.T1__f__1 = null;
  this.T1__f__1 = _1;
}
export { $c_T1 as $c_T1 };
$c_T1.prototype = new $h_O();
$c_T1.prototype.constructor = $c_T1;
/** @constructor */
function $h_T1() {
}
export { $h_T1 as $h_T1 };
$h_T1.prototype = $c_T1.prototype;
$c_T1.prototype.productArity__I = (function() {
  return 1;
});
$c_T1.prototype.productElement__I__O = (function(n) {
  return $f_s_Product1__productElement__I__O(this, n);
});
$c_T1.prototype.toString__T = (function() {
  return (("(" + this.T1__f__1) + ")");
});
$c_T1.prototype.productPrefix__T = (function() {
  return "Tuple1";
});
$c_T1.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T1.prototype.productElementName__I__T = (function(x$1) {
  return ((x$1 === 0) ? "_1" : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_T1.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1228477340, true);
});
$c_T1.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T1__f__1, x$1.T1__f__1)));
});
function $isArrayOf_T1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T1)));
}
export { $isArrayOf_T1 as $isArrayOf_T1 };
var $d_T1 = new $TypeData().initClass($c_T1, "scala.Tuple1", ({
  T1: 1,
  s_Product1: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T1 as $d_T1 };
/** @constructor */
function $c_T10(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10) {
  this.T10__f__1 = null;
  this.T10__f__2 = null;
  this.T10__f__3 = null;
  this.T10__f__4 = null;
  this.T10__f__5 = null;
  this.T10__f__6 = null;
  this.T10__f__7 = null;
  this.T10__f__8 = null;
  this.T10__f__9 = null;
  this.T10__f__10 = null;
  this.T10__f__1 = _1;
  this.T10__f__2 = _2;
  this.T10__f__3 = _3;
  this.T10__f__4 = _4;
  this.T10__f__5 = _5;
  this.T10__f__6 = _6;
  this.T10__f__7 = _7;
  this.T10__f__8 = _8;
  this.T10__f__9 = _9;
  this.T10__f__10 = _10;
}
export { $c_T10 as $c_T10 };
$c_T10.prototype = new $h_O();
$c_T10.prototype.constructor = $c_T10;
/** @constructor */
function $h_T10() {
}
export { $h_T10 as $h_T10 };
$h_T10.prototype = $c_T10.prototype;
$c_T10.prototype.productArity__I = (function() {
  return 10;
});
$c_T10.prototype.productElement__I__O = (function(n) {
  return $f_s_Product10__productElement__I__O(this, n);
});
$c_T10.prototype.toString__T = (function() {
  return (((((((((((((((((((("(" + this.T10__f__1) + ",") + this.T10__f__2) + ",") + this.T10__f__3) + ",") + this.T10__f__4) + ",") + this.T10__f__5) + ",") + this.T10__f__6) + ",") + this.T10__f__7) + ",") + this.T10__f__8) + ",") + this.T10__f__9) + ",") + this.T10__f__10) + ")");
});
$c_T10.prototype.productPrefix__T = (function() {
  return "Tuple10";
});
$c_T10.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T10.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T10.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2104595240, true);
});
$c_T10.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T10) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__1, x$1.T10__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__2, x$1.T10__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__3, x$1.T10__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__4, x$1.T10__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__5, x$1.T10__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__6, x$1.T10__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__7, x$1.T10__f__7)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__8, x$1.T10__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__9, x$1.T10__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T10__f__10, x$1.T10__f__10)))))));
});
function $isArrayOf_T10(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T10)));
}
export { $isArrayOf_T10 as $isArrayOf_T10 };
var $d_T10 = new $TypeData().initClass($c_T10, "scala.Tuple10", ({
  T10: 1,
  s_Product10: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T10 as $d_T10 };
/** @constructor */
function $c_T11(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11) {
  this.T11__f__1 = null;
  this.T11__f__2 = null;
  this.T11__f__3 = null;
  this.T11__f__4 = null;
  this.T11__f__5 = null;
  this.T11__f__6 = null;
  this.T11__f__7 = null;
  this.T11__f__8 = null;
  this.T11__f__9 = null;
  this.T11__f__10 = null;
  this.T11__f__11 = null;
  this.T11__f__1 = _1;
  this.T11__f__2 = _2;
  this.T11__f__3 = _3;
  this.T11__f__4 = _4;
  this.T11__f__5 = _5;
  this.T11__f__6 = _6;
  this.T11__f__7 = _7;
  this.T11__f__8 = _8;
  this.T11__f__9 = _9;
  this.T11__f__10 = _10;
  this.T11__f__11 = _11;
}
export { $c_T11 as $c_T11 };
$c_T11.prototype = new $h_O();
$c_T11.prototype.constructor = $c_T11;
/** @constructor */
function $h_T11() {
}
export { $h_T11 as $h_T11 };
$h_T11.prototype = $c_T11.prototype;
$c_T11.prototype.productArity__I = (function() {
  return 11;
});
$c_T11.prototype.productElement__I__O = (function(n) {
  return $f_s_Product11__productElement__I__O(this, n);
});
$c_T11.prototype.toString__T = (function() {
  return (((((((((((((((((((((("(" + this.T11__f__1) + ",") + this.T11__f__2) + ",") + this.T11__f__3) + ",") + this.T11__f__4) + ",") + this.T11__f__5) + ",") + this.T11__f__6) + ",") + this.T11__f__7) + ",") + this.T11__f__8) + ",") + this.T11__f__9) + ",") + this.T11__f__10) + ",") + this.T11__f__11) + ")");
});
$c_T11.prototype.productPrefix__T = (function() {
  return "Tuple11";
});
$c_T11.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T11.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T11.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 838406606, true);
});
$c_T11.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T11) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__1, x$1.T11__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__2, x$1.T11__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__3, x$1.T11__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__4, x$1.T11__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__5, x$1.T11__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__6, x$1.T11__f__6) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__7, x$1.T11__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__8, x$1.T11__f__8))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__9, x$1.T11__f__9) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__10, x$1.T11__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T11__f__11, x$1.T11__f__11)))))));
});
function $isArrayOf_T11(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T11)));
}
export { $isArrayOf_T11 as $isArrayOf_T11 };
var $d_T11 = new $TypeData().initClass($c_T11, "scala.Tuple11", ({
  T11: 1,
  s_Product11: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T11 as $d_T11 };
/** @constructor */
function $c_T12(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12) {
  this.T12__f__1 = null;
  this.T12__f__2 = null;
  this.T12__f__3 = null;
  this.T12__f__4 = null;
  this.T12__f__5 = null;
  this.T12__f__6 = null;
  this.T12__f__7 = null;
  this.T12__f__8 = null;
  this.T12__f__9 = null;
  this.T12__f__10 = null;
  this.T12__f__11 = null;
  this.T12__f__12 = null;
  this.T12__f__1 = _1;
  this.T12__f__2 = _2;
  this.T12__f__3 = _3;
  this.T12__f__4 = _4;
  this.T12__f__5 = _5;
  this.T12__f__6 = _6;
  this.T12__f__7 = _7;
  this.T12__f__8 = _8;
  this.T12__f__9 = _9;
  this.T12__f__10 = _10;
  this.T12__f__11 = _11;
  this.T12__f__12 = _12;
}
export { $c_T12 as $c_T12 };
$c_T12.prototype = new $h_O();
$c_T12.prototype.constructor = $c_T12;
/** @constructor */
function $h_T12() {
}
export { $h_T12 as $h_T12 };
$h_T12.prototype = $c_T12.prototype;
$c_T12.prototype.productArity__I = (function() {
  return 12;
});
$c_T12.prototype.productElement__I__O = (function(n) {
  return $f_s_Product12__productElement__I__O(this, n);
});
$c_T12.prototype.toString__T = (function() {
  return (((((((((((((((((((((((("(" + this.T12__f__1) + ",") + this.T12__f__2) + ",") + this.T12__f__3) + ",") + this.T12__f__4) + ",") + this.T12__f__5) + ",") + this.T12__f__6) + ",") + this.T12__f__7) + ",") + this.T12__f__8) + ",") + this.T12__f__9) + ",") + this.T12__f__10) + ",") + this.T12__f__11) + ",") + this.T12__f__12) + ")");
});
$c_T12.prototype.productPrefix__T = (function() {
  return "Tuple12";
});
$c_T12.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T12.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    case 11: {
      return "_12";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T12.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1964145863), true);
});
$c_T12.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T12) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__1, x$1.T12__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__2, x$1.T12__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__3, x$1.T12__f__3))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__4, x$1.T12__f__4) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__5, x$1.T12__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__6, x$1.T12__f__6)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__7, x$1.T12__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__8, x$1.T12__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__9, x$1.T12__f__9))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__10, x$1.T12__f__10) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__11, x$1.T12__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T12__f__12, x$1.T12__f__12)))))));
});
function $isArrayOf_T12(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T12)));
}
export { $isArrayOf_T12 as $isArrayOf_T12 };
var $d_T12 = new $TypeData().initClass($c_T12, "scala.Tuple12", ({
  T12: 1,
  s_Product12: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T12 as $d_T12 };
/** @constructor */
function $c_T13(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13) {
  this.T13__f__1 = null;
  this.T13__f__2 = null;
  this.T13__f__3 = null;
  this.T13__f__4 = null;
  this.T13__f__5 = null;
  this.T13__f__6 = null;
  this.T13__f__7 = null;
  this.T13__f__8 = null;
  this.T13__f__9 = null;
  this.T13__f__10 = null;
  this.T13__f__11 = null;
  this.T13__f__12 = null;
  this.T13__f__13 = null;
  this.T13__f__1 = _1;
  this.T13__f__2 = _2;
  this.T13__f__3 = _3;
  this.T13__f__4 = _4;
  this.T13__f__5 = _5;
  this.T13__f__6 = _6;
  this.T13__f__7 = _7;
  this.T13__f__8 = _8;
  this.T13__f__9 = _9;
  this.T13__f__10 = _10;
  this.T13__f__11 = _11;
  this.T13__f__12 = _12;
  this.T13__f__13 = _13;
}
export { $c_T13 as $c_T13 };
$c_T13.prototype = new $h_O();
$c_T13.prototype.constructor = $c_T13;
/** @constructor */
function $h_T13() {
}
export { $h_T13 as $h_T13 };
$h_T13.prototype = $c_T13.prototype;
$c_T13.prototype.productArity__I = (function() {
  return 13;
});
$c_T13.prototype.productElement__I__O = (function(n) {
  return $f_s_Product13__productElement__I__O(this, n);
});
$c_T13.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((("(" + this.T13__f__1) + ",") + this.T13__f__2) + ",") + this.T13__f__3) + ",") + this.T13__f__4) + ",") + this.T13__f__5) + ",") + this.T13__f__6) + ",") + this.T13__f__7) + ",") + this.T13__f__8) + ",") + this.T13__f__9) + ",") + this.T13__f__10) + ",") + this.T13__f__11) + ",") + this.T13__f__12) + ",") + this.T13__f__13) + ")");
});
$c_T13.prototype.productPrefix__T = (function() {
  return "Tuple13";
});
$c_T13.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T13.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    case 11: {
      return "_12";
      break;
    }
    case 12: {
      return "_13";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T13.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1224168367, true);
});
$c_T13.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T13) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__1, x$1.T13__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__2, x$1.T13__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__3, x$1.T13__f__3))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__4, x$1.T13__f__4) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__5, x$1.T13__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__6, x$1.T13__f__6)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__7, x$1.T13__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__8, x$1.T13__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__9, x$1.T13__f__9))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__10, x$1.T13__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__11, x$1.T13__f__11)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__12, x$1.T13__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T13__f__13, x$1.T13__f__13)))))));
});
function $isArrayOf_T13(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T13)));
}
export { $isArrayOf_T13 as $isArrayOf_T13 };
var $d_T13 = new $TypeData().initClass($c_T13, "scala.Tuple13", ({
  T13: 1,
  s_Product13: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T13 as $d_T13 };
/** @constructor */
function $c_T14(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14) {
  this.T14__f__1 = null;
  this.T14__f__2 = null;
  this.T14__f__3 = null;
  this.T14__f__4 = null;
  this.T14__f__5 = null;
  this.T14__f__6 = null;
  this.T14__f__7 = null;
  this.T14__f__8 = null;
  this.T14__f__9 = null;
  this.T14__f__10 = null;
  this.T14__f__11 = null;
  this.T14__f__12 = null;
  this.T14__f__13 = null;
  this.T14__f__14 = null;
  this.T14__f__1 = _1;
  this.T14__f__2 = _2;
  this.T14__f__3 = _3;
  this.T14__f__4 = _4;
  this.T14__f__5 = _5;
  this.T14__f__6 = _6;
  this.T14__f__7 = _7;
  this.T14__f__8 = _8;
  this.T14__f__9 = _9;
  this.T14__f__10 = _10;
  this.T14__f__11 = _11;
  this.T14__f__12 = _12;
  this.T14__f__13 = _13;
  this.T14__f__14 = _14;
}
export { $c_T14 as $c_T14 };
$c_T14.prototype = new $h_O();
$c_T14.prototype.constructor = $c_T14;
/** @constructor */
function $h_T14() {
}
export { $h_T14 as $h_T14 };
$h_T14.prototype = $c_T14.prototype;
$c_T14.prototype.productArity__I = (function() {
  return 14;
});
$c_T14.prototype.productElement__I__O = (function(n) {
  return $f_s_Product14__productElement__I__O(this, n);
});
$c_T14.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((("(" + this.T14__f__1) + ",") + this.T14__f__2) + ",") + this.T14__f__3) + ",") + this.T14__f__4) + ",") + this.T14__f__5) + ",") + this.T14__f__6) + ",") + this.T14__f__7) + ",") + this.T14__f__8) + ",") + this.T14__f__9) + ",") + this.T14__f__10) + ",") + this.T14__f__11) + ",") + this.T14__f__12) + ",") + this.T14__f__13) + ",") + this.T14__f__14) + ")");
});
$c_T14.prototype.productPrefix__T = (function() {
  return "Tuple14";
});
$c_T14.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T14.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    case 11: {
      return "_12";
      break;
    }
    case 12: {
      return "_13";
      break;
    }
    case 13: {
      return "_14";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T14.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 147759069, true);
});
$c_T14.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T14) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__1, x$1.T14__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__2, x$1.T14__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__3, x$1.T14__f__3))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__4, x$1.T14__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__5, x$1.T14__f__5)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__6, x$1.T14__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__7, x$1.T14__f__7)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__8, x$1.T14__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__9, x$1.T14__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__10, x$1.T14__f__10))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__11, x$1.T14__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__12, x$1.T14__f__12)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__13, x$1.T14__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T14__f__14, x$1.T14__f__14)))))));
});
function $isArrayOf_T14(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T14)));
}
export { $isArrayOf_T14 as $isArrayOf_T14 };
var $d_T14 = new $TypeData().initClass($c_T14, "scala.Tuple14", ({
  T14: 1,
  s_Product14: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T14 as $d_T14 };
/** @constructor */
function $c_T15(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15) {
  this.T15__f__1 = null;
  this.T15__f__2 = null;
  this.T15__f__3 = null;
  this.T15__f__4 = null;
  this.T15__f__5 = null;
  this.T15__f__6 = null;
  this.T15__f__7 = null;
  this.T15__f__8 = null;
  this.T15__f__9 = null;
  this.T15__f__10 = null;
  this.T15__f__11 = null;
  this.T15__f__12 = null;
  this.T15__f__13 = null;
  this.T15__f__14 = null;
  this.T15__f__15 = null;
  this.T15__f__1 = _1;
  this.T15__f__2 = _2;
  this.T15__f__3 = _3;
  this.T15__f__4 = _4;
  this.T15__f__5 = _5;
  this.T15__f__6 = _6;
  this.T15__f__7 = _7;
  this.T15__f__8 = _8;
  this.T15__f__9 = _9;
  this.T15__f__10 = _10;
  this.T15__f__11 = _11;
  this.T15__f__12 = _12;
  this.T15__f__13 = _13;
  this.T15__f__14 = _14;
  this.T15__f__15 = _15;
}
export { $c_T15 as $c_T15 };
$c_T15.prototype = new $h_O();
$c_T15.prototype.constructor = $c_T15;
/** @constructor */
function $h_T15() {
}
export { $h_T15 as $h_T15 };
$h_T15.prototype = $c_T15.prototype;
$c_T15.prototype.productArity__I = (function() {
  return 15;
});
$c_T15.prototype.productElement__I__O = (function(n) {
  return $f_s_Product15__productElement__I__O(this, n);
});
$c_T15.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((("(" + this.T15__f__1) + ",") + this.T15__f__2) + ",") + this.T15__f__3) + ",") + this.T15__f__4) + ",") + this.T15__f__5) + ",") + this.T15__f__6) + ",") + this.T15__f__7) + ",") + this.T15__f__8) + ",") + this.T15__f__9) + ",") + this.T15__f__10) + ",") + this.T15__f__11) + ",") + this.T15__f__12) + ",") + this.T15__f__13) + ",") + this.T15__f__14) + ",") + this.T15__f__15) + ")");
});
$c_T15.prototype.productPrefix__T = (function() {
  return "Tuple15";
});
$c_T15.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T15.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    case 11: {
      return "_12";
      break;
    }
    case 12: {
      return "_13";
      break;
    }
    case 13: {
      return "_14";
      break;
    }
    case 14: {
      return "_15";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T15.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1834180931, true);
});
$c_T15.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T15) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__1, x$1.T15__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__2, x$1.T15__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__3, x$1.T15__f__3))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__4, x$1.T15__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__5, x$1.T15__f__5)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__6, x$1.T15__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__7, x$1.T15__f__7)))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__8, x$1.T15__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__9, x$1.T15__f__9)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__10, x$1.T15__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__11, x$1.T15__f__11))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__12, x$1.T15__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__13, x$1.T15__f__13)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__14, x$1.T15__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T15__f__15, x$1.T15__f__15)))))));
});
function $isArrayOf_T15(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T15)));
}
export { $isArrayOf_T15 as $isArrayOf_T15 };
var $d_T15 = new $TypeData().initClass($c_T15, "scala.Tuple15", ({
  T15: 1,
  s_Product15: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T15 as $d_T15 };
/** @constructor */
function $c_T16(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16) {
  this.T16__f__1 = null;
  this.T16__f__2 = null;
  this.T16__f__3 = null;
  this.T16__f__4 = null;
  this.T16__f__5 = null;
  this.T16__f__6 = null;
  this.T16__f__7 = null;
  this.T16__f__8 = null;
  this.T16__f__9 = null;
  this.T16__f__10 = null;
  this.T16__f__11 = null;
  this.T16__f__12 = null;
  this.T16__f__13 = null;
  this.T16__f__14 = null;
  this.T16__f__15 = null;
  this.T16__f__16 = null;
  this.T16__f__1 = _1;
  this.T16__f__2 = _2;
  this.T16__f__3 = _3;
  this.T16__f__4 = _4;
  this.T16__f__5 = _5;
  this.T16__f__6 = _6;
  this.T16__f__7 = _7;
  this.T16__f__8 = _8;
  this.T16__f__9 = _9;
  this.T16__f__10 = _10;
  this.T16__f__11 = _11;
  this.T16__f__12 = _12;
  this.T16__f__13 = _13;
  this.T16__f__14 = _14;
  this.T16__f__15 = _15;
  this.T16__f__16 = _16;
}
export { $c_T16 as $c_T16 };
$c_T16.prototype = new $h_O();
$c_T16.prototype.constructor = $c_T16;
/** @constructor */
function $h_T16() {
}
export { $h_T16 as $h_T16 };
$h_T16.prototype = $c_T16.prototype;
$c_T16.prototype.productArity__I = (function() {
  return 16;
});
$c_T16.prototype.productElement__I__O = (function(n) {
  return $f_s_Product16__productElement__I__O(this, n);
});
$c_T16.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((("(" + this.T16__f__1) + ",") + this.T16__f__2) + ",") + this.T16__f__3) + ",") + this.T16__f__4) + ",") + this.T16__f__5) + ",") + this.T16__f__6) + ",") + this.T16__f__7) + ",") + this.T16__f__8) + ",") + this.T16__f__9) + ",") + this.T16__f__10) + ",") + this.T16__f__11) + ",") + this.T16__f__12) + ",") + this.T16__f__13) + ",") + this.T16__f__14) + ",") + this.T16__f__15) + ",") + this.T16__f__16) + ")");
});
$c_T16.prototype.productPrefix__T = (function() {
  return "Tuple16";
});
$c_T16.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T16.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    case 11: {
      return "_12";
      break;
    }
    case 12: {
      return "_13";
      break;
    }
    case 13: {
      return "_14";
      break;
    }
    case 14: {
      return "_15";
      break;
    }
    case 15: {
      return "_16";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T16.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 499793902, true);
});
$c_T16.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T16) && (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__1, x$1.T16__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__2, x$1.T16__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__3, x$1.T16__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__4, x$1.T16__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__5, x$1.T16__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__6, x$1.T16__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__7, x$1.T16__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__8, x$1.T16__f__8)))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__9, x$1.T16__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__10, x$1.T16__f__10)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__11, x$1.T16__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__12, x$1.T16__f__12))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__13, x$1.T16__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__14, x$1.T16__f__14)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__15, x$1.T16__f__15) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T16__f__16, x$1.T16__f__16)))))));
});
function $isArrayOf_T16(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T16)));
}
export { $isArrayOf_T16 as $isArrayOf_T16 };
var $d_T16 = new $TypeData().initClass($c_T16, "scala.Tuple16", ({
  T16: 1,
  s_Product16: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T16 as $d_T16 };
/** @constructor */
function $c_T17(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17) {
  this.T17__f__1 = null;
  this.T17__f__2 = null;
  this.T17__f__3 = null;
  this.T17__f__4 = null;
  this.T17__f__5 = null;
  this.T17__f__6 = null;
  this.T17__f__7 = null;
  this.T17__f__8 = null;
  this.T17__f__9 = null;
  this.T17__f__10 = null;
  this.T17__f__11 = null;
  this.T17__f__12 = null;
  this.T17__f__13 = null;
  this.T17__f__14 = null;
  this.T17__f__15 = null;
  this.T17__f__16 = null;
  this.T17__f__17 = null;
  this.T17__f__1 = _1;
  this.T17__f__2 = _2;
  this.T17__f__3 = _3;
  this.T17__f__4 = _4;
  this.T17__f__5 = _5;
  this.T17__f__6 = _6;
  this.T17__f__7 = _7;
  this.T17__f__8 = _8;
  this.T17__f__9 = _9;
  this.T17__f__10 = _10;
  this.T17__f__11 = _11;
  this.T17__f__12 = _12;
  this.T17__f__13 = _13;
  this.T17__f__14 = _14;
  this.T17__f__15 = _15;
  this.T17__f__16 = _16;
  this.T17__f__17 = _17;
}
export { $c_T17 as $c_T17 };
$c_T17.prototype = new $h_O();
$c_T17.prototype.constructor = $c_T17;
/** @constructor */
function $h_T17() {
}
export { $h_T17 as $h_T17 };
$h_T17.prototype = $c_T17.prototype;
$c_T17.prototype.productArity__I = (function() {
  return 17;
});
$c_T17.prototype.productElement__I__O = (function(n) {
  return $f_s_Product17__productElement__I__O(this, n);
});
$c_T17.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((("(" + this.T17__f__1) + ",") + this.T17__f__2) + ",") + this.T17__f__3) + ",") + this.T17__f__4) + ",") + this.T17__f__5) + ",") + this.T17__f__6) + ",") + this.T17__f__7) + ",") + this.T17__f__8) + ",") + this.T17__f__9) + ",") + this.T17__f__10) + ",") + this.T17__f__11) + ",") + this.T17__f__12) + ",") + this.T17__f__13) + ",") + this.T17__f__14) + ",") + this.T17__f__15) + ",") + this.T17__f__16) + ",") + this.T17__f__17) + ")");
});
$c_T17.prototype.productPrefix__T = (function() {
  return "Tuple17";
});
$c_T17.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T17.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    case 11: {
      return "_12";
      break;
    }
    case 12: {
      return "_13";
      break;
    }
    case 13: {
      return "_14";
      break;
    }
    case 14: {
      return "_15";
      break;
    }
    case 15: {
      return "_16";
      break;
    }
    case 16: {
      return "_17";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T17.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-934366247), true);
});
$c_T17.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T17) && (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__1, x$1.T17__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__2, x$1.T17__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__3, x$1.T17__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__4, x$1.T17__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__5, x$1.T17__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__6, x$1.T17__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__7, x$1.T17__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__8, x$1.T17__f__8)))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__9, x$1.T17__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__10, x$1.T17__f__10)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__11, x$1.T17__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__12, x$1.T17__f__12))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__13, x$1.T17__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__14, x$1.T17__f__14)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__15, x$1.T17__f__15) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__16, x$1.T17__f__16) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T17__f__17, x$1.T17__f__17))))))));
});
function $isArrayOf_T17(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T17)));
}
export { $isArrayOf_T17 as $isArrayOf_T17 };
var $d_T17 = new $TypeData().initClass($c_T17, "scala.Tuple17", ({
  T17: 1,
  s_Product17: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T17 as $d_T17 };
/** @constructor */
function $c_T18(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18) {
  this.T18__f__1 = null;
  this.T18__f__2 = null;
  this.T18__f__3 = null;
  this.T18__f__4 = null;
  this.T18__f__5 = null;
  this.T18__f__6 = null;
  this.T18__f__7 = null;
  this.T18__f__8 = null;
  this.T18__f__9 = null;
  this.T18__f__10 = null;
  this.T18__f__11 = null;
  this.T18__f__12 = null;
  this.T18__f__13 = null;
  this.T18__f__14 = null;
  this.T18__f__15 = null;
  this.T18__f__16 = null;
  this.T18__f__17 = null;
  this.T18__f__18 = null;
  this.T18__f__1 = _1;
  this.T18__f__2 = _2;
  this.T18__f__3 = _3;
  this.T18__f__4 = _4;
  this.T18__f__5 = _5;
  this.T18__f__6 = _6;
  this.T18__f__7 = _7;
  this.T18__f__8 = _8;
  this.T18__f__9 = _9;
  this.T18__f__10 = _10;
  this.T18__f__11 = _11;
  this.T18__f__12 = _12;
  this.T18__f__13 = _13;
  this.T18__f__14 = _14;
  this.T18__f__15 = _15;
  this.T18__f__16 = _16;
  this.T18__f__17 = _17;
  this.T18__f__18 = _18;
}
export { $c_T18 as $c_T18 };
$c_T18.prototype = new $h_O();
$c_T18.prototype.constructor = $c_T18;
/** @constructor */
function $h_T18() {
}
export { $h_T18 as $h_T18 };
$h_T18.prototype = $c_T18.prototype;
$c_T18.prototype.productArity__I = (function() {
  return 18;
});
$c_T18.prototype.productElement__I__O = (function(n) {
  return $f_s_Product18__productElement__I__O(this, n);
});
$c_T18.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((("(" + this.T18__f__1) + ",") + this.T18__f__2) + ",") + this.T18__f__3) + ",") + this.T18__f__4) + ",") + this.T18__f__5) + ",") + this.T18__f__6) + ",") + this.T18__f__7) + ",") + this.T18__f__8) + ",") + this.T18__f__9) + ",") + this.T18__f__10) + ",") + this.T18__f__11) + ",") + this.T18__f__12) + ",") + this.T18__f__13) + ",") + this.T18__f__14) + ",") + this.T18__f__15) + ",") + this.T18__f__16) + ",") + this.T18__f__17) + ",") + this.T18__f__18) + ")");
});
$c_T18.prototype.productPrefix__T = (function() {
  return "Tuple18";
});
$c_T18.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T18.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    case 11: {
      return "_12";
      break;
    }
    case 12: {
      return "_13";
      break;
    }
    case 13: {
      return "_14";
      break;
    }
    case 14: {
      return "_15";
      break;
    }
    case 15: {
      return "_16";
      break;
    }
    case 16: {
      return "_17";
      break;
    }
    case 17: {
      return "_18";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T18.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-937041276), true);
});
$c_T18.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T18) && (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__1, x$1.T18__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__2, x$1.T18__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__3, x$1.T18__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__4, x$1.T18__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__5, x$1.T18__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__6, x$1.T18__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__7, x$1.T18__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__8, x$1.T18__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__9, x$1.T18__f__9))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__10, x$1.T18__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__11, x$1.T18__f__11)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__12, x$1.T18__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__13, x$1.T18__f__13))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__14, x$1.T18__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__15, x$1.T18__f__15)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__16, x$1.T18__f__16) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__17, x$1.T18__f__17) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T18__f__18, x$1.T18__f__18))))))));
});
function $isArrayOf_T18(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T18)));
}
export { $isArrayOf_T18 as $isArrayOf_T18 };
var $d_T18 = new $TypeData().initClass($c_T18, "scala.Tuple18", ({
  T18: 1,
  s_Product18: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T18 as $d_T18 };
/** @constructor */
function $c_T19(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19) {
  this.T19__f__1 = null;
  this.T19__f__2 = null;
  this.T19__f__3 = null;
  this.T19__f__4 = null;
  this.T19__f__5 = null;
  this.T19__f__6 = null;
  this.T19__f__7 = null;
  this.T19__f__8 = null;
  this.T19__f__9 = null;
  this.T19__f__10 = null;
  this.T19__f__11 = null;
  this.T19__f__12 = null;
  this.T19__f__13 = null;
  this.T19__f__14 = null;
  this.T19__f__15 = null;
  this.T19__f__16 = null;
  this.T19__f__17 = null;
  this.T19__f__18 = null;
  this.T19__f__19 = null;
  this.T19__f__1 = _1;
  this.T19__f__2 = _2;
  this.T19__f__3 = _3;
  this.T19__f__4 = _4;
  this.T19__f__5 = _5;
  this.T19__f__6 = _6;
  this.T19__f__7 = _7;
  this.T19__f__8 = _8;
  this.T19__f__9 = _9;
  this.T19__f__10 = _10;
  this.T19__f__11 = _11;
  this.T19__f__12 = _12;
  this.T19__f__13 = _13;
  this.T19__f__14 = _14;
  this.T19__f__15 = _15;
  this.T19__f__16 = _16;
  this.T19__f__17 = _17;
  this.T19__f__18 = _18;
  this.T19__f__19 = _19;
}
export { $c_T19 as $c_T19 };
$c_T19.prototype = new $h_O();
$c_T19.prototype.constructor = $c_T19;
/** @constructor */
function $h_T19() {
}
export { $h_T19 as $h_T19 };
$h_T19.prototype = $c_T19.prototype;
$c_T19.prototype.productArity__I = (function() {
  return 19;
});
$c_T19.prototype.productElement__I__O = (function(n) {
  return $f_s_Product19__productElement__I__O(this, n);
});
$c_T19.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((("(" + this.T19__f__1) + ",") + this.T19__f__2) + ",") + this.T19__f__3) + ",") + this.T19__f__4) + ",") + this.T19__f__5) + ",") + this.T19__f__6) + ",") + this.T19__f__7) + ",") + this.T19__f__8) + ",") + this.T19__f__9) + ",") + this.T19__f__10) + ",") + this.T19__f__11) + ",") + this.T19__f__12) + ",") + this.T19__f__13) + ",") + this.T19__f__14) + ",") + this.T19__f__15) + ",") + this.T19__f__16) + ",") + this.T19__f__17) + ",") + this.T19__f__18) + ",") + this.T19__f__19) + ")");
});
$c_T19.prototype.productPrefix__T = (function() {
  return "Tuple19";
});
$c_T19.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T19.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    case 11: {
      return "_12";
      break;
    }
    case 12: {
      return "_13";
      break;
    }
    case 13: {
      return "_14";
      break;
    }
    case 14: {
      return "_15";
      break;
    }
    case 15: {
      return "_16";
      break;
    }
    case 16: {
      return "_17";
      break;
    }
    case 17: {
      return "_18";
      break;
    }
    case 18: {
      return "_19";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T19.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1955940499), true);
});
$c_T19.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T19) && (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__1, x$1.T19__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__2, x$1.T19__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__3, x$1.T19__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__4, x$1.T19__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__5, x$1.T19__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__6, x$1.T19__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__7, x$1.T19__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__8, x$1.T19__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__9, x$1.T19__f__9))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__10, x$1.T19__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__11, x$1.T19__f__11)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__12, x$1.T19__f__12) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__13, x$1.T19__f__13) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__14, x$1.T19__f__14)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__15, x$1.T19__f__15) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__16, x$1.T19__f__16)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__17, x$1.T19__f__17) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__18, x$1.T19__f__18) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T19__f__19, x$1.T19__f__19))))))));
});
function $isArrayOf_T19(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T19)));
}
export { $isArrayOf_T19 as $isArrayOf_T19 };
var $d_T19 = new $TypeData().initClass($c_T19, "scala.Tuple19", ({
  T19: 1,
  s_Product19: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T19 as $d_T19 };
function $ct_T2__O__O__($thiz, _1, _2) {
  $thiz.T2__f__1 = _1;
  $thiz.T2__f__2 = _2;
  return $thiz;
}
export { $ct_T2__O__O__ as $ct_T2__O__O__ };
/** @constructor */
function $c_T2() {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
}
export { $c_T2 as $c_T2 };
$c_T2.prototype = new $h_O();
$c_T2.prototype.constructor = $c_T2;
/** @constructor */
function $h_T2() {
}
export { $h_T2 as $h_T2 };
$h_T2.prototype = $c_T2.prototype;
$c_T2.prototype.productArity__I = (function() {
  return 2;
});
$c_T2.prototype.productElement__I__O = (function(n) {
  return $f_s_Product2__productElement__I__O(this, n);
});
$c_T2.prototype._1__O = (function() {
  return this.T2__f__1;
});
$c_T2.prototype._2__O = (function() {
  return this.T2__f__2;
});
$c_T2.prototype.toString__T = (function() {
  return (((("(" + this._1__O()) + ",") + this._2__O()) + ")");
});
$c_T2.prototype.swap__T2 = (function() {
  return $ct_T2__O__O__(new $c_T2(), this._2__O(), this._1__O());
});
$c_T2.prototype.productPrefix__T = (function() {
  return "Tuple2";
});
$c_T2.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T2.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T2.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-116390334), true);
});
$c_T2.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T2) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this._1__O(), x$1._1__O()) && $m_sr_BoxesRunTime$().equals__O__O__Z(this._2__O(), x$1._2__O()))));
});
$c_T2.prototype._1$mcC$sp__C = (function() {
  return $uC(this._1__O());
});
$c_T2.prototype._2$mcI$sp__I = (function() {
  return (this._2__O() | 0);
});
function $isArrayOf_T2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T2)));
}
export { $isArrayOf_T2 as $isArrayOf_T2 };
var $d_T2 = new $TypeData().initClass($c_T2, "scala.Tuple2", ({
  T2: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T2 as $d_T2 };
/** @constructor */
function $c_T20(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20) {
  this.T20__f__1 = null;
  this.T20__f__2 = null;
  this.T20__f__3 = null;
  this.T20__f__4 = null;
  this.T20__f__5 = null;
  this.T20__f__6 = null;
  this.T20__f__7 = null;
  this.T20__f__8 = null;
  this.T20__f__9 = null;
  this.T20__f__10 = null;
  this.T20__f__11 = null;
  this.T20__f__12 = null;
  this.T20__f__13 = null;
  this.T20__f__14 = null;
  this.T20__f__15 = null;
  this.T20__f__16 = null;
  this.T20__f__17 = null;
  this.T20__f__18 = null;
  this.T20__f__19 = null;
  this.T20__f__20 = null;
  this.T20__f__1 = _1;
  this.T20__f__2 = _2;
  this.T20__f__3 = _3;
  this.T20__f__4 = _4;
  this.T20__f__5 = _5;
  this.T20__f__6 = _6;
  this.T20__f__7 = _7;
  this.T20__f__8 = _8;
  this.T20__f__9 = _9;
  this.T20__f__10 = _10;
  this.T20__f__11 = _11;
  this.T20__f__12 = _12;
  this.T20__f__13 = _13;
  this.T20__f__14 = _14;
  this.T20__f__15 = _15;
  this.T20__f__16 = _16;
  this.T20__f__17 = _17;
  this.T20__f__18 = _18;
  this.T20__f__19 = _19;
  this.T20__f__20 = _20;
}
export { $c_T20 as $c_T20 };
$c_T20.prototype = new $h_O();
$c_T20.prototype.constructor = $c_T20;
/** @constructor */
function $h_T20() {
}
export { $h_T20 as $h_T20 };
$h_T20.prototype = $c_T20.prototype;
$c_T20.prototype.productArity__I = (function() {
  return 20;
});
$c_T20.prototype.productElement__I__O = (function(n) {
  return $f_s_Product20__productElement__I__O(this, n);
});
$c_T20.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((((("(" + this.T20__f__1) + ",") + this.T20__f__2) + ",") + this.T20__f__3) + ",") + this.T20__f__4) + ",") + this.T20__f__5) + ",") + this.T20__f__6) + ",") + this.T20__f__7) + ",") + this.T20__f__8) + ",") + this.T20__f__9) + ",") + this.T20__f__10) + ",") + this.T20__f__11) + ",") + this.T20__f__12) + ",") + this.T20__f__13) + ",") + this.T20__f__14) + ",") + this.T20__f__15) + ",") + this.T20__f__16) + ",") + this.T20__f__17) + ",") + this.T20__f__18) + ",") + this.T20__f__19) + ",") + this.T20__f__20) + ")");
});
$c_T20.prototype.productPrefix__T = (function() {
  return "Tuple20";
});
$c_T20.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T20.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    case 11: {
      return "_12";
      break;
    }
    case 12: {
      return "_13";
      break;
    }
    case 13: {
      return "_14";
      break;
    }
    case 14: {
      return "_15";
      break;
    }
    case 15: {
      return "_16";
      break;
    }
    case 16: {
      return "_17";
      break;
    }
    case 17: {
      return "_18";
      break;
    }
    case 18: {
      return "_19";
      break;
    }
    case 19: {
      return "_20";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T20.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1328807075, true);
});
$c_T20.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T20) && (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__1, x$1.T20__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__2, x$1.T20__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__3, x$1.T20__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__4, x$1.T20__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__5, x$1.T20__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__6, x$1.T20__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__7, x$1.T20__f__7)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__8, x$1.T20__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__9, x$1.T20__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__10, x$1.T20__f__10))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__11, x$1.T20__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__12, x$1.T20__f__12)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__13, x$1.T20__f__13) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__14, x$1.T20__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__15, x$1.T20__f__15)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__16, x$1.T20__f__16) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__17, x$1.T20__f__17)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__18, x$1.T20__f__18) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__19, x$1.T20__f__19) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T20__f__20, x$1.T20__f__20))))))));
});
function $isArrayOf_T20(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T20)));
}
export { $isArrayOf_T20 as $isArrayOf_T20 };
var $d_T20 = new $TypeData().initClass($c_T20, "scala.Tuple20", ({
  T20: 1,
  s_Product20: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T20 as $d_T20 };
/** @constructor */
function $c_T21(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21) {
  this.T21__f__1 = null;
  this.T21__f__2 = null;
  this.T21__f__3 = null;
  this.T21__f__4 = null;
  this.T21__f__5 = null;
  this.T21__f__6 = null;
  this.T21__f__7 = null;
  this.T21__f__8 = null;
  this.T21__f__9 = null;
  this.T21__f__10 = null;
  this.T21__f__11 = null;
  this.T21__f__12 = null;
  this.T21__f__13 = null;
  this.T21__f__14 = null;
  this.T21__f__15 = null;
  this.T21__f__16 = null;
  this.T21__f__17 = null;
  this.T21__f__18 = null;
  this.T21__f__19 = null;
  this.T21__f__20 = null;
  this.T21__f__21 = null;
  this.T21__f__1 = _1;
  this.T21__f__2 = _2;
  this.T21__f__3 = _3;
  this.T21__f__4 = _4;
  this.T21__f__5 = _5;
  this.T21__f__6 = _6;
  this.T21__f__7 = _7;
  this.T21__f__8 = _8;
  this.T21__f__9 = _9;
  this.T21__f__10 = _10;
  this.T21__f__11 = _11;
  this.T21__f__12 = _12;
  this.T21__f__13 = _13;
  this.T21__f__14 = _14;
  this.T21__f__15 = _15;
  this.T21__f__16 = _16;
  this.T21__f__17 = _17;
  this.T21__f__18 = _18;
  this.T21__f__19 = _19;
  this.T21__f__20 = _20;
  this.T21__f__21 = _21;
}
export { $c_T21 as $c_T21 };
$c_T21.prototype = new $h_O();
$c_T21.prototype.constructor = $c_T21;
/** @constructor */
function $h_T21() {
}
export { $h_T21 as $h_T21 };
$h_T21.prototype = $c_T21.prototype;
$c_T21.prototype.productArity__I = (function() {
  return 21;
});
$c_T21.prototype.productElement__I__O = (function(n) {
  return $f_s_Product21__productElement__I__O(this, n);
});
$c_T21.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((((((("(" + this.T21__f__1) + ",") + this.T21__f__2) + ",") + this.T21__f__3) + ",") + this.T21__f__4) + ",") + this.T21__f__5) + ",") + this.T21__f__6) + ",") + this.T21__f__7) + ",") + this.T21__f__8) + ",") + this.T21__f__9) + ",") + this.T21__f__10) + ",") + this.T21__f__11) + ",") + this.T21__f__12) + ",") + this.T21__f__13) + ",") + this.T21__f__14) + ",") + this.T21__f__15) + ",") + this.T21__f__16) + ",") + this.T21__f__17) + ",") + this.T21__f__18) + ",") + this.T21__f__19) + ",") + this.T21__f__20) + ",") + this.T21__f__21) + ")");
});
$c_T21.prototype.productPrefix__T = (function() {
  return "Tuple21";
});
$c_T21.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T21.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    case 11: {
      return "_12";
      break;
    }
    case 12: {
      return "_13";
      break;
    }
    case 13: {
      return "_14";
      break;
    }
    case 14: {
      return "_15";
      break;
    }
    case 15: {
      return "_16";
      break;
    }
    case 16: {
      return "_17";
      break;
    }
    case 17: {
      return "_18";
      break;
    }
    case 18: {
      return "_19";
      break;
    }
    case 19: {
      return "_20";
      break;
    }
    case 20: {
      return "_21";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T21.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-21288119), true);
});
$c_T21.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T21) && (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__1, x$1.T21__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__2, x$1.T21__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__3, x$1.T21__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__4, x$1.T21__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__5, x$1.T21__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__6, x$1.T21__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__7, x$1.T21__f__7)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__8, x$1.T21__f__8) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__9, x$1.T21__f__9) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__10, x$1.T21__f__10))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__11, x$1.T21__f__11) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__12, x$1.T21__f__12)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__13, x$1.T21__f__13) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__14, x$1.T21__f__14) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__15, x$1.T21__f__15)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__16, x$1.T21__f__16) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__17, x$1.T21__f__17) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__18, x$1.T21__f__18))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__19, x$1.T21__f__19) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__20, x$1.T21__f__20) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T21__f__21, x$1.T21__f__21))))))));
});
function $isArrayOf_T21(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T21)));
}
export { $isArrayOf_T21 as $isArrayOf_T21 };
var $d_T21 = new $TypeData().initClass($c_T21, "scala.Tuple21", ({
  T21: 1,
  s_Product21: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T21 as $d_T21 };
/** @constructor */
function $c_T22(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22) {
  this.T22__f__1 = null;
  this.T22__f__2 = null;
  this.T22__f__3 = null;
  this.T22__f__4 = null;
  this.T22__f__5 = null;
  this.T22__f__6 = null;
  this.T22__f__7 = null;
  this.T22__f__8 = null;
  this.T22__f__9 = null;
  this.T22__f__10 = null;
  this.T22__f__11 = null;
  this.T22__f__12 = null;
  this.T22__f__13 = null;
  this.T22__f__14 = null;
  this.T22__f__15 = null;
  this.T22__f__16 = null;
  this.T22__f__17 = null;
  this.T22__f__18 = null;
  this.T22__f__19 = null;
  this.T22__f__20 = null;
  this.T22__f__21 = null;
  this.T22__f__22 = null;
  this.T22__f__1 = _1;
  this.T22__f__2 = _2;
  this.T22__f__3 = _3;
  this.T22__f__4 = _4;
  this.T22__f__5 = _5;
  this.T22__f__6 = _6;
  this.T22__f__7 = _7;
  this.T22__f__8 = _8;
  this.T22__f__9 = _9;
  this.T22__f__10 = _10;
  this.T22__f__11 = _11;
  this.T22__f__12 = _12;
  this.T22__f__13 = _13;
  this.T22__f__14 = _14;
  this.T22__f__15 = _15;
  this.T22__f__16 = _16;
  this.T22__f__17 = _17;
  this.T22__f__18 = _18;
  this.T22__f__19 = _19;
  this.T22__f__20 = _20;
  this.T22__f__21 = _21;
  this.T22__f__22 = _22;
}
export { $c_T22 as $c_T22 };
$c_T22.prototype = new $h_O();
$c_T22.prototype.constructor = $c_T22;
/** @constructor */
function $h_T22() {
}
export { $h_T22 as $h_T22 };
$h_T22.prototype = $c_T22.prototype;
$c_T22.prototype.productArity__I = (function() {
  return 22;
});
$c_T22.prototype.productElement__I__O = (function(n) {
  return $f_s_Product22__productElement__I__O(this, n);
});
$c_T22.prototype.toString__T = (function() {
  return (((((((((((((((((((((((((((((((((((((((((((("(" + this.T22__f__1) + ",") + this.T22__f__2) + ",") + this.T22__f__3) + ",") + this.T22__f__4) + ",") + this.T22__f__5) + ",") + this.T22__f__6) + ",") + this.T22__f__7) + ",") + this.T22__f__8) + ",") + this.T22__f__9) + ",") + this.T22__f__10) + ",") + this.T22__f__11) + ",") + this.T22__f__12) + ",") + this.T22__f__13) + ",") + this.T22__f__14) + ",") + this.T22__f__15) + ",") + this.T22__f__16) + ",") + this.T22__f__17) + ",") + this.T22__f__18) + ",") + this.T22__f__19) + ",") + this.T22__f__20) + ",") + this.T22__f__21) + ",") + this.T22__f__22) + ")");
});
$c_T22.prototype.productPrefix__T = (function() {
  return "Tuple22";
});
$c_T22.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T22.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    case 9: {
      return "_10";
      break;
    }
    case 10: {
      return "_11";
      break;
    }
    case 11: {
      return "_12";
      break;
    }
    case 12: {
      return "_13";
      break;
    }
    case 13: {
      return "_14";
      break;
    }
    case 14: {
      return "_15";
      break;
    }
    case 15: {
      return "_16";
      break;
    }
    case 16: {
      return "_17";
      break;
    }
    case 17: {
      return "_18";
      break;
    }
    case 18: {
      return "_19";
      break;
    }
    case 19: {
      return "_20";
      break;
    }
    case 20: {
      return "_21";
      break;
    }
    case 21: {
      return "_22";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T22.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-139445068), true);
});
$c_T22.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T22) && (((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__1, x$1.T22__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__2, x$1.T22__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__3, x$1.T22__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__4, x$1.T22__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__5, x$1.T22__f__5)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__6, x$1.T22__f__6) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__7, x$1.T22__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__8, x$1.T22__f__8))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__9, x$1.T22__f__9) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__10, x$1.T22__f__10) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__11, x$1.T22__f__11))))) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__12, x$1.T22__f__12) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__13, x$1.T22__f__13)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__14, x$1.T22__f__14) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__15, x$1.T22__f__15) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__16, x$1.T22__f__16)))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__17, x$1.T22__f__17) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__18, x$1.T22__f__18) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__19, x$1.T22__f__19))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__20, x$1.T22__f__20) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__21, x$1.T22__f__21) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T22__f__22, x$1.T22__f__22))))))));
});
function $isArrayOf_T22(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T22)));
}
export { $isArrayOf_T22 as $isArrayOf_T22 };
var $d_T22 = new $TypeData().initClass($c_T22, "scala.Tuple22", ({
  T22: 1,
  s_Product22: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T22 as $d_T22 };
/** @constructor */
function $c_T3(_1, _2, _3) {
  this.T3__f__1 = null;
  this.T3__f__2 = null;
  this.T3__f__3 = null;
  this.T3__f__1 = _1;
  this.T3__f__2 = _2;
  this.T3__f__3 = _3;
}
export { $c_T3 as $c_T3 };
$c_T3.prototype = new $h_O();
$c_T3.prototype.constructor = $c_T3;
/** @constructor */
function $h_T3() {
}
export { $h_T3 as $h_T3 };
$h_T3.prototype = $c_T3.prototype;
$c_T3.prototype.productArity__I = (function() {
  return 3;
});
$c_T3.prototype.productElement__I__O = (function(n) {
  return $f_s_Product3__productElement__I__O(this, n);
});
$c_T3.prototype.toString__T = (function() {
  return (((((("(" + this.T3__f__1) + ",") + this.T3__f__2) + ",") + this.T3__f__3) + ")");
});
$c_T3.prototype.productPrefix__T = (function() {
  return "Tuple3";
});
$c_T3.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T3.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T3.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-192629203), true);
});
$c_T3.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__1, x$1.T3__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__2, x$1.T3__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T3__f__3, x$1.T3__f__3)))));
});
function $isArrayOf_T3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T3)));
}
export { $isArrayOf_T3 as $isArrayOf_T3 };
var $d_T3 = new $TypeData().initClass($c_T3, "scala.Tuple3", ({
  T3: 1,
  s_Product3: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T3 as $d_T3 };
/** @constructor */
function $c_T4(_1, _2, _3, _4) {
  this.T4__f__1 = null;
  this.T4__f__2 = null;
  this.T4__f__3 = null;
  this.T4__f__4 = null;
  this.T4__f__1 = _1;
  this.T4__f__2 = _2;
  this.T4__f__3 = _3;
  this.T4__f__4 = _4;
}
export { $c_T4 as $c_T4 };
$c_T4.prototype = new $h_O();
$c_T4.prototype.constructor = $c_T4;
/** @constructor */
function $h_T4() {
}
export { $h_T4 as $h_T4 };
$h_T4.prototype = $c_T4.prototype;
$c_T4.prototype.productArity__I = (function() {
  return 4;
});
$c_T4.prototype.productElement__I__O = (function(n) {
  return $f_s_Product4__productElement__I__O(this, n);
});
$c_T4.prototype.toString__T = (function() {
  return (((((((("(" + this.T4__f__1) + ",") + this.T4__f__2) + ",") + this.T4__f__3) + ",") + this.T4__f__4) + ")");
});
$c_T4.prototype.productPrefix__T = (function() {
  return "Tuple4";
});
$c_T4.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T4.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T4.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1542739752), true);
});
$c_T4.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T4) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__1, x$1.T4__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__2, x$1.T4__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__3, x$1.T4__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T4__f__4, x$1.T4__f__4)))));
});
function $isArrayOf_T4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T4)));
}
export { $isArrayOf_T4 as $isArrayOf_T4 };
var $d_T4 = new $TypeData().initClass($c_T4, "scala.Tuple4", ({
  T4: 1,
  s_Product4: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T4 as $d_T4 };
/** @constructor */
function $c_T5(_1, _2, _3, _4, _5) {
  this.T5__f__1 = null;
  this.T5__f__2 = null;
  this.T5__f__3 = null;
  this.T5__f__4 = null;
  this.T5__f__5 = null;
  this.T5__f__1 = _1;
  this.T5__f__2 = _2;
  this.T5__f__3 = _3;
  this.T5__f__4 = _4;
  this.T5__f__5 = _5;
}
export { $c_T5 as $c_T5 };
$c_T5.prototype = new $h_O();
$c_T5.prototype.constructor = $c_T5;
/** @constructor */
function $h_T5() {
}
export { $h_T5 as $h_T5 };
$h_T5.prototype = $c_T5.prototype;
$c_T5.prototype.productArity__I = (function() {
  return 5;
});
$c_T5.prototype.productElement__I__O = (function(n) {
  return $f_s_Product5__productElement__I__O(this, n);
});
$c_T5.prototype.toString__T = (function() {
  return (((((((((("(" + this.T5__f__1) + ",") + this.T5__f__2) + ",") + this.T5__f__3) + ",") + this.T5__f__4) + ",") + this.T5__f__5) + ")");
});
$c_T5.prototype.productPrefix__T = (function() {
  return "Tuple5";
});
$c_T5.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T5.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T5.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 417360321, true);
});
$c_T5.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T5) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__1, x$1.T5__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__2, x$1.T5__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__3, x$1.T5__f__3) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__4, x$1.T5__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T5__f__5, x$1.T5__f__5))))));
});
function $isArrayOf_T5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T5)));
}
export { $isArrayOf_T5 as $isArrayOf_T5 };
var $d_T5 = new $TypeData().initClass($c_T5, "scala.Tuple5", ({
  T5: 1,
  s_Product5: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T5 as $d_T5 };
/** @constructor */
function $c_T6(_1, _2, _3, _4, _5, _6) {
  this.T6__f__1 = null;
  this.T6__f__2 = null;
  this.T6__f__3 = null;
  this.T6__f__4 = null;
  this.T6__f__5 = null;
  this.T6__f__6 = null;
  this.T6__f__1 = _1;
  this.T6__f__2 = _2;
  this.T6__f__3 = _3;
  this.T6__f__4 = _4;
  this.T6__f__5 = _5;
  this.T6__f__6 = _6;
}
export { $c_T6 as $c_T6 };
$c_T6.prototype = new $h_O();
$c_T6.prototype.constructor = $c_T6;
/** @constructor */
function $h_T6() {
}
export { $h_T6 as $h_T6 };
$h_T6.prototype = $c_T6.prototype;
$c_T6.prototype.productArity__I = (function() {
  return 6;
});
$c_T6.prototype.productElement__I__O = (function(n) {
  return $f_s_Product6__productElement__I__O(this, n);
});
$c_T6.prototype.toString__T = (function() {
  return (((((((((((("(" + this.T6__f__1) + ",") + this.T6__f__2) + ",") + this.T6__f__3) + ",") + this.T6__f__4) + ",") + this.T6__f__5) + ",") + this.T6__f__6) + ")");
});
$c_T6.prototype.productPrefix__T = (function() {
  return "Tuple6";
});
$c_T6.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T6.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T6.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1037607828), true);
});
$c_T6.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T6) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__1, x$1.T6__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__2, x$1.T6__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__3, x$1.T6__f__3))) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__4, x$1.T6__f__4) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__5, x$1.T6__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T6__f__6, x$1.T6__f__6))))));
});
function $isArrayOf_T6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T6)));
}
export { $isArrayOf_T6 as $isArrayOf_T6 };
var $d_T6 = new $TypeData().initClass($c_T6, "scala.Tuple6", ({
  T6: 1,
  s_Product6: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T6 as $d_T6 };
/** @constructor */
function $c_T7(_1, _2, _3, _4, _5, _6, _7) {
  this.T7__f__1 = null;
  this.T7__f__2 = null;
  this.T7__f__3 = null;
  this.T7__f__4 = null;
  this.T7__f__5 = null;
  this.T7__f__6 = null;
  this.T7__f__7 = null;
  this.T7__f__1 = _1;
  this.T7__f__2 = _2;
  this.T7__f__3 = _3;
  this.T7__f__4 = _4;
  this.T7__f__5 = _5;
  this.T7__f__6 = _6;
  this.T7__f__7 = _7;
}
export { $c_T7 as $c_T7 };
$c_T7.prototype = new $h_O();
$c_T7.prototype.constructor = $c_T7;
/** @constructor */
function $h_T7() {
}
export { $h_T7 as $h_T7 };
$h_T7.prototype = $c_T7.prototype;
$c_T7.prototype.productArity__I = (function() {
  return 7;
});
$c_T7.prototype.productElement__I__O = (function(n) {
  return $f_s_Product7__productElement__I__O(this, n);
});
$c_T7.prototype.toString__T = (function() {
  return (((((((((((((("(" + this.T7__f__1) + ",") + this.T7__f__2) + ",") + this.T7__f__3) + ",") + this.T7__f__4) + ",") + this.T7__f__5) + ",") + this.T7__f__6) + ",") + this.T7__f__7) + ")");
});
$c_T7.prototype.productPrefix__T = (function() {
  return "Tuple7";
});
$c_T7.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T7.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T7.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1050932777), true);
});
$c_T7.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T7) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__1, x$1.T7__f__1) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__2, x$1.T7__f__2) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__3, x$1.T7__f__3))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__4, x$1.T7__f__4) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__5, x$1.T7__f__5)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__6, x$1.T7__f__6) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T7__f__7, x$1.T7__f__7))))));
});
function $isArrayOf_T7(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T7)));
}
export { $isArrayOf_T7 as $isArrayOf_T7 };
var $d_T7 = new $TypeData().initClass($c_T7, "scala.Tuple7", ({
  T7: 1,
  s_Product7: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T7 as $d_T7 };
/** @constructor */
function $c_T8(_1, _2, _3, _4, _5, _6, _7, _8) {
  this.T8__f__1 = null;
  this.T8__f__2 = null;
  this.T8__f__3 = null;
  this.T8__f__4 = null;
  this.T8__f__5 = null;
  this.T8__f__6 = null;
  this.T8__f__7 = null;
  this.T8__f__8 = null;
  this.T8__f__1 = _1;
  this.T8__f__2 = _2;
  this.T8__f__3 = _3;
  this.T8__f__4 = _4;
  this.T8__f__5 = _5;
  this.T8__f__6 = _6;
  this.T8__f__7 = _7;
  this.T8__f__8 = _8;
}
export { $c_T8 as $c_T8 };
$c_T8.prototype = new $h_O();
$c_T8.prototype.constructor = $c_T8;
/** @constructor */
function $h_T8() {
}
export { $h_T8 as $h_T8 };
$h_T8.prototype = $c_T8.prototype;
$c_T8.prototype.productArity__I = (function() {
  return 8;
});
$c_T8.prototype.productElement__I__O = (function(n) {
  return $f_s_Product8__productElement__I__O(this, n);
});
$c_T8.prototype.toString__T = (function() {
  return (((((((((((((((("(" + this.T8__f__1) + ",") + this.T8__f__2) + ",") + this.T8__f__3) + ",") + this.T8__f__4) + ",") + this.T8__f__5) + ",") + this.T8__f__6) + ",") + this.T8__f__7) + ",") + this.T8__f__8) + ")");
});
$c_T8.prototype.productPrefix__T = (function() {
  return "Tuple8";
});
$c_T8.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T8.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T8.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1998822530, true);
});
$c_T8.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T8) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__1, x$1.T8__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__2, x$1.T8__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__3, x$1.T8__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__4, x$1.T8__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__5, x$1.T8__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__6, x$1.T8__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__7, x$1.T8__f__7) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T8__f__8, x$1.T8__f__8))))));
});
function $isArrayOf_T8(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T8)));
}
export { $isArrayOf_T8 as $isArrayOf_T8 };
var $d_T8 = new $TypeData().initClass($c_T8, "scala.Tuple8", ({
  T8: 1,
  s_Product8: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T8 as $d_T8 };
/** @constructor */
function $c_T9(_1, _2, _3, _4, _5, _6, _7, _8, _9) {
  this.T9__f__1 = null;
  this.T9__f__2 = null;
  this.T9__f__3 = null;
  this.T9__f__4 = null;
  this.T9__f__5 = null;
  this.T9__f__6 = null;
  this.T9__f__7 = null;
  this.T9__f__8 = null;
  this.T9__f__9 = null;
  this.T9__f__1 = _1;
  this.T9__f__2 = _2;
  this.T9__f__3 = _3;
  this.T9__f__4 = _4;
  this.T9__f__5 = _5;
  this.T9__f__6 = _6;
  this.T9__f__7 = _7;
  this.T9__f__8 = _8;
  this.T9__f__9 = _9;
}
export { $c_T9 as $c_T9 };
$c_T9.prototype = new $h_O();
$c_T9.prototype.constructor = $c_T9;
/** @constructor */
function $h_T9() {
}
export { $h_T9 as $h_T9 };
$h_T9.prototype = $c_T9.prototype;
$c_T9.prototype.productArity__I = (function() {
  return 9;
});
$c_T9.prototype.productElement__I__O = (function(n) {
  return $f_s_Product9__productElement__I__O(this, n);
});
$c_T9.prototype.toString__T = (function() {
  return (((((((((((((((((("(" + this.T9__f__1) + ",") + this.T9__f__2) + ",") + this.T9__f__3) + ",") + this.T9__f__4) + ",") + this.T9__f__5) + ",") + this.T9__f__6) + ",") + this.T9__f__7) + ",") + this.T9__f__8) + ",") + this.T9__f__9) + ")");
});
$c_T9.prototype.productPrefix__T = (function() {
  return "Tuple9";
});
$c_T9.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_T9.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "_1";
      break;
    }
    case 1: {
      return "_2";
      break;
    }
    case 2: {
      return "_3";
      break;
    }
    case 3: {
      return "_4";
      break;
    }
    case 4: {
      return "_5";
      break;
    }
    case 5: {
      return "_6";
      break;
    }
    case 6: {
      return "_7";
      break;
    }
    case 7: {
      return "_8";
      break;
    }
    case 8: {
      return "_9";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_T9.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1807911176), true);
});
$c_T9.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_T9) && ((($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__1, x$1.T9__f__1) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__2, x$1.T9__f__2)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__3, x$1.T9__f__3) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__4, x$1.T9__f__4))) && (($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__5, x$1.T9__f__5) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__6, x$1.T9__f__6)) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__7, x$1.T9__f__7) && ($m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__8, x$1.T9__f__8) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.T9__f__9, x$1.T9__f__9)))))));
});
function $isArrayOf_T9(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T9)));
}
export { $isArrayOf_T9 as $isArrayOf_T9 };
var $d_T9 = new $TypeData().initClass($c_T9, "scala.Tuple9", ({
  T9: 1,
  s_Product9: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T9 as $d_T9 };
/** @constructor */
function $c_sc_ClassTagSeqFactory$AnySeqDelegate(delegate) {
  this.sc_ClassTagIterableFactory$AnyIterableDelegate__f_delegate = null;
  $ct_sc_ClassTagIterableFactory$AnyIterableDelegate__sc_ClassTagIterableFactory__(this, delegate);
}
export { $c_sc_ClassTagSeqFactory$AnySeqDelegate as $c_sc_ClassTagSeqFactory$AnySeqDelegate };
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = new $h_sc_ClassTagIterableFactory$AnyIterableDelegate();
$c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype.constructor = $c_sc_ClassTagSeqFactory$AnySeqDelegate;
/** @constructor */
function $h_sc_ClassTagSeqFactory$AnySeqDelegate() {
}
export { $h_sc_ClassTagSeqFactory$AnySeqDelegate as $h_sc_ClassTagSeqFactory$AnySeqDelegate };
$h_sc_ClassTagSeqFactory$AnySeqDelegate.prototype = $c_sc_ClassTagSeqFactory$AnySeqDelegate.prototype;
var $d_sc_ClassTagSeqFactory$AnySeqDelegate = new $TypeData().initClass($c_sc_ClassTagSeqFactory$AnySeqDelegate, "scala.collection.ClassTagSeqFactory$AnySeqDelegate", ({
  sc_ClassTagSeqFactory$AnySeqDelegate: 1,
  sc_ClassTagIterableFactory$AnyIterableDelegate: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1,
  sc_SeqFactory: 1
}));
export { $d_sc_ClassTagSeqFactory$AnySeqDelegate as $d_sc_ClassTagSeqFactory$AnySeqDelegate };
function $p_sc_IndexedSeqOps__foldr__I__I__O__F2__O($thiz, start, end, z, op) {
  while (true) {
    if ((start === end)) {
      return z;
    } else {
      var temp$end = (((-1) + end) | 0);
      var temp$z = op.apply__O__O__O($thiz.apply__I__O((((-1) + end) | 0)), z);
      end = temp$end;
      z = temp$z;
    }
  }
}
export { $p_sc_IndexedSeqOps__foldr__I__I__O__F2__O as $p_sc_IndexedSeqOps__foldr__I__I__O__F2__O };
function $f_sc_IndexedSeqOps__prepended__O__O($thiz, elem) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(new $c_sc_IndexedSeqView$Prepended(elem, $thiz));
}
export { $f_sc_IndexedSeqOps__prepended__O__O as $f_sc_IndexedSeqOps__prepended__O__O };
function $f_sc_IndexedSeqOps__take__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), $thiz, n));
}
export { $f_sc_IndexedSeqOps__take__I__O as $f_sc_IndexedSeqOps__take__I__O };
function $f_sc_IndexedSeqOps__drop__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), $thiz, n));
}
export { $f_sc_IndexedSeqOps__drop__I__O as $f_sc_IndexedSeqOps__drop__I__O };
function $f_sc_IndexedSeqOps__dropRight__I__O($thiz, n) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), $thiz, n));
}
export { $f_sc_IndexedSeqOps__dropRight__I__O as $f_sc_IndexedSeqOps__dropRight__I__O };
function $f_sc_IndexedSeqOps__map__F1__O($thiz, f) {
  return $thiz.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O($ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), $thiz, f));
}
export { $f_sc_IndexedSeqOps__map__F1__O as $f_sc_IndexedSeqOps__map__F1__O };
function $f_sc_IndexedSeqOps__reverse__O($thiz) {
  return $thiz.fromSpecific__sc_IterableOnce__O($ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), $thiz));
}
export { $f_sc_IndexedSeqOps__reverse__O as $f_sc_IndexedSeqOps__reverse__O };
function $f_sc_IndexedSeqOps__head__O($thiz) {
  if ((!$thiz.isEmpty__Z())) {
    return $thiz.apply__I__O(0);
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("head of empty " + ($is_sc_IndexedSeq($thiz) ? $thiz.className__T() : $thiz.toString__T())));
  }
}
export { $f_sc_IndexedSeqOps__head__O as $f_sc_IndexedSeqOps__head__O };
function $f_sc_IndexedSeqOps__headOption__s_Option($thiz) {
  return ($thiz.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($thiz.head__O()));
}
export { $f_sc_IndexedSeqOps__headOption__s_Option as $f_sc_IndexedSeqOps__headOption__s_Option };
function $f_sc_IndexedSeqOps__last__O($thiz) {
  if ((!$thiz.isEmpty__Z())) {
    return $thiz.apply__I__O((((-1) + $thiz.length__I()) | 0));
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("last of empty " + ($is_sc_IndexedSeq($thiz) ? $thiz.className__T() : $thiz.toString__T())));
  }
}
export { $f_sc_IndexedSeqOps__last__O as $f_sc_IndexedSeqOps__last__O };
function $f_sc_Iterable__toString__T($thiz) {
  return $f_sc_IterableOnceOps__mkString__T__T__T__T($thiz, ($thiz.className__T() + "("), ", ", ")");
}
export { $f_sc_Iterable__toString__T as $f_sc_Iterable__toString__T };
function $is_sc_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Iterable)));
}
export { $is_sc_Iterable as $is_sc_Iterable };
function $isArrayOf_sc_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterable)));
}
export { $isArrayOf_sc_Iterable as $isArrayOf_sc_Iterable };
function $p_sc_Iterator$$anon$10__nextCur__V($thiz) {
  $thiz.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  $thiz.sc_Iterator$$anon$10__f_cur = $thiz.sc_Iterator$$anon$10__f_f$3.apply__O__O($thiz.sc_Iterator$$anon$10__f_$outer.next__O()).iterator__sc_Iterator();
  $thiz.sc_Iterator$$anon$10__f__hasNext = (-1);
}
export { $p_sc_Iterator$$anon$10__nextCur__V as $p_sc_Iterator$$anon$10__nextCur__V };
/** @constructor */
function $c_sc_Iterator$$anon$10(outer, f$3) {
  this.sc_Iterator$$anon$10__f_cur = null;
  this.sc_Iterator$$anon$10__f__hasNext = 0;
  this.sc_Iterator$$anon$10__f_$outer = null;
  this.sc_Iterator$$anon$10__f_f$3 = null;
  this.sc_Iterator$$anon$10__f_$outer = outer;
  this.sc_Iterator$$anon$10__f_f$3 = f$3;
  this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  this.sc_Iterator$$anon$10__f__hasNext = (-1);
}
export { $c_sc_Iterator$$anon$10 as $c_sc_Iterator$$anon$10 };
$c_sc_Iterator$$anon$10.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$10.prototype.constructor = $c_sc_Iterator$$anon$10;
/** @constructor */
function $h_sc_Iterator$$anon$10() {
}
export { $h_sc_Iterator$$anon$10 as $h_sc_Iterator$$anon$10 };
$h_sc_Iterator$$anon$10.prototype = $c_sc_Iterator$$anon$10.prototype;
$c_sc_Iterator$$anon$10.prototype.hasNext__Z = (function() {
  if ((this.sc_Iterator$$anon$10__f__hasNext === (-1))) {
    while ((!this.sc_Iterator$$anon$10__f_cur.hasNext__Z())) {
      if ((!this.sc_Iterator$$anon$10__f_$outer.hasNext__Z())) {
        this.sc_Iterator$$anon$10__f__hasNext = 0;
        this.sc_Iterator$$anon$10__f_cur = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
        return false;
      }
      $p_sc_Iterator$$anon$10__nextCur__V(this);
    }
    this.sc_Iterator$$anon$10__f__hasNext = 1;
    return true;
  } else {
    return (this.sc_Iterator$$anon$10__f__hasNext === 1);
  }
});
$c_sc_Iterator$$anon$10.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$10__f__hasNext = (-1);
  }
  return this.sc_Iterator$$anon$10__f_cur.next__O();
});
var $d_sc_Iterator$$anon$10 = new $TypeData().initClass($c_sc_Iterator$$anon$10, "scala.collection.Iterator$$anon$10", ({
  sc_Iterator$$anon$10: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_Iterator$$anon$10 as $d_sc_Iterator$$anon$10 };
/** @constructor */
function $c_sc_Iterator$$anon$16(outer) {
  this.sc_Iterator$$anon$16__f_idx = 0;
  this.sc_Iterator$$anon$16__f_$outer = null;
  this.sc_Iterator$$anon$16__f_$outer = outer;
  this.sc_Iterator$$anon$16__f_idx = 0;
}
export { $c_sc_Iterator$$anon$16 as $c_sc_Iterator$$anon$16 };
$c_sc_Iterator$$anon$16.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$16.prototype.constructor = $c_sc_Iterator$$anon$16;
/** @constructor */
function $h_sc_Iterator$$anon$16() {
}
export { $h_sc_Iterator$$anon$16 as $h_sc_Iterator$$anon$16 };
$h_sc_Iterator$$anon$16.prototype = $c_sc_Iterator$$anon$16.prototype;
$c_sc_Iterator$$anon$16.prototype.knownSize__I = (function() {
  return this.sc_Iterator$$anon$16__f_$outer.knownSize__I();
});
$c_sc_Iterator$$anon$16.prototype.hasNext__Z = (function() {
  return this.sc_Iterator$$anon$16__f_$outer.hasNext__Z();
});
$c_sc_Iterator$$anon$16.prototype.next__T2 = (function() {
  var ret = $ct_T2__O__O__(new $c_T2(), this.sc_Iterator$$anon$16__f_$outer.next__O(), this.sc_Iterator$$anon$16__f_idx);
  this.sc_Iterator$$anon$16__f_idx = ((1 + this.sc_Iterator$$anon$16__f_idx) | 0);
  return ret;
});
$c_sc_Iterator$$anon$16.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sc_Iterator$$anon$16 = new $TypeData().initClass($c_sc_Iterator$$anon$16, "scala.collection.Iterator$$anon$16", ({
  sc_Iterator$$anon$16: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_Iterator$$anon$16 as $d_sc_Iterator$$anon$16 };
/** @constructor */
function $c_sc_Iterator$$anon$19() {
}
export { $c_sc_Iterator$$anon$19 as $c_sc_Iterator$$anon$19 };
$c_sc_Iterator$$anon$19.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$19.prototype.constructor = $c_sc_Iterator$$anon$19;
/** @constructor */
function $h_sc_Iterator$$anon$19() {
}
export { $h_sc_Iterator$$anon$19 as $h_sc_Iterator$$anon$19 };
$h_sc_Iterator$$anon$19.prototype = $c_sc_Iterator$$anon$19.prototype;
$c_sc_Iterator$$anon$19.prototype.hasNext__Z = (function() {
  return false;
});
$c_sc_Iterator$$anon$19.prototype.next__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next on empty iterator");
});
$c_sc_Iterator$$anon$19.prototype.knownSize__I = (function() {
  return 0;
});
$c_sc_Iterator$$anon$19.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return this;
});
$c_sc_Iterator$$anon$19.prototype.next__O = (function() {
  this.next__E();
});
var $d_sc_Iterator$$anon$19 = new $TypeData().initClass($c_sc_Iterator$$anon$19, "scala.collection.Iterator$$anon$19", ({
  sc_Iterator$$anon$19: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_Iterator$$anon$19 as $d_sc_Iterator$$anon$19 };
/** @constructor */
function $c_sc_Iterator$$anon$20(a$1) {
  this.sc_Iterator$$anon$20__f_consumed = false;
  this.sc_Iterator$$anon$20__f_a$1 = null;
  this.sc_Iterator$$anon$20__f_a$1 = a$1;
  this.sc_Iterator$$anon$20__f_consumed = false;
}
export { $c_sc_Iterator$$anon$20 as $c_sc_Iterator$$anon$20 };
$c_sc_Iterator$$anon$20.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$20.prototype.constructor = $c_sc_Iterator$$anon$20;
/** @constructor */
function $h_sc_Iterator$$anon$20() {
}
export { $h_sc_Iterator$$anon$20 as $h_sc_Iterator$$anon$20 };
$h_sc_Iterator$$anon$20.prototype = $c_sc_Iterator$$anon$20.prototype;
$c_sc_Iterator$$anon$20.prototype.hasNext__Z = (function() {
  return (!this.sc_Iterator$$anon$20__f_consumed);
});
$c_sc_Iterator$$anon$20.prototype.next__O = (function() {
  if (this.sc_Iterator$$anon$20__f_consumed) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  } else {
    this.sc_Iterator$$anon$20__f_consumed = true;
    return this.sc_Iterator$$anon$20__f_a$1;
  }
});
$c_sc_Iterator$$anon$20.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  return (((this.sc_Iterator$$anon$20__f_consumed || (from > 0)) || (until === 0)) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : this);
});
var $d_sc_Iterator$$anon$20 = new $TypeData().initClass($c_sc_Iterator$$anon$20, "scala.collection.Iterator$$anon$20", ({
  sc_Iterator$$anon$20: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_Iterator$$anon$20 as $d_sc_Iterator$$anon$20 };
/** @constructor */
function $c_sc_Iterator$$anon$6(outer, p$1, isFlipped$1) {
  this.sc_Iterator$$anon$6__f_hd = null;
  this.sc_Iterator$$anon$6__f_hdDefined = false;
  this.sc_Iterator$$anon$6__f_$outer = null;
  this.sc_Iterator$$anon$6__f_p$1 = null;
  this.sc_Iterator$$anon$6__f_isFlipped$1 = false;
  this.sc_Iterator$$anon$6__f_$outer = outer;
  this.sc_Iterator$$anon$6__f_p$1 = p$1;
  this.sc_Iterator$$anon$6__f_isFlipped$1 = isFlipped$1;
  this.sc_Iterator$$anon$6__f_hdDefined = false;
}
export { $c_sc_Iterator$$anon$6 as $c_sc_Iterator$$anon$6 };
$c_sc_Iterator$$anon$6.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$6.prototype.constructor = $c_sc_Iterator$$anon$6;
/** @constructor */
function $h_sc_Iterator$$anon$6() {
}
export { $h_sc_Iterator$$anon$6 as $h_sc_Iterator$$anon$6 };
$h_sc_Iterator$$anon$6.prototype = $c_sc_Iterator$$anon$6.prototype;
$c_sc_Iterator$$anon$6.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$$anon$6__f_hdDefined) {
    return true;
  } else {
    if ((!this.sc_Iterator$$anon$6__f_$outer.hasNext__Z())) {
      return false;
    }
    this.sc_Iterator$$anon$6__f_hd = this.sc_Iterator$$anon$6__f_$outer.next__O();
    while (((!(!this.sc_Iterator$$anon$6__f_p$1.apply__O__O(this.sc_Iterator$$anon$6__f_hd))) === this.sc_Iterator$$anon$6__f_isFlipped$1)) {
      if ((!this.sc_Iterator$$anon$6__f_$outer.hasNext__Z())) {
        return false;
      }
      this.sc_Iterator$$anon$6__f_hd = this.sc_Iterator$$anon$6__f_$outer.next__O();
    }
    this.sc_Iterator$$anon$6__f_hdDefined = true;
    return true;
  }
});
$c_sc_Iterator$$anon$6.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$6__f_hdDefined = false;
    return this.sc_Iterator$$anon$6__f_hd;
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
var $d_sc_Iterator$$anon$6 = new $TypeData().initClass($c_sc_Iterator$$anon$6, "scala.collection.Iterator$$anon$6", ({
  sc_Iterator$$anon$6: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_Iterator$$anon$6 as $d_sc_Iterator$$anon$6 };
/** @constructor */
function $c_sc_Iterator$$anon$8(outer, f$1) {
  this.sc_Iterator$$anon$8__f_traversedValues = null;
  this.sc_Iterator$$anon$8__f_nextElementDefined = false;
  this.sc_Iterator$$anon$8__f_nextElement = null;
  this.sc_Iterator$$anon$8__f_$outer = null;
  this.sc_Iterator$$anon$8__f_f$1 = null;
  this.sc_Iterator$$anon$8__f_$outer = outer;
  this.sc_Iterator$$anon$8__f_f$1 = f$1;
  this.sc_Iterator$$anon$8__f_traversedValues = $ct_scm_HashSet__(new $c_scm_HashSet());
  this.sc_Iterator$$anon$8__f_nextElementDefined = false;
}
export { $c_sc_Iterator$$anon$8 as $c_sc_Iterator$$anon$8 };
$c_sc_Iterator$$anon$8.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$8.prototype.constructor = $c_sc_Iterator$$anon$8;
/** @constructor */
function $h_sc_Iterator$$anon$8() {
}
export { $h_sc_Iterator$$anon$8 as $h_sc_Iterator$$anon$8 };
$h_sc_Iterator$$anon$8.prototype = $c_sc_Iterator$$anon$8.prototype;
$c_sc_Iterator$$anon$8.prototype.hasNext__Z = (function() {
  while (true) {
    if (this.sc_Iterator$$anon$8__f_nextElementDefined) {
      return true;
    } else if (this.sc_Iterator$$anon$8__f_$outer.hasNext__Z()) {
      var a = this.sc_Iterator$$anon$8__f_$outer.next__O();
      if (this.sc_Iterator$$anon$8__f_traversedValues.add__O__Z(this.sc_Iterator$$anon$8__f_f$1.apply__O__O(a))) {
        this.sc_Iterator$$anon$8__f_nextElement = a;
        this.sc_Iterator$$anon$8__f_nextElementDefined = true;
        return true;
      }
    } else {
      return false;
    }
  }
});
$c_sc_Iterator$$anon$8.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$8__f_nextElementDefined = false;
    return this.sc_Iterator$$anon$8__f_nextElement;
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
var $d_sc_Iterator$$anon$8 = new $TypeData().initClass($c_sc_Iterator$$anon$8, "scala.collection.Iterator$$anon$8", ({
  sc_Iterator$$anon$8: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_Iterator$$anon$8 as $d_sc_Iterator$$anon$8 };
/** @constructor */
function $c_sc_Iterator$$anon$9(outer, f$2) {
  this.sc_Iterator$$anon$9__f_$outer = null;
  this.sc_Iterator$$anon$9__f_f$2 = null;
  this.sc_Iterator$$anon$9__f_$outer = outer;
  this.sc_Iterator$$anon$9__f_f$2 = f$2;
}
export { $c_sc_Iterator$$anon$9 as $c_sc_Iterator$$anon$9 };
$c_sc_Iterator$$anon$9.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$9.prototype.constructor = $c_sc_Iterator$$anon$9;
/** @constructor */
function $h_sc_Iterator$$anon$9() {
}
export { $h_sc_Iterator$$anon$9 as $h_sc_Iterator$$anon$9 };
$h_sc_Iterator$$anon$9.prototype = $c_sc_Iterator$$anon$9.prototype;
$c_sc_Iterator$$anon$9.prototype.knownSize__I = (function() {
  return this.sc_Iterator$$anon$9__f_$outer.knownSize__I();
});
$c_sc_Iterator$$anon$9.prototype.hasNext__Z = (function() {
  return this.sc_Iterator$$anon$9__f_$outer.hasNext__Z();
});
$c_sc_Iterator$$anon$9.prototype.next__O = (function() {
  return this.sc_Iterator$$anon$9__f_f$2.apply__O__O(this.sc_Iterator$$anon$9__f_$outer.next__O());
});
var $d_sc_Iterator$$anon$9 = new $TypeData().initClass($c_sc_Iterator$$anon$9, "scala.collection.Iterator$$anon$9", ({
  sc_Iterator$$anon$9: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_Iterator$$anon$9 as $d_sc_Iterator$$anon$9 };
function $p_sc_Iterator$ConcatIterator__merge$1__V($thiz) {
  while (true) {
    if (($thiz.sc_Iterator$ConcatIterator__f_current instanceof $c_sc_Iterator$ConcatIterator)) {
      var c = $thiz.sc_Iterator$ConcatIterator__f_current;
      $thiz.sc_Iterator$ConcatIterator__f_current = c.sc_Iterator$ConcatIterator__f_current;
      $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = c.sc_Iterator$ConcatIterator__f_currentHasNextChecked;
      if ((c.sc_Iterator$ConcatIterator__f_tail !== null)) {
        if (($thiz.sc_Iterator$ConcatIterator__f_last === null)) {
          $thiz.sc_Iterator$ConcatIterator__f_last = c.sc_Iterator$ConcatIterator__f_last;
        }
        c.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail = $thiz.sc_Iterator$ConcatIterator__f_tail;
        $thiz.sc_Iterator$ConcatIterator__f_tail = c.sc_Iterator$ConcatIterator__f_tail;
      }
      continue;
    }
    return (void 0);
  }
}
export { $p_sc_Iterator$ConcatIterator__merge$1__V as $p_sc_Iterator$ConcatIterator__merge$1__V };
function $p_sc_Iterator$ConcatIterator__advance$1__Z($thiz) {
  while (true) {
    if (($thiz.sc_Iterator$ConcatIterator__f_tail === null)) {
      $thiz.sc_Iterator$ConcatIterator__f_current = null;
      $thiz.sc_Iterator$ConcatIterator__f_last = null;
      return false;
    } else {
      $thiz.sc_Iterator$ConcatIterator__f_current = $thiz.sc_Iterator$ConcatIterator__f_tail.headIterator__sc_Iterator();
      if (($thiz.sc_Iterator$ConcatIterator__f_last === $thiz.sc_Iterator$ConcatIterator__f_tail)) {
        $thiz.sc_Iterator$ConcatIterator__f_last = $thiz.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail;
      }
      $thiz.sc_Iterator$ConcatIterator__f_tail = $thiz.sc_Iterator$ConcatIterator__f_tail.sc_Iterator$ConcatIteratorCell__f_tail;
      $p_sc_Iterator$ConcatIterator__merge$1__V($thiz);
      if ($thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
        return true;
      } else if ((($thiz.sc_Iterator$ConcatIterator__f_current !== null) && $thiz.sc_Iterator$ConcatIterator__f_current.hasNext__Z())) {
        $thiz.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
        return true;
      }
    }
  }
}
export { $p_sc_Iterator$ConcatIterator__advance$1__Z as $p_sc_Iterator$ConcatIterator__advance$1__Z };
/** @constructor */
function $c_sc_Iterator$ConcatIterator(current) {
  this.sc_Iterator$ConcatIterator__f_current = null;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
  this.sc_Iterator$ConcatIterator__f_current = current;
  this.sc_Iterator$ConcatIterator__f_tail = null;
  this.sc_Iterator$ConcatIterator__f_last = null;
  this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
}
export { $c_sc_Iterator$ConcatIterator as $c_sc_Iterator$ConcatIterator };
$c_sc_Iterator$ConcatIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$ConcatIterator.prototype.constructor = $c_sc_Iterator$ConcatIterator;
/** @constructor */
function $h_sc_Iterator$ConcatIterator() {
}
export { $h_sc_Iterator$ConcatIterator as $h_sc_Iterator$ConcatIterator };
$h_sc_Iterator$ConcatIterator.prototype = $c_sc_Iterator$ConcatIterator.prototype;
$c_sc_Iterator$ConcatIterator.prototype.hasNext__Z = (function() {
  if (this.sc_Iterator$ConcatIterator__f_currentHasNextChecked) {
    return true;
  } else if ((this.sc_Iterator$ConcatIterator__f_current !== null)) {
    if (this.sc_Iterator$ConcatIterator__f_current.hasNext__Z()) {
      this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = true;
      return true;
    } else {
      return $p_sc_Iterator$ConcatIterator__advance$1__Z(this);
    }
  } else {
    return false;
  }
});
$c_sc_Iterator$ConcatIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$ConcatIterator__f_currentHasNextChecked = false;
    return this.sc_Iterator$ConcatIterator__f_current.next__O();
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
$c_sc_Iterator$ConcatIterator.prototype.concat__F0__sc_Iterator = (function(that) {
  var c = new $c_sc_Iterator$ConcatIteratorCell(that, null);
  if ((this.sc_Iterator$ConcatIterator__f_tail === null)) {
    this.sc_Iterator$ConcatIterator__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c;
  } else {
    this.sc_Iterator$ConcatIterator__f_last.sc_Iterator$ConcatIteratorCell__f_tail = c;
    this.sc_Iterator$ConcatIterator__f_last = c;
  }
  if ((this.sc_Iterator$ConcatIterator__f_current === null)) {
    this.sc_Iterator$ConcatIterator__f_current = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  }
  return this;
});
function $isArrayOf_sc_Iterator$ConcatIterator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Iterator$ConcatIterator)));
}
export { $isArrayOf_sc_Iterator$ConcatIterator as $isArrayOf_sc_Iterator$ConcatIterator };
var $d_sc_Iterator$ConcatIterator = new $TypeData().initClass($c_sc_Iterator$ConcatIterator, "scala.collection.Iterator$ConcatIterator", ({
  sc_Iterator$ConcatIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_Iterator$ConcatIterator as $d_sc_Iterator$ConcatIterator };
function $p_sc_Iterator$SliceIterator__skip__V($thiz) {
  while (($thiz.sc_Iterator$SliceIterator__f_dropping > 0)) {
    if ($thiz.sc_Iterator$SliceIterator__f_underlying.hasNext__Z()) {
      $thiz.sc_Iterator$SliceIterator__f_underlying.next__O();
      $thiz.sc_Iterator$SliceIterator__f_dropping = (((-1) + $thiz.sc_Iterator$SliceIterator__f_dropping) | 0);
    } else {
      $thiz.sc_Iterator$SliceIterator__f_dropping = 0;
    }
  }
}
export { $p_sc_Iterator$SliceIterator__skip__V as $p_sc_Iterator$SliceIterator__skip__V };
function $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I($thiz, lo$1) {
  if (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    return (-1);
  } else {
    var that = (($thiz.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining - lo$1) | 0);
    return ((that < 0) ? 0 : that);
  }
}
export { $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I as $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I };
/** @constructor */
function $c_sc_Iterator$SliceIterator(underlying, start, limit) {
  this.sc_Iterator$SliceIterator__f_underlying = null;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = 0;
  this.sc_Iterator$SliceIterator__f_dropping = 0;
  this.sc_Iterator$SliceIterator__f_underlying = underlying;
  this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = limit;
  this.sc_Iterator$SliceIterator__f_dropping = start;
}
export { $c_sc_Iterator$SliceIterator as $c_sc_Iterator$SliceIterator };
$c_sc_Iterator$SliceIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$SliceIterator.prototype.constructor = $c_sc_Iterator$SliceIterator;
/** @constructor */
function $h_sc_Iterator$SliceIterator() {
}
export { $h_sc_Iterator$SliceIterator as $h_sc_Iterator$SliceIterator };
$h_sc_Iterator$SliceIterator.prototype = $c_sc_Iterator$SliceIterator.prototype;
$c_sc_Iterator$SliceIterator.prototype.knownSize__I = (function() {
  var size = this.sc_Iterator$SliceIterator__f_underlying.knownSize__I();
  if ((size < 0)) {
    return (-1);
  } else {
    var that = ((size - this.sc_Iterator$SliceIterator__f_dropping) | 0);
    var dropSize = ((that < 0) ? 0 : that);
    if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
      return dropSize;
    } else {
      var x = this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining;
      return ((x < dropSize) ? x : dropSize);
    }
  }
});
$c_sc_Iterator$SliceIterator.prototype.hasNext__Z = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining !== 0) && this.sc_Iterator$SliceIterator__f_underlying.hasNext__Z());
});
$c_sc_Iterator$SliceIterator.prototype.next__O = (function() {
  $p_sc_Iterator$SliceIterator__skip__V(this);
  if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining > 0)) {
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = (((-1) + this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining) | 0);
    return this.sc_Iterator$SliceIterator__f_underlying.next__O();
  } else {
    return ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0) ? this.sc_Iterator$SliceIterator__f_underlying.next__O() : $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O());
  }
});
$c_sc_Iterator$SliceIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  if ((until < 0)) {
    var rest = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
  } else if ((until <= lo)) {
    var rest = 0;
  } else if ((this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining < 0)) {
    var rest = ((until - lo) | 0);
  } else {
    var x = $p_sc_Iterator$SliceIterator__adjustedBound$1__I__I(this, lo);
    var that = ((until - lo) | 0);
    var rest = ((x < that) ? x : that);
  }
  var sum = ((this.sc_Iterator$SliceIterator__f_dropping + lo) | 0);
  if ((rest === 0)) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  } else if ((sum < 0)) {
    this.sc_Iterator$SliceIterator__f_dropping = 2147483647;
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = 0;
    var xs = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $c_sc_Iterator$SliceIterator(this.sc_Iterator$SliceIterator__f_underlying, (((-2147483647) + sum) | 0), rest)));
    return $f_sc_Iterator__concat__F0__sc_Iterator(this, xs);
  } else {
    this.sc_Iterator$SliceIterator__f_dropping = sum;
    this.sc_Iterator$SliceIterator__f_scala$collection$Iterator$SliceIterator$$remaining = rest;
    return this;
  }
});
var $d_sc_Iterator$SliceIterator = new $TypeData().initClass($c_sc_Iterator$SliceIterator, "scala.collection.Iterator$SliceIterator", ({
  sc_Iterator$SliceIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_Iterator$SliceIterator as $d_sc_Iterator$SliceIterator };
/** @constructor */
function $c_sc_LinearSeqIterator(coll) {
  this.sc_LinearSeqIterator__f_these = null;
  this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => coll)));
}
export { $c_sc_LinearSeqIterator as $c_sc_LinearSeqIterator };
$c_sc_LinearSeqIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_LinearSeqIterator.prototype.constructor = $c_sc_LinearSeqIterator;
/** @constructor */
function $h_sc_LinearSeqIterator() {
}
export { $h_sc_LinearSeqIterator as $h_sc_LinearSeqIterator };
$h_sc_LinearSeqIterator.prototype = $c_sc_LinearSeqIterator.prototype;
$c_sc_LinearSeqIterator.prototype.hasNext__Z = (function() {
  var this$1 = this.sc_LinearSeqIterator__f_these.v__sc_LinearSeqOps();
  return (!this$1.isEmpty__Z());
});
$c_sc_LinearSeqIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  } else {
    var cur = this.sc_LinearSeqIterator__f_these.v__sc_LinearSeqOps();
    var result = cur.head__O();
    this.sc_LinearSeqIterator__f_these = new $c_sc_LinearSeqIterator$LazyCell(this, new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => cur.tail__O())));
    return result;
  }
});
var $d_sc_LinearSeqIterator = new $TypeData().initClass($c_sc_LinearSeqIterator, "scala.collection.LinearSeqIterator", ({
  sc_LinearSeqIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_LinearSeqIterator as $d_sc_LinearSeqIterator };
function $f_sc_LinearSeqOps__headOption__s_Option($thiz) {
  return ($thiz.isEmpty__Z() ? $m_s_None$() : new $c_s_Some($thiz.head__O()));
}
export { $f_sc_LinearSeqOps__headOption__s_Option as $f_sc_LinearSeqOps__headOption__s_Option };
function $f_sc_LinearSeqOps__iterator__sc_Iterator($thiz) {
  return (($thiz.knownSize__I() === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sc_LinearSeqIterator($thiz));
}
export { $f_sc_LinearSeqOps__iterator__sc_Iterator as $f_sc_LinearSeqOps__iterator__sc_Iterator };
function $f_sc_LinearSeqOps__length__I($thiz) {
  var these = $thiz;
  var len = 0;
  while (true) {
    var this$1 = these;
    if ((!this$1.isEmpty__Z())) {
      len = ((1 + len) | 0);
      these = these.tail__O();
    } else {
      break;
    }
  }
  return len;
}
export { $f_sc_LinearSeqOps__length__I as $f_sc_LinearSeqOps__length__I };
function $f_sc_LinearSeqOps__last__O($thiz) {
  if ($thiz.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "LinearSeq.last");
  } else {
    var these = $thiz;
    var scout = $thiz.tail__O();
    while (true) {
      var this$1 = scout;
      if ((!this$1.isEmpty__Z())) {
        these = scout;
        scout = scout.tail__O();
      } else {
        break;
      }
    }
    return these.head__O();
  }
}
export { $f_sc_LinearSeqOps__last__O as $f_sc_LinearSeqOps__last__O };
function $f_sc_LinearSeqOps__lengthCompare__I__I($thiz, len) {
  return ((len < 0) ? 1 : $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, 0, $thiz, len));
}
export { $f_sc_LinearSeqOps__lengthCompare__I__I as $f_sc_LinearSeqOps__lengthCompare__I__I };
function $f_sc_LinearSeqOps__isDefinedAt__I__Z($thiz, x) {
  return ((x >= 0) && ($thiz.lengthCompare__I__I(x) > 0));
}
export { $f_sc_LinearSeqOps__isDefinedAt__I__Z as $f_sc_LinearSeqOps__isDefinedAt__I__Z };
function $f_sc_LinearSeqOps__apply__I__O($thiz, n) {
  if ((n < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  var skipped = $thiz.drop__I__O(n);
  if (skipped.isEmpty__Z()) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  return skipped.head__O();
}
export { $f_sc_LinearSeqOps__apply__I__O as $f_sc_LinearSeqOps__apply__I__O };
function $f_sc_LinearSeqOps__foreach__F1__V($thiz, f) {
  var these = $thiz;
  while ((!these.isEmpty__Z())) {
    f.apply__O__O(these.head__O());
    these = these.tail__O();
  }
}
export { $f_sc_LinearSeqOps__foreach__F1__V as $f_sc_LinearSeqOps__foreach__F1__V };
function $f_sc_LinearSeqOps__forall__F1__Z($thiz, p) {
  var these = $thiz;
  while ((!these.isEmpty__Z())) {
    if ((!(!(!p.apply__O__O(these.head__O()))))) {
      return false;
    }
    these = these.tail__O();
  }
  return true;
}
export { $f_sc_LinearSeqOps__forall__F1__Z as $f_sc_LinearSeqOps__forall__F1__Z };
function $f_sc_LinearSeqOps__exists__F1__Z($thiz, p) {
  var these = $thiz;
  while ((!these.isEmpty__Z())) {
    if ((!(!p.apply__O__O(these.head__O())))) {
      return true;
    }
    these = these.tail__O();
  }
  return false;
}
export { $f_sc_LinearSeqOps__exists__F1__Z as $f_sc_LinearSeqOps__exists__F1__Z };
function $f_sc_LinearSeqOps__find__F1__s_Option($thiz, p) {
  var these = $thiz;
  while ((!these.isEmpty__Z())) {
    if ((!(!p.apply__O__O(these.head__O())))) {
      return new $c_s_Some(these.head__O());
    }
    these = these.tail__O();
  }
  return $m_s_None$();
}
export { $f_sc_LinearSeqOps__find__F1__s_Option as $f_sc_LinearSeqOps__find__F1__s_Option };
function $f_sc_LinearSeqOps__foldLeft__O__F2__O($thiz, z, op) {
  var acc = z;
  var these = $thiz;
  while ((!these.isEmpty__Z())) {
    acc = op.apply__O__O__O(acc, these.head__O());
    these = these.tail__O();
  }
  return acc;
}
export { $f_sc_LinearSeqOps__foldLeft__O__F2__O as $f_sc_LinearSeqOps__foldLeft__O__F2__O };
function $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z($thiz, that) {
  return ($is_sc_LinearSeq(that) ? $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, $thiz, that) : $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, that));
}
export { $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z as $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z };
function $f_sc_LinearSeqOps__indexWhere__F1__I__I($thiz, p, from) {
  var i = ((from > 0) ? from : 0);
  var these = $thiz.drop__I__O(from);
  while (true) {
    var this$3 = these;
    if ((!this$3.isEmpty__Z())) {
      if ((!(!p.apply__O__O(these.head__O())))) {
        return i;
      }
      i = ((1 + i) | 0);
      these = these.tail__O();
    } else {
      break;
    }
  }
  return (-1);
}
export { $f_sc_LinearSeqOps__indexWhere__F1__I__I as $f_sc_LinearSeqOps__indexWhere__F1__I__I };
function $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return (xs.isEmpty__Z() ? 0 : 1);
    } else if (xs.isEmpty__Z()) {
      return (-1);
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = xs.tail__O();
      i = temp$i;
      xs = temp$xs;
    }
  }
}
export { $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I as $p_sc_LinearSeqOps__loop$1__I__sc_LinearSeq__I__I };
function $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true;
    } else {
      var this$1 = a;
      if ((!this$1.isEmpty__Z())) {
        var this$2 = b;
        var $x_1 = (!this$2.isEmpty__Z());
      } else {
        var $x_1 = false;
      }
      if (($x_1 && $m_sr_BoxesRunTime$().equals__O__O__Z(a.head__O(), b.head__O()))) {
        var temp$a = a.tail__O();
        var temp$b = b.tail__O();
        a = temp$a;
        b = temp$b;
      } else {
        return (a.isEmpty__Z() && b.isEmpty__Z());
      }
    }
  }
}
export { $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z as $p_sc_LinearSeqOps__linearSeqEq$1__sc_LinearSeq__sc_LinearSeq__Z };
/** @constructor */
function $c_sc_MapOps$$anon$2(outer) {
  this.sc_MapOps$$anon$2__f_iter = null;
  this.sc_MapOps$$anon$2__f_iter = outer.iterator__sc_Iterator();
}
export { $c_sc_MapOps$$anon$2 as $c_sc_MapOps$$anon$2 };
$c_sc_MapOps$$anon$2.prototype = new $h_sc_AbstractIterator();
$c_sc_MapOps$$anon$2.prototype.constructor = $c_sc_MapOps$$anon$2;
/** @constructor */
function $h_sc_MapOps$$anon$2() {
}
export { $h_sc_MapOps$$anon$2 as $h_sc_MapOps$$anon$2 };
$h_sc_MapOps$$anon$2.prototype = $c_sc_MapOps$$anon$2.prototype;
$c_sc_MapOps$$anon$2.prototype.hasNext__Z = (function() {
  return this.sc_MapOps$$anon$2__f_iter.hasNext__Z();
});
$c_sc_MapOps$$anon$2.prototype.next__O = (function() {
  return this.sc_MapOps$$anon$2__f_iter.next__O()._1__O();
});
var $d_sc_MapOps$$anon$2 = new $TypeData().initClass($c_sc_MapOps$$anon$2, "scala.collection.MapOps$$anon$2", ({
  sc_MapOps$$anon$2: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_MapOps$$anon$2 as $d_sc_MapOps$$anon$2 };
/** @constructor */
function $c_sc_MapOps$$anon$3(outer) {
  this.sc_MapOps$$anon$3__f_iter = null;
  this.sc_MapOps$$anon$3__f_iter = outer.iterator__sc_Iterator();
}
export { $c_sc_MapOps$$anon$3 as $c_sc_MapOps$$anon$3 };
$c_sc_MapOps$$anon$3.prototype = new $h_sc_AbstractIterator();
$c_sc_MapOps$$anon$3.prototype.constructor = $c_sc_MapOps$$anon$3;
/** @constructor */
function $h_sc_MapOps$$anon$3() {
}
export { $h_sc_MapOps$$anon$3 as $h_sc_MapOps$$anon$3 };
$h_sc_MapOps$$anon$3.prototype = $c_sc_MapOps$$anon$3.prototype;
$c_sc_MapOps$$anon$3.prototype.hasNext__Z = (function() {
  return this.sc_MapOps$$anon$3__f_iter.hasNext__Z();
});
$c_sc_MapOps$$anon$3.prototype.next__O = (function() {
  return this.sc_MapOps$$anon$3__f_iter.next__O()._2__O();
});
var $d_sc_MapOps$$anon$3 = new $TypeData().initClass($c_sc_MapOps$$anon$3, "scala.collection.MapOps$$anon$3", ({
  sc_MapOps$$anon$3: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_MapOps$$anon$3 as $d_sc_MapOps$$anon$3 };
function $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps($thiz, that) {
  if ((($thiz instanceof $c_sci_Set$Set1) || (($thiz instanceof $c_sci_Set$Set2) || (($thiz instanceof $c_sci_Set$Set3) || ($thiz instanceof $c_sci_Set$Set4))))) {
    var result = $thiz;
    var it = that.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var this$1 = result;
      var elem = it.next__O();
      result = this$1.incl__O__sci_SetOps(elem);
    }
    return result;
  } else {
    return $thiz.fromSpecific__sc_IterableOnce__O(($is_sc_Iterable(that) ? new $c_sc_View$Concat($thiz, that) : $thiz.iterator__sc_Iterator().concat__F0__sc_Iterator(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => that.iterator__sc_Iterator())))));
  }
}
export { $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps as $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps };
/** @constructor */
function $c_sc_StrictOptimizedLinearSeqOps$$anon$1(outer) {
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = null;
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = outer;
}
export { $c_sc_StrictOptimizedLinearSeqOps$$anon$1 as $c_sc_StrictOptimizedLinearSeqOps$$anon$1 };
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.constructor = $c_sc_StrictOptimizedLinearSeqOps$$anon$1;
/** @constructor */
function $h_sc_StrictOptimizedLinearSeqOps$$anon$1() {
}
export { $h_sc_StrictOptimizedLinearSeqOps$$anon$1 as $h_sc_StrictOptimizedLinearSeqOps$$anon$1 };
$h_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype = $c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype;
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.hasNext__Z = (function() {
  return (!this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.isEmpty__Z());
});
$c_sc_StrictOptimizedLinearSeqOps$$anon$1.prototype.next__O = (function() {
  var r = this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.head__O();
  this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current = this.sc_StrictOptimizedLinearSeqOps$$anon$1__f_current.tail__O();
  return r;
});
var $d_sc_StrictOptimizedLinearSeqOps$$anon$1 = new $TypeData().initClass($c_sc_StrictOptimizedLinearSeqOps$$anon$1, "scala.collection.StrictOptimizedLinearSeqOps$$anon$1", ({
  sc_StrictOptimizedLinearSeqOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_StrictOptimizedLinearSeqOps$$anon$1 as $d_sc_StrictOptimizedLinearSeqOps$$anon$1 };
function $p_sc_StringOps$$anon$1__advance__T($thiz) {
  var start = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  while (true) {
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      var this$ = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var c = this$.charCodeAt(i);
      var $x_1 = (!((c === 13) || (c === 10)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    } else {
      break;
    }
  }
  var end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
  if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
    var this$$2 = $thiz.sc_StringOps$$anon$1__f_$this$2;
    var i$1 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
    var c$1 = this$$2.charCodeAt(i$1);
    $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    if (($thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len)) {
      var this$$3 = $thiz.sc_StringOps$$anon$1__f_$this$2;
      var i$2 = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
      var c$2 = this$$3.charCodeAt(i$2);
      var $x_2 = ((c$1 === 13) && (c$2 === 10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = ((1 + $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index) | 0);
    }
    if ((!$thiz.sc_StringOps$$anon$1__f_stripped$1)) {
      end = $thiz.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index;
    }
  }
  var this$6 = $thiz.sc_StringOps$$anon$1__f_$this$2;
  var endIndex = end;
  return this$6.substring(start, endIndex);
}
export { $p_sc_StringOps$$anon$1__advance__T as $p_sc_StringOps$$anon$1__advance__T };
/** @constructor */
function $c_sc_StringOps$$anon$1(\u03b4this$2, stripped$1) {
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = 0;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0;
  this.sc_StringOps$$anon$1__f_$this$2 = null;
  this.sc_StringOps$$anon$1__f_stripped$1 = false;
  this.sc_StringOps$$anon$1__f_$this$2 = \u03b4this$2;
  this.sc_StringOps$$anon$1__f_stripped$1 = stripped$1;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len = \u03b4this$2.length;
  this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index = 0;
}
export { $c_sc_StringOps$$anon$1 as $c_sc_StringOps$$anon$1 };
$c_sc_StringOps$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sc_StringOps$$anon$1.prototype.constructor = $c_sc_StringOps$$anon$1;
/** @constructor */
function $h_sc_StringOps$$anon$1() {
}
export { $h_sc_StringOps$$anon$1 as $h_sc_StringOps$$anon$1 };
$h_sc_StringOps$$anon$1.prototype = $c_sc_StringOps$$anon$1.prototype;
$c_sc_StringOps$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index < this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len);
});
$c_sc_StringOps$$anon$1.prototype.next__T = (function() {
  return ((this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$index >= this.sc_StringOps$$anon$1__f_scala$collection$StringOps$$anon$$len) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O() : $p_sc_StringOps$$anon$1__advance__T(this));
});
$c_sc_StringOps$$anon$1.prototype.next__O = (function() {
  return this.next__T();
});
var $d_sc_StringOps$$anon$1 = new $TypeData().initClass($c_sc_StringOps$$anon$1, "scala.collection.StringOps$$anon$1", ({
  sc_StringOps$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_StringOps$$anon$1 as $d_sc_StringOps$$anon$1 };
/** @constructor */
function $c_sc_View$DropRightIterator(underlying, maxlen) {
  this.sc_View$DropRightIterator__f_underlying = null;
  this.sc_View$DropRightIterator__f_maxlen = 0;
  this.sc_View$DropRightIterator__f_len = 0;
  this.sc_View$DropRightIterator__f_pos = 0;
  this.sc_View$DropRightIterator__f_buf = null;
  this.sc_View$DropRightIterator__f_underlying = underlying;
  this.sc_View$DropRightIterator__f_maxlen = maxlen;
  this.sc_View$DropRightIterator__f_len = (-1);
  this.sc_View$DropRightIterator__f_pos = 0;
}
export { $c_sc_View$DropRightIterator as $c_sc_View$DropRightIterator };
$c_sc_View$DropRightIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_View$DropRightIterator.prototype.constructor = $c_sc_View$DropRightIterator;
/** @constructor */
function $h_sc_View$DropRightIterator() {
}
export { $h_sc_View$DropRightIterator as $h_sc_View$DropRightIterator };
$h_sc_View$DropRightIterator.prototype = $c_sc_View$DropRightIterator.prototype;
$c_sc_View$DropRightIterator.prototype.init__V = (function() {
  if ((this.sc_View$DropRightIterator__f_buf === null)) {
    var x = this.sc_View$DropRightIterator__f_maxlen;
    this.sc_View$DropRightIterator__f_buf = $ct_scm_ArrayBuffer__I__(new $c_scm_ArrayBuffer(), ((x < 256) ? x : 256));
    while (((this.sc_View$DropRightIterator__f_pos < this.sc_View$DropRightIterator__f_maxlen) && this.sc_View$DropRightIterator__f_underlying.hasNext__Z())) {
      this.sc_View$DropRightIterator__f_buf.addOne__O__scm_ArrayBuffer(this.sc_View$DropRightIterator__f_underlying.next__O());
      this.sc_View$DropRightIterator__f_pos = ((1 + this.sc_View$DropRightIterator__f_pos) | 0);
    }
    if ((!this.sc_View$DropRightIterator__f_underlying.hasNext__Z())) {
      this.sc_View$DropRightIterator__f_len = 0;
    }
    this.sc_View$DropRightIterator__f_pos = 0;
  }
});
$c_sc_View$DropRightIterator.prototype.knownSize__I = (function() {
  return this.sc_View$DropRightIterator__f_len;
});
$c_sc_View$DropRightIterator.prototype.hasNext__Z = (function() {
  this.init__V();
  return (this.sc_View$DropRightIterator__f_len !== 0);
});
$c_sc_View$DropRightIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  } else {
    var x = this.sc_View$DropRightIterator__f_buf.apply__I__O(this.sc_View$DropRightIterator__f_pos);
    if ((this.sc_View$DropRightIterator__f_len === (-1))) {
      this.sc_View$DropRightIterator__f_buf.update__I__O__V(this.sc_View$DropRightIterator__f_pos, this.sc_View$DropRightIterator__f_underlying.next__O());
      if ((!this.sc_View$DropRightIterator__f_underlying.hasNext__Z())) {
        this.sc_View$DropRightIterator__f_len = 0;
      }
    } else {
      this.sc_View$DropRightIterator__f_len = (((-1) + this.sc_View$DropRightIterator__f_len) | 0);
    }
    this.sc_View$DropRightIterator__f_pos = ((1 + this.sc_View$DropRightIterator__f_pos) | 0);
    if ((this.sc_View$DropRightIterator__f_pos === this.sc_View$DropRightIterator__f_maxlen)) {
      this.sc_View$DropRightIterator__f_pos = 0;
    }
    return x;
  }
});
var $d_sc_View$DropRightIterator = new $TypeData().initClass($c_sc_View$DropRightIterator, "scala.collection.View$DropRightIterator", ({
  sc_View$DropRightIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_View$DropRightIterator as $d_sc_View$DropRightIterator };
/** @constructor */
function $c_sc_View$Updated$$anon$4(outer) {
  this.sc_View$Updated$$anon$4__f_it = null;
  this.sc_View$Updated$$anon$4__f_i = 0;
  this.sc_View$Updated$$anon$4__f_$outer = null;
  this.sc_View$Updated$$anon$4__f_$outer = outer;
  this.sc_View$Updated$$anon$4__f_it = outer.sc_View$Updated__f_scala$collection$View$Updated$$underlying.iterator__sc_Iterator();
  this.sc_View$Updated$$anon$4__f_i = 0;
}
export { $c_sc_View$Updated$$anon$4 as $c_sc_View$Updated$$anon$4 };
$c_sc_View$Updated$$anon$4.prototype = new $h_sc_AbstractIterator();
$c_sc_View$Updated$$anon$4.prototype.constructor = $c_sc_View$Updated$$anon$4;
/** @constructor */
function $h_sc_View$Updated$$anon$4() {
}
export { $h_sc_View$Updated$$anon$4 as $h_sc_View$Updated$$anon$4 };
$h_sc_View$Updated$$anon$4.prototype = $c_sc_View$Updated$$anon$4.prototype;
$c_sc_View$Updated$$anon$4.prototype.next__O = (function() {
  var value = ((this.sc_View$Updated$$anon$4__f_i === this.sc_View$Updated$$anon$4__f_$outer.sc_View$Updated__f_scala$collection$View$Updated$$index) ? (this.sc_View$Updated$$anon$4__f_it.next__O(), this.sc_View$Updated$$anon$4__f_$outer.sc_View$Updated__f_scala$collection$View$Updated$$elem) : this.sc_View$Updated$$anon$4__f_it.next__O());
  this.sc_View$Updated$$anon$4__f_i = ((1 + this.sc_View$Updated$$anon$4__f_i) | 0);
  return value;
});
$c_sc_View$Updated$$anon$4.prototype.hasNext__Z = (function() {
  if (this.sc_View$Updated$$anon$4__f_it.hasNext__Z()) {
    return true;
  } else if ((this.sc_View$Updated$$anon$4__f_$outer.sc_View$Updated__f_scala$collection$View$Updated$$index >= this.sc_View$Updated$$anon$4__f_i)) {
    var this$1 = this.sc_View$Updated$$anon$4__f_$outer.sc_View$Updated__f_scala$collection$View$Updated$$index;
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + this$1));
  } else {
    return false;
  }
});
var $d_sc_View$Updated$$anon$4 = new $TypeData().initClass($c_sc_View$Updated$$anon$4, "scala.collection.View$Updated$$anon$4", ({
  sc_View$Updated$$anon$4: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sc_View$Updated$$anon$4 as $d_sc_View$Updated$$anon$4 };
function $p_sci_ChampBaseIterator__initNodes__V($thiz) {
  if (($thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths === null)) {
    $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths = new $ac_I(($m_sci_Node$().sci_Node$__f_MaxDepth << 1));
    $thiz.sci_ChampBaseIterator__f_nodes = new ($d_sci_Node.getArrayOf().constr)($m_sci_Node$().sci_Node$__f_MaxDepth);
  }
}
export { $p_sci_ChampBaseIterator__initNodes__V as $p_sci_ChampBaseIterator__initNodes__V };
function $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = node.payloadArity__I();
}
export { $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V as $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V };
function $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, node) {
  $p_sci_ChampBaseIterator__initNodes__V($thiz);
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0);
  var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
  var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
  $thiz.sci_ChampBaseIterator__f_nodes.u[$thiz.sci_ChampBaseIterator__f_currentStackLevel] = node;
  $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.u[cursorIndex] = 0;
  $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.u[lengthIndex] = node.nodeArity__I();
}
export { $p_sci_ChampBaseIterator__pushNode__sci_Node__V as $p_sci_ChampBaseIterator__pushNode__sci_Node__V };
function $p_sci_ChampBaseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseIterator__f_currentStackLevel) | 0);
}
export { $p_sci_ChampBaseIterator__popNode__V as $p_sci_ChampBaseIterator__popNode__V };
function $p_sci_ChampBaseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseIterator__f_currentStackLevel >= 0)) {
    var cursorIndex = ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1);
    var lengthIndex = ((1 + ($thiz.sci_ChampBaseIterator__f_currentStackLevel << 1)) | 0);
    var nodeCursor = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.u[cursorIndex];
    var nodeLength = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths.u[lengthIndex];
    if ((nodeCursor < nodeLength)) {
      var ev$1 = $thiz.sci_ChampBaseIterator__f_nodeCursorsAndLengths;
      ev$1.u[cursorIndex] = ((1 + ev$1.u[cursorIndex]) | 0);
      var nextNode = $thiz.sci_ChampBaseIterator__f_nodes.u[$thiz.sci_ChampBaseIterator__f_currentStackLevel].getNode__I__sci_Node(nodeCursor);
      if (nextNode.hasNodes__Z()) {
        $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, nextNode);
      }
      if (nextNode.hasPayload__Z()) {
        $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, nextNode);
        return true;
      }
    } else {
      $p_sci_ChampBaseIterator__popNode__V($thiz);
    }
  }
  return false;
}
export { $p_sci_ChampBaseIterator__searchNextValueNode__Z as $p_sci_ChampBaseIterator__searchNextValueNode__Z };
function $ct_sci_ChampBaseIterator__($thiz) {
  $thiz.sci_ChampBaseIterator__f_currentValueCursor = 0;
  $thiz.sci_ChampBaseIterator__f_currentValueLength = 0;
  $thiz.sci_ChampBaseIterator__f_currentStackLevel = (-1);
  return $thiz;
}
export { $ct_sci_ChampBaseIterator__ as $ct_sci_ChampBaseIterator__ };
function $ct_sci_ChampBaseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseIterator__($thiz);
  if (rootNode.hasNodes__Z()) {
    $p_sci_ChampBaseIterator__pushNode__sci_Node__V($thiz, rootNode);
  }
  if (rootNode.hasPayload__Z()) {
    $p_sci_ChampBaseIterator__setupPayloadNode__sci_Node__V($thiz, rootNode);
  }
  return $thiz;
}
export { $ct_sci_ChampBaseIterator__sci_Node__ as $ct_sci_ChampBaseIterator__sci_Node__ };
/** @constructor */
function $c_sci_ChampBaseIterator() {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
}
export { $c_sci_ChampBaseIterator as $c_sci_ChampBaseIterator };
$c_sci_ChampBaseIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_ChampBaseIterator.prototype.constructor = $c_sci_ChampBaseIterator;
/** @constructor */
function $h_sci_ChampBaseIterator() {
}
export { $h_sci_ChampBaseIterator as $h_sci_ChampBaseIterator };
$h_sci_ChampBaseIterator.prototype = $c_sci_ChampBaseIterator.prototype;
$c_sci_ChampBaseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseIterator__f_currentValueCursor < this.sci_ChampBaseIterator__f_currentValueLength) || $p_sci_ChampBaseIterator__searchNextValueNode__Z(this));
});
function $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueNode = node;
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + node.payloadArity__I()) | 0);
}
export { $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V as $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V };
function $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, node) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = ((1 + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0);
  $thiz.sci_ChampBaseReverseIterator__f_nodeStack.u[$thiz.sci_ChampBaseReverseIterator__f_currentStackLevel] = node;
  $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.u[$thiz.sci_ChampBaseReverseIterator__f_currentStackLevel] = (((-1) + node.nodeArity__I()) | 0);
}
export { $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V as $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V };
function $p_sci_ChampBaseReverseIterator__popNode__V($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (((-1) + $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel) | 0);
}
export { $p_sci_ChampBaseReverseIterator__popNode__V as $p_sci_ChampBaseReverseIterator__popNode__V };
function $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz) {
  while (($thiz.sci_ChampBaseReverseIterator__f_currentStackLevel >= 0)) {
    var nodeCursor = $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.u[$thiz.sci_ChampBaseReverseIterator__f_currentStackLevel];
    $thiz.sci_ChampBaseReverseIterator__f_nodeIndex.u[$thiz.sci_ChampBaseReverseIterator__f_currentStackLevel] = (((-1) + nodeCursor) | 0);
    if ((nodeCursor >= 0)) {
      var nextNode = $thiz.sci_ChampBaseReverseIterator__f_nodeStack.u[$thiz.sci_ChampBaseReverseIterator__f_currentStackLevel].getNode__I__sci_Node(nodeCursor);
      $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, nextNode);
    } else {
      var currNode = $thiz.sci_ChampBaseReverseIterator__f_nodeStack.u[$thiz.sci_ChampBaseReverseIterator__f_currentStackLevel];
      $p_sci_ChampBaseReverseIterator__popNode__V($thiz);
      if (currNode.hasPayload__Z()) {
        $p_sci_ChampBaseReverseIterator__setupPayloadNode__sci_Node__V($thiz, currNode);
        return true;
      }
    }
  }
  return false;
}
export { $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z as $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z };
function $ct_sci_ChampBaseReverseIterator__($thiz) {
  $thiz.sci_ChampBaseReverseIterator__f_currentValueCursor = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_currentStackLevel = (-1);
  $thiz.sci_ChampBaseReverseIterator__f_nodeIndex = new $ac_I(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  $thiz.sci_ChampBaseReverseIterator__f_nodeStack = new ($d_sci_Node.getArrayOf().constr)(((1 + $m_sci_Node$().sci_Node$__f_MaxDepth) | 0));
  return $thiz;
}
export { $ct_sci_ChampBaseReverseIterator__ as $ct_sci_ChampBaseReverseIterator__ };
function $ct_sci_ChampBaseReverseIterator__sci_Node__($thiz, rootNode) {
  $ct_sci_ChampBaseReverseIterator__($thiz);
  $p_sci_ChampBaseReverseIterator__pushNode__sci_Node__V($thiz, rootNode);
  $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z($thiz);
  return $thiz;
}
export { $ct_sci_ChampBaseReverseIterator__sci_Node__ as $ct_sci_ChampBaseReverseIterator__sci_Node__ };
/** @constructor */
function $c_sci_ChampBaseReverseIterator() {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
}
export { $c_sci_ChampBaseReverseIterator as $c_sci_ChampBaseReverseIterator };
$c_sci_ChampBaseReverseIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_ChampBaseReverseIterator.prototype.constructor = $c_sci_ChampBaseReverseIterator;
/** @constructor */
function $h_sci_ChampBaseReverseIterator() {
}
export { $h_sci_ChampBaseReverseIterator as $h_sci_ChampBaseReverseIterator };
$h_sci_ChampBaseReverseIterator.prototype = $c_sci_ChampBaseReverseIterator.prototype;
$c_sci_ChampBaseReverseIterator.prototype.hasNext__Z = (function() {
  return ((this.sci_ChampBaseReverseIterator__f_currentValueCursor >= 0) || $p_sci_ChampBaseReverseIterator__searchNextValueNode__Z(this));
});
function $p_sci_HashMapBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashMapBuilder__f_aliased !== null);
}
export { $p_sci_HashMapBuilder__isAliased__Z as $p_sci_HashMapBuilder__isAliased__Z };
function $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  if ((ix > as.u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  var result = new $ac_I(((1 + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  result.u[ix] = elem;
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  as.copyTo(ix, result, destPos, length);
  return result;
}
export { $p_sci_HashMapBuilder__insertElement__AI__I__I__AI as $p_sci_HashMapBuilder__insertElement__AI__I__I__AI };
function $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V($thiz, bm, bitpos, key, originalHash, keyHash, value) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  var idx = (dataIx << 1);
  var src = bm.sci_BitmapIndexedMapNode__f_content;
  var dst = new $ac_O(((2 + src.u.length) | 0));
  src.copyTo(0, dst, 0, idx);
  dst.u[idx] = key;
  dst.u[((1 + idx) | 0)] = value;
  var destPos = ((2 + idx) | 0);
  var length = ((src.u.length - idx) | 0);
  src.copyTo(idx, dst, destPos, length);
  var dstHashes = $p_sci_HashMapBuilder__insertElement__AI__I__I__AI($thiz, bm.sci_BitmapIndexedMapNode__f_originalHashes, dataIx, originalHash);
  bm.sci_BitmapIndexedMapNode__f_dataMap = (bm.sci_BitmapIndexedMapNode__f_dataMap | bitpos);
  bm.sci_BitmapIndexedMapNode__f_content = dst;
  bm.sci_BitmapIndexedMapNode__f_originalHashes = dstHashes;
  bm.sci_BitmapIndexedMapNode__f_size = ((1 + bm.sci_BitmapIndexedMapNode__f_size) | 0);
  bm.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((bm.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + keyHash) | 0);
}
export { $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V as $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V };
function $p_sci_HashMapBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashMapBuilder__isAliased__Z($thiz)) {
    $p_sci_HashMapBuilder__copyElems__V($thiz);
  }
  $thiz.sci_HashMapBuilder__f_aliased = null;
}
export { $p_sci_HashMapBuilder__ensureUnaliased__V as $p_sci_HashMapBuilder__ensureUnaliased__V };
function $p_sci_HashMapBuilder__copyElems__V($thiz) {
  $thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = $thiz.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode.copy__sci_BitmapIndexedMapNode();
}
export { $p_sci_HashMapBuilder__copyElems__V as $p_sci_HashMapBuilder__copyElems__V };
/** @constructor */
function $c_sci_HashMapBuilder() {
  this.sci_HashMapBuilder__f_aliased = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = null;
  this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode = new $c_sci_BitmapIndexedMapNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0);
}
export { $c_sci_HashMapBuilder as $c_sci_HashMapBuilder };
$c_sci_HashMapBuilder.prototype = new $h_O();
$c_sci_HashMapBuilder.prototype.constructor = $c_sci_HashMapBuilder;
/** @constructor */
function $h_sci_HashMapBuilder() {
}
export { $h_sci_HashMapBuilder as $h_sci_HashMapBuilder };
$h_sci_HashMapBuilder.prototype = $c_sci_HashMapBuilder.prototype;
$c_sci_HashMapBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_HashMapBuilder.prototype.update__sci_MapNode__O__O__I__I__I__V = (function(mapNode, key, value, originalHash, keyHash, shift) {
  if ((mapNode instanceof $c_sci_BitmapIndexedMapNode)) {
    var mask = $m_sci_Node$().maskFrom__I__I__I(keyHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if (((mapNode.sci_BitmapIndexedMapNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I(mapNode.sci_BitmapIndexedMapNode__f_dataMap, mask, bitpos);
      var key0 = mapNode.getKey__I__O(index);
      var key0UnimprovedHash = mapNode.getHash__I__I(index);
      if (((key0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key0, key))) {
        mapNode.sci_BitmapIndexedMapNode__f_content.u[((1 + (index << 1)) | 0)] = value;
      } else {
        var value0 = mapNode.getValue__I__O(index);
        var key0Hash = $m_sc_Hashing$().improve__I__I(key0UnimprovedHash);
        var subNodeNew = mapNode.mergeTwoKeyValPairs__O__O__I__I__O__O__I__I__I__sci_MapNode(key0, value0, key0UnimprovedHash, key0Hash, key, value, originalHash, keyHash, ((5 + shift) | 0));
        mapNode.migrateFromInlineToNodeInPlace__I__I__sci_MapNode__sci_BitmapIndexedMapNode(bitpos, key0Hash, subNodeNew);
      }
    } else if (((mapNode.sci_BitmapIndexedMapNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(mapNode.sci_BitmapIndexedMapNode__f_nodeMap, mask, bitpos);
      var subNode = mapNode.getNode__I__sci_MapNode(index$2);
      var beforeSize = subNode.size__I();
      var beforeHash = subNode.cachedJavaKeySetHashCode__I();
      this.update__sci_MapNode__O__O__I__I__I__V(subNode, key, value, originalHash, keyHash, ((5 + shift) | 0));
      mapNode.sci_BitmapIndexedMapNode__f_size = ((mapNode.sci_BitmapIndexedMapNode__f_size + ((subNode.size__I() - beforeSize) | 0)) | 0);
      mapNode.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode = ((mapNode.sci_BitmapIndexedMapNode__f_cachedJavaKeySetHashCode + ((subNode.cachedJavaKeySetHashCode__I() - beforeHash) | 0)) | 0);
    } else {
      $p_sci_HashMapBuilder__insertValue__sci_BitmapIndexedMapNode__I__O__I__I__O__V(this, mapNode, bitpos, key, originalHash, keyHash, value);
    }
  } else if ((mapNode instanceof $c_sci_HashCollisionMapNode)) {
    var index$3 = mapNode.indexOf__O__I(key);
    if ((index$3 < 0)) {
      mapNode.sci_HashCollisionMapNode__f_content = mapNode.sci_HashCollisionMapNode__f_content.appended__O__sci_Vector($ct_T2__O__O__(new $c_T2(), key, value));
    } else {
      mapNode.sci_HashCollisionMapNode__f_content = mapNode.sci_HashCollisionMapNode__f_content.updated__I__O__sci_Vector(index$3, $ct_T2__O__O__(new $c_T2(), key, value));
    }
  } else {
    throw new $c_s_MatchError(mapNode);
  }
});
$c_sci_HashMapBuilder.prototype.result__sci_HashMap = (function() {
  if ((this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode.sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap;
  } else if ((this.sci_HashMapBuilder__f_aliased !== null)) {
    return this.sci_HashMapBuilder__f_aliased;
  } else {
    this.sci_HashMapBuilder__f_aliased = new $c_sci_HashMap(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode);
    return this.sci_HashMapBuilder__f_aliased;
  }
});
$c_sci_HashMapBuilder.prototype.addOne__T2__sci_HashMapBuilder = (function(elem) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var x = elem._1__O();
  var h = $m_sr_Statics$().anyHash__O__I(x);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, elem._1__O(), elem._2__O(), h, im, 0);
  return this;
});
$c_sci_HashMapBuilder.prototype.addOne__O__O__sci_HashMapBuilder = (function(key, value) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, key, value, originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
  return this;
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__sci_HashMapBuilder = (function(xs) {
  $p_sci_HashMapBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashMap)) {
    new $c_sci_HashMapBuilder$$anon$1(this, xs);
  } else if ((xs instanceof $c_scm_HashMap)) {
    var iter = xs.nodeIterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var next = iter.next__O();
      var improvedHash = next.scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var hash = $m_sc_Hashing$().improve__I__I(originalHash);
      this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, next.scm_HashMap$Node__f__key, next.scm_HashMap$Node__f__value, originalHash, hash, 0);
    }
  } else if ((xs instanceof $c_scm_LinkedHashMap)) {
    var iter$2 = xs.entryIterator__sc_Iterator();
    while (iter$2.hasNext__Z()) {
      var next$2 = iter$2.next__O();
      var improvedHash$1 = next$2.scm_LinkedHashMap$LinkedEntry__f_hash;
      var originalHash$2 = (improvedHash$1 ^ ((improvedHash$1 >>> 16) | 0));
      var hash$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
      this.update__sci_MapNode__O__O__I__I__I__V(this.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, next$2.scm_LinkedHashMap$LinkedEntry__f_key, next$2.scm_LinkedHashMap$LinkedEntry__f_value, originalHash$2, hash$2, 0);
    }
  } else if ($is_sci_Map(xs)) {
    xs.foreachEntry__F2__V(new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((key$2$2, value$2$2) => this.addOne__O__O__sci_HashMapBuilder(key$2$2, value$2$2))));
  } else {
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      this.addOne__T2__sci_HashMapBuilder(it.next__O());
    }
  }
  return this;
});
$c_sci_HashMapBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_HashMapBuilder(elems);
});
$c_sci_HashMapBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__sci_HashMapBuilder(elem);
});
$c_sci_HashMapBuilder.prototype.result__O = (function() {
  return this.result__sci_HashMap();
});
var $d_sci_HashMapBuilder = new $TypeData().initClass($c_sci_HashMapBuilder, "scala.collection.immutable.HashMapBuilder", ({
  sci_HashMapBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_sci_HashMapBuilder as $d_sci_HashMapBuilder };
function $p_sci_HashSetBuilder__isAliased__Z($thiz) {
  return ($thiz.sci_HashSetBuilder__f_aliased !== null);
}
export { $p_sci_HashSetBuilder__isAliased__Z as $p_sci_HashSetBuilder__isAliased__Z };
function $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, as, ix, elem) {
  if ((ix < 0)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  if ((ix > as.u.length)) {
    throw $ct_jl_ArrayIndexOutOfBoundsException__(new $c_jl_ArrayIndexOutOfBoundsException());
  }
  var result = new $ac_I(((1 + as.u.length) | 0));
  as.copyTo(0, result, 0, ix);
  result.u[ix] = elem;
  var destPos = ((1 + ix) | 0);
  var length = ((as.u.length - ix) | 0);
  as.copyTo(ix, result, destPos, length);
  return result;
}
export { $p_sci_HashSetBuilder__insertElement__AI__I__I__AI as $p_sci_HashSetBuilder__insertElement__AI__I__I__AI };
function $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V($thiz, bm, bitpos, key, originalHash, keyHash) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  var src = bm.sci_BitmapIndexedSetNode__f_content;
  var dst = new $ac_O(((1 + src.u.length) | 0));
  src.copyTo(0, dst, 0, dataIx);
  dst.u[dataIx] = key;
  var destPos = ((1 + dataIx) | 0);
  var length = ((src.u.length - dataIx) | 0);
  src.copyTo(dataIx, dst, destPos, length);
  var dstHashes = $p_sci_HashSetBuilder__insertElement__AI__I__I__AI($thiz, bm.sci_BitmapIndexedSetNode__f_originalHashes, dataIx, originalHash);
  bm.sci_BitmapIndexedSetNode__f_dataMap = (bm.sci_BitmapIndexedSetNode__f_dataMap | bitpos);
  bm.sci_BitmapIndexedSetNode__f_content = dst;
  bm.sci_BitmapIndexedSetNode__f_originalHashes = dstHashes;
  bm.sci_BitmapIndexedSetNode__f_size = ((1 + bm.sci_BitmapIndexedSetNode__f_size) | 0);
  bm.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((bm.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + keyHash) | 0);
}
export { $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V as $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V };
function $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V($thiz, bm, bitpos, elem) {
  var dataIx = bm.dataIndex__I__I(bitpos);
  bm.sci_BitmapIndexedSetNode__f_content.u[dataIx] = elem;
}
export { $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V as $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V };
function $p_sci_HashSetBuilder__ensureUnaliased__V($thiz) {
  if ($p_sci_HashSetBuilder__isAliased__Z($thiz)) {
    $p_sci_HashSetBuilder__copyElems__V($thiz);
  }
  $thiz.sci_HashSetBuilder__f_aliased = null;
}
export { $p_sci_HashSetBuilder__ensureUnaliased__V as $p_sci_HashSetBuilder__ensureUnaliased__V };
function $p_sci_HashSetBuilder__copyElems__V($thiz) {
  $thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = $thiz.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode.copy__sci_BitmapIndexedSetNode();
}
export { $p_sci_HashSetBuilder__copyElems__V as $p_sci_HashSetBuilder__copyElems__V };
/** @constructor */
function $c_sci_HashSetBuilder() {
  this.sci_HashSetBuilder__f_aliased = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = null;
  this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode = new $c_sci_BitmapIndexedSetNode(0, 0, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyObjectArray, $m_s_Array$EmptyArrays$().s_Array$EmptyArrays$__f_emptyIntArray, 0, 0);
}
export { $c_sci_HashSetBuilder as $c_sci_HashSetBuilder };
$c_sci_HashSetBuilder.prototype = new $h_O();
$c_sci_HashSetBuilder.prototype.constructor = $c_sci_HashSetBuilder;
/** @constructor */
function $h_sci_HashSetBuilder() {
}
export { $h_sci_HashSetBuilder as $h_sci_HashSetBuilder };
$h_sci_HashSetBuilder.prototype = $c_sci_HashSetBuilder.prototype;
$c_sci_HashSetBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_HashSetBuilder.prototype.update__sci_SetNode__O__I__I__I__V = (function(setNode, element, originalHash, elementHash, shift) {
  if ((setNode instanceof $c_sci_BitmapIndexedSetNode)) {
    var mask = $m_sci_Node$().maskFrom__I__I__I(elementHash, shift);
    var bitpos = $m_sci_Node$().bitposFrom__I__I(mask);
    if (((setNode.sci_BitmapIndexedSetNode__f_dataMap & bitpos) !== 0)) {
      var index = $m_sci_Node$().indexFrom__I__I__I__I(setNode.sci_BitmapIndexedSetNode__f_dataMap, mask, bitpos);
      var element0 = setNode.getPayload__I__O(index);
      var element0UnimprovedHash = setNode.getHash__I__I(index);
      if (((element0UnimprovedHash === originalHash) && $m_sr_BoxesRunTime$().equals__O__O__Z(element0, element))) {
        $p_sci_HashSetBuilder__setValue__sci_BitmapIndexedSetNode__I__O__V(this, setNode, bitpos, element0);
      } else {
        var element0Hash = $m_sc_Hashing$().improve__I__I(element0UnimprovedHash);
        var subNodeNew = setNode.mergeTwoKeyValPairs__O__I__I__O__I__I__I__sci_SetNode(element0, element0UnimprovedHash, element0Hash, element, originalHash, elementHash, ((5 + shift) | 0));
        setNode.migrateFromInlineToNodeInPlace__I__I__sci_SetNode__sci_BitmapIndexedSetNode(bitpos, element0Hash, subNodeNew);
      }
    } else if (((setNode.sci_BitmapIndexedSetNode__f_nodeMap & bitpos) !== 0)) {
      var index$2 = $m_sci_Node$().indexFrom__I__I__I__I(setNode.sci_BitmapIndexedSetNode__f_nodeMap, mask, bitpos);
      var subNode = setNode.getNode__I__sci_SetNode(index$2);
      var beforeSize = subNode.size__I();
      var beforeHashCode = subNode.cachedJavaKeySetHashCode__I();
      this.update__sci_SetNode__O__I__I__I__V(subNode, element, originalHash, elementHash, ((5 + shift) | 0));
      setNode.sci_BitmapIndexedSetNode__f_size = ((setNode.sci_BitmapIndexedSetNode__f_size + ((subNode.size__I() - beforeSize) | 0)) | 0);
      setNode.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode = ((setNode.sci_BitmapIndexedSetNode__f_cachedJavaKeySetHashCode + ((subNode.cachedJavaKeySetHashCode__I() - beforeHashCode) | 0)) | 0);
    } else {
      $p_sci_HashSetBuilder__insertValue__sci_BitmapIndexedSetNode__I__O__I__I__V(this, setNode, bitpos, element, originalHash, elementHash);
    }
  } else if ((setNode instanceof $c_sci_HashCollisionSetNode)) {
    var this$1 = setNode.sci_HashCollisionSetNode__f_content;
    var index$3 = $f_sc_SeqOps__indexOf__O__I__I(this$1, element, 0);
    if ((index$3 < 0)) {
      setNode.sci_HashCollisionSetNode__f_content = setNode.sci_HashCollisionSetNode__f_content.appended__O__sci_Vector(element);
    } else {
      setNode.sci_HashCollisionSetNode__f_content = setNode.sci_HashCollisionSetNode__f_content.updated__I__O__sci_Vector(index$3, element);
    }
  } else {
    throw new $c_s_MatchError(setNode);
  }
});
$c_sci_HashSetBuilder.prototype.result__sci_HashSet = (function() {
  if ((this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode.sci_BitmapIndexedSetNode__f_size === 0)) {
    var this$1 = $m_sci_HashSet$();
    return this$1.sci_HashSet$__f_EmptySet;
  } else if ((this.sci_HashSetBuilder__f_aliased !== null)) {
    return this.sci_HashSetBuilder__f_aliased;
  } else {
    this.sci_HashSetBuilder__f_aliased = new $c_sci_HashSet(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode);
    return this.sci_HashSetBuilder__f_aliased;
  }
});
$c_sci_HashSetBuilder.prototype.addOne__O__sci_HashSetBuilder = (function(elem) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  var h = $m_sr_Statics$().anyHash__O__I(elem);
  var im = $m_sc_Hashing$().improve__I__I(h);
  this.update__sci_SetNode__O__I__I__I__V(this.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, elem, h, im, 0);
  return this;
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__sci_HashSetBuilder = (function(xs) {
  $p_sci_HashSetBuilder__ensureUnaliased__V(this);
  if ((xs instanceof $c_sci_HashSet)) {
    new $c_sci_HashSetBuilder$$anon$1(this, xs);
  } else {
    var it = xs.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      this.addOne__O__sci_HashSetBuilder(it.next__O());
    }
  }
  return this;
});
$c_sci_HashSetBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_HashSetBuilder(elems);
});
$c_sci_HashSetBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_HashSetBuilder(elem);
});
$c_sci_HashSetBuilder.prototype.result__O = (function() {
  return this.result__sci_HashSet();
});
var $d_sci_HashSetBuilder = new $TypeData().initClass($c_sci_HashSetBuilder, "scala.collection.immutable.HashSetBuilder", ({
  sci_HashSetBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_sci_HashSetBuilder as $d_sci_HashSetBuilder };
/** @constructor */
function $c_sci_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_Vector$());
}
export { $c_sci_IndexedSeq$ as $c_sci_IndexedSeq$ };
$c_sci_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_IndexedSeq$.prototype.constructor = $c_sci_IndexedSeq$;
/** @constructor */
function $h_sci_IndexedSeq$() {
}
export { $h_sci_IndexedSeq$ as $h_sci_IndexedSeq$ };
$h_sci_IndexedSeq$.prototype = $c_sci_IndexedSeq$.prototype;
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sci_IndexedSeq = (function(it) {
  return ($is_sci_IndexedSeq(it) ? it : $c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it));
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(source);
});
$c_sci_IndexedSeq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_IndexedSeq(it);
});
var $d_sci_IndexedSeq$ = new $TypeData().initClass($c_sci_IndexedSeq$, "scala.collection.immutable.IndexedSeq$", ({
  sci_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_IndexedSeq$ as $d_sci_IndexedSeq$ };
var $n_sci_IndexedSeq$;
function $m_sci_IndexedSeq$() {
  if ((!$n_sci_IndexedSeq$)) {
    $n_sci_IndexedSeq$ = new $c_sci_IndexedSeq$();
  }
  return $n_sci_IndexedSeq$;
}
export { $m_sci_IndexedSeq$ as $m_sci_IndexedSeq$ };
/** @constructor */
function $c_sci_LazyList$LazyBuilder() {
  this.sci_LazyList$LazyBuilder__f_next = null;
  this.sci_LazyList$LazyBuilder__f_list = null;
  this.clear__V();
}
export { $c_sci_LazyList$LazyBuilder as $c_sci_LazyList$LazyBuilder };
$c_sci_LazyList$LazyBuilder.prototype = new $h_O();
$c_sci_LazyList$LazyBuilder.prototype.constructor = $c_sci_LazyList$LazyBuilder;
/** @constructor */
function $h_sci_LazyList$LazyBuilder() {
}
export { $h_sci_LazyList$LazyBuilder as $h_sci_LazyList$LazyBuilder };
$h_sci_LazyList$LazyBuilder.prototype = $c_sci_LazyList$LazyBuilder.prototype;
$c_sci_LazyList$LazyBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_LazyList$LazyBuilder.prototype.clear__V = (function() {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  $m_sci_LazyList$();
  var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => deferred.eval__sci_LazyList()));
  this.sci_LazyList$LazyBuilder__f_list = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
  this.sci_LazyList$LazyBuilder__f_next = deferred;
});
$c_sci_LazyList$LazyBuilder.prototype.result__sci_LazyList = (function() {
  this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)));
  return this.sci_LazyList$LazyBuilder__f_list;
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__sci_LazyList$LazyBuilder = (function(elem) {
  var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
  this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    $m_sci_LazyList$();
    $m_sci_LazyList$();
    var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => deferred.eval__sci_LazyList()));
    var tl = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, tl);
  })));
  this.sci_LazyList$LazyBuilder__f_next = deferred;
  return this;
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder = (function(xs) {
  if ((xs.knownSize__I() !== 0)) {
    var deferred = new $c_sci_LazyList$LazyBuilder$DeferredState();
    this.sci_LazyList$LazyBuilder__f_next.init__F0__V(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadPrependIterator__sc_Iterator__F0__sci_LazyList(xs.iterator__sc_Iterator(), new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => deferred.eval__sci_LazyList()))))));
    this.sci_LazyList$LazyBuilder__f_next = deferred;
  }
  return this;
});
$c_sci_LazyList$LazyBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_LazyList$LazyBuilder(elems);
});
$c_sci_LazyList$LazyBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_LazyList$LazyBuilder(elem);
});
$c_sci_LazyList$LazyBuilder.prototype.result__O = (function() {
  return this.result__sci_LazyList();
});
var $d_sci_LazyList$LazyBuilder = new $TypeData().initClass($c_sci_LazyList$LazyBuilder, "scala.collection.immutable.LazyList$LazyBuilder", ({
  sci_LazyList$LazyBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_sci_LazyList$LazyBuilder as $d_sci_LazyList$LazyBuilder };
/** @constructor */
function $c_sci_LazyList$LazyIterator(lazyList) {
  this.sci_LazyList$LazyIterator__f_lazyList = null;
  this.sci_LazyList$LazyIterator__f_lazyList = lazyList;
}
export { $c_sci_LazyList$LazyIterator as $c_sci_LazyList$LazyIterator };
$c_sci_LazyList$LazyIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_LazyList$LazyIterator.prototype.constructor = $c_sci_LazyList$LazyIterator;
/** @constructor */
function $h_sci_LazyList$LazyIterator() {
}
export { $h_sci_LazyList$LazyIterator as $h_sci_LazyList$LazyIterator };
$h_sci_LazyList$LazyIterator.prototype = $c_sci_LazyList$LazyIterator.prototype;
$c_sci_LazyList$LazyIterator.prototype.hasNext__Z = (function() {
  var this$1 = this.sci_LazyList$LazyIterator__f_lazyList;
  return (!(this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
});
$c_sci_LazyList$LazyIterator.prototype.next__O = (function() {
  var this$1 = this.sci_LazyList$LazyIterator__f_lazyList;
  if ((this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  } else {
    var res = this.sci_LazyList$LazyIterator__f_lazyList.head__O();
    this.sci_LazyList$LazyIterator__f_lazyList = this.sci_LazyList$LazyIterator__f_lazyList.tail__sci_LazyList();
    return res;
  }
});
var $d_sci_LazyList$LazyIterator = new $TypeData().initClass($c_sci_LazyList$LazyIterator, "scala.collection.immutable.LazyList$LazyIterator", ({
  sci_LazyList$LazyIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_LazyList$LazyIterator as $d_sci_LazyList$LazyIterator };
/** @constructor */
function $c_sci_List$() {
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = null;
  this.sci_List$__f_partialNotApplied = null;
  $n_sci_List$ = this;
  this.sci_List$__f_scala$collection$immutable$List$$TupleOfNil = $ct_T2__O__O__(new $c_T2(), $m_sci_Nil$(), $m_sci_Nil$());
  this.sci_List$__f_partialNotApplied = new $c_sci_List$$anon$1();
}
export { $c_sci_List$ as $c_sci_List$ };
$c_sci_List$.prototype = new $h_O();
$c_sci_List$.prototype.constructor = $c_sci_List$;
/** @constructor */
function $h_sci_List$() {
}
export { $h_sci_List$ as $h_sci_List$ };
$h_sci_List$.prototype = $c_sci_List$.prototype;
$c_sci_List$.prototype.apply__sci_Seq__O = (function(elems) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
});
$c_sci_List$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ListBuffer();
});
$c_sci_List$.prototype.empty__O = (function() {
  return $m_sci_Nil$();
});
$c_sci_List$.prototype.from__sc_IterableOnce__O = (function(source) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(source);
});
var $d_sci_List$ = new $TypeData().initClass($c_sci_List$, "scala.collection.immutable.List$", ({
  sci_List$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_List$ as $d_sci_List$ };
var $n_sci_List$;
function $m_sci_List$() {
  if ((!$n_sci_List$)) {
    $n_sci_List$ = new $c_sci_List$();
  }
  return $n_sci_List$;
}
export { $m_sci_List$ as $m_sci_List$ };
function $p_sci_ListMapBuilder__insertValueAtKeyReturnFound__sci_ListMap__O__O__Z($thiz, m, key, value) {
  while (true) {
    var x1 = m;
    if ((x1 instanceof $c_sci_ListMap$Node)) {
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(x1.sci_ListMap$Node__f_key, key)) {
        x1.sci_ListMap$Node__f__value = value;
        return true;
      } else {
        m = x1.sci_ListMap$Node__f__init;
      }
    } else {
      return false;
    }
  }
}
export { $p_sci_ListMapBuilder__insertValueAtKeyReturnFound__sci_ListMap__O__O__Z as $p_sci_ListMapBuilder__insertValueAtKeyReturnFound__sci_ListMap__O__O__Z };
/** @constructor */
function $c_sci_ListMapBuilder() {
  this.sci_ListMapBuilder__f_isAliased = false;
  this.sci_ListMapBuilder__f_underlying = null;
  this.sci_ListMapBuilder__f_isAliased = false;
  this.sci_ListMapBuilder__f_underlying = $m_sci_ListMap$EmptyListMap$();
}
export { $c_sci_ListMapBuilder as $c_sci_ListMapBuilder };
$c_sci_ListMapBuilder.prototype = new $h_O();
$c_sci_ListMapBuilder.prototype.constructor = $c_sci_ListMapBuilder;
/** @constructor */
function $h_sci_ListMapBuilder() {
}
export { $h_sci_ListMapBuilder as $h_sci_ListMapBuilder };
$h_sci_ListMapBuilder.prototype = $c_sci_ListMapBuilder.prototype;
$c_sci_ListMapBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_ListMapBuilder.prototype.result__sci_ListMap = (function() {
  this.sci_ListMapBuilder__f_isAliased = true;
  return this.sci_ListMapBuilder__f_underlying;
});
$c_sci_ListMapBuilder.prototype.addOne__O__O__sci_ListMapBuilder = (function(key, value) {
  if (this.sci_ListMapBuilder__f_isAliased) {
    this.sci_ListMapBuilder__f_underlying = this.sci_ListMapBuilder__f_underlying.updated__O__O__sci_ListMap(key, value);
  } else if ((!$p_sci_ListMapBuilder__insertValueAtKeyReturnFound__sci_ListMap__O__O__Z(this, this.sci_ListMapBuilder__f_underlying, key, value))) {
    this.sci_ListMapBuilder__f_underlying = new $c_sci_ListMap$Node(key, value, this.sci_ListMapBuilder__f_underlying);
  }
  return this;
});
$c_sci_ListMapBuilder.prototype.addAll__sc_IterableOnce__sci_ListMapBuilder = (function(xs) {
  if (this.sci_ListMapBuilder__f_isAliased) {
    return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
  } else {
    var this$1 = this.sci_ListMapBuilder__f_underlying;
    if ((!this$1.isEmpty__Z())) {
      if ($is_sc_Map(xs)) {
        var iter = xs.iterator__sc_Iterator();
        var newUnderlying = this.sci_ListMapBuilder__f_underlying;
        while (iter.hasNext__Z()) {
          var next = iter.next__O();
          if ((!$p_sci_ListMapBuilder__insertValueAtKeyReturnFound__sci_ListMap__O__O__Z(this, this.sci_ListMapBuilder__f_underlying, next._1__O(), next._2__O()))) {
            newUnderlying = new $c_sci_ListMap$Node(next._1__O(), next._2__O(), newUnderlying);
          }
        }
        this.sci_ListMapBuilder__f_underlying = newUnderlying;
        return this;
      } else {
        return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
      }
    } else if ((xs instanceof $c_scm_LinkedHashMap)) {
      var firstEntry = xs.scm_LinkedHashMap__f_firstEntry;
      while ((firstEntry !== null)) {
        this.sci_ListMapBuilder__f_underlying = new $c_sci_ListMap$Node(firstEntry.scm_LinkedHashMap$LinkedEntry__f_key, firstEntry.scm_LinkedHashMap$LinkedEntry__f_value, this.sci_ListMapBuilder__f_underlying);
        firstEntry = firstEntry.scm_LinkedHashMap$LinkedEntry__f_later;
      }
      return this;
    } else if (($is_sc_Map(xs) || $is_sc_MapView(xs))) {
      var iter$2 = xs.iterator__sc_Iterator();
      while (iter$2.hasNext__Z()) {
        var x1$3 = iter$2.next__O();
        if ((x1$3 === null)) {
          throw new $c_s_MatchError(x1$3);
        }
        var k = x1$3._1__O();
        var v = x1$3._2__O();
        this.sci_ListMapBuilder__f_underlying = new $c_sci_ListMap$Node(k, v, this.sci_ListMapBuilder__f_underlying);
      }
      return this;
    } else {
      return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
    }
  }
});
$c_sci_ListMapBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_ListMapBuilder(elems);
});
$c_sci_ListMapBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__O__sci_ListMapBuilder(elem._1__O(), elem._2__O());
});
$c_sci_ListMapBuilder.prototype.result__O = (function() {
  return this.result__sci_ListMap();
});
var $d_sci_ListMapBuilder = new $TypeData().initClass($c_sci_ListMapBuilder, "scala.collection.immutable.ListMapBuilder", ({
  sci_ListMapBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_sci_ListMapBuilder as $d_sci_ListMapBuilder };
function $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__($thiz, outer) {
  $thiz.sci_Map$Map2$Map2Iterator__f_$outer = outer;
  $thiz.sci_Map$Map2$Map2Iterator__f_i = 0;
  return $thiz;
}
export { $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__ as $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__ };
/** @constructor */
function $c_sci_Map$Map2$Map2Iterator() {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
}
export { $c_sci_Map$Map2$Map2Iterator as $c_sci_Map$Map2$Map2Iterator };
$c_sci_Map$Map2$Map2Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map2$Map2Iterator.prototype.constructor = $c_sci_Map$Map2$Map2Iterator;
/** @constructor */
function $h_sci_Map$Map2$Map2Iterator() {
}
export { $h_sci_Map$Map2$Map2Iterator as $h_sci_Map$Map2$Map2Iterator };
$h_sci_Map$Map2$Map2Iterator.prototype = $c_sci_Map$Map2$Map2Iterator.prototype;
$c_sci_Map$Map2$Map2Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map2$Map2Iterator__f_i < 2);
});
$c_sci_Map$Map2$Map2Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map2$Map2Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
      break;
    }
    case 1: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2$Map2Iterator__f_$outer.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
      break;
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
    }
  }
  this.sci_Map$Map2$Map2Iterator__f_i = ((1 + this.sci_Map$Map2$Map2Iterator__f_i) | 0);
  return result;
});
$c_sci_Map$Map2$Map2Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map2$Map2Iterator__f_i = ((this.sci_Map$Map2$Map2Iterator__f_i + n) | 0);
  return this;
});
function $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__($thiz, outer) {
  $thiz.sci_Map$Map3$Map3Iterator__f_$outer = outer;
  $thiz.sci_Map$Map3$Map3Iterator__f_i = 0;
  return $thiz;
}
export { $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__ as $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__ };
/** @constructor */
function $c_sci_Map$Map3$Map3Iterator() {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
}
export { $c_sci_Map$Map3$Map3Iterator as $c_sci_Map$Map3$Map3Iterator };
$c_sci_Map$Map3$Map3Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map3$Map3Iterator.prototype.constructor = $c_sci_Map$Map3$Map3Iterator;
/** @constructor */
function $h_sci_Map$Map3$Map3Iterator() {
}
export { $h_sci_Map$Map3$Map3Iterator as $h_sci_Map$Map3$Map3Iterator };
$h_sci_Map$Map3$Map3Iterator.prototype = $c_sci_Map$Map3$Map3Iterator.prototype;
$c_sci_Map$Map3$Map3Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map3$Map3Iterator__f_i < 3);
});
$c_sci_Map$Map3$Map3Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map3$Map3Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
      break;
    }
    case 1: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
      break;
    }
    case 2: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3$Map3Iterator__f_$outer.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
      break;
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
    }
  }
  this.sci_Map$Map3$Map3Iterator__f_i = ((1 + this.sci_Map$Map3$Map3Iterator__f_i) | 0);
  return result;
});
$c_sci_Map$Map3$Map3Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map3$Map3Iterator__f_i = ((this.sci_Map$Map3$Map3Iterator__f_i + n) | 0);
  return this;
});
function $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__($thiz, outer) {
  $thiz.sci_Map$Map4$Map4Iterator__f_$outer = outer;
  $thiz.sci_Map$Map4$Map4Iterator__f_i = 0;
  return $thiz;
}
export { $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__ as $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__ };
/** @constructor */
function $c_sci_Map$Map4$Map4Iterator() {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
}
export { $c_sci_Map$Map4$Map4Iterator as $c_sci_Map$Map4$Map4Iterator };
$c_sci_Map$Map4$Map4Iterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Map$Map4$Map4Iterator.prototype.constructor = $c_sci_Map$Map4$Map4Iterator;
/** @constructor */
function $h_sci_Map$Map4$Map4Iterator() {
}
export { $h_sci_Map$Map4$Map4Iterator as $h_sci_Map$Map4$Map4Iterator };
$h_sci_Map$Map4$Map4Iterator.prototype = $c_sci_Map$Map4$Map4Iterator.prototype;
$c_sci_Map$Map4$Map4Iterator.prototype.hasNext__Z = (function() {
  return (this.sci_Map$Map4$Map4Iterator__f_i < 4);
});
$c_sci_Map$Map4$Map4Iterator.prototype.next__O = (function() {
  var x1 = this.sci_Map$Map4$Map4Iterator__f_i;
  switch (x1) {
    case 0: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
      break;
    }
    case 1: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
      break;
    }
    case 2: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
      break;
    }
    case 3: {
      var result = this.nextResult__O__O__O(this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4$Map4Iterator__f_$outer.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
      break;
    }
    default: {
      var result = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
    }
  }
  this.sci_Map$Map4$Map4Iterator__f_i = ((1 + this.sci_Map$Map4$Map4Iterator__f_i) | 0);
  return result;
});
$c_sci_Map$Map4$Map4Iterator.prototype.drop__I__sc_Iterator = (function(n) {
  this.sci_Map$Map4$Map4Iterator__f_i = ((this.sci_Map$Map4$Map4Iterator__f_i + n) | 0);
  return this;
});
/** @constructor */
function $c_sci_MapBuilderImpl() {
  this.sci_MapBuilderImpl__f_elems = null;
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false;
  this.sci_MapBuilderImpl__f_hashMapBuilder = null;
  this.sci_MapBuilderImpl__f_elems = $m_sci_Map$EmptyMap$();
  this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = false;
}
export { $c_sci_MapBuilderImpl as $c_sci_MapBuilderImpl };
$c_sci_MapBuilderImpl.prototype = new $h_O();
$c_sci_MapBuilderImpl.prototype.constructor = $c_sci_MapBuilderImpl;
/** @constructor */
function $h_sci_MapBuilderImpl() {
}
export { $h_sci_MapBuilderImpl as $h_sci_MapBuilderImpl };
$h_sci_MapBuilderImpl.prototype = $c_sci_MapBuilderImpl.prototype;
$c_sci_MapBuilderImpl.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_MapBuilderImpl.prototype.result__sci_Map = (function() {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? this.sci_MapBuilderImpl__f_hashMapBuilder.result__sci_HashMap() : this.sci_MapBuilderImpl__f_elems);
});
$c_sci_MapBuilderImpl.prototype.addOne__O__O__sci_MapBuilderImpl = (function(key, value) {
  if (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder) {
    this.sci_MapBuilderImpl__f_hashMapBuilder.addOne__O__O__sci_HashMapBuilder(key, value);
  } else if ((this.sci_MapBuilderImpl__f_elems.size__I() < 4)) {
    this.sci_MapBuilderImpl__f_elems = this.sci_MapBuilderImpl__f_elems.updated__O__O__sci_MapOps(key, value);
  } else if (this.sci_MapBuilderImpl__f_elems.contains__O__Z(key)) {
    this.sci_MapBuilderImpl__f_elems = this.sci_MapBuilderImpl__f_elems.updated__O__O__sci_MapOps(key, value);
  } else {
    this.sci_MapBuilderImpl__f_switchedToHashMapBuilder = true;
    if ((this.sci_MapBuilderImpl__f_hashMapBuilder === null)) {
      this.sci_MapBuilderImpl__f_hashMapBuilder = new $c_sci_HashMapBuilder();
    }
    this.sci_MapBuilderImpl__f_elems.buildTo__sci_HashMapBuilder__sci_HashMapBuilder(this.sci_MapBuilderImpl__f_hashMapBuilder);
    this.sci_MapBuilderImpl__f_hashMapBuilder.addOne__O__O__sci_HashMapBuilder(key, value);
  }
  return this;
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__sci_MapBuilderImpl = (function(xs) {
  return (this.sci_MapBuilderImpl__f_switchedToHashMapBuilder ? (this.sci_MapBuilderImpl__f_hashMapBuilder.addAll__sc_IterableOnce__sci_HashMapBuilder(xs), this) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
});
$c_sci_MapBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_MapBuilderImpl(elems);
});
$c_sci_MapBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__O__sci_MapBuilderImpl(elem._1__O(), elem._2__O());
});
$c_sci_MapBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Map();
});
var $d_sci_MapBuilderImpl = new $TypeData().initClass($c_sci_MapBuilderImpl, "scala.collection.immutable.MapBuilderImpl", ({
  sci_MapBuilderImpl: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_sci_MapBuilderImpl as $d_sci_MapBuilderImpl };
/** @constructor */
function $c_sci_Seq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sci_List$());
}
export { $c_sci_Seq$ as $c_sci_Seq$ };
$c_sci_Seq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_sci_Seq$.prototype.constructor = $c_sci_Seq$;
/** @constructor */
function $h_sci_Seq$() {
}
export { $h_sci_Seq$ as $h_sci_Seq$ };
$h_sci_Seq$.prototype = $c_sci_Seq$.prototype;
$c_sci_Seq$.prototype.from__sc_IterableOnce__sci_Seq = (function(it) {
  return ($is_sci_Seq(it) ? it : $c_sc_SeqFactory$Delegate.prototype.from__sc_IterableOnce__sc_SeqOps.call(this, it));
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Seq(source);
});
$c_sci_Seq$.prototype.from__sc_IterableOnce__sc_SeqOps = (function(it) {
  return this.from__sc_IterableOnce__sci_Seq(it);
});
var $d_sci_Seq$ = new $TypeData().initClass($c_sci_Seq$, "scala.collection.immutable.Seq$", ({
  sci_Seq$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Seq$ as $d_sci_Seq$ };
var $n_sci_Seq$;
function $m_sci_Seq$() {
  if ((!$n_sci_Seq$)) {
    $n_sci_Seq$ = new $c_sci_Seq$();
  }
  return $n_sci_Seq$;
}
export { $m_sci_Seq$ as $m_sci_Seq$ };
/** @constructor */
function $c_sci_SetBuilderImpl() {
  this.sci_SetBuilderImpl__f_elems = null;
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false;
  this.sci_SetBuilderImpl__f_hashSetBuilder = null;
  this.sci_SetBuilderImpl__f_elems = $m_sci_Set$EmptySet$();
  this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = false;
}
export { $c_sci_SetBuilderImpl as $c_sci_SetBuilderImpl };
$c_sci_SetBuilderImpl.prototype = new $h_O();
$c_sci_SetBuilderImpl.prototype.constructor = $c_sci_SetBuilderImpl;
/** @constructor */
function $h_sci_SetBuilderImpl() {
}
export { $h_sci_SetBuilderImpl as $h_sci_SetBuilderImpl };
$h_sci_SetBuilderImpl.prototype = $c_sci_SetBuilderImpl.prototype;
$c_sci_SetBuilderImpl.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_SetBuilderImpl.prototype.result__sci_Set = (function() {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? this.sci_SetBuilderImpl__f_hashSetBuilder.result__sci_HashSet() : this.sci_SetBuilderImpl__f_elems);
});
$c_sci_SetBuilderImpl.prototype.addOne__O__sci_SetBuilderImpl = (function(elem) {
  if (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder) {
    this.sci_SetBuilderImpl__f_hashSetBuilder.addOne__O__sci_HashSetBuilder(elem);
  } else if ((this.sci_SetBuilderImpl__f_elems.size__I() < 4)) {
    var this$1 = this.sci_SetBuilderImpl__f_elems;
    this.sci_SetBuilderImpl__f_elems = this$1.incl__O__sci_SetOps(elem);
  } else if ((!this.sci_SetBuilderImpl__f_elems.contains__O__Z(elem))) {
    this.sci_SetBuilderImpl__f_switchedToHashSetBuilder = true;
    if ((this.sci_SetBuilderImpl__f_hashSetBuilder === null)) {
      this.sci_SetBuilderImpl__f_hashSetBuilder = new $c_sci_HashSetBuilder();
    }
    this.sci_SetBuilderImpl__f_elems.buildTo__scm_Builder__scm_Builder(this.sci_SetBuilderImpl__f_hashSetBuilder);
    this.sci_SetBuilderImpl__f_hashSetBuilder.addOne__O__sci_HashSetBuilder(elem);
  }
  return this;
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__sci_SetBuilderImpl = (function(xs) {
  return (this.sci_SetBuilderImpl__f_switchedToHashSetBuilder ? (this.sci_SetBuilderImpl__f_hashSetBuilder.addAll__sc_IterableOnce__sci_HashSetBuilder(xs), this) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
});
$c_sci_SetBuilderImpl.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_SetBuilderImpl(elems);
});
$c_sci_SetBuilderImpl.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_SetBuilderImpl(elem);
});
$c_sci_SetBuilderImpl.prototype.result__O = (function() {
  return this.result__sci_Set();
});
var $d_sci_SetBuilderImpl = new $TypeData().initClass($c_sci_SetBuilderImpl, "scala.collection.immutable.SetBuilderImpl", ({
  sci_SetBuilderImpl: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_sci_SetBuilderImpl as $d_sci_SetBuilderImpl };
function $ps_sci_Vector$__liftedTree1$1__I() {
  try {
    var this$ = $m_jl_System$SystemProperties$().getProperty__T__T__T("scala.collection.immutable.Vector.defaultApplyPreferredMaxLength", "250");
    var this$3 = $m_jl_Integer$();
    return this$3.java$lang$Integer$$parseIntImpl__T__I__I__I(this$, 10, 214748364);
  } catch (e) {
    if (false) {
      return 250;
    } else {
      throw e;
    }
  }
}
export { $ps_sci_Vector$__liftedTree1$1__I as $ps_sci_Vector$__liftedTree1$1__I };
/** @constructor */
function $c_sci_Vector$() {
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = 0;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = null;
  $n_sci_Vector$ = this;
  this.sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength = $ps_sci_Vector$__liftedTree1$1__I();
  this.sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator = new $c_sci_NewVectorIterator($m_sci_Vector0$(), 0, 0);
}
export { $c_sci_Vector$ as $c_sci_Vector$ };
$c_sci_Vector$.prototype = new $h_O();
$c_sci_Vector$.prototype.constructor = $c_sci_Vector$;
/** @constructor */
function $h_sci_Vector$() {
}
export { $h_sci_Vector$ as $h_sci_Vector$ };
$h_sci_Vector$.prototype = $c_sci_Vector$.prototype;
$c_sci_Vector$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sci_Vector(elems);
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__sci_Vector = (function(it) {
  if ((it instanceof $c_sci_Vector)) {
    return it;
  } else {
    var knownSize = it.knownSize__I();
    if ((knownSize === 0)) {
      return $m_sci_Vector0$();
    } else if (((knownSize > 0) && (knownSize <= 32))) {
      matchEnd5: {
        var a1$3;
        if ((it instanceof $c_sci_ArraySeq$ofRef)) {
          var x = it.elemTag__s_reflect_ClassTag().runtimeClass__jl_Class();
          if (((x !== null) && (x === $d_O.getClassOf()))) {
            var a1$3 = it.sci_ArraySeq$ofRef__f_unsafeArray;
            break matchEnd5;
          }
        }
        if ($is_sci_Iterable(it)) {
          var a1 = new $ac_O(knownSize);
          it.copyToArray__O__I__I__I(a1, 0, 2147483647);
          var a1$3 = a1;
          break matchEnd5;
        }
        var a1$2 = new $ac_O(knownSize);
        var this$1 = it.iterator__sc_Iterator();
        this$1.copyToArray__O__I__I__I(a1$2, 0, 2147483647);
        var a1$3 = a1$2;
      }
      return new $c_sci_Vector1(a1$3);
    } else {
      var this$2 = new $c_sci_VectorBuilder();
      var this$3 = this$2.addAll__sc_IterableOnce__sci_VectorBuilder(it);
      return this$3.result__sci_Vector();
    }
  }
});
$c_sci_Vector$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_sci_VectorBuilder();
});
$c_sci_Vector$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sci_Vector(source);
});
$c_sci_Vector$.prototype.empty__O = (function() {
  return $m_sci_Vector0$();
});
var $d_sci_Vector$ = new $TypeData().initClass($c_sci_Vector$, "scala.collection.immutable.Vector$", ({
  sci_Vector$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Vector$ as $d_sci_Vector$ };
var $n_sci_Vector$;
function $m_sci_Vector$() {
  if ((!$n_sci_Vector$)) {
    $n_sci_Vector$ = new $c_sci_Vector$();
  }
  return $n_sci_Vector$;
}
export { $m_sci_Vector$ as $m_sci_Vector$ };
function $p_sci_VectorBuilder__leftAlignPrefix__V($thiz) {
  var a = null;
  var aParent = null;
  if (($thiz.sci_VectorBuilder__f_depth >= 6)) {
    a = $thiz.sci_VectorBuilder__f_a6;
    var i = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 25) | 0);
    if ((i > 0)) {
      var src = a;
      var dest = a;
      var length = ((64 - i) | 0);
      src.copyTo(i, dest, 0, length);
    }
    var newOffset = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 33554432) | 0);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset) | 0)) | 0);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset;
    if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 25) | 0) === 0)) {
      $thiz.sci_VectorBuilder__f_depth = 5;
    }
    aParent = a;
    a = a.u[0];
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 5)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a5;
    }
    var i$2 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 20) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 5)) {
      if ((i$2 > 0)) {
        var src$1 = a;
        var dest$1 = a;
        var length$1 = ((32 - i$2) | 0);
        src$1.copyTo(i$2, dest$1, 0, length$1);
      }
      $thiz.sci_VectorBuilder__f_a5 = a;
      var newOffset$1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 1048576) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$1) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$1;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 20) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 4;
      }
    } else {
      if ((i$2 > 0)) {
        var original = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, i$2, 32);
      }
      aParent.u[0] = a;
    }
    aParent = a;
    a = a.u[0];
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 4)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a4;
    }
    var i$3 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 15) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 4)) {
      if ((i$3 > 0)) {
        var src$2 = a;
        var dest$2 = a;
        var length$2 = ((32 - i$3) | 0);
        src$2.copyTo(i$3, dest$2, 0, length$2);
      }
      $thiz.sci_VectorBuilder__f_a4 = a;
      var newOffset$2 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 32768) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$2) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$2;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 15) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 3;
      }
    } else {
      if ((i$3 > 0)) {
        var original$1 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$1, i$3, 32);
      }
      aParent.u[0] = a;
    }
    aParent = a;
    a = a.u[0];
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 3)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a3;
    }
    var i$4 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 10) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 3)) {
      if ((i$4 > 0)) {
        var src$3 = a;
        var dest$3 = a;
        var length$3 = ((32 - i$4) | 0);
        src$3.copyTo(i$4, dest$3, 0, length$3);
      }
      $thiz.sci_VectorBuilder__f_a3 = a;
      var newOffset$3 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 1024) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$3) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$3;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 10) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 2;
      }
    } else {
      if ((i$4 > 0)) {
        var original$2 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$2, i$4, 32);
      }
      aParent.u[0] = a;
    }
    aParent = a;
    a = a.u[0];
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 2)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a2;
    }
    var i$5 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset >>> 5) | 0));
    if (($thiz.sci_VectorBuilder__f_depth === 2)) {
      if ((i$5 > 0)) {
        var src$4 = a;
        var dest$4 = a;
        var length$4 = ((32 - i$5) | 0);
        src$4.copyTo(i$5, dest$4, 0, length$4);
      }
      $thiz.sci_VectorBuilder__f_a2 = a;
      var newOffset$4 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset % 32) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest - (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset - newOffset$4) | 0)) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = newOffset$4;
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 5) | 0) === 0)) {
        $thiz.sci_VectorBuilder__f_depth = 1;
      }
    } else {
      if ((i$5 > 0)) {
        var original$3 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$3, i$5, 32);
      }
      aParent.u[0] = a;
    }
    aParent = a;
    a = a.u[0];
  }
  if (($thiz.sci_VectorBuilder__f_depth >= 1)) {
    if ((a === null)) {
      a = $thiz.sci_VectorBuilder__f_a1;
    }
    var i$6 = (31 & $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset);
    if (($thiz.sci_VectorBuilder__f_depth === 1)) {
      if ((i$6 > 0)) {
        var src$5 = a;
        var dest$5 = a;
        var length$5 = ((32 - i$6) | 0);
        src$5.copyTo(i$6, dest$5, 0, length$5);
      }
      $thiz.sci_VectorBuilder__f_a1 = a;
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0;
    } else {
      if ((i$6 > 0)) {
        var original$4 = a;
        a = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$4, i$6, 32);
      }
      aParent.u[0] = a;
    }
  }
  $thiz.sci_VectorBuilder__f_prefixIsRightAligned = false;
}
export { $p_sci_VectorBuilder__leftAlignPrefix__V as $p_sci_VectorBuilder__leftAlignPrefix__V };
function $p_sci_VectorBuilder__addArr1__AO__V($thiz, data) {
  var dl = data.u.length;
  if ((dl > 0)) {
    if (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
      $p_sci_VectorBuilder__advance__V($thiz);
    }
    var a = ((32 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
    var copy1 = ((a < dl) ? a : dl);
    var copy2 = ((dl - copy1) | 0);
    var dest = $thiz.sci_VectorBuilder__f_a1;
    var destPos = $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1;
    data.copyTo(0, dest, destPos, copy1);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy1) | 0);
    if ((copy2 > 0)) {
      $p_sci_VectorBuilder__advance__V($thiz);
      var dest$1 = $thiz.sci_VectorBuilder__f_a1;
      data.copyTo(copy1, dest$1, 0, copy2);
      $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + copy2) | 0);
    }
  }
}
export { $p_sci_VectorBuilder__addArr1__AO__V as $p_sci_VectorBuilder__addArr1__AO__V };
function $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, dim) {
  if ((slice.u.length === 0)) {
    return (void 0);
  }
  if (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
    $p_sci_VectorBuilder__advance__V($thiz);
  }
  var sl = slice.u.length;
  switch (dim) {
    case 2: {
      var a = (31 & ((((1024 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 5) | 0));
      var copy1 = ((a < sl) ? a : sl);
      var copy2 = ((sl - copy1) | 0);
      var destPos = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 5) | 0));
      var dest = $thiz.sci_VectorBuilder__f_a2;
      slice.copyTo(0, dest, destPos, copy1);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1 << 5));
      if ((copy2 > 0)) {
        var dest$1 = $thiz.sci_VectorBuilder__f_a2;
        slice.copyTo(copy1, dest$1, 0, copy2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2 << 5));
      }
      break;
    }
    case 3: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 1024) | 0) !== 0)) {
        var f = ((e$2$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$2$2, 2);
        });
        var len = slice.u.length;
        var i = 0;
        if ((slice !== null)) {
          while ((i < len)) {
            var x0 = slice.u[i];
            f(x0);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i < len)) {
            var x0$1 = slice.u[i];
            f(x0$1);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i < len)) {
            var x0$2 = slice.u[i];
            f(x0$2);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i < len)) {
            var t = slice.u[i];
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            f(new $c_RTLong(lo, hi));
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i < len)) {
            var x0$3 = slice.u[i];
            f(x0$3);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i < len)) {
            var x0$4 = slice.u[i];
            f($bC(x0$4));
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i < len)) {
            var x0$5 = slice.u[i];
            f(x0$5);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i < len)) {
            var x0$6 = slice.u[i];
            f(x0$6);
            i = ((1 + i) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i < len)) {
            var x0$7 = slice.u[i];
            f(x0$7);
            i = ((1 + i) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$1 = (31 & ((((32768 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 10) | 0));
      var copy1$2 = ((a$1 < sl) ? a$1 : sl);
      var copy2$2 = ((sl - copy1$2) | 0);
      var destPos$2 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 10) | 0));
      var dest$2 = $thiz.sci_VectorBuilder__f_a3;
      slice.copyTo(0, dest$2, destPos$2, copy1$2);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$2 << 10));
      if ((copy2$2 > 0)) {
        var dest$3 = $thiz.sci_VectorBuilder__f_a3;
        slice.copyTo(copy1$2, dest$3, 0, copy2$2);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$2 << 10));
      }
      break;
    }
    case 4: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 32768) | 0) !== 0)) {
        var f$1 = ((e$2$2$1) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$2$2$1, 3);
        });
        var len$1 = slice.u.length;
        var i$1 = 0;
        if ((slice !== null)) {
          while ((i$1 < len$1)) {
            var x0$8 = slice.u[i$1];
            f$1(x0$8);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i$1 < len$1)) {
            var x0$9 = slice.u[i$1];
            f$1(x0$9);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i$1 < len$1)) {
            var x0$10 = slice.u[i$1];
            f$1(x0$10);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i$1 < len$1)) {
            var t$1 = slice.u[i$1];
            var lo$1 = t$1.RTLong__f_lo;
            var hi$1 = t$1.RTLong__f_hi;
            f$1(new $c_RTLong(lo$1, hi$1));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i$1 < len$1)) {
            var x0$11 = slice.u[i$1];
            f$1(x0$11);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i$1 < len$1)) {
            var x0$12 = slice.u[i$1];
            f$1($bC(x0$12));
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i$1 < len$1)) {
            var x0$13 = slice.u[i$1];
            f$1(x0$13);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i$1 < len$1)) {
            var x0$14 = slice.u[i$1];
            f$1(x0$14);
            i$1 = ((1 + i$1) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i$1 < len$1)) {
            var x0$15 = slice.u[i$1];
            f$1(x0$15);
            i$1 = ((1 + i$1) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$2 = (31 & ((((1048576 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 15) | 0));
      var copy1$3 = ((a$2 < sl) ? a$2 : sl);
      var copy2$3 = ((sl - copy1$3) | 0);
      var destPos$3 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 15) | 0));
      var dest$4 = $thiz.sci_VectorBuilder__f_a4;
      slice.copyTo(0, dest$4, destPos$3, copy1$3);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$3 << 15));
      if ((copy2$3 > 0)) {
        var dest$5 = $thiz.sci_VectorBuilder__f_a4;
        slice.copyTo(copy1$3, dest$5, 0, copy2$3);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$3 << 15));
      }
      break;
    }
    case 5: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 1048576) | 0) !== 0)) {
        var f$2 = ((e$2$2$2) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$2$2$2, 4);
        });
        var len$2 = slice.u.length;
        var i$2 = 0;
        if ((slice !== null)) {
          while ((i$2 < len$2)) {
            var x0$16 = slice.u[i$2];
            f$2(x0$16);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i$2 < len$2)) {
            var x0$17 = slice.u[i$2];
            f$2(x0$17);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i$2 < len$2)) {
            var x0$18 = slice.u[i$2];
            f$2(x0$18);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i$2 < len$2)) {
            var t$2 = slice.u[i$2];
            var lo$2 = t$2.RTLong__f_lo;
            var hi$2 = t$2.RTLong__f_hi;
            f$2(new $c_RTLong(lo$2, hi$2));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i$2 < len$2)) {
            var x0$19 = slice.u[i$2];
            f$2(x0$19);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i$2 < len$2)) {
            var x0$20 = slice.u[i$2];
            f$2($bC(x0$20));
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i$2 < len$2)) {
            var x0$21 = slice.u[i$2];
            f$2(x0$21);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i$2 < len$2)) {
            var x0$22 = slice.u[i$2];
            f$2(x0$22);
            i$2 = ((1 + i$2) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i$2 < len$2)) {
            var x0$23 = slice.u[i$2];
            f$2(x0$23);
            i$2 = ((1 + i$2) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var a$3 = (31 & ((((33554432 - $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0) >>> 20) | 0));
      var copy1$4 = ((a$3 < sl) ? a$3 : sl);
      var copy2$4 = ((sl - copy1$4) | 0);
      var destPos$4 = (31 & (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 20) | 0));
      var dest$6 = $thiz.sci_VectorBuilder__f_a5;
      slice.copyTo(0, dest$6, destPos$4, copy1$4);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy1$4 << 20));
      if ((copy2$4 > 0)) {
        var dest$7 = $thiz.sci_VectorBuilder__f_a5;
        slice.copyTo(copy1$4, dest$7, 0, copy2$4);
        $p_sci_VectorBuilder__advanceN__I__V($thiz, (copy2$4 << 20));
      }
      break;
    }
    case 6: {
      if (((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest % 33554432) | 0) !== 0)) {
        var f$3 = ((e$2$2$3) => {
          $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, e$2$2$3, 5);
        });
        var len$3 = slice.u.length;
        var i$3 = 0;
        if ((slice !== null)) {
          while ((i$3 < len$3)) {
            var x0$24 = slice.u[i$3];
            f$3(x0$24);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_I)) {
          while ((i$3 < len$3)) {
            var x0$25 = slice.u[i$3];
            f$3(x0$25);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_D)) {
          while ((i$3 < len$3)) {
            var x0$26 = slice.u[i$3];
            f$3(x0$26);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_J)) {
          while ((i$3 < len$3)) {
            var t$3 = slice.u[i$3];
            var lo$3 = t$3.RTLong__f_lo;
            var hi$3 = t$3.RTLong__f_hi;
            f$3(new $c_RTLong(lo$3, hi$3));
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_F)) {
          while ((i$3 < len$3)) {
            var x0$27 = slice.u[i$3];
            f$3(x0$27);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_C)) {
          while ((i$3 < len$3)) {
            var x0$28 = slice.u[i$3];
            f$3($bC(x0$28));
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_B)) {
          while ((i$3 < len$3)) {
            var x0$29 = slice.u[i$3];
            f$3(x0$29);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_S)) {
          while ((i$3 < len$3)) {
            var x0$30 = slice.u[i$3];
            f$3(x0$30);
            i$3 = ((1 + i$3) | 0);
          }
        } else if ((slice instanceof $ac_Z)) {
          while ((i$3 < len$3)) {
            var x0$31 = slice.u[i$3];
            f$3(x0$31);
            i$3 = ((1 + i$3) | 0);
          }
        } else {
          throw new $c_s_MatchError(slice);
        }
        return (void 0);
      }
      var destPos$5 = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest >>> 25) | 0);
      if ((((destPos$5 + sl) | 0) > 64)) {
        throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "exceeding 2^31 elements");
      }
      var dest$8 = $thiz.sci_VectorBuilder__f_a6;
      slice.copyTo(0, dest$8, destPos$5, sl);
      $p_sci_VectorBuilder__advanceN__I__V($thiz, (sl << 25));
      break;
    }
    default: {
      throw new $c_s_MatchError(dim);
    }
  }
}
export { $p_sci_VectorBuilder__addArrN__AO__I__V as $p_sci_VectorBuilder__addArrN__AO__I__V };
function $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder($thiz, xs) {
  var sliceCount = xs.vectorSliceCount__I();
  var sliceIdx = 0;
  while ((sliceIdx < sliceCount)) {
    var slice = xs.vectorSlice__I__AO(sliceIdx);
    var idx = sliceIdx;
    var c = ((sliceCount / 2) | 0);
    var a = ((idx - c) | 0);
    var sign = (a >> 31);
    var x1 = ((((1 + c) | 0) - (((a ^ sign) - sign) | 0)) | 0);
    if ((x1 === 1)) {
      $p_sci_VectorBuilder__addArr1__AO__V($thiz, slice);
    } else if ((($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32) || ($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0))) {
      $p_sci_VectorBuilder__addArrN__AO__I__V($thiz, slice, x1);
    } else {
      $m_sci_VectorStatics$().foreachRec__I__AO__F1__V((((-2) + x1) | 0), slice, new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((data$2$2) => {
        $p_sci_VectorBuilder__addArr1__AO__V($thiz, data$2$2);
      })));
    }
    sliceIdx = ((1 + sliceIdx) | 0);
  }
  return $thiz;
}
export { $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder as $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder };
function $p_sci_VectorBuilder__advance__V($thiz) {
  var idx = ((32 + $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var xor = (idx ^ $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest);
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = idx;
  $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor);
}
export { $p_sci_VectorBuilder__advance__V as $p_sci_VectorBuilder__advance__V };
function $p_sci_VectorBuilder__advanceN__I__V($thiz, n) {
  if ((n > 0)) {
    var idx = (($thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest + n) | 0);
    var xor = (idx ^ $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest);
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = idx;
    $thiz.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
    $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor);
  }
}
export { $p_sci_VectorBuilder__advanceN__I__V as $p_sci_VectorBuilder__advanceN__I__V };
function $p_sci_VectorBuilder__advance1__I__I__V($thiz, idx, xor) {
  if ((xor <= 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), ((((((((((((((((("advance1(" + idx) + ", ") + xor) + "): a1=") + $thiz.sci_VectorBuilder__f_a1) + ", a2=") + $thiz.sci_VectorBuilder__f_a2) + ", a3=") + $thiz.sci_VectorBuilder__f_a3) + ", a4=") + $thiz.sci_VectorBuilder__f_a4) + ", a5=") + $thiz.sci_VectorBuilder__f_a5) + ", a6=") + $thiz.sci_VectorBuilder__f_a6) + ", depth=") + $thiz.sci_VectorBuilder__f_depth));
  } else if ((xor < 1024)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 1)) {
      $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a2.u[0] = $thiz.sci_VectorBuilder__f_a1;
      $thiz.sci_VectorBuilder__f_depth = 2;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2.u[(31 & ((idx >>> 5) | 0))] = $thiz.sci_VectorBuilder__f_a1;
  } else if ((xor < 32768)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 2)) {
      $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a3.u[0] = $thiz.sci_VectorBuilder__f_a2;
      $thiz.sci_VectorBuilder__f_depth = 3;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.u[(31 & ((idx >>> 5) | 0))] = $thiz.sci_VectorBuilder__f_a1;
    $thiz.sci_VectorBuilder__f_a3.u[(31 & ((idx >>> 10) | 0))] = $thiz.sci_VectorBuilder__f_a2;
  } else if ((xor < 1048576)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 3)) {
      $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a4.u[0] = $thiz.sci_VectorBuilder__f_a3;
      $thiz.sci_VectorBuilder__f_depth = 4;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.u[(31 & ((idx >>> 5) | 0))] = $thiz.sci_VectorBuilder__f_a1;
    $thiz.sci_VectorBuilder__f_a3.u[(31 & ((idx >>> 10) | 0))] = $thiz.sci_VectorBuilder__f_a2;
    $thiz.sci_VectorBuilder__f_a4.u[(31 & ((idx >>> 15) | 0))] = $thiz.sci_VectorBuilder__f_a3;
  } else if ((xor < 33554432)) {
    if (($thiz.sci_VectorBuilder__f_depth <= 4)) {
      $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      $thiz.sci_VectorBuilder__f_a5.u[0] = $thiz.sci_VectorBuilder__f_a4;
      $thiz.sci_VectorBuilder__f_depth = 5;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.u[(31 & ((idx >>> 5) | 0))] = $thiz.sci_VectorBuilder__f_a1;
    $thiz.sci_VectorBuilder__f_a3.u[(31 & ((idx >>> 10) | 0))] = $thiz.sci_VectorBuilder__f_a2;
    $thiz.sci_VectorBuilder__f_a4.u[(31 & ((idx >>> 15) | 0))] = $thiz.sci_VectorBuilder__f_a3;
    $thiz.sci_VectorBuilder__f_a5.u[(31 & ((idx >>> 20) | 0))] = $thiz.sci_VectorBuilder__f_a4;
  } else {
    if (($thiz.sci_VectorBuilder__f_depth <= 5)) {
      $thiz.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(64);
      $thiz.sci_VectorBuilder__f_a6.u[0] = $thiz.sci_VectorBuilder__f_a5;
      $thiz.sci_VectorBuilder__f_depth = 6;
    }
    $thiz.sci_VectorBuilder__f_a1 = new $ac_O(32);
    $thiz.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
    $thiz.sci_VectorBuilder__f_a2.u[(31 & ((idx >>> 5) | 0))] = $thiz.sci_VectorBuilder__f_a1;
    $thiz.sci_VectorBuilder__f_a3.u[(31 & ((idx >>> 10) | 0))] = $thiz.sci_VectorBuilder__f_a2;
    $thiz.sci_VectorBuilder__f_a4.u[(31 & ((idx >>> 15) | 0))] = $thiz.sci_VectorBuilder__f_a3;
    $thiz.sci_VectorBuilder__f_a5.u[(31 & ((idx >>> 20) | 0))] = $thiz.sci_VectorBuilder__f_a4;
    $thiz.sci_VectorBuilder__f_a6.u[((idx >>> 25) | 0)] = $thiz.sci_VectorBuilder__f_a5;
  }
}
export { $p_sci_VectorBuilder__advance1__I__I__V as $p_sci_VectorBuilder__advance1__I__I__V };
/** @constructor */
function $c_sci_VectorBuilder() {
  this.sci_VectorBuilder__f_a6 = null;
  this.sci_VectorBuilder__f_a5 = null;
  this.sci_VectorBuilder__f_a4 = null;
  this.sci_VectorBuilder__f_a3 = null;
  this.sci_VectorBuilder__f_a2 = null;
  this.sci_VectorBuilder__f_a1 = null;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0;
  this.sci_VectorBuilder__f_prefixIsRightAligned = false;
  this.sci_VectorBuilder__f_depth = 0;
  this.sci_VectorBuilder__f_a1 = new $ac_O(32);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = 0;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = 0;
  this.sci_VectorBuilder__f_prefixIsRightAligned = false;
  this.sci_VectorBuilder__f_depth = 1;
}
export { $c_sci_VectorBuilder as $c_sci_VectorBuilder };
$c_sci_VectorBuilder.prototype = new $h_O();
$c_sci_VectorBuilder.prototype.constructor = $c_sci_VectorBuilder;
/** @constructor */
function $h_sci_VectorBuilder() {
}
export { $h_sci_VectorBuilder as $h_sci_VectorBuilder };
$h_sci_VectorBuilder.prototype = $c_sci_VectorBuilder.prototype;
$c_sci_VectorBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_sci_VectorBuilder.prototype.initFrom__AO__V = (function(prefix1) {
  this.sci_VectorBuilder__f_depth = 1;
  var i = prefix1.u.length;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  this.sci_VectorBuilder__f_a1 = ((prefix1.u.length === 32) ? prefix1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(prefix1, 0, 32));
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  }
});
$c_sci_VectorBuilder.prototype.initFrom__sci_Vector__sci_VectorBuilder = (function(v) {
  var x1 = v.vectorSliceCount__I();
  switch (x1) {
    case 0: {
      break;
    }
    case 1: {
      this.sci_VectorBuilder__f_depth = 1;
      var i = v.sci_Vector__f_prefix1.u.length;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      var a = v.sci_Vector__f_prefix1;
      this.sci_VectorBuilder__f_a1 = ((a.u.length === 32) ? a : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, 32));
      break;
    }
    case 3: {
      var d2 = v.sci_Vector2__f_data2;
      var a$1 = v.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$1.u.length === 32) ? a$1 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$1, 0, 32));
      this.sci_VectorBuilder__f_depth = 2;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((32 - v.sci_Vector2__f_len1) | 0);
      var i$1 = ((v.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$1);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$1 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a2 = new ($d_O.getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a2.u[0] = v.sci_Vector__f_prefix1;
      var dest = this.sci_VectorBuilder__f_a2;
      var length = d2.u.length;
      d2.copyTo(0, dest, 1, length);
      this.sci_VectorBuilder__f_a2.u[((1 + d2.u.length) | 0)] = this.sci_VectorBuilder__f_a1;
      break;
    }
    case 5: {
      var d3 = v.sci_Vector3__f_data3;
      var s2 = v.sci_Vector3__f_suffix2;
      var a$2 = v.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$2.u.length === 32) ? a$2 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, 0, 32));
      this.sci_VectorBuilder__f_depth = 3;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((1024 - v.sci_Vector3__f_len12) | 0);
      var i$2 = ((v.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$2);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$2 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a3.u[0] = $m_sci_VectorStatics$().copyPrepend__O__AO__AO(v.sci_Vector__f_prefix1, v.sci_Vector3__f_prefix2);
      var dest$1 = this.sci_VectorBuilder__f_a3;
      var length$1 = d3.u.length;
      d3.copyTo(0, dest$1, 1, length$1);
      this.sci_VectorBuilder__f_a2 = $m_ju_Arrays$().copyOf__AO__I__AO(s2, 32);
      this.sci_VectorBuilder__f_a3.u[((1 + d3.u.length) | 0)] = this.sci_VectorBuilder__f_a2;
      this.sci_VectorBuilder__f_a2.u[s2.u.length] = this.sci_VectorBuilder__f_a1;
      break;
    }
    case 7: {
      var d4 = v.sci_Vector4__f_data4;
      var s3 = v.sci_Vector4__f_suffix3;
      var s2$2 = v.sci_Vector4__f_suffix2;
      var a$3 = v.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$3.u.length === 32) ? a$3 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$3, 0, 32));
      this.sci_VectorBuilder__f_depth = 4;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((32768 - v.sci_Vector4__f_len123) | 0);
      var i$3 = ((v.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$3);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$3 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a4.u[0] = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v.sci_Vector__f_prefix1, v.sci_Vector4__f_prefix2), v.sci_Vector4__f_prefix3);
      var dest$2 = this.sci_VectorBuilder__f_a4;
      var length$2 = d4.u.length;
      d4.copyTo(0, dest$2, 1, length$2);
      this.sci_VectorBuilder__f_a3 = $m_ju_Arrays$().copyOf__AO__I__AO(s3, 32);
      this.sci_VectorBuilder__f_a2 = $m_ju_Arrays$().copyOf__AO__I__AO(s2$2, 32);
      this.sci_VectorBuilder__f_a4.u[((1 + d4.u.length) | 0)] = this.sci_VectorBuilder__f_a3;
      this.sci_VectorBuilder__f_a3.u[s3.u.length] = this.sci_VectorBuilder__f_a2;
      this.sci_VectorBuilder__f_a2.u[s2$2.u.length] = this.sci_VectorBuilder__f_a1;
      break;
    }
    case 9: {
      var d5 = v.sci_Vector5__f_data5;
      var s4 = v.sci_Vector5__f_suffix4;
      var s3$2 = v.sci_Vector5__f_suffix3;
      var s2$3 = v.sci_Vector5__f_suffix2;
      var a$4 = v.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$4.u.length === 32) ? a$4 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 0, 32));
      this.sci_VectorBuilder__f_depth = 5;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((1048576 - v.sci_Vector5__f_len1234) | 0);
      var i$4 = ((v.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$4);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$4 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(32);
      this.sci_VectorBuilder__f_a5.u[0] = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v.sci_Vector__f_prefix1, v.sci_Vector5__f_prefix2), v.sci_Vector5__f_prefix3), v.sci_Vector5__f_prefix4);
      var dest$3 = this.sci_VectorBuilder__f_a5;
      var length$3 = d5.u.length;
      d5.copyTo(0, dest$3, 1, length$3);
      this.sci_VectorBuilder__f_a4 = $m_ju_Arrays$().copyOf__AO__I__AO(s4, 32);
      this.sci_VectorBuilder__f_a3 = $m_ju_Arrays$().copyOf__AO__I__AO(s3$2, 32);
      this.sci_VectorBuilder__f_a2 = $m_ju_Arrays$().copyOf__AO__I__AO(s2$3, 32);
      this.sci_VectorBuilder__f_a5.u[((1 + d5.u.length) | 0)] = this.sci_VectorBuilder__f_a4;
      this.sci_VectorBuilder__f_a4.u[s4.u.length] = this.sci_VectorBuilder__f_a3;
      this.sci_VectorBuilder__f_a3.u[s3$2.u.length] = this.sci_VectorBuilder__f_a2;
      this.sci_VectorBuilder__f_a2.u[s2$3.u.length] = this.sci_VectorBuilder__f_a1;
      break;
    }
    case 11: {
      var d6 = v.sci_Vector6__f_data6;
      var s5 = v.sci_Vector6__f_suffix5;
      var s4$2 = v.sci_Vector6__f_suffix4;
      var s3$3 = v.sci_Vector6__f_suffix3;
      var s2$4 = v.sci_Vector6__f_suffix2;
      var a$5 = v.sci_BigVector__f_suffix1;
      this.sci_VectorBuilder__f_a1 = ((a$5.u.length === 32) ? a$5 : $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, 0, 32));
      this.sci_VectorBuilder__f_depth = 6;
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((33554432 - v.sci_Vector6__f_len12345) | 0);
      var i$5 = ((v.sci_BigVector__f_length0 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & i$5);
      this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = ((i$5 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
      this.sci_VectorBuilder__f_a6 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(64);
      this.sci_VectorBuilder__f_a6.u[0] = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(v.sci_Vector__f_prefix1, v.sci_Vector6__f_prefix2), v.sci_Vector6__f_prefix3), v.sci_Vector6__f_prefix4), v.sci_Vector6__f_prefix5);
      var dest$4 = this.sci_VectorBuilder__f_a6;
      var length$4 = d6.u.length;
      d6.copyTo(0, dest$4, 1, length$4);
      this.sci_VectorBuilder__f_a5 = $m_ju_Arrays$().copyOf__AO__I__AO(s5, 32);
      this.sci_VectorBuilder__f_a4 = $m_ju_Arrays$().copyOf__AO__I__AO(s4$2, 32);
      this.sci_VectorBuilder__f_a3 = $m_ju_Arrays$().copyOf__AO__I__AO(s3$3, 32);
      this.sci_VectorBuilder__f_a2 = $m_ju_Arrays$().copyOf__AO__I__AO(s2$4, 32);
      this.sci_VectorBuilder__f_a6.u[((1 + d6.u.length) | 0)] = this.sci_VectorBuilder__f_a5;
      this.sci_VectorBuilder__f_a5.u[s5.u.length] = this.sci_VectorBuilder__f_a4;
      this.sci_VectorBuilder__f_a4.u[s4$2.u.length] = this.sci_VectorBuilder__f_a3;
      this.sci_VectorBuilder__f_a3.u[s3$3.u.length] = this.sci_VectorBuilder__f_a2;
      this.sci_VectorBuilder__f_a2.u[s2$4.u.length] = this.sci_VectorBuilder__f_a1;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest > 0))) {
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = 32;
    this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest = (((-32) + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  }
  return this;
});
$c_sci_VectorBuilder.prototype.alignTo__I__sci_Vector__sci_VectorBuilder = (function(before, bigVector) {
  if (((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 !== 0) || (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest !== 0))) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "A non-empty VectorBuilder cannot be aligned retrospectively. Please call .reset() or use a new VectorBuilder.");
  }
  var x = $m_sci_Vector0$();
  if (x.equals__O__Z(bigVector)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = 0;
    var x1$2___2$mcI$sp = 1;
  } else if ((bigVector instanceof $c_sci_Vector1)) {
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = 0;
    var x1$2___2$mcI$sp = 1;
  } else if ((bigVector instanceof $c_sci_Vector2)) {
    var _1$mcI$sp = bigVector.sci_Vector2__f_len1;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp;
    var x1$2___2$mcI$sp = 32;
  } else if ((bigVector instanceof $c_sci_Vector3)) {
    var _1$mcI$sp$1 = bigVector.sci_Vector3__f_len12;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$1;
    var x1$2___2$mcI$sp = 1024;
  } else if ((bigVector instanceof $c_sci_Vector4)) {
    var _1$mcI$sp$2 = bigVector.sci_Vector4__f_len123;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$2;
    var x1$2___2$mcI$sp = 32768;
  } else if ((bigVector instanceof $c_sci_Vector5)) {
    var _1$mcI$sp$3 = bigVector.sci_Vector5__f_len1234;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$3;
    var x1$2___2$mcI$sp = 1048576;
  } else {
    if ((!(bigVector instanceof $c_sci_Vector6))) {
      throw new $c_s_MatchError(bigVector);
    }
    var _1$mcI$sp$4 = bigVector.sci_Vector6__f_len12345;
    var x1$2___1 = null;
    var x1$2___2 = null;
    var x1$2___1$mcI$sp = _1$mcI$sp$4;
    var x1$2___2$mcI$sp = 33554432;
  }
  var prefixLength = x1$2___1$mcI$sp;
  var maxPrefixLength = x1$2___2$mcI$sp;
  if ((maxPrefixLength === 1)) {
    return this;
  }
  var overallPrefixLength = ((((before + prefixLength) | 0) % $checkIntDivisor(maxPrefixLength)) | 0);
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset = ((((maxPrefixLength - overallPrefixLength) | 0) % $checkIntDivisor(maxPrefixLength)) | 0);
  $p_sci_VectorBuilder__advanceN__I__V(this, ((-32) & this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset));
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = (31 & this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset);
  this.sci_VectorBuilder__f_prefixIsRightAligned = true;
  return this;
});
$c_sci_VectorBuilder.prototype.addOne__O__sci_VectorBuilder = (function(elem) {
  if ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 32)) {
    $p_sci_VectorBuilder__advance__V(this);
  }
  this.sci_VectorBuilder__f_a1.u[this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1] = elem;
  this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 = ((1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) | 0);
  return this;
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__sci_VectorBuilder = (function(xs) {
  return ((xs instanceof $c_sci_Vector) ? ((((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 === 0) && (this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest === 0)) && (!this.sci_VectorBuilder__f_prefixIsRightAligned)) ? this.initFrom__sci_Vector__sci_VectorBuilder(xs) : $p_sci_VectorBuilder__addVector__sci_Vector__sci_VectorBuilder(this, xs)) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
});
$c_sci_VectorBuilder.prototype.result__sci_Vector = (function() {
  if (this.sci_VectorBuilder__f_prefixIsRightAligned) {
    $p_sci_VectorBuilder__leftAlignPrefix__V(this);
  }
  var len = ((this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1 + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) | 0);
  var realLen = ((len - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0);
  if ((realLen === 0)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  } else if ((len < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("Vector cannot have negative size " + len));
  } else if ((len <= 32)) {
    var a = this.sci_VectorBuilder__f_a1;
    return new $c_sci_Vector1(((a.u.length === realLen) ? a : $m_ju_Arrays$().copyOf__AO__I__AO(a, realLen)));
  } else if ((len <= 1024)) {
    var i1 = (31 & (((-1) + len) | 0));
    var i2 = (((((-1) + len) | 0) >>> 5) | 0);
    var original = this.sci_VectorBuilder__f_a2;
    var data = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, 1, i2);
    var prefix1 = this.sci_VectorBuilder__f_a2.u[0];
    var a$1 = this.sci_VectorBuilder__f_a2.u[i2];
    var len$1 = ((1 + i1) | 0);
    var suffix1 = ((a$1.u.length === len$1) ? a$1 : $m_ju_Arrays$().copyOf__AO__I__AO(a$1, len$1));
    return new $c_sci_Vector2(prefix1, ((32 - this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) | 0), data, suffix1, realLen);
  } else if ((len <= 32768)) {
    var i1$2 = (31 & (((-1) + len) | 0));
    var i2$2 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3 = (((((-1) + len) | 0) >>> 10) | 0);
    var original$1 = this.sci_VectorBuilder__f_a3;
    var data$2 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$1, 1, i3);
    var a$2 = this.sci_VectorBuilder__f_a3.u[0];
    var to = a$2.u.length;
    var prefix2 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$2, 1, to);
    var prefix1$2 = this.sci_VectorBuilder__f_a3.u[0].u[0];
    var original$2 = this.sci_VectorBuilder__f_a3.u[i3];
    var suffix2 = $m_ju_Arrays$().copyOf__AO__I__AO(original$2, i2$2);
    var a$3 = this.sci_VectorBuilder__f_a3.u[i3].u[i2$2];
    var len$2 = ((1 + i1$2) | 0);
    var suffix1$2 = ((a$3.u.length === len$2) ? a$3 : $m_ju_Arrays$().copyOf__AO__I__AO(a$3, len$2));
    var len1 = prefix1$2.u.length;
    var len12 = ((len1 + (prefix2.u.length << 5)) | 0);
    return new $c_sci_Vector3(prefix1$2, len1, prefix2, len12, data$2, suffix2, suffix1$2, realLen);
  } else if ((len <= 1048576)) {
    var i1$3 = (31 & (((-1) + len) | 0));
    var i2$3 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$2 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4 = (((((-1) + len) | 0) >>> 15) | 0);
    var original$3 = this.sci_VectorBuilder__f_a4;
    var data$3 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$3, 1, i4);
    var a$4 = this.sci_VectorBuilder__f_a4.u[0];
    var to$1 = a$4.u.length;
    var prefix3 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$4, 1, to$1);
    var a$5 = this.sci_VectorBuilder__f_a4.u[0].u[0];
    var to$2 = a$5.u.length;
    var prefix2$2 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$5, 1, to$2);
    var prefix1$3 = this.sci_VectorBuilder__f_a4.u[0].u[0].u[0];
    var original$4 = this.sci_VectorBuilder__f_a4.u[i4];
    var suffix3 = $m_ju_Arrays$().copyOf__AO__I__AO(original$4, i3$2);
    var original$5 = this.sci_VectorBuilder__f_a4.u[i4].u[i3$2];
    var suffix2$2 = $m_ju_Arrays$().copyOf__AO__I__AO(original$5, i2$3);
    var a$6 = this.sci_VectorBuilder__f_a4.u[i4].u[i3$2].u[i2$3];
    var len$3 = ((1 + i1$3) | 0);
    var suffix1$3 = ((a$6.u.length === len$3) ? a$6 : $m_ju_Arrays$().copyOf__AO__I__AO(a$6, len$3));
    var len1$2 = prefix1$3.u.length;
    var len12$2 = ((len1$2 + (prefix2$2.u.length << 5)) | 0);
    var len123 = ((len12$2 + (prefix3.u.length << 10)) | 0);
    return new $c_sci_Vector4(prefix1$3, len1$2, prefix2$2, len12$2, prefix3, len123, data$3, suffix3, suffix2$2, suffix1$3, realLen);
  } else if ((len <= 33554432)) {
    var i1$4 = (31 & (((-1) + len) | 0));
    var i2$4 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$3 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$2 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5 = (((((-1) + len) | 0) >>> 20) | 0);
    var original$6 = this.sci_VectorBuilder__f_a5;
    var data$4 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$6, 1, i5);
    var a$7 = this.sci_VectorBuilder__f_a5.u[0];
    var to$3 = a$7.u.length;
    var prefix4 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$7, 1, to$3);
    var a$8 = this.sci_VectorBuilder__f_a5.u[0].u[0];
    var to$4 = a$8.u.length;
    var prefix3$2 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$8, 1, to$4);
    var a$9 = this.sci_VectorBuilder__f_a5.u[0].u[0].u[0];
    var to$5 = a$9.u.length;
    var prefix2$3 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$9, 1, to$5);
    var prefix1$4 = this.sci_VectorBuilder__f_a5.u[0].u[0].u[0].u[0];
    var original$7 = this.sci_VectorBuilder__f_a5.u[i5];
    var suffix4 = $m_ju_Arrays$().copyOf__AO__I__AO(original$7, i4$2);
    var original$8 = this.sci_VectorBuilder__f_a5.u[i5].u[i4$2];
    var suffix3$2 = $m_ju_Arrays$().copyOf__AO__I__AO(original$8, i3$3);
    var original$9 = this.sci_VectorBuilder__f_a5.u[i5].u[i4$2].u[i3$3];
    var suffix2$3 = $m_ju_Arrays$().copyOf__AO__I__AO(original$9, i2$4);
    var a$10 = this.sci_VectorBuilder__f_a5.u[i5].u[i4$2].u[i3$3].u[i2$4];
    var len$4 = ((1 + i1$4) | 0);
    var suffix1$4 = ((a$10.u.length === len$4) ? a$10 : $m_ju_Arrays$().copyOf__AO__I__AO(a$10, len$4));
    var len1$3 = prefix1$4.u.length;
    var len12$3 = ((len1$3 + (prefix2$3.u.length << 5)) | 0);
    var len123$2 = ((len12$3 + (prefix3$2.u.length << 10)) | 0);
    var len1234 = ((len123$2 + (prefix4.u.length << 15)) | 0);
    return new $c_sci_Vector5(prefix1$4, len1$3, prefix2$3, len12$3, prefix3$2, len123$2, prefix4, len1234, data$4, suffix4, suffix3$2, suffix2$3, suffix1$4, realLen);
  } else {
    var i1$5 = (31 & (((-1) + len) | 0));
    var i2$5 = (31 & (((((-1) + len) | 0) >>> 5) | 0));
    var i3$4 = (31 & (((((-1) + len) | 0) >>> 10) | 0));
    var i4$3 = (31 & (((((-1) + len) | 0) >>> 15) | 0));
    var i5$2 = (31 & (((((-1) + len) | 0) >>> 20) | 0));
    var i6 = (((((-1) + len) | 0) >>> 25) | 0);
    var original$10 = this.sci_VectorBuilder__f_a6;
    var data$5 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(original$10, 1, i6);
    var a$11 = this.sci_VectorBuilder__f_a6.u[0];
    var to$6 = a$11.u.length;
    var prefix5 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$11, 1, to$6);
    var a$12 = this.sci_VectorBuilder__f_a6.u[0].u[0];
    var to$7 = a$12.u.length;
    var prefix4$2 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$12, 1, to$7);
    var a$13 = this.sci_VectorBuilder__f_a6.u[0].u[0].u[0];
    var to$8 = a$13.u.length;
    var prefix3$3 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$13, 1, to$8);
    var a$14 = this.sci_VectorBuilder__f_a6.u[0].u[0].u[0].u[0];
    var to$9 = a$14.u.length;
    var prefix2$4 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a$14, 1, to$9);
    var prefix1$5 = this.sci_VectorBuilder__f_a6.u[0].u[0].u[0].u[0].u[0];
    var original$11 = this.sci_VectorBuilder__f_a6.u[i6];
    var suffix5 = $m_ju_Arrays$().copyOf__AO__I__AO(original$11, i5$2);
    var original$12 = this.sci_VectorBuilder__f_a6.u[i6].u[i5$2];
    var suffix4$2 = $m_ju_Arrays$().copyOf__AO__I__AO(original$12, i4$3);
    var original$13 = this.sci_VectorBuilder__f_a6.u[i6].u[i5$2].u[i4$3];
    var suffix3$3 = $m_ju_Arrays$().copyOf__AO__I__AO(original$13, i3$4);
    var original$14 = this.sci_VectorBuilder__f_a6.u[i6].u[i5$2].u[i4$3].u[i3$4];
    var suffix2$4 = $m_ju_Arrays$().copyOf__AO__I__AO(original$14, i2$5);
    var a$15 = this.sci_VectorBuilder__f_a6.u[i6].u[i5$2].u[i4$3].u[i3$4].u[i2$5];
    var len$5 = ((1 + i1$5) | 0);
    var suffix1$5 = ((a$15.u.length === len$5) ? a$15 : $m_ju_Arrays$().copyOf__AO__I__AO(a$15, len$5));
    var len1$4 = prefix1$5.u.length;
    var len12$4 = ((len1$4 + (prefix2$4.u.length << 5)) | 0);
    var len123$3 = ((len12$4 + (prefix3$3.u.length << 10)) | 0);
    var len1234$2 = ((len123$3 + (prefix4$2.u.length << 15)) | 0);
    var len12345 = ((len1234$2 + (prefix5.u.length << 20)) | 0);
    return new $c_sci_Vector6(prefix1$5, len1$4, prefix2$4, len12$4, prefix3$3, len123$3, prefix4$2, len1234$2, prefix5, len12345, data$5, suffix5, suffix4$2, suffix3$3, suffix2$4, suffix1$5, realLen);
  }
});
$c_sci_VectorBuilder.prototype.toString__T = (function() {
  return (((((((("VectorBuilder(len1=" + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$len1) + ", lenRest=") + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$lenRest) + ", offset=") + this.sci_VectorBuilder__f_scala$collection$immutable$VectorBuilder$$offset) + ", depth=") + this.sci_VectorBuilder__f_depth) + ")");
});
$c_sci_VectorBuilder.prototype.result__O = (function() {
  return this.result__sci_Vector();
});
$c_sci_VectorBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
});
$c_sci_VectorBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sci_VectorBuilder(elem);
});
var $d_sci_VectorBuilder = new $TypeData().initClass($c_sci_VectorBuilder, "scala.collection.immutable.VectorBuilder", ({
  sci_VectorBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_sci_VectorBuilder as $d_sci_VectorBuilder };
/** @constructor */
function $c_scm_ArrayBuffer$() {
  this.scm_ArrayBuffer$__f_emptyArray = null;
  $n_scm_ArrayBuffer$ = this;
  this.scm_ArrayBuffer$__f_emptyArray = new $ac_O(0);
}
export { $c_scm_ArrayBuffer$ as $c_scm_ArrayBuffer$ };
$c_scm_ArrayBuffer$.prototype = new $h_O();
$c_scm_ArrayBuffer$.prototype.constructor = $c_scm_ArrayBuffer$;
/** @constructor */
function $h_scm_ArrayBuffer$() {
}
export { $h_scm_ArrayBuffer$ as $h_scm_ArrayBuffer$ };
$h_scm_ArrayBuffer$.prototype = $c_scm_ArrayBuffer$.prototype;
$c_scm_ArrayBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(elems);
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__scm_ArrayBuffer = (function(coll) {
  var k = coll.knownSize__I();
  if ((k >= 0)) {
    var array = this.scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO(this.scm_ArrayBuffer$__f_emptyArray, 0, k);
    var actual = ($is_sc_Iterable(coll) ? coll.copyToArray__O__I__I__I(array, 0, 2147483647) : coll.iterator__sc_Iterator().copyToArray__O__I__I__I(array, 0, 2147483647));
    if ((actual !== k)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + k));
    }
    return $ct_scm_ArrayBuffer__AO__I__(new $c_scm_ArrayBuffer(), array, k);
  } else {
    var this$2 = $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
    return this$2.addAll__sc_IterableOnce__scm_ArrayBuffer(coll);
  }
});
$c_scm_ArrayBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayBuffer$$anon$1();
});
$c_scm_ArrayBuffer$.prototype.resizeUp__I__I__I = (function(arrayLen, targetLen) {
  if ((targetLen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), ((((("Overflow while resizing array of array-backed collection. Requested length: " + targetLen) + "; current length: ") + arrayLen) + "; increase: ") + ((targetLen - arrayLen) | 0)));
  } else if ((targetLen <= arrayLen)) {
    return (-1);
  } else if ((targetLen > 2147483639)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), ((("Array of array-backed collection exceeds VM length limit of 2147483639. Requested length: " + targetLen) + "; current length: ") + arrayLen));
  } else if ((arrayLen > 1073741819)) {
    return 2147483639;
  } else {
    var x = (arrayLen << 1);
    var y = ((x > 16) ? x : 16);
    return ((targetLen > y) ? targetLen : y);
  }
});
$c_scm_ArrayBuffer$.prototype.scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO = (function(array, curSize, targetSize) {
  var newLen = this.resizeUp__I__I__I(array.u.length, targetSize);
  if ((newLen < 0)) {
    return array;
  } else {
    var res = new $ac_O(newLen);
    array.copyTo(0, res, 0, curSize);
    return res;
  }
});
$c_scm_ArrayBuffer$.prototype.empty__O = (function() {
  return $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer());
});
$c_scm_ArrayBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayBuffer(source);
});
var $d_scm_ArrayBuffer$ = new $TypeData().initClass($c_scm_ArrayBuffer$, "scala.collection.mutable.ArrayBuffer$", ({
  scm_ArrayBuffer$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArrayBuffer$ as $d_scm_ArrayBuffer$ };
var $n_scm_ArrayBuffer$;
function $m_scm_ArrayBuffer$() {
  if ((!$n_scm_ArrayBuffer$)) {
    $n_scm_ArrayBuffer$ = new $c_scm_ArrayBuffer$();
  }
  return $n_scm_ArrayBuffer$;
}
export { $m_scm_ArrayBuffer$ as $m_scm_ArrayBuffer$ };
/** @constructor */
function $c_scm_ArrayBuffer$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, ($m_scm_ArrayBuffer$(), $ct_scm_ArrayBuffer__(new $c_scm_ArrayBuffer())));
}
export { $c_scm_ArrayBuffer$$anon$1 as $c_scm_ArrayBuffer$$anon$1 };
$c_scm_ArrayBuffer$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayBuffer$$anon$1.prototype.constructor = $c_scm_ArrayBuffer$$anon$1;
/** @constructor */
function $h_scm_ArrayBuffer$$anon$1() {
}
export { $h_scm_ArrayBuffer$$anon$1 as $h_scm_ArrayBuffer$$anon$1 };
$h_scm_ArrayBuffer$$anon$1.prototype = $c_scm_ArrayBuffer$$anon$1.prototype;
$c_scm_ArrayBuffer$$anon$1.prototype.sizeHint__I__V = (function(size) {
  this.scm_GrowableBuilder__f_elems.sizeHint__I__V(size);
});
var $d_scm_ArrayBuffer$$anon$1 = new $TypeData().initClass($c_scm_ArrayBuffer$$anon$1, "scala.collection.mutable.ArrayBuffer$$anon$1", ({
  scm_ArrayBuffer$$anon$1: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_scm_ArrayBuffer$$anon$1 as $d_scm_ArrayBuffer$$anon$1 };
/** @constructor */
function $c_scm_ArrayDeque$() {
}
export { $c_scm_ArrayDeque$ as $c_scm_ArrayDeque$ };
$c_scm_ArrayDeque$.prototype = new $h_O();
$c_scm_ArrayDeque$.prototype.constructor = $c_scm_ArrayDeque$;
/** @constructor */
function $h_scm_ArrayDeque$() {
}
export { $h_scm_ArrayDeque$ as $h_scm_ArrayDeque$ };
$h_scm_ArrayDeque$.prototype = $c_scm_ArrayDeque$.prototype;
$c_scm_ArrayDeque$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__scm_ArrayDeque(elems);
});
$c_scm_ArrayDeque$.prototype.from__sc_IterableOnce__scm_ArrayDeque = (function(coll) {
  var s = coll.knownSize__I();
  if ((s >= 0)) {
    var array = this.alloc__I__AO(s);
    var actual = ($is_sc_Iterable(coll) ? coll.copyToArray__O__I__I__I(array, 0, 2147483647) : coll.iterator__sc_Iterator().copyToArray__O__I__I__I(array, 0, 2147483647));
    if ((actual !== s)) {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), ((("Copied " + actual) + " of ") + s));
    }
    return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), array, 0, s);
  } else {
    var this$2 = $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16);
    return this$2.addAll__sc_IterableOnce__scm_ArrayDeque(coll);
  }
});
$c_scm_ArrayDeque$.prototype.newBuilder__scm_Builder = (function() {
  return new $c_scm_ArrayDeque$$anon$1();
});
$c_scm_ArrayDeque$.prototype.alloc__I__AO = (function(len) {
  var requirement = (len >= 0);
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Non-negative array size required");
  }
  var size = ((((-2147483648) >>> Math.clz32(len)) | 0) << 1);
  var requirement$1 = (size >= 0);
  if ((!requirement$1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "ArrayDeque too big - cannot allocate ArrayDeque of length ") + len));
  }
  return new $ac_O(((size > 16) ? size : 16));
});
$c_scm_ArrayDeque$.prototype.empty__O = (function() {
  return $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16);
});
$c_scm_ArrayDeque$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__scm_ArrayDeque(source);
});
var $d_scm_ArrayDeque$ = new $TypeData().initClass($c_scm_ArrayDeque$, "scala.collection.mutable.ArrayDeque$", ({
  scm_ArrayDeque$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArrayDeque$ as $d_scm_ArrayDeque$ };
var $n_scm_ArrayDeque$;
function $m_scm_ArrayDeque$() {
  if ((!$n_scm_ArrayDeque$)) {
    $n_scm_ArrayDeque$ = new $c_scm_ArrayDeque$();
  }
  return $n_scm_ArrayDeque$;
}
export { $m_scm_ArrayDeque$ as $m_scm_ArrayDeque$ };
/** @constructor */
function $c_scm_ArrayDeque$$anon$1() {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_ArrayDeque__I__(new $c_scm_ArrayDeque(), 16));
}
export { $c_scm_ArrayDeque$$anon$1 as $c_scm_ArrayDeque$$anon$1 };
$c_scm_ArrayDeque$$anon$1.prototype = new $h_scm_GrowableBuilder();
$c_scm_ArrayDeque$$anon$1.prototype.constructor = $c_scm_ArrayDeque$$anon$1;
/** @constructor */
function $h_scm_ArrayDeque$$anon$1() {
}
export { $h_scm_ArrayDeque$$anon$1 as $h_scm_ArrayDeque$$anon$1 };
$h_scm_ArrayDeque$$anon$1.prototype = $c_scm_ArrayDeque$$anon$1.prototype;
$c_scm_ArrayDeque$$anon$1.prototype.sizeHint__I__V = (function(size) {
  var this$1 = this.scm_GrowableBuilder__f_elems;
  var idx = this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  if (((size > (((this$1.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this$1.scm_ArrayDeque__f_array.u.length) | 0))) && (size >= this$1.scm_ArrayDeque__f_array.u.length))) {
    this$1.scala$collection$mutable$ArrayDeque$$resize__I__V(size);
  }
});
var $d_scm_ArrayDeque$$anon$1 = new $TypeData().initClass($c_scm_ArrayDeque$$anon$1, "scala.collection.mutable.ArrayDeque$$anon$1", ({
  scm_ArrayDeque$$anon$1: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_scm_ArrayDeque$$anon$1 as $d_scm_ArrayDeque$$anon$1 };
/** @constructor */
function $c_scm_Buffer$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_sjs_js_WrappedArray$());
}
export { $c_scm_Buffer$ as $c_scm_Buffer$ };
$c_scm_Buffer$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_Buffer$.prototype.constructor = $c_scm_Buffer$;
/** @constructor */
function $h_scm_Buffer$() {
}
export { $h_scm_Buffer$ as $h_scm_Buffer$ };
$h_scm_Buffer$.prototype = $c_scm_Buffer$.prototype;
var $d_scm_Buffer$ = new $TypeData().initClass($c_scm_Buffer$, "scala.collection.mutable.Buffer$", ({
  scm_Buffer$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_Buffer$ as $d_scm_Buffer$ };
var $n_scm_Buffer$;
function $m_scm_Buffer$() {
  if ((!$n_scm_Buffer$)) {
    $n_scm_Buffer$ = new $c_scm_Buffer$();
  }
  return $n_scm_Buffer$;
}
export { $m_scm_Buffer$ as $m_scm_Buffer$ };
/** @constructor */
function $c_scm_HashMap$$anon$6(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashMap__I__D__(new $c_scm_HashMap(), initialCapacity$1, loadFactor$1));
}
export { $c_scm_HashMap$$anon$6 as $c_scm_HashMap$$anon$6 };
$c_scm_HashMap$$anon$6.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashMap$$anon$6.prototype.constructor = $c_scm_HashMap$$anon$6;
/** @constructor */
function $h_scm_HashMap$$anon$6() {
}
export { $h_scm_HashMap$$anon$6 as $h_scm_HashMap$$anon$6 };
$h_scm_HashMap$$anon$6.prototype = $c_scm_HashMap$$anon$6.prototype;
$c_scm_HashMap$$anon$6.prototype.sizeHint__I__V = (function(size) {
  this.scm_GrowableBuilder__f_elems.sizeHint__I__V(size);
});
var $d_scm_HashMap$$anon$6 = new $TypeData().initClass($c_scm_HashMap$$anon$6, "scala.collection.mutable.HashMap$$anon$6", ({
  scm_HashMap$$anon$6: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_scm_HashMap$$anon$6 as $d_scm_HashMap$$anon$6 };
function $ct_scm_HashMap$HashMapIterator__scm_HashMap__($thiz, outer) {
  $thiz.scm_HashMap$HashMapIterator__f_$outer = outer;
  $thiz.scm_HashMap$HashMapIterator__f_i = 0;
  $thiz.scm_HashMap$HashMapIterator__f_node = null;
  $thiz.scm_HashMap$HashMapIterator__f_len = outer.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  return $thiz;
}
export { $ct_scm_HashMap$HashMapIterator__scm_HashMap__ as $ct_scm_HashMap$HashMapIterator__scm_HashMap__ };
/** @constructor */
function $c_scm_HashMap$HashMapIterator() {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
}
export { $c_scm_HashMap$HashMapIterator as $c_scm_HashMap$HashMapIterator };
$c_scm_HashMap$HashMapIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashMap$HashMapIterator.prototype.constructor = $c_scm_HashMap$HashMapIterator;
/** @constructor */
function $h_scm_HashMap$HashMapIterator() {
}
export { $h_scm_HashMap$HashMapIterator as $h_scm_HashMap$HashMapIterator };
$h_scm_HashMap$HashMapIterator.prototype = $c_scm_HashMap$HashMapIterator.prototype;
$c_scm_HashMap$HashMapIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashMap$HashMapIterator__f_node !== null)) {
    return true;
  } else {
    while ((this.scm_HashMap$HashMapIterator__f_i < this.scm_HashMap$HashMapIterator__f_len)) {
      var n = this.scm_HashMap$HashMapIterator__f_$outer.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[this.scm_HashMap$HashMapIterator__f_i];
      this.scm_HashMap$HashMapIterator__f_i = ((1 + this.scm_HashMap$HashMapIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashMap$HashMapIterator__f_node = n;
        return true;
      }
    }
    return false;
  }
});
$c_scm_HashMap$HashMapIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  } else {
    var r = this.extract__scm_HashMap$Node__O(this.scm_HashMap$HashMapIterator__f_node);
    this.scm_HashMap$HashMapIterator__f_node = this.scm_HashMap$HashMapIterator__f_node.scm_HashMap$Node__f__next;
    return r;
  }
});
/** @constructor */
function $c_scm_HashSet$$anon$4(initialCapacity$1, loadFactor$1) {
  this.scm_GrowableBuilder__f_elems = null;
  $ct_scm_GrowableBuilder__scm_Growable__(this, $ct_scm_HashSet__I__D__(new $c_scm_HashSet(), initialCapacity$1, loadFactor$1));
}
export { $c_scm_HashSet$$anon$4 as $c_scm_HashSet$$anon$4 };
$c_scm_HashSet$$anon$4.prototype = new $h_scm_GrowableBuilder();
$c_scm_HashSet$$anon$4.prototype.constructor = $c_scm_HashSet$$anon$4;
/** @constructor */
function $h_scm_HashSet$$anon$4() {
}
export { $h_scm_HashSet$$anon$4 as $h_scm_HashSet$$anon$4 };
$h_scm_HashSet$$anon$4.prototype = $c_scm_HashSet$$anon$4.prototype;
$c_scm_HashSet$$anon$4.prototype.sizeHint__I__V = (function(size) {
  this.scm_GrowableBuilder__f_elems.sizeHint__I__V(size);
});
var $d_scm_HashSet$$anon$4 = new $TypeData().initClass($c_scm_HashSet$$anon$4, "scala.collection.mutable.HashSet$$anon$4", ({
  scm_HashSet$$anon$4: 1,
  scm_GrowableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_scm_HashSet$$anon$4 as $d_scm_HashSet$$anon$4 };
function $ct_scm_HashSet$HashSetIterator__scm_HashSet__($thiz, outer) {
  $thiz.scm_HashSet$HashSetIterator__f_$outer = outer;
  $thiz.scm_HashSet$HashSetIterator__f_i = 0;
  $thiz.scm_HashSet$HashSetIterator__f_node = null;
  $thiz.scm_HashSet$HashSetIterator__f_len = outer.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length;
  return $thiz;
}
export { $ct_scm_HashSet$HashSetIterator__scm_HashSet__ as $ct_scm_HashSet$HashSetIterator__scm_HashSet__ };
/** @constructor */
function $c_scm_HashSet$HashSetIterator() {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
}
export { $c_scm_HashSet$HashSetIterator as $c_scm_HashSet$HashSetIterator };
$c_scm_HashSet$HashSetIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_HashSet$HashSetIterator.prototype.constructor = $c_scm_HashSet$HashSetIterator;
/** @constructor */
function $h_scm_HashSet$HashSetIterator() {
}
export { $h_scm_HashSet$HashSetIterator as $h_scm_HashSet$HashSetIterator };
$h_scm_HashSet$HashSetIterator.prototype = $c_scm_HashSet$HashSetIterator.prototype;
$c_scm_HashSet$HashSetIterator.prototype.hasNext__Z = (function() {
  if ((this.scm_HashSet$HashSetIterator__f_node !== null)) {
    return true;
  } else {
    while ((this.scm_HashSet$HashSetIterator__f_i < this.scm_HashSet$HashSetIterator__f_len)) {
      var n = this.scm_HashSet$HashSetIterator__f_$outer.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u[this.scm_HashSet$HashSetIterator__f_i];
      this.scm_HashSet$HashSetIterator__f_i = ((1 + this.scm_HashSet$HashSetIterator__f_i) | 0);
      if ((n !== null)) {
        this.scm_HashSet$HashSetIterator__f_node = n;
        return true;
      }
    }
    return false;
  }
});
$c_scm_HashSet$HashSetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  } else {
    var r = this.extract__scm_HashSet$Node__O(this.scm_HashSet$HashSetIterator__f_node);
    this.scm_HashSet$HashSetIterator__f_node = this.scm_HashSet$HashSetIterator__f_node.scm_HashSet$Node__f__next;
    return r;
  }
});
function $ct_scm_ImmutableBuilder__sc_IterableOnce__($thiz, empty) {
  $thiz.scm_ImmutableBuilder__f_elems = empty;
  return $thiz;
}
export { $ct_scm_ImmutableBuilder__sc_IterableOnce__ as $ct_scm_ImmutableBuilder__sc_IterableOnce__ };
/** @constructor */
function $c_scm_ImmutableBuilder() {
  this.scm_ImmutableBuilder__f_elems = null;
}
export { $c_scm_ImmutableBuilder as $c_scm_ImmutableBuilder };
$c_scm_ImmutableBuilder.prototype = new $h_O();
$c_scm_ImmutableBuilder.prototype.constructor = $c_scm_ImmutableBuilder;
/** @constructor */
function $h_scm_ImmutableBuilder() {
}
export { $h_scm_ImmutableBuilder as $h_scm_ImmutableBuilder };
$h_scm_ImmutableBuilder.prototype = $c_scm_ImmutableBuilder.prototype;
$c_scm_ImmutableBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_ImmutableBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_ImmutableBuilder.prototype.result__O = (function() {
  return this.scm_ImmutableBuilder__f_elems;
});
/** @constructor */
function $c_scm_IndexedSeq$() {
  this.sc_SeqFactory$Delegate__f_delegate = null;
  $ct_sc_SeqFactory$Delegate__sc_SeqFactory__(this, $m_scm_ArrayBuffer$());
}
export { $c_scm_IndexedSeq$ as $c_scm_IndexedSeq$ };
$c_scm_IndexedSeq$.prototype = new $h_sc_SeqFactory$Delegate();
$c_scm_IndexedSeq$.prototype.constructor = $c_scm_IndexedSeq$;
/** @constructor */
function $h_scm_IndexedSeq$() {
}
export { $h_scm_IndexedSeq$ as $h_scm_IndexedSeq$ };
$h_scm_IndexedSeq$.prototype = $c_scm_IndexedSeq$.prototype;
var $d_scm_IndexedSeq$ = new $TypeData().initClass($c_scm_IndexedSeq$, "scala.collection.mutable.IndexedSeq$", ({
  scm_IndexedSeq$: 1,
  sc_SeqFactory$Delegate: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_IndexedSeq$ as $d_scm_IndexedSeq$ };
var $n_scm_IndexedSeq$;
function $m_scm_IndexedSeq$() {
  if ((!$n_scm_IndexedSeq$)) {
    $n_scm_IndexedSeq$ = new $c_scm_IndexedSeq$();
  }
  return $n_scm_IndexedSeq$;
}
export { $m_scm_IndexedSeq$ as $m_scm_IndexedSeq$ };
function $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__($thiz, outer) {
  $thiz.scm_LinkedHashMap$LinkedHashMapIterator__f_cur = outer.scm_LinkedHashMap__f_firstEntry;
  return $thiz;
}
export { $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__ as $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__ };
/** @constructor */
function $c_scm_LinkedHashMap$LinkedHashMapIterator() {
  this.scm_LinkedHashMap$LinkedHashMapIterator__f_cur = null;
}
export { $c_scm_LinkedHashMap$LinkedHashMapIterator as $c_scm_LinkedHashMap$LinkedHashMapIterator };
$c_scm_LinkedHashMap$LinkedHashMapIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_LinkedHashMap$LinkedHashMapIterator.prototype.constructor = $c_scm_LinkedHashMap$LinkedHashMapIterator;
/** @constructor */
function $h_scm_LinkedHashMap$LinkedHashMapIterator() {
}
export { $h_scm_LinkedHashMap$LinkedHashMapIterator as $h_scm_LinkedHashMap$LinkedHashMapIterator };
$h_scm_LinkedHashMap$LinkedHashMapIterator.prototype = $c_scm_LinkedHashMap$LinkedHashMapIterator.prototype;
$c_scm_LinkedHashMap$LinkedHashMapIterator.prototype.hasNext__Z = (function() {
  return (this.scm_LinkedHashMap$LinkedHashMapIterator__f_cur !== null);
});
$c_scm_LinkedHashMap$LinkedHashMapIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var r = this.extract__scm_LinkedHashMap$LinkedEntry__O(this.scm_LinkedHashMap$LinkedHashMapIterator__f_cur);
    this.scm_LinkedHashMap$LinkedHashMapIterator__f_cur = this.scm_LinkedHashMap$LinkedHashMapIterator__f_cur.scm_LinkedHashMap$LinkedEntry__f_later;
    return r;
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
function $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__($thiz, outer) {
  $thiz.scm_LinkedHashSet$LinkedHashSetIterator__f_cur = outer.scm_LinkedHashSet__f_firstEntry;
  return $thiz;
}
export { $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__ as $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__ };
/** @constructor */
function $c_scm_LinkedHashSet$LinkedHashSetIterator() {
  this.scm_LinkedHashSet$LinkedHashSetIterator__f_cur = null;
}
export { $c_scm_LinkedHashSet$LinkedHashSetIterator as $c_scm_LinkedHashSet$LinkedHashSetIterator };
$c_scm_LinkedHashSet$LinkedHashSetIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_LinkedHashSet$LinkedHashSetIterator.prototype.constructor = $c_scm_LinkedHashSet$LinkedHashSetIterator;
/** @constructor */
function $h_scm_LinkedHashSet$LinkedHashSetIterator() {
}
export { $h_scm_LinkedHashSet$LinkedHashSetIterator as $h_scm_LinkedHashSet$LinkedHashSetIterator };
$h_scm_LinkedHashSet$LinkedHashSetIterator.prototype = $c_scm_LinkedHashSet$LinkedHashSetIterator.prototype;
$c_scm_LinkedHashSet$LinkedHashSetIterator.prototype.hasNext__Z = (function() {
  return (this.scm_LinkedHashSet$LinkedHashSetIterator__f_cur !== null);
});
$c_scm_LinkedHashSet$LinkedHashSetIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var r = this.extract__scm_LinkedHashSet$Entry__O(this.scm_LinkedHashSet$LinkedHashSetIterator__f_cur);
    this.scm_LinkedHashSet$LinkedHashSetIterator__f_cur = this.scm_LinkedHashSet$LinkedHashSetIterator__f_cur.scm_LinkedHashSet$Entry__f_later;
    return r;
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
/** @constructor */
function $c_scm_ListBuffer$() {
}
export { $c_scm_ListBuffer$ as $c_scm_ListBuffer$ };
$c_scm_ListBuffer$.prototype = new $h_O();
$c_scm_ListBuffer$.prototype.constructor = $c_scm_ListBuffer$;
/** @constructor */
function $h_scm_ListBuffer$() {
}
export { $h_scm_ListBuffer$ as $h_scm_ListBuffer$ };
$h_scm_ListBuffer$.prototype = $c_scm_ListBuffer$.prototype;
$c_scm_ListBuffer$.prototype.apply__sci_Seq__O = (function(elems) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(elems);
});
$c_scm_ListBuffer$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), new $c_scm_ListBuffer());
});
$c_scm_ListBuffer$.prototype.empty__O = (function() {
  return new $c_scm_ListBuffer();
});
$c_scm_ListBuffer$.prototype.from__sc_IterableOnce__O = (function(source) {
  return new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(source);
});
var $d_scm_ListBuffer$ = new $TypeData().initClass($c_scm_ListBuffer$, "scala.collection.mutable.ListBuffer$", ({
  scm_ListBuffer$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ListBuffer$ as $d_scm_ListBuffer$ };
var $n_scm_ListBuffer$;
function $m_scm_ListBuffer$() {
  if ((!$n_scm_ListBuffer$)) {
    $n_scm_ListBuffer$ = new $c_scm_ListBuffer$();
  }
  return $n_scm_ListBuffer$;
}
export { $m_scm_ListBuffer$ as $m_scm_ListBuffer$ };
/** @constructor */
function $c_scm_MutationTracker$CheckedIterator(underlying, mutationCount) {
  this.scm_MutationTracker$CheckedIterator__f_underlying = null;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = null;
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = 0;
  this.scm_MutationTracker$CheckedIterator__f_underlying = underlying;
  this.scm_MutationTracker$CheckedIterator__f_mutationCount = mutationCount;
  this.scm_MutationTracker$CheckedIterator__f_expectedCount = (mutationCount.apply__O() | 0);
}
export { $c_scm_MutationTracker$CheckedIterator as $c_scm_MutationTracker$CheckedIterator };
$c_scm_MutationTracker$CheckedIterator.prototype = new $h_sc_AbstractIterator();
$c_scm_MutationTracker$CheckedIterator.prototype.constructor = $c_scm_MutationTracker$CheckedIterator;
/** @constructor */
function $h_scm_MutationTracker$CheckedIterator() {
}
export { $h_scm_MutationTracker$CheckedIterator as $h_scm_MutationTracker$CheckedIterator };
$h_scm_MutationTracker$CheckedIterator.prototype = $c_scm_MutationTracker$CheckedIterator.prototype;
$c_scm_MutationTracker$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_MutationTracker$CheckedIterator__f_expectedCount;
  var this$1 = this.scm_MutationTracker$CheckedIterator__f_mutationCount;
  var actualCount = (this$1.apply__O() | 0);
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return this.scm_MutationTracker$CheckedIterator__f_underlying.hasNext__Z();
});
$c_scm_MutationTracker$CheckedIterator.prototype.next__O = (function() {
  return this.scm_MutationTracker$CheckedIterator__f_underlying.next__O();
});
var $d_scm_MutationTracker$CheckedIterator = new $TypeData().initClass($c_scm_MutationTracker$CheckedIterator, "scala.collection.mutable.MutationTracker$CheckedIterator", ({
  scm_MutationTracker$CheckedIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_MutationTracker$CheckedIterator as $d_scm_MutationTracker$CheckedIterator };
/** @constructor */
function $c_scm_Queue$() {
}
export { $c_scm_Queue$ as $c_scm_Queue$ };
$c_scm_Queue$.prototype = new $h_O();
$c_scm_Queue$.prototype.constructor = $c_scm_Queue$;
/** @constructor */
function $h_scm_Queue$() {
}
export { $h_scm_Queue$ as $h_scm_Queue$ };
$h_scm_Queue$.prototype = $c_scm_Queue$.prototype;
$c_scm_Queue$.prototype.apply__sci_Seq__O = (function(elems) {
  var this$1 = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
  return this$1.addAll__sc_IterableOnce__scm_ArrayDeque(elems);
});
$c_scm_Queue$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_Queue__I__(new $c_scm_Queue(), 16));
});
$c_scm_Queue$.prototype.empty__O = (function() {
  return $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
});
$c_scm_Queue$.prototype.from__sc_IterableOnce__O = (function(source) {
  var this$1 = $ct_scm_Queue__I__(new $c_scm_Queue(), 16);
  return this$1.addAll__sc_IterableOnce__scm_ArrayDeque(source);
});
var $d_scm_Queue$ = new $TypeData().initClass($c_scm_Queue$, "scala.collection.mutable.Queue$", ({
  scm_Queue$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_Queue$ as $d_scm_Queue$ };
var $n_scm_Queue$;
function $m_scm_Queue$() {
  if ((!$n_scm_Queue$)) {
    $n_scm_Queue$ = new $c_scm_Queue$();
  }
  return $n_scm_Queue$;
}
export { $m_scm_Queue$ as $m_scm_Queue$ };
/** @constructor */
function $c_s_concurrent_duration_Duration$Infinite() {
}
export { $c_s_concurrent_duration_Duration$Infinite as $c_s_concurrent_duration_Duration$Infinite };
$c_s_concurrent_duration_Duration$Infinite.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_Duration$Infinite.prototype.constructor = $c_s_concurrent_duration_Duration$Infinite;
/** @constructor */
function $h_s_concurrent_duration_Duration$Infinite() {
}
export { $h_s_concurrent_duration_Duration$Infinite as $h_s_concurrent_duration_Duration$Infinite };
$h_s_concurrent_duration_Duration$Infinite.prototype = $c_s_concurrent_duration_Duration$Infinite.prototype;
$c_s_concurrent_duration_Duration$Infinite.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  if ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined)) {
    return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined;
  }
  if ((other instanceof $c_s_concurrent_duration_Duration$Infinite)) {
    if ((other !== this)) {
      return $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined;
    }
  }
  return this;
});
function $isArrayOf_s_concurrent_duration_Duration$Infinite(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_Duration$Infinite)));
}
export { $isArrayOf_s_concurrent_duration_Duration$Infinite as $isArrayOf_s_concurrent_duration_Duration$Infinite };
function $p_s_concurrent_duration_FiniteDuration__bounded__J__Z($thiz, max) {
  var blo = max.RTLong__f_lo;
  var lo = ((-blo) | 0);
  var hi = ((((-max.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
  var b = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  var bhi = b.RTLong__f_hi;
  if (((hi === bhi) ? ((lo >>> 0) <= (b.RTLong__f_lo >>> 0)) : (hi < bhi))) {
    var a = $thiz.s_concurrent_duration_FiniteDuration__f_length;
    var ahi = a.RTLong__f_hi;
    var bhi$1 = max.RTLong__f_hi;
    return ((ahi === bhi$1) ? ((a.RTLong__f_lo >>> 0) <= (max.RTLong__f_lo >>> 0)) : (ahi < bhi$1));
  } else {
    return false;
  }
}
export { $p_s_concurrent_duration_FiniteDuration__bounded__J__Z as $p_s_concurrent_duration_FiniteDuration__bounded__J__Z };
function $p_s_concurrent_duration_FiniteDuration__unitString__T($thiz) {
  var $x_1 = $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_timeUnitName.apply__O__O($thiz.s_concurrent_duration_FiniteDuration__f_unit);
  var a = $thiz.s_concurrent_duration_FiniteDuration__f_length;
  return ($x_1 + (((a.RTLong__f_lo === 1) && (a.RTLong__f_hi === 0)) ? "" : "s"));
}
export { $p_s_concurrent_duration_FiniteDuration__unitString__T as $p_s_concurrent_duration_FiniteDuration__unitString__T };
function $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, a, b) {
  var ahi = b.RTLong__f_hi;
  if (((ahi === 0) ? (b.RTLong__f_lo !== 0) : (ahi > 0))) {
    var blo = b.RTLong__f_lo;
    var lo = (((-1) - blo) | 0);
    var hi = ((((2147483647 - b.RTLong__f_hi) | 0) + ((blo & lo) >> 31)) | 0);
    var ahi$1 = a.RTLong__f_hi;
    var $x_2 = ((ahi$1 === hi) ? ((a.RTLong__f_lo >>> 0) > (lo >>> 0)) : (ahi$1 > hi));
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    var $x_1 = true;
  } else {
    var ahi$2 = b.RTLong__f_hi;
    if ((ahi$2 < 0)) {
      var blo$1 = b.RTLong__f_lo;
      var lo$1 = ((-blo$1) | 0);
      var hi$1 = (((((-2147483648) - b.RTLong__f_hi) | 0) + ((blo$1 | lo$1) >> 31)) | 0);
      var ahi$3 = a.RTLong__f_hi;
      var $x_1 = ((ahi$3 === hi$1) ? ((a.RTLong__f_lo >>> 0) < (lo$1 >>> 0)) : (ahi$3 < hi$1));
    } else {
      var $x_1 = false;
    }
  }
  if ($x_1) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "integer overflow");
  }
  var alo = a.RTLong__f_lo;
  var blo$2 = b.RTLong__f_lo;
  var lo$2 = ((alo + blo$2) | 0);
  var hi$2 = ((((a.RTLong__f_hi + b.RTLong__f_hi) | 0) + ((((alo & blo$2) | ((alo | blo$2) & (~lo$2))) >>> 31) | 0)) | 0);
  return new $c_RTLong(lo$2, hi$2);
}
export { $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J as $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J };
function $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration($thiz, otherLength, otherUnit) {
  var a = otherUnit.convert__J__ju_concurrent_TimeUnit__J(new $c_RTLong(1, 0), $thiz.s_concurrent_duration_FiniteDuration__f_unit);
  if (((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === 0))) {
    var commonUnit = $thiz.s_concurrent_duration_FiniteDuration__f_unit;
  } else {
    var commonUnit = otherUnit;
  }
  var t = $p_s_concurrent_duration_FiniteDuration__safeAdd__J__J__J($thiz, commonUnit.convert__J__ju_concurrent_TimeUnit__J($thiz.s_concurrent_duration_FiniteDuration__f_length, $thiz.s_concurrent_duration_FiniteDuration__f_unit), commonUnit.convert__J__ju_concurrent_TimeUnit__J(otherLength, otherUnit));
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_s_concurrent_duration_FiniteDuration(new $c_RTLong(lo, hi), commonUnit);
}
export { $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration as $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration };
function $p_s_concurrent_duration_FiniteDuration__safeMul__J__J__J($thiz, _a, _b) {
  var lo = _a.RTLong__f_lo;
  var hi = _a.RTLong__f_hi;
  var sign = (hi >> 31);
  var xlo = (lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((hi ^ sign) + (((xlo & (~rlo)) >>> 31) | 0)) | 0);
  var lo$1 = _b.RTLong__f_lo;
  var hi$1 = _b.RTLong__f_hi;
  var sign$1 = (hi$1 >> 31);
  var xlo$1 = (lo$1 ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((hi$1 ^ sign$1) + (((xlo$1 & (~rlo$1)) >>> 31) | 0)) | 0);
  if ((((((rhi !== 0) ? Math.clz32(rhi) : ((32 + Math.clz32(rlo)) | 0)) + ((rhi$1 !== 0) ? Math.clz32(rhi$1) : ((32 + Math.clz32(rlo$1)) | 0))) | 0) < 64)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "multiplication overflow");
  }
  var a0 = (65535 & rlo);
  var a1 = ((rlo >>> 16) | 0);
  var b0 = (65535 & rlo$1);
  var b1 = ((rlo$1 >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((((((((Math.imul(rlo, rhi$1) + Math.imul(rhi, rlo$1)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  if ((hi$2 < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "multiplication overflow");
  }
  if ((((rlo === _a.RTLong__f_lo) && (rhi === _a.RTLong__f_hi)) !== ((rlo$1 === _b.RTLong__f_lo) && (rhi$1 === _b.RTLong__f_hi)))) {
    var lo$3 = ((-lo$2) | 0);
    var hi$3 = ((((-hi$2) | 0) + ((lo$2 | lo$3) >> 31)) | 0);
    return new $c_RTLong(lo$3, hi$3);
  } else {
    return new $c_RTLong(lo$2, hi$2);
  }
}
export { $p_s_concurrent_duration_FiniteDuration__safeMul__J__J__J as $p_s_concurrent_duration_FiniteDuration__safeMul__J__J__J };
/** @constructor */
function $c_s_concurrent_duration_FiniteDuration(length, unit) {
  this.s_concurrent_duration_FiniteDuration__f_length = $L0;
  this.s_concurrent_duration_FiniteDuration__f_unit = null;
  this.s_concurrent_duration_FiniteDuration__f_length = length;
  this.s_concurrent_duration_FiniteDuration__f_unit = unit;
  var x = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS;
  if ((x === unit)) {
    var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1), 2147483647));
  } else {
    var x$3 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MICROSECONDS;
    if ((x$3 === unit)) {
      var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong((-1511828489), 2147483));
    } else {
      var x$5 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MILLISECONDS;
      if ((x$5 === unit)) {
        var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2077252342, 2147));
      } else {
        var x$7 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_SECONDS;
        if ((x$7 === unit)) {
          var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(633437444, 2));
        } else {
          var x$9 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_MINUTES;
          if ((x$9 === unit)) {
            var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(153722867, 0));
          } else {
            var x$11 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_HOURS;
            if ((x$11 === unit)) {
              var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(2562047, 0));
            } else {
              var x$13 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS;
              if ((x$13 === unit)) {
                var requirement = $p_s_concurrent_duration_FiniteDuration__bounded__J__Z(this, new $c_RTLong(106751, 0));
              } else {
                var t = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_DAYS.convert__J__ju_concurrent_TimeUnit__J(length, unit);
                var lo = t.RTLong__f_lo;
                var hi = t.RTLong__f_hi;
                var requirement = (((hi === (-1)) ? ((lo >>> 0) >= 4294860545) : (hi > (-1))) && ((hi === 0) ? ((lo >>> 0) <= 106751) : (hi < 0)));
              }
            }
          }
        }
      }
    }
  }
  if ((!requirement)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "requirement failed: Duration is limited to +-(2^63-1)ns (ca. 292 years)");
  }
}
export { $c_s_concurrent_duration_FiniteDuration as $c_s_concurrent_duration_FiniteDuration };
$c_s_concurrent_duration_FiniteDuration.prototype = new $h_s_concurrent_duration_Duration();
$c_s_concurrent_duration_FiniteDuration.prototype.constructor = $c_s_concurrent_duration_FiniteDuration;
/** @constructor */
function $h_s_concurrent_duration_FiniteDuration() {
}
export { $h_s_concurrent_duration_FiniteDuration as $h_s_concurrent_duration_FiniteDuration };
$h_s_concurrent_duration_FiniteDuration.prototype = $c_s_concurrent_duration_FiniteDuration.prototype;
$c_s_concurrent_duration_FiniteDuration.prototype.toUnit__ju_concurrent_TimeUnit__D = (function(u) {
  var a = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
  var lo = a.RTLong__f_lo;
  var hi = a.RTLong__f_hi;
  var a$1 = $m_ju_concurrent_TimeUnit$().ju_concurrent_TimeUnit$__f_NANOSECONDS.convert__J__ju_concurrent_TimeUnit__J(new $c_RTLong(1, 0), u);
  var lo$1 = a$1.RTLong__f_lo;
  var hi$1 = a$1.RTLong__f_hi;
  return (((4.294967296E9 * hi) + (lo >>> 0.0)) / ((4.294967296E9 * hi$1) + (lo$1 >>> 0.0)));
});
$c_s_concurrent_duration_FiniteDuration.prototype.toString__T = (function() {
  return ((this.s_concurrent_duration_FiniteDuration__f_length + " ") + $p_s_concurrent_duration_FiniteDuration__unitString__T(this));
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var t = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$2 = new $c_sr_RichLong(new $c_RTLong(lo, hi));
    var t$1 = other.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(other.s_concurrent_duration_FiniteDuration__f_length);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var t$3 = this$2.sr_RichLong__f_self;
    var lo$3 = t$3.RTLong__f_lo;
    var hi$3 = t$3.RTLong__f_hi;
    return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$3, hi$3, lo$1, hi$1);
  } else {
    return ((-other.compare__s_concurrent_duration_Duration__I(this)) | 0);
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  return ((other instanceof $c_s_concurrent_duration_FiniteDuration) ? $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this, other.s_concurrent_duration_FiniteDuration__f_length, other.s_concurrent_duration_FiniteDuration__f_unit) : other);
});
$c_s_concurrent_duration_FiniteDuration.prototype.$minus__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration = (function(other) {
  var b = other.s_concurrent_duration_FiniteDuration__f_length;
  var blo = b.RTLong__f_lo;
  var lo = ((-blo) | 0);
  var hi = ((((-b.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
  return $p_s_concurrent_duration_FiniteDuration__add__J__ju_concurrent_TimeUnit__s_concurrent_duration_FiniteDuration(this, new $c_RTLong(lo, hi), other.s_concurrent_duration_FiniteDuration__f_unit);
});
$c_s_concurrent_duration_FiniteDuration.prototype.max__s_concurrent_duration_FiniteDuration__s_concurrent_duration_FiniteDuration = (function(other) {
  return ($f_s_math_Ordered__$greater__O__Z(this, other) ? this : other);
});
$c_s_concurrent_duration_FiniteDuration.prototype.$times__J__s_concurrent_duration_FiniteDuration = (function(factor) {
  return new $c_s_concurrent_duration_FiniteDuration($p_s_concurrent_duration_FiniteDuration__safeMul__J__J__J(this, this.s_concurrent_duration_FiniteDuration__f_length, factor), this.s_concurrent_duration_FiniteDuration__f_unit);
});
$c_s_concurrent_duration_FiniteDuration.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_s_concurrent_duration_FiniteDuration)) {
    var a = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
    var b = other.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(other.s_concurrent_duration_FiniteDuration__f_length);
    return ((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi));
  } else {
    return (this === other);
  }
});
$c_s_concurrent_duration_FiniteDuration.prototype.hashCode__I = (function() {
  var a = this.s_concurrent_duration_FiniteDuration__f_unit.toNanos__J__J(this.s_concurrent_duration_FiniteDuration__f_length);
  return a.RTLong__f_lo;
});
$c_s_concurrent_duration_FiniteDuration.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I(that);
});
function $isArrayOf_s_concurrent_duration_FiniteDuration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_concurrent_duration_FiniteDuration)));
}
export { $isArrayOf_s_concurrent_duration_FiniteDuration as $isArrayOf_s_concurrent_duration_FiniteDuration };
var $d_s_concurrent_duration_FiniteDuration = new $TypeData().initClass($c_s_concurrent_duration_FiniteDuration, "scala.concurrent.duration.FiniteDuration", ({
  s_concurrent_duration_FiniteDuration: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
export { $d_s_concurrent_duration_FiniteDuration as $d_s_concurrent_duration_FiniteDuration };
function $f_s_math_Ordering__lteq__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) <= 0);
}
export { $f_s_math_Ordering__lteq__O__O__Z as $f_s_math_Ordering__lteq__O__O__Z };
function $f_s_math_Ordering__gteq__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) >= 0);
}
export { $f_s_math_Ordering__gteq__O__O__Z as $f_s_math_Ordering__gteq__O__O__Z };
function $f_s_math_Ordering__lt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) < 0);
}
export { $f_s_math_Ordering__lt__O__O__Z as $f_s_math_Ordering__lt__O__O__Z };
function $f_s_math_Ordering__gt__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) > 0);
}
export { $f_s_math_Ordering__gt__O__O__Z as $f_s_math_Ordering__gt__O__O__Z };
function $f_s_math_Ordering__equiv__O__O__Z($thiz, x, y) {
  return ($thiz.compare__O__O__I(x, y) === 0);
}
export { $f_s_math_Ordering__equiv__O__O__Z as $f_s_math_Ordering__equiv__O__O__Z };
function $f_s_math_Ordering__max__O__O__O($thiz, x, y) {
  return ($thiz.gteq__O__O__Z(x, y) ? x : y);
}
export { $f_s_math_Ordering__max__O__O__O as $f_s_math_Ordering__max__O__O__O };
function $f_s_math_Ordering__min__O__O__O($thiz, x, y) {
  return ($thiz.lteq__O__O__Z(x, y) ? x : y);
}
export { $f_s_math_Ordering__min__O__O__O as $f_s_math_Ordering__min__O__O__O };
function $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z($thiz, other) {
  if ((other instanceof $c_s_math_Ordering$Reverse)) {
    var x = other.s_math_Ordering$Reverse__f_outer;
    return ((x !== null) && x.equals__O__Z($thiz));
  } else {
    return false;
  }
}
export { $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z as $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z };
function $f_s_reflect_ClassTag__unapply__O__s_Option($thiz, x) {
  var this$1 = $thiz.runtimeClass__jl_Class();
  if (this$1.data.isInstance(x)) {
    return new $c_s_Some(x);
  } else {
    return $m_s_None$();
  }
}
export { $f_s_reflect_ClassTag__unapply__O__s_Option as $f_s_reflect_ClassTag__unapply__O__s_Option };
function $f_s_reflect_ClassTag__equals__O__Z($thiz, x) {
  if ($is_s_reflect_ClassTag(x)) {
    var x$2 = $thiz.runtimeClass__jl_Class();
    var x$3 = x.runtimeClass__jl_Class();
    return (x$2 === x$3);
  } else {
    return false;
  }
}
export { $f_s_reflect_ClassTag__equals__O__Z as $f_s_reflect_ClassTag__equals__O__Z };
function $ps_s_reflect_ClassTag__prettyprint$1__jl_Class__T(clazz) {
  return (clazz.data.isArrayClass ? (("Array[" + $ps_s_reflect_ClassTag__prettyprint$1__jl_Class__T(clazz.data.getComponentType())) + "]") : clazz.data.name);
}
export { $ps_s_reflect_ClassTag__prettyprint$1__jl_Class__T as $ps_s_reflect_ClassTag__prettyprint$1__jl_Class__T };
function $is_s_reflect_ClassTag(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_reflect_ClassTag)));
}
export { $is_s_reflect_ClassTag as $is_s_reflect_ClassTag };
function $isArrayOf_s_reflect_ClassTag(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_reflect_ClassTag)));
}
export { $isArrayOf_s_reflect_ClassTag as $isArrayOf_s_reflect_ClassTag };
/** @constructor */
function $c_sr_ScalaRunTime$$anon$1(x$2) {
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = 0;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = null;
  this.sr_ScalaRunTime$$anon$1__f_x$2 = x$2;
  this.sr_ScalaRunTime$$anon$1__f_c = 0;
  this.sr_ScalaRunTime$$anon$1__f_cmax = x$2.productArity__I();
}
export { $c_sr_ScalaRunTime$$anon$1 as $c_sr_ScalaRunTime$$anon$1 };
$c_sr_ScalaRunTime$$anon$1.prototype = new $h_sc_AbstractIterator();
$c_sr_ScalaRunTime$$anon$1.prototype.constructor = $c_sr_ScalaRunTime$$anon$1;
/** @constructor */
function $h_sr_ScalaRunTime$$anon$1() {
}
export { $h_sr_ScalaRunTime$$anon$1 as $h_sr_ScalaRunTime$$anon$1 };
$h_sr_ScalaRunTime$$anon$1.prototype = $c_sr_ScalaRunTime$$anon$1.prototype;
$c_sr_ScalaRunTime$$anon$1.prototype.hasNext__Z = (function() {
  return (this.sr_ScalaRunTime$$anon$1__f_c < this.sr_ScalaRunTime$$anon$1__f_cmax);
});
$c_sr_ScalaRunTime$$anon$1.prototype.next__O = (function() {
  var result = this.sr_ScalaRunTime$$anon$1__f_x$2.productElement__I__O(this.sr_ScalaRunTime$$anon$1__f_c);
  this.sr_ScalaRunTime$$anon$1__f_c = ((1 + this.sr_ScalaRunTime$$anon$1__f_c) | 0);
  return result;
});
var $d_sr_ScalaRunTime$$anon$1 = new $TypeData().initClass($c_sr_ScalaRunTime$$anon$1, "scala.runtime.ScalaRunTime$$anon$1", ({
  sr_ScalaRunTime$$anon$1: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sr_ScalaRunTime$$anon$1 as $d_sr_ScalaRunTime$$anon$1 };
/** @constructor */
function $c_sjs_js_WrappedArray$() {
}
export { $c_sjs_js_WrappedArray$ as $c_sjs_js_WrappedArray$ };
$c_sjs_js_WrappedArray$.prototype = new $h_O();
$c_sjs_js_WrappedArray$.prototype.constructor = $c_sjs_js_WrappedArray$;
/** @constructor */
function $h_sjs_js_WrappedArray$() {
}
export { $h_sjs_js_WrappedArray$ as $h_sjs_js_WrappedArray$ };
$h_sjs_js_WrappedArray$.prototype = $c_sjs_js_WrappedArray$.prototype;
$c_sjs_js_WrappedArray$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(elems);
});
$c_sjs_js_WrappedArray$.prototype.newBuilder__scm_Builder = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__sjs_js_WrappedArray = (function(source) {
  var this$1 = $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this$1, source).result__O();
});
$c_sjs_js_WrappedArray$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjs_js_WrappedArray(source);
});
$c_sjs_js_WrappedArray$.prototype.empty__O = (function() {
  return $ct_sjs_js_WrappedArray__(new $c_sjs_js_WrappedArray());
});
var $d_sjs_js_WrappedArray$ = new $TypeData().initClass($c_sjs_js_WrappedArray$, "scala.scalajs.js.WrappedArray$", ({
  sjs_js_WrappedArray$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sjs_js_WrappedArray$ as $d_sjs_js_WrappedArray$ };
var $n_sjs_js_WrappedArray$;
function $m_sjs_js_WrappedArray$() {
  if ((!$n_sjs_js_WrappedArray$)) {
    $n_sjs_js_WrappedArray$ = new $c_sjs_js_WrappedArray$();
  }
  return $n_sjs_js_WrappedArray$;
}
export { $m_sjs_js_WrappedArray$ as $m_sjs_js_WrappedArray$ };
/** @constructor */
function $c_sjsr_WrappedVarArgs$() {
}
export { $c_sjsr_WrappedVarArgs$ as $c_sjsr_WrappedVarArgs$ };
$c_sjsr_WrappedVarArgs$.prototype = new $h_O();
$c_sjsr_WrappedVarArgs$.prototype.constructor = $c_sjsr_WrappedVarArgs$;
/** @constructor */
function $h_sjsr_WrappedVarArgs$() {
}
export { $h_sjsr_WrappedVarArgs$ as $h_sjsr_WrappedVarArgs$ };
$h_sjsr_WrappedVarArgs$.prototype = $c_sjsr_WrappedVarArgs$.prototype;
$c_sjsr_WrappedVarArgs$.prototype.apply__sci_Seq__O = (function(elems) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(elems);
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__sjsr_WrappedVarArgs = (function(source) {
  var this$1 = this.newBuilder__scm_Builder();
  return this$1.addAll__sc_IterableOnce__scm_Growable(source).result__O();
});
$c_sjsr_WrappedVarArgs$.prototype.newBuilder__scm_Builder = (function() {
  var array = [];
  var this$3 = $ct_sjs_js_WrappedArray__sjs_js_Array__(new $c_sjs_js_WrappedArray(), array);
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2$2) => $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), x$1$2$2.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array)));
  return new $c_scm_Builder$$anon$1(this$3, f);
});
$c_sjsr_WrappedVarArgs$.prototype.from__sc_IterableOnce__O = (function(source) {
  return this.from__sc_IterableOnce__sjsr_WrappedVarArgs(source);
});
$c_sjsr_WrappedVarArgs$.prototype.empty__O = (function() {
  return $ct_sjsr_WrappedVarArgs__(new $c_sjsr_WrappedVarArgs());
});
var $d_sjsr_WrappedVarArgs$ = new $TypeData().initClass($c_sjsr_WrappedVarArgs$, "scala.scalajs.runtime.WrappedVarArgs$", ({
  sjsr_WrappedVarArgs$: 1,
  sc_StrictOptimizedSeqFactory: 1,
  sc_SeqFactory: 1,
  sc_IterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sjsr_WrappedVarArgs$ as $d_sjsr_WrappedVarArgs$ };
var $n_sjsr_WrappedVarArgs$;
function $m_sjsr_WrappedVarArgs$() {
  if ((!$n_sjsr_WrappedVarArgs$)) {
    $n_sjsr_WrappedVarArgs$ = new $c_sjsr_WrappedVarArgs$();
  }
  return $n_sjsr_WrappedVarArgs$;
}
export { $m_sjsr_WrappedVarArgs$ as $m_sjsr_WrappedVarArgs$ };
/** @constructor */
function $c_s_util_Failure(exception) {
  this.s_util_Failure__f_exception = null;
  this.s_util_Failure__f_exception = exception;
}
export { $c_s_util_Failure as $c_s_util_Failure };
$c_s_util_Failure.prototype = new $h_s_util_Try();
$c_s_util_Failure.prototype.constructor = $c_s_util_Failure;
/** @constructor */
function $h_s_util_Failure() {
}
export { $h_s_util_Failure as $h_s_util_Failure };
$h_s_util_Failure.prototype = $c_s_util_Failure.prototype;
$c_s_util_Failure.prototype.isFailure__Z = (function() {
  return true;
});
$c_s_util_Failure.prototype.isSuccess__Z = (function() {
  return false;
});
$c_s_util_Failure.prototype.get__O = (function() {
  var $x_1 = this.s_util_Failure__f_exception;
  throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
});
$c_s_util_Failure.prototype.getOrElse__F0__O = (function(default$1) {
  return default$1.apply__O();
});
$c_s_util_Failure.prototype.orElse__F0__s_util_Try = (function(default$1) {
  try {
    return default$1.apply__O();
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
$c_s_util_Failure.prototype.flatMap__F1__s_util_Try = (function(f) {
  return this;
});
$c_s_util_Failure.prototype.foreach__F1__V = (function(f) {
});
$c_s_util_Failure.prototype.map__F1__s_util_Try = (function(f) {
  return this;
});
$c_s_util_Failure.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  var marker = $m_sr_Statics$PFMarker$();
  try {
    var v = pf.applyOrElse__O__F1__O(this.s_util_Failure__f_exception, new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => marker)));
    return ((marker !== v) ? new $c_s_util_Success(v) : this);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
$c_s_util_Failure.prototype.toOption__s_Option = (function() {
  return $m_s_None$();
});
$c_s_util_Failure.prototype.toEither__s_util_Either = (function() {
  return new $c_s_util_Left(this.s_util_Failure__f_exception);
});
$c_s_util_Failure.prototype.fold__F1__F1__O = (function(fa, fb) {
  return fa.apply__O__O(this.s_util_Failure__f_exception);
});
$c_s_util_Failure.prototype.productPrefix__T = (function() {
  return "Failure";
});
$c_s_util_Failure.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Failure.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Failure__f_exception : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Failure.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Failure.prototype.productElementName__I__T = (function(x$1) {
  return ((x$1 === 0) ? "exception" : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Failure.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1408943127), true);
});
$c_s_util_Failure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Failure.prototype.equals__O__Z = (function(x$1) {
  if ((this === x$1)) {
    return true;
  } else if ((x$1 instanceof $c_s_util_Failure)) {
    var x = this.s_util_Failure__f_exception;
    var x$2 = x$1.s_util_Failure__f_exception;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
function $isArrayOf_s_util_Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Failure)));
}
export { $isArrayOf_s_util_Failure as $isArrayOf_s_util_Failure };
var $d_s_util_Failure = new $TypeData().initClass($c_s_util_Failure, "scala.util.Failure", ({
  s_util_Failure: 1,
  s_util_Try: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_Failure as $d_s_util_Failure };
/** @constructor */
function $c_s_util_Left(value) {
  this.s_util_Left__f_value = null;
  this.s_util_Left__f_value = value;
}
export { $c_s_util_Left as $c_s_util_Left };
$c_s_util_Left.prototype = new $h_s_util_Either();
$c_s_util_Left.prototype.constructor = $c_s_util_Left;
/** @constructor */
function $h_s_util_Left() {
}
export { $h_s_util_Left as $h_s_util_Left };
$h_s_util_Left.prototype = $c_s_util_Left.prototype;
$c_s_util_Left.prototype.isLeft__Z = (function() {
  return true;
});
$c_s_util_Left.prototype.isRight__Z = (function() {
  return false;
});
$c_s_util_Left.prototype.productPrefix__T = (function() {
  return "Left";
});
$c_s_util_Left.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Left.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Left__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Left.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Left.prototype.productElementName__I__T = (function(x$1) {
  return ((x$1 === 0) ? "value" : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Left.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 877209692, true);
});
$c_s_util_Left.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Left.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_s_util_Left) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Left__f_value, x$1.s_util_Left__f_value)));
});
function $isArrayOf_s_util_Left(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Left)));
}
export { $isArrayOf_s_util_Left as $isArrayOf_s_util_Left };
var $d_s_util_Left = new $TypeData().initClass($c_s_util_Left, "scala.util.Left", ({
  s_util_Left: 1,
  s_util_Either: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_Left as $d_s_util_Left };
/** @constructor */
function $c_s_util_Right(value) {
  this.s_util_Right__f_value = null;
  this.s_util_Right__f_value = value;
}
export { $c_s_util_Right as $c_s_util_Right };
$c_s_util_Right.prototype = new $h_s_util_Either();
$c_s_util_Right.prototype.constructor = $c_s_util_Right;
/** @constructor */
function $h_s_util_Right() {
}
export { $h_s_util_Right as $h_s_util_Right };
$h_s_util_Right.prototype = $c_s_util_Right.prototype;
$c_s_util_Right.prototype.isLeft__Z = (function() {
  return false;
});
$c_s_util_Right.prototype.isRight__Z = (function() {
  return true;
});
$c_s_util_Right.prototype.productPrefix__T = (function() {
  return "Right";
});
$c_s_util_Right.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Right.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Right__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Right.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Right.prototype.productElementName__I__T = (function(x$1) {
  return ((x$1 === 0) ? "value" : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Right.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 252890491, true);
});
$c_s_util_Right.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Right.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_s_util_Right) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Right__f_value, x$1.s_util_Right__f_value)));
});
function $isArrayOf_s_util_Right(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Right)));
}
export { $isArrayOf_s_util_Right as $isArrayOf_s_util_Right };
var $d_s_util_Right = new $TypeData().initClass($c_s_util_Right, "scala.util.Right", ({
  s_util_Right: 1,
  s_util_Either: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_Right as $d_s_util_Right };
/** @constructor */
function $c_s_util_Success(value) {
  this.s_util_Success__f_value = null;
  this.s_util_Success__f_value = value;
}
export { $c_s_util_Success as $c_s_util_Success };
$c_s_util_Success.prototype = new $h_s_util_Try();
$c_s_util_Success.prototype.constructor = $c_s_util_Success;
/** @constructor */
function $h_s_util_Success() {
}
export { $h_s_util_Success as $h_s_util_Success };
$h_s_util_Success.prototype = $c_s_util_Success.prototype;
$c_s_util_Success.prototype.isFailure__Z = (function() {
  return false;
});
$c_s_util_Success.prototype.isSuccess__Z = (function() {
  return true;
});
$c_s_util_Success.prototype.get__O = (function() {
  return this.s_util_Success__f_value;
});
$c_s_util_Success.prototype.getOrElse__F0__O = (function(default$1) {
  return this.s_util_Success__f_value;
});
$c_s_util_Success.prototype.orElse__F0__s_util_Try = (function(default$1) {
  return this;
});
$c_s_util_Success.prototype.flatMap__F1__s_util_Try = (function(f) {
  try {
    return f.apply__O__O(this.s_util_Success__f_value);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
$c_s_util_Success.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.s_util_Success__f_value);
});
$c_s_util_Success.prototype.map__F1__s_util_Try = (function(f) {
  try {
    var r1 = f.apply__O__O(this.s_util_Success__f_value);
    return new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return new $c_s_util_Failure(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
$c_s_util_Success.prototype.recover__s_PartialFunction__s_util_Try = (function(pf) {
  return this;
});
$c_s_util_Success.prototype.toOption__s_Option = (function() {
  return new $c_s_Some(this.s_util_Success__f_value);
});
$c_s_util_Success.prototype.toEither__s_util_Either = (function() {
  return new $c_s_util_Right(this.s_util_Success__f_value);
});
$c_s_util_Success.prototype.fold__F1__F1__O = (function(fa, fb) {
  try {
    return fb.apply__O__O(this.s_util_Success__f_value);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
      return fa.apply__O__O(e$2);
    }
    throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
  }
});
$c_s_util_Success.prototype.productPrefix__T = (function() {
  return "Success";
});
$c_s_util_Success.prototype.productArity__I = (function() {
  return 1;
});
$c_s_util_Success.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_util_Success__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Success.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_util_Success.prototype.productElementName__I__T = (function(x$1) {
  return ((x$1 === 0) ? "value" : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_util_Success.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1750213842), true);
});
$c_s_util_Success.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_util_Success.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_s_util_Success) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_util_Success__f_value, x$1.s_util_Success__f_value)));
});
function $isArrayOf_s_util_Success(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_util_Success)));
}
export { $isArrayOf_s_util_Success as $isArrayOf_s_util_Success };
var $d_s_util_Success = new $TypeData().initClass($c_s_util_Success, "scala.util.Success", ({
  s_util_Success: 1,
  s_util_Try: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_util_Success as $d_s_util_Success };
/** @constructor */
function $c_Lscodec_Attempt$Failure(cause) {
  this.Lscodec_Attempt$Failure__f_cause = null;
  this.Lscodec_Attempt$Failure__f_cause = cause;
}
export { $c_Lscodec_Attempt$Failure as $c_Lscodec_Attempt$Failure };
$c_Lscodec_Attempt$Failure.prototype = new $h_Lscodec_Attempt();
$c_Lscodec_Attempt$Failure.prototype.constructor = $c_Lscodec_Attempt$Failure;
/** @constructor */
function $h_Lscodec_Attempt$Failure() {
}
export { $h_Lscodec_Attempt$Failure as $h_Lscodec_Attempt$Failure };
$h_Lscodec_Attempt$Failure.prototype = $c_Lscodec_Attempt$Failure.prototype;
$c_Lscodec_Attempt$Failure.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lscodec_Attempt$Failure.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscodec_Attempt$Failure)) {
    var x = this.Lscodec_Attempt$Failure__f_cause;
    var x$2 = x$0.Lscodec_Attempt$Failure__f_cause;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lscodec_Attempt$Failure.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lscodec_Attempt$Failure.prototype.productArity__I = (function() {
  return 1;
});
$c_Lscodec_Attempt$Failure.prototype.productPrefix__T = (function() {
  return "Failure";
});
$c_Lscodec_Attempt$Failure.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_Attempt$Failure__f_cause;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_Attempt$Failure.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "cause";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_Attempt$Failure.prototype.map__F1__Lscodec_Attempt = (function(f) {
  return this;
});
$c_Lscodec_Attempt$Failure.prototype.mapErr__F1__Lscodec_Attempt = (function(f) {
  var cause = f.apply__O__O(this.Lscodec_Attempt$Failure__f_cause);
  return new $c_Lscodec_Attempt$Failure(cause);
});
$c_Lscodec_Attempt$Failure.prototype.flatMap__F1__Lscodec_Attempt = (function(f) {
  return this;
});
$c_Lscodec_Attempt$Failure.prototype.toEither__s_util_Either = (function() {
  var value = this.Lscodec_Attempt$Failure__f_cause;
  return new $c_s_util_Left(value);
});
function $isArrayOf_Lscodec_Attempt$Failure(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_Attempt$Failure)));
}
export { $isArrayOf_Lscodec_Attempt$Failure as $isArrayOf_Lscodec_Attempt$Failure };
var $d_Lscodec_Attempt$Failure = new $TypeData().initClass($c_Lscodec_Attempt$Failure, "scodec.Attempt$Failure", ({
  Lscodec_Attempt$Failure: 1,
  Lscodec_Attempt: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_Attempt$Failure as $d_Lscodec_Attempt$Failure };
/** @constructor */
function $c_Lscodec_Attempt$Successful(value) {
  this.Lscodec_Attempt$Successful__f_value = null;
  this.Lscodec_Attempt$Successful__f_value = value;
}
export { $c_Lscodec_Attempt$Successful as $c_Lscodec_Attempt$Successful };
$c_Lscodec_Attempt$Successful.prototype = new $h_Lscodec_Attempt();
$c_Lscodec_Attempt$Successful.prototype.constructor = $c_Lscodec_Attempt$Successful;
/** @constructor */
function $h_Lscodec_Attempt$Successful() {
}
export { $h_Lscodec_Attempt$Successful as $h_Lscodec_Attempt$Successful };
$h_Lscodec_Attempt$Successful.prototype = $c_Lscodec_Attempt$Successful.prototype;
$c_Lscodec_Attempt$Successful.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lscodec_Attempt$Successful.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscodec_Attempt$Successful)) {
    var x = this.Lscodec_Attempt$Successful__f_value;
    var y = x$0.Lscodec_Attempt$Successful__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lscodec_Attempt$Successful.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lscodec_Attempt$Successful.prototype.productArity__I = (function() {
  return 1;
});
$c_Lscodec_Attempt$Successful.prototype.productPrefix__T = (function() {
  return "Successful";
});
$c_Lscodec_Attempt$Successful.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_Attempt$Successful__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_Attempt$Successful.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_Attempt$Successful.prototype.map__F1__Lscodec_Attempt = (function(f) {
  var value = f.apply__O__O(this.Lscodec_Attempt$Successful__f_value);
  return new $c_Lscodec_Attempt$Successful(value);
});
$c_Lscodec_Attempt$Successful.prototype.mapErr__F1__Lscodec_Attempt = (function(f) {
  return this;
});
$c_Lscodec_Attempt$Successful.prototype.flatMap__F1__Lscodec_Attempt = (function(f) {
  return f.apply__O__O(this.Lscodec_Attempt$Successful__f_value);
});
$c_Lscodec_Attempt$Successful.prototype.toEither__s_util_Either = (function() {
  var value = this.Lscodec_Attempt$Successful__f_value;
  return new $c_s_util_Right(value);
});
function $isArrayOf_Lscodec_Attempt$Successful(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_Attempt$Successful)));
}
export { $isArrayOf_Lscodec_Attempt$Successful as $isArrayOf_Lscodec_Attempt$Successful };
var $d_Lscodec_Attempt$Successful = new $TypeData().initClass($c_Lscodec_Attempt$Successful, "scodec.Attempt$Successful", ({
  Lscodec_Attempt$Successful: 1,
  Lscodec_Attempt: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_Attempt$Successful as $d_Lscodec_Attempt$Successful };
function $ct_Lscodec_Err$General__T__sci_List__($thiz, message, context) {
  $thiz.Lscodec_Err$General__f_message = message;
  $thiz.Lscodec_Err$General__f_context = context;
  return $thiz;
}
export { $ct_Lscodec_Err$General__T__sci_List__ as $ct_Lscodec_Err$General__T__sci_List__ };
function $ct_Lscodec_Err$General__T__($thiz, message) {
  $ct_Lscodec_Err$General__T__sci_List__($thiz, message, $m_sci_Nil$());
  return $thiz;
}
export { $ct_Lscodec_Err$General__T__ as $ct_Lscodec_Err$General__T__ };
/** @constructor */
function $c_Lscodec_Err$General() {
  this.Lscodec_Err$General__f_message = null;
  this.Lscodec_Err$General__f_context = null;
}
export { $c_Lscodec_Err$General as $c_Lscodec_Err$General };
$c_Lscodec_Err$General.prototype = new $h_O();
$c_Lscodec_Err$General.prototype.constructor = $c_Lscodec_Err$General;
/** @constructor */
function $h_Lscodec_Err$General() {
}
export { $h_Lscodec_Err$General as $h_Lscodec_Err$General };
$h_Lscodec_Err$General.prototype = $c_Lscodec_Err$General.prototype;
$c_Lscodec_Err$General.prototype.toString__T = (function() {
  return $f_Lscodec_Err__messageWithContext__T(this);
});
$c_Lscodec_Err$General.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_Err$General.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lscodec_Err$General.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscodec_Err$General)) {
    if ((this.Lscodec_Err$General__f_message === x$0.Lscodec_Err$General__f_message)) {
      var x = this.Lscodec_Err$General__f_context;
      var x$2 = x$0.Lscodec_Err$General__f_context;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lscodec_Err$General.prototype.productArity__I = (function() {
  return 2;
});
$c_Lscodec_Err$General.prototype.productPrefix__T = (function() {
  return "General";
});
$c_Lscodec_Err$General.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_Err$General__f_message;
  }
  if ((n === 1)) {
    return this.Lscodec_Err$General__f_context;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_Err$General.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "message";
  }
  if ((n === 1)) {
    return "context";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_Err$General.prototype.message__T = (function() {
  return this.Lscodec_Err$General__f_message;
});
$c_Lscodec_Err$General.prototype.context__sci_List = (function() {
  return this.Lscodec_Err$General__f_context;
});
$c_Lscodec_Err$General.prototype.pushContext__T__Lscodec_Err = (function(ctx) {
  var this$1 = this.Lscodec_Err$General__f_context;
  var context$1 = new $c_sci_$colon$colon(ctx, this$1);
  var message$1 = this.Lscodec_Err$General__f_message;
  return $ct_Lscodec_Err$General__T__sci_List__(new $c_Lscodec_Err$General(), message$1, context$1);
});
function $isArrayOf_Lscodec_Err$General(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_Err$General)));
}
export { $isArrayOf_Lscodec_Err$General as $isArrayOf_Lscodec_Err$General };
var $d_Lscodec_Err$General = new $TypeData().initClass($c_Lscodec_Err$General, "scodec.Err$General", ({
  Lscodec_Err$General: 1,
  Lscodec_Err: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_Err$General as $d_Lscodec_Err$General };
function $ct_Lscodec_Err$InsufficientBits__J__J__sci_List__($thiz, needed, have, context) {
  $thiz.Lscodec_Err$InsufficientBits__f_needed = needed;
  $thiz.Lscodec_Err$InsufficientBits__f_have = have;
  $thiz.Lscodec_Err$InsufficientBits__f_context = context;
  return $thiz;
}
export { $ct_Lscodec_Err$InsufficientBits__J__J__sci_List__ as $ct_Lscodec_Err$InsufficientBits__J__J__sci_List__ };
function $ct_Lscodec_Err$InsufficientBits__J__J__($thiz, needed, have) {
  $ct_Lscodec_Err$InsufficientBits__J__J__sci_List__($thiz, needed, have, $m_sci_Nil$());
  return $thiz;
}
export { $ct_Lscodec_Err$InsufficientBits__J__J__ as $ct_Lscodec_Err$InsufficientBits__J__J__ };
/** @constructor */
function $c_Lscodec_Err$InsufficientBits() {
  this.Lscodec_Err$InsufficientBits__f_needed = $L0;
  this.Lscodec_Err$InsufficientBits__f_have = $L0;
  this.Lscodec_Err$InsufficientBits__f_context = null;
}
export { $c_Lscodec_Err$InsufficientBits as $c_Lscodec_Err$InsufficientBits };
$c_Lscodec_Err$InsufficientBits.prototype = new $h_O();
$c_Lscodec_Err$InsufficientBits.prototype.constructor = $c_Lscodec_Err$InsufficientBits;
/** @constructor */
function $h_Lscodec_Err$InsufficientBits() {
}
export { $h_Lscodec_Err$InsufficientBits as $h_Lscodec_Err$InsufficientBits };
$h_Lscodec_Err$InsufficientBits.prototype = $c_Lscodec_Err$InsufficientBits.prototype;
$c_Lscodec_Err$InsufficientBits.prototype.toString__T = (function() {
  return $f_Lscodec_Err__messageWithContext__T(this);
});
$c_Lscodec_Err$InsufficientBits.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_Err$InsufficientBits.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("InsufficientBits");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var t = this.Lscodec_Err$InsufficientBits__f_needed;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var data$1 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo, hi));
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var t$1 = this.Lscodec_Err$InsufficientBits__f_have;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var data$2 = $m_sr_Statics$().longHash__J__I(new $c_RTLong(lo$1, hi$1));
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x = this.Lscodec_Err$InsufficientBits__f_context;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lscodec_Err$InsufficientBits.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscodec_Err$InsufficientBits)) {
    var a = this.Lscodec_Err$InsufficientBits__f_needed;
    var b = x$0.Lscodec_Err$InsufficientBits__f_needed;
    if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
      var a$1 = this.Lscodec_Err$InsufficientBits__f_have;
      var b$1 = x$0.Lscodec_Err$InsufficientBits__f_have;
      var $x_1 = ((a$1.RTLong__f_lo === b$1.RTLong__f_lo) && (a$1.RTLong__f_hi === b$1.RTLong__f_hi));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x = this.Lscodec_Err$InsufficientBits__f_context;
      var x$2 = x$0.Lscodec_Err$InsufficientBits__f_context;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lscodec_Err$InsufficientBits.prototype.productArity__I = (function() {
  return 3;
});
$c_Lscodec_Err$InsufficientBits.prototype.productPrefix__T = (function() {
  return "InsufficientBits";
});
$c_Lscodec_Err$InsufficientBits.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lscodec_Err$InsufficientBits__f_needed;
      break;
    }
    case 1: {
      return this.Lscodec_Err$InsufficientBits__f_have;
      break;
    }
    case 2: {
      return this.Lscodec_Err$InsufficientBits__f_context;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lscodec_Err$InsufficientBits.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "needed";
      break;
    }
    case 1: {
      return "have";
      break;
    }
    case 2: {
      return "context";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lscodec_Err$InsufficientBits.prototype.context__sci_List = (function() {
  return this.Lscodec_Err$InsufficientBits__f_context;
});
$c_Lscodec_Err$InsufficientBits.prototype.message__T = (function() {
  return (((("cannot acquire " + this.Lscodec_Err$InsufficientBits__f_needed) + " bits from a vector that contains ") + this.Lscodec_Err$InsufficientBits__f_have) + " bits");
});
$c_Lscodec_Err$InsufficientBits.prototype.pushContext__T__Lscodec_Err = (function(ctx) {
  var this$1 = this.Lscodec_Err$InsufficientBits__f_context;
  var context$2 = new $c_sci_$colon$colon(ctx, this$1);
  var t = this.Lscodec_Err$InsufficientBits__f_needed;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = this.Lscodec_Err$InsufficientBits__f_have;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $ct_Lscodec_Err$InsufficientBits__J__J__sci_List__(new $c_Lscodec_Err$InsufficientBits(), new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1), context$2);
});
function $isArrayOf_Lscodec_Err$InsufficientBits(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_Err$InsufficientBits)));
}
export { $isArrayOf_Lscodec_Err$InsufficientBits as $isArrayOf_Lscodec_Err$InsufficientBits };
var $d_Lscodec_Err$InsufficientBits = new $TypeData().initClass($c_Lscodec_Err$InsufficientBits, "scodec.Err$InsufficientBits", ({
  Lscodec_Err$InsufficientBits: 1,
  Lscodec_Err: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_Err$InsufficientBits as $d_Lscodec_Err$InsufficientBits };
function $ct_Lscodec_Err$MatchingDiscriminatorNotFound__O__sci_List__($thiz, a, context) {
  $thiz.Lscodec_Err$MatchingDiscriminatorNotFound__f_a = a;
  $thiz.Lscodec_Err$MatchingDiscriminatorNotFound__f_context = context;
  return $thiz;
}
export { $ct_Lscodec_Err$MatchingDiscriminatorNotFound__O__sci_List__ as $ct_Lscodec_Err$MatchingDiscriminatorNotFound__O__sci_List__ };
function $ct_Lscodec_Err$MatchingDiscriminatorNotFound__O__($thiz, a) {
  $ct_Lscodec_Err$MatchingDiscriminatorNotFound__O__sci_List__($thiz, a, $m_sci_Nil$());
  return $thiz;
}
export { $ct_Lscodec_Err$MatchingDiscriminatorNotFound__O__ as $ct_Lscodec_Err$MatchingDiscriminatorNotFound__O__ };
/** @constructor */
function $c_Lscodec_Err$MatchingDiscriminatorNotFound() {
  this.Lscodec_Err$MatchingDiscriminatorNotFound__f_a = null;
  this.Lscodec_Err$MatchingDiscriminatorNotFound__f_context = null;
}
export { $c_Lscodec_Err$MatchingDiscriminatorNotFound as $c_Lscodec_Err$MatchingDiscriminatorNotFound };
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype = new $h_O();
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.constructor = $c_Lscodec_Err$MatchingDiscriminatorNotFound;
/** @constructor */
function $h_Lscodec_Err$MatchingDiscriminatorNotFound() {
}
export { $h_Lscodec_Err$MatchingDiscriminatorNotFound as $h_Lscodec_Err$MatchingDiscriminatorNotFound };
$h_Lscodec_Err$MatchingDiscriminatorNotFound.prototype = $c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype;
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.toString__T = (function() {
  return $f_Lscodec_Err__messageWithContext__T(this);
});
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lscodec_Err$MatchingDiscriminatorNotFound)) {
    var x = this.Lscodec_Err$MatchingDiscriminatorNotFound__f_a;
    var y = x$0.Lscodec_Err$MatchingDiscriminatorNotFound__f_a;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lscodec_Err$MatchingDiscriminatorNotFound__f_context;
      var x$2 = x$0.Lscodec_Err$MatchingDiscriminatorNotFound__f_context;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.productArity__I = (function() {
  return 2;
});
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.productPrefix__T = (function() {
  return "MatchingDiscriminatorNotFound";
});
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_Err$MatchingDiscriminatorNotFound__f_a;
  }
  if ((n === 1)) {
    return this.Lscodec_Err$MatchingDiscriminatorNotFound__f_context;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "a";
  }
  if ((n === 1)) {
    return "context";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.context__sci_List = (function() {
  return this.Lscodec_Err$MatchingDiscriminatorNotFound__f_context;
});
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.message__T = (function() {
  return ("could not find matching case for " + this.Lscodec_Err$MatchingDiscriminatorNotFound__f_a);
});
$c_Lscodec_Err$MatchingDiscriminatorNotFound.prototype.pushContext__T__Lscodec_Err = (function(ctx) {
  var this$1 = this.Lscodec_Err$MatchingDiscriminatorNotFound__f_context;
  var context$3 = new $c_sci_$colon$colon(ctx, this$1);
  var a$1 = this.Lscodec_Err$MatchingDiscriminatorNotFound__f_a;
  return $ct_Lscodec_Err$MatchingDiscriminatorNotFound__O__sci_List__(new $c_Lscodec_Err$MatchingDiscriminatorNotFound(), a$1, context$3);
});
function $isArrayOf_Lscodec_Err$MatchingDiscriminatorNotFound(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_Err$MatchingDiscriminatorNotFound)));
}
export { $isArrayOf_Lscodec_Err$MatchingDiscriminatorNotFound as $isArrayOf_Lscodec_Err$MatchingDiscriminatorNotFound };
var $d_Lscodec_Err$MatchingDiscriminatorNotFound = new $TypeData().initClass($c_Lscodec_Err$MatchingDiscriminatorNotFound, "scodec.Err$MatchingDiscriminatorNotFound", ({
  Lscodec_Err$MatchingDiscriminatorNotFound: 1,
  Lscodec_Err: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_Err$MatchingDiscriminatorNotFound as $d_Lscodec_Err$MatchingDiscriminatorNotFound };
/** @constructor */
function $c_Lscodec_bits_Bases$Alphabets$Base64Url$() {
  this.Lscodec_bits_Bases$Alphabets$Base64Url$__f_pad = 0;
  this.Lscodec_bits_Bases$Alphabets$Base64Url$__f_pad = 61;
}
export { $c_Lscodec_bits_Bases$Alphabets$Base64Url$ as $c_Lscodec_bits_Bases$Alphabets$Base64Url$ };
$c_Lscodec_bits_Bases$Alphabets$Base64Url$.prototype = new $h_O();
$c_Lscodec_bits_Bases$Alphabets$Base64Url$.prototype.constructor = $c_Lscodec_bits_Bases$Alphabets$Base64Url$;
/** @constructor */
function $h_Lscodec_bits_Bases$Alphabets$Base64Url$() {
}
export { $h_Lscodec_bits_Bases$Alphabets$Base64Url$ as $h_Lscodec_bits_Bases$Alphabets$Base64Url$ };
$h_Lscodec_bits_Bases$Alphabets$Base64Url$.prototype = $c_Lscodec_bits_Bases$Alphabets$Base64Url$.prototype;
$c_Lscodec_bits_Bases$Alphabets$Base64Url$.prototype.pad__C = (function() {
  return this.Lscodec_bits_Bases$Alphabets$Base64Url$__f_pad;
});
var $d_Lscodec_bits_Bases$Alphabets$Base64Url$ = new $TypeData().initClass($c_Lscodec_bits_Bases$Alphabets$Base64Url$, "scodec.bits.Bases$Alphabets$Base64Url$", ({
  Lscodec_bits_Bases$Alphabets$Base64Url$: 1,
  Lscodec_bits_Bases$Alphabet: 1,
  Lscodec_bits_Bases$PaddedAlphabet: 1,
  Lscodec_bits_Bases$Base64Alphabet: 1,
  Lscodec_bits_Bases$Alphabets$Base64UrlBase: 1
}));
export { $d_Lscodec_bits_Bases$Alphabets$Base64Url$ as $d_Lscodec_bits_Bases$Alphabets$Base64Url$ };
var $n_Lscodec_bits_Bases$Alphabets$Base64Url$;
function $m_Lscodec_bits_Bases$Alphabets$Base64Url$() {
  if ((!$n_Lscodec_bits_Bases$Alphabets$Base64Url$)) {
    $n_Lscodec_bits_Bases$Alphabets$Base64Url$ = new $c_Lscodec_bits_Bases$Alphabets$Base64Url$();
  }
  return $n_Lscodec_bits_Bases$Alphabets$Base64Url$;
}
export { $m_Lscodec_bits_Bases$Alphabets$Base64Url$ as $m_Lscodec_bits_Bases$Alphabets$Base64Url$ };
/** @constructor */
function $c_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$() {
  this.Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$__f_pad = 0;
  this.Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$__f_pad = 61;
  this.Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$__f_pad = 0;
}
export { $c_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$ as $c_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$ };
$c_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$.prototype = new $h_O();
$c_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$.prototype.constructor = $c_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$;
/** @constructor */
function $h_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$() {
}
export { $h_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$ as $h_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$ };
$h_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$.prototype = $c_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$.prototype;
$c_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$.prototype.pad__C = (function() {
  return this.Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$__f_pad;
});
var $d_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$ = new $TypeData().initClass($c_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$, "scodec.bits.Bases$Alphabets$Base64UrlNoPad$", ({
  Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$: 1,
  Lscodec_bits_Bases$Alphabet: 1,
  Lscodec_bits_Bases$PaddedAlphabet: 1,
  Lscodec_bits_Bases$Base64Alphabet: 1,
  Lscodec_bits_Bases$Alphabets$Base64UrlBase: 1
}));
export { $d_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$ as $d_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$ };
var $n_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$;
function $m_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$() {
  if ((!$n_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$)) {
    $n_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$ = new $c_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$();
  }
  return $n_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$;
}
export { $m_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$ as $m_Lscodec_bits_Bases$Alphabets$Base64UrlNoPad$ };
/** @constructor */
function $c_Lscodec_bits_BitVector$() {
  this.Lscodec_bits_BitVector$__f_empty = null;
  this.Lscodec_bits_BitVector$__f_zero = null;
  this.Lscodec_bits_BitVector$__f_lowByte = null;
  $n_Lscodec_bits_BitVector$ = this;
  this.Lscodec_bits_BitVector$__f_empty = this.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes($m_Lscodec_bits_ByteVector$().Lscodec_bits_ByteVector$__f_empty, $L0);
  this.Lscodec_bits_BitVector$__f_zero = this.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes($m_Lscodec_bits_ByteVector$().apply__sci_Seq__s_math_Integral__Lscodec_bits_ByteVector($m_sr_ScalaRunTime$().wrapIntArray__AI__sci_ArraySeq(new $ac_I(new Int32Array([0]))), $m_s_math_Numeric$IntIsIntegral$()), new $c_RTLong(1, 0));
  this.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes($m_Lscodec_bits_ByteVector$().apply__sci_Seq__s_math_Integral__Lscodec_bits_ByteVector($m_sr_ScalaRunTime$().wrapIntArray__AI__sci_ArraySeq(new $ac_I(new Int32Array([255]))), $m_s_math_Numeric$IntIsIntegral$()), new $c_RTLong(1, 0));
  var this$1 = $m_Lscodec_bits_ByteVector$();
  this.Lscodec_bits_BitVector$__f_lowByte = this.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes(this$1.fill__J__O__s_math_Integral__Lscodec_bits_ByteVector(new $c_RTLong(1, 0), 0, $m_s_math_Numeric$IntIsIntegral$()), new $c_RTLong(8, 0));
  var this$2 = $m_Lscodec_bits_ByteVector$();
  this.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes(this$2.fill__J__O__s_math_Integral__Lscodec_bits_ByteVector(new $c_RTLong(1, 0), 255, $m_s_math_Numeric$IntIsIntegral$()), new $c_RTLong(8, 0));
}
export { $c_Lscodec_bits_BitVector$ as $c_Lscodec_bits_BitVector$ };
$c_Lscodec_bits_BitVector$.prototype = new $h_O();
$c_Lscodec_bits_BitVector$.prototype.constructor = $c_Lscodec_bits_BitVector$;
/** @constructor */
function $h_Lscodec_bits_BitVector$() {
}
export { $h_Lscodec_bits_BitVector$ as $h_Lscodec_bits_BitVector$ };
$h_Lscodec_bits_BitVector$.prototype = $c_Lscodec_bits_BitVector$.prototype;
$c_Lscodec_bits_BitVector$.prototype.apply__Lscodec_bits_ByteVector__Lscodec_bits_BitVector = (function(bs) {
  var a = bs.size__J();
  var lo = a.RTLong__f_lo;
  var lo$1 = (lo << 3);
  var hi = (((lo >>> 29) | 0) | (a.RTLong__f_hi << 3));
  return this.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes(bs, new $c_RTLong(lo$1, hi));
});
$c_Lscodec_bits_BitVector$.prototype.apply__Ljava_nio_ByteBuffer__Lscodec_bits_BitVector = (function(buffer) {
  return this.apply__Lscodec_bits_ByteVector__Lscodec_bits_BitVector($m_Lscodec_bits_ByteVector$().apply__Ljava_nio_ByteBuffer__Lscodec_bits_ByteVector(buffer));
});
$c_Lscodec_bits_BitVector$.prototype.apply__sci_Seq__s_math_Integral__Lscodec_bits_BitVector = (function(bytes, evidence$1) {
  return this.apply__Lscodec_bits_ByteVector__Lscodec_bits_BitVector($m_Lscodec_bits_ByteVector$().apply__sci_Seq__s_math_Integral__Lscodec_bits_ByteVector(bytes, evidence$1));
});
$c_Lscodec_bits_BitVector$.prototype.view__Ljava_nio_ByteBuffer__Lscodec_bits_BitVector = (function(buffer) {
  var $x_1 = $m_Lscodec_bits_ByteVector$().view__Ljava_nio_ByteBuffer__Lscodec_bits_ByteVector(buffer);
  var value = buffer.Ljava_nio_Buffer__f__limit;
  var hi = (value >> 31);
  var lo = (value << 3);
  var hi$1 = (((value >>> 29) | 0) | (hi << 3));
  return this.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes($x_1, new $c_RTLong(lo, hi$1));
});
$c_Lscodec_bits_BitVector$.prototype.view__AB__Lscodec_bits_BitVector = (function(bs) {
  var value = bs.u.length;
  var hi = (value >> 31);
  var lo = (value << 3);
  var hi$1 = (((value >>> 29) | 0) | (hi << 3));
  return this.view__AB__J__Lscodec_bits_BitVector(bs, new $c_RTLong(lo, hi$1));
});
$c_Lscodec_bits_BitVector$.prototype.view__AB__J__Lscodec_bits_BitVector = (function(bs, sizeInBits) {
  return this.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes($m_Lscodec_bits_ByteVector$().view__AB__Lscodec_bits_ByteVector(bs), sizeInBits);
});
$c_Lscodec_bits_BitVector$.prototype.fill__J__Z__Lscodec_bits_BitVector = (function(n, high) {
  var t = this.scodec$bits$BitVector$$$bytesNeededForBits__J__J(n);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var bs = $m_Lscodec_bits_ByteVector$().fill__J__O__s_math_Integral__Lscodec_bits_ByteVector(new $c_RTLong(lo, hi), (high ? (-1) : 0), $m_s_math_Numeric$IntIsIntegral$());
  return this.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes(bs, n);
});
$c_Lscodec_bits_BitVector$.prototype.fromByte__B__I__Lscodec_bits_BitVector = (function(b, size) {
  $m_s_Predef$().require__Z__V((size <= 8));
  var this$3 = $m_Lscodec_bits_BitVector$().apply__sci_Seq__s_math_Integral__Lscodec_bits_BitVector($m_sr_ScalaRunTime$().wrapByteArray__AB__sci_ArraySeq(new $ac_B(new Int8Array([b]))), $m_s_math_Numeric$ByteIsIntegral$());
  var hi = (size >> 31);
  var lo = ((8 - size) | 0);
  var hi$1 = ((((-hi) | 0) + ((size | lo) >> 31)) | 0);
  var $x_1 = this$3.shiftLeft__J__Lscodec_bits_BitVector(new $c_RTLong(lo, hi$1));
  var hi$2 = (size >> 31);
  return $x_1.take__J__Lscodec_bits_BitVector(new $c_RTLong(size, hi$2));
});
$c_Lscodec_bits_BitVector$.prototype.fromShort__S__I__Lscodec_bits_ByteOrdering__Lscodec_bits_BitVector = (function(s, size, ordering) {
  $m_s_Predef$().require__Z__V((size <= 16));
  var buffer = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(2).order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer($m_Ljava_nio_ByteOrder$().Ljava_nio_ByteOrder$__f_BIG_ENDIAN).putShort__S__Ljava_nio_ByteBuffer(s);
  $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(buffer);
  var this$3 = $m_Lscodec_bits_BitVector$().view__Ljava_nio_ByteBuffer__Lscodec_bits_BitVector(buffer);
  var hi = (size >> 31);
  var lo = ((16 - size) | 0);
  var hi$1 = ((((-hi) | 0) + ((size | lo) >> 31)) | 0);
  var $x_1 = this$3.shiftLeft__J__Lscodec_bits_BitVector(new $c_RTLong(lo, hi$1));
  var hi$2 = (size >> 31);
  var relevantBits = $x_1.take__J__Lscodec_bits_BitVector(new $c_RTLong(size, hi$2));
  var x$2 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
  if (((ordering !== null) && (ordering === x$2))) {
    return relevantBits;
  } else {
    return relevantBits.reverseByteOrder__Lscodec_bits_BitVector();
  }
});
$c_Lscodec_bits_BitVector$.prototype.fromInt__I__I__Lscodec_bits_ByteOrdering__Lscodec_bits_BitVector = (function(i, size, ordering) {
  $m_s_Predef$().require__Z__V((size <= 32));
  var buffer = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(4).order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer($m_Ljava_nio_ByteOrder$().Ljava_nio_ByteOrder$__f_BIG_ENDIAN).putInt__I__Ljava_nio_ByteBuffer(i);
  $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(buffer);
  var this$3 = $m_Lscodec_bits_BitVector$().view__Ljava_nio_ByteBuffer__Lscodec_bits_BitVector(buffer);
  var hi = (size >> 31);
  var lo = ((32 - size) | 0);
  var hi$1 = ((((-hi) | 0) + ((size | lo) >> 31)) | 0);
  var $x_1 = this$3.shiftLeft__J__Lscodec_bits_BitVector(new $c_RTLong(lo, hi$1));
  var hi$2 = (size >> 31);
  var relevantBits = $x_1.take__J__Lscodec_bits_BitVector(new $c_RTLong(size, hi$2));
  var x$2 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
  if (((ordering !== null) && (ordering === x$2))) {
    return relevantBits;
  } else {
    return relevantBits.reverseByteOrder__Lscodec_bits_BitVector();
  }
});
$c_Lscodec_bits_BitVector$.prototype.fromLong__J__I__Lscodec_bits_ByteOrdering__Lscodec_bits_BitVector = (function(l, size, ordering) {
  $m_s_Predef$().require__Z__V((size <= 64));
  var buffer = $m_Ljava_nio_ByteBuffer$().allocate__I__Ljava_nio_ByteBuffer(8).order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer($m_Ljava_nio_ByteOrder$().Ljava_nio_ByteOrder$__f_BIG_ENDIAN).putLong__J__Ljava_nio_ByteBuffer(l);
  $c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(buffer);
  var this$3 = $m_Lscodec_bits_BitVector$().view__Ljava_nio_ByteBuffer__Lscodec_bits_BitVector(buffer);
  var hi = (size >> 31);
  var lo = ((64 - size) | 0);
  var hi$1 = ((((-hi) | 0) + ((size | lo) >> 31)) | 0);
  var $x_1 = this$3.shiftLeft__J__Lscodec_bits_BitVector(new $c_RTLong(lo, hi$1));
  var hi$2 = (size >> 31);
  var relevantBits = $x_1.take__J__Lscodec_bits_BitVector(new $c_RTLong(size, hi$2));
  var x$2 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
  if (((ordering !== null) && (ordering === x$2))) {
    return relevantBits;
  } else {
    return relevantBits.reverseByteOrder__Lscodec_bits_BitVector();
  }
});
$c_Lscodec_bits_BitVector$.prototype.fromBigInt__s_math_BigInt__s_Option__Lscodec_bits_ByteOrdering__Lscodec_bits_BitVector = (function(value, size, ordering) {
  var actualSize = ((size.isEmpty__Z() ? ((1 + value.bitLength__I()) | 0) : size.get__O()) | 0);
  $m_s_Predef$().require__Z__V((actualSize > 0));
  var bits = $m_Lscodec_bits_BitVector$().view__AB__Lscodec_bits_BitVector(value.bigInteger__Ljava_math_BigInteger().toByteArray__AB());
  var a = bits.size__J();
  var hi = (actualSize >> 31);
  var ahi = a.RTLong__f_hi;
  if (((ahi === hi) ? ((a.RTLong__f_lo >>> 0) < (actualSize >>> 0)) : (ahi < hi))) {
    var $x_1 = $m_Lscodec_bits_BitVector$();
    var hi$1 = (actualSize >> 31);
    var b = bits.size__J();
    var blo = b.RTLong__f_lo;
    var lo = ((actualSize - blo) | 0);
    var hi$2 = ((((hi$1 - b.RTLong__f_hi) | 0) + ((((~actualSize) & blo) | ((~(actualSize ^ blo)) & lo)) >> 31)) | 0);
    var relevantBits = $x_1.fill__J__Z__Lscodec_bits_BitVector(new $c_RTLong(lo, hi$2), bits.get__J__Z($L0)).$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(bits);
  } else {
    var hi$3 = (actualSize >> 31);
    var relevantBits = bits.takeRight__J__Lscodec_bits_BitVector(new $c_RTLong(actualSize, hi$3));
  }
  var x$2 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
  if (((ordering !== null) && (ordering === x$2))) {
    return relevantBits;
  } else {
    return relevantBits.reverseByteOrder__Lscodec_bits_BitVector();
  }
});
$c_Lscodec_bits_BitVector$.prototype.fromBase64Descriptive__T__Lscodec_bits_Bases$Base64Alphabet__s_util_Either = (function(str, alphabet) {
  var this$1 = $m_Lscodec_bits_ByteVector$().fromBase64Descriptive__T__Lscodec_bits_Bases$Base64Alphabet__s_util_Either(str, alphabet);
  if ((this$1 instanceof $c_s_util_Right)) {
    var b = this$1.s_util_Right__f_value;
    return new $c_s_util_Right($m_Lscodec_bits_BitVector$().apply__Lscodec_bits_ByteVector__Lscodec_bits_BitVector(b));
  } else {
    return this$1;
  }
});
$c_Lscodec_bits_BitVector$.prototype.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes = (function(bs, sizeInBits) {
  var t = this.scodec$bits$BitVector$$$bytesNeededForBits__J__J(sizeInBits);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var $x_1 = $m_s_Predef$();
  var b = bs.size__J();
  var bhi = b.RTLong__f_hi;
  $x_1.require__Z__V(((hi === bhi) ? ((lo >>> 0) <= (b.RTLong__f_lo >>> 0)) : (hi < bhi)));
  var a = bs.size__J();
  var ahi = a.RTLong__f_hi;
  if (((ahi === hi) ? ((a.RTLong__f_lo >>> 0) > (lo >>> 0)) : (ahi > hi))) {
    var b$1 = bs.take__J__Lscodec_bits_ByteVector(new $c_RTLong(lo, hi));
  } else {
    var b$1 = bs;
  }
  return new $c_Lscodec_bits_BitVector$Bytes(b$1, sizeInBits);
});
$c_Lscodec_bits_BitVector$.prototype.scodec$bits$BitVector$$$getBit__B__I__Z = (function(byte, n) {
  return (((128 >> n) & byte) !== 0);
});
$c_Lscodec_bits_BitVector$.prototype.scodec$bits$BitVector$$$validBitsInLastByte__J__J = (function(size) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(size.RTLong__f_lo, size.RTLong__f_hi, 8, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return (((lo === 0) && (hi === 0)) ? new $c_RTLong(8, 0) : new $c_RTLong(lo, hi));
});
$c_Lscodec_bits_BitVector$.prototype.scodec$bits$BitVector$$$topNBits__I__B = (function(n) {
  return ((((-1) << ((8 - n) | 0)) << 24) >> 24);
});
$c_Lscodec_bits_BitVector$.prototype.scodec$bits$BitVector$$$bytesNeededForBits__J__J = (function(size) {
  var blo = size.RTLong__f_lo;
  var lo = ((7 + blo) | 0);
  var hi = ((size.RTLong__f_hi + (((blo & (~lo)) >>> 31) | 0)) | 0);
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.divideImpl__I__I__I__I__I(lo, hi, 8, 0);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo$1, hi$1);
});
$c_Lscodec_bits_BitVector$.prototype.scodec$bits$BitVector$$$clearUnneededBits__J__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector = (function(size, bytes) {
  var a = this.scodec$bits$BitVector$$$validBitsInLastByte__J__J(size);
  var valid = a.RTLong__f_lo;
  if (((!bytes.isEmpty__Z()) && (valid < 8))) {
    var b = bytes.size__J();
    var blo = b.RTLong__f_lo;
    var lo = (((-1) + blo) | 0);
    var hi = (((((-1) + b.RTLong__f_hi) | 0) + (((blo | (~lo)) >>> 31) | 0)) | 0);
    var last = bytes.get__J__B(new $c_RTLong(lo, hi));
    return bytes.update__J__B__Lscodec_bits_ByteVector(new $c_RTLong(lo, hi), (((last & this.scodec$bits$BitVector$$$topNBits__I__B(valid)) << 24) >> 24));
  } else {
    return bytes;
  }
});
$c_Lscodec_bits_BitVector$.prototype.ordinal__Lscodec_bits_BitVector__I = (function(x$0) {
  if ((x$0 instanceof $c_Lscodec_bits_BitVector$Bytes)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lscodec_bits_BitVector$Drop)) {
    return 1;
  }
  if ((x$0 instanceof $c_Lscodec_bits_BitVector$Append)) {
    return 2;
  }
  if (false) {
    return 3;
  }
  if ((x$0 instanceof $c_Lscodec_bits_BitVector$Chunks)) {
    return 4;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lscodec_bits_BitVector$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lscodec_bits_BitVector__I(x);
});
var $d_Lscodec_bits_BitVector$ = new $TypeData().initClass($c_Lscodec_bits_BitVector$, "scodec.bits.BitVector$", ({
  Lscodec_bits_BitVector$: 1,
  Lscodec_bits_BitVectorPlatform: 1,
  Lscodec_bits_BitVectorCompanionCrossPlatform: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lscodec_bits_BitVector$ as $d_Lscodec_bits_BitVector$ };
var $n_Lscodec_bits_BitVector$;
function $m_Lscodec_bits_BitVector$() {
  if ((!$n_Lscodec_bits_BitVector$)) {
    $n_Lscodec_bits_BitVector$ = new $c_Lscodec_bits_BitVector$();
  }
  return $n_Lscodec_bits_BitVector$;
}
export { $m_Lscodec_bits_BitVector$ as $m_Lscodec_bits_BitVector$ };
function $p_Lscodec_codecs_DiscriminatorCodec__appendCase__Lscodec_codecs_DiscriminatorCodec$Case__Lscodec_codecs_DiscriminatorCodec($thiz, c) {
  var $x_1 = $thiz.Lscodec_codecs_DiscriminatorCodec__f_by;
  var this$1 = $thiz.Lscodec_codecs_DiscriminatorCodec__f_cases;
  return new $c_Lscodec_codecs_DiscriminatorCodec($x_1, this$1.appended__O__O(c), $thiz.Lscodec_codecs_DiscriminatorCodec__f_framing);
}
export { $p_Lscodec_codecs_DiscriminatorCodec__appendCase__Lscodec_codecs_DiscriminatorCodec$Case__Lscodec_codecs_DiscriminatorCodec as $p_Lscodec_codecs_DiscriminatorCodec__appendCase__Lscodec_codecs_DiscriminatorCodec$Case__Lscodec_codecs_DiscriminatorCodec };
function $p_Lscodec_codecs_DiscriminatorCodec__errOrCase$1__O__s_Option__Lscodec_Attempt($thiz, b, opt) {
  if (opt.isEmpty__Z()) {
    var err = $ct_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__Lscodec_codecs_KnownDiscriminatorType__O__(new $c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator(), $thiz, b);
    var $x_1 = new $c_Lscodec_Attempt$Failure(err);
  } else {
    var x0 = opt.get__O();
    var $x_1 = new $c_Lscodec_Attempt$Successful(x0);
  }
  return $x_1;
}
export { $p_Lscodec_codecs_DiscriminatorCodec__errOrCase$1__O__s_Option__Lscodec_Attempt as $p_Lscodec_codecs_DiscriminatorCodec__errOrCase$1__O__s_Option__Lscodec_Attempt };
/** @constructor */
function $c_Lscodec_codecs_DiscriminatorCodec(by, cases, framing) {
  this.Lscodec_codecs_DiscriminatorCodec__f_by = null;
  this.Lscodec_codecs_DiscriminatorCodec__f_cases = null;
  this.Lscodec_codecs_DiscriminatorCodec__f_framing = null;
  this.Lscodec_codecs_DiscriminatorCodec__f_matcher = null;
  this.Lscodec_codecs_DiscriminatorCodec__f_by = by;
  this.Lscodec_codecs_DiscriminatorCodec__f_cases = cases;
  this.Lscodec_codecs_DiscriminatorCodec__f_framing = framing;
  var $x_1 = $f_sc_IndexedSeqOps__reverse__O(cases).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((kase) => {
    var self = kase.Lscodec_codecs_DiscriminatorCodec$Case__f_tag;
    return $ct_T2__O__O__(new $c_T2(), self, kase);
  })));
  var this$3 = $m_s_$less$colon$less$();
  var tbl = $x_1.toMap__s_$less$colon$less__sci_Map(this$3.s_$less$colon$less$__f_singleton);
  this.Lscodec_codecs_DiscriminatorCodec__f_matcher = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => $p_Lscodec_codecs_DiscriminatorCodec__errOrCase$1__O__s_Option__Lscodec_Attempt(this, b, tbl.get__O__s_Option(b))));
}
export { $c_Lscodec_codecs_DiscriminatorCodec as $c_Lscodec_codecs_DiscriminatorCodec };
$c_Lscodec_codecs_DiscriminatorCodec.prototype = new $h_O();
$c_Lscodec_codecs_DiscriminatorCodec.prototype.constructor = $c_Lscodec_codecs_DiscriminatorCodec;
/** @constructor */
function $h_Lscodec_codecs_DiscriminatorCodec() {
}
export { $h_Lscodec_codecs_DiscriminatorCodec as $h_Lscodec_codecs_DiscriminatorCodec };
$h_Lscodec_codecs_DiscriminatorCodec.prototype = $c_Lscodec_codecs_DiscriminatorCodec.prototype;
$c_Lscodec_codecs_DiscriminatorCodec.prototype.caseP__O__s_PartialFunction__F1__Lscodec_Codec__Lscodec_codecs_DiscriminatorCodec = (function(tag, toRep, fromRep, cr) {
  var preview = toRep.lift__F1();
  var prism = new $c_Lscodec_codecs_DiscriminatorCodec$Prism(preview, fromRep, cr);
  return $p_Lscodec_codecs_DiscriminatorCodec__appendCase__Lscodec_codecs_DiscriminatorCodec$Case__Lscodec_codecs_DiscriminatorCodec(this, new $c_Lscodec_codecs_DiscriminatorCodec$Case(tag, prism));
});
$c_Lscodec_codecs_DiscriminatorCodec.prototype.sizeBound__Lscodec_SizeBound = (function() {
  return this.Lscodec_codecs_DiscriminatorCodec__f_by.sizeBound__Lscodec_SizeBound().$plus__Lscodec_SizeBound__Lscodec_SizeBound($m_Lscodec_SizeBound$().choice__sc_Iterable__Lscodec_SizeBound(this.Lscodec_codecs_DiscriminatorCodec__f_cases.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((c) => this.Lscodec_codecs_DiscriminatorCodec__f_framing.apply__O__O(c.Lscodec_codecs_DiscriminatorCodec$Case__f_prism.Lscodec_codecs_DiscriminatorCodec$Prism__f_repCodec).sizeBound__Lscodec_SizeBound())))));
});
$c_Lscodec_codecs_DiscriminatorCodec.prototype.encode__O__Lscodec_Attempt = (function(a) {
  var this$5 = this.Lscodec_codecs_DiscriminatorCodec__f_cases.iterator__sc_Iterator();
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((k) => {
    var this$2 = k.Lscodec_codecs_DiscriminatorCodec$Case__f_prism.Lscodec_codecs_DiscriminatorCodec$Prism__f_preview.apply__O__O(a);
    if (this$2.isEmpty__Z()) {
      var this$3 = $m_s_None$();
    } else {
      var x0 = this$2.get__O();
      var this$3 = new $c_s_Some(this.Lscodec_codecs_DiscriminatorCodec__f_by.encode__O__Lscodec_Attempt(k.Lscodec_codecs_DiscriminatorCodec$Case__f_tag).flatMap__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((k$1$2) => ((bits) => this.Lscodec_codecs_DiscriminatorCodec__f_framing.apply__O__O(k$1$2.Lscodec_codecs_DiscriminatorCodec$Case__f_prism.Lscodec_codecs_DiscriminatorCodec$Prism__f_repCodec).encode__O__Lscodec_Attempt(x0).map__F1__Lscodec_Attempt(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((bits$2) => ((_$1) => bits$2.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(_$1)))(bits)))))(k))));
    }
    if (this$3.isEmpty__Z()) {
      var this$4 = $m_s_None$();
    } else {
      var x0$1 = this$3.get__O();
      var this$4 = new $c_s_Some(new $c_sci_$colon$colon(x0$1, $m_sci_Nil$()));
    }
    return (this$4.isEmpty__Z() ? $m_sci_Nil$() : this$4.get__O());
  }));
  var itr = new $c_sc_Iterator$$anon$10(this$5, f);
  if (itr.hasNext__Z()) {
    return itr.next__O();
  } else {
    var err = $ct_Lscodec_Err$MatchingDiscriminatorNotFound__O__(new $c_Lscodec_Err$MatchingDiscriminatorNotFound(), a);
    return new $c_Lscodec_Attempt$Failure(err);
  }
});
$c_Lscodec_codecs_DiscriminatorCodec.prototype.decode__Lscodec_bits_BitVector__Lscodec_Attempt = (function(bits) {
  var this$5 = this.Lscodec_codecs_DiscriminatorCodec__f_by;
  var f$2 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => {
    var attempt = this.Lscodec_codecs_DiscriminatorCodec__f_matcher.apply__O__O(b);
    var this$4 = new $c_Lscodec_Decoder$$anon$9(attempt);
    var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((k) => {
      var this$3 = this.Lscodec_codecs_DiscriminatorCodec__f_framing.apply__O__O(k.Lscodec_codecs_DiscriminatorCodec$Case__f_prism.Lscodec_codecs_DiscriminatorCodec$Prism__f_repCodec);
      var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((k$2) => ((r) => k$2.Lscodec_codecs_DiscriminatorCodec$Case__f_prism.Lscodec_codecs_DiscriminatorCodec$Prism__f_review.apply__O__O(r)))(k));
      return new $c_Lscodec_Decoder$$anon$1(f, this$3);
    }));
    return new $c_Lscodec_Decoder$$anon$2(f$1, this$4);
  }));
  return new $c_Lscodec_Decoder$$anon$2(f$2, this$5).decode__Lscodec_bits_BitVector__Lscodec_Attempt(bits);
});
$c_Lscodec_codecs_DiscriminatorCodec.prototype.toString__T = (function() {
  return (("discriminated(" + this.Lscodec_codecs_DiscriminatorCodec__f_by) + ")");
});
var $d_Lscodec_codecs_DiscriminatorCodec = new $TypeData().initClass($c_Lscodec_codecs_DiscriminatorCodec, "scodec.codecs.DiscriminatorCodec", ({
  Lscodec_codecs_DiscriminatorCodec: 1,
  Lscodec_Encoder: 1,
  Lscodec_Decoder: 1,
  Lscodec_Codec: 1,
  Lscodec_codecs_KnownDiscriminatorType: 1
}));
export { $d_Lscodec_codecs_DiscriminatorCodec as $d_Lscodec_codecs_DiscriminatorCodec };
function $ct_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__Lscodec_codecs_KnownDiscriminatorType__O__sci_List__($thiz, outer, discriminator, context) {
  $thiz.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_discriminator = discriminator;
  $thiz.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_context = context;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  $thiz.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_$outer = outer;
  return $thiz;
}
export { $ct_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__Lscodec_codecs_KnownDiscriminatorType__O__sci_List__ as $ct_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__Lscodec_codecs_KnownDiscriminatorType__O__sci_List__ };
function $ct_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__Lscodec_codecs_KnownDiscriminatorType__O__($thiz, outer, discriminator) {
  $ct_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__Lscodec_codecs_KnownDiscriminatorType__O__sci_List__($thiz, outer, discriminator, $m_sci_Nil$());
  return $thiz;
}
export { $ct_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__Lscodec_codecs_KnownDiscriminatorType__O__ as $ct_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__Lscodec_codecs_KnownDiscriminatorType__O__ };
/** @constructor */
function $c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator() {
  this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_discriminator = null;
  this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_context = null;
  this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_$outer = null;
}
export { $c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator as $c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator };
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype = new $h_O();
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.constructor = $c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator;
/** @constructor */
function $h_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator() {
}
export { $h_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator as $h_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator };
$h_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype = $c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype;
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.toString__T = (function() {
  return $f_Lscodec_Err__messageWithContext__T(this);
});
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if (((x$0 instanceof $c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator) && (x$0.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_$outer === this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_$outer))) {
    var x = this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_discriminator;
    var y = x$0.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_discriminator;
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(x, y)) {
      var x$1 = this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_context;
      var x$2 = x$0.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_context;
      return ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.productArity__I = (function() {
  return 2;
});
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.productPrefix__T = (function() {
  return "UnknownDiscriminator";
});
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_discriminator;
  }
  if ((n === 1)) {
    return this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_context;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "discriminator";
  }
  if ((n === 1)) {
    return "context";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.context__sci_List = (function() {
  return this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_context;
});
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.message__T = (function() {
  return ("Unknown discriminator " + this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_discriminator);
});
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.pushContext__T__Lscodec_Err = (function(ctx) {
  var this$1 = this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_context;
  var context$1 = new $c_sci_$colon$colon(ctx, this$1);
  var discriminator$1 = this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_discriminator;
  return this.copy__O__sci_List__Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator(discriminator$1, context$1);
});
$c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator.prototype.copy__O__sci_List__Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator = (function(discriminator, context) {
  return $ct_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__Lscodec_codecs_KnownDiscriminatorType__O__sci_List__(new $c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator(), this.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator__f_$outer, discriminator, context);
});
function $isArrayOf_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator)));
}
export { $isArrayOf_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator as $isArrayOf_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator };
var $d_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator = new $TypeData().initClass($c_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator, "scodec.codecs.KnownDiscriminatorType$UnknownDiscriminator", ({
  Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator: 1,
  Lscodec_Err: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator as $d_Lscodec_codecs_KnownDiscriminatorType$UnknownDiscriminator };
/** @constructor */
function $c_Lscodec_codecs_codecs$package$$anon$16() {
}
export { $c_Lscodec_codecs_codecs$package$$anon$16 as $c_Lscodec_codecs_codecs$package$$anon$16 };
$c_Lscodec_codecs_codecs$package$$anon$16.prototype = new $h_sr_AbstractPartialFunction();
$c_Lscodec_codecs_codecs$package$$anon$16.prototype.constructor = $c_Lscodec_codecs_codecs$package$$anon$16;
/** @constructor */
function $h_Lscodec_codecs_codecs$package$$anon$16() {
}
export { $h_Lscodec_codecs_codecs$package$$anon$16 as $h_Lscodec_codecs_codecs$package$$anon$16 };
$h_Lscodec_codecs_codecs$package$$anon$16.prototype = $c_Lscodec_codecs_codecs$package$$anon$16.prototype;
$c_Lscodec_codecs_codecs$package$$anon$16.prototype.isDefinedAt__s_util_Either__Z = (function(x) {
  return (x instanceof $c_s_util_Left);
});
$c_Lscodec_codecs_codecs$package$$anon$16.prototype.applyOrElse__s_util_Either__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_util_Left)) {
    var l = x.s_util_Left__f_value;
    return l;
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lscodec_codecs_codecs$package$$anon$16.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Either__Z(x);
});
$c_Lscodec_codecs_codecs$package$$anon$16.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Either__F1__O(x, default$1);
});
var $d_Lscodec_codecs_codecs$package$$anon$16 = new $TypeData().initClass($c_Lscodec_codecs_codecs$package$$anon$16, "scodec.codecs.codecs$package$$anon$16", ({
  Lscodec_codecs_codecs$package$$anon$16: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_codecs_codecs$package$$anon$16 as $d_Lscodec_codecs_codecs$package$$anon$16 };
/** @constructor */
function $c_Lscodec_codecs_codecs$package$$anon$17() {
}
export { $c_Lscodec_codecs_codecs$package$$anon$17 as $c_Lscodec_codecs_codecs$package$$anon$17 };
$c_Lscodec_codecs_codecs$package$$anon$17.prototype = new $h_sr_AbstractPartialFunction();
$c_Lscodec_codecs_codecs$package$$anon$17.prototype.constructor = $c_Lscodec_codecs_codecs$package$$anon$17;
/** @constructor */
function $h_Lscodec_codecs_codecs$package$$anon$17() {
}
export { $h_Lscodec_codecs_codecs$package$$anon$17 as $h_Lscodec_codecs_codecs$package$$anon$17 };
$h_Lscodec_codecs_codecs$package$$anon$17.prototype = $c_Lscodec_codecs_codecs$package$$anon$17.prototype;
$c_Lscodec_codecs_codecs$package$$anon$17.prototype.isDefinedAt__s_util_Either__Z = (function(x) {
  return (x instanceof $c_s_util_Right);
});
$c_Lscodec_codecs_codecs$package$$anon$17.prototype.applyOrElse__s_util_Either__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_util_Right)) {
    var r = x.s_util_Right__f_value;
    return r;
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lscodec_codecs_codecs$package$$anon$17.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_util_Either__Z(x);
});
$c_Lscodec_codecs_codecs$package$$anon$17.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_util_Either__F1__O(x, default$1);
});
var $d_Lscodec_codecs_codecs$package$$anon$17 = new $TypeData().initClass($c_Lscodec_codecs_codecs$package$$anon$17, "scodec.codecs.codecs$package$$anon$17", ({
  Lscodec_codecs_codecs$package$$anon$17: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_codecs_codecs$package$$anon$17 as $d_Lscodec_codecs_codecs$package$$anon$17 };
/** @constructor */
function $c_Lsquants_space_InternationalMiles$() {
  this.Lsquants_space_InternationalMiles$__f_conversionFactor = 0.0;
  this.Lsquants_space_InternationalMiles$__f_symbol = null;
  this.Lsquants_space_InternationalMiles$__f_conversionFactor = 1609.344;
  this.Lsquants_space_InternationalMiles$__f_symbol = "mile";
}
export { $c_Lsquants_space_InternationalMiles$ as $c_Lsquants_space_InternationalMiles$ };
$c_Lsquants_space_InternationalMiles$.prototype = new $h_O();
$c_Lsquants_space_InternationalMiles$.prototype.constructor = $c_Lsquants_space_InternationalMiles$;
/** @constructor */
function $h_Lsquants_space_InternationalMiles$() {
}
export { $h_Lsquants_space_InternationalMiles$ as $h_Lsquants_space_InternationalMiles$ };
$h_Lsquants_space_InternationalMiles$.prototype = $c_Lsquants_space_InternationalMiles$.prototype;
$c_Lsquants_space_InternationalMiles$.prototype.converterTo__F1 = (function() {
  return $f_Lsquants_UnitConverter__converterTo__F1(this);
});
$c_Lsquants_space_InternationalMiles$.prototype.converterFrom__F1 = (function() {
  return $f_Lsquants_UnitConverter__converterFrom__F1(this);
});
$c_Lsquants_space_InternationalMiles$.prototype.conversionFactor__D = (function() {
  return 1609.344;
});
$c_Lsquants_space_InternationalMiles$.prototype.symbol__T = (function() {
  return "mile";
});
var $d_Lsquants_space_InternationalMiles$ = new $TypeData().initClass($c_Lsquants_space_InternationalMiles$, "squants.space.InternationalMiles$", ({
  Lsquants_space_InternationalMiles$: 1,
  Ljava_io_Serializable: 1,
  Lsquants_UnitOfMeasure: 1,
  Lsquants_UnitConverter: 1,
  Lsquants_space_LengthUnit: 1
}));
export { $d_Lsquants_space_InternationalMiles$ as $d_Lsquants_space_InternationalMiles$ };
var $n_Lsquants_space_InternationalMiles$;
function $m_Lsquants_space_InternationalMiles$() {
  if ((!$n_Lsquants_space_InternationalMiles$)) {
    $n_Lsquants_space_InternationalMiles$ = new $c_Lsquants_space_InternationalMiles$();
  }
  return $n_Lsquants_space_InternationalMiles$;
}
export { $m_Lsquants_space_InternationalMiles$ as $m_Lsquants_space_InternationalMiles$ };
/** @constructor */
function $c_Lsttp_model_Part(name, body, otherDispositionParams, headers) {
  this.Lsttp_model_Part__f_name = null;
  this.Lsttp_model_Part__f_body = null;
  this.Lsttp_model_Part__f_otherDispositionParams = null;
  this.Lsttp_model_Part__f_headers = null;
  this.Lsttp_model_Part__f_name = name;
  this.Lsttp_model_Part__f_body = body;
  this.Lsttp_model_Part__f_otherDispositionParams = otherDispositionParams;
  this.Lsttp_model_Part__f_headers = headers;
}
export { $c_Lsttp_model_Part as $c_Lsttp_model_Part };
$c_Lsttp_model_Part.prototype = new $h_O();
$c_Lsttp_model_Part.prototype.constructor = $c_Lsttp_model_Part;
/** @constructor */
function $h_Lsttp_model_Part() {
}
export { $h_Lsttp_model_Part as $h_Lsttp_model_Part };
$h_Lsttp_model_Part.prototype = $c_Lsttp_model_Part.prototype;
$c_Lsttp_model_Part.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Part.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 2007195162, true);
});
$c_Lsttp_model_Part.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_Part)) {
    if ((this.Lsttp_model_Part__f_name === x$0.Lsttp_model_Part__f_name)) {
      var x = this.Lsttp_model_Part__f_body;
      var y = x$0.Lsttp_model_Part__f_body;
      var $x_2 = $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$1 = this.Lsttp_model_Part__f_otherDispositionParams;
      var x$2 = x$0.Lsttp_model_Part__f_otherDispositionParams;
      var $x_1 = ((x$1 === null) ? (x$2 === null) : x$1.equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lsttp_model_Part__f_headers;
      var x$4 = x$0.Lsttp_model_Part__f_headers;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_model_Part.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_model_Part.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_model_Part.prototype.productPrefix__T = (function() {
  return "Part";
});
$c_Lsttp_model_Part.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_model_Part__f_name;
      break;
    }
    case 1: {
      return this.Lsttp_model_Part__f_body;
      break;
    }
    case 2: {
      return this.Lsttp_model_Part__f_otherDispositionParams;
      break;
    }
    case 3: {
      return this.Lsttp_model_Part__f_headers;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_Part.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "body";
      break;
    }
    case 2: {
      return "otherDispositionParams";
      break;
    }
    case 3: {
      return "headers";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_Part.prototype.headers__sci_Seq = (function() {
  return this.Lsttp_model_Part__f_headers;
});
$c_Lsttp_model_Part.prototype.dispositionParam__T__T__Lsttp_model_Part = (function(k, v) {
  var otherDispositionParams$1 = this.Lsttp_model_Part__f_otherDispositionParams.$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), k, v));
  var name$1 = this.Lsttp_model_Part__f_name;
  var body$1 = this.Lsttp_model_Part__f_body;
  var headers$1 = this.Lsttp_model_Part__f_headers;
  return new $c_Lsttp_model_Part(name$1, body$1, otherDispositionParams$1, headers$1);
});
$c_Lsttp_model_Part.prototype.fileName__s_Option = (function() {
  var this$1 = this.Lsttp_model_Part__f_otherDispositionParams.get__O__s_Option("filename*");
  return (this$1.isEmpty__Z() ? this.Lsttp_model_Part__f_otherDispositionParams.get__O__s_Option("filename") : this$1);
});
$c_Lsttp_model_Part.prototype.contentType__Lsttp_model_MediaType__Lsttp_model_Part = (function(v) {
  $m_Lsttp_model_Header$();
  $m_Lsttp_model_Header$();
  var name = $m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType;
  var value = $p_Lsttp_model_MediaType__toStringCache__T(v);
  return this.header__Lsttp_model_Header__Z__Lsttp_model_Part(new $c_Lsttp_model_Header(name, value), true);
});
$c_Lsttp_model_Part.prototype.header__Lsttp_model_Header__Z__Lsttp_model_Part = (function(h, replaceExisting) {
  var current = (replaceExisting ? this.Lsttp_model_Part__f_headers.filterNot__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    var otherName = h.Lsttp_model_Header__f_name;
    var this$1 = _$1.Lsttp_model_Header__f_name;
    var len = this$1.length;
    if ((!((otherName === null) || (otherName.length !== len)))) {
      var i = 0;
      while ((i !== len)) {
        var index = i;
        var c = this$1.charCodeAt(index);
        var $x_1 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
        var index$1 = i;
        var c$1 = otherName.charCodeAt(index$1);
        if (($x_1 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    } else {
      return false;
    }
  }))) : this.Lsttp_model_Part__f_headers);
  var headers$2 = current.appended__O__O(h);
  var name$2 = this.Lsttp_model_Part__f_name;
  var body$2 = this.Lsttp_model_Part__f_body;
  var otherDispositionParams$2 = this.Lsttp_model_Part__f_otherDispositionParams;
  return new $c_Lsttp_model_Part(name$2, body$2, otherDispositionParams$2, headers$2);
});
function $isArrayOf_Lsttp_model_Part(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Part)));
}
export { $isArrayOf_Lsttp_model_Part as $isArrayOf_Lsttp_model_Part };
var $d_Lsttp_model_Part = new $TypeData().initClass($c_Lsttp_model_Part, "sttp.model.Part", ({
  Lsttp_model_Part: 1,
  Lsttp_model_HasHeaders: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_Part as $d_Lsttp_model_Part };
/** @constructor */
function $c_Lsttp_model_Uri$AbsolutePath(segments) {
  this.Lsttp_model_Uri$AbsolutePath__f_segments = null;
  this.Lsttp_model_Uri$AbsolutePath__f_segments = segments;
}
export { $c_Lsttp_model_Uri$AbsolutePath as $c_Lsttp_model_Uri$AbsolutePath };
$c_Lsttp_model_Uri$AbsolutePath.prototype = new $h_O();
$c_Lsttp_model_Uri$AbsolutePath.prototype.constructor = $c_Lsttp_model_Uri$AbsolutePath;
/** @constructor */
function $h_Lsttp_model_Uri$AbsolutePath() {
}
export { $h_Lsttp_model_Uri$AbsolutePath as $h_Lsttp_model_Uri$AbsolutePath };
$h_Lsttp_model_Uri$AbsolutePath.prototype = $c_Lsttp_model_Uri$AbsolutePath.prototype;
$c_Lsttp_model_Uri$AbsolutePath.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Uri$AbsolutePath.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1796778336), true);
});
$c_Lsttp_model_Uri$AbsolutePath.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_Uri$AbsolutePath)) {
    var x = this.Lsttp_model_Uri$AbsolutePath__f_segments;
    var x$2 = x$0.Lsttp_model_Uri$AbsolutePath__f_segments;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_Uri$AbsolutePath.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_Uri$AbsolutePath.prototype.productPrefix__T = (function() {
  return "AbsolutePath";
});
$c_Lsttp_model_Uri$AbsolutePath.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_Uri$AbsolutePath__f_segments;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Uri$AbsolutePath.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "segments";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Uri$AbsolutePath.prototype.toString__T = (function() {
  var this$1 = this.Lsttp_model_Uri$AbsolutePath__f_segments.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$48) => _$48.Lsttp_model_Uri$Segment__f_encoding.apply__O__O(_$48.Lsttp_model_Uri$Segment__f_v))));
  return ("/" + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", "/", ""));
});
$c_Lsttp_model_Uri$AbsolutePath.prototype.segments__sc_Seq = (function() {
  return this.Lsttp_model_Uri$AbsolutePath__f_segments;
});
$c_Lsttp_model_Uri$AbsolutePath.prototype.withSegments__sc_Seq__Lsttp_model_Uri$PathSegments = (function(ss) {
  var segments = ss.toList__sci_List();
  return new $c_Lsttp_model_Uri$AbsolutePath(segments);
});
function $isArrayOf_Lsttp_model_Uri$AbsolutePath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Uri$AbsolutePath)));
}
export { $isArrayOf_Lsttp_model_Uri$AbsolutePath as $isArrayOf_Lsttp_model_Uri$AbsolutePath };
var $d_Lsttp_model_Uri$AbsolutePath = new $TypeData().initClass($c_Lsttp_model_Uri$AbsolutePath, "sttp.model.Uri$AbsolutePath", ({
  Lsttp_model_Uri$AbsolutePath: 1,
  Lsttp_model_Uri$PathSegments: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_Uri$AbsolutePath as $d_Lsttp_model_Uri$AbsolutePath };
/** @constructor */
function $c_Lsttp_model_Uri$QuerySegment$KeyValue(k, v, keyEncoding, valueEncoding) {
  this.Lsttp_model_Uri$QuerySegment$KeyValue__f_k = null;
  this.Lsttp_model_Uri$QuerySegment$KeyValue__f_v = null;
  this.Lsttp_model_Uri$QuerySegment$KeyValue__f_keyEncoding = null;
  this.Lsttp_model_Uri$QuerySegment$KeyValue__f_valueEncoding = null;
  this.Lsttp_model_Uri$QuerySegment$KeyValue__f_k = k;
  this.Lsttp_model_Uri$QuerySegment$KeyValue__f_v = v;
  this.Lsttp_model_Uri$QuerySegment$KeyValue__f_keyEncoding = keyEncoding;
  this.Lsttp_model_Uri$QuerySegment$KeyValue__f_valueEncoding = valueEncoding;
}
export { $c_Lsttp_model_Uri$QuerySegment$KeyValue as $c_Lsttp_model_Uri$QuerySegment$KeyValue };
$c_Lsttp_model_Uri$QuerySegment$KeyValue.prototype = new $h_O();
$c_Lsttp_model_Uri$QuerySegment$KeyValue.prototype.constructor = $c_Lsttp_model_Uri$QuerySegment$KeyValue;
/** @constructor */
function $h_Lsttp_model_Uri$QuerySegment$KeyValue() {
}
export { $h_Lsttp_model_Uri$QuerySegment$KeyValue as $h_Lsttp_model_Uri$QuerySegment$KeyValue };
$h_Lsttp_model_Uri$QuerySegment$KeyValue.prototype = $c_Lsttp_model_Uri$QuerySegment$KeyValue.prototype;
$c_Lsttp_model_Uri$QuerySegment$KeyValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Uri$QuerySegment$KeyValue.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-2082581853), true);
});
$c_Lsttp_model_Uri$QuerySegment$KeyValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_Uri$QuerySegment$KeyValue)) {
    if (((this.Lsttp_model_Uri$QuerySegment$KeyValue__f_k === x$0.Lsttp_model_Uri$QuerySegment$KeyValue__f_k) && (this.Lsttp_model_Uri$QuerySegment$KeyValue__f_v === x$0.Lsttp_model_Uri$QuerySegment$KeyValue__f_v))) {
      var x = this.Lsttp_model_Uri$QuerySegment$KeyValue__f_keyEncoding;
      var x$2 = x$0.Lsttp_model_Uri$QuerySegment$KeyValue__f_keyEncoding;
      var $x_1 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.Lsttp_model_Uri$QuerySegment$KeyValue__f_valueEncoding;
      var x$4 = x$0.Lsttp_model_Uri$QuerySegment$KeyValue__f_valueEncoding;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_model_Uri$QuerySegment$KeyValue.prototype.productArity__I = (function() {
  return 4;
});
$c_Lsttp_model_Uri$QuerySegment$KeyValue.prototype.productPrefix__T = (function() {
  return "KeyValue";
});
$c_Lsttp_model_Uri$QuerySegment$KeyValue.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_model_Uri$QuerySegment$KeyValue__f_k;
      break;
    }
    case 1: {
      return this.Lsttp_model_Uri$QuerySegment$KeyValue__f_v;
      break;
    }
    case 2: {
      return this.Lsttp_model_Uri$QuerySegment$KeyValue__f_keyEncoding;
      break;
    }
    case 3: {
      return this.Lsttp_model_Uri$QuerySegment$KeyValue__f_valueEncoding;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_Uri$QuerySegment$KeyValue.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "k";
      break;
    }
    case 1: {
      return "v";
      break;
    }
    case 2: {
      return "keyEncoding";
      break;
    }
    case 3: {
      return "valueEncoding";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_model_Uri$QuerySegment$KeyValue.prototype.toString__T = (function() {
  return (((("KeyValue(" + this.Lsttp_model_Uri$QuerySegment$KeyValue__f_k) + ",") + this.Lsttp_model_Uri$QuerySegment$KeyValue__f_v) + ",[keyEncoding],[valueEncoding])");
});
function $isArrayOf_Lsttp_model_Uri$QuerySegment$KeyValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Uri$QuerySegment$KeyValue)));
}
export { $isArrayOf_Lsttp_model_Uri$QuerySegment$KeyValue as $isArrayOf_Lsttp_model_Uri$QuerySegment$KeyValue };
var $d_Lsttp_model_Uri$QuerySegment$KeyValue = new $TypeData().initClass($c_Lsttp_model_Uri$QuerySegment$KeyValue, "sttp.model.Uri$QuerySegment$KeyValue", ({
  Lsttp_model_Uri$QuerySegment$KeyValue: 1,
  Lsttp_model_Uri$QuerySegment: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_Uri$QuerySegment$KeyValue as $d_Lsttp_model_Uri$QuerySegment$KeyValue };
function $isArrayOf_Lsttp_model_Uri$QuerySegment$Plain(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Uri$QuerySegment$Plain)));
}
export { $isArrayOf_Lsttp_model_Uri$QuerySegment$Plain as $isArrayOf_Lsttp_model_Uri$QuerySegment$Plain };
/** @constructor */
function $c_Lsttp_model_Uri$QuerySegment$Value(v, encoding) {
  this.Lsttp_model_Uri$QuerySegment$Value__f_v = null;
  this.Lsttp_model_Uri$QuerySegment$Value__f_encoding = null;
  this.Lsttp_model_Uri$QuerySegment$Value__f_v = v;
  this.Lsttp_model_Uri$QuerySegment$Value__f_encoding = encoding;
}
export { $c_Lsttp_model_Uri$QuerySegment$Value as $c_Lsttp_model_Uri$QuerySegment$Value };
$c_Lsttp_model_Uri$QuerySegment$Value.prototype = new $h_O();
$c_Lsttp_model_Uri$QuerySegment$Value.prototype.constructor = $c_Lsttp_model_Uri$QuerySegment$Value;
/** @constructor */
function $h_Lsttp_model_Uri$QuerySegment$Value() {
}
export { $h_Lsttp_model_Uri$QuerySegment$Value as $h_Lsttp_model_Uri$QuerySegment$Value };
$h_Lsttp_model_Uri$QuerySegment$Value.prototype = $c_Lsttp_model_Uri$QuerySegment$Value.prototype;
$c_Lsttp_model_Uri$QuerySegment$Value.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Uri$QuerySegment$Value.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-817380036), true);
});
$c_Lsttp_model_Uri$QuerySegment$Value.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_Uri$QuerySegment$Value)) {
    if ((this.Lsttp_model_Uri$QuerySegment$Value__f_v === x$0.Lsttp_model_Uri$QuerySegment$Value__f_v)) {
      var x = this.Lsttp_model_Uri$QuerySegment$Value__f_encoding;
      var x$2 = x$0.Lsttp_model_Uri$QuerySegment$Value__f_encoding;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_model_Uri$QuerySegment$Value.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_model_Uri$QuerySegment$Value.prototype.productPrefix__T = (function() {
  return "Value";
});
$c_Lsttp_model_Uri$QuerySegment$Value.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_Uri$QuerySegment$Value__f_v;
  }
  if ((n === 1)) {
    return this.Lsttp_model_Uri$QuerySegment$Value__f_encoding;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Uri$QuerySegment$Value.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "v";
  }
  if ((n === 1)) {
    return "encoding";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Uri$QuerySegment$Value.prototype.toString__T = (function() {
  return (("Value(" + this.Lsttp_model_Uri$QuerySegment$Value__f_v) + ",[encoding])");
});
function $isArrayOf_Lsttp_model_Uri$QuerySegment$Value(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Uri$QuerySegment$Value)));
}
export { $isArrayOf_Lsttp_model_Uri$QuerySegment$Value as $isArrayOf_Lsttp_model_Uri$QuerySegment$Value };
var $d_Lsttp_model_Uri$QuerySegment$Value = new $TypeData().initClass($c_Lsttp_model_Uri$QuerySegment$Value, "sttp.model.Uri$QuerySegment$Value", ({
  Lsttp_model_Uri$QuerySegment$Value: 1,
  Lsttp_model_Uri$QuerySegment: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_Uri$QuerySegment$Value as $d_Lsttp_model_Uri$QuerySegment$Value };
/** @constructor */
function $c_Lsttp_model_Uri$RelativePath(segments) {
  this.Lsttp_model_Uri$RelativePath__f_segments = null;
  this.Lsttp_model_Uri$RelativePath__f_segments = segments;
}
export { $c_Lsttp_model_Uri$RelativePath as $c_Lsttp_model_Uri$RelativePath };
$c_Lsttp_model_Uri$RelativePath.prototype = new $h_O();
$c_Lsttp_model_Uri$RelativePath.prototype.constructor = $c_Lsttp_model_Uri$RelativePath;
/** @constructor */
function $h_Lsttp_model_Uri$RelativePath() {
}
export { $h_Lsttp_model_Uri$RelativePath as $h_Lsttp_model_Uri$RelativePath };
$h_Lsttp_model_Uri$RelativePath.prototype = $c_Lsttp_model_Uri$RelativePath.prototype;
$c_Lsttp_model_Uri$RelativePath.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Uri$RelativePath.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1123545830), true);
});
$c_Lsttp_model_Uri$RelativePath.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_Uri$RelativePath)) {
    var x = this.Lsttp_model_Uri$RelativePath__f_segments;
    var x$2 = x$0.Lsttp_model_Uri$RelativePath__f_segments;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_Uri$RelativePath.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_Uri$RelativePath.prototype.productPrefix__T = (function() {
  return "RelativePath";
});
$c_Lsttp_model_Uri$RelativePath.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_Uri$RelativePath__f_segments;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Uri$RelativePath.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "segments";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Uri$RelativePath.prototype.toString__T = (function() {
  var this$1 = this.Lsttp_model_Uri$RelativePath__f_segments.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$49) => _$49.Lsttp_model_Uri$Segment__f_encoding.apply__O__O(_$49.Lsttp_model_Uri$Segment__f_v))));
  return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$1, "", "/", "");
});
$c_Lsttp_model_Uri$RelativePath.prototype.segments__sc_Seq = (function() {
  return this.Lsttp_model_Uri$RelativePath__f_segments;
});
$c_Lsttp_model_Uri$RelativePath.prototype.withSegments__sc_Seq__Lsttp_model_Uri$PathSegments = (function(ss) {
  var segments = ss.toList__sci_List();
  return new $c_Lsttp_model_Uri$RelativePath(segments);
});
function $isArrayOf_Lsttp_model_Uri$RelativePath(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_Uri$RelativePath)));
}
export { $isArrayOf_Lsttp_model_Uri$RelativePath as $isArrayOf_Lsttp_model_Uri$RelativePath };
var $d_Lsttp_model_Uri$RelativePath = new $TypeData().initClass($c_Lsttp_model_Uri$RelativePath, "sttp.model.Uri$RelativePath", ({
  Lsttp_model_Uri$RelativePath: 1,
  Lsttp_model_Uri$PathSegments: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_Uri$RelativePath as $d_Lsttp_model_Uri$RelativePath };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$ExpressionToken(e) {
  this.Lsttp_model_UriInterpolator$ExpressionToken__f_e = null;
  this.Lsttp_model_UriInterpolator$ExpressionToken__f_e = e;
}
export { $c_Lsttp_model_UriInterpolator$ExpressionToken as $c_Lsttp_model_UriInterpolator$ExpressionToken };
$c_Lsttp_model_UriInterpolator$ExpressionToken.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$ExpressionToken.prototype.constructor = $c_Lsttp_model_UriInterpolator$ExpressionToken;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$ExpressionToken() {
}
export { $h_Lsttp_model_UriInterpolator$ExpressionToken as $h_Lsttp_model_UriInterpolator$ExpressionToken };
$h_Lsttp_model_UriInterpolator$ExpressionToken.prototype = $c_Lsttp_model_UriInterpolator$ExpressionToken.prototype;
$c_Lsttp_model_UriInterpolator$ExpressionToken.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$ExpressionToken.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-2063964921), true);
});
$c_Lsttp_model_UriInterpolator$ExpressionToken.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_UriInterpolator$ExpressionToken)) {
    var x = this.Lsttp_model_UriInterpolator$ExpressionToken__f_e;
    var y = x$0.Lsttp_model_UriInterpolator$ExpressionToken__f_e;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lsttp_model_UriInterpolator$ExpressionToken.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_model_UriInterpolator$ExpressionToken.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_UriInterpolator$ExpressionToken.prototype.productPrefix__T = (function() {
  return "ExpressionToken";
});
$c_Lsttp_model_UriInterpolator$ExpressionToken.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_UriInterpolator$ExpressionToken__f_e;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$ExpressionToken.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "e";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_model_UriInterpolator$ExpressionToken(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_UriInterpolator$ExpressionToken)));
}
export { $isArrayOf_Lsttp_model_UriInterpolator$ExpressionToken as $isArrayOf_Lsttp_model_UriInterpolator$ExpressionToken };
var $d_Lsttp_model_UriInterpolator$ExpressionToken = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$ExpressionToken, "sttp.model.UriInterpolator$ExpressionToken", ({
  Lsttp_model_UriInterpolator$ExpressionToken: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_UriInterpolator$ExpressionToken as $d_Lsttp_model_UriInterpolator$ExpressionToken };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$StringToken(s) {
  this.Lsttp_model_UriInterpolator$StringToken__f_s = null;
  this.Lsttp_model_UriInterpolator$StringToken__f_s = s;
}
export { $c_Lsttp_model_UriInterpolator$StringToken as $c_Lsttp_model_UriInterpolator$StringToken };
$c_Lsttp_model_UriInterpolator$StringToken.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$StringToken.prototype.constructor = $c_Lsttp_model_UriInterpolator$StringToken;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$StringToken() {
}
export { $h_Lsttp_model_UriInterpolator$StringToken as $h_Lsttp_model_UriInterpolator$StringToken };
$h_Lsttp_model_UriInterpolator$StringToken.prototype = $c_Lsttp_model_UriInterpolator$StringToken.prototype;
$c_Lsttp_model_UriInterpolator$StringToken.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$StringToken.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1974787337), true);
});
$c_Lsttp_model_UriInterpolator$StringToken.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lsttp_model_UriInterpolator$StringToken) && (this.Lsttp_model_UriInterpolator$StringToken__f_s === x$0.Lsttp_model_UriInterpolator$StringToken__f_s)));
});
$c_Lsttp_model_UriInterpolator$StringToken.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_model_UriInterpolator$StringToken.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_UriInterpolator$StringToken.prototype.productPrefix__T = (function() {
  return "StringToken";
});
$c_Lsttp_model_UriInterpolator$StringToken.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_UriInterpolator$StringToken__f_s;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$StringToken.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "s";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_model_UriInterpolator$StringToken(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_UriInterpolator$StringToken)));
}
export { $isArrayOf_Lsttp_model_UriInterpolator$StringToken as $isArrayOf_Lsttp_model_UriInterpolator$StringToken };
var $d_Lsttp_model_UriInterpolator$StringToken = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$StringToken, "sttp.model.UriInterpolator$StringToken", ({
  Lsttp_model_UriInterpolator$StringToken: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_UriInterpolator$StringToken as $d_Lsttp_model_UriInterpolator$StringToken };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$MaxAge(d) {
  this.Lsttp_model_headers_CacheDirective$MaxAge__f_d = null;
  this.Lsttp_model_headers_CacheDirective$MaxAge__f_d = d;
}
export { $c_Lsttp_model_headers_CacheDirective$MaxAge as $c_Lsttp_model_headers_CacheDirective$MaxAge };
$c_Lsttp_model_headers_CacheDirective$MaxAge.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$MaxAge.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$MaxAge;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$MaxAge() {
}
export { $h_Lsttp_model_headers_CacheDirective$MaxAge as $h_Lsttp_model_headers_CacheDirective$MaxAge };
$h_Lsttp_model_headers_CacheDirective$MaxAge.prototype = $c_Lsttp_model_headers_CacheDirective$MaxAge.prototype;
$c_Lsttp_model_headers_CacheDirective$MaxAge.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$MaxAge.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1770425541), true);
});
$c_Lsttp_model_headers_CacheDirective$MaxAge.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$MaxAge)) {
    var x = this.Lsttp_model_headers_CacheDirective$MaxAge__f_d;
    var x$2 = x$0.Lsttp_model_headers_CacheDirective$MaxAge__f_d;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_headers_CacheDirective$MaxAge.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_headers_CacheDirective$MaxAge.prototype.productPrefix__T = (function() {
  return "MaxAge";
});
$c_Lsttp_model_headers_CacheDirective$MaxAge.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_headers_CacheDirective$MaxAge__f_d;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$MaxAge.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "d";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$MaxAge.prototype.toString__T = (function() {
  var this$1 = this.Lsttp_model_headers_CacheDirective$MaxAge__f_d;
  return ("max-age=" + this$1.s_concurrent_duration_FiniteDuration__f_unit.toSeconds__J__J(this$1.s_concurrent_duration_FiniteDuration__f_length));
});
function $isArrayOf_Lsttp_model_headers_CacheDirective$MaxAge(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_headers_CacheDirective$MaxAge)));
}
export { $isArrayOf_Lsttp_model_headers_CacheDirective$MaxAge as $isArrayOf_Lsttp_model_headers_CacheDirective$MaxAge };
var $d_Lsttp_model_headers_CacheDirective$MaxAge = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$MaxAge, "sttp.model.headers.CacheDirective$MaxAge", ({
  Lsttp_model_headers_CacheDirective$MaxAge: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$MaxAge as $d_Lsttp_model_headers_CacheDirective$MaxAge };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$MaxStale(d) {
  this.Lsttp_model_headers_CacheDirective$MaxStale__f_d = null;
  this.Lsttp_model_headers_CacheDirective$MaxStale__f_d = d;
}
export { $c_Lsttp_model_headers_CacheDirective$MaxStale as $c_Lsttp_model_headers_CacheDirective$MaxStale };
$c_Lsttp_model_headers_CacheDirective$MaxStale.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$MaxStale.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$MaxStale;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$MaxStale() {
}
export { $h_Lsttp_model_headers_CacheDirective$MaxStale as $h_Lsttp_model_headers_CacheDirective$MaxStale };
$h_Lsttp_model_headers_CacheDirective$MaxStale.prototype = $c_Lsttp_model_headers_CacheDirective$MaxStale.prototype;
$c_Lsttp_model_headers_CacheDirective$MaxStale.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$MaxStale.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 897387591, true);
});
$c_Lsttp_model_headers_CacheDirective$MaxStale.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$MaxStale)) {
    var x = this.Lsttp_model_headers_CacheDirective$MaxStale__f_d;
    var x$2 = x$0.Lsttp_model_headers_CacheDirective$MaxStale__f_d;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_headers_CacheDirective$MaxStale.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_headers_CacheDirective$MaxStale.prototype.productPrefix__T = (function() {
  return "MaxStale";
});
$c_Lsttp_model_headers_CacheDirective$MaxStale.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_headers_CacheDirective$MaxStale__f_d;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$MaxStale.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "d";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$MaxStale.prototype.toString__T = (function() {
  var this$1 = this.Lsttp_model_headers_CacheDirective$MaxStale__f_d;
  if (this$1.isEmpty__Z()) {
    var $x_1 = "";
  } else {
    var x0 = this$1.get__O();
    var this$2 = x0.s_concurrent_duration_FiniteDuration__f_unit.toSeconds__J__J(x0.s_concurrent_duration_FiniteDuration__f_length);
    var this$3 = $m_RTLong$();
    var $x_1 = this$3.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$2.RTLong__f_lo, this$2.RTLong__f_hi);
  }
  return ("max-stale" + $x_1);
});
function $isArrayOf_Lsttp_model_headers_CacheDirective$MaxStale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_headers_CacheDirective$MaxStale)));
}
export { $isArrayOf_Lsttp_model_headers_CacheDirective$MaxStale as $isArrayOf_Lsttp_model_headers_CacheDirective$MaxStale };
var $d_Lsttp_model_headers_CacheDirective$MaxStale = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$MaxStale, "sttp.model.headers.CacheDirective$MaxStale", ({
  Lsttp_model_headers_CacheDirective$MaxStale: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$MaxStale as $d_Lsttp_model_headers_CacheDirective$MaxStale };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$MinFresh(d) {
  this.Lsttp_model_headers_CacheDirective$MinFresh__f_d = null;
  this.Lsttp_model_headers_CacheDirective$MinFresh__f_d = d;
}
export { $c_Lsttp_model_headers_CacheDirective$MinFresh as $c_Lsttp_model_headers_CacheDirective$MinFresh };
$c_Lsttp_model_headers_CacheDirective$MinFresh.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$MinFresh.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$MinFresh;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$MinFresh() {
}
export { $h_Lsttp_model_headers_CacheDirective$MinFresh as $h_Lsttp_model_headers_CacheDirective$MinFresh };
$h_Lsttp_model_headers_CacheDirective$MinFresh.prototype = $c_Lsttp_model_headers_CacheDirective$MinFresh.prototype;
$c_Lsttp_model_headers_CacheDirective$MinFresh.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$MinFresh.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 46233733, true);
});
$c_Lsttp_model_headers_CacheDirective$MinFresh.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$MinFresh)) {
    var x = this.Lsttp_model_headers_CacheDirective$MinFresh__f_d;
    var x$2 = x$0.Lsttp_model_headers_CacheDirective$MinFresh__f_d;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_headers_CacheDirective$MinFresh.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_headers_CacheDirective$MinFresh.prototype.productPrefix__T = (function() {
  return "MinFresh";
});
$c_Lsttp_model_headers_CacheDirective$MinFresh.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_headers_CacheDirective$MinFresh__f_d;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$MinFresh.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "d";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$MinFresh.prototype.toString__T = (function() {
  var this$1 = this.Lsttp_model_headers_CacheDirective$MinFresh__f_d;
  return ("min-fresh=" + this$1.s_concurrent_duration_FiniteDuration__f_unit.toSeconds__J__J(this$1.s_concurrent_duration_FiniteDuration__f_length));
});
function $isArrayOf_Lsttp_model_headers_CacheDirective$MinFresh(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_headers_CacheDirective$MinFresh)));
}
export { $isArrayOf_Lsttp_model_headers_CacheDirective$MinFresh as $isArrayOf_Lsttp_model_headers_CacheDirective$MinFresh };
var $d_Lsttp_model_headers_CacheDirective$MinFresh = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$MinFresh, "sttp.model.headers.CacheDirective$MinFresh", ({
  Lsttp_model_headers_CacheDirective$MinFresh: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$MinFresh as $d_Lsttp_model_headers_CacheDirective$MinFresh };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$SMaxage(d) {
  this.Lsttp_model_headers_CacheDirective$SMaxage__f_d = null;
  this.Lsttp_model_headers_CacheDirective$SMaxage__f_d = d;
}
export { $c_Lsttp_model_headers_CacheDirective$SMaxage as $c_Lsttp_model_headers_CacheDirective$SMaxage };
$c_Lsttp_model_headers_CacheDirective$SMaxage.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$SMaxage.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$SMaxage;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$SMaxage() {
}
export { $h_Lsttp_model_headers_CacheDirective$SMaxage as $h_Lsttp_model_headers_CacheDirective$SMaxage };
$h_Lsttp_model_headers_CacheDirective$SMaxage.prototype = $c_Lsttp_model_headers_CacheDirective$SMaxage.prototype;
$c_Lsttp_model_headers_CacheDirective$SMaxage.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$SMaxage.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-229012697), true);
});
$c_Lsttp_model_headers_CacheDirective$SMaxage.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$SMaxage)) {
    var x = this.Lsttp_model_headers_CacheDirective$SMaxage__f_d;
    var x$2 = x$0.Lsttp_model_headers_CacheDirective$SMaxage__f_d;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_headers_CacheDirective$SMaxage.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_headers_CacheDirective$SMaxage.prototype.productPrefix__T = (function() {
  return "SMaxage";
});
$c_Lsttp_model_headers_CacheDirective$SMaxage.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_headers_CacheDirective$SMaxage__f_d;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$SMaxage.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "d";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$SMaxage.prototype.toString__T = (function() {
  var this$1 = this.Lsttp_model_headers_CacheDirective$SMaxage__f_d;
  return ("s-maxage=" + this$1.s_concurrent_duration_FiniteDuration__f_unit.toSeconds__J__J(this$1.s_concurrent_duration_FiniteDuration__f_length));
});
function $isArrayOf_Lsttp_model_headers_CacheDirective$SMaxage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_headers_CacheDirective$SMaxage)));
}
export { $isArrayOf_Lsttp_model_headers_CacheDirective$SMaxage as $isArrayOf_Lsttp_model_headers_CacheDirective$SMaxage };
var $d_Lsttp_model_headers_CacheDirective$SMaxage = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$SMaxage, "sttp.model.headers.CacheDirective$SMaxage", ({
  Lsttp_model_headers_CacheDirective$SMaxage: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$SMaxage as $d_Lsttp_model_headers_CacheDirective$SMaxage };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$StaleIfError(d) {
  this.Lsttp_model_headers_CacheDirective$StaleIfError__f_d = null;
  this.Lsttp_model_headers_CacheDirective$StaleIfError__f_d = d;
}
export { $c_Lsttp_model_headers_CacheDirective$StaleIfError as $c_Lsttp_model_headers_CacheDirective$StaleIfError };
$c_Lsttp_model_headers_CacheDirective$StaleIfError.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$StaleIfError.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$StaleIfError;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$StaleIfError() {
}
export { $h_Lsttp_model_headers_CacheDirective$StaleIfError as $h_Lsttp_model_headers_CacheDirective$StaleIfError };
$h_Lsttp_model_headers_CacheDirective$StaleIfError.prototype = $c_Lsttp_model_headers_CacheDirective$StaleIfError.prototype;
$c_Lsttp_model_headers_CacheDirective$StaleIfError.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$StaleIfError.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1272923724, true);
});
$c_Lsttp_model_headers_CacheDirective$StaleIfError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$StaleIfError)) {
    var x = this.Lsttp_model_headers_CacheDirective$StaleIfError__f_d;
    var x$2 = x$0.Lsttp_model_headers_CacheDirective$StaleIfError__f_d;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_headers_CacheDirective$StaleIfError.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_headers_CacheDirective$StaleIfError.prototype.productPrefix__T = (function() {
  return "StaleIfError";
});
$c_Lsttp_model_headers_CacheDirective$StaleIfError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_headers_CacheDirective$StaleIfError__f_d;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$StaleIfError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "d";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$StaleIfError.prototype.toString__T = (function() {
  var this$1 = this.Lsttp_model_headers_CacheDirective$StaleIfError__f_d;
  return ("stale-if-error=" + this$1.s_concurrent_duration_FiniteDuration__f_unit.toSeconds__J__J(this$1.s_concurrent_duration_FiniteDuration__f_length));
});
function $isArrayOf_Lsttp_model_headers_CacheDirective$StaleIfError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_headers_CacheDirective$StaleIfError)));
}
export { $isArrayOf_Lsttp_model_headers_CacheDirective$StaleIfError as $isArrayOf_Lsttp_model_headers_CacheDirective$StaleIfError };
var $d_Lsttp_model_headers_CacheDirective$StaleIfError = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$StaleIfError, "sttp.model.headers.CacheDirective$StaleIfError", ({
  Lsttp_model_headers_CacheDirective$StaleIfError: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$StaleIfError as $d_Lsttp_model_headers_CacheDirective$StaleIfError };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate(d) {
  this.Lsttp_model_headers_CacheDirective$StaleWhileRevalidate__f_d = null;
  this.Lsttp_model_headers_CacheDirective$StaleWhileRevalidate__f_d = d;
}
export { $c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate as $c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate };
$c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate() {
}
export { $h_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate as $h_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate };
$h_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype = $c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype;
$c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1401398402), true);
});
$c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate)) {
    var x = this.Lsttp_model_headers_CacheDirective$StaleWhileRevalidate__f_d;
    var x$2 = x$0.Lsttp_model_headers_CacheDirective$StaleWhileRevalidate__f_d;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype.productPrefix__T = (function() {
  return "StaleWhileRevalidate";
});
$c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_model_headers_CacheDirective$StaleWhileRevalidate__f_d;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "d";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate.prototype.toString__T = (function() {
  var this$1 = this.Lsttp_model_headers_CacheDirective$StaleWhileRevalidate__f_d;
  return ("stale-while-revalidate=" + this$1.s_concurrent_duration_FiniteDuration__f_unit.toSeconds__J__J(this$1.s_concurrent_duration_FiniteDuration__f_length));
});
function $isArrayOf_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_model_headers_CacheDirective$StaleWhileRevalidate)));
}
export { $isArrayOf_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate as $isArrayOf_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate };
var $d_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate, "sttp.model.headers.CacheDirective$StaleWhileRevalidate", ({
  Lsttp_model_headers_CacheDirective$StaleWhileRevalidate: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate as $d_Lsttp_model_headers_CacheDirective$StaleWhileRevalidate };
/** @constructor */
function $c_Lsttp_model_internal_Validate$$anon$1() {
}
export { $c_Lsttp_model_internal_Validate$$anon$1 as $c_Lsttp_model_internal_Validate$$anon$1 };
$c_Lsttp_model_internal_Validate$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lsttp_model_internal_Validate$$anon$1.prototype.constructor = $c_Lsttp_model_internal_Validate$$anon$1;
/** @constructor */
function $h_Lsttp_model_internal_Validate$$anon$1() {
}
export { $h_Lsttp_model_internal_Validate$$anon$1 as $h_Lsttp_model_internal_Validate$$anon$1 };
$h_Lsttp_model_internal_Validate$$anon$1.prototype = $c_Lsttp_model_internal_Validate$$anon$1.prototype;
$c_Lsttp_model_internal_Validate$$anon$1.prototype.isDefinedAt__s_Option__Z = (function(x) {
  return (x instanceof $c_s_Some);
});
$c_Lsttp_model_internal_Validate$$anon$1.prototype.applyOrElse__s_Option__F1__O = (function(x, default$1) {
  if ((x instanceof $c_s_Some)) {
    var e = x.s_Some__f_value;
    return e;
  } else {
    return default$1.apply__O__O(x);
  }
});
$c_Lsttp_model_internal_Validate$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__s_Option__Z(x);
});
$c_Lsttp_model_internal_Validate$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__s_Option__F1__O(x, default$1);
});
var $d_Lsttp_model_internal_Validate$$anon$1 = new $TypeData().initClass($c_Lsttp_model_internal_Validate$$anon$1, "sttp.model.internal.Validate$$anon$1", ({
  Lsttp_model_internal_Validate$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_model_internal_Validate$$anon$1 as $d_Lsttp_model_internal_Validate$$anon$1 };
/** @constructor */
function $c_Lsttp_tapir_Codec$$anon$6() {
}
export { $c_Lsttp_tapir_Codec$$anon$6 as $c_Lsttp_tapir_Codec$$anon$6 };
$c_Lsttp_tapir_Codec$$anon$6.prototype = new $h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_Codec$$anon$6.prototype.constructor = $c_Lsttp_tapir_Codec$$anon$6;
/** @constructor */
function $h_Lsttp_tapir_Codec$$anon$6() {
}
export { $h_Lsttp_tapir_Codec$$anon$6 as $h_Lsttp_tapir_Codec$$anon$6 };
$h_Lsttp_tapir_Codec$$anon$6.prototype = $c_Lsttp_tapir_Codec$$anon$6.prototype;
$c_Lsttp_tapir_Codec$$anon$6.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    var x28 = x._2__O();
    x._1__O();
    if ($is_Lsttp_tapir_DecodeResult$Failure(x28)) {
      return true;
    }
  }
  return false;
});
$c_Lsttp_tapir_Codec$$anon$6.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x32 = x._2__O();
    var partName = x._1__O();
    if ($is_Lsttp_tapir_DecodeResult$Failure(x32)) {
      return $ct_T2__O__O__(new $c_T2(), partName, x32);
    }
  }
  return default$1.apply__O__O(x);
});
$c_Lsttp_tapir_Codec$$anon$6.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z(x);
});
$c_Lsttp_tapir_Codec$$anon$6.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O(x, default$1);
});
var $d_Lsttp_tapir_Codec$$anon$6 = new $TypeData().initClass($c_Lsttp_tapir_Codec$$anon$6, "sttp.tapir.Codec$$anon$6", ({
  Lsttp_tapir_Codec$$anon$6: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Codec$$anon$6 as $d_Lsttp_tapir_Codec$$anon$6 };
/** @constructor */
function $c_Lsttp_tapir_Codec$$anon$7() {
}
export { $c_Lsttp_tapir_Codec$$anon$7 as $c_Lsttp_tapir_Codec$$anon$7 };
$c_Lsttp_tapir_Codec$$anon$7.prototype = new $h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_Codec$$anon$7.prototype.constructor = $c_Lsttp_tapir_Codec$$anon$7;
/** @constructor */
function $h_Lsttp_tapir_Codec$$anon$7() {
}
export { $h_Lsttp_tapir_Codec$$anon$7 as $h_Lsttp_tapir_Codec$$anon$7 };
$h_Lsttp_tapir_Codec$$anon$7.prototype = $c_Lsttp_tapir_Codec$$anon$7.prototype;
$c_Lsttp_tapir_Codec$$anon$7.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    var x36 = x._2__O();
    x._1__O();
    if ((x36 instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
      return true;
    }
  }
  return false;
});
$c_Lsttp_tapir_Codec$$anon$7.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x42 = x._2__O();
    var partName = x._1__O();
    if ((x42 instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
      var x45 = x42.Lsttp_tapir_DecodeResult$Value__f_v;
      return $ct_T2__O__O__(new $c_T2(), partName, x45);
    }
  }
  return default$1.apply__O__O(x);
});
$c_Lsttp_tapir_Codec$$anon$7.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z(x);
});
$c_Lsttp_tapir_Codec$$anon$7.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O(x, default$1);
});
var $d_Lsttp_tapir_Codec$$anon$7 = new $TypeData().initClass($c_Lsttp_tapir_Codec$$anon$7, "sttp.tapir.Codec$$anon$7", ({
  Lsttp_tapir_Codec$$anon$7: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Codec$$anon$7 as $d_Lsttp_tapir_Codec$$anon$7 };
/** @constructor */
function $c_Lsttp_tapir_CodecFormat$MultipartFormData() {
  this.Lsttp_tapir_CodecFormat$MultipartFormData__f_mediaType = null;
  this.Lsttp_tapir_CodecFormat$MultipartFormData__f_mediaType = $m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_MultipartFormData;
}
export { $c_Lsttp_tapir_CodecFormat$MultipartFormData as $c_Lsttp_tapir_CodecFormat$MultipartFormData };
$c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype = new $h_O();
$c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype.constructor = $c_Lsttp_tapir_CodecFormat$MultipartFormData;
/** @constructor */
function $h_Lsttp_tapir_CodecFormat$MultipartFormData() {
}
export { $h_Lsttp_tapir_CodecFormat$MultipartFormData as $h_Lsttp_tapir_CodecFormat$MultipartFormData };
$h_Lsttp_tapir_CodecFormat$MultipartFormData.prototype = $c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype;
$c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype.hashCode__I = (function() {
  return 1337301818;
});
$c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_CodecFormat$MultipartFormData));
});
$c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype.productPrefix__T = (function() {
  return "MultipartFormData";
});
$c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$MultipartFormData.prototype.mediaType__Lsttp_model_MediaType = (function() {
  return this.Lsttp_tapir_CodecFormat$MultipartFormData__f_mediaType;
});
function $isArrayOf_Lsttp_tapir_CodecFormat$MultipartFormData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_CodecFormat$MultipartFormData)));
}
export { $isArrayOf_Lsttp_tapir_CodecFormat$MultipartFormData as $isArrayOf_Lsttp_tapir_CodecFormat$MultipartFormData };
var $d_Lsttp_tapir_CodecFormat$MultipartFormData = new $TypeData().initClass($c_Lsttp_tapir_CodecFormat$MultipartFormData, "sttp.tapir.CodecFormat$MultipartFormData", ({
  Lsttp_tapir_CodecFormat$MultipartFormData: 1,
  Lsttp_tapir_CodecFormat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_CodecFormat$MultipartFormData as $d_Lsttp_tapir_CodecFormat$MultipartFormData };
/** @constructor */
function $c_Lsttp_tapir_CodecFormat$OctetStream() {
  this.Lsttp_tapir_CodecFormat$OctetStream__f_mediaType = null;
  this.Lsttp_tapir_CodecFormat$OctetStream__f_mediaType = $m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationOctetStream;
}
export { $c_Lsttp_tapir_CodecFormat$OctetStream as $c_Lsttp_tapir_CodecFormat$OctetStream };
$c_Lsttp_tapir_CodecFormat$OctetStream.prototype = new $h_O();
$c_Lsttp_tapir_CodecFormat$OctetStream.prototype.constructor = $c_Lsttp_tapir_CodecFormat$OctetStream;
/** @constructor */
function $h_Lsttp_tapir_CodecFormat$OctetStream() {
}
export { $h_Lsttp_tapir_CodecFormat$OctetStream as $h_Lsttp_tapir_CodecFormat$OctetStream };
$h_Lsttp_tapir_CodecFormat$OctetStream.prototype = $c_Lsttp_tapir_CodecFormat$OctetStream.prototype;
$c_Lsttp_tapir_CodecFormat$OctetStream.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_CodecFormat$OctetStream.prototype.hashCode__I = (function() {
  return 576716303;
});
$c_Lsttp_tapir_CodecFormat$OctetStream.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_CodecFormat$OctetStream));
});
$c_Lsttp_tapir_CodecFormat$OctetStream.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_CodecFormat$OctetStream.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_CodecFormat$OctetStream.prototype.productPrefix__T = (function() {
  return "OctetStream";
});
$c_Lsttp_tapir_CodecFormat$OctetStream.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$OctetStream.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$OctetStream.prototype.mediaType__Lsttp_model_MediaType = (function() {
  return this.Lsttp_tapir_CodecFormat$OctetStream__f_mediaType;
});
function $isArrayOf_Lsttp_tapir_CodecFormat$OctetStream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_CodecFormat$OctetStream)));
}
export { $isArrayOf_Lsttp_tapir_CodecFormat$OctetStream as $isArrayOf_Lsttp_tapir_CodecFormat$OctetStream };
var $d_Lsttp_tapir_CodecFormat$OctetStream = new $TypeData().initClass($c_Lsttp_tapir_CodecFormat$OctetStream, "sttp.tapir.CodecFormat$OctetStream", ({
  Lsttp_tapir_CodecFormat$OctetStream: 1,
  Lsttp_tapir_CodecFormat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_CodecFormat$OctetStream as $d_Lsttp_tapir_CodecFormat$OctetStream };
/** @constructor */
function $c_Lsttp_tapir_CodecFormat$TextPlain() {
  this.Lsttp_tapir_CodecFormat$TextPlain__f_mediaType = null;
  this.Lsttp_tapir_CodecFormat$TextPlain__f_mediaType = $m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_TextPlain;
}
export { $c_Lsttp_tapir_CodecFormat$TextPlain as $c_Lsttp_tapir_CodecFormat$TextPlain };
$c_Lsttp_tapir_CodecFormat$TextPlain.prototype = new $h_O();
$c_Lsttp_tapir_CodecFormat$TextPlain.prototype.constructor = $c_Lsttp_tapir_CodecFormat$TextPlain;
/** @constructor */
function $h_Lsttp_tapir_CodecFormat$TextPlain() {
}
export { $h_Lsttp_tapir_CodecFormat$TextPlain as $h_Lsttp_tapir_CodecFormat$TextPlain };
$h_Lsttp_tapir_CodecFormat$TextPlain.prototype = $c_Lsttp_tapir_CodecFormat$TextPlain.prototype;
$c_Lsttp_tapir_CodecFormat$TextPlain.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_CodecFormat$TextPlain.prototype.hashCode__I = (function() {
  return 952301693;
});
$c_Lsttp_tapir_CodecFormat$TextPlain.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_CodecFormat$TextPlain));
});
$c_Lsttp_tapir_CodecFormat$TextPlain.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_CodecFormat$TextPlain.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_CodecFormat$TextPlain.prototype.productPrefix__T = (function() {
  return "TextPlain";
});
$c_Lsttp_tapir_CodecFormat$TextPlain.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$TextPlain.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$TextPlain.prototype.mediaType__Lsttp_model_MediaType = (function() {
  return this.Lsttp_tapir_CodecFormat$TextPlain__f_mediaType;
});
function $isArrayOf_Lsttp_tapir_CodecFormat$TextPlain(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_CodecFormat$TextPlain)));
}
export { $isArrayOf_Lsttp_tapir_CodecFormat$TextPlain as $isArrayOf_Lsttp_tapir_CodecFormat$TextPlain };
var $d_Lsttp_tapir_CodecFormat$TextPlain = new $TypeData().initClass($c_Lsttp_tapir_CodecFormat$TextPlain, "sttp.tapir.CodecFormat$TextPlain", ({
  Lsttp_tapir_CodecFormat$TextPlain: 1,
  Lsttp_tapir_CodecFormat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_CodecFormat$TextPlain as $d_Lsttp_tapir_CodecFormat$TextPlain };
/** @constructor */
function $c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded() {
  this.Lsttp_tapir_CodecFormat$XWwwFormUrlencoded__f_mediaType = null;
  this.Lsttp_tapir_CodecFormat$XWwwFormUrlencoded__f_mediaType = $m_Lsttp_model_MediaType$().Lsttp_model_MediaType$__f_ApplicationXWwwFormUrlencoded;
}
export { $c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded as $c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded };
$c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype = new $h_O();
$c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype.constructor = $c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded;
/** @constructor */
function $h_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded() {
}
export { $h_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded as $h_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded };
$h_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype = $c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype;
$c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype.hashCode__I = (function() {
  return 833214626;
});
$c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded));
});
$c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype.productPrefix__T = (function() {
  return "XWwwFormUrlencoded";
});
$c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded.prototype.mediaType__Lsttp_model_MediaType = (function() {
  return this.Lsttp_tapir_CodecFormat$XWwwFormUrlencoded__f_mediaType;
});
function $isArrayOf_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_CodecFormat$XWwwFormUrlencoded)));
}
export { $isArrayOf_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded as $isArrayOf_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded };
var $d_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded = new $TypeData().initClass($c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded, "sttp.tapir.CodecFormat$XWwwFormUrlencoded", ({
  Lsttp_tapir_CodecFormat$XWwwFormUrlencoded: 1,
  Lsttp_tapir_CodecFormat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded as $d_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded };
/** @constructor */
function $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1() {
}
export { $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1 as $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1 };
$c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1.prototype = new $h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1.prototype.constructor = $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1;
/** @constructor */
function $h_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1() {
}
export { $h_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1 as $h_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1 };
$h_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1.prototype = $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1.prototype;
$c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1.prototype.isDefinedAt__T2__Z = (function(x) {
  if ((x !== null)) {
    var x29 = x._2__O();
    if ((x29 instanceof $c_Lsttp_tapir_DecodeResult$Error)) {
      return true;
    }
  }
  return false;
});
$c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1.prototype.applyOrElse__T2__F1__O = (function(x, default$1) {
  if ((x !== null)) {
    var x36 = x._2__O();
    if ((x36 instanceof $c_Lsttp_tapir_DecodeResult$Error)) {
      var x40 = x36.Lsttp_tapir_DecodeResult$Error__f_error;
      return x40;
    }
  }
  return default$1.apply__O__O(x);
});
$c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__T2__Z(x);
});
$c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__T2__F1__O(x, default$1);
});
var $d_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1 = new $TypeData().initClass($c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1, "sttp.tapir.DecodeResult$Error$MultipartDecodeException$$anon$1", ({
  Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1 as $d_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$$anon$1 };
/** @constructor */
function $c_Lsttp_tapir_DecodeResult$Value(v) {
  this.Lsttp_tapir_DecodeResult$Value__f_v = null;
  this.Lsttp_tapir_DecodeResult$Value__f_v = v;
}
export { $c_Lsttp_tapir_DecodeResult$Value as $c_Lsttp_tapir_DecodeResult$Value };
$c_Lsttp_tapir_DecodeResult$Value.prototype = new $h_O();
$c_Lsttp_tapir_DecodeResult$Value.prototype.constructor = $c_Lsttp_tapir_DecodeResult$Value;
/** @constructor */
function $h_Lsttp_tapir_DecodeResult$Value() {
}
export { $h_Lsttp_tapir_DecodeResult$Value as $h_Lsttp_tapir_DecodeResult$Value };
$h_Lsttp_tapir_DecodeResult$Value.prototype = $c_Lsttp_tapir_DecodeResult$Value.prototype;
$c_Lsttp_tapir_DecodeResult$Value.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_DecodeResult$Value.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-817380036), true);
});
$c_Lsttp_tapir_DecodeResult$Value.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_DecodeResult$Value)) {
    var x = this.Lsttp_tapir_DecodeResult$Value__f_v;
    var y = x$0.Lsttp_tapir_DecodeResult$Value__f_v;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lsttp_tapir_DecodeResult$Value.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_DecodeResult$Value.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_DecodeResult$Value.prototype.productPrefix__T = (function() {
  return "Value";
});
$c_Lsttp_tapir_DecodeResult$Value.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_DecodeResult$Value__f_v;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_DecodeResult$Value.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "v";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_DecodeResult$Value.prototype.map__F1__Lsttp_tapir_DecodeResult = (function(f) {
  var v = f.apply__O__O(this.Lsttp_tapir_DecodeResult$Value__f_v);
  return new $c_Lsttp_tapir_DecodeResult$Value(v);
});
$c_Lsttp_tapir_DecodeResult$Value.prototype.flatMap__F1__Lsttp_tapir_DecodeResult = (function(f) {
  return f.apply__O__O(this.Lsttp_tapir_DecodeResult$Value__f_v);
});
function $isArrayOf_Lsttp_tapir_DecodeResult$Value(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_DecodeResult$Value)));
}
export { $isArrayOf_Lsttp_tapir_DecodeResult$Value as $isArrayOf_Lsttp_tapir_DecodeResult$Value };
var $d_Lsttp_tapir_DecodeResult$Value = new $TypeData().initClass($c_Lsttp_tapir_DecodeResult$Value, "sttp.tapir.DecodeResult$Value", ({
  Lsttp_tapir_DecodeResult$Value: 1,
  Lsttp_tapir_DecodeResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_DecodeResult$Value as $d_Lsttp_tapir_DecodeResult$Value };
/** @constructor */
function $c_Lsttp_tapir_RawBodyType$MultipartBody(partTypes, defaultType) {
  this.Lsttp_tapir_RawBodyType$MultipartBody__f_partTypes = null;
  this.Lsttp_tapir_RawBodyType$MultipartBody__f_defaultType = null;
  this.Lsttp_tapir_RawBodyType$MultipartBody__f_partTypes = partTypes;
  this.Lsttp_tapir_RawBodyType$MultipartBody__f_defaultType = defaultType;
}
export { $c_Lsttp_tapir_RawBodyType$MultipartBody as $c_Lsttp_tapir_RawBodyType$MultipartBody };
$c_Lsttp_tapir_RawBodyType$MultipartBody.prototype = new $h_O();
$c_Lsttp_tapir_RawBodyType$MultipartBody.prototype.constructor = $c_Lsttp_tapir_RawBodyType$MultipartBody;
/** @constructor */
function $h_Lsttp_tapir_RawBodyType$MultipartBody() {
}
export { $h_Lsttp_tapir_RawBodyType$MultipartBody as $h_Lsttp_tapir_RawBodyType$MultipartBody };
$h_Lsttp_tapir_RawBodyType$MultipartBody.prototype = $c_Lsttp_tapir_RawBodyType$MultipartBody.prototype;
$c_Lsttp_tapir_RawBodyType$MultipartBody.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_RawBodyType$MultipartBody.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1629569812, true);
});
$c_Lsttp_tapir_RawBodyType$MultipartBody.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_RawBodyType$MultipartBody)) {
    var x = this.Lsttp_tapir_RawBodyType$MultipartBody__f_partTypes;
    var x$2 = x$0.Lsttp_tapir_RawBodyType$MultipartBody__f_partTypes;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_RawBodyType$MultipartBody__f_defaultType;
      var x$4 = x$0.Lsttp_tapir_RawBodyType$MultipartBody__f_defaultType;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_RawBodyType$MultipartBody.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_RawBodyType$MultipartBody.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_RawBodyType$MultipartBody.prototype.productPrefix__T = (function() {
  return "MultipartBody";
});
$c_Lsttp_tapir_RawBodyType$MultipartBody.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_RawBodyType$MultipartBody__f_partTypes;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_RawBodyType$MultipartBody__f_defaultType;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$MultipartBody.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "partTypes";
  }
  if ((n === 1)) {
    return "defaultType";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$MultipartBody.prototype.partType__T__s_Option = (function(name) {
  var this$1 = this.Lsttp_tapir_RawBodyType$MultipartBody__f_partTypes.get__O__s_Option(name);
  return (this$1.isEmpty__Z() ? this.Lsttp_tapir_RawBodyType$MultipartBody__f_defaultType : this$1);
});
function $isArrayOf_Lsttp_tapir_RawBodyType$MultipartBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_RawBodyType$MultipartBody)));
}
export { $isArrayOf_Lsttp_tapir_RawBodyType$MultipartBody as $isArrayOf_Lsttp_tapir_RawBodyType$MultipartBody };
var $d_Lsttp_tapir_RawBodyType$MultipartBody = new $TypeData().initClass($c_Lsttp_tapir_RawBodyType$MultipartBody, "sttp.tapir.RawBodyType$MultipartBody", ({
  Lsttp_tapir_RawBodyType$MultipartBody: 1,
  Lsttp_tapir_RawBodyType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_RawBodyType$MultipartBody as $d_Lsttp_tapir_RawBodyType$MultipartBody };
/** @constructor */
function $c_Lsttp_tapir_RawBodyType$StringBody(charset) {
  this.Lsttp_tapir_RawBodyType$StringBody__f_charset = null;
  this.Lsttp_tapir_RawBodyType$StringBody__f_charset = charset;
}
export { $c_Lsttp_tapir_RawBodyType$StringBody as $c_Lsttp_tapir_RawBodyType$StringBody };
$c_Lsttp_tapir_RawBodyType$StringBody.prototype = new $h_O();
$c_Lsttp_tapir_RawBodyType$StringBody.prototype.constructor = $c_Lsttp_tapir_RawBodyType$StringBody;
/** @constructor */
function $h_Lsttp_tapir_RawBodyType$StringBody() {
}
export { $h_Lsttp_tapir_RawBodyType$StringBody as $h_Lsttp_tapir_RawBodyType$StringBody };
$h_Lsttp_tapir_RawBodyType$StringBody.prototype = $c_Lsttp_tapir_RawBodyType$StringBody.prototype;
$c_Lsttp_tapir_RawBodyType$StringBody.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_RawBodyType$StringBody.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-301019284), true);
});
$c_Lsttp_tapir_RawBodyType$StringBody.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_RawBodyType$StringBody)) {
    var x = this.Lsttp_tapir_RawBodyType$StringBody__f_charset;
    var x$2 = x$0.Lsttp_tapir_RawBodyType$StringBody__f_charset;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_RawBodyType$StringBody.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_RawBodyType$StringBody.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_RawBodyType$StringBody.prototype.productPrefix__T = (function() {
  return "StringBody";
});
$c_Lsttp_tapir_RawBodyType$StringBody.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_RawBodyType$StringBody__f_charset;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$StringBody.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "charset";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_RawBodyType$StringBody(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_RawBodyType$StringBody)));
}
export { $isArrayOf_Lsttp_tapir_RawBodyType$StringBody as $isArrayOf_Lsttp_tapir_RawBodyType$StringBody };
var $d_Lsttp_tapir_RawBodyType$StringBody = new $TypeData().initClass($c_Lsttp_tapir_RawBodyType$StringBody, "sttp.tapir.RawBodyType$StringBody", ({
  Lsttp_tapir_RawBodyType$StringBody: 1,
  Lsttp_tapir_RawBodyType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_RawBodyType$StringBody as $d_Lsttp_tapir_RawBodyType$StringBody };
function $p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema($thiz, fieldPath, modify) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(fieldPath)) {
    return modify.apply__O__O($thiz);
  }
  if ((fieldPath instanceof $c_sci_$colon$colon)) {
    var x83 = fieldPath.sci_$colon$colon__f_next;
    var f = fieldPath.sci_$colon$colon__f_head;
    matchResult15: {
      var $x_1;
      var x62 = $thiz.Lsttp_tapir_Schema__f_schemaType;
      if ((x62 instanceof $c_Lsttp_tapir_SchemaType$SArray)) {
        var x79 = x62.Lsttp_tapir_SchemaType$SArray__f_element;
        if ((f === $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_ModifyCollectionElements)) {
          var element = $p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(x79, x83, modify);
          var toIterable = x62.Lsttp_tapir_SchemaType$SArray__f_toIterable;
          var $x_1 = new $c_Lsttp_tapir_SchemaType$SArray(element, toIterable);
          break matchResult15;
        }
      }
      if ((x62 instanceof $c_Lsttp_tapir_SchemaType$SOption)) {
        var x76 = x62.Lsttp_tapir_SchemaType$SOption__f_element;
        if ((f === $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_ModifyCollectionElements)) {
          var element$1 = $p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(x76, x83, modify);
          var toOption = x62.Lsttp_tapir_SchemaType$SOption__f_toOption;
          var $x_1 = new $c_Lsttp_tapir_SchemaType$SOption(element$1, toOption);
          break matchResult15;
        }
      }
      if ((x62 instanceof $c_Lsttp_tapir_SchemaType$SProduct)) {
        var x73 = x62.Lsttp_tapir_SchemaType$SProduct__f_fields;
        var fields = $ps_Lsttp_tapir_Schema__modifyFieldsAtPath$1__T__sci_List__F1__sci_List__sci_List(f, x83, modify, x73);
        var $x_1 = new $c_Lsttp_tapir_SchemaType$SProduct(fields);
        break matchResult15;
      }
      if ((x62 instanceof $c_Lsttp_tapir_SchemaType$SOpenProduct)) {
        var x69 = x62.Lsttp_tapir_SchemaType$SOpenProduct__f_fields;
        var x70 = x62.Lsttp_tapir_SchemaType$SOpenProduct__f_valueSchema;
        if ((f === $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_ModifyCollectionElements)) {
          var fields$1 = $ps_Lsttp_tapir_Schema__modifyFieldsAtPath$1__T__sci_List__F1__sci_List__sci_List(f, x83, modify, x69);
          var valueSchema = $p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(x70, x83, modify);
          var mapFieldValues = x62.Lsttp_tapir_SchemaType$SOpenProduct__f_mapFieldValues;
          var $x_1 = new $c_Lsttp_tapir_SchemaType$SOpenProduct(fields$1, valueSchema, mapFieldValues);
          break matchResult15;
        }
      }
      if ((x62 instanceof $c_Lsttp_tapir_SchemaType$SCoproduct)) {
        var x65 = x62.Lsttp_tapir_SchemaType$SCoproduct__f_subtypes;
        var f$1 = ((_$2) => $p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(_$2, fieldPath, modify));
        if ((x65 === $m_sci_Nil$())) {
          var subtypes = $m_sci_Nil$();
        } else {
          var x0 = x65.head__O();
          var h = new $c_sci_$colon$colon(f$1(x0), $m_sci_Nil$());
          var t = h;
          var rest = x65.tail__O();
          while ((rest !== $m_sci_Nil$())) {
            var x0$1 = rest.head__O();
            var nx = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
            t.sci_$colon$colon__f_next = nx;
            t = nx;
            rest = rest.tail__O();
          }
          var subtypes = h;
        }
        var discriminator = x62.Lsttp_tapir_SchemaType$SCoproduct__f_discriminator;
        var subtypeSchema = x62.Lsttp_tapir_SchemaType$SCoproduct__f_subtypeSchema;
        var $x_1 = new $c_Lsttp_tapir_SchemaType$SCoproduct(subtypes, discriminator, subtypeSchema);
        break matchResult15;
      }
      var $x_1 = $thiz.Lsttp_tapir_Schema__f_schemaType;
    }
    var schemaType2 = $x_1;
    var name = $thiz.Lsttp_tapir_Schema__f_name;
    var isOptional = $thiz.Lsttp_tapir_Schema__f_isOptional;
    var description = $thiz.Lsttp_tapir_Schema__f_description;
    var default$1 = $thiz.Lsttp_tapir_Schema__f_default;
    var format = $thiz.Lsttp_tapir_Schema__f_format;
    var encodedExample = $thiz.Lsttp_tapir_Schema__f_encodedExample;
    var deprecated = $thiz.Lsttp_tapir_Schema__f_deprecated;
    var hidden = $thiz.Lsttp_tapir_Schema__f_hidden;
    var validator = $thiz.Lsttp_tapir_Schema__f_validator;
    var attributes = $thiz.Lsttp_tapir_Schema__f_attributes;
    return new $c_Lsttp_tapir_Schema(schemaType2, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  }
  throw new $c_s_MatchError(fieldPath);
}
export { $p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema as $p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema };
function $p_Lsttp_tapir_Schema__applyValidation__O__sci_Map__sci_List($thiz, t, objects) {
  var this$1 = $thiz.Lsttp_tapir_Schema__f_name;
  if (this$1.isEmpty__Z()) {
    var objects2 = objects;
  } else {
    var x0 = this$1.get__O();
    var objects2 = objects.$plus__T2__sci_MapOps($ct_T2__O__O__(new $c_T2(), x0, $thiz));
  }
  if ($thiz.hasValidation__Z()) {
    var this$19 = $thiz.Lsttp_tapir_Schema__f_validator.apply__O__sci_List(t);
    matchResult22: {
      var suffix$1;
      var x111 = $thiz.Lsttp_tapir_Schema__f_schemaType;
      if ((x111 instanceof $c_Lsttp_tapir_SchemaType$SOption)) {
        var x131 = x111.Lsttp_tapir_SchemaType$SOption__f_element;
        var this$5 = x111.Lsttp_tapir_SchemaType$SOption__f_toOption.apply__O__O(t).toList__sci_List();
        var rest = this$5;
        var h = null;
        var t$1 = null;
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = rest.head__O();
          var it = $p_Lsttp_tapir_Schema__applyValidation__O__sci_Map__sci_List(x131, x0$1, objects2).iterator__sc_Iterator();
          while (it.hasNext__Z()) {
            var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
            if ((t$1 === null)) {
              h = nx;
            } else {
              t$1.sci_$colon$colon__f_next = nx;
            }
            t$1 = nx;
          }
          rest = rest.tail__O();
        }
        var suffix$1 = ((h === null) ? $m_sci_Nil$() : h);
        break matchResult22;
      }
      if ((x111 instanceof $c_Lsttp_tapir_SchemaType$SArray)) {
        var x128 = x111.Lsttp_tapir_SchemaType$SArray__f_element;
        var suffix$1 = x111.Lsttp_tapir_SchemaType$SArray__f_toIterable.apply__O__O(t).flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => $p_Lsttp_tapir_Schema__applyValidation__O__sci_Map__sci_List(x128, _$6, objects2))));
        break matchResult22;
      }
      if ((x111 instanceof $c_Lsttp_tapir_SchemaType$SProduct)) {
        var suffix$1 = $ps_Lsttp_tapir_Schema__applyFieldsValidation$1__O__sci_Map__sci_List__sci_List(t, objects2, x111.Lsttp_tapir_SchemaType$SProduct__f_fieldsWithValidation);
        break matchResult22;
      }
      if ((x111 instanceof $c_Lsttp_tapir_SchemaType$SOpenProduct)) {
        var x122 = x111.Lsttp_tapir_SchemaType$SOpenProduct__f_valueSchema;
        var this$11 = $ps_Lsttp_tapir_Schema__applyFieldsValidation$1__O__sci_Map__sci_List__sci_List(t, objects2, x111.Lsttp_tapir_SchemaType$SOpenProduct__f_fieldsWithValidation);
        var suffix = x111.Lsttp_tapir_SchemaType$SOpenProduct__f_mapFieldValues.apply__O__O(t).flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
          if ((x$1 !== null)) {
            var k = x$1._1__O();
            var v = x$1._2__O();
            var this$10 = $p_Lsttp_tapir_Schema__applyValidation__O__sci_Map__sci_List(x122, v, objects2);
            var f = ((_$7) => _$7.prependPath__Lsttp_tapir_FieldName__Lsttp_tapir_ValidationError(new $c_Lsttp_tapir_FieldName(k, k)));
            if ((this$10 === $m_sci_Nil$())) {
              return $m_sci_Nil$();
            } else {
              var x0$2 = this$10.head__O();
              var h$1 = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
              var t$2 = h$1;
              var rest$1 = this$10.tail__O();
              while ((rest$1 !== $m_sci_Nil$())) {
                var x0$3 = rest$1.head__O();
                var nx$1 = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
                t$2.sci_$colon$colon__f_next = nx$1;
                t$2 = nx$1;
                rest$1 = rest$1.tail__O();
              }
              return h$1;
            }
          }
          throw new $c_s_MatchError(x$1);
        })));
        var suffix$1 = this$11.appendedAll__sc_IterableOnce__sci_List(suffix);
        break matchResult22;
      }
      if ((x111 instanceof $c_Lsttp_tapir_SchemaType$SCoproduct)) {
        var this$13 = x111.Lsttp_tapir_SchemaType$SCoproduct__f_subtypeSchema.apply__O__O(t);
        if (this$13.isEmpty__Z()) {
          var this$15 = $m_s_None$();
        } else {
          var x0$4 = this$13.get__O();
          matchResult21: {
            var $x_1;
            if ((x0$4 !== null)) {
              var x109 = x0$4.Lsttp_tapir_SchemaType$SchemaWithValue__f_schema;
              var x110 = x0$4.Lsttp_tapir_SchemaType$SchemaWithValue__f_value;
              var $x_1 = $p_Lsttp_tapir_Schema__applyValidation__O__sci_Map__sci_List(x109, x110, objects2);
              break matchResult21;
            }
            throw new $c_s_MatchError(x0$4);
          }
          var this$15 = new $c_s_Some($x_1);
        }
        var suffix$1 = (this$15.isEmpty__Z() ? $m_sci_Nil$() : this$15.get__O());
        break matchResult22;
      }
      if ((x111 instanceof $c_Lsttp_tapir_SchemaType$SRef)) {
        var x114 = x111.Lsttp_tapir_SchemaType$SRef__f_name;
        var this$17 = objects.get__O__s_Option(x114);
        if (this$17.isEmpty__Z()) {
          var this$18 = $m_s_None$();
        } else {
          var x0$5 = this$17.get__O();
          var this$18 = new $c_s_Some($p_Lsttp_tapir_Schema__applyValidation__O__sci_Map__sci_List(x0$5, t, objects2));
        }
        var suffix$1 = (this$18.isEmpty__Z() ? $m_sci_Nil$() : this$18.get__O());
        break matchResult22;
      }
      var suffix$1 = $m_sci_Nil$();
    }
    return this$19.appendedAll__sc_IterableOnce__sci_List(suffix$1);
  } else {
    return $m_sci_Nil$();
  }
}
export { $p_Lsttp_tapir_Schema__applyValidation__O__sci_Map__sci_List as $p_Lsttp_tapir_Schema__applyValidation__O__sci_Map__sci_List };
function $ps_Lsttp_tapir_Schema__modifyFieldsAtPath$1__T__sci_List__F1__sci_List__sci_List(f$3, fs$1, modify$1, fields) {
  var f = ((field) => {
    if ((field.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name.Lsttp_tapir_FieldName__f_name === f$3)) {
      var _name = field.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name;
      var _schema = $p_Lsttp_tapir_Schema__modifyAtPath__sci_List__F1__Lsttp_tapir_Schema(field.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema, fs$1, modify$1);
      var _get = field.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_get;
      return new $c_Lsttp_tapir_SchemaType$SProductField$$anon$1(_name, _schema, _get);
    } else {
      return field;
    }
  });
  if ((fields === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var x0 = fields.head__O();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = fields.tail__O();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    return h;
  }
}
export { $ps_Lsttp_tapir_Schema__modifyFieldsAtPath$1__T__sci_List__F1__sci_List__sci_List as $ps_Lsttp_tapir_Schema__modifyFieldsAtPath$1__T__sci_List__F1__sci_List__sci_List };
function $ps_Lsttp_tapir_Schema__applyFieldsValidation$1__O__sci_Map__sci_List__sci_List(t$1, objects2$1, fields) {
  var rest = fields;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var x0 = rest.head__O();
    var this$1 = x0.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_get.apply__O__O(t$1);
    if (this$1.isEmpty__Z()) {
      var this$2 = $m_s_None$();
    } else {
      var x0$1 = this$1.get__O();
      var this$2 = new $c_s_Some($p_Lsttp_tapir_Schema__applyValidation__O__sci_Map__sci_List(x0.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema, x0$1, objects2$1));
    }
    var this$3 = (this$2.isEmpty__Z() ? $m_sci_Nil$() : this$2.get__O());
    var f = ((f$3) => ((_$4) => _$4.prependPath__Lsttp_tapir_FieldName__Lsttp_tapir_ValidationError(f$3.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name)))(x0);
    if ((this$3 === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0$2 = this$3.head__O();
      var h$1 = new $c_sci_$colon$colon(f(x0$2), $m_sci_Nil$());
      var t$2 = h$1;
      var rest$1 = this$3.tail__O();
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$3 = rest$1.head__O();
        var nx = new $c_sci_$colon$colon(f(x0$3), $m_sci_Nil$());
        t$2.sci_$colon$colon__f_next = nx;
        t$2 = nx;
        rest$1 = rest$1.tail__O();
      }
      var $x_1 = h$1;
    }
    var it = $x_1.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx$1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx$1;
      } else {
        t.sci_$colon$colon__f_next = nx$1;
      }
      t = nx$1;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $m_sci_Nil$() : h);
}
export { $ps_Lsttp_tapir_Schema__applyFieldsValidation$1__O__sci_Map__sci_List__sci_List as $ps_Lsttp_tapir_Schema__applyFieldsValidation$1__O__sci_Map__sci_List__sci_List };
/** @constructor */
function $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes) {
  this.Lsttp_tapir_Schema__f_schemaType = null;
  this.Lsttp_tapir_Schema__f_name = null;
  this.Lsttp_tapir_Schema__f_isOptional = false;
  this.Lsttp_tapir_Schema__f_description = null;
  this.Lsttp_tapir_Schema__f_default = null;
  this.Lsttp_tapir_Schema__f_format = null;
  this.Lsttp_tapir_Schema__f_encodedExample = null;
  this.Lsttp_tapir_Schema__f_deprecated = false;
  this.Lsttp_tapir_Schema__f_hidden = false;
  this.Lsttp_tapir_Schema__f_validator = null;
  this.Lsttp_tapir_Schema__f_attributes = null;
  this.Lsttp_tapir_Schema__f_schemaType = schemaType;
  this.Lsttp_tapir_Schema__f_name = name;
  this.Lsttp_tapir_Schema__f_isOptional = isOptional;
  this.Lsttp_tapir_Schema__f_description = description;
  this.Lsttp_tapir_Schema__f_default = default$1;
  this.Lsttp_tapir_Schema__f_format = format;
  this.Lsttp_tapir_Schema__f_encodedExample = encodedExample;
  this.Lsttp_tapir_Schema__f_deprecated = deprecated;
  this.Lsttp_tapir_Schema__f_hidden = hidden;
  this.Lsttp_tapir_Schema__f_validator = validator;
  this.Lsttp_tapir_Schema__f_attributes = attributes;
}
export { $c_Lsttp_tapir_Schema as $c_Lsttp_tapir_Schema };
$c_Lsttp_tapir_Schema.prototype = new $h_O();
$c_Lsttp_tapir_Schema.prototype.constructor = $c_Lsttp_tapir_Schema;
/** @constructor */
function $h_Lsttp_tapir_Schema() {
}
export { $h_Lsttp_tapir_Schema as $h_Lsttp_tapir_Schema };
$h_Lsttp_tapir_Schema.prototype = $c_Lsttp_tapir_Schema.prototype;
$c_Lsttp_tapir_Schema.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Schema.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $m_sr_Statics$().mix__I__I__I(hash, (-1824120383));
  var hash$1 = acc;
  var x = this.Lsttp_tapir_Schema__f_schemaType;
  var data = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  var x$1 = this.Lsttp_tapir_Schema__f_name;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$1);
  var hash$3 = acc;
  var data$2 = (this.Lsttp_tapir_Schema__f_isOptional ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$2);
  var hash$4 = acc;
  var x$2 = this.Lsttp_tapir_Schema__f_description;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$2);
  acc = $m_sr_Statics$().mix__I__I__I(hash$4, data$3);
  var hash$5 = acc;
  var x$3 = this.Lsttp_tapir_Schema__f_default;
  var data$4 = $m_sr_Statics$().anyHash__O__I(x$3);
  acc = $m_sr_Statics$().mix__I__I__I(hash$5, data$4);
  var hash$6 = acc;
  var x$4 = this.Lsttp_tapir_Schema__f_format;
  var data$5 = $m_sr_Statics$().anyHash__O__I(x$4);
  acc = $m_sr_Statics$().mix__I__I__I(hash$6, data$5);
  var hash$7 = acc;
  var x$5 = this.Lsttp_tapir_Schema__f_encodedExample;
  var data$6 = $m_sr_Statics$().anyHash__O__I(x$5);
  acc = $m_sr_Statics$().mix__I__I__I(hash$7, data$6);
  var hash$8 = acc;
  var data$7 = (this.Lsttp_tapir_Schema__f_deprecated ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$8, data$7);
  var hash$9 = acc;
  var data$8 = (this.Lsttp_tapir_Schema__f_hidden ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$9, data$8);
  var hash$10 = acc;
  var x$6 = this.Lsttp_tapir_Schema__f_validator;
  var data$9 = $m_sr_Statics$().anyHash__O__I(x$6);
  acc = $m_sr_Statics$().mix__I__I__I(hash$10, data$9);
  var hash$11 = acc;
  var x$7 = this.Lsttp_tapir_Schema__f_attributes;
  var data$10 = $m_sr_Statics$().anyHash__O__I(x$7);
  acc = $m_sr_Statics$().mix__I__I__I(hash$11, data$10);
  var hash$12 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$12, 11);
});
$c_Lsttp_tapir_Schema.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_Schema)) {
    if ((((this.Lsttp_tapir_Schema__f_isOptional === x$0.Lsttp_tapir_Schema__f_isOptional) && (this.Lsttp_tapir_Schema__f_deprecated === x$0.Lsttp_tapir_Schema__f_deprecated)) && (this.Lsttp_tapir_Schema__f_hidden === x$0.Lsttp_tapir_Schema__f_hidden))) {
      var x = this.Lsttp_tapir_Schema__f_schemaType;
      var x$2 = x$0.Lsttp_tapir_Schema__f_schemaType;
      var $x_7 = ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$3 = this.Lsttp_tapir_Schema__f_name;
      var x$4 = x$0.Lsttp_tapir_Schema__f_name;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.Lsttp_tapir_Schema__f_description;
      var x$6 = x$0.Lsttp_tapir_Schema__f_description;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.Lsttp_tapir_Schema__f_default;
      var x$8 = x$0.Lsttp_tapir_Schema__f_default;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.equals__O__Z(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.Lsttp_tapir_Schema__f_format;
      var x$10 = x$0.Lsttp_tapir_Schema__f_format;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.equals__O__Z(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.Lsttp_tapir_Schema__f_encodedExample;
      var x$12 = x$0.Lsttp_tapir_Schema__f_encodedExample;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.equals__O__Z(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.Lsttp_tapir_Schema__f_validator;
      var x$14 = x$0.Lsttp_tapir_Schema__f_validator;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.equals__O__Z(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.Lsttp_tapir_Schema__f_attributes;
      var x$16 = x$0.Lsttp_tapir_Schema__f_attributes;
      return ((x$15 === null) ? (x$16 === null) : x$15.equals__O__Z(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_Schema.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Schema.prototype.productArity__I = (function() {
  return 11;
});
$c_Lsttp_tapir_Schema.prototype.productPrefix__T = (function() {
  return "Schema";
});
$c_Lsttp_tapir_Schema.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_Schema__f_schemaType;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_Schema__f_name;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_Schema__f_isOptional;
      break;
    }
    case 3: {
      return this.Lsttp_tapir_Schema__f_description;
      break;
    }
    case 4: {
      return this.Lsttp_tapir_Schema__f_default;
      break;
    }
    case 5: {
      return this.Lsttp_tapir_Schema__f_format;
      break;
    }
    case 6: {
      return this.Lsttp_tapir_Schema__f_encodedExample;
      break;
    }
    case 7: {
      return this.Lsttp_tapir_Schema__f_deprecated;
      break;
    }
    case 8: {
      return this.Lsttp_tapir_Schema__f_hidden;
      break;
    }
    case 9: {
      return this.Lsttp_tapir_Schema__f_validator;
      break;
    }
    case 10: {
      return this.Lsttp_tapir_Schema__f_attributes;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_Schema.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "schemaType";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "isOptional";
      break;
    }
    case 3: {
      return "description";
      break;
    }
    case 4: {
      return "default";
      break;
    }
    case 5: {
      return "format";
      break;
    }
    case 6: {
      return "encodedExample";
      break;
    }
    case 7: {
      return "deprecated";
      break;
    }
    case 8: {
      return "hidden";
      break;
    }
    case 9: {
      return "validator";
      break;
    }
    case 10: {
      return "attributes";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_Schema.prototype.asOption__Lsttp_tapir_Schema = (function() {
  var toOption = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x));
  var schemaType$3 = new $c_Lsttp_tapir_SchemaType$SOption(this, toOption);
  $m_Lsttp_tapir_Schema$();
  var name$3 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var description$3 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$3 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$3 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var validator$3 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var format = this.Lsttp_tapir_Schema__f_format;
  var deprecated = this.Lsttp_tapir_Schema__f_deprecated;
  var hidden = this.Lsttp_tapir_Schema__f_hidden;
  var attributes = this.Lsttp_tapir_Schema__f_attributes;
  return new $c_Lsttp_tapir_Schema(schemaType$3, name$3, true, description$3, default$3, format, encodedExample$3, deprecated, hidden, validator$3, attributes);
});
$c_Lsttp_tapir_Schema.prototype.asIterable__Lsttp_tapir_Schema = (function() {
  var toIterable = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x));
  var schemaType$5 = new $c_Lsttp_tapir_SchemaType$SArray(this, toIterable);
  $m_Lsttp_tapir_Schema$();
  var name$5 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var description$5 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$5 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$4 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$5 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var validator$5 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var deprecated = this.Lsttp_tapir_Schema__f_deprecated;
  var hidden = this.Lsttp_tapir_Schema__f_hidden;
  var attributes = this.Lsttp_tapir_Schema__f_attributes;
  return new $c_Lsttp_tapir_Schema(schemaType$5, name$5, true, description$5, default$5, format$4, encodedExample$5, deprecated, hidden, validator$5, attributes);
});
$c_Lsttp_tapir_Schema.prototype.name__Lsttp_tapir_Schema$SName__Lsttp_tapir_Schema = (function(name) {
  var name$6 = new $c_s_Some(name);
  var schemaType$6 = this.Lsttp_tapir_Schema__f_schemaType;
  var isOptional$3 = this.Lsttp_tapir_Schema__f_isOptional;
  var description$6 = this.Lsttp_tapir_Schema__f_description;
  var default$6 = this.Lsttp_tapir_Schema__f_default;
  var format$5 = this.Lsttp_tapir_Schema__f_format;
  var encodedExample$6 = this.Lsttp_tapir_Schema__f_encodedExample;
  var deprecated$3 = this.Lsttp_tapir_Schema__f_deprecated;
  var hidden$3 = this.Lsttp_tapir_Schema__f_hidden;
  var validator$6 = this.Lsttp_tapir_Schema__f_validator;
  var attributes$3 = this.Lsttp_tapir_Schema__f_attributes;
  return new $c_Lsttp_tapir_Schema(schemaType$6, name$6, isOptional$3, description$6, default$6, format$5, encodedExample$6, deprecated$3, hidden$3, validator$6, attributes$3);
});
$c_Lsttp_tapir_Schema.prototype.description__T__Lsttp_tapir_Schema = (function(d) {
  var description$8 = new $c_s_Some(d);
  var schemaType$8 = this.Lsttp_tapir_Schema__f_schemaType;
  var name$8 = this.Lsttp_tapir_Schema__f_name;
  var isOptional$5 = this.Lsttp_tapir_Schema__f_isOptional;
  var default$8 = this.Lsttp_tapir_Schema__f_default;
  var format$7 = this.Lsttp_tapir_Schema__f_format;
  var encodedExample$8 = this.Lsttp_tapir_Schema__f_encodedExample;
  var deprecated$5 = this.Lsttp_tapir_Schema__f_deprecated;
  var hidden$5 = this.Lsttp_tapir_Schema__f_hidden;
  var validator$8 = this.Lsttp_tapir_Schema__f_validator;
  var attributes$5 = this.Lsttp_tapir_Schema__f_attributes;
  return new $c_Lsttp_tapir_Schema(schemaType$8, name$8, isOptional$5, description$8, default$8, format$7, encodedExample$8, deprecated$5, hidden$5, validator$8, attributes$5);
});
$c_Lsttp_tapir_Schema.prototype.encodedExample__O__Lsttp_tapir_Schema = (function(e) {
  var encodedExample$9 = new $c_s_Some(e);
  var schemaType$9 = this.Lsttp_tapir_Schema__f_schemaType;
  var name$9 = this.Lsttp_tapir_Schema__f_name;
  var isOptional$6 = this.Lsttp_tapir_Schema__f_isOptional;
  var description$9 = this.Lsttp_tapir_Schema__f_description;
  var default$9 = this.Lsttp_tapir_Schema__f_default;
  var format$8 = this.Lsttp_tapir_Schema__f_format;
  var deprecated$6 = this.Lsttp_tapir_Schema__f_deprecated;
  var hidden$6 = this.Lsttp_tapir_Schema__f_hidden;
  var validator$9 = this.Lsttp_tapir_Schema__f_validator;
  var attributes$6 = this.Lsttp_tapir_Schema__f_attributes;
  return new $c_Lsttp_tapir_Schema(schemaType$9, name$9, isOptional$6, description$9, default$9, format$8, encodedExample$9, deprecated$6, hidden$6, validator$9, attributes$6);
});
$c_Lsttp_tapir_Schema.prototype.default__O__s_Option__Lsttp_tapir_Schema = (function(t, encoded) {
  var x = $m_s_None$();
  if (((x === encoded) && $m_Lsttp_tapir_internal_package$().isBasicValue__O__Z(t))) {
    var raw2 = new $c_s_Some(t);
  } else {
    var raw2 = encoded;
  }
  var value = $ct_T2__O__O__(new $c_T2(), t, raw2);
  var default$10 = new $c_s_Some(value);
  var schemaType$10 = this.Lsttp_tapir_Schema__f_schemaType;
  var name$10 = this.Lsttp_tapir_Schema__f_name;
  var description$10 = this.Lsttp_tapir_Schema__f_description;
  var format$9 = this.Lsttp_tapir_Schema__f_format;
  var encodedExample$10 = this.Lsttp_tapir_Schema__f_encodedExample;
  var deprecated$7 = this.Lsttp_tapir_Schema__f_deprecated;
  var hidden$7 = this.Lsttp_tapir_Schema__f_hidden;
  var validator$10 = this.Lsttp_tapir_Schema__f_validator;
  var attributes$7 = this.Lsttp_tapir_Schema__f_attributes;
  return new $c_Lsttp_tapir_Schema(schemaType$10, name$10, true, description$10, default$10, format$9, encodedExample$10, deprecated$7, hidden$7, validator$10, attributes$7);
});
$c_Lsttp_tapir_Schema.prototype.format__T__Lsttp_tapir_Schema = (function(f) {
  var format$10 = new $c_s_Some(f);
  var schemaType$11 = this.Lsttp_tapir_Schema__f_schemaType;
  var name$11 = this.Lsttp_tapir_Schema__f_name;
  var isOptional$7 = this.Lsttp_tapir_Schema__f_isOptional;
  var description$11 = this.Lsttp_tapir_Schema__f_description;
  var default$11 = this.Lsttp_tapir_Schema__f_default;
  var encodedExample$11 = this.Lsttp_tapir_Schema__f_encodedExample;
  var deprecated$8 = this.Lsttp_tapir_Schema__f_deprecated;
  var hidden$8 = this.Lsttp_tapir_Schema__f_hidden;
  var validator$11 = this.Lsttp_tapir_Schema__f_validator;
  var attributes$8 = this.Lsttp_tapir_Schema__f_attributes;
  return new $c_Lsttp_tapir_Schema(schemaType$11, name$11, isOptional$7, description$11, default$11, format$10, encodedExample$11, deprecated$8, hidden$8, validator$11, attributes$8);
});
$c_Lsttp_tapir_Schema.prototype.title__T__Lsttp_tapir_Schema = (function(t) {
  return this.attribute__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_Schema($m_Lsttp_tapir_Schema$Title$().Lsttp_tapir_Schema$Title$__f_Attribute, new $c_Lsttp_tapir_Schema$Title(t));
});
$c_Lsttp_tapir_Schema.prototype.tuple__Lsttp_tapir_Schema = (function() {
  return this.attribute__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_Schema($m_Lsttp_tapir_Schema$Tuple$().Lsttp_tapir_Schema$Tuple$__f_Attribute, new $c_Lsttp_tapir_Schema$Tuple(true));
});
$c_Lsttp_tapir_Schema.prototype.encodedDiscriminatorValue__T__Lsttp_tapir_Schema = (function(v) {
  return this.attribute__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_Schema($m_Lsttp_tapir_Schema$EncodedDiscriminatorValue$().Lsttp_tapir_Schema$EncodedDiscriminatorValue$__f_Attribute, new $c_Lsttp_tapir_Schema$EncodedDiscriminatorValue(v));
});
$c_Lsttp_tapir_Schema.prototype.validate__Lsttp_tapir_Validator__Lsttp_tapir_Schema = (function(v) {
  var v2 = new $c_Lsttp_tapir_internal_package$ValidatorSyntax(v).inferEnumerationEncode__Lsttp_tapir_Validator();
  var x100 = new $c_Lsttp_tapir_internal_package$ValidatorSyntax(v2).asPrimitiveValidators__sci_Seq().collectFirst__s_PartialFunction__s_Option(new $c_Lsttp_tapir_Schema$$anon$2());
  if ((x100 instanceof $c_s_Some)) {
    var name = x100.s_Some__f_value;
    var name$12 = new $c_s_Some(name);
    var validator$12 = this.Lsttp_tapir_Schema__f_validator.and__Lsttp_tapir_Validator__Lsttp_tapir_Validator(v2);
    var schemaType$12 = this.Lsttp_tapir_Schema__f_schemaType;
    var isOptional$8 = this.Lsttp_tapir_Schema__f_isOptional;
    var description$12 = this.Lsttp_tapir_Schema__f_description;
    var default$12 = this.Lsttp_tapir_Schema__f_default;
    var format$11 = this.Lsttp_tapir_Schema__f_format;
    var encodedExample$12 = this.Lsttp_tapir_Schema__f_encodedExample;
    var deprecated$9 = this.Lsttp_tapir_Schema__f_deprecated;
    var hidden$9 = this.Lsttp_tapir_Schema__f_hidden;
    var attributes$9 = this.Lsttp_tapir_Schema__f_attributes;
    return new $c_Lsttp_tapir_Schema(schemaType$12, name$12, isOptional$8, description$12, default$12, format$11, encodedExample$12, deprecated$9, hidden$9, validator$12, attributes$9);
  }
  var x = $m_s_None$();
  if ((x === x100)) {
    var validator$13 = this.Lsttp_tapir_Schema__f_validator.and__Lsttp_tapir_Validator__Lsttp_tapir_Validator(v2);
    var schemaType$13 = this.Lsttp_tapir_Schema__f_schemaType;
    var name$13 = this.Lsttp_tapir_Schema__f_name;
    var isOptional$9 = this.Lsttp_tapir_Schema__f_isOptional;
    var description$13 = this.Lsttp_tapir_Schema__f_description;
    var default$13 = this.Lsttp_tapir_Schema__f_default;
    var format$12 = this.Lsttp_tapir_Schema__f_format;
    var encodedExample$13 = this.Lsttp_tapir_Schema__f_encodedExample;
    var deprecated$10 = this.Lsttp_tapir_Schema__f_deprecated;
    var hidden$10 = this.Lsttp_tapir_Schema__f_hidden;
    var attributes$10 = this.Lsttp_tapir_Schema__f_attributes;
    return new $c_Lsttp_tapir_Schema(schemaType$13, name$13, isOptional$9, description$13, default$13, format$12, encodedExample$13, deprecated$10, hidden$10, validator$13, attributes$10);
  }
  throw new $c_s_MatchError(x100);
});
$c_Lsttp_tapir_Schema.prototype.applyValidation__O__sci_List = (function(t) {
  var this$1 = $m_sci_Map$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T2.getArrayOf().constr)([]));
  return $p_Lsttp_tapir_Schema__applyValidation__O__sci_Map__sci_List(this, t, this$1.from__sc_IterableOnce__sci_Map(elems));
});
$c_Lsttp_tapir_Schema.prototype.hasValidation__Z = (function() {
  var x = this.Lsttp_tapir_Schema__f_validator;
  var x$2 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  if ((!((x === null) ? (x$2 === null) : x.equals__O__Z(x$2)))) {
    return true;
  } else {
    var x132 = this.Lsttp_tapir_Schema__f_schemaType;
    if ((x132 instanceof $c_Lsttp_tapir_SchemaType$SOption)) {
      var x150 = x132.Lsttp_tapir_SchemaType$SOption__f_element;
      return x150.hasValidation__Z();
    }
    if ((x132 instanceof $c_Lsttp_tapir_SchemaType$SArray)) {
      var x147 = x132.Lsttp_tapir_SchemaType$SArray__f_element;
      return x147.hasValidation__Z();
    }
    if ((x132 instanceof $c_Lsttp_tapir_SchemaType$SProduct)) {
      var this$3 = x132.Lsttp_tapir_SchemaType$SProduct__f_fieldsWithValidation;
      return (!this$3.isEmpty__Z());
    }
    if ((x132 instanceof $c_Lsttp_tapir_SchemaType$SOpenProduct)) {
      var x143 = x132.Lsttp_tapir_SchemaType$SOpenProduct__f_valueSchema;
      var this$5 = x132.Lsttp_tapir_SchemaType$SOpenProduct__f_fieldsWithValidation;
      if ((!this$5.isEmpty__Z())) {
        return true;
      } else {
        return x143.hasValidation__Z();
      }
    }
    if ((x132 instanceof $c_Lsttp_tapir_SchemaType$SCoproduct)) {
      var x138 = x132.Lsttp_tapir_SchemaType$SCoproduct__f_subtypes;
      var these = x138;
      while ((!these.isEmpty__Z())) {
        var x0 = these.head__O();
        if (x0.hasValidation__Z()) {
          return true;
        }
        these = these.tail__O();
      }
      return false;
    }
    if ((x132 instanceof $c_Lsttp_tapir_SchemaType$SRef)) {
      return true;
    }
    return false;
  }
});
$c_Lsttp_tapir_Schema.prototype.attribute__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_Schema = (function(k, v) {
  var attributes$11 = this.Lsttp_tapir_Schema__f_attributes.put__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_AttributeMap(k, v);
  var schemaType$14 = this.Lsttp_tapir_Schema__f_schemaType;
  var name$14 = this.Lsttp_tapir_Schema__f_name;
  var isOptional$10 = this.Lsttp_tapir_Schema__f_isOptional;
  var description$14 = this.Lsttp_tapir_Schema__f_description;
  var default$14 = this.Lsttp_tapir_Schema__f_default;
  var format$13 = this.Lsttp_tapir_Schema__f_format;
  var encodedExample$14 = this.Lsttp_tapir_Schema__f_encodedExample;
  var deprecated$11 = this.Lsttp_tapir_Schema__f_deprecated;
  var hidden$11 = this.Lsttp_tapir_Schema__f_hidden;
  var validator$14 = this.Lsttp_tapir_Schema__f_validator;
  return new $c_Lsttp_tapir_Schema(schemaType$14, name$14, isOptional$10, description$14, default$14, format$13, encodedExample$14, deprecated$11, hidden$11, validator$14, attributes$11);
});
function $isArrayOf_Lsttp_tapir_Schema(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Schema)));
}
export { $isArrayOf_Lsttp_tapir_Schema as $isArrayOf_Lsttp_tapir_Schema };
var $d_Lsttp_tapir_Schema = new $TypeData().initClass($c_Lsttp_tapir_Schema, "sttp.tapir.Schema", ({
  Lsttp_tapir_Schema: 1,
  Lsttp_tapir_macros_SchemaMacros: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Schema as $d_Lsttp_tapir_Schema };
/** @constructor */
function $c_Lsttp_tapir_Schema$$anon$2() {
}
export { $c_Lsttp_tapir_Schema$$anon$2 as $c_Lsttp_tapir_Schema$$anon$2 };
$c_Lsttp_tapir_Schema$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_Schema$$anon$2.prototype.constructor = $c_Lsttp_tapir_Schema$$anon$2;
/** @constructor */
function $h_Lsttp_tapir_Schema$$anon$2() {
}
export { $h_Lsttp_tapir_Schema$$anon$2 as $h_Lsttp_tapir_Schema$$anon$2 };
$h_Lsttp_tapir_Schema$$anon$2.prototype = $c_Lsttp_tapir_Schema$$anon$2.prototype;
$c_Lsttp_tapir_Schema$$anon$2.prototype.isDefinedAt__Lsttp_tapir_Validator$Primitive__Z = (function(x) {
  if ((x instanceof $c_Lsttp_tapir_Validator$Enumeration)) {
    var x89 = x.Lsttp_tapir_Validator$Enumeration__f_name;
    if ((x89 instanceof $c_s_Some)) {
      return true;
    }
  }
  return false;
});
$c_Lsttp_tapir_Schema$$anon$2.prototype.applyOrElse__Lsttp_tapir_Validator$Primitive__F1__O = (function(x, default$1) {
  if ((x instanceof $c_Lsttp_tapir_Validator$Enumeration)) {
    var x97 = x.Lsttp_tapir_Validator$Enumeration__f_name;
    if ((x97 instanceof $c_s_Some)) {
      var name = x97.s_Some__f_value;
      return name;
    }
  }
  return default$1.apply__O__O(x);
});
$c_Lsttp_tapir_Schema$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_Validator$Primitive__Z(x);
});
$c_Lsttp_tapir_Schema$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_Validator$Primitive__F1__O(x, default$1);
});
var $d_Lsttp_tapir_Schema$$anon$2 = new $TypeData().initClass($c_Lsttp_tapir_Schema$$anon$2, "sttp.tapir.Schema$$anon$2", ({
  Lsttp_tapir_Schema$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Schema$$anon$2 as $d_Lsttp_tapir_Schema$$anon$2 };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SArray(element, toIterable) {
  this.Lsttp_tapir_SchemaType$SArray__f_element = null;
  this.Lsttp_tapir_SchemaType$SArray__f_toIterable = null;
  this.Lsttp_tapir_SchemaType$SArray__f_element = element;
  this.Lsttp_tapir_SchemaType$SArray__f_toIterable = toIterable;
}
export { $c_Lsttp_tapir_SchemaType$SArray as $c_Lsttp_tapir_SchemaType$SArray };
$c_Lsttp_tapir_SchemaType$SArray.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SArray.prototype.constructor = $c_Lsttp_tapir_SchemaType$SArray;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SArray() {
}
export { $h_Lsttp_tapir_SchemaType$SArray as $h_Lsttp_tapir_SchemaType$SArray };
$h_Lsttp_tapir_SchemaType$SArray.prototype = $c_Lsttp_tapir_SchemaType$SArray.prototype;
$c_Lsttp_tapir_SchemaType$SArray.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SArray.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1238577726, true);
});
$c_Lsttp_tapir_SchemaType$SArray.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_SchemaType$SArray)) {
    var x = this.Lsttp_tapir_SchemaType$SArray__f_element;
    var x$2 = x$0.Lsttp_tapir_SchemaType$SArray__f_element;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_SchemaType$SArray.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SArray.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_SchemaType$SArray.prototype.productPrefix__T = (function() {
  return "SArray";
});
$c_Lsttp_tapir_SchemaType$SArray.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_SchemaType$SArray__f_element;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SArray.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "element";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SArray.prototype.contramap__F1__Lsttp_tapir_SchemaType = (function(g) {
  var element = this.Lsttp_tapir_SchemaType$SArray__f_element;
  var toIterable = g.andThen__F1__F1(this.Lsttp_tapir_SchemaType$SArray__f_toIterable);
  return new $c_Lsttp_tapir_SchemaType$SArray(element, toIterable);
});
function $isArrayOf_Lsttp_tapir_SchemaType$SArray(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SArray)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SArray as $isArrayOf_Lsttp_tapir_SchemaType$SArray };
var $d_Lsttp_tapir_SchemaType$SArray = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SArray, "sttp.tapir.SchemaType$SArray", ({
  Lsttp_tapir_SchemaType$SArray: 1,
  Lsttp_tapir_SchemaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SArray as $d_Lsttp_tapir_SchemaType$SArray };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SBinary() {
}
export { $c_Lsttp_tapir_SchemaType$SBinary as $c_Lsttp_tapir_SchemaType$SBinary };
$c_Lsttp_tapir_SchemaType$SBinary.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SBinary.prototype.constructor = $c_Lsttp_tapir_SchemaType$SBinary;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SBinary() {
}
export { $h_Lsttp_tapir_SchemaType$SBinary as $h_Lsttp_tapir_SchemaType$SBinary };
$h_Lsttp_tapir_SchemaType$SBinary.prototype = $c_Lsttp_tapir_SchemaType$SBinary.prototype;
$c_Lsttp_tapir_SchemaType$SBinary.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SBinary.prototype.hashCode__I = (function() {
  return (-1656738252);
});
$c_Lsttp_tapir_SchemaType$SBinary.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_SchemaType$SBinary));
});
$c_Lsttp_tapir_SchemaType$SBinary.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SBinary.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_SchemaType$SBinary.prototype.productPrefix__T = (function() {
  return "SBinary";
});
$c_Lsttp_tapir_SchemaType$SBinary.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SBinary.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SBinary.prototype.contramap__F1__Lsttp_tapir_SchemaType = (function(g) {
  return new $c_Lsttp_tapir_SchemaType$SBinary();
});
function $isArrayOf_Lsttp_tapir_SchemaType$SBinary(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SBinary)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SBinary as $isArrayOf_Lsttp_tapir_SchemaType$SBinary };
var $d_Lsttp_tapir_SchemaType$SBinary = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SBinary, "sttp.tapir.SchemaType$SBinary", ({
  Lsttp_tapir_SchemaType$SBinary: 1,
  Lsttp_tapir_SchemaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SBinary as $d_Lsttp_tapir_SchemaType$SBinary };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SBoolean() {
}
export { $c_Lsttp_tapir_SchemaType$SBoolean as $c_Lsttp_tapir_SchemaType$SBoolean };
$c_Lsttp_tapir_SchemaType$SBoolean.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SBoolean.prototype.constructor = $c_Lsttp_tapir_SchemaType$SBoolean;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SBoolean() {
}
export { $h_Lsttp_tapir_SchemaType$SBoolean as $h_Lsttp_tapir_SchemaType$SBoolean };
$h_Lsttp_tapir_SchemaType$SBoolean.prototype = $c_Lsttp_tapir_SchemaType$SBoolean.prototype;
$c_Lsttp_tapir_SchemaType$SBoolean.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SBoolean.prototype.hashCode__I = (function() {
  return 353734741;
});
$c_Lsttp_tapir_SchemaType$SBoolean.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_SchemaType$SBoolean));
});
$c_Lsttp_tapir_SchemaType$SBoolean.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SBoolean.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_SchemaType$SBoolean.prototype.productPrefix__T = (function() {
  return "SBoolean";
});
$c_Lsttp_tapir_SchemaType$SBoolean.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SBoolean.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SBoolean.prototype.contramap__F1__Lsttp_tapir_SchemaType = (function(g) {
  return new $c_Lsttp_tapir_SchemaType$SBoolean();
});
function $isArrayOf_Lsttp_tapir_SchemaType$SBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SBoolean)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SBoolean as $isArrayOf_Lsttp_tapir_SchemaType$SBoolean };
var $d_Lsttp_tapir_SchemaType$SBoolean = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SBoolean, "sttp.tapir.SchemaType$SBoolean", ({
  Lsttp_tapir_SchemaType$SBoolean: 1,
  Lsttp_tapir_SchemaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SBoolean as $d_Lsttp_tapir_SchemaType$SBoolean };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SCoproduct(subtypes, discriminator, subtypeSchema) {
  this.Lsttp_tapir_SchemaType$SCoproduct__f_subtypes = null;
  this.Lsttp_tapir_SchemaType$SCoproduct__f_discriminator = null;
  this.Lsttp_tapir_SchemaType$SCoproduct__f_subtypeSchema = null;
  this.Lsttp_tapir_SchemaType$SCoproduct__f_subtypes = subtypes;
  this.Lsttp_tapir_SchemaType$SCoproduct__f_discriminator = discriminator;
  this.Lsttp_tapir_SchemaType$SCoproduct__f_subtypeSchema = subtypeSchema;
}
export { $c_Lsttp_tapir_SchemaType$SCoproduct as $c_Lsttp_tapir_SchemaType$SCoproduct };
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype.constructor = $c_Lsttp_tapir_SchemaType$SCoproduct;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SCoproduct() {
}
export { $h_Lsttp_tapir_SchemaType$SCoproduct as $h_Lsttp_tapir_SchemaType$SCoproduct };
$h_Lsttp_tapir_SchemaType$SCoproduct.prototype = $c_Lsttp_tapir_SchemaType$SCoproduct.prototype;
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 698194036, true);
});
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_SchemaType$SCoproduct)) {
    var x = this.Lsttp_tapir_SchemaType$SCoproduct__f_subtypes;
    var x$2 = x$0.Lsttp_tapir_SchemaType$SCoproduct__f_subtypes;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_SchemaType$SCoproduct__f_discriminator;
      var x$4 = x$0.Lsttp_tapir_SchemaType$SCoproduct__f_discriminator;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype.productPrefix__T = (function() {
  return "SCoproduct";
});
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_SchemaType$SCoproduct__f_subtypes;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_SchemaType$SCoproduct__f_discriminator;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "subtypes";
  }
  if ((n === 1)) {
    return "discriminator";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype.addDiscriminatorField__Lsttp_tapir_FieldName__Lsttp_tapir_Schema__sci_Map__Lsttp_tapir_SchemaType$SCoproduct = (function(discriminatorName, discriminatorSchema, discriminatorMapping) {
  var this$2 = discriminatorMapping.toList__sci_List();
  var f = ((x$1) => {
    if ((x$1 !== null)) {
      var v = x$1._1__O();
      var ref = x$1._2__O();
      var _1 = ref.Lsttp_tapir_SchemaType$SRef__f_name;
      return $ct_T2__O__O__(new $c_T2(), _1, v);
    }
    throw new $c_s_MatchError(x$1);
  });
  if ((this$2 === $m_sci_Nil$())) {
    var this$4 = $m_sci_Nil$();
  } else {
    var x0 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$2.tail__O();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    var this$4 = h;
  }
  var reverseDiscriminatorByNameMapping = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$4);
  var this$13 = this.Lsttp_tapir_SchemaType$SCoproduct__f_subtypes;
  var f$2 = ((x$1$2) => {
    if ((x$1$2 !== null)) {
      $m_Lsttp_tapir_Schema$();
      var x72 = x$1$2.Lsttp_tapir_Schema__f_schemaType;
      if ((x72 instanceof $c_Lsttp_tapir_SchemaType$SProduct)) {
        var this$6 = x72.Lsttp_tapir_SchemaType$SProduct__f_fields;
        _return: {
          var these = this$6;
          while ((!these.isEmpty__Z())) {
            var x0$2 = these.head__O();
            var x = x0$2.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name;
            if ((!(!((x === null) ? (discriminatorName === null) : x.equals__O__Z(discriminatorName))))) {
              var $x_1 = false;
              break _return;
            }
            these = these.tail__O();
          }
          var $x_1 = true;
        }
        if ($x_1) {
          var this$8 = x72.Lsttp_tapir_SchemaType$SProduct__f_fields;
          var _get = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => $m_s_None$()));
          var elem = new $c_Lsttp_tapir_SchemaType$SProductField$$anon$1(discriminatorName, discriminatorSchema, _get);
          var fields = $f_sc_StrictOptimizedSeqOps__appended__O__O(this$8, elem);
          var targetSt = new $c_Lsttp_tapir_SchemaType$SProduct(fields);
        } else {
          var targetSt = x72;
        }
        var this$11 = targetSt.Lsttp_tapir_SchemaType$SProduct__f_fields;
        var f$1 = ((s$2) => ((field) => {
          var x$2 = field.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name;
          if (((x$2 === null) ? (discriminatorName === null) : x$2.equals__O__Z(discriminatorName))) {
            var this$9 = s$2.Lsttp_tapir_Schema__f_name;
            if (this$9.isEmpty__Z()) {
              var discriminatorValue = $m_s_None$();
            } else {
              var x0$3 = this$9.get__O();
              var discriminatorValue = reverseDiscriminatorByNameMapping.get__O__s_Option(x0$3);
            }
            if ((discriminatorValue instanceof $c_s_Some)) {
              var v$1 = discriminatorValue.s_Some__f_value;
              var _name = field.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name;
              var _schema = field.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema.encodedDiscriminatorValue__T__Lsttp_tapir_Schema(v$1);
              var _get$1 = field.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_get;
              return new $c_Lsttp_tapir_SchemaType$SProductField$$anon$1(_name, _schema, _get$1);
            }
            var x$3 = $m_s_None$();
            if ((x$3 === discriminatorValue)) {
              return field;
            }
            throw new $c_s_MatchError(discriminatorValue);
          } else {
            return field;
          }
        }))(x$1$2);
        if ((this$11 === $m_sci_Nil$())) {
          var fields$1 = $m_sci_Nil$();
        } else {
          var x0$4 = this$11.head__O();
          var h$1 = new $c_sci_$colon$colon(f$1(x0$4), $m_sci_Nil$());
          var t$1 = h$1;
          var rest$1 = this$11.tail__O();
          while ((rest$1 !== $m_sci_Nil$())) {
            var x0$5 = rest$1.head__O();
            var nx$1 = new $c_sci_$colon$colon(f$1(x0$5), $m_sci_Nil$());
            t$1.sci_$colon$colon__f_next = nx$1;
            t$1 = nx$1;
            rest$1 = rest$1.tail__O();
          }
          var fields$1 = h$1;
        }
        targetSt = new $c_Lsttp_tapir_SchemaType$SProduct(fields$1);
        var schemaType = targetSt;
        var name = x$1$2.Lsttp_tapir_Schema__f_name;
        var isOptional = x$1$2.Lsttp_tapir_Schema__f_isOptional;
        var description = x$1$2.Lsttp_tapir_Schema__f_description;
        var default$1 = x$1$2.Lsttp_tapir_Schema__f_default;
        var format = x$1$2.Lsttp_tapir_Schema__f_format;
        var encodedExample = x$1$2.Lsttp_tapir_Schema__f_encodedExample;
        var deprecated = x$1$2.Lsttp_tapir_Schema__f_deprecated;
        var hidden = x$1$2.Lsttp_tapir_Schema__f_hidden;
        var validator = x$1$2.Lsttp_tapir_Schema__f_validator;
        var attributes = x$1$2.Lsttp_tapir_Schema__f_attributes;
        return new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
      }
    }
    return x$1$2;
  });
  if ((this$13 === $m_sci_Nil$())) {
    var subtypes = $m_sci_Nil$();
  } else {
    var x0$6 = this$13.head__O();
    var h$2 = new $c_sci_$colon$colon(f$2(x0$6), $m_sci_Nil$());
    var t$2 = h$2;
    var rest$2 = this$13.tail__O();
    while ((rest$2 !== $m_sci_Nil$())) {
      var x0$7 = rest$2.head__O();
      var nx$2 = new $c_sci_$colon$colon(f$2(x0$7), $m_sci_Nil$());
      t$2.sci_$colon$colon__f_next = nx$2;
      t$2 = nx$2;
      rest$2 = rest$2.tail__O();
    }
    var subtypes = h$2;
  }
  var value = new $c_Lsttp_tapir_SchemaType$SDiscriminator(discriminatorName, discriminatorMapping);
  var discriminator = new $c_s_Some(value);
  var subtypeSchema = this.Lsttp_tapir_SchemaType$SCoproduct__f_subtypeSchema;
  return new $c_Lsttp_tapir_SchemaType$SCoproduct(subtypes, discriminator, subtypeSchema);
});
$c_Lsttp_tapir_SchemaType$SCoproduct.prototype.contramap__F1__Lsttp_tapir_SchemaType = (function(g) {
  var subtypes = this.Lsttp_tapir_SchemaType$SCoproduct__f_subtypes;
  var discriminator = this.Lsttp_tapir_SchemaType$SCoproduct__f_discriminator;
  var subtypeSchema = g.andThen__F1__F1(this.Lsttp_tapir_SchemaType$SCoproduct__f_subtypeSchema);
  return new $c_Lsttp_tapir_SchemaType$SCoproduct(subtypes, discriminator, subtypeSchema);
});
function $isArrayOf_Lsttp_tapir_SchemaType$SCoproduct(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SCoproduct)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SCoproduct as $isArrayOf_Lsttp_tapir_SchemaType$SCoproduct };
var $d_Lsttp_tapir_SchemaType$SCoproduct = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SCoproduct, "sttp.tapir.SchemaType$SCoproduct", ({
  Lsttp_tapir_SchemaType$SCoproduct: 1,
  Lsttp_tapir_SchemaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SCoproduct as $d_Lsttp_tapir_SchemaType$SCoproduct };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SInteger() {
}
export { $c_Lsttp_tapir_SchemaType$SInteger as $c_Lsttp_tapir_SchemaType$SInteger };
$c_Lsttp_tapir_SchemaType$SInteger.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SInteger.prototype.constructor = $c_Lsttp_tapir_SchemaType$SInteger;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SInteger() {
}
export { $h_Lsttp_tapir_SchemaType$SInteger as $h_Lsttp_tapir_SchemaType$SInteger };
$h_Lsttp_tapir_SchemaType$SInteger.prototype = $c_Lsttp_tapir_SchemaType$SInteger.prototype;
$c_Lsttp_tapir_SchemaType$SInteger.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SInteger.prototype.hashCode__I = (function() {
  return (-2047892117);
});
$c_Lsttp_tapir_SchemaType$SInteger.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_SchemaType$SInteger));
});
$c_Lsttp_tapir_SchemaType$SInteger.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SInteger.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_SchemaType$SInteger.prototype.productPrefix__T = (function() {
  return "SInteger";
});
$c_Lsttp_tapir_SchemaType$SInteger.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SInteger.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SInteger.prototype.contramap__F1__Lsttp_tapir_SchemaType = (function(g) {
  return new $c_Lsttp_tapir_SchemaType$SInteger();
});
function $isArrayOf_Lsttp_tapir_SchemaType$SInteger(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SInteger)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SInteger as $isArrayOf_Lsttp_tapir_SchemaType$SInteger };
var $d_Lsttp_tapir_SchemaType$SInteger = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SInteger, "sttp.tapir.SchemaType$SInteger", ({
  Lsttp_tapir_SchemaType$SInteger: 1,
  Lsttp_tapir_SchemaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SInteger as $d_Lsttp_tapir_SchemaType$SInteger };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SNumber() {
}
export { $c_Lsttp_tapir_SchemaType$SNumber as $c_Lsttp_tapir_SchemaType$SNumber };
$c_Lsttp_tapir_SchemaType$SNumber.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SNumber.prototype.constructor = $c_Lsttp_tapir_SchemaType$SNumber;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SNumber() {
}
export { $h_Lsttp_tapir_SchemaType$SNumber as $h_Lsttp_tapir_SchemaType$SNumber };
$h_Lsttp_tapir_SchemaType$SNumber.prototype = $c_Lsttp_tapir_SchemaType$SNumber.prototype;
$c_Lsttp_tapir_SchemaType$SNumber.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SNumber.prototype.hashCode__I = (function() {
  return (-1302135428);
});
$c_Lsttp_tapir_SchemaType$SNumber.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_SchemaType$SNumber));
});
$c_Lsttp_tapir_SchemaType$SNumber.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SNumber.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_SchemaType$SNumber.prototype.productPrefix__T = (function() {
  return "SNumber";
});
$c_Lsttp_tapir_SchemaType$SNumber.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SNumber.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SNumber.prototype.contramap__F1__Lsttp_tapir_SchemaType = (function(g) {
  return new $c_Lsttp_tapir_SchemaType$SNumber();
});
function $isArrayOf_Lsttp_tapir_SchemaType$SNumber(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SNumber)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SNumber as $isArrayOf_Lsttp_tapir_SchemaType$SNumber };
var $d_Lsttp_tapir_SchemaType$SNumber = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SNumber, "sttp.tapir.SchemaType$SNumber", ({
  Lsttp_tapir_SchemaType$SNumber: 1,
  Lsttp_tapir_SchemaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SNumber as $d_Lsttp_tapir_SchemaType$SNumber };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SOpenProduct(fields, valueSchema, mapFieldValues) {
  this.Lsttp_tapir_SchemaType$SOpenProduct__f_fields = null;
  this.Lsttp_tapir_SchemaType$SOpenProduct__f_valueSchema = null;
  this.Lsttp_tapir_SchemaType$SOpenProduct__f_mapFieldValues = null;
  this.Lsttp_tapir_SchemaType$SOpenProduct__f_fieldsWithValidation = null;
  this.Lsttp_tapir_SchemaType$SOpenProduct__f_fields = fields;
  this.Lsttp_tapir_SchemaType$SOpenProduct__f_valueSchema = valueSchema;
  this.Lsttp_tapir_SchemaType$SOpenProduct__f_mapFieldValues = mapFieldValues;
  this.Lsttp_tapir_SchemaType$SOpenProduct__f_fieldsWithValidation = fields.collect__s_PartialFunction__sci_List(new $c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4());
}
export { $c_Lsttp_tapir_SchemaType$SOpenProduct as $c_Lsttp_tapir_SchemaType$SOpenProduct };
$c_Lsttp_tapir_SchemaType$SOpenProduct.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SOpenProduct.prototype.constructor = $c_Lsttp_tapir_SchemaType$SOpenProduct;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SOpenProduct() {
}
export { $h_Lsttp_tapir_SchemaType$SOpenProduct as $h_Lsttp_tapir_SchemaType$SOpenProduct };
$h_Lsttp_tapir_SchemaType$SOpenProduct.prototype = $c_Lsttp_tapir_SchemaType$SOpenProduct.prototype;
$c_Lsttp_tapir_SchemaType$SOpenProduct.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SOpenProduct.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1458480968, true);
});
$c_Lsttp_tapir_SchemaType$SOpenProduct.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_SchemaType$SOpenProduct)) {
    var x = this.Lsttp_tapir_SchemaType$SOpenProduct__f_fields;
    var x$2 = x$0.Lsttp_tapir_SchemaType$SOpenProduct__f_fields;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_SchemaType$SOpenProduct__f_valueSchema;
      var x$4 = x$0.Lsttp_tapir_SchemaType$SOpenProduct__f_valueSchema;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_SchemaType$SOpenProduct.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SOpenProduct.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_SchemaType$SOpenProduct.prototype.productPrefix__T = (function() {
  return "SOpenProduct";
});
$c_Lsttp_tapir_SchemaType$SOpenProduct.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_SchemaType$SOpenProduct__f_fields;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_SchemaType$SOpenProduct__f_valueSchema;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SOpenProduct.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "fields";
  }
  if ((n === 1)) {
    return "valueSchema";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SOpenProduct.prototype.contramap__F1__Lsttp_tapir_SchemaType = (function(g) {
  var this$2 = this.Lsttp_tapir_SchemaType$SOpenProduct__f_fields;
  var f$1 = ((f) => {
    var _name = f.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name;
    var _schema = f.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema;
    var _get = g.andThen__F1__F1(f.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_get);
    return new $c_Lsttp_tapir_SchemaType$SProductField$$anon$1(_name, _schema, _get);
  });
  if ((this$2 === $m_sci_Nil$())) {
    var fields = $m_sci_Nil$();
  } else {
    var x0 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f$1(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$2.tail__O();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    var fields = h;
  }
  var valueSchema = this.Lsttp_tapir_SchemaType$SOpenProduct__f_valueSchema;
  var mapFieldValues = g.andThen__F1__F1(this.Lsttp_tapir_SchemaType$SOpenProduct__f_mapFieldValues);
  return new $c_Lsttp_tapir_SchemaType$SOpenProduct(fields, valueSchema, mapFieldValues);
});
function $isArrayOf_Lsttp_tapir_SchemaType$SOpenProduct(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SOpenProduct)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SOpenProduct as $isArrayOf_Lsttp_tapir_SchemaType$SOpenProduct };
var $d_Lsttp_tapir_SchemaType$SOpenProduct = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SOpenProduct, "sttp.tapir.SchemaType$SOpenProduct", ({
  Lsttp_tapir_SchemaType$SOpenProduct: 1,
  Lsttp_tapir_SchemaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SOpenProduct as $d_Lsttp_tapir_SchemaType$SOpenProduct };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4() {
}
export { $c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4 as $c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4 };
$c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4.prototype = new $h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4.prototype.constructor = $c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4() {
}
export { $h_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4 as $h_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4 };
$h_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4.prototype = $c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4.prototype;
$c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4.prototype.isDefinedAt__Lsttp_tapir_SchemaType$SProductField__Z = (function(x) {
  return x.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema.hasValidation__Z();
});
$c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4.prototype.applyOrElse__Lsttp_tapir_SchemaType$SProductField__F1__O = (function(x, default$1) {
  return (x.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema.hasValidation__Z() ? x : default$1.apply__O__O(x));
});
$c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_SchemaType$SProductField__Z(x);
});
$c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_SchemaType$SProductField__F1__O(x, default$1);
});
var $d_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4 = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4, "sttp.tapir.SchemaType$SOpenProduct$$anon$4", ({
  Lsttp_tapir_SchemaType$SOpenProduct$$anon$4: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4 as $d_Lsttp_tapir_SchemaType$SOpenProduct$$anon$4 };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SOption(element, toOption) {
  this.Lsttp_tapir_SchemaType$SOption__f_element = null;
  this.Lsttp_tapir_SchemaType$SOption__f_toOption = null;
  this.Lsttp_tapir_SchemaType$SOption__f_element = element;
  this.Lsttp_tapir_SchemaType$SOption__f_toOption = toOption;
}
export { $c_Lsttp_tapir_SchemaType$SOption as $c_Lsttp_tapir_SchemaType$SOption };
$c_Lsttp_tapir_SchemaType$SOption.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SOption.prototype.constructor = $c_Lsttp_tapir_SchemaType$SOption;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SOption() {
}
export { $h_Lsttp_tapir_SchemaType$SOption as $h_Lsttp_tapir_SchemaType$SOption };
$h_Lsttp_tapir_SchemaType$SOption.prototype = $c_Lsttp_tapir_SchemaType$SOption.prototype;
$c_Lsttp_tapir_SchemaType$SOption.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SOption.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-235208584), true);
});
$c_Lsttp_tapir_SchemaType$SOption.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_SchemaType$SOption)) {
    var x = this.Lsttp_tapir_SchemaType$SOption__f_element;
    var x$2 = x$0.Lsttp_tapir_SchemaType$SOption__f_element;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_SchemaType$SOption.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SOption.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_SchemaType$SOption.prototype.productPrefix__T = (function() {
  return "SOption";
});
$c_Lsttp_tapir_SchemaType$SOption.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_SchemaType$SOption__f_element;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SOption.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "element";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SOption.prototype.contramap__F1__Lsttp_tapir_SchemaType = (function(g) {
  var element = this.Lsttp_tapir_SchemaType$SOption__f_element;
  var toOption = g.andThen__F1__F1(this.Lsttp_tapir_SchemaType$SOption__f_toOption);
  return new $c_Lsttp_tapir_SchemaType$SOption(element, toOption);
});
function $isArrayOf_Lsttp_tapir_SchemaType$SOption(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SOption)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SOption as $isArrayOf_Lsttp_tapir_SchemaType$SOption };
var $d_Lsttp_tapir_SchemaType$SOption = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SOption, "sttp.tapir.SchemaType$SOption", ({
  Lsttp_tapir_SchemaType$SOption: 1,
  Lsttp_tapir_SchemaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SOption as $d_Lsttp_tapir_SchemaType$SOption };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SProduct(fields) {
  this.Lsttp_tapir_SchemaType$SProduct__f_fields = null;
  this.Lsttp_tapir_SchemaType$SProduct__f_fieldsWithValidation = null;
  this.Lsttp_tapir_SchemaType$SProduct__f_fields = fields;
  this.Lsttp_tapir_SchemaType$SProduct__f_fieldsWithValidation = fields.collect__s_PartialFunction__sci_List(new $c_Lsttp_tapir_SchemaType$SProduct$$anon$2());
}
export { $c_Lsttp_tapir_SchemaType$SProduct as $c_Lsttp_tapir_SchemaType$SProduct };
$c_Lsttp_tapir_SchemaType$SProduct.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SProduct.prototype.constructor = $c_Lsttp_tapir_SchemaType$SProduct;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SProduct() {
}
export { $h_Lsttp_tapir_SchemaType$SProduct as $h_Lsttp_tapir_SchemaType$SProduct };
$h_Lsttp_tapir_SchemaType$SProduct.prototype = $c_Lsttp_tapir_SchemaType$SProduct.prototype;
$c_Lsttp_tapir_SchemaType$SProduct.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SProduct.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-846072001), true);
});
$c_Lsttp_tapir_SchemaType$SProduct.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_SchemaType$SProduct)) {
    var x = this.Lsttp_tapir_SchemaType$SProduct__f_fields;
    var x$2 = x$0.Lsttp_tapir_SchemaType$SProduct__f_fields;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_SchemaType$SProduct.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SProduct.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_SchemaType$SProduct.prototype.productPrefix__T = (function() {
  return "SProduct";
});
$c_Lsttp_tapir_SchemaType$SProduct.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_SchemaType$SProduct__f_fields;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SProduct.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "fields";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SProduct.prototype.contramap__F1__Lsttp_tapir_SchemaType = (function(g) {
  var this$2 = this.Lsttp_tapir_SchemaType$SProduct__f_fields;
  var f$1 = ((f) => {
    var _name = f.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_name;
    var _schema = f.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema;
    var _get = g.andThen__F1__F1(f.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_get);
    return new $c_Lsttp_tapir_SchemaType$SProductField$$anon$1(_name, _schema, _get);
  });
  if ((this$2 === $m_sci_Nil$())) {
    var fields = $m_sci_Nil$();
  } else {
    var x0 = this$2.head__O();
    var h = new $c_sci_$colon$colon(f$1(x0), $m_sci_Nil$());
    var t = h;
    var rest = this$2.tail__O();
    while ((rest !== $m_sci_Nil$())) {
      var x0$1 = rest.head__O();
      var nx = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    var fields = h;
  }
  return new $c_Lsttp_tapir_SchemaType$SProduct(fields);
});
function $isArrayOf_Lsttp_tapir_SchemaType$SProduct(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SProduct)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SProduct as $isArrayOf_Lsttp_tapir_SchemaType$SProduct };
var $d_Lsttp_tapir_SchemaType$SProduct = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SProduct, "sttp.tapir.SchemaType$SProduct", ({
  Lsttp_tapir_SchemaType$SProduct: 1,
  Lsttp_tapir_SchemaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SProduct as $d_Lsttp_tapir_SchemaType$SProduct };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SProduct$$anon$2() {
}
export { $c_Lsttp_tapir_SchemaType$SProduct$$anon$2 as $c_Lsttp_tapir_SchemaType$SProduct$$anon$2 };
$c_Lsttp_tapir_SchemaType$SProduct$$anon$2.prototype = new $h_sr_AbstractPartialFunction();
$c_Lsttp_tapir_SchemaType$SProduct$$anon$2.prototype.constructor = $c_Lsttp_tapir_SchemaType$SProduct$$anon$2;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SProduct$$anon$2() {
}
export { $h_Lsttp_tapir_SchemaType$SProduct$$anon$2 as $h_Lsttp_tapir_SchemaType$SProduct$$anon$2 };
$h_Lsttp_tapir_SchemaType$SProduct$$anon$2.prototype = $c_Lsttp_tapir_SchemaType$SProduct$$anon$2.prototype;
$c_Lsttp_tapir_SchemaType$SProduct$$anon$2.prototype.isDefinedAt__Lsttp_tapir_SchemaType$SProductField__Z = (function(x) {
  return x.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema.hasValidation__Z();
});
$c_Lsttp_tapir_SchemaType$SProduct$$anon$2.prototype.applyOrElse__Lsttp_tapir_SchemaType$SProductField__F1__O = (function(x, default$1) {
  return (x.Lsttp_tapir_SchemaType$SProductField$$anon$1__f_schema.hasValidation__Z() ? x : default$1.apply__O__O(x));
});
$c_Lsttp_tapir_SchemaType$SProduct$$anon$2.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__Lsttp_tapir_SchemaType$SProductField__Z(x);
});
$c_Lsttp_tapir_SchemaType$SProduct$$anon$2.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return this.applyOrElse__Lsttp_tapir_SchemaType$SProductField__F1__O(x, default$1);
});
var $d_Lsttp_tapir_SchemaType$SProduct$$anon$2 = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SProduct$$anon$2, "sttp.tapir.SchemaType$SProduct$$anon$2", ({
  Lsttp_tapir_SchemaType$SProduct$$anon$2: 1,
  sr_AbstractPartialFunction: 1,
  F1: 1,
  s_PartialFunction: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SProduct$$anon$2 as $d_Lsttp_tapir_SchemaType$SProduct$$anon$2 };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SRef(name) {
  this.Lsttp_tapir_SchemaType$SRef__f_name = null;
  this.Lsttp_tapir_SchemaType$SRef__f_name = name;
}
export { $c_Lsttp_tapir_SchemaType$SRef as $c_Lsttp_tapir_SchemaType$SRef };
$c_Lsttp_tapir_SchemaType$SRef.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SRef.prototype.constructor = $c_Lsttp_tapir_SchemaType$SRef;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SRef() {
}
export { $h_Lsttp_tapir_SchemaType$SRef as $h_Lsttp_tapir_SchemaType$SRef };
$h_Lsttp_tapir_SchemaType$SRef.prototype = $c_Lsttp_tapir_SchemaType$SRef.prototype;
$c_Lsttp_tapir_SchemaType$SRef.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SRef.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 827875442, true);
});
$c_Lsttp_tapir_SchemaType$SRef.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_SchemaType$SRef)) {
    var x = this.Lsttp_tapir_SchemaType$SRef__f_name;
    var x$2 = x$0.Lsttp_tapir_SchemaType$SRef__f_name;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_SchemaType$SRef.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SRef.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_SchemaType$SRef.prototype.productPrefix__T = (function() {
  return "SRef";
});
$c_Lsttp_tapir_SchemaType$SRef.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_SchemaType$SRef__f_name;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SRef.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SRef.prototype.contramap__F1__Lsttp_tapir_SchemaType = (function(g) {
  var name = this.Lsttp_tapir_SchemaType$SRef__f_name;
  return new $c_Lsttp_tapir_SchemaType$SRef(name);
});
function $isArrayOf_Lsttp_tapir_SchemaType$SRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SRef)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SRef as $isArrayOf_Lsttp_tapir_SchemaType$SRef };
var $d_Lsttp_tapir_SchemaType$SRef = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SRef, "sttp.tapir.SchemaType$SRef", ({
  Lsttp_tapir_SchemaType$SRef: 1,
  Lsttp_tapir_SchemaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SRef as $d_Lsttp_tapir_SchemaType$SRef };
/** @constructor */
function $c_Lsttp_tapir_SchemaType$SString() {
}
export { $c_Lsttp_tapir_SchemaType$SString as $c_Lsttp_tapir_SchemaType$SString };
$c_Lsttp_tapir_SchemaType$SString.prototype = new $h_O();
$c_Lsttp_tapir_SchemaType$SString.prototype.constructor = $c_Lsttp_tapir_SchemaType$SString;
/** @constructor */
function $h_Lsttp_tapir_SchemaType$SString() {
}
export { $h_Lsttp_tapir_SchemaType$SString as $h_Lsttp_tapir_SchemaType$SString };
$h_Lsttp_tapir_SchemaType$SString.prototype = $c_Lsttp_tapir_SchemaType$SString.prototype;
$c_Lsttp_tapir_SchemaType$SString.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_SchemaType$SString.prototype.hashCode__I = (function() {
  return (-1159757244);
});
$c_Lsttp_tapir_SchemaType$SString.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (x$0 instanceof $c_Lsttp_tapir_SchemaType$SString));
});
$c_Lsttp_tapir_SchemaType$SString.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_SchemaType$SString.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_SchemaType$SString.prototype.productPrefix__T = (function() {
  return "SString";
});
$c_Lsttp_tapir_SchemaType$SString.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SString.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_SchemaType$SString.prototype.contramap__F1__Lsttp_tapir_SchemaType = (function(g) {
  return new $c_Lsttp_tapir_SchemaType$SString();
});
function $isArrayOf_Lsttp_tapir_SchemaType$SString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_SchemaType$SString)));
}
export { $isArrayOf_Lsttp_tapir_SchemaType$SString as $isArrayOf_Lsttp_tapir_SchemaType$SString };
var $d_Lsttp_tapir_SchemaType$SString = new $TypeData().initClass($c_Lsttp_tapir_SchemaType$SString, "sttp.tapir.SchemaType$SString", ({
  Lsttp_tapir_SchemaType$SString: 1,
  Lsttp_tapir_SchemaType: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_SchemaType$SString as $d_Lsttp_tapir_SchemaType$SString };
/** @constructor */
function $c_Lsttp_tapir_ValidationResult$Invalid(customMessage) {
  this.Lsttp_tapir_ValidationResult$Invalid__f_customMessage = null;
  this.Lsttp_tapir_ValidationResult$Invalid__f_customMessage = customMessage;
}
export { $c_Lsttp_tapir_ValidationResult$Invalid as $c_Lsttp_tapir_ValidationResult$Invalid };
$c_Lsttp_tapir_ValidationResult$Invalid.prototype = new $h_O();
$c_Lsttp_tapir_ValidationResult$Invalid.prototype.constructor = $c_Lsttp_tapir_ValidationResult$Invalid;
/** @constructor */
function $h_Lsttp_tapir_ValidationResult$Invalid() {
}
export { $h_Lsttp_tapir_ValidationResult$Invalid as $h_Lsttp_tapir_ValidationResult$Invalid };
$h_Lsttp_tapir_ValidationResult$Invalid.prototype = $c_Lsttp_tapir_ValidationResult$Invalid.prototype;
$c_Lsttp_tapir_ValidationResult$Invalid.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_ValidationResult$Invalid.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 821397941, true);
});
$c_Lsttp_tapir_ValidationResult$Invalid.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_ValidationResult$Invalid)) {
    var x = this.Lsttp_tapir_ValidationResult$Invalid__f_customMessage;
    var x$2 = x$0.Lsttp_tapir_ValidationResult$Invalid__f_customMessage;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_ValidationResult$Invalid.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_ValidationResult$Invalid.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_ValidationResult$Invalid.prototype.productPrefix__T = (function() {
  return "Invalid";
});
$c_Lsttp_tapir_ValidationResult$Invalid.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_ValidationResult$Invalid__f_customMessage;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_ValidationResult$Invalid.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "customMessage";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_ValidationResult$Invalid(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_ValidationResult$Invalid)));
}
export { $isArrayOf_Lsttp_tapir_ValidationResult$Invalid as $isArrayOf_Lsttp_tapir_ValidationResult$Invalid };
var $d_Lsttp_tapir_ValidationResult$Invalid = new $TypeData().initClass($c_Lsttp_tapir_ValidationResult$Invalid, "sttp.tapir.ValidationResult$Invalid", ({
  Lsttp_tapir_ValidationResult$Invalid: 1,
  Lsttp_tapir_ValidationResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_ValidationResult$Invalid as $d_Lsttp_tapir_ValidationResult$Invalid };
/** @constructor */
function $c_Lsttp_tapir_Validator$All(validators) {
  this.Lsttp_tapir_Validator$All__f_validators = null;
  this.Lsttp_tapir_Validator$All__f_validators = validators;
}
export { $c_Lsttp_tapir_Validator$All as $c_Lsttp_tapir_Validator$All };
$c_Lsttp_tapir_Validator$All.prototype = new $h_O();
$c_Lsttp_tapir_Validator$All.prototype.constructor = $c_Lsttp_tapir_Validator$All;
/** @constructor */
function $h_Lsttp_tapir_Validator$All() {
}
export { $h_Lsttp_tapir_Validator$All as $h_Lsttp_tapir_Validator$All };
$h_Lsttp_tapir_Validator$All.prototype = $c_Lsttp_tapir_Validator$All.prototype;
$c_Lsttp_tapir_Validator$All.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Validator$All.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1760799491, true);
});
$c_Lsttp_tapir_Validator$All.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_Validator$All)) {
    var x = this.Lsttp_tapir_Validator$All__f_validators;
    var x$2 = x$0.Lsttp_tapir_Validator$All__f_validators;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_Validator$All.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Validator$All.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_Validator$All.prototype.productPrefix__T = (function() {
  return "All";
});
$c_Lsttp_tapir_Validator$All.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_Validator$All__f_validators;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Validator$All.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "validators";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Validator$All.prototype.apply__O__sci_List = (function(t) {
  return this.Lsttp_tapir_Validator$All__f_validators.flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$7) => _$7.apply__O__sci_List(t)))).toList__sci_List();
});
$c_Lsttp_tapir_Validator$All.prototype.contramap__F1__Lsttp_tapir_Validator = (function(g) {
  return (this.Lsttp_tapir_Validator$All__f_validators.isEmpty__Z() ? this : new $c_Lsttp_tapir_Validator$Mapped(this, g));
});
$c_Lsttp_tapir_Validator$All.prototype.and__Lsttp_tapir_Validator__Lsttp_tapir_Validator = (function(other) {
  if (this.Lsttp_tapir_Validator$All__f_validators.isEmpty__Z()) {
    return other;
  } else {
    var this$1 = this.Lsttp_tapir_Validator$All__f_validators;
    var validators = this$1.appended__O__O(other);
    return new $c_Lsttp_tapir_Validator$All(validators);
  }
});
function $isArrayOf_Lsttp_tapir_Validator$All(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Validator$All)));
}
export { $isArrayOf_Lsttp_tapir_Validator$All as $isArrayOf_Lsttp_tapir_Validator$All };
var $d_Lsttp_tapir_Validator$All = new $TypeData().initClass($c_Lsttp_tapir_Validator$All, "sttp.tapir.Validator$All", ({
  Lsttp_tapir_Validator$All: 1,
  Lsttp_tapir_Validator: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Validator$All as $d_Lsttp_tapir_Validator$All };
/** @constructor */
function $c_Lsttp_tapir_Validator$Any(validators) {
  this.Lsttp_tapir_Validator$Any__f_validators = null;
  this.Lsttp_tapir_Validator$Any__f_validators = validators;
}
export { $c_Lsttp_tapir_Validator$Any as $c_Lsttp_tapir_Validator$Any };
$c_Lsttp_tapir_Validator$Any.prototype = new $h_O();
$c_Lsttp_tapir_Validator$Any.prototype.constructor = $c_Lsttp_tapir_Validator$Any;
/** @constructor */
function $h_Lsttp_tapir_Validator$Any() {
}
export { $h_Lsttp_tapir_Validator$Any as $h_Lsttp_tapir_Validator$Any };
$h_Lsttp_tapir_Validator$Any.prototype = $c_Lsttp_tapir_Validator$Any.prototype;
$c_Lsttp_tapir_Validator$Any.prototype.and__Lsttp_tapir_Validator__Lsttp_tapir_Validator = (function(other) {
  return $f_Lsttp_tapir_Validator__and__Lsttp_tapir_Validator__Lsttp_tapir_Validator(this, other);
});
$c_Lsttp_tapir_Validator$Any.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Validator$Any.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-113686424), true);
});
$c_Lsttp_tapir_Validator$Any.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_Validator$Any)) {
    var x = this.Lsttp_tapir_Validator$Any__f_validators;
    var x$2 = x$0.Lsttp_tapir_Validator$Any__f_validators;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_Validator$Any.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Validator$Any.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_Validator$Any.prototype.productPrefix__T = (function() {
  return "Any";
});
$c_Lsttp_tapir_Validator$Any.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_Validator$Any__f_validators;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Validator$Any.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "validators";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Validator$Any.prototype.apply__O__sci_List = (function(t) {
  var results = this.Lsttp_tapir_Validator$Any__f_validators.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => _$8.apply__O__sci_List(t))));
  if (results.exists__F1__Z(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$9) => _$9.isEmpty__Z())))) {
    return $m_sci_Nil$();
  } else {
    var this$2 = this.Lsttp_tapir_Validator$Any__f_validators;
    if ((!this$2.isEmpty__Z())) {
      var this$4 = $m_s_$less$colon$less$();
      return results.flatten__F1__O(this$4.s_$less$colon$less$__f_singleton).toList__sci_List();
    } else {
      var validator = $m_Lsttp_tapir_Validator$Any$().Lsttp_tapir_Validator$Any$__f__primitiveRejectValidator;
      var path = $m_sci_Nil$();
      var customMessage = $m_s_None$();
      return new $c_sci_$colon$colon(new $c_Lsttp_tapir_ValidationError(validator, t, path, customMessage), $m_sci_Nil$());
    }
  }
});
$c_Lsttp_tapir_Validator$Any.prototype.contramap__F1__Lsttp_tapir_Validator = (function(g) {
  if (this.Lsttp_tapir_Validator$Any__f_validators.isEmpty__Z()) {
    $m_Lsttp_tapir_Validator$Any$();
    var validators = $m_sci_Nil$();
    return new $c_Lsttp_tapir_Validator$Any(validators);
  } else {
    return new $c_Lsttp_tapir_Validator$Mapped(this, g);
  }
});
function $isArrayOf_Lsttp_tapir_Validator$Any(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Validator$Any)));
}
export { $isArrayOf_Lsttp_tapir_Validator$Any as $isArrayOf_Lsttp_tapir_Validator$Any };
var $d_Lsttp_tapir_Validator$Any = new $TypeData().initClass($c_Lsttp_tapir_Validator$Any, "sttp.tapir.Validator$Any", ({
  Lsttp_tapir_Validator$Any: 1,
  Lsttp_tapir_Validator: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Validator$Any as $d_Lsttp_tapir_Validator$Any };
/** @constructor */
function $c_Lsttp_tapir_Validator$Mapped(wrapped, g) {
  this.Lsttp_tapir_Validator$Mapped__f_wrapped = null;
  this.Lsttp_tapir_Validator$Mapped__f_g = null;
  this.Lsttp_tapir_Validator$Mapped__f_wrapped = wrapped;
  this.Lsttp_tapir_Validator$Mapped__f_g = g;
}
export { $c_Lsttp_tapir_Validator$Mapped as $c_Lsttp_tapir_Validator$Mapped };
$c_Lsttp_tapir_Validator$Mapped.prototype = new $h_O();
$c_Lsttp_tapir_Validator$Mapped.prototype.constructor = $c_Lsttp_tapir_Validator$Mapped;
/** @constructor */
function $h_Lsttp_tapir_Validator$Mapped() {
}
export { $h_Lsttp_tapir_Validator$Mapped as $h_Lsttp_tapir_Validator$Mapped };
$h_Lsttp_tapir_Validator$Mapped.prototype = $c_Lsttp_tapir_Validator$Mapped.prototype;
$c_Lsttp_tapir_Validator$Mapped.prototype.contramap__F1__Lsttp_tapir_Validator = (function(g) {
  return new $c_Lsttp_tapir_Validator$Mapped(this, g);
});
$c_Lsttp_tapir_Validator$Mapped.prototype.and__Lsttp_tapir_Validator__Lsttp_tapir_Validator = (function(other) {
  return $f_Lsttp_tapir_Validator__and__Lsttp_tapir_Validator__Lsttp_tapir_Validator(this, other);
});
$c_Lsttp_tapir_Validator$Mapped.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Validator$Mapped.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1833983837, true);
});
$c_Lsttp_tapir_Validator$Mapped.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_Validator$Mapped)) {
    var x = this.Lsttp_tapir_Validator$Mapped__f_wrapped;
    var x$2 = x$0.Lsttp_tapir_Validator$Mapped__f_wrapped;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_Validator$Mapped__f_g;
      var x$4 = x$0.Lsttp_tapir_Validator$Mapped__f_g;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_Validator$Mapped.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Validator$Mapped.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_Validator$Mapped.prototype.productPrefix__T = (function() {
  return "Mapped";
});
$c_Lsttp_tapir_Validator$Mapped.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_Validator$Mapped__f_wrapped;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_Validator$Mapped__f_g;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Validator$Mapped.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "wrapped";
  }
  if ((n === 1)) {
    return "g";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Validator$Mapped.prototype.apply__O__sci_List = (function(t) {
  return this.Lsttp_tapir_Validator$Mapped__f_wrapped.apply__O__sci_List(this.Lsttp_tapir_Validator$Mapped__f_g.apply__O__O(t));
});
function $isArrayOf_Lsttp_tapir_Validator$Mapped(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Validator$Mapped)));
}
export { $isArrayOf_Lsttp_tapir_Validator$Mapped as $isArrayOf_Lsttp_tapir_Validator$Mapped };
var $d_Lsttp_tapir_Validator$Mapped = new $TypeData().initClass($c_Lsttp_tapir_Validator$Mapped, "sttp.tapir.Validator$Mapped", ({
  Lsttp_tapir_Validator$Mapped: 1,
  Lsttp_tapir_Validator: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Validator$Mapped as $d_Lsttp_tapir_Validator$Mapped };
/** @constructor */
function $c_Lsttp_tapir_internal_package$ParamsAsAny(asAny) {
  this.Lsttp_tapir_internal_package$ParamsAsAny__f_asAny = null;
  this.Lsttp_tapir_internal_package$ParamsAsAny__f_asVector$lzy1 = null;
  this.Lsttp_tapir_internal_package$ParamsAsAny__f_asVectorbitmap$1 = false;
  this.Lsttp_tapir_internal_package$ParamsAsAny__f_asAny = asAny;
}
export { $c_Lsttp_tapir_internal_package$ParamsAsAny as $c_Lsttp_tapir_internal_package$ParamsAsAny };
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype = new $h_O();
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype.constructor = $c_Lsttp_tapir_internal_package$ParamsAsAny;
/** @constructor */
function $h_Lsttp_tapir_internal_package$ParamsAsAny() {
}
export { $h_Lsttp_tapir_internal_package$ParamsAsAny as $h_Lsttp_tapir_internal_package$ParamsAsAny };
$h_Lsttp_tapir_internal_package$ParamsAsAny.prototype = $c_Lsttp_tapir_internal_package$ParamsAsAny.prototype;
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 23944303, true);
});
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_internal_package$ParamsAsAny)) {
    var x = this.Lsttp_tapir_internal_package$ParamsAsAny__f_asAny;
    var y = x$0.Lsttp_tapir_internal_package$ParamsAsAny__f_asAny;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype.productPrefix__T = (function() {
  return "ParamsAsAny";
});
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_internal_package$ParamsAsAny__f_asAny;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "asAny";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype.asAny__O = (function() {
  return this.Lsttp_tapir_internal_package$ParamsAsAny__f_asAny;
});
$c_Lsttp_tapir_internal_package$ParamsAsAny.prototype.asVector__sci_Vector = (function() {
  if ((!this.Lsttp_tapir_internal_package$ParamsAsAny__f_asVectorbitmap$1)) {
    this.Lsttp_tapir_internal_package$ParamsAsAny__f_asVector$lzy1 = $m_Lsttp_tapir_internal_ParamsToSeq$().apply__O__sci_Seq(this.Lsttp_tapir_internal_package$ParamsAsAny__f_asAny).toVector__sci_Vector();
    this.Lsttp_tapir_internal_package$ParamsAsAny__f_asVectorbitmap$1 = true;
  }
  return this.Lsttp_tapir_internal_package$ParamsAsAny__f_asVector$lzy1;
});
function $isArrayOf_Lsttp_tapir_internal_package$ParamsAsAny(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_internal_package$ParamsAsAny)));
}
export { $isArrayOf_Lsttp_tapir_internal_package$ParamsAsAny as $isArrayOf_Lsttp_tapir_internal_package$ParamsAsAny };
var $d_Lsttp_tapir_internal_package$ParamsAsAny = new $TypeData().initClass($c_Lsttp_tapir_internal_package$ParamsAsAny, "sttp.tapir.internal.package$ParamsAsAny", ({
  Lsttp_tapir_internal_package$ParamsAsAny: 1,
  Lsttp_tapir_internal_package$Params: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_internal_package$ParamsAsAny as $d_Lsttp_tapir_internal_package$ParamsAsAny };
/** @constructor */
function $c_Lsttp_tapir_internal_package$ParamsAsVector(asVector) {
  this.Lsttp_tapir_internal_package$ParamsAsVector__f_asVector = null;
  this.Lsttp_tapir_internal_package$ParamsAsVector__f_asAny$lzy1 = null;
  this.Lsttp_tapir_internal_package$ParamsAsVector__f_asAnybitmap$1 = false;
  this.Lsttp_tapir_internal_package$ParamsAsVector__f_asVector = asVector;
}
export { $c_Lsttp_tapir_internal_package$ParamsAsVector as $c_Lsttp_tapir_internal_package$ParamsAsVector };
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype = new $h_O();
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype.constructor = $c_Lsttp_tapir_internal_package$ParamsAsVector;
/** @constructor */
function $h_Lsttp_tapir_internal_package$ParamsAsVector() {
}
export { $h_Lsttp_tapir_internal_package$ParamsAsVector as $h_Lsttp_tapir_internal_package$ParamsAsVector };
$h_Lsttp_tapir_internal_package$ParamsAsVector.prototype = $c_Lsttp_tapir_internal_package$ParamsAsVector.prototype;
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-2118168897), true);
});
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_internal_package$ParamsAsVector)) {
    var x = this.Lsttp_tapir_internal_package$ParamsAsVector__f_asVector;
    var x$2 = x$0.Lsttp_tapir_internal_package$ParamsAsVector__f_asVector;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype.productPrefix__T = (function() {
  return "ParamsAsVector";
});
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_internal_package$ParamsAsVector__f_asVector;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "asVector";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype.asVector__sci_Vector = (function() {
  return this.Lsttp_tapir_internal_package$ParamsAsVector__f_asVector;
});
$c_Lsttp_tapir_internal_package$ParamsAsVector.prototype.asAny__O = (function() {
  if ((!this.Lsttp_tapir_internal_package$ParamsAsVector__f_asAnybitmap$1)) {
    this.Lsttp_tapir_internal_package$ParamsAsVector__f_asAny$lzy1 = $m_Lsttp_tapir_internal_SeqToParams$().apply__sci_Seq__O(this.Lsttp_tapir_internal_package$ParamsAsVector__f_asVector);
    this.Lsttp_tapir_internal_package$ParamsAsVector__f_asAnybitmap$1 = true;
  }
  return this.Lsttp_tapir_internal_package$ParamsAsVector__f_asAny$lzy1;
});
function $isArrayOf_Lsttp_tapir_internal_package$ParamsAsVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_internal_package$ParamsAsVector)));
}
export { $isArrayOf_Lsttp_tapir_internal_package$ParamsAsVector as $isArrayOf_Lsttp_tapir_internal_package$ParamsAsVector };
var $d_Lsttp_tapir_internal_package$ParamsAsVector = new $TypeData().initClass($c_Lsttp_tapir_internal_package$ParamsAsVector, "sttp.tapir.internal.package$ParamsAsVector", ({
  Lsttp_tapir_internal_package$ParamsAsVector: 1,
  Lsttp_tapir_internal_package$Params: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_internal_package$ParamsAsVector as $d_Lsttp_tapir_internal_package$ParamsAsVector };
class $c_Lsttp_tapir_model_UnsupportedWebSocketFrameException extends $c_Lsttp_ws_WebSocketException {
  constructor(f) {
    super();
    var msg = ("Unsupported web socket frame: " + f);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, msg, null, true, true);
  }
}
export { $c_Lsttp_tapir_model_UnsupportedWebSocketFrameException as $c_Lsttp_tapir_model_UnsupportedWebSocketFrameException };
var $d_Lsttp_tapir_model_UnsupportedWebSocketFrameException = new $TypeData().initClass($c_Lsttp_tapir_model_UnsupportedWebSocketFrameException, "sttp.tapir.model.UnsupportedWebSocketFrameException", ({
  Lsttp_tapir_model_UnsupportedWebSocketFrameException: 1,
  Lsttp_ws_WebSocketException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_model_UnsupportedWebSocketFrameException as $d_Lsttp_tapir_model_UnsupportedWebSocketFrameException };
function $ct_Lcats_NonEmptyReducible__Lcats_Foldable__($thiz, G) {
  $thiz.Lcats_NonEmptyReducible__f_G = G;
  return $thiz;
}
export { $ct_Lcats_NonEmptyReducible__Lcats_Foldable__ as $ct_Lcats_NonEmptyReducible__Lcats_Foldable__ };
/** @constructor */
function $c_Lcats_NonEmptyReducible() {
  this.Lcats_NonEmptyReducible__f_G = null;
}
export { $c_Lcats_NonEmptyReducible as $c_Lcats_NonEmptyReducible };
$c_Lcats_NonEmptyReducible.prototype = new $h_O();
$c_Lcats_NonEmptyReducible.prototype.constructor = $c_Lcats_NonEmptyReducible;
/** @constructor */
function $h_Lcats_NonEmptyReducible() {
}
export { $h_Lcats_NonEmptyReducible as $h_Lcats_NonEmptyReducible };
$h_Lcats_NonEmptyReducible.prototype = $c_Lcats_NonEmptyReducible.prototype;
$c_Lcats_NonEmptyReducible.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_NonEmptyReducible.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__O__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_NonEmptyReducible.prototype.size__O__J = (function(fa) {
  matchResult6: {
    var tail$2;
    var x18 = this.split__O__T2(fa);
    if ((x18 !== null)) {
      var tail = x18._2__O();
      var tail$2 = tail;
      break matchResult6;
    }
    throw new $c_s_MatchError(x18);
  }
  var b = this.Lcats_NonEmptyReducible__f_G.size__O__J(tail$2);
  var blo = b.RTLong__f_lo;
  var lo = ((1 + blo) | 0);
  var hi = ((b.RTLong__f_hi + (((blo & (~lo)) >>> 31) | 0)) | 0);
  return new $c_RTLong(lo, hi);
});
$c_Lcats_NonEmptyReducible.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, H) {
  matchResult8: {
    var \u03b44$___1;
    var \u03b44$___2;
    var x24 = this.split__O__T2(fa);
    if ((x24 !== null)) {
      var a = x24._1__O();
      var ga = x24._2__O();
      var \u03b44$___1 = a;
      var \u03b44$___2 = ga;
      break matchResult8;
    }
    throw new $c_s_MatchError(x24);
  }
  var a$2 = \u03b44$___1;
  var ga$2 = \u03b44$___2;
  return H.flatMap__O__F1__O(f.apply__O__O__O(z, a$2), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => this.Lcats_NonEmptyReducible__f_G.foldM__O__O__F2__Lcats_Monad__O(ga$2, _$4, f, H))));
});
/** @constructor */
function $c_Lcats_Now(value) {
  this.Lcats_Now__f_value = null;
  this.Lcats_Now__f_value = value;
}
export { $c_Lcats_Now as $c_Lcats_Now };
$c_Lcats_Now.prototype = new $h_Lcats_Eval$Leaf();
$c_Lcats_Now.prototype.constructor = $c_Lcats_Now;
/** @constructor */
function $h_Lcats_Now() {
}
export { $h_Lcats_Now as $h_Lcats_Now };
$h_Lcats_Now.prototype = $c_Lcats_Now.prototype;
$c_Lcats_Now.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_Now.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lcats_Now.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lcats_Now)) {
    var x = this.Lcats_Now__f_value;
    var y = x$0.Lcats_Now__f_value;
    return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lcats_Now.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lcats_Now.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_Now.prototype.productPrefix__T = (function() {
  return "Now";
});
$c_Lcats_Now.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_Now__f_value;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_Now.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "value";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_Now.prototype.value__O = (function() {
  return this.Lcats_Now__f_value;
});
function $isArrayOf_Lcats_Now(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_Now)));
}
export { $isArrayOf_Lcats_Now as $isArrayOf_Lcats_Now };
var $d_Lcats_Now = new $TypeData().initClass($c_Lcats_Now, "cats.Now", ({
  Lcats_Now: 1,
  Lcats_Eval$Leaf: 1,
  Lcats_Eval: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcats_Now as $d_Lcats_Now };
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$1() {
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$1__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_False;
}
export { $c_Lcats_UnorderedFoldable$$anon$1 as $c_Lcats_UnorderedFoldable$$anon$1 };
$c_Lcats_UnorderedFoldable$$anon$1.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$1.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$1;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$1() {
}
export { $h_Lcats_UnorderedFoldable$$anon$1 as $h_Lcats_UnorderedFoldable$$anon$1 };
$h_Lcats_UnorderedFoldable$$anon$1.prototype = $c_Lcats_UnorderedFoldable$$anon$1.prototype;
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return lx.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    var x$1$1 = (!(!x$1));
    if ((x$1$1 === true)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_True;
    }
    if ((x$1$1 === false)) {
      return ly;
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$1__f_empty;
});
$c_Lcats_UnorderedFoldable$$anon$1.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval(x, y);
});
var $d_Lcats_UnorderedFoldable$$anon$1 = new $TypeData().initClass($c_Lcats_UnorderedFoldable$$anon$1, "cats.UnorderedFoldable$$anon$1", ({
  Lcats_UnorderedFoldable$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1
}));
export { $d_Lcats_UnorderedFoldable$$anon$1 as $d_Lcats_UnorderedFoldable$$anon$1 };
/** @constructor */
function $c_Lcats_UnorderedFoldable$$anon$2() {
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = null;
  this.Lcats_UnorderedFoldable$$anon$2__f_empty = $m_Lcats_Eval$().Lcats_Eval$__f_True;
}
export { $c_Lcats_UnorderedFoldable$$anon$2 as $c_Lcats_UnorderedFoldable$$anon$2 };
$c_Lcats_UnorderedFoldable$$anon$2.prototype = new $h_O();
$c_Lcats_UnorderedFoldable$$anon$2.prototype.constructor = $c_Lcats_UnorderedFoldable$$anon$2;
/** @constructor */
function $h_Lcats_UnorderedFoldable$$anon$2() {
}
export { $h_Lcats_UnorderedFoldable$$anon$2 as $h_Lcats_UnorderedFoldable$$anon$2 };
$h_Lcats_UnorderedFoldable$$anon$2.prototype = $c_Lcats_UnorderedFoldable$$anon$2.prototype;
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval = (function(lx, ly) {
  return lx.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    var x$1$1 = (!(!x$1));
    if ((x$1$1 === true)) {
      return ly;
    }
    if ((x$1$1 === false)) {
      return $m_Lcats_Eval$().Lcats_Eval$__f_False;
    }
    throw new $c_s_MatchError(x$1$1);
  })));
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.empty__O = (function() {
  return this.Lcats_UnorderedFoldable$$anon$2__f_empty;
});
$c_Lcats_UnorderedFoldable$$anon$2.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__Lcats_Eval__Lcats_Eval__Lcats_Eval(x, y);
});
var $d_Lcats_UnorderedFoldable$$anon$2 = new $TypeData().initClass($c_Lcats_UnorderedFoldable$$anon$2, "cats.UnorderedFoldable$$anon$2", ({
  Lcats_UnorderedFoldable$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1
}));
export { $d_Lcats_UnorderedFoldable$$anon$2 as $d_Lcats_UnorderedFoldable$$anon$2 };
/** @constructor */
function $c_Lcats_data_NonEmptyList$() {
  this.Lcats_data_NonEmptyListInstances__f_catsDataInstancesForNonEmptyListBinCompat1 = null;
  $ct_Lcats_data_NonEmptyListInstances__(this);
}
export { $c_Lcats_data_NonEmptyList$ as $c_Lcats_data_NonEmptyList$ };
$c_Lcats_data_NonEmptyList$.prototype = new $h_Lcats_data_NonEmptyListInstances();
$c_Lcats_data_NonEmptyList$.prototype.constructor = $c_Lcats_data_NonEmptyList$;
/** @constructor */
function $h_Lcats_data_NonEmptyList$() {
}
export { $h_Lcats_data_NonEmptyList$ as $h_Lcats_data_NonEmptyList$ };
$h_Lcats_data_NonEmptyList$.prototype = $c_Lcats_data_NonEmptyList$.prototype;
$c_Lcats_data_NonEmptyList$.prototype.fromList__sci_List__s_Option = (function(l) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(l)) {
    return $m_s_None$();
  }
  if ((l instanceof $c_sci_$colon$colon)) {
    var x47 = l.sci_$colon$colon__f_next;
    var h = l.sci_$colon$colon__f_head;
    $m_Lcats_data_NonEmptyList$();
    var value = new $c_Lcats_data_NonEmptyList(h, x47);
    return new $c_s_Some(value);
  }
  throw new $c_s_MatchError(l);
});
$c_Lcats_data_NonEmptyList$.prototype.fromListUnsafe__sci_List__Lcats_data_NonEmptyList = (function(l) {
  var x = $m_sci_Nil$();
  if (x.equals__O__Z(l)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Cannot create NonEmptyList from empty list");
  }
  if ((l instanceof $c_sci_$colon$colon)) {
    var x51 = l.sci_$colon$colon__f_next;
    var h = l.sci_$colon$colon__f_head;
    $m_Lcats_data_NonEmptyList$();
    return new $c_Lcats_data_NonEmptyList(h, x51);
  }
  throw new $c_s_MatchError(l);
});
$c_Lcats_data_NonEmptyList$.prototype.fromFoldable__O__Lcats_Foldable__s_Option = (function(fa, F) {
  return this.fromList__sci_List__s_Option(F.toList__O__sci_List(fa));
});
$c_Lcats_data_NonEmptyList$.prototype.fromProduct__s_Product__Lcats_data_NonEmptyList = (function(x$0) {
  return new $c_Lcats_data_NonEmptyList(x$0.productElement__I__O(0), x$0.productElement__I__O(1));
});
$c_Lcats_data_NonEmptyList$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lcats_data_NonEmptyList(p);
});
var $d_Lcats_data_NonEmptyList$ = new $TypeData().initClass($c_Lcats_data_NonEmptyList$, "cats.data.NonEmptyList$", ({
  Lcats_data_NonEmptyList$: 1,
  Lcats_data_NonEmptyListInstances: 1,
  Lcats_data_NonEmptyListInstances0: 1,
  Lcats_data_NonEmptyListInstances1: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lcats_data_NonEmptyList$ as $d_Lcats_data_NonEmptyList$ };
var $n_Lcats_data_NonEmptyList$;
function $m_Lcats_data_NonEmptyList$() {
  if ((!$n_Lcats_data_NonEmptyList$)) {
    $n_Lcats_data_NonEmptyList$ = new $c_Lcats_data_NonEmptyList$();
  }
  return $n_Lcats_data_NonEmptyList$;
}
export { $m_Lcats_data_NonEmptyList$ as $m_Lcats_data_NonEmptyList$ };
/** @constructor */
function $c_Lcats_data_NonEmptyVector$() {
  this.Lcats_data_NonEmptyVectorInstances__f_catsDataInstancesForNonEmptyVectorBinCompat1 = null;
  $ct_Lcats_data_NonEmptyVectorInstances__(this);
}
export { $c_Lcats_data_NonEmptyVector$ as $c_Lcats_data_NonEmptyVector$ };
$c_Lcats_data_NonEmptyVector$.prototype = new $h_Lcats_data_NonEmptyVectorInstances();
$c_Lcats_data_NonEmptyVector$.prototype.constructor = $c_Lcats_data_NonEmptyVector$;
/** @constructor */
function $h_Lcats_data_NonEmptyVector$() {
}
export { $h_Lcats_data_NonEmptyVector$ as $h_Lcats_data_NonEmptyVector$ };
$h_Lcats_data_NonEmptyVector$.prototype = $c_Lcats_data_NonEmptyVector$.prototype;
$c_Lcats_data_NonEmptyVector$.prototype.one__O__sci_Vector = (function(head) {
  $m_sci_Vector$();
  var tail = $m_sci_Vector0$();
  return tail.prepended__O__sci_Vector(head);
});
$c_Lcats_data_NonEmptyVector$.prototype.fromVector__sci_Vector__s_Option = (function(vector) {
  if ($f_sc_SeqOps__isEmpty__Z(vector)) {
    return $m_s_None$();
  } else {
    var value = new $c_Lcats_data_NonEmptyVector(vector);
    return new $c_s_Some(value);
  }
});
$c_Lcats_data_NonEmptyVector$.prototype.fromVectorUnsafe__sci_Vector__sci_Vector = (function(vector) {
  if ((!$f_sc_SeqOps__isEmpty__Z(vector))) {
    return vector;
  } else {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "Cannot create NonEmptyVector from empty vector");
  }
});
$c_Lcats_data_NonEmptyVector$.prototype.equals$extension__sci_Vector__O__Z = (function(this$, x$0) {
  if ((x$0 instanceof $c_Lcats_data_NonEmptyVector)) {
    var x$0$2 = ((x$0 === null) ? null : x$0.Lcats_data_NonEmptyVector__f_toVector);
    return ((this$ === null) ? (x$0$2 === null) : this$.equals__O__Z(x$0$2));
  } else {
    return false;
  }
});
$c_Lcats_data_NonEmptyVector$.prototype.foldRight$extension__sci_Vector__Lcats_Eval__F2__Lcats_Eval = (function(this$, lb, f) {
  $m_Lcats_UnorderedFoldable$();
  var instance = $m_Lcats_instances_package$vector$().Lcats_instances_package$vector$__f_catsStdInstancesForVector;
  return instance.foldRight__O__Lcats_Eval__F2__Lcats_Eval(this$, lb, f);
});
$c_Lcats_data_NonEmptyVector$.prototype.flatMap$extension__sci_Vector__F1__sci_Vector = (function(this$, f) {
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var x0 = it.next__O();
    var elems = f.apply__O__O(x0).Lcats_data_NonEmptyVector__f_toVector;
    b.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
  }
  return b.result__sci_Vector();
});
$c_Lcats_data_NonEmptyVector$.prototype.toString$extension__sci_Vector__T = (function(this$) {
  return ("NonEmpty" + $f_sc_Iterable__toString__T(this$));
});
var $d_Lcats_data_NonEmptyVector$ = new $TypeData().initClass($c_Lcats_data_NonEmptyVector$, "cats.data.NonEmptyVector$", ({
  Lcats_data_NonEmptyVector$: 1,
  Lcats_data_NonEmptyVectorInstances: 1,
  Lcats_data_NonEmptyVectorInstances0: 1,
  Lcats_data_NonEmptyVectorInstances1: 1,
  Lcats_data_NonEmptyVectorInstances2: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_NonEmptyVector$ as $d_Lcats_data_NonEmptyVector$ };
var $n_Lcats_data_NonEmptyVector$;
function $m_Lcats_data_NonEmptyVector$() {
  if ((!$n_Lcats_data_NonEmptyVector$)) {
    $n_Lcats_data_NonEmptyVector$ = new $c_Lcats_data_NonEmptyVector$();
  }
  return $n_Lcats_data_NonEmptyVector$;
}
export { $m_Lcats_data_NonEmptyVector$ as $m_Lcats_data_NonEmptyVector$ };
/** @constructor */
function $c_Lcats_instances_package$list$() {
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = null;
  $n_Lcats_instances_package$list$ = this;
  this.Lcats_instances_package$list$__f_catsStdInstancesForList = new $c_Lcats_instances_ListInstances$$anon$1();
  new $c_Lcats_instances_ListInstancesBinCompat0$$anon$6();
}
export { $c_Lcats_instances_package$list$ as $c_Lcats_instances_package$list$ };
$c_Lcats_instances_package$list$.prototype = new $h_O();
$c_Lcats_instances_package$list$.prototype.constructor = $c_Lcats_instances_package$list$;
/** @constructor */
function $h_Lcats_instances_package$list$() {
}
export { $h_Lcats_instances_package$list$ as $h_Lcats_instances_package$list$ };
$h_Lcats_instances_package$list$.prototype = $c_Lcats_instances_package$list$.prototype;
var $d_Lcats_instances_package$list$ = new $TypeData().initClass($c_Lcats_instances_package$list$, "cats.instances.package$list$", ({
  Lcats_instances_package$list$: 1,
  Lcats_kernel_instances_ListInstances2: 1,
  Lcats_kernel_instances_ListInstances1: 1,
  Lcats_kernel_instances_ListInstances: 1,
  Lcats_instances_ListInstances: 1,
  Lcats_instances_ListInstancesBinCompat0: 1
}));
export { $d_Lcats_instances_package$list$ as $d_Lcats_instances_package$list$ };
var $n_Lcats_instances_package$list$;
function $m_Lcats_instances_package$list$() {
  if ((!$n_Lcats_instances_package$list$)) {
    $n_Lcats_instances_package$list$ = new $c_Lcats_instances_package$list$();
  }
  return $n_Lcats_instances_package$list$;
}
export { $m_Lcats_instances_package$list$ as $m_Lcats_instances_package$list$ };
/** @constructor */
function $c_Lcats_instances_package$vector$() {
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = null;
  $n_Lcats_instances_package$vector$ = this;
  this.Lcats_instances_package$vector$__f_catsStdInstancesForVector = new $c_Lcats_instances_VectorInstances$$anon$1();
  new $c_Lcats_instances_VectorInstancesBinCompat0$$anon$6();
}
export { $c_Lcats_instances_package$vector$ as $c_Lcats_instances_package$vector$ };
$c_Lcats_instances_package$vector$.prototype = new $h_O();
$c_Lcats_instances_package$vector$.prototype.constructor = $c_Lcats_instances_package$vector$;
/** @constructor */
function $h_Lcats_instances_package$vector$() {
}
export { $h_Lcats_instances_package$vector$ as $h_Lcats_instances_package$vector$ };
$h_Lcats_instances_package$vector$.prototype = $c_Lcats_instances_package$vector$.prototype;
var $d_Lcats_instances_package$vector$ = new $TypeData().initClass($c_Lcats_instances_package$vector$, "cats.instances.package$vector$", ({
  Lcats_instances_package$vector$: 1,
  Lcats_kernel_instances_VectorInstances2: 1,
  Lcats_kernel_instances_VectorInstances1: 1,
  Lcats_kernel_instances_VectorInstances: 1,
  Lcats_instances_VectorInstances: 1,
  Lcats_instances_VectorInstancesBinCompat0: 1
}));
export { $d_Lcats_instances_package$vector$ as $d_Lcats_instances_package$vector$ };
var $n_Lcats_instances_package$vector$;
function $m_Lcats_instances_package$vector$() {
  if ((!$n_Lcats_instances_package$vector$)) {
    $n_Lcats_instances_package$vector$ = new $c_Lcats_instances_package$vector$();
  }
  return $n_Lcats_instances_package$vector$;
}
export { $m_Lcats_instances_package$vector$ as $m_Lcats_instances_package$vector$ };
/** @constructor */
function $c_Lcats_kernel_Order$$anon$1(outer) {
  this.Lcats_kernel_Order$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_kernel_Order$$anon$1__f_$outer = outer;
}
export { $c_Lcats_kernel_Order$$anon$1 as $c_Lcats_kernel_Order$$anon$1 };
$c_Lcats_kernel_Order$$anon$1.prototype = new $h_O();
$c_Lcats_kernel_Order$$anon$1.prototype.constructor = $c_Lcats_kernel_Order$$anon$1;
/** @constructor */
function $h_Lcats_kernel_Order$$anon$1() {
}
export { $h_Lcats_kernel_Order$$anon$1 as $h_Lcats_kernel_Order$$anon$1 };
$h_Lcats_kernel_Order$$anon$1.prototype = $c_Lcats_kernel_Order$$anon$1.prototype;
$c_Lcats_kernel_Order$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_Lcats_kernel_Order$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_Lcats_kernel_Order$$anon$1.prototype.compare__O__O__I = (function(_$1, _$2) {
  var this$1 = this.Lcats_kernel_Order$$anon$1__f_$outer;
  return this$1.compare__O__O__I(_$1, _$2);
});
var $d_Lcats_kernel_Order$$anon$1 = new $TypeData().initClass($c_Lcats_kernel_Order$$anon$1, "cats.kernel.Order$$anon$1", ({
  Lcats_kernel_Order$$anon$1: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1
}));
export { $d_Lcats_kernel_Order$$anon$1 as $d_Lcats_kernel_Order$$anon$1 };
class $c_Lcom_raquo_airstream_core_AirstreamError$CombinedError extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(causes) {
    super();
    this.Lcom_raquo_airstream_core_AirstreamError$CombinedError__f_causes = null;
    this.Lcom_raquo_airstream_core_AirstreamError$CombinedError__f_causes = causes;
    var message = $m_Lcom_raquo_airstream_core_AirstreamError$().com$raquo$airstream$core$AirstreamError$$$CombinedError$superArg$1__sci_Seq__T(causes);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
    var this$2 = $m_s_$less$colon$less$();
    var this$3 = causes.flatten__F1__O(this$2.s_$less$colon$less$__f_singleton).headOption__s_Option();
    if ((!this$3.isEmpty__Z())) {
      var x0 = this$3.get__O();
      this.initCause__jl_Throwable__jl_Throwable(x0);
    }
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1237825959, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$CombinedError)) {
      var x = this.Lcom_raquo_airstream_core_AirstreamError$CombinedError__f_causes;
      var x$2 = x$0.Lcom_raquo_airstream_core_AirstreamError$CombinedError__f_causes;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  }
  productArity__I() {
    return 1;
  }
  productPrefix__T() {
    return "CombinedError";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$CombinedError__f_causes;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "causes";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  toString__T() {
    var $x_1 = this.Lcom_raquo_airstream_core_AirstreamError$CombinedError__f_causes;
    var this$2 = $m_s_$less$colon$less$();
    var this$3 = $x_1.flatten__F1__O(this$2.s_$less$colon$less$__f_singleton).toList__sci_List();
    return ("CombinedError: " + $f_sc_IterableOnceOps__mkString__T__T__T__T(this$3, "", "; ", ""));
  }
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$CombinedError as $c_Lcom_raquo_airstream_core_AirstreamError$CombinedError };
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$CombinedError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_airstream_core_AirstreamError$CombinedError)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$CombinedError as $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$CombinedError };
var $d_Lcom_raquo_airstream_core_AirstreamError$CombinedError = new $TypeData().initClass($c_Lcom_raquo_airstream_core_AirstreamError$CombinedError, "com.raquo.airstream.core.AirstreamError$CombinedError", ({
  Lcom_raquo_airstream_core_AirstreamError$CombinedError: 1,
  Lcom_raquo_airstream_core_AirstreamError: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$CombinedError as $d_Lcom_raquo_airstream_core_AirstreamError$CombinedError };
class $c_Lcom_raquo_airstream_core_AirstreamError$DebugError extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(error, cause) {
    super();
    this.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_error = null;
    this.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_cause = null;
    this.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_error = error;
    this.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_cause = cause;
    var message = $m_Lcom_raquo_airstream_core_AirstreamError$().com$raquo$airstream$core$AirstreamError$$$DebugError$superArg$1__jl_Throwable__s_Option__T(error, cause);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-938358552), true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$DebugError)) {
      var x = this.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_error;
      var x$2 = x$0.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_error;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_cause;
        var x$4 = x$0.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_cause;
        return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "DebugError";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_error;
    }
    if ((n === 1)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_cause;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "error";
    }
    if ((n === 1)) {
      return "cause";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  toString__T() {
    return ((("DebugError: " + this.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_error) + "; cause: ") + this.Lcom_raquo_airstream_core_AirstreamError$DebugError__f_cause);
  }
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$DebugError as $c_Lcom_raquo_airstream_core_AirstreamError$DebugError };
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$DebugError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_airstream_core_AirstreamError$DebugError)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$DebugError as $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$DebugError };
var $d_Lcom_raquo_airstream_core_AirstreamError$DebugError = new $TypeData().initClass($c_Lcom_raquo_airstream_core_AirstreamError$DebugError, "com.raquo.airstream.core.AirstreamError$DebugError", ({
  Lcom_raquo_airstream_core_AirstreamError$DebugError: 1,
  Lcom_raquo_airstream_core_AirstreamError: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$DebugError as $d_Lcom_raquo_airstream_core_AirstreamError$DebugError };
class $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(error, cause) {
    super();
    this.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_error = null;
    this.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_cause = null;
    this.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_error = error;
    this.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_cause = cause;
    var message = ((("ErrorHandlingError: " + $m_Lcom_raquo_airstream_core_AirstreamError$().getFullMessage__jl_Throwable__T(error)) + "; cause: ") + $m_Lcom_raquo_airstream_core_AirstreamError$().getFullMessage__jl_Throwable__T(cause));
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
    this.initCause__jl_Throwable__jl_Throwable(cause);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1733418522, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError)) {
      var x = this.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_error;
      var x$2 = x$0.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_error;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_cause;
        var x$4 = x$0.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_cause;
        return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "ErrorHandlingError";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_error;
    }
    if ((n === 1)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_cause;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "error";
    }
    if ((n === 1)) {
      return "cause";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  toString__T() {
    return ((("ErrorHandlingError: " + this.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_error) + "; cause: ") + this.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError__f_cause);
  }
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError as $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError };
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError as $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError };
var $d_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError = new $TypeData().initClass($c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError, "com.raquo.airstream.core.AirstreamError$ErrorHandlingError", ({
  Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError: 1,
  Lcom_raquo_airstream_core_AirstreamError: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError as $d_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError };
class $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(error) {
    super();
    this.Lcom_raquo_airstream_core_AirstreamError$ObserverError__f_error = null;
    this.Lcom_raquo_airstream_core_AirstreamError$ObserverError__f_error = error;
    var message = ("ObserverError: " + $m_Lcom_raquo_airstream_core_AirstreamError$().getFullMessage__jl_Throwable__T(error));
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1450158632, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError)) {
      var x = this.Lcom_raquo_airstream_core_AirstreamError$ObserverError__f_error;
      var x$2 = x$0.Lcom_raquo_airstream_core_AirstreamError$ObserverError__f_error;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  }
  productArity__I() {
    return 1;
  }
  productPrefix__T() {
    return "ObserverError";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$ObserverError__f_error;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "error";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  toString__T() {
    return ("ObserverError: " + this.Lcom_raquo_airstream_core_AirstreamError$ObserverError__f_error);
  }
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError as $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError };
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_airstream_core_AirstreamError$ObserverError)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverError as $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverError };
var $d_Lcom_raquo_airstream_core_AirstreamError$ObserverError = new $TypeData().initClass($c_Lcom_raquo_airstream_core_AirstreamError$ObserverError, "com.raquo.airstream.core.AirstreamError$ObserverError", ({
  Lcom_raquo_airstream_core_AirstreamError$ObserverError: 1,
  Lcom_raquo_airstream_core_AirstreamError: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$ObserverError as $d_Lcom_raquo_airstream_core_AirstreamError$ObserverError };
class $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(error, cause) {
    super();
    this.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_error = null;
    this.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_cause = null;
    this.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_error = error;
    this.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_cause = cause;
    var message = ((("ObserverErrorHandlingError: " + $m_Lcom_raquo_airstream_core_AirstreamError$().getFullMessage__jl_Throwable__T(error)) + "; cause: ") + $m_Lcom_raquo_airstream_core_AirstreamError$().getFullMessage__jl_Throwable__T(cause));
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
    this.initCause__jl_Throwable__jl_Throwable(cause);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 617600855, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError)) {
      var x = this.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_error;
      var x$2 = x$0.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_error;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_cause;
        var x$4 = x$0.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_cause;
        return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "ObserverErrorHandlingError";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_error;
    }
    if ((n === 1)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_cause;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "error";
    }
    if ((n === 1)) {
      return "cause";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  toString__T() {
    return ((("ObserverErrorHandlingError: " + this.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_error) + "; cause: ") + this.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError__f_cause);
  }
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError as $c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError };
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError as $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError };
var $d_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError = new $TypeData().initClass($c_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError, "com.raquo.airstream.core.AirstreamError$ObserverErrorHandlingError", ({
  Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError: 1,
  Lcom_raquo_airstream_core_AirstreamError: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError as $d_Lcom_raquo_airstream_core_AirstreamError$ObserverErrorHandlingError };
class $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(trx, depth) {
    super();
    this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_trx = null;
    this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_depth = 0;
    this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_trx = trx;
    this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_depth = depth;
    var message = (((("Transaction depth exceeded maxDepth = " + depth) + ": Execution of ") + trx) + " aborted. See `Transaction.maxDepth`.");
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    var acc = (-889275714);
    var hash = acc;
    acc = $m_sr_Statics$().mix__I__I__I(hash, 557402392);
    var hash$1 = acc;
    var x = this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_trx;
    var data = $m_sr_Statics$().anyHash__O__I(x);
    acc = $m_sr_Statics$().mix__I__I__I(hash$1, data);
    var hash$2 = acc;
    var data$1 = this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_depth;
    acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$1);
    var hash$3 = acc;
    return $m_sr_Statics$().finalizeHash__I__I__I(hash$3, 2);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded)) {
      if ((this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_depth === x$0.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_depth)) {
        var x = this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_trx;
        var x$2 = x$0.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_trx;
        return (x === x$2);
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "TransactionDepthExceeded";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_trx;
    }
    if ((n === 1)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_depth;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "trx";
    }
    if ((n === 1)) {
      return "depth";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  toString__T() {
    return ((("TransactionDepthExceeded: " + this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_trx) + "; maxDepth: ") + this.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded__f_depth);
  }
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded as $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded };
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded as $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded };
var $d_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded = new $TypeData().initClass($c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded, "com.raquo.airstream.core.AirstreamError$TransactionDepthExceeded", ({
  Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded: 1,
  Lcom_raquo_airstream_core_AirstreamError: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded as $d_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded };
class $c_Lcom_raquo_airstream_core_AirstreamError$VarError extends $c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(message, cause) {
    super();
    this.Lcom_raquo_airstream_core_AirstreamError$VarError__f_message = null;
    this.Lcom_raquo_airstream_core_AirstreamError$VarError__f_cause = null;
    this.Lcom_raquo_airstream_core_AirstreamError$VarError__f_message = message;
    this.Lcom_raquo_airstream_core_AirstreamError$VarError__f_cause = cause;
    var message$1 = $m_Lcom_raquo_airstream_core_AirstreamError$().com$raquo$airstream$core$AirstreamError$$$VarError$superArg$1__T__s_Option__T(message, cause);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message$1, null, true, true);
    if ((!cause.isEmpty__Z())) {
      var x0 = cause.get__O();
      this.initCause__jl_Throwable__jl_Throwable(x0);
    }
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 367027540, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$VarError)) {
      if ((this.Lcom_raquo_airstream_core_AirstreamError$VarError__f_message === x$0.Lcom_raquo_airstream_core_AirstreamError$VarError__f_message)) {
        var x = this.Lcom_raquo_airstream_core_AirstreamError$VarError__f_cause;
        var x$2 = x$0.Lcom_raquo_airstream_core_AirstreamError$VarError__f_cause;
        return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  productArity__I() {
    return 2;
  }
  productPrefix__T() {
    return "VarError";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$VarError__f_message;
    }
    if ((n === 1)) {
      return this.Lcom_raquo_airstream_core_AirstreamError$VarError__f_cause;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "message";
    }
    if ((n === 1)) {
      return "cause";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  toString__T() {
    return ((("VarError: " + this.Lcom_raquo_airstream_core_AirstreamError$VarError__f_message) + "; cause: ") + this.Lcom_raquo_airstream_core_AirstreamError$VarError__f_cause);
  }
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$VarError as $c_Lcom_raquo_airstream_core_AirstreamError$VarError };
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$VarError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_airstream_core_AirstreamError$VarError)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$VarError as $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$VarError };
var $d_Lcom_raquo_airstream_core_AirstreamError$VarError = new $TypeData().initClass($c_Lcom_raquo_airstream_core_AirstreamError$VarError, "com.raquo.airstream.core.AirstreamError$VarError", ({
  Lcom_raquo_airstream_core_AirstreamError$VarError: 1,
  Lcom_raquo_airstream_core_AirstreamError: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$VarError as $d_Lcom_raquo_airstream_core_AirstreamError$VarError };
function $f_Lcom_raquo_airstream_custom_CustomSource__$init$__V($thiz) {
  $thiz.Lcom_raquo_airstream_custom_CustomStreamSource__f_topoRank = 1;
  $thiz.Lcom_raquo_airstream_custom_CustomStreamSource__f_startIndex = 0;
}
export { $f_Lcom_raquo_airstream_custom_CustomSource__$init$__V as $f_Lcom_raquo_airstream_custom_CustomSource__$init$__V };
function $f_Lcom_raquo_airstream_custom_CustomSource__onWillStart__V($thiz) {
  $thiz.Lcom_raquo_airstream_custom_CustomStreamSource__f_startIndex = ((1 + $thiz.Lcom_raquo_airstream_custom_CustomStreamSource__f_startIndex) | 0);
  $thiz.Lcom_raquo_airstream_custom_CustomStreamSource__f_config.Lcom_raquo_airstream_custom_CustomSource$Config__f_onWillStart.apply__O();
}
export { $f_Lcom_raquo_airstream_custom_CustomSource__onWillStart__V as $f_Lcom_raquo_airstream_custom_CustomSource__onWillStart__V };
function $f_Lcom_raquo_airstream_custom_CustomSource__onStart__V($thiz) {
  try {
    $thiz.Lcom_raquo_airstream_custom_CustomStreamSource__f_config.Lcom_raquo_airstream_custom_CustomSource$Config__f_onStart.apply__O();
    var r1 = (void 0);
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  $x_1.recover__s_PartialFunction__s_util_Try(new $c_Lcom_raquo_airstream_custom_CustomSource$$anon$1($thiz));
}
export { $f_Lcom_raquo_airstream_custom_CustomSource__onStart__V as $f_Lcom_raquo_airstream_custom_CustomSource__onStart__V };
function $f_Lcom_raquo_airstream_custom_CustomSource__onStop__V($thiz) {
  $thiz.Lcom_raquo_airstream_custom_CustomStreamSource__f_config.Lcom_raquo_airstream_custom_CustomSource$Config__f_onStop.apply__O();
}
export { $f_Lcom_raquo_airstream_custom_CustomSource__onStop__V as $f_Lcom_raquo_airstream_custom_CustomSource__onStop__V };
/** @constructor */
function $c_Lcom_raquo_airstream_state_LazyDerivedVar(parent, signal, zoomOut, displayNameSuffix) {
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_writer = null;
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_parent = null;
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_signal = null;
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_zoomOut = null;
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_displayNameSuffix = null;
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_parent = parent;
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_signal = signal;
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_zoomOut = zoomOut;
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_displayNameSuffix = displayNameSuffix;
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_state_Var__$init$__V(this);
}
export { $c_Lcom_raquo_airstream_state_LazyDerivedVar as $c_Lcom_raquo_airstream_state_LazyDerivedVar };
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype = new $h_O();
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.constructor = $c_Lcom_raquo_airstream_state_LazyDerivedVar;
/** @constructor */
function $h_Lcom_raquo_airstream_state_LazyDerivedVar() {
}
export { $h_Lcom_raquo_airstream_state_LazyDerivedVar as $h_Lcom_raquo_airstream_state_LazyDerivedVar };
$h_Lcom_raquo_airstream_state_LazyDerivedVar.prototype = $c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype;
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_state_LazyDerivedVar__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.writer__Lcom_raquo_airstream_core_Observer = (function() {
  return this.Lcom_raquo_airstream_state_LazyDerivedVar__f_writer;
});
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.com$raquo$airstream$state$Var$_setter_$writer_$eq__Lcom_raquo_airstream_core_Observer__V = (function(x$0) {
  this.Lcom_raquo_airstream_state_LazyDerivedVar__f_writer = x$0;
});
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this.Lcom_raquo_airstream_state_LazyDerivedVar__f_signal;
});
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.toObserver__Lcom_raquo_airstream_core_Observer = (function() {
  return this.Lcom_raquo_airstream_state_LazyDerivedVar__f_writer;
});
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.signal__Lcom_raquo_airstream_state_StrictSignal = (function() {
  return this.Lcom_raquo_airstream_state_LazyDerivedVar__f_signal;
});
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.setCurrentValue__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(value, transaction) {
  var x1 = this.Lcom_raquo_airstream_state_LazyDerivedVar__f_parent.signal__Lcom_raquo_airstream_state_StrictSignal().tryNow__s_util_Try();
  if ((x1 instanceof $c_s_util_Success)) {
    var parentValue = x1.s_util_Success__f_value;
    var nextValue = value.map__F1__s_util_Try(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => this.Lcom_raquo_airstream_state_LazyDerivedVar__f_zoomOut.apply__O__O__O(parentValue, _$1))));
    this.Lcom_raquo_airstream_state_LazyDerivedVar__f_parent.setCurrentValue__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(nextValue, transaction);
    return (void 0);
  }
  if ((x1 instanceof $c_s_util_Failure)) {
    var err = x1.s_util_Failure__f_exception;
    var $x_1 = $m_Lcom_raquo_airstream_core_AirstreamError$();
    var cause = new $c_s_Some(err);
    $x_1.sendUnhandledError__jl_Throwable__V(new $c_Lcom_raquo_airstream_core_AirstreamError$VarError("Unable to zoom out of lazy derived var when the parent var is failed.", cause));
    return (void 0);
  }
  throw new $c_s_MatchError(x1);
});
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.defaultDisplayName__T = (function() {
  return (("" + $f_Lcom_raquo_airstream_core_Named__displayName__T(this.Lcom_raquo_airstream_state_LazyDerivedVar__f_parent)) + this.Lcom_raquo_airstream_state_LazyDerivedVar__f_displayNameSuffix);
});
$c_Lcom_raquo_airstream_state_LazyDerivedVar.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_state_LazyDerivedVar__f_signal;
});
var $d_Lcom_raquo_airstream_state_LazyDerivedVar = new $TypeData().initClass($c_Lcom_raquo_airstream_state_LazyDerivedVar, "com.raquo.airstream.state.LazyDerivedVar", ({
  Lcom_raquo_airstream_state_LazyDerivedVar: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_core_Sink: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_state_Var: 1
}));
export { $d_Lcom_raquo_airstream_state_LazyDerivedVar as $d_Lcom_raquo_airstream_state_LazyDerivedVar };
/** @constructor */
function $c_Lcom_raquo_airstream_state_SourceVar(initial) {
  this.Lcom_raquo_airstream_state_SourceVar__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_state_SourceVar__f_writer = null;
  this.Lcom_raquo_airstream_state_SourceVar__f_currentValue = null;
  this.Lcom_raquo_airstream_state_SourceVar__f__varSignal = null;
  this.Lcom_raquo_airstream_state_SourceVar__f_signal = null;
  this.Lcom_raquo_airstream_state_SourceVar__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_state_Var__$init$__V(this);
  this.Lcom_raquo_airstream_state_SourceVar__f_currentValue = initial;
  this.Lcom_raquo_airstream_state_SourceVar__f__varSignal = new $c_Lcom_raquo_airstream_state_VarSignal(this.Lcom_raquo_airstream_state_SourceVar__f_currentValue, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $f_Lcom_raquo_airstream_core_Named__displayName__T(this))));
  this.Lcom_raquo_airstream_state_SourceVar__f_signal = this.Lcom_raquo_airstream_state_SourceVar__f__varSignal;
}
export { $c_Lcom_raquo_airstream_state_SourceVar as $c_Lcom_raquo_airstream_state_SourceVar };
$c_Lcom_raquo_airstream_state_SourceVar.prototype = new $h_O();
$c_Lcom_raquo_airstream_state_SourceVar.prototype.constructor = $c_Lcom_raquo_airstream_state_SourceVar;
/** @constructor */
function $h_Lcom_raquo_airstream_state_SourceVar() {
}
export { $h_Lcom_raquo_airstream_state_SourceVar as $h_Lcom_raquo_airstream_state_SourceVar };
$h_Lcom_raquo_airstream_state_SourceVar.prototype = $c_Lcom_raquo_airstream_state_SourceVar.prototype;
$c_Lcom_raquo_airstream_state_SourceVar.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_state_SourceVar__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_state_SourceVar.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_SourceVar__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_state_SourceVar.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_state_SourceVar.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_state_SourceVar.prototype.writer__Lcom_raquo_airstream_core_Observer = (function() {
  return this.Lcom_raquo_airstream_state_SourceVar__f_writer;
});
$c_Lcom_raquo_airstream_state_SourceVar.prototype.com$raquo$airstream$state$Var$_setter_$writer_$eq__Lcom_raquo_airstream_core_Observer__V = (function(x$0) {
  this.Lcom_raquo_airstream_state_SourceVar__f_writer = x$0;
});
$c_Lcom_raquo_airstream_state_SourceVar.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this.Lcom_raquo_airstream_state_SourceVar__f_signal;
});
$c_Lcom_raquo_airstream_state_SourceVar.prototype.toObserver__Lcom_raquo_airstream_core_Observer = (function() {
  return this.Lcom_raquo_airstream_state_SourceVar__f_writer;
});
$c_Lcom_raquo_airstream_state_SourceVar.prototype.setCurrentValue__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(value, transaction) {
  this.Lcom_raquo_airstream_state_SourceVar__f_currentValue = value;
  var this$1 = this.Lcom_raquo_airstream_state_SourceVar__f__varSignal;
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this$1, value, transaction);
});
$c_Lcom_raquo_airstream_state_SourceVar.prototype.signal__Lcom_raquo_airstream_state_StrictSignal = (function() {
  return this.Lcom_raquo_airstream_state_SourceVar__f_signal;
});
$c_Lcom_raquo_airstream_state_SourceVar.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_state_SourceVar__f_signal;
});
var $d_Lcom_raquo_airstream_state_SourceVar = new $TypeData().initClass($c_Lcom_raquo_airstream_state_SourceVar, "com.raquo.airstream.state.SourceVar", ({
  Lcom_raquo_airstream_state_SourceVar: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_core_Sink: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_state_Var: 1
}));
export { $d_Lcom_raquo_airstream_state_SourceVar as $d_Lcom_raquo_airstream_state_SourceVar };
function $ct_Lcom_raquo_laminar_keys_StyleProp__T__sci_Seq__($thiz, name, prefixes) {
  $thiz.Lcom_raquo_laminar_keys_StyleProp__f_name = name;
  $thiz.Lcom_raquo_laminar_keys_StyleProp__f_prefixes = prefixes;
  return $thiz;
}
export { $ct_Lcom_raquo_laminar_keys_StyleProp__T__sci_Seq__ as $ct_Lcom_raquo_laminar_keys_StyleProp__T__sci_Seq__ };
/** @constructor */
function $c_Lcom_raquo_laminar_keys_StyleProp() {
  this.Lcom_raquo_laminar_keys_StyleProp__f_name = null;
  this.Lcom_raquo_laminar_keys_StyleProp__f_prefixes = null;
}
export { $c_Lcom_raquo_laminar_keys_StyleProp as $c_Lcom_raquo_laminar_keys_StyleProp };
$c_Lcom_raquo_laminar_keys_StyleProp.prototype = new $h_O();
$c_Lcom_raquo_laminar_keys_StyleProp.prototype.constructor = $c_Lcom_raquo_laminar_keys_StyleProp;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_StyleProp() {
}
export { $h_Lcom_raquo_laminar_keys_StyleProp as $h_Lcom_raquo_laminar_keys_StyleProp };
$h_Lcom_raquo_laminar_keys_StyleProp.prototype = $c_Lcom_raquo_laminar_keys_StyleProp.prototype;
function $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendValueController__Lcom_raquo_laminar_inputs_InputController__V($thiz, controller) {
  var x = $thiz.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_controllers;
  if ((x === (void 0))) {
    $thiz.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_controllers = $m_sjs_js_defined$().apply__O__sjs_js_$bar($m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_laminar_inputs_InputController.getArrayOf().constr)([controller]))));
  } else {
    (x.push(controller) | 0);
  }
}
export { $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendValueController__Lcom_raquo_laminar_inputs_InputController__V as $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendValueController__Lcom_raquo_laminar_inputs_InputController__V };
function $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendControllablePropBinder__T__V($thiz, propDomName) {
  var x = $thiz.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_controllablePropBinders;
  if ((x === (void 0))) {
    $thiz.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_controllablePropBinders = $m_sjs_js_defined$().apply__O__sjs_js_$bar($m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_T.getArrayOf().constr)([propDomName]))));
  } else {
    (x.push(propDomName) | 0);
  }
}
export { $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendControllablePropBinder__T__V as $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendControllablePropBinder__T__V };
function $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__hasController__T__Z($thiz, propDomName) {
  var x = $thiz.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_controllers;
  if ((x !== (void 0))) {
    _return: {
      var len = (x.length | 0);
      var i = 0;
      while ((i < len)) {
        var x0 = x[i];
        if ((x0.propDomName__T() === propDomName)) {
          var $x_1 = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var $x_1 = (-1);
    }
    return ($x_1 >= 0);
  } else {
    return false;
  }
}
export { $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__hasController__T__Z as $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__hasController__T__Z };
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement(tag, ref) {
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = null;
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_dynamicOwner = null;
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription = null;
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners = null;
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ReactiveElement$$_compositeValues = null;
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_tag = null;
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref = null;
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_controllers = null;
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_controllablePropBinders = null;
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_tag = tag;
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref = ref;
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = $m_s_None$();
  $f_Lcom_raquo_laminar_nodes_ParentNode__$init$__V(this);
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__$init$__V(this);
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_controllers = (void 0);
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_controllablePropBinders = (void 0);
}
export { $c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement as $c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement };
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype = new $h_O();
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.constructor = $c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_ReactiveHtmlElement() {
}
export { $h_Lcom_raquo_laminar_nodes_ReactiveHtmlElement as $h_Lcom_raquo_laminar_nodes_ReactiveHtmlElement };
$h_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype = $c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype;
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.com$raquo$laminar$nodes$ChildNode$$_maybeParent__s_Option = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent;
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.com$raquo$laminar$nodes$ChildNode$$_maybeParent_$eq__s_Option__V = (function(x$1) {
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = x$1;
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(parentNode) {
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  $f_Lcom_raquo_laminar_domapi_DomTree__appendChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$1, parentNode, this, (void 0));
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_dynamicOwner;
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.com$raquo$laminar$nodes$ParentNode$_setter_$dynamicOwner_$eq__Lcom_raquo_airstream_ownership_DynamicOwner__V = (function(x$0) {
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_dynamicOwner = x$0;
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription__Lcom_raquo_airstream_ownership_TransferableSubscription = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription;
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners__O = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners;
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.com$raquo$laminar$nodes$ReactiveElement$$_compositeValues__sci_Map = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ReactiveElement$$_compositeValues;
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners = x$1;
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.com$raquo$laminar$nodes$ReactiveElement$$_compositeValues_$eq__sci_Map__V = (function(x$1) {
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ReactiveElement$$_compositeValues = x$1;
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.com$raquo$laminar$nodes$ReactiveElement$_setter_$com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription_$eq__Lcom_raquo_airstream_ownership_TransferableSubscription__V = (function(x$0) {
  this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription = x$0;
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.willSetParent__s_Option__V = (function(maybeNextParent) {
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__willSetParent__s_Option__V(this, maybeNextParent);
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.setParent__s_Option__V = (function(maybeNextParent) {
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__setParent__s_Option__V(this, maybeNextParent);
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.hasBinderForControllableProp__T__Z = (function(domPropName) {
  var x = this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_controllablePropBinders;
  return ((x !== (void 0)) && $m_Lcom_raquo_ew_JsArray$RichJsArray$().includes$extension__Lcom_raquo_ew_JsArray__O__I__Z(x, domPropName, 0));
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.hasOtherControllerForSameProp__Lcom_raquo_laminar_inputs_InputController__Z = (function(thisController) {
  var x = this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_controllers;
  if ((x !== (void 0))) {
    _return: {
      var len = (x.length | 0);
      var i = 0;
      while ((i < len)) {
        var x0 = x[i];
        if (((x0.propDomName__T() === thisController.propDomName__T()) && (!((x0 === null) ? (thisController === null) : (x0 === thisController))))) {
          var $x_1 = i;
          break _return;
        }
        i = ((1 + i) | 0);
      }
      var $x_1 = (-1);
    }
    return ($x_1 >= 0);
  } else {
    return false;
  }
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.bindController__Lcom_raquo_laminar_inputs_InputController__Lcom_raquo_airstream_ownership_DynamicSubscription = (function(controller) {
  var dynSub = controller.bind__Lcom_raquo_airstream_ownership_DynamicSubscription();
  $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendValueController__Lcom_raquo_laminar_inputs_InputController__V(this, controller);
  return dynSub;
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.controllableProps__O = (function() {
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  var element = this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
  if ($f_Lcom_raquo_laminar_domapi_DomTags__isCustomElement__Lorg_scalajs_dom_Element__Z(this$1, element)) {
    var x1 = this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_tag;
    if (false) {
      return x1.allowableControlProps__O();
    }
    return (void 0);
  } else {
    return $m_Lcom_raquo_laminar_inputs_InputController$().Lcom_raquo_laminar_inputs_InputController$__f_htmlControllableProps;
  }
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.isControllableProp__T__Z = (function(propDomName) {
  var x = this.controllableProps__O();
  return ((x !== (void 0)) && $m_Lcom_raquo_ew_JsArray$RichJsArray$().includes$extension__Lcom_raquo_ew_JsArray__O__I__Z(x, propDomName, 0));
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.onBoundKeyUpdater__Lcom_raquo_laminar_keys_SimpleKey__V = (function(key) {
  if ((key instanceof $c_Lcom_raquo_laminar_keys_HtmlProp)) {
    if (this.isControllableProp__T__Z(key.Lcom_raquo_laminar_keys_HtmlProp__f_name)) {
      if ($p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__hasController__T__Z(this, key.Lcom_raquo_laminar_keys_HtmlProp__f_name)) {
        var $x_1 = key.Lcom_raquo_laminar_keys_HtmlProp__f_name;
        var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
        var node = this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
        throw $ct_jl_Exception__T__(new $c_jl_Exception(), (((((("Can not add uncontrolled `" + $x_1) + " <-- ???` to element `") + $f_Lcom_raquo_laminar_domapi_DomDebug__debugNodeDescription__Lorg_scalajs_dom_Node__T(this$1, node)) + "` that already has an input controller for `") + key.Lcom_raquo_laminar_keys_HtmlProp__f_name) + "` property."));
      } else {
        $p_Lcom_raquo_laminar_nodes_ReactiveHtmlElement__appendControllablePropBinder__T__V(this, key.Lcom_raquo_laminar_keys_HtmlProp__f_name);
      }
    }
  }
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.toString__T = (function() {
  return (("ReactiveHtmlElement(" + ((this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref !== null) ? this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref.outerHTML : ("tag=" + this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_tag.Lcom_raquo_laminar_tags_HtmlTag__f_name))) + ")");
});
$c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement.prototype.ref__Lorg_scalajs_dom_Node = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveHtmlElement__f_ref;
});
var $d_Lcom_raquo_laminar_nodes_ReactiveHtmlElement = new $TypeData().initClass($c_Lcom_raquo_laminar_nodes_ReactiveHtmlElement, "com.raquo.laminar.nodes.ReactiveHtmlElement", ({
  Lcom_raquo_laminar_nodes_ReactiveHtmlElement: 1,
  Lcom_raquo_laminar_nodes_ReactiveNode: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_nodes_ChildNode: 1,
  Lcom_raquo_laminar_nodes_ParentNode: 1,
  Lcom_raquo_laminar_nodes_ReactiveElement: 1
}));
export { $d_Lcom_raquo_laminar_nodes_ReactiveHtmlElement as $d_Lcom_raquo_laminar_nodes_ReactiveHtmlElement };
/** @constructor */
function $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement(tag, ref) {
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = null;
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_dynamicOwner = null;
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription = null;
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners = null;
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ReactiveElement$$_compositeValues = null;
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_tag = null;
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_ref = null;
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_tag = tag;
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_ref = ref;
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = $m_s_None$();
  $f_Lcom_raquo_laminar_nodes_ParentNode__$init$__V(this);
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__$init$__V(this);
}
export { $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement as $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement };
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype = new $h_O();
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.constructor = $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement;
/** @constructor */
function $h_Lcom_raquo_laminar_nodes_ReactiveSvgElement() {
}
export { $h_Lcom_raquo_laminar_nodes_ReactiveSvgElement as $h_Lcom_raquo_laminar_nodes_ReactiveSvgElement };
$h_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype = $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype;
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.com$raquo$laminar$nodes$ChildNode$$_maybeParent__s_Option = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent;
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.com$raquo$laminar$nodes$ChildNode$$_maybeParent_$eq__s_Option__V = (function(x$1) {
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ChildNode$$_maybeParent = x$1;
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.apply__Lcom_raquo_laminar_nodes_ReactiveElement__V = (function(parentNode) {
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  $f_Lcom_raquo_laminar_domapi_DomTree__appendChild__Lcom_raquo_laminar_nodes_ParentNode__Lcom_raquo_laminar_nodes_ChildNode__O__Z(this$1, parentNode, this, (void 0));
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.dynamicOwner__Lcom_raquo_airstream_ownership_DynamicOwner = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_dynamicOwner;
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.com$raquo$laminar$nodes$ParentNode$_setter_$dynamicOwner_$eq__Lcom_raquo_airstream_ownership_DynamicOwner__V = (function(x$0) {
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_dynamicOwner = x$0;
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription__Lcom_raquo_airstream_ownership_TransferableSubscription = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription;
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners__O = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners;
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.com$raquo$laminar$nodes$ReactiveElement$$_compositeValues__sci_Map = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ReactiveElement$$_compositeValues;
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ReactiveElement$$maybeEventListeners = x$1;
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.com$raquo$laminar$nodes$ReactiveElement$$_compositeValues_$eq__sci_Map__V = (function(x$1) {
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ReactiveElement$$_compositeValues = x$1;
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.com$raquo$laminar$nodes$ReactiveElement$_setter_$com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription_$eq__Lcom_raquo_airstream_ownership_TransferableSubscription__V = (function(x$0) {
  this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_com$raquo$laminar$nodes$ReactiveElement$$pilotSubscription = x$0;
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.willSetParent__s_Option__V = (function(maybeNextParent) {
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__willSetParent__s_Option__V(this, maybeNextParent);
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.setParent__s_Option__V = (function(maybeNextParent) {
  $f_Lcom_raquo_laminar_nodes_ReactiveElement__setParent__s_Option__V(this, maybeNextParent);
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.onBoundKeyUpdater__Lcom_raquo_laminar_keys_SimpleKey__V = (function(key) {
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.toString__T = (function() {
  return (("ReactiveSvgElement(" + ((this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_ref !== null) ? this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_ref.outerHTML : ("tag=" + this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_tag.Lcom_raquo_laminar_tags_SvgTag__f_name))) + ")");
});
$c_Lcom_raquo_laminar_nodes_ReactiveSvgElement.prototype.ref__Lorg_scalajs_dom_Node = (function() {
  return this.Lcom_raquo_laminar_nodes_ReactiveSvgElement__f_ref;
});
var $d_Lcom_raquo_laminar_nodes_ReactiveSvgElement = new $TypeData().initClass($c_Lcom_raquo_laminar_nodes_ReactiveSvgElement, "com.raquo.laminar.nodes.ReactiveSvgElement", ({
  Lcom_raquo_laminar_nodes_ReactiveSvgElement: 1,
  Lcom_raquo_laminar_nodes_ReactiveNode: 1,
  Lcom_raquo_laminar_modifiers_Modifier: 1,
  Lcom_raquo_laminar_nodes_ChildNode: 1,
  Lcom_raquo_laminar_nodes_ParentNode: 1,
  Lcom_raquo_laminar_nodes_ReactiveElement: 1
}));
export { $d_Lcom_raquo_laminar_nodes_ReactiveSvgElement as $d_Lcom_raquo_laminar_nodes_ReactiveSvgElement };
/** @constructor */
function $c_Lframework_data_FrameworkDateTime(ldt) {
  this.Lframework_data_FrameworkDateTime__f_ldt = null;
  this.Lframework_data_FrameworkDateTime__f_ldt = ldt;
}
export { $c_Lframework_data_FrameworkDateTime as $c_Lframework_data_FrameworkDateTime };
$c_Lframework_data_FrameworkDateTime.prototype = new $h_O();
$c_Lframework_data_FrameworkDateTime.prototype.constructor = $c_Lframework_data_FrameworkDateTime;
/** @constructor */
function $h_Lframework_data_FrameworkDateTime() {
}
export { $h_Lframework_data_FrameworkDateTime as $h_Lframework_data_FrameworkDateTime };
$h_Lframework_data_FrameworkDateTime.prototype = $c_Lframework_data_FrameworkDateTime.prototype;
$c_Lframework_data_FrameworkDateTime.prototype.compareTo__O__I = (function(that) {
  return this.compare__O__I(that);
});
$c_Lframework_data_FrameworkDateTime.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lframework_data_FrameworkDateTime.prototype.hashCode__I = (function() {
  $m_Lframework_data_FrameworkDateTime$();
  var this$ = this.Lframework_data_FrameworkDateTime__f_ldt;
  return this$.hashCode__I();
});
$c_Lframework_data_FrameworkDateTime.prototype.equals__O__Z = (function(x$0) {
  return $m_Lframework_data_FrameworkDateTime$().equals$extension__Ljava_time_LocalDateTime__O__Z(this.Lframework_data_FrameworkDateTime__f_ldt, x$0);
});
$c_Lframework_data_FrameworkDateTime.prototype.toString__T = (function() {
  return $m_Lframework_data_FrameworkDateTime$().toString$extension__Ljava_time_LocalDateTime__T(this.Lframework_data_FrameworkDateTime__f_ldt);
});
$c_Lframework_data_FrameworkDateTime.prototype.productArity__I = (function() {
  $m_Lframework_data_FrameworkDateTime$();
  return 1;
});
$c_Lframework_data_FrameworkDateTime.prototype.productPrefix__T = (function() {
  $m_Lframework_data_FrameworkDateTime$();
  return "FrameworkDateTime";
});
$c_Lframework_data_FrameworkDateTime.prototype.productElement__I__O = (function(n) {
  return $m_Lframework_data_FrameworkDateTime$().productElement$extension__Ljava_time_LocalDateTime__I__O(this.Lframework_data_FrameworkDateTime__f_ldt, n);
});
$c_Lframework_data_FrameworkDateTime.prototype.productElementName__I__T = (function(n) {
  return $m_Lframework_data_FrameworkDateTime$().productElementName$extension__Ljava_time_LocalDateTime__I__T(this.Lframework_data_FrameworkDateTime__f_ldt, n);
});
$c_Lframework_data_FrameworkDateTime.prototype.compare__O__I = (function(that) {
  var that$1 = ((that === null) ? null : that.Lframework_data_FrameworkDateTime__f_ldt);
  $m_Lframework_data_FrameworkDateTime$();
  var this$ = this.Lframework_data_FrameworkDateTime__f_ldt;
  return this$.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(that$1);
});
function $isArrayOf_Lframework_data_FrameworkDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lframework_data_FrameworkDateTime)));
}
export { $isArrayOf_Lframework_data_FrameworkDateTime as $isArrayOf_Lframework_data_FrameworkDateTime };
var $d_Lframework_data_FrameworkDateTime = new $TypeData().initClass($c_Lframework_data_FrameworkDateTime, "framework.data.FrameworkDateTime", ({
  Lframework_data_FrameworkDateTime: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lframework_data_FrameworkDateTime as $d_Lframework_data_FrameworkDateTime };
function $f_Lframework_utils_NewtypeULID__fromBytes__AB__s_util_Either($thiz, bytes) {
  try {
    var binary = $m_s_IArray$package$IArray$().wrapByteIArray__AB__sci_ArraySeq$ofByte(bytes).sci_ArraySeq$ofByte__f_unsafeArray;
    var r1 = $f_Lyantl_Newtype$WithoutValidation__apply__O__O($thiz, $m_Ljkugiya_ulid_BinaryCodec$().decode__AB__Ljkugiya_ulid_ULID(binary));
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  var this$3 = $x_1.toEither__s_util_Either();
  var this$4 = new $c_s_util_Either$LeftProjection(this$3);
  var x1 = this$4.s_util_Either$LeftProjection__f_e;
  if ((x1 instanceof $c_s_util_Left)) {
    var a = x1.s_util_Left__f_value;
    var target = a.getMessage__T();
    var tc = $m_Lcats_instances_package$string$().Lcats_instances_package$string$__f_catsStdShowForString;
    var this$8 = new $c_Lcats_Show$ToShowOps$$anon$3(target, tc);
    return new $c_s_util_Left(("Failed to create ULID from bytes: " + this$8.Lcats_Show$ToShowOps$$anon$3__f_typeClassInstance.show__O__T(this$8.Lcats_Show$ToShowOps$$anon$3__f_self)));
  } else {
    return this$4.s_util_Either$LeftProjection__f_e;
  }
}
export { $f_Lframework_utils_NewtypeULID__fromBytes__AB__s_util_Either as $f_Lframework_utils_NewtypeULID__fromBytes__AB__s_util_Either };
function $f_Lframework_utils_NewtypeULID__toBinary__Ljkugiya_ulid_ULID__AB($thiz, value) {
  var s = $m_Ljkugiya_ulid_BinaryCodec$().encode__Ljkugiya_ulid_ULID__AB(value);
  return s;
}
export { $f_Lframework_utils_NewtypeULID__toBinary__Ljkugiya_ulid_ULID__AB as $f_Lframework_utils_NewtypeULID__toBinary__Ljkugiya_ulid_ULID__AB };
function $f_Lframework_utils_NewtypeULID__toBase64__Ljkugiya_ulid_ULID__Lframework_data_Base64Id($thiz, value) {
  var bytes = $f_Lframework_utils_NewtypeULID__toBinary__Ljkugiya_ulid_ULID__AB($thiz, value);
  return new $c_Lframework_data_Base64Id(bytes);
}
export { $f_Lframework_utils_NewtypeULID__toBase64__Ljkugiya_ulid_ULID__Lframework_data_Base64Id as $f_Lframework_utils_NewtypeULID__toBase64__Ljkugiya_ulid_ULID__Lframework_data_Base64Id };
function $f_Lframework_utils_NewtypeULID__given_Ordering_Type__s_math_Ordering($thiz) {
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => $m_Ljkugiya_ulid_UUIDCodec$().encode__Ljkugiya_ulid_ULID__ju_UUID(_$2)));
  var this$4 = $m_s_math_Ordering$();
  var this$3 = $m_s_$less$colon$less$();
  var asComparable = this$3.s_$less$colon$less$__f_singleton;
  var ord = new $c_s_math_LowPriorityOrderingImplicits$$anon$2(this$4, asComparable);
  return new $c_s_math_Ordering$$anon$5(ord, f);
}
export { $f_Lframework_utils_NewtypeULID__given_Ordering_Type__s_math_Ordering as $f_Lframework_utils_NewtypeULID__given_Ordering_Type__s_math_Ordering };
function $f_Lframework_utils_NewtypeULID__circeCodec__Lio_circe_Codec($thiz) {
  return $f_Lio_circe_Codec__iemap__F1__F1__Lio_circe_Codec($m_Lframework_data_Base64Id$().circeCodec__Lio_circe_Codec(), new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((base64) => $f_Lframework_utils_NewtypeULID__fromBytes__AB__s_util_Either($thiz, base64.Lframework_data_Base64Id__f_bytes))), new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => $f_Lframework_utils_NewtypeULID__toBase64__Ljkugiya_ulid_ULID__Lframework_data_Base64Id($thiz, _$3))));
}
export { $f_Lframework_utils_NewtypeULID__circeCodec__Lio_circe_Codec as $f_Lframework_utils_NewtypeULID__circeCodec__Lio_circe_Codec };
function $f_Lframework_utils_NewtypeULID__circeKeyCodec__Lframework_utils_CirceKeyCodec($thiz) {
  var this$3 = $m_Lframework_data_Base64Id$().circeKeyCodec__Lframework_utils_CirceKeyCodec();
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$4) => $f_Lframework_utils_NewtypeULID__fromBytes__AB__s_util_Either($thiz, _$4.Lframework_data_Base64Id__f_bytes).toOption__s_Option()));
  var g = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$5) => $f_Lframework_utils_NewtypeULID__toBase64__Ljkugiya_ulid_ULID__Lframework_data_Base64Id($thiz, _$5)));
  return new $c_Lframework_utils_CirceKeyCodec$$anon$1(f, g, this$3);
}
export { $f_Lframework_utils_NewtypeULID__circeKeyCodec__Lframework_utils_CirceKeyCodec as $f_Lframework_utils_NewtypeULID__circeKeyCodec__Lframework_utils_CirceKeyCodec };
function $f_Lframework_utils_NewtypeULID__tapirCodec__Lsttp_tapir_Codec($thiz) {
  return $f_Lsttp_tapir_Codec__mapEither__F1__F1__Lsttp_tapir_Codec($m_Lframework_data_Base64Id$().codec__Lsttp_tapir_Codec(), new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((base64) => $f_Lframework_utils_NewtypeULID__fromBytes__AB__s_util_Either($thiz, base64.Lframework_data_Base64Id__f_bytes))), new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$6) => $f_Lframework_utils_NewtypeULID__toBase64__Ljkugiya_ulid_ULID__Lframework_data_Base64Id($thiz, _$6))));
}
export { $f_Lframework_utils_NewtypeULID__tapirCodec__Lsttp_tapir_Codec as $f_Lframework_utils_NewtypeULID__tapirCodec__Lsttp_tapir_Codec };
function $f_Lframework_utils_NewtypeULID__schemaForMap__Lsttp_tapir_Schema__Lsttp_tapir_Schema($thiz, evidence$1) {
  var keyToString$proxy1 = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$7) => $f_Lframework_utils_NewtypeULID__toBase64__Ljkugiya_ulid_ULID__Lframework_data_Base64Id($thiz, _$7).asString__T()));
  $m_Lsttp_tapir_Schema$();
  var fields = $m_sci_Nil$();
  var mapFieldValues = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$3) => _$3.map__F1__sc_IterableOps(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1) => {
    if ((x$1 !== null)) {
      var k = x$1._1__O();
      var v = x$1._2__O();
      var _1 = keyToString$proxy1.apply__O__O(k);
      return $ct_T2__O__O__(new $c_T2(), _1, v);
    }
    throw new $c_s_MatchError(x$1);
  })))));
  var schemaType = new $c_Lsttp_tapir_SchemaType$SOpenProduct(fields, evidence$1, mapFieldValues);
  $m_Lsttp_tapir_Schema$SName$();
  var typeParameterShortNames = new $c_sci_$colon$colon("yantl.Newtype.Type", new $c_sci_$colon$colon("framework.utils.NewtypeULID.schemaForMap.V", $m_sci_Nil$()));
  var value = new $c_Lsttp_tapir_Schema$SName("Map", typeParameterShortNames);
  var name = new $c_s_Some(value);
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  return new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
}
export { $f_Lframework_utils_NewtypeULID__schemaForMap__Lsttp_tapir_Schema__Lsttp_tapir_Schema as $f_Lframework_utils_NewtypeULID__schemaForMap__Lsttp_tapir_Schema__Lsttp_tapir_Schema };
/** @constructor */
function $c_Lio_circe_CursorOp$DownField(k) {
  this.Lio_circe_CursorOp$DownField__f_k = null;
  this.Lio_circe_CursorOp$DownField__f_k = k;
}
export { $c_Lio_circe_CursorOp$DownField as $c_Lio_circe_CursorOp$DownField };
$c_Lio_circe_CursorOp$DownField.prototype = new $h_Lio_circe_CursorOp$ObjectOp();
$c_Lio_circe_CursorOp$DownField.prototype.constructor = $c_Lio_circe_CursorOp$DownField;
/** @constructor */
function $h_Lio_circe_CursorOp$DownField() {
}
export { $h_Lio_circe_CursorOp$DownField as $h_Lio_circe_CursorOp$DownField };
$h_Lio_circe_CursorOp$DownField.prototype = $c_Lio_circe_CursorOp$DownField.prototype;
$c_Lio_circe_CursorOp$DownField.prototype.hashCode__I = (function() {
  var this$2 = $m_s_util_hashing_MurmurHash3$();
  return this$2.caseClassHash__s_Product__I__T__I(this, (-889275714), null);
});
$c_Lio_circe_CursorOp$DownField.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_circe_CursorOp$DownField) && (this.Lio_circe_CursorOp$DownField__f_k === x$0.Lio_circe_CursorOp$DownField__f_k)));
});
$c_Lio_circe_CursorOp$DownField.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_CursorOp$DownField.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_CursorOp$DownField.prototype.productPrefix__T = (function() {
  return "DownField";
});
$c_Lio_circe_CursorOp$DownField.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_CursorOp$DownField__f_k;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$DownField.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "k";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_circe_CursorOp$DownField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$DownField)));
}
export { $isArrayOf_Lio_circe_CursorOp$DownField as $isArrayOf_Lio_circe_CursorOp$DownField };
var $d_Lio_circe_CursorOp$DownField = new $TypeData().initClass($c_Lio_circe_CursorOp$DownField, "io.circe.CursorOp$DownField", ({
  Lio_circe_CursorOp$DownField: 1,
  Lio_circe_CursorOp$ObjectOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_CursorOp$DownField as $d_Lio_circe_CursorOp$DownField };
/** @constructor */
function $c_Lio_circe_CursorOp$DownN(n) {
  this.Lio_circe_CursorOp$DownN__f_n = 0;
  this.Lio_circe_CursorOp$DownN__f_n = n;
}
export { $c_Lio_circe_CursorOp$DownN as $c_Lio_circe_CursorOp$DownN };
$c_Lio_circe_CursorOp$DownN.prototype = new $h_Lio_circe_CursorOp$ArrayOp();
$c_Lio_circe_CursorOp$DownN.prototype.constructor = $c_Lio_circe_CursorOp$DownN;
/** @constructor */
function $h_Lio_circe_CursorOp$DownN() {
}
export { $h_Lio_circe_CursorOp$DownN as $h_Lio_circe_CursorOp$DownN };
$h_Lio_circe_CursorOp$DownN.prototype = $c_Lio_circe_CursorOp$DownN.prototype;
$c_Lio_circe_CursorOp$DownN.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("DownN");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var data$1 = this.Lio_circe_CursorOp$DownN__f_n;
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lio_circe_CursorOp$DownN.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_circe_CursorOp$DownN) && (this.Lio_circe_CursorOp$DownN__f_n === x$0.Lio_circe_CursorOp$DownN__f_n)));
});
$c_Lio_circe_CursorOp$DownN.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lio_circe_CursorOp$DownN.prototype.productArity__I = (function() {
  return 1;
});
$c_Lio_circe_CursorOp$DownN.prototype.productPrefix__T = (function() {
  return "DownN";
});
$c_Lio_circe_CursorOp$DownN.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lio_circe_CursorOp$DownN__f_n;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$DownN.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "n";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_circe_CursorOp$DownN(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$DownN)));
}
export { $isArrayOf_Lio_circe_CursorOp$DownN as $isArrayOf_Lio_circe_CursorOp$DownN };
var $d_Lio_circe_CursorOp$DownN = new $TypeData().initClass($c_Lio_circe_CursorOp$DownN, "io.circe.CursorOp$DownN", ({
  Lio_circe_CursorOp$DownN: 1,
  Lio_circe_CursorOp$ArrayOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_CursorOp$DownN as $d_Lio_circe_CursorOp$DownN };
function $isArrayOf_Lio_circe_CursorOp$Field(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lio_circe_CursorOp$Field)));
}
export { $isArrayOf_Lio_circe_CursorOp$Field as $isArrayOf_Lio_circe_CursorOp$Field };
class $c_Lio_circe_DecodingFailure$DecodingFailureImpl extends $c_Lio_circe_DecodingFailure {
  constructor(lazyReason, pathToRoot, ops) {
    super();
    this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_pathToRoot = null;
    this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_ops = null;
    this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_pathToRoot = pathToRoot;
    this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_ops = ops;
    $ct_Lio_circe_DecodingFailure__Lcats_Eval__(this, lazyReason);
  }
  pathToRootString__s_Option() {
    var x = this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_pathToRoot;
    var value = new $c_Lio_circe_PathToRoot($m_Lio_circe_PathToRoot$().Lio_circe_PathToRoot$__f_empty);
    var x$2 = new $c_s_Some(value);
    if (((x !== null) && x.equals__O__Z(x$2))) {
      return new $c_s_Some("");
    } else {
      var this$3 = this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_pathToRoot;
      var this$4 = (this$3.isEmpty__Z() ? $m_Lio_circe_PathToRoot$().fromHistory__sci_List__s_util_Either(this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_ops.value__O()).toOption__s_Option() : this$3);
      if (this$4.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var x0 = this$4.get__O();
        var _$1 = ((x0 === null) ? null : x0.Lio_circe_PathToRoot__f_value);
        $m_Lio_circe_PathToRoot$();
        return new $c_s_Some($m_Lio_circe_PathToRoot$().toPathString__sci_Vector__T(_$1));
      }
    }
  }
  history__sci_List() {
    return this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_ops.value__O();
  }
  withReason__Lio_circe_DecodingFailure$Reason__Lio_circe_DecodingFailure(reason) {
    $m_Lcats_Eval$();
    var reason$1 = new $c_Lcats_Now(reason);
    var pathToRoot = this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_pathToRoot;
    var ops = this.Lio_circe_DecodingFailure$DecodingFailureImpl__f_ops;
    return new $c_Lio_circe_DecodingFailure$DecodingFailureImpl(reason$1, pathToRoot, ops);
  }
}
export { $c_Lio_circe_DecodingFailure$DecodingFailureImpl as $c_Lio_circe_DecodingFailure$DecodingFailureImpl };
var $d_Lio_circe_DecodingFailure$DecodingFailureImpl = new $TypeData().initClass($c_Lio_circe_DecodingFailure$DecodingFailureImpl, "io.circe.DecodingFailure$DecodingFailureImpl", ({
  Lio_circe_DecodingFailure$DecodingFailureImpl: 1,
  Lio_circe_DecodingFailure: 1,
  Lio_circe_Error: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lio_circe_DecodingFailure$DecodingFailureImpl as $d_Lio_circe_DecodingFailure$DecodingFailureImpl };
/** @constructor */
function $c_Lio_circe_Encoder$$anon$38(encodeK$2, encodeV$2, ev$4) {
  this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeK = null;
  this.Lio_circe_Encoder$IterableAsObjectEncoder__f_encodeV = null;
  this.Lio_circe_Encoder$$anon$38__f_ev$5 = null;
  this.Lio_circe_Encoder$$anon$38__f_ev$5 = ev$4;
  $ct_Lio_circe_Encoder$IterableAsObjectEncoder__Lio_circe_KeyEncoder__Lio_circe_Encoder__(this, encodeK$2, encodeV$2);
}
export { $c_Lio_circe_Encoder$$anon$38 as $c_Lio_circe_Encoder$$anon$38 };
$c_Lio_circe_Encoder$$anon$38.prototype = new $h_Lio_circe_Encoder$IterableAsObjectEncoder();
$c_Lio_circe_Encoder$$anon$38.prototype.constructor = $c_Lio_circe_Encoder$$anon$38;
/** @constructor */
function $h_Lio_circe_Encoder$$anon$38() {
}
export { $h_Lio_circe_Encoder$$anon$38 as $h_Lio_circe_Encoder$$anon$38 };
$h_Lio_circe_Encoder$$anon$38.prototype = $c_Lio_circe_Encoder$$anon$38.prototype;
$c_Lio_circe_Encoder$$anon$38.prototype.toIterator__sc_Map__sc_Iterator = (function(a) {
  return this.Lio_circe_Encoder$$anon$38__f_ev$5.apply__O__O(a).iterator__sc_Iterator();
});
var $d_Lio_circe_Encoder$$anon$38 = new $TypeData().initClass($c_Lio_circe_Encoder$$anon$38, "io.circe.Encoder$$anon$38", ({
  Lio_circe_Encoder$$anon$38: 1,
  Lio_circe_Encoder$IterableAsObjectEncoder: 1,
  Ljava_io_Serializable: 1,
  Lio_circe_Encoder: 1,
  Lio_circe_Encoder$AsRoot: 1,
  Lio_circe_Encoder$AsObject: 1
}));
export { $d_Lio_circe_Encoder$$anon$38 as $d_Lio_circe_Encoder$$anon$38 };
/** @constructor */
function $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1(outer) {
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1__f_$outer = outer;
}
export { $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1 as $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1 };
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype = new $h_O();
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.constructor = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1;
/** @constructor */
function $h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1() {
}
export { $h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1 as $h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1 };
$h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype;
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.head__O = (function() {
  var this$1 = new $c_Lio_circe_JsonObject$$anon$2(this);
  return this$1.next__T();
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$();
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.className__T = (function() {
  return "Iterable";
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lio_circe_JsonObject$$anon$2(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sc_Iterable$().from__sc_IterableOnce__O(coll);
});
var $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1 = new $TypeData().initClass($c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1, "io.circe.JsonObject$LinkedHashMapJsonObject$$anon$1", ({
  Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1
}));
export { $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1 as $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$1 };
/** @constructor */
function $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5(outer) {
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5__f_$outer = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5__f_$outer = outer;
}
export { $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5 as $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5 };
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype = new $h_O();
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.constructor = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5;
/** @constructor */
function $h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5() {
}
export { $h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5 as $h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5 };
$h_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype = $c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype;
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.knownSize__I = (function() {
  return (-1);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.head__O = (function() {
  var this$1 = new $c_Lio_circe_JsonObject$$anon$6(this);
  return this$1.next__T2();
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$();
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.className__T = (function() {
  return "Iterable";
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.iterator__sc_Iterator = (function() {
  return new $c_Lio_circe_JsonObject$$anon$6(this);
});
$c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sc_Iterable$().from__sc_IterableOnce__O(coll);
});
var $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5 = new $TypeData().initClass($c_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5, "io.circe.JsonObject$LinkedHashMapJsonObject$$anon$5", ({
  Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1
}));
export { $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5 as $d_Lio_circe_JsonObject$LinkedHashMapJsonObject$$anon$5 };
function $ct_jl_ArrayIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_jl_ArrayIndexOutOfBoundsException__T__ as $ct_jl_ArrayIndexOutOfBoundsException__T__ };
function $ct_jl_ArrayIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
export { $ct_jl_ArrayIndexOutOfBoundsException__ as $ct_jl_ArrayIndexOutOfBoundsException__ };
class $c_jl_ArrayIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
export { $c_jl_ArrayIndexOutOfBoundsException as $c_jl_ArrayIndexOutOfBoundsException };
var $d_jl_ArrayIndexOutOfBoundsException = new $TypeData().initClass($c_jl_ArrayIndexOutOfBoundsException, "java.lang.ArrayIndexOutOfBoundsException", ({
  jl_ArrayIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_ArrayIndexOutOfBoundsException as $d_jl_ArrayIndexOutOfBoundsException };
function $f_jl_Double__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
export { $f_jl_Double__equals__O__Z as $f_jl_Double__equals__O__Z };
function $f_jl_Double__hashCode__I($thiz) {
  var valueInt = ($thiz | 0);
  if (((valueInt === $thiz) && ((1.0 / $thiz) !== (-Infinity)))) {
    return valueInt;
  } else if (($thiz !== $thiz)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, $thiz, true);
    var lo = (fpBitsDataView.getInt32(0, true) | 0);
    var hi = (fpBitsDataView.getInt32(4, true) | 0);
    return (lo ^ hi);
  }
}
export { $f_jl_Double__hashCode__I as $f_jl_Double__hashCode__I };
function $f_jl_Double__toString__T($thiz) {
  return ("" + $thiz);
}
export { $f_jl_Double__toString__T as $f_jl_Double__toString__T };
function $f_jl_Double__compareTo__O__I($thiz, o) {
  return $m_jl_Double$().compare__D__D__I($thiz, o);
}
export { $f_jl_Double__compareTo__O__I as $f_jl_Double__compareTo__O__I };
function $isArrayOf_jl_Double(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Double)));
}
export { $isArrayOf_jl_Double as $isArrayOf_jl_Double };
var $d_jl_Double = new $TypeData().initClass(0, "java.lang.Double", ({
  jl_Double: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => ((typeof x) === "number")));
export { $d_jl_Double as $d_jl_Double };
function $f_jl_Float__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
export { $f_jl_Float__equals__O__Z as $f_jl_Float__equals__O__Z };
function $f_jl_Float__hashCode__I($thiz) {
  var value = $thiz;
  var valueInt = (value | 0);
  if (((valueInt === value) && ((1.0 / value) !== (-Infinity)))) {
    return valueInt;
  } else if ((value !== value)) {
    return 2146959360;
  } else {
    var fpBitsDataView = $fpBitsDataView;
    fpBitsDataView.setFloat64(0, value, true);
    var lo = (fpBitsDataView.getInt32(0, true) | 0);
    var hi = (fpBitsDataView.getInt32(4, true) | 0);
    return (lo ^ hi);
  }
}
export { $f_jl_Float__hashCode__I as $f_jl_Float__hashCode__I };
function $f_jl_Float__toString__T($thiz) {
  return ("" + $thiz);
}
export { $f_jl_Float__toString__T as $f_jl_Float__toString__T };
function $f_jl_Float__compareTo__O__I($thiz, o) {
  return $m_jl_Double$().compare__D__D__I($thiz, o);
}
export { $f_jl_Float__compareTo__O__I as $f_jl_Float__compareTo__O__I };
function $isArrayOf_jl_Float(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Float)));
}
export { $isArrayOf_jl_Float as $isArrayOf_jl_Float };
var $d_jl_Float = new $TypeData().initClass(0, "java.lang.Float", ({
  jl_Float: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => $isFloat(x)));
export { $d_jl_Float as $d_jl_Float };
function $f_jl_Integer__equals__O__Z($thiz, that) {
  return Object.is($thiz, that);
}
export { $f_jl_Integer__equals__O__Z as $f_jl_Integer__equals__O__Z };
function $f_jl_Integer__hashCode__I($thiz) {
  return $thiz;
}
export { $f_jl_Integer__hashCode__I as $f_jl_Integer__hashCode__I };
function $f_jl_Integer__toString__T($thiz) {
  return ("" + $thiz);
}
export { $f_jl_Integer__toString__T as $f_jl_Integer__toString__T };
function $f_jl_Integer__compareTo__O__I($thiz, o) {
  return (($thiz === o) ? 0 : (($thiz < o) ? (-1) : 1));
}
export { $f_jl_Integer__compareTo__O__I as $f_jl_Integer__compareTo__O__I };
function $isArrayOf_jl_Integer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Integer)));
}
export { $isArrayOf_jl_Integer as $isArrayOf_jl_Integer };
var $d_jl_Integer = new $TypeData().initClass(0, "java.lang.Integer", ({
  jl_Integer: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => $isInt(x)));
export { $d_jl_Integer as $d_jl_Integer };
function $f_jl_Long__equals__O__Z($thiz, that) {
  return ((that instanceof $c_RTLong) && (($thiz.RTLong__f_lo === that.RTLong__f_lo) && ($thiz.RTLong__f_hi === that.RTLong__f_hi)));
}
export { $f_jl_Long__equals__O__Z as $f_jl_Long__equals__O__Z };
function $f_jl_Long__hashCode__I($thiz) {
  var $x_1 = $thiz.RTLong__f_lo;
  var hi = $thiz.RTLong__f_hi;
  return ($x_1 ^ hi);
}
export { $f_jl_Long__hashCode__I as $f_jl_Long__hashCode__I };
function $f_jl_Long__toString__T($thiz) {
  var this$1 = $m_RTLong$();
  return this$1.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T($thiz.RTLong__f_lo, $thiz.RTLong__f_hi);
}
export { $f_jl_Long__toString__T as $f_jl_Long__toString__T };
function $f_jl_Long__compareTo__O__I($thiz, o) {
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I($thiz.RTLong__f_lo, $thiz.RTLong__f_hi, o.RTLong__f_lo, o.RTLong__f_hi);
}
export { $f_jl_Long__compareTo__O__I as $f_jl_Long__compareTo__O__I };
function $isArrayOf_jl_Long(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_Long)));
}
export { $isArrayOf_jl_Long as $isArrayOf_jl_Long };
var $d_jl_Long = new $TypeData().initClass(0, "java.lang.Long", ({
  jl_Long: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => (x instanceof $c_RTLong)));
export { $d_jl_Long as $d_jl_Long };
class $c_jl_NumberFormatException extends $c_jl_IllegalArgumentException {
  constructor(s) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
export { $c_jl_NumberFormatException as $c_jl_NumberFormatException };
function $isArrayOf_jl_NumberFormatException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.jl_NumberFormatException)));
}
export { $isArrayOf_jl_NumberFormatException as $isArrayOf_jl_NumberFormatException };
var $d_jl_NumberFormatException = new $TypeData().initClass($c_jl_NumberFormatException, "java.lang.NumberFormatException", ({
  jl_NumberFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_NumberFormatException as $d_jl_NumberFormatException };
function $f_T__length__I($thiz) {
  return $thiz.length;
}
export { $f_T__length__I as $f_T__length__I };
function $f_T__charAt__I__C($thiz, index) {
  return $thiz.charCodeAt(index);
}
export { $f_T__charAt__I__C as $f_T__charAt__I__C };
function $f_T__codePointAt__I__I($thiz, index) {
  return ($thiz.codePointAt(index) | 0);
}
export { $f_T__codePointAt__I__I as $f_T__codePointAt__I__I };
function $f_T__codePointBefore__I__I($thiz, index) {
  var index$1 = (((-1) + index) | 0);
  var low = $thiz.charCodeAt(index$1);
  if ((((64512 & low) === 56320) && (index > 1))) {
    var index$2 = (((-2) + index) | 0);
    var high = $thiz.charCodeAt(index$2);
    return (((64512 & high) === 55296) ? ((((64 + (1023 & high)) | 0) << 10) | (1023 & low)) : low);
  } else {
    return low;
  }
}
export { $f_T__codePointBefore__I__I as $f_T__codePointBefore__I__I };
function $f_T__hashCode__I($thiz) {
  var n = $thiz.length;
  var h = 0;
  var i = 0;
  while ((i !== n)) {
    var $x_2 = h;
    var $x_1 = h;
    var index = i;
    h = ((((($x_2 << 5) - $x_1) | 0) + $thiz.charCodeAt(index)) | 0);
    i = ((1 + i) | 0);
  }
  return h;
}
export { $f_T__hashCode__I as $f_T__hashCode__I };
function $f_T__equals__O__Z($thiz, that) {
  return ($thiz === that);
}
export { $f_T__equals__O__Z as $f_T__equals__O__Z };
function $f_T__compareTo__T__I($thiz, anotherString) {
  var thisLength = $thiz.length;
  var strLength = anotherString.length;
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var index = i;
    var index$1 = i;
    var cmp = (($thiz.charCodeAt(index) - anotherString.charCodeAt(index$1)) | 0);
    if ((cmp !== 0)) {
      return cmp;
    }
    i = ((1 + i) | 0);
  }
  return ((thisLength - strLength) | 0);
}
export { $f_T__compareTo__T__I as $f_T__compareTo__T__I };
function $f_T__compareToIgnoreCase__T__I($thiz, str) {
  var thisLength = $thiz.length;
  var strLength = str.length;
  var minLength = ((thisLength < strLength) ? thisLength : strLength);
  var i = 0;
  while ((i !== minLength)) {
    var index = i;
    var c = $thiz.charCodeAt(index);
    var $x_1 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
    var index$1 = i;
    var c$1 = str.charCodeAt(index$1);
    var cmp = (($x_1 - $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1))) | 0);
    if ((cmp !== 0)) {
      return cmp;
    }
    i = ((1 + i) | 0);
  }
  return ((thisLength - strLength) | 0);
}
export { $f_T__compareToIgnoreCase__T__I as $f_T__compareToIgnoreCase__T__I };
function $f_T__getBytes__T__AB($thiz, charsetName) {
  return $f_T__getBytes__Ljava_nio_charset_Charset__AB($thiz, $m_Ljava_nio_charset_Charset$().forName__T__Ljava_nio_charset_Charset(charsetName));
}
export { $f_T__getBytes__T__AB as $f_T__getBytes__T__AB };
function $f_T__getBytes__Ljava_nio_charset_Charset__AB($thiz, charset) {
  var buf = charset.encode__T__Ljava_nio_ByteBuffer($thiz);
  var res = new $ac_B(((buf.Ljava_nio_Buffer__f__limit - buf.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0));
  buf.get__AB__I__I__Ljava_nio_ByteBuffer(res, 0, res.u.length);
  return res;
}
export { $f_T__getBytes__Ljava_nio_charset_Charset__AB as $f_T__getBytes__Ljava_nio_charset_Charset__AB };
function $f_T__getChars__I__I__AC__I__V($thiz, srcBegin, srcEnd, dst, dstBegin) {
  if (((((srcEnd > $thiz.length) || (srcBegin < 0)) || (srcEnd < 0)) || (srcBegin > srcEnd))) {
    throw $ct_jl_StringIndexOutOfBoundsException__T__(new $c_jl_StringIndexOutOfBoundsException(), "Index out of Bound");
  }
  var offset = ((dstBegin - srcBegin) | 0);
  var i = srcBegin;
  while ((i < srcEnd)) {
    var $x_1 = i;
    var index = i;
    dst.u[(($x_1 + offset) | 0)] = $thiz.charCodeAt(index);
    i = ((1 + i) | 0);
  }
}
export { $f_T__getChars__I__I__AC__I__V as $f_T__getChars__I__I__AC__I__V };
function $f_T__indexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return ($thiz.indexOf(str) | 0);
}
export { $f_T__indexOf__I__I as $f_T__indexOf__I__I };
function $f_T__indexOf__I__I__I($thiz, ch, fromIndex) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return ($thiz.indexOf(str, fromIndex) | 0);
}
export { $f_T__indexOf__I__I__I as $f_T__indexOf__I__I__I };
function $f_T__lastIndexOf__I__I($thiz, ch) {
  var str = $m_jl_Character$().toString__I__T(ch);
  return ($thiz.lastIndexOf(str) | 0);
}
export { $f_T__lastIndexOf__I__I as $f_T__lastIndexOf__I__I };
function $f_T__repeat__I__T($thiz, count) {
  if ((count < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  } else {
    return $thiz.repeat(count);
  }
}
export { $f_T__repeat__I__T as $f_T__repeat__I__T };
function $f_T__replaceAll__T__T__T($thiz, regex, replacement) {
  var this$2 = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0);
  return new $c_ju_regex_Matcher(this$2, $thiz).replaceAll__T__T(replacement);
}
export { $f_T__replaceAll__T__T__T as $f_T__replaceAll__T__T__T };
function $f_T__replaceFirst__T__T__T($thiz, regex, replacement) {
  var this$2 = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0);
  return new $c_ju_regex_Matcher(this$2, $thiz).replaceFirst__T__T(replacement);
}
export { $f_T__replaceFirst__T__T__T as $f_T__replaceFirst__T__T__T };
function $f_T__split__T__I__AT($thiz, regex, limit) {
  var this$2 = $m_ju_regex_PatternCompiler$().compile__T__I__ju_regex_Pattern(regex, 0);
  return this$2.java$util$regex$Pattern$$split__T__I__AT($thiz, limit);
}
export { $f_T__split__T__I__AT as $f_T__split__T__I__AT };
function $f_T__subSequence__I__I__jl_CharSequence($thiz, beginIndex, endIndex) {
  return $thiz.substring(beginIndex, endIndex);
}
export { $f_T__subSequence__I__I__jl_CharSequence as $f_T__subSequence__I__I__jl_CharSequence };
function $f_T__toCharArray__AC($thiz) {
  var len = $thiz.length;
  var result = new $ac_C(len);
  var i = 0;
  while ((i < len)) {
    var $x_1 = i;
    var index = i;
    result.u[$x_1] = $thiz.charCodeAt(index);
    i = ((1 + i) | 0);
  }
  return result;
}
export { $f_T__toCharArray__AC as $f_T__toCharArray__AC };
function $f_T__toLowerCase__ju_Locale__T($thiz, locale) {
  var x1 = locale.getLanguage__T();
  return ((x1 === "lt") ? $p_T__toLowerCaseLithuanian__T($thiz) : (((x1 === "tr") || (x1 === "az")) ? $p_T__toLowerCaseTurkishAndAzeri__T($thiz) : $thiz.toLowerCase()));
}
export { $f_T__toLowerCase__ju_Locale__T as $f_T__toLowerCase__ju_Locale__T };
function $p_T__toLowerCaseLithuanian__T($thiz) {
  var prep = "";
  var len = $thiz.length;
  var i = 0;
  var startOfSegment = 0;
  while ((i !== len)) {
    var x0 = i;
    var x1 = $thiz.charCodeAt(x0);
    switch (x1) {
      case 73: {
        var replacement = ($p_T__moreAbove$1__I__Z($thiz, x0) ? "i\u0307" : null);
        break;
      }
      case 74: {
        var replacement = ($p_T__moreAbove$1__I__Z($thiz, x0) ? "j\u0307" : null);
        break;
      }
      case 302: {
        var replacement = ($p_T__moreAbove$1__I__Z($thiz, x0) ? "\u012f\u0307" : null);
        break;
      }
      case 204: {
        var replacement = "i\u0307\u0300";
        break;
      }
      case 205: {
        var replacement = "i\u0307\u0301";
        break;
      }
      case 296: {
        var replacement = "i\u0307\u0303";
        break;
      }
      default: {
        var replacement = null;
      }
    }
    if ((replacement !== null)) {
      var $x_1 = prep;
      var beginIndex = startOfSegment;
      var endIndex = i;
      prep = (("" + $x_1) + $thiz.substring(beginIndex, endIndex));
      prep = (("" + prep) + replacement);
      startOfSegment = ((1 + i) | 0);
    }
    i = ((1 + i) | 0);
  }
  if ((startOfSegment === 0)) {
    var preprocessed = $thiz;
  } else {
    var $x_2 = prep;
    var beginIndex$1 = startOfSegment;
    var endIndex$1 = i;
    var preprocessed = (("" + $x_2) + $thiz.substring(beginIndex$1, endIndex$1));
  }
  return preprocessed.toLowerCase();
}
export { $p_T__toLowerCaseLithuanian__T as $p_T__toLowerCaseLithuanian__T };
function $p_T__toLowerCaseTurkishAndAzeri__T($thiz) {
  var prep = "";
  var len = $thiz.length;
  var i = 0;
  var startOfSegment = 0;
  while ((i !== len)) {
    var x0 = i;
    var x1 = $thiz.charCodeAt(x0);
    switch (x1) {
      case 304: {
        var replacement = "i";
        break;
      }
      case 775: {
        var replacement = ($p_T__afterI$1__I__Z($thiz, x0) ? "" : null);
        break;
      }
      case 73: {
        var replacement = ((!$p_T__beforeDot$1__I__Z($thiz, x0)) ? "\u0131" : null);
        break;
      }
      default: {
        var replacement = null;
      }
    }
    if ((replacement !== null)) {
      var $x_1 = prep;
      var beginIndex = startOfSegment;
      var endIndex = i;
      prep = (("" + $x_1) + $thiz.substring(beginIndex, endIndex));
      prep = (("" + prep) + replacement);
      startOfSegment = ((1 + i) | 0);
    }
    i = ((1 + i) | 0);
  }
  if ((startOfSegment === 0)) {
    var preprocessed = $thiz;
  } else {
    var $x_2 = prep;
    var beginIndex$1 = startOfSegment;
    var endIndex$1 = i;
    var preprocessed = (("" + $x_2) + $thiz.substring(beginIndex$1, endIndex$1));
  }
  return preprocessed.toLowerCase();
}
export { $p_T__toLowerCaseTurkishAndAzeri__T as $p_T__toLowerCaseTurkishAndAzeri__T };
function $f_T__toUpperCase__ju_Locale__T($thiz, locale) {
  var x1 = locale.getLanguage__T();
  return ((x1 === "lt") ? $p_T__toUpperCaseLithuanian__T($thiz) : (((x1 === "tr") || (x1 === "az")) ? $p_T__toUpperCaseTurkishAndAzeri__T($thiz) : $thiz.toUpperCase()));
}
export { $f_T__toUpperCase__ju_Locale__T as $f_T__toUpperCase__ju_Locale__T };
function $p_T__toUpperCaseLithuanian__T($thiz) {
  var prep = "";
  var len = $thiz.length;
  var i = 0;
  var startOfSegment = 0;
  while ((i !== len)) {
    var x0 = i;
    var x1 = $thiz.charCodeAt(x0);
    var replacement = ((x1 === 775) ? ($p_T__afterSoftDotted$1__I__Z($thiz, x0) ? "" : null) : null);
    if ((replacement !== null)) {
      var $x_1 = prep;
      var beginIndex = startOfSegment;
      var endIndex = i;
      prep = (("" + $x_1) + $thiz.substring(beginIndex, endIndex));
      prep = (("" + prep) + replacement);
      startOfSegment = ((1 + i) | 0);
    }
    i = ((1 + i) | 0);
  }
  if ((startOfSegment === 0)) {
    var preprocessed = $thiz;
  } else {
    var $x_2 = prep;
    var beginIndex$1 = startOfSegment;
    var endIndex$1 = i;
    var preprocessed = (("" + $x_2) + $thiz.substring(beginIndex$1, endIndex$1));
  }
  return preprocessed.toUpperCase();
}
export { $p_T__toUpperCaseLithuanian__T as $p_T__toUpperCaseLithuanian__T };
function $p_T__toUpperCaseTurkishAndAzeri__T($thiz) {
  var prep = "";
  var len = $thiz.length;
  var i = 0;
  var startOfSegment = 0;
  while ((i !== len)) {
    var x0 = i;
    var x1 = $thiz.charCodeAt(x0);
    var replacement = ((x1 === 105) ? "\u0130" : null);
    if ((replacement !== null)) {
      var $x_1 = prep;
      var beginIndex = startOfSegment;
      var endIndex = i;
      prep = (("" + $x_1) + $thiz.substring(beginIndex, endIndex));
      prep = (("" + prep) + replacement);
      startOfSegment = ((1 + i) | 0);
    }
    i = ((1 + i) | 0);
  }
  if ((startOfSegment === 0)) {
    var preprocessed = $thiz;
  } else {
    var $x_2 = prep;
    var beginIndex$1 = startOfSegment;
    var endIndex$1 = i;
    var preprocessed = (("" + $x_2) + $thiz.substring(beginIndex$1, endIndex$1));
  }
  return preprocessed.toUpperCase();
}
export { $p_T__toUpperCaseTurkishAndAzeri__T as $p_T__toUpperCaseTurkishAndAzeri__T };
function $p_T__skipCharsWithCombiningClassOtherThanNoneOrAboveForwards__I__I($thiz, i) {
  var len = $thiz.length;
  var j = i;
  while ((j !== len)) {
    var cp = $f_T__codePointAt__I__I($thiz, j);
    if (($m_jl_Character$().combiningClassNoneOrAboveOrOther__I__I(cp) !== 2)) {
      return j;
    }
    j = ((j + ((cp >= 65536) ? 2 : 1)) | 0);
  }
  return j;
}
export { $p_T__skipCharsWithCombiningClassOtherThanNoneOrAboveForwards__I__I as $p_T__skipCharsWithCombiningClassOtherThanNoneOrAboveForwards__I__I };
function $p_T__skipCharsWithCombiningClassOtherThanNoneOrAboveBackwards__I__I($thiz, i) {
  var j = i;
  while ((j > 0)) {
    var cp = $f_T__codePointBefore__I__I($thiz, j);
    if (($m_jl_Character$().combiningClassNoneOrAboveOrOther__I__I(cp) !== 2)) {
      return j;
    }
    j = ((j - ((cp >= 65536) ? 2 : 1)) | 0);
  }
  return 0;
}
export { $p_T__skipCharsWithCombiningClassOtherThanNoneOrAboveBackwards__I__I as $p_T__skipCharsWithCombiningClassOtherThanNoneOrAboveBackwards__I__I };
function $f_T__trim__T($thiz) {
  var len = $thiz.length;
  var start = 0;
  while (true) {
    if ((start !== len)) {
      var index = start;
      var $x_1 = ($thiz.charCodeAt(index) <= 32);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      start = ((1 + start) | 0);
    } else {
      break;
    }
  }
  if ((start === len)) {
    return "";
  } else {
    var end = len;
    while (true) {
      var index$1 = (((-1) + end) | 0);
      if (($thiz.charCodeAt(index$1) <= 32)) {
        end = (((-1) + end) | 0);
      } else {
        break;
      }
    }
    if (((start === 0) && (end === len))) {
      return $thiz;
    } else {
      var beginIndex = start;
      var endIndex = end;
      return $thiz.substring(beginIndex, endIndex);
    }
  }
}
export { $f_T__trim__T as $f_T__trim__T };
function $f_T__isBlank__Z($thiz) {
  var len = $thiz.length;
  var start = 0;
  while (true) {
    if ((start !== len)) {
      var this$1 = $m_jl_Character$();
      var index = start;
      var c = $thiz.charCodeAt(index);
      var $x_1 = this$1.isWhitespace__I__Z(c);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      start = ((1 + start) | 0);
    } else {
      break;
    }
  }
  return (start === len);
}
export { $f_T__isBlank__Z as $f_T__isBlank__Z };
function $p_T__splitLines__O($thiz) {
  var xs = [];
  var len = $thiz.length;
  var idx = 0;
  var last = 0;
  while ((idx < len)) {
    var index = idx;
    var c = $thiz.charCodeAt(index);
    if (((c === 10) || (c === 13))) {
      var beginIndex = last;
      var endIndex = idx;
      xs.push($thiz.substring(beginIndex, endIndex));
      if (((c === 13) && (((1 + idx) | 0) < len))) {
        var index$1 = ((1 + idx) | 0);
        var $x_1 = ($thiz.charCodeAt(index$1) === 10);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        idx = ((1 + idx) | 0);
      }
      last = ((1 + idx) | 0);
    }
    idx = ((1 + idx) | 0);
  }
  if ((last !== len)) {
    var beginIndex$1 = last;
    var $x_2 = xs.push($thiz.substring(beginIndex$1));
  }
  return xs;
}
export { $p_T__splitLines__O as $p_T__splitLines__O };
function $f_T__indent__I__T($thiz, n) {
  if ((n < 0)) {
    var out = "";
    var i = 0;
    var xs = $p_T__splitLines__O($thiz);
    while ((i < (xs.length | 0))) {
      var $x_2 = out;
      var t = xs[i];
      var idx = 0;
      var lim = ((t.length <= ((-n) | 0)) ? t.length : ((-n) | 0));
      while (true) {
        if ((idx < lim)) {
          var this$1 = $m_jl_Character$();
          var index = idx;
          var c = t.charCodeAt(index);
          var $x_1 = this$1.isWhitespace__I__Z(c);
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          idx = ((1 + idx) | 0);
        } else {
          break;
        }
      }
      var beginIndex = idx;
      out = ((("" + $x_2) + t.substring(beginIndex)) + "\n");
      i = ((1 + i) | 0);
    }
    return out;
  } else {
    var padding = $f_T__repeat__I__T(" ", n);
    var out$1 = "";
    var i$1 = 0;
    var xs$1 = $p_T__splitLines__O($thiz);
    while ((i$1 < (xs$1.length | 0))) {
      var $x_3 = out$1;
      var t$1 = xs$1[i$1];
      out$1 = (($x_3 + (("" + padding) + t$1)) + "\n");
      i$1 = ((1 + i$1) | 0);
    }
    return out$1;
  }
}
export { $f_T__indent__I__T as $f_T__indent__I__T };
function $f_T__toString__T($thiz) {
  return $thiz;
}
export { $f_T__toString__T as $f_T__toString__T };
function $f_T__compareTo__O__I($thiz, o) {
  return $f_T__compareTo__T__I($thiz, o);
}
export { $f_T__compareTo__O__I as $f_T__compareTo__O__I };
function $p_T__loop$1__I__I__Z($thiz, j, len$1) {
  while (true) {
    if ((j !== len$1)) {
      var cp = $f_T__codePointAt__I__I($thiz, j);
      var x1 = $m_jl_Character$().combiningClassNoneOrAboveOrOther__I__I(cp);
      switch (x1) {
        case 0: {
          return false;
          break;
        }
        case 1: {
          return true;
          break;
        }
        default: {
          j = ((j + ((cp >= 65536) ? 2 : 1)) | 0);
        }
      }
    } else {
      return false;
    }
  }
}
export { $p_T__loop$1__I__I__Z as $p_T__loop$1__I__I__Z };
function $p_T__moreAbove$1__I__Z($thiz, i) {
  var len = $thiz.length;
  return $p_T__loop$1__I__I__Z($thiz, ((1 + i) | 0), len);
}
export { $p_T__moreAbove$1__I__Z as $p_T__moreAbove$1__I__Z };
function $p_T__afterI$1__I__Z($thiz, i) {
  var j = $p_T__skipCharsWithCombiningClassOtherThanNoneOrAboveBackwards__I__I($thiz, i);
  if ((j > 0)) {
    var index = (((-1) + j) | 0);
    return ($thiz.charCodeAt(index) === 73);
  } else {
    return false;
  }
}
export { $p_T__afterI$1__I__Z as $p_T__afterI$1__I__Z };
function $p_T__beforeDot$1__I__Z($thiz, i) {
  var j = $p_T__skipCharsWithCombiningClassOtherThanNoneOrAboveForwards__I__I($thiz, ((1 + i) | 0));
  return ((j !== $thiz.length) && ($thiz.charCodeAt(j) === 775));
}
export { $p_T__beforeDot$1__I__Z as $p_T__beforeDot$1__I__Z };
function $p_T__afterSoftDotted$1__I__Z($thiz, i) {
  var j = $p_T__skipCharsWithCombiningClassOtherThanNoneOrAboveBackwards__I__I($thiz, i);
  if ((j > 0)) {
    var x1 = $f_T__codePointBefore__I__I($thiz, j);
    switch (x1) {
      case 105:
      case 106:
      case 303:
      case 616:
      case 1110:
      case 1112:
      case 7725:
      case 7883: {
        return true;
        break;
      }
      default: {
        return false;
      }
    }
  } else {
    return false;
  }
}
export { $p_T__afterSoftDotted$1__I__Z as $p_T__afterSoftDotted$1__I__Z };
function $isArrayOf_T(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.T)));
}
export { $isArrayOf_T as $isArrayOf_T };
var $d_T = new $TypeData().initClass(0, "java.lang.String", ({
  T: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1,
  jl_constant_Constable: 1,
  jl_constant_ConstantDesc: 1
}), ((x) => ((typeof x) === "string")));
export { $d_T as $d_T };
function $ct_jl_StringIndexOutOfBoundsException__T__($thiz, s) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_jl_StringIndexOutOfBoundsException__T__ as $ct_jl_StringIndexOutOfBoundsException__T__ };
function $ct_jl_StringIndexOutOfBoundsException__I__($thiz, index) {
  var s = ("String index out of range: " + index);
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, s, null, true, true);
  return $thiz;
}
export { $ct_jl_StringIndexOutOfBoundsException__I__ as $ct_jl_StringIndexOutOfBoundsException__I__ };
function $ct_jl_StringIndexOutOfBoundsException__($thiz) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, null, null, true, true);
  return $thiz;
}
export { $ct_jl_StringIndexOutOfBoundsException__ as $ct_jl_StringIndexOutOfBoundsException__ };
class $c_jl_StringIndexOutOfBoundsException extends $c_jl_IndexOutOfBoundsException {
}
export { $c_jl_StringIndexOutOfBoundsException as $c_jl_StringIndexOutOfBoundsException };
var $d_jl_StringIndexOutOfBoundsException = new $TypeData().initClass($c_jl_StringIndexOutOfBoundsException, "java.lang.StringIndexOutOfBoundsException", ({
  jl_StringIndexOutOfBoundsException: 1,
  jl_IndexOutOfBoundsException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_jl_StringIndexOutOfBoundsException as $d_jl_StringIndexOutOfBoundsException };
function $ct_Ljava_nio_CharBuffer__I__AC__I__($thiz, _capacity, _array, _arrayOffset) {
  $thiz.Ljava_nio_CharBuffer__f__array = _array;
  $thiz.Ljava_nio_CharBuffer__f__arrayOffset = _arrayOffset;
  $ct_Ljava_nio_Buffer__I__($thiz, _capacity);
  return $thiz;
}
export { $ct_Ljava_nio_CharBuffer__I__AC__I__ as $ct_Ljava_nio_CharBuffer__I__AC__I__ };
/** @constructor */
function $c_Ljava_nio_CharBuffer() {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_CharBuffer__f__array = null;
  this.Ljava_nio_CharBuffer__f__arrayOffset = 0;
}
export { $c_Ljava_nio_CharBuffer as $c_Ljava_nio_CharBuffer };
$c_Ljava_nio_CharBuffer.prototype = new $h_Ljava_nio_Buffer();
$c_Ljava_nio_CharBuffer.prototype.constructor = $c_Ljava_nio_CharBuffer;
/** @constructor */
function $h_Ljava_nio_CharBuffer() {
}
export { $h_Ljava_nio_CharBuffer as $h_Ljava_nio_CharBuffer };
$h_Ljava_nio_CharBuffer.prototype = $c_Ljava_nio_CharBuffer.prototype;
$c_Ljava_nio_CharBuffer.prototype.put__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer = (function(src) {
  if ((src === this)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  if (this.isReadOnly__Z()) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var srcLimit = src.Ljava_nio_Buffer__f__limit;
  var srcPos = src.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var length = ((srcLimit - srcPos) | 0);
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var selfPos = p;
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(src, srcLimit);
  var srcArray = src.Ljava_nio_CharBuffer__f__array;
  if ((srcArray !== null)) {
    var x0 = selfPos;
    var x2 = ((src.Ljava_nio_CharBuffer__f__arrayOffset + srcPos) | 0);
    this.store__I__AC__I__I__V(x0, srcArray, x2, length);
  } else {
    while ((srcPos !== srcLimit)) {
      var x0$1 = selfPos;
      var x1 = src.load__I__C(srcPos);
      this.store__I__C__V(x0$1, x1);
      srcPos = ((1 + srcPos) | 0);
      selfPos = ((1 + selfPos) | 0);
    }
  }
  return this;
});
$c_Ljava_nio_CharBuffer.prototype.put__T__I__I__Ljava_nio_CharBuffer = (function(src, start, end) {
  return this.put__Ljava_nio_CharBuffer__Ljava_nio_CharBuffer($m_Ljava_nio_CharBuffer$().wrap__jl_CharSequence__I__I__Ljava_nio_CharBuffer(src, start, end));
});
$c_Ljava_nio_CharBuffer.prototype.hashCode__I = (function() {
  var start = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var end = this.Ljava_nio_Buffer__f__limit;
  var h = (-182887236);
  var i = start;
  while ((i !== end)) {
    var $x_2 = $m_ju_internal_MurmurHash3$();
    var $x_1 = h;
    var this$3 = this.load__I__C(i);
    h = $x_2.mix__I__I__I($x_1, this$3);
    i = ((1 + i) | 0);
  }
  return $m_ju_internal_MurmurHash3$().finalizeHash__I__I__I(h, ((end - start) | 0));
});
$c_Ljava_nio_CharBuffer.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_Ljava_nio_CharBuffer) && (this.compareTo__Ljava_nio_CharBuffer__I(that) === 0));
});
$c_Ljava_nio_CharBuffer.prototype.compareTo__Ljava_nio_CharBuffer__I = (function(that) {
  if ((this === that)) {
    return 0;
  } else {
    var thisStart = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thisRemaining = ((this.Ljava_nio_Buffer__f__limit - thisStart) | 0);
    var thatStart = that.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    var thatRemaining = ((that.Ljava_nio_Buffer__f__limit - thatStart) | 0);
    var shortestLength = ((thisRemaining < thatRemaining) ? thisRemaining : thatRemaining);
    var i = 0;
    while ((i !== shortestLength)) {
      var t = this.load__I__C(((thisStart + i) | 0));
      var u = that.load__I__C(((thatStart + i) | 0));
      var cmp = ((t - u) | 0);
      if ((cmp !== 0)) {
        return cmp;
      }
      i = ((1 + i) | 0);
    }
    return ((thisRemaining === thatRemaining) ? 0 : ((thisRemaining < thatRemaining) ? (-1) : 1));
  }
});
$c_Ljava_nio_CharBuffer.prototype.toString__T = (function() {
  if ((this.Ljava_nio_CharBuffer__f__array !== null)) {
    var value = this.Ljava_nio_CharBuffer__f__array;
    var offset = ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + this.Ljava_nio_CharBuffer__f__arrayOffset) | 0);
    var count = ((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
    return $m_jl_String$().new__AC__I__I__T(value, offset, count);
  } else {
    var chars = new $ac_C(((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0));
    var savedPos = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
    this.get__AC__I__I__Ljava_nio_CharBuffer(chars, 0, chars.u.length);
    $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this, savedPos);
    var this$1 = $m_jl_String$();
    return this$1.new__AC__I__I__T(chars, 0, chars.u.length);
  }
});
$c_Ljava_nio_CharBuffer.prototype.length__I = (function() {
  return ((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0);
});
$c_Ljava_nio_CharBuffer.prototype.charAt__I__C = (function(index) {
  return this.get__I__C(((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + index) | 0));
});
$c_Ljava_nio_CharBuffer.prototype.append__jl_CharSequence__I__I__Ljava_nio_CharBuffer = (function(csq, start, end) {
  var src = $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(csq, start, end));
  return this.put__T__I__I__Ljava_nio_CharBuffer(src, 0, src.length);
});
$c_Ljava_nio_CharBuffer.prototype.append__C__jl_Appendable = (function(c) {
  return this.put__C__Ljava_nio_CharBuffer(c);
});
$c_Ljava_nio_CharBuffer.prototype.append__jl_CharSequence__I__I__jl_Appendable = (function(csq, start, end) {
  return this.append__jl_CharSequence__I__I__Ljava_nio_CharBuffer(csq, start, end);
});
$c_Ljava_nio_CharBuffer.prototype.append__jl_CharSequence__jl_Appendable = (function(csq) {
  var src = $dp_toString__T(csq);
  return this.put__T__I__I__Ljava_nio_CharBuffer(src, 0, src.length);
});
$c_Ljava_nio_CharBuffer.prototype.compareTo__O__I = (function(o) {
  return this.compareTo__Ljava_nio_CharBuffer__I(o);
});
function $isArrayOf_Ljava_nio_CharBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_CharBuffer)));
}
export { $isArrayOf_Ljava_nio_CharBuffer as $isArrayOf_Ljava_nio_CharBuffer };
class $c_Ljava_nio_ReadOnlyBufferException extends $c_jl_UnsupportedOperationException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
export { $c_Ljava_nio_ReadOnlyBufferException as $c_Ljava_nio_ReadOnlyBufferException };
var $d_Ljava_nio_ReadOnlyBufferException = new $TypeData().initClass($c_Ljava_nio_ReadOnlyBufferException, "java.nio.ReadOnlyBufferException", ({
  Ljava_nio_ReadOnlyBufferException: 1,
  jl_UnsupportedOperationException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_nio_ReadOnlyBufferException as $d_Ljava_nio_ReadOnlyBufferException };
class $c_Ljava_nio_charset_MalformedInputException extends $c_Ljava_nio_charset_CharacterCodingException {
  constructor(inputLength) {
    super();
    this.Ljava_nio_charset_MalformedInputException__f_inputLength = 0;
    this.Ljava_nio_charset_MalformedInputException__f_inputLength = inputLength;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return ("Input length = " + this.Ljava_nio_charset_MalformedInputException__f_inputLength);
  }
}
export { $c_Ljava_nio_charset_MalformedInputException as $c_Ljava_nio_charset_MalformedInputException };
function $isArrayOf_Ljava_nio_charset_MalformedInputException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_charset_MalformedInputException)));
}
export { $isArrayOf_Ljava_nio_charset_MalformedInputException as $isArrayOf_Ljava_nio_charset_MalformedInputException };
var $d_Ljava_nio_charset_MalformedInputException = new $TypeData().initClass($c_Ljava_nio_charset_MalformedInputException, "java.nio.charset.MalformedInputException", ({
  Ljava_nio_charset_MalformedInputException: 1,
  Ljava_nio_charset_CharacterCodingException: 1,
  Ljava_io_IOException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_nio_charset_MalformedInputException as $d_Ljava_nio_charset_MalformedInputException };
class $c_Ljava_nio_charset_UnmappableCharacterException extends $c_Ljava_nio_charset_CharacterCodingException {
  constructor(inputLength) {
    super();
    this.Ljava_nio_charset_UnmappableCharacterException__f_inputLength = 0;
    this.Ljava_nio_charset_UnmappableCharacterException__f_inputLength = inputLength;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return ("Input length = " + this.Ljava_nio_charset_UnmappableCharacterException__f_inputLength);
  }
}
export { $c_Ljava_nio_charset_UnmappableCharacterException as $c_Ljava_nio_charset_UnmappableCharacterException };
function $isArrayOf_Ljava_nio_charset_UnmappableCharacterException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_nio_charset_UnmappableCharacterException)));
}
export { $isArrayOf_Ljava_nio_charset_UnmappableCharacterException as $isArrayOf_Ljava_nio_charset_UnmappableCharacterException };
var $d_Ljava_nio_charset_UnmappableCharacterException = new $TypeData().initClass($c_Ljava_nio_charset_UnmappableCharacterException, "java.nio.charset.UnmappableCharacterException", ({
  Ljava_nio_charset_UnmappableCharacterException: 1,
  Ljava_nio_charset_CharacterCodingException: 1,
  Ljava_io_IOException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_nio_charset_UnmappableCharacterException as $d_Ljava_nio_charset_UnmappableCharacterException };
class $c_Ljava_nio_charset_UnsupportedCharsetException extends $c_jl_IllegalArgumentException {
  constructor(charsetName) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, charsetName, null, true, true);
  }
}
export { $c_Ljava_nio_charset_UnsupportedCharsetException as $c_Ljava_nio_charset_UnsupportedCharsetException };
var $d_Ljava_nio_charset_UnsupportedCharsetException = new $TypeData().initClass($c_Ljava_nio_charset_UnsupportedCharsetException, "java.nio.charset.UnsupportedCharsetException", ({
  Ljava_nio_charset_UnsupportedCharsetException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_nio_charset_UnsupportedCharsetException as $d_Ljava_nio_charset_UnsupportedCharsetException };
function $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z($thiz, field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? field.isDateBased__Z() : ((field !== null) && field.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z($thiz)));
}
export { $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z as $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z };
function $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === query)) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  }
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === query)) {
    return $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  }
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$5 === query)) {
    return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate($thiz.toEpochDay__J());
  }
  matchAlts1: {
    matchAlts2: {
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
      if ((x$7 === query)) {
        break matchAlts2;
      }
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$9 === query)) {
        break matchAlts2;
      }
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x$11 === query)) {
        break matchAlts2;
      }
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$13 === query)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query);
}
export { $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O as $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O };
function $f_Ljava_time_chrono_ChronoLocalDate__format__Ljava_time_format_DateTimeFormatter__T($thiz, formatter) {
  if ((formatter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "formatter");
  }
  return formatter.format__Ljava_time_temporal_TemporalAccessor__T($thiz);
}
export { $f_Ljava_time_chrono_ChronoLocalDate__format__Ljava_time_format_DateTimeFormatter__T as $f_Ljava_time_chrono_ChronoLocalDate__format__Ljava_time_format_DateTimeFormatter__T };
function $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I($thiz, other) {
  var t = $thiz.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = other.toEpochDay__J();
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  if ((cmp === 0)) {
    $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    cmp = $f_T__compareTo__T__I("ISO", "ISO");
  }
  return cmp;
}
export { $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I as $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I };
function $f_Ljava_time_chrono_ChronoLocalDate__isAfter__Ljava_time_chrono_ChronoLocalDate__Z($thiz, other) {
  var a = $thiz.toEpochDay__J();
  var b = other.toEpochDay__J();
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) > (b.RTLong__f_lo >>> 0)) : (ahi > bhi));
}
export { $f_Ljava_time_chrono_ChronoLocalDate__isAfter__Ljava_time_chrono_ChronoLocalDate__Z as $f_Ljava_time_chrono_ChronoLocalDate__isAfter__Ljava_time_chrono_ChronoLocalDate__Z };
function $f_Ljava_time_chrono_ChronoLocalDate__isBefore__Ljava_time_chrono_ChronoLocalDate__Z($thiz, other) {
  var a = $thiz.toEpochDay__J();
  var b = other.toEpochDay__J();
  var ahi = a.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) < (b.RTLong__f_lo >>> 0)) : (ahi < bhi));
}
export { $f_Ljava_time_chrono_ChronoLocalDate__isBefore__Ljava_time_chrono_ChronoLocalDate__Z as $f_Ljava_time_chrono_ChronoLocalDate__isBefore__Ljava_time_chrono_ChronoLocalDate__Z };
function $is_Ljava_time_chrono_ChronoLocalDate(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Ljava_time_chrono_ChronoLocalDate)));
}
export { $is_Ljava_time_chrono_ChronoLocalDate as $is_Ljava_time_chrono_ChronoLocalDate };
function $isArrayOf_Ljava_time_chrono_ChronoLocalDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoLocalDate)));
}
export { $isArrayOf_Ljava_time_chrono_ChronoLocalDate as $isArrayOf_Ljava_time_chrono_ChronoLocalDate };
/** @constructor */
function $c_Ljava_time_chrono_ChronoLocalDateTime() {
}
export { $c_Ljava_time_chrono_ChronoLocalDateTime as $c_Ljava_time_chrono_ChronoLocalDateTime };
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype = new $h_O();
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.constructor = $c_Ljava_time_chrono_ChronoLocalDateTime;
/** @constructor */
function $h_Ljava_time_chrono_ChronoLocalDateTime() {
}
export { $h_Ljava_time_chrono_ChronoLocalDateTime as $h_Ljava_time_chrono_ChronoLocalDateTime };
$h_Ljava_time_chrono_ChronoLocalDateTime.prototype = $c_Ljava_time_chrono_ChronoLocalDateTime.prototype;
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === query)) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  }
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === query)) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  }
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$5 === query)) {
    return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(this.Ljava_time_LocalDateTime__f_date.toEpochDay__J());
  }
  var x$7 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$7 === query)) {
    return this.Ljava_time_LocalDateTime__f_time;
  }
  matchAlts1: {
    matchAlts2: {
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$9 === query)) {
        break matchAlts2;
      }
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x$11 === query)) {
        break matchAlts2;
      }
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$13 === query)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query);
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField(), this.Ljava_time_LocalDateTime__f_date.toEpochDay__J()).with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField(), this.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J());
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.format__Ljava_time_format_DateTimeFormatter__T = (function(formatter) {
  if ((formatter === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "formatter");
  }
  return formatter.format__Ljava_time_temporal_TemporalAccessor__T(this);
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.toInstant__Ljava_time_ZoneOffset__Ljava_time_Instant = (function(offset) {
  var $x_2 = $m_Ljava_time_Instant$();
  var $x_1 = this.toEpochSecond__Ljava_time_ZoneOffset__J(offset);
  var this$1 = this.Ljava_time_LocalDateTime__f_time;
  var value = this$1.Ljava_time_LocalTime__f_nano;
  var hi = (value >> 31);
  return $x_2.ofEpochSecond__J__J__Ljava_time_Instant($x_1, new $c_RTLong(value, hi));
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.toEpochSecond__Ljava_time_ZoneOffset__J = (function(offset) {
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset");
  }
  var t = this.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(20864, b0);
  var a0b1 = Math.imul(20864, b1);
  var lo$1 = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((Math.imul(86400, hi) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
  var value = this.Ljava_time_LocalDateTime__f_time.toSecondOfDay__I();
  var hi$2 = (value >> 31);
  var lo$2 = ((lo$1 + value) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo$1 & value) | ((lo$1 | value) & (~lo$2))) >>> 31) | 0)) | 0);
  var secs__lo = lo$2;
  var secs__hi = hi$3;
  var a__lo = secs__lo;
  var a__hi = secs__hi;
  var value$1 = offset.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi$4 = (value$1 >> 31);
  var alo = a__lo;
  var lo$3 = ((alo - value$1) | 0);
  var hi$5 = ((((a__hi - hi$4) | 0) + ((((~alo) & value$1) | ((~(alo ^ value$1)) & lo$3)) >> 31)) | 0);
  var $x_1__lo = lo$3;
  var $x_1__hi = hi$5;
  secs__lo = $x_1__lo;
  secs__hi = $x_1__hi;
  return new $c_RTLong(secs__lo, secs__hi);
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.compare__Ljava_time_chrono_ChronoLocalDateTime__I = (function(other) {
  var this$1 = this.Ljava_time_LocalDateTime__f_date;
  var that = other.Ljava_time_LocalDateTime__f_date;
  var cmp = this$1.compareTo__Ljava_time_chrono_ChronoLocalDate__I(that);
  if ((cmp === 0)) {
    var this$2 = this.Ljava_time_LocalDateTime__f_time;
    var other$1 = other.Ljava_time_LocalDateTime__f_time;
    cmp = this$2.compare__Ljava_time_LocalTime__I(other$1);
    if ((cmp === 0)) {
      $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      cmp = $f_T__compareTo__T__I("ISO", "ISO");
    }
  }
  return cmp;
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  var t = this.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = other.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if (((hi === hi$1) ? ((lo >>> 0) > (lo$1 >>> 0)) : (hi > hi$1))) {
    return true;
  } else if (((lo === lo$1) && (hi === hi$1))) {
    var a = this.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
    var b = other.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
    var ahi = a.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) > (b.RTLong__f_lo >>> 0)) : (ahi > bhi));
  } else {
    return false;
  }
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  var t = this.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = other.Ljava_time_LocalDateTime__f_date.toEpochDay__J();
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if (((hi === hi$1) ? ((lo >>> 0) < (lo$1 >>> 0)) : (hi < hi$1))) {
    return true;
  } else if (((lo === lo$1) && (hi === hi$1))) {
    var a = this.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
    var b = other.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
    var ahi = a.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) < (b.RTLong__f_lo >>> 0)) : (ahi < bhi));
  } else {
    return false;
  }
});
$c_Ljava_time_chrono_ChronoLocalDateTime.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_chrono_ChronoLocalDateTime__I(that);
});
function $isArrayOf_Ljava_time_chrono_ChronoLocalDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_chrono_ChronoLocalDateTime)));
}
export { $isArrayOf_Ljava_time_chrono_ChronoLocalDateTime as $isArrayOf_Ljava_time_chrono_ChronoLocalDateTime };
function $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__jl_Throwable__($thiz, message, parsedData, errorIndex, cause) {
  $ct_jl_Throwable__T__jl_Throwable__Z__Z__($thiz, message, cause, true, true);
  $dp_toString__T(parsedData);
  return $thiz;
}
export { $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__jl_Throwable__ as $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__jl_Throwable__ };
function $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__($thiz, message, parsedData, errorIndex) {
  $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__jl_Throwable__($thiz, message, parsedData, errorIndex, null);
  return $thiz;
}
export { $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__ as $ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__ };
class $c_Ljava_time_format_DateTimeParseException extends $c_Ljava_time_DateTimeException {
}
export { $c_Ljava_time_format_DateTimeParseException as $c_Ljava_time_format_DateTimeParseException };
function $isArrayOf_Ljava_time_format_DateTimeParseException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_format_DateTimeParseException)));
}
export { $isArrayOf_Ljava_time_format_DateTimeParseException as $isArrayOf_Ljava_time_format_DateTimeParseException };
var $d_Ljava_time_format_DateTimeParseException = new $TypeData().initClass($c_Ljava_time_format_DateTimeParseException, "java.time.format.DateTimeParseException", ({
  Ljava_time_format_DateTimeParseException: 1,
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_format_DateTimeParseException as $d_Ljava_time_format_DateTimeParseException };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5(outer) {
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5 as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5 };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype = new $h_O();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5 as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5 };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype.compare__ju_Map$Entry__ju_Map$Entry__I = (function(str1, str2) {
  var this$1 = str2.getKey__O();
  var this$2 = str1.getKey__O();
  var cmp = ((this$1.length - this$2.length) | 0);
  if ((cmp === 0)) {
    cmp = $f_T__compareTo__T__I(str1.getKey__O(), str2.getKey__O());
  }
  return cmp;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__ju_Map$Entry__ju_Map$Entry__I(x, y);
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5 = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5, "java.time.format.internal.TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5: 1,
  ju_Comparator: 1,
  Ljava_io_Serializable: 1,
  s_math_Equiv: 1,
  s_math_PartialOrdering: 1,
  s_math_Ordering: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5 as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$ZoneTextPrinterParser$$anon$5 };
class $c_Ljava_time_temporal_UnsupportedTemporalTypeException extends $c_Ljava_time_DateTimeException {
  constructor(message) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
  }
}
export { $c_Ljava_time_temporal_UnsupportedTemporalTypeException as $c_Ljava_time_temporal_UnsupportedTemporalTypeException };
var $d_Ljava_time_temporal_UnsupportedTemporalTypeException = new $TypeData().initClass($c_Ljava_time_temporal_UnsupportedTemporalTypeException, "java.time.temporal.UnsupportedTemporalTypeException", ({
  Ljava_time_temporal_UnsupportedTemporalTypeException: 1,
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_temporal_UnsupportedTemporalTypeException as $d_Ljava_time_temporal_UnsupportedTemporalTypeException };
class $c_Ljava_time_zone_ZoneRulesException extends $c_Ljava_time_DateTimeException {
  constructor(message) {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, message, null, true, true);
  }
}
export { $c_Ljava_time_zone_ZoneRulesException as $c_Ljava_time_zone_ZoneRulesException };
function $isArrayOf_Ljava_time_zone_ZoneRulesException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_zone_ZoneRulesException)));
}
export { $isArrayOf_Ljava_time_zone_ZoneRulesException as $isArrayOf_Ljava_time_zone_ZoneRulesException };
var $d_Ljava_time_zone_ZoneRulesException = new $TypeData().initClass($c_Ljava_time_zone_ZoneRulesException, "java.time.zone.ZoneRulesException", ({
  Ljava_time_zone_ZoneRulesException: 1,
  Ljava_time_DateTimeException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_zone_ZoneRulesException as $d_Ljava_time_zone_ZoneRulesException };
/** @constructor */
function $c_ju_AbstractList() {
}
export { $c_ju_AbstractList as $c_ju_AbstractList };
$c_ju_AbstractList.prototype = new $h_ju_AbstractCollection();
$c_ju_AbstractList.prototype.constructor = $c_ju_AbstractList;
/** @constructor */
function $h_ju_AbstractList() {
}
export { $h_ju_AbstractList as $h_ju_AbstractList };
$h_ju_AbstractList.prototype = $c_ju_AbstractList.prototype;
$c_ju_AbstractList.prototype.add__O__Z = (function(element) {
  this.add__I__O__V(this.size__I(), element);
  return true;
});
$c_ju_AbstractList.prototype.set__I__O__O = (function(index, element) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_AbstractList.prototype.add__I__O__V = (function(index, element) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_AbstractList.prototype.remove__I__O = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_AbstractList.prototype.iterator__ju_Iterator = (function() {
  return this.listIterator__I__ju_ListIterator(0);
});
$c_ju_AbstractList.prototype.listIterator__ju_ListIterator = (function() {
  return this.listIterator__I__ju_ListIterator(0);
});
$c_ju_AbstractList.prototype.listIterator__I__ju_ListIterator = (function(index) {
  this.checkIndexOnBounds__I__V(index);
  return new $c_ju_RandomAccessListIterator(this, index, 0, this.size__I());
});
$c_ju_AbstractList.prototype.equals__O__Z = (function(o) {
  if ((o === this)) {
    return true;
  } else if ($is_ju_List(o)) {
    var oIter = o.listIterator__ju_ListIterator();
    var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
    _return: {
      while (_\uff3fself.hasNext__Z()) {
        var t = _\uff3fself.next__O();
        if (oIter.hasNext__Z()) {
          var b = oIter.next__O();
          var $x_2 = ((t === null) ? (b === null) : $dp_equals__O__Z(t, b));
        } else {
          var $x_2 = false;
        }
        if ((!$x_2)) {
          var $x_1 = true;
          break _return;
        }
      }
      var $x_1 = false;
    }
    if ((!$x_1)) {
      return (!oIter.hasNext__Z());
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_AbstractList.prototype.hashCode__I = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = 1;
  while (_\uff3fself.hasNext__Z()) {
    var t = result;
    var u = _\uff3fself.next__O();
    var t$1 = (t | 0);
    result = ((Math.imul(31, t$1) + ((u === null) ? 0 : $dp_hashCode__I(u))) | 0);
  }
  return (result | 0);
});
$c_ju_AbstractList.prototype.checkIndexInBounds__I__V = (function(index) {
  if (((index < 0) || (index >= this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
$c_ju_AbstractList.prototype.checkIndexOnBounds__I__V = (function(index) {
  if (((index < 0) || (index > this.size__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
/** @constructor */
function $c_ju_Collections$UnmodifiableListIterator(innerIterator) {
  this.ju_Collections$UnmodifiableIterator__f_inner = null;
  $ct_ju_Collections$UnmodifiableIterator__ju_Iterator__(this, innerIterator);
}
export { $c_ju_Collections$UnmodifiableListIterator as $c_ju_Collections$UnmodifiableListIterator };
$c_ju_Collections$UnmodifiableListIterator.prototype = new $h_ju_Collections$UnmodifiableIterator();
$c_ju_Collections$UnmodifiableListIterator.prototype.constructor = $c_ju_Collections$UnmodifiableListIterator;
/** @constructor */
function $h_ju_Collections$UnmodifiableListIterator() {
}
export { $h_ju_Collections$UnmodifiableListIterator as $h_ju_Collections$UnmodifiableListIterator };
$h_ju_Collections$UnmodifiableListIterator.prototype = $c_ju_Collections$UnmodifiableListIterator.prototype;
$c_ju_Collections$UnmodifiableListIterator.prototype.set__O__V = (function(e) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
var $d_ju_Collections$UnmodifiableListIterator = new $TypeData().initClass($c_ju_Collections$UnmodifiableListIterator, "java.util.Collections$UnmodifiableListIterator", ({
  ju_Collections$UnmodifiableListIterator: 1,
  ju_Collections$UnmodifiableIterator: 1,
  ju_Collections$WrappedIterator: 1,
  ju_Iterator: 1,
  ju_Collections$WrappedListIterator: 1,
  ju_ListIterator: 1
}));
export { $d_ju_Collections$UnmodifiableListIterator as $d_ju_Collections$UnmodifiableListIterator };
class $c_ju_FormatterClosedException extends $c_jl_IllegalStateException {
  constructor() {
    super();
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
}
export { $c_ju_FormatterClosedException as $c_ju_FormatterClosedException };
var $d_ju_FormatterClosedException = new $TypeData().initClass($c_ju_FormatterClosedException, "java.util.FormatterClosedException", ({
  ju_FormatterClosedException: 1,
  jl_IllegalStateException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_FormatterClosedException as $d_ju_FormatterClosedException };
/** @constructor */
function $c_ju_HashMap$EntrySet(outer) {
  this.ju_HashMap$EntrySet__f_$outer = null;
  this.ju_HashMap$EntrySet__f_$outer = outer;
}
export { $c_ju_HashMap$EntrySet as $c_ju_HashMap$EntrySet };
$c_ju_HashMap$EntrySet.prototype = new $h_ju_AbstractSet();
$c_ju_HashMap$EntrySet.prototype.constructor = $c_ju_HashMap$EntrySet;
/** @constructor */
function $h_ju_HashMap$EntrySet() {
}
export { $h_ju_HashMap$EntrySet as $h_ju_HashMap$EntrySet };
$h_ju_HashMap$EntrySet.prototype = $c_ju_HashMap$EntrySet.prototype;
$c_ju_HashMap$EntrySet.prototype.iterator__ju_Iterator = (function() {
  var this$1 = this.ju_HashMap$EntrySet__f_$outer;
  return this$1.nodeIterator__ju_Iterator();
});
$c_ju_HashMap$EntrySet.prototype.size__I = (function() {
  return this.ju_HashMap$EntrySet__f_$outer.ju_HashMap__f_contentSize;
});
$c_ju_HashMap$EntrySet.prototype.contains__O__Z = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var this$1 = this.ju_HashMap$EntrySet__f_$outer;
    var key = o.getKey__O();
    if ((key === null)) {
      var hash = 0;
    } else {
      var originalHash = $dp_hashCode__I(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    var node = this$1.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, (hash & (((-1) + this$1.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0)));
    if ((node !== null)) {
      var a = node.ju_HashMap$Node__f_value;
      var b = o.getValue__O();
      return ((a === null) ? (b === null) : $dp_equals__O__Z(a, b));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_HashMap$EntrySet.prototype.remove__O__Z = (function(o) {
  if ($is_ju_Map$Entry(o)) {
    var key = o.getKey__O();
    var this$1 = this.ju_HashMap$EntrySet__f_$outer;
    if ((key === null)) {
      var hash = 0;
    } else {
      var originalHash = $dp_hashCode__I(key);
      var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    var idx = (hash & (((-1) + this$1.ju_HashMap__f_java$util$HashMap$$table.u.length) | 0));
    var node = this$1.java$util$HashMap$$findNode0__O__I__I__ju_HashMap$Node(key, hash, idx);
    if ((node !== null)) {
      var a = node.ju_HashMap$Node__f_value;
      var b = o.getValue__O();
      var $x_1 = ((a === null) ? (b === null) : $dp_equals__O__Z(a, b));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this.ju_HashMap$EntrySet__f_$outer.java$util$HashMap$$remove0__ju_HashMap$Node__I__V(node, idx);
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
});
var $d_ju_HashMap$EntrySet = new $TypeData().initClass($c_ju_HashMap$EntrySet, "java.util.HashMap$EntrySet", ({
  ju_HashMap$EntrySet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
}));
export { $d_ju_HashMap$EntrySet as $d_ju_HashMap$EntrySet };
/** @constructor */
function $c_ju_HashMap$KeySet(outer) {
  this.ju_HashMap$KeySet__f_$outer = null;
  this.ju_HashMap$KeySet__f_$outer = outer;
}
export { $c_ju_HashMap$KeySet as $c_ju_HashMap$KeySet };
$c_ju_HashMap$KeySet.prototype = new $h_ju_AbstractSet();
$c_ju_HashMap$KeySet.prototype.constructor = $c_ju_HashMap$KeySet;
/** @constructor */
function $h_ju_HashMap$KeySet() {
}
export { $h_ju_HashMap$KeySet as $h_ju_HashMap$KeySet };
$h_ju_HashMap$KeySet.prototype = $c_ju_HashMap$KeySet.prototype;
$c_ju_HashMap$KeySet.prototype.iterator__ju_Iterator = (function() {
  return this.ju_HashMap$KeySet__f_$outer.keyIterator__ju_Iterator();
});
$c_ju_HashMap$KeySet.prototype.size__I = (function() {
  return this.ju_HashMap$KeySet__f_$outer.ju_HashMap__f_contentSize;
});
$c_ju_HashMap$KeySet.prototype.contains__O__Z = (function(o) {
  return this.ju_HashMap$KeySet__f_$outer.containsKey__O__Z(o);
});
$c_ju_HashMap$KeySet.prototype.remove__O__Z = (function(o) {
  return (this.ju_HashMap$KeySet__f_$outer.java$util$HashMap$$remove0__O__ju_HashMap$Node(o) !== null);
});
var $d_ju_HashMap$KeySet = new $TypeData().initClass($c_ju_HashMap$KeySet, "java.util.HashMap$KeySet", ({
  ju_HashMap$KeySet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1
}));
export { $d_ju_HashMap$KeySet as $d_ju_HashMap$KeySet };
class $c_ju_IllegalFormatException extends $c_jl_IllegalArgumentException {
}
export { $c_ju_IllegalFormatException as $c_ju_IllegalFormatException };
/** @constructor */
function $c_ju_NullRejectingHashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
}
export { $c_ju_NullRejectingHashMap as $c_ju_NullRejectingHashMap };
$c_ju_NullRejectingHashMap.prototype = new $h_ju_HashMap();
$c_ju_NullRejectingHashMap.prototype.constructor = $c_ju_NullRejectingHashMap;
/** @constructor */
function $h_ju_NullRejectingHashMap() {
}
export { $h_ju_NullRejectingHashMap as $h_ju_NullRejectingHashMap };
$h_ju_NullRejectingHashMap.prototype = $c_ju_NullRejectingHashMap.prototype;
$c_ju_NullRejectingHashMap.prototype.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node = (function(key, hash, value, previous, next) {
  return new $c_ju_NullRejectingHashMap$Node(key, hash, value, previous, next);
});
$c_ju_NullRejectingHashMap.prototype.get__O__O = (function(key) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $p_ju_HashMap__getOrDefaultImpl__O__O__O(this, key, null);
});
$c_ju_NullRejectingHashMap.prototype.containsKey__O__Z = (function(key) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $c_ju_HashMap.prototype.containsKey__O__Z.call(this, key);
});
$c_ju_NullRejectingHashMap.prototype.put__O__O__O = (function(key, value) {
  if (((key === null) || (value === null))) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  if ((key === null)) {
    var $x_1 = 0;
  } else {
    var originalHash = $dp_hashCode__I(key);
    var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  return this.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $x_1, false);
});
$c_ju_NullRejectingHashMap.prototype.putIfAbsent__O__O__O = (function(key, value) {
  if ((value === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  var old = this.get__O__O(key);
  if ((old === null)) {
    if ((key === null)) {
      var $x_1 = 0;
    } else {
      var originalHash = $dp_hashCode__I(key);
      var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
    }
    this.java$util$HashMap$$put0__O__O__I__Z__O(key, value, $x_1, false);
  }
  return old;
});
$c_ju_NullRejectingHashMap.prototype.putAll__ju_Map__V = (function(m) {
  var iter = m.entrySet__ju_Set().iterator__ju_Iterator();
  while (iter.hasNext__Z()) {
    var entry = iter.next__O();
    this.put__O__O__O(entry.getKey__O(), entry.getValue__O());
  }
});
$c_ju_NullRejectingHashMap.prototype.remove__O__O = (function(key) {
  if ((key === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  return $c_ju_HashMap.prototype.remove__O__O.call(this, key);
});
class $c_ju_regex_PatternSyntaxException extends $c_jl_IllegalArgumentException {
  constructor(desc, regex, index) {
    super();
    this.ju_regex_PatternSyntaxException__f_desc = null;
    this.ju_regex_PatternSyntaxException__f_regex = null;
    this.ju_regex_PatternSyntaxException__f_index = 0;
    this.ju_regex_PatternSyntaxException__f_desc = desc;
    this.ju_regex_PatternSyntaxException__f_regex = regex;
    this.ju_regex_PatternSyntaxException__f_index = index;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var idx = this.ju_regex_PatternSyntaxException__f_index;
    var re = this.ju_regex_PatternSyntaxException__f_regex;
    var indexHint = ((idx < 0) ? "" : (" near index " + idx));
    var base = (((this.ju_regex_PatternSyntaxException__f_desc + indexHint) + "\n") + re);
    return ((((idx >= 0) && (re !== null)) && (idx < re.length)) ? (((base + "\n") + $f_T__repeat__I__T(" ", idx)) + "^") : base);
  }
}
export { $c_ju_regex_PatternSyntaxException as $c_ju_regex_PatternSyntaxException };
var $d_ju_regex_PatternSyntaxException = new $TypeData().initClass($c_ju_regex_PatternSyntaxException, "java.util.regex.PatternSyntaxException", ({
  ju_regex_PatternSyntaxException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_regex_PatternSyntaxException as $d_ju_regex_PatternSyntaxException };
/** @constructor */
function $c_s_None$() {
}
export { $c_s_None$ as $c_s_None$ };
$c_s_None$.prototype = new $h_s_Option();
$c_s_None$.prototype.constructor = $c_s_None$;
/** @constructor */
function $h_s_None$() {
}
export { $h_s_None$ as $h_s_None$ };
$h_s_None$.prototype = $c_s_None$.prototype;
$c_s_None$.prototype.get__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "None.get");
});
$c_s_None$.prototype.productPrefix__T = (function() {
  return "None";
});
$c_s_None$.prototype.productArity__I = (function() {
  return 0;
});
$c_s_None$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_s_None$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_None$.prototype.hashCode__I = (function() {
  return 2433880;
});
$c_s_None$.prototype.toString__T = (function() {
  return "None";
});
$c_s_None$.prototype.get__O = (function() {
  this.get__E();
});
var $d_s_None$ = new $TypeData().initClass($c_s_None$, "scala.None$", ({
  s_None$: 1,
  s_Option: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_None$ as $d_s_None$ };
var $n_s_None$;
function $m_s_None$() {
  if ((!$n_s_None$)) {
    $n_s_None$ = new $c_s_None$();
  }
  return $n_s_None$;
}
export { $m_s_None$ as $m_s_None$ };
/** @constructor */
function $c_s_Some(value) {
  this.s_Some__f_value = null;
  this.s_Some__f_value = value;
}
export { $c_s_Some as $c_s_Some };
$c_s_Some.prototype = new $h_s_Option();
$c_s_Some.prototype.constructor = $c_s_Some;
/** @constructor */
function $h_s_Some() {
}
export { $h_s_Some as $h_s_Some };
$h_s_Some.prototype = $c_s_Some.prototype;
$c_s_Some.prototype.get__O = (function() {
  return this.s_Some__f_value;
});
$c_s_Some.prototype.productPrefix__T = (function() {
  return "Some";
});
$c_s_Some.prototype.productArity__I = (function() {
  return 1;
});
$c_s_Some.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.s_Some__f_value : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_Some.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_s_Some.prototype.productElementName__I__T = (function(x$1) {
  return ((x$1 === 0) ? "value" : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_s_Some.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1323286827, true);
});
$c_s_Some.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_s_Some.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_s_Some) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.s_Some__f_value, x$1.s_Some__f_value)));
});
function $isArrayOf_s_Some(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_Some)));
}
export { $isArrayOf_s_Some as $isArrayOf_s_Some };
var $d_s_Some = new $TypeData().initClass($c_s_Some, "scala.Some", ({
  s_Some: 1,
  s_Option: 1,
  sc_IterableOnce: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_Some as $d_s_Some };
class $c_s_StringContext$InvalidEscapeException extends $c_jl_IllegalArgumentException {
  constructor(str, index) {
    super();
    $m_s_Predef$().require__Z__V(((index >= 0) && (index < str.length)));
    if ((index === (((-1) + str.length) | 0))) {
      var $x_1 = "at terminal";
    } else {
      var i = ((1 + index) | 0);
      var $x_1 = (("'\\" + $cToS(str.charCodeAt(i))) + "' not one of [\\b, \\t, \\n, \\f, \\r, \\\\, \\\", \\', \\uxxxx] at");
    }
    var s = (((((("invalid escape " + $x_1) + " index ") + index) + " in \"") + str) + "\". Use \\\\ for literal \\.");
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
export { $c_s_StringContext$InvalidEscapeException as $c_s_StringContext$InvalidEscapeException };
var $d_s_StringContext$InvalidEscapeException = new $TypeData().initClass($c_s_StringContext$InvalidEscapeException, "scala.StringContext$InvalidEscapeException", ({
  s_StringContext$InvalidEscapeException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_StringContext$InvalidEscapeException as $d_s_StringContext$InvalidEscapeException };
class $c_s_StringContext$InvalidUnicodeEscapeException extends $c_jl_IllegalArgumentException {
  constructor(str, escapeStart, index) {
    super();
    var s = ((("invalid unicode escape at index " + index) + " of ") + str);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, null, true, true);
  }
}
export { $c_s_StringContext$InvalidUnicodeEscapeException as $c_s_StringContext$InvalidUnicodeEscapeException };
var $d_s_StringContext$InvalidUnicodeEscapeException = new $TypeData().initClass($c_s_StringContext$InvalidUnicodeEscapeException, "scala.StringContext$InvalidUnicodeEscapeException", ({
  s_StringContext$InvalidUnicodeEscapeException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_StringContext$InvalidUnicodeEscapeException as $d_s_StringContext$InvalidUnicodeEscapeException };
/** @constructor */
function $c_T2$mcCI$sp(_1$mcC$sp, _2$mcI$sp) {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
  this.T2$mcCI$sp__f__1$mcC$sp = 0;
  this.T2$mcCI$sp__f__2$mcI$sp = 0;
  this.T2$mcCI$sp__f__1$mcC$sp = _1$mcC$sp;
  this.T2$mcCI$sp__f__2$mcI$sp = _2$mcI$sp;
  $ct_T2__O__O__(this, null, null);
}
export { $c_T2$mcCI$sp as $c_T2$mcCI$sp };
$c_T2$mcCI$sp.prototype = new $h_T2();
$c_T2$mcCI$sp.prototype.constructor = $c_T2$mcCI$sp;
/** @constructor */
function $h_T2$mcCI$sp() {
}
export { $h_T2$mcCI$sp as $h_T2$mcCI$sp };
$h_T2$mcCI$sp.prototype = $c_T2$mcCI$sp.prototype;
$c_T2$mcCI$sp.prototype._1$mcC$sp__C = (function() {
  return this.T2$mcCI$sp__f__1$mcC$sp;
});
$c_T2$mcCI$sp.prototype._2$mcI$sp__I = (function() {
  return this.T2$mcCI$sp__f__2$mcI$sp;
});
$c_T2$mcCI$sp.prototype.swap__T2 = (function() {
  return new $c_T2$mcIC$sp(this.T2$mcCI$sp__f__2$mcI$sp, this.T2$mcCI$sp__f__1$mcC$sp);
});
$c_T2$mcCI$sp.prototype._2__O = (function() {
  return this.T2$mcCI$sp__f__2$mcI$sp;
});
$c_T2$mcCI$sp.prototype._1__O = (function() {
  return $bC(this.T2$mcCI$sp__f__1$mcC$sp);
});
var $d_T2$mcCI$sp = new $TypeData().initClass($c_T2$mcCI$sp, "scala.Tuple2$mcCI$sp", ({
  T2$mcCI$sp: 1,
  T2: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T2$mcCI$sp as $d_T2$mcCI$sp };
/** @constructor */
function $c_T2$mcIC$sp(_1$mcI$sp, _2$mcC$sp) {
  this.T2__f__1 = null;
  this.T2__f__2 = null;
  this.T2$mcIC$sp__f__1$mcI$sp = 0;
  this.T2$mcIC$sp__f__2$mcC$sp = 0;
  this.T2$mcIC$sp__f__1$mcI$sp = _1$mcI$sp;
  this.T2$mcIC$sp__f__2$mcC$sp = _2$mcC$sp;
  $ct_T2__O__O__(this, null, null);
}
export { $c_T2$mcIC$sp as $c_T2$mcIC$sp };
$c_T2$mcIC$sp.prototype = new $h_T2();
$c_T2$mcIC$sp.prototype.constructor = $c_T2$mcIC$sp;
/** @constructor */
function $h_T2$mcIC$sp() {
}
export { $h_T2$mcIC$sp as $h_T2$mcIC$sp };
$h_T2$mcIC$sp.prototype = $c_T2$mcIC$sp.prototype;
$c_T2$mcIC$sp.prototype.swap__T2 = (function() {
  return new $c_T2$mcCI$sp(this.T2$mcIC$sp__f__2$mcC$sp, this.T2$mcIC$sp__f__1$mcI$sp);
});
$c_T2$mcIC$sp.prototype._2__O = (function() {
  return $bC(this.T2$mcIC$sp__f__2$mcC$sp);
});
$c_T2$mcIC$sp.prototype._1__O = (function() {
  return this.T2$mcIC$sp__f__1$mcI$sp;
});
var $d_T2$mcIC$sp = new $TypeData().initClass($c_T2$mcIC$sp, "scala.Tuple2$mcIC$sp", ({
  T2$mcIC$sp: 1,
  T2: 1,
  s_Product2: 1,
  s_Product: 1,
  s_Equals: 1,
  Ljava_io_Serializable: 1
}));
export { $d_T2$mcIC$sp as $d_T2$mcIC$sp };
/** @constructor */
function $c_sc_AbstractIterable() {
}
export { $c_sc_AbstractIterable as $c_sc_AbstractIterable };
$c_sc_AbstractIterable.prototype = new $h_O();
$c_sc_AbstractIterable.prototype.constructor = $c_sc_AbstractIterable;
/** @constructor */
function $h_sc_AbstractIterable() {
}
export { $h_sc_AbstractIterable as $h_sc_AbstractIterable };
$h_sc_AbstractIterable.prototype = $c_sc_AbstractIterable.prototype;
$c_sc_AbstractIterable.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Iterable$();
});
$c_sc_AbstractIterable.prototype.className__T = (function() {
  return this.stringPrefix__T();
});
$c_sc_AbstractIterable.prototype.stringPrefix__T = (function() {
  return "Iterable";
});
$c_sc_AbstractIterable.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.iterableFactory__sc_IterableFactory().from__sc_IterableOnce__O(coll);
});
$c_sc_AbstractIterable.prototype.newSpecificBuilder__scm_Builder = (function() {
  return this.iterableFactory__sc_IterableFactory().newBuilder__scm_Builder();
});
$c_sc_AbstractIterable.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O();
});
$c_sc_AbstractIterable.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$c_sc_AbstractIterable.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_sc_AbstractIterable.prototype.lastOption__s_Option = (function() {
  return $f_sc_IterableOps__lastOption__s_Option(this);
});
$c_sc_AbstractIterable.prototype.sizeCompare__I__I = (function(otherSize) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, otherSize);
});
$c_sc_AbstractIterable.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_sc_AbstractIterable.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$c_sc_AbstractIterable.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$c_sc_AbstractIterable.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_IterableOps__partition__F1__T2(this, p);
});
$c_sc_AbstractIterable.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n);
});
$c_sc_AbstractIterable.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_sc_AbstractIterable.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IterableOps__dropRight__I__O(this, n);
});
$c_sc_AbstractIterable.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sc_AbstractIterable.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sc_AbstractIterable.prototype.map__F1__O = (function(f) {
  return $f_sc_IterableOps__map__F1__O(this, f);
});
$c_sc_AbstractIterable.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_sc_AbstractIterable.prototype.flatten__F1__O = (function(asIterable) {
  return this.flatMap__F1__O(asIterable);
});
$c_sc_AbstractIterable.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_IterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sc_AbstractIterable.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_AbstractIterable.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_sc_AbstractIterable.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sc_AbstractIterable.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sc_AbstractIterable.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_sc_AbstractIterable.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_AbstractIterable.prototype.foldRight__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldRight__O__F2__O(this, z, op);
});
$c_sc_AbstractIterable.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sc_AbstractIterable.prototype.isEmpty__Z = (function() {
  return $f_sc_IterableOnceOps__isEmpty__Z(this);
});
$c_sc_AbstractIterable.prototype.size__I = (function() {
  return $f_sc_IterableOnceOps__size__I(this);
});
$c_sc_AbstractIterable.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sc_AbstractIterable.prototype.min__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$c_sc_AbstractIterable.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$c_sc_AbstractIterable.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_sc_AbstractIterable.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_AbstractIterable.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_AbstractIterable.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sc_AbstractIterable.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_AbstractIterable.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_sc_AbstractIterable.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return $m_sci_IndexedSeq$().from__sc_IterableOnce__sci_IndexedSeq(this);
});
$c_sc_AbstractIterable.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_AbstractIterable.prototype.reversed__sc_Iterable = (function() {
  return $f_sc_IterableOnceOps__reversed__sc_Iterable(this);
});
$c_sc_AbstractIterable.prototype.knownSize__I = (function() {
  return (-1);
});
$c_sc_AbstractIterable.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll);
});
function $ct_sc_ArrayOps$ArrayIterator__O__($thiz, xs) {
  $thiz.sc_ArrayOps$ArrayIterator__f_xs = xs;
  $thiz.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  var xs$1 = $thiz.sc_ArrayOps$ArrayIterator__f_xs;
  $thiz.sc_ArrayOps$ArrayIterator__f_len = $m_jl_reflect_Array$().getLength__O__I(xs$1);
  return $thiz;
}
export { $ct_sc_ArrayOps$ArrayIterator__O__ as $ct_sc_ArrayOps$ArrayIterator__O__ };
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator() {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
}
export { $c_sc_ArrayOps$ArrayIterator as $c_sc_ArrayOps$ArrayIterator };
$c_sc_ArrayOps$ArrayIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_ArrayOps$ArrayIterator.prototype.constructor = $c_sc_ArrayOps$ArrayIterator;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator() {
}
export { $h_sc_ArrayOps$ArrayIterator as $h_sc_ArrayOps$ArrayIterator };
$h_sc_ArrayOps$ArrayIterator.prototype = $c_sc_ArrayOps$ArrayIterator.prototype;
$c_sc_ArrayOps$ArrayIterator.prototype.knownSize__I = (function() {
  return ((this.sc_ArrayOps$ArrayIterator__f_len - this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
});
$c_sc_ArrayOps$ArrayIterator.prototype.hasNext__Z = (function() {
  return (this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos < this.sc_ArrayOps$ArrayIterator__f_len);
});
$c_sc_ArrayOps$ArrayIterator.prototype.next__O = (function() {
  var $x_1 = this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos;
  var xs = this.sc_ArrayOps$ArrayIterator__f_xs;
  if (($x_1 >= $m_jl_reflect_Array$().getLength__O__I(xs))) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var r = $m_sr_ScalaRunTime$().array_apply__O__I__O(this.sc_ArrayOps$ArrayIterator__f_xs, this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos);
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var newPos = ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos + n) | 0);
    if ((newPos < 0)) {
      var $x_1 = this.sc_ArrayOps$ArrayIterator__f_len;
    } else {
      var a = this.sc_ArrayOps$ArrayIterator__f_len;
      var $x_1 = ((a < newPos) ? a : newPos);
    }
    this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = $x_1;
  }
  return this;
});
var $d_sc_ArrayOps$ArrayIterator = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator, "scala.collection.ArrayOps$ArrayIterator", ({
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_ArrayOps$ArrayIterator as $d_sc_ArrayOps$ArrayIterator };
function $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I($thiz, value) {
  return ((value < 0) ? 0 : ((value > $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder) ? $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder : value));
}
export { $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I as $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I };
function $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  $thiz.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = self.length__I();
  return $thiz;
}
export { $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__ as $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__ };
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0;
}
export { $c_sc_IndexedSeqView$IndexedSeqViewIterator as $c_sc_IndexedSeqView$IndexedSeqViewIterator };
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewIterator() {
}
export { $h_sc_IndexedSeqView$IndexedSeqViewIterator as $h_sc_IndexedSeqView$IndexedSeqViewIterator };
$h_sc_IndexedSeqView$IndexedSeqViewIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.knownSize__I = (function() {
  return this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder;
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0);
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0)) {
    var r = this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self.apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((1 + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder) | 0);
    return r;
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + n) | 0);
    var b = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder - n) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b);
  }
  return this;
});
$c_sc_IndexedSeqView$IndexedSeqViewIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  var formatFrom = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, from);
  var formatUntil = $p_sc_IndexedSeqView$IndexedSeqViewIterator__formatRange$1__I__I(this, until);
  var b = ((formatUntil - formatFrom) | 0);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = ((b < 0) ? 0 : b);
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = ((this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current + formatFrom) | 0);
  return this;
});
var $d_sc_IndexedSeqView$IndexedSeqViewIterator = new $TypeData().initClass($c_sc_IndexedSeqView$IndexedSeqViewIterator, "scala.collection.IndexedSeqView$IndexedSeqViewIterator", ({
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_IndexedSeqView$IndexedSeqViewIterator as $d_sc_IndexedSeqView$IndexedSeqViewIterator };
function $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__($thiz, self) {
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = self;
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = self.length__I();
  $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = (((-1) + $thiz.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder) | 0);
  return $thiz;
}
export { $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__ as $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__ };
/** @constructor */
function $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0;
}
export { $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator as $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator };
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = new $h_sc_AbstractIterator();
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.constructor = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator;
/** @constructor */
function $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator() {
}
export { $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator as $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator };
$h_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype = $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype;
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.hasNext__Z = (function() {
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0);
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.next__O = (function() {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    var r = this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self.apply__I__O(this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos) | 0);
    this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = (((-1) + this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder) | 0);
    return r;
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
$c_sc_IndexedSeqView$IndexedSeqViewReverseIterator.prototype.sliceIterator__I__I__sc_Iterator = (function(from, until) {
  if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
    if ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder <= from)) {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
    } else if ((from <= 0)) {
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = until;
      }
    } else {
      this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos - from) | 0);
      if (((until >= 0) && (until < this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder))) {
        if ((until <= from)) {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
        } else {
          this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((until - from) | 0);
        }
      } else {
        this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = ((this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder - from) | 0);
      }
    }
  }
  return this;
});
var $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator = new $TypeData().initClass($c_sc_IndexedSeqView$IndexedSeqViewReverseIterator, "scala.collection.IndexedSeqView$IndexedSeqViewReverseIterator", ({
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator as $d_sc_IndexedSeqView$IndexedSeqViewReverseIterator };
/** @constructor */
function $c_sc_Iterator$$anon$21() {
  this.scm_ImmutableBuilder__f_elems = null;
  $ct_scm_ImmutableBuilder__sc_IterableOnce__(this, $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty);
}
export { $c_sc_Iterator$$anon$21 as $c_sc_Iterator$$anon$21 };
$c_sc_Iterator$$anon$21.prototype = new $h_scm_ImmutableBuilder();
$c_sc_Iterator$$anon$21.prototype.constructor = $c_sc_Iterator$$anon$21;
/** @constructor */
function $h_sc_Iterator$$anon$21() {
}
export { $h_sc_Iterator$$anon$21 as $h_sc_Iterator$$anon$21 };
$h_sc_Iterator$$anon$21.prototype = $c_sc_Iterator$$anon$21.prototype;
$c_sc_Iterator$$anon$21.prototype.addOne__O__sc_Iterator$$anon$21 = (function(elem) {
  var this$2 = this.scm_ImmutableBuilder__f_elems;
  var xs = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $c_sc_Iterator$$anon$20(elem)));
  this.scm_ImmutableBuilder__f_elems = this$2.concat__F0__sc_Iterator(xs);
  return this;
});
$c_sc_Iterator$$anon$21.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sc_Iterator$$anon$21(elem);
});
var $d_sc_Iterator$$anon$21 = new $TypeData().initClass($c_sc_Iterator$$anon$21, "scala.collection.Iterator$$anon$21", ({
  sc_Iterator$$anon$21: 1,
  scm_ImmutableBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1
}));
export { $d_sc_Iterator$$anon$21 as $d_sc_Iterator$$anon$21 };
/** @constructor */
function $c_sc_Iterator$$anon$7(outer, pf$1) {
  this.sc_Iterator$$anon$7__f_hd = null;
  this.sc_Iterator$$anon$7__f_status = 0;
  this.sc_Iterator$$anon$7__f_$outer = null;
  this.sc_Iterator$$anon$7__f_pf$1 = null;
  this.sc_Iterator$$anon$7__f_$outer = outer;
  this.sc_Iterator$$anon$7__f_pf$1 = pf$1;
  this.sc_Iterator$$anon$7__f_status = 0;
}
export { $c_sc_Iterator$$anon$7 as $c_sc_Iterator$$anon$7 };
$c_sc_Iterator$$anon$7.prototype = new $h_sc_AbstractIterator();
$c_sc_Iterator$$anon$7.prototype.constructor = $c_sc_Iterator$$anon$7;
/** @constructor */
function $h_sc_Iterator$$anon$7() {
}
export { $h_sc_Iterator$$anon$7 as $h_sc_Iterator$$anon$7 };
$h_sc_Iterator$$anon$7.prototype = $c_sc_Iterator$$anon$7.prototype;
$c_sc_Iterator$$anon$7.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return $m_sr_Statics$PFMarker$();
});
$c_sc_Iterator$$anon$7.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_Iterator$$anon$7.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sc_Iterator$$anon$7.prototype.toString__T = (function() {
  return "<function1>";
});
$c_sc_Iterator$$anon$7.prototype.apply__O__O = (function(value) {
  return $m_sr_Statics$PFMarker$();
});
$c_sc_Iterator$$anon$7.prototype.hasNext__Z = (function() {
  var marker = $m_sr_Statics$PFMarker$();
  while ((this.sc_Iterator$$anon$7__f_status === 0)) {
    if (this.sc_Iterator$$anon$7__f_$outer.hasNext__Z()) {
      var x = this.sc_Iterator$$anon$7__f_$outer.next__O();
      var v = this.sc_Iterator$$anon$7__f_pf$1.applyOrElse__O__F1__O(x, this);
      if ((marker !== v)) {
        this.sc_Iterator$$anon$7__f_hd = v;
        this.sc_Iterator$$anon$7__f_status = 1;
      }
    } else {
      this.sc_Iterator$$anon$7__f_status = (-1);
    }
  }
  return (this.sc_Iterator$$anon$7__f_status === 1);
});
$c_sc_Iterator$$anon$7.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    this.sc_Iterator$$anon$7__f_status = 0;
    return this.sc_Iterator$$anon$7__f_hd;
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
var $d_sc_Iterator$$anon$7 = new $TypeData().initClass($c_sc_Iterator$$anon$7, "scala.collection.Iterator$$anon$7", ({
  sc_Iterator$$anon$7: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  F1: 1
}));
export { $d_sc_Iterator$$anon$7 as $d_sc_Iterator$$anon$7 };
function $f_sc_MapOps__getOrElse__O__F0__O($thiz, key, default$1) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var v = x1.s_Some__f_value;
    return v;
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      return default$1.apply__O();
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
}
export { $f_sc_MapOps__getOrElse__O__F0__O as $f_sc_MapOps__getOrElse__O__F0__O };
function $f_sc_MapOps__apply__O__O($thiz, key) {
  var x1 = $thiz.get__O__s_Option(key);
  var x = $m_s_None$();
  if ((x === x1)) {
    return $thiz.default__O__O(key);
  } else if ((x1 instanceof $c_s_Some)) {
    var value = x1.s_Some__f_value;
    return value;
  } else {
    throw new $c_s_MatchError(x1);
  }
}
export { $f_sc_MapOps__apply__O__O as $f_sc_MapOps__apply__O__O };
function $f_sc_MapOps__applyOrElse__O__F1__O($thiz, x, default$1) {
  return $thiz.getOrElse__O__F0__O(x, new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => default$1.apply__O__O(x))));
}
export { $f_sc_MapOps__applyOrElse__O__F1__O as $f_sc_MapOps__applyOrElse__O__F1__O };
function $f_sc_MapOps__foreachEntry__F2__V($thiz, f) {
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var next = it.next__O();
    f.apply__O__O__O(next._1__O(), next._2__O());
  }
}
export { $f_sc_MapOps__foreachEntry__F2__V as $f_sc_MapOps__foreachEntry__F2__V };
function $f_sc_MapOps__default__O__O($thiz, key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
}
export { $f_sc_MapOps__default__O__O as $f_sc_MapOps__default__O__O };
function $f_sc_MapOps__contains__O__Z($thiz, key) {
  var this$1 = $thiz.get__O__s_Option(key);
  return (!this$1.isEmpty__Z());
}
export { $f_sc_MapOps__contains__O__Z as $f_sc_MapOps__contains__O__Z };
function $f_sc_MapOps__map__F1__sc_IterableOps($thiz, f) {
  return $thiz.mapFactory__sc_MapFactory().from__sc_IterableOnce__O($ct_sc_View$Map__sc_IterableOps__F1__(new $c_sc_View$Map(), $thiz, f));
}
export { $f_sc_MapOps__map__F1__sc_IterableOps as $f_sc_MapOps__map__F1__sc_IterableOps };
function $f_sc_MapOps__collect__s_PartialFunction__sc_IterableOps($thiz, pf) {
  return $thiz.mapFactory__sc_MapFactory().from__sc_IterableOnce__O(new $c_sc_View$Collect($thiz, pf));
}
export { $f_sc_MapOps__collect__s_PartialFunction__sc_IterableOps as $f_sc_MapOps__collect__s_PartialFunction__sc_IterableOps };
function $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  return $thiz.mapFactory__sc_MapFactory().from__sc_IterableOnce__O(($is_sc_Iterable(suffix) ? new $c_sc_View$Concat($thiz, suffix) : $thiz.iterator__sc_Iterator().concat__F0__sc_Iterator(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => suffix.iterator__sc_Iterator())))));
}
export { $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps as $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps };
function $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder($thiz, sb, start, sep, end) {
  var this$1 = $thiz.iterator__sc_Iterator();
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x0$1$2$2) => {
    if ((x0$1$2$2 !== null)) {
      var k = x0$1$2$2._1__O();
      var v = x0$1$2$2._2__O();
      return ((k + " -> ") + v);
    } else {
      throw new $c_s_MatchError(x0$1$2$2);
    }
  }));
  var this$2 = new $c_sc_Iterator$$anon$9(this$1, f);
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this$2, sb, start, sep, end);
}
export { $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder as $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder };
function $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  var builder = $thiz.newSpecificBuilder__scm_Builder();
  var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var next = it.next__O();
    if (seen.add__O__Z(f.apply__O__O(next))) {
      builder.addOne__O__scm_Growable(next);
    }
  }
  return builder.result__O();
}
export { $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O as $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O };
function $f_sc_StrictOptimizedSeqOps__prepended__O__O($thiz, elem) {
  var b = $thiz.iterableFactory__sc_SeqFactory().newBuilder__scm_Builder();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, $thiz, 1);
  b.addOne__O__scm_Growable(elem);
  b.addAll__sc_IterableOnce__scm_Growable($thiz);
  return b.result__O();
}
export { $f_sc_StrictOptimizedSeqOps__prepended__O__O as $f_sc_StrictOptimizedSeqOps__prepended__O__O };
function $f_sc_StrictOptimizedSeqOps__appended__O__O($thiz, elem) {
  var b = $thiz.iterableFactory__sc_SeqFactory().newBuilder__scm_Builder();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, $thiz, 1);
  b.addAll__sc_IterableOnce__scm_Growable($thiz);
  b.addOne__O__scm_Growable(elem);
  return b.result__O();
}
export { $f_sc_StrictOptimizedSeqOps__appended__O__O as $f_sc_StrictOptimizedSeqOps__appended__O__O };
function $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O($thiz, suffix) {
  var b = $thiz.iterableFactory__sc_SeqFactory().newBuilder__scm_Builder();
  b.addAll__sc_IterableOnce__scm_Growable($thiz);
  b.addAll__sc_IterableOnce__scm_Growable(suffix);
  return b.result__O();
}
export { $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O as $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O };
function $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O($thiz, that) {
  if (($thiz.isEmpty__Z() || that.isEmpty__Z())) {
    return $thiz;
  } else {
    var occ = $f_sc_SeqOps__occCounts__sc_Seq__scm_Map($thiz, that);
    var b = $thiz.newSpecificBuilder__scm_Builder();
    $thiz.foreach__F1__V(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => occ.updateWith__O__F1__s_Option(x$2$2, new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x0$1$2$2) => {
      var rc8 = false;
      var x3 = null;
      var x$2 = $m_s_None$();
      if ((x$2 === x0$1$2$2)) {
        b.addOne__O__scm_Growable(x$2$2);
        return $m_s_None$();
      }
      if ((x0$1$2$2 instanceof $c_s_Some)) {
        rc8 = true;
        x3 = x0$1$2$2;
        var p4 = (x3.s_Some__f_value | 0);
        if ((p4 === 1)) {
          return $m_s_None$();
        }
      }
      if (rc8) {
        var n = (x3.s_Some__f_value | 0);
        return new $c_s_Some((((-1) + n) | 0));
      }
      throw new $c_s_MatchError(x0$1$2$2);
    }))))));
    return b.result__O();
  }
}
export { $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O as $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O };
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying = null;
  this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying = underlying;
}
export { $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper as $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper };
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype = new $h_sc_AbstractIterator();
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JIteratorWrapper() {
}
export { $h_sc_convert_JavaCollectionWrappers$JIteratorWrapper as $h_sc_convert_JavaCollectionWrappers$JIteratorWrapper };
$h_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.hasNext__Z = (function() {
  return this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying.hasNext__Z();
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.next__O = (function() {
  return this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying.next__O();
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sc_convert_JavaCollectionWrappers$JIteratorWrapper)) {
    var x = this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying;
    var x$2 = other.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_sc_convert_JavaCollectionWrappers$JIteratorWrapper.prototype.hashCode__I = (function() {
  var this$1 = this.sc_convert_JavaCollectionWrappers$JIteratorWrapper__f_underlying;
  return $systemIdentityHashCode(this$1);
});
function $isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$JIteratorWrapper)));
}
export { $isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper as $isArrayOf_sc_convert_JavaCollectionWrappers$JIteratorWrapper };
var $d_sc_convert_JavaCollectionWrappers$JIteratorWrapper = new $TypeData().initClass($c_sc_convert_JavaCollectionWrappers$JIteratorWrapper, "scala.collection.convert.JavaCollectionWrappers$JIteratorWrapper", ({
  sc_convert_JavaCollectionWrappers$JIteratorWrapper: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_convert_JavaCollectionWrappers$JIteratorWrapper as $d_sc_convert_JavaCollectionWrappers$JIteratorWrapper };
function $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) {
  if ((!$thiz.sci_ArraySeq$__f_bitmap$0)) {
    $thiz.sci_ArraySeq$__f_emptyImpl = new $c_sci_ArraySeq$ofRef(new $ac_O(0));
    $thiz.sci_ArraySeq$__f_bitmap$0 = true;
  }
  return $thiz.sci_ArraySeq$__f_emptyImpl;
}
export { $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef as $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef };
function $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef($thiz) {
  return ((!$thiz.sci_ArraySeq$__f_bitmap$0) ? $p_sci_ArraySeq$__emptyImpl$lzycompute__sci_ArraySeq$ofRef($thiz) : $thiz.sci_ArraySeq$__f_emptyImpl);
}
export { $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef as $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef };
/** @constructor */
function $c_sci_ArraySeq$() {
  this.sci_ArraySeq$__f_emptyImpl = null;
  this.sci_ArraySeq$__f_untagged = null;
  this.sci_ArraySeq$__f_bitmap$0 = false;
  $n_sci_ArraySeq$ = this;
  this.sci_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
}
export { $c_sci_ArraySeq$ as $c_sci_ArraySeq$ };
$c_sci_ArraySeq$.prototype = new $h_O();
$c_sci_ArraySeq$.prototype.constructor = $c_sci_ArraySeq$;
/** @constructor */
function $h_sci_ArraySeq$() {
}
export { $h_sci_ArraySeq$ as $h_sci_ArraySeq$ };
$h_sci_ArraySeq$.prototype = $c_sci_ArraySeq$.prototype;
$c_sci_ArraySeq$.prototype.apply__sci_Seq__O__O = (function(xs, evidence$7) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(xs, evidence$7);
});
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq = (function(it, tag) {
  return ((it instanceof $c_sci_ArraySeq) ? it : this.unsafeWrapArray__O__sci_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, tag)));
});
$c_sci_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$2) {
  $m_scm_ArrayBuffer$();
  var this$2 = new $c_scm_ArrayBuffer$$anon$1();
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((b$2$2) => $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(b$2$2, evidence$2))));
  return new $c_scm_Builder$$anon$1(this$2, f);
});
$c_sci_ArraySeq$.prototype.unsafeWrapArray__O__sci_ArraySeq = (function(x) {
  if ((x === null)) {
    return null;
  } else if ((x instanceof $ac_O)) {
    return new $c_sci_ArraySeq$ofRef(x);
  } else if ((x instanceof $ac_I)) {
    return new $c_sci_ArraySeq$ofInt(x);
  } else if ((x instanceof $ac_D)) {
    return new $c_sci_ArraySeq$ofDouble(x);
  } else if ((x instanceof $ac_J)) {
    return new $c_sci_ArraySeq$ofLong(x);
  } else if ((x instanceof $ac_F)) {
    return new $c_sci_ArraySeq$ofFloat(x);
  } else if ((x instanceof $ac_C)) {
    return new $c_sci_ArraySeq$ofChar(x);
  } else if ((x instanceof $ac_B)) {
    return new $c_sci_ArraySeq$ofByte(x);
  } else if ((x instanceof $ac_S)) {
    return new $c_sci_ArraySeq$ofShort(x);
  } else if ((x instanceof $ac_Z)) {
    return new $c_sci_ArraySeq$ofBoolean(x);
  } else if ($isArrayOf_jl_Void(x, 1)) {
    return new $c_sci_ArraySeq$ofUnit(x);
  } else {
    throw new $c_s_MatchError(x);
  }
});
$c_sci_ArraySeq$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  return this.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12);
});
$c_sci_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(it, evidence$5);
});
$c_sci_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  return $p_sci_ArraySeq$__emptyImpl__sci_ArraySeq$ofRef(this);
});
var $d_sci_ArraySeq$ = new $TypeData().initClass($c_sci_ArraySeq$, "scala.collection.immutable.ArraySeq$", ({
  sci_ArraySeq$: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ArraySeq$ as $d_sci_ArraySeq$ };
var $n_sci_ArraySeq$;
function $m_sci_ArraySeq$() {
  if ((!$n_sci_ArraySeq$)) {
    $n_sci_ArraySeq$ = new $c_sci_ArraySeq$();
  }
  return $n_sci_ArraySeq$;
}
export { $m_sci_ArraySeq$ as $m_sci_ArraySeq$ };
/** @constructor */
function $c_sci_HashMapBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, x2$1.sci_HashMap__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    outer.update__sci_MapNode__O__O__I__I__I__V(outer.sci_HashMapBuilder__f_scala$collection$immutable$HashMapBuilder$$rootNode, this.sci_ChampBaseIterator__f_currentValueNode.getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), this.sci_ChampBaseIterator__f_currentValueNode.getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  }
}
export { $c_sci_HashMapBuilder$$anon$1 as $c_sci_HashMapBuilder$$anon$1 };
$c_sci_HashMapBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashMapBuilder$$anon$1.prototype.constructor = $c_sci_HashMapBuilder$$anon$1;
/** @constructor */
function $h_sci_HashMapBuilder$$anon$1() {
}
export { $h_sci_HashMapBuilder$$anon$1 as $h_sci_HashMapBuilder$$anon$1 };
$h_sci_HashMapBuilder$$anon$1.prototype = $c_sci_HashMapBuilder$$anon$1.prototype;
$c_sci_HashMapBuilder$$anon$1.prototype.next__E = (function() {
  $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  throw new $c_jl_ClassCastException();
});
$c_sci_HashMapBuilder$$anon$1.prototype.next__O = (function() {
  this.next__E();
});
var $d_sci_HashMapBuilder$$anon$1 = new $TypeData().initClass($c_sci_HashMapBuilder$$anon$1, "scala.collection.immutable.HashMapBuilder$$anon$1", ({
  sci_HashMapBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_HashMapBuilder$$anon$1 as $d_sci_HashMapBuilder$$anon$1 };
/** @constructor */
function $c_sci_HashSetBuilder$$anon$1(outer, x2$1) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, x2$1.sci_HashSet__f_rootNode);
  while (this.hasNext__Z()) {
    var originalHash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    outer.update__sci_SetNode__O__I__I__I__V(outer.sci_HashSetBuilder__f_scala$collection$immutable$HashSetBuilder$$rootNode, this.sci_ChampBaseIterator__f_currentValueNode.getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor), originalHash, $m_sc_Hashing$().improve__I__I(originalHash), 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  }
}
export { $c_sci_HashSetBuilder$$anon$1 as $c_sci_HashSetBuilder$$anon$1 };
$c_sci_HashSetBuilder$$anon$1.prototype = new $h_sci_ChampBaseIterator();
$c_sci_HashSetBuilder$$anon$1.prototype.constructor = $c_sci_HashSetBuilder$$anon$1;
/** @constructor */
function $h_sci_HashSetBuilder$$anon$1() {
}
export { $h_sci_HashSetBuilder$$anon$1 as $h_sci_HashSetBuilder$$anon$1 };
$h_sci_HashSetBuilder$$anon$1.prototype = $c_sci_HashSetBuilder$$anon$1.prototype;
$c_sci_HashSetBuilder$$anon$1.prototype.next__E = (function() {
  $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  throw new $c_jl_ClassCastException();
});
$c_sci_HashSetBuilder$$anon$1.prototype.next__O = (function() {
  this.next__E();
});
var $d_sci_HashSetBuilder$$anon$1 = new $TypeData().initClass($c_sci_HashSetBuilder$$anon$1, "scala.collection.immutable.HashSetBuilder$$anon$1", ({
  sci_HashSetBuilder$$anon$1: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_HashSetBuilder$$anon$1 as $d_sci_HashSetBuilder$$anon$1 };
function $is_sci_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Iterable)));
}
export { $is_sci_Iterable as $is_sci_Iterable };
function $isArrayOf_sci_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Iterable)));
}
export { $isArrayOf_sci_Iterable as $isArrayOf_sci_Iterable };
/** @constructor */
function $c_sci_Map$Map2$$anon$1(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
export { $c_sci_Map$Map2$$anon$1 as $c_sci_Map$Map2$$anon$1 };
$c_sci_Map$Map2$$anon$1.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$1.prototype.constructor = $c_sci_Map$Map2$$anon$1;
/** @constructor */
function $h_sci_Map$Map2$$anon$1() {
}
export { $h_sci_Map$Map2$$anon$1 as $h_sci_Map$Map2$$anon$1 };
$h_sci_Map$Map2$$anon$1.prototype = $c_sci_Map$Map2$$anon$1.prototype;
$c_sci_Map$Map2$$anon$1.prototype.nextResult__O__O__O = (function(k, v) {
  return $ct_T2__O__O__(new $c_T2(), k, v);
});
var $d_sci_Map$Map2$$anon$1 = new $TypeData().initClass($c_sci_Map$Map2$$anon$1, "scala.collection.immutable.Map$Map2$$anon$1", ({
  sci_Map$Map2$$anon$1: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_Map$Map2$$anon$1 as $d_sci_Map$Map2$$anon$1 };
/** @constructor */
function $c_sci_Map$Map2$$anon$2(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
export { $c_sci_Map$Map2$$anon$2 as $c_sci_Map$Map2$$anon$2 };
$c_sci_Map$Map2$$anon$2.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$2.prototype.constructor = $c_sci_Map$Map2$$anon$2;
/** @constructor */
function $h_sci_Map$Map2$$anon$2() {
}
export { $h_sci_Map$Map2$$anon$2 as $h_sci_Map$Map2$$anon$2 };
$h_sci_Map$Map2$$anon$2.prototype = $c_sci_Map$Map2$$anon$2.prototype;
$c_sci_Map$Map2$$anon$2.prototype.nextResult__O__O__O = (function(k, v) {
  return k;
});
var $d_sci_Map$Map2$$anon$2 = new $TypeData().initClass($c_sci_Map$Map2$$anon$2, "scala.collection.immutable.Map$Map2$$anon$2", ({
  sci_Map$Map2$$anon$2: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_Map$Map2$$anon$2 as $d_sci_Map$Map2$$anon$2 };
/** @constructor */
function $c_sci_Map$Map2$$anon$3(outer) {
  this.sci_Map$Map2$Map2Iterator__f_i = 0;
  this.sci_Map$Map2$Map2Iterator__f_$outer = null;
  $ct_sci_Map$Map2$Map2Iterator__sci_Map$Map2__(this, outer);
}
export { $c_sci_Map$Map2$$anon$3 as $c_sci_Map$Map2$$anon$3 };
$c_sci_Map$Map2$$anon$3.prototype = new $h_sci_Map$Map2$Map2Iterator();
$c_sci_Map$Map2$$anon$3.prototype.constructor = $c_sci_Map$Map2$$anon$3;
/** @constructor */
function $h_sci_Map$Map2$$anon$3() {
}
export { $h_sci_Map$Map2$$anon$3 as $h_sci_Map$Map2$$anon$3 };
$h_sci_Map$Map2$$anon$3.prototype = $c_sci_Map$Map2$$anon$3.prototype;
$c_sci_Map$Map2$$anon$3.prototype.nextResult__O__O__O = (function(k, v) {
  return v;
});
var $d_sci_Map$Map2$$anon$3 = new $TypeData().initClass($c_sci_Map$Map2$$anon$3, "scala.collection.immutable.Map$Map2$$anon$3", ({
  sci_Map$Map2$$anon$3: 1,
  sci_Map$Map2$Map2Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_Map$Map2$$anon$3 as $d_sci_Map$Map2$$anon$3 };
/** @constructor */
function $c_sci_Map$Map3$$anon$4(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
export { $c_sci_Map$Map3$$anon$4 as $c_sci_Map$Map3$$anon$4 };
$c_sci_Map$Map3$$anon$4.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$4.prototype.constructor = $c_sci_Map$Map3$$anon$4;
/** @constructor */
function $h_sci_Map$Map3$$anon$4() {
}
export { $h_sci_Map$Map3$$anon$4 as $h_sci_Map$Map3$$anon$4 };
$h_sci_Map$Map3$$anon$4.prototype = $c_sci_Map$Map3$$anon$4.prototype;
$c_sci_Map$Map3$$anon$4.prototype.nextResult__O__O__O = (function(k, v) {
  return $ct_T2__O__O__(new $c_T2(), k, v);
});
var $d_sci_Map$Map3$$anon$4 = new $TypeData().initClass($c_sci_Map$Map3$$anon$4, "scala.collection.immutable.Map$Map3$$anon$4", ({
  sci_Map$Map3$$anon$4: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_Map$Map3$$anon$4 as $d_sci_Map$Map3$$anon$4 };
/** @constructor */
function $c_sci_Map$Map3$$anon$5(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
export { $c_sci_Map$Map3$$anon$5 as $c_sci_Map$Map3$$anon$5 };
$c_sci_Map$Map3$$anon$5.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$5.prototype.constructor = $c_sci_Map$Map3$$anon$5;
/** @constructor */
function $h_sci_Map$Map3$$anon$5() {
}
export { $h_sci_Map$Map3$$anon$5 as $h_sci_Map$Map3$$anon$5 };
$h_sci_Map$Map3$$anon$5.prototype = $c_sci_Map$Map3$$anon$5.prototype;
$c_sci_Map$Map3$$anon$5.prototype.nextResult__O__O__O = (function(k, v) {
  return k;
});
var $d_sci_Map$Map3$$anon$5 = new $TypeData().initClass($c_sci_Map$Map3$$anon$5, "scala.collection.immutable.Map$Map3$$anon$5", ({
  sci_Map$Map3$$anon$5: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_Map$Map3$$anon$5 as $d_sci_Map$Map3$$anon$5 };
/** @constructor */
function $c_sci_Map$Map3$$anon$6(outer) {
  this.sci_Map$Map3$Map3Iterator__f_i = 0;
  this.sci_Map$Map3$Map3Iterator__f_$outer = null;
  $ct_sci_Map$Map3$Map3Iterator__sci_Map$Map3__(this, outer);
}
export { $c_sci_Map$Map3$$anon$6 as $c_sci_Map$Map3$$anon$6 };
$c_sci_Map$Map3$$anon$6.prototype = new $h_sci_Map$Map3$Map3Iterator();
$c_sci_Map$Map3$$anon$6.prototype.constructor = $c_sci_Map$Map3$$anon$6;
/** @constructor */
function $h_sci_Map$Map3$$anon$6() {
}
export { $h_sci_Map$Map3$$anon$6 as $h_sci_Map$Map3$$anon$6 };
$h_sci_Map$Map3$$anon$6.prototype = $c_sci_Map$Map3$$anon$6.prototype;
$c_sci_Map$Map3$$anon$6.prototype.nextResult__O__O__O = (function(k, v) {
  return v;
});
var $d_sci_Map$Map3$$anon$6 = new $TypeData().initClass($c_sci_Map$Map3$$anon$6, "scala.collection.immutable.Map$Map3$$anon$6", ({
  sci_Map$Map3$$anon$6: 1,
  sci_Map$Map3$Map3Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_Map$Map3$$anon$6 as $d_sci_Map$Map3$$anon$6 };
/** @constructor */
function $c_sci_Map$Map4$$anon$7(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
export { $c_sci_Map$Map4$$anon$7 as $c_sci_Map$Map4$$anon$7 };
$c_sci_Map$Map4$$anon$7.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$7.prototype.constructor = $c_sci_Map$Map4$$anon$7;
/** @constructor */
function $h_sci_Map$Map4$$anon$7() {
}
export { $h_sci_Map$Map4$$anon$7 as $h_sci_Map$Map4$$anon$7 };
$h_sci_Map$Map4$$anon$7.prototype = $c_sci_Map$Map4$$anon$7.prototype;
$c_sci_Map$Map4$$anon$7.prototype.nextResult__O__O__O = (function(k, v) {
  return $ct_T2__O__O__(new $c_T2(), k, v);
});
var $d_sci_Map$Map4$$anon$7 = new $TypeData().initClass($c_sci_Map$Map4$$anon$7, "scala.collection.immutable.Map$Map4$$anon$7", ({
  sci_Map$Map4$$anon$7: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_Map$Map4$$anon$7 as $d_sci_Map$Map4$$anon$7 };
/** @constructor */
function $c_sci_Map$Map4$$anon$8(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
export { $c_sci_Map$Map4$$anon$8 as $c_sci_Map$Map4$$anon$8 };
$c_sci_Map$Map4$$anon$8.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$8.prototype.constructor = $c_sci_Map$Map4$$anon$8;
/** @constructor */
function $h_sci_Map$Map4$$anon$8() {
}
export { $h_sci_Map$Map4$$anon$8 as $h_sci_Map$Map4$$anon$8 };
$h_sci_Map$Map4$$anon$8.prototype = $c_sci_Map$Map4$$anon$8.prototype;
$c_sci_Map$Map4$$anon$8.prototype.nextResult__O__O__O = (function(k, v) {
  return k;
});
var $d_sci_Map$Map4$$anon$8 = new $TypeData().initClass($c_sci_Map$Map4$$anon$8, "scala.collection.immutable.Map$Map4$$anon$8", ({
  sci_Map$Map4$$anon$8: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_Map$Map4$$anon$8 as $d_sci_Map$Map4$$anon$8 };
/** @constructor */
function $c_sci_Map$Map4$$anon$9(outer) {
  this.sci_Map$Map4$Map4Iterator__f_i = 0;
  this.sci_Map$Map4$Map4Iterator__f_$outer = null;
  $ct_sci_Map$Map4$Map4Iterator__sci_Map$Map4__(this, outer);
}
export { $c_sci_Map$Map4$$anon$9 as $c_sci_Map$Map4$$anon$9 };
$c_sci_Map$Map4$$anon$9.prototype = new $h_sci_Map$Map4$Map4Iterator();
$c_sci_Map$Map4$$anon$9.prototype.constructor = $c_sci_Map$Map4$$anon$9;
/** @constructor */
function $h_sci_Map$Map4$$anon$9() {
}
export { $h_sci_Map$Map4$$anon$9 as $h_sci_Map$Map4$$anon$9 };
$h_sci_Map$Map4$$anon$9.prototype = $c_sci_Map$Map4$$anon$9.prototype;
$c_sci_Map$Map4$$anon$9.prototype.nextResult__O__O__O = (function(k, v) {
  return v;
});
var $d_sci_Map$Map4$$anon$9 = new $TypeData().initClass($c_sci_Map$Map4$$anon$9, "scala.collection.immutable.Map$Map4$$anon$9", ({
  sci_Map$Map4$$anon$9: 1,
  sci_Map$Map4$Map4Iterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_Map$Map4$$anon$9 as $d_sci_Map$Map4$$anon$9 };
/** @constructor */
function $c_sci_MapKeyIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
export { $c_sci_MapKeyIterator as $c_sci_MapKeyIterator };
$c_sci_MapKeyIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyIterator.prototype.constructor = $c_sci_MapKeyIterator;
/** @constructor */
function $h_sci_MapKeyIterator() {
}
export { $h_sci_MapKeyIterator as $h_sci_MapKeyIterator };
$h_sci_MapKeyIterator.prototype = $c_sci_MapKeyIterator.prototype;
$c_sci_MapKeyIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var key = this.sci_ChampBaseIterator__f_currentValueNode.getKey__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return key;
});
var $d_sci_MapKeyIterator = new $TypeData().initClass($c_sci_MapKeyIterator, "scala.collection.immutable.MapKeyIterator", ({
  sci_MapKeyIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_MapKeyIterator as $d_sci_MapKeyIterator };
/** @constructor */
function $c_sci_MapKeyValueTupleHashIterator(rootNode) {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0;
  this.sci_MapKeyValueTupleHashIterator__f_value = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
  this.sci_MapKeyValueTupleHashIterator__f_hash = 0;
}
export { $c_sci_MapKeyValueTupleHashIterator as $c_sci_MapKeyValueTupleHashIterator };
$c_sci_MapKeyValueTupleHashIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$c_sci_MapKeyValueTupleHashIterator.prototype.constructor = $c_sci_MapKeyValueTupleHashIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleHashIterator() {
}
export { $h_sci_MapKeyValueTupleHashIterator as $h_sci_MapKeyValueTupleHashIterator };
$h_sci_MapKeyValueTupleHashIterator.prototype = $c_sci_MapKeyValueTupleHashIterator.prototype;
$c_sci_MapKeyValueTupleHashIterator.prototype.hashCode__I = (function() {
  var $x_2 = $m_s_util_hashing_MurmurHash3$();
  var $x_1 = this.sci_MapKeyValueTupleHashIterator__f_hash;
  var x = this.sci_MapKeyValueTupleHashIterator__f_value;
  return $x_2.tuple2Hash__I__I__I__I($x_1, $m_sr_Statics$().anyHash__O__I(x), (-889275714));
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__sci_MapKeyValueTupleHashIterator = (function() {
  if ((!this.hasNext__Z())) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  this.sci_MapKeyValueTupleHashIterator__f_hash = this.sci_ChampBaseReverseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_MapKeyValueTupleHashIterator__f_value = this.sci_ChampBaseReverseIterator__f_currentValueNode.getValue__I__O(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + this.sci_ChampBaseReverseIterator__f_currentValueCursor) | 0);
  return this;
});
$c_sci_MapKeyValueTupleHashIterator.prototype.next__O = (function() {
  return this.next__sci_MapKeyValueTupleHashIterator();
});
var $d_sci_MapKeyValueTupleHashIterator = new $TypeData().initClass($c_sci_MapKeyValueTupleHashIterator, "scala.collection.immutable.MapKeyValueTupleHashIterator", ({
  sci_MapKeyValueTupleHashIterator: 1,
  sci_ChampBaseReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_MapKeyValueTupleHashIterator as $d_sci_MapKeyValueTupleHashIterator };
/** @constructor */
function $c_sci_MapKeyValueTupleIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
export { $c_sci_MapKeyValueTupleIterator as $c_sci_MapKeyValueTupleIterator };
$c_sci_MapKeyValueTupleIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapKeyValueTupleIterator.prototype.constructor = $c_sci_MapKeyValueTupleIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleIterator() {
}
export { $h_sci_MapKeyValueTupleIterator as $h_sci_MapKeyValueTupleIterator };
$h_sci_MapKeyValueTupleIterator.prototype = $c_sci_MapKeyValueTupleIterator.prototype;
$c_sci_MapKeyValueTupleIterator.prototype.next__T2 = (function() {
  if ((!this.hasNext__Z())) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var payload = this.sci_ChampBaseIterator__f_currentValueNode.getPayload__I__T2(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload;
});
$c_sci_MapKeyValueTupleIterator.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sci_MapKeyValueTupleIterator = new $TypeData().initClass($c_sci_MapKeyValueTupleIterator, "scala.collection.immutable.MapKeyValueTupleIterator", ({
  sci_MapKeyValueTupleIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_MapKeyValueTupleIterator as $d_sci_MapKeyValueTupleIterator };
/** @constructor */
function $c_sci_MapKeyValueTupleReverseIterator(rootNode) {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
}
export { $c_sci_MapKeyValueTupleReverseIterator as $c_sci_MapKeyValueTupleReverseIterator };
$c_sci_MapKeyValueTupleReverseIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$c_sci_MapKeyValueTupleReverseIterator.prototype.constructor = $c_sci_MapKeyValueTupleReverseIterator;
/** @constructor */
function $h_sci_MapKeyValueTupleReverseIterator() {
}
export { $h_sci_MapKeyValueTupleReverseIterator as $h_sci_MapKeyValueTupleReverseIterator };
$h_sci_MapKeyValueTupleReverseIterator.prototype = $c_sci_MapKeyValueTupleReverseIterator.prototype;
$c_sci_MapKeyValueTupleReverseIterator.prototype.next__T2 = (function() {
  if ((!this.hasNext__Z())) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var payload = this.sci_ChampBaseReverseIterator__f_currentValueNode.getPayload__I__T2(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + this.sci_ChampBaseReverseIterator__f_currentValueCursor) | 0);
  return payload;
});
$c_sci_MapKeyValueTupleReverseIterator.prototype.next__O = (function() {
  return this.next__T2();
});
var $d_sci_MapKeyValueTupleReverseIterator = new $TypeData().initClass($c_sci_MapKeyValueTupleReverseIterator, "scala.collection.immutable.MapKeyValueTupleReverseIterator", ({
  sci_MapKeyValueTupleReverseIterator: 1,
  sci_ChampBaseReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_MapKeyValueTupleReverseIterator as $d_sci_MapKeyValueTupleReverseIterator };
/** @constructor */
function $c_sci_MapNodeRemoveAllSetNodeIterator(rootSetNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootSetNode);
}
export { $c_sci_MapNodeRemoveAllSetNodeIterator as $c_sci_MapNodeRemoveAllSetNodeIterator };
$c_sci_MapNodeRemoveAllSetNodeIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapNodeRemoveAllSetNodeIterator.prototype.constructor = $c_sci_MapNodeRemoveAllSetNodeIterator;
/** @constructor */
function $h_sci_MapNodeRemoveAllSetNodeIterator() {
}
export { $h_sci_MapNodeRemoveAllSetNodeIterator as $h_sci_MapNodeRemoveAllSetNodeIterator };
$h_sci_MapNodeRemoveAllSetNodeIterator.prototype = $c_sci_MapNodeRemoveAllSetNodeIterator.prototype;
$c_sci_MapNodeRemoveAllSetNodeIterator.prototype.removeAll__sci_BitmapIndexedMapNode__sci_BitmapIndexedMapNode = (function(rootMapNode) {
  var curr = rootMapNode;
  while (((curr.sci_BitmapIndexedMapNode__f_size > 0) && this.hasNext__Z())) {
    var originalHash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
    var qual$1 = curr;
    var x$1 = this.sci_ChampBaseIterator__f_currentValueNode.getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
    var x$2 = $m_sc_Hashing$().improve__I__I(originalHash);
    curr = qual$1.removed__O__I__I__I__sci_BitmapIndexedMapNode(x$1, originalHash, x$2, 0);
    this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  }
  return curr;
});
$c_sci_MapNodeRemoveAllSetNodeIterator.prototype.next__O = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
});
var $d_sci_MapNodeRemoveAllSetNodeIterator = new $TypeData().initClass($c_sci_MapNodeRemoveAllSetNodeIterator, "scala.collection.immutable.MapNodeRemoveAllSetNodeIterator", ({
  sci_MapNodeRemoveAllSetNodeIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_MapNodeRemoveAllSetNodeIterator as $d_sci_MapNodeRemoveAllSetNodeIterator };
/** @constructor */
function $c_sci_MapValueIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
export { $c_sci_MapValueIterator as $c_sci_MapValueIterator };
$c_sci_MapValueIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_MapValueIterator.prototype.constructor = $c_sci_MapValueIterator;
/** @constructor */
function $h_sci_MapValueIterator() {
}
export { $h_sci_MapValueIterator as $h_sci_MapValueIterator };
$h_sci_MapValueIterator.prototype = $c_sci_MapValueIterator.prototype;
$c_sci_MapValueIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var value = this.sci_ChampBaseIterator__f_currentValueNode.getValue__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return value;
});
var $d_sci_MapValueIterator = new $TypeData().initClass($c_sci_MapValueIterator, "scala.collection.immutable.MapValueIterator", ({
  sci_MapValueIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_MapValueIterator as $d_sci_MapValueIterator };
function $p_sci_NewVectorIterator__advanceSlice__V($thiz) {
  if (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 <= $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
  var slice = $thiz.sci_NewVectorIterator__f_v.vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx);
  while ((slice.u.length === 0)) {
    $thiz.sci_NewVectorIterator__f_sliceIdx = ((1 + $thiz.sci_NewVectorIterator__f_sliceIdx) | 0);
    slice = $thiz.sci_NewVectorIterator__f_v.vectorSlice__I__AO($thiz.sci_NewVectorIterator__f_sliceIdx);
  }
  $thiz.sci_NewVectorIterator__f_sliceStart = $thiz.sci_NewVectorIterator__f_sliceEnd;
  var count = $thiz.sci_NewVectorIterator__f_sliceCount;
  var idx = $thiz.sci_NewVectorIterator__f_sliceIdx;
  var c = ((count / 2) | 0);
  var a = ((idx - c) | 0);
  var sign = (a >> 31);
  $thiz.sci_NewVectorIterator__f_sliceDim = ((((1 + c) | 0) - (((a ^ sign) - sign) | 0)) | 0);
  var x1 = $thiz.sci_NewVectorIterator__f_sliceDim;
  switch (x1) {
    case 1: {
      $thiz.sci_NewVectorIterator__f_a1 = slice;
      break;
    }
    case 2: {
      $thiz.sci_NewVectorIterator__f_a2 = slice;
      break;
    }
    case 3: {
      $thiz.sci_NewVectorIterator__f_a3 = slice;
      break;
    }
    case 4: {
      $thiz.sci_NewVectorIterator__f_a4 = slice;
      break;
    }
    case 5: {
      $thiz.sci_NewVectorIterator__f_a5 = slice;
      break;
    }
    case 6: {
      $thiz.sci_NewVectorIterator__f_a6 = slice;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
  $thiz.sci_NewVectorIterator__f_sliceEnd = (($thiz.sci_NewVectorIterator__f_sliceStart + Math.imul(slice.u.length, (1 << Math.imul(5, (((-1) + $thiz.sci_NewVectorIterator__f_sliceDim) | 0))))) | 0);
  if (($thiz.sci_NewVectorIterator__f_sliceEnd > $thiz.sci_NewVectorIterator__f_totalLength)) {
    $thiz.sci_NewVectorIterator__f_sliceEnd = $thiz.sci_NewVectorIterator__f_totalLength;
  }
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    $thiz.sci_NewVectorIterator__f_oldPos = (((-1) + (1 << Math.imul(5, $thiz.sci_NewVectorIterator__f_sliceDim))) | 0);
  }
}
export { $p_sci_NewVectorIterator__advanceSlice__V as $p_sci_NewVectorIterator__advanceSlice__V };
function $p_sci_NewVectorIterator__advance__V($thiz) {
  var pos = (((($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + $thiz.sci_NewVectorIterator__f_totalLength) | 0);
  if ((pos === $thiz.sci_NewVectorIterator__f_sliceEnd)) {
    $p_sci_NewVectorIterator__advanceSlice__V($thiz);
  }
  if (($thiz.sci_NewVectorIterator__f_sliceDim > 1)) {
    var io = ((pos - $thiz.sci_NewVectorIterator__f_sliceStart) | 0);
    var xor = ($thiz.sci_NewVectorIterator__f_oldPos ^ io);
    $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor);
    $thiz.sci_NewVectorIterator__f_oldPos = io;
  }
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = (($thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var a = $thiz.sci_NewVectorIterator__f_a1.u.length;
  var b = $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
  $thiz.sci_NewVectorIterator__f_a1len = ((a < b) ? a : b);
  $thiz.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
}
export { $p_sci_NewVectorIterator__advance__V as $p_sci_NewVectorIterator__advance__V };
function $p_sci_NewVectorIterator__advanceA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.u[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.u[(31 & ((io >>> 10) | 0))];
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.u[0];
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.u[(31 & ((io >>> 15) | 0))];
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.u[0];
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.u[0];
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.u[(31 & ((io >>> 20) | 0))];
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.u[0];
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.u[0];
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.u[0];
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $thiz.sci_NewVectorIterator__f_a6.u[((io >>> 25) | 0)];
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.u[0];
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.u[0];
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.u[0];
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.u[0];
  }
}
export { $p_sci_NewVectorIterator__advanceA__I__I__V as $p_sci_NewVectorIterator__advanceA__I__I__V };
function $p_sci_NewVectorIterator__setA__I__I__V($thiz, io, xor) {
  if ((xor < 1024)) {
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.u[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 32768)) {
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.u[(31 & ((io >>> 10) | 0))];
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.u[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 1048576)) {
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.u[(31 & ((io >>> 15) | 0))];
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.u[(31 & ((io >>> 10) | 0))];
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.u[(31 & ((io >>> 5) | 0))];
  } else if ((xor < 33554432)) {
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.u[(31 & ((io >>> 20) | 0))];
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.u[(31 & ((io >>> 15) | 0))];
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.u[(31 & ((io >>> 10) | 0))];
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.u[(31 & ((io >>> 5) | 0))];
  } else {
    $thiz.sci_NewVectorIterator__f_a5 = $thiz.sci_NewVectorIterator__f_a6.u[((io >>> 25) | 0)];
    $thiz.sci_NewVectorIterator__f_a4 = $thiz.sci_NewVectorIterator__f_a5.u[(31 & ((io >>> 20) | 0))];
    $thiz.sci_NewVectorIterator__f_a3 = $thiz.sci_NewVectorIterator__f_a4.u[(31 & ((io >>> 15) | 0))];
    $thiz.sci_NewVectorIterator__f_a2 = $thiz.sci_NewVectorIterator__f_a3.u[(31 & ((io >>> 10) | 0))];
    $thiz.sci_NewVectorIterator__f_a1 = $thiz.sci_NewVectorIterator__f_a2.u[(31 & ((io >>> 5) | 0))];
  }
}
export { $p_sci_NewVectorIterator__setA__I__I__V as $p_sci_NewVectorIterator__setA__I__I__V };
/** @constructor */
function $c_sci_NewVectorIterator(v, totalLength, sliceCount) {
  this.sci_NewVectorIterator__f_v = null;
  this.sci_NewVectorIterator__f_totalLength = 0;
  this.sci_NewVectorIterator__f_sliceCount = 0;
  this.sci_NewVectorIterator__f_a1 = null;
  this.sci_NewVectorIterator__f_a2 = null;
  this.sci_NewVectorIterator__f_a3 = null;
  this.sci_NewVectorIterator__f_a4 = null;
  this.sci_NewVectorIterator__f_a5 = null;
  this.sci_NewVectorIterator__f_a6 = null;
  this.sci_NewVectorIterator__f_a1len = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 0;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = 0;
  this.sci_NewVectorIterator__f_v = v;
  this.sci_NewVectorIterator__f_totalLength = totalLength;
  this.sci_NewVectorIterator__f_sliceCount = sliceCount;
  this.sci_NewVectorIterator__f_a1 = v.sci_Vector__f_prefix1;
  this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_a1.u.length;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
  this.sci_NewVectorIterator__f_oldPos = 0;
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = this.sci_NewVectorIterator__f_totalLength;
  this.sci_NewVectorIterator__f_sliceIdx = 0;
  this.sci_NewVectorIterator__f_sliceDim = 1;
  this.sci_NewVectorIterator__f_sliceStart = 0;
  this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_a1len;
}
export { $c_sci_NewVectorIterator as $c_sci_NewVectorIterator };
$c_sci_NewVectorIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_NewVectorIterator.prototype.constructor = $c_sci_NewVectorIterator;
/** @constructor */
function $h_sci_NewVectorIterator() {
}
export { $h_sci_NewVectorIterator as $h_sci_NewVectorIterator };
$h_sci_NewVectorIterator.prototype = $c_sci_NewVectorIterator.prototype;
$c_sci_NewVectorIterator.prototype.knownSize__I = (function() {
  return ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
});
$c_sci_NewVectorIterator.prototype.hasNext__Z = (function() {
  return (this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1);
});
$c_sci_NewVectorIterator.prototype.next__O = (function() {
  if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
    $p_sci_NewVectorIterator__advance__V(this);
  }
  var r = this.sci_NewVectorIterator__f_a1.u[this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1];
  this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((1 + this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  return r;
});
$c_sci_NewVectorIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var oldpos = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + this.sci_NewVectorIterator__f_totalLength) | 0);
    var a = ((oldpos + n) | 0);
    var b = this.sci_NewVectorIterator__f_totalLength;
    var newpos = ((a < b) ? a : b);
    if ((newpos === this.sci_NewVectorIterator__f_totalLength)) {
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = 0;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = 0;
      this.sci_NewVectorIterator__f_a1len = 0;
    } else {
      while ((newpos >= this.sci_NewVectorIterator__f_sliceEnd)) {
        $p_sci_NewVectorIterator__advanceSlice__V(this);
      }
      var io = ((newpos - this.sci_NewVectorIterator__f_sliceStart) | 0);
      if ((this.sci_NewVectorIterator__f_sliceDim > 1)) {
        var xor = (this.sci_NewVectorIterator__f_oldPos ^ io);
        $p_sci_NewVectorIterator__setA__I__I__V(this, io, xor);
        this.sci_NewVectorIterator__f_oldPos = io;
      }
      this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_a1.u.length;
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = (31 & io);
      this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + ((this.sci_NewVectorIterator__f_totalLength - newpos) | 0)) | 0);
      if ((this.sci_NewVectorIterator__f_a1len > this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1)) {
        this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
      }
    }
  }
  return this;
});
$c_sci_NewVectorIterator.prototype.take__I__sc_Iterator = (function(n) {
  if ((n < ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0))) {
    var trunc = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0) - ((n < 0) ? 0 : n)) | 0);
    this.sci_NewVectorIterator__f_totalLength = ((this.sci_NewVectorIterator__f_totalLength - trunc) | 0);
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - trunc) | 0);
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 < this.sci_NewVectorIterator__f_a1len)) {
      this.sci_NewVectorIterator__f_a1len = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1;
    }
    if ((this.sci_NewVectorIterator__f_totalLength < this.sci_NewVectorIterator__f_sliceEnd)) {
      this.sci_NewVectorIterator__f_sliceEnd = this.sci_NewVectorIterator__f_totalLength;
    }
  }
  return this;
});
$c_sci_NewVectorIterator.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var xsLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var srcLen = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? xsLen : ((xsLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var total$1 = ((total < 0) ? 0 : total);
  var copied = 0;
  var isBoxed = (xs instanceof $ac_O);
  while ((copied < total$1)) {
    if ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 === this.sci_NewVectorIterator__f_a1len)) {
      $p_sci_NewVectorIterator__advance__V(this);
    }
    var a = ((total$1 - copied) | 0);
    var b = ((this.sci_NewVectorIterator__f_a1.u.length - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1) | 0);
    var count = ((a < b) ? a : b);
    if (isBoxed) {
      var src = this.sci_NewVectorIterator__f_a1;
      var srcPos = this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1;
      var destPos = ((start + copied) | 0);
      src.copyTo(srcPos, xs, destPos, count);
    } else {
      $m_s_Array$().copy__O__I__O__I__I__V(this.sci_NewVectorIterator__f_a1, this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1, xs, ((start + copied) | 0), count);
    }
    this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 = ((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 + count) | 0);
    copied = ((copied + count) | 0);
  }
  return total$1;
});
$c_sci_NewVectorIterator.prototype.toVector__sci_Vector = (function() {
  var this$1 = this.sci_NewVectorIterator__f_v;
  var from = ((((this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$i1 - this.sci_NewVectorIterator__f_scala$collection$immutable$NewVectorIterator$$len1) | 0) + this.sci_NewVectorIterator__f_totalLength) | 0);
  var until = this.sci_NewVectorIterator__f_totalLength;
  return this$1.slice__I__I__sci_Vector(from, until);
});
var $d_sci_NewVectorIterator = new $TypeData().initClass($c_sci_NewVectorIterator, "scala.collection.immutable.NewVectorIterator", ({
  sci_NewVectorIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  jl_Cloneable: 1
}));
export { $d_sci_NewVectorIterator as $d_sci_NewVectorIterator };
/** @constructor */
function $c_sci_NumericRange$NumericRangeIterator(self, num) {
  this.sci_NumericRange$NumericRangeIterator__f_self = null;
  this.sci_NumericRange$NumericRangeIterator__f_num = null;
  this.sci_NumericRange$NumericRangeIterator__f__hasNext = false;
  this.sci_NumericRange$NumericRangeIterator__f__next = null;
  this.sci_NumericRange$NumericRangeIterator__f_lastElement = null;
  this.sci_NumericRange$NumericRangeIterator__f_self = self;
  this.sci_NumericRange$NumericRangeIterator__f_num = num;
  this.sci_NumericRange$NumericRangeIterator__f__hasNext = (!self.isEmpty__Z());
  this.sci_NumericRange$NumericRangeIterator__f__next = self.sci_NumericRange__f_start;
  this.sci_NumericRange$NumericRangeIterator__f_lastElement = (this.sci_NumericRange$NumericRangeIterator__f__hasNext ? self.last__O() : self.sci_NumericRange__f_start);
}
export { $c_sci_NumericRange$NumericRangeIterator as $c_sci_NumericRange$NumericRangeIterator };
$c_sci_NumericRange$NumericRangeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_NumericRange$NumericRangeIterator.prototype.constructor = $c_sci_NumericRange$NumericRangeIterator;
/** @constructor */
function $h_sci_NumericRange$NumericRangeIterator() {
}
export { $h_sci_NumericRange$NumericRangeIterator as $h_sci_NumericRange$NumericRangeIterator };
$h_sci_NumericRange$NumericRangeIterator.prototype = $c_sci_NumericRange$NumericRangeIterator.prototype;
$c_sci_NumericRange$NumericRangeIterator.prototype.knownSize__I = (function() {
  if (this.sci_NumericRange$NumericRangeIterator__f__hasNext) {
    var $x_1 = this.sci_NumericRange$NumericRangeIterator__f_num;
    var this$2 = this.sci_NumericRange$NumericRangeIterator__f_num;
    var this$1 = this.sci_NumericRange$NumericRangeIterator__f_num;
    var lhs = this.sci_NumericRange$NumericRangeIterator__f_lastElement;
    var lhs$1 = new $c_s_math_Integral$IntegralOps(this$1, lhs).$minus__O__O(this.sci_NumericRange$NumericRangeIterator__f__next);
    return ((1 + $x_1.toInt__O__I(new $c_s_math_Integral$IntegralOps(this$2, lhs$1).$div__O__O(this.sci_NumericRange$NumericRangeIterator__f_self.sci_NumericRange__f_step))) | 0);
  } else {
    return 0;
  }
});
$c_sci_NumericRange$NumericRangeIterator.prototype.hasNext__Z = (function() {
  return this.sci_NumericRange$NumericRangeIterator__f__hasNext;
});
$c_sci_NumericRange$NumericRangeIterator.prototype.next__O = (function() {
  if ((!this.sci_NumericRange$NumericRangeIterator__f__hasNext)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var value = this.sci_NumericRange$NumericRangeIterator__f__next;
  this.sci_NumericRange$NumericRangeIterator__f__hasNext = (!$m_sr_BoxesRunTime$().equals__O__O__Z(value, this.sci_NumericRange$NumericRangeIterator__f_lastElement));
  this.sci_NumericRange$NumericRangeIterator__f__next = this.sci_NumericRange$NumericRangeIterator__f_num.plus__O__O__O(value, this.sci_NumericRange$NumericRangeIterator__f_self.sci_NumericRange__f_step);
  return value;
});
var $d_sci_NumericRange$NumericRangeIterator = new $TypeData().initClass($c_sci_NumericRange$NumericRangeIterator, "scala.collection.immutable.NumericRange$NumericRangeIterator", ({
  sci_NumericRange$NumericRangeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_NumericRange$NumericRangeIterator as $d_sci_NumericRange$NumericRangeIterator };
/** @constructor */
function $c_sci_RangeIterator(start, step, lastElement, initiallyEmpty) {
  this.sci_RangeIterator__f_step = 0;
  this.sci_RangeIterator__f_lastElement = 0;
  this.sci_RangeIterator__f__hasNext = false;
  this.sci_RangeIterator__f__next = 0;
  this.sci_RangeIterator__f_step = step;
  this.sci_RangeIterator__f_lastElement = lastElement;
  this.sci_RangeIterator__f__hasNext = (!initiallyEmpty);
  this.sci_RangeIterator__f__next = start;
}
export { $c_sci_RangeIterator as $c_sci_RangeIterator };
$c_sci_RangeIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_RangeIterator.prototype.constructor = $c_sci_RangeIterator;
/** @constructor */
function $h_sci_RangeIterator() {
}
export { $h_sci_RangeIterator as $h_sci_RangeIterator };
$h_sci_RangeIterator.prototype = $c_sci_RangeIterator.prototype;
$c_sci_RangeIterator.prototype.knownSize__I = (function() {
  return (this.sci_RangeIterator__f__hasNext ? ((1 + ((((this.sci_RangeIterator__f_lastElement - this.sci_RangeIterator__f__next) | 0) / $checkIntDivisor(this.sci_RangeIterator__f_step)) | 0)) | 0) : 0);
});
$c_sci_RangeIterator.prototype.hasNext__Z = (function() {
  return this.sci_RangeIterator__f__hasNext;
});
$c_sci_RangeIterator.prototype.next__I = (function() {
  if ((!this.sci_RangeIterator__f__hasNext)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var value = this.sci_RangeIterator__f__next;
  this.sci_RangeIterator__f__hasNext = (value !== this.sci_RangeIterator__f_lastElement);
  this.sci_RangeIterator__f__next = ((value + this.sci_RangeIterator__f_step) | 0);
  return value;
});
$c_sci_RangeIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    var value = this.sci_RangeIterator__f__next;
    var hi = (value >> 31);
    var value$1 = Math.imul(this.sci_RangeIterator__f_step, n);
    var hi$1 = (value$1 >> 31);
    var lo = ((value + value$1) | 0);
    var hi$2 = ((((hi + hi$1) | 0) + ((((value & value$1) | ((value | value$1) & (~lo))) >>> 31) | 0)) | 0);
    if ((this.sci_RangeIterator__f_step > 0)) {
      var value$2 = this.sci_RangeIterator__f_lastElement;
      var hi$3 = (value$2 >> 31);
      if (((hi$3 === hi$2) ? ((value$2 >>> 0) < (lo >>> 0)) : (hi$3 < hi$2))) {
        var a__lo = value$2;
        var a__hi = hi$3;
      } else {
        var a__lo = lo;
        var a__hi = hi$2;
      }
      this.sci_RangeIterator__f__next = a__lo;
      var value$3 = this.sci_RangeIterator__f_lastElement;
      var hi$4 = (value$3 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$4) ? ((lo >>> 0) <= (value$3 >>> 0)) : (hi$2 < hi$4));
    } else if ((this.sci_RangeIterator__f_step < 0)) {
      var value$4 = this.sci_RangeIterator__f_lastElement;
      var hi$5 = (value$4 >> 31);
      if (((hi$5 === hi$2) ? ((value$4 >>> 0) > (lo >>> 0)) : (hi$5 > hi$2))) {
        var a$1__lo = value$4;
        var a$1__hi = hi$5;
      } else {
        var a$1__lo = lo;
        var a$1__hi = hi$2;
      }
      this.sci_RangeIterator__f__next = a$1__lo;
      var value$5 = this.sci_RangeIterator__f_lastElement;
      var hi$6 = (value$5 >> 31);
      this.sci_RangeIterator__f__hasNext = ((hi$2 === hi$6) ? ((lo >>> 0) >= (value$5 >>> 0)) : (hi$2 > hi$6));
    }
  }
  return this;
});
$c_sci_RangeIterator.prototype.next__O = (function() {
  return this.next__I();
});
var $d_sci_RangeIterator = new $TypeData().initClass($c_sci_RangeIterator, "scala.collection.immutable.RangeIterator", ({
  sci_RangeIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_RangeIterator as $d_sci_RangeIterator };
function $ct_sci_Set$SetNIterator__I__($thiz, n) {
  $thiz.sci_Set$SetNIterator__f_current = 0;
  $thiz.sci_Set$SetNIterator__f_remainder = n;
  return $thiz;
}
export { $ct_sci_Set$SetNIterator__I__ as $ct_sci_Set$SetNIterator__I__ };
/** @constructor */
function $c_sci_Set$SetNIterator() {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
}
export { $c_sci_Set$SetNIterator as $c_sci_Set$SetNIterator };
$c_sci_Set$SetNIterator.prototype = new $h_sc_AbstractIterator();
$c_sci_Set$SetNIterator.prototype.constructor = $c_sci_Set$SetNIterator;
/** @constructor */
function $h_sci_Set$SetNIterator() {
}
export { $h_sci_Set$SetNIterator as $h_sci_Set$SetNIterator };
$h_sci_Set$SetNIterator.prototype = $c_sci_Set$SetNIterator.prototype;
$c_sci_Set$SetNIterator.prototype.knownSize__I = (function() {
  return this.sci_Set$SetNIterator__f_remainder;
});
$c_sci_Set$SetNIterator.prototype.hasNext__Z = (function() {
  return (this.sci_Set$SetNIterator__f_remainder > 0);
});
$c_sci_Set$SetNIterator.prototype.next__O = (function() {
  if (this.hasNext__Z()) {
    var r = this.apply__I__O(this.sci_Set$SetNIterator__f_current);
    this.sci_Set$SetNIterator__f_current = ((1 + this.sci_Set$SetNIterator__f_current) | 0);
    this.sci_Set$SetNIterator__f_remainder = (((-1) + this.sci_Set$SetNIterator__f_remainder) | 0);
    return r;
  } else {
    return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
});
$c_sci_Set$SetNIterator.prototype.drop__I__sc_Iterator = (function(n) {
  if ((n > 0)) {
    this.sci_Set$SetNIterator__f_current = ((this.sci_Set$SetNIterator__f_current + n) | 0);
    var b = ((this.sci_Set$SetNIterator__f_remainder - n) | 0);
    this.sci_Set$SetNIterator__f_remainder = ((b < 0) ? 0 : b);
  }
  return this;
});
/** @constructor */
function $c_sci_SetHashIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  this.sci_SetHashIterator__f_hash = 0;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
  this.sci_SetHashIterator__f_hash = 0;
}
export { $c_sci_SetHashIterator as $c_sci_SetHashIterator };
$c_sci_SetHashIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetHashIterator.prototype.constructor = $c_sci_SetHashIterator;
/** @constructor */
function $h_sci_SetHashIterator() {
}
export { $h_sci_SetHashIterator as $h_sci_SetHashIterator };
$h_sci_SetHashIterator.prototype = $c_sci_SetHashIterator.prototype;
$c_sci_SetHashIterator.prototype.hashCode__I = (function() {
  return this.sci_SetHashIterator__f_hash;
});
$c_sci_SetHashIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  this.sci_SetHashIterator__f_hash = this.sci_ChampBaseIterator__f_currentValueNode.getHash__I__I(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return this;
});
var $d_sci_SetHashIterator = new $TypeData().initClass($c_sci_SetHashIterator, "scala.collection.immutable.SetHashIterator", ({
  sci_SetHashIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_SetHashIterator as $d_sci_SetHashIterator };
/** @constructor */
function $c_sci_SetIterator(rootNode) {
  this.sci_ChampBaseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseIterator__f_currentValueLength = 0;
  this.sci_ChampBaseIterator__f_currentValueNode = null;
  this.sci_ChampBaseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseIterator__f_nodeCursorsAndLengths = null;
  this.sci_ChampBaseIterator__f_nodes = null;
  $ct_sci_ChampBaseIterator__sci_Node__(this, rootNode);
}
export { $c_sci_SetIterator as $c_sci_SetIterator };
$c_sci_SetIterator.prototype = new $h_sci_ChampBaseIterator();
$c_sci_SetIterator.prototype.constructor = $c_sci_SetIterator;
/** @constructor */
function $h_sci_SetIterator() {
}
export { $h_sci_SetIterator as $h_sci_SetIterator };
$h_sci_SetIterator.prototype = $c_sci_SetIterator.prototype;
$c_sci_SetIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var payload = this.sci_ChampBaseIterator__f_currentValueNode.getPayload__I__O(this.sci_ChampBaseIterator__f_currentValueCursor);
  this.sci_ChampBaseIterator__f_currentValueCursor = ((1 + this.sci_ChampBaseIterator__f_currentValueCursor) | 0);
  return payload;
});
var $d_sci_SetIterator = new $TypeData().initClass($c_sci_SetIterator, "scala.collection.immutable.SetIterator", ({
  sci_SetIterator: 1,
  sci_ChampBaseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_SetIterator as $d_sci_SetIterator };
function $f_sci_SetOps__removedAll__sc_IterableOnce__sci_SetOps($thiz, that) {
  var this$1 = that.iterator__sc_Iterator();
  var f = ((x$1$2$2, x$2$2$2) => x$1$2$2.excl__O__sci_SetOps(x$2$2$2));
  if ($is_sc_IndexedSeq(this$1)) {
    var at = 0;
    var end = this$1.length__I();
    var acc = $thiz;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$1.apply__I__O(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = $thiz;
    while (this$1.hasNext__Z()) {
      var x0$1 = result;
      var x1$1 = this$1.next__O();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1;
}
export { $f_sci_SetOps__removedAll__sc_IterableOnce__sci_SetOps as $f_sci_SetOps__removedAll__sc_IterableOnce__sci_SetOps };
/** @constructor */
function $c_sci_SetReverseIterator(rootNode) {
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = 0;
  this.sci_ChampBaseReverseIterator__f_currentValueNode = null;
  this.sci_ChampBaseReverseIterator__f_currentStackLevel = 0;
  this.sci_ChampBaseReverseIterator__f_nodeIndex = null;
  this.sci_ChampBaseReverseIterator__f_nodeStack = null;
  $ct_sci_ChampBaseReverseIterator__sci_Node__(this, rootNode);
}
export { $c_sci_SetReverseIterator as $c_sci_SetReverseIterator };
$c_sci_SetReverseIterator.prototype = new $h_sci_ChampBaseReverseIterator();
$c_sci_SetReverseIterator.prototype.constructor = $c_sci_SetReverseIterator;
/** @constructor */
function $h_sci_SetReverseIterator() {
}
export { $h_sci_SetReverseIterator as $h_sci_SetReverseIterator };
$h_sci_SetReverseIterator.prototype = $c_sci_SetReverseIterator.prototype;
$c_sci_SetReverseIterator.prototype.next__O = (function() {
  if ((!this.hasNext__Z())) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var payload = this.sci_ChampBaseReverseIterator__f_currentValueNode.getPayload__I__O(this.sci_ChampBaseReverseIterator__f_currentValueCursor);
  this.sci_ChampBaseReverseIterator__f_currentValueCursor = (((-1) + this.sci_ChampBaseReverseIterator__f_currentValueCursor) | 0);
  return payload;
});
var $d_sci_SetReverseIterator = new $TypeData().initClass($c_sci_SetReverseIterator, "scala.collection.immutable.SetReverseIterator", ({
  sci_SetReverseIterator: 1,
  sci_ChampBaseReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_sci_SetReverseIterator as $d_sci_SetReverseIterator };
function $ct_scm_ArrayBuilder__($thiz) {
  $thiz.scm_ArrayBuilder__f_capacity = 0;
  $thiz.scm_ArrayBuilder__f_size = 0;
  return $thiz;
}
export { $ct_scm_ArrayBuilder__ as $ct_scm_ArrayBuilder__ };
/** @constructor */
function $c_scm_ArrayBuilder() {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder__f_size = 0;
}
export { $c_scm_ArrayBuilder as $c_scm_ArrayBuilder };
$c_scm_ArrayBuilder.prototype = new $h_O();
$c_scm_ArrayBuilder.prototype.constructor = $c_scm_ArrayBuilder;
/** @constructor */
function $h_scm_ArrayBuilder() {
}
export { $h_scm_ArrayBuilder as $h_scm_ArrayBuilder };
$h_scm_ArrayBuilder.prototype = $c_scm_ArrayBuilder.prototype;
$c_scm_ArrayBuilder.prototype.ensureSize__I__V = (function(size) {
  if (((this.scm_ArrayBuilder__f_capacity < size) || (this.scm_ArrayBuilder__f_capacity === 0))) {
    var newsize = ((this.scm_ArrayBuilder__f_capacity === 0) ? 16 : (this.scm_ArrayBuilder__f_capacity << 1));
    while ((newsize < size)) {
      newsize = (newsize << 1);
    }
    this.resize__I__V(newsize);
  }
});
$c_scm_ArrayBuilder.prototype.sizeHint__I__V = (function(size) {
  if ((this.scm_ArrayBuilder__f_capacity < size)) {
    this.resize__I__V(size);
  }
});
$c_scm_ArrayBuilder.prototype.addAll__sc_IterableOnce__scm_ArrayBuilder = (function(xs) {
  var k = xs.knownSize__I();
  if ((k > 0)) {
    this.ensureSize__I__V(((this.scm_ArrayBuilder__f_size + k) | 0));
    if ($is_scm_Iterable(xs)) {
      var dest = this.elems__O();
      var start = this.scm_ArrayBuilder__f_size;
      xs.copyToArray__O__I__I__I(dest, start, 2147483647);
    } else {
      var this$1 = xs.iterator__sc_Iterator();
      var dest$1 = this.elems__O();
      var start$1 = this.scm_ArrayBuilder__f_size;
      this$1.copyToArray__O__I__I__I(dest$1, start$1, 2147483647);
    }
    this.scm_ArrayBuilder__f_size = ((this.scm_ArrayBuilder__f_size + k) | 0);
  } else if ((k < 0)) {
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
  }
  return this;
});
$c_scm_ArrayBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuilder(elems);
});
/** @constructor */
function $c_scm_ArraySeq$() {
  this.scm_ArraySeq$__f_untagged = null;
  this.scm_ArraySeq$__f_EmptyArraySeq = null;
  $n_scm_ArraySeq$ = this;
  this.scm_ArraySeq$__f_untagged = new $c_sc_ClassTagSeqFactory$AnySeqDelegate(this);
  this.scm_ArraySeq$__f_EmptyArraySeq = new $c_scm_ArraySeq$ofRef(new $ac_O(0));
}
export { $c_scm_ArraySeq$ as $c_scm_ArraySeq$ };
$c_scm_ArraySeq$.prototype = new $h_O();
$c_scm_ArraySeq$.prototype.constructor = $c_scm_ArraySeq$;
/** @constructor */
function $h_scm_ArraySeq$() {
}
export { $h_scm_ArraySeq$ as $h_scm_ArraySeq$ };
$h_scm_ArraySeq$.prototype = $c_scm_ArraySeq$.prototype;
$c_scm_ArraySeq$.prototype.apply__sci_Seq__O__O = (function(xs, evidence$7) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq(xs, evidence$7);
});
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq = (function(it, evidence$2) {
  return this.make__O__scm_ArraySeq($m_s_Array$().from__sc_IterableOnce__s_reflect_ClassTag__O(it, evidence$2));
});
$c_scm_ArraySeq$.prototype.newBuilder__s_reflect_ClassTag__scm_Builder = (function(evidence$3) {
  var this$3 = new $c_scm_ArrayBuilder$generic(evidence$3.runtimeClass__jl_Class());
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => $m_scm_ArraySeq$().make__O__scm_ArraySeq(x$2$2)));
  return new $c_scm_Builder$$anon$1(this$3, f);
});
$c_scm_ArraySeq$.prototype.make__O__scm_ArraySeq = (function(x) {
  if ((x === null)) {
    return null;
  } else if ((x instanceof $ac_O)) {
    return new $c_scm_ArraySeq$ofRef(x);
  } else if ((x instanceof $ac_I)) {
    return new $c_scm_ArraySeq$ofInt(x);
  } else if ((x instanceof $ac_D)) {
    return new $c_scm_ArraySeq$ofDouble(x);
  } else if ((x instanceof $ac_J)) {
    return new $c_scm_ArraySeq$ofLong(x);
  } else if ((x instanceof $ac_F)) {
    return new $c_scm_ArraySeq$ofFloat(x);
  } else if ((x instanceof $ac_C)) {
    return new $c_scm_ArraySeq$ofChar(x);
  } else if ((x instanceof $ac_B)) {
    return new $c_scm_ArraySeq$ofByte(x);
  } else if ((x instanceof $ac_S)) {
    return new $c_scm_ArraySeq$ofShort(x);
  } else if ((x instanceof $ac_Z)) {
    return new $c_scm_ArraySeq$ofBoolean(x);
  } else if ($isArrayOf_jl_Void(x, 1)) {
    return new $c_scm_ArraySeq$ofUnit(x);
  } else {
    throw new $c_s_MatchError(x);
  }
});
$c_scm_ArraySeq$.prototype.newBuilder__O__scm_Builder = (function(evidence$12) {
  return this.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12);
});
$c_scm_ArraySeq$.prototype.from__sc_IterableOnce__O__O = (function(it, evidence$5) {
  return this.from__sc_IterableOnce__s_reflect_ClassTag__scm_ArraySeq(it, evidence$5);
});
$c_scm_ArraySeq$.prototype.empty__O__O = (function(evidence$6) {
  return this.scm_ArraySeq$__f_EmptyArraySeq;
});
var $d_scm_ArraySeq$ = new $TypeData().initClass($c_scm_ArraySeq$, "scala.collection.mutable.ArraySeq$", ({
  scm_ArraySeq$: 1,
  sc_StrictOptimizedClassTagSeqFactory: 1,
  sc_ClassTagSeqFactory: 1,
  sc_ClassTagIterableFactory: 1,
  sc_EvidenceIterableFactory: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArraySeq$ as $d_scm_ArraySeq$ };
var $n_scm_ArraySeq$;
function $m_scm_ArraySeq$() {
  if ((!$n_scm_ArraySeq$)) {
    $n_scm_ArraySeq$ = new $c_scm_ArraySeq$();
  }
  return $n_scm_ArraySeq$;
}
export { $m_scm_ArraySeq$ as $m_scm_ArraySeq$ };
/** @constructor */
function $c_scm_HashMap$$anon$1(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
export { $c_scm_HashMap$$anon$1 as $c_scm_HashMap$$anon$1 };
$c_scm_HashMap$$anon$1.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$1.prototype.constructor = $c_scm_HashMap$$anon$1;
/** @constructor */
function $h_scm_HashMap$$anon$1() {
}
export { $h_scm_HashMap$$anon$1 as $h_scm_HashMap$$anon$1 };
$h_scm_HashMap$$anon$1.prototype = $c_scm_HashMap$$anon$1.prototype;
$c_scm_HashMap$$anon$1.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return $ct_T2__O__O__(new $c_T2(), nd.scm_HashMap$Node__f__key, nd.scm_HashMap$Node__f__value);
});
var $d_scm_HashMap$$anon$1 = new $TypeData().initClass($c_scm_HashMap$$anon$1, "scala.collection.mutable.HashMap$$anon$1", ({
  scm_HashMap$$anon$1: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_HashMap$$anon$1 as $d_scm_HashMap$$anon$1 };
/** @constructor */
function $c_scm_HashMap$$anon$2(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
export { $c_scm_HashMap$$anon$2 as $c_scm_HashMap$$anon$2 };
$c_scm_HashMap$$anon$2.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$2.prototype.constructor = $c_scm_HashMap$$anon$2;
/** @constructor */
function $h_scm_HashMap$$anon$2() {
}
export { $h_scm_HashMap$$anon$2 as $h_scm_HashMap$$anon$2 };
$h_scm_HashMap$$anon$2.prototype = $c_scm_HashMap$$anon$2.prototype;
$c_scm_HashMap$$anon$2.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return nd.scm_HashMap$Node__f__key;
});
var $d_scm_HashMap$$anon$2 = new $TypeData().initClass($c_scm_HashMap$$anon$2, "scala.collection.mutable.HashMap$$anon$2", ({
  scm_HashMap$$anon$2: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_HashMap$$anon$2 as $d_scm_HashMap$$anon$2 };
/** @constructor */
function $c_scm_HashMap$$anon$3(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
export { $c_scm_HashMap$$anon$3 as $c_scm_HashMap$$anon$3 };
$c_scm_HashMap$$anon$3.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$3.prototype.constructor = $c_scm_HashMap$$anon$3;
/** @constructor */
function $h_scm_HashMap$$anon$3() {
}
export { $h_scm_HashMap$$anon$3 as $h_scm_HashMap$$anon$3 };
$h_scm_HashMap$$anon$3.prototype = $c_scm_HashMap$$anon$3.prototype;
$c_scm_HashMap$$anon$3.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return nd.scm_HashMap$Node__f__value;
});
var $d_scm_HashMap$$anon$3 = new $TypeData().initClass($c_scm_HashMap$$anon$3, "scala.collection.mutable.HashMap$$anon$3", ({
  scm_HashMap$$anon$3: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_HashMap$$anon$3 as $d_scm_HashMap$$anon$3 };
/** @constructor */
function $c_scm_HashMap$$anon$4(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
}
export { $c_scm_HashMap$$anon$4 as $c_scm_HashMap$$anon$4 };
$c_scm_HashMap$$anon$4.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$4.prototype.constructor = $c_scm_HashMap$$anon$4;
/** @constructor */
function $h_scm_HashMap$$anon$4() {
}
export { $h_scm_HashMap$$anon$4 as $h_scm_HashMap$$anon$4 };
$h_scm_HashMap$$anon$4.prototype = $c_scm_HashMap$$anon$4.prototype;
$c_scm_HashMap$$anon$4.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  return nd;
});
var $d_scm_HashMap$$anon$4 = new $TypeData().initClass($c_scm_HashMap$$anon$4, "scala.collection.mutable.HashMap$$anon$4", ({
  scm_HashMap$$anon$4: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_HashMap$$anon$4 as $d_scm_HashMap$$anon$4 };
/** @constructor */
function $c_scm_HashMap$$anon$5(outer) {
  this.scm_HashMap$HashMapIterator__f_i = 0;
  this.scm_HashMap$HashMapIterator__f_node = null;
  this.scm_HashMap$HashMapIterator__f_len = 0;
  this.scm_HashMap$HashMapIterator__f_$outer = null;
  this.scm_HashMap$$anon$5__f_hash = 0;
  this.scm_HashMap$$anon$5__f_$outer = null;
  this.scm_HashMap$$anon$5__f_$outer = outer;
  $ct_scm_HashMap$HashMapIterator__scm_HashMap__(this, outer);
  this.scm_HashMap$$anon$5__f_hash = 0;
}
export { $c_scm_HashMap$$anon$5 as $c_scm_HashMap$$anon$5 };
$c_scm_HashMap$$anon$5.prototype = new $h_scm_HashMap$HashMapIterator();
$c_scm_HashMap$$anon$5.prototype.constructor = $c_scm_HashMap$$anon$5;
/** @constructor */
function $h_scm_HashMap$$anon$5() {
}
export { $h_scm_HashMap$$anon$5 as $h_scm_HashMap$$anon$5 };
$h_scm_HashMap$$anon$5.prototype = $c_scm_HashMap$$anon$5.prototype;
$c_scm_HashMap$$anon$5.prototype.hashCode__I = (function() {
  return this.scm_HashMap$$anon$5__f_hash;
});
$c_scm_HashMap$$anon$5.prototype.extract__scm_HashMap$Node__O = (function(nd) {
  var $x_1 = $m_s_util_hashing_MurmurHash3$();
  var improvedHash = nd.scm_HashMap$Node__f__hash;
  var x = nd.scm_HashMap$Node__f__value;
  this.scm_HashMap$$anon$5__f_hash = $x_1.tuple2Hash__O__O__I((improvedHash ^ ((improvedHash >>> 16) | 0)), $m_sr_Statics$().anyHash__O__I(x));
  return this;
});
var $d_scm_HashMap$$anon$5 = new $TypeData().initClass($c_scm_HashMap$$anon$5, "scala.collection.mutable.HashMap$$anon$5", ({
  scm_HashMap$$anon$5: 1,
  scm_HashMap$HashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_HashMap$$anon$5 as $d_scm_HashMap$$anon$5 };
/** @constructor */
function $c_scm_HashSet$$anon$1(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
}
export { $c_scm_HashSet$$anon$1 as $c_scm_HashSet$$anon$1 };
$c_scm_HashSet$$anon$1.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$1.prototype.constructor = $c_scm_HashSet$$anon$1;
/** @constructor */
function $h_scm_HashSet$$anon$1() {
}
export { $h_scm_HashSet$$anon$1 as $h_scm_HashSet$$anon$1 };
$h_scm_HashSet$$anon$1.prototype = $c_scm_HashSet$$anon$1.prototype;
$c_scm_HashSet$$anon$1.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return nd.scm_HashSet$Node__f__key;
});
var $d_scm_HashSet$$anon$1 = new $TypeData().initClass($c_scm_HashSet$$anon$1, "scala.collection.mutable.HashSet$$anon$1", ({
  scm_HashSet$$anon$1: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_HashSet$$anon$1 as $d_scm_HashSet$$anon$1 };
/** @constructor */
function $c_scm_HashSet$$anon$2(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
}
export { $c_scm_HashSet$$anon$2 as $c_scm_HashSet$$anon$2 };
$c_scm_HashSet$$anon$2.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$2.prototype.constructor = $c_scm_HashSet$$anon$2;
/** @constructor */
function $h_scm_HashSet$$anon$2() {
}
export { $h_scm_HashSet$$anon$2 as $h_scm_HashSet$$anon$2 };
$h_scm_HashSet$$anon$2.prototype = $c_scm_HashSet$$anon$2.prototype;
$c_scm_HashSet$$anon$2.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  return nd;
});
var $d_scm_HashSet$$anon$2 = new $TypeData().initClass($c_scm_HashSet$$anon$2, "scala.collection.mutable.HashSet$$anon$2", ({
  scm_HashSet$$anon$2: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_HashSet$$anon$2 as $d_scm_HashSet$$anon$2 };
/** @constructor */
function $c_scm_HashSet$$anon$3(outer) {
  this.scm_HashSet$HashSetIterator__f_i = 0;
  this.scm_HashSet$HashSetIterator__f_node = null;
  this.scm_HashSet$HashSetIterator__f_len = 0;
  this.scm_HashSet$HashSetIterator__f_$outer = null;
  this.scm_HashSet$$anon$3__f_hash = 0;
  this.scm_HashSet$$anon$3__f_$outer = null;
  this.scm_HashSet$$anon$3__f_$outer = outer;
  $ct_scm_HashSet$HashSetIterator__scm_HashSet__(this, outer);
  this.scm_HashSet$$anon$3__f_hash = 0;
}
export { $c_scm_HashSet$$anon$3 as $c_scm_HashSet$$anon$3 };
$c_scm_HashSet$$anon$3.prototype = new $h_scm_HashSet$HashSetIterator();
$c_scm_HashSet$$anon$3.prototype.constructor = $c_scm_HashSet$$anon$3;
/** @constructor */
function $h_scm_HashSet$$anon$3() {
}
export { $h_scm_HashSet$$anon$3 as $h_scm_HashSet$$anon$3 };
$h_scm_HashSet$$anon$3.prototype = $c_scm_HashSet$$anon$3.prototype;
$c_scm_HashSet$$anon$3.prototype.hashCode__I = (function() {
  return this.scm_HashSet$$anon$3__f_hash;
});
$c_scm_HashSet$$anon$3.prototype.extract__scm_HashSet$Node__O = (function(nd) {
  var this$1 = this.scm_HashSet$$anon$3__f_$outer;
  var improvedHash = nd.scm_HashSet$Node__f__hash;
  this.scm_HashSet$$anon$3__f_hash = this$1.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
  return this;
});
var $d_scm_HashSet$$anon$3 = new $TypeData().initClass($c_scm_HashSet$$anon$3, "scala.collection.mutable.HashSet$$anon$3", ({
  scm_HashSet$$anon$3: 1,
  scm_HashSet$HashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_HashSet$$anon$3 as $d_scm_HashSet$$anon$3 };
function $is_scm_Iterable(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Iterable)));
}
export { $is_scm_Iterable as $is_scm_Iterable };
function $isArrayOf_scm_Iterable(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Iterable)));
}
export { $isArrayOf_scm_Iterable as $isArrayOf_scm_Iterable };
/** @constructor */
function $c_scm_LinkedHashMap$$anon$1(outer) {
  this.scm_LinkedHashMap$LinkedHashMapIterator__f_cur = null;
  $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__(this, outer);
}
export { $c_scm_LinkedHashMap$$anon$1 as $c_scm_LinkedHashMap$$anon$1 };
$c_scm_LinkedHashMap$$anon$1.prototype = new $h_scm_LinkedHashMap$LinkedHashMapIterator();
$c_scm_LinkedHashMap$$anon$1.prototype.constructor = $c_scm_LinkedHashMap$$anon$1;
/** @constructor */
function $h_scm_LinkedHashMap$$anon$1() {
}
export { $h_scm_LinkedHashMap$$anon$1 as $h_scm_LinkedHashMap$$anon$1 };
$h_scm_LinkedHashMap$$anon$1.prototype = $c_scm_LinkedHashMap$$anon$1.prototype;
$c_scm_LinkedHashMap$$anon$1.prototype.extract__scm_LinkedHashMap$LinkedEntry__O = (function(nd) {
  return $ct_T2__O__O__(new $c_T2(), nd.scm_LinkedHashMap$LinkedEntry__f_key, nd.scm_LinkedHashMap$LinkedEntry__f_value);
});
var $d_scm_LinkedHashMap$$anon$1 = new $TypeData().initClass($c_scm_LinkedHashMap$$anon$1, "scala.collection.mutable.LinkedHashMap$$anon$1", ({
  scm_LinkedHashMap$$anon$1: 1,
  scm_LinkedHashMap$LinkedHashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_LinkedHashMap$$anon$1 as $d_scm_LinkedHashMap$$anon$1 };
/** @constructor */
function $c_scm_LinkedHashMap$$anon$2(outer) {
  this.scm_LinkedHashMap$LinkedHashMapIterator__f_cur = null;
  $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__(this, outer);
}
export { $c_scm_LinkedHashMap$$anon$2 as $c_scm_LinkedHashMap$$anon$2 };
$c_scm_LinkedHashMap$$anon$2.prototype = new $h_scm_LinkedHashMap$LinkedHashMapIterator();
$c_scm_LinkedHashMap$$anon$2.prototype.constructor = $c_scm_LinkedHashMap$$anon$2;
/** @constructor */
function $h_scm_LinkedHashMap$$anon$2() {
}
export { $h_scm_LinkedHashMap$$anon$2 as $h_scm_LinkedHashMap$$anon$2 };
$h_scm_LinkedHashMap$$anon$2.prototype = $c_scm_LinkedHashMap$$anon$2.prototype;
$c_scm_LinkedHashMap$$anon$2.prototype.extract__scm_LinkedHashMap$LinkedEntry__O = (function(nd) {
  return nd.scm_LinkedHashMap$LinkedEntry__f_key;
});
var $d_scm_LinkedHashMap$$anon$2 = new $TypeData().initClass($c_scm_LinkedHashMap$$anon$2, "scala.collection.mutable.LinkedHashMap$$anon$2", ({
  scm_LinkedHashMap$$anon$2: 1,
  scm_LinkedHashMap$LinkedHashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_LinkedHashMap$$anon$2 as $d_scm_LinkedHashMap$$anon$2 };
/** @constructor */
function $c_scm_LinkedHashMap$$anon$3(outer) {
  this.scm_LinkedHashMap$LinkedHashMapIterator__f_cur = null;
  $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__(this, outer);
}
export { $c_scm_LinkedHashMap$$anon$3 as $c_scm_LinkedHashMap$$anon$3 };
$c_scm_LinkedHashMap$$anon$3.prototype = new $h_scm_LinkedHashMap$LinkedHashMapIterator();
$c_scm_LinkedHashMap$$anon$3.prototype.constructor = $c_scm_LinkedHashMap$$anon$3;
/** @constructor */
function $h_scm_LinkedHashMap$$anon$3() {
}
export { $h_scm_LinkedHashMap$$anon$3 as $h_scm_LinkedHashMap$$anon$3 };
$h_scm_LinkedHashMap$$anon$3.prototype = $c_scm_LinkedHashMap$$anon$3.prototype;
$c_scm_LinkedHashMap$$anon$3.prototype.extract__scm_LinkedHashMap$LinkedEntry__O = (function(nd) {
  return nd;
});
var $d_scm_LinkedHashMap$$anon$3 = new $TypeData().initClass($c_scm_LinkedHashMap$$anon$3, "scala.collection.mutable.LinkedHashMap$$anon$3", ({
  scm_LinkedHashMap$$anon$3: 1,
  scm_LinkedHashMap$LinkedHashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_LinkedHashMap$$anon$3 as $d_scm_LinkedHashMap$$anon$3 };
/** @constructor */
function $c_scm_LinkedHashMap$$anon$4(outer) {
  this.scm_LinkedHashMap$LinkedHashMapIterator__f_cur = null;
  $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__(this, outer);
}
export { $c_scm_LinkedHashMap$$anon$4 as $c_scm_LinkedHashMap$$anon$4 };
$c_scm_LinkedHashMap$$anon$4.prototype = new $h_scm_LinkedHashMap$LinkedHashMapIterator();
$c_scm_LinkedHashMap$$anon$4.prototype.constructor = $c_scm_LinkedHashMap$$anon$4;
/** @constructor */
function $h_scm_LinkedHashMap$$anon$4() {
}
export { $h_scm_LinkedHashMap$$anon$4 as $h_scm_LinkedHashMap$$anon$4 };
$h_scm_LinkedHashMap$$anon$4.prototype = $c_scm_LinkedHashMap$$anon$4.prototype;
$c_scm_LinkedHashMap$$anon$4.prototype.extract__scm_LinkedHashMap$LinkedEntry__O = (function(nd) {
  return nd.scm_LinkedHashMap$LinkedEntry__f_value;
});
var $d_scm_LinkedHashMap$$anon$4 = new $TypeData().initClass($c_scm_LinkedHashMap$$anon$4, "scala.collection.mutable.LinkedHashMap$$anon$4", ({
  scm_LinkedHashMap$$anon$4: 1,
  scm_LinkedHashMap$LinkedHashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_LinkedHashMap$$anon$4 as $d_scm_LinkedHashMap$$anon$4 };
/** @constructor */
function $c_scm_LinkedHashMap$$anon$5(outer) {
  this.scm_LinkedHashMap$LinkedHashMapIterator__f_cur = null;
  this.scm_LinkedHashMap$$anon$5__f_hash = 0;
  this.scm_LinkedHashMap$$anon$5__f_$outer = null;
  this.scm_LinkedHashMap$$anon$5__f_$outer = outer;
  $ct_scm_LinkedHashMap$LinkedHashMapIterator__scm_LinkedHashMap__(this, outer);
  this.scm_LinkedHashMap$$anon$5__f_hash = 0;
}
export { $c_scm_LinkedHashMap$$anon$5 as $c_scm_LinkedHashMap$$anon$5 };
$c_scm_LinkedHashMap$$anon$5.prototype = new $h_scm_LinkedHashMap$LinkedHashMapIterator();
$c_scm_LinkedHashMap$$anon$5.prototype.constructor = $c_scm_LinkedHashMap$$anon$5;
/** @constructor */
function $h_scm_LinkedHashMap$$anon$5() {
}
export { $h_scm_LinkedHashMap$$anon$5 as $h_scm_LinkedHashMap$$anon$5 };
$h_scm_LinkedHashMap$$anon$5.prototype = $c_scm_LinkedHashMap$$anon$5.prototype;
$c_scm_LinkedHashMap$$anon$5.prototype.hashCode__I = (function() {
  return this.scm_LinkedHashMap$$anon$5__f_hash;
});
$c_scm_LinkedHashMap$$anon$5.prototype.extract__scm_LinkedHashMap$LinkedEntry__O = (function(nd) {
  var $x_1 = $m_s_util_hashing_MurmurHash3$();
  var improvedHash = nd.scm_LinkedHashMap$LinkedEntry__f_hash;
  var x = nd.scm_LinkedHashMap$LinkedEntry__f_value;
  this.scm_LinkedHashMap$$anon$5__f_hash = $x_1.tuple2Hash__O__O__I((improvedHash ^ ((improvedHash >>> 16) | 0)), $m_sr_Statics$().anyHash__O__I(x));
  return this;
});
var $d_scm_LinkedHashMap$$anon$5 = new $TypeData().initClass($c_scm_LinkedHashMap$$anon$5, "scala.collection.mutable.LinkedHashMap$$anon$5", ({
  scm_LinkedHashMap$$anon$5: 1,
  scm_LinkedHashMap$LinkedHashMapIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_LinkedHashMap$$anon$5 as $d_scm_LinkedHashMap$$anon$5 };
/** @constructor */
function $c_scm_LinkedHashSet$$anon$1(outer) {
  this.scm_LinkedHashSet$LinkedHashSetIterator__f_cur = null;
  $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__(this, outer);
}
export { $c_scm_LinkedHashSet$$anon$1 as $c_scm_LinkedHashSet$$anon$1 };
$c_scm_LinkedHashSet$$anon$1.prototype = new $h_scm_LinkedHashSet$LinkedHashSetIterator();
$c_scm_LinkedHashSet$$anon$1.prototype.constructor = $c_scm_LinkedHashSet$$anon$1;
/** @constructor */
function $h_scm_LinkedHashSet$$anon$1() {
}
export { $h_scm_LinkedHashSet$$anon$1 as $h_scm_LinkedHashSet$$anon$1 };
$h_scm_LinkedHashSet$$anon$1.prototype = $c_scm_LinkedHashSet$$anon$1.prototype;
$c_scm_LinkedHashSet$$anon$1.prototype.extract__scm_LinkedHashSet$Entry__O = (function(nd) {
  return nd.scm_LinkedHashSet$Entry__f_key;
});
var $d_scm_LinkedHashSet$$anon$1 = new $TypeData().initClass($c_scm_LinkedHashSet$$anon$1, "scala.collection.mutable.LinkedHashSet$$anon$1", ({
  scm_LinkedHashSet$$anon$1: 1,
  scm_LinkedHashSet$LinkedHashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_LinkedHashSet$$anon$1 as $d_scm_LinkedHashSet$$anon$1 };
/** @constructor */
function $c_scm_LinkedHashSet$$anon$2(outer) {
  this.scm_LinkedHashSet$LinkedHashSetIterator__f_cur = null;
  $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__(this, outer);
}
export { $c_scm_LinkedHashSet$$anon$2 as $c_scm_LinkedHashSet$$anon$2 };
$c_scm_LinkedHashSet$$anon$2.prototype = new $h_scm_LinkedHashSet$LinkedHashSetIterator();
$c_scm_LinkedHashSet$$anon$2.prototype.constructor = $c_scm_LinkedHashSet$$anon$2;
/** @constructor */
function $h_scm_LinkedHashSet$$anon$2() {
}
export { $h_scm_LinkedHashSet$$anon$2 as $h_scm_LinkedHashSet$$anon$2 };
$h_scm_LinkedHashSet$$anon$2.prototype = $c_scm_LinkedHashSet$$anon$2.prototype;
$c_scm_LinkedHashSet$$anon$2.prototype.extract__scm_LinkedHashSet$Entry__O = (function(nd) {
  return nd;
});
var $d_scm_LinkedHashSet$$anon$2 = new $TypeData().initClass($c_scm_LinkedHashSet$$anon$2, "scala.collection.mutable.LinkedHashSet$$anon$2", ({
  scm_LinkedHashSet$$anon$2: 1,
  scm_LinkedHashSet$LinkedHashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_LinkedHashSet$$anon$2 as $d_scm_LinkedHashSet$$anon$2 };
/** @constructor */
function $c_scm_LinkedHashSet$$anon$3(outer) {
  this.scm_LinkedHashSet$LinkedHashSetIterator__f_cur = null;
  this.scm_LinkedHashSet$$anon$3__f_hash = 0;
  this.scm_LinkedHashSet$$anon$3__f_$outer = null;
  this.scm_LinkedHashSet$$anon$3__f_$outer = outer;
  $ct_scm_LinkedHashSet$LinkedHashSetIterator__scm_LinkedHashSet__(this, outer);
  this.scm_LinkedHashSet$$anon$3__f_hash = 0;
}
export { $c_scm_LinkedHashSet$$anon$3 as $c_scm_LinkedHashSet$$anon$3 };
$c_scm_LinkedHashSet$$anon$3.prototype = new $h_scm_LinkedHashSet$LinkedHashSetIterator();
$c_scm_LinkedHashSet$$anon$3.prototype.constructor = $c_scm_LinkedHashSet$$anon$3;
/** @constructor */
function $h_scm_LinkedHashSet$$anon$3() {
}
export { $h_scm_LinkedHashSet$$anon$3 as $h_scm_LinkedHashSet$$anon$3 };
$h_scm_LinkedHashSet$$anon$3.prototype = $c_scm_LinkedHashSet$$anon$3.prototype;
$c_scm_LinkedHashSet$$anon$3.prototype.hashCode__I = (function() {
  return this.scm_LinkedHashSet$$anon$3__f_hash;
});
$c_scm_LinkedHashSet$$anon$3.prototype.extract__scm_LinkedHashSet$Entry__O = (function(nd) {
  var improvedHash = nd.scm_LinkedHashSet$Entry__f_hash;
  this.scm_LinkedHashSet$$anon$3__f_hash = (improvedHash ^ ((improvedHash >>> 16) | 0));
  return this;
});
var $d_scm_LinkedHashSet$$anon$3 = new $TypeData().initClass($c_scm_LinkedHashSet$$anon$3, "scala.collection.mutable.LinkedHashSet$$anon$3", ({
  scm_LinkedHashSet$$anon$3: 1,
  scm_LinkedHashSet$LinkedHashSetIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1
}));
export { $d_scm_LinkedHashSet$$anon$3 as $d_scm_LinkedHashSet$$anon$3 };
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$1() {
}
export { $c_s_concurrent_duration_Duration$$anon$1 as $c_s_concurrent_duration_Duration$$anon$1 };
$c_s_concurrent_duration_Duration$$anon$1.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$1.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$1;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$1() {
}
export { $h_s_concurrent_duration_Duration$$anon$1 as $h_s_concurrent_duration_Duration$$anon$1 };
$h_s_concurrent_duration_Duration$$anon$1.prototype = $c_s_concurrent_duration_Duration$$anon$1.prototype;
$c_s_concurrent_duration_Duration$$anon$1.prototype.toString__T = (function() {
  return "Duration.Undefined";
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.equals__O__Z = (function(other) {
  return false;
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.$plus__s_concurrent_duration_Duration__s_concurrent_duration_Duration = (function(other) {
  return this;
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : 1);
});
$c_s_concurrent_duration_Duration$$anon$1.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I(that);
});
var $d_s_concurrent_duration_Duration$$anon$1 = new $TypeData().initClass($c_s_concurrent_duration_Duration$$anon$1, "scala.concurrent.duration.Duration$$anon$1", ({
  s_concurrent_duration_Duration$$anon$1: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
export { $d_s_concurrent_duration_Duration$$anon$1 as $d_s_concurrent_duration_Duration$$anon$1 };
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$2() {
}
export { $c_s_concurrent_duration_Duration$$anon$2 as $c_s_concurrent_duration_Duration$$anon$2 };
$c_s_concurrent_duration_Duration$$anon$2.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$2.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$2;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$2() {
}
export { $h_s_concurrent_duration_Duration$$anon$2 as $h_s_concurrent_duration_Duration$$anon$2 };
$h_s_concurrent_duration_Duration$$anon$2.prototype = $c_s_concurrent_duration_Duration$$anon$2.prototype;
$c_s_concurrent_duration_Duration$$anon$2.prototype.toString__T = (function() {
  return "Duration.Inf";
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === $m_s_concurrent_duration_Duration$().s_concurrent_duration_Duration$__f_Undefined) ? (-1) : ((other === this) ? 0 : 1));
});
$c_s_concurrent_duration_Duration$$anon$2.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I(that);
});
var $d_s_concurrent_duration_Duration$$anon$2 = new $TypeData().initClass($c_s_concurrent_duration_Duration$$anon$2, "scala.concurrent.duration.Duration$$anon$2", ({
  s_concurrent_duration_Duration$$anon$2: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
export { $d_s_concurrent_duration_Duration$$anon$2 as $d_s_concurrent_duration_Duration$$anon$2 };
/** @constructor */
function $c_s_concurrent_duration_Duration$$anon$3() {
}
export { $c_s_concurrent_duration_Duration$$anon$3 as $c_s_concurrent_duration_Duration$$anon$3 };
$c_s_concurrent_duration_Duration$$anon$3.prototype = new $h_s_concurrent_duration_Duration$Infinite();
$c_s_concurrent_duration_Duration$$anon$3.prototype.constructor = $c_s_concurrent_duration_Duration$$anon$3;
/** @constructor */
function $h_s_concurrent_duration_Duration$$anon$3() {
}
export { $h_s_concurrent_duration_Duration$$anon$3 as $h_s_concurrent_duration_Duration$$anon$3 };
$h_s_concurrent_duration_Duration$$anon$3.prototype = $c_s_concurrent_duration_Duration$$anon$3.prototype;
$c_s_concurrent_duration_Duration$$anon$3.prototype.toString__T = (function() {
  return "Duration.MinusInf";
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__s_concurrent_duration_Duration__I = (function(other) {
  return ((other === this) ? 0 : (-1));
});
$c_s_concurrent_duration_Duration$$anon$3.prototype.compare__O__I = (function(that) {
  return this.compare__s_concurrent_duration_Duration__I(that);
});
var $d_s_concurrent_duration_Duration$$anon$3 = new $TypeData().initClass($c_s_concurrent_duration_Duration$$anon$3, "scala.concurrent.duration.Duration$$anon$3", ({
  s_concurrent_duration_Duration$$anon$3: 1,
  s_concurrent_duration_Duration$Infinite: 1,
  s_concurrent_duration_Duration: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
export { $d_s_concurrent_duration_Duration$$anon$3 as $d_s_concurrent_duration_Duration$$anon$3 };
/** @constructor */
function $c_s_math_LowPriorityOrderingImplicits$$anon$2(outer, asComparable$1) {
  this.s_math_LowPriorityOrderingImplicits$$anon$2__f_asComparable$1 = null;
  this.s_math_LowPriorityOrderingImplicits$$anon$2__f_asComparable$1 = asComparable$1;
}
export { $c_s_math_LowPriorityOrderingImplicits$$anon$2 as $c_s_math_LowPriorityOrderingImplicits$$anon$2 };
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype = new $h_O();
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.constructor = $c_s_math_LowPriorityOrderingImplicits$$anon$2;
/** @constructor */
function $h_s_math_LowPriorityOrderingImplicits$$anon$2() {
}
export { $h_s_math_LowPriorityOrderingImplicits$$anon$2 as $h_s_math_LowPriorityOrderingImplicits$$anon$2 };
$h_s_math_LowPriorityOrderingImplicits$$anon$2.prototype = $c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype;
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_LowPriorityOrderingImplicits$$anon$2.prototype.compare__O__O__I = (function(x, y) {
  return $dp_compareTo__O__I(this.s_math_LowPriorityOrderingImplicits$$anon$2__f_asComparable$1.apply__O__O(x), y);
});
var $d_s_math_LowPriorityOrderingImplicits$$anon$2 = new $TypeData().initClass($c_s_math_LowPriorityOrderingImplicits$$anon$2, "scala.math.LowPriorityOrderingImplicits$$anon$2", ({
  s_math_LowPriorityOrderingImplicits$$anon$2: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_LowPriorityOrderingImplicits$$anon$2 as $d_s_math_LowPriorityOrderingImplicits$$anon$2 };
/** @constructor */
function $c_s_math_Ordering$$anon$1(outer, f$1) {
  this.s_math_Ordering$$anon$1__f_$outer = null;
  this.s_math_Ordering$$anon$1__f_f$1 = null;
  this.s_math_Ordering$$anon$1__f_$outer = outer;
  this.s_math_Ordering$$anon$1__f_f$1 = f$1;
}
export { $c_s_math_Ordering$$anon$1 as $c_s_math_Ordering$$anon$1 };
$c_s_math_Ordering$$anon$1.prototype = new $h_O();
$c_s_math_Ordering$$anon$1.prototype.constructor = $c_s_math_Ordering$$anon$1;
/** @constructor */
function $h_s_math_Ordering$$anon$1() {
}
export { $h_s_math_Ordering$$anon$1 as $h_s_math_Ordering$$anon$1 };
$h_s_math_Ordering$$anon$1.prototype = $c_s_math_Ordering$$anon$1.prototype;
$c_s_math_Ordering$$anon$1.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$$anon$1.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$$anon$1.prototype.compare__O__O__I = (function(x, y) {
  return this.s_math_Ordering$$anon$1__f_$outer.compare__O__O__I(this.s_math_Ordering$$anon$1__f_f$1.apply__O__O(x), this.s_math_Ordering$$anon$1__f_f$1.apply__O__O(y));
});
var $d_s_math_Ordering$$anon$1 = new $TypeData().initClass($c_s_math_Ordering$$anon$1, "scala.math.Ordering$$anon$1", ({
  s_math_Ordering$$anon$1: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_Ordering$$anon$1 as $d_s_math_Ordering$$anon$1 };
/** @constructor */
function $c_s_math_Ordering$$anon$5(ord$2, f$3) {
  this.s_math_Ordering$$anon$5__f_ord$2 = null;
  this.s_math_Ordering$$anon$5__f_f$3 = null;
  this.s_math_Ordering$$anon$5__f_ord$2 = ord$2;
  this.s_math_Ordering$$anon$5__f_f$3 = f$3;
}
export { $c_s_math_Ordering$$anon$5 as $c_s_math_Ordering$$anon$5 };
$c_s_math_Ordering$$anon$5.prototype = new $h_O();
$c_s_math_Ordering$$anon$5.prototype.constructor = $c_s_math_Ordering$$anon$5;
/** @constructor */
function $h_s_math_Ordering$$anon$5() {
}
export { $h_s_math_Ordering$$anon$5 as $h_s_math_Ordering$$anon$5 };
$h_s_math_Ordering$$anon$5.prototype = $c_s_math_Ordering$$anon$5.prototype;
$c_s_math_Ordering$$anon$5.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$$anon$5.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$$anon$5.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$$anon$5.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$$anon$5.prototype.compare__O__O__I = (function(x, y) {
  return this.s_math_Ordering$$anon$5__f_ord$2.compare__O__O__I(this.s_math_Ordering$$anon$5__f_f$3.apply__O__O(x), this.s_math_Ordering$$anon$5__f_f$3.apply__O__O(y));
});
$c_s_math_Ordering$$anon$5.prototype.gt__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$$anon$5__f_ord$2.gt__O__O__Z(this.s_math_Ordering$$anon$5__f_f$3.apply__O__O(x), this.s_math_Ordering$$anon$5__f_f$3.apply__O__O(y));
});
$c_s_math_Ordering$$anon$5.prototype.gteq__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$$anon$5__f_ord$2.gteq__O__O__Z(this.s_math_Ordering$$anon$5__f_f$3.apply__O__O(x), this.s_math_Ordering$$anon$5__f_f$3.apply__O__O(y));
});
$c_s_math_Ordering$$anon$5.prototype.lteq__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$$anon$5__f_ord$2.lteq__O__O__Z(this.s_math_Ordering$$anon$5__f_f$3.apply__O__O(x), this.s_math_Ordering$$anon$5__f_f$3.apply__O__O(y));
});
var $d_s_math_Ordering$$anon$5 = new $TypeData().initClass($c_s_math_Ordering$$anon$5, "scala.math.Ordering$$anon$5", ({
  s_math_Ordering$$anon$5: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_Ordering$$anon$5 as $d_s_math_Ordering$$anon$5 };
function $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z($thiz, other) {
  return (other === $thiz.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse);
}
export { $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z as $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z };
function $f_s_math_Ordering$Double$IeeeOrdering__lteq__D__D__Z($thiz, x, y) {
  return (x <= y);
}
export { $f_s_math_Ordering$Double$IeeeOrdering__lteq__D__D__Z as $f_s_math_Ordering$Double$IeeeOrdering__lteq__D__D__Z };
function $f_s_math_Ordering$Double$IeeeOrdering__gteq__D__D__Z($thiz, x, y) {
  return (x >= y);
}
export { $f_s_math_Ordering$Double$IeeeOrdering__gteq__D__D__Z as $f_s_math_Ordering$Double$IeeeOrdering__gteq__D__D__Z };
function $f_s_math_Ordering$Double$IeeeOrdering__lt__D__D__Z($thiz, x, y) {
  return (x < y);
}
export { $f_s_math_Ordering$Double$IeeeOrdering__lt__D__D__Z as $f_s_math_Ordering$Double$IeeeOrdering__lt__D__D__Z };
function $f_s_math_Ordering$Double$IeeeOrdering__gt__D__D__Z($thiz, x, y) {
  return (x > y);
}
export { $f_s_math_Ordering$Double$IeeeOrdering__gt__D__D__Z as $f_s_math_Ordering$Double$IeeeOrdering__gt__D__D__Z };
function $f_s_math_Ordering$Double$IeeeOrdering__equiv__D__D__Z($thiz, x, y) {
  return (x === y);
}
export { $f_s_math_Ordering$Double$IeeeOrdering__equiv__D__D__Z as $f_s_math_Ordering$Double$IeeeOrdering__equiv__D__D__Z };
/** @constructor */
function $c_s_math_Ordering$Reverse(outer) {
  this.s_math_Ordering$Reverse__f_outer = null;
  this.s_math_Ordering$Reverse__f_outer = outer;
}
export { $c_s_math_Ordering$Reverse as $c_s_math_Ordering$Reverse };
$c_s_math_Ordering$Reverse.prototype = new $h_O();
$c_s_math_Ordering$Reverse.prototype.constructor = $c_s_math_Ordering$Reverse;
/** @constructor */
function $h_s_math_Ordering$Reverse() {
}
export { $h_s_math_Ordering$Reverse as $h_s_math_Ordering$Reverse };
$h_s_math_Ordering$Reverse.prototype = $c_s_math_Ordering$Reverse.prototype;
$c_s_math_Ordering$Reverse.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  var x$2 = this.s_math_Ordering$Reverse__f_outer;
  return ((other === null) ? (x$2 === null) : other.equals__O__Z(x$2));
});
$c_s_math_Ordering$Reverse.prototype.compare__O__O__I = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.compare__O__O__I(y, x);
});
$c_s_math_Ordering$Reverse.prototype.lteq__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.lteq__O__O__Z(y, x);
});
$c_s_math_Ordering$Reverse.prototype.gteq__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.gteq__O__O__Z(y, x);
});
$c_s_math_Ordering$Reverse.prototype.gt__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.gt__O__O__Z(y, x);
});
$c_s_math_Ordering$Reverse.prototype.equiv__O__O__Z = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.equiv__O__O__Z(y, x);
});
$c_s_math_Ordering$Reverse.prototype.max__O__O__O = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.min__O__O__O(x, y);
});
$c_s_math_Ordering$Reverse.prototype.min__O__O__O = (function(x, y) {
  return this.s_math_Ordering$Reverse__f_outer.max__O__O__O(x, y);
});
$c_s_math_Ordering$Reverse.prototype.equals__O__Z = (function(obj) {
  if ((obj !== null)) {
    if ((this === obj)) {
      return true;
    }
  }
  if ((obj instanceof $c_s_math_Ordering$Reverse)) {
    var x = this.s_math_Ordering$Reverse__f_outer;
    var x$2 = obj.s_math_Ordering$Reverse__f_outer;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  }
  return false;
});
$c_s_math_Ordering$Reverse.prototype.hashCode__I = (function() {
  return Math.imul(41, this.s_math_Ordering$Reverse__f_outer.hashCode__I());
});
function $isArrayOf_s_math_Ordering$Reverse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Ordering$Reverse)));
}
export { $isArrayOf_s_math_Ordering$Reverse as $isArrayOf_s_math_Ordering$Reverse };
var $d_s_math_Ordering$Reverse = new $TypeData().initClass($c_s_math_Ordering$Reverse, "scala.math.Ordering$Reverse", ({
  s_math_Ordering$Reverse: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_Ordering$Reverse as $d_s_math_Ordering$Reverse };
/** @constructor */
function $c_s_reflect_ClassTag$GenericClassTag(runtimeClass) {
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = null;
  this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass = runtimeClass;
}
export { $c_s_reflect_ClassTag$GenericClassTag as $c_s_reflect_ClassTag$GenericClassTag };
$c_s_reflect_ClassTag$GenericClassTag.prototype = new $h_O();
$c_s_reflect_ClassTag$GenericClassTag.prototype.constructor = $c_s_reflect_ClassTag$GenericClassTag;
/** @constructor */
function $h_s_reflect_ClassTag$GenericClassTag() {
}
export { $h_s_reflect_ClassTag$GenericClassTag as $h_s_reflect_ClassTag$GenericClassTag };
$h_s_reflect_ClassTag$GenericClassTag.prototype = $c_s_reflect_ClassTag$GenericClassTag.prototype;
$c_s_reflect_ClassTag$GenericClassTag.prototype.unapply__O__s_Option = (function(x) {
  return $f_s_reflect_ClassTag__unapply__O__s_Option(this, x);
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.equals__O__Z = (function(x) {
  return $f_s_reflect_ClassTag__equals__O__Z(this, x);
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.hashCode__I = (function() {
  var x = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return $m_sr_Statics$().anyHash__O__I(x);
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.toString__T = (function() {
  return $ps_s_reflect_ClassTag__prettyprint$1__jl_Class__T(this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass);
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.runtimeClass__jl_Class = (function() {
  return this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
});
$c_s_reflect_ClassTag$GenericClassTag.prototype.newArray__I__O = (function(len) {
  var componentType = this.s_reflect_ClassTag$GenericClassTag__f_runtimeClass;
  return componentType.data.newArray(len);
});
var $d_s_reflect_ClassTag$GenericClassTag = new $TypeData().initClass($c_s_reflect_ClassTag$GenericClassTag, "scala.reflect.ClassTag$GenericClassTag", ({
  s_reflect_ClassTag$GenericClassTag: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ClassTag$GenericClassTag as $d_s_reflect_ClassTag$GenericClassTag };
/** @constructor */
function $c_sr_RichBoolean(self) {
  this.sr_RichBoolean__f_self = false;
  this.sr_RichBoolean__f_self = self;
}
export { $c_sr_RichBoolean as $c_sr_RichBoolean };
$c_sr_RichBoolean.prototype = new $h_O();
$c_sr_RichBoolean.prototype.constructor = $c_sr_RichBoolean;
/** @constructor */
function $h_sr_RichBoolean() {
}
export { $h_sr_RichBoolean as $h_sr_RichBoolean };
$h_sr_RichBoolean.prototype = $c_sr_RichBoolean.prototype;
$c_sr_RichBoolean.prototype.compare__O__I = (function(y) {
  var x = this.sr_RichBoolean__f_self;
  var y$1 = (!(!y));
  return ((x === y$1) ? 0 : (x ? 1 : (-1)));
});
$c_sr_RichBoolean.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this);
});
$c_sr_RichBoolean.prototype.compareTo__O__I = (function(that) {
  var x = this.sr_RichBoolean__f_self;
  var y = (!(!that));
  return ((x === y) ? 0 : (x ? 1 : (-1)));
});
$c_sr_RichBoolean.prototype.hashCode__I = (function() {
  var this$ = this.sr_RichBoolean__f_self;
  return (this$ ? 1231 : 1237);
});
$c_sr_RichBoolean.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichBoolean$().equals$extension__Z__O__Z(this.sr_RichBoolean__f_self, x$1);
});
$c_sr_RichBoolean.prototype.self__O = (function() {
  return this.sr_RichBoolean__f_self;
});
function $isArrayOf_sr_RichBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichBoolean)));
}
export { $isArrayOf_sr_RichBoolean as $isArrayOf_sr_RichBoolean };
var $d_sr_RichBoolean = new $TypeData().initClass($c_sr_RichBoolean, "scala.runtime.RichBoolean", ({
  sr_RichBoolean: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1
}));
export { $d_sr_RichBoolean as $d_sr_RichBoolean };
function $p_Lscodec_bits_BitVector__getByte__J__I__Z__B($thiz, start, bits, signed) {
  var $x_1 = $m_s_Predef$();
  var hi = (bits >> 31);
  var alo = start.RTLong__f_lo;
  var lo = ((alo + bits) | 0);
  var hi$1 = ((((start.RTLong__f_hi + hi) | 0) + ((((alo & bits) | ((alo | bits) & (~lo))) >>> 31) | 0)) | 0);
  $x_1.require__Z__V((($thiz.sizeGreaterThanOrEqual__J__Z(new $c_RTLong(lo, hi$1)) && (bits >= 0)) && (bits <= 8)));
  var this$3 = $m_RTLong$();
  var lo$1 = this$3.divideImpl__I__I__I__I__I(start.RTLong__f_lo, start.RTLong__f_hi, 8, 0);
  var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var result = (255 & $thiz.getByte__J__B(new $c_RTLong(lo$1, hi$2)));
  if ((bits !== 0)) {
    result = ((result >>> ((8 - bits) | 0)) | 0);
  }
  if (((signed && (bits !== 8)) && (((1 << (((-1) + bits) | 0)) & result) !== 0))) {
    var toShift = ((32 - bits) | 0);
    result = ((result << toShift) >> toShift);
  }
  return ((result << 24) >> 24);
}
export { $p_Lscodec_bits_BitVector__getByte__J__I__Z__B as $p_Lscodec_bits_BitVector__getByte__J__I__Z__B };
function $p_Lscodec_bits_BitVector__getBigEndianShort__J__I__Z__S($thiz, start, bits, signed) {
  var $x_1 = $m_s_Predef$();
  var hi = (bits >> 31);
  var alo = start.RTLong__f_lo;
  var lo = ((alo + bits) | 0);
  var hi$1 = ((((start.RTLong__f_hi + hi) | 0) + ((((alo & bits) | ((alo | bits) & (~lo))) >>> 31) | 0)) | 0);
  $x_1.require__Z__V((($thiz.sizeGreaterThanOrEqual__J__Z(new $c_RTLong(lo, hi$1)) && (bits >= 0)) && (bits <= 16)));
  var mod = ((bits % 8) | 0);
  var elem = 0;
  elem = 0;
  var $x_2 = $m_Lscodec_bits_BitVector$();
  var hi$2 = (bits >> 31);
  var t = $x_2.scodec$bits$BitVector$$$bytesNeededForBits__J__J(new $c_RTLong(bits, hi$2));
  var lo$1 = t.RTLong__f_lo;
  var hi$3 = t.RTLong__f_hi;
  var this$5 = $m_RTLong$();
  var lo$2 = this$5.divideImpl__I__I__I__I__I(start.RTLong__f_lo, start.RTLong__f_hi, 8, 0);
  var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var i$tailLocal1 = 0;
  while (true) {
    var value = i$tailLocal1;
    var hi$5 = (value >> 31);
    if (((hi$5 === hi$3) ? ((value >>> 0) < (lo$1 >>> 0)) : (hi$5 < hi$3))) {
      var $x_3 = elem;
      var value$1 = i$tailLocal1;
      var hi$6 = (value$1 >> 31);
      var lo$3 = ((lo$2 + value$1) | 0);
      var hi$7 = ((((hi$4 + hi$6) | 0) + ((((lo$2 & value$1) | ((lo$2 | value$1) & (~lo$3))) >>> 31) | 0)) | 0);
      elem = (($x_3 << 8) | (255 & $thiz.getByte__J__B(new $c_RTLong(lo$3, hi$7))));
      i$tailLocal1 = ((1 + i$tailLocal1) | 0);
    } else {
      break;
    }
  }
  if ((mod !== 0)) {
    elem = ((elem >>> ((8 - mod) | 0)) | 0);
  }
  if (((signed && (bits !== 16)) && (((1 << (((-1) + bits) | 0)) & elem) !== 0))) {
    var toShift = ((32 - bits) | 0);
    elem = ((elem << toShift) >> toShift);
  }
  return ((elem << 16) >> 16);
}
export { $p_Lscodec_bits_BitVector__getBigEndianShort__J__I__Z__S as $p_Lscodec_bits_BitVector__getBigEndianShort__J__I__Z__S };
function $p_Lscodec_bits_BitVector__getBigEndianInt__J__I__Z__I($thiz, start, bits, signed) {
  var $x_1 = $m_s_Predef$();
  var hi = (bits >> 31);
  var alo = start.RTLong__f_lo;
  var lo = ((alo + bits) | 0);
  var hi$1 = ((((start.RTLong__f_hi + hi) | 0) + ((((alo & bits) | ((alo | bits) & (~lo))) >>> 31) | 0)) | 0);
  $x_1.require__Z__V((($thiz.sizeGreaterThanOrEqual__J__Z(new $c_RTLong(lo, hi$1)) && (bits >= 0)) && (bits <= 32)));
  var mod = ((bits % 8) | 0);
  var elem = 0;
  elem = 0;
  var $x_2 = $m_Lscodec_bits_BitVector$();
  var hi$2 = (bits >> 31);
  var t = $x_2.scodec$bits$BitVector$$$bytesNeededForBits__J__J(new $c_RTLong(bits, hi$2));
  var lo$1 = t.RTLong__f_lo;
  var hi$3 = t.RTLong__f_hi;
  var this$5 = $m_RTLong$();
  var lo$2 = this$5.divideImpl__I__I__I__I__I(start.RTLong__f_lo, start.RTLong__f_hi, 8, 0);
  var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var i$tailLocal2 = 0;
  while (true) {
    var value = i$tailLocal2;
    var hi$5 = (value >> 31);
    if (((hi$5 === hi$3) ? ((value >>> 0) < (lo$1 >>> 0)) : (hi$5 < hi$3))) {
      var $x_3 = elem;
      var value$1 = i$tailLocal2;
      var hi$6 = (value$1 >> 31);
      var lo$3 = ((lo$2 + value$1) | 0);
      var hi$7 = ((((hi$4 + hi$6) | 0) + ((((lo$2 & value$1) | ((lo$2 | value$1) & (~lo$3))) >>> 31) | 0)) | 0);
      elem = (($x_3 << 8) | (255 & $thiz.getByte__J__B(new $c_RTLong(lo$3, hi$7))));
      i$tailLocal2 = ((1 + i$tailLocal2) | 0);
    } else {
      break;
    }
  }
  if ((mod !== 0)) {
    elem = ((elem >>> ((8 - mod) | 0)) | 0);
  }
  if (((signed && (bits !== 32)) && (((1 << (((-1) + bits) | 0)) & elem) !== 0))) {
    var toShift = ((32 - bits) | 0);
    elem = ((elem << toShift) >> toShift);
  }
  return elem;
}
export { $p_Lscodec_bits_BitVector__getBigEndianInt__J__I__Z__I as $p_Lscodec_bits_BitVector__getBigEndianInt__J__I__Z__I };
function $p_Lscodec_bits_BitVector__getBigEndianLong__J__I__Z__J($thiz, start, bits, signed) {
  var $x_1 = $m_s_Predef$();
  var hi = (bits >> 31);
  var alo = start.RTLong__f_lo;
  var lo = ((alo + bits) | 0);
  var hi$1 = ((((start.RTLong__f_hi + hi) | 0) + ((((alo & bits) | ((alo | bits) & (~lo))) >>> 31) | 0)) | 0);
  $x_1.require__Z__V((($thiz.sizeGreaterThanOrEqual__J__Z(new $c_RTLong(lo, hi$1)) && (bits >= 0)) && (bits <= 64)));
  var mod = ((bits % 8) | 0);
  var elem__lo = 0;
  var elem__hi = 0;
  var $x_2__lo = 0;
  var $x_2__hi = 0;
  elem__lo = $x_2__lo;
  elem__hi = $x_2__hi;
  var $x_3 = $m_Lscodec_bits_BitVector$();
  var hi$2 = (bits >> 31);
  var t = $x_3.scodec$bits$BitVector$$$bytesNeededForBits__J__J(new $c_RTLong(bits, hi$2));
  var lo$1 = t.RTLong__f_lo;
  var hi$3 = t.RTLong__f_hi;
  var this$5 = $m_RTLong$();
  var lo$2 = this$5.divideImpl__I__I__I__I__I(start.RTLong__f_lo, start.RTLong__f_hi, 8, 0);
  var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var i$tailLocal3 = 0;
  while (true) {
    var value = i$tailLocal3;
    var hi$5 = (value >> 31);
    if (((hi$5 === hi$3) ? ((value >>> 0) < (lo$1 >>> 0)) : (hi$5 < hi$3))) {
      var a__lo = elem__lo;
      var a__hi = elem__hi;
      var lo$3 = a__lo;
      var lo$4 = (lo$3 << 8);
      var hi$6 = (((lo$3 >>> 24) | 0) | (a__hi << 8));
      var value$1 = i$tailLocal3;
      var hi$7 = (value$1 >> 31);
      var lo$5 = ((lo$2 + value$1) | 0);
      var hi$8 = ((((hi$4 + hi$7) | 0) + ((((lo$2 & value$1) | ((lo$2 | value$1) & (~lo$5))) >>> 31) | 0)) | 0);
      var value$2 = $thiz.getByte__J__B(new $c_RTLong(lo$5, hi$8));
      var lo$6 = (255 & value$2);
      var lo$7 = (lo$4 | lo$6);
      var $x_4__lo = lo$7;
      var $x_4__hi = hi$6;
      elem__lo = $x_4__lo;
      elem__hi = $x_4__hi;
      i$tailLocal3 = ((1 + i$tailLocal3) | 0);
    } else {
      break;
    }
  }
  if ((mod !== 0)) {
    var a$1__lo = elem__lo;
    var a$1__hi = elem__hi;
    var n = ((8 - mod) | 0);
    var hi$10 = a$1__hi;
    var lo$8 = (((32 & n) === 0) ? (((a$1__lo >>> n) | 0) | ((hi$10 << 1) << ((31 - n) | 0))) : ((hi$10 >>> n) | 0));
    var hi$11 = (((32 & n) === 0) ? ((hi$10 >>> n) | 0) : 0);
    var $x_5__lo = lo$8;
    var $x_5__hi = hi$11;
    elem__lo = $x_5__lo;
    elem__hi = $x_5__hi;
  }
  if ((signed && (bits !== 64))) {
    var n$1 = (((-1) + bits) | 0);
    var lo$9 = (((32 & n$1) === 0) ? (1 << n$1) : 0);
    var hi$12 = (((32 & n$1) === 0) ? 0 : (1 << n$1));
    var b__lo = elem__lo;
    var b__hi = elem__hi;
    var lo$10 = (lo$9 & b__lo);
    var hi$13 = (hi$12 & b__hi);
    var $x_6 = (!((lo$10 === 0) && (hi$13 === 0)));
  } else {
    var $x_6 = false;
  }
  if ($x_6) {
    var toShift = ((64 - bits) | 0);
    var a$2__lo = elem__lo;
    var a$2__hi = elem__hi;
    var lo$11 = a$2__lo;
    var lo$12 = (((32 & toShift) === 0) ? (lo$11 << toShift) : 0);
    var hi$14 = (((32 & toShift) === 0) ? (((((lo$11 >>> 1) | 0) >>> ((31 - toShift) | 0)) | 0) | (a$2__hi << toShift)) : (lo$11 << toShift));
    var lo$13 = (((32 & toShift) === 0) ? (((lo$12 >>> toShift) | 0) | ((hi$14 << 1) << ((31 - toShift) | 0))) : (hi$14 >> toShift));
    var hi$15 = (((32 & toShift) === 0) ? (hi$14 >> toShift) : (hi$14 >> 31));
    var $x_7__lo = lo$13;
    var $x_7__hi = hi$15;
    elem__lo = $x_7__lo;
    elem__hi = $x_7__hi;
  }
  return new $c_RTLong(elem__lo, elem__hi);
}
export { $p_Lscodec_bits_BitVector__getBigEndianLong__J__I__Z__J as $p_Lscodec_bits_BitVector__getBigEndianLong__J__I__Z__J };
function $p_Lscodec_bits_BitVector__getBigEndianBigInt__J__I__Z__s_math_BigInt($thiz, start, bits, signed) {
  var $x_1 = $m_s_Predef$();
  var hi = (bits >> 31);
  var alo = start.RTLong__f_lo;
  var lo = ((alo + bits) | 0);
  var hi$1 = ((((start.RTLong__f_hi + hi) | 0) + ((((alo & bits) | ((alo | bits) & (~lo))) >>> 31) | 0)) | 0);
  $x_1.require__Z__V(($thiz.sizeGreaterThanOrEqual__J__Z(new $c_RTLong(lo, hi$1)) && (bits >= 0)));
  if ((bits === 0)) {
    return $m_s_package$().BigInt__s_math_BigInt$().apply__I__s_math_BigInt(0);
  } else {
    var firstBit = $thiz.get__J__Z(start);
    var signBit = (signed && firstBit);
    var explicitZeroSignBit = ((!signed) && firstBit);
    var explicitZeroSign = (explicitZeroSignBit ? $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_zero : $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_empty);
    var hi$2 = (bits >> 31);
    var b = explicitZeroSign.size__J();
    var blo = b.RTLong__f_lo;
    var lo$1 = ((bits + blo) | 0);
    var hi$3 = ((((hi$2 + b.RTLong__f_hi) | 0) + ((((bits & blo) | ((bits | blo) & (~lo$1))) >>> 31) | 0)) | 0);
    var this$5 = $m_RTLong$();
    var lo$2 = this$5.remainderImpl__I__I__I__I__I(lo$1, hi$3, 8, 0);
    var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((lo$2 === 0) && (hi$4 === 0))) {
      var pad = $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_empty;
    } else {
      var $x_2 = $m_Lscodec_bits_BitVector$();
      var lo$3 = ((8 - lo$2) | 0);
      var hi$5 = ((((-hi$4) | 0) + ((lo$2 | lo$3) >> 31)) | 0);
      var pad = $x_2.fill__J__Z__Lscodec_bits_BitVector(new $c_RTLong(lo$3, hi$5), signBit);
    }
    var $x_3 = explicitZeroSign.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(pad);
    var hi$6 = (bits >> 31);
    var alo$1 = start.RTLong__f_lo;
    var lo$4 = ((alo$1 + bits) | 0);
    var hi$7 = ((((start.RTLong__f_hi + hi$6) | 0) + ((((alo$1 & bits) | ((alo$1 | bits) & (~lo$4))) >>> 31) | 0)) | 0);
    var this$10 = $x_3.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector($thiz.slice__J__J__Lscodec_bits_BitVector(start, new $c_RTLong(lo$4, hi$7)));
    var arr = this$10.toByteVector__Lscodec_bits_ByteVector().toArray__AB();
    return $m_s_package$().BigInt__s_math_BigInt$().apply__AB__s_math_BigInt(arr);
  }
}
export { $p_Lscodec_bits_BitVector__getBigEndianBigInt__J__I__Z__s_math_BigInt as $p_Lscodec_bits_BitVector__getBigEndianBigInt__J__I__Z__s_math_BigInt };
function $ps_Lscodec_bits_BitVector__go$3__sci_List__sci_Vector__sci_Vector(b, acc) {
  var acc$tailLocal2 = acc;
  var b$tailLocal3 = b;
  while (true) {
    var x10 = b$tailLocal3;
    if ((x10 instanceof $c_sci_$colon$colon)) {
      var x34 = x10.sci_$colon$colon__f_head;
      var x35 = x10.sci_$colon$colon__f_next;
      if (false) {
        var elem$1 = x34.underlying__Lscodec_bits_BitVector();
        b$tailLocal3 = new $c_sci_$colon$colon(elem$1, x35);
        continue;
      }
      if ((x34 instanceof $c_Lscodec_bits_BitVector$Bytes)) {
        var t = x34.Lscodec_bits_BitVector$Bytes__f_size;
        var this$3 = acc$tailLocal2;
        var acc$tailLocal2$tmp1 = this$3.appended__O__O(x34);
        b$tailLocal3 = x35;
        acc$tailLocal2 = acc$tailLocal2$tmp1;
        continue;
      }
      if ((x34 instanceof $c_Lscodec_bits_BitVector$Append)) {
        var x24 = x34.Lscodec_bits_BitVector$Append__f_left;
        var x25 = x34.Lscodec_bits_BitVector$Append__f_right;
        var this$5 = new $c_sci_$colon$colon(x25, x35);
        b$tailLocal3 = new $c_sci_$colon$colon(x24, this$5);
        continue;
      }
      if ((x34 instanceof $c_Lscodec_bits_BitVector$Drop)) {
        var this$6 = acc$tailLocal2;
        var elem = x34.interpretDrop__Lscodec_bits_BitVector$Bytes();
        var acc$tailLocal2$tmp2 = this$6.appended__O__O(elem);
        b$tailLocal3 = x35;
        acc$tailLocal2 = acc$tailLocal2$tmp2;
        continue;
      }
      if ((x34 instanceof $c_Lscodec_bits_BitVector$Chunks)) {
        var elem$2 = x34.Lscodec_bits_BitVector$Chunks__f_chunks.Lscodec_bits_BitVector$Append__f_right;
        var this$7 = new $c_sci_$colon$colon(elem$2, x35);
        var elem$3 = x34.Lscodec_bits_BitVector$Chunks__f_chunks.Lscodec_bits_BitVector$Append__f_left;
        b$tailLocal3 = new $c_sci_$colon$colon(elem$3, this$7);
        continue;
      }
    }
    return acc$tailLocal2;
  }
}
export { $ps_Lscodec_bits_BitVector__go$3__sci_List__sci_Vector__sci_Vector as $ps_Lscodec_bits_BitVector__go$3__sci_List__sci_Vector__sci_Vector };
function $ps_Lscodec_bits_BitVector__go$8__J__Lscodec_bits_BitVector__Lscodec_bits_BitVector__Z(chunkSize$1, x, y) {
  var y$tailLocal1 = y;
  var x$tailLocal1 = x;
  while (true) {
    var this$1 = x$tailLocal1;
    if (this$1.sizeLessThan__J__Z(new $c_RTLong(1, 0))) {
      var this$2 = y$tailLocal1;
      return this$2.sizeLessThan__J__Z(new $c_RTLong(1, 0));
    } else {
      var chunkX = x$tailLocal1.take__J__Lscodec_bits_BitVector(chunkSize$1);
      var chunkY = y$tailLocal1.take__J__Lscodec_bits_BitVector(chunkSize$1);
      if (chunkX.toByteVector__Lscodec_bits_ByteVector().$eq$eq$eq__Lscodec_bits_ByteVector__Z(chunkY.toByteVector__Lscodec_bits_ByteVector())) {
        var x$tailLocal1$tmp1 = x$tailLocal1.drop__J__Lscodec_bits_BitVector(chunkSize$1);
        var y$tailLocal1$tmp1 = y$tailLocal1.drop__J__Lscodec_bits_BitVector(chunkSize$1);
        x$tailLocal1 = x$tailLocal1$tmp1;
        y$tailLocal1 = y$tailLocal1$tmp1;
      } else {
        return false;
      }
    }
  }
}
export { $ps_Lscodec_bits_BitVector__go$8__J__Lscodec_bits_BitVector__Lscodec_bits_BitVector__Z as $ps_Lscodec_bits_BitVector__go$8__J__Lscodec_bits_BitVector__Lscodec_bits_BitVector__Z };
function $ps_Lscodec_bits_BitVector__go$9__J__Lscodec_bits_BitVector__I__I__I(chunkSize$2, bits, h, iter) {
  var iter$tailLocal1 = iter;
  var h$tailLocal1 = h;
  var bits$tailLocal1 = bits;
  while (true) {
    var this$1 = bits$tailLocal1;
    if (this$1.sizeLessThan__J__Z(new $c_RTLong(1, 0))) {
      return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h$tailLocal1, iter$tailLocal1);
    } else {
      var bits$tailLocal1$tmp1 = bits$tailLocal1.drop__J__Lscodec_bits_BitVector(chunkSize$2);
      var $x_2 = $m_s_util_hashing_MurmurHash3$();
      var $x_1 = h$tailLocal1;
      var this$3 = $m_s_util_hashing_MurmurHash3$();
      var this$2 = bits$tailLocal1.take__J__Lscodec_bits_BitVector(chunkSize$2);
      var data = this$2.toByteVector__Lscodec_bits_ByteVector().toArray__AB();
      var h$tailLocal1$tmp1 = $x_2.mix__I__I__I($x_1, this$3.bytesHash__AB__I__I(data, 1007110753));
      var iter$tailLocal1$tmp1 = ((1 + iter$tailLocal1) | 0);
      bits$tailLocal1 = bits$tailLocal1$tmp1;
      h$tailLocal1 = h$tailLocal1$tmp1;
      iter$tailLocal1 = iter$tailLocal1$tmp1;
    }
  }
}
export { $ps_Lscodec_bits_BitVector__go$9__J__Lscodec_bits_BitVector__I__I__I as $ps_Lscodec_bits_BitVector__go$9__J__Lscodec_bits_BitVector__I__I__I };
/** @constructor */
function $c_Lscodec_bits_BitVector() {
  this.Lscodec_bits_BitVector__f_hashCode$lzy1 = 0;
  this.Lscodec_bits_BitVector__f_hashCodebitmap$1 = false;
}
export { $c_Lscodec_bits_BitVector as $c_Lscodec_bits_BitVector };
$c_Lscodec_bits_BitVector.prototype = new $h_O();
$c_Lscodec_bits_BitVector.prototype.constructor = $c_Lscodec_bits_BitVector;
/** @constructor */
function $h_Lscodec_bits_BitVector() {
}
export { $h_Lscodec_bits_BitVector as $h_Lscodec_bits_BitVector };
$h_Lscodec_bits_BitVector.prototype = $c_Lscodec_bits_BitVector.prototype;
$c_Lscodec_bits_BitVector.prototype.compareTo__O__I = (function(that) {
  return this.compare__Lscodec_bits_BitVector__I(that);
});
$c_Lscodec_bits_BitVector.prototype.sizeGreaterThan__J__Z = (function(n) {
  var ahi = n.RTLong__f_hi;
  if ((ahi < 0)) {
    return true;
  } else {
    return (!this.sizeLessThanOrEqual__J__Z(n));
  }
});
$c_Lscodec_bits_BitVector.prototype.sizeGreaterThanOrEqual__J__Z = (function(n) {
  var ahi = n.RTLong__f_hi;
  if ((ahi < 0)) {
    return true;
  } else {
    var blo = n.RTLong__f_lo;
    var lo = (((-1) + blo) | 0);
    var hi = (((((-1) + n.RTLong__f_hi) | 0) + (((blo | (~lo)) >>> 31) | 0)) | 0);
    return (!this.sizeLessThanOrEqual__J__Z(new $c_RTLong(lo, hi)));
  }
});
$c_Lscodec_bits_BitVector.prototype.sizeLessThanOrEqual__J__Z = (function(n) {
  if (((n.RTLong__f_lo === (-1)) && (n.RTLong__f_hi === 2147483647))) {
    return true;
  } else {
    var blo = n.RTLong__f_lo;
    var lo = ((1 + blo) | 0);
    var hi = ((n.RTLong__f_hi + (((blo & (~lo)) >>> 31) | 0)) | 0);
    return this.sizeLessThan__J__Z(new $c_RTLong(lo, hi));
  }
});
$c_Lscodec_bits_BitVector.prototype.unchunk__Lscodec_bits_BitVector = (function() {
  return this;
});
$c_Lscodec_bits_BitVector.prototype.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector = (function(b2) {
  if (this.sizeLessThan__J__Z(new $c_RTLong(1, 0))) {
    return b2;
  } else {
    var chunks = new $c_Lscodec_bits_BitVector$Append(this, b2);
    return new $c_Lscodec_bits_BitVector$Chunks(chunks);
  }
});
$c_Lscodec_bits_BitVector.prototype.takeRight__J__Lscodec_bits_BitVector = (function(n) {
  var ahi = n.RTLong__f_hi;
  if ((ahi < 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("takeRight(" + n) + ")"));
  } else {
    var b = this.size__J();
    var ahi$1 = n.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    if (((ahi$1 === bhi) ? ((n.RTLong__f_lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (ahi$1 > bhi))) {
      return this;
    } else {
      var a = this.size__J();
      var alo = a.RTLong__f_lo;
      var blo = n.RTLong__f_lo;
      var lo = ((alo - blo) | 0);
      var hi = ((((a.RTLong__f_hi - n.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
      return this.drop__J__Lscodec_bits_BitVector(new $c_RTLong(lo, hi));
    }
  }
});
$c_Lscodec_bits_BitVector.prototype.splitAt__J__T2 = (function(n) {
  var _1 = this.take__J__Lscodec_bits_BitVector(n);
  var _2 = this.drop__J__Lscodec_bits_BitVector(n);
  return $ct_T2__O__O__(new $c_T2(), _1, _2);
});
$c_Lscodec_bits_BitVector.prototype.slice__J__J__Lscodec_bits_BitVector = (function(from, until) {
  var $x_1 = this.drop__J__Lscodec_bits_BitVector(from);
  var ahi = from.RTLong__f_hi;
  if (((ahi === 0) ? (from.RTLong__f_lo !== 0) : (ahi > 0))) {
    var b = from;
  } else {
    var b = $L0;
  }
  var alo = until.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var lo = ((alo - blo) | 0);
  var hi = ((((until.RTLong__f_hi - b.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
  return $x_1.take__J__Lscodec_bits_BitVector(new $c_RTLong(lo, hi));
});
$c_Lscodec_bits_BitVector.prototype.acquire__J__s_util_Either = (function(n) {
  if (this.sizeGreaterThanOrEqual__J__Z(n)) {
    var value = this.take__J__Lscodec_bits_BitVector(n);
    return new $c_s_util_Right(value);
  } else {
    var value$1 = (((("cannot acquire " + n) + " bits from a vector that contains ") + this.size__J()) + " bits");
    return new $c_s_util_Left(value$1);
  }
});
$c_Lscodec_bits_BitVector.prototype.padRight__J__Lscodec_bits_BitVector = (function(n) {
  var b = this.size__J();
  var ahi = n.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? ((n.RTLong__f_lo >>> 0) < (b.RTLong__f_lo >>> 0)) : (ahi < bhi))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (((("Trying to right-pad a vector of " + this.size__J()) + " bits to only ") + n) + " bits."));
  } else {
    var $x_1 = $m_Lscodec_bits_BitVector$();
    var b$1 = this.size__J();
    var alo = n.RTLong__f_lo;
    var blo = b$1.RTLong__f_lo;
    var lo = ((alo - blo) | 0);
    var hi = ((((n.RTLong__f_hi - b$1.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
    return this.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector($x_1.fill__J__Z__Lscodec_bits_BitVector(new $c_RTLong(lo, hi), false));
  }
});
$c_Lscodec_bits_BitVector.prototype.reverseByteOrder__Lscodec_bits_BitVector = (function() {
  var a = this.size__J();
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 8, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((lo === 0) && (hi === 0))) {
    return $m_Lscodec_bits_BitVector$().toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes(this.compact__Lscodec_bits_BitVector$Bytes().Lscodec_bits_BitVector$Bytes__f_underlying.reverse__Lscodec_bits_ByteVector(), this.size__J());
  } else {
    var t = $m_Lscodec_bits_BitVector$().scodec$bits$BitVector$$$validBitsInLastByte__J__J(this.size__J());
    var lo$1 = t.RTLong__f_lo;
    var hi$1 = t.RTLong__f_hi;
    var last = this.take__J__Lscodec_bits_BitVector(new $c_RTLong(lo$1, hi$1)).compact__Lscodec_bits_BitVector$Bytes();
    var b = this.drop__J__Lscodec_bits_BitVector(new $c_RTLong(lo$1, hi$1)).toByteVector__Lscodec_bits_ByteVector().reverse__Lscodec_bits_ByteVector();
    var $x_1 = $m_Lscodec_bits_BitVector$();
    var a$1 = this.size__J();
    var b$1 = last.Lscodec_bits_BitVector$Bytes__f_size;
    var alo = a$1.RTLong__f_lo;
    var blo = b$1.RTLong__f_lo;
    var lo$2 = ((alo - blo) | 0);
    var hi$2 = ((((a$1.RTLong__f_hi - b$1.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo$2)) >> 31)) | 0);
    var init = $x_1.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes(b, new $c_RTLong(lo$2, hi$2));
    return init.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(last);
  }
});
$c_Lscodec_bits_BitVector.prototype.invertReverseByteOrder__Lscodec_bits_BitVector = (function() {
  var a = this.size__J();
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 8, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((lo === 0) && (hi === 0))) {
    return this.reverseByteOrder__Lscodec_bits_BitVector();
  } else {
    var t = $m_Lscodec_bits_BitVector$().scodec$bits$BitVector$$$validBitsInLastByte__J__J(this.size__J());
    var lo$1 = t.RTLong__f_lo;
    var hi$1 = t.RTLong__f_hi;
    matchResult2: {
      var \u03b41$___1;
      var \u03b41$___2;
      var a$1 = this.size__J();
      var alo = a$1.RTLong__f_lo;
      var lo$2 = ((alo - lo$1) | 0);
      var hi$2 = ((((a$1.RTLong__f_hi - hi$1) | 0) + ((((~alo) & lo$1) | ((~(alo ^ lo$1)) & lo$2)) >> 31)) | 0);
      var x7 = this.splitAt__J__T2(new $c_RTLong(lo$2, hi$2));
      if ((x7 !== null)) {
        var init = x7._1__O();
        var last = x7._2__O();
        var \u03b41$___1 = init;
        var \u03b41$___2 = last;
        break matchResult2;
      }
      throw new $c_s_MatchError(x7);
    }
    var init$2 = \u03b41$___1;
    var last$2 = \u03b41$___2;
    var this$5 = init$2.toByteVector__Lscodec_bits_ByteVector().reverse__Lscodec_bits_ByteVector();
    return last$2.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector($m_Lscodec_bits_BitVector$().apply__Lscodec_bits_ByteVector__Lscodec_bits_BitVector(this$5));
  }
});
$c_Lscodec_bits_BitVector.prototype.shiftLeft__J__Lscodec_bits_BitVector = (function(n) {
  var ahi = n.RTLong__f_hi;
  if (((ahi === 0) ? (n.RTLong__f_lo === 0) : (ahi < 0))) {
    return this;
  } else {
    var b = this.size__J();
    var ahi$1 = n.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    if (((ahi$1 === bhi) ? ((n.RTLong__f_lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (ahi$1 > bhi))) {
      var this$3 = $m_Lscodec_bits_BitVector$();
      var t = this.size__J();
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      return this$3.fill__J__Z__Lscodec_bits_BitVector(new $c_RTLong(lo, hi), false);
    } else {
      var $x_1 = this.drop__J__Lscodec_bits_BitVector(n);
      var this$4 = $m_Lscodec_bits_BitVector$();
      return $x_1.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(this$4.fill__J__Z__Lscodec_bits_BitVector(n, false));
    }
  }
});
$c_Lscodec_bits_BitVector.prototype.compact__Lscodec_bits_BitVector$Bytes = (function() {
  var a = $m_Lscodec_bits_BitVector$().scodec$bits$BitVector$$$bytesNeededForBits__J__J(this.size__J());
  var ahi = a.RTLong__f_hi;
  if (((ahi === 0) ? ((a.RTLong__f_lo >>> 0) > 2147483647) : (ahi > 0))) {
    var a$1 = this.size__J();
    var lo = a$1.RTLong__f_lo;
    var hi = a$1.RTLong__f_hi;
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("cannot compact bit vector of size " + ((((4.294967296E9 * hi) + (lo >>> 0.0)) / 8.0) / 1.0E9)) + " GB"));
  }
  if ((this instanceof $c_Lscodec_bits_BitVector$Bytes)) {
    var x47 = this.Lscodec_bits_BitVector$Bytes__f_underlying;
    var t = this.Lscodec_bits_BitVector$Bytes__f_size;
    var lo$1 = t.RTLong__f_lo;
    var hi$1 = t.RTLong__f_hi;
    var b2 = x47.compact__Lscodec_bits_ByteVector();
    return ((b2 === x47) ? this : new $c_Lscodec_bits_BitVector$Bytes(b2, new $c_RTLong(lo$1, hi$1)));
  } else if ((this instanceof $c_Lscodec_bits_BitVector$Drop)) {
    var bs$2 = this.interpretDrop__Lscodec_bits_BitVector$Bytes();
    var b2$2 = bs$2.Lscodec_bits_BitVector$Bytes__f_underlying.compact__Lscodec_bits_ByteVector();
    if ((b2$2 === bs$2.Lscodec_bits_BitVector$Bytes__f_underlying)) {
      return bs$2;
    } else {
      var t$1 = bs$2.Lscodec_bits_BitVector$Bytes__f_size;
      var lo$2 = t$1.RTLong__f_lo;
      var hi$2 = t$1.RTLong__f_hi;
      return new $c_Lscodec_bits_BitVector$Bytes(b2$2, new $c_RTLong(lo$2, hi$2));
    }
  } else {
    $m_Lscodec_bits_BitVector$();
    var $x_1 = new $c_sci_$colon$colon(this, $m_sci_Nil$());
    var this$6 = $m_sci_Vector$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($d_sr_Nothing$.getArrayOf().constr)([]));
    var v = $ps_Lscodec_bits_BitVector__go$3__sci_List__sci_Vector__sci_Vector($x_1, this$6.from__sc_IterableOnce__sci_Vector(elems));
    var f = ((_$11, _$12) => _$11.combine__Lscodec_bits_BitVector$Bytes__Lscodec_bits_BitVector$Bytes(_$12));
    var z = $m_sci_Nil$();
    var at = 0;
    var end = v.length__I();
    var acc = z;
    var $x_2;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = v.apply__I__O(at);
        var t$2 = x1.Lscodec_bits_BitVector$Bytes__f_size;
        var lo$3 = t$2.RTLong__f_lo;
        var hi$3 = t$2.RTLong__f_hi;
        var elem$5 = $ct_T2__O__O__(new $c_T2(), x1, new $c_RTLong(lo$3, hi$3));
        var stack = new $c_sci_$colon$colon(elem$5, x0);
        var temp$acc;
        var stack$tailLocal1 = stack;
        while (true) {
          var x189 = stack$tailLocal1;
          if ((x189 instanceof $c_sci_$colon$colon)) {
            var x191 = x189.sci_$colon$colon__f_head;
            var x192 = x189.sci_$colon$colon__f_next;
            if ((x191 !== null)) {
              var h2 = x191._1__O();
              var t$3 = $uJ(x191._2__O());
              var lo$4 = t$3.RTLong__f_lo;
              var hi$4 = t$3.RTLong__f_hi;
              if ((x192 instanceof $c_sci_$colon$colon)) {
                var x194 = x192.sci_$colon$colon__f_head;
                var x195 = x192.sci_$colon$colon__f_next;
                if ((x194 !== null)) {
                  var h = x194._1__O();
                  var t$4 = $uJ(x194._2__O());
                  var lo$5 = t$4.RTLong__f_lo;
                  var hi$5 = t$4.RTLong__f_hi;
                  var this$10 = $m_RTLong$();
                  var lo$6 = this$10.divideImpl__I__I__I__I__I(lo$5, hi$5, 2, 0);
                  var hi$6 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  if (((hi$4 === hi$6) ? ((lo$4 >>> 0) > (lo$6 >>> 0)) : (hi$4 > hi$6))) {
                    var _1 = f(h, h2);
                    var lo$7 = ((lo$5 + lo$4) | 0);
                    var hi$7 = ((((hi$5 + hi$4) | 0) + ((((lo$5 & lo$4) | ((lo$5 | lo$4) & (~lo$7))) >>> 31) | 0)) | 0);
                    var elem$4 = $ct_T2__O__O__(new $c_T2(), _1, new $c_RTLong(lo$7, hi$7));
                    stack$tailLocal1 = new $c_sci_$colon$colon(elem$4, x195);
                    continue;
                  }
                }
              }
            }
          }
          var temp$acc = stack$tailLocal1;
          break;
        }
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_2 = acc;
      break;
    }
    var this$14 = $x_2.reverse__sci_List();
    var f$1 = ((_$30) => _$30._1__O());
    if ((this$14 === $m_sci_Nil$())) {
      var this$15 = $m_sci_Nil$();
    } else {
      var x0$1 = this$14.head__O();
      var h$1 = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
      var t$5 = h$1;
      var rest = this$14.tail__O();
      while ((rest !== $m_sci_Nil$())) {
        var x0$2 = rest.head__O();
        var nx = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
        t$5.sci_$colon$colon__f_next = nx;
        t$5 = nx;
        rest = rest.tail__O();
      }
      var this$15 = h$1;
    }
    matchEnd4: {
      var $x_3;
      if ($is_sc_IndexedSeq(this$15)) {
        if ((this$15.length__I() > 0)) {
          var z$1 = this$15.apply__I__O(0);
          var at$1 = 1;
          var end$1 = this$15.length__I();
          var acc$1 = z$1;
          while (true) {
            if ((at$1 !== end$1)) {
              var temp$at$1 = ((1 + at$1) | 0);
              var x0$3 = acc$1;
              var x1$1 = this$15.apply__I__O(at$1);
              var temp$acc$1 = f(x0$3, x1$1);
              at$1 = temp$at$1;
              acc$1 = temp$acc$1;
              continue;
            }
            var $x_3 = acc$1;
            break matchEnd4;
          }
        }
      }
      if ((this$15.knownSize__I() === 0)) {
        throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
      }
      var it = this$15.iterator__sc_Iterator();
      if ((!it.hasNext__Z())) {
        throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
      }
      var acc$2 = it.next__O();
      while (it.hasNext__Z()) {
        var x0$4 = acc$2;
        var x1$2 = it.next__O();
        acc$2 = f(x0$4, x1$2);
      }
      var $x_3 = acc$2;
    }
    var x39 = $x_3;
    if ((x39 !== null)) {
      var x41 = x39.Lscodec_bits_BitVector$Bytes__f_underlying;
      var t$6 = x39.Lscodec_bits_BitVector$Bytes__f_size;
      var lo$8 = t$6.RTLong__f_lo;
      var hi$8 = t$6.RTLong__f_hi;
      var underlying = x41.compact__Lscodec_bits_ByteVector();
      return new $c_Lscodec_bits_BitVector$Bytes(underlying, new $c_RTLong(lo$8, hi$8));
    }
    throw new $c_s_MatchError(x39);
  }
});
$c_Lscodec_bits_BitVector.prototype.toByteVector__Lscodec_bits_ByteVector = (function() {
  return $m_Lscodec_bits_BitVector$().scodec$bits$BitVector$$$clearUnneededBits__J__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(this.size__J(), this.compact__Lscodec_bits_BitVector$Bytes().Lscodec_bits_BitVector$Bytes__f_underlying);
});
$c_Lscodec_bits_BitVector.prototype.toHex__Lscodec_bits_Bases$HexAlphabet__T = (function(alphabet) {
  var full = this.toByteVector__Lscodec_bits_ByteVector().toHex__Lscodec_bits_Bases$HexAlphabet__T(alphabet);
  var a = this.size__J();
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 8, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((lo === 0) && (hi === 0))) {
    return full;
  }
  if (((hi === 0) ? ((lo >>> 0) <= 4) : (hi < 0))) {
    return $m_sc_StringOps$().init$extension__T__T(full);
  }
  return full;
});
$c_Lscodec_bits_BitVector.prototype.toByte__Z__B = (function(signed) {
  $m_s_Predef$().require__Z__V(this.sizeLessThanOrEqual__J__Z(new $c_RTLong(8, 0)));
  if (this.sizeLessThan__J__Z(new $c_RTLong(1, 0))) {
    return 0;
  } else {
    var a = this.size__J();
    return $p_Lscodec_bits_BitVector__getByte__J__I__Z__B(this, $L0, a.RTLong__f_lo, signed);
  }
});
$c_Lscodec_bits_BitVector.prototype.toShort__Z__Lscodec_bits_ByteOrdering__S = (function(signed, ordering) {
  var \u03b4this$tailLocal3 = this;
  var ordering$tailLocal2 = ordering;
  while (true) {
    $m_s_Predef$().require__Z__V(\u03b4this$tailLocal3.sizeLessThanOrEqual__J__Z(new $c_RTLong(16, 0)));
    var x = ordering$tailLocal2;
    var x$2 = $m_Lscodec_bits_ByteOrdering$LittleEndian$();
    if (((x !== null) && (x === x$2))) {
      var \u03b4this$tailLocal3$tmp1 = \u03b4this$tailLocal3.invertReverseByteOrder__Lscodec_bits_BitVector();
      var ordering$tailLocal2$tmp1 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
      \u03b4this$tailLocal3 = \u03b4this$tailLocal3$tmp1;
      ordering$tailLocal2 = ordering$tailLocal2$tmp1;
    } else {
      var $x_1 = \u03b4this$tailLocal3;
      var a = \u03b4this$tailLocal3.size__J();
      return $p_Lscodec_bits_BitVector__getBigEndianShort__J__I__Z__S($x_1, $L0, a.RTLong__f_lo, signed);
    }
  }
});
$c_Lscodec_bits_BitVector.prototype.toInt__Z__Lscodec_bits_ByteOrdering__I = (function(signed, ordering) {
  var \u03b4this$tailLocal5 = this;
  var ordering$tailLocal4 = ordering;
  while (true) {
    $m_s_Predef$().require__Z__V(\u03b4this$tailLocal5.sizeLessThanOrEqual__J__Z(new $c_RTLong(32, 0)));
    var x76 = \u03b4this$tailLocal5;
    if ((x76 instanceof $c_Lscodec_bits_BitVector$Bytes)) {
      var a = \u03b4this$tailLocal5.size__J();
      var x75 = a.RTLong__f_lo;
      if (((x75 === 32) && signed)) {
        return x76.Lscodec_bits_BitVector$Bytes__f_underlying.toByteBuffer__Ljava_nio_ByteBuffer().order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer(ordering$tailLocal4.toJava__Ljava_nio_ByteOrder()).getInt__I();
      }
      if ((x75 === 16)) {
        var sh = x76.Lscodec_bits_BitVector$Bytes__f_underlying.toByteBuffer__Ljava_nio_ByteBuffer().order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer(ordering$tailLocal4.toJava__Ljava_nio_ByteOrder()).getShort__S();
        return (signed ? sh : (65535 & sh));
      }
      if ((x75 === 8)) {
        var b = x76.Lscodec_bits_BitVector$Bytes__f_underlying.toByteBuffer__Ljava_nio_ByteBuffer().get__B();
        return (signed ? b : (255 & b));
      }
      var x = ordering$tailLocal4;
      var x$2 = $m_Lscodec_bits_ByteOrdering$LittleEndian$();
      if (((x !== null) && (x === x$2))) {
        var \u03b4this$tailLocal5$tmp1 = \u03b4this$tailLocal5.invertReverseByteOrder__Lscodec_bits_BitVector();
        var ordering$tailLocal4$tmp1 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
        \u03b4this$tailLocal5 = \u03b4this$tailLocal5$tmp1;
        ordering$tailLocal4 = ordering$tailLocal4$tmp1;
        continue;
      } else {
        return $p_Lscodec_bits_BitVector__getBigEndianInt__J__I__Z__I(\u03b4this$tailLocal5, $L0, x75, signed);
      }
    }
    var x$3 = ordering$tailLocal4;
    var x$4 = $m_Lscodec_bits_ByteOrdering$LittleEndian$();
    if (((x$3 !== null) && (x$3 === x$4))) {
      var \u03b4this$tailLocal5$tmp2 = \u03b4this$tailLocal5.invertReverseByteOrder__Lscodec_bits_BitVector();
      var ordering$tailLocal4$tmp2 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
      \u03b4this$tailLocal5 = \u03b4this$tailLocal5$tmp2;
      ordering$tailLocal4 = ordering$tailLocal4$tmp2;
    } else {
      var $x_1 = \u03b4this$tailLocal5;
      var a$1 = \u03b4this$tailLocal5.size__J();
      return $p_Lscodec_bits_BitVector__getBigEndianInt__J__I__Z__I($x_1, $L0, a$1.RTLong__f_lo, signed);
    }
  }
});
$c_Lscodec_bits_BitVector.prototype.toLong__Z__Lscodec_bits_ByteOrdering__J = (function(signed, ordering) {
  var \u03b4this$tailLocal7 = this;
  var ordering$tailLocal6 = ordering;
  while (true) {
    $m_s_Predef$().require__Z__V(\u03b4this$tailLocal7.sizeLessThanOrEqual__J__Z(new $c_RTLong(64, 0)));
    var x79 = \u03b4this$tailLocal7;
    if ((x79 instanceof $c_Lscodec_bits_BitVector$Bytes)) {
      var a = \u03b4this$tailLocal7.size__J();
      var x78 = a.RTLong__f_lo;
      if (((x78 === 64) && signed)) {
        return x79.Lscodec_bits_BitVector$Bytes__f_underlying.toByteBuffer__Ljava_nio_ByteBuffer().order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer(ordering$tailLocal6.toJava__Ljava_nio_ByteOrder()).getLong__J();
      }
      switch (x78) {
        case 32: {
          var i = x79.Lscodec_bits_BitVector$Bytes__f_underlying.toByteBuffer__Ljava_nio_ByteBuffer().order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer(ordering$tailLocal6.toJava__Ljava_nio_ByteOrder()).getInt__I();
          if (signed) {
            var hi = (i >> 31);
            return new $c_RTLong(i, hi);
          } else {
            return new $c_RTLong(i, 0);
          }
          break;
        }
        case 16: {
          var sh = x79.Lscodec_bits_BitVector$Bytes__f_underlying.toByteBuffer__Ljava_nio_ByteBuffer().order__Ljava_nio_ByteOrder__Ljava_nio_ByteBuffer(ordering$tailLocal6.toJava__Ljava_nio_ByteOrder()).getShort__S();
          if (signed) {
            var value = sh;
            var hi$2 = (value >> 31);
            return new $c_RTLong(value, hi$2);
          } else {
            var value$1 = sh;
            var lo = (65535 & value$1);
            return new $c_RTLong(lo, 0);
          }
          break;
        }
        case 8: {
          var b = x79.Lscodec_bits_BitVector$Bytes__f_underlying.toByteBuffer__Ljava_nio_ByteBuffer().get__B();
          if (signed) {
            var value$2 = b;
            var hi$4 = (value$2 >> 31);
            return new $c_RTLong(value$2, hi$4);
          } else {
            var value$3 = b;
            var lo$1 = (255 & value$3);
            return new $c_RTLong(lo$1, 0);
          }
          break;
        }
        default: {
          var x = ordering$tailLocal6;
          var x$2 = $m_Lscodec_bits_ByteOrdering$LittleEndian$();
          if (((x !== null) && (x === x$2))) {
            var \u03b4this$tailLocal7$tmp1 = \u03b4this$tailLocal7.invertReverseByteOrder__Lscodec_bits_BitVector();
            var ordering$tailLocal6$tmp1 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
            \u03b4this$tailLocal7 = \u03b4this$tailLocal7$tmp1;
            ordering$tailLocal6 = ordering$tailLocal6$tmp1;
            continue;
          } else {
            return $p_Lscodec_bits_BitVector__getBigEndianLong__J__I__Z__J(\u03b4this$tailLocal7, $L0, x78, signed);
          }
        }
      }
    }
    var x$3 = ordering$tailLocal6;
    var x$4 = $m_Lscodec_bits_ByteOrdering$LittleEndian$();
    if (((x$3 !== null) && (x$3 === x$4))) {
      var \u03b4this$tailLocal7$tmp2 = \u03b4this$tailLocal7.invertReverseByteOrder__Lscodec_bits_BitVector();
      var ordering$tailLocal6$tmp2 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
      \u03b4this$tailLocal7 = \u03b4this$tailLocal7$tmp2;
      ordering$tailLocal6 = ordering$tailLocal6$tmp2;
    } else {
      var $x_1 = \u03b4this$tailLocal7;
      var a$1 = \u03b4this$tailLocal7.size__J();
      return $p_Lscodec_bits_BitVector__getBigEndianLong__J__I__Z__J($x_1, $L0, a$1.RTLong__f_lo, signed);
    }
  }
});
$c_Lscodec_bits_BitVector.prototype.toBigInt__Z__Lscodec_bits_ByteOrdering__s_math_BigInt = (function(signed, ordering) {
  var \u03b4this$tailLocal9 = this;
  var ordering$tailLocal8 = ordering;
  while (true) {
    var x = ordering$tailLocal8;
    var x$2 = $m_Lscodec_bits_ByteOrdering$LittleEndian$();
    if (((x !== null) && (x === x$2))) {
      var \u03b4this$tailLocal9$tmp1 = \u03b4this$tailLocal9.invertReverseByteOrder__Lscodec_bits_BitVector();
      var ordering$tailLocal8$tmp1 = $m_Lscodec_bits_ByteOrdering$BigEndian$();
      \u03b4this$tailLocal9 = \u03b4this$tailLocal9$tmp1;
      ordering$tailLocal8 = ordering$tailLocal8$tmp1;
    } else {
      var $x_1 = \u03b4this$tailLocal9;
      var a = \u03b4this$tailLocal9.size__J();
      return $p_Lscodec_bits_BitVector__getBigEndianBigInt__J__I__Z__s_math_BigInt($x_1, $L0, a.RTLong__f_lo, signed);
    }
  }
});
$c_Lscodec_bits_BitVector.prototype.$eq$eq$eq__Lscodec_bits_BitVector__Z = (function(other) {
  if ((this === other)) {
    return true;
  } else {
    var a = this.size__J();
    var b = other.size__J();
    if ((!(!((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))))) {
      return $ps_Lscodec_bits_BitVector__go$8__J__Lscodec_bits_BitVector__Lscodec_bits_BitVector__Z(new $c_RTLong(524288, 0), this, other);
    } else {
      return false;
    }
  }
});
$c_Lscodec_bits_BitVector.prototype.equals__O__Z = (function(other) {
  return ((other instanceof $c_Lscodec_bits_BitVector) && this.$eq$eq$eq__Lscodec_bits_BitVector__Z(other));
});
$c_Lscodec_bits_BitVector.prototype.hashCode__I = (function() {
  if ((!this.Lscodec_bits_BitVector__f_hashCodebitmap$1)) {
    var this$1 = $m_s_util_hashing_MurmurHash3$();
    this.Lscodec_bits_BitVector__f_hashCode$lzy1 = $ps_Lscodec_bits_BitVector__go$9__J__Lscodec_bits_BitVector__I__I__I(new $c_RTLong(524288, 0), this, this$1.stringHash__T__I__I("BitVector", (-137723950)), 1);
    this.Lscodec_bits_BitVector__f_hashCodebitmap$1 = true;
  }
  return this.Lscodec_bits_BitVector__f_hashCode$lzy1;
});
$c_Lscodec_bits_BitVector.prototype.toString__T = (function() {
  return (this.sizeLessThan__J__Z(new $c_RTLong(1, 0)) ? "BitVector(empty)" : (this.sizeLessThan__J__Z(new $c_RTLong(513, 0)) ? (((("BitVector(" + this.size__J()) + " bits, 0x") + this.toHex__Lscodec_bits_Bases$HexAlphabet__T($m_Lscodec_bits_Bases$Alphabets$HexLowercase$())) + ")") : (((("BitVector(" + this.size__J()) + " bits, #") + this.hashCode__I()) + ")")));
});
$c_Lscodec_bits_BitVector.prototype.checkBounds__J__V = (function(n) {
  if ((!this.sizeGreaterThan__J__Z(n))) {
    this.outOfBounds__J__E(n);
  }
});
$c_Lscodec_bits_BitVector.prototype.outOfBounds__J__E = (function(n) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ((("invalid index: " + n) + " of ") + this.size__J()));
});
$c_Lscodec_bits_BitVector.prototype.compare__Lscodec_bits_BitVector__I = (function(that) {
  if ((this === that)) {
    return 0;
  } else {
    var t = this.size__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = that.size__J();
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if (((hi === hi$1) ? ((lo >>> 0) < (lo$1 >>> 0)) : (hi < hi$1))) {
      var commonLength__lo = lo;
      var commonLength__hi = hi;
    } else {
      var commonLength__lo = lo$1;
      var commonLength__hi = hi$1;
    }
    var i = 0;
    while (true) {
      var value = i;
      var hi$2 = (value >> 31);
      var bhi = commonLength__hi;
      if (((hi$2 === bhi) ? ((value >>> 0) < (commonLength__lo >>> 0)) : (hi$2 < bhi))) {
        var value$1 = i;
        var hi$3 = (value$1 >> 31);
        var x = this.get__J__Z(new $c_RTLong(value$1, hi$3));
        var this$11 = new $c_sr_RichBoolean(x);
        var value$2 = i;
        var hi$4 = (value$2 >> 31);
        var y = that.get__J__Z(new $c_RTLong(value$2, hi$4));
        var x$1 = this$11.sr_RichBoolean__f_self;
        var cmp = ((x$1 === y) ? 0 : (x$1 ? 1 : (-1)));
        if ((cmp !== 0)) {
          return cmp;
        }
        i = ((1 + i) | 0);
      } else {
        break;
      }
    }
    return (((hi === hi$1) ? ((lo >>> 0) < (lo$1 >>> 0)) : (hi < hi$1)) ? (-1) : (((hi === hi$1) ? ((lo >>> 0) > (lo$1 >>> 0)) : (hi > hi$1)) ? 1 : 0));
  }
});
$c_Lscodec_bits_BitVector.prototype.compare__O__I = (function(that) {
  return this.compare__Lscodec_bits_BitVector__I(that);
});
function $isArrayOf_Lscodec_bits_BitVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_BitVector)));
}
export { $isArrayOf_Lscodec_bits_BitVector as $isArrayOf_Lscodec_bits_BitVector };
function $p_Lscodec_bits_ByteVector__checkIndex__J__V($thiz, n) {
  var ahi = n.RTLong__f_hi;
  if ((ahi < 0)) {
    var $x_1 = true;
  } else {
    var b = $thiz.size__J();
    var ahi$1 = n.RTLong__f_hi;
    var bhi = b.RTLong__f_hi;
    var $x_1 = ((ahi$1 === bhi) ? ((n.RTLong__f_lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (ahi$1 > bhi));
  }
  if ($x_1) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ((("invalid index: " + n) + " for size ") + $thiz.size__J()));
  }
}
export { $p_Lscodec_bits_ByteVector__checkIndex__J__V as $p_Lscodec_bits_ByteVector__checkIndex__J__V };
function $ps_Lscodec_bits_ByteVector__go$1__Lscodec_bits_ByteVector__J__sci_List__Lscodec_bits_ByteVector(cur, n1, accR) {
  var accR$tailLocal1 = accR;
  var lo = n1.RTLong__f_lo;
  var hi = n1.RTLong__f_hi;
  var n1$tailLocal1__lo = lo;
  var n1$tailLocal1__hi = hi;
  var cur$tailLocal1 = cur;
  while (true) {
    var x1 = cur$tailLocal1;
    if ((x1 instanceof $c_Lscodec_bits_ByteVector$Chunk)) {
      var x10 = x1.Lscodec_bits_ByteVector$Chunk__f_bytes;
      var this$3 = accR$tailLocal1;
      var bytes = x10.drop__J__Lscodec_bits_ByteVector$View(new $c_RTLong(n1$tailLocal1__lo, n1$tailLocal1__hi));
      var z = new $c_Lscodec_bits_ByteVector$Chunk(bytes);
      var acc = z;
      var these = this$3;
      while ((!these.isEmpty__Z())) {
        var x0 = acc;
        var x1$1 = these.head__O();
        acc = x0.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(x1$1);
        these = these.tail__O();
      }
      return acc.unbuffer__Lscodec_bits_ByteVector();
    }
    if ((x1 instanceof $c_Lscodec_bits_ByteVector$Append)) {
      var x6 = x1.Lscodec_bits_ByteVector$Append__f_left;
      var x7 = x1.Lscodec_bits_ByteVector$Append__f_right;
      var a__lo = n1$tailLocal1__lo;
      var a__hi = n1$tailLocal1__hi;
      var b = x6.size__J();
      var ahi = a__hi;
      var bhi = b.RTLong__f_hi;
      if (((ahi === bhi) ? ((a__lo >>> 0) > (b.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
        var a$1__lo = n1$tailLocal1__lo;
        var a$1__hi = n1$tailLocal1__hi;
        var b$1 = x6.size__J();
        var alo = a$1__lo;
        var blo = b$1.RTLong__f_lo;
        var lo$1 = ((alo - blo) | 0);
        var hi$1 = ((((a$1__hi - b$1.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo$1)) >> 31)) | 0);
        cur$tailLocal1 = x7;
        var $x_1__lo = lo$1;
        var $x_1__hi = hi$1;
        n1$tailLocal1__lo = $x_1__lo;
        n1$tailLocal1__hi = $x_1__hi;
        continue;
      } else {
        var this$7 = accR$tailLocal1;
        var accR$tailLocal1$tmp1 = new $c_sci_$colon$colon(x7, this$7);
        cur$tailLocal1 = x6;
        accR$tailLocal1 = accR$tailLocal1$tmp1;
        continue;
      }
    }
    if ((x1 instanceof $c_Lscodec_bits_ByteVector$Buffer)) {
      var a$2__lo = n1$tailLocal1__lo;
      var a$2__hi = n1$tailLocal1__hi;
      var b$2 = x1.Lscodec_bits_ByteVector$Buffer__f_hd.size__J();
      var ahi$1 = a$2__hi;
      var bhi$1 = b$2.RTLong__f_hi;
      if (((ahi$1 === bhi$1) ? ((a$2__lo >>> 0) > (b$2.RTLong__f_lo >>> 0)) : (ahi$1 > bhi$1))) {
        var cur$tailLocal1$tmp3 = x1.lastBytes__Lscodec_bits_ByteVector();
        var a$3__lo = n1$tailLocal1__lo;
        var a$3__hi = n1$tailLocal1__hi;
        var b$3 = x1.Lscodec_bits_ByteVector$Buffer__f_hd.size__J();
        var alo$1 = a$3__lo;
        var blo$1 = b$3.RTLong__f_lo;
        var lo$2 = ((alo$1 - blo$1) | 0);
        var hi$2 = ((((a$3__hi - b$3.RTLong__f_hi) | 0) + ((((~alo$1) & blo$1) | ((~(alo$1 ^ blo$1)) & lo$2)) >> 31)) | 0);
        cur$tailLocal1 = cur$tailLocal1$tmp3;
        var $x_2__lo = lo$2;
        var $x_2__hi = hi$2;
        n1$tailLocal1__lo = $x_2__lo;
        n1$tailLocal1__hi = $x_2__hi;
        continue;
      } else {
        var cur$tailLocal1$tmp4 = x1.Lscodec_bits_ByteVector$Buffer__f_hd;
        var elem$1 = x1.lastBytes__Lscodec_bits_ByteVector();
        var this$10 = accR$tailLocal1;
        var accR$tailLocal1$tmp2 = new $c_sci_$colon$colon(elem$1, this$10);
        cur$tailLocal1 = cur$tailLocal1$tmp4;
        accR$tailLocal1 = accR$tailLocal1$tmp2;
        continue;
      }
    }
    if ((x1 instanceof $c_Lscodec_bits_ByteVector$Chunks)) {
      cur$tailLocal1 = x1.Lscodec_bits_ByteVector$Chunks__f_chunks;
      continue;
    }
    throw new $c_s_MatchError(x1);
  }
}
export { $ps_Lscodec_bits_ByteVector__go$1__Lscodec_bits_ByteVector__J__sci_List__Lscodec_bits_ByteVector as $ps_Lscodec_bits_ByteVector__go$1__Lscodec_bits_ByteVector__J__sci_List__Lscodec_bits_ByteVector };
function $ps_Lscodec_bits_ByteVector__go$2__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector__J__Lscodec_bits_ByteVector(accL, cur, n1) {
  var lo = n1.RTLong__f_lo;
  var hi = n1.RTLong__f_hi;
  var n1$tailLocal2__lo = lo;
  var n1$tailLocal2__hi = hi;
  var cur$tailLocal2 = cur;
  var accL$tailLocal1 = accL;
  while (true) {
    var x11 = cur$tailLocal2;
    if ((x11 instanceof $c_Lscodec_bits_ByteVector$Chunk)) {
      var x20 = x11.Lscodec_bits_ByteVector$Chunk__f_bytes;
      var $x_1 = accL$tailLocal1;
      var bytes = x20.take__J__Lscodec_bits_ByteVector$View(new $c_RTLong(n1$tailLocal2__lo, n1$tailLocal2__hi));
      return $x_1.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(new $c_Lscodec_bits_ByteVector$Chunk(bytes));
    }
    if ((x11 instanceof $c_Lscodec_bits_ByteVector$Append)) {
      var x16 = x11.Lscodec_bits_ByteVector$Append__f_left;
      var x17 = x11.Lscodec_bits_ByteVector$Append__f_right;
      var a__lo = n1$tailLocal2__lo;
      var a__hi = n1$tailLocal2__hi;
      var b = x16.size__J();
      var ahi = a__hi;
      var bhi = b.RTLong__f_hi;
      if (((ahi === bhi) ? ((a__lo >>> 0) > (b.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
        var accL$tailLocal1$tmp1 = accL$tailLocal1.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(x16);
        var a$1__lo = n1$tailLocal2__lo;
        var a$1__hi = n1$tailLocal2__hi;
        var b$1 = x16.size__J();
        var alo = a$1__lo;
        var blo = b$1.RTLong__f_lo;
        var lo$1 = ((alo - blo) | 0);
        var hi$1 = ((((a$1__hi - b$1.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo$1)) >> 31)) | 0);
        accL$tailLocal1 = accL$tailLocal1$tmp1;
        cur$tailLocal2 = x17;
        var $x_2__lo = lo$1;
        var $x_2__hi = hi$1;
        n1$tailLocal2__lo = $x_2__lo;
        n1$tailLocal2__hi = $x_2__hi;
        continue;
      } else {
        cur$tailLocal2 = x16;
        continue;
      }
    }
    if ((x11 instanceof $c_Lscodec_bits_ByteVector$Chunks)) {
      cur$tailLocal2 = x11.Lscodec_bits_ByteVector$Chunks__f_chunks;
      continue;
    }
    if ((x11 instanceof $c_Lscodec_bits_ByteVector$Buffer)) {
      cur$tailLocal2 = x11.unbuffer__Lscodec_bits_ByteVector();
      continue;
    }
    throw new $c_s_MatchError(x11);
  }
}
export { $ps_Lscodec_bits_ByteVector__go$2__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector__J__Lscodec_bits_ByteVector as $ps_Lscodec_bits_ByteVector__go$2__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector__J__Lscodec_bits_ByteVector };
function $ps_Lscodec_bits_ByteVector__go$6__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector__J__J(slice$1, b, idx) {
  var lo = idx.RTLong__f_lo;
  var hi = idx.RTLong__f_hi;
  var idx$tailLocal1__lo = lo;
  var idx$tailLocal1__hi = hi;
  var b$tailLocal1 = b;
  while (true) {
    if (b$tailLocal1.startsWith__Lscodec_bits_ByteVector__Z(slice$1)) {
      return new $c_RTLong(idx$tailLocal1__lo, idx$tailLocal1__hi);
    } else if (b$tailLocal1.isEmpty__Z()) {
      return new $c_RTLong((-1), (-1));
    } else {
      var this$1 = b$tailLocal1;
      var b$tailLocal1$tmp1 = this$1.drop__J__Lscodec_bits_ByteVector(new $c_RTLong(1, 0));
      var b$1__lo = idx$tailLocal1__lo;
      var b$1__hi = idx$tailLocal1__hi;
      var blo = b$1__lo;
      var lo$1 = ((1 + blo) | 0);
      var hi$1 = ((b$1__hi + (((blo & (~lo$1)) >>> 31) | 0)) | 0);
      b$tailLocal1 = b$tailLocal1$tmp1;
      var $x_1__lo = lo$1;
      var $x_1__hi = hi$1;
      idx$tailLocal1__lo = $x_1__lo;
      idx$tailLocal1__hi = $x_1__hi;
    }
  }
}
export { $ps_Lscodec_bits_ByteVector__go$6__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector__J__J as $ps_Lscodec_bits_ByteVector__go$6__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector__J__J };
function $s_Lscodec_bits_ByteVector__scodec$bits$ByteVector$$_$update$1__AC__sr_IntRef__Lscodec_bits_Bases$HexAlphabet__B__V(out$1, i$3, alphabet$2, b) {
  out$1.u[i$3.sr_IntRef__f_elem] = alphabet$2.toChar__I__C((15 & (b >> 4)));
  out$1.u[((1 + i$3.sr_IntRef__f_elem) | 0)] = alphabet$2.toChar__I__C((15 & b));
  i$3.sr_IntRef__f_elem = ((2 + i$3.sr_IntRef__f_elem) | 0);
}
export { $s_Lscodec_bits_ByteVector__scodec$bits$ByteVector$$_$update$1__AC__sr_IntRef__Lscodec_bits_Bases$HexAlphabet__B__V as $s_Lscodec_bits_ByteVector__scodec$bits$ByteVector$$_$update$1__AC__sr_IntRef__Lscodec_bits_Bases$HexAlphabet__B__V };
function $ps_Lscodec_bits_ByteVector__go$8__J__Lscodec_bits_ByteVector__I__I__I(chunkSize$2, bytes, h, iter) {
  var iter$tailLocal1 = iter;
  var h$tailLocal1 = h;
  var bytes$tailLocal1 = bytes;
  while (true) {
    if (bytes$tailLocal1.isEmpty__Z()) {
      return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h$tailLocal1, iter$tailLocal1);
    } else {
      var bytes$tailLocal1$tmp1 = bytes$tailLocal1.drop__J__Lscodec_bits_ByteVector(chunkSize$2);
      var $x_2 = $m_s_util_hashing_MurmurHash3$();
      var $x_1 = h$tailLocal1;
      var this$1 = $m_s_util_hashing_MurmurHash3$();
      var data = bytes$tailLocal1.take__J__Lscodec_bits_ByteVector(chunkSize$2).toArray__AB();
      var h$tailLocal1$tmp1 = $x_2.mix__I__I__I($x_1, this$1.bytesHash__AB__I__I(data, 1007110753));
      var iter$tailLocal1$tmp1 = ((1 + iter$tailLocal1) | 0);
      bytes$tailLocal1 = bytes$tailLocal1$tmp1;
      h$tailLocal1 = h$tailLocal1$tmp1;
      iter$tailLocal1 = iter$tailLocal1$tmp1;
    }
  }
}
export { $ps_Lscodec_bits_ByteVector__go$8__J__Lscodec_bits_ByteVector__I__I__I as $ps_Lscodec_bits_ByteVector__go$8__J__Lscodec_bits_ByteVector__I__I__I };
function $p_Lscodec_bits_ByteVector__go$9__J__Lscodec_bits_ByteVector__J__Z($thiz, s$2, other$4, i) {
  var lo = i.RTLong__f_lo;
  var hi = i.RTLong__f_hi;
  var i$tailLocal1__lo = lo;
  var i$tailLocal1__hi = hi;
  while (true) {
    var a__lo = i$tailLocal1__lo;
    var a__hi = i$tailLocal1__hi;
    var ahi = a__hi;
    var bhi = s$2.RTLong__f_hi;
    if ((!((ahi === bhi) ? ((a__lo >>> 0) < (s$2.RTLong__f_lo >>> 0)) : (ahi < bhi)))) {
      return true;
    } else {
      var index__lo = i$tailLocal1__lo;
      var index__hi = i$tailLocal1__hi;
      var $x_1 = $thiz.get__J__B(new $c_RTLong(index__lo, index__hi));
      var index$1__lo = i$tailLocal1__lo;
      var index$1__hi = i$tailLocal1__hi;
      if (($x_1 === other$4.get__J__B(new $c_RTLong(index$1__lo, index$1__hi)))) {
        var b__lo = i$tailLocal1__lo;
        var b__hi = i$tailLocal1__hi;
        var blo = b__lo;
        var lo$1 = ((1 + blo) | 0);
        var hi$1 = ((b__hi + (((blo & (~lo$1)) >>> 31) | 0)) | 0);
        var $x_2__lo = lo$1;
        var $x_2__hi = hi$1;
        i$tailLocal1__lo = $x_2__lo;
        i$tailLocal1__hi = $x_2__hi;
      } else {
        return false;
      }
    }
  }
}
export { $p_Lscodec_bits_ByteVector__go$9__J__Lscodec_bits_ByteVector__J__Z as $p_Lscodec_bits_ByteVector__go$9__J__Lscodec_bits_ByteVector__J__Z };
/** @constructor */
function $c_Lscodec_bits_ByteVector() {
  this.Lscodec_bits_ByteVector__f_hashCode$lzy1 = 0;
  this.Lscodec_bits_ByteVector__f_hashCodebitmap$1 = false;
}
export { $c_Lscodec_bits_ByteVector as $c_Lscodec_bits_ByteVector };
$c_Lscodec_bits_ByteVector.prototype = new $h_O();
$c_Lscodec_bits_ByteVector.prototype.constructor = $c_Lscodec_bits_ByteVector;
/** @constructor */
function $h_Lscodec_bits_ByteVector() {
}
export { $h_Lscodec_bits_ByteVector as $h_Lscodec_bits_ByteVector };
$h_Lscodec_bits_ByteVector.prototype = $c_Lscodec_bits_ByteVector.prototype;
$c_Lscodec_bits_ByteVector.prototype.compareTo__O__I = (function(that) {
  return this.compare__Lscodec_bits_ByteVector__I(that);
});
$c_Lscodec_bits_ByteVector.prototype.isEmpty__Z = (function() {
  var a = this.size__J();
  return ((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === 0));
});
$c_Lscodec_bits_ByteVector.prototype.get__J__B = (function(index) {
  $p_Lscodec_bits_ByteVector__checkIndex__J__V(this, index);
  return this.getImpl__J__B(index);
});
$c_Lscodec_bits_ByteVector.prototype.update__J__B__Lscodec_bits_ByteVector = (function(idx, b) {
  $p_Lscodec_bits_ByteVector__checkIndex__J__V(this, idx);
  var $x_1 = this.take__J__Lscodec_bits_ByteVector(idx).$colon$plus__B__Lscodec_bits_ByteVector(b);
  var blo = idx.RTLong__f_lo;
  var lo = ((1 + blo) | 0);
  var hi = ((idx.RTLong__f_hi + (((blo & (~lo)) >>> 31) | 0)) | 0);
  return $x_1.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(this.drop__J__Lscodec_bits_ByteVector(new $c_RTLong(lo, hi)));
});
$c_Lscodec_bits_ByteVector.prototype.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector = (function(other) {
  if (this.isEmpty__Z()) {
    return other;
  } else if (other.isEmpty__Z()) {
    return this;
  } else {
    var chunks = new $c_Lscodec_bits_ByteVector$Append(this, other);
    return new $c_Lscodec_bits_ByteVector$Chunks(chunks).bufferBy__I__Lscodec_bits_ByteVector(64);
  }
});
$c_Lscodec_bits_ByteVector.prototype.$colon$plus__B__Lscodec_bits_ByteVector = (function(byte) {
  return this.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector($m_Lscodec_bits_ByteVector$().apply__sci_Seq__s_math_Integral__Lscodec_bits_ByteVector($m_sr_ScalaRunTime$().wrapByteArray__AB__sci_ArraySeq(new $ac_B(new Int8Array([byte]))), $m_s_math_Numeric$ByteIsIntegral$()));
});
$c_Lscodec_bits_ByteVector.prototype.drop__J__Lscodec_bits_ByteVector = (function(n) {
  var t = this.size__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var ahi = n.RTLong__f_hi;
  if (((ahi === hi) ? ((n.RTLong__f_lo >>> 0) < (lo >>> 0)) : (ahi < hi))) {
    var t$1 = n;
  } else {
    var t$1 = new $c_RTLong(lo, hi);
  }
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = (((hi$1 === 0) ? (lo$1 !== 0) : (hi$1 > 0)) ? new $c_RTLong(lo$1, hi$1) : $L0);
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var b = this.size__J();
  if (((lo$2 === b.RTLong__f_lo) && (hi$2 === b.RTLong__f_hi))) {
    return $m_Lscodec_bits_ByteVector$().Lscodec_bits_ByteVector$__f_empty;
  } else {
    return (((lo$2 === 0) && (hi$2 === 0)) ? this : $ps_Lscodec_bits_ByteVector__go$1__Lscodec_bits_ByteVector__J__sci_List__Lscodec_bits_ByteVector(this, new $c_RTLong(lo$2, hi$2), $m_sci_Nil$()));
  }
});
$c_Lscodec_bits_ByteVector.prototype.dropRight__J__Lscodec_bits_ByteVector = (function(n) {
  var a = this.size__J();
  var ahi = n.RTLong__f_hi;
  if (((ahi === 0) ? (n.RTLong__f_lo !== 0) : (ahi > 0))) {
    var b = n;
  } else {
    var b = $L0;
  }
  var alo = a.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var lo = ((alo - blo) | 0);
  var hi = ((((a.RTLong__f_hi - b.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
  return this.take__J__Lscodec_bits_ByteVector(new $c_RTLong(lo, hi));
});
$c_Lscodec_bits_ByteVector.prototype.take__J__Lscodec_bits_ByteVector = (function(n) {
  var t = this.size__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var ahi = n.RTLong__f_hi;
  if (((ahi === hi) ? ((n.RTLong__f_lo >>> 0) < (lo >>> 0)) : (ahi < hi))) {
    var t$1 = n;
  } else {
    var t$1 = new $c_RTLong(lo, hi);
  }
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = (((hi$1 === 0) ? (lo$1 !== 0) : (hi$1 > 0)) ? new $c_RTLong(lo$1, hi$1) : $L0);
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  var b = this.size__J();
  if (((lo$2 === b.RTLong__f_lo) && (hi$2 === b.RTLong__f_hi))) {
    return this;
  } else {
    return (((lo$2 === 0) && (hi$2 === 0)) ? $m_Lscodec_bits_ByteVector$().Lscodec_bits_ByteVector$__f_empty : $ps_Lscodec_bits_ByteVector__go$2__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector__J__Lscodec_bits_ByteVector($m_Lscodec_bits_ByteVector$().Lscodec_bits_ByteVector$__f_empty, this, new $c_RTLong(lo$2, hi$2)));
  }
});
$c_Lscodec_bits_ByteVector.prototype.slice__J__J__Lscodec_bits_ByteVector = (function(from, until) {
  var $x_1 = this.drop__J__Lscodec_bits_ByteVector(from);
  var ahi = from.RTLong__f_hi;
  if (((ahi === 0) ? (from.RTLong__f_lo !== 0) : (ahi > 0))) {
    var b = from;
  } else {
    var b = $L0;
  }
  var alo = until.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var lo = ((alo - blo) | 0);
  var hi = ((((until.RTLong__f_hi - b.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
  return $x_1.take__J__Lscodec_bits_ByteVector(new $c_RTLong(lo, hi));
});
$c_Lscodec_bits_ByteVector.prototype.startsWith__Lscodec_bits_ByteVector__Z = (function(b) {
  return this.take__J__Lscodec_bits_ByteVector(b.size__J()).$eq$eq$eq__Lscodec_bits_ByteVector__Z(b);
});
$c_Lscodec_bits_ByteVector.prototype.indexOfSlice__Lscodec_bits_ByteVector__J__J = (function(slice, from) {
  return $ps_Lscodec_bits_ByteVector__go$6__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector__J__J(slice, this.drop__J__Lscodec_bits_ByteVector(from), from);
});
$c_Lscodec_bits_ByteVector.prototype.reverse__Lscodec_bits_ByteVector = (function() {
  return $m_Lscodec_bits_ByteVector$().viewAt__F1__J__Lscodec_bits_ByteVector(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((l) => {
    var t = $uJ(l);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var a = this.size__J();
    var alo = a.RTLong__f_lo;
    var lo$1 = ((alo - lo) | 0);
    var hi$1 = ((((a.RTLong__f_hi - hi) | 0) + ((((~alo) & lo) | ((~(alo ^ lo)) & lo$1)) >> 31)) | 0);
    var lo$2 = (((-1) + lo$1) | 0);
    var hi$2 = (((((-1) + hi$1) | 0) + (((lo$1 | (~lo$2)) >>> 31) | 0)) | 0);
    return this.get__J__B(new $c_RTLong(lo$2, hi$2));
  })), this.size__J());
});
$c_Lscodec_bits_ByteVector.prototype.compact__Lscodec_bits_ByteVector = (function() {
  return ((this instanceof $c_Lscodec_bits_ByteVector$Chunk) ? this : this.copy__Lscodec_bits_ByteVector());
});
$c_Lscodec_bits_ByteVector.prototype.copy__Lscodec_bits_ByteVector = (function() {
  var t = this.size__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (((hi === 0) ? ((lo >>> 0) <= 2147483647) : (hi < 0))) {
    var arr = this.toArray__AB();
    $m_Lscodec_bits_ByteVector$View$();
    var at = new $c_Lscodec_bits_ByteVector$AtArray(arr);
    var bytes = new $c_Lscodec_bits_ByteVector$View(at, $L0, new $c_RTLong(lo, hi));
    return new $c_Lscodec_bits_ByteVector$Chunk(bytes);
  } else {
    return this.take__J__Lscodec_bits_ByteVector(new $c_RTLong(2147483647, 0)).copy__Lscodec_bits_ByteVector().$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(this.drop__J__Lscodec_bits_ByteVector(new $c_RTLong(2147483647, 0)).copy__Lscodec_bits_ByteVector());
  }
});
$c_Lscodec_bits_ByteVector.prototype.toArray__AB = (function() {
  var dimensions = new $ac_I(new Int32Array([$m_Lscodec_bits_ByteVector$().toIntSize__J__I(this.size__J())]));
  var buf = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_B.getClassOf(), dimensions);
  this.copyToArray__AB__I__V(buf, 0);
  return buf;
});
$c_Lscodec_bits_ByteVector.prototype.copyToArray__AB__I__V = (function(xs, start) {
  var elem = 0;
  elem = start;
  var this$2 = $m_sci_Nil$();
  var rem = new $c_sci_$colon$colon(this, this$2);
  var rem$tailLocal2 = rem;
  while (true) {
    var x48 = rem$tailLocal2;
    if ((x48 instanceof $c_sci_$colon$colon)) {
      var x70 = x48.sci_$colon$colon__f_head;
      var x71 = x48.sci_$colon$colon__f_next;
      if ((x70 instanceof $c_Lscodec_bits_ByteVector$Chunk)) {
        var x74 = x70.Lscodec_bits_ByteVector$Chunk__f_bytes;
        x74.copyToArray__AB__I__V(xs, elem);
        elem = ((elem + $m_Lscodec_bits_ByteVector$().toIntSize__J__I(x74.Lscodec_bits_ByteVector$View__f_size)) | 0);
        rem$tailLocal2 = x71;
        continue;
      }
      if ((x70 instanceof $c_Lscodec_bits_ByteVector$Append)) {
        var x67 = x70.Lscodec_bits_ByteVector$Append__f_left;
        var x68 = x70.Lscodec_bits_ByteVector$Append__f_right;
        var this$5 = new $c_sci_$colon$colon(x68, x71);
        rem$tailLocal2 = new $c_sci_$colon$colon(x67, this$5);
        continue;
      }
      if ((x70 instanceof $c_Lscodec_bits_ByteVector$Chunks)) {
        var x58 = x70.Lscodec_bits_ByteVector$Chunks__f_chunks;
        if ((x58 !== null)) {
          var x60 = x58.Lscodec_bits_ByteVector$Append__f_left;
          var x61 = x58.Lscodec_bits_ByteVector$Append__f_right;
          var this$8 = new $c_sci_$colon$colon(x61, x71);
          rem$tailLocal2 = new $c_sci_$colon$colon(x60, this$8);
          continue;
        }
      }
      if ((x70 instanceof $c_Lscodec_bits_ByteVector$Buffer)) {
        var elem$3 = x70.unbuffer__Lscodec_bits_ByteVector();
        rem$tailLocal2 = new $c_sci_$colon$colon(elem$3, x71);
        continue;
      }
    }
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x48)) {
      break;
    }
    throw new $c_s_MatchError(x48);
  }
});
$c_Lscodec_bits_ByteVector.prototype.bufferBy__I__Lscodec_bits_ByteVector = (function(chunkSize) {
  if ((this instanceof $c_Lscodec_bits_ByteVector$Buffer)) {
    return ((this.Lscodec_bits_ByteVector$Buffer__f_lastChunk.u.length >= chunkSize) ? this : this.rebuffer__I__Lscodec_bits_ByteVector(chunkSize));
  } else {
    var id = new $c_ju_concurrent_atomic_AtomicLong($L0);
    var dimensions = new $ac_I(new Int32Array([chunkSize]));
    var lastChunk = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_B.getClassOf(), dimensions);
    return new $c_Lscodec_bits_ByteVector$Buffer(id, $L0, this.unbuffer__Lscodec_bits_ByteVector(), lastChunk, 0);
  }
});
$c_Lscodec_bits_ByteVector.prototype.unbuffer__Lscodec_bits_ByteVector = (function() {
  return this;
});
$c_Lscodec_bits_ByteVector.prototype.toByteBuffer__Ljava_nio_ByteBuffer = (function() {
  if ((this instanceof $c_Lscodec_bits_ByteVector$Chunk)) {
    var x120 = this.Lscodec_bits_ByteVector$Chunk__f_bytes;
    return x120.asByteBuffer__Ljava_nio_ByteBuffer();
  } else {
    var array = this.toArray__AB();
    var length = array.u.length;
    return $m_Ljava_nio_HeapByteBuffer$().wrap__AB__I__I__I__I__Z__Ljava_nio_ByteBuffer(array, 0, array.u.length, 0, length, false);
  }
});
$c_Lscodec_bits_ByteVector.prototype.toHex__Lscodec_bits_Bases$HexAlphabet__T = (function(alphabet) {
  var a = this.size__J();
  var dimensions = new $ac_I(new Int32Array([(a.RTLong__f_lo << 1)]));
  var out = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_C.getClassOf(), dimensions);
  var i = new $c_sr_IntRef(0);
  var this$4 = $m_sci_Nil$();
  var rem = new $c_sci_$colon$colon(this, this$4);
  var rem$tailLocal2 = rem;
  while (true) {
    var x48 = rem$tailLocal2;
    if ((x48 instanceof $c_sci_$colon$colon)) {
      var x70 = x48.sci_$colon$colon__f_head;
      var x71 = x48.sci_$colon$colon__f_next;
      if ((x70 instanceof $c_Lscodec_bits_ByteVector$Chunk)) {
        var x74 = x70.Lscodec_bits_ByteVector$Chunk__f_bytes;
        matchResult12: {
          if ((x74 !== null)) {
            $m_Lscodec_bits_ByteVector$View$();
            var x132 = x74.Lscodec_bits_ByteVector$View__f_at;
            var t = x74.Lscodec_bits_ByteVector$View__f_offset;
            var lo = t.RTLong__f_lo;
            var hi = t.RTLong__f_hi;
            var t$1 = x74.Lscodec_bits_ByteVector$View__f_size;
            var lo$1 = t$1.RTLong__f_lo;
            var hi$1 = t$1.RTLong__f_hi;
            if ((x132 instanceof $c_Lscodec_bits_ByteVector$AtArray)) {
              var j__lo = lo;
              var j__hi = hi;
              var lo$2 = ((lo + lo$1) | 0);
              var hi$2 = ((((hi + hi$1) | 0) + ((((lo & lo$1) | ((lo | lo$1) & (~lo$2))) >>> 31) | 0)) | 0);
              while (true) {
                var a$1__lo = j__lo;
                var a$1__hi = j__hi;
                var ahi = a$1__hi;
                if (((ahi === hi$2) ? ((a$1__lo >>> 0) < (lo$2 >>> 0)) : (ahi < hi$2))) {
                  $s_Lscodec_bits_ByteVector__scodec$bits$ByteVector$$_$update$1__AC__sr_IntRef__Lscodec_bits_Bases$HexAlphabet__B__V(out, i, alphabet, x132.apply__J__B(new $c_RTLong(j__lo, j__hi)));
                  var b__lo = j__lo;
                  var b__hi = j__hi;
                  var blo = b__lo;
                  var lo$3 = ((1 + blo) | 0);
                  var hi$3 = ((b__hi + (((blo & (~lo$3)) >>> 31) | 0)) | 0);
                  var $x_1__lo = lo$3;
                  var $x_1__hi = hi$3;
                  j__lo = $x_1__lo;
                  j__hi = $x_1__hi;
                } else {
                  break;
                }
              }
              break matchResult12;
            }
            if ((x132 instanceof $c_Lscodec_bits_ByteVector$AtByteBuffer)) {
              var buf = x132.Lscodec_bits_ByteVector$AtByteBuffer__f_buf.duplicate__Ljava_nio_ByteBuffer();
              $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(buf, lo);
              var lo$4 = ((lo + lo$1) | 0);
              $c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer.call(buf, lo$4);
              while ((buf.Ljava_nio_Buffer__f_java$nio$Buffer$$_position !== buf.Ljava_nio_Buffer__f__limit)) {
                $s_Lscodec_bits_ByteVector__scodec$bits$ByteVector$$_$update$1__AC__sr_IntRef__Lscodec_bits_Bases$HexAlphabet__B__V(out, i, alphabet, buf.get__B());
              }
              break matchResult12;
            }
          }
          x74.foreach__Lscodec_bits_ByteVector$F1BU__V(new $c_Lscodec_bits_ByteVector$$anon$8(out, i, alphabet, this));
        }
        rem$tailLocal2 = x71;
        continue;
      }
      if ((x70 instanceof $c_Lscodec_bits_ByteVector$Append)) {
        var x67 = x70.Lscodec_bits_ByteVector$Append__f_left;
        var x68 = x70.Lscodec_bits_ByteVector$Append__f_right;
        var this$14 = new $c_sci_$colon$colon(x68, x71);
        rem$tailLocal2 = new $c_sci_$colon$colon(x67, this$14);
        continue;
      }
      if ((x70 instanceof $c_Lscodec_bits_ByteVector$Chunks)) {
        var x58 = x70.Lscodec_bits_ByteVector$Chunks__f_chunks;
        if ((x58 !== null)) {
          var x60 = x58.Lscodec_bits_ByteVector$Append__f_left;
          var x61 = x58.Lscodec_bits_ByteVector$Append__f_right;
          var this$17 = new $c_sci_$colon$colon(x61, x71);
          rem$tailLocal2 = new $c_sci_$colon$colon(x60, this$17);
          continue;
        }
      }
      if ((x70 instanceof $c_Lscodec_bits_ByteVector$Buffer)) {
        var elem$3 = x70.unbuffer__Lscodec_bits_ByteVector();
        rem$tailLocal2 = new $c_sci_$colon$colon(elem$3, x71);
        continue;
      }
    }
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x48)) {
      break;
    }
    throw new $c_s_MatchError(x48);
  }
  var this$18 = $m_jl_String$();
  return this$18.new__AC__I__I__T(out, 0, out.u.length);
});
$c_Lscodec_bits_ByteVector.prototype.toBase64__Lscodec_bits_Bases$Base64Alphabet__T = (function(alphabet) {
  var bytes = this.toArray__AB();
  var capacity = (((((2 + bytes.u.length) | 0) / 3) | 0) << 2);
  var bldr = $m_Ljava_nio_CharBuffer$().allocate__I__Ljava_nio_CharBuffer(capacity);
  var idx = 0;
  var mod = ((bytes.u.length % 3) | 0);
  while ((idx < ((bytes.u.length - mod) | 0))) {
    var buffer = ((((255 & bytes.u[idx]) << 16) | ((255 & bytes.u[((1 + idx) | 0)]) << 8)) | (255 & bytes.u[((2 + idx) | 0)]));
    var fourth = (63 & buffer);
    buffer = (buffer >> 6);
    var third = (63 & buffer);
    buffer = (buffer >> 6);
    var second = (63 & buffer);
    buffer = (buffer >> 6);
    var first = buffer;
    var c = $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C(alphabet, first);
    var this$1 = bldr.put__C__Ljava_nio_CharBuffer(c);
    var c$1 = $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C(alphabet, second);
    var this$2 = this$1.put__C__Ljava_nio_CharBuffer(c$1);
    var c$2 = $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C(alphabet, third);
    var this$3 = this$2.put__C__Ljava_nio_CharBuffer(c$2);
    var c$3 = $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C(alphabet, fourth);
    this$3.put__C__Ljava_nio_CharBuffer(c$3);
    idx = ((3 + idx) | 0);
  }
  if ((mod === 1)) {
    var buffer$2 = ((255 & bytes.u[idx]) << 4);
    var second$2 = (63 & buffer$2);
    buffer$2 = (buffer$2 >> 6);
    var first$2 = buffer$2;
    var c$4 = $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C(alphabet, first$2);
    var this$4 = bldr.put__C__Ljava_nio_CharBuffer(c$4);
    var c$5 = $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C(alphabet, second$2);
    this$4.put__C__Ljava_nio_CharBuffer(c$5);
    if ((alphabet.pad__C() !== 0)) {
      var c$6 = alphabet.pad__C();
      var this$5 = bldr.put__C__Ljava_nio_CharBuffer(c$6);
      var c$7 = alphabet.pad__C();
      this$5.put__C__Ljava_nio_CharBuffer(c$7);
    }
  } else if ((mod === 2)) {
    var buffer$3 = (((255 & bytes.u[idx]) << 10) | ((255 & bytes.u[((1 + idx) | 0)]) << 2));
    var third$2 = (63 & buffer$3);
    buffer$3 = (buffer$3 >> 6);
    var second$3 = (63 & buffer$3);
    buffer$3 = (buffer$3 >> 6);
    var first$3 = buffer$3;
    var c$8 = $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C(alphabet, first$3);
    var this$6 = bldr.put__C__Ljava_nio_CharBuffer(c$8);
    var c$9 = $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C(alphabet, second$3);
    var this$7 = this$6.put__C__Ljava_nio_CharBuffer(c$9);
    var c$10 = $f_Lscodec_bits_Bases$Alphabets$Base64UrlBase__toChar__I__C(alphabet, third$2);
    this$7.put__C__Ljava_nio_CharBuffer(c$10);
    if ((alphabet.pad__C() !== 0)) {
      var c$11 = alphabet.pad__C();
      bldr.put__C__Ljava_nio_CharBuffer(c$11);
    }
  }
  return ($c_Ljava_nio_Buffer.prototype.flip__Ljava_nio_Buffer.call(bldr), bldr).toString__T();
});
$c_Lscodec_bits_ByteVector.prototype.zipWith__Lscodec_bits_ByteVector__F2__Lscodec_bits_ByteVector = (function(other, f) {
  return this.zipWithS__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector$F2B__Lscodec_bits_ByteVector(other, new $c_Lscodec_bits_ByteVector$$anon$13(f));
});
$c_Lscodec_bits_ByteVector.prototype.zipWithS__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector$F2B__Lscodec_bits_ByteVector = (function(other, f) {
  var at = new $c_Lscodec_bits_ByteVector$$anon$16(f, other, this);
  $m_Lscodec_bits_ByteVector$View$();
  var t = this.size__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = other.size__J();
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  if (((hi === hi$1) ? ((lo >>> 0) < (lo$1 >>> 0)) : (hi < hi$1))) {
    var size__lo = lo;
    var size__hi = hi;
  } else {
    var size__lo = lo$1;
    var size__hi = hi$1;
  }
  var bytes = new $c_Lscodec_bits_ByteVector$View(at, $L0, new $c_RTLong(size__lo, size__hi));
  return new $c_Lscodec_bits_ByteVector$Chunk(bytes);
});
$c_Lscodec_bits_ByteVector.prototype.zipWithI__Lscodec_bits_ByteVector__F2__Lscodec_bits_ByteVector = (function(other, op) {
  return this.zipWith__Lscodec_bits_ByteVector__F2__Lscodec_bits_ByteVector(other, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => {
    var x$1$1 = (x$1 | 0);
    var x$2$1 = (x$2 | 0);
    return (((op.apply__O__O__O(x$1$1, x$2$1) | 0) << 24) >> 24);
  })));
});
$c_Lscodec_bits_ByteVector.prototype.hashCode__I = (function() {
  if ((!this.Lscodec_bits_ByteVector__f_hashCodebitmap$1)) {
    var this$1 = $m_s_util_hashing_MurmurHash3$();
    this.Lscodec_bits_ByteVector__f_hashCode$lzy1 = $ps_Lscodec_bits_ByteVector__go$8__J__Lscodec_bits_ByteVector__I__I__I(new $c_RTLong(65536, 0), this, this$1.stringHash__T__I__I("ByteVector", (-137723950)), 1);
    this.Lscodec_bits_ByteVector__f_hashCodebitmap$1 = true;
  }
  return this.Lscodec_bits_ByteVector__f_hashCode$lzy1;
});
$c_Lscodec_bits_ByteVector.prototype.$eq$eq$eq__Lscodec_bits_ByteVector__Z = (function(other) {
  if ((this === other)) {
    return true;
  } else {
    var t = this.size__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var b = other.size__J();
    if ((!(!((lo === b.RTLong__f_lo) && (hi === b.RTLong__f_hi))))) {
      return $p_Lscodec_bits_ByteVector__go$9__J__Lscodec_bits_ByteVector__J__Z(this, new $c_RTLong(lo, hi), other, $L0);
    } else {
      return false;
    }
  }
});
$c_Lscodec_bits_ByteVector.prototype.equals__O__Z = (function(other) {
  return ((other instanceof $c_Lscodec_bits_ByteVector) && this.$eq$eq$eq__Lscodec_bits_ByteVector__Z(other));
});
$c_Lscodec_bits_ByteVector.prototype.toString__T = (function() {
  if (this.isEmpty__Z()) {
    return "ByteVector(empty)";
  } else {
    var a = this.size__J();
    var ahi = a.RTLong__f_hi;
    if (((ahi === 0) ? ((a.RTLong__f_lo >>> 0) < 512) : (ahi < 0))) {
      return (((("ByteVector(" + this.size__J()) + " bytes, 0x") + this.toHex__Lscodec_bits_Bases$HexAlphabet__T($m_Lscodec_bits_Bases$Alphabets$HexLowercase$())) + ")");
    } else {
      return (((("ByteVector(" + this.size__J()) + " bytes, #") + this.hashCode__I()) + ")");
    }
  }
});
$c_Lscodec_bits_ByteVector.prototype.compare__Lscodec_bits_ByteVector__I = (function(that) {
  if ((this === that)) {
    return 0;
  } else {
    var t = this.size__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = that.size__J();
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    if (((hi === hi$1) ? ((lo >>> 0) < (lo$1 >>> 0)) : (hi < hi$1))) {
      var commonLength__lo = lo;
      var commonLength__hi = hi;
    } else {
      var commonLength__lo = lo$1;
      var commonLength__hi = hi$1;
    }
    var i = 0;
    while (true) {
      var value = i;
      var hi$2 = (value >> 31);
      var bhi = commonLength__hi;
      if (((hi$2 === bhi) ? ((value >>> 0) < (commonLength__lo >>> 0)) : (hi$2 < bhi))) {
        var value$1 = i;
        var hi$3 = (value$1 >> 31);
        var x = (255 & this.get__J__B(new $c_RTLong(value$1, hi$3)));
        var this$11 = new $c_sr_RichInt(x);
        var value$2 = i;
        var hi$4 = (value$2 >> 31);
        var y = (255 & that.get__J__B(new $c_RTLong(value$2, hi$4)));
        $m_s_math_Ordering$Int$();
        var x$1 = this$11.sr_RichInt__f_self;
        var cmp = ((x$1 === y) ? 0 : ((x$1 < y) ? (-1) : 1));
        if ((cmp !== 0)) {
          return cmp;
        }
        i = ((1 + i) | 0);
      } else {
        break;
      }
    }
    return (((hi === hi$1) ? ((lo >>> 0) < (lo$1 >>> 0)) : (hi < hi$1)) ? (-1) : (((hi === hi$1) ? ((lo >>> 0) > (lo$1 >>> 0)) : (hi > hi$1)) ? 1 : 0));
  }
});
$c_Lscodec_bits_ByteVector.prototype.compare__O__I = (function(that) {
  return this.compare__Lscodec_bits_ByteVector__I(that);
});
function $isArrayOf_Lscodec_bits_ByteVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_ByteVector)));
}
export { $isArrayOf_Lscodec_bits_ByteVector as $isArrayOf_Lscodec_bits_ByteVector };
function $p_Lsttp_tapir_Codec$__withContentType__Lsttp_model_Part__Lsttp_tapir_RawBodyType__Lsttp_model_MediaType__Lsttp_model_Part($thiz, p, rawBodyType, mediaType) {
  var h = $m_Lsttp_model_HeaderNames$().Lsttp_model_HeaderNames$__f_ContentType;
  var x52 = $f_Lsttp_model_HasHeaders__header__T__s_Option(p, h);
  var x = $m_s_None$();
  if ((x === x52)) {
    if ((rawBodyType instanceof $c_Lsttp_tapir_RawBodyType$StringBody)) {
      var x51 = rawBodyType.Lsttp_tapir_RawBodyType$StringBody__f_charset;
      var this$3 = mediaType.Lsttp_model_MediaType__f_mainType;
      _return: {
        var len = this$3.length;
        if ((len === 4)) {
          var i = 0;
          while ((i !== len)) {
            var index = i;
            var c = this$3.charCodeAt(index);
            var $x_2 = $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c));
            var index$1 = i;
            var c$1 = "text".charCodeAt(index$1);
            if (($x_2 !== $m_jl_Character$().toLowerCase__C__C($m_jl_Character$().toUpperCase__C__C(c$1)))) {
              var $x_1 = false;
              break _return;
            }
            i = ((1 + i) | 0);
          }
          var $x_1 = true;
        } else {
          var $x_1 = false;
        }
      }
      if ($x_1) {
        return p.contentType__Lsttp_model_MediaType__Lsttp_model_Part(mediaType.charset__T__Lsttp_model_MediaType(x51.Ljava_nio_charset_Charset__f_canonicalName));
      }
    }
    return p.contentType__Lsttp_model_MediaType__Lsttp_model_Part(mediaType);
  }
  return p;
}
export { $p_Lsttp_tapir_Codec$__withContentType__Lsttp_model_Part__Lsttp_tapir_RawBodyType__Lsttp_model_MediaType__Lsttp_model_Part as $p_Lsttp_tapir_Codec$__withContentType__Lsttp_model_Part__Lsttp_tapir_RawBodyType__Lsttp_model_MediaType__Lsttp_model_Part };
function $p_Lsttp_tapir_Codec$__toEitherOrList$1__sci_List__sci_List__s_util_Either($thiz, l, acc) {
  var acc$tailLocal1 = acc;
  var l$tailLocal1 = l;
  while (true) {
    var x119 = l$tailLocal1;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x119)) {
      var value = acc$tailLocal1.reverse__sci_List();
      return new $c_s_util_Right(value);
    }
    if ((x119 instanceof $c_sci_$colon$colon)) {
      var x126 = x119.sci_$colon$colon__f_head;
      var x127 = x119.sci_$colon$colon__f_next;
      if ((x126 instanceof $c_s_util_Left)) {
        var t = x126.s_util_Left__f_value;
        return new $c_s_util_Left(t);
      }
      if ((x126 instanceof $c_s_util_Right)) {
        var u = x126.s_util_Right__f_value;
        var this$3 = acc$tailLocal1;
        var acc$tailLocal1$tmp1 = new $c_sci_$colon$colon(u, this$3);
        l$tailLocal1 = x127;
        acc$tailLocal1 = acc$tailLocal1$tmp1;
        continue;
      }
    }
    throw new $c_s_MatchError(x119);
  }
}
export { $p_Lsttp_tapir_Codec$__toEitherOrList$1__sci_List__sci_List__s_util_Either as $p_Lsttp_tapir_Codec$__toEitherOrList$1__sci_List__sci_List__s_util_Either };
/** @constructor */
function $c_Lsttp_tapir_Codec$() {
  this.Lsttp_tapir_Codec$__f_string = null;
  this.Lsttp_tapir_Codec$__f_byteArray = null;
  this.Lsttp_tapir_Codec$__f_fileRange = null;
  this.Lsttp_tapir_Codec$__f_cookie = null;
  $n_Lsttp_tapir_Codec$ = this;
  var f = new $c_Lsttp_tapir_CodecFormat$TextPlain();
  var s = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForString;
  this.Lsttp_tapir_Codec$__f_string = new $c_Lsttp_tapir_Codec$$anon$4(s, f);
  var this$6 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => {
    var this$5 = $m_jl_Byte$();
    return this$5.parseByte__T__I__B(_$6, 10);
  })), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForByte);
  var s2 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForByte;
  new $c_Lsttp_tapir_Codec$$anon$2(s2, this$6);
  var this$10 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$7) => {
    var this$9 = $m_jl_Short$();
    return this$9.parseShort__T__I__S(_$7, 10);
  })), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForShort);
  var s2$1 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForShort;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$1, this$10);
  var this$14 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => {
    var this$13 = $m_jl_Integer$();
    return this$13.java$lang$Integer$$parseIntImpl__T__I__I__I(_$8, 10, 214748364);
  })), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForInt);
  var s2$2 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForInt;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$2, this$14);
  var this$18 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$9) => {
    var this$17 = $m_jl_Long$();
    return this$17.parseLongImplJS__T__I__J(_$9, 10);
  })), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForLong);
  var s2$3 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForLong;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$3, this$18);
  var this$21 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$10) => $m_jl_Float$().parseFloat__T__F(_$10))), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForFloat);
  var s2$4 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForFloat;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$4, this$21);
  var this$24 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$11) => $m_jl_Double$().parseDouble__T__D(_$11))), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForDouble);
  var s2$5 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForDouble;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$5, this$24);
  var this$27 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$12) => $m_sc_StringOps$().toBooleanImpl$extension__T__T__Z(_$12, _$12))), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForBoolean);
  var s2$6 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForBoolean;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$6, this$27);
  var this$28 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$0) => $m_ju_UUID$().fromString__T__ju_UUID(x$0))), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForUUID);
  var s2$7 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForUUID;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$7, this$28);
  var this$30 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$13) => {
    var this$29 = $m_s_package$().BigDecimal__s_math_BigDecimal$();
    return this$29.exact__T__s_math_BigDecimal(_$13);
  })), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForBigDecimal);
  var s2$8 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForBigDecimal;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$8, this$30);
  var this$31 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$14) => $ct_Ljava_math_BigDecimal__T__(new $c_Ljava_math_BigDecimal(), _$14))), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForJBigDecimal);
  var s2$9 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForJBigDecimal;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$9, this$31);
  var this$32 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$15) => $m_s_package$().BigInt__s_math_BigInt$().apply__T__s_math_BigInt(_$15))), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForBigInt);
  var s2$10 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForBigInt;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$10, this$32);
  var this$33 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$16) => $ct_Ljava_math_BigInteger__T__(new $c_Ljava_math_BigInteger(), _$16))), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForJBigInteger);
  var s2$11 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForJBigInteger;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$11, this$33);
  var this$34 = this.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s$1) => $m_s_concurrent_duration_Duration$().apply__T__s_concurrent_duration_Duration(s$1))), $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForScalaDuration);
  var s2$12 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForScalaDuration;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$12, this$34);
  var this$39 = $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec(this.Lsttp_tapir_Codec$__f_string, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((raw) => {
    var this$35 = $m_Lsttp_model_Uri$().parse__T__s_util_Either(raw);
    if ((this$35 instanceof $c_s_util_Right)) {
      var b = this$35.s_util_Right__f_value;
      var $x_1 = new $c_Lsttp_tapir_DecodeResult$Value(b);
    } else {
      if ((!(this$35 instanceof $c_s_util_Left))) {
        throw new $c_s_MatchError(this$35);
      }
      var a = this$35.s_util_Left__f_value;
      var error = $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), a);
      var $x_1 = new $c_Lsttp_tapir_DecodeResult$Error(raw, error);
    }
    return $x_1;
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$26) => _$26.toStringSafe__sci_Set__T($m_sci_Set$EmptySet$()))));
  var s2$13 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForUri;
  new $c_Lsttp_tapir_Codec$$anon$2(s2$13, this$39);
  var f$1 = new $c_Lsttp_tapir_CodecFormat$OctetStream();
  var s$2 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForByteArray;
  this.Lsttp_tapir_Codec$__f_byteArray = new $c_Lsttp_tapir_Codec$$anon$4(s$2, f$1);
  var f$2 = new $c_Lsttp_tapir_CodecFormat$OctetStream();
  $m_Lsttp_tapir_Schema$();
  var f$3 = new $c_Lsttp_tapir_CodecFormat$OctetStream();
  $m_Lsttp_tapir_Schema$();
  var f$4 = new $c_Lsttp_tapir_CodecFormat$OctetStream();
  $m_Lsttp_tapir_Schema$();
  var f$5 = new $c_Lsttp_tapir_CodecFormat$OctetStream();
  var s$6 = $m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForFileRange;
  this.Lsttp_tapir_Codec$__f_fileRange = new $c_Lsttp_tapir_Codec$$anon$4(s$6, f$5);
  $f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec(this.Lsttp_tapir_Codec$__f_fileRange, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$28) => _$28.Lsttp_tapir_FileRange__f_file)), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((f$6) => {
    var range = $m_s_None$();
    return new $c_Lsttp_tapir_FileRange(f$6, range);
  })));
  this.formSeq__Ljava_nio_charset_Charset__Lsttp_tapir_Codec($m_Ljava_nio_charset_UTF\uff3f8$());
  this.formMap__Ljava_nio_charset_Charset__Lsttp_tapir_Codec($m_Ljava_nio_charset_UTF\uff3f8$());
  $m_Lsttp_tapir_Codec$();
  $m_Lsttp_tapir_Codec$();
  $m_Lsttp_tapir_Schema$();
  var schemaType = new $c_Lsttp_tapir_SchemaType$SString();
  $m_Lsttp_tapir_Schema$();
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s$7 = new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  new $c_Lsttp_tapir_CodecFormat$TextPlain();
  $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec($m_Lsttp_tapir_Codec$().Lsttp_tapir_Codec$__f_string, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v) => $m_Lsttp_tapir_DecodeResult$().fromEitherString__T__s_util_Either__Lsttp_tapir_DecodeResult(v, $m_Lsttp_model_MediaType$().parse__T__s_util_Either(v)))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$47) => $p_Lsttp_model_MediaType__toStringCache__T(_$47))));
  $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec($m_Lsttp_tapir_Codec$().Lsttp_tapir_Codec$__f_string, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v$2) => $m_Lsttp_tapir_DecodeResult$().fromEitherString__T__s_util_Either__Lsttp_tapir_DecodeResult(v$2, $m_Lsttp_model_headers_ETag$().parse__T__s_util_Either(v$2)))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$48) => _$48.toString__T())));
  $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec($m_Lsttp_tapir_Codec$().Lsttp_tapir_Codec$__f_string, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v$3) => $m_Lsttp_tapir_DecodeResult$().fromEitherString__T__s_util_Either__Lsttp_tapir_DecodeResult(v$3, $m_Lsttp_model_headers_Range$().parse__T__s_util_Either(v$3)).flatMap__F1__Lsttp_tapir_DecodeResult(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    matchResult25: {
      var $x_2;
      var x = $m_sci_Nil$();
      if (x.equals__O__Z(x$1)) {
        var $x_2 = $m_Lsttp_tapir_DecodeResult$Missing$();
        break matchResult25;
      }
      if ((x$1 !== null)) {
        if ((x$1.lengthCompare__I__I(1) === 0)) {
          var x118 = $f_sc_LinearSeqOps__apply__I__O(x$1, 0);
          var $x_2 = new $c_Lsttp_tapir_DecodeResult$Value(x118);
          break matchResult25;
        }
      }
      var $x_2 = new $c_Lsttp_tapir_DecodeResult$Multiple(x$1);
    }
    return $x_2;
  }))))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$49) => _$49.toString__T())));
  $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec($m_Lsttp_tapir_Codec$().Lsttp_tapir_Codec$__f_string, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v$4) => $m_Lsttp_tapir_DecodeResult$().fromEitherString__T__s_util_Either__Lsttp_tapir_DecodeResult(v$4, $m_Lsttp_model_headers_ContentRange$().parse__T__s_util_Either(v$4)))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$50) => _$50.toString__T())));
  $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec($m_Lsttp_tapir_Codec$().Lsttp_tapir_Codec$__f_string, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((v$5) => $m_Lsttp_tapir_DecodeResult$().fromEitherString__T__s_util_Either__Lsttp_tapir_DecodeResult(v$5, $p_Lsttp_tapir_Codec$__toEitherOrList$1__sci_List__sci_List__s_util_Either(this, $m_Lsttp_model_headers_CacheDirective$().parse__T__sci_List(v$5), $m_sci_Nil$())))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$51) => {
    var f$8 = ((_$52) => _$52.toString__T());
    if ((_$51 === $m_sci_Nil$())) {
      var this$66 = $m_sci_Nil$();
    } else {
      var x0 = _$51.head__O();
      var h = new $c_sci_$colon$colon(f$8(x0), $m_sci_Nil$());
      var t = h;
      var rest = _$51.tail__O();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.head__O();
        var nx = new $c_sci_$colon$colon(f$8(x0$1), $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
        rest = rest.tail__O();
      }
      var this$66 = h;
    }
    return $f_sc_IterableOnceOps__mkString__T__T__T__T(this$66, "", ", ", "");
  })));
  this.Lsttp_tapir_Codec$__f_cookie = $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec($m_Lsttp_tapir_Codec$().Lsttp_tapir_Codec$__f_string, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((cookie) => this.decodeCookie__T__Lsttp_tapir_DecodeResult(cookie))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((cs) => $m_Lsttp_model_headers_Cookie$().toString__sci_List__T(cs))));
  $f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec($m_Lsttp_tapir_Codec$().list__Lsttp_tapir_Codec__Lsttp_tapir_Codec(this.Lsttp_tapir_Codec$__f_cookie), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$53) => {
    var this$68 = $m_s_$less$colon$less$();
    var toIterableOnce = this$68.s_$less$colon$less$__f_singleton;
    return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(_$53, toIterableOnce);
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$54) => new $c_sci_$colon$colon(_$54, $m_sci_Nil$()))));
}
export { $c_Lsttp_tapir_Codec$ as $c_Lsttp_tapir_Codec$ };
$c_Lsttp_tapir_Codec$.prototype = new $h_O();
$c_Lsttp_tapir_Codec$.prototype.constructor = $c_Lsttp_tapir_Codec$;
/** @constructor */
function $h_Lsttp_tapir_Codec$() {
}
export { $h_Lsttp_tapir_Codec$ as $h_Lsttp_tapir_Codec$ };
$h_Lsttp_tapir_Codec$.prototype = $c_Lsttp_tapir_Codec$.prototype;
$c_Lsttp_tapir_Codec$.prototype.parsedString__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec = (function(parse, evidence$1) {
  var this$2 = $f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec(this.Lsttp_tapir_Codec$__f_string, parse, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$27) => $dp_toString__T(_$27))));
  return new $c_Lsttp_tapir_Codec$$anon$2(evidence$1, this$2);
});
$c_Lsttp_tapir_Codec$.prototype.formSeq__Ljava_nio_charset_Charset__Lsttp_tapir_Codec = (function(charset) {
  var this$2 = this.Lsttp_tapir_Codec$__f_string;
  var f = new $c_Lsttp_tapir_CodecFormat$XWwwFormUrlencoded();
  var this$3 = new $c_Lsttp_tapir_Codec$$anon$3(f, this$2);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$29) => $m_Lsttp_tapir_internal_UrlencodedData$().decode__T__Ljava_nio_charset_Charset__sci_Seq(_$29, charset)));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$30) => $m_Lsttp_tapir_internal_UrlencodedData$().encode__sci_Seq__Ljava_nio_charset_Charset__T(_$30, charset)));
  return $f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec(this$3, f$1, g);
});
$c_Lsttp_tapir_Codec$.prototype.formMap__Ljava_nio_charset_Charset__Lsttp_tapir_Codec = (function(charset) {
  return $f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec(this.formSeq__Ljava_nio_charset_Charset__Lsttp_tapir_Codec(charset), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$31) => $m_sci_Map$().from__sc_IterableOnce__sci_Map(_$31))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$32) => $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(_$32))));
});
$c_Lsttp_tapir_Codec$.prototype.multipart__sci_Map__s_Option__Lsttp_tapir_MultipartCodec = (function(partCodecs, defaultPartCodec) {
  $m_Lsttp_tapir_MultipartCodec$();
  var this$3 = partCodecs.map__F1__sc_IterableOps(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t) => {
    var _1 = t._1__O();
    var _2 = t._2__O().Lsttp_tapir_PartCodec__f_rawBodyType;
    return $ct_T2__O__O__(new $c_T2(), _1, _2);
  })));
  var partTypes = $m_sci_Map$().from__sc_IterableOnce__sci_Map(this$3);
  if (defaultPartCodec.isEmpty__Z()) {
    var defaultType = $m_s_None$();
  } else {
    var x0 = defaultPartCodec.get__O();
    var defaultType = new $c_s_Some(x0.Lsttp_tapir_PartCodec__f_rawBodyType);
  }
  var rawBodyType = new $c_Lsttp_tapir_RawBodyType$MultipartBody(partTypes, defaultType);
  var codec = new $c_Lsttp_tapir_Codec$$anon$5(partCodecs, defaultPartCodec);
  return new $c_Lsttp_tapir_MultipartCodec(rawBodyType, codec);
});
$c_Lsttp_tapir_Codec$.prototype.part__Lsttp_tapir_Codec__Lsttp_tapir_Codec = (function(c) {
  var f = c.format__Lsttp_tapir_CodecFormat();
  $m_Lsttp_tapir_Schema$();
  $m_Lsttp_tapir_Schema$();
  var schemaType = new $c_Lsttp_tapir_SchemaType$SBinary();
  $m_Lsttp_tapir_Schema$();
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s = new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  var this$11 = new $c_Lsttp_tapir_Codec$$anon$4(s, f);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e) => $f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(c, e.Lsttp_model_Part__f_body).map__F1__Lsttp_tapir_DecodeResult(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e$2) => ((r) => {
    var name$1 = e$2.Lsttp_model_Part__f_name;
    var otherDispositionParams = e$2.Lsttp_model_Part__f_otherDispositionParams;
    var headers = e$2.Lsttp_model_Part__f_headers;
    return new $c_Lsttp_model_Part(name$1, r, otherDispositionParams, headers);
  }))(e)))));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e$2$1) => {
    var body$1 = c.encode__O__O(e$2$1.Lsttp_model_Part__f_body);
    var name$1$1 = e$2$1.Lsttp_model_Part__f_name;
    var otherDispositionParams$1 = e$2$1.Lsttp_model_Part__f_otherDispositionParams;
    var headers$1 = e$2$1.Lsttp_model_Part__f_headers;
    return new $c_Lsttp_model_Part(name$1$1, body$1, otherDispositionParams$1, headers$1);
  }));
  return $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec(this$11, f$1, g);
});
$c_Lsttp_tapir_Codec$.prototype.textWebSocketFrame__Lsttp_tapir_Codec__Lsttp_tapir_Codec = (function(stringCodec) {
  $m_Lsttp_tapir_Codec$();
  var f = stringCodec.format__Lsttp_tapir_CodecFormat();
  $m_Lsttp_tapir_Schema$();
  $m_Lsttp_tapir_Schema$();
  var schemaType = new $c_Lsttp_tapir_SchemaType$SString();
  $m_Lsttp_tapir_Schema$();
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s = new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  var this$16 = new $c_Lsttp_tapir_Codec$$anon$4(s, f);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $c_Lsttp_ws_WebSocketFrame$Text)) {
      var x66 = x$1.Lsttp_ws_WebSocketFrame$Text__f_payload;
      return $f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(stringCodec, x66);
    } else {
      var original = x$1.toString__T();
      var error = new $c_Lsttp_tapir_model_UnsupportedWebSocketFrameException(x$1);
      return new $c_Lsttp_tapir_DecodeResult$Error(original, error);
    }
  }));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
    var payload = stringCodec.encode__O__O(a);
    var rsv = $m_s_None$();
    return new $c_Lsttp_ws_WebSocketFrame$Text(payload, true, rsv);
  }));
  var this$17 = $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec(this$16, f$1, g);
  var s2 = stringCodec.schema__Lsttp_tapir_Schema();
  return new $c_Lsttp_tapir_Codec$$anon$2(s2, this$17);
});
$c_Lsttp_tapir_Codec$.prototype.listBinary__Lsttp_tapir_Codec__Lsttp_tapir_Codec = (function(c) {
  var f = c.format__Lsttp_tapir_CodecFormat();
  $m_Lsttp_tapir_Schema$();
  $m_Lsttp_tapir_Schema$();
  var schemaType = new $c_Lsttp_tapir_SchemaType$SBinary();
  $m_Lsttp_tapir_Schema$();
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s = new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  var this$11 = new $c_Lsttp_tapir_Codec$$anon$4(s, f);
  var f$3 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ts) => {
    var $x_2 = $m_Lsttp_tapir_DecodeResult$();
    var f$1 = ((l) => $f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(c, l));
    if ((ts === $m_sci_Nil$())) {
      var $x_1 = $m_sci_Nil$();
    } else {
      var x0 = ts.head__O();
      var h = new $c_sci_$colon$colon(f$1(x0), $m_sci_Nil$());
      var t = h;
      var rest = ts.tail__O();
      while ((rest !== $m_sci_Nil$())) {
        var x0$1 = rest.head__O();
        var nx = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
        rest = rest.tail__O();
      }
      var $x_1 = h;
    }
    return $x_2.sequence__sci_Seq__Lsttp_tapir_DecodeResult($x_1).map__F1__Lsttp_tapir_DecodeResult(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$40) => _$40.toList__sci_List())));
  }));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((us) => {
    var f$2 = ((h$1) => c.encode__O__O(h$1));
    if ((us === $m_sci_Nil$())) {
      return $m_sci_Nil$();
    } else {
      var x0$2 = us.head__O();
      var h$2 = new $c_sci_$colon$colon(f$2(x0$2), $m_sci_Nil$());
      var t$1 = h$2;
      var rest$1 = us.tail__O();
      while ((rest$1 !== $m_sci_Nil$())) {
        var x0$3 = rest$1.head__O();
        var nx$1 = new $c_sci_$colon$colon(f$2(x0$3), $m_sci_Nil$());
        t$1.sci_$colon$colon__f_next = nx$1;
        t$1 = nx$1;
        rest$1 = rest$1.tail__O();
      }
      return h$2;
    }
  }));
  return $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec(this$11, f$3, g);
});
$c_Lsttp_tapir_Codec$.prototype.list__Lsttp_tapir_Codec__Lsttp_tapir_Codec = (function(c) {
  var this$1 = this.listBinary__Lsttp_tapir_Codec__Lsttp_tapir_Codec(c);
  var s2 = c.schema__Lsttp_tapir_Schema().asIterable__Lsttp_tapir_Schema();
  return new $c_Lsttp_tapir_Codec$$anon$2(s2, this$1);
});
$c_Lsttp_tapir_Codec$.prototype.listHead__Lsttp_tapir_Codec__Lsttp_tapir_Codec = (function(c) {
  var this$7 = $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec(this.listBinary__Lsttp_tapir_Codec__Lsttp_tapir_Codec(c), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    matchResult20: {
      var $x_1;
      var x = $m_sci_Nil$();
      if (x.equals__O__Z(x$1)) {
        var $x_1 = $m_Lsttp_tapir_DecodeResult$Missing$();
        break matchResult20;
      }
      if ((x$1 !== null)) {
        if ((x$1.lengthCompare__I__I(1) === 0)) {
          var x103 = $f_sc_LinearSeqOps__apply__I__O(x$1, 0);
          var $x_1 = new $c_Lsttp_tapir_DecodeResult$Value(x103);
          break matchResult20;
        }
      }
      var $x_1 = new $c_Lsttp_tapir_DecodeResult$Multiple(x$1);
    }
    return $x_1;
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$43) => {
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([_$43]));
    return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
  })));
  var s2 = c.schema__Lsttp_tapir_Schema();
  return new $c_Lsttp_tapir_Codec$$anon$2(s2, this$7);
});
$c_Lsttp_tapir_Codec$.prototype.listHeadOption__Lsttp_tapir_Codec__Lsttp_tapir_Codec = (function(c) {
  var this$8 = $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec(this.listBinary__Lsttp_tapir_Codec__Lsttp_tapir_Codec(c), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    matchResult21: {
      var $x_1;
      var x = $m_sci_Nil$();
      if (x.equals__O__Z(x$1)) {
        var v = $m_s_None$();
        var $x_1 = new $c_Lsttp_tapir_DecodeResult$Value(v);
        break matchResult21;
      }
      if ((x$1 !== null)) {
        if ((x$1.lengthCompare__I__I(1) === 0)) {
          var x106 = $f_sc_LinearSeqOps__apply__I__O(x$1, 0);
          var v$1 = new $c_s_Some(x106);
          var $x_1 = new $c_Lsttp_tapir_DecodeResult$Value(v$1);
          break matchResult21;
        }
      }
      var f = ((_$44) => $dp_toString__T(_$44));
      if ((x$1 === $m_sci_Nil$())) {
        var vs = $m_sci_Nil$();
      } else {
        var x0 = x$1.head__O();
        var h = new $c_sci_$colon$colon(f(x0), $m_sci_Nil$());
        var t = h;
        var rest = x$1.tail__O();
        while ((rest !== $m_sci_Nil$())) {
          var x0$1 = rest.head__O();
          var nx = new $c_sci_$colon$colon(f(x0$1), $m_sci_Nil$());
          t.sci_$colon$colon__f_next = nx;
          t = nx;
          rest = rest.tail__O();
        }
        var vs = h;
      }
      var $x_1 = new $c_Lsttp_tapir_DecodeResult$Multiple(vs);
    }
    return $x_1;
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$45) => _$45.toList__sci_List())));
  var s2 = c.schema__Lsttp_tapir_Schema().asOption__Lsttp_tapir_Schema();
  return new $c_Lsttp_tapir_Codec$$anon$2(s2, this$8);
});
$c_Lsttp_tapir_Codec$.prototype.optionHead__Lsttp_tapir_Codec__Lsttp_tapir_Codec = (function(c) {
  var f = c.format__Lsttp_tapir_CodecFormat();
  $m_Lsttp_tapir_Schema$();
  $m_Lsttp_tapir_Schema$();
  var schemaType = new $c_Lsttp_tapir_SchemaType$SBinary();
  $m_Lsttp_tapir_Schema$();
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  var s = new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  var this$12 = new $c_Lsttp_tapir_Codec$$anon$4(s, f);
  var f$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    var x = $m_s_None$();
    if ((x === x$1)) {
      return $m_Lsttp_tapir_DecodeResult$Missing$();
    }
    if ((x$1 instanceof $c_s_Some)) {
      var e = x$1.s_Some__f_value;
      return $f_Lsttp_tapir_Codec__decode__O__Lsttp_tapir_DecodeResult(c, e);
    }
    throw new $c_s_MatchError(x$1);
  }));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((u) => {
    var value = c.encode__O__O(u);
    return new $c_s_Some(value);
  }));
  var this$13 = $f_Lsttp_tapir_Codec__mapDecode__F1__F1__Lsttp_tapir_Codec(this$12, f$1, g);
  var s2 = c.schema__Lsttp_tapir_Schema();
  return new $c_Lsttp_tapir_Codec$$anon$2(s2, this$13);
});
$c_Lsttp_tapir_Codec$.prototype.anyString__Lsttp_tapir_CodecFormat__F1__F1__Lsttp_tapir_Schema__Lsttp_tapir_Codec = (function(cf, _rawDecode, _encode, evidence$1) {
  var isOptional = evidence$1.Lsttp_tapir_Schema__f_isOptional;
  var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((s) => {
    var toDecode = ((isOptional && (s === "")) ? "null" : s);
    return _rawDecode.apply__O__O(toDecode);
  }));
  var g = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((t) => {
    if (isOptional) {
      var x$2 = $m_s_None$();
      var $x_1 = ((t !== null) && $dp_equals__O__Z(t, x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return "";
    } else {
      return _encode.apply__O__O(t);
    }
  }));
  return new $c_Lsttp_tapir_Codec$$anon$8(f, g, evidence$1, cf);
});
$c_Lsttp_tapir_Codec$.prototype.decodeCookie__T__Lsttp_tapir_DecodeResult = (function(cookie) {
  matchResult27: {
    var $x_1;
    var x130 = $m_Lsttp_model_headers_Cookie$().parse__T__s_util_Either(cookie);
    if ((x130 instanceof $c_s_util_Left)) {
      var e = x130.s_util_Left__f_value;
      var error = $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), e);
      var $x_1 = new $c_Lsttp_tapir_DecodeResult$Error(cookie, error);
      break matchResult27;
    }
    if ((x130 instanceof $c_s_util_Right)) {
      var r = x130.s_util_Right__f_value;
      var $x_1 = new $c_Lsttp_tapir_DecodeResult$Value(r);
      break matchResult27;
    }
    throw new $c_s_MatchError(x130);
  }
  return $x_1;
});
var $d_Lsttp_tapir_Codec$ = new $TypeData().initClass($c_Lsttp_tapir_Codec$, "sttp.tapir.Codec$", ({
  Lsttp_tapir_Codec$: 1,
  Lsttp_tapir_CodecExtensions: 1,
  Lsttp_tapir_CodecExtensions2: 1,
  Lsttp_tapir_macros_FormCodecMacros: 1,
  Lsttp_tapir_macros_CodecMacros: 1,
  Lsttp_tapir_LowPriorityCodec: 1
}));
export { $d_Lsttp_tapir_Codec$ as $d_Lsttp_tapir_Codec$ };
var $n_Lsttp_tapir_Codec$;
function $m_Lsttp_tapir_Codec$() {
  if ((!$n_Lsttp_tapir_Codec$)) {
    $n_Lsttp_tapir_Codec$ = new $c_Lsttp_tapir_Codec$();
  }
  return $n_Lsttp_tapir_Codec$;
}
export { $m_Lsttp_tapir_Codec$ as $m_Lsttp_tapir_Codec$ };
/** @constructor */
function $c_Lsttp_tapir_DecodeResult$Error(original, error) {
  this.Lsttp_tapir_DecodeResult$Error__f_original = null;
  this.Lsttp_tapir_DecodeResult$Error__f_error = null;
  this.Lsttp_tapir_DecodeResult$Error__f_original = original;
  this.Lsttp_tapir_DecodeResult$Error__f_error = error;
}
export { $c_Lsttp_tapir_DecodeResult$Error as $c_Lsttp_tapir_DecodeResult$Error };
$c_Lsttp_tapir_DecodeResult$Error.prototype = new $h_O();
$c_Lsttp_tapir_DecodeResult$Error.prototype.constructor = $c_Lsttp_tapir_DecodeResult$Error;
/** @constructor */
function $h_Lsttp_tapir_DecodeResult$Error() {
}
export { $h_Lsttp_tapir_DecodeResult$Error as $h_Lsttp_tapir_DecodeResult$Error };
$h_Lsttp_tapir_DecodeResult$Error.prototype = $c_Lsttp_tapir_DecodeResult$Error.prototype;
$c_Lsttp_tapir_DecodeResult$Error.prototype.map__F1__Lsttp_tapir_DecodeResult = (function(f) {
  return this;
});
$c_Lsttp_tapir_DecodeResult$Error.prototype.flatMap__F1__Lsttp_tapir_DecodeResult = (function(f) {
  return this;
});
$c_Lsttp_tapir_DecodeResult$Error.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_DecodeResult$Error.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1475389217, true);
});
$c_Lsttp_tapir_DecodeResult$Error.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_DecodeResult$Error)) {
    if ((this.Lsttp_tapir_DecodeResult$Error__f_original === x$0.Lsttp_tapir_DecodeResult$Error__f_original)) {
      var x = this.Lsttp_tapir_DecodeResult$Error__f_error;
      var x$2 = x$0.Lsttp_tapir_DecodeResult$Error__f_error;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_DecodeResult$Error.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_DecodeResult$Error.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_DecodeResult$Error.prototype.productPrefix__T = (function() {
  return "Error";
});
$c_Lsttp_tapir_DecodeResult$Error.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_DecodeResult$Error__f_original;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_DecodeResult$Error__f_error;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_DecodeResult$Error.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "original";
  }
  if ((n === 1)) {
    return "error";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_DecodeResult$Error(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_DecodeResult$Error)));
}
export { $isArrayOf_Lsttp_tapir_DecodeResult$Error as $isArrayOf_Lsttp_tapir_DecodeResult$Error };
var $d_Lsttp_tapir_DecodeResult$Error = new $TypeData().initClass($c_Lsttp_tapir_DecodeResult$Error, "sttp.tapir.DecodeResult$Error", ({
  Lsttp_tapir_DecodeResult$Error: 1,
  Lsttp_tapir_DecodeResult: 1,
  Lsttp_tapir_DecodeResult$Failure: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_DecodeResult$Error as $d_Lsttp_tapir_DecodeResult$Error };
class $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException extends $c_jl_Exception {
  constructor(partFailures) {
    super();
    this.Lsttp_tapir_DecodeResult$Error$MultipartDecodeException__f_partFailures = null;
    this.Lsttp_tapir_DecodeResult$Error$MultipartDecodeException__f_partFailures = partFailures;
    var s = $f_sc_Iterable__toString__T(partFailures);
    var e = $m_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException$().causeOrNull__sci_List__jl_Throwable(partFailures);
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, s, e, true, false);
  }
  productIterator__sc_Iterator() {
    return new $c_s_Product$$anon$1(this);
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 188210239, true);
  }
  equals__O__Z(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException)) {
      var x = this.Lsttp_tapir_DecodeResult$Error$MultipartDecodeException__f_partFailures;
      var x$2 = x$0.Lsttp_tapir_DecodeResult$Error$MultipartDecodeException__f_partFailures;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  }
  productArity__I() {
    return 1;
  }
  productPrefix__T() {
    return "MultipartDecodeException";
  }
  productElement__I__O(n) {
    if ((n === 0)) {
      return this.Lsttp_tapir_DecodeResult$Error$MultipartDecodeException__f_partFailures;
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  productElementName__I__T(n) {
    if ((n === 0)) {
      return "partFailures";
    }
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
  }
}
export { $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException as $c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException };
function $isArrayOf_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_DecodeResult$Error$MultipartDecodeException)));
}
export { $isArrayOf_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException as $isArrayOf_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException };
var $d_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException = new $TypeData().initClass($c_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException, "sttp.tapir.DecodeResult$Error$MultipartDecodeException", ({
  Lsttp_tapir_DecodeResult$Error$MultipartDecodeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException as $d_Lsttp_tapir_DecodeResult$Error$MultipartDecodeException };
/** @constructor */
function $c_Lsttp_tapir_DecodeResult$InvalidValue(errors) {
  this.Lsttp_tapir_DecodeResult$InvalidValue__f_errors = null;
  this.Lsttp_tapir_DecodeResult$InvalidValue__f_errors = errors;
}
export { $c_Lsttp_tapir_DecodeResult$InvalidValue as $c_Lsttp_tapir_DecodeResult$InvalidValue };
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype = new $h_O();
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype.constructor = $c_Lsttp_tapir_DecodeResult$InvalidValue;
/** @constructor */
function $h_Lsttp_tapir_DecodeResult$InvalidValue() {
}
export { $h_Lsttp_tapir_DecodeResult$InvalidValue as $h_Lsttp_tapir_DecodeResult$InvalidValue };
$h_Lsttp_tapir_DecodeResult$InvalidValue.prototype = $c_Lsttp_tapir_DecodeResult$InvalidValue.prototype;
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype.map__F1__Lsttp_tapir_DecodeResult = (function(f) {
  return this;
});
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype.flatMap__F1__Lsttp_tapir_DecodeResult = (function(f) {
  return this;
});
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1595024660, true);
});
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_DecodeResult$InvalidValue)) {
    var x = this.Lsttp_tapir_DecodeResult$InvalidValue__f_errors;
    var x$2 = x$0.Lsttp_tapir_DecodeResult$InvalidValue__f_errors;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype.productPrefix__T = (function() {
  return "InvalidValue";
});
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_DecodeResult$InvalidValue__f_errors;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_DecodeResult$InvalidValue.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "errors";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_DecodeResult$InvalidValue(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_DecodeResult$InvalidValue)));
}
export { $isArrayOf_Lsttp_tapir_DecodeResult$InvalidValue as $isArrayOf_Lsttp_tapir_DecodeResult$InvalidValue };
var $d_Lsttp_tapir_DecodeResult$InvalidValue = new $TypeData().initClass($c_Lsttp_tapir_DecodeResult$InvalidValue, "sttp.tapir.DecodeResult$InvalidValue", ({
  Lsttp_tapir_DecodeResult$InvalidValue: 1,
  Lsttp_tapir_DecodeResult: 1,
  Lsttp_tapir_DecodeResult$Failure: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_DecodeResult$InvalidValue as $d_Lsttp_tapir_DecodeResult$InvalidValue };
/** @constructor */
function $c_Lsttp_tapir_DecodeResult$Multiple(vs) {
  this.Lsttp_tapir_DecodeResult$Multiple__f_vs = null;
  this.Lsttp_tapir_DecodeResult$Multiple__f_vs = vs;
}
export { $c_Lsttp_tapir_DecodeResult$Multiple as $c_Lsttp_tapir_DecodeResult$Multiple };
$c_Lsttp_tapir_DecodeResult$Multiple.prototype = new $h_O();
$c_Lsttp_tapir_DecodeResult$Multiple.prototype.constructor = $c_Lsttp_tapir_DecodeResult$Multiple;
/** @constructor */
function $h_Lsttp_tapir_DecodeResult$Multiple() {
}
export { $h_Lsttp_tapir_DecodeResult$Multiple as $h_Lsttp_tapir_DecodeResult$Multiple };
$h_Lsttp_tapir_DecodeResult$Multiple.prototype = $c_Lsttp_tapir_DecodeResult$Multiple.prototype;
$c_Lsttp_tapir_DecodeResult$Multiple.prototype.map__F1__Lsttp_tapir_DecodeResult = (function(f) {
  return this;
});
$c_Lsttp_tapir_DecodeResult$Multiple.prototype.flatMap__F1__Lsttp_tapir_DecodeResult = (function(f) {
  return this;
});
$c_Lsttp_tapir_DecodeResult$Multiple.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_DecodeResult$Multiple.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 497964451, true);
});
$c_Lsttp_tapir_DecodeResult$Multiple.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_DecodeResult$Multiple)) {
    var x = this.Lsttp_tapir_DecodeResult$Multiple__f_vs;
    var x$2 = x$0.Lsttp_tapir_DecodeResult$Multiple__f_vs;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lsttp_tapir_DecodeResult$Multiple.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_DecodeResult$Multiple.prototype.productArity__I = (function() {
  return 1;
});
$c_Lsttp_tapir_DecodeResult$Multiple.prototype.productPrefix__T = (function() {
  return "Multiple";
});
$c_Lsttp_tapir_DecodeResult$Multiple.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_DecodeResult$Multiple__f_vs;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_DecodeResult$Multiple.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "vs";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lsttp_tapir_DecodeResult$Multiple(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_DecodeResult$Multiple)));
}
export { $isArrayOf_Lsttp_tapir_DecodeResult$Multiple as $isArrayOf_Lsttp_tapir_DecodeResult$Multiple };
var $d_Lsttp_tapir_DecodeResult$Multiple = new $TypeData().initClass($c_Lsttp_tapir_DecodeResult$Multiple, "sttp.tapir.DecodeResult$Multiple", ({
  Lsttp_tapir_DecodeResult$Multiple: 1,
  Lsttp_tapir_DecodeResult: 1,
  Lsttp_tapir_DecodeResult$Failure: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_DecodeResult$Multiple as $d_Lsttp_tapir_DecodeResult$Multiple };
/** @constructor */
function $c_Lsttp_tapir_Schema$() {
  this.Lsttp_tapir_Schema$__f_ModifyCollectionElements = null;
  this.Lsttp_tapir_Schema$__f_schemaForString = null;
  this.Lsttp_tapir_Schema$__f_schemaForByte = null;
  this.Lsttp_tapir_Schema$__f_schemaForShort = null;
  this.Lsttp_tapir_Schema$__f_schemaForInt = null;
  this.Lsttp_tapir_Schema$__f_schemaForLong = null;
  this.Lsttp_tapir_Schema$__f_schemaForFloat = null;
  this.Lsttp_tapir_Schema$__f_schemaForDouble = null;
  this.Lsttp_tapir_Schema$__f_schemaForBoolean = null;
  this.Lsttp_tapir_Schema$__f_schemaForFileRange = null;
  this.Lsttp_tapir_Schema$__f_schemaForByteArray = null;
  this.Lsttp_tapir_Schema$__f_schemaForByteBuffer = null;
  this.Lsttp_tapir_Schema$__f_schemaForInputStream = null;
  this.Lsttp_tapir_Schema$__f_schemaForInputStreamRange = null;
  this.Lsttp_tapir_Schema$__f_schemaForScalaDuration = null;
  this.Lsttp_tapir_Schema$__f_schemaForUUID = null;
  this.Lsttp_tapir_Schema$__f_schemaForBigDecimal = null;
  this.Lsttp_tapir_Schema$__f_schemaForJBigDecimal = null;
  this.Lsttp_tapir_Schema$__f_schemaForBigInt = null;
  this.Lsttp_tapir_Schema$__f_schemaForJBigInteger = null;
  this.Lsttp_tapir_Schema$__f_schemaForUri = null;
  $n_Lsttp_tapir_Schema$ = this;
  this.Lsttp_tapir_Schema$__f_ModifyCollectionElements = "each";
  $m_Lsttp_tapir_Schema$();
  var schemaType = new $c_Lsttp_tapir_SchemaType$SString();
  $m_Lsttp_tapir_Schema$();
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForString = new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
  $m_Lsttp_tapir_Schema$();
  var schemaType$1 = new $c_Lsttp_tapir_SchemaType$SInteger();
  $m_Lsttp_tapir_Schema$();
  var name$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$1 = false;
  $m_Lsttp_tapir_Schema$();
  var description$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$2 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$1 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$1 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$1 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$1 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForByte = new $c_Lsttp_tapir_Schema(schemaType$1, name$1, isOptional$1, description$1, default$2, format$1, encodedExample$1, deprecated$1, hidden$1, validator$1, attributes$1);
  $m_Lsttp_tapir_Schema$();
  var schemaType$2 = new $c_Lsttp_tapir_SchemaType$SInteger();
  $m_Lsttp_tapir_Schema$();
  var name$2 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$2 = false;
  $m_Lsttp_tapir_Schema$();
  var description$2 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$3 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$2 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$2 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$2 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$2 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$2 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$2 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForShort = new $c_Lsttp_tapir_Schema(schemaType$2, name$2, isOptional$2, description$2, default$3, format$2, encodedExample$2, deprecated$2, hidden$2, validator$2, attributes$2);
  $m_Lsttp_tapir_Schema$();
  var schemaType$3 = new $c_Lsttp_tapir_SchemaType$SInteger();
  $m_Lsttp_tapir_Schema$();
  var name$3 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$3 = false;
  $m_Lsttp_tapir_Schema$();
  var description$3 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$4 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$3 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$3 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$3 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$3 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$3 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$3 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForInt = new $c_Lsttp_tapir_Schema(schemaType$3, name$3, isOptional$3, description$3, default$4, format$3, encodedExample$3, deprecated$3, hidden$3, validator$3, attributes$3).format__T__Lsttp_tapir_Schema("int32");
  $m_Lsttp_tapir_Schema$();
  var schemaType$4 = new $c_Lsttp_tapir_SchemaType$SInteger();
  $m_Lsttp_tapir_Schema$();
  var name$4 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$4 = false;
  $m_Lsttp_tapir_Schema$();
  var description$4 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$5 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$4 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$4 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$4 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$4 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$4 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$4 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForLong = new $c_Lsttp_tapir_Schema(schemaType$4, name$4, isOptional$4, description$4, default$5, format$4, encodedExample$4, deprecated$4, hidden$4, validator$4, attributes$4).format__T__Lsttp_tapir_Schema("int64");
  $m_Lsttp_tapir_Schema$();
  var schemaType$5 = new $c_Lsttp_tapir_SchemaType$SNumber();
  $m_Lsttp_tapir_Schema$();
  var name$5 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$5 = false;
  $m_Lsttp_tapir_Schema$();
  var description$5 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$6 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$5 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$5 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$5 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$5 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$5 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$5 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForFloat = new $c_Lsttp_tapir_Schema(schemaType$5, name$5, isOptional$5, description$5, default$6, format$5, encodedExample$5, deprecated$5, hidden$5, validator$5, attributes$5).format__T__Lsttp_tapir_Schema("float");
  $m_Lsttp_tapir_Schema$();
  var schemaType$6 = new $c_Lsttp_tapir_SchemaType$SNumber();
  $m_Lsttp_tapir_Schema$();
  var name$6 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$6 = false;
  $m_Lsttp_tapir_Schema$();
  var description$6 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$7 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$6 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$6 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$6 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$6 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$6 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$6 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForDouble = new $c_Lsttp_tapir_Schema(schemaType$6, name$6, isOptional$6, description$6, default$7, format$6, encodedExample$6, deprecated$6, hidden$6, validator$6, attributes$6).format__T__Lsttp_tapir_Schema("double");
  $m_Lsttp_tapir_Schema$();
  var schemaType$7 = new $c_Lsttp_tapir_SchemaType$SBoolean();
  $m_Lsttp_tapir_Schema$();
  var name$7 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$7 = false;
  $m_Lsttp_tapir_Schema$();
  var description$7 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$8 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$7 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$7 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$7 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$7 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$7 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$7 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForBoolean = new $c_Lsttp_tapir_Schema(schemaType$7, name$7, isOptional$7, description$7, default$8, format$7, encodedExample$7, deprecated$7, hidden$7, validator$7, attributes$7);
  $m_Lsttp_tapir_Schema$();
  var fields = $m_sci_Nil$();
  var schemaType$8 = new $c_Lsttp_tapir_SchemaType$SProduct(fields);
  $m_Lsttp_tapir_Schema$();
  var name$8 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$8 = false;
  $m_Lsttp_tapir_Schema$();
  var description$8 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$9 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$8 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$8 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$8 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$8 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$8 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  $m_Lsttp_tapir_AttributeMap$();
  $m_Lsttp_tapir_Schema$();
  var schemaType$9 = new $c_Lsttp_tapir_SchemaType$SBinary();
  $m_Lsttp_tapir_Schema$();
  var name$9 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$9 = false;
  $m_Lsttp_tapir_Schema$();
  var description$9 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$10 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$9 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$9 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$9 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$9 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$9 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$9 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForFileRange = new $c_Lsttp_tapir_Schema(schemaType$9, name$9, isOptional$9, description$9, default$10, format$9, encodedExample$9, deprecated$9, hidden$9, validator$9, attributes$9);
  $m_Lsttp_tapir_Schema$();
  var schemaType$10 = new $c_Lsttp_tapir_SchemaType$SBinary();
  $m_Lsttp_tapir_Schema$();
  var name$10 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$10 = false;
  $m_Lsttp_tapir_Schema$();
  var description$10 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$11 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$10 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$10 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$10 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$10 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$10 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$10 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForByteArray = new $c_Lsttp_tapir_Schema(schemaType$10, name$10, isOptional$10, description$10, default$11, format$10, encodedExample$10, deprecated$10, hidden$10, validator$10, attributes$10);
  $m_Lsttp_tapir_Schema$();
  var schemaType$11 = new $c_Lsttp_tapir_SchemaType$SBinary();
  $m_Lsttp_tapir_Schema$();
  var name$11 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$11 = false;
  $m_Lsttp_tapir_Schema$();
  var description$11 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$12 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$11 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$11 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$11 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$11 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$11 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$11 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForByteBuffer = new $c_Lsttp_tapir_Schema(schemaType$11, name$11, isOptional$11, description$11, default$12, format$11, encodedExample$11, deprecated$11, hidden$11, validator$11, attributes$11);
  $m_Lsttp_tapir_Schema$();
  var schemaType$12 = new $c_Lsttp_tapir_SchemaType$SBinary();
  $m_Lsttp_tapir_Schema$();
  var name$12 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$12 = false;
  $m_Lsttp_tapir_Schema$();
  var description$12 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$13 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$12 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$12 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$12 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$12 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$12 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$12 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForInputStream = new $c_Lsttp_tapir_Schema(schemaType$12, name$12, isOptional$12, description$12, default$13, format$12, encodedExample$12, deprecated$12, hidden$12, validator$12, attributes$12);
  $m_Lsttp_tapir_Schema$();
  var schemaType$13 = new $c_Lsttp_tapir_SchemaType$SBinary();
  $m_Lsttp_tapir_Schema$();
  var name$13 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$13 = false;
  $m_Lsttp_tapir_Schema$();
  var description$13 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$14 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$13 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$13 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$13 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$13 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$13 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$13 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForInputStreamRange = new $c_Lsttp_tapir_Schema(schemaType$13, name$13, isOptional$13, description$13, default$14, format$13, encodedExample$13, deprecated$13, hidden$13, validator$13, attributes$13);
  $m_Lsttp_tapir_Schema$();
  var schemaType$14 = new $c_Lsttp_tapir_SchemaType$SString();
  $m_Lsttp_tapir_Schema$();
  var name$14 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$14 = false;
  $m_Lsttp_tapir_Schema$();
  var description$14 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$15 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$14 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$14 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$14 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$14 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$14 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$14 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForScalaDuration = new $c_Lsttp_tapir_Schema(schemaType$14, name$14, isOptional$14, description$14, default$15, format$14, encodedExample$14, deprecated$14, hidden$14, validator$14, attributes$14);
  $m_Lsttp_tapir_Schema$();
  var schemaType$15 = new $c_Lsttp_tapir_SchemaType$SString();
  $m_Lsttp_tapir_Schema$();
  var name$15 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$15 = false;
  $m_Lsttp_tapir_Schema$();
  var description$15 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$16 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$15 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$15 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$15 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$15 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$15 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$15 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForUUID = new $c_Lsttp_tapir_Schema(schemaType$15, name$15, isOptional$15, description$15, default$16, format$15, encodedExample$15, deprecated$15, hidden$15, validator$15, attributes$15).format__T__Lsttp_tapir_Schema("uuid");
  $m_Lsttp_tapir_Schema$();
  var schemaType$16 = new $c_Lsttp_tapir_SchemaType$SNumber();
  $m_Lsttp_tapir_Schema$();
  var name$16 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$16 = false;
  $m_Lsttp_tapir_Schema$();
  var description$16 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$17 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$16 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$16 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$16 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$16 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$16 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$16 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForBigDecimal = new $c_Lsttp_tapir_Schema(schemaType$16, name$16, isOptional$16, description$16, default$17, format$16, encodedExample$16, deprecated$16, hidden$16, validator$16, attributes$16);
  $m_Lsttp_tapir_Schema$();
  var schemaType$17 = new $c_Lsttp_tapir_SchemaType$SNumber();
  $m_Lsttp_tapir_Schema$();
  var name$17 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$17 = false;
  $m_Lsttp_tapir_Schema$();
  var description$17 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$18 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$17 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$17 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$17 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$17 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$17 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$17 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForJBigDecimal = new $c_Lsttp_tapir_Schema(schemaType$17, name$17, isOptional$17, description$17, default$18, format$17, encodedExample$17, deprecated$17, hidden$17, validator$17, attributes$17);
  $m_Lsttp_tapir_Schema$();
  var schemaType$18 = new $c_Lsttp_tapir_SchemaType$SInteger();
  $m_Lsttp_tapir_Schema$();
  var name$18 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$18 = false;
  $m_Lsttp_tapir_Schema$();
  var description$18 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$19 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$18 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$18 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$18 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$18 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$18 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$18 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForBigInt = new $c_Lsttp_tapir_Schema(schemaType$18, name$18, isOptional$18, description$18, default$19, format$18, encodedExample$18, deprecated$18, hidden$18, validator$18, attributes$18);
  $m_Lsttp_tapir_Schema$();
  var schemaType$19 = new $c_Lsttp_tapir_SchemaType$SInteger();
  $m_Lsttp_tapir_Schema$();
  var name$19 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$19 = false;
  $m_Lsttp_tapir_Schema$();
  var description$19 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$20 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$19 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$19 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$19 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$19 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$19 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$19 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForJBigInteger = new $c_Lsttp_tapir_Schema(schemaType$19, name$19, isOptional$19, description$19, default$20, format$19, encodedExample$19, deprecated$19, hidden$19, validator$19, attributes$19);
  $m_Lsttp_tapir_Schema$();
  var schemaType$20 = new $c_Lsttp_tapir_SchemaType$SBinary();
  $m_Lsttp_tapir_Schema$();
  var name$20 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$20 = false;
  $m_Lsttp_tapir_Schema$();
  var description$20 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$21 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$20 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$20 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$20 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$20 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$20 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  $m_Lsttp_tapir_AttributeMap$();
  $m_Lsttp_tapir_Schema$();
  var schemaType$21 = new $c_Lsttp_tapir_SchemaType$SString();
  $m_Lsttp_tapir_Schema$();
  var name$21 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional$21 = false;
  $m_Lsttp_tapir_Schema$();
  var description$21 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$22 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format$21 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample$21 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated$21 = false;
  $m_Lsttp_tapir_Schema$();
  var hidden$21 = false;
  $m_Lsttp_tapir_Schema$();
  var validator$21 = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes$21 = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  this.Lsttp_tapir_Schema$__f_schemaForUri = new $c_Lsttp_tapir_Schema(schemaType$21, name$21, isOptional$21, description$21, default$22, format$21, encodedExample$21, deprecated$21, hidden$21, validator$21, attributes$21).encodedExample__O__Lsttp_tapir_Schema($m_Lsttp_model_Uri$().apply__T__T__Lsttp_model_Uri("https", "example.com"));
}
export { $c_Lsttp_tapir_Schema$ as $c_Lsttp_tapir_Schema$ };
$c_Lsttp_tapir_Schema$.prototype = new $h_O();
$c_Lsttp_tapir_Schema$.prototype.constructor = $c_Lsttp_tapir_Schema$;
/** @constructor */
function $h_Lsttp_tapir_Schema$() {
}
export { $h_Lsttp_tapir_Schema$ as $h_Lsttp_tapir_Schema$ };
$h_Lsttp_tapir_Schema$.prototype = $c_Lsttp_tapir_Schema$.prototype;
$c_Lsttp_tapir_Schema$.prototype.schemaForOption__Lsttp_tapir_Schema__Lsttp_tapir_Schema = (function(evidence$1) {
  return evidence$1.asOption__Lsttp_tapir_Schema();
});
$c_Lsttp_tapir_Schema$.prototype.schemaForIterable__Lsttp_tapir_Schema__Lsttp_tapir_Schema = (function(evidence$1) {
  return evidence$1.asIterable__Lsttp_tapir_Schema();
});
$c_Lsttp_tapir_Schema$.prototype.schemaForSet__Lsttp_tapir_Schema__Lsttp_tapir_Schema = (function(evidence$1) {
  return this.schemaForIterable__Lsttp_tapir_Schema__Lsttp_tapir_Schema(evidence$1).attribute__Lsttp_tapir_AttributeKey__O__Lsttp_tapir_Schema($m_Lsttp_tapir_Schema$UniqueItems$().Lsttp_tapir_Schema$UniqueItems$__f_Attribute, new $c_Lsttp_tapir_Schema$UniqueItems(true));
});
$c_Lsttp_tapir_Schema$.prototype.any__Lsttp_tapir_Schema = (function() {
  $m_Lsttp_tapir_Schema$();
  var subtypes = $m_sci_Nil$();
  var discriminator = $m_s_None$();
  var subtypeSchema = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$13) => $m_s_None$()));
  var schemaType = new $c_Lsttp_tapir_SchemaType$SCoproduct(subtypes, discriminator, subtypeSchema);
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  return new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
});
$c_Lsttp_tapir_Schema$.prototype.anyObject__Lsttp_tapir_Schema = (function() {
  $m_Lsttp_tapir_Schema$();
  var fields = $m_sci_Nil$();
  var schemaType = new $c_Lsttp_tapir_SchemaType$SProduct(fields);
  var name = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var isOptional = false;
  $m_Lsttp_tapir_Schema$();
  var description = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var default$1 = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var format = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var encodedExample = $m_s_None$();
  $m_Lsttp_tapir_Schema$();
  var deprecated = false;
  $m_Lsttp_tapir_Schema$();
  var hidden = false;
  $m_Lsttp_tapir_Schema$();
  var validator = $m_Lsttp_tapir_Validator$().Lsttp_tapir_Validator$__f__pass;
  $m_Lsttp_tapir_Schema$();
  var attributes = $m_Lsttp_tapir_AttributeMap$().Lsttp_tapir_AttributeMap$__f_Empty;
  return new $c_Lsttp_tapir_Schema(schemaType, name, isOptional, description, default$1, format, encodedExample, deprecated, hidden, validator, attributes);
});
$c_Lsttp_tapir_Schema$.prototype.fromProduct__s_Product__Lsttp_tapir_Schema = (function(x$0) {
  return new $c_Lsttp_tapir_Schema(x$0.productElement__I__O(0), x$0.productElement__I__O(1), (!(!x$0.productElement__I__O(2))), x$0.productElement__I__O(3), x$0.productElement__I__O(4), x$0.productElement__I__O(5), x$0.productElement__I__O(6), (!(!x$0.productElement__I__O(7))), (!(!x$0.productElement__I__O(8))), x$0.productElement__I__O(9), x$0.productElement__I__O(10));
});
$c_Lsttp_tapir_Schema$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lsttp_tapir_Schema(p);
});
var $d_Lsttp_tapir_Schema$ = new $TypeData().initClass($c_Lsttp_tapir_Schema$, "sttp.tapir.Schema$", ({
  Lsttp_tapir_Schema$: 1,
  Lsttp_tapir_LowPrioritySchema: 1,
  Lsttp_tapir_generic_auto_SchemaMagnoliaDerivation: 1,
  Lsttp_tapir_macros_SchemaCompanionMacros: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lsttp_tapir_Schema$ as $d_Lsttp_tapir_Schema$ };
var $n_Lsttp_tapir_Schema$;
function $m_Lsttp_tapir_Schema$() {
  if ((!$n_Lsttp_tapir_Schema$)) {
    $n_Lsttp_tapir_Schema$ = new $c_Lsttp_tapir_Schema$();
  }
  return $n_Lsttp_tapir_Schema$;
}
export { $m_Lsttp_tapir_Schema$ as $m_Lsttp_tapir_Schema$ };
/** @constructor */
function $c_Lsttp_tapir_Validator$Custom(validationLogic, showMessage) {
  this.Lsttp_tapir_Validator$Custom__f_validationLogic = null;
  this.Lsttp_tapir_Validator$Custom__f_showMessage = null;
  this.Lsttp_tapir_Validator$Custom__f_validationLogic = validationLogic;
  this.Lsttp_tapir_Validator$Custom__f_showMessage = showMessage;
}
export { $c_Lsttp_tapir_Validator$Custom as $c_Lsttp_tapir_Validator$Custom };
$c_Lsttp_tapir_Validator$Custom.prototype = new $h_O();
$c_Lsttp_tapir_Validator$Custom.prototype.constructor = $c_Lsttp_tapir_Validator$Custom;
/** @constructor */
function $h_Lsttp_tapir_Validator$Custom() {
}
export { $h_Lsttp_tapir_Validator$Custom as $h_Lsttp_tapir_Validator$Custom };
$h_Lsttp_tapir_Validator$Custom.prototype = $c_Lsttp_tapir_Validator$Custom.prototype;
$c_Lsttp_tapir_Validator$Custom.prototype.contramap__F1__Lsttp_tapir_Validator = (function(g) {
  return new $c_Lsttp_tapir_Validator$Mapped(this, g);
});
$c_Lsttp_tapir_Validator$Custom.prototype.and__Lsttp_tapir_Validator__Lsttp_tapir_Validator = (function(other) {
  return $f_Lsttp_tapir_Validator__and__Lsttp_tapir_Validator__Lsttp_tapir_Validator(this, other);
});
$c_Lsttp_tapir_Validator$Custom.prototype.apply__O__sci_List = (function(t) {
  return $f_Lsttp_tapir_Validator$Primitive__apply__O__sci_List(this, t);
});
$c_Lsttp_tapir_Validator$Custom.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Validator$Custom.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1709309230, true);
});
$c_Lsttp_tapir_Validator$Custom.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_Validator$Custom)) {
    var x = this.Lsttp_tapir_Validator$Custom__f_validationLogic;
    var x$2 = x$0.Lsttp_tapir_Validator$Custom__f_validationLogic;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_Validator$Custom__f_showMessage;
      var x$4 = x$0.Lsttp_tapir_Validator$Custom__f_showMessage;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_Validator$Custom.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Validator$Custom.prototype.productArity__I = (function() {
  return 2;
});
$c_Lsttp_tapir_Validator$Custom.prototype.productPrefix__T = (function() {
  return "Custom";
});
$c_Lsttp_tapir_Validator$Custom.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lsttp_tapir_Validator$Custom__f_validationLogic;
  }
  if ((n === 1)) {
    return this.Lsttp_tapir_Validator$Custom__f_showMessage;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Validator$Custom.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "validationLogic";
  }
  if ((n === 1)) {
    return "showMessage";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_Validator$Custom.prototype.doValidate__O__Lsttp_tapir_ValidationResult = (function(t) {
  return this.Lsttp_tapir_Validator$Custom__f_validationLogic.apply__O__O(t);
});
function $isArrayOf_Lsttp_tapir_Validator$Custom(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Validator$Custom)));
}
export { $isArrayOf_Lsttp_tapir_Validator$Custom as $isArrayOf_Lsttp_tapir_Validator$Custom };
var $d_Lsttp_tapir_Validator$Custom = new $TypeData().initClass($c_Lsttp_tapir_Validator$Custom, "sttp.tapir.Validator$Custom", ({
  Lsttp_tapir_Validator$Custom: 1,
  Lsttp_tapir_Validator: 1,
  Lsttp_tapir_Validator$Primitive: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Validator$Custom as $d_Lsttp_tapir_Validator$Custom };
/** @constructor */
function $c_Lsttp_tapir_Validator$Enumeration(possibleValues, encode, name) {
  this.Lsttp_tapir_Validator$Enumeration__f_possibleValues = null;
  this.Lsttp_tapir_Validator$Enumeration__f_encode = null;
  this.Lsttp_tapir_Validator$Enumeration__f_name = null;
  this.Lsttp_tapir_Validator$Enumeration__f_possibleValues = possibleValues;
  this.Lsttp_tapir_Validator$Enumeration__f_encode = encode;
  this.Lsttp_tapir_Validator$Enumeration__f_name = name;
}
export { $c_Lsttp_tapir_Validator$Enumeration as $c_Lsttp_tapir_Validator$Enumeration };
$c_Lsttp_tapir_Validator$Enumeration.prototype = new $h_O();
$c_Lsttp_tapir_Validator$Enumeration.prototype.constructor = $c_Lsttp_tapir_Validator$Enumeration;
/** @constructor */
function $h_Lsttp_tapir_Validator$Enumeration() {
}
export { $h_Lsttp_tapir_Validator$Enumeration as $h_Lsttp_tapir_Validator$Enumeration };
$h_Lsttp_tapir_Validator$Enumeration.prototype = $c_Lsttp_tapir_Validator$Enumeration.prototype;
$c_Lsttp_tapir_Validator$Enumeration.prototype.contramap__F1__Lsttp_tapir_Validator = (function(g) {
  return new $c_Lsttp_tapir_Validator$Mapped(this, g);
});
$c_Lsttp_tapir_Validator$Enumeration.prototype.and__Lsttp_tapir_Validator__Lsttp_tapir_Validator = (function(other) {
  return $f_Lsttp_tapir_Validator__and__Lsttp_tapir_Validator__Lsttp_tapir_Validator(this, other);
});
$c_Lsttp_tapir_Validator$Enumeration.prototype.apply__O__sci_List = (function(t) {
  return $f_Lsttp_tapir_Validator$Primitive__apply__O__sci_List(this, t);
});
$c_Lsttp_tapir_Validator$Enumeration.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_Validator$Enumeration.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1480953738), true);
});
$c_Lsttp_tapir_Validator$Enumeration.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_tapir_Validator$Enumeration)) {
    var x = this.Lsttp_tapir_Validator$Enumeration__f_possibleValues;
    var x$2 = x$0.Lsttp_tapir_Validator$Enumeration__f_possibleValues;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lsttp_tapir_Validator$Enumeration__f_encode;
      var x$4 = x$0.Lsttp_tapir_Validator$Enumeration__f_encode;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.Lsttp_tapir_Validator$Enumeration__f_name;
      var x$6 = x$0.Lsttp_tapir_Validator$Enumeration__f_name;
      return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_tapir_Validator$Enumeration.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_tapir_Validator$Enumeration.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_tapir_Validator$Enumeration.prototype.productPrefix__T = (function() {
  return "Enumeration";
});
$c_Lsttp_tapir_Validator$Enumeration.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_tapir_Validator$Enumeration__f_possibleValues;
      break;
    }
    case 1: {
      return this.Lsttp_tapir_Validator$Enumeration__f_encode;
      break;
    }
    case 2: {
      return this.Lsttp_tapir_Validator$Enumeration__f_name;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_Validator$Enumeration.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "possibleValues";
      break;
    }
    case 1: {
      return "encode";
      break;
    }
    case 2: {
      return "name";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_tapir_Validator$Enumeration.prototype.doValidate__O__Lsttp_tapir_ValidationResult = (function(t) {
  return $m_Lsttp_tapir_ValidationResult$().validWhen__Z__Lsttp_tapir_ValidationResult(this.Lsttp_tapir_Validator$Enumeration__f_possibleValues.contains__O__Z(t));
});
function $isArrayOf_Lsttp_tapir_Validator$Enumeration(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_tapir_Validator$Enumeration)));
}
export { $isArrayOf_Lsttp_tapir_Validator$Enumeration as $isArrayOf_Lsttp_tapir_Validator$Enumeration };
var $d_Lsttp_tapir_Validator$Enumeration = new $TypeData().initClass($c_Lsttp_tapir_Validator$Enumeration, "sttp.tapir.Validator$Enumeration", ({
  Lsttp_tapir_Validator$Enumeration: 1,
  Lsttp_tapir_Validator: 1,
  Lsttp_tapir_Validator$Primitive: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_tapir_Validator$Enumeration as $d_Lsttp_tapir_Validator$Enumeration };
/** @constructor */
function $c_Lsttp_ws_WebSocketFrame$Text(payload, finalFragment, rsv) {
  this.Lsttp_ws_WebSocketFrame$Text__f_payload = null;
  this.Lsttp_ws_WebSocketFrame$Text__f_finalFragment = false;
  this.Lsttp_ws_WebSocketFrame$Text__f_rsv = null;
  this.Lsttp_ws_WebSocketFrame$Text__f_payload = payload;
  this.Lsttp_ws_WebSocketFrame$Text__f_finalFragment = finalFragment;
  this.Lsttp_ws_WebSocketFrame$Text__f_rsv = rsv;
}
export { $c_Lsttp_ws_WebSocketFrame$Text as $c_Lsttp_ws_WebSocketFrame$Text };
$c_Lsttp_ws_WebSocketFrame$Text.prototype = new $h_O();
$c_Lsttp_ws_WebSocketFrame$Text.prototype.constructor = $c_Lsttp_ws_WebSocketFrame$Text;
/** @constructor */
function $h_Lsttp_ws_WebSocketFrame$Text() {
}
export { $h_Lsttp_ws_WebSocketFrame$Text as $h_Lsttp_ws_WebSocketFrame$Text };
$h_Lsttp_ws_WebSocketFrame$Text.prototype = $c_Lsttp_ws_WebSocketFrame$Text.prototype;
$c_Lsttp_ws_WebSocketFrame$Text.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_ws_WebSocketFrame$Text.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  var data = $f_T__hashCode__I("Text");
  acc = $m_sr_Statics$().mix__I__I__I(hash, data);
  var hash$1 = acc;
  var x = this.Lsttp_ws_WebSocketFrame$Text__f_payload;
  var data$1 = $m_sr_Statics$().anyHash__O__I(x);
  acc = $m_sr_Statics$().mix__I__I__I(hash$1, data$1);
  var hash$2 = acc;
  var data$2 = (this.Lsttp_ws_WebSocketFrame$Text__f_finalFragment ? 1231 : 1237);
  acc = $m_sr_Statics$().mix__I__I__I(hash$2, data$2);
  var hash$3 = acc;
  var x$1 = this.Lsttp_ws_WebSocketFrame$Text__f_rsv;
  var data$3 = $m_sr_Statics$().anyHash__O__I(x$1);
  acc = $m_sr_Statics$().mix__I__I__I(hash$3, data$3);
  var hash$4 = acc;
  return $m_sr_Statics$().finalizeHash__I__I__I(hash$4, 3);
});
$c_Lsttp_ws_WebSocketFrame$Text.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsttp_ws_WebSocketFrame$Text)) {
    if (((this.Lsttp_ws_WebSocketFrame$Text__f_finalFragment === x$0.Lsttp_ws_WebSocketFrame$Text__f_finalFragment) && (this.Lsttp_ws_WebSocketFrame$Text__f_payload === x$0.Lsttp_ws_WebSocketFrame$Text__f_payload))) {
      var x = this.Lsttp_ws_WebSocketFrame$Text__f_rsv;
      var x$2 = x$0.Lsttp_ws_WebSocketFrame$Text__f_rsv;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lsttp_ws_WebSocketFrame$Text.prototype.toString__T = (function() {
  return $m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lsttp_ws_WebSocketFrame$Text.prototype.productArity__I = (function() {
  return 3;
});
$c_Lsttp_ws_WebSocketFrame$Text.prototype.productPrefix__T = (function() {
  return "Text";
});
$c_Lsttp_ws_WebSocketFrame$Text.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lsttp_ws_WebSocketFrame$Text__f_payload;
      break;
    }
    case 1: {
      return this.Lsttp_ws_WebSocketFrame$Text__f_finalFragment;
      break;
    }
    case 2: {
      return this.Lsttp_ws_WebSocketFrame$Text__f_rsv;
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lsttp_ws_WebSocketFrame$Text.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "payload";
      break;
    }
    case 1: {
      return "finalFragment";
      break;
    }
    case 2: {
      return "rsv";
      break;
    }
    default: {
      throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lsttp_ws_WebSocketFrame$Text(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lsttp_ws_WebSocketFrame$Text)));
}
export { $isArrayOf_Lsttp_ws_WebSocketFrame$Text as $isArrayOf_Lsttp_ws_WebSocketFrame$Text };
var $d_Lsttp_ws_WebSocketFrame$Text = new $TypeData().initClass($c_Lsttp_ws_WebSocketFrame$Text, "sttp.ws.WebSocketFrame$Text", ({
  Lsttp_ws_WebSocketFrame$Text: 1,
  Lsttp_ws_WebSocketFrame: 1,
  Lsttp_ws_WebSocketFrame$Data: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lsttp_ws_WebSocketFrame$Text as $d_Lsttp_ws_WebSocketFrame$Text };
function $f_Lcats_Apply__productL__O__O__O($thiz, fa, fb) {
  return $thiz.map2__O__O__F2__O(fa, fb, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a, _$2) => a)));
}
export { $f_Lcats_Apply__productL__O__O__O as $f_Lcats_Apply__productL__O__O__O };
function $f_Lcats_Apply__product__O__O__O($thiz, fa, fb) {
  return $thiz.ap__O__O__O($thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => $ct_T2__O__O__(new $c_T2(), a, b)))))), fb);
}
export { $f_Lcats_Apply__product__O__O__O as $f_Lcats_Apply__product__O__O__O };
function $f_Lcats_Apply__map2__O__O__F2__O($thiz, fa, fb, f) {
  return $thiz.map__O__F1__O($thiz.product__O__O__O(fa, fb), $f_F2__tupled__F1(f));
}
export { $f_Lcats_Apply__map2__O__O__F2__O as $f_Lcats_Apply__map2__O__O__F2__O };
function $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fb$2) => $thiz.map2__O__O__F2__O(fa, fb$2, f))));
}
export { $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval as $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval };
function $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__($thiz, leftNE, rightNE) {
  $thiz.Lcats_data_Chain$Append__f_leftNE = leftNE;
  $thiz.Lcats_data_Chain$Append__f_rightNE = rightNE;
  return $thiz;
}
export { $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__ as $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__ };
function $ct_Lcats_data_Chain$Append__Lcats_data_Chain__Lcats_data_Chain__($thiz, left, right) {
  $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__($thiz, left, right);
  return $thiz;
}
export { $ct_Lcats_data_Chain$Append__Lcats_data_Chain__Lcats_data_Chain__ as $ct_Lcats_data_Chain$Append__Lcats_data_Chain__Lcats_data_Chain__ };
/** @constructor */
function $c_Lcats_data_Chain$Append() {
  this.Lcats_data_Chain$Append__f_leftNE = null;
  this.Lcats_data_Chain$Append__f_rightNE = null;
}
export { $c_Lcats_data_Chain$Append as $c_Lcats_data_Chain$Append };
$c_Lcats_data_Chain$Append.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Append.prototype.constructor = $c_Lcats_data_Chain$Append;
/** @constructor */
function $h_Lcats_data_Chain$Append() {
}
export { $h_Lcats_data_Chain$Append as $h_Lcats_data_Chain$Append };
$h_Lcats_data_Chain$Append.prototype = $c_Lcats_data_Chain$Append.prototype;
$c_Lcats_data_Chain$Append.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Append.prototype.productArity__I = (function() {
  return 2;
});
$c_Lcats_data_Chain$Append.prototype.productPrefix__T = (function() {
  return "Append";
});
$c_Lcats_data_Chain$Append.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Append__f_leftNE;
  }
  if ((n === 1)) {
    return this.Lcats_data_Chain$Append__f_rightNE;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_Chain$Append.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "leftNE";
  }
  if ((n === 1)) {
    return "rightNE";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_data_Chain$Append(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Append)));
}
export { $isArrayOf_Lcats_data_Chain$Append as $isArrayOf_Lcats_data_Chain$Append };
var $d_Lcats_data_Chain$Append = new $TypeData().initClass($c_Lcats_data_Chain$Append, "cats.data.Chain$Append", ({
  Lcats_data_Chain$Append: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_Chain$Append as $d_Lcats_data_Chain$Append };
/** @constructor */
function $c_Lcats_data_Chain$Singleton(a) {
  this.Lcats_data_Chain$Singleton__f_a = null;
  this.Lcats_data_Chain$Singleton__f_a = a;
}
export { $c_Lcats_data_Chain$Singleton as $c_Lcats_data_Chain$Singleton };
$c_Lcats_data_Chain$Singleton.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Singleton.prototype.constructor = $c_Lcats_data_Chain$Singleton;
/** @constructor */
function $h_Lcats_data_Chain$Singleton() {
}
export { $h_Lcats_data_Chain$Singleton as $h_Lcats_data_Chain$Singleton };
$h_Lcats_data_Chain$Singleton.prototype = $c_Lcats_data_Chain$Singleton.prototype;
$c_Lcats_data_Chain$Singleton.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Singleton.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Chain$Singleton.prototype.productPrefix__T = (function() {
  return "Singleton";
});
$c_Lcats_data_Chain$Singleton.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Singleton__f_a;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_Chain$Singleton.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "a";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_data_Chain$Singleton(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Singleton)));
}
export { $isArrayOf_Lcats_data_Chain$Singleton as $isArrayOf_Lcats_data_Chain$Singleton };
var $d_Lcats_data_Chain$Singleton = new $TypeData().initClass($c_Lcats_data_Chain$Singleton, "cats.data.Chain$Singleton", ({
  Lcats_data_Chain$Singleton: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_Chain$Singleton as $d_Lcats_data_Chain$Singleton };
/** @constructor */
function $c_Lcats_data_Chain$Wrap(seq) {
  this.Lcats_data_Chain$Wrap__f_seq = null;
  this.Lcats_data_Chain$Wrap__f_seq = seq;
}
export { $c_Lcats_data_Chain$Wrap as $c_Lcats_data_Chain$Wrap };
$c_Lcats_data_Chain$Wrap.prototype = new $h_Lcats_data_Chain$NonEmpty();
$c_Lcats_data_Chain$Wrap.prototype.constructor = $c_Lcats_data_Chain$Wrap;
/** @constructor */
function $h_Lcats_data_Chain$Wrap() {
}
export { $h_Lcats_data_Chain$Wrap as $h_Lcats_data_Chain$Wrap };
$h_Lcats_data_Chain$Wrap.prototype = $c_Lcats_data_Chain$Wrap.prototype;
$c_Lcats_data_Chain$Wrap.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Wrap.prototype.productArity__I = (function() {
  return 1;
});
$c_Lcats_data_Chain$Wrap.prototype.productPrefix__T = (function() {
  return "Wrap";
});
$c_Lcats_data_Chain$Wrap.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lcats_data_Chain$Wrap__f_seq;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_Chain$Wrap.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "seq";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lcats_data_Chain$Wrap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_data_Chain$Wrap)));
}
export { $isArrayOf_Lcats_data_Chain$Wrap as $isArrayOf_Lcats_data_Chain$Wrap };
var $d_Lcats_data_Chain$Wrap = new $TypeData().initClass($c_Lcats_data_Chain$Wrap, "cats.data.Chain$Wrap", ({
  Lcats_data_Chain$Wrap: 1,
  Lcats_data_Chain$NonEmpty: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lcats_data_Chain$Wrap as $d_Lcats_data_Chain$Wrap };
/** @constructor */
function $c_Lcats_data_ChainInstances$$anon$4(fa$4) {
  this.Lcats_data_ChainInstances$$anon$4__f_fa$2 = null;
  this.Lcats_data_ChainInstances$$anon$4__f_fa$2 = fa$4;
}
export { $c_Lcats_data_ChainInstances$$anon$4 as $c_Lcats_data_ChainInstances$$anon$4 };
$c_Lcats_data_ChainInstances$$anon$4.prototype = new $h_sc_AbstractIterable();
$c_Lcats_data_ChainInstances$$anon$4.prototype.constructor = $c_Lcats_data_ChainInstances$$anon$4;
/** @constructor */
function $h_Lcats_data_ChainInstances$$anon$4() {
}
export { $h_Lcats_data_ChainInstances$$anon$4 as $h_Lcats_data_ChainInstances$$anon$4 };
$h_Lcats_data_ChainInstances$$anon$4.prototype = $c_Lcats_data_ChainInstances$$anon$4.prototype;
$c_Lcats_data_ChainInstances$$anon$4.prototype.iterator__sc_Iterator = (function() {
  return this.Lcats_data_ChainInstances$$anon$4__f_fa$2.iterator__sc_Iterator();
});
var $d_Lcats_data_ChainInstances$$anon$4 = new $TypeData().initClass($c_Lcats_data_ChainInstances$$anon$4, "cats.data.ChainInstances$$anon$4", ({
  Lcats_data_ChainInstances$$anon$4: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1
}));
export { $d_Lcats_data_ChainInstances$$anon$4 as $d_Lcats_data_ChainInstances$$anon$4 };
function $f_Lcom_raquo_airstream_core_EventStream__mergeWith__sci_Seq__Lcom_raquo_airstream_core_EventStream($thiz, streams) {
  var allStreams = streams.prepended__O__O($thiz);
  return $m_Lcom_raquo_airstream_core_EventStream$().merge__sci_Seq__Lcom_raquo_airstream_core_EventStream(allStreams);
}
export { $f_Lcom_raquo_airstream_core_EventStream__mergeWith__sci_Seq__Lcom_raquo_airstream_core_EventStream as $f_Lcom_raquo_airstream_core_EventStream__mergeWith__sci_Seq__Lcom_raquo_airstream_core_EventStream };
function $f_Lcom_raquo_airstream_core_EventStream__scanLeft__O__F2__Lcom_raquo_airstream_core_Signal($thiz, initial, fn) {
  return $f_Lcom_raquo_airstream_core_EventStream__scanLeftRecover__s_util_Try__F2__Lcom_raquo_airstream_core_Signal($thiz, new $c_s_util_Success(initial), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((currentValue, nextParentValue) => {
    try {
      var r1 = fn.apply__O__O__O(currentValue.get__O(), nextParentValue.get__O());
      return new $c_s_util_Success(r1);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        return new $c_s_util_Failure(e$2);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  })));
}
export { $f_Lcom_raquo_airstream_core_EventStream__scanLeft__O__F2__Lcom_raquo_airstream_core_Signal as $f_Lcom_raquo_airstream_core_EventStream__scanLeft__O__F2__Lcom_raquo_airstream_core_Signal };
function $f_Lcom_raquo_airstream_core_EventStream__scanLeftRecover__s_util_Try__F2__Lcom_raquo_airstream_core_Signal($thiz, initial, fn) {
  return new $c_Lcom_raquo_airstream_misc_ScanLeftSignal($thiz, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => initial)), fn);
}
export { $f_Lcom_raquo_airstream_core_EventStream__scanLeftRecover__s_util_Try__F2__Lcom_raquo_airstream_core_Signal as $f_Lcom_raquo_airstream_core_EventStream__scanLeftRecover__s_util_Try__F2__Lcom_raquo_airstream_core_Signal };
function $f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal($thiz, initial, cacheInitialValue) {
  var initial$1 = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    var value = initial.apply__O();
    return new $c_s_util_Success(value);
  }));
  return new $c_Lcom_raquo_airstream_misc_SignalFromStream($thiz, initial$1, cacheInitialValue);
}
export { $f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal as $f_Lcom_raquo_airstream_core_EventStream__toSignal__F0__Z__Lcom_raquo_airstream_core_Signal };
function $is_Lcom_raquo_airstream_core_EventStream(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_raquo_airstream_core_EventStream)));
}
export { $is_Lcom_raquo_airstream_core_EventStream as $is_Lcom_raquo_airstream_core_EventStream };
function $isArrayOf_Lcom_raquo_airstream_core_EventStream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_airstream_core_EventStream)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_EventStream as $isArrayOf_Lcom_raquo_airstream_core_EventStream };
var $d_Lcom_raquo_airstream_core_EventStream = new $TypeData().initClass(1, "com.raquo.airstream.core.EventStream", ({
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1
}));
export { $d_Lcom_raquo_airstream_core_EventStream as $d_Lcom_raquo_airstream_core_EventStream };
function $f_Lcom_raquo_airstream_core_Signal__scanLeft__F1__F2__Lcom_raquo_airstream_core_Signal($thiz, makeInitial, fn) {
  return $f_Lcom_raquo_airstream_core_Signal__scanLeftRecover__F1__F2__Lcom_raquo_airstream_core_Signal($thiz, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((parentInitial) => parentInitial.map__F1__s_util_Try(makeInitial))), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((currentValue, nextParentValue) => {
    try {
      var r1 = fn.apply__O__O__O(currentValue.get__O(), nextParentValue.get__O());
      return new $c_s_util_Success(r1);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        return new $c_s_util_Failure(e$2);
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  })));
}
export { $f_Lcom_raquo_airstream_core_Signal__scanLeft__F1__F2__Lcom_raquo_airstream_core_Signal as $f_Lcom_raquo_airstream_core_Signal__scanLeft__F1__F2__Lcom_raquo_airstream_core_Signal };
function $f_Lcom_raquo_airstream_core_Signal__scanLeftRecover__F1__F2__Lcom_raquo_airstream_core_Signal($thiz, makeInitial, fn) {
  return new $c_Lcom_raquo_airstream_misc_ScanLeftSignal($thiz, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => makeInitial.apply__O__O($thiz.tryNow__s_util_Try()))), fn);
}
export { $f_Lcom_raquo_airstream_core_Signal__scanLeftRecover__F1__F2__Lcom_raquo_airstream_core_Signal as $f_Lcom_raquo_airstream_core_Signal__scanLeftRecover__F1__F2__Lcom_raquo_airstream_core_Signal };
function $f_Lcom_raquo_airstream_core_Signal__onStart__V($thiz) {
  $thiz.tryNow__s_util_Try();
}
export { $f_Lcom_raquo_airstream_core_Signal__onStart__V as $f_Lcom_raquo_airstream_core_Signal__onStart__V };
function $is_Lcom_raquo_airstream_core_Signal(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcom_raquo_airstream_core_Signal)));
}
export { $is_Lcom_raquo_airstream_core_Signal as $is_Lcom_raquo_airstream_core_Signal };
function $isArrayOf_Lcom_raquo_airstream_core_Signal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcom_raquo_airstream_core_Signal)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_Signal as $isArrayOf_Lcom_raquo_airstream_core_Signal };
var $d_Lcom_raquo_airstream_core_Signal = new $TypeData().initClass(1, "com.raquo.airstream.core.Signal", ({
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1
}));
export { $d_Lcom_raquo_airstream_core_Signal as $d_Lcom_raquo_airstream_core_Signal };
/** @constructor */
function $c_Ljava_nio_HeapCharBuffer(_capacity, _array0, _arrayOffset0, _initialPosition, _initialLimit, _readOnly) {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_CharBuffer__f__array = null;
  this.Ljava_nio_CharBuffer__f__arrayOffset = 0;
  this.Ljava_nio_HeapCharBuffer__f__readOnly = false;
  this.Ljava_nio_HeapCharBuffer__f__readOnly = _readOnly;
  $ct_Ljava_nio_CharBuffer__I__AC__I__(this, _capacity, _array0, _arrayOffset0);
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer.call(this, _initialLimit);
}
export { $c_Ljava_nio_HeapCharBuffer as $c_Ljava_nio_HeapCharBuffer };
$c_Ljava_nio_HeapCharBuffer.prototype = new $h_Ljava_nio_CharBuffer();
$c_Ljava_nio_HeapCharBuffer.prototype.constructor = $c_Ljava_nio_HeapCharBuffer;
/** @constructor */
function $h_Ljava_nio_HeapCharBuffer() {
}
export { $h_Ljava_nio_HeapCharBuffer as $h_Ljava_nio_HeapCharBuffer };
$h_Ljava_nio_HeapCharBuffer.prototype = $c_Ljava_nio_HeapCharBuffer.prototype;
$c_Ljava_nio_HeapCharBuffer.prototype.isReadOnly__Z = (function() {
  return this.Ljava_nio_HeapCharBuffer__f__readOnly;
});
$c_Ljava_nio_HeapCharBuffer.prototype.subSequence__I__I__Ljava_nio_CharBuffer = (function(start, end) {
  if ((((start < 0) || (end < start)) || (end > ((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return new $c_Ljava_nio_HeapCharBuffer(this.Ljava_nio_Buffer__f__capacity, this.Ljava_nio_CharBuffer__f__array, this.Ljava_nio_CharBuffer__f__arrayOffset, ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + start) | 0), ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + end) | 0), this.Ljava_nio_HeapCharBuffer__f__readOnly);
});
$c_Ljava_nio_HeapCharBuffer.prototype.get__C = (function() {
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  var a = this.Ljava_nio_CharBuffer__f__array;
  var i = ((this.Ljava_nio_CharBuffer__f__arrayOffset + p) | 0);
  return a.u[i];
});
$c_Ljava_nio_HeapCharBuffer.prototype.put__C__Ljava_nio_CharBuffer = (function(c) {
  if (this.Ljava_nio_HeapCharBuffer__f__readOnly) {
    throw new $c_Ljava_nio_ReadOnlyBufferException();
  }
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferOverflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  var a = this.Ljava_nio_CharBuffer__f__array;
  var i = ((this.Ljava_nio_CharBuffer__f__arrayOffset + p) | 0);
  a.u[i] = c;
  return this;
});
$c_Ljava_nio_HeapCharBuffer.prototype.get__I__C = (function(index) {
  if (((index < 0) || (index >= this.Ljava_nio_Buffer__f__limit))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var a = this.Ljava_nio_CharBuffer__f__array;
  var i = ((this.Ljava_nio_CharBuffer__f__arrayOffset + index) | 0);
  return a.u[i];
});
$c_Ljava_nio_HeapCharBuffer.prototype.get__AC__I__I__Ljava_nio_CharBuffer = (function(dst, offset, length) {
  if ((((offset < 0) || (length < 0)) || (offset > ((dst.u.length - length) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var x0 = this.Ljava_nio_CharBuffer__f__array;
  var x1 = ((this.Ljava_nio_CharBuffer__f__arrayOffset + p) | 0);
  x0.copyTo(x1, dst, offset, length);
  return this;
});
$c_Ljava_nio_HeapCharBuffer.prototype.load__I__C = (function(index) {
  var a = this.Ljava_nio_CharBuffer__f__array;
  var i = ((this.Ljava_nio_CharBuffer__f__arrayOffset + index) | 0);
  return a.u[i];
});
$c_Ljava_nio_HeapCharBuffer.prototype.store__I__C__V = (function(index, elem) {
  var a = this.Ljava_nio_CharBuffer__f__array;
  var i = ((this.Ljava_nio_CharBuffer__f__arrayOffset + index) | 0);
  a.u[i] = elem;
});
$c_Ljava_nio_HeapCharBuffer.prototype.store__I__AC__I__I__V = (function(startIndex, src, offset, length) {
  var x2 = this.Ljava_nio_CharBuffer__f__array;
  var x3 = ((this.Ljava_nio_CharBuffer__f__arrayOffset + startIndex) | 0);
  src.copyTo(offset, x2, x3, length);
});
$c_Ljava_nio_HeapCharBuffer.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.subSequence__I__I__Ljava_nio_CharBuffer(start, end);
});
var $d_Ljava_nio_HeapCharBuffer = new $TypeData().initClass($c_Ljava_nio_HeapCharBuffer, "java.nio.HeapCharBuffer", ({
  Ljava_nio_HeapCharBuffer: 1,
  Ljava_nio_CharBuffer: 1,
  Ljava_nio_Buffer: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  jl_Readable: 1
}));
export { $d_Ljava_nio_HeapCharBuffer as $d_Ljava_nio_HeapCharBuffer };
/** @constructor */
function $c_Ljava_nio_StringCharBuffer(_capacity, _csq, _csqOffset, _initialPosition, _initialLimit) {
  this.Ljava_nio_Buffer__f__capacity = 0;
  this.Ljava_nio_Buffer__f__limit = 0;
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = 0;
  this.Ljava_nio_Buffer__f__mark = 0;
  this.Ljava_nio_CharBuffer__f__array = null;
  this.Ljava_nio_CharBuffer__f__arrayOffset = 0;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq = null;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset = 0;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq = _csq;
  this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset = _csqOffset;
  $ct_Ljava_nio_CharBuffer__I__AC__I__(this, _capacity, null, (-1));
  $c_Ljava_nio_Buffer.prototype.position__I__Ljava_nio_Buffer.call(this, _initialPosition);
  $c_Ljava_nio_Buffer.prototype.limit__I__Ljava_nio_Buffer.call(this, _initialLimit);
}
export { $c_Ljava_nio_StringCharBuffer as $c_Ljava_nio_StringCharBuffer };
$c_Ljava_nio_StringCharBuffer.prototype = new $h_Ljava_nio_CharBuffer();
$c_Ljava_nio_StringCharBuffer.prototype.constructor = $c_Ljava_nio_StringCharBuffer;
/** @constructor */
function $h_Ljava_nio_StringCharBuffer() {
}
export { $h_Ljava_nio_StringCharBuffer as $h_Ljava_nio_StringCharBuffer };
$h_Ljava_nio_StringCharBuffer.prototype = $c_Ljava_nio_StringCharBuffer.prototype;
$c_Ljava_nio_StringCharBuffer.prototype.isReadOnly__Z = (function() {
  return true;
});
$c_Ljava_nio_StringCharBuffer.prototype.subSequence__I__I__Ljava_nio_CharBuffer = (function(start, end) {
  if ((((start < 0) || (end < start)) || (end > ((this.Ljava_nio_Buffer__f__limit - this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return new $c_Ljava_nio_StringCharBuffer(this.Ljava_nio_Buffer__f__capacity, this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset, ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + start) | 0), ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + end) | 0));
});
$c_Ljava_nio_StringCharBuffer.prototype.get__C = (function() {
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  if ((p === this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = ((1 + p) | 0);
  return $dp_charAt__I__C(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + p) | 0));
});
$c_Ljava_nio_StringCharBuffer.prototype.put__C__Ljava_nio_CharBuffer = (function(c) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$c_Ljava_nio_StringCharBuffer.prototype.get__I__C = (function(index) {
  if (((index < 0) || (index >= this.Ljava_nio_Buffer__f__limit))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return $dp_charAt__I__C(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + index) | 0));
});
$c_Ljava_nio_StringCharBuffer.prototype.get__AC__I__I__Ljava_nio_CharBuffer = (function(dst, offset, length) {
  if ((((offset < 0) || (length < 0)) || (offset > ((dst.u.length - length) | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  var p = this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position;
  var newPos = ((p + length) | 0);
  if ((newPos > this.Ljava_nio_Buffer__f__limit)) {
    throw new $c_Ljava_nio_BufferUnderflowException();
  }
  this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position = newPos;
  var selfPos = p;
  var endPos = ((selfPos + length) | 0);
  var arrayIndex = offset;
  while ((selfPos !== endPos)) {
    var i = arrayIndex;
    var index = selfPos;
    var v = $dp_charAt__I__C(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + index) | 0));
    dst.u[i] = v;
    selfPos = ((1 + selfPos) | 0);
    arrayIndex = ((1 + arrayIndex) | 0);
  }
  return this;
});
$c_Ljava_nio_StringCharBuffer.prototype.toString__T = (function() {
  var offset = this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset;
  return $dp_toString__T($dp_subSequence__I__I__jl_CharSequence(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, ((this.Ljava_nio_Buffer__f_java$nio$Buffer$$_position + offset) | 0), ((this.Ljava_nio_Buffer__f__limit + offset) | 0)));
});
$c_Ljava_nio_StringCharBuffer.prototype.load__I__C = (function(index) {
  return $dp_charAt__I__C(this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csq, ((this.Ljava_nio_StringCharBuffer__f_java$nio$StringCharBuffer$$_csqOffset + index) | 0));
});
$c_Ljava_nio_StringCharBuffer.prototype.store__I__C__V = (function(index, elem) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$c_Ljava_nio_StringCharBuffer.prototype.store__I__AC__I__I__V = (function(startIndex, src, offset, length) {
  throw new $c_Ljava_nio_ReadOnlyBufferException();
});
$c_Ljava_nio_StringCharBuffer.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.subSequence__I__I__Ljava_nio_CharBuffer(start, end);
});
var $d_Ljava_nio_StringCharBuffer = new $TypeData().initClass($c_Ljava_nio_StringCharBuffer, "java.nio.StringCharBuffer", ({
  Ljava_nio_StringCharBuffer: 1,
  Ljava_nio_CharBuffer: 1,
  Ljava_nio_Buffer: 1,
  jl_Comparable: 1,
  jl_CharSequence: 1,
  jl_Appendable: 1,
  jl_Readable: 1
}));
export { $d_Ljava_nio_StringCharBuffer as $d_Ljava_nio_StringCharBuffer };
function $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant($thiz, secondsToAdd, nanosToAdd) {
  var lo = nanosToAdd.RTLong__f_lo;
  var hi = nanosToAdd.RTLong__f_hi;
  var _nanosToAdd__lo = lo;
  var _nanosToAdd__hi = hi;
  var b__lo = _nanosToAdd__lo;
  var b__hi = _nanosToAdd__hi;
  var lo$1 = (secondsToAdd.RTLong__f_lo | b__lo);
  var hi$1 = (secondsToAdd.RTLong__f_hi | b__hi);
  if (((lo$1 === 0) && (hi$1 === 0))) {
    return $thiz;
  }
  var t = $thiz.Ljava_time_Instant__f_seconds;
  var lo$2 = t.RTLong__f_lo;
  var hi$2 = t.RTLong__f_hi;
  var this$3 = $m_jl_Math$();
  var blo = secondsToAdd.RTLong__f_lo;
  var lo$3 = ((lo$2 + blo) | 0);
  var hi$3 = ((((hi$2 + secondsToAdd.RTLong__f_hi) | 0) + ((((lo$2 & blo) | ((lo$2 | blo) & (~lo$3))) >>> 31) | 0)) | 0);
  var hi$4 = (hi$3 ^ hi$2);
  var hi$5 = (hi$3 ^ secondsToAdd.RTLong__f_hi);
  var hi$6 = (hi$4 & hi$5);
  if ((hi$6 < 0)) {
    this$3.java$lang$Math$$longOverflow__E();
  }
  var epochSec__lo = lo$3;
  var epochSec__hi = hi$3;
  var a$1__lo = epochSec__lo;
  var a$1__hi = epochSec__hi;
  var a__lo = _nanosToAdd__lo;
  var a__hi = _nanosToAdd__hi;
  var this$9 = $m_RTLong$();
  var lo$7 = this$9.divideImpl__I__I__I__I__I(a__lo, a__hi, 1000000000, 0);
  var hi$7 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$10 = $m_jl_Math$();
  var alo = a$1__lo;
  var lo$8 = ((alo + lo$7) | 0);
  var hi$8 = ((((a$1__hi + hi$7) | 0) + ((((alo & lo$7) | ((alo | lo$7) & (~lo$8))) >>> 31) | 0)) | 0);
  var hi$9 = (hi$8 ^ a$1__hi);
  var hi$10 = (hi$8 ^ hi$7);
  var hi$11 = (hi$9 & hi$10);
  if ((hi$11 < 0)) {
    this$10.java$lang$Math$$longOverflow__E();
  }
  var $x_1__lo = lo$8;
  var $x_1__hi = hi$8;
  epochSec__lo = $x_1__lo;
  epochSec__hi = $x_1__hi;
  var a$2__lo = _nanosToAdd__lo;
  var a$2__hi = _nanosToAdd__hi;
  var this$16 = $m_RTLong$();
  var lo$12 = this$16.remainderImpl__I__I__I__I__I(a$2__lo, a$2__hi, 1000000000, 0);
  var hi$12 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var $x_2__lo = lo$12;
  var $x_2__hi = hi$12;
  _nanosToAdd__lo = $x_2__lo;
  _nanosToAdd__hi = $x_2__hi;
  var value = $thiz.Ljava_time_Instant__f_nanos;
  var hi$13 = (value >> 31);
  var b$1__lo = _nanosToAdd__lo;
  var b$1__hi = _nanosToAdd__hi;
  var blo$1 = b$1__lo;
  var lo$13 = ((value + blo$1) | 0);
  var hi$14 = ((((hi$13 + b$1__hi) | 0) + ((((value & blo$1) | ((value | blo$1) & (~lo$13))) >>> 31) | 0)) | 0);
  return $m_Ljava_time_Instant$().ofEpochSecond__J__J__Ljava_time_Instant(new $c_RTLong(epochSec__lo, epochSec__hi), new $c_RTLong(lo$13, hi$14));
}
export { $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant as $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant };
function $p_Ljava_time_Instant__nanosUntil__Ljava_time_Instant__J($thiz, end) {
  var t = end.Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $thiz.Ljava_time_Instant__f_seconds;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var this$1 = $m_jl_Math$();
  var lo$2 = ((lo - lo$1) | 0);
  var hi$2 = ((((hi - hi$1) | 0) + ((((~lo) & lo$1) | ((~(lo ^ lo$1)) & lo$2)) >> 31)) | 0);
  var hi$3 = (hi ^ hi$1);
  var hi$4 = (hi$2 ^ hi);
  var hi$5 = (hi$3 & hi$4);
  if ((hi$5 < 0)) {
    this$1.java$lang$Math$$longOverflow__E();
  }
  var this$7 = $m_jl_Math$();
  var b0 = (65535 & lo$2);
  var b1 = ((lo$2 >>> 16) | 0);
  var a0b0 = Math.imul(51712, b0);
  var a1b0 = Math.imul(15258, b0);
  var a0b1 = Math.imul(51712, b1);
  var lo$6 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$6 = ((((((Math.imul(1000000000, hi$2) + Math.imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  if ((!((lo$2 === 0) && (hi$2 === 0)))) {
    var this$11 = $m_RTLong$();
    var lo$7 = this$11.divideImpl__I__I__I__I__I(lo$6, hi$6, lo$2, hi$2);
    var hi$7 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var $x_1 = (!((lo$7 === 1000000000) && (hi$7 === 0)));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    this$7.java$lang$Math$$longOverflow__E();
  }
  var value = end.Ljava_time_Instant__f_nanos;
  var hi$8 = (value >> 31);
  var value$1 = $thiz.Ljava_time_Instant__f_nanos;
  var hi$9 = (value$1 >> 31);
  var lo$8 = ((value - value$1) | 0);
  var hi$10 = ((((hi$8 - hi$9) | 0) + ((((~value) & value$1) | ((~(value ^ value$1)) & lo$8)) >> 31)) | 0);
  var this$16 = $m_jl_Math$();
  var lo$9 = ((lo$6 + lo$8) | 0);
  var hi$11 = ((((hi$6 + hi$10) | 0) + ((((lo$6 & lo$8) | ((lo$6 | lo$8) & (~lo$9))) >>> 31) | 0)) | 0);
  var hi$12 = (hi$11 ^ hi$6);
  var hi$13 = (hi$11 ^ hi$10);
  var hi$14 = (hi$12 & hi$13);
  if ((hi$14 < 0)) {
    this$16.java$lang$Math$$longOverflow__E();
  }
  return new $c_RTLong(lo$9, hi$11);
}
export { $p_Ljava_time_Instant__nanosUntil__Ljava_time_Instant__J as $p_Ljava_time_Instant__nanosUntil__Ljava_time_Instant__J };
function $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J($thiz, end) {
  var t = end.Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $thiz.Ljava_time_Instant__f_seconds;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var this$1 = $m_jl_Math$();
  var lo$2 = ((lo - lo$1) | 0);
  var hi$2 = ((((hi - hi$1) | 0) + ((((~lo) & lo$1) | ((~(lo ^ lo$1)) & lo$2)) >> 31)) | 0);
  var hi$3 = (hi ^ hi$1);
  var hi$4 = (hi$2 ^ hi);
  var hi$5 = (hi$3 & hi$4);
  if ((hi$5 < 0)) {
    this$1.java$lang$Math$$longOverflow__E();
  }
  var value = end.Ljava_time_Instant__f_nanos;
  var hi$6 = (value >> 31);
  var value$1 = $thiz.Ljava_time_Instant__f_nanos;
  var hi$7 = (value$1 >> 31);
  var lo$6 = ((value - value$1) | 0);
  var hi$8 = ((((hi$6 - hi$7) | 0) + ((((~value) & value$1) | ((~(value ^ value$1)) & lo$6)) >> 31)) | 0);
  if ((((hi$2 === 0) ? (lo$2 !== 0) : (hi$2 > 0)) && (hi$8 < 0))) {
    var lo$7 = (((-1) + lo$2) | 0);
    var hi$9 = (((((-1) + hi$2) | 0) + (((lo$2 | (~lo$7)) >>> 31) | 0)) | 0);
    return new $c_RTLong(lo$7, hi$9);
  } else if (((hi$2 < 0) && ((hi$8 === 0) ? (lo$6 !== 0) : (hi$8 > 0)))) {
    var lo$8 = ((1 + lo$2) | 0);
    var hi$10 = ((hi$2 + (((lo$2 & (~lo$8)) >>> 31) | 0)) | 0);
    return new $c_RTLong(lo$8, hi$10);
  } else {
    return new $c_RTLong(lo$2, hi$2);
  }
}
export { $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J as $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J };
/** @constructor */
function $c_Ljava_time_Instant(seconds, nanos) {
  this.Ljava_time_Instant__f_seconds = $L0;
  this.Ljava_time_Instant__f_nanos = 0;
  this.Ljava_time_Instant__f_seconds = seconds;
  this.Ljava_time_Instant__f_nanos = nanos;
}
export { $c_Ljava_time_Instant as $c_Ljava_time_Instant };
$c_Ljava_time_Instant.prototype = new $h_O();
$c_Ljava_time_Instant.prototype.constructor = $c_Ljava_time_Instant;
/** @constructor */
function $h_Ljava_time_Instant() {
}
export { $h_Ljava_time_Instant as $h_Ljava_time_Instant };
$h_Ljava_time_Instant.prototype = $c_Ljava_time_Instant.prototype;
$c_Ljava_time_Instant.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? ((((field === $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) || (field === $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) || (field === $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) : ((field !== null) && field.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)));
});
$c_Ljava_time_Instant.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field);
});
$c_Ljava_time_Instant.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      return this.Ljava_time_Instant__f_nanos;
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      return ((this.Ljava_time_Instant__f_nanos / 1000) | 0);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$5 === null) ? (field === null) : (x$5 === field))) {
      return ((this.Ljava_time_Instant__f_nanos / 1000000) | 0);
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(field.getFrom__Ljava_time_temporal_TemporalAccessor__J(this), field);
  }
});
$c_Ljava_time_Instant.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      var value = this.Ljava_time_Instant__f_nanos;
      var hi = (value >> 31);
      return new $c_RTLong(value, hi);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      var value$1 = this.Ljava_time_Instant__f_nanos;
      var hi$1 = (value$1 >> 31);
      var this$3 = $m_RTLong$();
      var lo = this$3.divideImpl__I__I__I__I__I(value$1, hi$1, 1000, 0);
      var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo, hi$2);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$5 === null) ? (field === null) : (x$5 === field))) {
      var value$2 = this.Ljava_time_Instant__f_nanos;
      var hi$3 = (value$2 >> 31);
      var this$5 = $m_RTLong$();
      var lo$1 = this$5.divideImpl__I__I__I__I__I(value$2, hi$3, 1000000, 0);
      var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$1, hi$4);
    }
    var x$7 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x$7 === null) ? (field === null) : (x$7 === field))) {
      return this.Ljava_time_Instant__f_seconds;
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return field.getFrom__Ljava_time_temporal_TemporalAccessor__J(this);
  }
});
$c_Ljava_time_Instant.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_Instant = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    field.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, field);
    var x = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      var nval = Math.imul(1000000, newValue.RTLong__f_lo);
      return ((nval !== this.Ljava_time_Instant__f_nanos) ? $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds, nval) : this);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      var nval$2 = Math.imul(1000, newValue.RTLong__f_lo);
      return ((nval$2 !== this.Ljava_time_Instant__f_nanos) ? $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds, nval$2) : this);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$5 === null) ? (field === null) : (x$5 === field))) {
      var value = this.Ljava_time_Instant__f_nanos;
      var hi = (value >> 31);
      if ((!((newValue.RTLong__f_lo === value) && (newValue.RTLong__f_hi === hi)))) {
        return $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(this.Ljava_time_Instant__f_seconds, newValue.RTLong__f_lo);
      } else {
        return this;
      }
    }
    var x$7 = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x$7 === null) ? (field === null) : (x$7 === field))) {
      var b = this.Ljava_time_Instant__f_seconds;
      if ((!((newValue.RTLong__f_lo === b.RTLong__f_lo) && (newValue.RTLong__f_hi === b.RTLong__f_hi)))) {
        return $m_Ljava_time_Instant$().java$time$Instant$$$create__J__I__Ljava_time_Instant(newValue, this.Ljava_time_Instant__f_nanos);
      } else {
        return this;
      }
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  }
  return field.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue);
});
$c_Ljava_time_Instant.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if (((x === null) ? (unit === null) : (x === unit))) {
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, $L0, amountToAdd);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
    if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
      var this$1 = $m_RTLong$();
      var lo = this$1.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 1000000, 0);
      var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $x_1 = new $c_RTLong(lo, hi);
      var this$2 = $m_RTLong$();
      var lo$1 = this$2.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 1000000, 0);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var b0 = (65535 & lo$1);
      var b1 = ((lo$1 >>> 16) | 0);
      var a0b0 = Math.imul(1000, b0);
      var a0b1 = Math.imul(1000, b1);
      var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$2 = ((Math.imul(1000, hi$1) + ((c1part >>> 16) | 0)) | 0);
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, $x_1, new $c_RTLong(lo$2, hi$2));
    }
    var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
    if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
      return this.plusMillis__J__Ljava_time_Instant(amountToAdd);
    }
    var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
    if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, amountToAdd, $L0);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
    if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
      var this$4 = $m_jl_Math$();
      var blo = amountToAdd.RTLong__f_lo;
      var b0$1 = (65535 & blo);
      var b1$1 = ((blo >>> 16) | 0);
      var a0b0$1 = Math.imul(60, b0$1);
      var a0b1$1 = Math.imul(60, b1$1);
      var lo$3 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$3 = ((Math.imul(60, amountToAdd.RTLong__f_hi) + ((c1part$1 >>> 16) | 0)) | 0);
      if ((!((amountToAdd.RTLong__f_lo === 0) && (amountToAdd.RTLong__f_hi === 0)))) {
        var this$8 = $m_RTLong$();
        var lo$4 = this$8.divideImpl__I__I__I__I__I(lo$3, hi$3, amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi);
        var hi$4 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var $x_2 = (!((lo$4 === 60) && (hi$4 === 0)));
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        this$4.java$lang$Math$$longOverflow__E();
      }
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$3, hi$3), $L0);
    }
    var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
    if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
      var this$10 = $m_jl_Math$();
      var blo$1 = amountToAdd.RTLong__f_lo;
      var b0$2 = (65535 & blo$1);
      var b1$2 = ((blo$1 >>> 16) | 0);
      var a0b0$2 = Math.imul(3600, b0$2);
      var a0b1$2 = Math.imul(3600, b1$2);
      var lo$5 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$5 = ((Math.imul(3600, amountToAdd.RTLong__f_hi) + ((c1part$2 >>> 16) | 0)) | 0);
      if ((!((amountToAdd.RTLong__f_lo === 0) && (amountToAdd.RTLong__f_hi === 0)))) {
        var this$14 = $m_RTLong$();
        var lo$6 = this$14.divideImpl__I__I__I__I__I(lo$5, hi$5, amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi);
        var hi$6 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var $x_3 = (!((lo$6 === 3600) && (hi$6 === 0)));
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        this$10.java$lang$Math$$longOverflow__E();
      }
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$5, hi$5), $L0);
    }
    var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
      var this$16 = $m_jl_Math$();
      var blo$2 = amountToAdd.RTLong__f_lo;
      var b0$3 = (65535 & blo$2);
      var b1$3 = ((blo$2 >>> 16) | 0);
      var a0b0$3 = Math.imul(43200, b0$3);
      var a0b1$3 = Math.imul(43200, b1$3);
      var lo$7 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$7 = ((Math.imul(43200, amountToAdd.RTLong__f_hi) + ((c1part$3 >>> 16) | 0)) | 0);
      if ((!((amountToAdd.RTLong__f_lo === 0) && (amountToAdd.RTLong__f_hi === 0)))) {
        var this$20 = $m_RTLong$();
        var lo$8 = this$20.divideImpl__I__I__I__I__I(lo$7, hi$7, amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi);
        var hi$8 = this$20.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var $x_4 = (!((lo$8 === 43200) && (hi$8 === 0)));
      } else {
        var $x_4 = false;
      }
      if ($x_4) {
        this$16.java$lang$Math$$longOverflow__E();
      }
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$7, hi$7), $L0);
    }
    var x$15 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x$15 === null) ? (unit === null) : (x$15 === unit))) {
      var this$22 = $m_jl_Math$();
      var blo$3 = amountToAdd.RTLong__f_lo;
      var b0$4 = (65535 & blo$3);
      var b1$4 = ((blo$3 >>> 16) | 0);
      var a0b0$4 = Math.imul(20864, b0$4);
      var a0b1$4 = Math.imul(20864, b1$4);
      var lo$9 = ((a0b0$4 + (((b0$4 + a0b1$4) | 0) << 16)) | 0);
      var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
      var hi$9 = ((((((Math.imul(86400, amountToAdd.RTLong__f_hi) + b1$4) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + b0$4) | 0) >>> 16) | 0)) | 0);
      if ((!((amountToAdd.RTLong__f_lo === 0) && (amountToAdd.RTLong__f_hi === 0)))) {
        var this$26 = $m_RTLong$();
        var lo$10 = this$26.divideImpl__I__I__I__I__I(lo$9, hi$9, amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi);
        var hi$10 = this$26.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var $x_5 = (!((lo$10 === 86400) && (hi$10 === 0)));
      } else {
        var $x_5 = false;
      }
      if ($x_5) {
        this$22.java$lang$Math$$longOverflow__E();
      }
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, new $c_RTLong(lo$9, hi$9), $L0);
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  }
  return unit.addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd);
});
$c_Ljava_time_Instant.prototype.plusMillis__J__Ljava_time_Instant = (function(millisToAdd) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(millisToAdd.RTLong__f_lo, millisToAdd.RTLong__f_hi, 1000, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var $x_1 = new $c_RTLong(lo, hi);
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.remainderImpl__I__I__I__I__I(millisToAdd.RTLong__f_lo, millisToAdd.RTLong__f_hi, 1000, 0);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b0 = (65535 & lo$1);
  var b1 = ((lo$1 >>> 16) | 0);
  var a0b0 = Math.imul(16960, b0);
  var a1b0 = Math.imul(15, b0);
  var a0b1 = Math.imul(16960, b1);
  var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((((((Math.imul(1000000, hi$1) + Math.imul(15, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, $x_1, new $c_RTLong(lo$2, hi$2));
});
$c_Ljava_time_Instant.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(new $c_RTLong(1, 0), unit);
  } else {
    var blo = amountToSubtract.RTLong__f_lo;
    var lo = ((-blo) | 0);
    var hi = ((((-amountToSubtract.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(new $c_RTLong(lo, hi), unit);
  }
});
$c_Ljava_time_Instant.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit() : (((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)));
});
$c_Ljava_time_Instant.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $x_2 = temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), this.Ljava_time_Instant__f_seconds);
  var $x_1 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var value = this.Ljava_time_Instant__f_nanos;
  var hi = (value >> 31);
  return $x_2.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($x_1, new $c_RTLong(value, hi));
});
$c_Ljava_time_Instant.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_Instant$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_Instant(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if (((x === null) ? (unit === null) : (x === unit))) {
      return $p_Ljava_time_Instant__nanosUntil__Ljava_time_Instant__J(this, end);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
    if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
      var a = $p_Ljava_time_Instant__nanosUntil__Ljava_time_Instant__J(this, end);
      var this$1 = $m_RTLong$();
      var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
      var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo, hi);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
    if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
      var t = end.toEpochMilli__J();
      var lo$1 = t.RTLong__f_lo;
      var hi$1 = t.RTLong__f_hi;
      var t$1 = this.toEpochMilli__J();
      var lo$2 = t$1.RTLong__f_lo;
      var hi$2 = t$1.RTLong__f_hi;
      var this$2 = $m_jl_Math$();
      var lo$3 = ((lo$1 - lo$2) | 0);
      var hi$3 = ((((hi$1 - hi$2) | 0) + ((((~lo$1) & lo$2) | ((~(lo$1 ^ lo$2)) & lo$3)) >> 31)) | 0);
      var hi$4 = (hi$1 ^ hi$2);
      var hi$5 = (hi$3 ^ hi$1);
      var hi$6 = (hi$4 & hi$5);
      if ((hi$6 < 0)) {
        this$2.java$lang$Math$$longOverflow__E();
      }
      return new $c_RTLong(lo$3, hi$3);
    }
    var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
    if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
      return $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
    if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
      var a$1 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
      var this$8 = $m_RTLong$();
      var lo$7 = this$8.divideImpl__I__I__I__I__I(a$1.RTLong__f_lo, a$1.RTLong__f_hi, 60, 0);
      var hi$7 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$7, hi$7);
    }
    var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
    if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
      var a$2 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
      var this$9 = $m_RTLong$();
      var lo$8 = this$9.divideImpl__I__I__I__I__I(a$2.RTLong__f_lo, a$2.RTLong__f_hi, 3600, 0);
      var hi$8 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$8, hi$8);
    }
    var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
      var a$3 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
      var this$10 = $m_RTLong$();
      var lo$9 = this$10.divideImpl__I__I__I__I__I(a$3.RTLong__f_lo, a$3.RTLong__f_hi, 43200, 0);
      var hi$9 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$9, hi$9);
    }
    var x$15 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x$15 === null) ? (unit === null) : (x$15 === unit))) {
      var a$4 = $p_Ljava_time_Instant__secondsUntil__Ljava_time_Instant__J(this, end);
      var this$11 = $m_RTLong$();
      var lo$10 = this$11.divideImpl__I__I__I__I__I(a$4.RTLong__f_lo, a$4.RTLong__f_hi, 86400, 0);
      var hi$10 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$10, hi$10);
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  }
  return unit.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end);
});
$c_Ljava_time_Instant.prototype.toEpochMilli__J = (function() {
  var a = this.Ljava_time_Instant__f_seconds;
  var ahi = a.RTLong__f_hi;
  if ((ahi >= 0)) {
    var t = this.Ljava_time_Instant__f_seconds;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$2 = $m_jl_Math$();
    var b0 = (65535 & lo);
    var b1 = ((lo >>> 16) | 0);
    var a0b0 = Math.imul(1000, b0);
    var a0b1 = Math.imul(1000, b1);
    var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((Math.imul(1000, hi) + ((c1part >>> 16) | 0)) | 0);
    if ((!((lo === 0) && (hi === 0)))) {
      var this$6 = $m_RTLong$();
      var lo$2 = this$6.divideImpl__I__I__I__I__I(lo$1, hi$1, lo, hi);
      var hi$2 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $x_1 = (!((lo$2 === 1000) && (hi$2 === 0)));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      this$2.java$lang$Math$$longOverflow__E();
    }
    var value = this.Ljava_time_Instant__f_nanos;
    var hi$3 = (value >> 31);
    var this$9 = $m_RTLong$();
    var lo$3 = this$9.divideImpl__I__I__I__I__I(value, hi$3, 1000000, 0);
    var hi$4 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$10 = $m_jl_Math$();
    var lo$4 = ((lo$1 + lo$3) | 0);
    var hi$5 = ((((hi$1 + hi$4) | 0) + ((((lo$1 & lo$3) | ((lo$1 | lo$3) & (~lo$4))) >>> 31) | 0)) | 0);
    var hi$6 = (hi$5 ^ hi$1);
    var hi$7 = (hi$5 ^ hi$4);
    var hi$8 = (hi$6 & hi$7);
    if ((hi$8 < 0)) {
      this$10.java$lang$Math$$longOverflow__E();
    }
    return new $c_RTLong(lo$4, hi$5);
  } else {
    var b = this.Ljava_time_Instant__f_seconds;
    var blo = b.RTLong__f_lo;
    var lo$8 = ((1 + blo) | 0);
    var hi$9 = ((b.RTLong__f_hi + (((blo & (~lo$8)) >>> 31) | 0)) | 0);
    var this$17 = $m_jl_Math$();
    var b0$1 = (65535 & lo$8);
    var b1$1 = ((lo$8 >>> 16) | 0);
    var a0b0$1 = Math.imul(1000, b0$1);
    var a0b1$1 = Math.imul(1000, b1$1);
    var lo$9 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$10 = ((Math.imul(1000, hi$9) + ((c1part$1 >>> 16) | 0)) | 0);
    if ((!((lo$8 === 0) && (hi$9 === 0)))) {
      var this$21 = $m_RTLong$();
      var lo$10 = this$21.divideImpl__I__I__I__I__I(lo$9, hi$10, lo$8, hi$9);
      var hi$11 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $x_2 = (!((lo$10 === 1000) && (hi$11 === 0)));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      this$17.java$lang$Math$$longOverflow__E();
    }
    var value$1 = this.Ljava_time_Instant__f_nanos;
    var hi$12 = (value$1 >> 31);
    var this$24 = $m_RTLong$();
    var lo$11 = this$24.divideImpl__I__I__I__I__I(value$1, hi$12, 1000000, 0);
    var hi$13 = this$24.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$12 = ((1000 - lo$11) | 0);
    var hi$14 = ((((-hi$13) | 0) + ((lo$11 | lo$12) >> 31)) | 0);
    var this$26 = $m_jl_Math$();
    var lo$13 = ((lo$9 - lo$12) | 0);
    var hi$15 = ((((hi$10 - hi$14) | 0) + ((((~lo$9) & lo$12) | ((~(lo$9 ^ lo$12)) & lo$13)) >> 31)) | 0);
    var hi$16 = (hi$10 ^ hi$14);
    var hi$17 = (hi$15 ^ hi$10);
    var hi$18 = (hi$16 & hi$17);
    if ((hi$18 < 0)) {
      this$26.java$lang$Math$$longOverflow__E();
    }
    return new $c_RTLong(lo$13, hi$15);
  }
});
$c_Ljava_time_Instant.prototype.compare__Ljava_time_Instant__I = (function(otherInstant) {
  var t = this.Ljava_time_Instant__f_seconds;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = otherInstant.Ljava_time_Instant__f_seconds;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  return ((cmp !== 0) ? cmp : ((this.Ljava_time_Instant__f_nanos - otherInstant.Ljava_time_Instant__f_nanos) | 0));
});
$c_Ljava_time_Instant.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_Ljava_time_Instant)) {
    if ((this === other)) {
      return true;
    } else {
      var a = this.Ljava_time_Instant__f_seconds;
      var b = other.Ljava_time_Instant__f_seconds;
      if (((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi))) {
        return (this.Ljava_time_Instant__f_nanos === other.Ljava_time_Instant__f_nanos);
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_Instant.prototype.hashCode__I = (function() {
  var a$1 = this.Ljava_time_Instant__f_seconds;
  var a = this.Ljava_time_Instant__f_seconds;
  var hi = a.RTLong__f_hi;
  var lo = (a$1.RTLong__f_lo ^ hi);
  return ((lo + Math.imul(51, this.Ljava_time_Instant__f_nanos)) | 0);
});
$c_Ljava_time_Instant.prototype.toString__T = (function() {
  return $m_Ljava_time_format_DateTimeFormatter$().ISO_INSTANT__Ljava_time_format_DateTimeFormatter().format__Ljava_time_temporal_TemporalAccessor__T(this);
});
$c_Ljava_time_Instant.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return adjuster.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this);
});
$c_Ljava_time_Instant.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_Instant(field, newValue);
});
$c_Ljava_time_Instant.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(amountToAdd, unit);
});
$c_Ljava_time_Instant.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_Instant(amountToSubtract, unit);
});
$c_Ljava_time_Instant.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_Instant__I(that);
});
$c_Ljava_time_Instant.prototype.compareTo__O__I = (function(that) {
  return this.compare__Ljava_time_Instant__I(that);
});
function $isArrayOf_Ljava_time_Instant(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_Instant)));
}
export { $isArrayOf_Ljava_time_Instant as $isArrayOf_Ljava_time_Instant };
var $d_Ljava_time_Instant = new $TypeData().initClass($c_Ljava_time_Instant, "java.time.Instant", ({
  Ljava_time_Instant: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_Instant as $d_Ljava_time_Instant };
function $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J($thiz, field) {
  var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  if (((x === null) ? (field === null) : (x === field))) {
    var value = $thiz.Ljava_time_LocalTime__f_nano;
    var hi = (value >> 31);
    return new $c_RTLong(value, hi);
  }
  var x$3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$3 === null) ? (field === null) : (x$3 === field))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$5 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
  if (((x$5 === null) ? (field === null) : (x$5 === field))) {
    var value$1 = $thiz.Ljava_time_LocalTime__f_nano;
    var hi$1 = (value$1 >> 31);
    var this$3 = $m_RTLong$();
    var lo = this$3.divideImpl__I__I__I__I__I(value$1, hi$1, 1000, 0);
    var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo, hi$2);
  }
  var x$7 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$7 === null) ? (field === null) : (x$7 === field))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$9 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
  if (((x$9 === null) ? (field === null) : (x$9 === field))) {
    var value$2 = $thiz.Ljava_time_LocalTime__f_nano;
    var hi$3 = (value$2 >> 31);
    var this$5 = $m_RTLong$();
    var lo$1 = this$5.divideImpl__I__I__I__I__I(value$2, hi$3, 1000000, 0);
    var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$1, hi$4);
  }
  var x$11 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$11 === null) ? (field === null) : (x$11 === field))) {
    var a = $thiz.toNanoOfDay__J();
    var this$6 = $m_RTLong$();
    var lo$2 = this$6.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000000, 0);
    var hi$5 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$2, hi$5);
  }
  var x$13 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
  if (((x$13 === null) ? (field === null) : (x$13 === field))) {
    var value$3 = $thiz.Ljava_time_LocalTime__f_second;
    var hi$6 = (value$3 >> 31);
    return new $c_RTLong(value$3, hi$6);
  }
  var x$15 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$15 === null) ? (field === null) : (x$15 === field))) {
    var value$4 = $thiz.toSecondOfDay__I();
    var hi$7 = (value$4 >> 31);
    return new $c_RTLong(value$4, hi$7);
  }
  var x$17 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
  if (((x$17 === null) ? (field === null) : (x$17 === field))) {
    var value$5 = $thiz.Ljava_time_LocalTime__f_minute;
    var hi$8 = (value$5 >> 31);
    return new $c_RTLong(value$5, hi$8);
  }
  var x$19 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$19 === null) ? (field === null) : (x$19 === field))) {
    var value$6 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$9 = (value$6 >> 31);
    var b0 = (65535 & value$6);
    var b1 = ((value$6 >>> 16) | 0);
    var a0b0 = Math.imul(60, b0);
    var a0b1 = Math.imul(60, b1);
    var lo$3 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$10 = ((Math.imul(60, hi$9) + ((c1part >>> 16) | 0)) | 0);
    var value$7 = $thiz.Ljava_time_LocalTime__f_minute;
    var hi$11 = (value$7 >> 31);
    var lo$4 = ((lo$3 + value$7) | 0);
    var hi$12 = ((((hi$10 + hi$11) | 0) + ((((lo$3 & value$7) | ((lo$3 | value$7) & (~lo$4))) >>> 31) | 0)) | 0);
    return new $c_RTLong(lo$4, hi$12);
  }
  var x$21 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
  if (((x$21 === null) ? (field === null) : (x$21 === field))) {
    var value$8 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$13 = (value$8 >> 31);
    var this$15 = $m_RTLong$();
    var lo$5 = this$15.remainderImpl__I__I__I__I__I(value$8, hi$13, 12, 0);
    var hi$14 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$5, hi$14);
  }
  var x$23 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
  if (((x$23 === null) ? (field === null) : (x$23 === field))) {
    var value$9 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$15 = (value$9 >> 31);
    var this$17 = $m_RTLong$();
    var lo$6 = this$17.remainderImpl__I__I__I__I__I(value$9, hi$15, 12, 0);
    var hi$16 = this$17.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$18 = $m_RTLong$();
    var lo$7 = this$18.remainderImpl__I__I__I__I__I(lo$6, hi$16, 12, 0);
    var hi$17 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((lo$7 === 0) && (hi$17 === 0))) {
      return new $c_RTLong(12, 0);
    } else {
      return new $c_RTLong(lo$6, hi$16);
    }
  }
  var x$25 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$25 === null) ? (field === null) : (x$25 === field))) {
    var value$10 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$18 = (value$10 >> 31);
    return new $c_RTLong(value$10, hi$18);
  }
  var x$27 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$27 === null) ? (field === null) : (x$27 === field))) {
    if (($thiz.Ljava_time_LocalTime__f_hour === 0)) {
      return new $c_RTLong(24, 0);
    } else {
      var value$11 = $thiz.Ljava_time_LocalTime__f_hour;
      var hi$19 = (value$11 >> 31);
      return new $c_RTLong(value$11, hi$19);
    }
  }
  var x$29 = $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$29 === null) ? (field === null) : (x$29 === field))) {
    var value$12 = $thiz.Ljava_time_LocalTime__f_hour;
    var hi$20 = (value$12 >> 31);
    var this$23 = $m_RTLong$();
    var lo$8 = this$23.divideImpl__I__I__I__I__I(value$12, hi$20, 12, 0);
    var hi$21 = this$23.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$8, hi$21);
  }
  throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
}
export { $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J as $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J };
/** @constructor */
function $c_Ljava_time_LocalTime(_hour, _minute, _second, nano) {
  this.Ljava_time_LocalTime__f_nano = 0;
  this.Ljava_time_LocalTime__f_hour = 0;
  this.Ljava_time_LocalTime__f_minute = 0;
  this.Ljava_time_LocalTime__f_second = 0;
  this.Ljava_time_LocalTime__f_nano = nano;
  this.Ljava_time_LocalTime__f_hour = ((_hour << 24) >> 24);
  this.Ljava_time_LocalTime__f_minute = ((_minute << 24) >> 24);
  this.Ljava_time_LocalTime__f_second = ((_second << 24) >> 24);
}
export { $c_Ljava_time_LocalTime as $c_Ljava_time_LocalTime };
$c_Ljava_time_LocalTime.prototype = new $h_O();
$c_Ljava_time_LocalTime.prototype.constructor = $c_Ljava_time_LocalTime;
/** @constructor */
function $h_Ljava_time_LocalTime() {
}
export { $h_Ljava_time_LocalTime as $h_Ljava_time_LocalTime };
$h_Ljava_time_LocalTime.prototype = $c_Ljava_time_LocalTime.prototype;
$c_Ljava_time_LocalTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? field.isTimeBased__Z() : ((field !== null) && field.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)));
});
$c_Ljava_time_LocalTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field);
});
$c_Ljava_time_LocalTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var a = $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J(this, field);
    return a.RTLong__f_lo;
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
  }
});
$c_Ljava_time_LocalTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ((field === $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField())) {
      return this.toNanoOfDay__J();
    }
    if ((field === $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField())) {
      var a = this.toNanoOfDay__J();
      var this$1 = $m_RTLong$();
      var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 1000, 0);
      var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo, hi);
    }
    return $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J(this, field);
  } else {
    return field.getFrom__Ljava_time_temporal_TemporalAccessor__J(this);
  }
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalTime = (function(adjuster) {
  return ((adjuster instanceof $c_Ljava_time_LocalTime) ? adjuster : adjuster.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this));
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    field.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, field);
    var x = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      return this.withNano__I__Ljava_time_LocalTime(newValue.RTLong__f_lo);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      return $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(newValue);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$5 === null) ? (field === null) : (x$5 === field))) {
      return this.withNano__I__Ljava_time_LocalTime(Math.imul(1000, newValue.RTLong__f_lo));
    }
    var x$7 = $s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$7 === null) ? (field === null) : (x$7 === field))) {
      var $x_1 = $m_Ljava_time_LocalTime$();
      var blo = newValue.RTLong__f_lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(1000, b0);
      var a0b1 = Math.imul(1000, b1);
      var lo = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi = ((Math.imul(1000, newValue.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
      return $x_1.ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo, hi));
    }
    var x$9 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$9 === null) ? (field === null) : (x$9 === field))) {
      return this.withNano__I__Ljava_time_LocalTime(Math.imul(1000000, newValue.RTLong__f_lo));
    }
    var x$11 = $s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$11 === null) ? (field === null) : (x$11 === field))) {
      var $x_2 = $m_Ljava_time_LocalTime$();
      var blo$1 = newValue.RTLong__f_lo;
      var b0$1 = (65535 & blo$1);
      var b1$1 = ((blo$1 >>> 16) | 0);
      var a0b0$1 = Math.imul(16960, b0$1);
      var a1b0 = Math.imul(15, b0$1);
      var a0b1$1 = Math.imul(16960, b1$1);
      var lo$1 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$1 = ((((((Math.imul(1000000, newValue.RTLong__f_hi) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $x_2.ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo$1, hi$1));
    }
    var x$13 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    if (((x$13 === null) ? (field === null) : (x$13 === field))) {
      return this.withSecond__I__Ljava_time_LocalTime(newValue.RTLong__f_lo);
    }
    var x$15 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$15 === null) ? (field === null) : (x$15 === field))) {
      var value = this.toSecondOfDay__I();
      var hi$2 = (value >> 31);
      var alo = newValue.RTLong__f_lo;
      var lo$2 = ((alo - value) | 0);
      var hi$3 = ((((newValue.RTLong__f_hi - hi$2) | 0) + ((((~alo) & value) | ((~(alo ^ value)) & lo$2)) >> 31)) | 0);
      return this.plusSeconds__J__Ljava_time_LocalTime(new $c_RTLong(lo$2, hi$3));
    }
    var x$17 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    if (((x$17 === null) ? (field === null) : (x$17 === field))) {
      return this.withMinute__I__Ljava_time_LocalTime(newValue.RTLong__f_lo);
    }
    var x$19 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$19 === null) ? (field === null) : (x$19 === field))) {
      var value$1 = ((Math.imul(60, this.Ljava_time_LocalTime__f_hour) + this.Ljava_time_LocalTime__f_minute) | 0);
      var hi$4 = (value$1 >> 31);
      var alo$1 = newValue.RTLong__f_lo;
      var lo$3 = ((alo$1 - value$1) | 0);
      var hi$5 = ((((newValue.RTLong__f_hi - hi$4) | 0) + ((((~alo$1) & value$1) | ((~(alo$1 ^ value$1)) & lo$3)) >> 31)) | 0);
      return this.plusMinutes__J__Ljava_time_LocalTime(new $c_RTLong(lo$3, hi$5));
    }
    var x$21 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
    if (((x$21 === null) ? (field === null) : (x$21 === field))) {
      var value$2 = ((this.Ljava_time_LocalTime__f_hour % 12) | 0);
      var hi$6 = (value$2 >> 31);
      var alo$2 = newValue.RTLong__f_lo;
      var lo$4 = ((alo$2 - value$2) | 0);
      var hi$7 = ((((newValue.RTLong__f_hi - hi$6) | 0) + ((((~alo$2) & value$2) | ((~(alo$2 ^ value$2)) & lo$4)) >> 31)) | 0);
      return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$4, hi$7));
    }
    var x$23 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
    if (((x$23 === null) ? (field === null) : (x$23 === field))) {
      var a = (((newValue.RTLong__f_lo === 12) && (newValue.RTLong__f_hi === 0)) ? $L0 : newValue);
      var value$3 = ((this.Ljava_time_LocalTime__f_hour % 12) | 0);
      var hi$8 = (value$3 >> 31);
      var alo$3 = a.RTLong__f_lo;
      var lo$5 = ((alo$3 - value$3) | 0);
      var hi$9 = ((((a.RTLong__f_hi - hi$8) | 0) + ((((~alo$3) & value$3) | ((~(alo$3 ^ value$3)) & lo$5)) >> 31)) | 0);
      return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$5, hi$9));
    }
    var x$25 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$25 === null) ? (field === null) : (x$25 === field))) {
      return this.withHour__I__Ljava_time_LocalTime(newValue.RTLong__f_lo);
    }
    var x$27 = $s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$27 === null) ? (field === null) : (x$27 === field))) {
      var a$1 = (((newValue.RTLong__f_lo === 24) && (newValue.RTLong__f_hi === 0)) ? $L0 : newValue);
      return this.withHour__I__Ljava_time_LocalTime(a$1.RTLong__f_lo);
    }
    var x$29 = $s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$29 === null) ? (field === null) : (x$29 === field))) {
      var value$4 = ((this.Ljava_time_LocalTime__f_hour / 12) | 0);
      var hi$10 = (value$4 >> 31);
      var alo$4 = newValue.RTLong__f_lo;
      var lo$6 = ((alo$4 - value$4) | 0);
      var hi$11 = ((((newValue.RTLong__f_hi - hi$10) | 0) + ((((~alo$4) & value$4) | ((~(alo$4 ^ value$4)) & lo$6)) >> 31)) | 0);
      var b0$2 = (65535 & lo$6);
      var b1$2 = ((lo$6 >>> 16) | 0);
      var a0b0$2 = Math.imul(12, b0$2);
      var a0b1$2 = Math.imul(12, b1$2);
      var lo$7 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$12 = ((Math.imul(12, hi$11) + ((c1part$2 >>> 16) | 0)) | 0);
      return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$7, hi$12));
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return field.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue);
  }
});
$c_Ljava_time_LocalTime.prototype.withHour__I__Ljava_time_LocalTime = (function(hour) {
  if ((this.Ljava_time_LocalTime__f_hour === hour)) {
    return this;
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var hi = (hour >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(hour, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(hour, this.Ljava_time_LocalTime__f_minute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano);
  }
});
$c_Ljava_time_LocalTime.prototype.withMinute__I__Ljava_time_LocalTime = (function(minute) {
  if ((this.Ljava_time_LocalTime__f_minute === minute)) {
    return this;
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var hi = (minute >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(minute, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(this.Ljava_time_LocalTime__f_hour, minute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano);
  }
});
$c_Ljava_time_LocalTime.prototype.withSecond__I__Ljava_time_LocalTime = (function(second) {
  if ((this.Ljava_time_LocalTime__f_second === second)) {
    return this;
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    var hi = (second >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(second, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(this.Ljava_time_LocalTime__f_hour, this.Ljava_time_LocalTime__f_minute, second, this.Ljava_time_LocalTime__f_nano);
  }
});
$c_Ljava_time_LocalTime.prototype.withNano__I__Ljava_time_LocalTime = (function(nanoOfSecond) {
  if ((this.Ljava_time_LocalTime__f_nano === nanoOfSecond)) {
    return this;
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var hi = (nanoOfSecond >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(nanoOfSecond, hi), this$2);
    return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(this.Ljava_time_LocalTime__f_hour, this.Ljava_time_LocalTime__f_minute, this.Ljava_time_LocalTime__f_second, nanoOfSecond);
  }
});
$c_Ljava_time_LocalTime.prototype.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime = (function(unit) {
  if ((unit === $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit())) {
    return this;
  }
  var unitDur = unit.getDuration__Ljava_time_Duration();
  var a = unitDur.Ljava_time_Duration__f_seconds;
  var ahi = a.RTLong__f_hi;
  if (((ahi === 0) ? ((a.RTLong__f_lo >>> 0) > 86400) : (ahi > 0))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Unit is too large to be used for truncation");
  }
  var t = unitDur.toNanos__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.remainderImpl__I__I__I__I__I((-1857093632), 20116, lo, hi);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if ((!((lo$1 === 0) && (hi$1 === 0)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Unit must divide into a standard day without remainder");
  }
  var t$1 = this.toNanoOfDay__J();
  var lo$2 = t$1.RTLong__f_lo;
  var hi$2 = t$1.RTLong__f_hi;
  var $x_1 = $m_Ljava_time_LocalTime$();
  var this$4 = $m_RTLong$();
  var lo$3 = this$4.divideImpl__I__I__I__I__I(lo$2, hi$2, lo, hi);
  var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var a0 = (65535 & lo$3);
  var a1 = ((lo$3 >>> 16) | 0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$4 = ((((((((Math.imul(lo$3, hi) + Math.imul(hi$3, lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $x_1.ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(lo$4, hi$4));
});
$c_Ljava_time_LocalTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if (((x === null) ? (unit === null) : (x === unit))) {
      return this.plusNanos__J__Ljava_time_LocalTime(amountToAdd);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
    if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
      var this$1 = $m_RTLong$();
      var lo = this$1.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 500654080, 20);
      var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(1000, b0);
      var a0b1 = Math.imul(1000, b1);
      var lo$1 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((Math.imul(1000, hi) + ((c1part >>> 16) | 0)) | 0);
      return this.plusNanos__J__Ljava_time_LocalTime(new $c_RTLong(lo$1, hi$1));
    }
    var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
    if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
      var this$3 = $m_RTLong$();
      var lo$2 = this$3.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 86400000, 0);
      var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var b0$1 = (65535 & lo$2);
      var b1$1 = ((lo$2 >>> 16) | 0);
      var a0b0$1 = Math.imul(16960, b0$1);
      var a1b0 = Math.imul(15, b0$1);
      var a0b1$1 = Math.imul(16960, b1$1);
      var lo$3 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$3 = ((((((Math.imul(1000000, hi$2) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
      return this.plusNanos__J__Ljava_time_LocalTime(new $c_RTLong(lo$3, hi$3));
    }
    var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
    if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
      return this.plusSeconds__J__Ljava_time_LocalTime(amountToAdd);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
    if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
      return this.plusMinutes__J__Ljava_time_LocalTime(amountToAdd);
    }
    var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
    if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
      return this.plusHours__J__Ljava_time_LocalTime(amountToAdd);
    }
    var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
      var this$5 = $m_RTLong$();
      var lo$4 = this$5.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 2, 0);
      var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var b0$2 = (65535 & lo$4);
      var b1$2 = ((lo$4 >>> 16) | 0);
      var a0b0$2 = Math.imul(12, b0$2);
      var a0b1$2 = Math.imul(12, b1$2);
      var lo$5 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$5 = ((Math.imul(12, hi$4) + ((c1part$2 >>> 16) | 0)) | 0);
      return this.plusHours__J__Ljava_time_LocalTime(new $c_RTLong(lo$5, hi$5));
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  } else {
    return unit.addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd);
  }
});
$c_Ljava_time_LocalTime.prototype.plusHours__J__Ljava_time_LocalTime = (function(hoursToAdd) {
  if (((hoursToAdd.RTLong__f_lo === 0) && (hoursToAdd.RTLong__f_hi === 0))) {
    return this;
  }
  var this$2 = $m_RTLong$();
  var lo = this$2.remainderImpl__I__I__I__I__I(hoursToAdd.RTLong__f_lo, hoursToAdd.RTLong__f_hi, 24, 0);
  var newHour = ((((24 + ((lo + this.Ljava_time_LocalTime__f_hour) | 0)) | 0) % 24) | 0);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(newHour, this.Ljava_time_LocalTime__f_minute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano);
});
$c_Ljava_time_LocalTime.prototype.plusMinutes__J__Ljava_time_LocalTime = (function(minutesToAdd) {
  if (((minutesToAdd.RTLong__f_lo === 0) && (minutesToAdd.RTLong__f_hi === 0))) {
    return this;
  }
  var mofd = ((Math.imul(60, this.Ljava_time_LocalTime__f_hour) + this.Ljava_time_LocalTime__f_minute) | 0);
  var this$2 = $m_RTLong$();
  var lo = this$2.remainderImpl__I__I__I__I__I(minutesToAdd.RTLong__f_lo, minutesToAdd.RTLong__f_hi, 1440, 0);
  var newMofd = ((((1440 + ((lo + mofd) | 0)) | 0) % 1440) | 0);
  if ((mofd === newMofd)) {
    return this;
  }
  var newHour = ((newMofd / 60) | 0);
  var newMinute = ((newMofd % 60) | 0);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(newHour, newMinute, this.Ljava_time_LocalTime__f_second, this.Ljava_time_LocalTime__f_nano);
});
$c_Ljava_time_LocalTime.prototype.plusSeconds__J__Ljava_time_LocalTime = (function(secondstoAdd) {
  if (((secondstoAdd.RTLong__f_lo === 0) && (secondstoAdd.RTLong__f_hi === 0))) {
    return this;
  }
  var sofd = ((((Math.imul(3600, this.Ljava_time_LocalTime__f_hour) + Math.imul(60, this.Ljava_time_LocalTime__f_minute)) | 0) + this.Ljava_time_LocalTime__f_second) | 0);
  var this$2 = $m_RTLong$();
  var lo = this$2.remainderImpl__I__I__I__I__I(secondstoAdd.RTLong__f_lo, secondstoAdd.RTLong__f_hi, 86400, 0);
  var newSofd = ((((86400 + ((lo + sofd) | 0)) | 0) % 86400) | 0);
  if ((sofd === newSofd)) {
    return this;
  }
  var newHour = ((newSofd / 3600) | 0);
  var newMinute = ((((newSofd / 60) | 0) % 60) | 0);
  var newSecond = ((newSofd % 60) | 0);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(newHour, newMinute, newSecond, this.Ljava_time_LocalTime__f_nano);
});
$c_Ljava_time_LocalTime.prototype.plusNanos__J__Ljava_time_LocalTime = (function(nanosToAdd) {
  if (((nanosToAdd.RTLong__f_lo === 0) && (nanosToAdd.RTLong__f_hi === 0))) {
    return this;
  }
  var t = this.toNanoOfDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var this$2 = $m_RTLong$();
  var lo$1 = this$2.remainderImpl__I__I__I__I__I(nanosToAdd.RTLong__f_lo, nanosToAdd.RTLong__f_hi, (-1857093632), 20116);
  var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$2 = ((lo$1 + lo) | 0);
  var hi$2 = ((((hi$1 + hi) | 0) + ((((lo$1 & lo) | ((lo$1 | lo) & (~lo$2))) >>> 31) | 0)) | 0);
  var lo$3 = (((-1857093632) + lo$2) | 0);
  var hi$3 = ((((20116 + hi$2) | 0) + (((lo$2 | (~lo$3)) >>> 31) | 0)) | 0);
  var this$5 = $m_RTLong$();
  var lo$4 = this$5.remainderImpl__I__I__I__I__I(lo$3, hi$3, (-1857093632), 20116);
  var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((lo === lo$4) && (hi === hi$4))) {
    return this;
  }
  var this$7 = $m_RTLong$();
  var lo$5 = this$7.divideImpl__I__I__I__I__I(lo$4, hi$4, 817405952, 838);
  var this$9 = $m_RTLong$();
  var lo$6 = this$9.divideImpl__I__I__I__I__I(lo$4, hi$4, (-129542144), 13);
  var hi$6 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$10 = $m_RTLong$();
  var lo$7 = this$10.remainderImpl__I__I__I__I__I(lo$6, hi$6, 60, 0);
  var this$12 = $m_RTLong$();
  var lo$8 = this$12.divideImpl__I__I__I__I__I(lo$4, hi$4, 1000000000, 0);
  var hi$8 = this$12.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$13 = $m_RTLong$();
  var lo$9 = this$13.remainderImpl__I__I__I__I__I(lo$8, hi$8, 60, 0);
  var this$15 = $m_RTLong$();
  var lo$10 = this$15.remainderImpl__I__I__I__I__I(lo$4, hi$4, 1000000000, 0);
  return $m_Ljava_time_LocalTime$().java$time$LocalTime$$$create__I__I__I__I__Ljava_time_LocalTime(lo$5, lo$7, lo$9, lo$10);
});
$c_Ljava_time_LocalTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(new $c_RTLong(1, 0), unit);
  } else {
    var blo = amountToSubtract.RTLong__f_lo;
    var lo = ((-blo) | 0);
    var hi = ((((-amountToSubtract.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(new $c_RTLong(lo, hi), unit);
  }
});
$c_Ljava_time_LocalTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x === query)) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  }
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === query)) {
    return this;
  }
  matchAlts1: {
    matchAlts2: {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === query)) {
        break matchAlts2;
      }
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
      if ((x$7 === query)) {
        break matchAlts2;
      }
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$9 === query)) {
        break matchAlts2;
      }
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$11 === query)) {
        break matchAlts2;
      }
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
      if ((x$13 === query)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this);
});
$c_Ljava_time_LocalTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField(), this.toNanoOfDay__J());
});
$c_Ljava_time_LocalTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_LocalTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var a = end.toNanoOfDay__J();
    var b = this.toNanoOfDay__J();
    var alo = a.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var lo = ((alo - blo) | 0);
    var hi = ((((a.RTLong__f_hi - b.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
    var x = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if (((x === null) ? (unit === null) : (x === unit))) {
      return new $c_RTLong(lo, hi);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
    if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
      var this$2 = $m_RTLong$();
      var lo$1 = this$2.divideImpl__I__I__I__I__I(lo, hi, 1000, 0);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$1, hi$1);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
    if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
      var this$3 = $m_RTLong$();
      var lo$2 = this$3.divideImpl__I__I__I__I__I(lo, hi, 1000000, 0);
      var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$2, hi$2);
    }
    var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
    if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
      var this$4 = $m_RTLong$();
      var lo$3 = this$4.divideImpl__I__I__I__I__I(lo, hi, 1000000000, 0);
      var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$3, hi$3);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
    if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
      var this$5 = $m_RTLong$();
      var lo$4 = this$5.divideImpl__I__I__I__I__I(lo, hi, (-129542144), 13);
      var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$4, hi$4);
    }
    var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
    if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
      var this$6 = $m_RTLong$();
      var lo$5 = this$6.divideImpl__I__I__I__I__I(lo, hi, 817405952, 838);
      var hi$5 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$5, hi$5);
    }
    var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
      var this$7 = $m_RTLong$();
      var lo$6 = this$7.divideImpl__I__I__I__I__I(lo, hi, 1218936832, 10058);
      var hi$6 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$6, hi$6);
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  } else {
    return unit.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end);
  }
});
$c_Ljava_time_LocalTime.prototype.toSecondOfDay__I = (function() {
  var total = Math.imul(3600, this.Ljava_time_LocalTime__f_hour);
  total = ((total + Math.imul(60, this.Ljava_time_LocalTime__f_minute)) | 0);
  total = ((total + this.Ljava_time_LocalTime__f_second) | 0);
  return total;
});
$c_Ljava_time_LocalTime.prototype.toNanoOfDay__J = (function() {
  var value = this.Ljava_time_LocalTime__f_hour;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(40960, b0);
  var a1b0 = Math.imul(12472, b0);
  var a0b1 = Math.imul(40960, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(817405952, hi) + Math.imul(838, value)) | 0) + Math.imul(12472, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var total__lo = lo;
  var total__hi = hi$1;
  var a__lo = total__lo;
  var a__hi = total__hi;
  var value$1 = this.Ljava_time_LocalTime__f_minute;
  var hi$2 = (value$1 >> 31);
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(22528, b0$1);
  var a1b0$1 = Math.imul(63559, b0$1);
  var a0b1$1 = Math.imul(22528, b1$1);
  var lo$1 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((((((((Math.imul((-129542144), hi$2) + Math.imul(13, value$1)) | 0) + Math.imul(63559, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var alo = a__lo;
  var lo$2 = ((alo + lo$1) | 0);
  var hi$4 = ((((a__hi + hi$3) | 0) + ((((alo & lo$1) | ((alo | lo$1) & (~lo$2))) >>> 31) | 0)) | 0);
  var $x_1__lo = lo$2;
  var $x_1__hi = hi$4;
  total__lo = $x_1__lo;
  total__hi = $x_1__hi;
  var a$1__lo = total__lo;
  var a$1__hi = total__hi;
  var value$2 = this.Ljava_time_LocalTime__f_second;
  var hi$5 = (value$2 >> 31);
  var b0$2 = (65535 & value$2);
  var b1$2 = ((value$2 >>> 16) | 0);
  var a0b0$2 = Math.imul(51712, b0$2);
  var a1b0$2 = Math.imul(15258, b0$2);
  var a0b1$2 = Math.imul(51712, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$6 = ((((((Math.imul(1000000000, hi$5) + Math.imul(15258, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var alo$1 = a$1__lo;
  var lo$4 = ((alo$1 + lo$3) | 0);
  var hi$7 = ((((a$1__hi + hi$6) | 0) + ((((alo$1 & lo$3) | ((alo$1 | lo$3) & (~lo$4))) >>> 31) | 0)) | 0);
  var $x_2__lo = lo$4;
  var $x_2__hi = hi$7;
  total__lo = $x_2__lo;
  total__hi = $x_2__hi;
  var a$2__lo = total__lo;
  var a$2__hi = total__hi;
  var value$3 = this.Ljava_time_LocalTime__f_nano;
  var hi$8 = (value$3 >> 31);
  var alo$2 = a$2__lo;
  var lo$5 = ((alo$2 + value$3) | 0);
  var hi$9 = ((((a$2__hi + hi$8) | 0) + ((((alo$2 & value$3) | ((alo$2 | value$3) & (~lo$5))) >>> 31) | 0)) | 0);
  var $x_3__lo = lo$5;
  var $x_3__hi = hi$9;
  total__lo = $x_3__lo;
  total__hi = $x_3__hi;
  return new $c_RTLong(total__lo, total__hi);
});
$c_Ljava_time_LocalTime.prototype.compare__Ljava_time_LocalTime__I = (function(other) {
  var x = this.Ljava_time_LocalTime__f_hour;
  var y = other.Ljava_time_LocalTime__f_hour;
  var cmp = ((x === y) ? 0 : ((x < y) ? (-1) : 1));
  if ((cmp === 0)) {
    var x$1 = this.Ljava_time_LocalTime__f_minute;
    var y$1 = other.Ljava_time_LocalTime__f_minute;
    cmp = ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
    if ((cmp === 0)) {
      var x$2 = this.Ljava_time_LocalTime__f_second;
      var y$2 = other.Ljava_time_LocalTime__f_second;
      cmp = ((x$2 === y$2) ? 0 : ((x$2 < y$2) ? (-1) : 1));
      if ((cmp === 0)) {
        var x$3 = this.Ljava_time_LocalTime__f_nano;
        var y$3 = other.Ljava_time_LocalTime__f_nano;
        cmp = ((x$3 === y$3) ? 0 : ((x$3 < y$3) ? (-1) : 1));
      }
    }
  }
  return cmp;
});
$c_Ljava_time_LocalTime.prototype.isAfter__Ljava_time_LocalTime__Z = (function(other) {
  return (this.compare__Ljava_time_LocalTime__I(other) > 0);
});
$c_Ljava_time_LocalTime.prototype.isBefore__Ljava_time_LocalTime__Z = (function(other) {
  return (this.compare__Ljava_time_LocalTime__I(other) < 0);
});
$c_Ljava_time_LocalTime.prototype.equals__O__Z = (function(obj) {
  return ((obj instanceof $c_Ljava_time_LocalTime) && ((this === obj) || ((((this.Ljava_time_LocalTime__f_hour === obj.Ljava_time_LocalTime__f_hour) && (this.Ljava_time_LocalTime__f_minute === obj.Ljava_time_LocalTime__f_minute)) && (this.Ljava_time_LocalTime__f_second === obj.Ljava_time_LocalTime__f_second)) && (this.Ljava_time_LocalTime__f_nano === obj.Ljava_time_LocalTime__f_nano))));
});
$c_Ljava_time_LocalTime.prototype.hashCode__I = (function() {
  var t = this.toNanoOfDay__J();
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var lo$1 = (lo ^ hi);
  return lo$1;
});
$c_Ljava_time_LocalTime.prototype.toString__T = (function() {
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 18);
  var hourValue = this.Ljava_time_LocalTime__f_hour;
  var minuteValue = this.Ljava_time_LocalTime__f_minute;
  var secondValue = this.Ljava_time_LocalTime__f_second;
  var nanoValue = this.Ljava_time_LocalTime__f_nano;
  buf.append__T__scm_StringBuilder(((hourValue < 10) ? "0" : "")).append__I__scm_StringBuilder(hourValue).append__T__scm_StringBuilder(((minuteValue < 10) ? ":0" : ":")).append__I__scm_StringBuilder(minuteValue);
  if (((secondValue > 0) || (nanoValue > 0))) {
    buf.append__T__scm_StringBuilder(((secondValue < 10) ? ":0" : ":")).append__I__scm_StringBuilder(secondValue);
    if ((nanoValue > 0)) {
      buf.append__C__scm_StringBuilder(46);
      if ((((nanoValue % 1000000) | 0) === 0)) {
        var i = ((1000 + ((nanoValue / 1000000) | 0)) | 0);
        var this$2 = ("" + i);
        buf.append__T__scm_StringBuilder(this$2.substring(1));
      } else if ((((nanoValue % 1000) | 0) === 0)) {
        var i$1 = ((1000000 + ((nanoValue / 1000) | 0)) | 0);
        var this$4 = ("" + i$1);
        buf.append__T__scm_StringBuilder(this$4.substring(1));
      } else {
        var i$2 = ((1000000000 + nanoValue) | 0);
        var this$6 = ("" + i$2);
        buf.append__T__scm_StringBuilder(this$6.substring(1));
      }
    }
  }
  return buf.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return this.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalTime(adjuster);
});
$c_Ljava_time_LocalTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime(field, newValue);
});
$c_Ljava_time_LocalTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(amountToAdd, unit);
});
$c_Ljava_time_LocalTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(amountToSubtract, unit);
});
$c_Ljava_time_LocalTime.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_LocalTime__I(that);
});
$c_Ljava_time_LocalTime.prototype.compareTo__O__I = (function(that) {
  return this.compare__Ljava_time_LocalTime__I(that);
});
function $isArrayOf_Ljava_time_LocalTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalTime)));
}
export { $isArrayOf_Ljava_time_LocalTime as $isArrayOf_Ljava_time_LocalTime };
var $d_Ljava_time_LocalTime = new $TypeData().initClass($c_Ljava_time_LocalTime, "java.time.LocalTime", ({
  Ljava_time_LocalTime: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_LocalTime as $d_Ljava_time_LocalTime };
function $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime($thiz, dateTime, offset) {
  if (($thiz.Ljava_time_OffsetDateTime__f_dateTime === dateTime)) {
    var x = $thiz.Ljava_time_OffsetDateTime__f_offset;
    var $x_1 = ((x === null) ? (offset === null) : x.equals__O__Z(offset));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $thiz;
  } else {
    return new $c_Ljava_time_OffsetDateTime(dateTime, offset);
  }
}
export { $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime as $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime };
/** @constructor */
function $c_Ljava_time_OffsetDateTime(dateTime, offset) {
  this.Ljava_time_OffsetDateTime__f_dateTime = null;
  this.Ljava_time_OffsetDateTime__f_offset = null;
  this.Ljava_time_OffsetDateTime__f_dateTime = dateTime;
  this.Ljava_time_OffsetDateTime__f_offset = offset;
  if ((dateTime === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "dateTime");
  }
  if ((offset === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "offset");
  }
}
export { $c_Ljava_time_OffsetDateTime as $c_Ljava_time_OffsetDateTime };
$c_Ljava_time_OffsetDateTime.prototype = new $h_O();
$c_Ljava_time_OffsetDateTime.prototype.constructor = $c_Ljava_time_OffsetDateTime;
/** @constructor */
function $h_Ljava_time_OffsetDateTime() {
}
export { $h_Ljava_time_OffsetDateTime as $h_Ljava_time_OffsetDateTime };
$h_Ljava_time_OffsetDateTime.prototype = $c_Ljava_time_OffsetDateTime.prototype;
$c_Ljava_time_OffsetDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) || ((field !== null) && field.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)));
});
$c_Ljava_time_OffsetDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (((field === $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) ? field.range__Ljava_time_temporal_ValueRange() : this.Ljava_time_OffsetDateTime__f_dateTime.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)) : field.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this));
});
$c_Ljava_time_OffsetDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      var this$1 = this.Ljava_time_OffsetDateTime__f_offset;
      return this$1.Ljava_time_ZoneOffset__f_totalSeconds;
    }
    return this.Ljava_time_OffsetDateTime__f_dateTime.get__Ljava_time_temporal_TemporalField__I(field);
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
  }
});
$c_Ljava_time_OffsetDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      return this.Ljava_time_OffsetDateTime__f_dateTime.toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_OffsetDateTime__f_offset);
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if (((x$3 === null) ? (field === null) : (x$3 === field))) {
        var this$1 = this.Ljava_time_OffsetDateTime__f_offset;
        var value = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
        var hi = (value >> 31);
        return new $c_RTLong(value, hi);
      } else {
        return this.Ljava_time_OffsetDateTime__f_dateTime.getLong__Ljava_time_temporal_TemporalField__J(field);
      }
    }
  } else {
    return field.getFrom__Ljava_time_temporal_TemporalAccessor__J(this);
  }
});
$c_Ljava_time_OffsetDateTime.prototype.withOffsetSameInstant__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime = (function(offset) {
  var x$2 = this.Ljava_time_OffsetDateTime__f_offset;
  if (((offset === null) ? (x$2 === null) : offset.equals__O__Z(x$2))) {
    return this;
  }
  var $x_1 = offset.Ljava_time_ZoneOffset__f_totalSeconds;
  var this$1 = this.Ljava_time_OffsetDateTime__f_offset;
  var difference = (($x_1 - this$1.Ljava_time_ZoneOffset__f_totalSeconds) | 0);
  var this$3 = this.Ljava_time_OffsetDateTime__f_dateTime;
  var hi = (difference >> 31);
  var adjusted = $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$3, this$3.Ljava_time_LocalDateTime__f_date, $L0, $L0, new $c_RTLong(difference, hi), $L0, 1);
  return new $c_Ljava_time_OffsetDateTime(adjusted, offset);
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_OffsetDateTime = (function(adjuster) {
  matchAlts1: {
    matchAlts2: {
      if ((adjuster instanceof $c_Ljava_time_LocalDate)) {
        break matchAlts2;
      }
      if ((adjuster instanceof $c_Ljava_time_LocalTime)) {
        break matchAlts2;
      }
      if ((adjuster instanceof $c_Ljava_time_LocalDateTime)) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, this.Ljava_time_OffsetDateTime__f_dateTime.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDateTime(adjuster), this.Ljava_time_OffsetDateTime__f_offset);
  }
  if ((adjuster instanceof $c_Ljava_time_Instant)) {
    return $m_Ljava_time_OffsetDateTime$().ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime(adjuster, this.Ljava_time_OffsetDateTime__f_offset);
  }
  if ((adjuster instanceof $c_Ljava_time_ZoneOffset)) {
    return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, this.Ljava_time_OffsetDateTime__f_dateTime, adjuster);
  }
  if ((adjuster instanceof $c_Ljava_time_OffsetDateTime)) {
    return adjuster;
  }
  return adjuster.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this);
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_OffsetDateTime = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      var $x_2 = $m_Ljava_time_OffsetDateTime$();
      var $x_1 = $m_Ljava_time_Instant$();
      var this$1 = this.Ljava_time_OffsetDateTime__f_dateTime;
      var this$2 = this$1.Ljava_time_LocalDateTime__f_time;
      var value = this$2.Ljava_time_LocalTime__f_nano;
      var hi = (value >> 31);
      return $x_2.ofInstant__Ljava_time_Instant__Ljava_time_ZoneId__Ljava_time_OffsetDateTime($x_1.ofEpochSecond__J__J__Ljava_time_Instant(newValue, new $c_RTLong(value, hi)), this.Ljava_time_OffsetDateTime__f_offset);
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if (((x$3 === null) ? (field === null) : (x$3 === field))) {
        return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, this.Ljava_time_OffsetDateTime__f_dateTime, $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(field.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue, field)));
      } else {
        return $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, this.Ljava_time_OffsetDateTime__f_dateTime.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue), this.Ljava_time_OffsetDateTime__f_offset);
      }
    }
  } else {
    return field.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue);
  }
});
$c_Ljava_time_OffsetDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime = (function(amountToAdd, unit) {
  return ((unit instanceof $c_Ljava_time_temporal_ChronoUnit) ? $p_Ljava_time_OffsetDateTime__with__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this, this.Ljava_time_OffsetDateTime__f_dateTime.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit), this.Ljava_time_OffsetDateTime__f_offset) : unit.addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd));
});
$c_Ljava_time_OffsetDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(new $c_RTLong(1, 0), unit);
  } else {
    var blo = amountToSubtract.RTLong__f_lo;
    var lo = ((-blo) | 0);
    var hi = ((((-amountToSubtract.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(new $c_RTLong(lo, hi), unit);
  }
});
$c_Ljava_time_OffsetDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery();
  if ((x === query)) {
    return $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  }
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery();
  if ((x$3 === query)) {
    return $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  }
  matchAlts3: {
    matchAlts4: {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery();
      if ((x$5 === query)) {
        break matchAlts4;
      }
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery();
      if ((x$7 === query)) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return this.Ljava_time_OffsetDateTime__f_offset;
  }
  var x$9 = $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery();
  if ((x$9 === query)) {
    var this$1 = this.Ljava_time_OffsetDateTime__f_dateTime;
    return this$1.Ljava_time_LocalDateTime__f_date;
  }
  var x$11 = $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery();
  if ((x$11 === query)) {
    var this$2 = this.Ljava_time_OffsetDateTime__f_dateTime;
    return this$2.Ljava_time_LocalDateTime__f_time;
  }
  var x$13 = $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery();
  if ((x$13 === query)) {
    return null;
  }
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query);
});
$c_Ljava_time_OffsetDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $x_5 = $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  var this$1 = this.Ljava_time_OffsetDateTime__f_dateTime;
  var $x_4 = temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($x_5, this$1.Ljava_time_LocalDateTime__f_date.toEpochDay__J());
  var $x_3 = $s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  var this$2 = this.Ljava_time_OffsetDateTime__f_dateTime;
  var $x_2 = $x_4.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($x_3, this$2.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J());
  var $x_1 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  var this$3 = this.Ljava_time_OffsetDateTime__f_offset;
  var value = this$3.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  return $x_2.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($x_1, new $c_RTLong(value, hi));
});
$c_Ljava_time_OffsetDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_OffsetDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_OffsetDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    end = end.withOffsetSameInstant__Ljava_time_ZoneOffset__Ljava_time_OffsetDateTime(this.Ljava_time_OffsetDateTime__f_offset);
    return this.Ljava_time_OffsetDateTime__f_dateTime.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(end.Ljava_time_OffsetDateTime__f_dateTime, unit);
  } else {
    return unit.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end);
  }
});
$c_Ljava_time_OffsetDateTime.prototype.compare__Ljava_time_OffsetDateTime__I = (function(other) {
  var x = this.Ljava_time_OffsetDateTime__f_offset;
  var x$2 = other.Ljava_time_OffsetDateTime__f_offset;
  if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
    return this.Ljava_time_OffsetDateTime__f_dateTime.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(other.Ljava_time_OffsetDateTime__f_dateTime);
  }
  var t = this.Ljava_time_OffsetDateTime__f_dateTime.toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_OffsetDateTime__f_offset);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = other.Ljava_time_OffsetDateTime__f_dateTime.toEpochSecond__Ljava_time_ZoneOffset__J(other.Ljava_time_OffsetDateTime__f_offset);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var cmp = $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
  if ((cmp === 0)) {
    var this$2 = this.Ljava_time_OffsetDateTime__f_dateTime;
    var this$3 = this$2.Ljava_time_LocalDateTime__f_time;
    var $x_1 = this$3.Ljava_time_LocalTime__f_nano;
    var this$4 = other.Ljava_time_OffsetDateTime__f_dateTime;
    var this$5 = this$4.Ljava_time_LocalDateTime__f_time;
    cmp = (($x_1 - this$5.Ljava_time_LocalTime__f_nano) | 0);
    if ((cmp === 0)) {
      cmp = this.Ljava_time_OffsetDateTime__f_dateTime.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(other.Ljava_time_OffsetDateTime__f_dateTime);
    }
  }
  return cmp;
});
$c_Ljava_time_OffsetDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_OffsetDateTime)) {
    if ((this === obj)) {
      return true;
    } else {
      var x = this.Ljava_time_OffsetDateTime__f_dateTime;
      var x$2 = obj.Ljava_time_OffsetDateTime__f_dateTime;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_OffsetDateTime__f_offset;
        var x$4 = obj.Ljava_time_OffsetDateTime__f_offset;
        return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_OffsetDateTime.prototype.hashCode__I = (function() {
  var $x_1 = this.Ljava_time_OffsetDateTime__f_dateTime.hashCode__I();
  var this$1 = this.Ljava_time_OffsetDateTime__f_offset;
  return ($x_1 ^ this$1.Ljava_time_ZoneOffset__f_totalSeconds);
});
$c_Ljava_time_OffsetDateTime.prototype.toString__T = (function() {
  return (("" + this.Ljava_time_OffsetDateTime__f_dateTime.toString__T()) + this.Ljava_time_OffsetDateTime__f_offset.Ljava_time_ZoneOffset__f_id);
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return this.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_OffsetDateTime(adjuster);
});
$c_Ljava_time_OffsetDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_OffsetDateTime(field, newValue);
});
$c_Ljava_time_OffsetDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(amountToAdd, unit);
});
$c_Ljava_time_OffsetDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_OffsetDateTime(amountToSubtract, unit);
});
$c_Ljava_time_OffsetDateTime.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_OffsetDateTime__I(that);
});
$c_Ljava_time_OffsetDateTime.prototype.compareTo__O__I = (function(that) {
  return this.compare__Ljava_time_OffsetDateTime__I(that);
});
function $isArrayOf_Ljava_time_OffsetDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_OffsetDateTime)));
}
export { $isArrayOf_Ljava_time_OffsetDateTime as $isArrayOf_Ljava_time_OffsetDateTime };
var $d_Ljava_time_OffsetDateTime = new $TypeData().initClass($c_Ljava_time_OffsetDateTime, "java.time.OffsetDateTime", ({
  Ljava_time_OffsetDateTime: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_OffsetDateTime as $d_Ljava_time_OffsetDateTime };
/** @constructor */
function $c_Ljava_time_ZoneOffset(totalSeconds) {
  this.Ljava_time_ZoneOffset__f_totalSeconds = 0;
  this.Ljava_time_ZoneOffset__f_id = null;
  this.Ljava_time_ZoneOffset__f_totalSeconds = totalSeconds;
  $ct_Ljava_time_ZoneId__(this);
  this.Ljava_time_ZoneOffset__f_id = $m_Ljava_time_ZoneOffset$().java$time$ZoneOffset$$$buildId__I__T(totalSeconds);
}
export { $c_Ljava_time_ZoneOffset as $c_Ljava_time_ZoneOffset };
$c_Ljava_time_ZoneOffset.prototype = new $h_Ljava_time_ZoneId();
$c_Ljava_time_ZoneOffset.prototype.constructor = $c_Ljava_time_ZoneOffset;
/** @constructor */
function $h_Ljava_time_ZoneOffset() {
}
export { $h_Ljava_time_ZoneOffset as $h_Ljava_time_ZoneOffset };
$h_Ljava_time_ZoneOffset.prototype = $c_Ljava_time_ZoneOffset.prototype;
$c_Ljava_time_ZoneOffset.prototype.getId__T = (function() {
  return this.Ljava_time_ZoneOffset__f_id;
});
$c_Ljava_time_ZoneOffset.prototype.getRules__Ljava_time_zone_ZoneRules = (function() {
  return $m_Ljava_time_zone_ZoneRules$().of__Ljava_time_ZoneOffset__Ljava_time_zone_ZoneRules(this);
});
$c_Ljava_time_ZoneOffset.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()) : ((field !== null) && field.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)));
});
$c_Ljava_time_ZoneOffset.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    return field.range__Ljava_time_temporal_ValueRange();
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return field.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this);
  }
});
$c_Ljava_time_ZoneOffset.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    return this.Ljava_time_ZoneOffset__f_totalSeconds;
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(this.getLong__Ljava_time_temporal_TemporalField__J(field), field);
  }
});
$c_Ljava_time_ZoneOffset.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    var value = this.Ljava_time_ZoneOffset__f_totalSeconds;
    var hi = (value >> 31);
    return new $c_RTLong(value, hi);
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Unsupported field: " + field));
  } else {
    return field.getFrom__Ljava_time_temporal_TemporalAccessor__J(this);
  }
});
$c_Ljava_time_ZoneOffset.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return (((query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) ? this : ((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) ? null : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)));
});
$c_Ljava_time_ZoneOffset.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $x_1 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  var value = this.Ljava_time_ZoneOffset__f_totalSeconds;
  var hi = (value >> 31);
  return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($x_1, new $c_RTLong(value, hi));
});
$c_Ljava_time_ZoneOffset.prototype.compare__Ljava_time_ZoneOffset__I = (function(other) {
  return ((other.Ljava_time_ZoneOffset__f_totalSeconds - this.Ljava_time_ZoneOffset__f_totalSeconds) | 0);
});
$c_Ljava_time_ZoneOffset.prototype.equals__O__Z = (function(obj) {
  return ((obj instanceof $c_Ljava_time_ZoneOffset) && ((this === obj) || (this.Ljava_time_ZoneOffset__f_totalSeconds === obj.Ljava_time_ZoneOffset__f_totalSeconds)));
});
$c_Ljava_time_ZoneOffset.prototype.hashCode__I = (function() {
  return this.Ljava_time_ZoneOffset__f_totalSeconds;
});
$c_Ljava_time_ZoneOffset.prototype.toString__T = (function() {
  return this.Ljava_time_ZoneOffset__f_id;
});
$c_Ljava_time_ZoneOffset.prototype.compare__O__I = (function(that) {
  return this.compare__Ljava_time_ZoneOffset__I(that);
});
$c_Ljava_time_ZoneOffset.prototype.compareTo__O__I = (function(that) {
  return this.compare__Ljava_time_ZoneOffset__I(that);
});
function $isArrayOf_Ljava_time_ZoneOffset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZoneOffset)));
}
export { $isArrayOf_Ljava_time_ZoneOffset as $isArrayOf_Ljava_time_ZoneOffset };
var $d_Ljava_time_ZoneOffset = new $TypeData().initClass($c_Ljava_time_ZoneOffset, "java.time.ZoneOffset", ({
  Ljava_time_ZoneOffset: 1,
  Ljava_time_ZoneId: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1
}));
export { $d_Ljava_time_ZoneOffset as $d_Ljava_time_ZoneOffset };
function $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime($thiz, offset) {
  var x$2 = $thiz.Ljava_time_ZonedDateTime__f_offset;
  if (((!((offset === null) ? (x$2 === null) : offset.equals__O__Z(x$2))) && $thiz.Ljava_time_ZonedDateTime__f_zone.getRules__Ljava_time_zone_ZoneRules().isValidOffset__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Z($thiz.Ljava_time_ZonedDateTime__f_dateTime, offset))) {
    return new $c_Ljava_time_ZonedDateTime($thiz.Ljava_time_ZonedDateTime__f_dateTime, offset, $thiz.Ljava_time_ZonedDateTime__f_zone);
  } else {
    return $thiz;
  }
}
export { $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime as $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime };
/** @constructor */
function $c_Ljava_time_ZonedDateTime(dateTime, offset, zone) {
  this.Ljava_time_ZonedDateTime__f_dateTime = null;
  this.Ljava_time_ZonedDateTime__f_offset = null;
  this.Ljava_time_ZonedDateTime__f_zone = null;
  this.Ljava_time_ZonedDateTime__f_dateTime = dateTime;
  this.Ljava_time_ZonedDateTime__f_offset = offset;
  this.Ljava_time_ZonedDateTime__f_zone = zone;
}
export { $c_Ljava_time_ZonedDateTime as $c_Ljava_time_ZonedDateTime };
$c_Ljava_time_ZonedDateTime.prototype = new $h_O();
$c_Ljava_time_ZonedDateTime.prototype.constructor = $c_Ljava_time_ZonedDateTime;
/** @constructor */
function $h_Ljava_time_ZonedDateTime() {
}
export { $h_Ljava_time_ZonedDateTime as $h_Ljava_time_ZonedDateTime };
$h_Ljava_time_ZonedDateTime.prototype = $c_Ljava_time_ZonedDateTime.prototype;
$c_Ljava_time_ZonedDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) || ((field !== null) && field.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)));
});
$c_Ljava_time_ZonedDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (((field === $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) ? field.range__Ljava_time_temporal_ValueRange() : this.Ljava_time_ZonedDateTime__f_dateTime.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field)) : field.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this));
});
$c_Ljava_time_ZonedDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      var this$1 = this.Ljava_time_ZonedDateTime__f_offset;
      return this$1.Ljava_time_ZoneOffset__f_totalSeconds;
    }
    return this.Ljava_time_ZonedDateTime__f_dateTime.get__Ljava_time_temporal_TemporalField__I(field);
  } else {
    return $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I(this, field);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      return $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(this);
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if (((x$3 === null) ? (field === null) : (x$3 === field))) {
        var this$1 = this.Ljava_time_ZonedDateTime__f_offset;
        var value = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
        var hi = (value >> 31);
        return new $c_RTLong(value, hi);
      } else {
        return this.Ljava_time_ZonedDateTime__f_dateTime.getLong__Ljava_time_temporal_TemporalField__J(field);
      }
    }
  } else {
    return field.getFrom__Ljava_time_temporal_TemporalAccessor__J(this);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.withZoneSameInstant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime = (function(zone) {
  if ((zone === null)) {
    throw $ct_jl_NullPointerException__T__(new $c_jl_NullPointerException(), "zone");
  }
  var x = this.Ljava_time_ZonedDateTime__f_zone;
  if (((x === null) ? (zone === null) : x.equals__O__Z(zone))) {
    return this;
  } else {
    var $x_2 = $m_Ljava_time_ZonedDateTime$();
    var $x_1 = this.Ljava_time_ZonedDateTime__f_dateTime.toEpochSecond__Ljava_time_ZoneOffset__J(this.Ljava_time_ZonedDateTime__f_offset);
    var this$2 = this.Ljava_time_ZonedDateTime__f_dateTime;
    var this$3 = this$2.Ljava_time_LocalDateTime__f_time;
    return $x_2.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime($x_1, this$3.Ljava_time_LocalTime__f_nano, zone);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_ZonedDateTime = (function(adjuster) {
  if ((adjuster instanceof $c_Ljava_time_LocalDate)) {
    var $x_1 = $m_Ljava_time_LocalDateTime$();
    var this$1 = this.Ljava_time_ZonedDateTime__f_dateTime;
    var newDateTime = $x_1.of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(adjuster, this$1.Ljava_time_LocalDateTime__f_time);
    return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(newDateTime, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset);
  } else if ((adjuster instanceof $c_Ljava_time_LocalTime)) {
    var $x_2 = $m_Ljava_time_LocalDateTime$();
    var this$2 = this.Ljava_time_ZonedDateTime__f_dateTime;
    var newDateTime$1 = $x_2.of__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this$2.Ljava_time_LocalDateTime__f_date, adjuster);
    return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(newDateTime$1, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset);
  } else {
    return ((adjuster instanceof $c_Ljava_time_LocalDateTime) ? $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(adjuster, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset) : ((adjuster instanceof $c_Ljava_time_Instant) ? $m_Ljava_time_ZonedDateTime$().java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(adjuster.Ljava_time_Instant__f_seconds, adjuster.Ljava_time_Instant__f_nanos, this.Ljava_time_ZonedDateTime__f_zone) : ((adjuster instanceof $c_Ljava_time_ZoneOffset) ? $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this, adjuster) : adjuster.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this))));
  }
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_ZonedDateTime = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var x = $s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      var $x_1 = $m_Ljava_time_ZonedDateTime$();
      var this$1 = this.Ljava_time_ZonedDateTime__f_dateTime;
      var this$2 = this$1.Ljava_time_LocalDateTime__f_time;
      return $x_1.java$time$ZonedDateTime$$$create__J__I__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(newValue, this$2.Ljava_time_LocalTime__f_nano, this.Ljava_time_ZonedDateTime__f_zone);
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if (((x$3 === null) ? (field === null) : (x$3 === field))) {
        return $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this, $m_Ljava_time_ZoneOffset$().ofTotalSeconds__I__Ljava_time_ZoneOffset(field.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue, field)));
      } else {
        var newDateTime = this.Ljava_time_ZonedDateTime__f_dateTime.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue);
        return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(newDateTime, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset);
      }
    }
  } else {
    return field.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    if (unit.isDateBased__Z()) {
      var newDateTime = this.Ljava_time_ZonedDateTime__f_dateTime.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit);
      return $m_Ljava_time_ZonedDateTime$().ofLocal__Ljava_time_LocalDateTime__Ljava_time_ZoneId__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(newDateTime, this.Ljava_time_ZonedDateTime__f_zone, this.Ljava_time_ZonedDateTime__f_offset);
    } else {
      var newDateTime$1 = this.Ljava_time_ZonedDateTime__f_dateTime.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit);
      return $m_Ljava_time_ZonedDateTime$().ofInstant__Ljava_time_LocalDateTime__Ljava_time_ZoneOffset__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(newDateTime$1, this.Ljava_time_ZonedDateTime__f_offset, this.Ljava_time_ZonedDateTime__f_zone);
    }
  } else {
    return unit.addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(new $c_RTLong(1, 0), unit);
  } else {
    var blo = amountToSubtract.RTLong__f_lo;
    var lo = ((-blo) | 0);
    var hi = ((((-amountToSubtract.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(new $c_RTLong(lo, hi), unit);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  if ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery())) {
    var this$1 = this.Ljava_time_ZonedDateTime__f_dateTime;
    return this$1.Ljava_time_LocalDateTime__f_date;
  } else {
    return $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O(this, query);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_ZonedDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_ZonedDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    end = end.withZoneSameInstant__Ljava_time_ZoneId__Ljava_time_ZonedDateTime(this.Ljava_time_ZonedDateTime__f_zone);
    if (unit.isDateBased__Z()) {
      return this.Ljava_time_ZonedDateTime__f_dateTime.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(end.Ljava_time_ZonedDateTime__f_dateTime, unit);
    } else {
      var dateTime = this.Ljava_time_ZonedDateTime__f_dateTime;
      var offset = this.Ljava_time_ZonedDateTime__f_offset;
      var $x_1 = new $c_Ljava_time_OffsetDateTime(dateTime, offset);
      var this$2 = end;
      var dateTime$1 = this$2.Ljava_time_ZonedDateTime__f_dateTime;
      var offset$1 = this$2.Ljava_time_ZonedDateTime__f_offset;
      return $x_1.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(new $c_Ljava_time_OffsetDateTime(dateTime$1, offset$1), unit);
    }
  } else {
    return unit.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end);
  }
});
$c_Ljava_time_ZonedDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_ZonedDateTime)) {
    if ((this === obj)) {
      return true;
    } else {
      var x = this.Ljava_time_ZonedDateTime__f_dateTime;
      var x$2 = obj.Ljava_time_ZonedDateTime__f_dateTime;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_ZonedDateTime__f_offset;
        var x$4 = obj.Ljava_time_ZonedDateTime__f_offset;
        var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var x$5 = this.Ljava_time_ZonedDateTime__f_zone;
        var x$6 = obj.Ljava_time_ZonedDateTime__f_zone;
        return ((x$5 === null) ? (x$6 === null) : x$5.equals__O__Z(x$6));
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_ZonedDateTime.prototype.hashCode__I = (function() {
  var $x_2 = this.Ljava_time_ZonedDateTime__f_dateTime.hashCode__I();
  var this$1 = this.Ljava_time_ZonedDateTime__f_offset;
  var $x_1 = this$1.Ljava_time_ZoneOffset__f_totalSeconds;
  var i = this.Ljava_time_ZonedDateTime__f_zone.hashCode__I();
  return (($x_2 ^ $x_1) ^ ((i << 3) | ((i >>> 29) | 0)));
});
$c_Ljava_time_ZonedDateTime.prototype.toString__T = (function() {
  var str = (("" + this.Ljava_time_ZonedDateTime__f_dateTime.toString__T()) + this.Ljava_time_ZonedDateTime__f_offset.Ljava_time_ZoneOffset__f_id);
  if ((this.Ljava_time_ZonedDateTime__f_offset !== this.Ljava_time_ZonedDateTime__f_zone)) {
    str = ((str + ("[" + this.Ljava_time_ZonedDateTime__f_zone)) + "]");
  }
  return str;
});
$c_Ljava_time_ZonedDateTime.prototype.compareTo__O__I = (function(that) {
  return $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I(this, that);
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return this.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_ZonedDateTime(adjuster);
});
$c_Ljava_time_ZonedDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_ZonedDateTime(field, newValue);
});
$c_Ljava_time_ZonedDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(amountToAdd, unit);
});
$c_Ljava_time_ZonedDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_ZonedDateTime(amountToSubtract, unit);
});
$c_Ljava_time_ZonedDateTime.prototype.compare__O__I = (function(that) {
  return $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I(this, that);
});
function $isArrayOf_Ljava_time_ZonedDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_ZonedDateTime)));
}
export { $isArrayOf_Ljava_time_ZonedDateTime as $isArrayOf_Ljava_time_ZonedDateTime };
var $d_Ljava_time_ZonedDateTime = new $TypeData().initClass($c_Ljava_time_ZonedDateTime, "java.time.ZonedDateTime", ({
  Ljava_time_ZonedDateTime: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_time_chrono_ChronoZonedDateTime: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_ZonedDateTime as $d_Ljava_time_ZonedDateTime };
/** @constructor */
function $c_Ljava_time_format_ResolverStyle() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
}
export { $c_Ljava_time_format_ResolverStyle as $c_Ljava_time_format_ResolverStyle };
$c_Ljava_time_format_ResolverStyle.prototype = new $h_jl_Enum();
$c_Ljava_time_format_ResolverStyle.prototype.constructor = $c_Ljava_time_format_ResolverStyle;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle() {
}
export { $h_Ljava_time_format_ResolverStyle as $h_Ljava_time_format_ResolverStyle };
$h_Ljava_time_format_ResolverStyle.prototype = $c_Ljava_time_format_ResolverStyle.prototype;
$c_Ljava_time_format_ResolverStyle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
function $ct_Ljava_time_format_SignStyle__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_format_SignStyle__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_format_SignStyle__T__I__T__I__ as $ct_Ljava_time_format_SignStyle__T__I__T__I__ };
/** @constructor */
function $c_Ljava_time_format_SignStyle() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
}
export { $c_Ljava_time_format_SignStyle as $c_Ljava_time_format_SignStyle };
$c_Ljava_time_format_SignStyle.prototype = new $h_jl_Enum();
$c_Ljava_time_format_SignStyle.prototype.constructor = $c_Ljava_time_format_SignStyle;
/** @constructor */
function $h_Ljava_time_format_SignStyle() {
}
export { $h_Ljava_time_format_SignStyle as $h_Ljava_time_format_SignStyle };
$h_Ljava_time_format_SignStyle.prototype = $c_Ljava_time_format_SignStyle.prototype;
$c_Ljava_time_format_SignStyle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_format_SignStyle.prototype.parse__Z__Z__Z__Z = (function(positive, strict, fixedWidth) {
  var x1 = this.Ljava_time_format_SignStyle__f_ordinal;
  switch (x1) {
    case 0: {
      return ((!positive) || (!strict));
      break;
    }
    case 1:
    case 4: {
      return true;
      break;
    }
    default: {
      return ((!strict) && (!fixedWidth));
    }
  }
});
function $ct_Ljava_time_format_TextStyle__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_format_TextStyle__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_format_TextStyle__T__I__T__I__ as $ct_Ljava_time_format_TextStyle__T__I__T__I__ };
/** @constructor */
function $c_Ljava_time_format_TextStyle() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_TextStyle__f_ordinal = 0;
}
export { $c_Ljava_time_format_TextStyle as $c_Ljava_time_format_TextStyle };
$c_Ljava_time_format_TextStyle.prototype = new $h_jl_Enum();
$c_Ljava_time_format_TextStyle.prototype.constructor = $c_Ljava_time_format_TextStyle;
/** @constructor */
function $h_Ljava_time_format_TextStyle() {
}
export { $h_Ljava_time_format_TextStyle as $h_Ljava_time_format_TextStyle };
$h_Ljava_time_format_TextStyle.prototype = $c_Ljava_time_format_TextStyle.prototype;
$c_Ljava_time_format_TextStyle.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_format_TextStyle.prototype.asNormal__Ljava_time_format_TextStyle = (function() {
  return $m_Ljava_time_format_TextStyle$().values__ALjava_time_format_TextStyle().u[((-2) & this.Ljava_time_format_TextStyle__f_ordinal)];
});
var $d_Ljava_time_format_TextStyle = new $TypeData().initClass(0, "java.time.format.TextStyle", ({
  Ljava_time_format_TextStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
}));
export { $d_Ljava_time_format_TextStyle as $d_Ljava_time_format_TextStyle };
class $c_ju_DuplicateFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ju_DuplicateFormatFlagsException__f_f = null;
    this.ju_DuplicateFormatFlagsException__f_f = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return (("Flags = '" + this.ju_DuplicateFormatFlagsException__f_f) + "'");
  }
}
export { $c_ju_DuplicateFormatFlagsException as $c_ju_DuplicateFormatFlagsException };
var $d_ju_DuplicateFormatFlagsException = new $TypeData().initClass($c_ju_DuplicateFormatFlagsException, "java.util.DuplicateFormatFlagsException", ({
  ju_DuplicateFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_DuplicateFormatFlagsException as $d_ju_DuplicateFormatFlagsException };
class $c_ju_FormatFlagsConversionMismatchException extends $c_ju_IllegalFormatException {
  constructor(f, c) {
    super();
    this.ju_FormatFlagsConversionMismatchException__f_f = null;
    this.ju_FormatFlagsConversionMismatchException__f_c = 0;
    this.ju_FormatFlagsConversionMismatchException__f_f = f;
    this.ju_FormatFlagsConversionMismatchException__f_c = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return ((("Conversion = " + $cToS(this.ju_FormatFlagsConversionMismatchException__f_c)) + ", Flags = ") + this.ju_FormatFlagsConversionMismatchException__f_f);
  }
}
export { $c_ju_FormatFlagsConversionMismatchException as $c_ju_FormatFlagsConversionMismatchException };
var $d_ju_FormatFlagsConversionMismatchException = new $TypeData().initClass($c_ju_FormatFlagsConversionMismatchException, "java.util.FormatFlagsConversionMismatchException", ({
  ju_FormatFlagsConversionMismatchException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_FormatFlagsConversionMismatchException as $d_ju_FormatFlagsConversionMismatchException };
class $c_ju_IllegalFormatArgumentIndexException extends $c_ju_IllegalFormatException {
  constructor(msg) {
    super();
    this.ju_IllegalFormatArgumentIndexException__f_msg = null;
    this.ju_IllegalFormatArgumentIndexException__f_msg = msg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return this.ju_IllegalFormatArgumentIndexException__f_msg;
  }
}
export { $c_ju_IllegalFormatArgumentIndexException as $c_ju_IllegalFormatArgumentIndexException };
var $d_ju_IllegalFormatArgumentIndexException = new $TypeData().initClass($c_ju_IllegalFormatArgumentIndexException, "java.util.IllegalFormatArgumentIndexException", ({
  ju_IllegalFormatArgumentIndexException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_IllegalFormatArgumentIndexException as $d_ju_IllegalFormatArgumentIndexException };
class $c_ju_IllegalFormatCodePointException extends $c_ju_IllegalFormatException {
  constructor(c) {
    super();
    this.ju_IllegalFormatCodePointException__f_c = 0;
    this.ju_IllegalFormatCodePointException__f_c = c;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var i = this.ju_IllegalFormatCodePointException__f_c;
    return ("Code point = 0x" + (i >>> 0.0).toString(16));
  }
}
export { $c_ju_IllegalFormatCodePointException as $c_ju_IllegalFormatCodePointException };
var $d_ju_IllegalFormatCodePointException = new $TypeData().initClass($c_ju_IllegalFormatCodePointException, "java.util.IllegalFormatCodePointException", ({
  ju_IllegalFormatCodePointException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_IllegalFormatCodePointException as $d_ju_IllegalFormatCodePointException };
class $c_ju_IllegalFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(c, arg) {
    super();
    this.ju_IllegalFormatConversionException__f_c = 0;
    this.ju_IllegalFormatConversionException__f_arg = null;
    this.ju_IllegalFormatConversionException__f_c = c;
    this.ju_IllegalFormatConversionException__f_arg = arg;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((arg === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    var this$1 = this.ju_IllegalFormatConversionException__f_c;
    var this$3 = this.ju_IllegalFormatConversionException__f_arg;
    return ((("" + $cToS(this$1)) + " != ") + this$3.data.name);
  }
}
export { $c_ju_IllegalFormatConversionException as $c_ju_IllegalFormatConversionException };
var $d_ju_IllegalFormatConversionException = new $TypeData().initClass($c_ju_IllegalFormatConversionException, "java.util.IllegalFormatConversionException", ({
  ju_IllegalFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_IllegalFormatConversionException as $d_ju_IllegalFormatConversionException };
class $c_ju_IllegalFormatFlagsException extends $c_ju_IllegalFormatException {
  constructor(f) {
    super();
    this.ju_IllegalFormatFlagsException__f_f = null;
    this.ju_IllegalFormatFlagsException__f_f = f;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((f === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return (("Flags = '" + this.ju_IllegalFormatFlagsException__f_f) + "'");
  }
}
export { $c_ju_IllegalFormatFlagsException as $c_ju_IllegalFormatFlagsException };
var $d_ju_IllegalFormatFlagsException = new $TypeData().initClass($c_ju_IllegalFormatFlagsException, "java.util.IllegalFormatFlagsException", ({
  ju_IllegalFormatFlagsException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_IllegalFormatFlagsException as $d_ju_IllegalFormatFlagsException };
class $c_ju_IllegalFormatPrecisionException extends $c_ju_IllegalFormatException {
  constructor(p) {
    super();
    this.ju_IllegalFormatPrecisionException__f_p = 0;
    this.ju_IllegalFormatPrecisionException__f_p = p;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var i = this.ju_IllegalFormatPrecisionException__f_p;
    return ("" + i);
  }
}
export { $c_ju_IllegalFormatPrecisionException as $c_ju_IllegalFormatPrecisionException };
var $d_ju_IllegalFormatPrecisionException = new $TypeData().initClass($c_ju_IllegalFormatPrecisionException, "java.util.IllegalFormatPrecisionException", ({
  ju_IllegalFormatPrecisionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_IllegalFormatPrecisionException as $d_ju_IllegalFormatPrecisionException };
class $c_ju_IllegalFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(w) {
    super();
    this.ju_IllegalFormatWidthException__f_w = 0;
    this.ju_IllegalFormatWidthException__f_w = w;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    var i = this.ju_IllegalFormatWidthException__f_w;
    return ("" + i);
  }
}
export { $c_ju_IllegalFormatWidthException as $c_ju_IllegalFormatWidthException };
var $d_ju_IllegalFormatWidthException = new $TypeData().initClass($c_ju_IllegalFormatWidthException, "java.util.IllegalFormatWidthException", ({
  ju_IllegalFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_IllegalFormatWidthException as $d_ju_IllegalFormatWidthException };
function $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = $thiz.ju_LinkedHashMap__f_youngest;
  if ((older !== null)) {
    older.ju_LinkedHashMap$Node__f_younger = node;
  } else {
    $thiz.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = node;
  }
  node.ju_LinkedHashMap$Node__f_older = older;
  node.ju_LinkedHashMap$Node__f_younger = null;
  $thiz.ju_LinkedHashMap__f_youngest = node;
}
export { $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V as $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V };
function $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V($thiz, node) {
  var older = node.ju_LinkedHashMap$Node__f_older;
  var younger = node.ju_LinkedHashMap$Node__f_younger;
  if ((older === null)) {
    $thiz.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = younger;
  } else {
    older.ju_LinkedHashMap$Node__f_younger = younger;
  }
  if ((younger === null)) {
    $thiz.ju_LinkedHashMap__f_youngest = older;
  } else {
    younger.ju_LinkedHashMap$Node__f_older = older;
  }
}
export { $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V as $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V };
function $ct_ju_LinkedHashMap__I__F__Z__($thiz, initialCapacity, loadFactor, accessOrder) {
  $thiz.ju_LinkedHashMap__f_accessOrder = accessOrder;
  $ct_ju_HashMap__I__F__($thiz, initialCapacity, loadFactor);
  return $thiz;
}
export { $ct_ju_LinkedHashMap__I__F__Z__ as $ct_ju_LinkedHashMap__I__F__Z__ };
function $ct_ju_LinkedHashMap__($thiz) {
  $ct_ju_LinkedHashMap__I__F__Z__($thiz, 16, 0.75, false);
  return $thiz;
}
export { $ct_ju_LinkedHashMap__ as $ct_ju_LinkedHashMap__ };
/** @constructor */
function $c_ju_LinkedHashMap() {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
  this.ju_LinkedHashMap__f_accessOrder = false;
  this.ju_LinkedHashMap__f_java$util$LinkedHashMap$$eldest = null;
  this.ju_LinkedHashMap__f_youngest = null;
}
export { $c_ju_LinkedHashMap as $c_ju_LinkedHashMap };
$c_ju_LinkedHashMap.prototype = new $h_ju_HashMap();
$c_ju_LinkedHashMap.prototype.constructor = $c_ju_LinkedHashMap;
/** @constructor */
function $h_ju_LinkedHashMap() {
}
export { $h_ju_LinkedHashMap as $h_ju_LinkedHashMap };
$h_ju_LinkedHashMap.prototype = $c_ju_LinkedHashMap.prototype;
$c_ju_LinkedHashMap.prototype.newNode__O__I__O__ju_HashMap$Node__ju_HashMap$Node__ju_HashMap$Node = (function(key, hash, value, previous, next) {
  return new $c_ju_LinkedHashMap$Node(key, hash, value, previous, next, null, null);
});
$c_ju_LinkedHashMap.prototype.nodeWasAccessed__ju_HashMap$Node__V = (function(node) {
  if (this.ju_LinkedHashMap__f_accessOrder) {
    if ((node.ju_LinkedHashMap$Node__f_younger !== null)) {
      $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, node);
      $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, node);
    }
  }
});
$c_ju_LinkedHashMap.prototype.nodeWasAdded__ju_HashMap$Node__V = (function(node) {
  $p_ju_LinkedHashMap__appendToOrderedList__ju_LinkedHashMap$Node__V(this, node);
});
$c_ju_LinkedHashMap.prototype.nodeWasRemoved__ju_HashMap$Node__V = (function(node) {
  $p_ju_LinkedHashMap__removeFromOrderedList__ju_LinkedHashMap$Node__V(this, node);
});
$c_ju_LinkedHashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_LinkedHashMap$NodeIterator(this);
});
$c_ju_LinkedHashMap.prototype.keyIterator__ju_Iterator = (function() {
  return new $c_ju_LinkedHashMap$KeyIterator(this);
});
var $d_ju_LinkedHashMap = new $TypeData().initClass($c_ju_LinkedHashMap, "java.util.LinkedHashMap", ({
  ju_LinkedHashMap: 1,
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1,
  ju_SequencedMap: 1
}));
export { $d_ju_LinkedHashMap as $d_ju_LinkedHashMap };
/** @constructor */
function $c_ju_Locale$Category() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
}
export { $c_ju_Locale$Category as $c_ju_Locale$Category };
$c_ju_Locale$Category.prototype = new $h_jl_Enum();
$c_ju_Locale$Category.prototype.constructor = $c_ju_Locale$Category;
/** @constructor */
function $h_ju_Locale$Category() {
}
export { $h_ju_Locale$Category as $h_ju_Locale$Category };
$h_ju_Locale$Category.prototype = $c_ju_Locale$Category.prototype;
$c_ju_Locale$Category.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
var $d_ju_Locale$Category = new $TypeData().initClass(0, "java.util.Locale$Category", ({
  ju_Locale$Category: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
}));
export { $d_ju_Locale$Category as $d_ju_Locale$Category };
class $c_ju_MissingFormatArgumentException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_MissingFormatArgumentException__f_s = null;
    this.ju_MissingFormatArgumentException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return (("Format specifier '" + this.ju_MissingFormatArgumentException__f_s) + "'");
  }
}
export { $c_ju_MissingFormatArgumentException as $c_ju_MissingFormatArgumentException };
var $d_ju_MissingFormatArgumentException = new $TypeData().initClass($c_ju_MissingFormatArgumentException, "java.util.MissingFormatArgumentException", ({
  ju_MissingFormatArgumentException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_MissingFormatArgumentException as $d_ju_MissingFormatArgumentException };
class $c_ju_MissingFormatWidthException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_MissingFormatWidthException__f_s = null;
    this.ju_MissingFormatWidthException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return this.ju_MissingFormatWidthException__f_s;
  }
}
export { $c_ju_MissingFormatWidthException as $c_ju_MissingFormatWidthException };
var $d_ju_MissingFormatWidthException = new $TypeData().initClass($c_ju_MissingFormatWidthException, "java.util.MissingFormatWidthException", ({
  ju_MissingFormatWidthException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_MissingFormatWidthException as $d_ju_MissingFormatWidthException };
class $c_ju_UnknownFormatConversionException extends $c_ju_IllegalFormatException {
  constructor(s) {
    super();
    this.ju_UnknownFormatConversionException__f_s = null;
    this.ju_UnknownFormatConversionException__f_s = s;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
    if ((s === null)) {
      throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
    }
  }
  getMessage__T() {
    return (("Conversion = '" + this.ju_UnknownFormatConversionException__f_s) + "'");
  }
}
export { $c_ju_UnknownFormatConversionException as $c_ju_UnknownFormatConversionException };
var $d_ju_UnknownFormatConversionException = new $TypeData().initClass($c_ju_UnknownFormatConversionException, "java.util.UnknownFormatConversionException", ({
  ju_UnknownFormatConversionException: 1,
  ju_IllegalFormatException: 1,
  jl_IllegalArgumentException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_UnknownFormatConversionException as $d_ju_UnknownFormatConversionException };
/** @constructor */
function $c_ju_concurrent_ConcurrentHashMap$InnerHashMap(initialCapacity, loadFactor) {
  this.ju_HashMap__f_java$util$HashMap$$loadFactor = 0.0;
  this.ju_HashMap__f_java$util$HashMap$$table = null;
  this.ju_HashMap__f_threshold = 0;
  this.ju_HashMap__f_contentSize = 0;
  $ct_ju_HashMap__I__F__(this, initialCapacity, loadFactor);
}
export { $c_ju_concurrent_ConcurrentHashMap$InnerHashMap as $c_ju_concurrent_ConcurrentHashMap$InnerHashMap };
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype = new $h_ju_NullRejectingHashMap();
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.constructor = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap;
/** @constructor */
function $h_ju_concurrent_ConcurrentHashMap$InnerHashMap() {
}
export { $h_ju_concurrent_ConcurrentHashMap$InnerHashMap as $h_ju_concurrent_ConcurrentHashMap$InnerHashMap };
$h_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype = $c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype;
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.nodeIterator__ju_Iterator = (function() {
  return new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$NodeIterator(this);
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.keyIterator__ju_Iterator = (function() {
  return new $c_ju_concurrent_ConcurrentHashMap$InnerHashMap$KeyIterator(this);
});
$c_ju_concurrent_ConcurrentHashMap$InnerHashMap.prototype.java$util$concurrent$ConcurrentHashMap$InnerHashMap$$makeSnapshot__ju_ArrayList = (function() {
  var snapshot = $ct_ju_ArrayList__I__(new $c_ju_ArrayList(), this.ju_HashMap__f_contentSize);
  var iter = new $c_ju_HashMap$NodeIterator(this);
  while (iter.hasNext__Z()) {
    snapshot.add__O__Z(iter.next__O());
  }
  return snapshot;
});
var $d_ju_concurrent_ConcurrentHashMap$InnerHashMap = new $TypeData().initClass($c_ju_concurrent_ConcurrentHashMap$InnerHashMap, "java.util.concurrent.ConcurrentHashMap$InnerHashMap", ({
  ju_concurrent_ConcurrentHashMap$InnerHashMap: 1,
  ju_NullRejectingHashMap: 1,
  ju_HashMap: 1,
  ju_AbstractMap: 1,
  ju_Map: 1,
  Ljava_io_Serializable: 1,
  jl_Cloneable: 1
}));
export { $d_ju_concurrent_ConcurrentHashMap$InnerHashMap as $d_ju_concurrent_ConcurrentHashMap$InnerHashMap };
/** @constructor */
function $c_T$package$EmptyTuple$() {
}
export { $c_T$package$EmptyTuple$ as $c_T$package$EmptyTuple$ };
$c_T$package$EmptyTuple$.prototype = new $h_O();
$c_T$package$EmptyTuple$.prototype.constructor = $c_T$package$EmptyTuple$;
/** @constructor */
function $h_T$package$EmptyTuple$() {
}
export { $h_T$package$EmptyTuple$ as $h_T$package$EmptyTuple$ };
$h_T$package$EmptyTuple$.prototype = $c_T$package$EmptyTuple$.prototype;
$c_T$package$EmptyTuple$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_T$package$EmptyTuple$.prototype.hashCode__I = (function() {
  return 924202651;
});
$c_T$package$EmptyTuple$.prototype.productArity__I = (function() {
  return 0;
});
$c_T$package$EmptyTuple$.prototype.productPrefix__T = (function() {
  return "EmptyTuple";
});
$c_T$package$EmptyTuple$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_T$package$EmptyTuple$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_T$package$EmptyTuple$.prototype.toString__T = (function() {
  return "()";
});
$c_T$package$EmptyTuple$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_T$package$EmptyTuple$ = new $TypeData().initClass($c_T$package$EmptyTuple$, "scala.Tuple$package$EmptyTuple$", ({
  T$package$EmptyTuple$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_T$package$EmptyTuple$ as $d_T$package$EmptyTuple$ };
var $n_T$package$EmptyTuple$;
function $m_T$package$EmptyTuple$() {
  if ((!$n_T$package$EmptyTuple$)) {
    $n_T$package$EmptyTuple$ = new $c_T$package$EmptyTuple$();
  }
  return $n_T$package$EmptyTuple$;
}
export { $m_T$package$EmptyTuple$ as $m_T$package$EmptyTuple$ };
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcB$sp(xs$mcB$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp = xs$mcB$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcB$sp);
}
export { $c_sc_ArrayOps$ArrayIterator$mcB$sp as $c_sc_ArrayOps$ArrayIterator$mcB$sp };
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcB$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcB$sp() {
}
export { $h_sc_ArrayOps$ArrayIterator$mcB$sp as $h_sc_ArrayOps$ArrayIterator$mcB$sp };
$h_sc_ArrayOps$ArrayIterator$mcB$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next$mcB$sp__B = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp.u.length)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var r = this.sc_ArrayOps$ArrayIterator$mcB$sp__f_xs$mcB$sp.u[this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos];
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcB$sp.prototype.next__O = (function() {
  return this.next$mcB$sp__B();
});
var $d_sc_ArrayOps$ArrayIterator$mcB$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcB$sp, "scala.collection.ArrayOps$ArrayIterator$mcB$sp", ({
  sc_ArrayOps$ArrayIterator$mcB$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_ArrayOps$ArrayIterator$mcB$sp as $d_sc_ArrayOps$ArrayIterator$mcB$sp };
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcC$sp(xs$mcC$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp = xs$mcC$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcC$sp);
}
export { $c_sc_ArrayOps$ArrayIterator$mcC$sp as $c_sc_ArrayOps$ArrayIterator$mcC$sp };
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcC$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcC$sp() {
}
export { $h_sc_ArrayOps$ArrayIterator$mcC$sp as $h_sc_ArrayOps$ArrayIterator$mcC$sp };
$h_sc_ArrayOps$ArrayIterator$mcC$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next$mcC$sp__C = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp.u.length)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var r = this.sc_ArrayOps$ArrayIterator$mcC$sp__f_xs$mcC$sp.u[this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos];
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcC$sp.prototype.next__O = (function() {
  return $bC(this.next$mcC$sp__C());
});
var $d_sc_ArrayOps$ArrayIterator$mcC$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcC$sp, "scala.collection.ArrayOps$ArrayIterator$mcC$sp", ({
  sc_ArrayOps$ArrayIterator$mcC$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_ArrayOps$ArrayIterator$mcC$sp as $d_sc_ArrayOps$ArrayIterator$mcC$sp };
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcD$sp(xs$mcD$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp = xs$mcD$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcD$sp);
}
export { $c_sc_ArrayOps$ArrayIterator$mcD$sp as $c_sc_ArrayOps$ArrayIterator$mcD$sp };
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcD$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcD$sp() {
}
export { $h_sc_ArrayOps$ArrayIterator$mcD$sp as $h_sc_ArrayOps$ArrayIterator$mcD$sp };
$h_sc_ArrayOps$ArrayIterator$mcD$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next$mcD$sp__D = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp.u.length)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var r = this.sc_ArrayOps$ArrayIterator$mcD$sp__f_xs$mcD$sp.u[this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos];
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcD$sp.prototype.next__O = (function() {
  return this.next$mcD$sp__D();
});
var $d_sc_ArrayOps$ArrayIterator$mcD$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcD$sp, "scala.collection.ArrayOps$ArrayIterator$mcD$sp", ({
  sc_ArrayOps$ArrayIterator$mcD$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_ArrayOps$ArrayIterator$mcD$sp as $d_sc_ArrayOps$ArrayIterator$mcD$sp };
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcF$sp(xs$mcF$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp = xs$mcF$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcF$sp);
}
export { $c_sc_ArrayOps$ArrayIterator$mcF$sp as $c_sc_ArrayOps$ArrayIterator$mcF$sp };
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcF$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcF$sp() {
}
export { $h_sc_ArrayOps$ArrayIterator$mcF$sp as $h_sc_ArrayOps$ArrayIterator$mcF$sp };
$h_sc_ArrayOps$ArrayIterator$mcF$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next$mcF$sp__F = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp.u.length)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var r = this.sc_ArrayOps$ArrayIterator$mcF$sp__f_xs$mcF$sp.u[this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos];
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcF$sp.prototype.next__O = (function() {
  return this.next$mcF$sp__F();
});
var $d_sc_ArrayOps$ArrayIterator$mcF$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcF$sp, "scala.collection.ArrayOps$ArrayIterator$mcF$sp", ({
  sc_ArrayOps$ArrayIterator$mcF$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_ArrayOps$ArrayIterator$mcF$sp as $d_sc_ArrayOps$ArrayIterator$mcF$sp };
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcI$sp(xs$mcI$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp = xs$mcI$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcI$sp);
}
export { $c_sc_ArrayOps$ArrayIterator$mcI$sp as $c_sc_ArrayOps$ArrayIterator$mcI$sp };
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcI$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcI$sp() {
}
export { $h_sc_ArrayOps$ArrayIterator$mcI$sp as $h_sc_ArrayOps$ArrayIterator$mcI$sp };
$h_sc_ArrayOps$ArrayIterator$mcI$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next$mcI$sp__I = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp.u.length)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var r = this.sc_ArrayOps$ArrayIterator$mcI$sp__f_xs$mcI$sp.u[this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos];
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcI$sp.prototype.next__O = (function() {
  return this.next$mcI$sp__I();
});
var $d_sc_ArrayOps$ArrayIterator$mcI$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcI$sp, "scala.collection.ArrayOps$ArrayIterator$mcI$sp", ({
  sc_ArrayOps$ArrayIterator$mcI$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_ArrayOps$ArrayIterator$mcI$sp as $d_sc_ArrayOps$ArrayIterator$mcI$sp };
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcJ$sp(xs$mcJ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp = xs$mcJ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcJ$sp);
}
export { $c_sc_ArrayOps$ArrayIterator$mcJ$sp as $c_sc_ArrayOps$ArrayIterator$mcJ$sp };
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcJ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcJ$sp() {
}
export { $h_sc_ArrayOps$ArrayIterator$mcJ$sp as $h_sc_ArrayOps$ArrayIterator$mcJ$sp };
$h_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next$mcJ$sp__J = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp.u.length)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var t = this.sc_ArrayOps$ArrayIterator$mcJ$sp__f_xs$mcJ$sp.u[this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos];
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return new $c_RTLong(lo, hi);
});
$c_sc_ArrayOps$ArrayIterator$mcJ$sp.prototype.next__O = (function() {
  return this.next$mcJ$sp__J();
});
var $d_sc_ArrayOps$ArrayIterator$mcJ$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcJ$sp, "scala.collection.ArrayOps$ArrayIterator$mcJ$sp", ({
  sc_ArrayOps$ArrayIterator$mcJ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_ArrayOps$ArrayIterator$mcJ$sp as $d_sc_ArrayOps$ArrayIterator$mcJ$sp };
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcS$sp(xs$mcS$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp = xs$mcS$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcS$sp);
}
export { $c_sc_ArrayOps$ArrayIterator$mcS$sp as $c_sc_ArrayOps$ArrayIterator$mcS$sp };
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcS$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcS$sp() {
}
export { $h_sc_ArrayOps$ArrayIterator$mcS$sp as $h_sc_ArrayOps$ArrayIterator$mcS$sp };
$h_sc_ArrayOps$ArrayIterator$mcS$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next$mcS$sp__S = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp.u.length)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var r = this.sc_ArrayOps$ArrayIterator$mcS$sp__f_xs$mcS$sp.u[this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos];
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcS$sp.prototype.next__O = (function() {
  return this.next$mcS$sp__S();
});
var $d_sc_ArrayOps$ArrayIterator$mcS$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcS$sp, "scala.collection.ArrayOps$ArrayIterator$mcS$sp", ({
  sc_ArrayOps$ArrayIterator$mcS$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_ArrayOps$ArrayIterator$mcS$sp as $d_sc_ArrayOps$ArrayIterator$mcS$sp };
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcV$sp(xs$mcV$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp = xs$mcV$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcV$sp);
}
export { $c_sc_ArrayOps$ArrayIterator$mcV$sp as $c_sc_ArrayOps$ArrayIterator$mcV$sp };
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcV$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcV$sp() {
}
export { $h_sc_ArrayOps$ArrayIterator$mcV$sp as $h_sc_ArrayOps$ArrayIterator$mcV$sp };
$h_sc_ArrayOps$ArrayIterator$mcV$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next$mcV$sp__V = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= this.sc_ArrayOps$ArrayIterator$mcV$sp__f_xs$mcV$sp.u.length)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
});
$c_sc_ArrayOps$ArrayIterator$mcV$sp.prototype.next__O = (function() {
  this.next$mcV$sp__V();
});
var $d_sc_ArrayOps$ArrayIterator$mcV$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcV$sp, "scala.collection.ArrayOps$ArrayIterator$mcV$sp", ({
  sc_ArrayOps$ArrayIterator$mcV$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_ArrayOps$ArrayIterator$mcV$sp as $d_sc_ArrayOps$ArrayIterator$mcV$sp };
/** @constructor */
function $c_sc_ArrayOps$ArrayIterator$mcZ$sp(xs$mcZ$sp) {
  this.sc_ArrayOps$ArrayIterator__f_xs = null;
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = 0;
  this.sc_ArrayOps$ArrayIterator__f_len = 0;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = null;
  this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp = xs$mcZ$sp;
  $ct_sc_ArrayOps$ArrayIterator__O__(this, xs$mcZ$sp);
}
export { $c_sc_ArrayOps$ArrayIterator$mcZ$sp as $c_sc_ArrayOps$ArrayIterator$mcZ$sp };
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = new $h_sc_ArrayOps$ArrayIterator();
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.constructor = $c_sc_ArrayOps$ArrayIterator$mcZ$sp;
/** @constructor */
function $h_sc_ArrayOps$ArrayIterator$mcZ$sp() {
}
export { $h_sc_ArrayOps$ArrayIterator$mcZ$sp as $h_sc_ArrayOps$ArrayIterator$mcZ$sp };
$h_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype = $c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype;
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next$mcZ$sp__Z = (function() {
  if ((this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos >= this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp.u.length)) {
    $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty.next__O();
  }
  var r = this.sc_ArrayOps$ArrayIterator$mcZ$sp__f_xs$mcZ$sp.u[this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos];
  this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos = ((1 + this.sc_ArrayOps$ArrayIterator__f_scala$collection$ArrayOps$ArrayIterator$$pos) | 0);
  return r;
});
$c_sc_ArrayOps$ArrayIterator$mcZ$sp.prototype.next__O = (function() {
  return this.next$mcZ$sp__Z();
});
var $d_sc_ArrayOps$ArrayIterator$mcZ$sp = new $TypeData().initClass($c_sc_ArrayOps$ArrayIterator$mcZ$sp, "scala.collection.ArrayOps$ArrayIterator$mcZ$sp", ({
  sc_ArrayOps$ArrayIterator$mcZ$sp: 1,
  sc_ArrayOps$ArrayIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_ArrayOps$ArrayIterator$mcZ$sp as $d_sc_ArrayOps$ArrayIterator$mcZ$sp };
/** @constructor */
function $c_sc_Iterable$$anon$1(a$1) {
  this.sc_Iterable$$anon$1__f_a$1 = null;
  this.sc_Iterable$$anon$1__f_a$1 = a$1;
}
export { $c_sc_Iterable$$anon$1 as $c_sc_Iterable$$anon$1 };
$c_sc_Iterable$$anon$1.prototype = new $h_sc_AbstractIterable();
$c_sc_Iterable$$anon$1.prototype.constructor = $c_sc_Iterable$$anon$1;
/** @constructor */
function $h_sc_Iterable$$anon$1() {
}
export { $h_sc_Iterable$$anon$1 as $h_sc_Iterable$$anon$1 };
$h_sc_Iterable$$anon$1.prototype = $c_sc_Iterable$$anon$1.prototype;
$c_sc_Iterable$$anon$1.prototype.iterator__sc_Iterator = (function() {
  var a = this.sc_Iterable$$anon$1__f_a$1;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sc_Iterable$$anon$1.prototype.knownSize__I = (function() {
  return 1;
});
$c_sc_Iterable$$anon$1.prototype.head__O = (function() {
  return this.sc_Iterable$$anon$1__f_a$1;
});
$c_sc_Iterable$$anon$1.prototype.headOption__s_Some = (function() {
  return new $c_s_Some(this.sc_Iterable$$anon$1__f_a$1);
});
$c_sc_Iterable$$anon$1.prototype.last__O = (function() {
  return this.sc_Iterable$$anon$1__f_a$1;
});
$c_sc_Iterable$$anon$1.prototype.take__I__sc_Iterable = (function(n) {
  return ((n > 0) ? this : $m_sc_Iterable$().empty__O());
});
$c_sc_Iterable$$anon$1.prototype.drop__I__sc_Iterable = (function(n) {
  return ((n > 0) ? $m_sc_Iterable$().empty__O() : this);
});
$c_sc_Iterable$$anon$1.prototype.dropRight__I__sc_Iterable = (function(n) {
  return ((n > 0) ? $m_sc_Iterable$().empty__O() : this);
});
$c_sc_Iterable$$anon$1.prototype.tail__O = (function() {
  return $m_sc_Iterable$().empty__O();
});
$c_sc_Iterable$$anon$1.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_Iterable(n);
});
$c_sc_Iterable$$anon$1.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_Iterable(n);
});
$c_sc_Iterable$$anon$1.prototype.take__I__O = (function(n) {
  return this.take__I__sc_Iterable(n);
});
$c_sc_Iterable$$anon$1.prototype.headOption__s_Option = (function() {
  return this.headOption__s_Some();
});
var $d_sc_Iterable$$anon$1 = new $TypeData().initClass($c_sc_Iterable$$anon$1, "scala.collection.Iterable$$anon$1", ({
  sc_Iterable$$anon$1: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1
}));
export { $d_sc_Iterable$$anon$1 as $d_sc_Iterable$$anon$1 };
function $f_sc_View__toString__T($thiz) {
  return ($thiz.className__T() + "(<not computed>)");
}
export { $f_sc_View__toString__T as $f_sc_View__toString__T };
function $is_sc_View(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_View)));
}
export { $is_sc_View as $is_sc_View };
function $isArrayOf_sc_View(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_View)));
}
export { $isArrayOf_sc_View as $isArrayOf_sc_View };
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$SetWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying = null;
  this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying = underlying;
}
export { $c_sc_convert_JavaCollectionWrappers$SetWrapper as $c_sc_convert_JavaCollectionWrappers$SetWrapper };
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype = new $h_ju_AbstractSet();
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$SetWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$SetWrapper() {
}
export { $h_sc_convert_JavaCollectionWrappers$SetWrapper as $h_sc_convert_JavaCollectionWrappers$SetWrapper };
$h_sc_convert_JavaCollectionWrappers$SetWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.contains__O__Z = (function(o) {
  try {
    return this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying.contains__O__Z(o);
  } catch (e) {
    if ((e instanceof $c_jl_ClassCastException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.isEmpty__Z = (function() {
  return this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying.isEmpty__Z();
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.size__I = (function() {
  return this.sc_convert_JavaCollectionWrappers$SetWrapper__f_scala$collection$convert$JavaCollectionWrappers$SetWrapper$$underlying.size__I();
});
$c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype.iterator__ju_Iterator = (function() {
  return new $c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$1(this);
});
var $d_sc_convert_JavaCollectionWrappers$SetWrapper = new $TypeData().initClass($c_sc_convert_JavaCollectionWrappers$SetWrapper, "scala.collection.convert.JavaCollectionWrappers$SetWrapper", ({
  sc_convert_JavaCollectionWrappers$SetWrapper: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_convert_JavaCollectionWrappers$SetWrapper as $d_sc_convert_JavaCollectionWrappers$SetWrapper };
function $f_sci_MapOps__removedAll__sc_IterableOnce__sci_MapOps($thiz, keys) {
  var this$1 = keys.iterator__sc_Iterator();
  var z = $thiz.coll__sci_MapOps();
  var f = ((x$2$2$2, x$3$2$2) => x$2$2$2.removed__O__sci_MapOps(x$3$2$2));
  if ($is_sc_IndexedSeq(this$1)) {
    var at = 0;
    var end = this$1.length__I();
    var acc = z;
    var $x_1;
    while (true) {
      if ((at !== end)) {
        var temp$at = ((1 + at) | 0);
        var x0 = acc;
        var x1 = this$1.apply__I__O(at);
        var temp$acc = f(x0, x1);
        at = temp$at;
        acc = temp$acc;
        continue;
      }
      var $x_1 = acc;
      break;
    }
  } else {
    var result = z;
    while (this$1.hasNext__Z()) {
      var x0$1 = result;
      var x1$1 = this$1.next__O();
      result = f(x0$1, x1$1);
    }
    var $x_1 = result;
  }
  return $x_1;
}
export { $f_sci_MapOps__removedAll__sc_IterableOnce__sci_MapOps as $f_sci_MapOps__removedAll__sc_IterableOnce__sci_MapOps };
/** @constructor */
function $c_sci_Set$Set2$$anon$1(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set2$$anon$1__f_$outer = null;
  this.sci_Set$Set2$$anon$1__f_$outer = outer;
  $ct_sci_Set$SetNIterator__I__(this, 2);
}
export { $c_sci_Set$Set2$$anon$1 as $c_sci_Set$Set2$$anon$1 };
$c_sci_Set$Set2$$anon$1.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set2$$anon$1.prototype.constructor = $c_sci_Set$Set2$$anon$1;
/** @constructor */
function $h_sci_Set$Set2$$anon$1() {
}
export { $h_sci_Set$Set2$$anon$1 as $h_sci_Set$Set2$$anon$1 };
$h_sci_Set$Set2$$anon$1.prototype = $c_sci_Set$Set2$$anon$1.prototype;
$c_sci_Set$Set2$$anon$1.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set2$$anon$1__f_$outer.scala$collection$immutable$Set$Set2$$getElem__I__O(i);
});
var $d_sci_Set$Set2$$anon$1 = new $TypeData().initClass($c_sci_Set$Set2$$anon$1, "scala.collection.immutable.Set$Set2$$anon$1", ({
  sci_Set$Set2$$anon$1: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Set$Set2$$anon$1 as $d_sci_Set$Set2$$anon$1 };
/** @constructor */
function $c_sci_Set$Set3$$anon$2(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set3$$anon$2__f_$outer = null;
  this.sci_Set$Set3$$anon$2__f_$outer = outer;
  $ct_sci_Set$SetNIterator__I__(this, 3);
}
export { $c_sci_Set$Set3$$anon$2 as $c_sci_Set$Set3$$anon$2 };
$c_sci_Set$Set3$$anon$2.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set3$$anon$2.prototype.constructor = $c_sci_Set$Set3$$anon$2;
/** @constructor */
function $h_sci_Set$Set3$$anon$2() {
}
export { $h_sci_Set$Set3$$anon$2 as $h_sci_Set$Set3$$anon$2 };
$h_sci_Set$Set3$$anon$2.prototype = $c_sci_Set$Set3$$anon$2.prototype;
$c_sci_Set$Set3$$anon$2.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set3$$anon$2__f_$outer.scala$collection$immutable$Set$Set3$$getElem__I__O(i);
});
var $d_sci_Set$Set3$$anon$2 = new $TypeData().initClass($c_sci_Set$Set3$$anon$2, "scala.collection.immutable.Set$Set3$$anon$2", ({
  sci_Set$Set3$$anon$2: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Set$Set3$$anon$2 as $d_sci_Set$Set3$$anon$2 };
/** @constructor */
function $c_sci_Set$Set4$$anon$3(outer) {
  this.sci_Set$SetNIterator__f_current = 0;
  this.sci_Set$SetNIterator__f_remainder = 0;
  this.sci_Set$Set4$$anon$3__f_$outer = null;
  this.sci_Set$Set4$$anon$3__f_$outer = outer;
  $ct_sci_Set$SetNIterator__I__(this, 4);
}
export { $c_sci_Set$Set4$$anon$3 as $c_sci_Set$Set4$$anon$3 };
$c_sci_Set$Set4$$anon$3.prototype = new $h_sci_Set$SetNIterator();
$c_sci_Set$Set4$$anon$3.prototype.constructor = $c_sci_Set$Set4$$anon$3;
/** @constructor */
function $h_sci_Set$Set4$$anon$3() {
}
export { $h_sci_Set$Set4$$anon$3 as $h_sci_Set$Set4$$anon$3 };
$h_sci_Set$Set4$$anon$3.prototype = $c_sci_Set$Set4$$anon$3.prototype;
$c_sci_Set$Set4$$anon$3.prototype.apply__I__O = (function(i) {
  return this.sci_Set$Set4$$anon$3__f_$outer.scala$collection$immutable$Set$Set4$$getElem__I__O(i);
});
var $d_sci_Set$Set4$$anon$3 = new $TypeData().initClass($c_sci_Set$Set4$$anon$3, "scala.collection.immutable.Set$Set4$$anon$3", ({
  sci_Set$Set4$$anon$3: 1,
  sci_Set$SetNIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Set$Set4$$anon$3 as $d_sci_Set$Set4$$anon$3 };
/** @constructor */
function $c_scm_ArrayBuilder$generic(elementClass) {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder__f_size = 0;
  this.scm_ArrayBuilder$generic__f_elementClass = null;
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = false;
  this.scm_ArrayBuilder$generic__f_jsElems = null;
  this.scm_ArrayBuilder$generic__f_elementClass = elementClass;
  $ct_scm_ArrayBuilder__(this);
  this.scm_ArrayBuilder$generic__f_isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  this.scm_ArrayBuilder$generic__f_jsElems = [];
}
export { $c_scm_ArrayBuilder$generic as $c_scm_ArrayBuilder$generic };
$c_scm_ArrayBuilder$generic.prototype = new $h_scm_ArrayBuilder();
$c_scm_ArrayBuilder$generic.prototype.constructor = $c_scm_ArrayBuilder$generic;
/** @constructor */
function $h_scm_ArrayBuilder$generic() {
}
export { $h_scm_ArrayBuilder$generic as $h_scm_ArrayBuilder$generic };
$h_scm_ArrayBuilder$generic.prototype = $c_scm_ArrayBuilder$generic.prototype;
$c_scm_ArrayBuilder$generic.prototype.elems__O = (function() {
  throw $ct_jl_Error__T__(new $c_jl_Error(), "unreachable");
});
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_ArrayBuilder$generic = (function(elem) {
  var unboxedElem = (this.scm_ArrayBuilder$generic__f_isCharArrayBuilder ? $uC(elem) : ((elem === null) ? this.scm_ArrayBuilder$generic__f_elementClass.data.zero : elem));
  this.scm_ArrayBuilder$generic__f_jsElems.push(unboxedElem);
  return this;
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_ArrayBuilder$generic = (function(xs) {
  var it = xs.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    this.addOne__O__scm_ArrayBuilder$generic(elem);
  }
  return this;
});
$c_scm_ArrayBuilder$generic.prototype.resize__I__V = (function(size) {
});
$c_scm_ArrayBuilder$generic.prototype.result__O = (function() {
  var x$2 = this.scm_ArrayBuilder$generic__f_elementClass;
  if ((x$2 === $d_V.getClassOf())) {
    var elemRuntimeClass = $d_jl_Void.getClassOf();
  } else {
    var x$4 = this.scm_ArrayBuilder$generic__f_elementClass;
    if ((x$4 === $d_sr_Null$.getClassOf())) {
      var $x_1 = true;
    } else {
      var x$6 = this.scm_ArrayBuilder$generic__f_elementClass;
      var $x_1 = (x$6 === $d_sr_Nothing$.getClassOf());
    }
    if ($x_1) {
      var elemRuntimeClass = $d_O.getClassOf();
    } else {
      var elemRuntimeClass = this.scm_ArrayBuilder$generic__f_elementClass;
    }
  }
  return elemRuntimeClass.data.getArrayOf().wrapArray(this.scm_ArrayBuilder$generic__f_jsElems);
});
$c_scm_ArrayBuilder$generic.prototype.toString__T = (function() {
  return "ArrayBuilder.generic";
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuilder$generic(elems);
});
$c_scm_ArrayBuilder$generic.prototype.addAll__sc_IterableOnce__scm_ArrayBuilder = (function(xs) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuilder$generic(xs);
});
$c_scm_ArrayBuilder$generic.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuilder$generic(elem);
});
var $d_scm_ArrayBuilder$generic = new $TypeData().initClass($c_scm_ArrayBuilder$generic, "scala.collection.mutable.ArrayBuilder$generic", ({
  scm_ArrayBuilder$generic: 1,
  scm_ArrayBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArrayBuilder$generic as $d_scm_ArrayBuilder$generic };
function $p_scm_ArrayBuilder$ofRef__mkArray__I__AO($thiz, size) {
  if ((($thiz.scm_ArrayBuilder__f_capacity === size) && ($thiz.scm_ArrayBuilder__f_capacity > 0))) {
    return $thiz.scm_ArrayBuilder$ofRef__f_elems;
  } else if (($thiz.scm_ArrayBuilder$ofRef__f_elems === null)) {
    return $thiz.scm_ArrayBuilder$ofRef__f_ct.newArray__I__O(size);
  } else {
    var original = $thiz.scm_ArrayBuilder$ofRef__f_elems;
    return $m_ju_Arrays$().copyOf__AO__I__AO(original, size);
  }
}
export { $p_scm_ArrayBuilder$ofRef__mkArray__I__AO as $p_scm_ArrayBuilder$ofRef__mkArray__I__AO };
/** @constructor */
function $c_scm_ArrayBuilder$ofRef(ct) {
  this.scm_ArrayBuilder__f_capacity = 0;
  this.scm_ArrayBuilder__f_size = 0;
  this.scm_ArrayBuilder$ofRef__f_ct = null;
  this.scm_ArrayBuilder$ofRef__f_elems = null;
  this.scm_ArrayBuilder$ofRef__f_ct = ct;
  $ct_scm_ArrayBuilder__(this);
}
export { $c_scm_ArrayBuilder$ofRef as $c_scm_ArrayBuilder$ofRef };
$c_scm_ArrayBuilder$ofRef.prototype = new $h_scm_ArrayBuilder();
$c_scm_ArrayBuilder$ofRef.prototype.constructor = $c_scm_ArrayBuilder$ofRef;
/** @constructor */
function $h_scm_ArrayBuilder$ofRef() {
}
export { $h_scm_ArrayBuilder$ofRef as $h_scm_ArrayBuilder$ofRef };
$h_scm_ArrayBuilder$ofRef.prototype = $c_scm_ArrayBuilder$ofRef.prototype;
$c_scm_ArrayBuilder$ofRef.prototype.resize__I__V = (function(size) {
  this.scm_ArrayBuilder$ofRef__f_elems = $p_scm_ArrayBuilder$ofRef__mkArray__I__AO(this, size);
  this.scm_ArrayBuilder__f_capacity = size;
});
$c_scm_ArrayBuilder$ofRef.prototype.addOne__O__scm_ArrayBuilder$ofRef = (function(elem) {
  this.ensureSize__I__V(((1 + this.scm_ArrayBuilder__f_size) | 0));
  this.scm_ArrayBuilder$ofRef__f_elems.u[this.scm_ArrayBuilder__f_size] = elem;
  this.scm_ArrayBuilder__f_size = ((1 + this.scm_ArrayBuilder__f_size) | 0);
  return this;
});
$c_scm_ArrayBuilder$ofRef.prototype.result__AO = (function() {
  if (((this.scm_ArrayBuilder__f_capacity !== 0) && (this.scm_ArrayBuilder__f_capacity === this.scm_ArrayBuilder__f_size))) {
    this.scm_ArrayBuilder__f_capacity = 0;
    var res = this.scm_ArrayBuilder$ofRef__f_elems;
    this.scm_ArrayBuilder$ofRef__f_elems = null;
    return res;
  } else {
    return $p_scm_ArrayBuilder$ofRef__mkArray__I__AO(this, this.scm_ArrayBuilder__f_size);
  }
});
$c_scm_ArrayBuilder$ofRef.prototype.equals__O__Z = (function(other) {
  return ((other instanceof $c_scm_ArrayBuilder$ofRef) && ((this.scm_ArrayBuilder__f_size === other.scm_ArrayBuilder__f_size) && (this.scm_ArrayBuilder$ofRef__f_elems === other.scm_ArrayBuilder$ofRef__f_elems)));
});
$c_scm_ArrayBuilder$ofRef.prototype.toString__T = (function() {
  return "ArrayBuilder.ofRef";
});
$c_scm_ArrayBuilder$ofRef.prototype.result__O = (function() {
  return this.result__AO();
});
$c_scm_ArrayBuilder$ofRef.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuilder$ofRef(elem);
});
$c_scm_ArrayBuilder$ofRef.prototype.elems__O = (function() {
  return this.scm_ArrayBuilder$ofRef__f_elems;
});
function $isArrayOf_scm_ArrayBuilder$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayBuilder$ofRef)));
}
export { $isArrayOf_scm_ArrayBuilder$ofRef as $isArrayOf_scm_ArrayBuilder$ofRef };
var $d_scm_ArrayBuilder$ofRef = new $TypeData().initClass($c_scm_ArrayBuilder$ofRef, "scala.collection.mutable.ArrayBuilder$ofRef", ({
  scm_ArrayBuilder$ofRef: 1,
  scm_ArrayBuilder: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArrayBuilder$ofRef as $d_scm_ArrayBuilder$ofRef };
function $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O($thiz, srcStart, dest, destStart, maxItems) {
  var until = ((1 + $m_jl_reflect_Array$().getLength__O__I(dest)) | 0);
  if (((destStart < 0) || (destStart >= until))) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(destStart, (((-1) + until) | 0));
  }
  var idx = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var a = ((((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $thiz.scm_ArrayDeque__f_array.u.length) | 0)) - srcStart) | 0);
  var b = (($m_jl_reflect_Array$().getLength__O__I(dest) - destStart) | 0);
  var b$1 = ((a < b) ? a : b);
  var toCopy = ((maxItems < b$1) ? maxItems : b$1);
  if ((toCopy > 0)) {
    var idx$1 = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var until$1 = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + $thiz.scm_ArrayDeque__f_array.u.length) | 0));
    if (((srcStart < 0) || (srcStart >= until$1))) {
      throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(srcStart, (((-1) + until$1) | 0));
    }
    var startIdx = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + srcStart) | 0) & (((-1) + $thiz.scm_ArrayDeque__f_array.u.length) | 0));
    var b$2 = (($thiz.scm_ArrayDeque__f_array.u.length - startIdx) | 0);
    var block1 = ((toCopy < b$2) ? toCopy : b$2);
    $m_s_Array$().copy__O__I__O__I__I__V($thiz.scm_ArrayDeque__f_array, startIdx, dest, destStart, block1);
    var block2 = ((toCopy - block1) | 0);
    if ((block2 > 0)) {
      $m_s_Array$().copy__O__I__O__I__I__V($thiz.scm_ArrayDeque__f_array, 0, dest, ((destStart + block1) | 0), block2);
    }
  }
  return dest;
}
export { $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O as $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O };
function $f_scm_ArrayDequeOps__reverse__O($thiz) {
  var idx = $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var n = ((($thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + $thiz.scm_ArrayDeque__f_array.u.length) | 0));
  var arr = $m_scm_ArrayDeque$().alloc__I__AO(n);
  var i = 0;
  while ((i < n)) {
    arr.u[i] = $thiz.apply__I__O((((-1) + ((n - i) | 0)) | 0));
    i = ((1 + i) | 0);
  }
  return $thiz.ofArray__AO__I__O(arr, n);
}
export { $f_scm_ArrayDequeOps__reverse__O as $f_scm_ArrayDequeOps__reverse__O };
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_current = 0;
  this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(this, self);
  this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount = (mutationCount.apply__O() | 0);
}
export { $c_scm_CheckedIndexedSeqView$CheckedIterator as $c_scm_CheckedIndexedSeqView$CheckedIterator };
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewIterator();
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedIterator() {
}
export { $h_scm_CheckedIndexedSeqView$CheckedIterator as $h_scm_CheckedIndexedSeqView$CheckedIterator };
$h_scm_CheckedIndexedSeqView$CheckedIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedIterator__f_expectedCount;
  var this$1 = this.scm_CheckedIndexedSeqView$CheckedIterator__f_mutationCount;
  var actualCount = (this$1.apply__O() | 0);
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewIterator$$remainder > 0);
});
var $d_scm_CheckedIndexedSeqView$CheckedIterator = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$CheckedIterator, "scala.collection.mutable.CheckedIndexedSeqView$CheckedIterator", ({
  scm_CheckedIndexedSeqView$CheckedIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_CheckedIndexedSeqView$CheckedIterator as $d_scm_CheckedIndexedSeqView$CheckedIterator };
/** @constructor */
function $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(self, mutationCount) {
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_self = null;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder = 0;
  this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_pos = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = 0;
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(this, self);
  this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount = (mutationCount.apply__O() | 0);
}
export { $c_scm_CheckedIndexedSeqView$CheckedReverseIterator as $c_scm_CheckedIndexedSeqView$CheckedReverseIterator };
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = new $h_sc_IndexedSeqView$IndexedSeqViewReverseIterator();
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.constructor = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$CheckedReverseIterator() {
}
export { $h_scm_CheckedIndexedSeqView$CheckedReverseIterator as $h_scm_CheckedIndexedSeqView$CheckedReverseIterator };
$h_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype = $c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype;
$c_scm_CheckedIndexedSeqView$CheckedReverseIterator.prototype.hasNext__Z = (function() {
  var this$2 = $m_scm_MutationTracker$();
  var expectedCount = this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_expectedCount;
  var this$1 = this.scm_CheckedIndexedSeqView$CheckedReverseIterator__f_mutationCount;
  var actualCount = (this$1.apply__O() | 0);
  this$2.checkMutations__I__I__T__V(expectedCount, actualCount, "mutation occurred during iteration");
  return (this.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0);
});
var $d_scm_CheckedIndexedSeqView$CheckedReverseIterator = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$CheckedReverseIterator, "scala.collection.mutable.CheckedIndexedSeqView$CheckedReverseIterator", ({
  scm_CheckedIndexedSeqView$CheckedReverseIterator: 1,
  sc_IndexedSeqView$IndexedSeqViewReverseIterator: 1,
  sc_AbstractIterator: 1,
  sc_Iterator: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_CheckedIndexedSeqView$CheckedReverseIterator as $d_scm_CheckedIndexedSeqView$CheckedReverseIterator };
/** @constructor */
function $c_s_math_Ordering$Boolean$() {
}
export { $c_s_math_Ordering$Boolean$ as $c_s_math_Ordering$Boolean$ };
$c_s_math_Ordering$Boolean$.prototype = new $h_O();
$c_s_math_Ordering$Boolean$.prototype.constructor = $c_s_math_Ordering$Boolean$;
/** @constructor */
function $h_s_math_Ordering$Boolean$() {
}
export { $h_s_math_Ordering$Boolean$ as $h_s_math_Ordering$Boolean$ };
$h_s_math_Ordering$Boolean$.prototype = $c_s_math_Ordering$Boolean$.prototype;
$c_s_math_Ordering$Boolean$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Boolean$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Boolean$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = (!(!x));
  var y$1 = (!(!y));
  return ((x$1 === y$1) ? 0 : (x$1 ? 1 : (-1)));
});
var $d_s_math_Ordering$Boolean$ = new $TypeData().initClass($c_s_math_Ordering$Boolean$, "scala.math.Ordering$Boolean$", ({
  s_math_Ordering$Boolean$: 1,
  s_math_Ordering$BooleanOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_Ordering$Boolean$ as $d_s_math_Ordering$Boolean$ };
var $n_s_math_Ordering$Boolean$;
function $m_s_math_Ordering$Boolean$() {
  if ((!$n_s_math_Ordering$Boolean$)) {
    $n_s_math_Ordering$Boolean$ = new $c_s_math_Ordering$Boolean$();
  }
  return $n_s_math_Ordering$Boolean$;
}
export { $m_s_math_Ordering$Boolean$ as $m_s_math_Ordering$Boolean$ };
/** @constructor */
function $c_s_math_Ordering$Byte$() {
}
export { $c_s_math_Ordering$Byte$ as $c_s_math_Ordering$Byte$ };
$c_s_math_Ordering$Byte$.prototype = new $h_O();
$c_s_math_Ordering$Byte$.prototype.constructor = $c_s_math_Ordering$Byte$;
/** @constructor */
function $h_s_math_Ordering$Byte$() {
}
export { $h_s_math_Ordering$Byte$ as $h_s_math_Ordering$Byte$ };
$h_s_math_Ordering$Byte$.prototype = $c_s_math_Ordering$Byte$.prototype;
$c_s_math_Ordering$Byte$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Byte$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Byte$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Ordering$Byte$ = new $TypeData().initClass($c_s_math_Ordering$Byte$, "scala.math.Ordering$Byte$", ({
  s_math_Ordering$Byte$: 1,
  s_math_Ordering$ByteOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_Ordering$Byte$ as $d_s_math_Ordering$Byte$ };
var $n_s_math_Ordering$Byte$;
function $m_s_math_Ordering$Byte$() {
  if ((!$n_s_math_Ordering$Byte$)) {
    $n_s_math_Ordering$Byte$ = new $c_s_math_Ordering$Byte$();
  }
  return $n_s_math_Ordering$Byte$;
}
export { $m_s_math_Ordering$Byte$ as $m_s_math_Ordering$Byte$ };
/** @constructor */
function $c_s_math_Ordering$Char$() {
}
export { $c_s_math_Ordering$Char$ as $c_s_math_Ordering$Char$ };
$c_s_math_Ordering$Char$.prototype = new $h_O();
$c_s_math_Ordering$Char$.prototype.constructor = $c_s_math_Ordering$Char$;
/** @constructor */
function $h_s_math_Ordering$Char$() {
}
export { $h_s_math_Ordering$Char$ as $h_s_math_Ordering$Char$ };
$h_s_math_Ordering$Char$.prototype = $c_s_math_Ordering$Char$.prototype;
$c_s_math_Ordering$Char$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Char$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Char$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Ordering$Char$ = new $TypeData().initClass($c_s_math_Ordering$Char$, "scala.math.Ordering$Char$", ({
  s_math_Ordering$Char$: 1,
  s_math_Ordering$CharOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_Ordering$Char$ as $d_s_math_Ordering$Char$ };
var $n_s_math_Ordering$Char$;
function $m_s_math_Ordering$Char$() {
  if ((!$n_s_math_Ordering$Char$)) {
    $n_s_math_Ordering$Char$ = new $c_s_math_Ordering$Char$();
  }
  return $n_s_math_Ordering$Char$;
}
export { $m_s_math_Ordering$Char$ as $m_s_math_Ordering$Char$ };
/** @constructor */
function $c_s_math_Ordering$Long$() {
}
export { $c_s_math_Ordering$Long$ as $c_s_math_Ordering$Long$ };
$c_s_math_Ordering$Long$.prototype = new $h_O();
$c_s_math_Ordering$Long$.prototype.constructor = $c_s_math_Ordering$Long$;
/** @constructor */
function $h_s_math_Ordering$Long$() {
}
export { $h_s_math_Ordering$Long$ as $h_s_math_Ordering$Long$ };
$h_s_math_Ordering$Long$.prototype = $c_s_math_Ordering$Long$.prototype;
$c_s_math_Ordering$Long$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Long$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Long$.prototype.compare__O__O__I = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
});
var $d_s_math_Ordering$Long$ = new $TypeData().initClass($c_s_math_Ordering$Long$, "scala.math.Ordering$Long$", ({
  s_math_Ordering$Long$: 1,
  s_math_Ordering$LongOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_Ordering$Long$ as $d_s_math_Ordering$Long$ };
var $n_s_math_Ordering$Long$;
function $m_s_math_Ordering$Long$() {
  if ((!$n_s_math_Ordering$Long$)) {
    $n_s_math_Ordering$Long$ = new $c_s_math_Ordering$Long$();
  }
  return $n_s_math_Ordering$Long$;
}
export { $m_s_math_Ordering$Long$ as $m_s_math_Ordering$Long$ };
/** @constructor */
function $c_s_math_Ordering$Short$() {
}
export { $c_s_math_Ordering$Short$ as $c_s_math_Ordering$Short$ };
$c_s_math_Ordering$Short$.prototype = new $h_O();
$c_s_math_Ordering$Short$.prototype.constructor = $c_s_math_Ordering$Short$;
/** @constructor */
function $h_s_math_Ordering$Short$() {
}
export { $h_s_math_Ordering$Short$ as $h_s_math_Ordering$Short$ };
$h_s_math_Ordering$Short$.prototype = $c_s_math_Ordering$Short$.prototype;
$c_s_math_Ordering$Short$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Short$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Short$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Ordering$Short$ = new $TypeData().initClass($c_s_math_Ordering$Short$, "scala.math.Ordering$Short$", ({
  s_math_Ordering$Short$: 1,
  s_math_Ordering$ShortOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_Ordering$Short$ as $d_s_math_Ordering$Short$ };
var $n_s_math_Ordering$Short$;
function $m_s_math_Ordering$Short$() {
  if ((!$n_s_math_Ordering$Short$)) {
    $n_s_math_Ordering$Short$ = new $c_s_math_Ordering$Short$();
  }
  return $n_s_math_Ordering$Short$;
}
export { $m_s_math_Ordering$Short$ as $m_s_math_Ordering$Short$ };
/** @constructor */
function $c_s_math_Ordering$String$() {
}
export { $c_s_math_Ordering$String$ as $c_s_math_Ordering$String$ };
$c_s_math_Ordering$String$.prototype = new $h_O();
$c_s_math_Ordering$String$.prototype.constructor = $c_s_math_Ordering$String$;
/** @constructor */
function $h_s_math_Ordering$String$() {
}
export { $h_s_math_Ordering$String$ as $h_s_math_Ordering$String$ };
$h_s_math_Ordering$String$.prototype = $c_s_math_Ordering$String$.prototype;
$c_s_math_Ordering$String$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$String$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$String$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$String$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$String$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$String$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$String$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$String$.prototype.compare__O__O__I = (function(x, y) {
  return $f_T__compareTo__T__I(x, y);
});
var $d_s_math_Ordering$String$ = new $TypeData().initClass($c_s_math_Ordering$String$, "scala.math.Ordering$String$", ({
  s_math_Ordering$String$: 1,
  s_math_Ordering$StringOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1
}));
export { $d_s_math_Ordering$String$ as $d_s_math_Ordering$String$ };
var $n_s_math_Ordering$String$;
function $m_s_math_Ordering$String$() {
  if ((!$n_s_math_Ordering$String$)) {
    $n_s_math_Ordering$String$ = new $c_s_math_Ordering$String$();
  }
  return $n_s_math_Ordering$String$;
}
export { $m_s_math_Ordering$String$ as $m_s_math_Ordering$String$ };
/** @constructor */
function $c_s_reflect_AnyValManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
export { $c_s_reflect_AnyValManifest as $c_s_reflect_AnyValManifest };
$c_s_reflect_AnyValManifest.prototype = new $h_O();
$c_s_reflect_AnyValManifest.prototype.constructor = $c_s_reflect_AnyValManifest;
/** @constructor */
function $h_s_reflect_AnyValManifest() {
}
export { $h_s_reflect_AnyValManifest as $h_s_reflect_AnyValManifest };
$h_s_reflect_AnyValManifest.prototype = $c_s_reflect_AnyValManifest.prototype;
$c_s_reflect_AnyValManifest.prototype.toString__T = (function() {
  return this.s_reflect_AnyValManifest__f_toString;
});
$c_s_reflect_AnyValManifest.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_s_reflect_AnyValManifest.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ClassTypeManifest() {
}
export { $c_s_reflect_ManifestFactory$ClassTypeManifest as $c_s_reflect_ManifestFactory$ClassTypeManifest };
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype = new $h_O();
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ClassTypeManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ClassTypeManifest() {
}
export { $h_s_reflect_ManifestFactory$ClassTypeManifest as $h_s_reflect_ManifestFactory$ClassTypeManifest };
$h_s_reflect_ManifestFactory$ClassTypeManifest.prototype = $c_s_reflect_ManifestFactory$ClassTypeManifest.prototype;
$c_s_reflect_ManifestFactory$ClassTypeManifest.prototype.unapply__O__s_Option = (function(x) {
  return $f_s_reflect_ClassTag__unapply__O__s_Option(this, x);
});
class $c_sjs_js_JavaScriptException extends $c_jl_RuntimeException {
  constructor(exception) {
    super();
    this.sjs_js_JavaScriptException__f_exception = null;
    this.sjs_js_JavaScriptException__f_exception = exception;
    $ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, null, null, true, true);
  }
  getMessage__T() {
    return $dp_toString__T(this.sjs_js_JavaScriptException__f_exception);
  }
  productPrefix__T() {
    return "JavaScriptException";
  }
  productArity__I() {
    return 1;
  }
  productElement__I__O(x$1) {
    return ((x$1 === 0) ? this.sjs_js_JavaScriptException__f_exception : $m_sr_Statics$().ioobe__I__O(x$1));
  }
  productIterator__sc_Iterator() {
    return new $c_sr_ScalaRunTime$$anon$1(this);
  }
  productElementName__I__T(x$1) {
    return ((x$1 === 0) ? "exception" : $m_sr_Statics$().ioobe__I__O(x$1));
  }
  hashCode__I() {
    return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1744042595, true);
  }
  equals__O__Z(x$1) {
    if ((this === x$1)) {
      return true;
    } else if ((x$1 instanceof $c_sjs_js_JavaScriptException)) {
      var x = this.sjs_js_JavaScriptException__f_exception;
      var y = x$1.sjs_js_JavaScriptException__f_exception;
      return $m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
    } else {
      return false;
    }
  }
}
export { $c_sjs_js_JavaScriptException as $c_sjs_js_JavaScriptException };
function $isArrayOf_sjs_js_JavaScriptException(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjs_js_JavaScriptException)));
}
export { $isArrayOf_sjs_js_JavaScriptException as $isArrayOf_sjs_js_JavaScriptException };
var $d_sjs_js_JavaScriptException = new $TypeData().initClass($c_sjs_js_JavaScriptException, "scala.scalajs.js.JavaScriptException", ({
  sjs_js_JavaScriptException: 1,
  jl_RuntimeException: 1,
  jl_Exception: 1,
  jl_Throwable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
}));
export { $d_sjs_js_JavaScriptException as $d_sjs_js_JavaScriptException };
/** @constructor */
function $c_Lscodec_bits_ByteVector$Buffer(id, stamp, hd, lastChunk, lastSize) {
  this.Lscodec_bits_ByteVector__f_hashCode$lzy1 = 0;
  this.Lscodec_bits_ByteVector__f_hashCodebitmap$1 = false;
  this.Lscodec_bits_ByteVector$Buffer__f_id = null;
  this.Lscodec_bits_ByteVector$Buffer__f_stamp = $L0;
  this.Lscodec_bits_ByteVector$Buffer__f_hd = null;
  this.Lscodec_bits_ByteVector$Buffer__f_lastChunk = null;
  this.Lscodec_bits_ByteVector$Buffer__f_lastSize = 0;
  this.Lscodec_bits_ByteVector$Buffer__f_id = id;
  this.Lscodec_bits_ByteVector$Buffer__f_stamp = stamp;
  this.Lscodec_bits_ByteVector$Buffer__f_hd = hd;
  this.Lscodec_bits_ByteVector$Buffer__f_lastChunk = lastChunk;
  this.Lscodec_bits_ByteVector$Buffer__f_lastSize = lastSize;
}
export { $c_Lscodec_bits_ByteVector$Buffer as $c_Lscodec_bits_ByteVector$Buffer };
$c_Lscodec_bits_ByteVector$Buffer.prototype = new $h_Lscodec_bits_ByteVector();
$c_Lscodec_bits_ByteVector$Buffer.prototype.constructor = $c_Lscodec_bits_ByteVector$Buffer;
/** @constructor */
function $h_Lscodec_bits_ByteVector$Buffer() {
}
export { $h_Lscodec_bits_ByteVector$Buffer as $h_Lscodec_bits_ByteVector$Buffer };
$h_Lscodec_bits_ByteVector$Buffer.prototype = $c_Lscodec_bits_ByteVector$Buffer.prototype;
$c_Lscodec_bits_ByteVector$Buffer.prototype.size__J = (function() {
  var a = this.Lscodec_bits_ByteVector$Buffer__f_hd.size__J();
  var value = this.Lscodec_bits_ByteVector$Buffer__f_lastSize;
  var hi = (value >> 31);
  var alo = a.RTLong__f_lo;
  var lo = ((alo + value) | 0);
  var hi$1 = ((((a.RTLong__f_hi + hi) | 0) + ((((alo & value) | ((alo | value) & (~lo))) >>> 31) | 0)) | 0);
  return new $c_RTLong(lo, hi$1);
});
$c_Lscodec_bits_ByteVector$Buffer.prototype.take__J__Lscodec_bits_ByteVector = (function(n) {
  var b = this.Lscodec_bits_ByteVector$Buffer__f_hd.size__J();
  var ahi = n.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? ((n.RTLong__f_lo >>> 0) <= (b.RTLong__f_lo >>> 0)) : (ahi < bhi))) {
    return this.Lscodec_bits_ByteVector$Buffer__f_hd.take__J__Lscodec_bits_ByteVector(n);
  } else {
    var $x_2 = this.Lscodec_bits_ByteVector$Buffer__f_hd;
    var $x_1 = this.lastBytes__Lscodec_bits_ByteVector();
    var b$1 = this.Lscodec_bits_ByteVector$Buffer__f_hd.size__J();
    var alo = n.RTLong__f_lo;
    var blo = b$1.RTLong__f_lo;
    var lo = ((alo - blo) | 0);
    var hi = ((((n.RTLong__f_hi - b$1.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
    return $x_2.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector($x_1.take__J__Lscodec_bits_ByteVector(new $c_RTLong(lo, hi)));
  }
});
$c_Lscodec_bits_ByteVector$Buffer.prototype.drop__J__Lscodec_bits_ByteVector = (function(n) {
  var b = this.Lscodec_bits_ByteVector$Buffer__f_hd.size__J();
  var ahi = n.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? ((n.RTLong__f_lo >>> 0) <= (b.RTLong__f_lo >>> 0)) : (ahi < bhi))) {
    var id = this.Lscodec_bits_ByteVector$Buffer__f_id;
    var t = this.Lscodec_bits_ByteVector$Buffer__f_stamp;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var hd = this.Lscodec_bits_ByteVector$Buffer__f_hd.drop__J__Lscodec_bits_ByteVector(n);
    var lastChunk = this.Lscodec_bits_ByteVector$Buffer__f_lastChunk;
    var lastSize = this.Lscodec_bits_ByteVector$Buffer__f_lastSize;
    return new $c_Lscodec_bits_ByteVector$Buffer(id, new $c_RTLong(lo, hi), hd.unbuffer__Lscodec_bits_ByteVector(), lastChunk, lastSize);
  } else {
    return this.unbuffer__Lscodec_bits_ByteVector().drop__J__Lscodec_bits_ByteVector(n).bufferBy__I__Lscodec_bits_ByteVector(this.Lscodec_bits_ByteVector$Buffer__f_lastChunk.u.length);
  }
});
$c_Lscodec_bits_ByteVector$Buffer.prototype.getImpl__J__B = (function(n) {
  var b = this.Lscodec_bits_ByteVector$Buffer__f_hd.size__J();
  var ahi = n.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? ((n.RTLong__f_lo >>> 0) < (b.RTLong__f_lo >>> 0)) : (ahi < bhi))) {
    return this.Lscodec_bits_ByteVector$Buffer__f_hd.getImpl__J__B(n);
  } else {
    var $x_1 = this.Lscodec_bits_ByteVector$Buffer__f_lastChunk;
    var b$1 = this.Lscodec_bits_ByteVector$Buffer__f_hd.size__J();
    var alo = n.RTLong__f_lo;
    var blo = b$1.RTLong__f_lo;
    var lo = ((alo - blo) | 0);
    return $x_1.u[lo];
  }
});
$c_Lscodec_bits_ByteVector$Buffer.prototype.$colon$plus__B__Lscodec_bits_ByteVector = (function(b) {
  var $x_2 = this.Lscodec_bits_ByteVector$Buffer__f_id;
  var $x_1 = this.Lscodec_bits_ByteVector$Buffer__f_stamp;
  var b$1 = this.Lscodec_bits_ByteVector$Buffer__f_stamp;
  var blo = b$1.RTLong__f_lo;
  var lo = ((1 + blo) | 0);
  var hi = ((b$1.RTLong__f_hi + (((blo & (~lo)) >>> 31) | 0)) | 0);
  if (($x_2.compareAndSet__J__J__Z($x_1, new $c_RTLong(lo, hi)) && (this.Lscodec_bits_ByteVector$Buffer__f_lastSize < this.Lscodec_bits_ByteVector$Buffer__f_lastChunk.u.length))) {
    this.Lscodec_bits_ByteVector$Buffer__f_lastChunk.u[this.Lscodec_bits_ByteVector$Buffer__f_lastSize] = b;
    var id = this.Lscodec_bits_ByteVector$Buffer__f_id;
    var b$2 = this.Lscodec_bits_ByteVector$Buffer__f_stamp;
    var blo$1 = b$2.RTLong__f_lo;
    var lo$1 = ((1 + blo$1) | 0);
    var hi$1 = ((b$2.RTLong__f_hi + (((blo$1 & (~lo$1)) >>> 31) | 0)) | 0);
    var hd = this.Lscodec_bits_ByteVector$Buffer__f_hd;
    var lastChunk = this.Lscodec_bits_ByteVector$Buffer__f_lastChunk;
    var lastSize = ((1 + this.Lscodec_bits_ByteVector$Buffer__f_lastSize) | 0);
    return new $c_Lscodec_bits_ByteVector$Buffer(id, new $c_RTLong(lo$1, hi$1), hd.unbuffer__Lscodec_bits_ByteVector(), lastChunk, lastSize);
  } else {
    var id$1 = new $c_ju_concurrent_atomic_AtomicLong($L0);
    var hd$1 = this.unbuffer__Lscodec_bits_ByteVector();
    var dimensions = new $ac_I(new Int32Array([this.Lscodec_bits_ByteVector$Buffer__f_lastChunk.u.length]));
    var lastChunk$1 = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_B.getClassOf(), dimensions);
    return new $c_Lscodec_bits_ByteVector$Buffer(id$1, $L0, hd$1.unbuffer__Lscodec_bits_ByteVector(), lastChunk$1, 0).$colon$plus__B__Lscodec_bits_ByteVector(b);
  }
});
$c_Lscodec_bits_ByteVector$Buffer.prototype.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector = (function(bs) {
  if (bs.isEmpty__Z()) {
    return this;
  } else if (this.isEmpty__Z()) {
    return bs;
  } else {
    var $x_3 = this.Lscodec_bits_ByteVector$Buffer__f_id;
    var $x_2 = this.Lscodec_bits_ByteVector$Buffer__f_stamp;
    var b = this.Lscodec_bits_ByteVector$Buffer__f_stamp;
    var blo = b.RTLong__f_lo;
    var lo = ((1 + blo) | 0);
    var hi = ((b.RTLong__f_hi + (((blo & (~lo)) >>> 31) | 0)) | 0);
    if ($x_3.compareAndSet__J__J__Z($x_2, new $c_RTLong(lo, hi))) {
      var value = ((this.Lscodec_bits_ByteVector$Buffer__f_lastChunk.u.length - this.Lscodec_bits_ByteVector$Buffer__f_lastSize) | 0);
      var hi$1 = (value >> 31);
      var b$1 = bs.size__J();
      var bhi = b$1.RTLong__f_hi;
      var $x_1 = ((hi$1 === bhi) ? ((value >>> 0) > (b$1.RTLong__f_lo >>> 0)) : (hi$1 > bhi));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      bs.copyToArray__AB__I__V(this.Lscodec_bits_ByteVector$Buffer__f_lastChunk, this.Lscodec_bits_ByteVector$Buffer__f_lastSize);
      var id = this.Lscodec_bits_ByteVector$Buffer__f_id;
      var b$2 = this.Lscodec_bits_ByteVector$Buffer__f_stamp;
      var blo$1 = b$2.RTLong__f_lo;
      var lo$1 = ((1 + blo$1) | 0);
      var hi$2 = ((b$2.RTLong__f_hi + (((blo$1 & (~lo$1)) >>> 31) | 0)) | 0);
      var hd = this.Lscodec_bits_ByteVector$Buffer__f_hd;
      var lastChunk = this.Lscodec_bits_ByteVector$Buffer__f_lastChunk;
      var $x_4 = this.Lscodec_bits_ByteVector$Buffer__f_lastSize;
      var a = bs.size__J();
      var lastSize = (($x_4 + a.RTLong__f_lo) | 0);
      return new $c_Lscodec_bits_ByteVector$Buffer(id, new $c_RTLong(lo$1, hi$2), hd.unbuffer__Lscodec_bits_ByteVector(), lastChunk, lastSize);
    } else if ((this.Lscodec_bits_ByteVector$Buffer__f_lastSize === 0)) {
      var id$1 = this.Lscodec_bits_ByteVector$Buffer__f_id;
      var t = this.Lscodec_bits_ByteVector$Buffer__f_stamp;
      var lo$2 = t.RTLong__f_lo;
      var hi$3 = t.RTLong__f_hi;
      var hd$1 = this.Lscodec_bits_ByteVector$Buffer__f_hd.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(bs).unbuffer__Lscodec_bits_ByteVector();
      var lastChunk$1 = this.Lscodec_bits_ByteVector$Buffer__f_lastChunk;
      var lastSize$1 = this.Lscodec_bits_ByteVector$Buffer__f_lastSize;
      return new $c_Lscodec_bits_ByteVector$Buffer(id$1, new $c_RTLong(lo$2, hi$3), hd$1.unbuffer__Lscodec_bits_ByteVector(), lastChunk$1, lastSize$1);
    } else {
      var id$2 = new $c_ju_concurrent_atomic_AtomicLong($L0);
      var hd$2 = this.unbuffer__Lscodec_bits_ByteVector();
      var dimensions = new $ac_I(new Int32Array([this.Lscodec_bits_ByteVector$Buffer__f_lastChunk.u.length]));
      var lastChunk$2 = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_B.getClassOf(), dimensions);
      return new $c_Lscodec_bits_ByteVector$Buffer(id$2, $L0, hd$2.unbuffer__Lscodec_bits_ByteVector(), lastChunk$2, 0).$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(bs);
    }
  }
});
$c_Lscodec_bits_ByteVector$Buffer.prototype.lastBytes__Lscodec_bits_ByteVector = (function() {
  var $x_1 = $m_Lscodec_bits_ByteVector$().view__AB__Lscodec_bits_ByteVector(this.Lscodec_bits_ByteVector$Buffer__f_lastChunk);
  var value = this.Lscodec_bits_ByteVector$Buffer__f_lastSize;
  var hi = (value >> 31);
  return $x_1.take__J__Lscodec_bits_ByteVector(new $c_RTLong(value, hi));
});
$c_Lscodec_bits_ByteVector$Buffer.prototype.unbuffer__Lscodec_bits_ByteVector = (function() {
  return this.Lscodec_bits_ByteVector$Buffer__f_hd.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector((((this.Lscodec_bits_ByteVector$Buffer__f_lastSize << 1) < this.Lscodec_bits_ByteVector$Buffer__f_lastChunk.u.length) ? this.lastBytes__Lscodec_bits_ByteVector().copy__Lscodec_bits_ByteVector() : this.lastBytes__Lscodec_bits_ByteVector()));
});
$c_Lscodec_bits_ByteVector$Buffer.prototype.rebuffer__I__Lscodec_bits_ByteVector = (function(chunkSize) {
  $m_s_Predef$().require__Z__V((chunkSize > this.Lscodec_bits_ByteVector$Buffer__f_lastChunk.u.length));
  var dimensions = new $ac_I(new Int32Array([chunkSize]));
  var lastChunk2 = $m_jl_reflect_Array$().newInstance__jl_Class__AI__O($d_B.getClassOf(), dimensions);
  var xs = this.Lscodec_bits_ByteVector$Buffer__f_lastChunk;
  $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, lastChunk2, 0, lastChunk2.u.length);
  var id = new $c_ju_concurrent_atomic_AtomicLong($L0);
  var hd = this.Lscodec_bits_ByteVector$Buffer__f_hd;
  var lastChunk = this.Lscodec_bits_ByteVector$Buffer__f_lastChunk;
  var lastSize = this.Lscodec_bits_ByteVector$Buffer__f_lastSize;
  return new $c_Lscodec_bits_ByteVector$Buffer(id, $L0, hd.unbuffer__Lscodec_bits_ByteVector(), lastChunk, lastSize);
});
function $isArrayOf_Lscodec_bits_ByteVector$Buffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_ByteVector$Buffer)));
}
export { $isArrayOf_Lscodec_bits_ByteVector$Buffer as $isArrayOf_Lscodec_bits_ByteVector$Buffer };
var $d_Lscodec_bits_ByteVector$Buffer = new $TypeData().initClass($c_Lscodec_bits_ByteVector$Buffer, "scodec.bits.ByteVector$Buffer", ({
  Lscodec_bits_ByteVector$Buffer: 1,
  Lscodec_bits_ByteVector: 1,
  Lscodec_bits_ByteVectorCrossPlatform: 1,
  Lscodec_bits_BitwiseOperations: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lscodec_bits_ByteVector$Buffer as $d_Lscodec_bits_ByteVector$Buffer };
/** @constructor */
function $c_Lsquants_space_Length(value, unit) {
  this.Lsquants_space_Length__f_value = 0.0;
  this.Lsquants_space_Length__f_unit = null;
  this.Lsquants_space_Length__f_value = value;
  this.Lsquants_space_Length__f_unit = unit;
}
export { $c_Lsquants_space_Length as $c_Lsquants_space_Length };
$c_Lsquants_space_Length.prototype = new $h_Lsquants_Quantity();
$c_Lsquants_space_Length.prototype.constructor = $c_Lsquants_space_Length;
/** @constructor */
function $h_Lsquants_space_Length() {
}
export { $h_Lsquants_space_Length as $h_Lsquants_space_Length };
$h_Lsquants_space_Length.prototype = $c_Lsquants_space_Length.prototype;
var $d_Lsquants_space_Length = new $TypeData().initClass($c_Lsquants_space_Length, "squants.space.Length", ({
  Lsquants_space_Length: 1,
  Lsquants_Quantity: 1,
  Ljava_io_Serializable: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Lsquants_time_TimeIntegral: 1,
  Lsquants_time_SecondTimeIntegral: 1
}));
export { $d_Lsquants_space_Length as $d_Lsquants_space_Length };
function $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval($thiz, width$1, G$1, f$10, as$1, start, end) {
  if ((((end - start) | 0) <= width$1)) {
    $m_Lcats_Eval$();
    var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => G$1.map__O__F1__O(f$10.apply__O__O(as$1.apply__I__O((((-1) + end) | 0))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$5) => {
      var this$1 = $m_sci_Nil$();
      return new $c_sci_$colon$colon(_$5, this$1);
    })))));
    var flist = new $c_Lcats_Later(a);
    var idx = (((-2) + end) | 0);
    while ((start <= idx)) {
      var a$1 = as$1.apply__I__O(idx);
      var right = flist;
      $m_Lcats_Eval$();
      var a$2 = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1(((G$1, f$10, a$1, right) => (() => G$1.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f$10.apply__O__O(a$1), right, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$6, _$7) => new $c_sci_$colon$colon(_$6, _$7))))))(G$1, f$10, a$1, right));
      flist = new $c_Lcats_Eval$$anon$5(a$2);
      idx = (((-1) + idx) | 0);
    }
    return flist.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((glist) => G$1.map__O__F1__O(glist, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => {
      var this$4 = $m_Lcats_data_Chain$();
      return $f_Lcats_data_ChainCompanionCompat__fromSeq__sci_Seq__Lcats_data_Chain(this$4, _$8);
    }))))));
  } else {
    var step = ((((end - start) | 0) / $checkIntDivisor(width$1)) | 0);
    $m_Lcats_Eval$();
    var a$3 = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval($thiz, width$1, G$1, f$10, as$1, start, ((start + step) | 0))));
    var fchain = new $c_Lcats_Eval$$anon$5(a$3);
    var start0 = ((start + step) | 0);
    var end0 = ((start0 + step) | 0);
    while ((start0 < end)) {
      var y = end0;
      var end1 = ((end < y) ? end : y);
      var right$3 = $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval($thiz, width$1, G$1, f$10, as$1, start0, end1);
      fchain = fchain.flatMap__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((G$1, right$3) => ((_$9) => G$1.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(_$9, right$3, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$10, _$11) => $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(_$10, _$11))))))(G$1, right$3)));
      start0 = ((start0 + step) | 0);
      end0 = ((end0 + step) | 0);
    }
    return fchain;
  }
}
export { $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval as $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval };
/** @constructor */
function $c_Lcats_data_Chain$() {
  this.Lcats_data_ChainInstances__f_catsDataInstancesForChain = null;
  this.Lcats_data_Chain$__f_cats$data$Chain$$$sentinel = null;
  this.Lcats_data_Chain$__f_nil = null;
  $ct_Lcats_data_ChainInstances__(this);
  $n_Lcats_data_Chain$ = this;
  this.Lcats_data_Chain$__f_cats$data$Chain$$$sentinel = new $c_Lcats_data_Chain$$anon$2();
  this.Lcats_data_Chain$__f_nil = $m_Lcats_data_Chain$Empty$();
}
export { $c_Lcats_data_Chain$ as $c_Lcats_data_Chain$ };
$c_Lcats_data_Chain$.prototype = new $h_Lcats_data_ChainInstances();
$c_Lcats_data_Chain$.prototype.constructor = $c_Lcats_data_Chain$;
/** @constructor */
function $h_Lcats_data_Chain$() {
}
export { $h_Lcats_data_Chain$ as $h_Lcats_data_Chain$ };
$h_Lcats_data_Chain$.prototype = $c_Lcats_data_Chain$.prototype;
$c_Lcats_data_Chain$.prototype.concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain = (function(c, c2) {
  return ((c instanceof $c_Lcats_data_Chain$NonEmpty) ? ((c2 instanceof $c_Lcats_data_Chain$NonEmpty) ? $ct_Lcats_data_Chain$Append__Lcats_data_Chain$NonEmpty__Lcats_data_Chain$NonEmpty__(new $c_Lcats_data_Chain$Append(), c, c2) : c) : c2);
});
$c_Lcats_data_Chain$.prototype.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O = (function(as, f, G) {
  return (as.isEmpty__Z() ? G.pure__O__O($m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil) : $p_Lcats_data_Chain$__loop$4__I__Lcats_Applicative__F1__sci_IndexedSeq__I__I__Lcats_Eval(this, 128, G, f, as, 0, as.length__I()).value__O());
});
$c_Lcats_data_Chain$.prototype.ordinal__Lcats_data_Chain__I = (function(x$0) {
  if ((x$0 instanceof $c_Lcats_data_Chain$NonEmpty)) {
    return 0;
  }
  if ((x$0 === $m_Lcats_data_Chain$Empty$())) {
    return 1;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lcats_data_Chain$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcats_data_Chain__I(x);
});
var $d_Lcats_data_Chain$ = new $TypeData().initClass($c_Lcats_data_Chain$, "cats.data.Chain$", ({
  Lcats_data_Chain$: 1,
  Lcats_data_ChainInstances: 1,
  Lcats_data_ChainInstances1: 1,
  Lcats_data_ChainInstances2: 1,
  Lcats_data_ChainInstances3: 1,
  Lcats_data_ChainCompanionCompat: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lcats_data_Chain$ as $d_Lcats_data_Chain$ };
var $n_Lcats_data_Chain$;
function $m_Lcats_data_Chain$() {
  if ((!$n_Lcats_data_Chain$)) {
    $n_Lcats_data_Chain$ = new $c_Lcats_data_Chain$();
  }
  return $n_Lcats_data_Chain$;
}
export { $m_Lcats_data_Chain$ as $m_Lcats_data_Chain$ };
/** @constructor */
function $c_Lcats_data_Validated$() {
  this.Lcats_data_Validated$__f_validUnit = null;
  $ct_Lcats_data_ValidatedInstances__(this);
  $n_Lcats_data_Validated$ = this;
  this.Lcats_data_Validated$__f_validUnit = new $c_Lcats_data_Validated$Valid((void 0));
}
export { $c_Lcats_data_Validated$ as $c_Lcats_data_Validated$ };
$c_Lcats_data_Validated$.prototype = new $h_Lcats_data_ValidatedInstances();
$c_Lcats_data_Validated$.prototype.constructor = $c_Lcats_data_Validated$;
/** @constructor */
function $h_Lcats_data_Validated$() {
}
export { $h_Lcats_data_Validated$ as $h_Lcats_data_Validated$ };
$h_Lcats_data_Validated$.prototype = $c_Lcats_data_Validated$.prototype;
$c_Lcats_data_Validated$.prototype.ordinal__Lcats_data_Validated__I = (function(x$0) {
  if ((x$0 instanceof $c_Lcats_data_Validated$Valid)) {
    return 0;
  }
  if ((x$0 instanceof $c_Lcats_data_Validated$Invalid)) {
    return 1;
  }
  throw new $c_s_MatchError(x$0);
});
$c_Lcats_data_Validated$.prototype.ordinal__O__I = (function(x) {
  return this.ordinal__Lcats_data_Validated__I(x);
});
var $d_Lcats_data_Validated$ = new $TypeData().initClass($c_Lcats_data_Validated$, "cats.data.Validated$", ({
  Lcats_data_Validated$: 1,
  Lcats_data_ValidatedInstances: 1,
  Lcats_data_ValidatedInstances1: 1,
  Lcats_data_ValidatedInstances2: 1,
  Lcats_data_ValidatedFunctions: 1,
  Lcats_data_ValidatedFunctionsBinCompat0: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lcats_data_Validated$ as $d_Lcats_data_Validated$ };
var $n_Lcats_data_Validated$;
function $m_Lcats_data_Validated$() {
  if ((!$n_Lcats_data_Validated$)) {
    $n_Lcats_data_Validated$ = new $c_Lcats_data_Validated$();
  }
  return $n_Lcats_data_Validated$;
}
export { $m_Lcats_data_Validated$ as $m_Lcats_data_Validated$ };
/** @constructor */
function $c_Lcats_effect_SyncIO$Monotonic$() {
}
export { $c_Lcats_effect_SyncIO$Monotonic$ as $c_Lcats_effect_SyncIO$Monotonic$ };
$c_Lcats_effect_SyncIO$Monotonic$.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$Monotonic$.prototype.constructor = $c_Lcats_effect_SyncIO$Monotonic$;
/** @constructor */
function $h_Lcats_effect_SyncIO$Monotonic$() {
}
export { $h_Lcats_effect_SyncIO$Monotonic$ as $h_Lcats_effect_SyncIO$Monotonic$ };
$h_Lcats_effect_SyncIO$Monotonic$.prototype = $c_Lcats_effect_SyncIO$Monotonic$.prototype;
$c_Lcats_effect_SyncIO$Monotonic$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.hashCode__I = (function() {
  return 572915850;
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.productPrefix__T = (function() {
  return "Monotonic";
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.tag__B = (function() {
  return 10;
});
$c_Lcats_effect_SyncIO$Monotonic$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_SyncIO$Monotonic$ = new $TypeData().initClass($c_Lcats_effect_SyncIO$Monotonic$, "cats.effect.SyncIO$Monotonic$", ({
  Lcats_effect_SyncIO$Monotonic$: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_SyncIO$Monotonic$ as $d_Lcats_effect_SyncIO$Monotonic$ };
var $n_Lcats_effect_SyncIO$Monotonic$;
function $m_Lcats_effect_SyncIO$Monotonic$() {
  if ((!$n_Lcats_effect_SyncIO$Monotonic$)) {
    $n_Lcats_effect_SyncIO$Monotonic$ = new $c_Lcats_effect_SyncIO$Monotonic$();
  }
  return $n_Lcats_effect_SyncIO$Monotonic$;
}
export { $m_Lcats_effect_SyncIO$Monotonic$ as $m_Lcats_effect_SyncIO$Monotonic$ };
/** @constructor */
function $c_Lcats_effect_SyncIO$RealTime$() {
}
export { $c_Lcats_effect_SyncIO$RealTime$ as $c_Lcats_effect_SyncIO$RealTime$ };
$c_Lcats_effect_SyncIO$RealTime$.prototype = new $h_Lcats_effect_SyncIO();
$c_Lcats_effect_SyncIO$RealTime$.prototype.constructor = $c_Lcats_effect_SyncIO$RealTime$;
/** @constructor */
function $h_Lcats_effect_SyncIO$RealTime$() {
}
export { $h_Lcats_effect_SyncIO$RealTime$ as $h_Lcats_effect_SyncIO$RealTime$ };
$h_Lcats_effect_SyncIO$RealTime$.prototype = $c_Lcats_effect_SyncIO$RealTime$.prototype;
$c_Lcats_effect_SyncIO$RealTime$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.hashCode__I = (function() {
  return (-795507285);
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productPrefix__T = (function() {
  return "RealTime";
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.tag__B = (function() {
  return 9;
});
$c_Lcats_effect_SyncIO$RealTime$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_SyncIO$RealTime$ = new $TypeData().initClass($c_Lcats_effect_SyncIO$RealTime$, "cats.effect.SyncIO$RealTime$", ({
  Lcats_effect_SyncIO$RealTime$: 1,
  Lcats_effect_SyncIO: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_SyncIO$RealTime$ as $d_Lcats_effect_SyncIO$RealTime$ };
var $n_Lcats_effect_SyncIO$RealTime$;
function $m_Lcats_effect_SyncIO$RealTime$() {
  if ((!$n_Lcats_effect_SyncIO$RealTime$)) {
    $n_Lcats_effect_SyncIO$RealTime$ = new $c_Lcats_effect_SyncIO$RealTime$();
  }
  return $n_Lcats_effect_SyncIO$RealTime$;
}
export { $m_Lcats_effect_SyncIO$RealTime$ as $m_Lcats_effect_SyncIO$RealTime$ };
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$Blocking$() {
}
export { $c_Lcats_effect_kernel_Sync$Type$Blocking$ as $c_Lcats_effect_kernel_Sync$Type$Blocking$ };
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$Blocking$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$Blocking$() {
}
export { $h_Lcats_effect_kernel_Sync$Type$Blocking$ as $h_Lcats_effect_kernel_Sync$Type$Blocking$ };
$h_Lcats_effect_kernel_Sync$Type$Blocking$.prototype = $c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype;
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.hashCode__I = (function() {
  return (-599928747);
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.toString__T = (function() {
  return "Blocking";
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productPrefix__T = (function() {
  return "Blocking";
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Sync$Type$Blocking$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_kernel_Sync$Type$Blocking$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$Blocking$, "cats.effect.kernel.Sync$Type$Blocking$", ({
  Lcats_effect_kernel_Sync$Type$Blocking$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_kernel_Sync$Type$Blocking$ as $d_Lcats_effect_kernel_Sync$Type$Blocking$ };
var $n_Lcats_effect_kernel_Sync$Type$Blocking$;
function $m_Lcats_effect_kernel_Sync$Type$Blocking$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$Blocking$)) {
    $n_Lcats_effect_kernel_Sync$Type$Blocking$ = new $c_Lcats_effect_kernel_Sync$Type$Blocking$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$Blocking$;
}
export { $m_Lcats_effect_kernel_Sync$Type$Blocking$ as $m_Lcats_effect_kernel_Sync$Type$Blocking$ };
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$Delay$() {
}
export { $c_Lcats_effect_kernel_Sync$Type$Delay$ as $c_Lcats_effect_kernel_Sync$Type$Delay$ };
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$Delay$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$Delay$() {
}
export { $h_Lcats_effect_kernel_Sync$Type$Delay$ as $h_Lcats_effect_kernel_Sync$Type$Delay$ };
$h_Lcats_effect_kernel_Sync$Type$Delay$.prototype = $c_Lcats_effect_kernel_Sync$Type$Delay$.prototype;
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.hashCode__I = (function() {
  return 65915235;
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.toString__T = (function() {
  return "Delay";
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productPrefix__T = (function() {
  return "Delay";
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Sync$Type$Delay$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_kernel_Sync$Type$Delay$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$Delay$, "cats.effect.kernel.Sync$Type$Delay$", ({
  Lcats_effect_kernel_Sync$Type$Delay$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_kernel_Sync$Type$Delay$ as $d_Lcats_effect_kernel_Sync$Type$Delay$ };
var $n_Lcats_effect_kernel_Sync$Type$Delay$;
function $m_Lcats_effect_kernel_Sync$Type$Delay$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$Delay$)) {
    $n_Lcats_effect_kernel_Sync$Type$Delay$ = new $c_Lcats_effect_kernel_Sync$Type$Delay$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$Delay$;
}
export { $m_Lcats_effect_kernel_Sync$Type$Delay$ as $m_Lcats_effect_kernel_Sync$Type$Delay$ };
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
}
export { $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ as $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ };
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
}
export { $h_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ as $h_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ };
$h_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype = $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype;
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.hashCode__I = (function() {
  return 430282004;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.toString__T = (function() {
  return "InterruptibleMany";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productPrefix__T = (function() {
  return "InterruptibleMany";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$, "cats.effect.kernel.Sync$Type$InterruptibleMany$", ({
  Lcats_effect_kernel_Sync$Type$InterruptibleMany$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ as $d_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ };
var $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
function $m_Lcats_effect_kernel_Sync$Type$InterruptibleMany$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$)) {
    $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ = new $c_Lcats_effect_kernel_Sync$Type$InterruptibleMany$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$InterruptibleMany$;
}
export { $m_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ as $m_Lcats_effect_kernel_Sync$Type$InterruptibleMany$ };
/** @constructor */
function $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
}
export { $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ as $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ };
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype = new $h_O();
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.constructor = $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
/** @constructor */
function $h_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
}
export { $h_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ as $h_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ };
$h_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype = $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype;
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.hashCode__I = (function() {
  return 430353718;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.toString__T = (function() {
  return "InterruptibleOnce";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productPrefix__T = (function() {
  return "InterruptibleOnce";
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ = new $TypeData().initClass($c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$, "cats.effect.kernel.Sync$Type$InterruptibleOnce$", ({
  Lcats_effect_kernel_Sync$Type$InterruptibleOnce$: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lcats_effect_kernel_Sync$Type: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ as $d_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ };
var $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
function $m_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$() {
  if ((!$n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$)) {
    $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ = new $c_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$();
  }
  return $n_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$;
}
export { $m_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ as $m_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$ };
/** @constructor */
function $c_Lcats_kernel_Comparison$EqualTo$() {
  $ct_Lcats_kernel_Comparison__I__D__(this, 0, 0.0);
}
export { $c_Lcats_kernel_Comparison$EqualTo$ as $c_Lcats_kernel_Comparison$EqualTo$ };
$c_Lcats_kernel_Comparison$EqualTo$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$EqualTo$.prototype.constructor = $c_Lcats_kernel_Comparison$EqualTo$;
/** @constructor */
function $h_Lcats_kernel_Comparison$EqualTo$() {
}
export { $h_Lcats_kernel_Comparison$EqualTo$ as $h_Lcats_kernel_Comparison$EqualTo$ };
$h_Lcats_kernel_Comparison$EqualTo$.prototype = $c_Lcats_kernel_Comparison$EqualTo$.prototype;
$c_Lcats_kernel_Comparison$EqualTo$.prototype.hashCode__I = (function() {
  return 159386799;
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.toString__T = (function() {
  return "EqualTo";
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productPrefix__T = (function() {
  return "EqualTo";
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_kernel_Comparison$EqualTo$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_kernel_Comparison$EqualTo$ = new $TypeData().initClass($c_Lcats_kernel_Comparison$EqualTo$, "cats.kernel.Comparison$EqualTo$", ({
  Lcats_kernel_Comparison$EqualTo$: 1,
  Lcats_kernel_Comparison: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_kernel_Comparison$EqualTo$ as $d_Lcats_kernel_Comparison$EqualTo$ };
var $n_Lcats_kernel_Comparison$EqualTo$;
function $m_Lcats_kernel_Comparison$EqualTo$() {
  if ((!$n_Lcats_kernel_Comparison$EqualTo$)) {
    $n_Lcats_kernel_Comparison$EqualTo$ = new $c_Lcats_kernel_Comparison$EqualTo$();
  }
  return $n_Lcats_kernel_Comparison$EqualTo$;
}
export { $m_Lcats_kernel_Comparison$EqualTo$ as $m_Lcats_kernel_Comparison$EqualTo$ };
/** @constructor */
function $c_Lcats_kernel_Comparison$GreaterThan$() {
  $ct_Lcats_kernel_Comparison__I__D__(this, 1, 1.0);
}
export { $c_Lcats_kernel_Comparison$GreaterThan$ as $c_Lcats_kernel_Comparison$GreaterThan$ };
$c_Lcats_kernel_Comparison$GreaterThan$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.constructor = $c_Lcats_kernel_Comparison$GreaterThan$;
/** @constructor */
function $h_Lcats_kernel_Comparison$GreaterThan$() {
}
export { $h_Lcats_kernel_Comparison$GreaterThan$ as $h_Lcats_kernel_Comparison$GreaterThan$ };
$h_Lcats_kernel_Comparison$GreaterThan$.prototype = $c_Lcats_kernel_Comparison$GreaterThan$.prototype;
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.hashCode__I = (function() {
  return (-1701951333);
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.toString__T = (function() {
  return "GreaterThan";
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productPrefix__T = (function() {
  return "GreaterThan";
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_kernel_Comparison$GreaterThan$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_kernel_Comparison$GreaterThan$ = new $TypeData().initClass($c_Lcats_kernel_Comparison$GreaterThan$, "cats.kernel.Comparison$GreaterThan$", ({
  Lcats_kernel_Comparison$GreaterThan$: 1,
  Lcats_kernel_Comparison: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_kernel_Comparison$GreaterThan$ as $d_Lcats_kernel_Comparison$GreaterThan$ };
var $n_Lcats_kernel_Comparison$GreaterThan$;
function $m_Lcats_kernel_Comparison$GreaterThan$() {
  if ((!$n_Lcats_kernel_Comparison$GreaterThan$)) {
    $n_Lcats_kernel_Comparison$GreaterThan$ = new $c_Lcats_kernel_Comparison$GreaterThan$();
  }
  return $n_Lcats_kernel_Comparison$GreaterThan$;
}
export { $m_Lcats_kernel_Comparison$GreaterThan$ as $m_Lcats_kernel_Comparison$GreaterThan$ };
/** @constructor */
function $c_Lcats_kernel_Comparison$LessThan$() {
  $ct_Lcats_kernel_Comparison__I__D__(this, (-1), (-1.0));
}
export { $c_Lcats_kernel_Comparison$LessThan$ as $c_Lcats_kernel_Comparison$LessThan$ };
$c_Lcats_kernel_Comparison$LessThan$.prototype = new $h_Lcats_kernel_Comparison();
$c_Lcats_kernel_Comparison$LessThan$.prototype.constructor = $c_Lcats_kernel_Comparison$LessThan$;
/** @constructor */
function $h_Lcats_kernel_Comparison$LessThan$() {
}
export { $h_Lcats_kernel_Comparison$LessThan$ as $h_Lcats_kernel_Comparison$LessThan$ };
$h_Lcats_kernel_Comparison$LessThan$.prototype = $c_Lcats_kernel_Comparison$LessThan$.prototype;
$c_Lcats_kernel_Comparison$LessThan$.prototype.hashCode__I = (function() {
  return (-2140646662);
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.toString__T = (function() {
  return "LessThan";
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productPrefix__T = (function() {
  return "LessThan";
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_kernel_Comparison$LessThan$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_kernel_Comparison$LessThan$ = new $TypeData().initClass($c_Lcats_kernel_Comparison$LessThan$, "cats.kernel.Comparison$LessThan$", ({
  Lcats_kernel_Comparison$LessThan$: 1,
  Lcats_kernel_Comparison: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_kernel_Comparison$LessThan$ as $d_Lcats_kernel_Comparison$LessThan$ };
var $n_Lcats_kernel_Comparison$LessThan$;
function $m_Lcats_kernel_Comparison$LessThan$() {
  if ((!$n_Lcats_kernel_Comparison$LessThan$)) {
    $n_Lcats_kernel_Comparison$LessThan$ = new $c_Lcats_kernel_Comparison$LessThan$();
  }
  return $n_Lcats_kernel_Comparison$LessThan$;
}
export { $m_Lcats_kernel_Comparison$LessThan$ as $m_Lcats_kernel_Comparison$LessThan$ };
/** @constructor */
function $c_Lcats_kernel_instances_IntGroup() {
}
export { $c_Lcats_kernel_instances_IntGroup as $c_Lcats_kernel_instances_IntGroup };
$c_Lcats_kernel_instances_IntGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_IntGroup.prototype.constructor = $c_Lcats_kernel_instances_IntGroup;
/** @constructor */
function $h_Lcats_kernel_instances_IntGroup() {
}
export { $h_Lcats_kernel_instances_IntGroup as $h_Lcats_kernel_instances_IntGroup };
$h_Lcats_kernel_instances_IntGroup.prototype = $c_Lcats_kernel_instances_IntGroup.prototype;
$c_Lcats_kernel_instances_IntGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_IntGroup.prototype.combine__I__I__I = (function(x, y) {
  return ((x + y) | 0);
});
$c_Lcats_kernel_instances_IntGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__I__I__I((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_IntGroup.prototype.empty__O = (function() {
  return 0;
});
var $d_Lcats_kernel_instances_IntGroup = new $TypeData().initClass($c_Lcats_kernel_instances_IntGroup, "cats.kernel.instances.IntGroup", ({
  Lcats_kernel_instances_IntGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
export { $d_Lcats_kernel_instances_IntGroup as $d_Lcats_kernel_instances_IntGroup };
/** @constructor */
function $c_Lcats_kernel_instances_LongGroup() {
}
export { $c_Lcats_kernel_instances_LongGroup as $c_Lcats_kernel_instances_LongGroup };
$c_Lcats_kernel_instances_LongGroup.prototype = new $h_O();
$c_Lcats_kernel_instances_LongGroup.prototype.constructor = $c_Lcats_kernel_instances_LongGroup;
/** @constructor */
function $h_Lcats_kernel_instances_LongGroup() {
}
export { $h_Lcats_kernel_instances_LongGroup as $h_Lcats_kernel_instances_LongGroup };
$h_Lcats_kernel_instances_LongGroup.prototype = $c_Lcats_kernel_instances_LongGroup.prototype;
$c_Lcats_kernel_instances_LongGroup.prototype.combineAll__sc_IterableOnce__O = (function(as) {
  return $f_Lcats_kernel_Monoid__combineAll__sc_IterableOnce__O(this, as);
});
$c_Lcats_kernel_instances_LongGroup.prototype.combine__J__J__J = (function(x, y) {
  var alo = x.RTLong__f_lo;
  var blo = y.RTLong__f_lo;
  var lo = ((alo + blo) | 0);
  var hi = ((((x.RTLong__f_hi + y.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
  return new $c_RTLong(lo, hi);
});
$c_Lcats_kernel_instances_LongGroup.prototype.combine__O__O__O = (function(x, y) {
  return this.combine__J__J__J($uJ(x), $uJ(y));
});
$c_Lcats_kernel_instances_LongGroup.prototype.empty__O = (function() {
  return $L0;
});
var $d_Lcats_kernel_instances_LongGroup = new $TypeData().initClass($c_Lcats_kernel_instances_LongGroup, "cats.kernel.instances.LongGroup", ({
  Lcats_kernel_instances_LongGroup: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Semigroup: 1,
  Lcats_kernel_Monoid: 1,
  Lcats_kernel_Group: 1,
  Lcats_kernel_CommutativeSemigroup: 1,
  Lcats_kernel_CommutativeMonoid: 1,
  Lcats_kernel_CommutativeGroup: 1
}));
export { $d_Lcats_kernel_instances_LongGroup as $d_Lcats_kernel_instances_LongGroup };
/** @constructor */
function $c_Lcats_kernel_instances_StringOrder() {
}
export { $c_Lcats_kernel_instances_StringOrder as $c_Lcats_kernel_instances_StringOrder };
$c_Lcats_kernel_instances_StringOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_StringOrder.prototype.constructor = $c_Lcats_kernel_instances_StringOrder;
/** @constructor */
function $h_Lcats_kernel_instances_StringOrder() {
}
export { $h_Lcats_kernel_instances_StringOrder as $h_Lcats_kernel_instances_StringOrder };
$h_Lcats_kernel_instances_StringOrder.prototype = $c_Lcats_kernel_instances_StringOrder.prototype;
$c_Lcats_kernel_instances_StringOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__neqv__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.lt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__lt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.gt__O__O__Z = (function(x, y) {
  return $f_Lcats_kernel_Order__gt__O__O__Z(this, x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__T__T__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__T__T__I = (function(x, y) {
  return ((x === y) ? 0 : $f_T__compareTo__T__I(x, y));
});
$c_Lcats_kernel_instances_StringOrder.prototype.hash__O__I = (function(x) {
  return $f_T__hashCode__I(x);
});
$c_Lcats_kernel_instances_StringOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__T__T__Z(x, y);
});
$c_Lcats_kernel_instances_StringOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__T__T__I(x, y);
});
var $d_Lcats_kernel_instances_StringOrder = new $TypeData().initClass($c_Lcats_kernel_instances_StringOrder, "cats.kernel.instances.StringOrder", ({
  Lcats_kernel_instances_StringOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_StringLowerBounded: 1
}));
export { $d_Lcats_kernel_instances_StringOrder as $d_Lcats_kernel_instances_StringOrder };
/** @constructor */
function $c_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1(key$1) {
  this.Lcom_raquo_laminar_keys_StyleProp__f_name = null;
  this.Lcom_raquo_laminar_keys_StyleProp__f_prefixes = null;
  $ct_Lcom_raquo_laminar_keys_StyleProp__T__sci_Seq__(this, key$1, $m_sci_Nil$());
}
export { $c_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1 as $c_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1 };
$c_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1.prototype = new $h_Lcom_raquo_laminar_keys_StyleProp();
$c_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1.prototype.constructor = $c_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1() {
}
export { $h_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1 as $h_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1 };
$h_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1.prototype = $c_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1.prototype;
var $d_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1, "com.raquo.laminar.defs.styles.StyleProps$$anon$1", ({
  Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1: 1,
  Lcom_raquo_laminar_keys_StyleProp: 1,
  Lcom_raquo_laminar_keys_SimpleKey: 1,
  Lcom_raquo_laminar_defs_styles_traits_GlobalKeywords: 1,
  Lcom_raquo_laminar_defs_styles_units_GlobalUnits: 1,
  Lcom_raquo_laminar_keys_StyleBuilder: 1,
  Lcom_raquo_laminar_keys_DerivedStyleBuilder: 1,
  Lcom_raquo_laminar_defs_styles_traits_Auto: 1
}));
export { $d_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1 as $d_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1 };
/** @constructor */
function $c_Lcom_raquo_laminar_domapi_DomApi$() {
  this.Lcom_raquo_laminar_domapi_DomApi$__f_svgNamespaceUri = null;
  this.Lcom_raquo_laminar_domapi_DomApi$__f_com$raquo$laminar$domapi$DomParser$$svgParserContainer = null;
  this.Lcom_raquo_laminar_domapi_DomApi$__f_com$raquo$laminar$domapi$DomDebug$$classNamesSeparatorRegex = null;
  $n_Lcom_raquo_laminar_domapi_DomApi$ = this;
  $f_Lcom_raquo_laminar_domapi_DomTags__$init$__V(this);
  $f_Lcom_raquo_laminar_domapi_DomParser__$init$__V(this);
  $f_Lcom_raquo_laminar_domapi_DomDebug__$init$__V(this);
}
export { $c_Lcom_raquo_laminar_domapi_DomApi$ as $c_Lcom_raquo_laminar_domapi_DomApi$ };
$c_Lcom_raquo_laminar_domapi_DomApi$.prototype = new $h_O();
$c_Lcom_raquo_laminar_domapi_DomApi$.prototype.constructor = $c_Lcom_raquo_laminar_domapi_DomApi$;
/** @constructor */
function $h_Lcom_raquo_laminar_domapi_DomApi$() {
}
export { $h_Lcom_raquo_laminar_domapi_DomApi$ as $h_Lcom_raquo_laminar_domapi_DomApi$ };
$h_Lcom_raquo_laminar_domapi_DomApi$.prototype = $c_Lcom_raquo_laminar_domapi_DomApi$.prototype;
var $d_Lcom_raquo_laminar_domapi_DomApi$ = new $TypeData().initClass($c_Lcom_raquo_laminar_domapi_DomApi$, "com.raquo.laminar.domapi.DomApi$", ({
  Lcom_raquo_laminar_domapi_DomApi$: 1,
  Lcom_raquo_laminar_domapi_DomTree: 1,
  Lcom_raquo_laminar_domapi_DomEvents: 1,
  Lcom_raquo_laminar_domapi_DomKeys: 1,
  Lcom_raquo_laminar_domapi_DomTags: 1,
  Lcom_raquo_laminar_domapi_DomInputs: 1,
  Lcom_raquo_laminar_domapi_DomParser: 1,
  Lcom_raquo_laminar_domapi_DomDebug: 1
}));
export { $d_Lcom_raquo_laminar_domapi_DomApi$ as $d_Lcom_raquo_laminar_domapi_DomApi$ };
var $n_Lcom_raquo_laminar_domapi_DomApi$;
function $m_Lcom_raquo_laminar_domapi_DomApi$() {
  if ((!$n_Lcom_raquo_laminar_domapi_DomApi$)) {
    $n_Lcom_raquo_laminar_domapi_DomApi$ = new $c_Lcom_raquo_laminar_domapi_DomApi$();
  }
  return $n_Lcom_raquo_laminar_domapi_DomApi$;
}
export { $m_Lcom_raquo_laminar_domapi_DomApi$ as $m_Lcom_raquo_laminar_domapi_DomApi$ };
/** @constructor */
function $c_Lio_circe_DecodingFailure$Reason$MissingField$() {
}
export { $c_Lio_circe_DecodingFailure$Reason$MissingField$ as $c_Lio_circe_DecodingFailure$Reason$MissingField$ };
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype = new $h_Lio_circe_DecodingFailure$Reason();
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.constructor = $c_Lio_circe_DecodingFailure$Reason$MissingField$;
/** @constructor */
function $h_Lio_circe_DecodingFailure$Reason$MissingField$() {
}
export { $h_Lio_circe_DecodingFailure$Reason$MissingField$ as $h_Lio_circe_DecodingFailure$Reason$MissingField$ };
$h_Lio_circe_DecodingFailure$Reason$MissingField$.prototype = $c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype;
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.hashCode__I = (function() {
  return (-1005620396);
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.toString__T = (function() {
  return "MissingField";
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.productPrefix__T = (function() {
  return "MissingField";
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_DecodingFailure$Reason$MissingField$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lio_circe_DecodingFailure$Reason$MissingField$ = new $TypeData().initClass($c_Lio_circe_DecodingFailure$Reason$MissingField$, "io.circe.DecodingFailure$Reason$MissingField$", ({
  Lio_circe_DecodingFailure$Reason$MissingField$: 1,
  Lio_circe_DecodingFailure$Reason: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lio_circe_DecodingFailure$Reason$MissingField$ as $d_Lio_circe_DecodingFailure$Reason$MissingField$ };
var $n_Lio_circe_DecodingFailure$Reason$MissingField$;
function $m_Lio_circe_DecodingFailure$Reason$MissingField$() {
  if ((!$n_Lio_circe_DecodingFailure$Reason$MissingField$)) {
    $n_Lio_circe_DecodingFailure$Reason$MissingField$ = new $c_Lio_circe_DecodingFailure$Reason$MissingField$();
  }
  return $n_Lio_circe_DecodingFailure$Reason$MissingField$;
}
export { $m_Lio_circe_DecodingFailure$Reason$MissingField$ as $m_Lio_circe_DecodingFailure$Reason$MissingField$ };
/** @constructor */
function $c_Lio_circe_Json$JNull$() {
}
export { $c_Lio_circe_Json$JNull$ as $c_Lio_circe_Json$JNull$ };
$c_Lio_circe_Json$JNull$.prototype = new $h_Lio_circe_Json();
$c_Lio_circe_Json$JNull$.prototype.constructor = $c_Lio_circe_Json$JNull$;
/** @constructor */
function $h_Lio_circe_Json$JNull$() {
}
export { $h_Lio_circe_Json$JNull$ as $h_Lio_circe_Json$JNull$ };
$h_Lio_circe_Json$JNull$.prototype = $c_Lio_circe_Json$JNull$.prototype;
$c_Lio_circe_Json$JNull$.prototype.hashCode__I = (function() {
  return 70780145;
});
$c_Lio_circe_Json$JNull$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_Json$JNull$.prototype.productPrefix__T = (function() {
  return "JNull";
});
$c_Lio_circe_Json$JNull$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JNull$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_Json$JNull$.prototype.foldWith__Lio_circe_Json$Folder__O = (function(folder) {
  return folder.onNull__O();
});
$c_Lio_circe_Json$JNull$.prototype.isNull__Z = (function() {
  return true;
});
$c_Lio_circe_Json$JNull$.prototype.isArray__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JNull$.prototype.isObject__Z = (function() {
  return false;
});
$c_Lio_circe_Json$JNull$.prototype.asArray__s_Option = (function() {
  return $m_s_None$();
});
$c_Lio_circe_Json$JNull$.prototype.asObject__s_Option = (function() {
  return $m_s_None$();
});
$c_Lio_circe_Json$JNull$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lio_circe_Json$JNull$ = new $TypeData().initClass($c_Lio_circe_Json$JNull$, "io.circe.Json$JNull$", ({
  Lio_circe_Json$JNull$: 1,
  Lio_circe_Json: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lio_circe_Json$JNull$ as $d_Lio_circe_Json$JNull$ };
var $n_Lio_circe_Json$JNull$;
function $m_Lio_circe_Json$JNull$() {
  if ((!$n_Lio_circe_Json$JNull$)) {
    $n_Lio_circe_Json$JNull$ = new $c_Lio_circe_Json$JNull$();
  }
  return $n_Lio_circe_Json$JNull$;
}
export { $m_Lio_circe_Json$JNull$ as $m_Lio_circe_Json$JNull$ };
function $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J($thiz, field) {
  var x = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
  if (((x === null) ? (field === null) : (x === field))) {
    var value = $thiz.getDayOfWeek__Ljava_time_DayOfWeek().getValue__I();
    var hi = (value >> 31);
    return new $c_RTLong(value, hi);
  }
  var x$3 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
  if (((x$3 === null) ? (field === null) : (x$3 === field))) {
    var value$1 = $thiz.Ljava_time_LocalDate__f_day;
    var hi$1 = (value$1 >> 31);
    var lo = (((-1) + value$1) | 0);
    var hi$2 = (((((-1) + hi$1) | 0) + (((value$1 | (~lo)) >>> 31) | 0)) | 0);
    var this$4 = $m_RTLong$();
    var lo$1 = this$4.remainderImpl__I__I__I__I__I(lo, hi$2, 7, 0);
    var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$2 = ((1 + lo$1) | 0);
    var hi$4 = ((hi$3 + (((lo$1 & (~lo$2)) >>> 31) | 0)) | 0);
    return new $c_RTLong(lo$2, hi$4);
  }
  var x$5 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
  if (((x$5 === null) ? (field === null) : (x$5 === field))) {
    var value$2 = $thiz.getDayOfYear__I();
    var hi$5 = (value$2 >> 31);
    var lo$3 = (((-1) + value$2) | 0);
    var hi$6 = (((((-1) + hi$5) | 0) + (((value$2 | (~lo$3)) >>> 31) | 0)) | 0);
    var this$8 = $m_RTLong$();
    var lo$4 = this$8.remainderImpl__I__I__I__I__I(lo$3, hi$6, 7, 0);
    var hi$7 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$5 = ((1 + lo$4) | 0);
    var hi$8 = ((hi$7 + (((lo$4 & (~lo$5)) >>> 31) | 0)) | 0);
    return new $c_RTLong(lo$5, hi$8);
  }
  var x$7 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
  if (((x$7 === null) ? (field === null) : (x$7 === field))) {
    var value$3 = $thiz.Ljava_time_LocalDate__f_day;
    var hi$9 = (value$3 >> 31);
    return new $c_RTLong(value$3, hi$9);
  }
  var x$9 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
  if (((x$9 === null) ? (field === null) : (x$9 === field))) {
    var value$4 = $thiz.getDayOfYear__I();
    var hi$10 = (value$4 >> 31);
    return new $c_RTLong(value$4, hi$10);
  }
  var x$11 = $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  if (((x$11 === null) ? (field === null) : (x$11 === field))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$13 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
  if (((x$13 === null) ? (field === null) : (x$13 === field))) {
    var value$5 = $thiz.Ljava_time_LocalDate__f_day;
    var hi$11 = (value$5 >> 31);
    var lo$6 = (((-1) + value$5) | 0);
    var hi$12 = (((((-1) + hi$11) | 0) + (((value$5 | (~lo$6)) >>> 31) | 0)) | 0);
    var this$14 = $m_RTLong$();
    var lo$7 = this$14.divideImpl__I__I__I__I__I(lo$6, hi$12, 7, 0);
    var hi$13 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$8 = ((1 + lo$7) | 0);
    var hi$14 = ((hi$13 + (((lo$7 & (~lo$8)) >>> 31) | 0)) | 0);
    return new $c_RTLong(lo$8, hi$14);
  }
  var x$15 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
  if (((x$15 === null) ? (field === null) : (x$15 === field))) {
    var value$6 = $thiz.getDayOfYear__I();
    var hi$15 = (value$6 >> 31);
    var lo$9 = (((-1) + value$6) | 0);
    var hi$16 = (((((-1) + hi$15) | 0) + (((value$6 | (~lo$9)) >>> 31) | 0)) | 0);
    var this$18 = $m_RTLong$();
    var lo$10 = this$18.divideImpl__I__I__I__I__I(lo$9, hi$16, 7, 0);
    var hi$17 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$11 = ((1 + lo$10) | 0);
    var hi$18 = ((hi$17 + (((lo$10 & (~lo$11)) >>> 31) | 0)) | 0);
    return new $c_RTLong(lo$11, hi$18);
  }
  var x$17 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
  if (((x$17 === null) ? (field === null) : (x$17 === field))) {
    var value$7 = $thiz.Ljava_time_LocalDate__f_month;
    var hi$19 = (value$7 >> 31);
    return new $c_RTLong(value$7, hi$19);
  }
  var x$19 = $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
  if (((x$19 === null) ? (field === null) : (x$19 === field))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$21 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
  if (((x$21 === null) ? (field === null) : (x$21 === field))) {
    if (($thiz.Ljava_time_LocalDate__f_year >= 1)) {
      var value$8 = $thiz.Ljava_time_LocalDate__f_year;
      var hi$20 = (value$8 >> 31);
      return new $c_RTLong(value$8, hi$20);
    } else {
      var value$9 = $thiz.Ljava_time_LocalDate__f_year;
      var hi$21 = (value$9 >> 31);
      var lo$12 = ((1 - value$9) | 0);
      var hi$22 = ((((-hi$21) | 0) + ((value$9 | lo$12) >> 31)) | 0);
      return new $c_RTLong(lo$12, hi$22);
    }
  }
  var x$23 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  if (((x$23 === null) ? (field === null) : (x$23 === field))) {
    var value$10 = $thiz.Ljava_time_LocalDate__f_year;
    var hi$23 = (value$10 >> 31);
    return new $c_RTLong(value$10, hi$23);
  }
  var x$25 = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
  if (((x$25 === null) ? (field === null) : (x$25 === field))) {
    return (($thiz.Ljava_time_LocalDate__f_year >= 1) ? new $c_RTLong(1, 0) : $L0);
  }
  throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
}
export { $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J as $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J };
function $p_Ljava_time_LocalDate__getProlepticMonth__J($thiz) {
  var value = $thiz.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var value$1 = (((-1) + $thiz.Ljava_time_LocalDate__f_month) | 0);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo & value$1) | ((lo | value$1) & (~lo$1))) >>> 31) | 0)) | 0);
  return new $c_RTLong(lo$1, hi$3);
}
export { $p_Ljava_time_LocalDate__getProlepticMonth__J as $p_Ljava_time_LocalDate__getProlepticMonth__J };
function $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J($thiz, end) {
  var a = $p_Ljava_time_LocalDate__getProlepticMonth__J($thiz);
  var lo = a.RTLong__f_lo;
  var lo$1 = (lo << 5);
  var hi = (((lo >>> 27) | 0) | (a.RTLong__f_hi << 5));
  var value = $thiz.Ljava_time_LocalDate__f_day;
  var hi$1 = (value >> 31);
  var lo$2 = ((lo$1 + value) | 0);
  var hi$2 = ((((hi + hi$1) | 0) + ((((lo$1 & value) | ((lo$1 | value) & (~lo$2))) >>> 31) | 0)) | 0);
  var a$1 = $p_Ljava_time_LocalDate__getProlepticMonth__J(end);
  var lo$3 = a$1.RTLong__f_lo;
  var lo$4 = (lo$3 << 5);
  var hi$3 = (((lo$3 >>> 27) | 0) | (a$1.RTLong__f_hi << 5));
  var value$1 = end.Ljava_time_LocalDate__f_day;
  var hi$4 = (value$1 >> 31);
  var lo$5 = ((lo$4 + value$1) | 0);
  var hi$5 = ((((hi$3 + hi$4) | 0) + ((((lo$4 & value$1) | ((lo$4 | value$1) & (~lo$5))) >>> 31) | 0)) | 0);
  var lo$6 = ((lo$5 - lo$2) | 0);
  var hi$6 = ((((hi$5 - hi$2) | 0) + ((((~lo$5) & lo$2) | ((~(lo$5 ^ lo$2)) & lo$6)) >> 31)) | 0);
  var this$8 = $m_RTLong$();
  var lo$7 = this$8.divideImpl__I__I__I__I__I(lo$6, hi$6, 32, 0);
  var hi$7 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo$7, hi$7);
}
export { $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J as $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J };
/** @constructor */
function $c_Ljava_time_LocalDate(year, monthOfYear, dayOfMonth) {
  this.Ljava_time_LocalDate__f_year = 0;
  this.Ljava_time_LocalDate__f_month = 0;
  this.Ljava_time_LocalDate__f_day = 0;
  this.Ljava_time_LocalDate__f_year = year;
  this.Ljava_time_LocalDate__f_month = ((monthOfYear << 16) >> 16);
  this.Ljava_time_LocalDate__f_day = ((dayOfMonth << 16) >> 16);
}
export { $c_Ljava_time_LocalDate as $c_Ljava_time_LocalDate };
$c_Ljava_time_LocalDate.prototype = new $h_O();
$c_Ljava_time_LocalDate.prototype.constructor = $c_Ljava_time_LocalDate;
/** @constructor */
function $h_Ljava_time_LocalDate() {
}
export { $h_Ljava_time_LocalDate as $h_Ljava_time_LocalDate };
$h_Ljava_time_LocalDate.prototype = $c_Ljava_time_LocalDate.prototype;
$c_Ljava_time_LocalDate.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this, field);
});
$c_Ljava_time_LocalDate.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if (field.isDateBased__Z()) {
      var x = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
      if (((x === null) ? (field === null) : (x === field))) {
        var $x_1 = $m_Ljava_time_temporal_ValueRange$();
        var value = this.lengthOfMonth__I();
        var hi = (value >> 31);
        return $x_1.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(value, hi));
      } else {
        var x$3 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
        if (((x$3 === null) ? (field === null) : (x$3 === field))) {
          var $x_2 = $m_Ljava_time_temporal_ValueRange$();
          var value$1 = this.lengthOfYear__I();
          var hi$1 = (value$1 >> 31);
          return $x_2.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(value$1, hi$1));
        } else {
          var x$5 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
          if (((x$5 === null) ? (field === null) : (x$5 === field))) {
            var $x_5 = $m_Ljava_time_temporal_ValueRange$();
            if (($m_Ljava_time_Month$().of__I__Ljava_time_Month(this.Ljava_time_LocalDate__f_month) === $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month())) {
              var $x_4 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
              var value$2 = this.Ljava_time_LocalDate__f_year;
              var hi$2 = (value$2 >> 31);
              var $x_3 = (!$x_4.isLeapYear__J__Z(new $c_RTLong(value$2, hi$2)));
            } else {
              var $x_3 = false;
            }
            return $x_5.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), ($x_3 ? new $c_RTLong(4, 0) : new $c_RTLong(5, 0)));
          } else {
            var x$7 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
            if (((x$7 === null) ? (field === null) : (x$7 === field))) {
              if ((this.Ljava_time_LocalDate__f_year <= 0)) {
                var $x_6 = $m_Ljava_time_temporal_ValueRange$();
                var value$3 = $m_Ljava_time_Year$().MAX_VALUE__I();
                var hi$3 = (value$3 >> 31);
                var lo = ((1 + value$3) | 0);
                var hi$4 = ((hi$3 + (((value$3 & (~lo)) >>> 31) | 0)) | 0);
                return $x_6.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(lo, hi$4));
              } else {
                var $x_7 = $m_Ljava_time_temporal_ValueRange$();
                var value$4 = $m_Ljava_time_Year$().MAX_VALUE__I();
                var hi$5 = (value$4 >> 31);
                return $x_7.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(value$4, hi$5));
              }
            } else {
              return field.range__Ljava_time_temporal_ValueRange();
            }
          }
        }
      }
    } else {
      throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
    }
  } else {
    return field.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this);
  }
});
$c_Ljava_time_LocalDate.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    var a = $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J(this, field);
    return a.RTLong__f_lo;
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
  }
});
$c_Ljava_time_LocalDate.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if ((field === $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
      return this.toEpochDay__J();
    }
    if ((field === $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField())) {
      return $p_Ljava_time_LocalDate__getProlepticMonth__J(this);
    }
    return $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J(this, field);
  } else {
    return field.getFrom__Ljava_time_temporal_TemporalAccessor__J(this);
  }
});
$c_Ljava_time_LocalDate.prototype.getDayOfYear__I = (function() {
  var $x_2 = $m_Ljava_time_Month$().of__I__Ljava_time_Month(this.Ljava_time_LocalDate__f_month);
  var $x_1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  return (((-1) + (($x_2.firstDayOfYear__Z__I($x_1.isLeapYear__J__Z(new $c_RTLong(value, hi))) + this.Ljava_time_LocalDate__f_day) | 0)) | 0);
});
$c_Ljava_time_LocalDate.prototype.getDayOfWeek__Ljava_time_DayOfWeek = (function() {
  var b = this.toEpochDay__J();
  var blo = b.RTLong__f_lo;
  var lo = ((3 + blo) | 0);
  var hi = ((b.RTLong__f_hi + (((blo & (~lo)) >>> 31) | 0)) | 0);
  var this$3 = $m_RTLong$();
  var lo$1 = this$3.remainderImpl__I__I__I__I__I(lo, hi, 7, 0);
  var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  if (((hi >= 0) || ((lo$1 === 0) && (hi$1 === 0)))) {
    var a__lo = lo$1;
    var a__hi = hi$1;
  } else {
    var lo$3 = ((7 + lo$1) | 0);
    var hi$2 = ((hi$1 + (((lo$1 & (~lo$3)) >>> 31) | 0)) | 0);
    var a__lo = lo$3;
    var a__hi = hi$2;
  }
  var dow0 = a__lo;
  return $m_Ljava_time_DayOfWeek$().of__I__Ljava_time_DayOfWeek(((1 + dow0) | 0));
});
$c_Ljava_time_LocalDate.prototype.lengthOfMonth__I = (function() {
  var x3 = this.Ljava_time_LocalDate__f_month;
  switch (x3) {
    case 2: {
      var $x_1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      var value = this.Ljava_time_LocalDate__f_year;
      var hi = (value >> 31);
      if ($x_1.isLeapYear__J__Z(new $c_RTLong(value, hi))) {
        return 29;
      } else {
        return 28;
      }
      break;
    }
    case 4:
    case 6:
    case 9:
    case 11: {
      return 30;
      break;
    }
    default: {
      return 31;
    }
  }
});
$c_Ljava_time_LocalDate.prototype.lengthOfYear__I = (function() {
  var $x_1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  if ($x_1.isLeapYear__J__Z(new $c_RTLong(value, hi))) {
    return 366;
  } else {
    return 365;
  }
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate = (function(adjuster) {
  return ((adjuster instanceof $c_Ljava_time_LocalDate) ? adjuster : adjuster.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this));
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate = (function(field, newValue) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    field.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, field);
    var x = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      var value = this.getDayOfWeek__Ljava_time_DayOfWeek().getValue__I();
      var hi = (value >> 31);
      var alo = newValue.RTLong__f_lo;
      var lo = ((alo - value) | 0);
      var hi$1 = ((((newValue.RTLong__f_hi - hi) | 0) + ((((~alo) & value) | ((~(alo ^ value)) & lo)) >> 31)) | 0);
      return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi$1));
    }
    var x$3 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      var b = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField());
      var alo$1 = newValue.RTLong__f_lo;
      var blo = b.RTLong__f_lo;
      var lo$1 = ((alo$1 - blo) | 0);
      var hi$2 = ((((newValue.RTLong__f_hi - b.RTLong__f_hi) | 0) + ((((~alo$1) & blo) | ((~(alo$1 ^ blo)) & lo$1)) >> 31)) | 0);
      return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$2));
    }
    var x$5 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
    if (((x$5 === null) ? (field === null) : (x$5 === field))) {
      var b$1 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField());
      var alo$2 = newValue.RTLong__f_lo;
      var blo$1 = b$1.RTLong__f_lo;
      var lo$2 = ((alo$2 - blo$1) | 0);
      var hi$3 = ((((newValue.RTLong__f_hi - b$1.RTLong__f_hi) | 0) + ((((~alo$2) & blo$1) | ((~(alo$2 ^ blo$1)) & lo$2)) >> 31)) | 0);
      return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$2, hi$3));
    }
    var x$7 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
    if (((x$7 === null) ? (field === null) : (x$7 === field))) {
      return this.withDayOfMonth__I__Ljava_time_LocalDate(newValue.RTLong__f_lo);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
    if (((x$9 === null) ? (field === null) : (x$9 === field))) {
      return this.withDayOfYear__I__Ljava_time_LocalDate(newValue.RTLong__f_lo);
    }
    var x$11 = $s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
    if (((x$11 === null) ? (field === null) : (x$11 === field))) {
      return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(newValue);
    }
    var x$13 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
    if (((x$13 === null) ? (field === null) : (x$13 === field))) {
      var b$2 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField());
      var alo$3 = newValue.RTLong__f_lo;
      var blo$2 = b$2.RTLong__f_lo;
      var lo$3 = ((alo$3 - blo$2) | 0);
      var hi$4 = ((((newValue.RTLong__f_hi - b$2.RTLong__f_hi) | 0) + ((((~alo$3) & blo$2) | ((~(alo$3 ^ blo$2)) & lo$3)) >> 31)) | 0);
      return this.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$3, hi$4));
    }
    var x$15 = $s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
    if (((x$15 === null) ? (field === null) : (x$15 === field))) {
      var b$3 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField());
      var alo$4 = newValue.RTLong__f_lo;
      var blo$3 = b$3.RTLong__f_lo;
      var lo$4 = ((alo$4 - blo$3) | 0);
      var hi$5 = ((((newValue.RTLong__f_hi - b$3.RTLong__f_hi) | 0) + ((((~alo$4) & blo$3) | ((~(alo$4 ^ blo$3)) & lo$4)) >> 31)) | 0);
      return this.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$4, hi$5));
    }
    var x$17 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    if (((x$17 === null) ? (field === null) : (x$17 === field))) {
      return this.withMonth__I__Ljava_time_LocalDate(newValue.RTLong__f_lo);
    }
    var x$19 = $s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
    if (((x$19 === null) ? (field === null) : (x$19 === field))) {
      var b$4 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField());
      var alo$5 = newValue.RTLong__f_lo;
      var blo$4 = b$4.RTLong__f_lo;
      var lo$5 = ((alo$5 - blo$4) | 0);
      var hi$6 = ((((newValue.RTLong__f_hi - b$4.RTLong__f_hi) | 0) + ((((~alo$5) & blo$4) | ((~(alo$5 ^ blo$4)) & lo$5)) >> 31)) | 0);
      return this.plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$5, hi$6));
    }
    var x$21 = $s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
    if (((x$21 === null) ? (field === null) : (x$21 === field))) {
      if ((this.Ljava_time_LocalDate__f_year >= 1)) {
        var a = newValue;
      } else {
        var blo$5 = newValue.RTLong__f_lo;
        var lo$6 = ((1 - blo$5) | 0);
        var hi$7 = ((((-newValue.RTLong__f_hi) | 0) + ((blo$5 | lo$6) >> 31)) | 0);
        var x$1__lo = lo$6;
        var x$1__hi = hi$7;
        var a = new $c_RTLong(x$1__lo, x$1__hi);
      }
      return this.withYear__I__Ljava_time_LocalDate(a.RTLong__f_lo);
    }
    var x$23 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    if (((x$23 === null) ? (field === null) : (x$23 === field))) {
      return this.withYear__I__Ljava_time_LocalDate(newValue.RTLong__f_lo);
    }
    var x$25 = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
    if (((x$25 === null) ? (field === null) : (x$25 === field))) {
      var a$1 = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
      if (((a$1.RTLong__f_lo === newValue.RTLong__f_lo) && (a$1.RTLong__f_hi === newValue.RTLong__f_hi))) {
        return this;
      } else {
        return this.withYear__I__Ljava_time_LocalDate(((1 - this.Ljava_time_LocalDate__f_year) | 0));
      }
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return field.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue);
  }
});
$c_Ljava_time_LocalDate.prototype.withYear__I__Ljava_time_LocalDate = (function(year) {
  if ((this.Ljava_time_LocalDate__f_year === year)) {
    return this;
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var hi = (year >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(year, hi), this$2);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(year, this.Ljava_time_LocalDate__f_month, this.Ljava_time_LocalDate__f_day);
  }
});
$c_Ljava_time_LocalDate.prototype.withMonth__I__Ljava_time_LocalDate = (function(month) {
  if ((this.Ljava_time_LocalDate__f_month === month)) {
    return this;
  } else {
    var this$2 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var hi = (month >> 31);
    this$2.Ljava_time_temporal_ChronoField__f__range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(month, hi), this$2);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, month, this.Ljava_time_LocalDate__f_day);
  }
});
$c_Ljava_time_LocalDate.prototype.withDayOfMonth__I__Ljava_time_LocalDate = (function(dayOfMonth) {
  return ((this.Ljava_time_LocalDate__f_day === dayOfMonth) ? this : $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, this.Ljava_time_LocalDate__f_month, dayOfMonth));
});
$c_Ljava_time_LocalDate.prototype.withDayOfYear__I__Ljava_time_LocalDate = (function(dayOfYear) {
  return ((this.getDayOfYear__I() === dayOfYear) ? this : $m_Ljava_time_LocalDate$().ofYearDay__I__I__Ljava_time_LocalDate(this.Ljava_time_LocalDate__f_year, dayOfYear));
});
$c_Ljava_time_LocalDate.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x === null) ? (unit === null) : (x === unit))) {
      return this.plusDays__J__Ljava_time_LocalDate(amountToAdd);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
    if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
      return this.plusWeeks__J__Ljava_time_LocalDate(amountToAdd);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
    if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
      return this.plusMonths__J__Ljava_time_LocalDate(amountToAdd);
    }
    var x$7 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
    if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
      return this.plusYears__J__Ljava_time_LocalDate(amountToAdd);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit();
    if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
      var this$1 = $m_jl_Math$();
      var blo = amountToAdd.RTLong__f_lo;
      var b0 = (65535 & blo);
      var b1 = ((blo >>> 16) | 0);
      var a0b0 = Math.imul(10, b0);
      var a0b1 = Math.imul(10, b1);
      var lo = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi = ((Math.imul(10, amountToAdd.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
      if ((!((amountToAdd.RTLong__f_lo === 0) && (amountToAdd.RTLong__f_hi === 0)))) {
        var this$5 = $m_RTLong$();
        var lo$1 = this$5.divideImpl__I__I__I__I__I(lo, hi, amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi);
        var hi$1 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var $x_1 = (!((lo$1 === 10) && (hi$1 === 0)));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        this$1.java$lang$Math$$longOverflow__E();
      }
      return this.plusYears__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi));
    }
    var x$11 = $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit();
    if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
      var this$7 = $m_jl_Math$();
      var blo$1 = amountToAdd.RTLong__f_lo;
      var b0$1 = (65535 & blo$1);
      var b1$1 = ((blo$1 >>> 16) | 0);
      var a0b0$1 = Math.imul(100, b0$1);
      var a0b1$1 = Math.imul(100, b1$1);
      var lo$2 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$2 = ((Math.imul(100, amountToAdd.RTLong__f_hi) + ((c1part$1 >>> 16) | 0)) | 0);
      if ((!((amountToAdd.RTLong__f_lo === 0) && (amountToAdd.RTLong__f_hi === 0)))) {
        var this$11 = $m_RTLong$();
        var lo$3 = this$11.divideImpl__I__I__I__I__I(lo$2, hi$2, amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi);
        var hi$3 = this$11.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var $x_2 = (!((lo$3 === 100) && (hi$3 === 0)));
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        this$7.java$lang$Math$$longOverflow__E();
      }
      return this.plusYears__J__Ljava_time_LocalDate(new $c_RTLong(lo$2, hi$2));
    }
    var x$13 = $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit();
    if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
      var this$13 = $m_jl_Math$();
      var blo$2 = amountToAdd.RTLong__f_lo;
      var b0$2 = (65535 & blo$2);
      var b1$2 = ((blo$2 >>> 16) | 0);
      var a0b0$2 = Math.imul(1000, b0$2);
      var a0b1$2 = Math.imul(1000, b1$2);
      var lo$4 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$4 = ((Math.imul(1000, amountToAdd.RTLong__f_hi) + ((c1part$2 >>> 16) | 0)) | 0);
      if ((!((amountToAdd.RTLong__f_lo === 0) && (amountToAdd.RTLong__f_hi === 0)))) {
        var this$17 = $m_RTLong$();
        var lo$5 = this$17.divideImpl__I__I__I__I__I(lo$4, hi$4, amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi);
        var hi$5 = this$17.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var $x_3 = (!((lo$5 === 1000) && (hi$5 === 0)));
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        this$13.java$lang$Math$$longOverflow__E();
      }
      return this.plusYears__J__Ljava_time_LocalDate(new $c_RTLong(lo$4, hi$4));
    }
    var x$15 = $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit();
    if (((x$15 === null) ? (unit === null) : (x$15 === unit))) {
      var $x_4 = $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
      var t = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
      var lo$6 = t.RTLong__f_lo;
      var hi$6 = t.RTLong__f_hi;
      var this$19 = $m_jl_Math$();
      var blo$3 = amountToAdd.RTLong__f_lo;
      var lo$7 = ((lo$6 + blo$3) | 0);
      var hi$7 = ((((hi$6 + amountToAdd.RTLong__f_hi) | 0) + ((((lo$6 & blo$3) | ((lo$6 | blo$3) & (~lo$7))) >>> 31) | 0)) | 0);
      var hi$8 = (hi$7 ^ hi$6);
      var hi$9 = (hi$7 ^ amountToAdd.RTLong__f_hi);
      var hi$10 = (hi$8 & hi$9);
      if ((hi$10 < 0)) {
        this$19.java$lang$Math$$longOverflow__E();
      }
      return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate($x_4, new $c_RTLong(lo$7, hi$7));
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  } else {
    return unit.addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd);
  }
});
$c_Ljava_time_LocalDate.prototype.plusYears__J__Ljava_time_LocalDate = (function(yearsToAdd) {
  if (((yearsToAdd.RTLong__f_lo === 0) && (yearsToAdd.RTLong__f_hi === 0))) {
    return this;
  } else {
    var this$4 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var value = this.Ljava_time_LocalDate__f_year;
    var hi = (value >> 31);
    var blo = yearsToAdd.RTLong__f_lo;
    var lo = ((value + blo) | 0);
    var hi$1 = ((((hi + yearsToAdd.RTLong__f_hi) | 0) + ((((value & blo) | ((value | blo) & (~lo))) >>> 31) | 0)) | 0);
    var newYear = this$4.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo, hi$1), this$4);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(newYear, this.Ljava_time_LocalDate__f_month, this.Ljava_time_LocalDate__f_day);
  }
});
$c_Ljava_time_LocalDate.prototype.plusMonths__J__Ljava_time_LocalDate = (function(monthsToAdd) {
  if (((monthsToAdd.RTLong__f_lo === 0) && (monthsToAdd.RTLong__f_hi === 0))) {
    return this;
  } else {
    var value = this.Ljava_time_LocalDate__f_year;
    var hi = (value >> 31);
    var b0 = (65535 & value);
    var b1 = ((value >>> 16) | 0);
    var a0b0 = Math.imul(12, b0);
    var a0b1 = Math.imul(12, b1);
    var lo = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
    var value$1 = (((-1) + this.Ljava_time_LocalDate__f_month) | 0);
    var hi$2 = (value$1 >> 31);
    var lo$1 = ((lo + value$1) | 0);
    var hi$3 = ((((hi$1 + hi$2) | 0) + ((((lo & value$1) | ((lo | value$1) & (~lo$1))) >>> 31) | 0)) | 0);
    var blo = monthsToAdd.RTLong__f_lo;
    var lo$2 = ((lo$1 + blo) | 0);
    var hi$4 = ((((hi$3 + monthsToAdd.RTLong__f_hi) | 0) + ((((lo$1 & blo) | ((lo$1 | blo) & (~lo$2))) >>> 31) | 0)) | 0);
    var this$14 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var this$8 = $m_RTLong$();
    var lo$3 = this$8.divideImpl__I__I__I__I__I(lo$2, hi$4, 12, 0);
    var hi$5 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if ((hi$4 >= 0)) {
      var $x_1 = true;
    } else {
      var b0$1 = (65535 & lo$3);
      var b1$1 = ((lo$3 >>> 16) | 0);
      var a0b0$1 = Math.imul(12, b0$1);
      var a0b1$1 = Math.imul(12, b1$1);
      var lo$5 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$6 = ((Math.imul(12, hi$5) + ((c1part$1 >>> 16) | 0)) | 0);
      var $x_1 = ((lo$5 === lo$2) && (hi$6 === hi$4));
    }
    if ($x_1) {
      var value$2__lo = lo$3;
      var value$2__hi = hi$5;
    } else {
      var lo$6 = (((-1) + lo$3) | 0);
      var hi$7 = (((((-1) + hi$5) | 0) + (((lo$3 | (~lo$6)) >>> 31) | 0)) | 0);
      var value$2__lo = lo$6;
      var value$2__hi = hi$7;
    }
    var newYear = this$14.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(value$2__lo, value$2__hi), this$14);
    var this$16 = $m_RTLong$();
    var lo$7 = this$16.remainderImpl__I__I__I__I__I(lo$2, hi$4, 12, 0);
    var hi$8 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((hi$4 >= 0) || ((lo$7 === 0) && (hi$8 === 0)))) {
      var a__lo = lo$7;
      var a__hi = hi$8;
    } else {
      var lo$9 = ((12 + lo$7) | 0);
      var hi$9 = ((hi$8 + (((lo$7 & (~lo$9)) >>> 31) | 0)) | 0);
      var a__lo = lo$9;
      var a__hi = hi$9;
    }
    var newMonth = ((1 + a__lo) | 0);
    return $m_Ljava_time_LocalDate$().java$time$LocalDate$$$resolvePreviousValid__I__I__I__Ljava_time_LocalDate(newYear, newMonth, this.Ljava_time_LocalDate__f_day);
  }
});
$c_Ljava_time_LocalDate.prototype.plusWeeks__J__Ljava_time_LocalDate = (function(weeksToAdd) {
  var this$1 = $m_jl_Math$();
  var blo = weeksToAdd.RTLong__f_lo;
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(7, b0);
  var a0b1 = Math.imul(7, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((Math.imul(7, weeksToAdd.RTLong__f_hi) + ((c1part >>> 16) | 0)) | 0);
  if ((!((weeksToAdd.RTLong__f_lo === 0) && (weeksToAdd.RTLong__f_hi === 0)))) {
    var this$5 = $m_RTLong$();
    var lo$1 = this$5.divideImpl__I__I__I__I__I(lo, hi, weeksToAdd.RTLong__f_lo, weeksToAdd.RTLong__f_hi);
    var hi$1 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var $x_1 = (!((lo$1 === 7) && (hi$1 === 0)));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    this$1.java$lang$Math$$longOverflow__E();
  }
  return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi));
});
$c_Ljava_time_LocalDate.prototype.plusDays__J__Ljava_time_LocalDate = (function(daysToAdd) {
  if (((daysToAdd.RTLong__f_lo === 0) && (daysToAdd.RTLong__f_hi === 0))) {
    return this;
  } else {
    var t = this.toEpochDay__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var this$2 = $m_jl_Math$();
    var blo = daysToAdd.RTLong__f_lo;
    var lo$1 = ((lo + blo) | 0);
    var hi$1 = ((((hi + daysToAdd.RTLong__f_hi) | 0) + ((((lo & blo) | ((lo | blo) & (~lo$1))) >>> 31) | 0)) | 0);
    var hi$2 = (hi$1 ^ hi);
    var hi$3 = (hi$1 ^ daysToAdd.RTLong__f_hi);
    var hi$4 = (hi$2 & hi$3);
    if ((hi$4 < 0)) {
      this$2.java$lang$Math$$longOverflow__E();
    }
    return $m_Ljava_time_LocalDate$().ofEpochDay__J__Ljava_time_LocalDate(new $c_RTLong(lo$1, hi$1));
  }
});
$c_Ljava_time_LocalDate.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(1, 0), unit);
  } else {
    var blo = amountToSubtract.RTLong__f_lo;
    var lo = ((-blo) | 0);
    var hi = ((((-amountToSubtract.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(new $c_RTLong(lo, hi), unit);
  }
});
$c_Ljava_time_LocalDate.prototype.minusYears__J__Ljava_time_LocalDate = (function(yearsToSubtract) {
  if (((yearsToSubtract.RTLong__f_lo === 0) && (yearsToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plusYears__J__Ljava_time_LocalDate(new $c_RTLong((-1), 2147483647)).plusYears__J__Ljava_time_LocalDate(new $c_RTLong(1, 0));
  } else {
    var blo = yearsToSubtract.RTLong__f_lo;
    var lo = ((-blo) | 0);
    var hi = ((((-yearsToSubtract.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
    return this.plusYears__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi));
  }
});
$c_Ljava_time_LocalDate.prototype.minusDays__J__Ljava_time_LocalDate = (function(daysToSubtract) {
  if (((daysToSubtract.RTLong__f_lo === 0) && (daysToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong((-1), 2147483647)).plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0));
  } else {
    var blo = daysToSubtract.RTLong__f_lo;
    var lo = ((-blo) | 0);
    var hi = ((((-daysToSubtract.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
    return this.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo, hi));
  }
});
$c_Ljava_time_LocalDate.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) ? this : $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O(this, query));
});
$c_Ljava_time_LocalDate.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField(), this.toEpochDay__J());
});
$c_Ljava_time_LocalDate.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x === null) ? (unit === null) : (x === unit))) {
      return this.daysUntil__Ljava_time_LocalDate__J(end);
    }
    var x$3 = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
    if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
      var a = this.daysUntil__Ljava_time_LocalDate__J(end);
      var this$1 = $m_RTLong$();
      var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 7, 0);
      var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo, hi);
    }
    var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
    if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
      return $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
    }
    var x$7 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
    if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
      var a$1 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var this$2 = $m_RTLong$();
      var lo$1 = this$2.divideImpl__I__I__I__I__I(a$1.RTLong__f_lo, a$1.RTLong__f_hi, 12, 0);
      var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$1, hi$1);
    }
    var x$9 = $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit();
    if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
      var a$2 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var this$3 = $m_RTLong$();
      var lo$2 = this$3.divideImpl__I__I__I__I__I(a$2.RTLong__f_lo, a$2.RTLong__f_hi, 120, 0);
      var hi$2 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$2, hi$2);
    }
    var x$11 = $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit();
    if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
      var a$3 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var this$4 = $m_RTLong$();
      var lo$3 = this$4.divideImpl__I__I__I__I__I(a$3.RTLong__f_lo, a$3.RTLong__f_hi, 1200, 0);
      var hi$3 = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$3, hi$3);
    }
    var x$13 = $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit();
    if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
      var a$4 = $p_Ljava_time_LocalDate__monthsUntil__Ljava_time_LocalDate__J(this, end);
      var this$5 = $m_RTLong$();
      var lo$4 = this$5.divideImpl__I__I__I__I__I(a$4.RTLong__f_lo, a$4.RTLong__f_hi, 12000, 0);
      var hi$4 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      return new $c_RTLong(lo$4, hi$4);
    }
    var x$15 = $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit();
    if (((x$15 === null) ? (unit === null) : (x$15 === unit))) {
      var a$5 = end.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
      var b = this.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
      var alo = a$5.RTLong__f_lo;
      var blo = b.RTLong__f_lo;
      var lo$5 = ((alo - blo) | 0);
      var hi$5 = ((((a$5.RTLong__f_hi - b.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo$5)) >> 31)) | 0);
      return new $c_RTLong(lo$5, hi$5);
    }
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  } else {
    return unit.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end);
  }
});
$c_Ljava_time_LocalDate.prototype.daysUntil__Ljava_time_LocalDate__J = (function(end) {
  var a = end.toEpochDay__J();
  var b = this.toEpochDay__J();
  var alo = a.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var lo = ((alo - blo) | 0);
  var hi = ((((a.RTLong__f_hi - b.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
  return new $c_RTLong(lo, hi);
});
$c_Ljava_time_LocalDate.prototype.toEpochDay__J = (function() {
  var value = this.Ljava_time_LocalDate__f_year;
  var hi = (value >> 31);
  var value$1 = this.Ljava_time_LocalDate__f_month;
  var hi$1 = (value$1 >> 31);
  var total__lo = 0;
  var total__hi = 0;
  var a__lo = total__lo;
  var a__hi = total__hi;
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(365, b0);
  var a0b1 = Math.imul(365, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((Math.imul(365, hi) + ((c1part >>> 16) | 0)) | 0);
  var alo = a__lo;
  var lo$1 = ((alo + lo) | 0);
  var hi$3 = ((((a__hi + hi$2) | 0) + ((((alo & lo) | ((alo | lo) & (~lo$1))) >>> 31) | 0)) | 0);
  var $x_1__lo = lo$1;
  var $x_1__hi = hi$3;
  total__lo = $x_1__lo;
  total__hi = $x_1__hi;
  if ((hi >= 0)) {
    var a$1__lo = total__lo;
    var a$1__hi = total__hi;
    var lo$2 = ((3 + value) | 0);
    var hi$4 = ((hi + (((value & (~lo$2)) >>> 31) | 0)) | 0);
    var this$7 = $m_RTLong$();
    var lo$3 = this$7.divideImpl__I__I__I__I__I(lo$2, hi$4, 4, 0);
    var hi$5 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$4 = ((99 + value) | 0);
    var hi$6 = ((hi + (((value & (~lo$4)) >>> 31) | 0)) | 0);
    var this$9 = $m_RTLong$();
    var lo$5 = this$9.divideImpl__I__I__I__I__I(lo$4, hi$6, 100, 0);
    var hi$7 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$6 = ((lo$3 - lo$5) | 0);
    var hi$8 = ((((hi$5 - hi$7) | 0) + ((((~lo$3) & lo$5) | ((~(lo$3 ^ lo$5)) & lo$6)) >> 31)) | 0);
    var lo$7 = ((399 + value) | 0);
    var hi$9 = ((hi + (((value & (~lo$7)) >>> 31) | 0)) | 0);
    var this$12 = $m_RTLong$();
    var lo$8 = this$12.divideImpl__I__I__I__I__I(lo$7, hi$9, 400, 0);
    var hi$10 = this$12.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$9 = ((lo$6 + lo$8) | 0);
    var hi$11 = ((((hi$8 + hi$10) | 0) + ((((lo$6 & lo$8) | ((lo$6 | lo$8) & (~lo$9))) >>> 31) | 0)) | 0);
    var alo$1 = a$1__lo;
    var lo$10 = ((alo$1 + lo$9) | 0);
    var hi$12 = ((((a$1__hi + hi$11) | 0) + ((((alo$1 & lo$9) | ((alo$1 | lo$9) & (~lo$10))) >>> 31) | 0)) | 0);
    var $x_2__lo = lo$10;
    var $x_2__hi = hi$12;
    total__lo = $x_2__lo;
    total__hi = $x_2__hi;
  } else {
    var a$2__lo = total__lo;
    var a$2__hi = total__hi;
    var this$15 = $m_RTLong$();
    var lo$11 = this$15.divideImpl__I__I__I__I__I(value, hi, (-4), (-1));
    var hi$13 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var this$16 = $m_RTLong$();
    var lo$12 = this$16.divideImpl__I__I__I__I__I(value, hi, (-100), (-1));
    var hi$14 = this$16.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$13 = ((lo$11 - lo$12) | 0);
    var hi$15 = ((((hi$13 - hi$14) | 0) + ((((~lo$11) & lo$12) | ((~(lo$11 ^ lo$12)) & lo$13)) >> 31)) | 0);
    var this$18 = $m_RTLong$();
    var lo$14 = this$18.divideImpl__I__I__I__I__I(value, hi, (-400), (-1));
    var hi$16 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var lo$15 = ((lo$13 + lo$14) | 0);
    var hi$17 = ((((hi$15 + hi$16) | 0) + ((((lo$13 & lo$14) | ((lo$13 | lo$14) & (~lo$15))) >>> 31) | 0)) | 0);
    var alo$2 = a$2__lo;
    var lo$16 = ((alo$2 - lo$15) | 0);
    var hi$18 = ((((a$2__hi - hi$17) | 0) + ((((~alo$2) & lo$15) | ((~(alo$2 ^ lo$15)) & lo$16)) >> 31)) | 0);
    var $x_3__lo = lo$16;
    var $x_3__hi = hi$18;
    total__lo = $x_3__lo;
    total__hi = $x_3__hi;
  }
  var a$3__lo = total__lo;
  var a$3__hi = total__hi;
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(367, b0$1);
  var a0b1$1 = Math.imul(367, b1$1);
  var lo$17 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$19 = ((Math.imul(367, hi$1) + ((c1part$1 >>> 16) | 0)) | 0);
  var lo$18 = (((-362) + lo$17) | 0);
  var hi$20 = (((((-1) + hi$19) | 0) + (((lo$17 | (~lo$18)) >>> 31) | 0)) | 0);
  var this$23 = $m_RTLong$();
  var lo$19 = this$23.divideImpl__I__I__I__I__I(lo$18, hi$20, 12, 0);
  var hi$21 = this$23.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var alo$3 = a$3__lo;
  var lo$20 = ((alo$3 + lo$19) | 0);
  var hi$22 = ((((a$3__hi + hi$21) | 0) + ((((alo$3 & lo$19) | ((alo$3 | lo$19) & (~lo$20))) >>> 31) | 0)) | 0);
  var $x_4__lo = lo$20;
  var $x_4__hi = hi$22;
  total__lo = $x_4__lo;
  total__hi = $x_4__hi;
  var a$4__lo = total__lo;
  var a$4__hi = total__hi;
  var value$2 = (((-1) + this.Ljava_time_LocalDate__f_day) | 0);
  var hi$23 = (value$2 >> 31);
  var alo$4 = a$4__lo;
  var lo$21 = ((alo$4 + value$2) | 0);
  var hi$24 = ((((a$4__hi + hi$23) | 0) + ((((alo$4 & value$2) | ((alo$4 | value$2) & (~lo$21))) >>> 31) | 0)) | 0);
  var $x_5__lo = lo$21;
  var $x_5__hi = hi$24;
  total__lo = $x_5__lo;
  total__hi = $x_5__hi;
  if (((hi$1 === 0) ? ((value$1 >>> 0) > 2) : (hi$1 > 0))) {
    var b__lo = total__lo;
    var b__hi = total__hi;
    var blo = b__lo;
    var lo$22 = (((-1) + blo) | 0);
    var hi$25 = (((((-1) + b__hi) | 0) + (((blo | (~lo$22)) >>> 31) | 0)) | 0);
    var $x_6__lo = lo$22;
    var $x_6__hi = hi$25;
    total__lo = $x_6__lo;
    total__hi = $x_6__hi;
    var $x_7 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var value$3 = this.Ljava_time_LocalDate__f_year;
    var hi$26 = (value$3 >> 31);
    if ((!$x_7.isLeapYear__J__Z(new $c_RTLong(value$3, hi$26)))) {
      var b$1__lo = total__lo;
      var b$1__hi = total__hi;
      var blo$1 = b$1__lo;
      var lo$23 = (((-1) + blo$1) | 0);
      var hi$27 = (((((-1) + b$1__hi) | 0) + (((blo$1 | (~lo$23)) >>> 31) | 0)) | 0);
      var $x_8__lo = lo$23;
      var $x_8__hi = hi$27;
      total__lo = $x_8__lo;
      total__hi = $x_8__hi;
    }
  }
  var a$5__lo = total__lo;
  var a$5__hi = total__hi;
  var b$2 = $m_Ljava_time_LocalDate$().Ljava_time_LocalDate$__f_DAYS_0000_TO_1970;
  var alo$5 = a$5__lo;
  var blo$2 = b$2.RTLong__f_lo;
  var lo$24 = ((alo$5 - blo$2) | 0);
  var hi$28 = ((((a$5__hi - b$2.RTLong__f_hi) | 0) + ((((~alo$5) & blo$2) | ((~(alo$5 ^ blo$2)) & lo$24)) >> 31)) | 0);
  return new $c_RTLong(lo$24, hi$28);
});
$c_Ljava_time_LocalDate.prototype.compareTo__Ljava_time_chrono_ChronoLocalDate__I = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? this.compareTo0__Ljava_time_LocalDate__I(other) : $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I(this, other));
});
$c_Ljava_time_LocalDate.prototype.compareTo0__Ljava_time_LocalDate__I = (function(otherDate) {
  var cmp = ((this.Ljava_time_LocalDate__f_year - otherDate.Ljava_time_LocalDate__f_year) | 0);
  if ((cmp === 0)) {
    cmp = ((this.Ljava_time_LocalDate__f_month - otherDate.Ljava_time_LocalDate__f_month) | 0);
    if ((cmp === 0)) {
      cmp = ((this.Ljava_time_LocalDate__f_day - otherDate.Ljava_time_LocalDate__f_day) | 0);
    }
  }
  return cmp;
});
$c_Ljava_time_LocalDate.prototype.isAfter__Ljava_time_chrono_ChronoLocalDate__Z = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? (this.compareTo0__Ljava_time_LocalDate__I(other) > 0) : $f_Ljava_time_chrono_ChronoLocalDate__isAfter__Ljava_time_chrono_ChronoLocalDate__Z(this, other));
});
$c_Ljava_time_LocalDate.prototype.isBefore__Ljava_time_chrono_ChronoLocalDate__Z = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? (this.compareTo0__Ljava_time_LocalDate__I(other) < 0) : $f_Ljava_time_chrono_ChronoLocalDate__isBefore__Ljava_time_chrono_ChronoLocalDate__Z(this, other));
});
$c_Ljava_time_LocalDate.prototype.equals__O__Z = (function(obj) {
  return ((obj instanceof $c_Ljava_time_LocalDate) && ((this === obj) || (this.compareTo0__Ljava_time_LocalDate__I(obj) === 0)));
});
$c_Ljava_time_LocalDate.prototype.hashCode__I = (function() {
  var yearValue = this.Ljava_time_LocalDate__f_year;
  var monthValue = this.Ljava_time_LocalDate__f_month;
  var dayValue = this.Ljava_time_LocalDate__f_day;
  return (((-2048) & yearValue) ^ (((((yearValue << 11) + (monthValue << 6)) | 0) + dayValue) | 0));
});
$c_Ljava_time_LocalDate.prototype.toString__T = (function() {
  var yearValue = this.Ljava_time_LocalDate__f_year;
  var monthValue = this.Ljava_time_LocalDate__f_month;
  var dayValue = this.Ljava_time_LocalDate__f_day;
  var sign = (yearValue >> 31);
  var absYear = (((yearValue ^ sign) - sign) | 0);
  var buf = $ct_scm_StringBuilder__I__(new $c_scm_StringBuilder(), 10);
  if ((absYear < 1000)) {
    if ((yearValue < 0)) {
      buf.append__I__scm_StringBuilder((((-10000) + yearValue) | 0)).deleteCharAt__I__scm_StringBuilder(1);
    } else {
      buf.append__I__scm_StringBuilder(((10000 + yearValue) | 0)).deleteCharAt__I__scm_StringBuilder(0);
    }
  } else {
    if ((yearValue > 9999)) {
      buf.append__C__scm_StringBuilder(43);
    }
    buf.append__I__scm_StringBuilder(yearValue);
  }
  var this$2 = buf.append__T__scm_StringBuilder(((monthValue < 10) ? "-0" : "-")).append__I__scm_StringBuilder(monthValue).append__T__scm_StringBuilder(((dayValue < 10) ? "-0" : "-")).append__I__scm_StringBuilder(dayValue);
  return this$2.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return this.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDate(adjuster);
});
$c_Ljava_time_LocalDate.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate(field, newValue);
});
$c_Ljava_time_LocalDate.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(amountToAdd, unit);
});
$c_Ljava_time_LocalDate.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(amountToSubtract, unit);
});
$c_Ljava_time_LocalDate.prototype.compareTo__O__I = (function(that) {
  return this.compareTo__Ljava_time_chrono_ChronoLocalDate__I(that);
});
$c_Ljava_time_LocalDate.prototype.compare__O__I = (function(that) {
  return $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I(this, that);
});
function $isArrayOf_Ljava_time_LocalDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalDate)));
}
export { $isArrayOf_Ljava_time_LocalDate as $isArrayOf_Ljava_time_LocalDate };
var $d_Ljava_time_LocalDate = new $TypeData().initClass($c_Ljava_time_LocalDate, "java.time.LocalDate", ({
  Ljava_time_LocalDate: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_time_chrono_ChronoLocalDate: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_LocalDate as $d_Ljava_time_LocalDate };
function $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate, newTime) {
  return ((($thiz.Ljava_time_LocalDateTime__f_date === newDate) && ($thiz.Ljava_time_LocalDateTime__f_time === newTime)) ? $thiz : new $c_Ljava_time_LocalDateTime(newDate, newTime));
}
export { $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime as $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime };
function $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime($thiz, newDate, hours, minutes, seconds, nanos, sign) {
  var lo = (hours.RTLong__f_lo | minutes.RTLong__f_lo);
  var hi = (hours.RTLong__f_hi | minutes.RTLong__f_hi);
  var lo$1 = (lo | seconds.RTLong__f_lo);
  var hi$1 = (hi | seconds.RTLong__f_hi);
  var lo$2 = (lo$1 | nanos.RTLong__f_lo);
  var hi$2 = (hi$1 | nanos.RTLong__f_hi);
  if (((lo$2 === 0) && (hi$2 === 0))) {
    return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate, $thiz.Ljava_time_LocalDateTime__f_time);
  }
  var this$5 = $m_RTLong$();
  var lo$3 = this$5.divideImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-1857093632), 20116);
  var hi$3 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$6 = $m_RTLong$();
  var lo$4 = this$6.divideImpl__I__I__I__I__I(seconds.RTLong__f_lo, seconds.RTLong__f_hi, 86400, 0);
  var hi$4 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$5 = ((lo$3 + lo$4) | 0);
  var hi$5 = ((((hi$3 + hi$4) | 0) + ((((lo$3 & lo$4) | ((lo$3 | lo$4) & (~lo$5))) >>> 31) | 0)) | 0);
  var this$8 = $m_RTLong$();
  var lo$6 = this$8.divideImpl__I__I__I__I__I(minutes.RTLong__f_lo, minutes.RTLong__f_hi, 1440, 0);
  var hi$6 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$7 = ((lo$5 + lo$6) | 0);
  var hi$7 = ((((hi$5 + hi$6) | 0) + ((((lo$5 & lo$6) | ((lo$5 | lo$6) & (~lo$7))) >>> 31) | 0)) | 0);
  var this$10 = $m_RTLong$();
  var lo$8 = this$10.divideImpl__I__I__I__I__I(hours.RTLong__f_lo, hours.RTLong__f_hi, 24, 0);
  var hi$8 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var lo$9 = ((lo$7 + lo$8) | 0);
  var hi$9 = ((((hi$7 + hi$8) | 0) + ((((lo$7 & lo$8) | ((lo$7 | lo$8) & (~lo$9))) >>> 31) | 0)) | 0);
  var totDays__lo = lo$9;
  var totDays__hi = hi$9;
  var a__lo = totDays__lo;
  var a__hi = totDays__hi;
  var hi$10 = (sign >> 31);
  var alo = a__lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & sign);
  var b1 = ((sign >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo$10 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$11 = ((((((((Math.imul(alo, hi$10) + Math.imul(a__hi, sign)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var $x_1__lo = lo$10;
  var $x_1__hi = hi$11;
  totDays__lo = $x_1__lo;
  totDays__hi = $x_1__hi;
  var this$14 = $m_RTLong$();
  var lo$11 = this$14.remainderImpl__I__I__I__I__I(nanos.RTLong__f_lo, nanos.RTLong__f_hi, (-1857093632), 20116);
  var hi$12 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var this$15 = $m_RTLong$();
  var lo$12 = this$15.remainderImpl__I__I__I__I__I(seconds.RTLong__f_lo, seconds.RTLong__f_hi, 86400, 0);
  var hi$13 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b0$1 = (65535 & lo$12);
  var b1$1 = ((lo$12 >>> 16) | 0);
  var a0b0$1 = Math.imul(51712, b0$1);
  var a1b0$1 = Math.imul(15258, b0$1);
  var a0b1$1 = Math.imul(51712, b1$1);
  var lo$13 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$14 = ((((((Math.imul(1000000000, hi$13) + Math.imul(15258, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$14 = ((lo$11 + lo$13) | 0);
  var hi$15 = ((((hi$12 + hi$14) | 0) + ((((lo$11 & lo$13) | ((lo$11 | lo$13) & (~lo$14))) >>> 31) | 0)) | 0);
  var this$18 = $m_RTLong$();
  var lo$15 = this$18.remainderImpl__I__I__I__I__I(minutes.RTLong__f_lo, minutes.RTLong__f_hi, 1440, 0);
  var hi$16 = this$18.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b0$2 = (65535 & lo$15);
  var b1$2 = ((lo$15 >>> 16) | 0);
  var a0b0$2 = Math.imul(22528, b0$2);
  var a1b0$2 = Math.imul(63559, b0$2);
  var a0b1$2 = Math.imul(22528, b1$2);
  var lo$16 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$17 = ((((((((Math.imul((-129542144), hi$16) + Math.imul(13, lo$15)) | 0) + Math.imul(63559, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var lo$17 = ((lo$14 + lo$16) | 0);
  var hi$18 = ((((hi$15 + hi$17) | 0) + ((((lo$14 & lo$16) | ((lo$14 | lo$16) & (~lo$17))) >>> 31) | 0)) | 0);
  var this$21 = $m_RTLong$();
  var lo$18 = this$21.remainderImpl__I__I__I__I__I(hours.RTLong__f_lo, hours.RTLong__f_hi, 24, 0);
  var hi$19 = this$21.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var b0$3 = (65535 & lo$18);
  var b1$3 = ((lo$18 >>> 16) | 0);
  var a0b0$3 = Math.imul(40960, b0$3);
  var a1b0$3 = Math.imul(12472, b0$3);
  var a0b1$3 = Math.imul(40960, b1$3);
  var lo$19 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$20 = ((((((((Math.imul(817405952, hi$19) + Math.imul(838, lo$18)) | 0) + Math.imul(12472, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$20 = ((lo$17 + lo$19) | 0);
  var hi$21 = ((((hi$18 + hi$20) | 0) + ((((lo$17 & lo$19) | ((lo$17 | lo$19) & (~lo$20))) >>> 31) | 0)) | 0);
  var totNanos__lo = lo$20;
  var totNanos__hi = hi$21;
  var t = $thiz.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
  var lo$21 = t.RTLong__f_lo;
  var hi$22 = t.RTLong__f_hi;
  var a$1__lo = totNanos__lo;
  var a$1__hi = totNanos__hi;
  var hi$23 = (sign >> 31);
  var alo$1 = a$1__lo;
  var a0$1 = (65535 & alo$1);
  var a1$1 = ((alo$1 >>> 16) | 0);
  var b0$4 = (65535 & sign);
  var b1$4 = ((sign >>> 16) | 0);
  var a0b0$4 = Math.imul(a0$1, b0$4);
  var a1b0$4 = Math.imul(a1$1, b0$4);
  var a0b1$4 = Math.imul(a0$1, b1$4);
  var lo$22 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$24 = ((((((((Math.imul(alo$1, hi$23) + Math.imul(a$1__hi, sign)) | 0) + Math.imul(a1$1, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var lo$23 = ((lo$22 + lo$21) | 0);
  var hi$25 = ((((hi$24 + hi$22) | 0) + ((((lo$22 & lo$21) | ((lo$22 | lo$21) & (~lo$23))) >>> 31) | 0)) | 0);
  var $x_2__lo = lo$23;
  var $x_2__hi = hi$25;
  totNanos__lo = $x_2__lo;
  totNanos__hi = $x_2__hi;
  var a$3__lo = totDays__lo;
  var a$3__hi = totDays__hi;
  var a$2__lo = totNanos__lo;
  var a$2__hi = totNanos__hi;
  var this$28 = $m_RTLong$();
  var lo$24 = this$28.divideImpl__I__I__I__I__I(a$2__lo, a$2__hi, (-1857093632), 20116);
  var hi$26 = this$28.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var hi$27 = (20116 ^ a$2__hi);
  if ((hi$27 >= 0)) {
    var $x_3 = true;
  } else {
    var b0$5 = (65535 & lo$24);
    var b1$5 = ((lo$24 >>> 16) | 0);
    var a1b0$5 = Math.imul(37199, b0$5);
    var lo$26 = (a1b0$5 << 16);
    var hi$28 = ((((((Math.imul((-1857093632), hi$26) + Math.imul(20116, lo$24)) | 0) + Math.imul(37199, b1$5)) | 0) + ((a1b0$5 >>> 16) | 0)) | 0);
    var $x_3 = ((lo$26 === a$2__lo) && (hi$28 === a$2__hi));
  }
  if ($x_3) {
    var b__lo = lo$24;
    var b__hi = hi$26;
  } else {
    var lo$27 = (((-1) + lo$24) | 0);
    var hi$29 = (((((-1) + hi$26) | 0) + (((lo$24 | (~lo$27)) >>> 31) | 0)) | 0);
    var b__lo = lo$27;
    var b__hi = hi$29;
  }
  var alo$2 = a$3__lo;
  var blo = b__lo;
  var lo$28 = ((alo$2 + blo) | 0);
  var hi$30 = ((((a$3__hi + b__hi) | 0) + ((((alo$2 & blo) | ((alo$2 | blo) & (~lo$28))) >>> 31) | 0)) | 0);
  var $x_4__lo = lo$28;
  var $x_4__hi = hi$30;
  totDays__lo = $x_4__lo;
  totDays__hi = $x_4__hi;
  var a$4__lo = totNanos__lo;
  var a$4__hi = totNanos__hi;
  var this$36 = $m_RTLong$();
  var lo$29 = this$36.remainderImpl__I__I__I__I__I(a$4__lo, a$4__hi, (-1857093632), 20116);
  var hi$31 = this$36.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var hi$32 = (20116 ^ a$4__hi);
  if (((hi$32 >= 0) || ((lo$29 === 0) && (hi$31 === 0)))) {
    var newNoD__lo = lo$29;
    var newNoD__hi = hi$31;
  } else {
    var lo$31 = (((-1857093632) + lo$29) | 0);
    var hi$33 = ((((20116 + hi$31) | 0) + (((lo$29 | (~lo$31)) >>> 31) | 0)) | 0);
    var newNoD__lo = lo$31;
    var newNoD__hi = hi$33;
  }
  var newTime = (((newNoD__lo === lo$21) && (newNoD__hi === hi$22)) ? $thiz.Ljava_time_LocalDateTime__f_time : $m_Ljava_time_LocalTime$().ofNanoOfDay__J__Ljava_time_LocalTime(new $c_RTLong(newNoD__lo, newNoD__hi)));
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(totDays__lo, totDays__hi)), newTime);
}
export { $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime as $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime };
function $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I($thiz, other) {
  var cmp = $thiz.Ljava_time_LocalDateTime__f_date.compareTo0__Ljava_time_LocalDate__I(other.Ljava_time_LocalDateTime__f_date);
  if ((cmp === 0)) {
    var this$1 = $thiz.Ljava_time_LocalDateTime__f_time;
    var other$1 = other.Ljava_time_LocalDateTime__f_time;
    cmp = this$1.compare__Ljava_time_LocalTime__I(other$1);
  }
  return cmp;
}
export { $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I as $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I };
/** @constructor */
function $c_Ljava_time_LocalDateTime(date, time) {
  this.Ljava_time_LocalDateTime__f_date = null;
  this.Ljava_time_LocalDateTime__f_time = null;
  this.Ljava_time_LocalDateTime__f_date = date;
  this.Ljava_time_LocalDateTime__f_time = time;
}
export { $c_Ljava_time_LocalDateTime as $c_Ljava_time_LocalDateTime };
$c_Ljava_time_LocalDateTime.prototype = new $h_Ljava_time_chrono_ChronoLocalDateTime();
$c_Ljava_time_LocalDateTime.prototype.constructor = $c_Ljava_time_LocalDateTime;
/** @constructor */
function $h_Ljava_time_LocalDateTime() {
}
export { $h_Ljava_time_LocalDateTime as $h_Ljava_time_LocalDateTime };
$h_Ljava_time_LocalDateTime.prototype = $c_Ljava_time_LocalDateTime.prototype;
$c_Ljava_time_LocalDateTime.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field.isDateBased__Z() || field.isTimeBased__Z()) : ((field !== null) && field.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)));
});
$c_Ljava_time_LocalDateTime.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    if (field.isTimeBased__Z()) {
      var this$1 = this.Ljava_time_LocalDateTime__f_time;
      return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this$1, field);
    } else {
      return this.Ljava_time_LocalDateTime__f_date.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field);
    }
  } else {
    return field.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this);
  }
});
$c_Ljava_time_LocalDateTime.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field.isTimeBased__Z() ? this.Ljava_time_LocalDateTime__f_time.get__Ljava_time_temporal_TemporalField__I(field) : this.Ljava_time_LocalDateTime__f_date.get__Ljava_time_temporal_TemporalField__I(field)) : $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field));
});
$c_Ljava_time_LocalDateTime.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field.isTimeBased__Z() ? this.Ljava_time_LocalDateTime__f_time.getLong__Ljava_time_temporal_TemporalField__J(field) : this.Ljava_time_LocalDateTime__f_date.getLong__Ljava_time_temporal_TemporalField__J(field)) : field.getFrom__Ljava_time_temporal_TemporalAccessor__J(this));
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDateTime = (function(adjuster) {
  return ((adjuster instanceof $c_Ljava_time_LocalDate) ? $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, adjuster, this.Ljava_time_LocalDateTime__f_time) : ((adjuster instanceof $c_Ljava_time_LocalTime) ? $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, adjuster) : ((adjuster instanceof $c_Ljava_time_LocalDateTime) ? adjuster : adjuster.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal(this))));
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime = (function(field, newValue) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field.isTimeBased__Z() ? $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, this.Ljava_time_LocalDateTime__f_time.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalTime(field, newValue)) : $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate(field, newValue), this.Ljava_time_LocalDateTime__f_time)) : field.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, newValue));
});
$c_Ljava_time_LocalDateTime.prototype.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime = (function(unit) {
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, this.Ljava_time_LocalDateTime__f_time.truncatedTo__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalTime(unit));
});
$c_Ljava_time_LocalDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime = (function(amountToAdd, unit) {
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    var x = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if (((x === null) ? (unit === null) : (x === unit))) {
      return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $L0, $L0, $L0, amountToAdd, 1);
    } else {
      var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
      if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
        var this$1 = $m_RTLong$();
        var lo = this$1.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 500654080, 20);
        var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$4 = this.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(lo, hi));
        var this$2 = $m_RTLong$();
        var lo$1 = this$2.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 500654080, 20);
        var hi$1 = this$2.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var b0 = (65535 & lo$1);
        var b1 = ((lo$1 >>> 16) | 0);
        var a0b0 = Math.imul(1000, b0);
        var a0b1 = Math.imul(1000, b1);
        var lo$2 = ((a0b0 + (a0b1 << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$2 = ((Math.imul(1000, hi$1) + ((c1part >>> 16) | 0)) | 0);
        return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$4, this$4.Ljava_time_LocalDateTime__f_date, $L0, $L0, $L0, new $c_RTLong(lo$2, hi$2), 1);
      } else {
        var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
        if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
          var this$5 = $m_RTLong$();
          var lo$3 = this$5.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 86400000, 0);
          var hi$3 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var this$8 = this.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(lo$3, hi$3));
          var this$6 = $m_RTLong$();
          var lo$4 = this$6.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 86400000, 0);
          var hi$4 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var b0$1 = (65535 & lo$4);
          var b1$1 = ((lo$4 >>> 16) | 0);
          var a0b0$1 = Math.imul(16960, b0$1);
          var a1b0 = Math.imul(15, b0$1);
          var a0b1$1 = Math.imul(16960, b1$1);
          var lo$5 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$5 = ((((((Math.imul(1000000, hi$4) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
          return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$8, this$8.Ljava_time_LocalDateTime__f_date, $L0, $L0, $L0, new $c_RTLong(lo$5, hi$5), 1);
        } else {
          var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
          if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
            return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $L0, $L0, amountToAdd, $L0, 1);
          } else {
            var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
            if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
              return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, $L0, amountToAdd, $L0, $L0, 1);
            } else {
              var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
              if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
                return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date, amountToAdd, $L0, $L0, $L0, 1);
              } else {
                var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
                  var this$9 = $m_RTLong$();
                  var lo$6 = this$9.divideImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 256, 0);
                  var hi$6 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  var this$12 = this.plusDays__J__Ljava_time_LocalDateTime(new $c_RTLong(lo$6, hi$6));
                  var this$10 = $m_RTLong$();
                  var lo$7 = this$10.remainderImpl__I__I__I__I__I(amountToAdd.RTLong__f_lo, amountToAdd.RTLong__f_hi, 256, 0);
                  var hi$7 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
                  var b0$2 = (65535 & lo$7);
                  var b1$2 = ((lo$7 >>> 16) | 0);
                  var a0b0$2 = Math.imul(12, b0$2);
                  var a0b1$2 = Math.imul(12, b1$2);
                  var lo$8 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
                  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
                  var hi$8 = ((Math.imul(12, hi$7) + ((c1part$2 >>> 16) | 0)) | 0);
                  return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$12, this$12.Ljava_time_LocalDateTime__f_date, new $c_RTLong(lo$8, hi$8), $L0, $L0, $L0, 1);
                } else {
                  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.Ljava_time_LocalDateTime__f_date.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDate(amountToAdd, unit), this.Ljava_time_LocalDateTime__f_time);
                }
              }
            }
          }
        }
      }
    }
  } else {
    return unit.addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal(this, amountToAdd);
  }
});
$c_Ljava_time_LocalDateTime.prototype.plusDays__J__Ljava_time_LocalDateTime = (function(days) {
  var newDate = this.Ljava_time_LocalDateTime__f_date.plusDays__J__Ljava_time_LocalDate(days);
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, newDate, this.Ljava_time_LocalDateTime__f_time);
});
$c_Ljava_time_LocalDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime = (function(amountToSubtract, unit) {
  if (((amountToSubtract.RTLong__f_lo === 0) && (amountToSubtract.RTLong__f_hi === (-2147483648)))) {
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(new $c_RTLong((-1), 2147483647), unit).plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(new $c_RTLong(1, 0), unit);
  } else {
    var blo = amountToSubtract.RTLong__f_lo;
    var lo = ((-blo) | 0);
    var hi = ((((-amountToSubtract.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
    return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(new $c_RTLong(lo, hi), unit);
  }
});
$c_Ljava_time_LocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) ? this.Ljava_time_LocalDateTime__f_date : $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.query__Ljava_time_temporal_TemporalQuery__O.call(this, query));
});
$c_Ljava_time_LocalDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  return $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal.call(this, temporal);
});
$c_Ljava_time_LocalDateTime.prototype.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J = (function(endExclusive, unit) {
  var end = $m_Ljava_time_LocalDateTime$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDateTime(endExclusive);
  if ((unit instanceof $c_Ljava_time_temporal_ChronoUnit)) {
    if (unit.isTimeBased__Z()) {
      var t = this.Ljava_time_LocalDateTime__f_date.daysUntil__Ljava_time_LocalDate__J(end.Ljava_time_LocalDateTime__f_date);
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var daysUntil__lo = lo;
      var daysUntil__hi = hi;
      var a = end.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
      var b = this.Ljava_time_LocalDateTime__f_time.toNanoOfDay__J();
      var alo = a.RTLong__f_lo;
      var blo = b.RTLong__f_lo;
      var lo$1 = ((alo - blo) | 0);
      var hi$1 = ((((a.RTLong__f_hi - b.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo$1)) >> 31)) | 0);
      var timeUntil__lo = lo$1;
      var timeUntil__hi = hi$1;
      var a$1__lo = daysUntil__lo;
      var a$1__hi = daysUntil__hi;
      var ahi = a$1__hi;
      if (((ahi === 0) ? (a$1__lo !== 0) : (ahi > 0))) {
        var a$2__lo = timeUntil__lo;
        var a$2__hi = timeUntil__hi;
        var ahi$1 = a$2__hi;
        var $x_1 = (ahi$1 < 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var b$1__lo = daysUntil__lo;
        var b$1__hi = daysUntil__hi;
        var blo$1 = b$1__lo;
        var lo$2 = (((-1) + blo$1) | 0);
        var hi$2 = (((((-1) + b$1__hi) | 0) + (((blo$1 | (~lo$2)) >>> 31) | 0)) | 0);
        var $x_2__lo = lo$2;
        var $x_2__hi = hi$2;
        daysUntil__lo = $x_2__lo;
        daysUntil__hi = $x_2__hi;
        var b$2__lo = timeUntil__lo;
        var b$2__hi = timeUntil__hi;
        var blo$2 = b$2__lo;
        var lo$3 = (((-1857093632) + blo$2) | 0);
        var hi$3 = ((((20116 + b$2__hi) | 0) + (((blo$2 | (~lo$3)) >>> 31) | 0)) | 0);
        var $x_3__lo = lo$3;
        var $x_3__hi = hi$3;
        timeUntil__lo = $x_3__lo;
        timeUntil__hi = $x_3__hi;
      } else {
        var a$3__lo = daysUntil__lo;
        var a$3__hi = daysUntil__hi;
        var ahi$2 = a$3__hi;
        if ((ahi$2 < 0)) {
          var a$4__lo = timeUntil__lo;
          var a$4__hi = timeUntil__hi;
          var ahi$3 = a$4__hi;
          var $x_4 = ((ahi$3 === 0) ? (a$4__lo !== 0) : (ahi$3 > 0));
        } else {
          var $x_4 = false;
        }
        if ($x_4) {
          var b$3__lo = daysUntil__lo;
          var b$3__hi = daysUntil__hi;
          var blo$3 = b$3__lo;
          var lo$4 = ((1 + blo$3) | 0);
          var hi$4 = ((b$3__hi + (((blo$3 & (~lo$4)) >>> 31) | 0)) | 0);
          var $x_5__lo = lo$4;
          var $x_5__hi = hi$4;
          daysUntil__lo = $x_5__lo;
          daysUntil__hi = $x_5__hi;
          var b$4__lo = timeUntil__lo;
          var b$4__hi = timeUntil__hi;
          var blo$4 = b$4__lo;
          var lo$5 = ((1857093632 + blo$4) | 0);
          var hi$5 = (((((-20117) + b$4__hi) | 0) + (((blo$4 & (~lo$5)) >>> 31) | 0)) | 0);
          var $x_6__lo = lo$5;
          var $x_6__hi = hi$5;
          timeUntil__lo = $x_6__lo;
          timeUntil__hi = $x_6__hi;
        }
      }
      var x = $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
      if (((x === null) ? (unit === null) : (x === unit))) {
        var a$5__lo = daysUntil__lo;
        var a$5__hi = daysUntil__hi;
        var this$10 = $m_jl_Math$();
        var blo$5 = a$5__lo;
        var b0 = (65535 & blo$5);
        var b1 = ((blo$5 >>> 16) | 0);
        var a1b0 = Math.imul(37199, b0);
        var lo$6 = (a1b0 << 16);
        var hi$6 = ((((((Math.imul((-1857093632), a$5__hi) + Math.imul(20116, blo$5)) | 0) + Math.imul(37199, b1)) | 0) + ((a1b0 >>> 16) | 0)) | 0);
        if ((!((a$5__lo === 0) && (a$5__hi === 0)))) {
          var this$14 = $m_RTLong$();
          var lo$7 = this$14.divideImpl__I__I__I__I__I(lo$6, hi$6, a$5__lo, a$5__hi);
          var hi$7 = this$14.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_7 = (!((lo$7 === (-1857093632)) && (hi$7 === 20116)));
        } else {
          var $x_7 = false;
        }
        if ($x_7) {
          this$10.java$lang$Math$$longOverflow__E();
        }
        var b$5__lo = timeUntil__lo;
        var b$5__hi = timeUntil__hi;
        var this$16 = $m_jl_Math$();
        var blo$6 = b$5__lo;
        var lo$8 = ((lo$6 + blo$6) | 0);
        var hi$8 = ((((hi$6 + b$5__hi) | 0) + ((((lo$6 & blo$6) | ((lo$6 | blo$6) & (~lo$8))) >>> 31) | 0)) | 0);
        var hi$9 = (hi$8 ^ hi$6);
        var hi$10 = (hi$8 ^ b$5__hi);
        var hi$11 = (hi$9 & hi$10);
        if ((hi$11 < 0)) {
          this$16.java$lang$Math$$longOverflow__E();
        }
        return new $c_RTLong(lo$8, hi$8);
      }
      var x$3 = $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
      if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
        var a$6__lo = daysUntil__lo;
        var a$6__hi = daysUntil__hi;
        var this$22 = $m_jl_Math$();
        var blo$7 = a$6__lo;
        var b0$1 = (65535 & blo$7);
        var b1$1 = ((blo$7 >>> 16) | 0);
        var a0b0 = Math.imul(24576, b0$1);
        var a1b0$1 = Math.imul(7639, b0$1);
        var a0b1 = Math.imul(24576, b1$1);
        var lo$12 = ((a0b0 + (((a1b0$1 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$12 = ((((((((Math.imul(500654080, a$6__hi) + Math.imul(20, blo$7)) | 0) + Math.imul(7639, b1$1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        if ((!((a$6__lo === 0) && (a$6__hi === 0)))) {
          var this$26 = $m_RTLong$();
          var lo$13 = this$26.divideImpl__I__I__I__I__I(lo$12, hi$12, a$6__lo, a$6__hi);
          var hi$13 = this$26.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_8 = (!((lo$13 === 500654080) && (hi$13 === 20)));
        } else {
          var $x_8 = false;
        }
        if ($x_8) {
          this$22.java$lang$Math$$longOverflow__E();
        }
        var a$7__lo = timeUntil__lo;
        var a$7__hi = timeUntil__hi;
        var this$28 = $m_RTLong$();
        var lo$14 = this$28.divideImpl__I__I__I__I__I(a$7__lo, a$7__hi, 1000, 0);
        var hi$14 = this$28.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$29 = $m_jl_Math$();
        var lo$15 = ((lo$12 + lo$14) | 0);
        var hi$15 = ((((hi$12 + hi$14) | 0) + ((((lo$12 & lo$14) | ((lo$12 | lo$14) & (~lo$15))) >>> 31) | 0)) | 0);
        var hi$16 = (hi$15 ^ hi$12);
        var hi$17 = (hi$15 ^ hi$14);
        var hi$18 = (hi$16 & hi$17);
        if ((hi$18 < 0)) {
          this$29.java$lang$Math$$longOverflow__E();
        }
        return new $c_RTLong(lo$15, hi$15);
      }
      var x$5 = $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
      if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
        var a$8__lo = daysUntil__lo;
        var a$8__hi = daysUntil__hi;
        var this$35 = $m_jl_Math$();
        var blo$8 = a$8__lo;
        var b0$2 = (65535 & blo$8);
        var b1$2 = ((blo$8 >>> 16) | 0);
        var a0b0$1 = Math.imul(23552, b0$2);
        var a1b0$2 = Math.imul(1318, b0$2);
        var a0b1$1 = Math.imul(23552, b1$2);
        var lo$19 = ((a0b0$1 + (((a1b0$2 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$19 = ((((((Math.imul(86400000, a$8__hi) + Math.imul(1318, b1$2)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$2) | 0) >>> 16) | 0)) | 0);
        if ((!((a$8__lo === 0) && (a$8__hi === 0)))) {
          var this$39 = $m_RTLong$();
          var lo$20 = this$39.divideImpl__I__I__I__I__I(lo$19, hi$19, a$8__lo, a$8__hi);
          var hi$20 = this$39.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_9 = (!((lo$20 === 86400000) && (hi$20 === 0)));
        } else {
          var $x_9 = false;
        }
        if ($x_9) {
          this$35.java$lang$Math$$longOverflow__E();
        }
        var a$9__lo = timeUntil__lo;
        var a$9__hi = timeUntil__hi;
        var this$41 = $m_RTLong$();
        var lo$21 = this$41.divideImpl__I__I__I__I__I(a$9__lo, a$9__hi, 1000000, 0);
        var hi$21 = this$41.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$42 = $m_jl_Math$();
        var lo$22 = ((lo$19 + lo$21) | 0);
        var hi$22 = ((((hi$19 + hi$21) | 0) + ((((lo$19 & lo$21) | ((lo$19 | lo$21) & (~lo$22))) >>> 31) | 0)) | 0);
        var hi$23 = (hi$22 ^ hi$19);
        var hi$24 = (hi$22 ^ hi$21);
        var hi$25 = (hi$23 & hi$24);
        if ((hi$25 < 0)) {
          this$42.java$lang$Math$$longOverflow__E();
        }
        return new $c_RTLong(lo$22, hi$22);
      }
      var x$7 = $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
      if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
        var a$10__lo = daysUntil__lo;
        var a$10__hi = daysUntil__hi;
        var this$48 = $m_jl_Math$();
        var blo$9 = a$10__lo;
        var b0$3 = (65535 & blo$9);
        var b1$3 = ((blo$9 >>> 16) | 0);
        var a0b0$2 = Math.imul(20864, b0$3);
        var a0b1$2 = Math.imul(20864, b1$3);
        var lo$26 = ((a0b0$2 + (((b0$3 + a0b1$2) | 0) << 16)) | 0);
        var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
        var hi$26 = ((((((Math.imul(86400, a$10__hi) + b1$3) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + b0$3) | 0) >>> 16) | 0)) | 0);
        if ((!((a$10__lo === 0) && (a$10__hi === 0)))) {
          var this$52 = $m_RTLong$();
          var lo$27 = this$52.divideImpl__I__I__I__I__I(lo$26, hi$26, a$10__lo, a$10__hi);
          var hi$27 = this$52.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_10 = (!((lo$27 === 86400) && (hi$27 === 0)));
        } else {
          var $x_10 = false;
        }
        if ($x_10) {
          this$48.java$lang$Math$$longOverflow__E();
        }
        var a$11__lo = timeUntil__lo;
        var a$11__hi = timeUntil__hi;
        var this$54 = $m_RTLong$();
        var lo$28 = this$54.divideImpl__I__I__I__I__I(a$11__lo, a$11__hi, 1000000000, 0);
        var hi$28 = this$54.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$55 = $m_jl_Math$();
        var lo$29 = ((lo$26 + lo$28) | 0);
        var hi$29 = ((((hi$26 + hi$28) | 0) + ((((lo$26 & lo$28) | ((lo$26 | lo$28) & (~lo$29))) >>> 31) | 0)) | 0);
        var hi$30 = (hi$29 ^ hi$26);
        var hi$31 = (hi$29 ^ hi$28);
        var hi$32 = (hi$30 & hi$31);
        if ((hi$32 < 0)) {
          this$55.java$lang$Math$$longOverflow__E();
        }
        return new $c_RTLong(lo$29, hi$29);
      }
      var x$9 = $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
      if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
        var a$12__lo = daysUntil__lo;
        var a$12__hi = daysUntil__hi;
        var this$61 = $m_jl_Math$();
        var blo$10 = a$12__lo;
        var b0$4 = (65535 & blo$10);
        var b1$4 = ((blo$10 >>> 16) | 0);
        var a0b0$3 = Math.imul(1440, b0$4);
        var a0b1$3 = Math.imul(1440, b1$4);
        var lo$33 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
        var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
        var hi$33 = ((Math.imul(1440, a$12__hi) + ((c1part$3 >>> 16) | 0)) | 0);
        if ((!((a$12__lo === 0) && (a$12__hi === 0)))) {
          var this$65 = $m_RTLong$();
          var lo$34 = this$65.divideImpl__I__I__I__I__I(lo$33, hi$33, a$12__lo, a$12__hi);
          var hi$34 = this$65.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_11 = (!((lo$34 === 1440) && (hi$34 === 0)));
        } else {
          var $x_11 = false;
        }
        if ($x_11) {
          this$61.java$lang$Math$$longOverflow__E();
        }
        var a$13__lo = timeUntil__lo;
        var a$13__hi = timeUntil__hi;
        var this$67 = $m_RTLong$();
        var lo$35 = this$67.divideImpl__I__I__I__I__I(a$13__lo, a$13__hi, (-129542144), 13);
        var hi$35 = this$67.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$68 = $m_jl_Math$();
        var lo$36 = ((lo$33 + lo$35) | 0);
        var hi$36 = ((((hi$33 + hi$35) | 0) + ((((lo$33 & lo$35) | ((lo$33 | lo$35) & (~lo$36))) >>> 31) | 0)) | 0);
        var hi$37 = (hi$36 ^ hi$33);
        var hi$38 = (hi$36 ^ hi$35);
        var hi$39 = (hi$37 & hi$38);
        if ((hi$39 < 0)) {
          this$68.java$lang$Math$$longOverflow__E();
        }
        return new $c_RTLong(lo$36, hi$36);
      }
      var x$11 = $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
      if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
        var a$14__lo = daysUntil__lo;
        var a$14__hi = daysUntil__hi;
        var this$74 = $m_jl_Math$();
        var blo$11 = a$14__lo;
        var b0$5 = (65535 & blo$11);
        var b1$5 = ((blo$11 >>> 16) | 0);
        var a0b0$4 = Math.imul(24, b0$5);
        var a0b1$4 = Math.imul(24, b1$5);
        var lo$40 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
        var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
        var hi$40 = ((Math.imul(24, a$14__hi) + ((c1part$4 >>> 16) | 0)) | 0);
        if ((!((a$14__lo === 0) && (a$14__hi === 0)))) {
          var this$78 = $m_RTLong$();
          var lo$41 = this$78.divideImpl__I__I__I__I__I(lo$40, hi$40, a$14__lo, a$14__hi);
          var hi$41 = this$78.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_12 = (!((lo$41 === 24) && (hi$41 === 0)));
        } else {
          var $x_12 = false;
        }
        if ($x_12) {
          this$74.java$lang$Math$$longOverflow__E();
        }
        var a$15__lo = timeUntil__lo;
        var a$15__hi = timeUntil__hi;
        var this$80 = $m_RTLong$();
        var lo$42 = this$80.divideImpl__I__I__I__I__I(a$15__lo, a$15__hi, 817405952, 838);
        var hi$42 = this$80.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$81 = $m_jl_Math$();
        var lo$43 = ((lo$40 + lo$42) | 0);
        var hi$43 = ((((hi$40 + hi$42) | 0) + ((((lo$40 & lo$42) | ((lo$40 | lo$42) & (~lo$43))) >>> 31) | 0)) | 0);
        var hi$44 = (hi$43 ^ hi$40);
        var hi$45 = (hi$43 ^ hi$42);
        var hi$46 = (hi$44 & hi$45);
        if ((hi$46 < 0)) {
          this$81.java$lang$Math$$longOverflow__E();
        }
        return new $c_RTLong(lo$43, hi$43);
      }
      var x$13 = $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
      if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
        var a$16__lo = daysUntil__lo;
        var a$16__hi = daysUntil__hi;
        var this$87 = $m_jl_Math$();
        var lo$47 = a$16__lo;
        var lo$48 = (lo$47 << 1);
        var hi$47 = (((lo$47 >>> 31) | 0) | (a$16__hi << 1));
        if ((!((a$16__lo === 0) && (a$16__hi === 0)))) {
          var this$91 = $m_RTLong$();
          var lo$49 = this$91.divideImpl__I__I__I__I__I(lo$48, hi$47, a$16__lo, a$16__hi);
          var hi$48 = this$91.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var $x_13 = (!((lo$49 === 2) && (hi$48 === 0)));
        } else {
          var $x_13 = false;
        }
        if ($x_13) {
          this$87.java$lang$Math$$longOverflow__E();
        }
        var a$17__lo = timeUntil__lo;
        var a$17__hi = timeUntil__hi;
        var this$93 = $m_RTLong$();
        var lo$50 = this$93.divideImpl__I__I__I__I__I(a$17__lo, a$17__hi, 1218936832, 10058);
        var hi$49 = this$93.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$94 = $m_jl_Math$();
        var lo$51 = ((lo$48 + lo$50) | 0);
        var hi$50 = ((((hi$47 + hi$49) | 0) + ((((lo$48 & lo$50) | ((lo$48 | lo$50) & (~lo$51))) >>> 31) | 0)) | 0);
        var hi$51 = (hi$50 ^ hi$47);
        var hi$52 = (hi$50 ^ hi$49);
        var hi$53 = (hi$51 & hi$52);
        if ((hi$53 < 0)) {
          this$94.java$lang$Math$$longOverflow__E();
        }
        return new $c_RTLong(lo$51, hi$50);
      }
      throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
    }
    var endDate = ((end.Ljava_time_LocalDateTime__f_date.isAfter__Ljava_time_chrono_ChronoLocalDate__Z(this.Ljava_time_LocalDateTime__f_date) && end.Ljava_time_LocalDateTime__f_time.isBefore__Ljava_time_LocalTime__Z(this.Ljava_time_LocalDateTime__f_time)) ? end.Ljava_time_LocalDateTime__f_date.minusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0)) : ((end.Ljava_time_LocalDateTime__f_date.isBefore__Ljava_time_chrono_ChronoLocalDate__Z(this.Ljava_time_LocalDateTime__f_date) && end.Ljava_time_LocalDateTime__f_time.isAfter__Ljava_time_LocalTime__Z(this.Ljava_time_LocalDateTime__f_time)) ? end.Ljava_time_LocalDateTime__f_date.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(1, 0)) : end.Ljava_time_LocalDateTime__f_date));
    return this.Ljava_time_LocalDateTime__f_date.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(endDate, unit);
  } else {
    return unit.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J(this, end);
  }
});
$c_Ljava_time_LocalDateTime.prototype.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDateTime) ? $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I(this, other) : this.compare__Ljava_time_chrono_ChronoLocalDateTime__I(other));
});
$c_Ljava_time_LocalDateTime.prototype.isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDateTime) ? ($p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I(this, other) > 0) : $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isAfter__Ljava_time_chrono_ChronoLocalDateTime__Z.call(this, other));
});
$c_Ljava_time_LocalDateTime.prototype.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDateTime) ? ($p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I(this, other) < 0) : $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.isBefore__Ljava_time_chrono_ChronoLocalDateTime__Z.call(this, other));
});
$c_Ljava_time_LocalDateTime.prototype.equals__O__Z = (function(obj) {
  if ((obj instanceof $c_Ljava_time_LocalDateTime)) {
    if ((this === obj)) {
      return true;
    } else {
      var x = this.Ljava_time_LocalDateTime__f_date;
      var x$2 = obj.Ljava_time_LocalDateTime__f_date;
      if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
        var x$3 = this.Ljava_time_LocalDateTime__f_time;
        var x$4 = obj.Ljava_time_LocalDateTime__f_time;
        return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$c_Ljava_time_LocalDateTime.prototype.hashCode__I = (function() {
  return (this.Ljava_time_LocalDateTime__f_date.hashCode__I() ^ this.Ljava_time_LocalDateTime__f_time.hashCode__I());
});
$c_Ljava_time_LocalDateTime.prototype.toString__T = (function() {
  return ((this.Ljava_time_LocalDateTime__f_date.toString__T() + "T") + this.Ljava_time_LocalDateTime__f_time.toString__T());
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal = (function(adjuster) {
  return this.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_LocalDateTime(adjuster);
});
$c_Ljava_time_LocalDateTime.prototype.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal = (function(field, newValue) {
  return this.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDateTime(field, newValue);
});
$c_Ljava_time_LocalDateTime.prototype.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToAdd, unit) {
  return this.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToAdd, unit);
});
$c_Ljava_time_LocalDateTime.prototype.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal = (function(amountToSubtract, unit) {
  return this.minus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_LocalDateTime(amountToSubtract, unit);
});
$c_Ljava_time_LocalDateTime.prototype.compareTo__O__I = (function(that) {
  return this.compareTo__Ljava_time_chrono_ChronoLocalDateTime__I(that);
});
function $isArrayOf_Ljava_time_LocalDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_LocalDateTime)));
}
export { $isArrayOf_Ljava_time_LocalDateTime as $isArrayOf_Ljava_time_LocalDateTime };
var $d_Ljava_time_LocalDateTime = new $TypeData().initClass($c_Ljava_time_LocalDateTime, "java.time.LocalDateTime", ({
  Ljava_time_LocalDateTime: 1,
  Ljava_time_chrono_ChronoLocalDateTime: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_Temporal: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Ljava_time_LocalDateTime as $d_Ljava_time_LocalDateTime };
function $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__ as $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype = new $h_jl_Enum();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.print__Ljava_time_format_internal_TTBPDateTimePrintContext__jl_StringBuilder__Z = (function(context, buf) {
  return true;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.parse__Ljava_time_format_internal_TTBPDateTimeParseContext__jl_CharSequence__I__I = (function(context, text, position) {
  var x6 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal;
  switch (x6) {
    case 0: {
      context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = true;
      break;
    }
    case 1: {
      context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_caseSensitive = false;
      break;
    }
    case 2: {
      context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = true;
      break;
    }
    case 3: {
      context.Ljava_time_format_internal_TTBPDateTimeParseContext__f_strict = false;
      break;
    }
    default: {
      throw new $c_s_MatchError(x6);
    }
  }
  return position;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser.prototype.toString__T = (function() {
  var x7 = this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal;
  switch (x7) {
    case 0: {
      return "ParseCaseSensitive(true)";
      break;
    }
    case 1: {
      return "ParseCaseSensitive(false)";
      break;
    }
    case 2: {
      return "ParseStrict(true)";
      break;
    }
    case 3: {
      return "ParseStrict(false)";
      break;
    }
    default: {
      throw $ct_jl_IllegalStateException__T__(new $c_jl_IllegalStateException(), "Unreachable");
    }
  }
});
function $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__($thiz, name, ordinal, baseUnit, rangeUnit, _range, _$name, _$ordinal) {
  $thiz.Ljava_time_temporal_ChronoField__f_name = name;
  $thiz.Ljava_time_temporal_ChronoField__f_ordinal = ordinal;
  $thiz.Ljava_time_temporal_ChronoField__f__range = _range;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__ as $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__ };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
}
export { $c_Ljava_time_temporal_ChronoField as $c_Ljava_time_temporal_ChronoField };
$c_Ljava_time_temporal_ChronoField.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_ChronoField.prototype.constructor = $c_Ljava_time_temporal_ChronoField;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField() {
}
export { $h_Ljava_time_temporal_ChronoField as $h_Ljava_time_temporal_ChronoField };
$h_Ljava_time_temporal_ChronoField.prototype = $c_Ljava_time_temporal_ChronoField.prototype;
$c_Ljava_time_temporal_ChronoField.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_temporal_ChronoField.prototype.range__Ljava_time_temporal_ValueRange = (function() {
  return this.Ljava_time_temporal_ChronoField__f__range;
});
$c_Ljava_time_temporal_ChronoField.prototype.isDateBased__Z = (function() {
  return ((this.Ljava_time_temporal_ChronoField__f_ordinal >= $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField().jl_Enum__f__ordinal) && (this.Ljava_time_temporal_ChronoField__f_ordinal <= $s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField().jl_Enum__f__ordinal));
});
$c_Ljava_time_temporal_ChronoField.prototype.isTimeBased__Z = (function() {
  return (this.Ljava_time_temporal_ChronoField__f_ordinal < $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField().jl_Enum__f__ordinal);
});
$c_Ljava_time_temporal_ChronoField.prototype.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z = (function(temporal) {
  return temporal.isSupported__Ljava_time_temporal_TemporalField__Z(this);
});
$c_Ljava_time_temporal_ChronoField.prototype.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange = (function(temporal) {
  return temporal.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this);
});
$c_Ljava_time_temporal_ChronoField.prototype.getFrom__Ljava_time_temporal_TemporalAccessor__J = (function(temporal) {
  return temporal.getLong__Ljava_time_temporal_TemporalField__J(this);
});
$c_Ljava_time_temporal_ChronoField.prototype.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal = (function(temporal, newValue) {
  return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal(this, newValue);
});
$c_Ljava_time_temporal_ChronoField.prototype.resolve__ju_Map__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_ResolverStyle__Ljava_time_temporal_TemporalAccessor = (function(fieldValues, partialTemporal, resolverStyle) {
  return null;
});
$c_Ljava_time_temporal_ChronoField.prototype.toString__T = (function() {
  return this.Ljava_time_temporal_ChronoField__f_name;
});
function $isArrayOf_Ljava_time_temporal_ChronoField(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ChronoField)));
}
export { $isArrayOf_Ljava_time_temporal_ChronoField as $isArrayOf_Ljava_time_temporal_ChronoField };
var $d_Ljava_time_temporal_ChronoField = new $TypeData().initClass(0, "java.time.temporal.ChronoField", ({
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
}));
export { $d_Ljava_time_temporal_ChronoField as $d_Ljava_time_temporal_ChronoField };
function $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__($thiz, name, ordinal, duration, _$name, _$ordinal) {
  $thiz.Ljava_time_temporal_ChronoUnit__f_name = name;
  $thiz.Ljava_time_temporal_ChronoUnit__f_duration = duration;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__ as $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__ };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
}
export { $c_Ljava_time_temporal_ChronoUnit as $c_Ljava_time_temporal_ChronoUnit };
$c_Ljava_time_temporal_ChronoUnit.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_ChronoUnit.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit() {
}
export { $h_Ljava_time_temporal_ChronoUnit as $h_Ljava_time_temporal_ChronoUnit };
$h_Ljava_time_temporal_ChronoUnit.prototype = $c_Ljava_time_temporal_ChronoUnit.prototype;
$c_Ljava_time_temporal_ChronoUnit.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_temporal_ChronoUnit.prototype.getDuration__Ljava_time_Duration = (function() {
  return this.Ljava_time_temporal_ChronoUnit__f_duration;
});
$c_Ljava_time_temporal_ChronoUnit.prototype.isDateBased__Z = (function() {
  return ((this.compareTo__jl_Enum__I($s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit()) >= 0) && (this !== $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit()));
});
$c_Ljava_time_temporal_ChronoUnit.prototype.isTimeBased__Z = (function() {
  return (this.compareTo__jl_Enum__I($s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit()) < 0);
});
$c_Ljava_time_temporal_ChronoUnit.prototype.addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal = (function(dateTime, periodToAdd) {
  return dateTime.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(periodToAdd, this);
});
$c_Ljava_time_temporal_ChronoUnit.prototype.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J = (function(temporal1, temporal2) {
  return temporal1.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(temporal2, this);
});
$c_Ljava_time_temporal_ChronoUnit.prototype.toString__T = (function() {
  return this.Ljava_time_temporal_ChronoUnit__f_name;
});
function $isArrayOf_Ljava_time_temporal_ChronoUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Ljava_time_temporal_ChronoUnit)));
}
export { $isArrayOf_Ljava_time_temporal_ChronoUnit as $isArrayOf_Ljava_time_temporal_ChronoUnit };
function $p_Ljava_time_temporal_IsoFields$Field__unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException($thiz, f) {
  return new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + f));
}
export { $p_Ljava_time_temporal_IsoFields$Field__unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException as $p_Ljava_time_temporal_IsoFields$Field__unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException };
function $p_Ljava_time_temporal_IsoFields$Field__QUARTER_DAYS__AI($thiz) {
  if ((!$thiz.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYSbitmap$1)) {
    $thiz.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYS$lzy1 = new $ac_I(new Int32Array([0, 90, 181, 273, 0, 91, 182, 274]));
    $thiz.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYSbitmap$1 = true;
  }
  return $thiz.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYS$lzy1;
}
export { $p_Ljava_time_temporal_IsoFields$Field__QUARTER_DAYS__AI as $p_Ljava_time_temporal_IsoFields$Field__QUARTER_DAYS__AI };
function $p_Ljava_time_temporal_IsoFields$Field__isIso__Ljava_time_temporal_TemporalAccessor__Z($thiz, temporal) {
  var x = $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(temporal);
  var x$2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  return ((x === null) ? (x$2 === null) : $f_Ljava_time_chrono_Chronology__equals__O__Z(x, x$2));
}
export { $p_Ljava_time_temporal_IsoFields$Field__isIso__Ljava_time_temporal_TemporalAccessor__Z as $p_Ljava_time_temporal_IsoFields$Field__isIso__Ljava_time_temporal_TemporalAccessor__Z };
function $p_Ljava_time_temporal_IsoFields$Field__getWeekRange__Ljava_time_LocalDate__Ljava_time_temporal_ValueRange($thiz, date) {
  var wby = $p_Ljava_time_temporal_IsoFields$Field__getWeekBasedYear__Ljava_time_LocalDate__I($thiz, date);
  var $x_1 = $m_Ljava_time_temporal_ValueRange$();
  var value = $p_Ljava_time_temporal_IsoFields$Field__getWeekRange__I__I($thiz, wby);
  var hi = (value >> 31);
  return $x_1.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(value, hi));
}
export { $p_Ljava_time_temporal_IsoFields$Field__getWeekRange__Ljava_time_LocalDate__Ljava_time_temporal_ValueRange as $p_Ljava_time_temporal_IsoFields$Field__getWeekRange__Ljava_time_LocalDate__Ljava_time_temporal_ValueRange };
function $p_Ljava_time_temporal_IsoFields$Field__getWeekRange__I__I($thiz, wby) {
  var date = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(wby, 1, 1);
  if ((date.getDayOfWeek__Ljava_time_DayOfWeek() === $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek())) {
    var $x_1 = true;
  } else if ((date.getDayOfWeek__Ljava_time_DayOfWeek() === $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek())) {
    var $x_2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var value = date.Ljava_time_LocalDate__f_year;
    var hi = (value >> 31);
    var $x_1 = $x_2.isLeapYear__J__Z(new $c_RTLong(value, hi));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return 53;
  } else {
    return 52;
  }
}
export { $p_Ljava_time_temporal_IsoFields$Field__getWeekRange__I__I as $p_Ljava_time_temporal_IsoFields$Field__getWeekRange__I__I };
function $p_Ljava_time_temporal_IsoFields$Field__getWeek__Ljava_time_LocalDate__I($thiz, date) {
  var dow0 = date.getDayOfWeek__Ljava_time_DayOfWeek().jl_Enum__f__ordinal;
  var doy0 = (((-1) + date.getDayOfYear__I()) | 0);
  var doyThu0 = ((doy0 + ((3 - dow0) | 0)) | 0);
  var alignedWeek = ((doyThu0 / 7) | 0);
  var firstThuDoy0 = ((doyThu0 - Math.imul(7, alignedWeek)) | 0);
  var firstMonDoy0 = (((-3) + firstThuDoy0) | 0);
  if ((firstMonDoy0 < (-3))) {
    firstMonDoy0 = ((7 + firstMonDoy0) | 0);
  }
  if ((doy0 < firstMonDoy0)) {
    var this$1 = $p_Ljava_time_temporal_IsoFields$Field__getWeekRange__Ljava_time_LocalDate__Ljava_time_temporal_ValueRange($thiz, date.withDayOfYear__I__Ljava_time_LocalDate(180).minusYears__J__Ljava_time_LocalDate(new $c_RTLong(1, 0)));
    var a = this$1.Ljava_time_temporal_ValueRange__f_maxLargest;
    return a.RTLong__f_lo;
  }
  var week = ((1 + ((((doy0 - firstMonDoy0) | 0) / 7) | 0)) | 0);
  if ((week === 53)) {
    if ((firstMonDoy0 === (-3))) {
      var $x_1 = true;
    } else if ((firstMonDoy0 === (-2))) {
      var $x_2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
      var value = date.Ljava_time_LocalDate__f_year;
      var hi = (value >> 31);
      var $x_1 = $x_2.isLeapYear__J__Z(new $c_RTLong(value, hi));
    } else {
      var $x_1 = false;
    }
    if ((!$x_1)) {
      week = 1;
    }
  }
  return week;
}
export { $p_Ljava_time_temporal_IsoFields$Field__getWeek__Ljava_time_LocalDate__I as $p_Ljava_time_temporal_IsoFields$Field__getWeek__Ljava_time_LocalDate__I };
function $p_Ljava_time_temporal_IsoFields$Field__getWeekBasedYear__Ljava_time_LocalDate__I($thiz, date) {
  var year = date.Ljava_time_LocalDate__f_year;
  var doy = date.getDayOfYear__I();
  if ((doy <= 3)) {
    var dow = date.getDayOfWeek__Ljava_time_DayOfWeek().jl_Enum__f__ordinal;
    if ((((doy - dow) | 0) < (-2))) {
      year = (((-1) + year) | 0);
    }
  } else if ((doy >= 363)) {
    var dow$2 = date.getDayOfWeek__Ljava_time_DayOfWeek().jl_Enum__f__ordinal;
    var $x_2 = doy;
    var $x_1 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
    var value = date.Ljava_time_LocalDate__f_year;
    var hi = (value >> 31);
    doy = (((((-363) + $x_2) | 0) - ($x_1.isLeapYear__J__Z(new $c_RTLong(value, hi)) ? 1 : 0)) | 0);
    if ((((doy - dow$2) | 0) >= 0)) {
      year = ((1 + year) | 0);
    }
  }
  return year;
}
export { $p_Ljava_time_temporal_IsoFields$Field__getWeekBasedYear__Ljava_time_LocalDate__I as $p_Ljava_time_temporal_IsoFields$Field__getWeekBasedYear__Ljava_time_LocalDate__I };
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Field() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYS$lzy1 = null;
  this.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYSbitmap$1 = false;
}
export { $c_Ljava_time_temporal_IsoFields$Field as $c_Ljava_time_temporal_IsoFields$Field };
$c_Ljava_time_temporal_IsoFields$Field.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_IsoFields$Field.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Field;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Field() {
}
export { $h_Ljava_time_temporal_IsoFields$Field as $h_Ljava_time_temporal_IsoFields$Field };
$h_Ljava_time_temporal_IsoFields$Field.prototype = $c_Ljava_time_temporal_IsoFields$Field.prototype;
$c_Ljava_time_temporal_IsoFields$Field.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_temporal_IsoFields$Field.prototype.adjustInto__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal = (function(temporal, newValue) {
  var x = $s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field();
  if (((x !== null) && (x === this))) {
    var t = this.getFrom__Ljava_time_temporal_TemporalAccessor__J(temporal);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    this.range__Ljava_time_temporal_ValueRange().checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, this);
    var $x_1 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
    var a = temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField());
    var alo = newValue.RTLong__f_lo;
    var lo$1 = ((alo - lo) | 0);
    var hi$1 = ((((newValue.RTLong__f_hi - hi) | 0) + ((((~alo) & lo) | ((~(alo ^ lo)) & lo$1)) >> 31)) | 0);
    var alo$1 = a.RTLong__f_lo;
    var lo$2 = ((alo$1 + lo$1) | 0);
    var hi$2 = ((((a.RTLong__f_hi + hi$1) | 0) + ((((alo$1 & lo$1) | ((alo$1 | lo$1) & (~lo$2))) >>> 31) | 0)) | 0);
    return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($x_1, new $c_RTLong(lo$2, hi$2));
  }
  var x$3 = $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$3 !== null) && (x$3 === this))) {
    var t$1 = this.getFrom__Ljava_time_temporal_TemporalAccessor__J(temporal);
    var lo$3 = t$1.RTLong__f_lo;
    var hi$3 = t$1.RTLong__f_hi;
    this.range__Ljava_time_temporal_ValueRange().checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, this);
    var $x_2 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var a$1 = temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
    var alo$2 = newValue.RTLong__f_lo;
    var lo$4 = ((alo$2 - lo$3) | 0);
    var hi$4 = ((((newValue.RTLong__f_hi - hi$3) | 0) + ((((~alo$2) & lo$3) | ((~(alo$2 ^ lo$3)) & lo$4)) >> 31)) | 0);
    var b0 = (65535 & lo$4);
    var b1 = ((lo$4 >>> 16) | 0);
    var a0b0 = Math.imul(3, b0);
    var a0b1 = Math.imul(3, b1);
    var lo$5 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$5 = ((Math.imul(3, hi$4) + ((c1part >>> 16) | 0)) | 0);
    var alo$3 = a$1.RTLong__f_lo;
    var lo$6 = ((alo$3 + lo$5) | 0);
    var hi$6 = ((((a$1.RTLong__f_hi + hi$5) | 0) + ((((alo$3 & lo$5) | ((alo$3 | lo$5) & (~lo$6))) >>> 31) | 0)) | 0);
    return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($x_2, new $c_RTLong(lo$6, hi$6));
  }
  var x$5 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$5 !== null) && (x$5 === this))) {
    this.range__Ljava_time_temporal_ValueRange().checkValidValue__J__Ljava_time_temporal_TemporalField__J(newValue, this);
    var t$2 = this.getFrom__Ljava_time_temporal_TemporalAccessor__J(temporal);
    var lo$7 = t$2.RTLong__f_lo;
    var hi$7 = t$2.RTLong__f_hi;
    var this$6 = $m_jl_Math$();
    var alo$4 = newValue.RTLong__f_lo;
    var lo$8 = ((alo$4 - lo$7) | 0);
    var hi$8 = ((((newValue.RTLong__f_hi - hi$7) | 0) + ((((~alo$4) & lo$7) | ((~(alo$4 ^ lo$7)) & lo$8)) >> 31)) | 0);
    var hi$9 = (newValue.RTLong__f_hi ^ hi$7);
    var hi$10 = (hi$8 ^ newValue.RTLong__f_hi);
    var hi$11 = (hi$9 & hi$10);
    if ((hi$11 < 0)) {
      this$6.java$lang$Math$$longOverflow__E();
    }
    return temporal.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(lo$8, hi$8), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit());
  }
  var x$7 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$7 !== null) && (x$7 === this))) {
    if ((!this.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(temporal))) {
      throw $p_Ljava_time_temporal_IsoFields$Field__unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException(this, "WeekBasedYear");
    }
    var newWby = this.range__Ljava_time_temporal_ValueRange().checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(newValue, $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field());
    var date = $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal);
    var dow = date.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
    var week = $p_Ljava_time_temporal_IsoFields$Field__getWeek__Ljava_time_LocalDate__I(this, date);
    if (((week === 53) && ($p_Ljava_time_temporal_IsoFields$Field__getWeekRange__I__I(this, newWby) === 52))) {
      week = 52;
    }
    var resolved = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(newWby, 1, 4);
    var days = ((((dow - resolved.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) | 0) + Math.imul(7, (((-1) + week) | 0))) | 0);
    var hi$12 = (days >> 31);
    return temporal.with__Ljava_time_temporal_TemporalAdjuster__Ljava_time_temporal_Temporal(resolved.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(days, hi$12)));
  }
  throw new $c_s_MatchError(this);
});
$c_Ljava_time_temporal_IsoFields$Field.prototype.getFrom__Ljava_time_temporal_TemporalAccessor__J = (function(temporal) {
  var x = $s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field();
  if (((x !== null) && (x === this))) {
    if ((!temporal.isSupported__Ljava_time_temporal_TemporalField__Z(this))) {
      throw $p_Ljava_time_temporal_IsoFields$Field__unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException(this, "DayOfQuarter");
    }
    var doy = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField());
    var moy = temporal.get__Ljava_time_temporal_TemporalField__I($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
    var t = temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var hi$1 = (doy >> 31);
    var value = $p_Ljava_time_temporal_IsoFields$Field__QUARTER_DAYS__AI(this).u[(((((((-1) + moy) | 0) / 3) | 0) + ($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology().isLeapYear__J__Z(new $c_RTLong(lo, hi)) ? 4 : 0)) | 0)];
    var hi$2 = (value >> 31);
    var lo$1 = ((doy - value) | 0);
    var hi$3 = ((((hi$1 - hi$2) | 0) + ((((~doy) & value) | ((~(doy ^ value)) & lo$1)) >> 31)) | 0);
    return new $c_RTLong(lo$1, hi$3);
  }
  var x$3 = $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$3 !== null) && (x$3 === this))) {
    if ((!temporal.isSupported__Ljava_time_temporal_TemporalField__Z(this))) {
      throw $p_Ljava_time_temporal_IsoFields$Field__unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException(this, "QuarterOfYear");
    }
    var t$1 = temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
    var lo$2 = t$1.RTLong__f_lo;
    var hi$4 = t$1.RTLong__f_hi;
    var lo$3 = ((2 + lo$2) | 0);
    var hi$5 = ((hi$4 + (((lo$2 & (~lo$3)) >>> 31) | 0)) | 0);
    var this$5 = $m_RTLong$();
    var lo$4 = this$5.divideImpl__I__I__I__I__I(lo$3, hi$5, 3, 0);
    var hi$6 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$4, hi$6);
  }
  var x$5 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$5 !== null) && (x$5 === this))) {
    if ((!temporal.isSupported__Ljava_time_temporal_TemporalField__Z(this))) {
      throw $p_Ljava_time_temporal_IsoFields$Field__unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException(this, "WeekOfYWeekBasedYear");
    } else {
      var value$1 = $p_Ljava_time_temporal_IsoFields$Field__getWeek__Ljava_time_LocalDate__I(this, $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal));
      var hi$7 = (value$1 >> 31);
      return new $c_RTLong(value$1, hi$7);
    }
  }
  var x$7 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$7 !== null) && (x$7 === this))) {
    if ((!temporal.isSupported__Ljava_time_temporal_TemporalField__Z(this))) {
      throw $p_Ljava_time_temporal_IsoFields$Field__unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException(this, "WeekBasedYear");
    } else {
      var value$2 = $p_Ljava_time_temporal_IsoFields$Field__getWeekBasedYear__Ljava_time_LocalDate__I(this, $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal));
      var hi$8 = (value$2 >> 31);
      return new $c_RTLong(value$2, hi$8);
    }
  }
  throw new $c_s_MatchError(this);
});
$c_Ljava_time_temporal_IsoFields$Field.prototype.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z = (function(temporal) {
  var x = $s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field();
  if (((x !== null) && (x === this))) {
    return (((temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField()) && temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) && temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField())) && $p_Ljava_time_temporal_IsoFields$Field__isIso__Ljava_time_temporal_TemporalAccessor__Z(this, temporal));
  }
  var x$3 = $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$3 !== null) && (x$3 === this))) {
    return (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) && $p_Ljava_time_temporal_IsoFields$Field__isIso__Ljava_time_temporal_TemporalAccessor__Z(this, temporal));
  }
  var x$5 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$5 !== null) && (x$5 === this))) {
    return (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField()) && $p_Ljava_time_temporal_IsoFields$Field__isIso__Ljava_time_temporal_TemporalAccessor__Z(this, temporal));
  }
  var x$7 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$7 !== null) && (x$7 === this))) {
    return (temporal.isSupported__Ljava_time_temporal_TemporalField__Z($s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField()) && $p_Ljava_time_temporal_IsoFields$Field__isIso__Ljava_time_temporal_TemporalAccessor__Z(this, temporal));
  }
  throw new $c_s_MatchError(this);
});
$c_Ljava_time_temporal_IsoFields$Field.prototype.range__Ljava_time_temporal_ValueRange = (function() {
  var x = $s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field();
  if (((x !== null) && (x === this))) {
    var this$1 = $m_Ljava_time_temporal_ValueRange$();
    return this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(90, 0), new $c_RTLong(92, 0));
  }
  var x$3 = $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$3 !== null) && (x$3 === this))) {
    return $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(4, 0));
  }
  var x$5 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$5 !== null) && (x$5 === this))) {
    var this$2 = $m_Ljava_time_temporal_ValueRange$();
    return this$2.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(52, 0), new $c_RTLong(53, 0));
  }
  var x$7 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$7 !== null) && (x$7 === this))) {
    var this$3 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    return this$3.Ljava_time_temporal_ChronoField__f__range;
  }
  throw new $c_s_MatchError(this);
});
$c_Ljava_time_temporal_IsoFields$Field.prototype.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange = (function(temporal) {
  var x = $s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field();
  if (((x !== null) && (x === this))) {
    if ((!temporal.isSupported__Ljava_time_temporal_TemporalField__Z(this))) {
      throw $p_Ljava_time_temporal_IsoFields$Field__unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException(this, "DayOfQuarter");
    }
    var t = temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    if (((lo === 1) && (hi === 0))) {
      var t$1 = temporal.getLong__Ljava_time_temporal_TemporalField__J($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      return ($m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology().isLeapYear__J__Z(new $c_RTLong(lo$1, hi$1)) ? $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(91, 0)) : $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(90, 0)));
    } else if (((lo === 2) && (hi === 0))) {
      return $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(91, 0));
    } else if ((((lo === 3) && (hi === 0)) || ((lo === 4) && (hi === 0)))) {
      return $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(92, 0));
    }
    return this.range__Ljava_time_temporal_ValueRange();
  }
  var x$3 = $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$3 !== null) && (x$3 === this))) {
    return this.range__Ljava_time_temporal_ValueRange();
  }
  var x$5 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$5 !== null) && (x$5 === this))) {
    if ((!temporal.isSupported__Ljava_time_temporal_TemporalField__Z(this))) {
      throw $p_Ljava_time_temporal_IsoFields$Field__unsupportedEx__T__Ljava_time_temporal_UnsupportedTemporalTypeException(this, "WeekOfYWeekBasedYear");
    } else {
      return $p_Ljava_time_temporal_IsoFields$Field__getWeekRange__Ljava_time_LocalDate__Ljava_time_temporal_ValueRange(this, $m_Ljava_time_LocalDate$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_LocalDate(temporal));
    }
  }
  var x$7 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$7 !== null) && (x$7 === this))) {
    var this$5 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    return this$5.Ljava_time_temporal_ChronoField__f__range;
  }
  throw new $c_s_MatchError(this);
});
$c_Ljava_time_temporal_IsoFields$Field.prototype.toString__T = (function() {
  var x = $s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field();
  if (((x !== null) && (x === this))) {
    return "DayOfQuarter";
  }
  var x$3 = $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$3 !== null) && (x$3 === this))) {
    return "QuarterOfYear";
  }
  var x$5 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$5 !== null) && (x$5 === this))) {
    return "WeekOfYWeekBasedYear";
  }
  var x$7 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
  if (((x$7 !== null) && (x$7 === this))) {
    return "WeekBasedYear";
  }
  throw new $c_s_MatchError(this);
});
$c_Ljava_time_temporal_IsoFields$Field.prototype.resolve__ju_Map__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_ResolverStyle__Ljava_time_temporal_TemporalAccessor = (function(fieldValues, partialTemporal, resolverStyle) {
  var x = $s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field();
  if (((x !== null) && (x === this))) {
    var yearLong = fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
    var qoyLong = fieldValues.get__O__O($s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field());
    if (((yearLong === null) || (qoyLong === null))) {
      return null;
    }
    var this$2 = $s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var t = $uJ(yearLong);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var y = this$2.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo, hi), this$2);
    var x$1 = fieldValues.get__O__O($s_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER__Ljava_time_temporal_IsoFields$Field());
    var t$1 = $uJ(x$1);
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var date = null;
    if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var t$2 = $uJ(qoyLong);
      var lo$2 = t$2.RTLong__f_lo;
      var hi$2 = t$2.RTLong__f_hi;
      date = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y, 1, 1);
      var $x_2 = date;
      var this$5 = $m_jl_Math$();
      var lo$3 = (((-1) + lo$2) | 0);
      var hi$3 = (((((-1) + hi$2) | 0) + (((lo$2 | (~lo$3)) >>> 31) | 0)) | 0);
      var hi$4 = (hi$3 ^ hi$2);
      var hi$5 = (hi$2 & hi$4);
      if ((hi$5 < 0)) {
        this$5.java$lang$Math$$longOverflow__E();
      }
      var this$11 = $m_jl_Math$();
      var b0 = (65535 & lo$3);
      var b1 = ((lo$3 >>> 16) | 0);
      var a0b0 = Math.imul(3, b0);
      var a0b1 = Math.imul(3, b1);
      var lo$7 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$6 = ((Math.imul(3, hi$3) + ((c1part >>> 16) | 0)) | 0);
      if ((!((lo$3 === 0) && (hi$3 === 0)))) {
        var this$15 = $m_RTLong$();
        var lo$8 = this$15.divideImpl__I__I__I__I__I(lo$7, hi$6, lo$3, hi$3);
        var hi$7 = this$15.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var $x_1 = (!((lo$8 === 3) && (hi$7 === 0)));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        this$11.java$lang$Math$$longOverflow__E();
      }
      date = $x_2.plusMonths__J__Ljava_time_LocalDate(new $c_RTLong(lo$7, hi$6));
      var $x_3 = date;
      var this$17 = $m_jl_Math$();
      var lo$9 = (((-1) + lo$1) | 0);
      var hi$8 = (((((-1) + hi$1) | 0) + (((lo$1 | (~lo$9)) >>> 31) | 0)) | 0);
      var hi$9 = (hi$8 ^ hi$1);
      var hi$10 = (hi$1 & hi$9);
      if ((hi$10 < 0)) {
        this$17.java$lang$Math$$longOverflow__E();
      }
      date = $x_3.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$9, hi$8));
    } else {
      var qoy$2 = $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field().range__Ljava_time_temporal_ValueRange().checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($uJ(qoyLong), $s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field());
      if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle())) {
        if ((qoy$2 === 1)) {
          var $x_4 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
          var hi$11 = (y >> 31);
          if ($x_4.isLeapYear__J__Z(new $c_RTLong(y, hi$11))) {
            var max = 91;
          } else {
            var max = 90;
          }
        } else {
          var max = ((qoy$2 === 2) ? 91 : 92);
        }
        var $x_5 = $m_Ljava_time_temporal_ValueRange$();
        var hi$12 = (max >> 31);
        $x_5.of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(max, hi$12)).checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$1, hi$1), this);
      } else {
        this.range__Ljava_time_temporal_ValueRange().checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$1, hi$1), this);
      }
      var $x_6 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(y, ((1 + Math.imul(3, (((-1) + qoy$2) | 0))) | 0), 1);
      var lo$13 = (((-1) + lo$1) | 0);
      var hi$13 = (((((-1) + hi$1) | 0) + (((lo$1 | (~lo$13)) >>> 31) | 0)) | 0);
      date = $x_6.plusDays__J__Ljava_time_LocalDate(new $c_RTLong(lo$13, hi$13));
    }
    fieldValues.remove__O__O(this);
    fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
    fieldValues.remove__O__O($s_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR__Ljava_time_temporal_IsoFields$Field());
    return date;
  } else {
    var x$3 = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field();
    if (((x$3 !== null) && (x$3 === this))) {
      var wbyLong = fieldValues.get__O__O($s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field());
      var x$2 = fieldValues.get__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
      var t$3 = $uJ(x$2);
      var lo$14 = t$3.RTLong__f_lo;
      var hi$14 = t$3.RTLong__f_hi;
      if (((wbyLong === null) || (!fieldValues.containsKey__O__Z($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())))) {
        return null;
      }
      var wby = $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field().range__Ljava_time_temporal_ValueRange().checkValidIntValue__J__Ljava_time_temporal_TemporalField__I($uJ(wbyLong), $s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field());
      var x$4 = fieldValues.get__O__O($s_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field());
      var t$4 = $uJ(x$4);
      var lo$15 = t$4.RTLong__f_lo;
      var hi$15 = t$4.RTLong__f_hi;
      var date$2 = null;
      if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
        if (((hi$14 === 0) ? ((lo$14 >>> 0) > 7) : (hi$14 > 0))) {
          var lo$16 = (((-1) + lo$14) | 0);
          var hi$16 = (((((-1) + hi$14) | 0) + (((lo$14 | (~lo$16)) >>> 31) | 0)) | 0);
          var this$32 = $m_RTLong$();
          var lo$17 = this$32.remainderImpl__I__I__I__I__I(lo$16, hi$16, 7, 0);
          var hi$17 = this$32.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var lo$18 = ((1 + lo$17) | 0);
          var hi$18 = ((hi$17 + (((lo$17 & (~lo$18)) >>> 31) | 0)) | 0);
          var lo$19 = (((-1) + lo$14) | 0);
          var hi$19 = (((((-1) + hi$14) | 0) + (((lo$14 | (~lo$19)) >>> 31) | 0)) | 0);
          var this$35 = $m_RTLong$();
          var lo$20 = this$35.divideImpl__I__I__I__I__I(lo$19, hi$19, 7, 0);
          var hi$20 = this$35.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var \u03b41$___1 = new $c_RTLong(lo$18, hi$18);
          var \u03b41$___2 = new $c_RTLong(lo$20, hi$20);
        } else if (((hi$14 === 0) ? (lo$14 === 0) : (hi$14 < 0))) {
          var this$38 = $m_RTLong$();
          var lo$21 = this$38.remainderImpl__I__I__I__I__I(lo$14, hi$14, 7, 0);
          var hi$21 = this$38.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var lo$22 = ((7 + lo$21) | 0);
          var hi$22 = ((hi$21 + (((lo$21 & (~lo$22)) >>> 31) | 0)) | 0);
          var this$40 = $m_RTLong$();
          var lo$23 = this$40.divideImpl__I__I__I__I__I(lo$14, hi$14, 7, 0);
          var hi$23 = this$40.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
          var lo$24 = (((-1) + lo$23) | 0);
          var hi$24 = (((((-1) + hi$23) | 0) + (((lo$23 | (~lo$24)) >>> 31) | 0)) | 0);
          var \u03b41$___1 = new $c_RTLong(lo$22, hi$22);
          var \u03b41$___2 = new $c_RTLong(lo$24, hi$24);
        } else {
          var \u03b41$___1 = new $c_RTLong(lo$14, hi$14);
          var \u03b41$___2 = $L0;
        }
        var t$5 = $uJ(\u03b41$___1);
        var lo$25 = t$5.RTLong__f_lo;
        var hi$25 = t$5.RTLong__f_hi;
        var t$6 = $uJ(\u03b41$___2);
        var lo$26 = t$6.RTLong__f_lo;
        var hi$26 = t$6.RTLong__f_hi;
        var $x_7 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(wby, 1, 4);
        var lo$27 = (((-1) + lo$15) | 0);
        var hi$27 = (((((-1) + hi$15) | 0) + (((lo$15 | (~lo$27)) >>> 31) | 0)) | 0);
        date$2 = $x_7.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$27, hi$27)).plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$26, hi$26)).with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField(), new $c_RTLong(lo$25, hi$25));
      } else {
        var this$45 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
        var dow$2 = this$45.Ljava_time_temporal_ChronoField__f__range.checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(new $c_RTLong(lo$14, hi$14), this$45);
        if ((resolverStyle === $s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle())) {
          var temp = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(wby, 1, 4);
          var range = $p_Ljava_time_temporal_IsoFields$Field__getWeekRange__Ljava_time_LocalDate__Ljava_time_temporal_ValueRange(this, temp);
          range.checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$15, hi$15), this);
        } else {
          this.range__Ljava_time_temporal_ValueRange().checkValidValue__J__Ljava_time_temporal_TemporalField__J(new $c_RTLong(lo$15, hi$15), this);
        }
        var $x_10 = $m_Ljava_time_LocalDate$().of__I__I__I__Ljava_time_LocalDate(wby, 1, 4);
        var lo$28 = (((-1) + lo$15) | 0);
        var hi$28 = (((((-1) + hi$15) | 0) + (((lo$15 | (~lo$28)) >>> 31) | 0)) | 0);
        var $x_9 = $x_10.plusWeeks__J__Ljava_time_LocalDate(new $c_RTLong(lo$28, hi$28));
        var $x_8 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
        var hi$29 = (dow$2 >> 31);
        date$2 = $x_9.with__Ljava_time_temporal_TemporalField__J__Ljava_time_LocalDate($x_8, new $c_RTLong(dow$2, hi$29));
      }
      fieldValues.remove__O__O(this);
      fieldValues.remove__O__O($s_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR__Ljava_time_temporal_IsoFields$Field());
      fieldValues.remove__O__O($s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField());
      return date$2;
    } else {
      return null;
    }
  }
});
$c_Ljava_time_temporal_IsoFields$Field.prototype.isDateBased__Z = (function() {
  return true;
});
$c_Ljava_time_temporal_IsoFields$Field.prototype.isTimeBased__Z = (function() {
  return false;
});
function $ct_Ljava_time_temporal_IsoFields$Unit__T__I__Ljava_time_Duration__T__I__($thiz, name, ordinal, duration, _$name, _$ordinal) {
  $thiz.Ljava_time_temporal_IsoFields$Unit__f_name = name;
  $thiz.Ljava_time_temporal_IsoFields$Unit__f_duration = duration;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_temporal_IsoFields$Unit__T__I__Ljava_time_Duration__T__I__ as $ct_Ljava_time_temporal_IsoFields$Unit__T__I__Ljava_time_Duration__T__I__ };
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Unit() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_IsoFields$Unit__f_name = null;
  this.Ljava_time_temporal_IsoFields$Unit__f_duration = null;
}
export { $c_Ljava_time_temporal_IsoFields$Unit as $c_Ljava_time_temporal_IsoFields$Unit };
$c_Ljava_time_temporal_IsoFields$Unit.prototype = new $h_jl_Enum();
$c_Ljava_time_temporal_IsoFields$Unit.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Unit;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Unit() {
}
export { $h_Ljava_time_temporal_IsoFields$Unit as $h_Ljava_time_temporal_IsoFields$Unit };
$h_Ljava_time_temporal_IsoFields$Unit.prototype = $c_Ljava_time_temporal_IsoFields$Unit.prototype;
$c_Ljava_time_temporal_IsoFields$Unit.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_temporal_IsoFields$Unit.prototype.getDuration__Ljava_time_Duration = (function() {
  return this.Ljava_time_temporal_IsoFields$Unit__f_duration;
});
$c_Ljava_time_temporal_IsoFields$Unit.prototype.isDateBased__Z = (function() {
  return true;
});
$c_Ljava_time_temporal_IsoFields$Unit.prototype.addTo__Ljava_time_temporal_Temporal__J__Ljava_time_temporal_Temporal = (function(temporal, periodToAdd) {
  var x = $s_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS__Ljava_time_temporal_IsoFields$Unit();
  if (((x !== null) && (x === this))) {
    var value = temporal.get__Ljava_time_temporal_TemporalField__I($m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEAR__Ljava_time_temporal_TemporalField());
    var hi = (value >> 31);
    var this$2 = $m_jl_Math$();
    var blo = periodToAdd.RTLong__f_lo;
    var lo = ((value + blo) | 0);
    var hi$1 = ((((hi + periodToAdd.RTLong__f_hi) | 0) + ((((value & blo) | ((value | blo) & (~lo))) >>> 31) | 0)) | 0);
    var hi$2 = (hi$1 ^ hi);
    var hi$3 = (hi$1 ^ periodToAdd.RTLong__f_hi);
    var hi$4 = (hi$2 & hi$3);
    if ((hi$4 < 0)) {
      this$2.java$lang$Math$$longOverflow__E();
    }
    return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEAR__Ljava_time_temporal_TemporalField(), new $c_RTLong(lo, hi$1));
  }
  var x$3 = $s_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS__Ljava_time_temporal_IsoFields$Unit();
  if (((x$3 !== null) && (x$3 === this))) {
    var this$8 = $m_RTLong$();
    var lo$4 = this$8.divideImpl__I__I__I__I__I(periodToAdd.RTLong__f_lo, periodToAdd.RTLong__f_hi, 256, 0);
    var hi$5 = this$8.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var $x_1 = temporal.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(lo$4, hi$5), $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit());
    var this$9 = $m_RTLong$();
    var lo$5 = this$9.remainderImpl__I__I__I__I__I(periodToAdd.RTLong__f_lo, periodToAdd.RTLong__f_hi, 256, 0);
    var hi$6 = this$9.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var b0 = (65535 & lo$5);
    var b1 = ((lo$5 >>> 16) | 0);
    var a0b0 = Math.imul(3, b0);
    var a0b1 = Math.imul(3, b1);
    var lo$6 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$7 = ((Math.imul(3, hi$6) + ((c1part >>> 16) | 0)) | 0);
    return $x_1.plus__J__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_Temporal(new $c_RTLong(lo$6, hi$7), $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit());
  }
  throw new $c_s_MatchError(this);
});
$c_Ljava_time_temporal_IsoFields$Unit.prototype.between__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal__J = (function(temporal1, temporal2) {
  var x = $s_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS__Ljava_time_temporal_IsoFields$Unit();
  if (((x !== null) && (x === this))) {
    var t = temporal2.getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEAR__Ljava_time_temporal_TemporalField());
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = temporal1.getLong__Ljava_time_temporal_TemporalField__J($m_Ljava_time_temporal_IsoFields$().WEEK_BASED_YEAR__Ljava_time_temporal_TemporalField());
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var this$1 = $m_jl_Math$();
    var lo$2 = ((lo - lo$1) | 0);
    var hi$2 = ((((hi - hi$1) | 0) + ((((~lo) & lo$1) | ((~(lo ^ lo$1)) & lo$2)) >> 31)) | 0);
    var hi$3 = (hi ^ hi$1);
    var hi$4 = (hi$2 ^ hi);
    var hi$5 = (hi$3 & hi$4);
    if ((hi$5 < 0)) {
      this$1.java$lang$Math$$longOverflow__E();
    }
    return new $c_RTLong(lo$2, hi$2);
  }
  var x$3 = $s_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS__Ljava_time_temporal_IsoFields$Unit();
  if (((x$3 !== null) && (x$3 === this))) {
    var a = temporal1.until__Ljava_time_temporal_Temporal__Ljava_time_temporal_TemporalUnit__J(temporal2, $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit());
    var this$7 = $m_RTLong$();
    var lo$6 = this$7.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 3, 0);
    var hi$6 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    return new $c_RTLong(lo$6, hi$6);
  }
  throw new $c_s_MatchError(this);
});
$c_Ljava_time_temporal_IsoFields$Unit.prototype.toString__T = (function() {
  return this.Ljava_time_temporal_IsoFields$Unit__f_name;
});
/** @constructor */
function $c_ju_Arrays$$anon$1(a$1) {
  this.ju_Arrays$$anon$1__f_a$1 = null;
  this.ju_Arrays$$anon$1__f_a$1 = a$1;
}
export { $c_ju_Arrays$$anon$1 as $c_ju_Arrays$$anon$1 };
$c_ju_Arrays$$anon$1.prototype = new $h_ju_AbstractList();
$c_ju_Arrays$$anon$1.prototype.constructor = $c_ju_Arrays$$anon$1;
/** @constructor */
function $h_ju_Arrays$$anon$1() {
}
export { $h_ju_Arrays$$anon$1 as $h_ju_Arrays$$anon$1 };
$h_ju_Arrays$$anon$1.prototype = $c_ju_Arrays$$anon$1.prototype;
$c_ju_Arrays$$anon$1.prototype.size__I = (function() {
  return this.ju_Arrays$$anon$1__f_a$1.u.length;
});
$c_ju_Arrays$$anon$1.prototype.get__I__O = (function(index) {
  return this.ju_Arrays$$anon$1__f_a$1.u[index];
});
$c_ju_Arrays$$anon$1.prototype.set__I__O__O = (function(index, element) {
  var ret = this.ju_Arrays$$anon$1__f_a$1.u[index];
  this.ju_Arrays$$anon$1__f_a$1.u[index] = element;
  return ret;
});
var $d_ju_Arrays$$anon$1 = new $TypeData().initClass($c_ju_Arrays$$anon$1, "java.util.Arrays$$anon$1", ({
  ju_Arrays$$anon$1: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_SequencedCollection: 1,
  ju_RandomAccess: 1
}));
export { $d_ju_Arrays$$anon$1 as $d_ju_Arrays$$anon$1 };
/** @constructor */
function $c_ju_Collections$$anon$15(o$2) {
  this.ju_Collections$$anon$15__f_o$2 = null;
  this.ju_Collections$$anon$15__f_o$2 = o$2;
}
export { $c_ju_Collections$$anon$15 as $c_ju_Collections$$anon$15 };
$c_ju_Collections$$anon$15.prototype = new $h_ju_AbstractList();
$c_ju_Collections$$anon$15.prototype.constructor = $c_ju_Collections$$anon$15;
/** @constructor */
function $h_ju_Collections$$anon$15() {
}
export { $h_ju_Collections$$anon$15 as $h_ju_Collections$$anon$15 };
$h_ju_Collections$$anon$15.prototype = $c_ju_Collections$$anon$15.prototype;
$c_ju_Collections$$anon$15.prototype.size__I = (function() {
  return 1;
});
$c_ju_Collections$$anon$15.prototype.get__I__O = (function(index) {
  if ((index === 0)) {
    return this.ju_Collections$$anon$15__f_o$2;
  } else {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
var $d_ju_Collections$$anon$15 = new $TypeData().initClass($c_ju_Collections$$anon$15, "java.util.Collections$$anon$15", ({
  ju_Collections$$anon$15: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_SequencedCollection: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_Collections$$anon$15 as $d_ju_Collections$$anon$15 };
function $ct_ju_HashSet__ju_HashMap__($thiz, inner) {
  $thiz.ju_HashSet__f_inner = inner;
  $thiz.ju_HashSet__f_innerKeySet = new $c_ju_HashMap$KeySet(inner);
  return $thiz;
}
export { $ct_ju_HashSet__ju_HashMap__ as $ct_ju_HashSet__ju_HashMap__ };
function $ct_ju_HashSet__I__($thiz, initialCapacity) {
  $ct_ju_HashSet__ju_HashMap__($thiz, $ct_ju_HashMap__I__(new $c_ju_HashMap(), initialCapacity));
  return $thiz;
}
export { $ct_ju_HashSet__I__ as $ct_ju_HashSet__I__ };
function $ct_ju_HashSet__($thiz) {
  $ct_ju_HashSet__ju_HashMap__($thiz, $ct_ju_HashMap__(new $c_ju_HashMap()));
  return $thiz;
}
export { $ct_ju_HashSet__ as $ct_ju_HashSet__ };
function $ct_ju_HashSet__ju_Collection__($thiz, c) {
  $ct_ju_HashSet__I__($thiz, c.size__I());
  $thiz.addAll__ju_Collection__Z(c);
  return $thiz;
}
export { $ct_ju_HashSet__ju_Collection__ as $ct_ju_HashSet__ju_Collection__ };
/** @constructor */
function $c_ju_HashSet() {
  this.ju_HashSet__f_inner = null;
  this.ju_HashSet__f_innerKeySet = null;
}
export { $c_ju_HashSet as $c_ju_HashSet };
$c_ju_HashSet.prototype = new $h_ju_AbstractSet();
$c_ju_HashSet.prototype.constructor = $c_ju_HashSet;
/** @constructor */
function $h_ju_HashSet() {
}
export { $h_ju_HashSet as $h_ju_HashSet };
$h_ju_HashSet.prototype = $c_ju_HashSet.prototype;
$c_ju_HashSet.prototype.contains__O__Z = (function(o) {
  return this.ju_HashSet__f_inner.containsKey__O__Z(o);
});
$c_ju_HashSet.prototype.remove__O__Z = (function(o) {
  return (this.ju_HashSet__f_inner.remove__O__O(o) !== null);
});
$c_ju_HashSet.prototype.containsAll__ju_Collection__Z = (function(c) {
  return this.ju_HashSet__f_innerKeySet.containsAll__ju_Collection__Z(c);
});
$c_ju_HashSet.prototype.retainAll__ju_Collection__Z = (function(c) {
  return this.ju_HashSet__f_innerKeySet.retainAll__ju_Collection__Z(c);
});
$c_ju_HashSet.prototype.add__O__Z = (function(e) {
  return (this.ju_HashSet__f_inner.put__O__O__O(e, (void 0)) === null);
});
$c_ju_HashSet.prototype.addAll__ju_Collection__Z = (function(c) {
  var iter = c.iterator__ju_Iterator();
  var changed = false;
  while (iter.hasNext__Z()) {
    changed = (this.add__O__Z(iter.next__O()) || changed);
  }
  return changed;
});
$c_ju_HashSet.prototype.size__I = (function() {
  return this.ju_HashSet__f_inner.ju_HashMap__f_contentSize;
});
$c_ju_HashSet.prototype.iterator__ju_Iterator = (function() {
  return this.ju_HashSet__f_innerKeySet.iterator__ju_Iterator();
});
var $d_ju_HashSet = new $TypeData().initClass($c_ju_HashSet, "java.util.HashSet", ({
  ju_HashSet: 1,
  ju_AbstractSet: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_Set: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_HashSet as $d_ju_HashSet };
function $ct_ju_concurrent_CopyOnWriteArrayList__I__($thiz, initialCapacity) {
  $thiz.ju_concurrent_CopyOnWriteArrayList__f_inner = [];
  $thiz.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false;
  return $thiz;
}
export { $ct_ju_concurrent_CopyOnWriteArrayList__I__ as $ct_ju_concurrent_CopyOnWriteArrayList__I__ };
function $ct_ju_concurrent_CopyOnWriteArrayList__AO__($thiz, toCopyIn) {
  $ct_ju_concurrent_CopyOnWriteArrayList__I__($thiz, toCopyIn.u.length);
  var end = toCopyIn.u.length;
  var i = 0;
  while ((i < end)) {
    var value = i;
    $thiz.add__O__Z(toCopyIn.u[value]);
    i = ((1 + i) | 0);
  }
  return $thiz;
}
export { $ct_ju_concurrent_CopyOnWriteArrayList__AO__ as $ct_ju_concurrent_CopyOnWriteArrayList__AO__ };
/** @constructor */
function $c_ju_concurrent_CopyOnWriteArrayList() {
  this.ju_concurrent_CopyOnWriteArrayList__f_inner = null;
  this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false;
}
export { $c_ju_concurrent_CopyOnWriteArrayList as $c_ju_concurrent_CopyOnWriteArrayList };
$c_ju_concurrent_CopyOnWriteArrayList.prototype = new $h_O();
$c_ju_concurrent_CopyOnWriteArrayList.prototype.constructor = $c_ju_concurrent_CopyOnWriteArrayList;
/** @constructor */
function $h_ju_concurrent_CopyOnWriteArrayList() {
}
export { $h_ju_concurrent_CopyOnWriteArrayList as $h_ju_concurrent_CopyOnWriteArrayList };
$h_ju_concurrent_CopyOnWriteArrayList.prototype = $c_ju_concurrent_CopyOnWriteArrayList.prototype;
$c_ju_concurrent_CopyOnWriteArrayList.prototype.size__I = (function() {
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return (v.length | 0);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.isEmpty__Z = (function() {
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return ((v.length | 0) === 0);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.contains__O__Z = (function(o) {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  while (_\uff3fself.hasNext__Z()) {
    var t = _\uff3fself.next__O();
    if (((o === null) ? (t === null) : $dp_equals__O__Z(o, t))) {
      return true;
    }
  }
  return false;
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toArray__AO = (function() {
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return this.toArray__AO__AO(new $ac_O((v.length | 0)));
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toArray__AO__AO = (function(a) {
  var this$1 = $objectGetClass(a);
  var componentType = this$1.data.getComponentType();
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  if ((a.u.length >= (v.length | 0))) {
    var toFill = a;
  } else {
    var v$1 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    var length = (v$1.length | 0);
    var toFill = componentType.data.newArray(length);
  }
  var iter = this.listIterator__I__ju_ListIterator(0);
  var v$2 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  var end = (v$2.length | 0);
  var i = 0;
  while ((i < end)) {
    var value = i;
    toFill.u[value] = iter.next__O();
    i = ((1 + i) | 0);
  }
  var v$3 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  if ((toFill.u.length > (v$3.length | 0))) {
    var v$4 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    toFill.u[(v$4.length | 0)] = null;
  }
  return toFill;
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.get__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return v[index];
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.set__I__O__O = (function(index, element) {
  this.checkIndexInBounds__I__V(index);
  this.copyIfNeeded__V();
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  var oldValue = v[index];
  var v$1 = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  v$1[index] = element;
  return oldValue;
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.add__O__Z = (function(e) {
  this.copyIfNeeded__V();
  this.innerPush__O__V(e);
  return true;
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.remove__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  this.copyIfNeeded__V();
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return v.splice(index, 1)[0];
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.containsAll__ju_Collection__Z = (function(c) {
  var _\uff3fself = c.iterator__ju_Iterator();
  _return: {
    while (_\uff3fself.hasNext__Z()) {
      var t = _\uff3fself.next__O();
      if ((!this.contains__O__Z(t))) {
        var $x_1 = true;
        break _return;
      }
    }
    var $x_1 = false;
  }
  return (!$x_1);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.toString__T = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = "[";
  var first = true;
  while (_\uff3fself.hasNext__Z()) {
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (("" + result) + _\uff3fself.next__O());
  }
  return (result + "]");
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.equals__O__Z = (function(obj) {
  if ((obj === this)) {
    return true;
  } else if ($is_ju_List(obj)) {
    var oIter = obj.listIterator__ju_ListIterator();
    var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
    _return: {
      while (_\uff3fself.hasNext__Z()) {
        var t = _\uff3fself.next__O();
        if (oIter.hasNext__Z()) {
          var b = oIter.next__O();
          var $x_2 = ((t === null) ? (b === null) : $dp_equals__O__Z(t, b));
        } else {
          var $x_2 = false;
        }
        if ((!$x_2)) {
          var $x_1 = true;
          break _return;
        }
      }
      var $x_1 = false;
    }
    if ((!$x_1)) {
      return (!oIter.hasNext__Z());
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.hashCode__I = (function() {
  var _\uff3fself = this.listIterator__I__ju_ListIterator(0);
  var result = 1;
  while (_\uff3fself.hasNext__Z()) {
    var t = result;
    var u = _\uff3fself.next__O();
    var t$1 = (t | 0);
    result = ((Math.imul(31, t$1) + ((u === null) ? 0 : $dp_hashCode__I(u))) | 0);
  }
  return (result | 0);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.iterator__ju_Iterator = (function() {
  return this.listIterator__I__ju_ListIterator(0);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.listIterator__ju_ListIterator = (function() {
  return this.listIterator__I__ju_ListIterator(0);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.listIterator__I__ju_ListIterator = (function(index) {
  this.checkIndexOnBounds__I__V(index);
  var $x_1 = this.innerSnapshot__O();
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  return new $c_ju_concurrent_CopyOnWriteArrayListIterator($x_1, index, 0, (v.length | 0));
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerPush__O__V = (function(elem) {
  var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
  v.push(elem);
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.copyIfNeeded__V = (function() {
  if (this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite) {
    var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    this.ju_concurrent_CopyOnWriteArrayList__f_inner = v.slice(0);
    this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = false;
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.innerSnapshot__O = (function() {
  this.ju_concurrent_CopyOnWriteArrayList__f_requiresCopyOnWrite = true;
  return this.ju_concurrent_CopyOnWriteArrayList__f_inner;
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.checkIndexInBounds__I__V = (function(index) {
  if ((index < 0)) {
    var $x_1 = true;
  } else {
    var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    var $x_1 = (index >= (v.length | 0));
  }
  if ($x_1) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
$c_ju_concurrent_CopyOnWriteArrayList.prototype.checkIndexOnBounds__I__V = (function(index) {
  if ((index < 0)) {
    var $x_1 = true;
  } else {
    var v = this.ju_concurrent_CopyOnWriteArrayList__f_inner;
    var $x_1 = (index > (v.length | 0));
  }
  if ($x_1) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  }
});
var $d_ju_concurrent_CopyOnWriteArrayList = new $TypeData().initClass($c_ju_concurrent_CopyOnWriteArrayList, "java.util.concurrent.CopyOnWriteArrayList", ({
  ju_concurrent_CopyOnWriteArrayList: 1,
  ju_List: 1,
  ju_SequencedCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_RandomAccess: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_concurrent_CopyOnWriteArrayList as $d_ju_concurrent_CopyOnWriteArrayList };
function $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq($thiz, n, s) {
  while (true) {
    if (((n <= 0) || s.isEmpty__Z())) {
      return s;
    } else {
      var temp$n = (((-1) + n) | 0);
      var temp$s = s.tail__O();
      n = temp$n;
      s = temp$s;
    }
  }
}
export { $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq as $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq };
function $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps($thiz, f) {
  var b = $thiz.mapFactory__sc_MapFactory().newBuilder__scm_Builder();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = f.apply__O__O(it.next__O());
    b.addOne__O__scm_Growable(elem);
  }
  return b.result__O();
}
export { $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps as $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps };
function $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps($thiz, suffix) {
  var b = $thiz.mapFactory__sc_MapFactory().newBuilder__scm_Builder();
  b.addAll__sc_IterableOnce__scm_Growable($thiz);
  b.addAll__sc_IterableOnce__scm_Growable(suffix);
  return b.result__O();
}
export { $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps as $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps };
function $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps($thiz, pf) {
  var b = $thiz.mapFactory__sc_MapFactory().newBuilder__scm_Builder();
  var marker = $m_sr_Statics$PFMarker$();
  var it = $thiz.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var v = pf.applyOrElse__O__F1__O(elem, new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((marker) => ((x$2$2) => marker))(marker)));
    if ((marker !== v)) {
      b.addOne__O__scm_Growable(v);
    }
  }
  return b.result__O();
}
export { $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps as $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps };
function $isArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$MutableSetWrapper)));
}
export { $isArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper as $isArrayOf_sc_convert_JavaCollectionWrappers$MutableSetWrapper };
function $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O($thiz, f) {
  if (($thiz.lengthCompare__I__I(1) <= 0)) {
    return $thiz;
  } else {
    var builder = $thiz.newSpecificBuilder__scm_Builder();
    var seen = $ct_scm_HashSet__(new $c_scm_HashSet());
    var it = $thiz.iterator__sc_Iterator();
    var different = false;
    while (it.hasNext__Z()) {
      var next = it.next__O();
      if (seen.add__O__Z(f.apply__O__O(next))) {
        builder.addOne__O__scm_Growable(next);
      } else {
        different = true;
      }
    }
    return (different ? builder.result__O() : $thiz);
  }
}
export { $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O as $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O };
function $f_sci_StrictOptimizedSeqOps__updated__I__O__O($thiz, index, elem) {
  if ((index < 0)) {
    throw (($thiz.knownSize__I() >= 0) ? $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, $thiz.knownSize__I()) : $m_scg_CommonErrors$().indexOutOfBounds__I__jl_IndexOutOfBoundsException(index));
  }
  var b = $thiz.iterableFactory__sc_SeqFactory().newBuilder__scm_Builder();
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(b, $thiz, 0);
  var i = 0;
  var it = $thiz.iterator__sc_Iterator();
  while (((i < index) && it.hasNext__Z())) {
    var elem$1 = it.next__O();
    b.addOne__O__scm_Growable(elem$1);
    i = ((1 + i) | 0);
  }
  if ((!it.hasNext__Z())) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + i) | 0));
  }
  b.addOne__O__scm_Growable(elem);
  it.next__O();
  while (it.hasNext__Z()) {
    var elem$2 = it.next__O();
    b.addOne__O__scm_Growable(elem$2);
  }
  return b.result__O();
}
export { $f_sci_StrictOptimizedSeqOps__updated__I__O__O as $f_sci_StrictOptimizedSeqOps__updated__I__O__O };
function $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O($thiz, from, other, replaced) {
  var b = $thiz.iterableFactory__sc_SeqFactory().newBuilder__scm_Builder();
  var i = 0;
  var it = $thiz.iterator__sc_Iterator();
  while (((i < from) && it.hasNext__Z())) {
    var elem = it.next__O();
    b.addOne__O__scm_Growable(elem);
    i = ((1 + i) | 0);
  }
  b.addAll__sc_IterableOnce__scm_Growable(other);
  i = replaced;
  while (((i > 0) && it.hasNext__Z())) {
    it.next__O();
    i = (((-1) + i) | 0);
  }
  while (it.hasNext__Z()) {
    var elem$1 = it.next__O();
    b.addOne__O__scm_Growable(elem$1);
  }
  return b.result__O();
}
export { $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O as $f_sci_StrictOptimizedSeqOps__patch__I__sc_IterableOnce__I__O };
function $p_s_math_BigDecimal__computeHashCode__V($thiz) {
  if ($thiz.isWhole__Z()) {
    var $x_3 = $thiz.s_math_BigDecimal__f_bigDecimal.precision__I();
    var this$1 = $thiz.s_math_BigDecimal__f_bigDecimal;
    var $x_2 = ((($x_3 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0) < 4934);
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    var $x_1 = $thiz.toBigInt__s_math_BigInt().hashCode__I();
  } else if ($thiz.isDecimalDouble__Z()) {
    var dv = $thiz.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
    var $x_1 = $m_sr_Statics$().doubleHash__D__I(dv);
  } else {
    var temp = $thiz.s_math_BigDecimal__f_bigDecimal.stripTrailingZeros__Ljava_math_BigDecimal();
    var $x_1 = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(temp.scaleByPowerOfTen__I__Ljava_math_BigDecimal(temp.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale).toBigInteger__Ljava_math_BigInteger().hashCode__I(), temp.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale);
  }
  $thiz.s_math_BigDecimal__f_computedHashCode = $x_1;
}
export { $p_s_math_BigDecimal__computeHashCode__V as $p_s_math_BigDecimal__computeHashCode__V };
/** @constructor */
function $c_s_math_BigDecimal(bigDecimal, mc) {
  this.s_math_BigDecimal__f_bigDecimal = null;
  this.s_math_BigDecimal__f_mc = null;
  this.s_math_BigDecimal__f_computedHashCode = 0;
  this.s_math_BigDecimal__f_bigDecimal = bigDecimal;
  this.s_math_BigDecimal__f_mc = mc;
  if ((bigDecimal === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null value for BigDecimal");
  }
  if ((mc === null)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "null MathContext for BigDecimal");
  }
  this.s_math_BigDecimal__f_computedHashCode = 1565550863;
}
export { $c_s_math_BigDecimal as $c_s_math_BigDecimal };
$c_s_math_BigDecimal.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigDecimal.prototype.constructor = $c_s_math_BigDecimal;
/** @constructor */
function $h_s_math_BigDecimal() {
}
export { $h_s_math_BigDecimal as $h_s_math_BigDecimal };
$h_s_math_BigDecimal.prototype = $c_s_math_BigDecimal.prototype;
$c_s_math_BigDecimal.prototype.compareTo__O__I = (function(that) {
  return this.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(that.s_math_BigDecimal__f_bigDecimal);
});
$c_s_math_BigDecimal.prototype.hashCode__I = (function() {
  if ((this.s_math_BigDecimal__f_computedHashCode === 1565550863)) {
    $p_s_math_BigDecimal__computeHashCode__V(this);
  }
  return this.s_math_BigDecimal__f_computedHashCode;
});
$c_s_math_BigDecimal.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigDecimal)) {
    return this.equals__s_math_BigDecimal__Z(that);
  } else if ((that instanceof $c_s_math_BigInt)) {
    var $x_2 = that.bitLength__I();
    var $x_1 = this.s_math_BigDecimal__f_bigDecimal.precision__I();
    var this$1 = this.s_math_BigDecimal__f_bigDecimal;
    if (($x_2 > (3.3219280948873626 * (((-2) + (($x_1 - this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale) | 0)) | 0)))) {
      var this$2 = this.toBigIntExact__s_Option();
      if ((!this$2.isEmpty__Z())) {
        var x0 = this$2.get__O();
        return that.equals__s_math_BigInt__Z(x0);
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if (((typeof that) === "number")) {
    var x4 = (+that);
    if ((!((x4 === Infinity) || (x4 === (-Infinity))))) {
      var d = this.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
      if (((!((d === Infinity) || (d === (-Infinity)))) && (d === x4))) {
        var this$9 = $m_s_math_BigDecimal$();
        return this.equals__s_math_BigDecimal__Z(this$9.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$9.s_math_BigDecimal$__f_defaultMathContext));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else if ($isFloat(that)) {
    var x5 = Math.fround(that);
    if ((!((x5 === Infinity) || (x5 === (-Infinity))))) {
      var f = this.s_math_BigDecimal__f_bigDecimal.floatValue__F();
      if (((!((f === Infinity) || (f === (-Infinity)))) && (f === x5))) {
        var this$16 = $m_s_math_BigDecimal$();
        var d$1 = f;
        return this.equals__s_math_BigDecimal__Z(this$16.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d$1, this$16.s_math_BigDecimal$__f_defaultMathContext));
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that));
  }
});
$c_s_math_BigDecimal.prototype.isValidByte__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.byteValueExact__B();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidShort__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.shortValueExact__S();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidChar__Z = (function() {
  return ((this.isValidInt__Z() && (this.s_math_BigDecimal__f_bigDecimal.intValueExact__I() >= 0)) && (this.s_math_BigDecimal__f_bigDecimal.intValueExact__I() <= 65535));
});
$c_s_math_BigDecimal.prototype.isValidInt__Z = (function() {
  try {
    this.s_math_BigDecimal__f_bigDecimal.intValueExact__I();
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isValidLong__Z = (function() {
  try {
    var this$1 = this.s_math_BigDecimal__f_bigDecimal;
    $p_Ljava_math_BigDecimal__valueExact__I__J(this$1, 64);
    return true;
  } catch (e) {
    if ((e instanceof $c_jl_ArithmeticException)) {
      return false;
    } else {
      throw e;
    }
  }
});
$c_s_math_BigDecimal.prototype.isDecimalDouble__Z = (function() {
  var d = this.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
  if ((!((d === Infinity) || (d === (-Infinity))))) {
    var this$4 = $m_s_math_BigDecimal$();
    return this.equals__s_math_BigDecimal__Z(this$4.decimal__D__Ljava_math_MathContext__s_math_BigDecimal(d, this$4.s_math_BigDecimal$__f_defaultMathContext));
  } else {
    return false;
  }
});
$c_s_math_BigDecimal.prototype.isWhole__Z = (function() {
  var this$1 = this.s_math_BigDecimal__f_bigDecimal;
  if ((this$1.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0)) {
    return true;
  } else {
    var this$2 = this.s_math_BigDecimal__f_bigDecimal.stripTrailingZeros__Ljava_math_BigDecimal();
    return (this$2.Ljava_math_BigDecimal__f_java$math$BigDecimal$$_scale <= 0);
  }
});
$c_s_math_BigDecimal.prototype.equals__s_math_BigDecimal__Z = (function(that) {
  return (this.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(that.s_math_BigDecimal__f_bigDecimal) === 0);
});
$c_s_math_BigDecimal.prototype.byteValue__B = (function() {
  return ((this.s_math_BigDecimal__f_bigDecimal.intValue__I() << 24) >> 24);
});
$c_s_math_BigDecimal.prototype.shortValue__S = (function() {
  return ((this.s_math_BigDecimal__f_bigDecimal.intValue__I() << 16) >> 16);
});
$c_s_math_BigDecimal.prototype.intValue__I = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.intValue__I();
});
$c_s_math_BigDecimal.prototype.longValue__J = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.longValue__J();
});
$c_s_math_BigDecimal.prototype.floatValue__F = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.floatValue__F();
});
$c_s_math_BigDecimal.prototype.doubleValue__D = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.doubleValue__D();
});
$c_s_math_BigDecimal.prototype.toBigInt__s_math_BigInt = (function() {
  return $ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), this.s_math_BigDecimal__f_bigDecimal.toBigInteger__Ljava_math_BigInteger());
});
$c_s_math_BigDecimal.prototype.toBigIntExact__s_Option = (function() {
  if (this.isWhole__Z()) {
    try {
      return new $c_s_Some($ct_s_math_BigInt__Ljava_math_BigInteger__(new $c_s_math_BigInt(), this.s_math_BigDecimal__f_bigDecimal.toBigIntegerExact__Ljava_math_BigInteger()));
    } catch (e) {
      if ((e instanceof $c_jl_ArithmeticException)) {
        return $m_s_None$();
      } else {
        throw e;
      }
    }
  } else {
    return $m_s_None$();
  }
});
$c_s_math_BigDecimal.prototype.toString__T = (function() {
  return this.s_math_BigDecimal__f_bigDecimal.toString__T();
});
$c_s_math_BigDecimal.prototype.compare__O__I = (function(that) {
  return this.s_math_BigDecimal__f_bigDecimal.compareTo__Ljava_math_BigDecimal__I(that.s_math_BigDecimal__f_bigDecimal);
});
$c_s_math_BigDecimal.prototype.underlying__O = (function() {
  return this.s_math_BigDecimal__f_bigDecimal;
});
function $isArrayOf_s_math_BigDecimal(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigDecimal)));
}
export { $isArrayOf_s_math_BigDecimal as $isArrayOf_s_math_BigDecimal };
var $d_s_math_BigDecimal = new $TypeData().initClass($c_s_math_BigDecimal, "scala.math.BigDecimal", ({
  s_math_BigDecimal: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
export { $d_s_math_BigDecimal as $d_s_math_BigDecimal };
function $p_s_math_BigInt__longEncoding__Z($thiz) {
  var a = $thiz.s_math_BigInt__f__long;
  return (!((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === (-2147483648))));
}
export { $p_s_math_BigInt__longEncoding__Z as $p_s_math_BigInt__longEncoding__Z };
function $p_s_math_BigInt__bitLengthOverflow__Z($thiz) {
  var shifted = $thiz.bigInteger__Ljava_math_BigInteger().shiftRight__I__Ljava_math_BigInteger(2147483647);
  return ((shifted.Ljava_math_BigInteger__f_sign !== 0) && (!shifted.equals__O__Z($m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$minusOne)));
}
export { $p_s_math_BigInt__bitLengthOverflow__Z as $p_s_math_BigInt__bitLengthOverflow__Z };
function $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, _bigInteger, _long) {
  $thiz.s_math_BigInt__f__bigInteger = _bigInteger;
  $thiz.s_math_BigInt__f__long = _long;
  return $thiz;
}
export { $ct_s_math_BigInt__Ljava_math_BigInteger__J__ as $ct_s_math_BigInt__Ljava_math_BigInteger__J__ };
function $ct_s_math_BigInt__Ljava_math_BigInteger__($thiz, bigInteger) {
  $ct_s_math_BigInt__Ljava_math_BigInteger__J__($thiz, bigInteger, (($m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(bigInteger) <= 63) ? bigInteger.longValue__J() : new $c_RTLong(0, (-2147483648))));
  return $thiz;
}
export { $ct_s_math_BigInt__Ljava_math_BigInteger__ as $ct_s_math_BigInt__Ljava_math_BigInteger__ };
/** @constructor */
function $c_s_math_BigInt() {
  this.s_math_BigInt__f__bigInteger = null;
  this.s_math_BigInt__f__long = $L0;
}
export { $c_s_math_BigInt as $c_s_math_BigInt };
$c_s_math_BigInt.prototype = new $h_s_math_ScalaNumber();
$c_s_math_BigInt.prototype.constructor = $c_s_math_BigInt;
/** @constructor */
function $h_s_math_BigInt() {
}
export { $h_s_math_BigInt as $h_s_math_BigInt };
$h_s_math_BigInt.prototype = $c_s_math_BigInt.prototype;
$c_s_math_BigInt.prototype.compareTo__O__I = (function(that) {
  return this.compare__s_math_BigInt__I(that);
});
$c_s_math_BigInt.prototype.bigInteger__Ljava_math_BigInteger = (function() {
  var read = this.s_math_BigInt__f__bigInteger;
  if ((read !== null)) {
    return read;
  } else {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var write = $m_Ljava_math_BigInteger$().valueOf__J__Ljava_math_BigInteger(new $c_RTLong(lo, hi));
    this.s_math_BigInt__f__bigInteger = write;
    return write;
  }
});
$c_s_math_BigInt.prototype.hashCode__I = (function() {
  if (this.isValidLong__Z()) {
    return $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveHashcode__I(this);
  } else {
    var x = this.bigInteger__Ljava_math_BigInteger();
    return $m_sr_Statics$().anyHash__O__I(x);
  }
});
$c_s_math_BigInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_s_math_BigInt)) {
    return this.equals__s_math_BigInt__Z(that);
  } else if ((that instanceof $c_s_math_BigDecimal)) {
    return that.equals__O__Z(this);
  } else if (((typeof that) === "number")) {
    var x4 = (+that);
    return (this.isValidDouble__Z() && (this.doubleValue__D() === x4));
  } else if ($isFloat(that)) {
    var x5 = Math.fround(that);
    if (this.isValidFloat__Z()) {
      var this$1 = this.bigInteger__Ljava_math_BigInteger();
      return ($m_jl_Float$().parseFloat__T__F($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1)) === x5);
    } else {
      return false;
    }
  } else {
    return (this.isValidLong__Z() && $f_s_math_ScalaNumericAnyConversions__unifiedPrimitiveEquals__O__Z(this, that));
  }
});
$c_s_math_BigInt.prototype.isValidByte__Z = (function() {
  var a = this.s_math_BigInt__f__long;
  var ahi = a.RTLong__f_hi;
  if (((ahi === (-1)) ? ((a.RTLong__f_lo >>> 0) >= 4294967168) : (ahi > (-1)))) {
    var a$1 = this.s_math_BigInt__f__long;
    var ahi$1 = a$1.RTLong__f_hi;
    return ((ahi$1 === 0) ? ((a$1.RTLong__f_lo >>> 0) <= 127) : (ahi$1 < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidShort__Z = (function() {
  var a = this.s_math_BigInt__f__long;
  var ahi = a.RTLong__f_hi;
  if (((ahi === (-1)) ? ((a.RTLong__f_lo >>> 0) >= 4294934528) : (ahi > (-1)))) {
    var a$1 = this.s_math_BigInt__f__long;
    var ahi$1 = a$1.RTLong__f_hi;
    return ((ahi$1 === 0) ? ((a$1.RTLong__f_lo >>> 0) <= 32767) : (ahi$1 < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidChar__Z = (function() {
  var a = this.s_math_BigInt__f__long;
  var ahi = a.RTLong__f_hi;
  if ((ahi >= 0)) {
    var a$1 = this.s_math_BigInt__f__long;
    var ahi$1 = a$1.RTLong__f_hi;
    return ((ahi$1 === 0) ? ((a$1.RTLong__f_lo >>> 0) <= 65535) : (ahi$1 < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidInt__Z = (function() {
  var a = this.s_math_BigInt__f__long;
  var ahi = a.RTLong__f_hi;
  if (((ahi === (-1)) ? ((a.RTLong__f_lo >>> 0) >= 2147483648) : (ahi > (-1)))) {
    var a$1 = this.s_math_BigInt__f__long;
    var ahi$1 = a$1.RTLong__f_hi;
    return ((ahi$1 === 0) ? ((a$1.RTLong__f_lo >>> 0) <= 2147483647) : (ahi$1 < 0));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidLong__Z = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) || $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, $m_s_math_BigInt$().s_math_BigInt$__f_scala$math$BigInt$$longMinValueBigInteger));
});
$c_s_math_BigInt.prototype.isValidFloat__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 24)) {
    var $x_1 = true;
  } else {
    var lowest = this.lowestSetBit__I();
    var $x_1 = (((bitLen <= 128) && (lowest >= (((-24) + bitLen) | 0))) && (lowest < 128));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isValidDouble__Z = (function() {
  var bitLen = this.bitLength__I();
  if ((bitLen <= 53)) {
    var $x_1 = true;
  } else {
    var lowest = this.lowestSetBit__I();
    var $x_1 = (((bitLen <= 1024) && (lowest >= (((-53) + bitLen) | 0))) && (lowest < 1024));
  }
  if ($x_1) {
    return (!$p_s_math_BigInt__bitLengthOverflow__Z(this));
  } else {
    return false;
  }
});
$c_s_math_BigInt.prototype.isWhole__Z = (function() {
  return true;
});
$c_s_math_BigInt.prototype.equals__s_math_BigInt__Z = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var a = this.s_math_BigInt__f__long;
      var b = that.s_math_BigInt__f__long;
      return ((a.RTLong__f_lo === b.RTLong__f_lo) && (a.RTLong__f_hi === b.RTLong__f_hi));
    } else {
      return false;
    }
  } else {
    return ((!$p_s_math_BigInt__longEncoding__Z(that)) && $m_sr_BoxesRunTime$().equalsNumNum__jl_Number__jl_Number__Z(this.s_math_BigInt__f__bigInteger, that.s_math_BigInt__f__bigInteger));
  }
});
$c_s_math_BigInt.prototype.compare__s_math_BigInt__I = (function(that) {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    if ($p_s_math_BigInt__longEncoding__Z(that)) {
      var t = this.s_math_BigInt__f__long;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      var t$1 = that.s_math_BigInt__f__long;
      var lo$1 = t$1.RTLong__f_lo;
      var hi$1 = t$1.RTLong__f_hi;
      return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
    } else {
      var this$2 = that.s_math_BigInt__f__bigInteger;
      return ((-this$2.Ljava_math_BigInteger__f_sign) | 0);
    }
  } else if ($p_s_math_BigInt__longEncoding__Z(that)) {
    var this$3 = this.s_math_BigInt__f__bigInteger;
    return this$3.Ljava_math_BigInteger__f_sign;
  } else {
    return this.s_math_BigInt__f__bigInteger.compareTo__Ljava_math_BigInteger__I(that.s_math_BigInt__f__bigInteger);
  }
});
$c_s_math_BigInt.prototype.$plus__s_math_BigInt__s_math_BigInt = (function(that) {
  if (($p_s_math_BigInt__longEncoding__Z(this) && $p_s_math_BigInt__longEncoding__Z(that))) {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = that.s_math_BigInt__f__long;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var lo$2 = ((lo + lo$1) | 0);
    var hi$2 = ((((hi + hi$1) | 0) + ((((lo & lo$1) | ((lo | lo$1) & (~lo$2))) >>> 31) | 0)) | 0);
    var hi$3 = (hi ^ hi$1);
    var hi$4 = (~hi$3);
    var hi$5 = (hi ^ hi$2);
    var hi$6 = (hi$4 & hi$5);
    if ((hi$6 >= 0)) {
      return $m_s_math_BigInt$().apply__J__s_math_BigInt(new $c_RTLong(lo$2, hi$2));
    }
  }
  var $x_1 = $m_s_math_BigInt$();
  var this$7 = this.bigInteger__Ljava_math_BigInteger();
  var bi = that.bigInteger__Ljava_math_BigInteger();
  return $x_1.apply__Ljava_math_BigInteger__s_math_BigInt($m_Ljava_math_Elementary$().add__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$7, bi));
});
$c_s_math_BigInt.prototype.$minus__s_math_BigInt__s_math_BigInt = (function(that) {
  if (($p_s_math_BigInt__longEncoding__Z(this) && $p_s_math_BigInt__longEncoding__Z(that))) {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = that.s_math_BigInt__f__long;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var lo$2 = ((lo - lo$1) | 0);
    var hi$2 = ((((hi - hi$1) | 0) + ((((~lo) & lo$1) | ((~(lo ^ lo$1)) & lo$2)) >> 31)) | 0);
    var hi$3 = (hi ^ hi$1);
    var hi$4 = (hi ^ hi$2);
    var hi$5 = (hi$3 & hi$4);
    if ((hi$5 >= 0)) {
      return $m_s_math_BigInt$().apply__J__s_math_BigInt(new $c_RTLong(lo$2, hi$2));
    }
  }
  var $x_1 = $m_s_math_BigInt$();
  var this$6 = this.bigInteger__Ljava_math_BigInteger();
  var bi = that.bigInteger__Ljava_math_BigInteger();
  return $x_1.apply__Ljava_math_BigInteger__s_math_BigInt($m_Ljava_math_Elementary$().subtract__Ljava_math_BigInteger__Ljava_math_BigInteger__Ljava_math_BigInteger(this$6, bi));
});
$c_s_math_BigInt.prototype.$times__s_math_BigInt__s_math_BigInt = (function(that) {
  if (($p_s_math_BigInt__longEncoding__Z(this) && $p_s_math_BigInt__longEncoding__Z(that))) {
    var t = this.s_math_BigInt__f__long;
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var t$1 = that.s_math_BigInt__f__long;
    var lo$1 = t$1.RTLong__f_lo;
    var hi$1 = t$1.RTLong__f_hi;
    var a0 = (65535 & lo);
    var a1 = ((lo >>> 16) | 0);
    var b0 = (65535 & lo$1);
    var b1 = ((lo$1 >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((((((Math.imul(lo, hi$1) + Math.imul(hi, lo$1)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    if (((lo === 0) && (hi === 0))) {
      var $x_1 = true;
    } else {
      var this$3 = $m_RTLong$();
      var lo$3 = this$3.divideImpl__I__I__I__I__I(lo$2, hi$2, lo, hi);
      var hi$3 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var $x_1 = ((lo$1 === lo$3) && (hi$1 === hi$3));
    }
    if ($x_1) {
      return $m_s_math_BigInt$().apply__J__s_math_BigInt(new $c_RTLong(lo$2, hi$2));
    }
  }
  return $m_s_math_BigInt$().apply__Ljava_math_BigInteger__s_math_BigInt(this.bigInteger__Ljava_math_BigInteger().multiply__Ljava_math_BigInteger__Ljava_math_BigInteger(that.bigInteger__Ljava_math_BigInteger()));
});
$c_s_math_BigInt.prototype.$less$less__I__s_math_BigInt = (function(n) {
  return (($p_s_math_BigInt__longEncoding__Z(this) && (n <= 0)) ? this.$greater$greater__I__s_math_BigInt(((-n) | 0)) : $m_s_math_BigInt$().apply__Ljava_math_BigInteger__s_math_BigInt(this.bigInteger__Ljava_math_BigInteger().shiftLeft__I__Ljava_math_BigInteger(n)));
});
$c_s_math_BigInt.prototype.$greater$greater__I__s_math_BigInt = (function(n) {
  if (($p_s_math_BigInt__longEncoding__Z(this) && (n >= 0))) {
    if ((n < 64)) {
      var $x_1 = $m_s_math_BigInt$();
      var a = this.s_math_BigInt__f__long;
      var hi = a.RTLong__f_hi;
      var lo = (((32 & n) === 0) ? (((a.RTLong__f_lo >>> n) | 0) | ((hi << 1) << ((31 - n) | 0))) : (hi >> n));
      var hi$1 = (((32 & n) === 0) ? (hi >> n) : (hi >> 31));
      return $x_1.apply__J__s_math_BigInt(new $c_RTLong(lo, hi$1));
    } else {
      var a$1 = this.s_math_BigInt__f__long;
      var ahi = a$1.RTLong__f_hi;
      if ((ahi < 0)) {
        return $m_s_math_BigInt$().apply__I__s_math_BigInt((-1));
      } else {
        return $m_s_math_BigInt$().apply__I__s_math_BigInt(0);
      }
    }
  } else {
    return $m_s_math_BigInt$().apply__Ljava_math_BigInteger__s_math_BigInt(this.bigInteger__Ljava_math_BigInteger().shiftRight__I__Ljava_math_BigInteger(n));
  }
});
$c_s_math_BigInt.prototype.min__s_math_BigInt__s_math_BigInt = (function(that) {
  return ($f_s_math_Ordered__$less$eq__O__Z(this, that) ? this : that);
});
$c_s_math_BigInt.prototype.unary_$minus__s_math_BigInt = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var $x_1 = $m_s_math_BigInt$();
    var b = this.s_math_BigInt__f__long;
    var blo = b.RTLong__f_lo;
    var lo = ((-blo) | 0);
    var hi = ((((-b.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
    return $x_1.apply__J__s_math_BigInt(new $c_RTLong(lo, hi));
  } else {
    return $m_s_math_BigInt$().apply__Ljava_math_BigInteger__s_math_BigInt(this.bigInteger__Ljava_math_BigInteger().negate__Ljava_math_BigInteger());
  }
});
$c_s_math_BigInt.prototype.lowestSetBit__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var a = this.s_math_BigInt__f__long;
    if (((a.RTLong__f_lo === 0) && (a.RTLong__f_hi === 0))) {
      return (-1);
    } else {
      var t = this.s_math_BigInt__f__long;
      var lo = t.RTLong__f_lo;
      var hi = t.RTLong__f_hi;
      if ((lo !== 0)) {
        var i = ((~lo) & (((-1) + lo) | 0));
        return ((32 - Math.clz32(i)) | 0);
      } else {
        var i$1 = ((~hi) & (((-1) + hi) | 0));
        return ((64 - Math.clz32(i$1)) | 0);
      }
    }
  } else {
    return this.bigInteger__Ljava_math_BigInteger().getLowestSetBit__I();
  }
});
$c_s_math_BigInt.prototype.bitLength__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var a = this.s_math_BigInt__f__long;
    var ahi = a.RTLong__f_hi;
    if ((ahi < 0)) {
      var b = this.s_math_BigInt__f__long;
      var blo = b.RTLong__f_lo;
      var lo = ((1 + blo) | 0);
      var hi = ((b.RTLong__f_hi + (((blo & (~lo)) >>> 31) | 0)) | 0);
      var lo$1 = ((-lo) | 0);
      var hi$1 = ((((-hi) | 0) + ((lo | lo$1) >> 31)) | 0);
      return ((64 - ((hi$1 !== 0) ? Math.clz32(hi$1) : ((32 + Math.clz32(lo$1)) | 0))) | 0);
    } else {
      var t = this.s_math_BigInt__f__long;
      var lo$2 = t.RTLong__f_lo;
      var hi$2 = t.RTLong__f_hi;
      return ((64 - ((hi$2 !== 0) ? Math.clz32(hi$2) : ((32 + Math.clz32(lo$2)) | 0))) | 0);
    }
  } else {
    var this$12 = this.s_math_BigInt__f__bigInteger;
    return $m_Ljava_math_BitLevel$().bitLength__Ljava_math_BigInteger__I(this$12);
  }
});
$c_s_math_BigInt.prototype.byteValue__B = (function() {
  return ((this.intValue__I() << 24) >> 24);
});
$c_s_math_BigInt.prototype.shortValue__S = (function() {
  return ((this.intValue__I() << 16) >> 16);
});
$c_s_math_BigInt.prototype.intValue__I = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var a = this.s_math_BigInt__f__long;
    return a.RTLong__f_lo;
  } else {
    return this.bigInteger__Ljava_math_BigInteger().intValue__I();
  }
});
$c_s_math_BigInt.prototype.longValue__J = (function() {
  return ($p_s_math_BigInt__longEncoding__Z(this) ? this.s_math_BigInt__f__long : this.s_math_BigInt__f__bigInteger.longValue__J());
});
$c_s_math_BigInt.prototype.floatValue__F = (function() {
  var this$1 = this.bigInteger__Ljava_math_BigInteger();
  return $m_jl_Float$().parseFloat__T__F($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$1));
});
$c_s_math_BigInt.prototype.doubleValue__D = (function() {
  if (this.isValidLong__Z()) {
    var a = this.s_math_BigInt__f__long;
    var ahi = a.RTLong__f_hi;
    if ((ahi >= (-2097152))) {
      var a$1 = this.s_math_BigInt__f__long;
      var ahi$1 = a$1.RTLong__f_hi;
      var $x_1 = ((ahi$1 === 2097152) ? (a$1.RTLong__f_lo === 0) : (ahi$1 < 2097152));
    } else {
      var $x_1 = false;
    }
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var a$2 = this.s_math_BigInt__f__long;
    var lo = a$2.RTLong__f_lo;
    var hi = a$2.RTLong__f_hi;
    return ((4.294967296E9 * hi) + (lo >>> 0.0));
  } else {
    var this$4 = this.bigInteger__Ljava_math_BigInteger();
    return $m_jl_Double$().parseDouble__T__D($m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$4));
  }
});
$c_s_math_BigInt.prototype.toString__T = (function() {
  if ($p_s_math_BigInt__longEncoding__Z(this)) {
    var this$1 = this.s_math_BigInt__f__long;
    var this$2 = $m_RTLong$();
    return this$2.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(this$1.RTLong__f_lo, this$1.RTLong__f_hi);
  } else {
    var this$3 = this.s_math_BigInt__f__bigInteger;
    return $m_Ljava_math_Conversion$().toDecimalScaledString__Ljava_math_BigInteger__T(this$3);
  }
});
$c_s_math_BigInt.prototype.compare__O__I = (function(that) {
  return this.compare__s_math_BigInt__I(that);
});
$c_s_math_BigInt.prototype.underlying__O = (function() {
  return this.bigInteger__Ljava_math_BigInteger();
});
function $isArrayOf_s_math_BigInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_BigInt)));
}
export { $isArrayOf_s_math_BigInt as $isArrayOf_s_math_BigInt };
var $d_s_math_BigInt = new $TypeData().initClass($c_s_math_BigInt, "scala.math.BigInt", ({
  s_math_BigInt: 1,
  s_math_ScalaNumber: 1,
  jl_Number: 1,
  Ljava_io_Serializable: 1,
  s_math_ScalaNumericConversions: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1
}));
export { $d_s_math_BigInt as $d_s_math_BigInt };
function $f_s_math_Numeric$ByteIsIntegral__plus__B__B__B($thiz, x, y) {
  return ((((x + y) | 0) << 24) >> 24);
}
export { $f_s_math_Numeric$ByteIsIntegral__plus__B__B__B as $f_s_math_Numeric$ByteIsIntegral__plus__B__B__B };
function $f_s_math_Numeric$ByteIsIntegral__minus__B__B__B($thiz, x, y) {
  return ((((x - y) | 0) << 24) >> 24);
}
export { $f_s_math_Numeric$ByteIsIntegral__minus__B__B__B as $f_s_math_Numeric$ByteIsIntegral__minus__B__B__B };
function $f_s_math_Numeric$ByteIsIntegral__times__B__B__B($thiz, x, y) {
  return ((Math.imul(x, y) << 24) >> 24);
}
export { $f_s_math_Numeric$ByteIsIntegral__times__B__B__B as $f_s_math_Numeric$ByteIsIntegral__times__B__B__B };
function $f_s_math_Numeric$ByteIsIntegral__quot__B__B__B($thiz, x, y) {
  return ((((x / $checkIntDivisor(y)) | 0) << 24) >> 24);
}
export { $f_s_math_Numeric$ByteIsIntegral__quot__B__B__B as $f_s_math_Numeric$ByteIsIntegral__quot__B__B__B };
function $f_s_math_Numeric$ByteIsIntegral__rem__B__B__B($thiz, x, y) {
  return ((((x % $checkIntDivisor(y)) | 0) << 24) >> 24);
}
export { $f_s_math_Numeric$ByteIsIntegral__rem__B__B__B as $f_s_math_Numeric$ByteIsIntegral__rem__B__B__B };
function $f_s_math_Numeric$ByteIsIntegral__negate__B__B($thiz, x) {
  return ((((-x) | 0) << 24) >> 24);
}
export { $f_s_math_Numeric$ByteIsIntegral__negate__B__B as $f_s_math_Numeric$ByteIsIntegral__negate__B__B };
function $f_s_math_Numeric$ByteIsIntegral__sign__B__B($thiz, x) {
  var x$1 = x;
  return ((((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0)) << 24) >> 24);
}
export { $f_s_math_Numeric$ByteIsIntegral__sign__B__B as $f_s_math_Numeric$ByteIsIntegral__sign__B__B };
function $f_s_math_Numeric$CharIsIntegral__plus__C__C__C($thiz, x, y) {
  return (65535 & ((x + y) | 0));
}
export { $f_s_math_Numeric$CharIsIntegral__plus__C__C__C as $f_s_math_Numeric$CharIsIntegral__plus__C__C__C };
function $f_s_math_Numeric$CharIsIntegral__minus__C__C__C($thiz, x, y) {
  return (65535 & ((x - y) | 0));
}
export { $f_s_math_Numeric$CharIsIntegral__minus__C__C__C as $f_s_math_Numeric$CharIsIntegral__minus__C__C__C };
function $f_s_math_Numeric$CharIsIntegral__times__C__C__C($thiz, x, y) {
  return (65535 & Math.imul(x, y));
}
export { $f_s_math_Numeric$CharIsIntegral__times__C__C__C as $f_s_math_Numeric$CharIsIntegral__times__C__C__C };
function $f_s_math_Numeric$CharIsIntegral__quot__C__C__C($thiz, x, y) {
  return (65535 & ((x / $checkIntDivisor(y)) | 0));
}
export { $f_s_math_Numeric$CharIsIntegral__quot__C__C__C as $f_s_math_Numeric$CharIsIntegral__quot__C__C__C };
function $f_s_math_Numeric$CharIsIntegral__rem__C__C__C($thiz, x, y) {
  return (65535 & ((x % $checkIntDivisor(y)) | 0));
}
export { $f_s_math_Numeric$CharIsIntegral__rem__C__C__C as $f_s_math_Numeric$CharIsIntegral__rem__C__C__C };
function $f_s_math_Numeric$CharIsIntegral__negate__C__C($thiz, x) {
  return (65535 & ((-x) | 0));
}
export { $f_s_math_Numeric$CharIsIntegral__negate__C__C as $f_s_math_Numeric$CharIsIntegral__negate__C__C };
function $f_s_math_Numeric$CharIsIntegral__sign__C__C($thiz, x) {
  var x$1 = x;
  return (65535 & ((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0)));
}
export { $f_s_math_Numeric$CharIsIntegral__sign__C__C as $f_s_math_Numeric$CharIsIntegral__sign__C__C };
function $f_s_math_Numeric$DoubleIsFractional__plus__D__D__D($thiz, x, y) {
  return (x + y);
}
export { $f_s_math_Numeric$DoubleIsFractional__plus__D__D__D as $f_s_math_Numeric$DoubleIsFractional__plus__D__D__D };
function $f_s_math_Numeric$DoubleIsFractional__minus__D__D__D($thiz, x, y) {
  return (x - y);
}
export { $f_s_math_Numeric$DoubleIsFractional__minus__D__D__D as $f_s_math_Numeric$DoubleIsFractional__minus__D__D__D };
function $f_s_math_Numeric$DoubleIsFractional__times__D__D__D($thiz, x, y) {
  return (x * y);
}
export { $f_s_math_Numeric$DoubleIsFractional__times__D__D__D as $f_s_math_Numeric$DoubleIsFractional__times__D__D__D };
function $f_s_math_Numeric$DoubleIsFractional__negate__D__D($thiz, x) {
  return (-x);
}
export { $f_s_math_Numeric$DoubleIsFractional__negate__D__D as $f_s_math_Numeric$DoubleIsFractional__negate__D__D };
function $f_s_math_Numeric$IntIsIntegral__plus__I__I__I($thiz, x, y) {
  return ((x + y) | 0);
}
export { $f_s_math_Numeric$IntIsIntegral__plus__I__I__I as $f_s_math_Numeric$IntIsIntegral__plus__I__I__I };
function $f_s_math_Numeric$IntIsIntegral__minus__I__I__I($thiz, x, y) {
  return ((x - y) | 0);
}
export { $f_s_math_Numeric$IntIsIntegral__minus__I__I__I as $f_s_math_Numeric$IntIsIntegral__minus__I__I__I };
function $f_s_math_Numeric$IntIsIntegral__times__I__I__I($thiz, x, y) {
  return Math.imul(x, y);
}
export { $f_s_math_Numeric$IntIsIntegral__times__I__I__I as $f_s_math_Numeric$IntIsIntegral__times__I__I__I };
function $f_s_math_Numeric$IntIsIntegral__quot__I__I__I($thiz, x, y) {
  return ((x / $checkIntDivisor(y)) | 0);
}
export { $f_s_math_Numeric$IntIsIntegral__quot__I__I__I as $f_s_math_Numeric$IntIsIntegral__quot__I__I__I };
function $f_s_math_Numeric$IntIsIntegral__rem__I__I__I($thiz, x, y) {
  return ((x % $checkIntDivisor(y)) | 0);
}
export { $f_s_math_Numeric$IntIsIntegral__rem__I__I__I as $f_s_math_Numeric$IntIsIntegral__rem__I__I__I };
function $f_s_math_Numeric$IntIsIntegral__negate__I__I($thiz, x) {
  return ((-x) | 0);
}
export { $f_s_math_Numeric$IntIsIntegral__negate__I__I as $f_s_math_Numeric$IntIsIntegral__negate__I__I };
function $f_s_math_Numeric$LongIsIntegral__plus__J__J__J($thiz, x, y) {
  var alo = x.RTLong__f_lo;
  var blo = y.RTLong__f_lo;
  var lo = ((alo + blo) | 0);
  var hi = ((((x.RTLong__f_hi + y.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
  return new $c_RTLong(lo, hi);
}
export { $f_s_math_Numeric$LongIsIntegral__plus__J__J__J as $f_s_math_Numeric$LongIsIntegral__plus__J__J__J };
function $f_s_math_Numeric$LongIsIntegral__minus__J__J__J($thiz, x, y) {
  var alo = x.RTLong__f_lo;
  var blo = y.RTLong__f_lo;
  var lo = ((alo - blo) | 0);
  var hi = ((((x.RTLong__f_hi - y.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
  return new $c_RTLong(lo, hi);
}
export { $f_s_math_Numeric$LongIsIntegral__minus__J__J__J as $f_s_math_Numeric$LongIsIntegral__minus__J__J__J };
function $f_s_math_Numeric$LongIsIntegral__times__J__J__J($thiz, x, y) {
  var alo = x.RTLong__f_lo;
  var blo = y.RTLong__f_lo;
  var a0 = (65535 & alo);
  var a1 = ((alo >>> 16) | 0);
  var b0 = (65535 & blo);
  var b1 = ((blo >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0);
  var a1b0 = Math.imul(a1, b0);
  var a0b1 = Math.imul(a0, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((((Math.imul(alo, y.RTLong__f_hi) + Math.imul(x.RTLong__f_hi, blo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return new $c_RTLong(lo, hi);
}
export { $f_s_math_Numeric$LongIsIntegral__times__J__J__J as $f_s_math_Numeric$LongIsIntegral__times__J__J__J };
function $f_s_math_Numeric$LongIsIntegral__quot__J__J__J($thiz, x, y) {
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(x.RTLong__f_lo, x.RTLong__f_hi, y.RTLong__f_lo, y.RTLong__f_hi);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
}
export { $f_s_math_Numeric$LongIsIntegral__quot__J__J__J as $f_s_math_Numeric$LongIsIntegral__quot__J__J__J };
function $f_s_math_Numeric$LongIsIntegral__rem__J__J__J($thiz, x, y) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(x.RTLong__f_lo, x.RTLong__f_hi, y.RTLong__f_lo, y.RTLong__f_hi);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  return new $c_RTLong(lo, hi);
}
export { $f_s_math_Numeric$LongIsIntegral__rem__J__J__J as $f_s_math_Numeric$LongIsIntegral__rem__J__J__J };
function $f_s_math_Numeric$LongIsIntegral__negate__J__J($thiz, x) {
  var blo = x.RTLong__f_lo;
  var lo = ((-blo) | 0);
  var hi = ((((-x.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
  return new $c_RTLong(lo, hi);
}
export { $f_s_math_Numeric$LongIsIntegral__negate__J__J as $f_s_math_Numeric$LongIsIntegral__negate__J__J };
function $f_s_math_Numeric$ShortIsIntegral__plus__S__S__S($thiz, x, y) {
  return ((((x + y) | 0) << 16) >> 16);
}
export { $f_s_math_Numeric$ShortIsIntegral__plus__S__S__S as $f_s_math_Numeric$ShortIsIntegral__plus__S__S__S };
function $f_s_math_Numeric$ShortIsIntegral__minus__S__S__S($thiz, x, y) {
  return ((((x - y) | 0) << 16) >> 16);
}
export { $f_s_math_Numeric$ShortIsIntegral__minus__S__S__S as $f_s_math_Numeric$ShortIsIntegral__minus__S__S__S };
function $f_s_math_Numeric$ShortIsIntegral__times__S__S__S($thiz, x, y) {
  return ((Math.imul(x, y) << 16) >> 16);
}
export { $f_s_math_Numeric$ShortIsIntegral__times__S__S__S as $f_s_math_Numeric$ShortIsIntegral__times__S__S__S };
function $f_s_math_Numeric$ShortIsIntegral__quot__S__S__S($thiz, x, y) {
  return ((((x / $checkIntDivisor(y)) | 0) << 16) >> 16);
}
export { $f_s_math_Numeric$ShortIsIntegral__quot__S__S__S as $f_s_math_Numeric$ShortIsIntegral__quot__S__S__S };
function $f_s_math_Numeric$ShortIsIntegral__rem__S__S__S($thiz, x, y) {
  return ((((x % $checkIntDivisor(y)) | 0) << 16) >> 16);
}
export { $f_s_math_Numeric$ShortIsIntegral__rem__S__S__S as $f_s_math_Numeric$ShortIsIntegral__rem__S__S__S };
function $f_s_math_Numeric$ShortIsIntegral__negate__S__S($thiz, x) {
  return ((((-x) | 0) << 16) >> 16);
}
export { $f_s_math_Numeric$ShortIsIntegral__negate__S__S as $f_s_math_Numeric$ShortIsIntegral__negate__S__S };
function $f_s_math_Numeric$ShortIsIntegral__sign__S__S($thiz, x) {
  var x$1 = x;
  return ((((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0)) << 16) >> 16);
}
export { $f_s_math_Numeric$ShortIsIntegral__sign__S__S as $f_s_math_Numeric$ShortIsIntegral__sign__S__S };
/** @constructor */
function $c_s_math_Ordering$Int$() {
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = null;
  $n_s_math_Ordering$Int$ = this;
  this.s_math_Ordering$Int$__f_scala$math$Ordering$CachedReverse$$_reverse = new $c_s_math_Ordering$Reverse(this);
}
export { $c_s_math_Ordering$Int$ as $c_s_math_Ordering$Int$ };
$c_s_math_Ordering$Int$.prototype = new $h_O();
$c_s_math_Ordering$Int$.prototype.constructor = $c_s_math_Ordering$Int$;
/** @constructor */
function $h_s_math_Ordering$Int$() {
}
export { $h_s_math_Ordering$Int$ as $h_s_math_Ordering$Int$ };
$h_s_math_Ordering$Int$.prototype = $c_s_math_Ordering$Int$.prototype;
$c_s_math_Ordering$Int$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Ordering$Int$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Ordering$Int$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
});
var $d_s_math_Ordering$Int$ = new $TypeData().initClass($c_s_math_Ordering$Int$, "scala.math.Ordering$Int$", ({
  s_math_Ordering$Int$: 1,
  s_math_Ordering$IntOrdering: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$CachedReverse: 1
}));
export { $d_s_math_Ordering$Int$ as $d_s_math_Ordering$Int$ };
var $n_s_math_Ordering$Int$;
function $m_s_math_Ordering$Int$() {
  if ((!$n_s_math_Ordering$Int$)) {
    $n_s_math_Ordering$Int$ = new $c_s_math_Ordering$Int$();
  }
  return $n_s_math_Ordering$Int$;
}
export { $m_s_math_Ordering$Int$ as $m_s_math_Ordering$Int$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
export { $c_s_reflect_ManifestFactory$BooleanManifest as $c_s_reflect_ManifestFactory$BooleanManifest };
$c_s_reflect_ManifestFactory$BooleanManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest() {
}
export { $h_s_reflect_ManifestFactory$BooleanManifest as $h_s_reflect_ManifestFactory$BooleanManifest };
$h_s_reflect_ManifestFactory$BooleanManifest.prototype = $c_s_reflect_ManifestFactory$BooleanManifest.prototype;
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_Z.getClassOf();
});
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.unapply__O__s_Option = (function(x) {
  if (((typeof x) === "boolean")) {
    var x2 = (!(!x));
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$BooleanManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_Z(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
export { $c_s_reflect_ManifestFactory$ByteManifest as $c_s_reflect_ManifestFactory$ByteManifest };
$c_s_reflect_ManifestFactory$ByteManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ByteManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest() {
}
export { $h_s_reflect_ManifestFactory$ByteManifest as $h_s_reflect_ManifestFactory$ByteManifest };
$h_s_reflect_ManifestFactory$ByteManifest.prototype = $c_s_reflect_ManifestFactory$ByteManifest.prototype;
$c_s_reflect_ManifestFactory$ByteManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_B.getClassOf();
});
$c_s_reflect_ManifestFactory$ByteManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isByte(x)) {
    var x2 = (x | 0);
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$ByteManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_B(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
export { $c_s_reflect_ManifestFactory$CharManifest as $c_s_reflect_ManifestFactory$CharManifest };
$c_s_reflect_ManifestFactory$CharManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$CharManifest.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest() {
}
export { $h_s_reflect_ManifestFactory$CharManifest as $h_s_reflect_ManifestFactory$CharManifest };
$h_s_reflect_ManifestFactory$CharManifest.prototype = $c_s_reflect_ManifestFactory$CharManifest.prototype;
$c_s_reflect_ManifestFactory$CharManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_C.getClassOf();
});
$c_s_reflect_ManifestFactory$CharManifest.prototype.unapply__O__s_Option = (function(x) {
  if ((x instanceof $Char)) {
    var x2 = $uC(x);
    return new $c_s_Some($bC(x2));
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$CharManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_C(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
export { $c_s_reflect_ManifestFactory$DoubleManifest as $c_s_reflect_ManifestFactory$DoubleManifest };
$c_s_reflect_ManifestFactory$DoubleManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest() {
}
export { $h_s_reflect_ManifestFactory$DoubleManifest as $h_s_reflect_ManifestFactory$DoubleManifest };
$h_s_reflect_ManifestFactory$DoubleManifest.prototype = $c_s_reflect_ManifestFactory$DoubleManifest.prototype;
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_D.getClassOf();
});
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.unapply__O__s_Option = (function(x) {
  if (((typeof x) === "number")) {
    var x2 = (+x);
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$DoubleManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_D(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
export { $c_s_reflect_ManifestFactory$FloatManifest as $c_s_reflect_ManifestFactory$FloatManifest };
$c_s_reflect_ManifestFactory$FloatManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$FloatManifest.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest() {
}
export { $h_s_reflect_ManifestFactory$FloatManifest as $h_s_reflect_ManifestFactory$FloatManifest };
$h_s_reflect_ManifestFactory$FloatManifest.prototype = $c_s_reflect_ManifestFactory$FloatManifest.prototype;
$c_s_reflect_ManifestFactory$FloatManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_F.getClassOf();
});
$c_s_reflect_ManifestFactory$FloatManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isFloat(x)) {
    var x2 = Math.fround(x);
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$FloatManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_F(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
export { $c_s_reflect_ManifestFactory$IntManifest as $c_s_reflect_ManifestFactory$IntManifest };
$c_s_reflect_ManifestFactory$IntManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$IntManifest.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest() {
}
export { $h_s_reflect_ManifestFactory$IntManifest as $h_s_reflect_ManifestFactory$IntManifest };
$h_s_reflect_ManifestFactory$IntManifest.prototype = $c_s_reflect_ManifestFactory$IntManifest.prototype;
$c_s_reflect_ManifestFactory$IntManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_I.getClassOf();
});
$c_s_reflect_ManifestFactory$IntManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isInt(x)) {
    var x2 = (x | 0);
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$IntManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_I(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
export { $c_s_reflect_ManifestFactory$LongManifest as $c_s_reflect_ManifestFactory$LongManifest };
$c_s_reflect_ManifestFactory$LongManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$LongManifest.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest() {
}
export { $h_s_reflect_ManifestFactory$LongManifest as $h_s_reflect_ManifestFactory$LongManifest };
$h_s_reflect_ManifestFactory$LongManifest.prototype = $c_s_reflect_ManifestFactory$LongManifest.prototype;
$c_s_reflect_ManifestFactory$LongManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_J.getClassOf();
});
$c_s_reflect_ManifestFactory$LongManifest.prototype.unapply__O__s_Option = (function(x) {
  if ((x instanceof $c_RTLong)) {
    var t = $uJ(x);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    return new $c_s_Some(new $c_RTLong(lo, hi));
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$LongManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_J(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$PhantomManifest() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
}
export { $c_s_reflect_ManifestFactory$PhantomManifest as $c_s_reflect_ManifestFactory$PhantomManifest };
$c_s_reflect_ManifestFactory$PhantomManifest.prototype = new $h_s_reflect_ManifestFactory$ClassTypeManifest();
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.constructor = $c_s_reflect_ManifestFactory$PhantomManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$PhantomManifest() {
}
export { $h_s_reflect_ManifestFactory$PhantomManifest as $h_s_reflect_ManifestFactory$PhantomManifest };
$h_s_reflect_ManifestFactory$PhantomManifest.prototype = $c_s_reflect_ManifestFactory$PhantomManifest.prototype;
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.toString__T = (function() {
  return this.s_reflect_ManifestFactory$PhantomManifest__f_toString;
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.equals__O__Z = (function(that) {
  return (this === that);
});
$c_s_reflect_ManifestFactory$PhantomManifest.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
export { $c_s_reflect_ManifestFactory$ShortManifest as $c_s_reflect_ManifestFactory$ShortManifest };
$c_s_reflect_ManifestFactory$ShortManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$ShortManifest.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest() {
}
export { $h_s_reflect_ManifestFactory$ShortManifest as $h_s_reflect_ManifestFactory$ShortManifest };
$h_s_reflect_ManifestFactory$ShortManifest.prototype = $c_s_reflect_ManifestFactory$ShortManifest.prototype;
$c_s_reflect_ManifestFactory$ShortManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_S.getClassOf();
});
$c_s_reflect_ManifestFactory$ShortManifest.prototype.unapply__O__s_Option = (function(x) {
  if ($isShort(x)) {
    var x2 = (x | 0);
    return new $c_s_Some(x2);
  } else {
    return $m_s_None$();
  }
});
$c_s_reflect_ManifestFactory$ShortManifest.prototype.newArray__I__O = (function(len) {
  return new $ac_S(len);
});
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest() {
  this.s_reflect_AnyValManifest__f_toString = null;
}
export { $c_s_reflect_ManifestFactory$UnitManifest as $c_s_reflect_ManifestFactory$UnitManifest };
$c_s_reflect_ManifestFactory$UnitManifest.prototype = new $h_s_reflect_AnyValManifest();
$c_s_reflect_ManifestFactory$UnitManifest.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest() {
}
export { $h_s_reflect_ManifestFactory$UnitManifest as $h_s_reflect_ManifestFactory$UnitManifest };
$h_s_reflect_ManifestFactory$UnitManifest.prototype = $c_s_reflect_ManifestFactory$UnitManifest.prototype;
$c_s_reflect_ManifestFactory$UnitManifest.prototype.runtimeClass__jl_Class = (function() {
  return $d_V.getClassOf();
});
$c_s_reflect_ManifestFactory$UnitManifest.prototype.unapply__O__s_Option = (function(x) {
  return ((x === (void 0)) ? new $c_s_Some((void 0)) : $m_s_None$());
});
$c_s_reflect_ManifestFactory$UnitManifest.prototype.newArray__I__O = (function(len) {
  return new ($d_jl_Void.getArrayOf().constr)(len);
});
/** @constructor */
function $c_Lscodec_bits_ByteOrdering$BigEndian$() {
}
export { $c_Lscodec_bits_ByteOrdering$BigEndian$ as $c_Lscodec_bits_ByteOrdering$BigEndian$ };
$c_Lscodec_bits_ByteOrdering$BigEndian$.prototype = new $h_O();
$c_Lscodec_bits_ByteOrdering$BigEndian$.prototype.constructor = $c_Lscodec_bits_ByteOrdering$BigEndian$;
/** @constructor */
function $h_Lscodec_bits_ByteOrdering$BigEndian$() {
}
export { $h_Lscodec_bits_ByteOrdering$BigEndian$ as $h_Lscodec_bits_ByteOrdering$BigEndian$ };
$h_Lscodec_bits_ByteOrdering$BigEndian$.prototype = $c_Lscodec_bits_ByteOrdering$BigEndian$.prototype;
$c_Lscodec_bits_ByteOrdering$BigEndian$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_bits_ByteOrdering$BigEndian$.prototype.hashCode__I = (function() {
  return (-1717738341);
});
$c_Lscodec_bits_ByteOrdering$BigEndian$.prototype.toString__T = (function() {
  return "BigEndian";
});
$c_Lscodec_bits_ByteOrdering$BigEndian$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lscodec_bits_ByteOrdering$BigEndian$.prototype.productPrefix__T = (function() {
  return "BigEndian";
});
$c_Lscodec_bits_ByteOrdering$BigEndian$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_ByteOrdering$BigEndian$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_ByteOrdering$BigEndian$.prototype.toJava__Ljava_nio_ByteOrder = (function() {
  return $m_Ljava_nio_ByteOrder$().Ljava_nio_ByteOrder$__f_BIG_ENDIAN;
});
$c_Lscodec_bits_ByteOrdering$BigEndian$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lscodec_bits_ByteOrdering$BigEndian$ = new $TypeData().initClass($c_Lscodec_bits_ByteOrdering$BigEndian$, "scodec.bits.ByteOrdering$BigEndian$", ({
  Lscodec_bits_ByteOrdering$BigEndian$: 1,
  Lscodec_bits_ByteOrdering: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lscodec_bits_ByteOrdering$BigEndian$ as $d_Lscodec_bits_ByteOrdering$BigEndian$ };
var $n_Lscodec_bits_ByteOrdering$BigEndian$;
function $m_Lscodec_bits_ByteOrdering$BigEndian$() {
  if ((!$n_Lscodec_bits_ByteOrdering$BigEndian$)) {
    $n_Lscodec_bits_ByteOrdering$BigEndian$ = new $c_Lscodec_bits_ByteOrdering$BigEndian$();
  }
  return $n_Lscodec_bits_ByteOrdering$BigEndian$;
}
export { $m_Lscodec_bits_ByteOrdering$BigEndian$ as $m_Lscodec_bits_ByteOrdering$BigEndian$ };
/** @constructor */
function $c_Lscodec_bits_ByteOrdering$LittleEndian$() {
}
export { $c_Lscodec_bits_ByteOrdering$LittleEndian$ as $c_Lscodec_bits_ByteOrdering$LittleEndian$ };
$c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype = new $h_O();
$c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype.constructor = $c_Lscodec_bits_ByteOrdering$LittleEndian$;
/** @constructor */
function $h_Lscodec_bits_ByteOrdering$LittleEndian$() {
}
export { $h_Lscodec_bits_ByteOrdering$LittleEndian$ as $h_Lscodec_bits_ByteOrdering$LittleEndian$ };
$h_Lscodec_bits_ByteOrdering$LittleEndian$.prototype = $c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype;
$c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype.hashCode__I = (function() {
  return 1755565649;
});
$c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype.toString__T = (function() {
  return "LittleEndian";
});
$c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype.productPrefix__T = (function() {
  return "LittleEndian";
});
$c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype.toJava__Ljava_nio_ByteOrder = (function() {
  return $m_Ljava_nio_ByteOrder$().Ljava_nio_ByteOrder$__f_LITTLE_ENDIAN;
});
$c_Lscodec_bits_ByteOrdering$LittleEndian$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lscodec_bits_ByteOrdering$LittleEndian$ = new $TypeData().initClass($c_Lscodec_bits_ByteOrdering$LittleEndian$, "scodec.bits.ByteOrdering$LittleEndian$", ({
  Lscodec_bits_ByteOrdering$LittleEndian$: 1,
  Lscodec_bits_ByteOrdering: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lscodec_bits_ByteOrdering$LittleEndian$ as $d_Lscodec_bits_ByteOrdering$LittleEndian$ };
var $n_Lscodec_bits_ByteOrdering$LittleEndian$;
function $m_Lscodec_bits_ByteOrdering$LittleEndian$() {
  if ((!$n_Lscodec_bits_ByteOrdering$LittleEndian$)) {
    $n_Lscodec_bits_ByteOrdering$LittleEndian$ = new $c_Lscodec_bits_ByteOrdering$LittleEndian$();
  }
  return $n_Lscodec_bits_ByteOrdering$LittleEndian$;
}
export { $m_Lscodec_bits_ByteOrdering$LittleEndian$ as $m_Lscodec_bits_ByteOrdering$LittleEndian$ };
/** @constructor */
function $c_Lsquants_space_Meters$() {
  this.Lsquants_space_Meters$__f_symbol = null;
  this.Lsquants_space_Meters$__f_symbol = "m";
}
export { $c_Lsquants_space_Meters$ as $c_Lsquants_space_Meters$ };
$c_Lsquants_space_Meters$.prototype = new $h_O();
$c_Lsquants_space_Meters$.prototype.constructor = $c_Lsquants_space_Meters$;
/** @constructor */
function $h_Lsquants_space_Meters$() {
}
export { $h_Lsquants_space_Meters$ as $h_Lsquants_space_Meters$ };
$h_Lsquants_space_Meters$.prototype = $c_Lsquants_space_Meters$.prototype;
$c_Lsquants_space_Meters$.prototype.converterTo__F1 = (function() {
  return $f_Lsquants_PrimaryUnit__converterTo__F1(this);
});
$c_Lsquants_space_Meters$.prototype.converterFrom__F1 = (function() {
  return $f_Lsquants_PrimaryUnit__converterFrom__F1(this);
});
$c_Lsquants_space_Meters$.prototype.symbol__T = (function() {
  return "m";
});
$c_Lsquants_space_Meters$.prototype.conversionFactor__D = (function() {
  return 1.0;
});
var $d_Lsquants_space_Meters$ = new $TypeData().initClass($c_Lsquants_space_Meters$, "squants.space.Meters$", ({
  Lsquants_space_Meters$: 1,
  Ljava_io_Serializable: 1,
  Lsquants_UnitOfMeasure: 1,
  Lsquants_UnitConverter: 1,
  Lsquants_space_LengthUnit: 1,
  Lsquants_PrimaryUnit: 1,
  Lsquants_SiUnit: 1,
  Lsquants_SiBaseUnit: 1
}));
export { $d_Lsquants_space_Meters$ as $d_Lsquants_space_Meters$ };
var $n_Lsquants_space_Meters$;
function $m_Lsquants_space_Meters$() {
  if ((!$n_Lsquants_space_Meters$)) {
    $n_Lsquants_space_Meters$ = new $c_Lsquants_space_Meters$();
  }
  return $n_Lsquants_space_Meters$;
}
export { $m_Lsquants_space_Meters$ as $m_Lsquants_space_Meters$ };
/** @constructor */
function $c_Lsttp_model_Uri$EmptyPath$() {
}
export { $c_Lsttp_model_Uri$EmptyPath$ as $c_Lsttp_model_Uri$EmptyPath$ };
$c_Lsttp_model_Uri$EmptyPath$.prototype = new $h_O();
$c_Lsttp_model_Uri$EmptyPath$.prototype.constructor = $c_Lsttp_model_Uri$EmptyPath$;
/** @constructor */
function $h_Lsttp_model_Uri$EmptyPath$() {
}
export { $h_Lsttp_model_Uri$EmptyPath$ as $h_Lsttp_model_Uri$EmptyPath$ };
$h_Lsttp_model_Uri$EmptyPath$.prototype = $c_Lsttp_model_Uri$EmptyPath$.prototype;
$c_Lsttp_model_Uri$EmptyPath$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_Uri$EmptyPath$.prototype.hashCode__I = (function() {
  return 583864050;
});
$c_Lsttp_model_Uri$EmptyPath$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_Uri$EmptyPath$.prototype.productPrefix__T = (function() {
  return "EmptyPath";
});
$c_Lsttp_model_Uri$EmptyPath$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Uri$EmptyPath$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_Uri$EmptyPath$.prototype.withSegments__sc_Seq__Lsttp_model_Uri$PathSegments = (function(ss) {
  var segments = ss.toList__sci_List();
  return new $c_Lsttp_model_Uri$AbsolutePath(segments);
});
$c_Lsttp_model_Uri$EmptyPath$.prototype.segments__sc_Seq = (function() {
  return $m_sci_Nil$();
});
$c_Lsttp_model_Uri$EmptyPath$.prototype.toString__T = (function() {
  return "";
});
$c_Lsttp_model_Uri$EmptyPath$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_Uri$EmptyPath$ = new $TypeData().initClass($c_Lsttp_model_Uri$EmptyPath$, "sttp.model.Uri$EmptyPath$", ({
  Lsttp_model_Uri$EmptyPath$: 1,
  Lsttp_model_Uri$PathSegments: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_Uri$EmptyPath$ as $d_Lsttp_model_Uri$EmptyPath$ };
var $n_Lsttp_model_Uri$EmptyPath$;
function $m_Lsttp_model_Uri$EmptyPath$() {
  if ((!$n_Lsttp_model_Uri$EmptyPath$)) {
    $n_Lsttp_model_Uri$EmptyPath$ = new $c_Lsttp_model_Uri$EmptyPath$();
  }
  return $n_Lsttp_model_Uri$EmptyPath$;
}
export { $m_Lsttp_model_Uri$EmptyPath$ as $m_Lsttp_model_Uri$EmptyPath$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$AmpInQuery$() {
}
export { $c_Lsttp_model_UriInterpolator$AmpInQuery$ as $c_Lsttp_model_UriInterpolator$AmpInQuery$ };
$c_Lsttp_model_UriInterpolator$AmpInQuery$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$AmpInQuery$.prototype.constructor = $c_Lsttp_model_UriInterpolator$AmpInQuery$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$AmpInQuery$() {
}
export { $h_Lsttp_model_UriInterpolator$AmpInQuery$ as $h_Lsttp_model_UriInterpolator$AmpInQuery$ };
$h_Lsttp_model_UriInterpolator$AmpInQuery$.prototype = $c_Lsttp_model_UriInterpolator$AmpInQuery$.prototype;
$c_Lsttp_model_UriInterpolator$AmpInQuery$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$AmpInQuery$.prototype.hashCode__I = (function() {
  return 1884602463;
});
$c_Lsttp_model_UriInterpolator$AmpInQuery$.prototype.toString__T = (function() {
  return "AmpInQuery";
});
$c_Lsttp_model_UriInterpolator$AmpInQuery$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$AmpInQuery$.prototype.productPrefix__T = (function() {
  return "AmpInQuery";
});
$c_Lsttp_model_UriInterpolator$AmpInQuery$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$AmpInQuery$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$AmpInQuery$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$AmpInQuery$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$AmpInQuery$, "sttp.model.UriInterpolator$AmpInQuery$", ({
  Lsttp_model_UriInterpolator$AmpInQuery$: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$AmpInQuery$ as $d_Lsttp_model_UriInterpolator$AmpInQuery$ };
var $n_Lsttp_model_UriInterpolator$AmpInQuery$;
function $m_Lsttp_model_UriInterpolator$AmpInQuery$() {
  if ((!$n_Lsttp_model_UriInterpolator$AmpInQuery$)) {
    $n_Lsttp_model_UriInterpolator$AmpInQuery$ = new $c_Lsttp_model_UriInterpolator$AmpInQuery$();
  }
  return $n_Lsttp_model_UriInterpolator$AmpInQuery$;
}
export { $m_Lsttp_model_UriInterpolator$AmpInQuery$ as $m_Lsttp_model_UriInterpolator$AmpInQuery$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$AtInAuthority$() {
}
export { $c_Lsttp_model_UriInterpolator$AtInAuthority$ as $c_Lsttp_model_UriInterpolator$AtInAuthority$ };
$c_Lsttp_model_UriInterpolator$AtInAuthority$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$AtInAuthority$.prototype.constructor = $c_Lsttp_model_UriInterpolator$AtInAuthority$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$AtInAuthority$() {
}
export { $h_Lsttp_model_UriInterpolator$AtInAuthority$ as $h_Lsttp_model_UriInterpolator$AtInAuthority$ };
$h_Lsttp_model_UriInterpolator$AtInAuthority$.prototype = $c_Lsttp_model_UriInterpolator$AtInAuthority$.prototype;
$c_Lsttp_model_UriInterpolator$AtInAuthority$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$AtInAuthority$.prototype.hashCode__I = (function() {
  return 1206866251;
});
$c_Lsttp_model_UriInterpolator$AtInAuthority$.prototype.toString__T = (function() {
  return "AtInAuthority";
});
$c_Lsttp_model_UriInterpolator$AtInAuthority$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$AtInAuthority$.prototype.productPrefix__T = (function() {
  return "AtInAuthority";
});
$c_Lsttp_model_UriInterpolator$AtInAuthority$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$AtInAuthority$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$AtInAuthority$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$AtInAuthority$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$AtInAuthority$, "sttp.model.UriInterpolator$AtInAuthority$", ({
  Lsttp_model_UriInterpolator$AtInAuthority$: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$AtInAuthority$ as $d_Lsttp_model_UriInterpolator$AtInAuthority$ };
var $n_Lsttp_model_UriInterpolator$AtInAuthority$;
function $m_Lsttp_model_UriInterpolator$AtInAuthority$() {
  if ((!$n_Lsttp_model_UriInterpolator$AtInAuthority$)) {
    $n_Lsttp_model_UriInterpolator$AtInAuthority$ = new $c_Lsttp_model_UriInterpolator$AtInAuthority$();
  }
  return $n_Lsttp_model_UriInterpolator$AtInAuthority$;
}
export { $m_Lsttp_model_UriInterpolator$AtInAuthority$ as $m_Lsttp_model_UriInterpolator$AtInAuthority$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$AuthorityEnd$() {
}
export { $c_Lsttp_model_UriInterpolator$AuthorityEnd$ as $c_Lsttp_model_UriInterpolator$AuthorityEnd$ };
$c_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype.constructor = $c_Lsttp_model_UriInterpolator$AuthorityEnd$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$AuthorityEnd$() {
}
export { $h_Lsttp_model_UriInterpolator$AuthorityEnd$ as $h_Lsttp_model_UriInterpolator$AuthorityEnd$ };
$h_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype = $c_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype;
$c_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype.hashCode__I = (function() {
  return 1084584632;
});
$c_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype.toString__T = (function() {
  return "AuthorityEnd";
});
$c_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype.productPrefix__T = (function() {
  return "AuthorityEnd";
});
$c_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$AuthorityEnd$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$AuthorityEnd$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$AuthorityEnd$, "sttp.model.UriInterpolator$AuthorityEnd$", ({
  Lsttp_model_UriInterpolator$AuthorityEnd$: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$AuthorityEnd$ as $d_Lsttp_model_UriInterpolator$AuthorityEnd$ };
var $n_Lsttp_model_UriInterpolator$AuthorityEnd$;
function $m_Lsttp_model_UriInterpolator$AuthorityEnd$() {
  if ((!$n_Lsttp_model_UriInterpolator$AuthorityEnd$)) {
    $n_Lsttp_model_UriInterpolator$AuthorityEnd$ = new $c_Lsttp_model_UriInterpolator$AuthorityEnd$();
  }
  return $n_Lsttp_model_UriInterpolator$AuthorityEnd$;
}
export { $m_Lsttp_model_UriInterpolator$AuthorityEnd$ as $m_Lsttp_model_UriInterpolator$AuthorityEnd$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$ColonInAuthority$() {
}
export { $c_Lsttp_model_UriInterpolator$ColonInAuthority$ as $c_Lsttp_model_UriInterpolator$ColonInAuthority$ };
$c_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype.constructor = $c_Lsttp_model_UriInterpolator$ColonInAuthority$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$ColonInAuthority$() {
}
export { $h_Lsttp_model_UriInterpolator$ColonInAuthority$ as $h_Lsttp_model_UriInterpolator$ColonInAuthority$ };
$h_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype = $c_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype;
$c_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype.hashCode__I = (function() {
  return 1043451615;
});
$c_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype.toString__T = (function() {
  return "ColonInAuthority";
});
$c_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype.productPrefix__T = (function() {
  return "ColonInAuthority";
});
$c_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$ColonInAuthority$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$ColonInAuthority$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$ColonInAuthority$, "sttp.model.UriInterpolator$ColonInAuthority$", ({
  Lsttp_model_UriInterpolator$ColonInAuthority$: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$ColonInAuthority$ as $d_Lsttp_model_UriInterpolator$ColonInAuthority$ };
var $n_Lsttp_model_UriInterpolator$ColonInAuthority$;
function $m_Lsttp_model_UriInterpolator$ColonInAuthority$() {
  if ((!$n_Lsttp_model_UriInterpolator$ColonInAuthority$)) {
    $n_Lsttp_model_UriInterpolator$ColonInAuthority$ = new $c_Lsttp_model_UriInterpolator$ColonInAuthority$();
  }
  return $n_Lsttp_model_UriInterpolator$ColonInAuthority$;
}
export { $m_Lsttp_model_UriInterpolator$ColonInAuthority$ as $m_Lsttp_model_UriInterpolator$ColonInAuthority$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$DotInAuthority$() {
}
export { $c_Lsttp_model_UriInterpolator$DotInAuthority$ as $c_Lsttp_model_UriInterpolator$DotInAuthority$ };
$c_Lsttp_model_UriInterpolator$DotInAuthority$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$DotInAuthority$.prototype.constructor = $c_Lsttp_model_UriInterpolator$DotInAuthority$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$DotInAuthority$() {
}
export { $h_Lsttp_model_UriInterpolator$DotInAuthority$ as $h_Lsttp_model_UriInterpolator$DotInAuthority$ };
$h_Lsttp_model_UriInterpolator$DotInAuthority$.prototype = $c_Lsttp_model_UriInterpolator$DotInAuthority$.prototype;
$c_Lsttp_model_UriInterpolator$DotInAuthority$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$DotInAuthority$.prototype.hashCode__I = (function() {
  return 576981685;
});
$c_Lsttp_model_UriInterpolator$DotInAuthority$.prototype.toString__T = (function() {
  return "DotInAuthority";
});
$c_Lsttp_model_UriInterpolator$DotInAuthority$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$DotInAuthority$.prototype.productPrefix__T = (function() {
  return "DotInAuthority";
});
$c_Lsttp_model_UriInterpolator$DotInAuthority$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$DotInAuthority$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$DotInAuthority$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$DotInAuthority$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$DotInAuthority$, "sttp.model.UriInterpolator$DotInAuthority$", ({
  Lsttp_model_UriInterpolator$DotInAuthority$: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$DotInAuthority$ as $d_Lsttp_model_UriInterpolator$DotInAuthority$ };
var $n_Lsttp_model_UriInterpolator$DotInAuthority$;
function $m_Lsttp_model_UriInterpolator$DotInAuthority$() {
  if ((!$n_Lsttp_model_UriInterpolator$DotInAuthority$)) {
    $n_Lsttp_model_UriInterpolator$DotInAuthority$ = new $c_Lsttp_model_UriInterpolator$DotInAuthority$();
  }
  return $n_Lsttp_model_UriInterpolator$DotInAuthority$;
}
export { $m_Lsttp_model_UriInterpolator$DotInAuthority$ as $m_Lsttp_model_UriInterpolator$DotInAuthority$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$EqInQuery$() {
}
export { $c_Lsttp_model_UriInterpolator$EqInQuery$ as $c_Lsttp_model_UriInterpolator$EqInQuery$ };
$c_Lsttp_model_UriInterpolator$EqInQuery$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$EqInQuery$.prototype.constructor = $c_Lsttp_model_UriInterpolator$EqInQuery$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$EqInQuery$() {
}
export { $h_Lsttp_model_UriInterpolator$EqInQuery$ as $h_Lsttp_model_UriInterpolator$EqInQuery$ };
$h_Lsttp_model_UriInterpolator$EqInQuery$.prototype = $c_Lsttp_model_UriInterpolator$EqInQuery$.prototype;
$c_Lsttp_model_UriInterpolator$EqInQuery$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$EqInQuery$.prototype.hashCode__I = (function() {
  return (-1495344073);
});
$c_Lsttp_model_UriInterpolator$EqInQuery$.prototype.toString__T = (function() {
  return "EqInQuery";
});
$c_Lsttp_model_UriInterpolator$EqInQuery$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$EqInQuery$.prototype.productPrefix__T = (function() {
  return "EqInQuery";
});
$c_Lsttp_model_UriInterpolator$EqInQuery$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$EqInQuery$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$EqInQuery$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$EqInQuery$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$EqInQuery$, "sttp.model.UriInterpolator$EqInQuery$", ({
  Lsttp_model_UriInterpolator$EqInQuery$: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$EqInQuery$ as $d_Lsttp_model_UriInterpolator$EqInQuery$ };
var $n_Lsttp_model_UriInterpolator$EqInQuery$;
function $m_Lsttp_model_UriInterpolator$EqInQuery$() {
  if ((!$n_Lsttp_model_UriInterpolator$EqInQuery$)) {
    $n_Lsttp_model_UriInterpolator$EqInQuery$ = new $c_Lsttp_model_UriInterpolator$EqInQuery$();
  }
  return $n_Lsttp_model_UriInterpolator$EqInQuery$;
}
export { $m_Lsttp_model_UriInterpolator$EqInQuery$ as $m_Lsttp_model_UriInterpolator$EqInQuery$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$FragmentStart$() {
}
export { $c_Lsttp_model_UriInterpolator$FragmentStart$ as $c_Lsttp_model_UriInterpolator$FragmentStart$ };
$c_Lsttp_model_UriInterpolator$FragmentStart$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$FragmentStart$.prototype.constructor = $c_Lsttp_model_UriInterpolator$FragmentStart$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$FragmentStart$() {
}
export { $h_Lsttp_model_UriInterpolator$FragmentStart$ as $h_Lsttp_model_UriInterpolator$FragmentStart$ };
$h_Lsttp_model_UriInterpolator$FragmentStart$.prototype = $c_Lsttp_model_UriInterpolator$FragmentStart$.prototype;
$c_Lsttp_model_UriInterpolator$FragmentStart$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$FragmentStart$.prototype.hashCode__I = (function() {
  return (-70970414);
});
$c_Lsttp_model_UriInterpolator$FragmentStart$.prototype.toString__T = (function() {
  return "FragmentStart";
});
$c_Lsttp_model_UriInterpolator$FragmentStart$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$FragmentStart$.prototype.productPrefix__T = (function() {
  return "FragmentStart";
});
$c_Lsttp_model_UriInterpolator$FragmentStart$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$FragmentStart$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$FragmentStart$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$FragmentStart$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$FragmentStart$, "sttp.model.UriInterpolator$FragmentStart$", ({
  Lsttp_model_UriInterpolator$FragmentStart$: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$FragmentStart$ as $d_Lsttp_model_UriInterpolator$FragmentStart$ };
var $n_Lsttp_model_UriInterpolator$FragmentStart$;
function $m_Lsttp_model_UriInterpolator$FragmentStart$() {
  if ((!$n_Lsttp_model_UriInterpolator$FragmentStart$)) {
    $n_Lsttp_model_UriInterpolator$FragmentStart$ = new $c_Lsttp_model_UriInterpolator$FragmentStart$();
  }
  return $n_Lsttp_model_UriInterpolator$FragmentStart$;
}
export { $m_Lsttp_model_UriInterpolator$FragmentStart$ as $m_Lsttp_model_UriInterpolator$FragmentStart$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$PathStart$() {
}
export { $c_Lsttp_model_UriInterpolator$PathStart$ as $c_Lsttp_model_UriInterpolator$PathStart$ };
$c_Lsttp_model_UriInterpolator$PathStart$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$PathStart$.prototype.constructor = $c_Lsttp_model_UriInterpolator$PathStart$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$PathStart$() {
}
export { $h_Lsttp_model_UriInterpolator$PathStart$ as $h_Lsttp_model_UriInterpolator$PathStart$ };
$h_Lsttp_model_UriInterpolator$PathStart$.prototype = $c_Lsttp_model_UriInterpolator$PathStart$.prototype;
$c_Lsttp_model_UriInterpolator$PathStart$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$PathStart$.prototype.hashCode__I = (function() {
  return 1615290141;
});
$c_Lsttp_model_UriInterpolator$PathStart$.prototype.toString__T = (function() {
  return "PathStart";
});
$c_Lsttp_model_UriInterpolator$PathStart$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$PathStart$.prototype.productPrefix__T = (function() {
  return "PathStart";
});
$c_Lsttp_model_UriInterpolator$PathStart$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$PathStart$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$PathStart$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$PathStart$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$PathStart$, "sttp.model.UriInterpolator$PathStart$", ({
  Lsttp_model_UriInterpolator$PathStart$: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$PathStart$ as $d_Lsttp_model_UriInterpolator$PathStart$ };
var $n_Lsttp_model_UriInterpolator$PathStart$;
function $m_Lsttp_model_UriInterpolator$PathStart$() {
  if ((!$n_Lsttp_model_UriInterpolator$PathStart$)) {
    $n_Lsttp_model_UriInterpolator$PathStart$ = new $c_Lsttp_model_UriInterpolator$PathStart$();
  }
  return $n_Lsttp_model_UriInterpolator$PathStart$;
}
export { $m_Lsttp_model_UriInterpolator$PathStart$ as $m_Lsttp_model_UriInterpolator$PathStart$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$QueryStart$() {
}
export { $c_Lsttp_model_UriInterpolator$QueryStart$ as $c_Lsttp_model_UriInterpolator$QueryStart$ };
$c_Lsttp_model_UriInterpolator$QueryStart$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$QueryStart$.prototype.constructor = $c_Lsttp_model_UriInterpolator$QueryStart$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$QueryStart$() {
}
export { $h_Lsttp_model_UriInterpolator$QueryStart$ as $h_Lsttp_model_UriInterpolator$QueryStart$ };
$h_Lsttp_model_UriInterpolator$QueryStart$.prototype = $c_Lsttp_model_UriInterpolator$QueryStart$.prototype;
$c_Lsttp_model_UriInterpolator$QueryStart$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$QueryStart$.prototype.hashCode__I = (function() {
  return 1814221978;
});
$c_Lsttp_model_UriInterpolator$QueryStart$.prototype.toString__T = (function() {
  return "QueryStart";
});
$c_Lsttp_model_UriInterpolator$QueryStart$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$QueryStart$.prototype.productPrefix__T = (function() {
  return "QueryStart";
});
$c_Lsttp_model_UriInterpolator$QueryStart$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$QueryStart$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$QueryStart$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$QueryStart$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$QueryStart$, "sttp.model.UriInterpolator$QueryStart$", ({
  Lsttp_model_UriInterpolator$QueryStart$: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$QueryStart$ as $d_Lsttp_model_UriInterpolator$QueryStart$ };
var $n_Lsttp_model_UriInterpolator$QueryStart$;
function $m_Lsttp_model_UriInterpolator$QueryStart$() {
  if ((!$n_Lsttp_model_UriInterpolator$QueryStart$)) {
    $n_Lsttp_model_UriInterpolator$QueryStart$ = new $c_Lsttp_model_UriInterpolator$QueryStart$();
  }
  return $n_Lsttp_model_UriInterpolator$QueryStart$;
}
export { $m_Lsttp_model_UriInterpolator$QueryStart$ as $m_Lsttp_model_UriInterpolator$QueryStart$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$SchemeEnd$() {
}
export { $c_Lsttp_model_UriInterpolator$SchemeEnd$ as $c_Lsttp_model_UriInterpolator$SchemeEnd$ };
$c_Lsttp_model_UriInterpolator$SchemeEnd$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$SchemeEnd$.prototype.constructor = $c_Lsttp_model_UriInterpolator$SchemeEnd$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$SchemeEnd$() {
}
export { $h_Lsttp_model_UriInterpolator$SchemeEnd$ as $h_Lsttp_model_UriInterpolator$SchemeEnd$ };
$h_Lsttp_model_UriInterpolator$SchemeEnd$.prototype = $c_Lsttp_model_UriInterpolator$SchemeEnd$.prototype;
$c_Lsttp_model_UriInterpolator$SchemeEnd$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$SchemeEnd$.prototype.hashCode__I = (function() {
  return 1851055318;
});
$c_Lsttp_model_UriInterpolator$SchemeEnd$.prototype.toString__T = (function() {
  return "SchemeEnd";
});
$c_Lsttp_model_UriInterpolator$SchemeEnd$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$SchemeEnd$.prototype.productPrefix__T = (function() {
  return "SchemeEnd";
});
$c_Lsttp_model_UriInterpolator$SchemeEnd$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$SchemeEnd$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$SchemeEnd$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$SchemeEnd$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$SchemeEnd$, "sttp.model.UriInterpolator$SchemeEnd$", ({
  Lsttp_model_UriInterpolator$SchemeEnd$: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$SchemeEnd$ as $d_Lsttp_model_UriInterpolator$SchemeEnd$ };
var $n_Lsttp_model_UriInterpolator$SchemeEnd$;
function $m_Lsttp_model_UriInterpolator$SchemeEnd$() {
  if ((!$n_Lsttp_model_UriInterpolator$SchemeEnd$)) {
    $n_Lsttp_model_UriInterpolator$SchemeEnd$ = new $c_Lsttp_model_UriInterpolator$SchemeEnd$();
  }
  return $n_Lsttp_model_UriInterpolator$SchemeEnd$;
}
export { $m_Lsttp_model_UriInterpolator$SchemeEnd$ as $m_Lsttp_model_UriInterpolator$SchemeEnd$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$SlashInPath$() {
}
export { $c_Lsttp_model_UriInterpolator$SlashInPath$ as $c_Lsttp_model_UriInterpolator$SlashInPath$ };
$c_Lsttp_model_UriInterpolator$SlashInPath$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$SlashInPath$.prototype.constructor = $c_Lsttp_model_UriInterpolator$SlashInPath$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$SlashInPath$() {
}
export { $h_Lsttp_model_UriInterpolator$SlashInPath$ as $h_Lsttp_model_UriInterpolator$SlashInPath$ };
$h_Lsttp_model_UriInterpolator$SlashInPath$.prototype = $c_Lsttp_model_UriInterpolator$SlashInPath$.prototype;
$c_Lsttp_model_UriInterpolator$SlashInPath$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$SlashInPath$.prototype.hashCode__I = (function() {
  return 763670183;
});
$c_Lsttp_model_UriInterpolator$SlashInPath$.prototype.toString__T = (function() {
  return "SlashInPath";
});
$c_Lsttp_model_UriInterpolator$SlashInPath$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$SlashInPath$.prototype.productPrefix__T = (function() {
  return "SlashInPath";
});
$c_Lsttp_model_UriInterpolator$SlashInPath$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$SlashInPath$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$SlashInPath$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$SlashInPath$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$SlashInPath$, "sttp.model.UriInterpolator$SlashInPath$", ({
  Lsttp_model_UriInterpolator$SlashInPath$: 1,
  Lsttp_model_UriInterpolator$Token: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$SlashInPath$ as $d_Lsttp_model_UriInterpolator$SlashInPath$ };
var $n_Lsttp_model_UriInterpolator$SlashInPath$;
function $m_Lsttp_model_UriInterpolator$SlashInPath$() {
  if ((!$n_Lsttp_model_UriInterpolator$SlashInPath$)) {
    $n_Lsttp_model_UriInterpolator$SlashInPath$ = new $c_Lsttp_model_UriInterpolator$SlashInPath$();
  }
  return $n_Lsttp_model_UriInterpolator$SlashInPath$;
}
export { $m_Lsttp_model_UriInterpolator$SlashInPath$ as $m_Lsttp_model_UriInterpolator$SlashInPath$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$() {
}
export { $c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$ as $c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$ };
$c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype.constructor = $c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$UriBuilder$Fragment$() {
}
export { $h_Lsttp_model_UriInterpolator$UriBuilder$Fragment$ as $h_Lsttp_model_UriInterpolator$UriBuilder$Fragment$ };
$h_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype = $c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype;
$c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype.hashCode__I = (function() {
  return (-1585625488);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype.toString__T = (function() {
  return "Fragment";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype.productPrefix__T = (function() {
  return "Fragment";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype.fromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__T2 = (function(u, t) {
  if (t.startsWith__O__Z($m_Lsttp_model_UriInterpolator$FragmentStart$())) {
    var _1 = u.fragment__s_Option__Lsttp_model_Uri($m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$tokensToStringOpt__Lsttp_model_internal_ArrayView__Z__s_Option(t.drop__I__Lsttp_model_internal_ArrayView(1), false));
    var _2 = $m_Lsttp_model_internal_ArrayView$().empty__s_reflect_ClassTag__Lsttp_model_internal_ArrayView($m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag);
    return $ct_T2__O__O__(new $c_T2(), _1, _2);
  } else {
    return $ct_T2__O__O__(new $c_T2(), u, t);
  }
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$UriBuilder$Fragment$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$, "sttp.model.UriInterpolator$UriBuilder$Fragment$", ({
  Lsttp_model_UriInterpolator$UriBuilder$Fragment$: 1,
  Lsttp_model_UriInterpolator$UriBuilder: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$UriBuilder$Fragment$ as $d_Lsttp_model_UriInterpolator$UriBuilder$Fragment$ };
var $n_Lsttp_model_UriInterpolator$UriBuilder$Fragment$;
function $m_Lsttp_model_UriInterpolator$UriBuilder$Fragment$() {
  if ((!$n_Lsttp_model_UriInterpolator$UriBuilder$Fragment$)) {
    $n_Lsttp_model_UriInterpolator$UriBuilder$Fragment$ = new $c_Lsttp_model_UriInterpolator$UriBuilder$Fragment$();
  }
  return $n_Lsttp_model_UriInterpolator$UriBuilder$Fragment$;
}
export { $m_Lsttp_model_UriInterpolator$UriBuilder$Fragment$ as $m_Lsttp_model_UriInterpolator$UriBuilder$Fragment$ };
function $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostPortFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, u, rawHpTokens) {
  return (rawHpTokens.isEmpty__Z() ? u : $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostPortFromNonemptyTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, u, rawHpTokens));
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostPortFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri as $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostPortFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri };
function $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostPortFromNonemptyTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, u, rawHpTokens) {
  var ev = $m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag;
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = ev.runtimeClass__jl_Class();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  jsElems = [];
  rawHpTokens.size__I();
  var i = rawHpTokens.Lsttp_model_internal_ArrayView__f_from;
  while ((i < rawHpTokens.Lsttp_model_internal_ArrayView__f_till)) {
    var x0 = $m_sr_ScalaRunTime$().array_apply__O__I__O(rawHpTokens.Lsttp_model_internal_ArrayView__f_arr, i);
    if ((x0 instanceof $c_Lsttp_model_UriInterpolator$ExpressionToken)) {
      var es = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$anyToString__O__T(x0.Lsttp_model_UriInterpolator$ExpressionToken__f_e);
      matchResult59: {
        var this$20;
        var x159 = $f_T__split__T__I__AT(es, ":", 2);
        if ((x159 !== null)) {
          if (($m_s_Array$UnapplySeqWrapper$().lengthCompare$extension__O__I__I(x159, 2) === 0)) {
            var x161 = x159.u[0];
            var x162 = x159.u[1];
            if ((x162 !== "")) {
              _return: {
                var i$1 = 0;
                var len = x162.length;
                while ((i$1 < len)) {
                  var index = i$1;
                  var x0$1 = x162.charCodeAt(index);
                  var this$12 = $m_jl_Character$();
                  if ((!this$12.isDigit__I__Z(x0$1))) {
                    var $x_1 = false;
                    break _return;
                  }
                  i$1 = ((1 + i$1) | 0);
                }
                var $x_1 = true;
              }
            } else {
              var $x_1 = false;
            }
            if ($x_1) {
              var elem$2 = new $c_Lsttp_model_UriInterpolator$StringToken(x161);
              var elem$1 = new $c_Lsttp_model_UriInterpolator$StringToken(x162);
              var this$15 = $m_sci_Nil$();
              var this$16 = new $c_sci_$colon$colon(elem$1, this$15);
              var elem = $m_Lsttp_model_UriInterpolator$ColonInAuthority$();
              var this$17 = new $c_sci_$colon$colon(elem, this$16);
              var this$20 = new $c_sci_$colon$colon(elem$2, this$17);
              break matchResult59;
            }
          }
        }
        var this$18 = $m_sci_Nil$();
        var this$20 = new $c_sci_$colon$colon(x0, this$18);
      }
    } else {
      var this$19 = $m_sci_Nil$();
      var this$20 = new $c_sci_$colon$colon(x0, this$19);
    }
    var these = this$20;
    while ((!these.isEmpty__Z())) {
      var x0$2 = these.head__O();
      var unboxedElem = (isCharArrayBuilder ? $uC(x0$2) : ((x0$2 === null) ? elementClass.data.zero : x0$2));
      jsElems.push(unboxedElem);
      these = these.tail__O();
    }
    i = ((1 + i) | 0);
  }
  var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
  var result = elemRuntimeClass.data.getArrayOf().wrapArray(jsElems);
  var hpTokens = new $c_Lsttp_model_internal_ArrayView(result, 0, $m_jl_reflect_Array$().getLength__O__I(result));
  if ((hpTokens.startsWith__O__Z($m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$emptyStringToken) && hpTokens.drop__I__Lsttp_model_internal_ArrayView(1).startsWith__O__Z($m_Lsttp_model_UriInterpolator$DotInAuthority$()))) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "incorrect hostname");
  }
  var elem$3 = 0;
  elem$3 = 0;
  var i$2 = hpTokens.Lsttp_model_internal_ArrayView__f_from;
  while ((i$2 < hpTokens.Lsttp_model_internal_ArrayView__f_till)) {
    var x0$3 = $m_sr_ScalaRunTime$().array_apply__O__I__O(hpTokens.Lsttp_model_internal_ArrayView__f_arr, i$2);
    var x$2 = $m_Lsttp_model_UriInterpolator$ColonInAuthority$();
    if (((x0$3 !== null) && x0$3.equals__O__Z(x$2))) {
      elem$3 = ((1 + elem$3) | 0);
    }
    i$2 = ((1 + i$2) | 0);
  }
  if ((elem$3 > 1)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "port specified multiple times");
  }
  var x165 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$split__Lsttp_model_internal_ArrayView__O__s_util_Either(hpTokens, $m_Lsttp_model_UriInterpolator$ColonInAuthority$());
  if ((x165 instanceof $c_s_util_Left)) {
    var tt = x165.s_util_Left__f_value;
    return $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, u, tt);
  }
  if ((x165 instanceof $c_s_util_Right)) {
    var x167 = x165.s_util_Right__f_value;
    if ((x167 !== null)) {
      var hostTokens = x167.T3__f__1;
      var portTokens = x167.T3__f__3;
      return $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__portFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, u, hostTokens), portTokens);
    }
  }
  throw new $c_s_MatchError(x165);
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostPortFromNonemptyTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri as $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostPortFromNonemptyTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri };
function $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, u, tokens) {
  var hostFragments = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$tokensToStringSeq__Lsttp_model_internal_ArrayView__Z__sci_Seq(tokens, false);
  return u.host__T__Lsttp_model_Uri($f_sc_IterableOnceOps__mkString__T__T__T__T(hostFragments, "", ".", ""));
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri as $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri };
function $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__portFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, u, tokens) {
  var this$1 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$tokensToStringOpt__Lsttp_model_internal_ArrayView__Z__s_Option(tokens, false);
  if (this$1.isEmpty__Z()) {
    var $x_1 = $m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var this$2 = $m_Lsttp_model_internal_ParseUtils$().toIntOption__T__s_Option(x0);
    if (this$2.isEmpty__Z()) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("Invalid port: " + x0) + ". Is the port a number? Is the path separated with a / (directly in the string, not embedded)?"));
    }
    var $x_1 = new $c_s_Some((this$2.get__O() | 0));
  }
  return u.port__s_Option__Lsttp_model_Uri($x_1);
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__portFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri as $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__portFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$() {
}
export { $c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$ as $c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$ };
$c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype.constructor = $c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$UriBuilder$HostPort$() {
}
export { $h_Lsttp_model_UriInterpolator$UriBuilder$HostPort$ as $h_Lsttp_model_UriInterpolator$UriBuilder$HostPort$ };
$h_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype = $c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype;
$c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype.hashCode__I = (function() {
  return (-236039575);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype.toString__T = (function() {
  return "HostPort";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype.productPrefix__T = (function() {
  return "HostPort";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype.fromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__T2 = (function(u, t) {
  var x149 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$split__Lsttp_model_internal_ArrayView__O__s_util_Either(t, $m_Lsttp_model_UriInterpolator$AuthorityEnd$());
  if ((x149 instanceof $c_s_util_Left)) {
    var x158 = x149.s_util_Left__f_value;
    if (x158.lastOption__s_Option().contains__O__Z($m_Lsttp_model_UriInterpolator$AuthorityEnd$())) {
      var _1 = $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostPortFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri(this, u, x158);
      var _2 = $m_Lsttp_model_internal_ArrayView$().empty__s_reflect_ClassTag__Lsttp_model_internal_ArrayView($m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag);
      return $ct_T2__O__O__(new $c_T2(), _1, _2);
    }
    return $ct_T2__O__O__(new $c_T2(), u, x158);
  }
  if ((x149 instanceof $c_s_util_Right)) {
    var x151 = x149.s_util_Right__f_value;
    if ((x151 !== null)) {
      var hpTokens = x151.T3__f__1;
      var otherTokens = x151.T3__f__3;
      var _1$1 = $p_Lsttp_model_UriInterpolator$UriBuilder$HostPort$__hostPortFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri(this, u, hpTokens);
      return $ct_T2__O__O__(new $c_T2(), _1$1, otherTokens);
    }
  }
  throw new $c_s_MatchError(x149);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$UriBuilder$HostPort$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$, "sttp.model.UriInterpolator$UriBuilder$HostPort$", ({
  Lsttp_model_UriInterpolator$UriBuilder$HostPort$: 1,
  Lsttp_model_UriInterpolator$UriBuilder: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$UriBuilder$HostPort$ as $d_Lsttp_model_UriInterpolator$UriBuilder$HostPort$ };
var $n_Lsttp_model_UriInterpolator$UriBuilder$HostPort$;
function $m_Lsttp_model_UriInterpolator$UriBuilder$HostPort$() {
  if ((!$n_Lsttp_model_UriInterpolator$UriBuilder$HostPort$)) {
    $n_Lsttp_model_UriInterpolator$UriBuilder$HostPort$ = new $c_Lsttp_model_UriInterpolator$UriBuilder$HostPort$();
  }
  return $n_Lsttp_model_UriInterpolator$UriBuilder$HostPort$;
}
export { $m_Lsttp_model_UriInterpolator$UriBuilder$HostPort$ as $m_Lsttp_model_UriInterpolator$UriBuilder$HostPort$ };
function $p_Lsttp_model_UriInterpolator$UriBuilder$Path$__withoutAbsolutePathPrefixTokens__Lsttp_model_internal_ArrayView__s_Option($thiz, t) {
  if (t.startsWith__O__Z($m_Lsttp_model_UriInterpolator$PathStart$())) {
    var this$1 = t.drop__I__Lsttp_model_internal_ArrayView(1);
    var i = this$1.Lsttp_model_internal_ArrayView__f_from;
    var xs = this$1.Lsttp_model_internal_ArrayView__f_arr;
    var len = $m_jl_reflect_Array$().getLength__O__I(xs);
    while (true) {
      if ((i < len)) {
        var x0 = $m_sr_ScalaRunTime$().array_apply__O__I__O(this$1.Lsttp_model_internal_ArrayView__f_arr, i);
        var x$2 = $m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$emptyStringToken;
        var $x_1 = ((x0 === null) ? (x$2 === null) : x0.equals__O__Z(x$2));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        i = ((1 + i) | 0);
      } else {
        break;
      }
    }
    var t2 = new $c_Lsttp_model_internal_ArrayView(this$1.Lsttp_model_internal_ArrayView__f_arr, i, this$1.Lsttp_model_internal_ArrayView__f_till);
    if (t2.startsWith__O__Z($m_Lsttp_model_UriInterpolator$SlashInPath$())) {
      var value = t2.drop__I__Lsttp_model_internal_ArrayView(1);
      return new $c_s_Some(value);
    } else {
      return $m_s_None$();
    }
  } else {
    return $m_s_None$();
  }
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$Path$__withoutAbsolutePathPrefixTokens__Lsttp_model_internal_ArrayView__s_Option as $p_Lsttp_model_UriInterpolator$UriBuilder$Path$__withoutAbsolutePathPrefixTokens__Lsttp_model_internal_ArrayView__s_Option };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$UriBuilder$Path$() {
  this.Lsttp_model_UriInterpolator$UriBuilder$Path$__f_queryOrFragmentSeparators = null;
  $n_Lsttp_model_UriInterpolator$UriBuilder$Path$ = this;
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsttp_model_UriInterpolator$Token.getArrayOf().constr)([$m_Lsttp_model_UriInterpolator$QueryStart$(), $m_Lsttp_model_UriInterpolator$FragmentStart$()]));
  this.Lsttp_model_UriInterpolator$UriBuilder$Path$__f_queryOrFragmentSeparators = this$1.from__sc_IterableOnce__sci_Set(elems);
}
export { $c_Lsttp_model_UriInterpolator$UriBuilder$Path$ as $c_Lsttp_model_UriInterpolator$UriBuilder$Path$ };
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype.constructor = $c_Lsttp_model_UriInterpolator$UriBuilder$Path$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$UriBuilder$Path$() {
}
export { $h_Lsttp_model_UriInterpolator$UriBuilder$Path$ as $h_Lsttp_model_UriInterpolator$UriBuilder$Path$ };
$h_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype = $c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype;
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype.hashCode__I = (function() {
  return 2480197;
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype.toString__T = (function() {
  return "Path";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype.productPrefix__T = (function() {
  return "Path";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype.fromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__T2 = (function(u, t) {
  var noSchemeAndAuthority = (u.Lsttp_model_Uri__f_scheme.isEmpty__Z() && u.Lsttp_model_Uri__f_authority.isEmpty__Z());
  matchResult64: {
    var \u03b46$___1;
    var \u03b46$___2;
    var x175 = $p_Lsttp_model_UriInterpolator$UriBuilder$Path$__withoutAbsolutePathPrefixTokens__Lsttp_model_internal_ArrayView__s_Option(this, t);
    if ((x175 instanceof $c_s_Some)) {
      var tt = x175.s_Some__f_value;
      if (noSchemeAndAuthority) {
        var _2 = tt.$plus$colon__O__s_reflect_ClassTag__Lsttp_model_internal_ArrayView($m_Lsttp_model_UriInterpolator$PathStart$(), $m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag);
        var \u03b46$___1 = u;
        var \u03b46$___2 = _2;
        break matchResult64;
      }
    }
    if ((noSchemeAndAuthority && t.headOption__s_Option().contains__O__Z($m_Lsttp_model_UriInterpolator$PathStart$()))) {
      var segments = $m_sci_Nil$();
      var pathSegments$1 = new $c_Lsttp_model_Uri$RelativePath(segments);
      var scheme$1 = u.Lsttp_model_Uri__f_scheme;
      var authority$1 = u.Lsttp_model_Uri__f_authority;
      var querySegments$1 = u.Lsttp_model_Uri__f_querySegments;
      var fragmentSegment$1 = u.Lsttp_model_Uri__f_fragmentSegment;
      var _1 = new $c_Lsttp_model_Uri(scheme$1, authority$1, pathSegments$1, querySegments$1, fragmentSegment$1);
      var \u03b46$___1 = _1;
      var \u03b46$___2 = t;
      break matchResult64;
    }
    var \u03b46$___1 = u;
    var \u03b46$___2 = t;
  }
  var uu = \u03b46$___1;
  var tt$2 = \u03b46$___2;
  var this$5 = $m_Lsttp_model_UriInterpolator$UriBuilder$();
  var startingToken = $m_Lsttp_model_UriInterpolator$PathStart$();
  var nextComponentTokens = this.Lsttp_model_UriInterpolator$UriBuilder$Path$__f_queryOrFragmentSeparators;
  var f = ((u$2, tokens) => $m_Lsttp_model_UriInterpolator$UriBuilder$Path$().sttp$model$UriInterpolator$UriBuilder$Path$$$pathFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri(u$2, tokens));
  if (tt$2.startsWith__O__Z(startingToken)) {
    var tt$1 = tt$2.drop__I__Lsttp_model_internal_ArrayView(1);
    if ((nextComponentTokens.size__I() === 1)) {
      var x224 = this$5.sttp$model$UriInterpolator$UriBuilder$$$split__Lsttp_model_internal_ArrayView__O__s_util_Either(tt$1, nextComponentTokens.iterator__sc_Iterator().next__O());
      if ((x224 instanceof $c_s_util_Left)) {
        var ttt = x224.s_util_Left__f_value;
        var _1$1 = f(uu, ttt);
        var _2$1 = $m_Lsttp_model_internal_ArrayView$().empty__s_reflect_ClassTag__Lsttp_model_internal_ArrayView($m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag);
        return $ct_T2__O__O__(new $c_T2(), _1$1, _2$1);
      }
      if ((x224 instanceof $c_s_util_Right)) {
        var x226 = x224.s_util_Right__f_value;
        if ((x226 !== null)) {
          var componentTokens = x226.T3__f__1;
          var otherTokens = x226.T3__f__3;
          var _1$2 = f(uu, componentTokens);
          var _2$2 = otherTokens.shiftLeft__Lsttp_model_internal_ArrayView();
          return $ct_T2__O__O__(new $c_T2(), _1$2, _2$2);
        }
      }
      throw new $c_s_MatchError(x224);
    } else {
      var x232 = tt$1.indexWhere__F1__I(nextComponentTokens);
      if ((x232 === (-1))) {
        var _1$3 = f(uu, tt$1);
        var _2$3 = $m_Lsttp_model_internal_ArrayView$().empty__s_reflect_ClassTag__Lsttp_model_internal_ArrayView($m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag);
        return $ct_T2__O__O__(new $c_T2(), _1$3, _2$3);
      }
      var x1 = tt$1.take__I__Lsttp_model_internal_ArrayView(x232);
      var _1$4 = f(uu, x1);
      var _2$4 = tt$1.drop__I__Lsttp_model_internal_ArrayView(x232);
      return $ct_T2__O__O__(new $c_T2(), _1$4, _2$4);
    }
  } else {
    return $ct_T2__O__O__(new $c_T2(), uu, tt$2);
  }
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype.sttp$model$UriInterpolator$UriBuilder$Path$$$pathFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri = (function(u, tokens) {
  return u.addPath__sc_Seq__Lsttp_model_Uri($m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$tokensToStringSeq__Lsttp_model_internal_ArrayView__Z__sci_Seq(tokens, false));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Path$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$UriBuilder$Path$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$UriBuilder$Path$, "sttp.model.UriInterpolator$UriBuilder$Path$", ({
  Lsttp_model_UriInterpolator$UriBuilder$Path$: 1,
  Lsttp_model_UriInterpolator$UriBuilder: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$UriBuilder$Path$ as $d_Lsttp_model_UriInterpolator$UriBuilder$Path$ };
var $n_Lsttp_model_UriInterpolator$UriBuilder$Path$;
function $m_Lsttp_model_UriInterpolator$UriBuilder$Path$() {
  if ((!$n_Lsttp_model_UriInterpolator$UriBuilder$Path$)) {
    $n_Lsttp_model_UriInterpolator$UriBuilder$Path$ = new $c_Lsttp_model_UriInterpolator$UriBuilder$Path$();
  }
  return $n_Lsttp_model_UriInterpolator$UriBuilder$Path$;
}
export { $m_Lsttp_model_UriInterpolator$UriBuilder$Path$ as $m_Lsttp_model_UriInterpolator$UriBuilder$Path$ };
function $p_Lsttp_model_UriInterpolator$UriBuilder$Query$__expressionPairToQueryFragment$1__O__O__s_Option($thiz, ke, ve) {
  var this$1 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$anyToStringOpt__O__s_Option(ke);
  if (this$1.isEmpty__Z()) {
    return $m_s_None$();
  } else {
    var x0 = this$1.get__O();
    var this$2 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$anyToStringOpt__O__s_Option(ve);
    if (this$2.isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var x0$1 = this$2.get__O();
      var keyEncoding = $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_Standard;
      var valueEncoding = $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_Standard;
      return new $c_s_Some(new $c_Lsttp_model_Uri$QuerySegment$KeyValue(x0, x0$1, keyEncoding, valueEncoding));
    }
  }
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$Query$__expressionPairToQueryFragment$1__O__O__s_Option as $p_Lsttp_model_UriInterpolator$UriBuilder$Query$__expressionPairToQueryFragment$1__O__O__s_Option };
function $p_Lsttp_model_UriInterpolator$UriBuilder$Query$__seqToQueryFragments$1__sci_Seq__sci_Vector($thiz, s) {
  return s.flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $c_T2)) {
      var ke = x$1._1__O();
      var ve = x$1._2__O();
      return $p_Lsttp_model_UriInterpolator$UriBuilder$Query$__expressionPairToQueryFragment$1__O__O__s_Option($thiz, ke, ve);
    } else {
      var this$2 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$anyToStringOpt__O__s_Option(x$1);
      if (this$2.isEmpty__Z()) {
        return $m_s_None$();
      } else {
        var x0 = this$2.get__O();
        var encoding = $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_StandardValue;
        return new $c_s_Some(new $c_Lsttp_model_Uri$QuerySegment$Value(x0, encoding));
      }
    }
  }))).toVector__sci_Vector();
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$Query$__seqToQueryFragments$1__sci_Seq__sci_Vector as $p_Lsttp_model_UriInterpolator$UriBuilder$Query$__seqToQueryFragments$1__sci_Seq__sci_Vector };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$UriBuilder$Query$() {
  this.Lsttp_model_UriInterpolator$UriBuilder$Query$__f_fragmentSeparator = null;
  $n_Lsttp_model_UriInterpolator$UriBuilder$Query$ = this;
  var this$1 = $m_sci_Set$();
  var elems = $m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lsttp_model_UriInterpolator$Token.getArrayOf().constr)([$m_Lsttp_model_UriInterpolator$FragmentStart$()]));
  this.Lsttp_model_UriInterpolator$UriBuilder$Query$__f_fragmentSeparator = this$1.from__sc_IterableOnce__sci_Set(elems);
}
export { $c_Lsttp_model_UriInterpolator$UriBuilder$Query$ as $c_Lsttp_model_UriInterpolator$UriBuilder$Query$ };
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.constructor = $c_Lsttp_model_UriInterpolator$UriBuilder$Query$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$UriBuilder$Query$() {
}
export { $h_Lsttp_model_UriInterpolator$UriBuilder$Query$ as $h_Lsttp_model_UriInterpolator$UriBuilder$Query$ };
$h_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype = $c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype;
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.hashCode__I = (function() {
  return 78391464;
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.toString__T = (function() {
  return "Query";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.productPrefix__T = (function() {
  return "Query";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.fromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__T2 = (function(u, t) {
  var this$1 = $m_Lsttp_model_UriInterpolator$UriBuilder$();
  var startingToken = $m_Lsttp_model_UriInterpolator$QueryStart$();
  var nextComponentTokens = this.Lsttp_model_UriInterpolator$UriBuilder$Query$__f_fragmentSeparator;
  var f = ((u$2, tokens) => $m_Lsttp_model_UriInterpolator$UriBuilder$Query$().sttp$model$UriInterpolator$UriBuilder$Query$$$queryFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri(u$2, tokens));
  if (t.startsWith__O__Z(startingToken)) {
    var tt = t.drop__I__Lsttp_model_internal_ArrayView(1);
    if ((nextComponentTokens.size__I() === 1)) {
      var x224 = this$1.sttp$model$UriInterpolator$UriBuilder$$$split__Lsttp_model_internal_ArrayView__O__s_util_Either(tt, nextComponentTokens.iterator__sc_Iterator().next__O());
      if ((x224 instanceof $c_s_util_Left)) {
        var ttt = x224.s_util_Left__f_value;
        var _1 = f(u, ttt);
        var _2 = $m_Lsttp_model_internal_ArrayView$().empty__s_reflect_ClassTag__Lsttp_model_internal_ArrayView($m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag);
        return $ct_T2__O__O__(new $c_T2(), _1, _2);
      }
      if ((x224 instanceof $c_s_util_Right)) {
        var x226 = x224.s_util_Right__f_value;
        if ((x226 !== null)) {
          var componentTokens = x226.T3__f__1;
          var otherTokens = x226.T3__f__3;
          var _1$1 = f(u, componentTokens);
          var _2$1 = otherTokens.shiftLeft__Lsttp_model_internal_ArrayView();
          return $ct_T2__O__O__(new $c_T2(), _1$1, _2$1);
        }
      }
      throw new $c_s_MatchError(x224);
    } else {
      var x232 = tt.indexWhere__F1__I(nextComponentTokens);
      if ((x232 === (-1))) {
        var _1$2 = f(u, tt);
        var _2$2 = $m_Lsttp_model_internal_ArrayView$().empty__s_reflect_ClassTag__Lsttp_model_internal_ArrayView($m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag);
        return $ct_T2__O__O__(new $c_T2(), _1$2, _2$2);
      }
      var x1 = tt.take__I__Lsttp_model_internal_ArrayView(x232);
      var _1$3 = f(u, x1);
      var _2$3 = tt.drop__I__Lsttp_model_internal_ArrayView(x232);
      return $ct_T2__O__O__(new $c_T2(), _1$3, _2$3);
    }
  } else {
    return $ct_T2__O__O__(new $c_T2(), u, t);
  }
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.sttp$model$UriInterpolator$UriBuilder$Query$$$queryFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri = (function(u, tokens) {
  var this$1 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$splitToGroups__Lsttp_model_internal_ArrayView__O__sci_Vector(tokens, $m_Lsttp_model_UriInterpolator$AmpInQuery$());
  $m_sci_Vector$();
  var b = new $c_sci_VectorBuilder();
  var it = this$1.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var x0 = it.next__O();
    var elems = $m_Lsttp_model_UriInterpolator$UriBuilder$Query$().sttp$model$UriInterpolator$UriBuilder$Query$$$queryMappingsFromTokens__Lsttp_model_internal_ArrayView__sci_Vector(x0);
    b.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
  }
  var qfs = b.result__sci_Vector();
  var scheme = u.Lsttp_model_Uri__f_scheme;
  var authority = u.Lsttp_model_Uri__f_authority;
  var pathSegments = u.Lsttp_model_Uri__f_pathSegments;
  var fragmentSegment = u.Lsttp_model_Uri__f_fragmentSegment;
  return new $c_Lsttp_model_Uri(scheme, authority, pathSegments, qfs, fragmentSegment);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.sttp$model$UriInterpolator$UriBuilder$Query$$$queryMappingsFromTokens__Lsttp_model_internal_ArrayView__sci_Vector = (function(tokens) {
  var x187 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$split__Lsttp_model_internal_ArrayView__O__s_util_Either(tokens, $m_Lsttp_model_UriInterpolator$EqInQuery$());
  if ((x187 instanceof $c_s_util_Left)) {
    var x214 = x187.s_util_Left__f_value;
    if ((x214 !== null)) {
      var x215 = $m_Lsttp_model_internal_Singleton$().unapply__Lsttp_model_internal_ArrayView__s_Option(x214);
      if ((!x215.isEmpty__Z())) {
        var x216 = x215.get__O();
        if ((x216 instanceof $c_Lsttp_model_UriInterpolator$ExpressionToken)) {
          var x220 = x216.Lsttp_model_UriInterpolator$ExpressionToken__f_e;
          if ($is_sci_Map(x220)) {
            return $p_Lsttp_model_UriInterpolator$UriBuilder$Query$__seqToQueryFragments$1__sci_Seq__sci_Vector(this, $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(x220));
          }
          if ($is_sci_Seq(x220)) {
            return $p_Lsttp_model_UriInterpolator$UriBuilder$Query$__seqToQueryFragments$1__sci_Seq__sci_Vector(this, x220);
          }
          if ((x220 instanceof $c_Lsttp_model_QueryParams)) {
            return $m_Lsttp_model_Uri$QuerySegment$().fromQueryParams__Lsttp_model_QueryParams__sc_Iterable(x220).toVector__sci_Vector();
          }
        }
      }
    }
    var $x_2 = $m_s_Option$();
    var this$2 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$tokensToStringOpt__Lsttp_model_internal_ArrayView__Z__s_Option(x214, true);
    if (this$2.isEmpty__Z()) {
      var $x_1 = $m_s_None$();
    } else {
      var x0 = this$2.get__O();
      var encoding = $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_StandardValue;
      var $x_1 = new $c_s_Some(new $c_Lsttp_model_Uri$QuerySegment$Value(x0, encoding));
    }
    return $x_2.option2Iterable__s_Option__sc_Iterable($x_1).toVector__sci_Vector();
  }
  if ((x187 instanceof $c_s_util_Right)) {
    var x189 = x187.s_util_Right__f_value;
    if ((x189 !== null)) {
      var leftEq = x189.T3__f__1;
      var rightEq = x189.T3__f__3;
      var x184 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$tokensToStringOpt__Lsttp_model_internal_ArrayView__Z__s_Option(leftEq, true);
      if ((x184 instanceof $c_s_Some)) {
        var k = x184.s_Some__f_value;
        return $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$tokensToStringSeq__Lsttp_model_internal_ArrayView__Z__sci_Seq(rightEq, true).map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$14) => {
          var keyEncoding = $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_Standard;
          var valueEncoding = $m_Lsttp_model_Uri$QuerySegmentEncoding$().Lsttp_model_Uri$QuerySegmentEncoding$__f_Standard;
          return new $c_Lsttp_model_Uri$QuerySegment$KeyValue(k, _$14, keyEncoding, valueEncoding);
        }))).toVector__sci_Vector();
      }
      var x = $m_s_None$();
      if ((x === x184)) {
        $m_sci_Vector$();
        return $m_sci_Vector0$();
      }
      throw new $c_s_MatchError(x184);
    }
  }
  throw new $c_s_MatchError(x187);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Query$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$UriBuilder$Query$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$UriBuilder$Query$, "sttp.model.UriInterpolator$UriBuilder$Query$", ({
  Lsttp_model_UriInterpolator$UriBuilder$Query$: 1,
  Lsttp_model_UriInterpolator$UriBuilder: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$UriBuilder$Query$ as $d_Lsttp_model_UriInterpolator$UriBuilder$Query$ };
var $n_Lsttp_model_UriInterpolator$UriBuilder$Query$;
function $m_Lsttp_model_UriInterpolator$UriBuilder$Query$() {
  if ((!$n_Lsttp_model_UriInterpolator$UriBuilder$Query$)) {
    $n_Lsttp_model_UriInterpolator$UriBuilder$Query$ = new $c_Lsttp_model_UriInterpolator$UriBuilder$Query$();
  }
  return $n_Lsttp_model_UriInterpolator$UriBuilder$Query$;
}
export { $m_Lsttp_model_UriInterpolator$UriBuilder$Query$ as $m_Lsttp_model_UriInterpolator$UriBuilder$Query$ };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$() {
}
export { $c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$ as $c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$ };
$c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype.constructor = $c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$UriBuilder$Scheme$() {
}
export { $h_Lsttp_model_UriInterpolator$UriBuilder$Scheme$ as $h_Lsttp_model_UriInterpolator$UriBuilder$Scheme$ };
$h_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype = $c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype;
$c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype.hashCode__I = (function() {
  return (-1824120379);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype.toString__T = (function() {
  return "Scheme";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype.productPrefix__T = (function() {
  return "Scheme";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype.fromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__T2 = (function(u, t) {
  var x103 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$split__Lsttp_model_internal_ArrayView__O__s_util_Either(t, $m_Lsttp_model_UriInterpolator$SchemeEnd$());
  if ((x103 instanceof $c_s_util_Left)) {
    return $ct_T2__O__O__(new $c_T2(), u, t);
  }
  if ((x103 instanceof $c_s_util_Right)) {
    var x105 = x103.s_util_Right__f_value;
    if ((x105 !== null)) {
      var schemeTokens = x105.T3__f__1;
      var otherTokens = x105.T3__f__3;
      var scheme = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$tokensToString__Lsttp_model_internal_ArrayView__Z__T(schemeTokens, false);
      var _1 = u.scheme__T__Lsttp_model_Uri(scheme);
      return $ct_T2__O__O__(new $c_T2(), _1, otherTokens);
    }
  }
  throw new $c_s_MatchError(x103);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$UriBuilder$Scheme$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$, "sttp.model.UriInterpolator$UriBuilder$Scheme$", ({
  Lsttp_model_UriInterpolator$UriBuilder$Scheme$: 1,
  Lsttp_model_UriInterpolator$UriBuilder: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$UriBuilder$Scheme$ as $d_Lsttp_model_UriInterpolator$UriBuilder$Scheme$ };
var $n_Lsttp_model_UriInterpolator$UriBuilder$Scheme$;
function $m_Lsttp_model_UriInterpolator$UriBuilder$Scheme$() {
  if ((!$n_Lsttp_model_UriInterpolator$UriBuilder$Scheme$)) {
    $n_Lsttp_model_UriInterpolator$UriBuilder$Scheme$ = new $c_Lsttp_model_UriInterpolator$UriBuilder$Scheme$();
  }
  return $n_Lsttp_model_UriInterpolator$UriBuilder$Scheme$;
}
export { $m_Lsttp_model_UriInterpolator$UriBuilder$Scheme$ as $m_Lsttp_model_UriInterpolator$UriBuilder$Scheme$ };
function $p_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$__uiFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, u, uiTokens) {
  var evidence$1 = $m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag;
  var length = uiTokens.size__I();
  var newArray = evidence$1.newArray__I__O(length);
  var i = 0;
  while ((i < $m_jl_reflect_Array$().getLength__O__I(newArray))) {
    var $x_2 = $m_sr_ScalaRunTime$();
    var $x_1 = i;
    var x0 = $m_sr_ScalaRunTime$().array_apply__O__I__O(uiTokens.Lsttp_model_internal_ArrayView__f_arr, ((i + uiTokens.Lsttp_model_internal_ArrayView__f_from) | 0));
    var x = $m_Lsttp_model_UriInterpolator$DotInAuthority$();
    $x_2.array_update__O__I__O__V(newArray, $x_1, ((x === x0) ? new $c_Lsttp_model_UriInterpolator$StringToken(".") : x0));
    i = ((1 + i) | 0);
  }
  var uiTokensWithDots = new $c_Lsttp_model_internal_ArrayView(newArray, 0, $m_jl_reflect_Array$().getLength__O__I(newArray));
  var x122 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$split__Lsttp_model_internal_ArrayView__O__s_util_Either(uiTokensWithDots, $m_Lsttp_model_UriInterpolator$ColonInAuthority$());
  if ((x122 instanceof $c_s_util_Left)) {
    var tt = x122.s_util_Left__f_value;
    return $p_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$__uiFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, u, tt, $m_Lsttp_model_internal_ArrayView$().empty__s_reflect_ClassTag__Lsttp_model_internal_ArrayView($m_Lsttp_model_UriInterpolator$().Lsttp_model_UriInterpolator$__f_sttp$model$UriInterpolator$$$tokenClassTag));
  }
  if ((x122 instanceof $c_s_util_Right)) {
    var x124 = x122.s_util_Right__f_value;
    if ((x124 !== null)) {
      var usernameTokens = x124.T3__f__1;
      var passwordTokens = x124.T3__f__3;
      return $p_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$__uiFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, u, usernameTokens, passwordTokens);
    }
  }
  throw new $c_s_MatchError(x122);
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$__uiFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri as $p_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$__uiFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri };
function $p_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$__uiFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_internal_ArrayView__Lsttp_model_Uri($thiz, u, usernameTokens, passwordTokens) {
  var _1 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$tokensToStringOpt__Lsttp_model_internal_ArrayView__Z__s_Option(usernameTokens, false);
  var _2 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$tokensToStringOpt__Lsttp_model_internal_ArrayView__Z__s_Option(passwordTokens, false);
  var x130 = $ct_T2__O__O__(new $c_T2(), _1, _2);
  var x141 = x130.T2__f__1;
  var x142 = x130.T2__f__2;
  if ((x141 instanceof $c_s_Some)) {
    var x146 = x141.s_Some__f_value;
    if ((x142 instanceof $c_s_Some)) {
      var p = x142.s_Some__f_value;
      return u.userInfo__T__T__Lsttp_model_Uri(x146, p);
    }
    var x = $m_s_None$();
    if ((x === x142)) {
      return u.userInfo__T__Lsttp_model_Uri(x146);
    }
  }
  var x$3 = $m_s_None$();
  if ((x$3 === x141)) {
    if ((x142 instanceof $c_s_Some)) {
      var p$2 = x142.s_Some__f_value;
      return u.userInfo__T__T__Lsttp_model_Uri("", p$2);
    }
    var x$5 = $m_s_None$();
    if ((x$5 === x142)) {
      return u;
    }
  }
  throw new $c_s_MatchError(x130);
}
export { $p_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$__uiFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_internal_ArrayView__Lsttp_model_Uri as $p_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$__uiFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_internal_ArrayView__Lsttp_model_Uri };
/** @constructor */
function $c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$() {
}
export { $c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$ as $c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$ };
$c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype = new $h_O();
$c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype.constructor = $c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$;
/** @constructor */
function $h_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$() {
}
export { $h_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$ as $h_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$ };
$h_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype = $c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype;
$c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype.hashCode__I = (function() {
  return (-202159303);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype.toString__T = (function() {
  return "UserInfo";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype.productPrefix__T = (function() {
  return "UserInfo";
});
$c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype.fromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__T2 = (function(u, t) {
  var x113 = $m_Lsttp_model_UriInterpolator$UriBuilder$().sttp$model$UriInterpolator$UriBuilder$$$split__Lsttp_model_internal_ArrayView__O__s_util_Either(t, $m_Lsttp_model_UriInterpolator$AtInAuthority$());
  if ((x113 instanceof $c_s_util_Left)) {
    var tt = x113.s_util_Left__f_value;
    return $ct_T2__O__O__(new $c_T2(), u, tt);
  }
  if ((x113 instanceof $c_s_util_Right)) {
    var x115 = x113.s_util_Right__f_value;
    if ((x115 !== null)) {
      var uiTokens = x115.T3__f__1;
      var otherTokens = x115.T3__f__3;
      var _1 = $p_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$__uiFromTokens__Lsttp_model_Uri__Lsttp_model_internal_ArrayView__Lsttp_model_Uri(this, u, uiTokens);
      return $ct_T2__O__O__(new $c_T2(), _1, otherTokens);
    }
  }
  throw new $c_s_MatchError(x113);
});
$c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$ = new $TypeData().initClass($c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$, "sttp.model.UriInterpolator$UriBuilder$UserInfo$", ({
  Lsttp_model_UriInterpolator$UriBuilder$UserInfo$: 1,
  Lsttp_model_UriInterpolator$UriBuilder: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$ as $d_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$ };
var $n_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$;
function $m_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$() {
  if ((!$n_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$)) {
    $n_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$ = new $c_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$();
  }
  return $n_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$;
}
export { $m_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$ as $m_Lsttp_model_UriInterpolator$UriBuilder$UserInfo$ };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$Immutable$() {
}
export { $c_Lsttp_model_headers_CacheDirective$Immutable$ as $c_Lsttp_model_headers_CacheDirective$Immutable$ };
$c_Lsttp_model_headers_CacheDirective$Immutable$.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$Immutable$.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$Immutable$;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$Immutable$() {
}
export { $h_Lsttp_model_headers_CacheDirective$Immutable$ as $h_Lsttp_model_headers_CacheDirective$Immutable$ };
$h_Lsttp_model_headers_CacheDirective$Immutable$.prototype = $c_Lsttp_model_headers_CacheDirective$Immutable$.prototype;
$c_Lsttp_model_headers_CacheDirective$Immutable$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$Immutable$.prototype.hashCode__I = (function() {
  return (-694011550);
});
$c_Lsttp_model_headers_CacheDirective$Immutable$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_headers_CacheDirective$Immutable$.prototype.productPrefix__T = (function() {
  return "Immutable";
});
$c_Lsttp_model_headers_CacheDirective$Immutable$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$Immutable$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$Immutable$.prototype.toString__T = (function() {
  return "immutable";
});
$c_Lsttp_model_headers_CacheDirective$Immutable$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_headers_CacheDirective$Immutable$ = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$Immutable$, "sttp.model.headers.CacheDirective$Immutable$", ({
  Lsttp_model_headers_CacheDirective$Immutable$: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$Immutable$ as $d_Lsttp_model_headers_CacheDirective$Immutable$ };
var $n_Lsttp_model_headers_CacheDirective$Immutable$;
function $m_Lsttp_model_headers_CacheDirective$Immutable$() {
  if ((!$n_Lsttp_model_headers_CacheDirective$Immutable$)) {
    $n_Lsttp_model_headers_CacheDirective$Immutable$ = new $c_Lsttp_model_headers_CacheDirective$Immutable$();
  }
  return $n_Lsttp_model_headers_CacheDirective$Immutable$;
}
export { $m_Lsttp_model_headers_CacheDirective$Immutable$ as $m_Lsttp_model_headers_CacheDirective$Immutable$ };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$MustRevalidate$() {
}
export { $c_Lsttp_model_headers_CacheDirective$MustRevalidate$ as $c_Lsttp_model_headers_CacheDirective$MustRevalidate$ };
$c_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$MustRevalidate$;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$MustRevalidate$() {
}
export { $h_Lsttp_model_headers_CacheDirective$MustRevalidate$ as $h_Lsttp_model_headers_CacheDirective$MustRevalidate$ };
$h_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype = $c_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype;
$c_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype.hashCode__I = (function() {
  return 1205143378;
});
$c_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype.productPrefix__T = (function() {
  return "MustRevalidate";
});
$c_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype.toString__T = (function() {
  return "must-revalidate";
});
$c_Lsttp_model_headers_CacheDirective$MustRevalidate$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_headers_CacheDirective$MustRevalidate$ = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$MustRevalidate$, "sttp.model.headers.CacheDirective$MustRevalidate$", ({
  Lsttp_model_headers_CacheDirective$MustRevalidate$: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$MustRevalidate$ as $d_Lsttp_model_headers_CacheDirective$MustRevalidate$ };
var $n_Lsttp_model_headers_CacheDirective$MustRevalidate$;
function $m_Lsttp_model_headers_CacheDirective$MustRevalidate$() {
  if ((!$n_Lsttp_model_headers_CacheDirective$MustRevalidate$)) {
    $n_Lsttp_model_headers_CacheDirective$MustRevalidate$ = new $c_Lsttp_model_headers_CacheDirective$MustRevalidate$();
  }
  return $n_Lsttp_model_headers_CacheDirective$MustRevalidate$;
}
export { $m_Lsttp_model_headers_CacheDirective$MustRevalidate$ as $m_Lsttp_model_headers_CacheDirective$MustRevalidate$ };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$NoCache$() {
}
export { $c_Lsttp_model_headers_CacheDirective$NoCache$ as $c_Lsttp_model_headers_CacheDirective$NoCache$ };
$c_Lsttp_model_headers_CacheDirective$NoCache$.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$NoCache$.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$NoCache$;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$NoCache$() {
}
export { $h_Lsttp_model_headers_CacheDirective$NoCache$ as $h_Lsttp_model_headers_CacheDirective$NoCache$ };
$h_Lsttp_model_headers_CacheDirective$NoCache$.prototype = $c_Lsttp_model_headers_CacheDirective$NoCache$.prototype;
$c_Lsttp_model_headers_CacheDirective$NoCache$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$NoCache$.prototype.hashCode__I = (function() {
  return (-546457055);
});
$c_Lsttp_model_headers_CacheDirective$NoCache$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_headers_CacheDirective$NoCache$.prototype.productPrefix__T = (function() {
  return "NoCache";
});
$c_Lsttp_model_headers_CacheDirective$NoCache$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$NoCache$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$NoCache$.prototype.toString__T = (function() {
  return "no-cache";
});
$c_Lsttp_model_headers_CacheDirective$NoCache$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_headers_CacheDirective$NoCache$ = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$NoCache$, "sttp.model.headers.CacheDirective$NoCache$", ({
  Lsttp_model_headers_CacheDirective$NoCache$: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$NoCache$ as $d_Lsttp_model_headers_CacheDirective$NoCache$ };
var $n_Lsttp_model_headers_CacheDirective$NoCache$;
function $m_Lsttp_model_headers_CacheDirective$NoCache$() {
  if ((!$n_Lsttp_model_headers_CacheDirective$NoCache$)) {
    $n_Lsttp_model_headers_CacheDirective$NoCache$ = new $c_Lsttp_model_headers_CacheDirective$NoCache$();
  }
  return $n_Lsttp_model_headers_CacheDirective$NoCache$;
}
export { $m_Lsttp_model_headers_CacheDirective$NoCache$ as $m_Lsttp_model_headers_CacheDirective$NoCache$ };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$NoStore$() {
}
export { $c_Lsttp_model_headers_CacheDirective$NoStore$ as $c_Lsttp_model_headers_CacheDirective$NoStore$ };
$c_Lsttp_model_headers_CacheDirective$NoStore$.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$NoStore$.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$NoStore$;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$NoStore$() {
}
export { $h_Lsttp_model_headers_CacheDirective$NoStore$ as $h_Lsttp_model_headers_CacheDirective$NoStore$ };
$h_Lsttp_model_headers_CacheDirective$NoStore$.prototype = $c_Lsttp_model_headers_CacheDirective$NoStore$.prototype;
$c_Lsttp_model_headers_CacheDirective$NoStore$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$NoStore$.prototype.hashCode__I = (function() {
  return (-531102848);
});
$c_Lsttp_model_headers_CacheDirective$NoStore$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_headers_CacheDirective$NoStore$.prototype.productPrefix__T = (function() {
  return "NoStore";
});
$c_Lsttp_model_headers_CacheDirective$NoStore$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$NoStore$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$NoStore$.prototype.toString__T = (function() {
  return "no-store";
});
$c_Lsttp_model_headers_CacheDirective$NoStore$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_headers_CacheDirective$NoStore$ = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$NoStore$, "sttp.model.headers.CacheDirective$NoStore$", ({
  Lsttp_model_headers_CacheDirective$NoStore$: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$NoStore$ as $d_Lsttp_model_headers_CacheDirective$NoStore$ };
var $n_Lsttp_model_headers_CacheDirective$NoStore$;
function $m_Lsttp_model_headers_CacheDirective$NoStore$() {
  if ((!$n_Lsttp_model_headers_CacheDirective$NoStore$)) {
    $n_Lsttp_model_headers_CacheDirective$NoStore$ = new $c_Lsttp_model_headers_CacheDirective$NoStore$();
  }
  return $n_Lsttp_model_headers_CacheDirective$NoStore$;
}
export { $m_Lsttp_model_headers_CacheDirective$NoStore$ as $m_Lsttp_model_headers_CacheDirective$NoStore$ };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$NoTransform$() {
}
export { $c_Lsttp_model_headers_CacheDirective$NoTransform$ as $c_Lsttp_model_headers_CacheDirective$NoTransform$ };
$c_Lsttp_model_headers_CacheDirective$NoTransform$.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$NoTransform$.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$NoTransform$;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$NoTransform$() {
}
export { $h_Lsttp_model_headers_CacheDirective$NoTransform$ as $h_Lsttp_model_headers_CacheDirective$NoTransform$ };
$h_Lsttp_model_headers_CacheDirective$NoTransform$.prototype = $c_Lsttp_model_headers_CacheDirective$NoTransform$.prototype;
$c_Lsttp_model_headers_CacheDirective$NoTransform$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$NoTransform$.prototype.hashCode__I = (function() {
  return (-4780405);
});
$c_Lsttp_model_headers_CacheDirective$NoTransform$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_headers_CacheDirective$NoTransform$.prototype.productPrefix__T = (function() {
  return "NoTransform";
});
$c_Lsttp_model_headers_CacheDirective$NoTransform$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$NoTransform$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$NoTransform$.prototype.toString__T = (function() {
  return "no-transform";
});
$c_Lsttp_model_headers_CacheDirective$NoTransform$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_headers_CacheDirective$NoTransform$ = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$NoTransform$, "sttp.model.headers.CacheDirective$NoTransform$", ({
  Lsttp_model_headers_CacheDirective$NoTransform$: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$NoTransform$ as $d_Lsttp_model_headers_CacheDirective$NoTransform$ };
var $n_Lsttp_model_headers_CacheDirective$NoTransform$;
function $m_Lsttp_model_headers_CacheDirective$NoTransform$() {
  if ((!$n_Lsttp_model_headers_CacheDirective$NoTransform$)) {
    $n_Lsttp_model_headers_CacheDirective$NoTransform$ = new $c_Lsttp_model_headers_CacheDirective$NoTransform$();
  }
  return $n_Lsttp_model_headers_CacheDirective$NoTransform$;
}
export { $m_Lsttp_model_headers_CacheDirective$NoTransform$ as $m_Lsttp_model_headers_CacheDirective$NoTransform$ };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$OnlyIfCached$() {
}
export { $c_Lsttp_model_headers_CacheDirective$OnlyIfCached$ as $c_Lsttp_model_headers_CacheDirective$OnlyIfCached$ };
$c_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$OnlyIfCached$;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$OnlyIfCached$() {
}
export { $h_Lsttp_model_headers_CacheDirective$OnlyIfCached$ as $h_Lsttp_model_headers_CacheDirective$OnlyIfCached$ };
$h_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype = $c_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype;
$c_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype.hashCode__I = (function() {
  return (-1472815989);
});
$c_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype.productPrefix__T = (function() {
  return "OnlyIfCached";
});
$c_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype.toString__T = (function() {
  return "only-if-cached";
});
$c_Lsttp_model_headers_CacheDirective$OnlyIfCached$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_headers_CacheDirective$OnlyIfCached$ = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$OnlyIfCached$, "sttp.model.headers.CacheDirective$OnlyIfCached$", ({
  Lsttp_model_headers_CacheDirective$OnlyIfCached$: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$OnlyIfCached$ as $d_Lsttp_model_headers_CacheDirective$OnlyIfCached$ };
var $n_Lsttp_model_headers_CacheDirective$OnlyIfCached$;
function $m_Lsttp_model_headers_CacheDirective$OnlyIfCached$() {
  if ((!$n_Lsttp_model_headers_CacheDirective$OnlyIfCached$)) {
    $n_Lsttp_model_headers_CacheDirective$OnlyIfCached$ = new $c_Lsttp_model_headers_CacheDirective$OnlyIfCached$();
  }
  return $n_Lsttp_model_headers_CacheDirective$OnlyIfCached$;
}
export { $m_Lsttp_model_headers_CacheDirective$OnlyIfCached$ as $m_Lsttp_model_headers_CacheDirective$OnlyIfCached$ };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$Private$() {
}
export { $c_Lsttp_model_headers_CacheDirective$Private$ as $c_Lsttp_model_headers_CacheDirective$Private$ };
$c_Lsttp_model_headers_CacheDirective$Private$.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$Private$.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$Private$;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$Private$() {
}
export { $h_Lsttp_model_headers_CacheDirective$Private$ as $h_Lsttp_model_headers_CacheDirective$Private$ };
$h_Lsttp_model_headers_CacheDirective$Private$.prototype = $c_Lsttp_model_headers_CacheDirective$Private$.prototype;
$c_Lsttp_model_headers_CacheDirective$Private$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$Private$.prototype.hashCode__I = (function() {
  return 1350155619;
});
$c_Lsttp_model_headers_CacheDirective$Private$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_headers_CacheDirective$Private$.prototype.productPrefix__T = (function() {
  return "Private";
});
$c_Lsttp_model_headers_CacheDirective$Private$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$Private$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$Private$.prototype.toString__T = (function() {
  return "private";
});
$c_Lsttp_model_headers_CacheDirective$Private$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_headers_CacheDirective$Private$ = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$Private$, "sttp.model.headers.CacheDirective$Private$", ({
  Lsttp_model_headers_CacheDirective$Private$: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$Private$ as $d_Lsttp_model_headers_CacheDirective$Private$ };
var $n_Lsttp_model_headers_CacheDirective$Private$;
function $m_Lsttp_model_headers_CacheDirective$Private$() {
  if ((!$n_Lsttp_model_headers_CacheDirective$Private$)) {
    $n_Lsttp_model_headers_CacheDirective$Private$ = new $c_Lsttp_model_headers_CacheDirective$Private$();
  }
  return $n_Lsttp_model_headers_CacheDirective$Private$;
}
export { $m_Lsttp_model_headers_CacheDirective$Private$ as $m_Lsttp_model_headers_CacheDirective$Private$ };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$() {
}
export { $c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$ as $c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$ };
$c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$ProxyRevalidate$() {
}
export { $h_Lsttp_model_headers_CacheDirective$ProxyRevalidate$ as $h_Lsttp_model_headers_CacheDirective$ProxyRevalidate$ };
$h_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype = $c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype;
$c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype.hashCode__I = (function() {
  return 2035413303;
});
$c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype.productPrefix__T = (function() {
  return "ProxyRevalidate";
});
$c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype.toString__T = (function() {
  return "proxy-revalidate";
});
$c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_headers_CacheDirective$ProxyRevalidate$ = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$, "sttp.model.headers.CacheDirective$ProxyRevalidate$", ({
  Lsttp_model_headers_CacheDirective$ProxyRevalidate$: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$ProxyRevalidate$ as $d_Lsttp_model_headers_CacheDirective$ProxyRevalidate$ };
var $n_Lsttp_model_headers_CacheDirective$ProxyRevalidate$;
function $m_Lsttp_model_headers_CacheDirective$ProxyRevalidate$() {
  if ((!$n_Lsttp_model_headers_CacheDirective$ProxyRevalidate$)) {
    $n_Lsttp_model_headers_CacheDirective$ProxyRevalidate$ = new $c_Lsttp_model_headers_CacheDirective$ProxyRevalidate$();
  }
  return $n_Lsttp_model_headers_CacheDirective$ProxyRevalidate$;
}
export { $m_Lsttp_model_headers_CacheDirective$ProxyRevalidate$ as $m_Lsttp_model_headers_CacheDirective$ProxyRevalidate$ };
/** @constructor */
function $c_Lsttp_model_headers_CacheDirective$Public$() {
}
export { $c_Lsttp_model_headers_CacheDirective$Public$ as $c_Lsttp_model_headers_CacheDirective$Public$ };
$c_Lsttp_model_headers_CacheDirective$Public$.prototype = new $h_O();
$c_Lsttp_model_headers_CacheDirective$Public$.prototype.constructor = $c_Lsttp_model_headers_CacheDirective$Public$;
/** @constructor */
function $h_Lsttp_model_headers_CacheDirective$Public$() {
}
export { $h_Lsttp_model_headers_CacheDirective$Public$ as $h_Lsttp_model_headers_CacheDirective$Public$ };
$h_Lsttp_model_headers_CacheDirective$Public$.prototype = $c_Lsttp_model_headers_CacheDirective$Public$.prototype;
$c_Lsttp_model_headers_CacheDirective$Public$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_model_headers_CacheDirective$Public$.prototype.hashCode__I = (function() {
  return (-1893556599);
});
$c_Lsttp_model_headers_CacheDirective$Public$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_model_headers_CacheDirective$Public$.prototype.productPrefix__T = (function() {
  return "Public";
});
$c_Lsttp_model_headers_CacheDirective$Public$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$Public$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_model_headers_CacheDirective$Public$.prototype.toString__T = (function() {
  return "public";
});
$c_Lsttp_model_headers_CacheDirective$Public$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_model_headers_CacheDirective$Public$ = new $TypeData().initClass($c_Lsttp_model_headers_CacheDirective$Public$, "sttp.model.headers.CacheDirective$Public$", ({
  Lsttp_model_headers_CacheDirective$Public$: 1,
  Lsttp_model_headers_CacheDirective: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_model_headers_CacheDirective$Public$ as $d_Lsttp_model_headers_CacheDirective$Public$ };
var $n_Lsttp_model_headers_CacheDirective$Public$;
function $m_Lsttp_model_headers_CacheDirective$Public$() {
  if ((!$n_Lsttp_model_headers_CacheDirective$Public$)) {
    $n_Lsttp_model_headers_CacheDirective$Public$ = new $c_Lsttp_model_headers_CacheDirective$Public$();
  }
  return $n_Lsttp_model_headers_CacheDirective$Public$;
}
export { $m_Lsttp_model_headers_CacheDirective$Public$ as $m_Lsttp_model_headers_CacheDirective$Public$ };
/** @constructor */
function $c_Lsttp_tapir_ValidationResult$Valid$() {
}
export { $c_Lsttp_tapir_ValidationResult$Valid$ as $c_Lsttp_tapir_ValidationResult$Valid$ };
$c_Lsttp_tapir_ValidationResult$Valid$.prototype = new $h_O();
$c_Lsttp_tapir_ValidationResult$Valid$.prototype.constructor = $c_Lsttp_tapir_ValidationResult$Valid$;
/** @constructor */
function $h_Lsttp_tapir_ValidationResult$Valid$() {
}
export { $h_Lsttp_tapir_ValidationResult$Valid$ as $h_Lsttp_tapir_ValidationResult$Valid$ };
$h_Lsttp_tapir_ValidationResult$Valid$.prototype = $c_Lsttp_tapir_ValidationResult$Valid$.prototype;
$c_Lsttp_tapir_ValidationResult$Valid$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_ValidationResult$Valid$.prototype.hashCode__I = (function() {
  return 82419676;
});
$c_Lsttp_tapir_ValidationResult$Valid$.prototype.toString__T = (function() {
  return "Valid";
});
$c_Lsttp_tapir_ValidationResult$Valid$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_ValidationResult$Valid$.prototype.productPrefix__T = (function() {
  return "Valid";
});
$c_Lsttp_tapir_ValidationResult$Valid$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_ValidationResult$Valid$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_ValidationResult$Valid$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_tapir_ValidationResult$Valid$ = new $TypeData().initClass($c_Lsttp_tapir_ValidationResult$Valid$, "sttp.tapir.ValidationResult$Valid$", ({
  Lsttp_tapir_ValidationResult$Valid$: 1,
  Lsttp_tapir_ValidationResult: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_tapir_ValidationResult$Valid$ as $d_Lsttp_tapir_ValidationResult$Valid$ };
var $n_Lsttp_tapir_ValidationResult$Valid$;
function $m_Lsttp_tapir_ValidationResult$Valid$() {
  if ((!$n_Lsttp_tapir_ValidationResult$Valid$)) {
    $n_Lsttp_tapir_ValidationResult$Valid$ = new $c_Lsttp_tapir_ValidationResult$Valid$();
  }
  return $n_Lsttp_tapir_ValidationResult$Valid$;
}
export { $m_Lsttp_tapir_ValidationResult$Valid$ as $m_Lsttp_tapir_ValidationResult$Valid$ };
function $f_Lcats_FlatMap__flatten__O__O($thiz, ffa) {
  return $thiz.flatMap__O__F1__O(ffa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fa) => fa)));
}
export { $f_Lcats_FlatMap__flatten__O__O as $f_Lcats_FlatMap__flatten__O__O };
function $f_Lcats_FlatMap__ap__O__O__O($thiz, ff, fa) {
  return $thiz.flatMap__O__F1__O(ff, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((f) => $thiz.map__O__F1__O(fa, f))));
}
export { $f_Lcats_FlatMap__ap__O__O__O as $f_Lcats_FlatMap__ap__O__O__O };
function $f_Lcats_FlatMap__product__O__O__O($thiz, fa, fb) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => $thiz.map__O__F1__O(fb, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => $ct_T2__O__O__(new $c_T2(), a, b)))))));
}
export { $f_Lcats_FlatMap__product__O__O__O as $f_Lcats_FlatMap__product__O__O__O };
function $f_Lcats_FlatMap__map2__O__O__F2__O($thiz, fa, fb, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => $thiz.map__O__F1__O(fb, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => f.apply__O__O__O(a, b)))))));
}
export { $f_Lcats_FlatMap__map2__O__O__F2__O as $f_Lcats_FlatMap__map2__O__O__F2__O };
function $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval($thiz, fa, fb, f) {
  $m_Lcats_Eval$();
  var a$1 = $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => $thiz.map__O__F1__O(fb.value__O(), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => f.apply__O__O__O(a, b)))))));
  return new $c_Lcats_Now(a$1);
}
export { $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval as $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval };
function $f_Lcats_FlatMap__productR__O__O__O($thiz, fa, fb) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => fb)));
}
export { $f_Lcats_FlatMap__productR__O__O__O as $f_Lcats_FlatMap__productR__O__O__O };
function $f_Lcats_FlatMap__productL__O__O__O($thiz, fa, fb) {
  return $thiz.map2__O__O__F2__O(fa, fb, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a, _$5) => a)));
}
export { $f_Lcats_FlatMap__productL__O__O__O as $f_Lcats_FlatMap__productL__O__O__O };
function $f_Lcats_FlatMap__flatTap__O__F1__O($thiz, fa, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => $thiz.as__O__O__O(f.apply__O__O(a), a))));
}
export { $f_Lcats_FlatMap__flatTap__O__F1__O as $f_Lcats_FlatMap__flatTap__O__F1__O };
/** @constructor */
function $c_Lcats_data_Chain$Empty$() {
}
export { $c_Lcats_data_Chain$Empty$ as $c_Lcats_data_Chain$Empty$ };
$c_Lcats_data_Chain$Empty$.prototype = new $h_Lcats_data_Chain();
$c_Lcats_data_Chain$Empty$.prototype.constructor = $c_Lcats_data_Chain$Empty$;
/** @constructor */
function $h_Lcats_data_Chain$Empty$() {
}
export { $h_Lcats_data_Chain$Empty$ as $h_Lcats_data_Chain$Empty$ };
$h_Lcats_data_Chain$Empty$.prototype = $c_Lcats_data_Chain$Empty$.prototype;
$c_Lcats_data_Chain$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lcats_data_Chain$Empty$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lcats_data_Chain$Empty$.prototype.productPrefix__T = (function() {
  return "Empty";
});
$c_Lcats_data_Chain$Empty$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_Chain$Empty$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lcats_data_Chain$Empty$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lcats_data_Chain$Empty$ = new $TypeData().initClass($c_Lcats_data_Chain$Empty$, "cats.data.Chain$Empty$", ({
  Lcats_data_Chain$Empty$: 1,
  Lcats_data_Chain: 1,
  Lcats_data_ChainCompat: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lcats_data_Chain$Empty$ as $d_Lcats_data_Chain$Empty$ };
var $n_Lcats_data_Chain$Empty$;
function $m_Lcats_data_Chain$Empty$() {
  if ((!$n_Lcats_data_Chain$Empty$)) {
    $n_Lcats_data_Chain$Empty$ = new $c_Lcats_data_Chain$Empty$();
  }
  return $n_Lcats_data_Chain$Empty$;
}
export { $m_Lcats_data_Chain$Empty$ as $m_Lcats_data_Chain$Empty$ };
function $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, newValue) {
  var x = $thiz.maybeLastSeenCurrentValue__O();
  var isInitial = (x === (void 0));
  if ((!isInitial)) {
    $thiz._lastUpdateId_$eq__I__V($m_Lcom_raquo_airstream_core_Signal$().nextUpdateId__I());
  }
  $thiz.maybeLastSeenCurrentValue_$eq__O__V(newValue);
}
export { $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V as $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V };
function $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try($thiz) {
  var x = $thiz.maybeLastSeenCurrentValue__O();
  if ((x === (void 0))) {
    $thiz._lastUpdateId_$eq__I__V($m_Lcom_raquo_airstream_core_Signal$().nextUpdateId__I());
    var nextValue = $thiz.currentValueFromParent__s_util_Try();
    $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, nextValue);
    var $x_1 = nextValue;
  } else {
    var $x_1 = x;
  }
  return $x_1;
}
export { $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try as $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try };
function $f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  $thiz.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(new $c_s_util_Success(nextValue), transaction);
}
export { $f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, nextError, transaction) {
  $thiz.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(new $c_s_util_Failure(nextError), transaction);
}
export { $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, nextValue);
  var isError = nextValue.isFailure__Z();
  var elem = false;
  elem = false;
  $thiz.isSafeToRemoveObserver_$eq__Z__V(false);
  var this$ = $thiz.externalObservers__Lcom_raquo_ew_JsArray();
  var index = 0;
  while ((index < (this$.length | 0))) {
    var observer = this$[index];
    index = ((1 + index) | 0);
    observer.onTry__s_util_Try__V(nextValue);
    if ((isError && (!elem))) {
      elem = true;
    }
  }
  var this$$1 = $thiz.internalObservers__Lcom_raquo_ew_JsArray();
  var index$1 = 0;
  while ((index$1 < (this$$1.length | 0))) {
    var observer$1 = this$$1[index$1];
    index$1 = ((1 + index$1) | 0);
    observer$1.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(nextValue, transaction);
    if ((isError && (!elem))) {
      elem = true;
    }
  }
  $thiz.isSafeToRemoveObserver_$eq__Z__V(true);
  var x = $thiz.maybePendingObserverRemovals__O();
  if ((x !== (void 0))) {
    var i = 0;
    var len = (x.length | 0);
    while ((i < len)) {
      var remove = x[i];
      remove.apply__O();
      i = ((1 + i) | 0);
    }
    x.length = 0;
  }
  if ((isError && (!elem))) {
    nextValue.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((err) => {
      $m_Lcom_raquo_airstream_core_AirstreamError$().sendUnhandledError__jl_Throwable__V(err);
    })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => (void 0))));
  }
}
export { $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  $thiz.isSafeToRemoveObserver_$eq__Z__V(false);
  var this$ = $thiz.externalObservers__Lcom_raquo_ew_JsArray();
  var index = 0;
  while ((index < (this$.length | 0))) {
    var observer = this$[index];
    index = ((1 + index) | 0);
    try {
      observer.onNext__O__V(nextValue);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      $m_Lcom_raquo_airstream_core_AirstreamError$().sendUnhandledError__jl_Throwable__V(new $c_Lcom_raquo_airstream_core_AirstreamError$ObserverError(e$2));
    }
  }
  var this$$1 = $thiz.internalObservers__Lcom_raquo_ew_JsArray();
  var index$1 = 0;
  while ((index$1 < (this$$1.length | 0))) {
    var observer$1 = this$$1[index$1];
    index$1 = ((1 + index$1) | 0);
    observer$1.onNext__O__Lcom_raquo_airstream_core_Transaction__V(nextValue, transaction);
  }
  $thiz.isSafeToRemoveObserver_$eq__Z__V(true);
  var x = $thiz.maybePendingObserverRemovals__O();
  if ((x !== (void 0))) {
    var i = 0;
    var len = (x.length | 0);
    while ((i < len)) {
      var remove = x[i];
      remove.apply__O();
      i = ((1 + i) | 0);
    }
    x.length = 0;
  }
}
export { $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, nextError, transaction) {
  $thiz.isSafeToRemoveObserver_$eq__Z__V(false);
  var this$ = $thiz.externalObservers__Lcom_raquo_ew_JsArray();
  var index = 0;
  while ((index < (this$.length | 0))) {
    var observer = this$[index];
    index = ((1 + index) | 0);
    observer.onError__jl_Throwable__V(nextError);
  }
  var this$$1 = $thiz.internalObservers__Lcom_raquo_ew_JsArray();
  var index$1 = 0;
  while ((index$1 < (this$$1.length | 0))) {
    var observer$1 = this$$1[index$1];
    index$1 = ((1 + index$1) | 0);
    observer$1.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(nextError, transaction);
  }
  $thiz.isSafeToRemoveObserver_$eq__Z__V(true);
  var x = $thiz.maybePendingObserverRemovals__O();
  if ((x !== (void 0))) {
    var i = 0;
    var len = (x.length | 0);
    while ((i < len)) {
      var remove = x[i];
      remove.apply__O();
      i = ((1 + i) | 0);
    }
    x.length = 0;
  }
}
export { $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, transaction) {
  nextValue.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    $thiz.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(_$1, transaction);
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    $thiz.fireValue__O__Lcom_raquo_airstream_core_Transaction__V(_$2, transaction);
  })));
}
export { $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V };
/** @constructor */
function $c_Lio_circe_CursorOp$DeleteGoParent$() {
}
export { $c_Lio_circe_CursorOp$DeleteGoParent$ as $c_Lio_circe_CursorOp$DeleteGoParent$ };
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.constructor = $c_Lio_circe_CursorOp$DeleteGoParent$;
/** @constructor */
function $h_Lio_circe_CursorOp$DeleteGoParent$() {
}
export { $h_Lio_circe_CursorOp$DeleteGoParent$ as $h_Lio_circe_CursorOp$DeleteGoParent$ };
$h_Lio_circe_CursorOp$DeleteGoParent$.prototype = $c_Lio_circe_CursorOp$DeleteGoParent$.prototype;
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.hashCode__I = (function() {
  return (-1822060899);
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.toString__T = (function() {
  return "DeleteGoParent";
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productPrefix__T = (function() {
  return "DeleteGoParent";
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$DeleteGoParent$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lio_circe_CursorOp$DeleteGoParent$ = new $TypeData().initClass($c_Lio_circe_CursorOp$DeleteGoParent$, "io.circe.CursorOp$DeleteGoParent$", ({
  Lio_circe_CursorOp$DeleteGoParent$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lio_circe_CursorOp$DeleteGoParent$ as $d_Lio_circe_CursorOp$DeleteGoParent$ };
var $n_Lio_circe_CursorOp$DeleteGoParent$;
function $m_Lio_circe_CursorOp$DeleteGoParent$() {
  if ((!$n_Lio_circe_CursorOp$DeleteGoParent$)) {
    $n_Lio_circe_CursorOp$DeleteGoParent$ = new $c_Lio_circe_CursorOp$DeleteGoParent$();
  }
  return $n_Lio_circe_CursorOp$DeleteGoParent$;
}
export { $m_Lio_circe_CursorOp$DeleteGoParent$ as $m_Lio_circe_CursorOp$DeleteGoParent$ };
/** @constructor */
function $c_Lio_circe_CursorOp$DownArray$() {
}
export { $c_Lio_circe_CursorOp$DownArray$ as $c_Lio_circe_CursorOp$DownArray$ };
$c_Lio_circe_CursorOp$DownArray$.prototype = new $h_Lio_circe_CursorOp$ArrayOp();
$c_Lio_circe_CursorOp$DownArray$.prototype.constructor = $c_Lio_circe_CursorOp$DownArray$;
/** @constructor */
function $h_Lio_circe_CursorOp$DownArray$() {
}
export { $h_Lio_circe_CursorOp$DownArray$ as $h_Lio_circe_CursorOp$DownArray$ };
$h_Lio_circe_CursorOp$DownArray$.prototype = $c_Lio_circe_CursorOp$DownArray$.prototype;
$c_Lio_circe_CursorOp$DownArray$.prototype.hashCode__I = (function() {
  return (-1017900361);
});
$c_Lio_circe_CursorOp$DownArray$.prototype.toString__T = (function() {
  return "DownArray";
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productPrefix__T = (function() {
  return "DownArray";
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$DownArray$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$DownArray$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lio_circe_CursorOp$DownArray$ = new $TypeData().initClass($c_Lio_circe_CursorOp$DownArray$, "io.circe.CursorOp$DownArray$", ({
  Lio_circe_CursorOp$DownArray$: 1,
  Lio_circe_CursorOp$ArrayOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lio_circe_CursorOp$DownArray$ as $d_Lio_circe_CursorOp$DownArray$ };
var $n_Lio_circe_CursorOp$DownArray$;
function $m_Lio_circe_CursorOp$DownArray$() {
  if ((!$n_Lio_circe_CursorOp$DownArray$)) {
    $n_Lio_circe_CursorOp$DownArray$ = new $c_Lio_circe_CursorOp$DownArray$();
  }
  return $n_Lio_circe_CursorOp$DownArray$;
}
export { $m_Lio_circe_CursorOp$DownArray$ as $m_Lio_circe_CursorOp$DownArray$ };
/** @constructor */
function $c_Lio_circe_CursorOp$MoveLeft$() {
}
export { $c_Lio_circe_CursorOp$MoveLeft$ as $c_Lio_circe_CursorOp$MoveLeft$ };
$c_Lio_circe_CursorOp$MoveLeft$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveLeft$.prototype.constructor = $c_Lio_circe_CursorOp$MoveLeft$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveLeft$() {
}
export { $h_Lio_circe_CursorOp$MoveLeft$ as $h_Lio_circe_CursorOp$MoveLeft$ };
$h_Lio_circe_CursorOp$MoveLeft$.prototype = $c_Lio_circe_CursorOp$MoveLeft$.prototype;
$c_Lio_circe_CursorOp$MoveLeft$.prototype.hashCode__I = (function() {
  return (-40017000);
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.toString__T = (function() {
  return "MoveLeft";
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productPrefix__T = (function() {
  return "MoveLeft";
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$MoveLeft$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lio_circe_CursorOp$MoveLeft$ = new $TypeData().initClass($c_Lio_circe_CursorOp$MoveLeft$, "io.circe.CursorOp$MoveLeft$", ({
  Lio_circe_CursorOp$MoveLeft$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lio_circe_CursorOp$MoveLeft$ as $d_Lio_circe_CursorOp$MoveLeft$ };
var $n_Lio_circe_CursorOp$MoveLeft$;
function $m_Lio_circe_CursorOp$MoveLeft$() {
  if ((!$n_Lio_circe_CursorOp$MoveLeft$)) {
    $n_Lio_circe_CursorOp$MoveLeft$ = new $c_Lio_circe_CursorOp$MoveLeft$();
  }
  return $n_Lio_circe_CursorOp$MoveLeft$;
}
export { $m_Lio_circe_CursorOp$MoveLeft$ as $m_Lio_circe_CursorOp$MoveLeft$ };
/** @constructor */
function $c_Lio_circe_CursorOp$MoveRight$() {
}
export { $c_Lio_circe_CursorOp$MoveRight$ as $c_Lio_circe_CursorOp$MoveRight$ };
$c_Lio_circe_CursorOp$MoveRight$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveRight$.prototype.constructor = $c_Lio_circe_CursorOp$MoveRight$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveRight$() {
}
export { $h_Lio_circe_CursorOp$MoveRight$ as $h_Lio_circe_CursorOp$MoveRight$ };
$h_Lio_circe_CursorOp$MoveRight$.prototype = $c_Lio_circe_CursorOp$MoveRight$.prototype;
$c_Lio_circe_CursorOp$MoveRight$.prototype.hashCode__I = (function() {
  return (-1234866005);
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.toString__T = (function() {
  return "MoveRight";
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productPrefix__T = (function() {
  return "MoveRight";
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$MoveRight$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lio_circe_CursorOp$MoveRight$ = new $TypeData().initClass($c_Lio_circe_CursorOp$MoveRight$, "io.circe.CursorOp$MoveRight$", ({
  Lio_circe_CursorOp$MoveRight$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lio_circe_CursorOp$MoveRight$ as $d_Lio_circe_CursorOp$MoveRight$ };
var $n_Lio_circe_CursorOp$MoveRight$;
function $m_Lio_circe_CursorOp$MoveRight$() {
  if ((!$n_Lio_circe_CursorOp$MoveRight$)) {
    $n_Lio_circe_CursorOp$MoveRight$ = new $c_Lio_circe_CursorOp$MoveRight$();
  }
  return $n_Lio_circe_CursorOp$MoveRight$;
}
export { $m_Lio_circe_CursorOp$MoveRight$ as $m_Lio_circe_CursorOp$MoveRight$ };
/** @constructor */
function $c_Lio_circe_CursorOp$MoveUp$() {
}
export { $c_Lio_circe_CursorOp$MoveUp$ as $c_Lio_circe_CursorOp$MoveUp$ };
$c_Lio_circe_CursorOp$MoveUp$.prototype = new $h_Lio_circe_CursorOp$UnconstrainedOp();
$c_Lio_circe_CursorOp$MoveUp$.prototype.constructor = $c_Lio_circe_CursorOp$MoveUp$;
/** @constructor */
function $h_Lio_circe_CursorOp$MoveUp$() {
}
export { $h_Lio_circe_CursorOp$MoveUp$ as $h_Lio_circe_CursorOp$MoveUp$ };
$h_Lio_circe_CursorOp$MoveUp$.prototype = $c_Lio_circe_CursorOp$MoveUp$.prototype;
$c_Lio_circe_CursorOp$MoveUp$.prototype.hashCode__I = (function() {
  return (-1984396692);
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.toString__T = (function() {
  return "MoveUp";
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productPrefix__T = (function() {
  return "MoveUp";
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lio_circe_CursorOp$MoveUp$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lio_circe_CursorOp$MoveUp$ = new $TypeData().initClass($c_Lio_circe_CursorOp$MoveUp$, "io.circe.CursorOp$MoveUp$", ({
  Lio_circe_CursorOp$MoveUp$: 1,
  Lio_circe_CursorOp$UnconstrainedOp: 1,
  Lio_circe_CursorOp: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lio_circe_CursorOp$MoveUp$ as $d_Lio_circe_CursorOp$MoveUp$ };
var $n_Lio_circe_CursorOp$MoveUp$;
function $m_Lio_circe_CursorOp$MoveUp$() {
  if ((!$n_Lio_circe_CursorOp$MoveUp$)) {
    $n_Lio_circe_CursorOp$MoveUp$ = new $c_Lio_circe_CursorOp$MoveUp$();
  }
  return $n_Lio_circe_CursorOp$MoveUp$;
}
export { $m_Lio_circe_CursorOp$MoveUp$ as $m_Lio_circe_CursorOp$MoveUp$ };
/** @constructor */
function $c_Lio_circe_Decoder$() {
  this.Lio_circe_Decoder$__f_resultInstance = null;
  this.Lio_circe_Decoder$__f_accumulatingResultInstance = null;
  this.Lio_circe_Decoder$__f_decodeString = null;
  this.Lio_circe_Decoder$__f_decodeBoolean = null;
  this.Lio_circe_Decoder$__f_decodeUUID$lzy1 = null;
  this.Lio_circe_Decoder$__f_decodeUUIDbitmap$1 = false;
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$$rightNone = null;
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$$validNone = null;
  this.Lio_circe_Decoder$__f_keyMissingNone = null;
  this.Lio_circe_Decoder$__f_keyMissingNoneAccumulating = null;
  $n_Lio_circe_Decoder$ = this;
  this.Lio_circe_Decoder$__f_resultInstance = ($m_Lcats_instances_package$either$(), new $c_Lcats_instances_EitherInstances$$anon$2());
  $m_Lcats_data_Validated$();
  var E = $m_Lcats_data_NonEmptyList$().catsDataSemigroupForNonEmptyList__Lcats_kernel_Semigroup();
  this.Lio_circe_Decoder$__f_accumulatingResultInstance = new $c_Lcats_data_ValidatedInstances$$anon$7(E);
  $m_Lcats_instances_package$either$();
  this.Lio_circe_Decoder$__f_decodeString = new $c_Lio_circe_Decoder$$anon$19();
  this.Lio_circe_Decoder$__f_decodeBoolean = new $c_Lio_circe_Decoder$$anon$21();
  var value = $m_s_None$();
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$$rightNone = new $c_s_util_Right(value);
  $m_Lcats_data_Validated$();
  var a = $m_s_None$();
  this.Lio_circe_Decoder$__f_io$circe$Decoder$$$validNone = new $c_Lcats_data_Validated$Valid(a);
  var value$1 = $m_s_None$();
  this.Lio_circe_Decoder$__f_keyMissingNone = new $c_s_util_Right(value$1);
  $m_Lcats_data_Validated$();
  var a$1 = $m_s_None$();
  this.Lio_circe_Decoder$__f_keyMissingNoneAccumulating = new $c_Lcats_data_Validated$Valid(a$1);
}
export { $c_Lio_circe_Decoder$ as $c_Lio_circe_Decoder$ };
$c_Lio_circe_Decoder$.prototype = new $h_O();
$c_Lio_circe_Decoder$.prototype.constructor = $c_Lio_circe_Decoder$;
/** @constructor */
function $h_Lio_circe_Decoder$() {
}
export { $h_Lio_circe_Decoder$ as $h_Lio_circe_Decoder$ };
$h_Lio_circe_Decoder$.prototype = $c_Lio_circe_Decoder$.prototype;
$c_Lio_circe_Decoder$.prototype.decodeUUID__Lio_circe_Decoder = (function() {
  if ((!this.Lio_circe_Decoder$__f_decodeUUIDbitmap$1)) {
    this.Lio_circe_Decoder$__f_decodeUUID$lzy1 = new $c_Lio_circe_Decoder$$anon$43();
    this.Lio_circe_Decoder$__f_decodeUUIDbitmap$1 = true;
  }
  return this.Lio_circe_Decoder$__f_decodeUUID$lzy1;
});
var $d_Lio_circe_Decoder$ = new $TypeData().initClass($c_Lio_circe_Decoder$, "io.circe.Decoder$", ({
  Lio_circe_Decoder$: 1,
  Lio_circe_DecoderDerivation: 1,
  Lio_circe_LowPriorityCollectionDecoders: 1,
  Lio_circe_CollectionDecoders: 1,
  Lio_circe_TupleDecoders: 1,
  Lio_circe_ProductDecoders: 1,
  Lio_circe_LiteralDecoders: 1,
  Lio_circe_EnumerationDecoders: 1,
  Lio_circe_LowPriorityDecoders: 1
}));
export { $d_Lio_circe_Decoder$ as $d_Lio_circe_Decoder$ };
var $n_Lio_circe_Decoder$;
function $m_Lio_circe_Decoder$() {
  if ((!$n_Lio_circe_Decoder$)) {
    $n_Lio_circe_Decoder$ = new $c_Lio_circe_Decoder$();
  }
  return $n_Lio_circe_Decoder$;
}
export { $m_Lio_circe_Decoder$ as $m_Lio_circe_Decoder$ };
/** @constructor */
function $c_Lio_circe_Encoder$() {
  this.Lio_circe_Encoder$__f_encodeString = null;
  this.Lio_circe_Encoder$__f_encodeBoolean = null;
  this.Lio_circe_Encoder$__f_encodeUUID$lzy1 = null;
  this.Lio_circe_Encoder$__f_encodeUUIDbitmap$1 = false;
  $n_Lio_circe_Encoder$ = this;
  this.Lio_circe_Encoder$__f_encodeString = new $c_Lio_circe_Encoder$$anon$6();
  this.Lio_circe_Encoder$__f_encodeBoolean = new $c_Lio_circe_Encoder$$anon$8();
}
export { $c_Lio_circe_Encoder$ as $c_Lio_circe_Encoder$ };
$c_Lio_circe_Encoder$.prototype = new $h_O();
$c_Lio_circe_Encoder$.prototype.constructor = $c_Lio_circe_Encoder$;
/** @constructor */
function $h_Lio_circe_Encoder$() {
}
export { $h_Lio_circe_Encoder$ as $h_Lio_circe_Encoder$ };
$h_Lio_circe_Encoder$.prototype = $c_Lio_circe_Encoder$.prototype;
$c_Lio_circe_Encoder$.prototype.encodeUUID__Lio_circe_Encoder = (function() {
  if ((!this.Lio_circe_Encoder$__f_encodeUUIDbitmap$1)) {
    this.Lio_circe_Encoder$__f_encodeUUID$lzy1 = new $c_Lio_circe_Encoder$$anon$23();
    this.Lio_circe_Encoder$__f_encodeUUIDbitmap$1 = true;
  }
  return this.Lio_circe_Encoder$__f_encodeUUID$lzy1;
});
$c_Lio_circe_Encoder$.prototype.encodeMap__Lio_circe_KeyEncoder__Lio_circe_Encoder__Lio_circe_Encoder$AsObject = (function(encodeK, encodeV) {
  var ev = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => x));
  return new $c_Lio_circe_Encoder$$anon$38(encodeK, encodeV, ev);
});
var $d_Lio_circe_Encoder$ = new $TypeData().initClass($c_Lio_circe_Encoder$, "io.circe.Encoder$", ({
  Lio_circe_Encoder$: 1,
  Lio_circe_TupleEncoders: 1,
  Lio_circe_ProductEncoders: 1,
  Lio_circe_ProductTypedEncoders: 1,
  Lio_circe_LiteralEncoders: 1,
  Lio_circe_EnumerationEncoders: 1,
  Lio_circe_LowPriorityEncoders: 1,
  Lio_circe_MidPriorityEncoders: 1,
  Lio_circe_EncoderDerivationRelaxed: 1
}));
export { $d_Lio_circe_Encoder$ as $d_Lio_circe_Encoder$ };
var $n_Lio_circe_Encoder$;
function $m_Lio_circe_Encoder$() {
  if ((!$n_Lio_circe_Encoder$)) {
    $n_Lio_circe_Encoder$ = new $c_Lio_circe_Encoder$();
  }
  return $n_Lio_circe_Encoder$;
}
export { $m_Lio_circe_Encoder$ as $m_Lio_circe_Encoder$ };
function $ct_Ljava_time_DayOfWeek__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_DayOfWeek__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_DayOfWeek__T__I__T__I__ as $ct_Ljava_time_DayOfWeek__T__I__T__I__ };
/** @constructor */
function $c_Ljava_time_DayOfWeek() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
}
export { $c_Ljava_time_DayOfWeek as $c_Ljava_time_DayOfWeek };
$c_Ljava_time_DayOfWeek.prototype = new $h_jl_Enum();
$c_Ljava_time_DayOfWeek.prototype.constructor = $c_Ljava_time_DayOfWeek;
/** @constructor */
function $h_Ljava_time_DayOfWeek() {
}
export { $h_Ljava_time_DayOfWeek as $h_Ljava_time_DayOfWeek };
$h_Ljava_time_DayOfWeek.prototype = $c_Ljava_time_DayOfWeek.prototype;
$c_Ljava_time_DayOfWeek.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_DayOfWeek.prototype.getValue__I = (function() {
  return ((1 + this.Ljava_time_DayOfWeek__f_ordinal) | 0);
});
$c_Ljava_time_DayOfWeek.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()) : ((field !== null) && field.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)));
});
$c_Ljava_time_DayOfWeek.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    return field.range__Ljava_time_temporal_ValueRange();
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return field.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this);
  }
});
$c_Ljava_time_DayOfWeek.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return ((field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()) ? this.getValue__I() : this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(this.getLong__Ljava_time_temporal_TemporalField__J(field), field));
});
$c_Ljava_time_DayOfWeek.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    var value = this.getValue__I();
    var hi = (value >> 31);
    return new $c_RTLong(value, hi);
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return field.getFrom__Ljava_time_temporal_TemporalAccessor__J(this);
  }
});
$c_Ljava_time_DayOfWeek.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit() : (((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this)));
});
$c_Ljava_time_DayOfWeek.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var $x_1 = $s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
  var value = this.getValue__I();
  var hi = (value >> 31);
  return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($x_1, new $c_RTLong(value, hi));
});
var $d_Ljava_time_DayOfWeek = new $TypeData().initClass(0, "java.time.DayOfWeek", ({
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
}));
export { $d_Ljava_time_DayOfWeek as $d_Ljava_time_DayOfWeek };
function $ct_Ljava_time_Month__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.Ljava_time_Month__f_ordinal = ordinal;
  $ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_Month__T__I__T__I__ as $ct_Ljava_time_Month__T__I__T__I__ };
/** @constructor */
function $c_Ljava_time_Month() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
}
export { $c_Ljava_time_Month as $c_Ljava_time_Month };
$c_Ljava_time_Month.prototype = new $h_jl_Enum();
$c_Ljava_time_Month.prototype.constructor = $c_Ljava_time_Month;
/** @constructor */
function $h_Ljava_time_Month() {
}
export { $h_Ljava_time_Month as $h_Ljava_time_Month };
$h_Ljava_time_Month.prototype = $c_Ljava_time_Month.prototype;
$c_Ljava_time_Month.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Ljava_time_Month.prototype.getValue__I = (function() {
  return ((1 + this.Ljava_time_Month__f_ordinal) | 0);
});
$c_Ljava_time_Month.prototype.isSupported__Ljava_time_temporal_TemporalField__Z = (function(field) {
  return ((field instanceof $c_Ljava_time_temporal_ChronoField) ? (field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) : ((field !== null) && field.isSupportedBy__Ljava_time_temporal_TemporalAccessor__Z(this)));
});
$c_Ljava_time_Month.prototype.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    return field.range__Ljava_time_temporal_ValueRange();
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return field.rangeRefinedBy__Ljava_time_temporal_TemporalAccessor__Ljava_time_temporal_ValueRange(this);
  }
});
$c_Ljava_time_Month.prototype.get__Ljava_time_temporal_TemporalField__I = (function(field) {
  return ((field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) ? this.getValue__I() : this.range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(field).checkValidIntValue__J__Ljava_time_temporal_TemporalField__I(this.getLong__Ljava_time_temporal_TemporalField__J(field), field));
});
$c_Ljava_time_Month.prototype.getLong__Ljava_time_temporal_TemporalField__J = (function(field) {
  if ((field === $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    var value = this.getValue__I();
    var hi = (value >> 31);
    return new $c_RTLong(value, hi);
  } else if ((field instanceof $c_Ljava_time_temporal_ChronoField)) {
    throw new $c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return field.getFrom__Ljava_time_temporal_TemporalAccessor__J(this);
  }
});
$c_Ljava_time_Month.prototype.plus__J__Ljava_time_Month = (function(months) {
  var this$1 = $m_RTLong$();
  var lo = this$1.remainderImpl__I__I__I__I__I(months.RTLong__f_lo, months.RTLong__f_hi, 12, 0);
  return $m_Ljava_time_Month$().java$time$Month$$$ENUMS__ALjava_time_Month().u[((((this.Ljava_time_Month__f_ordinal + ((12 + lo) | 0)) | 0) % 12) | 0)];
});
$c_Ljava_time_Month.prototype.length__Z__I = (function(leapYear) {
  var x = $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month();
  if (((x !== null) && (x === this))) {
    return (leapYear ? 29 : 28);
  }
  matchAlts1: {
    matchAlts2: {
      var x$3 = $s_Ljava_time_Month$__APRIL__Ljava_time_Month();
      if (((x$3 !== null) && (x$3 === this))) {
        break matchAlts2;
      }
      var x$5 = $s_Ljava_time_Month$__JUNE__Ljava_time_Month();
      if (((x$5 !== null) && (x$5 === this))) {
        break matchAlts2;
      }
      var x$7 = $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month();
      if (((x$7 !== null) && (x$7 === this))) {
        break matchAlts2;
      }
      var x$9 = $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month();
      if (((x$9 !== null) && (x$9 === this))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return 30;
  }
  return 31;
});
$c_Ljava_time_Month.prototype.firstDayOfYear__Z__I = (function(leapYear) {
  var leap = (leapYear ? 1 : 0);
  var x = $s_Ljava_time_Month$__JANUARY__Ljava_time_Month();
  if (((x !== null) && (x === this))) {
    return 1;
  }
  var x$3 = $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month();
  if (((x$3 !== null) && (x$3 === this))) {
    return 32;
  }
  var x$5 = $s_Ljava_time_Month$__MARCH__Ljava_time_Month();
  if (((x$5 !== null) && (x$5 === this))) {
    return ((60 + leap) | 0);
  }
  var x$7 = $s_Ljava_time_Month$__APRIL__Ljava_time_Month();
  if (((x$7 !== null) && (x$7 === this))) {
    return ((91 + leap) | 0);
  }
  var x$9 = $s_Ljava_time_Month$__MAY__Ljava_time_Month();
  if (((x$9 !== null) && (x$9 === this))) {
    return ((121 + leap) | 0);
  }
  var x$11 = $s_Ljava_time_Month$__JUNE__Ljava_time_Month();
  if (((x$11 !== null) && (x$11 === this))) {
    return ((152 + leap) | 0);
  }
  var x$13 = $s_Ljava_time_Month$__JULY__Ljava_time_Month();
  if (((x$13 !== null) && (x$13 === this))) {
    return ((182 + leap) | 0);
  }
  var x$15 = $s_Ljava_time_Month$__AUGUST__Ljava_time_Month();
  if (((x$15 !== null) && (x$15 === this))) {
    return ((213 + leap) | 0);
  }
  var x$17 = $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month();
  if (((x$17 !== null) && (x$17 === this))) {
    return ((244 + leap) | 0);
  }
  var x$19 = $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month();
  if (((x$19 !== null) && (x$19 === this))) {
    return ((274 + leap) | 0);
  }
  var x$21 = $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month();
  if (((x$21 !== null) && (x$21 === this))) {
    return ((305 + leap) | 0);
  }
  var x$23 = $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month();
  if (((x$23 !== null) && (x$23 === this))) {
    return ((335 + leap) | 0);
  }
  throw new $c_s_MatchError(this);
});
$c_Ljava_time_Month.prototype.query__Ljava_time_temporal_TemporalQuery__O = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().chronology__Ljava_time_temporal_TemporalQuery()) ? $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology() : ((query === $m_Ljava_time_temporal_TemporalQueries$().precision__Ljava_time_temporal_TemporalQuery()) ? $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit() : ((((((query === $m_Ljava_time_temporal_TemporalQueries$().localDate__Ljava_time_temporal_TemporalQuery()) || (query === $m_Ljava_time_temporal_TemporalQueries$().localTime__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zone__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().zoneId__Ljava_time_temporal_TemporalQuery())) || (query === $m_Ljava_time_temporal_TemporalQueries$().offset__Ljava_time_temporal_TemporalQuery())) ? null : query.queryFrom__Ljava_time_temporal_TemporalAccessor__O(this))));
});
$c_Ljava_time_Month.prototype.adjustInto__Ljava_time_temporal_Temporal__Ljava_time_temporal_Temporal = (function(temporal) {
  var x = $m_Ljava_time_chrono_Chronology$().from__Ljava_time_temporal_TemporalAccessor__Ljava_time_chrono_Chronology(temporal);
  var x$2 = $m_Ljava_time_chrono_IsoChronology$().INSTANCE__Ljava_time_chrono_IsoChronology();
  if ((!((x === null) ? (x$2 === null) : $f_Ljava_time_chrono_Chronology__equals__O__Z(x, x$2)))) {
    throw $ct_Ljava_time_DateTimeException__T__(new $c_Ljava_time_DateTimeException(), "Adjustment only supported on ISO date-time");
  } else {
    var $x_1 = $s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var value = this.getValue__I();
    var hi = (value >> 31);
    return temporal.with__Ljava_time_temporal_TemporalField__J__Ljava_time_temporal_Temporal($x_1, new $c_RTLong(value, hi));
  }
});
var $d_Ljava_time_Month = new $TypeData().initClass(0, "java.time.Month", ({
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1
}));
export { $d_Ljava_time_Month as $d_Ljava_time_Month };
/** @constructor */
function $c_ju_Collections$$anon$2() {
}
export { $c_ju_Collections$$anon$2 as $c_ju_Collections$$anon$2 };
$c_ju_Collections$$anon$2.prototype = new $h_ju_AbstractList();
$c_ju_Collections$$anon$2.prototype.constructor = $c_ju_Collections$$anon$2;
/** @constructor */
function $h_ju_Collections$$anon$2() {
}
export { $h_ju_Collections$$anon$2 as $h_ju_Collections$$anon$2 };
$h_ju_Collections$$anon$2.prototype = $c_ju_Collections$$anon$2.prototype;
$c_ju_Collections$$anon$2.prototype.get__I__O = (function(index) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
});
$c_ju_Collections$$anon$2.prototype.size__I = (function() {
  return 0;
});
var $d_ju_Collections$$anon$2 = new $TypeData().initClass($c_ju_Collections$$anon$2, "java.util.Collections$$anon$2", ({
  ju_Collections$$anon$2: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_SequencedCollection: 1,
  Ljava_io_Serializable: 1,
  ju_RandomAccess: 1
}));
export { $d_ju_Collections$$anon$2 as $d_ju_Collections$$anon$2 };
/** @constructor */
function $c_ju_Collections$UnmodifiableSet(inner) {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false;
  $ct_ju_Collections$UnmodifiableCollection__ju_Collection__(this, inner);
}
export { $c_ju_Collections$UnmodifiableSet as $c_ju_Collections$UnmodifiableSet };
$c_ju_Collections$UnmodifiableSet.prototype = new $h_ju_Collections$UnmodifiableCollection();
$c_ju_Collections$UnmodifiableSet.prototype.constructor = $c_ju_Collections$UnmodifiableSet;
/** @constructor */
function $h_ju_Collections$UnmodifiableSet() {
}
export { $h_ju_Collections$UnmodifiableSet as $h_ju_Collections$UnmodifiableSet };
$h_ju_Collections$UnmodifiableSet.prototype = $c_ju_Collections$UnmodifiableSet.prototype;
$c_ju_Collections$UnmodifiableSet.prototype.equals__O__Z = (function(obj) {
  return this.ju_Collections$UnmodifiableCollection__f_inner.equals__O__Z(obj);
});
$c_ju_Collections$UnmodifiableSet.prototype.hashCode__I = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.hashCode__I();
});
var $d_ju_Collections$UnmodifiableSet = new $TypeData().initClass($c_ju_Collections$UnmodifiableSet, "java.util.Collections$UnmodifiableSet", ({
  ju_Collections$UnmodifiableSet: 1,
  ju_Collections$UnmodifiableCollection: 1,
  ju_Collections$WrappedCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  Ljava_io_Serializable: 1,
  ju_Collections$WrappedSet: 1,
  ju_Collections$WrappedEquals: 1,
  ju_Set: 1
}));
export { $d_ju_Collections$UnmodifiableSet as $d_ju_Collections$UnmodifiableSet };
/** @constructor */
function $c_sc_AbstractView() {
}
export { $c_sc_AbstractView as $c_sc_AbstractView };
$c_sc_AbstractView.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractView.prototype.constructor = $c_sc_AbstractView;
/** @constructor */
function $h_sc_AbstractView() {
}
export { $h_sc_AbstractView as $h_sc_AbstractView };
$h_sc_AbstractView.prototype = $c_sc_AbstractView.prototype;
$c_sc_AbstractView.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$();
});
$c_sc_AbstractView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_AbstractView.prototype.stringPrefix__T = (function() {
  return "View";
});
/** @constructor */
function $c_sc_MapOps$$anon$1(outer) {
  this.sc_MapOps$$anon$1__f_$outer = null;
  this.sc_MapOps$$anon$1__f_$outer = outer;
}
export { $c_sc_MapOps$$anon$1 as $c_sc_MapOps$$anon$1 };
$c_sc_MapOps$$anon$1.prototype = new $h_sc_AbstractIterable();
$c_sc_MapOps$$anon$1.prototype.constructor = $c_sc_MapOps$$anon$1;
/** @constructor */
function $h_sc_MapOps$$anon$1() {
}
export { $h_sc_MapOps$$anon$1 as $h_sc_MapOps$$anon$1 };
$h_sc_MapOps$$anon$1.prototype = $c_sc_MapOps$$anon$1.prototype;
$c_sc_MapOps$$anon$1.prototype.knownSize__I = (function() {
  return this.sc_MapOps$$anon$1__f_$outer.knownSize__I();
});
$c_sc_MapOps$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return this.sc_MapOps$$anon$1__f_$outer.valuesIterator__sc_Iterator();
});
var $d_sc_MapOps$$anon$1 = new $TypeData().initClass($c_sc_MapOps$$anon$1, "scala.collection.MapOps$$anon$1", ({
  sc_MapOps$$anon$1: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_MapOps$$anon$1 as $d_sc_MapOps$$anon$1 };
function $f_sc_Set__equals__O__Z($thiz, that) {
  if (($thiz === that)) {
    return true;
  } else if ($is_sc_Set(that)) {
    if (($thiz.size__I() === that.size__I())) {
      try {
        return $thiz.subsetOf__sc_Set__Z(that);
      } catch (e) {
        if ((e instanceof $c_jl_ClassCastException)) {
          return false;
        } else {
          throw e;
        }
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}
export { $f_sc_Set__equals__O__Z as $f_sc_Set__equals__O__Z };
function $is_sc_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Set)));
}
export { $is_sc_Set as $is_sc_Set };
function $isArrayOf_sc_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Set)));
}
export { $isArrayOf_sc_Set as $isArrayOf_sc_Set };
function $is_s_math_Numeric$BigDecimalAsIfIntegral(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.s_math_Numeric$BigDecimalAsIfIntegral)));
}
export { $is_s_math_Numeric$BigDecimalAsIfIntegral as $is_s_math_Numeric$BigDecimalAsIfIntegral };
function $isArrayOf_s_math_Numeric$BigDecimalAsIfIntegral(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.s_math_Numeric$BigDecimalAsIfIntegral)));
}
export { $isArrayOf_s_math_Numeric$BigDecimalAsIfIntegral as $isArrayOf_s_math_Numeric$BigDecimalAsIfIntegral };
/** @constructor */
function $c_s_reflect_ManifestFactory$AnyManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Any";
}
export { $c_s_reflect_ManifestFactory$AnyManifest$ as $c_s_reflect_ManifestFactory$AnyManifest$ };
$c_s_reflect_ManifestFactory$AnyManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$AnyManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$AnyManifest$() {
}
export { $h_s_reflect_ManifestFactory$AnyManifest$ as $h_s_reflect_ManifestFactory$AnyManifest$ };
$h_s_reflect_ManifestFactory$AnyManifest$.prototype = $c_s_reflect_ManifestFactory$AnyManifest$.prototype;
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf();
});
$c_s_reflect_ManifestFactory$AnyManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$AnyManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$AnyManifest$, "scala.reflect.ManifestFactory$AnyManifest$", ({
  s_reflect_ManifestFactory$AnyManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$AnyManifest$ as $d_s_reflect_ManifestFactory$AnyManifest$ };
var $n_s_reflect_ManifestFactory$AnyManifest$;
function $m_s_reflect_ManifestFactory$AnyManifest$() {
  if ((!$n_s_reflect_ManifestFactory$AnyManifest$)) {
    $n_s_reflect_ManifestFactory$AnyManifest$ = new $c_s_reflect_ManifestFactory$AnyManifest$();
  }
  return $n_s_reflect_ManifestFactory$AnyManifest$;
}
export { $m_s_reflect_ManifestFactory$AnyManifest$ as $m_s_reflect_ManifestFactory$AnyManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$BooleanManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Boolean";
}
export { $c_s_reflect_ManifestFactory$BooleanManifest$ as $c_s_reflect_ManifestFactory$BooleanManifest$ };
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype = new $h_s_reflect_ManifestFactory$BooleanManifest();
$c_s_reflect_ManifestFactory$BooleanManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$BooleanManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$BooleanManifest$() {
}
export { $h_s_reflect_ManifestFactory$BooleanManifest$ as $h_s_reflect_ManifestFactory$BooleanManifest$ };
$h_s_reflect_ManifestFactory$BooleanManifest$.prototype = $c_s_reflect_ManifestFactory$BooleanManifest$.prototype;
var $d_s_reflect_ManifestFactory$BooleanManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$BooleanManifest$, "scala.reflect.ManifestFactory$BooleanManifest$", ({
  s_reflect_ManifestFactory$BooleanManifest$: 1,
  s_reflect_ManifestFactory$BooleanManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$BooleanManifest$ as $d_s_reflect_ManifestFactory$BooleanManifest$ };
var $n_s_reflect_ManifestFactory$BooleanManifest$;
function $m_s_reflect_ManifestFactory$BooleanManifest$() {
  if ((!$n_s_reflect_ManifestFactory$BooleanManifest$)) {
    $n_s_reflect_ManifestFactory$BooleanManifest$ = new $c_s_reflect_ManifestFactory$BooleanManifest$();
  }
  return $n_s_reflect_ManifestFactory$BooleanManifest$;
}
export { $m_s_reflect_ManifestFactory$BooleanManifest$ as $m_s_reflect_ManifestFactory$BooleanManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$ByteManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Byte";
}
export { $c_s_reflect_ManifestFactory$ByteManifest$ as $c_s_reflect_ManifestFactory$ByteManifest$ };
$c_s_reflect_ManifestFactory$ByteManifest$.prototype = new $h_s_reflect_ManifestFactory$ByteManifest();
$c_s_reflect_ManifestFactory$ByteManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ByteManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ByteManifest$() {
}
export { $h_s_reflect_ManifestFactory$ByteManifest$ as $h_s_reflect_ManifestFactory$ByteManifest$ };
$h_s_reflect_ManifestFactory$ByteManifest$.prototype = $c_s_reflect_ManifestFactory$ByteManifest$.prototype;
var $d_s_reflect_ManifestFactory$ByteManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$ByteManifest$, "scala.reflect.ManifestFactory$ByteManifest$", ({
  s_reflect_ManifestFactory$ByteManifest$: 1,
  s_reflect_ManifestFactory$ByteManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$ByteManifest$ as $d_s_reflect_ManifestFactory$ByteManifest$ };
var $n_s_reflect_ManifestFactory$ByteManifest$;
function $m_s_reflect_ManifestFactory$ByteManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ByteManifest$)) {
    $n_s_reflect_ManifestFactory$ByteManifest$ = new $c_s_reflect_ManifestFactory$ByteManifest$();
  }
  return $n_s_reflect_ManifestFactory$ByteManifest$;
}
export { $m_s_reflect_ManifestFactory$ByteManifest$ as $m_s_reflect_ManifestFactory$ByteManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$CharManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Char";
}
export { $c_s_reflect_ManifestFactory$CharManifest$ as $c_s_reflect_ManifestFactory$CharManifest$ };
$c_s_reflect_ManifestFactory$CharManifest$.prototype = new $h_s_reflect_ManifestFactory$CharManifest();
$c_s_reflect_ManifestFactory$CharManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$CharManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$CharManifest$() {
}
export { $h_s_reflect_ManifestFactory$CharManifest$ as $h_s_reflect_ManifestFactory$CharManifest$ };
$h_s_reflect_ManifestFactory$CharManifest$.prototype = $c_s_reflect_ManifestFactory$CharManifest$.prototype;
var $d_s_reflect_ManifestFactory$CharManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$CharManifest$, "scala.reflect.ManifestFactory$CharManifest$", ({
  s_reflect_ManifestFactory$CharManifest$: 1,
  s_reflect_ManifestFactory$CharManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$CharManifest$ as $d_s_reflect_ManifestFactory$CharManifest$ };
var $n_s_reflect_ManifestFactory$CharManifest$;
function $m_s_reflect_ManifestFactory$CharManifest$() {
  if ((!$n_s_reflect_ManifestFactory$CharManifest$)) {
    $n_s_reflect_ManifestFactory$CharManifest$ = new $c_s_reflect_ManifestFactory$CharManifest$();
  }
  return $n_s_reflect_ManifestFactory$CharManifest$;
}
export { $m_s_reflect_ManifestFactory$CharManifest$ as $m_s_reflect_ManifestFactory$CharManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$DoubleManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Double";
}
export { $c_s_reflect_ManifestFactory$DoubleManifest$ as $c_s_reflect_ManifestFactory$DoubleManifest$ };
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype = new $h_s_reflect_ManifestFactory$DoubleManifest();
$c_s_reflect_ManifestFactory$DoubleManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$DoubleManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$DoubleManifest$() {
}
export { $h_s_reflect_ManifestFactory$DoubleManifest$ as $h_s_reflect_ManifestFactory$DoubleManifest$ };
$h_s_reflect_ManifestFactory$DoubleManifest$.prototype = $c_s_reflect_ManifestFactory$DoubleManifest$.prototype;
var $d_s_reflect_ManifestFactory$DoubleManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$DoubleManifest$, "scala.reflect.ManifestFactory$DoubleManifest$", ({
  s_reflect_ManifestFactory$DoubleManifest$: 1,
  s_reflect_ManifestFactory$DoubleManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$DoubleManifest$ as $d_s_reflect_ManifestFactory$DoubleManifest$ };
var $n_s_reflect_ManifestFactory$DoubleManifest$;
function $m_s_reflect_ManifestFactory$DoubleManifest$() {
  if ((!$n_s_reflect_ManifestFactory$DoubleManifest$)) {
    $n_s_reflect_ManifestFactory$DoubleManifest$ = new $c_s_reflect_ManifestFactory$DoubleManifest$();
  }
  return $n_s_reflect_ManifestFactory$DoubleManifest$;
}
export { $m_s_reflect_ManifestFactory$DoubleManifest$ as $m_s_reflect_ManifestFactory$DoubleManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$FloatManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Float";
}
export { $c_s_reflect_ManifestFactory$FloatManifest$ as $c_s_reflect_ManifestFactory$FloatManifest$ };
$c_s_reflect_ManifestFactory$FloatManifest$.prototype = new $h_s_reflect_ManifestFactory$FloatManifest();
$c_s_reflect_ManifestFactory$FloatManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$FloatManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$FloatManifest$() {
}
export { $h_s_reflect_ManifestFactory$FloatManifest$ as $h_s_reflect_ManifestFactory$FloatManifest$ };
$h_s_reflect_ManifestFactory$FloatManifest$.prototype = $c_s_reflect_ManifestFactory$FloatManifest$.prototype;
var $d_s_reflect_ManifestFactory$FloatManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$FloatManifest$, "scala.reflect.ManifestFactory$FloatManifest$", ({
  s_reflect_ManifestFactory$FloatManifest$: 1,
  s_reflect_ManifestFactory$FloatManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$FloatManifest$ as $d_s_reflect_ManifestFactory$FloatManifest$ };
var $n_s_reflect_ManifestFactory$FloatManifest$;
function $m_s_reflect_ManifestFactory$FloatManifest$() {
  if ((!$n_s_reflect_ManifestFactory$FloatManifest$)) {
    $n_s_reflect_ManifestFactory$FloatManifest$ = new $c_s_reflect_ManifestFactory$FloatManifest$();
  }
  return $n_s_reflect_ManifestFactory$FloatManifest$;
}
export { $m_s_reflect_ManifestFactory$FloatManifest$ as $m_s_reflect_ManifestFactory$FloatManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$IntManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Int";
}
export { $c_s_reflect_ManifestFactory$IntManifest$ as $c_s_reflect_ManifestFactory$IntManifest$ };
$c_s_reflect_ManifestFactory$IntManifest$.prototype = new $h_s_reflect_ManifestFactory$IntManifest();
$c_s_reflect_ManifestFactory$IntManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$IntManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$IntManifest$() {
}
export { $h_s_reflect_ManifestFactory$IntManifest$ as $h_s_reflect_ManifestFactory$IntManifest$ };
$h_s_reflect_ManifestFactory$IntManifest$.prototype = $c_s_reflect_ManifestFactory$IntManifest$.prototype;
var $d_s_reflect_ManifestFactory$IntManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$IntManifest$, "scala.reflect.ManifestFactory$IntManifest$", ({
  s_reflect_ManifestFactory$IntManifest$: 1,
  s_reflect_ManifestFactory$IntManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$IntManifest$ as $d_s_reflect_ManifestFactory$IntManifest$ };
var $n_s_reflect_ManifestFactory$IntManifest$;
function $m_s_reflect_ManifestFactory$IntManifest$() {
  if ((!$n_s_reflect_ManifestFactory$IntManifest$)) {
    $n_s_reflect_ManifestFactory$IntManifest$ = new $c_s_reflect_ManifestFactory$IntManifest$();
  }
  return $n_s_reflect_ManifestFactory$IntManifest$;
}
export { $m_s_reflect_ManifestFactory$IntManifest$ as $m_s_reflect_ManifestFactory$IntManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$LongManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Long";
}
export { $c_s_reflect_ManifestFactory$LongManifest$ as $c_s_reflect_ManifestFactory$LongManifest$ };
$c_s_reflect_ManifestFactory$LongManifest$.prototype = new $h_s_reflect_ManifestFactory$LongManifest();
$c_s_reflect_ManifestFactory$LongManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$LongManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$LongManifest$() {
}
export { $h_s_reflect_ManifestFactory$LongManifest$ as $h_s_reflect_ManifestFactory$LongManifest$ };
$h_s_reflect_ManifestFactory$LongManifest$.prototype = $c_s_reflect_ManifestFactory$LongManifest$.prototype;
var $d_s_reflect_ManifestFactory$LongManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$LongManifest$, "scala.reflect.ManifestFactory$LongManifest$", ({
  s_reflect_ManifestFactory$LongManifest$: 1,
  s_reflect_ManifestFactory$LongManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$LongManifest$ as $d_s_reflect_ManifestFactory$LongManifest$ };
var $n_s_reflect_ManifestFactory$LongManifest$;
function $m_s_reflect_ManifestFactory$LongManifest$() {
  if ((!$n_s_reflect_ManifestFactory$LongManifest$)) {
    $n_s_reflect_ManifestFactory$LongManifest$ = new $c_s_reflect_ManifestFactory$LongManifest$();
  }
  return $n_s_reflect_ManifestFactory$LongManifest$;
}
export { $m_s_reflect_ManifestFactory$LongManifest$ as $m_s_reflect_ManifestFactory$LongManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$NothingManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Nothing";
}
export { $c_s_reflect_ManifestFactory$NothingManifest$ as $c_s_reflect_ManifestFactory$NothingManifest$ };
$c_s_reflect_ManifestFactory$NothingManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NothingManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NothingManifest$() {
}
export { $h_s_reflect_ManifestFactory$NothingManifest$ as $h_s_reflect_ManifestFactory$NothingManifest$ };
$h_s_reflect_ManifestFactory$NothingManifest$.prototype = $c_s_reflect_ManifestFactory$NothingManifest$.prototype;
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Nothing$.getClassOf();
});
$c_s_reflect_ManifestFactory$NothingManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$NothingManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$NothingManifest$, "scala.reflect.ManifestFactory$NothingManifest$", ({
  s_reflect_ManifestFactory$NothingManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$NothingManifest$ as $d_s_reflect_ManifestFactory$NothingManifest$ };
var $n_s_reflect_ManifestFactory$NothingManifest$;
function $m_s_reflect_ManifestFactory$NothingManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NothingManifest$)) {
    $n_s_reflect_ManifestFactory$NothingManifest$ = new $c_s_reflect_ManifestFactory$NothingManifest$();
  }
  return $n_s_reflect_ManifestFactory$NothingManifest$;
}
export { $m_s_reflect_ManifestFactory$NothingManifest$ as $m_s_reflect_ManifestFactory$NothingManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$NullManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Null";
}
export { $c_s_reflect_ManifestFactory$NullManifest$ as $c_s_reflect_ManifestFactory$NullManifest$ };
$c_s_reflect_ManifestFactory$NullManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$NullManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$NullManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$NullManifest$() {
}
export { $h_s_reflect_ManifestFactory$NullManifest$ as $h_s_reflect_ManifestFactory$NullManifest$ };
$h_s_reflect_ManifestFactory$NullManifest$.prototype = $c_s_reflect_ManifestFactory$NullManifest$.prototype;
$c_s_reflect_ManifestFactory$NullManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_sr_Null$.getClassOf();
});
$c_s_reflect_ManifestFactory$NullManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$NullManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$NullManifest$, "scala.reflect.ManifestFactory$NullManifest$", ({
  s_reflect_ManifestFactory$NullManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$NullManifest$ as $d_s_reflect_ManifestFactory$NullManifest$ };
var $n_s_reflect_ManifestFactory$NullManifest$;
function $m_s_reflect_ManifestFactory$NullManifest$() {
  if ((!$n_s_reflect_ManifestFactory$NullManifest$)) {
    $n_s_reflect_ManifestFactory$NullManifest$ = new $c_s_reflect_ManifestFactory$NullManifest$();
  }
  return $n_s_reflect_ManifestFactory$NullManifest$;
}
export { $m_s_reflect_ManifestFactory$NullManifest$ as $m_s_reflect_ManifestFactory$NullManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$ObjectManifest$() {
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = null;
  this.s_reflect_ManifestFactory$PhantomManifest__f_toString = "Object";
}
export { $c_s_reflect_ManifestFactory$ObjectManifest$ as $c_s_reflect_ManifestFactory$ObjectManifest$ };
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype = new $h_s_reflect_ManifestFactory$PhantomManifest();
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ObjectManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ObjectManifest$() {
}
export { $h_s_reflect_ManifestFactory$ObjectManifest$ as $h_s_reflect_ManifestFactory$ObjectManifest$ };
$h_s_reflect_ManifestFactory$ObjectManifest$.prototype = $c_s_reflect_ManifestFactory$ObjectManifest$.prototype;
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.runtimeClass__jl_Class = (function() {
  return $d_O.getClassOf();
});
$c_s_reflect_ManifestFactory$ObjectManifest$.prototype.newArray__I__O = (function(len) {
  return new $ac_O(len);
});
var $d_s_reflect_ManifestFactory$ObjectManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$ObjectManifest$, "scala.reflect.ManifestFactory$ObjectManifest$", ({
  s_reflect_ManifestFactory$ObjectManifest$: 1,
  s_reflect_ManifestFactory$PhantomManifest: 1,
  s_reflect_ManifestFactory$ClassTypeManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$ObjectManifest$ as $d_s_reflect_ManifestFactory$ObjectManifest$ };
var $n_s_reflect_ManifestFactory$ObjectManifest$;
function $m_s_reflect_ManifestFactory$ObjectManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ObjectManifest$)) {
    $n_s_reflect_ManifestFactory$ObjectManifest$ = new $c_s_reflect_ManifestFactory$ObjectManifest$();
  }
  return $n_s_reflect_ManifestFactory$ObjectManifest$;
}
export { $m_s_reflect_ManifestFactory$ObjectManifest$ as $m_s_reflect_ManifestFactory$ObjectManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$ShortManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Short";
}
export { $c_s_reflect_ManifestFactory$ShortManifest$ as $c_s_reflect_ManifestFactory$ShortManifest$ };
$c_s_reflect_ManifestFactory$ShortManifest$.prototype = new $h_s_reflect_ManifestFactory$ShortManifest();
$c_s_reflect_ManifestFactory$ShortManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$ShortManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$ShortManifest$() {
}
export { $h_s_reflect_ManifestFactory$ShortManifest$ as $h_s_reflect_ManifestFactory$ShortManifest$ };
$h_s_reflect_ManifestFactory$ShortManifest$.prototype = $c_s_reflect_ManifestFactory$ShortManifest$.prototype;
var $d_s_reflect_ManifestFactory$ShortManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$ShortManifest$, "scala.reflect.ManifestFactory$ShortManifest$", ({
  s_reflect_ManifestFactory$ShortManifest$: 1,
  s_reflect_ManifestFactory$ShortManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$ShortManifest$ as $d_s_reflect_ManifestFactory$ShortManifest$ };
var $n_s_reflect_ManifestFactory$ShortManifest$;
function $m_s_reflect_ManifestFactory$ShortManifest$() {
  if ((!$n_s_reflect_ManifestFactory$ShortManifest$)) {
    $n_s_reflect_ManifestFactory$ShortManifest$ = new $c_s_reflect_ManifestFactory$ShortManifest$();
  }
  return $n_s_reflect_ManifestFactory$ShortManifest$;
}
export { $m_s_reflect_ManifestFactory$ShortManifest$ as $m_s_reflect_ManifestFactory$ShortManifest$ };
/** @constructor */
function $c_s_reflect_ManifestFactory$UnitManifest$() {
  this.s_reflect_AnyValManifest__f_toString = null;
  this.s_reflect_AnyValManifest__f_toString = "Unit";
}
export { $c_s_reflect_ManifestFactory$UnitManifest$ as $c_s_reflect_ManifestFactory$UnitManifest$ };
$c_s_reflect_ManifestFactory$UnitManifest$.prototype = new $h_s_reflect_ManifestFactory$UnitManifest();
$c_s_reflect_ManifestFactory$UnitManifest$.prototype.constructor = $c_s_reflect_ManifestFactory$UnitManifest$;
/** @constructor */
function $h_s_reflect_ManifestFactory$UnitManifest$() {
}
export { $h_s_reflect_ManifestFactory$UnitManifest$ as $h_s_reflect_ManifestFactory$UnitManifest$ };
$h_s_reflect_ManifestFactory$UnitManifest$.prototype = $c_s_reflect_ManifestFactory$UnitManifest$.prototype;
var $d_s_reflect_ManifestFactory$UnitManifest$ = new $TypeData().initClass($c_s_reflect_ManifestFactory$UnitManifest$, "scala.reflect.ManifestFactory$UnitManifest$", ({
  s_reflect_ManifestFactory$UnitManifest$: 1,
  s_reflect_ManifestFactory$UnitManifest: 1,
  s_reflect_AnyValManifest: 1,
  s_reflect_Manifest: 1,
  s_reflect_ClassTag: 1,
  s_reflect_ClassManifestDeprecatedApis: 1,
  s_reflect_OptManifest: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1
}));
export { $d_s_reflect_ManifestFactory$UnitManifest$ as $d_s_reflect_ManifestFactory$UnitManifest$ };
var $n_s_reflect_ManifestFactory$UnitManifest$;
function $m_s_reflect_ManifestFactory$UnitManifest$() {
  if ((!$n_s_reflect_ManifestFactory$UnitManifest$)) {
    $n_s_reflect_ManifestFactory$UnitManifest$ = new $c_s_reflect_ManifestFactory$UnitManifest$();
  }
  return $n_s_reflect_ManifestFactory$UnitManifest$;
}
export { $m_s_reflect_ManifestFactory$UnitManifest$ as $m_s_reflect_ManifestFactory$UnitManifest$ };
/** @constructor */
function $c_sr_RichInt(self) {
  this.sr_RichInt__f_self = 0;
  this.sr_RichInt__f_self = self;
}
export { $c_sr_RichInt as $c_sr_RichInt };
$c_sr_RichInt.prototype = new $h_O();
$c_sr_RichInt.prototype.constructor = $c_sr_RichInt;
/** @constructor */
function $h_sr_RichInt() {
}
export { $h_sr_RichInt as $h_sr_RichInt };
$h_sr_RichInt.prototype = $c_sr_RichInt.prototype;
$c_sr_RichInt.prototype.compare__O__I = (function(y) {
  $m_s_math_Ordering$Int$();
  var x = this.sr_RichInt__f_self;
  var y$1 = (y | 0);
  return ((x === y$1) ? 0 : ((x < y$1) ? (-1) : 1));
});
$c_sr_RichInt.prototype.compareTo__O__I = (function(that) {
  $m_s_math_Ordering$Int$();
  var x = this.sr_RichInt__f_self;
  var y = (that | 0);
  return ((x === y) ? 0 : ((x < y) ? (-1) : 1));
});
$c_sr_RichInt.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this);
});
$c_sr_RichInt.prototype.isValidByte__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidByte__Z(this);
});
$c_sr_RichInt.prototype.isValidShort__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidShort__Z(this);
});
$c_sr_RichInt.prototype.isValidChar__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidChar__Z(this);
});
$c_sr_RichInt.prototype.doubleValue__D = (function() {
  var this$ = this.sr_RichInt__f_self;
  return this$;
});
$c_sr_RichInt.prototype.floatValue__F = (function() {
  var this$ = this.sr_RichInt__f_self;
  return Math.fround(this$);
});
$c_sr_RichInt.prototype.longValue__J = (function() {
  var this$ = this.sr_RichInt__f_self;
  var hi = (this$ >> 31);
  return new $c_RTLong(this$, hi);
});
$c_sr_RichInt.prototype.intValue__I = (function() {
  var this$ = this.sr_RichInt__f_self;
  return this$;
});
$c_sr_RichInt.prototype.byteValue__B = (function() {
  var this$ = this.sr_RichInt__f_self;
  return ((this$ << 24) >> 24);
});
$c_sr_RichInt.prototype.shortValue__S = (function() {
  var this$ = this.sr_RichInt__f_self;
  return ((this$ << 16) >> 16);
});
$c_sr_RichInt.prototype.isWhole__Z = (function() {
  return true;
});
$c_sr_RichInt.prototype.isValidInt__Z = (function() {
  return true;
});
$c_sr_RichInt.prototype.hashCode__I = (function() {
  var this$ = this.sr_RichInt__f_self;
  return this$;
});
$c_sr_RichInt.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichInt$().equals$extension__I__O__Z(this.sr_RichInt__f_self, x$1);
});
$c_sr_RichInt.prototype.self__O = (function() {
  return this.sr_RichInt__f_self;
});
function $isArrayOf_sr_RichInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichInt)));
}
export { $isArrayOf_sr_RichInt as $isArrayOf_sr_RichInt };
var $d_sr_RichInt = new $TypeData().initClass($c_sr_RichInt, "scala.runtime.RichInt", ({
  sr_RichInt: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
}));
export { $d_sr_RichInt as $d_sr_RichInt };
function $p_Lscodec_bits_BitVector$Append__go$10__sci_List__J__J($thiz, rem, acc) {
  var lo = acc.RTLong__f_lo;
  var hi = acc.RTLong__f_hi;
  var acc$tailLocal3__lo = lo;
  var acc$tailLocal3__hi = hi;
  var rem$tailLocal1 = rem;
  while (true) {
    var x141 = rem$tailLocal1;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x141)) {
      return new $c_RTLong(acc$tailLocal3__lo, acc$tailLocal3__hi);
    }
    if ((x141 instanceof $c_sci_$colon$colon)) {
      var x159 = x141.sci_$colon$colon__f_head;
      var x160 = x141.sci_$colon$colon__f_next;
      if ((x159 instanceof $c_Lscodec_bits_BitVector$Append)) {
        var x163 = x159.Lscodec_bits_BitVector$Append__f_left;
        var x164 = x159.Lscodec_bits_BitVector$Append__f_right;
        var this$2 = new $c_sci_$colon$colon(x164, x160);
        rem$tailLocal1 = new $c_sci_$colon$colon(x163, this$2);
        continue;
      }
      if ((x159 instanceof $c_Lscodec_bits_BitVector$Chunks)) {
        var x154 = x159.Lscodec_bits_BitVector$Chunks__f_chunks;
        if ((x154 !== null)) {
          var x156 = x154.Lscodec_bits_BitVector$Append__f_left;
          var x157 = x154.Lscodec_bits_BitVector$Append__f_right;
          var this$5 = new $c_sci_$colon$colon(x157, x160);
          rem$tailLocal1 = new $c_sci_$colon$colon(x156, this$5);
          continue;
        }
      }
      if (false) {
        var elem$3 = x159.underlying__Lscodec_bits_BitVector();
        rem$tailLocal1 = new $c_sci_$colon$colon(elem$3, x160);
        continue;
      }
      var a__lo = acc$tailLocal3__lo;
      var a__hi = acc$tailLocal3__hi;
      var b = x159.size__J();
      var alo = a__lo;
      var blo = b.RTLong__f_lo;
      var lo$1 = ((alo + blo) | 0);
      var hi$1 = ((((a__hi + b.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo$1))) >>> 31) | 0)) | 0);
      rem$tailLocal1 = x160;
      var $x_1__lo = lo$1;
      var $x_1__hi = hi$1;
      acc$tailLocal3__lo = $x_1__lo;
      acc$tailLocal3__hi = $x_1__hi;
      continue;
    }
    throw new $c_s_MatchError(x141);
  }
}
export { $p_Lscodec_bits_BitVector$Append__go$10__sci_List__J__J as $p_Lscodec_bits_BitVector$Append__go$10__sci_List__J__J };
function $p_Lscodec_bits_BitVector$Append__go$11__Lscodec_bits_BitVector__Lscodec_bits_BitVector__J__Lscodec_bits_BitVector($thiz, accL, cur, n) {
  var lo = n.RTLong__f_lo;
  var hi = n.RTLong__f_hi;
  var n$tailLocal1__lo = lo;
  var n$tailLocal1__hi = hi;
  var cur$tailLocal1 = cur;
  var accL$tailLocal1 = accL;
  while (true) {
    var x165 = cur$tailLocal1;
    if ((x165 instanceof $c_Lscodec_bits_BitVector$Append)) {
      var x169 = x165.Lscodec_bits_BitVector$Append__f_left;
      var x170 = x165.Lscodec_bits_BitVector$Append__f_right;
      var a__lo = n$tailLocal1__lo;
      var a__hi = n$tailLocal1__hi;
      var b = x169.size__J();
      var ahi = a__hi;
      var bhi = b.RTLong__f_hi;
      if (((ahi === bhi) ? ((a__lo >>> 0) <= (b.RTLong__f_lo >>> 0)) : (ahi < bhi))) {
        return accL$tailLocal1.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(x169.take__J__Lscodec_bits_BitVector(new $c_RTLong(n$tailLocal1__lo, n$tailLocal1__hi)));
      } else {
        var accL$tailLocal1$tmp1 = accL$tailLocal1.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(x169);
        var a$1__lo = n$tailLocal1__lo;
        var a$1__hi = n$tailLocal1__hi;
        var b$1 = x169.size__J();
        var alo = a$1__lo;
        var blo = b$1.RTLong__f_lo;
        var lo$1 = ((alo - blo) | 0);
        var hi$1 = ((((a$1__hi - b$1.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo$1)) >> 31)) | 0);
        accL$tailLocal1 = accL$tailLocal1$tmp1;
        cur$tailLocal1 = x170;
        var $x_1__lo = lo$1;
        var $x_1__hi = hi$1;
        n$tailLocal1__lo = $x_1__lo;
        n$tailLocal1__hi = $x_1__hi;
        continue;
      }
    }
    if (false) {
      cur$tailLocal1 = x165.underlying__Lscodec_bits_BitVector();
      continue;
    }
    return accL$tailLocal1.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector(cur$tailLocal1.take__J__Lscodec_bits_BitVector(new $c_RTLong(n$tailLocal1__lo, n$tailLocal1__hi)));
  }
}
export { $p_Lscodec_bits_BitVector$Append__go$11__Lscodec_bits_BitVector__Lscodec_bits_BitVector__J__Lscodec_bits_BitVector as $p_Lscodec_bits_BitVector$Append__go$11__Lscodec_bits_BitVector__Lscodec_bits_BitVector__J__Lscodec_bits_BitVector };
function $p_Lscodec_bits_BitVector$Append__go$12__Lscodec_bits_BitVector__J__Lscodec_bits_BitVector($thiz, cur, n) {
  var lo = n.RTLong__f_lo;
  var hi = n.RTLong__f_hi;
  var n$tailLocal2__lo = lo;
  var n$tailLocal2__hi = hi;
  var cur$tailLocal2 = cur;
  while (true) {
    var x171 = cur$tailLocal2;
    if ((x171 instanceof $c_Lscodec_bits_BitVector$Append)) {
      var x175 = x171.Lscodec_bits_BitVector$Append__f_left;
      var x176 = x171.Lscodec_bits_BitVector$Append__f_right;
      var a__lo = n$tailLocal2__lo;
      var a__hi = n$tailLocal2__hi;
      var b = x175.size__J();
      var ahi = a__hi;
      var bhi = b.RTLong__f_hi;
      if (((ahi === bhi) ? ((a__lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
        var a$1__lo = n$tailLocal2__lo;
        var a$1__hi = n$tailLocal2__hi;
        var b$1 = x175.size__J();
        var alo = a$1__lo;
        var blo = b$1.RTLong__f_lo;
        var lo$1 = ((alo - blo) | 0);
        var hi$1 = ((((a$1__hi - b$1.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo$1)) >> 31)) | 0);
        cur$tailLocal2 = x176;
        var $x_1__lo = lo$1;
        var $x_1__hi = hi$1;
        n$tailLocal2__lo = $x_1__lo;
        n$tailLocal2__hi = $x_1__hi;
        continue;
      } else {
        var left = x175.drop__J__Lscodec_bits_BitVector(new $c_RTLong(n$tailLocal2__lo, n$tailLocal2__hi));
        return new $c_Lscodec_bits_BitVector$Append(left, x176);
      }
    }
    if (false) {
      cur$tailLocal2 = x171.underlying__Lscodec_bits_BitVector();
      continue;
    }
    return cur$tailLocal2.drop__J__Lscodec_bits_BitVector(new $c_RTLong(n$tailLocal2__lo, n$tailLocal2__hi));
  }
}
export { $p_Lscodec_bits_BitVector$Append__go$12__Lscodec_bits_BitVector__J__Lscodec_bits_BitVector as $p_Lscodec_bits_BitVector$Append__go$12__Lscodec_bits_BitVector__J__Lscodec_bits_BitVector };
function $p_Lscodec_bits_BitVector$Append__go$13__Lscodec_bits_BitVector__J__J__Z($thiz, cur, n, seen) {
  var lo = seen.RTLong__f_lo;
  var hi = seen.RTLong__f_hi;
  var seen$tailLocal1__lo = lo;
  var seen$tailLocal1__hi = hi;
  var lo$1 = n.RTLong__f_lo;
  var hi$1 = n.RTLong__f_hi;
  var n$tailLocal3__lo = lo$1;
  var n$tailLocal3__hi = hi$1;
  var cur$tailLocal3 = cur;
  while (true) {
    var x177 = cur$tailLocal3;
    if ((x177 instanceof $c_Lscodec_bits_BitVector$Append)) {
      var x181 = x177.Lscodec_bits_BitVector$Append__f_left;
      var x182 = x177.Lscodec_bits_BitVector$Append__f_right;
      var a = x181.size__J();
      var b__lo = n$tailLocal3__lo;
      var b__hi = n$tailLocal3__hi;
      var ahi = a.RTLong__f_hi;
      var bhi = b__hi;
      if (((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) >= (b__lo >>> 0)) : (ahi > bhi))) {
        var a$1__lo = seen$tailLocal1__lo;
        var a$1__hi = seen$tailLocal1__hi;
        var b$1 = x181.size__J();
        var alo = a$1__lo;
        var blo = b$1.RTLong__f_lo;
        var lo$2 = ((alo + blo) | 0);
        var hi$2 = ((((a$1__hi + b$1.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo$2))) >>> 31) | 0)) | 0);
        var t = $thiz.Lscodec_bits_BitVector$Append__f_sizeLowerBound;
        var lo$3 = t.RTLong__f_lo;
        var hi$3 = t.RTLong__f_hi;
        if (((hi$2 === hi$3) ? ((lo$2 >>> 0) > (lo$3 >>> 0)) : (hi$2 > hi$3))) {
          var x__lo = lo$2;
          var x__hi = hi$2;
        } else {
          var x__lo = lo$3;
          var x__hi = hi$3;
        }
        $thiz.Lscodec_bits_BitVector$Append__f_sizeLowerBound = new $c_RTLong(x__lo, x__hi);
        return false;
      } else {
        var a$2__lo = n$tailLocal3__lo;
        var a$2__hi = n$tailLocal3__hi;
        var b$2 = x181.size__J();
        var alo$1 = a$2__lo;
        var blo$1 = b$2.RTLong__f_lo;
        var lo$4 = ((alo$1 - blo$1) | 0);
        var hi$4 = ((((a$2__hi - b$2.RTLong__f_hi) | 0) + ((((~alo$1) & blo$1) | ((~(alo$1 ^ blo$1)) & lo$4)) >> 31)) | 0);
        var a$3__lo = seen$tailLocal1__lo;
        var a$3__hi = seen$tailLocal1__hi;
        var b$3 = x181.size__J();
        var alo$2 = a$3__lo;
        var blo$2 = b$3.RTLong__f_lo;
        var lo$5 = ((alo$2 + blo$2) | 0);
        var hi$5 = ((((a$3__hi + b$3.RTLong__f_hi) | 0) + ((((alo$2 & blo$2) | ((alo$2 | blo$2) & (~lo$5))) >>> 31) | 0)) | 0);
        cur$tailLocal3 = x182;
        var $x_1__lo = lo$4;
        var $x_1__hi = hi$4;
        n$tailLocal3__lo = $x_1__lo;
        n$tailLocal3__hi = $x_1__hi;
        var $x_2__lo = lo$5;
        var $x_2__hi = hi$5;
        seen$tailLocal1__lo = $x_2__lo;
        seen$tailLocal1__hi = $x_2__hi;
        continue;
      }
    }
    if (false) {
      cur$tailLocal3 = x177.underlying__Lscodec_bits_BitVector();
      continue;
    }
    var x$1__lo = seen$tailLocal1__lo;
    var x$1__hi = seen$tailLocal1__hi;
    var t$1 = $thiz.Lscodec_bits_BitVector$Append__f_sizeLowerBound;
    var lo$6 = t$1.RTLong__f_lo;
    var hi$6 = t$1.RTLong__f_hi;
    var ahi$1 = x$1__hi;
    if (((ahi$1 === hi$6) ? ((x$1__lo >>> 0) > (lo$6 >>> 0)) : (ahi$1 > hi$6))) {
      var x$2__lo = x$1__lo;
      var x$2__hi = x$1__hi;
    } else {
      var x$2__lo = lo$6;
      var x$2__hi = hi$6;
    }
    $thiz.Lscodec_bits_BitVector$Append__f_sizeLowerBound = new $c_RTLong(x$2__lo, x$2__hi);
    var a$4 = cur$tailLocal3.size__J();
    var b$4__lo = n$tailLocal3__lo;
    var b$4__hi = n$tailLocal3__hi;
    var ahi$2 = a$4.RTLong__f_hi;
    var bhi$1 = b$4__hi;
    return ((ahi$2 === bhi$1) ? ((a$4.RTLong__f_lo >>> 0) < (b$4__lo >>> 0)) : (ahi$2 < bhi$1));
  }
}
export { $p_Lscodec_bits_BitVector$Append__go$13__Lscodec_bits_BitVector__J__J__Z as $p_Lscodec_bits_BitVector$Append__go$13__Lscodec_bits_BitVector__J__J__Z };
/** @constructor */
function $c_Lscodec_bits_BitVector$Append(left, right) {
  this.Lscodec_bits_BitVector__f_hashCode$lzy1 = 0;
  this.Lscodec_bits_BitVector__f_hashCodebitmap$1 = false;
  this.Lscodec_bits_BitVector$Append__f_left = null;
  this.Lscodec_bits_BitVector$Append__f_right = null;
  this.Lscodec_bits_BitVector$Append__f_knownSize = $L0;
  this.Lscodec_bits_BitVector$Append__f_sizeLowerBound = $L0;
  this.Lscodec_bits_BitVector$Append__f_left = left;
  this.Lscodec_bits_BitVector$Append__f_right = right;
  if (false) {
    var $x_1 = new $c_RTLong((-1), (-1));
  } else {
    var a = left.size__J();
    var b = right.size__J();
    var alo = a.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var lo = ((alo + blo) | 0);
    var hi = ((((a.RTLong__f_hi + b.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
    var $x_1 = new $c_RTLong(lo, hi);
  }
  this.Lscodec_bits_BitVector$Append__f_knownSize = $x_1;
  this.Lscodec_bits_BitVector$Append__f_sizeLowerBound = left.size__J();
}
export { $c_Lscodec_bits_BitVector$Append as $c_Lscodec_bits_BitVector$Append };
$c_Lscodec_bits_BitVector$Append.prototype = new $h_Lscodec_bits_BitVector();
$c_Lscodec_bits_BitVector$Append.prototype.constructor = $c_Lscodec_bits_BitVector$Append;
/** @constructor */
function $h_Lscodec_bits_BitVector$Append() {
}
export { $h_Lscodec_bits_BitVector$Append as $h_Lscodec_bits_BitVector$Append };
$h_Lscodec_bits_BitVector$Append.prototype = $c_Lscodec_bits_BitVector$Append.prototype;
$c_Lscodec_bits_BitVector$Append.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_bits_BitVector$Append.prototype.productArity__I = (function() {
  return 2;
});
$c_Lscodec_bits_BitVector$Append.prototype.productPrefix__T = (function() {
  return "Append";
});
$c_Lscodec_bits_BitVector$Append.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_bits_BitVector$Append__f_left;
  }
  if ((n === 1)) {
    return this.Lscodec_bits_BitVector$Append__f_right;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_BitVector$Append.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "left";
  }
  if ((n === 1)) {
    return "right";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_BitVector$Append.prototype.get__J__Z = (function(n) {
  var b = this.Lscodec_bits_BitVector$Append__f_left.size__J();
  var ahi = n.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? ((n.RTLong__f_lo >>> 0) < (b.RTLong__f_lo >>> 0)) : (ahi < bhi))) {
    return this.Lscodec_bits_BitVector$Append__f_left.get__J__Z(n);
  } else {
    var $x_1 = this.Lscodec_bits_BitVector$Append__f_right;
    var b$1 = this.Lscodec_bits_BitVector$Append__f_left.size__J();
    var alo = n.RTLong__f_lo;
    var blo = b$1.RTLong__f_lo;
    var lo = ((alo - blo) | 0);
    var hi = ((((n.RTLong__f_hi - b$1.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
    return $x_1.get__J__Z(new $c_RTLong(lo, hi));
  }
});
$c_Lscodec_bits_BitVector$Append.prototype.getByte__J__B = (function(n) {
  var a = this.Lscodec_bits_BitVector$Append__f_left.size__J();
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 8, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var ahi = n.RTLong__f_hi;
  if (((ahi === hi) ? ((n.RTLong__f_lo >>> 0) < (lo >>> 0)) : (ahi < hi))) {
    return this.Lscodec_bits_BitVector$Append__f_left.getByte__J__B(n);
  } else {
    var a$1 = this.Lscodec_bits_BitVector$Append__f_left.size__J();
    var this$3 = $m_RTLong$();
    var lo$1 = this$3.remainderImpl__I__I__I__I__I(a$1.RTLong__f_lo, a$1.RTLong__f_hi, 8, 0);
    var hi$1 = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((lo$1 === 0) && (hi$1 === 0))) {
      var a$2 = this.Lscodec_bits_BitVector$Append__f_left.size__J();
      var this$5 = $m_RTLong$();
      var lo$2 = this$5.divideImpl__I__I__I__I__I(a$2.RTLong__f_lo, a$2.RTLong__f_hi, 8, 0);
      var hi$2 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var ahi$1 = n.RTLong__f_hi;
      var $x_1 = ((ahi$1 === hi$2) ? ((n.RTLong__f_lo >>> 0) > (lo$2 >>> 0)) : (ahi$1 > hi$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var $x_2 = this.Lscodec_bits_BitVector$Append__f_right;
      var a$3 = this.Lscodec_bits_BitVector$Append__f_left.size__J();
      var this$7 = $m_RTLong$();
      var lo$3 = this$7.divideImpl__I__I__I__I__I(a$3.RTLong__f_lo, a$3.RTLong__f_hi, 8, 0);
      var hi$3 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      var alo = n.RTLong__f_lo;
      var lo$4 = ((alo - lo$3) | 0);
      var hi$4 = ((((n.RTLong__f_hi - hi$3) | 0) + ((((~alo) & lo$3) | ((~(alo ^ lo$3)) & lo$4)) >> 31)) | 0);
      return $x_2.getByte__J__B(new $c_RTLong(lo$4, hi$4));
    } else {
      var lo$5 = n.RTLong__f_lo;
      var lo$6 = (lo$5 << 3);
      var hi$5 = (((lo$5 >>> 29) | 0) | (n.RTLong__f_hi << 3));
      return this.drop__J__Lscodec_bits_BitVector(new $c_RTLong(lo$6, hi$5)).take__J__Lscodec_bits_BitVector(new $c_RTLong(8, 0)).align__Lscodec_bits_BitVector$Bytes().getByte__J__B($L0);
    }
  }
});
$c_Lscodec_bits_BitVector$Append.prototype.align__Lscodec_bits_BitVector$Bytes = (function() {
  return this.Lscodec_bits_BitVector$Append__f_left.align__Lscodec_bits_BitVector$Bytes().combine__Lscodec_bits_BitVector$Bytes__Lscodec_bits_BitVector$Bytes(this.Lscodec_bits_BitVector$Append__f_right.align__Lscodec_bits_BitVector$Bytes());
});
$c_Lscodec_bits_BitVector$Append.prototype.size__J = (function() {
  var a = this.Lscodec_bits_BitVector$Append__f_knownSize;
  if ((!((a.RTLong__f_lo === (-1)) && (a.RTLong__f_hi === (-1))))) {
    return this.Lscodec_bits_BitVector$Append__f_knownSize;
  } else {
    var t = $p_Lscodec_bits_BitVector$Append__go$10__sci_List__J__J(this, new $c_sci_$colon$colon(this.Lscodec_bits_BitVector$Append__f_left, new $c_sci_$colon$colon(this.Lscodec_bits_BitVector$Append__f_right, $m_sci_Nil$())), $L0);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    this.Lscodec_bits_BitVector$Append__f_knownSize = new $c_RTLong(lo, hi);
    return new $c_RTLong(lo, hi);
  }
});
$c_Lscodec_bits_BitVector$Append.prototype.take__J__Lscodec_bits_BitVector = (function(n) {
  var ahi = n.RTLong__f_hi;
  if ((ahi < 0)) {
    var t = $L0;
  } else {
    var t = n;
  }
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (((lo === 0) && (hi === 0))) {
    return $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_empty;
  } else {
    var b = this.Lscodec_bits_BitVector$Append__f_left.size__J();
    var bhi = b.RTLong__f_hi;
    if (((hi === bhi) ? ((lo >>> 0) <= (b.RTLong__f_lo >>> 0)) : (hi < bhi))) {
      return this.Lscodec_bits_BitVector$Append__f_left.take__J__Lscodec_bits_BitVector(new $c_RTLong(lo, hi));
    } else {
      var $x_2 = this.Lscodec_bits_BitVector$Append__f_left;
      var $x_1 = this.Lscodec_bits_BitVector$Append__f_right;
      var b$1 = this.Lscodec_bits_BitVector$Append__f_left.size__J();
      var blo = b$1.RTLong__f_lo;
      var lo$1 = ((lo - blo) | 0);
      var hi$1 = ((((hi - b$1.RTLong__f_hi) | 0) + ((((~lo) & blo) | ((~(lo ^ blo)) & lo$1)) >> 31)) | 0);
      return $p_Lscodec_bits_BitVector$Append__go$11__Lscodec_bits_BitVector__Lscodec_bits_BitVector__J__Lscodec_bits_BitVector(this, $x_2, $x_1, new $c_RTLong(lo$1, hi$1));
    }
  }
});
$c_Lscodec_bits_BitVector$Append.prototype.drop__J__Lscodec_bits_BitVector = (function(n) {
  var ahi = n.RTLong__f_hi;
  if ((ahi < 0)) {
    var t = $L0;
  } else {
    var t = n;
  }
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  if (((lo === 0) && (hi === 0))) {
    return this;
  } else {
    var b = this.Lscodec_bits_BitVector$Append__f_left.size__J();
    var bhi = b.RTLong__f_hi;
    if (((hi === bhi) ? ((lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (hi > bhi))) {
      var $x_1 = this.Lscodec_bits_BitVector$Append__f_right;
      var b$1 = this.Lscodec_bits_BitVector$Append__f_left.size__J();
      var blo = b$1.RTLong__f_lo;
      var lo$1 = ((lo - blo) | 0);
      var hi$1 = ((((hi - b$1.RTLong__f_hi) | 0) + ((((~lo) & blo) | ((~(lo ^ blo)) & lo$1)) >> 31)) | 0);
      return $p_Lscodec_bits_BitVector$Append__go$12__Lscodec_bits_BitVector__J__Lscodec_bits_BitVector(this, $x_1, new $c_RTLong(lo$1, hi$1));
    } else {
      var left = this.Lscodec_bits_BitVector$Append__f_left.drop__J__Lscodec_bits_BitVector(new $c_RTLong(lo, hi));
      var right = this.Lscodec_bits_BitVector$Append__f_right;
      return new $c_Lscodec_bits_BitVector$Append(left, right);
    }
  }
});
$c_Lscodec_bits_BitVector$Append.prototype.sizeLessThan__J__Z = (function(n) {
  var a = this.Lscodec_bits_BitVector$Append__f_knownSize;
  if ((!((a.RTLong__f_lo === (-1)) && (a.RTLong__f_hi === (-1))))) {
    var a$1 = this.Lscodec_bits_BitVector$Append__f_knownSize;
    var ahi = a$1.RTLong__f_hi;
    var bhi = n.RTLong__f_hi;
    return ((ahi === bhi) ? ((a$1.RTLong__f_lo >>> 0) < (n.RTLong__f_lo >>> 0)) : (ahi < bhi));
  } else {
    var a$2 = this.Lscodec_bits_BitVector$Append__f_sizeLowerBound;
    var ahi$1 = a$2.RTLong__f_hi;
    var bhi$1 = n.RTLong__f_hi;
    if ((!((ahi$1 === bhi$1) ? ((a$2.RTLong__f_lo >>> 0) >= (n.RTLong__f_lo >>> 0)) : (ahi$1 > bhi$1)))) {
      return $p_Lscodec_bits_BitVector$Append__go$13__Lscodec_bits_BitVector__J__J__Z(this, this, n, $L0);
    } else {
      return false;
    }
  }
});
function $isArrayOf_Lscodec_bits_BitVector$Append(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_BitVector$Append)));
}
export { $isArrayOf_Lscodec_bits_BitVector$Append as $isArrayOf_Lscodec_bits_BitVector$Append };
var $d_Lscodec_bits_BitVector$Append = new $TypeData().initClass($c_Lscodec_bits_BitVector$Append, "scodec.bits.BitVector$Append", ({
  Lscodec_bits_BitVector$Append: 1,
  Lscodec_bits_BitVector: 1,
  Lscodec_bits_BitwiseOperations: 1,
  Lscodec_bits_BitVectorCrossPlatform: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lscodec_bits_BitVector$Append as $d_Lscodec_bits_BitVector$Append };
function $p_Lscodec_bits_BitVector$Bytes__invalidBits__J($thiz) {
  var b = $m_Lscodec_bits_BitVector$().scodec$bits$BitVector$$$validBitsInLastByte__J__J($thiz.Lscodec_bits_BitVector$Bytes__f_size);
  var blo = b.RTLong__f_lo;
  var lo = ((8 - blo) | 0);
  var hi = ((((-b.RTLong__f_hi) | 0) + ((blo | lo) >> 31)) | 0);
  return new $c_RTLong(lo, hi);
}
export { $p_Lscodec_bits_BitVector$Bytes__invalidBits__J as $p_Lscodec_bits_BitVector$Bytes__invalidBits__J };
/** @constructor */
function $c_Lscodec_bits_BitVector$Bytes(underlying, size) {
  this.Lscodec_bits_BitVector__f_hashCode$lzy1 = 0;
  this.Lscodec_bits_BitVector__f_hashCodebitmap$1 = false;
  this.Lscodec_bits_BitVector$Bytes__f_underlying = null;
  this.Lscodec_bits_BitVector$Bytes__f_size = $L0;
  this.Lscodec_bits_BitVector$Bytes__f_underlying = underlying;
  this.Lscodec_bits_BitVector$Bytes__f_size = size;
}
export { $c_Lscodec_bits_BitVector$Bytes as $c_Lscodec_bits_BitVector$Bytes };
$c_Lscodec_bits_BitVector$Bytes.prototype = new $h_Lscodec_bits_BitVector();
$c_Lscodec_bits_BitVector$Bytes.prototype.constructor = $c_Lscodec_bits_BitVector$Bytes;
/** @constructor */
function $h_Lscodec_bits_BitVector$Bytes() {
}
export { $h_Lscodec_bits_BitVector$Bytes as $h_Lscodec_bits_BitVector$Bytes };
$h_Lscodec_bits_BitVector$Bytes.prototype = $c_Lscodec_bits_BitVector$Bytes.prototype;
$c_Lscodec_bits_BitVector$Bytes.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_bits_BitVector$Bytes.prototype.productArity__I = (function() {
  return 2;
});
$c_Lscodec_bits_BitVector$Bytes.prototype.productPrefix__T = (function() {
  return "Bytes";
});
$c_Lscodec_bits_BitVector$Bytes.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_bits_BitVector$Bytes__f_underlying;
  }
  if ((n === 1)) {
    return this.Lscodec_bits_BitVector$Bytes__f_size;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_BitVector$Bytes.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "underlying";
  }
  if ((n === 1)) {
    return "size";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_BitVector$Bytes.prototype.size__J = (function() {
  return this.Lscodec_bits_BitVector$Bytes__f_size;
});
$c_Lscodec_bits_BitVector$Bytes.prototype.align__Lscodec_bits_BitVector$Bytes = (function() {
  return this;
});
$c_Lscodec_bits_BitVector$Bytes.prototype.sizeLessThan__J__Z = (function(n) {
  var a = this.Lscodec_bits_BitVector$Bytes__f_size;
  var ahi = a.RTLong__f_hi;
  var bhi = n.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) < (n.RTLong__f_lo >>> 0)) : (ahi < bhi));
});
$c_Lscodec_bits_BitVector$Bytes.prototype.take__J__Lscodec_bits_BitVector$Bytes = (function(n) {
  var $x_2 = $m_Lscodec_bits_BitVector$();
  var $x_1 = this.Lscodec_bits_BitVector$Bytes__f_underlying;
  var t = this.Lscodec_bits_BitVector$Bytes__f_size;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var bhi = n.RTLong__f_hi;
  if (((hi === bhi) ? ((lo >>> 0) < (n.RTLong__f_lo >>> 0)) : (hi < bhi))) {
    var t$1 = new $c_RTLong(lo, hi);
  } else {
    var t$1 = n;
  }
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $x_2.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes($x_1, ((hi$1 < 0) ? $L0 : new $c_RTLong(lo$1, hi$1)));
});
$c_Lscodec_bits_BitVector$Bytes.prototype.drop__J__Lscodec_bits_BitVector = (function(n) {
  var b = this.Lscodec_bits_BitVector$Bytes__f_size;
  var ahi = n.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? ((n.RTLong__f_lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
    return $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_empty;
  } else {
    var ahi$1 = n.RTLong__f_hi;
    if (((ahi$1 === 0) ? (n.RTLong__f_lo === 0) : (ahi$1 < 0))) {
      return this;
    } else {
      var this$3 = $m_RTLong$();
      var lo = this$3.remainderImpl__I__I__I__I__I(n.RTLong__f_lo, n.RTLong__f_hi, 8, 0);
      var hi = this$3.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
      if (((lo === 0) && (hi === 0))) {
        var $x_2 = this.Lscodec_bits_BitVector$Bytes__f_underlying;
        var this$5 = $m_RTLong$();
        var lo$1 = this$5.divideImpl__I__I__I__I__I(n.RTLong__f_lo, n.RTLong__f_hi, 8, 0);
        var hi$1 = this$5.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var underlying = $x_2.drop__J__Lscodec_bits_ByteVector(new $c_RTLong(lo$1, hi$1));
        var a = this.Lscodec_bits_BitVector$Bytes__f_size;
        var alo = a.RTLong__f_lo;
        var blo = n.RTLong__f_lo;
        var lo$2 = ((alo - blo) | 0);
        var hi$2 = ((((a.RTLong__f_hi - n.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo$2)) >> 31)) | 0);
        var $x_1 = new $c_Lscodec_bits_BitVector$Bytes(underlying, new $c_RTLong(lo$2, hi$2));
      } else {
        var $x_1 = new $c_Lscodec_bits_BitVector$Drop(this, n);
      }
      return $x_1;
    }
  }
});
$c_Lscodec_bits_BitVector$Bytes.prototype.get__J__Z = (function(n) {
  this.checkBounds__J__V(n);
  var $x_2 = $m_Lscodec_bits_BitVector$();
  var this$2 = this.Lscodec_bits_BitVector$Bytes__f_underlying;
  var this$1 = $m_RTLong$();
  var lo = this$1.divideImpl__I__I__I__I__I(n.RTLong__f_lo, n.RTLong__f_hi, 8, 0);
  var hi = this$1.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
  var $x_1 = this$2.get__J__B(new $c_RTLong(lo, hi));
  var this$3 = $m_RTLong$();
  var lo$1 = this$3.remainderImpl__I__I__I__I__I(n.RTLong__f_lo, n.RTLong__f_hi, 8, 0);
  return $x_2.scodec$bits$BitVector$$$getBit__B__I__Z($x_1, lo$1);
});
$c_Lscodec_bits_BitVector$Bytes.prototype.getByte__J__B = (function(n) {
  var b = this.Lscodec_bits_BitVector$Bytes__f_underlying.size__J();
  var blo = b.RTLong__f_lo;
  var lo = (((-1) + blo) | 0);
  var hi = (((((-1) + b.RTLong__f_hi) | 0) + (((blo | (~lo)) >>> 31) | 0)) | 0);
  var ahi = n.RTLong__f_hi;
  if (((ahi === hi) ? ((n.RTLong__f_lo >>> 0) < (lo >>> 0)) : (ahi < hi))) {
    var this$3 = this.Lscodec_bits_BitVector$Bytes__f_underlying;
    return this$3.get__J__B(n);
  } else {
    var b$1 = $p_Lscodec_bits_BitVector$Bytes__invalidBits__J(this);
    var blo$1 = b$1.RTLong__f_lo;
    var lo$1 = ((8 - blo$1) | 0);
    var this$5 = this.Lscodec_bits_BitVector$Bytes__f_underlying;
    return (((this$5.get__J__B(n) & $m_Lscodec_bits_BitVector$().scodec$bits$BitVector$$$topNBits__I__B(lo$1)) << 24) >> 24);
  }
});
$c_Lscodec_bits_BitVector$Bytes.prototype.combine__Lscodec_bits_BitVector$Bytes__Lscodec_bits_BitVector$Bytes = (function(other) {
  var t = $p_Lscodec_bits_BitVector$Bytes__invalidBits__J(this);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var otherBytes = other.Lscodec_bits_BitVector$Bytes__f_underlying;
  if (this.sizeLessThan__J__Z(new $c_RTLong(1, 0))) {
    return other;
  } else if (otherBytes.isEmpty__Z()) {
    return this;
  } else if (((lo === 0) && (hi === 0))) {
    var $x_2 = $m_Lscodec_bits_BitVector$();
    var $x_1 = this.Lscodec_bits_BitVector$Bytes__f_underlying.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(otherBytes);
    var a = this.Lscodec_bits_BitVector$Bytes__f_size;
    var b = other.Lscodec_bits_BitVector$Bytes__f_size;
    var alo = a.RTLong__f_lo;
    var blo = b.RTLong__f_lo;
    var lo$1 = ((alo + blo) | 0);
    var hi$1 = ((((a.RTLong__f_hi + b.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo$1))) >>> 31) | 0)) | 0);
    return $x_2.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes($x_1, new $c_RTLong(lo$1, hi$1));
  } else {
    var bytesCleared = $m_Lscodec_bits_BitVector$().scodec$bits$BitVector$$$clearUnneededBits__J__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(this.Lscodec_bits_BitVector$Bytes__f_size, this.Lscodec_bits_BitVector$Bytes__f_underlying);
    var b$1 = bytesCleared.size__J();
    var blo$1 = b$1.RTLong__f_lo;
    var lo$2 = (((-1) + blo$1) | 0);
    var hi$2 = (((((-1) + b$1.RTLong__f_hi) | 0) + (((blo$1 | (~lo$2)) >>> 31) | 0)) | 0);
    var hi$3 = bytesCleared.get__J__B(new $c_RTLong(lo$2, hi$2));
    var $x_4 = otherBytes.get__J__B($L0);
    var $x_3 = $m_Lscodec_bits_BitVector$().scodec$bits$BitVector$$$topNBits__I__B(lo);
    var a$1 = $m_Lscodec_bits_BitVector$().scodec$bits$BitVector$$$validBitsInLastByte__J__J(this.Lscodec_bits_BitVector$Bytes__f_size);
    var lo$3 = (((((255 & ($x_4 & $x_3)) >>> a$1.RTLong__f_lo) | 0) << 24) >> 24);
    var b$2 = bytesCleared.size__J();
    var blo$2 = b$2.RTLong__f_lo;
    var lo$4 = (((-1) + blo$2) | 0);
    var hi$4 = (((((-1) + b$2.RTLong__f_hi) | 0) + (((blo$2 | (~lo$4)) >>> 31) | 0)) | 0);
    var updatedOurBytes = bytesCleared.update__J__B__Lscodec_bits_ByteVector(new $c_RTLong(lo$4, hi$4), (((hi$3 | lo$3) << 24) >> 24));
    var updatedOtherBytes = other.drop__J__Lscodec_bits_BitVector(new $c_RTLong(lo, hi)).toByteVector__Lscodec_bits_ByteVector();
    var $x_6 = $m_Lscodec_bits_BitVector$();
    var $x_5 = updatedOurBytes.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(updatedOtherBytes);
    var a$2 = this.Lscodec_bits_BitVector$Bytes__f_size;
    var b$3 = other.Lscodec_bits_BitVector$Bytes__f_size;
    var alo$1 = a$2.RTLong__f_lo;
    var blo$3 = b$3.RTLong__f_lo;
    var lo$5 = ((alo$1 + blo$3) | 0);
    var hi$5 = ((((a$2.RTLong__f_hi + b$3.RTLong__f_hi) | 0) + ((((alo$1 & blo$3) | ((alo$1 | blo$3) & (~lo$5))) >>> 31) | 0)) | 0);
    return $x_6.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes($x_5, new $c_RTLong(lo$5, hi$5));
  }
});
$c_Lscodec_bits_BitVector$Bytes.prototype.take__J__Lscodec_bits_BitVector = (function(n) {
  return this.take__J__Lscodec_bits_BitVector$Bytes(n);
});
function $isArrayOf_Lscodec_bits_BitVector$Bytes(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_BitVector$Bytes)));
}
export { $isArrayOf_Lscodec_bits_BitVector$Bytes as $isArrayOf_Lscodec_bits_BitVector$Bytes };
var $d_Lscodec_bits_BitVector$Bytes = new $TypeData().initClass($c_Lscodec_bits_BitVector$Bytes, "scodec.bits.BitVector$Bytes", ({
  Lscodec_bits_BitVector$Bytes: 1,
  Lscodec_bits_BitVector: 1,
  Lscodec_bits_BitwiseOperations: 1,
  Lscodec_bits_BitVectorCrossPlatform: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lscodec_bits_BitVector$Bytes as $d_Lscodec_bits_BitVector$Bytes };
function $p_Lscodec_bits_BitVector$Chunks__go$14__Lscodec_bits_BitVector$Append__Lscodec_bits_BitVector__Lscodec_bits_BitVector($thiz, chunks, last) {
  var last$tailLocal1 = last;
  var chunks$tailLocal1 = chunks;
  while (true) {
    var t = last$tailLocal1.size__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var b = chunks$tailLocal1.size__J();
    var bhi = b.RTLong__f_hi;
    if (((hi === bhi) ? ((lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (hi > bhi))) {
      var $x_1 = true;
    } else {
      var lo$1 = (lo << 1);
      var hi$1 = (((lo >>> 31) | 0) | (hi << 1));
      var b$1 = chunks$tailLocal1.Lscodec_bits_BitVector$Append__f_right.size__J();
      var bhi$1 = b$1.RTLong__f_hi;
      var $x_1 = ((hi$1 === bhi$1) ? ((lo$1 >>> 0) <= (b$1.RTLong__f_lo >>> 0)) : (hi$1 < bhi$1));
    }
    if ($x_1) {
      var left = chunks$tailLocal1;
      var right = last$tailLocal1;
      var chunks$1 = new $c_Lscodec_bits_BitVector$Append(left, right);
      return new $c_Lscodec_bits_BitVector$Chunks(chunks$1);
    } else {
      var x187 = chunks$tailLocal1.Lscodec_bits_BitVector$Append__f_left;
      if ((x187 instanceof $c_Lscodec_bits_BitVector$Append)) {
        var t$1 = chunks$tailLocal1.Lscodec_bits_BitVector$Append__f_right.size__J();
        var lo$2 = t$1.RTLong__f_lo;
        var hi$2 = t$1.RTLong__f_hi;
        var this$6 = $m_RTLong$();
        var lo$3 = this$6.remainderImpl__I__I__I__I__I(lo, hi, 8, 0);
        var hi$3 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var this$7 = $m_RTLong$();
        var lo$4 = this$7.remainderImpl__I__I__I__I__I(lo$2, hi$2, 8, 0);
        var hi$4 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var lo$5 = ((lo$3 + lo$4) | 0);
        var hi$5 = ((((hi$3 + hi$4) | 0) + ((((lo$3 & lo$4) | ((lo$3 | lo$4) & (~lo$5))) >>> 31) | 0)) | 0);
        var aligned = ((lo$5 === 0) && (hi$5 === 0));
        if ((((hi$2 === 0) ? ((lo$2 >>> 0) <= 256) : (hi$2 < 0)) && aligned)) {
          var last$tailLocal1$tmp1 = chunks$tailLocal1.Lscodec_bits_BitVector$Append__f_right.align__Lscodec_bits_BitVector$Bytes().combine__Lscodec_bits_BitVector$Bytes__Lscodec_bits_BitVector$Bytes(last$tailLocal1.align__Lscodec_bits_BitVector$Bytes());
          chunks$tailLocal1 = x187;
          last$tailLocal1 = last$tailLocal1$tmp1;
          continue;
        } else {
          var left$1 = chunks$tailLocal1.Lscodec_bits_BitVector$Append__f_right;
          var right$1 = last$tailLocal1;
          var last$tailLocal1$tmp2 = new $c_Lscodec_bits_BitVector$Append(left$1, right$1);
          chunks$tailLocal1 = x187;
          last$tailLocal1 = last$tailLocal1$tmp2;
          continue;
        }
      }
      var left$2 = chunks$tailLocal1;
      var right$2 = last$tailLocal1;
      var chunks$2 = new $c_Lscodec_bits_BitVector$Append(left$2, right$2);
      return new $c_Lscodec_bits_BitVector$Chunks(chunks$2);
    }
  }
}
export { $p_Lscodec_bits_BitVector$Chunks__go$14__Lscodec_bits_BitVector$Append__Lscodec_bits_BitVector__Lscodec_bits_BitVector as $p_Lscodec_bits_BitVector$Chunks__go$14__Lscodec_bits_BitVector$Append__Lscodec_bits_BitVector__Lscodec_bits_BitVector };
/** @constructor */
function $c_Lscodec_bits_BitVector$Chunks(chunks) {
  this.Lscodec_bits_BitVector__f_hashCode$lzy1 = 0;
  this.Lscodec_bits_BitVector__f_hashCodebitmap$1 = false;
  this.Lscodec_bits_BitVector$Chunks__f_chunks = null;
  this.Lscodec_bits_BitVector$Chunks__f_chunks = chunks;
}
export { $c_Lscodec_bits_BitVector$Chunks as $c_Lscodec_bits_BitVector$Chunks };
$c_Lscodec_bits_BitVector$Chunks.prototype = new $h_Lscodec_bits_BitVector();
$c_Lscodec_bits_BitVector$Chunks.prototype.constructor = $c_Lscodec_bits_BitVector$Chunks;
/** @constructor */
function $h_Lscodec_bits_BitVector$Chunks() {
}
export { $h_Lscodec_bits_BitVector$Chunks as $h_Lscodec_bits_BitVector$Chunks };
$h_Lscodec_bits_BitVector$Chunks.prototype = $c_Lscodec_bits_BitVector$Chunks.prototype;
$c_Lscodec_bits_BitVector$Chunks.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_bits_BitVector$Chunks.prototype.productArity__I = (function() {
  return 1;
});
$c_Lscodec_bits_BitVector$Chunks.prototype.productPrefix__T = (function() {
  return "Chunks";
});
$c_Lscodec_bits_BitVector$Chunks.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_bits_BitVector$Chunks__f_chunks;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_BitVector$Chunks.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "chunks";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_BitVector$Chunks.prototype.unchunk__Lscodec_bits_BitVector = (function() {
  var left = this.Lscodec_bits_BitVector$Chunks__f_chunks.Lscodec_bits_BitVector$Append__f_left;
  var right = this.Lscodec_bits_BitVector$Chunks__f_chunks.Lscodec_bits_BitVector$Append__f_right.unchunk__Lscodec_bits_BitVector();
  return new $c_Lscodec_bits_BitVector$Append(left, right);
});
$c_Lscodec_bits_BitVector$Chunks.prototype.align__Lscodec_bits_BitVector$Bytes = (function() {
  return this.Lscodec_bits_BitVector$Chunks__f_chunks.align__Lscodec_bits_BitVector$Bytes();
});
$c_Lscodec_bits_BitVector$Chunks.prototype.take__J__Lscodec_bits_BitVector = (function(n) {
  return this.Lscodec_bits_BitVector$Chunks__f_chunks.take__J__Lscodec_bits_BitVector(n);
});
$c_Lscodec_bits_BitVector$Chunks.prototype.drop__J__Lscodec_bits_BitVector = (function(n) {
  return this.Lscodec_bits_BitVector$Chunks__f_chunks.drop__J__Lscodec_bits_BitVector(n);
});
$c_Lscodec_bits_BitVector$Chunks.prototype.$plus$plus__Lscodec_bits_BitVector__Lscodec_bits_BitVector = (function(b) {
  return (b.sizeLessThan__J__Z(new $c_RTLong(1, 0)) ? this : (this.Lscodec_bits_BitVector$Chunks__f_chunks.sizeLessThan__J__Z(new $c_RTLong(1, 0)) ? b : $p_Lscodec_bits_BitVector$Chunks__go$14__Lscodec_bits_BitVector$Append__Lscodec_bits_BitVector__Lscodec_bits_BitVector(this, this.Lscodec_bits_BitVector$Chunks__f_chunks, b.unchunk__Lscodec_bits_BitVector())));
});
$c_Lscodec_bits_BitVector$Chunks.prototype.size__J = (function() {
  return this.Lscodec_bits_BitVector$Chunks__f_chunks.size__J();
});
$c_Lscodec_bits_BitVector$Chunks.prototype.sizeLessThan__J__Z = (function(n) {
  return this.Lscodec_bits_BitVector$Chunks__f_chunks.sizeLessThan__J__Z(n);
});
$c_Lscodec_bits_BitVector$Chunks.prototype.get__J__Z = (function(n) {
  return this.Lscodec_bits_BitVector$Chunks__f_chunks.get__J__Z(n);
});
$c_Lscodec_bits_BitVector$Chunks.prototype.getByte__J__B = (function(n) {
  return this.Lscodec_bits_BitVector$Chunks__f_chunks.getByte__J__B(n);
});
function $isArrayOf_Lscodec_bits_BitVector$Chunks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_BitVector$Chunks)));
}
export { $isArrayOf_Lscodec_bits_BitVector$Chunks as $isArrayOf_Lscodec_bits_BitVector$Chunks };
var $d_Lscodec_bits_BitVector$Chunks = new $TypeData().initClass($c_Lscodec_bits_BitVector$Chunks, "scodec.bits.BitVector$Chunks", ({
  Lscodec_bits_BitVector$Chunks: 1,
  Lscodec_bits_BitVector: 1,
  Lscodec_bits_BitwiseOperations: 1,
  Lscodec_bits_BitVectorCrossPlatform: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lscodec_bits_BitVector$Chunks as $d_Lscodec_bits_BitVector$Chunks };
/** @constructor */
function $c_Lscodec_bits_BitVector$Drop(underlying, m) {
  this.Lscodec_bits_BitVector__f_hashCode$lzy1 = 0;
  this.Lscodec_bits_BitVector__f_hashCodebitmap$1 = false;
  this.Lscodec_bits_BitVector$Drop__f_underlying = null;
  this.Lscodec_bits_BitVector$Drop__f_m = $L0;
  this.Lscodec_bits_BitVector$Drop__f_underlying = underlying;
  this.Lscodec_bits_BitVector$Drop__f_m = m;
}
export { $c_Lscodec_bits_BitVector$Drop as $c_Lscodec_bits_BitVector$Drop };
$c_Lscodec_bits_BitVector$Drop.prototype = new $h_Lscodec_bits_BitVector();
$c_Lscodec_bits_BitVector$Drop.prototype.constructor = $c_Lscodec_bits_BitVector$Drop;
/** @constructor */
function $h_Lscodec_bits_BitVector$Drop() {
}
export { $h_Lscodec_bits_BitVector$Drop as $h_Lscodec_bits_BitVector$Drop };
$h_Lscodec_bits_BitVector$Drop.prototype = $c_Lscodec_bits_BitVector$Drop.prototype;
$c_Lscodec_bits_BitVector$Drop.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_bits_BitVector$Drop.prototype.productArity__I = (function() {
  return 2;
});
$c_Lscodec_bits_BitVector$Drop.prototype.productPrefix__T = (function() {
  return "Drop";
});
$c_Lscodec_bits_BitVector$Drop.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_bits_BitVector$Drop__f_underlying;
  }
  if ((n === 1)) {
    return this.Lscodec_bits_BitVector$Drop__f_m;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_BitVector$Drop.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "underlying";
  }
  if ((n === 1)) {
    return "m";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_BitVector$Drop.prototype.size__J = (function() {
  var a = this.Lscodec_bits_BitVector$Drop__f_underlying.Lscodec_bits_BitVector$Bytes__f_size;
  var b = this.Lscodec_bits_BitVector$Drop__f_m;
  var alo = a.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var lo = ((alo - blo) | 0);
  var hi = ((((a.RTLong__f_hi - b.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
  return ((hi < 0) ? $L0 : new $c_RTLong(lo, hi));
});
$c_Lscodec_bits_BitVector$Drop.prototype.sizeLessThan__J__Z = (function(n) {
  var a = this.size__J();
  var ahi = a.RTLong__f_hi;
  var bhi = n.RTLong__f_hi;
  return ((ahi === bhi) ? ((a.RTLong__f_lo >>> 0) < (n.RTLong__f_lo >>> 0)) : (ahi < bhi));
});
$c_Lscodec_bits_BitVector$Drop.prototype.align__Lscodec_bits_BitVector$Bytes = (function() {
  return this.interpretDrop__Lscodec_bits_BitVector$Bytes();
});
$c_Lscodec_bits_BitVector$Drop.prototype.drop__J__Lscodec_bits_BitVector = (function(n) {
  var b = this.size__J();
  var ahi = n.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? ((n.RTLong__f_lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
    return $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_empty;
  } else {
    var ahi$1 = n.RTLong__f_hi;
    if (((ahi$1 === 0) ? (n.RTLong__f_lo === 0) : (ahi$1 < 0))) {
      return this;
    } else {
      var b$1 = this.Lscodec_bits_BitVector$Drop__f_m;
      var alo = n.RTLong__f_lo;
      var blo = b$1.RTLong__f_lo;
      var lo = ((alo + blo) | 0);
      var hi = ((((n.RTLong__f_hi + b$1.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
      var underlying = this.Lscodec_bits_BitVector$Drop__f_underlying;
      var d = new $c_Lscodec_bits_BitVector$Drop(underlying, new $c_RTLong(lo, hi));
      if (((hi === 0) ? ((lo >>> 0) > 32768) : (hi > 0))) {
        var this$6 = $m_RTLong$();
        var lo$1 = this$6.remainderImpl__I__I__I__I__I(lo, hi, 8, 0);
        var hi$1 = this$6.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
        var $x_1 = ((lo$1 === 0) && (hi$1 === 0));
      } else {
        var $x_1 = false;
      }
      return ($x_1 ? d.interpretDrop__Lscodec_bits_BitVector$Bytes() : d);
    }
  }
});
$c_Lscodec_bits_BitVector$Drop.prototype.take__J__Lscodec_bits_BitVector = (function(n) {
  var b = this.size__J();
  var ahi = n.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? ((n.RTLong__f_lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (ahi > bhi))) {
    return this;
  } else {
    var ahi$1 = n.RTLong__f_hi;
    if (((ahi$1 === 0) ? (n.RTLong__f_lo === 0) : (ahi$1 < 0))) {
      return $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_empty;
    } else {
      var $x_1 = this.Lscodec_bits_BitVector$Drop__f_underlying;
      var a = this.Lscodec_bits_BitVector$Drop__f_m;
      var alo = a.RTLong__f_lo;
      var blo = n.RTLong__f_lo;
      var lo = ((alo + blo) | 0);
      var hi = ((((a.RTLong__f_hi + n.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
      return $x_1.take__J__Lscodec_bits_BitVector$Bytes(new $c_RTLong(lo, hi)).drop__J__Lscodec_bits_BitVector(this.Lscodec_bits_BitVector$Drop__f_m);
    }
  }
});
$c_Lscodec_bits_BitVector$Drop.prototype.get__J__Z = (function(n) {
  var $x_1 = this.Lscodec_bits_BitVector$Drop__f_underlying;
  var a = this.Lscodec_bits_BitVector$Drop__f_m;
  var alo = a.RTLong__f_lo;
  var blo = n.RTLong__f_lo;
  var lo = ((alo + blo) | 0);
  var hi = ((((a.RTLong__f_hi + n.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
  return $x_1.get__J__Z(new $c_RTLong(lo, hi));
});
$c_Lscodec_bits_BitVector$Drop.prototype.getByte__J__B = (function(n) {
  var lo = n.RTLong__f_lo;
  var lo$1 = (lo << 3);
  var hi = (((lo >>> 29) | 0) | (n.RTLong__f_hi << 3));
  return this.drop__J__Lscodec_bits_BitVector(new $c_RTLong(lo$1, hi)).take__J__Lscodec_bits_BitVector(new $c_RTLong(8, 0)).align__Lscodec_bits_BitVector$Bytes().getByte__J__B($L0);
});
$c_Lscodec_bits_BitVector$Drop.prototype.interpretDrop__Lscodec_bits_BitVector$Bytes = (function() {
  var t = this.Lscodec_bits_BitVector$Drop__f_m;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = (((hi === 0) ? (lo !== 0) : (hi > 0)) ? new $c_RTLong(lo, hi) : $L0);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = this.size__J();
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  if (((lo$2 === 0) && (hi$2 === 0))) {
    return $m_Lscodec_bits_BitVector$().Lscodec_bits_BitVector$__f_empty.align__Lscodec_bits_BitVector$Bytes();
  } else {
    var this$7 = $m_RTLong$();
    var lo$3 = this$7.divideImpl__I__I__I__I__I(lo$1, hi$1, 8, 0);
    var hi$3 = this$7.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    var $x_2 = this.Lscodec_bits_BitVector$Drop__f_underlying.Lscodec_bits_BitVector$Bytes__f_underlying;
    var $x_1 = new $c_RTLong(lo$3, hi$3);
    var b = $m_Lscodec_bits_BitVector$().scodec$bits$BitVector$$$bytesNeededForBits__J__J(new $c_RTLong(lo$2, hi$2));
    var blo = b.RTLong__f_lo;
    var lo$4 = ((lo$3 + blo) | 0);
    var hi$4 = ((((hi$3 + b.RTLong__f_hi) | 0) + ((((lo$3 & blo) | ((lo$3 | blo) & (~lo$4))) >>> 31) | 0)) | 0);
    var lo$5 = ((1 + lo$4) | 0);
    var hi$5 = ((hi$4 + (((lo$4 & (~lo$5)) >>> 31) | 0)) | 0);
    var shiftedByWholeBytes = $x_2.slice__J__J__Lscodec_bits_ByteVector($x_1, new $c_RTLong(lo$5, hi$5));
    var this$10 = $m_RTLong$();
    var lo$6 = this$10.remainderImpl__I__I__I__I__I(lo$1, hi$1, 8, 0);
    var newBytes = ((lo$6 === 0) ? shiftedByWholeBytes : shiftedByWholeBytes.zipWithI__Lscodec_bits_ByteVector__F2__Lscodec_bits_ByteVector(shiftedByWholeBytes.drop__J__Lscodec_bits_ByteVector(new $c_RTLong(1, 0)).$colon$plus__B__Lscodec_bits_ByteVector(0), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((x$1, x$2) => {
      var x$1$1 = (x$1 | 0);
      var x$2$1 = (x$2 | 0);
      var hi$7 = (x$1$1 << lo$6);
      var low = (((255 & (x$2$1 & $m_Lscodec_bits_BitVector$().scodec$bits$BitVector$$$topNBits__I__B(lo$6))) >>> ((8 - lo$6) | 0)) | 0);
      return (hi$7 | low);
    }))));
    var $x_3 = $m_Lscodec_bits_BitVector$();
    var b$1 = newBytes.size__J();
    var blo$1 = b$1.RTLong__f_lo;
    var lo$7 = (((-1) + blo$1) | 0);
    var hi$8 = (((((-1) + b$1.RTLong__f_hi) | 0) + (((blo$1 | (~lo$7)) >>> 31) | 0)) | 0);
    var lo$8 = (lo$7 << 3);
    var hi$9 = (((lo$7 >>> 29) | 0) | (hi$8 << 3));
    return $x_3.toBytes__Lscodec_bits_ByteVector__J__Lscodec_bits_BitVector$Bytes((((hi$2 === hi$9) ? ((lo$2 >>> 0) <= (lo$8 >>> 0)) : (hi$2 < hi$9)) ? newBytes.dropRight__J__Lscodec_bits_ByteVector(new $c_RTLong(1, 0)) : newBytes), new $c_RTLong(lo$2, hi$2));
  }
});
function $isArrayOf_Lscodec_bits_BitVector$Drop(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_BitVector$Drop)));
}
export { $isArrayOf_Lscodec_bits_BitVector$Drop as $isArrayOf_Lscodec_bits_BitVector$Drop };
var $d_Lscodec_bits_BitVector$Drop = new $TypeData().initClass($c_Lscodec_bits_BitVector$Drop, "scodec.bits.BitVector$Drop", ({
  Lscodec_bits_BitVector$Drop: 1,
  Lscodec_bits_BitVector: 1,
  Lscodec_bits_BitwiseOperations: 1,
  Lscodec_bits_BitVectorCrossPlatform: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lscodec_bits_BitVector$Drop as $d_Lscodec_bits_BitVector$Drop };
function $isArrayOf_Lscodec_bits_BitVector$Suspend(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_BitVector$Suspend)));
}
export { $isArrayOf_Lscodec_bits_BitVector$Suspend as $isArrayOf_Lscodec_bits_BitVector$Suspend };
/** @constructor */
function $c_Lscodec_bits_ByteVector$Append(left, right) {
  this.Lscodec_bits_ByteVector__f_hashCode$lzy1 = 0;
  this.Lscodec_bits_ByteVector__f_hashCodebitmap$1 = false;
  this.Lscodec_bits_ByteVector$Append__f_left = null;
  this.Lscodec_bits_ByteVector$Append__f_right = null;
  this.Lscodec_bits_ByteVector$Append__f_size = $L0;
  this.Lscodec_bits_ByteVector$Append__f_left = left;
  this.Lscodec_bits_ByteVector$Append__f_right = right;
  var a = left.size__J();
  var b = right.size__J();
  var alo = a.RTLong__f_lo;
  var blo = b.RTLong__f_lo;
  var lo = ((alo + blo) | 0);
  var hi = ((((a.RTLong__f_hi + b.RTLong__f_hi) | 0) + ((((alo & blo) | ((alo | blo) & (~lo))) >>> 31) | 0)) | 0);
  this.Lscodec_bits_ByteVector$Append__f_size = new $c_RTLong(lo, hi);
}
export { $c_Lscodec_bits_ByteVector$Append as $c_Lscodec_bits_ByteVector$Append };
$c_Lscodec_bits_ByteVector$Append.prototype = new $h_Lscodec_bits_ByteVector();
$c_Lscodec_bits_ByteVector$Append.prototype.constructor = $c_Lscodec_bits_ByteVector$Append;
/** @constructor */
function $h_Lscodec_bits_ByteVector$Append() {
}
export { $h_Lscodec_bits_ByteVector$Append as $h_Lscodec_bits_ByteVector$Append };
$h_Lscodec_bits_ByteVector$Append.prototype = $c_Lscodec_bits_ByteVector$Append.prototype;
$c_Lscodec_bits_ByteVector$Append.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_bits_ByteVector$Append.prototype.productArity__I = (function() {
  return 2;
});
$c_Lscodec_bits_ByteVector$Append.prototype.productPrefix__T = (function() {
  return "Append";
});
$c_Lscodec_bits_ByteVector$Append.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_bits_ByteVector$Append__f_left;
  }
  if ((n === 1)) {
    return this.Lscodec_bits_ByteVector$Append__f_right;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_ByteVector$Append.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "left";
  }
  if ((n === 1)) {
    return "right";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_ByteVector$Append.prototype.size__J = (function() {
  return this.Lscodec_bits_ByteVector$Append__f_size;
});
$c_Lscodec_bits_ByteVector$Append.prototype.getImpl__J__B = (function(n) {
  var b = this.Lscodec_bits_ByteVector$Append__f_left.size__J();
  var ahi = n.RTLong__f_hi;
  var bhi = b.RTLong__f_hi;
  if (((ahi === bhi) ? ((n.RTLong__f_lo >>> 0) < (b.RTLong__f_lo >>> 0)) : (ahi < bhi))) {
    return this.Lscodec_bits_ByteVector$Append__f_left.getImpl__J__B(n);
  } else {
    var $x_1 = this.Lscodec_bits_ByteVector$Append__f_right;
    var b$1 = this.Lscodec_bits_ByteVector$Append__f_left.size__J();
    var alo = n.RTLong__f_lo;
    var blo = b$1.RTLong__f_lo;
    var lo = ((alo - blo) | 0);
    var hi = ((((n.RTLong__f_hi - b$1.RTLong__f_hi) | 0) + ((((~alo) & blo) | ((~(alo ^ blo)) & lo)) >> 31)) | 0);
    return $x_1.getImpl__J__B(new $c_RTLong(lo, hi));
  }
});
function $isArrayOf_Lscodec_bits_ByteVector$Append(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_ByteVector$Append)));
}
export { $isArrayOf_Lscodec_bits_ByteVector$Append as $isArrayOf_Lscodec_bits_ByteVector$Append };
var $d_Lscodec_bits_ByteVector$Append = new $TypeData().initClass($c_Lscodec_bits_ByteVector$Append, "scodec.bits.ByteVector$Append", ({
  Lscodec_bits_ByteVector$Append: 1,
  Lscodec_bits_ByteVector: 1,
  Lscodec_bits_ByteVectorCrossPlatform: 1,
  Lscodec_bits_BitwiseOperations: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lscodec_bits_ByteVector$Append as $d_Lscodec_bits_ByteVector$Append };
/** @constructor */
function $c_Lscodec_bits_ByteVector$Chunk(bytes) {
  this.Lscodec_bits_ByteVector__f_hashCode$lzy1 = 0;
  this.Lscodec_bits_ByteVector__f_hashCodebitmap$1 = false;
  this.Lscodec_bits_ByteVector$Chunk__f_bytes = null;
  this.Lscodec_bits_ByteVector$Chunk__f_bytes = bytes;
}
export { $c_Lscodec_bits_ByteVector$Chunk as $c_Lscodec_bits_ByteVector$Chunk };
$c_Lscodec_bits_ByteVector$Chunk.prototype = new $h_Lscodec_bits_ByteVector();
$c_Lscodec_bits_ByteVector$Chunk.prototype.constructor = $c_Lscodec_bits_ByteVector$Chunk;
/** @constructor */
function $h_Lscodec_bits_ByteVector$Chunk() {
}
export { $h_Lscodec_bits_ByteVector$Chunk as $h_Lscodec_bits_ByteVector$Chunk };
$h_Lscodec_bits_ByteVector$Chunk.prototype = $c_Lscodec_bits_ByteVector$Chunk.prototype;
$c_Lscodec_bits_ByteVector$Chunk.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_bits_ByteVector$Chunk.prototype.productArity__I = (function() {
  return 1;
});
$c_Lscodec_bits_ByteVector$Chunk.prototype.productPrefix__T = (function() {
  return "Chunk";
});
$c_Lscodec_bits_ByteVector$Chunk.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_bits_ByteVector$Chunk__f_bytes;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_ByteVector$Chunk.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "bytes";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_ByteVector$Chunk.prototype.size__J = (function() {
  return this.Lscodec_bits_ByteVector$Chunk__f_bytes.Lscodec_bits_ByteVector$View__f_size;
});
$c_Lscodec_bits_ByteVector$Chunk.prototype.getImpl__J__B = (function(i) {
  return this.Lscodec_bits_ByteVector$Chunk__f_bytes.apply__J__B(i);
});
function $isArrayOf_Lscodec_bits_ByteVector$Chunk(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_ByteVector$Chunk)));
}
export { $isArrayOf_Lscodec_bits_ByteVector$Chunk as $isArrayOf_Lscodec_bits_ByteVector$Chunk };
var $d_Lscodec_bits_ByteVector$Chunk = new $TypeData().initClass($c_Lscodec_bits_ByteVector$Chunk, "scodec.bits.ByteVector$Chunk", ({
  Lscodec_bits_ByteVector$Chunk: 1,
  Lscodec_bits_ByteVector: 1,
  Lscodec_bits_ByteVectorCrossPlatform: 1,
  Lscodec_bits_BitwiseOperations: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lscodec_bits_ByteVector$Chunk as $d_Lscodec_bits_ByteVector$Chunk };
function $p_Lscodec_bits_ByteVector$Chunks__go$10__Lscodec_bits_ByteVector$Append__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector($thiz, chunks, last) {
  var last$tailLocal1 = last;
  var chunks$tailLocal1 = chunks;
  while (true) {
    var t = last$tailLocal1.size__J();
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var b = chunks$tailLocal1.Lscodec_bits_ByteVector$Append__f_size;
    var bhi = b.RTLong__f_hi;
    if (((hi === bhi) ? ((lo >>> 0) >= (b.RTLong__f_lo >>> 0)) : (hi > bhi))) {
      var $x_1 = true;
    } else {
      var lo$1 = (lo << 1);
      var hi$1 = (((lo >>> 31) | 0) | (hi << 1));
      var b$1 = chunks$tailLocal1.Lscodec_bits_ByteVector$Append__f_right.size__J();
      var bhi$1 = b$1.RTLong__f_hi;
      var $x_1 = ((hi$1 === bhi$1) ? ((lo$1 >>> 0) <= (b$1.RTLong__f_lo >>> 0)) : (hi$1 < bhi$1));
    }
    if ($x_1) {
      var left = chunks$tailLocal1;
      var right = last$tailLocal1;
      var chunks$1 = new $c_Lscodec_bits_ByteVector$Append(left, right);
      return new $c_Lscodec_bits_ByteVector$Chunks(chunks$1);
    } else {
      var x186 = chunks$tailLocal1.Lscodec_bits_ByteVector$Append__f_left;
      if ((x186 instanceof $c_Lscodec_bits_ByteVector$Append)) {
        var left$1 = chunks$tailLocal1.Lscodec_bits_ByteVector$Append__f_right;
        var right$1 = last$tailLocal1;
        var last$tailLocal1$tmp1 = new $c_Lscodec_bits_ByteVector$Append(left$1, right$1);
        chunks$tailLocal1 = x186;
        last$tailLocal1 = last$tailLocal1$tmp1;
        continue;
      }
      var left$2 = chunks$tailLocal1;
      var right$2 = last$tailLocal1;
      var chunks$2 = new $c_Lscodec_bits_ByteVector$Append(left$2, right$2);
      return new $c_Lscodec_bits_ByteVector$Chunks(chunks$2);
    }
  }
}
export { $p_Lscodec_bits_ByteVector$Chunks__go$10__Lscodec_bits_ByteVector$Append__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector as $p_Lscodec_bits_ByteVector$Chunks__go$10__Lscodec_bits_ByteVector$Append__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector };
/** @constructor */
function $c_Lscodec_bits_ByteVector$Chunks(chunks) {
  this.Lscodec_bits_ByteVector__f_hashCode$lzy1 = 0;
  this.Lscodec_bits_ByteVector__f_hashCodebitmap$1 = false;
  this.Lscodec_bits_ByteVector$Chunks__f_chunks = null;
  this.Lscodec_bits_ByteVector$Chunks__f_chunks = chunks;
}
export { $c_Lscodec_bits_ByteVector$Chunks as $c_Lscodec_bits_ByteVector$Chunks };
$c_Lscodec_bits_ByteVector$Chunks.prototype = new $h_Lscodec_bits_ByteVector();
$c_Lscodec_bits_ByteVector$Chunks.prototype.constructor = $c_Lscodec_bits_ByteVector$Chunks;
/** @constructor */
function $h_Lscodec_bits_ByteVector$Chunks() {
}
export { $h_Lscodec_bits_ByteVector$Chunks as $h_Lscodec_bits_ByteVector$Chunks };
$h_Lscodec_bits_ByteVector$Chunks.prototype = $c_Lscodec_bits_ByteVector$Chunks.prototype;
$c_Lscodec_bits_ByteVector$Chunks.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lscodec_bits_ByteVector$Chunks.prototype.productArity__I = (function() {
  return 1;
});
$c_Lscodec_bits_ByteVector$Chunks.prototype.productPrefix__T = (function() {
  return "Chunks";
});
$c_Lscodec_bits_ByteVector$Chunks.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lscodec_bits_ByteVector$Chunks__f_chunks;
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_ByteVector$Chunks.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "chunks";
  }
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lscodec_bits_ByteVector$Chunks.prototype.size__J = (function() {
  return this.Lscodec_bits_ByteVector$Chunks__f_chunks.Lscodec_bits_ByteVector$Append__f_size;
});
$c_Lscodec_bits_ByteVector$Chunks.prototype.getImpl__J__B = (function(n) {
  return this.Lscodec_bits_ByteVector$Chunks__f_chunks.getImpl__J__B(n);
});
$c_Lscodec_bits_ByteVector$Chunks.prototype.$plus$plus__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector = (function(b) {
  return (b.isEmpty__Z() ? this : (this.isEmpty__Z() ? b : $p_Lscodec_bits_ByteVector$Chunks__go$10__Lscodec_bits_ByteVector$Append__Lscodec_bits_ByteVector__Lscodec_bits_ByteVector(this, this.Lscodec_bits_ByteVector$Chunks__f_chunks, b.unbuffer__Lscodec_bits_ByteVector())));
});
function $isArrayOf_Lscodec_bits_ByteVector$Chunks(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lscodec_bits_ByteVector$Chunks)));
}
export { $isArrayOf_Lscodec_bits_ByteVector$Chunks as $isArrayOf_Lscodec_bits_ByteVector$Chunks };
var $d_Lscodec_bits_ByteVector$Chunks = new $TypeData().initClass($c_Lscodec_bits_ByteVector$Chunks, "scodec.bits.ByteVector$Chunks", ({
  Lscodec_bits_ByteVector$Chunks: 1,
  Lscodec_bits_ByteVector: 1,
  Lscodec_bits_ByteVectorCrossPlatform: 1,
  Lscodec_bits_BitwiseOperations: 1,
  jl_Comparable: 1,
  s_math_Ordered: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1
}));
export { $d_Lscodec_bits_ByteVector$Chunks as $d_Lscodec_bits_ByteVector$Chunks };
/** @constructor */
function $c_Lsttp_tapir_DecodeResult$Missing$() {
}
export { $c_Lsttp_tapir_DecodeResult$Missing$ as $c_Lsttp_tapir_DecodeResult$Missing$ };
$c_Lsttp_tapir_DecodeResult$Missing$.prototype = new $h_O();
$c_Lsttp_tapir_DecodeResult$Missing$.prototype.constructor = $c_Lsttp_tapir_DecodeResult$Missing$;
/** @constructor */
function $h_Lsttp_tapir_DecodeResult$Missing$() {
}
export { $h_Lsttp_tapir_DecodeResult$Missing$ as $h_Lsttp_tapir_DecodeResult$Missing$ };
$h_Lsttp_tapir_DecodeResult$Missing$.prototype = $c_Lsttp_tapir_DecodeResult$Missing$.prototype;
$c_Lsttp_tapir_DecodeResult$Missing$.prototype.map__F1__Lsttp_tapir_DecodeResult = (function(f) {
  return this;
});
$c_Lsttp_tapir_DecodeResult$Missing$.prototype.flatMap__F1__Lsttp_tapir_DecodeResult = (function(f) {
  return this;
});
$c_Lsttp_tapir_DecodeResult$Missing$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_DecodeResult$Missing$.prototype.hashCode__I = (function() {
  return (-1560864442);
});
$c_Lsttp_tapir_DecodeResult$Missing$.prototype.toString__T = (function() {
  return "Missing";
});
$c_Lsttp_tapir_DecodeResult$Missing$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_DecodeResult$Missing$.prototype.productPrefix__T = (function() {
  return "Missing";
});
$c_Lsttp_tapir_DecodeResult$Missing$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_DecodeResult$Missing$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_DecodeResult$Missing$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_tapir_DecodeResult$Missing$ = new $TypeData().initClass($c_Lsttp_tapir_DecodeResult$Missing$, "sttp.tapir.DecodeResult$Missing$", ({
  Lsttp_tapir_DecodeResult$Missing$: 1,
  Lsttp_tapir_DecodeResult: 1,
  Lsttp_tapir_DecodeResult$Failure: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_tapir_DecodeResult$Missing$ as $d_Lsttp_tapir_DecodeResult$Missing$ };
var $n_Lsttp_tapir_DecodeResult$Missing$;
function $m_Lsttp_tapir_DecodeResult$Missing$() {
  if ((!$n_Lsttp_tapir_DecodeResult$Missing$)) {
    $n_Lsttp_tapir_DecodeResult$Missing$ = new $c_Lsttp_tapir_DecodeResult$Missing$();
  }
  return $n_Lsttp_tapir_DecodeResult$Missing$;
}
export { $m_Lsttp_tapir_DecodeResult$Missing$ as $m_Lsttp_tapir_DecodeResult$Missing$ };
/** @constructor */
function $c_Lsttp_tapir_RawBodyType$ByteArrayBody$() {
}
export { $c_Lsttp_tapir_RawBodyType$ByteArrayBody$ as $c_Lsttp_tapir_RawBodyType$ByteArrayBody$ };
$c_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype = new $h_O();
$c_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype.constructor = $c_Lsttp_tapir_RawBodyType$ByteArrayBody$;
/** @constructor */
function $h_Lsttp_tapir_RawBodyType$ByteArrayBody$() {
}
export { $h_Lsttp_tapir_RawBodyType$ByteArrayBody$ as $h_Lsttp_tapir_RawBodyType$ByteArrayBody$ };
$h_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype = $c_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype;
$c_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_s_Product$$anon$1(this);
});
$c_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype.hashCode__I = (function() {
  return 466936659;
});
$c_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype.toString__T = (function() {
  return "ByteArrayBody";
});
$c_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype.productPrefix__T = (function() {
  return "ByteArrayBody";
});
$c_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype.productElement__I__O = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype.productElementName__I__T = (function(n) {
  throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lsttp_tapir_RawBodyType$ByteArrayBody$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lsttp_tapir_RawBodyType$ByteArrayBody$ = new $TypeData().initClass($c_Lsttp_tapir_RawBodyType$ByteArrayBody$, "sttp.tapir.RawBodyType$ByteArrayBody$", ({
  Lsttp_tapir_RawBodyType$ByteArrayBody$: 1,
  Lsttp_tapir_RawBodyType: 1,
  Lsttp_tapir_RawBodyType$Binary: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lsttp_tapir_RawBodyType$ByteArrayBody$ as $d_Lsttp_tapir_RawBodyType$ByteArrayBody$ };
var $n_Lsttp_tapir_RawBodyType$ByteArrayBody$;
function $m_Lsttp_tapir_RawBodyType$ByteArrayBody$() {
  if ((!$n_Lsttp_tapir_RawBodyType$ByteArrayBody$)) {
    $n_Lsttp_tapir_RawBodyType$ByteArrayBody$ = new $c_Lsttp_tapir_RawBodyType$ByteArrayBody$();
  }
  return $n_Lsttp_tapir_RawBodyType$ByteArrayBody$;
}
export { $m_Lsttp_tapir_RawBodyType$ByteArrayBody$ as $m_Lsttp_tapir_RawBodyType$ByteArrayBody$ };
function $f_Lcats_ApplicativeError__handleError__O__F1__O($thiz, fa, f) {
  return $thiz.handleErrorWith__O__F1__O(fa, f.andThen__F1__F1(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x) => $thiz.pure__O__O(x)))));
}
export { $f_Lcats_ApplicativeError__handleError__O__F1__O as $f_Lcats_ApplicativeError__handleError__O__F1__O };
function $f_Lcats_ApplicativeError__attempt__O__O($thiz, fa) {
  return $thiz.handleErrorWith__O__F1__O($thiz.map__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => new $c_s_util_Right(_$2)))), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e) => $thiz.pure__O__O(new $c_s_util_Left(e)))));
}
export { $f_Lcats_ApplicativeError__attempt__O__O as $f_Lcats_ApplicativeError__attempt__O__O };
function $f_Lcats_ApplicativeError__recoverWith__O__s_PartialFunction__O($thiz, fa, pf) {
  return $thiz.handleErrorWith__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e) => pf.applyOrElse__O__F1__O(e, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e$2) => $thiz.raiseError__O__O(e$2)))))));
}
export { $f_Lcats_ApplicativeError__recoverWith__O__s_PartialFunction__O as $f_Lcats_ApplicativeError__recoverWith__O__s_PartialFunction__O };
function $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O($thiz, fa, pf) {
  return $thiz.handleErrorWith__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e) => pf.andThen__F1__s_PartialFunction(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => $thiz.map2__O__O__F2__O(_$6, $thiz.raiseError__O__O(e), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$7, b) => b)))))).applyOrElse__O__F1__O(e, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((e$3) => $thiz.raiseError__O__O(e$3)))))));
}
export { $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O as $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O };
function $f_Lcats_ComposedApply__ap__O__O__O($thiz, fgf, fga) {
  return $thiz.F__Lcats_Apply().ap__O__O__O($thiz.F__Lcats_Apply().map__O__F1__O(fgf, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((gf) => new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((ga) => $thiz.G__Lcats_Applicative().ap__O__O__O(gf, ga)))))), fga);
}
export { $f_Lcats_ComposedApply__ap__O__O__O as $f_Lcats_ComposedApply__ap__O__O__O };
function $f_Lcats_ComposedApply__product__O__O__O($thiz, fga, fgb) {
  var $x_1 = $thiz.F__Lcats_Apply();
  var \u03b41$ = $thiz.G__Lcats_Applicative();
  return $x_1.map2__O__O__F2__O(fga, fgb, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((fa, fb) => \u03b41$.product__O__O__O(fa, fb))));
}
export { $f_Lcats_ComposedApply__product__O__O__O as $f_Lcats_ComposedApply__product__O__O__O };
function $f_Lcom_raquo_airstream_common_MultiParentStream__onWillStart__V($thiz) {
  var arr = $thiz.parents__Lcom_raquo_ew_JsArray();
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$1 = arr[i];
    $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(_$1);
    i = ((1 + i) | 0);
  }
}
export { $f_Lcom_raquo_airstream_common_MultiParentStream__onWillStart__V as $f_Lcom_raquo_airstream_common_MultiParentStream__onWillStart__V };
function $p_Lcom_raquo_airstream_timing_JsPromiseSignal__lazyPromise__sjs_js_Promise($thiz) {
  if ((!$thiz.Lcom_raquo_airstream_timing_JsPromiseSignal__f_lazyPromisebitmap$1)) {
    $thiz.Lcom_raquo_airstream_timing_JsPromiseSignal__f_lazyPromise$lzy1 = $thiz.Lcom_raquo_airstream_timing_JsPromiseSignal__f_promise.apply__O();
    $thiz.Lcom_raquo_airstream_timing_JsPromiseSignal__f_lazyPromisebitmap$1 = true;
    $thiz.Lcom_raquo_airstream_timing_JsPromiseSignal__f_promise = null;
  }
  return $thiz.Lcom_raquo_airstream_timing_JsPromiseSignal__f_lazyPromise$lzy1;
}
export { $p_Lcom_raquo_airstream_timing_JsPromiseSignal__lazyPromise__sjs_js_Promise as $p_Lcom_raquo_airstream_timing_JsPromiseSignal__lazyPromise__sjs_js_Promise };
function $p_Lcom_raquo_airstream_timing_JsPromiseSignal__onPromiseResolved__s_util_Try__V($thiz, nextPromiseValue) {
  var nextValue = nextPromiseValue.map__F1__s_util_Try(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => new $c_s_Some(_$1))));
  var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, _$2);
  }));
  new $c_Lcom_raquo_airstream_core_Transaction(code);
}
export { $p_Lcom_raquo_airstream_timing_JsPromiseSignal__onPromiseResolved__s_util_Try__V as $p_Lcom_raquo_airstream_timing_JsPromiseSignal__onPromiseResolved__s_util_Try__V };
/** @constructor */
function $c_Lcom_raquo_airstream_timing_JsPromiseSignal(promise) {
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_externalObservers = null;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_internalObservers = null;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_willStartDone = false;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_promise = null;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_topoRank = 0;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_promiseSubscribed = false;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_lazyPromise$lzy1 = null;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_lazyPromisebitmap$1 = false;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_promise = promise;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f__lastUpdateId = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_maybeLastSeenCurrentValue = (void 0);
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_topoRank = 1;
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_promiseSubscribed = false;
  var value = $m_s_None$();
  var newValue = new $c_s_util_Success(value);
  $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V(this, newValue);
}
export { $c_Lcom_raquo_airstream_timing_JsPromiseSignal as $c_Lcom_raquo_airstream_timing_JsPromiseSignal };
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype = new $h_O();
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.constructor = $c_Lcom_raquo_airstream_timing_JsPromiseSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_JsPromiseSignal() {
}
export { $h_Lcom_raquo_airstream_timing_JsPromiseSignal as $h_Lcom_raquo_airstream_timing_JsPromiseSignal };
$h_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype = $c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype;
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.onStop__V = (function() {
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype._lastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseSignal__f__lastUpdateId;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype._lastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f__lastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_core_Signal__onStart__V(this);
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
  observer.onTry__s_util_Try__V($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_externalObservers;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_internalObservers;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_willStartDone;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.maybeLastSeenCurrentValue__O = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_maybeLastSeenCurrentValue;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.maybeLastSeenCurrentValue_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_maybeLastSeenCurrentValue = x$1;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.tryNow__s_util_Try = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_topoRank;
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.currentValueFromParent__s_util_Try = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.onWillStart__V = (function() {
  if ((!this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_promiseSubscribed)) {
    this.Lcom_raquo_airstream_timing_JsPromiseSignal__f_promiseSubscribed = true;
    $p_Lcom_raquo_airstream_timing_JsPromiseSignal__lazyPromise__sjs_js_Promise(this).then(((nextValue) => {
      $p_Lcom_raquo_airstream_timing_JsPromiseSignal__onPromiseResolved__s_util_Try__V(this, new $c_s_util_Success(nextValue));
    }), ((rawException) => {
      var nextError = ((rawException instanceof $c_jl_Throwable) ? rawException : new $c_sjs_js_JavaScriptException(rawException));
      $p_Lcom_raquo_airstream_timing_JsPromiseSignal__onPromiseResolved__s_util_Try__V(this, new $c_s_util_Failure(nextError));
    }));
  }
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$c_Lcom_raquo_airstream_timing_JsPromiseSignal.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_JsPromiseSignal = new $TypeData().initClass($c_Lcom_raquo_airstream_timing_JsPromiseSignal, "com.raquo.airstream.timing.JsPromiseSignal", ({
  Lcom_raquo_airstream_timing_JsPromiseSignal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1
}));
export { $d_Lcom_raquo_airstream_timing_JsPromiseSignal as $d_Lcom_raquo_airstream_timing_JsPromiseSignal };
function $p_Lcom_raquo_airstream_timing_JsPromiseStream__lazyPromise__sjs_js_Promise($thiz) {
  if ((!$thiz.Lcom_raquo_airstream_timing_JsPromiseStream__f_lazyPromisebitmap$1)) {
    $thiz.Lcom_raquo_airstream_timing_JsPromiseStream__f_lazyPromise$lzy1 = $thiz.Lcom_raquo_airstream_timing_JsPromiseStream__f_promise.apply__O();
    $thiz.Lcom_raquo_airstream_timing_JsPromiseStream__f_lazyPromisebitmap$1 = true;
    $thiz.Lcom_raquo_airstream_timing_JsPromiseStream__f_promise = null;
  }
  return $thiz.Lcom_raquo_airstream_timing_JsPromiseStream__f_lazyPromise$lzy1;
}
export { $p_Lcom_raquo_airstream_timing_JsPromiseStream__lazyPromise__sjs_js_Promise as $p_Lcom_raquo_airstream_timing_JsPromiseStream__lazyPromise__sjs_js_Promise };
/** @constructor */
function $c_Lcom_raquo_airstream_timing_JsPromiseStream(promise, emitOnce) {
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_promise = null;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_emitOnce = false;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_shouldSubscribe = false;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_isPending = false;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_lazyPromise$lzy1 = null;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_lazyPromisebitmap$1 = false;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_promise = promise;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_emitOnce = emitOnce;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_topoRank = 1;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_shouldSubscribe = true;
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_isPending = false;
}
export { $c_Lcom_raquo_airstream_timing_JsPromiseStream as $c_Lcom_raquo_airstream_timing_JsPromiseStream };
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype = new $h_O();
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.constructor = $c_Lcom_raquo_airstream_timing_JsPromiseStream;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_JsPromiseStream() {
}
export { $h_Lcom_raquo_airstream_timing_JsPromiseStream as $h_Lcom_raquo_airstream_timing_JsPromiseStream };
$h_Lcom_raquo_airstream_timing_JsPromiseStream.prototype = $c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype;
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.onStart__V = (function() {
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.onStop__V = (function() {
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_JsPromiseStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_timing_JsPromiseStream__f_topoRank;
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.onWillStart__V = (function() {
  if ((this.Lcom_raquo_airstream_timing_JsPromiseStream__f_shouldSubscribe && (!this.Lcom_raquo_airstream_timing_JsPromiseStream__f_isPending))) {
    if (this.Lcom_raquo_airstream_timing_JsPromiseStream__f_emitOnce) {
      this.Lcom_raquo_airstream_timing_JsPromiseStream__f_shouldSubscribe = false;
    }
    this.Lcom_raquo_airstream_timing_JsPromiseStream__f_isPending = true;
    $p_Lcom_raquo_airstream_timing_JsPromiseStream__lazyPromise__sjs_js_Promise(this).then(((nextValue) => {
      this.Lcom_raquo_airstream_timing_JsPromiseStream__f_isPending = false;
      var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
        $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, _$1);
      }));
      new $c_Lcom_raquo_airstream_core_Transaction(code);
    }), ((rawException) => {
      this.Lcom_raquo_airstream_timing_JsPromiseStream__f_isPending = false;
      var nextError = ((rawException instanceof $c_jl_Throwable) ? rawException : new $c_sjs_js_JavaScriptException(rawException));
      var code$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
        $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, _$2);
      }));
      new $c_Lcom_raquo_airstream_core_Transaction(code$1);
    }));
  }
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_timing_JsPromiseStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_JsPromiseStream = new $TypeData().initClass($c_Lcom_raquo_airstream_timing_JsPromiseStream, "com.raquo.airstream.timing.JsPromiseStream", ({
  Lcom_raquo_airstream_timing_JsPromiseStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1
}));
export { $d_Lcom_raquo_airstream_timing_JsPromiseStream as $d_Lcom_raquo_airstream_timing_JsPromiseStream };
function $p_Lcom_raquo_airstream_timing_PeriodicStream__resetTo__O__Z__V($thiz, value, tickNext) {
  $p_Lcom_raquo_airstream_timing_PeriodicStream__clearTimeout__V($thiz);
  $thiz.Lcom_raquo_airstream_timing_PeriodicStream__f_currentValue = value;
  if ((tickNext && $f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz))) {
    $p_Lcom_raquo_airstream_timing_PeriodicStream__tick__V($thiz);
  }
}
export { $p_Lcom_raquo_airstream_timing_PeriodicStream__resetTo__O__Z__V as $p_Lcom_raquo_airstream_timing_PeriodicStream__resetTo__O__Z__V };
function $p_Lcom_raquo_airstream_timing_PeriodicStream__clearTimeout__V($thiz) {
  var x = $thiz.Lcom_raquo_airstream_timing_PeriodicStream__f_maybeTimeoutHandle;
  if ((x !== (void 0))) {
    $m_sjs_js_timers_package$().clearTimeout__sjs_js_timers_SetTimeoutHandle__V(x);
  }
  $thiz.Lcom_raquo_airstream_timing_PeriodicStream__f_maybeTimeoutHandle = (void 0);
}
export { $p_Lcom_raquo_airstream_timing_PeriodicStream__clearTimeout__V as $p_Lcom_raquo_airstream_timing_PeriodicStream__clearTimeout__V };
function $p_Lcom_raquo_airstream_timing_PeriodicStream__tick__V($thiz) {
  var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((trx) => {
    if ($f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z($thiz)) {
      var nextValue = $thiz.Lcom_raquo_airstream_timing_PeriodicStream__f_currentValue;
      $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V($thiz, nextValue, trx);
      $p_Lcom_raquo_airstream_timing_PeriodicStream__setNext__V($thiz);
    }
  }));
  new $c_Lcom_raquo_airstream_core_Transaction(code);
}
export { $p_Lcom_raquo_airstream_timing_PeriodicStream__tick__V as $p_Lcom_raquo_airstream_timing_PeriodicStream__tick__V };
function $p_Lcom_raquo_airstream_timing_PeriodicStream__setNext__V($thiz) {
  try {
    var r1 = $thiz.Lcom_raquo_airstream_timing_PeriodicStream__f_next.apply__O__O($thiz.Lcom_raquo_airstream_timing_PeriodicStream__f_currentValue);
    var x1 = new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var x1;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var x1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  if ((x1 instanceof $c_s_util_Success)) {
    var x7 = x1.s_util_Success__f_value;
    if ((x7 instanceof $c_s_Some)) {
      var x9 = x7.s_Some__f_value;
      if ((x9 !== null)) {
        var nextValue = x9._1__O();
        var nextIntervalMs = (x9._2__O() | 0);
        $thiz.Lcom_raquo_airstream_timing_PeriodicStream__f_currentValue = nextValue;
        $thiz.Lcom_raquo_airstream_timing_PeriodicStream__f_maybeTimeoutHandle = $m_sjs_js_timers_package$().setTimeout__D__F0__sjs_js_timers_SetTimeoutHandle(nextIntervalMs, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
          $p_Lcom_raquo_airstream_timing_PeriodicStream__tick__V($thiz);
        })));
        return (void 0);
      }
    }
    var x = $m_s_None$();
    if ((x === x7)) {
      $p_Lcom_raquo_airstream_timing_PeriodicStream__resetTo__O__Z__V($thiz, $thiz.Lcom_raquo_airstream_timing_PeriodicStream__f_initial, false);
      return (void 0);
    }
  }
  if ((x1 instanceof $c_s_util_Failure)) {
    var err = x1.s_util_Failure__f_exception;
    var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V($thiz, err, _$1);
    }));
    new $c_Lcom_raquo_airstream_core_Transaction(code);
    return (void 0);
  }
  throw new $c_s_MatchError(x1);
}
export { $p_Lcom_raquo_airstream_timing_PeriodicStream__setNext__V as $p_Lcom_raquo_airstream_timing_PeriodicStream__setNext__V };
/** @constructor */
function $c_Lcom_raquo_airstream_timing_PeriodicStream(initial, next, resetOnStop) {
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_initial = null;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_next = null;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_resetOnStop = false;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_currentValue = null;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_maybeTimeoutHandle = null;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_initial = initial;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_next = next;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_resetOnStop = resetOnStop;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_topoRank = 1;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_currentValue = initial;
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_maybeTimeoutHandle = (void 0);
}
export { $c_Lcom_raquo_airstream_timing_PeriodicStream as $c_Lcom_raquo_airstream_timing_PeriodicStream };
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype = new $h_O();
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.constructor = $c_Lcom_raquo_airstream_timing_PeriodicStream;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_PeriodicStream() {
}
export { $h_Lcom_raquo_airstream_timing_PeriodicStream as $h_Lcom_raquo_airstream_timing_PeriodicStream };
$h_Lcom_raquo_airstream_timing_PeriodicStream.prototype = $c_Lcom_raquo_airstream_timing_PeriodicStream.prototype;
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_timing_PeriodicStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_timing_PeriodicStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_timing_PeriodicStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_PeriodicStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_PeriodicStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_timing_PeriodicStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_PeriodicStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_timing_PeriodicStream__f_topoRank;
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.onWillStart__V = (function() {
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.onStart__V = (function() {
  $p_Lcom_raquo_airstream_timing_PeriodicStream__tick__V(this);
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.onStop__V = (function() {
  $p_Lcom_raquo_airstream_timing_PeriodicStream__clearTimeout__V(this);
  if (this.Lcom_raquo_airstream_timing_PeriodicStream__f_resetOnStop) {
    var value = this.Lcom_raquo_airstream_timing_PeriodicStream__f_initial;
    $p_Lcom_raquo_airstream_timing_PeriodicStream__resetTo__O__Z__V(this, value, true);
  }
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_timing_PeriodicStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_PeriodicStream = new $TypeData().initClass($c_Lcom_raquo_airstream_timing_PeriodicStream, "com.raquo.airstream.timing.PeriodicStream", ({
  Lcom_raquo_airstream_timing_PeriodicStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1
}));
export { $d_Lcom_raquo_airstream_timing_PeriodicStream as $d_Lcom_raquo_airstream_timing_PeriodicStream };
/** @constructor */
function $c_Lframework_components_TextKind$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Lframework_components_TextKind$$anon$1__f_$name$1 = null;
  this.Lframework_components_TextKind$$anon$1__f__$ordinal$1 = 0;
  this.Lframework_components_TextKind$$anon$1__f_$name$1 = \u03b4name$2;
  this.Lframework_components_TextKind$$anon$1__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lframework_components_TextKind$$anon$1 as $c_Lframework_components_TextKind$$anon$1 };
$c_Lframework_components_TextKind$$anon$1.prototype = new $h_Lframework_components_TextKind();
$c_Lframework_components_TextKind$$anon$1.prototype.constructor = $c_Lframework_components_TextKind$$anon$1;
/** @constructor */
function $h_Lframework_components_TextKind$$anon$1() {
}
export { $h_Lframework_components_TextKind$$anon$1 as $h_Lframework_components_TextKind$$anon$1 };
$h_Lframework_components_TextKind$$anon$1.prototype = $c_Lframework_components_TextKind$$anon$1.prototype;
$c_Lframework_components_TextKind$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_components_TextKind$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lframework_components_TextKind$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lframework_components_TextKind$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lframework_components_TextKind$$anon$1__f_$name$1;
});
$c_Lframework_components_TextKind$$anon$1.prototype.toString__T = (function() {
  return this.Lframework_components_TextKind$$anon$1__f_$name$1;
});
$c_Lframework_components_TextKind$$anon$1.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I(this.Lframework_components_TextKind$$anon$1__f_$name$1);
});
$c_Lframework_components_TextKind$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_components_TextKind$$anon$1 = new $TypeData().initClass($c_Lframework_components_TextKind$$anon$1, "framework.components.TextKind$$anon$1", ({
  Lframework_components_TextKind$$anon$1: 1,
  Lframework_components_TextKind: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_components_TextKind$$anon$1 as $d_Lframework_components_TextKind$$anon$1 };
/** @constructor */
function $c_Lframework_data_PageCursorDirection$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Lframework_data_PageCursorDirection$$anon$1__f_$name$1 = null;
  this.Lframework_data_PageCursorDirection$$anon$1__f__$ordinal$1 = 0;
  this.Lframework_data_PageCursorDirection$$anon$1__f_$name$1 = \u03b4name$2;
  this.Lframework_data_PageCursorDirection$$anon$1__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lframework_data_PageCursorDirection$$anon$1 as $c_Lframework_data_PageCursorDirection$$anon$1 };
$c_Lframework_data_PageCursorDirection$$anon$1.prototype = new $h_Lframework_data_PageCursorDirection();
$c_Lframework_data_PageCursorDirection$$anon$1.prototype.constructor = $c_Lframework_data_PageCursorDirection$$anon$1;
/** @constructor */
function $h_Lframework_data_PageCursorDirection$$anon$1() {
}
export { $h_Lframework_data_PageCursorDirection$$anon$1 as $h_Lframework_data_PageCursorDirection$$anon$1 };
$h_Lframework_data_PageCursorDirection$$anon$1.prototype = $c_Lframework_data_PageCursorDirection$$anon$1.prototype;
$c_Lframework_data_PageCursorDirection$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lframework_data_PageCursorDirection$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lframework_data_PageCursorDirection$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lframework_data_PageCursorDirection$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lframework_data_PageCursorDirection$$anon$1__f_$name$1;
});
$c_Lframework_data_PageCursorDirection$$anon$1.prototype.toString__T = (function() {
  return this.Lframework_data_PageCursorDirection$$anon$1__f_$name$1;
});
$c_Lframework_data_PageCursorDirection$$anon$1.prototype.hashCode__I = (function() {
  return $f_T__hashCode__I(this.Lframework_data_PageCursorDirection$$anon$1__f_$name$1);
});
$c_Lframework_data_PageCursorDirection$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lframework_data_PageCursorDirection$$anon$1 = new $TypeData().initClass($c_Lframework_data_PageCursorDirection$$anon$1, "framework.data.PageCursorDirection$$anon$1", ({
  Lframework_data_PageCursorDirection$$anon$1: 1,
  Lframework_data_PageCursorDirection: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lframework_data_PageCursorDirection$$anon$1 as $d_Lframework_data_PageCursorDirection$$anon$1 };
function $ct_ju_ArrayList__O__I__($thiz, innerInit, _size) {
  $thiz.ju_ArrayList__f__size = _size;
  $thiz.ju_ArrayList__f_innerJS = innerInit;
  $thiz.ju_ArrayList__f_innerWasm = null;
  return $thiz;
}
export { $ct_ju_ArrayList__O__I__ as $ct_ju_ArrayList__O__I__ };
function $ct_ju_ArrayList__I__($thiz, initialCapacity) {
  if ((initialCapacity < 0)) {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
  $ct_ju_ArrayList__O__I__($thiz, [], 0);
  return $thiz;
}
export { $ct_ju_ArrayList__I__ as $ct_ju_ArrayList__I__ };
function $ct_ju_ArrayList__($thiz) {
  $ct_ju_ArrayList__I__($thiz, 16);
  return $thiz;
}
export { $ct_ju_ArrayList__ as $ct_ju_ArrayList__ };
function $ct_ju_ArrayList__ju_Collection__($thiz, c) {
  $ct_ju_ArrayList__I__($thiz, c.size__I());
  $thiz.addAll__ju_Collection__Z(c);
  return $thiz;
}
export { $ct_ju_ArrayList__ju_Collection__ as $ct_ju_ArrayList__ju_Collection__ };
/** @constructor */
function $c_ju_ArrayList() {
  this.ju_ArrayList__f__size = 0;
  this.ju_ArrayList__f_innerJS = null;
  this.ju_ArrayList__f_innerWasm = null;
}
export { $c_ju_ArrayList as $c_ju_ArrayList };
$c_ju_ArrayList.prototype = new $h_ju_AbstractList();
$c_ju_ArrayList.prototype.constructor = $c_ju_ArrayList;
/** @constructor */
function $h_ju_ArrayList() {
}
export { $h_ju_ArrayList as $h_ju_ArrayList };
$h_ju_ArrayList.prototype = $c_ju_ArrayList.prototype;
$c_ju_ArrayList.prototype.size__I = (function() {
  return (this.ju_ArrayList__f_innerJS.length | 0);
});
$c_ju_ArrayList.prototype.get__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  return this.ju_ArrayList__f_innerJS[index];
});
$c_ju_ArrayList.prototype.set__I__O__O = (function(index, element) {
  var e = this.get__I__O(index);
  this.ju_ArrayList__f_innerJS[index] = element;
  return e;
});
$c_ju_ArrayList.prototype.add__O__Z = (function(e) {
  (this.ju_ArrayList__f_innerJS.push(e) | 0);
  return true;
});
$c_ju_ArrayList.prototype.add__I__O__V = (function(index, element) {
  this.checkIndexOnBounds__I__V(index);
  this.ju_ArrayList__f_innerJS.splice(index, 0, element);
});
$c_ju_ArrayList.prototype.remove__I__O = (function(index) {
  this.checkIndexInBounds__I__V(index);
  var array = this.ju_ArrayList__f_innerJS;
  return array.splice(index, 1)[0];
});
var $d_ju_ArrayList = new $TypeData().initClass($c_ju_ArrayList, "java.util.ArrayList", ({
  ju_ArrayList: 1,
  ju_AbstractList: 1,
  ju_AbstractCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  ju_List: 1,
  ju_SequencedCollection: 1,
  ju_RandomAccess: 1,
  jl_Cloneable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_ju_ArrayList as $d_ju_ArrayList };
function $ct_ju_Collections$UnmodifiableList__ju_List__($thiz, inner) {
  $ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner);
  return $thiz;
}
export { $ct_ju_Collections$UnmodifiableList__ju_List__ as $ct_ju_Collections$UnmodifiableList__ju_List__ };
/** @constructor */
function $c_ju_Collections$UnmodifiableList() {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false;
}
export { $c_ju_Collections$UnmodifiableList as $c_ju_Collections$UnmodifiableList };
$c_ju_Collections$UnmodifiableList.prototype = new $h_ju_Collections$UnmodifiableCollection();
$c_ju_Collections$UnmodifiableList.prototype.constructor = $c_ju_Collections$UnmodifiableList;
/** @constructor */
function $h_ju_Collections$UnmodifiableList() {
}
export { $h_ju_Collections$UnmodifiableList as $h_ju_Collections$UnmodifiableList };
$h_ju_Collections$UnmodifiableList.prototype = $c_ju_Collections$UnmodifiableList.prototype;
$c_ju_Collections$UnmodifiableList.prototype.get__I__O = (function(index) {
  return this.ju_Collections$UnmodifiableCollection__f_inner.get__I__O(index);
});
$c_ju_Collections$UnmodifiableList.prototype.equals__O__Z = (function(obj) {
  return this.ju_Collections$UnmodifiableCollection__f_inner.equals__O__Z(obj);
});
$c_ju_Collections$UnmodifiableList.prototype.hashCode__I = (function() {
  return this.ju_Collections$UnmodifiableCollection__f_inner.hashCode__I();
});
$c_ju_Collections$UnmodifiableList.prototype.set__I__O__O = (function(index, element) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_Collections$UnmodifiableList.prototype.remove__I__O = (function(index) {
  throw $ct_jl_UnsupportedOperationException__(new $c_jl_UnsupportedOperationException());
});
$c_ju_Collections$UnmodifiableList.prototype.listIterator__ju_ListIterator = (function() {
  return new $c_ju_Collections$UnmodifiableListIterator(this.ju_Collections$UnmodifiableCollection__f_inner.listIterator__ju_ListIterator());
});
/** @constructor */
function $c_sc_MapView$Values(underlying) {
  this.sc_MapView$Values__f_underlying = null;
  this.sc_MapView$Values__f_underlying = underlying;
}
export { $c_sc_MapView$Values as $c_sc_MapView$Values };
$c_sc_MapView$Values.prototype = new $h_sc_AbstractView();
$c_sc_MapView$Values.prototype.constructor = $c_sc_MapView$Values;
/** @constructor */
function $h_sc_MapView$Values() {
}
export { $h_sc_MapView$Values as $h_sc_MapView$Values };
$h_sc_MapView$Values.prototype = $c_sc_MapView$Values.prototype;
$c_sc_MapView$Values.prototype.iterator__sc_Iterator = (function() {
  return this.sc_MapView$Values__f_underlying.valuesIterator__sc_Iterator();
});
$c_sc_MapView$Values.prototype.knownSize__I = (function() {
  return this.sc_MapView$Values__f_underlying.knownSize__I();
});
$c_sc_MapView$Values.prototype.isEmpty__Z = (function() {
  return this.sc_MapView$Values__f_underlying.isEmpty__Z();
});
var $d_sc_MapView$Values = new $TypeData().initClass($c_sc_MapView$Values, "scala.collection.MapView$Values", ({
  sc_MapView$Values: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_MapView$Values as $d_sc_MapView$Values };
function $f_sc_Seq__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true;
  } else {
    if ($is_sc_Seq(o)) {
      if (o.canEqual__O__Z($thiz)) {
        return $thiz.sameElements__sc_IterableOnce__Z(o);
      }
    }
    return false;
  }
}
export { $f_sc_Seq__equals__O__Z as $f_sc_Seq__equals__O__Z };
function $is_sc_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Seq)));
}
export { $is_sc_Seq as $is_sc_Seq };
function $isArrayOf_sc_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Seq)));
}
export { $isArrayOf_sc_Seq as $isArrayOf_sc_Seq };
function $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq($thiz) {
  if ((!$thiz.sc_SeqView$Sorted__f_bitmap$0)) {
    var len = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
    if ((len === 0)) {
      var res = $m_sci_Nil$();
    } else if ((len === 1)) {
      var x0 = $thiz.sc_SeqView$Sorted__f_underlying.head__O();
      var array = [x0];
      var elems = $ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $c_sjsr_WrappedVarArgs(), array);
      var res = $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(elems);
    } else {
      var arr = new $ac_O(len);
      var this$5 = $thiz.sc_SeqView$Sorted__f_underlying;
      this$5.copyToArray__O__I__I__I(arr, 0, 2147483647);
      var comparator = $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
      $m_ju_Arrays$().sort__AO__ju_Comparator__V(arr, comparator);
      var res = $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(arr);
    }
    $thiz.sc_SeqView$Sorted__f_evaluated = true;
    $thiz.sc_SeqView$Sorted__f_underlying = null;
    $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = res;
    $thiz.sc_SeqView$Sorted__f_bitmap$0 = true;
  }
  return $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted;
}
export { $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq as $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq };
function $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, len, ord) {
  $thiz.sc_SeqView$Sorted__f_underlying = underlying;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = len;
  $thiz.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = ord;
  $thiz.sc_SeqView$Sorted__f_evaluated = false;
  return $thiz;
}
export { $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__ as $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__ };
function $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__($thiz, underlying, ord) {
  $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__($thiz, underlying, underlying.length__I(), ord);
  return $thiz;
}
export { $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__ as $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__ };
/** @constructor */
function $c_sc_SeqView$Sorted() {
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted = null;
  this.sc_SeqView$Sorted__f_underlying = null;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len = 0;
  this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord = null;
  this.sc_SeqView$Sorted__f_evaluated = false;
  this.sc_SeqView$Sorted__f_bitmap$0 = false;
}
export { $c_sc_SeqView$Sorted as $c_sc_SeqView$Sorted };
$c_sc_SeqView$Sorted.prototype = new $h_O();
$c_sc_SeqView$Sorted.prototype.constructor = $c_sc_SeqView$Sorted;
/** @constructor */
function $h_sc_SeqView$Sorted() {
}
export { $h_sc_SeqView$Sorted as $h_sc_SeqView$Sorted };
$h_sc_SeqView$Sorted.prototype = $c_sc_SeqView$Sorted.prototype;
$c_sc_SeqView$Sorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$();
});
$c_sc_SeqView$Sorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_SeqView$Sorted.prototype.className__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Sorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder();
});
$c_sc_SeqView$Sorted.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Sorted.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Sorted.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_sc_SeqView$Sorted$ReverseSorted(this).iterator__sc_Iterator();
});
$c_sc_SeqView$Sorted.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_SeqView$Sorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.iterator__sc_Iterator(), p, from);
});
$c_sc_SeqView$Sorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Sorted.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem);
});
$c_sc_SeqView$Sorted.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O();
});
$c_sc_SeqView$Sorted.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$c_sc_SeqView$Sorted.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_sc_SeqView$Sorted.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_sc_SeqView$Sorted.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sc_SeqView$Sorted.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sc_SeqView$Sorted.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_sc_SeqView$Sorted.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_sc_SeqView$Sorted.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sc_SeqView$Sorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sc_SeqView$Sorted.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_sc_SeqView$Sorted.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_SeqView$Sorted.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sc_SeqView$Sorted.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sc_SeqView$Sorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_SeqView$Sorted.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_SeqView$Sorted.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sc_SeqView$Sorted.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_SeqView$Sorted.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_sc_SeqView$Sorted.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$_sorted__sc_Seq = (function() {
  return ((!this.sc_SeqView$Sorted__f_bitmap$0) ? $p_sc_SeqView$Sorted___sorted$lzycompute__sc_Seq(this) : this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$_sorted);
});
$c_sc_SeqView$Sorted.prototype.scala$collection$SeqView$Sorted$$elems__sc_SeqOps = (function() {
  var orig = this.sc_SeqView$Sorted__f_underlying;
  return (this.sc_SeqView$Sorted__f_evaluated ? this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq() : orig);
});
$c_sc_SeqView$Sorted.prototype.apply__I__O = (function(i) {
  return this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq().apply__I__O(i);
});
$c_sc_SeqView$Sorted.prototype.length__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var xs = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => this.scala$collection$SeqView$Sorted$$_sorted__sc_Seq().iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs);
});
$c_sc_SeqView$Sorted.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted.prototype.isEmpty__Z = (function() {
  return (this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0);
});
$c_sc_SeqView$Sorted.prototype.reversed__sc_Iterable = (function() {
  return new $c_sc_SeqView$Sorted$ReverseSorted(this);
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : ord1.equals__O__Z(x$2))) {
    return this;
  } else {
    return (ord1.isReverseOf__s_math_Ordering__Z(this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? new $c_sc_SeqView$Sorted$ReverseSorted(this) : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), this.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1));
  }
});
$c_sc_SeqView$Sorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll);
});
$c_sc_SeqView$Sorted.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Sorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Sorted.prototype.take__I__O = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Sorted.prototype.appended__O__O = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Sorted.prototype.map__F1__O = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Sorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord);
});
var $d_sc_SeqView$Sorted = new $TypeData().initClass($c_sc_SeqView$Sorted, "scala.collection.SeqView$Sorted", ({
  sc_SeqView$Sorted: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_SeqView$Sorted as $d_sc_SeqView$Sorted };
function $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) {
  if ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0)) {
    $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed = $ct_sc_SeqView$Reverse__sc_SeqOps__(new $c_sc_SeqView$Reverse(), $thiz.sc_SeqView$Sorted$ReverseSorted__f_$outer.scala$collection$SeqView$Sorted$$_sorted__sc_Seq());
    $thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = true;
  }
  return $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed;
}
export { $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse as $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse };
function $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse($thiz) {
  return ((!$thiz.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0) ? $p_sc_SeqView$Sorted$ReverseSorted___reversed$lzycompute__sc_SeqView$Reverse($thiz) : $thiz.sc_SeqView$Sorted$ReverseSorted__f__reversed);
}
export { $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse as $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse };
/** @constructor */
function $c_sc_SeqView$Sorted$ReverseSorted(outer) {
  this.sc_SeqView$Sorted$ReverseSorted__f__reversed = null;
  this.sc_SeqView$Sorted$ReverseSorted__f_bitmap$0 = false;
  this.sc_SeqView$Sorted$ReverseSorted__f_$outer = null;
  this.sc_SeqView$Sorted$ReverseSorted__f_$outer = outer;
}
export { $c_sc_SeqView$Sorted$ReverseSorted as $c_sc_SeqView$Sorted$ReverseSorted };
$c_sc_SeqView$Sorted$ReverseSorted.prototype = new $h_O();
$c_sc_SeqView$Sorted$ReverseSorted.prototype.constructor = $c_sc_SeqView$Sorted$ReverseSorted;
/** @constructor */
function $h_sc_SeqView$Sorted$ReverseSorted() {
}
export { $h_sc_SeqView$Sorted$ReverseSorted as $h_sc_SeqView$Sorted$ReverseSorted };
$h_sc_SeqView$Sorted$ReverseSorted.prototype = $c_sc_SeqView$Sorted$ReverseSorted.prototype;
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_View$();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.className__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sc_View$().newBuilder__scm_Builder();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reverseIterator__sc_Iterator = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer.iterator__sc_Iterator();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.iterator__sc_Iterator(), p, from);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O();
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.headOption__s_Option = (function() {
  return $f_sc_IterableOps__headOption__s_Option(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.last__O = (function() {
  return $f_sc_IterableOps__last__O(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toSeq__sci_Seq = (function() {
  return $m_sci_Seq$().from__sc_IterableOnce__sci_Seq(this);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.apply__I__O = (function(i) {
  return $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this).apply__I__O(i);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.length__I = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.iterator__sc_Iterator = (function() {
  var this$2 = $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var xs = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $p_sc_SeqView$Sorted$ReverseSorted___reversed__sc_SeqView$Reverse(this).iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len;
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.isEmpty__Z = (function() {
  return (this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len === 0);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.reversed__sc_Iterable = (function() {
  return this.sc_SeqView$Sorted$ReverseSorted__f_$outer;
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__sc_SeqView = (function(ord1) {
  var x$2 = this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord;
  if (((ord1 === null) ? (x$2 === null) : ord1.equals__O__Z(x$2))) {
    return this.sc_SeqView$Sorted$ReverseSorted__f_$outer;
  } else {
    return (ord1.isReverseOf__s_math_Ordering__Z(this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$ord) ? this : $ct_sc_SeqView$Sorted__sc_SeqOps__I__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this.sc_SeqView$Sorted$ReverseSorted__f_$outer.scala$collection$SeqView$Sorted$$elems__sc_SeqOps(), this.sc_SeqView$Sorted$ReverseSorted__f_$outer.sc_SeqView$Sorted__f_scala$collection$SeqView$Sorted$$len, ord1));
  }
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sc_View$();
  return this$1.from__sc_IterableOnce__sc_View(coll);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.drop__I__O = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.take__I__O = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.appended__O__O = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.map__F1__O = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Sorted$ReverseSorted.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sc_SeqView(ord);
});
var $d_sc_SeqView$Sorted$ReverseSorted = new $TypeData().initClass($c_sc_SeqView$Sorted$ReverseSorted, "scala.collection.SeqView$Sorted$ReverseSorted", ({
  sc_SeqView$Sorted$ReverseSorted: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IterableOps: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_View: 1,
  sc_Iterable: 1,
  sc_IterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_SeqView$Sorted$ReverseSorted as $d_sc_SeqView$Sorted$ReverseSorted };
/** @constructor */
function $c_sc_View$$anon$1(it$1) {
  this.sc_View$$anon$1__f_it$1 = null;
  this.sc_View$$anon$1__f_it$1 = it$1;
}
export { $c_sc_View$$anon$1 as $c_sc_View$$anon$1 };
$c_sc_View$$anon$1.prototype = new $h_sc_AbstractView();
$c_sc_View$$anon$1.prototype.constructor = $c_sc_View$$anon$1;
/** @constructor */
function $h_sc_View$$anon$1() {
}
export { $h_sc_View$$anon$1 as $h_sc_View$$anon$1 };
$h_sc_View$$anon$1.prototype = $c_sc_View$$anon$1.prototype;
$c_sc_View$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return this.sc_View$$anon$1__f_it$1.apply__O();
});
var $d_sc_View$$anon$1 = new $TypeData().initClass($c_sc_View$$anon$1, "scala.collection.View$$anon$1", ({
  sc_View$$anon$1: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$$anon$1 as $d_sc_View$$anon$1 };
function $ct_sc_View$Appended__sc_IterableOps__O__($thiz, underlying, elem) {
  $thiz.sc_View$Appended__f_underlying = underlying;
  $thiz.sc_View$Appended__f_elem = elem;
  return $thiz;
}
export { $ct_sc_View$Appended__sc_IterableOps__O__ as $ct_sc_View$Appended__sc_IterableOps__O__ };
/** @constructor */
function $c_sc_View$Appended() {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null;
}
export { $c_sc_View$Appended as $c_sc_View$Appended };
$c_sc_View$Appended.prototype = new $h_sc_AbstractView();
$c_sc_View$Appended.prototype.constructor = $c_sc_View$Appended;
/** @constructor */
function $h_sc_View$Appended() {
}
export { $h_sc_View$Appended as $h_sc_View$Appended };
$h_sc_View$Appended.prototype = $c_sc_View$Appended.prototype;
$c_sc_View$Appended.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_View$Concat(this.sc_View$Appended__f_underlying, new $c_sc_View$Single(this.sc_View$Appended__f_elem)).iterator__sc_Iterator();
});
$c_sc_View$Appended.prototype.knownSize__I = (function() {
  var size = this.sc_View$Appended__f_underlying.knownSize__I();
  return ((size >= 0) ? ((1 + size) | 0) : (-1));
});
$c_sc_View$Appended.prototype.isEmpty__Z = (function() {
  return false;
});
var $d_sc_View$Appended = new $TypeData().initClass($c_sc_View$Appended, "scala.collection.View$Appended", ({
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$Appended as $d_sc_View$Appended };
/** @constructor */
function $c_sc_View$Collect(underlying, pf) {
  this.sc_View$Collect__f_underlying = null;
  this.sc_View$Collect__f_pf = null;
  this.sc_View$Collect__f_underlying = underlying;
  this.sc_View$Collect__f_pf = pf;
}
export { $c_sc_View$Collect as $c_sc_View$Collect };
$c_sc_View$Collect.prototype = new $h_sc_AbstractView();
$c_sc_View$Collect.prototype.constructor = $c_sc_View$Collect;
/** @constructor */
function $h_sc_View$Collect() {
}
export { $h_sc_View$Collect as $h_sc_View$Collect };
$h_sc_View$Collect.prototype = $c_sc_View$Collect.prototype;
$c_sc_View$Collect.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$Collect__f_underlying.iterator__sc_Iterator();
  var pf = this.sc_View$Collect__f_pf;
  return new $c_sc_Iterator$$anon$7(this$1, pf);
});
var $d_sc_View$Collect = new $TypeData().initClass($c_sc_View$Collect, "scala.collection.View$Collect", ({
  sc_View$Collect: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$Collect as $d_sc_View$Collect };
/** @constructor */
function $c_sc_View$Concat(prefix, suffix) {
  this.sc_View$Concat__f_prefix = null;
  this.sc_View$Concat__f_suffix = null;
  this.sc_View$Concat__f_prefix = prefix;
  this.sc_View$Concat__f_suffix = suffix;
}
export { $c_sc_View$Concat as $c_sc_View$Concat };
$c_sc_View$Concat.prototype = new $h_sc_AbstractView();
$c_sc_View$Concat.prototype.constructor = $c_sc_View$Concat;
/** @constructor */
function $h_sc_View$Concat() {
}
export { $h_sc_View$Concat as $h_sc_View$Concat };
$h_sc_View$Concat.prototype = $c_sc_View$Concat.prototype;
$c_sc_View$Concat.prototype.iterator__sc_Iterator = (function() {
  var this$2 = this.sc_View$Concat__f_prefix.iterator__sc_Iterator();
  var xs = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => this.sc_View$Concat__f_suffix.iterator__sc_Iterator()));
  return this$2.concat__F0__sc_Iterator(xs);
});
$c_sc_View$Concat.prototype.knownSize__I = (function() {
  var prefixSize = this.sc_View$Concat__f_prefix.knownSize__I();
  if ((prefixSize >= 0)) {
    var suffixSize = this.sc_View$Concat__f_suffix.knownSize__I();
    return ((suffixSize >= 0) ? ((prefixSize + suffixSize) | 0) : (-1));
  } else {
    return (-1);
  }
});
$c_sc_View$Concat.prototype.isEmpty__Z = (function() {
  return (this.sc_View$Concat__f_prefix.isEmpty__Z() && this.sc_View$Concat__f_suffix.isEmpty__Z());
});
var $d_sc_View$Concat = new $TypeData().initClass($c_sc_View$Concat, "scala.collection.View$Concat", ({
  sc_View$Concat: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$Concat as $d_sc_View$Concat };
/** @constructor */
function $c_sc_View$DistinctBy(underlying, f) {
  this.sc_View$DistinctBy__f_underlying = null;
  this.sc_View$DistinctBy__f_f = null;
  this.sc_View$DistinctBy__f_underlying = underlying;
  this.sc_View$DistinctBy__f_f = f;
}
export { $c_sc_View$DistinctBy as $c_sc_View$DistinctBy };
$c_sc_View$DistinctBy.prototype = new $h_sc_AbstractView();
$c_sc_View$DistinctBy.prototype.constructor = $c_sc_View$DistinctBy;
/** @constructor */
function $h_sc_View$DistinctBy() {
}
export { $h_sc_View$DistinctBy as $h_sc_View$DistinctBy };
$h_sc_View$DistinctBy.prototype = $c_sc_View$DistinctBy.prototype;
$c_sc_View$DistinctBy.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$DistinctBy__f_underlying.iterator__sc_Iterator();
  var f = this.sc_View$DistinctBy__f_f;
  return new $c_sc_Iterator$$anon$8(this$1, f);
});
$c_sc_View$DistinctBy.prototype.knownSize__I = (function() {
  return ((this.sc_View$DistinctBy__f_underlying.knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_View$DistinctBy.prototype.isEmpty__Z = (function() {
  return this.sc_View$DistinctBy__f_underlying.isEmpty__Z();
});
var $d_sc_View$DistinctBy = new $TypeData().initClass($c_sc_View$DistinctBy, "scala.collection.View$DistinctBy", ({
  sc_View$DistinctBy: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$DistinctBy as $d_sc_View$DistinctBy };
function $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Drop__f_underlying = underlying;
  $thiz.sc_View$Drop__f_n = n;
  $thiz.sc_View$Drop__f_normN = ((n > 0) ? n : 0);
  return $thiz;
}
export { $ct_sc_View$Drop__sc_IterableOps__I__ as $ct_sc_View$Drop__sc_IterableOps__I__ };
/** @constructor */
function $c_sc_View$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
}
export { $c_sc_View$Drop as $c_sc_View$Drop };
$c_sc_View$Drop.prototype = new $h_sc_AbstractView();
$c_sc_View$Drop.prototype.constructor = $c_sc_View$Drop;
/** @constructor */
function $h_sc_View$Drop() {
}
export { $h_sc_View$Drop as $h_sc_View$Drop };
$h_sc_View$Drop.prototype = $c_sc_View$Drop.prototype;
$c_sc_View$Drop.prototype.iterator__sc_Iterator = (function() {
  return this.sc_View$Drop__f_underlying.iterator__sc_Iterator().drop__I__sc_Iterator(this.sc_View$Drop__f_n);
});
$c_sc_View$Drop.prototype.knownSize__I = (function() {
  var size = this.sc_View$Drop__f_underlying.knownSize__I();
  if ((size >= 0)) {
    var x = ((size - this.sc_View$Drop__f_normN) | 0);
    return ((x > 0) ? x : 0);
  } else {
    return (-1);
  }
});
$c_sc_View$Drop.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z());
});
var $d_sc_View$Drop = new $TypeData().initClass($c_sc_View$Drop, "scala.collection.View$Drop", ({
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$Drop as $d_sc_View$Drop };
function $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$DropRight__f_underlying = underlying;
  $thiz.sc_View$DropRight__f_n = n;
  $thiz.sc_View$DropRight__f_normN = ((n > 0) ? n : 0);
  return $thiz;
}
export { $ct_sc_View$DropRight__sc_IterableOps__I__ as $ct_sc_View$DropRight__sc_IterableOps__I__ };
/** @constructor */
function $c_sc_View$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
}
export { $c_sc_View$DropRight as $c_sc_View$DropRight };
$c_sc_View$DropRight.prototype = new $h_sc_AbstractView();
$c_sc_View$DropRight.prototype.constructor = $c_sc_View$DropRight;
/** @constructor */
function $h_sc_View$DropRight() {
}
export { $h_sc_View$DropRight as $h_sc_View$DropRight };
$h_sc_View$DropRight.prototype = $c_sc_View$DropRight.prototype;
$c_sc_View$DropRight.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_View$().dropRightIterator__sc_Iterator__I__sc_Iterator(this.sc_View$DropRight__f_underlying.iterator__sc_Iterator(), this.sc_View$DropRight__f_n);
});
$c_sc_View$DropRight.prototype.knownSize__I = (function() {
  var size = this.sc_View$DropRight__f_underlying.knownSize__I();
  if ((size >= 0)) {
    var x = ((size - this.sc_View$DropRight__f_normN) | 0);
    return ((x > 0) ? x : 0);
  } else {
    return (-1);
  }
});
$c_sc_View$DropRight.prototype.isEmpty__Z = (function() {
  if ((this.knownSize__I() >= 0)) {
    return (this.knownSize__I() === 0);
  } else {
    var this$1 = this.iterator__sc_Iterator();
    return (!this$1.hasNext__Z());
  }
});
var $d_sc_View$DropRight = new $TypeData().initClass($c_sc_View$DropRight, "scala.collection.View$DropRight", ({
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$DropRight as $d_sc_View$DropRight };
/** @constructor */
function $c_sc_View$Elems(xs) {
  this.sc_View$Elems__f_xs = null;
  this.sc_View$Elems__f_xs = xs;
}
export { $c_sc_View$Elems as $c_sc_View$Elems };
$c_sc_View$Elems.prototype = new $h_sc_AbstractView();
$c_sc_View$Elems.prototype.constructor = $c_sc_View$Elems;
/** @constructor */
function $h_sc_View$Elems() {
}
export { $h_sc_View$Elems as $h_sc_View$Elems };
$h_sc_View$Elems.prototype = $c_sc_View$Elems.prototype;
$c_sc_View$Elems.prototype.iterator__sc_Iterator = (function() {
  return this.sc_View$Elems__f_xs.iterator__sc_Iterator();
});
$c_sc_View$Elems.prototype.knownSize__I = (function() {
  return this.sc_View$Elems__f_xs.knownSize__I();
});
$c_sc_View$Elems.prototype.isEmpty__Z = (function() {
  return this.sc_View$Elems__f_xs.isEmpty__Z();
});
var $d_sc_View$Elems = new $TypeData().initClass($c_sc_View$Elems, "scala.collection.View$Elems", ({
  sc_View$Elems: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$Elems as $d_sc_View$Elems };
/** @constructor */
function $c_sc_View$Filter(underlying, p, isFlipped) {
  this.sc_View$Filter__f_underlying = null;
  this.sc_View$Filter__f_p = null;
  this.sc_View$Filter__f_isFlipped = false;
  this.sc_View$Filter__f_underlying = underlying;
  this.sc_View$Filter__f_p = p;
  this.sc_View$Filter__f_isFlipped = isFlipped;
}
export { $c_sc_View$Filter as $c_sc_View$Filter };
$c_sc_View$Filter.prototype = new $h_sc_AbstractView();
$c_sc_View$Filter.prototype.constructor = $c_sc_View$Filter;
/** @constructor */
function $h_sc_View$Filter() {
}
export { $h_sc_View$Filter as $h_sc_View$Filter };
$h_sc_View$Filter.prototype = $c_sc_View$Filter.prototype;
$c_sc_View$Filter.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$Filter__f_underlying.iterator__sc_Iterator();
  var p = this.sc_View$Filter__f_p;
  var isFlipped = this.sc_View$Filter__f_isFlipped;
  return new $c_sc_Iterator$$anon$6(this$1, p, isFlipped);
});
$c_sc_View$Filter.prototype.knownSize__I = (function() {
  return ((this.sc_View$Filter__f_underlying.knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_View$Filter.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z());
});
var $d_sc_View$Filter = new $TypeData().initClass($c_sc_View$Filter, "scala.collection.View$Filter", ({
  sc_View$Filter: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$Filter as $d_sc_View$Filter };
/** @constructor */
function $c_sc_View$FlatMap(underlying, f) {
  this.sc_View$FlatMap__f_underlying = null;
  this.sc_View$FlatMap__f_f = null;
  this.sc_View$FlatMap__f_underlying = underlying;
  this.sc_View$FlatMap__f_f = f;
}
export { $c_sc_View$FlatMap as $c_sc_View$FlatMap };
$c_sc_View$FlatMap.prototype = new $h_sc_AbstractView();
$c_sc_View$FlatMap.prototype.constructor = $c_sc_View$FlatMap;
/** @constructor */
function $h_sc_View$FlatMap() {
}
export { $h_sc_View$FlatMap as $h_sc_View$FlatMap };
$h_sc_View$FlatMap.prototype = $c_sc_View$FlatMap.prototype;
$c_sc_View$FlatMap.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$FlatMap__f_underlying.iterator__sc_Iterator();
  var f = this.sc_View$FlatMap__f_f;
  return new $c_sc_Iterator$$anon$10(this$1, f);
});
$c_sc_View$FlatMap.prototype.knownSize__I = (function() {
  return ((this.sc_View$FlatMap__f_underlying.knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_View$FlatMap.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z());
});
var $d_sc_View$FlatMap = new $TypeData().initClass($c_sc_View$FlatMap, "scala.collection.View$FlatMap", ({
  sc_View$FlatMap: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$FlatMap as $d_sc_View$FlatMap };
function $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f) {
  $thiz.sc_View$Map__f_underlying = underlying;
  $thiz.sc_View$Map__f_f = f;
  return $thiz;
}
export { $ct_sc_View$Map__sc_IterableOps__F1__ as $ct_sc_View$Map__sc_IterableOps__F1__ };
/** @constructor */
function $c_sc_View$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
}
export { $c_sc_View$Map as $c_sc_View$Map };
$c_sc_View$Map.prototype = new $h_sc_AbstractView();
$c_sc_View$Map.prototype.constructor = $c_sc_View$Map;
/** @constructor */
function $h_sc_View$Map() {
}
export { $h_sc_View$Map as $h_sc_View$Map };
$h_sc_View$Map.prototype = $c_sc_View$Map.prototype;
$c_sc_View$Map.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$Map__f_underlying.iterator__sc_Iterator();
  var f = this.sc_View$Map__f_f;
  return new $c_sc_Iterator$$anon$9(this$1, f);
});
$c_sc_View$Map.prototype.knownSize__I = (function() {
  return this.sc_View$Map__f_underlying.knownSize__I();
});
$c_sc_View$Map.prototype.isEmpty__Z = (function() {
  return this.sc_View$Map__f_underlying.isEmpty__Z();
});
var $d_sc_View$Map = new $TypeData().initClass($c_sc_View$Map, "scala.collection.View$Map", ({
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$Map as $d_sc_View$Map };
function $ct_sc_View$Prepended__O__sc_IterableOps__($thiz, elem, underlying) {
  $thiz.sc_View$Prepended__f_elem = elem;
  $thiz.sc_View$Prepended__f_underlying = underlying;
  return $thiz;
}
export { $ct_sc_View$Prepended__O__sc_IterableOps__ as $ct_sc_View$Prepended__O__sc_IterableOps__ };
/** @constructor */
function $c_sc_View$Prepended() {
  this.sc_View$Prepended__f_elem = null;
  this.sc_View$Prepended__f_underlying = null;
}
export { $c_sc_View$Prepended as $c_sc_View$Prepended };
$c_sc_View$Prepended.prototype = new $h_sc_AbstractView();
$c_sc_View$Prepended.prototype.constructor = $c_sc_View$Prepended;
/** @constructor */
function $h_sc_View$Prepended() {
}
export { $h_sc_View$Prepended as $h_sc_View$Prepended };
$h_sc_View$Prepended.prototype = $c_sc_View$Prepended.prototype;
/** @constructor */
function $c_sc_View$Single(a) {
  this.sc_View$Single__f_a = null;
  this.sc_View$Single__f_a = a;
}
export { $c_sc_View$Single as $c_sc_View$Single };
$c_sc_View$Single.prototype = new $h_sc_AbstractView();
$c_sc_View$Single.prototype.constructor = $c_sc_View$Single;
/** @constructor */
function $h_sc_View$Single() {
}
export { $h_sc_View$Single as $h_sc_View$Single };
$h_sc_View$Single.prototype = $c_sc_View$Single.prototype;
$c_sc_View$Single.prototype.iterator__sc_Iterator = (function() {
  var a = this.sc_View$Single__f_a;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sc_View$Single.prototype.knownSize__I = (function() {
  return 1;
});
$c_sc_View$Single.prototype.isEmpty__Z = (function() {
  return false;
});
var $d_sc_View$Single = new $TypeData().initClass($c_sc_View$Single, "scala.collection.View$Single", ({
  sc_View$Single: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$Single as $d_sc_View$Single };
function $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n) {
  $thiz.sc_View$Take__f_underlying = underlying;
  $thiz.sc_View$Take__f_n = n;
  $thiz.sc_View$Take__f_normN = ((n > 0) ? n : 0);
  return $thiz;
}
export { $ct_sc_View$Take__sc_IterableOps__I__ as $ct_sc_View$Take__sc_IterableOps__I__ };
/** @constructor */
function $c_sc_View$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
}
export { $c_sc_View$Take as $c_sc_View$Take };
$c_sc_View$Take.prototype = new $h_sc_AbstractView();
$c_sc_View$Take.prototype.constructor = $c_sc_View$Take;
/** @constructor */
function $h_sc_View$Take() {
}
export { $h_sc_View$Take as $h_sc_View$Take };
$h_sc_View$Take.prototype = $c_sc_View$Take.prototype;
$c_sc_View$Take.prototype.iterator__sc_Iterator = (function() {
  return this.sc_View$Take__f_underlying.iterator__sc_Iterator().take__I__sc_Iterator(this.sc_View$Take__f_n);
});
$c_sc_View$Take.prototype.knownSize__I = (function() {
  var size = this.sc_View$Take__f_underlying.knownSize__I();
  if ((size >= 0)) {
    var that = this.sc_View$Take__f_normN;
    return ((size < that) ? size : that);
  } else {
    return (-1);
  }
});
$c_sc_View$Take.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z());
});
var $d_sc_View$Take = new $TypeData().initClass($c_sc_View$Take, "scala.collection.View$Take", ({
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$Take as $d_sc_View$Take };
/** @constructor */
function $c_sc_View$Updated(underlying, index, elem) {
  this.sc_View$Updated__f_scala$collection$View$Updated$$underlying = null;
  this.sc_View$Updated__f_scala$collection$View$Updated$$index = 0;
  this.sc_View$Updated__f_scala$collection$View$Updated$$elem = null;
  this.sc_View$Updated__f_scala$collection$View$Updated$$underlying = underlying;
  this.sc_View$Updated__f_scala$collection$View$Updated$$index = index;
  this.sc_View$Updated__f_scala$collection$View$Updated$$elem = elem;
}
export { $c_sc_View$Updated as $c_sc_View$Updated };
$c_sc_View$Updated.prototype = new $h_sc_AbstractView();
$c_sc_View$Updated.prototype.constructor = $c_sc_View$Updated;
/** @constructor */
function $h_sc_View$Updated() {
}
export { $h_sc_View$Updated as $h_sc_View$Updated };
$h_sc_View$Updated.prototype = $c_sc_View$Updated.prototype;
$c_sc_View$Updated.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_View$Updated$$anon$4(this);
});
$c_sc_View$Updated.prototype.knownSize__I = (function() {
  return this.sc_View$Updated__f_scala$collection$View$Updated$$underlying.knownSize__I();
});
$c_sc_View$Updated.prototype.isEmpty__Z = (function() {
  var this$1 = new $c_sc_View$Updated$$anon$4(this);
  return (!this$1.hasNext__Z());
});
var $d_sc_View$Updated = new $TypeData().initClass($c_sc_View$Updated, "scala.collection.View$Updated", ({
  sc_View$Updated: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$Updated as $d_sc_View$Updated };
/** @constructor */
function $c_sc_View$ZipWithIndex(underlying) {
  this.sc_View$ZipWithIndex__f_underlying = null;
  this.sc_View$ZipWithIndex__f_underlying = underlying;
}
export { $c_sc_View$ZipWithIndex as $c_sc_View$ZipWithIndex };
$c_sc_View$ZipWithIndex.prototype = new $h_sc_AbstractView();
$c_sc_View$ZipWithIndex.prototype.constructor = $c_sc_View$ZipWithIndex;
/** @constructor */
function $h_sc_View$ZipWithIndex() {
}
export { $h_sc_View$ZipWithIndex as $h_sc_View$ZipWithIndex };
$h_sc_View$ZipWithIndex.prototype = $c_sc_View$ZipWithIndex.prototype;
$c_sc_View$ZipWithIndex.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_View$ZipWithIndex__f_underlying.iterator__sc_Iterator();
  return new $c_sc_Iterator$$anon$16(this$1);
});
$c_sc_View$ZipWithIndex.prototype.knownSize__I = (function() {
  return this.sc_View$ZipWithIndex__f_underlying.knownSize__I();
});
$c_sc_View$ZipWithIndex.prototype.isEmpty__Z = (function() {
  return this.sc_View$ZipWithIndex__f_underlying.isEmpty__Z();
});
var $d_sc_View$ZipWithIndex = new $TypeData().initClass($c_sc_View$ZipWithIndex, "scala.collection.View$ZipWithIndex", ({
  sc_View$ZipWithIndex: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_View$ZipWithIndex as $d_sc_View$ZipWithIndex };
function $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps($thiz, that) {
  var result = $thiz;
  var it = that.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    result = result.$plus__T2__sci_MapOps(it.next__O());
  }
  return result;
}
export { $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps as $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps };
/** @constructor */
function $c_s_math_Numeric$ByteIsIntegral$() {
}
export { $c_s_math_Numeric$ByteIsIntegral$ as $c_s_math_Numeric$ByteIsIntegral$ };
$c_s_math_Numeric$ByteIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$ByteIsIntegral$.prototype.constructor = $c_s_math_Numeric$ByteIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$ByteIsIntegral$() {
}
export { $h_s_math_Numeric$ByteIsIntegral$ as $h_s_math_Numeric$ByteIsIntegral$ };
$h_s_math_Numeric$ByteIsIntegral$.prototype = $c_s_math_Numeric$ByteIsIntegral$.prototype;
$c_s_math_Numeric$ByteIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = (x | 0);
  return $f_s_math_Numeric$ByteIsIntegral__sign__B__B(this, x$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.toDouble__O__D = (function(x) {
  var x$1 = (x | 0);
  return x$1;
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = (x | 0);
  return x$1;
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return ((x << 24) >> 24);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = (x | 0);
  return $f_s_math_Numeric$ByteIsIntegral__negate__B__B(this, x$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$ByteIsIntegral__rem__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$ByteIsIntegral__quot__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$ByteIsIntegral__times__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$ByteIsIntegral__minus__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$ByteIsIntegral__plus__B__B__B(this, x$1, y$1);
});
$c_s_math_Numeric$ByteIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Numeric$ByteIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$ByteIsIntegral$, "scala.math.Numeric$ByteIsIntegral$", ({
  s_math_Numeric$ByteIsIntegral$: 1,
  s_math_Numeric$ByteIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$ByteOrdering: 1
}));
export { $d_s_math_Numeric$ByteIsIntegral$ as $d_s_math_Numeric$ByteIsIntegral$ };
var $n_s_math_Numeric$ByteIsIntegral$;
function $m_s_math_Numeric$ByteIsIntegral$() {
  if ((!$n_s_math_Numeric$ByteIsIntegral$)) {
    $n_s_math_Numeric$ByteIsIntegral$ = new $c_s_math_Numeric$ByteIsIntegral$();
  }
  return $n_s_math_Numeric$ByteIsIntegral$;
}
export { $m_s_math_Numeric$ByteIsIntegral$ as $m_s_math_Numeric$ByteIsIntegral$ };
/** @constructor */
function $c_s_math_Numeric$CharIsIntegral$() {
}
export { $c_s_math_Numeric$CharIsIntegral$ as $c_s_math_Numeric$CharIsIntegral$ };
$c_s_math_Numeric$CharIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$CharIsIntegral$.prototype.constructor = $c_s_math_Numeric$CharIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$CharIsIntegral$() {
}
export { $h_s_math_Numeric$CharIsIntegral$ as $h_s_math_Numeric$CharIsIntegral$ };
$h_s_math_Numeric$CharIsIntegral$.prototype = $c_s_math_Numeric$CharIsIntegral$.prototype;
$c_s_math_Numeric$CharIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$CharIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = $uC(x);
  return $bC($f_s_math_Numeric$CharIsIntegral__sign__C__C(this, x$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.toDouble__O__D = (function(x) {
  var x$1 = $uC(x);
  return x$1;
});
$c_s_math_Numeric$CharIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = $uC(x);
  return x$1;
});
$c_s_math_Numeric$CharIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return $bC((65535 & x));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = $uC(x);
  return $bC($f_s_math_Numeric$CharIsIntegral__negate__C__C(this, x$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__rem__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__quot__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__times__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__minus__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return $bC($f_s_math_Numeric$CharIsIntegral__plus__C__C__C(this, x$1, y$1));
});
$c_s_math_Numeric$CharIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = $uC(x);
  var y$1 = $uC(y);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Numeric$CharIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$CharIsIntegral$, "scala.math.Numeric$CharIsIntegral$", ({
  s_math_Numeric$CharIsIntegral$: 1,
  s_math_Numeric$CharIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$CharOrdering: 1
}));
export { $d_s_math_Numeric$CharIsIntegral$ as $d_s_math_Numeric$CharIsIntegral$ };
var $n_s_math_Numeric$CharIsIntegral$;
function $m_s_math_Numeric$CharIsIntegral$() {
  if ((!$n_s_math_Numeric$CharIsIntegral$)) {
    $n_s_math_Numeric$CharIsIntegral$ = new $c_s_math_Numeric$CharIsIntegral$();
  }
  return $n_s_math_Numeric$CharIsIntegral$;
}
export { $m_s_math_Numeric$CharIsIntegral$ as $m_s_math_Numeric$CharIsIntegral$ };
/** @constructor */
function $c_s_math_Numeric$DoubleIsFractional$() {
}
export { $c_s_math_Numeric$DoubleIsFractional$ as $c_s_math_Numeric$DoubleIsFractional$ };
$c_s_math_Numeric$DoubleIsFractional$.prototype = new $h_O();
$c_s_math_Numeric$DoubleIsFractional$.prototype.constructor = $c_s_math_Numeric$DoubleIsFractional$;
/** @constructor */
function $h_s_math_Numeric$DoubleIsFractional$() {
}
export { $h_s_math_Numeric$DoubleIsFractional$ as $h_s_math_Numeric$DoubleIsFractional$ };
$h_s_math_Numeric$DoubleIsFractional$.prototype = $c_s_math_Numeric$DoubleIsFractional$.prototype;
$c_s_math_Numeric$DoubleIsFractional$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.toDouble__O__D = (function(x) {
  var x$1 = (+x);
  return x$1;
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.toInt__O__I = (function(x) {
  var x$1 = (+x);
  return $doubleToInt(x$1);
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.fromInt__I__O = (function(x) {
  return x;
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.negate__O__O = (function(x) {
  var x$1 = (+x);
  return $f_s_math_Numeric$DoubleIsFractional__negate__D__D(this, x$1);
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return $f_s_math_Numeric$DoubleIsFractional__times__D__D__D(this, x$1, y$1);
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return $f_s_math_Numeric$DoubleIsFractional__minus__D__D__D(this, x$1, y$1);
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return $f_s_math_Numeric$DoubleIsFractional__plus__D__D__D(this, x$1, y$1);
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.min__O__O__O = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return (+Math.min(x$1, y$1));
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.max__O__O__O = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return (+Math.max(x$1, y$1));
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.equiv__O__O__Z = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return $f_s_math_Ordering$Double$IeeeOrdering__equiv__D__D__Z(this, x$1, y$1);
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.gt__O__O__Z = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return $f_s_math_Ordering$Double$IeeeOrdering__gt__D__D__Z(this, x$1, y$1);
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.lt__O__O__Z = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return $f_s_math_Ordering$Double$IeeeOrdering__lt__D__D__Z(this, x$1, y$1);
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.gteq__O__O__Z = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return $f_s_math_Ordering$Double$IeeeOrdering__gteq__D__D__Z(this, x$1, y$1);
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.lteq__O__O__Z = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return $f_s_math_Ordering$Double$IeeeOrdering__lteq__D__D__Z(this, x$1, y$1);
});
$c_s_math_Numeric$DoubleIsFractional$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = (+x);
  var y$1 = (+y);
  return $m_jl_Double$().compare__D__D__I(x$1, y$1);
});
var $d_s_math_Numeric$DoubleIsFractional$ = new $TypeData().initClass($c_s_math_Numeric$DoubleIsFractional$, "scala.math.Numeric$DoubleIsFractional$", ({
  s_math_Numeric$DoubleIsFractional$: 1,
  s_math_Numeric$DoubleIsFractional: 1,
  s_math_Fractional: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$Double$IeeeOrdering: 1
}));
export { $d_s_math_Numeric$DoubleIsFractional$ as $d_s_math_Numeric$DoubleIsFractional$ };
var $n_s_math_Numeric$DoubleIsFractional$;
function $m_s_math_Numeric$DoubleIsFractional$() {
  if ((!$n_s_math_Numeric$DoubleIsFractional$)) {
    $n_s_math_Numeric$DoubleIsFractional$ = new $c_s_math_Numeric$DoubleIsFractional$();
  }
  return $n_s_math_Numeric$DoubleIsFractional$;
}
export { $m_s_math_Numeric$DoubleIsFractional$ as $m_s_math_Numeric$DoubleIsFractional$ };
/** @constructor */
function $c_s_math_Numeric$IntIsIntegral$() {
}
export { $c_s_math_Numeric$IntIsIntegral$ as $c_s_math_Numeric$IntIsIntegral$ };
$c_s_math_Numeric$IntIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$IntIsIntegral$.prototype.constructor = $c_s_math_Numeric$IntIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$IntIsIntegral$() {
}
export { $h_s_math_Numeric$IntIsIntegral$ as $h_s_math_Numeric$IntIsIntegral$ };
$h_s_math_Numeric$IntIsIntegral$.prototype = $c_s_math_Numeric$IntIsIntegral$.prototype;
$c_s_math_Numeric$IntIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = (x | 0);
  return ((x$1 >> 31) | ((((-x$1) | 0) >>> 31) | 0));
});
$c_s_math_Numeric$IntIsIntegral$.prototype.toDouble__O__D = (function(x) {
  var x$1 = (x | 0);
  return x$1;
});
$c_s_math_Numeric$IntIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = (x | 0);
  return x$1;
});
$c_s_math_Numeric$IntIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return x;
});
$c_s_math_Numeric$IntIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = (x | 0);
  return $f_s_math_Numeric$IntIsIntegral__negate__I__I(this, x$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$IntIsIntegral__rem__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$IntIsIntegral__quot__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$IntIsIntegral__times__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$IntIsIntegral__minus__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$IntIsIntegral__plus__I__I__I(this, x$1, y$1);
});
$c_s_math_Numeric$IntIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
});
var $d_s_math_Numeric$IntIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$IntIsIntegral$, "scala.math.Numeric$IntIsIntegral$", ({
  s_math_Numeric$IntIsIntegral$: 1,
  s_math_Numeric$IntIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$IntOrdering: 1
}));
export { $d_s_math_Numeric$IntIsIntegral$ as $d_s_math_Numeric$IntIsIntegral$ };
var $n_s_math_Numeric$IntIsIntegral$;
function $m_s_math_Numeric$IntIsIntegral$() {
  if ((!$n_s_math_Numeric$IntIsIntegral$)) {
    $n_s_math_Numeric$IntIsIntegral$ = new $c_s_math_Numeric$IntIsIntegral$();
  }
  return $n_s_math_Numeric$IntIsIntegral$;
}
export { $m_s_math_Numeric$IntIsIntegral$ as $m_s_math_Numeric$IntIsIntegral$ };
/** @constructor */
function $c_s_math_Numeric$LongIsIntegral$() {
}
export { $c_s_math_Numeric$LongIsIntegral$ as $c_s_math_Numeric$LongIsIntegral$ };
$c_s_math_Numeric$LongIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$LongIsIntegral$.prototype.constructor = $c_s_math_Numeric$LongIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$LongIsIntegral$() {
}
export { $h_s_math_Numeric$LongIsIntegral$ as $h_s_math_Numeric$LongIsIntegral$ };
$h_s_math_Numeric$LongIsIntegral$.prototype = $c_s_math_Numeric$LongIsIntegral$.prototype;
$c_s_math_Numeric$LongIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.sign__O__O = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $m_s_math_package$().signum__J__J(new $c_RTLong(lo, hi));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.toDouble__O__D = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return ((4.294967296E9 * hi) + (lo >>> 0.0));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.toInt__O__I = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  return lo;
});
$c_s_math_Numeric$LongIsIntegral$.prototype.fromInt__I__O = (function(x) {
  var hi = (x >> 31);
  return new $c_RTLong(x, hi);
});
$c_s_math_Numeric$LongIsIntegral$.prototype.negate__O__O = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__negate__J__J(this, new $c_RTLong(lo, hi));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__rem__J__J__J(this, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__quot__J__J__J(this, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__times__J__J__J(this, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__minus__J__J__J(this, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $f_s_math_Numeric$LongIsIntegral__plus__J__J__J(this, new $c_RTLong(lo, hi), new $c_RTLong(lo$1, hi$1));
});
$c_s_math_Numeric$LongIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var t$1 = $uJ(y);
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo, hi, lo$1, hi$1);
});
var $d_s_math_Numeric$LongIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$LongIsIntegral$, "scala.math.Numeric$LongIsIntegral$", ({
  s_math_Numeric$LongIsIntegral$: 1,
  s_math_Numeric$LongIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$LongOrdering: 1
}));
export { $d_s_math_Numeric$LongIsIntegral$ as $d_s_math_Numeric$LongIsIntegral$ };
var $n_s_math_Numeric$LongIsIntegral$;
function $m_s_math_Numeric$LongIsIntegral$() {
  if ((!$n_s_math_Numeric$LongIsIntegral$)) {
    $n_s_math_Numeric$LongIsIntegral$ = new $c_s_math_Numeric$LongIsIntegral$();
  }
  return $n_s_math_Numeric$LongIsIntegral$;
}
export { $m_s_math_Numeric$LongIsIntegral$ as $m_s_math_Numeric$LongIsIntegral$ };
/** @constructor */
function $c_s_math_Numeric$ShortIsIntegral$() {
}
export { $c_s_math_Numeric$ShortIsIntegral$ as $c_s_math_Numeric$ShortIsIntegral$ };
$c_s_math_Numeric$ShortIsIntegral$.prototype = new $h_O();
$c_s_math_Numeric$ShortIsIntegral$.prototype.constructor = $c_s_math_Numeric$ShortIsIntegral$;
/** @constructor */
function $h_s_math_Numeric$ShortIsIntegral$() {
}
export { $h_s_math_Numeric$ShortIsIntegral$ as $h_s_math_Numeric$ShortIsIntegral$ };
$h_s_math_Numeric$ShortIsIntegral$.prototype = $c_s_math_Numeric$ShortIsIntegral$.prototype;
$c_s_math_Numeric$ShortIsIntegral$.prototype.lteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.gteq__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.lt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.gt__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__gt__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.equiv__O__O__Z = (function(x, y) {
  return $f_s_math_Ordering__equiv__O__O__Z(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.max__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__max__O__O__O(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.min__O__O__O = (function(x, y) {
  return $f_s_math_Ordering__min__O__O__O(this, x, y);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.isReverseOf__s_math_Ordering__Z = (function(other) {
  return $f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.sign__O__O = (function(x) {
  var x$1 = (x | 0);
  return $f_s_math_Numeric$ShortIsIntegral__sign__S__S(this, x$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.toDouble__O__D = (function(x) {
  var x$1 = (x | 0);
  return x$1;
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.toInt__O__I = (function(x) {
  var x$1 = (x | 0);
  return x$1;
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.fromInt__I__O = (function(x) {
  return ((x << 16) >> 16);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.negate__O__O = (function(x) {
  var x$1 = (x | 0);
  return $f_s_math_Numeric$ShortIsIntegral__negate__S__S(this, x$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.rem__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$ShortIsIntegral__rem__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.quot__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$ShortIsIntegral__quot__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.times__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$ShortIsIntegral__times__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.minus__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$ShortIsIntegral__minus__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.plus__O__O__O = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return $f_s_math_Numeric$ShortIsIntegral__plus__S__S__S(this, x$1, y$1);
});
$c_s_math_Numeric$ShortIsIntegral$.prototype.compare__O__O__I = (function(x, y) {
  var x$1 = (x | 0);
  var y$1 = (y | 0);
  return ((x$1 - y$1) | 0);
});
var $d_s_math_Numeric$ShortIsIntegral$ = new $TypeData().initClass($c_s_math_Numeric$ShortIsIntegral$, "scala.math.Numeric$ShortIsIntegral$", ({
  s_math_Numeric$ShortIsIntegral$: 1,
  s_math_Numeric$ShortIsIntegral: 1,
  s_math_Integral: 1,
  s_math_Numeric: 1,
  s_math_Ordering: 1,
  ju_Comparator: 1,
  s_math_PartialOrdering: 1,
  s_math_Equiv: 1,
  Ljava_io_Serializable: 1,
  s_math_Ordering$ShortOrdering: 1
}));
export { $d_s_math_Numeric$ShortIsIntegral$ as $d_s_math_Numeric$ShortIsIntegral$ };
var $n_s_math_Numeric$ShortIsIntegral$;
function $m_s_math_Numeric$ShortIsIntegral$() {
  if ((!$n_s_math_Numeric$ShortIsIntegral$)) {
    $n_s_math_Numeric$ShortIsIntegral$ = new $c_s_math_Numeric$ShortIsIntegral$();
  }
  return $n_s_math_Numeric$ShortIsIntegral$;
}
export { $m_s_math_Numeric$ShortIsIntegral$ as $m_s_math_Numeric$ShortIsIntegral$ };
function $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive($thiz, end) {
  $m_sci_NumericRange$();
  var start = $thiz.self__O();
  var this$1 = $thiz.num__s_math_Integral();
  var step = this$1.fromInt__I__O(1);
  var num = $thiz.num__s_math_Integral();
  return new $c_sci_NumericRange$Inclusive(start, end, step, num);
}
export { $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive as $f_sr_IntegralProxy__to__O__sci_NumericRange$Inclusive };
function $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V($thiz) {
  $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V($thiz.parent__Lcom_raquo_airstream_core_Observable(), $thiz, false);
}
export { $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V as $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V };
function $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V($thiz) {
  $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V($thiz.parent__Lcom_raquo_airstream_core_Observable(), $thiz);
}
export { $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V as $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V };
/** @constructor */
function $c_Lcom_raquo_airstream_custom_CustomStreamSource(makeConfig) {
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_externalObservers = null;
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_internalObservers = null;
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_willStartDone = false;
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_topoRank = 0;
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_startIndex = 0;
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_config = null;
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_custom_CustomSource__$init$__V(this);
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_config = makeConfig.apply__O__O__O__O__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((value) => {
    var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, value, _$1);
    }));
    new $c_Lcom_raquo_airstream_core_Transaction(code);
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((err) => {
    var code$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((err$2) => ((_$2) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, err$2, _$2);
    }))(err));
    new $c_Lcom_raquo_airstream_core_Transaction(code$1);
  })), new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => this.Lcom_raquo_airstream_custom_CustomStreamSource__f_startIndex)), new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $f_Lcom_raquo_airstream_core_BaseObservable__isStarted__Z(this))));
}
export { $c_Lcom_raquo_airstream_custom_CustomStreamSource as $c_Lcom_raquo_airstream_custom_CustomStreamSource };
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype = new $h_O();
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.constructor = $c_Lcom_raquo_airstream_custom_CustomStreamSource;
/** @constructor */
function $h_Lcom_raquo_airstream_custom_CustomStreamSource() {
}
export { $h_Lcom_raquo_airstream_custom_CustomStreamSource as $h_Lcom_raquo_airstream_custom_CustomStreamSource };
$h_Lcom_raquo_airstream_custom_CustomStreamSource.prototype = $c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype;
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_custom_CustomStreamSource__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_custom_CustomStreamSource__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_custom_CustomStreamSource__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_custom_CustomStreamSource__f_externalObservers;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_custom_CustomStreamSource__f_internalObservers;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_custom_CustomStreamSource__f_willStartDone;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_custom_CustomStreamSource__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_custom_CustomStreamSource__f_topoRank;
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.onWillStart__V = (function() {
  $f_Lcom_raquo_airstream_custom_CustomSource__onWillStart__V(this);
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_custom_CustomSource__onStart__V(this);
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.onStop__V = (function() {
  $f_Lcom_raquo_airstream_custom_CustomSource__onStop__V(this);
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_custom_CustomStreamSource.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_custom_CustomStreamSource = new $TypeData().initClass($c_Lcom_raquo_airstream_custom_CustomStreamSource, "com.raquo.airstream.custom.CustomStreamSource", ({
  Lcom_raquo_airstream_custom_CustomStreamSource: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_custom_CustomSource: 1
}));
export { $d_Lcom_raquo_airstream_custom_CustomStreamSource as $d_Lcom_raquo_airstream_custom_CustomStreamSource };
/** @constructor */
function $c_Lcom_raquo_airstream_state_VarSignal(initial, parentDisplayName) {
  this.Lcom_raquo_airstream_state_VarSignal__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_state_VarSignal__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_state_VarSignal__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_state_VarSignal__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_state_VarSignal__f_externalObservers = null;
  this.Lcom_raquo_airstream_state_VarSignal__f_internalObservers = null;
  this.Lcom_raquo_airstream_state_VarSignal__f_willStartDone = false;
  this.Lcom_raquo_airstream_state_VarSignal__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_state_VarSignal__f_parentDisplayName = null;
  this.Lcom_raquo_airstream_state_VarSignal__f_topoRank = 0;
  this.Lcom_raquo_airstream_state_VarSignal__f_parentDisplayName = parentDisplayName;
  this.Lcom_raquo_airstream_state_VarSignal__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.Lcom_raquo_airstream_state_VarSignal__f__lastUpdateId = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_state_VarSignal__f_maybeLastSeenCurrentValue = (void 0);
  this.Lcom_raquo_airstream_state_VarSignal__f_topoRank = 1;
  $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V(this, initial);
}
export { $c_Lcom_raquo_airstream_state_VarSignal as $c_Lcom_raquo_airstream_state_VarSignal };
$c_Lcom_raquo_airstream_state_VarSignal.prototype = new $h_O();
$c_Lcom_raquo_airstream_state_VarSignal.prototype.constructor = $c_Lcom_raquo_airstream_state_VarSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_state_VarSignal() {
}
export { $h_Lcom_raquo_airstream_state_VarSignal as $h_Lcom_raquo_airstream_state_VarSignal };
$h_Lcom_raquo_airstream_state_VarSignal.prototype = $c_Lcom_raquo_airstream_state_VarSignal.prototype;
$c_Lcom_raquo_airstream_state_VarSignal.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_state_VarSignal__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_VarSignal__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_state_VarSignal__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_state_VarSignal__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_VarSignal__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_VarSignal__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.onStop__V = (function() {
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype._lastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_state_VarSignal__f__lastUpdateId;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype._lastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_VarSignal__f__lastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_core_Signal__onStart__V(this);
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
  observer.onTry__s_util_Try__V($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_state_VarSignal__f_externalObservers;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_state_VarSignal__f_internalObservers;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_state_VarSignal__f_willStartDone;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_VarSignal__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_state_VarSignal__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_state_VarSignal__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.maybeLastSeenCurrentValue__O = (function() {
  return this.Lcom_raquo_airstream_state_VarSignal__f_maybeLastSeenCurrentValue;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.maybeLastSeenCurrentValue_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_state_VarSignal__f_maybeLastSeenCurrentValue = x$1;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.tryNow__s_util_Try = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_state_VarSignal__f_topoRank;
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.currentValueFromParent__s_util_Try = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.onWillStart__V = (function() {
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.defaultDisplayName__T = (function() {
  return (this.Lcom_raquo_airstream_state_VarSignal__f_parentDisplayName.apply__O() + ".signal");
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$c_Lcom_raquo_airstream_state_VarSignal.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_state_VarSignal = new $TypeData().initClass($c_Lcom_raquo_airstream_state_VarSignal, "com.raquo.airstream.state.VarSignal", ({
  Lcom_raquo_airstream_state_VarSignal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_state_StrictSignal: 1
}));
export { $d_Lcom_raquo_airstream_state_VarSignal as $d_Lcom_raquo_airstream_state_VarSignal };
/** @constructor */
function $c_ju_Collections$ImmutableList(inner) {
  this.ju_Collections$UnmodifiableCollection__f_inner = null;
  this.ju_Collections$UnmodifiableCollection__f_eagerThrow = false;
  this.ju_Collections$ImmutableList__f_eagerThrow = false;
  $ct_ju_Collections$UnmodifiableList__ju_List__(this, inner);
  this.ju_Collections$ImmutableList__f_eagerThrow = false;
}
export { $c_ju_Collections$ImmutableList as $c_ju_Collections$ImmutableList };
$c_ju_Collections$ImmutableList.prototype = new $h_ju_Collections$UnmodifiableList();
$c_ju_Collections$ImmutableList.prototype.constructor = $c_ju_Collections$ImmutableList;
/** @constructor */
function $h_ju_Collections$ImmutableList() {
}
export { $h_ju_Collections$ImmutableList as $h_ju_Collections$ImmutableList };
$h_ju_Collections$ImmutableList.prototype = $c_ju_Collections$ImmutableList.prototype;
$c_ju_Collections$ImmutableList.prototype.eagerThrow__Z = (function() {
  return this.ju_Collections$ImmutableList__f_eagerThrow;
});
var $d_ju_Collections$ImmutableList = new $TypeData().initClass($c_ju_Collections$ImmutableList, "java.util.Collections$ImmutableList", ({
  ju_Collections$ImmutableList: 1,
  ju_Collections$UnmodifiableList: 1,
  ju_Collections$UnmodifiableCollection: 1,
  ju_Collections$WrappedCollection: 1,
  ju_Collection: 1,
  jl_Iterable: 1,
  Ljava_io_Serializable: 1,
  ju_Collections$WrappedList: 1,
  ju_Collections$WrappedEquals: 1,
  ju_List: 1,
  ju_SequencedCollection: 1
}));
export { $d_ju_Collections$ImmutableList as $d_ju_Collections$ImmutableList };
/** @constructor */
function $c_sc_AbstractSet() {
}
export { $c_sc_AbstractSet as $c_sc_AbstractSet };
$c_sc_AbstractSet.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSet.prototype.constructor = $c_sc_AbstractSet;
/** @constructor */
function $h_sc_AbstractSet() {
}
export { $h_sc_AbstractSet as $h_sc_AbstractSet };
$h_sc_AbstractSet.prototype = $c_sc_AbstractSet.prototype;
$c_sc_AbstractSet.prototype.equals__O__Z = (function(that) {
  return $f_sc_Set__equals__O__Z(this, that);
});
$c_sc_AbstractSet.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  return this$1.unorderedHash__sc_IterableOnce__I__I(this, this$1.s_util_hashing_MurmurHash3$__f_setSeed);
});
$c_sc_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sc_Set$();
});
$c_sc_AbstractSet.prototype.stringPrefix__T = (function() {
  return "Set";
});
$c_sc_AbstractSet.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  return this.forall__F1__Z(that);
});
$c_sc_AbstractSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this, that);
});
$c_sc_AbstractSet.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.contains__O__Z(v1);
});
$c_sc_AbstractSet.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractSet.prototype.andThen__F1__F1 = (function(g) {
  return $f_F1__andThen__F1__F1(this, g);
});
$c_sc_AbstractSet.prototype.apply__O__O = (function(v1) {
  return this.contains__O__Z(v1);
});
function $is_sc_IndexedSeqView(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IndexedSeqView)));
}
export { $is_sc_IndexedSeqView as $is_sc_IndexedSeqView };
function $isArrayOf_sc_IndexedSeqView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IndexedSeqView)));
}
export { $isArrayOf_sc_IndexedSeqView as $isArrayOf_sc_IndexedSeqView };
function $f_sc_Map__equals__O__Z($thiz, o) {
  if (($thiz === o)) {
    return true;
  } else if ($is_sc_Map(o)) {
    if (($thiz.size__I() === o.size__I())) {
      try {
        return $thiz.forall__F1__Z(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x2) => ((kv$2$2) => $m_sr_BoxesRunTime$().equals__O__O__Z(x2.getOrElse__O__F0__O(kv$2$2._1__O(), $m_sc_Map$().sc_Map$__f_scala$collection$Map$$DefaultSentinelFn), kv$2$2._2__O())))(o)));
      } catch (e) {
        if ((e instanceof $c_jl_ClassCastException)) {
          return false;
        } else {
          throw e;
        }
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}
export { $f_sc_Map__equals__O__Z as $f_sc_Map__equals__O__Z };
function $is_sc_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_Map)));
}
export { $is_sc_Map as $is_sc_Map };
function $isArrayOf_sc_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_Map)));
}
export { $isArrayOf_sc_Map as $isArrayOf_sc_Map };
function $is_sc_MapView(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_MapView)));
}
export { $is_sc_MapView as $is_sc_MapView };
function $isArrayOf_sc_MapView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_MapView)));
}
export { $isArrayOf_sc_MapView as $isArrayOf_sc_MapView };
/** @constructor */
function $c_sr_RichChar(self) {
  this.sr_RichChar__f_self = 0;
  this.sr_RichChar__f_self = self;
}
export { $c_sr_RichChar as $c_sr_RichChar };
$c_sr_RichChar.prototype = new $h_O();
$c_sr_RichChar.prototype.constructor = $c_sr_RichChar;
/** @constructor */
function $h_sr_RichChar() {
}
export { $h_sr_RichChar as $h_sr_RichChar };
$h_sr_RichChar.prototype = $c_sr_RichChar.prototype;
$c_sr_RichChar.prototype.isWhole__Z = (function() {
  return true;
});
$c_sr_RichChar.prototype.compare__O__I = (function(y) {
  var x = this.sr_RichChar__f_self;
  var y$1 = $uC(y);
  return ((x - y$1) | 0);
});
$c_sr_RichChar.prototype.compareTo__O__I = (function(that) {
  var x = this.sr_RichChar__f_self;
  var y = $uC(that);
  return ((x - y) | 0);
});
$c_sr_RichChar.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this);
});
$c_sr_RichChar.prototype.isValidByte__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidByte__Z(this);
});
$c_sr_RichChar.prototype.isValidShort__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidShort__Z(this);
});
$c_sr_RichChar.prototype.isValidInt__Z = (function() {
  return $f_s_math_ScalaNumericAnyConversions__isValidInt__Z(this);
});
$c_sr_RichChar.prototype.doubleValue__D = (function() {
  var this$ = this.sr_RichChar__f_self;
  return this$;
});
$c_sr_RichChar.prototype.floatValue__F = (function() {
  var this$ = this.sr_RichChar__f_self;
  return Math.fround(this$);
});
$c_sr_RichChar.prototype.longValue__J = (function() {
  var this$ = this.sr_RichChar__f_self;
  var value = this$;
  var hi = (value >> 31);
  return new $c_RTLong(value, hi);
});
$c_sr_RichChar.prototype.intValue__I = (function() {
  var this$ = this.sr_RichChar__f_self;
  return this$;
});
$c_sr_RichChar.prototype.byteValue__B = (function() {
  var this$ = this.sr_RichChar__f_self;
  return ((this$ << 24) >> 24);
});
$c_sr_RichChar.prototype.shortValue__S = (function() {
  var this$ = this.sr_RichChar__f_self;
  return ((this$ << 16) >> 16);
});
$c_sr_RichChar.prototype.isValidChar__Z = (function() {
  return true;
});
$c_sr_RichChar.prototype.hashCode__I = (function() {
  var this$ = this.sr_RichChar__f_self;
  return this$;
});
$c_sr_RichChar.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichChar$().equals$extension__C__O__Z(this.sr_RichChar__f_self, x$1);
});
$c_sr_RichChar.prototype.num__s_math_Integral = (function() {
  return $m_s_math_Numeric$CharIsIntegral$();
});
$c_sr_RichChar.prototype.self__O = (function() {
  return $bC(this.sr_RichChar__f_self);
});
function $isArrayOf_sr_RichChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichChar)));
}
export { $isArrayOf_sr_RichChar as $isArrayOf_sr_RichChar };
var $d_sr_RichChar = new $TypeData().initClass($c_sr_RichChar, "scala.runtime.RichChar", ({
  sr_RichChar: 1,
  sr_IntegralProxy: 1,
  sr_ScalaWholeNumberProxy: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
}));
export { $d_sr_RichChar as $d_sr_RichChar };
/** @constructor */
function $c_sr_RichLong(self) {
  this.sr_RichLong__f_self = $L0;
  this.sr_RichLong__f_self = self;
}
export { $c_sr_RichLong as $c_sr_RichLong };
$c_sr_RichLong.prototype = new $h_O();
$c_sr_RichLong.prototype.constructor = $c_sr_RichLong;
/** @constructor */
function $h_sr_RichLong() {
}
export { $h_sr_RichLong as $h_sr_RichLong };
$h_sr_RichLong.prototype = $c_sr_RichLong.prototype;
$c_sr_RichLong.prototype.isWhole__Z = (function() {
  return true;
});
$c_sr_RichLong.prototype.compare__O__I = (function(y) {
  var t$1 = this.sr_RichLong__f_self;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $uJ(y);
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$1, hi$1, lo$2, hi$2);
});
$c_sr_RichLong.prototype.compareTo__O__I = (function(that) {
  var t$1 = this.sr_RichLong__f_self;
  var lo$1 = t$1.RTLong__f_lo;
  var hi$1 = t$1.RTLong__f_hi;
  var t$2 = $uJ(that);
  var lo$2 = t$2.RTLong__f_lo;
  var hi$2 = t$2.RTLong__f_hi;
  return $m_RTLong$().org$scalajs$linker$runtime$RuntimeLong$$compare__I__I__I__I__I(lo$1, hi$1, lo$2, hi$2);
});
$c_sr_RichLong.prototype.toString__T = (function() {
  return $f_s_Proxy__toString__T(this);
});
$c_sr_RichLong.prototype.doubleValue__D = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return ((4.294967296E9 * hi) + (lo >>> 0.0));
});
$c_sr_RichLong.prototype.floatValue__F = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  var compressedLo = (((((-2097152) & (hi ^ (hi >> 10))) === 0) || ((65535 & lo) === 0)) ? lo : (32768 | ((-32768) & lo)));
  return Math.fround(((4.294967296E9 * hi) + (compressedLo >>> 0.0)));
});
$c_sr_RichLong.prototype.longValue__J = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return new $c_RTLong(lo, hi);
});
$c_sr_RichLong.prototype.intValue__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return lo;
});
$c_sr_RichLong.prototype.byteValue__B = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 24) >> 24);
});
$c_sr_RichLong.prototype.shortValue__S = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  return ((lo << 16) >> 16);
});
$c_sr_RichLong.prototype.isValidByte__Z = (function() {
  return $m_sr_RichLong$().isValidByte$extension__J__Z(this.sr_RichLong__f_self);
});
$c_sr_RichLong.prototype.isValidShort__Z = (function() {
  return $m_sr_RichLong$().isValidShort$extension__J__Z(this.sr_RichLong__f_self);
});
$c_sr_RichLong.prototype.isValidChar__Z = (function() {
  return $m_sr_RichLong$().isValidChar$extension__J__Z(this.sr_RichLong__f_self);
});
$c_sr_RichLong.prototype.isValidInt__Z = (function() {
  return $m_sr_RichLong$().isValidInt$extension__J__Z(this.sr_RichLong__f_self);
});
$c_sr_RichLong.prototype.hashCode__I = (function() {
  var t = this.sr_RichLong__f_self;
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi);
});
$c_sr_RichLong.prototype.equals__O__Z = (function(x$1) {
  return $m_sr_RichLong$().equals$extension__J__O__Z(this.sr_RichLong__f_self, x$1);
});
$c_sr_RichLong.prototype.num__s_math_Integral = (function() {
  var t = this.sr_RichLong__f_self;
  return $m_s_math_Numeric$LongIsIntegral$();
});
$c_sr_RichLong.prototype.self__O = (function() {
  return this.sr_RichLong__f_self;
});
function $isArrayOf_sr_RichLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sr_RichLong)));
}
export { $isArrayOf_sr_RichLong as $isArrayOf_sr_RichLong };
var $d_sr_RichLong = new $TypeData().initClass($c_sr_RichLong, "scala.runtime.RichLong", ({
  sr_RichLong: 1,
  sr_IntegralProxy: 1,
  sr_ScalaWholeNumberProxy: 1,
  sr_ScalaNumberProxy: 1,
  s_math_ScalaNumericAnyConversions: 1,
  s_Proxy$Typed: 1,
  s_Proxy: 1,
  sr_OrderedProxy: 1,
  s_math_Ordered: 1,
  jl_Comparable: 1,
  sr_RangedProxy: 1
}));
export { $d_sr_RichLong as $d_sr_RichLong };
function $f_Lcats_Monad__map__O__F1__O($thiz, fa, f) {
  return $thiz.flatMap__O__F1__O(fa, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => $thiz.pure__O__O(f.apply__O__O(a)))));
}
export { $f_Lcats_Monad__map__O__F1__O as $f_Lcats_Monad__map__O__F1__O };
function $ct_Lcats_data_ValidatedApplicative__Lcats_kernel_Semigroup__($thiz, evidence$1) {
  $thiz.Lcats_data_ValidatedApplicative__f_evidence$1 = evidence$1;
  return $thiz;
}
export { $ct_Lcats_data_ValidatedApplicative__Lcats_kernel_Semigroup__ as $ct_Lcats_data_ValidatedApplicative__Lcats_kernel_Semigroup__ };
/** @constructor */
function $c_Lcats_data_ValidatedApplicative() {
  this.Lcats_data_ValidatedApplicative__f_evidence$1 = null;
}
export { $c_Lcats_data_ValidatedApplicative as $c_Lcats_data_ValidatedApplicative };
$c_Lcats_data_ValidatedApplicative.prototype = new $h_O();
$c_Lcats_data_ValidatedApplicative.prototype.constructor = $c_Lcats_data_ValidatedApplicative;
/** @constructor */
function $h_Lcats_data_ValidatedApplicative() {
}
export { $h_Lcats_data_ValidatedApplicative as $h_Lcats_data_ValidatedApplicative };
$h_Lcats_data_ValidatedApplicative.prototype = $c_Lcats_data_ValidatedApplicative.prototype;
$c_Lcats_data_ValidatedApplicative.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return fa.map__F1__Lcats_data_Validated(f);
});
$c_Lcats_data_ValidatedApplicative.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_ValidatedApplicative.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_ValidatedApplicative.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_Apply__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_ValidatedApplicative.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_data_ValidatedApplicative.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_data_ValidatedApplicative.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lcats_data_ValidatedApplicative.prototype.ap__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated = (function(ff, fa) {
  $m_Lcats_package$();
  var ev = this.Lcats_data_ValidatedApplicative__f_evidence$1;
  return fa.ap__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated(ff, ev);
});
$c_Lcats_data_ValidatedApplicative.prototype.product__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated = (function(fa, fb) {
  $m_Lcats_package$();
  var ev = this.Lcats_data_ValidatedApplicative__f_evidence$1;
  return fa.product__Lcats_data_Validated__Lcats_kernel_Semigroup__Lcats_data_Validated(fb, ev);
});
$c_Lcats_data_ValidatedApplicative.prototype.map__O__F1__O = (function(fa, f) {
  return fa.map__F1__Lcats_data_Validated(f);
});
$c_Lcats_data_ValidatedApplicative.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Validated$();
  return new $c_Lcats_data_Validated$Valid(x);
});
$c_Lcats_data_ValidatedApplicative.prototype.ap__O__O__O = (function(ff, fa) {
  return this.ap__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated(ff, fa);
});
$c_Lcats_data_ValidatedApplicative.prototype.product__O__O__O = (function(fa, fb) {
  return this.product__Lcats_data_Validated__Lcats_data_Validated__Lcats_data_Validated(fa, fb);
});
$c_Lcats_data_ValidatedApplicative.prototype.unit__O = (function() {
  return $m_Lcats_data_Validated$().Lcats_data_Validated$__f_validUnit;
});
function $p_Lcom_raquo_airstream_combine_MergeStream__makeInternalObserver__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_common_InternalParentObserver($thiz, parent) {
  return $m_Lcom_raquo_airstream_common_InternalParentObserver$().fromTry__Lcom_raquo_airstream_core_Observable__F2__Lcom_raquo_airstream_common_InternalParentObserver(parent, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((nextValue, transaction) => {
    $thiz.Lcom_raquo_airstream_combine_MergeStream__f_pendingParentValues.enqueue__O__V(new $c_Lcom_raquo_airstream_common_Observation(parent, nextValue));
    if ((!transaction.containsPendingObservable__Lcom_raquo_airstream_core_SyncObservable__Z($thiz))) {
      transaction.enqueuePendingObservable__Lcom_raquo_airstream_core_SyncObservable__V($thiz);
    }
  })));
}
export { $p_Lcom_raquo_airstream_combine_MergeStream__makeInternalObserver__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_common_InternalParentObserver as $p_Lcom_raquo_airstream_combine_MergeStream__makeInternalObserver__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_common_InternalParentObserver };
/** @constructor */
function $c_Lcom_raquo_airstream_combine_MergeStream(parentStreams) {
  this.Lcom_raquo_airstream_combine_MergeStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_combine_MergeStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_combine_MergeStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_combine_MergeStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_combine_MergeStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_combine_MergeStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_combine_MergeStream__f_parents = null;
  this.Lcom_raquo_airstream_combine_MergeStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_combine_MergeStream__f_lastFiredInTrx = null;
  this.Lcom_raquo_airstream_combine_MergeStream__f_pendingParentValues = null;
  this.Lcom_raquo_airstream_combine_MergeStream__f_parentObservers = null;
  this.Lcom_raquo_airstream_combine_MergeStream__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_combine_MergeStream__f_parents = parentStreams;
  var this$1 = $m_Lcom_raquo_airstream_core_Protected$();
  var observables = this.Lcom_raquo_airstream_combine_MergeStream__f_parents;
  this.Lcom_raquo_airstream_combine_MergeStream__f_topoRank = ((1 + this$1.maxTopoRank__I__Lcom_raquo_ew_JsArray__I(0, observables)) | 0);
  this.Lcom_raquo_airstream_combine_MergeStream__f_lastFiredInTrx = (void 0);
  this.Lcom_raquo_airstream_combine_MergeStream__f_pendingParentValues = new $c_Lcom_raquo_airstream_util_JsPriorityQueue(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((observation) => {
    var observable = observation.Lcom_raquo_airstream_common_Observation__f_observable;
    return observable.topoRank__I();
  })));
  this.Lcom_raquo_airstream_combine_MergeStream__f_parentObservers = $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_common_InternalParentObserver.getArrayOf().constr)([])));
  var arr = this.Lcom_raquo_airstream_combine_MergeStream__f_parents;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var parent = arr[i];
    (this.Lcom_raquo_airstream_combine_MergeStream__f_parentObservers.push($p_Lcom_raquo_airstream_combine_MergeStream__makeInternalObserver__Lcom_raquo_airstream_core_Observable__Lcom_raquo_airstream_common_InternalParentObserver(this, parent)) | 0);
    i = ((1 + i) | 0);
  }
}
export { $c_Lcom_raquo_airstream_combine_MergeStream as $c_Lcom_raquo_airstream_combine_MergeStream };
$c_Lcom_raquo_airstream_combine_MergeStream.prototype = new $h_O();
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.constructor = $c_Lcom_raquo_airstream_combine_MergeStream;
/** @constructor */
function $h_Lcom_raquo_airstream_combine_MergeStream() {
}
export { $h_Lcom_raquo_airstream_combine_MergeStream as $h_Lcom_raquo_airstream_combine_MergeStream };
$h_Lcom_raquo_airstream_combine_MergeStream.prototype = $c_Lcom_raquo_airstream_combine_MergeStream.prototype;
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_combine_MergeStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_MergeStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_combine_MergeStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_combine_MergeStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_MergeStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_MergeStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_combine_MergeStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_combine_MergeStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_combine_MergeStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_combine_MergeStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_combine_MergeStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_combine_MergeStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.onWillStart__V = (function() {
  $f_Lcom_raquo_airstream_common_MultiParentStream__onWillStart__V(this);
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.parents__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_combine_MergeStream__f_parents;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_combine_MergeStream__f_topoRank;
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.syncFire__Lcom_raquo_airstream_core_Transaction__V = (function(transaction) {
  while (true) {
    var this$1 = this.Lcom_raquo_airstream_combine_MergeStream__f_pendingParentValues;
    if (((this$1.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue.length | 0) !== 0)) {
      var this$2 = this.Lcom_raquo_airstream_combine_MergeStream__f_pendingParentValues;
      if (((this$2.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue.length | 0) === 0)) {
        throw $ct_jl_Exception__T__(new $c_jl_Exception(), "Unable to dequeue an empty JsPriorityQueue");
      }
      var nextValue = this$2.Lcom_raquo_airstream_util_JsPriorityQueue__f_queue.shift().Lcom_raquo_airstream_common_Observation__f_value;
      var x = this.Lcom_raquo_airstream_combine_MergeStream__f_lastFiredInTrx;
      if (((x !== (void 0)) && $m_sr_BoxesRunTime$().equals__O__O__Z(transaction, x))) {
        nextValue.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextError) => {
          var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextError$2) => ((_$1) => {
            $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError$2, _$1);
          }))(nextError));
          new $c_Lcom_raquo_airstream_core_Transaction(code);
        })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextEvent) => {
          var code$1 = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
            $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextEvent, _$2);
          }));
          new $c_Lcom_raquo_airstream_core_Transaction(code$1);
        })));
      } else {
        this.Lcom_raquo_airstream_combine_MergeStream__f_lastFiredInTrx = transaction;
        nextValue.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((transaction) => ((_$3) => {
          $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, _$3, transaction);
        }))(transaction)), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((transaction) => ((_$4) => {
          $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, _$4, transaction);
        }))(transaction)));
      }
    } else {
      break;
    }
  }
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.onStart__V = (function() {
  var arr = this.Lcom_raquo_airstream_combine_MergeStream__f_parentObservers;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$5 = arr[i];
    $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$5.Lcom_raquo_airstream_common_InternalParentObserver$$anon$2__f_parent, _$5, false);
    i = ((1 + i) | 0);
  }
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.onStop__V = (function() {
  var arr = this.Lcom_raquo_airstream_combine_MergeStream__f_parentObservers;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$6 = arr[i];
    $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$6.Lcom_raquo_airstream_common_InternalParentObserver$$anon$2__f_parent, _$6);
    i = ((1 + i) | 0);
  }
  this.Lcom_raquo_airstream_combine_MergeStream__f_lastFiredInTrx = (void 0);
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_combine_MergeStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_combine_MergeStream = new $TypeData().initClass($c_Lcom_raquo_airstream_combine_MergeStream, "com.raquo.airstream.combine.MergeStream", ({
  Lcom_raquo_airstream_combine_MergeStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_core_SyncObservable: 1,
  Lcom_raquo_airstream_common_MultiParentStream: 1
}));
export { $d_Lcom_raquo_airstream_combine_MergeStream as $d_Lcom_raquo_airstream_combine_MergeStream };
function $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V($thiz) {
  $thiz.com$raquo$airstream$common$SingleParentSignal$_setter_$parentIsSignal_$eq__Z__V($is_Lcom_raquo_airstream_core_Signal($thiz.parent__Lcom_raquo_airstream_core_Observable()));
  $thiz._parentLastUpdateId_$eq__I__V((-1));
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V };
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V($thiz) {
  var observable = $thiz.parent__Lcom_raquo_airstream_core_Observable();
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
  if ($thiz.parentIsSignal__Z()) {
    var signal = $thiz.parent__Lcom_raquo_airstream_core_Observable();
    var newParentLastUpdateId = signal._lastUpdateId__I();
    if ((newParentLastUpdateId !== $thiz._parentLastUpdateId__I())) {
      $thiz.updateCurrentValueFromParent__s_util_Try__I__V($thiz.currentValueFromParent__s_util_Try(), newParentLastUpdateId);
    }
  }
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V };
function $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V($thiz, nextValue, nextParentLastUpdateId) {
  $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V($thiz, nextValue);
  $thiz._parentLastUpdateId_$eq__I__V(nextParentLastUpdateId);
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V };
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V($thiz, nextParentValue, transaction) {
  if ($thiz.parentIsSignal__Z()) {
    var signal = $thiz.parent__Lcom_raquo_airstream_core_Observable();
    $thiz._parentLastUpdateId_$eq__I__V(signal._lastUpdateId__I());
  }
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V };
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V($thiz) {
  $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V($thiz.parent__Lcom_raquo_airstream_core_Observable(), $thiz, false);
  $f_Lcom_raquo_airstream_core_Signal__onStart__V($thiz);
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V };
function $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V($thiz) {
  $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V($thiz.parent__Lcom_raquo_airstream_core_Observable(), $thiz);
}
export { $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V as $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V };
/** @constructor */
function $c_Lcom_raquo_airstream_eventbus_EventBusStream(parentDisplayName) {
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_parentDisplayName = null;
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_sourceStreams = null;
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_parentDisplayName = parentDisplayName;
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_sourceStreams = $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_Lcom_raquo_airstream_core_EventStream.getArrayOf().constr)([])));
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_topoRank = 1;
}
export { $c_Lcom_raquo_airstream_eventbus_EventBusStream as $c_Lcom_raquo_airstream_eventbus_EventBusStream };
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype = new $h_O();
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.constructor = $c_Lcom_raquo_airstream_eventbus_EventBusStream;
/** @constructor */
function $h_Lcom_raquo_airstream_eventbus_EventBusStream() {
}
export { $h_Lcom_raquo_airstream_eventbus_EventBusStream as $h_Lcom_raquo_airstream_eventbus_EventBusStream };
$h_Lcom_raquo_airstream_eventbus_EventBusStream.prototype = $c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype;
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_eventbus_EventBusStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_eventbus_EventBusStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_eventbus_EventBusStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_eventbus_EventBusStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_eventbus_EventBusStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_eventbus_EventBusStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_eventbus_EventBusStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_eventbus_EventBusStream__f_topoRank;
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, ignoredTransaction) {
  var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, _$1);
  }));
  new $c_Lcom_raquo_airstream_core_Transaction(code);
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, _$2);
  }));
  new $c_Lcom_raquo_airstream_core_Transaction(code);
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.onWillStart__V = (function() {
  var arr = this.Lcom_raquo_airstream_eventbus_EventBusStream__f_sourceStreams;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$3 = arr[i];
    $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(_$3);
    i = ((1 + i) | 0);
  }
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.onStart__V = (function() {
  var arr = this.Lcom_raquo_airstream_eventbus_EventBusStream__f_sourceStreams;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$4 = arr[i];
    $f_Lcom_raquo_airstream_core_WritableObservable__addInternalObserver__Lcom_raquo_airstream_core_InternalObserver__Z__V(_$4, this, false);
    i = ((1 + i) | 0);
  }
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.onStop__V = (function() {
  var arr = this.Lcom_raquo_airstream_eventbus_EventBusStream__f_sourceStreams;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$5 = arr[i];
    $f_Lcom_raquo_airstream_core_BaseObservable__removeInternalObserver__Lcom_raquo_airstream_core_InternalObserver__V(_$5, this);
    i = ((1 + i) | 0);
  }
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.defaultDisplayName__T = (function() {
  return (this.Lcom_raquo_airstream_eventbus_EventBusStream__f_parentDisplayName.apply__O() + ".events");
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_eventbus_EventBusStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_eventbus_EventBusStream = new $TypeData().initClass($c_Lcom_raquo_airstream_eventbus_EventBusStream, "com.raquo.airstream.eventbus.EventBusStream", ({
  Lcom_raquo_airstream_eventbus_EventBusStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalNextErrorObserver: 1
}));
export { $d_Lcom_raquo_airstream_eventbus_EventBusStream as $d_Lcom_raquo_airstream_eventbus_EventBusStream };
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "STRICT", 0);
}
export { $c_Ljava_time_format_ResolverStyle$$anon$1 as $c_Ljava_time_format_ResolverStyle$$anon$1 };
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype = new $h_Ljava_time_format_ResolverStyle();
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.constructor = $c_Ljava_time_format_ResolverStyle$$anon$1;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$$anon$1() {
}
export { $h_Ljava_time_format_ResolverStyle$$anon$1 as $h_Ljava_time_format_ResolverStyle$$anon$1 };
$h_Ljava_time_format_ResolverStyle$$anon$1.prototype = $c_Ljava_time_format_ResolverStyle$$anon$1.prototype;
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_ResolverStyle$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_ResolverStyle$$anon$1 = new $TypeData().initClass($c_Ljava_time_format_ResolverStyle$$anon$1, "java.time.format.ResolverStyle$$anon$1", ({
  Ljava_time_format_ResolverStyle$$anon$1: 1,
  Ljava_time_format_ResolverStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_ResolverStyle$$anon$1 as $d_Ljava_time_format_ResolverStyle$$anon$1 };
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "SMART", 1);
}
export { $c_Ljava_time_format_ResolverStyle$$anon$2 as $c_Ljava_time_format_ResolverStyle$$anon$2 };
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype = new $h_Ljava_time_format_ResolverStyle();
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.constructor = $c_Ljava_time_format_ResolverStyle$$anon$2;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$$anon$2() {
}
export { $h_Ljava_time_format_ResolverStyle$$anon$2 as $h_Ljava_time_format_ResolverStyle$$anon$2 };
$h_Ljava_time_format_ResolverStyle$$anon$2.prototype = $c_Ljava_time_format_ResolverStyle$$anon$2.prototype;
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_ResolverStyle$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_ResolverStyle$$anon$2 = new $TypeData().initClass($c_Ljava_time_format_ResolverStyle$$anon$2, "java.time.format.ResolverStyle$$anon$2", ({
  Ljava_time_format_ResolverStyle$$anon$2: 1,
  Ljava_time_format_ResolverStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_ResolverStyle$$anon$2 as $d_Ljava_time_format_ResolverStyle$$anon$2 };
/** @constructor */
function $c_Ljava_time_format_ResolverStyle$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "LENIENT", 2);
}
export { $c_Ljava_time_format_ResolverStyle$$anon$3 as $c_Ljava_time_format_ResolverStyle$$anon$3 };
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype = new $h_Ljava_time_format_ResolverStyle();
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.constructor = $c_Ljava_time_format_ResolverStyle$$anon$3;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle$$anon$3() {
}
export { $h_Ljava_time_format_ResolverStyle$$anon$3 as $h_Ljava_time_format_ResolverStyle$$anon$3 };
$h_Ljava_time_format_ResolverStyle$$anon$3.prototype = $c_Ljava_time_format_ResolverStyle$$anon$3.prototype;
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_ResolverStyle$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_ResolverStyle$$anon$3 = new $TypeData().initClass($c_Ljava_time_format_ResolverStyle$$anon$3, "java.time.format.ResolverStyle$$anon$3", ({
  Ljava_time_format_ResolverStyle$$anon$3: 1,
  Ljava_time_format_ResolverStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_ResolverStyle$$anon$3 as $d_Ljava_time_format_ResolverStyle$$anon$3 };
/** @constructor */
function $c_Ljava_time_format_SignStyle$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
  $ct_Ljava_time_format_SignStyle__T__I__T__I__(this, "NORMAL", 0, "NORMAL", 0);
}
export { $c_Ljava_time_format_SignStyle$$anon$1 as $c_Ljava_time_format_SignStyle$$anon$1 };
$c_Ljava_time_format_SignStyle$$anon$1.prototype = new $h_Ljava_time_format_SignStyle();
$c_Ljava_time_format_SignStyle$$anon$1.prototype.constructor = $c_Ljava_time_format_SignStyle$$anon$1;
/** @constructor */
function $h_Ljava_time_format_SignStyle$$anon$1() {
}
export { $h_Ljava_time_format_SignStyle$$anon$1 as $h_Ljava_time_format_SignStyle$$anon$1 };
$h_Ljava_time_format_SignStyle$$anon$1.prototype = $c_Ljava_time_format_SignStyle$$anon$1.prototype;
$c_Ljava_time_format_SignStyle$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_SignStyle$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_SignStyle$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_SignStyle$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_SignStyle$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_SignStyle$$anon$1 = new $TypeData().initClass($c_Ljava_time_format_SignStyle$$anon$1, "java.time.format.SignStyle$$anon$1", ({
  Ljava_time_format_SignStyle$$anon$1: 1,
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_SignStyle$$anon$1 as $d_Ljava_time_format_SignStyle$$anon$1 };
/** @constructor */
function $c_Ljava_time_format_SignStyle$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
  $ct_Ljava_time_format_SignStyle__T__I__T__I__(this, "ALWAYS", 1, "ALWAYS", 1);
}
export { $c_Ljava_time_format_SignStyle$$anon$2 as $c_Ljava_time_format_SignStyle$$anon$2 };
$c_Ljava_time_format_SignStyle$$anon$2.prototype = new $h_Ljava_time_format_SignStyle();
$c_Ljava_time_format_SignStyle$$anon$2.prototype.constructor = $c_Ljava_time_format_SignStyle$$anon$2;
/** @constructor */
function $h_Ljava_time_format_SignStyle$$anon$2() {
}
export { $h_Ljava_time_format_SignStyle$$anon$2 as $h_Ljava_time_format_SignStyle$$anon$2 };
$h_Ljava_time_format_SignStyle$$anon$2.prototype = $c_Ljava_time_format_SignStyle$$anon$2.prototype;
$c_Ljava_time_format_SignStyle$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_SignStyle$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_SignStyle$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_SignStyle$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_SignStyle$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_SignStyle$$anon$2 = new $TypeData().initClass($c_Ljava_time_format_SignStyle$$anon$2, "java.time.format.SignStyle$$anon$2", ({
  Ljava_time_format_SignStyle$$anon$2: 1,
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_SignStyle$$anon$2 as $d_Ljava_time_format_SignStyle$$anon$2 };
/** @constructor */
function $c_Ljava_time_format_SignStyle$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
  $ct_Ljava_time_format_SignStyle__T__I__T__I__(this, "NEVER", 2, "NEVER", 2);
}
export { $c_Ljava_time_format_SignStyle$$anon$3 as $c_Ljava_time_format_SignStyle$$anon$3 };
$c_Ljava_time_format_SignStyle$$anon$3.prototype = new $h_Ljava_time_format_SignStyle();
$c_Ljava_time_format_SignStyle$$anon$3.prototype.constructor = $c_Ljava_time_format_SignStyle$$anon$3;
/** @constructor */
function $h_Ljava_time_format_SignStyle$$anon$3() {
}
export { $h_Ljava_time_format_SignStyle$$anon$3 as $h_Ljava_time_format_SignStyle$$anon$3 };
$h_Ljava_time_format_SignStyle$$anon$3.prototype = $c_Ljava_time_format_SignStyle$$anon$3.prototype;
$c_Ljava_time_format_SignStyle$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_SignStyle$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_SignStyle$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_SignStyle$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_SignStyle$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_SignStyle$$anon$3 = new $TypeData().initClass($c_Ljava_time_format_SignStyle$$anon$3, "java.time.format.SignStyle$$anon$3", ({
  Ljava_time_format_SignStyle$$anon$3: 1,
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_SignStyle$$anon$3 as $d_Ljava_time_format_SignStyle$$anon$3 };
/** @constructor */
function $c_Ljava_time_format_SignStyle$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
  $ct_Ljava_time_format_SignStyle__T__I__T__I__(this, "NOT_NEGATIVE", 3, "NOT_NEGATIVE", 3);
}
export { $c_Ljava_time_format_SignStyle$$anon$4 as $c_Ljava_time_format_SignStyle$$anon$4 };
$c_Ljava_time_format_SignStyle$$anon$4.prototype = new $h_Ljava_time_format_SignStyle();
$c_Ljava_time_format_SignStyle$$anon$4.prototype.constructor = $c_Ljava_time_format_SignStyle$$anon$4;
/** @constructor */
function $h_Ljava_time_format_SignStyle$$anon$4() {
}
export { $h_Ljava_time_format_SignStyle$$anon$4 as $h_Ljava_time_format_SignStyle$$anon$4 };
$h_Ljava_time_format_SignStyle$$anon$4.prototype = $c_Ljava_time_format_SignStyle$$anon$4.prototype;
$c_Ljava_time_format_SignStyle$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_SignStyle$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_SignStyle$$anon$4.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_SignStyle$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_SignStyle$$anon$4.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_SignStyle$$anon$4 = new $TypeData().initClass($c_Ljava_time_format_SignStyle$$anon$4, "java.time.format.SignStyle$$anon$4", ({
  Ljava_time_format_SignStyle$$anon$4: 1,
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_SignStyle$$anon$4 as $d_Ljava_time_format_SignStyle$$anon$4 };
/** @constructor */
function $c_Ljava_time_format_SignStyle$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_SignStyle__f_ordinal = 0;
  $ct_Ljava_time_format_SignStyle__T__I__T__I__(this, "EXCEEDS_PAD", 4, "EXCEEDS_PAD", 4);
}
export { $c_Ljava_time_format_SignStyle$$anon$5 as $c_Ljava_time_format_SignStyle$$anon$5 };
$c_Ljava_time_format_SignStyle$$anon$5.prototype = new $h_Ljava_time_format_SignStyle();
$c_Ljava_time_format_SignStyle$$anon$5.prototype.constructor = $c_Ljava_time_format_SignStyle$$anon$5;
/** @constructor */
function $h_Ljava_time_format_SignStyle$$anon$5() {
}
export { $h_Ljava_time_format_SignStyle$$anon$5 as $h_Ljava_time_format_SignStyle$$anon$5 };
$h_Ljava_time_format_SignStyle$$anon$5.prototype = $c_Ljava_time_format_SignStyle$$anon$5.prototype;
$c_Ljava_time_format_SignStyle$$anon$5.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_SignStyle$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_SignStyle$$anon$5.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_SignStyle$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_SignStyle$$anon$5.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_SignStyle$$anon$5 = new $TypeData().initClass($c_Ljava_time_format_SignStyle$$anon$5, "java.time.format.SignStyle$$anon$5", ({
  Ljava_time_format_SignStyle$$anon$5: 1,
  Ljava_time_format_SignStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_SignStyle$$anon$5 as $d_Ljava_time_format_SignStyle$$anon$5 };
/** @constructor */
function $c_Ljava_time_format_TextStyle$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_TextStyle__f_ordinal = 0;
  $ct_Ljava_time_format_TextStyle__T__I__T__I__(this, "FULL", 0, "FULL", 0);
}
export { $c_Ljava_time_format_TextStyle$$anon$1 as $c_Ljava_time_format_TextStyle$$anon$1 };
$c_Ljava_time_format_TextStyle$$anon$1.prototype = new $h_Ljava_time_format_TextStyle();
$c_Ljava_time_format_TextStyle$$anon$1.prototype.constructor = $c_Ljava_time_format_TextStyle$$anon$1;
/** @constructor */
function $h_Ljava_time_format_TextStyle$$anon$1() {
}
export { $h_Ljava_time_format_TextStyle$$anon$1 as $h_Ljava_time_format_TextStyle$$anon$1 };
$h_Ljava_time_format_TextStyle$$anon$1.prototype = $c_Ljava_time_format_TextStyle$$anon$1.prototype;
$c_Ljava_time_format_TextStyle$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_TextStyle$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_TextStyle$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_TextStyle$$anon$1 = new $TypeData().initClass($c_Ljava_time_format_TextStyle$$anon$1, "java.time.format.TextStyle$$anon$1", ({
  Ljava_time_format_TextStyle$$anon$1: 1,
  Ljava_time_format_TextStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_TextStyle$$anon$1 as $d_Ljava_time_format_TextStyle$$anon$1 };
/** @constructor */
function $c_Ljava_time_format_TextStyle$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_TextStyle__f_ordinal = 0;
  $ct_Ljava_time_format_TextStyle__T__I__T__I__(this, "FULL_STANDALONE", 1, "FULL_STANDALONE", 1);
}
export { $c_Ljava_time_format_TextStyle$$anon$2 as $c_Ljava_time_format_TextStyle$$anon$2 };
$c_Ljava_time_format_TextStyle$$anon$2.prototype = new $h_Ljava_time_format_TextStyle();
$c_Ljava_time_format_TextStyle$$anon$2.prototype.constructor = $c_Ljava_time_format_TextStyle$$anon$2;
/** @constructor */
function $h_Ljava_time_format_TextStyle$$anon$2() {
}
export { $h_Ljava_time_format_TextStyle$$anon$2 as $h_Ljava_time_format_TextStyle$$anon$2 };
$h_Ljava_time_format_TextStyle$$anon$2.prototype = $c_Ljava_time_format_TextStyle$$anon$2.prototype;
$c_Ljava_time_format_TextStyle$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_TextStyle$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_TextStyle$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_TextStyle$$anon$2 = new $TypeData().initClass($c_Ljava_time_format_TextStyle$$anon$2, "java.time.format.TextStyle$$anon$2", ({
  Ljava_time_format_TextStyle$$anon$2: 1,
  Ljava_time_format_TextStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_TextStyle$$anon$2 as $d_Ljava_time_format_TextStyle$$anon$2 };
/** @constructor */
function $c_Ljava_time_format_TextStyle$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_TextStyle__f_ordinal = 0;
  $ct_Ljava_time_format_TextStyle__T__I__T__I__(this, "SHORT", 2, "SHORT", 2);
}
export { $c_Ljava_time_format_TextStyle$$anon$3 as $c_Ljava_time_format_TextStyle$$anon$3 };
$c_Ljava_time_format_TextStyle$$anon$3.prototype = new $h_Ljava_time_format_TextStyle();
$c_Ljava_time_format_TextStyle$$anon$3.prototype.constructor = $c_Ljava_time_format_TextStyle$$anon$3;
/** @constructor */
function $h_Ljava_time_format_TextStyle$$anon$3() {
}
export { $h_Ljava_time_format_TextStyle$$anon$3 as $h_Ljava_time_format_TextStyle$$anon$3 };
$h_Ljava_time_format_TextStyle$$anon$3.prototype = $c_Ljava_time_format_TextStyle$$anon$3.prototype;
$c_Ljava_time_format_TextStyle$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_TextStyle$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_TextStyle$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_TextStyle$$anon$3 = new $TypeData().initClass($c_Ljava_time_format_TextStyle$$anon$3, "java.time.format.TextStyle$$anon$3", ({
  Ljava_time_format_TextStyle$$anon$3: 1,
  Ljava_time_format_TextStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_TextStyle$$anon$3 as $d_Ljava_time_format_TextStyle$$anon$3 };
/** @constructor */
function $c_Ljava_time_format_TextStyle$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_TextStyle__f_ordinal = 0;
  $ct_Ljava_time_format_TextStyle__T__I__T__I__(this, "SHORT_STANDALONE", 3, "SHORT_STANDALONE", 3);
}
export { $c_Ljava_time_format_TextStyle$$anon$4 as $c_Ljava_time_format_TextStyle$$anon$4 };
$c_Ljava_time_format_TextStyle$$anon$4.prototype = new $h_Ljava_time_format_TextStyle();
$c_Ljava_time_format_TextStyle$$anon$4.prototype.constructor = $c_Ljava_time_format_TextStyle$$anon$4;
/** @constructor */
function $h_Ljava_time_format_TextStyle$$anon$4() {
}
export { $h_Ljava_time_format_TextStyle$$anon$4 as $h_Ljava_time_format_TextStyle$$anon$4 };
$h_Ljava_time_format_TextStyle$$anon$4.prototype = $c_Ljava_time_format_TextStyle$$anon$4.prototype;
$c_Ljava_time_format_TextStyle$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_TextStyle$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$4.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_TextStyle$$anon$4.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_TextStyle$$anon$4 = new $TypeData().initClass($c_Ljava_time_format_TextStyle$$anon$4, "java.time.format.TextStyle$$anon$4", ({
  Ljava_time_format_TextStyle$$anon$4: 1,
  Ljava_time_format_TextStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_TextStyle$$anon$4 as $d_Ljava_time_format_TextStyle$$anon$4 };
/** @constructor */
function $c_Ljava_time_format_TextStyle$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_TextStyle__f_ordinal = 0;
  $ct_Ljava_time_format_TextStyle__T__I__T__I__(this, "NARROW", 4, "NARROW", 4);
}
export { $c_Ljava_time_format_TextStyle$$anon$5 as $c_Ljava_time_format_TextStyle$$anon$5 };
$c_Ljava_time_format_TextStyle$$anon$5.prototype = new $h_Ljava_time_format_TextStyle();
$c_Ljava_time_format_TextStyle$$anon$5.prototype.constructor = $c_Ljava_time_format_TextStyle$$anon$5;
/** @constructor */
function $h_Ljava_time_format_TextStyle$$anon$5() {
}
export { $h_Ljava_time_format_TextStyle$$anon$5 as $h_Ljava_time_format_TextStyle$$anon$5 };
$h_Ljava_time_format_TextStyle$$anon$5.prototype = $c_Ljava_time_format_TextStyle$$anon$5.prototype;
$c_Ljava_time_format_TextStyle$$anon$5.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_TextStyle$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$5.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_TextStyle$$anon$5.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_TextStyle$$anon$5 = new $TypeData().initClass($c_Ljava_time_format_TextStyle$$anon$5, "java.time.format.TextStyle$$anon$5", ({
  Ljava_time_format_TextStyle$$anon$5: 1,
  Ljava_time_format_TextStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_TextStyle$$anon$5 as $d_Ljava_time_format_TextStyle$$anon$5 };
/** @constructor */
function $c_Ljava_time_format_TextStyle$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_TextStyle__f_ordinal = 0;
  $ct_Ljava_time_format_TextStyle__T__I__T__I__(this, "NARROW_STANDALONE", 5, "NARROW_STANDALONE", 5);
}
export { $c_Ljava_time_format_TextStyle$$anon$6 as $c_Ljava_time_format_TextStyle$$anon$6 };
$c_Ljava_time_format_TextStyle$$anon$6.prototype = new $h_Ljava_time_format_TextStyle();
$c_Ljava_time_format_TextStyle$$anon$6.prototype.constructor = $c_Ljava_time_format_TextStyle$$anon$6;
/** @constructor */
function $h_Ljava_time_format_TextStyle$$anon$6() {
}
export { $h_Ljava_time_format_TextStyle$$anon$6 as $h_Ljava_time_format_TextStyle$$anon$6 };
$h_Ljava_time_format_TextStyle$$anon$6.prototype = $c_Ljava_time_format_TextStyle$$anon$6.prototype;
$c_Ljava_time_format_TextStyle$$anon$6.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_TextStyle$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$6.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_TextStyle$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_TextStyle$$anon$6.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_TextStyle$$anon$6 = new $TypeData().initClass($c_Ljava_time_format_TextStyle$$anon$6, "java.time.format.TextStyle$$anon$6", ({
  Ljava_time_format_TextStyle$$anon$6: 1,
  Ljava_time_format_TextStyle: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_TextStyle$$anon$6 as $d_Ljava_time_format_TextStyle$$anon$6 };
/** @constructor */
function $c_ju_Locale$Category$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "DISPLAY", 0);
}
export { $c_ju_Locale$Category$$anon$2 as $c_ju_Locale$Category$$anon$2 };
$c_ju_Locale$Category$$anon$2.prototype = new $h_ju_Locale$Category();
$c_ju_Locale$Category$$anon$2.prototype.constructor = $c_ju_Locale$Category$$anon$2;
/** @constructor */
function $h_ju_Locale$Category$$anon$2() {
}
export { $h_ju_Locale$Category$$anon$2 as $h_ju_Locale$Category$$anon$2 };
$h_ju_Locale$Category$$anon$2.prototype = $c_ju_Locale$Category$$anon$2.prototype;
$c_ju_Locale$Category$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_ju_Locale$Category$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_ju_Locale$Category$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_ju_Locale$Category$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_ju_Locale$Category$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_ju_Locale$Category$$anon$2 = new $TypeData().initClass($c_ju_Locale$Category$$anon$2, "java.util.Locale$Category$$anon$2", ({
  ju_Locale$Category$$anon$2: 1,
  ju_Locale$Category: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_ju_Locale$Category$$anon$2 as $d_ju_Locale$Category$$anon$2 };
/** @constructor */
function $c_ju_Locale$Category$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  $ct_jl_Enum__T__I__(this, "FORMAT", 1);
}
export { $c_ju_Locale$Category$$anon$3 as $c_ju_Locale$Category$$anon$3 };
$c_ju_Locale$Category$$anon$3.prototype = new $h_ju_Locale$Category();
$c_ju_Locale$Category$$anon$3.prototype.constructor = $c_ju_Locale$Category$$anon$3;
/** @constructor */
function $h_ju_Locale$Category$$anon$3() {
}
export { $h_ju_Locale$Category$$anon$3 as $h_ju_Locale$Category$$anon$3 };
$h_ju_Locale$Category$$anon$3.prototype = $c_ju_Locale$Category$$anon$3.prototype;
$c_ju_Locale$Category$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_ju_Locale$Category$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_ju_Locale$Category$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_ju_Locale$Category$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_ju_Locale$Category$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_ju_Locale$Category$$anon$3 = new $TypeData().initClass($c_ju_Locale$Category$$anon$3, "java.util.Locale$Category$$anon$3", ({
  ju_Locale$Category$$anon$3: 1,
  ju_Locale$Category: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_ju_Locale$Category$$anon$3 as $d_ju_Locale$Category$$anon$3 };
/** @constructor */
function $c_sc_AbstractSeq() {
}
export { $c_sc_AbstractSeq as $c_sc_AbstractSeq };
$c_sc_AbstractSeq.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractSeq.prototype.constructor = $c_sc_AbstractSeq;
/** @constructor */
function $h_sc_AbstractSeq() {
}
export { $h_sc_AbstractSeq as $h_sc_AbstractSeq };
$h_sc_AbstractSeq.prototype = $c_sc_AbstractSeq.prototype;
$c_sc_AbstractSeq.prototype.canEqual__O__Z = (function(that) {
  return true;
});
$c_sc_AbstractSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$c_sc_AbstractSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
});
$c_sc_AbstractSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractSeq.prototype.view__sc_SeqView = (function() {
  return $ct_sc_SeqView$Id__sc_SeqOps__(new $c_sc_SeqView$Id(), this);
});
$c_sc_AbstractSeq.prototype.appended__O__O = (function(elem) {
  return $f_sc_SeqOps__appended__O__O(this, elem);
});
$c_sc_AbstractSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_AbstractSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__O(suffix);
});
$c_sc_AbstractSeq.prototype.size__I = (function() {
  return this.length__I();
});
$c_sc_AbstractSeq.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$c_sc_AbstractSeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_AbstractSeq.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator();
});
$c_sc_AbstractSeq.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_AbstractSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.iterator__sc_Iterator(), p, from);
});
$c_sc_AbstractSeq.prototype.indexOf__O__I__I = (function(elem, from) {
  return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
});
$c_sc_AbstractSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sc_AbstractSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize);
});
$c_sc_AbstractSeq.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_AbstractSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_AbstractSeq.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sc_AbstractSeq.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_SeqOps__diff__sc_Seq__O(this, that);
});
$c_sc_AbstractSeq.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem);
});
$c_sc_AbstractSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sc_AbstractSeq.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sc_AbstractSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sc_AbstractSeq.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sc_AbstractSeq.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!this.apply__O__O(v1)));
});
$c_sc_AbstractSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sc_AbstractSeq.prototype.isDefinedAt__O__Z = (function(x) {
  return this.isDefinedAt__I__Z((x | 0));
});
/** @constructor */
function $c_sc_AbstractSeqView() {
}
export { $c_sc_AbstractSeqView as $c_sc_AbstractSeqView };
$c_sc_AbstractSeqView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractSeqView.prototype.constructor = $c_sc_AbstractSeqView;
/** @constructor */
function $h_sc_AbstractSeqView() {
}
export { $h_sc_AbstractSeqView as $h_sc_AbstractSeqView };
$h_sc_AbstractSeqView.prototype = $c_sc_AbstractSeqView.prototype;
$c_sc_AbstractSeqView.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_AbstractSeqView.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_AbstractSeqView.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_AbstractSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_AbstractSeqView.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_AbstractSeqView.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_AbstractSeqView.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_AbstractSeqView.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_AbstractSeqView.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator();
});
$c_sc_AbstractSeqView.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_AbstractSeqView.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.iterator__sc_Iterator(), p, from);
});
$c_sc_AbstractSeqView.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize);
});
$c_sc_AbstractSeqView.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_AbstractSeqView.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_AbstractSeqView.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem);
});
$c_sc_AbstractSeqView.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_AbstractSeqView.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_AbstractSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_AbstractSeqView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_AbstractSeqView.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_AbstractSeqView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
function $is_sc_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_IndexedSeq)));
}
export { $is_sc_IndexedSeq as $is_sc_IndexedSeq };
function $isArrayOf_sc_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_IndexedSeq)));
}
export { $isArrayOf_sc_IndexedSeq as $isArrayOf_sc_IndexedSeq };
function $is_sc_LinearSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sc_LinearSeq)));
}
export { $is_sc_LinearSeq as $is_sc_LinearSeq };
function $isArrayOf_sc_LinearSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_LinearSeq)));
}
export { $isArrayOf_sc_LinearSeq as $isArrayOf_sc_LinearSeq };
/** @constructor */
function $c_sc_View$Empty$() {
}
export { $c_sc_View$Empty$ as $c_sc_View$Empty$ };
$c_sc_View$Empty$.prototype = new $h_sc_AbstractView();
$c_sc_View$Empty$.prototype.constructor = $c_sc_View$Empty$;
/** @constructor */
function $h_sc_View$Empty$() {
}
export { $h_sc_View$Empty$ as $h_sc_View$Empty$ };
$h_sc_View$Empty$.prototype = $c_sc_View$Empty$.prototype;
$c_sc_View$Empty$.prototype.productElementName__I__T = (function(n) {
  return $f_s_Product__productElementName__I__T(this, n);
});
$c_sc_View$Empty$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sc_View$Empty$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sc_View$Empty$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sc_View$Empty$.prototype.productPrefix__T = (function() {
  return "Empty";
});
$c_sc_View$Empty$.prototype.productArity__I = (function() {
  return 0;
});
$c_sc_View$Empty$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_sc_View$Empty$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sc_View$Empty$.prototype.hashCode__I = (function() {
  return 67081517;
});
var $d_sc_View$Empty$ = new $TypeData().initClass($c_sc_View$Empty$, "scala.collection.View$Empty$", ({
  sc_View$Empty$: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1,
  s_Equals: 1
}));
export { $d_sc_View$Empty$ as $d_sc_View$Empty$ };
var $n_sc_View$Empty$;
function $m_sc_View$Empty$() {
  if ((!$n_sc_View$Empty$)) {
    $n_sc_View$Empty$ = new $c_sc_View$Empty$();
  }
  return $n_sc_View$Empty$;
}
export { $m_sc_View$Empty$ as $m_sc_View$Empty$ };
function $f_scm_SetOps__add__O__Z($thiz, elem) {
  return ((!$thiz.contains__O__Z(elem)) && ($thiz.addOne__O__scm_Growable(elem), true));
}
export { $f_scm_SetOps__add__O__Z as $f_scm_SetOps__add__O__Z };
function $f_scm_SetOps__remove__O__Z($thiz, elem) {
  var res = $thiz.contains__O__Z(elem);
  $thiz.subtractOne__O__scm_Shrinkable(elem);
  return res;
}
export { $f_scm_SetOps__remove__O__Z as $f_scm_SetOps__remove__O__Z };
function $f_Lcats_ComposedApplicative__pure__O__O($thiz, x) {
  return $thiz.F__Lcats_Applicative().pure__O__O($thiz.G__Lcats_Applicative().pure__O__O(x));
}
export { $f_Lcats_ComposedApplicative__pure__O__O as $f_Lcats_ComposedApplicative__pure__O__O };
function $f_Lcats_StackSafeMonad__tailRecM__O__F1__O($thiz, a, f) {
  return $thiz.flatMap__O__F1__O(f.apply__O__O(a), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 instanceof $c_s_util_Left)) {
      var a$1 = x$1.s_util_Left__f_value;
      return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O($thiz, a$1, f);
    }
    if ((x$1 instanceof $c_s_util_Right)) {
      var b = x$1.s_util_Right__f_value;
      return $thiz.pure__O__O(b);
    }
    throw new $c_s_MatchError(x$1);
  })));
}
export { $f_Lcats_StackSafeMonad__tailRecM__O__F1__O as $f_Lcats_StackSafeMonad__tailRecM__O__F1__O };
function $is_Lcats_StackSafeMonad(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lcats_StackSafeMonad)));
}
export { $is_Lcats_StackSafeMonad as $is_Lcats_StackSafeMonad };
function $isArrayOf_Lcats_StackSafeMonad(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lcats_StackSafeMonad)));
}
export { $isArrayOf_Lcats_StackSafeMonad as $isArrayOf_Lcats_StackSafeMonad };
/** @constructor */
function $c_Lcom_raquo_airstream_distinct_DistinctSignal(parent, isSame, resetOnStop) {
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_externalObservers = null;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_internalObservers = null;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_willStartDone = false;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_parentIsSignal = false;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f__parentLastUpdateId = 0;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_parent = null;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_isSame = null;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_resetOnStop = false;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_topoRank = 0;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_parent = parent;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_isSame = isSame;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_resetOnStop = resetOnStop;
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f__lastUpdateId = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_maybeLastSeenCurrentValue = (void 0);
  $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_topoRank = ((1 + parent.topoRank__I()) | 0);
}
export { $c_Lcom_raquo_airstream_distinct_DistinctSignal as $c_Lcom_raquo_airstream_distinct_DistinctSignal };
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype = new $h_O();
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.constructor = $c_Lcom_raquo_airstream_distinct_DistinctSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_distinct_DistinctSignal() {
}
export { $h_Lcom_raquo_airstream_distinct_DistinctSignal as $h_Lcom_raquo_airstream_distinct_DistinctSignal };
$h_Lcom_raquo_airstream_distinct_DistinctSignal.prototype = $c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype;
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype._lastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f__lastUpdateId;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype._lastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f__lastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
  observer.onTry__s_util_Try__V($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f_externalObservers;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f_internalObservers;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f_willStartDone;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.maybeLastSeenCurrentValue__O = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f_maybeLastSeenCurrentValue;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.maybeLastSeenCurrentValue_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_maybeLastSeenCurrentValue = x$1;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.tryNow__s_util_Try = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.parentIsSignal__Z = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f_parentIsSignal;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype._parentLastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f__parentLastUpdateId;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype._parentLastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f__parentLastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.com$raquo$airstream$common$SingleParentSignal$_setter_$parentIsSignal_$eq__Z__V = (function(x$0) {
  this.Lcom_raquo_airstream_distinct_DistinctSignal__f_parentIsSignal = x$0;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.onWillStart__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.onStop__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f_topoRank;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextParentValue, transaction) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  if ((!(!(!this.Lcom_raquo_airstream_distinct_DistinctSignal__f_isSame.apply__O__O__O($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this), nextParentValue))))) {
    $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  }
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.currentValueFromParent__s_util_Try = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f_parent.tryNow__s_util_Try();
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.updateCurrentValueFromParent__s_util_Try__I__V = (function(nextValue, nextParentLastUpdateId) {
  if ((this.Lcom_raquo_airstream_distinct_DistinctSignal__f_resetOnStop || (!(!(!this.Lcom_raquo_airstream_distinct_DistinctSignal__f_isSame.apply__O__O__O(nextValue, $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this))))))) {
    $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
  }
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctSignal__f_parent;
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$c_Lcom_raquo_airstream_distinct_DistinctSignal.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_distinct_DistinctSignal = new $TypeData().initClass($c_Lcom_raquo_airstream_distinct_DistinctSignal, "com.raquo.airstream.distinct.DistinctSignal", ({
  Lcom_raquo_airstream_distinct_DistinctSignal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1,
  Lcom_raquo_airstream_common_SingleParentSignal: 1
}));
export { $d_Lcom_raquo_airstream_distinct_DistinctSignal as $d_Lcom_raquo_airstream_distinct_DistinctSignal };
/** @constructor */
function $c_Lcom_raquo_airstream_distinct_DistinctStream(parent, isSame, resetOnStop) {
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_parent = null;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_isSame = null;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_resetOnStop = false;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybeLastSeenValue = null;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_parent = parent;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_isSame = isSame;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_resetOnStop = resetOnStop;
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_topoRank = ((1 + parent.topoRank__I()) | 0);
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybeLastSeenValue = (void 0);
}
export { $c_Lcom_raquo_airstream_distinct_DistinctStream as $c_Lcom_raquo_airstream_distinct_DistinctStream };
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype = new $h_O();
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.constructor = $c_Lcom_raquo_airstream_distinct_DistinctStream;
/** @constructor */
function $h_Lcom_raquo_airstream_distinct_DistinctStream() {
}
export { $h_Lcom_raquo_airstream_distinct_DistinctStream as $h_Lcom_raquo_airstream_distinct_DistinctStream };
$h_Lcom_raquo_airstream_distinct_DistinctStream.prototype = $c_Lcom_raquo_airstream_distinct_DistinctStream.prototype;
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_distinct_DistinctStream__f_parent;
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctStream__f_topoRank;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  var x = this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybeLastSeenValue;
  if ((x === (void 0))) {
    var x$1 = (void 0);
  } else {
    var a = (!(!(!this.Lcom_raquo_airstream_distinct_DistinctStream__f_isSame.apply__O__O__O(x, nextValue))));
    var x$1 = a;
  }
  var isDistinct = ((x$1 === (void 0)) || x$1);
  this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybeLastSeenValue = nextValue;
  if (isDistinct) {
    $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
  }
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.onStop__V = (function() {
  if (this.Lcom_raquo_airstream_distinct_DistinctStream__f_resetOnStop) {
    this.Lcom_raquo_airstream_distinct_DistinctStream__f_maybeLastSeenValue = (void 0);
  }
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_distinct_DistinctStream__f_parent;
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_distinct_DistinctStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_distinct_DistinctStream = new $TypeData().initClass($c_Lcom_raquo_airstream_distinct_DistinctStream, "com.raquo.airstream.distinct.DistinctStream", ({
  Lcom_raquo_airstream_distinct_DistinctStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_SingleParentStream: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1
}));
export { $d_Lcom_raquo_airstream_distinct_DistinctStream as $d_Lcom_raquo_airstream_distinct_DistinctStream };
function $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__($thiz, parent, project, recover) {
  $thiz.Lcom_raquo_airstream_misc_MapSignal__f_parent = parent;
  $thiz.Lcom_raquo_airstream_misc_MapSignal__f_project = project;
  $thiz.Lcom_raquo_airstream_misc_MapSignal__f_recover = recover;
  $thiz.Lcom_raquo_airstream_misc_MapSignal__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V($thiz);
  $thiz.Lcom_raquo_airstream_misc_MapSignal__f__lastUpdateId = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V($thiz);
  $thiz.Lcom_raquo_airstream_misc_MapSignal__f_maybeLastSeenCurrentValue = (void 0);
  $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V($thiz);
  $thiz.Lcom_raquo_airstream_misc_MapSignal__f_topoRank = ((1 + parent.topoRank__I()) | 0);
  return $thiz;
}
export { $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__ as $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__ };
/** @constructor */
function $c_Lcom_raquo_airstream_misc_MapSignal() {
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_misc_MapSignal__f_externalObservers = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_internalObservers = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_willStartDone = false;
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_parentIsSignal = false;
  this.Lcom_raquo_airstream_misc_MapSignal__f__parentLastUpdateId = 0;
  this.Lcom_raquo_airstream_misc_MapSignal__f_parent = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_project = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_recover = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_topoRank = 0;
}
export { $c_Lcom_raquo_airstream_misc_MapSignal as $c_Lcom_raquo_airstream_misc_MapSignal };
$c_Lcom_raquo_airstream_misc_MapSignal.prototype = new $h_O();
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.constructor = $c_Lcom_raquo_airstream_misc_MapSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_MapSignal() {
}
export { $h_Lcom_raquo_airstream_misc_MapSignal as $h_Lcom_raquo_airstream_misc_MapSignal };
$h_Lcom_raquo_airstream_misc_MapSignal.prototype = $c_Lcom_raquo_airstream_misc_MapSignal.prototype;
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_MapSignal__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype._lastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f__lastUpdateId;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype._lastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_MapSignal__f__lastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
  observer.onTry__s_util_Try__V(this.tryNow__s_util_Try());
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f_externalObservers;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f_internalObservers;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f_willStartDone;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_MapSignal__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_MapSignal__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_MapSignal__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.maybeLastSeenCurrentValue__O = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f_maybeLastSeenCurrentValue;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.maybeLastSeenCurrentValue_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybeLastSeenCurrentValue = x$1;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.tryNow__s_util_Try = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.parentIsSignal__Z = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f_parentIsSignal;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype._parentLastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f__parentLastUpdateId;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype._parentLastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_MapSignal__f__parentLastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.com$raquo$airstream$common$SingleParentSignal$_setter_$parentIsSignal_$eq__Z__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_MapSignal__f_parentIsSignal = x$0;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.onWillStart__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V(this);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.updateCurrentValueFromParent__s_util_Try__I__V = (function(nextValue, nextParentLastUpdateId) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.onStop__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.parent__Lcom_raquo_airstream_core_Signal = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f_parent;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_misc_MapSignal__f_topoRank;
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextParentValue, transaction) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  nextParentValue.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextError) => {
    var this$2 = this.Lcom_raquo_airstream_misc_MapSignal__f_recover;
    if (this$2.isEmpty__Z()) {
      $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
    } else {
      var x0 = this$2.get__O();
      try {
        var r1 = x0.applyOrElse__O__F1__O(nextError, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => null)));
        var $x_1 = new $c_s_util_Success(r1);
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        matchEnd8: {
          var $x_1;
          if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
            var $x_1 = new $c_s_util_Failure(e$2);
            break matchEnd8;
          }
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
        }
      }
      $x_1.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextError$3$3) => ((tryError) => {
        var nextError$1 = new $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError(tryError, nextError$3$3);
        $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError$1, transaction);
      }))(nextError)), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextError$3$4) => ((nextValue) => {
        if ((nextValue === null)) {
          $f_Lcom_raquo_airstream_core_WritableSignal__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError$3$4, transaction);
        } else if ((!nextValue.isEmpty__Z())) {
          var x0$1 = nextValue.get__O();
          $f_Lcom_raquo_airstream_core_WritableSignal__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, x0$1, transaction);
        }
      }))(nextError)));
    }
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => {
    var nextValue$1 = nextParentValue.map__F1__s_util_Try(this.Lcom_raquo_airstream_misc_MapSignal__f_project);
    $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue$1, transaction);
  })));
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.currentValueFromParent__s_util_Try = (function() {
  var originalValue = this.parent__Lcom_raquo_airstream_core_Signal().tryNow__s_util_Try().map__F1__s_util_Try(this.Lcom_raquo_airstream_misc_MapSignal__f_project);
  return originalValue.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextError) => {
    var this$2 = this.Lcom_raquo_airstream_misc_MapSignal__f_recover;
    if (this$2.isEmpty__Z()) {
      return originalValue;
    } else {
      var x0 = this$2.get__O();
      try {
        var r1 = x0.applyOrElse__O__F1__O(nextError, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => null)));
        var $x_1 = new $c_s_util_Success(r1);
      } catch (e) {
        var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
        matchEnd8: {
          var $x_1;
          if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
            var $x_1 = new $c_s_util_Failure(e$2);
            break matchEnd8;
          }
          throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
        }
      }
      return $x_1.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextError$7$3) => ((tryError) => {
        var exception = new $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError(tryError, nextError$7$3);
        return new $c_s_util_Failure(exception);
      }))(nextError)), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextValue) => {
        if ((nextValue === null)) {
          return originalValue;
        } else {
          if (nextValue.isEmpty__Z()) {
            var this$7 = $m_s_None$();
          } else {
            var x0$1 = nextValue.get__O();
            var this$7 = new $c_s_Some(new $c_s_util_Success(x0$1));
          }
          return (this$7.isEmpty__Z() ? originalValue : this$7.get__O());
        }
      })));
    }
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => originalValue)));
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.parent__Lcom_raquo_airstream_core_Signal();
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$c_Lcom_raquo_airstream_misc_MapSignal.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_MapSignal = new $TypeData().initClass($c_Lcom_raquo_airstream_misc_MapSignal, "com.raquo.airstream.misc.MapSignal", ({
  Lcom_raquo_airstream_misc_MapSignal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1,
  Lcom_raquo_airstream_common_SingleParentSignal: 1
}));
export { $d_Lcom_raquo_airstream_misc_MapSignal as $d_Lcom_raquo_airstream_misc_MapSignal };
/** @constructor */
function $c_Lcom_raquo_airstream_misc_MapStream(parent, project, recover) {
  this.Lcom_raquo_airstream_misc_MapStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_misc_MapStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_misc_MapStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_misc_MapStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_misc_MapStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_misc_MapStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_misc_MapStream__f_parent = null;
  this.Lcom_raquo_airstream_misc_MapStream__f_project = null;
  this.Lcom_raquo_airstream_misc_MapStream__f_recover = null;
  this.Lcom_raquo_airstream_misc_MapStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_misc_MapStream__f_parent = parent;
  this.Lcom_raquo_airstream_misc_MapStream__f_project = project;
  this.Lcom_raquo_airstream_misc_MapStream__f_recover = recover;
  this.Lcom_raquo_airstream_misc_MapStream__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_misc_MapStream__f_topoRank = ((1 + parent.topoRank__I()) | 0);
}
export { $c_Lcom_raquo_airstream_misc_MapStream as $c_Lcom_raquo_airstream_misc_MapStream };
$c_Lcom_raquo_airstream_misc_MapStream.prototype = new $h_O();
$c_Lcom_raquo_airstream_misc_MapStream.prototype.constructor = $c_Lcom_raquo_airstream_misc_MapStream;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_MapStream() {
}
export { $h_Lcom_raquo_airstream_misc_MapStream as $h_Lcom_raquo_airstream_misc_MapStream };
$h_Lcom_raquo_airstream_misc_MapStream.prototype = $c_Lcom_raquo_airstream_misc_MapStream.prototype;
$c_Lcom_raquo_airstream_misc_MapStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_misc_MapStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_MapStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_misc_MapStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_misc_MapStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_MapStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_MapStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_MapStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_MapStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_misc_MapStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_MapStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_MapStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_MapStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_misc_MapStream__f_parent;
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.onStop__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_misc_MapStream__f_parent;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_misc_MapStream__f_topoRank;
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextParentValue, transaction) {
  try {
    var r1 = this.Lcom_raquo_airstream_misc_MapStream__f_project.apply__O__O(nextParentValue);
    var $x_1 = new $c_s_util_Success(r1);
  } catch (e) {
    var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
    matchEnd8: {
      var $x_1;
      if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
        var $x_1 = new $c_s_util_Failure(e$2);
        break matchEnd8;
      }
      throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
    }
  }
  $x_1.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
    this.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(_$1, transaction);
  })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
    $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, _$2, transaction);
  })));
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  var this$1 = this.Lcom_raquo_airstream_misc_MapStream__f_recover;
  if (this$1.isEmpty__Z()) {
    $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
  } else {
    var x0 = this$1.get__O();
    try {
      var r1 = x0.applyOrElse__O__F1__O(nextError, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => null)));
      var $x_1 = new $c_s_util_Success(r1);
    } catch (e) {
      var e$2 = ((e instanceof $c_jl_Throwable) ? e : new $c_sjs_js_JavaScriptException(e));
      matchEnd8: {
        var $x_1;
        if ($m_s_util_control_NonFatal$().apply__jl_Throwable__Z(e$2)) {
          var $x_1 = new $c_s_util_Failure(e$2);
          break matchEnd8;
        }
        throw ((e$2 instanceof $c_sjs_js_JavaScriptException) ? e$2.sjs_js_JavaScriptException__f_exception : e$2);
      }
    }
    $x_1.fold__F1__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((tryError) => {
      var nextError$1 = new $c_Lcom_raquo_airstream_core_AirstreamError$ErrorHandlingError(tryError, nextError);
      $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError$1, transaction);
    })), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((nextValue) => {
      if ((nextValue === null)) {
        $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
      } else if ((!nextValue.isEmpty__Z())) {
        var x0$1 = nextValue.get__O();
        $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, x0$1, transaction);
      }
    })));
  }
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_misc_MapStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_MapStream = new $TypeData().initClass($c_Lcom_raquo_airstream_misc_MapStream, "com.raquo.airstream.misc.MapStream", ({
  Lcom_raquo_airstream_misc_MapStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_SingleParentStream: 1,
  Lcom_raquo_airstream_common_InternalNextErrorObserver: 1
}));
export { $d_Lcom_raquo_airstream_misc_MapStream as $d_Lcom_raquo_airstream_misc_MapStream };
/** @constructor */
function $c_Lcom_raquo_airstream_misc_ScanLeftSignal(parent, makeInitialValue, fn) {
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_externalObservers = null;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_internalObservers = null;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_willStartDone = false;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_parentIsSignal = false;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f__parentLastUpdateId = 0;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_parent = null;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_makeInitialValue = null;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_fn = null;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_topoRank = 0;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_parent = parent;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_makeInitialValue = makeInitialValue;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_fn = fn;
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f__lastUpdateId = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybeLastSeenCurrentValue = (void 0);
  $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_topoRank = ((1 + parent.topoRank__I()) | 0);
}
export { $c_Lcom_raquo_airstream_misc_ScanLeftSignal as $c_Lcom_raquo_airstream_misc_ScanLeftSignal };
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype = new $h_O();
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.constructor = $c_Lcom_raquo_airstream_misc_ScanLeftSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_ScanLeftSignal() {
}
export { $h_Lcom_raquo_airstream_misc_ScanLeftSignal as $h_Lcom_raquo_airstream_misc_ScanLeftSignal };
$h_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype = $c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype;
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype._lastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f__lastUpdateId;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype._lastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f__lastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
  observer.onTry__s_util_Try__V($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_externalObservers;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_internalObservers;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_willStartDone;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.maybeLastSeenCurrentValue__O = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybeLastSeenCurrentValue;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.maybeLastSeenCurrentValue_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybeLastSeenCurrentValue = x$1;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.tryNow__s_util_Try = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.parentIsSignal__Z = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_parentIsSignal;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype._parentLastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f__parentLastUpdateId;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype._parentLastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f__parentLastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.com$raquo$airstream$common$SingleParentSignal$_setter_$parentIsSignal_$eq__Z__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_parentIsSignal = x$0;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.onWillStart__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onWillStart__V(this);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.updateCurrentValueFromParent__s_util_Try__I__V = (function(nextValue, nextParentLastUpdateId) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.onStop__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_parent;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_topoRank;
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.currentValueFromParent__s_util_Try = (function() {
  if (this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_parentIsSignal) {
    var parentSignal = this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_parent;
    var x = this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybeLastSeenCurrentValue;
    if ((x === (void 0))) {
      var x$1 = (void 0);
    } else {
      var a = this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_fn.apply__O__O__O(x, parentSignal.tryNow__s_util_Try());
      var x$1 = a;
    }
    var default$1 = this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_makeInitialValue;
    return ((x$1 === (void 0)) ? default$1.apply__O() : x$1);
  } else {
    var x$2 = this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_maybeLastSeenCurrentValue;
    var default$2 = this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_makeInitialValue;
    return ((x$2 === (void 0)) ? default$2.apply__O() : x$2);
  }
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextParentValue, transaction) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  var nextValue = this.Lcom_raquo_airstream_misc_ScanLeftSignal__f_fn.apply__O__O__O($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this), nextParentValue);
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$c_Lcom_raquo_airstream_misc_ScanLeftSignal.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_ScanLeftSignal = new $TypeData().initClass($c_Lcom_raquo_airstream_misc_ScanLeftSignal, "com.raquo.airstream.misc.ScanLeftSignal", ({
  Lcom_raquo_airstream_misc_ScanLeftSignal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1,
  Lcom_raquo_airstream_common_SingleParentSignal: 1
}));
export { $d_Lcom_raquo_airstream_misc_ScanLeftSignal as $d_Lcom_raquo_airstream_misc_ScanLeftSignal };
function $p_Lcom_raquo_airstream_misc_SignalFromStream__maybeCurrentValueFromParent__O($thiz) {
  var x = $thiz.Lcom_raquo_airstream_misc_SignalFromStream__f_maybeLastSeenCurrentValue;
  if ((x === (void 0))) {
    return $thiz.Lcom_raquo_airstream_misc_SignalFromStream__f_pullInitialValue.apply__O();
  } else {
    return (((!$thiz.Lcom_raquo_airstream_misc_SignalFromStream__f_hasEmittedEvents) && (!$thiz.Lcom_raquo_airstream_misc_SignalFromStream__f_cacheInitialValue)) ? $thiz.Lcom_raquo_airstream_misc_SignalFromStream__f_pullInitialValue.apply__O() : (void 0));
  }
}
export { $p_Lcom_raquo_airstream_misc_SignalFromStream__maybeCurrentValueFromParent__O as $p_Lcom_raquo_airstream_misc_SignalFromStream__maybeCurrentValueFromParent__O };
/** @constructor */
function $c_Lcom_raquo_airstream_misc_SignalFromStream(parent, pullInitialValue, cacheInitialValue) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_parentIsSignal = false;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f__parentLastUpdateId = 0;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_parent = null;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_pullInitialValue = null;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_cacheInitialValue = false;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_hasEmittedEvents = false;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_parent = parent;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_pullInitialValue = pullInitialValue;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_cacheInitialValue = cacheInitialValue;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.Lcom_raquo_airstream_misc_SignalFromStream__f__lastUpdateId = 0;
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_maybeLastSeenCurrentValue = (void 0);
  $f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_hasEmittedEvents = false;
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_topoRank = ((1 + parent.topoRank__I()) | 0);
}
export { $c_Lcom_raquo_airstream_misc_SignalFromStream as $c_Lcom_raquo_airstream_misc_SignalFromStream };
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype = new $h_O();
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.constructor = $c_Lcom_raquo_airstream_misc_SignalFromStream;
/** @constructor */
function $h_Lcom_raquo_airstream_misc_SignalFromStream() {
}
export { $h_Lcom_raquo_airstream_misc_SignalFromStream as $h_Lcom_raquo_airstream_misc_SignalFromStream };
$h_Lcom_raquo_airstream_misc_SignalFromStream.prototype = $c_Lcom_raquo_airstream_misc_SignalFromStream.prototype;
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype._lastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f__lastUpdateId;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype._lastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f__lastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.toObservable__Lcom_raquo_airstream_core_Signal = (function() {
  return this;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
  observer.onTry__s_util_Try__V($f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.maybeLastSeenCurrentValue__O = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f_maybeLastSeenCurrentValue;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.maybeLastSeenCurrentValue_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_maybeLastSeenCurrentValue = x$1;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.tryNow__s_util_Try = (function() {
  return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.parentIsSignal__Z = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f_parentIsSignal;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype._parentLastUpdateId__I = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f__parentLastUpdateId;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype._parentLastUpdateId_$eq__I__V = (function(x$1) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f__parentLastUpdateId = x$1;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.com$raquo$airstream$common$SingleParentSignal$_setter_$parentIsSignal_$eq__Z__V = (function(x$0) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_parentIsSignal = x$0;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.updateCurrentValueFromParent__s_util_Try__I__V = (function(nextValue, nextParentLastUpdateId) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.onStop__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f_topoRank;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_misc_SignalFromStream__f_parent;
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
  var x = $p_Lcom_raquo_airstream_misc_SignalFromStream__maybeCurrentValueFromParent__O(this);
  if ((x !== (void 0))) {
    $f_Lcom_raquo_airstream_core_WritableSignal__setCurrentValue__s_util_Try__V(this, x);
  }
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.currentValueFromParent__s_util_Try = (function() {
  var x = $p_Lcom_raquo_airstream_misc_SignalFromStream__maybeCurrentValueFromParent__O(this);
  return ((x === (void 0)) ? $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this) : x);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextParentValue, transaction) {
  this.Lcom_raquo_airstream_misc_SignalFromStream__f_hasEmittedEvents = true;
  $f_Lcom_raquo_airstream_common_SingleParentSignal__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
  $f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextParentValue, transaction);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_misc_SignalFromStream__f_parent;
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $c_Lcom_raquo_airstream_misc_MapSignal(), this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$c_Lcom_raquo_airstream_misc_SignalFromStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_misc_SignalFromStream = new $TypeData().initClass($c_Lcom_raquo_airstream_misc_SignalFromStream, "com.raquo.airstream.misc.SignalFromStream", ({
  Lcom_raquo_airstream_misc_SignalFromStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1,
  Lcom_raquo_airstream_common_SingleParentSignal: 1
}));
export { $d_Lcom_raquo_airstream_misc_SignalFromStream as $d_Lcom_raquo_airstream_misc_SignalFromStream };
/** @constructor */
function $c_Lcom_raquo_airstream_timing_DelayStream(parent, delayMs) {
  this.Lcom_raquo_airstream_timing_DelayStream__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_timing_DelayStream__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_timing_DelayStream__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_timing_DelayStream__f_externalObservers = null;
  this.Lcom_raquo_airstream_timing_DelayStream__f_internalObservers = null;
  this.Lcom_raquo_airstream_timing_DelayStream__f_willStartDone = false;
  this.Lcom_raquo_airstream_timing_DelayStream__f_parent = null;
  this.Lcom_raquo_airstream_timing_DelayStream__f_delayMs = 0;
  this.Lcom_raquo_airstream_timing_DelayStream__f_topoRank = 0;
  this.Lcom_raquo_airstream_timing_DelayStream__f_timerHandles = null;
  this.Lcom_raquo_airstream_timing_DelayStream__f_parent = parent;
  this.Lcom_raquo_airstream_timing_DelayStream__f_delayMs = delayMs;
  this.Lcom_raquo_airstream_timing_DelayStream__f_maybeDisplayName = (void 0);
  $f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  $f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.Lcom_raquo_airstream_timing_DelayStream__f_topoRank = 1;
  this.Lcom_raquo_airstream_timing_DelayStream__f_timerHandles = $m_Lcom_raquo_ew_JsArray$().apply__sci_Seq__Lcom_raquo_ew_JsArray($m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($d_sjs_js_timers_SetTimeoutHandle.getArrayOf().constr)([])));
}
export { $c_Lcom_raquo_airstream_timing_DelayStream as $c_Lcom_raquo_airstream_timing_DelayStream };
$c_Lcom_raquo_airstream_timing_DelayStream.prototype = new $h_O();
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.constructor = $c_Lcom_raquo_airstream_timing_DelayStream;
/** @constructor */
function $h_Lcom_raquo_airstream_timing_DelayStream() {
}
export { $h_Lcom_raquo_airstream_timing_DelayStream as $h_Lcom_raquo_airstream_timing_DelayStream };
$h_Lcom_raquo_airstream_timing_DelayStream.prototype = $c_Lcom_raquo_airstream_timing_DelayStream.prototype;
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.maybeDisplayName__O = (function() {
  return this.Lcom_raquo_airstream_timing_DelayStream__f_maybeDisplayName;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.maybeDisplayName_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_DelayStream__f_maybeDisplayName = x$1;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.defaultDisplayName__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.toString__T = (function() {
  return $f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.isSafeToRemoveObserver__Z = (function() {
  return this.Lcom_raquo_airstream_timing_DelayStream__f_isSafeToRemoveObserver;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.maybePendingObserverRemovals__O = (function() {
  return this.Lcom_raquo_airstream_timing_DelayStream__f_maybePendingObserverRemovals;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.isSafeToRemoveObserver_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_DelayStream__f_isSafeToRemoveObserver = x$1;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.maybePendingObserverRemovals_$eq__O__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_DelayStream__f_maybePendingObserverRemovals = x$1;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.equals__O__Z = (function(obj) {
  return (this === obj);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.hashCode__I = (function() {
  return $systemIdentityHashCode(this);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.onAddedExternalObserver__Lcom_raquo_airstream_core_Observer__V = (function(observer) {
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.toObservable__Lcom_raquo_airstream_core_EventStream = (function() {
  return this;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.externalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_DelayStream__f_externalObservers;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.internalObservers__Lcom_raquo_ew_JsArray = (function() {
  return this.Lcom_raquo_airstream_timing_DelayStream__f_internalObservers;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.willStartDone__Z = (function() {
  return this.Lcom_raquo_airstream_timing_DelayStream__f_willStartDone;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.willStartDone_$eq__Z__V = (function(x$1) {
  this.Lcom_raquo_airstream_timing_DelayStream__f_willStartDone = x$1;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$externalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_DelayStream__f_externalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.com$raquo$airstream$core$WritableObservable$_setter_$internalObservers_$eq__Lcom_raquo_ew_JsArray__V = (function(x$0) {
  this.Lcom_raquo_airstream_timing_DelayStream__f_internalObservers = x$0;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.fireValue__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_core_WritableStream__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.onWillStart__V = (function() {
  var observable = this.Lcom_raquo_airstream_timing_DelayStream__f_parent;
  $f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(observable);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.onStart__V = (function() {
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStart__V(this);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  $f_Lcom_raquo_airstream_common_InternalNextErrorObserver__onTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.topoRank__I = (function() {
  return this.Lcom_raquo_airstream_timing_DelayStream__f_topoRank;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.onNext__O__Lcom_raquo_airstream_core_Transaction__V = (function(nextValue, transaction) {
  var timerHandle = new $c_sr_ObjectRef(null);
  timerHandle.sr_ObjectRef__f_elem = $m_sjs_js_timers_package$().setTimeout__D__F0__sjs_js_timers_SetTimeoutHandle(this.Lcom_raquo_airstream_timing_DelayStream__f_delayMs, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    this.Lcom_raquo_airstream_timing_DelayStream__f_timerHandles.splice((this.Lcom_raquo_airstream_timing_DelayStream__f_timerHandles.indexOf(timerHandle.sr_ObjectRef__f_elem) | 0), 1);
    var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$1) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireValue__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, _$1);
    }));
    new $c_Lcom_raquo_airstream_core_Transaction(code);
  })));
  this.Lcom_raquo_airstream_timing_DelayStream__f_timerHandles.push(timerHandle.sr_ObjectRef__f_elem);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V = (function(nextError, transaction) {
  var timerHandle = new $c_sr_ObjectRef(null);
  timerHandle.sr_ObjectRef__f_elem = $m_sjs_js_timers_package$().setTimeout__D__F0__sjs_js_timers_SetTimeoutHandle(this.Lcom_raquo_airstream_timing_DelayStream__f_delayMs, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    this.Lcom_raquo_airstream_timing_DelayStream__f_timerHandles.splice((this.Lcom_raquo_airstream_timing_DelayStream__f_timerHandles.indexOf(timerHandle.sr_ObjectRef__f_elem) | 0), 1);
    var code = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$2) => {
      $f_Lcom_raquo_airstream_core_WritableStream__fireError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, _$2);
    }));
    new $c_Lcom_raquo_airstream_core_Transaction(code);
  })));
  this.Lcom_raquo_airstream_timing_DelayStream__f_timerHandles.push(timerHandle.sr_ObjectRef__f_elem);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.onStop__V = (function() {
  var arr = this.Lcom_raquo_airstream_timing_DelayStream__f_timerHandles;
  var i = 0;
  var len = (arr.length | 0);
  while ((i < len)) {
    var _$3 = arr[i];
    $m_sjs_js_timers_package$().clearTimeout__sjs_js_timers_SetTimeoutHandle__V(_$3);
    i = ((1 + i) | 0);
  }
  this.Lcom_raquo_airstream_timing_DelayStream__f_timerHandles.length = 0;
  $f_Lcom_raquo_airstream_common_SingleParentStream__onStop__V(this);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.parent__Lcom_raquo_airstream_core_Observable = (function() {
  return this.Lcom_raquo_airstream_timing_DelayStream__f_parent;
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.map__F1__Lcom_raquo_airstream_core_Observable = (function(project) {
  return new $c_Lcom_raquo_airstream_misc_MapStream(this, project, $m_s_None$());
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.distinctTry__F2__Lcom_raquo_airstream_core_Observable = (function(isSame) {
  return new $c_Lcom_raquo_airstream_distinct_DistinctStream(this, isSame, false);
});
$c_Lcom_raquo_airstream_timing_DelayStream.prototype.toObservable__Lcom_raquo_airstream_core_Observable = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_timing_DelayStream = new $TypeData().initClass($c_Lcom_raquo_airstream_timing_DelayStream, "com.raquo.airstream.timing.DelayStream", ({
  Lcom_raquo_airstream_timing_DelayStream: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$EventSource: 1,
  Lcom_raquo_airstream_dynamicImport_StreamDynamicImportOps: 1,
  Lcom_raquo_airstream_core_EventStream: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableStream: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_SingleParentStream: 1,
  Lcom_raquo_airstream_common_InternalNextErrorObserver: 1
}));
export { $d_Lcom_raquo_airstream_timing_DelayStream as $d_Lcom_raquo_airstream_timing_DelayStream };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "SENSITIVE", 0, "SENSITIVE", 0);
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1 as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1 };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1 as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1 };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1 = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1 as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$1 };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "INSENSITIVE", 1, "INSENSITIVE", 1);
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$2 };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "STRICT", 2, "STRICT", 2);
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3 as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3 };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3 as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3 };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3 = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3 as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$3 };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__f_ordinal = 0;
  $ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser__T__I__T__I__(this, "LENIENT", 3, "LENIENT", 3);
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4 as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4 };
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype = new $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser();
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4 as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4 };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype;
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4 = new $TypeData().initClass($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4, "java.time.format.internal.TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4", ({
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4: 1,
  Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_format_internal_DateTimePrinterParser: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4 as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$$anon$4 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "NanoOfSecond", 0, $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(999999999, 0)), "NANO_OF_SECOND", 0);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$1 as $c_Ljava_time_temporal_ChronoField$$anon$1 };
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$1() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$1 as $h_Ljava_time_temporal_ChronoField$$anon$1 };
$h_Ljava_time_temporal_ChronoField$$anon$1.prototype = $c_Ljava_time_temporal_ChronoField$$anon$1.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$1 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$1, "java.time.temporal.ChronoField$$anon$1", ({
  Ljava_time_temporal_ChronoField$$anon$1: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$1 as $d_Ljava_time_temporal_ChronoField$$anon$1 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$10() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MinuteOfDay", 9, $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1439, 0)), "MINUTE_OF_DAY", 9);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$10 as $c_Ljava_time_temporal_ChronoField$$anon$10 };
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$10;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$10() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$10 as $h_Ljava_time_temporal_ChronoField$$anon$10 };
$h_Ljava_time_temporal_ChronoField$$anon$10.prototype = $c_Ljava_time_temporal_ChronoField$$anon$10.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$10.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$10 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$10, "java.time.temporal.ChronoField$$anon$10", ({
  Ljava_time_temporal_ChronoField$$anon$10: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$10 as $d_Ljava_time_temporal_ChronoField$$anon$10 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$11() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "HourOfAmPm", 10, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(11, 0)), "HOUR_OF_AMPM", 10);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$11 as $c_Ljava_time_temporal_ChronoField$$anon$11 };
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$11;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$11() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$11 as $h_Ljava_time_temporal_ChronoField$$anon$11 };
$h_Ljava_time_temporal_ChronoField$$anon$11.prototype = $c_Ljava_time_temporal_ChronoField$$anon$11.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$11.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$11 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$11, "java.time.temporal.ChronoField$$anon$11", ({
  Ljava_time_temporal_ChronoField$$anon$11: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$11 as $d_Ljava_time_temporal_ChronoField$$anon$11 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$12() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "ClockHourOfAmPm", 11, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(12, 0)), "CLOCK_HOUR_OF_AMPM", 11);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$12 as $c_Ljava_time_temporal_ChronoField$$anon$12 };
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$12;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$12() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$12 as $h_Ljava_time_temporal_ChronoField$$anon$12 };
$h_Ljava_time_temporal_ChronoField$$anon$12.prototype = $c_Ljava_time_temporal_ChronoField$$anon$12.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$12.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$12 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$12, "java.time.temporal.ChronoField$$anon$12", ({
  Ljava_time_temporal_ChronoField$$anon$12: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$12 as $d_Ljava_time_temporal_ChronoField$$anon$12 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$13() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "HourOfDay", 12, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(23, 0)), "HOUR_OF_DAY", 12);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$13 as $c_Ljava_time_temporal_ChronoField$$anon$13 };
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$13;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$13() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$13 as $h_Ljava_time_temporal_ChronoField$$anon$13 };
$h_Ljava_time_temporal_ChronoField$$anon$13.prototype = $c_Ljava_time_temporal_ChronoField$$anon$13.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$13.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$13 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$13, "java.time.temporal.ChronoField$$anon$13", ({
  Ljava_time_temporal_ChronoField$$anon$13: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$13 as $d_Ljava_time_temporal_ChronoField$$anon$13 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$14() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "ClockHourOfDay", 13, $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(24, 0)), "CLOCK_HOUR_OF_DAY", 13);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$14 as $c_Ljava_time_temporal_ChronoField$$anon$14 };
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$14;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$14() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$14 as $h_Ljava_time_temporal_ChronoField$$anon$14 };
$h_Ljava_time_temporal_ChronoField$$anon$14.prototype = $c_Ljava_time_temporal_ChronoField$$anon$14.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$14.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$14 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$14, "java.time.temporal.ChronoField$$anon$14", ({
  Ljava_time_temporal_ChronoField$$anon$14: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$14 as $d_Ljava_time_temporal_ChronoField$$anon$14 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$15() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AmPmOfDay", 14, $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1, 0)), "AMPM_OF_DAY", 14);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$15 as $c_Ljava_time_temporal_ChronoField$$anon$15 };
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$15;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$15() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$15 as $h_Ljava_time_temporal_ChronoField$$anon$15 };
$h_Ljava_time_temporal_ChronoField$$anon$15.prototype = $c_Ljava_time_temporal_ChronoField$$anon$15.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$15.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$15 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$15, "java.time.temporal.ChronoField$$anon$15", ({
  Ljava_time_temporal_ChronoField$$anon$15: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$15 as $d_Ljava_time_temporal_ChronoField$$anon$15 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$16() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "DayOfWeek", 15, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(7, 0)), "DAY_OF_WEEK", 15);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$16 as $c_Ljava_time_temporal_ChronoField$$anon$16 };
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$16;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$16() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$16 as $h_Ljava_time_temporal_ChronoField$$anon$16 };
$h_Ljava_time_temporal_ChronoField$$anon$16.prototype = $c_Ljava_time_temporal_ChronoField$$anon$16.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$16.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$16 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$16, "java.time.temporal.ChronoField$$anon$16", ({
  Ljava_time_temporal_ChronoField$$anon$16: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$16 as $d_Ljava_time_temporal_ChronoField$$anon$16 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$17() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedDayOfWeekInMonth", 16, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(7, 0)), "ALIGNED_DAY_OF_WEEK_IN_MONTH", 16);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$17 as $c_Ljava_time_temporal_ChronoField$$anon$17 };
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$17;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$17() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$17 as $h_Ljava_time_temporal_ChronoField$$anon$17 };
$h_Ljava_time_temporal_ChronoField$$anon$17.prototype = $c_Ljava_time_temporal_ChronoField$$anon$17.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$17.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$17 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$17, "java.time.temporal.ChronoField$$anon$17", ({
  Ljava_time_temporal_ChronoField$$anon$17: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$17 as $d_Ljava_time_temporal_ChronoField$$anon$17 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$18() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedDayOfWeekInYear", 17, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(7, 0)), "ALIGNED_DAY_OF_WEEK_IN_YEAR", 17);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$18 as $c_Ljava_time_temporal_ChronoField$$anon$18 };
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$18;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$18() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$18 as $h_Ljava_time_temporal_ChronoField$$anon$18 };
$h_Ljava_time_temporal_ChronoField$$anon$18.prototype = $c_Ljava_time_temporal_ChronoField$$anon$18.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$18.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$18 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$18, "java.time.temporal.ChronoField$$anon$18", ({
  Ljava_time_temporal_ChronoField$$anon$18: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$18 as $d_Ljava_time_temporal_ChronoField$$anon$18 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$19() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_2 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  var $x_1 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  var this$1 = $m_Ljava_time_temporal_ValueRange$();
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "DayOfMonth", 18, $x_2, $x_1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(28, 0), new $c_RTLong(31, 0)), "DAY_OF_MONTH", 18);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$19 as $c_Ljava_time_temporal_ChronoField$$anon$19 };
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$19;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$19() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$19 as $h_Ljava_time_temporal_ChronoField$$anon$19 };
$h_Ljava_time_temporal_ChronoField$$anon$19.prototype = $c_Ljava_time_temporal_ChronoField$$anon$19.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$19.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$19 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$19, "java.time.temporal.ChronoField$$anon$19", ({
  Ljava_time_temporal_ChronoField$$anon$19: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$19 as $d_Ljava_time_temporal_ChronoField$$anon$19 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "NanoOfDay", 1, $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong((-1857093633), 20116)), "NANO_OF_DAY", 1);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$2 as $c_Ljava_time_temporal_ChronoField$$anon$2 };
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$2() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$2 as $h_Ljava_time_temporal_ChronoField$$anon$2 };
$h_Ljava_time_temporal_ChronoField$$anon$2.prototype = $c_Ljava_time_temporal_ChronoField$$anon$2.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$2 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$2, "java.time.temporal.ChronoField$$anon$2", ({
  Ljava_time_temporal_ChronoField$$anon$2: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$2 as $d_Ljava_time_temporal_ChronoField$$anon$2 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$20() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_2 = $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  var $x_1 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  var this$1 = $m_Ljava_time_temporal_ValueRange$();
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "DayOfYear", 19, $x_2, $x_1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(365, 0), new $c_RTLong(366, 0)), "DAY_OF_YEAR", 19);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$20 as $c_Ljava_time_temporal_ChronoField$$anon$20 };
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$20;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$20() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$20 as $h_Ljava_time_temporal_ChronoField$$anon$20 };
$h_Ljava_time_temporal_ChronoField$$anon$20.prototype = $c_Ljava_time_temporal_ChronoField$$anon$20.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$20.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$20 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$20, "java.time.temporal.ChronoField$$anon$20", ({
  Ljava_time_temporal_ChronoField$$anon$20: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$20 as $d_Ljava_time_temporal_ChronoField$$anon$20 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$21() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "EpochDay", 20, $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong((-170999002), (-86)), new $c_RTLong(169560311, 85)), "EPOCH_DAY", 20);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$21 as $c_Ljava_time_temporal_ChronoField$$anon$21 };
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$21;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$21() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$21 as $h_Ljava_time_temporal_ChronoField$$anon$21 };
$h_Ljava_time_temporal_ChronoField$$anon$21.prototype = $c_Ljava_time_temporal_ChronoField$$anon$21.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$21.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$21 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$21, "java.time.temporal.ChronoField$$anon$21", ({
  Ljava_time_temporal_ChronoField$$anon$21: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$21 as $d_Ljava_time_temporal_ChronoField$$anon$21 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$22() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_2 = $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
  var $x_1 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  var this$1 = $m_Ljava_time_temporal_ValueRange$();
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedWeekOfMonth", 21, $x_2, $x_1, this$1.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(4, 0), new $c_RTLong(5, 0)), "ALIGNED_WEEK_OF_MONTH", 21);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$22 as $c_Ljava_time_temporal_ChronoField$$anon$22 };
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$22;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$22() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$22 as $h_Ljava_time_temporal_ChronoField$$anon$22 };
$h_Ljava_time_temporal_ChronoField$$anon$22.prototype = $c_Ljava_time_temporal_ChronoField$$anon$22.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$22.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$22 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$22, "java.time.temporal.ChronoField$$anon$22", ({
  Ljava_time_temporal_ChronoField$$anon$22: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$22 as $d_Ljava_time_temporal_ChronoField$$anon$22 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$23() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "AlignedWeekOfYear", 22, $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(53, 0)), "ALIGNED_WEEK_OF_YEAR", 22);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$23 as $c_Ljava_time_temporal_ChronoField$$anon$23 };
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$23;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$23() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$23 as $h_Ljava_time_temporal_ChronoField$$anon$23 };
$h_Ljava_time_temporal_ChronoField$$anon$23.prototype = $c_Ljava_time_temporal_ChronoField$$anon$23.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$23.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$23 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$23, "java.time.temporal.ChronoField$$anon$23", ({
  Ljava_time_temporal_ChronoField$$anon$23: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$23 as $d_Ljava_time_temporal_ChronoField$$anon$23 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$24() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MonthOfYear", 23, $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(12, 0)), "MONTH_OF_YEAR", 23);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$24 as $c_Ljava_time_temporal_ChronoField$$anon$24 };
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$24;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$24() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$24 as $h_Ljava_time_temporal_ChronoField$$anon$24 };
$h_Ljava_time_temporal_ChronoField$$anon$24.prototype = $c_Ljava_time_temporal_ChronoField$$anon$24.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$24.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$24 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$24, "java.time.temporal.ChronoField$$anon$24", ({
  Ljava_time_temporal_ChronoField$$anon$24: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$24 as $d_Ljava_time_temporal_ChronoField$$anon$24 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$25() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_4 = $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  var $x_3 = $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
  var $x_2 = $m_Ljava_time_temporal_ValueRange$();
  var value = $m_Ljava_time_Year$().MIN_VALUE__I();
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var $x_1 = new $c_RTLong(lo, hi$1);
  var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi$2 = (value$1 >> 31);
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(12, b0$1);
  var a0b1$1 = Math.imul(12, b1$1);
  var lo$1 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((Math.imul(12, hi$2) + ((c1part$1 >>> 16) | 0)) | 0);
  var lo$2 = ((11 + lo$1) | 0);
  var hi$4 = ((hi$3 + (((lo$1 & (~lo$2)) >>> 31) | 0)) | 0);
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "ProlepticMonth", 24, $x_4, $x_3, $x_2.of__J__J__Ljava_time_temporal_ValueRange($x_1, new $c_RTLong(lo$2, hi$4)), "PROLEPTIC_MONTH", 24);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$25 as $c_Ljava_time_temporal_ChronoField$$anon$25 };
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$25;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$25() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$25 as $h_Ljava_time_temporal_ChronoField$$anon$25 };
$h_Ljava_time_temporal_ChronoField$$anon$25.prototype = $c_Ljava_time_temporal_ChronoField$$anon$25.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$25.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$25 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$25, "java.time.temporal.ChronoField$$anon$25", ({
  Ljava_time_temporal_ChronoField$$anon$25: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$25 as $d_Ljava_time_temporal_ChronoField$$anon$25 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$26() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_2 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  var $x_1 = $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
  var this$4 = $m_Ljava_time_temporal_ValueRange$();
  var value = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi = (value >> 31);
  var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi$1 = (value$1 >> 31);
  var lo = ((1 + value$1) | 0);
  var hi$2 = ((hi$1 + (((value$1 & (~lo)) >>> 31) | 0)) | 0);
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "YearOfEra", 25, $x_2, $x_1, this$4.of__J__J__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(1, 0), new $c_RTLong(1, 0), new $c_RTLong(value, hi), new $c_RTLong(lo, hi$2)), "YEAR_OF_ERA", 25);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$26 as $c_Ljava_time_temporal_ChronoField$$anon$26 };
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$26;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$26() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$26 as $h_Ljava_time_temporal_ChronoField$$anon$26 };
$h_Ljava_time_temporal_ChronoField$$anon$26.prototype = $c_Ljava_time_temporal_ChronoField$$anon$26.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$26.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$26 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$26, "java.time.temporal.ChronoField$$anon$26", ({
  Ljava_time_temporal_ChronoField$$anon$26: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$26 as $d_Ljava_time_temporal_ChronoField$$anon$26 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$27() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  var $x_4 = $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  var $x_3 = $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
  var $x_2 = $m_Ljava_time_temporal_ValueRange$();
  var value = $m_Ljava_time_Year$().MIN_VALUE__I();
  var hi = (value >> 31);
  var $x_1 = new $c_RTLong(value, hi);
  var value$1 = $m_Ljava_time_Year$().MAX_VALUE__I();
  var hi$1 = (value$1 >> 31);
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "Year", 26, $x_4, $x_3, $x_2.of__J__J__Ljava_time_temporal_ValueRange($x_1, new $c_RTLong(value$1, hi$1)), "YEAR", 26);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$27 as $c_Ljava_time_temporal_ChronoField$$anon$27 };
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$27;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$27() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$27 as $h_Ljava_time_temporal_ChronoField$$anon$27 };
$h_Ljava_time_temporal_ChronoField$$anon$27.prototype = $c_Ljava_time_temporal_ChronoField$$anon$27.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$27.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$27 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$27, "java.time.temporal.ChronoField$$anon$27", ({
  Ljava_time_temporal_ChronoField$$anon$27: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$27 as $d_Ljava_time_temporal_ChronoField$$anon$27 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$28() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "Era", 27, $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(1, 0)), "ERA", 27);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$28 as $c_Ljava_time_temporal_ChronoField$$anon$28 };
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$28;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$28() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$28 as $h_Ljava_time_temporal_ChronoField$$anon$28 };
$h_Ljava_time_temporal_ChronoField$$anon$28.prototype = $c_Ljava_time_temporal_ChronoField$$anon$28.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$28.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$28 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$28, "java.time.temporal.ChronoField$$anon$28", ({
  Ljava_time_temporal_ChronoField$$anon$28: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$28 as $d_Ljava_time_temporal_ChronoField$$anon$28 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$29() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "InstantSeconds", 28, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong(0, (-2147483648)), new $c_RTLong((-1), 2147483647)), "INSTANT_SECONDS", 28);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$29 as $c_Ljava_time_temporal_ChronoField$$anon$29 };
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$29;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$29() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$29 as $h_Ljava_time_temporal_ChronoField$$anon$29 };
$h_Ljava_time_temporal_ChronoField$$anon$29.prototype = $c_Ljava_time_temporal_ChronoField$$anon$29.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$29.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$29 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$29, "java.time.temporal.ChronoField$$anon$29", ({
  Ljava_time_temporal_ChronoField$$anon$29: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$29 as $d_Ljava_time_temporal_ChronoField$$anon$29 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MicroOfSecond", 2, $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(999999, 0)), "MICRO_OF_SECOND", 2);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$3 as $c_Ljava_time_temporal_ChronoField$$anon$3 };
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$3() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$3 as $h_Ljava_time_temporal_ChronoField$$anon$3 };
$h_Ljava_time_temporal_ChronoField$$anon$3.prototype = $c_Ljava_time_temporal_ChronoField$$anon$3.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$3 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$3, "java.time.temporal.ChronoField$$anon$3", ({
  Ljava_time_temporal_ChronoField$$anon$3: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$3 as $d_Ljava_time_temporal_ChronoField$$anon$3 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$30() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "OffsetSeconds", 29, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange(new $c_RTLong((-64800), (-1)), new $c_RTLong(64800, 0)), "OFFSET_SECONDS", 29);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$30 as $c_Ljava_time_temporal_ChronoField$$anon$30 };
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$30;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$30() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$30 as $h_Ljava_time_temporal_ChronoField$$anon$30 };
$h_Ljava_time_temporal_ChronoField$$anon$30.prototype = $c_Ljava_time_temporal_ChronoField$$anon$30.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$30.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$30 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$30, "java.time.temporal.ChronoField$$anon$30", ({
  Ljava_time_temporal_ChronoField$$anon$30: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$30 as $d_Ljava_time_temporal_ChronoField$$anon$30 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MicroOfDay", 3, $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(500654079, 20)), "MICRO_OF_DAY", 3);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$4 as $c_Ljava_time_temporal_ChronoField$$anon$4 };
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$4() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$4 as $h_Ljava_time_temporal_ChronoField$$anon$4 };
$h_Ljava_time_temporal_ChronoField$$anon$4.prototype = $c_Ljava_time_temporal_ChronoField$$anon$4.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$4.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$4 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$4, "java.time.temporal.ChronoField$$anon$4", ({
  Ljava_time_temporal_ChronoField$$anon$4: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$4 as $d_Ljava_time_temporal_ChronoField$$anon$4 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MilliOfSecond", 4, $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(999, 0)), "MILLI_OF_SECOND", 4);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$5 as $c_Ljava_time_temporal_ChronoField$$anon$5 };
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$5() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$5 as $h_Ljava_time_temporal_ChronoField$$anon$5 };
$h_Ljava_time_temporal_ChronoField$$anon$5.prototype = $c_Ljava_time_temporal_ChronoField$$anon$5.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$5.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$5 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$5, "java.time.temporal.ChronoField$$anon$5", ({
  Ljava_time_temporal_ChronoField$$anon$5: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$5 as $d_Ljava_time_temporal_ChronoField$$anon$5 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MilliOfDay", 5, $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(86399999, 0)), "MILLI_OF_DAY", 5);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$6 as $c_Ljava_time_temporal_ChronoField$$anon$6 };
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$6() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$6 as $h_Ljava_time_temporal_ChronoField$$anon$6 };
$h_Ljava_time_temporal_ChronoField$$anon$6.prototype = $c_Ljava_time_temporal_ChronoField$$anon$6.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$6.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$6 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$6, "java.time.temporal.ChronoField$$anon$6", ({
  Ljava_time_temporal_ChronoField$$anon$6: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$6 as $d_Ljava_time_temporal_ChronoField$$anon$6 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "SecondOfMinute", 6, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(59, 0)), "SECOND_OF_MINUTE", 6);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$7 as $c_Ljava_time_temporal_ChronoField$$anon$7 };
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$7() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$7 as $h_Ljava_time_temporal_ChronoField$$anon$7 };
$h_Ljava_time_temporal_ChronoField$$anon$7.prototype = $c_Ljava_time_temporal_ChronoField$$anon$7.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$7.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$7 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$7, "java.time.temporal.ChronoField$$anon$7", ({
  Ljava_time_temporal_ChronoField$$anon$7: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$7 as $d_Ljava_time_temporal_ChronoField$$anon$7 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$8() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "SecondOfDay", 7, $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(86399, 0)), "SECOND_OF_DAY", 7);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$8 as $c_Ljava_time_temporal_ChronoField$$anon$8 };
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$8;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$8() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$8 as $h_Ljava_time_temporal_ChronoField$$anon$8 };
$h_Ljava_time_temporal_ChronoField$$anon$8.prototype = $c_Ljava_time_temporal_ChronoField$$anon$8.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$8.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$8 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$8, "java.time.temporal.ChronoField$$anon$8", ({
  Ljava_time_temporal_ChronoField$$anon$8: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$8 as $d_Ljava_time_temporal_ChronoField$$anon$8 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoField$$anon$9() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f_name = null;
  this.Ljava_time_temporal_ChronoField__f_ordinal = 0;
  this.Ljava_time_temporal_ChronoField__f__range = null;
  $ct_Ljava_time_temporal_ChronoField__T__I__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_TemporalUnit__Ljava_time_temporal_ValueRange__T__I__(this, "MinuteOfHour", 8, $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit(), $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit(), $m_Ljava_time_temporal_ValueRange$().of__J__J__Ljava_time_temporal_ValueRange($L0, new $c_RTLong(59, 0)), "MINUTE_OF_HOUR", 8);
}
export { $c_Ljava_time_temporal_ChronoField$$anon$9 as $c_Ljava_time_temporal_ChronoField$$anon$9 };
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype = new $h_Ljava_time_temporal_ChronoField();
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.constructor = $c_Ljava_time_temporal_ChronoField$$anon$9;
/** @constructor */
function $h_Ljava_time_temporal_ChronoField$$anon$9() {
}
export { $h_Ljava_time_temporal_ChronoField$$anon$9 as $h_Ljava_time_temporal_ChronoField$$anon$9 };
$h_Ljava_time_temporal_ChronoField$$anon$9.prototype = $c_Ljava_time_temporal_ChronoField$$anon$9.prototype;
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoField$$anon$9.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoField$$anon$9 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoField$$anon$9, "java.time.temporal.ChronoField$$anon$9", ({
  Ljava_time_temporal_ChronoField$$anon$9: 1,
  Ljava_time_temporal_ChronoField: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoField$$anon$9 as $d_Ljava_time_temporal_ChronoField$$anon$9 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Nanos", 0, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(new $c_RTLong(1, 0)), "NANOS", 0);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$1 as $c_Ljava_time_temporal_ChronoUnit$$anon$1 };
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$1() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$1 as $h_Ljava_time_temporal_ChronoUnit$$anon$1 };
$h_Ljava_time_temporal_ChronoUnit$$anon$1.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$1 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$1, "java.time.temporal.ChronoUnit$$anon$1", ({
  Ljava_time_temporal_ChronoUnit$$anon$1: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$1 as $d_Ljava_time_temporal_ChronoUnit$$anon$1 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$10() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Months", 9, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(2629746, 0), 0), "MONTHS", 9);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$10 as $c_Ljava_time_temporal_ChronoUnit$$anon$10 };
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$10;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$10() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$10 as $h_Ljava_time_temporal_ChronoUnit$$anon$10 };
$h_Ljava_time_temporal_ChronoUnit$$anon$10.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$10 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$10, "java.time.temporal.ChronoUnit$$anon$10", ({
  Ljava_time_temporal_ChronoUnit$$anon$10: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$10 as $d_Ljava_time_temporal_ChronoUnit$$anon$10 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$11() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Years", 10, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(31556952, 0), 0), "YEARS", 10);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$11 as $c_Ljava_time_temporal_ChronoUnit$$anon$11 };
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$11;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$11() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$11 as $h_Ljava_time_temporal_ChronoUnit$$anon$11 };
$h_Ljava_time_temporal_ChronoUnit$$anon$11.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$11 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$11, "java.time.temporal.ChronoUnit$$anon$11", ({
  Ljava_time_temporal_ChronoUnit$$anon$11: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$11 as $d_Ljava_time_temporal_ChronoUnit$$anon$11 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$12() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Decades", 11, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(315569520, 0), 0), "DECADES", 11);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$12 as $c_Ljava_time_temporal_ChronoUnit$$anon$12 };
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$12;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$12() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$12 as $h_Ljava_time_temporal_ChronoUnit$$anon$12 };
$h_Ljava_time_temporal_ChronoUnit$$anon$12.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$12 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$12, "java.time.temporal.ChronoUnit$$anon$12", ({
  Ljava_time_temporal_ChronoUnit$$anon$12: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$12 as $d_Ljava_time_temporal_ChronoUnit$$anon$12 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$13() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Centuries", 12, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong((-1139272096), 0), 0), "CENTURIES", 12);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$13 as $c_Ljava_time_temporal_ChronoUnit$$anon$13 };
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$13;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$13() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$13 as $h_Ljava_time_temporal_ChronoUnit$$anon$13 };
$h_Ljava_time_temporal_ChronoUnit$$anon$13.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$13 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$13, "java.time.temporal.ChronoUnit$$anon$13", ({
  Ljava_time_temporal_ChronoUnit$$anon$13: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$13 as $d_Ljava_time_temporal_ChronoUnit$$anon$13 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$14() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Millenia", 13, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(1492180928, 7), 0), "MILLENNIA", 13);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$14 as $c_Ljava_time_temporal_ChronoUnit$$anon$14 };
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$14;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$14() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$14 as $h_Ljava_time_temporal_ChronoUnit$$anon$14 };
$h_Ljava_time_temporal_ChronoUnit$$anon$14.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$14 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$14, "java.time.temporal.ChronoUnit$$anon$14", ({
  Ljava_time_temporal_ChronoUnit$$anon$14: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$14 as $d_Ljava_time_temporal_ChronoUnit$$anon$14 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$15() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Eras", 14, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(1915187200, 7347425), 0), "ERAS", 14);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$15 as $c_Ljava_time_temporal_ChronoUnit$$anon$15 };
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$15;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$15() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$15 as $h_Ljava_time_temporal_ChronoUnit$$anon$15 };
$h_Ljava_time_temporal_ChronoUnit$$anon$15.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$15 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$15, "java.time.temporal.ChronoUnit$$anon$15", ({
  Ljava_time_temporal_ChronoUnit$$anon$15: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$15 as $d_Ljava_time_temporal_ChronoUnit$$anon$15 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$16() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Forever", 15, $m_Ljava_time_Duration$().ofSeconds__J__J__Ljava_time_Duration(new $c_RTLong((-1), 2147483647), new $c_RTLong(999999999, 0)), "FOREVER", 15);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$16 as $c_Ljava_time_temporal_ChronoUnit$$anon$16 };
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$16;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$16() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$16 as $h_Ljava_time_temporal_ChronoUnit$$anon$16 };
$h_Ljava_time_temporal_ChronoUnit$$anon$16.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$16 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$16, "java.time.temporal.ChronoUnit$$anon$16", ({
  Ljava_time_temporal_ChronoUnit$$anon$16: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$16 as $d_Ljava_time_temporal_ChronoUnit$$anon$16 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Micros", 1, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(new $c_RTLong(1000, 0)), "MICROS", 1);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$2 as $c_Ljava_time_temporal_ChronoUnit$$anon$2 };
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$2() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$2 as $h_Ljava_time_temporal_ChronoUnit$$anon$2 };
$h_Ljava_time_temporal_ChronoUnit$$anon$2.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$2 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$2, "java.time.temporal.ChronoUnit$$anon$2", ({
  Ljava_time_temporal_ChronoUnit$$anon$2: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$2 as $d_Ljava_time_temporal_ChronoUnit$$anon$2 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Millis", 2, $m_Ljava_time_Duration$().ofNanos__J__Ljava_time_Duration(new $c_RTLong(1000000, 0)), "MILLIS", 2);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$3 as $c_Ljava_time_temporal_ChronoUnit$$anon$3 };
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$3() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$3 as $h_Ljava_time_temporal_ChronoUnit$$anon$3 };
$h_Ljava_time_temporal_ChronoUnit$$anon$3.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$3 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$3, "java.time.temporal.ChronoUnit$$anon$3", ({
  Ljava_time_temporal_ChronoUnit$$anon$3: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$3 as $d_Ljava_time_temporal_ChronoUnit$$anon$3 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Seconds", 3, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(1, 0), 0), "SECONDS", 3);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$4 as $c_Ljava_time_temporal_ChronoUnit$$anon$4 };
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$4() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$4 as $h_Ljava_time_temporal_ChronoUnit$$anon$4 };
$h_Ljava_time_temporal_ChronoUnit$$anon$4.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$4 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$4, "java.time.temporal.ChronoUnit$$anon$4", ({
  Ljava_time_temporal_ChronoUnit$$anon$4: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$4 as $d_Ljava_time_temporal_ChronoUnit$$anon$4 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Minutes", 4, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(60, 0), 0), "MINUTES", 4);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$5 as $c_Ljava_time_temporal_ChronoUnit$$anon$5 };
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$5() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$5 as $h_Ljava_time_temporal_ChronoUnit$$anon$5 };
$h_Ljava_time_temporal_ChronoUnit$$anon$5.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$5 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$5, "java.time.temporal.ChronoUnit$$anon$5", ({
  Ljava_time_temporal_ChronoUnit$$anon$5: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$5 as $d_Ljava_time_temporal_ChronoUnit$$anon$5 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Hours", 5, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(3600, 0), 0), "HOURS", 5);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$6 as $c_Ljava_time_temporal_ChronoUnit$$anon$6 };
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$6() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$6 as $h_Ljava_time_temporal_ChronoUnit$$anon$6 };
$h_Ljava_time_temporal_ChronoUnit$$anon$6.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$6 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$6, "java.time.temporal.ChronoUnit$$anon$6", ({
  Ljava_time_temporal_ChronoUnit$$anon$6: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$6 as $d_Ljava_time_temporal_ChronoUnit$$anon$6 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "HalfDays", 6, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(43200, 0), 0), "HALF_DAYS", 6);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$7 as $c_Ljava_time_temporal_ChronoUnit$$anon$7 };
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$7() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$7 as $h_Ljava_time_temporal_ChronoUnit$$anon$7 };
$h_Ljava_time_temporal_ChronoUnit$$anon$7.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$7 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$7, "java.time.temporal.ChronoUnit$$anon$7", ({
  Ljava_time_temporal_ChronoUnit$$anon$7: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$7 as $d_Ljava_time_temporal_ChronoUnit$$anon$7 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$8() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Days", 7, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(86400, 0), 0), "DAYS", 7);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$8 as $c_Ljava_time_temporal_ChronoUnit$$anon$8 };
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$8;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$8() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$8 as $h_Ljava_time_temporal_ChronoUnit$$anon$8 };
$h_Ljava_time_temporal_ChronoUnit$$anon$8.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$8 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$8, "java.time.temporal.ChronoUnit$$anon$8", ({
  Ljava_time_temporal_ChronoUnit$$anon$8: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$8 as $d_Ljava_time_temporal_ChronoUnit$$anon$8 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$9() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_ChronoUnit__f_name = null;
  this.Ljava_time_temporal_ChronoUnit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Weeks", 8, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(604800, 0), 0), "WEEKS", 8);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$9 as $c_Ljava_time_temporal_ChronoUnit$$anon$9 };
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$9;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$9() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$9 as $h_Ljava_time_temporal_ChronoUnit$$anon$9 };
$h_Ljava_time_temporal_ChronoUnit$$anon$9.prototype = $c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype;
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$9 = new $TypeData().initClass($c_Ljava_time_temporal_ChronoUnit$$anon$9, "java.time.temporal.ChronoUnit$$anon$9", ({
  Ljava_time_temporal_ChronoUnit$$anon$9: 1,
  Ljava_time_temporal_ChronoUnit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$9 as $d_Ljava_time_temporal_ChronoUnit$$anon$9 };
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Field$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYS$lzy1 = null;
  this.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYSbitmap$1 = false;
  $ct_jl_Enum__T__I__(this, "DAY_OF_QUARTER", 0);
}
export { $c_Ljava_time_temporal_IsoFields$Field$$anon$1 as $c_Ljava_time_temporal_IsoFields$Field$$anon$1 };
$c_Ljava_time_temporal_IsoFields$Field$$anon$1.prototype = new $h_Ljava_time_temporal_IsoFields$Field();
$c_Ljava_time_temporal_IsoFields$Field$$anon$1.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Field$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Field$$anon$1() {
}
export { $h_Ljava_time_temporal_IsoFields$Field$$anon$1 as $h_Ljava_time_temporal_IsoFields$Field$$anon$1 };
$h_Ljava_time_temporal_IsoFields$Field$$anon$1.prototype = $c_Ljava_time_temporal_IsoFields$Field$$anon$1.prototype;
$c_Ljava_time_temporal_IsoFields$Field$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_IsoFields$Field$$anon$1 = new $TypeData().initClass($c_Ljava_time_temporal_IsoFields$Field$$anon$1, "java.time.temporal.IsoFields$Field$$anon$1", ({
  Ljava_time_temporal_IsoFields$Field$$anon$1: 1,
  Ljava_time_temporal_IsoFields$Field: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_IsoFields$Field$$anon$1 as $d_Ljava_time_temporal_IsoFields$Field$$anon$1 };
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Field$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYS$lzy1 = null;
  this.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYSbitmap$1 = false;
  $ct_jl_Enum__T__I__(this, "QUARTER_OF_YEAR", 1);
}
export { $c_Ljava_time_temporal_IsoFields$Field$$anon$2 as $c_Ljava_time_temporal_IsoFields$Field$$anon$2 };
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype = new $h_Ljava_time_temporal_IsoFields$Field();
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Field$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Field$$anon$2() {
}
export { $h_Ljava_time_temporal_IsoFields$Field$$anon$2 as $h_Ljava_time_temporal_IsoFields$Field$$anon$2 };
$h_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype = $c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype;
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_IsoFields$Field$$anon$2 = new $TypeData().initClass($c_Ljava_time_temporal_IsoFields$Field$$anon$2, "java.time.temporal.IsoFields$Field$$anon$2", ({
  Ljava_time_temporal_IsoFields$Field$$anon$2: 1,
  Ljava_time_temporal_IsoFields$Field: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_IsoFields$Field$$anon$2 as $d_Ljava_time_temporal_IsoFields$Field$$anon$2 };
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Field$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYS$lzy1 = null;
  this.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYSbitmap$1 = false;
  $ct_jl_Enum__T__I__(this, "WEEK_OF_WEEK_BASED_YEAR", 2);
}
export { $c_Ljava_time_temporal_IsoFields$Field$$anon$3 as $c_Ljava_time_temporal_IsoFields$Field$$anon$3 };
$c_Ljava_time_temporal_IsoFields$Field$$anon$3.prototype = new $h_Ljava_time_temporal_IsoFields$Field();
$c_Ljava_time_temporal_IsoFields$Field$$anon$3.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Field$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Field$$anon$3() {
}
export { $h_Ljava_time_temporal_IsoFields$Field$$anon$3 as $h_Ljava_time_temporal_IsoFields$Field$$anon$3 };
$h_Ljava_time_temporal_IsoFields$Field$$anon$3.prototype = $c_Ljava_time_temporal_IsoFields$Field$$anon$3.prototype;
$c_Ljava_time_temporal_IsoFields$Field$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_IsoFields$Field$$anon$3 = new $TypeData().initClass($c_Ljava_time_temporal_IsoFields$Field$$anon$3, "java.time.temporal.IsoFields$Field$$anon$3", ({
  Ljava_time_temporal_IsoFields$Field$$anon$3: 1,
  Ljava_time_temporal_IsoFields$Field: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_IsoFields$Field$$anon$3 as $d_Ljava_time_temporal_IsoFields$Field$$anon$3 };
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Field$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYS$lzy1 = null;
  this.Ljava_time_temporal_IsoFields$Field__f_QUARTER_DAYSbitmap$1 = false;
  $ct_jl_Enum__T__I__(this, "WEEK_BASED_YEAR", 3);
}
export { $c_Ljava_time_temporal_IsoFields$Field$$anon$4 as $c_Ljava_time_temporal_IsoFields$Field$$anon$4 };
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype = new $h_Ljava_time_temporal_IsoFields$Field();
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Field$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Field$$anon$4() {
}
export { $h_Ljava_time_temporal_IsoFields$Field$$anon$4 as $h_Ljava_time_temporal_IsoFields$Field$$anon$4 };
$h_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype = $c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype;
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_IsoFields$Field$$anon$4.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_IsoFields$Field$$anon$4 = new $TypeData().initClass($c_Ljava_time_temporal_IsoFields$Field$$anon$4, "java.time.temporal.IsoFields$Field$$anon$4", ({
  Ljava_time_temporal_IsoFields$Field$$anon$4: 1,
  Ljava_time_temporal_IsoFields$Field: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalField: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_IsoFields$Field$$anon$4 as $d_Ljava_time_temporal_IsoFields$Field$$anon$4 };
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Unit$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_IsoFields$Unit__f_name = null;
  this.Ljava_time_temporal_IsoFields$Unit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_IsoFields$Unit__T__I__Ljava_time_Duration__T__I__(this, "WeekBasedYear", 0, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(31556952, 0), 0), "WEEK_BASED_YEARS", 0);
}
export { $c_Ljava_time_temporal_IsoFields$Unit$$anon$5 as $c_Ljava_time_temporal_IsoFields$Unit$$anon$5 };
$c_Ljava_time_temporal_IsoFields$Unit$$anon$5.prototype = new $h_Ljava_time_temporal_IsoFields$Unit();
$c_Ljava_time_temporal_IsoFields$Unit$$anon$5.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Unit$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Unit$$anon$5() {
}
export { $h_Ljava_time_temporal_IsoFields$Unit$$anon$5 as $h_Ljava_time_temporal_IsoFields$Unit$$anon$5 };
$h_Ljava_time_temporal_IsoFields$Unit$$anon$5.prototype = $c_Ljava_time_temporal_IsoFields$Unit$$anon$5.prototype;
$c_Ljava_time_temporal_IsoFields$Unit$$anon$5.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_IsoFields$Unit$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_IsoFields$Unit$$anon$5.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_IsoFields$Unit$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_IsoFields$Unit$$anon$5.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_IsoFields$Unit$$anon$5 = new $TypeData().initClass($c_Ljava_time_temporal_IsoFields$Unit$$anon$5, "java.time.temporal.IsoFields$Unit$$anon$5", ({
  Ljava_time_temporal_IsoFields$Unit$$anon$5: 1,
  Ljava_time_temporal_IsoFields$Unit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_IsoFields$Unit$$anon$5 as $d_Ljava_time_temporal_IsoFields$Unit$$anon$5 };
/** @constructor */
function $c_Ljava_time_temporal_IsoFields$Unit$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_temporal_IsoFields$Unit__f_name = null;
  this.Ljava_time_temporal_IsoFields$Unit__f_duration = null;
  var this$1 = $m_Ljava_time_Duration$();
  $ct_Ljava_time_temporal_IsoFields$Unit__T__I__Ljava_time_Duration__T__I__(this, "QuarterYears", 1, this$1.java$time$Duration$$$create__J__I__Ljava_time_Duration(new $c_RTLong(7889238, 0), 0), "QUARTER_YEARS", 1);
}
export { $c_Ljava_time_temporal_IsoFields$Unit$$anon$6 as $c_Ljava_time_temporal_IsoFields$Unit$$anon$6 };
$c_Ljava_time_temporal_IsoFields$Unit$$anon$6.prototype = new $h_Ljava_time_temporal_IsoFields$Unit();
$c_Ljava_time_temporal_IsoFields$Unit$$anon$6.prototype.constructor = $c_Ljava_time_temporal_IsoFields$Unit$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_IsoFields$Unit$$anon$6() {
}
export { $h_Ljava_time_temporal_IsoFields$Unit$$anon$6 as $h_Ljava_time_temporal_IsoFields$Unit$$anon$6 };
$h_Ljava_time_temporal_IsoFields$Unit$$anon$6.prototype = $c_Ljava_time_temporal_IsoFields$Unit$$anon$6.prototype;
$c_Ljava_time_temporal_IsoFields$Unit$$anon$6.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_temporal_IsoFields$Unit$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_temporal_IsoFields$Unit$$anon$6.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_temporal_IsoFields$Unit$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_temporal_IsoFields$Unit$$anon$6.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_IsoFields$Unit$$anon$6 = new $TypeData().initClass($c_Ljava_time_temporal_IsoFields$Unit$$anon$6, "java.time.temporal.IsoFields$Unit$$anon$6", ({
  Ljava_time_temporal_IsoFields$Unit$$anon$6: 1,
  Ljava_time_temporal_IsoFields$Unit: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalUnit: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_temporal_IsoFields$Unit$$anon$6 as $d_Ljava_time_temporal_IsoFields$Unit$$anon$6 };
/** @constructor */
function $c_sc_AbstractMap() {
}
export { $c_sc_AbstractMap as $c_sc_AbstractMap };
$c_sc_AbstractMap.prototype = new $h_sc_AbstractIterable();
$c_sc_AbstractMap.prototype.constructor = $c_sc_AbstractMap;
/** @constructor */
function $h_sc_AbstractMap() {
}
export { $h_sc_AbstractMap as $h_sc_AbstractMap };
$h_sc_AbstractMap.prototype = $c_sc_AbstractMap.prototype;
$c_sc_AbstractMap.prototype.equals__O__Z = (function(o) {
  return $f_sc_Map__equals__O__Z(this, o);
});
$c_sc_AbstractMap.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().mapHash__sc_Map__I(this);
});
$c_sc_AbstractMap.prototype.stringPrefix__T = (function() {
  return "Map";
});
$c_sc_AbstractMap.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.mapFactory__sc_MapFactory().from__sc_IterableOnce__O(coll);
});
$c_sc_AbstractMap.prototype.newSpecificBuilder__scm_Builder = (function() {
  return this.mapFactory__sc_MapFactory().newBuilder__scm_Builder();
});
$c_sc_AbstractMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$c_sc_AbstractMap.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$c_sc_AbstractMap.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sc_AbstractMap.prototype.keySet__sc_Set = (function() {
  return $ct_sc_MapOps$KeySet__sc_MapOps__(new $c_sc_MapOps$KeySet(), this);
});
$c_sc_AbstractMap.prototype.keys__sc_Iterable = (function() {
  return this.keySet__sc_Set();
});
$c_sc_AbstractMap.prototype.values__sc_Iterable = (function() {
  return new $c_sc_MapOps$$anon$1(this);
});
$c_sc_AbstractMap.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$c_sc_AbstractMap.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$c_sc_AbstractMap.prototype.foreachEntry__F2__V = (function(f) {
  $f_sc_MapOps__foreachEntry__F2__V(this, f);
});
$c_sc_AbstractMap.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$c_sc_AbstractMap.prototype.contains__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$c_sc_AbstractMap.prototype.isDefinedAt__O__Z = (function(key) {
  return this.contains__O__Z(key);
});
$c_sc_AbstractMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_MapOps__map__F1__sc_IterableOps(this, f);
});
$c_sc_AbstractMap.prototype.collect__s_PartialFunction__sc_IterableOps = (function(pf) {
  return $f_sc_MapOps__collect__s_PartialFunction__sc_IterableOps(this, pf);
});
$c_sc_AbstractMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$c_sc_AbstractMap.prototype.$plus$plus__sc_IterableOnce__sc_IterableOps = (function(xs) {
  return this.concat__sc_IterableOnce__sc_IterableOps(xs);
});
$c_sc_AbstractMap.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$c_sc_AbstractMap.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sc_AbstractMap.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sc_AbstractMap.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sc_AbstractMap.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!this.apply__O__O(v1)));
});
$c_sc_AbstractMap.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractMap.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sc_AbstractMap.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__sc_IterableOps(coll);
});
function $ct_sc_SeqView$Appended__sc_SeqOps__O__($thiz, underlying, elem) {
  $thiz.sc_SeqView$Appended__f_underlying = underlying;
  $thiz.sc_SeqView$Appended__f_elem = elem;
  $ct_sc_View$Appended__sc_IterableOps__O__($thiz, underlying, elem);
  return $thiz;
}
export { $ct_sc_SeqView$Appended__sc_SeqOps__O__ as $ct_sc_SeqView$Appended__sc_SeqOps__O__ };
/** @constructor */
function $c_sc_SeqView$Appended() {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null;
  this.sc_SeqView$Appended__f_underlying = null;
  this.sc_SeqView$Appended__f_elem = null;
}
export { $c_sc_SeqView$Appended as $c_sc_SeqView$Appended };
$c_sc_SeqView$Appended.prototype = new $h_sc_View$Appended();
$c_sc_SeqView$Appended.prototype.constructor = $c_sc_SeqView$Appended;
/** @constructor */
function $h_sc_SeqView$Appended() {
}
export { $h_sc_SeqView$Appended as $h_sc_SeqView$Appended };
$h_sc_SeqView$Appended.prototype = $c_sc_SeqView$Appended.prototype;
$c_sc_SeqView$Appended.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Appended.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Appended.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Appended.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Appended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Appended.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Appended.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Appended.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Appended.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator();
});
$c_sc_SeqView$Appended.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_SeqView$Appended.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.iterator__sc_Iterator(), p, from);
});
$c_sc_SeqView$Appended.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize);
});
$c_sc_SeqView$Appended.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Appended.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Appended.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem);
});
$c_sc_SeqView$Appended.prototype.apply__I__O = (function(idx) {
  return ((idx === this.sc_SeqView$Appended__f_underlying.length__I()) ? this.sc_SeqView$Appended__f_elem : this.sc_SeqView$Appended__f_underlying.apply__I__O(idx));
});
$c_sc_SeqView$Appended.prototype.length__I = (function() {
  return ((1 + this.sc_SeqView$Appended__f_underlying.length__I()) | 0);
});
$c_sc_SeqView$Appended.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$Appended.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$Appended.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_SeqView$Appended.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_SeqView$Appended.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Appended.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
var $d_sc_SeqView$Appended = new $TypeData().initClass($c_sc_SeqView$Appended, "scala.collection.SeqView$Appended", ({
  sc_SeqView$Appended: 1,
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
export { $d_sc_SeqView$Appended as $d_sc_SeqView$Appended };
function $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Drop__f_underlying = underlying;
  $thiz.sc_SeqView$Drop__f_n = n;
  $ct_sc_View$Drop__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz;
}
export { $ct_sc_SeqView$Drop__sc_SeqOps__I__ as $ct_sc_SeqView$Drop__sc_SeqOps__I__ };
/** @constructor */
function $c_sc_SeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
}
export { $c_sc_SeqView$Drop as $c_sc_SeqView$Drop };
$c_sc_SeqView$Drop.prototype = new $h_sc_View$Drop();
$c_sc_SeqView$Drop.prototype.constructor = $c_sc_SeqView$Drop;
/** @constructor */
function $h_sc_SeqView$Drop() {
}
export { $h_sc_SeqView$Drop as $h_sc_SeqView$Drop };
$h_sc_SeqView$Drop.prototype = $c_sc_SeqView$Drop.prototype;
$c_sc_SeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Drop.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Drop.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Drop.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Drop.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator();
});
$c_sc_SeqView$Drop.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_SeqView$Drop.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.iterator__sc_Iterator(), p, from);
});
$c_sc_SeqView$Drop.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize);
});
$c_sc_SeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Drop.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Drop.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem);
});
$c_sc_SeqView$Drop.prototype.length__I = (function() {
  var this$1 = this.sc_SeqView$Drop__f_underlying;
  var x = ((this$1.length__I() - this.sc_View$Drop__f_normN) | 0);
  return ((x > 0) ? x : 0);
});
$c_sc_SeqView$Drop.prototype.apply__I__O = (function(i) {
  return this.sc_SeqView$Drop__f_underlying.apply__I__O(((i + this.sc_View$Drop__f_normN) | 0));
});
$c_sc_SeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this.sc_SeqView$Drop__f_underlying, ((this.sc_SeqView$Drop__f_n + n) | 0));
});
$c_sc_SeqView$Drop.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$Drop.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_SeqView$Drop.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Drop.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
$c_sc_SeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
var $d_sc_SeqView$Drop = new $TypeData().initClass($c_sc_SeqView$Drop, "scala.collection.SeqView$Drop", ({
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
export { $d_sc_SeqView$Drop as $d_sc_SeqView$Drop };
function $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$DropRight__f_underlying = underlying;
  $ct_sc_View$DropRight__sc_IterableOps__I__($thiz, underlying, n);
  var x = ((underlying.length__I() - ((n > 0) ? n : 0)) | 0);
  $thiz.sc_SeqView$DropRight__f_len = ((x > 0) ? x : 0);
  return $thiz;
}
export { $ct_sc_SeqView$DropRight__sc_SeqOps__I__ as $ct_sc_SeqView$DropRight__sc_SeqOps__I__ };
/** @constructor */
function $c_sc_SeqView$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0;
}
export { $c_sc_SeqView$DropRight as $c_sc_SeqView$DropRight };
$c_sc_SeqView$DropRight.prototype = new $h_sc_View$DropRight();
$c_sc_SeqView$DropRight.prototype.constructor = $c_sc_SeqView$DropRight;
/** @constructor */
function $h_sc_SeqView$DropRight() {
}
export { $h_sc_SeqView$DropRight as $h_sc_SeqView$DropRight };
$h_sc_SeqView$DropRight.prototype = $c_sc_SeqView$DropRight.prototype;
$c_sc_SeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$DropRight.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$DropRight.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$DropRight.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$DropRight.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$DropRight.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator();
});
$c_sc_SeqView$DropRight.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_SeqView$DropRight.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.iterator__sc_Iterator(), p, from);
});
$c_sc_SeqView$DropRight.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize);
});
$c_sc_SeqView$DropRight.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$DropRight.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$DropRight.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem);
});
$c_sc_SeqView$DropRight.prototype.length__I = (function() {
  return this.sc_SeqView$DropRight__f_len;
});
$c_sc_SeqView$DropRight.prototype.apply__I__O = (function(i) {
  return this.sc_SeqView$DropRight__f_underlying.apply__I__O(i);
});
$c_sc_SeqView$DropRight.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$DropRight.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_SeqView$DropRight.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_SeqView$DropRight.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_SeqView$DropRight.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
var $d_sc_SeqView$DropRight = new $TypeData().initClass($c_sc_SeqView$DropRight, "scala.collection.SeqView$DropRight", ({
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
export { $d_sc_SeqView$DropRight as $d_sc_SeqView$DropRight };
function $ct_sc_SeqView$Id__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Id__f_underlying = underlying;
  return $thiz;
}
export { $ct_sc_SeqView$Id__sc_SeqOps__ as $ct_sc_SeqView$Id__sc_SeqOps__ };
/** @constructor */
function $c_sc_SeqView$Id() {
  this.sc_SeqView$Id__f_underlying = null;
}
export { $c_sc_SeqView$Id as $c_sc_SeqView$Id };
$c_sc_SeqView$Id.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Id.prototype.constructor = $c_sc_SeqView$Id;
/** @constructor */
function $h_sc_SeqView$Id() {
}
export { $h_sc_SeqView$Id as $h_sc_SeqView$Id };
$h_sc_SeqView$Id.prototype = $c_sc_SeqView$Id.prototype;
$c_sc_SeqView$Id.prototype.apply__I__O = (function(idx) {
  return this.sc_SeqView$Id__f_underlying.apply__I__O(idx);
});
$c_sc_SeqView$Id.prototype.length__I = (function() {
  return this.sc_SeqView$Id__f_underlying.length__I();
});
$c_sc_SeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return this.sc_SeqView$Id__f_underlying.iterator__sc_Iterator();
});
$c_sc_SeqView$Id.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Id__f_underlying.knownSize__I();
});
$c_sc_SeqView$Id.prototype.isEmpty__Z = (function() {
  return this.sc_SeqView$Id__f_underlying.isEmpty__Z();
});
var $d_sc_SeqView$Id = new $TypeData().initClass($c_sc_SeqView$Id, "scala.collection.SeqView$Id", ({
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
export { $d_sc_SeqView$Id as $d_sc_SeqView$Id };
function $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f) {
  $thiz.sc_SeqView$Map__f_underlying = underlying;
  $thiz.sc_SeqView$Map__f_f = f;
  $ct_sc_View$Map__sc_IterableOps__F1__($thiz, underlying, f);
  return $thiz;
}
export { $ct_sc_SeqView$Map__sc_SeqOps__F1__ as $ct_sc_SeqView$Map__sc_SeqOps__F1__ };
/** @constructor */
function $c_sc_SeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
}
export { $c_sc_SeqView$Map as $c_sc_SeqView$Map };
$c_sc_SeqView$Map.prototype = new $h_sc_View$Map();
$c_sc_SeqView$Map.prototype.constructor = $c_sc_SeqView$Map;
/** @constructor */
function $h_sc_SeqView$Map() {
}
export { $h_sc_SeqView$Map as $h_sc_SeqView$Map };
$h_sc_SeqView$Map.prototype = $c_sc_SeqView$Map.prototype;
$c_sc_SeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Map.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Map.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Map.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Map.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator();
});
$c_sc_SeqView$Map.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_SeqView$Map.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.iterator__sc_Iterator(), p, from);
});
$c_sc_SeqView$Map.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize);
});
$c_sc_SeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Map.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Map.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem);
});
$c_sc_SeqView$Map.prototype.apply__I__O = (function(idx) {
  return this.sc_SeqView$Map__f_f.apply__O__O(this.sc_SeqView$Map__f_underlying.apply__I__O(idx));
});
$c_sc_SeqView$Map.prototype.length__I = (function() {
  return this.sc_SeqView$Map__f_underlying.length__I();
});
$c_sc_SeqView$Map.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$Map.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$Map.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_SeqView$Map.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_SeqView$Map.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Map.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
var $d_sc_SeqView$Map = new $TypeData().initClass($c_sc_SeqView$Map, "scala.collection.SeqView$Map", ({
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
export { $d_sc_SeqView$Map as $d_sc_SeqView$Map };
function $ct_sc_SeqView$Prepended__O__sc_SeqOps__($thiz, elem, underlying) {
  $thiz.sc_SeqView$Prepended__f_elem = elem;
  $thiz.sc_SeqView$Prepended__f_underlying = underlying;
  $ct_sc_View$Prepended__O__sc_IterableOps__($thiz, elem, underlying);
  return $thiz;
}
export { $ct_sc_SeqView$Prepended__O__sc_SeqOps__ as $ct_sc_SeqView$Prepended__O__sc_SeqOps__ };
/** @constructor */
function $c_sc_SeqView$Prepended() {
  this.sc_View$Prepended__f_elem = null;
  this.sc_View$Prepended__f_underlying = null;
  this.sc_SeqView$Prepended__f_elem = null;
  this.sc_SeqView$Prepended__f_underlying = null;
}
export { $c_sc_SeqView$Prepended as $c_sc_SeqView$Prepended };
$c_sc_SeqView$Prepended.prototype = new $h_sc_View$Prepended();
$c_sc_SeqView$Prepended.prototype.constructor = $c_sc_SeqView$Prepended;
/** @constructor */
function $h_sc_SeqView$Prepended() {
}
export { $h_sc_SeqView$Prepended as $h_sc_SeqView$Prepended };
$h_sc_SeqView$Prepended.prototype = $c_sc_SeqView$Prepended.prototype;
$c_sc_SeqView$Prepended.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Prepended.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Prepended.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_SeqView$Prepended.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.iterator__sc_Iterator(), p, from);
});
$c_sc_SeqView$Prepended.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize);
});
$c_sc_SeqView$Prepended.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Prepended.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem);
});
$c_sc_SeqView$Prepended.prototype.apply__I__O = (function(idx) {
  return ((idx === 0) ? this.sc_SeqView$Prepended__f_elem : this.sc_SeqView$Prepended__f_underlying.apply__I__O((((-1) + idx) | 0)));
});
$c_sc_SeqView$Prepended.prototype.length__I = (function() {
  return ((1 + this.sc_SeqView$Prepended__f_underlying.length__I()) | 0);
});
$c_sc_SeqView$Prepended.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
function $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying) {
  $thiz.sc_SeqView$Reverse__f_underlying = underlying;
  return $thiz;
}
export { $ct_sc_SeqView$Reverse__sc_SeqOps__ as $ct_sc_SeqView$Reverse__sc_SeqOps__ };
/** @constructor */
function $c_sc_SeqView$Reverse() {
  this.sc_SeqView$Reverse__f_underlying = null;
}
export { $c_sc_SeqView$Reverse as $c_sc_SeqView$Reverse };
$c_sc_SeqView$Reverse.prototype = new $h_sc_AbstractSeqView();
$c_sc_SeqView$Reverse.prototype.constructor = $c_sc_SeqView$Reverse;
/** @constructor */
function $h_sc_SeqView$Reverse() {
}
export { $h_sc_SeqView$Reverse as $h_sc_SeqView$Reverse };
$h_sc_SeqView$Reverse.prototype = $c_sc_SeqView$Reverse.prototype;
$c_sc_SeqView$Reverse.prototype.apply__I__O = (function(i) {
  return this.sc_SeqView$Reverse__f_underlying.apply__I__O((((((-1) + this.length__I()) | 0) - i) | 0));
});
$c_sc_SeqView$Reverse.prototype.length__I = (function() {
  var this$1 = this.sc_SeqView$Reverse__f_underlying;
  return this$1.length__I();
});
$c_sc_SeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return this.sc_SeqView$Reverse__f_underlying.reverseIterator__sc_Iterator();
});
$c_sc_SeqView$Reverse.prototype.knownSize__I = (function() {
  return this.sc_SeqView$Reverse__f_underlying.knownSize__I();
});
$c_sc_SeqView$Reverse.prototype.isEmpty__Z = (function() {
  return this.sc_SeqView$Reverse__f_underlying.isEmpty__Z();
});
var $d_sc_SeqView$Reverse = new $TypeData().initClass($c_sc_SeqView$Reverse, "scala.collection.SeqView$Reverse", ({
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
export { $d_sc_SeqView$Reverse as $d_sc_SeqView$Reverse };
function $ct_sc_SeqView$Take__sc_SeqOps__I__($thiz, underlying, n) {
  $thiz.sc_SeqView$Take__f_underlying = underlying;
  $thiz.sc_SeqView$Take__f_n = n;
  $ct_sc_View$Take__sc_IterableOps__I__($thiz, underlying, n);
  return $thiz;
}
export { $ct_sc_SeqView$Take__sc_SeqOps__I__ as $ct_sc_SeqView$Take__sc_SeqOps__I__ };
/** @constructor */
function $c_sc_SeqView$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0;
}
export { $c_sc_SeqView$Take as $c_sc_SeqView$Take };
$c_sc_SeqView$Take.prototype = new $h_sc_View$Take();
$c_sc_SeqView$Take.prototype.constructor = $c_sc_SeqView$Take;
/** @constructor */
function $h_sc_SeqView$Take() {
}
export { $h_sc_SeqView$Take as $h_sc_SeqView$Take };
$h_sc_SeqView$Take.prototype = $c_sc_SeqView$Take.prototype;
$c_sc_SeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_SeqView$Map__sc_SeqOps__F1__(new $c_sc_SeqView$Map(), this, f);
});
$c_sc_SeqView$Take.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_SeqView$Appended__sc_SeqOps__O__(new $c_sc_SeqView$Appended(), this, elem);
});
$c_sc_SeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Take__sc_SeqOps__I__(new $c_sc_SeqView$Take(), this, n);
});
$c_sc_SeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$Drop__sc_SeqOps__I__(new $c_sc_SeqView$Drop(), this, n);
});
$c_sc_SeqView$Take.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_SeqView$DropRight__sc_SeqOps__I__(new $c_sc_SeqView$DropRight(), this, n);
});
$c_sc_SeqView$Take.prototype.stringPrefix__T = (function() {
  return "SeqView";
});
$c_sc_SeqView$Take.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_sc_SeqView$Take.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_sc_SeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return this.reversed__sc_Iterable().iterator__sc_Iterator();
});
$c_sc_SeqView$Take.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sc_SeqView$Take.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.iterator__sc_Iterator(), p, from);
});
$c_sc_SeqView$Take.prototype.sizeCompare__I__I = (function(otherSize) {
  return this.lengthCompare__I__I(otherSize);
});
$c_sc_SeqView$Take.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_IterableOps__sizeCompare__I__I(this, len);
});
$c_sc_SeqView$Take.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sc_SeqView$Take.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem);
});
$c_sc_SeqView$Take.prototype.apply__I__O = (function(idx) {
  if ((idx < this.sc_SeqView$Take__f_n)) {
    return this.sc_SeqView$Take__f_underlying.apply__I__O(idx);
  } else {
    throw ((this.sc_SeqView$Take__f_underlying.knownSize__I() >= 0) ? $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(idx, (((-1) + this.knownSize__I()) | 0)) : $m_scg_CommonErrors$().indexOutOfBounds__I__jl_IndexOutOfBoundsException(idx));
  }
});
$c_sc_SeqView$Take.prototype.length__I = (function() {
  var x = this.sc_SeqView$Take__f_underlying.length__I();
  var that = this.sc_View$Take__f_normN;
  return ((x < that) ? x : that);
});
$c_sc_SeqView$Take.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $ct_sc_SeqView$Sorted__sc_SeqOps__s_math_Ordering__(new $c_sc_SeqView$Sorted(), this, ord);
});
$c_sc_SeqView$Take.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_SeqView(n);
});
$c_sc_SeqView$Take.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_SeqView(n);
});
$c_sc_SeqView$Take.prototype.take__I__O = (function(n) {
  return this.take__I__sc_SeqView(n);
});
$c_sc_SeqView$Take.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_SeqView(elem);
});
$c_sc_SeqView$Take.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_SeqView(f);
});
var $d_sc_SeqView$Take = new $TypeData().initClass($c_sc_SeqView$Take, "scala.collection.SeqView$Take", ({
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1
}));
export { $d_sc_SeqView$Take as $d_sc_SeqView$Take };
function $is_sci_Seq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Seq)));
}
export { $is_sci_Seq as $is_sci_Seq };
function $isArrayOf_sci_Seq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Seq)));
}
export { $isArrayOf_sci_Seq as $isArrayOf_sci_Seq };
var $d_sci_Seq = new $TypeData().initClass(1, "scala.collection.immutable.Seq", ({
  sci_Seq: 1,
  sci_Iterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_SeqOps: 1
}));
export { $d_sci_Seq as $d_sci_Seq };
function $f_scm_MapOps__update__O__O__V($thiz, key, value) {
  var elem = $ct_T2__O__O__(new $c_T2(), key, value);
  $thiz.addOne__O__scm_Growable(elem);
}
export { $f_scm_MapOps__update__O__O__V as $f_scm_MapOps__update__O__O__V };
function $f_scm_MapOps__updateWith__O__F1__s_Option($thiz, key, remappingFunction) {
  var previousValue = $thiz.get__O__s_Option(key);
  var nextValue = remappingFunction.apply__O__O(previousValue);
  var x1 = $ct_T2__O__O__(new $c_T2(), previousValue, nextValue);
  matchEnd15: {
    var p2 = x1.T2__f__1;
    var p3 = x1.T2__f__2;
    var x = $m_s_None$();
    if ((x === p2)) {
      var x$3 = $m_s_None$();
      var $x_1 = (x$3 === p3);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      break matchEnd15;
    }
    var p6 = x1.T2__f__1;
    var p7 = x1.T2__f__2;
    if ((p6 instanceof $c_s_Some)) {
      var x$5 = $m_s_None$();
      var $x_2 = (x$5 === p7);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      $thiz.remove__O__s_Option(key);
      break matchEnd15;
    }
    var p12 = x1.T2__f__2;
    if ((p12 instanceof $c_s_Some)) {
      var v = p12.s_Some__f_value;
      $thiz.update__O__O__V(key, v);
      break matchEnd15;
    }
    throw new $c_s_MatchError(x1);
  }
  return nextValue;
}
export { $f_scm_MapOps__updateWith__O__F1__s_Option as $f_scm_MapOps__updateWith__O__F1__s_Option };
function $f_scm_MapOps__getOrElseUpdate__O__F0__O($thiz, key, defaultValue) {
  var x1 = $thiz.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var v = x1.s_Some__f_value;
    return v;
  } else {
    var x = $m_s_None$();
    if ((x === x1)) {
      var d = defaultValue.apply__O();
      $thiz.update__O__O__V(key, d);
      return d;
    } else {
      throw new $c_s_MatchError(x1);
    }
  }
}
export { $f_scm_MapOps__getOrElseUpdate__O__F0__O as $f_scm_MapOps__getOrElseUpdate__O__F0__O };
function $f_scm_MapOps__remove__O__s_Option($thiz, key) {
  var r = $thiz.get__O__s_Option(key);
  if ((!r.isEmpty__Z())) {
    $thiz.subtractOne__O__scm_Shrinkable(key);
  }
  return r;
}
export { $f_scm_MapOps__remove__O__s_Option as $f_scm_MapOps__remove__O__s_Option };
/** @constructor */
function $c_Lcats_Applicative$$anon$1(evidence$1$1, outer) {
  this.Lcats_Applicative$$anon$1__f_F = null;
  this.Lcats_Applicative$$anon$1__f_G = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_Applicative$$anon$1__f_F = outer;
  this.Lcats_Applicative$$anon$1__f_G = evidence$1$1;
}
export { $c_Lcats_Applicative$$anon$1 as $c_Lcats_Applicative$$anon$1 };
$c_Lcats_Applicative$$anon$1.prototype = new $h_O();
$c_Lcats_Applicative$$anon$1.prototype.constructor = $c_Lcats_Applicative$$anon$1;
/** @constructor */
function $h_Lcats_Applicative$$anon$1() {
}
export { $h_Lcats_Applicative$$anon$1 as $h_Lcats_Applicative$$anon$1 };
$h_Lcats_Applicative$$anon$1.prototype = $c_Lcats_Applicative$$anon$1.prototype;
$c_Lcats_Applicative$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_Applicative$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_Applicative$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_Apply__productL__O__O__O(this, fa, fb);
});
$c_Lcats_Applicative$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_Applicative$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_Applicative$$anon$1.prototype.unit__O = (function() {
  return $f_Lcats_ComposedApplicative__pure__O__O(this, (void 0));
});
$c_Lcats_Applicative$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lcats_Applicative$$anon$1.prototype.imap__O__F1__F1__O = (function(fga, f, g) {
  return $f_Lcats_ComposedInvariant__imap__O__F1__F1__O(this, fga, f, g);
});
$c_Lcats_Applicative$$anon$1.prototype.map__O__F1__O = (function(fga, f) {
  return $f_Lcats_ComposedFunctor__map__O__F1__O(this, fga, f);
});
$c_Lcats_Applicative$$anon$1.prototype.ap__O__O__O = (function(fgf, fga) {
  return $f_Lcats_ComposedApply__ap__O__O__O(this, fgf, fga);
});
$c_Lcats_Applicative$$anon$1.prototype.product__O__O__O = (function(fga, fgb) {
  return $f_Lcats_ComposedApply__product__O__O__O(this, fga, fgb);
});
$c_Lcats_Applicative$$anon$1.prototype.pure__O__O = (function(x) {
  return $f_Lcats_ComposedApplicative__pure__O__O(this, x);
});
$c_Lcats_Applicative$$anon$1.prototype.F__Lcats_Applicative = (function() {
  return this.Lcats_Applicative$$anon$1__f_F;
});
$c_Lcats_Applicative$$anon$1.prototype.G__Lcats_Applicative = (function() {
  return this.Lcats_Applicative$$anon$1__f_G;
});
$c_Lcats_Applicative$$anon$1.prototype.F__Lcats_Apply = (function() {
  return this.Lcats_Applicative$$anon$1__f_F;
});
$c_Lcats_Applicative$$anon$1.prototype.F__Lcats_Functor = (function() {
  return this.Lcats_Applicative$$anon$1__f_F;
});
$c_Lcats_Applicative$$anon$1.prototype.F__Lcats_Invariant = (function() {
  return this.Lcats_Applicative$$anon$1__f_F;
});
var $d_Lcats_Applicative$$anon$1 = new $TypeData().initClass($c_Lcats_Applicative$$anon$1, "cats.Applicative$$anon$1", ({
  Lcats_Applicative$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ComposedInvariant: 1,
  Lcats_ComposedFunctor: 1,
  Lcats_ComposedApply: 1,
  Lcats_ComposedApplicative: 1
}));
export { $d_Lcats_Applicative$$anon$1 as $d_Lcats_Applicative$$anon$1 };
/** @constructor */
function $c_Lcats_data_ValidatedInstances$$anon$7(E$1) {
  this.Lcats_data_ValidatedApplicative__f_evidence$1 = null;
  $ct_Lcats_data_ValidatedApplicative__Lcats_kernel_Semigroup__(this, E$1);
}
export { $c_Lcats_data_ValidatedInstances$$anon$7 as $c_Lcats_data_ValidatedInstances$$anon$7 };
$c_Lcats_data_ValidatedInstances$$anon$7.prototype = new $h_Lcats_data_ValidatedApplicative();
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.constructor = $c_Lcats_data_ValidatedInstances$$anon$7;
/** @constructor */
function $h_Lcats_data_ValidatedInstances$$anon$7() {
}
export { $h_Lcats_data_ValidatedInstances$$anon$7 as $h_Lcats_data_ValidatedInstances$$anon$7 };
$h_Lcats_data_ValidatedInstances$$anon$7.prototype = $c_Lcats_data_ValidatedInstances$$anon$7.prototype;
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.handleErrorWith__Lcats_data_Validated__F1__Lcats_data_Validated = (function(fa, f) {
  if ((fa instanceof $c_Lcats_data_Validated$Invalid)) {
    var x398 = fa.Lcats_data_Validated$Invalid__f_e;
    return f.apply__O__O(x398);
  }
  if ((fa instanceof $c_Lcats_data_Validated$Valid)) {
    return fa;
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__Lcats_data_Validated__F1__Lcats_data_Validated(fa, f);
});
$c_Lcats_data_ValidatedInstances$$anon$7.prototype.raiseError__O__O = (function(e) {
  return new $c_Lcats_data_Validated$Invalid(e);
});
var $d_Lcats_data_ValidatedInstances$$anon$7 = new $TypeData().initClass($c_Lcats_data_ValidatedInstances$$anon$7, "cats.data.ValidatedInstances$$anon$7", ({
  Lcats_data_ValidatedInstances$$anon$7: 1,
  Lcats_data_ValidatedApplicative: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_ApplicativeError: 1
}));
export { $d_Lcats_data_ValidatedInstances$$anon$7 as $d_Lcats_data_ValidatedInstances$$anon$7 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "MONDAY", 0, "MONDAY", 0);
}
export { $c_Ljava_time_DayOfWeek$$anon$1 as $c_Ljava_time_DayOfWeek$$anon$1 };
$c_Ljava_time_DayOfWeek$$anon$1.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$1.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$1;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$1() {
}
export { $h_Ljava_time_DayOfWeek$$anon$1 as $h_Ljava_time_DayOfWeek$$anon$1 };
$h_Ljava_time_DayOfWeek$$anon$1.prototype = $c_Ljava_time_DayOfWeek$$anon$1.prototype;
$c_Ljava_time_DayOfWeek$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_DayOfWeek$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$1 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$1, "java.time.DayOfWeek$$anon$1", ({
  Ljava_time_DayOfWeek$$anon$1: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$1 as $d_Ljava_time_DayOfWeek$$anon$1 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "TUESDAY", 1, "TUESDAY", 1);
}
export { $c_Ljava_time_DayOfWeek$$anon$2 as $c_Ljava_time_DayOfWeek$$anon$2 };
$c_Ljava_time_DayOfWeek$$anon$2.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$2.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$2;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$2() {
}
export { $h_Ljava_time_DayOfWeek$$anon$2 as $h_Ljava_time_DayOfWeek$$anon$2 };
$h_Ljava_time_DayOfWeek$$anon$2.prototype = $c_Ljava_time_DayOfWeek$$anon$2.prototype;
$c_Ljava_time_DayOfWeek$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_DayOfWeek$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$2 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$2, "java.time.DayOfWeek$$anon$2", ({
  Ljava_time_DayOfWeek$$anon$2: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$2 as $d_Ljava_time_DayOfWeek$$anon$2 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "WEDNESDAY", 2, "WEDNESDAY", 2);
}
export { $c_Ljava_time_DayOfWeek$$anon$3 as $c_Ljava_time_DayOfWeek$$anon$3 };
$c_Ljava_time_DayOfWeek$$anon$3.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$3.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$3;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$3() {
}
export { $h_Ljava_time_DayOfWeek$$anon$3 as $h_Ljava_time_DayOfWeek$$anon$3 };
$h_Ljava_time_DayOfWeek$$anon$3.prototype = $c_Ljava_time_DayOfWeek$$anon$3.prototype;
$c_Ljava_time_DayOfWeek$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_DayOfWeek$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$3 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$3, "java.time.DayOfWeek$$anon$3", ({
  Ljava_time_DayOfWeek$$anon$3: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$3 as $d_Ljava_time_DayOfWeek$$anon$3 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "THURSDAY", 3, "THURSDAY", 3);
}
export { $c_Ljava_time_DayOfWeek$$anon$4 as $c_Ljava_time_DayOfWeek$$anon$4 };
$c_Ljava_time_DayOfWeek$$anon$4.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$4.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$4;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$4() {
}
export { $h_Ljava_time_DayOfWeek$$anon$4 as $h_Ljava_time_DayOfWeek$$anon$4 };
$h_Ljava_time_DayOfWeek$$anon$4.prototype = $c_Ljava_time_DayOfWeek$$anon$4.prototype;
$c_Ljava_time_DayOfWeek$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$4.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_DayOfWeek$$anon$4.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$4 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$4, "java.time.DayOfWeek$$anon$4", ({
  Ljava_time_DayOfWeek$$anon$4: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$4 as $d_Ljava_time_DayOfWeek$$anon$4 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "FRIDAY", 4, "FRIDAY", 4);
}
export { $c_Ljava_time_DayOfWeek$$anon$5 as $c_Ljava_time_DayOfWeek$$anon$5 };
$c_Ljava_time_DayOfWeek$$anon$5.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$5.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$5;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$5() {
}
export { $h_Ljava_time_DayOfWeek$$anon$5 as $h_Ljava_time_DayOfWeek$$anon$5 };
$h_Ljava_time_DayOfWeek$$anon$5.prototype = $c_Ljava_time_DayOfWeek$$anon$5.prototype;
$c_Ljava_time_DayOfWeek$$anon$5.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$5.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_DayOfWeek$$anon$5.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$5 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$5, "java.time.DayOfWeek$$anon$5", ({
  Ljava_time_DayOfWeek$$anon$5: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$5 as $d_Ljava_time_DayOfWeek$$anon$5 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "SATURDAY", 5, "SATURDAY", 5);
}
export { $c_Ljava_time_DayOfWeek$$anon$6 as $c_Ljava_time_DayOfWeek$$anon$6 };
$c_Ljava_time_DayOfWeek$$anon$6.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$6.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$6;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$6() {
}
export { $h_Ljava_time_DayOfWeek$$anon$6 as $h_Ljava_time_DayOfWeek$$anon$6 };
$h_Ljava_time_DayOfWeek$$anon$6.prototype = $c_Ljava_time_DayOfWeek$$anon$6.prototype;
$c_Ljava_time_DayOfWeek$$anon$6.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$6.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_DayOfWeek$$anon$6.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$6 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$6, "java.time.DayOfWeek$$anon$6", ({
  Ljava_time_DayOfWeek$$anon$6: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$6 as $d_Ljava_time_DayOfWeek$$anon$6 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_DayOfWeek__f_ordinal = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "SUNDAY", 6, "SUNDAY", 6);
}
export { $c_Ljava_time_DayOfWeek$$anon$7 as $c_Ljava_time_DayOfWeek$$anon$7 };
$c_Ljava_time_DayOfWeek$$anon$7.prototype = new $h_Ljava_time_DayOfWeek();
$c_Ljava_time_DayOfWeek$$anon$7.prototype.constructor = $c_Ljava_time_DayOfWeek$$anon$7;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$7() {
}
export { $h_Ljava_time_DayOfWeek$$anon$7 as $h_Ljava_time_DayOfWeek$$anon$7 };
$h_Ljava_time_DayOfWeek$$anon$7.prototype = $c_Ljava_time_DayOfWeek$$anon$7.prototype;
$c_Ljava_time_DayOfWeek$$anon$7.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_DayOfWeek$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$7.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_DayOfWeek$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_DayOfWeek$$anon$7.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$7 = new $TypeData().initClass($c_Ljava_time_DayOfWeek$$anon$7, "java.time.DayOfWeek$$anon$7", ({
  Ljava_time_DayOfWeek$$anon$7: 1,
  Ljava_time_DayOfWeek: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$7 as $d_Ljava_time_DayOfWeek$$anon$7 };
/** @constructor */
function $c_Ljava_time_Month$$anon$1() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JANUARY", 0, "JANUARY", 0);
}
export { $c_Ljava_time_Month$$anon$1 as $c_Ljava_time_Month$$anon$1 };
$c_Ljava_time_Month$$anon$1.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$1.prototype.constructor = $c_Ljava_time_Month$$anon$1;
/** @constructor */
function $h_Ljava_time_Month$$anon$1() {
}
export { $h_Ljava_time_Month$$anon$1 as $h_Ljava_time_Month$$anon$1 };
$h_Ljava_time_Month$$anon$1.prototype = $c_Ljava_time_Month$$anon$1.prototype;
$c_Ljava_time_Month$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$1.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$1.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$1 = new $TypeData().initClass($c_Ljava_time_Month$$anon$1, "java.time.Month$$anon$1", ({
  Ljava_time_Month$$anon$1: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$1 as $d_Ljava_time_Month$$anon$1 };
/** @constructor */
function $c_Ljava_time_Month$$anon$10() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "OCTOBER", 9, "OCTOBER", 9);
}
export { $c_Ljava_time_Month$$anon$10 as $c_Ljava_time_Month$$anon$10 };
$c_Ljava_time_Month$$anon$10.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$10.prototype.constructor = $c_Ljava_time_Month$$anon$10;
/** @constructor */
function $h_Ljava_time_Month$$anon$10() {
}
export { $h_Ljava_time_Month$$anon$10 as $h_Ljava_time_Month$$anon$10 };
$h_Ljava_time_Month$$anon$10.prototype = $c_Ljava_time_Month$$anon$10.prototype;
$c_Ljava_time_Month$$anon$10.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$10.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$10.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$10.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$10.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$10 = new $TypeData().initClass($c_Ljava_time_Month$$anon$10, "java.time.Month$$anon$10", ({
  Ljava_time_Month$$anon$10: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$10 as $d_Ljava_time_Month$$anon$10 };
/** @constructor */
function $c_Ljava_time_Month$$anon$11() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "NOVEMBER", 10, "NOVEMBER", 10);
}
export { $c_Ljava_time_Month$$anon$11 as $c_Ljava_time_Month$$anon$11 };
$c_Ljava_time_Month$$anon$11.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$11.prototype.constructor = $c_Ljava_time_Month$$anon$11;
/** @constructor */
function $h_Ljava_time_Month$$anon$11() {
}
export { $h_Ljava_time_Month$$anon$11 as $h_Ljava_time_Month$$anon$11 };
$h_Ljava_time_Month$$anon$11.prototype = $c_Ljava_time_Month$$anon$11.prototype;
$c_Ljava_time_Month$$anon$11.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$11.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$11.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$11.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$11.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$11 = new $TypeData().initClass($c_Ljava_time_Month$$anon$11, "java.time.Month$$anon$11", ({
  Ljava_time_Month$$anon$11: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$11 as $d_Ljava_time_Month$$anon$11 };
/** @constructor */
function $c_Ljava_time_Month$$anon$12() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "DECEMBER", 11, "DECEMBER", 11);
}
export { $c_Ljava_time_Month$$anon$12 as $c_Ljava_time_Month$$anon$12 };
$c_Ljava_time_Month$$anon$12.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$12.prototype.constructor = $c_Ljava_time_Month$$anon$12;
/** @constructor */
function $h_Ljava_time_Month$$anon$12() {
}
export { $h_Ljava_time_Month$$anon$12 as $h_Ljava_time_Month$$anon$12 };
$h_Ljava_time_Month$$anon$12.prototype = $c_Ljava_time_Month$$anon$12.prototype;
$c_Ljava_time_Month$$anon$12.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$12.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$12.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$12.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$12.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$12 = new $TypeData().initClass($c_Ljava_time_Month$$anon$12, "java.time.Month$$anon$12", ({
  Ljava_time_Month$$anon$12: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$12 as $d_Ljava_time_Month$$anon$12 };
/** @constructor */
function $c_Ljava_time_Month$$anon$2() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "FEBRUARY", 1, "FEBRUARY", 1);
}
export { $c_Ljava_time_Month$$anon$2 as $c_Ljava_time_Month$$anon$2 };
$c_Ljava_time_Month$$anon$2.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$2.prototype.constructor = $c_Ljava_time_Month$$anon$2;
/** @constructor */
function $h_Ljava_time_Month$$anon$2() {
}
export { $h_Ljava_time_Month$$anon$2 as $h_Ljava_time_Month$$anon$2 };
$h_Ljava_time_Month$$anon$2.prototype = $c_Ljava_time_Month$$anon$2.prototype;
$c_Ljava_time_Month$$anon$2.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$2.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$2.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$2.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$2.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$2 = new $TypeData().initClass($c_Ljava_time_Month$$anon$2, "java.time.Month$$anon$2", ({
  Ljava_time_Month$$anon$2: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$2 as $d_Ljava_time_Month$$anon$2 };
/** @constructor */
function $c_Ljava_time_Month$$anon$3() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "MARCH", 2, "MARCH", 2);
}
export { $c_Ljava_time_Month$$anon$3 as $c_Ljava_time_Month$$anon$3 };
$c_Ljava_time_Month$$anon$3.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$3.prototype.constructor = $c_Ljava_time_Month$$anon$3;
/** @constructor */
function $h_Ljava_time_Month$$anon$3() {
}
export { $h_Ljava_time_Month$$anon$3 as $h_Ljava_time_Month$$anon$3 };
$h_Ljava_time_Month$$anon$3.prototype = $c_Ljava_time_Month$$anon$3.prototype;
$c_Ljava_time_Month$$anon$3.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$3.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$3.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$3.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$3.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$3 = new $TypeData().initClass($c_Ljava_time_Month$$anon$3, "java.time.Month$$anon$3", ({
  Ljava_time_Month$$anon$3: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$3 as $d_Ljava_time_Month$$anon$3 };
/** @constructor */
function $c_Ljava_time_Month$$anon$4() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "APRIL", 3, "APRIL", 3);
}
export { $c_Ljava_time_Month$$anon$4 as $c_Ljava_time_Month$$anon$4 };
$c_Ljava_time_Month$$anon$4.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$4.prototype.constructor = $c_Ljava_time_Month$$anon$4;
/** @constructor */
function $h_Ljava_time_Month$$anon$4() {
}
export { $h_Ljava_time_Month$$anon$4 as $h_Ljava_time_Month$$anon$4 };
$h_Ljava_time_Month$$anon$4.prototype = $c_Ljava_time_Month$$anon$4.prototype;
$c_Ljava_time_Month$$anon$4.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$4.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$4.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$4.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$4.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$4 = new $TypeData().initClass($c_Ljava_time_Month$$anon$4, "java.time.Month$$anon$4", ({
  Ljava_time_Month$$anon$4: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$4 as $d_Ljava_time_Month$$anon$4 };
/** @constructor */
function $c_Ljava_time_Month$$anon$5() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "MAY", 4, "MAY", 4);
}
export { $c_Ljava_time_Month$$anon$5 as $c_Ljava_time_Month$$anon$5 };
$c_Ljava_time_Month$$anon$5.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$5.prototype.constructor = $c_Ljava_time_Month$$anon$5;
/** @constructor */
function $h_Ljava_time_Month$$anon$5() {
}
export { $h_Ljava_time_Month$$anon$5 as $h_Ljava_time_Month$$anon$5 };
$h_Ljava_time_Month$$anon$5.prototype = $c_Ljava_time_Month$$anon$5.prototype;
$c_Ljava_time_Month$$anon$5.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$5.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$5.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$5.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$5.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$5 = new $TypeData().initClass($c_Ljava_time_Month$$anon$5, "java.time.Month$$anon$5", ({
  Ljava_time_Month$$anon$5: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$5 as $d_Ljava_time_Month$$anon$5 };
/** @constructor */
function $c_Ljava_time_Month$$anon$6() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JUNE", 5, "JUNE", 5);
}
export { $c_Ljava_time_Month$$anon$6 as $c_Ljava_time_Month$$anon$6 };
$c_Ljava_time_Month$$anon$6.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$6.prototype.constructor = $c_Ljava_time_Month$$anon$6;
/** @constructor */
function $h_Ljava_time_Month$$anon$6() {
}
export { $h_Ljava_time_Month$$anon$6 as $h_Ljava_time_Month$$anon$6 };
$h_Ljava_time_Month$$anon$6.prototype = $c_Ljava_time_Month$$anon$6.prototype;
$c_Ljava_time_Month$$anon$6.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$6.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$6.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$6.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$6.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$6 = new $TypeData().initClass($c_Ljava_time_Month$$anon$6, "java.time.Month$$anon$6", ({
  Ljava_time_Month$$anon$6: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$6 as $d_Ljava_time_Month$$anon$6 };
/** @constructor */
function $c_Ljava_time_Month$$anon$7() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JULY", 6, "JULY", 6);
}
export { $c_Ljava_time_Month$$anon$7 as $c_Ljava_time_Month$$anon$7 };
$c_Ljava_time_Month$$anon$7.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$7.prototype.constructor = $c_Ljava_time_Month$$anon$7;
/** @constructor */
function $h_Ljava_time_Month$$anon$7() {
}
export { $h_Ljava_time_Month$$anon$7 as $h_Ljava_time_Month$$anon$7 };
$h_Ljava_time_Month$$anon$7.prototype = $c_Ljava_time_Month$$anon$7.prototype;
$c_Ljava_time_Month$$anon$7.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$7.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$7.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$7.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$7.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$7 = new $TypeData().initClass($c_Ljava_time_Month$$anon$7, "java.time.Month$$anon$7", ({
  Ljava_time_Month$$anon$7: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$7 as $d_Ljava_time_Month$$anon$7 };
/** @constructor */
function $c_Ljava_time_Month$$anon$8() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "AUGUST", 7, "AUGUST", 7);
}
export { $c_Ljava_time_Month$$anon$8 as $c_Ljava_time_Month$$anon$8 };
$c_Ljava_time_Month$$anon$8.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$8.prototype.constructor = $c_Ljava_time_Month$$anon$8;
/** @constructor */
function $h_Ljava_time_Month$$anon$8() {
}
export { $h_Ljava_time_Month$$anon$8 as $h_Ljava_time_Month$$anon$8 };
$h_Ljava_time_Month$$anon$8.prototype = $c_Ljava_time_Month$$anon$8.prototype;
$c_Ljava_time_Month$$anon$8.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$8.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$8.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$8.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$8.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$8 = new $TypeData().initClass($c_Ljava_time_Month$$anon$8, "java.time.Month$$anon$8", ({
  Ljava_time_Month$$anon$8: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$8 as $d_Ljava_time_Month$$anon$8 };
/** @constructor */
function $c_Ljava_time_Month$$anon$9() {
  this.jl_Enum__f__name = null;
  this.jl_Enum__f__ordinal = 0;
  this.Ljava_time_Month__f_ordinal = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "SEPTEMBER", 8, "SEPTEMBER", 8);
}
export { $c_Ljava_time_Month$$anon$9 as $c_Ljava_time_Month$$anon$9 };
$c_Ljava_time_Month$$anon$9.prototype = new $h_Ljava_time_Month();
$c_Ljava_time_Month$$anon$9.prototype.constructor = $c_Ljava_time_Month$$anon$9;
/** @constructor */
function $h_Ljava_time_Month$$anon$9() {
}
export { $h_Ljava_time_Month$$anon$9 as $h_Ljava_time_Month$$anon$9 };
$h_Ljava_time_Month$$anon$9.prototype = $c_Ljava_time_Month$$anon$9.prototype;
$c_Ljava_time_Month$$anon$9.prototype.productArity__I = (function() {
  return 0;
});
$c_Ljava_time_Month$$anon$9.prototype.productElement__I__O = (function(n) {
  return $f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Ljava_time_Month$$anon$9.prototype.productElementName__I__T = (function(n) {
  return $f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Ljava_time_Month$$anon$9.prototype.productPrefix__T = (function() {
  return this.jl_Enum__f__name;
});
$c_Ljava_time_Month$$anon$9.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$9 = new $TypeData().initClass($c_Ljava_time_Month$$anon$9, "java.time.Month$$anon$9", ({
  Ljava_time_Month$$anon$9: 1,
  Ljava_time_Month: 1,
  jl_Enum: 1,
  jl_Comparable: 1,
  Ljava_io_Serializable: 1,
  Ljava_time_temporal_TemporalAccessor: 1,
  Ljava_time_temporal_TemporalAdjuster: 1,
  s_Equals: 1,
  s_Product: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Ljava_time_Month$$anon$9 as $d_Ljava_time_Month$$anon$9 };
/** @constructor */
function $c_sc_AbstractMapView() {
}
export { $c_sc_AbstractMapView as $c_sc_AbstractMapView };
$c_sc_AbstractMapView.prototype = new $h_sc_AbstractView();
$c_sc_AbstractMapView.prototype.constructor = $c_sc_AbstractMapView;
/** @constructor */
function $h_sc_AbstractMapView() {
}
export { $h_sc_AbstractMapView as $h_sc_AbstractMapView };
$h_sc_AbstractMapView.prototype = $c_sc_AbstractMapView.prototype;
$c_sc_AbstractMapView.prototype.values__sc_Iterable = (function() {
  return new $c_sc_MapView$Values(this);
});
$c_sc_AbstractMapView.prototype.filter__F1__sc_MapView = (function(pred) {
  return new $c_sc_MapView$Filter(this, false, pred);
});
$c_sc_AbstractMapView.prototype.toString__T = (function() {
  return $f_sc_View__toString__T(this);
});
$c_sc_AbstractMapView.prototype.stringPrefix__T = (function() {
  return "MapView";
});
$c_sc_AbstractMapView.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
});
$c_sc_AbstractMapView.prototype.apply__O__O = (function(key) {
  return $f_sc_MapOps__apply__O__O(this, key);
});
$c_sc_AbstractMapView.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_sc_MapOps__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sc_AbstractMapView.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$2(this);
});
$c_sc_AbstractMapView.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sc_MapOps$$anon$3(this);
});
$c_sc_AbstractMapView.prototype.default__O__O = (function(key) {
  return $f_sc_MapOps__default__O__O(this, key);
});
$c_sc_AbstractMapView.prototype.contains__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$c_sc_AbstractMapView.prototype.isDefinedAt__O__Z = (function(key) {
  return $f_sc_MapOps__contains__O__Z(this, key);
});
$c_sc_AbstractMapView.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return $f_sc_MapOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, sb, start, sep, end);
});
$c_sc_AbstractMapView.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sc_AbstractMapView.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sc_AbstractMapView.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sc_AbstractMapView.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!$f_sc_MapOps__apply__O__O(this, v1)));
});
$c_sc_AbstractMapView.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sc_AbstractMapView.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sc_AbstractMapView.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sc_MapView$();
});
$c_sc_AbstractMapView.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sc_MapView(pred);
});
function $is_sci_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_Map)));
}
export { $is_sci_Map as $is_sci_Map };
function $isArrayOf_sci_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map)));
}
export { $isArrayOf_sci_Map as $isArrayOf_sci_Map };
function $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O($thiz, fa, fin) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll) => {
    var finalized = $thiz.onCancel__O__O__O(poll.apply__O__O(fa), fin.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Canceled()));
    var handled = $thiz.onError__O__s_PartialFunction__O(finalized, new $c_Lcats_effect_kernel_MonadCancel$$anon$1(fin, $thiz));
    return $f_Lcats_FlatMap__flatTap__O__F1__O($thiz, handled, new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => {
      var fa$1 = $thiz.pure__O__O(a);
      return fin.apply__O__O(new $c_Lcats_effect_kernel_Outcome$Succeeded(fa$1));
    })));
  })));
}
export { $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O as $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O };
function $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O($thiz, acquire, use, release) {
  return $thiz.uncancelable__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll) => {
    var target = acquire.apply__O__O(poll);
    var this$4 = new $c_Lcats_FlatMap$ToFlatMapOps$$anon$2(target, $thiz);
    var f = new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((poll$2) => ((a) => {
      var fa = $thiz.unit__O();
      return $thiz.guaranteeCase__O__F1__O(poll$2.apply__O__O($m_Lcats_syntax_FlatMapOps$().$greater$greater$extension__O__F0__Lcats_FlatMap__O(fa, new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => use.apply__O__O(a))), $thiz)), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$6) => release.apply__O__O__O(a, _$6))));
    }))(poll));
    return this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_typeClassInstance.flatMap__O__F1__O(this$4.Lcats_FlatMap$ToFlatMapOps$$anon$2__f_self, f);
  })));
}
export { $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O as $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O };
/** @constructor */
function $c_Lcats_kernel_instances_IntOrder() {
}
export { $c_Lcats_kernel_instances_IntOrder as $c_Lcats_kernel_instances_IntOrder };
$c_Lcats_kernel_instances_IntOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_IntOrder.prototype.constructor = $c_Lcats_kernel_instances_IntOrder;
/** @constructor */
function $h_Lcats_kernel_instances_IntOrder() {
}
export { $h_Lcats_kernel_instances_IntOrder as $h_Lcats_kernel_instances_IntOrder };
$h_Lcats_kernel_instances_IntOrder.prototype = $c_Lcats_kernel_instances_IntOrder.prototype;
$c_Lcats_kernel_instances_IntOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_IntOrder.prototype.compare__I__I__I = (function(x, y) {
  return ((x < y) ? (-1) : ((x > y) ? 1 : 0));
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv__I__I__Z = (function(x, y) {
  return (x === y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.neqv__I__I__Z = (function(x, y) {
  return (x !== y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.gt__I__I__Z = (function(x, y) {
  return (x > y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.lt__I__I__Z = (function(x, y) {
  return (x < y);
});
$c_Lcats_kernel_instances_IntOrder.prototype.hash__O__I = (function(x) {
  var x$1 = (x | 0);
  return x$1;
});
$c_Lcats_kernel_instances_IntOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__I__I__I((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_IntOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__I__I__Z((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_IntOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__I__I__Z((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_IntOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__I__I__Z((x | 0), (y | 0));
});
$c_Lcats_kernel_instances_IntOrder.prototype.lt__O__O__Z = (function(x, y) {
  return this.lt__I__I__Z((x | 0), (y | 0));
});
var $d_Lcats_kernel_instances_IntOrder = new $TypeData().initClass($c_Lcats_kernel_instances_IntOrder, "cats.kernel.instances.IntOrder", ({
  Lcats_kernel_instances_IntOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_instances_IntBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_IntEnumerable: 1
}));
export { $d_Lcats_kernel_instances_IntOrder as $d_Lcats_kernel_instances_IntOrder };
/** @constructor */
function $c_Lcats_kernel_instances_LongOrder() {
}
export { $c_Lcats_kernel_instances_LongOrder as $c_Lcats_kernel_instances_LongOrder };
$c_Lcats_kernel_instances_LongOrder.prototype = new $h_O();
$c_Lcats_kernel_instances_LongOrder.prototype.constructor = $c_Lcats_kernel_instances_LongOrder;
/** @constructor */
function $h_Lcats_kernel_instances_LongOrder() {
}
export { $h_Lcats_kernel_instances_LongOrder as $h_Lcats_kernel_instances_LongOrder };
$h_Lcats_kernel_instances_LongOrder.prototype = $c_Lcats_kernel_instances_LongOrder.prototype;
$c_Lcats_kernel_instances_LongOrder.prototype.partialCompare__O__O__D = (function(x, y) {
  return $f_Lcats_kernel_Order__partialCompare__O__O__D(this, x, y);
});
$c_Lcats_kernel_instances_LongOrder.prototype.toOrdering__s_math_Ordering = (function() {
  return new $c_Lcats_kernel_Order$$anon$1(this);
});
$c_Lcats_kernel_instances_LongOrder.prototype.compare__J__J__I = (function(x, y) {
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  if (((ahi === bhi) ? ((x.RTLong__f_lo >>> 0) < (y.RTLong__f_lo >>> 0)) : (ahi < bhi))) {
    return (-1);
  } else {
    var ahi$1 = x.RTLong__f_hi;
    var bhi$1 = y.RTLong__f_hi;
    if (((ahi$1 === bhi$1) ? ((x.RTLong__f_lo >>> 0) > (y.RTLong__f_lo >>> 0)) : (ahi$1 > bhi$1))) {
      return 1;
    } else {
      return 0;
    }
  }
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv__J__J__Z = (function(x, y) {
  return ((x.RTLong__f_lo === y.RTLong__f_lo) && (x.RTLong__f_hi === y.RTLong__f_hi));
});
$c_Lcats_kernel_instances_LongOrder.prototype.neqv__J__J__Z = (function(x, y) {
  return (!((x.RTLong__f_lo === y.RTLong__f_lo) && (x.RTLong__f_hi === y.RTLong__f_hi)));
});
$c_Lcats_kernel_instances_LongOrder.prototype.gt__J__J__Z = (function(x, y) {
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  return ((ahi === bhi) ? ((x.RTLong__f_lo >>> 0) > (y.RTLong__f_lo >>> 0)) : (ahi > bhi));
});
$c_Lcats_kernel_instances_LongOrder.prototype.lt__J__J__Z = (function(x, y) {
  var ahi = x.RTLong__f_hi;
  var bhi = y.RTLong__f_hi;
  return ((ahi === bhi) ? ((x.RTLong__f_lo >>> 0) < (y.RTLong__f_lo >>> 0)) : (ahi < bhi));
});
$c_Lcats_kernel_instances_LongOrder.prototype.hash__O__I = (function(x) {
  var t = $uJ(x);
  var lo = t.RTLong__f_lo;
  var hi = t.RTLong__f_hi;
  return (lo ^ hi);
});
$c_Lcats_kernel_instances_LongOrder.prototype.compare__O__O__I = (function(x, y) {
  return this.compare__J__J__I($uJ(x), $uJ(y));
});
$c_Lcats_kernel_instances_LongOrder.prototype.eqv__O__O__Z = (function(x, y) {
  return this.eqv__J__J__Z($uJ(x), $uJ(y));
});
$c_Lcats_kernel_instances_LongOrder.prototype.neqv__O__O__Z = (function(x, y) {
  return this.neqv__J__J__Z($uJ(x), $uJ(y));
});
$c_Lcats_kernel_instances_LongOrder.prototype.gt__O__O__Z = (function(x, y) {
  return this.gt__J__J__Z($uJ(x), $uJ(y));
});
$c_Lcats_kernel_instances_LongOrder.prototype.lt__O__O__Z = (function(x, y) {
  return this.lt__J__J__Z($uJ(x), $uJ(y));
});
var $d_Lcats_kernel_instances_LongOrder = new $TypeData().initClass($c_Lcats_kernel_instances_LongOrder, "cats.kernel.instances.LongOrder", ({
  Lcats_kernel_instances_LongOrder: 1,
  Ljava_io_Serializable: 1,
  Lcats_kernel_Eq: 1,
  Lcats_kernel_PartialOrder: 1,
  Lcats_kernel_Order: 1,
  Lcats_kernel_Hash: 1,
  Lcats_kernel_UpperBounded: 1,
  Lcats_kernel_LowerBounded: 1,
  Lcats_kernel_instances_LongBounded: 1,
  Lcats_kernel_PartialPrevious: 1,
  Lcats_kernel_PartialNext: 1,
  Lcats_kernel_PartialPreviousUpperBounded: 1,
  Lcats_kernel_PartialNextLowerBounded: 1,
  Lcats_kernel_BoundedEnumerable: 1,
  Lcats_kernel_instances_LongEnumerable: 1
}));
export { $d_Lcats_kernel_instances_LongOrder as $d_Lcats_kernel_instances_LongOrder };
/** @constructor */
function $c_Lcom_raquo_airstream_state_LazyStrictSignal(parentSignal, zoomIn, parentDisplayName, displayNameSuffix) {
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybeDisplayName = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_isSafeToRemoveObserver = false;
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybePendingObserverRemovals = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f__lastUpdateId = 0;
  this.Lcom_raquo_airstream_misc_MapSignal__f_externalObservers = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_internalObservers = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_willStartDone = false;
  this.Lcom_raquo_airstream_misc_MapSignal__f_maybeLastSeenCurrentValue = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_parentIsSignal = false;
  this.Lcom_raquo_airstream_misc_MapSignal__f__parentLastUpdateId = 0;
  this.Lcom_raquo_airstream_misc_MapSignal__f_parent = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_project = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_recover = null;
  this.Lcom_raquo_airstream_misc_MapSignal__f_topoRank = 0;
  this.Lcom_raquo_airstream_state_LazyStrictSignal__f_parentSignal = null;
  this.Lcom_raquo_airstream_state_LazyStrictSignal__f_parentDisplayName = null;
  this.Lcom_raquo_airstream_state_LazyStrictSignal__f_displayNameSuffix = null;
  this.Lcom_raquo_airstream_state_LazyStrictSignal__f_parentSignal = parentSignal;
  this.Lcom_raquo_airstream_state_LazyStrictSignal__f_parentDisplayName = parentDisplayName;
  this.Lcom_raquo_airstream_state_LazyStrictSignal__f_displayNameSuffix = displayNameSuffix;
  $ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(this, parentSignal, zoomIn, $m_s_None$());
}
export { $c_Lcom_raquo_airstream_state_LazyStrictSignal as $c_Lcom_raquo_airstream_state_LazyStrictSignal };
$c_Lcom_raquo_airstream_state_LazyStrictSignal.prototype = new $h_Lcom_raquo_airstream_misc_MapSignal();
$c_Lcom_raquo_airstream_state_LazyStrictSignal.prototype.constructor = $c_Lcom_raquo_airstream_state_LazyStrictSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_state_LazyStrictSignal() {
}
export { $h_Lcom_raquo_airstream_state_LazyStrictSignal as $h_Lcom_raquo_airstream_state_LazyStrictSignal };
$h_Lcom_raquo_airstream_state_LazyStrictSignal.prototype = $c_Lcom_raquo_airstream_state_LazyStrictSignal.prototype;
$c_Lcom_raquo_airstream_state_LazyStrictSignal.prototype.defaultDisplayName__T = (function() {
  return (((("" + this.Lcom_raquo_airstream_state_LazyStrictSignal__f_parentDisplayName.apply__O()) + this.Lcom_raquo_airstream_state_LazyStrictSignal__f_displayNameSuffix) + "@") + $systemIdentityHashCode(this));
});
$c_Lcom_raquo_airstream_state_LazyStrictSignal.prototype.tryNow__s_util_Try = (function() {
  var signal = this.Lcom_raquo_airstream_state_LazyStrictSignal__f_parentSignal;
  var newParentLastUpdateId = signal._lastUpdateId__I();
  if ((newParentLastUpdateId !== this.Lcom_raquo_airstream_misc_MapSignal__f__parentLastUpdateId)) {
    var nextValue = this.currentValueFromParent__s_util_Try();
    $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, newParentLastUpdateId);
    return nextValue;
  } else {
    return $f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
  }
});
$c_Lcom_raquo_airstream_state_LazyStrictSignal.prototype.updateCurrentValueFromParent__s_util_Try__I__V = (function(nextValue, nextParentLastUpdateId) {
  $f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
});
var $d_Lcom_raquo_airstream_state_LazyStrictSignal = new $TypeData().initClass($c_Lcom_raquo_airstream_state_LazyStrictSignal, "com.raquo.airstream.state.LazyStrictSignal", ({
  Lcom_raquo_airstream_state_LazyStrictSignal: 1,
  Lcom_raquo_airstream_misc_MapSignal: 1,
  Lcom_raquo_airstream_core_Source: 1,
  Lcom_raquo_airstream_core_Named: 1,
  Lcom_raquo_airstream_core_BaseObservable: 1,
  Lcom_raquo_airstream_core_Observable: 1,
  Lcom_raquo_airstream_core_Source$SignalSource: 1,
  Lcom_raquo_airstream_dynamicImport_SignalDynamicImportOps: 1,
  Lcom_raquo_airstream_core_Signal: 1,
  Lcom_raquo_airstream_core_WritableObservable: 1,
  Lcom_raquo_airstream_core_WritableSignal: 1,
  Lcom_raquo_airstream_core_InternalObserver: 1,
  Lcom_raquo_airstream_common_InternalTryObserver: 1,
  Lcom_raquo_airstream_common_SingleParentSignal: 1,
  Lcom_raquo_airstream_state_StrictSignal: 1
}));
export { $d_Lcom_raquo_airstream_state_LazyStrictSignal as $d_Lcom_raquo_airstream_state_LazyStrictSignal };
/** @constructor */
function $c_sc_AbstractIndexedSeqView() {
}
export { $c_sc_AbstractIndexedSeqView as $c_sc_AbstractIndexedSeqView };
$c_sc_AbstractIndexedSeqView.prototype = new $h_sc_AbstractSeqView();
$c_sc_AbstractIndexedSeqView.prototype.constructor = $c_sc_AbstractIndexedSeqView;
/** @constructor */
function $h_sc_AbstractIndexedSeqView() {
}
export { $h_sc_AbstractIndexedSeqView as $h_sc_AbstractIndexedSeqView };
$h_sc_AbstractIndexedSeqView.prototype = $c_sc_AbstractIndexedSeqView.prototype;
$c_sc_AbstractIndexedSeqView.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_AbstractIndexedSeqView.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_AbstractIndexedSeqView.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_AbstractIndexedSeqView.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_AbstractIndexedSeqView.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_AbstractIndexedSeqView.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_AbstractIndexedSeqView.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_AbstractIndexedSeqView.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_AbstractIndexedSeqView.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_AbstractIndexedSeqView.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_AbstractIndexedSeqView.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_AbstractIndexedSeqView.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_AbstractIndexedSeqView.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_AbstractIndexedSeqView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_AbstractIndexedSeqView.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_AbstractIndexedSeqView.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_AbstractIndexedSeqView.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
function $ct_sc_MapOps$KeySet__sc_MapOps__($thiz, outer) {
  $thiz.sc_MapOps$KeySet__f_$outer = outer;
  return $thiz;
}
export { $ct_sc_MapOps$KeySet__sc_MapOps__ as $ct_sc_MapOps$KeySet__sc_MapOps__ };
/** @constructor */
function $c_sc_MapOps$KeySet() {
  this.sc_MapOps$KeySet__f_$outer = null;
}
export { $c_sc_MapOps$KeySet as $c_sc_MapOps$KeySet };
$c_sc_MapOps$KeySet.prototype = new $h_sc_AbstractSet();
$c_sc_MapOps$KeySet.prototype.constructor = $c_sc_MapOps$KeySet;
/** @constructor */
function $h_sc_MapOps$KeySet() {
}
export { $h_sc_MapOps$KeySet as $h_sc_MapOps$KeySet };
$h_sc_MapOps$KeySet.prototype = $c_sc_MapOps$KeySet.prototype;
$c_sc_MapOps$KeySet.prototype.iterator__sc_Iterator = (function() {
  return this.sc_MapOps$KeySet__f_$outer.keysIterator__sc_Iterator();
});
$c_sc_MapOps$KeySet.prototype.contains__O__Z = (function(key) {
  return this.sc_MapOps$KeySet__f_$outer.contains__O__Z(key);
});
$c_sc_MapOps$KeySet.prototype.size__I = (function() {
  return this.sc_MapOps$KeySet__f_$outer.size__I();
});
$c_sc_MapOps$KeySet.prototype.knownSize__I = (function() {
  return this.sc_MapOps$KeySet__f_$outer.knownSize__I();
});
$c_sc_MapOps$KeySet.prototype.isEmpty__Z = (function() {
  return this.sc_MapOps$KeySet__f_$outer.isEmpty__Z();
});
var $d_sc_MapOps$KeySet = new $TypeData().initClass($c_sc_MapOps$KeySet, "scala.collection.MapOps$KeySet", ({
  sc_MapOps$KeySet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_MapOps$KeySet as $d_sc_MapOps$KeySet };
/** @constructor */
function $c_sc_MapView$$anon$1() {
}
export { $c_sc_MapView$$anon$1 as $c_sc_MapView$$anon$1 };
$c_sc_MapView$$anon$1.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$$anon$1.prototype.constructor = $c_sc_MapView$$anon$1;
/** @constructor */
function $h_sc_MapView$$anon$1() {
}
export { $h_sc_MapView$$anon$1 as $h_sc_MapView$$anon$1 };
$h_sc_MapView$$anon$1.prototype = $c_sc_MapView$$anon$1.prototype;
$c_sc_MapView$$anon$1.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$();
});
$c_sc_MapView$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sc_MapView$$anon$1.prototype.knownSize__I = (function() {
  return 0;
});
$c_sc_MapView$$anon$1.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sc_MapView$$anon$1.prototype.filter__F1__sc_MapView = (function(pred) {
  return this;
});
$c_sc_MapView$$anon$1.prototype.filter__F1__O = (function(pred) {
  return this;
});
var $d_sc_MapView$$anon$1 = new $TypeData().initClass($c_sc_MapView$$anon$1, "scala.collection.MapView$$anon$1", ({
  sc_MapView$$anon$1: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
export { $d_sc_MapView$$anon$1 as $d_sc_MapView$$anon$1 };
/** @constructor */
function $c_sc_MapView$Filter(underlying, isFlipped, p) {
  this.sc_MapView$Filter__f_underlying = null;
  this.sc_MapView$Filter__f_isFlipped = false;
  this.sc_MapView$Filter__f_p = null;
  this.sc_MapView$Filter__f_underlying = underlying;
  this.sc_MapView$Filter__f_isFlipped = isFlipped;
  this.sc_MapView$Filter__f_p = p;
}
export { $c_sc_MapView$Filter as $c_sc_MapView$Filter };
$c_sc_MapView$Filter.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$Filter.prototype.constructor = $c_sc_MapView$Filter;
/** @constructor */
function $h_sc_MapView$Filter() {
}
export { $h_sc_MapView$Filter as $h_sc_MapView$Filter };
$h_sc_MapView$Filter.prototype = $c_sc_MapView$Filter.prototype;
$c_sc_MapView$Filter.prototype.iterator__sc_Iterator = (function() {
  var this$1 = this.sc_MapView$Filter__f_underlying.iterator__sc_Iterator();
  var p = this.sc_MapView$Filter__f_p;
  var isFlipped = this.sc_MapView$Filter__f_isFlipped;
  return new $c_sc_Iterator$$anon$6(this$1, p, isFlipped);
});
$c_sc_MapView$Filter.prototype.get__O__s_Option = (function(key) {
  var x1 = this.sc_MapView$Filter__f_underlying.get__O__s_Option(key);
  if ((x1 instanceof $c_s_Some)) {
    var v = x1.s_Some__f_value;
    if (((!(!this.sc_MapView$Filter__f_p.apply__O__O($ct_T2__O__O__(new $c_T2(), key, v)))) !== this.sc_MapView$Filter__f_isFlipped)) {
      return x1;
    }
  }
  return $m_s_None$();
});
$c_sc_MapView$Filter.prototype.knownSize__I = (function() {
  return ((this.sc_MapView$Filter__f_underlying.knownSize__I() === 0) ? 0 : (-1));
});
$c_sc_MapView$Filter.prototype.isEmpty__Z = (function() {
  var this$1 = this.iterator__sc_Iterator();
  return (!this$1.hasNext__Z());
});
var $d_sc_MapView$Filter = new $TypeData().initClass($c_sc_MapView$Filter, "scala.collection.MapView$Filter", ({
  sc_MapView$Filter: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
export { $d_sc_MapView$Filter as $d_sc_MapView$Filter };
/** @constructor */
function $c_sc_MapView$Id(underlying) {
  this.sc_MapView$Id__f_underlying = null;
  this.sc_MapView$Id__f_underlying = underlying;
}
export { $c_sc_MapView$Id as $c_sc_MapView$Id };
$c_sc_MapView$Id.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$Id.prototype.constructor = $c_sc_MapView$Id;
/** @constructor */
function $h_sc_MapView$Id() {
}
export { $h_sc_MapView$Id as $h_sc_MapView$Id };
$h_sc_MapView$Id.prototype = $c_sc_MapView$Id.prototype;
$c_sc_MapView$Id.prototype.get__O__s_Option = (function(key) {
  return this.sc_MapView$Id__f_underlying.get__O__s_Option(key);
});
$c_sc_MapView$Id.prototype.iterator__sc_Iterator = (function() {
  return this.sc_MapView$Id__f_underlying.iterator__sc_Iterator();
});
$c_sc_MapView$Id.prototype.knownSize__I = (function() {
  return this.sc_MapView$Id__f_underlying.knownSize__I();
});
$c_sc_MapView$Id.prototype.isEmpty__Z = (function() {
  return this.sc_MapView$Id__f_underlying.isEmpty__Z();
});
var $d_sc_MapView$Id = new $TypeData().initClass($c_sc_MapView$Id, "scala.collection.MapView$Id", ({
  sc_MapView$Id: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
export { $d_sc_MapView$Id as $d_sc_MapView$Id };
/** @constructor */
function $c_sc_MapView$MapValues(underlying, f) {
  this.sc_MapView$MapValues__f_underlying = null;
  this.sc_MapView$MapValues__f_f = null;
  this.sc_MapView$MapValues__f_underlying = underlying;
  this.sc_MapView$MapValues__f_f = f;
}
export { $c_sc_MapView$MapValues as $c_sc_MapView$MapValues };
$c_sc_MapView$MapValues.prototype = new $h_sc_AbstractMapView();
$c_sc_MapView$MapValues.prototype.constructor = $c_sc_MapView$MapValues;
/** @constructor */
function $h_sc_MapView$MapValues() {
}
export { $h_sc_MapView$MapValues as $h_sc_MapView$MapValues };
$h_sc_MapView$MapValues.prototype = $c_sc_MapView$MapValues.prototype;
$c_sc_MapView$MapValues.prototype.iterator__sc_Iterator = (function() {
  var this$2 = this.sc_MapView$MapValues__f_underlying.iterator__sc_Iterator();
  var f = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((kv$2$2) => $ct_T2__O__O__(new $c_T2(), kv$2$2._1__O(), this.sc_MapView$MapValues__f_f.apply__O__O(kv$2$2._2__O()))));
  return new $c_sc_Iterator$$anon$9(this$2, f);
});
$c_sc_MapView$MapValues.prototype.get__O__s_Option = (function(key) {
  var this$1 = this.sc_MapView$MapValues__f_underlying.get__O__s_Option(key);
  var f = this.sc_MapView$MapValues__f_f;
  return (this$1.isEmpty__Z() ? $m_s_None$() : new $c_s_Some(f.apply__O__O(this$1.get__O())));
});
$c_sc_MapView$MapValues.prototype.knownSize__I = (function() {
  return this.sc_MapView$MapValues__f_underlying.knownSize__I();
});
$c_sc_MapView$MapValues.prototype.isEmpty__Z = (function() {
  return this.sc_MapView$MapValues__f_underlying.isEmpty__Z();
});
var $d_sc_MapView$MapValues = new $TypeData().initClass($c_sc_MapView$MapValues, "scala.collection.MapView$MapValues", ({
  sc_MapView$MapValues: 1,
  sc_AbstractMapView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_MapView: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1
}));
export { $d_sc_MapView$MapValues as $d_sc_MapView$MapValues };
/** @constructor */
function $c_sci_AbstractSet() {
}
export { $c_sci_AbstractSet as $c_sci_AbstractSet };
$c_sci_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_sci_AbstractSet.prototype.constructor = $c_sci_AbstractSet;
/** @constructor */
function $h_sci_AbstractSet() {
}
export { $h_sci_AbstractSet as $h_sci_AbstractSet };
$h_sci_AbstractSet.prototype = $c_sci_AbstractSet.prototype;
$c_sci_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Set$();
});
$c_sci_AbstractSet.prototype.removedAll__sc_IterableOnce__sci_SetOps = (function(that) {
  return $f_sci_SetOps__removedAll__sc_IterableOnce__sci_SetOps(this, that);
});
function $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__($thiz, underlying, elem) {
  $ct_sc_SeqView$Appended__sc_SeqOps__O__($thiz, underlying, elem);
  return $thiz;
}
export { $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__ as $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__ };
/** @constructor */
function $c_sc_IndexedSeqView$Appended() {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null;
  this.sc_SeqView$Appended__f_underlying = null;
  this.sc_SeqView$Appended__f_elem = null;
}
export { $c_sc_IndexedSeqView$Appended as $c_sc_IndexedSeqView$Appended };
$c_sc_IndexedSeqView$Appended.prototype = new $h_sc_SeqView$Appended();
$c_sc_IndexedSeqView$Appended.prototype.constructor = $c_sc_IndexedSeqView$Appended;
/** @constructor */
function $h_sc_IndexedSeqView$Appended() {
}
export { $h_sc_IndexedSeqView$Appended as $h_sc_IndexedSeqView$Appended };
$h_sc_IndexedSeqView$Appended.prototype = $c_sc_IndexedSeqView$Appended.prototype;
$c_sc_IndexedSeqView$Appended.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Appended.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Appended.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Appended.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Appended.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Appended.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Appended.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Appended.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Appended.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Appended.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Appended.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Appended.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Appended.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Appended.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Appended.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Appended.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Appended.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Appended.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Appended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Appended.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Appended.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$Appended = new $TypeData().initClass($c_sc_IndexedSeqView$Appended, "scala.collection.IndexedSeqView$Appended", ({
  sc_IndexedSeqView$Appended: 1,
  sc_SeqView$Appended: 1,
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
export { $d_sc_IndexedSeqView$Appended as $d_sc_IndexedSeqView$Appended };
function $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Drop__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
export { $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__ as $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__ };
/** @constructor */
function $c_sc_IndexedSeqView$Drop() {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
}
export { $c_sc_IndexedSeqView$Drop as $c_sc_IndexedSeqView$Drop };
$c_sc_IndexedSeqView$Drop.prototype = new $h_sc_SeqView$Drop();
$c_sc_IndexedSeqView$Drop.prototype.constructor = $c_sc_IndexedSeqView$Drop;
/** @constructor */
function $h_sc_IndexedSeqView$Drop() {
}
export { $h_sc_IndexedSeqView$Drop as $h_sc_IndexedSeqView$Drop };
$h_sc_IndexedSeqView$Drop.prototype = $c_sc_IndexedSeqView$Drop.prototype;
$c_sc_IndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Drop.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Drop.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Drop.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Drop.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Drop.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Drop.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Drop.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Drop.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Drop.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Drop.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Drop.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Drop.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Drop.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$Drop = new $TypeData().initClass($c_sc_IndexedSeqView$Drop, "scala.collection.IndexedSeqView$Drop", ({
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
export { $d_sc_IndexedSeqView$Drop as $d_sc_IndexedSeqView$Drop };
function $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$DropRight__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
export { $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__ as $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__ };
/** @constructor */
function $c_sc_IndexedSeqView$DropRight() {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0;
}
export { $c_sc_IndexedSeqView$DropRight as $c_sc_IndexedSeqView$DropRight };
$c_sc_IndexedSeqView$DropRight.prototype = new $h_sc_SeqView$DropRight();
$c_sc_IndexedSeqView$DropRight.prototype.constructor = $c_sc_IndexedSeqView$DropRight;
/** @constructor */
function $h_sc_IndexedSeqView$DropRight() {
}
export { $h_sc_IndexedSeqView$DropRight as $h_sc_IndexedSeqView$DropRight };
$h_sc_IndexedSeqView$DropRight.prototype = $c_sc_IndexedSeqView$DropRight.prototype;
$c_sc_IndexedSeqView$DropRight.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$DropRight.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$DropRight.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$DropRight.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$DropRight.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$DropRight.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$DropRight.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$DropRight.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$DropRight.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$DropRight.prototype.lengthCompare__I__I = (function(len) {
  var x = this.sc_SeqView$DropRight__f_len;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$DropRight.prototype.knownSize__I = (function() {
  return this.sc_SeqView$DropRight__f_len;
});
$c_sc_IndexedSeqView$DropRight.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$DropRight.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$DropRight.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$DropRight.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$DropRight = new $TypeData().initClass($c_sc_IndexedSeqView$DropRight, "scala.collection.IndexedSeqView$DropRight", ({
  sc_IndexedSeqView$DropRight: 1,
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
export { $d_sc_IndexedSeqView$DropRight as $d_sc_IndexedSeqView$DropRight };
/** @constructor */
function $c_sc_IndexedSeqView$Id(underlying) {
  this.sc_SeqView$Id__f_underlying = null;
  $ct_sc_SeqView$Id__sc_SeqOps__(this, underlying);
}
export { $c_sc_IndexedSeqView$Id as $c_sc_IndexedSeqView$Id };
$c_sc_IndexedSeqView$Id.prototype = new $h_sc_SeqView$Id();
$c_sc_IndexedSeqView$Id.prototype.constructor = $c_sc_IndexedSeqView$Id;
/** @constructor */
function $h_sc_IndexedSeqView$Id() {
}
export { $h_sc_IndexedSeqView$Id as $h_sc_IndexedSeqView$Id };
$h_sc_IndexedSeqView$Id.prototype = $c_sc_IndexedSeqView$Id.prototype;
$c_sc_IndexedSeqView$Id.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Id.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Id.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Id.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Id.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Id.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Id.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Id.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Id.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Id.prototype.reverse__O = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__sc_SeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Id.prototype.map__F1__O = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Id.prototype.dropRight__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.dropRight__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.drop__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.take__I__sc_SeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.take__I__O = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Id.prototype.appended__O__O = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Id.prototype.appended__O__sc_SeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
var $d_sc_IndexedSeqView$Id = new $TypeData().initClass($c_sc_IndexedSeqView$Id, "scala.collection.IndexedSeqView$Id", ({
  sc_IndexedSeqView$Id: 1,
  sc_SeqView$Id: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
export { $d_sc_IndexedSeqView$Id as $d_sc_IndexedSeqView$Id };
function $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__($thiz, underlying, f) {
  $ct_sc_SeqView$Map__sc_SeqOps__F1__($thiz, underlying, f);
  return $thiz;
}
export { $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__ as $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__ };
/** @constructor */
function $c_sc_IndexedSeqView$Map() {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
}
export { $c_sc_IndexedSeqView$Map as $c_sc_IndexedSeqView$Map };
$c_sc_IndexedSeqView$Map.prototype = new $h_sc_SeqView$Map();
$c_sc_IndexedSeqView$Map.prototype.constructor = $c_sc_IndexedSeqView$Map;
/** @constructor */
function $h_sc_IndexedSeqView$Map() {
}
export { $h_sc_IndexedSeqView$Map as $h_sc_IndexedSeqView$Map };
$h_sc_IndexedSeqView$Map.prototype = $c_sc_IndexedSeqView$Map.prototype;
$c_sc_IndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Map.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Map.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Map.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Map.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Map.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Map.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Map.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Map.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Map.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Map.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Map.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Map.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Map.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Map.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$Map = new $TypeData().initClass($c_sc_IndexedSeqView$Map, "scala.collection.IndexedSeqView$Map", ({
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
export { $d_sc_IndexedSeqView$Map as $d_sc_IndexedSeqView$Map };
/** @constructor */
function $c_sc_IndexedSeqView$Prepended(elem, underlying) {
  this.sc_View$Prepended__f_elem = null;
  this.sc_View$Prepended__f_underlying = null;
  this.sc_SeqView$Prepended__f_elem = null;
  this.sc_SeqView$Prepended__f_underlying = null;
  $ct_sc_SeqView$Prepended__O__sc_SeqOps__(this, elem, underlying);
}
export { $c_sc_IndexedSeqView$Prepended as $c_sc_IndexedSeqView$Prepended };
$c_sc_IndexedSeqView$Prepended.prototype = new $h_sc_SeqView$Prepended();
$c_sc_IndexedSeqView$Prepended.prototype.constructor = $c_sc_IndexedSeqView$Prepended;
/** @constructor */
function $h_sc_IndexedSeqView$Prepended() {
}
export { $h_sc_IndexedSeqView$Prepended as $h_sc_IndexedSeqView$Prepended };
$h_sc_IndexedSeqView$Prepended.prototype = $c_sc_IndexedSeqView$Prepended.prototype;
$c_sc_IndexedSeqView$Prepended.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Prepended.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Prepended.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Prepended.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Prepended.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Prepended.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Prepended.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Prepended.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Prepended.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Prepended.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Prepended.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Prepended.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Prepended.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Prepended.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Prepended.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Prepended.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Prepended.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Prepended.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Prepended.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Prepended.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Prepended.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$Prepended = new $TypeData().initClass($c_sc_IndexedSeqView$Prepended, "scala.collection.IndexedSeqView$Prepended", ({
  sc_IndexedSeqView$Prepended: 1,
  sc_SeqView$Prepended: 1,
  sc_View$Prepended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
export { $d_sc_IndexedSeqView$Prepended as $d_sc_IndexedSeqView$Prepended };
function $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__($thiz, underlying) {
  $thiz.sc_IndexedSeqView$Reverse__f_underlying = underlying;
  $ct_sc_SeqView$Reverse__sc_SeqOps__($thiz, underlying);
  return $thiz;
}
export { $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__ as $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__ };
/** @constructor */
function $c_sc_IndexedSeqView$Reverse() {
  this.sc_SeqView$Reverse__f_underlying = null;
  this.sc_IndexedSeqView$Reverse__f_underlying = null;
}
export { $c_sc_IndexedSeqView$Reverse as $c_sc_IndexedSeqView$Reverse };
$c_sc_IndexedSeqView$Reverse.prototype = new $h_sc_SeqView$Reverse();
$c_sc_IndexedSeqView$Reverse.prototype.constructor = $c_sc_IndexedSeqView$Reverse;
/** @constructor */
function $h_sc_IndexedSeqView$Reverse() {
}
export { $h_sc_IndexedSeqView$Reverse as $h_sc_IndexedSeqView$Reverse };
$h_sc_IndexedSeqView$Reverse.prototype = $c_sc_IndexedSeqView$Reverse.prototype;
$c_sc_IndexedSeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Reverse.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Reverse.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Reverse.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Reverse.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Reverse.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Reverse.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Reverse.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Reverse.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Reverse.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Reverse.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Reverse.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Reverse.prototype.reverse__sc_IndexedSeqView = (function() {
  var x1 = this.sc_IndexedSeqView$Reverse__f_underlying;
  return ($is_sc_IndexedSeqView(x1) ? x1 : $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this));
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Reverse.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Reverse.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Reverse.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Reverse.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Reverse.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
var $d_sc_IndexedSeqView$Reverse = new $TypeData().initClass($c_sc_IndexedSeqView$Reverse, "scala.collection.IndexedSeqView$Reverse", ({
  sc_IndexedSeqView$Reverse: 1,
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
export { $d_sc_IndexedSeqView$Reverse as $d_sc_IndexedSeqView$Reverse };
function $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__($thiz, underlying, n) {
  $ct_sc_SeqView$Take__sc_SeqOps__I__($thiz, underlying, n);
  return $thiz;
}
export { $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__ as $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__ };
/** @constructor */
function $c_sc_IndexedSeqView$Take() {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0;
}
export { $c_sc_IndexedSeqView$Take as $c_sc_IndexedSeqView$Take };
$c_sc_IndexedSeqView$Take.prototype = new $h_sc_SeqView$Take();
$c_sc_IndexedSeqView$Take.prototype.constructor = $c_sc_IndexedSeqView$Take;
/** @constructor */
function $h_sc_IndexedSeqView$Take() {
}
export { $h_sc_IndexedSeqView$Take as $h_sc_IndexedSeqView$Take };
$h_sc_IndexedSeqView$Take.prototype = $c_sc_IndexedSeqView$Take.prototype;
$c_sc_IndexedSeqView$Take.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this);
});
$c_sc_IndexedSeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this);
});
$c_sc_IndexedSeqView$Take.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(new $c_sc_IndexedSeqView$Appended(), this, elem);
});
$c_sc_IndexedSeqView$Take.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Take(), this, n);
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$Drop(), this, n);
});
$c_sc_IndexedSeqView$Take.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(new $c_sc_IndexedSeqView$DropRight(), this, n);
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(new $c_sc_IndexedSeqView$Map(), this, f);
});
$c_sc_IndexedSeqView$Take.prototype.reverse__sc_IndexedSeqView = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Take.prototype.stringPrefix__T = (function() {
  return "IndexedSeqView";
});
$c_sc_IndexedSeqView$Take.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sc_IndexedSeqView$Take.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sc_IndexedSeqView$Take.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sc_IndexedSeqView$Take.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sc_IndexedSeqView$Take.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sc_IndexedSeqView$Take.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sc_IndexedSeqView$Take.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Take.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_sc_IndexedSeqView$Take.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_sc_IndexedSeqView$Take.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_sc_IndexedSeqView$Take.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_sc_IndexedSeqView$Take = new $TypeData().initClass($c_sc_IndexedSeqView$Take, "scala.collection.IndexedSeqView$Take", ({
  sc_IndexedSeqView$Take: 1,
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
export { $d_sc_IndexedSeqView$Take as $d_sc_IndexedSeqView$Take };
/** @constructor */
function $c_sci_AbstractSeq() {
}
export { $c_sci_AbstractSeq as $c_sci_AbstractSeq };
$c_sci_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_sci_AbstractSeq.prototype.constructor = $c_sci_AbstractSeq;
/** @constructor */
function $h_sci_AbstractSeq() {
}
export { $h_sci_AbstractSeq as $h_sci_AbstractSeq };
$h_sci_AbstractSeq.prototype = $c_sci_AbstractSeq.prototype;
$c_sci_AbstractSeq.prototype.toSeq__sci_Seq = (function() {
  return this;
});
/** @constructor */
function $c_scm_ArrayBufferView(underlying, mutationCount) {
  this.scm_ArrayBufferView__f_underlying = null;
  this.scm_ArrayBufferView__f_mutationCount = null;
  this.scm_ArrayBufferView__f_underlying = underlying;
  this.scm_ArrayBufferView__f_mutationCount = mutationCount;
}
export { $c_scm_ArrayBufferView as $c_scm_ArrayBufferView };
$c_scm_ArrayBufferView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_scm_ArrayBufferView.prototype.constructor = $c_scm_ArrayBufferView;
/** @constructor */
function $h_scm_ArrayBufferView() {
}
export { $h_scm_ArrayBufferView as $h_scm_ArrayBufferView };
$h_scm_ArrayBufferView.prototype = $c_scm_ArrayBufferView.prototype;
$c_scm_ArrayBufferView.prototype.apply__I__O = (function(n) {
  return this.scm_ArrayBufferView__f_underlying.apply__I__O(n);
});
$c_scm_ArrayBufferView.prototype.length__I = (function() {
  var this$1 = this.scm_ArrayBufferView__f_underlying;
  return this$1.scm_ArrayBuffer__f_size0;
});
$c_scm_ArrayBufferView.prototype.className__T = (function() {
  return "ArrayBufferView";
});
$c_scm_ArrayBufferView.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_ArrayBufferView__f_mutationCount);
});
$c_scm_ArrayBufferView.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
$c_scm_ArrayBufferView.prototype.map__F1__sc_SeqView = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_scm_ArrayBufferView.prototype.map__F1__O = (function(f) {
  return this.map__F1__sc_IndexedSeqView(f);
});
$c_scm_ArrayBufferView.prototype.dropRight__I__sc_SeqView = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.drop__I__sc_SeqView = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.drop__I__O = (function(n) {
  return this.drop__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.take__I__sc_SeqView = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.take__I__O = (function(n) {
  return this.take__I__sc_IndexedSeqView(n);
});
$c_scm_ArrayBufferView.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
$c_scm_ArrayBufferView.prototype.appended__O__sc_SeqView = (function(elem) {
  return this.appended__O__sc_IndexedSeqView(elem);
});
var $d_scm_ArrayBufferView = new $TypeData().initClass($c_scm_ArrayBufferView, "scala.collection.mutable.ArrayBufferView", ({
  scm_ArrayBufferView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1
}));
export { $d_scm_ArrayBufferView as $d_scm_ArrayBufferView };
/** @constructor */
function $c_scm_LinkedHashMap$LinkedKeySet(outer) {
  this.sc_MapOps$KeySet__f_$outer = null;
  $ct_sc_MapOps$KeySet__sc_MapOps__(this, outer);
}
export { $c_scm_LinkedHashMap$LinkedKeySet as $c_scm_LinkedHashMap$LinkedKeySet };
$c_scm_LinkedHashMap$LinkedKeySet.prototype = new $h_sc_MapOps$KeySet();
$c_scm_LinkedHashMap$LinkedKeySet.prototype.constructor = $c_scm_LinkedHashMap$LinkedKeySet;
/** @constructor */
function $h_scm_LinkedHashMap$LinkedKeySet() {
}
export { $h_scm_LinkedHashMap$LinkedKeySet as $h_scm_LinkedHashMap$LinkedKeySet };
$h_scm_LinkedHashMap$LinkedKeySet.prototype = $c_scm_LinkedHashMap$LinkedKeySet.prototype;
$c_scm_LinkedHashMap$LinkedKeySet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_LinkedHashSet$();
});
var $d_scm_LinkedHashMap$LinkedKeySet = new $TypeData().initClass($c_scm_LinkedHashMap$LinkedKeySet, "scala.collection.mutable.LinkedHashMap$LinkedKeySet", ({
  scm_LinkedHashMap$LinkedKeySet: 1,
  sc_MapOps$KeySet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_LinkedHashMap$LinkedKeySet as $d_scm_LinkedHashMap$LinkedKeySet };
function $f_Lcom_raquo_laminar_api_Laminar__$init$__V($thiz) {
  $thiz.Lcom_raquo_laminar_api_package$$anon$1__f_documentEventProps = new $c_Lcom_raquo_laminar_api_Laminar$$anon$1();
  $thiz.Lcom_raquo_laminar_api_package$$anon$1__f_windowEventProps = new $c_Lcom_raquo_laminar_api_Laminar$$anon$2();
  $thiz.Lcom_raquo_laminar_api_package$$anon$1__f_emptyMod = $thiz.Lcom_raquo_laminar_api_package$$anon$1__f_Modifier.Lcom_raquo_laminar_modifiers_Modifier$__f_empty;
  $thiz.Lcom_raquo_laminar_api_package$$anon$1__f_child = $m_Lcom_raquo_laminar_receivers_ChildReceiver$();
  $thiz.Lcom_raquo_laminar_api_package$$anon$1__f_children = $m_Lcom_raquo_laminar_receivers_ChildrenReceiver$();
}
export { $f_Lcom_raquo_laminar_api_Laminar__$init$__V as $f_Lcom_raquo_laminar_api_Laminar__$init$__V };
function $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_tags_SvgTag__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, element, assertTag) {
  var this$1 = $m_Lcom_raquo_laminar_domapi_DomApi$();
  var goodElement = $f_Lcom_raquo_laminar_domapi_DomTags__assertTagMatches__Lcom_raquo_laminar_tags_Tag__Lorg_scalajs_dom_Node__T__Lorg_scalajs_dom_Element(this$1, assertTag, element, "Unable to init foreign SVG element");
  return new $c_Lcom_raquo_laminar_nodes_ReactiveSvgElement(assertTag, goodElement);
}
export { $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_tags_SvgTag__Lcom_raquo_laminar_nodes_ReactiveSvgElement as $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_tags_SvgTag__Lcom_raquo_laminar_nodes_ReactiveSvgElement };
function $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lorg_scalajs_dom_SVGElement__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, element) {
  var tag = new $c_Lcom_raquo_laminar_tags_SvgTag($m_Lcom_raquo_laminar_nodes_ReactiveElement$().normalizeTagName__Lorg_scalajs_dom_Element__T(element), false);
  return $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lorg_scalajs_dom_Element__Lcom_raquo_laminar_tags_SvgTag__Lcom_raquo_laminar_nodes_ReactiveSvgElement($thiz, element, tag);
}
export { $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lorg_scalajs_dom_SVGElement__Lcom_raquo_laminar_nodes_ReactiveSvgElement as $f_Lcom_raquo_laminar_api_Laminar__foreignSvgElement__Lorg_scalajs_dom_SVGElement__Lcom_raquo_laminar_nodes_ReactiveSvgElement };
/** @constructor */
function $c_sci_AbstractMap() {
}
export { $c_sci_AbstractMap as $c_sci_AbstractMap };
$c_sci_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_sci_AbstractMap.prototype.constructor = $c_sci_AbstractMap;
/** @constructor */
function $h_sci_AbstractMap() {
}
export { $h_sci_AbstractMap as $h_sci_AbstractMap };
$h_sci_AbstractMap.prototype = $c_sci_AbstractMap.prototype;
$c_sci_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_Map$();
});
$c_sci_AbstractMap.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sci_AbstractMap.prototype.removedAll__sc_IterableOnce__sci_MapOps = (function(keys) {
  return $f_sci_MapOps__removedAll__sc_IterableOnce__sci_MapOps(this, keys);
});
$c_sci_AbstractMap.prototype.$plus__T2__sci_MapOps = (function(kv) {
  return this.updated__O__O__sci_MapOps(kv._1__O(), kv._2__O());
});
$c_sci_AbstractMap.prototype.keySet__sci_Set = (function() {
  return $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(new $c_sci_MapOps$ImmutableKeySet(), this);
});
$c_sci_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Iterable$();
});
$c_sci_AbstractMap.prototype.coll__sci_MapOps = (function() {
  return this;
});
$c_sci_AbstractMap.prototype.keySet__sc_Set = (function() {
  return this.keySet__sci_Set();
});
function $f_sci_IndexedSeq__canEqual__O__Z($thiz, that) {
  return ((!$is_sci_IndexedSeq(that)) || ($thiz.length__I() === that.length__I()));
}
export { $f_sci_IndexedSeq__canEqual__O__Z as $f_sci_IndexedSeq__canEqual__O__Z };
function $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z($thiz, o) {
  if ($is_sci_IndexedSeq(o)) {
    if (($thiz === o)) {
      return true;
    } else {
      var length = $thiz.length__I();
      var equal = (length === o.length__I());
      if (equal) {
        var index = 0;
        var a = $thiz.applyPreferredMaxLength__I();
        var b = o.applyPreferredMaxLength__I();
        var preferredLength = ((a < b) ? a : b);
        var hi = (length >> 31);
        var hi$1 = (preferredLength >> 31);
        var lo = (preferredLength << 1);
        var hi$2 = (((preferredLength >>> 31) | 0) | (hi$1 << 1));
        if (((hi === hi$2) ? ((length >>> 0) > (lo >>> 0)) : (hi > hi$2))) {
          var maxApplyCompare = preferredLength;
        } else {
          var maxApplyCompare = length;
        }
        while (((index < maxApplyCompare) && equal)) {
          equal = $m_sr_BoxesRunTime$().equals__O__O__Z($thiz.apply__I__O(index), o.apply__I__O(index));
          index = ((1 + index) | 0);
        }
        if (((index < length) && equal)) {
          var thisIt = $thiz.iterator__sc_Iterator().drop__I__sc_Iterator(index);
          var thatIt = o.iterator__sc_Iterator().drop__I__sc_Iterator(index);
          while ((equal && thisIt.hasNext__Z())) {
            equal = $m_sr_BoxesRunTime$().equals__O__O__Z(thisIt.next__O(), thatIt.next__O());
          }
        }
      }
      return equal;
    }
  } else {
    return $f_sc_SeqOps__sameElements__sc_IterableOnce__Z($thiz, o);
  }
}
export { $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z as $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z };
function $is_sci_IndexedSeq(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.sci_IndexedSeq)));
}
export { $is_sci_IndexedSeq as $is_sci_IndexedSeq };
function $isArrayOf_sci_IndexedSeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_IndexedSeq)));
}
export { $isArrayOf_sci_IndexedSeq as $isArrayOf_sci_IndexedSeq };
/** @constructor */
function $c_sci_Set$EmptySet$() {
}
export { $c_sci_Set$EmptySet$ as $c_sci_Set$EmptySet$ };
$c_sci_Set$EmptySet$.prototype = new $h_sci_AbstractSet();
$c_sci_Set$EmptySet$.prototype.constructor = $c_sci_Set$EmptySet$;
/** @constructor */
function $h_sci_Set$EmptySet$() {
}
export { $h_sci_Set$EmptySet$ as $h_sci_Set$EmptySet$ };
$h_sci_Set$EmptySet$.prototype = $c_sci_Set$EmptySet$.prototype;
$c_sci_Set$EmptySet$.prototype.size__I = (function() {
  return 0;
});
$c_sci_Set$EmptySet$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sci_Set$EmptySet$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Set$EmptySet$.prototype.subsetOf__sc_Set__Z = (function(that) {
  return true;
});
$c_sci_Set$EmptySet$.prototype.contains__O__Z = (function(elem) {
  return false;
});
$c_sci_Set$EmptySet$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Set$EmptySet$.prototype.foreach__F1__V = (function(f) {
});
$c_sci_Set$EmptySet$.prototype.excl__O__sci_SetOps = (function(elem) {
  return this;
});
$c_sci_Set$EmptySet$.prototype.incl__O__sci_SetOps = (function(elem) {
  return new $c_sci_Set$Set1(elem);
});
$c_sci_Set$EmptySet$.prototype.removedAll__sc_IterableOnce__sci_SetOps = (function(that) {
  return this;
});
$c_sci_Set$EmptySet$.prototype.filter__F1__O = (function(pred) {
  return this;
});
var $d_sci_Set$EmptySet$ = new $TypeData().initClass($c_sci_Set$EmptySet$, "scala.collection.immutable.Set$EmptySet$", ({
  sci_Set$EmptySet$: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Set$EmptySet$ as $d_sci_Set$EmptySet$ };
var $n_sci_Set$EmptySet$;
function $m_sci_Set$EmptySet$() {
  if ((!$n_sci_Set$EmptySet$)) {
    $n_sci_Set$EmptySet$ = new $c_sci_Set$EmptySet$();
  }
  return $n_sci_Set$EmptySet$;
}
export { $m_sci_Set$EmptySet$ as $m_sci_Set$EmptySet$ };
/** @constructor */
function $c_Lcats_NonEmptyAlternative$$anon$1(evidence$1$1, outer) {
  this.Lcats_NonEmptyAlternative$$anon$1__f_F = null;
  this.Lcats_NonEmptyAlternative$$anon$1__f_G = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_NonEmptyAlternative$$anon$1__f_F = outer;
  this.Lcats_NonEmptyAlternative$$anon$1__f_G = evidence$1$1;
}
export { $c_Lcats_NonEmptyAlternative$$anon$1 as $c_Lcats_NonEmptyAlternative$$anon$1 };
$c_Lcats_NonEmptyAlternative$$anon$1.prototype = new $h_O();
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.constructor = $c_Lcats_NonEmptyAlternative$$anon$1;
/** @constructor */
function $h_Lcats_NonEmptyAlternative$$anon$1() {
}
export { $h_Lcats_NonEmptyAlternative$$anon$1 as $h_Lcats_NonEmptyAlternative$$anon$1 };
$h_Lcats_NonEmptyAlternative$$anon$1.prototype = $c_Lcats_NonEmptyAlternative$$anon$1.prototype;
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_Apply__productL__O__O__O(this, fa, fb);
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.unit__O = (function() {
  return $f_Lcats_ComposedApplicative__pure__O__O(this, (void 0));
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this);
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.imap__O__F1__F1__O = (function(fga, f, g) {
  return $f_Lcats_ComposedInvariant__imap__O__F1__F1__O(this, fga, f, g);
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.map__O__F1__O = (function(fga, f) {
  return $f_Lcats_ComposedFunctor__map__O__F1__O(this, fga, f);
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.ap__O__O__O = (function(fgf, fga) {
  return $f_Lcats_ComposedApply__ap__O__O__O(this, fgf, fga);
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.product__O__O__O = (function(fga, fgb) {
  return $f_Lcats_ComposedApply__product__O__O__O(this, fga, fgb);
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.pure__O__O = (function(x) {
  return $f_Lcats_ComposedApplicative__pure__O__O(this, x);
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.Lcats_NonEmptyAlternative$$anon$1__f_F.combineK__O__O__O(x, y);
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.G__Lcats_Applicative = (function() {
  return this.Lcats_NonEmptyAlternative$$anon$1__f_G;
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.F__Lcats_Applicative = (function() {
  return this.Lcats_NonEmptyAlternative$$anon$1__f_F;
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.F__Lcats_Apply = (function() {
  return this.Lcats_NonEmptyAlternative$$anon$1__f_F;
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.F__Lcats_Functor = (function() {
  return this.Lcats_NonEmptyAlternative$$anon$1__f_F;
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.F__Lcats_Invariant = (function() {
  return this.Lcats_NonEmptyAlternative$$anon$1__f_F;
});
$c_Lcats_NonEmptyAlternative$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_NonEmptyAlternative$$anon$1(evidence$1, this);
});
var $d_Lcats_NonEmptyAlternative$$anon$1 = new $TypeData().initClass($c_Lcats_NonEmptyAlternative$$anon$1, "cats.NonEmptyAlternative$$anon$1", ({
  Lcats_NonEmptyAlternative$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_ComposedInvariant: 1,
  Lcats_ComposedFunctor: 1,
  Lcats_ComposedApply: 1,
  Lcats_ComposedApplicative: 1,
  Lcats_ComposedSemigroupK: 1,
  Lcats_ComposedNonEmptyAlternative: 1
}));
export { $d_Lcats_NonEmptyAlternative$$anon$1 as $d_Lcats_NonEmptyAlternative$$anon$1 };
/** @constructor */
function $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(m) {
  this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m = null;
  this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m = m;
}
export { $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq as $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq };
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype = new $h_O();
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.constructor = $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq;
/** @constructor */
function $h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq() {
}
export { $h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq as $h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq };
$h_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype = $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype;
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.min__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.lastOption__s_Option = (function() {
  return $f_sc_IterableOps__lastOption__s_Option(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_IterableOps__filter__F1__O(this, pred);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_IterableOps__filterNot__F1__O(this, pred);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_IterableOps__partition__F1__T2(this, p);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_IterableOps__flatMap__F1__O(this, f);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.flatten__F1__O = (function(asIterable) {
  return $f_sc_IterableOps__flatMap__F1__O(this, asIterable);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_IndexedSeq$().newBuilder__scm_Builder();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.className__T = (function() {
  return "IndexedSeq";
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.appended__O__O = (function(elem) {
  return $f_sc_SeqOps__appended__O__O(this, elem);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.size__I = (function() {
  return this.length__I();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_SeqOps__distinctBy__F1__O(this, f);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_Iterator__indexWhere__F1__I__I(this.iterator__sc_Iterator(), p, from);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_SeqOps__diff__sc_Seq__O(this, that);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sc_SeqOps__updated__I__O__O(this, index, elem);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toSeq__sci_Seq = (function() {
  return this;
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.foldRight__O__F2__O = (function(z, op) {
  return $p_sc_IndexedSeqOps__foldr__I__I__O__F2__O(this, 0, this.length__I(), z, op);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.prepended__O__O = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength;
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.length__I = (function() {
  return this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m.length__I();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply__I__O = (function(i) {
  return this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m.apply__I__O(i);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.iterator__sc_Iterator = (function() {
  return this.Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq__f_m.iterator__sc_Iterator();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O((v1 | 0));
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = (x | 0);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_IndexedSeq$();
  return this$1.from__sc_IterableOnce__sci_IndexedSeq(coll);
});
$c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!this.apply__I__O(v1)));
});
var $d_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq = new $TypeData().initClass($c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq, "cats.kernel.instances.StaticMethods$WrappedIndexedSeq", ({
  Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq: 1,
  sc_IterableOnce: 1,
  sc_IterableOnceOps: 1,
  sc_IterableOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Iterable: 1,
  sci_Iterable: 1,
  F1: 1,
  s_PartialFunction: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sc_Seq: 1,
  sci_SeqOps: 1,
  sci_Seq: 1,
  sc_IndexedSeqOps: 1,
  sc_IndexedSeq: 1,
  sci_IndexedSeqOps: 1,
  sci_IndexedSeq: 1
}));
export { $d_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq as $d_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq };
/** @constructor */
function $c_Lcom_raquo_laminar_api_package$$anon$1() {
  this.Lcom_raquo_laminar_api_package$$anon$1__f_img$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_imgbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_footerTag$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_footerTagbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_h1$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_h1bitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_h2$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_h2bitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_h3$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_h3bitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_h4$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_h4bitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_a$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_abitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_strong$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_strongbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_code$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_codebitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_span$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_spanbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_form$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_formbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_label$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_labelbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_input$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_inputbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_button$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_buttonbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_select$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_selectbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_option$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_optionbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_textArea$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_textAreabitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_p$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_pbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_pre$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_prebitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_ul$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_ulbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_li$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_libitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_div$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_divbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_table$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_tablebitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_tbody$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_tbodybitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_thead$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_theadbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_tr$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_trbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_td$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_tdbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_th$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_thbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_timeTag$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_timeTagbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_dialogTag$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_dialogTagbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_idAttr$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_idAttrbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_tabIndex$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_tabIndexbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_href$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_hrefbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_maxAttr$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_maxAttrbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_minAttr$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_minAttrbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_src$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_srcbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_stepAttr$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_stepAttrbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_type$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_typebitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_typ$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_typbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_tpe$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_tpebitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_checked$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_checkedbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_value$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_valuebitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_disabled$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_disabledbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_forId$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_forIdbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_inputMode$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_inputModebitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_method$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_methodbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_nameAttr$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_nameAttrbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_placeholder$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_placeholderbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_target$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_targetbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_title$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_titlebitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onClick$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onClickbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onChange$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onChangebitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onInput$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onInputbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onFocus$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onFocusbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onSubmit$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onSubmitbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onKeyDown$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_onKeyDownbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_zIndex$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_zIndexbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_className = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_cls = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_role$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_rolebitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_AirstreamError = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_EventBus = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_Var = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_Modifier = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_Binder = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_StringValueMapper$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_StringValueMapperbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqValueMapper$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqValueMapperbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqSeqValueMapper$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqSeqValueMapperbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_aria$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_ariabitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_svg$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_svgbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_documentEventProps = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_windowEventProps = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_unsafeWindowOwner$lzy1 = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_unsafeWindowOwnerbitmap$1 = false;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_emptyMod = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_child = null;
  this.Lcom_raquo_laminar_api_package$$anon$1__f_children = null;
  $f_Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys__$init$__V(this);
  $f_Lcom_raquo_laminar_api_MountHooks__$init$__V(this);
  $f_Lcom_raquo_laminar_api_AirstreamAliases__$init$__V(this);
  $f_Lcom_raquo_laminar_api_LaminarAliases__$init$__V(this);
  $f_Lcom_raquo_laminar_api_Laminar__$init$__V(this);
}
export { $c_Lcom_raquo_laminar_api_package$$anon$1 as $c_Lcom_raquo_laminar_api_package$$anon$1 };
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype = new $h_O();
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.constructor = $c_Lcom_raquo_laminar_api_package$$anon$1;
/** @constructor */
function $h_Lcom_raquo_laminar_api_package$$anon$1() {
}
export { $h_Lcom_raquo_laminar_api_package$$anon$1 as $h_Lcom_raquo_laminar_api_package$$anon$1 };
$h_Lcom_raquo_laminar_api_package$$anon$1.prototype = $c_Lcom_raquo_laminar_api_package$$anon$1.prototype;
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.img__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_imgbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_img$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("img", true);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_imgbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_img$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.footerTag__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_footerTagbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_footerTag$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("footer", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_footerTagbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_footerTag$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.h1__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_h1bitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_h1$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("h1", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_h1bitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_h1$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.h2__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_h2bitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_h2$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("h2", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_h2bitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_h2$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.h3__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_h3bitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_h3$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("h3", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_h3bitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_h3$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.h4__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_h4bitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_h4$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("h4", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_h4bitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_h4$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.a__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_abitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_a$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("a", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_abitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_a$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.strong__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_strongbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_strong$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("strong", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_strongbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_strong$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.code__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_codebitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_code$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("code", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_codebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_code$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.span__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_spanbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_span$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("span", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_spanbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_span$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.form__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_formbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_form$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("form", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_formbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_form$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.label__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_labelbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_label$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("label", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_labelbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_label$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.input__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_inputbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_input$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("input", true);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_inputbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_input$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.button__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_buttonbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_button$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("button", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_buttonbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_button$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.select__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_selectbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_select$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("select", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_selectbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_select$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.option__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_optionbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_option$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("option", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_optionbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_option$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.textArea__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_textAreabitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_textArea$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("textarea", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_textAreabitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_textArea$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.p__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_pbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_p$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("p", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_pbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_p$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.pre__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_prebitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_pre$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("pre", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_prebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_pre$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.ul__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_ulbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_ul$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("ul", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_ulbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_ul$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.li__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_libitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_li$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("li", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_libitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_li$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.div__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_divbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_div$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("div", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_divbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_div$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.table__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_tablebitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_table$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("table", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_tablebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_table$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.tbody__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_tbodybitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_tbody$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("tbody", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_tbodybitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_tbody$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.thead__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_theadbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_thead$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("thead", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_theadbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_thead$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.tr__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_trbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_tr$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("tr", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_trbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_tr$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.td__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_tdbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_td$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("td", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_tdbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_td$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.th__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_thbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_th$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("th", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_thbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_th$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.timeTag__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_timeTagbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_timeTag$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("time", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_timeTagbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_timeTag$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.dialogTag__Lcom_raquo_laminar_tags_HtmlTag = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_dialogTagbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_dialogTag$lzy1 = new $c_Lcom_raquo_laminar_tags_HtmlTag("dialog", false);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_dialogTagbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_dialogTag$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.idAttr__Lcom_raquo_laminar_keys_GlobalAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_idAttrbitmap$1)) {
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_idAttr$lzy1 = $ct_Lcom_raquo_laminar_keys_GlobalAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $c_Lcom_raquo_laminar_keys_GlobalAttr(), "id", codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_idAttrbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_idAttr$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.tabIndex__Lcom_raquo_laminar_keys_GlobalAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_tabIndexbitmap$1)) {
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().intAsString__Lcom_raquo_laminar_codecs_Codec();
    this.Lcom_raquo_laminar_api_package$$anon$1__f_tabIndex$lzy1 = $ct_Lcom_raquo_laminar_keys_GlobalAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $c_Lcom_raquo_laminar_keys_GlobalAttr(), "tabindex", codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_tabIndexbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_tabIndex$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.href__Lcom_raquo_laminar_keys_HtmlAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_hrefbitmap$1)) {
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_href$lzy1 = new $c_Lcom_raquo_laminar_keys_HtmlAttr("href", codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_hrefbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_href$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.maxAttr__Lcom_raquo_laminar_keys_HtmlAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_maxAttrbitmap$1)) {
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_maxAttr$lzy1 = new $c_Lcom_raquo_laminar_keys_HtmlAttr("max", codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_maxAttrbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_maxAttr$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.minAttr__Lcom_raquo_laminar_keys_HtmlAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_minAttrbitmap$1)) {
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_minAttr$lzy1 = new $c_Lcom_raquo_laminar_keys_HtmlAttr("min", codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_minAttrbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_minAttr$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.src__Lcom_raquo_laminar_keys_HtmlAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_srcbitmap$1)) {
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_src$lzy1 = new $c_Lcom_raquo_laminar_keys_HtmlAttr("src", codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_srcbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_src$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.stepAttr__Lcom_raquo_laminar_keys_HtmlAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_stepAttrbitmap$1)) {
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_stepAttr$lzy1 = new $c_Lcom_raquo_laminar_keys_HtmlAttr("step", codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_stepAttrbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_stepAttr$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.type__Lcom_raquo_laminar_keys_HtmlAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_typebitmap$1)) {
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_type$lzy1 = new $c_Lcom_raquo_laminar_keys_HtmlAttr("type", codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_typebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_type$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.typ__Lcom_raquo_laminar_keys_HtmlAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_typbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_typ$lzy1 = this.type__Lcom_raquo_laminar_keys_HtmlAttr();
    this.Lcom_raquo_laminar_api_package$$anon$1__f_typbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_typ$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.tpe__Lcom_raquo_laminar_keys_HtmlAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_tpebitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_tpe$lzy1 = this.type__Lcom_raquo_laminar_keys_HtmlAttr();
    this.Lcom_raquo_laminar_api_package$$anon$1__f_tpebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_tpe$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.checked__Lcom_raquo_laminar_keys_HtmlProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_checkedbitmap$1)) {
    var reflectedAttrName = $m_s_Option$().apply__O__s_Option(null);
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_booleanAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_checked$lzy1 = $m_Lcom_raquo_laminar_keys_HtmlProp$().apply__T__s_Option__Lcom_raquo_laminar_codecs_Codec__Lcom_raquo_laminar_keys_HtmlProp("checked", reflectedAttrName, codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_checkedbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_checked$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.value__Lcom_raquo_laminar_keys_HtmlProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_valuebitmap$1)) {
    var reflectedAttrName = $m_s_Option$().apply__O__s_Option(null);
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_value$lzy1 = $m_Lcom_raquo_laminar_keys_HtmlProp$().apply__T__s_Option__Lcom_raquo_laminar_codecs_Codec__Lcom_raquo_laminar_keys_HtmlProp("value", reflectedAttrName, codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_valuebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_value$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.disabled__Lcom_raquo_laminar_keys_HtmlProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_disabledbitmap$1)) {
    var reflectedAttrName = $m_s_Option$().apply__O__s_Option("disabled");
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_booleanAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_disabled$lzy1 = $m_Lcom_raquo_laminar_keys_HtmlProp$().apply__T__s_Option__Lcom_raquo_laminar_codecs_Codec__Lcom_raquo_laminar_keys_HtmlProp("disabled", reflectedAttrName, codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_disabledbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_disabled$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.forId__Lcom_raquo_laminar_keys_HtmlProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_forIdbitmap$1)) {
    var reflectedAttrName = $m_s_Option$().apply__O__s_Option("for");
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_forId$lzy1 = $m_Lcom_raquo_laminar_keys_HtmlProp$().apply__T__s_Option__Lcom_raquo_laminar_codecs_Codec__Lcom_raquo_laminar_keys_HtmlProp("htmlFor", reflectedAttrName, codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_forIdbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_forId$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.inputMode__Lcom_raquo_laminar_keys_HtmlProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_inputModebitmap$1)) {
    var reflectedAttrName = $m_s_Option$().apply__O__s_Option("inputmode");
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_inputMode$lzy1 = $m_Lcom_raquo_laminar_keys_HtmlProp$().apply__T__s_Option__Lcom_raquo_laminar_codecs_Codec__Lcom_raquo_laminar_keys_HtmlProp("inputMode", reflectedAttrName, codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_inputModebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_inputMode$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.method__Lcom_raquo_laminar_keys_HtmlProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_methodbitmap$1)) {
    var reflectedAttrName = $m_s_Option$().apply__O__s_Option("method");
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_method$lzy1 = $m_Lcom_raquo_laminar_keys_HtmlProp$().apply__T__s_Option__Lcom_raquo_laminar_codecs_Codec__Lcom_raquo_laminar_keys_HtmlProp("method", reflectedAttrName, codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_methodbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_method$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.nameAttr__Lcom_raquo_laminar_keys_HtmlProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_nameAttrbitmap$1)) {
    var reflectedAttrName = $m_s_Option$().apply__O__s_Option("name");
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_nameAttr$lzy1 = $m_Lcom_raquo_laminar_keys_HtmlProp$().apply__T__s_Option__Lcom_raquo_laminar_codecs_Codec__Lcom_raquo_laminar_keys_HtmlProp("name", reflectedAttrName, codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_nameAttrbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_nameAttr$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.placeholder__Lcom_raquo_laminar_keys_HtmlProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_placeholderbitmap$1)) {
    var reflectedAttrName = $m_s_Option$().apply__O__s_Option("placeholder");
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_placeholder$lzy1 = $m_Lcom_raquo_laminar_keys_HtmlProp$().apply__T__s_Option__Lcom_raquo_laminar_codecs_Codec__Lcom_raquo_laminar_keys_HtmlProp("placeholder", reflectedAttrName, codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_placeholderbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_placeholder$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.target__Lcom_raquo_laminar_keys_HtmlProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_targetbitmap$1)) {
    var reflectedAttrName = $m_s_Option$().apply__O__s_Option("target");
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_target$lzy1 = $m_Lcom_raquo_laminar_keys_HtmlProp$().apply__T__s_Option__Lcom_raquo_laminar_codecs_Codec__Lcom_raquo_laminar_keys_HtmlProp("target", reflectedAttrName, codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_targetbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_target$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.title__Lcom_raquo_laminar_keys_HtmlProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_titlebitmap$1)) {
    var reflectedAttrName = $m_s_Option$().apply__O__s_Option("title");
    var codec = $m_Lcom_raquo_laminar_codecs_Codec$().Lcom_raquo_laminar_codecs_Codec$__f_stringAsIs;
    this.Lcom_raquo_laminar_api_package$$anon$1__f_title$lzy1 = $m_Lcom_raquo_laminar_keys_HtmlProp$().apply__T__s_Option__Lcom_raquo_laminar_codecs_Codec__Lcom_raquo_laminar_keys_HtmlProp("title", reflectedAttrName, codec);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_titlebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_title$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.onClick__Lcom_raquo_laminar_keys_EventProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_onClickbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onClick$lzy1 = new $c_Lcom_raquo_laminar_keys_EventProp("click");
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onClickbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_onClick$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.onChange__Lcom_raquo_laminar_keys_EventProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_onChangebitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onChange$lzy1 = new $c_Lcom_raquo_laminar_keys_EventProp("change");
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onChangebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_onChange$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.onInput__Lcom_raquo_laminar_keys_EventProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_onInputbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onInput$lzy1 = new $c_Lcom_raquo_laminar_keys_EventProp("input");
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onInputbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_onInput$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.onFocus__Lcom_raquo_laminar_keys_EventProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_onFocusbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onFocus$lzy1 = new $c_Lcom_raquo_laminar_keys_EventProp("focus");
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onFocusbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_onFocus$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.onSubmit__Lcom_raquo_laminar_keys_EventProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_onSubmitbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onSubmit$lzy1 = new $c_Lcom_raquo_laminar_keys_EventProp("submit");
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onSubmitbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_onSubmit$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.onKeyDown__Lcom_raquo_laminar_keys_EventProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_onKeyDownbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onKeyDown$lzy1 = new $c_Lcom_raquo_laminar_keys_EventProp("keydown");
    this.Lcom_raquo_laminar_api_package$$anon$1__f_onKeyDownbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_onKeyDown$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.zIndex__Lcom_raquo_laminar_keys_StyleProp = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_zIndexbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_zIndex$lzy1 = new $c_Lcom_raquo_laminar_defs_styles_StyleProps$$anon$1("z-index");
    this.Lcom_raquo_laminar_api_package$$anon$1__f_zIndexbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_zIndex$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.className__Lcom_raquo_laminar_keys_CompositeAttr = (function() {
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_className;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.role__Lcom_raquo_laminar_keys_CompositeAttr = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_rolebitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_role$lzy1 = new $c_Lcom_raquo_laminar_keys_CompositeAttr("role", " ");
    this.Lcom_raquo_laminar_api_package$$anon$1__f_rolebitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_role$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.com$raquo$laminar$defs$complex$ComplexGlobalKeys$_setter_$className_$eq__Lcom_raquo_laminar_keys_CompositeAttr__V = (function(x$0) {
  this.Lcom_raquo_laminar_api_package$$anon$1__f_className = x$0;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.com$raquo$laminar$defs$complex$ComplexGlobalKeys$_setter_$cls_$eq__Lcom_raquo_laminar_keys_CompositeAttr__V = (function(x$0) {
  this.Lcom_raquo_laminar_api_package$$anon$1__f_cls = x$0;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.StringValueMapper__Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$ = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_StringValueMapperbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_StringValueMapper$lzy1 = new $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringValueMapper$(this);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_StringValueMapperbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_StringValueMapper$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.StringSeqValueMapper__Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$ = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqValueMapperbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqValueMapper$lzy1 = new $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqValueMapper$(this);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqValueMapperbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqValueMapper$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.StringSeqSeqValueMapper__Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$ = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqSeqValueMapperbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqSeqValueMapper$lzy1 = new $c_Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits$StringSeqSeqValueMapper$(this);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqSeqValueMapperbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_StringSeqSeqValueMapper$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.aria__Lcom_raquo_laminar_api_Laminar$aria$ = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_ariabitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_aria$lzy1 = new $c_Lcom_raquo_laminar_api_Laminar$aria$(this);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_ariabitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_aria$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.svg__Lcom_raquo_laminar_api_Laminar$svg$ = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_svgbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_svg$lzy1 = new $c_Lcom_raquo_laminar_api_Laminar$svg$(this);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_svgbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_svg$lzy1;
});
$c_Lcom_raquo_laminar_api_package$$anon$1.prototype.unsafeWindowOwner__Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ = (function() {
  if ((!this.Lcom_raquo_laminar_api_package$$anon$1__f_unsafeWindowOwnerbitmap$1)) {
    this.Lcom_raquo_laminar_api_package$$anon$1__f_unsafeWindowOwner$lzy1 = new $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$(this);
    this.Lcom_raquo_laminar_api_package$$anon$1__f_unsafeWindowOwnerbitmap$1 = true;
  }
  return this.Lcom_raquo_laminar_api_package$$anon$1__f_unsafeWindowOwner$lzy1;
});
var $d_Lcom_raquo_laminar_api_package$$anon$1 = new $TypeData().initClass($c_Lcom_raquo_laminar_api_package$$anon$1, "com.raquo.laminar.api.package$$anon$1", ({
  Lcom_raquo_laminar_api_package$$anon$1: 1,
  Lcom_raquo_laminar_api_LaminarPlatformSpecific: 1,
  Lcom_raquo_laminar_defs_tags_HtmlTags: 1,
  Lcom_raquo_laminar_defs_attrs_GlobalAttrs: 1,
  Lcom_raquo_laminar_defs_attrs_HtmlAttrs: 1,
  Lcom_raquo_laminar_defs_props_HtmlProps: 1,
  Lcom_raquo_laminar_defs_eventProps_GlobalEventProps: 1,
  Lcom_raquo_laminar_defs_styles_StyleProps: 1,
  Lcom_raquo_laminar_defs_complex_ComplexGlobalKeys: 1,
  Lcom_raquo_laminar_defs_complex_ComplexHtmlKeys: 1,
  Lcom_raquo_laminar_api_MountHooks: 1,
  Lcom_raquo_laminar_api_AirstreamAliases: 1,
  Lcom_raquo_laminar_api_LaminarAliases: 1,
  Lcom_raquo_laminar_api_ImplicitsPlatformSpecific: 1,
  Lcom_raquo_laminar_api_Implicits$LowPriorityImplicits: 1,
  Lcom_raquo_laminar_keys_CompositeValueMapper$Implicits: 1,
  Lcom_raquo_laminar_api_Implicits: 1,
  Lcom_raquo_laminar_api_Laminar: 1
}));
export { $d_Lcom_raquo_laminar_api_package$$anon$1 as $d_Lcom_raquo_laminar_api_package$$anon$1 };
/** @constructor */
function $c_sc_StringView(s) {
  this.sc_StringView__f_s = null;
  this.sc_StringView__f_s = s;
}
export { $c_sc_StringView as $c_sc_StringView };
$c_sc_StringView.prototype = new $h_sc_AbstractIndexedSeqView();
$c_sc_StringView.prototype.constructor = $c_sc_StringView;
/** @constructor */
function $h_sc_StringView() {
}
export { $h_sc_StringView as $h_sc_StringView };
$h_sc_StringView.prototype = $c_sc_StringView.prototype;
$c_sc_StringView.prototype.length__I = (function() {
  var this$1 = this.sc_StringView__f_s;
  return this$1.length;
});
$c_sc_StringView.prototype.toString__T = (function() {
  return (("StringView(" + this.sc_StringView__f_s) + ")");
});
$c_sc_StringView.prototype.productPrefix__T = (function() {
  return "StringView";
});
$c_sc_StringView.prototype.productArity__I = (function() {
  return 1;
});
$c_sc_StringView.prototype.productElement__I__O = (function(x$1) {
  return ((x$1 === 0) ? this.sc_StringView__f_s : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_sc_StringView.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sc_StringView.prototype.productElementName__I__T = (function(x$1) {
  return ((x$1 === 0) ? "s" : $m_sr_Statics$().ioobe__I__O(x$1));
});
$c_sc_StringView.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-351294208), true);
});
$c_sc_StringView.prototype.equals__O__Z = (function(x$1) {
  return ((this === x$1) || ((x$1 instanceof $c_sc_StringView) && (this.sc_StringView__f_s === x$1.sc_StringView__f_s)));
});
$c_sc_StringView.prototype.apply__I__O = (function(i) {
  var this$1 = this.sc_StringView__f_s;
  return $bC(this$1.charCodeAt(i));
});
function $isArrayOf_sc_StringView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_StringView)));
}
export { $isArrayOf_sc_StringView as $isArrayOf_sc_StringView };
var $d_sc_StringView = new $TypeData().initClass($c_sc_StringView, "scala.collection.StringView", ({
  sc_StringView: 1,
  sc_AbstractIndexedSeqView: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  s_Product: 1,
  s_Equals: 1
}));
export { $d_sc_StringView as $d_sc_StringView };
/** @constructor */
function $c_sci_ListMap$$anon$1(outer) {
  this.sci_ListMap$$anon$1__f_$outer = null;
  this.sci_ListMap$$anon$1__f_$outer = outer;
}
export { $c_sci_ListMap$$anon$1 as $c_sci_ListMap$$anon$1 };
$c_sci_ListMap$$anon$1.prototype = new $h_sci_AbstractMap();
$c_sci_ListMap$$anon$1.prototype.constructor = $c_sci_ListMap$$anon$1;
/** @constructor */
function $h_sci_ListMap$$anon$1() {
}
export { $h_sci_ListMap$$anon$1 as $h_sci_ListMap$$anon$1 };
$h_sci_ListMap$$anon$1.prototype = $c_sci_ListMap$$anon$1.prototype;
$c_sci_ListMap$$anon$1.prototype.isEmpty__Z = (function() {
  return this.sci_ListMap$$anon$1__f_$outer.isEmpty__Z();
});
$c_sci_ListMap$$anon$1.prototype.removed__O__sci_Map = (function(key) {
  return this.sci_ListMap$$anon$1__f_$outer.removed__O__sci_ListMap(key);
});
$c_sci_ListMap$$anon$1.prototype.updated__O__O__sci_Map = (function(key, value) {
  return this.sci_ListMap$$anon$1__f_$outer.updated__O__O__sci_ListMap(key, value);
});
$c_sci_ListMap$$anon$1.prototype.get__O__s_Option = (function(key) {
  return this.sci_ListMap$$anon$1__f_$outer.get__O__s_Option(key);
});
$c_sci_ListMap$$anon$1.prototype.iterator__sc_Iterator = (function() {
  return this.sci_ListMap$$anon$1__f_$outer.iterator__sc_Iterator();
});
$c_sci_ListMap$$anon$1.prototype.foreachEntry__F2__V = (function(f) {
  var curr = this.sci_ListMap$$anon$1__f_$outer;
  while (true) {
    var this$1 = curr;
    if ((!this$1.isEmpty__Z())) {
      f.apply__O__O__O(curr.key__O(), curr.value__O());
      curr = curr.next__sci_ListMap();
    } else {
      break;
    }
  }
});
$c_sci_ListMap$$anon$1.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
$c_sci_ListMap$$anon$1.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
var $d_sci_ListMap$$anon$1 = new $TypeData().initClass($c_sci_ListMap$$anon$1, "scala.collection.immutable.ListMap$$anon$1", ({
  sci_ListMap$$anon$1: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1
}));
export { $d_sci_ListMap$$anon$1 as $d_sci_ListMap$$anon$1 };
function $isArrayOf_sci_SeqMap$SeqMap1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap1)));
}
export { $isArrayOf_sci_SeqMap$SeqMap1 as $isArrayOf_sci_SeqMap$SeqMap1 };
function $isArrayOf_sci_SeqMap$SeqMap2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap2)));
}
export { $isArrayOf_sci_SeqMap$SeqMap2 as $isArrayOf_sci_SeqMap$SeqMap2 };
function $isArrayOf_sci_SeqMap$SeqMap3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap3)));
}
export { $isArrayOf_sci_SeqMap$SeqMap3 as $isArrayOf_sci_SeqMap$SeqMap3 };
function $isArrayOf_sci_SeqMap$SeqMap4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_SeqMap$SeqMap4)));
}
export { $isArrayOf_sci_SeqMap$SeqMap4 as $isArrayOf_sci_SeqMap$SeqMap4 };
/** @constructor */
function $c_sci_Set$Set1(elem1) {
  this.sci_Set$Set1__f_elem1 = null;
  this.sci_Set$Set1__f_elem1 = elem1;
}
export { $c_sci_Set$Set1 as $c_sci_Set$Set1 };
$c_sci_Set$Set1.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set1.prototype.constructor = $c_sci_Set$Set1;
/** @constructor */
function $h_sci_Set$Set1() {
}
export { $h_sci_Set$Set1 as $h_sci_Set$Set1 };
$h_sci_Set$Set1.prototype = $c_sci_Set$Set1.prototype;
$c_sci_Set$Set1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set1.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Set$Set1.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set1.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set1.prototype.size__I = (function() {
  return 1;
});
$c_sci_Set$Set1.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set1.prototype.knownSize__I = (function() {
  return 1;
});
$c_sci_Set$Set1.prototype.contains__O__Z = (function(elem) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1);
});
$c_sci_Set$Set1.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set2(this.sci_Set$Set1__f_elem1, elem));
});
$c_sci_Set$Set1.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set1__f_elem1) ? $m_sci_Set$EmptySet$() : this);
});
$c_sci_Set$Set1.prototype.iterator__sc_Iterator = (function() {
  var a = this.sci_Set$Set1__f_elem1;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Set$Set1.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set1__f_elem1);
});
$c_sci_Set$Set1.prototype.exists__F1__Z = (function(p) {
  return (!(!p.apply__O__O(this.sci_Set$Set1__f_elem1)));
});
$c_sci_Set$Set1.prototype.forall__F1__Z = (function(p) {
  return (!(!p.apply__O__O(this.sci_Set$Set1__f_elem1)));
});
$c_sci_Set$Set1.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  return (((!(!pred.apply__O__O(this.sci_Set$Set1__f_elem1))) !== isFlipped) ? this : $m_sci_Set$EmptySet$());
});
$c_sci_Set$Set1.prototype.find__F1__s_Option = (function(p) {
  return ((!(!p.apply__O__O(this.sci_Set$Set1__f_elem1))) ? new $c_s_Some(this.sci_Set$Set1__f_elem1) : $m_s_None$());
});
$c_sci_Set$Set1.prototype.head__O = (function() {
  return this.sci_Set$Set1__f_elem1;
});
$c_sci_Set$Set1.prototype.tail__O = (function() {
  return $m_sci_Set$EmptySet$();
});
$c_sci_Set$Set1.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set1.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $isArrayOf_sci_Set$Set1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set1)));
}
export { $isArrayOf_sci_Set$Set1 as $isArrayOf_sci_Set$Set1 };
var $d_sci_Set$Set1 = new $TypeData().initClass($c_sci_Set$Set1, "scala.collection.immutable.Set$Set1", ({
  sci_Set$Set1: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Set$Set1 as $d_sci_Set$Set1 };
/** @constructor */
function $c_sci_Set$Set2(elem1, elem2) {
  this.sci_Set$Set2__f_elem1 = null;
  this.sci_Set$Set2__f_elem2 = null;
  this.sci_Set$Set2__f_elem1 = elem1;
  this.sci_Set$Set2__f_elem2 = elem2;
}
export { $c_sci_Set$Set2 as $c_sci_Set$Set2 };
$c_sci_Set$Set2.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set2.prototype.constructor = $c_sci_Set$Set2;
/** @constructor */
function $h_sci_Set$Set2() {
}
export { $h_sci_Set$Set2 as $h_sci_Set$Set2 };
$h_sci_Set$Set2.prototype = $c_sci_Set$Set2.prototype;
$c_sci_Set$Set2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set2.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Set$Set2.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set2.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set2.prototype.size__I = (function() {
  return 2;
});
$c_sci_Set$Set2.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set2.prototype.knownSize__I = (function() {
  return 2;
});
$c_sci_Set$Set2.prototype.contains__O__Z = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2));
});
$c_sci_Set$Set2.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set3(this.sci_Set$Set2__f_elem1, this.sci_Set$Set2__f_elem2, elem));
});
$c_sci_Set$Set2.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem1) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set2__f_elem2) ? new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem1) : this));
});
$c_sci_Set$Set2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set2$$anon$1(this);
});
$c_sci_Set$Set2.prototype.scala$collection$immutable$Set$Set2$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set2__f_elem1;
      break;
    }
    case 1: {
      return this.sci_Set$Set2__f_elem2;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$c_sci_Set$Set2.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set2__f_elem1);
  f.apply__O__O(this.sci_Set$Set2__f_elem2);
});
$c_sci_Set$Set2.prototype.exists__F1__Z = (function(p) {
  return ((!(!p.apply__O__O(this.sci_Set$Set2__f_elem1))) || (!(!p.apply__O__O(this.sci_Set$Set2__f_elem2))));
});
$c_sci_Set$Set2.prototype.forall__F1__Z = (function(p) {
  return ((!(!p.apply__O__O(this.sci_Set$Set2__f_elem1))) && (!(!p.apply__O__O(this.sci_Set$Set2__f_elem2))));
});
$c_sci_Set$Set2.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var n = 0;
  if (((!(!pred.apply__O__O(this.sci_Set$Set2__f_elem1))) !== isFlipped)) {
    r1 = this.sci_Set$Set2__f_elem1;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O(this.sci_Set$Set2__f_elem2))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set2__f_elem2;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Set$Set2.prototype.find__F1__s_Option = (function(p) {
  return ((!(!p.apply__O__O(this.sci_Set$Set2__f_elem1))) ? new $c_s_Some(this.sci_Set$Set2__f_elem1) : ((!(!p.apply__O__O(this.sci_Set$Set2__f_elem2))) ? new $c_s_Some(this.sci_Set$Set2__f_elem2) : $m_s_None$()));
});
$c_sci_Set$Set2.prototype.head__O = (function() {
  return this.sci_Set$Set2__f_elem1;
});
$c_sci_Set$Set2.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set1(this.sci_Set$Set2__f_elem2);
});
$c_sci_Set$Set2.prototype.tail__O = (function() {
  return this.tail__sci_Set();
});
$c_sci_Set$Set2.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set2.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $isArrayOf_sci_Set$Set2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set2)));
}
export { $isArrayOf_sci_Set$Set2 as $isArrayOf_sci_Set$Set2 };
var $d_sci_Set$Set2 = new $TypeData().initClass($c_sci_Set$Set2, "scala.collection.immutable.Set$Set2", ({
  sci_Set$Set2: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Set$Set2 as $d_sci_Set$Set2 };
/** @constructor */
function $c_sci_Set$Set3(elem1, elem2, elem3) {
  this.sci_Set$Set3__f_elem1 = null;
  this.sci_Set$Set3__f_elem2 = null;
  this.sci_Set$Set3__f_elem3 = null;
  this.sci_Set$Set3__f_elem1 = elem1;
  this.sci_Set$Set3__f_elem2 = elem2;
  this.sci_Set$Set3__f_elem3 = elem3;
}
export { $c_sci_Set$Set3 as $c_sci_Set$Set3 };
$c_sci_Set$Set3.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set3.prototype.constructor = $c_sci_Set$Set3;
/** @constructor */
function $h_sci_Set$Set3() {
}
export { $h_sci_Set$Set3 as $h_sci_Set$Set3 };
$h_sci_Set$Set3.prototype = $c_sci_Set$Set3.prototype;
$c_sci_Set$Set3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set3.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Set$Set3.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set3.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set3.prototype.size__I = (function() {
  return 3;
});
$c_sci_Set$Set3.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set3.prototype.knownSize__I = (function() {
  return 3;
});
$c_sci_Set$Set3.prototype.contains__O__Z = (function(elem) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3));
});
$c_sci_Set$Set3.prototype.incl__O__sci_Set = (function(elem) {
  return (this.contains__O__Z(elem) ? this : new $c_sci_Set$Set4(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3, elem));
});
$c_sci_Set$Set3.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem1) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem2) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set3__f_elem3) ? new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem1, this.sci_Set$Set3__f_elem2) : this)));
});
$c_sci_Set$Set3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set3$$anon$2(this);
});
$c_sci_Set$Set3.prototype.scala$collection$immutable$Set$Set3$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set3__f_elem1;
      break;
    }
    case 1: {
      return this.sci_Set$Set3__f_elem2;
      break;
    }
    case 2: {
      return this.sci_Set$Set3__f_elem3;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$c_sci_Set$Set3.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set3__f_elem1);
  f.apply__O__O(this.sci_Set$Set3__f_elem2);
  f.apply__O__O(this.sci_Set$Set3__f_elem3);
});
$c_sci_Set$Set3.prototype.exists__F1__Z = (function(p) {
  return (((!(!p.apply__O__O(this.sci_Set$Set3__f_elem1))) || (!(!p.apply__O__O(this.sci_Set$Set3__f_elem2)))) || (!(!p.apply__O__O(this.sci_Set$Set3__f_elem3))));
});
$c_sci_Set$Set3.prototype.forall__F1__Z = (function(p) {
  return (((!(!p.apply__O__O(this.sci_Set$Set3__f_elem1))) && (!(!p.apply__O__O(this.sci_Set$Set3__f_elem2)))) && (!(!p.apply__O__O(this.sci_Set$Set3__f_elem3))));
});
$c_sci_Set$Set3.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var n = 0;
  if (((!(!pred.apply__O__O(this.sci_Set$Set3__f_elem1))) !== isFlipped)) {
    r1 = this.sci_Set$Set3__f_elem1;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O(this.sci_Set$Set3__f_elem2))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set3__f_elem2;
    } else {
      r2 = this.sci_Set$Set3__f_elem2;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O(this.sci_Set$Set3__f_elem3))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set3__f_elem3;
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set3__f_elem3;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break;
    }
    case 3: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Set$Set3.prototype.find__F1__s_Option = (function(p) {
  return ((!(!p.apply__O__O(this.sci_Set$Set3__f_elem1))) ? new $c_s_Some(this.sci_Set$Set3__f_elem1) : ((!(!p.apply__O__O(this.sci_Set$Set3__f_elem2))) ? new $c_s_Some(this.sci_Set$Set3__f_elem2) : ((!(!p.apply__O__O(this.sci_Set$Set3__f_elem3))) ? new $c_s_Some(this.sci_Set$Set3__f_elem3) : $m_s_None$())));
});
$c_sci_Set$Set3.prototype.head__O = (function() {
  return this.sci_Set$Set3__f_elem1;
});
$c_sci_Set$Set3.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set2(this.sci_Set$Set3__f_elem2, this.sci_Set$Set3__f_elem3);
});
$c_sci_Set$Set3.prototype.tail__O = (function() {
  return this.tail__sci_Set();
});
$c_sci_Set$Set3.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set3.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $isArrayOf_sci_Set$Set3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set3)));
}
export { $isArrayOf_sci_Set$Set3 as $isArrayOf_sci_Set$Set3 };
var $d_sci_Set$Set3 = new $TypeData().initClass($c_sci_Set$Set3, "scala.collection.immutable.Set$Set3", ({
  sci_Set$Set3: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Set$Set3 as $d_sci_Set$Set3 };
/** @constructor */
function $c_sci_Set$Set4(elem1, elem2, elem3, elem4) {
  this.sci_Set$Set4__f_elem1 = null;
  this.sci_Set$Set4__f_elem2 = null;
  this.sci_Set$Set4__f_elem3 = null;
  this.sci_Set$Set4__f_elem4 = null;
  this.sci_Set$Set4__f_elem1 = elem1;
  this.sci_Set$Set4__f_elem2 = elem2;
  this.sci_Set$Set4__f_elem3 = elem3;
  this.sci_Set$Set4__f_elem4 = elem4;
}
export { $c_sci_Set$Set4 as $c_sci_Set$Set4 };
$c_sci_Set$Set4.prototype = new $h_sci_AbstractSet();
$c_sci_Set$Set4.prototype.constructor = $c_sci_Set$Set4;
/** @constructor */
function $h_sci_Set$Set4() {
}
export { $h_sci_Set$Set4 as $h_sci_Set$Set4 };
$h_sci_Set$Set4.prototype = $c_sci_Set$Set4.prototype;
$c_sci_Set$Set4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Set$Set4.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Set$Set4.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Set(pred, false);
});
$c_sci_Set$Set4.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Set$Set4.prototype.size__I = (function() {
  return 4;
});
$c_sci_Set$Set4.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Set$Set4.prototype.knownSize__I = (function() {
  return 4;
});
$c_sci_Set$Set4.prototype.contains__O__Z = (function(elem) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4));
});
$c_sci_Set$Set4.prototype.incl__O__sci_Set = (function(elem) {
  if (this.contains__O__Z(elem)) {
    return this;
  } else {
    var this$1 = $m_sci_HashSet$();
    var this$2 = this$1.sci_HashSet$__f_EmptySet;
    var elem$1 = this.sci_Set$Set4__f_elem1;
    var this$3 = this$2.incl__O__sci_HashSet(elem$1);
    var elem$2 = this.sci_Set$Set4__f_elem2;
    var this$4 = this$3.incl__O__sci_HashSet(elem$2);
    var elem$3 = this.sci_Set$Set4__f_elem3;
    var this$5 = this$4.incl__O__sci_HashSet(elem$3);
    var elem$4 = this.sci_Set$Set4__f_elem4;
    var this$6 = this$5.incl__O__sci_HashSet(elem$4);
    return this$6.incl__O__sci_HashSet(elem);
  }
});
$c_sci_Set$Set4.prototype.excl__O__sci_Set = (function(elem) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem1) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem2) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem3) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(elem, this.sci_Set$Set4__f_elem4) ? new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem1, this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3) : this))));
});
$c_sci_Set$Set4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Set$Set4$$anon$3(this);
});
$c_sci_Set$Set4.prototype.scala$collection$immutable$Set$Set4$$getElem__I__O = (function(i) {
  switch (i) {
    case 0: {
      return this.sci_Set$Set4__f_elem1;
      break;
    }
    case 1: {
      return this.sci_Set$Set4__f_elem2;
      break;
    }
    case 2: {
      return this.sci_Set$Set4__f_elem3;
      break;
    }
    case 3: {
      return this.sci_Set$Set4__f_elem4;
      break;
    }
    default: {
      throw new $c_s_MatchError(i);
    }
  }
});
$c_sci_Set$Set4.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O(this.sci_Set$Set4__f_elem1);
  f.apply__O__O(this.sci_Set$Set4__f_elem2);
  f.apply__O__O(this.sci_Set$Set4__f_elem3);
  f.apply__O__O(this.sci_Set$Set4__f_elem4);
});
$c_sci_Set$Set4.prototype.exists__F1__Z = (function(p) {
  return ((((!(!p.apply__O__O(this.sci_Set$Set4__f_elem1))) || (!(!p.apply__O__O(this.sci_Set$Set4__f_elem2)))) || (!(!p.apply__O__O(this.sci_Set$Set4__f_elem3)))) || (!(!p.apply__O__O(this.sci_Set$Set4__f_elem4))));
});
$c_sci_Set$Set4.prototype.forall__F1__Z = (function(p) {
  return ((((!(!p.apply__O__O(this.sci_Set$Set4__f_elem1))) && (!(!p.apply__O__O(this.sci_Set$Set4__f_elem2)))) && (!(!p.apply__O__O(this.sci_Set$Set4__f_elem3)))) && (!(!p.apply__O__O(this.sci_Set$Set4__f_elem4))));
});
$c_sci_Set$Set4.prototype.filterImpl__F1__Z__sci_Set = (function(pred, isFlipped) {
  var r1 = null;
  var r2 = null;
  var r3 = null;
  var n = 0;
  if (((!(!pred.apply__O__O(this.sci_Set$Set4__f_elem1))) !== isFlipped)) {
    r1 = this.sci_Set$Set4__f_elem1;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O(this.sci_Set$Set4__f_elem2))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem2;
    } else {
      r2 = this.sci_Set$Set4__f_elem2;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O(this.sci_Set$Set4__f_elem3))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem3;
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set4__f_elem3;
    } else {
      r3 = this.sci_Set$Set4__f_elem3;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O(this.sci_Set$Set4__f_elem4))) !== isFlipped)) {
    if ((n === 0)) {
      r1 = this.sci_Set$Set4__f_elem4;
    } else if ((n === 1)) {
      r2 = this.sci_Set$Set4__f_elem4;
    } else if ((n === 2)) {
      r3 = this.sci_Set$Set4__f_elem4;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Set$EmptySet$();
      break;
    }
    case 1: {
      return new $c_sci_Set$Set1(r1);
      break;
    }
    case 2: {
      return new $c_sci_Set$Set2(r1, r2);
      break;
    }
    case 3: {
      return new $c_sci_Set$Set3(r1, r2, r3);
      break;
    }
    case 4: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Set$Set4.prototype.find__F1__s_Option = (function(p) {
  return ((!(!p.apply__O__O(this.sci_Set$Set4__f_elem1))) ? new $c_s_Some(this.sci_Set$Set4__f_elem1) : ((!(!p.apply__O__O(this.sci_Set$Set4__f_elem2))) ? new $c_s_Some(this.sci_Set$Set4__f_elem2) : ((!(!p.apply__O__O(this.sci_Set$Set4__f_elem3))) ? new $c_s_Some(this.sci_Set$Set4__f_elem3) : ((!(!p.apply__O__O(this.sci_Set$Set4__f_elem4))) ? new $c_s_Some(this.sci_Set$Set4__f_elem4) : $m_s_None$()))));
});
$c_sci_Set$Set4.prototype.head__O = (function() {
  return this.sci_Set$Set4__f_elem1;
});
$c_sci_Set$Set4.prototype.tail__sci_Set = (function() {
  return new $c_sci_Set$Set3(this.sci_Set$Set4__f_elem2, this.sci_Set$Set4__f_elem3, this.sci_Set$Set4__f_elem4);
});
$c_sci_Set$Set4.prototype.buildTo__scm_Builder__scm_Builder = (function(builder) {
  return builder.addOne__O__scm_Growable(this.sci_Set$Set4__f_elem1).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem2).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem3).addOne__O__scm_Growable(this.sci_Set$Set4__f_elem4);
});
$c_sci_Set$Set4.prototype.tail__O = (function() {
  return this.tail__sci_Set();
});
$c_sci_Set$Set4.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_Set$Set4.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $isArrayOf_sci_Set$Set4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Set$Set4)));
}
export { $isArrayOf_sci_Set$Set4 as $isArrayOf_sci_Set$Set4 };
var $d_sci_Set$Set4 = new $TypeData().initClass($c_sci_Set$Set4, "scala.collection.immutable.Set$Set4", ({
  sci_Set$Set4: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Set$Set4 as $d_sci_Set$Set4 };
/** @constructor */
function $c_scm_AbstractSeq() {
}
export { $c_scm_AbstractSeq as $c_scm_AbstractSeq };
$c_scm_AbstractSeq.prototype = new $h_sc_AbstractSeq();
$c_scm_AbstractSeq.prototype.constructor = $c_scm_AbstractSeq;
/** @constructor */
function $h_scm_AbstractSeq() {
}
export { $h_scm_AbstractSeq as $h_scm_AbstractSeq };
$h_scm_AbstractSeq.prototype = $c_scm_AbstractSeq.prototype;
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Appended(underlying, elem, mutationCount) {
  this.sc_View$Appended__f_underlying = null;
  this.sc_View$Appended__f_elem = null;
  this.sc_SeqView$Appended__f_underlying = null;
  this.sc_SeqView$Appended__f_elem = null;
  this.scm_CheckedIndexedSeqView$Appended__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Appended__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Appended__sc_IndexedSeqOps__O__(this, underlying, elem);
}
export { $c_scm_CheckedIndexedSeqView$Appended as $c_scm_CheckedIndexedSeqView$Appended };
$c_scm_CheckedIndexedSeqView$Appended.prototype = new $h_sc_IndexedSeqView$Appended();
$c_scm_CheckedIndexedSeqView$Appended.prototype.constructor = $c_scm_CheckedIndexedSeqView$Appended;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Appended() {
}
export { $h_scm_CheckedIndexedSeqView$Appended as $h_scm_CheckedIndexedSeqView$Appended };
$h_scm_CheckedIndexedSeqView$Appended.prototype = $c_scm_CheckedIndexedSeqView$Appended.prototype;
$c_scm_CheckedIndexedSeqView$Appended.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Appended.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Appended__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$Appended = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Appended, "scala.collection.mutable.CheckedIndexedSeqView$Appended", ({
  scm_CheckedIndexedSeqView$Appended: 1,
  sc_IndexedSeqView$Appended: 1,
  sc_SeqView$Appended: 1,
  sc_View$Appended: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
export { $d_scm_CheckedIndexedSeqView$Appended as $d_scm_CheckedIndexedSeqView$Appended };
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Drop(underlying, n, mutationCount) {
  this.sc_View$Drop__f_underlying = null;
  this.sc_View$Drop__f_n = 0;
  this.sc_View$Drop__f_normN = 0;
  this.sc_SeqView$Drop__f_underlying = null;
  this.sc_SeqView$Drop__f_n = 0;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Drop__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Drop__sc_IndexedSeqOps__I__(this, underlying, n);
}
export { $c_scm_CheckedIndexedSeqView$Drop as $c_scm_CheckedIndexedSeqView$Drop };
$c_scm_CheckedIndexedSeqView$Drop.prototype = new $h_sc_IndexedSeqView$Drop();
$c_scm_CheckedIndexedSeqView$Drop.prototype.constructor = $c_scm_CheckedIndexedSeqView$Drop;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Drop() {
}
export { $h_scm_CheckedIndexedSeqView$Drop as $h_scm_CheckedIndexedSeqView$Drop };
$h_scm_CheckedIndexedSeqView$Drop.prototype = $c_scm_CheckedIndexedSeqView$Drop.prototype;
$c_scm_CheckedIndexedSeqView$Drop.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Drop.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Drop__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$Drop = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Drop, "scala.collection.mutable.CheckedIndexedSeqView$Drop", ({
  scm_CheckedIndexedSeqView$Drop: 1,
  sc_IndexedSeqView$Drop: 1,
  sc_SeqView$Drop: 1,
  sc_View$Drop: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
export { $d_scm_CheckedIndexedSeqView$Drop as $d_scm_CheckedIndexedSeqView$Drop };
/** @constructor */
function $c_scm_CheckedIndexedSeqView$DropRight(underlying, n, mutationCount) {
  this.sc_View$DropRight__f_underlying = null;
  this.sc_View$DropRight__f_n = 0;
  this.sc_View$DropRight__f_normN = 0;
  this.sc_SeqView$DropRight__f_underlying = null;
  this.sc_SeqView$DropRight__f_len = 0;
  this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$DropRight__sc_IndexedSeqOps__I__(this, underlying, n);
}
export { $c_scm_CheckedIndexedSeqView$DropRight as $c_scm_CheckedIndexedSeqView$DropRight };
$c_scm_CheckedIndexedSeqView$DropRight.prototype = new $h_sc_IndexedSeqView$DropRight();
$c_scm_CheckedIndexedSeqView$DropRight.prototype.constructor = $c_scm_CheckedIndexedSeqView$DropRight;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$DropRight() {
}
export { $h_scm_CheckedIndexedSeqView$DropRight as $h_scm_CheckedIndexedSeqView$DropRight };
$h_scm_CheckedIndexedSeqView$DropRight.prototype = $c_scm_CheckedIndexedSeqView$DropRight.prototype;
$c_scm_CheckedIndexedSeqView$DropRight.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$DropRight.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$DropRight__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$DropRight = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$DropRight, "scala.collection.mutable.CheckedIndexedSeqView$DropRight", ({
  scm_CheckedIndexedSeqView$DropRight: 1,
  sc_IndexedSeqView$DropRight: 1,
  sc_SeqView$DropRight: 1,
  sc_View$DropRight: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
export { $d_scm_CheckedIndexedSeqView$DropRight as $d_scm_CheckedIndexedSeqView$DropRight };
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Map(underlying, f, mutationCount) {
  this.sc_View$Map__f_underlying = null;
  this.sc_View$Map__f_f = null;
  this.sc_SeqView$Map__f_underlying = null;
  this.sc_SeqView$Map__f_f = null;
  this.scm_CheckedIndexedSeqView$Map__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Map__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Map__sc_IndexedSeqOps__F1__(this, underlying, f);
}
export { $c_scm_CheckedIndexedSeqView$Map as $c_scm_CheckedIndexedSeqView$Map };
$c_scm_CheckedIndexedSeqView$Map.prototype = new $h_sc_IndexedSeqView$Map();
$c_scm_CheckedIndexedSeqView$Map.prototype.constructor = $c_scm_CheckedIndexedSeqView$Map;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Map() {
}
export { $h_scm_CheckedIndexedSeqView$Map as $h_scm_CheckedIndexedSeqView$Map };
$h_scm_CheckedIndexedSeqView$Map.prototype = $c_scm_CheckedIndexedSeqView$Map.prototype;
$c_scm_CheckedIndexedSeqView$Map.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Map.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Map__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$Map = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Map, "scala.collection.mutable.CheckedIndexedSeqView$Map", ({
  scm_CheckedIndexedSeqView$Map: 1,
  sc_IndexedSeqView$Map: 1,
  sc_SeqView$Map: 1,
  sc_View$Map: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
export { $d_scm_CheckedIndexedSeqView$Map as $d_scm_CheckedIndexedSeqView$Map };
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Reverse(underlying, mutationCount) {
  this.sc_SeqView$Reverse__f_underlying = null;
  this.sc_IndexedSeqView$Reverse__f_underlying = null;
  this.scm_CheckedIndexedSeqView$Reverse__f_underlying = null;
  this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Reverse__f_underlying = underlying;
  this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(this, underlying);
}
export { $c_scm_CheckedIndexedSeqView$Reverse as $c_scm_CheckedIndexedSeqView$Reverse };
$c_scm_CheckedIndexedSeqView$Reverse.prototype = new $h_sc_IndexedSeqView$Reverse();
$c_scm_CheckedIndexedSeqView$Reverse.prototype.constructor = $c_scm_CheckedIndexedSeqView$Reverse;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Reverse() {
}
export { $h_scm_CheckedIndexedSeqView$Reverse as $h_scm_CheckedIndexedSeqView$Reverse };
$h_scm_CheckedIndexedSeqView$Reverse.prototype = $c_scm_CheckedIndexedSeqView$Reverse.prototype;
$c_scm_CheckedIndexedSeqView$Reverse.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.reverse__sc_IndexedSeqView = (function() {
  var x1 = this.scm_CheckedIndexedSeqView$Reverse__f_underlying;
  return ($is_sc_IndexedSeqView(x1) ? x1 : new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount));
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Reverse__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Reverse.prototype.reverse__O = (function() {
  return this.reverse__sc_IndexedSeqView();
});
var $d_scm_CheckedIndexedSeqView$Reverse = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Reverse, "scala.collection.mutable.CheckedIndexedSeqView$Reverse", ({
  scm_CheckedIndexedSeqView$Reverse: 1,
  sc_IndexedSeqView$Reverse: 1,
  sc_SeqView$Reverse: 1,
  sc_AbstractSeqView: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
export { $d_scm_CheckedIndexedSeqView$Reverse as $d_scm_CheckedIndexedSeqView$Reverse };
/** @constructor */
function $c_scm_CheckedIndexedSeqView$Take(underlying, n, mutationCount) {
  this.sc_View$Take__f_underlying = null;
  this.sc_View$Take__f_n = 0;
  this.sc_View$Take__f_normN = 0;
  this.sc_SeqView$Take__f_underlying = null;
  this.sc_SeqView$Take__f_n = 0;
  this.scm_CheckedIndexedSeqView$Take__f_mutationCount = null;
  this.scm_CheckedIndexedSeqView$Take__f_mutationCount = mutationCount;
  $ct_sc_IndexedSeqView$Take__sc_IndexedSeqOps__I__(this, underlying, n);
}
export { $c_scm_CheckedIndexedSeqView$Take as $c_scm_CheckedIndexedSeqView$Take };
$c_scm_CheckedIndexedSeqView$Take.prototype = new $h_sc_IndexedSeqView$Take();
$c_scm_CheckedIndexedSeqView$Take.prototype.constructor = $c_scm_CheckedIndexedSeqView$Take;
/** @constructor */
function $h_scm_CheckedIndexedSeqView$Take() {
}
export { $h_scm_CheckedIndexedSeqView$Take as $h_scm_CheckedIndexedSeqView$Take };
$h_scm_CheckedIndexedSeqView$Take.prototype = $c_scm_CheckedIndexedSeqView$Take.prototype;
$c_scm_CheckedIndexedSeqView$Take.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedIterator(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverseIterator__sc_Iterator = (function() {
  return new $c_scm_CheckedIndexedSeqView$CheckedReverseIterator(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.appended__O__sc_IndexedSeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.dropRight__I__sc_IndexedSeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__sc_IndexedSeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverse__sc_IndexedSeqView = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.reverse__O = (function() {
  return new $c_scm_CheckedIndexedSeqView$Reverse(this, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__sc_SeqView = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.map__F1__O = (function(f) {
  return new $c_scm_CheckedIndexedSeqView$Map(this, f, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.dropRight__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.dropRight__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$DropRight(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.drop__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Drop(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__sc_SeqView = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.take__I__O = (function(n) {
  return new $c_scm_CheckedIndexedSeqView$Take(this, n, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.appended__O__O = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
$c_scm_CheckedIndexedSeqView$Take.prototype.appended__O__sc_SeqView = (function(elem) {
  return new $c_scm_CheckedIndexedSeqView$Appended(this, elem, this.scm_CheckedIndexedSeqView$Take__f_mutationCount);
});
var $d_scm_CheckedIndexedSeqView$Take = new $TypeData().initClass($c_scm_CheckedIndexedSeqView$Take, "scala.collection.mutable.CheckedIndexedSeqView$Take", ({
  scm_CheckedIndexedSeqView$Take: 1,
  sc_IndexedSeqView$Take: 1,
  sc_SeqView$Take: 1,
  sc_View$Take: 1,
  sc_AbstractView: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_View: 1,
  Ljava_io_Serializable: 1,
  sc_SeqView: 1,
  sc_SeqOps: 1,
  sc_IndexedSeqView: 1,
  sc_IndexedSeqOps: 1,
  scm_CheckedIndexedSeqView: 1
}));
export { $d_scm_CheckedIndexedSeqView$Take as $d_scm_CheckedIndexedSeqView$Take };
function $is_scm_Set(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Set)));
}
export { $is_scm_Set as $is_scm_Set };
function $isArrayOf_scm_Set(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Set)));
}
export { $isArrayOf_scm_Set as $isArrayOf_scm_Set };
/** @constructor */
function $c_sci_Map$EmptyMap$() {
}
export { $c_sci_Map$EmptyMap$ as $c_sci_Map$EmptyMap$ };
$c_sci_Map$EmptyMap$.prototype = new $h_sci_AbstractMap();
$c_sci_Map$EmptyMap$.prototype.constructor = $c_sci_Map$EmptyMap$;
/** @constructor */
function $h_sci_Map$EmptyMap$() {
}
export { $h_sci_Map$EmptyMap$ as $h_sci_Map$EmptyMap$ };
$h_sci_Map$EmptyMap$.prototype = $c_sci_Map$EmptyMap$.prototype;
$c_sci_Map$EmptyMap$.prototype.size__I = (function() {
  return 0;
});
$c_sci_Map$EmptyMap$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Map$EmptyMap$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sci_Map$EmptyMap$.prototype.apply__O__E = (function(key) {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
});
$c_sci_Map$EmptyMap$.prototype.contains__O__Z = (function(key) {
  return false;
});
$c_sci_Map$EmptyMap$.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$();
});
$c_sci_Map$EmptyMap$.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return default$1.apply__O();
});
$c_sci_Map$EmptyMap$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Map$EmptyMap$.prototype.keysIterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Map$EmptyMap$.prototype.valuesIterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Map$EmptyMap$.prototype.concat__sc_IterableOnce__sci_Map = (function(suffix) {
  return ($is_sci_Map(suffix) ? suffix : $f_sc_MapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix));
});
$c_sci_Map$EmptyMap$.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_Map(suffix);
});
$c_sci_Map$EmptyMap$.prototype.removed__O__sci_MapOps = (function(key) {
  return this;
});
$c_sci_Map$EmptyMap$.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return new $c_sci_Map$Map1(key, value);
});
$c_sci_Map$EmptyMap$.prototype.apply__O__O = (function(key) {
  this.apply__O__E(key);
});
var $d_sci_Map$EmptyMap$ = new $TypeData().initClass($c_sci_Map$EmptyMap$, "scala.collection.immutable.Map$EmptyMap$", ({
  sci_Map$EmptyMap$: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Map$EmptyMap$ as $d_sci_Map$EmptyMap$ };
var $n_sci_Map$EmptyMap$;
function $m_sci_Map$EmptyMap$() {
  if ((!$n_sci_Map$EmptyMap$)) {
    $n_sci_Map$EmptyMap$ = new $c_sci_Map$EmptyMap$();
  }
  return $n_sci_Map$EmptyMap$;
}
export { $m_sci_Map$EmptyMap$ as $m_sci_Map$EmptyMap$ };
function $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__($thiz, outer) {
  $thiz.sci_MapOps$ImmutableKeySet__f_$outer = outer;
  return $thiz;
}
export { $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__ as $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__ };
/** @constructor */
function $c_sci_MapOps$ImmutableKeySet() {
  this.sci_MapOps$ImmutableKeySet__f_$outer = null;
}
export { $c_sci_MapOps$ImmutableKeySet as $c_sci_MapOps$ImmutableKeySet };
$c_sci_MapOps$ImmutableKeySet.prototype = new $h_sci_AbstractSet();
$c_sci_MapOps$ImmutableKeySet.prototype.constructor = $c_sci_MapOps$ImmutableKeySet;
/** @constructor */
function $h_sci_MapOps$ImmutableKeySet() {
}
export { $h_sci_MapOps$ImmutableKeySet as $h_sci_MapOps$ImmutableKeySet };
$h_sci_MapOps$ImmutableKeySet.prototype = $c_sci_MapOps$ImmutableKeySet.prototype;
$c_sci_MapOps$ImmutableKeySet.prototype.iterator__sc_Iterator = (function() {
  return this.sci_MapOps$ImmutableKeySet__f_$outer.keysIterator__sc_Iterator();
});
$c_sci_MapOps$ImmutableKeySet.prototype.contains__O__Z = (function(key) {
  return this.sci_MapOps$ImmutableKeySet__f_$outer.contains__O__Z(key);
});
$c_sci_MapOps$ImmutableKeySet.prototype.size__I = (function() {
  return this.sci_MapOps$ImmutableKeySet__f_$outer.size__I();
});
$c_sci_MapOps$ImmutableKeySet.prototype.knownSize__I = (function() {
  return this.sci_MapOps$ImmutableKeySet__f_$outer.knownSize__I();
});
$c_sci_MapOps$ImmutableKeySet.prototype.isEmpty__Z = (function() {
  return this.sci_MapOps$ImmutableKeySet__f_$outer.isEmpty__Z();
});
$c_sci_MapOps$ImmutableKeySet.prototype.incl__O__sci_Set = (function(elem) {
  if (this.sci_MapOps$ImmutableKeySet__f_$outer.contains__O__Z(elem)) {
    return this;
  } else {
    var this$2 = $m_sci_Set$EmptySet$();
    var this$3 = $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this$2, this);
    return this$3.incl__O__sci_SetOps(elem);
  }
});
$c_sci_MapOps$ImmutableKeySet.prototype.excl__O__sci_Set = (function(elem) {
  if (this.sci_MapOps$ImmutableKeySet__f_$outer.contains__O__Z(elem)) {
    var this$2 = $m_sci_Set$EmptySet$();
    var this$3 = $f_sc_SetOps__concat__sc_IterableOnce__sc_SetOps(this$2, this);
    return this$3.excl__O__sci_SetOps(elem);
  } else {
    return this;
  }
});
$c_sci_MapOps$ImmutableKeySet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_MapOps$ImmutableKeySet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $isArrayOf_sci_MapOps$ImmutableKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_MapOps$ImmutableKeySet)));
}
export { $isArrayOf_sci_MapOps$ImmutableKeySet as $isArrayOf_sci_MapOps$ImmutableKeySet };
var $d_sci_MapOps$ImmutableKeySet = new $TypeData().initClass($c_sci_MapOps$ImmutableKeySet, "scala.collection.immutable.MapOps$ImmutableKeySet", ({
  sci_MapOps$ImmutableKeySet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_MapOps$ImmutableKeySet as $d_sci_MapOps$ImmutableKeySet };
function $f_scm_Buffer__subtractOne__O__scm_Buffer($thiz, x) {
  var i = $thiz.indexOf__O__I__I(x, 0);
  if ((i !== (-1))) {
    $thiz.remove__I__O(i);
  }
  return $thiz;
}
export { $f_scm_Buffer__subtractOne__O__scm_Buffer as $f_scm_Buffer__subtractOne__O__scm_Buffer };
function $f_Lcats_effect_kernel_Sync__$init$__V($thiz) {
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V($m_Lcats_effect_kernel_Sync$Type$Delay$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V($m_Lcats_effect_kernel_Sync$Type$Blocking$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V($m_Lcats_effect_kernel_Sync$Type$InterruptibleOnce$());
  $thiz.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V($m_Lcats_effect_kernel_Sync$Type$InterruptibleMany$());
}
export { $f_Lcats_effect_kernel_Sync__$init$__V as $f_Lcats_effect_kernel_Sync__$init$__V };
function $f_Lcats_effect_kernel_Sync__unique__O($thiz) {
  return $thiz.delay__F0__O(new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => new $c_Lcats_effect_kernel_Unique$Token())));
}
export { $f_Lcats_effect_kernel_Sync__unique__O as $f_Lcats_effect_kernel_Sync__unique__O };
/** @constructor */
function $c_Lcats_kernel_Eq$() {
}
export { $c_Lcats_kernel_Eq$ as $c_Lcats_kernel_Eq$ };
$c_Lcats_kernel_Eq$.prototype = new $h_Lcats_kernel_EqFunctions();
$c_Lcats_kernel_Eq$.prototype.constructor = $c_Lcats_kernel_Eq$;
/** @constructor */
function $h_Lcats_kernel_Eq$() {
}
export { $h_Lcats_kernel_Eq$ as $h_Lcats_kernel_Eq$ };
$h_Lcats_kernel_Eq$.prototype = $c_Lcats_kernel_Eq$.prototype;
var $d_Lcats_kernel_Eq$ = new $TypeData().initClass($c_Lcats_kernel_Eq$, "cats.kernel.Eq$", ({
  Lcats_kernel_Eq$: 1,
  Lcats_kernel_EqFunctions: 1,
  Lcats_kernel_EqToEquivConversion: 1,
  Lcats_kernel_ScalaVersionSpecificEqInstances: 1,
  Lcats_kernel_ScalaVersionSpecificHashInstances: 1,
  Lcats_kernel_ScalaVersionSpecificPartialOrderInstances: 1,
  Lcats_kernel_ScalaVersionSpecificOrderInstances: 1,
  Lcats_kernel_instances_TupleEqInstances: 1,
  Lcats_kernel_instances_TupleHashInstances: 1,
  Lcats_kernel_instances_TuplePartialOrderInstances: 1,
  Lcats_kernel_instances_TupleOrderInstances: 1,
  Lcats_kernel_EqInstances0: 1,
  Lcats_kernel_EqInstances: 1,
  Lcats_kernel_HashInstances0: 1,
  Lcats_kernel_HashInstances: 1,
  Lcats_kernel_PartialOrderInstances0: 1,
  Lcats_kernel_PartialOrderInstances1: 1,
  Lcats_kernel_PartialOrderInstances: 1,
  Lcats_kernel_OrderInstances0: 1,
  Lcats_kernel_OrderInstances1: 1
}));
export { $d_Lcats_kernel_Eq$ as $d_Lcats_kernel_Eq$ };
var $n_Lcats_kernel_Eq$;
function $m_Lcats_kernel_Eq$() {
  if ((!$n_Lcats_kernel_Eq$)) {
    $n_Lcats_kernel_Eq$ = new $c_Lcats_kernel_Eq$();
  }
  return $n_Lcats_kernel_Eq$;
}
export { $m_Lcats_kernel_Eq$ as $m_Lcats_kernel_Eq$ };
/** @constructor */
function $c_Lcats_kernel_Semigroup$() {
}
export { $c_Lcats_kernel_Semigroup$ as $c_Lcats_kernel_Semigroup$ };
$c_Lcats_kernel_Semigroup$.prototype = new $h_Lcats_kernel_SemigroupFunctions();
$c_Lcats_kernel_Semigroup$.prototype.constructor = $c_Lcats_kernel_Semigroup$;
/** @constructor */
function $h_Lcats_kernel_Semigroup$() {
}
export { $h_Lcats_kernel_Semigroup$ as $h_Lcats_kernel_Semigroup$ };
$h_Lcats_kernel_Semigroup$.prototype = $c_Lcats_kernel_Semigroup$.prototype;
var $d_Lcats_kernel_Semigroup$ = new $TypeData().initClass($c_Lcats_kernel_Semigroup$, "cats.kernel.Semigroup$", ({
  Lcats_kernel_Semigroup$: 1,
  Lcats_kernel_SemigroupFunctions: 1,
  Lcats_kernel_ScalaVersionSpecificMonoidInstances: 1,
  Lcats_kernel_instances_TupleSemigroupInstances: 1,
  Lcats_kernel_instances_TupleBandInstances: 1,
  Lcats_kernel_instances_TupleCommutativeSemigroupInstances: 1,
  Lcats_kernel_instances_TupleMonoidInstances: 1,
  Lcats_kernel_instances_TupleSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleCommutativeMonoidInstances: 1,
  Lcats_kernel_instances_TupleGroupInstances: 1,
  Lcats_kernel_instances_TupleBoundedSemilatticeInstances: 1,
  Lcats_kernel_instances_TupleCommutativeGroupInstances: 1,
  Lcats_kernel_SemigroupInstances: 1,
  Lcats_kernel_CommutativeSemigroupInstances: 1,
  Lcats_kernel_BandInstances: 1,
  Lcats_kernel_MonoidInstances: 1,
  Lcats_kernel_CommutativeMonoidInstances: 1,
  Lcats_kernel_SemilatticeInstances: 1,
  Lcats_kernel_BoundedSemilatticeInstances: 1,
  Lcats_kernel_GroupInstances: 1
}));
export { $d_Lcats_kernel_Semigroup$ as $d_Lcats_kernel_Semigroup$ };
var $n_Lcats_kernel_Semigroup$;
function $m_Lcats_kernel_Semigroup$() {
  if ((!$n_Lcats_kernel_Semigroup$)) {
    $n_Lcats_kernel_Semigroup$ = new $c_Lcats_kernel_Semigroup$();
  }
  return $n_Lcats_kernel_Semigroup$;
}
export { $m_Lcats_kernel_Semigroup$ as $m_Lcats_kernel_Semigroup$ };
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set($thiz, newHashMap) {
  return ((newHashMap === $thiz.sci_MapOps$ImmutableKeySet__f_$outer) ? $thiz : newHashMap.keySet__sci_Set());
}
export { $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set as $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set };
function $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set($thiz, newRootNode) {
  return ((newRootNode === $thiz.sci_MapOps$ImmutableKeySet__f_$outer.sci_HashMap__f_rootNode) ? $thiz : new $c_sci_HashMap(newRootNode).keySet__sci_Set());
}
export { $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set as $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set };
/** @constructor */
function $c_sci_HashMap$HashKeySet(outer) {
  this.sci_MapOps$ImmutableKeySet__f_$outer = null;
  $ct_sci_MapOps$ImmutableKeySet__sci_MapOps__(this, outer);
}
export { $c_sci_HashMap$HashKeySet as $c_sci_HashMap$HashKeySet };
$c_sci_HashMap$HashKeySet.prototype = new $h_sci_MapOps$ImmutableKeySet();
$c_sci_HashMap$HashKeySet.prototype.constructor = $c_sci_HashMap$HashKeySet;
/** @constructor */
function $h_sci_HashMap$HashKeySet() {
}
export { $h_sci_HashMap$HashKeySet as $h_sci_HashMap$HashKeySet };
$h_sci_HashMap$HashKeySet.prototype = $c_sci_HashMap$HashKeySet.prototype;
$c_sci_HashMap$HashKeySet.prototype.incl__O__sci_Set = (function(elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  var improvedHash = $m_sc_Hashing$().improve__I__I(originalHash);
  var newNode = this.sci_MapOps$ImmutableKeySet__f_$outer.sci_HashMap__f_rootNode.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(elem, null, originalHash, improvedHash, 0, false);
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_BitmapIndexedMapNode__sci_Set(this, newNode);
});
$c_sci_HashMap$HashKeySet.prototype.excl__O__sci_Set = (function(elem) {
  var this$1 = this.sci_MapOps$ImmutableKeySet__f_$outer;
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$1.removed__O__sci_HashMap(elem));
});
$c_sci_HashMap$HashKeySet.prototype.filter__F1__sci_Set = (function(pred) {
  var this$1 = this.sci_MapOps$ImmutableKeySet__f_$outer;
  var pred$1 = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((kv$2$2) => (!(!pred.apply__O__O(kv$2$2._1__O())))));
  return $p_sci_HashMap$HashKeySet__newKeySetOrThis__sci_HashMap__sci_Set(this, this$1.filterImpl__F1__Z__sci_HashMap(pred$1, false));
});
$c_sci_HashMap$HashKeySet.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_Set(pred);
});
$c_sci_HashMap$HashKeySet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_Set(elem);
});
$c_sci_HashMap$HashKeySet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_Set(elem);
});
function $isArrayOf_sci_HashMap$HashKeySet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashMap$HashKeySet)));
}
export { $isArrayOf_sci_HashMap$HashKeySet as $isArrayOf_sci_HashMap$HashKeySet };
var $d_sci_HashMap$HashKeySet = new $TypeData().initClass($c_sci_HashMap$HashKeySet, "scala.collection.immutable.HashMap$HashKeySet", ({
  sci_HashMap$HashKeySet: 1,
  sci_MapOps$ImmutableKeySet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sc_MapOps$GenKeySet: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_HashMap$HashKeySet as $d_sci_HashMap$HashKeySet };
/** @constructor */
function $c_sci_Map$Map1(key1, value1) {
  this.sci_Map$Map1__f_key1 = null;
  this.sci_Map$Map1__f_value1 = null;
  this.sci_Map$Map1__f_key1 = key1;
  this.sci_Map$Map1__f_value1 = value1;
}
export { $c_sci_Map$Map1 as $c_sci_Map$Map1 };
$c_sci_Map$Map1.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map1.prototype.constructor = $c_sci_Map$Map1;
/** @constructor */
function $h_sci_Map$Map1() {
}
export { $h_sci_Map$Map1 as $h_sci_Map$Map1 };
$h_sci_Map$Map1.prototype = $c_sci_Map$Map1.prototype;
$c_sci_Map$Map1.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map1.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Map$Map1.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Map$Map1.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map1.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map1.prototype.size__I = (function() {
  return 1;
});
$c_sci_Map$Map1.prototype.knownSize__I = (function() {
  return 1;
});
$c_sci_Map$Map1.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map1.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1)) {
    return this.sci_Map$Map1__f_value1;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map1.prototype.contains__O__Z = (function(key) {
  return $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1);
});
$c_sci_Map$Map1.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_s_Some(this.sci_Map$Map1__f_value1) : $m_s_None$());
});
$c_sci_Map$Map1.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? this.sci_Map$Map1__f_value1 : default$1.apply__O());
});
$c_sci_Map$Map1.prototype.iterator__sc_Iterator = (function() {
  var a = $ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Map$Map1.prototype.keysIterator__sc_Iterator = (function() {
  var a = this.sci_Map$Map1__f_key1;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Map$Map1.prototype.valuesIterator__sc_Iterator = (function() {
  var a = this.sci_Map$Map1__f_value1;
  return new $c_sc_Iterator$$anon$20(a);
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? new $c_sci_Map$Map1(this.sci_Map$Map1__f_key1, value) : new $c_sci_Map$Map2(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1, key, value));
});
$c_sci_Map$Map1.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map1__f_key1) ? $m_sci_Map$EmptyMap$() : this);
});
$c_sci_Map$Map1.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1));
});
$c_sci_Map$Map1.prototype.exists__F1__Z = (function(p) {
  return (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1))));
});
$c_sci_Map$Map1.prototype.forall__F1__Z = (function(p) {
  return (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1))));
});
$c_sci_Map$Map1.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  return (((!(!pred.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1)))) !== isFlipped) ? this : $m_sci_Map$EmptyMap$());
});
$c_sci_Map$Map1.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map1__f_key1, this.sci_Map$Map1__f_value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 1);
});
$c_sci_Map$Map1.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map1.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $isArrayOf_sci_Map$Map1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map1)));
}
export { $isArrayOf_sci_Map$Map1 as $isArrayOf_sci_Map$Map1 };
var $d_sci_Map$Map1 = new $TypeData().initClass($c_sci_Map$Map1, "scala.collection.immutable.Map$Map1", ({
  sci_Map$Map1: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Map$Map1 as $d_sci_Map$Map1 };
/** @constructor */
function $c_sci_Map$Map2(key1, value1, key2, value2) {
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = null;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1 = key1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 = value1;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2 = key2;
  this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 = value2;
}
export { $c_sci_Map$Map2 as $c_sci_Map$Map2 };
$c_sci_Map$Map2.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map2.prototype.constructor = $c_sci_Map$Map2;
/** @constructor */
function $h_sci_Map$Map2() {
}
export { $h_sci_Map$Map2 as $h_sci_Map$Map2 };
$h_sci_Map$Map2.prototype = $c_sci_Map$Map2.prototype;
$c_sci_Map$Map2.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map2.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Map$Map2.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Map$Map2.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map2.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map2.prototype.size__I = (function() {
  return 2;
});
$c_sci_Map$Map2.prototype.knownSize__I = (function() {
  return 2;
});
$c_sci_Map$Map2.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map2.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2)) {
    return this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map2.prototype.contains__O__Z = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2));
});
$c_sci_Map$Map2.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_s_Some(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : $m_s_None$()));
});
$c_sci_Map$Map2.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2 : default$1.apply__O()));
});
$c_sci_Map$Map2.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$1(this);
});
$c_sci_Map$Map2.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$2(this);
});
$c_sci_Map$Map2.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map2$$anon$3(this);
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, value, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, value) : new $c_sci_Map$Map3(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2, key, value)));
});
$c_sci_Map$Map2.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2) ? new $c_sci_Map$Map1(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1) : this));
});
$c_sci_Map$Map2.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2));
});
$c_sci_Map$Map2.prototype.exists__F1__Z = (function(p) {
  return ((!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1)))) || (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2)))));
});
$c_sci_Map$Map2.prototype.forall__F1__Z = (function(p) {
  return ((!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1)))) && (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2)))));
});
$c_sci_Map$Map2.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var v1 = null;
  var n = 0;
  if (((!(!pred.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1)))) !== isFlipped)) {
    k1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1;
    v1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2;
      v1 = this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Map$Map2.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key1, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$key2, this.sci_Map$Map2__f_scala$collection$immutable$Map$Map2$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 2);
});
$c_sci_Map$Map2.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map2.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $isArrayOf_sci_Map$Map2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map2)));
}
export { $isArrayOf_sci_Map$Map2 as $isArrayOf_sci_Map$Map2 };
var $d_sci_Map$Map2 = new $TypeData().initClass($c_sci_Map$Map2, "scala.collection.immutable.Map$Map2", ({
  sci_Map$Map2: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Map$Map2 as $d_sci_Map$Map2 };
/** @constructor */
function $c_sci_Map$Map3(key1, value1, key2, value2, key3, value3) {
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = null;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1 = key1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 = value1;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2 = key2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 = value2;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3 = key3;
  this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 = value3;
}
export { $c_sci_Map$Map3 as $c_sci_Map$Map3 };
$c_sci_Map$Map3.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map3.prototype.constructor = $c_sci_Map$Map3;
/** @constructor */
function $h_sci_Map$Map3() {
}
export { $h_sci_Map$Map3 as $h_sci_Map$Map3 };
$h_sci_Map$Map3.prototype = $c_sci_Map$Map3.prototype;
$c_sci_Map$Map3.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map3.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Map$Map3.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Map$Map3.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map3.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map3.prototype.size__I = (function() {
  return 3;
});
$c_sci_Map$Map3.prototype.knownSize__I = (function() {
  return 3;
});
$c_sci_Map$Map3.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map3.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3)) {
    return this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map3.prototype.contains__O__Z = (function(key) {
  return (($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3));
});
$c_sci_Map$Map3.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_s_Some(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : $m_s_None$())));
});
$c_sci_Map$Map3.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3 : default$1.apply__O())));
});
$c_sci_Map$Map3.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$4(this);
});
$c_sci_Map$Map3.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$5(this);
});
$c_sci_Map$Map3.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map3$$anon$6(this);
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_Map = (function(key, value) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, value, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, value) : new $c_sci_Map$Map4(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3, key, value))));
});
$c_sci_Map$Map3.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3) ? new $c_sci_Map$Map2(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2) : this)));
});
$c_sci_Map$Map3.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3));
});
$c_sci_Map$Map3.prototype.exists__F1__Z = (function(p) {
  return (((!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1)))) || (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2))))) || (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3)))));
});
$c_sci_Map$Map3.prototype.forall__F1__Z = (function(p) {
  return (((!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1)))) && (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2))))) && (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3)))));
});
$c_sci_Map$Map3.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var v1 = null;
  var v2 = null;
  var n = 0;
  if (((!(!pred.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1)))) !== isFlipped)) {
    k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1;
    v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2;
      v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2;
    } else {
      k2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2;
      v2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3;
      v1 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3;
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3;
      v2 = this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break;
    }
    case 3: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Map$Map3.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key1, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key2, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$key3, this.sci_Map$Map3__f_scala$collection$immutable$Map$Map3$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 3);
});
$c_sci_Map$Map3.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map3.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $isArrayOf_sci_Map$Map3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map3)));
}
export { $isArrayOf_sci_Map$Map3 as $isArrayOf_sci_Map$Map3 };
var $d_sci_Map$Map3 = new $TypeData().initClass($c_sci_Map$Map3, "scala.collection.immutable.Map$Map3", ({
  sci_Map$Map3: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Map$Map3 as $d_sci_Map$Map3 };
/** @constructor */
function $c_sci_Map$Map4(key1, value1, key2, value2, key3, value3, key4, value4) {
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = null;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1 = key1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 = value1;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2 = key2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 = value2;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3 = key3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 = value3;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4 = key4;
  this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 = value4;
}
export { $c_sci_Map$Map4 as $c_sci_Map$Map4 };
$c_sci_Map$Map4.prototype = new $h_sci_AbstractMap();
$c_sci_Map$Map4.prototype.constructor = $c_sci_Map$Map4;
/** @constructor */
function $h_sci_Map$Map4() {
}
export { $h_sci_Map$Map4 as $h_sci_Map$Map4 };
$h_sci_Map$Map4.prototype = $c_sci_Map$Map4.prototype;
$c_sci_Map$Map4.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Map$Map4.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Map$Map4.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_Map$Map4.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Map(pred, false);
});
$c_sci_Map$Map4.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_Map$Map4.prototype.size__I = (function() {
  return 4;
});
$c_sci_Map$Map4.prototype.knownSize__I = (function() {
  return 4;
});
$c_sci_Map$Map4.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Map$Map4.prototype.apply__O__O = (function(key) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + key));
  }
});
$c_sci_Map$Map4.prototype.contains__O__Z = (function(key) {
  return ((($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) || $m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4));
});
$c_sci_Map$Map4.prototype.get__O__s_Option = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_s_Some(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : $m_s_None$()))));
});
$c_sci_Map$Map4.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3 : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4 : default$1.apply__O()))));
});
$c_sci_Map$Map4.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$7(this);
});
$c_sci_Map$Map4.prototype.keysIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$8(this);
});
$c_sci_Map$Map4.prototype.valuesIterator__sc_Iterator = (function() {
  return new $c_sci_Map$Map4$$anon$9(this);
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_Map = (function(key, value) {
  if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, value, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4)) {
    return new $c_sci_Map$Map4(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, value);
  } else {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap.updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3).updated__O__O__sci_HashMap(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4).updated__O__O__sci_HashMap(key, value);
  }
});
$c_sci_Map$Map4.prototype.removed__O__sci_Map = (function(key) {
  return ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4) : ($m_sr_BoxesRunTime$().equals__O__O__Z(key, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4) ? new $c_sci_Map$Map3(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3) : this))));
});
$c_sci_Map$Map4.prototype.foreach__F1__V = (function(f) {
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3));
  f.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4));
});
$c_sci_Map$Map4.prototype.exists__F1__Z = (function(p) {
  return ((((!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1)))) || (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2))))) || (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3))))) || (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)))));
});
$c_sci_Map$Map4.prototype.forall__F1__Z = (function(p) {
  return ((((!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1)))) && (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2))))) && (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3))))) && (!(!p.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)))));
});
$c_sci_Map$Map4.prototype.filterImpl__F1__Z__sci_Map = (function(pred, isFlipped) {
  var k1 = null;
  var k2 = null;
  var k3 = null;
  var v1 = null;
  var v2 = null;
  var v3 = null;
  var n = 0;
  if (((!(!pred.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1)))) !== isFlipped)) {
    k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1;
    v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1;
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2;
    } else {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
    } else {
      k3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3;
      v3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3;
    }
    n = ((1 + n) | 0);
  }
  if (((!(!pred.apply__O__O($ct_T2__O__O__(new $c_T2(), this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4)))) !== isFlipped)) {
    if ((n === 0)) {
      k1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v1 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
    } else if ((n === 1)) {
      k2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v2 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
    } else if ((n === 2)) {
      k3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4;
      v3 = this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4;
    }
    n = ((1 + n) | 0);
  }
  var x1 = n;
  switch (x1) {
    case 0: {
      return $m_sci_Map$EmptyMap$();
      break;
    }
    case 1: {
      return new $c_sci_Map$Map1(k1, v1);
      break;
    }
    case 2: {
      return new $c_sci_Map$Map2(k1, v1, k2, v2);
      break;
    }
    case 3: {
      return new $c_sci_Map$Map3(k1, v1, k2, v2, k3, v3);
      break;
    }
    case 4: {
      return this;
      break;
    }
    default: {
      throw new $c_s_MatchError(x1);
    }
  }
});
$c_sci_Map$Map4.prototype.buildTo__sci_HashMapBuilder__sci_HashMapBuilder = (function(builder) {
  return builder.addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3).addOne__O__O__sci_HashMapBuilder(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
});
$c_sci_Map$Map4.prototype.hashCode__I = (function() {
  var a = 0;
  var b = 0;
  var c = 1;
  var h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key1, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value1);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key2, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value2);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key3, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value3);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().tuple2Hash__O__O__I(this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$key4, this.sci_Map$Map4__f_scala$collection$immutable$Map$Map4$$value4);
  a = ((a + h) | 0);
  b = (b ^ h);
  c = Math.imul(c, (1 | h));
  h = $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed;
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, a);
  h = $m_s_util_hashing_MurmurHash3$().mix__I__I__I(h, b);
  h = $m_s_util_hashing_MurmurHash3$().mixLast__I__I__I(h, c);
  return $m_s_util_hashing_MurmurHash3$().finalizeHash__I__I__I(h, 4);
});
$c_sci_Map$Map4.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_Map(key);
});
$c_sci_Map$Map4.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_Map(key, value);
});
function $isArrayOf_sci_Map$Map4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Map$Map4)));
}
export { $isArrayOf_sci_Map$Map4 as $isArrayOf_sci_Map$Map4 };
var $d_sci_Map$Map4 = new $TypeData().initClass($c_sci_Map$Map4, "scala.collection.immutable.Map$Map4", ({
  sci_Map$Map4: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Map$Map4 as $d_sci_Map$Map4 };
function $f_scm_Map__withDefaultValue__O__scm_Map($thiz, d) {
  return new $c_scm_Map$WithDefault($thiz, new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => d)));
}
export { $f_scm_Map__withDefaultValue__O__scm_Map as $f_scm_Map__withDefaultValue__O__scm_Map };
function $is_scm_Map(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.scm_Map)));
}
export { $is_scm_Map as $is_scm_Map };
function $isArrayOf_scm_Map(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_Map)));
}
export { $isArrayOf_scm_Map as $isArrayOf_scm_Map };
/** @constructor */
function $c_Lcats_EvalInstances$$anon$6() {
}
export { $c_Lcats_EvalInstances$$anon$6 as $c_Lcats_EvalInstances$$anon$6 };
$c_Lcats_EvalInstances$$anon$6.prototype = new $h_O();
$c_Lcats_EvalInstances$$anon$6.prototype.constructor = $c_Lcats_EvalInstances$$anon$6;
/** @constructor */
function $h_Lcats_EvalInstances$$anon$6() {
}
export { $h_Lcats_EvalInstances$$anon$6 as $h_Lcats_EvalInstances$$anon$6 };
$h_Lcats_EvalInstances$$anon$6.prototype = $c_Lcats_EvalInstances$$anon$6.prototype;
$c_Lcats_EvalInstances$$anon$6.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return fa.map__F1__Lcats_Eval(f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_EvalInstances$$anon$6.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_EvalInstances$$anon$6.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_EvalInstances$$anon$6.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_EvalInstances$$anon$6.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_EvalInstances$$anon$6.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_EvalInstances$$anon$6.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lcats_EvalInstances$$anon$6.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.map__O__F1__O = (function(fa, f) {
  return fa.map__F1__Lcats_Eval(f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.pure__O__O = (function(x) {
  return new $c_Lcats_Now(x);
});
$c_Lcats_EvalInstances$$anon$6.prototype.flatMap__O__F1__O = (function(fa, f) {
  return fa.flatMap__F1__Lcats_Eval(f);
});
$c_Lcats_EvalInstances$$anon$6.prototype.unit__O = (function() {
  return $m_Lcats_Eval$().Lcats_Eval$__f_Unit;
});
$c_Lcats_EvalInstances$$anon$6.prototype.void__O__O = (function(fa) {
  return $m_Lcats_Eval$().Lcats_Eval$__f_Unit;
});
var $d_Lcats_EvalInstances$$anon$6 = new $TypeData().initClass($c_Lcats_EvalInstances$$anon$6, "cats.EvalInstances$$anon$6", ({
  Lcats_EvalInstances$$anon$6: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1
}));
export { $d_Lcats_EvalInstances$$anon$6 as $d_Lcats_EvalInstances$$anon$6 };
/** @constructor */
function $c_Lcats_instances_EitherInstances$$anon$2() {
}
export { $c_Lcats_instances_EitherInstances$$anon$2 as $c_Lcats_instances_EitherInstances$$anon$2 };
$c_Lcats_instances_EitherInstances$$anon$2.prototype = new $h_O();
$c_Lcats_instances_EitherInstances$$anon$2.prototype.constructor = $c_Lcats_instances_EitherInstances$$anon$2;
/** @constructor */
function $h_Lcats_instances_EitherInstances$$anon$2() {
}
export { $h_Lcats_instances_EitherInstances$$anon$2 as $h_Lcats_instances_EitherInstances$$anon$2 };
$h_Lcats_instances_EitherInstances$$anon$2.prototype = $c_Lcats_instances_EitherInstances$$anon$2.prototype;
$c_Lcats_instances_EitherInstances$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return fa.map__F1__s_util_Either(f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__s_util_Either__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unit__s_util_Either = (function() {
  return $m_Lcats_syntax_EitherUtil$().Lcats_syntax_EitherUtil$__f_unit;
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleErrorWith__s_util_Either__F1__s_util_Either = (function(fea, f) {
  if ((fea instanceof $c_s_util_Left)) {
    var e = fea.s_util_Left__f_value;
    return f.apply__O__O(e);
  }
  if ((fea instanceof $c_s_util_Right)) {
    return fea;
  }
  throw new $c_s_MatchError(fea);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.tailRecM__O__F1__s_util_Either = (function(b, f) {
  var b$tailLocal1 = b;
  while (true) {
    var x26 = f.apply__O__O(b$tailLocal1);
    if ((x26 instanceof $c_s_util_Left)) {
      return x26;
    }
    if ((x26 instanceof $c_s_util_Right)) {
      var e = x26.s_util_Right__f_value;
      if ((e instanceof $c_s_util_Left)) {
        var b1 = e.s_util_Left__f_value;
        b$tailLocal1 = b1;
        continue;
      }
      if ((e instanceof $c_s_util_Right)) {
        return e;
      }
      throw new $c_s_MatchError(e);
    }
    throw new $c_s_MatchError(x26);
  }
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2Eval__s_util_Either__Lcats_Eval__F2__Lcats_Eval = (function(fb, fc, f) {
  if ((fb instanceof $c_s_util_Left)) {
    $m_Lcats_syntax_EitherUtil$();
    return new $c_Lcats_Now(fb);
  }
  if ((fb instanceof $c_s_util_Right)) {
    var b = fb.s_util_Right__f_value;
    return fc.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$10) => {
      if ((_$10 instanceof $c_s_util_Right)) {
        var b$1 = _$10.s_util_Right__f_value;
        return new $c_s_util_Right(f.apply__O__O__O(b, b$1));
      } else {
        return _$10;
      }
    })));
  }
  throw new $c_s_MatchError(fb);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse__s_util_Either__F1__Lcats_Applicative__O = (function(fa, f, F) {
  if ((fa instanceof $c_s_util_Left)) {
    return F.pure__O__O(fa);
  }
  if ((fa instanceof $c_s_util_Right)) {
    var b = fa.s_util_Right__f_value;
    return F.map__O__F1__O(f.apply__O__O(b), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$13) => new $c_s_util_Right(_$13))));
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldLeft__s_util_Either__O__F2__O = (function(fa, c, f) {
  if ((fa instanceof $c_s_util_Left)) {
    return c;
  }
  if ((fa instanceof $c_s_util_Right)) {
    var b = fa.s_util_Right__f_value;
    return f.apply__O__O__O(c, b);
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldRight__s_util_Either__Lcats_Eval__F2__Lcats_Eval = (function(fa, lc, f) {
  if ((fa instanceof $c_s_util_Left)) {
    return lc;
  }
  if ((fa instanceof $c_s_util_Right)) {
    var b = fa.s_util_Right__f_value;
    return f.apply__O__O__O(b, lc);
  }
  throw new $c_s_MatchError(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.size__s_util_Either__J = (function(fab) {
  if ((fab instanceof $c_s_util_Right)) {
    return new $c_RTLong(1, 0);
  } else {
    if ((!(fab instanceof $c_s_util_Left))) {
      throw new $c_s_MatchError(fab);
    }
    return $L0;
  }
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldMap__s_util_Either__F1__Lcats_kernel_Monoid__O = (function(fab, f, C) {
  if ((fab instanceof $c_s_util_Right)) {
    var b = fab.s_util_Right__f_value;
    return f.apply__O__O(b);
  } else if ((fab instanceof $c_s_util_Left)) {
    return C.empty__O();
  } else {
    throw new $c_s_MatchError(fab);
  }
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.toList__s_util_Either__sci_List = (function(fab) {
  if ((fab instanceof $c_s_util_Right)) {
    var a = fab.s_util_Right__f_value;
    var this$1 = $m_sci_Nil$();
    return new $c_sci_$colon$colon(a, this$1);
  }
  if ((fab instanceof $c_s_util_Left)) {
    return $m_sci_Nil$();
  }
  throw new $c_s_MatchError(fab);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.void__s_util_Either__s_util_Either = (function(e) {
  return (e.isRight__Z() ? $m_Lcats_syntax_EitherUtil$().Lcats_syntax_EitherUtil$__f_unit : e);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.unit__O = (function() {
  return this.unit__s_util_Either();
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.pure__O__O = (function(x) {
  return new $c_s_util_Right(x);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  return fa.flatMap__F1__s_util_Either(f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return this.handleErrorWith__s_util_Either__F1__s_util_Either(fa, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.raiseError__O__O = (function(e) {
  return new $c_s_util_Left(e);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  return fa.map__F1__s_util_Either(f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__s_util_Either(a, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__s_util_Either__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__s_util_Either__F1__Lcats_Applicative__O(fa, f, evidence$1);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return this.foldLeft__s_util_Either__O__F2__O(fa, b, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__s_util_Either__Lcats_Eval__F2__Lcats_Eval(fa, lb, f);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.attempt__O__O = (function(fa) {
  return new $c_s_util_Right(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.size__O__J = (function(fa) {
  return this.size__s_util_Either__J(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__s_util_Either__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.exists__O__F1__Z = (function(fa, p) {
  return fa.exists__F1__Z(p);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.toList__O__sci_List = (function(fa) {
  return this.toList__s_util_Either__sci_List(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return this.toList__s_util_Either__sci_List(fa);
});
$c_Lcats_instances_EitherInstances$$anon$2.prototype.void__O__O = (function(fa) {
  return this.void__s_util_Either__s_util_Either(fa);
});
var $d_Lcats_instances_EitherInstances$$anon$2 = new $TypeData().initClass($c_Lcats_instances_EitherInstances$$anon$2, "cats.instances.EitherInstances$$anon$2", ({
  Lcats_instances_EitherInstances$$anon$2: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_instances_EitherInstances$$anon$2 as $d_Lcats_instances_EitherInstances$$anon$2 };
function $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet($thiz, newRootNode) {
  return (($thiz.sci_HashSet__f_rootNode === newRootNode) ? $thiz : new $c_sci_HashSet(newRootNode));
}
export { $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet as $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet };
function $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet($thiz, that) {
  var iter = that.iterator__sc_Iterator();
  var curr = $thiz.sci_HashSet__f_rootNode;
  while (iter.hasNext__Z()) {
    var next = iter.next__O();
    var originalHash = $m_sr_Statics$().anyHash__O__I(next);
    var improved = $m_sc_Hashing$().improve__I__I(originalHash);
    curr = curr.removed__O__I__I__I__sci_BitmapIndexedSetNode(next, originalHash, improved, 0);
    if ((curr !== $thiz.sci_HashSet__f_rootNode)) {
      if ((curr.sci_BitmapIndexedSetNode__f_size === 0)) {
        var this$1 = $m_sci_HashSet$();
        return this$1.sci_HashSet$__f_EmptySet;
      }
      while (iter.hasNext__Z()) {
        var next$2 = iter.next__O();
        var originalHash$2 = $m_sr_Statics$().anyHash__O__I(next$2);
        var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
        curr.removeWithShallowMutations__O__I__I__sci_BitmapIndexedSetNode(next$2, originalHash$2, improved$2);
        if ((curr.sci_BitmapIndexedSetNode__f_size === 0)) {
          var this$2 = $m_sci_HashSet$();
          return this$2.sci_HashSet$__f_EmptySet;
        }
      }
      return new $c_sci_HashSet(curr);
    }
  }
  return $thiz;
}
export { $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet as $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet };
/** @constructor */
function $c_sci_HashSet(rootNode) {
  this.sci_HashSet__f_rootNode = null;
  this.sci_HashSet__f_rootNode = rootNode;
}
export { $c_sci_HashSet as $c_sci_HashSet };
$c_sci_HashSet.prototype = new $h_sci_AbstractSet();
$c_sci_HashSet.prototype.constructor = $c_sci_HashSet;
/** @constructor */
function $h_sci_HashSet() {
}
export { $h_sci_HashSet as $h_sci_HashSet };
$h_sci_HashSet.prototype = $c_sci_HashSet.prototype;
$c_sci_HashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_HashSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_HashSet.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashSet(pred, false);
});
$c_sci_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_HashSet$();
});
$c_sci_HashSet.prototype.knownSize__I = (function() {
  return this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size;
});
$c_sci_HashSet.prototype.size__I = (function() {
  return this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size;
});
$c_sci_HashSet.prototype.isEmpty__Z = (function() {
  return (this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size === 0);
});
$c_sci_HashSet.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_SetIterator(this.sci_HashSet__f_rootNode));
});
$c_sci_HashSet.prototype.contains__O__Z = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  return this.sci_HashSet__f_rootNode.contains__O__I__I__I__Z(element, elementUnimprovedHash, elementHash, 0);
});
$c_sci_HashSet.prototype.incl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = this.sci_HashSet__f_rootNode.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode);
});
$c_sci_HashSet.prototype.excl__O__sci_HashSet = (function(element) {
  var elementUnimprovedHash = $m_sr_Statics$().anyHash__O__I(element);
  var elementHash = $m_sc_Hashing$().improve__I__I(elementUnimprovedHash);
  var newRootNode = this.sci_HashSet__f_rootNode.removed__O__I__I__I__sci_BitmapIndexedSetNode(element, elementUnimprovedHash, elementHash, 0);
  return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newRootNode);
});
$c_sci_HashSet.prototype.concat__sc_IterableOnce__sci_HashSet = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    if (this.isEmpty__Z()) {
      return that;
    } else {
      var newNode = this.sci_HashSet__f_rootNode.concat__sci_SetNode__I__sci_BitmapIndexedSetNode(that.sci_HashSet__f_rootNode, 0);
      return ((newNode === that.sci_HashSet__f_rootNode) ? that : $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, newNode));
    }
  } else if ((that instanceof $c_scm_HashSet)) {
    var iter = new $c_scm_HashSet$$anon$2(that);
    var current = this.sci_HashSet__f_rootNode;
    while (iter.hasNext__Z()) {
      var next = iter.next__O();
      var improvedHash = next.scm_HashSet$Node__f__hash;
      var originalHash = that.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      current = current.updated__O__I__I__I__sci_BitmapIndexedSetNode(next.scm_HashSet$Node__f__key, originalHash, improved, 0);
      if ((current !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
        while (iter.hasNext__Z()) {
          var next$2 = iter.next__O();
          var improvedHash$1 = next$2.scm_HashSet$Node__f__hash;
          var originalHash$2 = that.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash$1);
          var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
          shallowlyMutableNodeMap = current.updateWithShallowMutations__O__I__I__I__I__I(next$2.scm_HashSet$Node__f__key, originalHash$2, improved$2, 0, shallowlyMutableNodeMap);
        }
        return new $c_sci_HashSet(current);
      }
    }
    return this;
  } else if ((that instanceof $c_scm_LinkedHashSet)) {
    var iter$2 = new $c_scm_LinkedHashSet$$anon$2(that);
    var current$2 = this.sci_HashSet__f_rootNode;
    while (iter$2.hasNext__Z()) {
      var next$3 = iter$2.next__O();
      var improvedHash$2 = next$3.scm_LinkedHashSet$Entry__f_hash;
      var originalHash$3 = (improvedHash$2 ^ ((improvedHash$2 >>> 16) | 0));
      var improved$3 = $m_sc_Hashing$().improve__I__I(originalHash$3);
      current$2 = current$2.updated__O__I__I__I__sci_BitmapIndexedSetNode(next$3.scm_LinkedHashSet$Entry__f_key, originalHash$3, improved$3, 0);
      if ((current$2 !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap$2 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved$3, 0));
        while (iter$2.hasNext__Z()) {
          var next$4 = iter$2.next__O();
          var improvedHash$3 = next$4.scm_LinkedHashSet$Entry__f_hash;
          var originalHash$4 = (improvedHash$3 ^ ((improvedHash$3 >>> 16) | 0));
          var improved$4 = $m_sc_Hashing$().improve__I__I(originalHash$4);
          shallowlyMutableNodeMap$2 = current$2.updateWithShallowMutations__O__I__I__I__I__I(next$4.scm_LinkedHashSet$Entry__f_key, originalHash$4, improved$4, 0, shallowlyMutableNodeMap$2);
        }
        return new $c_sci_HashSet(current$2);
      }
    }
    return this;
  } else {
    var iter$3 = that.iterator__sc_Iterator();
    var current$3 = this.sci_HashSet__f_rootNode;
    while (iter$3.hasNext__Z()) {
      var element = iter$3.next__O();
      var originalHash$5 = $m_sr_Statics$().anyHash__O__I(element);
      var improved$5 = $m_sc_Hashing$().improve__I__I(originalHash$5);
      current$3 = current$3.updated__O__I__I__I__sci_BitmapIndexedSetNode(element, originalHash$5, improved$5, 0);
      if ((current$3 !== this.sci_HashSet__f_rootNode)) {
        var shallowlyMutableNodeMap$3 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved$5, 0));
        while (iter$3.hasNext__Z()) {
          var element$2 = iter$3.next__O();
          var originalHash$6 = $m_sr_Statics$().anyHash__O__I(element$2);
          var improved$6 = $m_sc_Hashing$().improve__I__I(originalHash$6);
          shallowlyMutableNodeMap$3 = current$3.updateWithShallowMutations__O__I__I__I__I__I(element$2, originalHash$6, improved$6, 0, shallowlyMutableNodeMap$3);
        }
        return new $c_sci_HashSet(current$3);
      }
    }
    return this;
  }
});
$c_sci_HashSet.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O();
});
$c_sci_HashSet.prototype.last__O = (function() {
  return new $c_sci_SetReverseIterator(this.sci_HashSet__f_rootNode).next__O();
});
$c_sci_HashSet.prototype.foreach__F1__V = (function(f) {
  this.sci_HashSet__f_rootNode.foreach__F1__V(f);
});
$c_sci_HashSet.prototype.subsetOf__sc_Set__Z = (function(that) {
  return (this.isEmpty__Z() || ((!that.isEmpty__Z()) && ((that instanceof $c_sci_HashSet) ? this.sci_HashSet__f_rootNode.subsetOf__sci_SetNode__I__Z(that.sci_HashSet__f_rootNode, 0) : $f_sc_IterableOnceOps__forall__F1__Z(this, that))));
});
$c_sci_HashSet.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashSet)) {
    if ((this === that)) {
      return true;
    } else {
      var x = this.sci_HashSet__f_rootNode;
      var x$2 = that.sci_HashSet__f_rootNode;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    }
  } else {
    return $f_sc_Set__equals__O__Z(this, that);
  }
});
$c_sci_HashSet.prototype.className__T = (function() {
  return "HashSet";
});
$c_sci_HashSet.prototype.hashCode__I = (function() {
  var it = new $c_sci_SetHashIterator(this.sci_HashSet__f_rootNode);
  var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(it, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed);
  return hash;
});
$c_sci_HashSet.prototype.diff__sc_Set__sci_HashSet = (function(that) {
  if (this.isEmpty__Z()) {
    return this;
  } else if ((that instanceof $c_sci_HashSet)) {
    if (that.isEmpty__Z()) {
      return this;
    } else {
      var newRootNode = this.sci_HashSet__f_rootNode.diff__sci_SetNode__I__sci_BitmapIndexedSetNode(that.sci_HashSet__f_rootNode, 0);
      if ((newRootNode.sci_BitmapIndexedSetNode__f_size === 0)) {
        var this$1 = $m_sci_HashSet$();
        return this$1.sci_HashSet$__f_EmptySet;
      } else {
        return $p_sci_HashSet__newHashSetOrThis__sci_BitmapIndexedSetNode__sci_HashSet(this, this.sci_HashSet__f_rootNode.diff__sci_SetNode__I__sci_BitmapIndexedSetNode(that.sci_HashSet__f_rootNode, 0));
      }
    }
  } else if ((that instanceof $c_scm_HashSet)) {
    var iter = new $c_scm_HashSet$$anon$2(that);
    var curr = this.sci_HashSet__f_rootNode;
    while (iter.hasNext__Z()) {
      var next = iter.next__O();
      var improvedHash = next.scm_HashSet$Node__f__hash;
      var originalHash = that.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      curr = curr.removed__O__I__I__I__sci_BitmapIndexedSetNode(next.scm_HashSet$Node__f__key, originalHash, improved, 0);
      if ((curr !== this.sci_HashSet__f_rootNode)) {
        if ((curr.sci_BitmapIndexedSetNode__f_size === 0)) {
          var this$2 = $m_sci_HashSet$();
          return this$2.sci_HashSet$__f_EmptySet;
        }
        while (iter.hasNext__Z()) {
          var next$2 = iter.next__O();
          var improvedHash$1 = next$2.scm_HashSet$Node__f__hash;
          var originalHash$2 = that.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash$1);
          var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
          curr.removeWithShallowMutations__O__I__I__sci_BitmapIndexedSetNode(next$2.scm_HashSet$Node__f__key, originalHash$2, improved$2);
          if ((curr.sci_BitmapIndexedSetNode__f_size === 0)) {
            var this$3 = $m_sci_HashSet$();
            return this$3.sci_HashSet$__f_EmptySet;
          }
        }
        return new $c_sci_HashSet(curr);
      }
    }
    return this;
  } else {
    var thatKnownSize = that.knownSize__I();
    if ((thatKnownSize === 0)) {
      return this;
    } else if ((thatKnownSize <= this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size)) {
      return $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet(this, that);
    } else {
      var pred = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((elem$2$2) => that.contains__O__Z(elem$2$2)));
      return this.filterImpl__F1__Z__sci_HashSet(pred, true);
    }
  }
});
$c_sci_HashSet.prototype.removedAll__sc_IterableOnce__sci_HashSet = (function(that) {
  if ($is_sc_Set(that)) {
    return this.diff__sc_Set__sci_HashSet(that);
  }
  if ((that instanceof $c_sci_Range)) {
    if ((that.length__I() > this.sci_HashSet__f_rootNode.sci_BitmapIndexedSetNode__f_size)) {
      var pred = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x3) => ((x0$1$2$2) => {
        if ((!$isInt(x0$1$2$2))) {
          return true;
        } else {
          var x2 = (x0$1$2$2 | 0);
          return (!x3.contains__I__Z(x2));
        }
      }))(that));
      return this.filterImpl__F1__Z__sci_HashSet(pred, false);
    }
  }
  return $p_sci_HashSet__removedAllWithShallowMutations__sc_IterableOnce__sci_HashSet(this, that);
});
$c_sci_HashSet.prototype.filterImpl__F1__Z__sci_HashSet = (function(pred, isFlipped) {
  var newRootNode = this.sci_HashSet__f_rootNode.filterImpl__F1__Z__sci_BitmapIndexedSetNode(pred, isFlipped);
  if ((newRootNode === this.sci_HashSet__f_rootNode)) {
    return this;
  } else if ((newRootNode.sci_BitmapIndexedSetNode__f_size === 0)) {
    var this$1 = $m_sci_HashSet$();
    return this$1.sci_HashSet$__f_EmptySet;
  } else {
    return new $c_sci_HashSet(newRootNode);
  }
});
$c_sci_HashSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_HashSet.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_sci_HashSet.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n);
});
$c_sci_HashSet.prototype.removedAll__sc_IterableOnce__sci_SetOps = (function(that) {
  return this.removedAll__sc_IterableOnce__sci_HashSet(that);
});
$c_sci_HashSet.prototype.tail__O = (function() {
  var elem = this.iterator__sc_Iterator().next__O();
  return this.excl__O__sci_HashSet(elem);
});
$c_sci_HashSet.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  return this.concat__sc_IterableOnce__sci_HashSet(that);
});
$c_sci_HashSet.prototype.excl__O__sci_SetOps = (function(elem) {
  return this.excl__O__sci_HashSet(elem);
});
$c_sci_HashSet.prototype.incl__O__sci_SetOps = (function(elem) {
  return this.incl__O__sci_HashSet(elem);
});
function $isArrayOf_sci_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashSet)));
}
export { $isArrayOf_sci_HashSet as $isArrayOf_sci_HashSet };
var $d_sci_HashSet = new $TypeData().initClass($c_sci_HashSet, "scala.collection.immutable.HashSet", ({
  sci_HashSet: 1,
  sci_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  sci_Set: 1,
  sci_Iterable: 1,
  sci_SetOps: 1,
  sci_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_HashSet as $d_sci_HashSet };
function $isArrayOf_sci_ListSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ListSet)));
}
export { $isArrayOf_sci_ListSet as $isArrayOf_sci_ListSet };
/** @constructor */
function $c_scm_AbstractSet() {
}
export { $c_scm_AbstractSet as $c_scm_AbstractSet };
$c_scm_AbstractSet.prototype = new $h_sc_AbstractSet();
$c_scm_AbstractSet.prototype.constructor = $c_scm_AbstractSet;
/** @constructor */
function $h_scm_AbstractSet() {
}
export { $h_scm_AbstractSet as $h_scm_AbstractSet };
$h_scm_AbstractSet.prototype = $c_scm_AbstractSet.prototype;
$c_scm_AbstractSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Set$();
});
$c_scm_AbstractSet.prototype.add__O__Z = (function(elem) {
  return $f_scm_SetOps__add__O__Z(this, elem);
});
$c_scm_AbstractSet.prototype.remove__O__Z = (function(elem) {
  return $f_scm_SetOps__remove__O__Z(this, elem);
});
$c_scm_AbstractSet.prototype.knownSize__I = (function() {
  return (-1);
});
$c_scm_AbstractSet.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_AbstractSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_AbstractSet.prototype.result__O = (function() {
  return this;
});
/** @constructor */
function $c_Lcats_Alternative$$anon$1(evidence$1$1, outer) {
  this.Lcats_Alternative$$anon$1__f_F = null;
  this.Lcats_Alternative$$anon$1__f_G = null;
  if ((outer === null)) {
    throw $ct_jl_NullPointerException__(new $c_jl_NullPointerException());
  }
  this.Lcats_Alternative$$anon$1__f_F = outer;
  this.Lcats_Alternative$$anon$1__f_G = evidence$1$1;
}
export { $c_Lcats_Alternative$$anon$1 as $c_Lcats_Alternative$$anon$1 };
$c_Lcats_Alternative$$anon$1.prototype = new $h_O();
$c_Lcats_Alternative$$anon$1.prototype.constructor = $c_Lcats_Alternative$$anon$1;
/** @constructor */
function $h_Lcats_Alternative$$anon$1() {
}
export { $h_Lcats_Alternative$$anon$1 as $h_Lcats_Alternative$$anon$1 };
$h_Lcats_Alternative$$anon$1.prototype = $c_Lcats_Alternative$$anon$1.prototype;
$c_Lcats_Alternative$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_Alternative$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_Alternative$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_Apply__productL__O__O__O(this, fa, fb);
});
$c_Lcats_Alternative$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_Alternative$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_Apply__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_Alternative$$anon$1.prototype.unit__O = (function() {
  return $f_Lcats_ComposedApplicative__pure__O__O(this, (void 0));
});
$c_Lcats_Alternative$$anon$1.prototype.imap__O__F1__F1__O = (function(fga, f, g) {
  return $f_Lcats_ComposedInvariant__imap__O__F1__F1__O(this, fga, f, g);
});
$c_Lcats_Alternative$$anon$1.prototype.map__O__F1__O = (function(fga, f) {
  return $f_Lcats_ComposedFunctor__map__O__F1__O(this, fga, f);
});
$c_Lcats_Alternative$$anon$1.prototype.ap__O__O__O = (function(fgf, fga) {
  return $f_Lcats_ComposedApply__ap__O__O__O(this, fgf, fga);
});
$c_Lcats_Alternative$$anon$1.prototype.product__O__O__O = (function(fga, fgb) {
  return $f_Lcats_ComposedApply__product__O__O__O(this, fga, fgb);
});
$c_Lcats_Alternative$$anon$1.prototype.pure__O__O = (function(x) {
  return $f_Lcats_ComposedApplicative__pure__O__O(this, x);
});
$c_Lcats_Alternative$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return this.Lcats_Alternative$$anon$1__f_F.combineK__O__O__O(x, y);
});
$c_Lcats_Alternative$$anon$1.prototype.empty__O = (function() {
  return this.Lcats_Alternative$$anon$1__f_F.empty__O();
});
$c_Lcats_Alternative$$anon$1.prototype.G__Lcats_Applicative = (function() {
  return this.Lcats_Alternative$$anon$1__f_G;
});
$c_Lcats_Alternative$$anon$1.prototype.F__Lcats_Applicative = (function() {
  return this.Lcats_Alternative$$anon$1__f_F;
});
$c_Lcats_Alternative$$anon$1.prototype.F__Lcats_Apply = (function() {
  return this.Lcats_Alternative$$anon$1__f_F;
});
$c_Lcats_Alternative$$anon$1.prototype.F__Lcats_Functor = (function() {
  return this.Lcats_Alternative$$anon$1__f_F;
});
$c_Lcats_Alternative$$anon$1.prototype.F__Lcats_Invariant = (function() {
  return this.Lcats_Alternative$$anon$1__f_F;
});
$c_Lcats_Alternative$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_Alternative$$anon$1(evidence$1, this);
});
$c_Lcats_Alternative$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this);
});
var $d_Lcats_Alternative$$anon$1 = new $TypeData().initClass($c_Lcats_Alternative$$anon$1, "cats.Alternative$$anon$1", ({
  Lcats_Alternative$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_ComposedInvariant: 1,
  Lcats_ComposedFunctor: 1,
  Lcats_ComposedApply: 1,
  Lcats_ComposedApplicative: 1,
  Lcats_ComposedSemigroupK: 1,
  Lcats_ComposedNonEmptyAlternative: 1,
  Lcats_ComposedMonoidK: 1,
  Lcats_ComposedAlternative: 1
}));
export { $d_Lcats_Alternative$$anon$1 as $d_Lcats_Alternative$$anon$1 };
function $p_sci_LazyList__initState__V($thiz) {
  if (($thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$_head === $m_sci_LazyList$Uninitialized$())) {
    if (($thiz.sci_LazyList__f__tail === $m_sci_LazyList$MidEvaluation$())) {
      throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), "LazyList evaluation depends on its own result (self-reference); see docs for more info");
    }
    var fun = $thiz.sci_LazyList__f__tail;
    $thiz.sci_LazyList__f__tail = $m_sci_LazyList$MidEvaluation$();
    try {
      var l = fun.apply__O().scala$collection$immutable$LazyList$$evaluated__sci_LazyList();
    } finally {
      $thiz.sci_LazyList__f__tail = fun;
    }
    $thiz.sci_LazyList__f__tail = l.sci_LazyList__f__tail;
    $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$_head = l.sci_LazyList__f_scala$collection$immutable$LazyList$$_head;
  }
}
export { $p_sci_LazyList__initState__V as $p_sci_LazyList__initState__V };
function $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz, f) {
  $m_sci_LazyList$();
  var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    if (($thiz.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
    } else {
      $m_sci_LazyList$();
      var hd = f.apply__O__O($thiz.head__O());
      var tl = $p_sci_LazyList__mapImpl__F1__sci_LazyList($thiz.tail__sci_LazyList(), f);
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
    }
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
}
export { $p_sci_LazyList__mapImpl__F1__sci_LazyList as $p_sci_LazyList__mapImpl__F1__sci_LazyList };
function $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList($thiz, scout) {
  if ((scout.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  } else {
    $m_sci_LazyList$();
    var hd = $thiz.head__O();
    $m_sci_LazyList$();
    var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList($thiz.tail__sci_LazyList(), scout.tail__sci_LazyList())));
    var tl = $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
  }
}
export { $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList as $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList };
function $p_sci_LazyList__takeImpl__I__sci_LazyList($thiz, n) {
  if ((n <= 0)) {
    return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      if (($thiz.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
        return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
      } else {
        $m_sci_LazyList$();
        var hd = $thiz.head__O();
        var tl = $p_sci_LazyList__takeImpl__I__sci_LazyList($thiz.tail__sci_LazyList(), (((-1) + n) | 0));
        return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
      }
    }));
    return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
  }
}
export { $p_sci_LazyList__takeImpl__I__sci_LazyList as $p_sci_LazyList__takeImpl__I__sci_LazyList };
function $p_sci_LazyList__updatedImpl__I__O__I__sci_LazyList($thiz, index, elem, startIndex) {
  $m_sci_LazyList$();
  var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    if ((index <= 0)) {
      $m_sci_LazyList$();
      var tl = $thiz.tail__sci_LazyList();
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, tl);
    } else {
      var this$3 = $thiz.tail__sci_LazyList();
      if ((this$3.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
        throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + startIndex));
      } else {
        $m_sci_LazyList$();
        var hd = $thiz.head__O();
        var tl$1 = $p_sci_LazyList__updatedImpl__I__O__I__sci_LazyList($thiz.tail__sci_LazyList(), (((-1) + index) | 0), elem, startIndex);
        return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl$1);
      }
    }
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
}
export { $p_sci_LazyList__updatedImpl__I__O__I__sci_LazyList as $p_sci_LazyList__updatedImpl__I__O__I__sci_LazyList };
function $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if (($thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$_head === $m_sci_LazyList$Uninitialized$())) {
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>");
  } else if (($thiz.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() !== $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    var obj = $thiz.head__O();
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var cursor = $thiz;
    var scout = $thiz.tail__sci_LazyList();
    if ((cursor !== scout)) {
      cursor = scout;
      var this$1 = scout;
      if (((this$1.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() !== $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
        scout = scout.tail__sci_LazyList();
        while (true) {
          if ((cursor !== scout)) {
            var this$2 = scout;
            var $x_1 = ((this$2.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this$2.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() !== $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
          } else {
            var $x_1 = false;
          }
          if ($x_1) {
            var c = cursor;
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
            var obj$1 = c.head__O();
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
            cursor = cursor.tail__sci_LazyList();
            scout = scout.tail__sci_LazyList();
            var this$3 = scout;
            if (((this$3.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this$3.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() !== $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
              scout = scout.tail__sci_LazyList();
            }
          } else {
            break;
          }
        }
      }
    }
    var this$4 = scout;
    if ((!((this$4.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this$4.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() !== $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)))) {
      while ((cursor !== scout)) {
        var c$1 = cursor;
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var obj$2 = c$1.head__O();
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
        cursor = cursor.tail__sci_LazyList();
      }
      var this$5 = cursor;
      if ((!(this$5.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()))) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>");
      }
    } else {
      if ((cursor !== $thiz)) {
        var runner = $thiz;
        while ((runner !== scout)) {
          runner = runner.tail__sci_LazyList();
          scout = scout.tail__sci_LazyList();
        }
        while (true) {
          var ct = cursor.tail__sci_LazyList();
          if ((ct !== scout)) {
            var c$2 = cursor;
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
            var obj$3 = c$2.head__O();
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3);
          }
          cursor = ct;
          if ((cursor !== scout)) {
          } else {
            break;
          }
        }
      }
      b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
      b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>");
    }
  }
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b;
}
export { $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder as $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder };
function $ct_sci_LazyList__O__($thiz, lazyState) {
  $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$_head = ((lazyState === $m_sci_LazyList$EmptyMarker$()) ? null : $m_sci_LazyList$Uninitialized$());
  $thiz.sci_LazyList__f__tail = ((lazyState === $m_sci_LazyList$EmptyMarker$()) ? null : lazyState);
  return $thiz;
}
export { $ct_sci_LazyList__O__ as $ct_sci_LazyList__O__ };
function $ct_sci_LazyList__O__sci_LazyList__($thiz, head, tail) {
  $ct_sci_LazyList__O__($thiz, $m_sci_LazyList$EmptyMarker$());
  $thiz.sci_LazyList__f_scala$collection$immutable$LazyList$$_head = head;
  $thiz.sci_LazyList__f__tail = tail;
  return $thiz;
}
export { $ct_sci_LazyList__O__sci_LazyList__ as $ct_sci_LazyList__O__sci_LazyList__ };
/** @constructor */
function $c_sci_LazyList() {
  this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head = null;
  this.sci_LazyList__f__tail = null;
}
export { $c_sci_LazyList as $c_sci_LazyList };
$c_sci_LazyList.prototype = new $h_sci_AbstractSeq();
$c_sci_LazyList.prototype.constructor = $c_sci_LazyList;
/** @constructor */
function $h_sci_LazyList() {
}
export { $h_sci_LazyList as $h_sci_LazyList };
$h_sci_LazyList.prototype = $c_sci_LazyList.prototype;
$c_sci_LazyList.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_LazyList.prototype.headOption__s_Option = (function() {
  return $f_sc_LinearSeqOps__headOption__s_Option(this);
});
$c_sci_LazyList.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this);
});
$c_sci_LazyList.prototype.last__O = (function() {
  return $f_sc_LinearSeqOps__last__O(this);
});
$c_sci_LazyList.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len);
});
$c_sci_LazyList.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_LazyList.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_LazyList.prototype.forall__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__forall__F1__Z(this, p);
});
$c_sci_LazyList.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p);
});
$c_sci_LazyList.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_LazyList.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_LazyList.prototype.scala$collection$immutable$LazyList$$evaluated__sci_LazyList = (function() {
  while (true) {
    if ((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$())) {
      return ((this.sci_LazyList__f__tail === null) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : this);
    } else {
      $p_sci_LazyList__initState__V(this);
    }
  }
});
$c_sci_LazyList.prototype.isEmpty__Z = (function() {
  return (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty);
});
$c_sci_LazyList.prototype.knownSize__I = (function() {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? 0 : (-1));
});
$c_sci_LazyList.prototype.head__O = (function() {
  if ((this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty lazy list");
  } else {
    return this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head;
  }
});
$c_sci_LazyList.prototype.tail__sci_LazyList = (function() {
  if ((this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty lazy list");
  } else {
    return this.sci_LazyList__f__tail;
  }
});
$c_sci_LazyList.prototype.force__sci_LazyList = (function() {
  var these = this;
  var those = this;
  var this$1 = these;
  if ((!(this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
    these = these.tail__sci_LazyList();
  }
  while ((those !== these)) {
    var this$2 = these;
    if ((this$2.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return this;
    }
    these = these.tail__sci_LazyList();
    var this$3 = these;
    if ((this$3.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return this;
    }
    these = these.tail__sci_LazyList();
    if ((these === those)) {
      return this;
    }
    those = those.tail__sci_LazyList();
  }
  return this;
});
$c_sci_LazyList.prototype.iterator__sc_Iterator = (function() {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_LazyList$LazyIterator(this));
});
$c_sci_LazyList.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    var this$1 = _$this;
    if ((!(this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
      f.apply__O__O(_$this.head__O());
      _$this = _$this.tail__sci_LazyList();
      continue;
    }
    break;
  }
});
$c_sci_LazyList.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    var this$1 = _$this;
    if ((this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return z;
    } else {
      var temp$_$this = _$this.tail__sci_LazyList();
      var temp$z = op.apply__O__O__O(z, _$this.head__O());
      _$this = temp$_$this;
      z = temp$z;
    }
  }
});
$c_sci_LazyList.prototype.className__T = (function() {
  return "LazyList";
});
$c_sci_LazyList.prototype.lazyAppendedAll__F0__sci_LazyList = (function(suffix) {
  $m_sci_LazyList$();
  var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
    if ((this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      var x1 = suffix.apply__O();
      return ((x1 instanceof $c_sci_LazyList) ? x1 : ((x1.knownSize__I() === 0) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$eagerHeadFromIterator__sc_Iterator__sci_LazyList(x1.iterator__sc_Iterator())));
    } else {
      $m_sci_LazyList$();
      var hd = this.head__O();
      var tl = this.tail__sci_LazyList().lazyAppendedAll__F0__sci_LazyList(suffix);
      return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), hd, tl);
    }
  }));
  return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__sci_LazyList = (function(suffix) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().from__sc_IterableOnce__sci_LazyList(suffix) : this.lazyAppendedAll__F0__sci_LazyList(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => suffix))));
});
$c_sci_LazyList.prototype.appended__O__sci_LazyList = (function(elem) {
  if (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
    $m_sci_LazyList$();
    var tl = $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
    return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, tl);
  } else {
    return this.lazyAppendedAll__F0__sci_LazyList(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => new $c_sc_Iterator$$anon$20(elem))));
  }
});
$c_sci_LazyList.prototype.reduceLeft__F2__O = (function(f) {
  if ((this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  } else {
    var reducedRes = this.head__O();
    var left = this.tail__sci_LazyList();
    while (true) {
      var this$1 = left;
      if ((!(this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
        reducedRes = f.apply__O__O__O(reducedRes, left.head__O());
        left = left.tail__sci_LazyList();
      } else {
        break;
      }
    }
    return reducedRes;
  }
});
$c_sci_LazyList.prototype.partition__F1__T2 = (function(p) {
  return $ct_T2__O__O__(new $c_T2(), this.filter__F1__sci_LazyList(p), this.filterNot__F1__sci_LazyList(p));
});
$c_sci_LazyList.prototype.filter__F1__sci_LazyList = (function(pred) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList(this, pred, false));
});
$c_sci_LazyList.prototype.filterNot__F1__sci_LazyList = (function(pred) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$filterImpl__sci_LazyList__F1__Z__sci_LazyList(this, pred, true));
});
$c_sci_LazyList.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return new $c_sci_LazyList$WithFilter(this, p);
});
$c_sci_LazyList.prototype.map__F1__sci_LazyList = (function(f) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $p_sci_LazyList__mapImpl__F1__sci_LazyList(this, f));
});
$c_sci_LazyList.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  var _$this = this;
  while (true) {
    var this$1 = _$this;
    if ((this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return $m_s_None$();
    } else {
      var res = pf.applyOrElse__O__F1__O(_$this.head__O(), $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$anyToMarker);
      if ((res === $m_sr_Statics$PFMarker$())) {
        _$this = _$this.tail__sci_LazyList();
      } else {
        return new $c_s_Some(res);
      }
    }
  }
});
$c_sci_LazyList.prototype.find__F1__s_Option = (function(p) {
  var _$this = this;
  while (true) {
    var this$1 = _$this;
    if ((this$1.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) {
      return $m_s_None$();
    } else {
      var elem = _$this.head__O();
      if ((!(!p.apply__O__O(elem)))) {
        return new $c_s_Some(elem);
      } else {
        _$this = _$this.tail__sci_LazyList();
      }
    }
  }
});
$c_sci_LazyList.prototype.flatMap__F1__sci_LazyList = (function(f) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$flatMapImpl__sci_LazyList__F1__sci_LazyList(this, f));
});
$c_sci_LazyList.prototype.drop__I__sci_LazyList = (function(n) {
  return ((n <= 0) ? this : (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $m_sci_LazyList$().scala$collection$immutable$LazyList$$dropImpl__sci_LazyList__I__sci_LazyList(this, n)));
});
$c_sci_LazyList.prototype.dropRight__I__sci_LazyList = (function(n) {
  if ((n <= 0)) {
    return this;
  } else if (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty))) {
    return $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty;
  } else {
    $m_sci_LazyList$();
    var state = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => {
      var scout = this;
      var remaining = n;
      while (true) {
        if ((remaining > 0)) {
          var this$2 = scout;
          var $x_1 = (!(this$2.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty));
        } else {
          var $x_1 = false;
        }
        if ($x_1) {
          remaining = (((-1) + remaining) | 0);
          scout = scout.tail__sci_LazyList();
        } else {
          break;
        }
      }
      return $p_sci_LazyList__eagerHeadDropRightImpl__sci_LazyList__sci_LazyList(this, scout);
    }));
    return $ct_sci_LazyList__O__(new $c_sci_LazyList(), state);
  }
});
$c_sci_LazyList.prototype.take__I__sci_LazyList = (function(n) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $p_sci_LazyList__takeImpl__I__sci_LazyList(this, n));
});
$c_sci_LazyList.prototype.diff__sc_Seq__sci_LazyList = (function(that) {
  return (((this.sci_LazyList__f_scala$collection$immutable$LazyList$$_head !== $m_sci_LazyList$Uninitialized$()) && (this.scala$collection$immutable$LazyList$$evaluated__sci_LazyList() === $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty)) ? $m_sci_LazyList$().sci_LazyList$__f_scala$collection$immutable$LazyList$$Empty : $f_sc_SeqOps__diff__sc_Seq__O(this, that));
});
$c_sci_LazyList.prototype.updated__I__O__sci_LazyList = (function(index, elem) {
  if ((index < 0)) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), ("" + index));
  } else {
    return $p_sci_LazyList__updatedImpl__I__O__I__sci_LazyList(this, index, elem, index);
  }
});
$c_sci_LazyList.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_LazyList();
  $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, sb.scm_StringBuilder__f_underlying, start, sep, end);
  return sb;
});
$c_sci_LazyList.prototype.toString__T = (function() {
  return $p_sci_LazyList__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "LazyList"), "(", ", ", ")").jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sci_LazyList.prototype.apply__O__O = (function(v1) {
  var n = (v1 | 0);
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_LazyList.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = (x | 0);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_LazyList.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_LazyList(index, elem);
});
$c_sci_LazyList.prototype.diff__sc_Seq__O = (function(that) {
  return this.diff__sc_Seq__sci_LazyList(that);
});
$c_sci_LazyList.prototype.take__I__O = (function(n) {
  return this.take__I__sci_LazyList(n);
});
$c_sci_LazyList.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_LazyList(n);
});
$c_sci_LazyList.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_LazyList(n);
});
$c_sci_LazyList.prototype.flatten__F1__O = (function(asIterable) {
  return this.flatMap__F1__sci_LazyList(asIterable);
});
$c_sci_LazyList.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_LazyList(f);
});
$c_sci_LazyList.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_LazyList(f);
});
$c_sci_LazyList.prototype.prepended__O__O = (function(elem) {
  $m_sci_LazyList$();
  return $ct_sci_LazyList__O__sci_LazyList__(new $c_sci_LazyList(), elem, this);
});
$c_sci_LazyList.prototype.filterNot__F1__O = (function(pred) {
  return this.filterNot__F1__sci_LazyList(pred);
});
$c_sci_LazyList.prototype.filter__F1__O = (function(pred) {
  return this.filter__F1__sci_LazyList(pred);
});
$c_sci_LazyList.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_LazyList(elem);
});
$c_sci_LazyList.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_LazyList(suffix);
});
$c_sci_LazyList.prototype.tail__O = (function() {
  return this.tail__sci_LazyList();
});
$c_sci_LazyList.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_LazyList$();
});
function $isArrayOf_sci_LazyList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_LazyList)));
}
export { $isArrayOf_sci_LazyList as $isArrayOf_sci_LazyList };
var $d_sci_LazyList = new $TypeData().initClass($c_sci_LazyList, "scala.collection.immutable.LazyList", ({
  sci_LazyList: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_LazyList as $d_sci_LazyList };
function $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder($thiz, b, start, sep, end) {
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  if ((!$thiz.isEmpty__Z())) {
    var obj = $thiz.head__O();
    b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj);
    var elem = null;
    elem = $thiz;
    if ($thiz.tailDefined__Z()) {
      var scout = $thiz.tail__O();
      if ((elem !== scout)) {
        elem = scout;
        if (scout.tailDefined__Z()) {
          scout = scout.tail__O();
          while (((elem !== scout) && scout.tailDefined__Z())) {
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
            var obj$1 = elem.head__O();
            b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$1);
            elem = elem.tail__O();
            scout = scout.tail__O();
            if (scout.tailDefined__Z()) {
              scout = scout.tail__O();
            }
          }
        }
      }
      if ((!scout.tailDefined__Z())) {
        while ((elem !== scout)) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$2 = elem.head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$2);
          elem = elem.tail__O();
        }
        var this$2 = elem;
        if ((!this$2.isEmpty__Z())) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$3 = elem.head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$3);
        }
      } else {
        var runner = $thiz;
        var k = 0;
        while ((runner !== scout)) {
          runner = runner.tail__O();
          scout = scout.tail__O();
          k = ((1 + k) | 0);
        }
        if (((elem === scout) && (k > 0))) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$4 = elem.head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$4);
          elem = elem.tail__O();
        }
        while ((elem !== scout)) {
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
          var obj$5 = elem.head__O();
          b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + obj$5);
          elem = elem.tail__O();
        }
      }
    }
    var this$3 = elem;
    if ((!this$3.isEmpty__Z())) {
      if ((!elem.tailDefined__Z())) {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<not computed>");
      } else {
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + "<cycle>");
      }
    }
  }
  b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + b.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  return b;
}
export { $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder as $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder };
/** @constructor */
function $c_sci_Stream() {
}
export { $c_sci_Stream as $c_sci_Stream };
$c_sci_Stream.prototype = new $h_sci_AbstractSeq();
$c_sci_Stream.prototype.constructor = $c_sci_Stream;
/** @constructor */
function $h_sci_Stream() {
}
export { $h_sci_Stream as $h_sci_Stream };
$h_sci_Stream.prototype = $c_sci_Stream.prototype;
$c_sci_Stream.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_Stream.prototype.headOption__s_Option = (function() {
  return $f_sc_LinearSeqOps__headOption__s_Option(this);
});
$c_sci_Stream.prototype.iterator__sc_Iterator = (function() {
  return $f_sc_LinearSeqOps__iterator__sc_Iterator(this);
});
$c_sci_Stream.prototype.length__I = (function() {
  return $f_sc_LinearSeqOps__length__I(this);
});
$c_sci_Stream.prototype.last__O = (function() {
  return $f_sc_LinearSeqOps__last__O(this);
});
$c_sci_Stream.prototype.lengthCompare__I__I = (function(len) {
  return $f_sc_LinearSeqOps__lengthCompare__I__I(this, len);
});
$c_sci_Stream.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_Stream.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_Stream.prototype.forall__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__forall__F1__Z(this, p);
});
$c_sci_Stream.prototype.exists__F1__Z = (function(p) {
  return $f_sc_LinearSeqOps__exists__F1__Z(this, p);
});
$c_sci_Stream.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_Stream.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_Stream.prototype.className__T = (function() {
  return "Stream";
});
$c_sci_Stream.prototype.foreach__F1__V = (function(f) {
  var _$this = this;
  while (true) {
    if ((!_$this.isEmpty__Z())) {
      f.apply__O__O(_$this.head__O());
      _$this = _$this.tail__O();
      continue;
    }
    break;
  }
});
$c_sci_Stream.prototype.find__F1__s_Option = (function(p) {
  var _$this = this;
  while (true) {
    if (_$this.isEmpty__Z()) {
      return $m_s_None$();
    } else if ((!(!p.apply__O__O(_$this.head__O())))) {
      return new $c_s_Some(_$this.head__O());
    } else {
      _$this = _$this.tail__O();
    }
  }
});
$c_sci_Stream.prototype.take__I__sci_Stream = (function(n) {
  return (((n <= 0) || this.isEmpty__Z()) ? $m_sci_Stream$Empty$() : ((n === 1) ? new $c_sci_Stream$Cons(this.head__O(), new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => $m_sci_Stream$Empty$()))) : new $c_sci_Stream$Cons(this.head__O(), new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => this.tail__O().take__I__sci_Stream((((-1) + n) | 0)))))));
});
$c_sci_Stream.prototype.foldLeft__O__F2__O = (function(z, op) {
  var _$this = this;
  while (true) {
    if (_$this.isEmpty__Z()) {
      return z;
    } else {
      var temp$_$this = _$this.tail__O();
      var temp$z = op.apply__O__O__O(z, _$this.head__O());
      _$this = temp$_$this;
      z = temp$z;
    }
  }
});
$c_sci_Stream.prototype.lazyAppendedAll__F0__sci_Stream = (function(suffix) {
  if (this.isEmpty__Z()) {
    var this$1 = $m_sci_Stream$();
    var source = suffix.apply__O();
    return this$1.from__sc_IterableOnce__sci_Stream(source);
  } else {
    var hd = this.head__O();
    var tl = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => this.tail__O().lazyAppendedAll__F0__sci_Stream(suffix)));
    return new $c_sci_Stream$Cons(hd, tl);
  }
});
$c_sci_Stream.prototype.reduceLeft__F2__O = (function(f) {
  if (this.isEmpty__Z()) {
    throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.reduceLeft");
  } else {
    var reducedRes = this.head__O();
    var left = this.tail__O();
    while ((!left.isEmpty__Z())) {
      reducedRes = f.apply__O__O__O(reducedRes, left.head__O());
      left = left.tail__O();
    }
    return reducedRes;
  }
});
$c_sci_Stream.prototype.partition__F1__T2 = (function(p) {
  var pred = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$1$2$2) => (!(!p.apply__O__O(x$1$2$2)))));
  var $x_1 = this.filterImpl__F1__Z__sci_Stream(pred, false);
  var pred$1 = new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2$2) => (!(!p.apply__O__O(x$2$2$2)))));
  return $ct_T2__O__O__(new $c_T2(), $x_1, this.filterImpl__F1__Z__sci_Stream(pred$1, true));
});
$c_sci_Stream.prototype.filterImpl__F1__Z__sci_Stream = (function(p, isFlipped) {
  var rest = this;
  while (true) {
    var this$1 = rest;
    if (((!this$1.isEmpty__Z()) && ((!(!p.apply__O__O(rest.head__O()))) === isFlipped))) {
      rest = rest.tail__O();
    } else {
      break;
    }
  }
  var this$2 = rest;
  if ((!this$2.isEmpty__Z())) {
    return $m_sci_Stream$().filteredTail__sci_Stream__F1__Z__sci_Stream(rest, p, isFlipped);
  } else {
    return $m_sci_Stream$Empty$();
  }
});
$c_sci_Stream.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return new $c_sci_Stream$WithFilter(this, p);
});
$c_sci_Stream.prototype.prepended__O__sci_Stream = (function(elem) {
  var tl = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => this));
  return new $c_sci_Stream$Cons(elem, tl);
});
$c_sci_Stream.prototype.map__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$();
  } else {
    var hd = f.apply__O__O(this.head__O());
    var tl = new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => this.tail__O().map__F1__sci_Stream(f)));
    return new $c_sci_Stream$Cons(hd, tl);
  }
});
$c_sci_Stream.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  var _$this = this;
  while (true) {
    if (_$this.isEmpty__Z()) {
      return $m_s_None$();
    } else {
      var newHead = new $c_sr_ObjectRef(null);
      var runWith = pf.runWith__F1__F1(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((newHead) => ((b$2$2) => {
        newHead.sr_ObjectRef__f_elem = b$2$2;
      }))(newHead)));
      if ((!(!runWith.apply__O__O(_$this.head__O())))) {
        return new $c_s_Some(newHead.sr_ObjectRef__f_elem);
      } else {
        _$this = _$this.tail__O();
      }
    }
  }
});
$c_sci_Stream.prototype.flatMap__F1__sci_Stream = (function(f) {
  if (this.isEmpty__Z()) {
    return $m_sci_Stream$Empty$();
  } else {
    var nonEmptyPrefix = new $c_sr_ObjectRef(this);
    var this$3 = $m_sci_Stream$();
    var source = f.apply__O__O(nonEmptyPrefix.sr_ObjectRef__f_elem.head__O());
    var prefix = this$3.from__sc_IterableOnce__sci_Stream(source);
    while (((!nonEmptyPrefix.sr_ObjectRef__f_elem.isEmpty__Z()) && prefix.isEmpty__Z())) {
      nonEmptyPrefix.sr_ObjectRef__f_elem = nonEmptyPrefix.sr_ObjectRef__f_elem.tail__O();
      if ((!nonEmptyPrefix.sr_ObjectRef__f_elem.isEmpty__Z())) {
        var this$4 = $m_sci_Stream$();
        var source$1 = f.apply__O__O(nonEmptyPrefix.sr_ObjectRef__f_elem.head__O());
        prefix = this$4.from__sc_IterableOnce__sci_Stream(source$1);
      }
    }
    return (nonEmptyPrefix.sr_ObjectRef__f_elem.isEmpty__Z() ? $m_sci_Stream$Empty$() : prefix.lazyAppendedAll__F0__sci_Stream(new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => nonEmptyPrefix.sr_ObjectRef__f_elem.tail__O().flatMap__F1__sci_Stream(f)))));
  }
});
$c_sci_Stream.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  this.force__sci_Stream();
  $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, sb.scm_StringBuilder__f_underlying, start, sep, end);
  return sb;
});
$c_sci_Stream.prototype.toString__T = (function() {
  return $p_sci_Stream__addStringNoForce__jl_StringBuilder__T__T__T__jl_StringBuilder(this, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), "Stream"), "(", ", ", ")").jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_sci_Stream.prototype.apply__O__O = (function(v1) {
  var n = (v1 | 0);
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_Stream.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = (x | 0);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_Stream.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_Stream(f);
});
$c_sci_Stream.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Stream(f);
});
$c_sci_Stream.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Stream(elem);
});
$c_sci_Stream.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Stream(pred, true);
});
$c_sci_Stream.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Stream(pred, false);
});
$c_sci_Stream.prototype.take__I__O = (function(n) {
  return this.take__I__sci_Stream(n);
});
$c_sci_Stream.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Stream$();
});
function $isArrayOf_sci_Stream(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Stream)));
}
export { $isArrayOf_sci_Stream as $isArrayOf_sci_Stream };
/** @constructor */
function $c_sci_WrappedString(self) {
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = null;
  this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self = self;
}
export { $c_sci_WrappedString as $c_sci_WrappedString };
$c_sci_WrappedString.prototype = new $h_sci_AbstractSeq();
$c_sci_WrappedString.prototype.constructor = $c_sci_WrappedString;
/** @constructor */
function $h_sci_WrappedString() {
}
export { $h_sci_WrappedString as $h_sci_WrappedString };
$h_sci_WrappedString.prototype = $c_sci_WrappedString.prototype;
$c_sci_WrappedString.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_WrappedString.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_WrappedString.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_WrappedString.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_sci_WrappedString.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_WrappedString.prototype.foldRight__O__F2__O = (function(z, op) {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $p_sc_IndexedSeqOps__foldr__I__I__O__F2__O(this, 0, this$1.length, z, op);
});
$c_sci_WrappedString.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sci_WrappedString.prototype.prepended__O__O = (function(elem) {
  return $f_sc_IndexedSeqOps__prepended__O__O(this, elem);
});
$c_sci_WrappedString.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_sci_WrappedString.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_sci_WrappedString.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$c_sci_WrappedString.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$c_sci_WrappedString.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_sci_WrappedString.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sci_WrappedString.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sci_WrappedString.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sci_WrappedString.prototype.lengthCompare__I__I = (function(len) {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  var x = this$1.length;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_WrappedString.prototype.knownSize__I = (function() {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return this$1.length;
});
$c_sci_WrappedString.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sci_WrappedString$().newBuilder__scm_Builder();
});
$c_sci_WrappedString.prototype.length__I = (function() {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return this$1.length;
});
$c_sci_WrappedString.prototype.toString__T = (function() {
  return this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
});
$c_sci_WrappedString.prototype.indexOf__O__I__I = (function(elem, from) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    return $f_T__indexOf__I__I__I(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self, x2, from);
  } else {
    return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
  }
});
$c_sci_WrappedString.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  if ((xs instanceof $ac_C)) {
    var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    var srcLen = this$1.length;
    var destLen = xs.u.length;
    var limit = ((len < srcLen) ? len : srcLen);
    var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
    var total = ((capacity < limit) ? capacity : limit);
    var copied = ((total < 0) ? 0 : total);
    $f_T__getChars__I__I__AC__I__V(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self, 0, copied, xs, start);
    return copied;
  } else {
    return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, xs, start, len);
  }
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__sci_IndexedSeq = (function(suffix) {
  if ((suffix instanceof $c_sci_WrappedString)) {
    var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    var s = suffix.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    return new $c_sci_WrappedString((this$1 + s));
  } else {
    return $f_sc_IterableOps__concat__sc_IterableOnce__O(this, suffix);
  }
});
$c_sci_WrappedString.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return ((o instanceof $c_sci_WrappedString) ? (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === o.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self) : $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o));
});
$c_sci_WrappedString.prototype.className__T = (function() {
  return "WrappedString";
});
$c_sci_WrappedString.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647;
});
$c_sci_WrappedString.prototype.equals__O__Z = (function(other) {
  return ((other instanceof $c_sci_WrappedString) ? (this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self === other.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self) : $f_sc_Seq__equals__O__Z(this, other));
});
$c_sci_WrappedString.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_sci_WrappedString.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_IndexedSeq(suffix);
});
$c_sci_WrappedString.prototype.view__sc_SeqView = (function() {
  return new $c_sc_StringView(this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self);
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll);
});
$c_sci_WrappedString.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $m_sci_WrappedString$().fromSpecific__sc_IterableOnce__sci_WrappedString(coll);
});
$c_sci_WrappedString.prototype.apply__O__O = (function(v1) {
  var i = (v1 | 0);
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $bC(this$1.charCodeAt(i));
});
$c_sci_WrappedString.prototype.apply__I__O = (function(i) {
  var this$1 = this.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
  return $bC(this$1.charCodeAt(i));
});
function $isArrayOf_sci_WrappedString(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_WrappedString)));
}
export { $isArrayOf_sci_WrappedString as $isArrayOf_sci_WrappedString };
var $d_sci_WrappedString = new $TypeData().initClass($c_sci_WrappedString, "scala.collection.immutable.WrappedString", ({
  sci_WrappedString: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_WrappedString as $d_sci_WrappedString };
function $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, array) {
  $thiz.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = array;
  return $thiz;
}
export { $ct_sjsr_WrappedVarArgs__sjs_js_Array__ as $ct_sjsr_WrappedVarArgs__sjs_js_Array__ };
function $ct_sjsr_WrappedVarArgs__($thiz) {
  $ct_sjsr_WrappedVarArgs__sjs_js_Array__($thiz, []);
  return $thiz;
}
export { $ct_sjsr_WrappedVarArgs__ as $ct_sjsr_WrappedVarArgs__ };
/** @constructor */
function $c_sjsr_WrappedVarArgs() {
  this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array = null;
}
export { $c_sjsr_WrappedVarArgs as $c_sjsr_WrappedVarArgs };
$c_sjsr_WrappedVarArgs.prototype = new $h_O();
$c_sjsr_WrappedVarArgs.prototype.constructor = $c_sjsr_WrappedVarArgs;
/** @constructor */
function $h_sjsr_WrappedVarArgs() {
}
export { $h_sjsr_WrappedVarArgs as $h_sjsr_WrappedVarArgs };
$h_sjsr_WrappedVarArgs.prototype = $c_sjsr_WrappedVarArgs.prototype;
$c_sjsr_WrappedVarArgs.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sjsr_WrappedVarArgs.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sci_StrictOptimizedSeqOps__updated__I__O__O(this, index, elem);
});
$c_sjsr_WrappedVarArgs.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sjsr_WrappedVarArgs.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$c_sjsr_WrappedVarArgs.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_sjsr_WrappedVarArgs.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_sjsr_WrappedVarArgs.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that);
});
$c_sjsr_WrappedVarArgs.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sjsr_WrappedVarArgs.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sjsr_WrappedVarArgs.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sjsr_WrappedVarArgs.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sjsr_WrappedVarArgs.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sjsr_WrappedVarArgs.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sjsr_WrappedVarArgs.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sjsr_WrappedVarArgs.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sjsr_WrappedVarArgs.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sjsr_WrappedVarArgs.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_IndexedSeqDefaults$().sci_IndexedSeqDefaults$__f_defaultApplyPreferredMaxLength;
});
$c_sjsr_WrappedVarArgs.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_sjsr_WrappedVarArgs.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sjsr_WrappedVarArgs.prototype.foldRight__O__F2__O = (function(z, op) {
  return $p_sc_IndexedSeqOps__foldr__I__I__O__F2__O(this, 0, this.length__I(), z, op);
});
$c_sjsr_WrappedVarArgs.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sjsr_WrappedVarArgs.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_sjsr_WrappedVarArgs.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_sjsr_WrappedVarArgs.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sjsr_WrappedVarArgs.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sjsr_WrappedVarArgs.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sjsr_WrappedVarArgs.prototype.toSeq__sci_Seq = (function() {
  return this;
});
$c_sjsr_WrappedVarArgs.prototype.equals__O__Z = (function(o) {
  return $f_sc_Seq__equals__O__Z(this, o);
});
$c_sjsr_WrappedVarArgs.prototype.hashCode__I = (function() {
  return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
});
$c_sjsr_WrappedVarArgs.prototype.toString__T = (function() {
  return $f_sc_Iterable__toString__T(this);
});
$c_sjsr_WrappedVarArgs.prototype.concat__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_sjsr_WrappedVarArgs.prototype.size__I = (function() {
  return this.length__I();
});
$c_sjsr_WrappedVarArgs.prototype.distinct__O = (function() {
  return $f_sc_SeqOps__distinct__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.isDefinedAt__I__Z = (function(idx) {
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sjsr_WrappedVarArgs.prototype.indexWhere__F1__I__I = (function(p, from) {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  var this$2 = $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
  return $f_sc_Iterator__indexWhere__F1__I__I(this$2, p, from);
});
$c_sjsr_WrappedVarArgs.prototype.sizeCompare__I__I = (function(otherSize) {
  var x = this.length__I();
  return ((x === otherSize) ? 0 : ((x < otherSize) ? (-1) : 1));
});
$c_sjsr_WrappedVarArgs.prototype.isEmpty__Z = (function() {
  return $f_sc_SeqOps__isEmpty__Z(this);
});
$c_sjsr_WrappedVarArgs.prototype.andThen__F1__s_PartialFunction = (function(k) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, k);
});
$c_sjsr_WrappedVarArgs.prototype.lift__F1 = (function() {
  return new $c_s_PartialFunction$Lifted(this);
});
$c_sjsr_WrappedVarArgs.prototype.applyOrElse__O__F1__O = (function(x, default$1) {
  return $f_s_PartialFunction__applyOrElse__O__F1__O(this, x, default$1);
});
$c_sjsr_WrappedVarArgs.prototype.runWith__F1__F1 = (function(action) {
  return $f_s_PartialFunction__runWith__F1__F1(this, action);
});
$c_sjsr_WrappedVarArgs.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return (!(!this.apply__I__O(v1)));
});
$c_sjsr_WrappedVarArgs.prototype.compose__F1__F1 = (function(g) {
  return $f_F1__compose__F1__F1(this, g);
});
$c_sjsr_WrappedVarArgs.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_sjsr_WrappedVarArgs$().newBuilder__scm_Builder();
});
$c_sjsr_WrappedVarArgs.prototype.lastOption__s_Option = (function() {
  return $f_sc_IterableOps__lastOption__s_Option(this);
});
$c_sjsr_WrappedVarArgs.prototype.withFilter__F1__sc_WithFilter = (function(p) {
  return $ct_sc_IterableOps$WithFilter__sc_IterableOps__F1__(new $c_sc_IterableOps$WithFilter(), this, p);
});
$c_sjsr_WrappedVarArgs.prototype.tail__O = (function() {
  return $f_sc_IterableOps__tail__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.init__O = (function() {
  return $f_sc_IterableOps__init__O(this);
});
$c_sjsr_WrappedVarArgs.prototype.foreach__F1__V = (function(f) {
  $f_sc_IterableOnceOps__foreach__F1__V(this, f);
});
$c_sjsr_WrappedVarArgs.prototype.forall__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__forall__F1__Z(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.exists__F1__Z = (function(p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.find__F1__s_Option = (function(p) {
  return $f_sc_IterableOnceOps__find__F1__s_Option(this, p);
});
$c_sjsr_WrappedVarArgs.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(this, z, op);
});
$c_sjsr_WrappedVarArgs.prototype.reduceLeft__F2__O = (function(op) {
  return $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op);
});
$c_sjsr_WrappedVarArgs.prototype.copyToArray__O__I__I__I = (function(dest, start, n) {
  return $f_sc_IterableOnceOps__copyToArray__O__I__I__I(this, dest, start, n);
});
$c_sjsr_WrappedVarArgs.prototype.min__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
});
$c_sjsr_WrappedVarArgs.prototype.max__s_math_Ordering__O = (function(ord) {
  return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
});
$c_sjsr_WrappedVarArgs.prototype.collectFirst__s_PartialFunction__s_Option = (function(pf) {
  return $f_sc_IterableOnceOps__collectFirst__s_PartialFunction__s_Option(this, pf);
});
$c_sjsr_WrappedVarArgs.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(b, start, sep, end) {
  return $f_sc_IterableOnceOps__addString__scm_StringBuilder__T__T__T__scm_StringBuilder(this, b, start, sep, end);
});
$c_sjsr_WrappedVarArgs.prototype.toList__sci_List = (function() {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(this);
});
$c_sjsr_WrappedVarArgs.prototype.toVector__sci_Vector = (function() {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this);
});
$c_sjsr_WrappedVarArgs.prototype.toMap__s_$less$colon$less__sci_Map = (function(ev) {
  return $m_sci_Map$().from__sc_IterableOnce__sci_Map(this);
});
$c_sjsr_WrappedVarArgs.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$2) {
  return $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, evidence$2);
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjsr_WrappedVarArgs$();
});
$c_sjsr_WrappedVarArgs.prototype.length__I = (function() {
  return (this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array.length | 0);
});
$c_sjsr_WrappedVarArgs.prototype.apply__I__O = (function(idx) {
  return this.sjsr_WrappedVarArgs__f_scala$scalajs$runtime$WrappedVarArgs$$array[idx];
});
$c_sjsr_WrappedVarArgs.prototype.className__T = (function() {
  return "WrappedVarArgs";
});
$c_sjsr_WrappedVarArgs.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sjsr_WrappedVarArgs$();
  return this$1.from__sc_IterableOnce__sjsr_WrappedVarArgs(coll);
});
$c_sjsr_WrappedVarArgs.prototype.andThen__F1__F1 = (function(g) {
  return $f_s_PartialFunction__andThen__F1__s_PartialFunction(this, g);
});
$c_sjsr_WrappedVarArgs.prototype.isDefinedAt__O__Z = (function(x) {
  var idx = (x | 0);
  return $f_sc_SeqOps__isDefinedAt__I__Z(this, idx);
});
$c_sjsr_WrappedVarArgs.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$c_sjsr_WrappedVarArgs.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O((v1 | 0));
});
$c_sjsr_WrappedVarArgs.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjsr_WrappedVarArgs$();
});
function $isArrayOf_sjsr_WrappedVarArgs(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sjsr_WrappedVarArgs)));
}
export { $isArrayOf_sjsr_WrappedVarArgs as $isArrayOf_sjsr_WrappedVarArgs };
var $d_sjsr_WrappedVarArgs = new $TypeData().initClass($c_sjsr_WrappedVarArgs, "scala.scalajs.runtime.WrappedVarArgs", ({
  sjsr_WrappedVarArgs: 1,
  sci_IndexedSeq: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_SeqOps: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sjsr_WrappedVarArgs as $d_sjsr_WrappedVarArgs };
/** @constructor */
function $c_Lcats_effect_SyncIO$SyncIOSync() {
  this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$Sync$$Delay = null;
  this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll = null;
  $f_Lcats_effect_kernel_Sync__$init$__V(this);
  this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll = new $c_Lcats_effect_kernel_MonadCancel$Uncancelable$$anon$9();
}
export { $c_Lcats_effect_SyncIO$SyncIOSync as $c_Lcats_effect_SyncIO$SyncIOSync };
$c_Lcats_effect_SyncIO$SyncIOSync.prototype = new $h_O();
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.constructor = $c_Lcats_effect_SyncIO$SyncIOSync;
/** @constructor */
function $h_Lcats_effect_SyncIO$SyncIOSync() {
}
export { $h_Lcats_effect_SyncIO$SyncIOSync as $h_Lcats_effect_SyncIO$SyncIOSync };
$h_Lcats_effect_SyncIO$SyncIOSync.prototype = $c_Lcats_effect_SyncIO$SyncIOSync.prototype;
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.handleError__O__F1__O = (function(fa, f) {
  return $f_Lcats_ApplicativeError__handleError__O__F1__O(this, fa, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.onError__O__s_PartialFunction__O = (function(fa, pf) {
  return $f_Lcats_ApplicativeError__onError__O__s_PartialFunction__O(this, fa, pf);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.productR__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productR__O__O__O(this, fa, fb);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.map__O__F1__O = (function(fa, f) {
  return $f_Lcats_Monad__map__O__F1__O(this, fa, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.guaranteeCase__O__F1__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel__guaranteeCase__O__F1__O(this, fa, fin);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.bracketFull__F1__F1__F2__O = (function(acquire, use, release) {
  return $f_Lcats_effect_kernel_MonadCancel__bracketFull__F1__F1__F2__O(this, acquire, use, release);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Delay_$eq__Lcats_effect_kernel_Sync$Type$Delay$__V = (function(x$0) {
  this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$Sync$$Delay = x$0;
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$Blocking_$eq__Lcats_effect_kernel_Sync$Type$Blocking$__V = (function(x$0) {
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleOnce_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleOnce$__V = (function(x$0) {
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.cats$effect$kernel$Sync$_setter_$cats$effect$kernel$Sync$$InterruptibleMany_$eq__Lcats_effect_kernel_Sync$Type$InterruptibleMany$__V = (function(x$0) {
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.delay__F0__O = (function(thunk) {
  var hint = this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$Sync$$Delay;
  return new $c_Lcats_effect_SyncIO$Suspend(hint, thunk);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.tailRecM__O__F1__O = (function(a, f) {
  return $f_Lcats_StackSafeMonad__tailRecM__O__F1__O(this, a, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.onCancel__O__O__O = (function(fa, fin) {
  return $f_Lcats_effect_kernel_MonadCancel$Uncancelable__onCancel__O__O__O(this, fa, fin);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.uncancelable__F1__O = (function(body) {
  return body.apply__O__O(this.Lcats_effect_SyncIO$SyncIOSync__f_cats$effect$kernel$MonadCancel$Uncancelable$$IdPoll);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.pure__O__O = (function(x) {
  $m_Lcats_effect_SyncIO$();
  return new $c_Lcats_effect_SyncIO$Pure(x);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.raiseError__O__O = (function(e) {
  $m_Lcats_effect_SyncIO$();
  return new $c_Lcats_effect_SyncIO$Error(e);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.handleErrorWith__O__F1__O = (function(fa, f) {
  return new $c_Lcats_effect_SyncIO$HandleErrorWith(fa, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.flatMap__O__F1__O = (function(fa, f) {
  return new $c_Lcats_effect_SyncIO$FlatMap(fa, f);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.monotonic__O = (function() {
  return $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f_monotonic;
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.realTime__O = (function() {
  return $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f_realTime;
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.suspend__Lcats_effect_kernel_Sync$Type__F0__O = (function(hint, thunk) {
  return new $c_Lcats_effect_SyncIO$Suspend(hint, thunk);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.attempt__O__O = (function(fa) {
  return new $c_Lcats_effect_SyncIO$Attempt(fa);
});
$c_Lcats_effect_SyncIO$SyncIOSync.prototype.unit__O = (function() {
  return $m_Lcats_effect_SyncIO$().Lcats_effect_SyncIO$__f__unit;
});
var $d_Lcats_effect_SyncIO$SyncIOSync = new $TypeData().initClass($c_Lcats_effect_SyncIO$SyncIOSync, "cats.effect.SyncIO$SyncIOSync", ({
  Lcats_effect_SyncIO$SyncIOSync: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_ApplicativeError: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_MonadError: 1,
  Lcats_effect_kernel_MonadCancel: 1,
  Lcats_effect_kernel_ClockPlatform: 1,
  Lcats_effect_kernel_Clock: 1,
  Lcats_effect_kernel_Unique: 1,
  Lcats_Defer: 1,
  Lcats_effect_kernel_Sync: 1,
  Lcats_StackSafeMonad: 1,
  Lcats_effect_kernel_MonadCancel$Uncancelable: 1
}));
export { $d_Lcats_effect_SyncIO$SyncIOSync as $d_Lcats_effect_SyncIO$SyncIOSync };
/** @constructor */
function $c_sci_HashMap(rootNode) {
  this.sci_HashMap__f_rootNode = null;
  this.sci_HashMap__f_rootNode = rootNode;
}
export { $c_sci_HashMap as $c_sci_HashMap };
$c_sci_HashMap.prototype = new $h_sci_AbstractMap();
$c_sci_HashMap.prototype.constructor = $c_sci_HashMap;
/** @constructor */
function $h_sci_HashMap() {
}
export { $h_sci_HashMap as $h_sci_HashMap };
$h_sci_HashMap.prototype = $c_sci_HashMap.prototype;
$c_sci_HashMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f);
});
$c_sci_HashMap.prototype.collect__s_PartialFunction__sc_IterableOps = (function(pf) {
  return $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps(this, pf);
});
$c_sci_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_HashMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_HashMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_HashMap.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_HashMap(pred, false);
});
$c_sci_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_HashMap$();
});
$c_sci_HashMap.prototype.knownSize__I = (function() {
  return this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size;
});
$c_sci_HashMap.prototype.size__I = (function() {
  return this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size;
});
$c_sci_HashMap.prototype.isEmpty__Z = (function() {
  return (this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size === 0);
});
$c_sci_HashMap.prototype.keySet__sci_Set = (function() {
  return ((this.sci_HashMap__f_rootNode.sci_BitmapIndexedMapNode__f_size === 0) ? $m_sci_Set$EmptySet$() : new $c_sci_HashMap$HashKeySet(this));
});
$c_sci_HashMap.prototype.iterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyValueTupleIterator(this.sci_HashMap__f_rootNode));
});
$c_sci_HashMap.prototype.keysIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyIterator(this.sci_HashMap__f_rootNode));
});
$c_sci_HashMap.prototype.valuesIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapValueIterator(this.sci_HashMap__f_rootNode));
});
$c_sci_HashMap.prototype.reverseIterator__sc_Iterator = (function() {
  return (this.isEmpty__Z() ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_sci_MapKeyValueTupleReverseIterator(this.sci_HashMap__f_rootNode));
});
$c_sci_HashMap.prototype.contains__O__Z = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.containsKey__O__I__I__I__Z(key, keyUnimprovedHash, keyHash, 0);
});
$c_sci_HashMap.prototype.apply__O__O = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.apply__O__I__I__I__O(key, keyUnimprovedHash, keyHash, 0);
});
$c_sci_HashMap.prototype.get__O__s_Option = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.get__O__I__I__I__s_Option(key, keyUnimprovedHash, keyHash, 0);
});
$c_sci_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var keyHash = $m_sc_Hashing$().improve__I__I(keyUnimprovedHash);
  return this.sci_HashMap__f_rootNode.getOrElse__O__I__I__I__F0__O(key, keyUnimprovedHash, keyHash, 0, default$1);
});
$c_sci_HashMap.prototype.updated__O__O__sci_HashMap = (function(key, value) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = this.sci_HashMap__f_rootNode.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(key, value, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0, true);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode));
});
$c_sci_HashMap.prototype.removed__O__sci_HashMap = (function(key) {
  var keyUnimprovedHash = $m_sr_Statics$().anyHash__O__I(key);
  var newRootNode = this.sci_HashMap__f_rootNode.removed__O__I__I__I__sci_BitmapIndexedMapNode(key, keyUnimprovedHash, $m_sc_Hashing$().improve__I__I(keyUnimprovedHash), 0);
  return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode));
});
$c_sci_HashMap.prototype.concat__sc_IterableOnce__sci_HashMap = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    if (this.isEmpty__Z()) {
      return that;
    } else {
      var newNode = this.sci_HashMap__f_rootNode.concat__sci_MapNode__I__sci_BitmapIndexedMapNode(that.sci_HashMap__f_rootNode, 0);
      return ((newNode === that.sci_HashMap__f_rootNode) ? that : ((newNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newNode)));
    }
  } else if ((that instanceof $c_scm_HashMap)) {
    var iter = that.nodeIterator__sc_Iterator();
    var current = this.sci_HashMap__f_rootNode;
    while (iter.hasNext__Z()) {
      var next = iter.next__O();
      var improvedHash = next.scm_HashMap$Node__f__hash;
      var originalHash = (improvedHash ^ ((improvedHash >>> 16) | 0));
      var improved = $m_sc_Hashing$().improve__I__I(originalHash);
      current = current.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(next.scm_HashMap$Node__f__key, next.scm_HashMap$Node__f__value, originalHash, improved, 0, true);
      if ((current !== this.sci_HashMap__f_rootNode)) {
        var shallowlyMutableNodeMap = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved, 0));
        while (iter.hasNext__Z()) {
          var next$2 = iter.next__O();
          var improvedHash$1 = next$2.scm_HashMap$Node__f__hash;
          var originalHash$2 = (improvedHash$1 ^ ((improvedHash$1 >>> 16) | 0));
          shallowlyMutableNodeMap = current.updateWithShallowMutations__O__O__I__I__I__I__I(next$2.scm_HashMap$Node__f__key, next$2.scm_HashMap$Node__f__value, originalHash$2, $m_sc_Hashing$().improve__I__I(originalHash$2), 0, shallowlyMutableNodeMap);
        }
        return new $c_sci_HashMap(current);
      }
    }
    return this;
  } else if ((that instanceof $c_scm_LinkedHashMap)) {
    var iter$2 = that.entryIterator__sc_Iterator();
    var current$2 = this.sci_HashMap__f_rootNode;
    while (iter$2.hasNext__Z()) {
      var next$3 = iter$2.next__O();
      var improvedHash$2 = next$3.scm_LinkedHashMap$LinkedEntry__f_hash;
      var originalHash$3 = (improvedHash$2 ^ ((improvedHash$2 >>> 16) | 0));
      var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$3);
      current$2 = current$2.updated__O__O__I__I__I__Z__sci_BitmapIndexedMapNode(next$3.scm_LinkedHashMap$LinkedEntry__f_key, next$3.scm_LinkedHashMap$LinkedEntry__f_value, originalHash$3, improved$2, 0, true);
      if ((current$2 !== this.sci_HashMap__f_rootNode)) {
        var shallowlyMutableNodeMap$2 = $m_sci_Node$().bitposFrom__I__I($m_sci_Node$().maskFrom__I__I__I(improved$2, 0));
        while (iter$2.hasNext__Z()) {
          var next$4 = iter$2.next__O();
          var improvedHash$3 = next$4.scm_LinkedHashMap$LinkedEntry__f_hash;
          var originalHash$4 = (improvedHash$3 ^ ((improvedHash$3 >>> 16) | 0));
          shallowlyMutableNodeMap$2 = current$2.updateWithShallowMutations__O__O__I__I__I__I__I(next$4.scm_LinkedHashMap$LinkedEntry__f_key, next$4.scm_LinkedHashMap$LinkedEntry__f_value, originalHash$4, $m_sc_Hashing$().improve__I__I(originalHash$4), 0, shallowlyMutableNodeMap$2);
        }
        return new $c_sci_HashMap(current$2);
      }
    }
    return this;
  } else if ($is_sci_Map(that)) {
    if (that.isEmpty__Z()) {
      return this;
    } else {
      var accum = new $c_sci_HashMap$accum$1(this);
      that.foreachEntry__F2__V(accum);
      var newRootNode = accum.sci_HashMap$accum$1__f_current;
      return ((newRootNode === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode));
    }
  } else {
    var it = that.iterator__sc_Iterator();
    if ((!it.hasNext__Z())) {
      return this;
    } else {
      var accum$2 = new $c_sci_HashMap$accum$1(this);
      $f_sc_IterableOnceOps__foreach__F1__V(it, accum$2);
      var newRootNode$1 = accum$2.sci_HashMap$accum$1__f_current;
      return ((newRootNode$1 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$1));
    }
  }
});
$c_sci_HashMap.prototype.tail__sci_HashMap = (function() {
  var key = this.iterator__sc_Iterator().next__O()._1__O();
  return this.removed__O__sci_HashMap(key);
});
$c_sci_HashMap.prototype.foreach__F1__V = (function(f) {
  this.sci_HashMap__f_rootNode.foreach__F1__V(f);
});
$c_sci_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  this.sci_HashMap__f_rootNode.foreachEntry__F2__V(f);
});
$c_sci_HashMap.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_HashMap)) {
    if ((this === that)) {
      return true;
    } else {
      var x = this.sci_HashMap__f_rootNode;
      var x$2 = that.sci_HashMap__f_rootNode;
      return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
    }
  } else {
    return $f_sc_Map__equals__O__Z(this, that);
  }
});
$c_sci_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash;
  } else {
    var hashIterator = new $c_sci_MapKeyValueTupleHashIterator(this.sci_HashMap__f_rootNode);
    var hash = $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
    return hash;
  }
});
$c_sci_HashMap.prototype.className__T = (function() {
  return "HashMap";
});
$c_sci_HashMap.prototype.filterImpl__F1__Z__sci_HashMap = (function(pred, isFlipped) {
  var newRootNode = this.sci_HashMap__f_rootNode.filterImpl__F1__Z__sci_BitmapIndexedMapNode(pred, isFlipped);
  if ((newRootNode === this.sci_HashMap__f_rootNode)) {
    return this;
  } else if ((newRootNode.sci_BitmapIndexedMapNode__f_size === 0)) {
    var this$1 = $m_sci_HashMap$();
    return this$1.sci_HashMap$__f_EmptyMap;
  } else {
    return new $c_sci_HashMap(newRootNode);
  }
});
$c_sci_HashMap.prototype.removedAll__sc_IterableOnce__sci_HashMap = (function(keys) {
  if (this.isEmpty__Z()) {
    return this;
  } else if ((keys instanceof $c_sci_HashSet)) {
    if (keys.isEmpty__Z()) {
      return this;
    } else {
      var newRootNode = new $c_sci_MapNodeRemoveAllSetNodeIterator(keys.sci_HashSet__f_rootNode).removeAll__sci_BitmapIndexedMapNode__sci_BitmapIndexedMapNode(this.sci_HashMap__f_rootNode);
      if ((newRootNode === this.sci_HashMap__f_rootNode)) {
        return this;
      } else if ((newRootNode.sci_BitmapIndexedMapNode__f_size <= 0)) {
        var this$1 = $m_sci_HashMap$();
        return this$1.sci_HashMap$__f_EmptyMap;
      } else {
        return new $c_sci_HashMap(newRootNode);
      }
    }
  } else if ((keys instanceof $c_scm_HashSet)) {
    if (keys.isEmpty__Z()) {
      return this;
    } else {
      var iter = new $c_scm_HashSet$$anon$2(keys);
      var curr = this.sci_HashMap__f_rootNode;
      while (iter.hasNext__Z()) {
        var next = iter.next__O();
        var improvedHash = next.scm_HashSet$Node__f__hash;
        var originalHash = keys.scala$collection$mutable$HashSet$$improveHash__I__I(improvedHash);
        var improved = $m_sc_Hashing$().improve__I__I(originalHash);
        curr = curr.removed__O__I__I__I__sci_BitmapIndexedMapNode(next.scm_HashSet$Node__f__key, originalHash, improved, 0);
        if ((curr.sci_BitmapIndexedMapNode__f_size === 0)) {
          var this$2 = $m_sci_HashMap$();
          return this$2.sci_HashMap$__f_EmptyMap;
        }
      }
      var newRootNode$1 = curr;
      return ((newRootNode$1 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$1));
    }
  } else if ((keys instanceof $c_scm_LinkedHashSet)) {
    if (keys.isEmpty__Z()) {
      return this;
    } else {
      var iter$2 = new $c_scm_LinkedHashSet$$anon$2(keys);
      var curr$2 = this.sci_HashMap__f_rootNode;
      while (iter$2.hasNext__Z()) {
        var next$2 = iter$2.next__O();
        var improvedHash$1 = next$2.scm_LinkedHashSet$Entry__f_hash;
        var originalHash$2 = (improvedHash$1 ^ ((improvedHash$1 >>> 16) | 0));
        var improved$2 = $m_sc_Hashing$().improve__I__I(originalHash$2);
        curr$2 = curr$2.removed__O__I__I__I__sci_BitmapIndexedMapNode(next$2.scm_LinkedHashSet$Entry__f_key, originalHash$2, improved$2, 0);
        if ((curr$2.sci_BitmapIndexedMapNode__f_size === 0)) {
          var this$3 = $m_sci_HashMap$();
          return this$3.sci_HashMap$__f_EmptyMap;
        }
      }
      var newRootNode$2 = curr$2;
      return ((newRootNode$2 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$2));
    }
  } else {
    var iter$3 = keys.iterator__sc_Iterator();
    var curr$3 = this.sci_HashMap__f_rootNode;
    while (iter$3.hasNext__Z()) {
      var next$3 = iter$3.next__O();
      var originalHash$3 = $m_sr_Statics$().anyHash__O__I(next$3);
      var improved$3 = $m_sc_Hashing$().improve__I__I(originalHash$3);
      curr$3 = curr$3.removed__O__I__I__I__sci_BitmapIndexedMapNode(next$3, originalHash$3, improved$3, 0);
      if ((curr$3.sci_BitmapIndexedMapNode__f_size === 0)) {
        var this$4 = $m_sci_HashMap$();
        return this$4.sci_HashMap$__f_EmptyMap;
      }
    }
    var newRootNode$3 = curr$3;
    return ((newRootNode$3 === this.sci_HashMap__f_rootNode) ? this : new $c_sci_HashMap(newRootNode$3));
  }
});
$c_sci_HashMap.prototype.drop__I__O = (function(n) {
  return $f_sc_IterableOps__drop__I__O(this, n);
});
$c_sci_HashMap.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_HashMap.prototype.take__I__O = (function(n) {
  return $f_sc_IterableOps__take__I__O(this, n);
});
$c_sci_HashMap.prototype.removedAll__sc_IterableOnce__sci_MapOps = (function(keys) {
  return this.removedAll__sc_IterableOnce__sci_HashMap(keys);
});
$c_sci_HashMap.prototype.last__O = (function() {
  return this.reverseIterator__sc_Iterator().next__O();
});
$c_sci_HashMap.prototype.head__O = (function() {
  return this.iterator__sc_Iterator().next__O();
});
$c_sci_HashMap.prototype.tail__O = (function() {
  return this.tail__sci_HashMap();
});
$c_sci_HashMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__sci_HashMap(suffix);
});
$c_sci_HashMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_HashMap(key);
});
$c_sci_HashMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_HashMap(key, value);
});
$c_sci_HashMap.prototype.keySet__sc_Set = (function() {
  return this.keySet__sci_Set();
});
function $isArrayOf_sci_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_HashMap)));
}
export { $isArrayOf_sci_HashMap as $isArrayOf_sci_HashMap };
var $d_sci_HashMap = new $TypeData().initClass($c_sci_HashMap, "scala.collection.immutable.HashMap", ({
  sci_HashMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_HashMap as $d_sci_HashMap };
/** @constructor */
function $c_sci_Stream$Cons(head, tl) {
  this.sci_Stream$Cons__f_head = null;
  this.sci_Stream$Cons__f_tlVal = null;
  this.sci_Stream$Cons__f_tlGen = null;
  this.sci_Stream$Cons__f_head = head;
  this.sci_Stream$Cons__f_tlGen = tl;
}
export { $c_sci_Stream$Cons as $c_sci_Stream$Cons };
$c_sci_Stream$Cons.prototype = new $h_sci_Stream();
$c_sci_Stream$Cons.prototype.constructor = $c_sci_Stream$Cons;
/** @constructor */
function $h_sci_Stream$Cons() {
}
export { $h_sci_Stream$Cons as $h_sci_Stream$Cons };
$h_sci_Stream$Cons.prototype = $c_sci_Stream$Cons.prototype;
$c_sci_Stream$Cons.prototype.head__O = (function() {
  return this.sci_Stream$Cons__f_head;
});
$c_sci_Stream$Cons.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_Stream$Cons.prototype.tailDefined__Z = (function() {
  return (this.sci_Stream$Cons__f_tlGen === null);
});
$c_sci_Stream$Cons.prototype.tail__sci_Stream = (function() {
  if ((!this.tailDefined__Z())) {
    if ((!this.tailDefined__Z())) {
      this.sci_Stream$Cons__f_tlVal = this.sci_Stream$Cons__f_tlGen.apply__O();
      this.sci_Stream$Cons__f_tlGen = null;
    }
  }
  return this.sci_Stream$Cons__f_tlVal;
});
$c_sci_Stream$Cons.prototype.force__sci_Stream$Cons = (function() {
  var these = this;
  var those = this;
  if ((!these.isEmpty__Z())) {
    these = these.tail__O();
  }
  while ((those !== these)) {
    if (these.isEmpty__Z()) {
      return this;
    }
    these = these.tail__O();
    if (these.isEmpty__Z()) {
      return this;
    }
    these = these.tail__O();
    if ((these === those)) {
      return this;
    }
    those = those.tail__O();
  }
  return this;
});
$c_sci_Stream$Cons.prototype.force__sci_Stream = (function() {
  return this.force__sci_Stream$Cons();
});
$c_sci_Stream$Cons.prototype.tail__O = (function() {
  return this.tail__sci_Stream();
});
var $d_sci_Stream$Cons = new $TypeData().initClass($c_sci_Stream$Cons, "scala.collection.immutable.Stream$Cons", ({
  sci_Stream$Cons: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Stream$Cons as $d_sci_Stream$Cons };
/** @constructor */
function $c_sci_Stream$Empty$() {
}
export { $c_sci_Stream$Empty$ as $c_sci_Stream$Empty$ };
$c_sci_Stream$Empty$.prototype = new $h_sci_Stream();
$c_sci_Stream$Empty$.prototype.constructor = $c_sci_Stream$Empty$;
/** @constructor */
function $h_sci_Stream$Empty$() {
}
export { $h_sci_Stream$Empty$ as $h_sci_Stream$Empty$ };
$h_sci_Stream$Empty$.prototype = $c_sci_Stream$Empty$.prototype;
$c_sci_Stream$Empty$.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sci_Stream$Empty$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty stream");
});
$c_sci_Stream$Empty$.prototype.tail__sci_Stream = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty stream");
});
$c_sci_Stream$Empty$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Stream$Empty$.prototype.tailDefined__Z = (function() {
  return false;
});
$c_sci_Stream$Empty$.prototype.force__sci_Stream = (function() {
  return this;
});
$c_sci_Stream$Empty$.prototype.tail__O = (function() {
  return this.tail__sci_Stream();
});
$c_sci_Stream$Empty$.prototype.head__O = (function() {
  this.head__E();
});
var $d_sci_Stream$Empty$ = new $TypeData().initClass($c_sci_Stream$Empty$, "scala.collection.immutable.Stream$Empty$", ({
  sci_Stream$Empty$: 1,
  sci_Stream: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Stream$Empty$ as $d_sci_Stream$Empty$ };
var $n_sci_Stream$Empty$;
function $m_sci_Stream$Empty$() {
  if ((!$n_sci_Stream$Empty$)) {
    $n_sci_Stream$Empty$ = new $c_sci_Stream$Empty$();
  }
  return $n_sci_Stream$Empty$;
}
export { $m_sci_Stream$Empty$ as $m_sci_Stream$Empty$ };
function $isArrayOf_sci_TreeSeqMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_TreeSeqMap)));
}
export { $isArrayOf_sci_TreeSeqMap as $isArrayOf_sci_TreeSeqMap };
function $isArrayOf_sci_VectorMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_VectorMap)));
}
export { $isArrayOf_sci_VectorMap as $isArrayOf_sci_VectorMap };
/** @constructor */
function $c_scm_AbstractBuffer() {
}
export { $c_scm_AbstractBuffer as $c_scm_AbstractBuffer };
$c_scm_AbstractBuffer.prototype = new $h_scm_AbstractSeq();
$c_scm_AbstractBuffer.prototype.constructor = $c_scm_AbstractBuffer;
/** @constructor */
function $h_scm_AbstractBuffer() {
}
export { $h_scm_AbstractBuffer as $h_scm_AbstractBuffer };
$h_scm_AbstractBuffer.prototype = $c_scm_AbstractBuffer.prototype;
$c_scm_AbstractBuffer.prototype.subtractOne__O__scm_Buffer = (function(x) {
  return $f_scm_Buffer__subtractOne__O__scm_Buffer(this, x);
});
$c_scm_AbstractBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_AbstractBuffer.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_Buffer(elem);
});
/** @constructor */
function $c_scm_AbstractMap() {
}
export { $c_scm_AbstractMap as $c_scm_AbstractMap };
$c_scm_AbstractMap.prototype = new $h_sc_AbstractMap();
$c_scm_AbstractMap.prototype.constructor = $c_scm_AbstractMap;
/** @constructor */
function $h_scm_AbstractMap() {
}
export { $h_scm_AbstractMap as $h_scm_AbstractMap };
$h_scm_AbstractMap.prototype = $c_scm_AbstractMap.prototype;
$c_scm_AbstractMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_Map$();
});
$c_scm_AbstractMap.prototype.update__O__O__V = (function(key, value) {
  $f_scm_MapOps__update__O__O__V(this, key, value);
});
$c_scm_AbstractMap.prototype.updateWith__O__F1__s_Option = (function(key, remappingFunction) {
  return $f_scm_MapOps__updateWith__O__F1__s_Option(this, key, remappingFunction);
});
$c_scm_AbstractMap.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
});
$c_scm_AbstractMap.prototype.remove__O__s_Option = (function(key) {
  return $f_scm_MapOps__remove__O__s_Option(this, key);
});
$c_scm_AbstractMap.prototype.knownSize__I = (function() {
  return (-1);
});
$c_scm_AbstractMap.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_AbstractMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_AbstractMap.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Iterable$();
});
$c_scm_AbstractMap.prototype.result__O = (function() {
  return this;
});
/** @constructor */
function $c_Lcats_data_ChainInstances$$anon$3() {
}
export { $c_Lcats_data_ChainInstances$$anon$3 as $c_Lcats_data_ChainInstances$$anon$3 };
$c_Lcats_data_ChainInstances$$anon$3.prototype = new $h_O();
$c_Lcats_data_ChainInstances$$anon$3.prototype.constructor = $c_Lcats_data_ChainInstances$$anon$3;
/** @constructor */
function $h_Lcats_data_ChainInstances$$anon$3() {
}
export { $h_Lcats_data_ChainInstances$$anon$3 as $h_Lcats_data_ChainInstances$$anon$3 };
$h_Lcats_data_ChainInstances$$anon$3.prototype = $c_Lcats_data_ChainInstances$$anon$3.prototype;
$c_Lcats_data_ChainInstances$$anon$3.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return fa.map__F1__Lcats_data_Chain(f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__Lcats_data_Chain__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.unit__O = (function() {
  $m_Lcats_data_Chain$();
  return new $c_Lcats_data_Chain$Singleton((void 0));
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldRight__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $ps_Lcats_data_ChainInstances__loop$6__F2__Lcats_Eval__Lcats_data_Chain__Lcats_Eval(f, lb, fa)));
  return new $c_Lcats_Eval$$anon$5(a);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldMap__Lcats_data_Chain__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if (fa.isEmpty__Z()) {
    return G.pure__O__O($m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil);
  } else if ($is_Lcats_StackSafeMonad(G)) {
    return $m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa.iterator__sc_Iterator(), f, G);
  } else {
    var $x_1 = $m_Lcats_data_Chain$();
    var this$1 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    var elems$1 = fa.iterator__sc_Iterator();
    as.addAll__sc_IterableOnce__scm_ArrayBuffer(elems$1);
    return $x_1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G);
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverseVoid__Lcats_data_Chain__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    return $m_Lcats_Traverse$().traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa.iterator__sc_Iterator(), f, G);
  } else {
    var x$2 = $m_Lcats_data_Chain$Empty$();
    if (x$2.equals__O__Z(fa)) {
      return G.unit__O();
    }
    if ((fa instanceof $c_Lcats_data_Chain$NonEmpty)) {
      return $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$10__F1__Lcats_Applicative__Lcats_data_Chain$NonEmpty__Lcats_data_Chain__O__O(f, G, fa, $m_Lcats_data_Chain$Empty$(), G.unit__O());
    }
    throw new $c_s_MatchError(fa);
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.tailRecM__O__F1__Lcats_data_Chain = (function(a, f) {
  var elem$4 = f.apply__O__O(a);
  var this$1 = $m_sci_Nil$();
  return $s_Lcats_data_ChainInstances__cats$data$ChainInstances$$anon$3$$_$go$11__F1__sci_List__Lcats_data_Chain__Lcats_data_Chain(f, new $c_sci_$colon$colon(elem$4, this$1), $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain = (function(fa, fb, f) {
  if (fb.isEmpty__Z()) {
    return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
  } else {
    var this$1 = $m_Lcats_data_Chain$();
    var result = this$1.Lcats_data_Chain$__f_nil;
    var iter = fa.iterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var this$2 = result;
      var x0 = iter.next__O();
      var c = fb.map__F1__Lcats_data_Chain(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((f, x0) => ((b) => f.apply__O__O__O(x0, b)))(f, x0)));
      result = $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(this$2, c);
    }
    return result;
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2Eval__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  if (fa.isEmpty__Z()) {
    $m_Lcats_Eval$();
    var a = $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
    return new $c_Lcats_Now(a);
  } else {
    return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fb$2) => this.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain(fa, fb$2, f))));
  }
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return fa.foldLeft__O__F2__O(b, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval(fa, lb, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__Lcats_data_Chain__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map__O__F1__O = (function(fa, f) {
  return fa.map__F1__Lcats_data_Chain(f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.toList__O__sci_List = (function(fa) {
  return fa.toList__sci_List();
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.exists__O__F1__Z = (function(fa, p) {
  return fa.exists__F1__Z(p);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.size__O__J = (function(fa) {
  return fa.length__J();
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__Lcats_data_Chain__F1__Lcats_Applicative__O(fa, f, evidence$1);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverseVoid__Lcats_data_Chain__F1__Lcats_Applicative__O(fa, f, G);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return new $c_Lcats_data_ChainInstances$$anon$4(fa);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.empty__O = (function() {
  return $m_Lcats_data_Chain$().Lcats_data_Chain$__f_nil;
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.combineK__O__O__O = (function(x, y) {
  return $m_Lcats_data_Chain$().concat__Lcats_data_Chain__Lcats_data_Chain__Lcats_data_Chain(x, y);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_Chain$();
  return new $c_Lcats_data_Chain$Singleton(x);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.flatMap__O__F1__O = (function(fa, f) {
  return fa.flatMap__F1__Lcats_data_Chain(f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lcats_data_Chain(a, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__Lcats_data_Chain__Lcats_data_Chain__F2__Lcats_data_Chain(fa, fb, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__Lcats_data_Chain__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_Alternative$$anon$1(evidence$1, this);
});
$c_Lcats_data_ChainInstances$$anon$3.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_MonoidK$$anon$1(this);
});
var $d_Lcats_data_ChainInstances$$anon$3 = new $TypeData().initClass($c_Lcats_data_ChainInstances$$anon$3, "cats.data.ChainInstances$$anon$3", ({
  Lcats_data_ChainInstances$$anon$3: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_data_ChainInstances$$anon$3 as $d_Lcats_data_ChainInstances$$anon$3 };
/** @constructor */
function $c_Lcats_instances_ListInstances$$anon$1() {
  this.Lcats_instances_ListInstances$$anon$1__f_evalNil = null;
  this.Lcats_instances_ListInstances$$anon$1__f__unit = null;
  $m_Lcats_Eval$();
  var a = $m_sci_Nil$();
  this.Lcats_instances_ListInstances$$anon$1__f_evalNil = new $c_Lcats_Now(a);
  var this$3 = $m_sci_Nil$();
  this.Lcats_instances_ListInstances$$anon$1__f__unit = new $c_sci_$colon$colon((void 0), this$3);
}
export { $c_Lcats_instances_ListInstances$$anon$1 as $c_Lcats_instances_ListInstances$$anon$1 };
$c_Lcats_instances_ListInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_ListInstances$$anon$1.prototype.constructor = $c_Lcats_instances_ListInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_ListInstances$$anon$1() {
}
export { $h_Lcats_instances_ListInstances$$anon$1 as $h_Lcats_instances_ListInstances$$anon$1 };
$h_Lcats_instances_ListInstances$$anon$1.prototype = $c_Lcats_instances_ListInstances$$anon$1.prototype;
$c_Lcats_instances_ListInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return fa.map__F1__sci_List(f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.size__O__J = (function(fa) {
  return $f_Lcats_UnorderedFoldable__size__O__J(this, fa);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_List__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__sci_List__sci_List__F2__sci_List = (function(fa, fb, f) {
  if (fb.isEmpty__Z()) {
    return $m_sci_Nil$();
  } else {
    var rest = fa;
    var h = null;
    var t = null;
    while ((rest !== $m_sci_Nil$())) {
      var x0 = rest.head__O();
      var f$1 = ((f, x0) => ((b) => f.apply__O__O__O(x0, b)))(f, x0);
      if ((fb === $m_sci_Nil$())) {
        var $x_1 = $m_sci_Nil$();
      } else {
        var x0$1 = fb.head__O();
        var h$1 = new $c_sci_$colon$colon(f$1(x0$1), $m_sci_Nil$());
        var t$1 = h$1;
        var rest$1 = fb.tail__O();
        while ((rest$1 !== $m_sci_Nil$())) {
          var x0$2 = rest$1.head__O();
          var nx = new $c_sci_$colon$colon(f$1(x0$2), $m_sci_Nil$());
          t$1.sci_$colon$colon__f_next = nx;
          t$1 = nx;
          rest$1 = rest$1.tail__O();
        }
        var $x_1 = h$1;
      }
      var it = $x_1.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var nx$1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
        if ((t === null)) {
          h = nx$1;
        } else {
          t.sci_$colon$colon__f_next = nx$1;
        }
        t = nx$1;
      }
      rest = rest.tail__O();
    }
    return ((h === null) ? $m_sci_Nil$() : h);
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2Eval__sci_List__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return (fa.isEmpty__Z() ? this.Lcats_instances_ListInstances$$anon$1__f_evalNil : fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fb$2) => this.map2__sci_List__sci_List__F2__sci_List(fa, fb$2, f)))));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.tailRecM__O__F1__sci_List = (function(a, f) {
  var buf = new $c_scm_ListBuffer();
  var elem$2 = f.apply__O__O(a);
  var this$2 = $m_sci_Nil$();
  $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$go$1__scm_Builder__F1__sci_List__V(buf, f, new $c_sci_$colon$colon(elem$2, this$2));
  return buf.toList__sci_List();
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldRight__sci_List__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $ps_Lcats_instances_ListInstances__loop$2__Lcats_Eval__F2__sci_List__Lcats_Eval(lb, f, fa)));
  return new $c_Lcats_Eval$$anon$5(a);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldMap__sci_List__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse__sci_List__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if (fa.isEmpty__Z()) {
    return G.pure__O__O($m_sci_Nil$());
  } else if ($is_Lcats_StackSafeMonad(G)) {
    return G.map__O__F1__O($m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, G), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => _$3.toList__sci_List())));
  } else {
    var $x_1 = $m_Lcats_data_Chain$();
    var this$1 = $m_scm_ArrayBuffer$();
    var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([]));
    var as = this$1.from__sc_IterableOnce__scm_ArrayBuffer(elems);
    as.addAll__sc_IterableOnce__scm_ArrayBuffer(fa);
    return G.map__O__F1__O($x_1.traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(new $c_Lcats_kernel_instances_StaticMethods$WrappedIndexedSeq(as), f, G), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => _$4.toList__sci_List())));
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverseVoid__sci_List__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    return $m_Lcats_Traverse$().traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, G);
  } else {
    var len = fa.length__I();
    return ((len === 0) ? G.unit__O() : $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__F1__I__sci_List__Lcats_Eval(G, f, len, fa).value__O());
  }
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldM__sci_List__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return G.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), fa, z), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((in$1) => $ps_Lcats_instances_ListInstances__step$1__Lcats_Monad__F2__T2__O(G, f, in$1))));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.void__sci_List__sci_List = (function(fa) {
  return (fa.isEmpty__Z() ? $m_sci_Nil$() : $s_Lcats_instances_ListInstances__cats$instances$ListInstances$$anon$1$$_$build$1__sci_List__sci_List__sci_List(fa.tail__O(), this.Lcats_instances_ListInstances$$anon$1__f__unit));
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_Nil$();
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return y.$colon$colon$colon__sci_List__sci_List(x);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.pure__O__O = (function(x) {
  var this$1 = $m_sci_Nil$();
  return new $c_sci_$colon$colon(x, this$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return fa.map__F1__sci_List(f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  return fa.flatMap__F1__sci_List(f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_List__sci_List__F2__sci_List(fa, fb, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_List__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_List(a, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(fa, b, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_List__Lcats_Eval__F2__Lcats_Eval(fa, lb, f);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_List__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_List__F1__Lcats_Applicative__O(fa, f, evidence$1);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverseVoid__sci_List__F1__Lcats_Applicative__O(fa, f, G);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.exists__O__F1__Z = (function(fa, p) {
  return fa.exists__F1__Z(p);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_List__O__F2__Lcats_Monad__O(fa, z, f, G);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  return fa;
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return fa;
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return $m_Lcats_kernel_instances_ListMonoid$().Lcats_kernel_instances_ListMonoid$__f_singleton;
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.unit__O = (function() {
  return this.Lcats_instances_ListInstances$$anon$1__f__unit;
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return this.void__sci_List__sci_List(fa);
});
$c_Lcats_instances_ListInstances$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_Alternative$$anon$1(evidence$1, this);
});
var $d_Lcats_instances_ListInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_ListInstances$$anon$1, "cats.instances.ListInstances$$anon$1", ({
  Lcats_instances_ListInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_instances_ListInstances$$anon$1 as $d_Lcats_instances_ListInstances$$anon$1 };
/** @constructor */
function $c_Lcats_instances_SeqInstances$$anon$1() {
  this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty = null;
  $m_Lcats_Eval$();
  var a = $m_sci_Seq$().empty__sc_SeqOps();
  this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty = new $c_Lcats_Now(a);
}
export { $c_Lcats_instances_SeqInstances$$anon$1 as $c_Lcats_instances_SeqInstances$$anon$1 };
$c_Lcats_instances_SeqInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_SeqInstances$$anon$1.prototype.constructor = $c_Lcats_instances_SeqInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_SeqInstances$$anon$1() {
}
export { $h_Lcats_instances_SeqInstances$$anon$1 as $h_Lcats_instances_SeqInstances$$anon$1 };
$h_Lcats_instances_SeqInstances$$anon$1.prototype = $c_Lcats_instances_SeqInstances$$anon$1.prototype;
$c_Lcats_instances_SeqInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return fa.map__F1__O(f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_Seq__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Seq((void 0));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.pure__O__sci_Seq = (function(x) {
  return $m_sci_Seq$().apply__sci_Seq__sc_SeqOps($m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x])));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2__sci_Seq__sci_Seq__F2__sci_Seq = (function(fa, fb, f) {
  return (fb.isEmpty__Z() ? $m_sci_Seq$().empty__sc_SeqOps() : fa.flatMap__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((a) => fb.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b) => f.apply__O__O__O(a, b))))))));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2Eval__sci_Seq__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return (fa.isEmpty__Z() ? this.Lcats_instances_SeqInstances$$anon$1__f_evalEmpty : fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fb$2) => this.map2__sci_Seq__sci_Seq__F2__sci_Seq(fa, fb$2, f)))));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldMap__sci_Seq__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.tailRecM__O__F1__sci_Seq = (function(a, fn) {
  var buf = $m_sci_Seq$().newBuilder__scm_Builder();
  var elem = new $c_sci_$colon$colon(fn.apply__O__O(a).iterator__sc_Iterator(), $m_sci_Nil$());
  var elem$1 = null;
  elem$1 = elem;
  while (true) {
    var x11 = elem$1;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x11)) {
      break;
    }
    if ((x11 instanceof $c_sci_$colon$colon)) {
      var x16 = x11.sci_$colon$colon__f_head;
      var x17 = x11.sci_$colon$colon__f_next;
      if ((!x16.hasNext__Z())) {
        elem$1 = x17;
        continue;
      }
      var x6 = x16.next__O();
      if ((x6 instanceof $c_s_util_Right)) {
        var b = x6.s_util_Right__f_value;
        buf.addOne__O__scm_Growable(b);
        continue;
      }
      if ((x6 instanceof $c_s_util_Left)) {
        var a$1 = x6.s_util_Left__f_value;
        var elem$1$1 = fn.apply__O__O(a$1).iterator__sc_Iterator();
        var this$2 = new $c_sci_$colon$colon(x16, x17);
        elem$1 = new $c_sci_$colon$colon(elem$1$1, this$2);
        continue;
      }
      throw new $c_s_MatchError(x6);
    }
    throw new $c_s_MatchError(x11);
  }
  return buf.result__O();
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverse__sci_Seq__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return ($is_Lcats_StackSafeMonad(G) ? G.map__O__F1__O($m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, G), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => _$3.toList__sci_List()))) : G.map__O__F1__O($m_Lcats_data_Chain$().traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(fa.toIndexedSeq__sci_IndexedSeq(), f, G), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => _$4.toList__sci_List()))));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverseVoid__sci_Seq__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    return $m_Lcats_Traverse$().traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, G);
  } else {
    $m_Lcats_Eval$();
    var a = G.unit__O();
    var lb = new $c_Lcats_Now(a);
    var f$1 = new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((a$1, acc) => G.map2Eval__O__Lcats_Eval__F2__Lcats_Eval(f.apply__O__O(a$1), acc, new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$6, _$7) => (void 0))))));
    return $m_Lcats_Foldable$().iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval(fa, lb, f$1).value__O();
  }
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldM__sci_Seq__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  var length = fa.length__I();
  return G.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), z, 0), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var b = x$1._1__O();
      var i = (x$1._2__O() | 0);
      return ((i < length) ? G.map__O__F1__O(f.apply__O__O__O(b, fa.apply__I__O(i)), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b$2) => {
        var _2 = ((1 + i) | 0);
        var value = $ct_T2__O__O__(new $c_T2(), b$2, _2);
        return new $c_s_util_Left(value);
      }))) : G.pure__O__O(new $c_s_util_Right(b)));
    }
    throw new $c_s_MatchError(x$1);
  })));
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.empty__O = (function() {
  return $m_sci_Seq$().empty__sc_SeqOps();
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return x.appendedAll__sc_IterableOnce__O(y);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Seq(x);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return fa.map__F1__O(f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  return fa.flatMap__F1__O(f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Seq__sci_Seq__F2__sci_Seq(fa, fb, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Seq__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return fa.foldLeft__O__F2__O(b, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return $m_Lcats_Foldable$().iterateRight__sc_Iterable__Lcats_Eval__F2__Lcats_Eval(fa, lb, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Seq__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Seq(a, f);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.size__O__J = (function(fa) {
  var value = fa.length__I();
  var hi = (value >> 31);
  return new $c_RTLong(value, hi);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Seq__F1__Lcats_Applicative__O(fa, f, evidence$1);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverseVoid__sci_Seq__F1__Lcats_Applicative__O(fa, f, G);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.exists__O__F1__Z = (function(fa, p) {
  return fa.exists__F1__Z(p);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Seq__O__F2__Lcats_Monad__O(fa, z, f, G);
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  return fa.toList__sci_List();
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return fa;
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  var this$1 = $m_Lcats_kernel_instances_SeqMonoid$();
  return this$1.Lcats_kernel_instances_SeqMonoid$__f_singleton;
});
$c_Lcats_instances_SeqInstances$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_Alternative$$anon$1(evidence$1, this);
});
var $d_Lcats_instances_SeqInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_SeqInstances$$anon$1, "cats.instances.SeqInstances$$anon$1", ({
  Lcats_instances_SeqInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_instances_SeqInstances$$anon$1 as $d_Lcats_instances_SeqInstances$$anon$1 };
/** @constructor */
function $c_Lcats_instances_VectorInstances$$anon$1() {
  this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty = null;
  $m_Lcats_Eval$();
  $m_sci_Vector$();
  var a = $m_sci_Vector0$();
  this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty = new $c_Lcats_Now(a);
}
export { $c_Lcats_instances_VectorInstances$$anon$1 as $c_Lcats_instances_VectorInstances$$anon$1 };
$c_Lcats_instances_VectorInstances$$anon$1.prototype = new $h_O();
$c_Lcats_instances_VectorInstances$$anon$1.prototype.constructor = $c_Lcats_instances_VectorInstances$$anon$1;
/** @constructor */
function $h_Lcats_instances_VectorInstances$$anon$1() {
}
export { $h_Lcats_instances_VectorInstances$$anon$1 as $h_Lcats_instances_VectorInstances$$anon$1 };
$h_Lcats_instances_VectorInstances$$anon$1.prototype = $c_Lcats_instances_VectorInstances$$anon$1.prototype;
$c_Lcats_instances_VectorInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return fa.map__F1__O(f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return this.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O(fa, f, evidence$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__sci_Vector((void 0));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.pure__O__sci_Vector = (function(x) {
  var this$1 = $m_sci_Vector$();
  var elems = $m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $ac_O([x]));
  return this$1.from__sc_IterableOnce__sci_Vector(elems);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__sci_Vector__sci_Vector__F2__sci_Vector = (function(fa, fb, f) {
  if ($f_sc_SeqOps__isEmpty__Z(fb)) {
    $m_sci_Vector$();
    return $m_sci_Vector0$();
  } else {
    $m_sci_Vector$();
    var b = new $c_sci_VectorBuilder();
    var it = fa.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var x0 = it.next__O();
      var elems = fb.map__F1__O(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((f, x0) => ((b$1) => f.apply__O__O__O(x0, b$1)))(f, x0)));
      b.addAll__sc_IterableOnce__sci_VectorBuilder(elems);
    }
    return b.result__sci_Vector();
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2Eval__sci_Vector__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return ($f_sc_SeqOps__isEmpty__Z(fa) ? this.Lcats_instances_VectorInstances$$anon$1__f_evalEmpty : fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((fb$2) => this.map2__sci_Vector__sci_Vector__F2__sci_Vector(fa, fb$2, f)))));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldRight__sci_Vector__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  $m_Lcats_Eval$();
  var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => $ps_Lcats_instances_VectorInstances__loop$2__sci_Vector__F2__Lcats_Eval__I__Lcats_Eval(fa, f, lb, 0)));
  return new $c_Lcats_Eval$$anon$5(a);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.tailRecM__O__F1__sci_Vector = (function(a, fn) {
  $m_sci_Vector$();
  var buf = new $c_sci_VectorBuilder();
  var elem = new $c_sci_$colon$colon(fn.apply__O__O(a).iterator__sc_Iterator(), $m_sci_Nil$());
  var elem$1 = null;
  elem$1 = elem;
  while (true) {
    var x11 = elem$1;
    var x = $m_sci_Nil$();
    if (x.equals__O__Z(x11)) {
      break;
    }
    if ((x11 instanceof $c_sci_$colon$colon)) {
      var x16 = x11.sci_$colon$colon__f_head;
      var x17 = x11.sci_$colon$colon__f_next;
      if ((!x16.hasNext__Z())) {
        elem$1 = x17;
        continue;
      }
      var x6 = x16.next__O();
      if ((x6 instanceof $c_s_util_Right)) {
        var b = x6.s_util_Right__f_value;
        buf.addOne__O__sci_VectorBuilder(b);
        continue;
      }
      if ((x6 instanceof $c_s_util_Left)) {
        var a$1 = x6.s_util_Left__f_value;
        var elem$1$1 = fn.apply__O__O(a$1).iterator__sc_Iterator();
        var this$3 = new $c_sci_$colon$colon(x16, x17);
        elem$1 = new $c_sci_$colon$colon(elem$1$1, this$3);
        continue;
      }
      throw new $c_s_MatchError(x6);
    }
    throw new $c_s_MatchError(x11);
  }
  return buf.result__sci_Vector();
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse__sci_Vector__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return ($is_Lcats_StackSafeMonad(G) ? G.map__O__F1__O($m_Lcats_Traverse$().traverseDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, G), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$3) => _$3.toVector__sci_Vector()))) : G.map__O__F1__O($m_Lcats_data_Chain$().traverseViaChain__sci_IndexedSeq__F1__Lcats_Applicative__O(fa, f, G), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$4) => _$4.toVector__sci_Vector()))));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverseVoid__sci_Vector__F1__Lcats_Applicative__O = (function(fa, f, G) {
  if ($is_Lcats_StackSafeMonad(G)) {
    return $m_Lcats_Traverse$().traverseVoidDirectly__sc_IterableOnce__F1__Lcats_StackSafeMonad__O(fa, f, G);
  } else {
    var len = fa.length__I();
    return ((len === 0) ? G.unit__O() : $s_Lcats_instances_VectorInstances__cats$instances$VectorInstances$$anon$1$$_$runHalf$1__Lcats_Applicative__sci_Vector__F1__I__I__Lcats_Eval(G, fa, f, len, 0).value__O());
  }
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldM__sci_Vector__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  var length = fa.length__I();
  return G.tailRecM__O__F1__O($ct_T2__O__O__(new $c_T2(), z, 0), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((x$1) => {
    if ((x$1 !== null)) {
      var b = x$1._1__O();
      var i = (x$1._2__O() | 0);
      return ((i < length) ? G.map__O__F1__O(f.apply__O__O__O(b, fa.apply__I__O(i)), new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((b$2) => {
        var _2 = ((1 + i) | 0);
        var value = $ct_T2__O__O__(new $c_T2(), b$2, _2);
        return new $c_s_util_Left(value);
      }))) : G.pure__O__O(new $c_s_util_Right(b)));
    }
    throw new $c_s_MatchError(x$1);
  })));
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.empty__O = (function() {
  $m_sci_Vector$();
  return $m_sci_Vector0$();
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  return x.appendedAll__sc_IterableOnce__sci_Vector(y);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return this.pure__O__sci_Vector(x);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return fa.map__F1__O(f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(fa, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return this.map2__sci_Vector__sci_Vector__F2__sci_Vector(fa, fb, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return this.map2Eval__sci_Vector__Lcats_Eval__F2__Lcats_Eval(fa, fb, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(fa, b, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return this.foldRight__sci_Vector__Lcats_Eval__F2__Lcats_Eval(fa, lb, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__sci_Vector(a, f);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.size__O__J = (function(fa) {
  var value = fa.length__I();
  var hi = (value >> 31);
  return new $c_RTLong(value, hi);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Vector__F1__Lcats_Applicative__O(fa, f, evidence$1);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return this.traverseVoid__sci_Vector__F1__Lcats_Applicative__O(fa, f, G);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.exists__O__F1__Z = (function(fa, p) {
  return $f_sc_IterableOnceOps__exists__F1__Z(fa, p);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return this.foldM__sci_Vector__O__F2__Lcats_Monad__O(fa, z, f, G);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(fa);
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return fa;
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return $m_Lcats_kernel_instances_VectorMonoid$().Lcats_kernel_instances_VectorMonoid$__f_singleton;
});
$c_Lcats_instances_VectorInstances$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_Alternative$$anon$1(evidence$1, this);
});
var $d_Lcats_instances_VectorInstances$$anon$1 = new $TypeData().initClass($c_Lcats_instances_VectorInstances$$anon$1, "cats.instances.VectorInstances$$anon$1", ({
  Lcats_instances_VectorInstances$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_MonoidK: 1,
  Lcats_Alternative: 1,
  Lcats_CoflatMap: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_instances_VectorInstances$$anon$1 as $d_Lcats_instances_VectorInstances$$anon$1 };
function $p_scm_HashSet__addElem__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (((-1) + $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length) | 0));
  var x1 = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u[idx];
  if ((x1 === null)) {
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u[idx] = new $c_scm_HashSet$Node(elem, hash, null);
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.scm_HashSet$Node__f__hash <= hash))) {
      if (((n.scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(elem, n.scm_HashSet$Node__f__key))) {
        return false;
      }
      prev = n;
      n = n.scm_HashSet$Node__f__next;
    }
    if ((prev === null)) {
      $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u[idx] = new $c_scm_HashSet$Node(elem, hash, x1);
    } else {
      prev.scm_HashSet$Node__f__next = new $c_scm_HashSet$Node(elem, hash, prev.scm_HashSet$Node__f__next);
    }
  }
  $thiz.scm_HashSet__f_contentSize = ((1 + $thiz.scm_HashSet__f_contentSize) | 0);
  return true;
}
export { $p_scm_HashSet__addElem__O__I__Z as $p_scm_HashSet__addElem__O__I__Z };
function $p_scm_HashSet__remove__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (((-1) + $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length) | 0));
  var x1 = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u[idx];
  if ((x1 !== null)) {
    if (((x1.scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(x1.scm_HashSet$Node__f__key, elem))) {
      $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u[idx] = x1.scm_HashSet$Node__f__next;
      $thiz.scm_HashSet__f_contentSize = (((-1) + $thiz.scm_HashSet__f_contentSize) | 0);
      return true;
    } else {
      var prev = x1;
      var next = x1.scm_HashSet$Node__f__next;
      while (((next !== null) && (next.scm_HashSet$Node__f__hash <= hash))) {
        if (((next.scm_HashSet$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(next.scm_HashSet$Node__f__key, elem))) {
          prev.scm_HashSet$Node__f__next = next.scm_HashSet$Node__f__next;
          $thiz.scm_HashSet__f_contentSize = (((-1) + $thiz.scm_HashSet__f_contentSize) | 0);
          return true;
        }
        prev = next;
        next = next.scm_HashSet$Node__f__next;
      }
      return false;
    }
  } else {
    return false;
  }
}
export { $p_scm_HashSet__remove__O__I__Z as $p_scm_HashSet__remove__O__I__Z };
function $p_scm_HashSet__growTable__I__V($thiz, newlen) {
  var oldlen = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length;
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashSet__f_contentSize === 0)) {
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)(newlen);
  } else {
    var original = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table;
    $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = $m_ju_Arrays$().copyOf__AO__I__AO(original, newlen);
    var preLow = new $c_scm_HashSet$Node(null, 0, null);
    var preHigh = new $c_scm_HashSet$Node(null, 0, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u[i];
        if ((old !== null)) {
          preLow.scm_HashSet$Node__f__next = null;
          preHigh.scm_HashSet$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.scm_HashSet$Node__f__next;
            if (((n.scm_HashSet$Node__f__hash & oldlen) === 0)) {
              lastLow.scm_HashSet$Node__f__next = n;
              lastLow = n;
            } else {
              lastHigh.scm_HashSet$Node__f__next = n;
              lastHigh = n;
            }
            n = next;
          }
          lastLow.scm_HashSet$Node__f__next = null;
          if ((old !== preLow.scm_HashSet$Node__f__next)) {
            $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u[i] = preLow.scm_HashSet$Node__f__next;
          }
          if ((preHigh.scm_HashSet$Node__f__next !== null)) {
            $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u[((i + oldlen) | 0)] = preHigh.scm_HashSet$Node__f__next;
            lastHigh.scm_HashSet$Node__f__next = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
export { $p_scm_HashSet__growTable__I__V as $p_scm_HashSet__growTable__I__V };
function $p_scm_HashSet__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
export { $p_scm_HashSet__tableSizeFor__I__I as $p_scm_HashSet__tableSizeFor__I__I };
function $p_scm_HashSet__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashSet__f_loadFactor));
}
export { $p_scm_HashSet__newThreshold__I__I as $p_scm_HashSet__newThreshold__I__I };
function $ct_scm_HashSet__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashSet__f_loadFactor = loadFactor;
  $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table = new ($d_scm_HashSet$Node.getArrayOf().constr)($p_scm_HashSet__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashSet__f_threshold = $p_scm_HashSet__newThreshold__I__I($thiz, $thiz.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length);
  $thiz.scm_HashSet__f_contentSize = 0;
  return $thiz;
}
export { $ct_scm_HashSet__I__D__ as $ct_scm_HashSet__I__D__ };
function $ct_scm_HashSet__($thiz) {
  $ct_scm_HashSet__I__D__($thiz, 16, 0.75);
  return $thiz;
}
export { $ct_scm_HashSet__ as $ct_scm_HashSet__ };
/** @constructor */
function $c_scm_HashSet() {
  this.scm_HashSet__f_loadFactor = 0.0;
  this.scm_HashSet__f_scala$collection$mutable$HashSet$$table = null;
  this.scm_HashSet__f_threshold = 0;
  this.scm_HashSet__f_contentSize = 0;
}
export { $c_scm_HashSet as $c_scm_HashSet };
$c_scm_HashSet.prototype = new $h_scm_AbstractSet();
$c_scm_HashSet.prototype.constructor = $c_scm_HashSet;
/** @constructor */
function $h_scm_HashSet() {
}
export { $h_scm_HashSet as $h_scm_HashSet };
$h_scm_HashSet.prototype = $c_scm_HashSet.prototype;
$c_scm_HashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_HashSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_HashSet.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_HashSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_HashSet.prototype.size__I = (function() {
  return this.scm_HashSet__f_contentSize;
});
$c_scm_HashSet.prototype.scala$collection$mutable$HashSet$$improveHash__I__I = (function(originalHash) {
  return (originalHash ^ ((originalHash >>> 16) | 0));
});
$c_scm_HashSet.prototype.contains__O__Z = (function(elem) {
  var hash = this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem));
  var x1 = this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u[(hash & (((-1) + this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length) | 0))];
  return (((x1 === null) ? null : x1.findNode__O__I__scm_HashSet$Node(elem, hash)) !== null);
});
$c_scm_HashSet.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashSet__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashSet__f_loadFactor)));
  if ((target > this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length)) {
    $p_scm_HashSet__growTable__I__V(this, target);
  }
});
$c_scm_HashSet.prototype.add__O__Z = (function(elem) {
  if ((((1 + this.scm_HashSet__f_contentSize) | 0) >= this.scm_HashSet__f_threshold)) {
    $p_scm_HashSet__growTable__I__V(this, (this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length << 1));
  }
  return $p_scm_HashSet__addElem__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)));
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_HashSet = (function(xs) {
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this, xs, 0);
  if ((xs instanceof $c_sci_HashSet)) {
    var f = new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((k$2$2, h$2$2) => {
      var h$2 = (h$2$2 | 0);
      $p_scm_HashSet__addElem__O__I__Z(this, k$2$2, this.scala$collection$mutable$HashSet$$improveHash__I__I(h$2));
    }));
    xs.sci_HashSet__f_rootNode.foreachWithHash__F2__V(f);
    return this;
  } else if ((xs instanceof $c_scm_HashSet)) {
    var iter = new $c_scm_HashSet$$anon$2(xs);
    while (iter.hasNext__Z()) {
      var next = iter.next__O();
      $p_scm_HashSet__addElem__O__I__Z(this, next.scm_HashSet$Node__f__key, next.scm_HashSet$Node__f__hash);
    }
    return this;
  } else if ((xs instanceof $c_scm_LinkedHashSet)) {
    var iter$2 = new $c_scm_LinkedHashSet$$anon$2(xs);
    while (iter$2.hasNext__Z()) {
      var next$2 = iter$2.next__O();
      $p_scm_HashSet__addElem__O__I__Z(this, next$2.scm_LinkedHashSet$Entry__f_key, next$2.scm_LinkedHashSet$Entry__f_hash);
    }
    return this;
  } else {
    return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs);
  }
});
$c_scm_HashSet.prototype.remove__O__Z = (function(elem) {
  return $p_scm_HashSet__remove__O__I__Z(this, elem, this.scala$collection$mutable$HashSet$$improveHash__I__I($m_sr_Statics$().anyHash__O__I(elem)));
});
$c_scm_HashSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_HashSet$$anon$1(this);
});
$c_scm_HashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_HashSet$();
});
$c_scm_HashSet.prototype.knownSize__I = (function() {
  return this.scm_HashSet__f_contentSize;
});
$c_scm_HashSet.prototype.isEmpty__Z = (function() {
  return (this.scm_HashSet__f_contentSize === 0);
});
$c_scm_HashSet.prototype.foreach__F1__V = (function(f) {
  var len = this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u.length;
  var i = 0;
  while ((i < len)) {
    var n = this.scm_HashSet__f_scala$collection$mutable$HashSet$$table.u[i];
    if ((n !== null)) {
      n.foreach__F1__V(f);
    }
    i = ((1 + i) | 0);
  }
});
$c_scm_HashSet.prototype.className__T = (function() {
  return "HashSet";
});
$c_scm_HashSet.prototype.hashCode__I = (function() {
  var setIterator = new $c_scm_HashSet$$anon$1(this);
  var hashIterator = ((!setIterator.hasNext__Z()) ? setIterator : new $c_scm_HashSet$$anon$3(this));
  return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(hashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed);
});
$c_scm_HashSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  this.remove__O__Z(elem);
  return this;
});
$c_scm_HashSet.prototype.addOne__O__scm_Growable = (function(elem) {
  this.add__O__Z(elem);
  return this;
});
$c_scm_HashSet.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_HashSet(elems);
});
function $isArrayOf_scm_HashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashSet)));
}
export { $isArrayOf_scm_HashSet as $isArrayOf_scm_HashSet };
var $d_scm_HashSet = new $TypeData().initClass($c_scm_HashSet, "scala.collection.mutable.HashSet", ({
  scm_HashSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_HashSet as $d_scm_HashSet };
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$JSetWrapper(underlying) {
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying = null;
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying = underlying;
}
export { $c_sc_convert_JavaCollectionWrappers$JSetWrapper as $c_sc_convert_JavaCollectionWrappers$JSetWrapper };
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype = new $h_scm_AbstractSet();
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.constructor = $c_sc_convert_JavaCollectionWrappers$JSetWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$JSetWrapper() {
}
export { $h_sc_convert_JavaCollectionWrappers$JSetWrapper as $h_sc_convert_JavaCollectionWrappers$JSetWrapper };
$h_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype = $c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype;
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.concat__sc_IterableOnce__sc_SetOps = (function(that) {
  var b = new $c_scm_HashSet$$anon$4(16, 0.75);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(this);
  b.addAll__sc_IterableOnce__scm_GrowableBuilder(that);
  return b.scm_GrowableBuilder__f_elems;
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.size__I = (function() {
  return this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.size__I();
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.isEmpty__Z = (function() {
  return this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.isEmpty__Z();
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.knownSize__I = (function() {
  return (this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.isEmpty__Z() ? 0 : (-1));
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.iterator__sc_Iterator = (function() {
  var this$1 = $m_s_jdk_CollectionConverters$();
  var i = this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.iterator__ju_Iterator();
  return new $c_sc_convert_AsScalaExtensions$IteratorHasAsScala(this$1, i).asScala__sc_Iterator();
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.contains__O__Z = (function(elem) {
  return this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.contains__O__Z(elem);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.addOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper = (function(elem) {
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.add__O__Z(elem);
  return this;
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.subtractOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper = (function(elem) {
  this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.remove__O__Z(elem);
  return this;
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.remove__O__Z = (function(elem) {
  return this.sc_convert_JavaCollectionWrappers$JSetWrapper__f_underlying.remove__O__Z(elem);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_HashSet$();
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper(elem);
});
$c_sc_convert_JavaCollectionWrappers$JSetWrapper.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__sc_convert_JavaCollectionWrappers$JSetWrapper(elem);
});
function $isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sc_convert_JavaCollectionWrappers$JSetWrapper)));
}
export { $isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper as $isArrayOf_sc_convert_JavaCollectionWrappers$JSetWrapper };
var $d_sc_convert_JavaCollectionWrappers$JSetWrapper = new $TypeData().initClass($c_sc_convert_JavaCollectionWrappers$JSetWrapper, "scala.collection.convert.JavaCollectionWrappers$JSetWrapper", ({
  sc_convert_JavaCollectionWrappers$JSetWrapper: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSetOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sc_convert_JavaCollectionWrappers$JSetWrapper as $d_sc_convert_JavaCollectionWrappers$JSetWrapper };
/** @constructor */
function $c_sci_ListMap() {
}
export { $c_sci_ListMap as $c_sci_ListMap };
$c_sci_ListMap.prototype = new $h_sci_AbstractMap();
$c_sci_ListMap.prototype.constructor = $c_sci_ListMap;
/** @constructor */
function $h_sci_ListMap() {
}
export { $h_sci_ListMap as $h_sci_ListMap };
$h_sci_ListMap.prototype = $c_sci_ListMap.prototype;
$c_sci_ListMap.prototype.map__F1__sc_IterableOps = (function(f) {
  return $f_sc_StrictOptimizedMapOps__map__F1__sc_IterableOps(this, f);
});
$c_sci_ListMap.prototype.collect__s_PartialFunction__sc_IterableOps = (function(pf) {
  return $f_sc_StrictOptimizedMapOps__collect__s_PartialFunction__sc_IterableOps(this, pf);
});
$c_sci_ListMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_ListMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_ListMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_sci_ListMap.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_ListMap.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_ListMap.prototype.stringPrefix__T = (function() {
  return "SeqMap";
});
$c_sci_ListMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_sci_ListMap$();
});
$c_sci_ListMap.prototype.size__I = (function() {
  return 0;
});
$c_sci_ListMap.prototype.isEmpty__Z = (function() {
  return true;
});
$c_sci_ListMap.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_ListMap.prototype.get__O__s_Option = (function(key) {
  return $m_s_None$();
});
$c_sci_ListMap.prototype.updated__O__O__sci_ListMap = (function(key, value) {
  return new $c_sci_ListMap$Node(key, value, this);
});
$c_sci_ListMap.prototype.removed__O__sci_ListMap = (function(key) {
  return this;
});
$c_sci_ListMap.prototype.iterator__sc_Iterator = (function() {
  var curr = this;
  var res = $m_sci_Nil$();
  while (true) {
    var this$1 = curr;
    if ((!this$1.isEmpty__Z())) {
      var rassoc$1 = $ct_T2__O__O__(new $c_T2(), curr.key__O(), curr.value__O());
      var this$2 = res;
      res = new $c_sci_$colon$colon(rassoc$1, this$2);
      curr = curr.next__sci_ListMap();
    } else {
      break;
    }
  }
  return res.iterator__sc_Iterator();
});
$c_sci_ListMap.prototype.keys__sci_Iterable = (function() {
  var curr = this;
  var res = $m_sci_Nil$();
  while (true) {
    var this$1 = curr;
    if ((!this$1.isEmpty__Z())) {
      var rassoc$2 = curr.key__O();
      var this$2 = res;
      res = new $c_sci_$colon$colon(rassoc$2, this$2);
      curr = curr.next__sci_ListMap();
    } else {
      break;
    }
  }
  return res;
});
$c_sci_ListMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash;
  } else {
    var _reversed = new $c_sci_ListMap$$anon$1(this);
    return $m_s_util_hashing_MurmurHash3$().mapHash__sc_Map__I(_reversed);
  }
});
$c_sci_ListMap.prototype.key__O = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "key of empty map");
});
$c_sci_ListMap.prototype.value__O = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "value of empty map");
});
$c_sci_ListMap.prototype.next__sci_ListMap = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "next of empty map");
});
$c_sci_ListMap.prototype.className__T = (function() {
  return "ListMap";
});
$c_sci_ListMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sci_StrictOptimizedMapOps__concat__sc_IterableOnce__sci_MapOps(this, suffix);
});
$c_sci_ListMap.prototype.keys__sc_Iterable = (function() {
  return this.keys__sci_Iterable();
});
$c_sci_ListMap.prototype.removed__O__sci_MapOps = (function(key) {
  return this.removed__O__sci_ListMap(key);
});
$c_sci_ListMap.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_ListMap(key, value);
});
function $isArrayOf_sci_ListMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ListMap)));
}
export { $isArrayOf_sci_ListMap as $isArrayOf_sci_ListMap };
function $p_sci_NumericRange__length$lzycompute__I($thiz) {
  if (((((1 & $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.sci_NumericRange__f_length = $m_sci_NumericRange$().count__O__O__O__Z__s_math_Integral__I($thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step, $thiz.sci_NumericRange__f_isInclusive, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    $thiz.sci_NumericRange__f_bitmap$0 = (((1 | $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.sci_NumericRange__f_length;
}
export { $p_sci_NumericRange__length$lzycompute__I as $p_sci_NumericRange__length$lzycompute__I };
function $p_sci_NumericRange__isEmpty$lzycompute__Z($thiz) {
  if (((((2 & $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0)) {
    if ($f_s_math_Ordering__gt__O__O__Z($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num, $thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_end)) {
      var $x_4 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var $x_3 = $thiz.sci_NumericRange__f_step;
      var this$1 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var $x_2 = $f_s_math_Ordering__gt__O__O__Z($x_4, $x_3, this$1.fromInt__I__O(0));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var $x_1 = true;
    } else if ($f_s_math_Ordering__lt__O__O__Z($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num, $thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_end)) {
      var $x_6 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var $x_5 = $thiz.sci_NumericRange__f_step;
      var this$2 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var $x_1 = $f_s_math_Ordering__lt__O__O__Z($x_6, $x_5, this$2.fromInt__I__O(0));
    } else {
      var $x_1 = false;
    }
    $thiz.sci_NumericRange__f_isEmpty = ($x_1 || ($f_s_math_Ordering__equiv__O__O__Z($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num, $thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_end) && (!$thiz.sci_NumericRange__f_isInclusive)));
    $thiz.sci_NumericRange__f_bitmap$0 = (((2 | $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.sci_NumericRange__f_isEmpty;
}
export { $p_sci_NumericRange__isEmpty$lzycompute__Z as $p_sci_NumericRange__isEmpty$lzycompute__Z };
function $p_sci_NumericRange__locationAfterN__I__O($thiz, n) {
  var this$1 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
  var lhs = $thiz.sci_NumericRange__f_start;
  var $x_1 = new $c_s_math_Integral$IntegralOps(this$1, lhs);
  var this$2 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
  var lhs$1 = $thiz.sci_NumericRange__f_step;
  return $x_1.$plus__O__O(new $c_s_math_Integral$IntegralOps(this$2, lhs$1).$times__O__O($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.fromInt__I__O(n)));
}
export { $p_sci_NumericRange__locationAfterN__I__O as $p_sci_NumericRange__locationAfterN__I__O };
function $p_sci_NumericRange__crossesTheEndAfterN__I__Z($thiz, n) {
  if ($f_s_math_Ordering__gt__O__O__Z($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_start)) {
    var $x_3 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var $x_2 = $thiz.sci_NumericRange__f_step;
    var this$1 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var $x_1 = $f_s_math_Ordering__gt__O__O__Z($x_3, $x_2, this$1.fromInt__I__O(0));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var stepIsInTheSameDirectionAsStartToEndVector = true;
  } else if ($f_s_math_Ordering__lt__O__O__Z($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_start)) {
    var $x_5 = $m_sr_BoxesRunTime$();
    var $x_4 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.sign__O__O($thiz.sci_NumericRange__f_step);
    var this$3 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var this$2 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var lhs = this$2.fromInt__I__O(1);
    var stepIsInTheSameDirectionAsStartToEndVector = $x_5.equals__O__O__Z($x_4, new $c_s_math_Integral$IntegralOps(this$3, lhs).unary_$minus__O());
  } else {
    var stepIsInTheSameDirectionAsStartToEndVector = false;
  }
  if ((($f_s_math_Ordering__equiv__O__O__Z($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num, $thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_end) || (n <= 0)) || (!stepIsInTheSameDirectionAsStartToEndVector))) {
    return (n >= 1);
  }
  var sameSign = $f_s_math_Ordering__equiv__O__O__Z($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.sign__O__O($thiz.sci_NumericRange__f_start), $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.sign__O__O($thiz.sci_NumericRange__f_end));
  if (sameSign) {
    var len = $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, $thiz);
    return ($p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, len) ? (n >= $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.toInt__O__I(len)) : $f_s_math_Ordering__gteq__O__O__Z($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.fromInt__I__O(n), len));
  } else {
    var stepsRemainderToZero = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.rem__O__O__O($thiz.sci_NumericRange__f_start, $thiz.sci_NumericRange__f_step);
    var $x_6 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var this$4 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var walksOnZero = $f_s_math_Ordering__equiv__O__O__Z($x_6, stepsRemainderToZero, this$4.fromInt__I__O(0));
    if (walksOnZero) {
      var this$5 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var lhs$1 = $thiz.sci_NumericRange__f_step;
      var closestToZero = new $c_s_math_Integral$IntegralOps(this$5, lhs$1).unary_$minus__O();
    } else {
      var closestToZero = stepsRemainderToZero;
    }
    var $x_8 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var $x_7 = $thiz.sci_NumericRange__f_start;
    var this$6 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    if ($f_s_math_Ordering__lt__O__O__Z($x_8, $x_7, this$6.fromInt__I__O(0))) {
      if (walksOnZero) {
        var twoStepsAfterLargestNegativeNumber = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.plus__O__O__O(closestToZero, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.times__O__O__O($thiz.sci_NumericRange__f_step, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.fromInt__I__O(2)));
        $m_sci_NumericRange$();
        var start = $thiz.sci_NumericRange__f_start;
        var step = $thiz.sci_NumericRange__f_step;
        var num = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
        var x1 = new $c_T3(new $c_sci_NumericRange$Exclusive(start, closestToZero, step, num), $thiz.copy__O__O__O__sci_NumericRange(twoStepsAfterLargestNegativeNumber, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step), 2);
      } else {
        $m_sci_NumericRange$();
        var start$1 = $thiz.sci_NumericRange__f_start;
        var step$1 = $thiz.sci_NumericRange__f_step;
        var num$1 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
        var x1 = new $c_T3(new $c_sci_NumericRange$Exclusive(start$1, closestToZero, step$1, num$1), $thiz.copy__O__O__O__sci_NumericRange($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.plus__O__O__O(closestToZero, $thiz.sci_NumericRange__f_step), $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step), 1);
      }
    } else if (walksOnZero) {
      var twoStepsAfterZero = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.times__O__O__O($thiz.sci_NumericRange__f_step, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.fromInt__I__O(2));
      var $x_9 = $thiz.copy__O__O__O__sci_NumericRange(twoStepsAfterZero, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step);
      $m_sci_NumericRange$();
      var start$2 = $thiz.sci_NumericRange__f_start;
      var this$9 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var lhs$2 = $thiz.sci_NumericRange__f_step;
      var end = new $c_s_math_Integral$IntegralOps(this$9, lhs$2).unary_$minus__O();
      var step$2 = $thiz.sci_NumericRange__f_step;
      var num$2 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var x1 = new $c_T3($x_9, new $c_sci_NumericRange$Inclusive(start$2, end, step$2, num$2), 2);
    } else {
      var twoStepsAfterSmallestPositiveNumber = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.plus__O__O__O(closestToZero, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.times__O__O__O($thiz.sci_NumericRange__f_step, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.fromInt__I__O(2)));
      var $x_10 = $thiz.copy__O__O__O__sci_NumericRange(twoStepsAfterSmallestPositiveNumber, $thiz.sci_NumericRange__f_end, $thiz.sci_NumericRange__f_step);
      $m_sci_NumericRange$();
      var start$3 = $thiz.sci_NumericRange__f_start;
      var step$3 = $thiz.sci_NumericRange__f_step;
      var num$3 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
      var x1 = new $c_T3($x_10, new $c_sci_NumericRange$Inclusive(start$3, closestToZero, step$3, num$3), 2);
    }
    matchEnd6: {
      var x$1___1;
      var x$1___2;
      var x$1___3;
      var l = x1.T3__f__1;
      var r = x1.T3__f__2;
      var carry = (x1.T3__f__3 | 0);
      if ((l !== null)) {
        if ((r !== null)) {
          var x$1___1 = l;
          var x$1___2 = r;
          var x$1___3 = carry;
          break matchEnd6;
        }
      }
      throw new $c_s_MatchError(x1);
    }
    var l$2 = x$1___1;
    var r$2 = x$1___2;
    var carry$2 = (x$1___3 | 0);
    var leftLength = $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, l$2);
    var rightLength = $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, r$2);
    return (($p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, leftLength) && $p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, rightLength)) ? (((((n - $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.toInt__O__I(leftLength)) | 0) - carry$2) | 0) >= $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.toInt__O__I(rightLength)) : $f_s_math_Ordering__gteq__O__O__Z($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.minus__O__O__O($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.minus__O__O__O($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.fromInt__I__O(n), leftLength), $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.fromInt__I__O(carry$2)), rightLength));
  }
}
export { $p_sci_NumericRange__crossesTheEndAfterN__I__Z as $p_sci_NumericRange__crossesTheEndAfterN__I__Z };
function $p_sci_NumericRange__newEmptyRange__O__sci_NumericRange$Exclusive($thiz, value) {
  $m_sci_NumericRange$();
  var step = $thiz.sci_NumericRange__f_step;
  var num = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
  return new $c_sci_NumericRange$Exclusive(value, value, step, num);
}
export { $p_sci_NumericRange__newEmptyRange__O__sci_NumericRange$Exclusive as $p_sci_NumericRange__newEmptyRange__O__sci_NumericRange$Exclusive };
function $p_sci_NumericRange__hashCode$lzycompute__I($thiz) {
  if (((((4 & $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0)) {
    $thiz.sci_NumericRange__f_hashCode = $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I($thiz);
    $thiz.sci_NumericRange__f_bitmap$0 = (((4 | $thiz.sci_NumericRange__f_bitmap$0) << 24) >> 24);
  }
  return $thiz.sci_NumericRange__f_hashCode;
}
export { $p_sci_NumericRange__hashCode$lzycompute__I as $p_sci_NumericRange__hashCode$lzycompute__I };
function $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O($thiz, r) {
  var diff = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.minus__O__O__O(r.sci_NumericRange__f_end, r.sci_NumericRange__f_start);
  var quotient = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.quot__O__O__O(diff, r.sci_NumericRange__f_step);
  var remainder = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.rem__O__O__O(diff, r.sci_NumericRange__f_step);
  if ((!r.sci_NumericRange__f_isInclusive)) {
    var $x_2 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var this$1 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var $x_1 = $f_s_math_Ordering__equiv__O__O__Z($x_2, remainder, this$1.fromInt__I__O(0));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    var $x_3 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var this$2 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    return $f_s_math_Ordering__max__O__O__O($x_3, quotient, this$2.fromInt__I__O(0));
  } else {
    var $x_6 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var $x_5 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var this$3 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var $x_4 = $x_5.plus__O__O__O(quotient, this$3.fromInt__I__O(1));
    var this$4 = $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    return $f_s_math_Ordering__max__O__O__O($x_6, $x_4, this$4.fromInt__I__O(0));
  }
}
export { $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O as $p_sci_NumericRange__unsafeRangeLength$1__sci_NumericRange__O };
function $p_sci_NumericRange__fitsInInteger$1__O__Z($thiz, value) {
  return $f_s_math_Ordering__equiv__O__O__Z($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num, $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.fromInt__I__O($thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.toInt__O__I(value)), value);
}
export { $p_sci_NumericRange__fitsInInteger$1__O__Z as $p_sci_NumericRange__fitsInInteger$1__O__Z };
function $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__($thiz, start, end, step, isInclusive, num) {
  $thiz.sci_NumericRange__f_start = start;
  $thiz.sci_NumericRange__f_end = end;
  $thiz.sci_NumericRange__f_step = step;
  $thiz.sci_NumericRange__f_isInclusive = isInclusive;
  $thiz.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = num;
  return $thiz;
}
export { $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__ as $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__ };
/** @constructor */
function $c_sci_NumericRange() {
  this.sci_NumericRange__f_length = 0;
  this.sci_NumericRange__f_isEmpty = false;
  this.sci_NumericRange__f_hashCode = 0;
  this.sci_NumericRange__f_start = null;
  this.sci_NumericRange__f_end = null;
  this.sci_NumericRange__f_step = null;
  this.sci_NumericRange__f_isInclusive = false;
  this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = null;
  this.sci_NumericRange__f_bitmap$0 = 0;
}
export { $c_sci_NumericRange as $c_sci_NumericRange };
$c_sci_NumericRange.prototype = new $h_sci_AbstractSeq();
$c_sci_NumericRange.prototype.constructor = $c_sci_NumericRange;
/** @constructor */
function $h_sci_NumericRange() {
}
export { $h_sci_NumericRange as $h_sci_NumericRange };
$h_sci_NumericRange.prototype = $c_sci_NumericRange.prototype;
$c_sci_NumericRange.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sci_NumericRange.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sci_StrictOptimizedSeqOps__updated__I__O__O(this, index, elem);
});
$c_sci_NumericRange.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_NumericRange.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$c_sci_NumericRange.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_sci_NumericRange.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_sci_NumericRange.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that);
});
$c_sci_NumericRange.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_NumericRange.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_NumericRange.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_NumericRange.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sci_NumericRange.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_NumericRange.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sci_NumericRange.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_NumericRange.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_NumericRange.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_NumericRange.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sci_NumericRange.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_sci_NumericRange.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_NumericRange.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_NumericRange.prototype.foldRight__O__F2__O = (function(z, op) {
  return $p_sc_IndexedSeqOps__foldr__I__I__O__F2__O(this, 0, this.length__I(), z, op);
});
$c_sci_NumericRange.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sci_NumericRange.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sci_NumericRange.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_NumericRange.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sci_NumericRange.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_NumericRange$NumericRangeIterator(this, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
});
$c_sci_NumericRange.prototype.length__I = (function() {
  return (((((1 & this.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0) ? $p_sci_NumericRange__length$lzycompute__I(this) : this.sci_NumericRange__f_length);
});
$c_sci_NumericRange.prototype.isEmpty__Z = (function() {
  return (((((2 & this.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0) ? $p_sci_NumericRange__isEmpty$lzycompute__Z(this) : this.sci_NumericRange__f_isEmpty);
});
$c_sci_NumericRange.prototype.last__O = (function() {
  return (this.isEmpty__Z() ? $m_sci_Nil$().head__E() : $p_sci_NumericRange__locationAfterN__I__O(this, (((-1) + this.length__I()) | 0)));
});
$c_sci_NumericRange.prototype.init__sci_NumericRange = (function() {
  if (this.isEmpty__Z()) {
    $m_sci_Nil$().init__E();
  } else {
    var $x_1 = this.sci_NumericRange__f_start;
    var this$1 = this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var lhs = this.sci_NumericRange__f_end;
    return $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(new $c_sci_NumericRange(), $x_1, new $c_s_math_Integral$IntegralOps(this$1, lhs).$minus__O__O(this.sci_NumericRange__f_step), this.sci_NumericRange__f_step, this.sci_NumericRange__f_isInclusive, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  }
});
$c_sci_NumericRange.prototype.head__O = (function() {
  return (this.isEmpty__Z() ? $m_sci_Nil$().head__E() : this.sci_NumericRange__f_start);
});
$c_sci_NumericRange.prototype.tail__sci_NumericRange = (function() {
  if (this.isEmpty__Z()) {
    $m_sci_Nil$().tail__E();
  } else if (this.sci_NumericRange__f_isInclusive) {
    var this$1 = this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var lhs = this.sci_NumericRange__f_start;
    return new $c_sci_NumericRange$Inclusive(new $c_s_math_Integral$IntegralOps(this$1, lhs).$plus__O__O(this.sci_NumericRange__f_step), this.sci_NumericRange__f_end, this.sci_NumericRange__f_step, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  } else {
    var this$2 = this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var lhs$1 = this.sci_NumericRange__f_start;
    return new $c_sci_NumericRange$Exclusive(new $c_s_math_Integral$IntegralOps(this$2, lhs$1).$plus__O__O(this.sci_NumericRange__f_step), this.sci_NumericRange__f_end, this.sci_NumericRange__f_step, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
  }
});
$c_sci_NumericRange.prototype.copy__O__O__O__sci_NumericRange = (function(start, end, step) {
  return $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(new $c_sci_NumericRange(), start, end, step, this.sci_NumericRange__f_isInclusive, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
});
$c_sci_NumericRange.prototype.apply__I__O = (function(idx) {
  if (((idx < 0) || (idx >= this.length__I()))) {
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + (((-1) + this.length__I()) | 0)) + ")"));
  } else {
    return $p_sci_NumericRange__locationAfterN__I__O(this, idx);
  }
});
$c_sci_NumericRange.prototype.foreach__F1__V = (function(f) {
  var count = 0;
  var current = this.sci_NumericRange__f_start;
  while ((count < this.length__I())) {
    f.apply__O__O(current);
    var this$1 = this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var lhs = current;
    current = new $c_s_math_Integral$IntegralOps(this$1, lhs).$plus__O__O(this.sci_NumericRange__f_step);
    count = ((1 + count) | 0);
  }
});
$c_sci_NumericRange.prototype.take__I__sci_NumericRange = (function(n) {
  return (((n <= 0) || this.isEmpty__Z()) ? $p_sci_NumericRange__newEmptyRange__O__sci_NumericRange$Exclusive(this, this.sci_NumericRange__f_start) : ($p_sci_NumericRange__crossesTheEndAfterN__I__Z(this, n) ? this : new $c_sci_NumericRange$Inclusive(this.sci_NumericRange__f_start, $p_sci_NumericRange__locationAfterN__I__O(this, (((-1) + n) | 0)), this.sci_NumericRange__f_step, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num)));
});
$c_sci_NumericRange.prototype.drop__I__sci_NumericRange = (function(n) {
  return (((n <= 0) || this.isEmpty__Z()) ? this : ($p_sci_NumericRange__crossesTheEndAfterN__I__Z(this, n) ? $p_sci_NumericRange__newEmptyRange__O__sci_NumericRange$Exclusive(this, this.sci_NumericRange__f_end) : this.copy__O__O__O__sci_NumericRange($p_sci_NumericRange__locationAfterN__I__O(this, n), this.sci_NumericRange__f_end, this.sci_NumericRange__f_step)));
});
$c_sci_NumericRange.prototype.reverse__sci_NumericRange = (function() {
  if (this.isEmpty__Z()) {
    return this;
  } else {
    var this$1 = this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var lhs = this.sci_NumericRange__f_step;
    var newStep = new $c_s_math_Integral$IntegralOps(this$1, lhs).unary_$minus__O();
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.sign__O__O(newStep), this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.sign__O__O(this.sci_NumericRange__f_step))) {
      throw new $c_jl_ArithmeticException("number type is unsigned, and .reverse requires a negative step");
    } else {
      return new $c_sci_NumericRange$Inclusive(this.last__O(), this.sci_NumericRange__f_start, newStep, this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    }
  }
});
$c_sci_NumericRange.prototype.min__s_math_Ordering__O = (function(ord) {
  if ((ord === this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num)) {
    var $x_1 = true;
  } else {
    var this$1 = $m_sci_NumericRange$().sci_NumericRange$__f_defaultOrdering.get__O__s_Option(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    if ((!this$1.isEmpty__Z())) {
      var x0 = this$1.get__O();
      var $x_1 = (ord === x0);
    } else {
      var $x_1 = false;
    }
  }
  if ($x_1) {
    var this$2 = this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var lhs = this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.sign__O__O(this.sci_NumericRange__f_step);
    var $x_2 = new $c_s_math_Ordering$OrderingOps(this$2, lhs);
    var this$3 = this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    if ($x_2.$greater__O__Z(this$3.fromInt__I__O(0))) {
      return this.head__O();
    } else {
      return this.last__O();
    }
  } else {
    return $f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord);
  }
});
$c_sci_NumericRange.prototype.max__s_math_Ordering__O = (function(ord) {
  if ((ord === this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num)) {
    var $x_1 = true;
  } else {
    var this$1 = $m_sci_NumericRange$().sci_NumericRange$__f_defaultOrdering.get__O__s_Option(this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num);
    if ((!this$1.isEmpty__Z())) {
      var x0 = this$1.get__O();
      var $x_1 = (ord === x0);
    } else {
      var $x_1 = false;
    }
  }
  if ($x_1) {
    var this$2 = this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    var lhs = this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num.sign__O__O(this.sci_NumericRange__f_step);
    var $x_2 = new $c_s_math_Ordering$OrderingOps(this$2, lhs);
    var this$3 = this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num;
    if ($x_2.$greater__O__Z(this$3.fromInt__I__O(0))) {
      return this.last__O();
    } else {
      return this.head__O();
    }
  } else {
    return $f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord);
  }
});
$c_sci_NumericRange.prototype.hashCode__I = (function() {
  return (((((4 & this.sci_NumericRange__f_bitmap$0) << 24) >> 24) === 0) ? $p_sci_NumericRange__hashCode$lzycompute__I(this) : this.sci_NumericRange__f_hashCode);
});
$c_sci_NumericRange.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647;
});
$c_sci_NumericRange.prototype.equals__O__Z = (function(other) {
  return ((other instanceof $c_sci_NumericRange) ? (($f_sci_IndexedSeq__canEqual__O__Z(other, this) && (this.length__I() === other.length__I())) && (this.isEmpty__Z() || ($m_sr_BoxesRunTime$().equals__O__O__Z(this.sci_NumericRange__f_start, other.sci_NumericRange__f_start) && $m_sr_BoxesRunTime$().equals__O__O__Z(this.last__O(), other.last__O())))) : $f_sc_Seq__equals__O__Z(this, other));
});
$c_sci_NumericRange.prototype.toString__T = (function() {
  var empty = (this.isEmpty__Z() ? "empty " : "");
  var preposition = (this.sci_NumericRange__f_isInclusive ? "to" : "until");
  var stepped = ($m_sr_BoxesRunTime$().equals__O__O__Z(this.sci_NumericRange__f_step, 1) ? "" : (" by " + this.sci_NumericRange__f_step));
  return (((((((empty + "NumericRange ") + this.sci_NumericRange__f_start) + " ") + preposition) + " ") + this.sci_NumericRange__f_end) + stepped);
});
$c_sci_NumericRange.prototype.className__T = (function() {
  return "NumericRange";
});
$c_sci_NumericRange.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$c_sci_NumericRange.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_sci_NumericRange.prototype.reverse__O = (function() {
  return this.reverse__sci_NumericRange();
});
$c_sci_NumericRange.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_NumericRange(n);
});
$c_sci_NumericRange.prototype.take__I__O = (function(n) {
  return this.take__I__sci_NumericRange(n);
});
$c_sci_NumericRange.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O((v1 | 0));
});
$c_sci_NumericRange.prototype.tail__O = (function() {
  return this.tail__sci_NumericRange();
});
$c_sci_NumericRange.prototype.init__O = (function() {
  return this.init__sci_NumericRange();
});
function $isArrayOf_sci_NumericRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_NumericRange)));
}
export { $isArrayOf_sci_NumericRange as $isArrayOf_sci_NumericRange };
var $d_sci_NumericRange = new $TypeData().initClass($c_sci_NumericRange, "scala.collection.immutable.NumericRange", ({
  sci_NumericRange: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_NumericRange as $d_sci_NumericRange };
function $p_sci_Range__isInexact$1__Z($thiz) {
  return ($thiz.isInclusive__Z() ? ($thiz.sci_Range__f_scala$collection$immutable$Range$$lastElement !== $thiz.sci_Range__f_end) : ((($thiz.sci_Range__f_scala$collection$immutable$Range$$lastElement + $thiz.sci_Range__f_step) | 0) !== $thiz.sci_Range__f_end));
}
export { $p_sci_Range__isInexact$1__Z as $p_sci_Range__isInexact$1__Z };
function $ct_sci_Range__I__I__I__($thiz, start, end, step) {
  $thiz.sci_Range__f_start = start;
  $thiz.sci_Range__f_end = end;
  $thiz.sci_Range__f_step = step;
  $thiz.sci_Range__f_isEmpty = ($thiz.isInclusive__Z() ? ((step >= 0) ? (start > end) : (start < end)) : ((step >= 0) ? (start >= end) : (start <= end)));
  if ((step === 0)) {
    throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), "step cannot be 0.");
  }
  var stepSign = (step >> 31);
  var gap = (((((end - start) | 0) ^ stepSign) - stepSign) | 0);
  var absStep = (((step ^ stepSign) - stepSign) | 0);
  var div = (((gap >>> 0) / ($checkIntDivisor(absStep) >>> 0)) | 0);
  $thiz.sci_Range__f_scala$collection$immutable$Range$$numRangeElements = (($thiz.isInclusive__Z() || (Math.imul(absStep, div) !== gap)) ? ((1 + div) | 0) : div);
  if ((((-3) & ((1 + step) | 0)) === 0)) {
    var $x_1 = ($thiz.isInclusive__Z() ? end : ((end - step) | 0));
  } else {
    var n = (((-1) + $thiz.sci_Range__f_scala$collection$immutable$Range$$numRangeElements) | 0);
    var $x_1 = (($thiz.sci_Range__f_start + Math.imul($thiz.sci_Range__f_step, n)) | 0);
  }
  $thiz.sci_Range__f_scala$collection$immutable$Range$$lastElement = $x_1;
  return $thiz;
}
export { $ct_sci_Range__I__I__I__ as $ct_sci_Range__I__I__I__ };
/** @constructor */
function $c_sci_Range() {
  this.sci_Range__f_start = 0;
  this.sci_Range__f_end = 0;
  this.sci_Range__f_step = 0;
  this.sci_Range__f_isEmpty = false;
  this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements = 0;
  this.sci_Range__f_scala$collection$immutable$Range$$lastElement = 0;
}
export { $c_sci_Range as $c_sci_Range };
$c_sci_Range.prototype = new $h_sci_AbstractSeq();
$c_sci_Range.prototype.constructor = $c_sci_Range;
/** @constructor */
function $h_sci_Range() {
}
export { $h_sci_Range as $h_sci_Range };
$h_sci_Range.prototype = $c_sci_Range.prototype;
$c_sci_Range.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sci_Range.prototype.updated__I__O__O = (function(index, elem) {
  return $f_sci_StrictOptimizedSeqOps__updated__I__O__O(this, index, elem);
});
$c_sci_Range.prototype.prepended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__prepended__O__O(this, elem);
});
$c_sci_Range.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_sci_Range.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_sci_Range.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that);
});
$c_sci_Range.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Range.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Range.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sci_Range.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_Range.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sci_Range.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_Range.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_Range.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_sci_Range.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_Range.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_Range.prototype.foldRight__O__F2__O = (function(z, op) {
  return $p_sc_IndexedSeqOps__foldr__I__I__O__F2__O(this, 0, this.length__I(), z, op);
});
$c_sci_Range.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sci_Range.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sci_Range.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_Range.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sci_Range.prototype.iterator__sc_Iterator = (function() {
  return new $c_sci_RangeIterator(this.sci_Range__f_start, this.sci_Range__f_step, this.sci_Range__f_scala$collection$immutable$Range$$lastElement, this.sci_Range__f_isEmpty);
});
$c_sci_Range.prototype.isEmpty__Z = (function() {
  return this.sci_Range__f_isEmpty;
});
$c_sci_Range.prototype.length__I = (function() {
  return (this.sci_Range__f_isEmpty ? 0 : ((this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements > 0) ? this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements : $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(this.sci_Range__f_start, this.sci_Range__f_end, this.sci_Range__f_step, this.isInclusive__Z())));
});
$c_sci_Range.prototype.last__I = (function() {
  if (this.sci_Range__f_isEmpty) {
    var $x_1 = $m_sci_Range$().scala$collection$immutable$Range$$emptyRangeError__T__jl_Throwable("last");
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
  } else {
    return this.sci_Range__f_scala$collection$immutable$Range$$lastElement;
  }
});
$c_sci_Range.prototype.head__I = (function() {
  if (this.sci_Range__f_isEmpty) {
    var $x_1 = $m_sci_Range$().scala$collection$immutable$Range$$emptyRangeError__T__jl_Throwable("head");
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
  } else {
    return this.sci_Range__f_start;
  }
});
$c_sci_Range.prototype.init__sci_Range = (function() {
  if (this.sci_Range__f_isEmpty) {
    var $x_1 = $m_sci_Range$().scala$collection$immutable$Range$$emptyRangeError__T__jl_Throwable("init");
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
  } else {
    return this.dropRight__I__sci_Range(1);
  }
});
$c_sci_Range.prototype.tail__sci_Range = (function() {
  if (this.sci_Range__f_isEmpty) {
    var $x_1 = $m_sci_Range$().scala$collection$immutable$Range$$emptyRangeError__T__jl_Throwable("tail");
    throw (($x_1 instanceof $c_sjs_js_JavaScriptException) ? $x_1.sjs_js_JavaScriptException__f_exception : $x_1);
  }
  if ((this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements === 1)) {
    var value = this.sci_Range__f_end;
    return new $c_sci_Range$Exclusive(value, value, this.sci_Range__f_step);
  } else {
    return (this.isInclusive__Z() ? new $c_sci_Range$Inclusive(((this.sci_Range__f_start + this.sci_Range__f_step) | 0), this.sci_Range__f_end, this.sci_Range__f_step) : new $c_sci_Range$Exclusive(((this.sci_Range__f_start + this.sci_Range__f_step) | 0), this.sci_Range__f_end, this.sci_Range__f_step));
  }
});
$c_sci_Range.prototype.map__F1__sci_IndexedSeq = (function(f) {
  this.scala$collection$immutable$Range$$validateMaxLength__V();
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_sci_Range.prototype.copy__I__I__I__Z__sci_Range = (function(start, end, step, isInclusive) {
  return (isInclusive ? new $c_sci_Range$Inclusive(start, end, step) : new $c_sci_Range$Exclusive(start, end, step));
});
$c_sci_Range.prototype.scala$collection$immutable$Range$$validateMaxLength__V = (function() {
  if (((this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements <= 0) && (!this.sci_Range__f_isEmpty))) {
    $m_sci_Range$().scala$collection$immutable$Range$$fail__I__I__I__Z__E(this.sci_Range__f_start, this.sci_Range__f_end, this.sci_Range__f_step, this.isInclusive__Z());
  }
});
$c_sci_Range.prototype.foreach__F1__V = (function(f) {
  if ((!this.sci_Range__f_isEmpty)) {
    var i = this.sci_Range__f_start;
    while (true) {
      f.apply__O__O(i);
      if ((i === this.sci_Range__f_scala$collection$immutable$Range$$lastElement)) {
        return (void 0);
      }
      i = ((i + this.sci_Range__f_step) | 0);
    }
  }
});
$c_sci_Range.prototype.indexOf__O__I__I = (function(elem, from) {
  if ($isInt(elem)) {
    var x2 = (elem | 0);
    var pos = this.scala$collection$immutable$Range$$posOf__I__I(x2);
    return ((pos >= from) ? pos : (-1));
  } else {
    return $f_sc_SeqOps__indexOf__O__I__I(this, elem, from);
  }
});
$c_sci_Range.prototype.scala$collection$immutable$Range$$posOf__I__I = (function(i) {
  return (this.contains__I__Z(i) ? ((((i - this.sci_Range__f_start) | 0) / $checkIntDivisor(this.sci_Range__f_step)) | 0) : (-1));
});
$c_sci_Range.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  if ((that instanceof $c_sci_Range)) {
    var x1$2 = this.length__I();
    switch (x1$2) {
      case 0: {
        return that.sci_Range__f_isEmpty;
        break;
      }
      case 1: {
        return ((that.length__I() === 1) && (this.sci_Range__f_start === that.sci_Range__f_start));
        break;
      }
      default: {
        return ((that.length__I() === x1$2) && ((this.sci_Range__f_start === that.sci_Range__f_start) && (this.sci_Range__f_step === that.sci_Range__f_step)));
      }
    }
  } else {
    return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, that);
  }
});
$c_sci_Range.prototype.take__I__sci_Range = (function(n) {
  if (((n <= 0) || this.sci_Range__f_isEmpty)) {
    var value = this.sci_Range__f_start;
    return new $c_sci_Range$Exclusive(value, value, this.sci_Range__f_step);
  } else if (((n >>> 0) > ((((-1) + this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements) | 0) >>> 0))) {
    return this;
  } else {
    var $x_1 = this.sci_Range__f_start;
    var n$1 = (((-1) + n) | 0);
    return new $c_sci_Range$Inclusive($x_1, ((this.sci_Range__f_start + Math.imul(this.sci_Range__f_step, n$1)) | 0), this.sci_Range__f_step);
  }
});
$c_sci_Range.prototype.drop__I__sci_Range = (function(n) {
  if (((n <= 0) || this.sci_Range__f_isEmpty)) {
    return this;
  } else if (((n >>> 0) > ((((-1) + this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements) | 0) >>> 0))) {
    var value = this.sci_Range__f_end;
    return new $c_sci_Range$Exclusive(value, value, this.sci_Range__f_step);
  } else {
    return this.copy__I__I__I__Z__sci_Range(((this.sci_Range__f_start + Math.imul(this.sci_Range__f_step, n)) | 0), this.sci_Range__f_end, this.sci_Range__f_step, this.isInclusive__Z());
  }
});
$c_sci_Range.prototype.dropRight__I__sci_Range = (function(n) {
  if (((n <= 0) || this.sci_Range__f_isEmpty)) {
    return this;
  } else if (((n >>> 0) > ((((-1) + this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements) | 0) >>> 0))) {
    var value = this.sci_Range__f_end;
    return new $c_sci_Range$Exclusive(value, value, this.sci_Range__f_step);
  } else {
    var $x_1 = this.sci_Range__f_start;
    var n$1 = (((((-1) + this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements) | 0) - n) | 0);
    return new $c_sci_Range$Inclusive($x_1, ((this.sci_Range__f_start + Math.imul(this.sci_Range__f_step, n$1)) | 0), this.sci_Range__f_step);
  }
});
$c_sci_Range.prototype.reverse__sci_Range = (function() {
  return (this.sci_Range__f_isEmpty ? this : new $c_sci_Range$Inclusive(this.last__I(), this.sci_Range__f_start, ((-this.sci_Range__f_step) | 0)));
});
$c_sci_Range.prototype.contains__I__Z = (function(x) {
  if ((!this.sci_Range__f_isEmpty)) {
    if ((this.sci_Range__f_step > 0)) {
      if ((!((x < this.sci_Range__f_start) || (x > this.sci_Range__f_scala$collection$immutable$Range$$lastElement)))) {
        if ((this.sci_Range__f_step === 1)) {
          return true;
        } else {
          var dividend = ((x - this.sci_Range__f_start) | 0);
          var divisor = this.sci_Range__f_step;
          return ((((dividend >>> 0) % ($checkIntDivisor(divisor) >>> 0)) | 0) === 0);
        }
      } else {
        return false;
      }
    } else if ((!((x > this.sci_Range__f_start) || (x < this.sci_Range__f_scala$collection$immutable$Range$$lastElement)))) {
      if ((this.sci_Range__f_step === (-1))) {
        return true;
      } else {
        var dividend$1 = ((this.sci_Range__f_start - x) | 0);
        var divisor$1 = ((-this.sci_Range__f_step) | 0);
        return ((((dividend$1 >>> 0) % ($checkIntDivisor(divisor$1) >>> 0)) | 0) === 0);
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_sci_Range.prototype.min__s_math_Ordering__I = (function(ord) {
  if ((ord === $m_s_math_Ordering$Int$())) {
    return ((this.sci_Range__f_step > 0) ? this.head__I() : this.last__I());
  } else {
    var this$1 = $m_s_math_Ordering$Int$();
    if ($f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$1, ord)) {
      return ((this.sci_Range__f_step > 0) ? this.last__I() : this.head__I());
    } else {
      return ($f_sc_IterableOnceOps__min__s_math_Ordering__O(this, ord) | 0);
    }
  }
});
$c_sci_Range.prototype.max__s_math_Ordering__I = (function(ord) {
  if ((ord === $m_s_math_Ordering$Int$())) {
    return ((this.sci_Range__f_step > 0) ? this.last__I() : this.head__I());
  } else {
    var this$1 = $m_s_math_Ordering$Int$();
    if ($f_s_math_Ordering$CachedReverse__isReverseOf__s_math_Ordering__Z(this$1, ord)) {
      return ((this.sci_Range__f_step > 0) ? this.head__I() : this.last__I());
    } else {
      return ($f_sc_IterableOnceOps__max__s_math_Ordering__O(this, ord) | 0);
    }
  }
});
$c_sci_Range.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647;
});
$c_sci_Range.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_sci_Range)) {
    if (this.sci_Range__f_isEmpty) {
      return other.sci_Range__f_isEmpty;
    } else if (((!other.sci_Range__f_isEmpty) && (this.sci_Range__f_start === other.sci_Range__f_start))) {
      var l0 = this.last__I();
      return ((l0 === other.last__I()) && ((this.sci_Range__f_start === l0) || (this.sci_Range__f_step === other.sci_Range__f_step)));
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, other);
  }
});
$c_sci_Range.prototype.hashCode__I = (function() {
  if ((this.length__I() >= 2)) {
    var this$1 = $m_s_util_hashing_MurmurHash3$();
    var start = this.sci_Range__f_start;
    var step = this.sci_Range__f_step;
    var last = this.sci_Range__f_scala$collection$immutable$Range$$lastElement;
    return this$1.rangeHash__I__I__I__I__I(start, step, last, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
  } else {
    return $m_s_util_hashing_MurmurHash3$().seqHash__sc_Seq__I(this);
  }
});
$c_sci_Range.prototype.toString__T = (function() {
  var preposition = (this.isInclusive__Z() ? "to" : "until");
  var stepped = ((this.sci_Range__f_step === 1) ? "" : (" by " + this.sci_Range__f_step));
  var prefix = (this.sci_Range__f_isEmpty ? "empty " : ($p_sci_Range__isInexact$1__Z(this) ? "inexact " : ""));
  return (((((((prefix + "Range ") + this.sci_Range__f_start) + " ") + preposition) + " ") + this.sci_Range__f_end) + stepped);
});
$c_sci_Range.prototype.className__T = (function() {
  return "Range";
});
$c_sci_Range.prototype.sorted__s_math_Ordering__sci_IndexedSeq = (function(ord) {
  return ((ord === $m_s_math_Ordering$Int$()) ? ((this.sci_Range__f_step > 0) ? this : this.reverse__sci_Range()) : $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord));
});
$c_sci_Range.prototype.apply$mcII$sp__I__I = (function(idx) {
  if ((((idx < 0) || (idx >= this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements)) || this.sci_Range__f_isEmpty)) {
    this.scala$collection$immutable$Range$$validateMaxLength__V();
    var max = (this.sci_Range__f_isEmpty ? (-1) : (((-1) + this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements) | 0));
    throw $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (((idx + " is out of bounds (min 0, max ") + max) + ")"));
  } else {
    return ((this.sci_Range__f_start + Math.imul(this.sci_Range__f_step, idx)) | 0);
  }
});
$c_sci_Range.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$c_sci_Range.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_IndexedSeq$();
});
$c_sci_Range.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_IndexedSeq(ord);
});
$c_sci_Range.prototype.distinct__O = (function() {
  return this;
});
$c_sci_Range.prototype.max__s_math_Ordering__O = (function(ord) {
  return this.max__s_math_Ordering__I(ord);
});
$c_sci_Range.prototype.min__s_math_Ordering__O = (function(ord) {
  return this.min__s_math_Ordering__I(ord);
});
$c_sci_Range.prototype.reverse__O = (function() {
  return this.reverse__sci_Range();
});
$c_sci_Range.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_Range(n);
});
$c_sci_Range.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_Range(n);
});
$c_sci_Range.prototype.take__I__O = (function(n) {
  return this.take__I__sci_Range(n);
});
$c_sci_Range.prototype.apply__O__O = (function(v1) {
  var idx = (v1 | 0);
  return this.apply$mcII$sp__I__I(idx);
});
$c_sci_Range.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i);
});
$c_sci_Range.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_IndexedSeq(f);
});
$c_sci_Range.prototype.tail__O = (function() {
  return this.tail__sci_Range();
});
$c_sci_Range.prototype.init__O = (function() {
  return this.init__sci_Range();
});
$c_sci_Range.prototype.head__O = (function() {
  return this.head__I();
});
$c_sci_Range.prototype.last__O = (function() {
  return this.last__I();
});
function $isArrayOf_sci_Range(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Range)));
}
export { $isArrayOf_sci_Range as $isArrayOf_sci_Range };
function $p_scm_LinkedHashSet__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
export { $p_scm_LinkedHashSet__tableSizeFor__I__I as $p_scm_LinkedHashSet__tableSizeFor__I__I };
function $p_scm_LinkedHashSet__newThreshold__I__I($thiz, size) {
  return $doubleToInt((0.75 * size));
}
export { $p_scm_LinkedHashSet__newThreshold__I__I as $p_scm_LinkedHashSet__newThreshold__I__I };
function $p_scm_LinkedHashSet__createNewEntry__O__I__scm_LinkedHashSet$Entry($thiz, key, hash) {
  var e = new $c_scm_LinkedHashSet$Entry(key, hash);
  if (($thiz.scm_LinkedHashSet__f_firstEntry === null)) {
    $thiz.scm_LinkedHashSet__f_firstEntry = e;
  } else {
    $thiz.scm_LinkedHashSet__f_lastEntry.scm_LinkedHashSet$Entry__f_later = e;
    e.scm_LinkedHashSet$Entry__f_earlier = $thiz.scm_LinkedHashSet__f_lastEntry;
  }
  $thiz.scm_LinkedHashSet__f_lastEntry = e;
  return e;
}
export { $p_scm_LinkedHashSet__createNewEntry__O__I__scm_LinkedHashSet$Entry as $p_scm_LinkedHashSet__createNewEntry__O__I__scm_LinkedHashSet$Entry };
function $p_scm_LinkedHashSet__deleteEntry__scm_LinkedHashSet$Entry__V($thiz, e) {
  if ((e.scm_LinkedHashSet$Entry__f_earlier === null)) {
    $thiz.scm_LinkedHashSet__f_firstEntry = e.scm_LinkedHashSet$Entry__f_later;
  } else {
    e.scm_LinkedHashSet$Entry__f_earlier.scm_LinkedHashSet$Entry__f_later = e.scm_LinkedHashSet$Entry__f_later;
  }
  if ((e.scm_LinkedHashSet$Entry__f_later === null)) {
    $thiz.scm_LinkedHashSet__f_lastEntry = e.scm_LinkedHashSet$Entry__f_earlier;
  } else {
    e.scm_LinkedHashSet$Entry__f_later.scm_LinkedHashSet$Entry__f_earlier = e.scm_LinkedHashSet$Entry__f_earlier;
  }
  e.scm_LinkedHashSet$Entry__f_earlier = null;
  e.scm_LinkedHashSet$Entry__f_later = null;
  e.scm_LinkedHashSet$Entry__f_next = null;
}
export { $p_scm_LinkedHashSet__deleteEntry__scm_LinkedHashSet$Entry__V as $p_scm_LinkedHashSet__deleteEntry__scm_LinkedHashSet$Entry__V };
function $p_scm_LinkedHashSet__put0__O__I__I__Z($thiz, elem, hash, idx) {
  var x1 = $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u[idx];
  if ((x1 === null)) {
    $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u[idx] = $p_scm_LinkedHashSet__createNewEntry__O__I__scm_LinkedHashSet$Entry($thiz, elem, hash);
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.scm_LinkedHashSet$Entry__f_hash <= hash))) {
      if (((n.scm_LinkedHashSet$Entry__f_hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(elem, n.scm_LinkedHashSet$Entry__f_key))) {
        return false;
      }
      prev = n;
      n = n.scm_LinkedHashSet$Entry__f_next;
    }
    var nnode = $p_scm_LinkedHashSet__createNewEntry__O__I__scm_LinkedHashSet$Entry($thiz, elem, hash);
    if ((prev === null)) {
      nnode.scm_LinkedHashSet$Entry__f_next = x1;
      $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u[idx] = nnode;
    } else {
      nnode.scm_LinkedHashSet$Entry__f_next = prev.scm_LinkedHashSet$Entry__f_next;
      prev.scm_LinkedHashSet$Entry__f_next = nnode;
    }
  }
  $thiz.scm_LinkedHashSet__f_contentSize = ((1 + $thiz.scm_LinkedHashSet__f_contentSize) | 0);
  return true;
}
export { $p_scm_LinkedHashSet__put0__O__I__I__Z as $p_scm_LinkedHashSet__put0__O__I__I__Z };
function $p_scm_LinkedHashSet__remove0__O__I__Z($thiz, elem, hash) {
  var idx = (hash & (((-1) + $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u.length) | 0));
  var x1 = $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u[idx];
  if ((x1 !== null)) {
    if (((x1.scm_LinkedHashSet$Entry__f_hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(x1.scm_LinkedHashSet$Entry__f_key, elem))) {
      $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u[idx] = x1.scm_LinkedHashSet$Entry__f_next;
      $p_scm_LinkedHashSet__deleteEntry__scm_LinkedHashSet$Entry__V($thiz, x1);
      $thiz.scm_LinkedHashSet__f_contentSize = (((-1) + $thiz.scm_LinkedHashSet__f_contentSize) | 0);
      return true;
    } else {
      var prev = x1;
      var next = x1.scm_LinkedHashSet$Entry__f_next;
      while (((next !== null) && (next.scm_LinkedHashSet$Entry__f_hash <= hash))) {
        if (((next.scm_LinkedHashSet$Entry__f_hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(next.scm_LinkedHashSet$Entry__f_key, elem))) {
          prev.scm_LinkedHashSet$Entry__f_next = next.scm_LinkedHashSet$Entry__f_next;
          $p_scm_LinkedHashSet__deleteEntry__scm_LinkedHashSet$Entry__V($thiz, next);
          $thiz.scm_LinkedHashSet__f_contentSize = (((-1) + $thiz.scm_LinkedHashSet__f_contentSize) | 0);
          return true;
        }
        prev = next;
        next = next.scm_LinkedHashSet$Entry__f_next;
      }
      return false;
    }
  } else {
    return false;
  }
}
export { $p_scm_LinkedHashSet__remove0__O__I__Z as $p_scm_LinkedHashSet__remove0__O__I__Z };
function $p_scm_LinkedHashSet__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new hash table size " + newlen) + " exceeds maximum"));
  }
  var oldlen = $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u.length;
  $thiz.scm_LinkedHashSet__f_threshold = $p_scm_LinkedHashSet__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_LinkedHashSet__f_contentSize === 0)) {
    $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table = new ($d_scm_LinkedHashSet$Entry.getArrayOf().constr)(newlen);
  } else {
    var original = $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table;
    $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table = $m_ju_Arrays$().copyOf__AO__I__AO(original, newlen);
    var preLow = new $c_scm_LinkedHashSet$Entry(null, 0);
    var preHigh = new $c_scm_LinkedHashSet$Entry(null, 0);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u[i];
        if ((old !== null)) {
          preLow.scm_LinkedHashSet$Entry__f_next = null;
          preHigh.scm_LinkedHashSet$Entry__f_next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.scm_LinkedHashSet$Entry__f_next;
            if (((n.scm_LinkedHashSet$Entry__f_hash & oldlen) === 0)) {
              lastLow.scm_LinkedHashSet$Entry__f_next = n;
              lastLow = n;
            } else {
              lastHigh.scm_LinkedHashSet$Entry__f_next = n;
              lastHigh = n;
            }
            n = next;
          }
          lastLow.scm_LinkedHashSet$Entry__f_next = null;
          if ((old !== preLow.scm_LinkedHashSet$Entry__f_next)) {
            $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u[i] = preLow.scm_LinkedHashSet$Entry__f_next;
          }
          if ((preHigh.scm_LinkedHashSet$Entry__f_next !== null)) {
            $thiz.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u[((i + oldlen) | 0)] = preHigh.scm_LinkedHashSet$Entry__f_next;
            lastHigh.scm_LinkedHashSet$Entry__f_next = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
export { $p_scm_LinkedHashSet__growTable__I__V as $p_scm_LinkedHashSet__growTable__I__V };
/** @constructor */
function $c_scm_LinkedHashSet() {
  this.scm_LinkedHashSet__f_firstEntry = null;
  this.scm_LinkedHashSet__f_lastEntry = null;
  this.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table = null;
  this.scm_LinkedHashSet__f_threshold = 0;
  this.scm_LinkedHashSet__f_contentSize = 0;
  this.scm_LinkedHashSet__f_firstEntry = null;
  this.scm_LinkedHashSet__f_lastEntry = null;
  this.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table = new ($d_scm_LinkedHashSet$Entry.getArrayOf().constr)($p_scm_LinkedHashSet__tableSizeFor__I__I(this, 16));
  this.scm_LinkedHashSet__f_threshold = $p_scm_LinkedHashSet__newThreshold__I__I(this, this.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u.length);
  this.scm_LinkedHashSet__f_contentSize = 0;
}
export { $c_scm_LinkedHashSet as $c_scm_LinkedHashSet };
$c_scm_LinkedHashSet.prototype = new $h_scm_AbstractSet();
$c_scm_LinkedHashSet.prototype.constructor = $c_scm_LinkedHashSet;
/** @constructor */
function $h_scm_LinkedHashSet() {
}
export { $h_scm_LinkedHashSet as $h_scm_LinkedHashSet };
$h_scm_LinkedHashSet.prototype = $c_scm_LinkedHashSet.prototype;
$c_scm_LinkedHashSet.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_LinkedHashSet.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_LinkedHashSet.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_LinkedHashSet.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_LinkedHashSet.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_LinkedHashSet$();
});
$c_scm_LinkedHashSet.prototype.last__O = (function() {
  if ((this.scm_LinkedHashSet__f_contentSize > 0)) {
    return this.scm_LinkedHashSet__f_lastEntry.scm_LinkedHashSet$Entry__f_key;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Cannot call .last on empty LinkedHashSet");
  }
});
$c_scm_LinkedHashSet.prototype.head__O = (function() {
  if ((this.scm_LinkedHashSet__f_contentSize > 0)) {
    return this.scm_LinkedHashSet__f_firstEntry.scm_LinkedHashSet$Entry__f_key;
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Cannot call .head on empty LinkedHashSet");
  }
});
$c_scm_LinkedHashSet.prototype.headOption__s_Option = (function() {
  return ((this.scm_LinkedHashSet__f_contentSize > 0) ? new $c_s_Some(this.scm_LinkedHashSet__f_firstEntry.scm_LinkedHashSet$Entry__f_key) : $m_s_None$());
});
$c_scm_LinkedHashSet.prototype.size__I = (function() {
  return this.scm_LinkedHashSet__f_contentSize;
});
$c_scm_LinkedHashSet.prototype.knownSize__I = (function() {
  return this.scm_LinkedHashSet__f_contentSize;
});
$c_scm_LinkedHashSet.prototype.isEmpty__Z = (function() {
  return (this.scm_LinkedHashSet__f_contentSize === 0);
});
$c_scm_LinkedHashSet.prototype.contains__O__Z = (function(elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u[(hash & (((-1) + this.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u.length) | 0))];
  return (((x1 === null) ? null : x1.findEntry__O__I__scm_LinkedHashSet$Entry(elem, hash)) !== null);
});
$c_scm_LinkedHashSet.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_LinkedHashSet__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / 0.75)));
  if ((target > this.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u.length)) {
    $p_scm_LinkedHashSet__growTable__I__V(this, target);
  }
});
$c_scm_LinkedHashSet.prototype.add__O__Z = (function(elem) {
  if ((((1 + this.scm_LinkedHashSet__f_contentSize) | 0) >= this.scm_LinkedHashSet__f_threshold)) {
    $p_scm_LinkedHashSet__growTable__I__V(this, (this.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u.length << 1));
  }
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  return $p_scm_LinkedHashSet__put0__O__I__I__Z(this, elem, hash, (hash & (((-1) + this.scm_LinkedHashSet__f_scala$collection$mutable$LinkedHashSet$$table.u.length) | 0)));
});
$c_scm_LinkedHashSet.prototype.addOne__O__scm_LinkedHashSet = (function(elem) {
  this.add__O__Z(elem);
  return this;
});
$c_scm_LinkedHashSet.prototype.subtractOne__O__scm_LinkedHashSet = (function(elem) {
  this.remove__O__Z(elem);
  return this;
});
$c_scm_LinkedHashSet.prototype.remove__O__Z = (function(elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  return $p_scm_LinkedHashSet__remove0__O__I__Z(this, elem, (originalHash ^ ((originalHash >>> 16) | 0)));
});
$c_scm_LinkedHashSet.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_LinkedHashSet$$anon$1(this);
});
$c_scm_LinkedHashSet.prototype.foreach__F1__V = (function(f) {
  var cur = this.scm_LinkedHashSet__f_firstEntry;
  while ((cur !== null)) {
    f.apply__O__O(cur.scm_LinkedHashSet$Entry__f_key);
    cur = cur.scm_LinkedHashSet$Entry__f_later;
  }
});
$c_scm_LinkedHashSet.prototype.hashCode__I = (function() {
  var setHashIterator = (this.isEmpty__Z() ? new $c_scm_LinkedHashSet$$anon$1(this) : new $c_scm_LinkedHashSet$$anon$3(this));
  return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(setHashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_setSeed);
});
$c_scm_LinkedHashSet.prototype.stringPrefix__T = (function() {
  return "LinkedHashSet";
});
$c_scm_LinkedHashSet.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_LinkedHashSet(elem);
});
$c_scm_LinkedHashSet.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_LinkedHashSet(elem);
});
function $isArrayOf_scm_LinkedHashSet(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashSet)));
}
export { $isArrayOf_scm_LinkedHashSet as $isArrayOf_scm_LinkedHashSet };
var $d_scm_LinkedHashSet = new $TypeData().initClass($c_scm_LinkedHashSet, "scala.collection.mutable.LinkedHashSet", ({
  scm_LinkedHashSet: 1,
  scm_AbstractSet: 1,
  sc_AbstractSet: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Set: 1,
  sc_SetOps: 1,
  F1: 1,
  s_Equals: 1,
  scm_Set: 1,
  scm_Iterable: 1,
  scm_SetOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_LinkedHashSet as $d_scm_LinkedHashSet };
/** @constructor */
function $c_scm_Map$WithDefault(underlying, defaultValue) {
  this.scm_Map$WithDefault__f_underlying = null;
  this.scm_Map$WithDefault__f_defaultValue = null;
  this.scm_Map$WithDefault__f_underlying = underlying;
  this.scm_Map$WithDefault__f_defaultValue = defaultValue;
}
export { $c_scm_Map$WithDefault as $c_scm_Map$WithDefault };
$c_scm_Map$WithDefault.prototype = new $h_scm_AbstractMap();
$c_scm_Map$WithDefault.prototype.constructor = $c_scm_Map$WithDefault;
/** @constructor */
function $h_scm_Map$WithDefault() {
}
export { $h_scm_Map$WithDefault as $h_scm_Map$WithDefault };
$h_scm_Map$WithDefault.prototype = $c_scm_Map$WithDefault.prototype;
$c_scm_Map$WithDefault.prototype.default__O__O = (function(key) {
  return this.scm_Map$WithDefault__f_defaultValue.apply__O__O(key);
});
$c_scm_Map$WithDefault.prototype.iterator__sc_Iterator = (function() {
  return this.scm_Map$WithDefault__f_underlying.iterator__sc_Iterator();
});
$c_scm_Map$WithDefault.prototype.isEmpty__Z = (function() {
  return this.scm_Map$WithDefault__f_underlying.isEmpty__Z();
});
$c_scm_Map$WithDefault.prototype.knownSize__I = (function() {
  return this.scm_Map$WithDefault__f_underlying.knownSize__I();
});
$c_scm_Map$WithDefault.prototype.mapFactory__sc_MapFactory = (function() {
  return this.scm_Map$WithDefault__f_underlying.mapFactory__sc_MapFactory();
});
$c_scm_Map$WithDefault.prototype.get__O__s_Option = (function(key) {
  return this.scm_Map$WithDefault__f_underlying.get__O__s_Option(key);
});
$c_scm_Map$WithDefault.prototype.subtractOne__O__scm_Map$WithDefault = (function(elem) {
  this.scm_Map$WithDefault__f_underlying.subtractOne__O__scm_Shrinkable(elem);
  return this;
});
$c_scm_Map$WithDefault.prototype.addOne__T2__scm_Map$WithDefault = (function(elem) {
  this.scm_Map$WithDefault__f_underlying.addOne__O__scm_Growable(elem);
  return this;
});
$c_scm_Map$WithDefault.prototype.concat__sc_IterableOnce__scm_Map = (function(suffix) {
  var this$1 = this.scm_Map$WithDefault__f_underlying.concat__sc_IterableOnce__sc_IterableOps(suffix);
  var d = this.scm_Map$WithDefault__f_defaultValue;
  return new $c_scm_Map$WithDefault(this$1, d);
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__scm_Map$WithDefault = (function(coll) {
  return new $c_scm_Map$WithDefault(this.scm_Map$WithDefault__f_underlying.mapFactory__sc_MapFactory().from__sc_IterableOnce__O(coll), this.scm_Map$WithDefault__f_defaultValue);
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_Map$WithDefault(coll);
});
$c_scm_Map$WithDefault.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_Map$WithDefault(coll);
});
$c_scm_Map$WithDefault.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return this.concat__sc_IterableOnce__scm_Map(suffix);
});
$c_scm_Map$WithDefault.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_Map$WithDefault(elem);
});
$c_scm_Map$WithDefault.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_Map$WithDefault(elem);
});
var $d_scm_Map$WithDefault = new $TypeData().initClass($c_scm_Map$WithDefault, "scala.collection.mutable.Map$WithDefault", ({
  scm_Map$WithDefault: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_Map$WithDefault as $d_scm_Map$WithDefault };
function $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq($thiz, that) {
  if ($f_sc_SeqOps__isEmpty__Z($thiz)) {
    return that;
  } else if ($f_sc_SeqOps__isEmpty__Z(that)) {
    return $thiz;
  } else {
    var thisIsObj = ($thiz.unsafeArray__O() instanceof $ac_O);
    var thatIsObj = (that.unsafeArray__O() instanceof $ac_O);
    var mismatch = (thisIsObj !== thatIsObj);
    if (mismatch) {
      return null;
    } else if (thisIsObj) {
      var ax = $thiz.unsafeArray__O();
      var ay = that.unsafeArray__O();
      var len = (($m_jl_reflect_Array$().getLength__O__I(ax) + $m_jl_reflect_Array$().getLength__O__I(ay)) | 0);
      var a = new $ac_O(len);
      var length = $m_jl_reflect_Array$().getLength__O__I(ax);
      ax.copyTo(0, a, 0, length);
      var destPos = $m_jl_reflect_Array$().getLength__O__I(ax);
      var length$1 = $m_jl_reflect_Array$().getLength__O__I(ay);
      ay.copyTo(0, a, destPos, length$1);
      return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a);
    } else {
      var ax$2 = $thiz.unsafeArray__O();
      var ay$2 = that.unsafeArray__O();
      var len$2 = (($m_jl_reflect_Array$().getLength__O__I(ax$2) + $m_jl_reflect_Array$().getLength__O__I(ay$2)) | 0);
      var a$2 = $thiz.elemTag__s_reflect_ClassTag().newArray__I__O(len$2);
      var length$2 = $m_jl_reflect_Array$().getLength__O__I(ax$2);
      ax$2.copyTo(0, a$2, 0, length$2);
      var destPos$1 = $m_jl_reflect_Array$().getLength__O__I(ax$2);
      var length$3 = $m_jl_reflect_Array$().getLength__O__I(ay$2);
      ay$2.copyTo(0, a$2, destPos$1, length$3);
      return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a$2);
    }
  }
}
export { $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq as $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq };
function $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq($thiz, suffix$1) {
  var k = suffix$1.knownSize__I();
  if ((k === 0)) {
    return $thiz;
  } else {
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    capacity = 0;
    size = 0;
    jsElems = [];
    if ((k >= 0)) {
      var xs = $thiz.unsafeArray__O();
      $m_jl_reflect_Array$().getLength__O__I(xs);
    }
    var xs$1 = $thiz.unsafeArray__O();
    var length = $m_jl_reflect_Array$().getLength__O__I(xs$1);
    var i = 0;
    while ((i < length)) {
      var elem = $m_sr_ScalaRunTime$().array_apply__O__I__O(xs$1, i);
      var unboxedElem = ((elem === null) ? null : elem);
      jsElems.push(unboxedElem);
      i = ((1 + i) | 0);
    }
    var it = suffix$1.iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var elem$1 = it.next__O();
      var unboxedElem$1 = ((elem$1 === null) ? null : elem$1);
      jsElems.push(unboxedElem$1);
    }
    return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(new $ac_O(jsElems));
  }
}
export { $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq as $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq };
/** @constructor */
function $c_sci_ArraySeq() {
}
export { $c_sci_ArraySeq as $c_sci_ArraySeq };
$c_sci_ArraySeq.prototype = new $h_sci_AbstractSeq();
$c_sci_ArraySeq.prototype.constructor = $c_sci_ArraySeq;
/** @constructor */
function $h_sci_ArraySeq() {
}
export { $h_sci_ArraySeq as $h_sci_ArraySeq };
$h_sci_ArraySeq.prototype = $c_sci_ArraySeq.prototype;
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5);
});
$c_sci_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$12 = this.elemTag__s_reflect_ClassTag();
  return this$1.newBuilder__s_reflect_ClassTag__scm_Builder(evidence$12);
});
$c_sci_ArraySeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sci_ArraySeq.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that);
});
$c_sci_ArraySeq.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_ArraySeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_ArraySeq.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sci_ArraySeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sci_ArraySeq.prototype.filterNot__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, true);
});
$c_sci_ArraySeq.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_ArraySeq.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_ArraySeq.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sci_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sci_ArraySeq.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sci_ArraySeq.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sci_ArraySeq.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sci_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged;
});
$c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  var dest = new $ac_O(this.length__I());
  $m_s_Array$().copy__O__I__O__I__I__V(this.unsafeArray__O(), 0, dest, 0, this.length__I());
  dest.u[index] = elem;
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(dest);
});
$c_sci_ArraySeq.prototype.map__F1__sci_ArraySeq = (function(f) {
  var a = new $ac_O(this.length__I());
  var i = 0;
  while ((i < a.u.length)) {
    a.u[i] = f.apply__O__O(this.apply__I__O(i));
    i = ((1 + i) | 0);
  }
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq(a);
});
$c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  var $x_1 = $m_sci_ArraySeq$();
  var xs = this.unsafeArray__O();
  var len = ((1 + $m_jl_reflect_Array$().getLength__O__I(xs)) | 0);
  var dest = new $ac_O(len);
  dest.u[0] = elem;
  $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, $m_jl_reflect_Array$().getLength__O__I(xs));
  return $x_1.unsafeWrapArray__O__sci_ArraySeq(dest);
});
$c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq = (function(elem) {
  var $x_1 = $m_sci_ArraySeq$();
  var xs = this.unsafeArray__O();
  var newLength = ((1 + $m_jl_reflect_Array$().getLength__O__I(xs)) | 0);
  var this$5 = $objectGetClass(xs);
  var that = this$5.data.getComponentType();
  if ($d_O.isAssignableFrom(that.data)) {
    var dest$1 = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(xs, newLength, $d_O.getArrayOf().getClassOf());
  } else {
    var dest = new $ac_O(newLength);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(xs));
    var dest$1 = dest;
  }
  var x1 = $m_jl_reflect_Array$().getLength__O__I(xs);
  dest$1.u[x1] = elem;
  return $x_1.unsafeWrapArray__O__sci_ArraySeq(dest$1);
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__sci_ArraySeq = (function(suffix) {
  if ((suffix instanceof $c_sci_ArraySeq)) {
    var result = $p_sci_ArraySeq__appendedAllArraySeq__sci_ArraySeq__sci_ArraySeq(this, suffix);
    return ((result === null) ? $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix) : result);
  } else {
    return $p_sci_ArraySeq__genericResult$1__sc_IterableOnce__sci_ArraySeq(this, suffix);
  }
});
$c_sci_ArraySeq.prototype.take__I__sci_ArraySeq = (function(n) {
  var xs = this.unsafeArray__O();
  if (($m_jl_reflect_Array$().getLength__O__I(xs) <= n)) {
    return this;
  } else {
    var $x_1 = $m_sci_ArraySeq$();
    var this$ = this.unsafeArray__O();
    return $x_1.unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().slice$extension__O__I__I__O(this$, 0, n));
  }
});
$c_sci_ArraySeq.prototype.drop__I__sci_ArraySeq = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().drop$extension__O__I__O(this.unsafeArray__O(), n)));
});
$c_sci_ArraySeq.prototype.dropRight__I__sci_ArraySeq = (function(n) {
  return ((n <= 0) ? this : $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().dropRight$extension__O__I__O(this.unsafeArray__O(), n)));
});
$c_sci_ArraySeq.prototype.foldLeft__O__F2__O = (function(z, f) {
  var array = this.unsafeArray__O();
  var b = z;
  var i = 0;
  while ((i < $m_jl_reflect_Array$().getLength__O__I(array))) {
    var a = $m_sr_ScalaRunTime$().array_apply__O__I__O(array, i);
    b = f.apply__O__O__O(b, a);
    i = ((1 + i) | 0);
  }
  return b;
});
$c_sci_ArraySeq.prototype.foldRight__O__F2__O = (function(z, f) {
  var array = this.unsafeArray__O();
  var b = z;
  var i = $m_jl_reflect_Array$().getLength__O__I(array);
  while ((i > 0)) {
    i = (((-1) + i) | 0);
    var a = $m_sr_ScalaRunTime$().array_apply__O__I__O(array, i);
    b = f.apply__O__O__O(a, b);
  }
  return b;
});
$c_sci_ArraySeq.prototype.tail__sci_ArraySeq = (function() {
  return $m_sci_ArraySeq$().unsafeWrapArray__O__sci_ArraySeq($m_sc_ArrayOps$().tail$extension__O__O(this.unsafeArray__O()));
});
$c_sci_ArraySeq.prototype.reverse__sci_ArraySeq = (function() {
  var $x_2 = $m_sci_ArraySeq$();
  var this$ = this.unsafeArray__O();
  var len = $m_jl_reflect_Array$().getLength__O__I(this$);
  var $x_1 = $m_s_reflect_ClassTag$();
  var this$4 = $objectGetClass(this$);
  var res = $x_1.apply__jl_Class__s_reflect_ClassTag(this$4.data.getComponentType()).newArray__I__O(len);
  var i = 0;
  while ((i < len)) {
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(res, (((-1) + ((len - i) | 0)) | 0), $m_sr_ScalaRunTime$().array_apply__O__I__O(this$, i));
    i = ((1 + i) | 0);
  }
  return $x_2.unsafeWrapArray__O__sci_ArraySeq(res);
});
$c_sci_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq";
});
$c_sci_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.unsafeArray__O(), 0, xs, start, copied);
  }
  return copied;
});
$c_sci_ArraySeq.prototype.applyPreferredMaxLength__I = (function() {
  return 2147483647;
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  var xs = this.unsafeArray__O();
  if (($m_jl_reflect_Array$().getLength__O__I(xs) <= 1)) {
    return this;
  } else {
    var original = this.unsafeArray__O();
    var newLength = this.length__I();
    var this$3 = $objectGetClass(original);
    var that = this$3.data.getComponentType();
    if ($d_O.isAssignableFrom(that.data)) {
      var a = $m_ju_Arrays$().copyOf__AO__I__jl_Class__AO(original, newLength, $d_O.getArrayOf().getClassOf());
    } else {
      var dest = new $ac_O(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(original, 0, dest, 0, $m_jl_reflect_Array$().getLength__O__I(original));
      var a = dest;
    }
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a);
  }
});
$c_sci_ArraySeq.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$c_sci_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  var this$1 = $m_sci_ArraySeq$();
  var evidence$5 = this.elemTag__s_reflect_ClassTag();
  return this$1.from__sc_IterableOnce__s_reflect_ClassTag__sci_ArraySeq(coll, evidence$5);
});
$c_sci_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq.prototype.reverse__O = (function() {
  return this.reverse__sci_ArraySeq();
});
$c_sci_ArraySeq.prototype.tail__O = (function() {
  return this.tail__sci_ArraySeq();
});
$c_sci_ArraySeq.prototype.dropRight__I__O = (function(n) {
  return this.dropRight__I__sci_ArraySeq(n);
});
$c_sci_ArraySeq.prototype.drop__I__O = (function(n) {
  return this.drop__I__sci_ArraySeq(n);
});
$c_sci_ArraySeq.prototype.take__I__O = (function(n) {
  return this.take__I__sci_ArraySeq(n);
});
$c_sci_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_ArraySeq(suffix);
});
$c_sci_ArraySeq.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_ArraySeq(f);
});
$c_sci_ArraySeq.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem);
});
$c_sci_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_ArraySeq$().sci_ArraySeq$__f_untagged;
});
function $isArrayOf_sci_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq)));
}
export { $isArrayOf_sci_ArraySeq as $isArrayOf_sci_ArraySeq };
/** @constructor */
function $c_sci_ListMap$EmptyListMap$() {
}
export { $c_sci_ListMap$EmptyListMap$ as $c_sci_ListMap$EmptyListMap$ };
$c_sci_ListMap$EmptyListMap$.prototype = new $h_sci_ListMap();
$c_sci_ListMap$EmptyListMap$.prototype.constructor = $c_sci_ListMap$EmptyListMap$;
/** @constructor */
function $h_sci_ListMap$EmptyListMap$() {
}
export { $h_sci_ListMap$EmptyListMap$ as $h_sci_ListMap$EmptyListMap$ };
$h_sci_ListMap$EmptyListMap$.prototype = $c_sci_ListMap$EmptyListMap$.prototype;
var $d_sci_ListMap$EmptyListMap$ = new $TypeData().initClass($c_sci_ListMap$EmptyListMap$, "scala.collection.immutable.ListMap$EmptyListMap$", ({
  sci_ListMap$EmptyListMap$: 1,
  sci_ListMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_SeqMap: 1,
  sc_SeqMap: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ListMap$EmptyListMap$ as $d_sci_ListMap$EmptyListMap$ };
var $n_sci_ListMap$EmptyListMap$;
function $m_sci_ListMap$EmptyListMap$() {
  if ((!$n_sci_ListMap$EmptyListMap$)) {
    $n_sci_ListMap$EmptyListMap$ = new $c_sci_ListMap$EmptyListMap$();
  }
  return $n_sci_ListMap$EmptyListMap$;
}
export { $m_sci_ListMap$EmptyListMap$ as $m_sci_ListMap$EmptyListMap$ };
function $p_sci_ListMap$Node__sizeInternal__sci_ListMap__I__I($thiz, cur, acc) {
  while (true) {
    if (cur.isEmpty__Z()) {
      return acc;
    } else {
      var temp$cur = cur.next__sci_ListMap();
      var temp$acc = ((1 + acc) | 0);
      cur = temp$cur;
      acc = temp$acc;
    }
  }
}
export { $p_sci_ListMap$Node__sizeInternal__sci_ListMap__I__I as $p_sci_ListMap$Node__sizeInternal__sci_ListMap__I__I };
function $p_sci_ListMap$Node__applyInternal__sci_ListMap__O__O($thiz, cur, k) {
  while (true) {
    if (cur.isEmpty__Z()) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), ("key not found: " + k));
    } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(k, cur.key__O())) {
      return cur.value__O();
    } else {
      cur = cur.next__sci_ListMap();
    }
  }
}
export { $p_sci_ListMap$Node__applyInternal__sci_ListMap__O__O as $p_sci_ListMap$Node__applyInternal__sci_ListMap__O__O };
function $p_sci_ListMap$Node__getInternal__sci_ListMap__O__s_Option($thiz, cur, k) {
  while (true) {
    if (cur.isEmpty__Z()) {
      return $m_s_None$();
    } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(k, cur.key__O())) {
      return new $c_s_Some(cur.value__O());
    } else {
      cur = cur.next__sci_ListMap();
    }
  }
}
export { $p_sci_ListMap$Node__getInternal__sci_ListMap__O__s_Option as $p_sci_ListMap$Node__getInternal__sci_ListMap__O__s_Option };
function $p_sci_ListMap$Node__containsInternal__sci_ListMap__O__Z($thiz, cur, k) {
  while (true) {
    if ((!cur.isEmpty__Z())) {
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(k, cur.key__O())) {
        return true;
      } else {
        cur = cur.next__sci_ListMap();
      }
    } else {
      return false;
    }
  }
}
export { $p_sci_ListMap$Node__containsInternal__sci_ListMap__O__Z as $p_sci_ListMap$Node__containsInternal__sci_ListMap__O__Z };
function $p_sci_ListMap$Node__removeInternal__O__sci_ListMap__sci_List__sci_ListMap($thiz, k, cur, acc) {
  while (true) {
    if (cur.isEmpty__Z()) {
      return acc.last__O();
    } else if ($m_sr_BoxesRunTime$().equals__O__O__Z(k, cur.key__O())) {
      var this$1 = acc;
      var z = cur.next__sci_ListMap();
      var acc$1 = z;
      var these = this$1;
      while ((!these.isEmpty__Z())) {
        var x0 = acc$1;
        var x1 = these.head__O();
        acc$1 = new $c_sci_ListMap$Node(x1.key__O(), x1.value__O(), x0);
        these = these.tail__O();
      }
      return acc$1;
    } else {
      var temp$cur = cur.next__sci_ListMap();
      var rassoc$3 = cur;
      var this$2 = acc;
      var temp$acc = new $c_sci_$colon$colon(rassoc$3, this$2);
      cur = temp$cur;
      acc = temp$acc;
    }
  }
}
export { $p_sci_ListMap$Node__removeInternal__O__sci_ListMap__sci_List__sci_ListMap as $p_sci_ListMap$Node__removeInternal__O__sci_ListMap__sci_List__sci_ListMap };
/** @constructor */
function $c_sci_ListMap$Node(key, _value, _init) {
  this.sci_ListMap$Node__f_key = null;
  this.sci_ListMap$Node__f__value = null;
  this.sci_ListMap$Node__f__init = null;
  this.sci_ListMap$Node__f_key = key;
  this.sci_ListMap$Node__f__value = _value;
  this.sci_ListMap$Node__f__init = _init;
}
export { $c_sci_ListMap$Node as $c_sci_ListMap$Node };
$c_sci_ListMap$Node.prototype = new $h_sci_ListMap();
$c_sci_ListMap$Node.prototype.constructor = $c_sci_ListMap$Node;
/** @constructor */
function $h_sci_ListMap$Node() {
}
export { $h_sci_ListMap$Node as $h_sci_ListMap$Node };
$h_sci_ListMap$Node.prototype = $c_sci_ListMap$Node.prototype;
$c_sci_ListMap$Node.prototype.key__O = (function() {
  return this.sci_ListMap$Node__f_key;
});
$c_sci_ListMap$Node.prototype.value__O = (function() {
  return this.sci_ListMap$Node__f__value;
});
$c_sci_ListMap$Node.prototype.size__I = (function() {
  return $p_sci_ListMap$Node__sizeInternal__sci_ListMap__I__I(this, this, 0);
});
$c_sci_ListMap$Node.prototype.isEmpty__Z = (function() {
  return false;
});
$c_sci_ListMap$Node.prototype.knownSize__I = (function() {
  return (-1);
});
$c_sci_ListMap$Node.prototype.apply__O__O = (function(k) {
  return $p_sci_ListMap$Node__applyInternal__sci_ListMap__O__O(this, this, k);
});
$c_sci_ListMap$Node.prototype.get__O__s_Option = (function(k) {
  return $p_sci_ListMap$Node__getInternal__sci_ListMap__O__s_Option(this, this, k);
});
$c_sci_ListMap$Node.prototype.contains__O__Z = (function(k) {
  return $p_sci_ListMap$Node__containsInternal__sci_ListMap__O__Z(this, this, k);
});
$c_sci_ListMap$Node.prototype.updated__O__O__sci_ListMap = (function(k, v) {
  var index = (-1);
  var found = false;
  var isDifferent = false;
  var curr = this;
  while (true) {
    var this$1 = curr;
    if (((!this$1.isEmpty__Z()) && (!found))) {
      if ($m_sr_BoxesRunTime$().equals__O__O__Z(k, curr.key__O())) {
        found = true;
        isDifferent = (!Object.is(v, curr.value__O()));
      }
      index = ((1 + index) | 0);
      curr = curr.init__O();
    } else {
      break;
    }
  }
  if (found) {
    if (isDifferent) {
      var newHead = null;
      var prev = null;
      var curr$2 = this;
      var i = 0;
      while ((i < index)) {
        var temp = new $c_sci_ListMap$Node(curr$2.key__O(), curr$2.value__O(), null);
        if ((prev !== null)) {
          prev.sci_ListMap$Node__f__init = temp;
        }
        prev = temp;
        curr$2 = curr$2.init__O();
        if ((newHead === null)) {
          newHead = prev;
        }
        i = ((1 + i) | 0);
      }
      var newNode = new $c_sci_ListMap$Node(curr$2.key__O(), v, curr$2.init__O());
      if ((prev !== null)) {
        prev.sci_ListMap$Node__f__init = newNode;
      }
      return ((newHead === null) ? newNode : newHead);
    } else {
      return this;
    }
  } else {
    return new $c_sci_ListMap$Node(k, v, this);
  }
});
$c_sci_ListMap$Node.prototype.removed__O__sci_ListMap = (function(k) {
  return $p_sci_ListMap$Node__removeInternal__O__sci_ListMap__sci_List__sci_ListMap(this, k, this, $m_sci_Nil$());
});
$c_sci_ListMap$Node.prototype.next__sci_ListMap = (function() {
  return this.sci_ListMap$Node__f__init;
});
$c_sci_ListMap$Node.prototype.init__O = (function() {
  return this.sci_ListMap$Node__f__init;
});
$c_sci_ListMap$Node.prototype.last__O = (function() {
  return $ct_T2__O__O__(new $c_T2(), this.sci_ListMap$Node__f_key, this.sci_ListMap$Node__f__value);
});
$c_sci_ListMap$Node.prototype.removed__O__sci_MapOps = (function(key) {
  return $p_sci_ListMap$Node__removeInternal__O__sci_ListMap__sci_List__sci_ListMap(this, key, this, $m_sci_Nil$());
});
$c_sci_ListMap$Node.prototype.updated__O__O__sci_MapOps = (function(key, value) {
  return this.updated__O__O__sci_ListMap(key, value);
});
function $isArrayOf_sci_ListMap$Node(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ListMap$Node)));
}
export { $isArrayOf_sci_ListMap$Node as $isArrayOf_sci_ListMap$Node };
var $d_sci_ListMap$Node = new $TypeData().initClass($c_sci_ListMap$Node, "scala.collection.immutable.ListMap$Node", ({
  sci_ListMap$Node: 1,
  sci_ListMap: 1,
  sci_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  sci_Map: 1,
  sci_Iterable: 1,
  sci_MapOps: 1,
  sci_SeqMap: 1,
  sc_SeqMap: 1,
  sci_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedMapOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ListMap$Node as $d_sci_ListMap$Node };
/** @constructor */
function $c_sci_NumericRange$Exclusive(start, end, step, num) {
  this.sci_NumericRange__f_length = 0;
  this.sci_NumericRange__f_isEmpty = false;
  this.sci_NumericRange__f_hashCode = 0;
  this.sci_NumericRange__f_start = null;
  this.sci_NumericRange__f_end = null;
  this.sci_NumericRange__f_step = null;
  this.sci_NumericRange__f_isInclusive = false;
  this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = null;
  this.sci_NumericRange__f_bitmap$0 = 0;
  this.sci_NumericRange$Exclusive__f_num = null;
  this.sci_NumericRange$Exclusive__f_num = num;
  $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(this, start, end, step, false, num);
}
export { $c_sci_NumericRange$Exclusive as $c_sci_NumericRange$Exclusive };
$c_sci_NumericRange$Exclusive.prototype = new $h_sci_NumericRange();
$c_sci_NumericRange$Exclusive.prototype.constructor = $c_sci_NumericRange$Exclusive;
/** @constructor */
function $h_sci_NumericRange$Exclusive() {
}
export { $h_sci_NumericRange$Exclusive as $h_sci_NumericRange$Exclusive };
$h_sci_NumericRange$Exclusive.prototype = $c_sci_NumericRange$Exclusive.prototype;
$c_sci_NumericRange$Exclusive.prototype.copy__O__O__O__sci_NumericRange$Exclusive = (function(start, end, step) {
  $m_sci_NumericRange$();
  var num = this.sci_NumericRange$Exclusive__f_num;
  return new $c_sci_NumericRange$Exclusive(start, end, step, num);
});
$c_sci_NumericRange$Exclusive.prototype.copy__O__O__O__sci_NumericRange = (function(start, end, step) {
  return this.copy__O__O__O__sci_NumericRange$Exclusive(start, end, step);
});
var $d_sci_NumericRange$Exclusive = new $TypeData().initClass($c_sci_NumericRange$Exclusive, "scala.collection.immutable.NumericRange$Exclusive", ({
  sci_NumericRange$Exclusive: 1,
  sci_NumericRange: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_NumericRange$Exclusive as $d_sci_NumericRange$Exclusive };
/** @constructor */
function $c_sci_NumericRange$Inclusive(start, end, step, num) {
  this.sci_NumericRange__f_length = 0;
  this.sci_NumericRange__f_isEmpty = false;
  this.sci_NumericRange__f_hashCode = 0;
  this.sci_NumericRange__f_start = null;
  this.sci_NumericRange__f_end = null;
  this.sci_NumericRange__f_step = null;
  this.sci_NumericRange__f_isInclusive = false;
  this.sci_NumericRange__f_scala$collection$immutable$NumericRange$$num = null;
  this.sci_NumericRange__f_bitmap$0 = 0;
  this.sci_NumericRange$Inclusive__f_num = null;
  this.sci_NumericRange$Inclusive__f_num = num;
  $ct_sci_NumericRange__O__O__O__Z__s_math_Integral__(this, start, end, step, true, num);
}
export { $c_sci_NumericRange$Inclusive as $c_sci_NumericRange$Inclusive };
$c_sci_NumericRange$Inclusive.prototype = new $h_sci_NumericRange();
$c_sci_NumericRange$Inclusive.prototype.constructor = $c_sci_NumericRange$Inclusive;
/** @constructor */
function $h_sci_NumericRange$Inclusive() {
}
export { $h_sci_NumericRange$Inclusive as $h_sci_NumericRange$Inclusive };
$h_sci_NumericRange$Inclusive.prototype = $c_sci_NumericRange$Inclusive.prototype;
$c_sci_NumericRange$Inclusive.prototype.copy__O__O__O__sci_NumericRange$Inclusive = (function(start, end, step) {
  $m_sci_NumericRange$();
  var num = this.sci_NumericRange$Inclusive__f_num;
  return new $c_sci_NumericRange$Inclusive(start, end, step, num);
});
$c_sci_NumericRange$Inclusive.prototype.copy__O__O__O__sci_NumericRange = (function(start, end, step) {
  return this.copy__O__O__O__sci_NumericRange$Inclusive(start, end, step);
});
var $d_sci_NumericRange$Inclusive = new $TypeData().initClass($c_sci_NumericRange$Inclusive, "scala.collection.immutable.NumericRange$Inclusive", ({
  sci_NumericRange$Inclusive: 1,
  sci_NumericRange: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_NumericRange$Inclusive as $d_sci_NumericRange$Inclusive };
/** @constructor */
function $c_sci_Range$Exclusive(start, end, step) {
  this.sci_Range__f_start = 0;
  this.sci_Range__f_end = 0;
  this.sci_Range__f_step = 0;
  this.sci_Range__f_isEmpty = false;
  this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements = 0;
  this.sci_Range__f_scala$collection$immutable$Range$$lastElement = 0;
  $ct_sci_Range__I__I__I__(this, start, end, step);
}
export { $c_sci_Range$Exclusive as $c_sci_Range$Exclusive };
$c_sci_Range$Exclusive.prototype = new $h_sci_Range();
$c_sci_Range$Exclusive.prototype.constructor = $c_sci_Range$Exclusive;
/** @constructor */
function $h_sci_Range$Exclusive() {
}
export { $h_sci_Range$Exclusive as $h_sci_Range$Exclusive };
$h_sci_Range$Exclusive.prototype = $c_sci_Range$Exclusive.prototype;
$c_sci_Range$Exclusive.prototype.isInclusive__Z = (function() {
  return false;
});
var $d_sci_Range$Exclusive = new $TypeData().initClass($c_sci_Range$Exclusive, "scala.collection.immutable.Range$Exclusive", ({
  sci_Range$Exclusive: 1,
  sci_Range: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Range$Exclusive as $d_sci_Range$Exclusive };
/** @constructor */
function $c_sci_Range$Inclusive(start, end, step) {
  this.sci_Range__f_start = 0;
  this.sci_Range__f_end = 0;
  this.sci_Range__f_step = 0;
  this.sci_Range__f_isEmpty = false;
  this.sci_Range__f_scala$collection$immutable$Range$$numRangeElements = 0;
  this.sci_Range__f_scala$collection$immutable$Range$$lastElement = 0;
  $ct_sci_Range__I__I__I__(this, start, end, step);
}
export { $c_sci_Range$Inclusive as $c_sci_Range$Inclusive };
$c_sci_Range$Inclusive.prototype = new $h_sci_Range();
$c_sci_Range$Inclusive.prototype.constructor = $c_sci_Range$Inclusive;
/** @constructor */
function $h_sci_Range$Inclusive() {
}
export { $h_sci_Range$Inclusive as $h_sci_Range$Inclusive };
$h_sci_Range$Inclusive.prototype = $c_sci_Range$Inclusive.prototype;
$c_sci_Range$Inclusive.prototype.isInclusive__Z = (function() {
  return true;
});
var $d_sci_Range$Inclusive = new $TypeData().initClass($c_sci_Range$Inclusive, "scala.collection.immutable.Range$Inclusive", ({
  sci_Range$Inclusive: 1,
  sci_Range: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Range$Inclusive as $d_sci_Range$Inclusive };
function $ct_sci_Vector__AO__($thiz, prefix1) {
  $thiz.sci_Vector__f_prefix1 = prefix1;
  return $thiz;
}
export { $ct_sci_Vector__AO__ as $ct_sci_Vector__AO__ };
/** @constructor */
function $c_sci_Vector() {
  this.sci_Vector__f_prefix1 = null;
}
export { $c_sci_Vector as $c_sci_Vector };
$c_sci_Vector.prototype = new $h_sci_AbstractSeq();
$c_sci_Vector.prototype.constructor = $c_sci_Vector;
/** @constructor */
function $h_sci_Vector() {
}
export { $h_sci_Vector as $h_sci_Vector };
$h_sci_Vector.prototype = $c_sci_Vector.prototype;
$c_sci_Vector.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sci_Vector.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_Vector.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that);
});
$c_sci_Vector.prototype.partition__F1__T2 = (function(p) {
  return $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
});
$c_sci_Vector.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sci_Vector.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sci_Vector.prototype.filter__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Vector(pred, false);
});
$c_sci_Vector.prototype.filterNot__F1__O = (function(pred) {
  return this.filterImpl__F1__Z__sci_Vector(pred, true);
});
$c_sci_Vector.prototype.toIndexedSeq__sci_IndexedSeq = (function() {
  return this;
});
$c_sci_Vector.prototype.canEqual__O__Z = (function(that) {
  return $f_sci_IndexedSeq__canEqual__O__Z(this, that);
});
$c_sci_Vector.prototype.sameElements__sc_IterableOnce__Z = (function(o) {
  return $f_sci_IndexedSeq__sameElements__sc_IterableOnce__Z(this, o);
});
$c_sci_Vector.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sci_Vector.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sci_Vector.prototype.foldRight__O__F2__O = (function(z, op) {
  return $p_sc_IndexedSeqOps__foldr__I__I__O__F2__O(this, 0, this.length__I(), z, op);
});
$c_sci_Vector.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sci_Vector.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_sci_Vector.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sci_Vector.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sci_Vector.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_sci_Vector.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_Vector$();
});
$c_sci_Vector.prototype.length__I = (function() {
  return ((this instanceof $c_sci_BigVector) ? this.sci_BigVector__f_length0 : this.sci_Vector__f_prefix1.u.length);
});
$c_sci_Vector.prototype.iterator__sc_Iterator = (function() {
  return (($m_sci_Vector0$() === this) ? $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$emptyIterator : new $c_sci_NewVectorIterator(this, this.length__I(), this.vectorSliceCount__I()));
});
$c_sci_Vector.prototype.filterImpl__F1__Z__sci_Vector = (function(pred, isFlipped) {
  var i = 0;
  var len = this.sci_Vector__f_prefix1.u.length;
  while ((i !== len)) {
    if (((!(!pred.apply__O__O(this.sci_Vector__f_prefix1.u[i]))) === isFlipped)) {
      var bitmap = 0;
      var j = ((1 + i) | 0);
      while ((j < len)) {
        if (((!(!pred.apply__O__O(this.sci_Vector__f_prefix1.u[j]))) !== isFlipped)) {
          bitmap = (bitmap | (1 << j));
        }
        j = ((1 + j) | 0);
      }
      var $x_1 = i;
      var i$1 = bitmap;
      var newLen = (($x_1 + $m_jl_Integer$().bitCount__I__I(i$1)) | 0);
      if ((this instanceof $c_sci_BigVector)) {
        var b = new $c_sci_VectorBuilder();
        var k = 0;
        while ((k < i)) {
          b.addOne__O__sci_VectorBuilder(this.sci_Vector__f_prefix1.u[k]);
          k = ((1 + k) | 0);
        }
        k = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k) & bitmap) !== 0)) {
            b.addOne__O__sci_VectorBuilder(this.sci_Vector__f_prefix1.u[k]);
            i = ((1 + i) | 0);
          }
          k = ((1 + k) | 0);
        }
        this.foreachRest__F1__V(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((pred, isFlipped, b) => ((v$2$2) => (((!(!pred.apply__O__O(v$2$2))) !== isFlipped) ? b.addOne__O__sci_VectorBuilder(v$2$2) : (void 0))))(pred, isFlipped, b)));
        return b.result__sci_Vector();
      } else {
        if ((newLen === 0)) {
          return $m_sci_Vector0$();
        }
        var newData = new $ac_O(newLen);
        var src = this.sci_Vector__f_prefix1;
        var length = i;
        src.copyTo(0, newData, 0, length);
        var k$2 = ((1 + i) | 0);
        while ((i !== newLen)) {
          if ((((1 << k$2) & bitmap) !== 0)) {
            newData.u[i] = this.sci_Vector__f_prefix1.u[k$2];
            i = ((1 + i) | 0);
          }
          k$2 = ((1 + k$2) | 0);
        }
        return new $c_sci_Vector1(newData);
      }
    }
    i = ((1 + i) | 0);
  }
  if ((this instanceof $c_sci_BigVector)) {
    var b$2 = new $c_sci_VectorBuilder();
    b$2.initFrom__AO__V(this.sci_Vector__f_prefix1);
    this.foreachRest__F1__V(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((v$2$2$1) => (((!(!pred.apply__O__O(v$2$2$1))) !== isFlipped) ? b$2.addOne__O__sci_VectorBuilder(v$2$2$1) : (void 0)))));
    return b$2.result__sci_Vector();
  } else {
    return this;
  }
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__sci_Vector = (function(suffix) {
  var k = suffix.knownSize__I();
  return ((k === 0) ? this : ((k < 0) ? $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix) : this.appendedAll0__sc_IterableOnce__I__sci_Vector(suffix, k)));
});
$c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var tinyAppendLimit = ((4 + this.vectorSliceCount__I()) | 0);
  if ((k < tinyAppendLimit)) {
    var v = new $c_sr_ObjectRef(this);
    if ($is_sci_Iterable(suffix)) {
      suffix.foreach__F1__V(new $c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((x$2$2) => {
        v.sr_ObjectRef__f_elem = v.sr_ObjectRef__f_elem.appended__O__sci_Vector(x$2$2);
      })));
    } else {
      var this$2 = suffix.iterator__sc_Iterator();
      while (this$2.hasNext__Z()) {
        var x0 = this$2.next__O();
        v.sr_ObjectRef__f_elem = v.sr_ObjectRef__f_elem.appended__O__sci_Vector(x0);
      }
    }
    return v.sr_ObjectRef__f_elem;
  } else if (((this.length__I() < ((k >>> 5) | 0)) && (suffix instanceof $c_sci_Vector))) {
    var v$2 = suffix;
    var this$3 = new $c_sc_IndexedSeqView$Id(this);
    var ri = $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$3);
    while ((ri.sc_IndexedSeqView$IndexedSeqViewReverseIterator__f_scala$collection$IndexedSeqView$IndexedSeqViewReverseIterator$$remainder > 0)) {
      v$2 = v$2.prepended__O__sci_Vector(ri.next__O());
    }
    return v$2;
  } else {
    return (((this.length__I() < (((-64) + k) | 0)) && (suffix instanceof $c_sci_Vector)) ? new $c_sci_VectorBuilder().alignTo__I__sci_Vector__sci_VectorBuilder(this.length__I(), suffix).addAll__sc_IterableOnce__sci_VectorBuilder(this).addAll__sc_IterableOnce__sci_VectorBuilder(suffix).result__sci_Vector() : new $c_sci_VectorBuilder().initFrom__sci_Vector__sci_VectorBuilder(this).addAll__sc_IterableOnce__sci_VectorBuilder(suffix).result__sci_Vector());
  }
});
$c_sci_Vector.prototype.className__T = (function() {
  return "Vector";
});
$c_sci_Vector.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  return this.iterator__sc_Iterator().copyToArray__O__I__I__I(xs, start, len);
});
$c_sci_Vector.prototype.toVector__sci_Vector = (function() {
  return this;
});
$c_sci_Vector.prototype.applyPreferredMaxLength__I = (function() {
  return $m_sci_Vector$().sci_Vector$__f_scala$collection$immutable$Vector$$defaultApplyPreferredMaxLength;
});
$c_sci_Vector.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + this.length__I()) | 0));
});
$c_sci_Vector.prototype.head__O = (function() {
  if ((this.sci_Vector__f_prefix1.u.length === 0)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.head");
  } else {
    return this.sci_Vector__f_prefix1.u[0];
  }
});
$c_sci_Vector.prototype.last__O = (function() {
  if ((this instanceof $c_sci_BigVector)) {
    var suffix = this.sci_BigVector__f_suffix1;
    if ((suffix.u.length === 0)) {
      throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty.tail");
    } else {
      return suffix.u[(((-1) + suffix.u.length) | 0)];
    }
  } else {
    return this.sci_Vector__f_prefix1.u[(((-1) + this.sci_Vector__f_prefix1.u.length) | 0)];
  }
});
$c_sci_Vector.prototype.foreach__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 0;
  while ((i < c)) {
    var $x_1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    var sign = (a >> 31);
    $x_1.foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - (((a ^ sign) - sign) | 0)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0);
  }
});
$c_sci_Vector.prototype.view__sc_SeqView = (function() {
  return new $c_sc_IndexedSeqView$Id(this);
});
$c_sci_Vector.prototype.dropRight__I__O = (function(n) {
  var until = ((this.length__I() - ((n > 0) ? n : 0)) | 0);
  return this.slice__I__I__sci_Vector(0, until);
});
$c_sci_Vector.prototype.drop__I__O = (function(n) {
  var until = this.length__I();
  return this.slice__I__I__sci_Vector(n, until);
});
$c_sci_Vector.prototype.take__I__O = (function(n) {
  return this.slice__I__I__sci_Vector(0, n);
});
$c_sci_Vector.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_Vector(suffix);
});
$c_sci_Vector.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_Vector$();
});
function $isArrayOf_sci_Vector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector)));
}
export { $isArrayOf_sci_Vector as $isArrayOf_sci_Vector };
/** @constructor */
function $c_scm_ArraySeq() {
}
export { $c_scm_ArraySeq as $c_scm_ArraySeq };
$c_scm_ArraySeq.prototype = new $h_scm_AbstractSeq();
$c_scm_ArraySeq.prototype.constructor = $c_scm_ArraySeq;
/** @constructor */
function $h_scm_ArraySeq() {
}
export { $h_scm_ArraySeq as $h_scm_ArraySeq };
$h_scm_ArraySeq.prototype = $c_scm_ArraySeq.prototype;
$c_scm_ArraySeq.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_scm_ArraySeq.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_scm_ArraySeq.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_scm_ArraySeq.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ArraySeq.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_ArraySeq.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ArraySeq.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ArraySeq.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_scm_ArraySeq.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_scm_ArraySeq.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_scm_ArraySeq.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_scm_ArraySeq.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_ArraySeq.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_scm_ArraySeq.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_ArraySeq.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_scm_ArraySeq.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_ArraySeq.prototype.lengthCompare__I__I = (function(len) {
  var x = this.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_ArraySeq.prototype.knownSize__I = (function() {
  return this.length__I();
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged;
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__scm_ArraySeq = (function(coll) {
  var evidence$1 = this.elemTag__s_reflect_ClassTag();
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.runtimeClass__jl_Class();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $d_C.getClassOf());
  jsElems = [];
  coll.knownSize__I();
  var it = coll.iterator__sc_Iterator();
  while (it.hasNext__Z()) {
    var elem = it.next__O();
    var unboxedElem = (isCharArrayBuilder ? $uC(elem) : ((elem === null) ? elementClass.data.zero : elem));
    jsElems.push(unboxedElem);
  }
  var $x_1 = $m_scm_ArraySeq$();
  var elemRuntimeClass = ((elementClass === $d_V.getClassOf()) ? $d_jl_Void.getClassOf() : (((elementClass === $d_sr_Null$.getClassOf()) || (elementClass === $d_sr_Nothing$.getClassOf())) ? $d_O.getClassOf() : elementClass));
  return $x_1.make__O__scm_ArraySeq(elemRuntimeClass.data.getArrayOf().wrapArray(jsElems));
});
$c_scm_ArraySeq.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $m_scm_ArraySeq$().newBuilder__s_reflect_ClassTag__scm_Builder(this.elemTag__s_reflect_ClassTag());
});
$c_scm_ArraySeq.prototype.className__T = (function() {
  return "ArraySeq";
});
$c_scm_ArraySeq.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.length__I();
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.array__O(), 0, xs, start, copied);
  }
  return copied;
});
$c_scm_ArraySeq.prototype.equals__O__Z = (function(other) {
  if ((other instanceof $c_scm_ArraySeq)) {
    var xs = this.array__O();
    var $x_1 = $m_jl_reflect_Array$().getLength__O__I(xs);
    var xs$1 = other.array__O();
    if (($x_1 !== $m_jl_reflect_Array$().getLength__O__I(xs$1))) {
      return false;
    }
  }
  return $f_sc_Seq__equals__O__Z(this, other);
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__scm_ArraySeq = (function(ord) {
  var $x_2 = $m_scm_ArraySeq$();
  var $x_1 = $m_sc_ArrayOps$();
  var xs = this.array__O();
  return $x_2.make__O__scm_ArraySeq($x_1.sorted$extension__O__s_math_Ordering__O(xs, ord));
});
$c_scm_ArraySeq.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__scm_ArraySeq(ord);
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll);
});
$c_scm_ArraySeq.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return this.fromSpecific__sc_IterableOnce__scm_ArraySeq(coll);
});
$c_scm_ArraySeq.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArraySeq$().scm_ArraySeq$__f_untagged;
});
function $isArrayOf_scm_ArraySeq(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq)));
}
export { $isArrayOf_scm_ArraySeq as $isArrayOf_scm_ArraySeq };
/** @constructor */
function $c_Lcats_data_NonEmptyListInstances$$anon$2() {
  this.Lcats_NonEmptyReducible__f_G = null;
  $ct_Lcats_NonEmptyReducible__Lcats_Foldable__(this, ($m_Lcats_UnorderedFoldable$(), $m_Lcats_instances_package$list$().Lcats_instances_package$list$__f_catsStdInstancesForList));
}
export { $c_Lcats_data_NonEmptyListInstances$$anon$2 as $c_Lcats_data_NonEmptyListInstances$$anon$2 };
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype = new $h_Lcats_NonEmptyReducible();
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.constructor = $c_Lcats_data_NonEmptyListInstances$$anon$2;
/** @constructor */
function $h_Lcats_data_NonEmptyListInstances$$anon$2() {
}
export { $h_Lcats_data_NonEmptyListInstances$$anon$2 as $h_Lcats_data_NonEmptyListInstances$$anon$2 };
$h_Lcats_data_NonEmptyListInstances$$anon$2.prototype = $c_Lcats_data_NonEmptyListInstances$$anon$2.prototype;
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return fa.map__F1__Lcats_data_NonEmptyList(f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.unit__O = (function() {
  $m_Lcats_data_NonEmptyList$();
  $m_Lcats_data_NonEmptyList$();
  var tail = $m_sci_Nil$();
  return new $c_Lcats_data_NonEmptyList((void 0), tail);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.foldMap__Lcats_data_NonEmptyList__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.Lcats_data_NonEmptyList__f_tail;
  var elem = fa.Lcats_data_NonEmptyList__f_head;
  var this$2 = new $c_sci_$colon$colon(elem, this$1);
  var this$3 = new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this$2);
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$3, f));
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.tailRecM__O__F1__Lcats_data_NonEmptyList = (function(a, f) {
  var buf = new $c_scm_ListBuffer();
  $s_Lcats_data_NonEmptyListInstances__cats$data$NonEmptyListInstances$$anon$2$$_$go$2__scm_ListBuffer__F1__Lcats_data_NonEmptyList__V(buf, f, f.apply__O__O(a));
  return $m_Lcats_data_NonEmptyList$().fromListUnsafe__sci_List__Lcats_data_NonEmptyList(buf.toList__sci_List());
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.combineK__O__O__O = (function(x, y) {
  return x.concatNel__Lcats_data_NonEmptyList__Lcats_data_NonEmptyList(y);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.split__O__T2 = (function(fa) {
  var _1 = fa.Lcats_data_NonEmptyList__f_head;
  var _2 = fa.Lcats_data_NonEmptyList__f_tail;
  return $ct_T2__O__O__(new $c_T2(), _1, _2);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.map__O__F1__O = (function(fa, f) {
  return fa.map__F1__Lcats_data_NonEmptyList(f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.pure__O__O = (function(x) {
  $m_Lcats_data_NonEmptyList$();
  $m_Lcats_data_NonEmptyList$();
  var tail = $m_sci_Nil$();
  return new $c_Lcats_data_NonEmptyList(x, tail);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.flatMap__O__F1__O = (function(fa, f) {
  return fa.flatMap__F1__Lcats_data_NonEmptyList(f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return fa.traverse__F1__Lcats_Applicative__O(f, evidence$1);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  return fa.foldLeft__O__F2__O(b, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  return fa.foldRight__Lcats_Eval__F2__Lcats_Eval(lb, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__Lcats_data_NonEmptyList__F1__Lcats_kernel_Monoid__O(fa, f, B);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.tailRecM__O__F1__O = (function(a, f) {
  return this.tailRecM__O__F1__Lcats_data_NonEmptyList(a, f);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.exists__O__F1__Z = (function(fa, p) {
  return fa.exists__F1__Z(p);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.toList__O__sci_List = (function(fa) {
  var this$1 = fa.Lcats_data_NonEmptyList__f_tail;
  var elem = fa.Lcats_data_NonEmptyList__f_head;
  return new $c_sci_$colon$colon(elem, this$1);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.toIterable__O__sc_Iterable = (function(fa) {
  var this$1 = fa.Lcats_data_NonEmptyList__f_tail;
  var elem = fa.Lcats_data_NonEmptyList__f_head;
  return new $c_sci_$colon$colon(elem, this$1);
});
$c_Lcats_data_NonEmptyListInstances$$anon$2.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_NonEmptyAlternative$$anon$1(evidence$1, this);
});
var $d_Lcats_data_NonEmptyListInstances$$anon$2 = new $TypeData().initClass($c_Lcats_data_NonEmptyListInstances$$anon$2, "cats.data.NonEmptyListInstances$$anon$2", ({
  Lcats_data_NonEmptyListInstances$$anon$2: 1,
  Lcats_NonEmptyReducible: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_Reducible: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_data_NonEmptyListInstances$$anon$2 as $d_Lcats_data_NonEmptyListInstances$$anon$2 };
/** @constructor */
function $c_Lcats_data_NonEmptyVectorInstances$$anon$1() {
  this.Lcats_NonEmptyReducible__f_G = null;
  $ct_Lcats_NonEmptyReducible__Lcats_Foldable__(this, ($m_Lcats_UnorderedFoldable$(), $m_Lcats_instances_package$vector$().Lcats_instances_package$vector$__f_catsStdInstancesForVector));
}
export { $c_Lcats_data_NonEmptyVectorInstances$$anon$1 as $c_Lcats_data_NonEmptyVectorInstances$$anon$1 };
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype = new $h_Lcats_NonEmptyReducible();
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.constructor = $c_Lcats_data_NonEmptyVectorInstances$$anon$1;
/** @constructor */
function $h_Lcats_data_NonEmptyVectorInstances$$anon$1() {
}
export { $h_Lcats_data_NonEmptyVectorInstances$$anon$1 as $h_Lcats_data_NonEmptyVectorInstances$$anon$1 };
$h_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype = $c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype;
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, g) {
  return this.map__O__F1__O(fa, f);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.unit__O = (function() {
  return this.pure__O__O((void 0));
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.algebra__Lcats_kernel_Semigroup = (function() {
  return new $c_Lcats_SemigroupK$$anon$1(this);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return $f_Lcats_FlatMap__flatten__O__O(this, ffa);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return $f_Lcats_FlatMap__ap__O__O__O(this, ff, fa);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2__O__O__F2__O(this, fa, fb, f);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return $f_Lcats_FlatMap__map2Eval__O__Lcats_Eval__F2__Lcats_Eval(this, fa, fb, f);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.split__sci_Vector__T2 = (function(fa) {
  $m_Lcats_data_NonEmptyVector$();
  var _1 = fa.head__O();
  $m_Lcats_data_NonEmptyVector$();
  var _2 = fa.tail__sci_Vector();
  return $ct_T2__O__O__(new $c_T2(), _1, _2);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.size__sci_Vector__J = (function(fa) {
  $m_Lcats_data_NonEmptyVector$();
  var value = fa.length__I();
  var hi = (value >> 31);
  return new $c_RTLong(value, hi);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.traverse__sci_Vector__F1__Lcats_Applicative__O = (function(fa, f, G) {
  var $x_1 = f.apply__O__O(($m_Lcats_data_NonEmptyVector$(), fa.head__O()));
  var a = new $c_sjsr_AnonFunction0_$$Lambda$92a2e254bbb9c06a0a02fc31abab59c51c18ecc1((() => {
    $m_Lcats_UnorderedFoldable$();
    var instance = $m_Lcats_instances_package$vector$().Lcats_instances_package$vector$__f_catsStdInstancesForVector;
    return instance.traverse__O__F1__Lcats_Applicative__O(($m_Lcats_data_NonEmptyVector$(), fa.tail__sci_Vector()), f, G);
  }));
  return G.map2Eval__O__Lcats_Eval__F2__Lcats_Eval($x_1, new $c_Lcats_Always(a), new $c_sjsr_AnonFunction2_$$Lambda$1a8112ad760bd31301975c22c9537bb38341e0c2(((_$4, _$5) => new $c_Lcats_data_NonEmptyVector(($m_Lcats_data_NonEmptyVector$(), _$5.prepended__O__sci_Vector(_$4)))))).value__O();
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  var this$1 = fa.iterator__sc_Iterator();
  return B.combineAll__sc_IterableOnce__O(new $c_sc_Iterator$$anon$9(this$1, f));
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.tailRecM__O__F1__sci_Vector = (function(a, f) {
  var buf = new $c_sci_VectorBuilder();
  var ev$6 = f.apply__O__O(a);
  $s_Lcats_data_NonEmptyVectorInstances__cats$data$NonEmptyVectorInstances$$anon$1$$_$go$1__sci_VectorBuilder__F1__sci_Vector__V(buf, f, ((ev$6 === null) ? null : ev$6.Lcats_data_NonEmptyVector__f_toVector));
  return $m_Lcats_data_NonEmptyVector$().fromVectorUnsafe__sci_Vector__sci_Vector(buf.result__sci_Vector());
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.combineK__O__O__O = (function(x, y) {
  var a = ((x === null) ? null : x.Lcats_data_NonEmptyVector__f_toVector);
  var b = ((y === null) ? null : y.Lcats_data_NonEmptyVector__f_toVector);
  $m_Lcats_data_NonEmptyVector$();
  return new $c_Lcats_data_NonEmptyVector(a.appendedAll__sc_IterableOnce__sci_Vector(b));
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.split__O__T2 = (function(fa) {
  return this.split__sci_Vector__T2(((fa === null) ? null : fa.Lcats_data_NonEmptyVector__f_toVector));
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.size__O__J = (function(fa) {
  return this.size__sci_Vector__J(((fa === null) ? null : fa.Lcats_data_NonEmptyVector__f_toVector));
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  var fa$1 = ((fa === null) ? null : fa.Lcats_data_NonEmptyVector__f_toVector);
  $m_Lcats_data_NonEmptyVector$();
  return new $c_Lcats_data_NonEmptyVector(fa$1.map__F1__O(f));
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.pure__O__O = (function(x) {
  return new $c_Lcats_data_NonEmptyVector($m_Lcats_data_NonEmptyVector$().one__O__sci_Vector(x));
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.flatMap__O__F1__O = (function(fa, f) {
  var fa$1 = ((fa === null) ? null : fa.Lcats_data_NonEmptyVector__f_toVector);
  return new $c_Lcats_data_NonEmptyVector($m_Lcats_data_NonEmptyVector$().flatMap$extension__sci_Vector__F1__sci_Vector(fa$1, f));
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return this.traverse__sci_Vector__F1__Lcats_Applicative__O(((fa === null) ? null : fa.Lcats_data_NonEmptyVector__f_toVector), f, evidence$1);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.foldLeft__O__O__F2__O = (function(fa, b, f) {
  var fa$1 = ((fa === null) ? null : fa.Lcats_data_NonEmptyVector__f_toVector);
  $m_Lcats_data_NonEmptyVector$();
  return $f_sc_IterableOnceOps__foldLeft__O__F2__O(fa$1, b, f);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, lb, f) {
  var fa$1 = ((fa === null) ? null : fa.Lcats_data_NonEmptyVector__f_toVector);
  return $m_Lcats_data_NonEmptyVector$().foldRight$extension__sci_Vector__Lcats_Eval__F2__Lcats_Eval(fa$1, lb, f);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return this.foldMap__sci_Vector__F1__Lcats_kernel_Monoid__O(((fa === null) ? null : fa.Lcats_data_NonEmptyVector__f_toVector), f, B);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  return new $c_Lcats_data_NonEmptyVector(this.tailRecM__O__F1__sci_Vector(a, f));
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.exists__O__F1__Z = (function(fa, p) {
  var fa$1 = ((fa === null) ? null : fa.Lcats_data_NonEmptyVector__f_toVector);
  $m_Lcats_data_NonEmptyVector$();
  return $f_sc_IterableOnceOps__exists__F1__Z(fa$1, p);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  var fa$1 = ((fa === null) ? null : fa.Lcats_data_NonEmptyVector__f_toVector);
  return $m_sci_Nil$().prependedAll__sc_IterableOnce__sci_List(fa$1);
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  var fa$1 = ((fa === null) ? null : fa.Lcats_data_NonEmptyVector__f_toVector);
  return fa$1;
});
$c_Lcats_data_NonEmptyVectorInstances$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_NonEmptyAlternative$$anon$1(evidence$1, this);
});
var $d_Lcats_data_NonEmptyVectorInstances$$anon$1 = new $TypeData().initClass($c_Lcats_data_NonEmptyVectorInstances$$anon$1, "cats.data.NonEmptyVectorInstances$$anon$1", ({
  Lcats_data_NonEmptyVectorInstances$$anon$1: 1,
  Lcats_NonEmptyReducible: 1,
  Ljava_io_Serializable: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_Reducible: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_SemigroupK: 1,
  Lcats_NonEmptyAlternative: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Align: 1
}));
export { $d_Lcats_data_NonEmptyVectorInstances$$anon$1 as $d_Lcats_data_NonEmptyVectorInstances$$anon$1 };
/** @constructor */
function $c_sci_ArraySeq$ofBoolean(unsafeArray) {
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = null;
  this.sci_ArraySeq$ofBoolean__f_unsafeArray = unsafeArray;
}
export { $c_sci_ArraySeq$ofBoolean as $c_sci_ArraySeq$ofBoolean };
$c_sci_ArraySeq$ofBoolean.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofBoolean.prototype.constructor = $c_sci_ArraySeq$ofBoolean;
/** @constructor */
function $h_sci_ArraySeq$ofBoolean() {
}
export { $h_sci_ArraySeq$ofBoolean as $h_sci_ArraySeq$ofBoolean };
$h_sci_ArraySeq$ofBoolean.prototype = $c_sci_ArraySeq$ofBoolean.prototype;
$c_sci_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray.u.length;
});
$c_sci_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofBoolean)) {
    var a = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var b = that.sci_ArraySeq$ofBoolean__f_unsafeArray;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.sci_ArraySeq$ofBoolean__f_unsafeArray.u.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Boolean$())) {
    var this$1 = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var a = this$1.clone__O();
    var this$2 = $m_s_util_Sorting$();
    var evidence$3 = $m_s_math_Ordering$Boolean$();
    this$2.stableSort__O__I__I__s_math_Ordering__V(a, 0, a.u.length, evidence$3);
    return new $c_sci_ArraySeq$ofBoolean(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.sci_ArraySeq$ofBoolean__f_unsafeArray);
});
$c_sci_ArraySeq$ofBoolean.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if (((typeof elem) === "boolean")) {
    var x2 = (!(!elem));
    var xs = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    if (((index < 0) || (index >= xs.u.length))) {
      throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + xs.u.length) | 0));
    }
    var len = xs.u.length;
    var destination = new $ac_Z(len);
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.u[index] = x2;
    return new $c_sci_ArraySeq$ofBoolean(destination);
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem);
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "boolean")) {
    var x2 = (!(!elem));
    var xs = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.u.length) | 0);
    var this$4 = $objectGetClass(xs);
    var that = this$4.data.getComponentType();
    if ($d_Z.isAssignableFrom(that.data)) {
      var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
    } else {
      var dest = new $ac_Z(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, xs.u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, xs.u.length, x2);
    return new $c_sci_ArraySeq$ofBoolean(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "boolean")) {
    var x2 = (!(!elem));
    var xs = this.sci_ArraySeq$ofBoolean__f_unsafeArray;
    var len = ((1 + xs.u.length) | 0);
    var dest = new $ac_Z(len);
    dest.u[0] = x2;
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, xs.u.length);
    return new $c_sci_ArraySeq$ofBoolean(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(i) {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray.u[i];
});
$c_sci_ArraySeq$ofBoolean.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofBoolean.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofBoolean.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem);
});
$c_sci_ArraySeq$ofBoolean.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var i = (v1 | 0);
  return this.apply$mcZI$sp__I__Z(i);
});
$c_sci_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i);
});
$c_sci_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$();
});
$c_sci_ArraySeq$ofBoolean.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofBoolean__f_unsafeArray;
});
function $isArrayOf_sci_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofBoolean)));
}
export { $isArrayOf_sci_ArraySeq$ofBoolean as $isArrayOf_sci_ArraySeq$ofBoolean };
var $d_sci_ArraySeq$ofBoolean = new $TypeData().initClass($c_sci_ArraySeq$ofBoolean, "scala.collection.immutable.ArraySeq$ofBoolean", ({
  sci_ArraySeq$ofBoolean: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ArraySeq$ofBoolean as $d_sci_ArraySeq$ofBoolean };
/** @constructor */
function $c_sci_ArraySeq$ofByte(unsafeArray) {
  this.sci_ArraySeq$ofByte__f_unsafeArray = null;
  this.sci_ArraySeq$ofByte__f_unsafeArray = unsafeArray;
}
export { $c_sci_ArraySeq$ofByte as $c_sci_ArraySeq$ofByte };
$c_sci_ArraySeq$ofByte.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofByte.prototype.constructor = $c_sci_ArraySeq$ofByte;
/** @constructor */
function $h_sci_ArraySeq$ofByte() {
}
export { $h_sci_ArraySeq$ofByte as $h_sci_ArraySeq$ofByte };
$h_sci_ArraySeq$ofByte.prototype = $c_sci_ArraySeq$ofByte.prototype;
$c_sci_ArraySeq$ofByte.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofByte__f_unsafeArray.u.length;
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__B = (function(i) {
  return this.sci_ArraySeq$ofByte__f_unsafeArray.u[i];
});
$c_sci_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofByte)) {
    var a = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var b = that.sci_ArraySeq$ofByte__f_unsafeArray;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.sci_ArraySeq$ofByte__f_unsafeArray.u.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Byte$())) {
    var this$1 = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AB__V(a);
    return new $c_sci_ArraySeq$ofByte(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.sci_ArraySeq$ofByte__f_unsafeArray);
});
$c_sci_ArraySeq$ofByte.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ($isByte(elem)) {
    var x2 = (elem | 0);
    var xs = this.sci_ArraySeq$ofByte__f_unsafeArray;
    if (((index < 0) || (index >= xs.u.length))) {
      throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + xs.u.length) | 0));
    }
    var len = xs.u.length;
    var destination = new $ac_B(len);
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.u[index] = x2;
    return new $c_sci_ArraySeq$ofByte(destination);
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem);
  }
});
$c_sci_ArraySeq$ofByte.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isByte(elem)) {
    var x2 = (elem | 0);
    var xs = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.u.length) | 0);
    var this$4 = $objectGetClass(xs);
    var that = this$4.data.getComponentType();
    if ($d_B.isAssignableFrom(that.data)) {
      var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
    } else {
      var dest = new $ac_B(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, xs.u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, xs.u.length, x2);
    return new $c_sci_ArraySeq$ofByte(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofByte.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isByte(elem)) {
    var x2 = (elem | 0);
    var xs = this.sci_ArraySeq$ofByte__f_unsafeArray;
    var len = ((1 + xs.u.length) | 0);
    var dest = new $ac_B(len);
    dest.u[0] = x2;
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, xs.u.length);
    return new $c_sci_ArraySeq$ofByte(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofByte.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofByte.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofByte.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem);
});
$c_sci_ArraySeq$ofByte.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B((v1 | 0));
});
$c_sci_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i);
});
$c_sci_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$();
});
$c_sci_ArraySeq$ofByte.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofByte__f_unsafeArray;
});
function $isArrayOf_sci_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofByte)));
}
export { $isArrayOf_sci_ArraySeq$ofByte as $isArrayOf_sci_ArraySeq$ofByte };
var $d_sci_ArraySeq$ofByte = new $TypeData().initClass($c_sci_ArraySeq$ofByte, "scala.collection.immutable.ArraySeq$ofByte", ({
  sci_ArraySeq$ofByte: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ArraySeq$ofByte as $d_sci_ArraySeq$ofByte };
/** @constructor */
function $c_sci_ArraySeq$ofChar(unsafeArray) {
  this.sci_ArraySeq$ofChar__f_unsafeArray = null;
  this.sci_ArraySeq$ofChar__f_unsafeArray = unsafeArray;
}
export { $c_sci_ArraySeq$ofChar as $c_sci_ArraySeq$ofChar };
$c_sci_ArraySeq$ofChar.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofChar.prototype.constructor = $c_sci_ArraySeq$ofChar;
/** @constructor */
function $h_sci_ArraySeq$ofChar() {
}
export { $h_sci_ArraySeq$ofChar as $h_sci_ArraySeq$ofChar };
$h_sci_ArraySeq$ofChar.prototype = $c_sci_ArraySeq$ofChar.prototype;
$c_sci_ArraySeq$ofChar.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofChar__f_unsafeArray.u.length;
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__C = (function(i) {
  return this.sci_ArraySeq$ofChar__f_unsafeArray.u[i];
});
$c_sci_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofChar)) {
    var a = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var b = that.sci_ArraySeq$ofChar__f_unsafeArray;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.sci_ArraySeq$ofChar__f_unsafeArray.u.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Char$())) {
    var this$1 = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AC__V(a);
    return new $c_sci_ArraySeq$ofChar(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.sci_ArraySeq$ofChar__f_unsafeArray);
});
$c_sci_ArraySeq$ofChar.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    var xs = this.sci_ArraySeq$ofChar__f_unsafeArray;
    if (((index < 0) || (index >= xs.u.length))) {
      throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + xs.u.length) | 0));
    }
    var len = xs.u.length;
    var destination = new $ac_C(len);
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.u[index] = x2;
    return new $c_sci_ArraySeq$ofChar(destination);
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem);
  }
});
$c_sci_ArraySeq$ofChar.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    var xs = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.u.length) | 0);
    var this$4 = $objectGetClass(xs);
    var that = this$4.data.getComponentType();
    if ($d_C.isAssignableFrom(that.data)) {
      var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
    } else {
      var dest = new $ac_C(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, xs.u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, xs.u.length, $bC(x2));
    return new $c_sci_ArraySeq$ofChar(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofChar.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $Char)) {
    var x2 = $uC(elem);
    var xs = this.sci_ArraySeq$ofChar__f_unsafeArray;
    var len = ((1 + xs.u.length) | 0);
    var dest = new $ac_C(len);
    dest.u[0] = x2;
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, xs.u.length);
    return new $c_sci_ArraySeq$ofChar(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  return new $c_scm_ArraySeq$ofChar(this.sci_ArraySeq$ofChar__f_unsafeArray).addString__scm_StringBuilder__T__T__T__scm_StringBuilder(sb, start, sep, end);
});
$c_sci_ArraySeq$ofChar.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofChar.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofChar.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem);
});
$c_sci_ArraySeq$ofChar.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C((v1 | 0)));
});
$c_sci_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i));
});
$c_sci_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$();
});
$c_sci_ArraySeq$ofChar.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofChar__f_unsafeArray;
});
function $isArrayOf_sci_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofChar)));
}
export { $isArrayOf_sci_ArraySeq$ofChar as $isArrayOf_sci_ArraySeq$ofChar };
var $d_sci_ArraySeq$ofChar = new $TypeData().initClass($c_sci_ArraySeq$ofChar, "scala.collection.immutable.ArraySeq$ofChar", ({
  sci_ArraySeq$ofChar: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ArraySeq$ofChar as $d_sci_ArraySeq$ofChar };
/** @constructor */
function $c_sci_ArraySeq$ofDouble(unsafeArray) {
  this.sci_ArraySeq$ofDouble__f_unsafeArray = null;
  this.sci_ArraySeq$ofDouble__f_unsafeArray = unsafeArray;
}
export { $c_sci_ArraySeq$ofDouble as $c_sci_ArraySeq$ofDouble };
$c_sci_ArraySeq$ofDouble.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofDouble.prototype.constructor = $c_sci_ArraySeq$ofDouble;
/** @constructor */
function $h_sci_ArraySeq$ofDouble() {
}
export { $h_sci_ArraySeq$ofDouble as $h_sci_ArraySeq$ofDouble };
$h_sci_ArraySeq$ofDouble.prototype = $c_sci_ArraySeq$ofDouble.prototype;
$c_sci_ArraySeq$ofDouble.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray.u.length;
});
$c_sci_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofDouble__f_unsafeArray;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofDouble)) {
    var array = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    var thatArray = that.sci_ArraySeq$ofDouble__f_unsafeArray;
    if ((array === thatArray)) {
      return true;
    } else if ((array.u.length === thatArray.u.length)) {
      var i = 0;
      while (((i < array.u.length) && (array.u[i] === thatArray.u[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= array.u.length);
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.sci_ArraySeq$ofDouble__f_unsafeArray);
});
$c_sci_ArraySeq$ofDouble.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if (((typeof elem) === "number")) {
    var x2 = (+elem);
    var xs = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    if (((index < 0) || (index >= xs.u.length))) {
      throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + xs.u.length) | 0));
    }
    var len = xs.u.length;
    var destination = new $ac_D(len);
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.u[index] = x2;
    return new $c_sci_ArraySeq$ofDouble(destination);
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem);
  }
});
$c_sci_ArraySeq$ofDouble.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "number")) {
    var x2 = (+elem);
    var xs = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.u.length) | 0);
    var this$4 = $objectGetClass(xs);
    var that = this$4.data.getComponentType();
    if ($d_D.isAssignableFrom(that.data)) {
      var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
    } else {
      var dest = new $ac_D(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, xs.u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, xs.u.length, x2);
    return new $c_sci_ArraySeq$ofDouble(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofDouble.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if (((typeof elem) === "number")) {
    var x2 = (+elem);
    var xs = this.sci_ArraySeq$ofDouble__f_unsafeArray;
    var len = ((1 + xs.u.length) | 0);
    var dest = new $ac_D(len);
    dest.u[0] = x2;
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, xs.u.length);
    return new $c_sci_ArraySeq$ofDouble(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(i) {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray.u[i];
});
$c_sci_ArraySeq$ofDouble.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofDouble.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofDouble.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem);
});
$c_sci_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var i = (v1 | 0);
  return this.apply$mcDI$sp__I__D(i);
});
$c_sci_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i);
});
$c_sci_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$();
});
$c_sci_ArraySeq$ofDouble.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofDouble__f_unsafeArray;
});
function $isArrayOf_sci_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofDouble)));
}
export { $isArrayOf_sci_ArraySeq$ofDouble as $isArrayOf_sci_ArraySeq$ofDouble };
var $d_sci_ArraySeq$ofDouble = new $TypeData().initClass($c_sci_ArraySeq$ofDouble, "scala.collection.immutable.ArraySeq$ofDouble", ({
  sci_ArraySeq$ofDouble: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ArraySeq$ofDouble as $d_sci_ArraySeq$ofDouble };
/** @constructor */
function $c_sci_ArraySeq$ofFloat(unsafeArray) {
  this.sci_ArraySeq$ofFloat__f_unsafeArray = null;
  this.sci_ArraySeq$ofFloat__f_unsafeArray = unsafeArray;
}
export { $c_sci_ArraySeq$ofFloat as $c_sci_ArraySeq$ofFloat };
$c_sci_ArraySeq$ofFloat.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofFloat.prototype.constructor = $c_sci_ArraySeq$ofFloat;
/** @constructor */
function $h_sci_ArraySeq$ofFloat() {
}
export { $h_sci_ArraySeq$ofFloat as $h_sci_ArraySeq$ofFloat };
$h_sci_ArraySeq$ofFloat.prototype = $c_sci_ArraySeq$ofFloat.prototype;
$c_sci_ArraySeq$ofFloat.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray.u.length;
});
$c_sci_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofFloat__f_unsafeArray;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofFloat)) {
    var array = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    var thatArray = that.sci_ArraySeq$ofFloat__f_unsafeArray;
    if ((array === thatArray)) {
      return true;
    } else if ((array.u.length === thatArray.u.length)) {
      var i = 0;
      while (((i < array.u.length) && (array.u[i] === thatArray.u[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= array.u.length);
    } else {
      return false;
    }
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.sci_ArraySeq$ofFloat__f_unsafeArray);
});
$c_sci_ArraySeq$ofFloat.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ($isFloat(elem)) {
    var x2 = Math.fround(elem);
    var xs = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    if (((index < 0) || (index >= xs.u.length))) {
      throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + xs.u.length) | 0));
    }
    var len = xs.u.length;
    var destination = new $ac_F(len);
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.u[index] = x2;
    return new $c_sci_ArraySeq$ofFloat(destination);
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem);
  }
});
$c_sci_ArraySeq$ofFloat.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isFloat(elem)) {
    var x2 = Math.fround(elem);
    var xs = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.u.length) | 0);
    var this$4 = $objectGetClass(xs);
    var that = this$4.data.getComponentType();
    if ($d_F.isAssignableFrom(that.data)) {
      var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
    } else {
      var dest = new $ac_F(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, xs.u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, xs.u.length, x2);
    return new $c_sci_ArraySeq$ofFloat(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofFloat.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isFloat(elem)) {
    var x2 = Math.fround(elem);
    var xs = this.sci_ArraySeq$ofFloat__f_unsafeArray;
    var len = ((1 + xs.u.length) | 0);
    var dest = new $ac_F(len);
    dest.u[0] = x2;
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, xs.u.length);
    return new $c_sci_ArraySeq$ofFloat(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(i) {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray.u[i];
});
$c_sci_ArraySeq$ofFloat.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofFloat.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofFloat.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem);
});
$c_sci_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var i = (v1 | 0);
  return this.apply$mcFI$sp__I__F(i);
});
$c_sci_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i);
});
$c_sci_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$();
});
$c_sci_ArraySeq$ofFloat.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofFloat__f_unsafeArray;
});
function $isArrayOf_sci_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofFloat)));
}
export { $isArrayOf_sci_ArraySeq$ofFloat as $isArrayOf_sci_ArraySeq$ofFloat };
var $d_sci_ArraySeq$ofFloat = new $TypeData().initClass($c_sci_ArraySeq$ofFloat, "scala.collection.immutable.ArraySeq$ofFloat", ({
  sci_ArraySeq$ofFloat: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ArraySeq$ofFloat as $d_sci_ArraySeq$ofFloat };
/** @constructor */
function $c_sci_ArraySeq$ofInt(unsafeArray) {
  this.sci_ArraySeq$ofInt__f_unsafeArray = null;
  this.sci_ArraySeq$ofInt__f_unsafeArray = unsafeArray;
}
export { $c_sci_ArraySeq$ofInt as $c_sci_ArraySeq$ofInt };
$c_sci_ArraySeq$ofInt.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofInt.prototype.constructor = $c_sci_ArraySeq$ofInt;
/** @constructor */
function $h_sci_ArraySeq$ofInt() {
}
export { $h_sci_ArraySeq$ofInt as $h_sci_ArraySeq$ofInt };
$h_sci_ArraySeq$ofInt.prototype = $c_sci_ArraySeq$ofInt.prototype;
$c_sci_ArraySeq$ofInt.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofInt__f_unsafeArray.u.length;
});
$c_sci_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofInt)) {
    var a = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var b = that.sci_ArraySeq$ofInt__f_unsafeArray;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.sci_ArraySeq$ofInt__f_unsafeArray.u.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Int$())) {
    var this$1 = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AI__V(a);
    return new $c_sci_ArraySeq$ofInt(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.sci_ArraySeq$ofInt__f_unsafeArray);
});
$c_sci_ArraySeq$ofInt.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ($isInt(elem)) {
    var x2 = (elem | 0);
    var xs = this.sci_ArraySeq$ofInt__f_unsafeArray;
    if (((index < 0) || (index >= xs.u.length))) {
      throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + xs.u.length) | 0));
    }
    var len = xs.u.length;
    var destination = new $ac_I(len);
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.u[index] = x2;
    return new $c_sci_ArraySeq$ofInt(destination);
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem);
  }
});
$c_sci_ArraySeq$ofInt.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isInt(elem)) {
    var x2 = (elem | 0);
    var xs = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.u.length) | 0);
    var this$4 = $objectGetClass(xs);
    var that = this$4.data.getComponentType();
    if ($d_I.isAssignableFrom(that.data)) {
      var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
    } else {
      var dest = new $ac_I(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, xs.u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, xs.u.length, x2);
    return new $c_sci_ArraySeq$ofInt(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofInt.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isInt(elem)) {
    var x2 = (elem | 0);
    var xs = this.sci_ArraySeq$ofInt__f_unsafeArray;
    var len = ((1 + xs.u.length) | 0);
    var dest = new $ac_I(len);
    dest.u[0] = x2;
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, xs.u.length);
    return new $c_sci_ArraySeq$ofInt(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(i) {
  return this.sci_ArraySeq$ofInt__f_unsafeArray.u[i];
});
$c_sci_ArraySeq$ofInt.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofInt.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofInt.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem);
});
$c_sci_ArraySeq$ofInt.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var i = (v1 | 0);
  return this.apply$mcII$sp__I__I(i);
});
$c_sci_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i);
});
$c_sci_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$();
});
$c_sci_ArraySeq$ofInt.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofInt__f_unsafeArray;
});
function $isArrayOf_sci_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofInt)));
}
export { $isArrayOf_sci_ArraySeq$ofInt as $isArrayOf_sci_ArraySeq$ofInt };
var $d_sci_ArraySeq$ofInt = new $TypeData().initClass($c_sci_ArraySeq$ofInt, "scala.collection.immutable.ArraySeq$ofInt", ({
  sci_ArraySeq$ofInt: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ArraySeq$ofInt as $d_sci_ArraySeq$ofInt };
/** @constructor */
function $c_sci_ArraySeq$ofLong(unsafeArray) {
  this.sci_ArraySeq$ofLong__f_unsafeArray = null;
  this.sci_ArraySeq$ofLong__f_unsafeArray = unsafeArray;
}
export { $c_sci_ArraySeq$ofLong as $c_sci_ArraySeq$ofLong };
$c_sci_ArraySeq$ofLong.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofLong.prototype.constructor = $c_sci_ArraySeq$ofLong;
/** @constructor */
function $h_sci_ArraySeq$ofLong() {
}
export { $h_sci_ArraySeq$ofLong as $h_sci_ArraySeq$ofLong };
$h_sci_ArraySeq$ofLong.prototype = $c_sci_ArraySeq$ofLong.prototype;
$c_sci_ArraySeq$ofLong.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofLong__f_unsafeArray.u.length;
});
$c_sci_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofLong)) {
    var a = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var b = that.sci_ArraySeq$ofLong__f_unsafeArray;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.sci_ArraySeq$ofLong__f_unsafeArray.u.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Long$())) {
    var this$1 = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AJ__V(a);
    return new $c_sci_ArraySeq$ofLong(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.sci_ArraySeq$ofLong__f_unsafeArray);
});
$c_sci_ArraySeq$ofLong.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ((elem instanceof $c_RTLong)) {
    var t = $uJ(elem);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var xs = this.sci_ArraySeq$ofLong__f_unsafeArray;
    if (((index < 0) || (index >= xs.u.length))) {
      throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + xs.u.length) | 0));
    }
    var len = xs.u.length;
    var destination = new $ac_J(len);
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.u[index] = new $c_RTLong(lo, hi);
    return new $c_sci_ArraySeq$ofLong(destination);
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem);
  }
});
$c_sci_ArraySeq$ofLong.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $c_RTLong)) {
    var t = $uJ(elem);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var xs = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.u.length) | 0);
    var this$4 = $objectGetClass(xs);
    var that = this$4.data.getComponentType();
    if ($d_J.isAssignableFrom(that.data)) {
      var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
    } else {
      var dest = new $ac_J(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, xs.u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, xs.u.length, new $c_RTLong(lo, hi));
    return new $c_sci_ArraySeq$ofLong(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofLong.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ((elem instanceof $c_RTLong)) {
    var t = $uJ(elem);
    var lo = t.RTLong__f_lo;
    var hi = t.RTLong__f_hi;
    var xs = this.sci_ArraySeq$ofLong__f_unsafeArray;
    var len = ((1 + xs.u.length) | 0);
    var dest = new $ac_J(len);
    dest.u[0] = new $c_RTLong(lo, hi);
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, xs.u.length);
    return new $c_sci_ArraySeq$ofLong(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(i) {
  return this.sci_ArraySeq$ofLong__f_unsafeArray.u[i];
});
$c_sci_ArraySeq$ofLong.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofLong.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofLong.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem);
});
$c_sci_ArraySeq$ofLong.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var i = (v1 | 0);
  return this.apply$mcJI$sp__I__J(i);
});
$c_sci_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i);
});
$c_sci_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$();
});
$c_sci_ArraySeq$ofLong.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofLong__f_unsafeArray;
});
function $isArrayOf_sci_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofLong)));
}
export { $isArrayOf_sci_ArraySeq$ofLong as $isArrayOf_sci_ArraySeq$ofLong };
var $d_sci_ArraySeq$ofLong = new $TypeData().initClass($c_sci_ArraySeq$ofLong, "scala.collection.immutable.ArraySeq$ofLong", ({
  sci_ArraySeq$ofLong: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ArraySeq$ofLong as $d_sci_ArraySeq$ofLong };
/** @constructor */
function $c_sci_ArraySeq$ofRef(unsafeArray) {
  this.sci_ArraySeq$ofRef__f_unsafeArray = null;
  this.sci_ArraySeq$ofRef__f_unsafeArray = unsafeArray;
}
export { $c_sci_ArraySeq$ofRef as $c_sci_ArraySeq$ofRef };
$c_sci_ArraySeq$ofRef.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofRef.prototype.constructor = $c_sci_ArraySeq$ofRef;
/** @constructor */
function $h_sci_ArraySeq$ofRef() {
}
export { $h_sci_ArraySeq$ofRef as $h_sci_ArraySeq$ofRef };
$h_sci_ArraySeq$ofRef.prototype = $c_sci_ArraySeq$ofRef.prototype;
$c_sci_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $x_1 = $m_s_reflect_ClassTag$();
  var this$1 = this.sci_ArraySeq$ofRef__f_unsafeArray;
  var this$2 = $objectGetClass(this$1);
  return $x_1.apply__jl_Class__s_reflect_ClassTag(this$2.data.getComponentType());
});
$c_sci_ArraySeq$ofRef.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofRef__f_unsafeArray.u.length;
});
$c_sci_ArraySeq$ofRef.prototype.apply__I__O = (function(i) {
  return this.sci_ArraySeq$ofRef__f_unsafeArray.u[i];
});
$c_sci_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofRef__f_unsafeArray;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofRef) ? $m_s_Array$().equals__AO__AO__Z(this.sci_ArraySeq$ofRef__f_unsafeArray, that.sci_ArraySeq$ofRef__f_unsafeArray) : $f_sc_Seq__equals__O__Z(this, that));
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq$ofRef = (function(ord) {
  if ((this.sci_ArraySeq$ofRef__f_unsafeArray.u.length <= 1)) {
    return this;
  } else {
    var this$1 = this.sci_ArraySeq$ofRef__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AO__ju_Comparator__V(a, ord);
    return new $c_sci_ArraySeq$ofRef(a);
  }
});
$c_sci_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.sci_ArraySeq$ofRef__f_unsafeArray);
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord);
});
$c_sci_ArraySeq$ofRef.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq$ofRef(ord);
});
$c_sci_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O((v1 | 0));
});
$c_sci_ArraySeq$ofRef.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofRef__f_unsafeArray;
});
function $isArrayOf_sci_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofRef)));
}
export { $isArrayOf_sci_ArraySeq$ofRef as $isArrayOf_sci_ArraySeq$ofRef };
var $d_sci_ArraySeq$ofRef = new $TypeData().initClass($c_sci_ArraySeq$ofRef, "scala.collection.immutable.ArraySeq$ofRef", ({
  sci_ArraySeq$ofRef: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ArraySeq$ofRef as $d_sci_ArraySeq$ofRef };
/** @constructor */
function $c_sci_ArraySeq$ofShort(unsafeArray) {
  this.sci_ArraySeq$ofShort__f_unsafeArray = null;
  this.sci_ArraySeq$ofShort__f_unsafeArray = unsafeArray;
}
export { $c_sci_ArraySeq$ofShort as $c_sci_ArraySeq$ofShort };
$c_sci_ArraySeq$ofShort.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofShort.prototype.constructor = $c_sci_ArraySeq$ofShort;
/** @constructor */
function $h_sci_ArraySeq$ofShort() {
}
export { $h_sci_ArraySeq$ofShort as $h_sci_ArraySeq$ofShort };
$h_sci_ArraySeq$ofShort.prototype = $c_sci_ArraySeq$ofShort.prototype;
$c_sci_ArraySeq$ofShort.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofShort__f_unsafeArray.u.length;
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__S = (function(i) {
  return this.sci_ArraySeq$ofShort__f_unsafeArray.u[i];
});
$c_sci_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_sci_ArraySeq$ofShort)) {
    var a = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var b = that.sci_ArraySeq$ofShort__f_unsafeArray;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b);
  } else {
    return $f_sc_Seq__equals__O__Z(this, that);
  }
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__sci_ArraySeq = (function(ord) {
  if ((this.sci_ArraySeq$ofShort__f_unsafeArray.u.length <= 1)) {
    return this;
  } else if ((ord === $m_s_math_Ordering$Short$())) {
    var this$1 = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var a = this$1.clone__O();
    $m_ju_Arrays$().sort__AS__V(a);
    return new $c_sci_ArraySeq$ofShort(a);
  } else {
    return $c_sci_ArraySeq.prototype.sorted__s_math_Ordering__sci_ArraySeq.call(this, ord);
  }
});
$c_sci_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.sci_ArraySeq$ofShort__f_unsafeArray);
});
$c_sci_ArraySeq$ofShort.prototype.updated__I__O__sci_ArraySeq = (function(index, elem) {
  if ($isShort(elem)) {
    var x2 = (elem | 0);
    var xs = this.sci_ArraySeq$ofShort__f_unsafeArray;
    if (((index < 0) || (index >= xs.u.length))) {
      throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + xs.u.length) | 0));
    }
    var len = xs.u.length;
    var destination = new $ac_S(len);
    $m_sc_ArrayOps$().copyToArray$extension__O__O__I__I__I(xs, destination, 0, 2147483647);
    destination.u[index] = x2;
    return new $c_sci_ArraySeq$ofShort(destination);
  } else {
    return $c_sci_ArraySeq.prototype.updated__I__O__sci_ArraySeq.call(this, index, elem);
  }
});
$c_sci_ArraySeq$ofShort.prototype.appended__O__sci_ArraySeq = (function(elem) {
  if ($isShort(elem)) {
    var x2 = (elem | 0);
    var xs = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var this$3 = $m_s_Array$();
    var newLength = ((1 + xs.u.length) | 0);
    var this$4 = $objectGetClass(xs);
    var that = this$4.data.getComponentType();
    if ($d_S.isAssignableFrom(that.data)) {
      var dest$1 = this$3.copyOf__O__I__O(xs, newLength);
    } else {
      var dest = new $ac_S(newLength);
      $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 0, xs.u.length);
      var dest$1 = dest;
    }
    $m_sr_ScalaRunTime$().array_update__O__I__O__V(dest$1, xs.u.length, x2);
    return new $c_sci_ArraySeq$ofShort(dest$1);
  } else {
    return $c_sci_ArraySeq.prototype.appended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofShort.prototype.prepended__O__sci_ArraySeq = (function(elem) {
  if ($isShort(elem)) {
    var x2 = (elem | 0);
    var xs = this.sci_ArraySeq$ofShort__f_unsafeArray;
    var len = ((1 + xs.u.length) | 0);
    var dest = new $ac_S(len);
    dest.u[0] = x2;
    $m_s_Array$().copy__O__I__O__I__I__V(xs, 0, dest, 1, xs.u.length);
    return new $c_sci_ArraySeq$ofShort(dest);
  } else {
    return $c_sci_ArraySeq.prototype.prepended__O__sci_ArraySeq.call(this, elem);
  }
});
$c_sci_ArraySeq$ofShort.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofShort.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_ArraySeq(elem);
});
$c_sci_ArraySeq$ofShort.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_ArraySeq(index, elem);
});
$c_sci_ArraySeq$ofShort.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return this.sorted__s_math_Ordering__sci_ArraySeq(ord);
});
$c_sci_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S((v1 | 0));
});
$c_sci_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i);
});
$c_sci_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$();
});
$c_sci_ArraySeq$ofShort.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofShort__f_unsafeArray;
});
function $isArrayOf_sci_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofShort)));
}
export { $isArrayOf_sci_ArraySeq$ofShort as $isArrayOf_sci_ArraySeq$ofShort };
var $d_sci_ArraySeq$ofShort = new $TypeData().initClass($c_sci_ArraySeq$ofShort, "scala.collection.immutable.ArraySeq$ofShort", ({
  sci_ArraySeq$ofShort: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ArraySeq$ofShort as $d_sci_ArraySeq$ofShort };
/** @constructor */
function $c_sci_ArraySeq$ofUnit(unsafeArray) {
  this.sci_ArraySeq$ofUnit__f_unsafeArray = null;
  this.sci_ArraySeq$ofUnit__f_unsafeArray = unsafeArray;
}
export { $c_sci_ArraySeq$ofUnit as $c_sci_ArraySeq$ofUnit };
$c_sci_ArraySeq$ofUnit.prototype = new $h_sci_ArraySeq();
$c_sci_ArraySeq$ofUnit.prototype.constructor = $c_sci_ArraySeq$ofUnit;
/** @constructor */
function $h_sci_ArraySeq$ofUnit() {
}
export { $h_sci_ArraySeq$ofUnit as $h_sci_ArraySeq$ofUnit };
$h_sci_ArraySeq$ofUnit.prototype = $c_sci_ArraySeq$ofUnit.prototype;
$c_sci_ArraySeq$ofUnit.prototype.length__I = (function() {
  return this.sci_ArraySeq$ofUnit__f_unsafeArray.u.length;
});
$c_sci_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.sci_ArraySeq$ofUnit__f_unsafeArray;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_sci_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_sci_ArraySeq$ofUnit) ? (this.sci_ArraySeq$ofUnit__f_unsafeArray.u.length === that.sci_ArraySeq$ofUnit__f_unsafeArray.u.length) : $f_sc_Seq__equals__O__Z(this, that));
});
$c_sci_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.sci_ArraySeq$ofUnit__f_unsafeArray);
});
$c_sci_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(i) {
});
$c_sci_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var i = (v1 | 0);
  this.apply$mcVI$sp__I__V(i);
});
$c_sci_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i);
});
$c_sci_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$();
});
$c_sci_ArraySeq$ofUnit.prototype.unsafeArray__O = (function() {
  return this.sci_ArraySeq$ofUnit__f_unsafeArray;
});
function $isArrayOf_sci_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_ArraySeq$ofUnit)));
}
export { $isArrayOf_sci_ArraySeq$ofUnit as $isArrayOf_sci_ArraySeq$ofUnit };
var $d_sci_ArraySeq$ofUnit = new $TypeData().initClass($c_sci_ArraySeq$ofUnit, "scala.collection.immutable.ArraySeq$ofUnit", ({
  sci_ArraySeq$ofUnit: 1,
  sci_ArraySeq: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_EvidenceIterableFactoryDefaults: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_ArraySeq$ofUnit as $d_sci_ArraySeq$ofUnit };
function $p_sci_List__filterCommon__F1__Z__sci_List($thiz, p, isFlipped) {
  var result = $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List($thiz, $thiz, p, isFlipped);
  return result;
}
export { $p_sci_List__filterCommon__F1__Z__sci_List as $p_sci_List__filterCommon__F1__Z__sci_List };
function $p_sci_List__loop$2__I__sci_List__I__I($thiz, i, xs, len$1) {
  while (true) {
    if ((i === len$1)) {
      return (xs.isEmpty__Z() ? 0 : 1);
    } else if (xs.isEmpty__Z()) {
      return (-1);
    } else {
      var temp$i = ((1 + i) | 0);
      var temp$xs = xs.tail__O();
      i = temp$i;
      xs = temp$xs;
    }
  }
}
export { $p_sci_List__loop$2__I__sci_List__I__I as $p_sci_List__loop$2__I__sci_List__I__I };
function $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List($thiz, l, p$1, isFlipped$1) {
  while (true) {
    if (l.isEmpty__Z()) {
      return $m_sci_Nil$();
    } else {
      var h = l.head__O();
      var t = l.tail__O();
      if (((!(!p$1.apply__O__O(h))) !== isFlipped$1)) {
        return $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List($thiz, l, t, p$1, isFlipped$1);
      } else {
        l = t;
      }
    }
  }
}
export { $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List as $p_sci_List__noneIn$1__sci_List__F1__Z__sci_List };
function $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List($thiz, start, remaining, p$1, isFlipped$1) {
  while (true) {
    if (remaining.isEmpty__Z()) {
      return start;
    } else {
      var x = remaining.head__O();
      if (((!(!p$1.apply__O__O(x))) !== isFlipped$1)) {
        remaining = remaining.tail__O();
      } else {
        return $ps_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List(start, remaining, p$1, isFlipped$1);
      }
    }
  }
}
export { $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List as $p_sci_List__allIn$1__sci_List__sci_List__F1__Z__sci_List };
function $ps_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List(origStart, firstMiss, p$1, isFlipped$1) {
  var newHead = new $c_sci_$colon$colon(origStart.head__O(), $m_sci_Nil$());
  var toProcess = origStart.tail__O();
  var currentLast = newHead;
  while ((toProcess !== firstMiss)) {
    var newElem = new $c_sci_$colon$colon(toProcess.head__O(), $m_sci_Nil$());
    currentLast.sci_$colon$colon__f_next = newElem;
    currentLast = newElem;
    toProcess = toProcess.tail__O();
  }
  var next = firstMiss.tail__O();
  var nextToCopy = next;
  while ((!next.isEmpty__Z())) {
    var head = next.head__O();
    if (((!(!p$1.apply__O__O(head))) !== isFlipped$1)) {
      next = next.tail__O();
    } else {
      while ((nextToCopy !== next)) {
        var newElem$2 = new $c_sci_$colon$colon(nextToCopy.head__O(), $m_sci_Nil$());
        currentLast.sci_$colon$colon__f_next = newElem$2;
        currentLast = newElem$2;
        nextToCopy = nextToCopy.tail__O();
      }
      nextToCopy = next.tail__O();
      next = next.tail__O();
    }
  }
  if ((!nextToCopy.isEmpty__Z())) {
    currentLast.sci_$colon$colon__f_next = nextToCopy;
  }
  return newHead;
}
export { $ps_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List as $ps_sci_List__partialFill$1__sci_List__sci_List__F1__Z__sci_List };
function $p_sci_List__listEq$1__sci_List__sci_List__Z($thiz, a, b) {
  while (true) {
    if ((a === b)) {
      return true;
    } else {
      var aEmpty = a.isEmpty__Z();
      var bEmpty = b.isEmpty__Z();
      if (((!(aEmpty || bEmpty)) && $m_sr_BoxesRunTime$().equals__O__O__Z(a.head__O(), b.head__O()))) {
        var temp$a = a.tail__O();
        var temp$b = b.tail__O();
        a = temp$a;
        b = temp$b;
      } else {
        return (aEmpty && bEmpty);
      }
    }
  }
}
export { $p_sci_List__listEq$1__sci_List__sci_List__Z as $p_sci_List__listEq$1__sci_List__sci_List__Z };
/** @constructor */
function $c_sci_List() {
}
export { $c_sci_List as $c_sci_List };
$c_sci_List.prototype = new $h_sci_AbstractSeq();
$c_sci_List.prototype.constructor = $c_sci_List;
/** @constructor */
function $h_sci_List() {
}
export { $h_sci_List as $h_sci_List };
$h_sci_List.prototype = $c_sci_List.prototype;
$c_sci_List.prototype.distinctBy__F1__O = (function(f) {
  return $f_sci_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sci_List.prototype.sorted__s_math_Ordering__O = (function(ord) {
  return $f_sc_SeqOps__sorted__s_math_Ordering__O(this, ord);
});
$c_sci_List.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_StrictOptimizedLinearSeqOps$$anon$1(this);
});
$c_sci_List.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_sci_List.prototype.diff__sc_Seq__O = (function(that) {
  return $f_sc_StrictOptimizedSeqOps__diff__sc_Seq__O(this, that);
});
$c_sci_List.prototype.flatten__F1__O = (function(toIterableOnce) {
  return $f_sc_StrictOptimizedIterableOps__flatten__F1__O(this, toIterableOnce);
});
$c_sci_List.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_sci_List.prototype.stringPrefix__T = (function() {
  return "LinearSeq";
});
$c_sci_List.prototype.isDefinedAt__I__Z = (function(x) {
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x);
});
$c_sci_List.prototype.apply__I__O = (function(n) {
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_List.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $f_sc_LinearSeqOps__foldLeft__O__F2__O(this, z, op);
});
$c_sci_List.prototype.sameElements__sc_IterableOnce__Z = (function(that) {
  return $f_sc_LinearSeqOps__sameElements__sc_IterableOnce__Z(this, that);
});
$c_sci_List.prototype.indexWhere__F1__I__I = (function(p, from) {
  return $f_sc_LinearSeqOps__indexWhere__F1__I__I(this, p, from);
});
$c_sci_List.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sci_List$();
});
$c_sci_List.prototype.$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  if (this.isEmpty__Z()) {
    return prefix;
  } else if (prefix.isEmpty__Z()) {
    return this;
  } else {
    var result = new $c_sci_$colon$colon(prefix.head__O(), this);
    var curr = result;
    var that = prefix.tail__O();
    while ((!that.isEmpty__Z())) {
      var temp = new $c_sci_$colon$colon(that.head__O(), this);
      curr.sci_$colon$colon__f_next = temp;
      curr = temp;
      that = that.tail__O();
    }
    return result;
  }
});
$c_sci_List.prototype.reverse_$colon$colon$colon__sci_List__sci_List = (function(prefix) {
  var these = this;
  var pres = prefix;
  while ((!pres.isEmpty__Z())) {
    var rassoc$1 = pres.head__O();
    var this$1 = these;
    these = new $c_sci_$colon$colon(rassoc$1, this$1);
    pres = pres.tail__O();
  }
  return these;
});
$c_sci_List.prototype.isEmpty__Z = (function() {
  return (this === $m_sci_Nil$());
});
$c_sci_List.prototype.prepended__O__sci_List = (function(elem) {
  return new $c_sci_$colon$colon(elem, this);
});
$c_sci_List.prototype.prependedAll__sc_IterableOnce__sci_List = (function(prefix) {
  if ((prefix instanceof $c_sci_List)) {
    return this.$colon$colon$colon__sci_List__sci_List(prefix);
  }
  if ((prefix.knownSize__I() === 0)) {
    return this;
  }
  if ((prefix instanceof $c_scm_ListBuffer)) {
    if (this.isEmpty__Z()) {
      return prefix.toList__sci_List();
    }
  }
  var iter = prefix.iterator__sc_Iterator();
  if (iter.hasNext__Z()) {
    var result = new $c_sci_$colon$colon(iter.next__O(), this);
    var curr = result;
    while (iter.hasNext__Z()) {
      var temp = new $c_sci_$colon$colon(iter.next__O(), this);
      curr.sci_$colon$colon__f_next = temp;
      curr = temp;
    }
    return result;
  } else {
    return this;
  }
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__sci_List = (function(suffix) {
  return ((suffix instanceof $c_sci_List) ? suffix.$colon$colon$colon__sci_List__sci_List(this) : $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix));
});
$c_sci_List.prototype.take__I__sci_List = (function(n) {
  if ((this.isEmpty__Z() || (n <= 0))) {
    return $m_sci_Nil$();
  } else {
    var h = new $c_sci_$colon$colon(this.head__O(), $m_sci_Nil$());
    var t = h;
    var rest = this.tail__O();
    var i = 1;
    while (true) {
      if (rest.isEmpty__Z()) {
        return this;
      }
      if ((i < n)) {
        i = ((1 + i) | 0);
        var nx = new $c_sci_$colon$colon(rest.head__O(), $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
        rest = rest.tail__O();
      } else {
        break;
      }
    }
    return h;
  }
});
$c_sci_List.prototype.splitAt__I__T2 = (function(n) {
  var b = new $c_scm_ListBuffer();
  var i = 0;
  var these = this;
  while (((!these.isEmpty__Z()) && (i < n))) {
    i = ((1 + i) | 0);
    var elem = these.head__O();
    b.addOne__O__scm_ListBuffer(elem);
    these = these.tail__O();
  }
  return $ct_T2__O__O__(new $c_T2(), b.toList__sci_List(), these);
});
$c_sci_List.prototype.updated__I__O__sci_List = (function(index, elem) {
  var i = 0;
  var current = this;
  var prefix = new $c_scm_ListBuffer();
  while (true) {
    if ((i < index)) {
      var this$2 = current;
      var $x_1 = (!this$2.isEmpty__Z());
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      i = ((1 + i) | 0);
      var elem$1 = current.head__O();
      prefix.addOne__O__scm_ListBuffer(elem$1);
      current = current.tail__O();
    } else {
      break;
    }
  }
  if ((i === index)) {
    var this$3 = current;
    var $x_2 = (!this$3.isEmpty__Z());
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    var this$4 = current.tail__O();
    return prefix.prependToList__sci_List__sci_List(new $c_sci_$colon$colon(elem, this$4));
  } else {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + this.length__I()) | 0));
  }
});
$c_sci_List.prototype.map__F1__sci_List = (function(f) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var h = new $c_sci_$colon$colon(f.apply__O__O(this.head__O()), $m_sci_Nil$());
    var t = h;
    var rest = this.tail__O();
    while ((rest !== $m_sci_Nil$())) {
      var nx = new $c_sci_$colon$colon(f.apply__O__O(rest.head__O()), $m_sci_Nil$());
      t.sci_$colon$colon__f_next = nx;
      t = nx;
      rest = rest.tail__O();
    }
    return h;
  }
});
$c_sci_List.prototype.collect__s_PartialFunction__sci_List = (function(pf) {
  if ((this === $m_sci_Nil$())) {
    return $m_sci_Nil$();
  } else {
    var rest = this;
    var h = null;
    var x = null;
    while ((h === null)) {
      x = pf.applyOrElse__O__F1__O(rest.head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        h = new $c_sci_$colon$colon(x, $m_sci_Nil$());
      }
      rest = rest.tail__O();
      if ((rest === $m_sci_Nil$())) {
        return ((h === null) ? $m_sci_Nil$() : h);
      }
    }
    var t = h;
    while ((rest !== $m_sci_Nil$())) {
      x = pf.applyOrElse__O__F1__O(rest.head__O(), $m_sci_List$().sci_List$__f_partialNotApplied);
      if ((x !== $m_sci_List$().sci_List$__f_partialNotApplied)) {
        var nx = new $c_sci_$colon$colon(x, $m_sci_Nil$());
        t.sci_$colon$colon__f_next = nx;
        t = nx;
      }
      rest = rest.tail__O();
    }
    return h;
  }
});
$c_sci_List.prototype.flatMap__F1__sci_List = (function(f) {
  var rest = this;
  var h = null;
  var t = null;
  while ((rest !== $m_sci_Nil$())) {
    var it = f.apply__O__O(rest.head__O()).iterator__sc_Iterator();
    while (it.hasNext__Z()) {
      var nx = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      if ((t === null)) {
        h = nx;
      } else {
        t.sci_$colon$colon__f_next = nx;
      }
      t = nx;
    }
    rest = rest.tail__O();
  }
  return ((h === null) ? $m_sci_Nil$() : h);
});
$c_sci_List.prototype.foreach__F1__V = (function(f) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    f.apply__O__O(these.head__O());
    these = these.tail__O();
  }
});
$c_sci_List.prototype.reverse__sci_List = (function() {
  var result = $m_sci_Nil$();
  var these = this;
  while ((!these.isEmpty__Z())) {
    var rassoc$6 = these.head__O();
    var this$1 = result;
    result = new $c_sci_$colon$colon(rassoc$6, this$1);
    these = these.tail__O();
  }
  return result;
});
$c_sci_List.prototype.foldRight__O__F2__O = (function(z, op) {
  var acc = z;
  var these = this.reverse__sci_List();
  while ((!these.isEmpty__Z())) {
    acc = op.apply__O__O__O(these.head__O(), acc);
    these = these.tail__O();
  }
  return acc;
});
$c_sci_List.prototype.length__I = (function() {
  var these = this;
  var len = 0;
  while ((!these.isEmpty__Z())) {
    len = ((1 + len) | 0);
    these = these.tail__O();
  }
  return len;
});
$c_sci_List.prototype.lengthCompare__I__I = (function(len) {
  return ((len < 0) ? 1 : $p_sci_List__loop$2__I__sci_List__I__I(this, 0, this, len));
});
$c_sci_List.prototype.forall__F1__Z = (function(p) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    if ((!(!(!p.apply__O__O(these.head__O()))))) {
      return false;
    }
    these = these.tail__O();
  }
  return true;
});
$c_sci_List.prototype.exists__F1__Z = (function(p) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    if ((!(!p.apply__O__O(these.head__O())))) {
      return true;
    }
    these = these.tail__O();
  }
  return false;
});
$c_sci_List.prototype.contains__O__Z = (function(elem) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(these.head__O(), elem)) {
      return true;
    }
    these = these.tail__O();
  }
  return false;
});
$c_sci_List.prototype.find__F1__s_Option = (function(p) {
  var these = this;
  while ((!these.isEmpty__Z())) {
    if ((!(!p.apply__O__O(these.head__O())))) {
      return new $c_s_Some(these.head__O());
    }
    these = these.tail__O();
  }
  return $m_s_None$();
});
$c_sci_List.prototype.last__O = (function() {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "List.last");
  } else {
    var these = this;
    var scout = this.tail__O();
    while ((!scout.isEmpty__Z())) {
      these = scout;
      scout = scout.tail__O();
    }
    return these.head__O();
  }
});
$c_sci_List.prototype.className__T = (function() {
  return "List";
});
$c_sci_List.prototype.partition__F1__T2 = (function(p) {
  if (this.isEmpty__Z()) {
    return $m_sci_List$().sci_List$__f_scala$collection$immutable$List$$TupleOfNil;
  } else {
    var x1 = $f_sc_StrictOptimizedIterableOps__partition__F1__T2(this, p);
    if ((x1 !== null)) {
      var p2 = x1._1__O();
      var x = $m_sci_Nil$();
      if (x.equals__O__Z(p2)) {
        return $ct_T2__O__O__(new $c_T2(), $m_sci_Nil$(), this);
      }
    }
    if ((x1 !== null)) {
      var p4 = x1._2__O();
      var x$3 = $m_sci_Nil$();
      if (x$3.equals__O__Z(p4)) {
        return $ct_T2__O__O__(new $c_T2(), this, $m_sci_Nil$());
      }
    }
    return x1;
  }
});
$c_sci_List.prototype.toList__sci_List = (function() {
  return this;
});
$c_sci_List.prototype.equals__O__Z = (function(o) {
  return ((o instanceof $c_sci_List) ? $p_sci_List__listEq$1__sci_List__sci_List__Z(this, this, o) : $f_sc_Seq__equals__O__Z(this, o));
});
$c_sci_List.prototype.apply__O__O = (function(v1) {
  var n = (v1 | 0);
  return $f_sc_LinearSeqOps__apply__I__O(this, n);
});
$c_sci_List.prototype.isDefinedAt__O__Z = (function(x) {
  var x$1 = (x | 0);
  return $f_sc_LinearSeqOps__isDefinedAt__I__Z(this, x$1);
});
$c_sci_List.prototype.drop__I__O = (function(n) {
  return $p_sc_StrictOptimizedLinearSeqOps__loop$2__I__sc_LinearSeq__sc_LinearSeq(this, n, this);
});
$c_sci_List.prototype.filterNot__F1__O = (function(pred) {
  return $p_sci_List__filterCommon__F1__Z__sci_List(this, pred, true);
});
$c_sci_List.prototype.filter__F1__O = (function(pred) {
  return $p_sci_List__filterCommon__F1__Z__sci_List(this, pred, false);
});
$c_sci_List.prototype.flatMap__F1__O = (function(f) {
  return this.flatMap__F1__sci_List(f);
});
$c_sci_List.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_List(f);
});
$c_sci_List.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_List(index, elem);
});
$c_sci_List.prototype.take__I__O = (function(n) {
  return this.take__I__sci_List(n);
});
$c_sci_List.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return this.appendedAll__sc_IterableOnce__sci_List(suffix);
});
$c_sci_List.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_List(elem);
});
$c_sci_List.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sci_List$();
});
function $isArrayOf_sci_List(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_List)));
}
export { $isArrayOf_sci_List as $isArrayOf_sci_List };
var $d_sci_List = new $TypeData().initClass(0, "scala.collection.immutable.List", ({
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_List as $d_sci_List };
/** @constructor */
function $c_sci_VectorImpl() {
  this.sci_Vector__f_prefix1 = null;
}
export { $c_sci_VectorImpl as $c_sci_VectorImpl };
$c_sci_VectorImpl.prototype = new $h_sci_Vector();
$c_sci_VectorImpl.prototype.constructor = $c_sci_VectorImpl;
/** @constructor */
function $h_sci_VectorImpl() {
}
export { $h_sci_VectorImpl as $h_sci_VectorImpl };
$h_sci_VectorImpl.prototype = $c_sci_VectorImpl.prototype;
$c_sci_VectorImpl.prototype.slice__I__I__sci_Vector = (function(from, until) {
  var lo = ((from > 0) ? from : 0);
  var b = this.length__I();
  var hi = ((until < b) ? until : b);
  return ((hi <= lo) ? $m_sci_Vector0$() : ((((hi - lo) | 0) === this.length__I()) ? this : this.slice0__I__I__sci_Vector(lo, hi)));
});
/** @constructor */
function $c_scm_ArraySeq$ofBoolean(array) {
  this.scm_ArraySeq$ofBoolean__f_array = null;
  this.scm_ArraySeq$ofBoolean__f_array = array;
}
export { $c_scm_ArraySeq$ofBoolean as $c_scm_ArraySeq$ofBoolean };
$c_scm_ArraySeq$ofBoolean.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofBoolean.prototype.constructor = $c_scm_ArraySeq$ofBoolean;
/** @constructor */
function $h_scm_ArraySeq$ofBoolean() {
}
export { $h_scm_ArraySeq$ofBoolean as $h_scm_ArraySeq$ofBoolean };
$h_scm_ArraySeq$ofBoolean.prototype = $c_scm_ArraySeq$ofBoolean.prototype;
$c_scm_ArraySeq$ofBoolean.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofBoolean__f_array.u.length;
});
$c_scm_ArraySeq$ofBoolean.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofBoolean__f_array;
  return this$1.arrayHash$mZc$sp__AZ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofBoolean.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofBoolean)) {
    var a = this.scm_ArraySeq$ofBoolean__f_array;
    var b = that.scm_ArraySeq$ofBoolean__f_array;
    return $m_ju_Arrays$().equals__AZ__AZ__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofBoolean.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcZ$sp(this.scm_ArraySeq$ofBoolean__f_array);
});
$c_scm_ArraySeq$ofBoolean.prototype.apply$mcZI$sp__I__Z = (function(index) {
  return this.scm_ArraySeq$ofBoolean__f_array.u[index];
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  return this.apply$mcZI$sp__I__Z(index);
});
$c_scm_ArraySeq$ofBoolean.prototype.apply__I__O = (function(i) {
  return this.apply$mcZI$sp__I__Z(i);
});
$c_scm_ArraySeq$ofBoolean.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$BooleanManifest$();
});
$c_scm_ArraySeq$ofBoolean.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofBoolean__f_array;
});
function $isArrayOf_scm_ArraySeq$ofBoolean(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofBoolean)));
}
export { $isArrayOf_scm_ArraySeq$ofBoolean as $isArrayOf_scm_ArraySeq$ofBoolean };
var $d_scm_ArraySeq$ofBoolean = new $TypeData().initClass($c_scm_ArraySeq$ofBoolean, "scala.collection.mutable.ArraySeq$ofBoolean", ({
  scm_ArraySeq$ofBoolean: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArraySeq$ofBoolean as $d_scm_ArraySeq$ofBoolean };
/** @constructor */
function $c_scm_ArraySeq$ofByte(array) {
  this.scm_ArraySeq$ofByte__f_array = null;
  this.scm_ArraySeq$ofByte__f_array = array;
}
export { $c_scm_ArraySeq$ofByte as $c_scm_ArraySeq$ofByte };
$c_scm_ArraySeq$ofByte.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofByte.prototype.constructor = $c_scm_ArraySeq$ofByte;
/** @constructor */
function $h_scm_ArraySeq$ofByte() {
}
export { $h_scm_ArraySeq$ofByte as $h_scm_ArraySeq$ofByte };
$h_scm_ArraySeq$ofByte.prototype = $c_scm_ArraySeq$ofByte.prototype;
$c_scm_ArraySeq$ofByte.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofByte__f_array.u.length;
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__B = (function(index) {
  return this.scm_ArraySeq$ofByte__f_array.u[index];
});
$c_scm_ArraySeq$ofByte.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofByte__f_array;
  return this$1.arrayHash$mBc$sp__AB__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofByte.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofByte)) {
    var a = this.scm_ArraySeq$ofByte__f_array;
    var b = that.scm_ArraySeq$ofByte__f_array;
    return $m_ju_Arrays$().equals__AB__AB__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofByte.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcB$sp(this.scm_ArraySeq$ofByte__f_array);
});
$c_scm_ArraySeq$ofByte.prototype.apply__O__O = (function(v1) {
  return this.apply__I__B((v1 | 0));
});
$c_scm_ArraySeq$ofByte.prototype.apply__I__O = (function(i) {
  return this.apply__I__B(i);
});
$c_scm_ArraySeq$ofByte.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ByteManifest$();
});
$c_scm_ArraySeq$ofByte.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofByte__f_array;
});
function $isArrayOf_scm_ArraySeq$ofByte(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofByte)));
}
export { $isArrayOf_scm_ArraySeq$ofByte as $isArrayOf_scm_ArraySeq$ofByte };
var $d_scm_ArraySeq$ofByte = new $TypeData().initClass($c_scm_ArraySeq$ofByte, "scala.collection.mutable.ArraySeq$ofByte", ({
  scm_ArraySeq$ofByte: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArraySeq$ofByte as $d_scm_ArraySeq$ofByte };
/** @constructor */
function $c_scm_ArraySeq$ofChar(array) {
  this.scm_ArraySeq$ofChar__f_array = null;
  this.scm_ArraySeq$ofChar__f_array = array;
}
export { $c_scm_ArraySeq$ofChar as $c_scm_ArraySeq$ofChar };
$c_scm_ArraySeq$ofChar.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofChar.prototype.constructor = $c_scm_ArraySeq$ofChar;
/** @constructor */
function $h_scm_ArraySeq$ofChar() {
}
export { $h_scm_ArraySeq$ofChar as $h_scm_ArraySeq$ofChar };
$h_scm_ArraySeq$ofChar.prototype = $c_scm_ArraySeq$ofChar.prototype;
$c_scm_ArraySeq$ofChar.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofChar__f_array.u.length;
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__C = (function(index) {
  return this.scm_ArraySeq$ofChar__f_array.u[index];
});
$c_scm_ArraySeq$ofChar.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofChar__f_array;
  return this$1.arrayHash$mCc$sp__AC__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofChar.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofChar)) {
    var a = this.scm_ArraySeq$ofChar__f_array;
    var b = that.scm_ArraySeq$ofChar__f_array;
    return $m_ju_Arrays$().equals__AC__AC__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofChar.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcC$sp(this.scm_ArraySeq$ofChar__f_array);
});
$c_scm_ArraySeq$ofChar.prototype.addString__scm_StringBuilder__T__T__T__scm_StringBuilder = (function(sb, start, sep, end) {
  var jsb = sb.scm_StringBuilder__f_underlying;
  if ((start.length !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + start);
  }
  var len = this.scm_ArraySeq$ofChar__f_array.u.length;
  if ((len !== 0)) {
    if ((sep === "")) {
      jsb.append__AC__jl_StringBuilder(this.scm_ArraySeq$ofChar__f_array);
    } else {
      jsb.length__I();
      var c = this.scm_ArraySeq$ofChar__f_array.u[0];
      var str = ("" + $cToS(c));
      jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
      var i = 1;
      while ((i < len)) {
        jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + sep);
        var c$1 = this.scm_ArraySeq$ofChar__f_array.u[i];
        var str$1 = ("" + $cToS(c$1));
        jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
        i = ((1 + i) | 0);
      }
    }
  }
  if ((end.length !== 0)) {
    jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + jsb.jl_StringBuilder__f_java$lang$StringBuilder$$content) + end);
  }
  return sb;
});
$c_scm_ArraySeq$ofChar.prototype.apply__O__O = (function(v1) {
  return $bC(this.apply__I__C((v1 | 0)));
});
$c_scm_ArraySeq$ofChar.prototype.apply__I__O = (function(i) {
  return $bC(this.apply__I__C(i));
});
$c_scm_ArraySeq$ofChar.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$CharManifest$();
});
$c_scm_ArraySeq$ofChar.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofChar__f_array;
});
function $isArrayOf_scm_ArraySeq$ofChar(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofChar)));
}
export { $isArrayOf_scm_ArraySeq$ofChar as $isArrayOf_scm_ArraySeq$ofChar };
var $d_scm_ArraySeq$ofChar = new $TypeData().initClass($c_scm_ArraySeq$ofChar, "scala.collection.mutable.ArraySeq$ofChar", ({
  scm_ArraySeq$ofChar: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArraySeq$ofChar as $d_scm_ArraySeq$ofChar };
/** @constructor */
function $c_scm_ArraySeq$ofDouble(array) {
  this.scm_ArraySeq$ofDouble__f_array = null;
  this.scm_ArraySeq$ofDouble__f_array = array;
}
export { $c_scm_ArraySeq$ofDouble as $c_scm_ArraySeq$ofDouble };
$c_scm_ArraySeq$ofDouble.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofDouble.prototype.constructor = $c_scm_ArraySeq$ofDouble;
/** @constructor */
function $h_scm_ArraySeq$ofDouble() {
}
export { $h_scm_ArraySeq$ofDouble as $h_scm_ArraySeq$ofDouble };
$h_scm_ArraySeq$ofDouble.prototype = $c_scm_ArraySeq$ofDouble.prototype;
$c_scm_ArraySeq$ofDouble.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofDouble__f_array.u.length;
});
$c_scm_ArraySeq$ofDouble.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofDouble__f_array;
  return this$1.arrayHash$mDc$sp__AD__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofDouble.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofDouble)) {
    var thatArray = that.scm_ArraySeq$ofDouble__f_array;
    if ((this.scm_ArraySeq$ofDouble__f_array === thatArray)) {
      return true;
    } else if ((this.scm_ArraySeq$ofDouble__f_array.u.length === thatArray.u.length)) {
      var i = 0;
      while (((i < this.scm_ArraySeq$ofDouble__f_array.u.length) && (this.scm_ArraySeq$ofDouble__f_array.u[i] === thatArray.u[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= this.scm_ArraySeq$ofDouble__f_array.u.length);
    } else {
      return false;
    }
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofDouble.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcD$sp(this.scm_ArraySeq$ofDouble__f_array);
});
$c_scm_ArraySeq$ofDouble.prototype.apply$mcDI$sp__I__D = (function(index) {
  return this.scm_ArraySeq$ofDouble__f_array.u[index];
});
$c_scm_ArraySeq$ofDouble.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  return this.apply$mcDI$sp__I__D(index);
});
$c_scm_ArraySeq$ofDouble.prototype.apply__I__O = (function(i) {
  return this.apply$mcDI$sp__I__D(i);
});
$c_scm_ArraySeq$ofDouble.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$DoubleManifest$();
});
$c_scm_ArraySeq$ofDouble.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofDouble__f_array;
});
function $isArrayOf_scm_ArraySeq$ofDouble(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofDouble)));
}
export { $isArrayOf_scm_ArraySeq$ofDouble as $isArrayOf_scm_ArraySeq$ofDouble };
var $d_scm_ArraySeq$ofDouble = new $TypeData().initClass($c_scm_ArraySeq$ofDouble, "scala.collection.mutable.ArraySeq$ofDouble", ({
  scm_ArraySeq$ofDouble: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArraySeq$ofDouble as $d_scm_ArraySeq$ofDouble };
/** @constructor */
function $c_scm_ArraySeq$ofFloat(array) {
  this.scm_ArraySeq$ofFloat__f_array = null;
  this.scm_ArraySeq$ofFloat__f_array = array;
}
export { $c_scm_ArraySeq$ofFloat as $c_scm_ArraySeq$ofFloat };
$c_scm_ArraySeq$ofFloat.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofFloat.prototype.constructor = $c_scm_ArraySeq$ofFloat;
/** @constructor */
function $h_scm_ArraySeq$ofFloat() {
}
export { $h_scm_ArraySeq$ofFloat as $h_scm_ArraySeq$ofFloat };
$h_scm_ArraySeq$ofFloat.prototype = $c_scm_ArraySeq$ofFloat.prototype;
$c_scm_ArraySeq$ofFloat.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofFloat__f_array.u.length;
});
$c_scm_ArraySeq$ofFloat.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofFloat__f_array;
  return this$1.arrayHash$mFc$sp__AF__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofFloat.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofFloat)) {
    var thatArray = that.scm_ArraySeq$ofFloat__f_array;
    if ((this.scm_ArraySeq$ofFloat__f_array === thatArray)) {
      return true;
    } else if ((this.scm_ArraySeq$ofFloat__f_array.u.length === thatArray.u.length)) {
      var i = 0;
      while (((i < this.scm_ArraySeq$ofFloat__f_array.u.length) && (this.scm_ArraySeq$ofFloat__f_array.u[i] === thatArray.u[i]))) {
        i = ((1 + i) | 0);
      }
      return (i >= this.scm_ArraySeq$ofFloat__f_array.u.length);
    } else {
      return false;
    }
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofFloat.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcF$sp(this.scm_ArraySeq$ofFloat__f_array);
});
$c_scm_ArraySeq$ofFloat.prototype.apply$mcFI$sp__I__F = (function(index) {
  return this.scm_ArraySeq$ofFloat__f_array.u[index];
});
$c_scm_ArraySeq$ofFloat.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  return this.apply$mcFI$sp__I__F(index);
});
$c_scm_ArraySeq$ofFloat.prototype.apply__I__O = (function(i) {
  return this.apply$mcFI$sp__I__F(i);
});
$c_scm_ArraySeq$ofFloat.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$FloatManifest$();
});
$c_scm_ArraySeq$ofFloat.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofFloat__f_array;
});
function $isArrayOf_scm_ArraySeq$ofFloat(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofFloat)));
}
export { $isArrayOf_scm_ArraySeq$ofFloat as $isArrayOf_scm_ArraySeq$ofFloat };
var $d_scm_ArraySeq$ofFloat = new $TypeData().initClass($c_scm_ArraySeq$ofFloat, "scala.collection.mutable.ArraySeq$ofFloat", ({
  scm_ArraySeq$ofFloat: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArraySeq$ofFloat as $d_scm_ArraySeq$ofFloat };
/** @constructor */
function $c_scm_ArraySeq$ofInt(array) {
  this.scm_ArraySeq$ofInt__f_array = null;
  this.scm_ArraySeq$ofInt__f_array = array;
}
export { $c_scm_ArraySeq$ofInt as $c_scm_ArraySeq$ofInt };
$c_scm_ArraySeq$ofInt.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofInt.prototype.constructor = $c_scm_ArraySeq$ofInt;
/** @constructor */
function $h_scm_ArraySeq$ofInt() {
}
export { $h_scm_ArraySeq$ofInt as $h_scm_ArraySeq$ofInt };
$h_scm_ArraySeq$ofInt.prototype = $c_scm_ArraySeq$ofInt.prototype;
$c_scm_ArraySeq$ofInt.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofInt__f_array.u.length;
});
$c_scm_ArraySeq$ofInt.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofInt__f_array;
  return this$1.arrayHash$mIc$sp__AI__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofInt.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofInt)) {
    var a = this.scm_ArraySeq$ofInt__f_array;
    var b = that.scm_ArraySeq$ofInt__f_array;
    return $m_ju_Arrays$().equals__AI__AI__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofInt.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcI$sp(this.scm_ArraySeq$ofInt__f_array);
});
$c_scm_ArraySeq$ofInt.prototype.apply$mcII$sp__I__I = (function(index) {
  return this.scm_ArraySeq$ofInt__f_array.u[index];
});
$c_scm_ArraySeq$ofInt.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  return this.apply$mcII$sp__I__I(index);
});
$c_scm_ArraySeq$ofInt.prototype.apply__I__O = (function(i) {
  return this.apply$mcII$sp__I__I(i);
});
$c_scm_ArraySeq$ofInt.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$IntManifest$();
});
$c_scm_ArraySeq$ofInt.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofInt__f_array;
});
function $isArrayOf_scm_ArraySeq$ofInt(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofInt)));
}
export { $isArrayOf_scm_ArraySeq$ofInt as $isArrayOf_scm_ArraySeq$ofInt };
var $d_scm_ArraySeq$ofInt = new $TypeData().initClass($c_scm_ArraySeq$ofInt, "scala.collection.mutable.ArraySeq$ofInt", ({
  scm_ArraySeq$ofInt: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArraySeq$ofInt as $d_scm_ArraySeq$ofInt };
/** @constructor */
function $c_scm_ArraySeq$ofLong(array) {
  this.scm_ArraySeq$ofLong__f_array = null;
  this.scm_ArraySeq$ofLong__f_array = array;
}
export { $c_scm_ArraySeq$ofLong as $c_scm_ArraySeq$ofLong };
$c_scm_ArraySeq$ofLong.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofLong.prototype.constructor = $c_scm_ArraySeq$ofLong;
/** @constructor */
function $h_scm_ArraySeq$ofLong() {
}
export { $h_scm_ArraySeq$ofLong as $h_scm_ArraySeq$ofLong };
$h_scm_ArraySeq$ofLong.prototype = $c_scm_ArraySeq$ofLong.prototype;
$c_scm_ArraySeq$ofLong.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofLong__f_array.u.length;
});
$c_scm_ArraySeq$ofLong.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofLong__f_array;
  return this$1.arrayHash$mJc$sp__AJ__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofLong.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofLong)) {
    var a = this.scm_ArraySeq$ofLong__f_array;
    var b = that.scm_ArraySeq$ofLong__f_array;
    return $m_ju_Arrays$().equals__AJ__AJ__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofLong.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcJ$sp(this.scm_ArraySeq$ofLong__f_array);
});
$c_scm_ArraySeq$ofLong.prototype.apply$mcJI$sp__I__J = (function(index) {
  return this.scm_ArraySeq$ofLong__f_array.u[index];
});
$c_scm_ArraySeq$ofLong.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  return this.apply$mcJI$sp__I__J(index);
});
$c_scm_ArraySeq$ofLong.prototype.apply__I__O = (function(i) {
  return this.apply$mcJI$sp__I__J(i);
});
$c_scm_ArraySeq$ofLong.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$LongManifest$();
});
$c_scm_ArraySeq$ofLong.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofLong__f_array;
});
function $isArrayOf_scm_ArraySeq$ofLong(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofLong)));
}
export { $isArrayOf_scm_ArraySeq$ofLong as $isArrayOf_scm_ArraySeq$ofLong };
var $d_scm_ArraySeq$ofLong = new $TypeData().initClass($c_scm_ArraySeq$ofLong, "scala.collection.mutable.ArraySeq$ofLong", ({
  scm_ArraySeq$ofLong: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArraySeq$ofLong as $d_scm_ArraySeq$ofLong };
/** @constructor */
function $c_scm_ArraySeq$ofRef(array) {
  this.scm_ArraySeq$ofRef__f_array = null;
  this.scm_ArraySeq$ofRef__f_array = array;
}
export { $c_scm_ArraySeq$ofRef as $c_scm_ArraySeq$ofRef };
$c_scm_ArraySeq$ofRef.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofRef.prototype.constructor = $c_scm_ArraySeq$ofRef;
/** @constructor */
function $h_scm_ArraySeq$ofRef() {
}
export { $h_scm_ArraySeq$ofRef as $h_scm_ArraySeq$ofRef };
$h_scm_ArraySeq$ofRef.prototype = $c_scm_ArraySeq$ofRef.prototype;
$c_scm_ArraySeq$ofRef.prototype.elemTag__s_reflect_ClassTag = (function() {
  var $x_1 = $m_s_reflect_ClassTag$();
  var this$1 = this.scm_ArraySeq$ofRef__f_array;
  var this$2 = $objectGetClass(this$1);
  return $x_1.apply__jl_Class__s_reflect_ClassTag(this$2.data.getComponentType());
});
$c_scm_ArraySeq$ofRef.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofRef__f_array.u.length;
});
$c_scm_ArraySeq$ofRef.prototype.apply__I__O = (function(index) {
  return this.scm_ArraySeq$ofRef__f_array.u[index];
});
$c_scm_ArraySeq$ofRef.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofRef__f_array;
  return this$1.arrayHash__O__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofRef.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofRef) ? $m_s_Array$().equals__AO__AO__Z(this.scm_ArraySeq$ofRef__f_array, that.scm_ArraySeq$ofRef__f_array) : $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that));
});
$c_scm_ArraySeq$ofRef.prototype.iterator__sc_Iterator = (function() {
  return $ct_sc_ArrayOps$ArrayIterator__O__(new $c_sc_ArrayOps$ArrayIterator(), this.scm_ArraySeq$ofRef__f_array);
});
$c_scm_ArraySeq$ofRef.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O((v1 | 0));
});
$c_scm_ArraySeq$ofRef.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofRef__f_array;
});
function $isArrayOf_scm_ArraySeq$ofRef(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofRef)));
}
export { $isArrayOf_scm_ArraySeq$ofRef as $isArrayOf_scm_ArraySeq$ofRef };
var $d_scm_ArraySeq$ofRef = new $TypeData().initClass($c_scm_ArraySeq$ofRef, "scala.collection.mutable.ArraySeq$ofRef", ({
  scm_ArraySeq$ofRef: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArraySeq$ofRef as $d_scm_ArraySeq$ofRef };
/** @constructor */
function $c_scm_ArraySeq$ofShort(array) {
  this.scm_ArraySeq$ofShort__f_array = null;
  this.scm_ArraySeq$ofShort__f_array = array;
}
export { $c_scm_ArraySeq$ofShort as $c_scm_ArraySeq$ofShort };
$c_scm_ArraySeq$ofShort.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofShort.prototype.constructor = $c_scm_ArraySeq$ofShort;
/** @constructor */
function $h_scm_ArraySeq$ofShort() {
}
export { $h_scm_ArraySeq$ofShort as $h_scm_ArraySeq$ofShort };
$h_scm_ArraySeq$ofShort.prototype = $c_scm_ArraySeq$ofShort.prototype;
$c_scm_ArraySeq$ofShort.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofShort__f_array.u.length;
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__S = (function(index) {
  return this.scm_ArraySeq$ofShort__f_array.u[index];
});
$c_scm_ArraySeq$ofShort.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofShort__f_array;
  return this$1.arrayHash$mSc$sp__AS__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofShort.prototype.equals__O__Z = (function(that) {
  if ((that instanceof $c_scm_ArraySeq$ofShort)) {
    var a = this.scm_ArraySeq$ofShort__f_array;
    var b = that.scm_ArraySeq$ofShort__f_array;
    return $m_ju_Arrays$().equals__AS__AS__Z(a, b);
  } else {
    return $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that);
  }
});
$c_scm_ArraySeq$ofShort.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcS$sp(this.scm_ArraySeq$ofShort__f_array);
});
$c_scm_ArraySeq$ofShort.prototype.apply__O__O = (function(v1) {
  return this.apply__I__S((v1 | 0));
});
$c_scm_ArraySeq$ofShort.prototype.apply__I__O = (function(i) {
  return this.apply__I__S(i);
});
$c_scm_ArraySeq$ofShort.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$ShortManifest$();
});
$c_scm_ArraySeq$ofShort.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofShort__f_array;
});
function $isArrayOf_scm_ArraySeq$ofShort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofShort)));
}
export { $isArrayOf_scm_ArraySeq$ofShort as $isArrayOf_scm_ArraySeq$ofShort };
var $d_scm_ArraySeq$ofShort = new $TypeData().initClass($c_scm_ArraySeq$ofShort, "scala.collection.mutable.ArraySeq$ofShort", ({
  scm_ArraySeq$ofShort: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArraySeq$ofShort as $d_scm_ArraySeq$ofShort };
/** @constructor */
function $c_scm_ArraySeq$ofUnit(array) {
  this.scm_ArraySeq$ofUnit__f_array = null;
  this.scm_ArraySeq$ofUnit__f_array = array;
}
export { $c_scm_ArraySeq$ofUnit as $c_scm_ArraySeq$ofUnit };
$c_scm_ArraySeq$ofUnit.prototype = new $h_scm_ArraySeq();
$c_scm_ArraySeq$ofUnit.prototype.constructor = $c_scm_ArraySeq$ofUnit;
/** @constructor */
function $h_scm_ArraySeq$ofUnit() {
}
export { $h_scm_ArraySeq$ofUnit as $h_scm_ArraySeq$ofUnit };
$h_scm_ArraySeq$ofUnit.prototype = $c_scm_ArraySeq$ofUnit.prototype;
$c_scm_ArraySeq$ofUnit.prototype.length__I = (function() {
  return this.scm_ArraySeq$ofUnit__f_array.u.length;
});
$c_scm_ArraySeq$ofUnit.prototype.hashCode__I = (function() {
  var this$1 = $m_s_util_hashing_MurmurHash3$();
  var a = this.scm_ArraySeq$ofUnit__f_array;
  return this$1.arrayHash$mVc$sp__Ajl_Void__I__I(a, this$1.s_util_hashing_MurmurHash3$__f_seqSeed);
});
$c_scm_ArraySeq$ofUnit.prototype.equals__O__Z = (function(that) {
  return ((that instanceof $c_scm_ArraySeq$ofUnit) ? (this.scm_ArraySeq$ofUnit__f_array.u.length === that.scm_ArraySeq$ofUnit__f_array.u.length) : $c_scm_ArraySeq.prototype.equals__O__Z.call(this, that));
});
$c_scm_ArraySeq$ofUnit.prototype.iterator__sc_Iterator = (function() {
  return new $c_sc_ArrayOps$ArrayIterator$mcV$sp(this.scm_ArraySeq$ofUnit__f_array);
});
$c_scm_ArraySeq$ofUnit.prototype.apply$mcVI$sp__I__V = (function(index) {
});
$c_scm_ArraySeq$ofUnit.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  this.apply$mcVI$sp__I__V(index);
});
$c_scm_ArraySeq$ofUnit.prototype.apply__I__O = (function(i) {
  this.apply$mcVI$sp__I__V(i);
});
$c_scm_ArraySeq$ofUnit.prototype.elemTag__s_reflect_ClassTag = (function() {
  return $m_s_reflect_ManifestFactory$UnitManifest$();
});
$c_scm_ArraySeq$ofUnit.prototype.array__O = (function() {
  return this.scm_ArraySeq$ofUnit__f_array;
});
function $isArrayOf_scm_ArraySeq$ofUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArraySeq$ofUnit)));
}
export { $isArrayOf_scm_ArraySeq$ofUnit as $isArrayOf_scm_ArraySeq$ofUnit };
var $d_scm_ArraySeq$ofUnit = new $TypeData().initClass($c_scm_ArraySeq$ofUnit, "scala.collection.mutable.ArraySeq$ofUnit", ({
  scm_ArraySeq$ofUnit: 1,
  scm_ArraySeq: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArraySeq$ofUnit as $d_scm_ArraySeq$ofUnit };
function $p_scm_HashMap__put0__O__O__I__Z__s_Some($thiz, key, value, hash, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1));
  }
  var idx = (hash & (((-1) + $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx);
}
export { $p_scm_HashMap__put0__O__O__I__Z__s_Some as $p_scm_HashMap__put0__O__O__I__Z__s_Some };
function $p_scm_HashMap__put0__O__O__Z__s_Some($thiz, key, value, getOld) {
  if ((((1 + $thiz.scm_HashMap__f_contentSize) | 0) >= $thiz.scm_HashMap__f_threshold)) {
    $p_scm_HashMap__growTable__I__V($thiz, ($thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1));
  }
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var idx = (hash & (((-1) + $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
  return $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx);
}
export { $p_scm_HashMap__put0__O__O__Z__s_Some as $p_scm_HashMap__put0__O__O__Z__s_Some };
function $p_scm_HashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx) {
  var x1 = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[idx];
  if ((x1 === null)) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[idx] = new $c_scm_HashMap$Node(key, hash, value, null);
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.scm_HashMap$Node__f__hash <= hash))) {
      if (((n.scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, n.scm_HashMap$Node__f__key))) {
        var old = n.scm_HashMap$Node__f__value;
        n.scm_HashMap$Node__f__value = value;
        return (getOld ? new $c_s_Some(old) : null);
      }
      prev = n;
      n = n.scm_HashMap$Node__f__next;
    }
    if ((prev === null)) {
      $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[idx] = new $c_scm_HashMap$Node(key, hash, value, x1);
    } else {
      prev.scm_HashMap$Node__f__next = new $c_scm_HashMap$Node(key, hash, value, prev.scm_HashMap$Node__f__next);
    }
  }
  $thiz.scm_HashMap__f_contentSize = ((1 + $thiz.scm_HashMap__f_contentSize) | 0);
  return null;
}
export { $p_scm_HashMap__put0__O__O__Z__I__I__s_Some as $p_scm_HashMap__put0__O__O__Z__I__I__s_Some };
function $p_scm_HashMap__remove0__O__scm_HashMap$Node($thiz, elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  return $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, (originalHash ^ ((originalHash >>> 16) | 0)));
}
export { $p_scm_HashMap__remove0__O__scm_HashMap$Node as $p_scm_HashMap__remove0__O__scm_HashMap$Node };
function $p_scm_HashMap__remove0__O__I__scm_HashMap$Node($thiz, elem, hash) {
  var idx = (hash & (((-1) + $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
  var x1 = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[idx];
  if ((x1 === null)) {
    return null;
  } else if (((x1.scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(x1.scm_HashMap$Node__f__key, elem))) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[idx] = x1.scm_HashMap$Node__f__next;
    $thiz.scm_HashMap__f_contentSize = (((-1) + $thiz.scm_HashMap__f_contentSize) | 0);
    return x1;
  } else {
    var prev = x1;
    var next = x1.scm_HashMap$Node__f__next;
    while (((next !== null) && (next.scm_HashMap$Node__f__hash <= hash))) {
      if (((next.scm_HashMap$Node__f__hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(next.scm_HashMap$Node__f__key, elem))) {
        prev.scm_HashMap$Node__f__next = next.scm_HashMap$Node__f__next;
        $thiz.scm_HashMap__f_contentSize = (((-1) + $thiz.scm_HashMap__f_contentSize) | 0);
        return next;
      }
      prev = next;
      next = next.scm_HashMap$Node__f__next;
    }
    return null;
  }
}
export { $p_scm_HashMap__remove0__O__I__scm_HashMap$Node as $p_scm_HashMap__remove0__O__I__scm_HashMap$Node };
function $p_scm_HashMap__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new HashMap table size " + newlen) + " exceeds maximum"));
  }
  var oldlen = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_HashMap__f_contentSize === 0)) {
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)(newlen);
  } else {
    var original = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
    $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = $m_ju_Arrays$().copyOf__AO__I__AO(original, newlen);
    var preLow = new $c_scm_HashMap$Node(null, 0, null, null);
    var preHigh = new $c_scm_HashMap$Node(null, 0, null, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[i];
        if ((old !== null)) {
          preLow.scm_HashMap$Node__f__next = null;
          preHigh.scm_HashMap$Node__f__next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.scm_HashMap$Node__f__next;
            if (((n.scm_HashMap$Node__f__hash & oldlen) === 0)) {
              lastLow.scm_HashMap$Node__f__next = n;
              lastLow = n;
            } else {
              lastHigh.scm_HashMap$Node__f__next = n;
              lastHigh = n;
            }
            n = next;
          }
          lastLow.scm_HashMap$Node__f__next = null;
          if ((old !== preLow.scm_HashMap$Node__f__next)) {
            $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[i] = preLow.scm_HashMap$Node__f__next;
          }
          if ((preHigh.scm_HashMap$Node__f__next !== null)) {
            $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[((i + oldlen) | 0)] = preHigh.scm_HashMap$Node__f__next;
            lastHigh.scm_HashMap$Node__f__next = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
export { $p_scm_HashMap__growTable__I__V as $p_scm_HashMap__growTable__I__V };
function $p_scm_HashMap__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
export { $p_scm_HashMap__tableSizeFor__I__I as $p_scm_HashMap__tableSizeFor__I__I };
function $p_scm_HashMap__newThreshold__I__I($thiz, size) {
  return $doubleToInt((size * $thiz.scm_HashMap__f_loadFactor));
}
export { $p_scm_HashMap__newThreshold__I__I as $p_scm_HashMap__newThreshold__I__I };
function $ct_scm_HashMap__I__D__($thiz, initialCapacity, loadFactor) {
  $thiz.scm_HashMap__f_loadFactor = loadFactor;
  $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table = new ($d_scm_HashMap$Node.getArrayOf().constr)($p_scm_HashMap__tableSizeFor__I__I($thiz, initialCapacity));
  $thiz.scm_HashMap__f_threshold = $p_scm_HashMap__newThreshold__I__I($thiz, $thiz.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length);
  $thiz.scm_HashMap__f_contentSize = 0;
  return $thiz;
}
export { $ct_scm_HashMap__I__D__ as $ct_scm_HashMap__I__D__ };
function $ct_scm_HashMap__($thiz) {
  $ct_scm_HashMap__I__D__($thiz, 16, 0.75);
  return $thiz;
}
export { $ct_scm_HashMap__ as $ct_scm_HashMap__ };
/** @constructor */
function $c_scm_HashMap() {
  this.scm_HashMap__f_loadFactor = 0.0;
  this.scm_HashMap__f_scala$collection$mutable$HashMap$$table = null;
  this.scm_HashMap__f_threshold = 0;
  this.scm_HashMap__f_contentSize = 0;
}
export { $c_scm_HashMap as $c_scm_HashMap };
$c_scm_HashMap.prototype = new $h_scm_AbstractMap();
$c_scm_HashMap.prototype.constructor = $c_scm_HashMap;
/** @constructor */
function $h_scm_HashMap() {
}
export { $h_scm_HashMap as $h_scm_HashMap };
$h_scm_HashMap.prototype = $c_scm_HashMap.prototype;
$c_scm_HashMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$c_scm_HashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_HashMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_HashMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_scm_HashMap.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_HashMap.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_HashMap.prototype.size__I = (function() {
  return this.scm_HashMap__f_contentSize;
});
$c_scm_HashMap.prototype.contains__O__Z = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[(hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0))];
  return (((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash)) !== null);
});
$c_scm_HashMap.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_HashMap__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / this.scm_HashMap__f_loadFactor)));
  if ((target > this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length)) {
    $p_scm_HashMap__growTable__I__V(this, target);
  }
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_HashMap = (function(xs) {
  $f_scm_Builder__sizeHint__sc_IterableOnce__I__V(this, xs, 0);
  if ((xs instanceof $c_sci_HashMap)) {
    var f = new $c_sr_AbstractFunction3_$$Lambda$26e0a25d9b29f6b82ea50ab7badf4fb70c5c74e1(((k$2$2, v$2$2, h$2$2) => {
      var h$2 = (h$2$2 | 0);
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, k$2$2, v$2$2, (h$2 ^ ((h$2 >>> 16) | 0)), false);
    }));
    xs.sci_HashMap__f_rootNode.foreachWithHash__F3__V(f);
    return this;
  } else if ((xs instanceof $c_scm_HashMap)) {
    var iter = xs.nodeIterator__sc_Iterator();
    while (iter.hasNext__Z()) {
      var next = iter.next__O();
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, next.scm_HashMap$Node__f__key, next.scm_HashMap$Node__f__value, next.scm_HashMap$Node__f__hash, false);
    }
    return this;
  } else if ((xs instanceof $c_scm_LinkedHashMap)) {
    var iter$2 = xs.entryIterator__sc_Iterator();
    while (iter$2.hasNext__Z()) {
      var entry = iter$2.next__O();
      $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, entry.scm_LinkedHashMap$LinkedEntry__f_key, entry.scm_LinkedHashMap$LinkedEntry__f_value, entry.scm_LinkedHashMap$LinkedEntry__f_hash, false);
    }
    return this;
  } else {
    return ($is_scm_Map(xs) ? (xs.foreachEntry__F2__V(new $c_sr_AbstractFunction2_$$Lambda$286cbfc6187197affcadc8465aaec93d6b7d20dc(((key$2$2, value$2$2) => {
      var originalHash = $m_sr_Statics$().anyHash__O__I(key$2$2);
      return $p_scm_HashMap__put0__O__O__I__Z__s_Some(this, key$2$2, value$2$2, (originalHash ^ ((originalHash >>> 16) | 0)), false);
    }))), this) : $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, xs));
  }
});
$c_scm_HashMap.prototype.updateWith__O__F1__s_Option = (function(key, remappingFunction) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_scm_MapOps__updateWith__O__F1__s_Option(this, key, remappingFunction);
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var indexedHash = (hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
    var elem = null;
    elem = null;
    var elem$1 = null;
    elem$1 = null;
    var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[indexedHash];
    if ((x1 !== null)) {
      var prev = null;
      var nd = x1;
      while (true) {
        if (((hash === nd.scm_HashMap$Node__f__hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, nd.scm_HashMap$Node__f__key))) {
          elem$1 = prev;
          elem = nd;
        } else if ((!((nd.scm_HashMap$Node__f__next === null) || (nd.scm_HashMap$Node__f__hash > hash)))) {
          var temp$prev = nd;
          var temp$nd = nd.scm_HashMap$Node__f__next;
          prev = temp$prev;
          nd = temp$nd;
          continue;
        }
        break;
      }
    }
    var x1$2 = elem;
    var previousValue = ((x1$2 === null) ? $m_s_None$() : new $c_s_Some(x1$2.scm_HashMap$Node__f__value));
    var nextValue = remappingFunction.apply__O__O(previousValue);
    var x1$3 = $ct_T2__O__O__(new $c_T2(), previousValue, nextValue);
    matchEnd21: {
      var p2 = x1$3.T2__f__1;
      var p3 = x1$3.T2__f__2;
      var x$3 = $m_s_None$();
      if ((x$3 === p2)) {
        var x$5 = $m_s_None$();
        var $x_1 = (x$5 === p3);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        break matchEnd21;
      }
      var p6 = x1$3.T2__f__1;
      var p7 = x1$3.T2__f__2;
      if ((p6 instanceof $c_s_Some)) {
        var x$7 = $m_s_None$();
        var $x_2 = (x$7 === p7);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        if ((elem$1 !== null)) {
          elem$1.scm_HashMap$Node__f__next = elem.scm_HashMap$Node__f__next;
        } else {
          this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[indexedHash] = elem.scm_HashMap$Node__f__next;
        }
        this.scm_HashMap__f_contentSize = (((-1) + this.scm_HashMap__f_contentSize) | 0);
        break matchEnd21;
      }
      var p11 = x1$3.T2__f__1;
      var p12 = x1$3.T2__f__2;
      var x$9 = $m_s_None$();
      if (((x$9 === p11) && (p12 instanceof $c_s_Some))) {
        var value = p12.s_Some__f_value;
        var newIndexedHash = ((((1 + this.scm_HashMap__f_contentSize) | 0) >= this.scm_HashMap__f_threshold) ? ($p_scm_HashMap__growTable__I__V(this, (this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1)), (hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0))) : indexedHash);
        $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(this, key, value, false, hash, newIndexedHash);
        break matchEnd21;
      }
      var p15 = x1$3.T2__f__1;
      var p16 = x1$3.T2__f__2;
      if (((p15 instanceof $c_s_Some) && (p16 instanceof $c_s_Some))) {
        var newValue = p16.s_Some__f_value;
        elem.scm_HashMap$Node__f__value = newValue;
        break matchEnd21;
      }
      throw new $c_s_MatchError(x1$3);
    }
    return nextValue;
  }
});
$c_scm_HashMap.prototype.iterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$1(this));
});
$c_scm_HashMap.prototype.keysIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$2(this));
});
$c_scm_HashMap.prototype.valuesIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$3(this));
});
$c_scm_HashMap.prototype.nodeIterator__sc_Iterator = (function() {
  return ((this.scm_HashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_HashMap$$anon$4(this));
});
$c_scm_HashMap.prototype.get__O__s_Option = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[(hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0))];
  var x1$1 = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $m_s_None$() : new $c_s_Some(x1$1.scm_HashMap$Node__f__value));
});
$c_scm_HashMap.prototype.apply__O__O = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[(hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0))];
  var x1$1 = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
  return ((x1$1 === null) ? $f_sc_MapOps__default__O__O(this, key) : x1$1.scm_HashMap$Node__f__value);
});
$c_scm_HashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[(hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0))];
    var nd = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
    return ((nd === null) ? default$1.apply__O() : nd.scm_HashMap$Node__f__value);
  }
});
$c_scm_HashMap.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_HashMap.getClassOf()))) {
    return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0));
    var x1 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[idx];
    var nd = ((x1 === null) ? null : x1.findNode__O__I__scm_HashMap$Node(key, hash));
    if ((nd !== null)) {
      return nd.scm_HashMap$Node__f__value;
    } else {
      var table0 = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table;
      var default$1 = defaultValue.apply__O();
      if ((((1 + this.scm_HashMap__f_contentSize) | 0) >= this.scm_HashMap__f_threshold)) {
        $p_scm_HashMap__growTable__I__V(this, (this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length << 1));
      }
      var newIdx = ((table0 === this.scm_HashMap__f_scala$collection$mutable$HashMap$$table) ? idx : (hash & (((-1) + this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length) | 0)));
      $p_scm_HashMap__put0__O__O__Z__I__I__s_Some(this, key, default$1, false, hash, newIdx);
      return default$1;
    }
  }
});
$c_scm_HashMap.prototype.remove__O__s_Option = (function(key) {
  var x1 = $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, key);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some(x1.scm_HashMap$Node__f__value));
});
$c_scm_HashMap.prototype.update__O__O__V = (function(key, value) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, key, value, false);
});
$c_scm_HashMap.prototype.addOne__T2__scm_HashMap = (function(elem) {
  $p_scm_HashMap__put0__O__O__Z__s_Some(this, elem._1__O(), elem._2__O(), false);
  return this;
});
$c_scm_HashMap.prototype.subtractOne__O__scm_HashMap = (function(elem) {
  $p_scm_HashMap__remove0__O__scm_HashMap$Node(this, elem);
  return this;
});
$c_scm_HashMap.prototype.knownSize__I = (function() {
  return this.scm_HashMap__f_contentSize;
});
$c_scm_HashMap.prototype.isEmpty__Z = (function() {
  return (this.scm_HashMap__f_contentSize === 0);
});
$c_scm_HashMap.prototype.foreach__F1__V = (function(f) {
  var len = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  var i = 0;
  while ((i < len)) {
    var n = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[i];
    if ((n !== null)) {
      n.foreach__F1__V(f);
    }
    i = ((1 + i) | 0);
  }
});
$c_scm_HashMap.prototype.foreachEntry__F2__V = (function(f) {
  var len = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u.length;
  var i = 0;
  while ((i < len)) {
    var n = this.scm_HashMap__f_scala$collection$mutable$HashMap$$table.u[i];
    if ((n !== null)) {
      n.foreachEntry__F2__V(f);
    }
    i = ((1 + i) | 0);
  }
});
$c_scm_HashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_HashMap$();
});
$c_scm_HashMap.prototype.stringPrefix__T = (function() {
  return "HashMap";
});
$c_scm_HashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash;
  } else {
    var tupleHashIterator = new $c_scm_HashMap$$anon$5(this);
    return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(tupleHashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
  }
});
$c_scm_HashMap.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_HashMap(elem);
});
$c_scm_HashMap.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_HashMap(elem);
});
$c_scm_HashMap.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_HashMap(elems);
});
function $isArrayOf_scm_HashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_HashMap)));
}
export { $isArrayOf_scm_HashMap as $isArrayOf_scm_HashMap };
var $d_scm_HashMap = new $TypeData().initClass($c_scm_HashMap, "scala.collection.mutable.HashMap", ({
  scm_HashMap: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedMapOps: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_HashMap as $d_scm_HashMap };
/** @constructor */
function $c_Lcats_package$$anon$1() {
}
export { $c_Lcats_package$$anon$1 as $c_Lcats_package$$anon$1 };
$c_Lcats_package$$anon$1.prototype = new $h_O();
$c_Lcats_package$$anon$1.prototype.constructor = $c_Lcats_package$$anon$1;
/** @constructor */
function $h_Lcats_package$$anon$1() {
}
export { $h_Lcats_package$$anon$1 as $h_Lcats_package$$anon$1 };
$h_Lcats_package$$anon$1.prototype = $c_Lcats_package$$anon$1.prototype;
$c_Lcats_package$$anon$1.prototype.void__O__O = (function(fa) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, (void 0));
});
$c_Lcats_package$$anon$1.prototype.as__O__O__O = (function(fa, b) {
  return $f_Lcats_Functor__as__O__O__O(this, fa, b);
});
$c_Lcats_package$$anon$1.prototype.product__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__product__O__O__O(this, fa, fb);
});
$c_Lcats_package$$anon$1.prototype.productL__O__O__O = (function(fa, fb) {
  return $f_Lcats_FlatMap__productL__O__O__O(this, fa, fb);
});
$c_Lcats_package$$anon$1.prototype.unit__O = (function() {
  return (void 0);
});
$c_Lcats_package$$anon$1.prototype.compose__Lcats_Applicative__Lcats_Applicative = (function(evidence$1) {
  return new $c_Lcats_Applicative$$anon$1(evidence$1, this);
});
$c_Lcats_package$$anon$1.prototype.toIterable__O__sc_Iterable = (function(fa) {
  return $m_Lcats_compat_FoldableCompat$().toIterable__O__Lcats_Foldable__sc_Iterable(fa, this);
});
$c_Lcats_package$$anon$1.prototype.foldM__O__O__F2__Lcats_Monad__O = (function(fa, z, f, G) {
  return $f_Lcats_Foldable__foldM__O__O__F2__Lcats_Monad__O(this, fa, z, f, G);
});
$c_Lcats_package$$anon$1.prototype.traverseVoid__O__F1__Lcats_Applicative__O = (function(fa, f, G) {
  return $f_Lcats_Foldable__traverseVoid__O__F1__Lcats_Applicative__O(this, fa, f, G);
});
$c_Lcats_package$$anon$1.prototype.exists__O__F1__Z = (function(fa, p) {
  return $f_Lcats_Foldable__exists__O__F1__Z(this, fa, p);
});
$c_Lcats_package$$anon$1.prototype.toList__O__sci_List = (function(fa) {
  return $f_Lcats_Foldable__toList__O__sci_List(this, fa);
});
$c_Lcats_package$$anon$1.prototype.unorderedFoldMap__O__F1__Lcats_kernel_CommutativeMonoid__O = (function(fa, f, evidence$1) {
  return f.apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.traverse__O__F1__Lcats_Applicative__O = (function(fa, f, evidence$1) {
  return f.apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.pure__O__O = (function(a) {
  return a;
});
$c_Lcats_package$$anon$1.prototype.flatMap__O__F1__O = (function(a, f) {
  return f.apply__O__O(a);
});
$c_Lcats_package$$anon$1.prototype.tailRecM__O__F1__O = (function(a, f) {
  var a$tailLocal1 = a;
  while (true) {
    var x1 = f.apply__O__O(a$tailLocal1);
    if ((x1 instanceof $c_s_util_Left)) {
      var a1 = x1.s_util_Left__f_value;
      a$tailLocal1 = a1;
      continue;
    }
    if ((x1 instanceof $c_s_util_Right)) {
      var b = x1.s_util_Right__f_value;
      return b;
    }
    throw new $c_s_MatchError(x1);
  }
});
$c_Lcats_package$$anon$1.prototype.map__O__F1__O = (function(fa, f) {
  return f.apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.flatten__O__O = (function(ffa) {
  return ffa;
});
$c_Lcats_package$$anon$1.prototype.map2__O__O__F2__O = (function(fa, fb, f) {
  return f.apply__O__O__O(fa, fb);
});
$c_Lcats_package$$anon$1.prototype.map2Eval__O__Lcats_Eval__F2__Lcats_Eval = (function(fa, fb, f) {
  return fb.map__F1__Lcats_Eval(new $c_sjsr_AnonFunction1_$$Lambda$3aa60c34ef08a878abffbf4628007cc68fa3c7ab(((_$8) => f.apply__O__O__O(fa, _$8))));
});
$c_Lcats_package$$anon$1.prototype.imap__O__F1__F1__O = (function(fa, f, fi) {
  return f.apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.foldLeft__O__O__F2__O = (function(a, b, f) {
  return f.apply__O__O__O(b, a);
});
$c_Lcats_package$$anon$1.prototype.foldRight__O__Lcats_Eval__F2__Lcats_Eval = (function(a, lb, f) {
  return f.apply__O__O__O(a, lb);
});
$c_Lcats_package$$anon$1.prototype.foldMap__O__F1__Lcats_kernel_Monoid__O = (function(fa, f, B) {
  return f.apply__O__O(fa);
});
$c_Lcats_package$$anon$1.prototype.size__O__J = (function(fa) {
  return new $c_RTLong(1, 0);
});
$c_Lcats_package$$anon$1.prototype.ap__O__O__O = (function(ff, fa) {
  return ff.apply__O__O(fa);
});
var $d_Lcats_package$$anon$1 = new $TypeData().initClass($c_Lcats_package$$anon$1, "cats.package$$anon$1", ({
  Lcats_package$$anon$1: 1,
  Ljava_io_Serializable: 1,
  Lcats_Invariant: 1,
  Lcats_Functor: 1,
  Lcats_Semigroupal: 1,
  Lcats_InvariantSemigroupal: 1,
  Lcats_ApplyArityFunctions: 1,
  Lcats_Apply: 1,
  Lcats_FlatMapArityFunctions: 1,
  Lcats_FlatMap: 1,
  Lcats_InvariantMonoidal: 1,
  Lcats_Applicative: 1,
  Lcats_Monad: 1,
  Lcats_CoflatMap: 1,
  Lcats_Comonad: 1,
  Lcats_Bimonad: 1,
  Lcats_CommutativeApply: 1,
  Lcats_CommutativeFlatMap: 1,
  Lcats_CommutativeApplicative: 1,
  Lcats_CommutativeMonad: 1,
  Lcats_UnorderedFoldable: 1,
  Lcats_FoldableNFunctions: 1,
  Lcats_Foldable: 1,
  Lcats_UnorderedTraverse: 1,
  Lcats_Traverse: 1,
  Lcats_Reducible: 1,
  Lcats_NonEmptyTraverse: 1,
  Lcats_Distributive: 1
}));
export { $d_Lcats_package$$anon$1 as $d_Lcats_package$$anon$1 };
function $ct_sci_BigVector__AO__AO__I__($thiz, _prefix1, suffix1, length0) {
  $thiz.sci_BigVector__f_suffix1 = suffix1;
  $thiz.sci_BigVector__f_length0 = length0;
  $ct_sci_Vector__AO__($thiz, _prefix1);
  return $thiz;
}
export { $ct_sci_BigVector__AO__AO__I__ as $ct_sci_BigVector__AO__AO__I__ };
/** @constructor */
function $c_sci_BigVector() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
}
export { $c_sci_BigVector as $c_sci_BigVector };
$c_sci_BigVector.prototype = new $h_sci_VectorImpl();
$c_sci_BigVector.prototype.constructor = $c_sci_BigVector;
/** @constructor */
function $h_sci_BigVector() {
}
export { $h_sci_BigVector as $h_sci_BigVector };
$h_sci_BigVector.prototype = $c_sci_BigVector.prototype;
$c_sci_BigVector.prototype.foreachRest__F1__V = (function(f) {
  var c = this.vectorSliceCount__I();
  var i = 1;
  while ((i < c)) {
    var $x_1 = $m_sci_VectorStatics$();
    var idx = i;
    var c$1 = ((c / 2) | 0);
    var a = ((idx - c$1) | 0);
    var sign = (a >> 31);
    $x_1.foreachRec__I__AO__F1__V((((-1) + ((((1 + c$1) | 0) - (((a ^ sign) - sign) | 0)) | 0)) | 0), this.vectorSlice__I__AO(i), f);
    i = ((1 + i) | 0);
  }
});
function $isArrayOf_sci_BigVector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_BigVector)));
}
export { $isArrayOf_sci_BigVector as $isArrayOf_sci_BigVector };
/** @constructor */
function $c_sci_Vector1(_data1) {
  this.sci_Vector__f_prefix1 = null;
  $ct_sci_Vector__AO__(this, _data1);
}
export { $c_sci_Vector1 as $c_sci_Vector1 };
$c_sci_Vector1.prototype = new $h_sci_VectorImpl();
$c_sci_Vector1.prototype.constructor = $c_sci_Vector1;
/** @constructor */
function $h_sci_Vector1() {
}
export { $h_sci_Vector1 as $h_sci_Vector1 };
$h_sci_Vector1.prototype = $c_sci_Vector1.prototype;
$c_sci_Vector1.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    return this.sci_Vector__f_prefix1.u[index];
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector1.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    var a1 = this.sci_Vector__f_prefix1;
    var a1c = a1.clone__O();
    a1c.u[index] = elem;
    return new $c_sci_Vector1(a1c);
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector1.prototype.appended__O__sci_Vector = (function(elem) {
  var len1 = this.sci_Vector__f_prefix1.u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_Vector__f_prefix1, elem));
  } else {
    var $x_2 = this.sci_Vector__f_prefix1;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a = new $ac_O(1);
    a.u[0] = elem;
    return new $c_sci_Vector2($x_2, 32, $x_1, a, 33);
  }
});
$c_sci_Vector1.prototype.prepended__O__sci_Vector = (function(elem) {
  var len1 = this.sci_Vector__f_prefix1.u.length;
  if ((len1 < 32)) {
    return new $c_sci_Vector1($m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1));
  } else {
    var a = new $ac_O(1);
    a.u[0] = elem;
    return new $c_sci_Vector2(a, 1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2, this.sci_Vector__f_prefix1, ((1 + len1) | 0));
  }
});
$c_sci_Vector1.prototype.map__F1__sci_Vector = (function(f) {
  return new $c_sci_Vector1($m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f));
});
$c_sci_Vector1.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var original = this.sci_Vector__f_prefix1;
  return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(original, lo, hi));
});
$c_sci_Vector1.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector__f_prefix1.u.length === 1)) {
    return $m_sci_Vector0$();
  } else {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to));
  }
});
$c_sci_Vector1.prototype.init__sci_Vector = (function() {
  if ((this.sci_Vector__f_prefix1.u.length === 1)) {
    return $m_sci_Vector0$();
  } else {
    var a = this.sci_Vector__f_prefix1;
    var to = (((-1) + a.u.length) | 0);
    return new $c_sci_Vector1($m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to));
  }
});
$c_sci_Vector1.prototype.vectorSliceCount__I = (function() {
  return 1;
});
$c_sci_Vector1.prototype.vectorSlice__I__AO = (function(idx) {
  return this.sci_Vector__f_prefix1;
});
$c_sci_Vector1.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var data1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_Vector__f_prefix1, suffix);
  return ((data1b !== null) ? new $c_sci_Vector1(data1b) : $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k));
});
$c_sci_Vector1.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector1.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector1.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector1.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector1.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector1.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem);
});
$c_sci_Vector1.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.sci_Vector__f_prefix1.u.length))) {
    return this.sci_Vector__f_prefix1.u[index];
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
function $isArrayOf_sci_Vector1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector1)));
}
export { $isArrayOf_sci_Vector1 as $isArrayOf_sci_Vector1 };
var $d_sci_Vector1 = new $TypeData().initClass($c_sci_Vector1, "scala.collection.immutable.Vector1", ({
  sci_Vector1: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Vector1 as $d_sci_Vector1 };
/** @constructor */
function $c_sci_$colon$colon(head, next) {
  this.sci_$colon$colon__f_head = null;
  this.sci_$colon$colon__f_next = null;
  this.sci_$colon$colon__f_head = head;
  this.sci_$colon$colon__f_next = next;
}
export { $c_sci_$colon$colon as $c_sci_$colon$colon };
$c_sci_$colon$colon.prototype = new $h_sci_List();
$c_sci_$colon$colon.prototype.constructor = $c_sci_$colon$colon;
/** @constructor */
function $h_sci_$colon$colon() {
}
export { $h_sci_$colon$colon as $h_sci_$colon$colon };
$h_sci_$colon$colon.prototype = $c_sci_$colon$colon.prototype;
$c_sci_$colon$colon.prototype.head__O = (function() {
  return this.sci_$colon$colon__f_head;
});
$c_sci_$colon$colon.prototype.productPrefix__T = (function() {
  return "::";
});
$c_sci_$colon$colon.prototype.productArity__I = (function() {
  return 2;
});
$c_sci_$colon$colon.prototype.productElement__I__O = (function(x$1) {
  switch (x$1) {
    case 0: {
      return this.sci_$colon$colon__f_head;
      break;
    }
    case 1: {
      return this.sci_$colon$colon__f_next;
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_sci_$colon$colon.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_$colon$colon.prototype.productElementName__I__T = (function(x$1) {
  switch (x$1) {
    case 0: {
      return "head";
      break;
    }
    case 1: {
      return "next";
      break;
    }
    default: {
      return $m_sr_Statics$().ioobe__I__O(x$1);
    }
  }
});
$c_sci_$colon$colon.prototype.tail__O = (function() {
  return this.sci_$colon$colon__f_next;
});
$c_sci_$colon$colon.prototype.headOption__s_Option = (function() {
  return new $c_s_Some(this.sci_$colon$colon__f_head);
});
function $isArrayOf_sci_$colon$colon(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_$colon$colon)));
}
export { $isArrayOf_sci_$colon$colon as $isArrayOf_sci_$colon$colon };
var $d_sci_$colon$colon = new $TypeData().initClass($c_sci_$colon$colon, "scala.collection.immutable.$colon$colon", ({
  sci_$colon$colon: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
}));
export { $d_sci_$colon$colon as $d_sci_$colon$colon };
/** @constructor */
function $c_sci_Nil$() {
}
export { $c_sci_Nil$ as $c_sci_Nil$ };
$c_sci_Nil$.prototype = new $h_sci_List();
$c_sci_Nil$.prototype.constructor = $c_sci_Nil$;
/** @constructor */
function $h_sci_Nil$() {
}
export { $h_sci_Nil$ as $h_sci_Nil$ };
$h_sci_Nil$.prototype = $c_sci_Nil$.prototype;
$c_sci_Nil$.prototype.productElementName__I__T = (function(n) {
  return $f_s_Product__productElementName__I__T(this, n);
});
$c_sci_Nil$.prototype.head__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "head of empty list");
});
$c_sci_Nil$.prototype.tail__E = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "tail of empty list");
});
$c_sci_Nil$.prototype.last__E = (function() {
  throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty list");
});
$c_sci_Nil$.prototype.init__E = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "init of empty list");
});
$c_sci_Nil$.prototype.knownSize__I = (function() {
  return 0;
});
$c_sci_Nil$.prototype.iterator__sc_Iterator = (function() {
  return $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
});
$c_sci_Nil$.prototype.productPrefix__T = (function() {
  return "Nil";
});
$c_sci_Nil$.prototype.productArity__I = (function() {
  return 0;
});
$c_sci_Nil$.prototype.productElement__I__O = (function(x$1) {
  return $m_sr_Statics$().ioobe__I__O(x$1);
});
$c_sci_Nil$.prototype.productIterator__sc_Iterator = (function() {
  return new $c_sr_ScalaRunTime$$anon$1(this);
});
$c_sci_Nil$.prototype.init__O = (function() {
  this.init__E();
});
$c_sci_Nil$.prototype.last__O = (function() {
  this.last__E();
});
$c_sci_Nil$.prototype.tail__O = (function() {
  this.tail__E();
});
$c_sci_Nil$.prototype.headOption__s_Option = (function() {
  return $m_s_None$();
});
$c_sci_Nil$.prototype.head__O = (function() {
  this.head__E();
});
var $d_sci_Nil$ = new $TypeData().initClass($c_sci_Nil$, "scala.collection.immutable.Nil$", ({
  sci_Nil$: 1,
  sci_List: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_LinearSeq: 1,
  sc_LinearSeq: 1,
  sc_LinearSeqOps: 1,
  sci_LinearSeqOps: 1,
  sc_StrictOptimizedLinearSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1,
  s_Product: 1
}));
export { $d_sci_Nil$ as $d_sci_Nil$ };
var $n_sci_Nil$;
function $m_sci_Nil$() {
  if ((!$n_sci_Nil$)) {
    $n_sci_Nil$ = new $c_sci_Nil$();
  }
  return $n_sci_Nil$;
}
export { $m_sci_Nil$ as $m_sci_Nil$ };
/** @constructor */
function $c_sci_Vector0$() {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  $ct_sci_BigVector__AO__AO__I__(this, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, $m_sci_VectorStatics$().sci_VectorStatics$__f_empty1, 0);
}
export { $c_sci_Vector0$ as $c_sci_Vector0$ };
$c_sci_Vector0$.prototype = new $h_sci_BigVector();
$c_sci_Vector0$.prototype.constructor = $c_sci_Vector0$;
/** @constructor */
function $h_sci_Vector0$() {
}
export { $h_sci_Vector0$ as $h_sci_Vector0$ };
$h_sci_Vector0$.prototype = $c_sci_Vector0$.prototype;
$c_sci_Vector0$.prototype.apply__I__E = (function(index) {
  throw this.ioob__I__jl_IndexOutOfBoundsException(index);
});
$c_sci_Vector0$.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  throw this.ioob__I__jl_IndexOutOfBoundsException(index);
});
$c_sci_Vector0$.prototype.appended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  a.u[0] = elem;
  return new $c_sci_Vector1(a);
});
$c_sci_Vector0$.prototype.prepended__O__sci_Vector = (function(elem) {
  var a = new $ac_O(1);
  a.u[0] = elem;
  return new $c_sci_Vector1(a);
});
$c_sci_Vector0$.prototype.tail__sci_Vector = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.tail");
});
$c_sci_Vector0$.prototype.init__sci_Vector = (function() {
  throw $ct_jl_UnsupportedOperationException__T__(new $c_jl_UnsupportedOperationException(), "empty.init");
});
$c_sci_Vector0$.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  return this;
});
$c_sci_Vector0$.prototype.vectorSliceCount__I = (function() {
  return 0;
});
$c_sci_Vector0$.prototype.vectorSlice__I__AO = (function(idx) {
  return null;
});
$c_sci_Vector0$.prototype.equals__O__Z = (function(o) {
  return ((this === o) || ((!(o instanceof $c_sci_Vector)) && $f_sc_Seq__equals__O__Z(this, o)));
});
$c_sci_Vector0$.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  return $m_sci_Vector$().from__sc_IterableOnce__sci_Vector(suffix);
});
$c_sci_Vector0$.prototype.ioob__I__jl_IndexOutOfBoundsException = (function(index) {
  return $ct_jl_IndexOutOfBoundsException__T__(new $c_jl_IndexOutOfBoundsException(), (index + " is out of bounds (empty vector)"));
});
$c_sci_Vector0$.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector0$.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector0$.prototype.map__F1__O = (function(f) {
  return this;
});
$c_sci_Vector0$.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector0$.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector0$.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem);
});
$c_sci_Vector0$.prototype.apply__O__O = (function(v1) {
  this.apply__I__E((v1 | 0));
});
$c_sci_Vector0$.prototype.apply__I__O = (function(i) {
  this.apply__I__E(i);
});
var $d_sci_Vector0$ = new $TypeData().initClass($c_sci_Vector0$, "scala.collection.immutable.Vector0$", ({
  sci_Vector0$: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Vector0$ as $d_sci_Vector0$ };
var $n_sci_Vector0$;
function $m_sci_Vector0$() {
  if ((!$n_sci_Vector0$)) {
    $n_sci_Vector0$ = new $c_sci_Vector0$();
  }
  return $n_sci_Vector0$;
}
export { $m_sci_Vector0$ as $m_sci_Vector0$ };
/** @constructor */
function $c_sci_Vector2(_prefix1, len1, data2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector2__f_len1 = 0;
  this.sci_Vector2__f_data2 = null;
  this.sci_Vector2__f_len1 = len1;
  this.sci_Vector2__f_data2 = data2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
export { $c_sci_Vector2 as $c_sci_Vector2 };
$c_sci_Vector2.prototype = new $h_sci_BigVector();
$c_sci_Vector2.prototype.constructor = $c_sci_Vector2;
/** @constructor */
function $h_sci_Vector2() {
}
export { $h_sci_Vector2 as $h_sci_Vector2 };
$h_sci_Vector2.prototype = $c_sci_Vector2.prototype;
$c_sci_Vector2.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.sci_Vector2__f_data2.u.length) ? this.sci_Vector2__f_data2.u[i2].u[i1] : this.sci_BigVector__f_suffix1.u[(31 & io)]);
    } else {
      return this.sci_Vector__f_prefix1.u[index];
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector2.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector2__f_len1)) {
      var io = ((index - this.sci_Vector2__f_len1) | 0);
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      if ((i2 < this.sci_Vector2__f_data2.u.length)) {
        var a2 = this.sci_Vector2__f_data2;
        var a2c = a2.clone__O();
        var a1 = a2c.u[i2];
        var a1c = a1.clone__O();
        a1c.u[i1] = elem;
        a2c.u[i2] = a1c;
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector2__f_len1;
        var x$4 = this.sci_BigVector__f_suffix1;
        var x$5 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$2, x$3, a2c, x$4, x$5);
      } else {
        var a1$1 = this.sci_BigVector__f_suffix1;
        var a1c$1 = a1$1.clone__O();
        a1c$1.u[i1] = elem;
        var x$7 = this.sci_Vector__f_prefix1;
        var x$8 = this.sci_Vector2__f_len1;
        var x$9 = this.sci_Vector2__f_data2;
        var x$10 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector2(x$7, x$8, x$9, a1c$1, x$10);
      }
    } else {
      var a1$2 = this.sci_Vector__f_prefix1;
      var a1c$2 = a1$2.clone__O();
      a1c$2.u[index] = elem;
      var len1 = this.sci_Vector2__f_len1;
      var data2 = this.sci_Vector2__f_data2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector2(a1c$2, len1, data2, suffix1, length0);
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector2.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, x$1, x$2);
  } else if ((this.sci_Vector2__f_data2.u.length < 30)) {
    var x$6 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1);
    var a = new $ac_O(1);
    a.u[0] = elem;
    var x$8 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$9 = this.sci_Vector__f_prefix1;
    var x$10 = this.sci_Vector2__f_len1;
    return new $c_sci_Vector2(x$9, x$10, x$6, a, x$8);
  } else {
    var $x_5 = this.sci_Vector__f_prefix1;
    var $x_4 = this.sci_Vector2__f_len1;
    var $x_3 = this.sci_Vector2__f_data2;
    var $x_2 = this.sci_Vector2__f_len1;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = this.sci_BigVector__f_suffix1;
    var a$1 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    a$1.u[0] = x;
    var a$2 = new $ac_O(1);
    a$2.u[0] = elem;
    return new $c_sci_Vector3($x_5, $x_4, $x_3, ((960 + $x_2) | 0), $x_1, a$1, a$2, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector2.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector2__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector2__f_len1) | 0);
    var x$3 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3);
  } else if ((this.sci_Vector2__f_data2.u.length < 30)) {
    var a = new $ac_O(1);
    a.u[0] = elem;
    var x$8 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector2__f_data2);
    var x$9 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$10 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(a, 1, x$8, x$10, x$9);
  } else {
    var a$1 = new $ac_O(1);
    a$1.u[0] = elem;
    var x = this.sci_Vector__f_prefix1;
    var a$2 = new ($d_O.getArrayOf().getArrayOf().constr)(1);
    a$2.u[0] = x;
    return new $c_sci_Vector3(a$1, 1, a$2, ((1 + this.sci_Vector2__f_len1) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3, this.sci_Vector2__f_data2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector2.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector2__f_data2, f);
  var x$3 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$4 = this.sci_Vector2__f_len1;
  var x$5 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector2(x$1, x$4, x$2, x$3, x$5);
});
$c_sci_Vector2.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector2__f_data2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector2.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector2__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector2__f_len1) | 0);
    var x$3 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$4 = this.sci_Vector2__f_data2;
    var x$5 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector2(x$1, x$2, x$4, x$5, x$3);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector2.prototype.init__sci_Vector = (function() {
  if ((this.sci_BigVector__f_suffix1.u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + a.u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector2.prototype.vectorSliceCount__I = (function() {
  return 3;
});
$c_sci_Vector2.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector2__f_data2;
      break;
    }
    case 2: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector2.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector2__f_len1;
    var x$5 = this.sci_Vector2__f_data2;
    return new $c_sci_Vector2(x$3, x$4, x$5, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector2.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector2.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector2.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector2.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector2.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector2.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem);
});
$c_sci_Vector2.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector2__f_len1) | 0);
    if ((io >= 0)) {
      var i2 = ((io >>> 5) | 0);
      var i1 = (31 & io);
      return ((i2 < this.sci_Vector2__f_data2.u.length) ? this.sci_Vector2__f_data2.u[i2].u[i1] : this.sci_BigVector__f_suffix1.u[(31 & io)]);
    } else {
      return this.sci_Vector__f_prefix1.u[index];
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
function $isArrayOf_sci_Vector2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector2)));
}
export { $isArrayOf_sci_Vector2 as $isArrayOf_sci_Vector2 };
var $d_sci_Vector2 = new $TypeData().initClass($c_sci_Vector2, "scala.collection.immutable.Vector2", ({
  sci_Vector2: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Vector2 as $d_sci_Vector2 };
/** @constructor */
function $c_sci_Vector3(_prefix1, len1, prefix2, len12, data3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector3__f_len1 = 0;
  this.sci_Vector3__f_prefix2 = null;
  this.sci_Vector3__f_len12 = 0;
  this.sci_Vector3__f_data3 = null;
  this.sci_Vector3__f_suffix2 = null;
  this.sci_Vector3__f_len1 = len1;
  this.sci_Vector3__f_prefix2 = prefix2;
  this.sci_Vector3__f_len12 = len12;
  this.sci_Vector3__f_data3 = data3;
  this.sci_Vector3__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
export { $c_sci_Vector3 as $c_sci_Vector3 };
$c_sci_Vector3.prototype = new $h_sci_BigVector();
$c_sci_Vector3.prototype.constructor = $c_sci_Vector3;
/** @constructor */
function $h_sci_Vector3() {
}
export { $h_sci_Vector3 as $h_sci_Vector3 };
$h_sci_Vector3.prototype = $c_sci_Vector3.prototype;
$c_sci_Vector3.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.sci_Vector3__f_data3.u.length) ? this.sci_Vector3__f_data3.u[i3].u[i2].u[i1] : ((i2 < this.sci_Vector3__f_suffix2.u.length) ? this.sci_Vector3__f_suffix2.u[i2].u[i1] : this.sci_BigVector__f_suffix1.u[i1]));
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return this.sci_Vector3__f_prefix2.u[((io$2 >>> 5) | 0)].u[(31 & io$2)];
    } else {
      return this.sci_Vector__f_prefix1.u[index];
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector3.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector3__f_len12)) {
      var io = ((index - this.sci_Vector3__f_len12) | 0);
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i3 < this.sci_Vector3__f_data3.u.length)) {
        var a3 = this.sci_Vector3__f_data3;
        var a3c = a3.clone__O();
        var a2 = a3c.u[i3];
        var a2c = a2.clone__O();
        var a1 = a2c.u[i2];
        var a1c = a1.clone__O();
        a1c.u[i1] = elem;
        a2c.u[i2] = a1c;
        a3c.u[i3] = a2c;
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector3__f_len1;
        var x$4 = this.sci_Vector3__f_prefix2;
        var x$5 = this.sci_Vector3__f_len12;
        var x$6 = this.sci_Vector3__f_suffix2;
        var x$7 = this.sci_BigVector__f_suffix1;
        var x$8 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$2, x$3, x$4, x$5, a3c, x$6, x$7, x$8);
      } else if ((i2 < this.sci_Vector3__f_suffix2.u.length)) {
        var a2$1 = this.sci_Vector3__f_suffix2;
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.u[i2];
        var a1c$1 = a1$1.clone__O();
        a1c$1.u[i1] = elem;
        a2c$1.u[i2] = a1c$1;
        var x$10 = this.sci_Vector__f_prefix1;
        var x$11 = this.sci_Vector3__f_len1;
        var x$12 = this.sci_Vector3__f_prefix2;
        var x$13 = this.sci_Vector3__f_len12;
        var x$14 = this.sci_Vector3__f_data3;
        var x$15 = this.sci_BigVector__f_suffix1;
        var x$16 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$10, x$11, x$12, x$13, x$14, a2c$1, x$15, x$16);
      } else {
        var a1$2 = this.sci_BigVector__f_suffix1;
        var a1c$2 = a1$2.clone__O();
        a1c$2.u[i1] = elem;
        var x$18 = this.sci_Vector__f_prefix1;
        var x$19 = this.sci_Vector3__f_len1;
        var x$20 = this.sci_Vector3__f_prefix2;
        var x$21 = this.sci_Vector3__f_len12;
        var x$22 = this.sci_Vector3__f_data3;
        var x$23 = this.sci_Vector3__f_suffix2;
        var x$24 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector3(x$18, x$19, x$20, x$21, x$22, x$23, a1c$2, x$24);
      }
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      var a2$2 = this.sci_Vector3__f_prefix2;
      var idx2 = ((io$2 >>> 5) | 0);
      var idx1 = (31 & io$2);
      var a2c$2 = a2$2.clone__O();
      var a1$3 = a2c$2.u[idx2];
      var a1c$3 = a1$3.clone__O();
      a1c$3.u[idx1] = elem;
      a2c$2.u[idx2] = a1c$3;
      var x$26 = this.sci_Vector__f_prefix1;
      var x$27 = this.sci_Vector3__f_len1;
      var x$28 = this.sci_Vector3__f_len12;
      var x$29 = this.sci_Vector3__f_data3;
      var x$30 = this.sci_Vector3__f_suffix2;
      var x$31 = this.sci_BigVector__f_suffix1;
      var x$32 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(x$26, x$27, a2c$2, x$28, x$29, x$30, x$31, x$32);
    } else {
      var a1$4 = this.sci_Vector__f_prefix1;
      var a1c$4 = a1$4.clone__O();
      a1c$4.u[index] = elem;
      var len1 = this.sci_Vector3__f_len1;
      var prefix2 = this.sci_Vector3__f_prefix2;
      var len12 = this.sci_Vector3__f_len12;
      var data3 = this.sci_Vector3__f_data3;
      var suffix2 = this.sci_Vector3__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector3(a1c$4, len1, prefix2, len12, data3, suffix2, suffix1, length0);
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector3.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, x$1, x$2);
  } else if ((this.sci_Vector3__f_suffix2.u.length < 31)) {
    var x$9 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1);
    var a = new $ac_O(1);
    a.u[0] = elem;
    var x$11 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$12 = this.sci_Vector__f_prefix1;
    var x$13 = this.sci_Vector3__f_len1;
    var x$14 = this.sci_Vector3__f_prefix2;
    var x$15 = this.sci_Vector3__f_len12;
    var x$16 = this.sci_Vector3__f_data3;
    return new $c_sci_Vector3(x$12, x$13, x$14, x$15, x$16, x$9, a, x$11);
  } else if ((this.sci_Vector3__f_data3.u.length < 30)) {
    var x$17 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_data3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1));
    var x$18 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.u[0] = elem;
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector3__f_len1;
    var x$23 = this.sci_Vector3__f_prefix2;
    var x$24 = this.sci_Vector3__f_len12;
    return new $c_sci_Vector3(x$21, x$22, x$23, x$24, x$17, x$18, a$1, x$20);
  } else {
    var $x_8 = this.sci_Vector__f_prefix1;
    var $x_7 = this.sci_Vector3__f_len1;
    var $x_6 = this.sci_Vector3__f_prefix2;
    var $x_5 = this.sci_Vector3__f_len12;
    var $x_4 = this.sci_Vector3__f_data3;
    var $x_3 = this.sci_Vector3__f_len12;
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1);
    var a$2 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$2.u[0] = x;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.u[0] = elem;
    return new $c_sci_Vector4($x_8, $x_7, $x_6, $x_5, $x_4, ((30720 + $x_3) | 0), $x_2, a$2, $x_1, a$3, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector3.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector3__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector3__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$4 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4);
  } else if ((this.sci_Vector3__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.u[0] = elem;
    var x$11 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2);
    var x$12 = ((1 + this.sci_Vector3__f_len12) | 0);
    var x$13 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$14 = this.sci_Vector3__f_data3;
    var x$15 = this.sci_Vector3__f_suffix2;
    var x$16 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a, 1, x$11, x$12, x$14, x$15, x$16, x$13);
  } else if ((this.sci_Vector3__f_data3.u.length < 30)) {
    var a$1 = new $ac_O(1);
    a$1.u[0] = elem;
    var x$19 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$21 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2), this.sci_Vector3__f_data3);
    var x$22 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$23 = this.sci_Vector3__f_suffix2;
    var x$24 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(a$1, 1, x$19, 1, x$21, x$23, x$24, x$22);
  } else {
    var a$2 = new $ac_O(1);
    a$2.u[0] = elem;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x = $m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector3__f_prefix2);
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$3.u[0] = x;
    return new $c_sci_Vector4(a$2, 1, $x_1, 1, a$3, ((1 + this.sci_Vector3__f_len12) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4, this.sci_Vector3__f_data3, this.sci_Vector3__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector3.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_prefix2, f);
  var x$3 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector3__f_data3, f);
  var x$4 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector3__f_suffix2, f);
  var x$5 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$6 = this.sci_Vector3__f_len1;
  var x$7 = this.sci_Vector3__f_len12;
  var x$8 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector3(x$1, x$6, x$2, x$7, x$3, x$4, x$5, x$8);
});
$c_sci_Vector3.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector3__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector3__f_data3);
  b.consider__I__AO__V(2, this.sci_Vector3__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector3.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector3__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector3__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector3__f_len12) | 0);
    var x$4 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_data3;
    var x$7 = this.sci_Vector3__f_suffix2;
    var x$8 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector3(x$1, x$2, x$5, x$3, x$6, x$7, x$8, x$4);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector3.prototype.init__sci_Vector = (function() {
  if ((this.sci_BigVector__f_suffix1.u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + a.u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector3.prototype.vectorSliceCount__I = (function() {
  return 5;
});
$c_sci_Vector3.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector3__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector3__f_data3;
      break;
    }
    case 3: {
      return this.sci_Vector3__f_suffix2;
      break;
    }
    case 4: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector3.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector3__f_len1;
    var x$5 = this.sci_Vector3__f_prefix2;
    var x$6 = this.sci_Vector3__f_len12;
    var x$7 = this.sci_Vector3__f_data3;
    var x$8 = this.sci_Vector3__f_suffix2;
    return new $c_sci_Vector3(x$3, x$4, x$5, x$6, x$7, x$8, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector3.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector3.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector3.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector3.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector3.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector3.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem);
});
$c_sci_Vector3.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector3__f_len12) | 0);
    if ((io >= 0)) {
      var i3 = ((io >>> 10) | 0);
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i3 < this.sci_Vector3__f_data3.u.length) ? this.sci_Vector3__f_data3.u[i3].u[i2].u[i1] : ((i2 < this.sci_Vector3__f_suffix2.u.length) ? this.sci_Vector3__f_suffix2.u[i2].u[i1] : this.sci_BigVector__f_suffix1.u[i1]));
    } else if ((index >= this.sci_Vector3__f_len1)) {
      var io$2 = ((index - this.sci_Vector3__f_len1) | 0);
      return this.sci_Vector3__f_prefix2.u[((io$2 >>> 5) | 0)].u[(31 & io$2)];
    } else {
      return this.sci_Vector__f_prefix1.u[index];
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
function $isArrayOf_sci_Vector3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector3)));
}
export { $isArrayOf_sci_Vector3 as $isArrayOf_sci_Vector3 };
var $d_sci_Vector3 = new $TypeData().initClass($c_sci_Vector3, "scala.collection.immutable.Vector3", ({
  sci_Vector3: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Vector3 as $d_sci_Vector3 };
/** @constructor */
function $c_sci_Vector4(_prefix1, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector4__f_len1 = 0;
  this.sci_Vector4__f_prefix2 = null;
  this.sci_Vector4__f_len12 = 0;
  this.sci_Vector4__f_prefix3 = null;
  this.sci_Vector4__f_len123 = 0;
  this.sci_Vector4__f_data4 = null;
  this.sci_Vector4__f_suffix3 = null;
  this.sci_Vector4__f_suffix2 = null;
  this.sci_Vector4__f_len1 = len1;
  this.sci_Vector4__f_prefix2 = prefix2;
  this.sci_Vector4__f_len12 = len12;
  this.sci_Vector4__f_prefix3 = prefix3;
  this.sci_Vector4__f_len123 = len123;
  this.sci_Vector4__f_data4 = data4;
  this.sci_Vector4__f_suffix3 = suffix3;
  this.sci_Vector4__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
export { $c_sci_Vector4 as $c_sci_Vector4 };
$c_sci_Vector4.prototype = new $h_sci_BigVector();
$c_sci_Vector4.prototype.constructor = $c_sci_Vector4;
/** @constructor */
function $h_sci_Vector4() {
}
export { $h_sci_Vector4 as $h_sci_Vector4 };
$h_sci_Vector4.prototype = $c_sci_Vector4.prototype;
$c_sci_Vector4.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.sci_Vector4__f_data4.u.length) ? this.sci_Vector4__f_data4.u[i4].u[i3].u[i2].u[i1] : ((i3 < this.sci_Vector4__f_suffix3.u.length) ? this.sci_Vector4__f_suffix3.u[i3].u[i2].u[i1] : ((i2 < this.sci_Vector4__f_suffix2.u.length) ? this.sci_Vector4__f_suffix2.u[i2].u[i1] : this.sci_BigVector__f_suffix1.u[i1])));
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return this.sci_Vector4__f_prefix3.u[((io$2 >>> 10) | 0)].u[(31 & ((io$2 >>> 5) | 0))].u[(31 & io$2)];
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return this.sci_Vector4__f_prefix2.u[((io$3 >>> 5) | 0)].u[(31 & io$3)];
    } else {
      return this.sci_Vector__f_prefix1.u[index];
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector4.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector4__f_len123)) {
      var io = ((index - this.sci_Vector4__f_len123) | 0);
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i4 < this.sci_Vector4__f_data4.u.length)) {
        var a4 = this.sci_Vector4__f_data4;
        var a4c = a4.clone__O();
        var a3 = a4c.u[i4];
        var a3c = a3.clone__O();
        var a2 = a3c.u[i3];
        var a2c = a2.clone__O();
        var a1 = a2c.u[i2];
        var a1c = a1.clone__O();
        a1c.u[i1] = elem;
        a2c.u[i2] = a1c;
        a3c.u[i3] = a2c;
        a4c.u[i4] = a3c;
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector4__f_len1;
        var x$4 = this.sci_Vector4__f_prefix2;
        var x$5 = this.sci_Vector4__f_len12;
        var x$6 = this.sci_Vector4__f_prefix3;
        var x$7 = this.sci_Vector4__f_len123;
        var x$8 = this.sci_Vector4__f_suffix3;
        var x$9 = this.sci_Vector4__f_suffix2;
        var x$10 = this.sci_BigVector__f_suffix1;
        var x$11 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$2, x$3, x$4, x$5, x$6, x$7, a4c, x$8, x$9, x$10, x$11);
      } else if ((i3 < this.sci_Vector4__f_suffix3.u.length)) {
        var a3$1 = this.sci_Vector4__f_suffix3;
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.u[i3];
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.u[i2];
        var a1c$1 = a1$1.clone__O();
        a1c$1.u[i1] = elem;
        a2c$1.u[i2] = a1c$1;
        a3c$1.u[i3] = a2c$1;
        var x$13 = this.sci_Vector__f_prefix1;
        var x$14 = this.sci_Vector4__f_len1;
        var x$15 = this.sci_Vector4__f_prefix2;
        var x$16 = this.sci_Vector4__f_len12;
        var x$17 = this.sci_Vector4__f_prefix3;
        var x$18 = this.sci_Vector4__f_len123;
        var x$19 = this.sci_Vector4__f_data4;
        var x$20 = this.sci_Vector4__f_suffix2;
        var x$21 = this.sci_BigVector__f_suffix1;
        var x$22 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$13, x$14, x$15, x$16, x$17, x$18, x$19, a3c$1, x$20, x$21, x$22);
      } else if ((i2 < this.sci_Vector4__f_suffix2.u.length)) {
        var a2$2 = this.sci_Vector4__f_suffix2;
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.u[i2];
        var a1c$2 = a1$2.clone__O();
        a1c$2.u[i1] = elem;
        a2c$2.u[i2] = a1c$2;
        var x$24 = this.sci_Vector__f_prefix1;
        var x$25 = this.sci_Vector4__f_len1;
        var x$26 = this.sci_Vector4__f_prefix2;
        var x$27 = this.sci_Vector4__f_len12;
        var x$28 = this.sci_Vector4__f_prefix3;
        var x$29 = this.sci_Vector4__f_len123;
        var x$30 = this.sci_Vector4__f_data4;
        var x$31 = this.sci_Vector4__f_suffix3;
        var x$32 = this.sci_BigVector__f_suffix1;
        var x$33 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, a2c$2, x$32, x$33);
      } else {
        var a1$3 = this.sci_BigVector__f_suffix1;
        var a1c$3 = a1$3.clone__O();
        a1c$3.u[i1] = elem;
        var x$35 = this.sci_Vector__f_prefix1;
        var x$36 = this.sci_Vector4__f_len1;
        var x$37 = this.sci_Vector4__f_prefix2;
        var x$38 = this.sci_Vector4__f_len12;
        var x$39 = this.sci_Vector4__f_prefix3;
        var x$40 = this.sci_Vector4__f_len123;
        var x$41 = this.sci_Vector4__f_data4;
        var x$42 = this.sci_Vector4__f_suffix3;
        var x$43 = this.sci_Vector4__f_suffix2;
        var x$44 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector4(x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, a1c$3, x$44);
      }
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      var a3$2 = this.sci_Vector4__f_prefix3;
      var idx3 = ((io$2 >>> 10) | 0);
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a3c$2 = a3$2.clone__O();
      var a2$3 = a3c$2.u[idx3];
      var a2c$3 = a2$3.clone__O();
      var a1$4 = a2c$3.u[idx2];
      var a1c$4 = a1$4.clone__O();
      a1c$4.u[idx1] = elem;
      a2c$3.u[idx2] = a1c$4;
      a3c$2.u[idx3] = a2c$3;
      var x$46 = this.sci_Vector__f_prefix1;
      var x$47 = this.sci_Vector4__f_len1;
      var x$48 = this.sci_Vector4__f_prefix2;
      var x$49 = this.sci_Vector4__f_len12;
      var x$50 = this.sci_Vector4__f_len123;
      var x$51 = this.sci_Vector4__f_data4;
      var x$52 = this.sci_Vector4__f_suffix3;
      var x$53 = this.sci_Vector4__f_suffix2;
      var x$54 = this.sci_BigVector__f_suffix1;
      var x$55 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$46, x$47, x$48, x$49, a3c$2, x$50, x$51, x$52, x$53, x$54, x$55);
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      var a2$4 = this.sci_Vector4__f_prefix2;
      var idx2$1 = ((io$3 >>> 5) | 0);
      var idx1$1 = (31 & io$3);
      var a2c$4 = a2$4.clone__O();
      var a1$5 = a2c$4.u[idx2$1];
      var a1c$5 = a1$5.clone__O();
      a1c$5.u[idx1$1] = elem;
      a2c$4.u[idx2$1] = a1c$5;
      var x$57 = this.sci_Vector__f_prefix1;
      var x$58 = this.sci_Vector4__f_len1;
      var x$59 = this.sci_Vector4__f_len12;
      var x$60 = this.sci_Vector4__f_prefix3;
      var x$61 = this.sci_Vector4__f_len123;
      var x$62 = this.sci_Vector4__f_data4;
      var x$63 = this.sci_Vector4__f_suffix3;
      var x$64 = this.sci_Vector4__f_suffix2;
      var x$65 = this.sci_BigVector__f_suffix1;
      var x$66 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(x$57, x$58, a2c$4, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66);
    } else {
      var a1$6 = this.sci_Vector__f_prefix1;
      var a1c$6 = a1$6.clone__O();
      a1c$6.u[index] = elem;
      var len1 = this.sci_Vector4__f_len1;
      var prefix2 = this.sci_Vector4__f_prefix2;
      var len12 = this.sci_Vector4__f_len12;
      var prefix3 = this.sci_Vector4__f_prefix3;
      var len123 = this.sci_Vector4__f_len123;
      var data4 = this.sci_Vector4__f_data4;
      var suffix3 = this.sci_Vector4__f_suffix3;
      var suffix2 = this.sci_Vector4__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector4(a1c$6, len1, prefix2, len12, prefix3, len123, data4, suffix3, suffix2, suffix1, length0);
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector4.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$1, x$2);
  } else if ((this.sci_Vector4__f_suffix2.u.length < 31)) {
    var x$12 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1);
    var a = new $ac_O(1);
    a.u[0] = elem;
    var x$14 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$15 = this.sci_Vector__f_prefix1;
    var x$16 = this.sci_Vector4__f_len1;
    var x$17 = this.sci_Vector4__f_prefix2;
    var x$18 = this.sci_Vector4__f_len12;
    var x$19 = this.sci_Vector4__f_prefix3;
    var x$20 = this.sci_Vector4__f_len123;
    var x$21 = this.sci_Vector4__f_data4;
    var x$22 = this.sci_Vector4__f_suffix3;
    return new $c_sci_Vector4(x$15, x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$12, a, x$14);
  } else if ((this.sci_Vector4__f_suffix3.u.length < 31)) {
    var x$23 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1));
    var x$24 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.u[0] = elem;
    var x$26 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$27 = this.sci_Vector__f_prefix1;
    var x$28 = this.sci_Vector4__f_len1;
    var x$29 = this.sci_Vector4__f_prefix2;
    var x$30 = this.sci_Vector4__f_len12;
    var x$31 = this.sci_Vector4__f_prefix3;
    var x$32 = this.sci_Vector4__f_len123;
    var x$33 = this.sci_Vector4__f_data4;
    return new $c_sci_Vector4(x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$23, x$24, a$1, x$26);
  } else if ((this.sci_Vector4__f_data4.u.length < 30)) {
    var x$34 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_data4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1)));
    var x$35 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.u[0] = elem;
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector4__f_len1;
    var x$41 = this.sci_Vector4__f_prefix2;
    var x$42 = this.sci_Vector4__f_len12;
    var x$43 = this.sci_Vector4__f_prefix3;
    var x$44 = this.sci_Vector4__f_len123;
    return new $c_sci_Vector4(x$39, x$40, x$41, x$42, x$43, x$44, x$34, x$35, x$36, a$2, x$38);
  } else {
    var $x_11 = this.sci_Vector__f_prefix1;
    var $x_10 = this.sci_Vector4__f_len1;
    var $x_9 = this.sci_Vector4__f_prefix2;
    var $x_8 = this.sci_Vector4__f_len12;
    var $x_7 = this.sci_Vector4__f_prefix3;
    var $x_6 = this.sci_Vector4__f_len123;
    var $x_5 = this.sci_Vector4__f_data4;
    var $x_4 = this.sci_Vector4__f_len123;
    var $x_3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1));
    var a$3 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$3.u[0] = x;
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    a$4.u[0] = elem;
    return new $c_sci_Vector5($x_11, $x_10, $x_9, $x_8, $x_7, $x_6, $x_5, ((983040 + $x_4) | 0), $x_3, a$3, $x_2, $x_1, a$4, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector4.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector4__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector4__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$5 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5);
  } else if ((this.sci_Vector4__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.u[0] = elem;
    var x$14 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2);
    var x$15 = ((1 + this.sci_Vector4__f_len12) | 0);
    var x$16 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector4__f_prefix3;
    var x$19 = this.sci_Vector4__f_data4;
    var x$20 = this.sci_Vector4__f_suffix3;
    var x$21 = this.sci_Vector4__f_suffix2;
    var x$22 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a, 1, x$14, x$15, x$18, x$16, x$19, x$20, x$21, x$22, x$17);
  } else if ((this.sci_Vector4__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.u[0] = elem;
    var x$25 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$27 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3);
    var x$28 = ((1 + this.sci_Vector4__f_len123) | 0);
    var x$29 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$30 = this.sci_Vector4__f_data4;
    var x$31 = this.sci_Vector4__f_suffix3;
    var x$32 = this.sci_Vector4__f_suffix2;
    var x$33 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$1, 1, x$25, 1, x$27, x$28, x$30, x$31, x$32, x$33, x$29);
  } else if ((this.sci_Vector4__f_data4.u.length < 30)) {
    var a$2 = new $ac_O(1);
    a$2.u[0] = elem;
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$38 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$40 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3), this.sci_Vector4__f_data4);
    var x$41 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$42 = this.sci_Vector4__f_suffix3;
    var x$43 = this.sci_Vector4__f_suffix2;
    var x$44 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(a$2, 1, x$36, 1, x$38, 1, x$40, x$42, x$43, x$44, x$41);
  } else {
    var a$3 = new $ac_O(1);
    a$3.u[0] = elem;
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector4__f_prefix2), this.sci_Vector4__f_prefix3);
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$4.u[0] = x;
    return new $c_sci_Vector5(a$3, 1, $x_2, 1, $x_1, 1, a$4, ((1 + this.sci_Vector4__f_len123) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5, this.sci_Vector4__f_data4, this.sci_Vector4__f_suffix3, this.sci_Vector4__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector4.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_prefix2, f);
  var x$3 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_prefix3, f);
  var x$4 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector4__f_data4, f);
  var x$5 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector4__f_suffix3, f);
  var x$6 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector4__f_suffix2, f);
  var x$7 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$8 = this.sci_Vector4__f_len1;
  var x$9 = this.sci_Vector4__f_len12;
  var x$10 = this.sci_Vector4__f_len123;
  var x$11 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector4(x$1, x$8, x$2, x$9, x$3, x$10, x$4, x$5, x$6, x$7, x$11);
});
$c_sci_Vector4.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector4__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector4__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector4__f_data4);
  b.consider__I__AO__V(3, this.sci_Vector4__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector4__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector4.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector4__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector4__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector4__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector4__f_len123) | 0);
    var x$5 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$6 = this.sci_Vector4__f_prefix2;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_data4;
    var x$9 = this.sci_Vector4__f_suffix3;
    var x$10 = this.sci_Vector4__f_suffix2;
    var x$11 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector4(x$1, x$2, x$6, x$3, x$7, x$4, x$8, x$9, x$10, x$11, x$5);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector4.prototype.init__sci_Vector = (function() {
  if ((this.sci_BigVector__f_suffix1.u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + a.u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector4.prototype.vectorSliceCount__I = (function() {
  return 7;
});
$c_sci_Vector4.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector4__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector4__f_prefix3;
      break;
    }
    case 3: {
      return this.sci_Vector4__f_data4;
      break;
    }
    case 4: {
      return this.sci_Vector4__f_suffix3;
      break;
    }
    case 5: {
      return this.sci_Vector4__f_suffix2;
      break;
    }
    case 6: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector4.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector4__f_len1;
    var x$5 = this.sci_Vector4__f_prefix2;
    var x$6 = this.sci_Vector4__f_len12;
    var x$7 = this.sci_Vector4__f_prefix3;
    var x$8 = this.sci_Vector4__f_len123;
    var x$9 = this.sci_Vector4__f_data4;
    var x$10 = this.sci_Vector4__f_suffix3;
    var x$11 = this.sci_Vector4__f_suffix2;
    return new $c_sci_Vector4(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector4.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector4.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector4.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector4.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector4.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector4.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem);
});
$c_sci_Vector4.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector4__f_len123) | 0);
    if ((io >= 0)) {
      var i4 = ((io >>> 15) | 0);
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i4 < this.sci_Vector4__f_data4.u.length) ? this.sci_Vector4__f_data4.u[i4].u[i3].u[i2].u[i1] : ((i3 < this.sci_Vector4__f_suffix3.u.length) ? this.sci_Vector4__f_suffix3.u[i3].u[i2].u[i1] : ((i2 < this.sci_Vector4__f_suffix2.u.length) ? this.sci_Vector4__f_suffix2.u[i2].u[i1] : this.sci_BigVector__f_suffix1.u[i1])));
    } else if ((index >= this.sci_Vector4__f_len12)) {
      var io$2 = ((index - this.sci_Vector4__f_len12) | 0);
      return this.sci_Vector4__f_prefix3.u[((io$2 >>> 10) | 0)].u[(31 & ((io$2 >>> 5) | 0))].u[(31 & io$2)];
    } else if ((index >= this.sci_Vector4__f_len1)) {
      var io$3 = ((index - this.sci_Vector4__f_len1) | 0);
      return this.sci_Vector4__f_prefix2.u[((io$3 >>> 5) | 0)].u[(31 & io$3)];
    } else {
      return this.sci_Vector__f_prefix1.u[index];
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
function $isArrayOf_sci_Vector4(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector4)));
}
export { $isArrayOf_sci_Vector4 as $isArrayOf_sci_Vector4 };
var $d_sci_Vector4 = new $TypeData().initClass($c_sci_Vector4, "scala.collection.immutable.Vector4", ({
  sci_Vector4: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Vector4 as $d_sci_Vector4 };
/** @constructor */
function $c_sci_Vector5(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector5__f_len1 = 0;
  this.sci_Vector5__f_prefix2 = null;
  this.sci_Vector5__f_len12 = 0;
  this.sci_Vector5__f_prefix3 = null;
  this.sci_Vector5__f_len123 = 0;
  this.sci_Vector5__f_prefix4 = null;
  this.sci_Vector5__f_len1234 = 0;
  this.sci_Vector5__f_data5 = null;
  this.sci_Vector5__f_suffix4 = null;
  this.sci_Vector5__f_suffix3 = null;
  this.sci_Vector5__f_suffix2 = null;
  this.sci_Vector5__f_len1 = len1;
  this.sci_Vector5__f_prefix2 = prefix2;
  this.sci_Vector5__f_len12 = len12;
  this.sci_Vector5__f_prefix3 = prefix3;
  this.sci_Vector5__f_len123 = len123;
  this.sci_Vector5__f_prefix4 = prefix4;
  this.sci_Vector5__f_len1234 = len1234;
  this.sci_Vector5__f_data5 = data5;
  this.sci_Vector5__f_suffix4 = suffix4;
  this.sci_Vector5__f_suffix3 = suffix3;
  this.sci_Vector5__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
export { $c_sci_Vector5 as $c_sci_Vector5 };
$c_sci_Vector5.prototype = new $h_sci_BigVector();
$c_sci_Vector5.prototype.constructor = $c_sci_Vector5;
/** @constructor */
function $h_sci_Vector5() {
}
export { $h_sci_Vector5 as $h_sci_Vector5 };
$h_sci_Vector5.prototype = $c_sci_Vector5.prototype;
$c_sci_Vector5.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.sci_Vector5__f_data5.u.length) ? this.sci_Vector5__f_data5.u[i5].u[i4].u[i3].u[i2].u[i1] : ((i4 < this.sci_Vector5__f_suffix4.u.length) ? this.sci_Vector5__f_suffix4.u[i4].u[i3].u[i2].u[i1] : ((i3 < this.sci_Vector5__f_suffix3.u.length) ? this.sci_Vector5__f_suffix3.u[i3].u[i2].u[i1] : ((i2 < this.sci_Vector5__f_suffix2.u.length) ? this.sci_Vector5__f_suffix2.u[i2].u[i1] : this.sci_BigVector__f_suffix1.u[i1]))));
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return this.sci_Vector5__f_prefix4.u[((io$2 >>> 15) | 0)].u[(31 & ((io$2 >>> 10) | 0))].u[(31 & ((io$2 >>> 5) | 0))].u[(31 & io$2)];
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return this.sci_Vector5__f_prefix3.u[((io$3 >>> 10) | 0)].u[(31 & ((io$3 >>> 5) | 0))].u[(31 & io$3)];
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return this.sci_Vector5__f_prefix2.u[((io$4 >>> 5) | 0)].u[(31 & io$4)];
    } else {
      return this.sci_Vector__f_prefix1.u[index];
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector5.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector5__f_len1234)) {
      var io = ((index - this.sci_Vector5__f_len1234) | 0);
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i5 < this.sci_Vector5__f_data5.u.length)) {
        var a5 = this.sci_Vector5__f_data5;
        var a5c = a5.clone__O();
        var a4 = a5c.u[i5];
        var a4c = a4.clone__O();
        var a3 = a4c.u[i4];
        var a3c = a3.clone__O();
        var a2 = a3c.u[i3];
        var a2c = a2.clone__O();
        var a1 = a2c.u[i2];
        var a1c = a1.clone__O();
        a1c.u[i1] = elem;
        a2c.u[i2] = a1c;
        a3c.u[i3] = a2c;
        a4c.u[i4] = a3c;
        a5c.u[i5] = a4c;
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector5__f_len1;
        var x$4 = this.sci_Vector5__f_prefix2;
        var x$5 = this.sci_Vector5__f_len12;
        var x$6 = this.sci_Vector5__f_prefix3;
        var x$7 = this.sci_Vector5__f_len123;
        var x$8 = this.sci_Vector5__f_prefix4;
        var x$9 = this.sci_Vector5__f_len1234;
        var x$10 = this.sci_Vector5__f_suffix4;
        var x$11 = this.sci_Vector5__f_suffix3;
        var x$12 = this.sci_Vector5__f_suffix2;
        var x$13 = this.sci_BigVector__f_suffix1;
        var x$14 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, a5c, x$10, x$11, x$12, x$13, x$14);
      } else if ((i4 < this.sci_Vector5__f_suffix4.u.length)) {
        var a4$1 = this.sci_Vector5__f_suffix4;
        var a4c$1 = a4$1.clone__O();
        var a3$1 = a4c$1.u[i4];
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.u[i3];
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.u[i2];
        var a1c$1 = a1$1.clone__O();
        a1c$1.u[i1] = elem;
        a2c$1.u[i2] = a1c$1;
        a3c$1.u[i3] = a2c$1;
        a4c$1.u[i4] = a3c$1;
        var x$16 = this.sci_Vector__f_prefix1;
        var x$17 = this.sci_Vector5__f_len1;
        var x$18 = this.sci_Vector5__f_prefix2;
        var x$19 = this.sci_Vector5__f_len12;
        var x$20 = this.sci_Vector5__f_prefix3;
        var x$21 = this.sci_Vector5__f_len123;
        var x$22 = this.sci_Vector5__f_prefix4;
        var x$23 = this.sci_Vector5__f_len1234;
        var x$24 = this.sci_Vector5__f_data5;
        var x$25 = this.sci_Vector5__f_suffix3;
        var x$26 = this.sci_Vector5__f_suffix2;
        var x$27 = this.sci_BigVector__f_suffix1;
        var x$28 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$16, x$17, x$18, x$19, x$20, x$21, x$22, x$23, x$24, a4c$1, x$25, x$26, x$27, x$28);
      } else if ((i3 < this.sci_Vector5__f_suffix3.u.length)) {
        var a3$2 = this.sci_Vector5__f_suffix3;
        var a3c$2 = a3$2.clone__O();
        var a2$2 = a3c$2.u[i3];
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.u[i2];
        var a1c$2 = a1$2.clone__O();
        a1c$2.u[i1] = elem;
        a2c$2.u[i2] = a1c$2;
        a3c$2.u[i3] = a2c$2;
        var x$30 = this.sci_Vector__f_prefix1;
        var x$31 = this.sci_Vector5__f_len1;
        var x$32 = this.sci_Vector5__f_prefix2;
        var x$33 = this.sci_Vector5__f_len12;
        var x$34 = this.sci_Vector5__f_prefix3;
        var x$35 = this.sci_Vector5__f_len123;
        var x$36 = this.sci_Vector5__f_prefix4;
        var x$37 = this.sci_Vector5__f_len1234;
        var x$38 = this.sci_Vector5__f_data5;
        var x$39 = this.sci_Vector5__f_suffix4;
        var x$40 = this.sci_Vector5__f_suffix2;
        var x$41 = this.sci_BigVector__f_suffix1;
        var x$42 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$30, x$31, x$32, x$33, x$34, x$35, x$36, x$37, x$38, x$39, a3c$2, x$40, x$41, x$42);
      } else if ((i2 < this.sci_Vector5__f_suffix2.u.length)) {
        var a2$3 = this.sci_Vector5__f_suffix2;
        var a2c$3 = a2$3.clone__O();
        var a1$3 = a2c$3.u[i2];
        var a1c$3 = a1$3.clone__O();
        a1c$3.u[i1] = elem;
        a2c$3.u[i2] = a1c$3;
        var x$44 = this.sci_Vector__f_prefix1;
        var x$45 = this.sci_Vector5__f_len1;
        var x$46 = this.sci_Vector5__f_prefix2;
        var x$47 = this.sci_Vector5__f_len12;
        var x$48 = this.sci_Vector5__f_prefix3;
        var x$49 = this.sci_Vector5__f_len123;
        var x$50 = this.sci_Vector5__f_prefix4;
        var x$51 = this.sci_Vector5__f_len1234;
        var x$52 = this.sci_Vector5__f_data5;
        var x$53 = this.sci_Vector5__f_suffix4;
        var x$54 = this.sci_Vector5__f_suffix3;
        var x$55 = this.sci_BigVector__f_suffix1;
        var x$56 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$52, x$53, x$54, a2c$3, x$55, x$56);
      } else {
        var a1$4 = this.sci_BigVector__f_suffix1;
        var a1c$4 = a1$4.clone__O();
        a1c$4.u[i1] = elem;
        var x$58 = this.sci_Vector__f_prefix1;
        var x$59 = this.sci_Vector5__f_len1;
        var x$60 = this.sci_Vector5__f_prefix2;
        var x$61 = this.sci_Vector5__f_len12;
        var x$62 = this.sci_Vector5__f_prefix3;
        var x$63 = this.sci_Vector5__f_len123;
        var x$64 = this.sci_Vector5__f_prefix4;
        var x$65 = this.sci_Vector5__f_len1234;
        var x$66 = this.sci_Vector5__f_data5;
        var x$67 = this.sci_Vector5__f_suffix4;
        var x$68 = this.sci_Vector5__f_suffix3;
        var x$69 = this.sci_Vector5__f_suffix2;
        var x$70 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector5(x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$69, a1c$4, x$70);
      }
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      var a4$2 = this.sci_Vector5__f_prefix4;
      var idx4 = ((io$2 >>> 15) | 0);
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a4c$2 = a4$2.clone__O();
      var a3$3 = a4c$2.u[idx4];
      var a3c$3 = a3$3.clone__O();
      var a2$4 = a3c$3.u[idx3];
      var a2c$4 = a2$4.clone__O();
      var a1$5 = a2c$4.u[idx2];
      var a1c$5 = a1$5.clone__O();
      a1c$5.u[idx1] = elem;
      a2c$4.u[idx2] = a1c$5;
      a3c$3.u[idx3] = a2c$4;
      a4c$2.u[idx4] = a3c$3;
      var x$72 = this.sci_Vector__f_prefix1;
      var x$73 = this.sci_Vector5__f_len1;
      var x$74 = this.sci_Vector5__f_prefix2;
      var x$75 = this.sci_Vector5__f_len12;
      var x$76 = this.sci_Vector5__f_prefix3;
      var x$77 = this.sci_Vector5__f_len123;
      var x$78 = this.sci_Vector5__f_len1234;
      var x$79 = this.sci_Vector5__f_data5;
      var x$80 = this.sci_Vector5__f_suffix4;
      var x$81 = this.sci_Vector5__f_suffix3;
      var x$82 = this.sci_Vector5__f_suffix2;
      var x$83 = this.sci_BigVector__f_suffix1;
      var x$84 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$72, x$73, x$74, x$75, x$76, x$77, a4c$2, x$78, x$79, x$80, x$81, x$82, x$83, x$84);
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      var a3$4 = this.sci_Vector5__f_prefix3;
      var idx3$1 = ((io$3 >>> 10) | 0);
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a3c$4 = a3$4.clone__O();
      var a2$5 = a3c$4.u[idx3$1];
      var a2c$5 = a2$5.clone__O();
      var a1$6 = a2c$5.u[idx2$1];
      var a1c$6 = a1$6.clone__O();
      a1c$6.u[idx1$1] = elem;
      a2c$5.u[idx2$1] = a1c$6;
      a3c$4.u[idx3$1] = a2c$5;
      var x$86 = this.sci_Vector__f_prefix1;
      var x$87 = this.sci_Vector5__f_len1;
      var x$88 = this.sci_Vector5__f_prefix2;
      var x$89 = this.sci_Vector5__f_len12;
      var x$90 = this.sci_Vector5__f_len123;
      var x$91 = this.sci_Vector5__f_prefix4;
      var x$92 = this.sci_Vector5__f_len1234;
      var x$93 = this.sci_Vector5__f_data5;
      var x$94 = this.sci_Vector5__f_suffix4;
      var x$95 = this.sci_Vector5__f_suffix3;
      var x$96 = this.sci_Vector5__f_suffix2;
      var x$97 = this.sci_BigVector__f_suffix1;
      var x$98 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$86, x$87, x$88, x$89, a3c$4, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98);
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      var a2$6 = this.sci_Vector5__f_prefix2;
      var idx2$2 = ((io$4 >>> 5) | 0);
      var idx1$2 = (31 & io$4);
      var a2c$6 = a2$6.clone__O();
      var a1$7 = a2c$6.u[idx2$2];
      var a1c$7 = a1$7.clone__O();
      a1c$7.u[idx1$2] = elem;
      a2c$6.u[idx2$2] = a1c$7;
      var x$100 = this.sci_Vector__f_prefix1;
      var x$101 = this.sci_Vector5__f_len1;
      var x$102 = this.sci_Vector5__f_len12;
      var x$103 = this.sci_Vector5__f_prefix3;
      var x$104 = this.sci_Vector5__f_len123;
      var x$105 = this.sci_Vector5__f_prefix4;
      var x$106 = this.sci_Vector5__f_len1234;
      var x$107 = this.sci_Vector5__f_data5;
      var x$108 = this.sci_Vector5__f_suffix4;
      var x$109 = this.sci_Vector5__f_suffix3;
      var x$110 = this.sci_Vector5__f_suffix2;
      var x$111 = this.sci_BigVector__f_suffix1;
      var x$112 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(x$100, x$101, a2c$6, x$102, x$103, x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, x$112);
    } else {
      var a1$8 = this.sci_Vector__f_prefix1;
      var a1c$8 = a1$8.clone__O();
      a1c$8.u[index] = elem;
      var len1 = this.sci_Vector5__f_len1;
      var prefix2 = this.sci_Vector5__f_prefix2;
      var len12 = this.sci_Vector5__f_len12;
      var prefix3 = this.sci_Vector5__f_prefix3;
      var len123 = this.sci_Vector5__f_len123;
      var prefix4 = this.sci_Vector5__f_prefix4;
      var len1234 = this.sci_Vector5__f_len1234;
      var data5 = this.sci_Vector5__f_data5;
      var suffix4 = this.sci_Vector5__f_suffix4;
      var suffix3 = this.sci_Vector5__f_suffix3;
      var suffix2 = this.sci_Vector5__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector5(a1c$8, len1, prefix2, len12, prefix3, len123, prefix4, len1234, data5, suffix4, suffix3, suffix2, suffix1, length0);
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector5.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$1, x$2);
  } else if ((this.sci_Vector5__f_suffix2.u.length < 31)) {
    var x$15 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1);
    var a = new $ac_O(1);
    a.u[0] = elem;
    var x$17 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$18 = this.sci_Vector__f_prefix1;
    var x$19 = this.sci_Vector5__f_len1;
    var x$20 = this.sci_Vector5__f_prefix2;
    var x$21 = this.sci_Vector5__f_len12;
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_len123;
    var x$24 = this.sci_Vector5__f_prefix4;
    var x$25 = this.sci_Vector5__f_len1234;
    var x$26 = this.sci_Vector5__f_data5;
    var x$27 = this.sci_Vector5__f_suffix4;
    var x$28 = this.sci_Vector5__f_suffix3;
    return new $c_sci_Vector5(x$18, x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$15, a, x$17);
  } else if ((this.sci_Vector5__f_suffix3.u.length < 31)) {
    var x$29 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1));
    var x$30 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.u[0] = elem;
    var x$32 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$33 = this.sci_Vector__f_prefix1;
    var x$34 = this.sci_Vector5__f_len1;
    var x$35 = this.sci_Vector5__f_prefix2;
    var x$36 = this.sci_Vector5__f_len12;
    var x$37 = this.sci_Vector5__f_prefix3;
    var x$38 = this.sci_Vector5__f_len123;
    var x$39 = this.sci_Vector5__f_prefix4;
    var x$40 = this.sci_Vector5__f_len1234;
    var x$41 = this.sci_Vector5__f_data5;
    var x$42 = this.sci_Vector5__f_suffix4;
    return new $c_sci_Vector5(x$33, x$34, x$35, x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$29, x$30, a$1, x$32);
  } else if ((this.sci_Vector5__f_suffix4.u.length < 31)) {
    var x$43 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)));
    var x$44 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.u[0] = elem;
    var x$47 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$48 = this.sci_Vector__f_prefix1;
    var x$49 = this.sci_Vector5__f_len1;
    var x$50 = this.sci_Vector5__f_prefix2;
    var x$51 = this.sci_Vector5__f_len12;
    var x$52 = this.sci_Vector5__f_prefix3;
    var x$53 = this.sci_Vector5__f_len123;
    var x$54 = this.sci_Vector5__f_prefix4;
    var x$55 = this.sci_Vector5__f_len1234;
    var x$56 = this.sci_Vector5__f_data5;
    return new $c_sci_Vector5(x$48, x$49, x$50, x$51, x$52, x$53, x$54, x$55, x$56, x$43, x$44, x$45, a$2, x$47);
  } else if ((this.sci_Vector5__f_data5.u.length < 30)) {
    var x$57 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_data5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1))));
    var x$58 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$60 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.u[0] = elem;
    var x$62 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$63 = this.sci_Vector__f_prefix1;
    var x$64 = this.sci_Vector5__f_len1;
    var x$65 = this.sci_Vector5__f_prefix2;
    var x$66 = this.sci_Vector5__f_len12;
    var x$67 = this.sci_Vector5__f_prefix3;
    var x$68 = this.sci_Vector5__f_len123;
    var x$69 = this.sci_Vector5__f_prefix4;
    var x$70 = this.sci_Vector5__f_len1234;
    return new $c_sci_Vector5(x$63, x$64, x$65, x$66, x$67, x$68, x$69, x$70, x$57, x$58, x$59, x$60, a$3, x$62);
  } else {
    var $x_14 = this.sci_Vector__f_prefix1;
    var $x_13 = this.sci_Vector5__f_len1;
    var $x_12 = this.sci_Vector5__f_prefix2;
    var $x_11 = this.sci_Vector5__f_len12;
    var $x_10 = this.sci_Vector5__f_prefix3;
    var $x_9 = this.sci_Vector5__f_len123;
    var $x_8 = this.sci_Vector5__f_prefix4;
    var $x_7 = this.sci_Vector5__f_len1234;
    var $x_6 = this.sci_Vector5__f_data5;
    var $x_5 = this.sci_Vector5__f_len1234;
    var $x_4 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6;
    var x = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1)));
    var a$4 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$4.u[0] = x;
    var $x_3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$5 = new $ac_O(1);
    a$5.u[0] = elem;
    return new $c_sci_Vector6($x_14, $x_13, $x_12, $x_11, $x_10, $x_9, $x_8, $x_7, $x_6, ((31457280 + $x_5) | 0), $x_4, a$4, $x_3, $x_2, $x_1, a$5, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector5.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector5__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector5__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$6 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6);
  } else if ((this.sci_Vector5__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.u[0] = elem;
    var x$17 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2);
    var x$18 = ((1 + this.sci_Vector5__f_len12) | 0);
    var x$19 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$20 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$21 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$22 = this.sci_Vector5__f_prefix3;
    var x$23 = this.sci_Vector5__f_prefix4;
    var x$24 = this.sci_Vector5__f_data5;
    var x$25 = this.sci_Vector5__f_suffix4;
    var x$26 = this.sci_Vector5__f_suffix3;
    var x$27 = this.sci_Vector5__f_suffix2;
    var x$28 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a, 1, x$17, x$18, x$22, x$19, x$23, x$20, x$24, x$25, x$26, x$27, x$28, x$21);
  } else if ((this.sci_Vector5__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.u[0] = elem;
    var x$31 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$33 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3);
    var x$34 = ((1 + this.sci_Vector5__f_len123) | 0);
    var x$35 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$36 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$37 = this.sci_Vector5__f_prefix4;
    var x$38 = this.sci_Vector5__f_data5;
    var x$39 = this.sci_Vector5__f_suffix4;
    var x$40 = this.sci_Vector5__f_suffix3;
    var x$41 = this.sci_Vector5__f_suffix2;
    var x$42 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$1, 1, x$31, 1, x$33, x$34, x$37, x$35, x$38, x$39, x$40, x$41, x$42, x$36);
  } else if ((this.sci_Vector5__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.u[0] = elem;
    var x$45 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$47 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$49 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4);
    var x$50 = ((1 + this.sci_Vector5__f_len1234) | 0);
    var x$51 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$52 = this.sci_Vector5__f_data5;
    var x$53 = this.sci_Vector5__f_suffix4;
    var x$54 = this.sci_Vector5__f_suffix3;
    var x$55 = this.sci_Vector5__f_suffix2;
    var x$56 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$2, 1, x$45, 1, x$47, 1, x$49, x$50, x$52, x$53, x$54, x$55, x$56, x$51);
  } else if ((this.sci_Vector5__f_data5.u.length < 30)) {
    var a$3 = new $ac_O(1);
    a$3.u[0] = elem;
    var x$59 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$61 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$63 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$65 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4), this.sci_Vector5__f_data5);
    var x$66 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$67 = this.sci_Vector5__f_suffix4;
    var x$68 = this.sci_Vector5__f_suffix3;
    var x$69 = this.sci_Vector5__f_suffix2;
    var x$70 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(a$3, 1, x$59, 1, x$61, 1, x$63, 1, x$65, x$67, x$68, x$69, x$70, x$66);
  } else {
    var a$4 = new $ac_O(1);
    a$4.u[0] = elem;
    var $x_3 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var $x_2 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var $x_1 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector5__f_prefix2), this.sci_Vector5__f_prefix3), this.sci_Vector5__f_prefix4);
    var a$5 = new ($d_O.getArrayOf().getArrayOf().getArrayOf().getArrayOf().getArrayOf().constr)(1);
    a$5.u[0] = x;
    return new $c_sci_Vector6(a$4, 1, $x_3, 1, $x_2, 1, $x_1, 1, a$5, ((1 + this.sci_Vector5__f_len1234) | 0), $m_sci_VectorStatics$().sci_VectorStatics$__f_empty6, this.sci_Vector5__f_data5, this.sci_Vector5__f_suffix4, this.sci_Vector5__f_suffix3, this.sci_Vector5__f_suffix2, this.sci_BigVector__f_suffix1, ((1 + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector5.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_prefix2, f);
  var x$3 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_prefix3, f);
  var x$4 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_prefix4, f);
  var x$5 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector5__f_data5, f);
  var x$6 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector5__f_suffix4, f);
  var x$7 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector5__f_suffix3, f);
  var x$8 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector5__f_suffix2, f);
  var x$9 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$10 = this.sci_Vector5__f_len1;
  var x$11 = this.sci_Vector5__f_len12;
  var x$12 = this.sci_Vector5__f_len123;
  var x$13 = this.sci_Vector5__f_len1234;
  var x$14 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector5(x$1, x$10, x$2, x$11, x$3, x$12, x$4, x$13, x$5, x$6, x$7, x$8, x$9, x$14);
});
$c_sci_Vector5.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector5__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector5__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector5__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector5__f_data5);
  b.consider__I__AO__V(4, this.sci_Vector5__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector5__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector5__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector5.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector5__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector5__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector5__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector5__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector5__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$7 = this.sci_Vector5__f_prefix2;
    var x$8 = this.sci_Vector5__f_prefix3;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_data5;
    var x$11 = this.sci_Vector5__f_suffix4;
    var x$12 = this.sci_Vector5__f_suffix3;
    var x$13 = this.sci_Vector5__f_suffix2;
    var x$14 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector5(x$1, x$2, x$7, x$3, x$8, x$4, x$9, x$5, x$10, x$11, x$12, x$13, x$14, x$6);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector5.prototype.init__sci_Vector = (function() {
  if ((this.sci_BigVector__f_suffix1.u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + a.u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector5.prototype.vectorSliceCount__I = (function() {
  return 9;
});
$c_sci_Vector5.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector5__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector5__f_prefix3;
      break;
    }
    case 3: {
      return this.sci_Vector5__f_prefix4;
      break;
    }
    case 4: {
      return this.sci_Vector5__f_data5;
      break;
    }
    case 5: {
      return this.sci_Vector5__f_suffix4;
      break;
    }
    case 6: {
      return this.sci_Vector5__f_suffix3;
      break;
    }
    case 7: {
      return this.sci_Vector5__f_suffix2;
      break;
    }
    case 8: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector5.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector5__f_len1;
    var x$5 = this.sci_Vector5__f_prefix2;
    var x$6 = this.sci_Vector5__f_len12;
    var x$7 = this.sci_Vector5__f_prefix3;
    var x$8 = this.sci_Vector5__f_len123;
    var x$9 = this.sci_Vector5__f_prefix4;
    var x$10 = this.sci_Vector5__f_len1234;
    var x$11 = this.sci_Vector5__f_data5;
    var x$12 = this.sci_Vector5__f_suffix4;
    var x$13 = this.sci_Vector5__f_suffix3;
    var x$14 = this.sci_Vector5__f_suffix2;
    return new $c_sci_Vector5(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector5.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector5.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector5.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector5.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector5.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector5.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem);
});
$c_sci_Vector5.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector5__f_len1234) | 0);
    if ((io >= 0)) {
      var i5 = ((io >>> 20) | 0);
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i5 < this.sci_Vector5__f_data5.u.length) ? this.sci_Vector5__f_data5.u[i5].u[i4].u[i3].u[i2].u[i1] : ((i4 < this.sci_Vector5__f_suffix4.u.length) ? this.sci_Vector5__f_suffix4.u[i4].u[i3].u[i2].u[i1] : ((i3 < this.sci_Vector5__f_suffix3.u.length) ? this.sci_Vector5__f_suffix3.u[i3].u[i2].u[i1] : ((i2 < this.sci_Vector5__f_suffix2.u.length) ? this.sci_Vector5__f_suffix2.u[i2].u[i1] : this.sci_BigVector__f_suffix1.u[i1]))));
    } else if ((index >= this.sci_Vector5__f_len123)) {
      var io$2 = ((index - this.sci_Vector5__f_len123) | 0);
      return this.sci_Vector5__f_prefix4.u[((io$2 >>> 15) | 0)].u[(31 & ((io$2 >>> 10) | 0))].u[(31 & ((io$2 >>> 5) | 0))].u[(31 & io$2)];
    } else if ((index >= this.sci_Vector5__f_len12)) {
      var io$3 = ((index - this.sci_Vector5__f_len12) | 0);
      return this.sci_Vector5__f_prefix3.u[((io$3 >>> 10) | 0)].u[(31 & ((io$3 >>> 5) | 0))].u[(31 & io$3)];
    } else if ((index >= this.sci_Vector5__f_len1)) {
      var io$4 = ((index - this.sci_Vector5__f_len1) | 0);
      return this.sci_Vector5__f_prefix2.u[((io$4 >>> 5) | 0)].u[(31 & io$4)];
    } else {
      return this.sci_Vector__f_prefix1.u[index];
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
function $isArrayOf_sci_Vector5(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector5)));
}
export { $isArrayOf_sci_Vector5 as $isArrayOf_sci_Vector5 };
var $d_sci_Vector5 = new $TypeData().initClass($c_sci_Vector5, "scala.collection.immutable.Vector5", ({
  sci_Vector5: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Vector5 as $d_sci_Vector5 };
/** @constructor */
function $c_sci_Vector6(_prefix1, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, _suffix1, _length0) {
  this.sci_Vector__f_prefix1 = null;
  this.sci_BigVector__f_suffix1 = null;
  this.sci_BigVector__f_length0 = 0;
  this.sci_Vector6__f_len1 = 0;
  this.sci_Vector6__f_prefix2 = null;
  this.sci_Vector6__f_len12 = 0;
  this.sci_Vector6__f_prefix3 = null;
  this.sci_Vector6__f_len123 = 0;
  this.sci_Vector6__f_prefix4 = null;
  this.sci_Vector6__f_len1234 = 0;
  this.sci_Vector6__f_prefix5 = null;
  this.sci_Vector6__f_len12345 = 0;
  this.sci_Vector6__f_data6 = null;
  this.sci_Vector6__f_suffix5 = null;
  this.sci_Vector6__f_suffix4 = null;
  this.sci_Vector6__f_suffix3 = null;
  this.sci_Vector6__f_suffix2 = null;
  this.sci_Vector6__f_len1 = len1;
  this.sci_Vector6__f_prefix2 = prefix2;
  this.sci_Vector6__f_len12 = len12;
  this.sci_Vector6__f_prefix3 = prefix3;
  this.sci_Vector6__f_len123 = len123;
  this.sci_Vector6__f_prefix4 = prefix4;
  this.sci_Vector6__f_len1234 = len1234;
  this.sci_Vector6__f_prefix5 = prefix5;
  this.sci_Vector6__f_len12345 = len12345;
  this.sci_Vector6__f_data6 = data6;
  this.sci_Vector6__f_suffix5 = suffix5;
  this.sci_Vector6__f_suffix4 = suffix4;
  this.sci_Vector6__f_suffix3 = suffix3;
  this.sci_Vector6__f_suffix2 = suffix2;
  $ct_sci_BigVector__AO__AO__I__(this, _prefix1, _suffix1, _length0);
}
export { $c_sci_Vector6 as $c_sci_Vector6 };
$c_sci_Vector6.prototype = new $h_sci_BigVector();
$c_sci_Vector6.prototype.constructor = $c_sci_Vector6;
/** @constructor */
function $h_sci_Vector6() {
}
export { $h_sci_Vector6 as $h_sci_Vector6 };
$h_sci_Vector6.prototype = $c_sci_Vector6.prototype;
$c_sci_Vector6.prototype.apply__I__O = (function(index) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.sci_Vector6__f_data6.u.length) ? this.sci_Vector6__f_data6.u[i6].u[i5].u[i4].u[i3].u[i2].u[i1] : ((i5 < this.sci_Vector6__f_suffix5.u.length) ? this.sci_Vector6__f_suffix5.u[i5].u[i4].u[i3].u[i2].u[i1] : ((i4 < this.sci_Vector6__f_suffix4.u.length) ? this.sci_Vector6__f_suffix4.u[i4].u[i3].u[i2].u[i1] : ((i3 < this.sci_Vector6__f_suffix3.u.length) ? this.sci_Vector6__f_suffix3.u[i3].u[i2].u[i1] : ((i2 < this.sci_Vector6__f_suffix2.u.length) ? this.sci_Vector6__f_suffix2.u[i2].u[i1] : this.sci_BigVector__f_suffix1.u[i1])))));
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return this.sci_Vector6__f_prefix5.u[((io$2 >>> 20) | 0)].u[(31 & ((io$2 >>> 15) | 0))].u[(31 & ((io$2 >>> 10) | 0))].u[(31 & ((io$2 >>> 5) | 0))].u[(31 & io$2)];
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return this.sci_Vector6__f_prefix4.u[((io$3 >>> 15) | 0)].u[(31 & ((io$3 >>> 10) | 0))].u[(31 & ((io$3 >>> 5) | 0))].u[(31 & io$3)];
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return this.sci_Vector6__f_prefix3.u[((io$4 >>> 10) | 0)].u[(31 & ((io$4 >>> 5) | 0))].u[(31 & io$4)];
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return this.sci_Vector6__f_prefix2.u[((io$5 >>> 5) | 0)].u[(31 & io$5)];
    } else {
      return this.sci_Vector__f_prefix1.u[index];
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector6.prototype.updated__I__O__sci_Vector = (function(index, elem) {
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    if ((index >= this.sci_Vector6__f_len12345)) {
      var io = ((index - this.sci_Vector6__f_len12345) | 0);
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      if ((i6 < this.sci_Vector6__f_data6.u.length)) {
        var a6 = this.sci_Vector6__f_data6;
        var a6c = a6.clone__O();
        var a5 = a6c.u[i6];
        var a5c = a5.clone__O();
        var a4 = a5c.u[i5];
        var a4c = a4.clone__O();
        var a3 = a4c.u[i4];
        var a3c = a3.clone__O();
        var a2 = a3c.u[i3];
        var a2c = a2.clone__O();
        var a1 = a2c.u[i2];
        var a1c = a1.clone__O();
        a1c.u[i1] = elem;
        a2c.u[i2] = a1c;
        a3c.u[i3] = a2c;
        a4c.u[i4] = a3c;
        a5c.u[i5] = a4c;
        a6c.u[i6] = a5c;
        var x$2 = this.sci_Vector__f_prefix1;
        var x$3 = this.sci_Vector6__f_len1;
        var x$4 = this.sci_Vector6__f_prefix2;
        var x$5 = this.sci_Vector6__f_len12;
        var x$6 = this.sci_Vector6__f_prefix3;
        var x$7 = this.sci_Vector6__f_len123;
        var x$8 = this.sci_Vector6__f_prefix4;
        var x$9 = this.sci_Vector6__f_len1234;
        var x$10 = this.sci_Vector6__f_prefix5;
        var x$11 = this.sci_Vector6__f_len12345;
        var x$12 = this.sci_Vector6__f_suffix5;
        var x$13 = this.sci_Vector6__f_suffix4;
        var x$14 = this.sci_Vector6__f_suffix3;
        var x$15 = this.sci_Vector6__f_suffix2;
        var x$16 = this.sci_BigVector__f_suffix1;
        var x$17 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$2, x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, a6c, x$12, x$13, x$14, x$15, x$16, x$17);
      } else if ((i5 < this.sci_Vector6__f_suffix5.u.length)) {
        var a5$1 = this.sci_Vector6__f_suffix5;
        var a5c$1 = a5$1.clone__O();
        var a4$1 = a5c$1.u[i5];
        var a4c$1 = a4$1.clone__O();
        var a3$1 = a4c$1.u[i4];
        var a3c$1 = a3$1.clone__O();
        var a2$1 = a3c$1.u[i3];
        var a2c$1 = a2$1.clone__O();
        var a1$1 = a2c$1.u[i2];
        var a1c$1 = a1$1.clone__O();
        a1c$1.u[i1] = elem;
        a2c$1.u[i2] = a1c$1;
        a3c$1.u[i3] = a2c$1;
        a4c$1.u[i4] = a3c$1;
        a5c$1.u[i5] = a4c$1;
        var x$19 = this.sci_Vector__f_prefix1;
        var x$20 = this.sci_Vector6__f_len1;
        var x$21 = this.sci_Vector6__f_prefix2;
        var x$22 = this.sci_Vector6__f_len12;
        var x$23 = this.sci_Vector6__f_prefix3;
        var x$24 = this.sci_Vector6__f_len123;
        var x$25 = this.sci_Vector6__f_prefix4;
        var x$26 = this.sci_Vector6__f_len1234;
        var x$27 = this.sci_Vector6__f_prefix5;
        var x$28 = this.sci_Vector6__f_len12345;
        var x$29 = this.sci_Vector6__f_data6;
        var x$30 = this.sci_Vector6__f_suffix4;
        var x$31 = this.sci_Vector6__f_suffix3;
        var x$32 = this.sci_Vector6__f_suffix2;
        var x$33 = this.sci_BigVector__f_suffix1;
        var x$34 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$19, x$20, x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, a5c$1, x$30, x$31, x$32, x$33, x$34);
      } else if ((i4 < this.sci_Vector6__f_suffix4.u.length)) {
        var a4$2 = this.sci_Vector6__f_suffix4;
        var a4c$2 = a4$2.clone__O();
        var a3$2 = a4c$2.u[i4];
        var a3c$2 = a3$2.clone__O();
        var a2$2 = a3c$2.u[i3];
        var a2c$2 = a2$2.clone__O();
        var a1$2 = a2c$2.u[i2];
        var a1c$2 = a1$2.clone__O();
        a1c$2.u[i1] = elem;
        a2c$2.u[i2] = a1c$2;
        a3c$2.u[i3] = a2c$2;
        a4c$2.u[i4] = a3c$2;
        var x$36 = this.sci_Vector__f_prefix1;
        var x$37 = this.sci_Vector6__f_len1;
        var x$38 = this.sci_Vector6__f_prefix2;
        var x$39 = this.sci_Vector6__f_len12;
        var x$40 = this.sci_Vector6__f_prefix3;
        var x$41 = this.sci_Vector6__f_len123;
        var x$42 = this.sci_Vector6__f_prefix4;
        var x$43 = this.sci_Vector6__f_len1234;
        var x$44 = this.sci_Vector6__f_prefix5;
        var x$45 = this.sci_Vector6__f_len12345;
        var x$46 = this.sci_Vector6__f_data6;
        var x$47 = this.sci_Vector6__f_suffix5;
        var x$48 = this.sci_Vector6__f_suffix3;
        var x$49 = this.sci_Vector6__f_suffix2;
        var x$50 = this.sci_BigVector__f_suffix1;
        var x$51 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$36, x$37, x$38, x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, a4c$2, x$48, x$49, x$50, x$51);
      } else if ((i3 < this.sci_Vector6__f_suffix3.u.length)) {
        var a3$3 = this.sci_Vector6__f_suffix3;
        var a3c$3 = a3$3.clone__O();
        var a2$3 = a3c$3.u[i3];
        var a2c$3 = a2$3.clone__O();
        var a1$3 = a2c$3.u[i2];
        var a1c$3 = a1$3.clone__O();
        a1c$3.u[i1] = elem;
        a2c$3.u[i2] = a1c$3;
        a3c$3.u[i3] = a2c$3;
        var x$53 = this.sci_Vector__f_prefix1;
        var x$54 = this.sci_Vector6__f_len1;
        var x$55 = this.sci_Vector6__f_prefix2;
        var x$56 = this.sci_Vector6__f_len12;
        var x$57 = this.sci_Vector6__f_prefix3;
        var x$58 = this.sci_Vector6__f_len123;
        var x$59 = this.sci_Vector6__f_prefix4;
        var x$60 = this.sci_Vector6__f_len1234;
        var x$61 = this.sci_Vector6__f_prefix5;
        var x$62 = this.sci_Vector6__f_len12345;
        var x$63 = this.sci_Vector6__f_data6;
        var x$64 = this.sci_Vector6__f_suffix5;
        var x$65 = this.sci_Vector6__f_suffix4;
        var x$66 = this.sci_Vector6__f_suffix2;
        var x$67 = this.sci_BigVector__f_suffix1;
        var x$68 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$53, x$54, x$55, x$56, x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, a3c$3, x$66, x$67, x$68);
      } else if ((i2 < this.sci_Vector6__f_suffix2.u.length)) {
        var a2$4 = this.sci_Vector6__f_suffix2;
        var a2c$4 = a2$4.clone__O();
        var a1$4 = a2c$4.u[i2];
        var a1c$4 = a1$4.clone__O();
        a1c$4.u[i1] = elem;
        a2c$4.u[i2] = a1c$4;
        var x$70 = this.sci_Vector__f_prefix1;
        var x$71 = this.sci_Vector6__f_len1;
        var x$72 = this.sci_Vector6__f_prefix2;
        var x$73 = this.sci_Vector6__f_len12;
        var x$74 = this.sci_Vector6__f_prefix3;
        var x$75 = this.sci_Vector6__f_len123;
        var x$76 = this.sci_Vector6__f_prefix4;
        var x$77 = this.sci_Vector6__f_len1234;
        var x$78 = this.sci_Vector6__f_prefix5;
        var x$79 = this.sci_Vector6__f_len12345;
        var x$80 = this.sci_Vector6__f_data6;
        var x$81 = this.sci_Vector6__f_suffix5;
        var x$82 = this.sci_Vector6__f_suffix4;
        var x$83 = this.sci_Vector6__f_suffix3;
        var x$84 = this.sci_BigVector__f_suffix1;
        var x$85 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$70, x$71, x$72, x$73, x$74, x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, a2c$4, x$84, x$85);
      } else {
        var a1$5 = this.sci_BigVector__f_suffix1;
        var a1c$5 = a1$5.clone__O();
        a1c$5.u[i1] = elem;
        var x$87 = this.sci_Vector__f_prefix1;
        var x$88 = this.sci_Vector6__f_len1;
        var x$89 = this.sci_Vector6__f_prefix2;
        var x$90 = this.sci_Vector6__f_len12;
        var x$91 = this.sci_Vector6__f_prefix3;
        var x$92 = this.sci_Vector6__f_len123;
        var x$93 = this.sci_Vector6__f_prefix4;
        var x$94 = this.sci_Vector6__f_len1234;
        var x$95 = this.sci_Vector6__f_prefix5;
        var x$96 = this.sci_Vector6__f_len12345;
        var x$97 = this.sci_Vector6__f_data6;
        var x$98 = this.sci_Vector6__f_suffix5;
        var x$99 = this.sci_Vector6__f_suffix4;
        var x$100 = this.sci_Vector6__f_suffix3;
        var x$101 = this.sci_Vector6__f_suffix2;
        var x$102 = this.sci_BigVector__f_length0;
        return new $c_sci_Vector6(x$87, x$88, x$89, x$90, x$91, x$92, x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, a1c$5, x$102);
      }
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      var a5$2 = this.sci_Vector6__f_prefix5;
      var idx5 = ((io$2 >>> 20) | 0);
      var idx4 = (31 & ((io$2 >>> 15) | 0));
      var idx3 = (31 & ((io$2 >>> 10) | 0));
      var idx2 = (31 & ((io$2 >>> 5) | 0));
      var idx1 = (31 & io$2);
      var a5c$2 = a5$2.clone__O();
      var a4$3 = a5c$2.u[idx5];
      var a4c$3 = a4$3.clone__O();
      var a3$4 = a4c$3.u[idx4];
      var a3c$4 = a3$4.clone__O();
      var a2$5 = a3c$4.u[idx3];
      var a2c$5 = a2$5.clone__O();
      var a1$6 = a2c$5.u[idx2];
      var a1c$6 = a1$6.clone__O();
      a1c$6.u[idx1] = elem;
      a2c$5.u[idx2] = a1c$6;
      a3c$4.u[idx3] = a2c$5;
      a4c$3.u[idx4] = a3c$4;
      a5c$2.u[idx5] = a4c$3;
      var x$104 = this.sci_Vector__f_prefix1;
      var x$105 = this.sci_Vector6__f_len1;
      var x$106 = this.sci_Vector6__f_prefix2;
      var x$107 = this.sci_Vector6__f_len12;
      var x$108 = this.sci_Vector6__f_prefix3;
      var x$109 = this.sci_Vector6__f_len123;
      var x$110 = this.sci_Vector6__f_prefix4;
      var x$111 = this.sci_Vector6__f_len1234;
      var x$112 = this.sci_Vector6__f_len12345;
      var x$113 = this.sci_Vector6__f_data6;
      var x$114 = this.sci_Vector6__f_suffix5;
      var x$115 = this.sci_Vector6__f_suffix4;
      var x$116 = this.sci_Vector6__f_suffix3;
      var x$117 = this.sci_Vector6__f_suffix2;
      var x$118 = this.sci_BigVector__f_suffix1;
      var x$119 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$104, x$105, x$106, x$107, x$108, x$109, x$110, x$111, a5c$2, x$112, x$113, x$114, x$115, x$116, x$117, x$118, x$119);
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      var a4$4 = this.sci_Vector6__f_prefix4;
      var idx4$1 = ((io$3 >>> 15) | 0);
      var idx3$1 = (31 & ((io$3 >>> 10) | 0));
      var idx2$1 = (31 & ((io$3 >>> 5) | 0));
      var idx1$1 = (31 & io$3);
      var a4c$4 = a4$4.clone__O();
      var a3$5 = a4c$4.u[idx4$1];
      var a3c$5 = a3$5.clone__O();
      var a2$6 = a3c$5.u[idx3$1];
      var a2c$6 = a2$6.clone__O();
      var a1$7 = a2c$6.u[idx2$1];
      var a1c$7 = a1$7.clone__O();
      a1c$7.u[idx1$1] = elem;
      a2c$6.u[idx2$1] = a1c$7;
      a3c$5.u[idx3$1] = a2c$6;
      a4c$4.u[idx4$1] = a3c$5;
      var x$121 = this.sci_Vector__f_prefix1;
      var x$122 = this.sci_Vector6__f_len1;
      var x$123 = this.sci_Vector6__f_prefix2;
      var x$124 = this.sci_Vector6__f_len12;
      var x$125 = this.sci_Vector6__f_prefix3;
      var x$126 = this.sci_Vector6__f_len123;
      var x$127 = this.sci_Vector6__f_len1234;
      var x$128 = this.sci_Vector6__f_prefix5;
      var x$129 = this.sci_Vector6__f_len12345;
      var x$130 = this.sci_Vector6__f_data6;
      var x$131 = this.sci_Vector6__f_suffix5;
      var x$132 = this.sci_Vector6__f_suffix4;
      var x$133 = this.sci_Vector6__f_suffix3;
      var x$134 = this.sci_Vector6__f_suffix2;
      var x$135 = this.sci_BigVector__f_suffix1;
      var x$136 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$121, x$122, x$123, x$124, x$125, x$126, a4c$4, x$127, x$128, x$129, x$130, x$131, x$132, x$133, x$134, x$135, x$136);
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      var a3$6 = this.sci_Vector6__f_prefix3;
      var idx3$2 = ((io$4 >>> 10) | 0);
      var idx2$2 = (31 & ((io$4 >>> 5) | 0));
      var idx1$2 = (31 & io$4);
      var a3c$6 = a3$6.clone__O();
      var a2$7 = a3c$6.u[idx3$2];
      var a2c$7 = a2$7.clone__O();
      var a1$8 = a2c$7.u[idx2$2];
      var a1c$8 = a1$8.clone__O();
      a1c$8.u[idx1$2] = elem;
      a2c$7.u[idx2$2] = a1c$8;
      a3c$6.u[idx3$2] = a2c$7;
      var x$138 = this.sci_Vector__f_prefix1;
      var x$139 = this.sci_Vector6__f_len1;
      var x$140 = this.sci_Vector6__f_prefix2;
      var x$141 = this.sci_Vector6__f_len12;
      var x$142 = this.sci_Vector6__f_len123;
      var x$143 = this.sci_Vector6__f_prefix4;
      var x$144 = this.sci_Vector6__f_len1234;
      var x$145 = this.sci_Vector6__f_prefix5;
      var x$146 = this.sci_Vector6__f_len12345;
      var x$147 = this.sci_Vector6__f_data6;
      var x$148 = this.sci_Vector6__f_suffix5;
      var x$149 = this.sci_Vector6__f_suffix4;
      var x$150 = this.sci_Vector6__f_suffix3;
      var x$151 = this.sci_Vector6__f_suffix2;
      var x$152 = this.sci_BigVector__f_suffix1;
      var x$153 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$138, x$139, x$140, x$141, a3c$6, x$142, x$143, x$144, x$145, x$146, x$147, x$148, x$149, x$150, x$151, x$152, x$153);
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      var a2$8 = this.sci_Vector6__f_prefix2;
      var idx2$3 = ((io$5 >>> 5) | 0);
      var idx1$3 = (31 & io$5);
      var a2c$8 = a2$8.clone__O();
      var a1$9 = a2c$8.u[idx2$3];
      var a1c$9 = a1$9.clone__O();
      a1c$9.u[idx1$3] = elem;
      a2c$8.u[idx2$3] = a1c$9;
      var x$155 = this.sci_Vector__f_prefix1;
      var x$156 = this.sci_Vector6__f_len1;
      var x$157 = this.sci_Vector6__f_len12;
      var x$158 = this.sci_Vector6__f_prefix3;
      var x$159 = this.sci_Vector6__f_len123;
      var x$160 = this.sci_Vector6__f_prefix4;
      var x$161 = this.sci_Vector6__f_len1234;
      var x$162 = this.sci_Vector6__f_prefix5;
      var x$163 = this.sci_Vector6__f_len12345;
      var x$164 = this.sci_Vector6__f_data6;
      var x$165 = this.sci_Vector6__f_suffix5;
      var x$166 = this.sci_Vector6__f_suffix4;
      var x$167 = this.sci_Vector6__f_suffix3;
      var x$168 = this.sci_Vector6__f_suffix2;
      var x$169 = this.sci_BigVector__f_suffix1;
      var x$170 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(x$155, x$156, a2c$8, x$157, x$158, x$159, x$160, x$161, x$162, x$163, x$164, x$165, x$166, x$167, x$168, x$169, x$170);
    } else {
      var a1$10 = this.sci_Vector__f_prefix1;
      var a1c$10 = a1$10.clone__O();
      a1c$10.u[index] = elem;
      var len1 = this.sci_Vector6__f_len1;
      var prefix2 = this.sci_Vector6__f_prefix2;
      var len12 = this.sci_Vector6__f_len12;
      var prefix3 = this.sci_Vector6__f_prefix3;
      var len123 = this.sci_Vector6__f_len123;
      var prefix4 = this.sci_Vector6__f_prefix4;
      var len1234 = this.sci_Vector6__f_len1234;
      var prefix5 = this.sci_Vector6__f_prefix5;
      var len12345 = this.sci_Vector6__f_len12345;
      var data6 = this.sci_Vector6__f_data6;
      var suffix5 = this.sci_Vector6__f_suffix5;
      var suffix4 = this.sci_Vector6__f_suffix4;
      var suffix3 = this.sci_Vector6__f_suffix3;
      var suffix2 = this.sci_Vector6__f_suffix2;
      var suffix1 = this.sci_BigVector__f_suffix1;
      var length0 = this.sci_BigVector__f_length0;
      return new $c_sci_Vector6(a1c$10, len1, prefix2, len12, prefix3, len123, prefix4, len1234, prefix5, len12345, data6, suffix5, suffix4, suffix3, suffix2, suffix1, length0);
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
$c_sci_Vector6.prototype.appended__O__sci_Vector = (function(elem) {
  if ((this.sci_BigVector__f_suffix1.u.length < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyAppend1__AO__O__AO(this.sci_BigVector__f_suffix1, elem);
    var x$2 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$1, x$2);
  } else if ((this.sci_Vector6__f_suffix2.u.length < 31)) {
    var x$18 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1);
    var a = new $ac_O(1);
    a.u[0] = elem;
    var x$20 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$21 = this.sci_Vector__f_prefix1;
    var x$22 = this.sci_Vector6__f_len1;
    var x$23 = this.sci_Vector6__f_prefix2;
    var x$24 = this.sci_Vector6__f_len12;
    var x$25 = this.sci_Vector6__f_prefix3;
    var x$26 = this.sci_Vector6__f_len123;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_len1234;
    var x$29 = this.sci_Vector6__f_prefix5;
    var x$30 = this.sci_Vector6__f_len12345;
    var x$31 = this.sci_Vector6__f_data6;
    var x$32 = this.sci_Vector6__f_suffix5;
    var x$33 = this.sci_Vector6__f_suffix4;
    var x$34 = this.sci_Vector6__f_suffix3;
    return new $c_sci_Vector6(x$21, x$22, x$23, x$24, x$25, x$26, x$27, x$28, x$29, x$30, x$31, x$32, x$33, x$34, x$18, a, x$20);
  } else if ((this.sci_Vector6__f_suffix3.u.length < 31)) {
    var x$35 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1));
    var x$36 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$1 = new $ac_O(1);
    a$1.u[0] = elem;
    var x$38 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$39 = this.sci_Vector__f_prefix1;
    var x$40 = this.sci_Vector6__f_len1;
    var x$41 = this.sci_Vector6__f_prefix2;
    var x$42 = this.sci_Vector6__f_len12;
    var x$43 = this.sci_Vector6__f_prefix3;
    var x$44 = this.sci_Vector6__f_len123;
    var x$45 = this.sci_Vector6__f_prefix4;
    var x$46 = this.sci_Vector6__f_len1234;
    var x$47 = this.sci_Vector6__f_prefix5;
    var x$48 = this.sci_Vector6__f_len12345;
    var x$49 = this.sci_Vector6__f_data6;
    var x$50 = this.sci_Vector6__f_suffix5;
    var x$51 = this.sci_Vector6__f_suffix4;
    return new $c_sci_Vector6(x$39, x$40, x$41, x$42, x$43, x$44, x$45, x$46, x$47, x$48, x$49, x$50, x$51, x$35, x$36, a$1, x$38);
  } else if ((this.sci_Vector6__f_suffix4.u.length < 31)) {
    var x$52 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)));
    var x$53 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$2 = new $ac_O(1);
    a$2.u[0] = elem;
    var x$56 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$57 = this.sci_Vector__f_prefix1;
    var x$58 = this.sci_Vector6__f_len1;
    var x$59 = this.sci_Vector6__f_prefix2;
    var x$60 = this.sci_Vector6__f_len12;
    var x$61 = this.sci_Vector6__f_prefix3;
    var x$62 = this.sci_Vector6__f_len123;
    var x$63 = this.sci_Vector6__f_prefix4;
    var x$64 = this.sci_Vector6__f_len1234;
    var x$65 = this.sci_Vector6__f_prefix5;
    var x$66 = this.sci_Vector6__f_len12345;
    var x$67 = this.sci_Vector6__f_data6;
    var x$68 = this.sci_Vector6__f_suffix5;
    return new $c_sci_Vector6(x$57, x$58, x$59, x$60, x$61, x$62, x$63, x$64, x$65, x$66, x$67, x$68, x$52, x$53, x$54, a$2, x$56);
  } else if ((this.sci_Vector6__f_suffix5.u.length < 31)) {
    var x$69 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1))));
    var x$70 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$72 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$3 = new $ac_O(1);
    a$3.u[0] = elem;
    var x$74 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$75 = this.sci_Vector__f_prefix1;
    var x$76 = this.sci_Vector6__f_len1;
    var x$77 = this.sci_Vector6__f_prefix2;
    var x$78 = this.sci_Vector6__f_len12;
    var x$79 = this.sci_Vector6__f_prefix3;
    var x$80 = this.sci_Vector6__f_len123;
    var x$81 = this.sci_Vector6__f_prefix4;
    var x$82 = this.sci_Vector6__f_len1234;
    var x$83 = this.sci_Vector6__f_prefix5;
    var x$84 = this.sci_Vector6__f_len12345;
    var x$85 = this.sci_Vector6__f_data6;
    return new $c_sci_Vector6(x$75, x$76, x$77, x$78, x$79, x$80, x$81, x$82, x$83, x$84, x$85, x$69, x$70, x$71, x$72, a$3, x$74);
  } else if ((this.sci_Vector6__f_data6.u.length < 62)) {
    var x$86 = $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_data6, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix5, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix4, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix3, $m_sci_VectorStatics$().copyAppend__AO__O__AO(this.sci_Vector6__f_suffix2, this.sci_BigVector__f_suffix1)))));
    var x$87 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$89 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var a$4 = new $ac_O(1);
    a$4.u[0] = elem;
    var x$92 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$93 = this.sci_Vector__f_prefix1;
    var x$94 = this.sci_Vector6__f_len1;
    var x$95 = this.sci_Vector6__f_prefix2;
    var x$96 = this.sci_Vector6__f_len12;
    var x$97 = this.sci_Vector6__f_prefix3;
    var x$98 = this.sci_Vector6__f_len123;
    var x$99 = this.sci_Vector6__f_prefix4;
    var x$100 = this.sci_Vector6__f_len1234;
    var x$101 = this.sci_Vector6__f_prefix5;
    var x$102 = this.sci_Vector6__f_len12345;
    return new $c_sci_Vector6(x$93, x$94, x$95, x$96, x$97, x$98, x$99, x$100, x$101, x$102, x$86, x$87, x$88, x$89, x$90, a$4, x$92);
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
});
$c_sci_Vector6.prototype.prepended__O__sci_Vector = (function(elem) {
  if ((this.sci_Vector6__f_len1 < 32)) {
    var x$1 = $m_sci_VectorStatics$().copyPrepend1__O__AO__AO(elem, this.sci_Vector__f_prefix1);
    var x$2 = ((1 + this.sci_Vector6__f_len1) | 0);
    var x$3 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$4 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$5 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$6 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$7 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7);
  } else if ((this.sci_Vector6__f_len12 < 1024)) {
    var a = new $ac_O(1);
    a.u[0] = elem;
    var x$20 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2);
    var x$21 = ((1 + this.sci_Vector6__f_len12) | 0);
    var x$22 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$23 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$24 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$25 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$26 = this.sci_Vector6__f_prefix3;
    var x$27 = this.sci_Vector6__f_prefix4;
    var x$28 = this.sci_Vector6__f_prefix5;
    var x$29 = this.sci_Vector6__f_data6;
    var x$30 = this.sci_Vector6__f_suffix5;
    var x$31 = this.sci_Vector6__f_suffix4;
    var x$32 = this.sci_Vector6__f_suffix3;
    var x$33 = this.sci_Vector6__f_suffix2;
    var x$34 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a, 1, x$20, x$21, x$26, x$22, x$27, x$23, x$28, x$24, x$29, x$30, x$31, x$32, x$33, x$34, x$25);
  } else if ((this.sci_Vector6__f_len123 < 32768)) {
    var a$1 = new $ac_O(1);
    a$1.u[0] = elem;
    var x$37 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$39 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3);
    var x$40 = ((1 + this.sci_Vector6__f_len123) | 0);
    var x$41 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$42 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$43 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$44 = this.sci_Vector6__f_prefix4;
    var x$45 = this.sci_Vector6__f_prefix5;
    var x$46 = this.sci_Vector6__f_data6;
    var x$47 = this.sci_Vector6__f_suffix5;
    var x$48 = this.sci_Vector6__f_suffix4;
    var x$49 = this.sci_Vector6__f_suffix3;
    var x$50 = this.sci_Vector6__f_suffix2;
    var x$51 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$1, 1, x$37, 1, x$39, x$40, x$44, x$41, x$45, x$42, x$46, x$47, x$48, x$49, x$50, x$51, x$43);
  } else if ((this.sci_Vector6__f_len1234 < 1048576)) {
    var a$2 = new $ac_O(1);
    a$2.u[0] = elem;
    var x$54 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$56 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$58 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4);
    var x$59 = ((1 + this.sci_Vector6__f_len1234) | 0);
    var x$60 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$61 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$62 = this.sci_Vector6__f_prefix5;
    var x$63 = this.sci_Vector6__f_data6;
    var x$64 = this.sci_Vector6__f_suffix5;
    var x$65 = this.sci_Vector6__f_suffix4;
    var x$66 = this.sci_Vector6__f_suffix3;
    var x$67 = this.sci_Vector6__f_suffix2;
    var x$68 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$2, 1, x$54, 1, x$56, 1, x$58, x$59, x$62, x$60, x$63, x$64, x$65, x$66, x$67, x$68, x$61);
  } else if ((this.sci_Vector6__f_len12345 < 33554432)) {
    var a$3 = new $ac_O(1);
    a$3.u[0] = elem;
    var x$71 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$73 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$75 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$77 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5);
    var x$78 = ((1 + this.sci_Vector6__f_len12345) | 0);
    var x$79 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$80 = this.sci_Vector6__f_data6;
    var x$81 = this.sci_Vector6__f_suffix5;
    var x$82 = this.sci_Vector6__f_suffix4;
    var x$83 = this.sci_Vector6__f_suffix3;
    var x$84 = this.sci_Vector6__f_suffix2;
    var x$85 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$3, 1, x$71, 1, x$73, 1, x$75, 1, x$77, x$78, x$80, x$81, x$82, x$83, x$84, x$85, x$79);
  } else if ((this.sci_Vector6__f_data6.u.length < 62)) {
    var a$4 = new $ac_O(1);
    a$4.u[0] = elem;
    var x$88 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty2;
    var x$90 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty3;
    var x$92 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty4;
    var x$94 = $m_sci_VectorStatics$().sci_VectorStatics$__f_empty5;
    var x$96 = $m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO($m_sci_VectorStatics$().copyPrepend__O__AO__AO(this.sci_Vector__f_prefix1, this.sci_Vector6__f_prefix2), this.sci_Vector6__f_prefix3), this.sci_Vector6__f_prefix4), this.sci_Vector6__f_prefix5), this.sci_Vector6__f_data6);
    var x$97 = ((1 + this.sci_BigVector__f_length0) | 0);
    var x$98 = this.sci_Vector6__f_suffix5;
    var x$99 = this.sci_Vector6__f_suffix4;
    var x$100 = this.sci_Vector6__f_suffix3;
    var x$101 = this.sci_Vector6__f_suffix2;
    var x$102 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(a$4, 1, x$88, 1, x$90, 1, x$92, 1, x$94, 1, x$96, x$98, x$99, x$100, x$101, x$102, x$97);
  } else {
    throw $ct_jl_IllegalArgumentException__(new $c_jl_IllegalArgumentException());
  }
});
$c_sci_Vector6.prototype.map__F1__sci_Vector = (function(f) {
  var x$1 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_Vector__f_prefix1, f);
  var x$2 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_prefix2, f);
  var x$3 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_prefix3, f);
  var x$4 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_prefix4, f);
  var x$5 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_prefix5, f);
  var x$6 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(6, this.sci_Vector6__f_data6, f);
  var x$7 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(5, this.sci_Vector6__f_suffix5, f);
  var x$8 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(4, this.sci_Vector6__f_suffix4, f);
  var x$9 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(3, this.sci_Vector6__f_suffix3, f);
  var x$10 = $m_sci_VectorStatics$().mapElems__I__AO__F1__AO(2, this.sci_Vector6__f_suffix2, f);
  var x$11 = $m_sci_VectorStatics$().mapElems1__AO__F1__AO(this.sci_BigVector__f_suffix1, f);
  var x$12 = this.sci_Vector6__f_len1;
  var x$13 = this.sci_Vector6__f_len12;
  var x$14 = this.sci_Vector6__f_len123;
  var x$15 = this.sci_Vector6__f_len1234;
  var x$16 = this.sci_Vector6__f_len12345;
  var x$17 = this.sci_BigVector__f_length0;
  return new $c_sci_Vector6(x$1, x$12, x$2, x$13, x$3, x$14, x$4, x$15, x$5, x$16, x$6, x$7, x$8, x$9, x$10, x$11, x$17);
});
$c_sci_Vector6.prototype.slice0__I__I__sci_Vector = (function(lo, hi) {
  var b = new $c_sci_VectorSliceBuilder(lo, hi);
  b.consider__I__AO__V(1, this.sci_Vector__f_prefix1);
  b.consider__I__AO__V(2, this.sci_Vector6__f_prefix2);
  b.consider__I__AO__V(3, this.sci_Vector6__f_prefix3);
  b.consider__I__AO__V(4, this.sci_Vector6__f_prefix4);
  b.consider__I__AO__V(5, this.sci_Vector6__f_prefix5);
  b.consider__I__AO__V(6, this.sci_Vector6__f_data6);
  b.consider__I__AO__V(5, this.sci_Vector6__f_suffix5);
  b.consider__I__AO__V(4, this.sci_Vector6__f_suffix4);
  b.consider__I__AO__V(3, this.sci_Vector6__f_suffix3);
  b.consider__I__AO__V(2, this.sci_Vector6__f_suffix2);
  b.consider__I__AO__V(1, this.sci_BigVector__f_suffix1);
  return b.result__sci_Vector();
});
$c_sci_Vector6.prototype.tail__sci_Vector = (function() {
  if ((this.sci_Vector6__f_len1 > 1)) {
    var a = this.sci_Vector__f_prefix1;
    var to = a.u.length;
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 1, to);
    var x$2 = (((-1) + this.sci_Vector6__f_len1) | 0);
    var x$3 = (((-1) + this.sci_Vector6__f_len12) | 0);
    var x$4 = (((-1) + this.sci_Vector6__f_len123) | 0);
    var x$5 = (((-1) + this.sci_Vector6__f_len1234) | 0);
    var x$6 = (((-1) + this.sci_Vector6__f_len12345) | 0);
    var x$7 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$8 = this.sci_Vector6__f_prefix2;
    var x$9 = this.sci_Vector6__f_prefix3;
    var x$10 = this.sci_Vector6__f_prefix4;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_data6;
    var x$13 = this.sci_Vector6__f_suffix5;
    var x$14 = this.sci_Vector6__f_suffix4;
    var x$15 = this.sci_Vector6__f_suffix3;
    var x$16 = this.sci_Vector6__f_suffix2;
    var x$17 = this.sci_BigVector__f_suffix1;
    return new $c_sci_Vector6(x$1, x$2, x$8, x$3, x$9, x$4, x$10, x$5, x$11, x$6, x$12, x$13, x$14, x$15, x$16, x$17, x$7);
  } else {
    return this.slice0__I__I__sci_Vector(1, this.sci_BigVector__f_length0);
  }
});
$c_sci_Vector6.prototype.init__sci_Vector = (function() {
  if ((this.sci_BigVector__f_suffix1.u.length > 1)) {
    var a = this.sci_BigVector__f_suffix1;
    var to = (((-1) + a.u.length) | 0);
    var x$1 = $m_ju_Arrays$().copyOfRange__AO__I__I__AO(a, 0, to);
    var x$2 = (((-1) + this.sci_BigVector__f_length0) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, x$1, x$2);
  } else {
    return this.slice0__I__I__sci_Vector(0, (((-1) + this.sci_BigVector__f_length0) | 0));
  }
});
$c_sci_Vector6.prototype.vectorSliceCount__I = (function() {
  return 11;
});
$c_sci_Vector6.prototype.vectorSlice__I__AO = (function(idx) {
  switch (idx) {
    case 0: {
      return this.sci_Vector__f_prefix1;
      break;
    }
    case 1: {
      return this.sci_Vector6__f_prefix2;
      break;
    }
    case 2: {
      return this.sci_Vector6__f_prefix3;
      break;
    }
    case 3: {
      return this.sci_Vector6__f_prefix4;
      break;
    }
    case 4: {
      return this.sci_Vector6__f_prefix5;
      break;
    }
    case 5: {
      return this.sci_Vector6__f_data6;
      break;
    }
    case 6: {
      return this.sci_Vector6__f_suffix5;
      break;
    }
    case 7: {
      return this.sci_Vector6__f_suffix4;
      break;
    }
    case 8: {
      return this.sci_Vector6__f_suffix3;
      break;
    }
    case 9: {
      return this.sci_Vector6__f_suffix2;
      break;
    }
    case 10: {
      return this.sci_BigVector__f_suffix1;
      break;
    }
    default: {
      throw new $c_s_MatchError(idx);
    }
  }
});
$c_sci_Vector6.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector = (function(suffix, k) {
  var suffix1b = $m_sci_VectorStatics$().append1IfSpace__AO__sc_IterableOnce__AO(this.sci_BigVector__f_suffix1, suffix);
  if ((suffix1b !== null)) {
    var x$2 = ((((this.sci_BigVector__f_length0 - this.sci_BigVector__f_suffix1.u.length) | 0) + suffix1b.u.length) | 0);
    var x$3 = this.sci_Vector__f_prefix1;
    var x$4 = this.sci_Vector6__f_len1;
    var x$5 = this.sci_Vector6__f_prefix2;
    var x$6 = this.sci_Vector6__f_len12;
    var x$7 = this.sci_Vector6__f_prefix3;
    var x$8 = this.sci_Vector6__f_len123;
    var x$9 = this.sci_Vector6__f_prefix4;
    var x$10 = this.sci_Vector6__f_len1234;
    var x$11 = this.sci_Vector6__f_prefix5;
    var x$12 = this.sci_Vector6__f_len12345;
    var x$13 = this.sci_Vector6__f_data6;
    var x$14 = this.sci_Vector6__f_suffix5;
    var x$15 = this.sci_Vector6__f_suffix4;
    var x$16 = this.sci_Vector6__f_suffix3;
    var x$17 = this.sci_Vector6__f_suffix2;
    return new $c_sci_Vector6(x$3, x$4, x$5, x$6, x$7, x$8, x$9, x$10, x$11, x$12, x$13, x$14, x$15, x$16, x$17, suffix1b, x$2);
  } else {
    return $c_sci_Vector.prototype.appendedAll0__sc_IterableOnce__I__sci_Vector.call(this, suffix, k);
  }
});
$c_sci_Vector6.prototype.init__O = (function() {
  return this.init__sci_Vector();
});
$c_sci_Vector6.prototype.tail__O = (function() {
  return this.tail__sci_Vector();
});
$c_sci_Vector6.prototype.map__F1__O = (function(f) {
  return this.map__F1__sci_Vector(f);
});
$c_sci_Vector6.prototype.prepended__O__O = (function(elem) {
  return this.prepended__O__sci_Vector(elem);
});
$c_sci_Vector6.prototype.appended__O__O = (function(elem) {
  return this.appended__O__sci_Vector(elem);
});
$c_sci_Vector6.prototype.updated__I__O__O = (function(index, elem) {
  return this.updated__I__O__sci_Vector(index, elem);
});
$c_sci_Vector6.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  if (((index >= 0) && (index < this.sci_BigVector__f_length0))) {
    var io = ((index - this.sci_Vector6__f_len12345) | 0);
    if ((io >= 0)) {
      var i6 = ((io >>> 25) | 0);
      var i5 = (31 & ((io >>> 20) | 0));
      var i4 = (31 & ((io >>> 15) | 0));
      var i3 = (31 & ((io >>> 10) | 0));
      var i2 = (31 & ((io >>> 5) | 0));
      var i1 = (31 & io);
      return ((i6 < this.sci_Vector6__f_data6.u.length) ? this.sci_Vector6__f_data6.u[i6].u[i5].u[i4].u[i3].u[i2].u[i1] : ((i5 < this.sci_Vector6__f_suffix5.u.length) ? this.sci_Vector6__f_suffix5.u[i5].u[i4].u[i3].u[i2].u[i1] : ((i4 < this.sci_Vector6__f_suffix4.u.length) ? this.sci_Vector6__f_suffix4.u[i4].u[i3].u[i2].u[i1] : ((i3 < this.sci_Vector6__f_suffix3.u.length) ? this.sci_Vector6__f_suffix3.u[i3].u[i2].u[i1] : ((i2 < this.sci_Vector6__f_suffix2.u.length) ? this.sci_Vector6__f_suffix2.u[i2].u[i1] : this.sci_BigVector__f_suffix1.u[i1])))));
    } else if ((index >= this.sci_Vector6__f_len1234)) {
      var io$2 = ((index - this.sci_Vector6__f_len1234) | 0);
      return this.sci_Vector6__f_prefix5.u[((io$2 >>> 20) | 0)].u[(31 & ((io$2 >>> 15) | 0))].u[(31 & ((io$2 >>> 10) | 0))].u[(31 & ((io$2 >>> 5) | 0))].u[(31 & io$2)];
    } else if ((index >= this.sci_Vector6__f_len123)) {
      var io$3 = ((index - this.sci_Vector6__f_len123) | 0);
      return this.sci_Vector6__f_prefix4.u[((io$3 >>> 15) | 0)].u[(31 & ((io$3 >>> 10) | 0))].u[(31 & ((io$3 >>> 5) | 0))].u[(31 & io$3)];
    } else if ((index >= this.sci_Vector6__f_len12)) {
      var io$4 = ((index - this.sci_Vector6__f_len12) | 0);
      return this.sci_Vector6__f_prefix3.u[((io$4 >>> 10) | 0)].u[(31 & ((io$4 >>> 5) | 0))].u[(31 & io$4)];
    } else if ((index >= this.sci_Vector6__f_len1)) {
      var io$5 = ((index - this.sci_Vector6__f_len1) | 0);
      return this.sci_Vector6__f_prefix2.u[((io$5 >>> 5) | 0)].u[(31 & io$5)];
    } else {
      return this.sci_Vector__f_prefix1.u[index];
    }
  } else {
    throw this.ioob__I__jl_IndexOutOfBoundsException(index);
  }
});
function $isArrayOf_sci_Vector6(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.sci_Vector6)));
}
export { $isArrayOf_sci_Vector6 as $isArrayOf_sci_Vector6 };
var $d_sci_Vector6 = new $TypeData().initClass($c_sci_Vector6, "scala.collection.immutable.Vector6", ({
  sci_Vector6: 1,
  sci_BigVector: 1,
  sci_VectorImpl: 1,
  sci_Vector: 1,
  sci_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  sci_Seq: 1,
  sci_Iterable: 1,
  sci_SeqOps: 1,
  sci_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  sci_IndexedSeqOps: 1,
  sci_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sci_Vector6 as $d_sci_Vector6 };
function $ct_scm_StringBuilder__jl_StringBuilder__($thiz, underlying) {
  $thiz.scm_StringBuilder__f_underlying = underlying;
  return $thiz;
}
export { $ct_scm_StringBuilder__jl_StringBuilder__ as $ct_scm_StringBuilder__jl_StringBuilder__ };
function $ct_scm_StringBuilder__($thiz) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__(new $c_jl_StringBuilder()));
  return $thiz;
}
export { $ct_scm_StringBuilder__ as $ct_scm_StringBuilder__ };
function $ct_scm_StringBuilder__I__($thiz, capacity) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__I__(new $c_jl_StringBuilder(), capacity));
  return $thiz;
}
export { $ct_scm_StringBuilder__I__ as $ct_scm_StringBuilder__I__ };
function $ct_scm_StringBuilder__T__($thiz, str) {
  $ct_scm_StringBuilder__jl_StringBuilder__($thiz, $ct_jl_StringBuilder__T__(new $c_jl_StringBuilder(), str));
  return $thiz;
}
export { $ct_scm_StringBuilder__T__ as $ct_scm_StringBuilder__T__ };
/** @constructor */
function $c_scm_StringBuilder() {
  this.scm_StringBuilder__f_underlying = null;
}
export { $c_scm_StringBuilder as $c_scm_StringBuilder };
$c_scm_StringBuilder.prototype = new $h_scm_AbstractSeq();
$c_scm_StringBuilder.prototype.constructor = $c_scm_StringBuilder;
/** @constructor */
function $h_scm_StringBuilder() {
}
export { $h_scm_StringBuilder as $h_scm_StringBuilder };
$h_scm_StringBuilder.prototype = $c_scm_StringBuilder.prototype;
$c_scm_StringBuilder.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_scm_StringBuilder.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_scm_StringBuilder.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_scm_StringBuilder.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_scm_StringBuilder.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_scm_StringBuilder.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_StringBuilder.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$c_scm_StringBuilder.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$c_scm_StringBuilder.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_scm_StringBuilder.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_StringBuilder.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_scm_StringBuilder.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_StringBuilder.prototype.lengthCompare__I__I = (function(len) {
  var x = this.scm_StringBuilder__f_underlying.length__I();
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_StringBuilder.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_StringBuilder.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
});
$c_scm_StringBuilder.prototype.newSpecificBuilder__scm_Builder = (function() {
  return $ct_scm_GrowableBuilder__scm_Growable__(new $c_scm_GrowableBuilder(), $ct_scm_StringBuilder__(new $c_scm_StringBuilder()));
});
$c_scm_StringBuilder.prototype.length__I = (function() {
  return this.scm_StringBuilder__f_underlying.length__I();
});
$c_scm_StringBuilder.prototype.knownSize__I = (function() {
  return this.scm_StringBuilder__f_underlying.length__I();
});
$c_scm_StringBuilder.prototype.addOne__C__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var str = ("" + $cToS(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_scm_StringBuilder.prototype.addAll__T__scm_StringBuilder = (function(s) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this;
});
$c_scm_StringBuilder.prototype.toString__T = (function() {
  return this.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_scm_StringBuilder.prototype.toArray__s_reflect_ClassTag__O = (function(ct) {
  var x1 = ct.runtimeClass__jl_Class();
  return ((x1 === $d_C.getClassOf()) ? this.toCharArray__AC() : $f_sc_IterableOnceOps__toArray__s_reflect_ClassTag__O(this, ct));
});
$c_scm_StringBuilder.prototype.toCharArray__AC = (function() {
  var len = this.scm_StringBuilder__f_underlying.length__I();
  var arr = new $ac_C(len);
  this.scm_StringBuilder__f_underlying.getChars__I__I__AC__I__V(0, len, arr, 0);
  return arr;
});
$c_scm_StringBuilder.prototype.append__O__scm_StringBuilder = (function(x) {
  var this$2 = this.scm_StringBuilder__f_underlying;
  var str = ("" + x);
  this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$2.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_scm_StringBuilder.prototype.append__T__scm_StringBuilder = (function(s) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  return this;
});
$c_scm_StringBuilder.prototype.appendAll__sc_IterableOnce__scm_StringBuilder = (function(xs) {
  if ((xs instanceof $c_sci_WrappedString)) {
    var this$3 = this.scm_StringBuilder__f_underlying;
    var str = xs.sci_WrappedString__f_scala$collection$immutable$WrappedString$$self;
    this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$3.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  } else if ((xs instanceof $c_scm_ArraySeq$ofChar)) {
    this.scm_StringBuilder__f_underlying.append__AC__jl_StringBuilder(xs.scm_ArraySeq$ofChar__f_array);
  } else if ((xs instanceof $c_scm_StringBuilder)) {
    var this$4 = this.scm_StringBuilder__f_underlying;
    var s = xs.scm_StringBuilder__f_underlying;
    this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$4.jl_StringBuilder__f_java$lang$StringBuilder$$content) + s);
  } else {
    var ks = xs.knownSize__I();
    if ((ks !== 0)) {
      var b = this.scm_StringBuilder__f_underlying;
      if ((ks > 0)) {
        b.length__I();
      }
      var it = xs.iterator__sc_Iterator();
      while (it.hasNext__Z()) {
        var c = $uC(it.next__O());
        var str$1 = ("" + $cToS(c));
        b.jl_StringBuilder__f_java$lang$StringBuilder$$content = (b.jl_StringBuilder__f_java$lang$StringBuilder$$content + str$1);
      }
    }
  }
  return this;
});
$c_scm_StringBuilder.prototype.append__I__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var str = ("" + x);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_scm_StringBuilder.prototype.append__J__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var this$2 = $m_RTLong$();
  var str = this$2.org$scalajs$linker$runtime$RuntimeLong$$toString__I__I__T(x.RTLong__f_lo, x.RTLong__f_hi);
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (("" + this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content) + str);
  return this;
});
$c_scm_StringBuilder.prototype.append__C__scm_StringBuilder = (function(x) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  var str = ("" + $cToS(x));
  this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content = (this$1.jl_StringBuilder__f_java$lang$StringBuilder$$content + str);
  return this;
});
$c_scm_StringBuilder.prototype.delete__I__I__scm_StringBuilder = (function(start, end) {
  var this$1 = this.scm_StringBuilder__f_underlying;
  this$1.replace__I__I__T__jl_StringBuilder(start, end, "");
  return this;
});
$c_scm_StringBuilder.prototype.charAt__I__C = (function(index) {
  return this.scm_StringBuilder__f_underlying.charAt__I__C(index);
});
$c_scm_StringBuilder.prototype.deleteCharAt__I__scm_StringBuilder = (function(index) {
  this.scm_StringBuilder__f_underlying.deleteCharAt__I__jl_StringBuilder(index);
  return this;
});
$c_scm_StringBuilder.prototype.setCharAt__I__C__scm_StringBuilder = (function(index, ch) {
  this.scm_StringBuilder__f_underlying.setCharAt__I__C__V(index, ch);
  return this;
});
$c_scm_StringBuilder.prototype.subSequence__I__I__jl_CharSequence = (function(start, end) {
  return this.scm_StringBuilder__f_underlying.substring__I__I__T(start, end);
});
$c_scm_StringBuilder.prototype.isEmpty__Z = (function() {
  return (this.scm_StringBuilder__f_underlying.length__I() === 0);
});
$c_scm_StringBuilder.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_IndexedSeq$();
});
$c_scm_StringBuilder.prototype.result__O = (function() {
  return this.scm_StringBuilder__f_underlying.jl_StringBuilder__f_java$lang$StringBuilder$$content;
});
$c_scm_StringBuilder.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__C__scm_StringBuilder($uC(elem));
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__O = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll);
});
$c_scm_StringBuilder.prototype.fromSpecific__sc_IterableOnce__sc_IterableOps = (function(coll) {
  return $ct_scm_StringBuilder__(new $c_scm_StringBuilder()).appendAll__sc_IterableOnce__scm_StringBuilder(coll);
});
$c_scm_StringBuilder.prototype.apply__O__O = (function(v1) {
  var i = (v1 | 0);
  return $bC(this.scm_StringBuilder__f_underlying.charAt__I__C(i));
});
$c_scm_StringBuilder.prototype.apply__I__O = (function(i) {
  return $bC(this.scm_StringBuilder__f_underlying.charAt__I__C(i));
});
function $isArrayOf_scm_StringBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_StringBuilder)));
}
export { $isArrayOf_scm_StringBuilder as $isArrayOf_scm_StringBuilder };
var $d_scm_StringBuilder = new $TypeData().initClass($c_scm_StringBuilder, "scala.collection.mutable.StringBuilder", ({
  scm_StringBuilder: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  jl_CharSequence: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_StringBuilder as $d_scm_StringBuilder };
function $p_scm_LinkedHashMap__removeEntry0__O__scm_LinkedHashMap$LinkedEntry($thiz, elem) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(elem);
  return $p_scm_LinkedHashMap__removeEntry0__O__I__scm_LinkedHashMap$LinkedEntry($thiz, elem, (originalHash ^ ((originalHash >>> 16) | 0)));
}
export { $p_scm_LinkedHashMap__removeEntry0__O__scm_LinkedHashMap$LinkedEntry as $p_scm_LinkedHashMap__removeEntry0__O__scm_LinkedHashMap$LinkedEntry };
function $p_scm_LinkedHashMap__removeEntry0__O__I__scm_LinkedHashMap$LinkedEntry($thiz, elem, hash) {
  var idx = (hash & (((-1) + $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0));
  var x1 = $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[idx];
  if ((x1 === null)) {
    return null;
  } else if (((x1.scm_LinkedHashMap$LinkedEntry__f_hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(x1.scm_LinkedHashMap$LinkedEntry__f_key, elem))) {
    $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[idx] = x1.scm_LinkedHashMap$LinkedEntry__f_next;
    $p_scm_LinkedHashMap__deleteEntry__scm_LinkedHashMap$LinkedEntry__V($thiz, x1);
    $thiz.scm_LinkedHashMap__f_contentSize = (((-1) + $thiz.scm_LinkedHashMap__f_contentSize) | 0);
    return x1;
  } else {
    var prev = x1;
    var next = x1.scm_LinkedHashMap$LinkedEntry__f_next;
    while (((next !== null) && (next.scm_LinkedHashMap$LinkedEntry__f_hash <= hash))) {
      if (((next.scm_LinkedHashMap$LinkedEntry__f_hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(next.scm_LinkedHashMap$LinkedEntry__f_key, elem))) {
        prev.scm_LinkedHashMap$LinkedEntry__f_next = next.scm_LinkedHashMap$LinkedEntry__f_next;
        $p_scm_LinkedHashMap__deleteEntry__scm_LinkedHashMap$LinkedEntry__V($thiz, next);
        $thiz.scm_LinkedHashMap__f_contentSize = (((-1) + $thiz.scm_LinkedHashMap__f_contentSize) | 0);
        return next;
      }
      prev = next;
      next = next.scm_LinkedHashMap$LinkedEntry__f_next;
    }
    return null;
  }
}
export { $p_scm_LinkedHashMap__removeEntry0__O__I__scm_LinkedHashMap$LinkedEntry as $p_scm_LinkedHashMap__removeEntry0__O__I__scm_LinkedHashMap$LinkedEntry };
function $p_scm_LinkedHashMap__tableSizeFor__I__I($thiz, capacity) {
  var x = (((-1) + capacity) | 0);
  var i = ((x > 4) ? x : 4);
  var x$1 = ((((-2147483648) >> Math.clz32(i)) & i) << 1);
  return ((x$1 < 1073741824) ? x$1 : 1073741824);
}
export { $p_scm_LinkedHashMap__tableSizeFor__I__I as $p_scm_LinkedHashMap__tableSizeFor__I__I };
function $p_scm_LinkedHashMap__newThreshold__I__I($thiz, size) {
  return $doubleToInt((0.75 * size));
}
export { $p_scm_LinkedHashMap__newThreshold__I__I as $p_scm_LinkedHashMap__newThreshold__I__I };
function $p_scm_LinkedHashMap__createNewEntry__O__I__O__scm_LinkedHashMap$LinkedEntry($thiz, key, hash, value) {
  var e = new $c_scm_LinkedHashMap$LinkedEntry(key, hash, value);
  if (($thiz.scm_LinkedHashMap__f_firstEntry === null)) {
    $thiz.scm_LinkedHashMap__f_firstEntry = e;
  } else {
    $thiz.scm_LinkedHashMap__f_lastEntry.scm_LinkedHashMap$LinkedEntry__f_later = e;
    e.scm_LinkedHashMap$LinkedEntry__f_earlier = $thiz.scm_LinkedHashMap__f_lastEntry;
  }
  $thiz.scm_LinkedHashMap__f_lastEntry = e;
  return e;
}
export { $p_scm_LinkedHashMap__createNewEntry__O__I__O__scm_LinkedHashMap$LinkedEntry as $p_scm_LinkedHashMap__createNewEntry__O__I__O__scm_LinkedHashMap$LinkedEntry };
function $p_scm_LinkedHashMap__deleteEntry__scm_LinkedHashMap$LinkedEntry__V($thiz, e) {
  if ((e.scm_LinkedHashMap$LinkedEntry__f_earlier === null)) {
    $thiz.scm_LinkedHashMap__f_firstEntry = e.scm_LinkedHashMap$LinkedEntry__f_later;
  } else {
    e.scm_LinkedHashMap$LinkedEntry__f_earlier.scm_LinkedHashMap$LinkedEntry__f_later = e.scm_LinkedHashMap$LinkedEntry__f_later;
  }
  if ((e.scm_LinkedHashMap$LinkedEntry__f_later === null)) {
    $thiz.scm_LinkedHashMap__f_lastEntry = e.scm_LinkedHashMap$LinkedEntry__f_earlier;
  } else {
    e.scm_LinkedHashMap$LinkedEntry__f_later.scm_LinkedHashMap$LinkedEntry__f_earlier = e.scm_LinkedHashMap$LinkedEntry__f_earlier;
  }
  e.scm_LinkedHashMap$LinkedEntry__f_earlier = null;
  e.scm_LinkedHashMap$LinkedEntry__f_later = null;
  e.scm_LinkedHashMap$LinkedEntry__f_next = null;
}
export { $p_scm_LinkedHashMap__deleteEntry__scm_LinkedHashMap$LinkedEntry__V as $p_scm_LinkedHashMap__deleteEntry__scm_LinkedHashMap$LinkedEntry__V };
function $p_scm_LinkedHashMap__put0__O__O__Z__s_Some($thiz, key, value, getOld) {
  if ((((1 + $thiz.scm_LinkedHashMap__f_contentSize) | 0) >= $thiz.scm_LinkedHashMap__f_threshold)) {
    $p_scm_LinkedHashMap__growTable__I__V($thiz, ($thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length << 1));
  }
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var idx = (hash & (((-1) + $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0));
  return $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx);
}
export { $p_scm_LinkedHashMap__put0__O__O__Z__s_Some as $p_scm_LinkedHashMap__put0__O__O__Z__s_Some };
function $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some($thiz, key, value, getOld, hash, idx) {
  var x1 = $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[idx];
  if ((x1 === null)) {
    $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[idx] = $p_scm_LinkedHashMap__createNewEntry__O__I__O__scm_LinkedHashMap$LinkedEntry($thiz, key, hash, value);
  } else {
    var prev = null;
    var n = x1;
    while (((n !== null) && (n.scm_LinkedHashMap$LinkedEntry__f_hash <= hash))) {
      if (((n.scm_LinkedHashMap$LinkedEntry__f_hash === hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, n.scm_LinkedHashMap$LinkedEntry__f_key))) {
        var old = n.scm_LinkedHashMap$LinkedEntry__f_value;
        n.scm_LinkedHashMap$LinkedEntry__f_value = value;
        return (getOld ? new $c_s_Some(old) : null);
      }
      prev = n;
      n = n.scm_LinkedHashMap$LinkedEntry__f_next;
    }
    var nnode = $p_scm_LinkedHashMap__createNewEntry__O__I__O__scm_LinkedHashMap$LinkedEntry($thiz, key, hash, value);
    if ((prev === null)) {
      nnode.scm_LinkedHashMap$LinkedEntry__f_next = x1;
      $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[idx] = nnode;
    } else {
      nnode.scm_LinkedHashMap$LinkedEntry__f_next = prev.scm_LinkedHashMap$LinkedEntry__f_next;
      prev.scm_LinkedHashMap$LinkedEntry__f_next = nnode;
    }
  }
  $thiz.scm_LinkedHashMap__f_contentSize = ((1 + $thiz.scm_LinkedHashMap__f_contentSize) | 0);
  return null;
}
export { $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some as $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some };
function $p_scm_LinkedHashMap__growTable__I__V($thiz, newlen) {
  if ((newlen < 0)) {
    throw $ct_jl_RuntimeException__T__(new $c_jl_RuntimeException(), (("new hash table size " + newlen) + " exceeds maximum"));
  }
  var oldlen = $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length;
  $thiz.scm_LinkedHashMap__f_threshold = $p_scm_LinkedHashMap__newThreshold__I__I($thiz, newlen);
  if (($thiz.scm_LinkedHashMap__f_contentSize === 0)) {
    $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table = new ($d_scm_LinkedHashMap$LinkedEntry.getArrayOf().constr)(newlen);
  } else {
    var original = $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table;
    $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table = $m_ju_Arrays$().copyOf__AO__I__AO(original, newlen);
    var preLow = new $c_scm_LinkedHashMap$LinkedEntry(null, 0, null);
    var preHigh = new $c_scm_LinkedHashMap$LinkedEntry(null, 0, null);
    while ((oldlen < newlen)) {
      var i = 0;
      while ((i < oldlen)) {
        var old = $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[i];
        if ((old !== null)) {
          preLow.scm_LinkedHashMap$LinkedEntry__f_next = null;
          preHigh.scm_LinkedHashMap$LinkedEntry__f_next = null;
          var lastLow = preLow;
          var lastHigh = preHigh;
          var n = old;
          while ((n !== null)) {
            var next = n.scm_LinkedHashMap$LinkedEntry__f_next;
            if (((n.scm_LinkedHashMap$LinkedEntry__f_hash & oldlen) === 0)) {
              lastLow.scm_LinkedHashMap$LinkedEntry__f_next = n;
              lastLow = n;
            } else {
              lastHigh.scm_LinkedHashMap$LinkedEntry__f_next = n;
              lastHigh = n;
            }
            n = next;
          }
          lastLow.scm_LinkedHashMap$LinkedEntry__f_next = null;
          if ((old !== preLow.scm_LinkedHashMap$LinkedEntry__f_next)) {
            $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[i] = preLow.scm_LinkedHashMap$LinkedEntry__f_next;
          }
          if ((preHigh.scm_LinkedHashMap$LinkedEntry__f_next !== null)) {
            $thiz.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[((i + oldlen) | 0)] = preHigh.scm_LinkedHashMap$LinkedEntry__f_next;
            lastHigh.scm_LinkedHashMap$LinkedEntry__f_next = null;
          }
        }
        i = ((1 + i) | 0);
      }
      oldlen = (oldlen << 1);
    }
  }
}
export { $p_scm_LinkedHashMap__growTable__I__V as $p_scm_LinkedHashMap__growTable__I__V };
/** @constructor */
function $c_scm_LinkedHashMap() {
  this.scm_LinkedHashMap__f_firstEntry = null;
  this.scm_LinkedHashMap__f_lastEntry = null;
  this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table = null;
  this.scm_LinkedHashMap__f_threshold = 0;
  this.scm_LinkedHashMap__f_contentSize = 0;
  this.scm_LinkedHashMap__f_firstEntry = null;
  this.scm_LinkedHashMap__f_lastEntry = null;
  this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table = new ($d_scm_LinkedHashMap$LinkedEntry.getArrayOf().constr)($p_scm_LinkedHashMap__tableSizeFor__I__I(this, 16));
  this.scm_LinkedHashMap__f_threshold = $p_scm_LinkedHashMap__newThreshold__I__I(this, this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length);
  this.scm_LinkedHashMap__f_contentSize = 0;
}
export { $c_scm_LinkedHashMap as $c_scm_LinkedHashMap };
$c_scm_LinkedHashMap.prototype = new $h_scm_AbstractMap();
$c_scm_LinkedHashMap.prototype.constructor = $c_scm_LinkedHashMap;
/** @constructor */
function $h_scm_LinkedHashMap() {
}
export { $h_scm_LinkedHashMap as $h_scm_LinkedHashMap };
$h_scm_LinkedHashMap.prototype = $c_scm_LinkedHashMap.prototype;
$c_scm_LinkedHashMap.prototype.concat__sc_IterableOnce__sc_IterableOps = (function(suffix) {
  return $f_sc_StrictOptimizedMapOps__concat__sc_IterableOnce__sc_IterableOps(this, suffix);
});
$c_scm_LinkedHashMap.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_LinkedHashMap.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_LinkedHashMap.prototype.collect__s_PartialFunction__O = (function(pf) {
  return $f_sc_StrictOptimizedIterableOps__collect__s_PartialFunction__O(this, pf);
});
$c_scm_LinkedHashMap.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_LinkedHashMap.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_LinkedHashMap.prototype.mapFactory__sc_MapFactory = (function() {
  return $m_scm_LinkedHashMap$();
});
$c_scm_LinkedHashMap.prototype.last__T2 = (function() {
  if ((this.scm_LinkedHashMap__f_contentSize > 0)) {
    return $ct_T2__O__O__(new $c_T2(), this.scm_LinkedHashMap__f_lastEntry.scm_LinkedHashMap$LinkedEntry__f_key, this.scm_LinkedHashMap__f_lastEntry.scm_LinkedHashMap$LinkedEntry__f_value);
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Cannot call .last on empty LinkedHashMap");
  }
});
$c_scm_LinkedHashMap.prototype.head__T2 = (function() {
  if ((this.scm_LinkedHashMap__f_contentSize > 0)) {
    return $ct_T2__O__O__(new $c_T2(), this.scm_LinkedHashMap__f_firstEntry.scm_LinkedHashMap$LinkedEntry__f_key, this.scm_LinkedHashMap__f_firstEntry.scm_LinkedHashMap$LinkedEntry__f_value);
  } else {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "Cannot call .head on empty LinkedHashMap");
  }
});
$c_scm_LinkedHashMap.prototype.headOption__s_Option = (function() {
  return ((this.scm_LinkedHashMap__f_contentSize > 0) ? new $c_s_Some($ct_T2__O__O__(new $c_T2(), this.scm_LinkedHashMap__f_firstEntry.scm_LinkedHashMap$LinkedEntry__f_key, this.scm_LinkedHashMap__f_firstEntry.scm_LinkedHashMap$LinkedEntry__f_value)) : $m_s_None$());
});
$c_scm_LinkedHashMap.prototype.size__I = (function() {
  return this.scm_LinkedHashMap__f_contentSize;
});
$c_scm_LinkedHashMap.prototype.knownSize__I = (function() {
  return this.scm_LinkedHashMap__f_contentSize;
});
$c_scm_LinkedHashMap.prototype.isEmpty__Z = (function() {
  return (this.scm_LinkedHashMap__f_contentSize === 0);
});
$c_scm_LinkedHashMap.prototype.get__O__s_Option = (function(key) {
  var originalHash = $m_sr_Statics$().anyHash__O__I(key);
  var hash = (originalHash ^ ((originalHash >>> 16) | 0));
  var x1 = this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[(hash & (((-1) + this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0))];
  var e = ((x1 === null) ? null : x1.findEntry__O__I__scm_LinkedHashMap$LinkedEntry(key, hash));
  return ((e === null) ? $m_s_None$() : new $c_s_Some(e.scm_LinkedHashMap$LinkedEntry__f_value));
});
$c_scm_LinkedHashMap.prototype.sizeHint__I__V = (function(size) {
  var target = $p_scm_LinkedHashMap__tableSizeFor__I__I(this, $doubleToInt((((1 + size) | 0) / 0.75)));
  if ((target > this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length)) {
    $p_scm_LinkedHashMap__growTable__I__V(this, target);
  }
});
$c_scm_LinkedHashMap.prototype.contains__O__Z = (function(key) {
  if (($objectGetClass(this) === $d_scm_LinkedHashMap.getClassOf())) {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[(hash & (((-1) + this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0))];
    return (((x1 === null) ? null : x1.findEntry__O__I__scm_LinkedHashMap$LinkedEntry(key, hash)) !== null);
  } else {
    return $f_sc_MapOps__contains__O__Z(this, key);
  }
});
$c_scm_LinkedHashMap.prototype.put__O__O__s_Option = (function(key, value) {
  var x1 = $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(this, key, value, true);
  return ((x1 === null) ? $m_s_None$() : x1);
});
$c_scm_LinkedHashMap.prototype.update__O__O__V = (function(key, value) {
  $p_scm_LinkedHashMap__put0__O__O__Z__s_Some(this, key, value, false);
});
$c_scm_LinkedHashMap.prototype.remove__O__s_Option = (function(key) {
  var x1 = $p_scm_LinkedHashMap__removeEntry0__O__scm_LinkedHashMap$LinkedEntry(this, key);
  return ((x1 === null) ? $m_s_None$() : new $c_s_Some(x1.scm_LinkedHashMap$LinkedEntry__f_value));
});
$c_scm_LinkedHashMap.prototype.getOrElse__O__F0__O = (function(key, default$1) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_LinkedHashMap.getClassOf()))) {
    return $f_sc_MapOps__getOrElse__O__F0__O(this, key, default$1);
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var x1 = this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[(hash & (((-1) + this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0))];
    var nd = ((x1 === null) ? null : x1.findEntry__O__I__scm_LinkedHashMap$LinkedEntry(key, hash));
    return ((nd === null) ? default$1.apply__O() : nd.scm_LinkedHashMap$LinkedEntry__f_value);
  }
});
$c_scm_LinkedHashMap.prototype.getOrElseUpdate__O__F0__O = (function(key, defaultValue) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_LinkedHashMap.getClassOf()))) {
    return $f_scm_MapOps__getOrElseUpdate__O__F0__O(this, key, defaultValue);
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var idx = (hash & (((-1) + this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0));
    var x1 = this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[idx];
    var nd = ((x1 === null) ? null : x1.findEntry__O__I__scm_LinkedHashMap$LinkedEntry(key, hash));
    if ((nd !== null)) {
      return nd.scm_LinkedHashMap$LinkedEntry__f_value;
    } else {
      var table0 = this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table;
      var default$1 = defaultValue.apply__O();
      if ((((1 + this.scm_LinkedHashMap__f_contentSize) | 0) >= this.scm_LinkedHashMap__f_threshold)) {
        $p_scm_LinkedHashMap__growTable__I__V(this, (this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length << 1));
      }
      var newIdx = ((table0 === this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table) ? idx : (hash & (((-1) + this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0)));
      $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(this, key, default$1, false, hash, newIdx);
      return default$1;
    }
  }
});
$c_scm_LinkedHashMap.prototype.addOne__T2__scm_LinkedHashMap = (function(kv) {
  this.put__O__O__s_Option(kv._1__O(), kv._2__O());
  return this;
});
$c_scm_LinkedHashMap.prototype.subtractOne__O__scm_LinkedHashMap = (function(key) {
  this.remove__O__s_Option(key);
  return this;
});
$c_scm_LinkedHashMap.prototype.iterator__sc_Iterator = (function() {
  return ((this.scm_LinkedHashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_LinkedHashMap$$anon$1(this));
});
$c_scm_LinkedHashMap.prototype.keySet__sc_Set = (function() {
  return new $c_scm_LinkedHashMap$LinkedKeySet(this);
});
$c_scm_LinkedHashMap.prototype.keysIterator__sc_Iterator = (function() {
  return ((this.scm_LinkedHashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_LinkedHashMap$$anon$2(this));
});
$c_scm_LinkedHashMap.prototype.entryIterator__sc_Iterator = (function() {
  return ((this.scm_LinkedHashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_LinkedHashMap$$anon$3(this));
});
$c_scm_LinkedHashMap.prototype.updateWith__O__F1__s_Option = (function(key, remappingFunction) {
  var x = $objectGetClass(this);
  if ((!(x === $d_scm_LinkedHashMap.getClassOf()))) {
    return $f_scm_MapOps__updateWith__O__F1__s_Option(this, key, remappingFunction);
  } else {
    var originalHash = $m_sr_Statics$().anyHash__O__I(key);
    var hash = (originalHash ^ ((originalHash >>> 16) | 0));
    var indexedHash = (hash & (((-1) + this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0));
    var elem = null;
    elem = null;
    var elem$1 = null;
    elem$1 = null;
    var x1 = this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[indexedHash];
    if ((x1 !== null)) {
      var prev = null;
      var nd = x1;
      while (true) {
        if (((hash === nd.scm_LinkedHashMap$LinkedEntry__f_hash) && $m_sr_BoxesRunTime$().equals__O__O__Z(key, nd.scm_LinkedHashMap$LinkedEntry__f_key))) {
          elem$1 = prev;
          elem = nd;
        } else if ((!((nd.scm_LinkedHashMap$LinkedEntry__f_next === null) || (nd.scm_LinkedHashMap$LinkedEntry__f_hash > hash)))) {
          var temp$prev = nd;
          var temp$nd = nd.scm_LinkedHashMap$LinkedEntry__f_next;
          prev = temp$prev;
          nd = temp$nd;
          continue;
        }
        break;
      }
    }
    var x1$2 = elem;
    var previousValue = ((x1$2 === null) ? $m_s_None$() : new $c_s_Some(x1$2.scm_LinkedHashMap$LinkedEntry__f_value));
    var nextValue = remappingFunction.apply__O__O(previousValue);
    var x1$3 = $ct_T2__O__O__(new $c_T2(), previousValue, nextValue);
    matchEnd21: {
      var p2 = x1$3.T2__f__1;
      var p3 = x1$3.T2__f__2;
      var x$3 = $m_s_None$();
      if ((x$3 === p2)) {
        var x$5 = $m_s_None$();
        var $x_1 = (x$5 === p3);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        break matchEnd21;
      }
      var p6 = x1$3.T2__f__1;
      var p7 = x1$3.T2__f__2;
      if ((p6 instanceof $c_s_Some)) {
        var x$7 = $m_s_None$();
        var $x_2 = (x$7 === p7);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        if ((elem$1 !== null)) {
          elem$1.scm_LinkedHashMap$LinkedEntry__f_next = elem.scm_LinkedHashMap$LinkedEntry__f_next;
        } else {
          this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u[indexedHash] = elem.scm_LinkedHashMap$LinkedEntry__f_next;
        }
        $p_scm_LinkedHashMap__deleteEntry__scm_LinkedHashMap$LinkedEntry__V(this, elem);
        this.scm_LinkedHashMap__f_contentSize = (((-1) + this.scm_LinkedHashMap__f_contentSize) | 0);
        break matchEnd21;
      }
      var p11 = x1$3.T2__f__1;
      var p12 = x1$3.T2__f__2;
      var x$9 = $m_s_None$();
      if (((x$9 === p11) && (p12 instanceof $c_s_Some))) {
        var value = p12.s_Some__f_value;
        var newIndexedHash = ((((1 + this.scm_LinkedHashMap__f_contentSize) | 0) >= this.scm_LinkedHashMap__f_threshold) ? ($p_scm_LinkedHashMap__growTable__I__V(this, (this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length << 1)), (hash & (((-1) + this.scm_LinkedHashMap__f_scala$collection$mutable$LinkedHashMap$$table.u.length) | 0))) : indexedHash);
        $p_scm_LinkedHashMap__put0__O__O__Z__I__I__s_Some(this, key, value, false, hash, newIndexedHash);
        break matchEnd21;
      }
      var p15 = x1$3.T2__f__1;
      var p16 = x1$3.T2__f__2;
      if (((p15 instanceof $c_s_Some) && (p16 instanceof $c_s_Some))) {
        var newValue = p16.s_Some__f_value;
        elem.scm_LinkedHashMap$LinkedEntry__f_value = newValue;
        break matchEnd21;
      }
      throw new $c_s_MatchError(x1$3);
    }
    return nextValue;
  }
});
$c_scm_LinkedHashMap.prototype.valuesIterator__sc_Iterator = (function() {
  return ((this.scm_LinkedHashMap__f_contentSize === 0) ? $m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty : new $c_scm_LinkedHashMap$$anon$4(this));
});
$c_scm_LinkedHashMap.prototype.foreach__F1__V = (function(f) {
  var cur = this.scm_LinkedHashMap__f_firstEntry;
  while ((cur !== null)) {
    f.apply__O__O($ct_T2__O__O__(new $c_T2(), cur.scm_LinkedHashMap$LinkedEntry__f_key, cur.scm_LinkedHashMap$LinkedEntry__f_value));
    cur = cur.scm_LinkedHashMap$LinkedEntry__f_later;
  }
});
$c_scm_LinkedHashMap.prototype.foreachEntry__F2__V = (function(f) {
  var cur = this.scm_LinkedHashMap__f_firstEntry;
  while ((cur !== null)) {
    f.apply__O__O__O(cur.scm_LinkedHashMap$LinkedEntry__f_key, cur.scm_LinkedHashMap$LinkedEntry__f_value);
    cur = cur.scm_LinkedHashMap$LinkedEntry__f_later;
  }
});
$c_scm_LinkedHashMap.prototype.hashCode__I = (function() {
  if (this.isEmpty__Z()) {
    return $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_emptyMapHash;
  } else {
    var tupleHashIterator = new $c_scm_LinkedHashMap$$anon$5(this);
    return $m_s_util_hashing_MurmurHash3$().unorderedHash__sc_IterableOnce__I__I(tupleHashIterator, $m_s_util_hashing_MurmurHash3$().s_util_hashing_MurmurHash3$__f_mapSeed);
  }
});
$c_scm_LinkedHashMap.prototype.stringPrefix__T = (function() {
  return "LinkedHashMap";
});
$c_scm_LinkedHashMap.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_LinkedHashMap(elem);
});
$c_scm_LinkedHashMap.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__T2__scm_LinkedHashMap(elem);
});
$c_scm_LinkedHashMap.prototype.head__O = (function() {
  return this.head__T2();
});
$c_scm_LinkedHashMap.prototype.last__O = (function() {
  return this.last__T2();
});
function $isArrayOf_scm_LinkedHashMap(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_LinkedHashMap)));
}
export { $isArrayOf_scm_LinkedHashMap as $isArrayOf_scm_LinkedHashMap };
var $d_scm_LinkedHashMap = new $TypeData().initClass($c_scm_LinkedHashMap, "scala.collection.mutable.LinkedHashMap", ({
  scm_LinkedHashMap: 1,
  scm_AbstractMap: 1,
  sc_AbstractMap: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Map: 1,
  sc_MapOps: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_MapFactoryDefaults: 1,
  s_Equals: 1,
  scm_Map: 1,
  scm_Iterable: 1,
  scm_MapOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Builder: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_SeqMap: 1,
  sc_SeqMap: 1,
  sc_StrictOptimizedIterableOps: 1,
  sc_StrictOptimizedMapOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_LinkedHashMap as $d_scm_LinkedHashMap };
function $p_scm_ListBuffer__copyElems__V($thiz) {
  var buf = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer($thiz);
  $thiz.scm_ListBuffer__f_first = buf.scm_ListBuffer__f_first;
  $thiz.scm_ListBuffer__f_last0 = buf.scm_ListBuffer__f_last0;
  $thiz.scm_ListBuffer__f_aliased = false;
}
export { $p_scm_ListBuffer__copyElems__V as $p_scm_ListBuffer__copyElems__V };
function $p_scm_ListBuffer__ensureUnaliased__V($thiz) {
  $thiz.scm_ListBuffer__f_mutationCount = ((1 + $thiz.scm_ListBuffer__f_mutationCount) | 0);
  if ($thiz.scm_ListBuffer__f_aliased) {
    $p_scm_ListBuffer__copyElems__V($thiz);
  }
}
export { $p_scm_ListBuffer__ensureUnaliased__V as $p_scm_ListBuffer__ensureUnaliased__V };
function $p_scm_ListBuffer__reduceLengthBy__I__V($thiz, num) {
  $thiz.scm_ListBuffer__f_len = (($thiz.scm_ListBuffer__f_len - num) | 0);
  if (($thiz.scm_ListBuffer__f_len <= 0)) {
    $thiz.scm_ListBuffer__f_last0 = null;
  }
}
export { $p_scm_ListBuffer__reduceLengthBy__I__V as $p_scm_ListBuffer__reduceLengthBy__I__V };
function $p_scm_ListBuffer__predecessor__I__sci_$colon$colon($thiz, i) {
  if ((i === 0)) {
    return null;
  } else if ((i === $thiz.scm_ListBuffer__f_len)) {
    return $thiz.scm_ListBuffer__f_last0;
  } else {
    var j = (((-1) + i) | 0);
    var p = $thiz.scm_ListBuffer__f_first;
    while ((j > 0)) {
      p = p.tail__O();
      j = (((-1) + j) | 0);
    }
    return p;
  }
}
export { $p_scm_ListBuffer__predecessor__I__sci_$colon$colon as $p_scm_ListBuffer__predecessor__I__sci_$colon$colon };
function $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List($thiz, p) {
  return ((p === null) ? $thiz.scm_ListBuffer__f_first : p.sci_$colon$colon__f_next);
}
export { $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List as $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List };
/** @constructor */
function $c_scm_ListBuffer() {
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = null;
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0;
  this.scm_ListBuffer__f_mutationCount = 0;
  this.scm_ListBuffer__f_first = $m_sci_Nil$();
  this.scm_ListBuffer__f_last0 = null;
  this.scm_ListBuffer__f_aliased = false;
  this.scm_ListBuffer__f_len = 0;
}
export { $c_scm_ListBuffer as $c_scm_ListBuffer };
$c_scm_ListBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ListBuffer.prototype.constructor = $c_scm_ListBuffer;
/** @constructor */
function $h_scm_ListBuffer() {
}
export { $h_scm_ListBuffer as $h_scm_ListBuffer };
$h_scm_ListBuffer.prototype = $c_scm_ListBuffer.prototype;
$c_scm_ListBuffer.prototype.sizeHint__I__V = (function(size) {
});
$c_scm_ListBuffer.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_scm_ListBuffer.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_scm_ListBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_scm_ListBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ListBuffer.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_ListBuffer.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ListBuffer.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ListBuffer.prototype.iterator__sc_Iterator = (function() {
  return new $c_scm_MutationTracker$CheckedIterator(this.scm_ListBuffer__f_first.iterator__sc_Iterator(), new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => this.scm_ListBuffer__f_mutationCount)));
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ListBuffer$();
});
$c_scm_ListBuffer.prototype.apply__I__O = (function(i) {
  var this$1 = this.scm_ListBuffer__f_first;
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i);
});
$c_scm_ListBuffer.prototype.length__I = (function() {
  return this.scm_ListBuffer__f_len;
});
$c_scm_ListBuffer.prototype.knownSize__I = (function() {
  return this.scm_ListBuffer__f_len;
});
$c_scm_ListBuffer.prototype.isEmpty__Z = (function() {
  return (this.scm_ListBuffer__f_len === 0);
});
$c_scm_ListBuffer.prototype.toList__sci_List = (function() {
  this.scm_ListBuffer__f_aliased = (!this.isEmpty__Z());
  return this.scm_ListBuffer__f_first;
});
$c_scm_ListBuffer.prototype.prependToList__sci_List__sci_List = (function(xs) {
  if (this.isEmpty__Z()) {
    return xs;
  } else {
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    this.scm_ListBuffer__f_last0.sci_$colon$colon__f_next = xs;
    return this.toList__sci_List();
  }
});
$c_scm_ListBuffer.prototype.addOne__O__scm_ListBuffer = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  var last1 = new $c_sci_$colon$colon(elem, $m_sci_Nil$());
  if ((this.scm_ListBuffer__f_len === 0)) {
    this.scm_ListBuffer__f_first = last1;
  } else {
    this.scm_ListBuffer__f_last0.sci_$colon$colon__f_next = last1;
  }
  this.scm_ListBuffer__f_last0 = last1;
  this.scm_ListBuffer__f_len = ((1 + this.scm_ListBuffer__f_len) | 0);
  return this;
});
$c_scm_ListBuffer.prototype.scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = xs.iterator__sc_Iterator();
  if (it.hasNext__Z()) {
    var len = 1;
    var last0 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
    this.scm_ListBuffer__f_first = last0;
    while (it.hasNext__Z()) {
      var last1 = new $c_sci_$colon$colon(it.next__O(), $m_sci_Nil$());
      last0.sci_$colon$colon__f_next = last1;
      last0 = last1;
      len = ((1 + len) | 0);
    }
    this.scm_ListBuffer__f_len = len;
    this.scm_ListBuffer__f_last0 = last0;
  }
  return this;
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_ListBuffer = (function(xs) {
  var it = xs.iterator__sc_Iterator();
  if (it.hasNext__Z()) {
    var fresh = new $c_scm_ListBuffer().scala$collection$mutable$ListBuffer$$freshFrom__sc_IterableOnce__scm_ListBuffer(it);
    $p_scm_ListBuffer__ensureUnaliased__V(this);
    if ((this.scm_ListBuffer__f_len === 0)) {
      this.scm_ListBuffer__f_first = fresh.scm_ListBuffer__f_first;
    } else {
      this.scm_ListBuffer__f_last0.sci_$colon$colon__f_next = fresh.scm_ListBuffer__f_first;
    }
    this.scm_ListBuffer__f_last0 = fresh.scm_ListBuffer__f_last0;
    this.scm_ListBuffer__f_len = ((this.scm_ListBuffer__f_len + fresh.scm_ListBuffer__f_len) | 0);
  }
  return this;
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_ListBuffer = (function(elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if ((!this.isEmpty__Z())) {
    if ($m_sr_BoxesRunTime$().equals__O__O__Z(this.scm_ListBuffer__f_first.head__O(), elem)) {
      this.scm_ListBuffer__f_first = this.scm_ListBuffer__f_first.tail__O();
      $p_scm_ListBuffer__reduceLengthBy__I__V(this, 1);
    } else {
      var cursor = this.scm_ListBuffer__f_first;
      while (((!cursor.tail__O().isEmpty__Z()) && (!$m_sr_BoxesRunTime$().equals__O__O__Z(cursor.tail__O().head__O(), elem)))) {
        cursor = cursor.tail__O();
      }
      if ((!cursor.tail__O().isEmpty__Z())) {
        var z = cursor;
        var x = z.sci_$colon$colon__f_next;
        var x$2 = this.scm_ListBuffer__f_last0;
        if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
          this.scm_ListBuffer__f_last0 = z;
        }
        z.sci_$colon$colon__f_next = cursor.tail__O().tail__O();
        $p_scm_ListBuffer__reduceLengthBy__I__V(this, 1);
      }
    }
  }
  return this;
});
$c_scm_ListBuffer.prototype.update__I__O__V = (function(idx, elem) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if (((idx < 0) || (idx >= this.scm_ListBuffer__f_len))) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(idx, (((-1) + this.scm_ListBuffer__f_len) | 0));
  }
  if ((idx === 0)) {
    var newElem = new $c_sci_$colon$colon(elem, this.scm_ListBuffer__f_first.tail__O());
    if ((this.scm_ListBuffer__f_last0 === this.scm_ListBuffer__f_first)) {
      this.scm_ListBuffer__f_last0 = newElem;
    }
    this.scm_ListBuffer__f_first = newElem;
  } else {
    var p = $p_scm_ListBuffer__predecessor__I__sci_$colon$colon(this, idx);
    var newElem$2 = new $c_sci_$colon$colon(elem, p.sci_$colon$colon__f_next.tail__O());
    if ((this.scm_ListBuffer__f_last0 === p.sci_$colon$colon__f_next)) {
      this.scm_ListBuffer__f_last0 = newElem$2;
    }
    p.sci_$colon$colon__f_next = newElem$2;
  }
});
$c_scm_ListBuffer.prototype.remove__I__O = (function(idx) {
  $p_scm_ListBuffer__ensureUnaliased__V(this);
  if (((idx < 0) || (idx >= this.scm_ListBuffer__f_len))) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(idx, (((-1) + this.scm_ListBuffer__f_len) | 0));
  }
  var p = $p_scm_ListBuffer__predecessor__I__sci_$colon$colon(this, idx);
  var nx = $p_scm_ListBuffer__getNext__sci_$colon$colon__sci_List(this, p);
  if ((p === null)) {
    this.scm_ListBuffer__f_first = nx.tail__O();
    if (this.scm_ListBuffer__f_first.isEmpty__Z()) {
      this.scm_ListBuffer__f_last0 = null;
    }
  } else {
    if ((this.scm_ListBuffer__f_last0 === nx)) {
      this.scm_ListBuffer__f_last0 = p;
    }
    p.sci_$colon$colon__f_next = nx.tail__O();
  }
  this.scm_ListBuffer__f_len = (((-1) + this.scm_ListBuffer__f_len) | 0);
  return nx.head__O();
});
$c_scm_ListBuffer.prototype.last__O = (function() {
  if ((this.scm_ListBuffer__f_last0 === null)) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "last of empty ListBuffer");
  } else {
    return this.scm_ListBuffer__f_last0.sci_$colon$colon__f_head;
  }
});
$c_scm_ListBuffer.prototype.lastOption__s_Option = (function() {
  return ((this.scm_ListBuffer__f_last0 === null) ? $m_s_None$() : new $c_s_Some(this.scm_ListBuffer__f_last0.sci_$colon$colon__f_head));
});
$c_scm_ListBuffer.prototype.stringPrefix__T = (function() {
  return "ListBuffer";
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_ListBuffer(elem);
});
$c_scm_ListBuffer.prototype.subtractOne__O__scm_Buffer = (function(x) {
  return this.subtractOne__O__scm_ListBuffer(x);
});
$c_scm_ListBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ListBuffer(elems);
});
$c_scm_ListBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ListBuffer(elem);
});
$c_scm_ListBuffer.prototype.result__O = (function() {
  return this.toList__sci_List();
});
$c_scm_ListBuffer.prototype.apply__O__O = (function(v1) {
  var i = (v1 | 0);
  var this$1 = this.scm_ListBuffer__f_first;
  return $f_sc_LinearSeqOps__apply__I__O(this$1, i);
});
$c_scm_ListBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ListBuffer$();
});
function $isArrayOf_scm_ListBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ListBuffer)));
}
export { $isArrayOf_scm_ListBuffer as $isArrayOf_scm_ListBuffer };
var $d_scm_ListBuffer = new $TypeData().initClass($c_scm_ListBuffer, "scala.collection.mutable.ListBuffer", ({
  scm_ListBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ReusableBuilder: 1,
  scm_Builder: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ListBuffer as $d_scm_ListBuffer };
function $p_scm_ArrayBuffer__reduceToSize__I__V($thiz, n) {
  $thiz.scm_ArrayBuffer__f_mutationCount = ((1 + $thiz.scm_ArrayBuffer__f_mutationCount) | 0);
  var a = $thiz.scm_ArrayBuffer__f_array;
  var toIndex = $thiz.scm_ArrayBuffer__f_size0;
  $m_ju_Arrays$().fill__AO__I__I__O__V(a, n, toIndex, null);
  $thiz.scm_ArrayBuffer__f_size0 = n;
}
export { $p_scm_ArrayBuffer__reduceToSize__I__V as $p_scm_ArrayBuffer__reduceToSize__I__V };
function $p_scm_ArrayBuffer__foldl__I__I__O__F2__O($thiz, start, end, z, op) {
  while (true) {
    if ((start === end)) {
      return z;
    } else {
      var temp$start = ((1 + start) | 0);
      var temp$z = op.apply__O__O__O(z, $thiz.scm_ArrayBuffer__f_array.u[start]);
      start = temp$start;
      z = temp$z;
    }
  }
}
export { $p_scm_ArrayBuffer__foldl__I__I__O__F2__O as $p_scm_ArrayBuffer__foldl__I__I__O__F2__O };
function $ct_scm_ArrayBuffer__AO__I__($thiz, initialElements, initialSize) {
  $thiz.scm_ArrayBuffer__f_mutationCount = 0;
  $thiz.scm_ArrayBuffer__f_array = initialElements;
  $thiz.scm_ArrayBuffer__f_size0 = initialSize;
  return $thiz;
}
export { $ct_scm_ArrayBuffer__AO__I__ as $ct_scm_ArrayBuffer__AO__I__ };
function $ct_scm_ArrayBuffer__($thiz) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(16), 0);
  return $thiz;
}
export { $ct_scm_ArrayBuffer__ as $ct_scm_ArrayBuffer__ };
function $ct_scm_ArrayBuffer__I__($thiz, initialSize) {
  $ct_scm_ArrayBuffer__AO__I__($thiz, new $ac_O(((initialSize > 1) ? initialSize : 1)), 0);
  return $thiz;
}
export { $ct_scm_ArrayBuffer__I__ as $ct_scm_ArrayBuffer__I__ };
/** @constructor */
function $c_scm_ArrayBuffer() {
  this.scm_ArrayBuffer__f_mutationCount = 0;
  this.scm_ArrayBuffer__f_array = null;
  this.scm_ArrayBuffer__f_size0 = 0;
}
export { $c_scm_ArrayBuffer as $c_scm_ArrayBuffer };
$c_scm_ArrayBuffer.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayBuffer.prototype.constructor = $c_scm_ArrayBuffer;
/** @constructor */
function $h_scm_ArrayBuffer() {
}
export { $h_scm_ArrayBuffer as $h_scm_ArrayBuffer };
$h_scm_ArrayBuffer.prototype = $c_scm_ArrayBuffer.prototype;
$c_scm_ArrayBuffer.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_scm_ArrayBuffer.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_scm_ArrayBuffer.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_scm_ArrayBuffer.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ArrayBuffer.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_ArrayBuffer.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ArrayBuffer.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ArrayBuffer.prototype.iterator__sc_Iterator = (function() {
  return this.view__scm_ArrayBufferView().iterator__sc_Iterator();
});
$c_scm_ArrayBuffer.prototype.reverseIterator__sc_Iterator = (function() {
  return this.view__scm_ArrayBufferView().reverseIterator__sc_Iterator();
});
$c_scm_ArrayBuffer.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_scm_ArrayBuffer.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_scm_ArrayBuffer.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_ArrayBuffer.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_scm_ArrayBuffer.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_ArrayBuffer.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_scm_ArrayBuffer.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_ArrayBuffer.prototype.lengthCompare__I__I = (function(len) {
  var x = this.scm_ArrayBuffer__f_size0;
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_ArrayBuffer.prototype.knownSize__I = (function() {
  return this.scm_ArrayBuffer__f_size0;
});
$c_scm_ArrayBuffer.prototype.ensureSize__I__V = (function(n) {
  this.scm_ArrayBuffer__f_array = $m_scm_ArrayBuffer$().scala$collection$mutable$ArrayBuffer$$ensureSize__AO__I__I__AO(this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, n);
});
$c_scm_ArrayBuffer.prototype.sizeHint__I__V = (function(size) {
  if (((size > this.scm_ArrayBuffer__f_size0) && (size >= 1))) {
    this.ensureSize__I__V(size);
  }
});
$c_scm_ArrayBuffer.prototype.apply__I__O = (function(n) {
  var hi = ((1 + n) | 0);
  if ((n < 0)) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(n, (((-1) + this.scm_ArrayBuffer__f_size0) | 0));
  }
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException((((-1) + hi) | 0), (((-1) + this.scm_ArrayBuffer__f_size0) | 0));
  }
  return this.scm_ArrayBuffer__f_array.u[n];
});
$c_scm_ArrayBuffer.prototype.update__I__O__V = (function(index, elem) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + this.scm_ArrayBuffer__f_size0) | 0));
  }
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException((((-1) + hi) | 0), (((-1) + this.scm_ArrayBuffer__f_size0) | 0));
  }
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  this.scm_ArrayBuffer__f_array.u[index] = elem;
});
$c_scm_ArrayBuffer.prototype.length__I = (function() {
  return this.scm_ArrayBuffer__f_size0;
});
$c_scm_ArrayBuffer.prototype.view__scm_ArrayBufferView = (function() {
  return new $c_scm_ArrayBufferView(this, new $c_sr_AbstractFunction0_$$Lambda$a02b774b97db8234e08c6a02dd06557c99779855((() => this.scm_ArrayBuffer__f_mutationCount)));
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayBuffer$();
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_ArrayBuffer = (function(elem) {
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  var newSize = ((1 + this.scm_ArrayBuffer__f_size0) | 0);
  if ((this.scm_ArrayBuffer__f_array.u.length <= (((-1) + newSize) | 0))) {
    this.ensureSize__I__V(newSize);
  }
  this.scm_ArrayBuffer__f_size0 = newSize;
  this.scm_ArrayBuffer__f_array.u[(((-1) + newSize) | 0)] = elem;
  return this;
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_ArrayBuffer = (function(elems) {
  if ((elems instanceof $c_scm_ArrayBuffer)) {
    var elemsLength = elems.scm_ArrayBuffer__f_size0;
    if ((elemsLength > 0)) {
      this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
      this.ensureSize__I__V(((this.scm_ArrayBuffer__f_size0 + elemsLength) | 0));
      $m_s_Array$().copy__O__I__O__I__I__V(elems.scm_ArrayBuffer__f_array, 0, this.scm_ArrayBuffer__f_array, this.scm_ArrayBuffer__f_size0, elemsLength);
      this.scm_ArrayBuffer__f_size0 = ((this.scm_ArrayBuffer__f_size0 + elemsLength) | 0);
    }
  } else {
    $f_scm_Growable__addAll__sc_IterableOnce__scm_Growable(this, elems);
  }
  return this;
});
$c_scm_ArrayBuffer.prototype.insert__I__O__V = (function(index, elem) {
  if ((index < 0)) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + this.scm_ArrayBuffer__f_size0) | 0));
  }
  if ((index > this.scm_ArrayBuffer__f_size0)) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException((((-1) + index) | 0), (((-1) + this.scm_ArrayBuffer__f_size0) | 0));
  }
  this.scm_ArrayBuffer__f_mutationCount = ((1 + this.scm_ArrayBuffer__f_mutationCount) | 0);
  this.ensureSize__I__V(((1 + this.scm_ArrayBuffer__f_size0) | 0));
  $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, index, this.scm_ArrayBuffer__f_array, ((1 + index) | 0), ((this.scm_ArrayBuffer__f_size0 - index) | 0));
  this.scm_ArrayBuffer__f_size0 = ((1 + this.scm_ArrayBuffer__f_size0) | 0);
  this.update__I__O__V(index, elem);
});
$c_scm_ArrayBuffer.prototype.prepend__O__scm_ArrayBuffer = (function(elem) {
  this.insert__I__O__V(0, elem);
  return this;
});
$c_scm_ArrayBuffer.prototype.remove__I__O = (function(index) {
  var hi = ((1 + index) | 0);
  if ((index < 0)) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(index, (((-1) + this.scm_ArrayBuffer__f_size0) | 0));
  }
  if ((hi > this.scm_ArrayBuffer__f_size0)) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException((((-1) + hi) | 0), (((-1) + this.scm_ArrayBuffer__f_size0) | 0));
  }
  var res = this.apply__I__O(index);
  $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, ((1 + index) | 0), this.scm_ArrayBuffer__f_array, index, ((this.scm_ArrayBuffer__f_size0 - ((1 + index) | 0)) | 0));
  $p_scm_ArrayBuffer__reduceToSize__I__V(this, (((-1) + this.scm_ArrayBuffer__f_size0) | 0));
  return res;
});
$c_scm_ArrayBuffer.prototype.stringPrefix__T = (function() {
  return "ArrayBuffer";
});
$c_scm_ArrayBuffer.prototype.copyToArray__O__I__I__I = (function(xs, start, len) {
  var srcLen = this.scm_ArrayBuffer__f_size0;
  var destLen = $m_jl_reflect_Array$().getLength__O__I(xs);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((start < 0) ? destLen : ((destLen - start) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $m_s_Array$().copy__O__I__O__I__I__V(this.scm_ArrayBuffer__f_array, 0, xs, start, copied);
  }
  return copied;
});
$c_scm_ArrayBuffer.prototype.foldLeft__O__F2__O = (function(z, op) {
  return $p_scm_ArrayBuffer__foldl__I__I__O__F2__O(this, 0, this.scm_ArrayBuffer__f_size0, z, op);
});
$c_scm_ArrayBuffer.prototype.reduceLeft__F2__O = (function(op) {
  return ((this.scm_ArrayBuffer__f_size0 > 0) ? $p_scm_ArrayBuffer__foldl__I__I__O__F2__O(this, 1, this.scm_ArrayBuffer__f_size0, this.scm_ArrayBuffer__f_array.u[0], op) : $f_sc_IterableOnceOps__reduceLeft__F2__O(this, op));
});
$c_scm_ArrayBuffer.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ArrayBuffer(elems);
});
$c_scm_ArrayBuffer.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayBuffer(elem);
});
$c_scm_ArrayBuffer.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_ArrayBuffer$();
});
$c_scm_ArrayBuffer.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O((v1 | 0));
});
function $isArrayOf_scm_ArrayBuffer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.scm_ArrayBuffer)));
}
export { $isArrayOf_scm_ArrayBuffer as $isArrayOf_scm_ArrayBuffer };
var $d_scm_ArrayBuffer = new $TypeData().initClass($c_scm_ArrayBuffer, "scala.collection.mutable.ArrayBuffer", ({
  scm_ArrayBuffer: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArrayBuffer as $d_scm_ArrayBuffer };
function $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, array) {
  $thiz.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = array;
  return $thiz;
}
export { $ct_sjs_js_WrappedArray__sjs_js_Array__ as $ct_sjs_js_WrappedArray__sjs_js_Array__ };
function $ct_sjs_js_WrappedArray__($thiz) {
  $ct_sjs_js_WrappedArray__sjs_js_Array__($thiz, []);
  return $thiz;
}
export { $ct_sjs_js_WrappedArray__ as $ct_sjs_js_WrappedArray__ };
/** @constructor */
function $c_sjs_js_WrappedArray() {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array = null;
}
export { $c_sjs_js_WrappedArray as $c_sjs_js_WrappedArray };
$c_sjs_js_WrappedArray.prototype = new $h_scm_AbstractBuffer();
$c_sjs_js_WrappedArray.prototype.constructor = $c_sjs_js_WrappedArray;
/** @constructor */
function $h_sjs_js_WrappedArray() {
}
export { $h_sjs_js_WrappedArray as $h_sjs_js_WrappedArray };
$h_sjs_js_WrappedArray.prototype = $c_sjs_js_WrappedArray.prototype;
$c_sjs_js_WrappedArray.prototype.sizeHint__I__V = (function(size) {
});
$c_sjs_js_WrappedArray.prototype.stringPrefix__T = (function() {
  return "IndexedSeq";
});
$c_sjs_js_WrappedArray.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_sjs_js_WrappedArray.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_sjs_js_WrappedArray.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_sjs_js_WrappedArray.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_sjs_js_WrappedArray.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_sjs_js_WrappedArray.prototype.dropRight__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__dropRight__I__O(this, n);
});
$c_sjs_js_WrappedArray.prototype.map__F1__O = (function(f) {
  return $f_sc_IndexedSeqOps__map__F1__O(this, f);
});
$c_sjs_js_WrappedArray.prototype.reverse__O = (function() {
  return $f_sc_IndexedSeqOps__reverse__O(this);
});
$c_sjs_js_WrappedArray.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_sjs_js_WrappedArray.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_sjs_js_WrappedArray.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_sjs_js_WrappedArray.prototype.lengthCompare__I__I = (function(len) {
  var x = (this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length | 0);
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_sjs_js_WrappedArray.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_sjs_js_WrappedArray.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_sjs_js_WrappedArray.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_sjs_js_WrappedArray.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_sjs_js_WrappedArray.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_sjs_js_WrappedArray$();
});
$c_sjs_js_WrappedArray.prototype.update__I__O__V = (function(index, elem) {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index] = elem;
});
$c_sjs_js_WrappedArray.prototype.apply__I__O = (function(index) {
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index];
});
$c_sjs_js_WrappedArray.prototype.length__I = (function() {
  return (this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length | 0);
});
$c_sjs_js_WrappedArray.prototype.knownSize__I = (function() {
  return (this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length | 0);
});
$c_sjs_js_WrappedArray.prototype.remove__I__O = (function(n) {
  if (((n < 0) || (n >= (this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.length | 0)))) {
    throw $ct_jl_IndexOutOfBoundsException__(new $c_jl_IndexOutOfBoundsException());
  }
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.splice(n, 1)[0];
});
$c_sjs_js_WrappedArray.prototype.className__T = (function() {
  return "WrappedArray";
});
$c_sjs_js_WrappedArray.prototype.result__O = (function() {
  return this;
});
$c_sjs_js_WrappedArray.prototype.addOne__O__scm_Growable = (function(elem) {
  this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array.push(elem);
  return this;
});
$c_sjs_js_WrappedArray.prototype.apply__O__O = (function(v1) {
  var index = (v1 | 0);
  return this.sjs_js_WrappedArray__f_scala$scalajs$js$WrappedArray$$array[index];
});
$c_sjs_js_WrappedArray.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_sjs_js_WrappedArray$();
});
var $d_sjs_js_WrappedArray = new $TypeData().initClass($c_sjs_js_WrappedArray, "scala.scalajs.js.WrappedArray", ({
  sjs_js_WrappedArray: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  scm_IndexedBuffer: 1,
  scm_Builder: 1,
  Ljava_io_Serializable: 1
}));
export { $d_sjs_js_WrappedArray as $d_sjs_js_WrappedArray };
function $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, array, start, end) {
  var assertion = ((array.u.length & (((-1) + array.u.length) | 0)) === 0);
  if ((!assertion)) {
    throw $ct_jl_AssertionError__O__(new $c_jl_AssertionError(), "assertion failed: Array.length must be power of 2");
  }
  var until = array.u.length;
  if (((start < 0) || (start >= until))) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(start, (((-1) + until) | 0));
  }
  var until$1 = array.u.length;
  if (((end < 0) || (end >= until$1))) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(end, (((-1) + until$1) | 0));
  }
  $thiz.scm_ArrayDeque__f_array = array;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = start;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = end;
}
export { $p_scm_ArrayDeque__reset__AO__I__I__V as $p_scm_ArrayDeque__reset__AO__I__I__V };
function $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end) {
  $thiz.scm_ArrayDeque__f_array = array;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = start;
  $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = end;
  $p_scm_ArrayDeque__reset__AO__I__I__V($thiz, $thiz.scm_ArrayDeque__f_array, $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start, $thiz.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end);
  return $thiz;
}
export { $ct_scm_ArrayDeque__AO__I__I__ as $ct_scm_ArrayDeque__AO__I__I__ };
function $ct_scm_ArrayDeque__I__($thiz, initialSize) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, $m_scm_ArrayDeque$().alloc__I__AO(initialSize), 0, 0);
  return $thiz;
}
export { $ct_scm_ArrayDeque__I__ as $ct_scm_ArrayDeque__I__ };
/** @constructor */
function $c_scm_ArrayDeque() {
  this.scm_ArrayDeque__f_array = null;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = 0;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = 0;
}
export { $c_scm_ArrayDeque as $c_scm_ArrayDeque };
$c_scm_ArrayDeque.prototype = new $h_scm_AbstractBuffer();
$c_scm_ArrayDeque.prototype.constructor = $c_scm_ArrayDeque;
/** @constructor */
function $h_scm_ArrayDeque() {
}
export { $h_scm_ArrayDeque as $h_scm_ArrayDeque };
$h_scm_ArrayDeque.prototype = $c_scm_ArrayDeque.prototype;
$c_scm_ArrayDeque.prototype.reverse__O = (function() {
  return $f_scm_ArrayDequeOps__reverse__O(this);
});
$c_scm_ArrayDeque.prototype.distinctBy__F1__O = (function(f) {
  return $f_sc_StrictOptimizedSeqOps__distinctBy__F1__O(this, f);
});
$c_scm_ArrayDeque.prototype.appended__O__O = (function(elem) {
  return $f_sc_StrictOptimizedSeqOps__appended__O__O(this, elem);
});
$c_scm_ArrayDeque.prototype.appendedAll__sc_IterableOnce__O = (function(suffix) {
  return $f_sc_StrictOptimizedSeqOps__appendedAll__sc_IterableOnce__O(this, suffix);
});
$c_scm_ArrayDeque.prototype.map__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__map__F1__O(this, f);
});
$c_scm_ArrayDeque.prototype.flatMap__F1__O = (function(f) {
  return $f_sc_StrictOptimizedIterableOps__flatMap__F1__O(this, f);
});
$c_scm_ArrayDeque.prototype.filter__F1__O = (function(pred) {
  return $f_sc_StrictOptimizedIterableOps__filterImpl__F1__Z__O(this, pred, false);
});
$c_scm_ArrayDeque.prototype.dropRight__I__O = (function(n) {
  return $f_sc_StrictOptimizedIterableOps__dropRight__I__O(this, n);
});
$c_scm_ArrayDeque.prototype.iterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewIterator(), this$1);
});
$c_scm_ArrayDeque.prototype.reverseIterator__sc_Iterator = (function() {
  var this$1 = new $c_sc_IndexedSeqView$Id(this);
  return $ct_sc_IndexedSeqView$IndexedSeqViewReverseIterator__sc_IndexedSeqView__(new $c_sc_IndexedSeqView$IndexedSeqViewReverseIterator(), this$1);
});
$c_scm_ArrayDeque.prototype.reversed__sc_Iterable = (function() {
  return $ct_sc_IndexedSeqView$Reverse__sc_IndexedSeqOps__(new $c_sc_IndexedSeqView$Reverse(), this);
});
$c_scm_ArrayDeque.prototype.take__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__take__I__O(this, n);
});
$c_scm_ArrayDeque.prototype.drop__I__O = (function(n) {
  return $f_sc_IndexedSeqOps__drop__I__O(this, n);
});
$c_scm_ArrayDeque.prototype.head__O = (function() {
  return $f_sc_IndexedSeqOps__head__O(this);
});
$c_scm_ArrayDeque.prototype.headOption__s_Option = (function() {
  return $f_sc_IndexedSeqOps__headOption__s_Option(this);
});
$c_scm_ArrayDeque.prototype.last__O = (function() {
  return $f_sc_IndexedSeqOps__last__O(this);
});
$c_scm_ArrayDeque.prototype.lengthCompare__I__I = (function(len) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var x = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
  return ((x === len) ? 0 : ((x < len) ? (-1) : 1));
});
$c_scm_ArrayDeque.prototype.knownSize__I = (function() {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  return (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
});
$c_scm_ArrayDeque.prototype.apply__I__O = (function(idx) {
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var until = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
  if (((idx < 0) || (idx >= until))) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(idx, (((-1) + until) | 0));
  }
  return this.scm_ArrayDeque__f_array.u[(((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))];
});
$c_scm_ArrayDeque.prototype.update__I__O__V = (function(idx, elem) {
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var until = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
  if (((idx < 0) || (idx >= until))) {
    throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(idx, (((-1) + until) | 0));
  }
  this.scm_ArrayDeque__f_array.u[(((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))] = elem;
});
$c_scm_ArrayDeque.prototype.addOne__O__scm_ArrayDeque = (function(elem) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var hint = ((1 + (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))) | 0);
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  if (((hint > (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))) && (hint >= this.scm_ArrayDeque__f_array.u.length))) {
    this.scala$collection$mutable$ArrayDeque$$resize__I__V(hint);
  }
  this.scm_ArrayDeque__f_array.u[this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end] = elem;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
  return this;
});
$c_scm_ArrayDeque.prototype.addAll__sc_IterableOnce__scm_ArrayDeque = (function(elems) {
  var x1 = elems.knownSize__I();
  if ((x1 > 0)) {
    var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var hint = ((x1 + (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))) | 0);
    var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    if (((hint > (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))) && (hint >= this.scm_ArrayDeque__f_array.u.length))) {
      this.scala$collection$mutable$ArrayDeque$$resize__I__V(hint);
    }
    var this$1 = elems.iterator__sc_Iterator();
    while (this$1.hasNext__Z()) {
      var x0 = this$1.next__O();
      this.scm_ArrayDeque__f_array.u[this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end] = x0;
      this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
    }
  } else {
    var this$2 = elems.iterator__sc_Iterator();
    while (this$2.hasNext__Z()) {
      var x0$1 = this$2.next__O();
      this.addOne__O__scm_ArrayDeque(x0$1);
    }
  }
  return this;
});
$c_scm_ArrayDeque.prototype.remove__I__I__V = (function(idx, count) {
  if ((count > 0)) {
    var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var until = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
    if (((idx < 0) || (idx >= until))) {
      throw $m_scg_CommonErrors$().indexOutOfBounds__I__I__jl_IndexOutOfBoundsException(idx, (((-1) + until) | 0));
    }
    var idx$2 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var n = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$2) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
    var a = ((n - idx) | 0);
    var removals = ((a < count) ? a : count);
    var finalLength = ((n - removals) | 0);
    var suffixStart = ((idx + removals) | 0);
    if (((this.scm_ArrayDeque__f_array.u.length > 128) && (((((this.scm_ArrayDeque__f_array.u.length - finalLength) | 0) - (finalLength >> 1)) | 0) > finalLength))) {
      var array2 = $m_scm_ArrayDeque$().alloc__I__AO(finalLength);
      $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, array2, 0, idx);
      $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, suffixStart, array2, idx, n);
      $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, finalLength);
    } else if (((idx << 1) <= finalLength)) {
      var i = (((-1) + suffixStart) | 0);
      while ((i >= removals)) {
        var idx$4 = i;
        var idx$3 = ((i - removals) | 0);
        var elem = this.scm_ArrayDeque__f_array.u[(((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$3) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))];
        this.scm_ArrayDeque__f_array.u[(((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$4) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))] = elem;
        i = (((-1) + i) | 0);
      }
      while ((i >= 0)) {
        var idx$5 = i;
        this.scm_ArrayDeque__f_array.u[(((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$5) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))] = null;
        i = (((-1) + i) | 0);
      }
      this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + removals) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
    } else {
      var i$2 = idx;
      while ((i$2 < finalLength)) {
        var idx$7 = i$2;
        var idx$6 = ((i$2 + removals) | 0);
        var elem$1 = this.scm_ArrayDeque__f_array.u[(((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$6) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))];
        this.scm_ArrayDeque__f_array.u[(((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$7) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))] = elem$1;
        i$2 = ((1 + i$2) | 0);
      }
      while ((i$2 < n)) {
        var idx$8 = i$2;
        this.scm_ArrayDeque__f_array.u[(((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start + idx$8) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0))] = null;
        i$2 = ((1 + i$2) | 0);
      }
      this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - removals) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
    }
  } else {
    var requirement = (count === 0);
    if ((!requirement)) {
      throw $ct_jl_IllegalArgumentException__T__(new $c_jl_IllegalArgumentException(), (("requirement failed: " + "removing negative number of elements: ") + count));
    }
  }
});
$c_scm_ArrayDeque.prototype.remove__I__O = (function(idx) {
  var elem = this.apply__I__O(idx);
  this.remove__I__I__V(idx, 1);
  return elem;
});
$c_scm_ArrayDeque.prototype.subtractOne__O__scm_ArrayDeque = (function(elem) {
  var idx = $f_sc_SeqOps__indexOf__O__I__I(this, elem, 0);
  if ((idx >= 0)) {
    this.remove__I__I__V(idx, 1);
  }
  return this;
});
$c_scm_ArrayDeque.prototype.removeHead__Z__O = (function(resizeInternalRepr) {
  if (this.isEmpty__Z()) {
    throw $ct_ju_NoSuchElementException__T__(new $c_ju_NoSuchElementException(), "empty collection");
  } else {
    var elem = this.scm_ArrayDeque__f_array.u[this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start];
    this.scm_ArrayDeque__f_array.u[this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start] = null;
    this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = (((1 + this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
    if (resizeInternalRepr) {
      var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
      this.scala$collection$mutable$ArrayDeque$$resize__I__V((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0)));
    }
    return elem;
  }
});
$c_scm_ArrayDeque.prototype.length__I = (function() {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  return (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
});
$c_scm_ArrayDeque.prototype.isEmpty__Z = (function() {
  return (this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start === this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end);
});
$c_scm_ArrayDeque.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_ArrayDeque$();
});
$c_scm_ArrayDeque.prototype.ofArray__AO__I__scm_ArrayDeque = (function(array, end) {
  return $ct_scm_ArrayDeque__AO__I__I__(new $c_scm_ArrayDeque(), array, 0, end);
});
$c_scm_ArrayDeque.prototype.copyToArray__O__I__I__I = (function(dest, destStart, len) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var srcLen = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
  var destLen = $m_jl_reflect_Array$().getLength__O__I(dest);
  var limit = ((len < srcLen) ? len : srcLen);
  var capacity = ((destStart < 0) ? destLen : ((destLen - destStart) | 0));
  var total = ((capacity < limit) ? capacity : limit);
  var copied = ((total < 0) ? 0 : total);
  if ((copied > 0)) {
    $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, destStart, len);
  }
  return copied;
});
$c_scm_ArrayDeque.prototype.toArray__s_reflect_ClassTag__O = (function(evidence$1) {
  var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var dest = evidence$1.newArray__I__O((((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0)));
  var idx$1 = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
  var maxItems = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx$1) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
  return $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, 0, maxItems);
});
$c_scm_ArrayDeque.prototype.scala$collection$mutable$ArrayDeque$$resize__I__V = (function(len) {
  if (((len >= this.scm_ArrayDeque__f_array.u.length) || ((this.scm_ArrayDeque__f_array.u.length > 16) && (((this.scm_ArrayDeque__f_array.u.length - len) | 0) > len)))) {
    var idx = this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start;
    var n = (((this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end - idx) | 0) & (((-1) + this.scm_ArrayDeque__f_array.u.length) | 0));
    var dest = $m_scm_ArrayDeque$().alloc__I__AO(len);
    var array2 = $f_scm_ArrayDequeOps__copySliceToArray__I__O__I__I__O(this, 0, dest, 0, n);
    $p_scm_ArrayDeque__reset__AO__I__I__V(this, array2, 0, n);
  }
});
$c_scm_ArrayDeque.prototype.stringPrefix__T = (function() {
  return "ArrayDeque";
});
$c_scm_ArrayDeque.prototype.ofArray__AO__I__O = (function(array, end) {
  return this.ofArray__AO__I__scm_ArrayDeque(array, end);
});
$c_scm_ArrayDeque.prototype.iterableFactory__sc_IterableFactory = (function() {
  return this.iterableFactory__sc_SeqFactory();
});
$c_scm_ArrayDeque.prototype.subtractOne__O__scm_Shrinkable = (function(elem) {
  return this.subtractOne__O__scm_ArrayDeque(elem);
});
$c_scm_ArrayDeque.prototype.subtractOne__O__scm_Buffer = (function(x) {
  return this.subtractOne__O__scm_ArrayDeque(x);
});
$c_scm_ArrayDeque.prototype.addAll__sc_IterableOnce__scm_Growable = (function(elems) {
  return this.addAll__sc_IterableOnce__scm_ArrayDeque(elems);
});
$c_scm_ArrayDeque.prototype.addOne__O__scm_Growable = (function(elem) {
  return this.addOne__O__scm_ArrayDeque(elem);
});
$c_scm_ArrayDeque.prototype.apply__O__O = (function(v1) {
  return this.apply__I__O((v1 | 0));
});
var $d_scm_ArrayDeque = new $TypeData().initClass($c_scm_ArrayDeque, "scala.collection.mutable.ArrayDeque", ({
  scm_ArrayDeque: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ArrayDequeOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_ArrayDeque as $d_scm_ArrayDeque };
function $ct_scm_Queue__AO__I__I__($thiz, array, start, end) {
  $ct_scm_ArrayDeque__AO__I__I__($thiz, array, start, end);
  return $thiz;
}
export { $ct_scm_Queue__AO__I__I__ as $ct_scm_Queue__AO__I__I__ };
function $ct_scm_Queue__I__($thiz, initialSize) {
  var array = $m_scm_ArrayDeque$().alloc__I__AO(initialSize);
  $ct_scm_ArrayDeque__AO__I__I__($thiz, array, 0, 0);
  return $thiz;
}
export { $ct_scm_Queue__I__ as $ct_scm_Queue__I__ };
/** @constructor */
function $c_scm_Queue() {
  this.scm_ArrayDeque__f_array = null;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$start = 0;
  this.scm_ArrayDeque__f_scala$collection$mutable$ArrayDeque$$end = 0;
}
export { $c_scm_Queue as $c_scm_Queue };
$c_scm_Queue.prototype = new $h_scm_ArrayDeque();
$c_scm_Queue.prototype.constructor = $c_scm_Queue;
/** @constructor */
function $h_scm_Queue() {
}
export { $h_scm_Queue as $h_scm_Queue };
$h_scm_Queue.prototype = $c_scm_Queue.prototype;
$c_scm_Queue.prototype.iterableFactory__sc_SeqFactory = (function() {
  return $m_scm_Queue$();
});
$c_scm_Queue.prototype.stringPrefix__T = (function() {
  return "Queue";
});
$c_scm_Queue.prototype.ofArray__AO__I__O = (function(array, end) {
  return $ct_scm_Queue__AO__I__I__(new $c_scm_Queue(), array, 0, end);
});
$c_scm_Queue.prototype.ofArray__AO__I__scm_ArrayDeque = (function(array, end) {
  return $ct_scm_Queue__AO__I__I__(new $c_scm_Queue(), array, 0, end);
});
$c_scm_Queue.prototype.iterableFactory__sc_IterableFactory = (function() {
  return $m_scm_Queue$();
});
var $d_scm_Queue = new $TypeData().initClass($c_scm_Queue, "scala.collection.mutable.Queue", ({
  scm_Queue: 1,
  scm_ArrayDeque: 1,
  scm_AbstractBuffer: 1,
  scm_AbstractSeq: 1,
  sc_AbstractSeq: 1,
  sc_AbstractIterable: 1,
  sc_Iterable: 1,
  sc_IterableOnce: 1,
  sc_IterableOps: 1,
  sc_IterableOnceOps: 1,
  sc_IterableFactoryDefaults: 1,
  sc_Seq: 1,
  s_PartialFunction: 1,
  F1: 1,
  sc_SeqOps: 1,
  s_Equals: 1,
  scm_Seq: 1,
  scm_Iterable: 1,
  scm_SeqOps: 1,
  scm_Cloneable: 1,
  jl_Cloneable: 1,
  scm_Buffer: 1,
  scm_Growable: 1,
  scm_Clearable: 1,
  scm_Shrinkable: 1,
  scm_IndexedBuffer: 1,
  scm_IndexedSeq: 1,
  sc_IndexedSeq: 1,
  sc_IndexedSeqOps: 1,
  scm_IndexedSeqOps: 1,
  sc_StrictOptimizedSeqOps: 1,
  sc_StrictOptimizedIterableOps: 1,
  scm_ArrayDequeOps: 1,
  scg_DefaultSerializable: 1,
  Ljava_io_Serializable: 1
}));
export { $d_scm_Queue as $d_scm_Queue };
$L0 = new $c_RTLong(0, 0);
$d_J.zero = $L0;
var $t_Lframework_components_TextKind$__SingleLine = null;
function $u_Lframework_components_TextKind$__SingleLine(x) {
  $t_Lframework_components_TextKind$__SingleLine = x;
}
export { $t_Lframework_components_TextKind$__SingleLine as $t_Lframework_components_TextKind$__SingleLine, $u_Lframework_components_TextKind$__SingleLine as $u_Lframework_components_TextKind$__SingleLine };
var $t_Lframework_components_TextKind$__MultiLine = null;
function $u_Lframework_components_TextKind$__MultiLine(x) {
  $t_Lframework_components_TextKind$__MultiLine = x;
}
export { $t_Lframework_components_TextKind$__MultiLine as $t_Lframework_components_TextKind$__MultiLine, $u_Lframework_components_TextKind$__MultiLine as $u_Lframework_components_TextKind$__MultiLine };
var $t_Lframework_data_PageCursorDirection$__Backward = null;
function $u_Lframework_data_PageCursorDirection$__Backward(x) {
  $t_Lframework_data_PageCursorDirection$__Backward = x;
}
export { $t_Lframework_data_PageCursorDirection$__Backward as $t_Lframework_data_PageCursorDirection$__Backward, $u_Lframework_data_PageCursorDirection$__Backward as $u_Lframework_data_PageCursorDirection$__Backward };
var $t_Lframework_data_PageCursorDirection$__Forward = null;
function $u_Lframework_data_PageCursorDirection$__Forward(x) {
  $t_Lframework_data_PageCursorDirection$__Forward = x;
}
export { $t_Lframework_data_PageCursorDirection$__Forward as $t_Lframework_data_PageCursorDirection$__Forward, $u_Lframework_data_PageCursorDirection$__Forward as $u_Lframework_data_PageCursorDirection$__Forward };
var $t_Ljava_time_DayOfWeek$__MONDAY = null;
function $u_Ljava_time_DayOfWeek$__MONDAY(x) {
  $t_Ljava_time_DayOfWeek$__MONDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__MONDAY as $t_Ljava_time_DayOfWeek$__MONDAY, $u_Ljava_time_DayOfWeek$__MONDAY as $u_Ljava_time_DayOfWeek$__MONDAY };
var $t_Ljava_time_DayOfWeek$__TUESDAY = null;
function $u_Ljava_time_DayOfWeek$__TUESDAY(x) {
  $t_Ljava_time_DayOfWeek$__TUESDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__TUESDAY as $t_Ljava_time_DayOfWeek$__TUESDAY, $u_Ljava_time_DayOfWeek$__TUESDAY as $u_Ljava_time_DayOfWeek$__TUESDAY };
var $t_Ljava_time_DayOfWeek$__WEDNESDAY = null;
function $u_Ljava_time_DayOfWeek$__WEDNESDAY(x) {
  $t_Ljava_time_DayOfWeek$__WEDNESDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__WEDNESDAY as $t_Ljava_time_DayOfWeek$__WEDNESDAY, $u_Ljava_time_DayOfWeek$__WEDNESDAY as $u_Ljava_time_DayOfWeek$__WEDNESDAY };
var $t_Ljava_time_DayOfWeek$__THURSDAY = null;
function $u_Ljava_time_DayOfWeek$__THURSDAY(x) {
  $t_Ljava_time_DayOfWeek$__THURSDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__THURSDAY as $t_Ljava_time_DayOfWeek$__THURSDAY, $u_Ljava_time_DayOfWeek$__THURSDAY as $u_Ljava_time_DayOfWeek$__THURSDAY };
var $t_Ljava_time_DayOfWeek$__FRIDAY = null;
function $u_Ljava_time_DayOfWeek$__FRIDAY(x) {
  $t_Ljava_time_DayOfWeek$__FRIDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__FRIDAY as $t_Ljava_time_DayOfWeek$__FRIDAY, $u_Ljava_time_DayOfWeek$__FRIDAY as $u_Ljava_time_DayOfWeek$__FRIDAY };
var $t_Ljava_time_DayOfWeek$__SATURDAY = null;
function $u_Ljava_time_DayOfWeek$__SATURDAY(x) {
  $t_Ljava_time_DayOfWeek$__SATURDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__SATURDAY as $t_Ljava_time_DayOfWeek$__SATURDAY, $u_Ljava_time_DayOfWeek$__SATURDAY as $u_Ljava_time_DayOfWeek$__SATURDAY };
var $t_Ljava_time_DayOfWeek$__SUNDAY = null;
function $u_Ljava_time_DayOfWeek$__SUNDAY(x) {
  $t_Ljava_time_DayOfWeek$__SUNDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__SUNDAY as $t_Ljava_time_DayOfWeek$__SUNDAY, $u_Ljava_time_DayOfWeek$__SUNDAY as $u_Ljava_time_DayOfWeek$__SUNDAY };
var $t_Ljava_time_Month$__JANUARY = null;
function $u_Ljava_time_Month$__JANUARY(x) {
  $t_Ljava_time_Month$__JANUARY = x;
}
export { $t_Ljava_time_Month$__JANUARY as $t_Ljava_time_Month$__JANUARY, $u_Ljava_time_Month$__JANUARY as $u_Ljava_time_Month$__JANUARY };
var $t_Ljava_time_Month$__FEBRUARY = null;
function $u_Ljava_time_Month$__FEBRUARY(x) {
  $t_Ljava_time_Month$__FEBRUARY = x;
}
export { $t_Ljava_time_Month$__FEBRUARY as $t_Ljava_time_Month$__FEBRUARY, $u_Ljava_time_Month$__FEBRUARY as $u_Ljava_time_Month$__FEBRUARY };
var $t_Ljava_time_Month$__MARCH = null;
function $u_Ljava_time_Month$__MARCH(x) {
  $t_Ljava_time_Month$__MARCH = x;
}
export { $t_Ljava_time_Month$__MARCH as $t_Ljava_time_Month$__MARCH, $u_Ljava_time_Month$__MARCH as $u_Ljava_time_Month$__MARCH };
var $t_Ljava_time_Month$__APRIL = null;
function $u_Ljava_time_Month$__APRIL(x) {
  $t_Ljava_time_Month$__APRIL = x;
}
export { $t_Ljava_time_Month$__APRIL as $t_Ljava_time_Month$__APRIL, $u_Ljava_time_Month$__APRIL as $u_Ljava_time_Month$__APRIL };
var $t_Ljava_time_Month$__MAY = null;
function $u_Ljava_time_Month$__MAY(x) {
  $t_Ljava_time_Month$__MAY = x;
}
export { $t_Ljava_time_Month$__MAY as $t_Ljava_time_Month$__MAY, $u_Ljava_time_Month$__MAY as $u_Ljava_time_Month$__MAY };
var $t_Ljava_time_Month$__JUNE = null;
function $u_Ljava_time_Month$__JUNE(x) {
  $t_Ljava_time_Month$__JUNE = x;
}
export { $t_Ljava_time_Month$__JUNE as $t_Ljava_time_Month$__JUNE, $u_Ljava_time_Month$__JUNE as $u_Ljava_time_Month$__JUNE };
var $t_Ljava_time_Month$__JULY = null;
function $u_Ljava_time_Month$__JULY(x) {
  $t_Ljava_time_Month$__JULY = x;
}
export { $t_Ljava_time_Month$__JULY as $t_Ljava_time_Month$__JULY, $u_Ljava_time_Month$__JULY as $u_Ljava_time_Month$__JULY };
var $t_Ljava_time_Month$__AUGUST = null;
function $u_Ljava_time_Month$__AUGUST(x) {
  $t_Ljava_time_Month$__AUGUST = x;
}
export { $t_Ljava_time_Month$__AUGUST as $t_Ljava_time_Month$__AUGUST, $u_Ljava_time_Month$__AUGUST as $u_Ljava_time_Month$__AUGUST };
var $t_Ljava_time_Month$__SEPTEMBER = null;
function $u_Ljava_time_Month$__SEPTEMBER(x) {
  $t_Ljava_time_Month$__SEPTEMBER = x;
}
export { $t_Ljava_time_Month$__SEPTEMBER as $t_Ljava_time_Month$__SEPTEMBER, $u_Ljava_time_Month$__SEPTEMBER as $u_Ljava_time_Month$__SEPTEMBER };
var $t_Ljava_time_Month$__OCTOBER = null;
function $u_Ljava_time_Month$__OCTOBER(x) {
  $t_Ljava_time_Month$__OCTOBER = x;
}
export { $t_Ljava_time_Month$__OCTOBER as $t_Ljava_time_Month$__OCTOBER, $u_Ljava_time_Month$__OCTOBER as $u_Ljava_time_Month$__OCTOBER };
var $t_Ljava_time_Month$__NOVEMBER = null;
function $u_Ljava_time_Month$__NOVEMBER(x) {
  $t_Ljava_time_Month$__NOVEMBER = x;
}
export { $t_Ljava_time_Month$__NOVEMBER as $t_Ljava_time_Month$__NOVEMBER, $u_Ljava_time_Month$__NOVEMBER as $u_Ljava_time_Month$__NOVEMBER };
var $t_Ljava_time_Month$__DECEMBER = null;
function $u_Ljava_time_Month$__DECEMBER(x) {
  $t_Ljava_time_Month$__DECEMBER = x;
}
export { $t_Ljava_time_Month$__DECEMBER as $t_Ljava_time_Month$__DECEMBER, $u_Ljava_time_Month$__DECEMBER as $u_Ljava_time_Month$__DECEMBER };
var $t_Ljava_time_format_ResolverStyle$__STRICT = null;
function $u_Ljava_time_format_ResolverStyle$__STRICT(x) {
  $t_Ljava_time_format_ResolverStyle$__STRICT = x;
}
export { $t_Ljava_time_format_ResolverStyle$__STRICT as $t_Ljava_time_format_ResolverStyle$__STRICT, $u_Ljava_time_format_ResolverStyle$__STRICT as $u_Ljava_time_format_ResolverStyle$__STRICT };
var $t_Ljava_time_format_ResolverStyle$__SMART = null;
function $u_Ljava_time_format_ResolverStyle$__SMART(x) {
  $t_Ljava_time_format_ResolverStyle$__SMART = x;
}
export { $t_Ljava_time_format_ResolverStyle$__SMART as $t_Ljava_time_format_ResolverStyle$__SMART, $u_Ljava_time_format_ResolverStyle$__SMART as $u_Ljava_time_format_ResolverStyle$__SMART };
var $t_Ljava_time_format_ResolverStyle$__LENIENT = null;
function $u_Ljava_time_format_ResolverStyle$__LENIENT(x) {
  $t_Ljava_time_format_ResolverStyle$__LENIENT = x;
}
export { $t_Ljava_time_format_ResolverStyle$__LENIENT as $t_Ljava_time_format_ResolverStyle$__LENIENT, $u_Ljava_time_format_ResolverStyle$__LENIENT as $u_Ljava_time_format_ResolverStyle$__LENIENT };
var $t_Ljava_time_format_SignStyle$__NORMAL = null;
function $u_Ljava_time_format_SignStyle$__NORMAL(x) {
  $t_Ljava_time_format_SignStyle$__NORMAL = x;
}
export { $t_Ljava_time_format_SignStyle$__NORMAL as $t_Ljava_time_format_SignStyle$__NORMAL, $u_Ljava_time_format_SignStyle$__NORMAL as $u_Ljava_time_format_SignStyle$__NORMAL };
var $t_Ljava_time_format_SignStyle$__ALWAYS = null;
function $u_Ljava_time_format_SignStyle$__ALWAYS(x) {
  $t_Ljava_time_format_SignStyle$__ALWAYS = x;
}
export { $t_Ljava_time_format_SignStyle$__ALWAYS as $t_Ljava_time_format_SignStyle$__ALWAYS, $u_Ljava_time_format_SignStyle$__ALWAYS as $u_Ljava_time_format_SignStyle$__ALWAYS };
var $t_Ljava_time_format_SignStyle$__NEVER = null;
function $u_Ljava_time_format_SignStyle$__NEVER(x) {
  $t_Ljava_time_format_SignStyle$__NEVER = x;
}
export { $t_Ljava_time_format_SignStyle$__NEVER as $t_Ljava_time_format_SignStyle$__NEVER, $u_Ljava_time_format_SignStyle$__NEVER as $u_Ljava_time_format_SignStyle$__NEVER };
var $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE = null;
function $u_Ljava_time_format_SignStyle$__NOT_NEGATIVE(x) {
  $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE = x;
}
export { $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE as $t_Ljava_time_format_SignStyle$__NOT_NEGATIVE, $u_Ljava_time_format_SignStyle$__NOT_NEGATIVE as $u_Ljava_time_format_SignStyle$__NOT_NEGATIVE };
var $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD = null;
function $u_Ljava_time_format_SignStyle$__EXCEEDS_PAD(x) {
  $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD = x;
}
export { $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD as $t_Ljava_time_format_SignStyle$__EXCEEDS_PAD, $u_Ljava_time_format_SignStyle$__EXCEEDS_PAD as $u_Ljava_time_format_SignStyle$__EXCEEDS_PAD };
var $t_Ljava_time_format_TextStyle$__FULL = null;
function $u_Ljava_time_format_TextStyle$__FULL(x) {
  $t_Ljava_time_format_TextStyle$__FULL = x;
}
export { $t_Ljava_time_format_TextStyle$__FULL as $t_Ljava_time_format_TextStyle$__FULL, $u_Ljava_time_format_TextStyle$__FULL as $u_Ljava_time_format_TextStyle$__FULL };
var $t_Ljava_time_format_TextStyle$__FULL_STANDALONE = null;
function $u_Ljava_time_format_TextStyle$__FULL_STANDALONE(x) {
  $t_Ljava_time_format_TextStyle$__FULL_STANDALONE = x;
}
export { $t_Ljava_time_format_TextStyle$__FULL_STANDALONE as $t_Ljava_time_format_TextStyle$__FULL_STANDALONE, $u_Ljava_time_format_TextStyle$__FULL_STANDALONE as $u_Ljava_time_format_TextStyle$__FULL_STANDALONE };
var $t_Ljava_time_format_TextStyle$__SHORT = null;
function $u_Ljava_time_format_TextStyle$__SHORT(x) {
  $t_Ljava_time_format_TextStyle$__SHORT = x;
}
export { $t_Ljava_time_format_TextStyle$__SHORT as $t_Ljava_time_format_TextStyle$__SHORT, $u_Ljava_time_format_TextStyle$__SHORT as $u_Ljava_time_format_TextStyle$__SHORT };
var $t_Ljava_time_format_TextStyle$__SHORT_STANDALONE = null;
function $u_Ljava_time_format_TextStyle$__SHORT_STANDALONE(x) {
  $t_Ljava_time_format_TextStyle$__SHORT_STANDALONE = x;
}
export { $t_Ljava_time_format_TextStyle$__SHORT_STANDALONE as $t_Ljava_time_format_TextStyle$__SHORT_STANDALONE, $u_Ljava_time_format_TextStyle$__SHORT_STANDALONE as $u_Ljava_time_format_TextStyle$__SHORT_STANDALONE };
var $t_Ljava_time_format_TextStyle$__NARROW = null;
function $u_Ljava_time_format_TextStyle$__NARROW(x) {
  $t_Ljava_time_format_TextStyle$__NARROW = x;
}
export { $t_Ljava_time_format_TextStyle$__NARROW as $t_Ljava_time_format_TextStyle$__NARROW, $u_Ljava_time_format_TextStyle$__NARROW as $u_Ljava_time_format_TextStyle$__NARROW };
var $t_Ljava_time_format_TextStyle$__NARROW_STANDALONE = null;
function $u_Ljava_time_format_TextStyle$__NARROW_STANDALONE(x) {
  $t_Ljava_time_format_TextStyle$__NARROW_STANDALONE = x;
}
export { $t_Ljava_time_format_TextStyle$__NARROW_STANDALONE as $t_Ljava_time_format_TextStyle$__NARROW_STANDALONE, $u_Ljava_time_format_TextStyle$__NARROW_STANDALONE as $u_Ljava_time_format_TextStyle$__NARROW_STANDALONE };
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE = null;
function $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE(x) {
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE = x;
}
export { $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE as $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE, $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE as $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__SENSITIVE };
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE = null;
function $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE(x) {
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE = x;
}
export { $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE as $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE, $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE as $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE };
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT = null;
function $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT(x) {
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT = x;
}
export { $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT as $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT, $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT as $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__STRICT };
var $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT = null;
function $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT(x) {
  $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT = x;
}
export { $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT as $t_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT, $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT as $u_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__LENIENT };
var $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND = null;
function $u_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND(x) {
  $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND = x;
}
export { $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND as $t_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND, $u_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND as $u_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND };
var $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY = null;
function $u_Ljava_time_temporal_ChronoField$__NANO_OF_DAY(x) {
  $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY = x;
}
export { $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY as $t_Ljava_time_temporal_ChronoField$__NANO_OF_DAY, $u_Ljava_time_temporal_ChronoField$__NANO_OF_DAY as $u_Ljava_time_temporal_ChronoField$__NANO_OF_DAY };
var $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND = null;
function $u_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND(x) {
  $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND = x;
}
export { $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND as $t_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND, $u_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND as $u_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND };
var $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY = null;
function $u_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY(x) {
  $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY = x;
}
export { $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY as $t_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY, $u_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY as $u_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY };
var $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND = null;
function $u_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND(x) {
  $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND = x;
}
export { $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND as $t_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND, $u_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND as $u_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND };
var $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY = null;
function $u_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY(x) {
  $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY = x;
}
export { $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY as $t_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY, $u_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY as $u_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY };
var $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE = null;
function $u_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE(x) {
  $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE = x;
}
export { $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE as $t_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE, $u_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE as $u_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE };
var $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY = null;
function $u_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY(x) {
  $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY = x;
}
export { $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY as $t_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY, $u_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY as $u_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY };
var $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR = null;
function $u_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR(x) {
  $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR = x;
}
export { $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR as $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR, $u_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR as $u_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR };
var $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY = null;
function $u_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY(x) {
  $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY = x;
}
export { $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY as $t_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY, $u_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY as $u_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY };
var $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM = null;
function $u_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM(x) {
  $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM = x;
}
export { $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM as $t_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM, $u_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM as $u_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM };
var $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM = null;
function $u_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM(x) {
  $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM = x;
}
export { $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM as $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM, $u_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM as $u_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM };
var $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY = null;
function $u_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY(x) {
  $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY = x;
}
export { $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY as $t_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY, $u_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY as $u_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY };
var $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY = null;
function $u_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY(x) {
  $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY = x;
}
export { $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY as $t_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY, $u_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY as $u_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY };
var $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY = null;
function $u_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY(x) {
  $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY = x;
}
export { $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY as $t_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY, $u_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY as $u_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY };
var $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK = null;
function $u_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK(x) {
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK = x;
}
export { $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK as $t_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK, $u_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK as $u_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK };
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH = null;
function $u_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH(x) {
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH = x;
}
export { $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH as $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH, $u_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH as $u_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH };
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR = null;
function $u_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR(x) {
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR = x;
}
export { $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR as $t_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR, $u_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR as $u_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR };
var $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH = null;
function $u_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH(x) {
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH = x;
}
export { $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH as $t_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH, $u_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH as $u_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH };
var $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR = null;
function $u_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR(x) {
  $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR = x;
}
export { $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR as $t_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR, $u_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR as $u_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR };
var $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY = null;
function $u_Ljava_time_temporal_ChronoField$__EPOCH_DAY(x) {
  $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY = x;
}
export { $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY as $t_Ljava_time_temporal_ChronoField$__EPOCH_DAY, $u_Ljava_time_temporal_ChronoField$__EPOCH_DAY as $u_Ljava_time_temporal_ChronoField$__EPOCH_DAY };
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH = null;
function $u_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH(x) {
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH = x;
}
export { $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH as $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH, $u_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH as $u_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH };
var $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR = null;
function $u_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR(x) {
  $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR = x;
}
export { $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR as $t_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR, $u_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR as $u_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR };
var $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR = null;
function $u_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR(x) {
  $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR = x;
}
export { $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR as $t_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR, $u_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR as $u_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR };
var $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH = null;
function $u_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH(x) {
  $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH = x;
}
export { $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH as $t_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH, $u_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH as $u_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH };
var $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA = null;
function $u_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA(x) {
  $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA = x;
}
export { $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA as $t_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA, $u_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA as $u_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA };
var $t_Ljava_time_temporal_ChronoField$__YEAR = null;
function $u_Ljava_time_temporal_ChronoField$__YEAR(x) {
  $t_Ljava_time_temporal_ChronoField$__YEAR = x;
}
export { $t_Ljava_time_temporal_ChronoField$__YEAR as $t_Ljava_time_temporal_ChronoField$__YEAR, $u_Ljava_time_temporal_ChronoField$__YEAR as $u_Ljava_time_temporal_ChronoField$__YEAR };
var $t_Ljava_time_temporal_ChronoField$__ERA = null;
function $u_Ljava_time_temporal_ChronoField$__ERA(x) {
  $t_Ljava_time_temporal_ChronoField$__ERA = x;
}
export { $t_Ljava_time_temporal_ChronoField$__ERA as $t_Ljava_time_temporal_ChronoField$__ERA, $u_Ljava_time_temporal_ChronoField$__ERA as $u_Ljava_time_temporal_ChronoField$__ERA };
var $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS = null;
function $u_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS(x) {
  $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS = x;
}
export { $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS as $t_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS, $u_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS as $u_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS };
var $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS = null;
function $u_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS(x) {
  $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS = x;
}
export { $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS as $t_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS, $u_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS as $u_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS };
var $t_Ljava_time_temporal_ChronoUnit$__NANOS = null;
function $u_Ljava_time_temporal_ChronoUnit$__NANOS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__NANOS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__NANOS as $t_Ljava_time_temporal_ChronoUnit$__NANOS, $u_Ljava_time_temporal_ChronoUnit$__NANOS as $u_Ljava_time_temporal_ChronoUnit$__NANOS };
var $t_Ljava_time_temporal_ChronoUnit$__MICROS = null;
function $u_Ljava_time_temporal_ChronoUnit$__MICROS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__MICROS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__MICROS as $t_Ljava_time_temporal_ChronoUnit$__MICROS, $u_Ljava_time_temporal_ChronoUnit$__MICROS as $u_Ljava_time_temporal_ChronoUnit$__MICROS };
var $t_Ljava_time_temporal_ChronoUnit$__MILLIS = null;
function $u_Ljava_time_temporal_ChronoUnit$__MILLIS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__MILLIS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__MILLIS as $t_Ljava_time_temporal_ChronoUnit$__MILLIS, $u_Ljava_time_temporal_ChronoUnit$__MILLIS as $u_Ljava_time_temporal_ChronoUnit$__MILLIS };
var $t_Ljava_time_temporal_ChronoUnit$__SECONDS = null;
function $u_Ljava_time_temporal_ChronoUnit$__SECONDS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__SECONDS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__SECONDS as $t_Ljava_time_temporal_ChronoUnit$__SECONDS, $u_Ljava_time_temporal_ChronoUnit$__SECONDS as $u_Ljava_time_temporal_ChronoUnit$__SECONDS };
var $t_Ljava_time_temporal_ChronoUnit$__MINUTES = null;
function $u_Ljava_time_temporal_ChronoUnit$__MINUTES(x) {
  $t_Ljava_time_temporal_ChronoUnit$__MINUTES = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__MINUTES as $t_Ljava_time_temporal_ChronoUnit$__MINUTES, $u_Ljava_time_temporal_ChronoUnit$__MINUTES as $u_Ljava_time_temporal_ChronoUnit$__MINUTES };
var $t_Ljava_time_temporal_ChronoUnit$__HOURS = null;
function $u_Ljava_time_temporal_ChronoUnit$__HOURS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__HOURS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__HOURS as $t_Ljava_time_temporal_ChronoUnit$__HOURS, $u_Ljava_time_temporal_ChronoUnit$__HOURS as $u_Ljava_time_temporal_ChronoUnit$__HOURS };
var $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS = null;
function $u_Ljava_time_temporal_ChronoUnit$__HALF_DAYS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS as $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS, $u_Ljava_time_temporal_ChronoUnit$__HALF_DAYS as $u_Ljava_time_temporal_ChronoUnit$__HALF_DAYS };
var $t_Ljava_time_temporal_ChronoUnit$__DAYS = null;
function $u_Ljava_time_temporal_ChronoUnit$__DAYS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__DAYS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__DAYS as $t_Ljava_time_temporal_ChronoUnit$__DAYS, $u_Ljava_time_temporal_ChronoUnit$__DAYS as $u_Ljava_time_temporal_ChronoUnit$__DAYS };
var $t_Ljava_time_temporal_ChronoUnit$__WEEKS = null;
function $u_Ljava_time_temporal_ChronoUnit$__WEEKS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__WEEKS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__WEEKS as $t_Ljava_time_temporal_ChronoUnit$__WEEKS, $u_Ljava_time_temporal_ChronoUnit$__WEEKS as $u_Ljava_time_temporal_ChronoUnit$__WEEKS };
var $t_Ljava_time_temporal_ChronoUnit$__MONTHS = null;
function $u_Ljava_time_temporal_ChronoUnit$__MONTHS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__MONTHS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__MONTHS as $t_Ljava_time_temporal_ChronoUnit$__MONTHS, $u_Ljava_time_temporal_ChronoUnit$__MONTHS as $u_Ljava_time_temporal_ChronoUnit$__MONTHS };
var $t_Ljava_time_temporal_ChronoUnit$__YEARS = null;
function $u_Ljava_time_temporal_ChronoUnit$__YEARS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__YEARS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__YEARS as $t_Ljava_time_temporal_ChronoUnit$__YEARS, $u_Ljava_time_temporal_ChronoUnit$__YEARS as $u_Ljava_time_temporal_ChronoUnit$__YEARS };
var $t_Ljava_time_temporal_ChronoUnit$__DECADES = null;
function $u_Ljava_time_temporal_ChronoUnit$__DECADES(x) {
  $t_Ljava_time_temporal_ChronoUnit$__DECADES = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__DECADES as $t_Ljava_time_temporal_ChronoUnit$__DECADES, $u_Ljava_time_temporal_ChronoUnit$__DECADES as $u_Ljava_time_temporal_ChronoUnit$__DECADES };
var $t_Ljava_time_temporal_ChronoUnit$__CENTURIES = null;
function $u_Ljava_time_temporal_ChronoUnit$__CENTURIES(x) {
  $t_Ljava_time_temporal_ChronoUnit$__CENTURIES = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__CENTURIES as $t_Ljava_time_temporal_ChronoUnit$__CENTURIES, $u_Ljava_time_temporal_ChronoUnit$__CENTURIES as $u_Ljava_time_temporal_ChronoUnit$__CENTURIES };
var $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA = null;
function $u_Ljava_time_temporal_ChronoUnit$__MILLENNIA(x) {
  $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA as $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA, $u_Ljava_time_temporal_ChronoUnit$__MILLENNIA as $u_Ljava_time_temporal_ChronoUnit$__MILLENNIA };
var $t_Ljava_time_temporal_ChronoUnit$__ERAS = null;
function $u_Ljava_time_temporal_ChronoUnit$__ERAS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__ERAS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__ERAS as $t_Ljava_time_temporal_ChronoUnit$__ERAS, $u_Ljava_time_temporal_ChronoUnit$__ERAS as $u_Ljava_time_temporal_ChronoUnit$__ERAS };
var $t_Ljava_time_temporal_ChronoUnit$__FOREVER = null;
function $u_Ljava_time_temporal_ChronoUnit$__FOREVER(x) {
  $t_Ljava_time_temporal_ChronoUnit$__FOREVER = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__FOREVER as $t_Ljava_time_temporal_ChronoUnit$__FOREVER, $u_Ljava_time_temporal_ChronoUnit$__FOREVER as $u_Ljava_time_temporal_ChronoUnit$__FOREVER };
var $t_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER = null;
function $u_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER(x) {
  $t_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER = x;
}
export { $t_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER as $t_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER, $u_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER as $u_Ljava_time_temporal_IsoFields$Field$__DAY_OF_QUARTER };
var $t_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR = null;
function $u_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR(x) {
  $t_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR = x;
}
export { $t_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR as $t_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR, $u_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR as $u_Ljava_time_temporal_IsoFields$Field$__QUARTER_OF_YEAR };
var $t_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR = null;
function $u_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR(x) {
  $t_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR = x;
}
export { $t_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR as $t_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR, $u_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR as $u_Ljava_time_temporal_IsoFields$Field$__WEEK_OF_WEEK_BASED_YEAR };
var $t_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR = null;
function $u_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR(x) {
  $t_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR = x;
}
export { $t_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR as $t_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR, $u_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR as $u_Ljava_time_temporal_IsoFields$Field$__WEEK_BASED_YEAR };
var $t_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS = null;
function $u_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS(x) {
  $t_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS = x;
}
export { $t_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS as $t_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS, $u_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS as $u_Ljava_time_temporal_IsoFields$Unit$__WEEK_BASED_YEARS };
var $t_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS = null;
function $u_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS(x) {
  $t_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS = x;
}
export { $t_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS as $t_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS, $u_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS as $u_Ljava_time_temporal_IsoFields$Unit$__QUARTER_YEARS };
var $t_ju_Locale$Category$__DISPLAY = null;
function $u_ju_Locale$Category$__DISPLAY(x) {
  $t_ju_Locale$Category$__DISPLAY = x;
}
export { $t_ju_Locale$Category$__DISPLAY as $t_ju_Locale$Category$__DISPLAY, $u_ju_Locale$Category$__DISPLAY as $u_ju_Locale$Category$__DISPLAY };
var $t_ju_Locale$Category$__FORMAT = null;
function $u_ju_Locale$Category$__FORMAT(x) {
  $t_ju_Locale$Category$__FORMAT = x;
}
export { $t_ju_Locale$Category$__FORMAT as $t_ju_Locale$Category$__FORMAT, $u_ju_Locale$Category$__FORMAT as $u_ju_Locale$Category$__FORMAT };
//# sourceMappingURL=internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js.map
